
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aOnO8", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function() {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = undefined;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a;
                    }
                    var p = n[i] = {
                        exports: {}
                    };
                    e[i][0].call(p.exports, function(r) {
                        var n = e[i][1][r];
                        return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }
                return n[i].exports;
            }
            for(var u = undefined, i = 0; i < t.length; i++)o(t[i]);
            return o;
        }
        return r;
    })()({
        1: [
            function(require1, module1, exports) {
                'use strict';
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                /*******************************************************************************
 * Copyright (c) 2017 Kiel University and others.
 *
 * This program and the accompanying materials are made
 * available under the terms of the Eclipse Public License 2.0
 * which is available at https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *******************************************************************************/ var ELK = function() {
                    function ELK() {
                        var _this = this;
                        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$defaultLayoutOpt = _ref.defaultLayoutOptions, defaultLayoutOptions = _ref$defaultLayoutOpt === undefined ? {} : _ref$defaultLayoutOpt, _ref$algorithms = _ref.algorithms, algorithms = _ref$algorithms === undefined ? [
                            'layered',
                            'stress',
                            'mrtree',
                            'radial',
                            'force',
                            'disco',
                            'sporeOverlap',
                            'sporeCompaction',
                            'rectpacking'
                        ] : _ref$algorithms, workerFactory = _ref.workerFactory, workerUrl = _ref.workerUrl;
                        _classCallCheck(this, ELK);
                        this.defaultLayoutOptions = defaultLayoutOptions;
                        this.initialized = false;
                        // check valid worker construction possible
                        if (typeof workerUrl === 'undefined' && typeof workerFactory === 'undefined') throw new Error("Cannot construct an ELK without both 'workerUrl' and 'workerFactory'.");
                        var factory = workerFactory;
                        if (typeof workerUrl !== 'undefined' && typeof workerFactory === 'undefined') // use default Web Worker
                        factory = function factory(url) {
                            return new Worker(url);
                        };
                        // create the worker
                        var worker = factory(workerUrl);
                        if (typeof worker.postMessage !== 'function') throw new TypeError("Created worker does not provide the required 'postMessage' function.");
                        // wrap the worker to return promises
                        this.worker = new PromisedWorker(worker);
                        // initially register algorithms
                        this.worker.postMessage({
                            cmd: 'register',
                            algorithms: algorithms
                        }).then(function(r) {
                            return _this.initialized = true;
                        }).catch(console.err);
                    }
                    _createClass(ELK, [
                        {
                            key: 'layout',
                            value: function layout(graph) {
                                var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$layoutOptions = _ref2.layoutOptions, layoutOptions = _ref2$layoutOptions === undefined ? this.defaultLayoutOptions : _ref2$layoutOptions, _ref2$logging = _ref2.logging, logging = _ref2$logging === undefined ? false : _ref2$logging, _ref2$measureExecutio = _ref2.measureExecutionTime, measureExecutionTime = _ref2$measureExecutio === undefined ? false : _ref2$measureExecutio;
                                if (!graph) return Promise.reject(new Error("Missing mandatory parameter 'graph'."));
                                return this.worker.postMessage({
                                    cmd: 'layout',
                                    graph: graph,
                                    layoutOptions: layoutOptions,
                                    options: {
                                        logging: logging,
                                        measureExecutionTime: measureExecutionTime
                                    }
                                });
                            }
                        },
                        {
                            key: 'knownLayoutAlgorithms',
                            value: function knownLayoutAlgorithms() {
                                return this.worker.postMessage({
                                    cmd: 'algorithms'
                                });
                            }
                        },
                        {
                            key: 'knownLayoutOptions',
                            value: function knownLayoutOptions() {
                                return this.worker.postMessage({
                                    cmd: 'options'
                                });
                            }
                        },
                        {
                            key: 'knownLayoutCategories',
                            value: function knownLayoutCategories() {
                                return this.worker.postMessage({
                                    cmd: 'categories'
                                });
                            }
                        },
                        {
                            key: 'terminateWorker',
                            value: function terminateWorker() {
                                if (this.worker) this.worker.terminate();
                            }
                        }
                    ]);
                    return ELK;
                }();
                exports.default = ELK;
                var PromisedWorker = function() {
                    function PromisedWorker(worker) {
                        var _this2 = this;
                        _classCallCheck(this, PromisedWorker);
                        if (worker === undefined) throw new Error("Missing mandatory parameter 'worker'.");
                        this.resolvers = {};
                        this.worker = worker;
                        this.worker.onmessage = function(answer) {
                            // why is this necessary?
                            setTimeout(function() {
                                _this2.receive(_this2, answer);
                            }, 0);
                        };
                    }
                    _createClass(PromisedWorker, [
                        {
                            key: 'postMessage',
                            value: function postMessage(msg) {
                                var id = this.id || 0;
                                this.id = id + 1;
                                msg.id = id;
                                var self1 = this;
                                return new Promise(function(resolve, reject) {
                                    // prepare the resolver
                                    self1.resolvers[id] = function(err, res) {
                                        if (err) {
                                            self1.convertGwtStyleError(err);
                                            reject(err);
                                        } else resolve(res);
                                    };
                                    // post the message
                                    self1.worker.postMessage(msg);
                                });
                            }
                        },
                        {
                            key: 'receive',
                            value: function receive(self1, answer) {
                                var json = answer.data;
                                var resolver = self1.resolvers[json.id];
                                if (resolver) {
                                    delete self1.resolvers[json.id];
                                    if (json.error) resolver(json.error);
                                    else resolver(null, json.data);
                                }
                            }
                        },
                        {
                            key: 'terminate',
                            value: function terminate() {
                                if (this.worker) this.worker.terminate();
                            }
                        },
                        {
                            key: 'convertGwtStyleError',
                            value: function convertGwtStyleError(err) {
                                if (!err) return;
                                // Somewhat flatten the way GWT stores nested exception(s)
                                var javaException = err['__java$exception'];
                                if (javaException) {
                                    // Note that the property name of the nested exception is different
                                    // in the non-minified ('cause') and the minified (not deterministic) version.
                                    // Hence, the version below only works for the non-minified version.
                                    // However, as the minified stack trace is not of much use anyway, one
                                    // should switch the used version for debugging in such a case.
                                    if (javaException.cause && javaException.cause.backingJsObject) {
                                        err.cause = javaException.cause.backingJsObject;
                                        this.convertGwtStyleError(err.cause);
                                    }
                                    delete err['__java$exception'];
                                }
                            }
                        }
                    ]);
                    return PromisedWorker;
                }();
            },
            {}
        ],
        2: [
            function(require1, module1, exports) {
                (function(global1) {
                    (function() {
                        'use strict';
                        // --------------    FAKE ELEMENTS GWT ASSUMES EXIST   -------------- 
                        var $wnd;
                        if (typeof window !== 'undefined') $wnd = window;
                        else if (typeof global1 !== 'undefined') $wnd = global1 // nodejs
                        ;
                        else if (typeof self !== 'undefined') $wnd = self // web worker
                        ;
                        var $moduleName, $moduleBase;
                        // --------------    WORKAROUND STRICT MODE, SEE #127    -------------- 
                        var g, i, o;
                        // --------------    GENERATED CODE    -------------- 
                        function nb() {}
                        function xb() {}
                        function Fd() {}
                        function hh() {}
                        function lq() {}
                        function Nq() {}
                        function ir() {}
                        function Ws() {}
                        function Zw() {}
                        function jx() {}
                        function rx() {}
                        function sx() {}
                        function My() {}
                        function bA() {}
                        function mA() {}
                        function tA() {}
                        function aB() {}
                        function dB() {}
                        function jB() {}
                        function dC() {}
                        function keb() {}
                        function geb() {}
                        function oeb() {}
                        function iob() {}
                        function Job() {}
                        function Rob() {}
                        function apb() {}
                        function ipb() {}
                        function nrb() {}
                        function wrb() {}
                        function Brb() {}
                        function Prb() {}
                        function ltb() {}
                        function svb() {}
                        function xvb() {}
                        function zvb() {}
                        function $xb() {}
                        function Gzb() {}
                        function NAb() {}
                        function VAb() {}
                        function rBb() {}
                        function RBb() {}
                        function TBb() {}
                        function XBb() {}
                        function ZBb() {}
                        function _Bb() {}
                        function bCb() {}
                        function dCb() {}
                        function fCb() {}
                        function jCb() {}
                        function rCb() {}
                        function uCb() {}
                        function wCb() {}
                        function yCb() {}
                        function ACb() {}
                        function ECb() {}
                        function FEb() {}
                        function IEb() {}
                        function KEb() {}
                        function MEb() {}
                        function gFb() {}
                        function FFb() {}
                        function JFb() {}
                        function xGb() {}
                        function AGb() {}
                        function YGb() {}
                        function oHb() {}
                        function tHb() {}
                        function xHb() {}
                        function pIb() {}
                        function BJb() {}
                        function kLb() {}
                        function mLb() {}
                        function oLb() {}
                        function qLb() {}
                        function FLb() {}
                        function JLb() {}
                        function KMb() {}
                        function MMb() {}
                        function OMb() {}
                        function YMb() {}
                        function MNb() {}
                        function ONb() {}
                        function aOb() {}
                        function eOb() {}
                        function xOb() {}
                        function BOb() {}
                        function DOb() {}
                        function FOb() {}
                        function IOb() {}
                        function MOb() {}
                        function POb() {}
                        function UOb() {}
                        function ZOb() {}
                        function cPb() {}
                        function gPb() {}
                        function nPb() {}
                        function qPb() {}
                        function tPb() {}
                        function wPb() {}
                        function CPb() {}
                        function qQb() {}
                        function GQb() {}
                        function bRb() {}
                        function gRb() {}
                        function kRb() {}
                        function pRb() {}
                        function wRb() {}
                        function xSb() {}
                        function TSb() {}
                        function VSb() {}
                        function XSb() {}
                        function ZSb() {}
                        function _Sb() {}
                        function tTb() {}
                        function DTb() {}
                        function FTb() {}
                        function FXb() {}
                        function hXb() {}
                        function hWb() {}
                        function mWb() {}
                        function CVb() {}
                        function XXb() {}
                        function $Xb() {}
                        function bYb() {}
                        function lYb() {}
                        function FYb() {}
                        function XYb() {}
                        function aZb() {}
                        function SZb() {}
                        function ZZb() {}
                        function Z_b() {}
                        function j_b() {}
                        function j$b() {}
                        function b$b() {}
                        function f$b() {}
                        function n$b() {}
                        function K_b() {}
                        function V_b() {}
                        function b0b() {}
                        function l0b() {}
                        function X1b() {}
                        function _1b() {}
                        function x3b() {}
                        function r4b() {}
                        function w4b() {}
                        function A4b() {}
                        function E4b() {}
                        function I4b() {}
                        function M4b() {}
                        function o5b() {}
                        function q5b() {}
                        function w5b() {}
                        function A5b() {}
                        function E5b() {}
                        function h6b() {}
                        function j6b() {}
                        function l6b() {}
                        function q6b() {}
                        function v6b() {}
                        function y6b() {}
                        function G6b() {}
                        function K6b() {}
                        function N6b() {}
                        function P6b() {}
                        function R6b() {}
                        function b7b() {}
                        function f7b() {}
                        function j7b() {}
                        function n7b() {}
                        function C7b() {}
                        function H7b() {}
                        function J7b() {}
                        function L7b() {}
                        function N7b() {}
                        function P7b() {}
                        function a8b() {}
                        function c8b() {}
                        function e8b() {}
                        function g8b() {}
                        function i8b() {}
                        function m8b() {}
                        function Z8b() {}
                        function f9b() {}
                        function i9b() {}
                        function o9b() {}
                        function C9b() {}
                        function F9b() {}
                        function K9b() {}
                        function Q9b() {}
                        function aac() {}
                        function bac() {}
                        function eac() {}
                        function mac() {}
                        function pac() {}
                        function rac() {}
                        function tac() {}
                        function xac() {}
                        function Aac() {}
                        function Dac() {}
                        function Iac() {}
                        function Oac() {}
                        function Uac() {}
                        function Ucc() {}
                        function scc() {}
                        function ycc() {}
                        function Acc() {}
                        function Ccc() {}
                        function Ncc() {}
                        function Wcc() {}
                        function ydc() {}
                        function Adc() {}
                        function Gdc() {}
                        function Ldc() {}
                        function Zdc() {}
                        function fec() {}
                        function Dec() {}
                        function Gec() {}
                        function Kec() {}
                        function efc() {}
                        function jfc() {}
                        function nfc() {}
                        function Bfc() {}
                        function Ifc() {}
                        function Lfc() {}
                        function Rfc() {}
                        function Ufc() {}
                        function Zfc() {}
                        function cgc() {}
                        function egc() {}
                        function ggc() {}
                        function igc() {}
                        function kgc() {}
                        function Dgc() {}
                        function Hgc() {}
                        function Lgc() {}
                        function Ngc() {}
                        function Pgc() {}
                        function Vgc() {}
                        function Ygc() {}
                        function chc() {}
                        function ehc() {}
                        function ghc() {}
                        function ihc() {}
                        function mhc() {}
                        function rhc() {}
                        function uhc() {}
                        function whc() {}
                        function yhc() {}
                        function Ahc() {}
                        function Chc() {}
                        function Ghc() {}
                        function Nhc() {}
                        function Phc() {}
                        function Rhc() {}
                        function Thc() {}
                        function $hc() {}
                        function aic() {}
                        function cic() {}
                        function eic() {}
                        function jic() {}
                        function nic() {}
                        function pic() {}
                        function ric() {}
                        function vic() {}
                        function yic() {}
                        function Dic() {}
                        function Ric() {}
                        function Zic() {}
                        function bjc() {}
                        function djc() {}
                        function jjc() {}
                        function njc() {}
                        function rjc() {}
                        function tjc() {}
                        function zjc() {}
                        function Djc() {}
                        function Fjc() {}
                        function Ljc() {}
                        function Pjc() {}
                        function Rjc() {}
                        function fkc() {}
                        function Kkc() {}
                        function Mkc() {}
                        function Okc() {}
                        function Qkc() {}
                        function Skc() {}
                        function Ukc() {}
                        function Wkc() {}
                        function clc() {}
                        function elc() {}
                        function klc() {}
                        function mlc() {}
                        function olc() {}
                        function qlc() {}
                        function wlc() {}
                        function ylc() {}
                        function Alc() {}
                        function Jlc() {}
                        function Joc() {}
                        function poc() {}
                        function roc() {}
                        function toc() {}
                        function voc() {}
                        function Boc() {}
                        function Foc() {}
                        function Hoc() {}
                        function Loc() {}
                        function Noc() {}
                        function Poc() {}
                        function qnc() {}
                        function unc() {}
                        function upc() {}
                        function kpc() {}
                        function mpc() {}
                        function opc() {}
                        function qpc() {}
                        function ypc() {}
                        function Cpc() {}
                        function Mpc() {}
                        function Qpc() {}
                        function dqc() {}
                        function jqc() {}
                        function Aqc() {}
                        function Eqc() {}
                        function Gqc() {}
                        function Sqc() {}
                        function arc() {}
                        function lrc() {}
                        function zrc() {}
                        function Hrc() {}
                        function bsc() {}
                        function dsc() {}
                        function fsc() {}
                        function ksc() {}
                        function msc() {}
                        function Asc() {}
                        function Csc() {}
                        function Esc() {}
                        function Ksc() {}
                        function Nsc() {}
                        function Ssc() {}
                        function CCc() {}
                        function tGc() {}
                        function aHc() {}
                        function gHc() {}
                        function nIc() {}
                        function PJc() {}
                        function XKc() {}
                        function fLc() {}
                        function hLc() {}
                        function lLc() {}
                        function eNc() {}
                        function IOc() {}
                        function MOc() {}
                        function WOc() {}
                        function YOc() {}
                        function $Oc() {}
                        function cPc() {}
                        function iPc() {}
                        function mPc() {}
                        function oPc() {}
                        function qPc() {}
                        function sPc() {}
                        function wPc() {}
                        function APc() {}
                        function FPc() {}
                        function HPc() {}
                        function NPc() {}
                        function PPc() {}
                        function TPc() {}
                        function VPc() {}
                        function ZPc() {}
                        function _Pc() {}
                        function bQc() {}
                        function dQc() {}
                        function SQc() {}
                        function hRc() {}
                        function HRc() {}
                        function HSc() {}
                        function pSc() {}
                        function xSc() {}
                        function zSc() {}
                        function BSc() {}
                        function DSc() {}
                        function FSc() {}
                        function CTc() {}
                        function ITc() {}
                        function KTc() {}
                        function MTc() {}
                        function XTc() {}
                        function ZTc() {}
                        function jVc() {}
                        function lVc() {}
                        function zVc() {}
                        function IVc() {}
                        function KVc() {}
                        function KWc() {}
                        function uWc() {}
                        function xWc() {}
                        function AWc() {}
                        function QWc() {}
                        function UWc() {}
                        function qXc() {}
                        function KXc() {}
                        function OXc() {}
                        function SXc() {}
                        function $Xc() {}
                        function mYc() {}
                        function rYc() {}
                        function zYc() {}
                        function DYc() {}
                        function FYc() {}
                        function HYc() {}
                        function JYc() {}
                        function cZc() {}
                        function gZc() {}
                        function iZc() {}
                        function pZc() {}
                        function tZc() {}
                        function vZc() {}
                        function AZc() {}
                        function GZc() {}
                        function l_c() {}
                        function l1c() {}
                        function b1c() {}
                        function d1c() {}
                        function h1c() {}
                        function n1c() {}
                        function r1c() {}
                        function v1c() {}
                        function x1c() {}
                        function D1c() {}
                        function H1c() {}
                        function L1c() {}
                        function R1c() {}
                        function V1c() {}
                        function Z1c() {}
                        function Z0c() {}
                        function a0c() {}
                        function c0c() {}
                        function e0c() {}
                        function k0c() {}
                        function o0c() {}
                        function b2c() {}
                        function l2c() {}
                        function p2c() {}
                        function Y2c() {}
                        function _2c() {}
                        function A3c() {}
                        function F3c() {}
                        function I3c() {}
                        function K3c() {}
                        function M3c() {}
                        function Q3c() {}
                        function U3c() {}
                        function c5c() {}
                        function D5c() {}
                        function G5c() {}
                        function J5c() {}
                        function N5c() {}
                        function V5c() {}
                        function p6c() {}
                        function s6c() {}
                        function H6c() {}
                        function K6c() {}
                        function _7c() {}
                        function h8c() {}
                        function j8c() {}
                        function o8c() {}
                        function r8c() {}
                        function u8c() {}
                        function R8c() {}
                        function X8c() {}
                        function o9c() {}
                        function s9c() {}
                        function x9c() {}
                        function Qad() {}
                        function rcd() {}
                        function Xcd() {}
                        function vdd() {}
                        function Tdd() {}
                        function _dd() {}
                        function qed() {}
                        function sed() {}
                        function ved() {}
                        function Hed() {}
                        function Zed() {}
                        function bfd() {}
                        function ifd() {}
                        function Gfd() {}
                        function Ifd() {}
                        function Igd() {}
                        function agd() {}
                        function dgd() {}
                        function pgd() {}
                        function Hgd() {}
                        function Kgd() {}
                        function Mgd() {}
                        function Ogd() {}
                        function Qgd() {}
                        function Sgd() {}
                        function Ugd() {}
                        function Wgd() {}
                        function Ygd() {}
                        function $gd() {}
                        function ahd() {}
                        function chd() {}
                        function ehd() {}
                        function ghd() {}
                        function ihd() {}
                        function khd() {}
                        function mhd() {}
                        function ohd() {}
                        function qhd() {}
                        function shd() {}
                        function Shd() {}
                        function lkd() {}
                        function znd() {}
                        function Jpd() {}
                        function jrd() {}
                        function Mrd() {}
                        function Qrd() {}
                        function Urd() {}
                        function Yrd() {}
                        function Yud() {}
                        function eud() {}
                        function asd() {}
                        function Lsd() {}
                        function btd() {}
                        function dtd() {}
                        function jtd() {}
                        function otd() {}
                        function ztd() {}
                        function Xxd() {}
                        function $yd() {}
                        function rzd() {}
                        function Rzd() {}
                        function KAd() {}
                        function hCd() {}
                        function _Cd() {}
                        function _Sd() {}
                        function OSd() {}
                        function BDd() {}
                        function BId() {}
                        function JId() {}
                        function YHd() {}
                        function fLd() {}
                        function cPd() {}
                        function hQd() {}
                        function AQd() {}
                        function kUd() {}
                        function VUd() {}
                        function pVd() {}
                        function W$d() {}
                        function Z$d() {}
                        function a_d() {}
                        function i_d() {}
                        function v_d() {}
                        function y_d() {}
                        function f1d() {}
                        function L5d() {}
                        function v6d() {}
                        function b8d() {}
                        function e8d() {}
                        function h8d() {}
                        function k8d() {}
                        function n8d() {}
                        function q8d() {}
                        function t8d() {}
                        function w8d() {}
                        function z8d() {}
                        function X9d() {}
                        function _9d() {}
                        function Mae() {}
                        function cbe() {}
                        function ebe() {}
                        function hbe() {}
                        function kbe() {}
                        function nbe() {}
                        function qbe() {}
                        function tbe() {}
                        function wbe() {}
                        function zbe() {}
                        function Cbe() {}
                        function Fbe() {}
                        function Ibe() {}
                        function Lbe() {}
                        function Obe() {}
                        function Rbe() {}
                        function Ube() {}
                        function Xbe() {}
                        function $be() {}
                        function bce() {}
                        function ece() {}
                        function hce() {}
                        function kce() {}
                        function nce() {}
                        function qce() {}
                        function tce() {}
                        function wce() {}
                        function zce() {}
                        function Cce() {}
                        function Fce() {}
                        function Ice() {}
                        function Lce() {}
                        function Oce() {}
                        function Rce() {}
                        function Uce() {}
                        function Xce() {}
                        function $ce() {}
                        function bde() {}
                        function ede() {}
                        function hde() {}
                        function kde() {}
                        function nde() {}
                        function qde() {}
                        function tde() {}
                        function wde() {}
                        function Hie() {}
                        function rke() {}
                        function rne() {}
                        function Ene() {}
                        function Gne() {}
                        function Jne() {}
                        function Mne() {}
                        function Pne() {}
                        function Sne() {}
                        function Vne() {}
                        function Yne() {}
                        function _ne() {}
                        function yme() {}
                        function coe() {}
                        function foe() {}
                        function ioe() {}
                        function loe() {}
                        function ooe() {}
                        function roe() {}
                        function uoe() {}
                        function xoe() {}
                        function Aoe() {}
                        function Doe() {}
                        function Goe() {}
                        function Joe() {}
                        function Moe() {}
                        function Poe() {}
                        function Soe() {}
                        function Voe() {}
                        function Yoe() {}
                        function _oe() {}
                        function cpe() {}
                        function fpe() {}
                        function ipe() {}
                        function lpe() {}
                        function ope() {}
                        function rpe() {}
                        function upe() {}
                        function xpe() {}
                        function Ape() {}
                        function Dpe() {}
                        function Gpe() {}
                        function Jpe() {}
                        function Mpe() {}
                        function Ppe() {}
                        function Spe() {}
                        function Vpe() {}
                        function Ype() {}
                        function _pe() {}
                        function cqe() {}
                        function fqe() {}
                        function iqe() {}
                        function lqe() {}
                        function oqe() {}
                        function rqe() {}
                        function uqe() {}
                        function Tqe() {}
                        function sue() {}
                        function Cue() {}
                        function A2b(a) {}
                        function J3d(a) {}
                        function zl() {
                            wb();
                        }
                        function z7b() {
                            s7b();
                        }
                        function ZHb() {
                            YHb();
                        }
                        function fSb() {
                            eSb();
                        }
                        function vSb() {
                            tSb();
                        }
                        function PUb() {
                            OUb();
                        }
                        function AVb() {
                            yVb();
                        }
                        function RVb() {
                            QVb();
                        }
                        function fWb() {
                            dWb();
                        }
                        function N5b() {
                            H5b();
                        }
                        function $9b() {
                            U9b();
                        }
                        function Lcc() {
                            Hcc();
                        }
                        function pdc() {
                            Zcc();
                        }
                        function pec() {
                            iec();
                        }
                        function pGc() {
                            nGc();
                        }
                        function jGc() {
                            gGc();
                        }
                        function YGc() {
                            SGc();
                        }
                        function cGc() {
                            _Fc();
                        }
                        function NFc() {
                            KFc();
                        }
                        function xgc() {
                            sgc();
                        }
                        function xHc() {
                            tHc();
                        }
                        function pHc() {
                            lHc();
                        }
                        function IHc() {
                            CHc();
                        }
                        function XHc() {
                            RHc();
                        }
                        function boc() {
                            Mnc();
                        }
                        function yqc() {
                            mqc();
                        }
                        function Pzc() {
                            Ozc();
                        }
                        function ACc() {
                            yCc();
                        }
                        function aKc() {
                            YJc();
                        }
                        function FLc() {
                            DLc();
                        }
                        function DNc() {
                            ANc();
                        }
                        function TNc() {
                            JNc();
                        }
                        function iQc() {
                            gQc();
                        }
                        function WRc() {
                            TRc();
                        }
                        function C$c() {
                            B$c();
                        }
                        function J0c() {
                            B0c();
                        }
                        function x0c() {
                            r0c();
                        }
                        function j_c() {
                            h_c();
                        }
                        function N_c() {
                            H_c();
                        }
                        function V_c() {
                            R_c();
                        }
                        function E4c() {
                            D4c();
                        }
                        function a5c() {
                            $4c();
                        }
                        function v7c() {
                            u7c();
                        }
                        function Z7c() {
                            X7c();
                        }
                        function pcd() {
                            ncd();
                        }
                        function Lcd() {
                            Kcd();
                        }
                        function Vcd() {
                            Tcd();
                        }
                        function fUd() {
                            TTd();
                        }
                        function Bfd() {
                            Afd();
                        }
                        function jkd() {
                            hkd();
                        }
                        function vmd() {
                            umd();
                        }
                        function xnd() {
                            vnd();
                        }
                        function Hpd() {
                            Fpd();
                        }
                        function HYd() {
                            lYd();
                        }
                        function yAd() {
                            qAd();
                        }
                        function gke() {
                            rue();
                        }
                        function Yxb(a) {
                            uFb(a);
                        }
                        function Yb(a) {
                            this.a = a;
                        }
                        function cc(a) {
                            this.a = a;
                        }
                        function df(a) {
                            this.a = a;
                        }
                        function kf(a) {
                            this.a = a;
                        }
                        function kj(a) {
                            this.a = a;
                        }
                        function qj(a) {
                            this.a = a;
                        }
                        function Lj(a) {
                            this.a = a;
                        }
                        function jh(a) {
                            this.a = a;
                        }
                        function th(a) {
                            this.a = a;
                        }
                        function Bh(a) {
                            this.a = a;
                        }
                        function Xh(a) {
                            this.a = a;
                        }
                        function Xn(a) {
                            this.a = a;
                        }
                        function Di(a) {
                            this.a = a;
                        }
                        function Ki(a) {
                            this.a = a;
                        }
                        function Ik(a) {
                            this.a = a;
                        }
                        function Qk(a) {
                            this.a = a;
                        }
                        function mp(a) {
                            this.a = a;
                        }
                        function Lp(a) {
                            this.a = a;
                        }
                        function iq(a) {
                            this.a = a;
                        }
                        function Eq(a) {
                            this.a = a;
                        }
                        function Vq(a) {
                            this.a = a;
                        }
                        function Or(a) {
                            this.a = a;
                        }
                        function $r(a) {
                            this.b = a;
                        }
                        function Aj(a) {
                            this.c = a;
                        }
                        function vu(a) {
                            this.a = a;
                        }
                        function vw(a) {
                            this.a = a;
                        }
                        function gw(a) {
                            this.a = a;
                        }
                        function lw(a) {
                            this.a = a;
                        }
                        function Iw(a) {
                            this.a = a;
                        }
                        function Nw(a) {
                            this.a = a;
                        }
                        function Sw(a) {
                            this.a = a;
                        }
                        function ex(a) {
                            this.a = a;
                        }
                        function fx(a) {
                            this.a = a;
                        }
                        function lx(a) {
                            this.a = a;
                        }
                        function my(a) {
                            this.a = a;
                        }
                        function qy(a) {
                            this.a = a;
                        }
                        function Oy(a) {
                            this.a = a;
                        }
                        function NB(a) {
                            this.a = a;
                        }
                        function XB(a) {
                            this.a = a;
                        }
                        function hC(a) {
                            this.a = a;
                        }
                        function vC(a) {
                            this.a = a;
                        }
                        function MB() {
                            this.a = [];
                        }
                        function HEb(a, b) {
                            a.a = b;
                        }
                        function E2b(a, b) {
                            a.a = b;
                        }
                        function F2b(a, b) {
                            a.b = b;
                        }
                        function PRb(a, b) {
                            a.b = b;
                        }
                        function RRb(a, b) {
                            a.b = b;
                        }
                        function QJb(a, b) {
                            a.j = b;
                        }
                        function hQb(a, b) {
                            a.g = b;
                        }
                        function iQb(a, b) {
                            a.i = b;
                        }
                        function _Tb(a, b) {
                            a.c = b;
                        }
                        function G2b(a, b) {
                            a.c = b;
                        }
                        function H2b(a, b) {
                            a.d = b;
                        }
                        function aUb(a, b) {
                            a.d = b;
                        }
                        function h3b(a, b) {
                            a.k = b;
                        }
                        function O3b(a, b) {
                            a.c = b;
                        }
                        function Tmc(a, b) {
                            a.c = b;
                        }
                        function Smc(a, b) {
                            a.a = b;
                        }
                        function DJc(a, b) {
                            a.a = b;
                        }
                        function EJc(a, b) {
                            a.f = b;
                        }
                        function NSc(a, b) {
                            a.a = b;
                        }
                        function OSc(a, b) {
                            a.b = b;
                        }
                        function PSc(a, b) {
                            a.d = b;
                        }
                        function QSc(a, b) {
                            a.i = b;
                        }
                        function RSc(a, b) {
                            a.o = b;
                        }
                        function SSc(a, b) {
                            a.r = b;
                        }
                        function yUc(a, b) {
                            a.a = b;
                        }
                        function zUc(a, b) {
                            a.b = b;
                        }
                        function q3c(a, b) {
                            a.e = b;
                        }
                        function r3c(a, b) {
                            a.f = b;
                        }
                        function s3c(a, b) {
                            a.g = b;
                        }
                        function Y9c(a, b) {
                            a.e = b;
                        }
                        function Z9c(a, b) {
                            a.f = b;
                        }
                        function kad(a, b) {
                            a.f = b;
                        }
                        function Ntd(a, b) {
                            a.a = b;
                        }
                        function Otd(a, b) {
                            a.b = b;
                        }
                        function BWd(a, b) {
                            a.n = b;
                        }
                        function $ee(a, b) {
                            a.a = b;
                        }
                        function _ee(a, b) {
                            a.c = b;
                        }
                        function ife(a, b) {
                            a.c = b;
                        }
                        function Efe(a, b) {
                            a.c = b;
                        }
                        function hfe(a, b) {
                            a.a = b;
                        }
                        function Dfe(a, b) {
                            a.a = b;
                        }
                        function jfe(a, b) {
                            a.d = b;
                        }
                        function Ffe(a, b) {
                            a.d = b;
                        }
                        function kfe(a, b) {
                            a.e = b;
                        }
                        function Gfe(a, b) {
                            a.e = b;
                        }
                        function lfe(a, b) {
                            a.g = b;
                        }
                        function Hfe(a, b) {
                            a.f = b;
                        }
                        function Ife(a, b) {
                            a.j = b;
                        }
                        function wme(a, b) {
                            a.a = b;
                        }
                        function Fme(a, b) {
                            a.a = b;
                        }
                        function xme(a, b) {
                            a.b = b;
                        }
                        function gmc(a) {
                            a.b = a.a;
                        }
                        function Lg(a) {
                            a.c = a.d.d;
                        }
                        function fgb(a) {
                            this.a = a;
                        }
                        function zgb(a) {
                            this.a = a;
                        }
                        function Xgb(a) {
                            this.a = a;
                        }
                        function Xkb(a) {
                            this.a = a;
                        }
                        function mkb(a) {
                            this.a = a;
                        }
                        function reb(a) {
                            this.a = a;
                        }
                        function Seb(a) {
                            this.a = a;
                        }
                        function bfb(a) {
                            this.a = a;
                        }
                        function Tfb(a) {
                            this.a = a;
                        }
                        function blb(a) {
                            this.a = a;
                        }
                        function glb(a) {
                            this.a = a;
                        }
                        function llb(a) {
                            this.a = a;
                        }
                        function Ulb(a) {
                            this.a = a;
                        }
                        function _lb(a) {
                            this.a = a;
                        }
                        function Plb(a) {
                            this.b = a;
                        }
                        function Ppb(a) {
                            this.b = a;
                        }
                        function xpb(a) {
                            this.b = a;
                        }
                        function mpb(a) {
                            this.a = a;
                        }
                        function Yqb(a) {
                            this.a = a;
                        }
                        function uqb(a) {
                            this.c = a;
                        }
                        function Anb(a) {
                            this.c = a;
                        }
                        function zwb(a) {
                            this.c = a;
                        }
                        function Dkb(a) {
                            this.d = a;
                        }
                        function brb(a) {
                            this.a = a;
                        }
                        function Frb(a) {
                            this.a = a;
                        }
                        function hsb(a) {
                            this.a = a;
                        }
                        function ctb(a) {
                            this.a = a;
                        }
                        function cxb(a) {
                            this.a = a;
                        }
                        function axb(a) {
                            this.a = a;
                        }
                        function exb(a) {
                            this.a = a;
                        }
                        function gxb(a) {
                            this.a = a;
                        }
                        function wub(a) {
                            this.a = a;
                        }
                        function zAb(a) {
                            this.a = a;
                        }
                        function JAb(a) {
                            this.a = a;
                        }
                        function LAb(a) {
                            this.a = a;
                        }
                        function PAb(a) {
                            this.a = a;
                        }
                        function VBb(a) {
                            this.a = a;
                        }
                        function lCb(a) {
                            this.a = a;
                        }
                        function nCb(a) {
                            this.a = a;
                        }
                        function pCb(a) {
                            this.a = a;
                        }
                        function CCb(a) {
                            this.a = a;
                        }
                        function GCb(a) {
                            this.a = a;
                        }
                        function bDb(a) {
                            this.a = a;
                        }
                        function dDb(a) {
                            this.a = a;
                        }
                        function fDb(a) {
                            this.a = a;
                        }
                        function uDb(a) {
                            this.a = a;
                        }
                        function $Db(a) {
                            this.a = a;
                        }
                        function aEb(a) {
                            this.a = a;
                        }
                        function eEb(a) {
                            this.a = a;
                        }
                        function OEb(a) {
                            this.a = a;
                        }
                        function SEb(a) {
                            this.a = a;
                        }
                        function SFb(a) {
                            this.a = a;
                        }
                        function HFb(a) {
                            this.a = a;
                        }
                        function NFb(a) {
                            this.a = a;
                        }
                        function WGb(a) {
                            this.a = a;
                        }
                        function HJb(a) {
                            this.a = a;
                        }
                        function PJb(a) {
                            this.a = a;
                        }
                        function kNb(a) {
                            this.a = a;
                        }
                        function tOb(a) {
                            this.a = a;
                        }
                        function APb(a) {
                            this.a = a;
                        }
                        function IQb(a) {
                            this.a = a;
                        }
                        function bTb(a) {
                            this.a = a;
                        }
                        function dTb(a) {
                            this.a = a;
                        }
                        function wTb(a) {
                            this.a = a;
                        }
                        function GWb(a) {
                            this.a = a;
                        }
                        function UWb(a) {
                            this.a = a;
                        }
                        function WWb(a) {
                            this.a = a;
                        }
                        function fXb(a) {
                            this.a = a;
                        }
                        function jXb(a) {
                            this.a = a;
                        }
                        function M0b(a) {
                            this.a = a;
                        }
                        function r1b(a) {
                            this.a = a;
                        }
                        function D1b(a) {
                            this.e = a;
                        }
                        function T3b(a) {
                            this.a = a;
                        }
                        function W3b(a) {
                            this.a = a;
                        }
                        function _3b(a) {
                            this.a = a;
                        }
                        function c4b(a) {
                            this.a = a;
                        }
                        function s5b(a) {
                            this.a = a;
                        }
                        function u5b(a) {
                            this.a = a;
                        }
                        function y5b(a) {
                            this.a = a;
                        }
                        function C5b(a) {
                            this.a = a;
                        }
                        function Q5b(a) {
                            this.a = a;
                        }
                        function S5b(a) {
                            this.a = a;
                        }
                        function U5b(a) {
                            this.a = a;
                        }
                        function W5b(a) {
                            this.a = a;
                        }
                        function l7b(a) {
                            this.a = a;
                        }
                        function p7b(a) {
                            this.a = a;
                        }
                        function k8b(a) {
                            this.a = a;
                        }
                        function L8b(a) {
                            this.a = a;
                        }
                        function Rac(a) {
                            this.a = a;
                        }
                        function Xac(a) {
                            this.a = a;
                        }
                        function $ac(a) {
                            this.a = a;
                        }
                        function bbc(a) {
                            this.a = a;
                        }
                        function Cdc(a) {
                            this.a = a;
                        }
                        function Edc(a) {
                            this.a = a;
                        }
                        function Ehc(a) {
                            this.a = a;
                        }
                        function khc(a) {
                            this.a = a;
                        }
                        function Ihc(a) {
                            this.a = a;
                        }
                        function qfc(a) {
                            this.a = a;
                        }
                        function tfc(a) {
                            this.a = a;
                        }
                        function Wfc(a) {
                            this.a = a;
                        }
                        function Fic(a) {
                            this.a = a;
                        }
                        function Vic(a) {
                            this.a = a;
                        }
                        function fjc(a) {
                            this.a = a;
                        }
                        function pjc(a) {
                            this.a = a;
                        }
                        function ckc(a) {
                            this.a = a;
                        }
                        function hkc(a) {
                            this.a = a;
                        }
                        function Ykc(a) {
                            this.a = a;
                        }
                        function $kc(a) {
                            this.a = a;
                        }
                        function alc(a) {
                            this.a = a;
                        }
                        function glc(a) {
                            this.a = a;
                        }
                        function ilc(a) {
                            this.a = a;
                        }
                        function slc(a) {
                            this.a = a;
                        }
                        function Clc(a) {
                            this.a = a;
                        }
                        function xoc(a) {
                            this.a = a;
                        }
                        function zoc(a) {
                            this.a = a;
                        }
                        function spc(a) {
                            this.a = a;
                        }
                        function Vqc(a) {
                            this.a = a;
                        }
                        function Xqc(a) {
                            this.a = a;
                        }
                        function Gsc(a) {
                            this.a = a;
                        }
                        function Isc(a) {
                            this.a = a;
                        }
                        function JGc(a) {
                            this.a = a;
                        }
                        function NGc(a) {
                            this.a = a;
                        }
                        function MHc(a) {
                            this.a = a;
                        }
                        function JIc(a) {
                            this.a = a;
                        }
                        function fJc(a) {
                            this.a = a;
                        }
                        function BJc(a) {
                            this.a = a;
                        }
                        function dJc(a) {
                            this.c = a;
                        }
                        function Trc(a) {
                            this.b = a;
                        }
                        function eKc(a) {
                            this.a = a;
                        }
                        function IKc(a) {
                            this.a = a;
                        }
                        function KKc(a) {
                            this.a = a;
                        }
                        function MKc(a) {
                            this.a = a;
                        }
                        function yLc(a) {
                            this.a = a;
                        }
                        function HMc(a) {
                            this.a = a;
                        }
                        function LMc(a) {
                            this.a = a;
                        }
                        function PMc(a) {
                            this.a = a;
                        }
                        function TMc(a) {
                            this.a = a;
                        }
                        function XMc(a) {
                            this.a = a;
                        }
                        function ZMc(a) {
                            this.a = a;
                        }
                        function aNc(a) {
                            this.a = a;
                        }
                        function jNc(a) {
                            this.a = a;
                        }
                        function aPc(a) {
                            this.a = a;
                        }
                        function gPc(a) {
                            this.a = a;
                        }
                        function kPc(a) {
                            this.a = a;
                        }
                        function yPc(a) {
                            this.a = a;
                        }
                        function CPc(a) {
                            this.a = a;
                        }
                        function JPc(a) {
                            this.a = a;
                        }
                        function RPc(a) {
                            this.a = a;
                        }
                        function XPc(a) {
                            this.a = a;
                        }
                        function mRc(a) {
                            this.a = a;
                        }
                        function xTc(a) {
                            this.a = a;
                        }
                        function CWc(a) {
                            this.a = a;
                        }
                        function EWc(a) {
                            this.a = a;
                        }
                        function IWc(a) {
                            this.a = a;
                        }
                        function OWc(a) {
                            this.a = a;
                        }
                        function dXc(a) {
                            this.a = a;
                        }
                        function gXc(a) {
                            this.a = a;
                        }
                        function EXc(a) {
                            this.a = a;
                        }
                        function WXc(a) {
                            this.a = a;
                        }
                        function YXc(a) {
                            this.a = a;
                        }
                        function aYc(a) {
                            this.a = a;
                        }
                        function cYc(a) {
                            this.a = a;
                        }
                        function eYc(a) {
                            this.a = a;
                        }
                        function iYc(a) {
                            this.a = a;
                        }
                        function i0c(a) {
                            this.a = a;
                        }
                        function g0c(a) {
                            this.a = a;
                        }
                        function P1c(a) {
                            this.a = a;
                        }
                        function Sad(a) {
                            this.a = a;
                        }
                        function Uad(a) {
                            this.a = a;
                        }
                        function Wad(a) {
                            this.a = a;
                        }
                        function Yad(a) {
                            this.a = a;
                        }
                        function cbd(a) {
                            this.a = a;
                        }
                        function ydd(a) {
                            this.a = a;
                        }
                        function Kdd(a) {
                            this.a = a;
                        }
                        function Mdd(a) {
                            this.a = a;
                        }
                        function _ed(a) {
                            this.a = a;
                        }
                        function dfd(a) {
                            this.a = a;
                        }
                        function Kfd(a) {
                            this.a = a;
                        }
                        function prd(a) {
                            this.a = a;
                        }
                        function $rd(a) {
                            this.a = a;
                        }
                        function csd(a) {
                            this.a = a;
                        }
                        function Usd(a) {
                            this.a = a;
                        }
                        function Vtd(a) {
                            this.a = a;
                        }
                        function wud(a) {
                            this.a = a;
                        }
                        function Rud(a) {
                            this.f = a;
                        }
                        function LEd(a) {
                            this.a = a;
                        }
                        function UEd(a) {
                            this.a = a;
                        }
                        function VEd(a) {
                            this.a = a;
                        }
                        function WEd(a) {
                            this.a = a;
                        }
                        function XEd(a) {
                            this.a = a;
                        }
                        function YEd(a) {
                            this.a = a;
                        }
                        function ZEd(a) {
                            this.a = a;
                        }
                        function $Ed(a) {
                            this.a = a;
                        }
                        function _Ed(a) {
                            this.a = a;
                        }
                        function aFd(a) {
                            this.a = a;
                        }
                        function gFd(a) {
                            this.a = a;
                        }
                        function iFd(a) {
                            this.a = a;
                        }
                        function jFd(a) {
                            this.a = a;
                        }
                        function kFd(a) {
                            this.a = a;
                        }
                        function lFd(a) {
                            this.a = a;
                        }
                        function nFd(a) {
                            this.a = a;
                        }
                        function qFd(a) {
                            this.a = a;
                        }
                        function wFd(a) {
                            this.a = a;
                        }
                        function xFd(a) {
                            this.a = a;
                        }
                        function zFd(a) {
                            this.a = a;
                        }
                        function AFd(a) {
                            this.a = a;
                        }
                        function BFd(a) {
                            this.a = a;
                        }
                        function CFd(a) {
                            this.a = a;
                        }
                        function DFd(a) {
                            this.a = a;
                        }
                        function MFd(a) {
                            this.a = a;
                        }
                        function OFd(a) {
                            this.a = a;
                        }
                        function QFd(a) {
                            this.a = a;
                        }
                        function SFd(a) {
                            this.a = a;
                        }
                        function uGd(a) {
                            this.a = a;
                        }
                        function QGd(a) {
                            this.a = a;
                        }
                        function jGd(a) {
                            this.b = a;
                        }
                        function YOd(a) {
                            this.a = a;
                        }
                        function ePd(a) {
                            this.a = a;
                        }
                        function kPd(a) {
                            this.a = a;
                        }
                        function qPd(a) {
                            this.a = a;
                        }
                        function IPd(a) {
                            this.a = a;
                        }
                        function w$d(a) {
                            this.a = a;
                        }
                        function e_d(a) {
                            this.a = a;
                        }
                        function Q_d(a) {
                            this.b = a;
                        }
                        function c1d(a) {
                            this.a = a;
                        }
                        function c2d(a) {
                            this.a = a;
                        }
                        function l5d(a) {
                            this.a = a;
                        }
                        function I9d(a) {
                            this.a = a;
                        }
                        function L6d(a) {
                            this.c = a;
                        }
                        function t7d(a) {
                            this.e = a;
                        }
                        function pae(a) {
                            this.a = a;
                        }
                        function xae(a) {
                            this.a = a;
                        }
                        function Zde(a) {
                            this.a = a;
                        }
                        function Sde(a) {
                            this.d = a;
                        }
                        function mee(a) {
                            this.a = a;
                        }
                        function uje(a) {
                            this.a = a;
                        }
                        function Bte(a) {
                            this.a = a;
                        }
                        function Wse(a) {
                            this.e = a;
                        }
                        function Xsd() {
                            this.a = 0;
                        }
                        function Tsb() {
                            akb(this);
                        }
                        function bnb() {
                            Pmb(this);
                        }
                        function cHb() {
                            bHb(this);
                        }
                        function I2b() {
                            A2b(this);
                        }
                        function s2d() {
                            this.c = d2d;
                        }
                        function Prc(a, b) {
                            a.b += b;
                        }
                        function Uje(a, b) {
                            b.Wb(a);
                        }
                        function UC(a) {
                            return a.a;
                        }
                        function nC(a) {
                            return a.a;
                        }
                        function BC(a) {
                            return a.a;
                        }
                        function TB(a) {
                            return a.a;
                        }
                        function _B(a) {
                            return a.a;
                        }
                        function Adb(a) {
                            return a.e;
                        }
                        function gC() {
                            return null;
                        }
                        function MC() {
                            return null;
                        }
                        function leb() {
                            MId();
                            OId();
                        }
                        function qMb(a) {
                            a.b.Of(a.e);
                        }
                        function A$b(a) {
                            a.b = new Ri;
                        }
                        function A8b(a, b) {
                            a.b = b - a.b;
                        }
                        function x8b(a, b) {
                            a.a = b - a.a;
                        }
                        function ZEb(a, b) {
                            a.push(b);
                        }
                        function bFb(a, b) {
                            a.sort(b);
                        }
                        function Q5c(a, b) {
                            b.jd(a.a);
                        }
                        function Voc(a, b) {
                            Q3b(b, a);
                        }
                        function tp(a, b, c) {
                            a.Yd(c, b);
                        }
                        function Ss(a, b) {
                            a.e = b;
                            b.b = a;
                        }
                        function im(a) {
                            _l();
                            this.a = a;
                        }
                        function xq(a) {
                            _l();
                            this.a = a;
                        }
                        function Gq(a) {
                            _l();
                            this.a = a;
                        }
                        function Xq(a) {
                            tm();
                            this.a = a;
                        }
                        function gA(a) {
                            fA();
                            eA.le(a);
                        }
                        function vA() {
                            vA = geb;
                            new Tsb;
                        }
                        function xz() {
                            mz.call(this);
                        }
                        function Ceb() {
                            mz.call(this);
                        }
                        function ueb() {
                            xz.call(this);
                        }
                        function yeb() {
                            xz.call(this);
                        }
                        function Hfb() {
                            xz.call(this);
                        }
                        function _fb() {
                            xz.call(this);
                        }
                        function cgb() {
                            xz.call(this);
                        }
                        function Ngb() {
                            xz.call(this);
                        }
                        function jib() {
                            xz.call(this);
                        }
                        function Jrb() {
                            xz.call(this);
                        }
                        function Srb() {
                            xz.call(this);
                        }
                        function Dvb() {
                            xz.call(this);
                        }
                        function Ied() {
                            xz.call(this);
                        }
                        function R1d() {
                            this.a = this;
                        }
                        function k1d() {
                            this.Bb |= 256;
                        }
                        function vWb() {
                            this.b = new Et;
                        }
                        function aFb(a, b) {
                            a.length = b;
                        }
                        function dyb(a, b) {
                            Rmb(a.a, b);
                        }
                        function jNb(a, b) {
                            LKb(a.c, b);
                        }
                        function qRc(a, b) {
                            Ysb(a.b, b);
                        }
                        function VOd(a, b) {
                            UNd(a.a, b);
                        }
                        function WOd(a, b) {
                            VNd(a.a, b);
                        }
                        function eZd(a, b) {
                            qvd(a.e, b);
                        }
                        function Cke(a) {
                            bge(a.c, a.b);
                        }
                        function uj(a, b) {
                            a.kc().Nb(b);
                        }
                        function Ufb(a) {
                            this.a = Zfb(a);
                        }
                        function _sb() {
                            this.a = new Tsb;
                        }
                        function $Ab() {
                            this.a = new Tsb;
                        }
                        function xAb() {
                            this.a = new dzb;
                        }
                        function gyb() {
                            this.a = new bnb;
                        }
                        function BIb() {
                            this.a = new bnb;
                        }
                        function GIb() {
                            this.a = new bnb;
                        }
                        function wIb() {
                            this.a = new pIb;
                        }
                        function gJb() {
                            this.a = new DIb;
                        }
                        function TTb() {
                            this.a = new DTb;
                        }
                        function jGb() {
                            this.a = new fGb;
                        }
                        function qGb() {
                            this.a = new kGb;
                        }
                        function q_b() {
                            this.a = new bnb;
                        }
                        function E_b() {
                            this.a = new bnb;
                        }
                        function EZb() {
                            this.a = new bnb;
                        }
                        function J$b() {
                            this.a = new bnb;
                        }
                        function YNb() {
                            this.d = new bnb;
                        }
                        function lXb() {
                            this.a = new RWb;
                        }
                        function y_b() {
                            this.a = new _sb;
                        }
                        function k5b() {
                            this.a = new Tsb;
                        }
                        function E0b() {
                            this.b = new Tsb;
                        }
                        function jHc() {
                            this.b = new bnb;
                        }
                        function ZNc() {
                            this.e = new bnb;
                        }
                        function ahc() {
                            this.a = new boc;
                        }
                        function UQc() {
                            this.d = new bnb;
                        }
                        function uRc() {
                            tRc.call(this);
                        }
                        function BRc() {
                            tRc.call(this);
                        }
                        function VOc() {
                            bnb.call(this);
                        }
                        function web() {
                            ueb.call(this);
                        }
                        function Fyb() {
                            gyb.call(this);
                        }
                        function fKb() {
                            RJb.call(this);
                        }
                        function N$b() {
                            J$b.call(this);
                        }
                        function P2b() {
                            I2b.call(this);
                        }
                        function T2b() {
                            P2b.call(this);
                        }
                        function z3b() {
                            I2b.call(this);
                        }
                        function C3b() {
                            z3b.call(this);
                        }
                        function cUc() {
                            aUc.call(this);
                        }
                        function hUc() {
                            aUc.call(this);
                        }
                        function mUc() {
                            aUc.call(this);
                        }
                        function Hdd() {
                            Ddd.call(this);
                        }
                        function ACd() {
                            $yd.call(this);
                        }
                        function PCd() {
                            $yd.call(this);
                        }
                        function Ejd() {
                            Yub.call(this);
                        }
                        function LQd() {
                            wQd.call(this);
                        }
                        function lRd() {
                            wQd.call(this);
                        }
                        function MSd() {
                            Tsb.call(this);
                        }
                        function VSd() {
                            Tsb.call(this);
                        }
                        function eTd() {
                            Tsb.call(this);
                        }
                        function mXd() {
                            HWd.call(this);
                        }
                        function i1d() {
                            _sb.call(this);
                        }
                        function A1d() {
                            k1d.call(this);
                        }
                        function q4d() {
                            dWd.call(this);
                        }
                        function O5d() {
                            Tsb.call(this);
                        }
                        function R5d() {
                            dWd.call(this);
                        }
                        function lae() {
                            Tsb.call(this);
                        }
                        function Cae() {
                            Tsb.call(this);
                        }
                        function ome() {
                            kUd.call(this);
                        }
                        function Hme() {
                            ome.call(this);
                        }
                        function Nme() {
                            kUd.call(this);
                        }
                        function Gre() {
                            Tqe.call(this);
                        }
                        function aUc() {
                            this.a = new _sb;
                        }
                        function nZc() {
                            this.a = new Tsb;
                        }
                        function DZc() {
                            this.a = new bnb;
                        }
                        function Ddd() {
                            this.a = new Tsb;
                        }
                        function Oqd() {
                            this.a = new Yub;
                        }
                        function Oed() {
                            this.j = new bnb;
                        }
                        function obd() {
                            this.a = new nbd;
                        }
                        function wQd() {
                            this.a = new AQd;
                        }
                        function R5c() {
                            this.a = new V5c;
                        }
                        function wb() {
                            wb = geb;
                            vb = new xb;
                        }
                        function Wk() {
                            Wk = geb;
                            Vk = new Xk;
                        }
                        function kl() {
                            kl = geb;
                            jl = new ll;
                        }
                        function ll() {
                            Qk.call(this, '');
                        }
                        function Xk() {
                            Qk.call(this, '');
                        }
                        function Dd(a) {
                            yd.call(this, a);
                        }
                        function Hd(a) {
                            yd.call(this, a);
                        }
                        function xh(a) {
                            th.call(this, a);
                        }
                        function $h(a) {
                            Wc.call(this, a);
                        }
                        function Qi(a) {
                            Wc.call(this, a);
                        }
                        function wi(a) {
                            $h.call(this, a);
                        }
                        function Sp(a) {
                            $h.call(this, a);
                        }
                        function Js(a) {
                            $h.call(this, a);
                        }
                        function Jp(a) {
                            Xo.call(this, a);
                        }
                        function Qp(a) {
                            Xo.call(this, a);
                        }
                        function dq(a) {
                            ho.call(this, a);
                        }
                        function Fv(a) {
                            uv.call(this, a);
                        }
                        function aw(a) {
                            Tr.call(this, a);
                        }
                        function cw(a) {
                            Tr.call(this, a);
                        }
                        function _w(a) {
                            Tr.call(this, a);
                        }
                        function Mx(a) {
                            Gn.call(this, a);
                        }
                        function Nx(a) {
                            Mx.call(this, a);
                        }
                        function yz(a) {
                            nz.call(this, a);
                        }
                        function aC(a) {
                            yz.call(this, a);
                        }
                        function uC() {
                            vC.call(this, {});
                        }
                        function cC() {
                            cC = geb;
                            bC = new dC;
                        }
                        function zs() {
                            zs = geb;
                            ys = new As;
                        }
                        function Az() {
                            Az = geb;
                            zz = new nb;
                        }
                        function $z() {
                            $z = geb;
                            Zz = new bA;
                        }
                        function $A() {
                            $A = geb;
                            ZA = new aB;
                        }
                        function Ovb(a) {
                            Kvb();
                            this.a = a;
                        }
                        function FKc(a) {
                            jKc();
                            this.a = a;
                        }
                        function zud(a) {
                            nud();
                            this.f = a;
                        }
                        function Bud(a) {
                            nud();
                            this.f = a;
                        }
                        function Cde(a) {
                            KMd();
                            this.a = a;
                        }
                        function Lyb(a) {
                            a.b = null;
                            a.c = 0;
                        }
                        function kz(a, b) {
                            a.e = b;
                            hz(a, b);
                        }
                        function NYb(a, b) {
                            a.a = b;
                            PYb(a);
                        }
                        function cLb(a, b, c) {
                            a.a[b.g] = c;
                        }
                        function zsd(a, b, c) {
                            Hsd(c, a, b);
                        }
                        function shc(a, b) {
                            Xmc(b.i, a.n);
                        }
                        function HCc(a, b) {
                            ICc(a).Cd(b);
                        }
                        function yw(a, b) {
                            a.a.ec().Mc(b);
                        }
                        function ns(a, b) {
                            return a.g - b.g;
                        }
                        function AUb(a, b) {
                            return a * a / b;
                        }
                        function Heb(a) {
                            return uFb(a), a;
                        }
                        function Kfb(a) {
                            return uFb(a), a;
                        }
                        function Mfb(a) {
                            return uFb(a), a;
                        }
                        function JC(a) {
                            return new hC(a);
                        }
                        function LC(a) {
                            return new OC(a);
                        }
                        function shb(a) {
                            return uFb(a), a;
                        }
                        function Chb(a) {
                            return uFb(a), a;
                        }
                        function teb(a) {
                            yz.call(this, a);
                        }
                        function veb(a) {
                            yz.call(this, a);
                        }
                        function zeb(a) {
                            yz.call(this, a);
                        }
                        function Aeb(a) {
                            nz.call(this, a);
                        }
                        function Ifb(a) {
                            yz.call(this, a);
                        }
                        function agb(a) {
                            yz.call(this, a);
                        }
                        function dgb(a) {
                            yz.call(this, a);
                        }
                        function Mgb(a) {
                            yz.call(this, a);
                        }
                        function Ogb(a) {
                            yz.call(this, a);
                        }
                        function kib(a) {
                            yz.call(this, a);
                        }
                        function Jed(a) {
                            yz.call(this, a);
                        }
                        function Ked(a) {
                            yz.call(this, a);
                        }
                        function CDd(a) {
                            yz.call(this, a);
                        }
                        function Mle(a) {
                            yz.call(this, a);
                        }
                        function Lqe(a) {
                            yz.call(this, a);
                        }
                        function mob(a) {
                            uFb(a);
                            this.a = a;
                        }
                        function yYb(a) {
                            sYb(a);
                            return a;
                        }
                        function Nnb(a) {
                            Snb(a, a.length);
                        }
                        function nmb(a) {
                            return a.b == a.c;
                        }
                        function Vyb(a) {
                            return !!a && a.b;
                        }
                        function gLb(a) {
                            return !!a && a.k;
                        }
                        function hLb(a) {
                            return !!a && a.j;
                        }
                        function F_b(a, b, c) {
                            a.c.Ef(b, c);
                        }
                        function Ts(a, b) {
                            a.be(b);
                            b.ae(a);
                        }
                        function Fy(a) {
                            _l();
                            this.a = Qb(a);
                        }
                        function Gb() {
                            this.a = WD(Qb(pve));
                        }
                        function jc() {
                            throw Adb(new jib);
                        }
                        function jn() {
                            throw Adb(new jib);
                        }
                        function Hh() {
                            throw Adb(new jib);
                        }
                        function Xi() {
                            throw Adb(new jib);
                        }
                        function Xj() {
                            throw Adb(new jib);
                        }
                        function Yj() {
                            throw Adb(new jib);
                        }
                        function Qz() {
                            Qz = geb;
                            fA(), eA;
                        }
                        function Qhb() {
                            reb.call(this, '');
                        }
                        function Rhb() {
                            reb.call(this, '');
                        }
                        function bib() {
                            reb.call(this, '');
                        }
                        function cib() {
                            reb.call(this, '');
                        }
                        function eib(a) {
                            veb.call(this, a);
                        }
                        function xeb(a) {
                            veb.call(this, a);
                        }
                        function Vgb(a) {
                            agb.call(this, a);
                        }
                        function Lqb(a) {
                            xpb.call(this, a);
                        }
                        function Sqb(a) {
                            Lqb.call(this, a);
                        }
                        function irb(a) {
                            Upb.call(this, a);
                        }
                        function pc(a) {
                            qc.call(this, a, 0);
                        }
                        function Ri() {
                            Si.call(this, 12, 3);
                        }
                        function WC(a, b) {
                            return xfb(a, b);
                        }
                        function cFb(a, b) {
                            return dD(a, b);
                        }
                        function Reb(a, b) {
                            return a.a - b.a;
                        }
                        function afb(a, b) {
                            return a.a - b.a;
                        }
                        function Wgb(a, b) {
                            return a.a - b.a;
                        }
                        function pC(b, a) {
                            return a in b.a;
                        }
                        function Vvb(a) {
                            return a.a ? a.b : 0;
                        }
                        function cwb(a) {
                            return a.a ? a.b : 0;
                        }
                        function Fxb(a, b, c) {
                            b.Cd(a.a[c]);
                        }
                        function Kxb(a, b, c) {
                            b.Pe(a.a[c]);
                        }
                        function uKb(a, b) {
                            a.b = new sjd(b);
                        }
                        function QGb(a, b) {
                            a.b = b;
                            return a;
                        }
                        function RGb(a, b) {
                            a.c = b;
                            return a;
                        }
                        function SGb(a, b) {
                            a.f = b;
                            return a;
                        }
                        function TGb(a, b) {
                            a.g = b;
                            return a;
                        }
                        function yJb(a, b) {
                            a.a = b;
                            return a;
                        }
                        function zJb(a, b) {
                            a.f = b;
                            return a;
                        }
                        function AJb(a, b) {
                            a.k = b;
                            return a;
                        }
                        function WNb(a, b) {
                            a.a = b;
                            return a;
                        }
                        function XNb(a, b) {
                            a.e = b;
                            return a;
                        }
                        function BYb(a, b) {
                            a.e = b;
                            return a;
                        }
                        function CYb(a, b) {
                            a.f = b;
                            return a;
                        }
                        function BRb(a, b) {
                            a.b = true;
                            a.d = b;
                        }
                        function WNc(a, b) {
                            return a.b - b.b;
                        }
                        function KSc(a, b) {
                            return a.g - b.g;
                        }
                        function pmc(a, b) {
                            return a ? 0 : b - 1;
                        }
                        function qKc(a, b) {
                            return a ? 0 : b - 1;
                        }
                        function pKc(a, b) {
                            return a ? b - 1 : 0;
                        }
                        function uVc(a, b) {
                            return a.s - b.s;
                        }
                        function Xed(a, b) {
                            return b.rg(a);
                        }
                        function Xfd(a, b) {
                            a.b = b;
                            return a;
                        }
                        function Wfd(a, b) {
                            a.a = b;
                            return a;
                        }
                        function Yfd(a, b) {
                            a.c = b;
                            return a;
                        }
                        function Zfd(a, b) {
                            a.d = b;
                            return a;
                        }
                        function $fd(a, b) {
                            a.e = b;
                            return a;
                        }
                        function _fd(a, b) {
                            a.f = b;
                            return a;
                        }
                        function mgd(a, b) {
                            a.a = b;
                            return a;
                        }
                        function ngd(a, b) {
                            a.b = b;
                            return a;
                        }
                        function ogd(a, b) {
                            a.c = b;
                            return a;
                        }
                        function Khd(a, b) {
                            a.c = b;
                            return a;
                        }
                        function Jhd(a, b) {
                            a.b = b;
                            return a;
                        }
                        function Lhd(a, b) {
                            a.d = b;
                            return a;
                        }
                        function Mhd(a, b) {
                            a.e = b;
                            return a;
                        }
                        function Nhd(a, b) {
                            a.f = b;
                            return a;
                        }
                        function Ohd(a, b) {
                            a.g = b;
                            return a;
                        }
                        function Phd(a, b) {
                            a.a = b;
                            return a;
                        }
                        function Qhd(a, b) {
                            a.i = b;
                            return a;
                        }
                        function Rhd(a, b) {
                            a.j = b;
                            return a;
                        }
                        function coc(a, b) {
                            Mnc();
                            P3b(b, a);
                        }
                        function bbd(a, b, c) {
                            _ad(a.a, b, c);
                        }
                        function Fjd(a) {
                            Zub.call(this, a);
                        }
                        function TRb(a) {
                            SRb.call(this, a);
                        }
                        function pLc(a) {
                            CIc.call(this, a);
                        }
                        function ILc(a) {
                            CIc.call(this, a);
                        }
                        function gLd(a) {
                            ZHd.call(this, a);
                        }
                        function DPd(a) {
                            xPd.call(this, a);
                        }
                        function FPd(a) {
                            xPd.call(this, a);
                        }
                        function x2b() {
                            y2b.call(this, '');
                        }
                        function pjd() {
                            this.a = 0;
                            this.b = 0;
                        }
                        function ATc() {
                            this.b = 0;
                            this.a = 0;
                        }
                        function lXd(a, b) {
                            a.b = 0;
                            bWd(a, b);
                        }
                        function Kqd(a, b) {
                            a.k = b;
                            return a;
                        }
                        function Lqd(a, b) {
                            a.j = b;
                            return a;
                        }
                        function vfe(a, b) {
                            a.c = b;
                            a.b = true;
                        }
                        function Etb() {
                            Etb = geb;
                            Dtb = Gtb();
                        }
                        function bvd() {
                            bvd = geb;
                            avd = OAd();
                        }
                        function dvd() {
                            dvd = geb;
                            cvd = aCd();
                        }
                        function MId() {
                            MId = geb;
                            LId = ygd();
                        }
                        function jTd() {
                            jTd = geb;
                            iTd = Qae();
                        }
                        function Ole() {
                            Ole = geb;
                            Nle = vne();
                        }
                        function Qle() {
                            Qle = geb;
                            Ple = Cne();
                        }
                        function mfb(a) {
                            return a.e && a.e();
                        }
                        function FD(a) {
                            return a.l | a.m << 22;
                        }
                        function Oc(a, b) {
                            return a.c._b(b);
                        }
                        function En(a, b) {
                            return Wv(a.b, b);
                        }
                        function Vd(a) {
                            return !a ? null : a.d;
                        }
                        function Vv(a) {
                            return !a ? null : a.g;
                        }
                        function $v(a) {
                            return !a ? null : a.i;
                        }
                        function nfb(a) {
                            lfb(a);
                            return a.o;
                        }
                        function Khb(a, b) {
                            a.a += b;
                            return a;
                        }
                        function Lhb(a, b) {
                            a.a += b;
                            return a;
                        }
                        function Ohb(a, b) {
                            a.a += b;
                            return a;
                        }
                        function Uhb(a, b) {
                            a.a += b;
                            return a;
                        }
                        function _wb(a, b) {
                            while(a.Bd(b));
                        }
                        function atb(a) {
                            this.a = new Usb(a);
                        }
                        function $tb() {
                            throw Adb(new jib);
                        }
                        function qpb() {
                            throw Adb(new jib);
                        }
                        function rpb() {
                            throw Adb(new jib);
                        }
                        function spb() {
                            throw Adb(new jib);
                        }
                        function vpb() {
                            throw Adb(new jib);
                        }
                        function Opb() {
                            throw Adb(new jib);
                        }
                        function yAb(a) {
                            this.a = new ezb(a);
                        }
                        function H2c() {
                            this.a = new Wed(s0);
                        }
                        function TVc() {
                            this.b = new Wed(H$);
                        }
                        function l6c() {
                            this.a = new Wed(V0);
                        }
                        function $ad() {
                            this.b = new Wed(I1);
                        }
                        function nbd() {
                            this.b = new Wed(I1);
                        }
                        function T2c(a) {
                            this.a = 0;
                            this.b = a;
                        }
                        function Bib(a) {
                            tib();
                            vib(this, a);
                        }
                        function QDb(a) {
                            LCb(a);
                            return a.a;
                        }
                        function dvb(a) {
                            return a.b != a.d.c;
                        }
                        function AMc(a, b) {
                            return a.d[b.p];
                        }
                        function ued(a, b) {
                            return ned(a, b);
                        }
                        function $Eb(a, b, c) {
                            a.splice(b, c);
                        }
                        function ixb(a, b) {
                            while(a.Re(b));
                        }
                        function NKb(a) {
                            a.c ? MKb(a) : OKb(a);
                        }
                        function mQd() {
                            throw Adb(new jib);
                        }
                        function nQd() {
                            throw Adb(new jib);
                        }
                        function oQd() {
                            throw Adb(new jib);
                        }
                        function pQd() {
                            throw Adb(new jib);
                        }
                        function qQd() {
                            throw Adb(new jib);
                        }
                        function rQd() {
                            throw Adb(new jib);
                        }
                        function sQd() {
                            throw Adb(new jib);
                        }
                        function tQd() {
                            throw Adb(new jib);
                        }
                        function uQd() {
                            throw Adb(new jib);
                        }
                        function vQd() {
                            throw Adb(new jib);
                        }
                        function zue() {
                            throw Adb(new Dvb);
                        }
                        function Aue() {
                            throw Adb(new Dvb);
                        }
                        function oue(a) {
                            this.a = new Dte(a);
                        }
                        function Dte(a) {
                            Cte(this, a, sse());
                        }
                        function cve(a) {
                            return !a || bve(a);
                        }
                        function Cqe(a) {
                            return xqe[a] != -1;
                        }
                        function Yz() {
                            Nz != 0 && (Nz = 0);
                            Pz = -1;
                        }
                        function beb() {
                            _db == null && (_db = []);
                        }
                        function eg(a, b) {
                            zf.call(this, a, b);
                        }
                        function gg(a, b) {
                            eg.call(this, a, b);
                        }
                        function Nj(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function hk(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function nk(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function pk(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function xk(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function zk(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function Kk(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function ne(a, b) {
                            this.e = a;
                            this.d = b;
                        }
                        function Hf(a, b) {
                            this.b = a;
                            this.c = b;
                        }
                        function cp(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function Cp(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function qr(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function Rr(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function vr(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function su(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function Hu(a, b) {
                            this.a = a;
                            this.f = b;
                        }
                        function gp(a, b) {
                            this.g = a;
                            this.i = b;
                        }
                        function qs(a, b) {
                            this.f = a;
                            this.g = b;
                        }
                        function Gv(a, b) {
                            this.b = a;
                            this.c = b;
                        }
                        function Wc(a) {
                            Lb(a.dc());
                            this.c = a;
                        }
                        function Ex(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function ey(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function pv(a) {
                            this.a = RD(Qb(a), 15);
                        }
                        function uv(a) {
                            this.a = RD(Qb(a), 15);
                        }
                        function nw(a) {
                            this.a = RD(Qb(a), 85);
                        }
                        function rf(a) {
                            this.b = RD(Qb(a), 85);
                        }
                        function Tr(a) {
                            this.b = RD(Qb(a), 51);
                        }
                        function uB() {
                            this.q = new $wnd.Date;
                        }
                        function CC(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function Bt(a, b) {
                            return Ujb(a.b, b);
                        }
                        function tpb(a, b) {
                            return a.b.Hc(b);
                        }
                        function upb(a, b) {
                            return a.b.Ic(b);
                        }
                        function wpb(a, b) {
                            return a.b.Qc(b);
                        }
                        function Pqb(a, b) {
                            return a.b.Hc(b);
                        }
                        function pqb(a, b) {
                            return a.c.uc(b);
                        }
                        function rqb(a, b) {
                            return pb(a.c, b);
                        }
                        function Zsb(a, b) {
                            return a.a._b(b);
                        }
                        function Xp(a, b) {
                            return a > b && b < hwe;
                        }
                        function bkb(a) {
                            return a.f.c + a.i.c;
                        }
                        function IC(a) {
                            return WB(), a ? VB : UB;
                        }
                        function Usb(a) {
                            ckb.call(this, a, 0);
                        }
                        function dzb() {
                            ezb.call(this, null);
                        }
                        function Osb(a) {
                            this.c = a;
                            Lsb(this);
                        }
                        function Yub() {
                            Lub(this);
                            Xub(this);
                        }
                        function gib() {
                            gib = geb;
                            fib = new oeb;
                        }
                        function Qob() {
                            Qob = geb;
                            Pob = new Rob;
                        }
                        function Tvb() {
                            Tvb = geb;
                            Svb = new Xvb;
                        }
                        function bwb() {
                            bwb = geb;
                            awb = new dwb;
                        }
                        function SAb() {
                            SAb = geb;
                            RAb = new VAb;
                        }
                        function rDb() {
                            NCb.call(this, null);
                        }
                        function xDb() {
                            xDb = geb;
                            wDb = new KEb;
                        }
                        function FDb(a, b) {
                            LCb(a);
                            a.a.Nb(b);
                        }
                        function sAb(a, b) {
                            return a.a.Xc(b);
                        }
                        function tAb(a, b) {
                            return a.a.Yc(b);
                        }
                        function uAb(a, b) {
                            return a.a.$c(b);
                        }
                        function vAb(a, b) {
                            return a.a._c(b);
                        }
                        function JBb(a, b) {
                            return a.Gc(b), a;
                        }
                        function KBb(a, b) {
                            return ye(a, b), a;
                        }
                        function m_d(a, b) {
                            pLd(xYd(a.a), b);
                        }
                        function r_d(a, b) {
                            pLd(xYd(a.a), b);
                        }
                        function EBb(a, b) {
                            a.Gc(b);
                            return a;
                        }
                        function hGb(a, b) {
                            a.a.f = b;
                            return a;
                        }
                        function nGb(a, b) {
                            a.a.d = b;
                            return a;
                        }
                        function oGb(a, b) {
                            a.a.g = b;
                            return a;
                        }
                        function pGb(a, b) {
                            a.a.j = b;
                            return a;
                        }
                        function sIb(a, b) {
                            a.a.a = b;
                            return a;
                        }
                        function tIb(a, b) {
                            a.a.d = b;
                            return a;
                        }
                        function uIb(a, b) {
                            a.a.e = b;
                            return a;
                        }
                        function vIb(a, b) {
                            a.a.g = b;
                            return a;
                        }
                        function fJb(a, b) {
                            a.a.f = b;
                            return a;
                        }
                        function KJb(a) {
                            a.b = false;
                            return a;
                        }
                        function wGb() {
                            wGb = geb;
                            vGb = new xGb;
                        }
                        function VRb() {
                            VRb = geb;
                            URb = new WRb;
                        }
                        function zXb() {
                            zXb = geb;
                            yXb = new FXb;
                        }
                        function kYb() {
                            kYb = geb;
                            jYb = new lYb;
                        }
                        function pYb() {
                            pYb = geb;
                            oYb = new QYb;
                        }
                        function NZb() {
                            NZb = geb;
                            MZb = new SZb;
                        }
                        function g0b() {
                            g0b = geb;
                            f0b = new l0b;
                        }
                        function i1b() {
                            i1b = geb;
                            h1b = new X1b;
                        }
                        function s7b() {
                            s7b = geb;
                            r7b = new C7b;
                        }
                        function H5b() {
                            H5b = geb;
                            G5b = new pjd;
                        }
                        function Hcc() {
                            Hcc = geb;
                            Gcc = new Ncc;
                        }
                        function Wjc() {
                            Wjc = geb;
                            Vjc = new Jlc;
                        }
                        function mqc() {
                            mqc = geb;
                            lqc = new Aqc;
                        }
                        function GCc() {
                            GCc = geb;
                            FCc = new Yrd;
                        }
                        function sbd() {
                            sbd = geb;
                            rbd = new ubd;
                        }
                        function Cbd() {
                            Cbd = geb;
                            Bbd = new Dbd;
                        }
                        function _cd() {
                            _cd = geb;
                            $cd = new cdd;
                        }
                        function GGc() {
                            yGc();
                            this.c = new Ri;
                        }
                        function ubd() {
                            qs.call(this, DBe, 0);
                        }
                        function Mfd(a, b, c) {
                            $jb(a.d, b.f, c);
                        }
                        function bNb(a, b, c, d) {
                            aNb(a, d, b, c);
                        }
                        function V6b(a, b, c, d) {
                            $6b(d, a, b, c);
                        }
                        function vcc(a, b, c, d) {
                            wcc(d, a, b, c);
                        }
                        function Dgd(a, b) {
                            dub(a.c.c, b.b, b);
                        }
                        function Cgd(a, b) {
                            dub(a.c.b, b.c, b);
                        }
                        function BYc(a) {
                            return a.e.b + a.f.b;
                        }
                        function AYc(a) {
                            return a.e.a + a.f.a;
                        }
                        function N1d(a) {
                            return a.b ? a.b : a.a;
                        }
                        function yTc(a) {
                            return (a.c + a.a) / 2;
                        }
                        function b2d(a, b) {
                            return GA(a.a, b);
                        }
                        function rfd(a, b) {
                            a.a = b.g;
                            return a;
                        }
                        function hTd() {
                            hTd = geb;
                            gTd = new Cae;
                        }
                        function cTd() {
                            cTd = geb;
                            bTd = new eTd;
                        }
                        function lud() {
                            lud = geb;
                            kud = new Yud;
                        }
                        function $Sd() {
                            $Sd = geb;
                            ZSd = new _Sd;
                        }
                        function TSd() {
                            TSd = geb;
                            SSd = new VSd;
                        }
                        function YSd() {
                            YSd = geb;
                            XSd = new O5d;
                        }
                        function PRd() {
                            PRd = geb;
                            ORd = new Tsb;
                        }
                        function N2d() {
                            N2d = geb;
                            M2d = new Uhe;
                        }
                        function j3d() {
                            j3d = geb;
                            i3d = new Yhe;
                        }
                        function Gie() {
                            Gie = geb;
                            Fie = new Hie;
                        }
                        function nke() {
                            nke = geb;
                            mke = new rke;
                        }
                        function uue() {
                            uue = geb;
                            tue = new Cue;
                        }
                        function Tae() {
                            Tae = geb;
                            Rae = new bnb;
                        }
                        function _v(a) {
                            return RD(a, 44).ld();
                        }
                        function Akb(a) {
                            return a.b < a.d.gc();
                        }
                        function meb(b, a) {
                            return a.split(b);
                        }
                        function Idb(a, b) {
                            return Ddb(a, b) > 0;
                        }
                        function Ldb(a, b) {
                            return Ddb(a, b) < 0;
                        }
                        function Urb(a, b) {
                            return Bsb(a.a, b);
                        }
                        function Beb(a, b) {
                            oz.call(this, a, b);
                        }
                        function Qx(a) {
                            Px();
                            ho.call(this, a);
                        }
                        function Lnb(a, b) {
                            Pnb(a, a.length, b);
                        }
                        function Mnb(a, b) {
                            Rnb(a, a.length, b);
                        }
                        function Ktb(a, b) {
                            return a.a.get(b);
                        }
                        function bub(a, b) {
                            return Ujb(a.e, b);
                        }
                        function Zxb(a) {
                            return uFb(a), false;
                        }
                        function zw(a) {
                            this.a = RD(Qb(a), 229);
                        }
                        function $wb(a) {
                            Swb.call(this, a, 21);
                        }
                        function dAb(a, b) {
                            qs.call(this, a, b);
                        }
                        function yBb(a, b) {
                            qs.call(this, a, b);
                        }
                        function ssb(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function xlb(a, b) {
                            this.d = a;
                            this.e = b;
                        }
                        function jEb(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function pEb(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function vEb(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function BEb(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function TFb(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function QEb(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function sHb(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function EHb(a, b) {
                            qs.call(this, a, b);
                        }
                        function MHb(a, b) {
                            qs.call(this, a, b);
                        }
                        function jIb(a, b) {
                            qs.call(this, a, b);
                        }
                        function $Jb(a, b) {
                            qs.call(this, a, b);
                        }
                        function FKb(a, b) {
                            qs.call(this, a, b);
                        }
                        function wLb(a, b) {
                            qs.call(this, a, b);
                        }
                        function nOb(a, b) {
                            qs.call(this, a, b);
                        }
                        function kPb(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function JPb(a, b) {
                            qs.call(this, a, b);
                        }
                        function fRb(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function JRb(a, b) {
                            qs.call(this, a, b);
                        }
                        function OTb(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function UUb(a, b) {
                            qs.call(this, a, b);
                        }
                        function BWb(a, b) {
                            qs.call(this, a, b);
                        }
                        function tXb(a, b) {
                            qs.call(this, a, b);
                        }
                        function XEb(a, b, c) {
                            a.splice(b, 0, c);
                        }
                        function pr(a, b, c) {
                            a.Mb(c) && b.Cd(c);
                        }
                        function lEb(a, b, c) {
                            b.Pe(a.a.Ye(c));
                        }
                        function rEb(a, b, c) {
                            b.Dd(a.a.Ze(c));
                        }
                        function xEb(a, b, c) {
                            b.Cd(a.a.Kb(c));
                        }
                        function eYb(a, b) {
                            return Csb(a.c, b);
                        }
                        function cGb(a, b) {
                            return Csb(a.e, b);
                        }
                        function qZb(a, b) {
                            qs.call(this, a, b);
                        }
                        function V$b(a, b) {
                            qs.call(this, a, b);
                        }
                        function s3b(a, b) {
                            qs.call(this, a, b);
                        }
                        function Q8b(a, b) {
                            qs.call(this, a, b);
                        }
                        function icc(a, b) {
                            qs.call(this, a, b);
                        }
                        function xec(a, b) {
                            qs.call(this, a, b);
                        }
                        function gic(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function Xic(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function h4b(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function vjc(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function xjc(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function Hjc(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function hjc(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function Jjc(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function _Yb(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function eZb(a, b) {
                            this.c = a;
                            this.d = b;
                        }
                        function Q1b(a, b) {
                            this.e = a;
                            this.d = b;
                        }
                        function Tjc(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function ulc(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function Elc(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function fqc(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function smc(a, b) {
                            this.b = b;
                            this.c = a;
                        }
                        function fnc(a, b) {
                            qs.call(this, a, b);
                        }
                        function Cnc(a, b) {
                            qs.call(this, a, b);
                        }
                        function koc(a, b) {
                            qs.call(this, a, b);
                        }
                        function ktc(a, b) {
                            qs.call(this, a, b);
                        }
                        function ctc(a, b) {
                            qs.call(this, a, b);
                        }
                        function utc(a, b) {
                            qs.call(this, a, b);
                        }
                        function Ftc(a, b) {
                            qs.call(this, a, b);
                        }
                        function Rtc(a, b) {
                            qs.call(this, a, b);
                        }
                        function _tc(a, b) {
                            qs.call(this, a, b);
                        }
                        function iuc(a, b) {
                            qs.call(this, a, b);
                        }
                        function vuc(a, b) {
                            qs.call(this, a, b);
                        }
                        function Duc(a, b) {
                            qs.call(this, a, b);
                        }
                        function Puc(a, b) {
                            qs.call(this, a, b);
                        }
                        function _uc(a, b) {
                            qs.call(this, a, b);
                        }
                        function pvc(a, b) {
                            qs.call(this, a, b);
                        }
                        function yvc(a, b) {
                            qs.call(this, a, b);
                        }
                        function Hvc(a, b) {
                            qs.call(this, a, b);
                        }
                        function Pvc(a, b) {
                            qs.call(this, a, b);
                        }
                        function dxc(a, b) {
                            qs.call(this, a, b);
                        }
                        function bDc(a, b) {
                            qs.call(this, a, b);
                        }
                        function nDc(a, b) {
                            qs.call(this, a, b);
                        }
                        function yDc(a, b) {
                            qs.call(this, a, b);
                        }
                        function LDc(a, b) {
                            qs.call(this, a, b);
                        }
                        function bEc(a, b) {
                            qs.call(this, a, b);
                        }
                        function lEc(a, b) {
                            qs.call(this, a, b);
                        }
                        function tEc(a, b) {
                            qs.call(this, a, b);
                        }
                        function CEc(a, b) {
                            qs.call(this, a, b);
                        }
                        function LEc(a, b) {
                            qs.call(this, a, b);
                        }
                        function UEc(a, b) {
                            qs.call(this, a, b);
                        }
                        function mFc(a, b) {
                            qs.call(this, a, b);
                        }
                        function vFc(a, b) {
                            qs.call(this, a, b);
                        }
                        function EFc(a, b) {
                            qs.call(this, a, b);
                        }
                        function SKc(a, b) {
                            qs.call(this, a, b);
                        }
                        function cNc(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function tNc(a, b) {
                            qs.call(this, a, b);
                        }
                        function QOc(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function ePc(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function LPc(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function xQc(a, b) {
                            qs.call(this, a, b);
                        }
                        function FQc(a, b) {
                            qs.call(this, a, b);
                        }
                        function MQc(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function FMc(a, b) {
                            dMc();
                            return b != a;
                        }
                        function Uvb(a) {
                            sFb(a.a);
                            return a.b;
                        }
                        function qYb(a) {
                            rYb(a, a.c);
                            return a;
                        }
                        function Itb() {
                            Etb();
                            return new Dtb;
                        }
                        function _ec() {
                            Rec();
                            this.a = new e6b;
                        }
                        function lSc() {
                            dSc();
                            this.a = new _sb;
                        }
                        function aRc() {
                            WQc();
                            this.b = new _sb;
                        }
                        function xRc(a, b) {
                            this.b = a;
                            this.d = b;
                        }
                        function nVc(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function pVc(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function GWc(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function IXc(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function gTc(a, b) {
                            qs.call(this, a, b);
                        }
                        function eVc(a, b) {
                            qs.call(this, a, b);
                        }
                        function $Vc(a, b) {
                            qs.call(this, a, b);
                        }
                        function XYc(a, b) {
                            qs.call(this, a, b);
                        }
                        function MZc(a, b) {
                            qs.call(this, a, b);
                        }
                        function t_c(a, b) {
                            qs.call(this, a, b);
                        }
                        function B_c(a, b) {
                            qs.call(this, a, b);
                        }
                        function z2c(a, b) {
                            qs.call(this, a, b);
                        }
                        function h3c(a, b) {
                            qs.call(this, a, b);
                        }
                        function $3c(a, b) {
                            qs.call(this, a, b);
                        }
                        function i4c(a, b) {
                            qs.call(this, a, b);
                        }
                        function l5c(a, b) {
                            qs.call(this, a, b);
                        }
                        function v5c(a, b) {
                            qs.call(this, a, b);
                        }
                        function g6c(a, b) {
                            qs.call(this, a, b);
                        }
                        function A6c(a, b) {
                            qs.call(this, a, b);
                        }
                        function a7c(a, b) {
                            qs.call(this, a, b);
                        }
                        function B8c(a, b) {
                            qs.call(this, a, b);
                        }
                        function d9c(a, b) {
                            qs.call(this, a, b);
                        }
                        function D9c(a, b) {
                            qs.call(this, a, b);
                        }
                        function tad(a, b) {
                            qs.call(this, a, b);
                        }
                        function hbd(a, b) {
                            qs.call(this, a, b);
                        }
                        function Nbd(a, b) {
                            qs.call(this, a, b);
                        }
                        function Ybd(a, b) {
                            qs.call(this, a, b);
                        }
                        function ndd(a, b) {
                            qs.call(this, a, b);
                        }
                        function z1c(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function B1c(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function d2c(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function f2c(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function m9c(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function xed(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function ffd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function rjd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function Sjd(a, b) {
                            qs.call(this, a, b);
                        }
                        function Zhd(a, b) {
                            qs.call(this, a, b);
                        }
                        function lid(a, b) {
                            qs.call(this, a, b);
                        }
                        function vkd(a, b) {
                            qs.call(this, a, b);
                        }
                        function Gmd(a, b) {
                            qs.call(this, a, b);
                        }
                        function Pmd(a, b) {
                            qs.call(this, a, b);
                        }
                        function Zmd(a, b) {
                            qs.call(this, a, b);
                        }
                        function jnd(a, b) {
                            qs.call(this, a, b);
                        }
                        function Gnd(a, b) {
                            qs.call(this, a, b);
                        }
                        function Rnd(a, b) {
                            qs.call(this, a, b);
                        }
                        function eod(a, b) {
                            qs.call(this, a, b);
                        }
                        function qod(a, b) {
                            qs.call(this, a, b);
                        }
                        function Eod(a, b) {
                            qs.call(this, a, b);
                        }
                        function Qod(a, b) {
                            qs.call(this, a, b);
                        }
                        function upd(a, b) {
                            qs.call(this, a, b);
                        }
                        function Rpd(a, b) {
                            qs.call(this, a, b);
                        }
                        function eqd(a, b) {
                            qs.call(this, a, b);
                        }
                        function nqd(a, b) {
                            qs.call(this, a, b);
                        }
                        function vqd(a, b) {
                            qs.call(this, a, b);
                        }
                        function Hrd(a, b) {
                            qs.call(this, a, b);
                        }
                        function esd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function gsd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function isd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function Osd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function Qsd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function Ssd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function Ptd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function JEd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function KEd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function MEd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function NEd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function QEd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function REd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function SEd(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function TEd(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function bFd(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function dFd(a, b) {
                            this.b = a;
                            this.a = b;
                        }
                        function fFd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function hFd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function utd(a, b) {
                            qs.call(this, a, b);
                        }
                        function sFd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function uFd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function bGd(a, b) {
                            qs.call(this, a, b);
                        }
                        function uId(a, b) {
                            this.f = a;
                            this.c = b;
                        }
                        function Ofd(a, b) {
                            return Csb(a.g, b);
                        }
                        function Tqc(a, b) {
                            return Csb(b.b, a);
                        }
                        function HPd(a, b) {
                            return QNd(a.a, b);
                        }
                        function Idd(a, b) {
                            return -a.b.af(b);
                        }
                        function IId(a, b) {
                            !!a && Zjb(CId, a, b);
                        }
                        function yWd(a, b) {
                            a.i = null;
                            zWd(a, b);
                        }
                        function kEd(a, b, c) {
                            pDd(b, KDd(a, c));
                        }
                        function lEd(a, b, c) {
                            pDd(b, KDd(a, c));
                        }
                        function mFd(a, b) {
                            vEd(a.a, RD(b, 58));
                        }
                        function _Mc(a, b) {
                            GMc(a.a, RD(b, 12));
                        }
                        function KTd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function NTd(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function B5d(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function Z6d(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function Ble(a, b) {
                            this.a = a;
                            this.b = b;
                        }
                        function afe(a, b) {
                            this.d = a;
                            this.b = b;
                        }
                        function wfe(a, b) {
                            this.e = a;
                            this.a = b;
                        }
                        function Eke(a, b) {
                            this.b = a;
                            this.c = b;
                        }
                        function zNd(a, b) {
                            this.i = a;
                            this.g = b;
                        }
                        function kZd(a, b) {
                            this.d = a;
                            this.e = b;
                        }
                        function ave(a, b) {
                            eve(new dMd(a), b);
                        }
                        function Dke(a) {
                            return pge(a.c, a.b);
                        }
                        function Wd(a) {
                            return !a ? null : a.md();
                        }
                        function dE(a) {
                            return a == null ? null : a;
                        }
                        function bE(a) {
                            return typeof a === jve;
                        }
                        function $D(a) {
                            return typeof a === hve;
                        }
                        function _D(a) {
                            return typeof a === ive;
                        }
                        function Gdb(a, b) {
                            return Ddb(a, b) == 0;
                        }
                        function Jdb(a, b) {
                            return Ddb(a, b) >= 0;
                        }
                        function Pdb(a, b) {
                            return Ddb(a, b) != 0;
                        }
                        function ar(a, b) {
                            return zr(a.Kc(), b);
                        }
                        function Qm(a, b) {
                            return a.Rd().Xb(b);
                        }
                        function kg(a) {
                            ig(a);
                            return a.d.gc();
                        }
                        function fE(a) {
                            CFb(a == null);
                            return a;
                        }
                        function Mhb(a, b) {
                            a.a += '' + b;
                            return a;
                        }
                        function Nhb(a, b) {
                            a.a += '' + b;
                            return a;
                        }
                        function Whb(a, b) {
                            a.a += '' + b;
                            return a;
                        }
                        function Yhb(a, b) {
                            a.a += '' + b;
                            return a;
                        }
                        function Zhb(a, b) {
                            a.a += '' + b;
                            return a;
                        }
                        function Vhb(a, b) {
                            return a.a += '' + b, a;
                        }
                        function Pfb(a) {
                            return '' + (uFb(a), a);
                        }
                        function Vsb(a) {
                            akb(this);
                            Ld(this, a);
                        }
                        function YFc() {
                            RFc();
                            UFc.call(this);
                        }
                        function pxb(a, b) {
                            kxb.call(this, a, b);
                        }
                        function txb(a, b) {
                            kxb.call(this, a, b);
                        }
                        function xxb(a, b) {
                            kxb.call(this, a, b);
                        }
                        function Oub(a, b) {
                            Pub(a, b, a.c.b, a.c);
                        }
                        function Nub(a, b) {
                            Pub(a, b, a.a, a.a.a);
                        }
                        function Iob(a) {
                            tFb(a, 0);
                            return null;
                        }
                        function Xvb() {
                            this.b = 0;
                            this.a = false;
                        }
                        function dwb() {
                            this.b = 0;
                            this.a = false;
                        }
                        function Et() {
                            this.b = new Usb(Sv(12));
                        }
                        function pMb() {
                            pMb = geb;
                            oMb = ss(nMb());
                        }
                        function ncc() {
                            ncc = geb;
                            mcc = ss(lcc());
                        }
                        function aZc() {
                            aZc = geb;
                            _Yc = ss($Yc());
                        }
                        function WA() {
                            WA = geb;
                            vA();
                            VA = new Tsb;
                        }
                        function hjd(a) {
                            a.a = 0;
                            a.b = 0;
                            return a;
                        }
                        function qfd(a, b) {
                            a.a = b.g + 1;
                            return a;
                        }
                        function yNd(a, b) {
                            aMd.call(this, a, b);
                        }
                        function lGd(a, b) {
                            kGd.call(this, a, b);
                        }
                        function N$d(a, b) {
                            zNd.call(this, a, b);
                        }
                        function Whe(a, b) {
                            Q2d.call(this, a, b);
                        }
                        function She(a, b) {
                            Phe.call(this, a, b);
                        }
                        function RRd(a, b) {
                            PRd();
                            Zjb(ORd, a, b);
                        }
                        function sB(a, b) {
                            a.q.setTime(Xdb(b));
                        }
                        function Xz(a) {
                            $wnd.clearTimeout(a);
                        }
                        function cr(a) {
                            return Qb(a), new Dl(a);
                        }
                        function mb(a, b) {
                            return dE(a) === dE(b);
                        }
                        function Mw(a, b) {
                            return a.a.a.a.cc(b);
                        }
                        function qeb(a, b) {
                            return zhb(a.a, 0, b);
                        }
                        function SSb(a) {
                            return MSb(RD(a, 74));
                        }
                        function Nfb(a) {
                            return eE((uFb(a), a));
                        }
                        function Ofb(a) {
                            return eE((uFb(a), a));
                        }
                        function gD(a) {
                            return hD(a.l, a.m, a.h);
                        }
                        function egb(a, b) {
                            return hgb(a.a, b.a);
                        }
                        function ygb(a, b) {
                            return Agb(a.a, b.a);
                        }
                        function Sfb(a, b) {
                            return Qfb(a.a, b.a);
                        }
                        function qhb(a, b) {
                            return a.indexOf(b);
                        }
                        function nOc(a, b) {
                            return a.j[b.p] == 2;
                        }
                        function cz(a, b) {
                            return a == b ? 0 : a ? 1 : -1;
                        }
                        function AB(a) {
                            return a < 10 ? '0' + a : '' + a;
                        }
                        function Kdb(a) {
                            return typeof a === ive;
                        }
                        function oZb(a) {
                            return a == jZb || a == mZb;
                        }
                        function pZb(a) {
                            return a == jZb || a == kZb;
                        }
                        function ELb(a, b) {
                            return hgb(a.g, b.g);
                        }
                        function Q4b(a) {
                            return Wmb(a.b.b, a, 0);
                        }
                        function Q2b() {
                            J2b.call(this, 0, 0, 0, 0);
                        }
                        function Iub() {
                            ctb.call(this, new gub);
                        }
                        function Znb(a, b) {
                            Wnb(a, 0, a.length, b);
                        }
                        function Eyb(a, b) {
                            Rmb(a.a, b);
                            return b;
                        }
                        function Fkc(a, b) {
                            lkc();
                            return b.a += a;
                        }
                        function Hkc(a, b) {
                            lkc();
                            return b.a += a;
                        }
                        function Gkc(a, b) {
                            lkc();
                            return b.c += a;
                        }
                        function ied(a, b) {
                            Rmb(a.c, b);
                            return a;
                        }
                        function Ped(a, b) {
                            ofd(a.a, b);
                            return a;
                        }
                        function ttb(a) {
                            this.a = Itb();
                            this.b = a;
                        }
                        function Ntb(a) {
                            this.a = Itb();
                            this.b = a;
                        }
                        function sjd(a) {
                            this.a = a.a;
                            this.b = a.b;
                        }
                        function Dl(a) {
                            this.a = a;
                            zl.call(this);
                        }
                        function Gl(a) {
                            this.a = a;
                            zl.call(this);
                        }
                        function Tid() {
                            Uid.call(this, 0, 0, 0, 0);
                        }
                        function vfd(a) {
                            return ofd(new ufd, a);
                        }
                        function Ksd(a) {
                            return iyd(RD(a, 123));
                        }
                        function Mvd(a) {
                            return a.vh() && a.wh();
                        }
                        function Dod(a) {
                            return a != zod && a != Aod;
                        }
                        function Dmd(a) {
                            return a == ymd || a == zmd;
                        }
                        function Emd(a) {
                            return a == Bmd || a == xmd;
                        }
                        function xDc(a) {
                            return a == tDc || a == sDc;
                        }
                        function yrc(a, b) {
                            return hgb(a.g, b.g);
                        }
                        function Yfe(a, b) {
                            return new Phe(b, a);
                        }
                        function Zfe(a, b) {
                            return new Phe(b, a);
                        }
                        function lr(a) {
                            return Dr(a.b.Kc(), a.a);
                        }
                        function IXd(a, b) {
                            yXd(a, b);
                            zXd(a, a.D);
                        }
                        function Uxd(a, b, c) {
                            Vxd(a, b);
                            Wxd(a, c);
                        }
                        function zyd(a, b, c) {
                            Cyd(a, b);
                            Ayd(a, c);
                        }
                        function Byd(a, b, c) {
                            Dyd(a, b);
                            Eyd(a, c);
                        }
                        function Gzd(a, b, c) {
                            Hzd(a, b);
                            Izd(a, c);
                        }
                        function Nzd(a, b, c) {
                            Ozd(a, b);
                            Pzd(a, c);
                        }
                        function eh(a, b, c) {
                            bh.call(this, a, b, c);
                        }
                        function zId(a) {
                            uId.call(this, a, true);
                        }
                        function nAb() {
                            dAb.call(this, 'Tail', 3);
                        }
                        function iAb() {
                            dAb.call(this, 'Head', 1);
                        }
                        function ejb(a) {
                            Pib();
                            fjb.call(this, a);
                        }
                        function A3b(a) {
                            J2b.call(this, a, a, a, a);
                        }
                        function Pmb(a) {
                            a.c = $C(jJ, rve, 1, 0, 5, 1);
                        }
                        function yRb(a) {
                            a.b && CRb(a);
                            return a.a;
                        }
                        function zRb(a) {
                            a.b && CRb(a);
                            return a.c;
                        }
                        function mBb(a, b) {
                            if (dBb) return;
                            a.b = b;
                        }
                        function YCb(a, b) {
                            return a[a.length] = b;
                        }
                        function _Cb(a, b) {
                            return a[a.length] = b;
                        }
                        function l5b(a, b) {
                            return NGd(b, MCd(a));
                        }
                        function m5b(a, b) {
                            return NGd(b, MCd(a));
                        }
                        function DDd(a, b) {
                            return lp(Co(a.d), b);
                        }
                        function EDd(a, b) {
                            return lp(Co(a.g), b);
                        }
                        function FDd(a, b) {
                            return lp(Co(a.j), b);
                        }
                        function mGd(a, b) {
                            kGd.call(this, a.b, b);
                        }
                        function s0d(a, b) {
                            WGd(tYd(a.a), v0d(b));
                        }
                        function B4d(a, b) {
                            WGd(o4d(a.a), E4d(b));
                        }
                        function Asd(a, b, c) {
                            Byd(c, c.i + a, c.j + b);
                        }
                        function eFc(a, b, c) {
                            bD(a.c[b.g], b.g, c);
                        }
                        function zVd(a, b, c) {
                            RD(a.c, 71).Gi(b, c);
                        }
                        function LMd(a, b, c) {
                            bD(a, b, c);
                            return c;
                        }
                        function DJb(a) {
                            Umb(a.Sf(), new HJb(a));
                        }
                        function Gvb(a) {
                            return a != null ? tb(a) : 0;
                        }
                        function aOd(a) {
                            return a == null ? 0 : tb(a);
                        }
                        function iue(a) {
                            Vse();
                            Wse.call(this, a);
                        }
                        function Ug(a) {
                            this.a = a;
                            Og.call(this, a);
                        }
                        function Zy() {
                            Zy = geb;
                            $wnd.Math.log(2);
                        }
                        function s7d() {
                            s7d = geb;
                            r7d = ($Sd(), ZSd);
                        }
                        function FRc() {
                            FRc = geb;
                            ERc = new Zrb(u3);
                        }
                        function Hde() {
                            Hde = geb;
                            new Ide;
                            new bnb;
                        }
                        function Ide() {
                            new Tsb;
                            new Tsb;
                            new Tsb;
                        }
                        function yue() {
                            throw Adb(new kib(bMe));
                        }
                        function Nue() {
                            throw Adb(new kib(bMe));
                        }
                        function Bue() {
                            throw Adb(new kib(cMe));
                        }
                        function Que() {
                            throw Adb(new kib(cMe));
                        }
                        function Gp(a) {
                            this.a = a;
                            rf.call(this, a);
                        }
                        function Np(a) {
                            this.a = a;
                            rf.call(this, a);
                        }
                        function Sq(a, b) {
                            tm();
                            this.a = a;
                            this.b = b;
                        }
                        function Jh(a, b) {
                            Qb(b);
                            Ih(a).Jc(new jx);
                        }
                        function _mb(a, b) {
                            Ynb(a.c, a.c.length, b);
                        }
                        function xnb(a) {
                            return a.a < a.c.c.length;
                        }
                        function Msb(a) {
                            return a.a < a.c.a.length;
                        }
                        function Wvb(a, b) {
                            return a.a ? a.b : b.We();
                        }
                        function hgb(a, b) {
                            return a < b ? -1 : a > b ? 1 : 0;
                        }
                        function Kgb(a, b) {
                            return Ddb(a, b) > 0 ? a : b;
                        }
                        function hD(a, b, c) {
                            return {
                                l: a,
                                m: b,
                                h: c
                            };
                        }
                        function Mvb(a, b) {
                            a.a != null && _Mc(b, a.a);
                        }
                        function Lhc(a) {
                            Y0b(a, null);
                            Z0b(a, null);
                        }
                        function xkc(a, b, c) {
                            return Zjb(a.g, c, b);
                        }
                        function bFc(a, b, c) {
                            return _Ec(b, c, a.c);
                        }
                        function jOc(a, b, c) {
                            return Zjb(a.k, c, b);
                        }
                        function pOc(a, b, c) {
                            qOc(a, b, c);
                            return c;
                        }
                        function FOc(a, b) {
                            dOc();
                            return b.n.b += a;
                        }
                        function lUb(a) {
                            VTb.call(this);
                            this.b = a;
                        }
                        function y2b(a) {
                            v2b.call(this);
                            this.a = a;
                        }
                        function kAb() {
                            dAb.call(this, 'Range', 2);
                        }
                        function $Fb(a) {
                            this.b = a;
                            this.a = new bnb;
                        }
                        function WQb(a) {
                            this.b = new gRb;
                            this.a = a;
                        }
                        function Lub(a) {
                            a.a = new svb;
                            a.c = new svb;
                        }
                        function nrc(a) {
                            a.a = new Tsb;
                            a.d = new Tsb;
                        }
                        function $Sc(a) {
                            _Sc(a, null);
                            aTc(a, null);
                        }
                        function a2d(a, b) {
                            return xA(a.a, b, null);
                        }
                        function Cdd(a, b) {
                            return Zjb(a.a, b.a, b);
                        }
                        function ajd(a) {
                            return new rjd(a.a, a.b);
                        }
                        function Pid(a) {
                            return new rjd(a.c, a.d);
                        }
                        function Qid(a) {
                            return new rjd(a.c, a.d);
                        }
                        function Ake(a, b) {
                            return Tfe(a.c, a.b, b);
                        }
                        function ZD(a, b) {
                            return a != null && QD(a, b);
                        }
                        function br(a, b) {
                            return Jr(a.Kc(), b) != -1;
                        }
                        function Hr(a) {
                            return a.Ob() ? a.Pb() : null;
                        }
                        function _p(a) {
                            this.b = (yob(), new uqb(a));
                        }
                        function zke(a) {
                            this.a = a;
                            Tsb.call(this);
                        }
                        function Uhe() {
                            Q2d.call(this, null, null);
                        }
                        function Yhe() {
                            p3d.call(this, null, null);
                        }
                        function As() {
                            qs.call(this, 'INSTANCE', 0);
                        }
                        function dXb() {
                            _Wb();
                            this.a = new Wed(UP);
                        }
                        function Hhb(a) {
                            return Ihb(a, 0, a.length);
                        }
                        function Rv(a, b) {
                            return new ew(a.Kc(), b);
                        }
                        function $sb(a, b) {
                            return a.a.Bc(b) != null;
                        }
                        function hZd(a, b) {
                            sLd(a);
                            a.Gc(RD(b, 15));
                        }
                        function ONd(a, b, c) {
                            a.c.bd(b, RD(c, 136));
                        }
                        function eOd(a, b, c) {
                            a.c.Ui(b, RD(c, 136));
                        }
                        function eub(a, b) {
                            if (a.c) {
                                rub(b);
                                qub(b);
                            }
                        }
                        function oB(a, b) {
                            a.q.setHours(b);
                            mB(a, b);
                        }
                        function vTb(a, b) {
                            Zid(b, a.a.a.a, a.a.a.b);
                        }
                        function tKb(a, b, c, d) {
                            bD(a.a[b.g], c.g, d);
                        }
                        function oKb(a, b, c) {
                            return a.a[b.g][c.g];
                        }
                        function AIc(a, b) {
                            return a.e[b.c.p][b.p];
                        }
                        function TIc(a, b) {
                            return a.c[b.c.p][b.p];
                        }
                        function pJc(a, b) {
                            return a.a[b.c.p][b.p];
                        }
                        function mOc(a, b) {
                            return a.j[b.p] = AOc(b);
                        }
                        function wAb(a, b) {
                            return a.a.Bc(b) != null;
                        }
                        function wXc(a, b) {
                            return Kfb(UD(b.a)) <= a;
                        }
                        function xXc(a, b) {
                            return Kfb(UD(b.a)) >= a;
                        }
                        function vhd(a, b) {
                            return jhb(a.f, b.Pg());
                        }
                        function cjd(a, b) {
                            return a.a * b.a + a.b * b.b;
                        }
                        function Wsd(a, b) {
                            return a.a < Qeb(b) ? -1 : 1;
                        }
                        function gGd(a, b) {
                            return jhb(a.b, b.Pg());
                        }
                        function xIc(a, b, c) {
                            return c ? b != 0 : b != a - 1;
                        }
                        function Mwb(a, b, c) {
                            a.a = b ^ 1502;
                            a.b = c ^ Mxe;
                        }
                        function ljd(a, b, c) {
                            a.a = b;
                            a.b = c;
                            return a;
                        }
                        function ijd(a, b) {
                            a.a *= b;
                            a.b *= b;
                            return a;
                        }
                        function Rmb(a, b) {
                            ZEb(a.c, b);
                            return true;
                        }
                        function MHd(a, b, c) {
                            bD(a.g, b, c);
                            return c;
                        }
                        function XZd(a, b, c) {
                            PZd.call(this, a, b, c);
                        }
                        function _Zd(a, b, c) {
                            XZd.call(this, a, b, c);
                        }
                        function aie(a, b, c) {
                            Kfe.call(this, a, b, c);
                        }
                        function eie(a, b, c) {
                            Kfe.call(this, a, b, c);
                        }
                        function gie(a, b, c) {
                            aie.call(this, a, b, c);
                        }
                        function iie(a, b, c) {
                            XZd.call(this, a, b, c);
                        }
                        function lie(a, b, c) {
                            _Zd.call(this, a, b, c);
                        }
                        function vie(a, b, c) {
                            PZd.call(this, a, b, c);
                        }
                        function zie(a, b, c) {
                            PZd.call(this, a, b, c);
                        }
                        function Cie(a, b, c) {
                            vie.call(this, a, b, c);
                        }
                        function ez(a) {
                            a.j = $C(mJ, Nve, 319, 0, 0, 1);
                        }
                        function wmb() {
                            this.a = $C(jJ, rve, 1, 8, 5, 1);
                        }
                        function dWd() {
                            this.Bb |= 256;
                            this.Bb |= 512;
                        }
                        function dMd(a) {
                            this.i = a;
                            this.f = this.i.j;
                        }
                        function Rue(a) {
                            this.c = a;
                            this.a = this.c.a;
                        }
                        function zf(a, b) {
                            this.a = a;
                            rf.call(this, b);
                        }
                        function Eb(a, b) {
                            return Db(a, new bib, b).a;
                        }
                        function Lb(a) {
                            if (!a) throw Adb(new _fb);
                        }
                        function Ub(a) {
                            if (!a) throw Adb(new cgb);
                        }
                        function Txb() {
                            Txb = geb;
                            Txb();
                            Sxb = new $xb;
                        }
                        function fke() {
                            fke = geb;
                            Gie();
                            eke = new gke;
                        }
                        function Kvb() {
                            Kvb = geb;
                            Jvb = new Ovb(null);
                        }
                        function OGd(a) {
                            Ivb(a, IIe);
                            pzd(a, GGd(a));
                        }
                        function mNd(a) {
                            a.a = RD(Ywd(a.b.a, 4), 129);
                        }
                        function uNd(a) {
                            a.a = RD(Ywd(a.b.a, 4), 129);
                        }
                        function Mg(a) {
                            a.b.Qb();
                            --a.d.f.d;
                            jg(a.d);
                        }
                        function Zj(a) {
                            this.a = a;
                            Aj.call(this, a.d);
                        }
                        function ij(a, b) {
                            this.a = a;
                            pc.call(this, b);
                        }
                        function sj(a, b) {
                            this.a = a;
                            pc.call(this, b);
                        }
                        function Rj(a, b) {
                            this.a = a;
                            pc.call(this, b);
                        }
                        function Il(a, b) {
                            this.a = b;
                            pc.call(this, a);
                        }
                        function ap(a, b) {
                            this.a = b;
                            Xo.call(this, a);
                        }
                        function Ap(a, b) {
                            this.a = a;
                            Xo.call(this, b);
                        }
                        function Yr(a, b) {
                            this.a = b;
                            Tr.call(this, a);
                        }
                        function ew(a, b) {
                            this.a = b;
                            Tr.call(this, a);
                        }
                        function Mr(a, b) {
                            Qb(b);
                            return new Yr(a, b);
                        }
                        function ru(a, b) {
                            return new Ou(a.a, a.b, b);
                        }
                        function rhb(a, b, c) {
                            return a.indexOf(b, c);
                        }
                        function thb(a, b) {
                            return a.lastIndexOf(b);
                        }
                        function Ghb(a) {
                            return a == null ? vve : jeb(a);
                        }
                        function Ez(a) {
                            return a == null ? null : a.name;
                        }
                        function qD(a) {
                            return a.l + a.m * gxe + a.h * hxe;
                        }
                        function Gr(a) {
                            return dvb(a.a) ? Fr(a) : null;
                        }
                        function Shb(a) {
                            reb.call(this, (uFb(a), a));
                        }
                        function dib(a) {
                            reb.call(this, (uFb(a), a));
                        }
                        function dl(a) {
                            Qk.call(this, RD(Qb(a), 34));
                        }
                        function tl(a) {
                            Qk.call(this, RD(Qb(a), 34));
                        }
                        function Jub(a) {
                            ctb.call(this, new hub(a));
                        }
                        function Upb(a) {
                            xpb.call(this, a);
                            this.a = a;
                        }
                        function hqb(a) {
                            Ppb.call(this, a);
                            this.a = a;
                        }
                        function jrb(a) {
                            Lqb.call(this, a);
                            this.a = a;
                        }
                        function mz() {
                            ez(this);
                            gz(this);
                            this.je();
                        }
                        function Dzb(a) {
                            this.a = a;
                            Plb.call(this, a);
                        }
                        function Lvb(a) {
                            sFb(a.a != null);
                            return a.a;
                        }
                        function gGb(a, b) {
                            Rmb(b.a, a.a);
                            return a.a;
                        }
                        function mGb(a, b) {
                            Rmb(b.b, a.a);
                            return a.a;
                        }
                        function eJb(a, b) {
                            Rmb(b.a, a.a);
                            return a.a;
                        }
                        function aib(a, b, c) {
                            peb(a, b, b, c);
                            return a;
                        }
                        function EIb(a, b) {
                            ++a.b;
                            return Rmb(a.a, b);
                        }
                        function FIb(a, b) {
                            ++a.b;
                            return Ymb(a.a, b);
                        }
                        function NNb(a, b) {
                            return Qfb(a.c.d, b.c.d);
                        }
                        function ZNb(a, b) {
                            return Qfb(a.c.c, b.c.c);
                        }
                        function E9b(a, b) {
                            return Qfb(a.n.a, b.n.a);
                        }
                        function B$b(a, b) {
                            return RD(Qc(a.b, b), 15);
                        }
                        function Jac(a, b) {
                            return a.n.b = (uFb(b), b);
                        }
                        function Kac(a, b) {
                            return a.n.b = (uFb(b), b);
                        }
                        function Csb(a, b) {
                            return !!b && a.b[b.g] == b;
                        }
                        function k4b(a) {
                            return xnb(a.a) || xnb(a.b);
                        }
                        function kFb(a) {
                            return a.$H || (a.$H = ++iFb);
                        }
                        function Nvb(a) {
                            return a.a != null ? a.a : null;
                        }
                        function uXc(a, b) {
                            return Qfb(a.e.b, b.e.b);
                        }
                        function CXc(a, b) {
                            return Qfb(a.e.a, b.e.a);
                        }
                        function ZEc(a, b, c) {
                            return $Ec(a, b, c, a.b);
                        }
                        function aFc(a, b, c) {
                            return $Ec(a, b, c, a.c);
                        }
                        function Ikc(a) {
                            lkc();
                            return !!a && !a.dc();
                        }
                        function Yjc() {
                            Wjc();
                            this.b = new ckc(this);
                        }
                        function tNb() {
                            tNb = geb;
                            sNb = new kGd(Xye, 0);
                        }
                        function Geb() {
                            Geb = geb;
                            Eeb = false;
                            Feb = true;
                        }
                        function E8b(a) {
                            var b;
                            b = a.a;
                            a.a = a.b;
                            a.b = b;
                        }
                        function Q2d(a, b) {
                            N2d();
                            this.a = a;
                            this.b = b;
                        }
                        function p3d(a, b) {
                            j3d();
                            this.b = a;
                            this.c = b;
                        }
                        function Fud(a, b) {
                            nud();
                            this.f = b;
                            this.d = a;
                        }
                        function qc(a, b) {
                            Sb(b, a);
                            this.d = a;
                            this.c = b;
                        }
                        function IXb(a, b) {
                            JXb.call(this, a, b, null);
                        }
                        function Kg(a, b, c, d) {
                            yg.call(this, a, b, c, d);
                        }
                        function mMd(a) {
                            this.d = a;
                            dMd.call(this, a);
                        }
                        function yMd(a) {
                            this.c = a;
                            dMd.call(this, a);
                        }
                        function BMd(a) {
                            this.c = a;
                            mMd.call(this, a);
                        }
                        function Zse(a) {
                            ++Use;
                            return new Kte(3, a);
                        }
                        function ev(a) {
                            dk(a, iwe);
                            return new cnb(a);
                        }
                        function jA(a) {
                            fA();
                            return parseInt(a) || -1;
                        }
                        function Fs(a) {
                            zs();
                            return ws((Is(), Hs), a);
                        }
                        function phb(a, b, c) {
                            return rhb(a, Fhb(b), c);
                        }
                        function um(a, b) {
                            return new fq(a, a.gc(), b);
                        }
                        function zj(a, b) {
                            return hn(a.c).Md().Xb(b);
                        }
                        function hu(a, b, c) {
                            var d;
                            d = a.fd(b);
                            d.Rb(c);
                        }
                        function tfd(a, b, c) {
                            RD(Med(a, b), 21).Fc(c);
                        }
                        function XOd(a, b, c) {
                            VNd(a.a, c);
                            UNd(a.a, b);
                        }
                        function aAd(a) {
                            ZD(a, 158) && RD(a, 158).pi();
                        }
                        function tub(a) {
                            uub.call(this, a, null, null);
                        }
                        function Yvb(a) {
                            Tvb();
                            this.b = a;
                            this.a = true;
                        }
                        function ewb(a) {
                            bwb();
                            this.b = a;
                            this.a = true;
                        }
                        function Qub(a) {
                            sFb(a.b != 0);
                            return a.a.a.c;
                        }
                        function Rub(a) {
                            sFb(a.b != 0);
                            return a.c.b.c;
                        }
                        function Phb(a, b) {
                            peb(a, b, b + 1, '');
                            return a;
                        }
                        function nQb(a, b) {
                            return !!a.q && Ujb(a.q, b);
                        }
                        function vzb(a) {
                            return a.b = RD(Bkb(a.a), 44);
                        }
                        function os(a) {
                            return a.f != null ? a.f : '' + a.g;
                        }
                        function ps(a) {
                            return a.f != null ? a.f : '' + a.g;
                        }
                        function yUb(a, b) {
                            return a > 0 ? b / (a * a) : b * 100;
                        }
                        function FUb(a, b) {
                            return a > 0 ? b * b / a : b * b * 100;
                        }
                        function $5b(a, b) {
                            return RD(cub(a.a, b), 34);
                        }
                        function doc(a, b) {
                            Mnc();
                            return Rc(a, b.e, b);
                        }
                        function NCc(a, b, c) {
                            GCc();
                            return c.Mg(a, b);
                        }
                        function L0c(a) {
                            B0c();
                            return a.e.a + a.f.a / 2;
                        }
                        function N0c(a, b, c) {
                            B0c();
                            return c.e.a - a * b;
                        }
                        function V0c(a) {
                            B0c();
                            return a.e.b + a.f.b / 2;
                        }
                        function X0c(a, b, c) {
                            B0c();
                            return c.e.b - a * b;
                        }
                        function _tb(a) {
                            a.d = new tub(a);
                            a.e = new Tsb;
                        }
                        function x3c() {
                            this.a = new Tp;
                            this.b = new Tp;
                        }
                        function hmc(a) {
                            this.c = a;
                            this.a = 1;
                            this.b = 1;
                        }
                        function C$b(a) {
                            z$b();
                            A$b(this);
                            this.Ff(a);
                        }
                        function Efd(a, b, c) {
                            Afd();
                            a.pf(b) && c.Cd(a);
                        }
                        function Red(a, b, c) {
                            return Rmb(b, Ted(a, c));
                        }
                        function Zid(a, b, c) {
                            a.a += b;
                            a.b += c;
                            return a;
                        }
                        function jjd(a, b, c) {
                            a.a *= b;
                            a.b *= c;
                            return a;
                        }
                        function mjd(a, b) {
                            a.a = b.a;
                            a.b = b.b;
                            return a;
                        }
                        function fjd(a) {
                            a.a = -a.a;
                            a.b = -a.b;
                            return a;
                        }
                        function njd(a, b, c) {
                            a.a -= b;
                            a.b -= c;
                            return a;
                        }
                        function Gjd(a) {
                            Yub.call(this);
                            zjd(this, a);
                        }
                        function Dbd() {
                            qs.call(this, 'GROW_TREE', 0);
                        }
                        function WRb() {
                            qs.call(this, 'POLYOMINO', 0);
                        }
                        function SVd(a, b, c) {
                            DVd.call(this, a, b, c, 2);
                        }
                        function r0d(a, b, c) {
                            VGd(tYd(a.a), b, v0d(c));
                        }
                        function e3d(a, b) {
                            N2d();
                            Q2d.call(this, a, b);
                        }
                        function D3d(a, b) {
                            j3d();
                            p3d.call(this, a, b);
                        }
                        function F3d(a, b) {
                            j3d();
                            D3d.call(this, a, b);
                        }
                        function H3d(a, b) {
                            j3d();
                            p3d.call(this, a, b);
                        }
                        function PNd(a, b) {
                            return a.c.Fc(RD(b, 136));
                        }
                        function A4d(a, b, c) {
                            VGd(o4d(a.a), b, E4d(c));
                        }
                        function Ard(a) {
                            this.c = a;
                            Dyd(a, 0);
                            Eyd(a, 0);
                        }
                        function Z8d(a, b) {
                            s7d();
                            N8d.call(this, a, b);
                        }
                        function _8d(a, b) {
                            s7d();
                            Z8d.call(this, a, b);
                        }
                        function b9d(a, b) {
                            s7d();
                            Z8d.call(this, a, b);
                        }
                        function n9d(a, b) {
                            s7d();
                            N8d.call(this, a, b);
                        }
                        function d9d(a, b) {
                            s7d();
                            b9d.call(this, a, b);
                        }
                        function p9d(a, b) {
                            s7d();
                            n9d.call(this, a, b);
                        }
                        function v9d(a, b) {
                            s7d();
                            N8d.call(this, a, b);
                        }
                        function lge(a, b, c) {
                            return b.zl(a.e, a.c, c);
                        }
                        function nge(a, b, c) {
                            return b.Al(a.e, a.c, c);
                        }
                        function Wee(a, b, c) {
                            return tfe(Pee(a, b), c);
                        }
                        function Age(a, b) {
                            return Vvd(a.e, RD(b, 54));
                        }
                        function _me(a) {
                            return a == null ? null : Bqe(a);
                        }
                        function dne(a) {
                            return a == null ? null : Iqe(a);
                        }
                        function gne(a) {
                            return a == null ? null : jeb(a);
                        }
                        function hne(a) {
                            return a == null ? null : jeb(a);
                        }
                        function TD(a) {
                            CFb(a == null || $D(a));
                            return a;
                        }
                        function UD(a) {
                            CFb(a == null || _D(a));
                            return a;
                        }
                        function WD(a) {
                            CFb(a == null || bE(a));
                            return a;
                        }
                        function lfb(a) {
                            if (a.o != null) return;
                            Bfb(a);
                        }
                        function lFb(a) {
                            if (!a) throw Adb(new _fb);
                        }
                        function pFb(a) {
                            if (!a) throw Adb(new yeb);
                        }
                        function sFb(a) {
                            if (!a) throw Adb(new Dvb);
                        }
                        function yFb(a) {
                            if (!a) throw Adb(new cgb);
                        }
                        function zmb(a) {
                            if (!a) throw Adb(new Jrb);
                        }
                        function jQd() {
                            jQd = geb;
                            iQd = new LQd;
                            new lRd;
                        }
                        function u2c() {
                            u2c = geb;
                            t2c = new jGd('root');
                        }
                        function d6d() {
                            HWd.call(this);
                            this.Bb |= txe;
                        }
                        function Pg(a, b) {
                            this.d = a;
                            Lg(this);
                            this.b = b;
                        }
                        function WCb(a, b) {
                            NCb.call(this, a);
                            this.a = b;
                        }
                        function oDb(a, b) {
                            NCb.call(this, a);
                            this.a = b;
                        }
                        function bh(a, b, c) {
                            lg.call(this, a, b, c, null);
                        }
                        function fh(a, b, c) {
                            lg.call(this, a, b, c, null);
                        }
                        function Mf(a, b) {
                            this.c = a;
                            ne.call(this, a, b);
                        }
                        function Uf(a, b) {
                            this.a = a;
                            Mf.call(this, a, b);
                        }
                        function wB(a) {
                            this.q = new $wnd.Date(Xdb(a));
                        }
                        function OPb(a) {
                            if (a > 8) return 0;
                            return a + 1;
                        }
                        function iBb(a, b) {
                            if (dBb) return;
                            Rmb(a.a, b);
                        }
                        function P5b(a, b) {
                            H5b();
                            return n2b(b.d.i, a);
                        }
                        function qdc(a, b) {
                            Zcc();
                            return new xdc(b, a);
                        }
                        function HAb(a, b, c) {
                            return a.Ne(b, c) <= 0 ? c : b;
                        }
                        function IAb(a, b, c) {
                            return a.Ne(b, c) <= 0 ? b : c;
                        }
                        function rgd(a, b) {
                            return RD(cub(a.b, b), 143);
                        }
                        function tgd(a, b) {
                            return RD(cub(a.c, b), 233);
                        }
                        function amc(a) {
                            return RD(Vmb(a.a, a.b), 294);
                        }
                        function Mid(a) {
                            return new rjd(a.c, a.d + a.a);
                        }
                        function Jeb(a) {
                            return (uFb(a), a) ? 1231 : 1237;
                        }
                        function EPc(a) {
                            return dOc(), xDc(RD(a, 203));
                        }
                        function RMb() {
                            RMb = geb;
                            QMb = xsb((Qpd(), Ppd));
                        }
                        function YQb(a, b) {
                            b.a ? ZQb(a, b) : wAb(a.a, b.b);
                        }
                        function aJd(a, b, c) {
                            ++a.j;
                            a.tj();
                            $Gd(a, b, c);
                        }
                        function $Id(a, b, c) {
                            ++a.j;
                            a.qj(b, a.Zi(b, c));
                        }
                        function B2d(a, b, c) {
                            var d;
                            d = a.fd(b);
                            d.Rb(c);
                        }
                        function Bzd(a, b, c) {
                            c = xvd(a, b, 6, c);
                            return c;
                        }
                        function izd(a, b, c) {
                            c = xvd(a, b, 3, c);
                            return c;
                        }
                        function KCd(a, b, c) {
                            c = xvd(a, b, 9, c);
                            return c;
                        }
                        function SKb(a, b) {
                            Ivb(b, Pye);
                            a.f = b;
                            return a;
                        }
                        function bOd(a, b) {
                            return (b & lve) % a.d.length;
                        }
                        function Bke(a, b, c) {
                            return age(a.c, a.b, b, c);
                        }
                        function ZLd(a, b) {
                            this.c = a;
                            ZHd.call(this, b);
                        }
                        function w0d(a, b) {
                            this.a = a;
                            Q_d.call(this, b);
                        }
                        function F4d(a, b) {
                            this.a = a;
                            Q_d.call(this, b);
                        }
                        function kGd(a, b) {
                            jGd.call(this, a);
                            this.a = b;
                        }
                        function U6d(a, b) {
                            L6d.call(this, a);
                            this.a = b;
                        }
                        function S9d(a, b) {
                            L6d.call(this, a);
                            this.a = b;
                        }
                        function jQb(a) {
                            gQb.call(this, 0, 0);
                            this.f = a;
                        }
                        function _hb(a, b, c) {
                            a.a += Ihb(b, 0, c);
                            return a;
                        }
                        function _A(a) {
                            !a.a && (a.a = new jB);
                            return a.a;
                        }
                        function qlb(a, b) {
                            var c;
                            c = a.e;
                            a.e = b;
                            return c;
                        }
                        function Clb(a, b) {
                            var c;
                            c = b;
                            return !!a.Fe(c);
                        }
                        function Keb(a, b) {
                            Geb();
                            return a == b ? 0 : a ? 1 : -1;
                        }
                        function Ikb(a, b) {
                            a.a.bd(a.b, b);
                            ++a.b;
                            a.c = -1;
                        }
                        function hg(a) {
                            a.b ? hg(a.b) : a.f.c.zc(a.e, a.d);
                        }
                        function aub(a) {
                            akb(a.e);
                            a.d.b = a.d;
                            a.d.a = a.d;
                        }
                        function VDb(a, b, c) {
                            xDb();
                            HEb(a, b.Ve(a.a, c));
                        }
                        function Xrb(a, b, c) {
                            return Wrb(a, RD(b, 22), c);
                        }
                        function WEb(a, b) {
                            return cFb(new Array(b), a);
                        }
                        function Fgb(a) {
                            return Ydb(Udb(a, 32)) ^ Ydb(a);
                        }
                        function XD(a) {
                            return String.fromCharCode(a);
                        }
                        function Dz(a) {
                            return a == null ? null : a.message;
                        }
                        function Rz(a, b, c) {
                            var d;
                            return a.apply(b, c);
                        }
                        function Btb(a, b) {
                            var c;
                            c = a[Jxe];
                            c.call(a, b);
                        }
                        function Ctb(a, b) {
                            var c;
                            c = a[Jxe];
                            c.call(a, b);
                        }
                        function O5b(a, b) {
                            H5b();
                            return !n2b(b.d.i, a);
                        }
                        function R2b(a, b, c, d) {
                            J2b.call(this, a, b, c, d);
                        }
                        function TJb() {
                            RJb.call(this);
                            this.a = new pjd;
                        }
                        function v2b() {
                            this.n = new pjd;
                            this.o = new pjd;
                        }
                        function kGb() {
                            this.b = new pjd;
                            this.c = new bnb;
                        }
                        function cUb() {
                            this.a = new bnb;
                            this.b = new bnb;
                        }
                        function kWb() {
                            this.a = new DTb;
                            this.b = new vWb;
                        }
                        function e6b() {
                            this.b = new gub;
                            this.a = new gub;
                        }
                        function jIc() {
                            this.b = new _sb;
                            this.a = new _sb;
                        }
                        function vYc() {
                            this.b = new Tsb;
                            this.a = new Tsb;
                        }
                        function fWc() {
                            this.b = new TVc;
                            this.a = new IVc;
                        }
                        function Yhc() {
                            this.a = new yqc;
                            this.b = new Sqc;
                        }
                        function lNc() {
                            this.a = new bnb;
                            this.d = new bnb;
                        }
                        function RJb() {
                            this.n = new z3b;
                            this.i = new Tid;
                        }
                        function hq(a) {
                            this.a = (dk(a, iwe), new cnb(a));
                        }
                        function oq(a) {
                            this.a = (dk(a, iwe), new cnb(a));
                        }
                        function tLd(a) {
                            return a < 100 ? null : new gLd(a);
                        }
                        function Lac(a, b) {
                            return a.n.a = (uFb(b), b) + 10;
                        }
                        function Mac(a, b) {
                            return a.n.a = (uFb(b), b) + 10;
                        }
                        function DYd(a, b) {
                            return b == a || PHd(sYd(b), a);
                        }
                        function nae(a, b) {
                            return Zjb(a.a, b, '') == null;
                        }
                        function Hee(a, b) {
                            var c;
                            c = b.qi(a.a);
                            return c;
                        }
                        function $id(a, b) {
                            a.a += b.a;
                            a.b += b.b;
                            return a;
                        }
                        function ojd(a, b) {
                            a.a -= b.a;
                            a.b -= b.b;
                            return a;
                        }
                        function sfd(a) {
                            aFb(a.j.c, 0);
                            a.a = -1;
                            return a;
                        }
                        function rCd(a, b, c) {
                            c = xvd(a, b, 11, c);
                            return c;
                        }
                        function SDd(a, b, c) {
                            c != null && Kzd(b, uEd(a, c));
                        }
                        function TDd(a, b, c) {
                            c != null && Lzd(b, uEd(a, c));
                        }
                        function G5d(a, b, c, d) {
                            C5d.call(this, a, b, c, d);
                        }
                        function oie(a, b, c, d) {
                            C5d.call(this, a, b, c, d);
                        }
                        function sie(a, b, c, d) {
                            oie.call(this, a, b, c, d);
                        }
                        function Nie(a, b, c, d) {
                            Iie.call(this, a, b, c, d);
                        }
                        function Pie(a, b, c, d) {
                            Iie.call(this, a, b, c, d);
                        }
                        function Vie(a, b, c, d) {
                            Iie.call(this, a, b, c, d);
                        }
                        function Tie(a, b, c, d) {
                            Pie.call(this, a, b, c, d);
                        }
                        function $ie(a, b, c, d) {
                            Pie.call(this, a, b, c, d);
                        }
                        function Yie(a, b, c, d) {
                            Vie.call(this, a, b, c, d);
                        }
                        function bje(a, b, c, d) {
                            $ie.call(this, a, b, c, d);
                        }
                        function Dje(a, b, c, d) {
                            wje.call(this, a, b, c, d);
                        }
                        function aMd(a, b) {
                            veb.call(this, HJe + a + NIe + b);
                        }
                        function Hje(a, b) {
                            return a.jk().wi().ri(a, b);
                        }
                        function Ije(a, b) {
                            return a.jk().wi().ti(a, b);
                        }
                        function Lfb(a, b) {
                            return uFb(a), dE(a) === dE(b);
                        }
                        function lhb(a, b) {
                            return uFb(a), dE(a) === dE(b);
                        }
                        function mEb(a, b) {
                            return a.b.Bd(new pEb(a, b));
                        }
                        function sEb(a, b) {
                            return a.b.Bd(new vEb(a, b));
                        }
                        function yEb(a, b) {
                            return a.b.Bd(new BEb(a, b));
                        }
                        function Bk(a, b) {
                            return a.e = RD(a.d.Kb(b), 159);
                        }
                        function uhb(a, b, c) {
                            return a.lastIndexOf(b, c);
                        }
                        function wWb(a, b, c) {
                            return Qfb(a[b.a], a[c.a]);
                        }
                        function TWb(a, b) {
                            return pQb(b, (yCc(), gAc), a);
                        }
                        function Lpc(a, b) {
                            return hgb(b.a.d.p, a.a.d.p);
                        }
                        function Kpc(a, b) {
                            return hgb(a.a.d.p, b.a.d.p);
                        }
                        function zTc(a, b) {
                            return Qfb(a.c - a.s, b.c - b.s);
                        }
                        function qWc(a, b) {
                            return Qfb(a.b.e.a, b.b.e.a);
                        }
                        function sWc(a, b) {
                            return Qfb(a.c.e.a, b.c.e.a);
                        }
                        function $2b(a) {
                            return !a.c ? -1 : Wmb(a.c.a, a, 0);
                        }
                        function Cod(a) {
                            return a == vod || a == xod || a == wod;
                        }
                        function CMd(a, b) {
                            this.c = a;
                            nMd.call(this, a, b);
                        }
                        function fq(a, b, c) {
                            this.a = a;
                            qc.call(this, b, c);
                        }
                        function YDb(a) {
                            this.c = a;
                            xxb.call(this, Sve, 0);
                        }
                        function rk(a, b, c) {
                            this.c = b;
                            this.b = c;
                            this.a = a;
                        }
                        function DMc(a) {
                            dMc();
                            this.d = a;
                            this.a = new wmb;
                        }
                        function ho(a) {
                            _l();
                            this.a = (yob(), new Lqb(a));
                        }
                        function Xmc(a, b) {
                            Dmd(a.f) ? Ymc(a, b) : Zmc(a, b);
                        }
                        function Lxb(a, b) {
                            Mxb.call(this, a, a.length, b);
                        }
                        function nBb(a, b) {
                            if (dBb) return;
                            !!b && (a.d = b);
                        }
                        function ZNd(a, b) {
                            return ZD(b, 15) && _Gd(a.c, b);
                        }
                        function AVd(a, b, c) {
                            return RD(a.c, 71).Wk(b, c);
                        }
                        function BVd(a, b, c) {
                            return RD(a.c, 71).Xk(b, c);
                        }
                        function mge(a, b, c) {
                            return lge(a, RD(b, 343), c);
                        }
                        function oge(a, b, c) {
                            return nge(a, RD(b, 343), c);
                        }
                        function Ige(a, b, c) {
                            return Hge(a, RD(b, 343), c);
                        }
                        function Kge(a, b, c) {
                            return Jge(a, RD(b, 343), c);
                        }
                        function Fn(a, b) {
                            return b == null ? null : Xv(a.b, b);
                        }
                        function Qeb(a) {
                            return _D(a) ? (uFb(a), a) : a.ue();
                        }
                        function Rfb(a) {
                            return !isNaN(a) && !isFinite(a);
                        }
                        function Zub(a) {
                            Lub(this);
                            Xub(this);
                            ye(this, a);
                        }
                        function dnb(a) {
                            Pmb(this);
                            YEb(this.c, 0, a.Pc());
                        }
                        function Fsb(a, b, c) {
                            this.a = a;
                            this.b = b;
                            this.c = c;
                        }
                        function Vtb(a, b, c) {
                            this.a = a;
                            this.b = b;
                            this.c = c;
                        }
                        function hvb(a, b, c) {
                            this.d = a;
                            this.b = c;
                            this.a = b;
                        }
                        function aBb(a) {
                            this.a = a;
                            gib();
                            Hdb(Date.now());
                        }
                        function wzb(a) {
                            Ckb(a.a);
                            Yyb(a.c, a.b);
                            a.b = null;
                        }
                        function wvb() {
                            wvb = geb;
                            uvb = new xvb;
                            vvb = new zvb;
                        }
                        function KMd() {
                            KMd = geb;
                            JMd = $C(jJ, rve, 1, 0, 5, 1);
                        }
                        function TTd() {
                            TTd = geb;
                            STd = $C(jJ, rve, 1, 0, 5, 1);
                        }
                        function yUd() {
                            yUd = geb;
                            xUd = $C(jJ, rve, 1, 0, 5, 1);
                        }
                        function _l() {
                            _l = geb;
                            new im((yob(), yob(), vob));
                        }
                        function gAb(a) {
                            cAb();
                            return ws((qAb(), pAb), a);
                        }
                        function zBb(a) {
                            xBb();
                            return ws((CBb(), BBb), a);
                        }
                        function FHb(a) {
                            DHb();
                            return ws((IHb(), HHb), a);
                        }
                        function NHb(a) {
                            LHb();
                            return ws((QHb(), PHb), a);
                        }
                        function kIb(a) {
                            iIb();
                            return ws((nIb(), mIb), a);
                        }
                        function _Jb(a) {
                            ZJb();
                            return ws((cKb(), bKb), a);
                        }
                        function GKb(a) {
                            EKb();
                            return ws((JKb(), IKb), a);
                        }
                        function xLb(a) {
                            vLb();
                            return ws((ALb(), zLb), a);
                        }
                        function mMb(a) {
                            hMb();
                            return ws((pMb(), oMb), a);
                        }
                        function oOb(a) {
                            mOb();
                            return ws((rOb(), qOb), a);
                        }
                        function KPb(a) {
                            IPb();
                            return ws((NPb(), MPb), a);
                        }
                        function KRb(a) {
                            IRb();
                            return ws((NRb(), MRb), a);
                        }
                        function XRb(a) {
                            VRb();
                            return ws(($Rb(), ZRb), a);
                        }
                        function VUb(a) {
                            TUb();
                            return ws((YUb(), XUb), a);
                        }
                        function CWb(a) {
                            AWb();
                            return ws((FWb(), EWb), a);
                        }
                        function uXb(a) {
                            sXb();
                            return ws((xXb(), wXb), a);
                        }
                        function tZb(a) {
                            nZb();
                            return ws((wZb(), vZb), a);
                        }
                        function W$b(a) {
                            U$b();
                            return ws((Z$b(), Y$b), a);
                        }
                        function Mb(a, b) {
                            if (!a) throw Adb(new agb(b));
                        }
                        function Vb(a) {
                            if (!a) throw Adb(new dgb(tve));
                        }
                        function rFb(a, b) {
                            if (a != b) throw Adb(new Jrb);
                        }
                        function KQb(a, b, c) {
                            this.a = a;
                            this.b = b;
                            this.c = c;
                        }
                        function lRb(a, b, c) {
                            this.a = a;
                            this.b = b;
                            this.c = c;
                        }
                        function h7b(a, b, c) {
                            this.a = a;
                            this.b = b;
                            this.c = c;
                        }
                        function J0b(a, b, c) {
                            this.b = a;
                            this.a = b;
                            this.c = c;
                        }
                        function dNb(a, b, c) {
                            this.b = a;
                            this.c = b;
                            this.a = c;
                        }
                        function oac(a, b, c) {
                            this.a = a;
                            this.b = b;
                            this.c = c;
                        }
                        function F1b(a, b, c) {
                            this.e = b;
                            this.b = a;
                            this.d = c;
                        }
                        function Ecc(a, b, c) {
                            this.b = a;
                            this.a = b;
                            this.c = c;
                        }
                        function UDb(a, b, c) {
                            xDb();
                            a.a.Yd(b, c);
                            return b;
                        }
                        function CJb(a) {
                            var b;
                            b = new BJb;
                            b.e = a;
                            return b;
                        }
                        function _Nb(a) {
                            var b;
                            b = new YNb;
                            b.b = a;
                            return b;
                        }
                        function U9b() {
                            U9b = geb;
                            S9b = new bac;
                            T9b = new eac;
                        }
                        function Rec() {
                            Rec = geb;
                            Qec = new efc;
                            Pec = new jfc;
                        }
                        function lkc() {
                            lkc = geb;
                            jkc = new Mkc;
                            kkc = new Okc;
                        }
                        function loc(a) {
                            joc();
                            return ws((ooc(), noc), a);
                        }
                        function kcc(a) {
                            hcc();
                            return ws((ncc(), mcc), a);
                        }
                        function yec(a) {
                            vec();
                            return ws((Bec(), Aec), a);
                        }
                        function gnc(a) {
                            enc();
                            return ws((jnc(), inc), a);
                        }
                        function Enc(a) {
                            Bnc();
                            return ws((Hnc(), Gnc), a);
                        }
                        function gpc(a) {
                            epc();
                            return ws((jpc(), ipc), a);
                        }
                        function dtc(a) {
                            btc();
                            return ws((gtc(), ftc), a);
                        }
                        function ltc(a) {
                            jtc();
                            return ws((otc(), ntc), a);
                        }
                        function xtc(a) {
                            stc();
                            return ws((Atc(), ztc), a);
                        }
                        function Gtc(a) {
                            Etc();
                            return ws((Jtc(), Itc), a);
                        }
                        function Utc(a) {
                            Ptc();
                            return ws((Xtc(), Wtc), a);
                        }
                        function auc(a) {
                            $tc();
                            return ws((duc(), cuc), a);
                        }
                        function avc(a) {
                            $uc();
                            return ws((dvc(), cvc), a);
                        }
                        function qvc(a) {
                            ovc();
                            return ws((tvc(), svc), a);
                        }
                        function zvc(a) {
                            xvc();
                            return ws((Cvc(), Bvc), a);
                        }
                        function Ivc(a) {
                            Gvc();
                            return ws((Lvc(), Kvc), a);
                        }
                        function Qvc(a) {
                            Ovc();
                            return ws((Tvc(), Svc), a);
                        }
                        function Quc(a) {
                            Ouc();
                            return ws((Tuc(), Suc), a);
                        }
                        function juc(a) {
                            huc();
                            return ws((muc(), luc), a);
                        }
                        function wuc(a) {
                            tuc();
                            return ws((zuc(), yuc), a);
                        }
                        function Euc(a) {
                            Cuc();
                            return ws((Huc(), Guc), a);
                        }
                        function exc(a) {
                            cxc();
                            return ws((hxc(), gxc), a);
                        }
                        function eDc(a) {
                            _Cc();
                            return ws((hDc(), gDc), a);
                        }
                        function oDc(a) {
                            lDc();
                            return ws((rDc(), qDc), a);
                        }
                        function ADc(a) {
                            wDc();
                            return ws((DDc(), CDc), a);
                        }
                        function ODc(a) {
                            JDc();
                            return ws((RDc(), QDc), a);
                        }
                        function cEc(a) {
                            aEc();
                            return ws((fEc(), eEc), a);
                        }
                        function mEc(a) {
                            kEc();
                            return ws((pEc(), oEc), a);
                        }
                        function uEc(a) {
                            sEc();
                            return ws((xEc(), wEc), a);
                        }
                        function DEc(a) {
                            BEc();
                            return ws((GEc(), FEc), a);
                        }
                        function MEc(a) {
                            KEc();
                            return ws((PEc(), OEc), a);
                        }
                        function VEc(a) {
                            TEc();
                            return ws((YEc(), XEc), a);
                        }
                        function nFc(a) {
                            lFc();
                            return ws((qFc(), pFc), a);
                        }
                        function wFc(a) {
                            uFc();
                            return ws((zFc(), yFc), a);
                        }
                        function FFc(a) {
                            DFc();
                            return ws((IFc(), HFc), a);
                        }
                        function TKc(a) {
                            RKc();
                            return ws((WKc(), VKc), a);
                        }
                        function uNc(a) {
                            sNc();
                            return ws((xNc(), wNc), a);
                        }
                        function yQc(a) {
                            wQc();
                            return ws((BQc(), AQc), a);
                        }
                        function GQc(a) {
                            EQc();
                            return ws((JQc(), IQc), a);
                        }
                        function hTc(a) {
                            fTc();
                            return ws((kTc(), jTc), a);
                        }
                        function fVc(a) {
                            dVc();
                            return ws((iVc(), hVc), a);
                        }
                        function bWc(a) {
                            YVc();
                            return ws((eWc(), dWc), a);
                        }
                        function ZYc(a) {
                            WYc();
                            return ws((aZc(), _Yc), a);
                        }
                        function NZc(a) {
                            LZc();
                            return ws((QZc(), PZc), a);
                        }
                        function u_c(a) {
                            s_c();
                            return ws((x_c(), w_c), a);
                        }
                        function C_c(a) {
                            A_c();
                            return ws((F_c(), E_c), a);
                        }
                        function C2c(a) {
                            x2c();
                            return ws((F2c(), E2c), a);
                        }
                        function j3c(a) {
                            g3c();
                            return ws((m3c(), l3c), a);
                        }
                        function j4c(a) {
                            g4c();
                            return ws((m4c(), l4c), a);
                        }
                        function _3c(a) {
                            Y3c();
                            return ws((c4c(), b4c), a);
                        }
                        function m5c(a) {
                            j5c();
                            return ws((p5c(), o5c), a);
                        }
                        function w5c(a) {
                            t5c();
                            return ws((z5c(), y5c), a);
                        }
                        function h6c(a) {
                            f6c();
                            return ws((k6c(), j6c), a);
                        }
                        function C6c(a) {
                            z6c();
                            return ws((F6c(), E6c), a);
                        }
                        function b7c(a) {
                            _6c();
                            return ws((e7c(), d7c), a);
                        }
                        function E8c(a) {
                            z8c();
                            return ws((H8c(), G8c), a);
                        }
                        function R8b(a) {
                            P8b();
                            return ws((U8b(), T8b), a);
                        }
                        function t3b(a) {
                            r3b();
                            return ws((w3b(), v3b), a);
                        }
                        function g9c(a) {
                            b9c();
                            return ws((j9c(), i9c), a);
                        }
                        function G9c(a) {
                            B9c();
                            return ws((J9c(), I9c), a);
                        }
                        function uad(a) {
                            sad();
                            return ws((xad(), wad), a);
                        }
                        function xbd(a) {
                            sbd();
                            return ws((Abd(), zbd), a);
                        }
                        function ibd(a) {
                            gbd();
                            return ws((lbd(), kbd), a);
                        }
                        function Gbd(a) {
                            Cbd();
                            return ws((Jbd(), Ibd), a);
                        }
                        function Obd(a) {
                            Mbd();
                            return ws((Rbd(), Qbd), a);
                        }
                        function Zbd(a) {
                            Xbd();
                            return ws((acd(), _bd), a);
                        }
                        function fdd(a) {
                            _cd();
                            return ws((idd(), hdd), a);
                        }
                        function qdd(a) {
                            ldd();
                            return ws((tdd(), sdd), a);
                        }
                        function $hd(a) {
                            Yhd();
                            return ws((bid(), aid), a);
                        }
                        function mid(a) {
                            kid();
                            return ws((pid(), oid), a);
                        }
                        function Tjd(a) {
                            Rjd();
                            return ws((Wjd(), Vjd), a);
                        }
                        function wkd(a) {
                            ukd();
                            return ws((zkd(), ykd), a);
                        }
                        function Hmd(a) {
                            Cmd();
                            return ws((Kmd(), Jmd), a);
                        }
                        function Qmd(a) {
                            Omd();
                            return ws((Tmd(), Smd), a);
                        }
                        function $md(a) {
                            Ymd();
                            return ws((bnd(), and), a);
                        }
                        function knd(a) {
                            ind();
                            return ws((nnd(), mnd), a);
                        }
                        function Hnd(a) {
                            Fnd();
                            return ws((Knd(), Jnd), a);
                        }
                        function Snd(a) {
                            Pnd();
                            return ws((Vnd(), Und), a);
                        }
                        function god(a) {
                            dod();
                            return ws((jod(), iod), a);
                        }
                        function rod(a) {
                            pod();
                            return ws((uod(), tod), a);
                        }
                        function Fod(a) {
                            Bod();
                            return ws((Iod(), Hod), a);
                        }
                        function Tod(a) {
                            Pod();
                            return ws((Wod(), Vod), a);
                        }
                        function wpd(a) {
                            qpd();
                            return ws((zpd(), ypd), a);
                        }
                        function Spd(a) {
                            Qpd();
                            return ws((Vpd(), Upd), a);
                        }
                        function fqd(a) {
                            dqd();
                            return ws((iqd(), hqd), a);
                        }
                        function oqd(a) {
                            mqd();
                            return ws((rqd(), qqd), a);
                        }
                        function zsc(a, b) {
                            return (uFb(a), a) + (uFb(b), b);
                        }
                        function wqd(a) {
                            uqd();
                            return ws((Eqd(), Dqd), a);
                        }
                        function Ird(a) {
                            Grd();
                            return ws((Lrd(), Krd), a);
                        }
                        function vtd(a) {
                            ttd();
                            return ws((ytd(), xtd), a);
                        }
                        function dMc() {
                            dMc = geb;
                            bMc = (qpd(), ppd);
                            cMc = Xod;
                        }
                        function uqd() {
                            uqd = geb;
                            sqd = new zqd;
                            tqd = new Bqd;
                        }
                        function wJc(a) {
                            !a.e && (a.e = new bnb);
                            return a.e;
                        }
                        function BTc(a, b) {
                            this.c = a;
                            this.a = b;
                            this.b = b - a;
                        }
                        function g8c(a, b, c) {
                            this.a = a;
                            this.b = b;
                            this.c = c;
                        }
                        function gud(a, b, c) {
                            this.a = a;
                            this.b = b;
                            this.c = c;
                        }
                        function Wdd(a, b, c) {
                            this.a = a;
                            this.b = b;
                            this.c = c;
                        }
                        function ced(a, b, c) {
                            this.a = a;
                            this.b = b;
                            this.c = c;
                        }
                        function pFd(a, b, c) {
                            this.a = a;
                            this.b = b;
                            this.c = c;
                        }
                        function ZPd(a, b, c) {
                            this.a = a;
                            this.b = b;
                            this.c = c;
                        }
                        function g7d(a, b, c) {
                            this.e = a;
                            this.a = b;
                            this.c = c;
                        }
                        function K7d(a, b, c) {
                            s7d();
                            C7d.call(this, a, b, c);
                        }
                        function f9d(a, b, c) {
                            s7d();
                            O8d.call(this, a, b, c);
                        }
                        function r9d(a, b, c) {
                            s7d();
                            O8d.call(this, a, b, c);
                        }
                        function x9d(a, b, c) {
                            s7d();
                            O8d.call(this, a, b, c);
                        }
                        function h9d(a, b, c) {
                            s7d();
                            f9d.call(this, a, b, c);
                        }
                        function j9d(a, b, c) {
                            s7d();
                            f9d.call(this, a, b, c);
                        }
                        function l9d(a, b, c) {
                            s7d();
                            j9d.call(this, a, b, c);
                        }
                        function t9d(a, b, c) {
                            s7d();
                            r9d.call(this, a, b, c);
                        }
                        function z9d(a, b, c) {
                            s7d();
                            x9d.call(this, a, b, c);
                        }
                        function S2b(a) {
                            J2b.call(this, a.d, a.c, a.a, a.b);
                        }
                        function B3b(a) {
                            J2b.call(this, a.d, a.c, a.a, a.b);
                        }
                        function Og(a) {
                            this.d = a;
                            Lg(this);
                            this.b = ed(a.d);
                        }
                        function cGd(a) {
                            aGd();
                            return ws((fGd(), eGd), a);
                        }
                        function gk(a, b) {
                            Qb(a);
                            Qb(b);
                            return new hk(a, b);
                        }
                        function dr(a, b) {
                            Qb(a);
                            Qb(b);
                            return new mr(a, b);
                        }
                        function hr(a, b) {
                            Qb(a);
                            Qb(b);
                            return new sr(a, b);
                        }
                        function Dr(a, b) {
                            Qb(a);
                            Qb(b);
                            return new Rr(a, b);
                        }
                        function Uub(a) {
                            sFb(a.b != 0);
                            return Wub(a, a.a.a);
                        }
                        function Vub(a) {
                            sFb(a.b != 0);
                            return Wub(a, a.c.b);
                        }
                        function q$d(a) {
                            !a.c && (a.c = new X9d);
                            return a.c;
                        }
                        function cv(a) {
                            var b;
                            b = new bnb;
                            xr(b, a);
                            return b;
                        }
                        function Vx(a) {
                            var b;
                            b = new _sb;
                            xr(b, a);
                            return b;
                        }
                        function Yx(a) {
                            var b;
                            b = new xAb;
                            _q(b, a);
                            return b;
                        }
                        function gv(a) {
                            var b;
                            b = new Yub;
                            _q(b, a);
                            return b;
                        }
                        function RD(a, b) {
                            CFb(a == null || QD(a, b));
                            return a;
                        }
                        function Mxb(a, b, c) {
                            Axb.call(this, b, c);
                            this.a = a;
                        }
                        function kB(a, b) {
                            this.c = a;
                            this.b = b;
                            this.a = false;
                        }
                        function hCb() {
                            this.a = ';,;';
                            this.b = '';
                            this.c = '';
                        }
                        function $Cb(a, b, c) {
                            this.b = a;
                            pxb.call(this, b, c);
                        }
                        function uub(a, b, c) {
                            this.c = a;
                            xlb.call(this, b, c);
                        }
                        function fZb(a, b, c) {
                            eZb.call(this, a, b);
                            this.b = c;
                        }
                        function YEb(a, b, c) {
                            VEb(c, 0, a, b, c.length, false);
                        }
                        function JYb(a, b, c, d, e) {
                            a.b = b;
                            a.c = c;
                            a.d = d;
                            a.a = e;
                        }
                        function D2b(a, b, c, d, e) {
                            a.d = b;
                            a.c = c;
                            a.a = d;
                            a.b = e;
                        }
                        function XDb(a, b) {
                            if (b) {
                                a.b = b;
                                a.a = (LCb(b), b.a);
                            }
                        }
                        function mFb(a, b) {
                            if (!a) throw Adb(new agb(b));
                        }
                        function zFb(a, b) {
                            if (!a) throw Adb(new dgb(b));
                        }
                        function qFb(a, b) {
                            if (!a) throw Adb(new zeb(b));
                        }
                        function zqc(a, b) {
                            mqc();
                            return hgb(a.d.p, b.d.p);
                        }
                        function T0c(a, b) {
                            B0c();
                            return Qfb(a.e.b, b.e.b);
                        }
                        function U0c(a, b) {
                            B0c();
                            return Qfb(a.e.a, b.e.a);
                        }
                        function Xoc(a, b) {
                            return hgb(N3b(a.d), N3b(b.d));
                        }
                        function Izb(a, b) {
                            return !!b && Jzb(a, b.d) ? b : null;
                        }
                        function $lc(a, b) {
                            return b == (qpd(), ppd) ? a.c : a.d;
                        }
                        function Qdb(a) {
                            return Edb(yD(Kdb(a) ? Wdb(a) : a));
                        }
                        function Nid(a) {
                            return new rjd(a.c + a.b, a.d + a.a);
                        }
                        function GSd(a) {
                            return a != null && !mSd(a, aSd, bSd);
                        }
                        function DSd(a, b) {
                            return (JSd(a) << 4 | JSd(b)) & Bwe;
                        }
                        function Rid(a, b, c, d, e) {
                            a.c = b;
                            a.d = c;
                            a.b = d;
                            a.a = e;
                        }
                        function y8b(a) {
                            var b, c;
                            b = a.b;
                            c = a.c;
                            a.b = c;
                            a.c = b;
                        }
                        function B8b(a) {
                            var b, c;
                            c = a.d;
                            b = a.a;
                            a.d = b;
                            a.a = c;
                        }
                        function u6d(a, b) {
                            var c;
                            c = a.c;
                            t6d(a, b);
                            return c;
                        }
                        function Nqd(a, b) {
                            b < 0 ? a.g = -1 : a.g = b;
                            return a;
                        }
                        function kjd(a, b) {
                            gjd(a);
                            a.a *= b;
                            a.b *= b;
                            return a;
                        }
                        function hrc(a, b, c) {
                            grc.call(this, b, c);
                            this.d = a;
                        }
                        function PZd(a, b, c) {
                            kZd.call(this, a, b);
                            this.c = c;
                        }
                        function Kfe(a, b, c) {
                            kZd.call(this, a, b);
                            this.c = c;
                        }
                        function zUd(a) {
                            yUd();
                            kUd.call(this);
                            this.ci(a);
                        }
                        function Yee() {
                            ree();
                            Zee.call(this, (YSd(), XSd));
                        }
                        function Yse(a) {
                            Vse();
                            ++Use;
                            return new Hte(0, a);
                        }
                        function uke() {
                            uke = geb;
                            tke = (yob(), new mpb(eLe));
                        }
                        function ux() {
                            ux = geb;
                            new wx((kl(), jl), (Wk(), Vk));
                        }
                        function ugb() {
                            ugb = geb;
                            tgb = $C(bJ, Nve, 17, 256, 0, 1);
                        }
                        function zUb() {
                            this.b = Kfb(UD(iGd((yVb(), sVb))));
                        }
                        function Pq(a) {
                            this.b = a;
                            this.a = gn(this.b.a).Od();
                        }
                        function mr(a, b) {
                            this.b = a;
                            this.a = b;
                            zl.call(this);
                        }
                        function sr(a, b) {
                            this.a = a;
                            this.b = b;
                            zl.call(this);
                        }
                        function s_d(a, b, c) {
                            this.a = a;
                            N$d.call(this, b, c);
                        }
                        function n_d(a, b, c) {
                            this.a = a;
                            N$d.call(this, b, c);
                        }
                        function sDd(a, b, c) {
                            var d;
                            d = new OC(c);
                            sC(a, b, d);
                        }
                        function _Eb(a, b, c) {
                            var d;
                            d = a[b];
                            a[b] = c;
                            return d;
                        }
                        function UEb(a) {
                            var b;
                            b = a.slice();
                            return dD(b, a);
                        }
                        function SJb(a) {
                            var b;
                            b = a.n;
                            return a.a.b + b.d + b.a;
                        }
                        function PKb(a) {
                            var b;
                            b = a.n;
                            return a.e.b + b.d + b.a;
                        }
                        function QKb(a) {
                            var b;
                            b = a.n;
                            return a.e.a + b.b + b.c;
                        }
                        function rub(a) {
                            a.a.b = a.b;
                            a.b.a = a.a;
                            a.a = a.b = null;
                        }
                        function Mub(a, b) {
                            Pub(a, b, a.c.b, a.c);
                            return true;
                        }
                        function w2b(a) {
                            if (a.a) return a.a;
                            return R0b(a);
                        }
                        function NSb(a) {
                            HSb();
                            return JGd(a) == vCd(LGd(a));
                        }
                        function OSb(a) {
                            HSb();
                            return LGd(a) == vCd(JGd(a));
                        }
                        function l_b(a, b) {
                            return k_b(a, new eZb(b.a, b.b));
                        }
                        function xn(a, b) {
                            return fn(), ck(a, b), new zy(a, b);
                        }
                        function fmc(a, b) {
                            return a.c < b.c ? -1 : a.c == b.c ? 0 : 1;
                        }
                        function snc(a) {
                            return a.b.c.length - a.e.c.length;
                        }
                        function N3b(a) {
                            return a.e.c.length - a.g.c.length;
                        }
                        function L3b(a) {
                            return a.e.c.length + a.g.c.length;
                        }
                        function Lgb(a) {
                            return a == 0 || isNaN(a) ? a : a < 0 ? -1 : 1;
                        }
                        function V0b(a) {
                            return !W0b(a) && a.c.i.c == a.d.i.c;
                        }
                        function DOc(a) {
                            dOc();
                            return (qpd(), apd).Hc(a.j);
                        }
                        function M0c(a, b, c) {
                            B0c();
                            return c.e.a + c.f.a + a * b;
                        }
                        function W0c(a, b, c) {
                            B0c();
                            return c.e.b + c.f.b + a * b;
                        }
                        function SUc(a, b, c) {
                            return Zjb(a.b, RD(c.b, 18), b);
                        }
                        function TUc(a, b, c) {
                            return Zjb(a.b, RD(c.b, 18), b);
                        }
                        function oFd(a, b, c) {
                            iEd(a.a, a.b, a.c, RD(b, 166), c);
                        }
                        function lad(a, b, c, d) {
                            mad.call(this, a, b, c, d, 0, 0);
                        }
                        function LUd(a) {
                            yUd();
                            zUd.call(this, a);
                            this.a = -1;
                        }
                        function Gxb(a, b) {
                            Axb.call(this, b, 1040);
                            this.a = a;
                        }
                        function zqd() {
                            vqd.call(this, 'COUNT_CHILDREN', 0);
                        }
                        function ole(a, b) {
                            Eke.call(this, a, b);
                            this.a = this;
                        }
                        function ufb(a, b) {
                            var c;
                            c = rfb(a, b);
                            c.i = 2;
                            return c;
                        }
                        function cJd(a, b) {
                            var c;
                            ++a.j;
                            c = a.Cj(b);
                            return c;
                        }
                        function pfd(a, b, c) {
                            a.a = -1;
                            tfd(a, b.g, c);
                            return a;
                        }
                        function Bsd(a, b) {
                            return Rmb(a, new rjd(b.a, b.b));
                        }
                        function __c(a) {
                            return R_c(), $C(Z$, NEe, 40, a, 0, 1);
                        }
                        function dj(a) {
                            return a.e.Rd().gc() * a.c.Rd().gc();
                        }
                        function fk(a, b, c) {
                            return new rk(hDb(a)._e(), c, b);
                        }
                        function mVd(a, b) {
                            nVd(a, b == null ? null : (uFb(b), b));
                        }
                        function q6d(a, b) {
                            s6d(a, b == null ? null : (uFb(b), b));
                        }
                        function r6d(a, b) {
                            s6d(a, b == null ? null : (uFb(b), b));
                        }
                        function CFb(a) {
                            if (!a) throw Adb(new Ifb(null));
                        }
                        function tt(a) {
                            if (a.c.e != a.a) throw Adb(new Jrb);
                        }
                        function Au(a) {
                            if (a.e.c != a.b) throw Adb(new Jrb);
                        }
                        function Ar(a) {
                            Qb(a);
                            while(a.Ob()){
                                a.Pb();
                                a.Qb();
                            }
                        }
                        function Dy(a) {
                            tm();
                            this.a = (yob(), new mpb(Qb(a)));
                        }
                        function mf(a) {
                            this.c = a;
                            this.b = this.c.d.vc().Kc();
                        }
                        function hx(a) {
                            a.a.ld();
                            RD(a.a.md(), 16).gc();
                            Hh();
                        }
                        function $hb(a, b) {
                            a.a += Ihb(b, 0, b.length);
                            return a;
                        }
                        function Vmb(a, b) {
                            tFb(b, a.c.length);
                            return a.c[b];
                        }
                        function kob(a, b) {
                            tFb(b, a.a.length);
                            return a.a[b];
                        }
                        function Arb(a, b) {
                            return uFb(b), Leb(b, (uFb(a), a));
                        }
                        function vrb(a, b) {
                            return uFb(a), Leb(a, (uFb(b), b));
                        }
                        function YC(a, b, c, d, e, f) {
                            return ZC(a, b, c, d, e, 0, f);
                        }
                        function GBb(a, b) {
                            return bD(b, 0, tCb(b[0], Hgb(1)));
                        }
                        function IBb(a, b) {
                            return Hgb(Bdb(Hgb(a.a).a, b.a));
                        }
                        function tCb(a, b) {
                            return IBb(RD(a, 168), RD(b, 168));
                        }
                        function Jgb() {
                            Jgb = geb;
                            Igb = $C(eJ, Nve, 168, 256, 0, 1);
                        }
                        function dhb() {
                            dhb = geb;
                            chb = $C(lJ, Nve, 191, 256, 0, 1);
                        }
                        function Zeb() {
                            Zeb = geb;
                            Yeb = $C(RI, Nve, 222, 256, 0, 1);
                        }
                        function jfb() {
                            jfb = geb;
                            ifb = $C(SI, Nve, 180, 128, 0, 1);
                        }
                        function KYb() {
                            JYb(this, false, false, false, false);
                        }
                        function Kub(a) {
                            ctb.call(this, new gub);
                            ye(this, a);
                        }
                        function btb(a) {
                            this.a = new Usb(a.gc());
                            ye(this, a);
                        }
                        function nsb(a) {
                            this.c = a;
                            this.a = new Osb(this.c.a);
                        }
                        function Kmc(a) {
                            this.a = a;
                            this.c = new Tsb;
                            Emc(this);
                        }
                        function DRb() {
                            this.d = new rjd(0, 0);
                            this.e = new _sb;
                        }
                        function SDb(a, b) {
                            xDb();
                            NCb.call(this, a);
                            this.a = b;
                        }
                        function J2b(a, b, c, d) {
                            A2b(this);
                            D2b(this, a, b, c, d);
                        }
                        function Uqc(a, b, c) {
                            return hgb(b.d[a.g], c.d[a.g]);
                        }
                        function wMc(a, b, c) {
                            return hgb(a.d[b.p], a.d[c.p]);
                        }
                        function xMc(a, b, c) {
                            return hgb(a.d[b.p], a.d[c.p]);
                        }
                        function yMc(a, b, c) {
                            return hgb(a.d[b.p], a.d[c.p]);
                        }
                        function zMc(a, b, c) {
                            return hgb(a.d[b.p], a.d[c.p]);
                        }
                        function Aad(a, b, c) {
                            return $wnd.Math.min(c / a, 1 / b);
                        }
                        function SIc(a, b) {
                            return a ? 0 : $wnd.Math.max(0, b - 1);
                        }
                        function qSd(a, b) {
                            return a == null ? b == null : lhb(a, b);
                        }
                        function rSd(a, b) {
                            return a == null ? b == null : mhb(a, b);
                        }
                        function lQb(a) {
                            return !a.q ? (yob(), yob(), wob) : a.q;
                        }
                        function _lc(a) {
                            return a.c - RD(Vmb(a.a, a.b), 294).b;
                        }
                        function trd(a) {
                            if (a.c) return a.c.f;
                            return a.e.b;
                        }
                        function urd(a) {
                            if (a.c) return a.c.g;
                            return a.e.a;
                        }
                        function wsc(a, b) {
                            a.a == null && usc(a);
                            return a.a[b];
                        }
                        function L2c(a) {
                            var b;
                            b = R2c(a);
                            return !b ? a : L2c(b);
                        }
                        function $se(a, b) {
                            Vse();
                            ++Use;
                            return new Qte(a, b);
                        }
                        function Hte(a, b) {
                            Vse();
                            Wse.call(this, a);
                            this.a = b;
                        }
                        function N8d(a, b) {
                            s7d();
                            t7d.call(this, b);
                            this.a = a;
                        }
                        function iae(a, b, c) {
                            this.a = a;
                            XZd.call(this, b, c, 2);
                        }
                        function ntd(a) {
                            this.b = new Yub;
                            this.a = a;
                            this.c = -1;
                        }
                        function ds(a) {
                            qc.call(this, 0, 0);
                            this.a = a;
                            this.b = 0;
                        }
                        function PSd(a) {
                            ZHd.call(this, a.gc());
                            YGd(this, a);
                        }
                        function jg(a) {
                            a.b ? jg(a.b) : a.d.dc() && a.f.c.Bc(a.e);
                        }
                        function aD(a) {
                            return Array.isArray(a) && a.Tm === keb;
                        }
                        function Bsb(a, b) {
                            return ZD(b, 22) && Csb(a, RD(b, 22));
                        }
                        function Dsb(a, b) {
                            return ZD(b, 22) && Esb(a, RD(b, 22));
                        }
                        function qtb(a, b) {
                            return otb(a, b, ptb(a, a.b.Ce(b)));
                        }
                        function Jtb(a, b) {
                            return !(a.a.get(b) === undefined);
                        }
                        function Iwb(a) {
                            return Kwb(a, 26) * Kxe + Kwb(a, 27) * Lxe;
                        }
                        function OBb(a, b) {
                            return FBb(new jCb, new VBb(a), b);
                        }
                        function Ynb(a, b, c) {
                            nFb(0, b, a.length);
                            Wnb(a, 0, b, c);
                        }
                        function Qmb(a, b, c) {
                            wFb(b, a.c.length);
                            XEb(a.c, b, c);
                        }
                        function dKb(a, b, c) {
                            var d;
                            if (a) {
                                d = a.i;
                                d.c = b;
                                d.b = c;
                            }
                        }
                        function eKb(a, b, c) {
                            var d;
                            if (a) {
                                d = a.i;
                                d.d = b;
                                d.a = c;
                            }
                        }
                        function Pnb(a, b, c) {
                            var d;
                            for(d = 0; d < b; ++d)a[d] = c;
                        }
                        function Qnb(a, b) {
                            var c;
                            for(c = 0; c < b; ++c)a[c] = -1;
                        }
                        function ysb(a, b) {
                            var c;
                            c = xsb(a);
                            zob(c, b);
                            return c;
                        }
                        function cA(a, b) {
                            !a && (a = []);
                            a[a.length] = b;
                            return a;
                        }
                        function RQb(a, b) {
                            $id(a.c, b);
                            a.b.c += b.a;
                            a.b.d += b.b;
                        }
                        function QQb(a, b) {
                            RQb(a, ojd(new rjd(b.a, b.b), a.c));
                        }
                        function sOb(a, b) {
                            this.b = new Yub;
                            this.a = a;
                            this.c = b;
                        }
                        function QYb() {
                            this.b = new aZb;
                            this.c = new UYb(this);
                        }
                        function fHb() {
                            this.d = new tHb;
                            this.e = new lHb(this);
                        }
                        function UFc() {
                            RFc();
                            this.f = new Yub;
                            this.e = new Yub;
                        }
                        function yOc() {
                            dOc();
                            this.k = new Tsb;
                            this.d = new _sb;
                        }
                        function nud() {
                            nud = geb;
                            mud = new mGd((umd(), Gld), 0);
                        }
                        function cs() {
                            cs = geb;
                            bs = new ds($C(jJ, rve, 1, 0, 5, 1));
                        }
                        function _ad(a, b, c) {
                            return Ysb(a, new TFb(b.a, c.a));
                        }
                        function DGc(a, b, c) {
                            return -hgb(a.f[b.p], a.f[c.p]);
                        }
                        function Mic(a, b, c) {
                            Hic(c, a, 1);
                            Rmb(b, new xjc(c, a));
                        }
                        function Nic(a, b, c) {
                            Iic(c, a, 1);
                            Rmb(b, new Jjc(c, a));
                        }
                        function h$d(a, b, c) {
                            this.a = a;
                            _Zd.call(this, b, c, 22);
                        }
                        function s5d(a, b, c) {
                            this.a = a;
                            _Zd.call(this, b, c, 14);
                        }
                        function E8d(a, b, c, d) {
                            s7d();
                            N7d.call(this, a, b, c, d);
                        }
                        function L8d(a, b, c, d) {
                            s7d();
                            N7d.call(this, a, b, c, d);
                        }
                        function nfd(a, b, c) {
                            a.a = -1;
                            tfd(a, b.g + 1, c);
                            return a;
                        }
                        function bCd(a, b, c) {
                            c = xvd(a, RD(b, 54), 7, c);
                            return c;
                        }
                        function hVd(a, b, c) {
                            c = xvd(a, RD(b, 54), 3, c);
                            return c;
                        }
                        function Ydb(a) {
                            if (Kdb(a)) return a | 0;
                            return FD(a);
                        }
                        function cte(a) {
                            Vse();
                            ++Use;
                            return new eue(10, a, 0);
                        }
                        function fe(a) {
                            var b;
                            b = a.f;
                            return !b ? a.f = a.Dc() : b;
                        }
                        function Ec(a) {
                            var b;
                            b = a.i;
                            return !b ? a.i = a.bc() : b;
                        }
                        function Ahe(a) {
                            if (a.e.j != a.d) throw Adb(new Jrb);
                        }
                        function gn(a) {
                            if (a.c) return a.c;
                            return a.c = a.Sd();
                        }
                        function hn(a) {
                            if (a.d) return a.d;
                            return a.d = a.Td();
                        }
                        function Uee(a, b) {
                            return ufe(Pee(a, b)) ? b.zi() : null;
                        }
                        function ed(a) {
                            return ZD(a, 15) ? RD(a, 15).ed() : a.Kc();
                        }
                        function De(a) {
                            return a.Qc($C(jJ, rve, 1, a.gc(), 5, 1));
                        }
                        function aE(a) {
                            return a != null && cE(a) && !(a.Tm === keb);
                        }
                        function YD(a) {
                            return !Array.isArray(a) && a.Tm === keb;
                        }
                        function vx(a, b) {
                            return Qb(b), a.a.Jd(b) && !a.b.Jd(b);
                        }
                        function tD(a, b) {
                            return hD(a.l & b.l, a.m & b.m, a.h & b.h);
                        }
                        function zD(a, b) {
                            return hD(a.l | b.l, a.m | b.m, a.h | b.h);
                        }
                        function HD(a, b) {
                            return hD(a.l ^ b.l, a.m ^ b.m, a.h ^ b.h);
                        }
                        function Sdb(a, b) {
                            return Edb(AD(Kdb(a) ? Wdb(a) : a, b));
                        }
                        function Tdb(a, b) {
                            return Edb(BD(Kdb(a) ? Wdb(a) : a, b));
                        }
                        function Udb(a, b) {
                            return Edb(CD(Kdb(a) ? Wdb(a) : a, b));
                        }
                        function Ieb(a, b) {
                            return Keb((uFb(a), a), (uFb(b), b));
                        }
                        function Jfb(a, b) {
                            return Qfb((uFb(a), a), (uFb(b), b));
                        }
                        function pwb(a) {
                            this.b = new cnb(11);
                            this.a = (urb(), a);
                        }
                        function is(a) {
                            this.a = (cs(), bs);
                            this.d = RD(Qb(a), 51);
                        }
                        function Axb(a, b) {
                            this.c = 0;
                            this.d = a;
                            this.b = b | 64 | Ove;
                        }
                        function kxb(a, b) {
                            this.e = a;
                            this.d = (b & 64) != 0 ? b | Ove : b;
                        }
                        function ezb(a) {
                            this.b = null;
                            this.a = (urb(), !a ? rrb : a);
                        }
                        function nz(a) {
                            ez(this);
                            this.g = a;
                            gz(this);
                            this.je();
                        }
                        function vue(a) {
                            uue();
                            this.a = 0;
                            this.b = a - 1;
                            this.c = 1;
                        }
                        function yg(a, b, c, d) {
                            this.a = a;
                            lg.call(this, a, b, c, d);
                        }
                        function gEb(a, b, c) {
                            if (a.a.Mb(c)) {
                                a.b = true;
                                b.Cd(c);
                            }
                        }
                        function Qwb(a) {
                            if (!a.d) {
                                a.d = a.b.Kc();
                                a.c = a.b.gc();
                            }
                        }
                        function lyb(a, b) {
                            if (a < 0 || a >= b) throw Adb(new web);
                        }
                        function JDb(a, b) {
                            return MDb(a, (uFb(b), new JAb(b)));
                        }
                        function KDb(a, b) {
                            return MDb(a, (uFb(b), new LAb(b)));
                        }
                        function prc(a, b, c) {
                            return qrc(a, RD(b, 12), RD(c, 12));
                        }
                        function q4b(a) {
                            return J3b(), RD(a, 12).g.c.length != 0;
                        }
                        function v4b(a) {
                            return J3b(), RD(a, 12).e.c.length != 0;
                        }
                        function sdc(a, b) {
                            Zcc();
                            return Qfb(b.a.o.a, a.a.o.a);
                        }
                        function d_d(a, b) {
                            (b.Bb & QHe) != 0 && !a.a.o && (a.a.o = b);
                        }
                        function T3c(a, b) {
                            b.Ug("General 'Rotator", 1);
                            S3c(a);
                        }
                        function MCc(a, b, c) {
                            b.qf(c, Kfb(UD(Wjb(a.b, c))) * a.a);
                        }
                        function yid(a, b, c) {
                            tid();
                            return xid(a, b) && xid(a, c);
                        }
                        function Rod(a) {
                            Pod();
                            return !a.Hc(Lod) && !a.Hc(Nod);
                        }
                        function Nrc(a) {
                            if (a.e) return Src(a.e);
                            return null;
                        }
                        function Zdb(a) {
                            if (Kdb(a)) return '' + a;
                            return GD(a);
                        }
                        function XNc(a) {
                            var b;
                            b = a;
                            while(b.f)b = b.f;
                            return b;
                        }
                        function HBb(a, b, c) {
                            bD(b, 0, tCb(b[0], c[0]));
                            return b;
                        }
                        function Gpc(a, b, c, d) {
                            var e;
                            e = a.i;
                            e.i = b;
                            e.a = c;
                            e.b = d;
                        }
                        function C5d(a, b, c, d) {
                            XZd.call(this, a, b, c);
                            this.b = d;
                        }
                        function N3d(a, b, c, d, e) {
                            O3d.call(this, a, b, c, d, e, -1);
                        }
                        function b4d(a, b, c, d, e) {
                            c4d.call(this, a, b, c, d, e, -1);
                        }
                        function Iie(a, b, c, d) {
                            PZd.call(this, a, b, c);
                            this.b = d;
                        }
                        function Xde(a) {
                            uId.call(this, a, false);
                            this.a = false;
                        }
                        function Bqd() {
                            vqd.call(this, 'LOOKAHEAD_LAYOUT', 1);
                        }
                        function nNd(a) {
                            this.b = a;
                            mMd.call(this, a);
                            mNd(this);
                        }
                        function vNd(a) {
                            this.b = a;
                            BMd.call(this, a);
                            uNd(this);
                        }
                        function J5d(a, b, c) {
                            this.a = a;
                            G5d.call(this, b, c, 5, 6);
                        }
                        function wje(a, b, c, d) {
                            this.b = a;
                            XZd.call(this, b, c, d);
                        }
                        function Tj(a, b) {
                            this.b = a;
                            Aj.call(this, a.b);
                            this.a = b;
                        }
                        function NLc(a) {
                            this.a = LLc(a.a);
                            this.b = new dnb(a.b);
                        }
                        function Fx(a, b) {
                            tm();
                            Ex.call(this, a, Pm(new mob(b)));
                        }
                        function _se(a, b) {
                            Vse();
                            ++Use;
                            return new aue(a, b, 0);
                        }
                        function bte(a, b) {
                            Vse();
                            ++Use;
                            return new aue(6, a, b);
                        }
                        function Ztb(a, b) {
                            uFb(b);
                            while(a.Ob())b.Cd(a.Pb());
                        }
                        function Ujb(a, b) {
                            return bE(b) ? Yjb(a, b) : !!qtb(a.f, b);
                        }
                        function O_d(a, b) {
                            return b.Vh() ? Vvd(a.b, RD(b, 54)) : b;
                        }
                        function whb(a, b) {
                            return lhb(a.substr(0, b.length), b);
                        }
                        function Fl(a) {
                            return new is(new Il(a.a.length, a.a));
                        }
                        function Oid(a) {
                            return new rjd(a.c + a.b / 2, a.d + a.a / 2);
                        }
                        function yD(a) {
                            return hD(~a.l & dxe, ~a.m & dxe, ~a.h & exe);
                        }
                        function cE(a) {
                            return typeof a === gve || typeof a === kve;
                        }
                        function akb(a) {
                            a.f = new ttb(a);
                            a.i = new Ntb(a);
                            ++a.g;
                        }
                        function Klb(a) {
                            if (!a) throw Adb(new Dvb);
                            return a.d;
                        }
                        function smb(a) {
                            var b;
                            b = omb(a);
                            sFb(b != null);
                            return b;
                        }
                        function tmb(a) {
                            var b;
                            b = pmb(a);
                            sFb(b != null);
                            return b;
                        }
                        function tv(a, b) {
                            var c;
                            c = a.a.gc();
                            Sb(b, c);
                            return c - b;
                        }
                        function Ysb(a, b) {
                            var c;
                            c = a.a.zc(b, a);
                            return c == null;
                        }
                        function rAb(a, b) {
                            return a.a.zc(b, (Geb(), Eeb)) == null;
                        }
                        function _nb(a) {
                            return new SDb(null, $nb(a, a.length));
                        }
                        function yPb(a, b, c) {
                            return zPb(a, RD(b, 42), RD(c, 176));
                        }
                        function Wrb(a, b, c) {
                            zsb(a.a, b);
                            return _Eb(a.b, b.g, c);
                        }
                        function fyb(a, b, c) {
                            lyb(c, a.a.c.length);
                            $mb(a.a, c, b);
                        }
                        function Knb(a, b, c, d) {
                            nFb(b, c, a.length);
                            Onb(a, b, c, d);
                        }
                        function Onb(a, b, c, d) {
                            var e;
                            for(e = b; e < c; ++e)a[e] = d;
                        }
                        function Snb(a, b) {
                            var c;
                            for(c = 0; c < b; ++c)a[c] = false;
                        }
                        function cjb(a, b, c) {
                            Pib();
                            this.e = a;
                            this.d = b;
                            this.a = c;
                        }
                        function DBb(a, b, c) {
                            this.c = a;
                            this.a = b;
                            yob();
                            this.b = c;
                        }
                        function nMd(a, b) {
                            this.d = a;
                            dMd.call(this, a);
                            this.e = b;
                        }
                        function Ved(a, b, c) {
                            Ned(a, b.g, c);
                            zsb(a.c, b);
                            return a;
                        }
                        function xYb(a) {
                            vYb(a, (Cmd(), ymd));
                            a.d = true;
                            return a;
                        }
                        function Cfe(a) {
                            !a.j && Ife(a, Dee(a.g, a.b));
                            return a.j;
                        }
                        function At(a) {
                            a.a = null;
                            a.e = null;
                            akb(a.b);
                            a.d = 0;
                            ++a.c;
                        }
                        function znb(a) {
                            yFb(a.b != -1);
                            Xmb(a.c, a.a = a.b);
                            a.b = -1;
                        }
                        function Qte(a, b) {
                            Wse.call(this, 1);
                            this.a = a;
                            this.b = b;
                        }
                        function uUb(a, b) {
                            return a > 0 ? $wnd.Math.log(a / b) : -100;
                        }
                        function Agb(a, b) {
                            return Ddb(a, b) < 0 ? -1 : Ddb(a, b) > 0 ? 1 : 0;
                        }
                        function Dge(a, b) {
                            hZd(a, ZD(b, 160) ? b : RD(b, 2036).Rl());
                        }
                        function vFb(a, b) {
                            if (a == null) throw Adb(new Ogb(b));
                        }
                        function $nb(a, b) {
                            return jxb(b, a.length), new Gxb(a, b);
                        }
                        function hsc(a, b) {
                            if (!b) return false;
                            return ye(a, b);
                        }
                        function Gs() {
                            zs();
                            return cD(WC(RG, 1), jwe, 549, 0, [
                                ys
                            ]);
                        }
                        function Xib(a) {
                            return a.e == 0 ? a : new cjb(-a.e, a.d, a.a);
                        }
                        function $Nb(a, b) {
                            return Qfb(a.c.c + a.c.b, b.c.c + b.c.b);
                        }
                        function cvb(a, b) {
                            Pub(a.d, b, a.b.b, a.b);
                            ++a.a;
                            a.c = null;
                        }
                        function JCb(a, b) {
                            !a.c ? Rmb(a.b, b) : JCb(a.c, b);
                            return a;
                        }
                        function KB(a, b, c) {
                            var d;
                            d = JB(a, b);
                            LB(a, b, c);
                            return d;
                        }
                        function Rnb(a, b, c) {
                            var d;
                            for(d = 0; d < b; ++d)bD(a, d, c);
                        }
                        function nhb(a, b, c, d, e) {
                            while(b < c)d[e++] = ihb(a, b++);
                        }
                        function Qnc(a, b, c, d, e) {
                            Pnc(a, RD(Qc(b.k, c), 15), c, d, e);
                        }
                        function Nnc(a, b) {
                            FDb(GDb(a.Oc(), new voc), new xoc(b));
                        }
                        function tXc(a, b) {
                            return Qfb(a.e.a + a.f.a, b.e.a + b.f.a);
                        }
                        function vXc(a, b) {
                            return Qfb(a.e.b + a.f.b, b.e.b + b.f.b);
                        }
                        function GOc(a) {
                            return $wnd.Math.abs(a.d.e - a.e.e) - a.a;
                        }
                        function ane(a) {
                            return a == oxe ? mLe : a == pxe ? '-INF' : '' + a;
                        }
                        function cne(a) {
                            return a == oxe ? mLe : a == pxe ? '-INF' : '' + a;
                        }
                        function MSb(a) {
                            HSb();
                            return vCd(JGd(a)) == vCd(LGd(a));
                        }
                        function kOd(a, b, c) {
                            return RD(a.c.hd(b, RD(c, 136)), 44);
                        }
                        function IFd(a, b) {
                            oDd(a, new OC(b.f != null ? b.f : '' + b.g));
                        }
                        function KFd(a, b) {
                            oDd(a, new OC(b.f != null ? b.f : '' + b.g));
                        }
                        function YGd(a, b) {
                            a.Si() && (b = bHd(a, b));
                            return a.Fi(b);
                        }
                        function VVd(a, b) {
                            b = a.Yk(null, b);
                            return UVd(a, null, b);
                        }
                        function Wfe(a, b) {
                            ++a.j;
                            Tge(a, a.i, b);
                            Vfe(a, RD(b, 343));
                        }
                        function UId(a) {
                            a ? iz(a, (gib(), fib), '') : neb((gib(), a));
                        }
                        function Twb(a) {
                            this.d = (uFb(a), a);
                            this.a = 0;
                            this.c = Sve;
                        }
                        function TTc(a, b) {
                            this.d = bUc(a);
                            this.c = b;
                            this.a = 0.5 * b;
                        }
                        function WTb(a) {
                            VTb.call(this);
                            this.a = a;
                            Rmb(a.a, this);
                        }
                        function Zje() {
                            gub.call(this);
                            this.a = true;
                            this.b = true;
                        }
                        function WB() {
                            WB = geb;
                            UB = new XB(false);
                            VB = new XB(true);
                        }
                        function Pc(a) {
                            var b;
                            return b = a.g, !b ? a.g = new th(a) : b;
                        }
                        function Uc(a) {
                            var b;
                            return b = a.k, !b ? a.k = new Bh(a) : b;
                        }
                        function ki(a) {
                            var b;
                            return b = a.k, !b ? a.k = new Bh(a) : b;
                        }
                        function ej(a) {
                            var b;
                            return b = a.i, !b ? a.i = new Ki(a) : b;
                        }
                        function bj(a) {
                            var b;
                            b = a.f;
                            return !b ? a.f = new Zj(a) : b;
                        }
                        function Fc(a) {
                            var b;
                            b = a.j;
                            return !b ? a.j = new Sw(a) : b;
                        }
                        function Co(a) {
                            var b;
                            b = a.d;
                            return !b ? a.d = new mp(a) : b;
                        }
                        function ate(a, b, c) {
                            Vse();
                            ++Use;
                            return new Yte(a, b, c);
                        }
                        function yj(a, b) {
                            Pb(b, a.c.b.c.gc());
                            return new Nj(a, b);
                        }
                        function sv(a, b) {
                            var c;
                            c = a.a.gc();
                            Pb(b, c);
                            return c - 1 - b;
                        }
                        function sfb(a, b, c) {
                            var d;
                            d = rfb(a, b);
                            Ffb(c, d);
                            return d;
                        }
                        function rfb(a, b) {
                            var c;
                            c = new pfb;
                            c.j = a;
                            c.d = b;
                            return c;
                        }
                        function Qb(a) {
                            if (a == null) throw Adb(new Ngb);
                            return a;
                        }
                        function OC(a) {
                            if (a == null) throw Adb(new Ngb);
                            this.a = a;
                        }
                        function XA(a) {
                            vA();
                            this.b = new bnb;
                            this.a = a;
                            IA(this, a);
                        }
                        function Zs(a) {
                            this.b = a;
                            this.a = RD(Hvb(this.b.a.e), 227);
                        }
                        function tm() {
                            tm = geb;
                            _l();
                            sm = new Kx((yob(), yob(), vob));
                        }
                        function Px() {
                            Px = geb;
                            _l();
                            Ox = new Qx((yob(), yob(), xob));
                        }
                        function lTd() {
                            lTd = geb;
                            kTd = _ae();
                            !!(JTd(), nTd) && bbe();
                        }
                        function LSc(a) {
                            a.s = NaN;
                            a.c = NaN;
                            MSc(a, a.e);
                            MSc(a, a.j);
                        }
                        function AYd(a) {
                            return (a.i == null && rYd(a), a.i).length;
                        }
                        function wq(a, b) {
                            return RD(gn(a.a).Md().Xb(b), 44).ld();
                        }
                        function Wjb(a, b) {
                            return bE(b) ? Xjb(a, b) : Wd(qtb(a.f, b));
                        }
                        function QSb(a, b) {
                            HSb();
                            return a == JGd(b) ? LGd(b) : JGd(b);
                        }
                        function rWb(a, b, c, d) {
                            return c == 0 || (c - d) / c < a.e || b >= a.g;
                        }
                        function bD(a, b, c) {
                            pFb(c == null || VC(a, c));
                            return a[b] = c;
                        }
                        function yhb(a, b) {
                            BFb(b, a.length + 1);
                            return a.substr(b);
                        }
                        function yxb(a, b) {
                            uFb(b);
                            while(a.c < a.d)a.Se(b, a.c++);
                        }
                        function Dub(a) {
                            this.d = a;
                            this.c = a.a.d.a;
                            this.b = a.a.e.g;
                        }
                        function Ggd(a) {
                            this.c = a;
                            this.a = new Yub;
                            this.b = new Yub;
                        }
                        function R4b(a) {
                            this.c = new pjd;
                            this.a = new bnb;
                            this.b = a;
                        }
                        function fYb(a) {
                            this.b = new bnb;
                            this.a = new bnb;
                            this.c = a;
                        }
                        function Pdd(a, b, c) {
                            RD(b.b, 68);
                            Umb(b.a, new Wdd(a, c, b));
                        }
                        function rdc(a, b) {
                            Zcc();
                            return RD(Vrb(a, b.d), 15).Fc(b);
                        }
                        function oDd(a, b) {
                            var c;
                            c = a.a.length;
                            JB(a, c);
                            LB(a, c, b);
                        }
                        function eFb(a, b) {
                            var c;
                            c = console[a];
                            c.call(console, b);
                        }
                        function _Id(a, b) {
                            var c;
                            ++a.j;
                            c = a.Ej();
                            a.rj(a.Zi(c, b));
                        }
                        function lMc(a, b, c) {
                            var d;
                            d = rMc(a, b, c);
                            return kMc(a, d);
                        }
                        function j2d(a) {
                            !a.d && (a.d = new XZd(o7, a, 1));
                            return a.d;
                        }
                        function jVd(a) {
                            !a.a && (a.a = new XZd(r7, a, 4));
                            return a.a;
                        }
                        function Jhb(a, b) {
                            a.a += String.fromCharCode(b);
                            return a;
                        }
                        function Thb(a, b) {
                            a.a += String.fromCharCode(b);
                            return a;
                        }
                        function D9d(a, b, c) {
                            this.a = a;
                            L6d.call(this, b);
                            this.b = c;
                        }
                        function Fde(a, b, c) {
                            this.a = a;
                            MKd.call(this, 8, b, null, c);
                        }
                        function aue(a, b, c) {
                            Wse.call(this, a);
                            this.a = b;
                            this.b = c;
                        }
                        function O8d(a, b, c) {
                            t7d.call(this, b);
                            this.a = a;
                            this.b = c;
                        }
                        function ut(a) {
                            this.c = a;
                            this.b = this.c.a;
                            this.a = this.c.e;
                        }
                        function Zee(a) {
                            this.a = (uFb(qKe), qKe);
                            this.b = a;
                            new O5d;
                        }
                        function Trb(a) {
                            Ae(a.a);
                            a.b = $C(jJ, rve, 1, a.b.length, 5, 1);
                        }
                        function Ckb(a) {
                            yFb(a.c != -1);
                            a.d.gd(a.c);
                            a.b = a.c;
                            a.c = -1;
                        }
                        function ejd(a) {
                            return $wnd.Math.sqrt(a.a * a.a + a.b * a.b);
                        }
                        function Jzb(a, b) {
                            return Tyb(a.c, a.f, b, a.b, a.a, a.e, a.d);
                        }
                        function eyb(a, b) {
                            return lyb(b, a.a.c.length), Vmb(a.a, b);
                        }
                        function Hb(a, b) {
                            return dE(a) === dE(b) || a != null && pb(a, b);
                        }
                        function O2d(a) {
                            return ZD(a, 102) && (RD(a, 19).Bb & QHe) != 0;
                        }
                        function Fb(a) {
                            Hvb(a);
                            return ZD(a, 484) ? RD(a, 484) : jeb(a);
                        }
                        function bve(a) {
                            if (a) return a.dc();
                            return !a.Kc().Ob();
                        }
                        function kte(a) {
                            if (!Ase) return false;
                            return Yjb(Ase, a);
                        }
                        function hDb(a) {
                            if (0 >= a) return new rDb;
                            return iDb(a - 1);
                        }
                        function Y2b(a) {
                            if (!a.a && !!a.c) return a.c.b;
                            return a.a;
                        }
                        function Zx(a) {
                            if (ZD(a, 616)) return a;
                            return new sy(a);
                        }
                        function LCb(a) {
                            if (!a.c) {
                                MCb(a);
                                a.d = true;
                            } else LCb(a.c);
                        }
                        function ICb(a) {
                            if (!a.c) {
                                a.d = true;
                                KCb(a);
                            } else a.c.$e();
                        }
                        function bHb(a) {
                            a.b = false;
                            a.c = false;
                            a.d = false;
                            a.a = false;
                        }
                        function uMc(a) {
                            var b, c;
                            b = a.c.i.c;
                            c = a.d.i.c;
                            return b == c;
                        }
                        function _vd(a, b) {
                            var c;
                            c = a.Ih(b);
                            c >= 0 ? a.ki(c) : Tvd(a, b);
                        }
                        function mtd(a, b) {
                            a.c < 0 || a.b.b < a.c ? Oub(a.b, b) : a.a.tf(b);
                        }
                        function aBd(a, b) {
                            WGd((!a.a && (a.a = new F4d(a, a)), a.a), b);
                        }
                        function DQb(a, b) {
                            RQb(RD(b.b, 68), a);
                            Umb(b.a, new IQb(a));
                        }
                        function Woc(a, b) {
                            return hgb(b.j.c.length, a.j.c.length);
                        }
                        function oed(a, b, c) {
                            hed();
                            return c.Lg(a, RD(b.ld(), 149));
                        }
                        function Hvb(a) {
                            if (a == null) throw Adb(new Ngb);
                            return a;
                        }
                        function uFb(a) {
                            if (a == null) throw Adb(new Ngb);
                            return a;
                        }
                        function uKd(a) {
                            if (a.p != 4) throw Adb(new cgb);
                            return a.e;
                        }
                        function tKd(a) {
                            if (a.p != 3) throw Adb(new cgb);
                            return a.e;
                        }
                        function CKd(a) {
                            if (a.p != 3) throw Adb(new cgb);
                            return a.j;
                        }
                        function DKd(a) {
                            if (a.p != 4) throw Adb(new cgb);
                            return a.j;
                        }
                        function wKd(a) {
                            if (a.p != 6) throw Adb(new cgb);
                            return a.f;
                        }
                        function FKd(a) {
                            if (a.p != 6) throw Adb(new cgb);
                            return a.k;
                        }
                        function $9d(a) {
                            !a.b && (a.b = new pae(new lae));
                            return a.b;
                        }
                        function yfe(a) {
                            a.c == -2 && Efe(a, vee(a.g, a.b));
                            return a.c;
                        }
                        function vfb(a, b) {
                            var c;
                            c = rfb('', a);
                            c.n = b;
                            c.i = 1;
                            return c;
                        }
                        function kp(a, b, c, d) {
                            gp.call(this, a, c);
                            this.a = b;
                            this.f = d;
                        }
                        function ct(a, b, c, d) {
                            gp.call(this, a, b);
                            this.d = c;
                            this.a = d;
                        }
                        function zy(a, b) {
                            _p.call(this, Gob(Qb(a), Qb(b)));
                            this.a = b;
                        }
                        function ufd() {
                            Oed.call(this);
                            aFb(this.j.c, 0);
                            this.a = -1;
                        }
                        function $ae() {
                            FBd.call(this, AKe, (jTd(), iTd));
                            Uae(this);
                        }
                        function Bne() {
                            FBd.call(this, dLe, (Ole(), Nle));
                            xne(this);
                        }
                        function cdd() {
                            qs.call(this, 'DELAUNAY_TRIANGULATION', 0);
                        }
                        function Ehb(a) {
                            return String.fromCharCode.apply(null, a);
                        }
                        function Zjb(a, b, c) {
                            return bE(b) ? $jb(a, b, c) : rtb(a.f, b, c);
                        }
                        function Fob(a) {
                            yob();
                            return !a ? (urb(), urb(), trb) : a.Oe();
                        }
                        function Zu(a) {
                            dk(a, lwe);
                            return dz(Bdb(Bdb(5, a), a / 10 | 0));
                        }
                        function yx(a, b) {
                            ux();
                            return new wx(new tl(a), new dl(b));
                        }
                        function fn() {
                            fn = geb;
                            en = new Nx(cD(WC(UK, 1), Zve, 44, 0, []));
                        }
                        function tqb(a) {
                            !a.d && (a.d = new xpb(a.c.Cc()));
                            return a.d;
                        }
                        function qqb(a) {
                            !a.a && (a.a = new Sqb(a.c.vc()));
                            return a.a;
                        }
                        function sqb(a) {
                            !a.b && (a.b = new Lqb(a.c.ec()));
                            return a.b;
                        }
                        function qgb(a, b) {
                            while(b-- > 0)a = a << 1 | (a < 0 ? 1 : 0);
                            return a;
                        }
                        function BGc(a, b) {
                            var c;
                            c = new R4b(a);
                            ZEb(b.c, c);
                            return c;
                        }
                        function FMb(a, b) {
                            a.u.Hc((Pod(), Lod)) && DMb(a, b);
                            HMb(a, b);
                        }
                        function Fvb(a, b) {
                            return dE(a) === dE(b) || a != null && pb(a, b);
                        }
                        function Vrb(a, b) {
                            return Bsb(a.a, b) ? a.b[RD(b, 22).g] : null;
                        }
                        function YRb() {
                            VRb();
                            return cD(WC($O, 1), jwe, 489, 0, [
                                URb
                            ]);
                        }
                        function ybd() {
                            sbd();
                            return cD(WC(M1, 1), jwe, 490, 0, [
                                rbd
                            ]);
                        }
                        function Hbd() {
                            Cbd();
                            return cD(WC(N1, 1), jwe, 558, 0, [
                                Bbd
                            ]);
                        }
                        function gdd() {
                            _cd();
                            return cD(WC(V1, 1), jwe, 539, 0, [
                                $cd
                            ]);
                        }
                        function iyd(a) {
                            !a.n && (a.n = new C5d(I4, a, 1, 7));
                            return a.n;
                        }
                        function wCd(a) {
                            !a.c && (a.c = new C5d(K4, a, 9, 9));
                            return a.c;
                        }
                        function mzd(a) {
                            !a.c && (a.c = new Yie(E4, a, 5, 8));
                            return a.c;
                        }
                        function lzd(a) {
                            !a.b && (a.b = new Yie(E4, a, 4, 7));
                            return a.b;
                        }
                        function Sed(a) {
                            a.j.c.length = 0;
                            Ae(a.c);
                            sfd(a.a);
                            return a;
                        }
                        function Afe(a) {
                            a.e == fLe && Gfe(a, Aee(a.g, a.b));
                            return a.e;
                        }
                        function Bfe(a) {
                            a.f == fLe && Hfe(a, Bee(a.g, a.b));
                            return a.f;
                        }
                        function xBd(a, b, c, d) {
                            wBd(a, b, c, false);
                            j1d(a, d);
                            return a;
                        }
                        function oNd(a, b) {
                            this.b = a;
                            nMd.call(this, a, b);
                            mNd(this);
                        }
                        function wNd(a, b) {
                            this.b = a;
                            CMd.call(this, a, b);
                            uNd(this);
                        }
                        function Kmb(a) {
                            this.d = a;
                            this.a = this.d.b;
                            this.b = this.d.c;
                        }
                        function oy(a, b) {
                            this.b = a;
                            this.c = b;
                            this.a = new Osb(this.b);
                        }
                        function ihb(a, b) {
                            BFb(b, a.length);
                            return a.charCodeAt(b);
                        }
                        function NDd(a, b) {
                            CGd(a, Kfb(vDd(b, 'x')), Kfb(vDd(b, 'y')));
                        }
                        function $Dd(a, b) {
                            CGd(a, Kfb(vDd(b, 'x')), Kfb(vDd(b, 'y')));
                        }
                        function CDb(a, b) {
                            MCb(a);
                            return new SDb(a, new hEb(b, a.a));
                        }
                        function GDb(a, b) {
                            MCb(a);
                            return new SDb(a, new zEb(b, a.a));
                        }
                        function HDb(a, b) {
                            MCb(a);
                            return new WCb(a, new nEb(b, a.a));
                        }
                        function IDb(a, b) {
                            MCb(a);
                            return new oDb(a, new tEb(b, a.a));
                        }
                        function Ty(a, b) {
                            return new Ry(RD(Qb(a), 50), RD(Qb(b), 50));
                        }
                        function nHb(a, b) {
                            return Qfb(a.d.c + a.d.b / 2, b.d.c + b.d.b / 2);
                        }
                        function gTb(a, b, c) {
                            c.a ? Eyd(a, b.b - a.f / 2) : Dyd(a, b.a - a.g / 2);
                        }
                        function WYb(a, b) {
                            return Qfb(a.g.c + a.g.b / 2, b.g.c + b.g.b / 2);
                        }
                        function RZb(a, b) {
                            NZb();
                            return Qfb((uFb(a), a), (uFb(b), b));
                        }
                        function wSd(a) {
                            return a != null && tpb(eSd, a.toLowerCase());
                        }
                        function Ae(a) {
                            var b;
                            for(b = a.Kc(); b.Ob();){
                                b.Pb();
                                b.Qb();
                            }
                        }
                        function Ih(a) {
                            var b;
                            b = a.b;
                            !b && (a.b = b = new Xh(a));
                            return b;
                        }
                        function R0b(a) {
                            var b;
                            b = Z5b(a);
                            if (b) return b;
                            return null;
                        }
                        function BSb(a, b) {
                            var c, d;
                            c = a / b;
                            d = eE(c);
                            c > d && ++d;
                            return d;
                        }
                        function Ck(a, b, c) {
                            var d;
                            d = RD(a.d.Kb(c), 159);
                            !!d && d.Nb(b);
                        }
                        function Vhc(a, b, c) {
                            tqc(a.a, c);
                            Jpc(c);
                            Kqc(a.b, c);
                            bqc(b, c);
                        }
                        function oNc(a, b, c, d) {
                            this.a = a;
                            this.c = b;
                            this.b = c;
                            this.d = d;
                        }
                        function ROc(a, b, c, d) {
                            this.c = a;
                            this.b = b;
                            this.a = c;
                            this.d = d;
                        }
                        function uPc(a, b, c, d) {
                            this.c = a;
                            this.b = b;
                            this.d = c;
                            this.a = d;
                        }
                        function Uid(a, b, c, d) {
                            this.c = a;
                            this.d = b;
                            this.b = c;
                            this.a = d;
                        }
                        function GTc(a, b, c, d) {
                            this.a = a;
                            this.d = b;
                            this.c = c;
                            this.b = d;
                        }
                        function t1b(a, b, c, d) {
                            this.a = a;
                            this.e = b;
                            this.d = c;
                            this.c = d;
                        }
                        function $td(a, b, c, d) {
                            this.a = a;
                            this.c = b;
                            this.d = c;
                            this.b = d;
                        }
                        function ehb(a, b, c) {
                            this.a = ywe;
                            this.d = a;
                            this.b = b;
                            this.c = c;
                        }
                        function fpc(a, b, c, d) {
                            qs.call(this, a, b);
                            this.a = c;
                            this.b = d;
                        }
                        function Uwb(a, b) {
                            this.d = (uFb(a), a);
                            this.a = 16449;
                            this.c = b;
                        }
                        function CIc(a) {
                            this.a = new bnb;
                            this.e = $C(kE, Nve, 53, a, 0, 2);
                        }
                        function ELc(a) {
                            a.Ug('No crossing minimization', 1);
                            a.Vg();
                        }
                        function Evb() {
                            yz.call(this, 'There is no more element.');
                        }
                        function OEd(a, b, c, d) {
                            this.a = a;
                            this.b = b;
                            this.c = c;
                            this.d = d;
                        }
                        function PEd(a, b, c, d) {
                            this.a = a;
                            this.b = b;
                            this.c = c;
                            this.d = d;
                        }
                        function h7d(a, b, c, d) {
                            this.e = a;
                            this.a = b;
                            this.c = c;
                            this.d = d;
                        }
                        function x7d(a, b, c, d) {
                            this.a = a;
                            this.c = b;
                            this.d = c;
                            this.b = d;
                        }
                        function C8d(a, b, c, d) {
                            s7d();
                            M7d.call(this, b, c, d);
                            this.a = a;
                        }
                        function J8d(a, b, c, d) {
                            s7d();
                            M7d.call(this, b, c, d);
                            this.a = a;
                        }
                        function lwd(a, b, c) {
                            var d, e;
                            d = oSd(a);
                            e = b.ti(c, d);
                            return e;
                        }
                        function lBd(a) {
                            var b, c;
                            c = (b = new s2d, b);
                            l2d(c, a);
                            return c;
                        }
                        function mBd(a) {
                            var b, c;
                            c = (b = new s2d, b);
                            p2d(c, a);
                            return c;
                        }
                        function HDd(a, b) {
                            var c;
                            c = Wjb(a.f, b);
                            wEd(b, c);
                            return null;
                        }
                        function uCd(a) {
                            !a.b && (a.b = new C5d(G4, a, 12, 3));
                            return a.b;
                        }
                        function VD(a) {
                            CFb(a == null || cE(a) && !(a.Tm === keb));
                            return a;
                        }
                        function gz(a) {
                            if (a.n) {
                                a.e !== rwe && a.je();
                                a.j = null;
                            }
                            return a;
                        }
                        function Ng(a) {
                            ig(a.d);
                            if (a.d.d != a.c) throw Adb(new Jrb);
                        }
                        function Bkb(a) {
                            sFb(a.b < a.d.gc());
                            return a.d.Xb(a.c = a.b++);
                        }
                        function Xub(a) {
                            a.a.a = a.c;
                            a.c.b = a.a;
                            a.a.b = a.c.a = null;
                            a.b = 0;
                        }
                        function xPd(a) {
                            this.f = a;
                            this.c = this.f.e;
                            a.f > 0 && wPd(this);
                        }
                        function Vg(a, b) {
                            this.a = a;
                            Pg.call(this, a, RD(a.d, 15).fd(b));
                        }
                        function lrd(a, b) {
                            return Qfb(urd(a) * trd(a), urd(b) * trd(b));
                        }
                        function mrd(a, b) {
                            return Qfb(urd(a) * trd(a), urd(b) * trd(b));
                        }
                        function n5b(a) {
                            return ozd(a) && Heb(TD(Gxd(a, (yCc(), OAc))));
                        }
                        function Sfc(a, b) {
                            return Rc(a, RD(mQb(b, (yCc(), tBc)), 17), b);
                        }
                        function lic(a, b) {
                            RD(mQb(a, (Ywc(), qwc)), 15).Fc(b);
                            return b;
                        }
                        function C2b(a, b) {
                            a.b = b.b;
                            a.c = b.c;
                            a.d = b.d;
                            a.a = b.a;
                            return a;
                        }
                        function cEb(a, b, c, d) {
                            this.b = a;
                            this.c = d;
                            xxb.call(this, b, c);
                        }
                        function Ulc(a, b, c) {
                            a.i = 0;
                            a.e = 0;
                            if (b == c) return;
                            Qlc(a, b, c);
                        }
                        function Vlc(a, b, c) {
                            a.i = 0;
                            a.e = 0;
                            if (b == c) return;
                            Rlc(a, b, c);
                        }
                        function akc(a, b, c) {
                            Wjc();
                            return _Gb(RD(Wjb(a.e, b), 529), c);
                        }
                        function nd(a) {
                            var b;
                            return b = a.f, !b ? a.f = new ne(a, a.c) : b;
                        }
                        function nTc(a, b) {
                            return VTc(a.j, b.s, b.c) + VTc(b.e, a.s, a.c);
                        }
                        function Rrc(a, b) {
                            if (!!a.e && !a.e.a) {
                                Prc(a.e, b);
                                Rrc(a.e, b);
                            }
                        }
                        function Qrc(a, b) {
                            if (!!a.d && !a.d.a) {
                                Prc(a.d, b);
                                Qrc(a.d, b);
                            }
                        }
                        function krd(a, b) {
                            return -Qfb(urd(a) * trd(a), urd(b) * trd(b));
                        }
                        function gtd(a) {
                            return RD(a.ld(), 149).Pg() + ':' + jeb(a.md());
                        }
                        function EBd() {
                            BBd(this, new yAd);
                            this.wb = (lTd(), kTd);
                            jTd();
                        }
                        function G7b(a) {
                            this.b = new bnb;
                            Tmb(this.b, this.b);
                            this.a = a;
                        }
                        function WWc(a, b) {
                            new Yub;
                            this.a = new Ejd;
                            this.b = a;
                            this.c = b;
                        }
                        function urb() {
                            urb = geb;
                            rrb = new wrb;
                            srb = new wrb;
                            trb = new Brb;
                        }
                        function yob() {
                            yob = geb;
                            vob = new Job;
                            wob = new apb;
                            xob = new ipb;
                        }
                        function FGb() {
                            FGb = geb;
                            CGb = new AGb;
                            EGb = new fHb;
                            DGb = new YGb;
                        }
                        function HSb() {
                            HSb = geb;
                            GSb = new bnb;
                            FSb = new Tsb;
                            ESb = new bnb;
                        }
                        function Rb(a, b) {
                            if (a == null) throw Adb(new Ogb(b));
                            return a;
                        }
                        function tCd(a) {
                            !a.a && (a.a = new C5d(J4, a, 10, 11));
                            return a.a;
                        }
                        function uYd(a) {
                            !a.q && (a.q = new C5d(s7, a, 11, 10));
                            return a.q;
                        }
                        function xYd(a) {
                            !a.s && (a.s = new C5d(y7, a, 21, 17));
                            return a.s;
                        }
                        function er(a) {
                            Qb(a);
                            return Er(new is(Mr(a.a.Kc(), new ir)));
                        }
                        function hfd(a, b) {
                            rb(a);
                            rb(b);
                            return ns(RD(a, 22), RD(b, 22));
                        }
                        function qDd(a, b, c) {
                            var d, e;
                            d = Qeb(c);
                            e = new hC(d);
                            sC(a, b, e);
                        }
                        function d4d(a, b, c, d, e, f) {
                            c4d.call(this, a, b, c, d, e, f ? -2 : -1);
                        }
                        function sje(a, b, c, d) {
                            kZd.call(this, b, c);
                            this.b = a;
                            this.a = d;
                        }
                        function Ry(a, b) {
                            wi.call(this, new ezb(a));
                            this.a = a;
                            this.b = b;
                        }
                        function Gu(a) {
                            this.b = a;
                            this.c = a;
                            a.e = null;
                            a.c = null;
                            this.a = 1;
                        }
                        function Dkc(a) {
                            lkc();
                            var b;
                            b = RD(a.g, 10);
                            b.n.a = a.d.c + b.d.b;
                        }
                        function fA() {
                            fA = geb;
                            var a, b;
                            b = !lA();
                            a = new tA;
                            eA = b ? new mA : a;
                        }
                        function Hob(a) {
                            yob();
                            return ZD(a, 59) ? new irb(a) : new Upb(a);
                        }
                        function Ux(a) {
                            return ZD(a, 16) ? new btb(RD(a, 16)) : Vx(a.Kc());
                        }
                        function Vi(a) {
                            return new ij(a, a.e.Rd().gc() * a.c.Rd().gc());
                        }
                        function fj(a) {
                            return new sj(a, a.e.Rd().gc() * a.c.Rd().gc());
                        }
                        function Iz(a) {
                            return !!a && !!a.hashCode ? a.hashCode() : kFb(a);
                        }
                        function Yjb(a, b) {
                            return b == null ? !!qtb(a.f, null) : Jtb(a.i, b);
                        }
                        function hYb(a, b) {
                            var c;
                            c = $sb(a.a, b);
                            c && (b.d = null);
                            return c;
                        }
                        function MGb(a, b, c) {
                            if (a.f) return a.f.ef(b, c);
                            return false;
                        }
                        function cFc(a, b, c, d) {
                            bD(a.c[b.g], c.g, d);
                            bD(a.c[c.g], b.g, d);
                        }
                        function fFc(a, b, c, d) {
                            bD(a.c[b.g], b.g, c);
                            bD(a.b[b.g], b.g, d);
                        }
                        function sXc(a, b, c) {
                            return Kfb(UD(c.a)) <= a && Kfb(UD(c.b)) >= b;
                        }
                        function yJc(a, b) {
                            this.g = a;
                            this.d = cD(WC(jR, 1), WAe, 10, 0, [
                                b
                            ]);
                        }
                        function lHb(a) {
                            this.c = a;
                            this.b = new yAb(RD(Qb(new oHb), 50));
                        }
                        function UYb(a) {
                            this.c = a;
                            this.b = new yAb(RD(Qb(new XYb), 50));
                        }
                        function $Qb(a) {
                            this.b = a;
                            this.a = new yAb(RD(Qb(new bRb), 50));
                        }
                        function tRc() {
                            this.b = new _sb;
                            this.d = new Yub;
                            this.e = new Fyb;
                        }
                        function VTb() {
                            this.c = new pjd;
                            this.d = new pjd;
                            this.e = new pjd;
                        }
                        function a1b() {
                            this.a = new Ejd;
                            this.b = (dk(3, iwe), new cnb(3));
                        }
                        function i7d(a, b) {
                            this.e = a;
                            this.a = jJ;
                            this.b = pje(b);
                            this.c = b;
                        }
                        function Vid(a) {
                            this.c = a.c;
                            this.d = a.d;
                            this.b = a.b;
                            this.a = a.a;
                        }
                        function VLd(a, b, c, d, e, f) {
                            this.a = a;
                            NKd.call(this, b, c, d, e, f);
                        }
                        function aLd(a, b, c, d, e, f) {
                            this.a = a;
                            NKd.call(this, b, c, d, e, f);
                        }
                        function fge(a, b, c, d, e, f, g) {
                            return new lle(a.e, b, c, d, e, f, g);
                        }
                        function xhb(a, b, c) {
                            return c >= 0 && lhb(a.substr(c, b.length), b);
                        }
                        function hGd(a, b) {
                            return ZD(b, 149) && lhb(a.b, RD(b, 149).Pg());
                        }
                        function Tde(a, b) {
                            return a.a ? b.Gh().Kc() : RD(b.Gh(), 71).Ii();
                        }
                        function Qqb(a, b) {
                            var c;
                            c = a.b.Qc(b);
                            Rqb(c, a.b.gc());
                            return c;
                        }
                        function Ivb(a, b) {
                            if (a == null) throw Adb(new Ogb(b));
                            return a;
                        }
                        function zYd(a) {
                            if (!a.u) {
                                yYd(a);
                                a.u = new w0d(a, a);
                            }
                            return a.u;
                        }
                        function Kx(a) {
                            this.a = (yob(), ZD(a, 59) ? new irb(a) : new Upb(a));
                        }
                        function Uwd(a) {
                            var b;
                            b = RD(Ywd(a, 16), 29);
                            return !b ? a.ii() : b;
                        }
                        function lz(a, b) {
                            var c;
                            c = nfb(a.Rm);
                            return b == null ? c : c + ': ' + b;
                        }
                        function zhb(a, b, c) {
                            AFb(b, c, a.length);
                            return a.substr(b, c - b);
                        }
                        function VKb(a, b) {
                            RJb.call(this);
                            KKb(this);
                            this.a = a;
                            this.c = b;
                        }
                        function neb(a) {
                            !a ? vve : lz(a, a.ie());
                            String.fromCharCode(10);
                        }
                        function Wz(a) {
                            Qz();
                            $wnd.setTimeout(function() {
                                throw a;
                            }, 0);
                        }
                        function GHb() {
                            DHb();
                            return cD(WC(uN, 1), jwe, 436, 0, [
                                CHb,
                                BHb
                            ]);
                        }
                        function OHb() {
                            LHb();
                            return cD(WC(vN, 1), jwe, 435, 0, [
                                JHb,
                                KHb
                            ]);
                        }
                        function WUb() {
                            TUb();
                            return cD(WC(BP, 1), jwe, 432, 0, [
                                RUb,
                                SUb
                            ]);
                        }
                        function S8b() {
                            P8b();
                            return cD(WC(vS, 1), jwe, 517, 0, [
                                O8b,
                                N8b
                            ]);
                        }
                        function Rvc() {
                            Ovc();
                            return cD(WC(lX, 1), jwe, 429, 0, [
                                Mvc,
                                Nvc
                            ]);
                        }
                        function buc() {
                            $tc();
                            return cD(WC(cX, 1), jwe, 428, 0, [
                                Ytc,
                                Ztc
                            ]);
                        }
                        function mtc() {
                            jtc();
                            return cD(WC($W, 1), jwe, 431, 0, [
                                htc,
                                itc
                            ]);
                        }
                        function vEc() {
                            sEc();
                            return cD(WC(xX, 1), jwe, 430, 0, [
                                qEc,
                                rEc
                            ]);
                        }
                        function vNc() {
                            sNc();
                            return cD(WC(MY, 1), jwe, 531, 0, [
                                rNc,
                                qNc
                            ]);
                        }
                        function D2c() {
                            x2c();
                            return cD(WC(s0, 1), jwe, 501, 0, [
                                v2c,
                                w2c
                            ]);
                        }
                        function zQc() {
                            wQc();
                            return cD(WC(FZ, 1), jwe, 523, 0, [
                                vQc,
                                uQc
                            ]);
                        }
                        function HQc() {
                            EQc();
                            return cD(WC(GZ, 1), jwe, 522, 0, [
                                CQc,
                                DQc
                            ]);
                        }
                        function iTc() {
                            fTc();
                            return cD(WC(b$, 1), jwe, 528, 0, [
                                eTc,
                                dTc
                            ]);
                        }
                        function Fuc() {
                            Cuc();
                            return cD(WC(fX, 1), jwe, 488, 0, [
                                Buc,
                                Auc
                            ]);
                        }
                        function F8c() {
                            z8c();
                            return cD(WC(l1, 1), jwe, 491, 0, [
                                x8c,
                                y8c
                            ]);
                        }
                        function H9c() {
                            B9c();
                            return cD(WC(t1, 1), jwe, 492, 0, [
                                z9c,
                                A9c
                            ]);
                        }
                        function D_c() {
                            A_c();
                            return cD(WC(K_, 1), jwe, 433, 0, [
                                z_c,
                                y_c
                            ]);
                        }
                        function a4c() {
                            Y3c();
                            return cD(WC(H0, 1), jwe, 434, 0, [
                                W3c,
                                X3c
                            ]);
                        }
                        function gVc() {
                            dVc();
                            return cD(WC(w$, 1), jwe, 465, 0, [
                                bVc,
                                cVc
                            ]);
                        }
                        function Pbd() {
                            Mbd();
                            return cD(WC(O1, 1), jwe, 438, 0, [
                                Lbd,
                                Kbd
                            ]);
                        }
                        function rdd() {
                            ldd();
                            return cD(WC(W1, 1), jwe, 437, 0, [
                                kdd,
                                jdd
                            ]);
                        }
                        function xqd() {
                            uqd();
                            return cD(WC(M3, 1), jwe, 347, 0, [
                                sqd,
                                tqd
                            ]);
                        }
                        function Jvd(a, b, c, d) {
                            return c >= 0 ? a.Uh(b, c, d) : a.Ch(null, c, d);
                        }
                        function ltd(a) {
                            if (a.b.b == 0) return a.a.sf();
                            return Uub(a.b);
                        }
                        function vKd(a) {
                            if (a.p != 5) throw Adb(new cgb);
                            return Ydb(a.f);
                        }
                        function EKd(a) {
                            if (a.p != 5) throw Adb(new cgb);
                            return Ydb(a.k);
                        }
                        function P$d(a) {
                            dE(a.a) === dE((lYd(), kYd)) && Q$d(a);
                            return a.a;
                        }
                        function iad(a, b) {
                            a.b = b;
                            a.c > 0 && a.b > 0 && (a.g = Aad(a.c, a.b, a.a));
                        }
                        function jad(a, b) {
                            a.c = b;
                            a.c > 0 && a.b > 0 && (a.g = Aad(a.c, a.b, a.a));
                        }
                        function BUc(a, b) {
                            yUc(this, new rjd(a.a, a.b));
                            zUc(this, gv(b));
                        }
                        function Tp() {
                            Sp.call(this, new Usb(Sv(12)));
                            Lb(true);
                            this.a = 2;
                        }
                        function eue(a, b, c) {
                            Vse();
                            Wse.call(this, a);
                            this.b = b;
                            this.a = c;
                        }
                        function C7d(a, b, c) {
                            s7d();
                            t7d.call(this, b);
                            this.a = a;
                            this.b = c;
                        }
                        function qub(a) {
                            var b;
                            b = a.c.d.b;
                            a.b = b;
                            a.a = a.c.d;
                            b.a = a.c.d.b = a;
                        }
                        function Tub(a) {
                            return a.b == 0 ? null : (sFb(a.b != 0), Wub(a, a.a.a));
                        }
                        function Xjb(a, b) {
                            return b == null ? Wd(qtb(a.f, null)) : Ktb(a.i, b);
                        }
                        function bzb(a, b, c, d, e) {
                            return new Kzb(a, (cAb(), aAb), b, c, d, e);
                        }
                        function Fnb(a, b) {
                            oFb(b);
                            return Hnb(a, $C(kE, Pwe, 28, b, 15, 1), b);
                        }
                        function Tx(a, b) {
                            Rb(a, 'set1');
                            Rb(b, 'set2');
                            return new ey(a, b);
                        }
                        function Kz(a, b) {
                            var c = Jz[a.charCodeAt(0)];
                            return c == null ? a : c;
                        }
                        function Xyb(a, b) {
                            var c, d;
                            c = b;
                            d = new Gzb;
                            Zyb(a, c, d);
                            return d.d;
                        }
                        function EMb(a, b, c, d) {
                            var e;
                            e = new TJb;
                            b.a[c.g] = e;
                            Wrb(a.b, d, e);
                        }
                        function SXb(a, b) {
                            var c;
                            c = BXb(a.f, b);
                            return $id(fjd(c), a.f.d);
                        }
                        function RFb(a) {
                            var b;
                            EJb(a.a);
                            DJb(a.a);
                            b = new PJb(a.a);
                            LJb(b);
                        }
                        function _Mb(a, b) {
                            $Mb(a, true);
                            Umb(a.e.Rf(), new dNb(a, true, b));
                        }
                        function PSb(a, b) {
                            HSb();
                            return a == vCd(JGd(b)) || a == vCd(LGd(b));
                        }
                        function R0c(a, b) {
                            B0c();
                            return RD(mQb(b, (h_c(), f_c)), 17).a == a;
                        }
                        function eE(a) {
                            return Math.max(Math.min(a, lve), -2147483648) | 0;
                        }
                        function sy(a) {
                            this.a = RD(Qb(a), 277);
                            this.b = (yob(), new jrb(a));
                        }
                        function qbd(a, b, c) {
                            this.i = new bnb;
                            this.b = a;
                            this.g = b;
                            this.a = c;
                        }
                        function had(a, b, c) {
                            this.a = new bnb;
                            this.e = a;
                            this.f = b;
                            this.c = c;
                        }
                        function _9c(a, b, c) {
                            this.c = new bnb;
                            this.e = a;
                            this.f = b;
                            this.b = c;
                        }
                        function TKb(a) {
                            RJb.call(this);
                            KKb(this);
                            this.a = a;
                            this.c = true;
                        }
                        function ieb(a) {
                            function b() {}
                            b.prototype = a || {};
                            return new b;
                        }
                        function zfb(a) {
                            if (a.Ae()) return null;
                            var b = a.n;
                            return eeb[b];
                        }
                        function kzd(a) {
                            if (a.Db >> 16 != 3) return null;
                            return RD(a.Cb, 27);
                        }
                        function MCd(a) {
                            if (a.Db >> 16 != 9) return null;
                            return RD(a.Cb, 27);
                        }
                        function Fzd(a) {
                            if (a.Db >> 16 != 6) return null;
                            return RD(a.Cb, 74);
                        }
                        function dVc() {
                            dVc = geb;
                            bVc = new eVc(Nye, 0);
                            cVc = new eVc(Oye, 1);
                        }
                        function wQc() {
                            wQc = geb;
                            vQc = new xQc(Oye, 0);
                            uQc = new xQc(Nye, 1);
                        }
                        function EQc() {
                            EQc = geb;
                            CQc = new FQc(Zye, 0);
                            DQc = new FQc('UP', 1);
                        }
                        function Is() {
                            Is = geb;
                            Hs = ss((zs(), cD(WC(RG, 1), jwe, 549, 0, [
                                ys
                            ])));
                        }
                        function Wx(a) {
                            var b;
                            b = new atb(Sv(a.length));
                            zob(b, a);
                            return b;
                        }
                        function B2b(a, b) {
                            a.b += b.b;
                            a.c += b.c;
                            a.d += b.d;
                            a.a += b.a;
                            return a;
                        }
                        function qmb(a, b) {
                            if (kmb(a, b)) {
                                Jmb(a);
                                return true;
                            }
                            return false;
                        }
                        function qC(a, b) {
                            if (b == null) throw Adb(new Ngb);
                            return rC(a, b);
                        }
                        function nB(a, b) {
                            var c;
                            c = a.q.getHours();
                            a.q.setDate(b);
                            mB(a, c);
                        }
                        function Xvd(a, b, c) {
                            var d;
                            d = a.Ih(b);
                            d >= 0 ? a.bi(d, c) : Svd(a, b, c);
                        }
                        function Lvd(a, b) {
                            var c;
                            c = a.Ih(b);
                            return c >= 0 ? a.Wh(c) : Rvd(a, b);
                        }
                        function zo(a, b) {
                            var c;
                            Qb(b);
                            for(c = a.a; c; c = c.c)b.Yd(c.g, c.i);
                        }
                        function pMc(a, b, c) {
                            var d;
                            d = qMc(a, b, c);
                            a.b = new _Lc(d.c.length);
                        }
                        function HId(a, b, c) {
                            EId();
                            !!a && Zjb(DId, a, b);
                            !!a && Zjb(CId, a, c);
                        }
                        function bfc(a, b) {
                            Rec();
                            return Geb(), RD(b.a, 17).a < a ? true : false;
                        }
                        function afc(a, b) {
                            Rec();
                            return Geb(), RD(b.b, 17).a < a ? true : false;
                        }
                        function R7b(a, b) {
                            return $wnd.Math.abs(a) < $wnd.Math.abs(b) ? a : b;
                        }
                        function xCd(a) {
                            return !a.a && (a.a = new C5d(J4, a, 10, 11)), a.a.i > 0;
                        }
                        function sId(a) {
                            var b;
                            b = a.d;
                            b = a.bj(a.f);
                            WGd(a, b);
                            return b.Ob();
                        }
                        function bHd(a, b) {
                            var c;
                            c = new Kub(b);
                            Ve(c, a);
                            return new dnb(c);
                        }
                        function qKd(a) {
                            if (a.p != 0) throw Adb(new cgb);
                            return Pdb(a.f, 0);
                        }
                        function zKd(a) {
                            if (a.p != 0) throw Adb(new cgb);
                            return Pdb(a.k, 0);
                        }
                        function gBd(a) {
                            if (a.Db >> 16 != 7) return null;
                            return RD(a.Cb, 241);
                        }
                        function xXd(a) {
                            if (a.Db >> 16 != 6) return null;
                            return RD(a.Cb, 241);
                        }
                        function dCd(a) {
                            if (a.Db >> 16 != 7) return null;
                            return RD(a.Cb, 167);
                        }
                        function vCd(a) {
                            if (a.Db >> 16 != 11) return null;
                            return RD(a.Cb, 27);
                        }
                        function uWd(a) {
                            if (a.Db >> 16 != 17) return null;
                            return RD(a.Cb, 29);
                        }
                        function kVd(a) {
                            if (a.Db >> 16 != 3) return null;
                            return RD(a.Cb, 155);
                        }
                        function BDb(a) {
                            var b;
                            MCb(a);
                            b = new _sb;
                            return CDb(a, new aEb(b));
                        }
                        function xfb(a, b) {
                            var c = a.a = a.a || [];
                            return c[b] || (c[b] = a.ve(b));
                        }
                        function qB(a, b) {
                            var c;
                            c = a.q.getHours();
                            a.q.setMonth(b);
                            mB(a, c);
                        }
                        function oz(a, b) {
                            ez(this);
                            this.f = b;
                            this.g = a;
                            gz(this);
                            this.je();
                        }
                        function TQb(a, b) {
                            this.a = a;
                            this.c = ajd(this.a);
                            this.b = new Vid(b);
                        }
                        function aGb(a, b, c) {
                            this.a = b;
                            this.c = a;
                            this.b = (Qb(c), new dnb(c));
                        }
                        function s$b(a, b, c) {
                            this.a = b;
                            this.c = a;
                            this.b = (Qb(c), new dnb(c));
                        }
                        function _Kc(a) {
                            this.a = a;
                            this.b = $C(qY, Nve, 2043, a.e.length, 0, 2);
                        }
                        function fGb() {
                            this.a = new Iub;
                            this.e = new _sb;
                            this.g = 0;
                            this.i = 0;
                        }
                        function EId() {
                            EId = geb;
                            DId = new Tsb;
                            CId = new Tsb;
                            IId(zK, new JId);
                        }
                        function KFc() {
                            KFc = geb;
                            JFc = nfd(new ufd, (sXb(), rXb), (hcc(), $bc));
                        }
                        function RFc() {
                            RFc = geb;
                            QFc = nfd(new ufd, (sXb(), rXb), (hcc(), $bc));
                        }
                        function gGc() {
                            gGc = geb;
                            fGc = nfd(new ufd, (sXb(), rXb), (hcc(), $bc));
                        }
                        function ANc() {
                            ANc = geb;
                            zNc = pfd(new ufd, (sXb(), rXb), (hcc(), ybc));
                        }
                        function dOc() {
                            dOc = geb;
                            cOc = pfd(new ufd, (sXb(), rXb), (hcc(), ybc));
                        }
                        function gQc() {
                            gQc = geb;
                            fQc = pfd(new ufd, (sXb(), rXb), (hcc(), ybc));
                        }
                        function WQc() {
                            WQc = geb;
                            VQc = pfd(new ufd, (sXb(), rXb), (hcc(), ybc));
                        }
                        function dZd(a, b, c, d, e, f) {
                            return new P3d(a.e, b, a.Lj(), c, d, e, f);
                        }
                        function $jb(a, b, c) {
                            return b == null ? rtb(a.f, null, c) : Ltb(a.i, b, c);
                        }
                        function Y0b(a, b) {
                            !!a.c && Ymb(a.c.g, a);
                            a.c = b;
                            !!a.c && Rmb(a.c.g, a);
                        }
                        function g3b(a, b) {
                            !!a.c && Ymb(a.c.a, a);
                            a.c = b;
                            !!a.c && Rmb(a.c.a, a);
                        }
                        function P3b(a, b) {
                            !!a.i && Ymb(a.i.j, a);
                            a.i = b;
                            !!a.i && Rmb(a.i.j, a);
                        }
                        function Z0b(a, b) {
                            !!a.d && Ymb(a.d.e, a);
                            a.d = b;
                            !!a.d && Rmb(a.d.e, a);
                        }
                        function _Sc(a, b) {
                            !!a.a && Ymb(a.a.k, a);
                            a.a = b;
                            !!a.a && Rmb(a.a.k, a);
                        }
                        function aTc(a, b) {
                            !!a.b && Ymb(a.b.f, a);
                            a.b = b;
                            !!a.b && Rmb(a.b.f, a);
                        }
                        function Odd(a, b) {
                            Pdd(a, a.b, a.c);
                            RD(a.b.b, 68);
                            !!b && RD(b.b, 68).b;
                        }
                        function j2c(a, b) {
                            return Qfb(RD(a.c, 65).c.e.b, RD(b.c, 65).c.e.b);
                        }
                        function k2c(a, b) {
                            return Qfb(RD(a.c, 65).c.e.a, RD(b.c, 65).c.e.a);
                        }
                        function YXb(a) {
                            NXb();
                            return Geb(), RD(a.a, 86).d.e != 0 ? true : false;
                        }
                        function LXd(a, b) {
                            ZD(a.Cb, 184) && (RD(a.Cb, 184).tb = null);
                            PAd(a, b);
                        }
                        function CWd(a, b) {
                            ZD(a.Cb, 90) && v$d(yYd(RD(a.Cb, 90)), 4);
                            PAd(a, b);
                        }
                        function _5d(a, b) {
                            a6d(a, b);
                            ZD(a.Cb, 90) && v$d(yYd(RD(a.Cb, 90)), 2);
                        }
                        function JFd(a, b) {
                            var c, d;
                            c = b.c;
                            d = c != null;
                            d && oDd(a, new OC(b.c));
                        }
                        function v0d(a) {
                            var b, c;
                            c = (jTd(), b = new s2d, b);
                            l2d(c, a);
                            return c;
                        }
                        function E4d(a) {
                            var b, c;
                            c = (jTd(), b = new s2d, b);
                            l2d(c, a);
                            return c;
                        }
                        function Fr(a) {
                            var b;
                            while(true){
                                b = a.Pb();
                                if (!a.Ob()) return b;
                            }
                        }
                        function nq(a, b, c) {
                            Rmb(a.a, (fn(), ck(b, c), new gp(b, c)));
                            return a;
                        }
                        function rge(a, b) {
                            return nke(), wWd(b) ? new ole(b, a) : new Eke(b, a);
                        }
                        function ojb(a) {
                            Pib();
                            return Ddb(a, 0) >= 0 ? jjb(a) : Xib(jjb(Odb(a)));
                        }
                        function Asb(a) {
                            var b;
                            b = RD(UEb(a.b), 9);
                            return new Fsb(a.a, b, a.c);
                        }
                        function Qw(a, b) {
                            var c;
                            c = RD(Xv(nd(a.a), b), 16);
                            return !c ? 0 : c.gc();
                        }
                        function Zmb(a, b, c) {
                            var d;
                            xFb(b, c, a.c.length);
                            d = c - b;
                            $Eb(a.c, b, d);
                        }
                        function Rkb(a, b, c) {
                            xFb(b, c, a.gc());
                            this.c = a;
                            this.a = b;
                            this.b = c - b;
                        }
                        function fgd(a) {
                            this.c = new Yub;
                            this.b = a.b;
                            this.d = a.c;
                            this.a = a.a;
                        }
                        function qjd(a) {
                            this.a = $wnd.Math.cos(a);
                            this.b = $wnd.Math.sin(a);
                        }
                        function bTc(a, b, c, d) {
                            this.c = a;
                            this.d = d;
                            _Sc(this, b);
                            aTc(this, c);
                        }
                        function Si(a, b) {
                            Qi.call(this, new Usb(Sv(a)));
                            dk(b, Mve);
                            this.a = b;
                        }
                        function Ryb(a, b, c) {
                            return new Kzb(a, (cAb(), _zb), null, false, b, c);
                        }
                        function czb(a, b, c) {
                            return new Kzb(a, (cAb(), bAb), b, c, null, false);
                        }
                        function ABb() {
                            xBb();
                            return cD(WC(QL, 1), jwe, 108, 0, [
                                uBb,
                                vBb,
                                wBb
                            ]);
                        }
                        function yLb() {
                            vLb();
                            return cD(WC(TN, 1), jwe, 472, 0, [
                                uLb,
                                tLb,
                                sLb
                            ]);
                        }
                        function HKb() {
                            EKb();
                            return cD(WC(MN, 1), jwe, 471, 0, [
                                CKb,
                                BKb,
                                DKb
                            ]);
                        }
                        function aKb() {
                            ZJb();
                            return cD(WC(JN, 1), jwe, 237, 0, [
                                WJb,
                                XJb,
                                YJb
                            ]);
                        }
                        function DWb() {
                            AWb();
                            return cD(WC(JP, 1), jwe, 391, 0, [
                                yWb,
                                xWb,
                                zWb
                            ]);
                        }
                        function moc() {
                            joc();
                            return cD(WC(UV, 1), jwe, 372, 0, [
                                ioc,
                                hoc,
                                goc
                            ]);
                        }
                        function ytc() {
                            stc();
                            return cD(WC(_W, 1), jwe, 322, 0, [
                                qtc,
                                ptc,
                                rtc
                            ]);
                        }
                        function Htc() {
                            Etc();
                            return cD(WC(aX, 1), jwe, 351, 0, [
                                Btc,
                                Dtc,
                                Ctc
                            ]);
                        }
                        function kuc() {
                            huc();
                            return cD(WC(dX, 1), jwe, 460, 0, [
                                fuc,
                                euc,
                                guc
                            ]);
                        }
                        function Avc() {
                            xvc();
                            return cD(WC(jX, 1), jwe, 299, 0, [
                                vvc,
                                wvc,
                                uvc
                            ]);
                        }
                        function Jvc() {
                            Gvc();
                            return cD(WC(kX, 1), jwe, 311, 0, [
                                Evc,
                                Fvc,
                                Dvc
                            ]);
                        }
                        function pDc() {
                            lDc();
                            return cD(WC(sX, 1), jwe, 390, 0, [
                                iDc,
                                jDc,
                                kDc
                            ]);
                        }
                        function EEc() {
                            BEc();
                            return cD(WC(yX, 1), jwe, 463, 0, [
                                AEc,
                                yEc,
                                zEc
                            ]);
                        }
                        function NEc() {
                            KEc();
                            return cD(WC(zX, 1), jwe, 387, 0, [
                                HEc,
                                IEc,
                                JEc
                            ]);
                        }
                        function WEc() {
                            TEc();
                            return cD(WC(AX, 1), jwe, 349, 0, [
                                SEc,
                                QEc,
                                REc
                            ]);
                        }
                        function oFc() {
                            lFc();
                            return cD(WC(CX, 1), jwe, 350, 0, [
                                iFc,
                                jFc,
                                kFc
                            ]);
                        }
                        function xFc() {
                            uFc();
                            return cD(WC(DX, 1), jwe, 352, 0, [
                                tFc,
                                rFc,
                                sFc
                            ]);
                        }
                        function GFc() {
                            DFc();
                            return cD(WC(EX, 1), jwe, 388, 0, [
                                BFc,
                                CFc,
                                AFc
                            ]);
                        }
                        function UKc() {
                            RKc();
                            return cD(WC(nY, 1), jwe, 464, 0, [
                                OKc,
                                PKc,
                                QKc
                            ]);
                        }
                        function K3b(a) {
                            return xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                a.i.n,
                                a.n,
                                a.a
                            ]));
                        }
                        function OZc() {
                            LZc();
                            return cD(WC(F_, 1), jwe, 392, 0, [
                                KZc,
                                JZc,
                                IZc
                            ]);
                        }
                        function H_c() {
                            H_c = geb;
                            G_c = nfd(new ufd, (YVc(), WVc), (WYc(), MYc));
                        }
                        function A_c() {
                            A_c = geb;
                            z_c = new B_c('DFS', 0);
                            y_c = new B_c('BFS', 1);
                        }
                        function TQc(a, b, c) {
                            var d;
                            d = new SQc;
                            d.b = b;
                            d.a = c;
                            ++b.b;
                            Rmb(a.d, d);
                        }
                        function NTb(a, b, c) {
                            var d;
                            d = new sjd(c.d);
                            $id(d, a);
                            CGd(b, d.a, d.b);
                        }
                        function Nwb(a, b) {
                            Mwb(a, Ydb(Cdb(Tdb(b, 24), Pxe)), Ydb(Cdb(b, Pxe)));
                        }
                        function wFb(a, b) {
                            if (a < 0 || a > b) throw Adb(new veb(cye + a + dye + b));
                        }
                        function tFb(a, b) {
                            if (a < 0 || a >= b) throw Adb(new veb(cye + a + dye + b));
                        }
                        function BFb(a, b) {
                            if (a < 0 || a >= b) throw Adb(new eib(cye + a + dye + b));
                        }
                        function Swb(a, b) {
                            this.b = (uFb(a), a);
                            this.a = (b & qxe) == 0 ? b | 64 | Ove : b;
                        }
                        function ODb(a) {
                            var b;
                            MCb(a);
                            b = (urb(), urb(), srb);
                            return PDb(a, b);
                        }
                        function R9c(a, b, c) {
                            var d;
                            d = S9c(a, b, false);
                            return d.b <= b && d.a <= c;
                        }
                        function h9c() {
                            b9c();
                            return cD(WC(o1, 1), jwe, 439, 0, [
                                $8c,
                                a9c,
                                _8c
                            ]);
                        }
                        function c7c() {
                            _6c();
                            return cD(WC(a1, 1), jwe, 394, 0, [
                                Z6c,
                                $6c,
                                Y6c
                            ]);
                        }
                        function i6c() {
                            f6c();
                            return cD(WC(V0, 1), jwe, 445, 0, [
                                c6c,
                                d6c,
                                e6c
                            ]);
                        }
                        function D6c() {
                            z6c();
                            return cD(WC(Z0, 1), jwe, 456, 0, [
                                w6c,
                                y6c,
                                x6c
                            ]);
                        }
                        function k4c() {
                            g4c();
                            return cD(WC(I0, 1), jwe, 393, 0, [
                                d4c,
                                e4c,
                                f4c
                            ]);
                        }
                        function x5c() {
                            t5c();
                            return cD(WC(N0, 1), jwe, 300, 0, [
                                r5c,
                                s5c,
                                q5c
                            ]);
                        }
                        function Ind() {
                            Fnd();
                            return cD(WC(y3, 1), jwe, 346, 0, [
                                Dnd,
                                Cnd,
                                End
                            ]);
                        }
                        function jbd() {
                            gbd();
                            return cD(WC(I1, 1), jwe, 444, 0, [
                                dbd,
                                ebd,
                                fbd
                            ]);
                        }
                        function Rmd() {
                            Omd();
                            return cD(WC(t3, 1), jwe, 278, 0, [
                                Lmd,
                                Mmd,
                                Nmd
                            ]);
                        }
                        function pqd() {
                            mqd();
                            return cD(WC(J3, 1), jwe, 280, 0, [
                                kqd,
                                jqd,
                                lqd
                            ]);
                        }
                        function bv(a) {
                            Qb(a);
                            return ZD(a, 16) ? new dnb(RD(a, 16)) : cv(a.Kc());
                        }
                        function Hz(a, b) {
                            return !!a && !!a.equals ? a.equals(b) : dE(a) === dE(b);
                        }
                        function Cdb(a, b) {
                            return Edb(tD(Kdb(a) ? Wdb(a) : a, Kdb(b) ? Wdb(b) : b));
                        }
                        function Rdb(a, b) {
                            return Edb(zD(Kdb(a) ? Wdb(a) : a, Kdb(b) ? Wdb(b) : b));
                        }
                        function $db(a, b) {
                            return Edb(HD(Kdb(a) ? Wdb(a) : a, Kdb(b) ? Wdb(b) : b));
                        }
                        function xs(a, b) {
                            var c;
                            c = (uFb(a), a).g;
                            lFb(!!c);
                            uFb(b);
                            return c(b);
                        }
                        function rv(a, b) {
                            var c, d;
                            d = tv(a, b);
                            c = a.a.fd(d);
                            return new Gv(a, c);
                        }
                        function CXd(a) {
                            if (a.Db >> 16 != 6) return null;
                            return RD(yvd(a), 241);
                        }
                        function sKd(a) {
                            if (a.p != 2) throw Adb(new cgb);
                            return Ydb(a.f) & Bwe;
                        }
                        function BKd(a) {
                            if (a.p != 2) throw Adb(new cgb);
                            return Ydb(a.k) & Bwe;
                        }
                        function ynb(a) {
                            sFb(a.a < a.c.c.length);
                            a.b = a.a++;
                            return a.c.c[a.b];
                        }
                        function $Gb(a, b) {
                            a.b = a.b | b.b;
                            a.c = a.c | b.c;
                            a.d = a.d | b.d;
                            a.a = a.a | b.a;
                        }
                        function NJb(a, b) {
                            var c;
                            c = Kfb(UD(a.a.of((umd(), cmd))));
                            OJb(a, b, c);
                        }
                        function bjb(a, b) {
                            cjb.call(this, 1, 2, cD(WC(kE, 1), Pwe, 28, 15, [
                                a,
                                b
                            ]));
                        }
                        function Yte(a, b, c) {
                            Wse.call(this, 25);
                            this.b = a;
                            this.a = b;
                            this.c = c;
                        }
                        function xte(a) {
                            Vse();
                            Wse.call(this, a);
                            this.c = false;
                            this.a = false;
                        }
                        function xfe(a) {
                            a.a == (ree(), qee) && Dfe(a, see(a.g, a.b));
                            return a.a;
                        }
                        function zfe(a) {
                            a.d == (ree(), qee) && Ffe(a, wee(a.g, a.b));
                            return a.d;
                        }
                        function IZb(a, b) {
                            CZb();
                            return a.c == b.c ? Qfb(b.d, a.d) : Qfb(b.c, a.c);
                        }
                        function GZb(a, b) {
                            CZb();
                            return a.c == b.c ? Qfb(b.d, a.d) : Qfb(a.c, b.c);
                        }
                        function HZb(a, b) {
                            CZb();
                            return a.c == b.c ? Qfb(a.d, b.d) : Qfb(a.c, b.c);
                        }
                        function JZb(a, b) {
                            CZb();
                            return a.c == b.c ? Qfb(a.d, b.d) : Qfb(b.c, a.c);
                        }
                        function Yrb(a, b) {
                            return Dsb(a.a, b) ? _Eb(a.b, RD(b, 22).g, null) : null;
                        }
                        function Lwb(a) {
                            return Bdb(Sdb(Hdb(Kwb(a, 32)), 32), Hdb(Kwb(a, 32)));
                        }
                        function kUb(a) {
                            return a.b == null || a.b.length == 0 ? 'n_' + a.a : 'n_' + a.b;
                        }
                        function aXc(a) {
                            return a.c == null || a.c.length == 0 ? 'n_' + a.g : 'n_' + a.c;
                        }
                        function wYc(a, b) {
                            var c;
                            c = a + '';
                            while(c.length < b)c = '0' + c;
                            return c;
                        }
                        function vkc(a, b) {
                            var c;
                            c = RD(Wjb(a.g, b), 60);
                            Umb(b.d, new ulc(a, c));
                        }
                        function J_b(a, b) {
                            var c, d;
                            c = l2b(a);
                            d = l2b(b);
                            return c < d ? -1 : c > d ? 1 : 0;
                        }
                        function Hmc(a, b) {
                            var c, d;
                            c = Gmc(b);
                            d = c;
                            return RD(Wjb(a.c, d), 17).a;
                        }
                        function CMc(a, b, c) {
                            var d;
                            d = a.d[b.p];
                            a.d[b.p] = a.d[c.p];
                            a.d[c.p] = d;
                        }
                        function Jqd(a, b, c) {
                            var d;
                            if (a.n && !!b && !!c) {
                                d = new otd;
                                Rmb(a.e, d);
                            }
                        }
                        function gYb(a, b) {
                            Ysb(a.a, b);
                            if (b.d) throw Adb(new yz(jye));
                            b.d = a;
                        }
                        function Had(a, b) {
                            this.a = new bnb;
                            this.d = new bnb;
                            this.f = a;
                            this.c = b;
                        }
                        function RWb() {
                            this.c = new dXb;
                            this.a = new I_b;
                            this.b = new E0b;
                            g0b();
                        }
                        function med() {
                            hed();
                            this.b = new Tsb;
                            this.a = new Tsb;
                            this.c = new bnb;
                        }
                        function KKd(a, b, c) {
                            this.d = a;
                            this.j = b;
                            this.e = c;
                            this.o = -1;
                            this.p = 3;
                        }
                        function LKd(a, b, c) {
                            this.d = a;
                            this.k = b;
                            this.f = c;
                            this.o = -1;
                            this.p = 5;
                        }
                        function S3d(a, b, c, d, e, f) {
                            R3d.call(this, a, b, c, d, e);
                            f && (this.o = -2);
                        }
                        function U3d(a, b, c, d, e, f) {
                            T3d.call(this, a, b, c, d, e);
                            f && (this.o = -2);
                        }
                        function W3d(a, b, c, d, e, f) {
                            V3d.call(this, a, b, c, d, e);
                            f && (this.o = -2);
                        }
                        function Y3d(a, b, c, d, e, f) {
                            X3d.call(this, a, b, c, d, e);
                            f && (this.o = -2);
                        }
                        function $3d(a, b, c, d, e, f) {
                            Z3d.call(this, a, b, c, d, e);
                            f && (this.o = -2);
                        }
                        function a4d(a, b, c, d, e, f) {
                            _3d.call(this, a, b, c, d, e);
                            f && (this.o = -2);
                        }
                        function f4d(a, b, c, d, e, f) {
                            e4d.call(this, a, b, c, d, e);
                            f && (this.o = -2);
                        }
                        function h4d(a, b, c, d, e, f) {
                            g4d.call(this, a, b, c, d, e);
                            f && (this.o = -2);
                        }
                        function N7d(a, b, c, d) {
                            t7d.call(this, c);
                            this.b = a;
                            this.c = b;
                            this.d = d;
                        }
                        function mfe(a, b) {
                            this.f = a;
                            this.a = (ree(), pee);
                            this.c = pee;
                            this.b = b;
                        }
                        function Jfe(a, b) {
                            this.g = a;
                            this.d = (ree(), qee);
                            this.a = qee;
                            this.b = b;
                        }
                        function Gme(a, b) {
                            !a.c && (a.c = new Uge(a, 0));
                            Fge(a.c, (nme(), fme), b);
                        }
                        function Oge(a, b) {
                            return Pge(a, b, ZD(b, 102) && (RD(b, 19).Bb & txe) != 0);
                        }
                        function lB(a, b) {
                            return Agb(Hdb(a.q.getTime()), Hdb(b.q.getTime()));
                        }
                        function gj(a) {
                            return fk(a.e.Rd().gc() * a.c.Rd().gc(), 16, new qj(a));
                        }
                        function CYd(a) {
                            return !!a.u && tYd(a.u.a).i != 0 && !(!!a.n && d$d(a.n));
                        }
                        function p4d(a) {
                            return !!a.a && o4d(a.a.a).i != 0 && !(!!a.b && o5d(a.b));
                        }
                        function Cxd(a, b) {
                            if (b == 0) return !!a.o && a.o.f != 0;
                            return Kvd(a, b);
                        }
                        function Cc(a, b, c) {
                            var d;
                            d = RD(a.Zb().xc(b), 16);
                            return !!d && d.Hc(c);
                        }
                        function Gc(a, b, c) {
                            var d;
                            d = RD(a.Zb().xc(b), 16);
                            return !!d && d.Mc(c);
                        }
                        function _yb(a, b) {
                            var c;
                            c = 1 - b;
                            a.a[c] = azb(a.a[c], c);
                            return azb(a, b);
                        }
                        function DFb(a, b) {
                            var c, d;
                            d = Cdb(a, yxe);
                            c = Sdb(b, 32);
                            return Rdb(c, d);
                        }
                        function bGb(a, b, c) {
                            var d;
                            d = (Qb(a), new dnb(a));
                            _Fb(new aGb(d, b, c));
                        }
                        function t$b(a, b, c) {
                            var d;
                            d = (Qb(a), new dnb(a));
                            r$b(new s$b(d, b, c));
                        }
                        function vBd(a, b, c, d, e, f) {
                            wBd(a, b, c, f);
                            EYd(a, d);
                            FYd(a, e);
                            return a;
                        }
                        function Xhb(a, b, c, d) {
                            a.a += '' + zhb(b == null ? vve : jeb(b), c, d);
                            return a;
                        }
                        function Jkb(a, b) {
                            this.a = a;
                            Dkb.call(this, a);
                            wFb(b, a.gc());
                            this.b = b;
                        }
                        function xmb(a) {
                            this.a = $C(jJ, rve, 1, mgb($wnd.Math.max(8, a)) << 1, 5, 1);
                        }
                        function t2b(a) {
                            return RD(anb(a, $C(jR, WAe, 10, a.c.length, 0, 1)), 199);
                        }
                        function s2b(a) {
                            return RD(anb(a, $C(WQ, VAe, 18, a.c.length, 0, 1)), 483);
                        }
                        function Iyb(a) {
                            return !a.a ? a.c : a.e.length == 0 ? a.a.a : a.a.a + ('' + a.e);
                        }
                        function Rib(a) {
                            while(a.d > 0 && a.a[--a.d] == 0);
                            a.a[a.d++] == 0 && (a.e = 0);
                        }
                        function fvb(a) {
                            sFb(a.b.b != a.d.a);
                            a.c = a.b = a.b.b;
                            --a.a;
                            return a.c.c;
                        }
                        function sRc(a, b, c) {
                            a.a = b;
                            a.c = c;
                            a.b.a.$b();
                            Xub(a.d);
                            aFb(a.e.a.c, 0);
                        }
                        function Z5c(a, b) {
                            var c;
                            a.e = new R5c;
                            c = Q2c(b);
                            _mb(c, a.c);
                            $5c(a, c, 0);
                        }
                        function zgd(a, b, c, d) {
                            var e;
                            e = new Hgd;
                            e.a = b;
                            e.b = c;
                            e.c = d;
                            Mub(a.a, e);
                        }
                        function Agd(a, b, c, d) {
                            var e;
                            e = new Hgd;
                            e.a = b;
                            e.b = c;
                            e.c = d;
                            Mub(a.b, e);
                        }
                        function Tb(a, b, c) {
                            if (a < 0 || b < a || b > c) throw Adb(new veb(Kb(a, b, c)));
                        }
                        function Pb(a, b) {
                            if (a < 0 || a >= b) throw Adb(new veb(Ib(a, b)));
                            return a;
                        }
                        function qz(b) {
                            if (!('stack' in b)) try {
                                throw b;
                            } catch (a) {}
                            return b;
                        }
                        function Zjc(a) {
                            Wjc();
                            if (ZD(a.g, 10)) return RD(a.g, 10);
                            return null;
                        }
                        function nx(a) {
                            if (Ih(a).dc()) return false;
                            Jh(a, new rx);
                            return true;
                        }
                        function Xdb(a) {
                            var b;
                            if (Kdb(a)) {
                                b = a;
                                return b == -0 ? 0 : b;
                            }
                            return ED(a);
                        }
                        function lkb(a, b) {
                            if (ZD(b, 44)) return Jd(a.a, RD(b, 44));
                            return false;
                        }
                        function gsb(a, b) {
                            if (ZD(b, 44)) return Jd(a.a, RD(b, 44));
                            return false;
                        }
                        function vub(a, b) {
                            if (ZD(b, 44)) return Jd(a.a, RD(b, 44));
                            return false;
                        }
                        function RCb(a) {
                            var b;
                            LCb(a);
                            b = new Prb;
                            ixb(a.a, new fDb(b));
                            return b;
                        }
                        function Vae() {
                            var a, b, c;
                            b = (c = (a = new s2d, a), c);
                            Rmb(Rae, b);
                            return b;
                        }
                        function mDb(a) {
                            var b;
                            LCb(a);
                            b = new ltb;
                            ixb(a.a, new uDb(b));
                            return b;
                        }
                        function jDb(a, b) {
                            if (a.a <= a.b) {
                                b.Dd(a.a++);
                                return true;
                            }
                            return false;
                        }
                        function xzb(a) {
                            yzb.call(this, a, (cAb(), $zb), null, false, null, false);
                        }
                        function $Rb() {
                            $Rb = geb;
                            ZRb = ss((VRb(), cD(WC($O, 1), jwe, 489, 0, [
                                URb
                            ])));
                        }
                        function CHc() {
                            CHc = geb;
                            BHc = yx(sgb(1), sgb(4));
                            AHc = yx(sgb(1), sgb(2));
                        }
                        function yXc(a, b) {
                            return new gud(b, njd(ajd(b.e), a, a), (Geb(), true));
                        }
                        function fv(a) {
                            return new cnb((dk(a, lwe), dz(Bdb(Bdb(5, a), a / 10 | 0))));
                        }
                        function Wi(a) {
                            return fk(a.e.Rd().gc() * a.c.Rd().gc(), 273, new kj(a));
                        }
                        function u2b(a) {
                            return RD(anb(a, $C(xR, XAe, 12, a.c.length, 0, 1)), 2042);
                        }
                        function COc(a) {
                            dOc();
                            return !W0b(a) && !(!W0b(a) && a.c.i.c == a.d.i.c);
                        }
                        function Y_c(a, b) {
                            R_c();
                            return RD(mQb(b, (h_c(), W$c)), 17).a >= a.gc();
                        }
                        function q8b(a, b) {
                            w8b(b, a);
                            y8b(a.d);
                            y8b(RD(mQb(a, (yCc(), cBc)), 214));
                        }
                        function r8b(a, b) {
                            z8b(b, a);
                            B8b(a.d);
                            B8b(RD(mQb(a, (yCc(), cBc)), 214));
                        }
                        function $0b(a, b, c) {
                            !!a.d && Ymb(a.d.e, a);
                            a.d = b;
                            !!a.d && Qmb(a.d.e, c, a);
                        }
                        function jPb(a, b, c) {
                            return c.f.c.length > 0 ? yPb(a.a, b, c) : yPb(a.b, b, c);
                        }
                        function Uz(a, b, c) {
                            var d;
                            d = Sz();
                            try {
                                return Rz(a, b, c);
                            } finally{
                                Vz(d);
                            }
                        }
                        function wDd(a, b) {
                            var c, d;
                            c = qC(a, b);
                            d = null;
                            !!c && (d = c.pe());
                            return d;
                        }
                        function yDd(a, b) {
                            var c, d;
                            c = qC(a, b);
                            d = null;
                            !!c && (d = c.se());
                            return d;
                        }
                        function xDd(a, b) {
                            var c, d;
                            c = JB(a, b);
                            d = null;
                            !!c && (d = c.se());
                            return d;
                        }
                        function zDd(a, b) {
                            var c, d;
                            c = qC(a, b);
                            d = null;
                            !!c && (d = ADd(c));
                            return d;
                        }
                        function rEd(a, b, c) {
                            var d;
                            d = uDd(c);
                            Do(a.g, d, b);
                            Do(a.i, b, c);
                            return b;
                        }
                        function UIc(a, b, c) {
                            this.d = new fJc(this);
                            this.e = a;
                            this.i = b;
                            this.f = c;
                        }
                        function Mk(a, b, c, d) {
                            this.e = null;
                            this.c = a;
                            this.d = b;
                            this.a = c;
                            this.b = d;
                        }
                        function urc(a, b, c, d) {
                            nrc(this);
                            this.c = a;
                            this.e = b;
                            this.f = c;
                            this.b = d;
                        }
                        function MKd(a, b, c, d) {
                            this.d = a;
                            this.n = b;
                            this.g = c;
                            this.o = d;
                            this.p = -1;
                        }
                        function Vc(a, b, c, d) {
                            return ZD(c, 59) ? new Kg(a, b, c, d) : new yg(a, b, c, d);
                        }
                        function gr(a) {
                            if (ZD(a, 16)) return RD(a, 16).dc();
                            return !a.Kc().Ob();
                        }
                        function Wo(a) {
                            if (a.e.g != a.b) throw Adb(new Jrb);
                            return !!a.c && a.d > 0;
                        }
                        function evb(a) {
                            sFb(a.b != a.d.c);
                            a.c = a.b;
                            a.b = a.b.a;
                            ++a.a;
                            return a.c.c;
                        }
                        function imb(a, b) {
                            uFb(b);
                            bD(a.a, a.c, b);
                            a.c = a.c + 1 & a.a.length - 1;
                            mmb(a);
                        }
                        function hmb(a, b) {
                            uFb(b);
                            a.b = a.b - 1 & a.a.length - 1;
                            bD(a.a, a.b, b);
                            mmb(a);
                        }
                        function _je(a) {
                            var b;
                            b = a.Gh();
                            this.a = ZD(b, 71) ? RD(b, 71).Ii() : b.Kc();
                        }
                        function px(a) {
                            return new Swb(Dob(RD(a.a.md(), 16).gc(), a.a.ld()), 16);
                        }
                        function Abd() {
                            Abd = geb;
                            zbd = ss((sbd(), cD(WC(M1, 1), jwe, 490, 0, [
                                rbd
                            ])));
                        }
                        function Jbd() {
                            Jbd = geb;
                            Ibd = ss((Cbd(), cD(WC(N1, 1), jwe, 558, 0, [
                                Bbd
                            ])));
                        }
                        function idd() {
                            idd = geb;
                            hdd = ss((_cd(), cD(WC(V1, 1), jwe, 539, 0, [
                                $cd
                            ])));
                        }
                        function X$b() {
                            U$b();
                            return cD(WC(CQ, 1), jwe, 389, 0, [
                                T$b,
                                R$b,
                                Q$b,
                                S$b
                            ]);
                        }
                        function hAb() {
                            cAb();
                            return cD(WC(AL, 1), jwe, 304, 0, [
                                $zb,
                                _zb,
                                aAb,
                                bAb
                            ]);
                        }
                        function LPb() {
                            IPb();
                            return cD(WC(DO, 1), jwe, 332, 0, [
                                FPb,
                                EPb,
                                GPb,
                                HPb
                            ]);
                        }
                        function LRb() {
                            IRb();
                            return cD(WC(WO, 1), jwe, 406, 0, [
                                FRb,
                                ERb,
                                GRb,
                                HRb
                            ]);
                        }
                        function pOb() {
                            mOb();
                            return cD(WC(hO, 1), jwe, 417, 0, [
                                lOb,
                                iOb,
                                jOb,
                                kOb
                            ]);
                        }
                        function uZb() {
                            nZb();
                            return cD(WC(lQ, 1), jwe, 416, 0, [
                                jZb,
                                mZb,
                                kZb,
                                lZb
                            ]);
                        }
                        function hnc() {
                            enc();
                            return cD(WC(LV, 1), jwe, 421, 0, [
                                anc,
                                bnc,
                                cnc,
                                dnc
                            ]);
                        }
                        function zec() {
                            vec();
                            return cD(WC(qT, 1), jwe, 371, 0, [
                                uec,
                                sec,
                                tec,
                                rec
                            ]);
                        }
                        function BDc() {
                            wDc();
                            return cD(WC(tX, 1), jwe, 203, 0, [
                                uDc,
                                vDc,
                                tDc,
                                sDc
                            ]);
                        }
                        function nEc() {
                            kEc();
                            return cD(WC(wX, 1), jwe, 284, 0, [
                                hEc,
                                gEc,
                                iEc,
                                jEc
                            ]);
                        }
                        function Unc(a) {
                            var b;
                            return a.j == (qpd(), npd) && (b = Vnc(a), Csb(b, Xod));
                        }
                        function qhc(a, b) {
                            var c;
                            c = b.a;
                            Y0b(c, b.c.d);
                            Z0b(c, b.d.d);
                            Cjd(c.a, a.n);
                        }
                        function _5b(a, b) {
                            var c;
                            c = RD(cub(a.b, b), 67);
                            !c && (c = new Yub);
                            return c;
                        }
                        function $jc(a) {
                            Wjc();
                            if (ZD(a.g, 154)) return RD(a.g, 154);
                            return null;
                        }
                        function gRc(a) {
                            a.a = null;
                            a.e = null;
                            aFb(a.b.c, 0);
                            aFb(a.f.c, 0);
                            a.c = null;
                        }
                        function Ovc() {
                            Ovc = geb;
                            Mvc = new Pvc(Kye, 0);
                            Nvc = new Pvc('TOP_LEFT', 1);
                        }
                        function sNc() {
                            sNc = geb;
                            rNc = new tNc('UPPER', 0);
                            qNc = new tNc('LOWER', 1);
                        }
                        function nWc(a, b) {
                            return cjd(new rjd(b.e.a + b.f.a / 2, b.e.b + b.f.b / 2), a);
                        }
                        function wqc(a, b) {
                            return RD(Lvb(JDb(RD(Qc(a.k, b), 15).Oc(), lqc)), 113);
                        }
                        function xqc(a, b) {
                            return RD(Lvb(KDb(RD(Qc(a.k, b), 15).Oc(), lqc)), 113);
                        }
                        function cWc() {
                            YVc();
                            return cD(WC(H$, 1), jwe, 405, 0, [
                                UVc,
                                VVc,
                                WVc,
                                XVc
                            ]);
                        }
                        function v_c() {
                            s_c();
                            return cD(WC(J_, 1), jwe, 353, 0, [
                                r_c,
                                p_c,
                                q_c,
                                o_c
                            ]);
                        }
                        function n5c() {
                            j5c();
                            return cD(WC(M0, 1), jwe, 354, 0, [
                                i5c,
                                g5c,
                                h5c,
                                f5c
                            ]);
                        }
                        function Tpd() {
                            Qpd();
                            return cD(WC(H3, 1), jwe, 386, 0, [
                                Opd,
                                Ppd,
                                Npd,
                                Mpd
                            ]);
                        }
                        function Tnd() {
                            Pnd();
                            return cD(WC(z3, 1), jwe, 291, 0, [
                                Ond,
                                Lnd,
                                Mnd,
                                Nnd
                            ]);
                        }
                        function _md() {
                            Ymd();
                            return cD(WC(u3, 1), jwe, 223, 0, [
                                Xmd,
                                Vmd,
                                Umd,
                                Wmd
                            ]);
                        }
                        function Jrd() {
                            Grd();
                            return cD(WC(R3, 1), jwe, 320, 0, [
                                Frd,
                                Crd,
                                Erd,
                                Drd
                            ]);
                        }
                        function wtd() {
                            ttd();
                            return cD(WC(n4, 1), jwe, 415, 0, [
                                qtd,
                                rtd,
                                ptd,
                                std
                            ]);
                        }
                        function GId(a) {
                            EId();
                            return Ujb(DId, a) ? RD(Wjb(DId, a), 341).Qg() : null;
                        }
                        function Avd(a, b, c) {
                            return b < 0 ? Rvd(a, c) : RD(c, 69).wk().Bk(a, a.hi(), b);
                        }
                        function sEd(a, b, c) {
                            var d;
                            d = uDd(c);
                            Do(a.j, d, b);
                            Zjb(a.k, b, c);
                            return b;
                        }
                        function qEd(a, b, c) {
                            var d;
                            d = uDd(c);
                            Do(a.d, d, b);
                            Zjb(a.e, b, c);
                            return b;
                        }
                        function DGd(a) {
                            var b, c;
                            b = (bvd(), c = new rzd, c);
                            !!a && pzd(b, a);
                            return b;
                        }
                        function WHd(a) {
                            var b;
                            b = a.aj(a.i);
                            a.i > 0 && hib(a.g, 0, b, 0, a.i);
                            return b;
                        }
                        function Led(a, b) {
                            var c;
                            for(c = a.j.c.length; c < b; c++)Rmb(a.j, a.Ng());
                        }
                        function $Ec(a, b, c, d) {
                            var e;
                            e = d[b.g][c.g];
                            return Kfb(UD(mQb(a.a, e)));
                        }
                        function QRd(a, b) {
                            PRd();
                            var c;
                            c = RD(Wjb(ORd, a), 57);
                            return !c || c.fk(b);
                        }
                        function rKd(a) {
                            if (a.p != 1) throw Adb(new cgb);
                            return Ydb(a.f) << 24 >> 24;
                        }
                        function AKd(a) {
                            if (a.p != 1) throw Adb(new cgb);
                            return Ydb(a.k) << 24 >> 24;
                        }
                        function GKd(a) {
                            if (a.p != 7) throw Adb(new cgb);
                            return Ydb(a.k) << 16 >> 16;
                        }
                        function xKd(a) {
                            if (a.p != 7) throw Adb(new cgb);
                            return Ydb(a.f) << 16 >> 16;
                        }
                        function Wib(a, b) {
                            if (b.e == 0 || a.e == 0) return Oib;
                            return Ljb(), Mjb(a, b);
                        }
                        function Nd(a, b) {
                            return dE(b) === dE(a) ? '(this Map)' : b == null ? vve : jeb(b);
                        }
                        function MFb(a, b, c) {
                            return Jfb(UD(Wd(qtb(a.f, b))), UD(Wd(qtb(a.f, c))));
                        }
                        function wkc(a, b, c) {
                            var d;
                            d = RD(Wjb(a.g, c), 60);
                            Rmb(a.a.c, new Ptd(b, d));
                        }
                        function Slc(a, b, c) {
                            a.i = 0;
                            a.e = 0;
                            if (b == c) return;
                            Rlc(a, b, c);
                            Qlc(a, b, c);
                        }
                        function rTc(a, b, c, d, e) {
                            var f;
                            f = mTc(e, c, d);
                            Rmb(b, TSc(e, f));
                            vTc(a, e, b);
                        }
                        function Jrc(a, b, c, d, e) {
                            this.i = a;
                            this.a = b;
                            this.e = c;
                            this.j = d;
                            this.f = e;
                        }
                        function iUb(a, b) {
                            VTb.call(this);
                            this.a = a;
                            this.b = b;
                            Rmb(this.a.b, this);
                        }
                        function rTb(a) {
                            this.b = new Tsb;
                            this.c = new Tsb;
                            this.d = new Tsb;
                            this.a = a;
                        }
                        function Dx(a, b) {
                            var c;
                            c = new cib;
                            a.Gd(c);
                            c.a += '..';
                            b.Hd(c);
                            return c.a;
                        }
                        function Fsd(a, b) {
                            var c;
                            c = b;
                            while(c){
                                Zid(a, c.i, c.j);
                                c = vCd(c);
                            }
                            return a;
                        }
                        function pEd(a, b, c) {
                            var d;
                            d = uDd(c);
                            Zjb(a.b, d, b);
                            Zjb(a.c, b, c);
                            return b;
                        }
                        function Kr(a) {
                            var b;
                            b = 0;
                            while(a.Ob()){
                                a.Pb();
                                b = Bdb(b, 1);
                            }
                            return dz(b);
                        }
                        function oke(a, b) {
                            nke();
                            var c;
                            c = RD(a, 69).vk();
                            K6d(c, b);
                            return c.xl(b);
                        }
                        function tC(d, a, b) {
                            if (b) {
                                var c = b.oe();
                                d.a[a] = c(b);
                            } else delete d.a[a];
                        }
                        function tB(a, b) {
                            var c;
                            c = a.q.getHours();
                            a.q.setFullYear(b + Owe);
                            mB(a, c);
                        }
                        function KSd(a, b) {
                            return RD(b == null ? Wd(qtb(a.f, null)) : Ktb(a.i, b), 288);
                        }
                        function hOc(a, b) {
                            return a == (r3b(), p3b) && b == p3b ? 4 : a == p3b || b == p3b ? 8 : 32;
                        }
                        function cge(a, b, c) {
                            return dge(a, b, c, ZD(b, 102) && (RD(b, 19).Bb & txe) != 0);
                        }
                        function jge(a, b, c) {
                            return kge(a, b, c, ZD(b, 102) && (RD(b, 19).Bb & txe) != 0);
                        }
                        function Qge(a, b, c) {
                            return Rge(a, b, c, ZD(b, 102) && (RD(b, 19).Bb & txe) != 0);
                        }
                        function jmb(a) {
                            if (a.b == a.c) return;
                            a.a = $C(jJ, rve, 1, 8, 5, 1);
                            a.b = 0;
                            a.c = 0;
                        }
                        function Nsb(a) {
                            sFb(a.a < a.c.a.length);
                            a.b = a.a;
                            Lsb(a);
                            return a.c.b[a.b];
                        }
                        function tYd(a) {
                            if (!a.n) {
                                yYd(a);
                                a.n = new h$d(a, o7, a);
                                zYd(a);
                            }
                            return a.n;
                        }
                        function oFb(a) {
                            if (a < 0) throw Adb(new Mgb('Negative array size: ' + a));
                        }
                        function LB(d, a, b) {
                            if (b) {
                                var c = b.oe();
                                b = c(b);
                            } else b = undefined;
                            d.a[a] = b;
                        }
                        function ygc(a, b) {
                            sgc();
                            var c;
                            c = a.j.g - b.j.g;
                            if (c != 0) return c;
                            return 0;
                        }
                        function l_d(a, b) {
                            gib();
                            String.fromCharCode(10);
                            return WGd(xYd(a.a), b);
                        }
                        function q_d(a, b) {
                            gib();
                            String.fromCharCode(10);
                            return WGd(xYd(a.a), b);
                        }
                        function ajb(a, b) {
                            Pib();
                            cjb.call(this, a, 1, cD(WC(kE, 1), Pwe, 28, 15, [
                                b
                            ]));
                        }
                        function Kte(a, b) {
                            Vse();
                            Wse.call(this, a);
                            this.a = b;
                            this.c = -1;
                            this.b = -1;
                        }
                        function L3d(a, b, c, d) {
                            KKd.call(this, 1, c, d);
                            J3d(this);
                            this.c = a;
                            this.b = b;
                        }
                        function M3d(a, b, c, d) {
                            LKd.call(this, 1, c, d);
                            J3d(this);
                            this.c = a;
                            this.b = b;
                        }
                        function lle(a, b, c, d, e, f, g) {
                            NKd.call(this, b, d, e, f, g);
                            this.c = a;
                            this.a = c;
                        }
                        function j7d(a, b, c) {
                            this.e = a;
                            this.a = jJ;
                            this.b = pje(b);
                            this.c = b;
                            this.d = c;
                        }
                        function Xo(a) {
                            this.e = a;
                            this.c = this.e.a;
                            this.b = this.e.g;
                            this.d = this.e.i;
                        }
                        function Qtb(a) {
                            this.d = a;
                            this.b = this.d.a.entries();
                            this.a = this.b.next();
                        }
                        function N9d(a) {
                            this.c = a;
                            this.a = RD(WVd(a), 156);
                            this.b = this.a.jk().wi();
                        }
                        function gub() {
                            Tsb.call(this);
                            _tb(this);
                            this.d.b = this.d;
                            this.d.a = this.d;
                        }
                        function Pub(a, b, c, d) {
                            var e;
                            e = new svb;
                            e.c = b;
                            e.b = c;
                            e.a = d;
                            d.b = c.a = e;
                            ++a.b;
                        }
                        function USd(a, b) {
                            var c;
                            return c = b != null ? Xjb(a, b) : Wd(qtb(a.f, b)), fE(c);
                        }
                        function dTd(a, b) {
                            var c;
                            return c = b != null ? Xjb(a, b) : Wd(qtb(a.f, b)), fE(c);
                        }
                        function zDb(a, b) {
                            var c;
                            return b.b.Kb(LDb(a, b.c.Xe(), (c = new OEb(b), c)));
                        }
                        function Gnb(a, b) {
                            var c;
                            oFb(b);
                            return c = a.slice(0, b), c.length = b, dD(c, a);
                        }
                        function Rqb(a, b) {
                            var c;
                            for(c = 0; c < b; ++c)bD(a, c, new brb(RD(a[c], 44)));
                        }
                        function Tib(a, b) {
                            var c;
                            for(c = a.d - 1; c >= 0 && a.a[c] === b[c]; c--);
                            return c < 0;
                        }
                        function Xx(a) {
                            var b;
                            if (a) return new Kub(a);
                            b = new Iub;
                            _q(b, a);
                            return b;
                        }
                        function nmc(a, b) {
                            var c, d;
                            d = false;
                            do {
                                c = qmc(a, b);
                                d = d | c;
                            }while (c);
                            return d;
                        }
                        function Vz(a) {
                            a && aA(($z(), Zz));
                            --Nz;
                            if (a) {
                                if (Pz != -1) {
                                    Xz(Pz);
                                    Pz = -1;
                                }
                            }
                        }
                        function Pwb(a) {
                            Hwb();
                            Mwb(this, Ydb(Cdb(Tdb(a, 24), Pxe)), Ydb(Cdb(a, Pxe)));
                        }
                        function IHb() {
                            IHb = geb;
                            HHb = ss((DHb(), cD(WC(uN, 1), jwe, 436, 0, [
                                CHb,
                                BHb
                            ])));
                        }
                        function QHb() {
                            QHb = geb;
                            PHb = ss((LHb(), cD(WC(vN, 1), jwe, 435, 0, [
                                JHb,
                                KHb
                            ])));
                        }
                        function YUb() {
                            YUb = geb;
                            XUb = ss((TUb(), cD(WC(BP, 1), jwe, 432, 0, [
                                RUb,
                                SUb
                            ])));
                        }
                        function U8b() {
                            U8b = geb;
                            T8b = ss((P8b(), cD(WC(vS, 1), jwe, 517, 0, [
                                O8b,
                                N8b
                            ])));
                        }
                        function Tvc() {
                            Tvc = geb;
                            Svc = ss((Ovc(), cD(WC(lX, 1), jwe, 429, 0, [
                                Mvc,
                                Nvc
                            ])));
                        }
                        function duc() {
                            duc = geb;
                            cuc = ss(($tc(), cD(WC(cX, 1), jwe, 428, 0, [
                                Ytc,
                                Ztc
                            ])));
                        }
                        function Huc() {
                            Huc = geb;
                            Guc = ss((Cuc(), cD(WC(fX, 1), jwe, 488, 0, [
                                Buc,
                                Auc
                            ])));
                        }
                        function xEc() {
                            xEc = geb;
                            wEc = ss((sEc(), cD(WC(xX, 1), jwe, 430, 0, [
                                qEc,
                                rEc
                            ])));
                        }
                        function xNc() {
                            xNc = geb;
                            wNc = ss((sNc(), cD(WC(MY, 1), jwe, 531, 0, [
                                rNc,
                                qNc
                            ])));
                        }
                        function otc() {
                            otc = geb;
                            ntc = ss((jtc(), cD(WC($W, 1), jwe, 431, 0, [
                                htc,
                                itc
                            ])));
                        }
                        function F_c() {
                            F_c = geb;
                            E_c = ss((A_c(), cD(WC(K_, 1), jwe, 433, 0, [
                                z_c,
                                y_c
                            ])));
                        }
                        function F2c() {
                            F2c = geb;
                            E2c = ss((x2c(), cD(WC(s0, 1), jwe, 501, 0, [
                                v2c,
                                w2c
                            ])));
                        }
                        function BQc() {
                            BQc = geb;
                            AQc = ss((wQc(), cD(WC(FZ, 1), jwe, 523, 0, [
                                vQc,
                                uQc
                            ])));
                        }
                        function JQc() {
                            JQc = geb;
                            IQc = ss((EQc(), cD(WC(GZ, 1), jwe, 522, 0, [
                                CQc,
                                DQc
                            ])));
                        }
                        function kTc() {
                            kTc = geb;
                            jTc = ss((fTc(), cD(WC(b$, 1), jwe, 528, 0, [
                                eTc,
                                dTc
                            ])));
                        }
                        function iVc() {
                            iVc = geb;
                            hVc = ss((dVc(), cD(WC(w$, 1), jwe, 465, 0, [
                                bVc,
                                cVc
                            ])));
                        }
                        function c4c() {
                            c4c = geb;
                            b4c = ss((Y3c(), cD(WC(H0, 1), jwe, 434, 0, [
                                W3c,
                                X3c
                            ])));
                        }
                        function H8c() {
                            H8c = geb;
                            G8c = ss((z8c(), cD(WC(l1, 1), jwe, 491, 0, [
                                x8c,
                                y8c
                            ])));
                        }
                        function J9c() {
                            J9c = geb;
                            I9c = ss((B9c(), cD(WC(t1, 1), jwe, 492, 0, [
                                z9c,
                                A9c
                            ])));
                        }
                        function Rbd() {
                            Rbd = geb;
                            Qbd = ss((Mbd(), cD(WC(O1, 1), jwe, 438, 0, [
                                Lbd,
                                Kbd
                            ])));
                        }
                        function tdd() {
                            tdd = geb;
                            sdd = ss((ldd(), cD(WC(W1, 1), jwe, 437, 0, [
                                kdd,
                                jdd
                            ])));
                        }
                        function Eqd() {
                            Eqd = geb;
                            Dqd = ss((uqd(), cD(WC(M3, 1), jwe, 347, 0, [
                                sqd,
                                tqd
                            ])));
                        }
                        function Imd() {
                            Cmd();
                            return cD(WC(s3, 1), jwe, 88, 0, [
                                Amd,
                                zmd,
                                ymd,
                                xmd,
                                Bmd
                            ]);
                        }
                        function xpd() {
                            qpd();
                            return cD(WC(E3, 1), NAe, 64, 0, [
                                opd,
                                Yod,
                                Xod,
                                npd,
                                ppd
                            ]);
                        }
                        function LSd(a, b, c) {
                            return RD(b == null ? rtb(a.f, null, c) : Ltb(a.i, b, c), 288);
                        }
                        function L6b(a) {
                            return (a.k == (r3b(), p3b) || a.k == m3b) && nQb(a, (Ywc(), cwc));
                        }
                        function bUb(a) {
                            return !!a.c && !!a.d ? kUb(a.c) + '->' + kUb(a.d) : 'e_' + kFb(a);
                        }
                        function xgb(a, b) {
                            var c, d;
                            uFb(b);
                            for(d = a.Kc(); d.Ob();){
                                c = d.Pb();
                                b.Cd(c);
                            }
                        }
                        function jEd(a, b) {
                            var c;
                            c = new uC;
                            qDd(c, 'x', b.a);
                            qDd(c, 'y', b.b);
                            oDd(a, c);
                        }
                        function mEd(a, b) {
                            var c;
                            c = new uC;
                            qDd(c, 'x', b.a);
                            qDd(c, 'y', b.b);
                            oDd(a, c);
                        }
                        function Gsd(a, b) {
                            var c;
                            c = b;
                            while(c){
                                Zid(a, -c.i, -c.j);
                                c = vCd(c);
                            }
                            return a;
                        }
                        function ZLc(a, b) {
                            var c, d;
                            c = b;
                            d = 0;
                            while(c > 0){
                                d += a.a[c];
                                c -= c & -c;
                            }
                            return d;
                        }
                        function $mb(a, b, c) {
                            var d;
                            d = (tFb(b, a.c.length), a.c[b]);
                            a.c[b] = c;
                            return d;
                        }
                        function uIc(a, b, c) {
                            a.a.c.length = 0;
                            yIc(a, b, c);
                            a.a.c.length == 0 || rIc(a, b);
                        }
                        function wo(a) {
                            a.i = 0;
                            Mnb(a.b, null);
                            Mnb(a.c, null);
                            a.a = null;
                            a.e = null;
                            ++a.g;
                        }
                        function gBb() {
                            gBb = geb;
                            dBb = true;
                            bBb = false;
                            cBb = false;
                            fBb = false;
                            eBb = false;
                        }
                        function oBb(a) {
                            gBb();
                            if (dBb) return;
                            this.c = a;
                            this.e = true;
                            this.a = new bnb;
                        }
                        function kDb(a, b) {
                            this.c = 0;
                            this.b = b;
                            txb.call(this, a, 17493);
                            this.a = this.c;
                        }
                        function S_b(a) {
                            P_b();
                            A$b(this);
                            this.a = new Yub;
                            Q_b(this, a);
                            Mub(this.a, a);
                        }
                        function m_b() {
                            Pmb(this);
                            this.b = new rjd(oxe, oxe);
                            this.a = new rjd(pxe, pxe);
                        }
                        function z8c() {
                            z8c = geb;
                            x8c = new B8c(CBe, 0);
                            y8c = new B8c('TARGET_WIDTH', 1);
                        }
                        function yDb(a, b) {
                            return (MCb(a), QDb(new SDb(a, new hEb(b, a.a)))).Bd(wDb);
                        }
                        function vXb() {
                            sXb();
                            return cD(WC(UP, 1), jwe, 367, 0, [
                                nXb,
                                oXb,
                                pXb,
                                qXb,
                                rXb
                            ]);
                        }
                        function Fnc() {
                            Bnc();
                            return cD(WC(TV, 1), jwe, 375, 0, [
                                xnc,
                                znc,
                                Anc,
                                ync,
                                wnc
                            ]);
                        }
                        function Vtc() {
                            Ptc();
                            return cD(WC(bX, 1), jwe, 348, 0, [
                                Ltc,
                                Ktc,
                                Ntc,
                                Otc,
                                Mtc
                            ]);
                        }
                        function PDc() {
                            JDc();
                            return cD(WC(uX, 1), jwe, 323, 0, [
                                IDc,
                                FDc,
                                GDc,
                                EDc,
                                HDc
                            ]);
                        }
                        function fxc() {
                            cxc();
                            return cD(WC(mX, 1), jwe, 171, 0, [
                                bxc,
                                Zwc,
                                $wc,
                                _wc,
                                axc
                            ]);
                        }
                        function k3c() {
                            g3c();
                            return cD(WC(x0, 1), jwe, 368, 0, [
                                e3c,
                                b3c,
                                f3c,
                                c3c,
                                d3c
                            ]);
                        }
                        function vad() {
                            sad();
                            return cD(WC(x1, 1), jwe, 373, 0, [
                                oad,
                                nad,
                                qad,
                                pad,
                                rad
                            ]);
                        }
                        function $bd() {
                            Xbd();
                            return cD(WC(P1, 1), jwe, 324, 0, [
                                Sbd,
                                Tbd,
                                Wbd,
                                Ubd,
                                Vbd
                            ]);
                        }
                        function _hd() {
                            Yhd();
                            return cD(WC(d3, 1), jwe, 170, 0, [
                                Whd,
                                Vhd,
                                Thd,
                                Xhd,
                                Uhd
                            ]);
                        }
                        function sod() {
                            pod();
                            return cD(WC(B3, 1), jwe, 256, 0, [
                                mod,
                                ood,
                                kod,
                                lod,
                                nod
                            ]);
                        }
                        function Tz(b) {
                            Qz();
                            return function() {
                                var a;
                                return Uz(b, this, arguments);
                            };
                        }
                        function W0b(a) {
                            if (!a.c || !a.d) return false;
                            return !!a.c.i && a.c.i == a.d.i;
                        }
                        function Nfd(a, b) {
                            if (ZD(b, 143)) return lhb(a.c, RD(b, 143).c);
                            return false;
                        }
                        function yYd(a) {
                            if (!a.t) {
                                a.t = new w$d(a);
                                VGd(new Cde(a), 0, a.t);
                            }
                            return a.t;
                        }
                        function jNd(a) {
                            this.b = a;
                            dMd.call(this, a);
                            this.a = RD(Ywd(this.b.a, 4), 129);
                        }
                        function sNd(a) {
                            this.b = a;
                            yMd.call(this, a);
                            this.a = RD(Ywd(this.b.a, 4), 129);
                        }
                        function Q3d(a, b, c, d, e) {
                            OKd.call(this, b, d, e);
                            J3d(this);
                            this.c = a;
                            this.b = c;
                        }
                        function V3d(a, b, c, d, e) {
                            KKd.call(this, b, d, e);
                            J3d(this);
                            this.c = a;
                            this.a = c;
                        }
                        function Z3d(a, b, c, d, e) {
                            LKd.call(this, b, d, e);
                            J3d(this);
                            this.c = a;
                            this.a = c;
                        }
                        function g4d(a, b, c, d, e) {
                            OKd.call(this, b, d, e);
                            J3d(this);
                            this.c = a;
                            this.a = c;
                        }
                        function ugd(a, b) {
                            var c;
                            c = RD(cub(a.d, b), 23);
                            return c ? c : RD(cub(a.e, b), 23);
                        }
                        function Blb(a, b) {
                            var c, d;
                            c = b.ld();
                            d = a.Fe(c);
                            return !!d && Fvb(d.e, b.md());
                        }
                        function me(a, b) {
                            var c;
                            c = b.ld();
                            return new gp(c, a.e.pc(c, RD(b.md(), 16)));
                        }
                        function ptb(a, b) {
                            var c;
                            c = a.a.get(b);
                            return c == null ? $C(jJ, rve, 1, 0, 5, 1) : c;
                        }
                        function khb(a) {
                            var b;
                            b = a.length;
                            return lhb(sxe.substr(sxe.length - b, b), a);
                        }
                        function hs(a) {
                            if (gs(a)) {
                                a.c = a.a;
                                return a.a.Pb();
                            } else throw Adb(new Dvb);
                        }
                        function $ib(a, b) {
                            if (b == 0 || a.e == 0) return a;
                            return b > 0 ? tjb(a, b) : qjb(a, -b);
                        }
                        function Zib(a, b) {
                            if (b == 0 || a.e == 0) return a;
                            return b > 0 ? qjb(a, b) : tjb(a, -b);
                        }
                        function Deb(a) {
                            Beb.call(this, a == null ? vve : jeb(a), ZD(a, 82) ? RD(a, 82) : null);
                        }
                        function Y5d(a) {
                            var b;
                            if (!a.c) {
                                b = a.r;
                                ZD(b, 90) && (a.c = RD(b, 29));
                            }
                            return a.c;
                        }
                        function s0b(a) {
                            var b;
                            b = new a1b;
                            kQb(b, a);
                            pQb(b, (yCc(), RAc), null);
                            return b;
                        }
                        function lec(a) {
                            var b, c;
                            b = a.c.i;
                            c = a.d.i;
                            return b.k == (r3b(), m3b) && c.k == m3b;
                        }
                        function fD(a) {
                            var b, c, d;
                            b = a & dxe;
                            c = a >> 22 & dxe;
                            d = a < 0 ? exe : 0;
                            return hD(b, c, d);
                        }
                        function Ky(a) {
                            var b, c, d, e;
                            for(c = a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                ICb(b);
                            }
                        }
                        function Tc(a, b) {
                            var c, d;
                            c = RD(Yv(a.c, b), 16);
                            if (c) {
                                d = c.gc();
                                c.$b();
                                a.d -= d;
                            }
                        }
                        function Fvd(a, b, c) {
                            var d;
                            return d = a.Ih(b), d >= 0 ? a.Lh(d, c, true) : Qvd(a, b, c);
                        }
                        function AXc(a, b, c) {
                            return Qfb(cjd(jWc(a), ajd(b.b)), cjd(jWc(a), ajd(c.b)));
                        }
                        function BXc(a, b, c) {
                            return Qfb(cjd(jWc(a), ajd(b.e)), cjd(jWc(a), ajd(c.e)));
                        }
                        function Kad(a, b) {
                            return $wnd.Math.min(bjd(b.a, a.d.d.c), bjd(b.b, a.d.d.c));
                        }
                        function LHd(a, b) {
                            a._i(a.i + 1);
                            MHd(a, a.i, a.Zi(a.i, b));
                            a.Mi(a.i++, b);
                            a.Ni();
                        }
                        function OHd(a) {
                            var b, c;
                            ++a.j;
                            b = a.g;
                            c = a.i;
                            a.g = null;
                            a.i = 0;
                            a.Oi(c, b);
                            a.Ni();
                        }
                        function yke(a, b, c) {
                            var d;
                            d = new zke(a.a);
                            Ld(d, a.a.a);
                            rtb(d.f, b, c);
                            a.a.a = d;
                        }
                        function mKb(a, b, c, d) {
                            var e;
                            for(e = 0; e < jKb; e++)dKb(a.a[e][b.g], c, d[b.g]);
                        }
                        function lKb(a, b, c, d) {
                            var e;
                            for(e = 0; e < iKb; e++)eKb(a.a[b.g][e], c, d[b.g]);
                        }
                        function Qc(a, b) {
                            var c;
                            c = RD(a.c.xc(b), 16);
                            !c && (c = a.ic(b));
                            return a.pc(b, c);
                        }
                        function vm(a) {
                            var b;
                            b = (Qb(a), a ? new dnb(a) : cv(a.Kc()));
                            Eob(b);
                            return Pm(b);
                        }
                        function dv(a) {
                            var b, c;
                            Qb(a);
                            b = Zu(a.length);
                            c = new cnb(b);
                            zob(c, a);
                            return c;
                        }
                        function Hjb(a, b, c, d) {
                            var e;
                            e = $C(kE, Pwe, 28, b, 15, 1);
                            Ijb(e, a, b, c, d);
                            return e;
                        }
                        function Sb(a, b) {
                            if (a < 0 || a > b) throw Adb(new veb(Jb(a, b, 'index')));
                            return a;
                        }
                        function Xmb(a, b) {
                            var c;
                            c = (tFb(b, a.c.length), a.c[b]);
                            $Eb(a.c, b, 1);
                            return c;
                        }
                        function jhb(a, b) {
                            var c, d;
                            c = (uFb(a), a);
                            d = (uFb(b), b);
                            return c == d ? 0 : c < d ? -1 : 1;
                        }
                        function Orb(a) {
                            var b;
                            b = a.e + a.f;
                            if (isNaN(b) && Rfb(a.d)) return a.d;
                            return b;
                        }
                        function zc(a) {
                            a.e = 3;
                            a.d = a.Yb();
                            if (a.e != 2) {
                                a.e = 0;
                                return true;
                            }
                            return false;
                        }
                        function Gyb(a, b) {
                            !a.a ? a.a = new dib(a.d) : Zhb(a.a, a.b);
                            Whb(a.a, b);
                            return a;
                        }
                        function _jb(a, b) {
                            return bE(b) ? b == null ? stb(a.f, null) : Mtb(a.i, b) : stb(a.f, b);
                        }
                        function nEb(a, b) {
                            pxb.call(this, b.zd(), b.yd() & -6);
                            uFb(a);
                            this.a = a;
                            this.b = b;
                        }
                        function tEb(a, b) {
                            txb.call(this, b.zd(), b.yd() & -6);
                            uFb(a);
                            this.a = a;
                            this.b = b;
                        }
                        function zEb(a, b) {
                            xxb.call(this, b.zd(), b.yd() & -6);
                            uFb(a);
                            this.a = a;
                            this.b = b;
                        }
                        function M7d(a, b, c) {
                            t7d.call(this, c);
                            this.b = a;
                            this.c = b;
                            this.d = (a8d(), $7d);
                        }
                        function OKd(a, b, c) {
                            this.d = a;
                            this.k = b ? 1 : 0;
                            this.f = c ? 1 : 0;
                            this.o = -1;
                            this.p = 0;
                        }
                        function l4b(a) {
                            this.c = a;
                            this.a = new Anb(this.c.a);
                            this.b = new Anb(this.c.b);
                        }
                        function gUb() {
                            this.e = new bnb;
                            this.c = new bnb;
                            this.d = new bnb;
                            this.b = new bnb;
                        }
                        function DIb() {
                            this.g = new GIb;
                            this.b = new GIb;
                            this.a = new bnb;
                            this.k = new bnb;
                        }
                        function I_b() {
                            this.a = new J$b;
                            this.b = new N$b;
                            this.d = new Z_b;
                            this.e = new V_b;
                        }
                        function knc(a, b, c) {
                            this.a = a;
                            this.c = b;
                            this.d = c;
                            Rmb(b.e, this);
                            Rmb(c.b, this);
                        }
                        function sIc(a, b, c) {
                            var d, e;
                            d = 0;
                            for(e = 0; e < b.length; e++)d += a.tg(b[e], d, c);
                        }
                        function nMc(a, b) {
                            var c;
                            c = tMc(a, b);
                            a.b = new _Lc(c.c.length);
                            return mMc(a, c);
                        }
                        function pB(a, b) {
                            var c;
                            c = a.q.getHours() + (b / 60 | 0);
                            a.q.setMinutes(b);
                            mB(a, c);
                        }
                        function _Wc(a) {
                            var b;
                            b = a.b;
                            if (b.b == 0) return null;
                            return RD(ju(b, 0), 65).b;
                        }
                        function Src(a) {
                            if (a.a) {
                                if (a.e) return Src(a.e);
                            } else return a;
                            return null;
                        }
                        function mIc(a, b) {
                            if (a.p < b.p) return 1;
                            else if (a.p > b.p) return -1;
                            return 0;
                        }
                        function hXd(a) {
                            var b;
                            if (!a.a) {
                                b = a.r;
                                ZD(b, 156) && (a.a = RD(b, 156));
                            }
                            return a.a;
                        }
                        function iOd(a, b, c) {
                            var d;
                            ++a.e;
                            --a.f;
                            d = RD(a.d[b].gd(c), 136);
                            return d.md();
                        }
                        function fd(a) {
                            var b, c;
                            b = a.ld();
                            c = RD(a.md(), 16);
                            return gk(c.Nc(), new jh(b));
                        }
                        function oae(a, b) {
                            if (Ujb(a.a, b)) {
                                _jb(a.a, b);
                                return true;
                            } else return false;
                        }
                        function Ui(a, b, c) {
                            Pb(b, a.e.Rd().gc());
                            Pb(c, a.c.Rd().gc());
                            return a.a[b][c];
                        }
                        function _Uc(a, b, c) {
                            this.a = a;
                            this.b = b;
                            this.c = c;
                            Rmb(a.t, this);
                            Rmb(b.i, this);
                        }
                        function lg(a, b, c, d) {
                            this.f = a;
                            this.e = b;
                            this.d = c;
                            this.b = d;
                            this.c = !d ? null : d.d;
                        }
                        function YWc() {
                            this.b = new Yub;
                            this.a = new Yub;
                            this.b = new Yub;
                            this.a = new Yub;
                        }
                        function ree() {
                            ree = geb;
                            var a, b;
                            pee = (jTd(), b = new k1d, b);
                            qee = (a = new mXd, a);
                        }
                        function UCb(a) {
                            var b;
                            MCb(a);
                            b = new $Cb(a, a.a.e, a.a.d | 4);
                            return new WCb(a, b);
                        }
                        function ADb(a) {
                            var b;
                            LCb(a);
                            b = 0;
                            while(a.a.Bd(new MEb))b = Bdb(b, 1);
                            return b;
                        }
                        function zxb(a, b) {
                            uFb(b);
                            if (a.c < a.d) {
                                a.Se(b, a.c++);
                                return true;
                            }
                            return false;
                        }
                        function cnb(a) {
                            Pmb(this);
                            mFb(a >= 0, 'Initial capacity must not be negative');
                        }
                        function rid() {
                            rid = geb;
                            qid = new jGd('org.eclipse.elk.labels.labelManager');
                        }
                        function iec() {
                            iec = geb;
                            hec = new kGd('separateLayerConnections', (vec(), uec));
                        }
                        function fTc() {
                            fTc = geb;
                            eTc = new gTc('REGULAR', 0);
                            dTc = new gTc('CRITICAL', 1);
                        }
                        function Mbd() {
                            Mbd = geb;
                            Lbd = new Nbd('FIXED', 0);
                            Kbd = new Nbd('CENTER_NODE', 1);
                        }
                        function jtc() {
                            jtc = geb;
                            htc = new ktc('QUADRATIC', 0);
                            itc = new ktc('SCANLINE', 1);
                        }
                        function Atc() {
                            Atc = geb;
                            ztc = ss((stc(), cD(WC(_W, 1), jwe, 322, 0, [
                                qtc,
                                ptc,
                                rtc
                            ])));
                        }
                        function Jtc() {
                            Jtc = geb;
                            Itc = ss((Etc(), cD(WC(aX, 1), jwe, 351, 0, [
                                Btc,
                                Dtc,
                                Ctc
                            ])));
                        }
                        function ooc() {
                            ooc = geb;
                            noc = ss((joc(), cD(WC(UV, 1), jwe, 372, 0, [
                                ioc,
                                hoc,
                                goc
                            ])));
                        }
                        function muc() {
                            muc = geb;
                            luc = ss((huc(), cD(WC(dX, 1), jwe, 460, 0, [
                                fuc,
                                euc,
                                guc
                            ])));
                        }
                        function Cvc() {
                            Cvc = geb;
                            Bvc = ss((xvc(), cD(WC(jX, 1), jwe, 299, 0, [
                                vvc,
                                wvc,
                                uvc
                            ])));
                        }
                        function Lvc() {
                            Lvc = geb;
                            Kvc = ss((Gvc(), cD(WC(kX, 1), jwe, 311, 0, [
                                Evc,
                                Fvc,
                                Dvc
                            ])));
                        }
                        function rDc() {
                            rDc = geb;
                            qDc = ss((lDc(), cD(WC(sX, 1), jwe, 390, 0, [
                                iDc,
                                jDc,
                                kDc
                            ])));
                        }
                        function PEc() {
                            PEc = geb;
                            OEc = ss((KEc(), cD(WC(zX, 1), jwe, 387, 0, [
                                HEc,
                                IEc,
                                JEc
                            ])));
                        }
                        function YEc() {
                            YEc = geb;
                            XEc = ss((TEc(), cD(WC(AX, 1), jwe, 349, 0, [
                                SEc,
                                QEc,
                                REc
                            ])));
                        }
                        function GEc() {
                            GEc = geb;
                            FEc = ss((BEc(), cD(WC(yX, 1), jwe, 463, 0, [
                                AEc,
                                yEc,
                                zEc
                            ])));
                        }
                        function qFc() {
                            qFc = geb;
                            pFc = ss((lFc(), cD(WC(CX, 1), jwe, 350, 0, [
                                iFc,
                                jFc,
                                kFc
                            ])));
                        }
                        function zFc() {
                            zFc = geb;
                            yFc = ss((uFc(), cD(WC(DX, 1), jwe, 352, 0, [
                                tFc,
                                rFc,
                                sFc
                            ])));
                        }
                        function IFc() {
                            IFc = geb;
                            HFc = ss((DFc(), cD(WC(EX, 1), jwe, 388, 0, [
                                BFc,
                                CFc,
                                AFc
                            ])));
                        }
                        function QZc() {
                            QZc = geb;
                            PZc = ss((LZc(), cD(WC(F_, 1), jwe, 392, 0, [
                                KZc,
                                JZc,
                                IZc
                            ])));
                        }
                        function m4c() {
                            m4c = geb;
                            l4c = ss((g4c(), cD(WC(I0, 1), jwe, 393, 0, [
                                d4c,
                                e4c,
                                f4c
                            ])));
                        }
                        function z5c() {
                            z5c = geb;
                            y5c = ss((t5c(), cD(WC(N0, 1), jwe, 300, 0, [
                                r5c,
                                s5c,
                                q5c
                            ])));
                        }
                        function k6c() {
                            k6c = geb;
                            j6c = ss((f6c(), cD(WC(V0, 1), jwe, 445, 0, [
                                c6c,
                                d6c,
                                e6c
                            ])));
                        }
                        function F6c() {
                            F6c = geb;
                            E6c = ss((z6c(), cD(WC(Z0, 1), jwe, 456, 0, [
                                w6c,
                                y6c,
                                x6c
                            ])));
                        }
                        function e7c() {
                            e7c = geb;
                            d7c = ss((_6c(), cD(WC(a1, 1), jwe, 394, 0, [
                                Z6c,
                                $6c,
                                Y6c
                            ])));
                        }
                        function j9c() {
                            j9c = geb;
                            i9c = ss((b9c(), cD(WC(o1, 1), jwe, 439, 0, [
                                $8c,
                                a9c,
                                _8c
                            ])));
                        }
                        function WKc() {
                            WKc = geb;
                            VKc = ss((RKc(), cD(WC(nY, 1), jwe, 464, 0, [
                                OKc,
                                PKc,
                                QKc
                            ])));
                        }
                        function JKb() {
                            JKb = geb;
                            IKb = ss((EKb(), cD(WC(MN, 1), jwe, 471, 0, [
                                CKb,
                                BKb,
                                DKb
                            ])));
                        }
                        function cKb() {
                            cKb = geb;
                            bKb = ss((ZJb(), cD(WC(JN, 1), jwe, 237, 0, [
                                WJb,
                                XJb,
                                YJb
                            ])));
                        }
                        function ALb() {
                            ALb = geb;
                            zLb = ss((vLb(), cD(WC(TN, 1), jwe, 472, 0, [
                                uLb,
                                tLb,
                                sLb
                            ])));
                        }
                        function CBb() {
                            CBb = geb;
                            BBb = ss((xBb(), cD(WC(QL, 1), jwe, 108, 0, [
                                uBb,
                                vBb,
                                wBb
                            ])));
                        }
                        function FWb() {
                            FWb = geb;
                            EWb = ss((AWb(), cD(WC(JP, 1), jwe, 391, 0, [
                                yWb,
                                xWb,
                                zWb
                            ])));
                        }
                        function Knd() {
                            Knd = geb;
                            Jnd = ss((Fnd(), cD(WC(y3, 1), jwe, 346, 0, [
                                Dnd,
                                Cnd,
                                End
                            ])));
                        }
                        function lbd() {
                            lbd = geb;
                            kbd = ss((gbd(), cD(WC(I1, 1), jwe, 444, 0, [
                                dbd,
                                ebd,
                                fbd
                            ])));
                        }
                        function Tmd() {
                            Tmd = geb;
                            Smd = ss((Omd(), cD(WC(t3, 1), jwe, 278, 0, [
                                Lmd,
                                Mmd,
                                Nmd
                            ])));
                        }
                        function rqd() {
                            rqd = geb;
                            qqd = ss((mqd(), cD(WC(J3, 1), jwe, 280, 0, [
                                kqd,
                                jqd,
                                lqd
                            ])));
                        }
                        function Hxd(a, b) {
                            return !a.o && (a.o = new DVd((pvd(), mvd), X4, a, 0)), QNd(a.o, b);
                        }
                        function HMb(a, b) {
                            var c;
                            if (a.C) {
                                c = RD(Vrb(a.b, b), 127).n;
                                c.d = a.C.d;
                                c.a = a.C.a;
                            }
                        }
                        function F8b(a) {
                            var b, c, d, e;
                            e = a.d;
                            b = a.a;
                            c = a.b;
                            d = a.c;
                            a.d = c;
                            a.a = d;
                            a.b = e;
                            a.c = b;
                        }
                        function cOd(a) {
                            !a.g && (a.g = new hQd);
                            !a.g.b && (a.g.b = new ePd(a));
                            return a.g.b;
                        }
                        function dOd(a) {
                            !a.g && (a.g = new hQd);
                            !a.g.c && (a.g.c = new IPd(a));
                            return a.g.c;
                        }
                        function lOd(a) {
                            !a.g && (a.g = new hQd);
                            !a.g.d && (a.g.d = new kPd(a));
                            return a.g.d;
                        }
                        function YNd(a) {
                            !a.g && (a.g = new hQd);
                            !a.g.a && (a.g.a = new qPd(a));
                            return a.g.a;
                        }
                        function B9d(a, b, c, d) {
                            !!c && (d = c.Rh(b, BYd(c.Dh(), a.c.uk()), null, d));
                            return d;
                        }
                        function C9d(a, b, c, d) {
                            !!c && (d = c.Th(b, BYd(c.Dh(), a.c.uk()), null, d));
                            return d;
                        }
                        function Cjb(a, b, c, d) {
                            var e;
                            e = $C(kE, Pwe, 28, b + 1, 15, 1);
                            Djb(e, a, b, c, d);
                            return e;
                        }
                        function $C(a, b, c, d, e, f) {
                            var g;
                            g = _C(e, d);
                            e != 10 && cD(WC(a, f), b, c, e, g);
                            return g;
                        }
                        function $fe(a, b, c) {
                            var d, e;
                            e = new Phe(b, a);
                            for(d = 0; d < c; ++d)Dhe(e);
                            return e;
                        }
                        function $Gd(a, b, c) {
                            var d, e;
                            if (c != null) for(d = 0; d < b; ++d){
                                e = c[d];
                                a.Qi(d, e);
                            }
                        }
                        function Yyb(a, b) {
                            var c;
                            c = new Gzb;
                            c.c = true;
                            c.d = b.md();
                            return Zyb(a, b.ld(), c);
                        }
                        function rB(a, b) {
                            var c;
                            c = a.q.getHours() + (b / 3600 | 0);
                            a.q.setSeconds(b);
                            mB(a, c);
                        }
                        function Ct(a, b) {
                            var c, d;
                            c = b;
                            d = Hob(cv(new Nu(a, c)));
                            Ar(new Nu(a, c));
                            return d;
                        }
                        function Kdc(a, b) {
                            b.Ug('Label management', 1);
                            fE(mQb(a, (rid(), qid)));
                            b.Vg();
                        }
                        function wge(a, b, c, d) {
                            vge(a, b, c, kge(a, b, d, ZD(b, 102) && (RD(b, 19).Bb & txe) != 0));
                        }
                        function BQb(a, b, c) {
                            RD(a.b, 68);
                            RD(a.b, 68);
                            RD(a.b, 68);
                            Umb(a.a, new KQb(c, b, a));
                        }
                        function AFb(a, b, c) {
                            if (a < 0 || b > c || b < a) throw Adb(new eib(_xe + a + bye + b + Qxe + c));
                        }
                        function NCb(a) {
                            if (!a) {
                                this.c = null;
                                this.b = new bnb;
                            } else {
                                this.c = a;
                                this.b = null;
                            }
                        }
                        function Fzb(a, b) {
                            xlb.call(this, a, b);
                            this.a = $C(vL, Zve, 447, 2, 0, 1);
                            this.b = true;
                        }
                        function hub(a) {
                            ckb.call(this, a, 0);
                            _tb(this);
                            this.d.b = this.d;
                            this.d.a = this.d;
                        }
                        function wtb(a) {
                            this.e = a;
                            this.b = this.e.a.entries();
                            this.a = $C(jJ, rve, 1, 0, 5, 1);
                        }
                        function _Fc() {
                            _Fc = geb;
                            $Fc = nfd(pfd(new ufd, (sXb(), nXb), (hcc(), Ebc)), rXb, $bc);
                        }
                        function xuc() {
                            tuc();
                            return cD(WC(eX, 1), jwe, 283, 0, [
                                ouc,
                                nuc,
                                quc,
                                puc,
                                suc,
                                ruc
                            ]);
                        }
                        function Ruc() {
                            Ouc();
                            return cD(WC(gX, 1), jwe, 281, 0, [
                                Luc,
                                Kuc,
                                Nuc,
                                Juc,
                                Muc,
                                Iuc
                            ]);
                        }
                        function bvc() {
                            $uc();
                            return cD(WC(hX, 1), jwe, 282, 0, [
                                Yuc,
                                Vuc,
                                Zuc,
                                Xuc,
                                Wuc,
                                Uuc
                            ]);
                        }
                        function etc() {
                            btc();
                            return cD(WC(ZW, 1), jwe, 232, 0, [
                                Zsc,
                                _sc,
                                Ysc,
                                $sc,
                                atc,
                                Xsc
                            ]);
                        }
                        function u3b() {
                            r3b();
                            return cD(WC(hR, 1), jwe, 273, 0, [
                                p3b,
                                o3b,
                                m3b,
                                q3b,
                                n3b,
                                l3b
                            ]);
                        }
                        function Uod() {
                            Pod();
                            return cD(WC(D3, 1), jwe, 279, 0, [
                                Nod,
                                Lod,
                                Mod,
                                Kod,
                                Jod,
                                Ood
                            ]);
                        }
                        function God() {
                            Bod();
                            return cD(WC(C3, 1), jwe, 101, 0, [
                                Aod,
                                zod,
                                yod,
                                vod,
                                xod,
                                wod
                            ]);
                        }
                        function lnd() {
                            ind();
                            return cD(WC(v3, 1), jwe, 321, 0, [
                                gnd,
                                end,
                                hnd,
                                cnd,
                                fnd,
                                dnd
                            ]);
                        }
                        function Ujd() {
                            Rjd();
                            return cD(WC(n3, 1), jwe, 255, 0, [
                                Ljd,
                                Ojd,
                                Pjd,
                                Qjd,
                                Mjd,
                                Njd
                            ]);
                        }
                        function xkd() {
                            ukd();
                            return cD(WC(q3, 1), jwe, 298, 0, [
                                tkd,
                                skd,
                                rkd,
                                pkd,
                                okd,
                                qkd
                            ]);
                        }
                        function K3d(a) {
                            var b;
                            if (!a.a && a.b != -1) {
                                b = a.c.Dh();
                                a.a = vYd(b, a.b);
                            }
                            return a.a;
                        }
                        function WGd(a, b) {
                            if (a.Si() && a.Hc(b)) return false;
                            else {
                                a.Hi(b);
                                return true;
                            }
                        }
                        function RKb(a, b) {
                            Ivb(b, 'Horizontal alignment cannot be null');
                            a.b = b;
                            return a;
                        }
                        function ite(a, b, c) {
                            Vse();
                            var d;
                            d = hte(a, b);
                            c && !!d && kte(a) && (d = null);
                            return d;
                        }
                        function ZKc(a, b, c) {
                            var d;
                            d = a.b[c.c.p][c.p];
                            d.b += b.b;
                            d.c += b.c;
                            d.a += b.a;
                            ++d.a;
                        }
                        function Umc(a, b, c) {
                            var d;
                            a.d[b.g] = c;
                            d = a.g.c;
                            d[b.g] = $wnd.Math.max(d[b.g], c + 1);
                        }
                        function bjd(a, b) {
                            var c, d;
                            c = a.a - b.a;
                            d = a.b - b.b;
                            return $wnd.Math.sqrt(c * c + d * d);
                        }
                        function v$b(a, b) {
                            var c, d;
                            for(d = b.Kc(); d.Ob();){
                                c = RD(d.Pb(), 36);
                                u$b(a, c, 0, 0);
                            }
                        }
                        function x$b(a, b, c) {
                            var d, e;
                            for(e = a.Kc(); e.Ob();){
                                d = RD(e.Pb(), 36);
                                w$b(d, b, c);
                            }
                        }
                        function G0c(a) {
                            var b, c;
                            for(c = Sub(a.a, 0); c.b != c.d.c;){
                                b = RD(evb(c), 65);
                                H0c(b);
                            }
                        }
                        function nnc(a, b) {
                            bub(a.e, b) || dub(a.e, b, new tnc(b));
                            return RD(cub(a.e, b), 113);
                        }
                        function tBb(a, b, c, d) {
                            uFb(a);
                            uFb(b);
                            uFb(c);
                            uFb(d);
                            return new DBb(a, b, new NAb);
                        }
                        function DVd(a, b, c, d) {
                            this.ak();
                            this.a = b;
                            this.b = a;
                            this.c = new wje(this, b, c, d);
                        }
                        function O3d(a, b, c, d, e, f) {
                            MKd.call(this, b, d, e, f);
                            J3d(this);
                            this.c = a;
                            this.b = c;
                        }
                        function c4d(a, b, c, d, e, f) {
                            MKd.call(this, b, d, e, f);
                            J3d(this);
                            this.c = a;
                            this.a = c;
                        }
                        function Q9c(a, b) {
                            var c, d, e;
                            e = a.r;
                            d = a.d;
                            c = S9c(a, b, true);
                            return c.b != e || c.a != d;
                        }
                        function Vee(a, b, c) {
                            var d, e;
                            e = (d = N5d(a.b, b), d);
                            return !e ? null : tfe(Pee(a, e), c);
                        }
                        function _Dd(a, b, c) {
                            var d, e, f;
                            d = qC(a, c);
                            e = null;
                            !!d && (e = ADd(d));
                            f = e;
                            tEd(b, c, f);
                        }
                        function aEd(a, b, c) {
                            var d, e, f;
                            d = qC(a, c);
                            e = null;
                            !!d && (e = ADd(d));
                            f = e;
                            tEd(b, c, f);
                        }
                        function Evd(a, b) {
                            var c;
                            return c = a.Ih(b), c >= 0 ? a.Lh(c, true, true) : Qvd(a, b, true);
                        }
                        function gMc(a, b, c) {
                            var d;
                            d = qMc(a, b, c);
                            a.b = new _Lc(d.c.length);
                            return iMc(a, d);
                        }
                        function Pue(a) {
                            if (a.b <= 0) throw Adb(new Dvb);
                            --a.b;
                            a.a -= a.c.c;
                            return sgb(a.a);
                        }
                        function PGd(a) {
                            var b;
                            if (!a.a) throw Adb(new Evb);
                            b = a.a;
                            a.a = vCd(a.a);
                            return b;
                        }
                        function WDb(a) {
                            while(!a.a){
                                if (!yEb(a.c, new $Db(a))) return false;
                            }
                            return true;
                        }
                        function Nr(a) {
                            var b;
                            Qb(a);
                            if (ZD(a, 204)) {
                                b = RD(a, 204);
                                return b;
                            }
                            return new Or(a);
                        }
                        function Cfd(a) {
                            Afd();
                            RD(a.of((umd(), Lld)), 181).Fc((Pod(), Mod));
                            a.qf(Kld, null);
                        }
                        function Afd() {
                            Afd = geb;
                            xfd = new Gfd;
                            zfd = new Ifd;
                            yfd = yn((umd(), Kld), xfd, pld, zfd);
                        }
                        function Y3c() {
                            Y3c = geb;
                            W3c = new $3c('LEAF_NUMBER', 0);
                            X3c = new $3c('NODE_SIZE', 1);
                        }
                        function YLc(a) {
                            a.a = $C(kE, Pwe, 28, a.b + 1, 15, 1);
                            a.c = $C(kE, Pwe, 28, a.b, 15, 1);
                            a.d = 0;
                        }
                        function OZb(a, b) {
                            if (a.a.Ne(b.d, a.b) > 0) {
                                Rmb(a.c, new fZb(b.c, b.d, a.d));
                                a.b = b.d;
                            }
                        }
                        function NHd(a, b) {
                            if (a.g == null || b >= a.i) throw Adb(new yNd(b, a.i));
                            return a.g[b];
                        }
                        function P_d(a, b, c) {
                            gHd(a, c);
                            if (c != null && !a.fk(c)) throw Adb(new yeb);
                            return c;
                        }
                        function dD(a, b) {
                            XC(b) != 10 && cD(rb(b), b.Sm, b.__elementTypeId$, XC(b), a);
                            return a;
                        }
                        function Wnb(a, b, c, d) {
                            var e;
                            d = (urb(), !d ? rrb : d);
                            e = a.slice(b, c);
                            Xnb(e, a, b, c, -b, d);
                        }
                        function zvd(a, b, c, d, e) {
                            return b < 0 ? Qvd(a, c, d) : RD(c, 69).wk().yk(a, a.hi(), b, d, e);
                        }
                        function J9b(a, b) {
                            return Qfb(Kfb(UD(mQb(a, (Ywc(), Jwc)))), Kfb(UD(mQb(b, Jwc))));
                        }
                        function qAb() {
                            qAb = geb;
                            pAb = ss((cAb(), cD(WC(AL, 1), jwe, 304, 0, [
                                $zb,
                                _zb,
                                aAb,
                                bAb
                            ])));
                        }
                        function cAb() {
                            cAb = geb;
                            $zb = new dAb('All', 0);
                            _zb = new iAb;
                            aAb = new kAb;
                            bAb = new nAb;
                        }
                        function EKb() {
                            EKb = geb;
                            CKb = new FKb(Nye, 0);
                            BKb = new FKb(Kye, 1);
                            DKb = new FKb(Oye, 2);
                        }
                        function Zme() {
                            Zme = geb;
                            qAd();
                            Wme = oxe;
                            Vme = pxe;
                            Yme = new Tfb(oxe);
                            Xme = new Tfb(pxe);
                        }
                        function rOb() {
                            rOb = geb;
                            qOb = ss((mOb(), cD(WC(hO, 1), jwe, 417, 0, [
                                lOb,
                                iOb,
                                jOb,
                                kOb
                            ])));
                        }
                        function NRb() {
                            NRb = geb;
                            MRb = ss((IRb(), cD(WC(WO, 1), jwe, 406, 0, [
                                FRb,
                                ERb,
                                GRb,
                                HRb
                            ])));
                        }
                        function NPb() {
                            NPb = geb;
                            MPb = ss((IPb(), cD(WC(DO, 1), jwe, 332, 0, [
                                FPb,
                                EPb,
                                GPb,
                                HPb
                            ])));
                        }
                        function Z$b() {
                            Z$b = geb;
                            Y$b = ss((U$b(), cD(WC(CQ, 1), jwe, 389, 0, [
                                T$b,
                                R$b,
                                Q$b,
                                S$b
                            ])));
                        }
                        function wZb() {
                            wZb = geb;
                            vZb = ss((nZb(), cD(WC(lQ, 1), jwe, 416, 0, [
                                jZb,
                                mZb,
                                kZb,
                                lZb
                            ])));
                        }
                        function jnc() {
                            jnc = geb;
                            inc = ss((enc(), cD(WC(LV, 1), jwe, 421, 0, [
                                anc,
                                bnc,
                                cnc,
                                dnc
                            ])));
                        }
                        function Bec() {
                            Bec = geb;
                            Aec = ss((vec(), cD(WC(qT, 1), jwe, 371, 0, [
                                uec,
                                sec,
                                tec,
                                rec
                            ])));
                        }
                        function DDc() {
                            DDc = geb;
                            CDc = ss((wDc(), cD(WC(tX, 1), jwe, 203, 0, [
                                uDc,
                                vDc,
                                tDc,
                                sDc
                            ])));
                        }
                        function pEc() {
                            pEc = geb;
                            oEc = ss((kEc(), cD(WC(wX, 1), jwe, 284, 0, [
                                hEc,
                                gEc,
                                iEc,
                                jEc
                            ])));
                        }
                        function Cuc() {
                            Cuc = geb;
                            Buc = new Duc(LAe, 0);
                            Auc = new Duc('IMPROVE_STRAIGHTNESS', 1);
                        }
                        function _i(a, b) {
                            var c, d;
                            d = b / a.c.Rd().gc() | 0;
                            c = b % a.c.Rd().gc();
                            return Ui(a, d, c);
                        }
                        function iZd(a) {
                            var b;
                            if (a.nl()) for(b = a.i - 1; b >= 0; --b)QHd(a, b);
                            return WHd(a);
                        }
                        function Nyb(a) {
                            var b, c;
                            if (!a.b) return null;
                            c = a.b;
                            while(b = c.a[0])c = b;
                            return c;
                        }
                        function Oyb(a) {
                            var b, c;
                            if (!a.b) return null;
                            c = a.b;
                            while(b = c.a[1])c = b;
                            return c;
                        }
                        function Hae(a) {
                            if (ZD(a, 180)) return '' + RD(a, 180).a;
                            return a == null ? null : jeb(a);
                        }
                        function Iae(a) {
                            if (ZD(a, 180)) return '' + RD(a, 180).a;
                            return a == null ? null : jeb(a);
                        }
                        function eGb(a, b) {
                            if (b.a) throw Adb(new yz(jye));
                            Ysb(a.a, b);
                            b.a = a;
                            !a.j && (a.j = b);
                        }
                        function hEb(a, b) {
                            xxb.call(this, b.zd(), b.yd() & -16449);
                            uFb(a);
                            this.a = a;
                            this.c = b;
                        }
                        function zXc(a, b) {
                            return new gud(b, Zid(ajd(b.e), b.f.a + a, b.f.b + a), (Geb(), false));
                        }
                        function EMc(a, b) {
                            dMc();
                            return Rmb(a, new Ptd(b, sgb(b.e.c.length + b.g.c.length)));
                        }
                        function GMc(a, b) {
                            dMc();
                            return Rmb(a, new Ptd(b, sgb(b.e.c.length + b.g.c.length)));
                        }
                        function p5c() {
                            p5c = geb;
                            o5c = ss((j5c(), cD(WC(M0, 1), jwe, 354, 0, [
                                i5c,
                                g5c,
                                h5c,
                                f5c
                            ])));
                        }
                        function x_c() {
                            x_c = geb;
                            w_c = ss((s_c(), cD(WC(J_, 1), jwe, 353, 0, [
                                r_c,
                                p_c,
                                q_c,
                                o_c
                            ])));
                        }
                        function eWc() {
                            eWc = geb;
                            dWc = ss((YVc(), cD(WC(H$, 1), jwe, 405, 0, [
                                UVc,
                                VVc,
                                WVc,
                                XVc
                            ])));
                        }
                        function bnd() {
                            bnd = geb;
                            and = ss((Ymd(), cD(WC(u3, 1), jwe, 223, 0, [
                                Xmd,
                                Vmd,
                                Umd,
                                Wmd
                            ])));
                        }
                        function Vnd() {
                            Vnd = geb;
                            Und = ss((Pnd(), cD(WC(z3, 1), jwe, 291, 0, [
                                Ond,
                                Lnd,
                                Mnd,
                                Nnd
                            ])));
                        }
                        function Vpd() {
                            Vpd = geb;
                            Upd = ss((Qpd(), cD(WC(H3, 1), jwe, 386, 0, [
                                Opd,
                                Ppd,
                                Npd,
                                Mpd
                            ])));
                        }
                        function Lrd() {
                            Lrd = geb;
                            Krd = ss((Grd(), cD(WC(R3, 1), jwe, 320, 0, [
                                Frd,
                                Crd,
                                Erd,
                                Drd
                            ])));
                        }
                        function ytd() {
                            ytd = geb;
                            xtd = ss((ttd(), cD(WC(n4, 1), jwe, 415, 0, [
                                qtd,
                                rtd,
                                ptd,
                                std
                            ])));
                        }
                        function b9c() {
                            b9c = geb;
                            $8c = new d9c(iFe, 0);
                            a9c = new d9c(mEe, 1);
                            _8c = new d9c(LAe, 2);
                        }
                        function sBb(a, b, c, d, e) {
                            uFb(a);
                            uFb(b);
                            uFb(c);
                            uFb(d);
                            uFb(e);
                            return new DBb(a, b, d);
                        }
                        function fub(a, b) {
                            var c;
                            c = RD(_jb(a.e, b), 400);
                            if (c) {
                                rub(c);
                                return c.e;
                            }
                            return null;
                        }
                        function Ymb(a, b) {
                            var c;
                            c = Wmb(a, b, 0);
                            if (c == -1) return false;
                            Xmb(a, c);
                            return true;
                        }
                        function LDb(a, b, c) {
                            var d;
                            LCb(a);
                            d = new IEb;
                            d.a = b;
                            a.a.Nb(new QEb(d, c));
                            return d.a;
                        }
                        function VCb(a) {
                            var b;
                            LCb(a);
                            b = $C(iE, vxe, 28, 0, 15, 1);
                            ixb(a.a, new dDb(b));
                            return b;
                        }
                        function yc(a) {
                            var b;
                            if (!xc(a)) throw Adb(new Dvb);
                            a.e = 1;
                            b = a.d;
                            a.d = null;
                            return b;
                        }
                        function Odb(a) {
                            var b;
                            if (Kdb(a)) {
                                b = 0 - a;
                                if (!isNaN(b)) return b;
                            }
                            return Edb(xD(a));
                        }
                        function Wmb(a, b, c) {
                            for(; c < a.c.length; ++c){
                                if (Fvb(b, a.c[c])) return c;
                            }
                            return -1;
                        }
                        function Gmc(a) {
                            var b, c;
                            c = RD(Vmb(a.j, 0), 12);
                            b = RD(mQb(c, (Ywc(), Awc)), 12);
                            return b;
                        }
                        function Nu(a, b) {
                            var c;
                            this.f = a;
                            this.b = b;
                            c = RD(Wjb(a.b, b), 260);
                            this.c = !c ? null : c.b;
                        }
                        function Ckc() {
                            lkc();
                            this.b = new Tsb;
                            this.f = new Tsb;
                            this.g = new Tsb;
                            this.e = new Tsb;
                        }
                        function RSd(a) {
                            ez(this);
                            this.g = !a ? null : lz(a, a.ie());
                            this.f = a;
                            gz(this);
                            this.je();
                        }
                        function pKd(a) {
                            var b;
                            b = a.jj();
                            b != null && a.d != -1 && RD(b, 94).xh(a);
                            !!a.i && a.i.oj();
                        }
                        function asc(a) {
                            var b;
                            for(b = a.p + 1; b < a.c.a.c.length; ++b)--RD(Vmb(a.c.a, b), 10).p;
                        }
                        function ukb(a) {
                            yFb(!!a.c);
                            rFb(a.f.g, a.d);
                            a.c.Qb();
                            a.c = null;
                            a.b = skb(a);
                            a.d = a.f.g;
                        }
                        function o4d(a) {
                            if (!a.b) {
                                a.b = new s5d(a, o7, a);
                                !a.a && (a.a = new F4d(a, a));
                            }
                            return a.b;
                        }
                        function Pee(a, b) {
                            var c, d;
                            c = RD(b, 690);
                            d = c.xi();
                            !d && c.Ai(d = new wfe(a, b));
                            return d;
                        }
                        function Qee(a, b) {
                            var c, d;
                            c = RD(b, 692);
                            d = c.$k();
                            !d && c.cl(d = new Jfe(a, b));
                            return d;
                        }
                        function _jc(a, b) {
                            Wjc();
                            var c, d;
                            c = $jc(a);
                            d = $jc(b);
                            return !!c && !!d && !Aob(c.k, d.k);
                        }
                        function WFb(a, b) {
                            return Fvb(b, Vmb(a.f, 0)) || Fvb(b, Vmb(a.f, 1)) || Fvb(b, Vmb(a.f, 2));
                        }
                        function Med(a, b) {
                            if (b < 0) throw Adb(new veb(zGe + b));
                            Led(a, b + 1);
                            return Vmb(a.j, b);
                        }
                        function Ob(a, b, c, d) {
                            if (!a) throw Adb(new agb(hc(b, cD(WC(jJ, 1), rve, 1, 5, [
                                c,
                                d
                            ]))));
                        }
                        function P3d(a, b, c, d, e, f, g) {
                            NKd.call(this, b, d, e, f, g);
                            J3d(this);
                            this.c = a;
                            this.b = c;
                        }
                        function UA(a, b, c) {
                            var d, e;
                            d = 10;
                            for(e = 0; e < c - 1; e++){
                                b < d && (a.a += '0', a);
                                d *= 10;
                            }
                            a.a += b;
                        }
                        function Ahb(a) {
                            var b, c;
                            c = a.length;
                            b = $C(hE, zwe, 28, c, 15, 1);
                            nhb(a, 0, c, b, 0);
                            return b;
                        }
                        function $eb(a) {
                            Zeb();
                            var b, c;
                            b = a + 128;
                            c = Yeb[b];
                            !c && (c = Yeb[b] = new Seb(a));
                            return c;
                        }
                        function Cub(a) {
                            rFb(a.d.a.e.g, a.b);
                            sFb(a.c != a.d.a.d);
                            a.a = a.c;
                            a.c = a.c.a;
                            return a.a;
                        }
                        function mDc(a) {
                            switch(a.g){
                                case 0:
                                    return lve;
                                case 1:
                                    return -1;
                                default:
                                    return 0;
                            }
                        }
                        function ED(a) {
                            if (uD(a, (MD(), LD)) < 0) return -qD(xD(a));
                            return a.l + a.m * gxe + a.h * hxe;
                        }
                        function etd(a) {
                            (!this.q ? (yob(), yob(), wob) : this.q).Ac(!a.q ? (yob(), yob(), wob) : a.q);
                        }
                        function Eud(a, b) {
                            Cod(RD(RD(a.f, 27).of((umd(), Hld)), 101)) && lQd(wCd(RD(a.f, 27)), b);
                        }
                        function Gvd(a, b) {
                            var c;
                            c = BYd(a.d, b);
                            return c >= 0 ? Dvd(a, c, true, true) : Qvd(a, b, true);
                        }
                        function Vwd(a) {
                            var b;
                            b = SD(Ywd(a, 32));
                            if (b == null) {
                                Wwd(a);
                                b = SD(Ywd(a, 32));
                            }
                            return b;
                        }
                        function Yvd(a) {
                            var b;
                            if (!a.Oh()) {
                                b = AYd(a.Dh()) - a.ji();
                                a.$h().Mk(b);
                            }
                            return a.zh();
                        }
                        function zQb(a, b) {
                            yQb = new kRb;
                            wQb = b;
                            xQb = a;
                            RD(xQb.b, 68);
                            BQb(xQb, yQb, null);
                            AQb(xQb);
                        }
                        function AWb() {
                            AWb = geb;
                            yWb = new BWb('XY', 0);
                            xWb = new BWb('X', 1);
                            zWb = new BWb('Y', 2);
                        }
                        function vLb() {
                            vLb = geb;
                            uLb = new wLb('TOP', 0);
                            tLb = new wLb(Kye, 1);
                            sLb = new wLb(Qye, 2);
                        }
                        function Gvc() {
                            Gvc = geb;
                            Evc = new Hvc(LAe, 0);
                            Fvc = new Hvc('TOP', 1);
                            Dvc = new Hvc(Qye, 2);
                        }
                        function sEc() {
                            sEc = geb;
                            qEc = new tEc('INPUT_ORDER', 0);
                            rEc = new tEc('PORT_DEGREE', 1);
                        }
                        function MD() {
                            MD = geb;
                            ID = hD(dxe, dxe, 524287);
                            JD = hD(0, 0, fxe);
                            KD = fD(1);
                            fD(2);
                            LD = fD(0);
                        }
                        function wWd(a) {
                            var b;
                            if (a.d != a.r) {
                                b = WVd(a);
                                a.e = !!b && b.lk() == aKe;
                                a.d = b;
                            }
                            return a.e;
                        }
                        function UHd(a, b, c) {
                            var d;
                            d = a.g[b];
                            MHd(a, b, a.Zi(b, c));
                            a.Ri(b, c, d);
                            a.Ni();
                            return d;
                        }
                        function dHd(a, b) {
                            var c;
                            c = a.dd(b);
                            if (c >= 0) {
                                a.gd(c);
                                return true;
                            } else return false;
                        }
                        function xr(a, b) {
                            var c;
                            Qb(a);
                            Qb(b);
                            c = false;
                            while(b.Ob())c = c | a.Fc(b.Pb());
                            return c;
                        }
                        function cub(a, b) {
                            var c;
                            c = RD(Wjb(a.e, b), 400);
                            if (c) {
                                eub(a, c);
                                return c.e;
                            }
                            return null;
                        }
                        function iB(a) {
                            var b, c;
                            b = a / 60 | 0;
                            c = a % 60;
                            if (c == 0) return '' + b;
                            return '' + b + ':' + ('' + c);
                        }
                        function JB(d, a) {
                            var b = d.a[a];
                            var c = (HC(), GC)[typeof b];
                            return c ? c(b) : NC(typeof b);
                        }
                        function EDb(a, b) {
                            var c, d;
                            MCb(a);
                            d = new zEb(b, a.a);
                            c = new YDb(d);
                            return new SDb(a, c);
                        }
                        function mwb(a) {
                            var b;
                            b = a.b.c.length == 0 ? null : Vmb(a.b, 0);
                            b != null && owb(a, 0);
                            return b;
                        }
                        function ukc(a, b) {
                            var c, d, e;
                            e = b.c.i;
                            c = RD(Wjb(a.f, e), 60);
                            d = c.d.c - c.e.c;
                            Bjd(b.a, d, 0);
                        }
                        function XLc(a, b) {
                            var c;
                            ++a.d;
                            ++a.c[b];
                            c = b + 1;
                            while(c < a.a.length){
                                ++a.a[c];
                                c += c & -c;
                            }
                        }
                        function Ute(a, b, c, d) {
                            Vse();
                            Wse.call(this, 26);
                            this.c = a;
                            this.a = b;
                            this.d = c;
                            this.b = d;
                        }
                        function KA(a, b) {
                            while(b[0] < a.length && qhb(' \t\r\n', Fhb(ihb(a, b[0]))) >= 0)++b[0];
                        }
                        function eEd(a, b) {
                            Dyd(a, b == null || Rfb((uFb(b), b)) || isNaN((uFb(b), b)) ? 0 : (uFb(b), b));
                        }
                        function fEd(a, b) {
                            Eyd(a, b == null || Rfb((uFb(b), b)) || isNaN((uFb(b), b)) ? 0 : (uFb(b), b));
                        }
                        function gEd(a, b) {
                            Cyd(a, b == null || Rfb((uFb(b), b)) || isNaN((uFb(b), b)) ? 0 : (uFb(b), b));
                        }
                        function hEd(a, b) {
                            Ayd(a, b == null || Rfb((uFb(b), b)) || isNaN((uFb(b), b)) ? 0 : (uFb(b), b));
                        }
                        function oWc(a, b, c) {
                            return cjd(new rjd(c.e.a + c.f.a / 2, c.e.b + c.f.b / 2), a) == (uFb(b), b);
                        }
                        function qge(a, b) {
                            return ZD(b, 102) && (RD(b, 19).Bb & txe) != 0 ? new She(b, a) : new Phe(b, a);
                        }
                        function sge(a, b) {
                            return ZD(b, 102) && (RD(b, 19).Bb & txe) != 0 ? new She(b, a) : new Phe(b, a);
                        }
                        function XC(a) {
                            return a.__elementTypeCategory$ == null ? 10 : a.__elementTypeCategory$;
                        }
                        function Bhb(a, b) {
                            return b == (wvb(), wvb(), vvb) ? a.toLocaleLowerCase() : a.toLowerCase();
                        }
                        function Mu(a) {
                            if (!a.e) throw Adb(new Dvb);
                            a.c = a.a = a.e;
                            a.e = a.e.e;
                            --a.d;
                            return a.a.f;
                        }
                        function Lu(a) {
                            if (!a.c) throw Adb(new Dvb);
                            a.e = a.a = a.c;
                            a.c = a.c.c;
                            ++a.d;
                            return a.a.f;
                        }
                        function Lsb(a) {
                            var b;
                            ++a.a;
                            for(b = a.c.a.length; a.a < b; ++a.a){
                                if (a.c.b[a.a]) return;
                            }
                        }
                        function _z(a) {
                            var b, c;
                            if (a.a) {
                                c = null;
                                do {
                                    b = a.a;
                                    a.a = null;
                                    c = dA(b, c);
                                }while (a.a);
                                a.a = c;
                            }
                        }
                        function aA(a) {
                            var b, c;
                            if (a.b) {
                                c = null;
                                do {
                                    b = a.b;
                                    a.b = null;
                                    c = dA(b, c);
                                }while (a.b);
                                a.b = c;
                            }
                        }
                        function eve(a, b) {
                            var c;
                            c = 0;
                            while(a.e != a.i.gc()){
                                oFd(b, bMd(a), sgb(c));
                                c != lve && ++c;
                            }
                        }
                        function Llc(a, b) {
                            var c;
                            c = $y(a.e.c, b.e.c);
                            if (c == 0) return Qfb(a.e.d, b.e.d);
                            return c;
                        }
                        function hdc(a, b) {
                            var c, d;
                            d = b.c;
                            for(c = d + 1; c <= b.f; c++)a.a[c] > a.a[d] && (d = c);
                            return d;
                        }
                        function Krc(a) {
                            var b;
                            b = RD(mQb(a, (Ywc(), Wvc)), 313);
                            if (b) return b.a == a;
                            return false;
                        }
                        function Lrc(a) {
                            var b;
                            b = RD(mQb(a, (Ywc(), Wvc)), 313);
                            if (b) return b.i == a;
                            return false;
                        }
                        function xXb() {
                            xXb = geb;
                            wXb = ss((sXb(), cD(WC(UP, 1), jwe, 367, 0, [
                                nXb,
                                oXb,
                                pXb,
                                qXb,
                                rXb
                            ])));
                        }
                        function Hnc() {
                            Hnc = geb;
                            Gnc = ss((Bnc(), cD(WC(TV, 1), jwe, 375, 0, [
                                xnc,
                                znc,
                                Anc,
                                ync,
                                wnc
                            ])));
                        }
                        function Xtc() {
                            Xtc = geb;
                            Wtc = ss((Ptc(), cD(WC(bX, 1), jwe, 348, 0, [
                                Ltc,
                                Ktc,
                                Ntc,
                                Otc,
                                Mtc
                            ])));
                        }
                        function RDc() {
                            RDc = geb;
                            QDc = ss((JDc(), cD(WC(uX, 1), jwe, 323, 0, [
                                IDc,
                                FDc,
                                GDc,
                                EDc,
                                HDc
                            ])));
                        }
                        function hxc() {
                            hxc = geb;
                            gxc = ss((cxc(), cD(WC(mX, 1), jwe, 171, 0, [
                                bxc,
                                Zwc,
                                $wc,
                                _wc,
                                axc
                            ])));
                        }
                        function m3c() {
                            m3c = geb;
                            l3c = ss((g3c(), cD(WC(x0, 1), jwe, 368, 0, [
                                e3c,
                                b3c,
                                f3c,
                                c3c,
                                d3c
                            ])));
                        }
                        function xad() {
                            xad = geb;
                            wad = ss((sad(), cD(WC(x1, 1), jwe, 373, 0, [
                                oad,
                                nad,
                                qad,
                                pad,
                                rad
                            ])));
                        }
                        function acd() {
                            acd = geb;
                            _bd = ss((Xbd(), cD(WC(P1, 1), jwe, 324, 0, [
                                Sbd,
                                Tbd,
                                Wbd,
                                Ubd,
                                Vbd
                            ])));
                        }
                        function Kmd() {
                            Kmd = geb;
                            Jmd = ss((Cmd(), cD(WC(s3, 1), jwe, 88, 0, [
                                Amd,
                                zmd,
                                ymd,
                                xmd,
                                Bmd
                            ])));
                        }
                        function bid() {
                            bid = geb;
                            aid = ss((Yhd(), cD(WC(d3, 1), jwe, 170, 0, [
                                Whd,
                                Vhd,
                                Thd,
                                Xhd,
                                Uhd
                            ])));
                        }
                        function uod() {
                            uod = geb;
                            tod = ss((pod(), cD(WC(B3, 1), jwe, 256, 0, [
                                mod,
                                ood,
                                kod,
                                lod,
                                nod
                            ])));
                        }
                        function zpd() {
                            zpd = geb;
                            ypd = ss((qpd(), cD(WC(E3, 1), NAe, 64, 0, [
                                opd,
                                Yod,
                                Xod,
                                npd,
                                ppd
                            ])));
                        }
                        function LHb() {
                            LHb = geb;
                            JHb = new MHb('BY_SIZE', 0);
                            KHb = new MHb('BY_SIZE_AND_SHAPE', 1);
                        }
                        function TUb() {
                            TUb = geb;
                            RUb = new UUb('EADES', 0);
                            SUb = new UUb('FRUCHTERMAN_REINGOLD', 1);
                        }
                        function $tc() {
                            $tc = geb;
                            Ytc = new _tc('READING_DIRECTION', 0);
                            Ztc = new _tc('ROTATION', 1);
                        }
                        function CZb() {
                            CZb = geb;
                            zZb = new ZZb;
                            AZb = new b$b;
                            xZb = new f$b;
                            yZb = new j$b;
                            BZb = new n$b;
                        }
                        function dGb(a) {
                            this.b = new bnb;
                            this.a = new bnb;
                            this.c = new bnb;
                            this.d = new bnb;
                            this.e = a;
                        }
                        function XZb(a) {
                            this.g = a;
                            this.f = new bnb;
                            this.a = $wnd.Math.min(this.g.c.c, this.g.d.c);
                        }
                        function UKb(a, b, c) {
                            RJb.call(this);
                            KKb(this);
                            this.a = a;
                            this.c = c;
                            this.b = b.d;
                            this.f = b.e;
                        }
                        function d6b(a, b, c) {
                            var d, e;
                            for(e = new Anb(c); e.a < e.c.c.length;){
                                d = ynb(e);
                                c6b(a, b, d);
                            }
                        }
                        function sC(a, b, c) {
                            var d;
                            if (b == null) throw Adb(new Ngb);
                            d = qC(a, b);
                            tC(a, b, c);
                            return d;
                        }
                        function ked(a, b) {
                            var c;
                            c = RD(Wjb(a.a, b), 137);
                            if (!c) {
                                c = new qQb;
                                Zjb(a.a, b, c);
                            }
                            return c;
                        }
                        function vYd(a, b) {
                            var c;
                            c = (a.i == null && rYd(a), a.i);
                            return b >= 0 && b < c.length ? c[b] : null;
                        }
                        function Gqd(a, b) {
                            var c;
                            c = b > 0 ? b - 1 : b;
                            return Kqd(Lqd(Mqd(Nqd(new Oqd, c), a.n), a.j), a.k);
                        }
                        function nBd(a) {
                            var b, c;
                            c = (b = new q4d, b);
                            WGd((!a.q && (a.q = new C5d(s7, a, 11, 10)), a.q), c);
                        }
                        function ofb(a) {
                            return ((a.i & 2) != 0 ? 'interface ' : (a.i & 1) != 0 ? '' : 'class ') + (lfb(a), a.o);
                        }
                        function dz(a) {
                            if (Ddb(a, lve) > 0) return lve;
                            if (Ddb(a, qwe) < 0) return qwe;
                            return Ydb(a);
                        }
                        function Sv(a) {
                            if (a < 3) {
                                dk(a, fwe);
                                return a + 1;
                            }
                            if (a < hwe) return eE(a / 0.75 + 1);
                            return lve;
                        }
                        function Rwb(a, b) {
                            uFb(b);
                            Qwb(a);
                            if (a.d.Ob()) {
                                b.Cd(a.d.Pb());
                                return true;
                            }
                            return false;
                        }
                        function ke(a, b) {
                            var c, d;
                            c = RD(Xv(a.d, b), 16);
                            if (!c) return null;
                            d = b;
                            return a.e.pc(d, c);
                        }
                        function Ufe(a, b, c, d) {
                            var e;
                            a.j = -1;
                            oLd(a, gge(a, b, c), (nke(), e = RD(b, 69).vk(), e.xl(d)));
                        }
                        function Z_c(a, b) {
                            R_c();
                            return -hgb(RD(mQb(a, (h_c(), W$c)), 17).a, RD(mQb(b, W$c), 17).a);
                        }
                        function xo(a, b) {
                            return !!Ho(a, b, Ydb(Ndb(cwe, qgb(Ydb(Ndb(b == null ? 0 : tb(b), dwe)), 15))));
                        }
                        function dGd() {
                            aGd();
                            return cD(WC(T5, 1), jwe, 245, 0, [
                                _Fd,
                                YFd,
                                ZFd,
                                XFd,
                                $Fd,
                                VFd,
                                UFd,
                                WFd
                            ]);
                        }
                        function nid() {
                            kid();
                            return cD(WC(e3, 1), jwe, 285, 0, [
                                jid,
                                cid,
                                gid,
                                iid,
                                did,
                                eid,
                                fid,
                                hid
                            ]);
                        }
                        function hpc() {
                            epc();
                            return cD(WC(hW, 1), jwe, 276, 0, [
                                Zoc,
                                apc,
                                Yoc,
                                dpc,
                                _oc,
                                $oc,
                                cpc,
                                bpc
                            ]);
                        }
                        function Kcc(a) {
                            var b;
                            b = Kfb(UD(mQb(a, (yCc(), FAc))));
                            if (b < 0) {
                                b = 0;
                                pQb(a, FAc, b);
                            }
                            return b;
                        }
                        function Odc(a, b) {
                            var c, d;
                            for(d = a.Kc(); d.Ob();){
                                c = RD(d.Pb(), 72);
                                pQb(c, (Ywc(), swc), b);
                            }
                        }
                        function Oic(a, b, c) {
                            var d;
                            d = $wnd.Math.max(0, a.b / 2 - 0.5);
                            Iic(c, d, 1);
                            Rmb(b, new Xic(c, d));
                        }
                        function lRc(a, b, c) {
                            var d;
                            d = a.a.e[RD(b.a, 10).p] - a.a.e[RD(c.a, 10).p];
                            return eE(Lgb(d));
                        }
                        function PDb(a, b) {
                            var c;
                            MCb(a);
                            c = new cEb(a, a.a.zd(), a.a.yd() | 4, b);
                            return new SDb(a, c);
                        }
                        function gvb(a) {
                            var b;
                            yFb(!!a.c);
                            b = a.c.a;
                            Wub(a.d, a.c);
                            a.b == a.c ? a.b = b : --a.a;
                            a.c = null;
                        }
                        function iqc(a) {
                            a.a >= -0.01 && a.a <= Tye && (a.a = 0);
                            a.b >= -0.01 && a.b <= Tye && (a.b = 0);
                            return a;
                        }
                        function Hid(a) {
                            tid();
                            var b, c;
                            c = KEe;
                            for(b = 0; b < a.length; b++)a[b] > c && (c = a[b]);
                            return c;
                        }
                        function Zvd(a, b) {
                            var c;
                            c = wYd(a.Dh(), b);
                            if (!c) throw Adb(new agb(KHe + b + NHe));
                            return c;
                        }
                        function NGd(a, b) {
                            var c;
                            c = a;
                            while(vCd(c)){
                                c = vCd(c);
                                if (c == b) return true;
                            }
                            return false;
                        }
                        function ix(a, b) {
                            var c, d, e;
                            d = b.a.ld();
                            c = RD(b.a.md(), 16).gc();
                            for(e = 0; e < c; e++)a.Cd(d);
                        }
                        function Umb(a, b) {
                            var c, d, e, f;
                            uFb(b);
                            for(d = a.c, e = 0, f = d.length; e < f; ++e){
                                c = d[e];
                                b.Cd(c);
                            }
                        }
                        function q0b(a, b, c, d, e, f) {
                            var g;
                            g = s0b(d);
                            Y0b(g, e);
                            Z0b(g, f);
                            Rc(a.a, d, new J0b(g, b, c.f));
                        }
                        function P8c(a, b) {
                            Ixd(a, (X6c(), T6c), b.f);
                            Ixd(a, Q6c, b.e);
                            Ixd(a, S6c, b.d);
                            Ixd(a, P6c, b.c);
                        }
                        function grc(a, b) {
                            this.a = new Tsb;
                            this.e = new Tsb;
                            this.b = (lDc(), kDc);
                            this.c = a;
                            this.b = b;
                        }
                        function yd(a) {
                            this.d = a;
                            this.c = a.c.vc().Kc();
                            this.b = null;
                            this.a = null;
                            this.e = (zs(), ys);
                        }
                        function Wub(a, b) {
                            var c;
                            c = b.c;
                            b.a.b = b.b;
                            b.b.a = b.a;
                            b.a = b.b = null;
                            b.c = null;
                            --a.b;
                            return c;
                        }
                        function Esb(a, b) {
                            if (!!b && a.b[b.g] == b) {
                                bD(a.b, b.g, null);
                                --a.c;
                                return true;
                            }
                            return false;
                        }
                        function jxb(a, b) {
                            if (0 > a || a > b) throw Adb(new xeb('fromIndex: 0, toIndex: ' + a + Qxe + b));
                        }
                        function ZHd(a) {
                            if (a < 0) throw Adb(new agb('Illegal Capacity: ' + a));
                            this.g = this.aj(a);
                        }
                        function _y(a, b) {
                            Zy();
                            bz(pwe);
                            return $wnd.Math.abs(a - b) <= pwe || a == b || isNaN(a) && isNaN(b);
                        }
                        function xJc(a, b) {
                            var c, d, e, f;
                            for(d = a.d, e = 0, f = d.length; e < f; ++e){
                                c = d[e];
                                pJc(a.g, c).a = b;
                            }
                        }
                        function BIc(a, b, c) {
                            var d, e, f;
                            e = b[c];
                            for(d = 0; d < e.length; d++){
                                f = e[d];
                                a.e[f.c.p][f.p] = d;
                            }
                        }
                        function nqc(a) {
                            var b;
                            for(b = 0; b < a.c.length; b++)(tFb(b, a.c.length), RD(a.c[b], 12)).p = b;
                        }
                        function qqc(a) {
                            var b, c;
                            b = a.a.d.j;
                            c = a.c.d.j;
                            while(b != c){
                                zsb(a.b, b);
                                b = tpd(b);
                            }
                            zsb(a.b, b);
                        }
                        function gjd(a) {
                            var b;
                            b = $wnd.Math.sqrt(a.a * a.a + a.b * a.b);
                            if (b > 0) {
                                a.a /= b;
                                a.b /= b;
                            }
                            return a;
                        }
                        function BXd(a) {
                            var b;
                            if (a.w) return a.w;
                            else {
                                b = CXd(a);
                                !!b && !b.Vh() && (a.w = b);
                                return b;
                            }
                        }
                        function l2d(a, b) {
                            var c, d;
                            d = a.a;
                            c = m2d(a, b, null);
                            d != b && !a.e && (c = o2d(a, b, c));
                            !!c && c.oj();
                        }
                        function rQc(a, b, c) {
                            var d, e;
                            d = b;
                            do {
                                e = Kfb(a.p[d.p]) + c;
                                a.p[d.p] = e;
                                d = a.a[d.p];
                            }while (d != b);
                        }
                        function heb(a, b, c) {
                            var d = function() {
                                return a.apply(d, arguments);
                            };
                            b.apply(d, c);
                            return d;
                        }
                        function Gae(a) {
                            var b;
                            if (a == null) return null;
                            else {
                                b = RD(a, 195);
                                return sAd(b, b.length);
                            }
                        }
                        function QHd(a, b) {
                            if (a.g == null || b >= a.i) throw Adb(new yNd(b, a.i));
                            return a.Wi(b, a.g[b]);
                        }
                        function Dob(a, b) {
                            yob();
                            var c, d;
                            d = new bnb;
                            for(c = 0; c < a; ++c)ZEb(d.c, b);
                            return new irb(d);
                        }
                        function NDb(a) {
                            MCb(a);
                            zFb(true, 'n may not be negative');
                            return new SDb(a, new DEb(a.a));
                        }
                        function KKb(a) {
                            a.b = (EKb(), BKb);
                            a.f = (vLb(), tLb);
                            a.d = (dk(2, iwe), new cnb(2));
                            a.e = new pjd;
                        }
                        function zrd(a) {
                            this.b = (Qb(a), new dnb(a));
                            this.a = new bnb;
                            this.d = new bnb;
                            this.e = new pjd;
                        }
                        function ZJb() {
                            ZJb = geb;
                            WJb = new $Jb('BEGIN', 0);
                            XJb = new $Jb(Kye, 1);
                            YJb = new $Jb('END', 2);
                        }
                        function Omd() {
                            Omd = geb;
                            Lmd = new Pmd(Kye, 0);
                            Mmd = new Pmd('HEAD', 1);
                            Nmd = new Pmd('TAIL', 2);
                        }
                        function R_c() {
                            R_c = geb;
                            Q_c = mfd(mfd(mfd(rfd(new ufd, (YVc(), VVc)), (WYc(), VYc)), OYc), SYc);
                        }
                        function B0c() {
                            B0c = geb;
                            A0c = mfd(mfd(mfd(rfd(new ufd, (YVc(), XVc)), (WYc(), QYc)), LYc), PYc);
                        }
                        function gtc() {
                            gtc = geb;
                            ftc = ss((btc(), cD(WC(ZW, 1), jwe, 232, 0, [
                                Zsc,
                                _sc,
                                Ysc,
                                $sc,
                                atc,
                                Xsc
                            ])));
                        }
                        function zuc() {
                            zuc = geb;
                            yuc = ss((tuc(), cD(WC(eX, 1), jwe, 283, 0, [
                                ouc,
                                nuc,
                                quc,
                                puc,
                                suc,
                                ruc
                            ])));
                        }
                        function Tuc() {
                            Tuc = geb;
                            Suc = ss((Ouc(), cD(WC(gX, 1), jwe, 281, 0, [
                                Luc,
                                Kuc,
                                Nuc,
                                Juc,
                                Muc,
                                Iuc
                            ])));
                        }
                        function dvc() {
                            dvc = geb;
                            cvc = ss(($uc(), cD(WC(hX, 1), jwe, 282, 0, [
                                Yuc,
                                Vuc,
                                Zuc,
                                Xuc,
                                Wuc,
                                Uuc
                            ])));
                        }
                        function w3b() {
                            w3b = geb;
                            v3b = ss((r3b(), cD(WC(hR, 1), jwe, 273, 0, [
                                p3b,
                                o3b,
                                m3b,
                                q3b,
                                n3b,
                                l3b
                            ])));
                        }
                        function Wjd() {
                            Wjd = geb;
                            Vjd = ss((Rjd(), cD(WC(n3, 1), jwe, 255, 0, [
                                Ljd,
                                Ojd,
                                Pjd,
                                Qjd,
                                Mjd,
                                Njd
                            ])));
                        }
                        function zkd() {
                            zkd = geb;
                            ykd = ss((ukd(), cD(WC(q3, 1), jwe, 298, 0, [
                                tkd,
                                skd,
                                rkd,
                                pkd,
                                okd,
                                qkd
                            ])));
                        }
                        function nnd() {
                            nnd = geb;
                            mnd = ss((ind(), cD(WC(v3, 1), jwe, 321, 0, [
                                gnd,
                                end,
                                hnd,
                                cnd,
                                fnd,
                                dnd
                            ])));
                        }
                        function Iod() {
                            Iod = geb;
                            Hod = ss((Bod(), cD(WC(C3, 1), jwe, 101, 0, [
                                Aod,
                                zod,
                                yod,
                                vod,
                                xod,
                                wod
                            ])));
                        }
                        function Wod() {
                            Wod = geb;
                            Vod = ss((Pod(), cD(WC(D3, 1), jwe, 279, 0, [
                                Nod,
                                Lod,
                                Mod,
                                Kod,
                                Jod,
                                Ood
                            ])));
                        }
                        function kKb() {
                            kKb = geb;
                            jKb = (ZJb(), cD(WC(JN, 1), jwe, 237, 0, [
                                WJb,
                                XJb,
                                YJb
                            ])).length;
                            iKb = jKb;
                        }
                        function hod() {
                            dod();
                            return cD(WC(A3, 1), jwe, 95, 0, [
                                Xnd,
                                Wnd,
                                Znd,
                                cod,
                                bod,
                                aod,
                                $nd,
                                _nd,
                                Ynd
                            ]);
                        }
                        function eoc(a, b) {
                            Mnc();
                            return hgb(a.b.c.length - a.e.c.length, b.b.c.length - b.e.c.length);
                        }
                        function Ao(a, b) {
                            return $v(Go(a, b, Ydb(Ndb(cwe, qgb(Ydb(Ndb(b == null ? 0 : tb(b), dwe)), 15)))));
                        }
                        function rGb(a, b) {
                            return Zy(), bz(pwe), $wnd.Math.abs(a - b) <= pwe || a == b || isNaN(a) && isNaN(b);
                        }
                        function Wxd(a, b) {
                            var c;
                            c = a.b;
                            a.b = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new L3d(a, 1, c, a.b));
                        }
                        function Hzd(a, b) {
                            var c;
                            c = a.b;
                            a.b = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new L3d(a, 3, c, a.b));
                        }
                        function Ayd(a, b) {
                            var c;
                            c = a.f;
                            a.f = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new L3d(a, 3, c, a.f));
                        }
                        function Cyd(a, b) {
                            var c;
                            c = a.g;
                            a.g = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new L3d(a, 4, c, a.g));
                        }
                        function Dyd(a, b) {
                            var c;
                            c = a.i;
                            a.i = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new L3d(a, 5, c, a.i));
                        }
                        function Eyd(a, b) {
                            var c;
                            c = a.j;
                            a.j = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new L3d(a, 6, c, a.j));
                        }
                        function Ozd(a, b) {
                            var c;
                            c = a.j;
                            a.j = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new L3d(a, 1, c, a.j));
                        }
                        function Izd(a, b) {
                            var c;
                            c = a.c;
                            a.c = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new L3d(a, 4, c, a.c));
                        }
                        function Pzd(a, b) {
                            var c;
                            c = a.k;
                            a.k = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new L3d(a, 2, c, a.k));
                        }
                        function Vxd(a, b) {
                            var c;
                            c = a.a;
                            a.a = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new L3d(a, 0, c, a.a));
                        }
                        function $Vd(a, b) {
                            var c;
                            c = a.s;
                            a.s = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new M3d(a, 4, c, a.s));
                        }
                        function bWd(a, b) {
                            var c;
                            c = a.t;
                            a.t = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new M3d(a, 5, c, a.t));
                        }
                        function Q1d(a, b) {
                            var c;
                            c = a.d;
                            a.d = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new M3d(a, 2, c, a.d));
                        }
                        function zXd(a, b) {
                            var c;
                            c = a.F;
                            a.F = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 5, c, b));
                        }
                        function IMd(a, b) {
                            var c;
                            c = RD(Wjb((PRd(), ORd), a), 57);
                            return c ? c.gk(b) : $C(jJ, rve, 1, b, 5, 1);
                        }
                        function BXb(a, b) {
                            var c;
                            c = ojd(ajd(RD(Wjb(a.g, b), 8)), Pid(RD(Wjb(a.f, b), 470).b));
                            return c;
                        }
                        function FGd(a, b) {
                            var c, d, e;
                            c = (d = (bvd(), e = new hCd, e), !!b && eCd(d, b), d);
                            fCd(c, a);
                            return c;
                        }
                        function vDd(a, b) {
                            var c, d;
                            c = b in a.a;
                            if (c) {
                                d = qC(a, b).re();
                                if (d) return d.a;
                            }
                            return null;
                        }
                        function jZd(a, b, c) {
                            gHd(a, c);
                            if (!a.kl() && c != null && !a.fk(c)) throw Adb(new yeb);
                            return c;
                        }
                        function Mqd(a, b) {
                            a.n = b;
                            if (a.n) {
                                a.f = new bnb;
                                a.e = new bnb;
                            } else {
                                a.f = null;
                                a.e = null;
                            }
                            return a;
                        }
                        function Ffb(a, b) {
                            var c;
                            if (!a) return;
                            b.n = a;
                            var d = zfb(b);
                            if (!d) {
                                eeb[a] = [
                                    b
                                ];
                                return;
                            }
                            d.Rm = b;
                        }
                        function SD(a) {
                            var b;
                            CFb(a == null || Array.isArray(a) && (b = XC(a), !(b >= 14 && b <= 16)));
                            return a;
                        }
                        function ws(a, b) {
                            var c;
                            uFb(b);
                            c = a[':' + b];
                            mFb(!!c, 'Enum constant undefined: ' + b);
                            return c;
                        }
                        function tfb(a, b, c, d, e, f) {
                            var g;
                            g = rfb(a, b);
                            Ffb(c, g);
                            g.i = e ? 8 : 0;
                            g.f = d;
                            g.e = e;
                            g.g = f;
                            return g;
                        }
                        function R3d(a, b, c, d, e) {
                            this.d = b;
                            this.k = d;
                            this.f = e;
                            this.o = -1;
                            this.p = 1;
                            this.c = a;
                            this.a = c;
                        }
                        function T3d(a, b, c, d, e) {
                            this.d = b;
                            this.k = d;
                            this.f = e;
                            this.o = -1;
                            this.p = 2;
                            this.c = a;
                            this.a = c;
                        }
                        function _3d(a, b, c, d, e) {
                            this.d = b;
                            this.k = d;
                            this.f = e;
                            this.o = -1;
                            this.p = 6;
                            this.c = a;
                            this.a = c;
                        }
                        function e4d(a, b, c, d, e) {
                            this.d = b;
                            this.k = d;
                            this.f = e;
                            this.o = -1;
                            this.p = 7;
                            this.c = a;
                            this.a = c;
                        }
                        function X3d(a, b, c, d, e) {
                            this.d = b;
                            this.j = d;
                            this.e = e;
                            this.o = -1;
                            this.p = 4;
                            this.c = a;
                            this.a = c;
                        }
                        function iGb(a, b) {
                            var c, d, e, f;
                            for(d = b, e = 0, f = d.length; e < f; ++e){
                                c = d[e];
                                eGb(a.a, c);
                            }
                            return a;
                        }
                        function Al(a) {
                            var b, c, d, e;
                            for(c = a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                Qb(b);
                            }
                            return new Gl(a);
                        }
                        function ZTb(a) {
                            var b;
                            b = ojd(ajd(a.d.d), a.c.d);
                            wid(b, a.c.e.a, a.c.e.b);
                            return $id(b, a.c.d);
                        }
                        function $Tb(a) {
                            var b;
                            b = ojd(ajd(a.c.d), a.d.d);
                            wid(b, a.d.e.a, a.d.e.b);
                            return $id(b, a.d.d);
                        }
                        function iA(a) {
                            var b = /function(?:\s+([\w$]+))?\s*\(/;
                            var c = b.exec(a);
                            return c && c[1] || wwe;
                        }
                        function Hnb(a, b, c) {
                            var d, e;
                            e = a.length;
                            d = $wnd.Math.min(c, e);
                            VEb(a, 0, b, 0, d, true);
                            return b;
                        }
                        function ISb(a, b, c) {
                            var d, e;
                            for(e = b.Kc(); e.Ob();){
                                d = RD(e.Pb(), 74);
                                Ysb(a, RD(c.Kb(d), 27));
                            }
                        }
                        function E1b(a, b) {
                            Cod(RD(mQb(RD(a.e, 10), (yCc(), BBc)), 101)) && (yob(), _mb(RD(a.e, 10).j, b));
                        }
                        function lIb() {
                            iIb();
                            return cD(WC(xN, 1), jwe, 257, 0, [
                                hIb,
                                cIb,
                                dIb,
                                bIb,
                                fIb,
                                gIb,
                                eIb,
                                aIb,
                                _Hb
                            ]);
                        }
                        function fDc() {
                            _Cc();
                            return cD(WC(rX, 1), jwe, 265, 0, [
                                ZCc,
                                WCc,
                                XCc,
                                TCc,
                                VCc,
                                $Cc,
                                YCc,
                                SCc,
                                UCc
                            ]);
                        }
                        function RKc() {
                            RKc = geb;
                            OKc = new SKc('BARYCENTER', 0);
                            PKc = new SKc(jBe, 1);
                            QKc = new SKc(kBe, 2);
                        }
                        function uFc() {
                            uFc = geb;
                            tFc = new vFc('NO', 0);
                            rFc = new vFc(CBe, 1);
                            sFc = new vFc('LOOK_BACK', 2);
                        }
                        function Etc() {
                            Etc = geb;
                            Btc = new Ftc('ARD', 0);
                            Dtc = new Ftc('MSD', 1);
                            Ctc = new Ftc('MANUAL', 2);
                        }
                        function BEc() {
                            BEc = geb;
                            AEc = new CEc(Sye, 0);
                            yEc = new CEc('INPUT', 1);
                            zEc = new CEc('OUTPUT', 2);
                        }
                        function ygd() {
                            if (!qgd) {
                                qgd = new xgd;
                                wgd(qgd, cD(WC(B2, 1), rve, 134, 0, [
                                    new vmd
                                ]));
                            }
                            return qgd;
                        }
                        function bz(a) {
                            if (!(a >= 0)) throw Adb(new agb('tolerance (' + a + ') must be >= 0'));
                            return a;
                        }
                        function hOd(a, b) {
                            var c;
                            if (ZD(b, 44)) return a.c.Mc(b);
                            else {
                                c = QNd(a, b);
                                jOd(a, b);
                                return c;
                            }
                        }
                        function yBd(a, b, c) {
                            YVd(a, b);
                            PAd(a, c);
                            $Vd(a, 0);
                            bWd(a, 1);
                            aWd(a, true);
                            _Vd(a, true);
                            return a;
                        }
                        function ZGd(a, b) {
                            var c;
                            c = a.gc();
                            if (b < 0 || b > c) throw Adb(new aMd(b, c));
                            return new CMd(a, b);
                        }
                        function Cad(a, b) {
                            a.b = $wnd.Math.max(a.b, b.d);
                            a.e += b.r + (a.a.c.length == 0 ? 0 : a.c);
                            Rmb(a.a, b);
                        }
                        function Jmb(a) {
                            yFb(a.c >= 0);
                            if (rmb(a.d, a.c) < 0) {
                                a.a = a.a - 1 & a.d.a.length - 1;
                                a.b = a.d.c;
                            }
                            a.c = -1;
                        }
                        function Nc(a) {
                            var b, c;
                            for(c = a.c.Cc().Kc(); c.Ob();){
                                b = RD(c.Pb(), 16);
                                b.$b();
                            }
                            a.c.$b();
                            a.d = 0;
                        }
                        function Zi(a) {
                            var b, c, d, e;
                            for(c = a.a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                Rnb(b, b.length, null);
                            }
                        }
                        function zjd(a, b) {
                            var c, d, e, f;
                            for(d = b, e = 0, f = d.length; e < f; ++e){
                                c = d[e];
                                Pub(a, c, a.c.b, a.c);
                            }
                        }
                        function St(a, b) {
                            var c, d;
                            for(c = 0, d = a.gc(); c < d; ++c){
                                if (Fvb(b, a.Xb(c))) return c;
                            }
                            return -1;
                        }
                        function ogb(a) {
                            var b, c;
                            if (a == 0) return 32;
                            else {
                                c = 0;
                                for(b = 1; (b & a) == 0; b <<= 1)++c;
                                return c;
                            }
                        }
                        function dk(a, b) {
                            if (a < 0) throw Adb(new agb(b + ' cannot be negative but was: ' + a));
                            return a;
                        }
                        function deb(a, b) {
                            typeof window === gve && typeof window['$gwt'] === gve && (window['$gwt'][a] = b);
                        }
                        function lp(a, b) {
                            return Vv(Ho(a.a, b, Ydb(Ndb(cwe, qgb(Ydb(Ndb(b == null ? 0 : tb(b), dwe)), 15)))));
                        }
                        function FBb(a, b, c) {
                            return sBb(a, new CCb(b), new ECb, new GCb(c), cD(WC(QL, 1), jwe, 108, 0, []));
                        }
                        function gqd() {
                            dqd();
                            return cD(WC(I3, 1), jwe, 264, 0, [
                                Ypd,
                                $pd,
                                Xpd,
                                _pd,
                                aqd,
                                cqd,
                                bqd,
                                Zpd,
                                Wpd
                            ]);
                        }
                        function wgb() {
                            wgb = geb;
                            vgb = cD(WC(kE, 1), Pwe, 28, 15, [
                                0,
                                8,
                                4,
                                12,
                                2,
                                10,
                                6,
                                14,
                                1,
                                9,
                                5,
                                13,
                                3,
                                11,
                                7,
                                15
                            ]);
                        }
                        function stc() {
                            stc = geb;
                            qtc = new utc('LAYER_SWEEP', 0);
                            ptc = new utc(BBe, 1);
                            rtc = new utc(LAe, 2);
                        }
                        function nGc() {
                            nGc = geb;
                            mGc = pfd(pfd(pfd(new ufd, (sXb(), nXb), (hcc(), obc)), oXb, Nbc), pXb, Mbc);
                        }
                        function yGc() {
                            yGc = geb;
                            xGc = pfd(pfd(pfd(new ufd, (sXb(), nXb), (hcc(), obc)), oXb, Nbc), pXb, Mbc);
                        }
                        function SGc() {
                            SGc = geb;
                            RGc = pfd(pfd(pfd(new ufd, (sXb(), nXb), (hcc(), obc)), oXb, Nbc), pXb, Mbc);
                        }
                        function lHc() {
                            lHc = geb;
                            kHc = pfd(pfd(pfd(new ufd, (sXb(), nXb), (hcc(), obc)), oXb, Nbc), pXb, Mbc);
                        }
                        function tHc() {
                            tHc = geb;
                            sHc = pfd(pfd(pfd(new ufd, (sXb(), nXb), (hcc(), obc)), oXb, Nbc), pXb, Mbc);
                        }
                        function RHc() {
                            RHc = geb;
                            QHc = pfd(pfd(pfd(new ufd, (sXb(), nXb), (hcc(), obc)), oXb, Nbc), pXb, Mbc);
                        }
                        function YJc() {
                            YJc = geb;
                            XJc = nfd(pfd(pfd(new ufd, (sXb(), pXb), (hcc(), Qbc)), qXb, Gbc), rXb, Pbc);
                        }
                        function EJb(a) {
                            var b, c;
                            for(c = new Anb(yud(a)); c.a < c.c.c.length;){
                                b = RD(ynb(c), 695);
                                b._f();
                            }
                        }
                        function aeb() {
                            beb();
                            var a = _db;
                            for(var b = 0; b < arguments.length; b++)a.push(arguments[b]);
                        }
                        function EXb(a) {
                            zXb();
                            this.g = new Tsb;
                            this.f = new Tsb;
                            this.b = new Tsb;
                            this.c = new Tp;
                            this.i = a;
                        }
                        function d1b() {
                            this.f = new pjd;
                            this.d = new C3b;
                            this.c = new pjd;
                            this.a = new bnb;
                            this.b = new bnb;
                        }
                        function Cje(a, b, c, d) {
                            this.ak();
                            this.a = b;
                            this.b = a;
                            this.c = null;
                            this.c = new Dje(this, b, c, d);
                        }
                        function NKd(a, b, c, d, e) {
                            this.d = a;
                            this.n = b;
                            this.g = c;
                            this.o = d;
                            this.p = -1;
                            e || (this.o = -2 - d - 1);
                        }
                        function HWd() {
                            dWd.call(this);
                            this.n = -1;
                            this.g = null;
                            this.i = null;
                            this.j = null;
                            this.Bb |= gwe;
                        }
                        function DEb(a) {
                            xxb.call(this, a.Ad(64) ? Kgb(0, Vdb(a.zd(), 1)) : Sve, a.yd());
                            this.b = 1;
                            this.a = a;
                        }
                        function X_c(a, b) {
                            R_c();
                            return RD(mQb(b, (h_c(), W$c)), 17).a < a.gc() && RD(mQb(b, W$c), 17).a >= 0;
                        }
                        function Iqd(a, b) {
                            if (a.r > 0 && a.c < a.r) {
                                a.c += b;
                                !!a.i && a.i.d > 0 && a.g != 0 && Iqd(a.i, b / a.r * a.i.d);
                            }
                        }
                        function $Cd(a, b) {
                            var c;
                            c = a.c;
                            a.c = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 1, c, a.c));
                        }
                        function P1d(a, b) {
                            var c;
                            c = a.c;
                            a.c = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 4, c, a.c));
                        }
                        function jyd(a, b) {
                            var c;
                            c = a.k;
                            a.k = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 2, c, a.k));
                        }
                        function JXd(a, b) {
                            var c;
                            c = a.D;
                            a.D = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 2, c, a.D));
                        }
                        function Kzd(a, b) {
                            var c;
                            c = a.f;
                            a.f = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 8, c, a.f));
                        }
                        function Lzd(a, b) {
                            var c;
                            c = a.i;
                            a.i = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 7, c, a.i));
                        }
                        function fCd(a, b) {
                            var c;
                            c = a.a;
                            a.a = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 8, c, a.a));
                        }
                        function ZCd(a, b) {
                            var c;
                            c = a.b;
                            a.b = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 0, c, a.b));
                        }
                        function s6d(a, b) {
                            var c;
                            c = a.b;
                            a.b = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 0, c, a.b));
                        }
                        function t6d(a, b) {
                            var c;
                            c = a.c;
                            a.c = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 1, c, a.c));
                        }
                        function nVd(a, b) {
                            var c;
                            c = a.d;
                            a.d = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 1, c, a.d));
                        }
                        function Cte(a, b, c) {
                            var d;
                            a.b = b;
                            a.a = c;
                            d = (a.a & 512) == 512 ? new Gre : new Tqe;
                            a.c = Nqe(d, a.b, a.a);
                        }
                        function Gge(a, b) {
                            return qke(a.e, b) ? (nke(), wWd(b) ? new ole(b, a) : new Eke(b, a)) : new Ble(b, a);
                        }
                        function iDb(a) {
                            var b, c;
                            if (0 > a) return new rDb;
                            b = a + 1;
                            c = new kDb(b, a);
                            return new oDb(null, c);
                        }
                        function Gob(a, b) {
                            yob();
                            var c;
                            c = new Usb(1);
                            bE(a) ? $jb(c, a, b) : rtb(c.f, a, b);
                            return new uqb(c);
                        }
                        function pQc(a, b) {
                            var c, d;
                            c = a.c;
                            d = b.e[a.p];
                            if (d > 0) return RD(Vmb(c.a, d - 1), 10);
                            return null;
                        }
                        function TOb(a, b) {
                            var c, d;
                            c = a.o + a.p;
                            d = b.o + b.p;
                            if (c < d) return -1;
                            if (c == d) return 0;
                            return 1;
                        }
                        function Z5b(a) {
                            var b;
                            b = mQb(a, (Ywc(), Awc));
                            if (ZD(b, 167)) return Y5b(RD(b, 167));
                            return null;
                        }
                        function Wp(a) {
                            var b;
                            a = $wnd.Math.max(a, 2);
                            b = mgb(a);
                            if (a > b) {
                                b <<= 1;
                                return b > 0 ? b : hwe;
                            }
                            return b;
                        }
                        function xc(a) {
                            Ub(a.e != 3);
                            switch(a.e){
                                case 2:
                                    return false;
                                case 0:
                                    return true;
                            }
                            return zc(a);
                        }
                        function djd(a, b) {
                            var c;
                            if (ZD(b, 8)) {
                                c = RD(b, 8);
                                return a.a == c.a && a.b == c.b;
                            } else return false;
                        }
                        function Ydd(a, b) {
                            var c;
                            c = new kRb;
                            RD(b.b, 68);
                            RD(b.b, 68);
                            RD(b.b, 68);
                            Umb(b.a, new ced(a, c, b));
                        }
                        function gOd(a, b) {
                            var c, d;
                            for(d = b.vc().Kc(); d.Ob();){
                                c = RD(d.Pb(), 44);
                                fOd(a, c.ld(), c.md());
                            }
                        }
                        function Jzd(a, b) {
                            var c;
                            c = a.d;
                            a.d = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 11, c, a.d));
                        }
                        function zWd(a, b) {
                            var c;
                            c = a.j;
                            a.j = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 13, c, a.j));
                        }
                        function b6d(a, b) {
                            var c;
                            c = a.b;
                            a.b = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 21, c, a.b));
                        }
                        function YAb(a, b) {
                            ((gBb(), dBb) ? null : b.c).length == 0 && iBb(b, new rBb);
                            $jb(a.a, dBb ? null : b.c, b);
                        }
                        function b9b(a, b) {
                            b.Ug('Hierarchical port constraint processing', 1);
                            c9b(a);
                            e9b(a);
                            b.Vg();
                        }
                        function joc() {
                            joc = geb;
                            ioc = new koc('START', 0);
                            hoc = new koc('MIDDLE', 1);
                            goc = new koc('END', 2);
                        }
                        function x2c() {
                            x2c = geb;
                            v2c = new z2c('P1_NODE_PLACEMENT', 0);
                            w2c = new z2c('P2_EDGE_ROUTING', 1);
                        }
                        function JVb() {
                            JVb = geb;
                            HVb = new jGd(rAe);
                            IVb = new jGd(sAe);
                            GVb = new jGd(tAe);
                            FVb = new jGd(uAe);
                        }
                        function tkb(a) {
                            var b;
                            rFb(a.f.g, a.d);
                            sFb(a.b);
                            a.c = a.a;
                            b = RD(a.a.Pb(), 44);
                            a.b = skb(a);
                            return b;
                        }
                        function P2d(a) {
                            var b;
                            if (a.b == null) return j3d(), j3d(), i3d;
                            b = a.ul() ? a.tl() : a.sl();
                            return b;
                        }
                        function nwb(a, b) {
                            var c;
                            c = b == null ? -1 : Wmb(a.b, b, 0);
                            if (c < 0) return false;
                            owb(a, c);
                            return true;
                        }
                        function zsb(a, b) {
                            var c;
                            uFb(b);
                            c = b.g;
                            if (!a.b[c]) {
                                bD(a.b, c, b);
                                ++a.c;
                                return true;
                            }
                            return false;
                        }
                        function azb(a, b) {
                            var c, d;
                            c = 1 - b;
                            d = a.a[c];
                            a.a[c] = d.a[b];
                            d.a[b] = a;
                            a.b = true;
                            d.b = false;
                            return d;
                        }
                        function xRb(a, b) {
                            var c, d;
                            for(d = b.Kc(); d.Ob();){
                                c = RD(d.Pb(), 272);
                                a.b = true;
                                Ysb(a.e, c);
                                c.b = a;
                            }
                        }
                        function kic(a, b) {
                            var c, d;
                            c = RD(mQb(a, (yCc(), IBc)), 8);
                            d = RD(mQb(b, IBc), 8);
                            return Qfb(c.b, d.b);
                        }
                        function SPb(a, b, c) {
                            var d, e, f;
                            f = b >> 5;
                            e = b & 31;
                            d = Cdb(Udb(a.n[c][f], Ydb(Sdb(e, 1))), 3);
                            return d;
                        }
                        function lmb(a, b, c) {
                            var d, e, f;
                            f = a.a.length - 1;
                            for(e = a.b, d = 0; d < c; e = e + 1 & f, ++d)bD(b, d, a.a[e]);
                        }
                        function owb(a, b) {
                            var c;
                            c = Xmb(a.b, a.b.c.length - 1);
                            if (b < a.b.c.length) {
                                $mb(a.b, b, c);
                                kwb(a, b);
                            }
                        }
                        function NQc(a, b) {
                            var c;
                            c = RD(Wjb(a.c, b), 467);
                            if (!c) {
                                c = new UQc;
                                c.c = b;
                                Zjb(a.c, c.c, c);
                            }
                            return c;
                        }
                        function PUc(a, b) {
                            var c, d;
                            d = new bnb;
                            c = b;
                            do {
                                ZEb(d.c, c);
                                c = RD(Wjb(a.k, c), 18);
                            }while (c);
                            return d;
                        }
                        function rMc(a, b, c) {
                            var d;
                            d = new bnb;
                            sMc(a, b, d, c, true, true);
                            a.b = new _Lc(d.c.length);
                            return d;
                        }
                        function tvb(a, b) {
                            var c, d;
                            c = a.Pc();
                            Wnb(c, 0, c.length, b);
                            for(d = 0; d < c.length; d++)a.hd(d, c[d]);
                        }
                        function Bad(a) {
                            var b, c;
                            for(c = new dMd(a); c.e != c.i.gc();){
                                b = RD(bMd(c), 27);
                                Dyd(b, 0);
                                Eyd(b, 0);
                            }
                        }
                        function Bu(a) {
                            this.e = a;
                            this.d = new atb(Sv(Ec(this.e).gc()));
                            this.c = this.e.a;
                            this.b = this.e.c;
                        }
                        function _Lc(a) {
                            this.b = a;
                            this.a = $C(kE, Pwe, 28, a + 1, 15, 1);
                            this.c = $C(kE, Pwe, 28, a, 15, 1);
                            this.d = 0;
                        }
                        function frc(a, b, c) {
                            grc.call(this, b, c);
                            this.d = $C(jR, WAe, 10, a.a.c.length, 0, 1);
                            anb(a.a, this.d);
                        }
                        function vLc(a, b, c) {
                            UIc.call(this, a, b, c);
                            this.a = new Tsb;
                            this.b = new Tsb;
                            this.d = new yLc(this);
                        }
                        function Pic(a) {
                            fHb.call(this);
                            this.b = Kfb(UD(mQb(a, (yCc(), TBc))));
                            this.a = RD(mQb(a, yAc), 223);
                        }
                        function _q(a, b) {
                            var c;
                            if (ZD(b, 16)) {
                                c = RD(b, 16);
                                return a.Gc(c);
                            }
                            return xr(a, RD(Qb(b), 20).Kc());
                        }
                        function KCc(a, b) {
                            FDb(CDb(new SDb(null, new Swb(new Xkb(a.b), 1)), new esd(a, b)), new isd(a, b));
                        }
                        function f6b(a, b) {
                            b.Ug(iBe, 1);
                            FDb(EDb(new SDb(null, new Swb(a.b, 16)), new j6b), new l6b);
                            b.Vg();
                        }
                        function tb(a) {
                            return bE(a) ? ohb(a) : _D(a) ? Nfb(a) : $D(a) ? Jeb(a) : YD(a) ? a.Hb() : aD(a) ? kFb(a) : Iz(a);
                        }
                        function xKc(a) {
                            var b, c;
                            for(c = a.c.a.ec().Kc(); c.Ob();){
                                b = RD(c.Pb(), 219);
                                DJc(b, new NLc(b.f));
                            }
                        }
                        function yKc(a) {
                            var b, c;
                            for(c = a.c.a.ec().Kc(); c.Ob();){
                                b = RD(c.Pb(), 219);
                                EJc(b, new OLc(b.e));
                            }
                        }
                        function PAd(a, b) {
                            var c;
                            c = a.zb;
                            a.zb = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 1, c, a.zb));
                        }
                        function CBd(a, b) {
                            var c;
                            c = a.xb;
                            a.xb = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 3, c, a.xb));
                        }
                        function DBd(a, b) {
                            var c;
                            c = a.yb;
                            a.yb = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 2, c, a.yb));
                        }
                        function iBd(a, b) {
                            var c, d;
                            c = (d = new mXd, d);
                            c.n = b;
                            WGd((!a.s && (a.s = new C5d(y7, a, 21, 17)), a.s), c);
                        }
                        function oBd(a, b) {
                            var c, d;
                            d = (c = new d6d, c);
                            d.n = b;
                            WGd((!a.s && (a.s = new C5d(y7, a, 21, 17)), a.s), d);
                        }
                        function ye(a, b) {
                            var c, d, e;
                            uFb(b);
                            c = false;
                            for(e = b.Kc(); e.Ob();){
                                d = e.Pb();
                                c = c | a.Fc(d);
                            }
                            return c;
                        }
                        function Sx(a) {
                            var b, c, d;
                            b = 0;
                            for(d = a.Kc(); d.Ob();){
                                c = d.Pb();
                                b += c != null ? tb(c) : 0;
                                b = ~~b;
                            }
                            return b;
                        }
                        function oC(e, a) {
                            var b = e.a;
                            var c = 0;
                            for(var d in b)b.hasOwnProperty(d) && (a[c++] = d);
                            return a;
                        }
                        function gB(a) {
                            var b;
                            if (a == 0) return 'UTC';
                            if (a < 0) {
                                a = -a;
                                b = 'UTC+';
                            } else b = 'UTC-';
                            return b + iB(a);
                        }
                        function xib(a) {
                            if (a.a < 54) return a.f < 0 ? -1 : a.f > 0 ? 1 : 0;
                            return (!a.c && (a.c = ojb(Hdb(a.f))), a.c).e;
                        }
                        function GXd(a, b) {
                            if (b) {
                                if (a.B == null) {
                                    a.B = a.D;
                                    a.D = null;
                                }
                            } else if (a.B != null) {
                                a.D = a.B;
                                a.B = null;
                            }
                        }
                        function rZb(a, b) {
                            nZb();
                            return a == jZb && b == mZb || a == mZb && b == jZb || a == lZb && b == kZb || a == kZb && b == lZb;
                        }
                        function sZb(a, b) {
                            nZb();
                            return a == jZb && b == kZb || a == jZb && b == lZb || a == mZb && b == lZb || a == mZb && b == kZb;
                        }
                        function zMb(a, b) {
                            return Zy(), bz(Tye), $wnd.Math.abs(0 - b) <= Tye || 0 == b || isNaN(0) && isNaN(b) ? 0 : a / b;
                        }
                        function qsc(a, b) {
                            return Kfb(UD(Lvb(MDb(GDb(new SDb(null, new Swb(a.c.b, 16)), new Isc(a)), b))));
                        }
                        function tsc(a, b) {
                            return Kfb(UD(Lvb(MDb(GDb(new SDb(null, new Swb(a.c.b, 16)), new Gsc(a)), b))));
                        }
                        function rvc() {
                            ovc();
                            return cD(WC(iX, 1), jwe, 259, 0, [
                                fvc,
                                hvc,
                                ivc,
                                jvc,
                                kvc,
                                lvc,
                                nvc,
                                evc,
                                gvc,
                                mvc
                            ]);
                        }
                        function dEc() {
                            aEc();
                            return cD(WC(vX, 1), jwe, 243, 0, [
                                $Dc,
                                VDc,
                                YDc,
                                WDc,
                                XDc,
                                SDc,
                                ZDc,
                                _Dc,
                                TDc,
                                UDc
                            ]);
                        }
                        function z3c(a, b) {
                            var c;
                            b.Ug('General Compactor', 1);
                            c = h4c(RD(Gxd(a, ($4c(), I4c)), 393));
                            c.Cg(a);
                        }
                        function T5c(a, b) {
                            var c, d;
                            c = RD(Gxd(a, ($4c(), P4c)), 17);
                            d = RD(Gxd(b, P4c), 17);
                            return hgb(c.a, d.a);
                        }
                        function Bjd(a, b, c) {
                            var d, e;
                            for(e = Sub(a, 0); e.b != e.d.c;){
                                d = RD(evb(e), 8);
                                d.a += b;
                                d.b += c;
                            }
                            return a;
                        }
                        function Go(a, b, c) {
                            var d;
                            for(d = a.b[c & a.f]; d; d = d.b){
                                if (c == d.a && Hb(b, d.g)) return d;
                            }
                            return null;
                        }
                        function Ho(a, b, c) {
                            var d;
                            for(d = a.c[c & a.f]; d; d = d.d){
                                if (c == d.f && Hb(b, d.i)) return d;
                            }
                            return null;
                        }
                        function sjb(a, b, c) {
                            var d, e, f;
                            d = 0;
                            for(e = 0; e < c; e++){
                                f = b[e];
                                a[e] = f << 1 | d;
                                d = f >>> 31;
                            }
                            d != 0 && (a[c] = d);
                        }
                        function yzb(a, b, c, d, e, f) {
                            var g;
                            this.c = a;
                            g = new bnb;
                            Syb(a, g, b, a.b, c, d, e, f);
                            this.a = new Jkb(g, 0);
                        }
                        function _5c() {
                            this.c = new T2c(0);
                            this.b = new T2c(FEe);
                            this.d = new T2c(EEe);
                            this.a = new T2c(Gze);
                        }
                        function kMb(a, b, c, d, e, f, g) {
                            qs.call(this, a, b);
                            this.d = c;
                            this.e = d;
                            this.c = e;
                            this.b = f;
                            this.a = dv(g);
                        }
                        function tBd(a, b, c, d, e, f, g, h, i, j, k, l, m) {
                            ABd(a, b, c, d, e, f, g, h, i, j, k, l, m);
                            kXd(a, false);
                            return a;
                        }
                        function H0b(a) {
                            if (a.b.c.i.k == (r3b(), m3b)) return RD(mQb(a.b.c.i, (Ywc(), Awc)), 12);
                            return a.b.c;
                        }
                        function I0b(a) {
                            if (a.b.d.i.k == (r3b(), m3b)) return RD(mQb(a.b.d.i, (Ywc(), Awc)), 12);
                            return a.b.d;
                        }
                        function nDb(a) {
                            var b;
                            b = mDb(a);
                            if (Gdb(b.a, 0)) return bwb(), bwb(), awb;
                            return bwb(), new ewb(b.b);
                        }
                        function SCb(a) {
                            var b;
                            b = RCb(a);
                            if (Gdb(b.a, 0)) return Tvb(), Tvb(), Svb;
                            return Tvb(), new Yvb(b.b);
                        }
                        function TCb(a) {
                            var b;
                            b = RCb(a);
                            if (Gdb(b.a, 0)) return Tvb(), Tvb(), Svb;
                            return Tvb(), new Yvb(b.c);
                        }
                        function o8b(a) {
                            switch(a.g){
                                case 2:
                                    return qpd(), ppd;
                                case 4:
                                    return qpd(), Xod;
                                default:
                                    return a;
                            }
                        }
                        function p8b(a) {
                            switch(a.g){
                                case 1:
                                    return qpd(), npd;
                                case 3:
                                    return qpd(), Yod;
                                default:
                                    return a;
                            }
                        }
                        function C9c(a) {
                            switch(a.g){
                                case 0:
                                    return new s9c;
                                case 1:
                                    return new x9c;
                                default:
                                    return null;
                            }
                        }
                        function Zcc() {
                            Zcc = geb;
                            Ycc = new kGd('edgelabelcenterednessanalysis.includelabel', (Geb(), Eeb));
                        }
                        function jKc() {
                            jKc = geb;
                            iKc = mfd(qfd(pfd(pfd(new ufd, (sXb(), pXb), (hcc(), Qbc)), qXb, Gbc), rXb), Pbc);
                        }
                        function DLc() {
                            DLc = geb;
                            CLc = mfd(qfd(pfd(pfd(new ufd, (sXb(), pXb), (hcc(), Qbc)), qXb, Gbc), rXb), Pbc);
                        }
                        function lYd() {
                            lYd = geb;
                            iYd = new i1d;
                            kYd = cD(WC(y7, 1), lKe, 179, 0, []);
                            jYd = cD(WC(s7, 1), mKe, 62, 0, []);
                        }
                        function P8b() {
                            P8b = geb;
                            O8b = new Q8b('TO_INTERNAL_LTR', 0);
                            N8b = new Q8b('TO_INPUT_DIRECTION', 1);
                        }
                        function J3b() {
                            J3b = geb;
                            G3b = new r4b;
                            E3b = new w4b;
                            F3b = new A4b;
                            D3b = new E4b;
                            H3b = new I4b;
                            I3b = new M4b;
                        }
                        function Cac(a, b) {
                            b.Ug(iBe, 1);
                            LJb(KJb(new PJb((i1b(), new t1b(a, false, false, new _1b)))));
                            b.Vg();
                        }
                        function M_c(a, b, c) {
                            c.Ug('DFS Treeifying phase', 1);
                            L_c(a, b);
                            J_c(a, b);
                            a.a = null;
                            a.b = null;
                            c.Vg();
                        }
                        function Leb(a, b) {
                            Geb();
                            return bE(a) ? jhb(a, WD(b)) : _D(a) ? Jfb(a, UD(b)) : $D(a) ? Ieb(a, TD(b)) : a.Fd(b);
                        }
                        function Ld(a, b) {
                            var c, d;
                            uFb(b);
                            for(d = b.vc().Kc(); d.Ob();){
                                c = RD(d.Pb(), 44);
                                a.zc(c.ld(), c.md());
                            }
                        }
                        function ege(a, b, c) {
                            var d;
                            for(d = c.Kc(); d.Ob();){
                                if (!cge(a, b, d.Pb())) return false;
                            }
                            return true;
                        }
                        function S6d(a, b, c, d, e) {
                            var f;
                            if (c) {
                                f = BYd(b.Dh(), a.c);
                                e = c.Rh(b, -1 - (f == -1 ? d : f), null, e);
                            }
                            return e;
                        }
                        function T6d(a, b, c, d, e) {
                            var f;
                            if (c) {
                                f = BYd(b.Dh(), a.c);
                                e = c.Th(b, -1 - (f == -1 ? d : f), null, e);
                            }
                            return e;
                        }
                        function Uib(a) {
                            var b;
                            if (a.b == -2) {
                                if (a.e == 0) b = -1;
                                else {
                                    for(b = 0; a.a[b] == 0; b++);
                                }
                                a.b = b;
                            }
                            return a.b;
                        }
                        function fjb(a) {
                            uFb(a);
                            if (a.length == 0) throw Adb(new Vgb('Zero length BigInteger'));
                            mjb(this, a);
                        }
                        function $Hd(a) {
                            this.i = a.gc();
                            if (this.i > 0) {
                                this.g = this.aj(this.i + (this.i / 8 | 0) + 1);
                                a.Qc(this.g);
                            }
                        }
                        function dmc(a, b, c) {
                            this.g = a;
                            this.d = b;
                            this.e = c;
                            this.a = new bnb;
                            bmc(this);
                            yob();
                            _mb(this.a, null);
                        }
                        function aad(a, b) {
                            b.q = a;
                            a.d = $wnd.Math.max(a.d, b.r);
                            a.b += b.d + (a.a.c.length == 0 ? 0 : a.c);
                            Rmb(a.a, b);
                        }
                        function xid(a, b) {
                            var c, d, e, f;
                            e = a.c;
                            c = a.c + a.b;
                            f = a.d;
                            d = a.d + a.a;
                            return b.a > e && b.a < c && b.b > f && b.b < d;
                        }
                        function Cjd(a, b) {
                            var c, d;
                            for(d = Sub(a, 0); d.b != d.d.c;){
                                c = RD(evb(d), 8);
                                c.a += b.a;
                                c.b += b.b;
                            }
                            return a;
                        }
                        function $cc(a) {
                            var b, c, d;
                            d = 0;
                            for(c = new Anb(a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 30);
                                b.p = d;
                                ++d;
                            }
                        }
                        function Tnc(a) {
                            var b, c, d;
                            return a.j == (qpd(), Yod) && (b = Vnc(a), c = Csb(b, Xod), d = Csb(b, ppd), d || d && c);
                        }
                        function rsd(a, b) {
                            var c;
                            c = wsd(a);
                            return qsd(new rjd(c.c, c.d), new rjd(c.b, c.a), a.Mf(), b, a.ag());
                        }
                        function wEd(a, b) {
                            var c;
                            c = RD(b, 190);
                            qDd(c, 'x', a.i);
                            qDd(c, 'y', a.j);
                            qDd(c, fIe, a.g);
                            qDd(c, eIe, a.f);
                        }
                        function CVd(a, b) {
                            var c;
                            if (ZD(b, 85)) {
                                RD(a.c, 79).Gk();
                                c = RD(b, 85);
                                gOd(a, c);
                            } else RD(a.c, 79).Wb(b);
                        }
                        function Bvb(a, b) {
                            var c, d;
                            uFb(b);
                            for(d = a.vc().Kc(); d.Ob();){
                                c = RD(d.Pb(), 44);
                                b.Yd(c.ld(), c.md());
                            }
                        }
                        function zr(a, b) {
                            var c;
                            Qb(b);
                            while(a.Ob()){
                                c = a.Pb();
                                if (!oSc(RD(c, 10))) return false;
                            }
                            return true;
                        }
                        function _Ab() {
                            var a;
                            if (!XAb) {
                                XAb = new $Ab;
                                a = new oBb('');
                                mBb(a, (SAb(), RAb));
                                YAb(XAb, a);
                            }
                            return XAb;
                        }
                        function PBb(a, b) {
                            return sBb(new lCb(a), new nCb(b), new pCb(b), new rCb, cD(WC(QL, 1), jwe, 108, 0, []));
                        }
                        function t5c() {
                            t5c = geb;
                            r5c = new v5c(LAe, 0);
                            s5c = new v5c('POLAR_COORDINATE', 1);
                            q5c = new v5c('ID', 2);
                        }
                        function KEc() {
                            KEc = geb;
                            HEc = new LEc('EQUALLY', 0);
                            IEc = new LEc(_ye, 1);
                            JEc = new LEc('NORTH_SOUTH', 2);
                        }
                        function OQb() {
                            OQb = geb;
                            MQb = new kGd('debugSVG', (Geb(), false));
                            NQb = new kGd('overlapsExisted', true);
                        }
                        function pid() {
                            pid = geb;
                            oid = ss((kid(), cD(WC(e3, 1), jwe, 285, 0, [
                                jid,
                                cid,
                                gid,
                                iid,
                                did,
                                eid,
                                fid,
                                hid
                            ])));
                        }
                        function fGd() {
                            fGd = geb;
                            eGd = ss((aGd(), cD(WC(T5, 1), jwe, 245, 0, [
                                _Fd,
                                YFd,
                                ZFd,
                                XFd,
                                $Fd,
                                VFd,
                                UFd,
                                WFd
                            ])));
                        }
                        function jpc() {
                            jpc = geb;
                            ipc = ss((epc(), cD(WC(hW, 1), jwe, 276, 0, [
                                Zoc,
                                apc,
                                Yoc,
                                dpc,
                                _oc,
                                $oc,
                                cpc,
                                bpc
                            ])));
                        }
                        function $Yc() {
                            WYc();
                            return cD(WC(u_, 1), jwe, 262, 0, [
                                VYc,
                                OYc,
                                SYc,
                                TYc,
                                RYc,
                                NYc,
                                UYc,
                                LYc,
                                QYc,
                                PYc,
                                MYc
                            ]);
                        }
                        function $i(a, b, c) {
                            var d, e;
                            e = RD(Fn(a.d, b), 17);
                            d = RD(Fn(a.b, c), 17);
                            return !e || !d ? null : Ui(a, e.a, d.a);
                        }
                        function cgd(a, b) {
                            var c;
                            c = sgd(ygd(), a);
                            if (c) {
                                Ixd(b, (umd(), Tld), c);
                                return true;
                            } else return false;
                        }
                        function TMb(a) {
                            RMb();
                            if (a.A.Hc((Qpd(), Mpd))) {
                                if (!a.B.Hc((dqd(), $pd))) return SMb(a);
                            }
                            return null;
                        }
                        function tUb() {
                            this.a = RD(iGd((yVb(), aVb)), 17).a;
                            this.c = Kfb(UD(iGd(rVb)));
                            this.b = Kfb(UD(iGd(nVb)));
                        }
                        function vkb(a) {
                            this.f = a;
                            this.e = new Qtb(this.f.i);
                            this.a = this.e;
                            this.b = skb(this);
                            this.d = this.f.g;
                        }
                        function Uge(a, b) {
                            Kfe.call(this, Ibb, a, b);
                            this.b = this;
                            this.a = pke(a.Dh(), vYd(this.e.Dh(), this.c));
                        }
                        function bdc(a, b) {
                            var c, d;
                            for(d = new Anb(b.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 30);
                                a.a[c.p] = h2b(c);
                            }
                        }
                        function ofd(a, b) {
                            var c;
                            for(c = 0; c < b.j.c.length; c++)RD(Med(a, c), 21).Gc(RD(Med(b, c), 16));
                            return a;
                        }
                        function peb(a, b, c, d) {
                            var e;
                            e = a.a.length;
                            c > e ? c = e : BFb(b, c + 1);
                            a.a = zhb(a.a, 0, b) + ('' + d) + yhb(a.a, c);
                        }
                        function ktb(a, b) {
                            a.a = Bdb(a.a, 1);
                            a.c = $wnd.Math.min(a.c, b);
                            a.b = $wnd.Math.max(a.b, b);
                            a.d = Bdb(a.d, b);
                        }
                        function wdc(a, b) {
                            return b < a.b.gc() ? RD(a.b.Xb(b), 10) : b == a.b.gc() ? a.a : RD(Vmb(a.e, b - a.b.gc() - 1), 10);
                        }
                        function rXc(a, b, c) {
                            return Qfb(cjd(jWc(a), new rjd(b.e.a, b.e.b)), cjd(jWc(a), new rjd(c.e.a, c.e.b)));
                        }
                        function WJc(a, b, c) {
                            return a == (RKc(), QKc) ? new PJc : Kwb(b, 1) != 0 ? new ILc(c.length) : new pLc(c.length);
                        }
                        function qvd(a, b) {
                            var c, d, e;
                            c = a.th();
                            if (c != null && a.wh()) for(d = 0, e = c.length; d < e; ++d)c[d].dj(b);
                        }
                        function QBb(a, b) {
                            var c, d, e;
                            c = a.c.Xe();
                            for(e = b.Kc(); e.Ob();){
                                d = e.Pb();
                                a.a.Yd(c, d);
                            }
                            return a.b.Kb(c);
                        }
                        function n2b(a, b) {
                            var c, d;
                            c = a;
                            d = Y2b(c).e;
                            while(d){
                                c = d;
                                if (c == b) return true;
                                d = Y2b(c).e;
                            }
                            return false;
                        }
                        function Edb(a) {
                            var b;
                            b = a.h;
                            if (b == 0) return a.l + a.m * gxe;
                            if (b == exe) return a.l + a.m * gxe - hxe;
                            return a;
                        }
                        function LHc(a, b, c) {
                            var d, e;
                            d = a.a.f[b.p];
                            e = a.a.f[c.p];
                            if (d < e) return -1;
                            if (d == e) return 0;
                            return 1;
                        }
                        function Wmc(a, b) {
                            var c, d;
                            for(d = new Anb(b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 72);
                                Rmb(a.d, c);
                                $mc(a, c);
                            }
                        }
                        function E6b(a, b) {
                            var c;
                            b.Ug('Edge and layer constraint edge reversal', 1);
                            c = D6b(a);
                            C6b(c);
                            b.Vg();
                        }
                        function m6c(a, b) {
                            var c, d;
                            for(d = new dMd(a); d.e != d.i.gc();){
                                c = RD(bMd(d), 27);
                                Byd(c, c.i + b.b, c.j + b.d);
                            }
                        }
                        function TNd(a) {
                            var b;
                            if (a.d == null) {
                                ++a.e;
                                a.f = 0;
                                SNd(null);
                            } else {
                                ++a.e;
                                b = a.d;
                                a.d = null;
                                a.f = 0;
                                SNd(b);
                            }
                        }
                        function Ys(a) {
                            var b;
                            if (a.a == a.b.a) throw Adb(new Dvb);
                            b = a.a;
                            a.c = b;
                            a.a = RD(Hvb(a.a.e), 227);
                            return b;
                        }
                        function Ywd(a, b) {
                            var c;
                            if ((a.Db & b) != 0) {
                                c = Xwd(a, b);
                                return c == -1 ? a.Eb : SD(a.Eb)[c];
                            } else return null;
                        }
                        function jBd(a, b) {
                            var c, d;
                            c = (d = new HYd, d);
                            c.G = b;
                            !a.rb && (a.rb = new J5d(a, i7, a));
                            WGd(a.rb, c);
                            return c;
                        }
                        function kBd(a, b) {
                            var c, d;
                            c = (d = new k1d, d);
                            c.G = b;
                            !a.rb && (a.rb = new J5d(a, i7, a));
                            WGd(a.rb, c);
                            return c;
                        }
                        function wBd(a, b, c, d) {
                            ZD(a.Cb, 184) && (RD(a.Cb, 184).tb = null);
                            PAd(a, c);
                            !!b && HXd(a, b);
                            d && a.gl(true);
                        }
                        function nJc(a, b) {
                            if (a.c) {
                                oJc(a, b, true);
                                FDb(new SDb(null, new Swb(b, 16)), new BJc(a));
                            }
                            oJc(a, b, false);
                        }
                        function KRc(a) {
                            FRc();
                            var b;
                            if (!Urb(ERc, a)) {
                                b = new HRc;
                                b.a = a;
                                Xrb(ERc, a, b);
                            }
                            return RD(Vrb(ERc, a), 645);
                        }
                        function k3d(a) {
                            var b;
                            if (a.g > 1 || a.Ob()) {
                                ++a.a;
                                a.g = 0;
                                b = a.i;
                                a.Ob();
                                return b;
                            } else throw Adb(new Dvb);
                        }
                        function GRc(a) {
                            switch(a.a.g){
                                case 1:
                                    return new lSc;
                                case 3:
                                    return new VUc;
                                default:
                                    return new WRc;
                            }
                        }
                        function fyd(a, b) {
                            switch(b){
                                case 1:
                                    return !!a.n && a.n.i != 0;
                                case 2:
                                    return a.k != null;
                            }
                            return Cxd(a, b);
                        }
                        function Hdb(a) {
                            if (jxe < a && a < hxe) return a < 0 ? $wnd.Math.ceil(a) : $wnd.Math.floor(a);
                            return Edb(vD(a));
                        }
                        function hfb(a) {
                            var b;
                            if (a < 128) return jfb(), b = ifb[a], !b && (b = ifb[a] = new bfb(a)), b;
                            return new bfb(a);
                        }
                        function PCb(b, c) {
                            var d;
                            try {
                                c.de();
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 82)) {
                                    d = a;
                                    ZEb(b.c, d);
                                } else throw Adb(a);
                            }
                        }
                        function Wdb(a) {
                            var b, c, d, e;
                            e = a;
                            d = 0;
                            if (e < 0) {
                                e += hxe;
                                d = exe;
                            }
                            c = eE(e / gxe);
                            b = eE(e - c * gxe);
                            return hD(b, c, d);
                        }
                        function dy(a) {
                            var b, c, d;
                            d = 0;
                            for(c = new Osb(a.a); c.a < c.c.a.length;){
                                b = Nsb(c);
                                a.b.Hc(b) && ++d;
                            }
                            return d;
                        }
                        function _u(a) {
                            var b, c, d;
                            b = 1;
                            for(d = a.Kc(); d.Ob();){
                                c = d.Pb();
                                b = 31 * b + (c == null ? 0 : tb(c));
                                b = ~~b;
                            }
                            return b;
                        }
                        function kQb(a, b) {
                            var c;
                            if (!b) return a;
                            c = b.nf();
                            c.dc() || (!a.q ? a.q = new Vsb(c) : Ld(a.q, c));
                            return a;
                        }
                        function Mtb(a, b) {
                            var c;
                            c = a.a.get(b);
                            if (c === undefined) ++a.d;
                            else {
                                Ctb(a.a, b);
                                --a.c;
                                ++a.b.g;
                            }
                            return c;
                        }
                        function a0b(a, b) {
                            var c, d, e;
                            c = b.p - a.p;
                            if (c == 0) {
                                d = a.f.a * a.f.b;
                                e = b.f.a * b.f.b;
                                return Qfb(d, e);
                            }
                            return c;
                        }
                        function Jfc(a, b) {
                            var c, d;
                            c = a.j;
                            d = b.j;
                            return c != d ? c.g - d.g : a.p == b.p ? 0 : c == (qpd(), Yod) ? a.p - b.p : b.p - a.p;
                        }
                        function dFc(a, b, c, d, e) {
                            bD(a.c[b.g], c.g, d);
                            bD(a.c[c.g], b.g, d);
                            bD(a.b[b.g], c.g, e);
                            bD(a.b[c.g], b.g, e);
                        }
                        function Jyb(a, b, c) {
                            this.b = (uFb(a), a);
                            this.d = (uFb(b), b);
                            this.e = (uFb(c), c);
                            this.c = this.d + ('' + this.e);
                        }
                        function Phe(a, b) {
                            this.b = a;
                            this.e = b;
                            this.d = b.j;
                            this.f = (nke(), RD(a, 69).xk());
                            this.k = pke(b.e.Dh(), a);
                        }
                        function USc(a) {
                            this.n = new bnb;
                            this.e = new Yub;
                            this.j = new Yub;
                            this.k = new bnb;
                            this.f = new bnb;
                            this.p = a;
                        }
                        function rVc(a) {
                            a.r = new _sb;
                            a.w = new _sb;
                            a.t = new bnb;
                            a.i = new bnb;
                            a.d = new _sb;
                            a.a = new Tid;
                            a.c = new Tsb;
                        }
                        function mOb() {
                            mOb = geb;
                            lOb = new nOb('UP', 0);
                            iOb = new nOb(Zye, 1);
                            jOb = new nOb(Nye, 2);
                            kOb = new nOb(Oye, 3);
                        }
                        function xvc() {
                            xvc = geb;
                            vvc = new yvc('ONE_SIDED', 0);
                            wvc = new yvc('TWO_SIDED', 1);
                            uvc = new yvc('OFF', 2);
                        }
                        function B9c() {
                            B9c = geb;
                            z9c = new D9c('EQUAL_BETWEEN_STRUCTURES', 0);
                            A9c = new D9c('TO_ASPECT_RATIO', 1);
                        }
                        function hDc() {
                            hDc = geb;
                            gDc = ss((_Cc(), cD(WC(rX, 1), jwe, 265, 0, [
                                ZCc,
                                WCc,
                                XCc,
                                TCc,
                                VCc,
                                $Cc,
                                YCc,
                                SCc,
                                UCc
                            ])));
                        }
                        function iqd() {
                            iqd = geb;
                            hqd = ss((dqd(), cD(WC(I3, 1), jwe, 264, 0, [
                                Ypd,
                                $pd,
                                Xpd,
                                _pd,
                                aqd,
                                cqd,
                                bqd,
                                Zpd,
                                Wpd
                            ])));
                        }
                        function jod() {
                            jod = geb;
                            iod = ss((dod(), cD(WC(A3, 1), jwe, 95, 0, [
                                Xnd,
                                Wnd,
                                Znd,
                                cod,
                                bod,
                                aod,
                                $nd,
                                _nd,
                                Ynd
                            ])));
                        }
                        function nIb() {
                            nIb = geb;
                            mIb = ss((iIb(), cD(WC(xN, 1), jwe, 257, 0, [
                                hIb,
                                cIb,
                                dIb,
                                bIb,
                                fIb,
                                gIb,
                                eIb,
                                aIb,
                                _Hb
                            ])));
                        }
                        function oSc(a) {
                            var b;
                            b = RD(mQb(a, (Ywc(), hwc)), 64);
                            return a.k == (r3b(), m3b) && (b == (qpd(), ppd) || b == Xod);
                        }
                        function j0b(a, b, c) {
                            var d, e;
                            e = RD(mQb(a, (yCc(), RAc)), 75);
                            if (e) {
                                d = new Ejd;
                                Ajd(d, 0, e);
                                Cjd(d, c);
                                ye(b, d);
                            }
                        }
                        function U2b(a, b, c) {
                            var d, e, f, g;
                            g = Y2b(a);
                            d = g.d;
                            e = g.c;
                            f = a.n;
                            b && (f.a = f.a - d.b - e.a);
                            c && (f.b = f.b - d.d - e.b);
                        }
                        function OOb(a, b) {
                            var c, d;
                            c = a.f.c.length;
                            d = b.f.c.length;
                            if (c < d) return -1;
                            if (c == d) return 0;
                            return 1;
                        }
                        function S0b(a) {
                            if (a.b.c.length != 0 && !!RD(Vmb(a.b, 0), 72).a) return RD(Vmb(a.b, 0), 72).a;
                            return R0b(a);
                        }
                        function fr(a) {
                            var b;
                            if (a) {
                                b = a;
                                if (b.dc()) throw Adb(new Dvb);
                                return b.Xb(b.gc() - 1);
                            }
                            return Fr(a.Kc());
                        }
                        function Dib(a) {
                            var b;
                            Ddb(a, 0) < 0 && (a = Qdb(a));
                            return b = Ydb(Udb(a, 32)), 64 - (b != 0 ? ngb(b) : ngb(Ydb(a)) + 32);
                        }
                        function pBb() {
                            gBb();
                            if (dBb) return new oBb(null);
                            return ZAb(_Ab(), 'com.google.common.base.Strings');
                        }
                        function eyd(a, b, c, d) {
                            if (c == 1) return !a.n && (a.n = new C5d(I4, a, 1, 7)), rLd(a.n, b, d);
                            return Bxd(a, b, c, d);
                        }
                        function eBd(a, b) {
                            var c, d;
                            d = (c = new _9d, c);
                            PAd(d, b);
                            WGd((!a.A && (a.A = new iie(z7, a, 7)), a.A), d);
                            return d;
                        }
                        function xEd(a, b, c) {
                            var d, e, f, g;
                            f = null;
                            g = b;
                            e = wDd(g, iIe);
                            d = new JEd(a, c);
                            f = (LDd(d.a, d.b, e), e);
                            return f;
                        }
                        function iXd(a) {
                            var b;
                            if (!a.a || (a.Bb & 1) == 0 && a.a.Vh()) {
                                b = WVd(a);
                                ZD(b, 156) && (a.a = RD(b, 156));
                            }
                            return a.a;
                        }
                        function Be(a, b) {
                            var c, d;
                            uFb(b);
                            for(d = b.Kc(); d.Ob();){
                                c = d.Pb();
                                if (!a.Hc(c)) return false;
                            }
                            return true;
                        }
                        function sD(a, b) {
                            var c, d, e;
                            c = a.l + b.l;
                            d = a.m + b.m + (c >> 22);
                            e = a.h + b.h + (d >> 22);
                            return hD(c & dxe, d & dxe, e & exe);
                        }
                        function DD(a, b) {
                            var c, d, e;
                            c = a.l - b.l;
                            d = a.m - b.m + (c >> 22);
                            e = a.h - b.h + (d >> 22);
                            return hD(c & dxe, d & dxe, e & exe);
                        }
                        function Jpc(a) {
                            var b, c;
                            Hpc(a);
                            for(c = new Anb(a.d); c.a < c.c.c.length;){
                                b = RD(ynb(c), 105);
                                !!b.i && Ipc(b);
                            }
                        }
                        function zdb(a) {
                            var b;
                            if (ZD(a, 82)) return a;
                            b = a && a.__java$exception;
                            if (!b) {
                                b = new Cz(a);
                                gA(b);
                            }
                            return b;
                        }
                        function BGd(a) {
                            if (ZD(a, 193)) return RD(a, 123);
                            else if (!a) throw Adb(new Ogb(HIe));
                            else return null;
                        }
                        function skb(a) {
                            if (a.a.Ob()) return true;
                            if (a.a != a.e) return false;
                            a.a = new wtb(a.f.f);
                            return a.a.Ob();
                        }
                        function kmb(a, b) {
                            if (b == null) return false;
                            while(a.a != a.b){
                                if (pb(b, Imb(a))) return true;
                            }
                            return false;
                        }
                        function dHb(a, b) {
                            if (!a || !b || a == b) return false;
                            return tGb(a.d.c, b.d.c + b.d.b) && tGb(b.d.c, a.d.c + a.d.b);
                        }
                        function Tmb(a, b) {
                            var c, d;
                            c = b.Pc();
                            d = c.length;
                            if (d == 0) return false;
                            YEb(a.c, a.c.length, c);
                            return true;
                        }
                        function NBb(a, b, c) {
                            var d, e;
                            for(e = b.vc().Kc(); e.Ob();){
                                d = RD(e.Pb(), 44);
                                a.yc(d.ld(), d.md(), c);
                            }
                            return a;
                        }
                        function $Wc(a) {
                            var b, c, d;
                            b = new Yub;
                            for(d = Sub(a.d, 0); d.b != d.d.c;){
                                c = RD(evb(d), 65);
                                Mub(b, c.c);
                            }
                            return b;
                        }
                        function Pdc(a, b) {
                            var c, d;
                            for(d = new Anb(a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 72);
                                pQb(c, (Ywc(), swc), b);
                            }
                        }
                        function L9c(a, b, c) {
                            var d, e;
                            for(e = new Anb(a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 27);
                                Byd(d, d.i + b, d.j + c);
                            }
                        }
                        function Nb(a, b) {
                            if (!a) throw Adb(new agb(hc('value already present: %s', cD(WC(jJ, 1), rve, 1, 5, [
                                b
                            ]))));
                        }
                        function Aid(a, b, c, d, e) {
                            tid();
                            return $wnd.Math.min(Lid(a, b, c, d, e), Lid(c, d, a, b, fjd(new rjd(e.a, e.b))));
                        }
                        function Rdd(a, b, c, d) {
                            RD(c.b, 68);
                            RD(c.b, 68);
                            RD(d.b, 68);
                            RD(d.b, 68);
                            RD(d.b, 68);
                            Umb(d.a, new Wdd(a, b, d));
                        }
                        function NGb(a, b) {
                            a.d == (Cmd(), ymd) || a.d == Bmd ? RD(b.a, 60).c.Fc(RD(b.b, 60)) : RD(b.b, 60).c.Fc(RD(b.a, 60));
                        }
                        function Ued(a, b) {
                            var c;
                            c = ev(b.a.gc());
                            FDb(PDb(new SDb(null, new Swb(b, 1)), a.i), new ffd(a, c));
                            return c;
                        }
                        function fBd(a) {
                            var b, c;
                            c = (b = new _9d, b);
                            PAd(c, 'T');
                            WGd((!a.d && (a.d = new iie(z7, a, 11)), a.d), c);
                            return c;
                        }
                        function cHd(a) {
                            var b, c, d, e;
                            b = 1;
                            for(c = 0, e = a.gc(); c < e; ++c){
                                d = a.Vi(c);
                                b = 31 * b + (d == null ? 0 : tb(d));
                            }
                            return b;
                        }
                        function cj(a, b, c, d) {
                            var e;
                            Pb(b, a.e.Rd().gc());
                            Pb(c, a.c.Rd().gc());
                            e = a.a[b][c];
                            bD(a.a[b], c, d);
                            return e;
                        }
                        function cD(a, b, c, d, e) {
                            e.Rm = a;
                            e.Sm = b;
                            e.Tm = keb;
                            e.__elementTypeId$ = c;
                            e.__elementTypeCategory$ = d;
                            return e;
                        }
                        function vec() {
                            vec = geb;
                            uec = new xec(LAe, 0);
                            sec = new xec(oBe, 1);
                            tec = new xec(pBe, 2);
                            rec = new xec('BOTH', 3);
                        }
                        function enc() {
                            enc = geb;
                            anc = new fnc(Kye, 0);
                            bnc = new fnc(Nye, 1);
                            cnc = new fnc(Oye, 2);
                            dnc = new fnc('TOP', 3);
                        }
                        function nZb() {
                            nZb = geb;
                            jZb = new qZb('Q1', 0);
                            mZb = new qZb('Q4', 1);
                            kZb = new qZb('Q2', 2);
                            lZb = new qZb('Q3', 3);
                        }
                        function DFc() {
                            DFc = geb;
                            BFc = new EFc('OFF', 0);
                            CFc = new EFc('SINGLE_EDGE', 1);
                            AFc = new EFc('MULTI_EDGE', 2);
                        }
                        function ldd() {
                            ldd = geb;
                            kdd = new ndd('MINIMUM_SPANNING_TREE', 0);
                            jdd = new ndd('MAXIMUM_SPANNING_TREE', 1);
                        }
                        function hed() {
                            hed = geb;
                            new jGd('org.eclipse.elk.addLayoutConfig');
                            fed = new sed;
                            eed = new qed;
                            ged = new ved;
                        }
                        function EGd(a) {
                            var b, c;
                            c = (bvd(), b = new Rzd, b);
                            !!a && WGd((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a), c);
                            return c;
                        }
                        function N2c(a) {
                            var b, c, d, e;
                            e = new bnb;
                            for(d = a.Kc(); d.Ob();){
                                c = RD(d.Pb(), 27);
                                b = Q2c(c);
                                Tmb(e, b);
                            }
                            return e;
                        }
                        function Jr(a, b) {
                            var c, d;
                            Rb(b, 'predicate');
                            for(d = 0; a.Ob(); d++){
                                c = a.Pb();
                                if (b.Lb(c)) return d;
                            }
                            return -1;
                        }
                        function xSd(a, b) {
                            var c, d;
                            d = 0;
                            if (a < 64 && a <= b) {
                                b = b < 64 ? b : 63;
                                for(c = a; c <= b; c++)d = Rdb(d, Sdb(1, c));
                            }
                            return d;
                        }
                        function oQc(a, b) {
                            var c, d;
                            c = a.c;
                            d = b.e[a.p];
                            if (d < c.a.c.length - 1) return RD(Vmb(c.a, d + 1), 10);
                            return null;
                        }
                        function Bob(a) {
                            yob();
                            var b, c, d;
                            d = 0;
                            for(c = a.Kc(); c.Ob();){
                                b = c.Pb();
                                d = d + (b != null ? tb(b) : 0);
                                d = d | 0;
                            }
                            return d;
                        }
                        function wsb(a) {
                            var b, c, d;
                            b = RD(a.e && a.e(), 9);
                            d = (c = b.slice(), RD(dD(c, b), 9));
                            return new Fsb(b, d, b.length);
                        }
                        function Bdd(a, b, c) {
                            var d;
                            akb(a.a);
                            Umb(c.i, new Mdd(a));
                            d = new $Fb(RD(Wjb(a.a, b.b), 68));
                            Add(a, d, b);
                            c.f = d;
                        }
                        function bgc(a) {
                            var b;
                            X0b(a, true);
                            b = Awe;
                            nQb(a, (yCc(), KBc)) && (b += RD(mQb(a, KBc), 17).a);
                            pQb(a, KBc, sgb(b));
                        }
                        function hB(a) {
                            var b;
                            b = new dB;
                            b.a = a;
                            b.b = fB(a);
                            b.c = $C(qJ, Nve, 2, 2, 6, 1);
                            b.c[0] = gB(a);
                            b.c[1] = gB(a);
                            return b;
                        }
                        function Z7b(a) {
                            var b, c, d;
                            c = a.n;
                            d = a.o;
                            b = a.d;
                            return new Uid(c.a - b.b, c.b - b.d, d.a + (b.b + b.c), d.b + (b.d + b.a));
                        }
                        function UQb(a, b) {
                            if (!a || !b || a == b) return false;
                            return $y(a.b.c, b.b.c + b.b.b) < 0 && $y(b.b.c, a.b.c + a.b.b) < 0;
                        }
                        function Qnd(a) {
                            switch(a.g){
                                case 1:
                                    return Mnd;
                                case 2:
                                    return Lnd;
                                case 3:
                                    return Nnd;
                                default:
                                    return Ond;
                            }
                        }
                        function mec(a) {
                            switch(RD(mQb(a, (yCc(), UAc)), 171).g){
                                case 2:
                                case 4:
                                    return true;
                                default:
                                    return false;
                            }
                        }
                        function aHb(a, b, c) {
                            switch(c.g){
                                case 2:
                                    a.b = b;
                                    break;
                                case 1:
                                    a.c = b;
                                    break;
                                case 4:
                                    a.d = b;
                                    break;
                                case 3:
                                    a.a = b;
                            }
                        }
                        function Exd(a, b) {
                            switch(b){
                                case 0:
                                    !a.o && (a.o = new DVd((pvd(), mvd), X4, a, 0));
                                    a.o.c.$b();
                                    return;
                            }
                            $vd(a, b);
                        }
                        function Mad(a, b) {
                            var c, d;
                            c = RD(RD(Wjb(a.g, b.a), 42).a, 68);
                            d = RD(RD(Wjb(a.g, b.b), 42).a, 68);
                            return SQb(c, d);
                        }
                        function XGd(a, b, c) {
                            var d;
                            d = a.gc();
                            if (b > d) throw Adb(new aMd(b, d));
                            a.Si() && (c = bHd(a, c));
                            return a.Ei(b, c);
                        }
                        function eQb(a, b, c, d, e) {
                            var f, g;
                            for(g = c; g <= e; g++)for(f = b; f <= d; f++)PPb(a, f, g) || TPb(a, f, g, true, false);
                        }
                        function uid(a) {
                            tid();
                            var b, c, d;
                            c = $C(l3, Nve, 8, 2, 0, 1);
                            d = 0;
                            for(b = 0; b < 2; b++){
                                d += 0.5;
                                c[b] = Cid(d, a);
                            }
                            return c;
                        }
                        function xD(a) {
                            var b, c, d;
                            b = ~a.l + 1 & dxe;
                            c = ~a.m + (b == 0 ? 1 : 0) & dxe;
                            d = ~a.h + (b == 0 && c == 0 ? 1 : 0) & exe;
                            return hD(b, c, d);
                        }
                        function mgb(a) {
                            var b;
                            if (a < 0) return qwe;
                            else if (a == 0) return 0;
                            else {
                                for(b = hwe; (b & a) == 0; b >>= 1);
                                return b;
                            }
                        }
                        function zSd(a, b, c) {
                            if (a >= 128) return false;
                            return a < 64 ? Pdb(Cdb(Sdb(1, a), c), 0) : Pdb(Cdb(Sdb(1, a - 64), b), 0);
                        }
                        function oQb(a, b, c) {
                            return c == null ? (!a.q && (a.q = new Tsb), _jb(a.q, b)) : (!a.q && (a.q = new Tsb), Zjb(a.q, b, c)), a;
                        }
                        function pQb(a, b, c) {
                            c == null ? (!a.q && (a.q = new Tsb), _jb(a.q, b)) : (!a.q && (a.q = new Tsb), Zjb(a.q, b, c));
                            return a;
                        }
                        function KTb(a) {
                            var b, c;
                            c = new gUb;
                            kQb(c, a);
                            pQb(c, (JVb(), HVb), a);
                            b = new Tsb;
                            MTb(a, c, b);
                            LTb(a, c, b);
                            return c;
                        }
                        function cIc(a) {
                            var b, c;
                            b = a.t - a.k[a.o.p] * a.d + a.j[a.o.p] > a.f;
                            c = a.u + a.e[a.o.p] * a.d > a.f * a.s * a.d;
                            return b || c;
                        }
                        function qmc(a, b) {
                            var c, d, e, f;
                            c = false;
                            d = a.a[b].length;
                            for(f = 0; f < d - 1; f++){
                                e = f + 1;
                                c = c | rmc(a, b, f, e);
                            }
                            return c;
                        }
                        function Emc(a) {
                            var b, c, d, e;
                            for(c = a.a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                Jmc(a, b, (qpd(), npd));
                                Jmc(a, b, Yod);
                            }
                        }
                        function tvc() {
                            tvc = geb;
                            svc = ss((ovc(), cD(WC(iX, 1), jwe, 259, 0, [
                                fvc,
                                hvc,
                                ivc,
                                jvc,
                                kvc,
                                lvc,
                                nvc,
                                evc,
                                gvc,
                                mvc
                            ])));
                        }
                        function fEc() {
                            fEc = geb;
                            eEc = ss((aEc(), cD(WC(vX, 1), jwe, 243, 0, [
                                $Dc,
                                VDc,
                                YDc,
                                WDc,
                                XDc,
                                SDc,
                                ZDc,
                                _Dc,
                                TDc,
                                UDc
                            ])));
                        }
                        function huc() {
                            huc = geb;
                            fuc = new iuc(LAe, 0);
                            euc = new iuc('INCOMING_ONLY', 1);
                            guc = new iuc('OUTGOING_ONLY', 2);
                        }
                        function HC() {
                            HC = geb;
                            GC = {
                                'boolean': IC,
                                'number': JC,
                                'string': LC,
                                'object': KC,
                                'function': KC,
                                'undefined': MC
                            };
                        }
                        function pfb() {
                            ++kfb;
                            this.o = null;
                            this.k = null;
                            this.j = null;
                            this.d = null;
                            this.b = null;
                            this.n = null;
                            this.a = null;
                        }
                        function pj(a, b) {
                            this.c = a;
                            this.d = b;
                            this.b = this.d / this.c.c.Rd().gc() | 0;
                            this.a = this.d % this.c.c.Rd().gc();
                        }
                        function R$d(a, b) {
                            this.b = a;
                            N$d.call(this, (RD(QHd(xYd((lTd(), kTd).o), 10), 19), b.i), b.g);
                            this.a = (lYd(), kYd);
                        }
                        function vB(a, b, c) {
                            this.q = new $wnd.Date;
                            this.q.setFullYear(a + Owe, b, c);
                            this.q.setHours(0, 0, 0, 0);
                            mB(this, 0);
                        }
                        function ckb(a, b) {
                            mFb(a >= 0, 'Negative initial capacity');
                            mFb(b >= 0, 'Non-positive load factor');
                            akb(this);
                        }
                        function iib(a, b, c, d, e) {
                            var f, g;
                            g = a.length;
                            f = c.length;
                            if (b < 0 || d < 0 || e < 0 || b + e > g || d + e > f) throw Adb(new ueb);
                        }
                        function zob(a, b) {
                            yob();
                            var c, d, e, f, g;
                            g = false;
                            for(d = b, e = 0, f = d.length; e < f; ++e){
                                c = d[e];
                                g = g | a.Fc(c);
                            }
                            return g;
                        }
                        function Wyb(a, b, c) {
                            var d, e;
                            d = new Fzb(b, c);
                            e = new Gzb;
                            a.b = Uyb(a, a.b, d, e);
                            e.b || ++a.c;
                            a.b.b = false;
                            return e.d;
                        }
                        function omb(a) {
                            var b;
                            b = a.a[a.b];
                            if (b == null) return null;
                            bD(a.a, a.b, null);
                            a.b = a.b + 1 & a.a.length - 1;
                            return b;
                        }
                        function oD(a) {
                            var b, c;
                            c = ngb(a.h);
                            if (c == 32) {
                                b = ngb(a.m);
                                return b == 32 ? ngb(a.l) + 32 : b + 20 - 10;
                            } else return c - 12;
                        }
                        function $5d(a) {
                            var b;
                            if (!a.c || (a.Bb & 1) == 0 && (a.c.Db & 64) != 0) {
                                b = WVd(a);
                                ZD(b, 90) && (a.c = RD(b, 29));
                            }
                            return a.c;
                        }
                        function OGb(a) {
                            var b, c;
                            for(c = new Anb(a.a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 60);
                                b.d.c = -b.d.c - b.d.b;
                            }
                            IGb(a);
                        }
                        function zYb(a) {
                            var b, c;
                            for(c = new Anb(a.a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 86);
                                b.g.c = -b.g.c - b.g.b;
                            }
                            uYb(a);
                        }
                        function Jmc(a, b, c) {
                            var d, e, f, g;
                            g = aMc(b, c);
                            f = 0;
                            for(e = g.Kc(); e.Ob();){
                                d = RD(e.Pb(), 12);
                                Zjb(a.c, d, sgb(f++));
                            }
                        }
                        function qMc(a, b, c) {
                            var d;
                            d = new bnb;
                            sMc(a, b, d, (qpd(), Xod), true, false);
                            sMc(a, c, d, ppd, false, false);
                            return d;
                        }
                        function xjd(a) {
                            var b, c, d, e, f;
                            b = new pjd;
                            for(d = a, e = 0, f = d.length; e < f; ++e){
                                c = d[e];
                                b.a += c.a;
                                b.b += c.b;
                            }
                            return b;
                        }
                        function CEd(a, b, c) {
                            var d, e, f, g;
                            f = null;
                            g = b;
                            e = wDd(g, 'labels');
                            d = new fFd(a, c);
                            f = (bEd(d.a, d.b, e), e);
                            return f;
                        }
                        function Jee(a, b, c, d) {
                            var e;
                            e = Ree(a, b, c, d);
                            if (!e) {
                                e = Iee(a, c, d);
                                if (!!e && !Eee(a, b, e)) return null;
                            }
                            return e;
                        }
                        function Mee(a, b, c, d) {
                            var e;
                            e = See(a, b, c, d);
                            if (!e) {
                                e = Lee(a, c, d);
                                if (!!e && !Eee(a, b, e)) return null;
                            }
                            return e;
                        }
                        function Cb(a, b, c) {
                            Qb(b);
                            if (c.Ob()) {
                                Vhb(b, Fb(c.Pb()));
                                while(c.Ob()){
                                    Vhb(b, a.a);
                                    Vhb(b, Fb(c.Pb()));
                                }
                            }
                            return b;
                        }
                        function Xb(a, b) {
                            var c;
                            for(c = 0; c < a.a.a.length; c++){
                                if (!RD(kob(a.a, c), 178).Lb(b)) return false;
                            }
                            return true;
                        }
                        function fB(a) {
                            var b;
                            if (a == 0) return 'Etc/GMT';
                            if (a < 0) {
                                a = -a;
                                b = 'Etc/GMT-';
                            } else b = 'Etc/GMT+';
                            return b + iB(a);
                        }
                        function DA(a) {
                            var b;
                            if (a.b <= 0) return false;
                            b = qhb('MLydhHmsSDkK', Fhb(ihb(a.c, 0)));
                            return b > 1 || b >= 0 && a.b < 3;
                        }
                        function nD(a) {
                            var b, c, d;
                            b = ~a.l + 1 & dxe;
                            c = ~a.m + (b == 0 ? 1 : 0) & dxe;
                            d = ~a.h + (b == 0 && c == 0 ? 1 : 0) & exe;
                            a.l = b;
                            a.m = c;
                            a.h = d;
                        }
                        function Cob(a) {
                            yob();
                            var b, c, d;
                            d = 1;
                            for(c = a.Kc(); c.Ob();){
                                b = c.Pb();
                                d = 31 * d + (b != null ? tb(b) : 0);
                                d = d | 0;
                            }
                            return d;
                        }
                        function kD(a, b, c, d, e) {
                            var f;
                            f = BD(a, b);
                            c && nD(f);
                            if (e) {
                                a = mD(a, b);
                                d ? eD = xD(a) : eD = hD(a.l, a.m, a.h);
                            }
                            return f;
                        }
                        function Qlc(a, b, c) {
                            a.g = Wlc(a, b, (qpd(), Xod), a.b);
                            a.d = Wlc(a, c, Xod, a.b);
                            if (a.g.c == 0 || a.d.c == 0) return;
                            Tlc(a);
                        }
                        function Rlc(a, b, c) {
                            a.g = Wlc(a, b, (qpd(), ppd), a.j);
                            a.d = Wlc(a, c, ppd, a.j);
                            if (a.g.c == 0 || a.d.c == 0) return;
                            Tlc(a);
                        }
                        function Xyd(a, b) {
                            switch(b){
                                case 7:
                                    return !!a.e && a.e.i != 0;
                                case 8:
                                    return !!a.d && a.d.i != 0;
                            }
                            return wyd(a, b);
                        }
                        function STb(a, b) {
                            switch(b.g){
                                case 0:
                                    ZD(a.b, 641) || (a.b = new tUb);
                                    break;
                                case 1:
                                    ZD(a.b, 642) || (a.b = new zUb);
                            }
                        }
                        function tbd(a) {
                            switch(a.g){
                                case 0:
                                    return new _dd;
                                default:
                                    throw Adb(new agb(eGe + (a.f != null ? a.f : '' + a.g)));
                            }
                        }
                        function bdd(a) {
                            switch(a.g){
                                case 0:
                                    return new vdd;
                                default:
                                    throw Adb(new agb(eGe + (a.f != null ? a.f : '' + a.g)));
                            }
                        }
                        function LCc(a, b, c) {
                            return !QDb(CDb(new SDb(null, new Swb(a.c, 16)), new PAb(new gsd(b, c)))).Bd((xDb(), wDb));
                        }
                        function mWc(a, b) {
                            return cjd(jWc(RD(mQb(b, (h_c(), H$c)), 88)), new rjd(a.c.e.a - a.b.e.a, a.c.e.b - a.b.e.b)) <= 0;
                        }
                        function dve(a, b) {
                            while(a.g == null && !a.c ? sId(a) : a.g == null || a.i != 0 && RD(a.g[a.i - 1], 51).Ob())mFd(b, tId(a));
                        }
                        function sYb(a) {
                            var b, c;
                            for(c = new Anb(a.a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 86);
                                b.f.$b();
                            }
                            NYb(a.b, a);
                            tYb(a);
                        }
                        function Ijd(a) {
                            var b, c, d;
                            b = new Ejd;
                            for(d = Sub(a, 0); d.b != d.d.c;){
                                c = RD(evb(d), 8);
                                hu(b, 0, new sjd(c));
                            }
                            return b;
                        }
                        function DDb(a) {
                            var b;
                            LCb(a);
                            b = new IEb;
                            if (a.a.Bd(b)) return Kvb(), new Ovb(uFb(b.a));
                            return Kvb(), Kvb(), Jvb;
                        }
                        function Dxd(a, b, c) {
                            switch(b){
                                case 0:
                                    !a.o && (a.o = new DVd((pvd(), mvd), X4, a, 0));
                                    CVd(a.o, c);
                                    return;
                            }
                            Wvd(a, b, c);
                        }
                        function bXc(a, b, c) {
                            this.g = a;
                            this.e = new pjd;
                            this.f = new pjd;
                            this.d = new Yub;
                            this.b = new Yub;
                            this.a = b;
                            this.c = c;
                        }
                        function V9c(a, b, c, d) {
                            this.b = new bnb;
                            this.n = new bnb;
                            this.i = d;
                            this.j = c;
                            this.s = a;
                            this.t = b;
                            this.r = 0;
                            this.d = 0;
                        }
                        function gHd(a, b) {
                            if (!a.Li() && b == null) throw Adb(new agb("The 'no null' constraint is violated"));
                            return b;
                        }
                        function ohb(a) {
                            var b, c;
                            b = 0;
                            for(c = 0; c < a.length; c++)b = (b << 5) - b + (BFb(c, a.length), a.charCodeAt(c)) | 0;
                            return b;
                        }
                        function Myb(a, b) {
                            var c, d, e;
                            e = a.b;
                            while(e){
                                c = a.a.Ne(b, e.d);
                                if (c == 0) return e;
                                d = c < 0 ? 0 : 1;
                                e = e.a[d];
                            }
                            return null;
                        }
                        function LBb(a, b, c) {
                            var d, e;
                            d = (Geb(), SSb(c) ? true : false);
                            e = RD(b.xc(d), 15);
                            if (!e) {
                                e = new bnb;
                                b.zc(d, e);
                            }
                            e.Fc(c);
                        }
                        function q6c(a, b) {
                            var c, d;
                            c = RD(Gxd(a, (X7c(), A7c)), 17).a;
                            d = RD(Gxd(b, A7c), 17).a;
                            return c == d ? -1 : c < d ? -1 : c > d ? 1 : 0;
                        }
                        function ICc(a) {
                            Rmb(a.c, (hed(), fed));
                            if (_y(a.a, Kfb(UD(iGd((QCc(), OCc)))))) return new asd;
                            return new csd(a);
                        }
                        function fs(a) {
                            while(!a.d || !a.d.Ob()){
                                if (!!a.b && !nmb(a.b)) a.d = RD(smb(a.b), 51);
                                else return null;
                            }
                            return a.d;
                        }
                        function BVc(a) {
                            switch(a.g){
                                case 1:
                                    return EEe;
                                default:
                                case 2:
                                    return 0;
                                case 3:
                                    return Gze;
                                case 4:
                                    return FEe;
                            }
                        }
                        function fte() {
                            Vse();
                            var a;
                            if (Cse) return Cse;
                            a = Zse(hte('M', true));
                            a = $se(hte('M', false), a);
                            Cse = a;
                            return Cse;
                        }
                        function ttd() {
                            ttd = geb;
                            qtd = new utd('ELK', 0);
                            rtd = new utd('JSON', 1);
                            ptd = new utd('DOT', 2);
                            std = new utd('SVG', 3);
                        }
                        function TEc() {
                            TEc = geb;
                            SEc = new UEc('STACKED', 0);
                            QEc = new UEc('REVERSE_STACKED', 1);
                            REc = new UEc('SEQUENCED', 2);
                        }
                        function LZc() {
                            LZc = geb;
                            KZc = new MZc(LAe, 0);
                            JZc = new MZc('MIDDLE_TO_MIDDLE', 1);
                            IZc = new MZc('AVOID_OVERLAP', 2);
                        }
                        function sgc() {
                            sgc = geb;
                            qgc = new Lgc;
                            rgc = new Ngc;
                            pgc = new Dgc;
                            ogc = new Pgc;
                            ngc = new Hgc;
                            mgc = (uFb(ngc), new nrb);
                        }
                        function vnd() {
                            vnd = geb;
                            tnd = new A3b(15);
                            snd = new mGd((umd(), tld), tnd);
                            und = Qld;
                            ond = Ekd;
                            pnd = kld;
                            rnd = nld;
                            qnd = mld;
                        }
                        function wgd(a, b) {
                            var c, d, e, f, g;
                            for(d = b, e = 0, f = d.length; e < f; ++e){
                                c = d[e];
                                g = new Ggd(a);
                                c.hf(g);
                                Bgd(g);
                            }
                            akb(a.f);
                        }
                        function xw(a, b) {
                            var c;
                            if (b === a) return true;
                            if (ZD(b, 229)) {
                                c = RD(b, 229);
                                return pb(a.Zb(), c.Zb());
                            }
                            return false;
                        }
                        function Q_b(a, b) {
                            if (R_b(a, b)) {
                                Rc(a.b, RD(mQb(b, (Ywc(), ewc)), 21), b);
                                Mub(a.a, b);
                                return true;
                            } else return false;
                        }
                        function u6b(a) {
                            var b, c;
                            b = RD(mQb(a, (Ywc(), Iwc)), 10);
                            if (b) {
                                c = b.c;
                                Ymb(c.a, b);
                                c.a.c.length == 0 && Ymb(Y2b(b).b, c);
                            }
                        }
                        function dfc(a, b) {
                            if (nQb(a, (Ywc(), zwc)) && nQb(b, zwc)) return RD(mQb(b, zwc), 17).a - RD(mQb(a, zwc), 17).a;
                            return 0;
                        }
                        function ifc(a, b) {
                            if (nQb(a, (Ywc(), zwc)) && nQb(b, zwc)) return RD(mQb(a, zwc), 17).a - RD(mQb(b, zwc), 17).a;
                            return 0;
                        }
                        function kBb(a) {
                            if (dBb) return $C(JL, Xxe, 581, 0, 0, 1);
                            return RD(anb(a.a, $C(JL, Xxe, 581, a.a.c.length, 0, 1)), 856);
                        }
                        function yn(a, b, c, d) {
                            fn();
                            return new Nx(cD(WC(UK, 1), Zve, 44, 0, [
                                (ck(a, b), new gp(a, b)),
                                (ck(c, d), new gp(c, d))
                            ]));
                        }
                        function bBd(a, b, c) {
                            var d, e;
                            e = (d = new q4d, d);
                            yBd(e, b, c);
                            WGd((!a.q && (a.q = new C5d(s7, a, 11, 10)), a.q), e);
                            return e;
                        }
                        function xAd(a) {
                            var b, c, d, e;
                            e = meb(pAd, a);
                            c = e.length;
                            d = $C(qJ, Nve, 2, c, 6, 1);
                            for(b = 0; b < c; ++b)d[b] = e[b];
                            return d;
                        }
                        function jwb(a, b) {
                            var c;
                            if (b * 2 + 1 >= a.b.c.length) return;
                            jwb(a, 2 * b + 1);
                            c = 2 * b + 2;
                            c < a.b.c.length && jwb(a, c);
                            kwb(a, b);
                        }
                        function sKc(a, b) {
                            var c, d;
                            for(d = Sub(a, 0); d.b != d.d.c;){
                                c = RD(evb(d), 219);
                                if (c.e.length > 0) {
                                    b.Cd(c);
                                    c.i && zKc(c);
                                }
                            }
                        }
                        function Ejb(a, b, c) {
                            var d;
                            for(d = c - 1; d >= 0 && a[d] === b[d]; d--);
                            return d < 0 ? 0 : Ldb(Cdb(a[d], yxe), Cdb(b[d], yxe)) ? -1 : 1;
                        }
                        function it(a, b, c) {
                            var d, e;
                            this.g = a;
                            this.c = b;
                            this.a = this;
                            this.d = this;
                            e = Wp(c);
                            d = $C(UG, ewe, 227, e, 0, 1);
                            this.b = d;
                        }
                        function fQb(a, b, c, d, e) {
                            var f, g;
                            for(g = c; g <= e; g++)for(f = b; f <= d; f++){
                                if (PPb(a, f, g)) return true;
                            }
                            return false;
                        }
                        function Dc(a, b) {
                            var c, d;
                            for(d = a.Zb().Cc().Kc(); d.Ob();){
                                c = RD(d.Pb(), 16);
                                if (c.Hc(b)) return true;
                            }
                            return false;
                        }
                        function iu(a, b, c) {
                            var d, e, f, g;
                            uFb(c);
                            g = false;
                            f = a.fd(b);
                            for(e = c.Kc(); e.Ob();){
                                d = e.Pb();
                                f.Rb(d);
                                g = true;
                            }
                            return g;
                        }
                        function NMd(a, b) {
                            var c, d;
                            d = RD(Ywd(a.a, 4), 129);
                            c = $C(d6, IJe, 424, b, 0, 1);
                            d != null && hib(d, 0, c, 0, d.length);
                            return c;
                        }
                        function hSd(a, b) {
                            var c;
                            c = new lSd((a.f & 256) != 0, a.i, a.a, a.d, (a.f & 16) != 0, a.j, a.g, b);
                            a.e != null || (c.c = a);
                            return c;
                        }
                        function Tv(a, b) {
                            var c;
                            if (a === b) return true;
                            else if (ZD(b, 85)) {
                                c = RD(b, 85);
                                return Rx(gn(a), c.vc());
                            }
                            return false;
                        }
                        function Vjb(a, b, c) {
                            var d, e;
                            for(e = c.Kc(); e.Ob();){
                                d = RD(e.Pb(), 44);
                                if (a.Be(b, d.md())) return true;
                            }
                            return false;
                        }
                        function lmc(a, b, c) {
                            if (!a.d[b.p][c.p]) {
                                kmc(a, b, c);
                                a.d[b.p][c.p] = true;
                                a.d[c.p][b.p] = true;
                            }
                            return a.a[b.p][c.p];
                        }
                        function vMc(a, b) {
                            var c;
                            if (!a || a == b || !nQb(b, (Ywc(), pwc))) return false;
                            c = RD(mQb(b, (Ywc(), pwc)), 10);
                            return c != a;
                        }
                        function Bhe(a) {
                            switch(a.i){
                                case 2:
                                    return true;
                                case 1:
                                    return false;
                                case -1:
                                    ++a.c;
                                default:
                                    return a.$l();
                            }
                        }
                        function Che(a) {
                            switch(a.i){
                                case -2:
                                    return true;
                                case -1:
                                    return false;
                                case 1:
                                    --a.c;
                                default:
                                    return a._l();
                            }
                        }
                        function bgb(a) {
                            oz.call(this, 'The given string does not match the expected format for individual spacings.', a);
                        }
                        function J6c(a, b) {
                            var c;
                            b.Ug('Min Size Preprocessing', 1);
                            c = vsd(a);
                            Ixd(a, (X6c(), U6c), c.a);
                            Ixd(a, R6c, c.b);
                            b.Vg();
                        }
                        function Djd(a) {
                            var b, c, d;
                            b = 0;
                            d = $C(l3, Nve, 8, a.b, 0, 1);
                            c = Sub(a, 0);
                            while(c.b != c.d.c)d[b++] = RD(evb(c), 8);
                            return d;
                        }
                        function Ajd(a, b, c) {
                            var d, e, f;
                            d = new Yub;
                            for(f = Sub(c, 0); f.b != f.d.c;){
                                e = RD(evb(f), 8);
                                Mub(d, new sjd(e));
                            }
                            iu(a, b, d);
                        }
                        function az(a, b) {
                            var c;
                            c = Bdb(a, b);
                            if (Ldb($db(a, b), 0) | Jdb($db(a, c), 0)) return c;
                            return Bdb(Sve, $db(Udb(c, 63), 1));
                        }
                        function le(a, b) {
                            var c, d;
                            c = RD(a.d.Bc(b), 16);
                            if (!c) return null;
                            d = a.e.hc();
                            d.Gc(c);
                            a.e.d -= c.gc();
                            c.$b();
                            return d;
                        }
                        function Dyb(a) {
                            var b;
                            b = a.a.c.length;
                            if (b > 0) return lyb(b - 1, a.a.c.length), Xmb(a.a, b - 1);
                            else throw Adb(new Srb);
                        }
                        function nFb(a, b, c) {
                            if (a > b) throw Adb(new agb(_xe + a + aye + b));
                            if (a < 0 || b > c) throw Adb(new xeb(_xe + a + bye + b + Qxe + c));
                        }
                        function yXd(a, b) {
                            if (a.D == null && a.B != null) {
                                a.D = a.B;
                                a.B = null;
                            }
                            JXd(a, b == null ? null : (uFb(b), b));
                            !!a.C && a.hl(null);
                        }
                        function JCc(a, b) {
                            var c;
                            c = iGd((QCc(), OCc)) != null && b.Sg() != null ? Kfb(UD(b.Sg())) / Kfb(UD(iGd(OCc))) : 1;
                            Zjb(a.b, b, c);
                        }
                        function $Lc(a, b) {
                            var c, d;
                            d = a.c[b];
                            if (d == 0) return;
                            a.c[b] = 0;
                            a.d -= d;
                            c = b + 1;
                            while(c < a.a.length){
                                a.a[c] -= d;
                                c += c & -c;
                            }
                        }
                        function VHd(a) {
                            var b;
                            ++a.j;
                            if (a.i == 0) a.g = null;
                            else if (a.i < a.g.length) {
                                b = a.g;
                                a.g = a.aj(a.i);
                                hib(b, 0, a.g, 0, a.i);
                            }
                        }
                        function Ned(a, b, c) {
                            if (b < 0) throw Adb(new veb(zGe + b));
                            if (b < a.j.c.length) $mb(a.j, b, c);
                            else {
                                Led(a, b);
                                Rmb(a.j, c);
                            }
                        }
                        function uhd(a) {
                            if (!a.a || (a.a.i & 8) == 0) throw Adb(new dgb('Enumeration class expected for layout option ' + a.f));
                        }
                        function y1d(a) {
                            var b;
                            b = (!a.a && (a.a = new C5d(l7, a, 9, 5)), a.a);
                            if (b.i != 0) return N1d(RD(QHd(b, 0), 694));
                            return null;
                        }
                        function yr(a) {
                            var b;
                            Qb(a);
                            Mb(true, 'numberToAdvance must be nonnegative');
                            for(b = 0; b < 0 && gs(a); b++)hs(a);
                            return b;
                        }
                        function eSb() {
                            eSb = geb;
                            bSb = (VRb(), URb);
                            aSb = new lGd(vze, bSb);
                            _Rb = new jGd(wze);
                            cSb = new jGd(xze);
                            dSb = new jGd(yze);
                        }
                        function s_c() {
                            s_c = geb;
                            r_c = new t_c(MAe, 0);
                            p_c = new t_c(QEe, 1);
                            q_c = new t_c('FAN', 2);
                            o_c = new t_c('CONSTRAINT', 3);
                        }
                        function g4c() {
                            g4c = geb;
                            d4c = new i4c(LAe, 0);
                            e4c = new i4c('RADIAL_COMPACTION', 1);
                            f4c = new i4c('WEDGE_COMPACTION', 2);
                        }
                        function lFc() {
                            lFc = geb;
                            iFc = new mFc('CONSERVATIVE', 0);
                            jFc = new mFc('CONSERVATIVE_SOFT', 1);
                            kFc = new mFc('SLOPPY', 2);
                        }
                        function xBb() {
                            xBb = geb;
                            uBb = new yBb('CONCURRENT', 0);
                            vBb = new yBb('IDENTITY_FINISH', 1);
                            wBb = new yBb('UNORDERED', 2);
                        }
                        function NXb() {
                            NXb = geb;
                            LXb = Wx(cD(WC(s3, 1), jwe, 88, 0, [
                                (Cmd(), ymd),
                                zmd
                            ]));
                            MXb = Wx(cD(WC(s3, 1), jwe, 88, 0, [
                                Bmd,
                                xmd
                            ]));
                        }
                        function rb(a) {
                            return bE(a) ? qJ : _D(a) ? VI : $D(a) ? QI : YD(a) ? a.Rm : aD(a) ? a.Rm : a.Rm || Array.isArray(a) && WC(hI, 1) || hI;
                        }
                        function Qje(a) {
                            return !a ? null : (a.i & 1) != 0 ? a == xdb ? QI : a == kE ? bJ : a == jE ? ZI : a == iE ? VI : a == lE ? eJ : a == wdb ? lJ : a == gE ? RI : SI : a;
                        }
                        function CIb(a) {
                            if (a.c != a.b.b || a.i != a.g.b) {
                                aFb(a.a.c, 0);
                                Tmb(a.a, a.b);
                                Tmb(a.a, a.g);
                                a.c = a.b.b;
                                a.i = a.g.b;
                            }
                            return a.a;
                        }
                        function vmb(a, b) {
                            var c, d;
                            c = a.a.length - 1;
                            while(b != a.b){
                                d = b - 1 & c;
                                bD(a.a, b, a.a[d]);
                                b = d;
                            }
                            bD(a.a, a.b, null);
                            a.b = a.b + 1 & c;
                        }
                        function umb(a, b) {
                            var c, d;
                            c = a.a.length - 1;
                            a.c = a.c - 1 & c;
                            while(b != a.c){
                                d = b + 1 & c;
                                bD(a.a, b, a.a[d]);
                                b = d;
                            }
                            bD(a.a, a.c, null);
                        }
                        function Smb(a, b, c) {
                            var d, e;
                            wFb(b, a.c.length);
                            d = c.Pc();
                            e = d.length;
                            if (e == 0) return false;
                            YEb(a.c, b, d);
                            return true;
                        }
                        function otb(a, b, c) {
                            var d, e, f, g;
                            for(e = c, f = 0, g = e.length; f < g; ++f){
                                d = e[f];
                                if (a.b.Be(b, d.ld())) return d;
                            }
                            return null;
                        }
                        function Tnb(a) {
                            var b, c, d, e, f;
                            f = 1;
                            for(c = a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                f = 31 * f + (b != null ? tb(b) : 0);
                                f = f | 0;
                            }
                            return f;
                        }
                        function ss(a) {
                            var b, c, d, e, f;
                            b = {};
                            for(d = a, e = 0, f = d.length; e < f; ++e){
                                c = d[e];
                                b[':' + (c.f != null ? c.f : '' + c.g)] = c;
                            }
                            return b;
                        }
                        function tSd(a) {
                            var b, c;
                            if (a == null) return null;
                            for(b = 0, c = a.length; b < c; b++){
                                if (!GSd(a[b])) return a[b];
                            }
                            return null;
                        }
                        function gKb(a, b) {
                            if (!a) return 0;
                            if (b && !a.j) return 0;
                            if (ZD(a, 127)) {
                                if (RD(a, 127).a.b == 0) return 0;
                            }
                            return a.jf();
                        }
                        function hKb(a, b) {
                            if (!a) return 0;
                            if (b && !a.k) return 0;
                            if (ZD(a, 127)) {
                                if (RD(a, 127).a.a == 0) return 0;
                            }
                            return a.kf();
                        }
                        function orc(a, b) {
                            if (nQb(a, (Ywc(), zwc)) && nQb(b, zwc)) return hgb(RD(mQb(a, zwc), 17).a, RD(mQb(b, zwc), 17).a);
                            return 0;
                        }
                        function EHc(a) {
                            var b, c, d;
                            d = 0;
                            for(c = new is(Mr(a.a.Kc(), new ir)); gs(c);){
                                b = RD(hs(c), 18);
                                b.c.i == b.d.i || ++d;
                            }
                            return d;
                        }
                        function Gad(a, b) {
                            var c, d, e;
                            e = b - a.f;
                            for(d = new Anb(a.d); d.a < d.c.c.length;){
                                c = RD(ynb(d), 315);
                                fad(c, c.e, c.f + e);
                            }
                            a.f = b;
                        }
                        function YVd(a, b) {
                            var c, d, e;
                            d = a.Yk(b, null);
                            e = null;
                            if (b) {
                                e = (jTd(), c = new s2d, c);
                                l2d(e, a.r);
                            }
                            d = XVd(a, e, d);
                            !!d && d.oj();
                        }
                        function P0b(a, b) {
                            var c, d, e;
                            c = a;
                            e = 0;
                            do {
                                if (c == b) return e;
                                d = c.e;
                                if (!d) throw Adb(new _fb);
                                c = Y2b(d);
                                ++e;
                            }while (true);
                        }
                        function uRb(a) {
                            var b, c, d, e;
                            d = a.b.a;
                            for(c = d.a.ec().Kc(); c.Ob();){
                                b = RD(c.Pb(), 567);
                                e = new DSb(b, a.e, a.f);
                                Rmb(a.g, e);
                            }
                        }
                        function DZb(a) {
                            var b;
                            b = new XZb(a);
                            t$b(a.a, BZb, new mob(cD(WC(wQ, 1), rve, 382, 0, [
                                b
                            ])));
                            !!b.d && Rmb(b.f, b.d);
                            return b.f;
                        }
                        function M2b(a, b) {
                            var c;
                            for(c = 0; c < b.length; c++){
                                if (a == (BFb(c, b.length), b.charCodeAt(c))) return true;
                            }
                            return false;
                        }
                        function BSd(a, b) {
                            return b < a.length && (BFb(b, a.length), a.charCodeAt(b) != 63) && (BFb(b, a.length), a.charCodeAt(b) != 35);
                        }
                        function trc(a, b, c, d) {
                            nrc(this);
                            this.c = $C(jR, WAe, 10, a.a.c.length, 0, 1);
                            this.e = b;
                            anb(a.a, this.c);
                            this.f = c;
                            this.b = d;
                        }
                        function Cz(a) {
                            Az();
                            ez(this);
                            gz(this);
                            this.e = a;
                            hz(this, a);
                            this.g = a == null ? vve : jeb(a);
                            this.a = '';
                            this.b = a;
                            this.a = '';
                        }
                        function Pad() {
                            this.a = new Qad;
                            this.f = new Sad(this);
                            this.b = new Uad(this);
                            this.i = new Wad(this);
                            this.e = new Yad(this);
                        }
                        function Ks() {
                            Js.call(this, new hub(Sv(16)));
                            dk(2, Mve);
                            this.b = 2;
                            this.a = new ct(null, null, 0, null);
                            Ss(this.a, this.a);
                        }
                        function NC(a) {
                            HC();
                            throw Adb(new aC("Unexpected typeof result '" + a + "'; please report this bug to the GWT team"));
                        }
                        function AVc(a, b, c) {
                            if ($wnd.Math.abs(b - a) < DEe || $wnd.Math.abs(c - a) < DEe) return true;
                            return b - a > DEe ? a - c > DEe : c - a > DEe;
                        }
                        function vjd(a, b) {
                            var c;
                            for(c = 0; c < b.length; c++){
                                if (a == (BFb(c, b.length), b.charCodeAt(c))) return true;
                            }
                            return false;
                        }
                        function HSd(a) {
                            var b, c;
                            if (a == null) return false;
                            for(b = 0, c = a.length; b < c; b++){
                                if (!GSd(a[b])) return false;
                            }
                            return true;
                        }
                        function M8c(a, b) {
                            var c, d, e;
                            d = false;
                            c = b.q.d;
                            if (b.d < a.b) {
                                e = dad(b.q, a.b);
                                if (b.q.d > e) {
                                    ead(b.q, e);
                                    d = c != b.q.d;
                                }
                            }
                            return d;
                        }
                        function C3c(a, b) {
                            var c, d, e, f, g, h, i, j;
                            i = b.i;
                            j = b.j;
                            d = a.f;
                            e = d.i;
                            f = d.j;
                            g = i - e;
                            h = j - f;
                            c = $wnd.Math.sqrt(g * g + h * h);
                            return c;
                        }
                        function pBd(a, b) {
                            var c, d;
                            d = Hvd(a);
                            if (!d) {
                                !$Ad && ($Ad = new L5d);
                                c = (gSd(), nSd(b));
                                d = new Sde(c);
                                WGd(d.El(), a);
                            }
                            return d;
                        }
                        function Sc(a, b) {
                            var c, d;
                            c = RD(a.c.Bc(b), 16);
                            if (!c) return a.jc();
                            d = a.hc();
                            d.Gc(c);
                            a.d -= c.gc();
                            c.$b();
                            return a.mc(d);
                        }
                        function tKc(a, b) {
                            var c, d;
                            d = Kwb(a.d, 1) != 0;
                            c = true;
                            while(c){
                                c = false;
                                c = b.c.mg(b.e, d);
                                c = c | DKc(a, b, d, false);
                                d = !d;
                            }
                            yKc(a);
                        }
                        function omc(a, b, c, d) {
                            var e, f;
                            a.a = b;
                            f = d ? 0 : 1;
                            a.f = (e = new mmc(a.c, a.a, c, f), new Pmc(c, a.a, e, a.e, a.b, a.c == (RKc(), PKc)));
                        }
                        function Imb(a) {
                            var b;
                            sFb(a.a != a.b);
                            b = a.d.a[a.a];
                            zmb(a.b == a.d.c && b != null);
                            a.c = a.a;
                            a.a = a.a + 1 & a.d.a.length - 1;
                            return b;
                        }
                        function Vib(a) {
                            var b;
                            if (a.c != 0) return a.c;
                            for(b = 0; b < a.a.length; b++)a.c = a.c * 33 + (a.a[b] & -1);
                            a.c = a.c * a.e;
                            return a.c;
                        }
                        function Oue(a) {
                            var b;
                            if (!(a.c.c < 0 ? a.a >= a.c.b : a.a <= a.c.b)) throw Adb(new Dvb);
                            b = a.a;
                            a.a += a.c.c;
                            ++a.b;
                            return sgb(b);
                        }
                        function h5b(a) {
                            var b;
                            b = new y2b(a.a);
                            kQb(b, a);
                            pQb(b, (Ywc(), Awc), a);
                            b.o.a = a.g;
                            b.o.b = a.f;
                            b.n.a = a.i;
                            b.n.b = a.j;
                            return b;
                        }
                        function tVc(a) {
                            return (qpd(), hpd).Hc(a.j) ? Kfb(UD(mQb(a, (Ywc(), Swc)))) : xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                a.i.n,
                                a.n,
                                a.a
                            ])).b;
                        }
                        function ZJc(a) {
                            var b;
                            b = vfd(XJc);
                            RD(mQb(a, (Ywc(), kwc)), 21).Hc((ovc(), kvc)) && pfd(b, (sXb(), pXb), (hcc(), Ybc));
                            return b;
                        }
                        function M2c(a) {
                            var b, c, d, e;
                            e = new _sb;
                            for(d = new Anb(a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 27);
                                b = P2c(c);
                                ye(e, b);
                            }
                            return e;
                        }
                        function hIc(a) {
                            var b, c;
                            for(c = new Anb(a.r); c.a < c.c.c.length;){
                                b = RD(ynb(c), 10);
                                if (a.n[b.p] <= 0) return b;
                            }
                            return null;
                        }
                        function LGb(a, b, c) {
                            var d, e;
                            for(e = b.a.a.ec().Kc(); e.Ob();){
                                d = RD(e.Pb(), 60);
                                if (MGb(a, d, c)) return true;
                            }
                            return false;
                        }
                        function Rcc(a, b, c, d) {
                            var e, f;
                            for(f = a.Kc(); f.Ob();){
                                e = RD(f.Pb(), 72);
                                e.n.a = b.a + (d.a - e.o.a) / 2;
                                e.n.b = b.b;
                                b.b += e.o.b + c;
                            }
                        }
                        function hNb(a, b, c) {
                            var d;
                            d = new rMb(a, b);
                            Rc(a.r, b.ag(), d);
                            if (c && !Rod(a.u)) {
                                d.c = new TKb(a.d);
                                Umb(b.Rf(), new kNb(d));
                            }
                        }
                        function Ddb(a, b) {
                            var c;
                            if (Kdb(a) && Kdb(b)) {
                                c = a - b;
                                if (!isNaN(c)) return c;
                            }
                            return uD(Kdb(a) ? Wdb(a) : a, Kdb(b) ? Wdb(b) : b);
                        }
                        function Iid(a, b) {
                            var c, d, e;
                            e = 1;
                            c = a;
                            d = b >= 0 ? b : -b;
                            while(d > 0)if (d % 2 == 0) {
                                c *= c;
                                d = d / 2 | 0;
                            } else {
                                e *= c;
                                d -= 1;
                            }
                            return b < 0 ? 1 / e : e;
                        }
                        function Jid(a, b) {
                            var c, d, e;
                            e = 1;
                            c = a;
                            d = b >= 0 ? b : -b;
                            while(d > 0)if (d % 2 == 0) {
                                c *= c;
                                d = d / 2 | 0;
                            } else {
                                e *= c;
                                d -= 1;
                            }
                            return b < 0 ? 1 / e : e;
                        }
                        function Vvd(a, b) {
                            var c, d, e, f;
                            f = (e = a ? Hvd(a) : null, Pje((d = b, e && e.Gl(), d)));
                            if (f == b) {
                                c = Hvd(a);
                                !!c && c.Gl();
                            }
                            return f;
                        }
                        function g2d(a, b, c) {
                            var d, e;
                            e = a.f;
                            a.f = b;
                            if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
                                d = new N3d(a, 1, 0, e, b);
                                !c ? c = d : c.nj(d);
                            }
                            return c;
                        }
                        function e2d(a, b, c) {
                            var d, e;
                            e = a.b;
                            a.b = b;
                            if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
                                d = new N3d(a, 1, 3, e, b);
                                !c ? c = d : c.nj(d);
                            }
                            return c;
                        }
                        function rAd(a, b, c) {
                            var d, e;
                            e = a.a;
                            a.a = b;
                            if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
                                d = new N3d(a, 1, 1, e, b);
                                !c ? c = d : c.nj(d);
                            }
                            return c;
                        }
                        function SNd(a) {
                            var b, c, d, e;
                            if (a != null) for(c = 0; c < a.length; ++c){
                                b = a[c];
                                if (b) {
                                    RD(b.g, 379);
                                    e = b.i;
                                    for(d = 0; d < e; ++d);
                                }
                            }
                        }
                        function Vnb(a, b, c, d, e, f, g, h) {
                            var i;
                            i = c;
                            while(f < g)i >= d || b < c && h.Ne(a[b], a[i]) <= 0 ? bD(e, f++, a[b++]) : bD(e, f++, a[i++]);
                        }
                        function Njb(a, b, c, d, e) {
                            if (b == 0 || d == 0) return;
                            b == 1 ? e[d] = Pjb(e, c, d, a[0]) : d == 1 ? e[b] = Pjb(e, a, b, c[0]) : Ojb(a, c, e, b, d);
                        }
                        function w9c(a, b, c) {
                            var d, e, f, g;
                            d = c / a.gc();
                            e = 0;
                            for(g = a.Kc(); g.Ob();){
                                f = RD(g.Pb(), 186);
                                Gad(f, f.f + d * e);
                                Dad(f, b, d);
                                ++e;
                            }
                        }
                        function cad(a) {
                            var b, c, d;
                            d = 0;
                            for(c = new Anb(a.a); c.a < c.c.c.length;){
                                b = RD(ynb(c), 172);
                                d = $wnd.Math.max(d, b.g);
                            }
                            return d;
                        }
                        function EKc(a) {
                            var b, c, d;
                            for(d = new Anb(a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 219);
                                b = c.c.kg() ? c.f : c.a;
                                !!b && MLc(b, c.j);
                            }
                        }
                        function lDc() {
                            lDc = geb;
                            iDc = new nDc('DUMMY_NODE_OVER', 0);
                            jDc = new nDc('DUMMY_NODE_UNDER', 1);
                            kDc = new nDc('EQUAL', 2);
                        }
                        function mqd() {
                            mqd = geb;
                            kqd = new nqd('PARALLEL_NODE', 0);
                            jqd = new nqd('HIERARCHICAL_NODE', 1);
                            lqd = new nqd('ROOT_NODE', 2);
                        }
                        function Fnd() {
                            Fnd = geb;
                            Dnd = new Gnd('INHERIT', 0);
                            Cnd = new Gnd('INCLUDE_CHILDREN', 1);
                            End = new Gnd('SEPARATE_CHILDREN', 2);
                        }
                        function hyd(a, b) {
                            switch(b){
                                case 1:
                                    !a.n && (a.n = new C5d(I4, a, 1, 7));
                                    sLd(a.n);
                                    return;
                                case 2:
                                    jyd(a, null);
                                    return;
                            }
                            Exd(a, b);
                        }
                        function c9c(a) {
                            switch(a.g){
                                case 0:
                                    return new R8c;
                                case 1:
                                    return new o9c;
                                case 2:
                                    return new X8c;
                                default:
                                    return null;
                            }
                        }
                        function eq(a) {
                            _l();
                            switch(a.c){
                                case 0:
                                    return Px(), Ox;
                                case 1:
                                    return new Fy(Ir(new Osb(a)));
                                default:
                                    return new dq(a);
                            }
                        }
                        function go(a) {
                            _l();
                            switch(a.gc()){
                                case 0:
                                    return Px(), Ox;
                                case 1:
                                    return new Fy(a.Kc().Pb());
                                default:
                                    return new Qx(a);
                            }
                        }
                        function Pm(a) {
                            var b;
                            switch(a.gc()){
                                case 0:
                                    return sm;
                                case 1:
                                    return new Dy(Qb(a.Xb(0)));
                                default:
                                    b = a;
                                    return new Kx(b);
                            }
                        }
                        function sgb(a) {
                            var b, c;
                            if (a > -129 && a < 128) return ugb(), b = a + 128, c = tgb[b], !c && (c = tgb[b] = new fgb(a)), c;
                            return new fgb(a);
                        }
                        function bhb(a) {
                            var b, c;
                            if (a > -129 && a < 128) return dhb(), b = a + 128, c = chb[b], !c && (c = chb[b] = new Xgb(a)), c;
                            return new Xgb(a);
                        }
                        function M$b(a, b) {
                            var c;
                            if (a.a.c.length > 0) {
                                c = RD(Vmb(a.a, a.a.c.length - 1), 579);
                                if (Q_b(c, b)) return;
                            }
                            Rmb(a.a, new S_b(b));
                        }
                        function Ekc(a) {
                            lkc();
                            var b, c;
                            b = a.d.c - a.e.c;
                            c = RD(a.g, 154);
                            Umb(c.b, new Ykc(b));
                            Umb(c.c, new $kc(b));
                            xgb(c.i, new alc(b));
                        }
                        function Mlc(a) {
                            var b;
                            b = new bib;
                            b.a += 'VerticalSegment ';
                            Yhb(b, a.e);
                            b.a += ' ';
                            Zhb(b, Eb(new Gb, new Anb(a.k)));
                            return b.a;
                        }
                        function Fmc(a, b) {
                            var c, d, e;
                            c = 0;
                            for(e = b3b(a, b).Kc(); e.Ob();){
                                d = RD(e.Pb(), 12);
                                c += mQb(d, (Ywc(), Iwc)) != null ? 1 : 0;
                            }
                            return c;
                        }
                        function VTc(a, b, c) {
                            var d, e, f;
                            d = 0;
                            for(f = Sub(a, 0); f.b != f.d.c;){
                                e = Kfb(UD(evb(f)));
                                if (e > c) break;
                                else e >= b && ++d;
                            }
                            return d;
                        }
                        function Wv(b, c) {
                            Qb(b);
                            try {
                                return b._b(c);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 212) || ZD(a, 169)) return false;
                                else throw Adb(a);
                            }
                        }
                        function Nk(b, c) {
                            Qb(b);
                            try {
                                return b.Hc(c);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 212) || ZD(a, 169)) return false;
                                else throw Adb(a);
                            }
                        }
                        function Ok(b, c) {
                            Qb(b);
                            try {
                                return b.Mc(c);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 212) || ZD(a, 169)) return false;
                                else throw Adb(a);
                            }
                        }
                        function Xv(b, c) {
                            Qb(b);
                            try {
                                return b.xc(c);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 212) || ZD(a, 169)) return null;
                                else throw Adb(a);
                            }
                        }
                        function Yv(b, c) {
                            Qb(b);
                            try {
                                return b.Bc(c);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 212) || ZD(a, 169)) return null;
                                else throw Adb(a);
                            }
                        }
                        function aMc(a, b) {
                            switch(b.g){
                                case 2:
                                case 1:
                                    return b3b(a, b);
                                case 3:
                                case 4:
                                    return hv(b3b(a, b));
                            }
                            return yob(), yob(), vob;
                        }
                        function QAd(a) {
                            var b;
                            if ((a.Db & 64) != 0) return awd(a);
                            b = new Shb(awd(a));
                            b.a += ' (name: ';
                            Nhb(b, a.zb);
                            b.a += ')';
                            return b.a;
                        }
                        function Fgd(a) {
                            var b;
                            b = RD(cub(a.c.c, ''), 233);
                            if (!b) {
                                b = new fgd(ogd(ngd(new pgd, ''), 'Other'));
                                dub(a.c.c, '', b);
                            }
                            return b;
                        }
                        function hBd(a, b, c) {
                            var d, e;
                            e = a.sb;
                            a.sb = b;
                            if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
                                d = new N3d(a, 1, 4, e, b);
                                !c ? c = d : c.nj(d);
                            }
                            return c;
                        }
                        function ZVd(a, b, c) {
                            var d, e;
                            e = a.r;
                            a.r = b;
                            if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
                                d = new N3d(a, 1, 8, e, a.r);
                                !c ? c = d : c.nj(d);
                            }
                            return c;
                        }
                        function q5d(a, b, c) {
                            var d, e;
                            d = new P3d(a.e, 4, 13, (e = b.c, e ? e : (JTd(), wTd)), null, fZd(a, b), false);
                            !c ? c = d : c.nj(d);
                            return c;
                        }
                        function p5d(a, b, c) {
                            var d, e;
                            d = new P3d(a.e, 3, 13, null, (e = b.c, e ? e : (JTd(), wTd)), fZd(a, b), false);
                            !c ? c = d : c.nj(d);
                            return c;
                        }
                        function Oee(a, b) {
                            var c, d;
                            c = RD(b, 691);
                            d = c.el();
                            !d && c.fl(d = ZD(b, 90) ? new afe(a, RD(b, 29)) : new mfe(a, RD(b, 156)));
                            return d;
                        }
                        function KHd(a, b, c) {
                            var d;
                            a._i(a.i + 1);
                            d = a.Zi(b, c);
                            b != a.i && hib(a.g, b, a.g, b + 1, a.i - b);
                            bD(a.g, b, d);
                            ++a.i;
                            a.Mi(b, c);
                            a.Ni();
                        }
                        function Hyb(a, b) {
                            var c;
                            if (b.a) {
                                c = b.a.a.length;
                                !a.a ? a.a = new dib(a.d) : Zhb(a.a, a.b);
                                Xhb(a.a, b.a, b.d.length, c);
                            }
                            return a;
                        }
                        function wib(a, b) {
                            var c;
                            a.c = b;
                            a.a = pjb(b);
                            a.a < 54 && (a.f = (c = b.d > 1 ? DFb(b.a[0], b.a[1]) : DFb(b.a[0], 0), Xdb(b.e > 0 ? c : Odb(c))));
                        }
                        function MDb(a, b) {
                            var c;
                            c = new IEb;
                            if (!a.a.Bd(c)) {
                                LCb(a);
                                return Kvb(), Kvb(), Jvb;
                            }
                            return Kvb(), new Ovb(uFb(LDb(a, c.a, b)));
                        }
                        function t9b(a, b) {
                            var c;
                            if (a.c.length == 0) return;
                            c = RD(anb(a, $C(jR, WAe, 10, a.c.length, 0, 1)), 199);
                            Znb(c, new F9b);
                            q9b(c, b);
                        }
                        function z9b(a, b) {
                            var c;
                            if (a.c.length == 0) return;
                            c = RD(anb(a, $C(jR, WAe, 10, a.c.length, 0, 1)), 199);
                            Znb(c, new K9b);
                            q9b(c, b);
                        }
                        function pb(a, b) {
                            return bE(a) ? lhb(a, b) : _D(a) ? Lfb(a, b) : $D(a) ? (uFb(a), dE(a) === dE(b)) : YD(a) ? a.Fb(b) : aD(a) ? mb(a, b) : Hz(a, b);
                        }
                        function Cvd(a, b, c) {
                            if (b < 0) Tvd(a, c);
                            else {
                                if (!c.rk()) throw Adb(new agb(KHe + c.xe() + LHe));
                                RD(c, 69).wk().Ek(a, a.hi(), b);
                            }
                        }
                        function xFb(a, b, c) {
                            if (a < 0 || b > c) throw Adb(new veb(_xe + a + bye + b + ', size: ' + c));
                            if (a > b) throw Adb(new agb(_xe + a + aye + b));
                        }
                        function oVd(a) {
                            var b;
                            if ((a.Db & 64) != 0) return awd(a);
                            b = new Shb(awd(a));
                            b.a += ' (source: ';
                            Nhb(b, a.d);
                            b.a += ')';
                            return b.a;
                        }
                        function JSd(a) {
                            if (a >= 65 && a <= 70) return a - 65 + 10;
                            if (a >= 97 && a <= 102) return a - 97 + 10;
                            if (a >= 48 && a <= 57) return a - 48;
                            return 0;
                        }
                        function lMb(a) {
                            hMb();
                            var b, c, d, e;
                            for(c = nMb(), d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                if (Wmb(b.a, a, 0) != -1) return b;
                            }
                            return gMb;
                        }
                        function zde(a, b) {
                            var c, d, e, f;
                            b.ej(a.a);
                            f = RD(Ywd(a.a, 8), 2035);
                            if (f != null) for(c = f, d = 0, e = c.length; d < e; ++d)null.Um();
                        }
                        function _Vd(a, b) {
                            var c;
                            c = (a.Bb & 256) != 0;
                            b ? a.Bb |= 256 : a.Bb &= -257;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new Q3d(a, 1, 2, c, b));
                        }
                        function EYd(a, b) {
                            var c;
                            c = (a.Bb & 256) != 0;
                            b ? a.Bb |= 256 : a.Bb &= -257;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new Q3d(a, 1, 8, c, b));
                        }
                        function j1d(a, b) {
                            var c;
                            c = (a.Bb & 256) != 0;
                            b ? a.Bb |= 256 : a.Bb &= -257;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new Q3d(a, 1, 8, c, b));
                        }
                        function aWd(a, b) {
                            var c;
                            c = (a.Bb & 512) != 0;
                            b ? a.Bb |= 512 : a.Bb &= -513;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new Q3d(a, 1, 3, c, b));
                        }
                        function FYd(a, b) {
                            var c;
                            c = (a.Bb & 512) != 0;
                            b ? a.Bb |= 512 : a.Bb &= -513;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new Q3d(a, 1, 9, c, b));
                        }
                        function m2d(a, b, c) {
                            var d, e;
                            e = a.a;
                            a.a = b;
                            if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
                                d = new N3d(a, 1, 5, e, a.a);
                                !c ? c = d : oKd(c, d);
                            }
                            return c;
                        }
                        function kle(a, b) {
                            var c;
                            if (a.b == -1 && !!a.a) {
                                c = a.a.pk();
                                a.b = !c ? BYd(a.c.Dh(), a.a) : a.c.Hh(a.a.Lj(), c);
                            }
                            return a.c.yh(a.b, b);
                        }
                        function t0d(a, b) {
                            var c, d;
                            for(d = new dMd(a); d.e != d.i.gc();){
                                c = RD(bMd(d), 29);
                                if (dE(b) === dE(c)) return true;
                            }
                            return false;
                        }
                        function a9b(a) {
                            var b, c;
                            b = a.k;
                            if (b == (r3b(), m3b)) {
                                c = RD(mQb(a, (Ywc(), hwc)), 64);
                                return c == (qpd(), Yod) || c == npd;
                            }
                            return false;
                        }
                        function QCb(a) {
                            var b;
                            b = RCb(a);
                            if (Gdb(b.a, 0)) return Tvb(), Tvb(), Svb;
                            return Tvb(), new Yvb(Idb(b.a, 0) ? Orb(b) / Xdb(b.a) : 0);
                        }
                        function Aib(a, b) {
                            this.e = b;
                            this.a = Dib(a);
                            this.a < 54 ? this.f = Xdb(a) : this.c = (Pib(), Ddb(a, 0) >= 0 ? jjb(a) : Xib(jjb(Odb(a))));
                        }
                        function G0b(a, b, c, d, e, f) {
                            this.e = new bnb;
                            this.f = (BEc(), AEc);
                            Rmb(this.e, a);
                            this.d = b;
                            this.a = c;
                            this.b = d;
                            this.f = e;
                            this.c = f;
                        }
                        function bQb(a, b, c) {
                            a.n = YC(lE, [
                                Nve,
                                rxe
                            ], [
                                376,
                                28
                            ], 14, [
                                c,
                                eE($wnd.Math.ceil(b / 32))
                            ], 2);
                            a.o = b;
                            a.p = c;
                            a.j = b - 1 >> 1;
                            a.k = c - 1 >> 1;
                        }
                        function ggb(a) {
                            a -= a >> 1 & 1431655765;
                            a = (a >> 2 & 858993459) + (a & 858993459);
                            a = (a >> 4) + a & 252645135;
                            a += a >> 8;
                            a += a >> 16;
                            return a & 63;
                        }
                        function C4d(a, b) {
                            var c, d;
                            for(d = new dMd(a); d.e != d.i.gc();){
                                c = RD(bMd(d), 142);
                                if (dE(b) === dE(c)) return true;
                            }
                            return false;
                        }
                        function Iee(a, b, c) {
                            var d, e, f;
                            f = (e = N5d(a.b, b), e);
                            if (f) {
                                d = RD(tfe(Pee(a, f), ''), 29);
                                if (d) return Ree(a, d, b, c);
                            }
                            return null;
                        }
                        function Lee(a, b, c) {
                            var d, e, f;
                            f = (e = N5d(a.b, b), e);
                            if (f) {
                                d = RD(tfe(Pee(a, f), ''), 29);
                                if (d) return See(a, d, b, c);
                            }
                            return null;
                        }
                        function IDd(a, b) {
                            var c;
                            c = Ao(a.i, b);
                            if (c == null) throw Adb(new CDd('Node did not exist in input.'));
                            wEd(b, c);
                            return null;
                        }
                        function wvd(a, b) {
                            var c;
                            c = wYd(a, b);
                            if (ZD(c, 331)) return RD(c, 35);
                            throw Adb(new agb(KHe + b + "' is not a valid attribute"));
                        }
                        function VGd(a, b, c) {
                            var d;
                            d = a.gc();
                            if (b > d) throw Adb(new aMd(b, d));
                            if (a.Si() && a.Hc(c)) throw Adb(new agb(LIe));
                            a.Gi(b, c);
                        }
                        function w7b(a, b) {
                            b.Ug('Sort end labels', 1);
                            FDb(CDb(EDb(new SDb(null, new Swb(a.b, 16)), new H7b), new J7b), new L7b);
                            b.Vg();
                        }
                        function Cmd() {
                            Cmd = geb;
                            Amd = new Gmd(Sye, 0);
                            zmd = new Gmd(Oye, 1);
                            ymd = new Gmd(Nye, 2);
                            xmd = new Gmd(Zye, 3);
                            Bmd = new Gmd('UP', 4);
                        }
                        function gbd() {
                            gbd = geb;
                            dbd = new hbd('P1_STRUCTURE', 0);
                            ebd = new hbd('P2_PROCESSING_ORDER', 1);
                            fbd = new hbd('P3_EXECUTION', 2);
                        }
                        function r0c() {
                            r0c = geb;
                            q0c = mfd(mfd(rfd(mfd(mfd(rfd(pfd(new ufd, (YVc(), VVc), (WYc(), VYc)), WVc), RYc), TYc), XVc), NYc), UYc);
                        }
                        function s8b(a) {
                            switch(RD(mQb(a, (Ywc(), owc)), 311).g){
                                case 1:
                                    pQb(a, owc, (Gvc(), Dvc));
                                    break;
                                case 2:
                                    pQb(a, owc, (Gvc(), Fvc));
                            }
                        }
                        function bUc(a) {
                            switch(a){
                                case 0:
                                    return new mUc;
                                case 1:
                                    return new cUc;
                                case 2:
                                    return new hUc;
                                default:
                                    throw Adb(new _fb);
                            }
                        }
                        function Fmd(a) {
                            switch(a.g){
                                case 2:
                                    return zmd;
                                case 1:
                                    return ymd;
                                case 4:
                                    return xmd;
                                case 3:
                                    return Bmd;
                                default:
                                    return Amd;
                            }
                        }
                        function UNb(a, b) {
                            switch(a.b.g){
                                case 0:
                                case 1:
                                    return b;
                                case 2:
                                case 3:
                                    return new Uid(b.d, 0, b.a, b.b);
                                default:
                                    return null;
                            }
                        }
                        function rpd(a) {
                            switch(a.g){
                                case 1:
                                    return ppd;
                                case 2:
                                    return Yod;
                                case 3:
                                    return Xod;
                                case 4:
                                    return npd;
                                default:
                                    return opd;
                            }
                        }
                        function spd(a) {
                            switch(a.g){
                                case 1:
                                    return npd;
                                case 2:
                                    return ppd;
                                case 3:
                                    return Yod;
                                case 4:
                                    return Xod;
                                default:
                                    return opd;
                            }
                        }
                        function tpd(a) {
                            switch(a.g){
                                case 1:
                                    return Xod;
                                case 2:
                                    return npd;
                                case 3:
                                    return ppd;
                                case 4:
                                    return Yod;
                                default:
                                    return opd;
                            }
                        }
                        function cyd(a, b, c, d) {
                            switch(b){
                                case 1:
                                    return !a.n && (a.n = new C5d(I4, a, 1, 7)), a.n;
                                case 2:
                                    return a.k;
                            }
                            return Axd(a, b, c, d);
                        }
                        function uLd(a, b, c) {
                            var d, e;
                            if (a.Pj()) {
                                e = a.Qj();
                                d = SHd(a, b, c);
                                a.Jj(a.Ij(7, sgb(c), d, b, e));
                                return d;
                            } else return SHd(a, b, c);
                        }
                        function VNd(a, b) {
                            var c, d, e;
                            if (a.d == null) {
                                ++a.e;
                                --a.f;
                            } else {
                                e = b.ld();
                                c = b.Bi();
                                d = (c & lve) % a.d.length;
                                iOd(a, d, XNd(a, d, c, e));
                            }
                        }
                        function xWd(a, b) {
                            var c;
                            c = (a.Bb & gwe) != 0;
                            b ? a.Bb |= gwe : a.Bb &= -1025;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new Q3d(a, 1, 10, c, b));
                        }
                        function DWd(a, b) {
                            var c;
                            c = (a.Bb & qxe) != 0;
                            b ? a.Bb |= qxe : a.Bb &= -4097;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new Q3d(a, 1, 12, c, b));
                        }
                        function EWd(a, b) {
                            var c;
                            c = (a.Bb & bKe) != 0;
                            b ? a.Bb |= bKe : a.Bb &= -8193;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new Q3d(a, 1, 15, c, b));
                        }
                        function FWd(a, b) {
                            var c;
                            c = (a.Bb & cKe) != 0;
                            b ? a.Bb |= cKe : a.Bb &= -2049;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new Q3d(a, 1, 11, c, b));
                        }
                        function zKc(a) {
                            var b;
                            if (a.g) {
                                b = a.c.kg() ? a.f : a.a;
                                BKc(b.a, a.o, true);
                                BKc(b.a, a.o, false);
                                pQb(a.o, (yCc(), BBc), (Bod(), vod));
                            }
                        }
                        function Orc(a) {
                            var b;
                            if (!a.a) throw Adb(new dgb('Cannot offset an unassigned cut.'));
                            b = a.c - a.b;
                            a.b += b;
                            Qrc(a, b);
                            Rrc(a, b);
                        }
                        function JDd(a, b) {
                            var c;
                            c = Wjb(a.k, b);
                            if (c == null) throw Adb(new CDd('Port did not exist in input.'));
                            wEd(b, c);
                            return null;
                        }
                        function Jje(a) {
                            var b, c;
                            for(c = Kje(BXd(a)).Kc(); c.Ob();){
                                b = WD(c.Pb());
                                if (bAd(a, b)) return USd((TSd(), SSd), b);
                            }
                            return null;
                        }
                        function qJb(a) {
                            var b, c;
                            for(c = a.p.a.ec().Kc(); c.Ob();){
                                b = RD(c.Pb(), 218);
                                if (b.f && a.b[b.c] < -0.0000000001) return b;
                            }
                            return null;
                        }
                        function Lr(a) {
                            var b, c;
                            c = Thb(new bib, 91);
                            b = true;
                            while(a.Ob()){
                                b || (c.a += pve, c);
                                b = false;
                                Yhb(c, a.Pb());
                            }
                            return (c.a += ']', c).a;
                        }
                        function o_b(a) {
                            var b, c, d;
                            b = new bnb;
                            for(d = new Anb(a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 602);
                                Tmb(b, RD(c.Cf(), 16));
                            }
                            return b;
                        }
                        function TXb(a, b) {
                            var c, d;
                            for(d = new Anb(b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 42);
                                Ymb(a.b.b, c.b);
                                hYb(RD(c.a, 194), RD(c.b, 86));
                            }
                        }
                        function aRb(a, b) {
                            var c;
                            c = Qfb(a.b.c, b.b.c);
                            if (c != 0) return c;
                            c = Qfb(a.a.a, b.a.a);
                            if (c != 0) return c;
                            return Qfb(a.a.b, b.a.b);
                        }
                        function Qfb(a, b) {
                            if (a < b) return -1;
                            if (a > b) return 1;
                            if (a == b) return a == 0 ? Qfb(1 / a, 1 / b) : 0;
                            return isNaN(a) ? isNaN(b) ? 0 : 1 : -1;
                        }
                        function pmb(a) {
                            var b;
                            b = a.a[a.c - 1 & a.a.length - 1];
                            if (b == null) return null;
                            a.c = a.c - 1 & a.a.length - 1;
                            bD(a.a, a.c, null);
                            return b;
                        }
                        function Dqe(a) {
                            var b, c, d;
                            d = 0;
                            c = a.length;
                            for(b = 0; b < c; b++)a[b] == 32 || a[b] == 13 || a[b] == 10 || a[b] == 9 || (a[d++] = a[b]);
                            return d;
                        }
                        function Nge(a, b) {
                            var c, d, e, f, g;
                            g = pke(a.e.Dh(), b);
                            f = 0;
                            c = RD(a.g, 124);
                            for(e = 0; e < a.i; ++e){
                                d = c[e];
                                g.am(d.Lk()) && ++f;
                            }
                            return f;
                        }
                        function tge(a, b, c) {
                            var d, e;
                            e = ZD(b, 102) && (RD(b, 19).Bb & txe) != 0 ? new She(b, a) : new Phe(b, a);
                            for(d = 0; d < c; ++d)Dhe(e);
                            return e;
                        }
                        function yrd(a, b, c) {
                            var d, e;
                            if (a.c) Isd(a.c, b, c);
                            else for(e = new Anb(a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 163);
                                yrd(d, b, c);
                            }
                        }
                        function tGd(a, b, c) {
                            var d, e;
                            d = RD(b.of(a.a), 34);
                            e = RD(c.of(a.a), 34);
                            return d != null && e != null ? Leb(d, e) : d != null ? -1 : e != null ? 1 : 0;
                        }
                        function Ce(a, b) {
                            var c, d, e;
                            uFb(b);
                            c = false;
                            for(d = new Anb(a); d.a < d.c.c.length;){
                                e = ynb(d);
                                if (b.Hc(e)) {
                                    znb(d);
                                    c = true;
                                }
                            }
                            return c;
                        }
                        function xsb(a) {
                            var b, c, d, e;
                            c = (b = RD(mfb((d = a.Rm, e = d.f, e == WI ? d : e)), 9), new Fsb(b, RD(WEb(b, b.length), 9), 0));
                            zsb(c, a);
                            return c;
                        }
                        function i2b(a) {
                            var b, c;
                            c = RD(mQb(a, (yCc(), rAc)), 88);
                            if (c == (Cmd(), Amd)) {
                                b = Kfb(UD(mQb(a, Tzc)));
                                return b >= 1 ? zmd : xmd;
                            }
                            return c;
                        }
                        function Xhc(a) {
                            switch(RD(mQb(a, (yCc(), yAc)), 223).g){
                                case 1:
                                    return new jqc;
                                case 3:
                                    return new arc;
                                default:
                                    return new dqc;
                            }
                        }
                        function MCb(a) {
                            if (a.c) MCb(a.c);
                            else if (a.d) throw Adb(new dgb("Stream already terminated, can't be modified or used"));
                        }
                        function Ltb(a, b, c) {
                            var d;
                            d = a.a.get(b);
                            a.a.set(b, c === undefined ? null : c);
                            if (d === undefined) {
                                ++a.c;
                                ++a.b.g;
                            } else ++a.d;
                            return d;
                        }
                        function HHc(a, b, c) {
                            var d, e;
                            for(e = a.a.ec().Kc(); e.Ob();){
                                d = RD(e.Pb(), 10);
                                if (Be(c, RD(Vmb(b, d.p), 16))) return d;
                            }
                            return null;
                        }
                        function u0c(a, b, c) {
                            var d;
                            d = 0;
                            !!b && (Emd(a.a) ? d += b.f.a / 2 : d += b.f.b / 2);
                            !!c && (Emd(a.a) ? d += c.f.a / 2 : d += c.f.b / 2);
                            return d;
                        }
                        function LWb(a, b, c) {
                            var d;
                            d = c;
                            !d && (d = Nqd(new Oqd, 0));
                            d.Ug(EAe, 2);
                            y0b(a.b, b, d.eh(1));
                            NWb(a, b, d.eh(1));
                            h0b(b, d.eh(1));
                            d.Vg();
                        }
                        function CGd(a, b, c) {
                            var d, e;
                            d = (bvd(), e = new Xxd, e);
                            Vxd(d, b);
                            Wxd(d, c);
                            !!a && WGd((!a.a && (a.a = new XZd(D4, a, 5)), a.a), d);
                            return d;
                        }
                        function kyd(a) {
                            var b;
                            if ((a.Db & 64) != 0) return awd(a);
                            b = new Shb(awd(a));
                            b.a += ' (identifier: ';
                            Nhb(b, a.k);
                            b.a += ')';
                            return b.a;
                        }
                        function kXd(a, b) {
                            var c;
                            c = (a.Bb & QHe) != 0;
                            b ? a.Bb |= QHe : a.Bb &= -32769;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new Q3d(a, 1, 18, c, b));
                        }
                        function a6d(a, b) {
                            var c;
                            c = (a.Bb & QHe) != 0;
                            b ? a.Bb |= QHe : a.Bb &= -32769;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new Q3d(a, 1, 18, c, b));
                        }
                        function AWd(a, b) {
                            var c;
                            c = (a.Bb & Ove) != 0;
                            b ? a.Bb |= Ove : a.Bb &= -16385;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new Q3d(a, 1, 16, c, b));
                        }
                        function c6d(a, b) {
                            var c;
                            c = (a.Bb & txe) != 0;
                            b ? a.Bb |= txe : a.Bb &= -65537;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new Q3d(a, 1, 20, c, b));
                        }
                        function qse(a) {
                            var b;
                            b = $C(hE, zwe, 28, 2, 15, 1);
                            a -= txe;
                            b[0] = (a >> 10) + uxe & Bwe;
                            b[1] = (a & 1023) + 56320 & Bwe;
                            return Ihb(b, 0, b.length);
                        }
                        function Zfb(a) {
                            var b;
                            b = Neb(a);
                            if (b > 3.4028234663852886E38) return oxe;
                            else if (b < -340282346638528860000000000000000000000) return pxe;
                            return b;
                        }
                        function Bdb(a, b) {
                            var c;
                            if (Kdb(a) && Kdb(b)) {
                                c = a + b;
                                if (jxe < c && c < hxe) return c;
                            }
                            return Edb(sD(Kdb(a) ? Wdb(a) : a, Kdb(b) ? Wdb(b) : b));
                        }
                        function Ndb(a, b) {
                            var c;
                            if (Kdb(a) && Kdb(b)) {
                                c = a * b;
                                if (jxe < c && c < hxe) return c;
                            }
                            return Edb(wD(Kdb(a) ? Wdb(a) : a, Kdb(b) ? Wdb(b) : b));
                        }
                        function Vdb(a, b) {
                            var c;
                            if (Kdb(a) && Kdb(b)) {
                                c = a - b;
                                if (jxe < c && c < hxe) return c;
                            }
                            return Edb(DD(Kdb(a) ? Wdb(a) : a, Kdb(b) ? Wdb(b) : b));
                        }
                        function b3b(a, b) {
                            var c;
                            a.i || V2b(a);
                            c = RD(Vrb(a.g, b), 42);
                            return !c ? (yob(), yob(), vob) : new Rkb(a.j, RD(c.a, 17).a, RD(c.b, 17).a);
                        }
                        function ZXb(a) {
                            NXb();
                            return Geb(), IYb(RD(a.a, 86).j, RD(a.b, 88)) || RD(a.a, 86).d.e != 0 && IYb(RD(a.a, 86).j, RD(a.b, 88)) ? true : false;
                        }
                        function pWc(a, b) {
                            return lhb(!!b.b && !!b.c ? aXc(b.b) + '->' + aXc(b.c) : 'e_' + tb(b), !!a.b && !!a.c ? aXc(a.b) + '->' + aXc(a.c) : 'e_' + tb(a));
                        }
                        function rWc(a, b) {
                            return lhb(!!b.b && !!b.c ? aXc(b.b) + '->' + aXc(b.c) : 'e_' + tb(b), !!a.b && !!a.c ? aXc(a.b) + '->' + aXc(a.c) : 'e_' + tb(a));
                        }
                        function $y(a, b) {
                            Zy();
                            return bz(pwe), $wnd.Math.abs(a - b) <= pwe || a == b || isNaN(a) && isNaN(b) ? 0 : a < b ? -1 : a > b ? 1 : cz(isNaN(a), isNaN(b));
                        }
                        function Ymd() {
                            Ymd = geb;
                            Xmd = new Zmd(Sye, 0);
                            Vmd = new Zmd('POLYLINE', 1);
                            Umd = new Zmd('ORTHOGONAL', 2);
                            Wmd = new Zmd('SPLINES', 3);
                        }
                        function _6c() {
                            _6c = geb;
                            Z6c = new a7c('ASPECT_RATIO_DRIVEN', 0);
                            $6c = new a7c('MAX_SCALE_DRIVEN', 1);
                            Y6c = new a7c('AREA_DRIVEN', 2);
                        }
                        function Db(b, c, d) {
                            var e;
                            try {
                                Cb(b, c, d);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 606)) {
                                    e = a;
                                    throw Adb(new Deb(e));
                                } else throw Adb(a);
                            }
                            return c;
                        }
                        function Im(a) {
                            var b, c, d;
                            for(c = 0, d = a.length; c < d; c++){
                                if (a[c] == null) throw Adb(new Ogb('at index ' + c));
                            }
                            b = a;
                            return new mob(b);
                        }
                        function W2b(a) {
                            var b, c, d;
                            b = new bnb;
                            for(d = new Anb(a.j); d.a < d.c.c.length;){
                                c = RD(ynb(d), 12);
                                Rmb(b, c.b);
                            }
                            return Qb(b), new Dl(b);
                        }
                        function Z2b(a) {
                            var b, c, d;
                            b = new bnb;
                            for(d = new Anb(a.j); d.a < d.c.c.length;){
                                c = RD(ynb(d), 12);
                                Rmb(b, c.e);
                            }
                            return Qb(b), new Dl(b);
                        }
                        function a3b(a) {
                            var b, c, d;
                            b = new bnb;
                            for(d = new Anb(a.j); d.a < d.c.c.length;){
                                c = RD(ynb(d), 12);
                                Rmb(b, c.g);
                            }
                            return Qb(b), new Dl(b);
                        }
                        function MBb(a, b) {
                            var c, d, e;
                            e = new Tsb;
                            for(d = b.vc().Kc(); d.Ob();){
                                c = RD(d.Pb(), 44);
                                Zjb(e, c.ld(), QBb(a, RD(c.md(), 15)));
                            }
                            return e;
                        }
                        function Mje(a) {
                            var b, c;
                            for(c = Nje(BXd(uWd(a))).Kc(); c.Ob();){
                                b = WD(c.Pb());
                                if (bAd(a, b)) return dTd((cTd(), bTd), b);
                            }
                            return null;
                        }
                        function Cgc(a, b) {
                            var c, d, e;
                            e = 0;
                            for(d = RD(b.Kb(a), 20).Kc(); d.Ob();){
                                c = RD(d.Pb(), 18);
                                Heb(TD(mQb(c, (Ywc(), Nwc)))) || ++e;
                            }
                            return e;
                        }
                        function Uv(a) {
                            var b, c, d, e;
                            b = new oq(a.Rd().gc());
                            e = 0;
                            for(d = Nr(a.Rd().Kc()); d.Ob();){
                                c = d.Pb();
                                nq(b, c, sgb(e++));
                            }
                            return sn(b.a);
                        }
                        function Cvb(a, b, c, d) {
                            var e, f;
                            uFb(d);
                            uFb(c);
                            e = a.xc(b);
                            f = e == null ? c : EBb(RD(e, 15), RD(c, 16));
                            f == null ? a.Bc(b) : a.zc(b, f);
                            return f;
                        }
                        function Unb(a, b, c, d) {
                            var e, f, g;
                            for(e = b + 1; e < c; ++e)for(f = e; f > b && d.Ne(a[f - 1], a[f]) > 0; --f){
                                g = a[f];
                                bD(a, f, a[f - 1]);
                                bD(a, f - 1, g);
                            }
                        }
                        function Egd(a, b) {
                            var c, d, e, f, g;
                            c = b.f;
                            dub(a.c.d, c, b);
                            if (b.g != null) for(e = b.g, f = 0, g = e.length; f < g; ++f){
                                d = e[f];
                                dub(a.c.e, d, b);
                            }
                        }
                        function YSc(a, b) {
                            var c, d;
                            c = Sub(a, 0);
                            while(c.b != c.d.c){
                                d = Mfb(UD(evb(c)));
                                if (d == b) return;
                                else if (d > b) {
                                    fvb(c);
                                    break;
                                }
                            }
                            cvb(c, b);
                        }
                        function Kic(a, b) {
                            var c, d, e;
                            d = Zjc(b);
                            e = Kfb(UD(hFc(d, (yCc(), TBc))));
                            c = $wnd.Math.max(0, e / 2 - 0.5);
                            Iic(b, c, 1);
                            Rmb(a, new hjc(b, c));
                        }
                        function L5c(a, b, c) {
                            var d;
                            c.Ug('Straight Line Edge Routing', 1);
                            c.dh(b, eFe);
                            d = RD(Gxd(b, (u2c(), t2c)), 27);
                            M5c(a, d);
                            c.dh(b, gFe);
                        }
                        function K9c(a, b) {
                            a.n.c.length == 0 && Rmb(a.n, new _9c(a.s, a.t, a.i));
                            Rmb(a.b, b);
                            W9c(RD(Vmb(a.n, a.n.c.length - 1), 209), b);
                            M9c(a, b);
                        }
                        function Zrb(a) {
                            var b;
                            this.a = (b = RD(a.e && a.e(), 9), new Fsb(b, RD(WEb(b, b.length), 9), 0));
                            this.b = $C(jJ, rve, 1, this.a.a.length, 5, 1);
                        }
                        function jeb(a) {
                            var b;
                            if (Array.isArray(a) && a.Tm === keb) return nfb(rb(a)) + '@' + (b = tb(a) >>> 0, b.toString(16));
                            return a.toString();
                        }
                        function jD(a, b) {
                            if (a.h == fxe && a.m == 0 && a.l == 0) {
                                b && (eD = hD(0, 0, 0));
                                return gD((MD(), KD));
                            }
                            b && (eD = hD(a.l, a.m, a.h));
                            return hD(0, 0, 0);
                        }
                        function _Gb(a, b) {
                            switch(b.g){
                                case 2:
                                    return a.b;
                                case 1:
                                    return a.c;
                                case 4:
                                    return a.d;
                                case 3:
                                    return a.a;
                                default:
                                    return false;
                            }
                        }
                        function IYb(a, b) {
                            switch(b.g){
                                case 2:
                                    return a.b;
                                case 1:
                                    return a.c;
                                case 4:
                                    return a.d;
                                case 3:
                                    return a.a;
                                default:
                                    return false;
                            }
                        }
                        function vyd(a, b, c, d) {
                            switch(b){
                                case 3:
                                    return a.f;
                                case 4:
                                    return a.g;
                                case 5:
                                    return a.i;
                                case 6:
                                    return a.j;
                            }
                            return cyd(a, b, c, d);
                        }
                        function oIb(a, b) {
                            if (b == a.d) return a.e;
                            else if (b == a.e) return a.d;
                            else throw Adb(new agb('Node ' + b + ' not part of edge ' + a));
                        }
                        function Uvd(a, b) {
                            var c;
                            c = wYd(a.Dh(), b);
                            if (ZD(c, 102)) return RD(c, 19);
                            throw Adb(new agb(KHe + b + "' is not a valid reference"));
                        }
                        function Bvd(a, b, c, d) {
                            if (b < 0) Svd(a, c, d);
                            else {
                                if (!c.rk()) throw Adb(new agb(KHe + c.xe() + LHe));
                                RD(c, 69).wk().Ck(a, a.hi(), b, d);
                            }
                        }
                        function ig(a) {
                            var b;
                            if (a.b) {
                                ig(a.b);
                                if (a.b.d != a.c) throw Adb(new Jrb);
                            } else if (a.d.dc()) {
                                b = RD(a.f.c.xc(a.e), 16);
                                !!b && (a.d = b);
                            }
                        }
                        function VMb(a) {
                            RMb();
                            var b, c, d, e;
                            b = a.o.b;
                            for(d = RD(RD(Qc(a.r, (qpd(), npd)), 21), 87).Kc(); d.Ob();){
                                c = RD(d.Pb(), 117);
                                e = c.e;
                                e.b += b;
                            }
                        }
                        function SRb(a) {
                            var b, c, d;
                            this.a = new Iub;
                            for(d = new Anb(a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 16);
                                b = new DRb;
                                xRb(b, c);
                                Ysb(this.a, b);
                            }
                        }
                        function fdc(a, b) {
                            var c, d, e;
                            d = cdc(a, b);
                            e = d[d.length - 1] / 2;
                            for(c = 0; c < d.length; c++){
                                if (d[c] >= e) return b.c + c;
                            }
                            return b.c + b.b.gc();
                        }
                        function lQd(a, b) {
                            jQd();
                            var c, d, e, f;
                            d = iZd(a);
                            e = b;
                            Wnb(d, 0, d.length, e);
                            for(c = 0; c < d.length; c++){
                                f = kQd(a, d[c], c);
                                c != f && uLd(a, c, f);
                            }
                        }
                        function mSd(a, b, c) {
                            var d, e;
                            for(d = 0, e = a.length; d < e; d++){
                                if (zSd((BFb(d, a.length), a.charCodeAt(d)), b, c)) return true;
                            }
                            return false;
                        }
                        function ARb(a, b) {
                            var c, d;
                            for(d = a.e.a.ec().Kc(); d.Ob();){
                                c = RD(d.Pb(), 272);
                                if (Eid(b, c.d) || zid(b, c.d)) return true;
                            }
                            return false;
                        }
                        function oMc(a, b, c, d, e) {
                            var f, g, h;
                            g = e;
                            while(b.b != b.c){
                                f = RD(smb(b), 10);
                                h = RD(b3b(f, d).Xb(0), 12);
                                a.d[h.p] = g++;
                                ZEb(c.c, h);
                            }
                            return g;
                        }
                        function vKb(a, b) {
                            var c, d, e, f, g, h;
                            d = 0;
                            c = 0;
                            for(f = b, g = 0, h = f.length; g < h; ++g){
                                e = f[g];
                                if (e > 0) {
                                    d += e;
                                    ++c;
                                }
                            }
                            c > 1 && (d += a.d * (c - 1));
                            return d;
                        }
                        function FFd(a) {
                            var b, c, d, e, f;
                            f = HFd(a);
                            c = cve(a.c);
                            d = !c;
                            if (d) {
                                e = new MB;
                                sC(f, 'knownLayouters', e);
                                b = new QFd(e);
                                xgb(a.c, b);
                            }
                            return f;
                        }
                        function fHd(a) {
                            var b, c, d;
                            d = new Qhb;
                            d.a += '[';
                            for(b = 0, c = a.gc(); b < c;){
                                Nhb(d, Ghb(a.Vi(b)));
                                ++b < c && (d.a += pve, d);
                            }
                            d.a += ']';
                            return d.a;
                        }
                        function kSd(a) {
                            if (a.e == null) return a;
                            else !a.c && (a.c = new lSd((a.f & 256) != 0, a.i, a.a, a.d, (a.f & 16) != 0, a.j, a.g, null));
                            return a.c;
                        }
                        function pnc(a) {
                            if (a.k != (r3b(), p3b)) return false;
                            return yDb(new SDb(null, new Twb(new is(Mr(a3b(a).a.Kc(), new ir)))), new qnc);
                        }
                        function hv(a) {
                            var b, c;
                            if (ZD(a, 307)) {
                                c = vm(RD(a, 307));
                                b = c;
                                return b;
                            } else return ZD(a, 441) ? RD(a, 441).a : ZD(a, 59) ? new Fv(a) : new uv(a);
                        }
                        function FSd(a) {
                            var b;
                            if (a == null) return true;
                            b = a.length;
                            return b > 0 && (BFb(b - 1, a.length), a.charCodeAt(b - 1) == 58) && !mSd(a, aSd, bSd);
                        }
                        function Sib(a, b) {
                            var c;
                            if (dE(a) === dE(b)) return true;
                            if (ZD(b, 92)) {
                                c = RD(b, 92);
                                return a.e == c.e && a.d == c.d && Tib(a, c.a);
                            }
                            return false;
                        }
                        function vpd(a) {
                            qpd();
                            switch(a.g){
                                case 4:
                                    return Yod;
                                case 1:
                                    return Xod;
                                case 3:
                                    return npd;
                                case 2:
                                    return ppd;
                                default:
                                    return opd;
                            }
                        }
                        function jBb(a) {
                            var b, c;
                            if (a.b) return a.b;
                            c = dBb ? null : a.d;
                            while(c){
                                b = dBb ? null : c.b;
                                if (b) return b;
                                c = dBb ? null : c.d;
                            }
                            return SAb(), RAb;
                        }
                        function LJb(a) {
                            var b, c, d;
                            d = Kfb(UD(a.a.of((umd(), cmd))));
                            for(c = new Anb(a.a.Sf()); c.a < c.c.c.length;){
                                b = RD(ynb(c), 695);
                                OJb(a, b, d);
                            }
                        }
                        function jz(a) {
                            var b, c, d, e;
                            for(b = (a.j == null && (a.j = (fA(), e = eA.me(a), hA(e))), a.j), c = 0, d = b.length; c < d; ++c)String.fromCharCode(10);
                        }
                        function OXb(a, b) {
                            var c, d;
                            for(d = new Anb(b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 42);
                                Rmb(a.b.b, RD(c.b, 86));
                                gYb(RD(c.a, 194), RD(c.b, 86));
                            }
                        }
                        function nHc(a, b, c) {
                            var d, e;
                            e = a.a.b;
                            for(d = e.c.length; d < c; d++)Qmb(e, 0, new R4b(a.a));
                            g3b(b, RD(Vmb(e, e.c.length - c), 30));
                            a.b[b.p] = c;
                        }
                        function EOc(a, b, c, d, e) {
                            dOc();
                            rIb(uIb(tIb(sIb(vIb(new wIb, 0), e.d.e - a), b), e.d));
                            rIb(uIb(tIb(sIb(vIb(new wIb, 0), c - e.a.e), e.a), d));
                        }
                        function Ted(a, b) {
                            var c;
                            if (a.d) {
                                if (Ujb(a.b, b)) return RD(Wjb(a.b, b), 47);
                                else {
                                    c = b.dg();
                                    Zjb(a.b, b, c);
                                    return c;
                                }
                            } else return b.dg();
                        }
                        function hFb(b) {
                            var c = b.e;
                            function d(a) {
                                if (!a || a.length == 0) return '';
                                return '\t' + a.join('\n\t');
                            }
                            return c && (c.stack || d(b[xwe]));
                        }
                        function wyd(a, b) {
                            switch(b){
                                case 3:
                                    return a.f != 0;
                                case 4:
                                    return a.g != 0;
                                case 5:
                                    return a.i != 0;
                                case 6:
                                    return a.j != 0;
                            }
                            return fyd(a, b);
                        }
                        function y2c(a) {
                            switch(a.g){
                                case 0:
                                    return new D5c;
                                case 1:
                                    return new N5c;
                                default:
                                    throw Adb(new agb(lBe + (a.f != null ? a.f : '' + a.g)));
                            }
                        }
                        function Z3c(a) {
                            switch(a.g){
                                case 0:
                                    return new G5c;
                                case 1:
                                    return new J5c;
                                default:
                                    throw Adb(new agb(mFe + (a.f != null ? a.f : '' + a.g)));
                            }
                        }
                        function h4c(a) {
                            switch(a.g){
                                case 1:
                                    return new F3c;
                                case 2:
                                    return new x3c;
                                default:
                                    throw Adb(new agb(mFe + (a.f != null ? a.f : '' + a.g)));
                            }
                        }
                        function mdd(a) {
                            switch(a.g){
                                case 0:
                                    return new Ddd;
                                case 1:
                                    return new Hdd;
                                default:
                                    throw Adb(new agb(eGe + (a.f != null ? a.f : '' + a.g)));
                            }
                        }
                        function Owb() {
                            Hwb();
                            var a, b, c;
                            c = Gwb++ + Date.now();
                            a = eE($wnd.Math.floor(c * Nxe)) & Pxe;
                            b = eE(c - a * Oxe);
                            this.a = a ^ 1502;
                            this.b = b ^ Mxe;
                        }
                        function cxc() {
                            cxc = geb;
                            bxc = new dxc(LAe, 0);
                            Zwc = new dxc('FIRST', 1);
                            $wc = new dxc(oBe, 2);
                            _wc = new dxc('LAST', 3);
                            axc = new dxc(pBe, 4);
                        }
                        function Grd() {
                            Grd = geb;
                            Frd = new Hrd(mEe, 0);
                            Crd = new Hrd('GROUP_DEC', 1);
                            Erd = new Hrd('GROUP_MIXED', 2);
                            Drd = new Hrd('GROUP_INC', 3);
                        }
                        function cEd(a, b) {
                            var c, d, e, f;
                            if (b) {
                                e = vDd(b, 'x');
                                c = new wFd(a);
                                Ozd(c.a, (uFb(e), e));
                                f = vDd(b, 'y');
                                d = new zFd(a);
                                Pzd(d.a, (uFb(f), f));
                            }
                        }
                        function nEd(a, b) {
                            var c, d, e, f;
                            if (b) {
                                e = vDd(b, 'x');
                                c = new BFd(a);
                                Hzd(c.a, (uFb(e), e));
                                f = vDd(b, 'y');
                                d = new CFd(a);
                                Izd(d.a, (uFb(f), f));
                            }
                        }
                        function Sje(a, b) {
                            var c, d, e, f;
                            e = new cnb(b.gc());
                            for(d = b.Kc(); d.Ob();){
                                c = d.Pb();
                                f = Rje(a, RD(c, 58));
                                !!f && ZEb(e.c, f);
                            }
                            return e;
                        }
                        function ze(a, b, c) {
                            var d, e;
                            for(e = a.Kc(); e.Ob();){
                                d = e.Pb();
                                if (dE(b) === dE(d) || b != null && pb(b, d)) {
                                    c && e.Qb();
                                    return true;
                                }
                            }
                            return false;
                        }
                        function Y5b(a) {
                            var b, c, d;
                            c = a.jh();
                            if (c) {
                                b = a.Eh();
                                if (ZD(b, 167)) {
                                    d = Y5b(RD(b, 167));
                                    if (d != null) return d + '.' + c;
                                }
                                return c;
                            }
                            return null;
                        }
                        function pjb(a) {
                            var b, c, d;
                            if (a.e == 0) return 0;
                            b = a.d << 5;
                            c = a.a[a.d - 1];
                            if (a.e < 0) {
                                d = Uib(a);
                                if (d == a.d - 1) {
                                    --c;
                                    c = c | 0;
                                }
                            }
                            b -= ngb(c);
                            return b;
                        }
                        function kjb(a) {
                            var b, c, d;
                            if (a < Nib.length) return Nib[a];
                            c = a >> 5;
                            b = a & 31;
                            d = $C(kE, Pwe, 28, c + 1, 15, 1);
                            d[c] = 1 << b;
                            return new cjb(1, c + 1, d);
                        }
                        function eLd(a, b) {
                            var c, d;
                            if (!b) return false;
                            else {
                                for(c = 0; c < a.i; ++c){
                                    d = RD(a.g[c], 378);
                                    if (d.mj(b)) return false;
                                }
                                return WGd(a, b);
                            }
                        }
                        function ZId(a, b, c) {
                            var d, e;
                            ++a.j;
                            if (c.dc()) return false;
                            else {
                                for(e = c.Kc(); e.Ob();){
                                    d = e.Pb();
                                    a.qj(b, a.Zi(b, d));
                                    ++b;
                                }
                                return true;
                            }
                        }
                        function OA(a, b, c, d) {
                            var e, f;
                            f = c - b;
                            if (f < 3) while(f < 3){
                                a *= 10;
                                ++f;
                            }
                            else {
                                e = 1;
                                while(f > 3){
                                    e *= 10;
                                    --f;
                                }
                                a = (a + (e >> 1)) / e | 0;
                            }
                            d.i = a;
                            return true;
                        }
                        function BYd(a, b) {
                            var c, d, e;
                            c = (a.i == null && rYd(a), a.i);
                            d = b.Lj();
                            if (d != -1) for(e = c.length; d < e; ++d){
                                if (c[d] == b) return d;
                            }
                            return -1;
                        }
                        function T$d(a) {
                            var b, c, d, e, f;
                            c = RD(a.g, 689);
                            for(d = a.i - 1; d >= 0; --d){
                                b = c[d];
                                for(e = 0; e < d; ++e){
                                    f = c[e];
                                    if (U$d(a, b, f)) {
                                        THd(a, d);
                                        break;
                                    }
                                }
                            }
                        }
                        function PId(a) {
                            var b, c, d, e;
                            b = new MB;
                            for(e = new Ppb(a.b.Kc()); e.b.Ob();){
                                d = RD(e.b.Pb(), 701);
                                c = LFd(d);
                                KB(b, b.a.length, c);
                            }
                            return b.a;
                        }
                        function VNb(a) {
                            var b;
                            !a.c && (a.c = new MNb);
                            _mb(a.d, new aOb);
                            SNb(a);
                            b = LNb(a);
                            FDb(new SDb(null, new Swb(a.d, 16)), new tOb(a));
                            return b;
                        }
                        function I6b(a, b) {
                            b.Ug('End label post-processing', 1);
                            FDb(CDb(EDb(new SDb(null, new Swb(a.b, 16)), new N6b), new P6b), new R6b);
                            b.Vg();
                        }
                        function RCc(a) {
                            QCc();
                            this.c = dv(cD(WC(g2, 1), rve, 845, 0, [
                                FCc
                            ]));
                            this.b = new Tsb;
                            this.a = a;
                            Zjb(this.b, OCc, 1);
                            Umb(PCc, new $rd(this));
                        }
                        function wKb(a, b, c) {
                            kKb();
                            fKb.call(this);
                            this.a = YC(IN, [
                                Nve,
                                Mye
                            ], [
                                603,
                                217
                            ], 0, [
                                jKb,
                                iKb
                            ], 2);
                            this.c = new Tid;
                            this.g = a;
                            this.f = b;
                            this.d = c;
                        }
                        function gQb(a, b) {
                            this.n = YC(lE, [
                                Nve,
                                rxe
                            ], [
                                376,
                                28
                            ], 14, [
                                b,
                                eE($wnd.Math.ceil(a / 32))
                            ], 2);
                            this.o = a;
                            this.p = b;
                            this.j = a - 1 >> 1;
                            this.k = b - 1 >> 1;
                        }
                        function Dfd(a) {
                            Afd();
                            if (RD(a.of((umd(), pld)), 181).Hc((dqd(), bqd))) {
                                RD(a.of(Lld), 181).Fc((Pod(), Ood));
                                RD(a.of(pld), 181).Mc(bqd);
                            }
                        }
                        function ndc(a) {
                            var b, c;
                            b = a.d == (btc(), Ysc);
                            c = jdc(a);
                            b && !c || !b && c ? pQb(a.a, (yCc(), Rzc), (Rjd(), Pjd)) : pQb(a.a, (yCc(), Rzc), (Rjd(), Ojd));
                        }
                        function QCc() {
                            QCc = geb;
                            GCc();
                            OCc = (yCc(), bCc);
                            PCc = dv(cD(WC(V5, 1), kEe, 149, 0, [
                                SBc,
                                TBc,
                                VBc,
                                WBc,
                                ZBc,
                                $Bc,
                                _Bc,
                                aCc,
                                dCc,
                                fCc,
                                UBc,
                                XBc,
                                cCc
                            ]));
                        }
                        function RDb(a, b) {
                            var c;
                            c = RD(zDb(a, tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), vBb)
                            ]))), 15);
                            return c.Qc(__c(c.gc()));
                        }
                        function nXc(a, b) {
                            var c, d;
                            d = new zAb(a.a.ad(b, true));
                            if (d.a.gc() <= 1) throw Adb(new Ngb);
                            c = d.a.ec().Kc();
                            c.Pb();
                            return RD(c.Pb(), 40);
                        }
                        function lQc(a, b, c) {
                            var d, e;
                            d = Kfb(a.p[b.i.p]) + Kfb(a.d[b.i.p]) + b.n.b + b.a.b;
                            e = Kfb(a.p[c.i.p]) + Kfb(a.d[c.i.p]) + c.n.b + c.a.b;
                            return e - d;
                        }
                        function XHd(a, b) {
                            var c;
                            if (a.i > 0) {
                                if (b.length < a.i) {
                                    c = IMd(rb(b).c, a.i);
                                    b = c;
                                }
                                hib(a.g, 0, b, 0, a.i);
                            }
                            b.length > a.i && bD(b, a.i, null);
                            return b;
                        }
                        function MXd(a) {
                            var b;
                            if ((a.Db & 64) != 0) return QAd(a);
                            b = new Shb(QAd(a));
                            b.a += ' (instanceClassName: ';
                            Nhb(b, a.D);
                            b.a += ')';
                            return b.a;
                        }
                        function ySd(a) {
                            var b, c, d, e;
                            e = 0;
                            for(c = 0, d = a.length; c < d; c++){
                                b = (BFb(c, a.length), a.charCodeAt(c));
                                b < 64 && (e = Rdb(e, Sdb(1, b)));
                            }
                            return e;
                        }
                        function Fjb(a, b, c) {
                            var d, e;
                            d = Cdb(c, yxe);
                            for(e = 0; Ddb(d, 0) != 0 && e < b; e++){
                                d = Bdb(d, Cdb(a[e], yxe));
                                a[e] = Ydb(d);
                                d = Tdb(d, 32);
                            }
                            return Ydb(d);
                        }
                        function pge(a, b) {
                            var c, d, e, f;
                            f = pke(a.e.Dh(), b);
                            c = RD(a.g, 124);
                            for(e = 0; e < a.i; ++e){
                                d = c[e];
                                if (f.am(d.Lk())) return false;
                            }
                            return true;
                        }
                        function QNd(a, b) {
                            var c, d, e;
                            if (a.f > 0) {
                                a._j();
                                d = b == null ? 0 : tb(b);
                                e = (d & lve) % a.d.length;
                                c = XNd(a, e, d, b);
                                return c != -1;
                            } else return false;
                        }
                        function Nrb(a, b) {
                            var c, d;
                            a.a = Bdb(a.a, 1);
                            a.c = $wnd.Math.min(a.c, b);
                            a.b = $wnd.Math.max(a.b, b);
                            a.d += b;
                            c = b - a.f;
                            d = a.e + c;
                            a.f = d - a.e - c;
                            a.e = d;
                        }
                        function yyd(a, b) {
                            switch(b){
                                case 3:
                                    Ayd(a, 0);
                                    return;
                                case 4:
                                    Cyd(a, 0);
                                    return;
                                case 5:
                                    Dyd(a, 0);
                                    return;
                                case 6:
                                    Eyd(a, 0);
                                    return;
                            }
                            hyd(a, b);
                        }
                        function c3b(a, b) {
                            switch(b.g){
                                case 1:
                                    return dr(a.j, (J3b(), E3b));
                                case 2:
                                    return dr(a.j, (J3b(), G3b));
                                default:
                                    return yob(), yob(), vob;
                            }
                        }
                        function zm(a) {
                            tm();
                            var b;
                            b = a.Pc();
                            switch(b.length){
                                case 0:
                                    return sm;
                                case 1:
                                    return new Dy(Qb(b[0]));
                                default:
                                    return new Kx(Im(b));
                            }
                        }
                        function kMd(b, c) {
                            b.Xj();
                            try {
                                b.d.bd(b.e++, c);
                                b.f = b.d.j;
                                b.g = -1;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) throw Adb(new Jrb);
                                else throw Adb(a);
                            }
                        }
                        function a8d() {
                            a8d = geb;
                            $7d = new b8d;
                            T7d = new e8d;
                            U7d = new h8d;
                            V7d = new k8d;
                            W7d = new n8d;
                            X7d = new q8d;
                            Y7d = new t8d;
                            Z7d = new w8d;
                            _7d = new z8d;
                        }
                        function YA(a, b) {
                            WA();
                            var c, d;
                            c = _A(($A(), $A(), ZA));
                            d = null;
                            b == c && (d = RD(Xjb(VA, a), 624));
                            if (!d) {
                                d = new XA(a);
                                b == c && $jb(VA, a, d);
                            }
                            return d;
                        }
                        function zDc(a) {
                            wDc();
                            var b;
                            (!a.q ? (yob(), yob(), wob) : a.q)._b((yCc(), iBc)) ? b = RD(mQb(a, iBc), 203) : b = RD(mQb(Y2b(a), jBc), 203);
                            return b;
                        }
                        function hFc(a, b) {
                            var c, d;
                            d = null;
                            if (nQb(a, (yCc(), YBc))) {
                                c = RD(mQb(a, YBc), 96);
                                c.pf(b) && (d = c.of(b));
                            }
                            d == null && (d = mQb(Y2b(a), b));
                            return d;
                        }
                        function Ze(a, b) {
                            var c, d, e;
                            if (ZD(b, 44)) {
                                c = RD(b, 44);
                                d = c.ld();
                                e = Xv(a.Rc(), d);
                                return Hb(e, c.md()) && (e != null || a.Rc()._b(d));
                            }
                            return false;
                        }
                        function $Nd(a, b) {
                            var c, d, e;
                            if (a.f > 0) {
                                a._j();
                                d = b == null ? 0 : tb(b);
                                e = (d & lve) % a.d.length;
                                c = WNd(a, e, d, b);
                                if (c) return c.md();
                            }
                            return null;
                        }
                        function qLd(a, b, c) {
                            var d, e, f;
                            if (a.Pj()) {
                                d = a.i;
                                f = a.Qj();
                                KHd(a, d, b);
                                e = a.Ij(3, null, b, d, f);
                                !c ? c = e : c.nj(e);
                            } else KHd(a, a.i, b);
                            return c;
                        }
                        function f$d(a, b, c) {
                            var d, e;
                            d = new P3d(a.e, 4, 10, (e = b.c, ZD(e, 90) ? RD(e, 29) : (JTd(), zTd)), null, fZd(a, b), false);
                            !c ? c = d : c.nj(d);
                            return c;
                        }
                        function e$d(a, b, c) {
                            var d, e;
                            d = new P3d(a.e, 3, 10, null, (e = b.c, ZD(e, 90) ? RD(e, 29) : (JTd(), zTd)), fZd(a, b), false);
                            !c ? c = d : c.nj(d);
                            return c;
                        }
                        function SMb(a) {
                            RMb();
                            var b;
                            b = new sjd(RD(a.e.of((umd(), nld)), 8));
                            if (a.B.Hc((dqd(), Ypd))) {
                                b.a <= 0 && (b.a = 20);
                                b.b <= 0 && (b.b = 20);
                            }
                            return b;
                        }
                        function jjb(a) {
                            Pib();
                            var b, c;
                            c = Ydb(a);
                            b = Ydb(Udb(a, 32));
                            if (b != 0) return new bjb(c, b);
                            if (c > 10 || c < 0) return new ajb(1, c);
                            return Lib[c];
                        }
                        function Mdb(a, b) {
                            var c;
                            if (Kdb(a) && Kdb(b)) {
                                c = a % b;
                                if (jxe < c && c < hxe) return c;
                            }
                            return Edb((iD(Kdb(a) ? Wdb(a) : a, Kdb(b) ? Wdb(b) : b, true), eD));
                        }
                        function G8b(a, b) {
                            var c;
                            D8b(b);
                            c = RD(mQb(a, (yCc(), xAc)), 283);
                            !!c && pQb(a, xAc, uuc(c));
                            E8b(a.c);
                            E8b(a.f);
                            F8b(a.d);
                            F8b(RD(mQb(a, cBc), 214));
                        }
                        function y7b(a) {
                            var b, c, d, e;
                            d = t7b(a);
                            _mb(d, r7b);
                            e = a.d;
                            e.c.length = 0;
                            for(c = new Anb(d); c.a < c.c.c.length;){
                                b = RD(ynb(c), 466);
                                Tmb(e, b.b);
                            }
                        }
                        function cmc(a) {
                            var b;
                            if (a.c == 0) return;
                            b = RD(Vmb(a.a, a.b), 294);
                            b.b == 1 ? (++a.b, a.b < a.a.c.length && gmc(RD(Vmb(a.a, a.b), 294))) : --b.b;
                            --a.c;
                        }
                        function vdc(a) {
                            var b;
                            b = a.a;
                            do {
                                b = RD(hs(new is(Mr(a3b(b).a.Kc(), new ir))), 18).d.i;
                                b.k == (r3b(), o3b) && Rmb(a.e, b);
                            }while (b.k == (r3b(), o3b));
                        }
                        function RLc(a) {
                            this.e = $C(kE, Pwe, 28, a.length, 15, 1);
                            this.c = $C(xdb, Hye, 28, a.length, 16, 1);
                            this.b = $C(xdb, Hye, 28, a.length, 16, 1);
                            this.f = 0;
                        }
                        function _Hc(a) {
                            var b, c;
                            a.j = $C(iE, vxe, 28, a.p.c.length, 15, 1);
                            for(c = new Anb(a.p); c.a < c.c.c.length;){
                                b = RD(ynb(c), 10);
                                a.j[b.p] = b.o.b / a.i;
                            }
                        }
                        function L_c(a, b) {
                            var c, d, e, f;
                            f = b.b.b;
                            a.a = new Yub;
                            a.b = $C(kE, Pwe, 28, f, 15, 1);
                            c = 0;
                            for(e = Sub(b.b, 0); e.b != e.d.c;){
                                d = RD(evb(e), 40);
                                d.g = c++;
                            }
                        }
                        function fad(a, b, c) {
                            var d, e, f, g;
                            f = b - a.e;
                            g = c - a.f;
                            for(e = new Anb(a.a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 172);
                                U9c(d, d.s + f, d.t + g);
                            }
                            a.e = b;
                            a.f = c;
                        }
                        function ose(a, b) {
                            var c, d;
                            d = b.length;
                            for(c = 0; c < d; c += 2)rte(a, (BFb(c, b.length), b.charCodeAt(c)), (BFb(c + 1, b.length), b.charCodeAt(c + 1)));
                        }
                        function G6c(a, b) {
                            b.Ug('Min Size Postprocessing', 1);
                            Ixd(a, (X6c(), W6c), $wnd.Math.max(Kfb(UD(Gxd(a, W6c))), Kfb(UD(Gxd(a, U6c)))));
                            b.Vg();
                        }
                        function Fpd() {
                            Fpd = geb;
                            Cpd = new A3b(15);
                            Bpd = new mGd((umd(), tld), Cpd);
                            Epd = new mGd(fmd, 15);
                            Dpd = new mGd(Sld, sgb(0));
                            Apd = new mGd(Dkd, Yze);
                        }
                        function Qpd() {
                            Qpd = geb;
                            Opd = new Rpd('PORTS', 0);
                            Ppd = new Rpd('PORT_LABELS', 1);
                            Npd = new Rpd('NODE_LABELS', 2);
                            Mpd = new Rpd('MINIMUM_SIZE', 3);
                        }
                        function f6c() {
                            f6c = geb;
                            c6c = new g6c('P1_WIDTH_APPROXIMATION', 0);
                            d6c = new g6c('P2_PACKING', 1);
                            e6c = new g6c('P3_WHITESPACE_ELIMINATION', 2);
                        }
                        function $je(a) {
                            if (a.b == null) {
                                while(a.a.Ob()){
                                    a.b = a.a.Pb();
                                    if (!RD(a.b, 54).Jh()) return true;
                                }
                                a.b = null;
                                return false;
                            } else return true;
                        }
                        function Pyb(a, b, c) {
                            var d, e, f;
                            e = null;
                            f = a.b;
                            while(f){
                                d = a.a.Ne(b, f.d);
                                if (c && d == 0) return f;
                                if (d >= 0) f = f.a[1];
                                else {
                                    e = f;
                                    f = f.a[0];
                                }
                            }
                            return e;
                        }
                        function Qyb(a, b, c) {
                            var d, e, f;
                            e = null;
                            f = a.b;
                            while(f){
                                d = a.a.Ne(b, f.d);
                                if (c && d == 0) return f;
                                if (d <= 0) f = f.a[0];
                                else {
                                    e = f;
                                    f = f.a[1];
                                }
                            }
                            return e;
                        }
                        function rmc(a, b, c, d) {
                            var e, f, g;
                            e = false;
                            if (Lmc(a.f, c, d)) {
                                Omc(a.f, a.a[b][c], a.a[b][d]);
                                f = a.a[b];
                                g = f[d];
                                f[d] = f[c];
                                f[c] = g;
                                e = true;
                            }
                            return e;
                        }
                        function Nqc(a, b, c) {
                            var d, e, f, g;
                            e = RD(Wjb(a.b, c), 183);
                            d = 0;
                            for(g = new Anb(b.j); g.a < g.c.c.length;){
                                f = RD(ynb(g), 113);
                                e[f.d.p] && ++d;
                            }
                            return d;
                        }
                        function lte(a, b, c) {
                            var d, e;
                            d = RD(Xjb(wse, b), 122);
                            e = RD(Xjb(xse, b), 122);
                            if (c) {
                                $jb(wse, a, d);
                                $jb(xse, a, e);
                            } else {
                                $jb(xse, a, d);
                                $jb(wse, a, e);
                            }
                        }
                        function qjb(a, b) {
                            var c, d, e, f;
                            c = b >> 5;
                            b &= 31;
                            e = a.d + c + (b == 0 ? 0 : 1);
                            d = $C(kE, Pwe, 28, e, 15, 1);
                            rjb(d, a.a, c, b);
                            f = new cjb(a.e, e, d);
                            Rib(f);
                            return f;
                        }
                        function zGc(a, b) {
                            var c, d, e;
                            for(d = new is(Mr(a3b(a).a.Kc(), new ir)); gs(d);){
                                c = RD(hs(d), 18);
                                e = c.d.i;
                                if (e.c == b) return false;
                            }
                            return true;
                        }
                        function _Ec(a, b, c) {
                            var d, e, f, g, h;
                            g = a.k;
                            h = b.k;
                            d = c[g.g][h.g];
                            e = UD(hFc(a, d));
                            f = UD(hFc(b, d));
                            return $wnd.Math.max((uFb(e), e), (uFb(f), f));
                        }
                        function lA() {
                            if (Error.stackTraceLimit > 0) {
                                $wnd.Error.stackTraceLimit = Error.stackTraceLimit = 64;
                                return true;
                            }
                            return 'stack' in new Error;
                        }
                        function sGb(a, b) {
                            return Zy(), Zy(), bz(pwe), ($wnd.Math.abs(a - b) <= pwe || a == b || isNaN(a) && isNaN(b) ? 0 : a < b ? -1 : a > b ? 1 : cz(isNaN(a), isNaN(b))) > 0;
                        }
                        function uGb(a, b) {
                            return Zy(), Zy(), bz(pwe), ($wnd.Math.abs(a - b) <= pwe || a == b || isNaN(a) && isNaN(b) ? 0 : a < b ? -1 : a > b ? 1 : cz(isNaN(a), isNaN(b))) < 0;
                        }
                        function tGb(a, b) {
                            return Zy(), Zy(), bz(pwe), ($wnd.Math.abs(a - b) <= pwe || a == b || isNaN(a) && isNaN(b) ? 0 : a < b ? -1 : a > b ? 1 : cz(isNaN(a), isNaN(b))) <= 0;
                        }
                        function Efb(a, b) {
                            var c = 0;
                            while(!b[c] || b[c] == '')c++;
                            var d = b[c++];
                            for(; c < b.length; c++){
                                if (!b[c] || b[c] == '') continue;
                                d += a + b[c];
                            }
                            return d;
                        }
                        function MMd(a) {
                            var b, c;
                            b = RD(Ywd(a.a, 4), 129);
                            if (b != null) {
                                c = $C(d6, IJe, 424, b.length, 0, 1);
                                hib(b, 0, c, 0, b.length);
                                return c;
                            } else return JMd;
                        }
                        function kne(a) {
                            var b, c, d, e, f;
                            if (a == null) return null;
                            f = new bnb;
                            for(c = xAd(a), d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                Rmb(f, nue(b, true));
                            }
                            return f;
                        }
                        function nne(a) {
                            var b, c, d, e, f;
                            if (a == null) return null;
                            f = new bnb;
                            for(c = xAd(a), d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                Rmb(f, nue(b, true));
                            }
                            return f;
                        }
                        function one(a) {
                            var b, c, d, e, f;
                            if (a == null) return null;
                            f = new bnb;
                            for(c = xAd(a), d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                Rmb(f, nue(b, true));
                            }
                            return f;
                        }
                        function vrd(a, b) {
                            var c, d, e;
                            if (a.c) Ayd(a.c, b);
                            else {
                                c = b - trd(a);
                                for(e = new Anb(a.a); e.a < e.c.c.length;){
                                    d = RD(ynb(e), 163);
                                    vrd(d, trd(d) + c);
                                }
                            }
                        }
                        function wrd(a, b) {
                            var c, d, e;
                            if (a.c) Cyd(a.c, b);
                            else {
                                c = b - urd(a);
                                for(e = new Anb(a.d); e.a < e.c.c.length;){
                                    d = RD(ynb(e), 163);
                                    wrd(d, urd(d) + c);
                                }
                            }
                        }
                        function Ihb(a, b, c) {
                            var d, e, f, g;
                            f = b + c;
                            AFb(b, f, a.length);
                            g = '';
                            for(e = b; e < f;){
                                d = $wnd.Math.min(e + 10000, f);
                                g += Ehb(a.slice(e, d));
                                e = d;
                            }
                            return g;
                        }
                        function jMb(a) {
                            switch(a.g){
                                case 12:
                                case 13:
                                case 14:
                                case 15:
                                case 16:
                                case 17:
                                case 18:
                                case 19:
                                case 20:
                                    return true;
                                default:
                                    return false;
                            }
                        }
                        function Ptc() {
                            Ptc = geb;
                            Ltc = new Rtc(CBe, 0);
                            Ktc = new Rtc(DBe, 1);
                            Ntc = new Rtc(BBe, 2);
                            Otc = new Rtc(MAe, 3);
                            Mtc = new Rtc('GREEDY_MODEL_ORDER', 4);
                        }
                        function kEc() {
                            kEc = geb;
                            hEc = new lEc(LAe, 0);
                            gEc = new lEc('NODES_AND_EDGES', 1);
                            iEc = new lEc('PREFER_EDGES', 2);
                            jEc = new lEc('PREFER_NODES', 3);
                        }
                        function mad(a, b, c, d, e, f) {
                            this.a = a;
                            this.c = b;
                            this.b = c;
                            this.f = d;
                            this.d = e;
                            this.e = f;
                            this.c > 0 && this.b > 0 && (this.g = Aad(this.c, this.b, this.a));
                        }
                        function rC(f, a) {
                            var b = f.a;
                            var c;
                            a = String(a);
                            b.hasOwnProperty(a) && (c = b[a]);
                            var d = (HC(), GC)[typeof c];
                            var e = d ? d(c) : NC(typeof c);
                            return e;
                        }
                        function uDd(a) {
                            var b, c, d;
                            d = null;
                            b = uIe in a.a;
                            c = !b;
                            if (c) throw Adb(new CDd('Every element must have an id.'));
                            d = tDd(qC(a, uIe));
                            return d;
                        }
                        function Qqe(a) {
                            var b, c;
                            c = Rqe(a);
                            b = null;
                            while(a.c == 2){
                                Mqe(a);
                                if (!b) {
                                    b = (Vse(), Vse(), ++Use, new iue(2));
                                    hue(b, c);
                                    c = b;
                                }
                                c.Jm(Rqe(a));
                            }
                            return c;
                        }
                        function jOd(a, b) {
                            var c, d, e;
                            a._j();
                            d = b == null ? 0 : tb(b);
                            e = (d & lve) % a.d.length;
                            c = WNd(a, e, d, b);
                            if (c) {
                                hOd(a, c);
                                return c.md();
                            } else return null;
                        }
                        function Qib(a, b) {
                            if (a.e > b.e) return 1;
                            if (a.e < b.e) return -1;
                            if (a.d > b.d) return a.e;
                            if (a.d < b.d) return -b.e;
                            return a.e * Ejb(a.a, b.a, a.d);
                        }
                        function dfb(a) {
                            if (a >= 48 && a < 48 + $wnd.Math.min(10, 10)) return a - 48;
                            if (a >= 97 && a < 97) return a - 97 + 10;
                            if (a >= 65 && a < 65) return a - 65 + 10;
                            return -1;
                        }
                        function UHc(a, b) {
                            if (b.c == a) return b.d;
                            else if (b.d == a) return b.c;
                            throw Adb(new agb('Input edge is not connected to the input port.'));
                        }
                        function Fae(a) {
                            if (mhb(FGe, a)) return Geb(), Feb;
                            else if (mhb(GGe, a)) return Geb(), Eeb;
                            else throw Adb(new agb('Expecting true or false'));
                        }
                        function jFb(a) {
                            switch(typeof a){
                                case jve:
                                    return ohb(a);
                                case ive:
                                    return Nfb(a);
                                case hve:
                                    return Jeb(a);
                                default:
                                    return a == null ? 0 : kFb(a);
                            }
                        }
                        function mfd(a, b) {
                            if (a.a < 0) throw Adb(new dgb('Did not call before(...) or after(...) before calling add(...).'));
                            tfd(a, a.a, b);
                            return a;
                        }
                        function FId(a) {
                            EId();
                            if (ZD(a, 162)) return RD(Wjb(CId, zK), 295).Rg(a);
                            if (Ujb(CId, rb(a))) return RD(Wjb(CId, rb(a)), 295).Rg(a);
                            return null;
                        }
                        function Wwd(a) {
                            var b, c;
                            if ((a.Db & 32) == 0) {
                                c = (b = RD(Ywd(a, 16), 29), AYd(!b ? a.ii() : b) - AYd(a.ii()));
                                c != 0 && $wd(a, 32, $C(jJ, rve, 1, c, 5, 1));
                            }
                            return a;
                        }
                        function $wd(a, b, c) {
                            var d;
                            if ((a.Db & b) != 0) {
                                if (c == null) Zwd(a, b);
                                else {
                                    d = Xwd(a, b);
                                    d == -1 ? a.Eb = c : bD(SD(a.Eb), d, c);
                                }
                            } else c != null && Twd(a, b, c);
                        }
                        function tTc(a, b, c, d) {
                            var e, f;
                            if (b.c.length == 0) return;
                            e = pTc(c, d);
                            f = oTc(b);
                            FDb(PDb(new SDb(null, new Swb(f, 1)), new CTc), new GTc(a, c, e, d));
                        }
                        function rmb(a, b) {
                            var c, d, e, f;
                            d = a.a.length - 1;
                            c = b - a.b & d;
                            f = a.c - b & d;
                            e = a.c - a.b & d;
                            zmb(c < e);
                            if (c >= f) {
                                umb(a, b);
                                return -1;
                            } else {
                                vmb(a, b);
                                return 1;
                            }
                        }
                        function Hvd(a) {
                            var b, c, d;
                            d = a.Jh();
                            if (!d) {
                                b = 0;
                                for(c = a.Ph(); c; c = c.Ph()){
                                    if (++b > wxe) return c.Qh();
                                    d = c.Jh();
                                    if (!!d || c == a) break;
                                }
                            }
                            return d;
                        }
                        function Ue(a, b) {
                            var c;
                            if (dE(b) === dE(a)) return true;
                            if (!ZD(b, 21)) return false;
                            c = RD(b, 21);
                            if (c.gc() != a.gc()) return false;
                            return a.Ic(c);
                        }
                        function kNc(a, b) {
                            if (a.e < b.e) return -1;
                            else if (a.e > b.e) return 1;
                            else if (a.f < b.f) return -1;
                            else if (a.f > b.f) return 1;
                            return tb(a) - tb(b);
                        }
                        function mhb(a, b) {
                            uFb(a);
                            if (b == null) return false;
                            if (lhb(a, b)) return true;
                            return a.length == b.length && lhb(a.toLowerCase(), b.toLowerCase());
                        }
                        function Hgb(a) {
                            var b, c;
                            if (Ddb(a, -129) > 0 && Ddb(a, 128) < 0) return Jgb(), b = Ydb(a) + 128, c = Igb[b], !c && (c = Igb[b] = new zgb(a)), c;
                            return new zgb(a);
                        }
                        function U$b() {
                            U$b = geb;
                            T$b = new V$b(LAe, 0);
                            R$b = new V$b('INSIDE_PORT_SIDE_GROUPS', 1);
                            Q$b = new V$b('GROUP_MODEL_ORDER', 2);
                            S$b = new V$b(MAe, 3);
                        }
                        function ufe(a) {
                            var b;
                            a.b || vfe(a, (b = Hee(a.e, a.a), !b || !lhb(GGe, $Nd((!b.b && (b.b = new SVd((JTd(), FTd), C8, b)), b.b), 'qualified'))));
                            return a.c;
                        }
                        function BA(a, b) {
                            var c, d;
                            c = (BFb(b, a.length), a.charCodeAt(b));
                            d = b + 1;
                            while(d < a.length && (BFb(d, a.length), a.charCodeAt(d) == c))++d;
                            return d - b;
                        }
                        function dFb(a, b) {
                            (!b && console.groupCollapsed != null ? console.groupCollapsed : console.group != null ? console.group : console.log).call(console, a);
                        }
                        function EQb(a, b, c, d) {
                            d == a ? (RD(c.b, 68), RD(c.b, 68), RD(d.b, 68), RD(d.b, 68).c.b) : (RD(c.b, 68), RD(c.b, 68), RD(d.b, 68), RD(d.b, 68).c.b);
                            BQb(d, b, a);
                        }
                        function vRb(a) {
                            var b, c, d;
                            b = 0;
                            for(c = new Anb(a.g); c.a < c.c.c.length;){
                                RD(ynb(c), 568);
                                ++b;
                            }
                            d = new vQb(a.g, Kfb(a.a), a.c);
                            vOb(d);
                            a.g = d.b;
                            a.d = d.a;
                        }
                        function Add(a, b, c) {
                            var d, e, f;
                            for(f = new Anb(c.a); f.a < f.c.c.length;){
                                e = RD(ynb(f), 225);
                                d = new $Fb(RD(Wjb(a.a, e.b), 68));
                                Rmb(b.a, d);
                                Add(a, d, e);
                            }
                        }
                        function D4d(a, b, c) {
                            var d, e, f;
                            d = RD(QHd(o4d(a.a), b), 89);
                            f = (e = d.c, e ? e : (JTd(), wTd));
                            (f.Vh() ? Vvd(a.b, RD(f, 54)) : f) == c ? i2d(d) : l2d(d, c);
                            return f;
                        }
                        function cqc(a, b, c) {
                            b.b = $wnd.Math.max(b.b, -c.a);
                            b.c = $wnd.Math.max(b.c, c.a - a.a);
                            b.d = $wnd.Math.max(b.d, -c.b);
                            b.a = $wnd.Math.max(b.a, c.b - a.b);
                        }
                        function JXb(a, b, c) {
                            this.c = a;
                            this.f = new bnb;
                            this.e = new pjd;
                            this.j = new KYb;
                            this.n = new KYb;
                            this.b = b;
                            this.g = new Uid(b.c, b.d, b.b, b.a);
                            this.a = c;
                        }
                        function iYb(a) {
                            var b, c, d, e;
                            this.a = new Iub;
                            this.d = new _sb;
                            this.e = 0;
                            for(c = a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                !this.f && (this.f = b);
                                gYb(this, b);
                            }
                        }
                        function djb(a) {
                            Pib();
                            if (a.length == 0) {
                                this.e = 0;
                                this.d = 1;
                                this.a = cD(WC(kE, 1), Pwe, 28, 15, [
                                    0
                                ]);
                            } else {
                                this.e = 1;
                                this.d = a.length;
                                this.a = a;
                                Rib(this);
                            }
                        }
                        function dLb(a, b, c) {
                            fKb.call(this);
                            this.a = $C(IN, Mye, 217, (ZJb(), cD(WC(JN, 1), jwe, 237, 0, [
                                WJb,
                                XJb,
                                YJb
                            ])).length, 0, 1);
                            this.b = a;
                            this.d = b;
                            this.c = c;
                        }
                        function zfc(a) {
                            var b, c, d, e, f, g;
                            g = RD(mQb(a, (Ywc(), Awc)), 12);
                            pQb(g, Swc, a.i.n.b);
                            b = s2b(a.e);
                            for(d = b, e = 0, f = d.length; e < f; ++e){
                                c = d[e];
                                Z0b(c, g);
                            }
                        }
                        function Afc(a) {
                            var b, c, d, e, f, g;
                            c = RD(mQb(a, (Ywc(), Awc)), 12);
                            pQb(c, Swc, a.i.n.b);
                            b = s2b(a.g);
                            for(e = b, f = 0, g = e.length; f < g; ++f){
                                d = e[f];
                                Y0b(d, c);
                            }
                        }
                        function dRc(a, b) {
                            WQc();
                            var c, d;
                            for(d = new is(Mr(W2b(a).a.Kc(), new ir)); gs(d);){
                                c = RD(hs(d), 18);
                                if (c.d.i == b || c.c.i == b) return c;
                            }
                            return null;
                        }
                        function zee(a, b) {
                            var c, d;
                            c = b.qi(a.a);
                            if (c) {
                                d = WD($Nd((!c.b && (c.b = new SVd((JTd(), FTd), C8, c)), c.b), GIe));
                                if (d != null) return d;
                            }
                            return b.xe();
                        }
                        function Aee(a, b) {
                            var c, d;
                            c = b.qi(a.a);
                            if (c) {
                                d = WD($Nd((!c.b && (c.b = new SVd((JTd(), FTd), C8, c)), c.b), GIe));
                                if (d != null) return d;
                            }
                            return b.xe();
                        }
                        function B7b(a, b) {
                            var c, d;
                            c = hgb(a.a.c.p, b.a.c.p);
                            if (c != 0) return c;
                            d = hgb(a.a.d.i.p, b.a.d.i.p);
                            if (d != 0) return d;
                            return hgb(b.a.d.p, a.a.d.p);
                        }
                        function Wje(a, b) {
                            var c, d, e, f;
                            for(d = 0, e = b.gc(); d < e; ++d){
                                c = b.Tl(d);
                                if (ZD(c, 102) && (RD(c, 19).Bb & QHe) != 0) {
                                    f = b.Ul(d);
                                    f != null && Rje(a, RD(f, 58));
                                }
                            }
                        }
                        function KSb(a, b) {
                            var c, d, e;
                            Rmb(GSb, a);
                            b.Fc(a);
                            c = RD(Wjb(FSb, a), 21);
                            if (c) for(e = c.Kc(); e.Ob();){
                                d = RD(e.Pb(), 27);
                                Wmb(GSb, d, 0) != -1 || KSb(d, b);
                            }
                        }
                        function Omc(a, b, c) {
                            var d, e;
                            BMc(a.e, b, c, (qpd(), ppd));
                            BMc(a.i, b, c, Xod);
                            if (a.a) {
                                e = RD(mQb(b, (Ywc(), Awc)), 12);
                                d = RD(mQb(c, Awc), 12);
                                CMc(a.g, e, d);
                            }
                        }
                        function mJc(a, b, c) {
                            var d, e, f;
                            d = b.c.p;
                            f = b.p;
                            a.b[d][f] = new yJc(a, b);
                            if (c) {
                                a.a[d][f] = new dJc(b);
                                e = RD(mQb(b, (Ywc(), pwc)), 10);
                                !!e && Rc(a.d, e, b);
                            }
                        }
                        function zIc(a, b, c) {
                            var d, e, f, g;
                            f = b.j;
                            g = c.j;
                            if (f != g) return f.g - g.g;
                            else {
                                d = a.f[b.p];
                                e = a.f[c.p];
                                return d == 0 && e == 0 ? 0 : d == 0 ? -1 : e == 0 ? 1 : Qfb(d, e);
                            }
                        }
                        function Sz() {
                            var a;
                            if (Nz != 0) {
                                a = Date.now();
                                if (a - Oz > 2000) {
                                    Oz = a;
                                    Pz = $wnd.setTimeout(Yz, 10);
                                }
                            }
                            if (Nz++ == 0) {
                                _z(($z(), Zz));
                                return true;
                            }
                            return false;
                        }
                        function lBb(a, b, c) {
                            var d;
                            (bBb ? (jBb(a), true) : cBb ? (SAb(), true) : fBb ? (SAb(), true) : eBb && (SAb(), false)) && (d = new aBb(b), d.b = c, hBb(a, d), undefined);
                        }
                        function oNb(a, b) {
                            var c;
                            c = !a.A.Hc((Qpd(), Ppd)) || a.q == (Bod(), wod);
                            a.u.Hc((Pod(), Lod)) ? c ? mNb(a, b) : qNb(a, b) : a.u.Hc(Nod) && (c ? nNb(a, b) : rNb(a, b));
                        }
                        function Bed(a) {
                            var b;
                            if (dE(Gxd(a, (umd(), Xkd))) === dE((Fnd(), Dnd))) {
                                if (!vCd(a)) Ixd(a, Xkd, End);
                                else {
                                    b = RD(Gxd(vCd(a), Xkd), 346);
                                    Ixd(a, Xkd, b);
                                }
                            }
                        }
                        function _fc(a) {
                            var b, c;
                            if (nQb(a.d.i, (yCc(), tBc))) {
                                b = RD(mQb(a.c.i, tBc), 17);
                                c = RD(mQb(a.d.i, tBc), 17);
                                return hgb(b.a, c.a) > 0;
                            } else return false;
                        }
                        function g_b(a, b, c) {
                            return new Uid($wnd.Math.min(a.a, b.a) - c / 2, $wnd.Math.min(a.b, b.b) - c / 2, $wnd.Math.abs(a.a - b.a) + c, $wnd.Math.abs(a.b - b.b) + c);
                        }
                        function _mc(a) {
                            var b;
                            this.d = new bnb;
                            this.j = new pjd;
                            this.g = new pjd;
                            b = a.g.b;
                            this.f = RD(mQb(Y2b(b), (yCc(), rAc)), 88);
                            this.e = Kfb(UD(k2b(b, ZBc)));
                        }
                        function onc(a) {
                            this.d = new bnb;
                            this.e = new gub;
                            this.c = $C(kE, Pwe, 28, (qpd(), cD(WC(E3, 1), NAe, 64, 0, [
                                opd,
                                Yod,
                                Xod,
                                npd,
                                ppd
                            ])).length, 15, 1);
                            this.b = a;
                        }
                        function $pc(a, b, c) {
                            var d;
                            d = c[a.g][b];
                            switch(a.g){
                                case 1:
                                case 3:
                                    return new rjd(0, d);
                                case 2:
                                case 4:
                                    return new rjd(d, 0);
                                default:
                                    return null;
                            }
                        }
                        function Ced(b, c, d) {
                            var e, f;
                            f = RD(ltd(c.f), 205);
                            try {
                                f.rf(b, d);
                                mtd(c.f, f);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 103)) {
                                    e = a;
                                    throw Adb(e);
                                } else throw Adb(a);
                            }
                        }
                        function tEd(a, b, c) {
                            var d, e, f, g, h, i;
                            d = null;
                            h = vgd(ygd(), b);
                            f = null;
                            if (h) {
                                e = null;
                                i = zhd(h, c);
                                g = null;
                                i != null && (g = a.qf(h, i));
                                e = g;
                                f = e;
                            }
                            d = f;
                            return d;
                        }
                        function sSd(a, b, c, d) {
                            var e;
                            e = a.length;
                            if (b >= e) return e;
                            for(b = b > 0 ? b : 0; b < e; b++){
                                if (zSd((BFb(b, a.length), a.charCodeAt(b)), c, d)) break;
                            }
                            return b;
                        }
                        function anb(a, b) {
                            var c, d;
                            d = a.c.length;
                            b.length < d && (b = cFb(new Array(d), b));
                            for(c = 0; c < d; ++c)bD(b, c, a.c[c]);
                            b.length > d && bD(b, d, null);
                            return b;
                        }
                        function lob(a, b) {
                            var c, d;
                            d = a.a.length;
                            b.length < d && (b = cFb(new Array(d), b));
                            for(c = 0; c < d; ++c)bD(b, c, a.a[c]);
                            b.length > d && bD(b, d, null);
                            return b;
                        }
                        function Bde(a, b) {
                            var c, d;
                            ++a.j;
                            if (b != null) {
                                c = (d = a.a.Cb, ZD(d, 99) ? RD(d, 99).th() : null);
                                if (Jnb(b, c)) {
                                    $wd(a.a, 4, c);
                                    return;
                                }
                            }
                            $wd(a.a, 4, RD(b, 129));
                        }
                        function mne(a) {
                            var b;
                            if (a == null) return null;
                            b = Hqe(nue(a, true));
                            if (b == null) throw Adb(new Mle("Invalid hexBinary value: '" + a + "'"));
                            return b;
                        }
                        function wA(a, b, c) {
                            var d;
                            if (b.a.length > 0) {
                                Rmb(a.b, new kB(b.a, c));
                                d = b.a.length;
                                0 < d ? b.a = zhb(b.a, 0, 0) : 0 > d && (b.a += Hhb($C(hE, zwe, 28, -d, 15, 1)));
                            }
                        }
                        function yIb(a, b, c) {
                            var d, e, f;
                            if (c[b.d]) return;
                            c[b.d] = true;
                            for(e = new Anb(CIb(b)); e.a < e.c.c.length;){
                                d = RD(ynb(e), 218);
                                f = oIb(d, b);
                                yIb(a, f, c);
                            }
                        }
                        function dub(a, b, c) {
                            var d, e, f;
                            e = RD(Wjb(a.e, b), 400);
                            if (!e) {
                                d = new uub(a, b, c);
                                Zjb(a.e, b, d);
                                qub(d);
                                return null;
                            } else {
                                f = qlb(e, c);
                                eub(a, e);
                                return f;
                            }
                        }
                        function r5d(a, b, c, d) {
                            var e, f, g;
                            e = new P3d(a.e, 1, 13, (g = b.c, g ? g : (JTd(), wTd)), (f = c.c, f ? f : (JTd(), wTd)), fZd(a, b), false);
                            !d ? d = e : d.nj(e);
                            return d;
                        }
                        function nMb() {
                            hMb();
                            return cD(WC(XN, 1), jwe, 164, 0, [
                                eMb,
                                dMb,
                                fMb,
                                XLb,
                                WLb,
                                YLb,
                                _Lb,
                                $Lb,
                                ZLb,
                                cMb,
                                bMb,
                                aMb,
                                ULb,
                                TLb,
                                VLb,
                                RLb,
                                QLb,
                                SLb,
                                OLb,
                                NLb,
                                PLb,
                                gMb
                            ]);
                        }
                        function jWc(a) {
                            switch(a.g){
                                case 4:
                                    return new rjd(0, -1);
                                case 1:
                                    return new rjd(1, 0);
                                case 2:
                                    return new rjd(-1, 0);
                                default:
                                    return new rjd(0, 1);
                            }
                        }
                        function f_b(a) {
                            switch(a.g){
                                case 1:
                                    return Cmd(), Bmd;
                                case 4:
                                    return Cmd(), ymd;
                                case 2:
                                    return Cmd(), zmd;
                                case 3:
                                    return Cmd(), xmd;
                            }
                            return Cmd(), Amd;
                        }
                        function s$d(a) {
                            var b;
                            b = a.hj(null);
                            switch(b){
                                case 10:
                                    return 0;
                                case 15:
                                    return 1;
                                case 14:
                                    return 2;
                                case 11:
                                    return 3;
                                case 21:
                                    return 4;
                            }
                            return -1;
                        }
                        function Yhd() {
                            Yhd = geb;
                            Whd = new Zhd('PARENTS', 0);
                            Vhd = new Zhd('NODES', 1);
                            Thd = new Zhd('EDGES', 2);
                            Xhd = new Zhd('PORTS', 3);
                            Uhd = new Zhd('LABELS', 4);
                        }
                        function AA(a, b, c) {
                            var d;
                            d = c.q.getFullYear() - Owe + Owe;
                            d < 0 && (d = -d);
                            switch(b){
                                case 1:
                                    a.a += d;
                                    break;
                                case 2:
                                    UA(a, d % 100, 2);
                                    break;
                                default:
                                    UA(a, d, b);
                            }
                        }
                        function Sub(a, b) {
                            var c, d;
                            wFb(b, a.b);
                            if (b >= a.b >> 1) {
                                d = a.c;
                                for(c = a.b; c > b; --c)d = d.b;
                            } else {
                                d = a.a.a;
                                for(c = 0; c < b; ++c)d = d.a;
                            }
                            return new hvb(a, b, d);
                        }
                        function DHb() {
                            DHb = geb;
                            CHb = new EHb('NUM_OF_EXTERNAL_SIDES_THAN_NUM_OF_EXTENSIONS_LAST', 0);
                            BHb = new EHb('CORNER_CASES_THAN_SINGLE_SIDE_LAST', 1);
                        }
                        function tnc(a) {
                            this.b = new bnb;
                            this.e = new bnb;
                            this.d = a;
                            this.a = !QDb(CDb(new SDb(null, new Twb(new l4b(a.b))), new PAb(new unc))).Bd((xDb(), wDb));
                        }
                        function ssc(a, b) {
                            var c, d, e, f;
                            c = 0;
                            for(e = new Anb(b.a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 10);
                                f = d.o.a + d.d.c + d.d.b + a.j;
                                c = $wnd.Math.max(c, f);
                            }
                            return c;
                        }
                        function OUc(a, b) {
                            var c, d, e;
                            e = b.d.i;
                            d = e.k;
                            if (d == (r3b(), p3b) || d == l3b) return;
                            c = new is(Mr(a3b(e).a.Kc(), new ir));
                            gs(c) && Zjb(a.k, b, RD(hs(c), 18));
                        }
                        function O0c(a, b) {
                            B0c();
                            return Qfb((a.a.b == 0 ? new rjd(a.c.e.a, a.c.e.b) : RD(Qub(a.a), 8)).b, (b.a.b == 0 ? new rjd(b.c.e.a, b.c.e.b) : RD(Qub(b.a), 8)).b);
                        }
                        function P0c(a, b) {
                            B0c();
                            return Qfb((a.a.b == 0 ? new rjd(a.c.e.a, a.c.e.b) : RD(Qub(a.a), 8)).a, (b.a.b == 0 ? new rjd(b.c.e.a, b.c.e.b) : RD(Qub(b.a), 8)).a);
                        }
                        function S0c(a, b) {
                            B0c();
                            return Qfb((a.a.b == 0 ? new rjd(a.b.e.a, a.b.e.b) : RD(Rub(a.a), 8)).a, (b.a.b == 0 ? new rjd(b.b.e.a, b.b.e.b) : RD(Rub(b.a), 8)).a);
                        }
                        function Q0c(a, b) {
                            B0c();
                            return Qfb((a.a.b == 0 ? new rjd(a.b.e.a, a.b.e.b) : RD(Rub(a.a), 8)).b, (b.a.b == 0 ? new rjd(b.b.e.a, b.b.e.b) : RD(Rub(b.a), 8)).b);
                        }
                        function pod() {
                            pod = geb;
                            mod = new qod('DISTRIBUTED', 0);
                            ood = new qod('JUSTIFIED', 1);
                            kod = new qod('BEGIN', 2);
                            lod = new qod(Kye, 3);
                            nod = new qod('END', 4);
                        }
                        function Kvd(a, b) {
                            var c, d, e;
                            d = vYd(a.Dh(), b);
                            c = b - a.ji();
                            return c < 0 ? (e = a.Ih(d), e >= 0 ? a.Wh(e) : Rvd(a, d)) : c < 0 ? Rvd(a, d) : RD(d, 69).wk().Bk(a, a.hi(), c);
                        }
                        function Fxd(a) {
                            var b, c, d;
                            d = (!a.o && (a.o = new DVd((pvd(), mvd), X4, a, 0)), a.o);
                            for(c = d.c.Kc(); c.e != c.i.gc();){
                                b = RD(c.Yj(), 44);
                                b.md();
                            }
                            return dOd(d);
                        }
                        function iGd(a) {
                            var b;
                            if (ZD(a.a, 4)) {
                                b = FId(a.a);
                                if (b == null) throw Adb(new dgb(HGe + a.b + "'. " + DGe + (lfb(b6), b6.k) + EGe));
                                return b;
                            } else return a.a;
                        }
                        function iSd(a, b) {
                            var c, d;
                            if (a.j.length != b.j.length) return false;
                            for(c = 0, d = a.j.length; c < d; c++){
                                if (!lhb(a.j[c], b.j[c])) return false;
                            }
                            return true;
                        }
                        function bMd(b) {
                            var c;
                            try {
                                c = b.i.Xb(b.e);
                                b.Xj();
                                b.g = b.e++;
                                return c;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) {
                                    b.Xj();
                                    throw Adb(new Dvb);
                                } else throw Adb(a);
                            }
                        }
                        function xMd(b) {
                            var c;
                            try {
                                c = b.c.Vi(b.e);
                                b.Xj();
                                b.g = b.e++;
                                return c;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) {
                                    b.Xj();
                                    throw Adb(new Dvb);
                                } else throw Adb(a);
                            }
                        }
                        function vSd(a) {
                            var b, c, d, e;
                            e = 0;
                            for(c = 0, d = a.length; c < d; c++){
                                b = (BFb(c, a.length), a.charCodeAt(c));
                                b >= 64 && b < 128 && (e = Rdb(e, Sdb(1, b - 64)));
                            }
                            return e;
                        }
                        function k2b(a, b) {
                            var c, d;
                            d = null;
                            if (nQb(a, (umd(), amd))) {
                                c = RD(mQb(a, amd), 96);
                                c.pf(b) && (d = c.of(b));
                            }
                            d == null && !!Y2b(a) && (d = mQb(Y2b(a), b));
                            return d;
                        }
                        function i0b(a, b) {
                            var c;
                            c = RD(mQb(a, (yCc(), RAc)), 75);
                            if (br(b, f0b)) {
                                if (!c) {
                                    c = new Ejd;
                                    pQb(a, RAc, c);
                                } else Xub(c);
                            } else !!c && pQb(a, RAc, null);
                            return c;
                        }
                        function tSb() {
                            tSb = geb;
                            sSb = (umd(), Yld);
                            mSb = Ukd;
                            hSb = Dkd;
                            nSb = tld;
                            qSb = (YHb(), UHb);
                            pSb = SHb;
                            rSb = WHb;
                            oSb = RHb;
                            jSb = (eSb(), aSb);
                            iSb = _Rb;
                            kSb = cSb;
                            lSb = dSb;
                        }
                        function PZb(a) {
                            NZb();
                            this.c = new bnb;
                            this.d = a;
                            switch(a.g){
                                case 0:
                                case 2:
                                    this.a = Fob(MZb);
                                    this.b = oxe;
                                    break;
                                case 3:
                                case 1:
                                    this.a = MZb;
                                    this.b = pxe;
                            }
                        }
                        function c9b(a) {
                            var b;
                            if (!Cod(RD(mQb(a, (yCc(), BBc)), 101))) return;
                            b = a.b;
                            d9b((tFb(0, b.c.length), RD(b.c[0], 30)));
                            d9b(RD(Vmb(b, b.c.length - 1), 30));
                        }
                        function ohc(a, b) {
                            b.Ug('Self-Loop post-processing', 1);
                            FDb(CDb(CDb(EDb(new SDb(null, new Swb(a.b, 16)), new uhc), new whc), new yhc), new Ahc);
                            b.Vg();
                        }
                        function xrd(a, b, c) {
                            var d, e;
                            if (a.c) {
                                Dyd(a.c, a.c.i + b);
                                Eyd(a.c, a.c.j + c);
                            } else for(e = new Anb(a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 163);
                                xrd(d, b, c);
                            }
                        }
                        function ine(a) {
                            var b;
                            if (a == null) return null;
                            b = Aqe(nue(a, true));
                            if (b == null) throw Adb(new Mle("Invalid base64Binary value: '" + a + "'"));
                            return b;
                        }
                        function ju(b, c) {
                            var d;
                            d = b.fd(c);
                            try {
                                return d.Pb();
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 112)) throw Adb(new veb("Can't get element " + c));
                                else throw Adb(a);
                            }
                        }
                        function ANb(a, b) {
                            var c, d, e;
                            c = a.o;
                            for(e = RD(RD(Qc(a.r, b), 21), 87).Kc(); e.Ob();){
                                d = RD(e.Pb(), 117);
                                d.e.a = uNb(d, c.a);
                                d.e.b = c.b * Kfb(UD(d.b.of(sNb)));
                            }
                        }
                        function kdc(a, b) {
                            var c, d, e;
                            e = new cnb(b.gc());
                            for(d = b.Kc(); d.Ob();){
                                c = RD(d.Pb(), 293);
                                c.c == c.f ? _cc(a, c, c.c) : adc(a, c) || ZEb(e.c, c);
                            }
                            return e;
                        }
                        function i3b(a) {
                            var b;
                            b = new bib;
                            b.a += 'n';
                            a.k != (r3b(), p3b) && Zhb(Zhb((b.a += '(', b), ps(a.k).toLowerCase()), ')');
                            Zhb((b.a += '_', b), X2b(a));
                            return b.a;
                        }
                        function h9b(a, b) {
                            var c, d, e, f;
                            e = a.k;
                            c = Kfb(UD(mQb(a, (Ywc(), Jwc))));
                            f = b.k;
                            d = Kfb(UD(mQb(b, Jwc)));
                            return f != (r3b(), m3b) ? -1 : e != m3b ? 1 : c == d ? 0 : c < d ? -1 : 1;
                        }
                        function Lad(a, b) {
                            var c, d;
                            c = RD(RD(Wjb(a.g, b.a), 42).a, 68);
                            d = RD(RD(Wjb(a.g, b.b), 42).a, 68);
                            return bjd(b.a, b.b) - bjd(b.a, Pid(c.b)) - bjd(b.b, Pid(d.b));
                        }
                        function GMb(a, b) {
                            var c;
                            c = RD(Vrb(a.b, b), 127).n;
                            switch(b.g){
                                case 1:
                                    a.t >= 0 && (c.d = a.t);
                                    break;
                                case 3:
                                    a.t >= 0 && (c.a = a.t);
                            }
                            if (a.C) {
                                c.b = a.C.b;
                                c.c = a.C.c;
                            }
                        }
                        function JDc() {
                            JDc = geb;
                            IDc = new LDc(mEe, 0);
                            FDc = new LDc(BBe, 1);
                            GDc = new LDc('LINEAR_SEGMENTS', 2);
                            EDc = new LDc('BRANDES_KOEPF', 3);
                            HDc = new LDc(lEe, 4);
                        }
                        function IRb() {
                            IRb = geb;
                            FRb = new JRb(_ye, 0);
                            ERb = new JRb(aze, 1);
                            GRb = new JRb(bze, 2);
                            HRb = new JRb(cze, 3);
                            FRb.a = false;
                            ERb.a = true;
                            GRb.a = false;
                            HRb.a = true;
                        }
                        function IPb() {
                            IPb = geb;
                            FPb = new JPb(_ye, 0);
                            EPb = new JPb(aze, 1);
                            GPb = new JPb(bze, 2);
                            HPb = new JPb(cze, 3);
                            FPb.a = false;
                            EPb.a = true;
                            GPb.a = false;
                            HPb.a = true;
                        }
                        function Ivd(a, b, c, d) {
                            var e;
                            if (c >= 0) return a.Sh(b, c, d);
                            else {
                                !!a.Ph() && (d = (e = a.Fh(), e >= 0 ? a.Ah(d) : a.Ph().Th(a, -1 - e, null, d)));
                                return a.Ch(b, c, d);
                            }
                        }
                        function Zyd(a, b) {
                            switch(b){
                                case 7:
                                    !a.e && (a.e = new Yie(G4, a, 7, 4));
                                    sLd(a.e);
                                    return;
                                case 8:
                                    !a.d && (a.d = new Yie(G4, a, 8, 5));
                                    sLd(a.d);
                                    return;
                            }
                            yyd(a, b);
                        }
                        function Ixd(a, b, c) {
                            c == null ? (!a.o && (a.o = new DVd((pvd(), mvd), X4, a, 0)), jOd(a.o, b)) : (!a.o && (a.o = new DVd((pvd(), mvd), X4, a, 0)), fOd(a.o, b, c));
                            return a;
                        }
                        function Aob(a, b) {
                            yob();
                            var c, d, e, f;
                            c = a;
                            f = b;
                            if (ZD(a, 21) && !ZD(b, 21)) {
                                c = b;
                                f = a;
                            }
                            for(e = c.Kc(); e.Ob();){
                                d = e.Pb();
                                if (f.Hc(d)) return false;
                            }
                            return true;
                        }
                        function qTc(a, b, c, d) {
                            if (b.a < d.a) return true;
                            else if (b.a == d.a) {
                                if (b.b < d.b) return true;
                                else if (b.b == d.b) {
                                    if (a.b > c.b) return true;
                                }
                            }
                            return false;
                        }
                        function QD(a, b) {
                            if (bE(a)) return !!PD[b];
                            else if (a.Sm) return !!a.Sm[b];
                            else if (_D(a)) return !!OD[b];
                            else if ($D(a)) return !!ND[b];
                            return false;
                        }
                        function udc(a) {
                            var b;
                            b = a.a;
                            do {
                                b = RD(hs(new is(Mr(Z2b(b).a.Kc(), new ir))), 18).c.i;
                                b.k == (r3b(), o3b) && a.b.Fc(b);
                            }while (b.k == (r3b(), o3b));
                            a.b = hv(a.b);
                        }
                        function UGc(a, b) {
                            var c, d, e;
                            e = a;
                            for(d = new is(Mr(Z2b(b).a.Kc(), new ir)); gs(d);){
                                c = RD(hs(d), 18);
                                !!c.c.i.c && (e = $wnd.Math.max(e, c.c.i.c.p));
                            }
                            return e;
                        }
                        function INb(a, b) {
                            var c, d, e;
                            e = 0;
                            d = RD(RD(Qc(a.r, b), 21), 87).Kc();
                            while(d.Ob()){
                                c = RD(d.Pb(), 117);
                                e += c.d.d + c.b.Mf().b + c.d.a;
                                d.Ob() && (e += a.w);
                            }
                            return e;
                        }
                        function AMb(a, b) {
                            var c, d, e;
                            e = 0;
                            d = RD(RD(Qc(a.r, b), 21), 87).Kc();
                            while(d.Ob()){
                                c = RD(d.Pb(), 117);
                                e += c.d.b + c.b.Mf().a + c.d.c;
                                d.Ob() && (e += a.w);
                            }
                            return e;
                        }
                        function O2c(a) {
                            var b, c, d, e;
                            d = 0;
                            e = Q2c(a);
                            if (e.c.length == 0) return 1;
                            else for(c = new Anb(e); c.a < c.c.c.length;){
                                b = RD(ynb(c), 27);
                                d += O2c(b);
                            }
                            return d;
                        }
                        function aIc(a) {
                            var b, c, d;
                            d = a.c.a;
                            a.p = (Qb(d), new dnb(d));
                            for(c = new Anb(d); c.a < c.c.c.length;){
                                b = RD(ynb(c), 10);
                                b.p = eIc(b).a;
                            }
                            yob();
                            _mb(a.p, new nIc);
                        }
                        function UJd(a, b, c) {
                            var d, e, f, g;
                            d = a.dd(b);
                            if (d != -1) {
                                if (a.Pj()) {
                                    f = a.Qj();
                                    g = cJd(a, d);
                                    e = a.Ij(4, g, null, d, f);
                                    !c ? c = e : c.nj(e);
                                } else cJd(a, d);
                            }
                            return c;
                        }
                        function rLd(a, b, c) {
                            var d, e, f, g;
                            d = a.dd(b);
                            if (d != -1) {
                                if (a.Pj()) {
                                    f = a.Qj();
                                    g = THd(a, d);
                                    e = a.Ij(4, g, null, d, f);
                                    !c ? c = e : c.nj(e);
                                } else THd(a, d);
                            }
                            return c;
                        }
                        function Tje(a, b, c, d) {
                            var e, f, g;
                            if (c.Xh(b)) {
                                nke();
                                if (wWd(b)) {
                                    e = RD(c.Mh(b), 160);
                                    Wje(a, e);
                                } else {
                                    f = (g = b, !g ? null : RD(d, 54).gi(g));
                                    !!f && Uje(c.Mh(b), f);
                                }
                            }
                        }
                        function Dvd(a, b, c, d) {
                            var e, f, g;
                            f = vYd(a.Dh(), b);
                            e = b - a.ji();
                            return e < 0 ? (g = a.Ih(f), g >= 0 ? a.Lh(g, c, true) : Qvd(a, f, c)) : RD(f, 69).wk().yk(a, a.hi(), e, c, d);
                        }
                        function aNb(a, b, c, d) {
                            var e, f;
                            f = b.pf((umd(), ild)) ? RD(b.of(ild), 21) : a.j;
                            e = lMb(f);
                            if (e == (hMb(), gMb)) return;
                            if (c && !jMb(e)) return;
                            LKb(cNb(a, e, d), b);
                        }
                        function Y6b(a) {
                            switch(a.g){
                                case 1:
                                    return mOb(), lOb;
                                case 3:
                                    return mOb(), iOb;
                                case 2:
                                    return mOb(), kOb;
                                case 4:
                                    return mOb(), jOb;
                                default:
                                    return null;
                            }
                        }
                        function kmc(a, b, c) {
                            if (a.e) switch(a.b){
                                case 1:
                                    Ulc(a.c, b, c);
                                    break;
                                case 0:
                                    Vlc(a.c, b, c);
                            }
                            else Slc(a.c, b, c);
                            a.a[b.p][c.p] = a.c.i;
                            a.a[c.p][b.p] = a.c.e;
                        }
                        function LLc(a) {
                            var b, c;
                            if (a == null) return null;
                            c = $C(jR, Nve, 199, a.length, 0, 2);
                            for(b = 0; b < c.length; b++)c[b] = RD(Gnb(a[b], a[b].length), 199);
                            return c;
                        }
                        function Dhe(a) {
                            var b;
                            if (Bhe(a)) {
                                Ahe(a);
                                if (a.ul()) {
                                    b = Bge(a.e, a.b, a.c, a.a, a.j);
                                    a.j = b;
                                }
                                a.g = a.a;
                                ++a.a;
                                ++a.c;
                                a.i = 0;
                                return a.j;
                            } else throw Adb(new Dvb);
                        }
                        function YOb(a, b) {
                            var c, d, e, f;
                            f = a.o;
                            c = a.p;
                            f < c ? f *= f : c *= c;
                            d = f + c;
                            f = b.o;
                            c = b.p;
                            f < c ? f *= f : c *= c;
                            e = f + c;
                            if (d < e) return -1;
                            if (d == e) return 0;
                            return 1;
                        }
                        function fZd(a, b) {
                            var c, d, e;
                            e = RHd(a, b);
                            if (e >= 0) return e;
                            if (a.ol()) for(d = 0; d < a.i; ++d){
                                c = a.pl(RD(a.g[d], 58));
                                if (dE(c) === dE(b)) return d;
                            }
                            return -1;
                        }
                        function eHd(a, b, c) {
                            var d, e;
                            e = a.gc();
                            if (b >= e) throw Adb(new aMd(b, e));
                            if (a.Si()) {
                                d = a.dd(c);
                                if (d >= 0 && d != b) throw Adb(new agb(LIe));
                            }
                            return a.Xi(b, c);
                        }
                        function wx(a, b) {
                            this.a = RD(Qb(a), 253);
                            this.b = RD(Qb(b), 253);
                            if (a.Ed(b) > 0 || a == (Wk(), Vk) || b == (kl(), jl)) throw Adb(new agb('Invalid range: ' + Dx(a, b)));
                        }
                        function p_b(a) {
                            var b, c;
                            this.b = new bnb;
                            this.c = a;
                            this.a = false;
                            for(c = new Anb(a.a); c.a < c.c.c.length;){
                                b = RD(ynb(c), 10);
                                this.a = this.a | b.k == (r3b(), p3b);
                            }
                        }
                        function xIb(a, b) {
                            var c, d, e;
                            c = eJb(new gJb, a);
                            for(e = new Anb(b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 125);
                                rIb(uIb(tIb(vIb(sIb(new wIb, 0), 0), c), d));
                            }
                            return c;
                        }
                        function y0b(a, b, c) {
                            c.Ug('Compound graph preprocessor', 1);
                            a.a = new Tp;
                            D0b(a, b, null);
                            x0b(a, b);
                            C0b(a);
                            pQb(b, (Ywc(), _vc), a.a);
                            a.a = null;
                            akb(a.b);
                            c.Vg();
                        }
                        function aec(a, b, c) {
                            var d, e, f;
                            for(e = new is(Mr((b ? Z2b(a) : a3b(a)).a.Kc(), new ir)); gs(e);){
                                d = RD(hs(e), 18);
                                f = b ? d.c.i : d.d.i;
                                f.k == (r3b(), n3b) && g3b(f, c);
                            }
                        }
                        function FZc(a, b) {
                            var c, d, e;
                            b.Ug('Untreeify', 1);
                            c = RD(mQb(a, (q$c(), k$c)), 15);
                            for(e = c.Kc(); e.Ob();){
                                d = RD(e.Pb(), 65);
                                Mub(d.b.d, d);
                                Mub(d.c.b, d);
                            }
                            b.Vg();
                        }
                        function Znc(a) {
                            var b, c, d;
                            for(d = RD(Qc(a.a, (Bnc(), znc)), 15).Kc(); d.Ob();){
                                c = RD(d.Pb(), 105);
                                b = foc(c);
                                Qnc(a, c, b[0], (joc(), goc), 0);
                                Qnc(a, c, b[1], ioc, 1);
                            }
                        }
                        function $nc(a) {
                            var b, c, d;
                            for(d = RD(Qc(a.a, (Bnc(), Anc)), 15).Kc(); d.Ob();){
                                c = RD(d.Pb(), 105);
                                b = foc(c);
                                Qnc(a, c, b[0], (joc(), goc), 0);
                                Qnc(a, c, b[1], ioc, 1);
                            }
                        }
                        function wDc() {
                            wDc = geb;
                            uDc = new yDc(LAe, 0);
                            vDc = new yDc('PORT_POSITION', 1);
                            tDc = new yDc('NODE_SIZE_WHERE_SPACE_PERMITS', 2);
                            sDc = new yDc('NODE_SIZE', 3);
                        }
                        function z6c() {
                            z6c = geb;
                            w6c = new A6c('INTERACTIVE_NODE_REORDERER', 0);
                            y6c = new A6c('MIN_SIZE_PRE_PROCESSOR', 1);
                            x6c = new A6c('MIN_SIZE_POST_PROCESSOR', 2);
                        }
                        function Rjd() {
                            Rjd = geb;
                            Ljd = new Sjd('AUTOMATIC', 0);
                            Ojd = new Sjd(Nye, 1);
                            Pjd = new Sjd(Oye, 2);
                            Qjd = new Sjd('TOP', 3);
                            Mjd = new Sjd(Qye, 4);
                            Njd = new Sjd(Kye, 5);
                        }
                        function Pjb(a, b, c, d) {
                            Ljb();
                            var e, f;
                            e = 0;
                            for(f = 0; f < c; f++){
                                e = Bdb(Ndb(Cdb(b[f], yxe), Cdb(d, yxe)), Cdb(Ydb(e), yxe));
                                a[f] = Ydb(e);
                                e = Udb(e, 32);
                            }
                            return Ydb(e);
                        }
                        function qKb(a, b, c) {
                            var d, e;
                            e = 0;
                            for(d = 0; d < iKb; d++)e = $wnd.Math.max(e, gKb(a.a[b.g][d], c));
                            b == (ZJb(), XJb) && !!a.b && (e = $wnd.Math.max(e, a.b.b));
                            return e;
                        }
                        function Jwb(a, b) {
                            var c, d;
                            lFb(b > 0);
                            if ((b & -b) == b) return eE(b * Kwb(a, 31) * 4.6566128730773926E-10);
                            do {
                                c = Kwb(a, 31);
                                d = c % b;
                            }while (c - d + (b - 1) < 0);
                            return eE(d);
                        }
                        function d2b(a, b, c) {
                            switch(c.g){
                                case 1:
                                    a.a = b.a / 2;
                                    a.b = 0;
                                    break;
                                case 2:
                                    a.a = b.a;
                                    a.b = b.b / 2;
                                    break;
                                case 3:
                                    a.a = b.a / 2;
                                    a.b = b.b;
                                    break;
                                case 4:
                                    a.a = 0;
                                    a.b = b.b / 2;
                            }
                        }
                        function Onc(a, b, c, d) {
                            var e, f;
                            for(e = b; e < a.c.length; e++){
                                f = (tFb(e, a.c.length), RD(a.c[e], 12));
                                if (c.Mb(f)) ZEb(d.c, f);
                                else return e;
                            }
                            return a.c.length;
                        }
                        function u5c(a) {
                            switch(a.g){
                                case 0:
                                    return null;
                                case 1:
                                    return new _5c;
                                case 2:
                                    return new R5c;
                                default:
                                    throw Adb(new agb(mFe + (a.f != null ? a.f : '' + a.g)));
                            }
                        }
                        function U9c(a, b, c) {
                            var d, e;
                            L9c(a, b - a.s, c - a.t);
                            for(e = new Anb(a.n); e.a < e.c.c.length;){
                                d = RD(ynb(e), 209);
                                Y9c(d, d.e + b - a.s);
                                Z9c(d, d.f + c - a.t);
                            }
                            a.s = b;
                            a.t = c;
                        }
                        function AIb(a) {
                            var b, c, d, e, f;
                            c = 0;
                            for(e = new Anb(a.a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 125);
                                d.d = c++;
                            }
                            b = zIb(a);
                            f = null;
                            b.c.length > 1 && (f = xIb(a, b));
                            return f;
                        }
                        function yqd(a) {
                            var b;
                            b = Kfb(UD(Gxd(a, (umd(), lmd)))) * $wnd.Math.sqrt((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a).i);
                            return new rjd(b, b / Kfb(UD(Gxd(a, kmd))));
                        }
                        function Dzd(a) {
                            var b;
                            if (!!a.f && a.f.Vh()) {
                                b = RD(a.f, 54);
                                a.f = RD(Vvd(a, b), 84);
                                a.f != b && (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 9, 8, b, a.f));
                            }
                            return a.f;
                        }
                        function Ezd(a) {
                            var b;
                            if (!!a.i && a.i.Vh()) {
                                b = RD(a.i, 54);
                                a.i = RD(Vvd(a, b), 84);
                                a.i != b && (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 9, 7, b, a.i));
                            }
                            return a.i;
                        }
                        function Z5d(a) {
                            var b;
                            if (!!a.b && (a.b.Db & 64) != 0) {
                                b = a.b;
                                a.b = RD(Vvd(a, b), 19);
                                a.b != b && (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 9, 21, b, a.b));
                            }
                            return a.b;
                        }
                        function UNd(a, b) {
                            var c, d, e;
                            if (a.d == null) {
                                ++a.e;
                                ++a.f;
                            } else {
                                d = b.Bi();
                                _Nd(a, a.f + 1);
                                e = (d & lve) % a.d.length;
                                c = a.d[e];
                                !c && (c = a.d[e] = a.dk());
                                c.Fc(b);
                                ++a.f;
                            }
                        }
                        function Mge(a, b, c) {
                            var d;
                            if (b.tk()) return false;
                            else if (b.Ik() != -2) {
                                d = b.ik();
                                return d == null ? c == null : pb(d, c);
                            } else return b.qk() == a.e.Dh() && c == null;
                        }
                        function Io() {
                            var a;
                            dk(16, fwe);
                            a = Wp(16);
                            this.b = $C(XF, ewe, 303, a, 0, 1);
                            this.c = $C(XF, ewe, 303, a, 0, 1);
                            this.a = null;
                            this.e = null;
                            this.i = 0;
                            this.f = a - 1;
                            this.g = 0;
                        }
                        function j3b(a) {
                            v2b.call(this);
                            this.k = (r3b(), p3b);
                            this.j = (dk(6, iwe), new cnb(6));
                            this.b = (dk(2, iwe), new cnb(2));
                            this.d = new T2b;
                            this.f = new C3b;
                            this.a = a;
                        }
                        function wgc(a) {
                            var b, c;
                            if (a.c.length <= 1) return;
                            b = tgc(a, (qpd(), npd));
                            vgc(a, RD(b.a, 17).a, RD(b.b, 17).a);
                            c = tgc(a, ppd);
                            vgc(a, RD(c.a, 17).a, RD(c.b, 17).a);
                        }
                        function vHc(a, b, c) {
                            var d, e;
                            e = a.a.b;
                            for(d = e.c.length; d < c; d++)Qmb(e, e.c.length, new R4b(a.a));
                            g3b(b, (tFb(c - 1, e.c.length), RD(e.c[c - 1], 30)));
                            a.b[b.p] = c;
                        }
                        function K_c(a, b) {
                            var c, d, e;
                            a.b[b.g] = 1;
                            for(d = Sub(b.d, 0); d.b != d.d.c;){
                                c = RD(evb(d), 65);
                                e = c.c;
                                a.b[e.g] == 1 ? Mub(a.a, c) : a.b[e.g] == 2 ? a.b[e.g] = 1 : K_c(a, e);
                            }
                        }
                        function u3c(a, b, c, d) {
                            var e, f, g;
                            e = d ? RD(Qc(a.a, b), 21) : RD(Qc(a.b, b), 21);
                            for(g = e.Kc(); g.Ob();){
                                f = RD(g.Pb(), 27);
                                if (o3c(a, c, f)) return true;
                            }
                            return false;
                        }
                        function d$d(a) {
                            var b, c;
                            for(c = new dMd(a); c.e != c.i.gc();){
                                b = RD(bMd(c), 89);
                                if (!!b.e || (!b.d && (b.d = new XZd(o7, b, 1)), b.d).i != 0) return true;
                            }
                            return false;
                        }
                        function o5d(a) {
                            var b, c;
                            for(c = new dMd(a); c.e != c.i.gc();){
                                b = RD(bMd(c), 89);
                                if (!!b.e || (!b.d && (b.d = new XZd(o7, b, 1)), b.d).i != 0) return true;
                            }
                            return false;
                        }
                        function dIc(a) {
                            var b, c, d;
                            b = 0;
                            for(d = new Anb(a.c.a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 10);
                                b += Kr(new is(Mr(a3b(c).a.Kc(), new ir)));
                            }
                            return b / a.c.a.c.length;
                        }
                        function Tcd() {
                            Tcd = geb;
                            Scd = (Kcd(), Jcd);
                            Qcd = new A3b(8);
                            new mGd((umd(), tld), Qcd);
                            new mGd(fmd, 8);
                            Rcd = Hcd;
                            Ocd = xcd;
                            Pcd = ycd;
                            Ncd = new mGd(Mkd, (Geb(), false));
                        }
                        function $dd(a, b, c) {
                            var d;
                            c.Ug('Shrinking tree compaction', 1);
                            if (Heb(TD(mQb(b, (OQb(), MQb))))) {
                                Ydd(a, b.f);
                                zQb(b.f, (d = b.c, d));
                            } else zQb(b.f, b.c);
                            c.Vg();
                        }
                        function Uyd(a, b, c, d) {
                            switch(b){
                                case 7:
                                    return !a.e && (a.e = new Yie(G4, a, 7, 4)), a.e;
                                case 8:
                                    return !a.d && (a.d = new Yie(G4, a, 8, 5)), a.d;
                            }
                            return vyd(a, b, c, d);
                        }
                        function h2d(a) {
                            var b;
                            if (!!a.a && a.a.Vh()) {
                                b = RD(a.a, 54);
                                a.a = RD(Vvd(a, b), 142);
                                a.a != b && (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 9, 5, b, a.a));
                            }
                            return a.a;
                        }
                        function Xqe(a) {
                            if (a < 48) return -1;
                            if (a > 102) return -1;
                            if (a <= 57) return a - 48;
                            if (a < 65) return -1;
                            if (a <= 70) return a - 65 + 10;
                            if (a < 97) return -1;
                            return a - 97 + 10;
                        }
                        function ck(a, b) {
                            if (a == null) throw Adb(new Ogb('null key in entry: null=' + b));
                            else if (b == null) throw Adb(new Ogb('null value in entry: ' + a + '=null'));
                        }
                        function Cr(a, b) {
                            var c, d;
                            while(a.Ob()){
                                if (!b.Ob()) return false;
                                c = a.Pb();
                                d = b.Pb();
                                if (!(dE(c) === dE(d) || c != null && pb(c, d))) return false;
                            }
                            return !b.Ob();
                        }
                        function aLb(a, b) {
                            var c;
                            c = cD(WC(iE, 1), vxe, 28, 15, [
                                gKb(a.a[0], b),
                                gKb(a.a[1], b),
                                gKb(a.a[2], b)
                            ]);
                            if (a.d) {
                                c[0] = $wnd.Math.max(c[0], c[2]);
                                c[2] = c[0];
                            }
                            return c;
                        }
                        function bLb(a, b) {
                            var c;
                            c = cD(WC(iE, 1), vxe, 28, 15, [
                                hKb(a.a[0], b),
                                hKb(a.a[1], b),
                                hKb(a.a[2], b)
                            ]);
                            if (a.d) {
                                c[0] = $wnd.Math.max(c[0], c[2]);
                                c[2] = c[0];
                            }
                            return c;
                        }
                        function vIc(a, b, c) {
                            if (!Cod(RD(mQb(b, (yCc(), BBc)), 101))) {
                                uIc(a, b, e3b(b, c));
                                uIc(a, b, e3b(b, (qpd(), npd)));
                                uIc(a, b, e3b(b, Yod));
                                yob();
                                _mb(b.j, new JIc(a));
                            }
                        }
                        function sUc(a) {
                            var b, c;
                            a.c || vUc(a);
                            c = new Ejd;
                            b = new Anb(a.a);
                            ynb(b);
                            while(b.a < b.c.c.length)Mub(c, RD(ynb(b), 418).a);
                            sFb(c.b != 0);
                            Wub(c, c.c.b);
                            return c;
                        }
                        function O9c(a, b, c) {
                            var d, e, f, g, h;
                            h = a.r + b;
                            a.r += b;
                            a.d += c;
                            d = c / a.n.c.length;
                            e = 0;
                            for(g = new Anb(a.n); g.a < g.c.c.length;){
                                f = RD(ynb(g), 209);
                                X9c(f, h, d, e);
                                ++e;
                            }
                        }
                        function kHb(a) {
                            var b, c, d;
                            a.b.a.$b();
                            a.a = $C(hN, rve, 60, a.c.c.a.b.c.length, 0, 1);
                            b = 0;
                            for(d = new Anb(a.c.c.a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 60);
                                c.f = b++;
                            }
                        }
                        function TYb(a) {
                            var b, c, d;
                            a.b.a.$b();
                            a.a = $C(bQ, rve, 86, a.c.a.a.b.c.length, 0, 1);
                            b = 0;
                            for(d = new Anb(a.c.a.a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 86);
                                c.i = b++;
                            }
                        }
                        function Er(a) {
                            var b;
                            b = yr(a);
                            if (!gs(a)) throw Adb(new veb('position (0) must be less than the number of elements that remained (' + b + ')'));
                            return hs(a);
                        }
                        function ZCb(a, b) {
                            var c;
                            if (!a.a) {
                                c = $C(iE, vxe, 28, 0, 15, 1);
                                ixb(a.b.a, new bDb(c));
                                bFb(c, heb(iob.prototype.Me, iob, []));
                                a.a = new Lxb(c, a.d);
                            }
                            return zxb(a.a, b);
                        }
                        function $Pb(b, c, d) {
                            var e;
                            try {
                                return PPb(b, c + b.j, d + b.k);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) {
                                    e = a;
                                    throw Adb(new veb(e.g + ize + c + pve + d + ').'));
                                } else throw Adb(a);
                            }
                        }
                        function _Pb(b, c, d) {
                            var e;
                            try {
                                return QPb(b, c + b.j, d + b.k);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) {
                                    e = a;
                                    throw Adb(new veb(e.g + ize + c + pve + d + ').'));
                                } else throw Adb(a);
                            }
                        }
                        function aQb(b, c, d) {
                            var e;
                            try {
                                return RPb(b, c + b.j, d + b.k);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) {
                                    e = a;
                                    throw Adb(new veb(e.g + ize + c + pve + d + ').'));
                                } else throw Adb(a);
                            }
                        }
                        function J8b(a) {
                            switch(a.g){
                                case 1:
                                    return qpd(), ppd;
                                case 4:
                                    return qpd(), Yod;
                                case 3:
                                    return qpd(), Xod;
                                case 2:
                                    return qpd(), npd;
                                default:
                                    return qpd(), opd;
                            }
                        }
                        function Imc(a, b, c) {
                            if (b.k == (r3b(), p3b) && c.k == o3b) {
                                a.d = Fmc(b, (qpd(), npd));
                                a.b = Fmc(b, Yod);
                            }
                            if (c.k == p3b && b.k == o3b) {
                                a.d = Fmc(c, (qpd(), Yod));
                                a.b = Fmc(c, npd);
                            }
                        }
                        function Mmc(a, b) {
                            var c, d, e;
                            e = b3b(a, b);
                            for(d = e.Kc(); d.Ob();){
                                c = RD(d.Pb(), 12);
                                if (mQb(c, (Ywc(), Iwc)) != null || k4b(new l4b(c.b))) return true;
                            }
                            return false;
                        }
                        function RNc(a, b, c) {
                            c.Ug('Linear segments node placement', 1);
                            a.b = RD(mQb(b, (Ywc(), Qwc)), 312);
                            SNc(a, b);
                            NNc(a, b);
                            KNc(a, b);
                            QNc(a);
                            a.a = null;
                            a.b = null;
                            c.Vg();
                        }
                        function W9c(a, b) {
                            Dyd(b, a.e + a.d + (a.c.c.length == 0 ? 0 : a.b));
                            Eyd(b, a.f);
                            a.a = $wnd.Math.max(a.a, b.f);
                            a.d += b.g + (a.c.c.length == 0 ? 0 : a.b);
                            Rmb(a.c, b);
                            return true;
                        }
                        function bad(a, b, c) {
                            var d, e, f, g;
                            g = 0;
                            d = c / a.a.c.length;
                            for(f = new Anb(a.a); f.a < f.c.c.length;){
                                e = RD(ynb(f), 172);
                                U9c(e, e.s, e.t + g * d);
                                O9c(e, a.d - e.r + b, d);
                                ++g;
                            }
                        }
                        function Cid(a, b) {
                            var c, d, e, f, g, h;
                            e = b.length - 1;
                            g = 0;
                            h = 0;
                            for(d = 0; d <= e; d++){
                                f = b[d];
                                c = vid(e, d) * Iid(1 - a, e - d) * Iid(a, d);
                                g += f.a * c;
                                h += f.b * c;
                            }
                            return new rjd(g, h);
                        }
                        function JHd(a, b) {
                            var c, d, e, f, g;
                            c = b.gc();
                            a._i(a.i + c);
                            f = b.Kc();
                            g = a.i;
                            a.i += c;
                            for(d = g; d < a.i; ++d){
                                e = f.Pb();
                                MHd(a, d, a.Zi(d, e));
                                a.Mi(d, e);
                                a.Ni();
                            }
                            return c != 0;
                        }
                        function TJd(a, b, c) {
                            var d, e, f;
                            if (a.Pj()) {
                                d = a.Ej();
                                f = a.Qj();
                                ++a.j;
                                a.qj(d, a.Zi(d, b));
                                e = a.Ij(3, null, b, d, f);
                                !c ? c = e : c.nj(e);
                            } else $Id(a, a.Ej(), b);
                            return c;
                        }
                        function u0d(a, b, c) {
                            var d, e, f;
                            d = RD(QHd(tYd(a.a), b), 89);
                            f = (e = d.c, ZD(e, 90) ? RD(e, 29) : (JTd(), zTd));
                            ((f.Db & 64) != 0 ? Vvd(a.b, f) : f) == c ? i2d(d) : l2d(d, c);
                            return f;
                        }
                        function pne(a) {
                            var b;
                            return a == null ? null : new ejb((b = nue(a, true), b.length > 0 && (BFb(0, b.length), b.charCodeAt(0) == 43) ? (BFb(1, b.length + 1), b.substr(1)) : b));
                        }
                        function qne(a) {
                            var b;
                            return a == null ? null : new ejb((b = nue(a, true), b.length > 0 && (BFb(0, b.length), b.charCodeAt(0) == 43) ? (BFb(1, b.length + 1), b.substr(1)) : b));
                        }
                        function Syb(a, b, c, d, e, f, g, h) {
                            var i, j;
                            if (!d) return;
                            i = d.a[0];
                            !!i && Syb(a, b, c, i, e, f, g, h);
                            Tyb(a, c, d.d, e, f, g, h) && b.Fc(d);
                            j = d.a[1];
                            !!j && Syb(a, b, c, j, e, f, g, h);
                        }
                        function PPb(b, c, d) {
                            try {
                                return Gdb(SPb(b, c, d), 1);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 333)) throw Adb(new veb(fze + b.o + '*' + b.p + gze + c + pve + d + hze));
                                else throw Adb(a);
                            }
                        }
                        function QPb(b, c, d) {
                            try {
                                return Gdb(SPb(b, c, d), 0);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 333)) throw Adb(new veb(fze + b.o + '*' + b.p + gze + c + pve + d + hze));
                                else throw Adb(a);
                            }
                        }
                        function RPb(b, c, d) {
                            try {
                                return Gdb(SPb(b, c, d), 2);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 333)) throw Adb(new veb(fze + b.o + '*' + b.p + gze + c + pve + d + hze));
                                else throw Adb(a);
                            }
                        }
                        function lMd(b, c) {
                            if (b.g == -1) throw Adb(new cgb);
                            b.Xj();
                            try {
                                b.d.hd(b.g, c);
                                b.f = b.d.j;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) throw Adb(new Jrb);
                                else throw Adb(a);
                            }
                        }
                        function Y7b(a) {
                            var b, c, d, e, f;
                            for(d = new Anb(a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 30);
                                b = 0;
                                for(f = new Anb(c.a); f.a < f.c.c.length;){
                                    e = RD(ynb(f), 10);
                                    e.p = b++;
                                }
                            }
                        }
                        function Ee(a, b) {
                            var c, d, e, f;
                            f = a.gc();
                            b.length < f && (b = cFb(new Array(f), b));
                            e = b;
                            d = a.Kc();
                            for(c = 0; c < f; ++c)bD(e, c, d.Pb());
                            b.length > f && bD(b, f, null);
                            return b;
                        }
                        function av(a, b) {
                            var c, d;
                            d = a.gc();
                            if (b == null) for(c = 0; c < d; c++){
                                if (a.Xb(c) == null) return c;
                            }
                            else for(c = 0; c < d; c++){
                                if (pb(b, a.Xb(c))) return c;
                            }
                            return -1;
                        }
                        function Jd(a, b) {
                            var c, d, e;
                            c = b.ld();
                            e = b.md();
                            d = a.xc(c);
                            if (!(dE(e) === dE(d) || e != null && pb(e, d))) return false;
                            if (d == null && !a._b(c)) return false;
                            return true;
                        }
                        function mD(a, b) {
                            var c, d, e;
                            if (b <= 22) {
                                c = a.l & (1 << b) - 1;
                                d = e = 0;
                            } else if (b <= 44) {
                                c = a.l;
                                d = a.m & (1 << b - 22) - 1;
                                e = 0;
                            } else {
                                c = a.l;
                                d = a.m;
                                e = a.h & (1 << b - 44) - 1;
                            }
                            return hD(c, d, e);
                        }
                        function pNb(a, b) {
                            switch(b.g){
                                case 1:
                                    return a.f.n.d + a.t;
                                case 3:
                                    return a.f.n.a + a.t;
                                case 2:
                                    return a.f.n.c + a.s;
                                case 4:
                                    return a.f.n.b + a.s;
                                default:
                                    return 0;
                            }
                        }
                        function TNb(a, b) {
                            var c, d;
                            d = b.c;
                            c = b.a;
                            switch(a.b.g){
                                case 0:
                                    c.d = a.e - d.a - d.d;
                                    break;
                                case 1:
                                    c.d += a.e;
                                    break;
                                case 2:
                                    c.c = a.e - d.a - d.d;
                                    break;
                                case 3:
                                    c.c = a.e + d.d;
                            }
                        }
                        function QRb(a, b, c, d) {
                            var e, f;
                            this.a = b;
                            this.c = d;
                            e = a.a;
                            PRb(this, new rjd(-e.c, -e.d));
                            $id(this.b, c);
                            f = d / 2;
                            b.a ? njd(this.b, 0, f) : njd(this.b, f, 0);
                            Rmb(a.c, this);
                        }
                        function i2c(a, b, c, d) {
                            var e;
                            this.c = a;
                            this.d = b;
                            e = new Yub;
                            Pub(e, c, e.c.b, e.c);
                            this.a = e;
                            this.b = RD(mQb(d, (h_c(), H$c)), 88);
                            this.e = Kfb(UD(mQb(d, $$c)));
                            h2c(this);
                        }
                        function j5c() {
                            j5c = geb;
                            i5c = new l5c(LAe, 0);
                            g5c = new l5c(EBe, 1);
                            h5c = new l5c('EDGE_LENGTH_BY_POSITION', 2);
                            f5c = new l5c('CROSSING_MINIMIZATION_BY_POSITION', 3);
                        }
                        function uEd(a, b) {
                            var c, d;
                            c = RD(Ao(a.g, b), 27);
                            if (c) return c;
                            d = RD(Ao(a.j, b), 123);
                            if (d) return d;
                            throw Adb(new CDd('Referenced shape does not exist: ' + b));
                        }
                        function Pk(b, c) {
                            var d, e;
                            if (ZD(c, 253)) {
                                e = RD(c, 253);
                                try {
                                    d = b.Ed(e);
                                    return d == 0;
                                } catch (a) {
                                    a = zdb(a);
                                    if (ZD(a, 212)) return false;
                                    else throw Adb(a);
                                }
                            }
                            return false;
                        }
                        function tWb(a, b) {
                            if (a.c == b) return a.d;
                            else if (a.d == b) return a.c;
                            else throw Adb(new agb("Node 'one' must be either source or target of edge 'edge'."));
                        }
                        function rRc(a, b) {
                            if (a.c.i == b) return a.d.i;
                            else if (a.d.i == b) return a.c.i;
                            else throw Adb(new agb('Node ' + b + ' is neither source nor target of edge ' + a));
                        }
                        function $gc(a, b, c) {
                            c.Ug('Self-Loop ordering', 1);
                            FDb(GDb(CDb(CDb(EDb(new SDb(null, new Swb(b.b, 16)), new chc), new ehc), new ghc), new ihc), new khc(a));
                            c.Vg();
                        }
                        function Fpc(a, b) {
                            var c;
                            switch(b.g){
                                case 2:
                                case 4:
                                    c = a.a;
                                    a.c.d.n.b < c.d.n.b && (c = a.c);
                                    Gpc(a, b, (enc(), dnc), c);
                                    break;
                                case 1:
                                case 3:
                                    Gpc(a, b, (enc(), anc), null);
                            }
                        }
                        function Ypc(a, b, c, d, e, f) {
                            var g, h, i, j, k;
                            g = Wpc(b, c, f);
                            h = c == (qpd(), Yod) || c == ppd ? -1 : 1;
                            j = a[c.g];
                            for(k = 0; k < j.length; k++){
                                i = j[k];
                                i > 0 && (i += e);
                                j[k] = g;
                                g += h * (i + d);
                            }
                        }
                        function vsc(a) {
                            var b, c, d;
                            d = a.f;
                            a.n = $C(iE, vxe, 28, d, 15, 1);
                            a.d = $C(iE, vxe, 28, d, 15, 1);
                            for(b = 0; b < d; b++){
                                c = RD(Vmb(a.c.b, b), 30);
                                a.n[b] = ssc(a, c);
                                a.d[b] = rsc(a, c);
                            }
                        }
                        function Xwd(a, b) {
                            var c, d, e;
                            e = 0;
                            for(d = 2; d < b; d <<= 1)(a.Db & d) != 0 && ++e;
                            if (e == 0) {
                                for(c = b <<= 1; c <= 128; c <<= 1){
                                    if ((a.Db & c) != 0) return 0;
                                }
                                return -1;
                            } else return e;
                        }
                        function Sge(a, b) {
                            var c, d, e, f, g;
                            g = pke(a.e.Dh(), b);
                            f = null;
                            c = RD(a.g, 124);
                            for(e = 0; e < a.i; ++e){
                                d = c[e];
                                if (g.am(d.Lk())) {
                                    !f && (f = new YHd);
                                    WGd(f, d);
                                }
                            }
                            !!f && wLd(a, f);
                        }
                        function ene(a) {
                            var b, c, d;
                            if (!a) return null;
                            if (a.dc()) return '';
                            d = new Qhb;
                            for(c = a.Kc(); c.Ob();){
                                b = c.Pb();
                                Nhb(d, WD(b));
                                d.a += ' ';
                            }
                            return qeb(d, d.a.length - 1);
                        }
                        function _C(a, b) {
                            var c = new Array(b);
                            var d;
                            switch(a){
                                case 14:
                                case 15:
                                    d = 0;
                                    break;
                                case 16:
                                    d = false;
                                    break;
                                default:
                                    return c;
                            }
                            for(var e = 0; e < b; ++e)c[e] = d;
                            return c;
                        }
                        function GGb(a) {
                            var b, c, d;
                            for(c = new Anb(a.a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 60);
                                b.c.$b();
                            }
                            Dmd(a.d) ? d = a.a.c : d = a.a.d;
                            Umb(d, new WGb(a));
                            a.c.df(a);
                            HGb(a);
                        }
                        function oUb(a) {
                            var b, c, d, e;
                            for(c = new Anb(a.e.c); c.a < c.c.c.length;){
                                b = RD(ynb(c), 290);
                                for(e = new Anb(b.b); e.a < e.c.c.length;){
                                    d = RD(ynb(e), 454);
                                    hUb(d);
                                }
                                YTb(b);
                            }
                        }
                        function gad(a) {
                            var b, c, d, e, f;
                            d = 0;
                            f = 0;
                            e = 0;
                            for(c = new Anb(a.a); c.a < c.c.c.length;){
                                b = RD(ynb(c), 172);
                                f = $wnd.Math.max(f, b.r);
                                d += b.d + (e > 0 ? a.c : 0);
                                ++e;
                            }
                            a.b = d;
                            a.d = f;
                        }
                        function rKb(a, b) {
                            var c;
                            c = cD(WC(iE, 1), vxe, 28, 15, [
                                qKb(a, (ZJb(), WJb), b),
                                qKb(a, XJb, b),
                                qKb(a, YJb, b)
                            ]);
                            if (a.f) {
                                c[0] = $wnd.Math.max(c[0], c[2]);
                                c[2] = c[0];
                            }
                            return c;
                        }
                        function cQb(b, c, d) {
                            var e;
                            try {
                                TPb(b, c + b.j, d + b.k, false, true);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) {
                                    e = a;
                                    throw Adb(new veb(e.g + ize + c + pve + d + ').'));
                                } else throw Adb(a);
                            }
                        }
                        function dQb(b, c, d) {
                            var e;
                            try {
                                TPb(b, c + b.j, d + b.k, true, false);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) {
                                    e = a;
                                    throw Adb(new veb(e.g + ize + c + pve + d + ').'));
                                } else throw Adb(a);
                            }
                        }
                        function u8b(a) {
                            var b;
                            if (!nQb(a, (yCc(), dBc))) return;
                            b = RD(mQb(a, dBc), 21);
                            if (b.Hc((dod(), Xnd))) {
                                b.Mc(Xnd);
                                b.Fc(Znd);
                            } else if (b.Hc(Znd)) {
                                b.Mc(Znd);
                                b.Fc(Xnd);
                            }
                        }
                        function v8b(a) {
                            var b;
                            if (!nQb(a, (yCc(), dBc))) return;
                            b = RD(mQb(a, dBc), 21);
                            if (b.Hc((dod(), cod))) {
                                b.Mc(cod);
                                b.Fc(aod);
                            } else if (b.Hc(aod)) {
                                b.Mc(aod);
                                b.Fc(cod);
                            }
                        }
                        function oqc(a, b, c, d) {
                            var e, f, g, h;
                            a.a == null && rqc(a, b);
                            g = b.b.j.c.length;
                            f = c.d.p;
                            h = d.d.p;
                            e = h - 1;
                            e < 0 && (e = g - 1);
                            return f <= e ? a.a[e] - a.a[f] : a.a[g - 1] - a.a[f] + a.a[e];
                        }
                        function Cud(a) {
                            var b, c;
                            if (!a.b) {
                                a.b = fv(RD(a.f, 27).kh().i);
                                for(c = new dMd(RD(a.f, 27).kh()); c.e != c.i.gc();){
                                    b = RD(bMd(c), 135);
                                    Rmb(a.b, new Bud(b));
                                }
                            }
                            return a.b;
                        }
                        function Dud(a) {
                            var b, c;
                            if (!a.e) {
                                a.e = fv(wCd(RD(a.f, 27)).i);
                                for(c = new dMd(wCd(RD(a.f, 27))); c.e != c.i.gc();){
                                    b = RD(bMd(c), 123);
                                    Rmb(a.e, new Rud(b));
                                }
                            }
                            return a.e;
                        }
                        function yud(a) {
                            var b, c;
                            if (!a.a) {
                                a.a = fv(tCd(RD(a.f, 27)).i);
                                for(c = new dMd(tCd(RD(a.f, 27))); c.e != c.i.gc();){
                                    b = RD(bMd(c), 27);
                                    Rmb(a.a, new Fud(a, b));
                                }
                            }
                            return a.a;
                        }
                        function DXd(b) {
                            var c;
                            if (!b.C && (b.D != null || b.B != null)) {
                                c = EXd(b);
                                if (c) b.hl(c);
                                else try {
                                    b.hl(null);
                                } catch (a) {
                                    a = zdb(a);
                                    if (!ZD(a, 63)) throw Adb(a);
                                }
                            }
                            return b.C;
                        }
                        function xMb(a) {
                            switch(a.q.g){
                                case 5:
                                    uMb(a, (qpd(), Yod));
                                    uMb(a, npd);
                                    break;
                                case 4:
                                    vMb(a, (qpd(), Yod));
                                    vMb(a, npd);
                                    break;
                                default:
                                    wMb(a, (qpd(), Yod));
                                    wMb(a, npd);
                            }
                        }
                        function GNb(a) {
                            switch(a.q.g){
                                case 5:
                                    DNb(a, (qpd(), Xod));
                                    DNb(a, ppd);
                                    break;
                                case 4:
                                    ENb(a, (qpd(), Xod));
                                    ENb(a, ppd);
                                    break;
                                default:
                                    FNb(a, (qpd(), Xod));
                                    FNb(a, ppd);
                            }
                        }
                        function G$b(a, b) {
                            var c, d, e;
                            e = new pjd;
                            for(d = a.Kc(); d.Ob();){
                                c = RD(d.Pb(), 36);
                                w$b(c, e.a, 0);
                                e.a += c.f.a + b;
                                e.b = $wnd.Math.max(e.b, c.f.b);
                            }
                            e.b > 0 && (e.b += b);
                            return e;
                        }
                        function I$b(a, b) {
                            var c, d, e;
                            e = new pjd;
                            for(d = a.Kc(); d.Ob();){
                                c = RD(d.Pb(), 36);
                                w$b(c, 0, e.b);
                                e.b += c.f.b + b;
                                e.a = $wnd.Math.max(e.a, c.f.a);
                            }
                            e.a > 0 && (e.a += b);
                            return e;
                        }
                        function l2b(a) {
                            var b, c, d;
                            d = lve;
                            for(c = new Anb(a.a); c.a < c.c.c.length;){
                                b = RD(ynb(c), 10);
                                nQb(b, (Ywc(), zwc)) && (d = $wnd.Math.min(d, RD(mQb(b, zwc), 17).a));
                            }
                            return d;
                        }
                        function PLc(a, b) {
                            var c, d;
                            if (b.length == 0) return 0;
                            c = lMc(a.a, b[0], (qpd(), ppd));
                            c += lMc(a.a, b[b.length - 1], Xod);
                            for(d = 0; d < b.length; d++)c += QLc(a, d, b);
                            return c;
                        }
                        function VUc() {
                            HUc();
                            this.c = new bnb;
                            this.i = new bnb;
                            this.e = new Iub;
                            this.f = new Iub;
                            this.g = new Iub;
                            this.j = new bnb;
                            this.a = new bnb;
                            this.b = new Tsb;
                            this.k = new Tsb;
                        }
                        function AXd(a, b) {
                            var c, d;
                            if (a.Db >> 16 == 6) return a.Cb.Th(a, 5, t7, b);
                            return d = Z5d(RD(vYd((c = RD(Ywd(a, 16), 29), !c ? a.ii() : c), a.Db >> 16), 19)), a.Cb.Th(a, d.n, d.f, b);
                        }
                        function kA(a) {
                            fA();
                            var b = a.e;
                            if (b && b.stack) {
                                var c = b.stack;
                                var d = b + '\n';
                                c.substring(0, d.length) == d && (c = c.substring(d.length));
                                return c.split('\n');
                            }
                            return [];
                        }
                        function pgb(a) {
                            var b;
                            b = (wgb(), vgb);
                            return b[a >>> 28] | b[a >> 24 & 15] << 4 | b[a >> 20 & 15] << 8 | b[a >> 16 & 15] << 12 | b[a >> 12 & 15] << 16 | b[a >> 8 & 15] << 20 | b[a >> 4 & 15] << 24 | b[a & 15] << 28;
                        }
                        function mmb(a) {
                            var b, c, d;
                            if (a.b != a.c) return;
                            d = a.a.length;
                            c = mgb($wnd.Math.max(8, d)) << 1;
                            if (a.b != 0) {
                                b = WEb(a.a, c);
                                lmb(a, b, d);
                                a.a = b;
                                a.b = 0;
                            } else aFb(a.a, c);
                            a.c = d;
                        }
                        function uNb(a, b) {
                            var c;
                            c = a.b;
                            return c.pf((umd(), Gld)) ? c.ag() == (qpd(), ppd) ? -c.Mf().a - Kfb(UD(c.of(Gld))) : b + Kfb(UD(c.of(Gld))) : c.ag() == (qpd(), ppd) ? -c.Mf().a : b;
                        }
                        function X2b(a) {
                            var b;
                            if (a.b.c.length != 0 && !!RD(Vmb(a.b, 0), 72).a) return RD(Vmb(a.b, 0), 72).a;
                            b = R0b(a);
                            if (b != null) return b;
                            return '' + (!a.c ? -1 : Wmb(a.c.a, a, 0));
                        }
                        function M3b(a) {
                            var b;
                            if (a.f.c.length != 0 && !!RD(Vmb(a.f, 0), 72).a) return RD(Vmb(a.f, 0), 72).a;
                            b = R0b(a);
                            if (b != null) return b;
                            return '' + (!a.i ? -1 : Wmb(a.i.j, a, 0));
                        }
                        function skc(a, b) {
                            var c, d;
                            if (b < 0 || b >= a.gc()) return null;
                            for(c = b; c < a.gc(); ++c){
                                d = RD(a.Xb(c), 131);
                                if (c == a.gc() - 1 || !d.o) return new Ptd(sgb(c), d);
                            }
                            return null;
                        }
                        function Xrc(a, b, c) {
                            var d, e, f, g, h;
                            f = a.c;
                            h = c ? b : a;
                            d = c ? a : b;
                            for(e = h.p + 1; e < d.p; ++e){
                                g = RD(Vmb(f.a, e), 10);
                                if (!(g.k == (r3b(), l3b) || Yrc(g))) return false;
                            }
                            return true;
                        }
                        function Ead(a) {
                            var b, c, d, e, f;
                            f = 0;
                            e = pxe;
                            d = 0;
                            for(c = new Anb(a.a); c.a < c.c.c.length;){
                                b = RD(ynb(c), 172);
                                f += b.r + (d > 0 ? a.c : 0);
                                e = $wnd.Math.max(e, b.d);
                                ++d;
                            }
                            a.e = f;
                            a.b = e;
                        }
                        function Qud(a) {
                            var b, c;
                            if (!a.b) {
                                a.b = fv(RD(a.f, 123).kh().i);
                                for(c = new dMd(RD(a.f, 123).kh()); c.e != c.i.gc();){
                                    b = RD(bMd(c), 135);
                                    Rmb(a.b, new Bud(b));
                                }
                            }
                            return a.b;
                        }
                        function aHd(a, b) {
                            var c, d, e;
                            if (b.dc()) return jQd(), jQd(), iQd;
                            else {
                                c = new ZLd(a, b.gc());
                                for(e = new dMd(a); e.e != e.i.gc();){
                                    d = bMd(e);
                                    b.Hc(d) && WGd(c, d);
                                }
                                return c;
                            }
                        }
                        function Axd(a, b, c, d) {
                            if (b == 0) return d ? (!a.o && (a.o = new DVd((pvd(), mvd), X4, a, 0)), a.o) : (!a.o && (a.o = new DVd((pvd(), mvd), X4, a, 0)), dOd(a.o));
                            return Dvd(a, b, c, d);
                        }
                        function rBd(a) {
                            var b, c;
                            if (a.rb) for(b = 0, c = a.rb.i; b < c; ++b)aAd(QHd(a.rb, b));
                            if (a.vb) for(b = 0, c = a.vb.i; b < c; ++b)aAd(QHd(a.vb, b));
                            Uee((lke(), jke), a);
                            a.Bb |= 1;
                        }
                        function zBd(a, b, c, d, e, f, g, h, i, j, k, l, m, n) {
                            ABd(a, b, d, null, e, f, g, h, i, j, m, true, n);
                            a6d(a, k);
                            ZD(a.Cb, 90) && v$d(yYd(RD(a.Cb, 90)), 2);
                            !!c && b6d(a, c);
                            c6d(a, l);
                            return a;
                        }
                        function Jae(b) {
                            var c, d;
                            if (b == null) return null;
                            d = 0;
                            try {
                                d = Oeb(b, qwe, lve) & Bwe;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 130)) {
                                    c = Ahb(b);
                                    d = c[0];
                                } else throw Adb(a);
                            }
                            return hfb(d);
                        }
                        function Kae(b) {
                            var c, d;
                            if (b == null) return null;
                            d = 0;
                            try {
                                d = Oeb(b, qwe, lve) & Bwe;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 130)) {
                                    c = Ahb(b);
                                    d = c[0];
                                } else throw Adb(a);
                            }
                            return hfb(d);
                        }
                        function rD(a, b) {
                            var c, d, e;
                            e = a.h - b.h;
                            if (e < 0) return false;
                            c = a.l - b.l;
                            d = a.m - b.m + (c >> 22);
                            e += d >> 22;
                            if (e < 0) return false;
                            a.l = c & dxe;
                            a.m = d & dxe;
                            a.h = e & exe;
                            return true;
                        }
                        function Tyb(a, b, c, d, e, f, g) {
                            var h, i;
                            if (b.Te() && (i = a.a.Ne(c, d), i < 0 || !e && i == 0)) return false;
                            if (b.Ue() && (h = a.a.Ne(c, f), h > 0 || !g && h == 0)) return false;
                            return true;
                        }
                        function Agc(a, b) {
                            sgc();
                            var c;
                            c = a.j.g - b.j.g;
                            if (c != 0) return 0;
                            switch(a.j.g){
                                case 2:
                                    return Cgc(b, rgc) - Cgc(a, rgc);
                                case 4:
                                    return Cgc(a, qgc) - Cgc(b, qgc);
                            }
                            return 0;
                        }
                        function uuc(a) {
                            switch(a.g){
                                case 0:
                                    return nuc;
                                case 1:
                                    return ouc;
                                case 2:
                                    return puc;
                                case 3:
                                    return quc;
                                case 4:
                                    return ruc;
                                case 5:
                                    return suc;
                                default:
                                    return null;
                            }
                        }
                        function cBd(a, b, c) {
                            var d, e;
                            d = (e = new R5d, YVd(e, b), PAd(e, c), WGd((!a.c && (a.c = new C5d(u7, a, 12, 10)), a.c), e), e);
                            $Vd(d, 0);
                            bWd(d, 1);
                            aWd(d, true);
                            _Vd(d, true);
                            return d;
                        }
                        function THd(a, b) {
                            var c, d;
                            if (b >= a.i) throw Adb(new yNd(b, a.i));
                            ++a.j;
                            c = a.g[b];
                            d = a.i - b - 1;
                            d > 0 && hib(a.g, b + 1, a.g, b, d);
                            bD(a.g, --a.i, null);
                            a.Qi(b, c);
                            a.Ni();
                            return c;
                        }
                        function sWd(a, b) {
                            var c, d;
                            if (a.Db >> 16 == 17) return a.Cb.Th(a, 21, h7, b);
                            return d = Z5d(RD(vYd((c = RD(Ywd(a, 16), 29), !c ? a.ii() : c), a.Db >> 16), 19)), a.Cb.Th(a, d.n, d.f, b);
                        }
                        function _Fb(a) {
                            var b, c, d, e;
                            yob();
                            _mb(a.c, a.a);
                            for(e = new Anb(a.c); e.a < e.c.c.length;){
                                d = ynb(e);
                                for(c = new Anb(a.b); c.a < c.c.c.length;){
                                    b = RD(ynb(c), 693);
                                    b.bf(d);
                                }
                            }
                        }
                        function r$b(a) {
                            var b, c, d, e;
                            yob();
                            _mb(a.c, a.a);
                            for(e = new Anb(a.c); e.a < e.c.c.length;){
                                d = ynb(e);
                                for(c = new Anb(a.b); c.a < c.c.c.length;){
                                    b = RD(ynb(c), 382);
                                    b.bf(d);
                                }
                            }
                        }
                        function rJb(a) {
                            var b, c, d, e, f;
                            e = lve;
                            f = null;
                            for(d = new Anb(a.d); d.a < d.c.c.length;){
                                c = RD(ynb(d), 218);
                                if (c.d.j ^ c.e.j) {
                                    b = c.e.e - c.d.e - c.a;
                                    if (b < e) {
                                        e = b;
                                        f = c;
                                    }
                                }
                            }
                            return f;
                        }
                        function QVb() {
                            QVb = geb;
                            OVb = new lGd(vAe, (Geb(), false));
                            KVb = new lGd(wAe, 100);
                            MVb = (AWb(), yWb);
                            LVb = new lGd(xAe, MVb);
                            NVb = new lGd(yAe, Vze);
                            PVb = new lGd(zAe, sgb(lve));
                        }
                        function Xlc(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            j = 0;
                            for(e = a.a[b], f = 0, g = e.length; f < g; ++f){
                                d = e[f];
                                k = aMc(d, c);
                                for(i = k.Kc(); i.Ob();){
                                    h = RD(i.Pb(), 12);
                                    Zjb(a.f, h, sgb(j++));
                                }
                            }
                        }
                        function UDd(a, b, c) {
                            var d, e, f, g;
                            if (c) {
                                e = c.a.length;
                                d = new vue(e);
                                for(g = (d.b - d.a) * d.c < 0 ? (uue(), tue) : new Rue(d); g.Ob();){
                                    f = RD(g.Pb(), 17);
                                    Rc(a, b, tDd(JB(c, f.a)));
                                }
                            }
                        }
                        function VDd(a, b, c) {
                            var d, e, f, g;
                            if (c) {
                                e = c.a.length;
                                d = new vue(e);
                                for(g = (d.b - d.a) * d.c < 0 ? (uue(), tue) : new Rue(d); g.Ob();){
                                    f = RD(g.Pb(), 17);
                                    Rc(a, b, tDd(JB(c, f.a)));
                                }
                            }
                        }
                        function foc(a) {
                            Mnc();
                            var b;
                            b = RD(Ee(Ec(a.k), $C(E3, NAe, 64, 2, 0, 1)), 126);
                            Wnb(b, 0, b.length, null);
                            if (b[0] == (qpd(), Yod) && b[1] == ppd) {
                                bD(b, 0, ppd);
                                bD(b, 1, Yod);
                            }
                            return b;
                        }
                        function hMc(a, b, c) {
                            var d, e, f;
                            e = fMc(a, b, c);
                            f = iMc(a, e);
                            YLc(a.b);
                            CMc(a, b, c);
                            yob();
                            _mb(e, new HMc(a));
                            d = iMc(a, e);
                            YLc(a.b);
                            CMc(a, c, b);
                            return new Ptd(sgb(f), sgb(d));
                        }
                        function JNc() {
                            JNc = geb;
                            GNc = pfd(new ufd, (sXb(), rXb), (hcc(), ybc));
                            HNc = new kGd('linearSegments.inputPrio', sgb(0));
                            INc = new kGd('linearSegments.outputPrio', sgb(0));
                        }
                        function YVc() {
                            YVc = geb;
                            UVc = new $Vc('P1_TREEIFICATION', 0);
                            VVc = new $Vc('P2_NODE_ORDERING', 1);
                            WVc = new $Vc('P3_NODE_PLACEMENT', 2);
                            XVc = new $Vc('P4_EDGE_ROUTING', 3);
                        }
                        function yad(a) {
                            var b, c, d, e;
                            c = 0;
                            b = 0;
                            for(e = new dMd(a); e.e != e.i.gc();){
                                d = RD(bMd(e), 27);
                                c = $wnd.Math.max(d.g + d.i, c);
                                b = $wnd.Math.max(d.f + d.j, b);
                            }
                            return new rjd(c, b);
                        }
                        function ard(a, b) {
                            var c, d, e, f;
                            f = 0;
                            for(d = new Anb(a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 27);
                                f += $wnd.Math.pow(c.g * c.f - b, 2);
                            }
                            e = $wnd.Math.sqrt(f / (a.c.length - 1));
                            return e;
                        }
                        function Pnd() {
                            Pnd = geb;
                            Ond = new Rnd('UNKNOWN', 0);
                            Lnd = new Rnd('ABOVE', 1);
                            Mnd = new Rnd('BELOW', 2);
                            Nnd = new Rnd('INLINE', 3);
                            new kGd('org.eclipse.elk.labelSide', Ond);
                        }
                        function RHd(a, b) {
                            var c;
                            if (a.Yi() && b != null) for(c = 0; c < a.i; ++c){
                                if (pb(b, a.g[c])) return c;
                            }
                            else for(c = 0; c < a.i; ++c){
                                if (dE(a.g[c]) === dE(b)) return c;
                            }
                            return -1;
                        }
                        function L0b(a, b, c) {
                            var d, e;
                            if (b.c == (BEc(), zEc) && c.c == yEc) return -1;
                            else if (b.c == yEc && c.c == zEc) return 1;
                            d = P0b(b.a, a.a);
                            e = P0b(c.a, a.a);
                            return b.c == zEc ? e - d : d - e;
                        }
                        function f3b(a, b, c) {
                            if (!!c && (b < 0 || b > c.a.c.length)) throw Adb(new agb('index must be >= 0 and <= layer node count'));
                            !!a.c && Ymb(a.c.a, a);
                            a.c = c;
                            !!c && Qmb(c.a, b, a);
                        }
                        function Gac(a, b) {
                            var c, d, e;
                            for(d = new is(Mr(W2b(a).a.Kc(), new ir)); gs(d);){
                                c = RD(hs(d), 18);
                                e = RD(b.Kb(c), 10);
                                return new cc(Qb(e.n.b + e.o.b / 2));
                            }
                            return wb(), wb(), vb;
                        }
                        function RQc(a, b) {
                            this.c = new Tsb;
                            this.a = a;
                            this.b = b;
                            this.d = RD(mQb(a, (Ywc(), Qwc)), 312);
                            dE(mQb(a, (yCc(), eBc))) === dE((Cuc(), Auc)) ? this.e = new BRc : this.e = new uRc;
                        }
                        function ftd(a, b) {
                            var c, d;
                            d = null;
                            if (a.pf((umd(), amd))) {
                                c = RD(a.of(amd), 96);
                                c.pf(b) && (d = c.of(b));
                            }
                            d == null && !!a.Tf() && (d = a.Tf().of(b));
                            d == null && (d = iGd(b));
                            return d;
                        }
                        function ku(b, c) {
                            var d, e;
                            d = b.fd(c);
                            try {
                                e = d.Pb();
                                d.Qb();
                                return e;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 112)) throw Adb(new veb("Can't remove element " + c));
                                else throw Adb(a);
                            }
                        }
                        function GA(a, b) {
                            var c, d, e;
                            d = new uB;
                            e = new vB(d.q.getFullYear() - Owe, d.q.getMonth(), d.q.getDate());
                            c = FA(a, b, e);
                            if (c == 0 || c < b.length) throw Adb(new agb(b));
                            return e;
                        }
                        function iwb(a, b) {
                            var c, d, e;
                            uFb(b);
                            lFb(b != a);
                            e = a.b.c.length;
                            for(d = b.Kc(); d.Ob();){
                                c = d.Pb();
                                Rmb(a.b, uFb(c));
                            }
                            if (e != a.b.c.length) {
                                jwb(a, 0);
                                return true;
                            }
                            return false;
                        }
                        function dWb() {
                            dWb = geb;
                            XVb = (umd(), ald);
                            new mGd(Pkd, (Geb(), true));
                            $Vb = kld;
                            _Vb = nld;
                            aWb = pld;
                            ZVb = ild;
                            bWb = sld;
                            cWb = Lld;
                            WVb = (QVb(), OVb);
                            UVb = LVb;
                            VVb = NVb;
                            YVb = PVb;
                            TVb = KVb;
                        }
                        function U0b(a, b) {
                            if (b == a.c) return a.d;
                            else if (b == a.d) return a.c;
                            else throw Adb(new agb("'port' must be either the source port or target port of the edge."));
                        }
                        function T6b(a, b, c) {
                            var d, e;
                            e = a.o;
                            d = a.d;
                            switch(b.g){
                                case 1:
                                    return -d.d - c;
                                case 3:
                                    return e.b + d.a + c;
                                case 2:
                                    return e.a + d.c + c;
                                case 4:
                                    return -d.b - c;
                                default:
                                    return 0;
                            }
                        }
                        function Y9b(a, b, c, d) {
                            var e, f, g, h;
                            g3b(b, RD(d.Xb(0), 30));
                            h = d.kd(1, d.gc());
                            for(f = RD(c.Kb(b), 20).Kc(); f.Ob();){
                                e = RD(f.Pb(), 18);
                                g = e.c.i == b ? e.d.i : e.c.i;
                                Y9b(a, g, c, h);
                            }
                        }
                        function Bic(a) {
                            var b;
                            b = new Tsb;
                            if (nQb(a, (Ywc(), Vwc))) return RD(mQb(a, Vwc), 85);
                            FDb(CDb(new SDb(null, new Swb(a.j, 16)), new Dic), new Fic(b));
                            pQb(a, Vwc, b);
                            return b;
                        }
                        function zad(a, b) {
                            var c, d, e, f, g;
                            d = 0;
                            e = 0;
                            c = 0;
                            for(g = new Anb(a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 186);
                                d = $wnd.Math.max(d, f.e);
                                e += f.b + (c > 0 ? b : 0);
                                ++c;
                            }
                            return new rjd(d, e);
                        }
                        function Czd(a, b) {
                            var c, d;
                            if (a.Db >> 16 == 6) return a.Cb.Th(a, 6, G4, b);
                            return d = Z5d(RD(vYd((c = RD(Ywd(a, 16), 29), !c ? (pvd(), hvd) : c), a.Db >> 16), 19)), a.Cb.Th(a, d.n, d.f, b);
                        }
                        function cCd(a, b) {
                            var c, d;
                            if (a.Db >> 16 == 7) return a.Cb.Th(a, 1, H4, b);
                            return d = Z5d(RD(vYd((c = RD(Ywd(a, 16), 29), !c ? (pvd(), jvd) : c), a.Db >> 16), 19)), a.Cb.Th(a, d.n, d.f, b);
                        }
                        function LCd(a, b) {
                            var c, d;
                            if (a.Db >> 16 == 9) return a.Cb.Th(a, 9, J4, b);
                            return d = Z5d(RD(vYd((c = RD(Ywd(a, 16), 29), !c ? (pvd(), lvd) : c), a.Db >> 16), 19)), a.Cb.Th(a, d.n, d.f, b);
                        }
                        function M1d(a, b) {
                            var c, d;
                            if (a.Db >> 16 == 5) return a.Cb.Th(a, 9, m7, b);
                            return d = Z5d(RD(vYd((c = RD(Ywd(a, 16), 29), !c ? (JTd(), tTd) : c), a.Db >> 16), 19)), a.Cb.Th(a, d.n, d.f, b);
                        }
                        function qBd(a, b) {
                            var c, d;
                            if (a.Db >> 16 == 7) return a.Cb.Th(a, 6, t7, b);
                            return d = Z5d(RD(vYd((c = RD(Ywd(a, 16), 29), !c ? (JTd(), CTd) : c), a.Db >> 16), 19)), a.Cb.Th(a, d.n, d.f, b);
                        }
                        function iVd(a, b) {
                            var c, d;
                            if (a.Db >> 16 == 3) return a.Cb.Th(a, 0, p7, b);
                            return d = Z5d(RD(vYd((c = RD(Ywd(a, 16), 29), !c ? (JTd(), mTd) : c), a.Db >> 16), 19)), a.Cb.Th(a, d.n, d.f, b);
                        }
                        function IEd() {
                            this.a = new BDd;
                            this.g = new Io;
                            this.j = new Io;
                            this.b = new Tsb;
                            this.d = new Io;
                            this.i = new Io;
                            this.k = new Tsb;
                            this.c = new Tsb;
                            this.e = new Tsb;
                            this.f = new Tsb;
                        }
                        function kQd(a, b, c) {
                            var d, e, f;
                            c < 0 && (c = 0);
                            f = a.i;
                            for(e = c; e < f; e++){
                                d = QHd(a, e);
                                if (b == null) {
                                    if (d == null) return e;
                                } else if (dE(b) === dE(d) || pb(b, d)) return e;
                            }
                            return -1;
                        }
                        function Bee(a, b) {
                            var c, d;
                            c = b.qi(a.a);
                            if (!c) return null;
                            else {
                                d = WD($Nd((!c.b && (c.b = new SVd((JTd(), FTd), C8, c)), c.b), _Ke));
                                return lhb(aLe, d) ? Uee(a, BXd(b.qk())) : d;
                            }
                        }
                        function Oje(a, b) {
                            var c, d;
                            if (b) {
                                if (b == a) return true;
                                c = 0;
                                for(d = RD(b, 54).Ph(); !!d && d != b; d = d.Ph()){
                                    if (++c > wxe) return Oje(a, d);
                                    if (d == a) return true;
                                }
                            }
                            return false;
                        }
                        function yNb(a) {
                            tNb();
                            switch(a.q.g){
                                case 5:
                                    vNb(a, (qpd(), Yod));
                                    vNb(a, npd);
                                    break;
                                case 4:
                                    wNb(a, (qpd(), Yod));
                                    wNb(a, npd);
                                    break;
                                default:
                                    xNb(a, (qpd(), Yod));
                                    xNb(a, npd);
                            }
                        }
                        function CNb(a) {
                            tNb();
                            switch(a.q.g){
                                case 5:
                                    zNb(a, (qpd(), Xod));
                                    zNb(a, ppd);
                                    break;
                                case 4:
                                    ANb(a, (qpd(), Xod));
                                    ANb(a, ppd);
                                    break;
                                default:
                                    BNb(a, (qpd(), Xod));
                                    BNb(a, ppd);
                            }
                        }
                        function RTb(a) {
                            var b, c;
                            b = RD(mQb(a, (yVb(), mVb)), 17);
                            if (b) {
                                c = b.a;
                                c == 0 ? pQb(a, (JVb(), IVb), new Owb) : pQb(a, (JVb(), IVb), new Pwb(c));
                            } else pQb(a, (JVb(), IVb), new Pwb(1));
                        }
                        function b2b(a, b) {
                            var c;
                            c = a.i;
                            switch(b.g){
                                case 1:
                                    return -(a.n.b + a.o.b);
                                case 2:
                                    return a.n.a - c.o.a;
                                case 3:
                                    return a.n.b - c.o.b;
                                case 4:
                                    return -(a.n.a + a.o.a);
                            }
                            return 0;
                        }
                        function wec(a, b) {
                            switch(a.g){
                                case 0:
                                    return b == (cxc(), $wc) ? sec : tec;
                                case 1:
                                    return b == (cxc(), $wc) ? sec : rec;
                                case 2:
                                    return b == (cxc(), $wc) ? rec : tec;
                                default:
                                    return rec;
                            }
                        }
                        function Fad(a, b) {
                            var c, d, e;
                            Ymb(a.a, b);
                            a.e -= b.r + (a.a.c.length == 0 ? 0 : a.c);
                            e = fFe;
                            for(d = new Anb(a.a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 172);
                                e = $wnd.Math.max(e, c.d);
                            }
                            a.b = e;
                        }
                        function jzd(a, b) {
                            var c, d;
                            if (a.Db >> 16 == 3) return a.Cb.Th(a, 12, J4, b);
                            return d = Z5d(RD(vYd((c = RD(Ywd(a, 16), 29), !c ? (pvd(), gvd) : c), a.Db >> 16), 19)), a.Cb.Th(a, d.n, d.f, b);
                        }
                        function sCd(a, b) {
                            var c, d;
                            if (a.Db >> 16 == 11) return a.Cb.Th(a, 10, J4, b);
                            return d = Z5d(RD(vYd((c = RD(Ywd(a, 16), 29), !c ? (pvd(), kvd) : c), a.Db >> 16), 19)), a.Cb.Th(a, d.n, d.f, b);
                        }
                        function n4d(a, b) {
                            var c, d;
                            if (a.Db >> 16 == 10) return a.Cb.Th(a, 11, h7, b);
                            return d = Z5d(RD(vYd((c = RD(Ywd(a, 16), 29), !c ? (JTd(), ATd) : c), a.Db >> 16), 19)), a.Cb.Th(a, d.n, d.f, b);
                        }
                        function Q5d(a, b) {
                            var c, d;
                            if (a.Db >> 16 == 10) return a.Cb.Th(a, 12, s7, b);
                            return d = Z5d(RD(vYd((c = RD(Ywd(a, 16), 29), !c ? (JTd(), DTd) : c), a.Db >> 16), 19)), a.Cb.Th(a, d.n, d.f, b);
                        }
                        function WVd(a) {
                            var b;
                            if ((a.Bb & 1) == 0 && !!a.r && a.r.Vh()) {
                                b = RD(a.r, 54);
                                a.r = RD(Vvd(a, b), 142);
                                a.r != b && (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 9, 8, b, a.r));
                            }
                            return a.r;
                        }
                        function pKb(a, b, c) {
                            var d;
                            d = cD(WC(iE, 1), vxe, 28, 15, [
                                sKb(a, (ZJb(), WJb), b, c),
                                sKb(a, XJb, b, c),
                                sKb(a, YJb, b, c)
                            ]);
                            if (a.f) {
                                d[0] = $wnd.Math.max(d[0], d[2]);
                                d[2] = d[0];
                            }
                            return d;
                        }
                        function ddc(a, b) {
                            var c, d, e;
                            e = kdc(a, b);
                            if (e.c.length == 0) return;
                            _mb(e, new Gdc);
                            c = e.c.length;
                            for(d = 0; d < c; d++)_cc(a, (tFb(d, e.c.length), RD(e.c[d], 293)), gdc(a, e, d));
                        }
                        function Wnc(a) {
                            var b, c, d, e;
                            for(e = RD(Qc(a.a, (Bnc(), wnc)), 15).Kc(); e.Ob();){
                                d = RD(e.Pb(), 105);
                                for(c = Ec(d.k).Kc(); c.Ob();){
                                    b = RD(c.Pb(), 64);
                                    Qnc(a, d, b, (joc(), hoc), 1);
                                }
                            }
                        }
                        function Yrc(a) {
                            var b, c;
                            if (a.k == (r3b(), o3b)) for(c = new is(Mr(W2b(a).a.Kc(), new ir)); gs(c);){
                                b = RD(hs(c), 18);
                                if (!W0b(b) && a.c == T0b(b, a).c) return true;
                            }
                            return false;
                        }
                        function hSc(a) {
                            var b, c;
                            if (a.k == (r3b(), o3b)) for(c = new is(Mr(W2b(a).a.Kc(), new ir)); gs(c);){
                                b = RD(hs(c), 18);
                                if (!W0b(b) && b.c.i.c == b.d.i.c) return true;
                            }
                            return false;
                        }
                        function XDd(a, b) {
                            var c, d, e, f, g;
                            if (b) {
                                e = b.a.length;
                                c = new vue(e);
                                for(g = (c.b - c.a) * c.c < 0 ? (uue(), tue) : new Rue(c); g.Ob();){
                                    f = RD(g.Pb(), 17);
                                    d = xDd(b, f.a);
                                    !!d && AEd(a, d);
                                }
                            }
                        }
                        function bbe() {
                            Tae();
                            var a, b;
                            Xae((lTd(), kTd));
                            Wae(kTd);
                            rBd(kTd);
                            d2d = (JTd(), wTd);
                            for(b = new Anb(Rae); b.a < b.c.c.length;){
                                a = RD(ynb(b), 248);
                                o2d(a, wTd, null);
                            }
                            return true;
                        }
                        function uD(a, b) {
                            var c, d, e, f, g, h, i, j;
                            i = a.h >> 19;
                            j = b.h >> 19;
                            if (i != j) return j - i;
                            e = a.h;
                            h = b.h;
                            if (e != h) return e - h;
                            d = a.m;
                            g = b.m;
                            if (d != g) return d - g;
                            c = a.l;
                            f = b.l;
                            return c - f;
                        }
                        function YHb() {
                            YHb = geb;
                            XHb = (iIb(), fIb);
                            WHb = new lGd(Aye, XHb);
                            VHb = (LHb(), KHb);
                            UHb = new lGd(Bye, VHb);
                            THb = (DHb(), CHb);
                            SHb = new lGd(Cye, THb);
                            RHb = new lGd(Dye, (Geb(), true));
                        }
                        function Iic(a, b, c) {
                            var d, e;
                            d = b * c;
                            if (ZD(a.g, 154)) {
                                e = $jc(a);
                                if (e.f.d) e.f.a || (a.d.a += d + Tye);
                                else {
                                    a.d.d -= d + Tye;
                                    a.d.a += d + Tye;
                                }
                            } else if (ZD(a.g, 10)) {
                                a.d.d -= d;
                                a.d.a += 2 * d;
                            }
                        }
                        function _pc(a, b, c) {
                            var d, e, f, g, h;
                            e = a[c.g];
                            for(h = new Anb(b.d); h.a < h.c.c.length;){
                                g = RD(ynb(h), 105);
                                f = g.i;
                                if (!!f && f.i == c) {
                                    d = g.d[c.g];
                                    e[d] = $wnd.Math.max(e[d], f.j.b);
                                }
                            }
                        }
                        function k9c(a, b) {
                            var c, d, e, f, g;
                            d = 0;
                            e = 0;
                            c = 0;
                            for(g = new Anb(b.d); g.a < g.c.c.length;){
                                f = RD(ynb(g), 315);
                                gad(f);
                                d = $wnd.Math.max(d, f.b);
                                e += f.d + (c > 0 ? a.b : 0);
                                ++c;
                            }
                            b.b = d;
                            b.e = e;
                        }
                        function Fo(a) {
                            var b, c, d;
                            d = a.b;
                            if (Xp(a.i, d.length)) {
                                c = d.length * 2;
                                a.b = $C(XF, ewe, 303, c, 0, 1);
                                a.c = $C(XF, ewe, 303, c, 0, 1);
                                a.f = c - 1;
                                a.i = 0;
                                for(b = a.a; b; b = b.c)Bo(a, b, b);
                                ++a.g;
                            }
                        }
                        function VPb(a, b, c, d) {
                            var e, f, g, h;
                            for(e = 0; e < b.o; e++){
                                f = e - b.j + c;
                                for(g = 0; g < b.p; g++){
                                    h = g - b.k + d;
                                    PPb(b, e, g) ? aQb(a, f, h) || cQb(a, f, h) : RPb(b, e, g) && ($Pb(a, f, h) || dQb(a, f, h));
                                }
                            }
                        }
                        function k_b(a, b) {
                            a.b.a = $wnd.Math.min(a.b.a, b.c);
                            a.b.b = $wnd.Math.min(a.b.b, b.d);
                            a.a.a = $wnd.Math.max(a.a.a, b.c);
                            a.a.b = $wnd.Math.max(a.a.b, b.d);
                            return ZEb(a.c, b), true;
                        }
                        function psc(a, b, c) {
                            var d;
                            d = b.c.i;
                            if (d.k == (r3b(), o3b)) {
                                pQb(a, (Ywc(), vwc), RD(mQb(d, vwc), 12));
                                pQb(a, wwc, RD(mQb(d, wwc), 12));
                            } else {
                                pQb(a, (Ywc(), vwc), b.c);
                                pQb(a, wwc, c.d);
                            }
                        }
                        function wid(a, b, c) {
                            tid();
                            var d, e, f, g, h, i;
                            g = b / 2;
                            f = c / 2;
                            d = $wnd.Math.abs(a.a);
                            e = $wnd.Math.abs(a.b);
                            h = 1;
                            i = 1;
                            d > g && (h = g / d);
                            e > f && (i = f / e);
                            ijd(a, $wnd.Math.min(h, i));
                            return a;
                        }
                        function OAd() {
                            qAd();
                            var b, c;
                            try {
                                c = RD(M5d((YSd(), XSd), $He), 2113);
                                if (c) return c;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 103)) {
                                    b = a;
                                    UId((Hde(), b));
                                } else throw Adb(a);
                            }
                            return new KAd;
                        }
                        function Qae() {
                            qAd();
                            var b, c;
                            try {
                                c = RD(M5d((YSd(), XSd), AKe), 2040);
                                if (c) return c;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 103)) {
                                    b = a;
                                    UId((Hde(), b));
                                } else throw Adb(a);
                            }
                            return new Mae;
                        }
                        function vne() {
                            Zme();
                            var b, c;
                            try {
                                c = RD(M5d((YSd(), XSd), dLe), 2122);
                                if (c) return c;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 103)) {
                                    b = a;
                                    UId((Hde(), b));
                                } else throw Adb(a);
                            }
                            return new rne;
                        }
                        function f2d(a, b, c) {
                            var d, e;
                            e = a.e;
                            a.e = b;
                            if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
                                d = new N3d(a, 1, 4, e, b);
                                !c ? c = d : c.nj(d);
                            }
                            e != b && (b ? c = o2d(a, k2d(a, b), c) : c = o2d(a, a.a, c));
                            return c;
                        }
                        function DB() {
                            uB.call(this);
                            this.e = -1;
                            this.a = false;
                            this.p = qwe;
                            this.k = -1;
                            this.c = -1;
                            this.b = -1;
                            this.g = false;
                            this.f = -1;
                            this.j = -1;
                            this.n = -1;
                            this.i = -1;
                            this.d = -1;
                            this.o = qwe;
                        }
                        function hHb(a, b) {
                            var c, d, e;
                            d = a.b.d.d;
                            a.a || (d += a.b.d.a);
                            e = b.b.d.d;
                            b.a || (e += b.b.d.a);
                            c = Qfb(d, e);
                            if (c == 0) {
                                if (!a.a && b.a) return -1;
                                else if (!b.a && a.a) return 1;
                            }
                            return c;
                        }
                        function XQb(a, b) {
                            var c, d, e;
                            d = a.b.b.d;
                            a.a || (d += a.b.b.a);
                            e = b.b.b.d;
                            b.a || (e += b.b.b.a);
                            c = Qfb(d, e);
                            if (c == 0) {
                                if (!a.a && b.a) return -1;
                                else if (!b.a && a.a) return 1;
                            }
                            return c;
                        }
                        function RYb(a, b) {
                            var c, d, e;
                            d = a.b.g.d;
                            a.a || (d += a.b.g.a);
                            e = b.b.g.d;
                            b.a || (e += b.b.g.a);
                            c = Qfb(d, e);
                            if (c == 0) {
                                if (!a.a && b.a) return -1;
                                else if (!b.a && a.a) return 1;
                            }
                            return c;
                        }
                        function _Wb() {
                            _Wb = geb;
                            YWb = nfd(pfd(pfd(pfd(new ufd, (sXb(), qXb), (hcc(), Dbc)), qXb, Hbc), rXb, Obc), rXb, rbc);
                            $Wb = pfd(pfd(new ufd, qXb, hbc), qXb, sbc);
                            ZWb = nfd(new ufd, rXb, ubc);
                        }
                        function J6b(a) {
                            var b, c, d, e, f;
                            b = RD(mQb(a, (Ywc(), cwc)), 85);
                            f = a.n;
                            for(d = b.Cc().Kc(); d.Ob();){
                                c = RD(d.Pb(), 314);
                                e = c.i;
                                e.c += f.a;
                                e.d += f.b;
                                c.c ? MKb(c) : OKb(c);
                            }
                            pQb(a, cwc, null);
                        }
                        function Wpc(a, b, c) {
                            var d, e;
                            e = a.b;
                            d = e.d;
                            switch(b.g){
                                case 1:
                                    return -d.d - c;
                                case 2:
                                    return e.o.a + d.c + c;
                                case 3:
                                    return e.o.b + d.a + c;
                                case 4:
                                    return -d.b - c;
                                default:
                                    return -1;
                            }
                        }
                        function CNc(a, b, c) {
                            var d, e;
                            c.Ug('Interactive node placement', 1);
                            a.a = RD(mQb(b, (Ywc(), Qwc)), 312);
                            for(e = new Anb(b.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 30);
                                BNc(a, d);
                            }
                            c.Vg();
                        }
                        function C5c(a) {
                            var b, c, d, e, f;
                            d = 0;
                            e = Hze;
                            if (a.b) for(b = 0; b < 360; b++){
                                c = b * 0.017453292519943295;
                                A5c(a, a.d, 0, 0, dFe, c);
                                f = a.b.Dg(a.d);
                                if (f < e) {
                                    d = c;
                                    e = f;
                                }
                            }
                            A5c(a, a.d, 0, 0, dFe, d);
                        }
                        function Oad(a, b) {
                            var c, d, e, f;
                            f = new Tsb;
                            b.e = null;
                            b.f = null;
                            for(d = new Anb(b.i); d.a < d.c.c.length;){
                                c = RD(ynb(d), 68);
                                e = RD(Wjb(a.g, c.a), 42);
                                c.a = Oid(c.b);
                                Zjb(f, c.a, e);
                            }
                            a.g = f;
                        }
                        function Dad(a, b, c) {
                            var d, e, f, g, h, i;
                            e = b - a.e;
                            f = e / a.d.c.length;
                            g = 0;
                            for(i = new Anb(a.d); i.a < i.c.c.length;){
                                h = RD(ynb(i), 315);
                                d = a.b - h.b + c;
                                fad(h, h.e + g * f, h.f);
                                bad(h, f, d);
                                ++g;
                            }
                        }
                        function wPd(a) {
                            var b;
                            a.f._j();
                            if (a.b != -1) {
                                ++a.b;
                                b = a.f.d[a.a];
                                if (a.b < b.i) return;
                                ++a.a;
                            }
                            for(; a.a < a.f.d.length; ++a.a){
                                b = a.f.d[a.a];
                                if (!!b && b.i != 0) {
                                    a.b = 0;
                                    return;
                                }
                            }
                            a.b = -1;
                        }
                        function Jde(a, b) {
                            var c, d, e;
                            e = b.c.length;
                            c = Lde(a, e == 0 ? '' : (tFb(0, b.c.length), WD(b.c[0])));
                            for(d = 1; d < e && !!c; ++d)c = RD(c, 54).Zh((tFb(d, b.c.length), WD(b.c[d])));
                            return c;
                        }
                        function RIc(a, b) {
                            var c, d;
                            for(d = new Anb(b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 10);
                                a.c[c.c.p][c.p].a = Iwb(a.i);
                                a.c[c.c.p][c.p].d = Kfb(a.c[c.c.p][c.p].a);
                                a.c[c.c.p][c.p].b = 1;
                            }
                        }
                        function brd(a, b) {
                            var c, d, e, f;
                            f = 0;
                            for(d = new Anb(a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 163);
                                f += $wnd.Math.pow(urd(c) * trd(c) - b, 2);
                            }
                            e = $wnd.Math.sqrt(f / (a.c.length - 1));
                            return e;
                        }
                        function uMb(a, b) {
                            var c, d, e, f;
                            f = 0;
                            for(e = RD(RD(Qc(a.r, b), 21), 87).Kc(); e.Ob();){
                                d = RD(e.Pb(), 117);
                                f = $wnd.Math.max(f, d.e.a + d.b.Mf().a);
                            }
                            c = RD(Vrb(a.b, b), 127);
                            c.n.b = 0;
                            c.a.a = f;
                        }
                        function DNb(a, b) {
                            var c, d, e, f;
                            c = 0;
                            for(f = RD(RD(Qc(a.r, b), 21), 87).Kc(); f.Ob();){
                                e = RD(f.Pb(), 117);
                                c = $wnd.Math.max(c, e.e.b + e.b.Mf().b);
                            }
                            d = RD(Vrb(a.b, b), 127);
                            d.n.d = 0;
                            d.a.b = c;
                        }
                        function jMc(a, b, c, d) {
                            var e, f, g;
                            f = eMc(a, b, c, d);
                            g = kMc(a, f);
                            BMc(a, b, c, d);
                            YLc(a.b);
                            yob();
                            _mb(f, new LMc(a));
                            e = kMc(a, f);
                            BMc(a, c, b, d);
                            YLc(a.b);
                            return new Ptd(sgb(g), sgb(e));
                        }
                        function udd(a, b) {
                            var c;
                            b.Ug('Delaunay triangulation', 1);
                            c = new bnb;
                            Umb(a.i, new ydd(c));
                            Heb(TD(mQb(a, (OQb(), MQb))));
                            !a.e ? a.e = EFb(c) : ye(a.e, EFb(c));
                            b.Vg();
                        }
                        function Hsd(a, b, c) {
                            var d, e;
                            Nzd(a, a.j + b, a.k + c);
                            for(e = new dMd((!a.a && (a.a = new XZd(D4, a, 5)), a.a)); e.e != e.i.gc();){
                                d = RD(bMd(e), 377);
                                Uxd(d, d.a + b, d.b + c);
                            }
                            Gzd(a, a.b + b, a.c + c);
                        }
                        function Vyd(a, b, c, d) {
                            switch(c){
                                case 7:
                                    return !a.e && (a.e = new Yie(G4, a, 7, 4)), qLd(a.e, b, d);
                                case 8:
                                    return !a.d && (a.d = new Yie(G4, a, 8, 5)), qLd(a.d, b, d);
                            }
                            return dyd(a, b, c, d);
                        }
                        function Wyd(a, b, c, d) {
                            switch(c){
                                case 7:
                                    return !a.e && (a.e = new Yie(G4, a, 7, 4)), rLd(a.e, b, d);
                                case 8:
                                    return !a.d && (a.d = new Yie(G4, a, 8, 5)), rLd(a.d, b, d);
                            }
                            return eyd(a, b, c, d);
                        }
                        function LDd(a, b, c) {
                            var d, e, f, g, h;
                            if (c) {
                                f = c.a.length;
                                d = new vue(f);
                                for(h = (d.b - d.a) * d.c < 0 ? (uue(), tue) : new Rue(d); h.Ob();){
                                    g = RD(h.Pb(), 17);
                                    e = xDd(c, g.a);
                                    !!e && DEd(a, e, b);
                                }
                            }
                        }
                        function fOd(a, b, c) {
                            var d, e, f, g, h;
                            a._j();
                            f = b == null ? 0 : tb(b);
                            if (a.f > 0) {
                                g = (f & lve) % a.d.length;
                                e = WNd(a, g, f, b);
                                if (e) {
                                    h = e.nd(c);
                                    return h;
                                }
                            }
                            d = a.ck(f, b, c);
                            a.c.Fc(d);
                            return null;
                        }
                        function Tee(a, b) {
                            var c, d, e, f;
                            switch(Oee(a, b).Kl()){
                                case 3:
                                case 2:
                                    c = mYd(b);
                                    for(e = 0, f = c.i; e < f; ++e){
                                        d = RD(QHd(c, e), 35);
                                        if (yfe(Qee(a, d)) == 5) return d;
                                    }
                                    break;
                            }
                            return null;
                        }
                        function gt(a) {
                            var b, c, d, e, f;
                            if (Xp(a.f, a.b.length)) {
                                d = $C(UG, ewe, 227, a.b.length * 2, 0, 1);
                                a.b = d;
                                e = d.length - 1;
                                for(c = a.a; c != a; c = c._d()){
                                    f = RD(c, 227);
                                    b = f.d & e;
                                    f.a = d[b];
                                    d[b] = f;
                                }
                            }
                        }
                        function gSc(a) {
                            var b, c;
                            c = RD(mQb(a, (Ywc(), kwc)), 21);
                            b = vfd(ZRc);
                            c.Hc((ovc(), lvc)) && ofd(b, aSc);
                            c.Hc(nvc) && ofd(b, cSc);
                            c.Hc(evc) && ofd(b, $Rc);
                            c.Hc(gvc) && ofd(b, _Rc);
                            return b;
                        }
                        function Bid(a) {
                            if (a < 0) throw Adb(new agb('The input must be positive'));
                            else return a < sid.length ? Xdb(sid[a]) : $wnd.Math.sqrt(dFe * a) * (Jid(a, a) / Iid(2.718281828459045, a));
                        }
                        function PHd(a, b) {
                            var c;
                            if (a.Yi() && b != null) for(c = 0; c < a.i; ++c){
                                if (pb(b, a.g[c])) return true;
                            }
                            else for(c = 0; c < a.i; ++c){
                                if (dE(a.g[c]) === dE(b)) return true;
                            }
                            return false;
                        }
                        function Br(a, b) {
                            if (b == null) while(a.a.Ob()){
                                if (RD(a.a.Pb(), 44).md() == null) return true;
                            }
                            else while(a.a.Ob()){
                                if (pb(b, RD(a.a.Pb(), 44).md())) return true;
                            }
                            return false;
                        }
                        function Qy(a, b) {
                            var c, d, e;
                            if (b === a) return true;
                            else if (ZD(b, 678)) {
                                e = RD(b, 2046);
                                return Ue((d = a.g, !d ? a.g = new Di(a) : d), (c = e.g, !c ? e.g = new Di(e) : c));
                            } else return false;
                        }
                        function hA(a) {
                            var b, c, d, e;
                            b = 'gA';
                            c = 'vz';
                            e = $wnd.Math.min(a.length, 5);
                            for(d = e - 1; d >= 0; d--)if (lhb(a[d].d, b) || lhb(a[d].d, c)) {
                                a.length >= d + 1 && a.splice(0, d + 1);
                                break;
                            }
                            return a;
                        }
                        function Fdb(a, b) {
                            var c;
                            if (Kdb(a) && Kdb(b)) {
                                c = a / b;
                                if (jxe < c && c < hxe) return c < 0 ? $wnd.Math.ceil(c) : $wnd.Math.floor(c);
                            }
                            return Edb(iD(Kdb(a) ? Wdb(a) : a, Kdb(b) ? Wdb(b) : b, false));
                        }
                        function T0b(a, b) {
                            if (b == a.c.i) return a.d.i;
                            else if (b == a.d.i) return a.c.i;
                            else throw Adb(new agb("'node' must either be the source node or target node of the edge."));
                        }
                        function M5b(a) {
                            var b, c, d, e;
                            e = RD(mQb(a, (Ywc(), Zvc)), 36);
                            if (e) {
                                d = new pjd;
                                b = Y2b(a.c.i);
                                while(b != e){
                                    c = b.e;
                                    b = Y2b(c);
                                    Zid($id($id(d, c.n), b.c), b.d.b, b.d.d);
                                }
                                return d;
                            }
                            return G5b;
                        }
                        function phc(a) {
                            var b;
                            b = RD(mQb(a, (Ywc(), Pwc)), 337);
                            FDb(EDb(new SDb(null, new Swb(b.d, 16)), new Chc), new Ehc(a));
                            FDb(CDb(new SDb(null, new Swb(b.d, 16)), new Ghc), new Ihc(a));
                        }
                        function Zrc(a, b) {
                            var c, d, e, f;
                            e = b ? a3b(a) : Z2b(a);
                            for(d = new is(Mr(e.a.Kc(), new ir)); gs(d);){
                                c = RD(hs(d), 18);
                                f = T0b(c, a);
                                if (f.k == (r3b(), o3b) && f.c != a.c) return f;
                            }
                            return null;
                        }
                        function fIc(a) {
                            var b, c, d;
                            for(c = new Anb(a.p); c.a < c.c.c.length;){
                                b = RD(ynb(c), 10);
                                if (b.k != (r3b(), p3b)) continue;
                                d = b.o.b;
                                a.i = $wnd.Math.min(a.i, d);
                                a.g = $wnd.Math.max(a.g, d);
                            }
                        }
                        function OIc(a, b, c) {
                            var d, e, f;
                            for(f = new Anb(b); f.a < f.c.c.length;){
                                d = RD(ynb(f), 10);
                                a.c[d.c.p][d.p].e = false;
                            }
                            for(e = new Anb(b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 10);
                                NIc(a, d, c);
                            }
                        }
                        function uTc(a, b, c) {
                            var d, e;
                            d = VTc(b.j, c.s, c.c) + VTc(c.e, b.s, b.c);
                            e = VTc(c.j, b.s, b.c) + VTc(b.e, c.s, c.c);
                            if (d == e) {
                                if (d > 0) {
                                    a.b += 2;
                                    a.a += d;
                                }
                            } else {
                                a.b += 1;
                                a.a += $wnd.Math.min(d, e);
                            }
                        }
                        function CVc(a) {
                            var b;
                            b = RD(mQb(RD(ju(a.b, 0), 40), (h_c(), T$c)), 107);
                            pQb(a, (q$c(), SZc), new rjd(0, 0));
                            FVc(new YWc, a, b.b + b.c - Kfb(UD(mQb(a, ZZc))), b.d + b.a - Kfb(UD(mQb(a, _Zc))));
                        }
                        function pDd(a, b) {
                            var c, d;
                            d = false;
                            if (bE(b)) {
                                d = true;
                                oDd(a, new OC(WD(b)));
                            }
                            if (!d) {
                                if (ZD(b, 242)) {
                                    d = true;
                                    oDd(a, (c = Qeb(RD(b, 242)), new hC(c)));
                                }
                            }
                            if (!d) throw Adb(new Aeb(tIe));
                        }
                        function g$d(a, b, c, d) {
                            var e, f, g;
                            e = new P3d(a.e, 1, 10, (g = b.c, ZD(g, 90) ? RD(g, 29) : (JTd(), zTd)), (f = c.c, ZD(f, 90) ? RD(f, 29) : (JTd(), zTd)), fZd(a, b), false);
                            !d ? d = e : d.nj(e);
                            return d;
                        }
                        function _2b(a) {
                            var b, c;
                            switch(RD(mQb(Y2b(a), (yCc(), QAc)), 429).g){
                                case 0:
                                    b = a.n;
                                    c = a.o;
                                    return new rjd(b.a + c.a / 2, b.b + c.b / 2);
                                case 1:
                                    return new sjd(a.n);
                                default:
                                    return null;
                            }
                        }
                        function Ouc() {
                            Ouc = geb;
                            Luc = new Puc(LAe, 0);
                            Kuc = new Puc('LEFTUP', 1);
                            Nuc = new Puc('RIGHTUP', 2);
                            Juc = new Puc('LEFTDOWN', 3);
                            Muc = new Puc('RIGHTDOWN', 4);
                            Iuc = new Puc('BALANCED', 5);
                        }
                        function dKc(a, b, c) {
                            var d, e, f;
                            d = Qfb(a.a[b.p], a.a[c.p]);
                            if (d == 0) {
                                e = RD(mQb(b, (Ywc(), qwc)), 15);
                                f = RD(mQb(c, qwc), 15);
                                if (e.Hc(c)) return -1;
                                else if (f.Hc(b)) return 1;
                            }
                            return d;
                        }
                        function k5c(a) {
                            switch(a.g){
                                case 1:
                                    return new K3c;
                                case 2:
                                    return new M3c;
                                case 3:
                                    return new I3c;
                                case 0:
                                    return null;
                                default:
                                    throw Adb(new agb(mFe + (a.f != null ? a.f : '' + a.g)));
                            }
                        }
                        function gyd(a, b, c) {
                            switch(b){
                                case 1:
                                    !a.n && (a.n = new C5d(I4, a, 1, 7));
                                    sLd(a.n);
                                    !a.n && (a.n = new C5d(I4, a, 1, 7));
                                    YGd(a.n, RD(c, 16));
                                    return;
                                case 2:
                                    jyd(a, WD(c));
                                    return;
                            }
                            Dxd(a, b, c);
                        }
                        function xyd(a, b, c) {
                            switch(b){
                                case 3:
                                    Ayd(a, Kfb(UD(c)));
                                    return;
                                case 4:
                                    Cyd(a, Kfb(UD(c)));
                                    return;
                                case 5:
                                    Dyd(a, Kfb(UD(c)));
                                    return;
                                case 6:
                                    Eyd(a, Kfb(UD(c)));
                                    return;
                            }
                            gyd(a, b, c);
                        }
                        function dBd(a, b, c) {
                            var d, e, f;
                            f = (d = new R5d, d);
                            e = XVd(f, b, null);
                            !!e && e.oj();
                            PAd(f, c);
                            WGd((!a.c && (a.c = new C5d(u7, a, 12, 10)), a.c), f);
                            $Vd(f, 0);
                            bWd(f, 1);
                            aWd(f, true);
                            _Vd(f, true);
                        }
                        function M5d(a, b) {
                            var c, d, e;
                            c = Ktb(a.i, b);
                            if (ZD(c, 241)) {
                                e = RD(c, 241);
                                e.zi() == null && undefined;
                                return e.wi();
                            } else if (ZD(c, 507)) {
                                d = RD(c, 2037);
                                e = d.b;
                                return e;
                            } else return null;
                        }
                        function aj(a, b, c, d) {
                            var e, f;
                            Qb(b);
                            Qb(c);
                            f = RD(Fn(a.d, b), 17);
                            Ob(!!f, 'Row %s not in %s', b, a.e);
                            e = RD(Fn(a.b, c), 17);
                            Ob(!!e, 'Column %s not in %s', c, a.c);
                            return cj(a, f.a, e.a, d);
                        }
                        function ZC(a, b, c, d, e, f, g) {
                            var h, i, j, k, l;
                            k = e[f];
                            j = f == g - 1;
                            h = j ? d : 0;
                            l = _C(h, k);
                            d != 10 && cD(WC(a, g - f), b[f], c[f], h, l);
                            if (!j) {
                                ++f;
                                for(i = 0; i < k; ++i)l[i] = ZC(a, b, c, d, e, f, g);
                            }
                            return l;
                        }
                        function cMd(b) {
                            if (b.g == -1) throw Adb(new cgb);
                            b.Xj();
                            try {
                                b.i.gd(b.g);
                                b.f = b.i.j;
                                b.g < b.e && --b.e;
                                b.g = -1;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) throw Adb(new Jrb);
                                else throw Adb(a);
                            }
                        }
                        function v0b(a) {
                            var b, c, d, e;
                            e = -1;
                            d = 0;
                            for(c = new Anb(a); c.a < c.c.c.length;){
                                b = RD(ynb(c), 249);
                                if (b.c == (BEc(), yEc)) {
                                    e = d == 0 ? 0 : d - 1;
                                    break;
                                } else d == a.c.length - 1 && (e = d);
                                d += 1;
                            }
                            return e;
                        }
                        function $9c(a) {
                            var b, c, d, e;
                            e = 0;
                            b = 0;
                            for(d = new Anb(a.c); d.a < d.c.c.length;){
                                c = RD(ynb(d), 27);
                                Dyd(c, a.e + e);
                                Eyd(c, a.f);
                                e += c.g + a.b;
                                b = $wnd.Math.max(b, c.f + a.b);
                            }
                            a.d = e - a.b;
                            a.a = b - a.b;
                        }
                        function UGb(a) {
                            var b, c, d;
                            for(c = new Anb(a.a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 60);
                                d = b.d.c;
                                b.d.c = b.d.d;
                                b.d.d = d;
                                d = b.d.b;
                                b.d.b = b.d.a;
                                b.d.a = d;
                                d = b.b.a;
                                b.b.a = b.b.b;
                                b.b.b = d;
                            }
                            IGb(a);
                        }
                        function DYb(a) {
                            var b, c, d;
                            for(c = new Anb(a.a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 86);
                                d = b.g.c;
                                b.g.c = b.g.d;
                                b.g.d = d;
                                d = b.g.b;
                                b.g.b = b.g.a;
                                b.g.a = d;
                                d = b.e.a;
                                b.e.a = b.e.b;
                                b.e.b = d;
                            }
                            uYb(a);
                        }
                        function pqc(a) {
                            var b, c, d, e, f;
                            f = Ec(a.k);
                            for(c = (qpd(), cD(WC(E3, 1), NAe, 64, 0, [
                                opd,
                                Yod,
                                Xod,
                                npd,
                                ppd
                            ])), d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                if (b != opd && !f.Hc(b)) return b;
                            }
                            return null;
                        }
                        function drc(a, b) {
                            var c, d;
                            d = RD(Nvb(DDb(CDb(new SDb(null, new Swb(b.j, 16)), new lrc))), 12);
                            if (d) {
                                c = RD(Vmb(d.e, 0), 18);
                                if (c) return RD(mQb(c, (Ywc(), zwc)), 17).a;
                            }
                            return mDc(a.b);
                        }
                        function FGc(a, b) {
                            var c, d, e, f;
                            for(f = new Anb(b.a); f.a < f.c.c.length;){
                                e = RD(ynb(f), 10);
                                Nnb(a.d);
                                for(d = new is(Mr(a3b(e).a.Kc(), new ir)); gs(d);){
                                    c = RD(hs(d), 18);
                                    CGc(a, e, c.d.i);
                                }
                            }
                        }
                        function T9c(a, b) {
                            var c, d;
                            Ymb(a.b, b);
                            for(d = new Anb(a.n); d.a < d.c.c.length;){
                                c = RD(ynb(d), 209);
                                if (Wmb(c.c, b, 0) != -1) {
                                    Ymb(c.c, b);
                                    $9c(c);
                                    c.c.c.length == 0 && Ymb(a.n, c);
                                    break;
                                }
                            }
                            N9c(a);
                        }
                        function ead(a, b) {
                            var c, d, e, f, g;
                            g = a.f;
                            e = 0;
                            f = 0;
                            for(d = new Anb(a.a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 172);
                                U9c(c, a.e, g);
                                Q9c(c, b);
                                f = $wnd.Math.max(f, c.r);
                                g += c.d + a.c;
                                e = g;
                            }
                            a.d = f;
                            a.b = e;
                        }
                        function R2c(a) {
                            var b, c;
                            c = yGd(a);
                            if (gr(c)) return null;
                            else {
                                b = (Qb(c), RD(Er(new is(Mr(c.a.Kc(), new ir))), 74));
                                return AGd(RD(QHd((!b.b && (b.b = new Yie(E4, b, 4, 7)), b.b), 0), 84));
                            }
                        }
                        function vWd(a) {
                            var b;
                            if (!a.o) {
                                b = a.uk();
                                b ? a.o = new D9d(a, a, null) : a.al() ? a.o = new U6d(a, null) : yfe(Qee((lke(), jke), a)) == 1 ? a.o = new N9d(a) : a.o = new S9d(a, null);
                            }
                            return a.o;
                        }
                        function Vje(a, b, c, d) {
                            var e, f, g, h, i;
                            if (c.Xh(b)) {
                                e = (g = b, !g ? null : RD(d, 54).gi(g));
                                if (e) {
                                    i = c.Mh(b);
                                    h = b.t;
                                    if (h > 1 || h == -1) {
                                        f = RD(i, 15);
                                        e.Wb(Sje(a, f));
                                    } else e.Wb(Rje(a, RD(i, 58)));
                                }
                            }
                        }
                        function ceb(b, c, d, e) {
                            beb();
                            var f = _db;
                            $moduleName = c;
                            $moduleBase = d;
                            ydb = e;
                            function g() {
                                for(var a = 0; a < f.length; a++)f[a]();
                            }
                            if (b) try {
                                fve(g)();
                            } catch (a) {
                                b(c, a);
                            }
                            else fve(g)();
                        }
                        function a6b(a, b) {
                            var c, d, e, f;
                            for(e = (f = new Xkb(a.b).a.vc().Kc(), new blb(f)); e.a.Ob();){
                                d = (c = RD(e.a.Pb(), 44), RD(c.ld(), 34));
                                if (egb(b, RD(d, 17)) < 0) return false;
                            }
                            return true;
                        }
                        function b6b(a, b) {
                            var c, d, e, f;
                            for(e = (f = new Xkb(a.b).a.vc().Kc(), new blb(f)); e.a.Ob();){
                                d = (c = RD(e.a.Pb(), 44), RD(c.ld(), 34));
                                if (egb(b, RD(d, 17)) > 0) return false;
                            }
                            return true;
                        }
                        function okc(a) {
                            var b, c, d, e, f;
                            for(d = new vkb(new mkb(a.b).a); d.b;){
                                c = tkb(d);
                                b = RD(c.ld(), 10);
                                f = RD(RD(c.md(), 42).a, 10);
                                e = RD(RD(c.md(), 42).b, 8);
                                $id(hjd(b.n), $id(ajd(f.n), e));
                            }
                        }
                        function Roc(a) {
                            switch(RD(mQb(a.b, (yCc(), BAc)), 387).g){
                                case 1:
                                    FDb(GDb(EDb(new SDb(null, new Swb(a.d, 16)), new kpc), new mpc), new opc);
                                    break;
                                case 2:
                                    Toc(a);
                                    break;
                                case 0:
                                    Soc(a);
                            }
                        }
                        function SVc(a, b, c) {
                            var d, e, f;
                            d = c;
                            !d && (d = new Oqd);
                            d.Ug('Layout', a.a.c.length);
                            for(f = new Anb(a.a); f.a < f.c.c.length;){
                                e = RD(ynb(f), 47);
                                if (d.$g()) return;
                                e.Kf(b, d.eh(1));
                            }
                            d.Vg();
                        }
                        function ukd() {
                            ukd = geb;
                            tkd = new vkd('V_TOP', 0);
                            skd = new vkd('V_CENTER', 1);
                            rkd = new vkd('V_BOTTOM', 2);
                            pkd = new vkd('H_LEFT', 3);
                            okd = new vkd('H_CENTER', 4);
                            qkd = new vkd('H_RIGHT', 5);
                        }
                        function GYd(a) {
                            var b;
                            if ((a.Db & 64) != 0) return MXd(a);
                            b = new Shb(MXd(a));
                            b.a += ' (abstract: ';
                            Ohb(b, (a.Bb & 256) != 0);
                            b.a += ', interface: ';
                            Ohb(b, (a.Bb & 512) != 0);
                            b.a += ')';
                            return b.a;
                        }
                        function Bz(a) {
                            var b;
                            if (a.c == null) {
                                b = dE(a.b) === dE(zz) ? null : a.b;
                                a.d = b == null ? vve : aE(b) ? Ez(VD(b)) : bE(b) ? uwe : nfb(rb(b));
                                a.a = a.a + ': ' + (aE(b) ? Dz(VD(b)) : b + '');
                                a.c = '(' + a.d + ') ' + a.a;
                            }
                        }
                        function Gtb() {
                            function b() {
                                try {
                                    return (new Map).entries().next().done;
                                } catch (a) {
                                    return false;
                                }
                            }
                            if (typeof Map === kve && Map.prototype.entries && b()) return Map;
                            else return Htb();
                        }
                        function tUc(a, b) {
                            var c, d, e, f;
                            f = new Jkb(a.e, 0);
                            c = 0;
                            while(f.b < f.d.gc()){
                                d = Kfb((sFb(f.b < f.d.gc()), UD(f.d.Xb(f.c = f.b++))));
                                e = d - b;
                                if (e > AEe) return c;
                                else e > -0.000001 && ++c;
                            }
                            return c;
                        }
                        function n2d(a, b) {
                            var c;
                            if (b != a.b) {
                                c = null;
                                !!a.b && (c = Jvd(a.b, a, -4, c));
                                !!b && (c = Ivd(b, a, -4, c));
                                c = e2d(a, b, c);
                                !!c && c.oj();
                            } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 3, b, b));
                        }
                        function q2d(a, b) {
                            var c;
                            if (b != a.f) {
                                c = null;
                                !!a.f && (c = Jvd(a.f, a, -1, c));
                                !!b && (c = Ivd(b, a, -1, c));
                                c = g2d(a, b, c);
                                !!c && c.oj();
                            } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 0, b, b));
                        }
                        function Lge(a, b, c, d) {
                            var e, f, g, h;
                            if (Mvd(a.e)) {
                                e = b.Lk();
                                h = b.md();
                                f = c.md();
                                g = fge(a, 1, e, h, f, e.Jk() ? kge(a, e, f, ZD(e, 102) && (RD(e, 19).Bb & txe) != 0) : -1, true);
                                d ? d.nj(g) : d = g;
                            }
                            return d;
                        }
                        function bne(a) {
                            var b, c, d;
                            if (a == null) return null;
                            c = RD(a, 15);
                            if (c.dc()) return '';
                            d = new Qhb;
                            for(b = c.Kc(); b.Ob();){
                                Nhb(d, (nme(), WD(b.Pb())));
                                d.a += ' ';
                            }
                            return qeb(d, d.a.length - 1);
                        }
                        function fne(a) {
                            var b, c, d;
                            if (a == null) return null;
                            c = RD(a, 15);
                            if (c.dc()) return '';
                            d = new Qhb;
                            for(b = c.Kc(); b.Ob();){
                                Nhb(d, (nme(), WD(b.Pb())));
                                d.a += ' ';
                            }
                            return qeb(d, d.a.length - 1);
                        }
                        function QIc(a, b, c) {
                            var d, e;
                            d = a.c[b.c.p][b.p];
                            e = a.c[c.c.p][c.p];
                            if (d.a != null && e.a != null) return Jfb(d.a, e.a);
                            else if (d.a != null) return -1;
                            else if (e.a != null) return 1;
                            return 0;
                        }
                        function RVc(a, b, c) {
                            c.Ug('Tree layout', 1);
                            Sed(a.b);
                            Ved(a.b, (YVc(), UVc), UVc);
                            Ved(a.b, VVc, VVc);
                            Ved(a.b, WVc, WVc);
                            Ved(a.b, XVc, XVc);
                            a.a = Qed(a.b, b);
                            SVc(a, b, c.eh(1));
                            c.Vg();
                            return b;
                        }
                        function ZDd(a, b) {
                            var c, d, e, f, g, h;
                            if (b) {
                                f = b.a.length;
                                c = new vue(f);
                                for(h = (c.b - c.a) * c.c < 0 ? (uue(), tue) : new Rue(c); h.Ob();){
                                    g = RD(h.Pb(), 17);
                                    e = xDd(b, g.a);
                                    d = new aFd(a);
                                    $Dd(d.a, e);
                                }
                            }
                        }
                        function oEd(a, b) {
                            var c, d, e, f, g, h;
                            if (b) {
                                f = b.a.length;
                                c = new vue(f);
                                for(h = (c.b - c.a) * c.c < 0 ? (uue(), tue) : new Rue(c); h.Ob();){
                                    g = RD(h.Pb(), 17);
                                    e = xDd(b, g.a);
                                    d = new LEd(a);
                                    NDd(d.a, e);
                                }
                            }
                        }
                        function ESd(b) {
                            var c;
                            if (b != null && b.length > 0 && ihb(b, b.length - 1) == 33) try {
                                c = nSd(zhb(b, 0, b.length - 1));
                                return c.e == null;
                            } catch (a) {
                                a = zdb(a);
                                if (!ZD(a, 33)) throw Adb(a);
                            }
                            return false;
                        }
                        function u0b(a, b, c) {
                            var d, e, f;
                            d = Y2b(b);
                            e = i2b(d);
                            f = new R3b;
                            P3b(f, b);
                            switch(c.g){
                                case 1:
                                    Q3b(f, spd(vpd(e)));
                                    break;
                                case 2:
                                    Q3b(f, vpd(e));
                            }
                            pQb(f, (yCc(), ABc), UD(mQb(a, ABc)));
                            return f;
                        }
                        function jdc(a) {
                            var b, c;
                            b = RD(hs(new is(Mr(Z2b(a.a).a.Kc(), new ir))), 18);
                            c = RD(hs(new is(Mr(a3b(a.a).a.Kc(), new ir))), 18);
                            return Heb(TD(mQb(b, (Ywc(), Nwc)))) || Heb(TD(mQb(c, Nwc)));
                        }
                        function Bnc() {
                            Bnc = geb;
                            xnc = new Cnc('ONE_SIDE', 0);
                            znc = new Cnc('TWO_SIDES_CORNER', 1);
                            Anc = new Cnc('TWO_SIDES_OPPOSING', 2);
                            ync = new Cnc('THREE_SIDES', 3);
                            wnc = new Cnc('FOUR_SIDES', 4);
                        }
                        function Usc(a, b) {
                            var c, d, e, f;
                            f = new bnb;
                            e = 0;
                            d = b.Kc();
                            while(d.Ob()){
                                c = sgb(RD(d.Pb(), 17).a + e);
                                while(c.a < a.f && !wsc(a, c.a)){
                                    c = sgb(c.a + 1);
                                    ++e;
                                }
                                if (c.a >= a.f) break;
                                ZEb(f.c, c);
                            }
                            return f;
                        }
                        function iIc(a, b) {
                            var c, d, e, f, g;
                            for(f = new Anb(b.a); f.a < f.c.c.length;){
                                e = RD(ynb(f), 10);
                                for(d = new is(Mr(Z2b(e).a.Kc(), new ir)); gs(d);){
                                    c = RD(hs(d), 18);
                                    g = c.c.i.p;
                                    a.n[g] = a.n[g] - 1;
                                }
                            }
                        }
                        function fOc(a) {
                            var b, c;
                            for(c = new Anb(a.e.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 30);
                                wOc(a, b);
                            }
                            FDb(CDb(EDb(EDb(new SDb(null, new Swb(a.e.b, 16)), new wPc), new TPc), new VPc), new XPc(a));
                        }
                        function oKd(a, b) {
                            if (!b) return false;
                            else {
                                if (a.mj(b)) return false;
                                if (!a.i) {
                                    if (ZD(b, 152)) {
                                        a.i = RD(b, 152);
                                        return true;
                                    } else {
                                        a.i = new fLd;
                                        return a.i.nj(b);
                                    }
                                } else return a.i.nj(b);
                            }
                        }
                        function Hge(a, b, c) {
                            var d, e, f;
                            d = b.Lk();
                            f = b.md();
                            e = d.Jk() ? fge(a, 3, d, null, f, kge(a, d, f, ZD(d, 102) && (RD(d, 19).Bb & txe) != 0), true) : fge(a, 1, d, d.ik(), f, -1, true);
                            c ? c.nj(e) : c = e;
                            return c;
                        }
                        function $me(a) {
                            a = nue(a, true);
                            if (lhb(FGe, a) || lhb('1', a)) return Geb(), Feb;
                            else if (lhb(GGe, a) || lhb('0', a)) return Geb(), Eeb;
                            throw Adb(new Mle("Invalid boolean value: '" + a + "'"));
                        }
                        function Kd(a, b, c) {
                            var d, e, f;
                            for(e = a.vc().Kc(); e.Ob();){
                                d = RD(e.Pb(), 44);
                                f = d.ld();
                                if (dE(b) === dE(f) || b != null && pb(b, f)) {
                                    if (c) {
                                        d = new xlb(d.ld(), d.md());
                                        e.Qb();
                                    }
                                    return d;
                                }
                            }
                            return null;
                        }
                        function WMb(a) {
                            RMb();
                            var b, c, d;
                            if (!a.B.Hc((dqd(), Xpd))) return;
                            d = a.f.i;
                            b = new Vid(a.a.c);
                            c = new z3b;
                            c.b = b.c - d.c;
                            c.d = b.d - d.d;
                            c.c = d.c + d.b - (b.c + b.b);
                            c.a = d.d + d.a - (b.d + b.a);
                            a.e.$f(c);
                        }
                        function CQb(a, b, c, d) {
                            var e, f, g;
                            g = $wnd.Math.min(c, FQb(RD(a.b, 68), b, c, d));
                            for(f = new Anb(a.a); f.a < f.c.c.length;){
                                e = RD(ynb(f), 225);
                                e != b && (g = $wnd.Math.min(g, CQb(e, b, g, d)));
                            }
                            return g;
                        }
                        function c1b(a) {
                            var b, c, d, e;
                            e = $C(jR, Nve, 199, a.b.c.length, 0, 2);
                            d = new Jkb(a.b, 0);
                            while(d.b < d.d.gc()){
                                b = (sFb(d.b < d.d.gc()), RD(d.d.Xb(d.c = d.b++), 30));
                                c = d.b - 1;
                                e[c] = t2b(b.a);
                            }
                            return e;
                        }
                        function c6b(a, b, c) {
                            var d, e, f;
                            d = RD(cub(a.a, c), 34);
                            if (d != null) {
                                f = RD(cub(a.b, d), 67);
                                ze(f, c, true);
                            }
                            e = RD(cub(a.b, b), 67);
                            if (!e) {
                                e = new Yub;
                                dub(a.b, b, e);
                            }
                            Pub(e, c, e.c.b, e.c);
                            dub(a.a, c, b);
                        }
                        function _6b(a, b, c, d, e) {
                            var f, g, h, i;
                            g = XNb(WNb(_Nb(Y6b(c)), d), T6b(a, c, e));
                            for(i = e3b(a, c).Kc(); i.Ob();){
                                h = RD(i.Pb(), 12);
                                if (b[h.p]) {
                                    f = b[h.p].i;
                                    Rmb(g.d, new sOb(f, UNb(g, f)));
                                }
                            }
                            VNb(g);
                        }
                        function Ylc(a, b) {
                            this.f = new Tsb;
                            this.b = new Tsb;
                            this.j = new Tsb;
                            this.a = a;
                            this.c = b;
                            this.c > 0 && Xlc(this, this.c - 1, (qpd(), Xod));
                            this.c < this.a.length - 1 && Xlc(this, this.c + 1, (qpd(), ppd));
                        }
                        function Iqc(a, b) {
                            var c, d, e, f, g;
                            for(f = new Anb(b.d); f.a < f.c.c.length;){
                                e = RD(ynb(f), 105);
                                g = RD(Wjb(a.c, e), 118).o;
                                for(d = new Osb(e.b); d.a < d.c.a.length;){
                                    c = RD(Nsb(d), 64);
                                    Umc(e, c, g);
                                }
                            }
                        }
                        function qJc(a) {
                            a.length > 0 && a[0].length > 0 && (this.c = Heb(TD(mQb(Y2b(a[0][0]), (Ywc(), rwc)))));
                            this.a = $C(aY, Nve, 2117, a.length, 0, 2);
                            this.b = $C(dY, Nve, 2118, a.length, 0, 2);
                            this.d = new Ks;
                        }
                        function TOc(a) {
                            if (a.c.length == 0) return false;
                            if ((tFb(0, a.c.length), RD(a.c[0], 18)).c.i.k == (r3b(), o3b)) return true;
                            return yDb(GDb(new SDb(null, new Swb(a, 16)), new WOc), new YOc);
                        }
                        function I5c(a, b) {
                            var c, d, e, f, g, h, i;
                            h = Q2c(b);
                            f = b.f;
                            i = b.g;
                            g = $wnd.Math.sqrt(f * f + i * i);
                            e = 0;
                            for(d = new Anb(h); d.a < d.c.c.length;){
                                c = RD(ynb(d), 27);
                                e += I5c(a, c);
                            }
                            return $wnd.Math.max(e, g);
                        }
                        function Bod() {
                            Bod = geb;
                            Aod = new Eod(Sye, 0);
                            zod = new Eod('FREE', 1);
                            yod = new Eod('FIXED_SIDE', 2);
                            vod = new Eod('FIXED_ORDER', 3);
                            xod = new Eod('FIXED_RATIO', 4);
                            wod = new Eod('FIXED_POS', 5);
                        }
                        function Cee(a, b) {
                            var c, d, e;
                            c = b.qi(a.a);
                            if (c) {
                                e = WD($Nd((!c.b && (c.b = new SVd((JTd(), FTd), C8, c)), c.b), bLe));
                                for(d = 1; d < (lke(), kke).length; ++d){
                                    if (lhb(kke[d], e)) return d;
                                }
                            }
                            return 0;
                        }
                        function aob(a) {
                            var b, c, d, e, f;
                            if (a == null) return vve;
                            f = new Jyb(pve, '[', ']');
                            for(c = a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                Gyb(f, '' + b);
                            }
                            return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
                        }
                        function gob(a) {
                            var b, c, d, e, f;
                            if (a == null) return vve;
                            f = new Jyb(pve, '[', ']');
                            for(c = a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                Gyb(f, '' + b);
                            }
                            return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
                        }
                        function Md(a) {
                            var b, c, d;
                            d = new Jyb(pve, '{', '}');
                            for(c = a.vc().Kc(); c.Ob();){
                                b = RD(c.Pb(), 44);
                                Gyb(d, Nd(a, b.ld()) + '=' + Nd(a, b.md()));
                            }
                            return !d.a ? d.c : d.e.length == 0 ? d.a.a : d.a.a + ('' + d.e);
                        }
                        function vJb(a) {
                            var b, c, d, e;
                            while(!nmb(a.o)){
                                c = RD(smb(a.o), 42);
                                d = RD(c.a, 125);
                                b = RD(c.b, 218);
                                e = oIb(b, d);
                                if (b.e == d) {
                                    EIb(e.g, b);
                                    d.e = e.e + b.a;
                                } else {
                                    EIb(e.b, b);
                                    d.e = e.e - b.a;
                                }
                                Rmb(a.e.a, d);
                            }
                        }
                        function W9b(a, b) {
                            var c, d, e;
                            c = null;
                            for(e = RD(b.Kb(a), 20).Kc(); e.Ob();){
                                d = RD(e.Pb(), 18);
                                if (!c) c = d.c.i == a ? d.d.i : d.c.i;
                                else {
                                    if ((d.c.i == a ? d.d.i : d.c.i) != c) return false;
                                }
                            }
                            return true;
                        }
                        function UTc(a, b) {
                            var c, d, e, f, g;
                            c = uSc(a, false, b);
                            for(e = new Anb(c); e.a < e.c.c.length;){
                                d = RD(ynb(e), 132);
                                d.d == 0 ? (_Sc(d, null), aTc(d, null)) : (f = d.a, g = d.b, _Sc(d, g), aTc(d, f), undefined);
                            }
                        }
                        function QUc(a) {
                            var b, c;
                            b = new ufd;
                            ofd(b, CUc);
                            c = RD(mQb(a, (Ywc(), kwc)), 21);
                            c.Hc((ovc(), nvc)) && ofd(b, GUc);
                            c.Hc(evc) && ofd(b, DUc);
                            c.Hc(lvc) && ofd(b, FUc);
                            c.Hc(gvc) && ofd(b, EUc);
                            return b;
                        }
                        function iz(a, b, c) {
                            var d, e, f, g, h;
                            String.fromCharCode(10);
                            jz(a);
                            for(e = (a.k == null && (a.k = $C(rJ, Nve, 82, 0, 0, 1)), a.k), f = 0, g = e.length; f < g; ++f){
                                d = e[f];
                                iz(d, b, '\t' + c);
                            }
                            h = a.f;
                            !!h && iz(h, b, c);
                        }
                        function kec(a) {
                            var b, c, d, e;
                            jec(a);
                            for(c = new is(Mr(W2b(a).a.Kc(), new ir)); gs(c);){
                                b = RD(hs(c), 18);
                                d = b.c.i == a;
                                e = d ? b.d : b.c;
                                d ? Z0b(b, null) : Y0b(b, null);
                                pQb(b, (Ywc(), Ewc), e);
                                oec(a, e.i);
                            }
                        }
                        function aqc(a, b, c, d) {
                            var e, f;
                            f = b.i;
                            e = c[f.g][a.d[f.g]];
                            switch(f.g){
                                case 1:
                                    e -= d + b.j.b;
                                    b.g.b = e;
                                    break;
                                case 3:
                                    e += d;
                                    b.g.b = e;
                                    break;
                                case 4:
                                    e -= d + b.j.a;
                                    b.g.a = e;
                                    break;
                                case 2:
                                    e += d;
                                    b.g.a = e;
                            }
                        }
                        function K2c(a) {
                            var b, c, d;
                            for(c = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); c.e != c.i.gc();){
                                b = RD(bMd(c), 27);
                                d = yGd(b);
                                if (!gs(new is(Mr(d.a.Kc(), new ir)))) return b;
                            }
                            return null;
                        }
                        function g3c() {
                            g3c = geb;
                            e3c = new h3c('OVERLAP_REMOVAL', 0);
                            b3c = new h3c(iFe, 1);
                            f3c = new h3c('ROTATION', 2);
                            c3c = new h3c('GRAPH_SIZE_CALCULATION', 3);
                            d3c = new h3c('OUTGOING_EDGE_ANGLES', 4);
                        }
                        function aCd() {
                            var a;
                            if (YBd) return RD(N5d((YSd(), XSd), $He), 2115);
                            a = RD(ZD(Xjb((YSd(), XSd), $He), 569) ? Xjb(XSd, $He) : new _Bd, 569);
                            YBd = true;
                            ZBd(a);
                            $Bd(a);
                            rBd(a);
                            $jb(XSd, $He, a);
                            return a;
                        }
                        function Tge(a, b, c) {
                            var d, e;
                            if (a.j == 0) return c;
                            e = RD(jZd(a, b, c), 76);
                            d = c.Lk();
                            if (!d.rk() || !a.a.am(d)) throw Adb(new yz("Invalid entry feature '" + d.qk().zb + '.' + d.xe() + "'"));
                            return e;
                        }
                        function Yi(a, b) {
                            var c, d, e, f, g, h, i, j;
                            for(h = a.a, i = 0, j = h.length; i < j; ++i){
                                g = h[i];
                                for(d = g, e = 0, f = d.length; e < f; ++e){
                                    c = d[e];
                                    if (dE(b) === dE(c) || b != null && pb(b, c)) return true;
                                }
                            }
                            return false;
                        }
                        function yjb(a) {
                            var b, c, d;
                            if (Ddb(a, 0) >= 0) {
                                c = Fdb(a, ixe);
                                d = Mdb(a, ixe);
                            } else {
                                b = Udb(a, 1);
                                c = Fdb(b, 500000000);
                                d = Mdb(b, 500000000);
                                d = Bdb(Sdb(d, 1), Cdb(a, 1));
                            }
                            return Rdb(Sdb(d, 32), Cdb(c, yxe));
                        }
                        function fTb(a, b, c) {
                            var d, e;
                            d = (sFb(b.b != 0), RD(Wub(b, b.a.a), 8));
                            switch(c.g){
                                case 0:
                                    d.b = 0;
                                    break;
                                case 2:
                                    d.b = a.f;
                                    break;
                                case 3:
                                    d.a = 0;
                                    break;
                                default:
                                    d.a = a.g;
                            }
                            e = Sub(b, 0);
                            cvb(e, d);
                            return b;
                        }
                        function Vpc(a, b, c, d) {
                            var e, f, g, h, i;
                            i = a.b;
                            f = b.d;
                            g = f.j;
                            h = $pc(g, i.d[g.g], c);
                            e = $id(ajd(f.n), f.a);
                            switch(f.j.g){
                                case 1:
                                case 3:
                                    h.a += e.a;
                                    break;
                                case 2:
                                case 4:
                                    h.b += e.b;
                            }
                            Pub(d, h, d.c.b, d.c);
                        }
                        function YNc(a, b, c) {
                            var d, e, f, g;
                            g = Wmb(a.e, b, 0);
                            f = new ZNc;
                            f.b = c;
                            d = new Jkb(a.e, g);
                            while(d.b < d.d.gc()){
                                e = (sFb(d.b < d.d.gc()), RD(d.d.Xb(d.c = d.b++), 10));
                                e.p = c;
                                Rmb(f.e, e);
                                Ckb(d);
                            }
                            return f;
                        }
                        function l8c(a, b, c, d) {
                            var e, f, g, h, i;
                            e = null;
                            f = 0;
                            for(h = new Anb(b); h.a < h.c.c.length;){
                                g = RD(ynb(h), 27);
                                i = g.i + g.g;
                                if (a < g.j + g.f + d) {
                                    !e ? e = g : c.i - i < c.i - f && (e = g);
                                    f = e.i + e.g;
                                }
                            }
                            return !e ? 0 : f + d;
                        }
                        function m8c(a, b, c, d) {
                            var e, f, g, h, i;
                            f = null;
                            e = 0;
                            for(h = new Anb(b); h.a < h.c.c.length;){
                                g = RD(ynb(h), 27);
                                i = g.j + g.f;
                                if (a < g.i + g.g + d) {
                                    !f ? f = g : c.j - i < c.j - e && (f = g);
                                    e = f.j + f.f;
                                }
                            }
                            return !f ? 0 : e + d;
                        }
                        function CA(a) {
                            var b, c, d;
                            b = false;
                            d = a.b.c.length;
                            for(c = 0; c < d; c++){
                                if (DA(RD(Vmb(a.b, c), 443))) {
                                    if (!b && c + 1 < d && DA(RD(Vmb(a.b, c + 1), 443))) {
                                        b = true;
                                        RD(Vmb(a.b, c), 443).a = true;
                                    }
                                } else b = false;
                            }
                        }
                        function Ijb(a, b, c, d, e) {
                            var f, g;
                            f = 0;
                            for(g = 0; g < e; g++){
                                f = Bdb(f, Vdb(Cdb(b[g], yxe), Cdb(d[g], yxe)));
                                a[g] = Ydb(f);
                                f = Tdb(f, 32);
                            }
                            for(; g < c; g++){
                                f = Bdb(f, Cdb(b[g], yxe));
                                a[g] = Ydb(f);
                                f = Tdb(f, 32);
                            }
                        }
                        function Rjb(a, b) {
                            Ljb();
                            var c, d;
                            d = (Pib(), Kib);
                            c = a;
                            for(; b > 1; b >>= 1){
                                (b & 1) != 0 && (d = Wib(d, c));
                                c.d == 1 ? c = Wib(c, c) : c = new djb(Tjb(c.a, c.d, $C(kE, Pwe, 28, c.d << 1, 15, 1)));
                            }
                            d = Wib(d, c);
                            return d;
                        }
                        function Hwb() {
                            Hwb = geb;
                            var a, b, c, d;
                            Ewb = $C(iE, vxe, 28, 25, 15, 1);
                            Fwb = $C(iE, vxe, 28, 33, 15, 1);
                            d = 1.52587890625E-5;
                            for(b = 32; b >= 0; b--){
                                Fwb[b] = d;
                                d *= 0.5;
                            }
                            c = 1;
                            for(a = 24; a >= 0; a--){
                                Ewb[a] = c;
                                c *= 0.5;
                            }
                        }
                        function a5b(a) {
                            var b, c;
                            if (Heb(TD(Gxd(a, (yCc(), NAc))))) for(c = new is(Mr(zGd(a).a.Kc(), new ir)); gs(c);){
                                b = RD(hs(c), 74);
                                if (ozd(b)) {
                                    if (Heb(TD(Gxd(b, OAc)))) return true;
                                }
                            }
                            return false;
                        }
                        function Qmc(a, b) {
                            var c, d, e;
                            if (Ysb(a.f, b)) {
                                b.b = a;
                                d = b.c;
                                Wmb(a.j, d, 0) != -1 || Rmb(a.j, d);
                                e = b.d;
                                Wmb(a.j, e, 0) != -1 || Rmb(a.j, e);
                                c = b.a.b;
                                if (c.c.length != 0) {
                                    !a.i && (a.i = new _mc(a));
                                    Wmc(a.i, c);
                                }
                            }
                        }
                        function Xpc(a) {
                            var b, c, d, e, f;
                            c = a.c.d;
                            d = c.j;
                            e = a.d.d;
                            f = e.j;
                            if (d == f) return c.p < e.p ? 0 : 1;
                            else if (tpd(d) == f) return 0;
                            else if (rpd(d) == f) return 1;
                            else {
                                b = a.b;
                                return Csb(b.b, tpd(d)) ? 0 : 1;
                            }
                        }
                        function Pfd(a) {
                            var b;
                            this.d = new Tsb;
                            this.c = a.c;
                            this.e = a.d;
                            this.b = a.b;
                            this.f = new ntd(a.e);
                            this.a = a.a;
                            !a.f ? this.g = (b = RD(mfb(T5), 9), new Fsb(b, RD(WEb(b, b.length), 9), 0)) : this.g = a.f;
                        }
                        function GEd(a, b) {
                            var c, d, e, f, g, h;
                            e = a;
                            g = yDd(e, 'layoutOptions');
                            !g && (g = yDd(e, cIe));
                            if (g) {
                                h = g;
                                d = null;
                                !!h && (d = (f = oC(h, $C(qJ, Nve, 2, 0, 6, 1)), new CC(h, f)));
                                if (d) {
                                    c = new bFd(h, b);
                                    xgb(d, c);
                                }
                            }
                        }
                        function AGd(a) {
                            if (ZD(a, 207)) return RD(a, 27);
                            else if (ZD(a, 193)) return MCd(RD(a, 123));
                            else if (!a) throw Adb(new Ogb(HIe));
                            else throw Adb(new kib('Only support nodes and ports.'));
                        }
                        function SA(a, b, c, d) {
                            if (b >= 0 && lhb(a.substr(b, 3), 'GMT')) {
                                c[0] = b + 3;
                                return JA(a, c, d);
                            }
                            if (b >= 0 && lhb(a.substr(b, 3), 'UTC')) {
                                c[0] = b + 3;
                                return JA(a, c, d);
                            }
                            return JA(a, c, d);
                        }
                        function Zmc(a, b) {
                            var c, d, e, f, g;
                            f = a.g.a;
                            g = a.g.b;
                            for(d = new Anb(a.d); d.a < d.c.c.length;){
                                c = RD(ynb(d), 72);
                                e = c.n;
                                e.a = f;
                                a.i == (qpd(), Yod) ? e.b = g + a.j.b - c.o.b : e.b = g;
                                $id(e, b);
                                f += c.o.a + a.e;
                            }
                        }
                        function Fqd(a, b, c) {
                            if (a.b) throw Adb(new dgb('The task is already done.'));
                            else if (a.p != null) return false;
                            else {
                                a.p = b;
                                a.r = c;
                                a.k && (a.o = (gib(), Ndb(Hdb(Date.now()), Awe)));
                                return true;
                            }
                        }
                        function HFd(a) {
                            var b, c, d, e, f, g, h;
                            h = new uC;
                            c = a.Pg();
                            e = c != null;
                            e && sDd(h, uIe, a.Pg());
                            d = a.xe();
                            f = d != null;
                            f && sDd(h, GIe, a.xe());
                            b = a.Og();
                            g = b != null;
                            g && sDd(h, 'description', a.Og());
                            return h;
                        }
                        function UVd(a, b, c) {
                            var d, e, f;
                            f = a.q;
                            a.q = b;
                            if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
                                e = new N3d(a, 1, 9, f, b);
                                !c ? c = e : c.nj(e);
                            }
                            if (!b) !!a.r && (c = a.Yk(null, c));
                            else {
                                d = b.c;
                                d != a.r && (c = a.Yk(d, c));
                            }
                            return c;
                        }
                        function gae(a, b, c) {
                            var d, e, f, g, h;
                            c = (h = b, Ivd(h, a.e, -1 - a.c, c));
                            g = $9d(a.a);
                            for(f = (d = new vkb(new mkb(g.a).a), new xae(d)); f.a.b;){
                                e = RD(tkb(f.a).ld(), 89);
                                c = o2d(e, k2d(e, a.a), c);
                            }
                            return c;
                        }
                        function hae(a, b, c) {
                            var d, e, f, g, h;
                            c = (h = b, Jvd(h, a.e, -1 - a.c, c));
                            g = $9d(a.a);
                            for(f = (d = new vkb(new mkb(g.a).a), new xae(d)); f.a.b;){
                                e = RD(tkb(f.a).ld(), 89);
                                c = o2d(e, k2d(e, a.a), c);
                            }
                            return c;
                        }
                        function rjb(a, b, c, d) {
                            var e, f, g;
                            if (d == 0) hib(b, 0, a, c, a.length - c);
                            else {
                                g = 32 - d;
                                a[a.length - 1] = 0;
                                for(f = a.length - 1; f > c; f--){
                                    a[f] |= b[f - c - 1] >>> g;
                                    a[f - 1] = b[f - c - 1] << d;
                                }
                            }
                            for(e = 0; e < c; e++)a[e] = 0;
                        }
                        function CMb(a) {
                            var b, c, d, e, f;
                            b = 0;
                            c = 0;
                            for(f = a.Kc(); f.Ob();){
                                d = RD(f.Pb(), 117);
                                b = $wnd.Math.max(b, d.d.b);
                                c = $wnd.Math.max(c, d.d.c);
                            }
                            for(e = a.Kc(); e.Ob();){
                                d = RD(e.Pb(), 117);
                                d.d.b = b;
                                d.d.c = c;
                            }
                        }
                        function KNb(a) {
                            var b, c, d, e, f;
                            c = 0;
                            b = 0;
                            for(f = a.Kc(); f.Ob();){
                                d = RD(f.Pb(), 117);
                                c = $wnd.Math.max(c, d.d.d);
                                b = $wnd.Math.max(b, d.d.a);
                            }
                            for(e = a.Kc(); e.Ob();){
                                d = RD(e.Pb(), 117);
                                d.d.d = c;
                                d.d.a = b;
                            }
                        }
                        function Pnc(a, b, c, d, e) {
                            var f, g;
                            f = RD(zDb(CDb(b.Oc(), new Foc), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), vBb)
                            ]))), 15);
                            Eob(f);
                            g = RD($i(a.b, c, d), 15);
                            e == 0 ? g.cd(0, f) : g.Gc(f);
                        }
                        function Sdd(a, b, c) {
                            c.Ug('Grow Tree', 1);
                            a.b = b.f;
                            if (Heb(TD(mQb(b, (OQb(), MQb))))) {
                                a.c = new kRb;
                                Odd(a, null);
                            } else a.c = new kRb;
                            a.a = false;
                            Qdd(a, b.f);
                            pQb(b, NQb, (Geb(), a.a ? true : false));
                            c.Vg();
                        }
                        function wsd(a) {
                            var b, c, d, e;
                            b = null;
                            for(e = new Anb(a.Rf()); e.a < e.c.c.length;){
                                d = RD(ynb(e), 187);
                                c = new Uid(d.Lf().a, d.Lf().b, d.Mf().a, d.Mf().b);
                                !b ? b = c : Sid(b, c);
                            }
                            !b && (b = new Tid);
                            return b;
                        }
                        function dyd(a, b, c, d) {
                            var e, f;
                            if (c == 1) return !a.n && (a.n = new C5d(I4, a, 1, 7)), qLd(a.n, b, d);
                            return f = RD(vYd((e = RD(Ywd(a, 16), 29), !e ? a.ii() : e), c), 69), f.wk().zk(a, Wwd(a), c - AYd(a.ii()), b, d);
                        }
                        function IHd(a, b, c) {
                            var d, e, f, g, h;
                            d = c.gc();
                            a._i(a.i + d);
                            h = a.i - b;
                            h > 0 && hib(a.g, b, a.g, b + d, h);
                            g = c.Kc();
                            a.i += d;
                            for(e = 0; e < d; ++e){
                                f = g.Pb();
                                MHd(a, b, a.Zi(b, f));
                                a.Mi(b, f);
                                a.Ni();
                                ++b;
                            }
                            return d != 0;
                        }
                        function XVd(a, b, c) {
                            var d;
                            if (b != a.q) {
                                !!a.q && (c = Jvd(a.q, a, -10, c));
                                !!b && (c = Ivd(b, a, -10, c));
                                c = UVd(a, b, c);
                            } else if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
                                d = new N3d(a, 1, 9, b, b);
                                !c ? c = d : c.nj(d);
                            }
                            return c;
                        }
                        function ek(a, b, c, d) {
                            Mb((c & Ove) == 0, 'flatMap does not support SUBSIZED characteristic');
                            Mb((c & 4) == 0, 'flatMap does not support SORTED characteristic');
                            Qb(a);
                            Qb(b);
                            return new Mk(a, b, c, d);
                        }
                        function fz(a, b) {
                            vFb(b, 'Cannot suppress a null exception.');
                            mFb(b != a, 'Exception can not suppress itself.');
                            if (a.i) return;
                            a.k == null ? a.k = cD(WC(rJ, 1), Nve, 82, 0, [
                                b
                            ]) : a.k[a.k.length] = b;
                        }
                        function DLb(a, b) {
                            var c;
                            c = ELb(a.b.ag(), b.b.ag());
                            if (c != 0) return c;
                            switch(a.b.ag().g){
                                case 1:
                                case 2:
                                    return hgb(a.b.Nf(), b.b.Nf());
                                case 3:
                                case 4:
                                    return hgb(b.b.Nf(), a.b.Nf());
                            }
                            return 0;
                        }
                        function eUb(a) {
                            var b, c, d;
                            d = a.e.c.length;
                            a.a = YC(kE, [
                                Nve,
                                Pwe
                            ], [
                                53,
                                28
                            ], 15, [
                                d,
                                d
                            ], 2);
                            for(c = new Anb(a.c); c.a < c.c.c.length;){
                                b = RD(ynb(c), 290);
                                a.a[b.c.a][b.d.a] += RD(mQb(b, (yVb(), lVb)), 17).a;
                            }
                        }
                        function sAd(a, b) {
                            var c, d, e, f, g;
                            if (a == null) return null;
                            else {
                                g = $C(hE, zwe, 28, 2 * b, 15, 1);
                                for(d = 0, e = 0; d < b; ++d){
                                    c = a[d] >> 4 & 15;
                                    f = a[d] & 15;
                                    g[e++] = oAd[c];
                                    g[e++] = oAd[f];
                                }
                                return Ihb(g, 0, g.length);
                            }
                        }
                        function Fhb(a) {
                            var b, c;
                            if (a >= txe) {
                                b = uxe + (a - txe >> 10 & 1023) & Bwe;
                                c = 56320 + (a - txe & 1023) & Bwe;
                                return String.fromCharCode(b) + ('' + String.fromCharCode(c));
                            } else return String.fromCharCode(a & Bwe);
                        }
                        function UMb(a, b) {
                            RMb();
                            var c, d, e, f;
                            e = RD(RD(Qc(a.r, b), 21), 87);
                            if (e.gc() >= 2) {
                                d = RD(e.Kc().Pb(), 117);
                                c = a.u.Hc((Pod(), Kod));
                                f = a.u.Hc(Ood);
                                return !d.a && !c && (e.gc() == 2 || f);
                            } else return false;
                        }
                        function v3c(a, b, c, d, e) {
                            var f, g, h;
                            f = w3c(a, b, c, d, e);
                            h = false;
                            while(!f){
                                n3c(a, e, true);
                                h = true;
                                f = w3c(a, b, c, d, e);
                            }
                            h && n3c(a, e, false);
                            g = N2c(e);
                            if (g.c.length != 0) {
                                !!a.d && a.d.Gg(g);
                                v3c(a, e, c, d, g);
                            }
                        }
                        function ind() {
                            ind = geb;
                            gnd = new jnd(LAe, 0);
                            end = new jnd('DIRECTED', 1);
                            hnd = new jnd('UNDIRECTED', 2);
                            cnd = new jnd('ASSOCIATION', 3);
                            fnd = new jnd('GENERALIZATION', 4);
                            dnd = new jnd('DEPENDENCY', 5);
                        }
                        function nsd(a, b) {
                            var c;
                            if (!MCd(a)) throw Adb(new dgb(sHe));
                            c = MCd(a);
                            switch(b.g){
                                case 1:
                                    return -(a.j + a.f);
                                case 2:
                                    return a.i - c.g;
                                case 3:
                                    return a.j - c.f;
                                case 4:
                                    return -(a.i + a.g);
                            }
                            return 0;
                        }
                        function Jge(a, b, c) {
                            var d, e, f;
                            d = b.Lk();
                            f = b.md();
                            e = d.Jk() ? fge(a, 4, d, f, null, kge(a, d, f, ZD(d, 102) && (RD(d, 19).Bb & txe) != 0), true) : fge(a, d.tk() ? 2 : 1, d, f, d.ik(), -1, true);
                            c ? c.nj(e) : c = e;
                            return c;
                        }
                        function lwb(a, b) {
                            var c, d;
                            uFb(b);
                            d = a.b.c.length;
                            Rmb(a.b, b);
                            while(d > 0){
                                c = d;
                                d = (d - 1) / 2 | 0;
                                if (a.a.Ne(Vmb(a.b, d), b) <= 0) {
                                    $mb(a.b, c, b);
                                    return true;
                                }
                                $mb(a.b, c, Vmb(a.b, d));
                            }
                            $mb(a.b, d, b);
                            return true;
                        }
                        function sKb(a, b, c, d) {
                            var e, f;
                            e = 0;
                            if (!c) for(f = 0; f < jKb; f++)e = $wnd.Math.max(e, hKb(a.a[f][b.g], d));
                            else e = hKb(a.a[c.g][b.g], d);
                            b == (ZJb(), XJb) && !!a.b && (e = $wnd.Math.max(e, a.b.a));
                            return e;
                        }
                        function Qqc(a, b) {
                            var c, d, e, f, g, h;
                            e = a.i;
                            f = b.i;
                            if (!e || !f) return false;
                            if (e.i != f.i || e.i == (qpd(), Xod) || e.i == (qpd(), ppd)) return false;
                            g = e.g.a;
                            c = g + e.j.a;
                            h = f.g.a;
                            d = h + f.j.a;
                            return g <= d && c >= h;
                        }
                        function A8c(a) {
                            switch(a.g){
                                case 0:
                                    return new o8c;
                                case 1:
                                    return new u8c;
                                default:
                                    throw Adb(new agb('No implementation is available for the width approximator ' + (a.f != null ? a.f : '' + a.g)));
                            }
                        }
                        function rDd(a, b, c, d) {
                            var e;
                            e = false;
                            if (bE(d)) {
                                e = true;
                                sDd(b, c, WD(d));
                            }
                            if (!e) {
                                if ($D(d)) {
                                    e = true;
                                    rDd(a, b, c, d);
                                }
                            }
                            if (!e) {
                                if (ZD(d, 242)) {
                                    e = true;
                                    qDd(b, c, RD(d, 242));
                                }
                            }
                            if (!e) throw Adb(new Aeb(tIe));
                        }
                        function uee(a, b) {
                            var c, d, e;
                            c = b.qi(a.a);
                            if (c) {
                                e = $Nd((!c.b && (c.b = new SVd((JTd(), FTd), C8, c)), c.b), rKe);
                                if (e != null) for(d = 1; d < (lke(), hke).length; ++d){
                                    if (lhb(hke[d], e)) return d;
                                }
                            }
                            return 0;
                        }
                        function vee(a, b) {
                            var c, d, e;
                            c = b.qi(a.a);
                            if (c) {
                                e = $Nd((!c.b && (c.b = new SVd((JTd(), FTd), C8, c)), c.b), rKe);
                                if (e != null) for(d = 1; d < (lke(), ike).length; ++d){
                                    if (lhb(ike[d], e)) return d;
                                }
                            }
                            return 0;
                        }
                        function Ve(a, b) {
                            var c, d, e, f;
                            uFb(b);
                            f = a.a.gc();
                            if (f < b.gc()) for(c = a.a.ec().Kc(); c.Ob();){
                                d = c.Pb();
                                b.Hc(d) && c.Qb();
                            }
                            else for(e = b.Kc(); e.Ob();){
                                d = e.Pb();
                                a.a.Bc(d);
                            }
                            return f != a.a.gc();
                        }
                        function e_b(a) {
                            var b, c;
                            c = ajd(xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                a.i.n,
                                a.n,
                                a.a
                            ])));
                            b = a.i.d;
                            switch(a.j.g){
                                case 1:
                                    c.b -= b.d;
                                    break;
                                case 2:
                                    c.a += b.c;
                                    break;
                                case 3:
                                    c.b += b.a;
                                    break;
                                case 4:
                                    c.a -= b.b;
                            }
                            return c;
                        }
                        function edc(a) {
                            var b;
                            b = (Zcc(), RD(hs(new is(Mr(Z2b(a).a.Kc(), new ir))), 18).c.i);
                            while(b.k == (r3b(), o3b)){
                                pQb(b, (Ywc(), twc), (Geb(), true));
                                b = RD(hs(new is(Mr(Z2b(b).a.Kc(), new ir))), 18).c.i;
                            }
                        }
                        function BMc(a, b, c, d) {
                            var e, f, g, h;
                            h = aMc(b, d);
                            for(g = h.Kc(); g.Ob();){
                                e = RD(g.Pb(), 12);
                                a.d[e.p] = a.d[e.p] + a.c[c.p];
                            }
                            h = aMc(c, d);
                            for(f = h.Kc(); f.Ob();){
                                e = RD(f.Pb(), 12);
                                a.d[e.p] = a.d[e.p] - a.c[b.p];
                            }
                        }
                        function Isd(a, b, c) {
                            var d, e;
                            for(e = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); e.e != e.i.gc();){
                                d = RD(bMd(e), 27);
                                Byd(d, d.i + b, d.j + c);
                            }
                            xgb((!a.b && (a.b = new C5d(G4, a, 12, 3)), a.b), new Osd(b, c));
                        }
                        function $yb(a, b, c, d) {
                            var e, f;
                            f = b;
                            e = f.d == null || a.a.Ne(c.d, f.d) > 0 ? 1 : 0;
                            while(f.a[e] != c){
                                f = f.a[e];
                                e = a.a.Ne(c.d, f.d) > 0 ? 1 : 0;
                            }
                            f.a[e] = d;
                            d.b = c.b;
                            d.a[0] = c.a[0];
                            d.a[1] = c.a[1];
                            c.a[0] = null;
                            c.a[1] = null;
                        }
                        function zIb(a) {
                            var b, c, d, e;
                            b = new bnb;
                            c = $C(xdb, Hye, 28, a.a.c.length, 16, 1);
                            Snb(c, c.length);
                            for(e = new Anb(a.a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 125);
                                if (!c[d.d]) {
                                    ZEb(b.c, d);
                                    yIb(a, d, c);
                                }
                            }
                            return b;
                        }
                        function UXb(a, b) {
                            var c, d, e, f, g;
                            e = b == 1 ? MXb : LXb;
                            for(d = e.a.ec().Kc(); d.Ob();){
                                c = RD(d.Pb(), 88);
                                for(g = RD(Qc(a.f.c, c), 21).Kc(); g.Ob();){
                                    f = RD(g.Pb(), 42);
                                    Ymb(a.b.b, f.b);
                                    Ymb(a.b.a, RD(f.b, 86).d);
                                }
                            }
                        }
                        function P9b(a, b) {
                            var c;
                            b.Ug('Hierarchical port position processing', 1);
                            c = a.b;
                            c.c.length > 0 && O9b((tFb(0, c.c.length), RD(c.c[0], 30)), a);
                            c.c.length > 1 && O9b(RD(Vmb(c, c.c.length - 1), 30), a);
                            b.Vg();
                        }
                        function Sod(a) {
                            Pod();
                            var b, c;
                            b = ysb(Lod, cD(WC(D3, 1), jwe, 279, 0, [
                                Nod
                            ]));
                            if (dy(Tx(b, a)) > 1) return false;
                            c = ysb(Kod, cD(WC(D3, 1), jwe, 279, 0, [
                                Jod,
                                Ood
                            ]));
                            if (dy(Tx(c, a)) > 1) return false;
                            return true;
                        }
                        function FBd(a, b) {
                            var c;
                            c = Xjb((YSd(), XSd), a);
                            ZD(c, 507) ? $jb(XSd, a, new B5d(this, b)) : $jb(XSd, a, this);
                            BBd(this, b);
                            if (b == (jTd(), iTd)) {
                                this.wb = RD(this, 2038);
                                RD(b, 2040);
                            } else this.wb = (lTd(), kTd);
                        }
                        function Lae(b) {
                            var c, d, e;
                            if (b == null) return null;
                            c = null;
                            for(d = 0; d < nAd.length; ++d)try {
                                return b2d(nAd[d], b);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 33)) {
                                    e = a;
                                    c = e;
                                } else throw Adb(a);
                            }
                            throw Adb(new RSd(c));
                        }
                        function Mrb() {
                            Mrb = geb;
                            Krb = cD(WC(qJ, 1), Nve, 2, 6, [
                                'Sun',
                                'Mon',
                                'Tue',
                                'Wed',
                                'Thu',
                                'Fri',
                                'Sat'
                            ]);
                            Lrb = cD(WC(qJ, 1), Nve, 2, 6, [
                                'Jan',
                                'Feb',
                                'Mar',
                                'Apr',
                                Gwe,
                                'Jun',
                                'Jul',
                                'Aug',
                                'Sep',
                                'Oct',
                                'Nov',
                                'Dec'
                            ]);
                        }
                        function qBb(a) {
                            var b, c, d;
                            b = lhb(typeof b, Yxe) ? null : new gFb;
                            if (!b) return;
                            SAb();
                            c = (d = 900, d >= Awe ? 'error' : d >= 900 ? 'warn' : d >= 800 ? 'info' : 'log');
                            eFb(c, a.a);
                            !!a.b && fFb(b, c, a.b, 'Exception: ', true);
                        }
                        function mQb(a, b) {
                            var c, d;
                            d = (!a.q && (a.q = new Tsb), Wjb(a.q, b));
                            if (d != null) return d;
                            c = b.Sg();
                            ZD(c, 4) && (c == null ? (!a.q && (a.q = new Tsb), _jb(a.q, b)) : (!a.q && (a.q = new Tsb), Zjb(a.q, b, c)), a);
                            return c;
                        }
                        function sXb() {
                            sXb = geb;
                            nXb = new tXb('P1_CYCLE_BREAKING', 0);
                            oXb = new tXb('P2_LAYERING', 1);
                            pXb = new tXb('P3_NODE_ORDERING', 2);
                            qXb = new tXb('P4_NODE_PLACEMENT', 3);
                            rXb = new tXb('P5_EDGE_ROUTING', 4);
                        }
                        function KZb(a, b) {
                            CZb();
                            var c;
                            if (a.c == b.c) {
                                if (a.b == b.b || rZb(a.b, b.b)) {
                                    c = oZb(a.b) ? 1 : -1;
                                    if (a.a && !b.a) return c;
                                    else if (!a.a && b.a) return -c;
                                }
                                return hgb(a.b.g, b.b.g);
                            } else return Qfb(a.c, b.c);
                        }
                        function E3c(a, b) {
                            var c, d, e;
                            if (p3c(a, b)) return true;
                            for(d = new Anb(b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 27);
                                e = R2c(c);
                                if (o3c(a, c, e)) return true;
                                if (C3c(a, c) - a.g <= a.a) return true;
                            }
                            return false;
                        }
                        function ncd() {
                            ncd = geb;
                            mcd = (Kcd(), Jcd);
                            jcd = Fcd;
                            icd = Dcd;
                            gcd = zcd;
                            hcd = Bcd;
                            fcd = new A3b(8);
                            ecd = new mGd((umd(), tld), fcd);
                            kcd = new mGd(fmd, 8);
                            lcd = Hcd;
                            bcd = ucd;
                            ccd = wcd;
                            dcd = new mGd(Mkd, (Geb(), false));
                        }
                        function hkd() {
                            hkd = geb;
                            ekd = new A3b(15);
                            dkd = new mGd((umd(), tld), ekd);
                            gkd = new mGd(fmd, 15);
                            fkd = new mGd(Rld, sgb(0));
                            $jd = Wkd;
                            akd = kld;
                            ckd = pld;
                            Xjd = new mGd(Dkd, KGe);
                            _jd = ald;
                            bkd = nld;
                            Yjd = Fkd;
                            Zjd = Kkd;
                        }
                        function JGd(a) {
                            if ((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b).i != 1 || (!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c).i != 1) throw Adb(new agb(JIe));
                            return AGd(RD(QHd((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b), 0), 84));
                        }
                        function KGd(a) {
                            if ((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b).i != 1 || (!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c).i != 1) throw Adb(new agb(JIe));
                            return BGd(RD(QHd((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b), 0), 84));
                        }
                        function MGd(a) {
                            if ((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b).i != 1 || (!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c).i != 1) throw Adb(new agb(JIe));
                            return BGd(RD(QHd((!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c), 0), 84));
                        }
                        function LGd(a) {
                            if ((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b).i != 1 || (!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c).i != 1) throw Adb(new agb(JIe));
                            return AGd(RD(QHd((!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c), 0), 84));
                        }
                        function bJd(a, b, c) {
                            var d, e, f;
                            ++a.j;
                            e = a.Ej();
                            if (b >= e || b < 0) throw Adb(new veb(MIe + b + NIe + e));
                            if (c >= e || c < 0) throw Adb(new veb(OIe + c + NIe + e));
                            b != c ? d = (f = a.Cj(c), a.qj(b, f), f) : d = a.xj(c);
                            return d;
                        }
                        function Lje(a) {
                            var b, c, d;
                            d = a;
                            if (a) {
                                b = 0;
                                for(c = a.Eh(); c; c = c.Eh()){
                                    if (++b > wxe) return Lje(c);
                                    d = c;
                                    if (c == a) throw Adb(new dgb('There is a cycle in the containment hierarchy of ' + a));
                                }
                            }
                            return d;
                        }
                        function Fe(a) {
                            var b, c, d;
                            d = new Jyb(pve, '[', ']');
                            for(c = a.Kc(); c.Ob();){
                                b = c.Pb();
                                Gyb(d, dE(b) === dE(a) ? '(this Collection)' : b == null ? vve : jeb(b));
                            }
                            return !d.a ? d.c : d.e.length == 0 ? d.a.a : d.a.a + ('' + d.e);
                        }
                        function p3c(a, b) {
                            var c, d;
                            d = false;
                            if (b.gc() < 2) return false;
                            for(c = 0; c < b.gc(); c++)c < b.gc() - 1 ? d = d | o3c(a, RD(b.Xb(c), 27), RD(b.Xb(c + 1), 27)) : d = d | o3c(a, RD(b.Xb(c), 27), RD(b.Xb(0), 27));
                            return d;
                        }
                        function wAd(a, b) {
                            var c;
                            if (b != a.a) {
                                c = null;
                                !!a.a && (c = RD(a.a, 54).Th(a, 4, t7, c));
                                !!b && (c = RD(b, 54).Rh(a, 4, t7, c));
                                c = rAd(a, b, c);
                                !!c && c.oj();
                            } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 1, b, b));
                        }
                        function p2d(a, b) {
                            var c;
                            if (b != a.e) {
                                !!a.e && oae($9d(a.e), a);
                                !!b && (!b.b && (b.b = new pae(new lae)), nae(b.b, a));
                                c = f2d(a, b, null);
                                !!c && c.oj();
                            } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 4, b, b));
                        }
                        function $mc(a, b) {
                            var c;
                            c = b.o;
                            if (Dmd(a.f)) {
                                a.j.a = $wnd.Math.max(a.j.a, c.a);
                                a.j.b += c.b;
                                a.d.c.length > 1 && (a.j.b += a.e);
                            } else {
                                a.j.a += c.a;
                                a.j.b = $wnd.Math.max(a.j.b, c.b);
                                a.d.c.length > 1 && (a.j.a += a.e);
                            }
                        }
                        function Mnc() {
                            Mnc = geb;
                            Jnc = cD(WC(E3, 1), NAe, 64, 0, [
                                (qpd(), Yod),
                                Xod,
                                npd
                            ]);
                            Inc = cD(WC(E3, 1), NAe, 64, 0, [
                                Xod,
                                npd,
                                ppd
                            ]);
                            Knc = cD(WC(E3, 1), NAe, 64, 0, [
                                npd,
                                ppd,
                                Yod
                            ]);
                            Lnc = cD(WC(E3, 1), NAe, 64, 0, [
                                ppd,
                                Yod,
                                Xod
                            ]);
                        }
                        function Upc(a, b, c, d) {
                            var e, f, g, h, i, j, k;
                            g = a.c.d;
                            h = a.d.d;
                            if (g.j == h.j) return;
                            k = a.b;
                            e = g.j;
                            i = null;
                            while(e != h.j){
                                i = b == 0 ? tpd(e) : rpd(e);
                                f = $pc(e, k.d[e.g], c);
                                j = $pc(i, k.d[i.g], c);
                                Mub(d, $id(f, j));
                                e = i;
                            }
                        }
                        function OJc(a, b, c, d) {
                            var e, f, g, h, i;
                            g = hMc(a.a, b, c);
                            h = RD(g.a, 17).a;
                            f = RD(g.b, 17).a;
                            if (d) {
                                i = RD(mQb(b, (Ywc(), Iwc)), 10);
                                e = RD(mQb(c, Iwc), 10);
                                if (!!i && !!e) {
                                    Slc(a.b, i, e);
                                    h += a.b.i;
                                    f += a.b.e;
                                }
                            }
                            return h > f;
                        }
                        function OLc(a) {
                            var b, c, d, e, f, g, h, i, j;
                            this.a = LLc(a);
                            this.b = new bnb;
                            for(c = a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                f = new bnb;
                                Rmb(this.b, f);
                                for(h = b, i = 0, j = h.length; i < j; ++i){
                                    g = h[i];
                                    Rmb(f, new dnb(g.j));
                                }
                            }
                        }
                        function QLc(a, b, c) {
                            var d, e, f;
                            f = 0;
                            d = c[b];
                            if (b < c.length - 1) {
                                e = c[b + 1];
                                if (a.b[b]) {
                                    f = iNc(a.d, d, e);
                                    f += lMc(a.a, d, (qpd(), Xod));
                                    f += lMc(a.a, e, ppd);
                                } else f = gMc(a.a, d, e);
                            }
                            a.c[b] && (f += nMc(a.a, d));
                            return f;
                        }
                        function r0b(a, b, c, d, e) {
                            var f, g, h, i;
                            i = null;
                            for(h = new Anb(d); h.a < h.c.c.length;){
                                g = RD(ynb(h), 453);
                                if (g != c && Wmb(g.e, e, 0) != -1) {
                                    i = g;
                                    break;
                                }
                            }
                            f = s0b(e);
                            Y0b(f, c.b);
                            Z0b(f, i.b);
                            Rc(a.a, e, new J0b(f, b, c.f));
                        }
                        function h2b(a) {
                            var b, c, d, e;
                            if (Emd(RD(mQb(a.b, (yCc(), rAc)), 88))) return 0;
                            b = 0;
                            for(d = new Anb(a.a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 10);
                                if (c.k == (r3b(), p3b)) {
                                    e = c.o.a;
                                    b = $wnd.Math.max(b, e);
                                }
                            }
                            return b;
                        }
                        function Tlc(a) {
                            while(a.g.c != 0 && a.d.c != 0){
                                if (amc(a.g).c > amc(a.d).c) {
                                    a.i += a.g.c;
                                    cmc(a.d);
                                } else if (amc(a.d).c > amc(a.g).c) {
                                    a.e += a.d.c;
                                    cmc(a.g);
                                } else {
                                    a.i += _lc(a.g);
                                    a.e += _lc(a.d);
                                    cmc(a.g);
                                    cmc(a.d);
                                }
                            }
                        }
                        function vTc(a, b, c) {
                            var d, e, f, g;
                            f = b.q;
                            g = b.r;
                            new bTc((fTc(), dTc), b, f, 1);
                            new bTc(dTc, f, g, 1);
                            for(e = new Anb(c); e.a < e.c.c.length;){
                                d = RD(ynb(e), 118);
                                if (d != f && d != b && d != g) {
                                    PTc(a.a, d, b);
                                    PTc(a.a, d, g);
                                }
                            }
                        }
                        function vVc(a, b, c, d) {
                            a.a.d = $wnd.Math.min(b, c);
                            a.a.a = $wnd.Math.max(b, d) - a.a.d;
                            if (b < c) {
                                a.b = 0.5 * (b + c);
                                a.g = CEe * a.b + 0.9 * b;
                                a.f = CEe * a.b + 0.9 * c;
                            } else {
                                a.b = 0.5 * (b + d);
                                a.g = CEe * a.b + 0.9 * d;
                                a.f = CEe * a.b + 0.9 * b;
                            }
                        }
                        function zZc(a) {
                            var b, c, d, e;
                            if (a.b != 0) {
                                b = new Yub;
                                for(e = Sub(a, 0); e.b != e.d.c;){
                                    d = RD(evb(e), 40);
                                    ye(b, $Wc(d));
                                    c = d.e;
                                    c.a = RD(mQb(d, (q$c(), o$c)), 17).a;
                                    c.b = RD(mQb(d, p$c), 17).a;
                                }
                                return b;
                            }
                            return new Yub;
                        }
                        function t8b(a) {
                            switch(RD(mQb(a, (yCc(), UAc)), 171).g){
                                case 1:
                                    pQb(a, UAc, (cxc(), _wc));
                                    break;
                                case 2:
                                    pQb(a, UAc, (cxc(), axc));
                                    break;
                                case 3:
                                    pQb(a, UAc, (cxc(), Zwc));
                                    break;
                                case 4:
                                    pQb(a, UAc, (cxc(), $wc));
                            }
                        }
                        function Whc(a, b, c) {
                            var d;
                            c.Ug('Self-Loop routing', 1);
                            d = Xhc(b);
                            fE(mQb(b, (rid(), qid)));
                            FDb(GDb(CDb(CDb(EDb(new SDb(null, new Swb(b.b, 16)), new $hc), new aic), new cic), new eic), new gic(a, d));
                            c.Vg();
                        }
                        function $uc() {
                            $uc = geb;
                            Yuc = new _uc(LAe, 0);
                            Vuc = new _uc(Nye, 1);
                            Zuc = new _uc(Oye, 2);
                            Xuc = new _uc('LEFT_RIGHT_CONSTRAINT_LOCKING', 3);
                            Wuc = new _uc('LEFT_RIGHT_CONNECTION_LOCKING', 4);
                            Uuc = new _uc(EBe, 5);
                        }
                        function tWc(a, b, c) {
                            var d, e, f, g, h, i, j;
                            h = c.a / 2;
                            f = c.b / 2;
                            d = $wnd.Math.abs(b.a - a.a);
                            e = $wnd.Math.abs(b.b - a.b);
                            i = 1;
                            j = 1;
                            d > h && (i = h / d);
                            e > f && (j = f / e);
                            g = $wnd.Math.min(i, j);
                            a.a += g * (b.a - a.a);
                            a.b += g * (b.b - a.b);
                        }
                        function I8c(a, b, c, d, e) {
                            var f, g;
                            g = false;
                            f = RD(Vmb(c.b, 0), 27);
                            while(V8c(a, b, f, d, e)){
                                g = true;
                                T9c(c, f);
                                if (c.b.c.length == 0) break;
                                f = RD(Vmb(c.b, 0), 27);
                            }
                            c.b.c.length == 0 && Fad(c.j, c);
                            g && gad(b.q);
                            return g;
                        }
                        function Eid(a, b) {
                            tid();
                            var c, d, e, f;
                            if (b.b < 2) return false;
                            f = Sub(b, 0);
                            c = RD(evb(f), 8);
                            d = c;
                            while(f.b != f.d.c){
                                e = RD(evb(f), 8);
                                if (Did(a, d, e)) return true;
                                d = e;
                            }
                            if (Did(a, d, c)) return true;
                            return false;
                        }
                        function Bxd(a, b, c, d) {
                            var e, f;
                            if (c == 0) return !a.o && (a.o = new DVd((pvd(), mvd), X4, a, 0)), BVd(a.o, b, d);
                            return f = RD(vYd((e = RD(Ywd(a, 16), 29), !e ? a.ii() : e), c), 69), f.wk().Ak(a, Wwd(a), c - AYd(a.ii()), b, d);
                        }
                        function BBd(a, b) {
                            var c;
                            if (b != a.sb) {
                                c = null;
                                !!a.sb && (c = RD(a.sb, 54).Th(a, 1, n7, c));
                                !!b && (c = RD(b, 54).Rh(a, 1, n7, c));
                                c = hBd(a, b, c);
                                !!c && c.oj();
                            } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 4, b, b));
                        }
                        function YDd(a, b) {
                            var c, d, e, f;
                            if (b) {
                                e = vDd(b, 'x');
                                c = new ZEd(a);
                                Hzd(c.a, (uFb(e), e));
                                f = vDd(b, 'y');
                                d = new $Ed(a);
                                Izd(d.a, (uFb(f), f));
                            } else throw Adb(new CDd('All edge sections need an end point.'));
                        }
                        function WDd(a, b) {
                            var c, d, e, f;
                            if (b) {
                                e = vDd(b, 'x');
                                c = new WEd(a);
                                Ozd(c.a, (uFb(e), e));
                                f = vDd(b, 'y');
                                d = new XEd(a);
                                Pzd(d.a, (uFb(f), f));
                            } else throw Adb(new CDd('All edge sections need a start point.'));
                        }
                        function hBb(a, b) {
                            var c, d, e, f, g, h, i;
                            for(d = kBb(a), f = 0, h = d.length; f < h; ++f)qBb(b);
                            i = !dBb && a.e ? dBb ? null : a.d : null;
                            while(i){
                                for(c = kBb(i), e = 0, g = c.length; e < g; ++e)qBb(b);
                                i = !dBb && i.e ? dBb ? null : i.d : null;
                            }
                        }
                        function aXb(a, b) {
                            var c, d;
                            d = RD(mQb(b, (yCc(), BBc)), 101);
                            pQb(b, (Ywc(), Fwc), d);
                            c = b.e;
                            !!c && (FDb(new SDb(null, new Swb(c.a, 16)), new fXb(a)), FDb(EDb(new SDb(null, new Swb(c.b, 16)), new hXb), new jXb(a)));
                        }
                        function r3b() {
                            r3b = geb;
                            p3b = new s3b('NORMAL', 0);
                            o3b = new s3b('LONG_EDGE', 1);
                            m3b = new s3b('EXTERNAL_PORT', 2);
                            q3b = new s3b('NORTH_SOUTH_PORT', 3);
                            n3b = new s3b('LABEL', 4);
                            l3b = new s3b('BREAKING_POINT', 5);
                        }
                        function x7b(a) {
                            var b, c, d, e;
                            b = false;
                            if (nQb(a, (Ywc(), cwc))) {
                                c = RD(mQb(a, cwc), 85);
                                for(e = new Anb(a.j); e.a < e.c.c.length;){
                                    d = RD(ynb(e), 12);
                                    if (v7b(d)) {
                                        if (!b) {
                                            u7b(Y2b(a));
                                            b = true;
                                        }
                                        y7b(RD(c.xc(d), 314));
                                    }
                                }
                            }
                        }
                        function GFd(a) {
                            var b, c, d, e, f, g, h, i, j;
                            j = HFd(a);
                            c = a.e;
                            f = c != null;
                            f && sDd(j, FIe, a.e);
                            h = a.k;
                            g = !!h;
                            g && sDd(j, 'type', ps(a.k));
                            d = cve(a.j);
                            e = !d;
                            if (e) {
                                i = new MB;
                                sC(j, lIe, i);
                                b = new SFd(i);
                                xgb(a.j, b);
                            }
                            return j;
                        }
                        function Zv(a) {
                            var b, c, d, e;
                            e = Thb((dk(a.gc(), 'size'), new cib), 123);
                            d = true;
                            for(c = gn(a).Kc(); c.Ob();){
                                b = RD(c.Pb(), 44);
                                d || (e.a += pve, e);
                                d = false;
                                Yhb(Thb(Yhb(e, b.ld()), 61), b.md());
                            }
                            return (e.a += '}', e).a;
                        }
                        function AD(a, b) {
                            var c, d, e;
                            b &= 63;
                            if (b < 22) {
                                c = a.l << b;
                                d = a.m << b | a.l >> 22 - b;
                                e = a.h << b | a.m >> 22 - b;
                            } else if (b < 44) {
                                c = 0;
                                d = a.l << b - 22;
                                e = a.m << b - 22 | a.l >> 44 - b;
                            } else {
                                c = 0;
                                d = 0;
                                e = a.l << b - 44;
                            }
                            return hD(c & dxe, d & dxe, e & exe);
                        }
                        function Neb(a) {
                            Meb == null && (Meb = new RegExp('^\\s*[+-]?(NaN|Infinity|((\\d+\\.?\\d*)|(\\.\\d+))([eE][+-]?\\d+)?[dDfF]?)\\s*$'));
                            if (!Meb.test(a)) throw Adb(new Vgb(nxe + a + '"'));
                            return parseFloat(a);
                        }
                        function PXb(a, b) {
                            var c, d, e, f, g;
                            e = b == 1 ? MXb : LXb;
                            for(d = e.a.ec().Kc(); d.Ob();){
                                c = RD(d.Pb(), 88);
                                for(g = RD(Qc(a.f.c, c), 21).Kc(); g.Ob();){
                                    f = RD(g.Pb(), 42);
                                    Rmb(a.b.b, RD(f.b, 86));
                                    Rmb(a.b.a, RD(f.b, 86).d);
                                }
                            }
                        }
                        function rqc(a, b) {
                            var c, d, e, f;
                            f = b.b.j;
                            a.a = $C(kE, Pwe, 28, f.c.length, 15, 1);
                            e = 0;
                            for(d = 0; d < f.c.length; d++){
                                c = (tFb(d, f.c.length), RD(f.c[d], 12));
                                c.e.c.length == 0 && c.g.c.length == 0 ? e += 1 : e += 3;
                                a.a[d] = e;
                            }
                        }
                        function tuc() {
                            tuc = geb;
                            ouc = new vuc('ALWAYS_UP', 0);
                            nuc = new vuc('ALWAYS_DOWN', 1);
                            quc = new vuc('DIRECTION_UP', 2);
                            puc = new vuc('DIRECTION_DOWN', 3);
                            suc = new vuc('SMART_UP', 4);
                            ruc = new vuc('SMART_DOWN', 5);
                        }
                        function vid(a, b) {
                            if (a < 0 || b < 0) throw Adb(new agb('k and n must be positive'));
                            else if (b > a) throw Adb(new agb('k must be smaller than n'));
                            else return b == 0 || b == a ? 1 : a == 0 ? 0 : Bid(a) / (Bid(b) * Bid(a - b));
                        }
                        function msd(a, b) {
                            var c, d, e, f;
                            c = new zId(a);
                            while(c.g == null && !c.c ? sId(c) : c.g == null || c.i != 0 && RD(c.g[c.i - 1], 51).Ob()){
                                f = RD(tId(c), 58);
                                if (ZD(f, 167)) {
                                    d = RD(f, 167);
                                    for(e = 0; e < b.length; e++)b[e].Kg(d);
                                }
                            }
                        }
                        function Fyd(a) {
                            var b;
                            if ((a.Db & 64) != 0) return kyd(a);
                            b = new Shb(kyd(a));
                            b.a += ' (height: ';
                            Khb(b, a.f);
                            b.a += ', width: ';
                            Khb(b, a.g);
                            b.a += ', x: ';
                            Khb(b, a.i);
                            b.a += ', y: ';
                            Khb(b, a.j);
                            b.a += ')';
                            return b.a;
                        }
                        function Gn(a) {
                            var b, c, d, e, f, g, h;
                            b = new gub;
                            for(d = a, e = 0, f = d.length; e < f; ++e){
                                c = d[e];
                                g = Qb(c.ld());
                                h = dub(b, g, Qb(c.md()));
                                if (h != null) throw Adb(new agb('duplicate key: ' + g));
                            }
                            this.b = (yob(), new uqb(b));
                        }
                        function bob(a) {
                            var b, c, d, e, f;
                            if (a == null) return vve;
                            f = new Jyb(pve, '[', ']');
                            for(c = a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                Gyb(f, String.fromCharCode(b));
                            }
                            return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
                        }
                        function OUb() {
                            OUb = geb;
                            IUb = (TUb(), SUb);
                            HUb = new lGd(Rze, IUb);
                            sgb(1);
                            GUb = new lGd(Sze, sgb(300));
                            sgb(0);
                            LUb = new lGd(Tze, sgb(0));
                            new Xsd;
                            MUb = new lGd(Uze, Vze);
                            new Xsd;
                            JUb = new lGd(Wze, 5);
                            NUb = SUb;
                            KUb = RUb;
                        }
                        function K6d(a, b) {
                            var c;
                            if (b != null && !a.c.Hk().fk(b)) {
                                c = ZD(b, 58) ? RD(b, 58).Dh().zb : nfb(rb(b));
                                throw Adb(new Ifb(KHe + a.c.xe() + "'s type '" + a.c.Hk().xe() + "' does not permit a value of type '" + c + "'"));
                            }
                        }
                        function k0b(a, b, c) {
                            var d, e;
                            e = new Jkb(a.b, 0);
                            while(e.b < e.d.gc()){
                                d = (sFb(e.b < e.d.gc()), RD(e.d.Xb(e.c = e.b++), 72));
                                if (dE(mQb(d, (Ywc(), Dwc))) !== dE(b)) continue;
                                e2b(d.n, Y2b(a.c.i), c);
                                Ckb(e);
                                Rmb(b.b, d);
                            }
                        }
                        function Arc(a) {
                            var b, c;
                            c = $wnd.Math.sqrt((a.k == null && (a.k = tsc(a, new Esc)), Kfb(a.k) / (a.b * (a.g == null && (a.g = qsc(a, new Csc)), Kfb(a.g)))));
                            b = Ydb(Hdb($wnd.Math.round(c)));
                            b = $wnd.Math.min(b, a.f);
                            return b;
                        }
                        function sse() {
                            var a, b, c;
                            b = 0;
                            for(a = 0; a < 1; a++){
                                c = rse((BFb(a, 1), 'X'.charCodeAt(a)));
                                if (c == 0) throw Adb(new Lqe((BFb(a, 2), 'Unknown Option: ' + 'X'.substr(a))));
                                b |= c;
                            }
                            return b;
                        }
                        function R3b() {
                            J3b();
                            v2b.call(this);
                            this.j = (qpd(), opd);
                            this.a = new pjd;
                            new T2b;
                            this.f = (dk(2, iwe), new cnb(2));
                            this.e = (dk(4, iwe), new cnb(4));
                            this.g = (dk(4, iwe), new cnb(4));
                            this.b = new h4b(this.e, this.g);
                        }
                        function A6b(a, b) {
                            var c, d;
                            if (Heb(TD(mQb(b, (Ywc(), Nwc))))) return false;
                            d = b.c.i;
                            if (a == (cxc(), Zwc)) {
                                if (d.k == (r3b(), n3b)) return false;
                            }
                            c = RD(mQb(d, (yCc(), UAc)), 171);
                            if (c == $wc) return false;
                            return true;
                        }
                        function B6b(a, b) {
                            var c, d;
                            if (Heb(TD(mQb(b, (Ywc(), Nwc))))) return false;
                            d = b.d.i;
                            if (a == (cxc(), _wc)) {
                                if (d.k == (r3b(), n3b)) return false;
                            }
                            c = RD(mQb(d, (yCc(), UAc)), 171);
                            if (c == axc) return false;
                            return true;
                        }
                        function a7b(a, b) {
                            var c, d, e, f, g, h, i;
                            g = a.d;
                            i = a.o;
                            h = new Uid(-g.b, -g.d, g.b + i.a + g.c, g.d + i.b + g.a);
                            for(d = b, e = 0, f = d.length; e < f; ++e){
                                c = d[e];
                                !!c && Sid(h, c.i);
                            }
                            g.b = -h.c;
                            g.d = -h.d;
                            g.c = h.b - g.b - i.a;
                            g.a = h.a - g.d - i.b;
                        }
                        function _gc(a, b) {
                            if (b.a) switch(RD(mQb(b.b, (Ywc(), Fwc)), 101).g){
                                case 0:
                                case 1:
                                    Roc(b);
                                case 2:
                                    FDb(new SDb(null, new Swb(b.d, 16)), new mhc);
                                    aoc(a.a, b);
                            }
                            else FDb(new SDb(null, new Swb(b.d, 16)), new mhc);
                        }
                        function Xbd() {
                            Xbd = geb;
                            Sbd = new Ybd('CENTER_DISTANCE', 0);
                            Tbd = new Ybd('CIRCLE_UNDERLAP', 1);
                            Wbd = new Ybd('RECTANGLE_UNDERLAP', 2);
                            Ubd = new Ybd('INVERTED_OVERLAP', 3);
                            Vbd = new Ybd('MINIMUM_ROOT_DISTANCE', 4);
                        }
                        function Iqe(a) {
                            Gqe();
                            var b, c, d, e, f;
                            if (a == null) return null;
                            d = a.length;
                            e = d * 2;
                            b = $C(hE, zwe, 28, e, 15, 1);
                            for(c = 0; c < d; c++){
                                f = a[c];
                                f < 0 && (f += 256);
                                b[c * 2] = Fqe[f >> 4];
                                b[c * 2 + 1] = Fqe[f & 15];
                            }
                            return Ihb(b, 0, b.length);
                        }
                        function sn(a) {
                            fn();
                            var b, c, d;
                            d = a.c.length;
                            switch(d){
                                case 0:
                                    return en;
                                case 1:
                                    b = RD(Ir(new Anb(a)), 44);
                                    return xn(b.ld(), b.md());
                                default:
                                    c = RD(anb(a, $C(UK, Zve, 44, a.c.length, 0, 1)), 173);
                                    return new Mx(c);
                            }
                        }
                        function KWb(a) {
                            var b, c, d, e, f, g;
                            b = new wmb;
                            c = new wmb;
                            hmb(b, a);
                            hmb(c, a);
                            while(c.b != c.c){
                                e = RD(smb(c), 36);
                                for(g = new Anb(e.a); g.a < g.c.c.length;){
                                    f = RD(ynb(g), 10);
                                    if (f.e) {
                                        d = f.e;
                                        hmb(b, d);
                                        hmb(c, d);
                                    }
                                }
                            }
                            return b;
                        }
                        function e3b(a, b) {
                            switch(b.g){
                                case 1:
                                    return dr(a.j, (J3b(), F3b));
                                case 2:
                                    return dr(a.j, (J3b(), D3b));
                                case 3:
                                    return dr(a.j, (J3b(), H3b));
                                case 4:
                                    return dr(a.j, (J3b(), I3b));
                                default:
                                    return yob(), yob(), vob;
                            }
                        }
                        function Zlc(a, b) {
                            var c, d, e;
                            c = $lc(b, a.e);
                            d = RD(Wjb(a.g.f, c), 17).a;
                            e = a.a.c.length - 1;
                            if (a.a.c.length != 0 && RD(Vmb(a.a, e), 294).c == d) {
                                ++RD(Vmb(a.a, e), 294).a;
                                ++RD(Vmb(a.a, e), 294).b;
                            } else Rmb(a.a, new hmc(d));
                        }
                        function tLc(a, b, c) {
                            var d, e;
                            d = sLc(a, b, c);
                            if (d != 0) return d;
                            if (nQb(b, (Ywc(), zwc)) && nQb(c, zwc)) {
                                e = hgb(RD(mQb(b, zwc), 17).a, RD(mQb(c, zwc), 17).a);
                                e < 0 ? uLc(a, b, c) : e > 0 && uLc(a, c, b);
                                return e;
                            }
                            return rLc(a, b, c);
                        }
                        function $4c() {
                            $4c = geb;
                            R4c = (umd(), Qld);
                            Y4c = fmd;
                            K4c = kld;
                            L4c = nld;
                            M4c = pld;
                            J4c = ild;
                            N4c = sld;
                            Q4c = Lld;
                            H4c = (D4c(), o4c);
                            I4c = p4c;
                            T4c = v4c;
                            W4c = y4c;
                            U4c = w4c;
                            V4c = x4c;
                            O4c = r4c;
                            P4c = t4c;
                            S4c = u4c;
                            X4c = z4c;
                            Z4c = B4c;
                            G4c = n4c;
                        }
                        function P9c(a, b) {
                            var c, d, e, f, g;
                            if (a.e <= b) return a.g;
                            if (R9c(a, a.g, b)) return a.g;
                            f = a.r;
                            d = a.g;
                            g = a.r;
                            e = (f - d) / 2 + d;
                            while(d + 1 < f){
                                c = S9c(a, e, false);
                                if (c.b <= e && c.a <= b) {
                                    g = e;
                                    f = e;
                                } else d = e;
                                e = (f - d) / 2 + d;
                            }
                            return g;
                        }
                        function Eed(a, b, c) {
                            var d;
                            d = zed(a, b, true);
                            Fqd(c, 'Recursive Graph Layout', d);
                            msd(b, cD(WC(j4, 1), rve, 536, 0, [
                                new Bfd
                            ]));
                            Hxd(b, (umd(), Tld)) || msd(b, cD(WC(j4, 1), rve, 536, 0, [
                                new dgd
                            ]));
                            Fed(a, b, null, c);
                            Hqd(c);
                        }
                        function Hqd(a) {
                            var b;
                            if (a.p == null) throw Adb(new dgb('The task has not begun yet.'));
                            if (!a.b) {
                                if (a.k) {
                                    b = (gib(), Ndb(Hdb(Date.now()), Awe));
                                    a.q = Xdb(Vdb(b, a.o)) * 1.0E-9;
                                }
                                a.c < a.r && Iqd(a, a.r - a.c);
                                a.b = true;
                            }
                        }
                        function ssd(a) {
                            var b, c, d;
                            d = new Ejd;
                            Mub(d, new rjd(a.j, a.k));
                            for(c = new dMd((!a.a && (a.a = new XZd(D4, a, 5)), a.a)); c.e != c.i.gc();){
                                b = RD(bMd(c), 377);
                                Mub(d, new rjd(b.a, b.b));
                            }
                            Mub(d, new rjd(a.b, a.c));
                            return d;
                        }
                        function QDd(a, b, c, d, e) {
                            var f, g, h, i, j, k;
                            if (e) {
                                i = e.a.length;
                                f = new vue(i);
                                for(k = (f.b - f.a) * f.c < 0 ? (uue(), tue) : new Rue(f); k.Ob();){
                                    j = RD(k.Pb(), 17);
                                    h = xDd(e, j.a);
                                    g = new PEd(a, b, c, d);
                                    RDd(g.a, g.b, g.c, g.d, h);
                                }
                            }
                        }
                        function Rx(b, c) {
                            var d;
                            if (dE(b) === dE(c)) return true;
                            if (ZD(c, 21)) {
                                d = RD(c, 21);
                                try {
                                    return b.gc() == d.gc() && b.Ic(d);
                                } catch (a) {
                                    a = zdb(a);
                                    if (ZD(a, 169) || ZD(a, 212)) return false;
                                    else throw Adb(a);
                                }
                            }
                            return false;
                        }
                        function Kzb(a, b, c, d, e, f) {
                            this.c = a;
                            switch(b.g){
                                case 2:
                                    if (a.a.Ne(e, c) < 0) throw Adb(new agb(Sxe + e + Txe + c));
                                    break;
                                case 1:
                                    a.a.Ne(e, e);
                                    break;
                                case 3:
                                    a.a.Ne(c, c);
                            }
                            this.f = b;
                            this.b = c;
                            this.a = d;
                            this.e = e;
                            this.d = f;
                        }
                        function LKb(a, b) {
                            var c;
                            Rmb(a.d, b);
                            c = b.Mf();
                            if (a.c) {
                                a.e.a = $wnd.Math.max(a.e.a, c.a);
                                a.e.b += c.b;
                                a.d.c.length > 1 && (a.e.b += a.a);
                            } else {
                                a.e.a += c.a;
                                a.e.b = $wnd.Math.max(a.e.b, c.b);
                                a.d.c.length > 1 && (a.e.a += a.a);
                            }
                        }
                        function Ipc(a) {
                            var b, c, d, e;
                            e = a.i;
                            b = e.b;
                            d = e.j;
                            c = e.g;
                            switch(e.a.g){
                                case 0:
                                    c.a = (a.g.b.o.a - d.a) / 2;
                                    break;
                                case 1:
                                    c.a = b.d.n.a + b.d.a.a;
                                    break;
                                case 2:
                                    c.a = b.d.n.a + b.d.a.a - d.a;
                                    break;
                                case 3:
                                    c.b = b.d.n.b + b.d.a.b;
                            }
                        }
                        function oOc(a, b, c) {
                            var d, e, f;
                            for(e = new is(Mr(W2b(c).a.Kc(), new ir)); gs(e);){
                                d = RD(hs(e), 18);
                                if (!(!W0b(d) && !(!W0b(d) && d.c.i.c == d.d.i.c))) continue;
                                f = gOc(a, d, c, new VOc);
                                f.c.length > 1 && ZEb(b.c, f);
                            }
                        }
                        function _id(a, b, c, d, e) {
                            if (d < b || e < c) throw Adb(new agb('The highx must be bigger then lowx and the highy must be bigger then lowy'));
                            a.a < b ? a.a = b : a.a > d && (a.a = d);
                            a.b < c ? a.b = c : a.b > e && (a.b = e);
                            return a;
                        }
                        function LFd(a) {
                            if (ZD(a, 143)) return EFd(RD(a, 143));
                            else if (ZD(a, 233)) return FFd(RD(a, 233));
                            else if (ZD(a, 23)) return GFd(RD(a, 23));
                            else throw Adb(new agb(wIe + Fe(new mob(cD(WC(jJ, 1), rve, 1, 5, [
                                a
                            ])))));
                        }
                        function ujb(a, b, c, d, e) {
                            var f, g, h;
                            f = true;
                            for(g = 0; g < d; g++)f = f & c[g] == 0;
                            if (e == 0) {
                                hib(c, d, a, 0, b);
                                g = b;
                            } else {
                                h = 32 - e;
                                f = f & c[g] << h == 0;
                                for(g = 0; g < b - 1; g++)a[g] = c[g + d] >>> e | c[g + d + 1] << h;
                                a[g] = c[g + d] >>> e;
                                ++g;
                            }
                            return f;
                        }
                        function ZQc(a, b, c, d) {
                            var e, f, g;
                            if (b.k == (r3b(), o3b)) for(f = new is(Mr(Z2b(b).a.Kc(), new ir)); gs(f);){
                                e = RD(hs(f), 18);
                                g = e.c.i.k;
                                if (g == o3b && a.c.a[e.c.i.c.p] == d && a.c.a[b.c.p] == c) return true;
                            }
                            return false;
                        }
                        function CD(a, b) {
                            var c, d, e, f;
                            b &= 63;
                            c = a.h & exe;
                            if (b < 22) {
                                f = c >>> b;
                                e = a.m >> b | c << 22 - b;
                                d = a.l >> b | a.m << 22 - b;
                            } else if (b < 44) {
                                f = 0;
                                e = c >>> b - 22;
                                d = a.m >> b - 22 | a.h << 44 - b;
                            } else {
                                f = 0;
                                e = 0;
                                d = c >>> b - 44;
                            }
                            return hD(d & dxe, e & dxe, f & exe);
                        }
                        function mmc(a, b, c, d) {
                            var e;
                            this.b = d;
                            this.e = a == (RKc(), PKc);
                            e = b[c];
                            this.d = YC(xdb, [
                                Nve,
                                Hye
                            ], [
                                183,
                                28
                            ], 16, [
                                e.length,
                                e.length
                            ], 2);
                            this.a = YC(kE, [
                                Nve,
                                Pwe
                            ], [
                                53,
                                28
                            ], 15, [
                                e.length,
                                e.length
                            ], 2);
                            this.c = new Ylc(b, c);
                        }
                        function Rmc(a) {
                            var b, c, d;
                            a.k = new Si((qpd(), cD(WC(E3, 1), NAe, 64, 0, [
                                opd,
                                Yod,
                                Xod,
                                npd,
                                ppd
                            ])).length, a.j.c.length);
                            for(d = new Anb(a.j); d.a < d.c.c.length;){
                                c = RD(ynb(d), 113);
                                b = c.d.j;
                                Rc(a.k, b, c);
                            }
                            a.e = Dnc(Ec(a.k));
                        }
                        function sVc(a, b) {
                            var c, d, e;
                            Ysb(a.d, b);
                            c = new zVc;
                            Zjb(a.c, b, c);
                            c.f = tVc(b.c);
                            c.a = tVc(b.d);
                            c.d = (HUc(), e = b.c.i.k, e == (r3b(), p3b) || e == l3b);
                            c.e = (d = b.d.i.k, d == p3b || d == l3b);
                            c.b = b.c.j == (qpd(), ppd);
                            c.c = b.d.j == Xod;
                        }
                        function sJb(a) {
                            var b, c, d, e, f;
                            f = lve;
                            e = lve;
                            for(d = new Anb(CIb(a)); d.a < d.c.c.length;){
                                c = RD(ynb(d), 218);
                                b = c.e.e - c.d.e;
                                c.e == a && b < e ? e = b : b < f && (f = b);
                            }
                            e == lve && (e = -1);
                            f == lve && (f = -1);
                            return new Ptd(sgb(e), sgb(f));
                        }
                        function qTb(a, b) {
                            var c, d, e;
                            e = Hze;
                            d = (IRb(), FRb);
                            e = $wnd.Math.abs(a.b);
                            c = $wnd.Math.abs(b.f - a.b);
                            if (c < e) {
                                e = c;
                                d = GRb;
                            }
                            c = $wnd.Math.abs(a.a);
                            if (c < e) {
                                e = c;
                                d = HRb;
                            }
                            c = $wnd.Math.abs(b.g - a.a);
                            if (c < e) {
                                e = c;
                                d = ERb;
                            }
                            return d;
                        }
                        function adc(a, b) {
                            var c, d, e, f;
                            c = b.a.o.a;
                            f = new Rkb(Y2b(b.a).b, b.c, b.f + 1);
                            for(e = new Dkb(f); e.b < e.d.gc();){
                                d = (sFb(e.b < e.d.gc()), RD(e.d.Xb(e.c = e.b++), 30));
                                if (d.c.a >= c) {
                                    _cc(a, b, d.p);
                                    return true;
                                }
                            }
                            return false;
                        }
                        function EA(a, b, c, d) {
                            var e, f, g, h, i, j;
                            g = c.length;
                            f = 0;
                            e = -1;
                            j = Bhb((BFb(b, a.length + 1), a.substr(b)), (wvb(), uvb));
                            for(h = 0; h < g; ++h){
                                i = c[h].length;
                                if (i > f && whb(j, Bhb(c[h], uvb))) {
                                    e = h;
                                    f = i;
                                }
                            }
                            e >= 0 && (d[0] = b + f);
                            return e;
                        }
                        function gCd(a) {
                            var b;
                            if ((a.Db & 64) != 0) return Fyd(a);
                            b = new dib(FHe);
                            !a.a || Zhb(Zhb((b.a += ' "', b), a.a), '"');
                            Zhb(Uhb(Zhb(Uhb(Zhb(Uhb(Zhb(Uhb((b.a += ' (', b), a.i), ','), a.j), ' | '), a.g), ','), a.f), ')');
                            return b.a;
                        }
                        function xge(a, b, c) {
                            var d, e, f, g, h;
                            h = pke(a.e.Dh(), b);
                            e = RD(a.g, 124);
                            d = 0;
                            for(g = 0; g < a.i; ++g){
                                f = e[g];
                                if (h.am(f.Lk())) {
                                    if (d == c) {
                                        vLd(a, g);
                                        return nke(), RD(b, 69).xk() ? f : f.md();
                                    }
                                    ++d;
                                }
                            }
                            throw Adb(new veb(HJe + c + NIe + d));
                        }
                        function Rqe(a) {
                            var b, c, d;
                            b = a.c;
                            if (b == 2 || b == 7 || b == 1) return Vse(), Vse(), Ese;
                            else {
                                d = Pqe(a);
                                c = null;
                                while((b = a.c) != 2 && b != 7 && b != 1){
                                    if (!c) {
                                        c = (Vse(), Vse(), ++Use, new iue(1));
                                        hue(c, d);
                                        d = c;
                                    }
                                    hue(c, Pqe(a));
                                }
                                return d;
                            }
                        }
                        function Kb(a, b, c) {
                            if (a < 0 || a > c) return Jb(a, c, 'start index');
                            if (b < 0 || b > c) return Jb(b, c, 'end index');
                            return hc('end index (%s) must not be less than start index (%s)', cD(WC(jJ, 1), rve, 1, 5, [
                                sgb(b),
                                sgb(a)
                            ]));
                        }
                        function dA(b, c) {
                            var d, e, f, g;
                            for(e = 0, f = b.length; e < f; e++){
                                g = b[e];
                                try {
                                    g[1] ? g[0].Um() && (c = cA(c, g)) : g[0].Um();
                                } catch (a) {
                                    a = zdb(a);
                                    if (ZD(a, 82)) {
                                        d = a;
                                        Qz();
                                        Wz(ZD(d, 486) ? RD(d, 486).ke() : d);
                                    } else throw Adb(a);
                                }
                            }
                            return c;
                        }
                        function _cc(a, b, c) {
                            var d, e, f;
                            c != b.c + b.b.gc() && odc(b.a, wdc(b, c - b.c));
                            f = b.a.c.p;
                            a.a[f] = $wnd.Math.max(a.a[f], b.a.o.a);
                            for(e = RD(mQb(b.a, (Ywc(), Mwc)), 15).Kc(); e.Ob();){
                                d = RD(e.Pb(), 72);
                                pQb(d, Ycc, (Geb(), true));
                            }
                        }
                        function Aic(a, b) {
                            var c, d, e;
                            e = zic(b);
                            pQb(b, (Ywc(), xwc), e);
                            if (e) {
                                d = lve;
                                !!qtb(a.f, e) && (d = RD(Wd(qtb(a.f, e)), 17).a);
                                c = RD(Vmb(b.g, 0), 18);
                                Heb(TD(mQb(c, Nwc))) || Zjb(a, e, sgb($wnd.Math.min(RD(mQb(c, zwc), 17).a, d)));
                            }
                        }
                        function aGc(a, b, c) {
                            var d, e, f, g, h;
                            b.p = -1;
                            for(h = c3b(b, (BEc(), zEc)).Kc(); h.Ob();){
                                g = RD(h.Pb(), 12);
                                for(e = new Anb(g.g); e.a < e.c.c.length;){
                                    d = RD(ynb(e), 18);
                                    f = d.d.i;
                                    b != f && (f.p < 0 ? c.Fc(d) : f.p > 0 && aGc(a, f, c));
                                }
                            }
                            b.p = 0;
                        }
                        function Ahd(a) {
                            var b;
                            this.c = new Yub;
                            this.f = a.e;
                            this.e = a.d;
                            this.i = a.g;
                            this.d = a.c;
                            this.b = a.b;
                            this.k = a.j;
                            this.a = a.a;
                            !a.i ? this.j = (b = RD(mfb(d3), 9), new Fsb(b, RD(WEb(b, b.length), 9), 0)) : this.j = a.i;
                            this.g = a.f;
                        }
                        function Wb(a) {
                            var b, c, d, e;
                            b = Thb(Zhb(new dib('Predicates.'), 'and'), 40);
                            c = true;
                            for(e = new Dkb(a); e.b < e.d.gc();){
                                d = (sFb(e.b < e.d.gc()), e.d.Xb(e.c = e.b++));
                                c || (b.a += ',', b);
                                b.a += '' + d;
                                c = false;
                            }
                            return (b.a += ')', b).a;
                        }
                        function vgc(a, b, c) {
                            var d, e, f;
                            if (c <= b + 2) return;
                            e = (c - b) / 2 | 0;
                            for(d = 0; d < e; ++d){
                                f = (tFb(b + d, a.c.length), RD(a.c[b + d], 12));
                                $mb(a, b + d, (tFb(c - d - 1, a.c.length), RD(a.c[c - d - 1], 12)));
                                tFb(c - d - 1, a.c.length);
                                a.c[c - d - 1] = f;
                            }
                        }
                        function Nmc(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            f = a.d.p;
                            h = f.e;
                            i = f.r;
                            a.g = new DMc(i);
                            g = a.d.o.c.p;
                            d = g > 0 ? h[g - 1] : $C(jR, WAe, 10, 0, 0, 1);
                            e = h[g];
                            j = g < h.length - 1 ? h[g + 1] : $C(jR, WAe, 10, 0, 0, 1);
                            k = b == c - 1;
                            k ? pMc(a.g, e, j) : pMc(a.g, d, e);
                        }
                        function Vmc(a) {
                            var b;
                            this.j = new bnb;
                            this.f = new _sb;
                            this.b = (b = RD(mfb(E3), 9), new Fsb(b, RD(WEb(b, b.length), 9), 0));
                            this.d = $C(kE, Pwe, 28, (qpd(), cD(WC(E3, 1), NAe, 64, 0, [
                                opd,
                                Yod,
                                Xod,
                                npd,
                                ppd
                            ])).length, 15, 1);
                            this.g = a;
                        }
                        function D3c(a, b) {
                            var c, d, e;
                            if (b.c.length != 0) {
                                c = E3c(a, b);
                                e = false;
                                while(!c){
                                    n3c(a, b, true);
                                    e = true;
                                    c = E3c(a, b);
                                }
                                e && n3c(a, b, false);
                                d = N2c(b);
                                !!a.b && a.b.Gg(d);
                                a.a = C3c(a, (tFb(0, b.c.length), RD(b.c[0], 27)));
                                D3c(a, d);
                            }
                        }
                        function $vd(a, b) {
                            var c, d, e;
                            d = vYd(a.Dh(), b);
                            c = b - a.ji();
                            if (c < 0) {
                                if (!d) throw Adb(new agb(OHe + b + PHe));
                                else if (d.rk()) {
                                    e = a.Ih(d);
                                    e >= 0 ? a.ki(e) : Tvd(a, d);
                                } else throw Adb(new agb(KHe + d.xe() + LHe));
                            } else Cvd(a, c, d);
                        }
                        function ADd(a) {
                            var b, c;
                            c = null;
                            b = false;
                            if (ZD(a, 211)) {
                                b = true;
                                c = RD(a, 211).a;
                            }
                            if (!b) {
                                if (ZD(a, 263)) {
                                    b = true;
                                    c = '' + RD(a, 263).a;
                                }
                            }
                            if (!b) {
                                if (ZD(a, 493)) {
                                    b = true;
                                    c = '' + RD(a, 493).a;
                                }
                            }
                            if (!b) throw Adb(new Aeb(tIe));
                            return c;
                        }
                        function gge(a, b, c) {
                            var d, e, f, g, h, i;
                            i = pke(a.e.Dh(), b);
                            d = 0;
                            h = a.i;
                            e = RD(a.g, 124);
                            for(g = 0; g < a.i; ++g){
                                f = e[g];
                                if (i.am(f.Lk())) {
                                    if (c == d) return g;
                                    ++d;
                                    h = g + 1;
                                }
                            }
                            if (c == d) return h;
                            else throw Adb(new veb(HJe + c + NIe + d));
                        }
                        function ucc(a, b) {
                            var c, d, e, f;
                            if (a.f.c.length == 0) return null;
                            else {
                                f = new Tid;
                                for(d = new Anb(a.f); d.a < d.c.c.length;){
                                    c = RD(ynb(d), 72);
                                    e = c.o;
                                    f.b = $wnd.Math.max(f.b, e.a);
                                    f.a += e.b;
                                }
                                f.a += (a.f.c.length - 1) * b;
                                return f;
                            }
                        }
                        function rOc(a) {
                            var b, c, d, e;
                            c = new Yub;
                            ye(c, a.o);
                            d = new Fyb;
                            while(c.b != 0){
                                b = RD(c.b == 0 ? null : (sFb(c.b != 0), Wub(c, c.a.a)), 515);
                                e = iOc(a, b, true);
                                e && Rmb(d.a, b);
                            }
                            while(d.a.c.length != 0){
                                b = RD(Dyb(d), 515);
                                iOc(a, b, false);
                            }
                        }
                        function kid() {
                            kid = geb;
                            jid = new lid(Sye, 0);
                            cid = new lid('BOOLEAN', 1);
                            gid = new lid('INT', 2);
                            iid = new lid('STRING', 3);
                            did = new lid('DOUBLE', 4);
                            eid = new lid('ENUM', 5);
                            fid = new lid('ENUMSET', 6);
                            hid = new lid('OBJECT', 7);
                        }
                        function Sid(a, b) {
                            var c, d, e, f, g;
                            d = $wnd.Math.min(a.c, b.c);
                            f = $wnd.Math.min(a.d, b.d);
                            e = $wnd.Math.max(a.c + a.b, b.c + b.b);
                            g = $wnd.Math.max(a.d + a.a, b.d + b.a);
                            if (e < d) {
                                c = d;
                                d = e;
                                e = c;
                            }
                            if (g < f) {
                                c = f;
                                f = g;
                                g = c;
                            }
                            Rid(a, d, f, e - d, g - f);
                        }
                        function m3d(a, b) {
                            var c, d;
                            if (a.f) {
                                while(b.Ob()){
                                    c = RD(b.Pb(), 76);
                                    d = c.Lk();
                                    if (ZD(d, 102) && (RD(d, 19).Bb & QHe) != 0 && (!a.e || d.pk() != C4 || d.Lj() != 0) && c.md() != null) {
                                        b.Ub();
                                        return true;
                                    }
                                }
                                return false;
                            } else return b.Ob();
                        }
                        function o3d(a, b) {
                            var c, d;
                            if (a.f) {
                                while(b.Sb()){
                                    c = RD(b.Ub(), 76);
                                    d = c.Lk();
                                    if (ZD(d, 102) && (RD(d, 19).Bb & QHe) != 0 && (!a.e || d.pk() != C4 || d.Lj() != 0) && c.md() != null) {
                                        b.Pb();
                                        return true;
                                    }
                                }
                                return false;
                            } else return b.Sb();
                        }
                        function lke() {
                            lke = geb;
                            ike = cD(WC(qJ, 1), Nve, 2, 6, [
                                TKe,
                                UKe,
                                VKe,
                                WKe,
                                XKe,
                                YKe,
                                FIe
                            ]);
                            hke = cD(WC(qJ, 1), Nve, 2, 6, [
                                TKe,
                                'empty',
                                UKe,
                                pKe,
                                'elementOnly'
                            ]);
                            kke = cD(WC(qJ, 1), Nve, 2, 6, [
                                TKe,
                                'preserve',
                                'replace',
                                ZKe
                            ]);
                            jke = new Yee;
                        }
                        function e2b(a, b, c) {
                            var d, e, f;
                            if (b == c) return;
                            d = b;
                            do {
                                $id(a, d.c);
                                e = d.e;
                                if (e) {
                                    f = d.d;
                                    Zid(a, f.b, f.d);
                                    $id(a, e.n);
                                    d = Y2b(e);
                                }
                            }while (e);
                            d = c;
                            do {
                                ojd(a, d.c);
                                e = d.e;
                                if (e) {
                                    f = d.d;
                                    njd(a, f.b, f.d);
                                    ojd(a, e.n);
                                    d = Y2b(e);
                                }
                            }while (e);
                        }
                        function Wlc(a, b, c, d) {
                            var e, f, g, h, i;
                            if (d.f.c + d.i.c == 0) for(g = a.a[a.c], h = 0, i = g.length; h < i; ++h){
                                f = g[h];
                                Zjb(d, f, new dmc(a, f, c));
                            }
                            e = RD(Wd(qtb(d.f, b)), 677);
                            e.b = 0;
                            e.c = e.f;
                            e.c == 0 || gmc(RD(Vmb(e.a, e.b), 294));
                            return e;
                        }
                        function btc() {
                            btc = geb;
                            Zsc = new ctc('MEDIAN_LAYER', 0);
                            _sc = new ctc('TAIL_LAYER', 1);
                            Ysc = new ctc('HEAD_LAYER', 2);
                            $sc = new ctc('SPACE_EFFICIENT_LAYER', 3);
                            atc = new ctc('WIDEST_LAYER', 4);
                            Xsc = new ctc('CENTER_LAYER', 5);
                        }
                        function WGc(a) {
                            var b, c, d, e;
                            a.e = 0;
                            for(e = Sub(a.f, 0); e.b != e.d.c;){
                                d = RD(evb(e), 10);
                                if (d.p >= a.d.b.c.length) {
                                    b = new R4b(a.d);
                                    b.p = d.p - 1;
                                    Rmb(a.d.b, b);
                                    c = new R4b(a.d);
                                    c.p = d.p;
                                    Rmb(a.d.b, c);
                                }
                                g3b(d, RD(Vmb(a.d.b, d.p), 30));
                            }
                        }
                        function DVc(a, b, c) {
                            var d, e, f;
                            if (!a.b[b.g]) {
                                a.b[b.g] = true;
                                d = c;
                                !d && (d = new YWc);
                                Mub(d.b, b);
                                for(f = a.a[b.g].Kc(); f.Ob();){
                                    e = RD(f.Pb(), 65);
                                    e.b != b && DVc(a, e.b, d);
                                    e.c != b && DVc(a, e.c, d);
                                    Mub(d.a, e);
                                }
                                return d;
                            }
                            return null;
                        }
                        function iMb(a) {
                            switch(a.g){
                                case 0:
                                case 1:
                                case 2:
                                    return qpd(), Yod;
                                case 3:
                                case 4:
                                case 5:
                                    return qpd(), npd;
                                case 6:
                                case 7:
                                case 8:
                                    return qpd(), ppd;
                                case 9:
                                case 10:
                                case 11:
                                    return qpd(), Xod;
                                default:
                                    return qpd(), opd;
                            }
                        }
                        function SOc(a, b) {
                            var c;
                            if (a.c.length == 0) return false;
                            c = zDc((tFb(0, a.c.length), RD(a.c[0], 18)).c.i);
                            dOc();
                            if (c == (wDc(), tDc) || c == sDc) return true;
                            return yDb(GDb(new SDb(null, new Swb(a, 16)), new $Oc), new aPc(b));
                        }
                        function KDd(a, b) {
                            if (ZD(b, 207)) return EDd(a, RD(b, 27));
                            else if (ZD(b, 193)) return FDd(a, RD(b, 123));
                            else if (ZD(b, 452)) return DDd(a, RD(b, 166));
                            else throw Adb(new agb(wIe + Fe(new mob(cD(WC(jJ, 1), rve, 1, 5, [
                                b
                            ])))));
                        }
                        function Ou(a, b, c) {
                            var d, e;
                            this.f = a;
                            d = RD(Wjb(a.b, b), 260);
                            e = !d ? 0 : d.a;
                            Sb(c, e);
                            if (c >= (e / 2 | 0)) {
                                this.e = !d ? null : d.c;
                                this.d = e;
                                while(c++ < e)Mu(this);
                            } else {
                                this.c = !d ? null : d.b;
                                while(c-- > 0)Lu(this);
                            }
                            this.b = b;
                            this.a = null;
                        }
                        function iHb(a, b) {
                            var c, d;
                            b.a ? jHb(a, b) : (c = RD(vAb(a.b, b.b), 60), !!c && c == a.a[b.b.f] && !!c.a && c.a != b.b.a && c.c.Fc(b.b), d = RD(uAb(a.b, b.b), 60), !!d && a.a[d.f] == b.b && !!d.a && d.a != b.b.a && b.b.c.Fc(d), wAb(a.b, b.b), undefined);
                        }
                        function wMb(a, b) {
                            var c, d;
                            c = RD(Vrb(a.b, b), 127);
                            if (RD(RD(Qc(a.r, b), 21), 87).dc()) {
                                c.n.b = 0;
                                c.n.c = 0;
                                return;
                            }
                            c.n.b = a.C.b;
                            c.n.c = a.C.c;
                            a.A.Hc((Qpd(), Ppd)) && BMb(a, b);
                            d = AMb(a, b);
                            BLb(a, b) == (pod(), mod) && (d += 2 * a.w);
                            c.a.a = d;
                        }
                        function FNb(a, b) {
                            var c, d;
                            c = RD(Vrb(a.b, b), 127);
                            if (RD(RD(Qc(a.r, b), 21), 87).dc()) {
                                c.n.d = 0;
                                c.n.a = 0;
                                return;
                            }
                            c.n.d = a.C.d;
                            c.n.a = a.C.a;
                            a.A.Hc((Qpd(), Ppd)) && JNb(a, b);
                            d = INb(a, b);
                            BLb(a, b) == (pod(), mod) && (d += 2 * a.w);
                            c.a.b = d;
                        }
                        function VQb(a, b) {
                            var c, d, e, f;
                            f = new bnb;
                            for(d = new Anb(b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 68);
                                Rmb(f, new fRb(c, true));
                                Rmb(f, new fRb(c, false));
                            }
                            e = new $Qb(a);
                            e.a.a.$b();
                            bGb(f, a.b, new mob(cD(WC(bN, 1), rve, 693, 0, [
                                e
                            ])));
                        }
                        function iTb(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p, q;
                            i = a.a;
                            n = a.b;
                            j = b.a;
                            o = b.b;
                            k = c.a;
                            p = c.b;
                            l = d.a;
                            q = d.b;
                            f = i * o - n * j;
                            g = k * q - p * l;
                            e = (i - j) * (p - q) - (n - o) * (k - l);
                            h = (f * (k - l) - g * (i - j)) / e;
                            m = (f * (p - q) - g * (n - o)) / e;
                            return new rjd(h, m);
                        }
                        function Z6b(a, b) {
                            var c, d, e;
                            b.Ug('End label pre-processing', 1);
                            c = Kfb(UD(mQb(a, (yCc(), VBc))));
                            d = Kfb(UD(mQb(a, ZBc)));
                            e = Emd(RD(mQb(a, rAc), 88));
                            FDb(EDb(new SDb(null, new Swb(a.b, 16)), new f7b), new h7b(c, d, e));
                            b.Vg();
                        }
                        function LFc(a, b) {
                            var c, d, e;
                            if (a.d[b.p]) return;
                            a.d[b.p] = true;
                            a.a[b.p] = true;
                            for(d = new is(Mr(a3b(b).a.Kc(), new ir)); gs(d);){
                                c = RD(hs(d), 18);
                                if (W0b(c)) continue;
                                e = c.d.i;
                                a.a[e.p] ? Rmb(a.b, c) : LFc(a, e);
                            }
                            a.a[b.p] = false;
                        }
                        function hGc(a, b, c) {
                            var d;
                            d = 0;
                            switch(RD(mQb(b, (yCc(), UAc)), 171).g){
                                case 2:
                                    d = 2 * -c + a.a;
                                    ++a.a;
                                    break;
                                case 1:
                                    d = -c;
                                    break;
                                case 3:
                                    d = c;
                                    break;
                                case 4:
                                    d = 2 * c + a.b;
                                    ++a.b;
                            }
                            nQb(b, (Ywc(), zwc)) && (d += RD(mQb(b, zwc), 17).a);
                            return d;
                        }
                        function JSc(a, b, c) {
                            var d, e, f;
                            c.zc(b, a);
                            Rmb(a.n, b);
                            f = a.p.zg(b);
                            b.j == a.p.Ag() ? YSc(a.e, f) : YSc(a.j, f);
                            LSc(a);
                            for(e = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                new T3b(b),
                                new _3b(b)
                            ]))); gs(e);){
                                d = RD(hs(e), 12);
                                c._b(d) || JSc(a, d, c);
                            }
                        }
                        function rZc(a, b, c) {
                            var d, e, f;
                            c.Ug('Processor set neighbors', 1);
                            a.a = b.b.b == 0 ? 1 : b.b.b;
                            e = null;
                            d = Sub(b.b, 0);
                            while(!e && d.b != d.d.c){
                                f = RD(evb(d), 40);
                                Heb(TD(mQb(f, (q$c(), n$c)))) && (e = f);
                            }
                            !!e && sZc(a, new dXc(e), c);
                            c.Vg();
                        }
                        function vsd(a) {
                            var b, c, d;
                            c = RD(Gxd(a, (umd(), kld)), 21);
                            if (c.Hc((Qpd(), Mpd))) {
                                d = RD(Gxd(a, pld), 21);
                                b = new sjd(RD(Gxd(a, nld), 8));
                                if (d.Hc((dqd(), Ypd))) {
                                    b.a <= 0 && (b.a = 20);
                                    b.b <= 0 && (b.b = 20);
                                }
                                return b;
                            } else return new pjd;
                        }
                        function nYd(a) {
                            var b, c, d;
                            if (!a.b) {
                                d = new y_d;
                                for(c = new yMd(qYd(a)); c.e != c.i.gc();){
                                    b = RD(xMd(c), 19);
                                    (b.Bb & QHe) != 0 && WGd(d, b);
                                }
                                VHd(d);
                                a.b = new N$d((RD(QHd(xYd((lTd(), kTd).o), 8), 19), d.i), d.g);
                                yYd(a).b &= -9;
                            }
                            return a.b;
                        }
                        function Dhb(a) {
                            var b, c, d;
                            c = a.length;
                            d = 0;
                            while(d < c && (BFb(d, a.length), a.charCodeAt(d) <= 32))++d;
                            b = c;
                            while(b > d && (BFb(b - 1, a.length), a.charCodeAt(b - 1) <= 32))--b;
                            return d > 0 || b < c ? (AFb(d, b, a.length), a.substr(d, b - d)) : a;
                        }
                        function vqc(a, b) {
                            var c, d, e, f, g, h, i, j;
                            i = RD(Ee(Ec(b.k), $C(E3, NAe, 64, 2, 0, 1)), 126);
                            j = b.g;
                            c = xqc(b, i[0]);
                            e = wqc(b, i[1]);
                            d = oqc(a, j, c, e);
                            f = xqc(b, i[1]);
                            h = wqc(b, i[0]);
                            g = oqc(a, j, f, h);
                            if (d <= g) {
                                b.a = c;
                                b.c = e;
                            } else {
                                b.a = f;
                                b.c = h;
                            }
                        }
                        function Eob(a) {
                            var h;
                            yob();
                            var b, c, d, e, f, g;
                            if (ZD(a, 59)) for(e = 0, d = a.gc() - 1; e < d; ++e, --d){
                                h = a.Xb(e);
                                a.hd(e, a.Xb(d));
                                a.hd(d, h);
                            }
                            else {
                                b = a.ed();
                                f = a.fd(a.gc());
                                while(b.Tb() < f.Vb()){
                                    c = b.Pb();
                                    g = f.Ub();
                                    b.Wb(g);
                                    f.Wb(c);
                                }
                            }
                        }
                        function lKc(a, b) {
                            var c, d, e, f, g, h;
                            h = 0;
                            f = new wmb;
                            hmb(f, b);
                            while(f.b != f.c){
                                g = RD(smb(f), 219);
                                h += PLc(g.d, g.e);
                                for(e = new Anb(g.b); e.a < e.c.c.length;){
                                    d = RD(ynb(e), 36);
                                    c = RD(Vmb(a.b, d.p), 219);
                                    c.s || (h += lKc(a, c));
                                }
                            }
                            return h;
                        }
                        function QTc(a, b, c, d, e) {
                            var f, g, h, i, j;
                            if (b) for(h = b.Kc(); h.Ob();){
                                g = RD(h.Pb(), 10);
                                for(j = d3b(g, (BEc(), zEc), c).Kc(); j.Ob();){
                                    i = RD(j.Pb(), 12);
                                    f = RD(Wd(qtb(e.f, i)), 118);
                                    if (!f) {
                                        f = new USc(a.d);
                                        ZEb(d.c, f);
                                        JSc(f, i, e);
                                    }
                                }
                            }
                        }
                        function wVc(a, b, c) {
                            var d, e;
                            rVc(this);
                            b == (dVc(), bVc) ? Ysb(this.r, a.c) : Ysb(this.w, a.c);
                            c == bVc ? Ysb(this.r, a.d) : Ysb(this.w, a.d);
                            sVc(this, a);
                            d = tVc(a.c);
                            e = tVc(a.d);
                            vVc(this, d, e, e);
                            this.o = (HUc(), $wnd.Math.abs(d - e) < 0.2);
                        }
                        function Ade(a, b, c) {
                            var d, e, f, g, h, i;
                            h = RD(Ywd(a.a, 8), 2035);
                            if (h != null) for(e = h, f = 0, g = e.length; f < g; ++f)null.Um();
                            d = c;
                            if ((a.a.Db & 1) == 0) {
                                i = new Fde(a, c, b);
                                d.dj(i);
                            }
                            ZD(d, 686) ? RD(d, 686).fj(a.a) : d.cj() == a.a && d.ej(null);
                        }
                        function Cne() {
                            var a;
                            if (wne) return RD(N5d((YSd(), XSd), dLe), 2044);
                            Dne();
                            a = RD(ZD(Xjb((YSd(), XSd), dLe), 594) ? Xjb(XSd, dLe) : new Bne, 594);
                            wne = true;
                            zne(a);
                            Ane(a);
                            Zjb((hTd(), gTd), a, new Ene);
                            rBd(a);
                            $jb(XSd, dLe, a);
                            return a;
                        }
                        function NA(a, b, c, d) {
                            var e;
                            e = EA(a, c, cD(WC(qJ, 1), Nve, 2, 6, [
                                Swe,
                                Twe,
                                Uwe,
                                Vwe,
                                Wwe,
                                Xwe,
                                Ywe
                            ]), b);
                            e < 0 && (e = EA(a, c, cD(WC(qJ, 1), Nve, 2, 6, [
                                'Sun',
                                'Mon',
                                'Tue',
                                'Wed',
                                'Thu',
                                'Fri',
                                'Sat'
                            ]), b));
                            if (e < 0) return false;
                            d.d = e;
                            return true;
                        }
                        function QA(a, b, c, d) {
                            var e;
                            e = EA(a, c, cD(WC(qJ, 1), Nve, 2, 6, [
                                Swe,
                                Twe,
                                Uwe,
                                Vwe,
                                Wwe,
                                Xwe,
                                Ywe
                            ]), b);
                            e < 0 && (e = EA(a, c, cD(WC(qJ, 1), Nve, 2, 6, [
                                'Sun',
                                'Mon',
                                'Tue',
                                'Wed',
                                'Thu',
                                'Fri',
                                'Sat'
                            ]), b));
                            if (e < 0) return false;
                            d.d = e;
                            return true;
                        }
                        function rtb(a, b, c) {
                            var d, e, f, g;
                            g = a.b.Ce(b);
                            e = (d = a.a.get(g), d == null ? $C(jJ, rve, 1, 0, 5, 1) : d);
                            if (e.length == 0) a.a.set(g, e);
                            else {
                                f = otb(a, b, e);
                                if (f) return f.nd(c);
                            }
                            bD(e, e.length, new xlb(b, c));
                            ++a.c;
                            ++a.b.g;
                            return null;
                        }
                        function PYb(a) {
                            var b, c, d;
                            MYb(a);
                            d = new bnb;
                            for(c = new Anb(a.a.a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 86);
                                Rmb(d, new _Yb(b, true));
                                Rmb(d, new _Yb(b, false));
                            }
                            TYb(a.c);
                            t$b(d, a.b, new mob(cD(WC(wQ, 1), rve, 382, 0, [
                                a.c
                            ])));
                            OYb(a);
                        }
                        function eHb(a, b) {
                            var c, d, e;
                            e = new bnb;
                            for(d = new Anb(a.c.a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 60);
                                if (b.Lb(c)) {
                                    Rmb(e, new sHb(c, true));
                                    Rmb(e, new sHb(c, false));
                                }
                            }
                            kHb(a.e);
                            bGb(e, a.d, new mob(cD(WC(bN, 1), rve, 693, 0, [
                                a.e
                            ])));
                        }
                        function t7b(a) {
                            var b, c, d, e;
                            c = new Tsb;
                            for(e = new Anb(a.d); e.a < e.c.c.length;){
                                d = RD(ynb(e), 187);
                                b = RD(d.of((Ywc(), dwc)), 18);
                                !!qtb(c.f, b) || Zjb(c, b, new G7b(b));
                                Rmb(RD(Wd(qtb(c.f, b)), 466).b, d);
                            }
                            return new dnb(new glb(c));
                        }
                        function Xdc(a, b) {
                            var c, d, e, f, g;
                            d = new xmb(a.j.c.length);
                            c = null;
                            for(f = new Anb(a.j); f.a < f.c.c.length;){
                                e = RD(ynb(f), 12);
                                if (e.j != c) {
                                    d.b == d.c || Ydc(d, c, b);
                                    jmb(d);
                                    c = e.j;
                                }
                                g = c7b(e);
                                !!g && imb(d, g);
                            }
                            d.b == d.c || Ydc(d, c, b);
                        }
                        function Lec(a, b) {
                            var c, d, e;
                            d = new Jkb(a.b, 0);
                            while(d.b < d.d.gc()){
                                c = (sFb(d.b < d.d.gc()), RD(d.d.Xb(d.c = d.b++), 72));
                                e = RD(mQb(c, (yCc(), wAc)), 278);
                                if (e == (Omd(), Mmd)) {
                                    Ckb(d);
                                    Rmb(b.b, c);
                                    nQb(c, (Ywc(), dwc)) || pQb(c, dwc, a);
                                }
                            }
                        }
                        function eIc(a) {
                            var b, c, d, e, f;
                            b = Kr(new is(Mr(a3b(a).a.Kc(), new ir)));
                            for(e = new is(Mr(Z2b(a).a.Kc(), new ir)); gs(e);){
                                d = RD(hs(e), 18);
                                c = d.c.i;
                                f = Kr(new is(Mr(a3b(c).a.Kc(), new ir)));
                                b = $wnd.Math.max(b, f);
                            }
                            return sgb(b);
                        }
                        function Jsd(a, b, c) {
                            var d, e, f;
                            d = RD(Gxd(a, (umd(), Kkd)), 21);
                            e = 0;
                            f = 0;
                            b.a > c.a && (d.Hc((ukd(), okd)) ? e = (b.a - c.a) / 2 : d.Hc(qkd) && (e = b.a - c.a));
                            b.b > c.b && (d.Hc((ukd(), skd)) ? f = (b.b - c.b) / 2 : d.Hc(rkd) && (f = b.b - c.b));
                            Isd(a, e, f);
                        }
                        function ABd(a, b, c, d, e, f, g, h, i, j, k, l, m) {
                            ZD(a.Cb, 90) && v$d(yYd(RD(a.Cb, 90)), 4);
                            PAd(a, c);
                            a.f = g;
                            DWd(a, h);
                            FWd(a, i);
                            xWd(a, j);
                            EWd(a, k);
                            aWd(a, l);
                            AWd(a, m);
                            _Vd(a, true);
                            $Vd(a, e);
                            a.Zk(f);
                            YVd(a, b);
                            d != null && (a.i = null, zWd(a, d));
                        }
                        function Jb(a, b, c) {
                            if (a < 0) return hc(qve, cD(WC(jJ, 1), rve, 1, 5, [
                                c,
                                sgb(a)
                            ]));
                            else if (b < 0) throw Adb(new agb(sve + b));
                            else return hc('%s (%s) must not be greater than size (%s)', cD(WC(jJ, 1), rve, 1, 5, [
                                c,
                                sgb(a),
                                sgb(b)
                            ]));
                        }
                        function Xnb(a, b, c, d, e, f) {
                            var g, h, i, j;
                            g = d - c;
                            if (g < 7) {
                                Unb(b, c, d, f);
                                return;
                            }
                            i = c + e;
                            h = d + e;
                            j = i + (h - i >> 1);
                            Xnb(b, a, i, j, -e, f);
                            Xnb(b, a, j, h, -e, f);
                            if (f.Ne(a[j - 1], a[j]) <= 0) {
                                while(c < d)bD(b, c++, a[i++]);
                                return;
                            }
                            Vnb(a, i, j, h, b, c, d, f);
                        }
                        function Mqc(a, b) {
                            var c, d, e, f, g, h, i;
                            i = b.d;
                            e = b.b.j;
                            for(h = new Anb(i); h.a < h.c.c.length;){
                                g = RD(ynb(h), 105);
                                f = $C(xdb, Hye, 28, e.c.length, 16, 1);
                                Zjb(a.b, g, f);
                                c = g.a.d.p - 1;
                                d = g.c.d.p;
                                while(c != d){
                                    c = (c + 1) % e.c.length;
                                    f[c] = true;
                                }
                            }
                        }
                        function rGc(a, b) {
                            nGc();
                            if (nQb(a, (Ywc(), zwc)) && nQb(b, zwc)) return hgb(RD(mQb(a, zwc), 17).a, RD(mQb(b, zwc), 17).a);
                            throw Adb(new Ked('The BF model order layer assigner requires all real nodes to have a model order.'));
                        }
                        function $Gc(a, b) {
                            SGc();
                            if (nQb(a, (Ywc(), zwc)) && nQb(b, zwc)) return hgb(RD(mQb(a, zwc), 17).a, RD(mQb(b, zwc), 17).a);
                            throw Adb(new Ked('The DF model order layer assigner requires all real nodes to have a model order.'));
                        }
                        function TSc(a, b) {
                            a.r = new USc(a.p);
                            SSc(a.r, a);
                            ye(a.r.j, a.j);
                            Xub(a.j);
                            Mub(a.j, b);
                            Mub(a.r.e, b);
                            LSc(a);
                            LSc(a.r);
                            while(a.f.c.length != 0)$Sc(RD(Vmb(a.f, 0), 132));
                            while(a.k.c.length != 0)$Sc(RD(Vmb(a.k, 0), 132));
                            return a.r;
                        }
                        function Wvd(a, b, c) {
                            var d, e, f;
                            e = vYd(a.Dh(), b);
                            d = b - a.ji();
                            if (d < 0) {
                                if (!e) throw Adb(new agb(OHe + b + PHe));
                                else if (e.rk()) {
                                    f = a.Ih(e);
                                    f >= 0 ? a.bi(f, c) : Svd(a, e, c);
                                } else throw Adb(new agb(KHe + e.xe() + LHe));
                            } else Bvd(a, d, e, c);
                        }
                        function n3d(a) {
                            var b, c;
                            if (a.f) {
                                while(a.n > 0){
                                    b = RD(a.k.Xb(a.n - 1), 76);
                                    c = b.Lk();
                                    if (ZD(c, 102) && (RD(c, 19).Bb & QHe) != 0 && (!a.e || c.pk() != C4 || c.Lj() != 0) && b.md() != null) return true;
                                    else --a.n;
                                }
                                return false;
                            } else return a.n > 0;
                        }
                        function Pje(b) {
                            var c, d, e, f;
                            d = RD(b, 54)._h();
                            if (d) try {
                                e = null;
                                c = N5d((YSd(), XSd), jSd(kSd(d)));
                                if (c) {
                                    f = c.ai();
                                    !!f && (e = f.Fl(Chb(d.e)));
                                }
                                if (!!e && e != b) return Pje(e);
                            } catch (a) {
                                a = zdb(a);
                                if (!ZD(a, 63)) throw Adb(a);
                            }
                            return b;
                        }
                        function P3c(a, b, c) {
                            var d, e, f;
                            c.Ug('Remove overlaps', 1);
                            c.dh(b, eFe);
                            d = RD(Gxd(b, (u2c(), t2c)), 27);
                            a.f = d;
                            a.a = u5c(RD(Gxd(b, ($4c(), X4c)), 300));
                            e = UD(Gxd(b, (umd(), fmd)));
                            s3c(a, (uFb(e), e));
                            f = Q2c(d);
                            O3c(a, b, f, c);
                            c.dh(b, gFe);
                        }
                        function Ded(a) {
                            var b, c, d;
                            if (Heb(TD(Gxd(a, (umd(), $kd))))) {
                                d = new bnb;
                                for(c = new is(Mr(zGd(a).a.Kc(), new ir)); gs(c);){
                                    b = RD(hs(c), 74);
                                    ozd(b) && Heb(TD(Gxd(b, _kd))) && ZEb(d.c, b);
                                }
                                return d;
                            } else return yob(), yob(), vob;
                        }
                        function KC(a) {
                            if (!a) return cC(), bC;
                            var b = a.valueOf ? a.valueOf() : a;
                            if (b !== a) {
                                var c = GC[typeof b];
                                return c ? c(b) : NC(typeof b);
                            } else if (a instanceof Array || a instanceof $wnd.Array) return new NB(a);
                            else return new vC(a);
                        }
                        function IMb(a, b, c) {
                            var d, e, f;
                            f = a.o;
                            d = RD(Vrb(a.p, c), 252);
                            e = d.i;
                            e.b = ZKb(d);
                            e.a = YKb(d);
                            e.b = $wnd.Math.max(e.b, f.a);
                            e.b > f.a && !b && (e.b = f.a);
                            e.c = -(e.b - f.a) / 2;
                            switch(c.g){
                                case 1:
                                    e.d = -e.a;
                                    break;
                                case 3:
                                    e.d = f.b;
                            }
                            $Kb(d);
                            _Kb(d);
                        }
                        function JMb(a, b, c) {
                            var d, e, f;
                            f = a.o;
                            d = RD(Vrb(a.p, c), 252);
                            e = d.i;
                            e.b = ZKb(d);
                            e.a = YKb(d);
                            e.a = $wnd.Math.max(e.a, f.b);
                            e.a > f.b && !b && (e.a = f.b);
                            e.d = -(e.a - f.b) / 2;
                            switch(c.g){
                                case 4:
                                    e.c = -e.b;
                                    break;
                                case 2:
                                    e.c = f.a;
                            }
                            $Kb(d);
                            _Kb(d);
                        }
                        function nkc(a, b) {
                            var c, d, e, f, g;
                            if (b.dc()) return;
                            e = RD(b.Xb(0), 131);
                            if (b.gc() == 1) {
                                mkc(a, e, e, 1, 0, b);
                                return;
                            }
                            c = 1;
                            while(c < b.gc())if (e.j || !e.o) {
                                f = skc(b, c);
                                if (f) {
                                    d = RD(f.a, 17).a;
                                    g = RD(f.b, 131);
                                    mkc(a, e, g, c, d, b);
                                    c = d + 1;
                                    e = g;
                                }
                            }
                        }
                        function Soc(a) {
                            var b, c, d, e, f, g;
                            g = new dnb(a.d);
                            _mb(g, new upc);
                            b = (epc(), cD(WC(hW, 1), jwe, 276, 0, [
                                Zoc,
                                apc,
                                Yoc,
                                dpc,
                                _oc,
                                $oc,
                                cpc,
                                bpc
                            ]));
                            c = 0;
                            for(f = new Anb(g); f.a < f.c.c.length;){
                                e = RD(ynb(f), 105);
                                d = b[c % b.length];
                                Uoc(e, d);
                                ++c;
                            }
                        }
                        function zid(a, b) {
                            tid();
                            var c, d, e, f;
                            if (b.b < 2) return false;
                            f = Sub(b, 0);
                            c = RD(evb(f), 8);
                            d = c;
                            while(f.b != f.d.c){
                                e = RD(evb(f), 8);
                                if (!(xid(a, d) && xid(a, e))) return false;
                                d = e;
                            }
                            if (!(xid(a, d) && xid(a, c))) return false;
                            return true;
                        }
                        function HEd(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            k = null;
                            l = a;
                            g = vDd(l, 'x');
                            c = new iFd(b);
                            eEd(c.a, g);
                            h = vDd(l, 'y');
                            d = new jFd(b);
                            fEd(d.a, h);
                            i = vDd(l, fIe);
                            e = new kFd(b);
                            gEd(e.a, i);
                            j = vDd(l, eIe);
                            f = new lFd(b);
                            k = (hEd(f.a, j), j);
                            return k;
                        }
                        function v$d(a, b) {
                            r$d(a, b);
                            (a.b & 1) != 0 && (a.a.a = null);
                            (a.b & 2) != 0 && (a.a.f = null);
                            if ((a.b & 4) != 0) {
                                a.a.g = null;
                                a.a.i = null;
                            }
                            if ((a.b & 16) != 0) {
                                a.a.d = null;
                                a.a.e = null;
                            }
                            (a.b & 8) != 0 && (a.a.b = null);
                            if ((a.b & 32) != 0) {
                                a.a.j = null;
                                a.a.c = null;
                            }
                        }
                        function Lde(b, c) {
                            var d, e, f;
                            f = 0;
                            if (c.length > 0) try {
                                f = Oeb(c, qwe, lve);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 130)) {
                                    e = a;
                                    throw Adb(new RSd(e));
                                } else throw Adb(a);
                            }
                            d = (!b.a && (b.a = new Zde(b)), b.a);
                            return f < d.i && f >= 0 ? RD(QHd(d, f), 58) : null;
                        }
                        function Ib(a, b) {
                            if (a < 0) return hc(qve, cD(WC(jJ, 1), rve, 1, 5, [
                                'index',
                                sgb(a)
                            ]));
                            else if (b < 0) throw Adb(new agb(sve + b));
                            else return hc('%s (%s) must be less than size (%s)', cD(WC(jJ, 1), rve, 1, 5, [
                                'index',
                                sgb(a),
                                sgb(b)
                            ]));
                        }
                        function cob(a) {
                            var b, c, d, e, f;
                            if (a == null) return vve;
                            f = new Jyb(pve, '[', ']');
                            for(c = a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                !f.a ? f.a = new dib(f.d) : Zhb(f.a, f.b);
                                Whb(f.a, '' + b);
                            }
                            return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
                        }
                        function dob(a) {
                            var b, c, d, e, f;
                            if (a == null) return vve;
                            f = new Jyb(pve, '[', ']');
                            for(c = a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                !f.a ? f.a = new dib(f.d) : Zhb(f.a, f.b);
                                Whb(f.a, '' + b);
                            }
                            return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
                        }
                        function eob(a) {
                            var b, c, d, e, f;
                            if (a == null) return vve;
                            f = new Jyb(pve, '[', ']');
                            for(c = a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                !f.a ? f.a = new dib(f.d) : Zhb(f.a, f.b);
                                Whb(f.a, '' + b);
                            }
                            return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
                        }
                        function hob(a) {
                            var b, c, d, e, f;
                            if (a == null) return vve;
                            f = new Jyb(pve, '[', ']');
                            for(c = a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                !f.a ? f.a = new dib(f.d) : Zhb(f.a, f.b);
                                Whb(f.a, '' + b);
                            }
                            return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
                        }
                        function kwb(a, b) {
                            var c, d, e, f, g, h;
                            c = a.b.c.length;
                            e = Vmb(a.b, b);
                            while(b * 2 + 1 < c){
                                d = (f = 2 * b + 1, g = f + 1, h = f, g < c && a.a.Ne(Vmb(a.b, g), Vmb(a.b, f)) < 0 && (h = g), h);
                                if (a.a.Ne(e, Vmb(a.b, d)) < 0) break;
                                $mb(a.b, b, Vmb(a.b, d));
                                b = d;
                            }
                            $mb(a.b, b, e);
                        }
                        function oJb(a, b, c) {
                            var d, e;
                            d = c.d;
                            e = c.e;
                            if (a.g[d.d] <= a.i[b.d] && a.i[b.d] <= a.i[d.d] && a.g[e.d] <= a.i[b.d] && a.i[b.d] <= a.i[e.d]) {
                                if (a.i[d.d] < a.i[e.d]) return false;
                                return true;
                            }
                            if (a.i[d.d] < a.i[e.d]) return true;
                            return false;
                        }
                        function SWb(a, b) {
                            var c;
                            c = RD(mQb(b, (yCc(), oAc)), 322);
                            if (c != a) throw Adb(new Ked('The hierarchy aware processor ' + c + ' in child node ' + b + ' is only allowed if the root node specifies the same hierarchical processor.'));
                        }
                        function Kee(a, b) {
                            var c, d, e, f, g;
                            d = (!b.s && (b.s = new C5d(y7, b, 21, 17)), b.s);
                            f = null;
                            for(e = 0, g = d.i; e < g; ++e){
                                c = RD(QHd(d, e), 179);
                                switch(yfe(Qee(a, c))){
                                    case 2:
                                    case 3:
                                        !f && (f = new bnb);
                                        ZEb(f.c, c);
                                }
                            }
                            return !f ? (yob(), yob(), vob) : f;
                        }
                        function PQb(a, b, c) {
                            var d, e, f, g, h, i;
                            i = oxe;
                            for(f = new Anb(nRb(a.b)); f.a < f.c.c.length;){
                                e = RD(ynb(f), 177);
                                for(h = new Anb(nRb(b.b)); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 177);
                                    d = Aid(e.a, e.b, g.a, g.b, c);
                                    i = $wnd.Math.min(i, d);
                                }
                            }
                            return i;
                        }
                        function Q3b(a, b) {
                            if (!b) throw Adb(new Ngb);
                            a.j = b;
                            if (!a.d) switch(a.j.g){
                                case 1:
                                    a.a.a = a.o.a / 2;
                                    a.a.b = 0;
                                    break;
                                case 2:
                                    a.a.a = a.o.a;
                                    a.a.b = a.o.b / 2;
                                    break;
                                case 3:
                                    a.a.a = a.o.a / 2;
                                    a.a.b = a.o.b;
                                    break;
                                case 4:
                                    a.a.a = 0;
                                    a.a.b = a.o.b / 2;
                            }
                        }
                        function Jic(a, b) {
                            var c, d, e;
                            if (ZD(b.g, 10) && RD(b.g, 10).k == (r3b(), m3b)) return oxe;
                            e = $jc(b);
                            if (e) return $wnd.Math.max(0, a.b / 2 - 0.5);
                            c = Zjc(b);
                            if (c) {
                                d = Kfb(UD(hFc(c, (yCc(), bCc))));
                                return $wnd.Math.max(0, d / 2 - 0.5);
                            }
                            return oxe;
                        }
                        function Lic(a, b) {
                            var c, d, e;
                            if (ZD(b.g, 10) && RD(b.g, 10).k == (r3b(), m3b)) return oxe;
                            e = $jc(b);
                            if (e) return $wnd.Math.max(0, a.b / 2 - 0.5);
                            c = Zjc(b);
                            if (c) {
                                d = Kfb(UD(hFc(c, (yCc(), bCc))));
                                return $wnd.Math.max(0, d / 2 - 0.5);
                            }
                            return oxe;
                        }
                        function Jkc(a, b) {
                            lkc();
                            var c, d, e, f, g, h;
                            c = null;
                            for(g = b.Kc(); g.Ob();){
                                f = RD(g.Pb(), 131);
                                if (f.o) continue;
                                d = Qid(f.a);
                                e = Nid(f.a);
                                h = new Nlc(d, e, null, RD(f.d.a.ec().Kc().Pb(), 18));
                                Rmb(h.c, f.a);
                                ZEb(a.c, h);
                                !!c && Rmb(c.d, h);
                                c = h;
                            }
                        }
                        function bmc(a) {
                            var b, c, d, e, f, g;
                            g = aMc(a.d, a.e);
                            for(f = g.Kc(); f.Ob();){
                                e = RD(f.Pb(), 12);
                                d = a.e == (qpd(), ppd) ? e.e : e.g;
                                for(c = new Anb(d); c.a < c.c.c.length;){
                                    b = RD(ynb(c), 18);
                                    if (!W0b(b) && b.c.i.c != b.d.i.c) {
                                        Zlc(a, b);
                                        ++a.f;
                                        ++a.c;
                                    }
                                }
                            }
                        }
                        function Wsc(a, b) {
                            var c, d;
                            if (b.dc()) return yob(), yob(), vob;
                            d = new bnb;
                            Rmb(d, sgb(qwe));
                            for(c = 1; c < a.f; ++c){
                                a.a == null && usc(a);
                                a.a[c] && Rmb(d, sgb(c));
                            }
                            if (d.c.length == 1) return yob(), yob(), vob;
                            Rmb(d, sgb(lve));
                            return Vsc(b, d);
                        }
                        function kOc(a, b) {
                            var c, d, e, f, g, h, i;
                            g = b.c.i.k != (r3b(), p3b);
                            i = g ? b.d : b.c;
                            c = U0b(b, i).i;
                            e = RD(Wjb(a.k, i), 125);
                            d = a.i[c.p].a;
                            if ($2b(i.i) < (!c.c ? -1 : Wmb(c.c.a, c, 0))) {
                                f = e;
                                h = d;
                            } else {
                                f = d;
                                h = e;
                            }
                            rIb(uIb(tIb(vIb(sIb(new wIb, 0), 4), f), h));
                        }
                        function ODd(a, b, c) {
                            var d, e, f, g, h, i;
                            if (c) {
                                e = c.a.length;
                                d = new vue(e);
                                for(h = (d.b - d.a) * d.c < 0 ? (uue(), tue) : new Rue(d); h.Ob();){
                                    g = RD(h.Pb(), 17);
                                    i = uEd(a, tDd(JB(c, g.a)));
                                    if (i) {
                                        f = (!b.b && (b.b = new Yie(E4, b, 4, 7)), b.b);
                                        WGd(f, i);
                                    }
                                }
                            }
                        }
                        function PDd(a, b, c) {
                            var d, e, f, g, h, i;
                            if (c) {
                                e = c.a.length;
                                d = new vue(e);
                                for(h = (d.b - d.a) * d.c < 0 ? (uue(), tue) : new Rue(d); h.Ob();){
                                    g = RD(h.Pb(), 17);
                                    i = uEd(a, tDd(JB(c, g.a)));
                                    if (i) {
                                        f = (!b.c && (b.c = new Yie(E4, b, 5, 8)), b.c);
                                        WGd(f, i);
                                    }
                                }
                            }
                        }
                        function Bo(a, b, c) {
                            var d, e;
                            d = b.a & a.f;
                            b.b = a.b[d];
                            a.b[d] = b;
                            e = b.f & a.f;
                            b.d = a.c[e];
                            a.c[e] = b;
                            if (!c) {
                                b.e = a.e;
                                b.c = null;
                                !a.e ? a.a = b : a.e.c = b;
                                a.e = b;
                            } else {
                                b.e = c.e;
                                !b.e ? a.a = b : b.e.c = b;
                                b.c = c.c;
                                !b.c ? a.e = b : b.c.e = b;
                            }
                            ++a.i;
                            ++a.g;
                        }
                        function Ir(a) {
                            var b, c, d;
                            b = a.Pb();
                            if (!a.Ob()) return b;
                            d = Yhb(Zhb(new bib, 'expected one element but was: <'), b);
                            for(c = 0; c < 4 && a.Ob(); c++)Yhb((d.a += pve, d), a.Pb());
                            a.Ob() && (d.a += ', ...', d);
                            d.a += '>';
                            throw Adb(new agb(d.a));
                        }
                        function cB(a) {
                            var b, c;
                            c = -a.a;
                            b = cD(WC(hE, 1), zwe, 28, 15, [
                                43,
                                48,
                                48,
                                48,
                                48
                            ]);
                            if (c < 0) {
                                b[0] = 45;
                                c = -c;
                            }
                            b[1] = b[1] + ((c / 60 | 0) / 10 | 0) & Bwe;
                            b[2] = b[2] + (c / 60 | 0) % 10 & Bwe;
                            b[3] = b[3] + (c % 60 / 10 | 0) & Bwe;
                            b[4] = b[4] + c % 10 & Bwe;
                            return Ihb(b, 0, b.length);
                        }
                        function V2b(a) {
                            var b, c, d, e;
                            a.g = new Zrb(RD(Qb(E3), 297));
                            d = 0;
                            c = (qpd(), Yod);
                            b = 0;
                            for(; b < a.j.c.length; b++){
                                e = RD(Vmb(a.j, b), 12);
                                if (e.j != c) {
                                    d != b && Wrb(a.g, c, new Ptd(sgb(d), sgb(b)));
                                    c = e.j;
                                    d = b;
                                }
                            }
                            Wrb(a.g, c, new Ptd(sgb(d), sgb(b)));
                        }
                        function u7b(a) {
                            var b, c, d, e, f, g, h;
                            d = 0;
                            for(c = new Anb(a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 30);
                                for(f = new Anb(b.a); f.a < f.c.c.length;){
                                    e = RD(ynb(f), 10);
                                    e.p = d++;
                                    for(h = new Anb(e.j); h.a < h.c.c.length;){
                                        g = RD(ynb(h), 12);
                                        g.p = d++;
                                    }
                                }
                            }
                        }
                        function Tvd(a, b) {
                            var c, d, e;
                            e = Eee((lke(), jke), a.Dh(), b);
                            if (e) {
                                nke();
                                RD(e, 69).xk() || (e = zfe(Qee(jke, e)));
                                d = (c = a.Ih(e), RD(c >= 0 ? a.Lh(c, true, true) : Qvd(a, e, true), 160));
                                RD(d, 220).Zl(b);
                            } else throw Adb(new agb(KHe + b.xe() + LHe));
                        }
                        function Cib(a) {
                            var b, c;
                            if (a > -140737488355328 && a < 140737488355328) {
                                if (a == 0) return 0;
                                b = a < 0;
                                b && (a = -a);
                                c = eE($wnd.Math.floor($wnd.Math.log(a) / 0.6931471805599453));
                                (!b || a != $wnd.Math.pow(2, c)) && ++c;
                                return c;
                            }
                            return Dib(Hdb(a));
                        }
                        function oTc(a) {
                            var b, c, d, e, f, g, h;
                            f = new Iub;
                            for(c = new Anb(a); c.a < c.c.c.length;){
                                b = RD(ynb(c), 132);
                                g = b.a;
                                h = b.b;
                                if (f.a._b(g) || f.a._b(h)) continue;
                                e = g;
                                d = h;
                                if (g.e.b + g.j.b > 2 && h.e.b + h.j.b <= 2) {
                                    e = h;
                                    d = g;
                                }
                                f.a.zc(e, f);
                                e.q = d;
                            }
                            return f;
                        }
                        function B5c(a, b, c) {
                            c.Ug('Eades radial', 1);
                            c.dh(b, gFe);
                            a.d = RD(Gxd(b, (u2c(), t2c)), 27);
                            a.c = Kfb(UD(Gxd(b, ($4c(), S4c))));
                            a.e = u5c(RD(Gxd(b, X4c), 300));
                            a.a = Z3c(RD(Gxd(b, Z4c), 434));
                            a.b = k5c(RD(Gxd(b, O4c), 354));
                            C5c(a);
                            c.dh(b, gFe);
                        }
                        function t8c(a, b) {
                            b.Ug('Target Width Setter', 1);
                            if (Hxd(a, (X7c(), W7c))) Ixd(a, (X6c(), W6c), UD(Gxd(a, W7c)));
                            else throw Adb(new Jed('A target width has to be set if the TargetWidthWidthApproximator should be used.'));
                            b.Vg();
                        }
                        function _8b(a, b) {
                            var c, d, e;
                            d = new j3b(a);
                            kQb(d, b);
                            pQb(d, (Ywc(), gwc), b);
                            pQb(d, (yCc(), BBc), (Bod(), wod));
                            pQb(d, Rzc, (Rjd(), Njd));
                            h3b(d, (r3b(), m3b));
                            c = new R3b;
                            P3b(c, d);
                            Q3b(c, (qpd(), ppd));
                            e = new R3b;
                            P3b(e, d);
                            Q3b(e, Xod);
                            return d;
                        }
                        function ttc(a) {
                            switch(a.g){
                                case 0:
                                    return new FKc((RKc(), OKc));
                                case 1:
                                    return new aKc;
                                case 2:
                                    return new FLc;
                                default:
                                    throw Adb(new agb('No implementation is available for the crossing minimizer ' + (a.f != null ? a.f : '' + a.g)));
                            }
                        }
                        function THc(a, b) {
                            var c, d, e, f, g;
                            a.c[b.p] = true;
                            Rmb(a.a, b);
                            for(g = new Anb(b.j); g.a < g.c.c.length;){
                                f = RD(ynb(g), 12);
                                for(d = new l4b(f.b); xnb(d.a) || xnb(d.b);){
                                    c = RD(xnb(d.a) ? ynb(d.a) : ynb(d.b), 18);
                                    e = UHc(f, c).i;
                                    a.c[e.p] || THc(a, e);
                                }
                            }
                        }
                        function J2c(a) {
                            var b, c, d, e, f, g, h;
                            g = 0;
                            for(c = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); c.e != c.i.gc();){
                                b = RD(bMd(c), 27);
                                h = b.g;
                                e = b.f;
                                d = $wnd.Math.sqrt(h * h + e * e);
                                g = $wnd.Math.max(d, g);
                                f = J2c(b);
                                g = $wnd.Math.max(f, g);
                            }
                            return g;
                        }
                        function Pod() {
                            Pod = geb;
                            Nod = new Qod('OUTSIDE', 0);
                            Lod = new Qod('INSIDE', 1);
                            Mod = new Qod('NEXT_TO_PORT_IF_POSSIBLE', 2);
                            Kod = new Qod('ALWAYS_SAME_SIDE', 3);
                            Jod = new Qod('ALWAYS_OTHER_SAME_SIDE', 4);
                            Ood = new Qod('SPACE_EFFICIENT', 5);
                        }
                        function DEd(a, b, c) {
                            var d, e, f, h, i, j;
                            d = rEd(a, (e = (bvd(), f = new ACd, f), !!c && yCd(e, c), e), b);
                            jyd(d, zDd(b, uIe));
                            GEd(b, d);
                            BEd(b, d);
                            HEd(b, d);
                            g = null;
                            h = b;
                            i = wDd(h, 'ports');
                            j = new hFd(a, d);
                            dEd(j.a, j.b, i);
                            CEd(a, b, d);
                            xEd(a, b, d);
                            return d;
                        }
                        function bB(a) {
                            var b, c;
                            c = -a.a;
                            b = cD(WC(hE, 1), zwe, 28, 15, [
                                43,
                                48,
                                48,
                                58,
                                48,
                                48
                            ]);
                            if (c < 0) {
                                b[0] = 45;
                                c = -c;
                            }
                            b[1] = b[1] + ((c / 60 | 0) / 10 | 0) & Bwe;
                            b[2] = b[2] + (c / 60 | 0) % 10 & Bwe;
                            b[4] = b[4] + (c % 60 / 10 | 0) & Bwe;
                            b[5] = b[5] + c % 10 & Bwe;
                            return Ihb(b, 0, b.length);
                        }
                        function eB(a) {
                            var b;
                            b = cD(WC(hE, 1), zwe, 28, 15, [
                                71,
                                77,
                                84,
                                45,
                                48,
                                48,
                                58,
                                48,
                                48
                            ]);
                            if (a <= 0) {
                                b[3] = 43;
                                a = -a;
                            }
                            b[4] = b[4] + ((a / 60 | 0) / 10 | 0) & Bwe;
                            b[5] = b[5] + (a / 60 | 0) % 10 & Bwe;
                            b[7] = b[7] + (a % 60 / 10 | 0) & Bwe;
                            b[8] = b[8] + a % 10 & Bwe;
                            return Ihb(b, 0, b.length);
                        }
                        function fob(a) {
                            var b, c, d, e, f;
                            if (a == null) return vve;
                            f = new Jyb(pve, '[', ']');
                            for(c = a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                !f.a ? f.a = new dib(f.d) : Zhb(f.a, f.b);
                                Whb(f.a, '' + Zdb(b));
                            }
                            return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
                        }
                        function uJb(a, b) {
                            var c, d, e;
                            e = lve;
                            for(d = new Anb(CIb(b)); d.a < d.c.c.length;){
                                c = RD(ynb(d), 218);
                                if (c.f && !a.c[c.c]) {
                                    a.c[c.c] = true;
                                    e = $wnd.Math.min(e, uJb(a, oIb(c, b)));
                                }
                            }
                            a.i[b.d] = a.j;
                            a.g[b.d] = $wnd.Math.min(e, a.j++);
                            return a.g[b.d];
                        }
                        function vNb(a, b) {
                            var c, d, e;
                            for(e = RD(RD(Qc(a.r, b), 21), 87).Kc(); e.Ob();){
                                d = RD(e.Pb(), 117);
                                d.e.b = (c = d.b, c.pf((umd(), Gld)) ? c.ag() == (qpd(), Yod) ? -c.Mf().b - Kfb(UD(c.of(Gld))) : Kfb(UD(c.of(Gld))) : c.ag() == (qpd(), Yod) ? -c.Mf().b : 0);
                            }
                        }
                        function CSb(a) {
                            var b, c, d, e, f, g, h;
                            c = zRb(a.e);
                            f = ijd(njd(ajd(yRb(a.e)), a.d * a.a, a.c * a.b), -0.5);
                            b = c.a - f.a;
                            e = c.b - f.b;
                            for(h = 0; h < a.c; h++){
                                d = b;
                                for(g = 0; g < a.d; g++){
                                    ARb(a.e, new Uid(d, e, a.a, a.b)) && TPb(a, g, h, false, true);
                                    d += a.a;
                                }
                                e += a.b;
                            }
                        }
                        function H0c(a) {
                            var b, c, d, e, f;
                            b = a.a;
                            c = a.b;
                            e = a.c;
                            d = new rjd(c.e.a + c.f.a / 2, c.e.b + c.f.b / 2);
                            f = new rjd(e.e.a + e.f.a / 2, e.e.b + e.f.b / 2);
                            Pub(b, d, b.a, b.a.a);
                            Pub(b, f, b.c.b, b.c);
                            tWc(d, RD(ju(b, 1), 8), a.b.f);
                            tWc(f, RD(ju(b, b.b - 2), 8), a.c.f);
                        }
                        function tDd(a) {
                            var b, c;
                            c = false;
                            if (ZD(a, 211)) {
                                c = true;
                                return RD(a, 211).a;
                            }
                            if (!c) {
                                if (ZD(a, 263)) {
                                    b = RD(a, 263).a % 1 == 0;
                                    if (b) {
                                        c = true;
                                        return sgb(Ofb(RD(a, 263).a));
                                    }
                                }
                            }
                            throw Adb(new CDd("Id must be a string or an integer: '" + a + "'."));
                        }
                        function Kde(a, b) {
                            var c, d, e, f, g, h;
                            f = null;
                            for(e = new Xde((!a.a && (a.a = new Zde(a)), a.a)); Ude(e);){
                                c = RD(tId(e), 58);
                                d = (g = c.Dh(), h = (mYd(g), g.o), !h || !c.Xh(h) ? null : Hje(iXd(h), c.Mh(h)));
                                if (d != null) {
                                    if (lhb(d, b)) {
                                        f = c;
                                        break;
                                    }
                                }
                            }
                            return f;
                        }
                        function Rw(a, b, c) {
                            var d, e, f, g, h;
                            dk(c, 'occurrences');
                            if (c == 0) return h = RD(Xv(nd(a.a), b), 16), !h ? 0 : h.gc();
                            g = RD(Xv(nd(a.a), b), 16);
                            if (!g) return 0;
                            f = g.gc();
                            if (c >= f) g.$b();
                            else {
                                e = g.Kc();
                                for(d = 0; d < c; d++){
                                    e.Pb();
                                    e.Qb();
                                }
                            }
                            return f;
                        }
                        function qx(a, b, c) {
                            var d, e, f, g;
                            dk(c, 'oldCount');
                            dk(0, 'newCount');
                            d = RD(Xv(nd(a.a), b), 16);
                            if ((!d ? 0 : d.gc()) == c) {
                                dk(0, 'count');
                                e = (f = RD(Xv(nd(a.a), b), 16), !f ? 0 : f.gc());
                                g = -e;
                                g > 0 ? Hh() : g < 0 && Rw(a, b, -g);
                                return true;
                            } else return false;
                        }
                        function YKb(a) {
                            var b, c, d, e, f, g, h;
                            h = 0;
                            if (a.b == 0) {
                                g = aLb(a, true);
                                b = 0;
                                for(d = g, e = 0, f = d.length; e < f; ++e){
                                    c = d[e];
                                    if (c > 0) {
                                        h += c;
                                        ++b;
                                    }
                                }
                                b > 1 && (h += a.c * (b - 1));
                            } else h = Vvb(SCb(HDb(CDb(_nb(a.a), new oLb), new qLb)));
                            return h > 0 ? h + a.n.d + a.n.a : 0;
                        }
                        function ZKb(a) {
                            var b, c, d, e, f, g, h;
                            h = 0;
                            if (a.b == 0) h = Vvb(SCb(HDb(CDb(_nb(a.a), new kLb), new mLb)));
                            else {
                                g = bLb(a, true);
                                b = 0;
                                for(d = g, e = 0, f = d.length; e < f; ++e){
                                    c = d[e];
                                    if (c > 0) {
                                        h += c;
                                        ++b;
                                    }
                                }
                                b > 1 && (h += a.c * (b - 1));
                            }
                            return h > 0 ? h + a.n.b + a.n.c : 0;
                        }
                        function UOc(a) {
                            var b, c;
                            if (a.c.length != 2) throw Adb(new dgb('Order only allowed for two paths.'));
                            b = (tFb(0, a.c.length), RD(a.c[0], 18));
                            c = (tFb(1, a.c.length), RD(a.c[1], 18));
                            if (b.d.i != c.c.i) {
                                a.c.length = 0;
                                ZEb(a.c, c);
                                ZEb(a.c, b);
                            }
                        }
                        function O8c(a, b, c) {
                            var d;
                            zyd(c, b.g, b.f);
                            Byd(c, b.i, b.j);
                            for(d = 0; d < (!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a).i; d++)O8c(a, RD(QHd((!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a), d), 27), RD(QHd((!c.a && (c.a = new C5d(J4, c, 10, 11)), c.a), d), 27));
                        }
                        function DMb(a, b) {
                            var c, d, e, f;
                            f = RD(Vrb(a.b, b), 127);
                            c = f.a;
                            for(e = RD(RD(Qc(a.r, b), 21), 87).Kc(); e.Ob();){
                                d = RD(e.Pb(), 117);
                                !!d.c && (c.a = $wnd.Math.max(c.a, QKb(d.c)));
                            }
                            if (c.a > 0) switch(b.g){
                                case 2:
                                    f.n.c = a.s;
                                    break;
                                case 4:
                                    f.n.b = a.s;
                            }
                        }
                        function ETb(a, b) {
                            var c, d, e;
                            c = RD(mQb(b, (yVb(), lVb)), 17).a - RD(mQb(a, lVb), 17).a;
                            if (c == 0) {
                                d = ojd(ajd(RD(mQb(a, (JVb(), FVb)), 8)), RD(mQb(a, GVb), 8));
                                e = ojd(ajd(RD(mQb(b, FVb), 8)), RD(mQb(b, GVb), 8));
                                return Qfb(d.a * d.b, e.a * e.b);
                            }
                            return c;
                        }
                        function JVc(a, b) {
                            var c, d, e;
                            c = RD(mQb(b, (h_c(), X$c)), 17).a - RD(mQb(a, X$c), 17).a;
                            if (c == 0) {
                                d = ojd(ajd(RD(mQb(a, (q$c(), RZc)), 8)), RD(mQb(a, SZc), 8));
                                e = ojd(ajd(RD(mQb(b, RZc), 8)), RD(mQb(b, SZc), 8));
                                return Qfb(d.a * d.b, e.a * e.b);
                            }
                            return c;
                        }
                        function _0b(a) {
                            var b, c;
                            c = new bib;
                            c.a += 'e_';
                            b = S0b(a);
                            b != null && (c.a += '' + b, c);
                            if (!!a.c && !!a.d) {
                                Zhb((c.a += ' ', c), M3b(a.c));
                                Zhb(Yhb((c.a += '[', c), a.c.i), ']');
                                Zhb((c.a += SAe, c), M3b(a.d));
                                Zhb(Yhb((c.a += '[', c), a.d.i), ']');
                            }
                            return c.a;
                        }
                        function ZVc(a) {
                            switch(a.g){
                                case 0:
                                    return new N_c;
                                case 1:
                                    return new V_c;
                                case 2:
                                    return new x0c;
                                case 3:
                                    return new J0c;
                                default:
                                    throw Adb(new agb('No implementation is available for the layout phase ' + (a.f != null ? a.f : '' + a.g)));
                            }
                        }
                        function qsd(a, b, c, d, e) {
                            var f;
                            f = 0;
                            switch(e.g){
                                case 1:
                                    f = $wnd.Math.max(0, b.b + a.b - (c.b + d));
                                    break;
                                case 3:
                                    f = $wnd.Math.max(0, -a.b - d);
                                    break;
                                case 2:
                                    f = $wnd.Math.max(0, -a.a - d);
                                    break;
                                case 4:
                                    f = $wnd.Math.max(0, b.a + a.a - (c.a + d));
                            }
                            return f;
                        }
                        function MDd(a, b, c) {
                            var d, e, f, g, h;
                            if (c) {
                                e = c.a.length;
                                d = new vue(e);
                                for(h = (d.b - d.a) * d.c < 0 ? (uue(), tue) : new Rue(d); h.Ob();){
                                    g = RD(h.Pb(), 17);
                                    f = xDd(c, g.a);
                                    kIe in f.a || lIe in f.a ? yEd(a, f, b) : EEd(a, f, b);
                                    OGd(RD(Wjb(a.b, uDd(f)), 74));
                                }
                            }
                        }
                        function jXd(a) {
                            var b, c;
                            switch(a.b){
                                case -1:
                                    return true;
                                case 0:
                                    c = a.t;
                                    if (c > 1 || c == -1) {
                                        a.b = -1;
                                        return true;
                                    } else {
                                        b = WVd(a);
                                        if (!!b && (nke(), b.lk() == aKe)) {
                                            a.b = -1;
                                            return true;
                                        } else {
                                            a.b = 1;
                                            return false;
                                        }
                                    }
                                default:
                                case 1:
                                    return false;
                            }
                        }
                        function Sqe(a, b) {
                            var c, d, e, f;
                            Mqe(a);
                            if (a.c != 0 || a.a != 123) throw Adb(new Lqe(TId((Hde(), eJe))));
                            f = b == 112;
                            d = a.d;
                            c = phb(a.i, 125, d);
                            if (c < 0) throw Adb(new Lqe(TId((Hde(), fJe))));
                            e = zhb(a.i, d, c);
                            a.d = c + 1;
                            return ite(e, f, (a.e & 512) == 512);
                        }
                        function YTb(a) {
                            var b, c, d, e, f, g, h;
                            d = a.a.c.length;
                            if (d > 0) {
                                g = a.c.d;
                                h = a.d.d;
                                e = ijd(ojd(new rjd(h.a, h.b), g), 1 / (d + 1));
                                f = new rjd(g.a, g.b);
                                for(c = new Anb(a.a); c.a < c.c.c.length;){
                                    b = RD(ynb(c), 250);
                                    b.d.a = f.a + e.a;
                                    b.d.b = f.b + e.b;
                                    $id(f, e);
                                }
                            }
                        }
                        function HXd(a, b) {
                            var c, d, e;
                            if (!b) {
                                JXd(a, null);
                                zXd(a, null);
                            } else if ((b.i & 4) != 0) {
                                d = '[]';
                                for(c = b.c;; c = c.c){
                                    if ((c.i & 4) == 0) {
                                        e = shb((lfb(c), c.o + d));
                                        JXd(a, e);
                                        zXd(a, e);
                                        break;
                                    }
                                    d += '[]';
                                }
                            } else {
                                e = shb((lfb(b), b.o));
                                JXd(a, e);
                                zXd(a, e);
                            }
                            a.hl(b);
                        }
                        function Bge(a, b, c, d, e) {
                            var f, g, h, i;
                            i = Age(a, RD(e, 58));
                            if (dE(i) !== dE(e)) {
                                h = RD(a.g[c], 76);
                                f = oke(b, i);
                                MHd(a, c, Tge(a, c, f));
                                if (Mvd(a.e)) {
                                    g = fge(a, 9, f.Lk(), e, i, d, false);
                                    oKd(g, new P3d(a.e, 9, a.c, h, f, d, false));
                                    pKd(g);
                                }
                                return i;
                            }
                            return e;
                        }
                        function AGc(a, b, c) {
                            var d, e, f, g, h, i;
                            d = RD(Qc(a.c, b), 15);
                            e = RD(Qc(a.c, c), 15);
                            f = d.fd(d.gc());
                            g = e.fd(e.gc());
                            while(f.Sb() && g.Sb()){
                                h = RD(f.Ub(), 17);
                                i = RD(g.Ub(), 17);
                                if (h != i) return hgb(h.a, i.a);
                            }
                            return !f.Ob() && !g.Ob() ? 0 : f.Ob() ? 1 : -1;
                        }
                        function FHc(a) {
                            var b, c, d, e, f, g, h;
                            h = ev(a.c.length);
                            for(e = new Anb(a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 10);
                                g = new _sb;
                                f = a3b(d);
                                for(c = new is(Mr(f.a.Kc(), new ir)); gs(c);){
                                    b = RD(hs(c), 18);
                                    b.c.i == b.d.i || Ysb(g, b.d.i);
                                }
                                ZEb(h.c, g);
                            }
                            return h;
                        }
                        function xhd(c, d) {
                            var e, f, g;
                            try {
                                g = xs(c.a, d);
                                return g;
                            } catch (b) {
                                b = zdb(b);
                                if (ZD(b, 33)) {
                                    try {
                                        f = Oeb(d, qwe, lve);
                                        e = mfb(c.a);
                                        if (f >= 0 && f < e.length) return e[f];
                                    } catch (a) {
                                        a = zdb(a);
                                        if (!ZD(a, 130)) throw Adb(a);
                                    }
                                    return null;
                                } else throw Adb(b);
                            }
                        }
                        function Rvd(a, b) {
                            var c, d, e;
                            e = Eee((lke(), jke), a.Dh(), b);
                            if (e) {
                                nke();
                                RD(e, 69).xk() || (e = zfe(Qee(jke, e)));
                                d = (c = a.Ih(e), RD(c >= 0 ? a.Lh(c, true, true) : Qvd(a, e, true), 160));
                                return RD(d, 220).Wl(b);
                            } else throw Adb(new agb(KHe + b.xe() + NHe));
                        }
                        function _ae() {
                            Tae();
                            var a;
                            if (Sae) return RD(N5d((YSd(), XSd), AKe), 2038);
                            RRd(UK, new hde);
                            abe();
                            a = RD(ZD(Xjb((YSd(), XSd), AKe), 560) ? Xjb(XSd, AKe) : new $ae, 560);
                            Sae = true;
                            Yae(a);
                            Zae(a);
                            Zjb((hTd(), gTd), a, new cbe);
                            $jb(XSd, AKe, a);
                            return a;
                        }
                        function Vfe(a, b) {
                            var c, d, e, f;
                            a.j = -1;
                            if (Mvd(a.e)) {
                                c = a.i;
                                f = a.i != 0;
                                LHd(a, b);
                                d = new P3d(a.e, 3, a.c, null, b, c, f);
                                e = b.zl(a.e, a.c, null);
                                e = Hge(a, b, e);
                                if (!e) qvd(a.e, d);
                                else {
                                    e.nj(d);
                                    e.oj();
                                }
                            } else {
                                LHd(a, b);
                                e = b.zl(a.e, a.c, null);
                                !!e && e.oj();
                            }
                        }
                        function HA(a, b) {
                            var c, d, e;
                            e = 0;
                            d = b[0];
                            if (d >= a.length) return -1;
                            c = (BFb(d, a.length), a.charCodeAt(d));
                            while(c >= 48 && c <= 57){
                                e = e * 10 + (c - 48);
                                ++d;
                                if (d >= a.length) break;
                                c = (BFb(d, a.length), a.charCodeAt(d));
                            }
                            d > b[0] ? b[0] = d : e = -1;
                            return e;
                        }
                        function mPb(a) {
                            var b, c, d, e, f;
                            e = RD(a.a, 17).a;
                            f = RD(a.b, 17).a;
                            c = e;
                            d = f;
                            b = $wnd.Math.max($wnd.Math.abs(e), $wnd.Math.abs(f));
                            if (e <= 0 && e == f) {
                                c = 0;
                                d = f - 1;
                            } else if (e == -b && f != b) {
                                c = f;
                                d = e;
                                f >= 0 && ++c;
                            } else {
                                c = -f;
                                d = e;
                            }
                            return new Ptd(sgb(c), sgb(d));
                        }
                        function YPb(a, b, c, d) {
                            var e, f, g, h, i, j;
                            for(e = 0; e < b.o; e++){
                                f = e - b.j + c;
                                for(g = 0; g < b.p; g++){
                                    h = g - b.k + d;
                                    if ((i = f, j = h, i += a.j, j += a.k, i >= 0 && j >= 0 && i < a.o && j < a.p) && (!QPb(b, e, g) && $Pb(a, f, h) || PPb(b, e, g) && !_Pb(a, f, h))) return true;
                                }
                            }
                            return false;
                        }
                        function jSc(a, b, c) {
                            var d, e, f, g, h;
                            g = a.c;
                            h = a.d;
                            f = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                g.i.n,
                                g.n,
                                g.a
                            ])).b;
                            e = (f + xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                h.i.n,
                                h.n,
                                h.a
                            ])).b) / 2;
                            d = null;
                            g.j == (qpd(), Xod) ? d = new rjd(b + g.i.c.c.a + c, e) : d = new rjd(b - c, e);
                            hu(a.a, 0, d);
                        }
                        function ozd(a) {
                            var b, c, d, e;
                            b = null;
                            for(d = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                (!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b),
                                (!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c)
                            ]))); gs(d);){
                                c = RD(hs(d), 84);
                                e = AGd(c);
                                if (!b) b = e;
                                else if (b != e) return false;
                            }
                            return true;
                        }
                        function SHd(a, b, c) {
                            var d;
                            ++a.j;
                            if (b >= a.i) throw Adb(new veb(MIe + b + NIe + a.i));
                            if (c >= a.i) throw Adb(new veb(OIe + c + NIe + a.i));
                            d = a.g[c];
                            if (b != c) {
                                b < c ? hib(a.g, b, a.g, b + 1, c - b) : hib(a.g, c + 1, a.g, c, b - c);
                                bD(a.g, b, d);
                                a.Pi(b, d, c);
                                a.Ni();
                            }
                            return d;
                        }
                        function Rc(a, b, c) {
                            var d;
                            d = RD(a.c.xc(b), 16);
                            if (!d) {
                                d = a.ic(b);
                                if (d.Fc(c)) {
                                    ++a.d;
                                    a.c.zc(b, d);
                                    return true;
                                } else throw Adb(new Deb('New Collection violated the Collection spec'));
                            } else if (d.Fc(c)) {
                                ++a.d;
                                return true;
                            } else return false;
                        }
                        function ngb(a) {
                            var b, c, d;
                            if (a < 0) return 0;
                            else if (a == 0) return 32;
                            else {
                                d = -(a >> 16);
                                b = d >> 16 & 16;
                                c = 16 - b;
                                a = a >> b;
                                d = a - 256;
                                b = d >> 16 & 8;
                                c += b;
                                a <<= b;
                                d = a - qxe;
                                b = d >> 16 & 4;
                                c += b;
                                a <<= b;
                                d = a - Ove;
                                b = d >> 16 & 2;
                                c += b;
                                a <<= b;
                                d = a >> 14;
                                b = d & ~(d >> 1);
                                return c + 2 - b;
                            }
                        }
                        function RSb(a) {
                            HSb();
                            var b, c, d, e;
                            GSb = new bnb;
                            FSb = new Tsb;
                            ESb = new bnb;
                            b = (!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a);
                            JSb(b);
                            for(e = new dMd(b); e.e != e.i.gc();){
                                d = RD(bMd(e), 27);
                                if (Wmb(GSb, d, 0) == -1) {
                                    c = new bnb;
                                    Rmb(ESb, c);
                                    KSb(d, c);
                                }
                            }
                            return ESb;
                        }
                        function sTb(a, b, c) {
                            var d, e, f, g;
                            a.a = c.b.d;
                            if (ZD(b, 326)) {
                                e = IGd(RD(b, 74), false, false);
                                f = ssd(e);
                                d = new wTb(a);
                                xgb(f, d);
                                lsd(f, e);
                                b.of((umd(), cld)) != null && xgb(RD(b.of(cld), 75), d);
                            } else {
                                g = RD(b, 422);
                                g.rh(g.nh() + a.a.a);
                                g.sh(g.oh() + a.a.b);
                            }
                        }
                        function hWc(a, b) {
                            var c, d, e;
                            e = new bnb;
                            for(d = Sub(b.a, 0); d.b != d.d.c;){
                                c = RD(evb(d), 65);
                                c.c.g == a.g && dE(mQb(c.b, (h_c(), f_c))) !== dE(mQb(c.c, f_c)) && !yDb(new SDb(null, new Swb(e, 16)), new IWc(c)) && ZEb(e.c, c);
                            }
                            _mb(e, new KWc);
                            return e;
                        }
                        function fUb(a, b, c) {
                            var d, e, f, g;
                            if (ZD(b, 153) && ZD(c, 153)) {
                                f = RD(b, 153);
                                g = RD(c, 153);
                                return a.a[f.a][g.a] + a.a[g.a][f.a];
                            } else if (ZD(b, 250) && ZD(c, 250)) {
                                d = RD(b, 250);
                                e = RD(c, 250);
                                if (d.a == e.a) return RD(mQb(e.a, (yVb(), lVb)), 17).a;
                            }
                            return 0;
                        }
                        function q9b(a, b) {
                            var c, d, e, f, g, h, i, j;
                            j = Kfb(UD(mQb(b, (yCc(), fCc))));
                            i = a[0].n.a + a[0].o.a + a[0].d.c + j;
                            for(h = 1; h < a.length; h++){
                                d = a[h].n;
                                e = a[h].o;
                                c = a[h].d;
                                f = d.a - c.b - i;
                                f < 0 && (d.a -= f);
                                g = b.f;
                                g.a = $wnd.Math.max(g.a, d.a + e.a);
                                i = d.a + e.a + c.c + j;
                            }
                        }
                        function Nad(a, b) {
                            var c, d, e, f, g, h;
                            d = RD(RD(Wjb(a.g, b.a), 42).a, 68);
                            e = RD(RD(Wjb(a.g, b.b), 42).a, 68);
                            f = d.b;
                            g = e.b;
                            c = Kid(f, g);
                            if (c >= 0) return c;
                            h = ejd(ojd(new rjd(g.c + g.b / 2, g.d + g.a / 2), new rjd(f.c + f.b / 2, f.d + f.a / 2)));
                            return -(oRb(f, g) - 1) * h;
                        }
                        function ysd(a, b, c) {
                            var d;
                            FDb(new SDb(null, (!c.a && (c.a = new C5d(F4, c, 6, 6)), new Swb(c.a, 16))), new Qsd(a, b));
                            FDb(new SDb(null, (!c.n && (c.n = new C5d(I4, c, 1, 7)), new Swb(c.n, 16))), new Ssd(a, b));
                            d = RD(Gxd(c, (umd(), cld)), 75);
                            !!d && Bjd(d, a, b);
                        }
                        function Qvd(a, b, c) {
                            var d, e, f;
                            f = Eee((lke(), jke), a.Dh(), b);
                            if (f) {
                                nke();
                                RD(f, 69).xk() || (f = zfe(Qee(jke, f)));
                                e = (d = a.Ih(f), RD(d >= 0 ? a.Lh(d, true, true) : Qvd(a, f, true), 160));
                                return RD(e, 220).Sl(b, c);
                            } else throw Adb(new agb(KHe + b.xe() + NHe));
                        }
                        function WNd(a, b, c, d) {
                            var e, f, g, h, i;
                            e = a.d[b];
                            if (e) {
                                f = e.g;
                                i = e.i;
                                if (d != null) for(h = 0; h < i; ++h){
                                    g = RD(f[h], 136);
                                    if (g.Bi() == c && pb(d, g.ld())) return g;
                                }
                                else for(h = 0; h < i; ++h){
                                    g = RD(f[h], 136);
                                    if (dE(g.ld()) === dE(d)) return g;
                                }
                            }
                            return null;
                        }
                        function Nee(a, b) {
                            var c, d, e, f, g;
                            d = (!b.s && (b.s = new C5d(y7, b, 21, 17)), b.s);
                            f = null;
                            for(e = 0, g = d.i; e < g; ++e){
                                c = RD(QHd(d, e), 179);
                                switch(yfe(Qee(a, c))){
                                    case 4:
                                    case 5:
                                    case 6:
                                        !f && (f = new bnb);
                                        ZEb(f.c, c);
                                        break;
                                }
                            }
                            return !f ? (yob(), yob(), vob) : f;
                        }
                        function Yib(a, b) {
                            var c;
                            if (b < 0) throw Adb(new teb('Negative exponent'));
                            if (b == 0) return Kib;
                            else if (b == 1 || Sib(a, Kib) || Sib(a, Oib)) return a;
                            if (!_ib(a, 0)) {
                                c = 1;
                                while(!_ib(a, c))++c;
                                return Wib(kjb(c * b), Yib($ib(a, c), b));
                            }
                            return Rjb(a, b);
                        }
                        function Jnb(a, b) {
                            var c, d, e;
                            if (dE(a) === dE(b)) return true;
                            if (a == null || b == null) return false;
                            if (a.length != b.length) return false;
                            for(c = 0; c < a.length; ++c){
                                d = a[c];
                                e = b[c];
                                if (!(dE(d) === dE(e) || d != null && pb(d, e))) return false;
                            }
                            return true;
                        }
                        function EYb(a) {
                            pYb();
                            var b, c, d;
                            this.b = oYb;
                            this.c = (Cmd(), Amd);
                            this.f = (kYb(), jYb);
                            this.a = a;
                            BYb(this, new FYb);
                            uYb(this);
                            for(d = new Anb(a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 86);
                                if (!c.d) {
                                    b = new iYb(cD(WC(bQ, 1), rve, 86, 0, [
                                        c
                                    ]));
                                    Rmb(a.a, b);
                                }
                            }
                        }
                        function U6b(a, b, c) {
                            var d, e, f, g, h, i;
                            if (!a || a.c.length == 0) return null;
                            f = new VKb(b, !c);
                            for(e = new Anb(a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 72);
                                LKb(f, (i1b(), new D1b(d)));
                            }
                            g = f.i;
                            g.a = (i = f.n, f.e.b + i.d + i.a);
                            g.b = (h = f.n, f.e.a + h.b + h.c);
                            return f;
                        }
                        function d9b(a) {
                            var b, c, d, e, f, g, h;
                            h = t2b(a.a);
                            Znb(h, new i9b);
                            c = null;
                            for(e = h, f = 0, g = e.length; f < g; ++f){
                                d = e[f];
                                if (d.k != (r3b(), m3b)) break;
                                b = RD(mQb(d, (Ywc(), hwc)), 64);
                                if (b != (qpd(), ppd) && b != Xod) continue;
                                !!c && RD(mQb(c, qwc), 15).Fc(d);
                                c = d;
                            }
                        }
                        function wTc(a, b, c) {
                            var d, e, f, g, h, i, j;
                            i = (tFb(b, a.c.length), RD(a.c[b], 339));
                            Xmb(a, b);
                            if (i.b / 2 >= c) {
                                d = b;
                                j = (i.c + i.a) / 2;
                                g = j - c;
                                if (i.c <= j - c) {
                                    e = new BTc(i.c, g);
                                    Qmb(a, d++, e);
                                }
                                h = j + c;
                                if (h <= i.a) {
                                    f = new BTc(h, i.a);
                                    wFb(d, a.c.length);
                                    XEb(a.c, d, f);
                                }
                            }
                        }
                        function mZc(a, b, c) {
                            var d, e, f, g, h, i;
                            if (!b.dc()) {
                                e = new Yub;
                                for(i = b.Kc(); i.Ob();){
                                    h = RD(i.Pb(), 40);
                                    Zjb(a.a, sgb(h.g), sgb(c));
                                    for(g = (d = Sub(new dXc(h).a.d, 0), new gXc(d)); dvb(g.a);){
                                        f = RD(evb(g.a), 65).c;
                                        Pub(e, f, e.c.b, e.c);
                                    }
                                }
                                mZc(a, e, c + 1);
                            }
                        }
                        function Ude(a) {
                            var b;
                            if (!a.c && a.g == null) {
                                a.d = a.bj(a.f);
                                WGd(a, a.d);
                                b = a.d;
                            } else {
                                if (a.g == null) return true;
                                else if (a.i == 0) return false;
                                else b = RD(a.g[a.i - 1], 51);
                            }
                            if (b == a.b && null.Vm >= null.Um()) {
                                tId(a);
                                return Ude(a);
                            } else return b.Ob();
                        }
                        function t_b(a) {
                            this.a = a;
                            if (a.c.i.k == (r3b(), m3b)) {
                                this.c = a.c;
                                this.d = RD(mQb(a.c.i, (Ywc(), hwc)), 64);
                            } else if (a.d.i.k == m3b) {
                                this.c = a.d;
                                this.d = RD(mQb(a.d.i, (Ywc(), hwc)), 64);
                            } else throw Adb(new agb('Edge ' + a + ' is not an external edge.'));
                        }
                        function O1d(a, b) {
                            var c, d, e;
                            e = a.b;
                            a.b = b;
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 3, e, a.b));
                            if (!b) {
                                PAd(a, null);
                                Q1d(a, 0);
                                P1d(a, null);
                            } else if (b != a) {
                                PAd(a, b.zb);
                                Q1d(a, b.d);
                                c = (d = b.c, d == null ? b.zb : d);
                                P1d(a, c == null || lhb(c, b.zb) ? null : c);
                            }
                        }
                        function hj(a, b) {
                            var c;
                            this.e = (tm(), Qb(a), tm(), zm(a));
                            this.c = (Qb(b), zm(b));
                            Lb(this.e.Rd().dc() == this.c.Rd().dc());
                            this.d = Uv(this.e);
                            this.b = Uv(this.c);
                            c = YC(jJ, [
                                Nve,
                                rve
                            ], [
                                5,
                                1
                            ], 5, [
                                this.e.Rd().gc(),
                                this.c.Rd().gc()
                            ], 2);
                            this.a = c;
                            Zi(this);
                        }
                        function Lz(b) {
                            var c = (!Jz && (Jz = Mz()), Jz);
                            var d = b.replace(/[\x00-\x1f\xad\u0600-\u0603\u06dd\u070f\u17b4\u17b5\u200b-\u200f\u2028-\u202e\u2060-\u2064\u206a-\u206f\ufeff\ufff9-\ufffb"\\]/g, function(a) {
                                return Kz(a, c);
                            });
                            return '"' + d + '"';
                        }
                        function VEb(a, b, c, d, e, f) {
                            var g, h, i, j, k;
                            if (e == 0) return;
                            if (dE(a) === dE(c)) {
                                a = a.slice(b, b + e);
                                b = 0;
                            }
                            i = c;
                            for(h = b, j = b + e; h < j;){
                                g = $wnd.Math.min(h + 10000, j);
                                e = g - h;
                                k = a.slice(h, g);
                                k.splice(0, 0, d, f ? e : 0);
                                Array.prototype.splice.apply(i, k);
                                h = g;
                                d += e;
                            }
                        }
                        function VGb(a) {
                            FGb();
                            var b, c;
                            this.b = CGb;
                            this.c = EGb;
                            this.g = (wGb(), vGb);
                            this.d = (Cmd(), Amd);
                            this.a = a;
                            IGb(this);
                            for(c = new Anb(a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 60);
                                !b.a && gGb(iGb(new jGb, cD(WC(hN, 1), rve, 60, 0, [
                                    b
                                ])), a);
                                b.e = new Vid(b.d);
                            }
                        }
                        function yTb(a) {
                            var b, c, d, e, f, g;
                            e = a.e.c.length;
                            d = $C(QK, Ize, 15, e, 0, 1);
                            for(g = new Anb(a.e); g.a < g.c.c.length;){
                                f = RD(ynb(g), 153);
                                d[f.a] = new Yub;
                            }
                            for(c = new Anb(a.c); c.a < c.c.c.length;){
                                b = RD(ynb(c), 290);
                                d[b.c.a].Fc(b);
                                d[b.d.a].Fc(b);
                            }
                            return d;
                        }
                        function OMd(a, b) {
                            var c, d, e, f, g;
                            c = RD(Ywd(a.a, 4), 129);
                            g = c == null ? 0 : c.length;
                            if (b >= g) throw Adb(new aMd(b, g));
                            e = c[b];
                            if (g == 1) d = null;
                            else {
                                d = $C(d6, IJe, 424, g - 1, 0, 1);
                                hib(c, 0, d, 0, b);
                                f = g - b - 1;
                                f > 0 && hib(c, b + 1, d, b, f);
                            }
                            Bde(a, d);
                            Ade(a, b, e);
                            return e;
                        }
                        function l3d(a) {
                            var b, c;
                            if (a.f) {
                                while(a.n < a.o){
                                    b = RD(!a.j ? a.k.Xb(a.n) : a.j.$i(a.n), 76);
                                    c = b.Lk();
                                    if (ZD(c, 102) && (RD(c, 19).Bb & QHe) != 0 && (!a.e || c.pk() != C4 || c.Lj() != 0) && b.md() != null) return true;
                                    else ++a.n;
                                }
                                return false;
                            } else return a.n < a.o;
                        }
                        function Lle() {
                            Lle = geb;
                            Jle = RD(QHd(xYd((Qle(), Ple).qb), 6), 35);
                            Gle = RD(QHd(xYd(Ple.qb), 3), 35);
                            Hle = RD(QHd(xYd(Ple.qb), 4), 35);
                            Ile = RD(QHd(xYd(Ple.qb), 5), 19);
                            vWd(Jle);
                            vWd(Gle);
                            vWd(Hle);
                            vWd(Ile);
                            Kle = new mob(cD(WC(y7, 1), lKe, 179, 0, [
                                Jle,
                                Gle
                            ]));
                        }
                        function rMb(a, b) {
                            var c;
                            this.d = new P2b;
                            this.b = b;
                            this.e = new sjd(b.Lf());
                            c = a.u.Hc((Pod(), Mod));
                            a.u.Hc(Lod) ? a.F ? this.a = c && !b.bg() : this.a = true : a.u.Hc(Nod) ? c ? this.a = !(b.Uf().Kc().Ob() || b.Wf().Kc().Ob()) : this.a = false : this.a = false;
                        }
                        function zNb(a, b) {
                            var c, d, e, f;
                            c = a.o.a;
                            for(f = RD(RD(Qc(a.r, b), 21), 87).Kc(); f.Ob();){
                                e = RD(f.Pb(), 117);
                                e.e.a = (d = e.b, d.pf((umd(), Gld)) ? d.ag() == (qpd(), ppd) ? -d.Mf().a - Kfb(UD(d.of(Gld))) : c + Kfb(UD(d.of(Gld))) : d.ag() == (qpd(), ppd) ? -d.Mf().a : c);
                            }
                        }
                        function $4b(a, b) {
                            var c, d, e, f;
                            c = RD(mQb(a, (yCc(), rAc)), 88);
                            f = RD(Gxd(b, GBc), 64);
                            e = RD(mQb(a, BBc), 101);
                            if (e != (Bod(), zod) && e != Aod) {
                                if (f == (qpd(), opd)) {
                                    f = osd(b, c);
                                    f == opd && (f = vpd(c));
                                }
                            } else {
                                d = W4b(b);
                                d > 0 ? f = vpd(c) : f = spd(vpd(c));
                            }
                            Ixd(b, GBc, f);
                        }
                        function agc(a, b) {
                            var c;
                            b.Ug('Partition preprocessing', 1);
                            c = RD(zDb(CDb(EDb(CDb(new SDb(null, new Swb(a.a, 16)), new egc), new ggc), new igc), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), vBb)
                            ]))), 15);
                            FDb(c.Oc(), new kgc);
                            b.Vg();
                        }
                        function Uoc(a, b) {
                            var c, d, e, f, g;
                            g = a.j;
                            b.a != b.b && _mb(g, new ypc);
                            e = g.c.length / 2 | 0;
                            for(d = 0; d < e; d++){
                                f = (tFb(d, g.c.length), RD(g.c[d], 113));
                                f.c && Q3b(f.d, b.a);
                            }
                            for(c = e; c < g.c.length; c++){
                                f = (tFb(c, g.c.length), RD(g.c[c], 113));
                                f.c && Q3b(f.d, b.b);
                            }
                        }
                        function rLc(a, b, c) {
                            var d, e, f;
                            d = a.c[b.c.p][b.p];
                            e = a.c[c.c.p][c.p];
                            if (d.a != null && e.a != null) {
                                f = Jfb(d.a, e.a);
                                f < 0 ? uLc(a, b, c) : f > 0 && uLc(a, c, b);
                                return f;
                            } else if (d.a != null) {
                                uLc(a, b, c);
                                return -1;
                            } else if (e.a != null) {
                                uLc(a, c, b);
                                return 1;
                            }
                            return 0;
                        }
                        function EVc(a, b) {
                            var c, d, e, f, g;
                            e = b.b.b;
                            a.a = $C(QK, Ize, 15, e, 0, 1);
                            a.b = $C(xdb, Hye, 28, e, 16, 1);
                            for(g = Sub(b.b, 0); g.b != g.d.c;){
                                f = RD(evb(g), 40);
                                a.a[f.g] = new Yub;
                            }
                            for(d = Sub(b.a, 0); d.b != d.d.c;){
                                c = RD(evb(d), 65);
                                a.a[c.b.g].Fc(c);
                                a.a[c.c.g].Fc(c);
                            }
                        }
                        function SJd(a, b) {
                            var c, d, e, f;
                            if (a.Pj()) {
                                c = a.Ej();
                                f = a.Qj();
                                ++a.j;
                                a.qj(c, a.Zi(c, b));
                                d = a.Ij(3, null, b, c, f);
                                if (a.Mj()) {
                                    e = a.Nj(b, null);
                                    if (!e) a.Jj(d);
                                    else {
                                        e.nj(d);
                                        e.oj();
                                    }
                                } else a.Jj(d);
                            } else {
                                _Id(a, b);
                                if (a.Mj()) {
                                    e = a.Nj(b, null);
                                    !!e && e.oj();
                                }
                            }
                        }
                        function oLd(a, b, c) {
                            var d, e, f;
                            if (a.Pj()) {
                                f = a.Qj();
                                KHd(a, b, c);
                                d = a.Ij(3, null, c, b, f);
                                if (a.Mj()) {
                                    e = a.Nj(c, null);
                                    a.Tj() && (e = a.Uj(c, e));
                                    if (!e) a.Jj(d);
                                    else {
                                        e.nj(d);
                                        e.oj();
                                    }
                                } else a.Jj(d);
                            } else {
                                KHd(a, b, c);
                                if (a.Mj()) {
                                    e = a.Nj(c, null);
                                    !!e && e.oj();
                                }
                            }
                        }
                        function bge(a, b) {
                            var c, d, e, f, g;
                            g = pke(a.e.Dh(), b);
                            e = new YHd;
                            c = RD(a.g, 124);
                            for(f = a.i; --f >= 0;){
                                d = c[f];
                                g.am(d.Lk()) && WGd(e, d);
                            }
                            !wLd(a, e) && Mvd(a.e) && eZd(a, b.Jk() ? fge(a, 6, b, (yob(), vob), null, -1, false) : fge(a, b.tk() ? 2 : 1, b, null, null, -1, false));
                        }
                        function _7b(a, b) {
                            var c, d, e, f, g;
                            if (a.a == ($uc(), Yuc)) return true;
                            f = b.a.c;
                            c = b.a.c + b.a.b;
                            if (b.j) {
                                d = b.A;
                                g = d.c.c.a - d.o.a / 2;
                                e = f - (d.n.a + d.o.a);
                                if (e > g) return false;
                            }
                            if (b.q) {
                                d = b.C;
                                g = d.c.c.a - d.o.a / 2;
                                e = d.n.a - c;
                                if (e > g) return false;
                            }
                            return true;
                        }
                        function bRc(a) {
                            WQc();
                            var b, c, d, e, f, g, h;
                            c = new gub;
                            for(e = new Anb(a.e.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 30);
                                for(g = new Anb(d.a); g.a < g.c.c.length;){
                                    f = RD(ynb(g), 10);
                                    h = a.g[f.p];
                                    b = RD(cub(c, h), 15);
                                    if (!b) {
                                        b = new bnb;
                                        dub(c, h, b);
                                    }
                                    b.Fc(f);
                                }
                            }
                            return c;
                        }
                        function Qzd(a) {
                            var b;
                            if ((a.Db & 64) != 0) return awd(a);
                            b = new Shb(awd(a));
                            b.a += ' (startX: ';
                            Khb(b, a.j);
                            b.a += ', startY: ';
                            Khb(b, a.k);
                            b.a += ', endX: ';
                            Khb(b, a.b);
                            b.a += ', endY: ';
                            Khb(b, a.c);
                            b.a += ', identifier: ';
                            Nhb(b, a.d);
                            b.a += ')';
                            return b.a;
                        }
                        function cWd(a) {
                            var b;
                            if ((a.Db & 64) != 0) return QAd(a);
                            b = new Shb(QAd(a));
                            b.a += ' (ordered: ';
                            Ohb(b, (a.Bb & 256) != 0);
                            b.a += ', unique: ';
                            Ohb(b, (a.Bb & 512) != 0);
                            b.a += ', lowerBound: ';
                            Lhb(b, a.s);
                            b.a += ', upperBound: ';
                            Lhb(b, a.t);
                            b.a += ')';
                            return b.a;
                        }
                        function uBd(a, b, c, d, e, f, g, h) {
                            var i;
                            ZD(a.Cb, 90) && v$d(yYd(RD(a.Cb, 90)), 4);
                            PAd(a, c);
                            a.f = d;
                            DWd(a, e);
                            FWd(a, f);
                            xWd(a, g);
                            EWd(a, false);
                            aWd(a, true);
                            AWd(a, h);
                            _Vd(a, true);
                            $Vd(a, 0);
                            a.b = 0;
                            bWd(a, 1);
                            i = XVd(a, b, null);
                            !!i && i.oj();
                            kXd(a, false);
                            return a;
                        }
                        function ZAb(a, b) {
                            var c, d, e, f;
                            c = RD(Xjb(a.a, b), 525);
                            if (!c) {
                                d = new oBb(b);
                                e = (gBb(), dBb) ? null : d.c;
                                f = zhb(e, 0, $wnd.Math.max(0, thb(e, Fhb(46))));
                                nBb(d, ZAb(a, f));
                                (dBb ? null : d.c).length == 0 && iBb(d, new rBb);
                                $jb(a.a, dBb ? null : d.c, d);
                                return d;
                            }
                            return c;
                        }
                        function sRb(a, b) {
                            var c;
                            a.b = b;
                            a.g = new bnb;
                            c = tRb(a.b);
                            a.e = c;
                            a.f = c;
                            a.c = Heb(TD(mQb(a.b, (YHb(), RHb))));
                            a.a = UD(mQb(a.b, (umd(), Dkd)));
                            a.a == null && (a.a = 1);
                            Kfb(a.a) > 1 ? a.e *= Kfb(a.a) : a.f /= Kfb(a.a);
                            uRb(a);
                            vRb(a);
                            rRb(a);
                            pQb(a.b, (tSb(), lSb), a.g);
                        }
                        function n9b(a, b, c) {
                            var d, e, f, g, h, i;
                            d = 0;
                            i = c;
                            if (!b) {
                                d = c * (a.c.length - 1);
                                i *= -1;
                            }
                            for(f = new Anb(a); f.a < f.c.c.length;){
                                e = RD(ynb(f), 10);
                                pQb(e, (yCc(), Rzc), (Rjd(), Njd));
                                e.o.a = d;
                                for(h = e3b(e, (qpd(), Xod)).Kc(); h.Ob();){
                                    g = RD(h.Pb(), 12);
                                    g.n.a = d;
                                }
                                d += i;
                            }
                        }
                        function gZd(a, b, c) {
                            var d, e, f, g, h, i;
                            h = a.pl(c);
                            if (h != c) {
                                g = a.g[b];
                                i = h;
                                MHd(a, b, a.Zi(b, i));
                                f = g;
                                a.Ri(b, i, f);
                                if (a.al()) {
                                    d = c;
                                    e = a.Oj(d, null);
                                    !RD(h, 54).Ph() && (e = a.Nj(i, e));
                                    !!e && e.oj();
                                }
                                Mvd(a.e) && eZd(a, a.Ij(9, c, h, b, false));
                                return h;
                            } else return c;
                        }
                        function rYb(a, b) {
                            var c, d, e, f;
                            for(d = new Anb(a.a.a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 194);
                                c.g = true;
                            }
                            for(f = new Anb(a.a.b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 86);
                                e.k = Heb(TD(a.e.Kb(new Ptd(e, b))));
                                e.d.g = e.d.g & Heb(TD(a.e.Kb(new Ptd(e, b))));
                            }
                            return a;
                        }
                        function Rdc(a, b) {
                            var c, d;
                            if (a.c.length != 0) {
                                if (a.c.length == 2) {
                                    Qdc((tFb(0, a.c.length), RD(a.c[0], 10)), (Pnd(), Lnd));
                                    Qdc((tFb(1, a.c.length), RD(a.c[1], 10)), Mnd);
                                } else for(d = new Anb(a); d.a < d.c.c.length;){
                                    c = RD(ynb(d), 10);
                                    Qdc(c, b);
                                }
                                a.c.length = 0;
                            }
                        }
                        function Vnc(a) {
                            var b, c, d, e, f;
                            c = (b = RD(mfb(E3), 9), new Fsb(b, RD(WEb(b, b.length), 9), 0));
                            f = RD(mQb(a, (Ywc(), Iwc)), 10);
                            if (f) for(e = new Anb(f.j); e.a < e.c.c.length;){
                                d = RD(ynb(e), 12);
                                dE(mQb(d, Awc)) === dE(a) && k4b(new l4b(d.b)) && zsb(c, d.j);
                            }
                            return c;
                        }
                        function CGc(a, b, c) {
                            var d, e, f, g, h;
                            if (a.d[c.p]) return;
                            for(e = new is(Mr(a3b(c).a.Kc(), new ir)); gs(e);){
                                d = RD(hs(e), 18);
                                h = d.d.i;
                                for(g = new is(Mr(Z2b(h).a.Kc(), new ir)); gs(g);){
                                    f = RD(hs(g), 18);
                                    f.c.i == b && (a.a[f.p] = true);
                                }
                                CGc(a, b, h);
                            }
                            a.d[c.p] = true;
                        }
                        function Zwd(a, b) {
                            var c, d, e, f, g, h, i;
                            d = ggb(a.Db & 254);
                            if (d == 1) a.Eb = null;
                            else {
                                f = SD(a.Eb);
                                if (d == 2) {
                                    e = Xwd(a, b);
                                    a.Eb = f[e == 0 ? 1 : 0];
                                } else {
                                    g = $C(jJ, rve, 1, d - 1, 5, 1);
                                    for(c = 2, h = 0, i = 0; c <= 128; c <<= 1)c == b ? ++h : (a.Db & c) != 0 && (g[i++] = f[h++]);
                                    a.Eb = g;
                                }
                            }
                            a.Db &= ~b;
                        }
                        function rse(a) {
                            var b;
                            b = 0;
                            switch(a){
                                case 105:
                                    b = 2;
                                    break;
                                case 109:
                                    b = 8;
                                    break;
                                case 115:
                                    b = 4;
                                    break;
                                case 120:
                                    b = 16;
                                    break;
                                case 117:
                                    b = 32;
                                    break;
                                case 119:
                                    b = 64;
                                    break;
                                case 70:
                                    b = 256;
                                    break;
                                case 72:
                                    b = 128;
                                    break;
                                case 88:
                                    b = 512;
                                    break;
                                case 44:
                                    b = gwe;
                            }
                            return b;
                        }
                        function Ojb(a, b, c, d, e) {
                            var f, g, h, i;
                            if (dE(a) === dE(b) && d == e) {
                                Tjb(a, d, c);
                                return;
                            }
                            for(h = 0; h < d; h++){
                                g = 0;
                                f = a[h];
                                for(i = 0; i < e; i++){
                                    g = Bdb(Bdb(Ndb(Cdb(f, yxe), Cdb(b[i], yxe)), Cdb(c[h + i], yxe)), Cdb(Ydb(g), yxe));
                                    c[h + i] = Ydb(g);
                                    g = Udb(g, 32);
                                }
                                c[h + e] = Ydb(g);
                            }
                        }
                        function tRb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l;
                            k = 0;
                            j = 0;
                            e = a.a;
                            h = e.a.gc();
                            for(d = e.a.ec().Kc(); d.Ob();){
                                c = RD(d.Pb(), 567);
                                b = (c.b && CRb(c), c.a);
                                l = b.a;
                                g = b.b;
                                k += l + g;
                                j += l * g;
                            }
                            i = $wnd.Math.sqrt(400 * h * j - 4 * j + k * k) + k;
                            f = 2 * (100 * h - 1);
                            if (f == 0) return i;
                            return i / f;
                        }
                        function MSc(a, b) {
                            if (b.b != 0) {
                                isNaN(a.s) ? a.s = Kfb((sFb(b.b != 0), UD(b.a.a.c))) : a.s = $wnd.Math.min(a.s, Kfb((sFb(b.b != 0), UD(b.a.a.c))));
                                isNaN(a.c) ? a.c = Kfb((sFb(b.b != 0), UD(b.c.b.c))) : a.c = $wnd.Math.max(a.c, Kfb((sFb(b.b != 0), UD(b.c.b.c))));
                            }
                        }
                        function nzd(a) {
                            var b, c, d, e;
                            b = null;
                            for(d = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                (!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b),
                                (!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c)
                            ]))); gs(d);){
                                c = RD(hs(d), 84);
                                e = AGd(c);
                                if (!b) b = vCd(e);
                                else if (b != vCd(e)) return true;
                            }
                            return false;
                        }
                        function pLd(a, b) {
                            var c, d, e, f;
                            if (a.Pj()) {
                                c = a.i;
                                f = a.Qj();
                                LHd(a, b);
                                d = a.Ij(3, null, b, c, f);
                                if (a.Mj()) {
                                    e = a.Nj(b, null);
                                    a.Tj() && (e = a.Uj(b, e));
                                    if (!e) a.Jj(d);
                                    else {
                                        e.nj(d);
                                        e.oj();
                                    }
                                } else a.Jj(d);
                            } else {
                                LHd(a, b);
                                if (a.Mj()) {
                                    e = a.Nj(b, null);
                                    !!e && e.oj();
                                }
                            }
                        }
                        function ZQb(a, b) {
                            var c, d, e, f;
                            f = rAb(a.a, b.b);
                            if (!f) throw Adb(new dgb('Invalid hitboxes for scanline overlap calculation.'));
                            e = false;
                            for(d = a.a.a.ec().Kc(); d.Ob();){
                                c = RD(d.Pb(), 68);
                                if (UQb(b.b, c)) {
                                    bbd(a.b.a, b.b, c);
                                    e = true;
                                } else {
                                    if (e) break;
                                }
                            }
                        }
                        function whd(a) {
                            var b;
                            if (!a.a) throw Adb(new dgb('IDataType class expected for layout option ' + a.f));
                            b = GId(a.a);
                            if (b == null) throw Adb(new dgb("Couldn't create new instance of property '" + a.f + "'. " + DGe + (lfb(b6), b6.k) + EGe));
                            return RD(b, 423);
                        }
                        function yvd(a) {
                            var b, c, d, e, f;
                            f = a.Ph();
                            if (f) {
                                if (f.Vh()) {
                                    e = Vvd(a, f);
                                    if (e != f) {
                                        c = a.Fh();
                                        d = (b = a.Fh(), b >= 0 ? a.Ah(null) : a.Ph().Th(a, -1 - b, null, null));
                                        a.Bh(RD(e, 54), c);
                                        !!d && d.oj();
                                        a.vh() && a.wh() && c > -1 && qvd(a, new N3d(a, 9, c, f, e));
                                        return e;
                                    }
                                }
                            }
                            return f;
                        }
                        function stb(a, b) {
                            var c, d, e, f, g;
                            f = a.b.Ce(b);
                            d = (c = a.a.get(f), c == null ? $C(jJ, rve, 1, 0, 5, 1) : c);
                            for(g = 0; g < d.length; g++){
                                e = d[g];
                                if (a.b.Be(b, e.ld())) {
                                    if (d.length == 1) {
                                        d.length = 0;
                                        Btb(a.a, f);
                                    } else d.splice(g, 1);
                                    --a.c;
                                    ++a.b.g;
                                    return e.md();
                                }
                            }
                            return null;
                        }
                        function pWb(a) {
                            var b, c, d, e, f, g, h, i;
                            g = 0;
                            f = a.f.e;
                            for(d = 0; d < f.c.length; ++d){
                                h = (tFb(d, f.c.length), RD(f.c[d], 153));
                                for(e = d + 1; e < f.c.length; ++e){
                                    i = (tFb(e, f.c.length), RD(f.c[e], 153));
                                    c = bjd(h.d, i.d);
                                    b = c - a.a[h.a][i.a];
                                    g += a.i[h.a][i.a] * b * b;
                                }
                            }
                            return g;
                        }
                        function oec(a, b) {
                            var c;
                            if (nQb(b, (yCc(), UAc))) return;
                            c = wec(RD(mQb(b, hec), 371), RD(mQb(a, UAc), 171));
                            pQb(b, hec, c);
                            if (gs(new is(Mr(W2b(b).a.Kc(), new ir)))) return;
                            switch(c.g){
                                case 1:
                                    pQb(b, UAc, (cxc(), Zwc));
                                    break;
                                case 2:
                                    pQb(b, UAc, (cxc(), _wc));
                            }
                        }
                        function aoc(a, b) {
                            var c;
                            Snc(a);
                            a.a = (c = new Ri, FDb(new SDb(null, new Swb(b.d, 16)), new zoc(c)), c);
                            Xnc(a, RD(mQb(b.b, (yCc(), CAc)), 349));
                            Znc(a);
                            Ync(a);
                            Wnc(a);
                            $nc(a);
                            _nc(a, b);
                            FDb(EDb(new SDb(null, gj(ej(a.b).a)), new poc), new roc);
                            b.a = false;
                            a.a = null;
                        }
                        function B$c() {
                            B$c = geb;
                            r$c = new lGd(REe, (Geb(), false));
                            s$c = new lGd(SEe, 7);
                            sgb(0);
                            y$c = new lGd(TEe, sgb(0));
                            v$c = new lGd(UEe, sgb(-1));
                            A$c = (s_c(), r_c);
                            z$c = new lGd(VEe, A$c);
                            u$c = (LZc(), IZc);
                            t$c = new lGd(WEe, u$c);
                            x$c = (A_c(), z_c);
                            w$c = new lGd(XEe, x$c);
                        }
                        function _Bd() {
                            FBd.call(this, $He, (bvd(), avd));
                            this.p = null;
                            this.a = null;
                            this.f = null;
                            this.n = null;
                            this.g = null;
                            this.c = null;
                            this.i = null;
                            this.j = null;
                            this.d = null;
                            this.b = null;
                            this.e = null;
                            this.k = null;
                            this.o = null;
                            this.s = null;
                            this.q = false;
                            this.r = false;
                        }
                        function aGd() {
                            aGd = geb;
                            _Fd = new bGd(FBe, 0);
                            YFd = new bGd('INSIDE_SELF_LOOPS', 1);
                            ZFd = new bGd('MULTI_EDGES', 2);
                            XFd = new bGd('EDGE_LABELS', 3);
                            $Fd = new bGd('PORTS', 4);
                            VFd = new bGd('COMPOUND', 5);
                            UFd = new bGd('CLUSTERS', 6);
                            WFd = new bGd('DISCONNECTED', 7);
                        }
                        function RJd(a, b, c) {
                            var d, e, f;
                            if (a.Pj()) {
                                f = a.Qj();
                                ++a.j;
                                a.qj(b, a.Zi(b, c));
                                d = a.Ij(3, null, c, b, f);
                                if (a.Mj()) {
                                    e = a.Nj(c, null);
                                    if (!e) a.Jj(d);
                                    else {
                                        e.nj(d);
                                        e.oj();
                                    }
                                } else a.Jj(d);
                            } else {
                                ++a.j;
                                a.qj(b, a.Zi(b, c));
                                if (a.Mj()) {
                                    e = a.Nj(c, null);
                                    !!e && e.oj();
                                }
                            }
                        }
                        function _ib(a, b) {
                            var c, d, e;
                            if (b == 0) return (a.a[0] & 1) != 0;
                            if (b < 0) throw Adb(new teb('Negative bit address'));
                            e = b >> 5;
                            if (e >= a.d) return a.e < 0;
                            c = a.a[e];
                            b = 1 << (b & 31);
                            if (a.e < 0) {
                                d = Uib(a);
                                if (e < d) return false;
                                else d == e ? c = -c : c = ~c;
                            }
                            return (c & b) != 0;
                        }
                        function Zdd(a, b, c, d) {
                            var e;
                            RD(c.b, 68);
                            RD(c.b, 68);
                            RD(d.b, 68);
                            RD(d.b, 68);
                            e = ojd(ajd(RD(c.b, 68).c), RD(d.b, 68).c);
                            kjd(e, PQb(RD(c.b, 68), RD(d.b, 68), e));
                            RD(d.b, 68);
                            RD(d.b, 68);
                            RD(d.b, 68).c.a, e.a;
                            RD(d.b, 68).c.b, e.b;
                            RD(d.b, 68);
                            Umb(d.a, new ced(a, b, d));
                        }
                        function V$d(a, b) {
                            var c, d, e, f, g, h, i;
                            f = b.e;
                            if (f) {
                                c = yvd(f);
                                d = RD(a.g, 689);
                                for(g = 0; g < a.i; ++g){
                                    i = d[g];
                                    if (h2d(i) == c) {
                                        e = (!i.d && (i.d = new XZd(o7, i, 1)), i.d);
                                        h = RD(c.Mh(jwd(f, f.Cb, f.Db >> 16)), 15).dd(f);
                                        if (h < e.i) return V$d(a, RD(QHd(e, h), 89));
                                    }
                                }
                            }
                            return b;
                        }
                        function feb(a, b, c) {
                            var d = eeb, h;
                            var e = d[a];
                            var f = e instanceof Array ? e[0] : null;
                            if (e && !f) _ = e;
                            else {
                                _ = (h = b && b.prototype, !h && (h = eeb[b]), ieb(h));
                                _.Sm = c;
                                !b && (_.Tm = keb);
                                d[a] = _;
                            }
                            for(var g = 3; g < arguments.length; ++g)arguments[g].prototype = _;
                            f && (_.Rm = f);
                        }
                        function gs(a) {
                            var b;
                            while(!RD(Qb(a.a), 51).Ob()){
                                a.d = fs(a);
                                if (!a.d) return false;
                                a.a = RD(a.d.Pb(), 51);
                                if (ZD(a.a, 38)) {
                                    b = RD(a.a, 38);
                                    a.a = b.a;
                                    !a.b && (a.b = new wmb);
                                    hmb(a.b, a.d);
                                    if (b.b) while(!nmb(b.b))hmb(a.b, RD(tmb(b.b), 51));
                                    a.d = b.d;
                                }
                            }
                            return true;
                        }
                        function xJb(a, b) {
                            var c, d, e, f;
                            e = 1;
                            b.j = true;
                            f = null;
                            for(d = new Anb(CIb(b)); d.a < d.c.c.length;){
                                c = RD(ynb(d), 218);
                                if (!a.c[c.c]) {
                                    a.c[c.c] = true;
                                    f = oIb(c, b);
                                    if (c.f) e += xJb(a, f);
                                    else if (!f.j && c.a == c.e.e - c.d.e) {
                                        c.f = true;
                                        Ysb(a.p, c);
                                        e += xJb(a, f);
                                    }
                                }
                            }
                            return e;
                        }
                        function OYb(a) {
                            var b, c, d;
                            for(c = new Anb(a.a.a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 86);
                                d = (uFb(0), 0);
                                if (d > 0) {
                                    !(Dmd(a.a.c) && b.n.d) && !(Emd(a.a.c) && b.n.b) && (b.g.d += $wnd.Math.max(0, d / 2 - 0.5));
                                    !(Dmd(a.a.c) && b.n.a) && !(Emd(a.a.c) && b.n.c) && (b.g.a -= d - 1);
                                }
                            }
                        }
                        function c7b(a) {
                            var b, c, d, e, f;
                            e = new bnb;
                            f = d7b(a, e);
                            b = RD(mQb(a, (Ywc(), Iwc)), 10);
                            if (b) for(d = new Anb(b.j); d.a < d.c.c.length;){
                                c = RD(ynb(d), 12);
                                dE(mQb(c, Awc)) === dE(a) && (f = $wnd.Math.max(f, d7b(c, e)));
                            }
                            e.c.length == 0 || pQb(a, ywc, f);
                            return f != -1 ? e : null;
                        }
                        function rcc(a, b, c) {
                            var d, e, f, g, h, i;
                            f = RD(Vmb(b.e, 0), 18).c;
                            d = f.i;
                            e = d.k;
                            i = RD(Vmb(c.g, 0), 18).d;
                            g = i.i;
                            h = g.k;
                            e == (r3b(), o3b) ? pQb(a, (Ywc(), vwc), RD(mQb(d, vwc), 12)) : pQb(a, (Ywc(), vwc), f);
                            h == o3b ? pQb(a, (Ywc(), wwc), RD(mQb(g, wwc), 12)) : pQb(a, (Ywc(), wwc), i);
                        }
                        function ysc(a) {
                            var b, c, d;
                            this.c = a;
                            d = RD(mQb(a, (yCc(), rAc)), 88);
                            b = Kfb(UD(mQb(a, Tzc)));
                            c = Kfb(UD(mQb(a, oCc)));
                            d == (Cmd(), ymd) || d == zmd || d == Amd ? this.b = b * c : this.b = 1 / (b * c);
                            this.j = Kfb(UD(mQb(a, cCc)));
                            this.e = Kfb(UD(mQb(a, bCc)));
                            this.f = a.b.c.length;
                        }
                        function BD(a, b) {
                            var c, d, e, f, g;
                            b &= 63;
                            c = a.h;
                            d = (c & fxe) != 0;
                            d && (c |= -1048576);
                            if (b < 22) {
                                g = c >> b;
                                f = a.m >> b | c << 22 - b;
                                e = a.l >> b | a.m << 22 - b;
                            } else if (b < 44) {
                                g = d ? exe : 0;
                                f = c >> b - 22;
                                e = a.m >> b - 22 | c << 44 - b;
                            } else {
                                g = d ? exe : 0;
                                f = d ? dxe : 0;
                                e = c >> b - 44;
                            }
                            return hD(e & dxe, f & dxe, g & exe);
                        }
                        function ORb(a) {
                            var b, c, d, e, f, g;
                            this.c = new bnb;
                            this.d = a;
                            d = oxe;
                            e = oxe;
                            b = pxe;
                            c = pxe;
                            for(g = Sub(a, 0); g.b != g.d.c;){
                                f = RD(evb(g), 8);
                                d = $wnd.Math.min(d, f.a);
                                e = $wnd.Math.min(e, f.b);
                                b = $wnd.Math.max(b, f.a);
                                c = $wnd.Math.max(c, f.b);
                            }
                            this.a = new Uid(d, e, b - d, c - e);
                        }
                        function Udc(a, b) {
                            var c, d, e, f, g, h;
                            for(f = new Anb(a.b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 30);
                                for(h = new Anb(e.a); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 10);
                                    g.k == (r3b(), n3b) && Qdc(g, b);
                                    for(d = new is(Mr(a3b(g).a.Kc(), new ir)); gs(d);){
                                        c = RD(hs(d), 18);
                                        Pdc(c, b);
                                    }
                                }
                            }
                        }
                        function nec(a, b) {
                            var c, d, e;
                            b.Ug('Layer constraint preprocessing', 1);
                            c = new bnb;
                            e = new Jkb(a.a, 0);
                            while(e.b < e.d.gc()){
                                d = (sFb(e.b < e.d.gc()), RD(e.d.Xb(e.c = e.b++), 10));
                                if (mec(d)) {
                                    kec(d);
                                    ZEb(c.c, d);
                                    Ckb(e);
                                }
                            }
                            c.c.length == 0 || pQb(a, (Ywc(), lwc), c);
                            b.Vg();
                        }
                        function $Hc(a) {
                            var b, c;
                            a.e = $C(kE, Pwe, 28, a.p.c.length, 15, 1);
                            a.k = $C(kE, Pwe, 28, a.p.c.length, 15, 1);
                            for(c = new Anb(a.p); c.a < c.c.c.length;){
                                b = RD(ynb(c), 10);
                                a.e[b.p] = Kr(new is(Mr(Z2b(b).a.Kc(), new ir)));
                                a.k[b.p] = Kr(new is(Mr(a3b(b).a.Kc(), new ir)));
                            }
                        }
                        function bIc(a) {
                            var b, c, d, e, f, g;
                            e = 0;
                            a.q = new bnb;
                            b = new _sb;
                            for(g = new Anb(a.p); g.a < g.c.c.length;){
                                f = RD(ynb(g), 10);
                                f.p = e;
                                for(d = new is(Mr(a3b(f).a.Kc(), new ir)); gs(d);){
                                    c = RD(hs(d), 18);
                                    Ysb(b, c.d.i);
                                }
                                b.a.Bc(f);
                                Rmb(a.q, new btb(b));
                                b.a.$b();
                                ++e;
                            }
                        }
                        function pPd(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            if (a.a.f > 0 && ZD(b, 44)) {
                                a.a._j();
                                j = RD(b, 44);
                                i = j.ld();
                                f = i == null ? 0 : tb(i);
                                g = bOd(a.a, f);
                                c = a.a.d[g];
                                if (c) {
                                    d = RD(c.g, 379);
                                    k = c.i;
                                    for(h = 0; h < k; ++h){
                                        e = d[h];
                                        if (e.Bi() == f && e.Fb(j)) {
                                            pPd(a, j);
                                            return true;
                                        }
                                    }
                                }
                            }
                            return false;
                        }
                        function Nje(a) {
                            var b, c, d, e, f, g, h;
                            b = a.qi(AKe);
                            if (b) {
                                h = WD($Nd((!b.b && (b.b = new SVd((JTd(), FTd), C8, b)), b.b), 'settingDelegates'));
                                if (h != null) {
                                    c = new bnb;
                                    for(e = vhb(h, '\\w+'), f = 0, g = e.length; f < g; ++f){
                                        d = e[f];
                                        ZEb(c.c, d);
                                    }
                                    return c;
                                }
                            }
                            return yob(), yob(), vob;
                        }
                        function Ync(a) {
                            var b, c, d, e;
                            for(e = RD(Qc(a.a, (Bnc(), ync)), 15).Kc(); e.Ob();){
                                d = RD(e.Pb(), 105);
                                c = (b = Ec(d.k), b.Hc((qpd(), Yod)) ? b.Hc(Xod) ? b.Hc(npd) ? b.Hc(ppd) ? null : Jnc : Lnc : Knc : Inc);
                                Qnc(a, d, c[0], (joc(), goc), 0);
                                Qnc(a, d, c[1], hoc, 1);
                                Qnc(a, d, c[2], ioc, 1);
                            }
                        }
                        function Kqc(a, b) {
                            var c, d;
                            c = Lqc(b);
                            Oqc(a, b, c);
                            UTc(a.a, RD(mQb(Y2b(b.b), (Ywc(), Lwc)), 234));
                            Jqc(a);
                            Iqc(a, b);
                            d = $C(kE, Pwe, 28, b.b.j.c.length, 15, 1);
                            Rqc(a, b, (qpd(), Yod), d, c);
                            Rqc(a, b, Xod, d, c);
                            Rqc(a, b, npd, d, c);
                            Rqc(a, b, ppd, d, c);
                            a.a = null;
                            a.c = null;
                            a.b = null;
                        }
                        function Yyd(a, b, c) {
                            switch(b){
                                case 7:
                                    !a.e && (a.e = new Yie(G4, a, 7, 4));
                                    sLd(a.e);
                                    !a.e && (a.e = new Yie(G4, a, 7, 4));
                                    YGd(a.e, RD(c, 16));
                                    return;
                                case 8:
                                    !a.d && (a.d = new Yie(G4, a, 8, 5));
                                    sLd(a.d);
                                    !a.d && (a.d = new Yie(G4, a, 8, 5));
                                    YGd(a.d, RD(c, 16));
                                    return;
                            }
                            xyd(a, b, c);
                        }
                        function Rt(a, b) {
                            var c, d, e, f, g;
                            if (dE(b) === dE(a)) return true;
                            if (!ZD(b, 15)) return false;
                            g = RD(b, 15);
                            if (a.gc() != g.gc()) return false;
                            f = g.Kc();
                            for(d = a.Kc(); d.Ob();){
                                c = d.Pb();
                                e = f.Pb();
                                if (!(dE(c) === dE(e) || c != null && pb(c, e))) return false;
                            }
                            return true;
                        }
                        function jac(a, b) {
                            var c, d, e, f;
                            f = RD(zDb(EDb(EDb(new SDb(null, new Swb(b.b, 16)), new pac), new rac), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), vBb)
                            ]))), 15);
                            f.Jc(new tac);
                            c = 0;
                            for(e = f.Kc(); e.Ob();){
                                d = RD(e.Pb(), 12);
                                d.p == -1 && iac(a, d, c++);
                            }
                        }
                        function KDc(a) {
                            switch(a.g){
                                case 0:
                                    return new iQc;
                                case 1:
                                    return new DNc;
                                case 2:
                                    return new TNc;
                                case 3:
                                    return new aRc;
                                case 4:
                                    return new yOc;
                                default:
                                    throw Adb(new agb('No implementation is available for the node placer ' + (a.f != null ? a.f : '' + a.g)));
                            }
                        }
                        function Qtc(a) {
                            switch(a.g){
                                case 0:
                                    return new UFc;
                                case 1:
                                    return new NFc;
                                case 2:
                                    return new cGc;
                                case 3:
                                    return new jGc;
                                case 4:
                                    return new YFc;
                                default:
                                    throw Adb(new agb('No implementation is available for the cycle breaker ' + (a.f != null ? a.f : '' + a.g)));
                            }
                        }
                        function I_c(a, b) {
                            var c, d, e, f, g;
                            d = new Yub;
                            Pub(d, b, d.c.b, d.c);
                            do {
                                c = (sFb(d.b != 0), RD(Wub(d, d.a.a), 40));
                                a.b[c.g] = 1;
                                for(f = Sub(c.d, 0); f.b != f.d.c;){
                                    e = RD(evb(f), 65);
                                    g = e.c;
                                    a.b[g.g] == 1 ? Mub(a.a, e) : a.b[g.g] == 2 ? a.b[g.g] = 1 : Pub(d, g, d.c.b, d.c);
                                }
                            }while (d.b != 0);
                        }
                        function $$b(a, b, c) {
                            var d;
                            d = null;
                            !!b && (d = b.d);
                            k_b(a, new eZb(b.n.a - d.b + c.a, b.n.b - d.d + c.b));
                            k_b(a, new eZb(b.n.a - d.b + c.a, b.n.b + b.o.b + d.a + c.b));
                            k_b(a, new eZb(b.n.a + b.o.a + d.c + c.a, b.n.b - d.d + c.b));
                            k_b(a, new eZb(b.n.a + b.o.a + d.c + c.a, b.n.b + b.o.b + d.a + c.b));
                        }
                        function iac(a, b, c) {
                            var d, e, f;
                            b.p = c;
                            for(f = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                new T3b(b),
                                new _3b(b)
                            ]))); gs(f);){
                                d = RD(hs(f), 12);
                                d.p == -1 && iac(a, d, c);
                            }
                            if (b.i.k == (r3b(), o3b)) for(e = new Anb(b.i.j); e.a < e.c.c.length;){
                                d = RD(ynb(e), 12);
                                d != b && d.p == -1 && iac(a, d, c);
                            }
                        }
                        function cRc(a, b) {
                            var c, d, e, f, g, h;
                            d = new gub;
                            g = Xx(new mob(a.g));
                            for(f = g.a.ec().Kc(); f.Ob();){
                                e = RD(f.Pb(), 10);
                                if (!e) {
                                    b.bh('There are no classes in a balanced layout.');
                                    break;
                                }
                                h = a.j[e.p];
                                c = RD(cub(d, h), 15);
                                if (!c) {
                                    c = new bnb;
                                    dub(d, h, c);
                                }
                                c.Fc(e);
                            }
                            return d;
                        }
                        function RTc(a) {
                            var b, c, d, e, f;
                            e = RD(zDb(BDb(ODb(a)), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), vBb)
                            ]))), 15);
                            d = Hze;
                            if (e.gc() >= 2) {
                                c = e.Kc();
                                b = UD(c.Pb());
                                while(c.Ob()){
                                    f = b;
                                    b = UD(c.Pb());
                                    d = $wnd.Math.min(d, (uFb(b), b) - (uFb(f), f));
                                }
                            }
                            return d;
                        }
                        function iWc(a, b) {
                            var c, d, e;
                            e = new bnb;
                            for(d = Sub(b.a, 0); d.b != d.d.c;){
                                c = RD(evb(d), 65);
                                c.b.g == a.g && !lhb(c.b.c, IEe) && dE(mQb(c.b, (h_c(), f_c))) !== dE(mQb(c.c, f_c)) && !yDb(new SDb(null, new Swb(e, 16)), new OWc(c)) && ZEb(e.c, c);
                            }
                            _mb(e, new QWc);
                            return e;
                        }
                        function $u(a, b) {
                            var c, d, e;
                            if (dE(b) === dE(Qb(a))) return true;
                            if (!ZD(b, 15)) return false;
                            d = RD(b, 15);
                            e = a.gc();
                            if (e != d.gc()) return false;
                            if (ZD(d, 59)) {
                                for(c = 0; c < e; c++){
                                    if (!Hb(a.Xb(c), d.Xb(c))) return false;
                                }
                                return true;
                            } else return Cr(a.Kc(), d.Kc());
                        }
                        function Scc(a, b, c, d, e, f) {
                            var g, h, i, j;
                            h = !QDb(CDb(a.Oc(), new PAb(new Wcc))).Bd((xDb(), wDb));
                            g = a;
                            f == (Cmd(), Bmd) && (g = hv(g));
                            for(j = g.Kc(); j.Ob();){
                                i = RD(j.Pb(), 72);
                                i.n.a = b.a;
                                h ? i.n.b = b.b + (d.b - i.o.b) / 2 : e ? i.n.b = b.b : i.n.b = b.b + d.b - i.o.b;
                                b.a += i.o.a + c;
                            }
                        }
                        function Tgc(a, b) {
                            var c, d, e, f, g;
                            b.Ug('Port side processing', 1);
                            for(g = new Anb(a.a); g.a < g.c.c.length;){
                                e = RD(ynb(g), 10);
                                Ugc(e);
                            }
                            for(d = new Anb(a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 30);
                                for(f = new Anb(c.a); f.a < f.c.c.length;){
                                    e = RD(ynb(f), 10);
                                    Ugc(e);
                                }
                            }
                            b.Vg();
                        }
                        function bEd(a, b, c) {
                            var d, e, f, g, h, i, j;
                            if (c) {
                                f = c.a.length;
                                d = new vue(f);
                                for(h = (d.b - d.a) * d.c < 0 ? (uue(), tue) : new Rue(d); h.Ob();){
                                    g = RD(h.Pb(), 17);
                                    i = xDd(c, g.a);
                                    if (i) {
                                        j = FGd(zDd(i, hIe), b);
                                        Zjb(a.f, j, i);
                                        e = uIe in i.a;
                                        e && jyd(j, zDd(i, uIe));
                                        GEd(i, j);
                                        HEd(i, j);
                                    }
                                }
                            }
                        }
                        function MWb(a, b, c) {
                            var d, e, f, g, h;
                            h = c;
                            !h && (h = Nqd(new Oqd, 0));
                            h.Ug(EAe, 1);
                            cXb(a.c, b);
                            g = H_b(a.a, b);
                            if (g.gc() == 1) OWb(RD(g.Xb(0), 36), h);
                            else {
                                f = 1 / g.gc();
                                for(e = g.Kc(); e.Ob();){
                                    d = RD(e.Pb(), 36);
                                    if (c.$g()) return;
                                    OWb(d, h.eh(f));
                                }
                            }
                            F_b(a.a, g, b);
                            PWb(b);
                            h.Vg();
                        }
                        function Hic(a, b, c) {
                            var d, e, f, g, h;
                            e = a.f;
                            !e && (e = RD(a.a.a.ec().Kc().Pb(), 60));
                            Iic(e, b, c);
                            if (a.a.a.gc() == 1) return;
                            d = b * c;
                            for(g = a.a.a.ec().Kc(); g.Ob();){
                                f = RD(g.Pb(), 60);
                                if (f != e) {
                                    h = $jc(f);
                                    if (h.f.d) {
                                        f.d.d += d + Tye;
                                        f.d.a -= d + Tye;
                                    } else h.f.a && (f.d.a -= d + Tye);
                                }
                            }
                        }
                        function kTb(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n;
                            g = c - a;
                            h = d - b;
                            f = $wnd.Math.atan2(g, h);
                            i = f + Gze;
                            j = f - Gze;
                            k = e * $wnd.Math.sin(i) + a;
                            m = e * $wnd.Math.cos(i) + b;
                            l = e * $wnd.Math.sin(j) + a;
                            n = e * $wnd.Math.cos(j) + b;
                            return dv(cD(WC(l3, 1), Nve, 8, 0, [
                                new rjd(k, m),
                                new rjd(l, n)
                            ]));
                        }
                        function mQc(a, b, c, d) {
                            var e, f, g, h, i, j, k, l;
                            e = c;
                            k = b;
                            f = k;
                            do {
                                f = a.a[f.p];
                                h = (l = a.g[f.p], Kfb(a.p[l.p]) + Kfb(a.d[f.p]) - f.d.d);
                                i = pQc(f, d);
                                if (i) {
                                    g = (j = a.g[i.p], Kfb(a.p[j.p]) + Kfb(a.d[i.p]) + i.o.b + i.d.a);
                                    e = $wnd.Math.min(e, h - (g + bFc(a.k, f, i)));
                                }
                            }while (k != f);
                            return e;
                        }
                        function nQc(a, b, c, d) {
                            var e, f, g, h, i, j, k, l;
                            e = c;
                            k = b;
                            f = k;
                            do {
                                f = a.a[f.p];
                                g = (l = a.g[f.p], Kfb(a.p[l.p]) + Kfb(a.d[f.p]) + f.o.b + f.d.a);
                                i = oQc(f, d);
                                if (i) {
                                    h = (j = a.g[i.p], Kfb(a.p[j.p]) + Kfb(a.d[i.p]) - i.d.d);
                                    e = $wnd.Math.min(e, h - (g + bFc(a.k, f, i)));
                                }
                            }while (k != f);
                            return e;
                        }
                        function r9c(a, b) {
                            var c;
                            b.Ug('Equal Whitespace Eliminator', 1);
                            if (Hxd(a, (X6c(), V6c))) w9c(RD(Gxd(a, V6c), 15), Kfb(UD(Gxd(a, O6c))), (c = Kfb(UD(Gxd(a, M6c))), Kfb(UD(Gxd(a, (X7c(), Q7c)))), c));
                            else throw Adb(new Jed('The graph does not contain rows.'));
                            b.Vg();
                        }
                        function Gxd(a, b) {
                            var c, d;
                            d = (!a.o && (a.o = new DVd((pvd(), mvd), X4, a, 0)), $Nd(a.o, b));
                            if (d != null) return d;
                            c = b.Sg();
                            ZD(c, 4) && (c == null ? (!a.o && (a.o = new DVd((pvd(), mvd), X4, a, 0)), jOd(a.o, b)) : (!a.o && (a.o = new DVd((pvd(), mvd), X4, a, 0)), fOd(a.o, b, c)), a);
                            return c;
                        }
                        function dod() {
                            dod = geb;
                            Xnd = new eod('H_LEFT', 0);
                            Wnd = new eod('H_CENTER', 1);
                            Znd = new eod('H_RIGHT', 2);
                            cod = new eod('V_TOP', 3);
                            bod = new eod('V_CENTER', 4);
                            aod = new eod('V_BOTTOM', 5);
                            $nd = new eod('INSIDE', 6);
                            _nd = new eod('OUTSIDE', 7);
                            Ynd = new eod('H_PRIORITY', 8);
                        }
                        function jJb(a, b) {
                            var c, d, e, f, g, h, i;
                            if (!b.f) throw Adb(new agb('The input edge is not a tree edge.'));
                            f = null;
                            e = lve;
                            for(d = new Anb(a.d); d.a < d.c.c.length;){
                                c = RD(ynb(d), 218);
                                h = c.d;
                                i = c.e;
                                if (oJb(a, h, b) && !oJb(a, i, b)) {
                                    g = i.e - h.e - c.a;
                                    if (g < e) {
                                        e = g;
                                        f = c;
                                    }
                                }
                            }
                            return f;
                        }
                        function sWb(a) {
                            var b, c, d, e, f, g;
                            if (a.f.e.c.length <= 1) return;
                            b = 0;
                            e = pWb(a);
                            c = oxe;
                            do {
                                b > 0 && (e = c);
                                for(g = new Anb(a.f.e); g.a < g.c.c.length;){
                                    f = RD(ynb(g), 153);
                                    if (Heb(TD(mQb(f, (dWb(), WVb))))) continue;
                                    d = oWb(a, f);
                                    $id(hjd(f.d), d);
                                }
                                c = pWb(a);
                            }while (!rWb(a, b++, e, c));
                        }
                        function Ymc(a, b) {
                            var c, d, e, f, g;
                            f = a.g.a;
                            g = a.g.b;
                            for(d = new Anb(a.d); d.a < d.c.c.length;){
                                c = RD(ynb(d), 72);
                                e = c.n;
                                a.a == (enc(), bnc) || a.i == (qpd(), Xod) ? e.a = f : a.a == cnc || a.i == (qpd(), ppd) ? e.a = f + a.j.a - c.o.a : e.a = f + (a.j.a - c.o.a) / 2;
                                e.b = g;
                                $id(e, b);
                                g += c.o.b + a.e;
                            }
                        }
                        function BEd(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            j = a;
                            i = yDd(j, 'individualSpacings');
                            if (i) {
                                d = Hxd(b, (umd(), amd));
                                g = !d;
                                if (g) {
                                    e = new dtd;
                                    Ixd(b, amd, e);
                                }
                                h = RD(Gxd(b, amd), 385);
                                l = i;
                                f = null;
                                !!l && (f = (k = oC(l, $C(qJ, Nve, 2, 0, 6, 1)), new CC(l, k)));
                                if (f) {
                                    c = new dFd(l, h);
                                    xgb(f, c);
                                }
                            }
                        }
                        function FEd(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m;
                            i = null;
                            l = a;
                            k = null;
                            if (DIe in l.a || EIe in l.a || nIe in l.a) {
                                j = null;
                                m = EGd(b);
                                g = yDd(l, DIe);
                                c = new gFd(m);
                                cEd(c.a, g);
                                h = yDd(l, EIe);
                                d = new AFd(m);
                                nEd(d.a, h);
                                f = wDd(l, nIe);
                                e = new DFd(m);
                                j = (oEd(e.a, f), f);
                                k = j;
                            }
                            i = k;
                            return i;
                        }
                        function ox(a, b) {
                            var c, d, e;
                            if (b === a) return true;
                            if (ZD(b, 552)) {
                                e = RD(b, 849);
                                if (a.a.d != e.a.d || Ih(a).gc() != Ih(e).gc()) return false;
                                for(d = Ih(e).Kc(); d.Ob();){
                                    c = RD(d.Pb(), 425);
                                    if (Qw(a, c.a.ld()) != RD(c.a.md(), 16).gc()) return false;
                                }
                                return true;
                            }
                            return false;
                        }
                        function sPb(a) {
                            var b, c, d, e;
                            d = RD(a.a, 17).a;
                            e = RD(a.b, 17).a;
                            b = d;
                            c = e;
                            if (d == 0 && e == 0) c -= 1;
                            else {
                                if (d == -1 && e <= 0) {
                                    b = 0;
                                    c -= 2;
                                } else if (d <= 0 && e > 0) {
                                    b -= 1;
                                    c -= 1;
                                } else {
                                    if (d >= 0 && e < 0) {
                                        b += 1;
                                        c += 1;
                                    } else if (d > 0 && e >= 0) {
                                        b -= 1;
                                        c += 1;
                                    } else {
                                        b += 1;
                                        c -= 1;
                                    }
                                }
                            }
                            return new Ptd(sgb(b), sgb(c));
                        }
                        function nNc(a, b) {
                            if (a.c < b.c) return -1;
                            else if (a.c > b.c) return 1;
                            else if (a.b < b.b) return -1;
                            else if (a.b > b.b) return 1;
                            else if (a.a != b.a) return tb(a.a) - tb(b.a);
                            else if (a.d == (sNc(), rNc) && b.d == qNc) return -1;
                            else if (a.d == qNc && b.d == rNc) return 1;
                            return 0;
                        }
                        function ARc(a, b) {
                            var c, d, e, f, g;
                            f = b.a;
                            f.c.i == b.b ? g = f.d : g = f.c;
                            f.c.i == b.b ? d = f.c : d = f.d;
                            e = lQc(a.a, g, d);
                            if (e > 0 && e < Hze) {
                                c = mQc(a.a, d.i, e, a.c);
                                rQc(a.a, d.i, -c);
                                return c > 0;
                            } else if (e < 0 && -e < Hze) {
                                c = nQc(a.a, d.i, -e, a.c);
                                rQc(a.a, d.i, c);
                                return c > 0;
                            }
                            return false;
                        }
                        function X9c(a, b, c, d) {
                            var e, f, g, h, i, j, k, l;
                            e = (b - a.d) / a.c.c.length;
                            f = 0;
                            a.a += c;
                            a.d = b;
                            for(l = new Anb(a.c); l.a < l.c.c.length;){
                                k = RD(ynb(l), 27);
                                j = k.g;
                                i = k.f;
                                Dyd(k, k.i + f * e);
                                Eyd(k, k.j + d * c);
                                Cyd(k, k.g + e);
                                Ayd(k, a.a);
                                ++f;
                                h = k.g;
                                g = k.f;
                                Jsd(k, new rjd(h, g), new rjd(j, i));
                            }
                        }
                        function vAd(a) {
                            var b, c, d, e, f, g, h;
                            if (a == null) return null;
                            h = a.length;
                            e = (h + 1) / 2 | 0;
                            g = $C(gE, YHe, 28, e, 15, 1);
                            h % 2 != 0 && (g[--e] = JAd((BFb(h - 1, a.length), a.charCodeAt(h - 1))));
                            for(c = 0, d = 0; c < e; ++c){
                                b = JAd(ihb(a, d++));
                                f = JAd(ihb(a, d++));
                                g[c] = (b << 4 | f) << 24 >> 24;
                            }
                            return g;
                        }
                        function Bfb(a) {
                            if (a.ze()) {
                                var b = a.c;
                                b.Ae() ? a.o = '[' + b.n : !b.ze() ? a.o = '[L' + b.xe() + ';' : a.o = '[' + b.xe();
                                a.b = b.we() + '[]';
                                a.k = b.ye() + '[]';
                                return;
                            }
                            var c = a.j;
                            var d = a.d;
                            d = d.split('/');
                            a.o = Efb('.', [
                                c,
                                Efb('$', d)
                            ]);
                            a.b = Efb('.', [
                                c,
                                Efb('.', d)
                            ]);
                            a.k = d[d.length - 1];
                        }
                        function hJb(a, b) {
                            var c, d, e, f, g;
                            g = null;
                            for(f = new Anb(a.e.a); f.a < f.c.c.length;){
                                e = RD(ynb(f), 125);
                                if (e.b.a.c.length == e.g.a.c.length) {
                                    d = e.e;
                                    g = sJb(e);
                                    for(c = e.e - RD(g.a, 17).a + 1; c < e.e + RD(g.b, 17).a; c++)b[c] < b[d] && (d = c);
                                    if (b[d] < b[e.e]) {
                                        --b[e.e];
                                        ++b[d];
                                        e.e = d;
                                    }
                                }
                            }
                        }
                        function qQc(a) {
                            var b, c, d, e, f, g, h, i;
                            e = oxe;
                            d = pxe;
                            for(c = new Anb(a.e.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 30);
                                for(g = new Anb(b.a); g.a < g.c.c.length;){
                                    f = RD(ynb(g), 10);
                                    i = Kfb(a.p[f.p]);
                                    h = i + Kfb(a.b[a.g[f.p].p]);
                                    e = $wnd.Math.min(e, i);
                                    d = $wnd.Math.max(d, h);
                                }
                            }
                            return d - e;
                        }
                        function nSd(a) {
                            gSd();
                            var b, c, d, e;
                            d = qhb(a, Fhb(35));
                            b = d == -1 ? a : (AFb(0, d, a.length), a.substr(0, d));
                            c = d == -1 ? null : (BFb(d + 1, a.length + 1), a.substr(d + 1));
                            e = KSd(fSd, b);
                            if (!e) {
                                e = ASd(b);
                                LSd(fSd, b, e);
                                c != null && (e = hSd(e, c));
                            } else c != null && (e = hSd(e, (uFb(c), c)));
                            return e;
                        }
                        function Ree(a, b, c, d) {
                            var e, f, g, h, i, j;
                            i = null;
                            e = Fee(a, b);
                            for(h = 0, j = e.gc(); h < j; ++h){
                                f = RD(e.Xb(h), 179);
                                if (lhb(d, Afe(Qee(a, f)))) {
                                    g = Bfe(Qee(a, f));
                                    if (c == null) {
                                        if (g == null) return f;
                                        else !i && (i = f);
                                    } else if (lhb(c, g)) return f;
                                    else g == null && !i && (i = f);
                                }
                            }
                            return null;
                        }
                        function See(a, b, c, d) {
                            var e, f, g, h, i, j;
                            i = null;
                            e = Gee(a, b);
                            for(h = 0, j = e.gc(); h < j; ++h){
                                f = RD(e.Xb(h), 179);
                                if (lhb(d, Afe(Qee(a, f)))) {
                                    g = Bfe(Qee(a, f));
                                    if (c == null) {
                                        if (g == null) return f;
                                        else !i && (i = f);
                                    } else if (lhb(c, g)) return f;
                                    else g == null && !i && (i = f);
                                }
                            }
                            return null;
                        }
                        function Pge(a, b, c) {
                            var d, e, f, g, h, i;
                            g = new YHd;
                            h = pke(a.e.Dh(), b);
                            d = RD(a.g, 124);
                            nke();
                            if (RD(b, 69).xk()) for(f = 0; f < a.i; ++f){
                                e = d[f];
                                h.am(e.Lk()) && WGd(g, e);
                            }
                            else for(f = 0; f < a.i; ++f){
                                e = d[f];
                                if (h.am(e.Lk())) {
                                    i = e.md();
                                    WGd(g, c ? Bge(a, b, f, g.i, i) : i);
                                }
                            }
                            return WHd(g);
                        }
                        function Kje(a) {
                            var b, c, d, e, f, g, h;
                            if (a) {
                                b = a.qi(AKe);
                                if (b) {
                                    g = WD($Nd((!b.b && (b.b = new SVd((JTd(), FTd), C8, b)), b.b), 'conversionDelegates'));
                                    if (g != null) {
                                        h = new bnb;
                                        for(d = vhb(g, '\\w+'), e = 0, f = d.length; e < f; ++e){
                                            c = d[e];
                                            ZEb(h.c, c);
                                        }
                                        return h;
                                    }
                                }
                            }
                            return yob(), yob(), vob;
                        }
                        function WXb(a, b) {
                            var c, d, e, f, g, h, i, j;
                            g = b == 1 ? MXb : LXb;
                            for(f = g.a.ec().Kc(); f.Ob();){
                                e = RD(f.Pb(), 88);
                                for(i = RD(Qc(a.f.c, e), 21).Kc(); i.Ob();){
                                    h = RD(i.Pb(), 42);
                                    d = RD(h.b, 86);
                                    j = RD(h.a, 194);
                                    c = j.c;
                                    switch(e.g){
                                        case 2:
                                        case 1:
                                            d.g.d += c;
                                            break;
                                        case 4:
                                        case 3:
                                            d.g.c += c;
                                    }
                                }
                            }
                        }
                        function idc(a, b) {
                            var c, d, e, f, g;
                            c = new Zrb(ZW);
                            for(e = (btc(), cD(WC(ZW, 1), jwe, 232, 0, [
                                Zsc,
                                _sc,
                                Ysc,
                                $sc,
                                atc,
                                Xsc
                            ])), f = 0, g = e.length; f < g; ++f){
                                d = e[f];
                                Xrb(c, d, new bnb);
                            }
                            FDb(GDb(CDb(EDb(new SDb(null, new Swb(a.b, 16)), new ydc), new Adc), new Cdc(b)), new Edc(c));
                            return c;
                        }
                        function n3c(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            for(f = b.Kc(); f.Ob();){
                                e = RD(f.Pb(), 27);
                                k = e.i + e.g / 2;
                                m = e.j + e.f / 2;
                                i = a.f;
                                g = i.i + i.g / 2;
                                h = i.j + i.f / 2;
                                j = k - g;
                                l = m - h;
                                d = $wnd.Math.sqrt(j * j + l * l);
                                j *= a.e / d;
                                l *= a.e / d;
                                if (c) {
                                    k -= j;
                                    m -= l;
                                } else {
                                    k += j;
                                    m += l;
                                }
                                Dyd(e, k - e.g / 2);
                                Eyd(e, m - e.f / 2);
                            }
                        }
                        function vte(a) {
                            var b, c, d;
                            if (a.c) return;
                            if (a.b == null) return;
                            for(b = a.b.length - 4; b >= 0; b -= 2){
                                for(c = 0; c <= b; c += 2)if (a.b[c] > a.b[c + 2] || a.b[c] === a.b[c + 2] && a.b[c + 1] > a.b[c + 3]) {
                                    d = a.b[c + 2];
                                    a.b[c + 2] = a.b[c];
                                    a.b[c] = d;
                                    d = a.b[c + 3];
                                    a.b[c + 3] = a.b[c + 1];
                                    a.b[c + 1] = d;
                                }
                            }
                            a.c = true;
                        }
                        function nKc(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            j = -1;
                            k = 0;
                            for(g = a, h = 0, i = g.length; h < i; ++h){
                                f = g[h];
                                c = new hrc(j == -1 ? a[0] : a[j], b, (lDc(), kDc));
                                for(d = 0; d < f.length; d++)for(e = d + 1; e < f.length; e++)nQb(f[d], (Ywc(), zwc)) && nQb(f[e], zwc) && crc(c, f[d], f[e]) > 0 && ++k;
                                ++j;
                            }
                            return k;
                        }
                        function awd(a) {
                            var b, c;
                            c = new dib(nfb(a.Rm));
                            c.a += '@';
                            Zhb(c, (b = tb(a) >>> 0, b.toString(16)));
                            if (a.Vh()) {
                                c.a += ' (eProxyURI: ';
                                Yhb(c, a._h());
                                if (a.Kh()) {
                                    c.a += ' eClass: ';
                                    Yhb(c, a.Kh());
                                }
                                c.a += ')';
                            } else if (a.Kh()) {
                                c.a += ' (eClass: ';
                                Yhb(c, a.Kh());
                                c.a += ')';
                            }
                            return c.a;
                        }
                        function KGb(a) {
                            var b, c, d, e;
                            if (a.e) throw Adb(new dgb((lfb(lN), lye + lN.k + mye)));
                            a.d == (Cmd(), Amd) && JGb(a, ymd);
                            for(c = new Anb(a.a.a); c.a < c.c.c.length;){
                                b = RD(ynb(c), 316);
                                b.g = b.i;
                            }
                            for(e = new Anb(a.a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 60);
                                d.i = pxe;
                            }
                            a.b.cf(a);
                            return a;
                        }
                        function rUc(a, b) {
                            var c, d, e, f, g;
                            if (b < 2 * a.b) throw Adb(new agb('The knot vector must have at least two time the dimension elements.'));
                            a.f = 1;
                            for(e = 0; e < a.b; e++)Rmb(a.e, 0);
                            g = b + 1 - 2 * a.b;
                            c = g;
                            for(f = 1; f < g; f++)Rmb(a.e, f / c);
                            if (a.d) for(d = 0; d < a.b; d++)Rmb(a.e, 1);
                        }
                        function AEd(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            j = b;
                            k = RD(lp(Co(a.i), j), 27);
                            if (!k) {
                                e = zDd(j, uIe);
                                h = "Unable to find elk node for json object '" + e;
                                i = h + "' Panic!";
                                throw Adb(new CDd(i));
                            }
                            f = wDd(j, 'edges');
                            c = new KEd(a, k);
                            MDd(c.a, c.b, f);
                            g = wDd(j, iIe);
                            d = new VEd(a);
                            XDd(d.a, g);
                        }
                        function XNd(a, b, c, d) {
                            var e, f, g, h, i;
                            if (d != null) {
                                e = a.d[b];
                                if (e) {
                                    f = e.g;
                                    i = e.i;
                                    for(h = 0; h < i; ++h){
                                        g = RD(f[h], 136);
                                        if (g.Bi() == c && pb(d, g.ld())) return h;
                                    }
                                }
                            } else {
                                e = a.d[b];
                                if (e) {
                                    f = e.g;
                                    i = e.i;
                                    for(h = 0; h < i; ++h){
                                        g = RD(f[h], 136);
                                        if (dE(g.ld()) === dE(d)) return h;
                                    }
                                }
                            }
                            return -1;
                        }
                        function N5d(a, b) {
                            var c, d, e;
                            c = b == null ? Wd(qtb(a.f, null)) : Ktb(a.i, b);
                            if (ZD(c, 241)) {
                                e = RD(c, 241);
                                e.zi() == null && undefined;
                                return e;
                            } else if (ZD(c, 507)) {
                                d = RD(c, 2037);
                                e = d.a;
                                !!e && (e.yb == null ? undefined : b == null ? rtb(a.f, null, e) : Ltb(a.i, b, e));
                                return e;
                            } else return null;
                        }
                        function Hqe(a) {
                            Gqe();
                            var b, c, d, e, f, g, h;
                            if (a == null) return null;
                            e = a.length;
                            if (e % 2 != 0) return null;
                            b = Ahb(a);
                            f = e / 2 | 0;
                            c = $C(gE, YHe, 28, f, 15, 1);
                            for(d = 0; d < f; d++){
                                g = Eqe[b[d * 2]];
                                if (g == -1) return null;
                                h = Eqe[b[d * 2 + 1]];
                                if (h == -1) return null;
                                c[d] = (g << 4 | h) << 24 >> 24;
                            }
                            return c;
                        }
                        function cNb(a, b, c) {
                            var d, e, f;
                            e = RD(Vrb(a.i, b), 314);
                            if (!e) {
                                e = new UKb(a.d, b, c);
                                Wrb(a.i, b, e);
                                if (jMb(b)) tKb(a.a, b.c, b.b, e);
                                else {
                                    f = iMb(b);
                                    d = RD(Vrb(a.p, f), 252);
                                    switch(f.g){
                                        case 1:
                                        case 3:
                                            e.j = true;
                                            cLb(d, b.b, e);
                                            break;
                                        case 4:
                                        case 2:
                                            e.k = true;
                                            cLb(d, b.c, e);
                                    }
                                }
                            }
                            return e;
                        }
                        function Ndc(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            i = ev(a.c - a.b & a.a.length - 1);
                            j = null;
                            k = null;
                            for(f = new Kmb(a); f.a != f.b;){
                                e = RD(Imb(f), 10);
                                c = (h = RD(mQb(e, (Ywc(), vwc)), 12), !h ? null : h.i);
                                d = (g = RD(mQb(e, wwc), 12), !g ? null : g.i);
                                if (j != c || k != d) {
                                    Rdc(i, b);
                                    j = c;
                                    k = d;
                                }
                                ZEb(i.c, e);
                            }
                            Rdc(i, b);
                        }
                        function Rge(a, b, c, d) {
                            var e, f, g, h, i, j;
                            h = new YHd;
                            i = pke(a.e.Dh(), b);
                            e = RD(a.g, 124);
                            nke();
                            if (RD(b, 69).xk()) for(g = 0; g < a.i; ++g){
                                f = e[g];
                                i.am(f.Lk()) && WGd(h, f);
                            }
                            else for(g = 0; g < a.i; ++g){
                                f = e[g];
                                if (i.am(f.Lk())) {
                                    j = f.md();
                                    WGd(h, d ? Bge(a, b, g, h.i, j) : j);
                                }
                            }
                            return XHd(h, c);
                        }
                        function oHc(a, b) {
                            var c, d, e, f, g, h, i, j;
                            e = a.b[b.p];
                            if (e >= 0) return e;
                            else {
                                f = 1;
                                for(h = new Anb(b.j); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 12);
                                    for(d = new Anb(g.g); d.a < d.c.c.length;){
                                        c = RD(ynb(d), 18);
                                        j = c.d.i;
                                        if (b != j) {
                                            i = oHc(a, j);
                                            f = $wnd.Math.max(f, i + 1);
                                        }
                                    }
                                }
                                nHc(a, b, f);
                                return f;
                            }
                        }
                        function wHc(a, b) {
                            var c, d, e, f, g, h, i, j;
                            e = a.b[b.p];
                            if (e >= 0) return e;
                            else {
                                f = 1;
                                for(h = new Anb(b.j); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 12);
                                    for(d = new Anb(g.e); d.a < d.c.c.length;){
                                        c = RD(ynb(d), 18);
                                        j = c.c.i;
                                        if (b != j) {
                                            i = wHc(a, j);
                                            f = $wnd.Math.max(f, i + 1);
                                        }
                                    }
                                }
                                vHc(a, b, f);
                                return f;
                            }
                        }
                        function wLc(a, b, c) {
                            var d, e, f;
                            for(d = 1; d < a.c.length; d++){
                                f = (tFb(d, a.c.length), RD(a.c[d], 10));
                                e = d;
                                while(e > 0 && b.Ne((tFb(e - 1, a.c.length), RD(a.c[e - 1], 10)), f) > 0){
                                    $mb(a, e, (tFb(e - 1, a.c.length), RD(a.c[e - 1], 10)));
                                    --e;
                                }
                                tFb(e, a.c.length);
                                a.c[e] = f;
                            }
                            c.a = new Tsb;
                            c.b = new Tsb;
                        }
                        function yhd(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            k = (d = RD(b.e && b.e(), 9), new Fsb(d, RD(WEb(d, d.length), 9), 0));
                            i = vhb(c, '[\\[\\]\\s,]+');
                            for(f = i, g = 0, h = f.length; g < h; ++g){
                                e = f[g];
                                if (Dhb(e).length == 0) continue;
                                j = xhd(a, e);
                                if (j == null) return null;
                                else zsb(k, RD(j, 22));
                            }
                            return k;
                        }
                        function tse(a) {
                            var b, c, d, e;
                            e = a.length;
                            b = null;
                            for(d = 0; d < e; d++){
                                c = (BFb(d, a.length), a.charCodeAt(d));
                                if (qhb('.*+?{[()|\\^$', Fhb(c)) >= 0) {
                                    if (!b) {
                                        b = new Rhb;
                                        d > 0 && Nhb(b, (AFb(0, d, a.length), a.substr(0, d)));
                                    }
                                    b.a += '\\';
                                    Jhb(b, c & Bwe);
                                } else !!b && Jhb(b, c & Bwe);
                            }
                            return b ? b.a : a;
                        }
                        function MYb(a) {
                            var b, c, d;
                            for(c = new Anb(a.a.a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 86);
                                d = (uFb(0), 0);
                                if (d > 0) {
                                    !(Dmd(a.a.c) && b.n.d) && !(Emd(a.a.c) && b.n.b) && (b.g.d -= $wnd.Math.max(0, d / 2 - 0.5));
                                    !(Dmd(a.a.c) && b.n.a) && !(Emd(a.a.c) && b.n.c) && (b.g.a += $wnd.Math.max(0, d - 1));
                                }
                            }
                        }
                        function Ydc(a, b, c) {
                            var d, e;
                            if ((a.c - a.b & a.a.length - 1) == 2) {
                                if (b == (qpd(), Yod) || b == Xod) {
                                    Odc(RD(omb(a), 15), (Pnd(), Lnd));
                                    Odc(RD(omb(a), 15), Mnd);
                                } else {
                                    Odc(RD(omb(a), 15), (Pnd(), Mnd));
                                    Odc(RD(omb(a), 15), Lnd);
                                }
                            } else for(e = new Kmb(a); e.a != e.b;){
                                d = RD(Imb(e), 15);
                                Odc(d, c);
                            }
                        }
                        function HGd(a, b) {
                            var c, d, e, f, g, h, i;
                            e = cv(new QGd(a));
                            h = new Jkb(e, e.c.length);
                            f = cv(new QGd(b));
                            i = new Jkb(f, f.c.length);
                            g = null;
                            while(h.b > 0 && i.b > 0){
                                c = (sFb(h.b > 0), RD(h.a.Xb(h.c = --h.b), 27));
                                d = (sFb(i.b > 0), RD(i.a.Xb(i.c = --i.b), 27));
                                if (c == d) g = c;
                                else break;
                            }
                            return g;
                        }
                        function Dmc(a, b, c) {
                            var d, e, f, g;
                            if (Hmc(a, b) > Hmc(a, c)) {
                                d = b3b(c, (qpd(), Xod));
                                a.d = d.dc() ? 0 : L3b(RD(d.Xb(0), 12));
                                g = b3b(b, ppd);
                                a.b = g.dc() ? 0 : L3b(RD(g.Xb(0), 12));
                            } else {
                                e = b3b(c, (qpd(), ppd));
                                a.d = e.dc() ? 0 : L3b(RD(e.Xb(0), 12));
                                f = b3b(b, Xod);
                                a.b = f.dc() ? 0 : L3b(RD(f.Xb(0), 12));
                            }
                        }
                        function wNb(a, b) {
                            var c, d, e, f;
                            c = a.o.a;
                            for(f = RD(RD(Qc(a.r, b), 21), 87).Kc(); f.Ob();){
                                e = RD(f.Pb(), 117);
                                e.e.a = c * Kfb(UD(e.b.of(sNb)));
                                e.e.b = (d = e.b, d.pf((umd(), Gld)) ? d.ag() == (qpd(), Yod) ? -d.Mf().b - Kfb(UD(d.of(Gld))) : Kfb(UD(d.of(Gld))) : d.ag() == (qpd(), Yod) ? -d.Mf().b : 0);
                            }
                        }
                        function Mhc(a, b) {
                            var c, d, e, f;
                            b.Ug('Self-Loop pre-processing', 1);
                            for(d = new Anb(a.a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 10);
                                if (pnc(c)) {
                                    e = (f = new onc(c), pQb(c, (Ywc(), Pwc), f), lnc(f), f);
                                    FDb(GDb(EDb(new SDb(null, new Swb(e.d, 16)), new Phc), new Rhc), new Thc);
                                    Khc(e);
                                }
                            }
                            b.Vg();
                        }
                        function xsc(a) {
                            var b, c, d, e, f, g, h, i;
                            b = true;
                            e = null;
                            f = null;
                            j: for(i = new Anb(a.a); i.a < i.c.c.length;){
                                h = RD(ynb(i), 10);
                                for(d = new is(Mr(Z2b(h).a.Kc(), new ir)); gs(d);){
                                    c = RD(hs(d), 18);
                                    if (!!e && e != h) {
                                        b = false;
                                        break j;
                                    }
                                    e = h;
                                    g = c.c.i;
                                    if (!!f && f != g) {
                                        b = false;
                                        break j;
                                    }
                                    f = g;
                                }
                            }
                            return b;
                        }
                        function mTc(a, b, c) {
                            var d, e, f, g, h, i;
                            f = -1;
                            h = -1;
                            for(g = 0; g < b.c.length; g++){
                                e = (tFb(g, b.c.length), RD(b.c[g], 339));
                                if (e.c > a.c) break;
                                else if (e.a >= a.s) {
                                    f < 0 && (f = g);
                                    h = g;
                                }
                            }
                            i = (a.s + a.c) / 2;
                            if (f >= 0) {
                                d = lTc(a, b, f, h);
                                i = yTc((tFb(d, b.c.length), RD(b.c[d], 339)));
                                wTc(b, d, c);
                            }
                            return i;
                        }
                        function _Ad(a, b, c) {
                            var d, e, f, g, h, i, j;
                            g = (f = new pVd, f);
                            nVd(g, (uFb(b), b));
                            j = (!g.b && (g.b = new SVd((JTd(), FTd), C8, g)), g.b);
                            for(i = 1; i < c.length; i += 2)fOd(j, c[i - 1], c[i]);
                            d = (!a.Ab && (a.Ab = new C5d(f7, a, 0, 3)), a.Ab);
                            for(h = 0; h < 0; ++h){
                                e = jVd(RD(QHd(d, d.i - 1), 598));
                                d = e;
                            }
                            WGd(d, g);
                        }
                        function DSb(a, b, c) {
                            var d, e, f;
                            jQb.call(this, new bnb);
                            this.a = b;
                            this.b = c;
                            this.e = a;
                            d = (a.b && CRb(a), a.a);
                            this.d = BSb(d.a, this.a);
                            this.c = BSb(d.b, this.b);
                            bQb(this, this.d, this.c);
                            CSb(this);
                            for(f = this.e.e.a.ec().Kc(); f.Ob();){
                                e = RD(f.Pb(), 272);
                                e.c.c.length > 0 && ASb(this, e);
                            }
                        }
                        function zTb(a, b, c, d, e, f) {
                            var g, h, i;
                            if (!e[b.a]) {
                                e[b.a] = true;
                                g = d;
                                !g && (g = new gUb);
                                Rmb(g.e, b);
                                for(i = f[b.a].Kc(); i.Ob();){
                                    h = RD(i.Pb(), 290);
                                    if (h.d == c || h.c == c) continue;
                                    h.c != b && zTb(a, h.c, b, g, e, f);
                                    h.d != b && zTb(a, h.d, b, g, e, f);
                                    Rmb(g.c, h);
                                    Tmb(g.d, h.b);
                                }
                                return g;
                            }
                            return null;
                        }
                        function v7b(a) {
                            var b, c, d, e, f, g, h;
                            b = 0;
                            for(e = new Anb(a.e); e.a < e.c.c.length;){
                                d = RD(ynb(e), 18);
                                c = yDb(new SDb(null, new Swb(d.b, 16)), new N7b);
                                c && ++b;
                            }
                            for(g = new Anb(a.g); g.a < g.c.c.length;){
                                f = RD(ynb(g), 18);
                                h = yDb(new SDb(null, new Swb(f.b, 16)), new P7b);
                                h && ++b;
                            }
                            return b >= 2;
                        }
                        function _qc(a, b, c, d, e) {
                            var f, g, h, i, j, k;
                            f = a.c.d.j;
                            g = RD(ju(c, 0), 8);
                            for(k = 1; k < c.b; k++){
                                j = RD(ju(c, k), 8);
                                Pub(d, g, d.c.b, d.c);
                                h = ijd($id(new sjd(g), j), 0.5);
                                i = ijd(new qjd(BVc(f)), e);
                                $id(h, i);
                                Pub(d, h, d.c.b, d.c);
                                g = j;
                                f = b == 0 ? tpd(f) : rpd(f);
                            }
                            Mub(d, (sFb(c.b != 0), RD(c.c.b.c, 8)));
                        }
                        function fod(a) {
                            dod();
                            var b, c, d;
                            c = ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                _nd
                            ]));
                            if (dy(Tx(c, a)) > 1) return false;
                            b = ysb(Xnd, cD(WC(A3, 1), jwe, 95, 0, [
                                Wnd,
                                Znd
                            ]));
                            if (dy(Tx(b, a)) > 1) return false;
                            d = ysb(cod, cD(WC(A3, 1), jwe, 95, 0, [
                                bod,
                                aod
                            ]));
                            if (dy(Tx(d, a)) > 1) return false;
                            return true;
                        }
                        function $Uc(a, b, c) {
                            var d, e, f;
                            for(f = new Anb(a.t); f.a < f.c.c.length;){
                                d = RD(ynb(f), 274);
                                if (d.b.s < 0 && d.c > 0) {
                                    d.b.n -= d.c;
                                    d.b.n <= 0 && d.b.u > 0 && Mub(b, d.b);
                                }
                            }
                            for(e = new Anb(a.i); e.a < e.c.c.length;){
                                d = RD(ynb(e), 274);
                                if (d.a.s < 0 && d.c > 0) {
                                    d.a.u -= d.c;
                                    d.a.u <= 0 && d.a.n > 0 && Mub(c, d.a);
                                }
                            }
                        }
                        function tId(a) {
                            var b, c, d, e, f;
                            if (a.g == null) {
                                a.d = a.bj(a.f);
                                WGd(a, a.d);
                                if (a.c) {
                                    f = a.f;
                                    return f;
                                }
                            }
                            b = RD(a.g[a.i - 1], 51);
                            e = b.Pb();
                            a.e = b;
                            c = a.bj(e);
                            if (c.Ob()) {
                                a.d = c;
                                WGd(a, c);
                            } else {
                                a.d = null;
                                while(!b.Ob()){
                                    bD(a.g, --a.i, null);
                                    if (a.i == 0) break;
                                    d = RD(a.g[a.i - 1], 51);
                                    b = d;
                                }
                            }
                            return e;
                        }
                        function Rfe(a, b) {
                            var c, d, e, f, g, h;
                            d = b;
                            e = d.Lk();
                            if (qke(a.e, e)) {
                                if (e.Si() && cge(a, e, d.md())) return false;
                            } else {
                                h = pke(a.e.Dh(), e);
                                c = RD(a.g, 124);
                                for(f = 0; f < a.i; ++f){
                                    g = c[f];
                                    if (h.am(g.Lk())) {
                                        if (pb(g, d)) return false;
                                        else {
                                            RD(eHd(a, f, b), 76);
                                            return true;
                                        }
                                    }
                                }
                            }
                            return WGd(a, b);
                        }
                        function Icc(a, b, c, d) {
                            var e, f, g, h;
                            e = new j3b(a);
                            h3b(e, (r3b(), n3b));
                            pQb(e, (Ywc(), Awc), b);
                            pQb(e, Mwc, d);
                            pQb(e, (yCc(), BBc), (Bod(), wod));
                            pQb(e, vwc, b.c);
                            pQb(e, wwc, b.d);
                            Oec(b, e);
                            h = $wnd.Math.floor(c / 2);
                            for(g = new Anb(e.j); g.a < g.c.c.length;){
                                f = RD(ynb(g), 12);
                                f.n.b = h;
                            }
                            return e;
                        }
                        function fSc(a) {
                            var b, c, d, e, f, g, h;
                            b = 0;
                            for(d = new Anb(a.a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 10);
                                for(f = new is(Mr(a3b(c).a.Kc(), new ir)); gs(f);){
                                    e = RD(hs(f), 18);
                                    if (a == e.d.i.c && e.c.j == (qpd(), ppd)) {
                                        g = K3b(e.c).b;
                                        h = K3b(e.d).b;
                                        b = $wnd.Math.max(b, $wnd.Math.abs(h - g));
                                    }
                                }
                            }
                            return b;
                        }
                        function QTb(a, b, c) {
                            var d, e, f, g, h;
                            c.Ug('ELK Force', 1);
                            Heb(TD(Gxd(b, (yVb(), gVb)))) || RFb((d = new SFb((lud(), new zud(b))), d));
                            h = KTb(b);
                            RTb(h);
                            STb(a, RD(mQb(h, bVb), 432));
                            g = CTb(a.a, h);
                            for(f = g.Kc(); f.Ob();){
                                e = RD(f.Pb(), 235);
                                pUb(a.b, e, c.eh(1 / g.gc()));
                            }
                            h = BTb(g);
                            JTb(h);
                            c.Vg();
                        }
                        function d_b(a, b, c) {
                            switch(c.g){
                                case 1:
                                    return new rjd(b.a, $wnd.Math.min(a.d.b, b.b));
                                case 2:
                                    return new rjd($wnd.Math.max(a.c.a, b.a), b.b);
                                case 3:
                                    return new rjd(b.a, $wnd.Math.max(a.c.b, b.b));
                                case 4:
                                    return new rjd($wnd.Math.min(b.a, a.d.a), b.b);
                            }
                            return new rjd(b.a, b.b);
                        }
                        function yGd(a) {
                            var b, c, d;
                            b = ev(1 + (!a.c && (a.c = new C5d(K4, a, 9, 9)), a.c).i);
                            Rmb(b, (!a.d && (a.d = new Yie(G4, a, 8, 5)), a.d));
                            for(d = new dMd((!a.c && (a.c = new C5d(K4, a, 9, 9)), a.c)); d.e != d.i.gc();){
                                c = RD(bMd(d), 123);
                                Rmb(b, (!c.d && (c.d = new Yie(G4, c, 8, 5)), c.d));
                            }
                            return Qb(b), new Dl(b);
                        }
                        function zGd(a) {
                            var b, c, d;
                            b = ev(1 + (!a.c && (a.c = new C5d(K4, a, 9, 9)), a.c).i);
                            Rmb(b, (!a.e && (a.e = new Yie(G4, a, 7, 4)), a.e));
                            for(d = new dMd((!a.c && (a.c = new C5d(K4, a, 9, 9)), a.c)); d.e != d.i.gc();){
                                c = RD(bMd(d), 123);
                                Rmb(b, (!c.e && (c.e = new Yie(G4, c, 7, 4)), c.e));
                            }
                            return Qb(b), new Dl(b);
                        }
                        function jne(a) {
                            var b, c, d, e;
                            if (a == null) return null;
                            else {
                                d = nue(a, true);
                                e = mLe.length;
                                if (lhb(d.substr(d.length - e, e), mLe)) {
                                    c = d.length;
                                    if (c == 4) {
                                        b = (BFb(0, d.length), d.charCodeAt(0));
                                        if (b == 43) return Wme;
                                        else if (b == 45) return Vme;
                                    } else if (c == 3) return Wme;
                                }
                                return Neb(d);
                            }
                        }
                        function _rc(a, b) {
                            var c, d, e, f, g;
                            b.Ug('Breaking Point Processor', 1);
                            $rc(a);
                            if (Heb(TD(mQb(a, (yCc(), uCc))))) {
                                for(e = new Anb(a.b); e.a < e.c.c.length;){
                                    d = RD(ynb(e), 30);
                                    c = 0;
                                    for(g = new Anb(d.a); g.a < g.c.c.length;){
                                        f = RD(ynb(g), 10);
                                        f.p = c++;
                                    }
                                }
                                Vrc(a);
                                Wrc(a, true);
                                Wrc(a, false);
                            }
                            b.Vg();
                        }
                        function MJc(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m;
                            l = d ? (qpd(), ppd) : (qpd(), Xod);
                            e = false;
                            for(i = b[c], j = 0, k = i.length; j < k; ++j){
                                h = i[j];
                                if (Cod(RD(mQb(h, (yCc(), BBc)), 101))) continue;
                                g = h.e;
                                m = !b3b(h, l).dc() && !!g;
                                if (m) {
                                    f = c1b(g);
                                    a.b = new Ylc(f, d ? 0 : f.length - 1);
                                }
                                e = e | NJc(a, h, l, m);
                            }
                            return e;
                        }
                        function gOc(a, b, c, d) {
                            var e, f, g;
                            g = T0b(b, c);
                            ZEb(d.c, b);
                            if (a.j[g.p] == -1 || a.j[g.p] == 2 || a.a[b.p]) return d;
                            a.j[g.p] = -1;
                            for(f = new is(Mr(W2b(g).a.Kc(), new ir)); gs(f);){
                                e = RD(hs(f), 18);
                                if (!(!W0b(e) && !(!W0b(e) && e.c.i.c == e.d.i.c)) || e == b) continue;
                                return gOc(a, e, g, d);
                            }
                            return d;
                        }
                        function AOc(a) {
                            var b, c, d, e;
                            b = 0;
                            c = 0;
                            for(e = new Anb(a.j); e.a < e.c.c.length;){
                                d = RD(ynb(e), 12);
                                b = Ydb(Bdb(b, ADb(CDb(new SDb(null, new Swb(d.e, 16)), new NPc))));
                                c = Ydb(Bdb(c, ADb(CDb(new SDb(null, new Swb(d.g, 16)), new PPc))));
                                if (b > 1 || c > 1) return 2;
                            }
                            if (b + c == 1) return 2;
                            return 0;
                        }
                        function Kwb(a, b) {
                            var c, d, e, f, g, h;
                            f = a.a * Mxe + a.b * 1502;
                            h = a.b * Mxe + 11;
                            c = $wnd.Math.floor(h * Nxe);
                            f += c;
                            h -= c * Oxe;
                            f %= Oxe;
                            a.a = f;
                            a.b = h;
                            if (b <= 24) return $wnd.Math.floor(a.a * Ewb[b]);
                            else {
                                e = a.a * (1 << b - 24);
                                g = $wnd.Math.floor(a.b * Fwb[b]);
                                d = e + g;
                                d >= 2147483648 && (d -= 4294967296);
                                return d;
                            }
                        }
                        function uSc(a, b, c) {
                            var d, e, f, g, h, i, j;
                            f = new bnb;
                            j = new Yub;
                            g = new Yub;
                            vSc(a, j, g, b);
                            tSc(a, j, g, b, c);
                            for(i = new Anb(a); i.a < i.c.c.length;){
                                h = RD(ynb(i), 118);
                                for(e = new Anb(h.k); e.a < e.c.c.length;){
                                    d = RD(ynb(e), 132);
                                    (!b || d.c == (fTc(), dTc)) && h.g > d.b.g && ZEb(f.c, d);
                                }
                            }
                            return f;
                        }
                        function jed(a, b, c) {
                            var d, e, f, g, h, i;
                            h = a.c;
                            for(g = (!c.q ? (yob(), yob(), wob) : c.q).vc().Kc(); g.Ob();){
                                f = RD(g.Pb(), 44);
                                d = !QDb(CDb(new SDb(null, new Swb(h, 16)), new PAb(new xed(b, f)))).Bd((xDb(), wDb));
                                if (d) {
                                    i = f.md();
                                    if (ZD(i, 4)) {
                                        e = FId(i);
                                        e != null && (i = e);
                                    }
                                    b.qf(RD(f.ld(), 149), i);
                                }
                            }
                        }
                        function mbd(a, b, c) {
                            var d, e;
                            Sed(a.b);
                            Ved(a.b, (gbd(), dbd), (_cd(), $cd));
                            Ved(a.b, ebd, b.g);
                            Ved(a.b, fbd, b.a);
                            a.a = Qed(a.b, b);
                            c.Ug('Compaction by shrinking a tree', a.a.c.length);
                            if (b.i.c.length > 1) for(e = new Anb(a.a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 47);
                                d.Kf(b, c.eh(1));
                            }
                            c.Vg();
                        }
                        function Svd(a, b, c) {
                            var d, e, f;
                            f = Eee((lke(), jke), a.Dh(), b);
                            if (f) {
                                nke();
                                if (!RD(f, 69).xk()) {
                                    f = zfe(Qee(jke, f));
                                    if (!f) throw Adb(new agb(KHe + b.xe() + LHe));
                                }
                                e = (d = a.Ih(f), RD(d >= 0 ? a.Lh(d, true, true) : Qvd(a, f, true), 160));
                                RD(e, 220).Xl(b, c);
                            } else throw Adb(new agb(KHe + b.xe() + LHe));
                        }
                        function k2d(a, b) {
                            var c, d, e, f, g;
                            if (!b) return null;
                            else {
                                f = ZD(a.Cb, 90) || ZD(a.Cb, 102);
                                g = !f && ZD(a.Cb, 331);
                                for(d = new dMd((!b.a && (b.a = new iae(b, o7, b)), b.a)); d.e != d.i.gc();){
                                    c = RD(bMd(d), 89);
                                    e = i2d(c);
                                    if (f ? ZD(e, 90) : g ? ZD(e, 156) : !!e) return e;
                                }
                                return f ? (JTd(), zTd) : (JTd(), wTd);
                            }
                        }
                        function W8b(a, b) {
                            var c, d, e, f;
                            b.Ug('Resize child graph to fit parent.', 1);
                            for(d = new Anb(a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 30);
                                Tmb(a.a, c.a);
                                c.a.c.length = 0;
                            }
                            for(f = new Anb(a.a); f.a < f.c.c.length;){
                                e = RD(ynb(f), 10);
                                g3b(e, null);
                            }
                            a.b.c.length = 0;
                            X8b(a);
                            !!a.e && V8b(a.e, a);
                            b.Vg();
                        }
                        function Fec(a, b) {
                            var c, d, e, f, g;
                            b.Ug('Edge joining', 1);
                            c = Heb(TD(mQb(a, (yCc(), mCc))));
                            for(e = new Anb(a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 30);
                                g = new Jkb(d.a, 0);
                                while(g.b < g.d.gc()){
                                    f = (sFb(g.b < g.d.gc()), RD(g.d.Xb(g.c = g.b++), 10));
                                    if (f.k == (r3b(), o3b)) {
                                        Hec(f, c);
                                        Ckb(g);
                                    }
                                }
                            }
                            b.Vg();
                        }
                        function pTc(a, b) {
                            var c, d, e, f, g;
                            c = new bnb;
                            e = EDb(new SDb(null, new Swb(a, 16)), new ITc);
                            f = EDb(new SDb(null, new Swb(a, 16)), new KTc);
                            g = VCb(UCb(HDb(Ly(cD(WC(RM, 1), rve, 848, 0, [
                                e,
                                f
                            ])), new MTc)));
                            for(d = 1; d < g.length; d++)g[d] - g[d - 1] >= 2 * b && Rmb(c, new BTc(g[d - 1] + b, g[d] - b));
                            return c;
                        }
                        function dEd(a, b, c) {
                            var d, e, f, g, h, j, k, l;
                            if (c) {
                                f = c.a.length;
                                d = new vue(f);
                                for(h = (d.b - d.a) * d.c < 0 ? (uue(), tue) : new Rue(d); h.Ob();){
                                    g = RD(h.Pb(), 17);
                                    e = xDd(c, g.a);
                                    !!e && (i = null, j = sEd(a, (k = (bvd(), l = new PCd, l), !!b && NCd(k, b), k), e), jyd(j, zDd(e, uIe)), GEd(e, j), HEd(e, j), CEd(a, e, j));
                                }
                            }
                        }
                        function sYd(a) {
                            var b, c, d, e, f, g;
                            if (!a.j) {
                                g = new f1d;
                                b = iYd;
                                f = b.a.zc(a, b);
                                if (f == null) {
                                    for(d = new dMd(zYd(a)); d.e != d.i.gc();){
                                        c = RD(bMd(d), 29);
                                        e = sYd(c);
                                        YGd(g, e);
                                        WGd(g, c);
                                    }
                                    b.a.Bc(a);
                                }
                                VHd(g);
                                a.j = new N$d((RD(QHd(xYd((lTd(), kTd).o), 11), 19), g.i), g.g);
                                yYd(a).b &= -33;
                            }
                            return a.j;
                        }
                        function lne(a) {
                            var b, c, d, e;
                            if (a == null) return null;
                            else {
                                d = nue(a, true);
                                e = mLe.length;
                                if (lhb(d.substr(d.length - e, e), mLe)) {
                                    c = d.length;
                                    if (c == 4) {
                                        b = (BFb(0, d.length), d.charCodeAt(0));
                                        if (b == 43) return Yme;
                                        else if (b == 45) return Xme;
                                    } else if (c == 3) return Yme;
                                }
                                return new Ufb(d);
                            }
                        }
                        function pD(a) {
                            var b, c, d;
                            c = a.l;
                            if ((c & c - 1) != 0) return -1;
                            d = a.m;
                            if ((d & d - 1) != 0) return -1;
                            b = a.h;
                            if ((b & b - 1) != 0) return -1;
                            if (b == 0 && d == 0 && c == 0) return -1;
                            if (b == 0 && d == 0 && c != 0) return ogb(c);
                            if (b == 0 && d != 0 && c == 0) return ogb(d) + 22;
                            if (b != 0 && d == 0 && c == 0) return ogb(b) + 44;
                            return -1;
                        }
                        function yo(a, b) {
                            var c, d, e, f, g;
                            e = b.a & a.f;
                            f = null;
                            for(d = a.b[e];; d = d.b){
                                if (d == b) {
                                    !f ? a.b[e] = b.b : f.b = b.b;
                                    break;
                                }
                                f = d;
                            }
                            g = b.f & a.f;
                            f = null;
                            for(c = a.c[g];; c = c.d){
                                if (c == b) {
                                    !f ? a.c[g] = b.d : f.d = b.d;
                                    break;
                                }
                                f = c;
                            }
                            !b.e ? a.a = b.c : b.e.c = b.c;
                            !b.c ? a.e = b.e : b.c.e = b.e;
                            --a.i;
                            ++a.g;
                        }
                        function Dt(a, b) {
                            var c;
                            b.d ? b.d.b = b.b : a.a = b.b;
                            b.b ? b.b.d = b.d : a.e = b.d;
                            if (!b.e && !b.c) {
                                c = RD(Hvb(RD(_jb(a.b, b.a), 260)), 260);
                                c.a = 0;
                                ++a.c;
                            } else {
                                c = RD(Hvb(RD(Wjb(a.b, b.a), 260)), 260);
                                --c.a;
                                !b.e ? c.b = RD(Hvb(b.c), 511) : b.e.c = b.c;
                                !b.c ? c.c = RD(Hvb(b.e), 511) : b.c.e = b.e;
                            }
                            --a.d;
                        }
                        function XPb(a) {
                            var b, c, d, e, f, g, h, i, j, k;
                            c = a.o;
                            b = a.p;
                            g = lve;
                            e = qwe;
                            h = lve;
                            f = qwe;
                            for(j = 0; j < c; ++j){
                                for(k = 0; k < b; ++k)if (PPb(a, j, k)) {
                                    g = $wnd.Math.min(g, j);
                                    e = $wnd.Math.max(e, j);
                                    h = $wnd.Math.min(h, k);
                                    f = $wnd.Math.max(f, k);
                                }
                            }
                            i = e - g + 1;
                            d = f - h + 1;
                            return new $td(sgb(g), sgb(h), sgb(i), sgb(d));
                        }
                        function FZb(a, b) {
                            var c, d, e, f;
                            f = new Jkb(a, 0);
                            c = (sFb(f.b < f.d.gc()), RD(f.d.Xb(f.c = f.b++), 148));
                            while(f.b < f.d.gc()){
                                d = (sFb(f.b < f.d.gc()), RD(f.d.Xb(f.c = f.b++), 148));
                                e = new fZb(d.c, c.d, b);
                                sFb(f.b > 0);
                                f.a.Xb(f.c = --f.b);
                                Ikb(f, e);
                                sFb(f.b < f.d.gc());
                                f.d.Xb(f.c = f.b++);
                                e.a = false;
                                c = d;
                            }
                        }
                        function n6b(a) {
                            var b, c, d, e, f, g;
                            e = RD(mQb(a, (Ywc(), Xvc)), 12);
                            for(g = new Anb(a.j); g.a < g.c.c.length;){
                                f = RD(ynb(g), 12);
                                for(d = new Anb(f.g); d.a < d.c.c.length;){
                                    b = RD(ynb(d), 18);
                                    Z0b(b, e);
                                    return f;
                                }
                                for(c = new Anb(f.e); c.a < c.c.c.length;){
                                    b = RD(ynb(c), 18);
                                    Y0b(b, e);
                                    return f;
                                }
                            }
                            return null;
                        }
                        function Xec(a, b, c) {
                            var d, e, f, g, h, i;
                            i = RD($5b(a.a, b), 17).a;
                            c ? c6b(a.a, sgb(i + 1), b) : c6b(a.a, sgb(i - 1), b);
                            g = new Iub;
                            for(e = new is(Mr((c ? a3b(b) : Z2b(b)).a.Kc(), new ir)); gs(e);){
                                d = RD(hs(e), 18);
                                c ? f = d.d.i : f = d.c.i;
                                dE($5b(a.a, f)) === dE($5b(a.a, b)) && (h = g.a.zc(f, g), h);
                            }
                            return g;
                        }
                        function yA(a, b, c) {
                            var d, e;
                            d = Hdb(c.q.getTime());
                            if (Ddb(d, 0) < 0) {
                                e = Awe - Ydb(Mdb(Odb(d), Awe));
                                e == Awe && (e = 0);
                            } else e = Ydb(Mdb(d, Awe));
                            if (b == 1) {
                                e = $wnd.Math.min((e + 50) / 100 | 0, 9);
                                Thb(a, 48 + e & Bwe);
                            } else if (b == 2) {
                                e = $wnd.Math.min((e + 5) / 10 | 0, 99);
                                UA(a, e, 2);
                            } else {
                                UA(a, e, 3);
                                b > 3 && UA(a, 0, b - 3);
                            }
                        }
                        function eXb(a) {
                            var b, c, d, e;
                            if (dE(mQb(a, (yCc(), IAc))) === dE((Fnd(), Cnd))) return !a.e && dE(mQb(a, gAc)) !== dE((xvc(), uvc));
                            d = RD(mQb(a, hAc), 299);
                            e = Heb(TD(mQb(a, nAc))) || dE(mQb(a, oAc)) === dE((stc(), ptc));
                            b = RD(mQb(a, fAc), 17).a;
                            c = a.a.c.length;
                            return !e && d != (xvc(), uvc) && (b == 0 || b > c);
                        }
                        function Rnc(a) {
                            var b, c;
                            c = 0;
                            for(; c < a.c.length; c++){
                                if (snc((tFb(c, a.c.length), RD(a.c[c], 113))) > 0) break;
                            }
                            if (c > 0 && c < a.c.length - 1) return c;
                            b = 0;
                            for(; b < a.c.length; b++){
                                if (snc((tFb(b, a.c.length), RD(a.c[b], 113))) > 0) break;
                            }
                            if (b > 0 && c < a.c.length - 1) return b;
                            return a.c.length / 2 | 0;
                        }
                        function Mzd(a, b) {
                            var c, d;
                            if (b != a.Cb || a.Db >> 16 != 6 && !!b) {
                                if (Oje(a, b)) throw Adb(new agb(UHe + Qzd(a)));
                                d = null;
                                !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? Czd(a, d) : a.Cb.Th(a, -1 - c, null, d)));
                                !!b && (d = Ivd(b, a, 6, d));
                                d = Bzd(a, b, d);
                                !!d && d.oj();
                            } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 6, b, b));
                        }
                        function pzd(a, b) {
                            var c, d;
                            if (b != a.Cb || a.Db >> 16 != 3 && !!b) {
                                if (Oje(a, b)) throw Adb(new agb(UHe + qzd(a)));
                                d = null;
                                !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? jzd(a, d) : a.Cb.Th(a, -1 - c, null, d)));
                                !!b && (d = Ivd(b, a, 12, d));
                                d = izd(a, b, d);
                                !!d && d.oj();
                            } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 3, b, b));
                        }
                        function NCd(a, b) {
                            var c, d;
                            if (b != a.Cb || a.Db >> 16 != 9 && !!b) {
                                if (Oje(a, b)) throw Adb(new agb(UHe + OCd(a)));
                                d = null;
                                !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? LCd(a, d) : a.Cb.Th(a, -1 - c, null, d)));
                                !!b && (d = Ivd(b, a, 9, d));
                                d = KCd(a, b, d);
                                !!d && d.oj();
                            } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 9, b, b));
                        }
                        function tWd(b) {
                            var c, d, e, f, g;
                            e = WVd(b);
                            g = b.j;
                            if (g == null && !!e) return b.Jk() ? null : e.ik();
                            else if (ZD(e, 156)) {
                                d = e.jk();
                                if (d) {
                                    f = d.wi();
                                    if (f != b.i) {
                                        c = RD(e, 156);
                                        if (c.nk()) try {
                                            b.g = f.ti(c, g);
                                        } catch (a) {
                                            a = zdb(a);
                                            if (ZD(a, 82)) b.g = null;
                                            else throw Adb(a);
                                        }
                                        b.i = f;
                                    }
                                }
                                return b.g;
                            }
                            return null;
                        }
                        function nRb(a) {
                            var b;
                            b = new bnb;
                            Rmb(b, new TFb(new rjd(a.c, a.d), new rjd(a.c + a.b, a.d)));
                            Rmb(b, new TFb(new rjd(a.c, a.d), new rjd(a.c, a.d + a.a)));
                            Rmb(b, new TFb(new rjd(a.c + a.b, a.d + a.a), new rjd(a.c + a.b, a.d)));
                            Rmb(b, new TFb(new rjd(a.c + a.b, a.d + a.a), new rjd(a.c, a.d + a.a)));
                            return b;
                        }
                        function ic(b) {
                            var c, d, e;
                            if (b == null) return vve;
                            try {
                                return jeb(b);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 103)) {
                                    c = a;
                                    e = nfb(rb(b)) + '@' + (d = (gib(), jFb(b)) >>> 0, d.toString(16));
                                    lBb(pBb(), (SAb(), 'Exception during lenientFormat for ' + e), c);
                                    return '<' + e + ' threw ' + nfb(c.Rm) + '>';
                                } else throw Adb(a);
                            }
                        }
                        function mTb(a, b, c) {
                            var d, e, f;
                            for(f = b.a.ec().Kc(); f.Ob();){
                                e = RD(f.Pb(), 74);
                                d = RD(Wjb(a.b, e), 272);
                                !d && (vCd(JGd(e)) == vCd(LGd(e)) ? lTb(a, e, c) : JGd(e) == vCd(LGd(e)) ? Wjb(a.c, e) == null && Wjb(a.b, LGd(e)) != null && oTb(a, e, c, false) : Wjb(a.d, e) == null && Wjb(a.b, JGd(e)) != null && oTb(a, e, c, true));
                            }
                        }
                        function Pfc(a, b) {
                            var c, d, e, f, g, h, i;
                            for(e = a.Kc(); e.Ob();){
                                d = RD(e.Pb(), 10);
                                h = new R3b;
                                P3b(h, d);
                                Q3b(h, (qpd(), Xod));
                                pQb(h, (Ywc(), Hwc), (Geb(), true));
                                for(g = b.Kc(); g.Ob();){
                                    f = RD(g.Pb(), 10);
                                    i = new R3b;
                                    P3b(i, f);
                                    Q3b(i, ppd);
                                    pQb(i, Hwc, true);
                                    c = new a1b;
                                    pQb(c, Hwc, true);
                                    Y0b(c, h);
                                    Z0b(c, i);
                                }
                            }
                        }
                        function Pqc(a, b, c, d) {
                            var e, f, g, h;
                            e = Nqc(a, b, c);
                            f = Nqc(a, c, b);
                            g = RD(Wjb(a.c, b), 118);
                            h = RD(Wjb(a.c, c), 118);
                            if (e < f) new bTc((fTc(), eTc), g, h, f - e);
                            else if (f < e) new bTc((fTc(), eTc), h, g, e - f);
                            else if (e != 0 || !(!b.i || !c.i) && d[b.i.c][c.i.c]) {
                                new bTc((fTc(), eTc), g, h, 0);
                                new bTc(eTc, h, g, 0);
                            }
                        }
                        function rsc(a, b) {
                            var c, d, e, f, g, h, i;
                            e = 0;
                            for(g = new Anb(b.a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 10);
                                e += f.o.b + f.d.a + f.d.d + a.e;
                                for(d = new is(Mr(Z2b(f).a.Kc(), new ir)); gs(d);){
                                    c = RD(hs(d), 18);
                                    if (c.c.i.k == (r3b(), q3b)) {
                                        i = c.c.i;
                                        h = RD(mQb(i, (Ywc(), Awc)), 10);
                                        e += h.o.b + h.d.a + h.d.d;
                                    }
                                }
                            }
                            return e;
                        }
                        function sad() {
                            sad = geb;
                            oad = new tad('CANDIDATE_POSITION_LAST_PLACED_RIGHT', 0);
                            nad = new tad('CANDIDATE_POSITION_LAST_PLACED_BELOW', 1);
                            qad = new tad('CANDIDATE_POSITION_WHOLE_DRAWING_RIGHT', 2);
                            pad = new tad('CANDIDATE_POSITION_WHOLE_DRAWING_BELOW', 3);
                            rad = new tad('WHOLE_DRAWING', 4);
                        }
                        function vEd(a, b) {
                            if (ZD(b, 207)) return IDd(a, RD(b, 27));
                            else if (ZD(b, 193)) return JDd(a, RD(b, 123));
                            else if (ZD(b, 366)) return HDd(a, RD(b, 135));
                            else if (ZD(b, 326)) return GDd(a, RD(b, 74));
                            else if (b) return null;
                            else throw Adb(new agb(wIe + Fe(new mob(cD(WC(jJ, 1), rve, 1, 5, [
                                b
                            ])))));
                        }
                        function Glc(a) {
                            var b, c, d, e, f, g, h;
                            f = new Yub;
                            for(e = new Anb(a.d.a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 125);
                                d.b.a.c.length == 0 && Pub(f, d, f.c.b, f.c);
                            }
                            if (f.b > 1) {
                                b = eJb((c = new gJb, ++a.b, c), a.d);
                                for(h = Sub(f, 0); h.b != h.d.c;){
                                    g = RD(evb(h), 125);
                                    rIb(uIb(tIb(vIb(sIb(new wIb, 1), 0), b), g));
                                }
                            }
                        }
                        function isc(a, b, c) {
                            var d, e, f, g, h;
                            c.Ug('Breaking Point Removing', 1);
                            a.a = RD(mQb(b, (yCc(), yAc)), 223);
                            for(f = new Anb(b.b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 30);
                                for(h = new Anb(bv(e.a)); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 10);
                                    if (Krc(g)) {
                                        d = RD(mQb(g, (Ywc(), Wvc)), 313);
                                        !d.d && jsc(a, d);
                                    }
                                }
                            }
                            c.Vg();
                        }
                        function yCd(a, b) {
                            var c, d;
                            if (b != a.Cb || a.Db >> 16 != 11 && !!b) {
                                if (Oje(a, b)) throw Adb(new agb(UHe + zCd(a)));
                                d = null;
                                !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? sCd(a, d) : a.Cb.Th(a, -1 - c, null, d)));
                                !!b && (d = Ivd(b, a, 10, d));
                                d = rCd(a, b, d);
                                !!d && d.oj();
                            } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 11, b, b));
                        }
                        function C0b(a) {
                            var b, c, d, e;
                            for(d = new vkb(new mkb(a.b).a); d.b;){
                                c = tkb(d);
                                e = RD(c.ld(), 12);
                                b = RD(c.md(), 10);
                                pQb(b, (Ywc(), Awc), e);
                                pQb(e, Iwc, b);
                                pQb(e, nwc, (Geb(), true));
                                Q3b(e, RD(mQb(b, hwc), 64));
                                mQb(b, hwc);
                                pQb(e.i, (yCc(), BBc), (Bod(), yod));
                                RD(mQb(Y2b(e.i), kwc), 21).Fc((ovc(), kvc));
                            }
                        }
                        function X7b(a, b, c) {
                            var d, e, f, g, h, i;
                            f = 0;
                            g = 0;
                            if (a.c) for(i = new Anb(a.d.i.j); i.a < i.c.c.length;){
                                h = RD(ynb(i), 12);
                                f += h.e.c.length;
                            }
                            else f = 1;
                            if (a.d) for(i = new Anb(a.c.i.j); i.a < i.c.c.length;){
                                h = RD(ynb(i), 12);
                                g += h.g.c.length;
                            }
                            else g = 1;
                            e = eE(Lgb(g - f));
                            d = (c + b) / 2 + (c - b) * (0.4 * e);
                            return d;
                        }
                        function Dnc(a) {
                            Bnc();
                            var b, c;
                            if (a.Hc((qpd(), opd))) throw Adb(new agb('Port sides must not contain UNDEFINED'));
                            switch(a.gc()){
                                case 1:
                                    return xnc;
                                case 2:
                                    b = a.Hc(Xod) && a.Hc(ppd);
                                    c = a.Hc(Yod) && a.Hc(npd);
                                    return b || c ? Anc : znc;
                                case 3:
                                    return ync;
                                case 4:
                                    return wnc;
                                default:
                                    return null;
                            }
                        }
                        function Did(a, b, c) {
                            tid();
                            if (xid(a, b) && xid(a, c)) return false;
                            return Fid(new rjd(a.c, a.d), new rjd(a.c + a.b, a.d), b, c) || Fid(new rjd(a.c + a.b, a.d), new rjd(a.c + a.b, a.d + a.a), b, c) || Fid(new rjd(a.c + a.b, a.d + a.a), new rjd(a.c, a.d + a.a), b, c) || Fid(new rjd(a.c, a.d + a.a), new rjd(a.c, a.d), b, c);
                        }
                        function Xee(a, b) {
                            var c, d, e, f;
                            if (!a.dc()) for(c = 0, d = a.gc(); c < d; ++c){
                                f = WD(a.Xb(c));
                                if (f == null ? b == null : lhb(f.substr(0, 3), '!##') ? b != null && (e = b.length, !lhb(f.substr(f.length - e, e), b) || f.length != b.length + 3) && !lhb(dLe, b) : lhb(f, eLe) && !lhb(dLe, b) || lhb(f, b)) return true;
                            }
                            return false;
                        }
                        function $6b(a, b, c, d) {
                            var e, f, g, h, i, j;
                            g = a.j.c.length;
                            i = $C(NN, Mye, 314, g, 0, 1);
                            for(h = 0; h < g; h++){
                                f = RD(Vmb(a.j, h), 12);
                                f.p = h;
                                i[h] = U6b(c7b(f), c, d);
                            }
                            W6b(a, i, c, b, d);
                            j = new Tsb;
                            for(e = 0; e < i.length; e++)!!i[e] && Zjb(j, RD(Vmb(a.j, e), 12), i[e]);
                            if (j.f.c + j.i.c != 0) {
                                pQb(a, (Ywc(), cwc), j);
                                a7b(a, i);
                            }
                        }
                        function Yfc(a, b) {
                            var c, d, e, f, g, h;
                            b.Ug('Partition postprocessing', 1);
                            for(d = new Anb(a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 30);
                                for(f = new Anb(c.a); f.a < f.c.c.length;){
                                    e = RD(ynb(f), 10);
                                    h = new Anb(e.j);
                                    while(h.a < h.c.c.length){
                                        g = RD(ynb(h), 12);
                                        Heb(TD(mQb(g, (Ywc(), Hwc)))) && znb(h);
                                    }
                                }
                            }
                            b.Vg();
                        }
                        function pkc(a, b, c) {
                            var d, e, f;
                            for(e = new Anb(a.a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 60);
                                f = Zjc(d);
                                if (f) {
                                    if (f.k == (r3b(), m3b)) switch(RD(mQb(f, (Ywc(), hwc)), 64).g){
                                        case 4:
                                            f.n.a = b.a;
                                            break;
                                        case 2:
                                            f.n.a = c.a - (f.o.a + f.d.c);
                                            break;
                                        case 1:
                                            f.n.b = b.b;
                                            break;
                                        case 3:
                                            f.n.b = c.b - (f.o.b + f.d.a);
                                    }
                                }
                            }
                        }
                        function eZc(a, b, c) {
                            var d, e, f;
                            c.Ug('Processor determine the height for each level', 1);
                            a.a = b.b.b == 0 ? 1 : b.b.b;
                            e = null;
                            d = Sub(b.b, 0);
                            while(!e && d.b != d.d.c){
                                f = RD(evb(d), 40);
                                Heb(TD(mQb(f, (q$c(), n$c)))) && (e = f);
                            }
                            !!e && fZc(a, dv(cD(WC(Z$, 1), NEe, 40, 0, [
                                e
                            ])), c, RD(mQb(b, (h_c(), H$c)), 88));
                            c.Vg();
                        }
                        function N8c(a) {
                            var b, c, d, e, f, g;
                            d = (bvd(), f = new ACd, f);
                            zxd(d, a);
                            for(c = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); c.e != c.i.gc();){
                                b = RD(bMd(c), 27);
                                g = (e = new ACd, e);
                                yCd(g, d);
                                zyd(g, b.g, b.f);
                                jyd(g, b.k);
                                Byd(g, b.i, b.j);
                                WGd((!d.a && (d.a = new C5d(J4, d, 10, 11)), d.a), g);
                                zxd(g, b);
                            }
                            return d;
                        }
                        function ord(a, b, c) {
                            var d, e, f, g, h;
                            e = RD(Gxd(b, (hkd(), fkd)), 17);
                            !e && (e = sgb(0));
                            f = RD(Gxd(c, fkd), 17);
                            !f && (f = sgb(0));
                            if (e.a > f.a) return -1;
                            else if (e.a < f.a) return 1;
                            else {
                                if (a.a) {
                                    d = Qfb(b.j, c.j);
                                    if (d != 0) return d;
                                    d = Qfb(b.i, c.i);
                                    if (d != 0) return d;
                                }
                                g = b.g * b.f;
                                h = c.g * c.f;
                                return Qfb(g, h);
                            }
                        }
                        function _Nd(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            ++a.e;
                            i = a.d == null ? 0 : a.d.length;
                            if (b > i) {
                                k = a.d;
                                a.d = $C(D6, KJe, 66, 2 * i + 4, 0, 1);
                                for(f = 0; f < i; ++f){
                                    j = k[f];
                                    if (j) {
                                        d = j.g;
                                        l = j.i;
                                        for(h = 0; h < l; ++h){
                                            e = RD(d[h], 136);
                                            g = bOd(a, e.Bi());
                                            c = a.d[g];
                                            !c && (c = a.d[g] = a.dk());
                                            c.Fc(e);
                                        }
                                    }
                                }
                                return true;
                            } else return false;
                        }
                        function Ofe(a, b, c) {
                            var d, e, f, g, h, i;
                            e = c;
                            f = e.Lk();
                            if (qke(a.e, f)) {
                                if (f.Si()) {
                                    d = RD(a.g, 124);
                                    for(g = 0; g < a.i; ++g){
                                        h = d[g];
                                        if (pb(h, e) && g != b) throw Adb(new agb(LIe));
                                    }
                                }
                            } else {
                                i = pke(a.e.Dh(), f);
                                d = RD(a.g, 124);
                                for(g = 0; g < a.i; ++g){
                                    h = d[g];
                                    if (i.am(h.Lk())) throw Adb(new agb(gLe));
                                }
                            }
                            VGd(a, b, c);
                        }
                        function R_b(a, b) {
                            var c, d, e, f, g, h;
                            c = RD(mQb(b, (Ywc(), ewc)), 21);
                            g = RD(Qc((z$b(), y$b), c), 21);
                            h = RD(Qc(O_b, c), 21);
                            for(f = g.Kc(); f.Ob();){
                                d = RD(f.Pb(), 21);
                                if (!RD(Qc(a.b, d), 15).dc()) return false;
                            }
                            for(e = h.Kc(); e.Ob();){
                                d = RD(e.Pb(), 21);
                                if (!RD(Qc(a.b, d), 15).dc()) return false;
                            }
                            return true;
                        }
                        function dad(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            if (a.a.c.length == 1) return P9c(RD(Vmb(a.a, 0), 172), b);
                            g = cad(a);
                            i = 0;
                            j = a.d;
                            f = g;
                            k = a.d;
                            h = (j - f) / 2 + f;
                            while(f + 1 < j){
                                i = 0;
                                for(d = new Anb(a.a); d.a < d.c.c.length;){
                                    c = RD(ynb(d), 172);
                                    i += (e = S9c(c, h, false), e.a);
                                }
                                if (i < b) {
                                    k = h;
                                    j = h;
                                } else f = h;
                                h = (j - f) / 2 + f;
                            }
                            return k;
                        }
                        function zxd(a, b) {
                            var c, d, e, f, g;
                            if (!b) return a;
                            if (ZD(b, 342)) {
                                e = RD(b, 342);
                                f = (!a.o && (a.o = new DVd((pvd(), mvd), X4, a, 0)), a.o);
                                for(d = e.gh().c.Kc(); d.e != d.i.gc();){
                                    c = RD(d.Yj(), 44);
                                    g = c.md();
                                    fOd(f, RD(c.ld(), 149), g);
                                }
                            } else {
                                !a.o && (a.o = new DVd((pvd(), mvd), X4, a, 0));
                                gOd(a.o, b.nf());
                            }
                            return a;
                        }
                        function vD(a) {
                            var b, c, d, e, f;
                            if (isNaN(a)) return MD(), LD;
                            if (a < -9223372036854776000) return MD(), JD;
                            if (a >= 9223372036854775807) return MD(), ID;
                            e = false;
                            if (a < 0) {
                                e = true;
                                a = -a;
                            }
                            d = 0;
                            if (a >= hxe) {
                                d = eE(a / hxe);
                                a -= d * hxe;
                            }
                            c = 0;
                            if (a >= gxe) {
                                c = eE(a / gxe);
                                a -= c * gxe;
                            }
                            b = eE(a);
                            f = hD(b, c, d);
                            e && nD(f);
                            return f;
                        }
                        function KCb(a) {
                            var b, c, d, e, f;
                            f = new bnb;
                            Umb(a.b, new SEb(f));
                            a.b.c.length = 0;
                            if (f.c.length != 0) {
                                b = (tFb(0, f.c.length), RD(f.c[0], 82));
                                for(c = 1, d = f.c.length; c < d; ++c){
                                    e = (tFb(c, f.c.length), RD(f.c[c], 82));
                                    e != b && fz(b, e);
                                }
                                if (ZD(b, 63)) throw Adb(RD(b, 63));
                                if (ZD(b, 296)) throw Adb(RD(b, 296));
                            }
                        }
                        function iNb(a, b) {
                            var c, d, e, f;
                            c = !b || !a.u.Hc((Pod(), Lod));
                            f = 0;
                            for(e = new Anb(a.e.Xf()); e.a < e.c.c.length;){
                                d = RD(ynb(e), 852);
                                if (d.ag() == (qpd(), opd)) throw Adb(new agb('Label and node size calculator can only be used with ports that have port sides assigned.'));
                                d.Qf(f++);
                                hNb(a, d, c);
                            }
                        }
                        function IGb(a) {
                            var b, c, d, e, f;
                            for(c = new Anb(a.a.a); c.a < c.c.c.length;){
                                b = RD(ynb(c), 316);
                                b.j = null;
                                for(f = b.a.a.ec().Kc(); f.Ob();){
                                    d = RD(f.Pb(), 60);
                                    hjd(d.b);
                                    (!b.j || d.d.c < b.j.d.c) && (b.j = d);
                                }
                                for(e = b.a.a.ec().Kc(); e.Ob();){
                                    d = RD(e.Pb(), 60);
                                    d.b.a = d.d.c - b.j.d.c;
                                    d.b.b = d.d.d - b.j.d.d;
                                }
                            }
                            return a;
                        }
                        function uYb(a) {
                            var b, c, d, e, f;
                            for(c = new Anb(a.a.a); c.a < c.c.c.length;){
                                b = RD(ynb(c), 194);
                                b.f = null;
                                for(f = b.a.a.ec().Kc(); f.Ob();){
                                    d = RD(f.Pb(), 86);
                                    hjd(d.e);
                                    (!b.f || d.g.c < b.f.g.c) && (b.f = d);
                                }
                                for(e = b.a.a.ec().Kc(); e.Ob();){
                                    d = RD(e.Pb(), 86);
                                    d.e.a = d.g.c - b.f.g.c;
                                    d.e.b = d.g.d - b.f.g.d;
                                }
                            }
                            return a;
                        }
                        function vPb(a) {
                            var b, c, d;
                            c = RD(a.a, 17).a;
                            d = RD(a.b, 17).a;
                            b = $wnd.Math.max($wnd.Math.abs(c), $wnd.Math.abs(d));
                            if (c < b && d == -b) return new Ptd(sgb(c + 1), sgb(d));
                            if (c == b && d < b) return new Ptd(sgb(c), sgb(d + 1));
                            if (c >= -b && d == b) return new Ptd(sgb(c - 1), sgb(d));
                            return new Ptd(sgb(c), sgb(d - 1));
                        }
                        function lcc() {
                            hcc();
                            return cD(WC(YS, 1), jwe, 81, 0, [
                                nbc,
                                kbc,
                                obc,
                                Ebc,
                                Xbc,
                                Ibc,
                                bcc,
                                Nbc,
                                Vbc,
                                zbc,
                                Rbc,
                                Mbc,
                                Wbc,
                                vbc,
                                dcc,
                                ebc,
                                Qbc,
                                Zbc,
                                Fbc,
                                Ybc,
                                fcc,
                                Tbc,
                                fbc,
                                Ubc,
                                gcc,
                                _bc,
                                ecc,
                                Gbc,
                                sbc,
                                Hbc,
                                Dbc,
                                ccc,
                                ibc,
                                qbc,
                                Kbc,
                                hbc,
                                Lbc,
                                Bbc,
                                wbc,
                                Obc,
                                ybc,
                                lbc,
                                jbc,
                                Cbc,
                                xbc,
                                Pbc,
                                acc,
                                gbc,
                                Sbc,
                                Abc,
                                Jbc,
                                tbc,
                                rbc,
                                $bc,
                                pbc,
                                ubc,
                                mbc
                            ]);
                        }
                        function Cmc(a, b, c) {
                            a.d = 0;
                            a.b = 0;
                            b.k == (r3b(), q3b) && c.k == q3b && RD(mQb(b, (Ywc(), Awc)), 10) == RD(mQb(c, Awc), 10) && (Gmc(b).j == (qpd(), Yod) ? Dmc(a, b, c) : Dmc(a, c, b));
                            b.k == q3b && c.k == o3b ? Gmc(b).j == (qpd(), Yod) ? a.d = 1 : a.b = 1 : c.k == q3b && b.k == o3b && (Gmc(c).j == (qpd(), Yod) ? a.b = 1 : a.d = 1);
                            Imc(a, b, c);
                        }
                        function EFd(a) {
                            var b, c, d, e, f, g, h, i, j, k, l;
                            l = HFd(a);
                            b = a.a;
                            i = b != null;
                            i && sDd(l, 'category', a.a);
                            e = cve(new Xkb(a.d));
                            g = !e;
                            if (g) {
                                j = new MB;
                                sC(l, 'knownOptions', j);
                                c = new MFd(j);
                                xgb(new Xkb(a.d), c);
                            }
                            f = cve(a.g);
                            h = !f;
                            if (h) {
                                k = new MB;
                                sC(l, 'supportedFeatures', k);
                                d = new OFd(k);
                                xgb(a.g, d);
                            }
                            return l;
                        }
                        function Ly(a) {
                            var b, c, d, e, f, g, h, i, j;
                            d = false;
                            b = 336;
                            c = 0;
                            f = new hq(a.length);
                            for(h = a, i = 0, j = h.length; i < j; ++i){
                                g = h[i];
                                d = d | (MCb(g), false);
                                e = (LCb(g), g.a);
                                Rmb(f.a, Qb(e));
                                b &= e.yd();
                                c = az(c, e.zd());
                            }
                            return RD(RD(JCb(new SDb(null, ek(new Swb((tm(), zm(f.a)), 16), new My, b, c)), new Oy(a)), 687), 848);
                        }
                        function WZb(a, b) {
                            var c;
                            if (!!a.d && (b.c != a.e.c || sZb(a.e.b, b.b))) {
                                Rmb(a.f, a.d);
                                a.a = a.d.c + a.d.b;
                                a.d = null;
                                a.e = null;
                            }
                            pZb(b.b) ? a.c = b : a.b = b;
                            if (b.b == (nZb(), jZb) && !b.a || b.b == kZb && b.a || b.b == lZb && b.a || b.b == mZb && !b.a) {
                                if (!!a.c && !!a.b) {
                                    c = new Uid(a.a, a.c.d, b.c - a.a, a.b.d - a.c.d);
                                    a.d = c;
                                    a.e = b;
                                }
                            }
                        }
                        function Wed(a) {
                            var b;
                            Oed.call(this);
                            this.i = new ifd;
                            this.g = a;
                            this.f = RD(a.e && a.e(), 9).length;
                            if (this.f == 0) throw Adb(new agb('There must be at least one phase in the phase enumeration.'));
                            this.c = (b = RD(mfb(this.g), 9), new Fsb(b, RD(WEb(b, b.length), 9), 0));
                            this.a = new ufd;
                            this.b = new Tsb;
                        }
                        function eCd(a, b) {
                            var c, d;
                            if (b != a.Cb || a.Db >> 16 != 7 && !!b) {
                                if (Oje(a, b)) throw Adb(new agb(UHe + gCd(a)));
                                d = null;
                                !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? cCd(a, d) : a.Cb.Th(a, -1 - c, null, d)));
                                !!b && (d = RD(b, 54).Rh(a, 1, H4, d));
                                d = bCd(a, b, d);
                                !!d && d.oj();
                            } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 7, b, b));
                        }
                        function lVd(a, b) {
                            var c, d;
                            if (b != a.Cb || a.Db >> 16 != 3 && !!b) {
                                if (Oje(a, b)) throw Adb(new agb(UHe + oVd(a)));
                                d = null;
                                !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? iVd(a, d) : a.Cb.Th(a, -1 - c, null, d)));
                                !!b && (d = RD(b, 54).Rh(a, 0, p7, d));
                                d = hVd(a, b, d);
                                !!d && d.oj();
                            } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 3, b, b));
                        }
                        function Mjb(a, b) {
                            Ljb();
                            var c, d, e, f, g, h, i, j, k;
                            if (b.d > a.d) {
                                h = a;
                                a = b;
                                b = h;
                            }
                            if (b.d < 63) return Qjb(a, b);
                            g = (a.d & -2) << 4;
                            j = $ib(a, g);
                            k = $ib(b, g);
                            d = Gjb(a, Zib(j, g));
                            e = Gjb(b, Zib(k, g));
                            i = Mjb(j, k);
                            c = Mjb(d, e);
                            f = Mjb(Gjb(j, d), Gjb(e, k));
                            f = Bjb(Bjb(f, i), c);
                            f = Zib(f, g);
                            i = Zib(i, g << 1);
                            return Bjb(Bjb(i, f), c);
                        }
                        function _Cc() {
                            _Cc = geb;
                            ZCc = new bDc(lEe, 0);
                            WCc = new bDc('LONGEST_PATH', 1);
                            XCc = new bDc('LONGEST_PATH_SOURCE', 2);
                            TCc = new bDc('COFFMAN_GRAHAM', 3);
                            VCc = new bDc(BBe, 4);
                            $Cc = new bDc('STRETCH_WIDTH', 5);
                            YCc = new bDc('MIN_WIDTH', 6);
                            SCc = new bDc('BF_MODEL_ORDER', 7);
                            UCc = new bDc('DF_MODEL_ORDER', 8);
                        }
                        function AKc(a, b, c) {
                            var d, e, f, g, h;
                            g = aMc(a, c);
                            h = $C(jR, WAe, 10, b.length, 0, 1);
                            d = 0;
                            for(f = g.Kc(); f.Ob();){
                                e = RD(f.Pb(), 12);
                                Heb(TD(mQb(e, (Ywc(), nwc)))) && (h[d++] = RD(mQb(e, Iwc), 10));
                            }
                            if (d < b.length) throw Adb(new dgb('Expected ' + b.length + ' hierarchical ports, but found only ' + d + '.'));
                            return h;
                        }
                        function sBd(a, b) {
                            var c, d, e, f, g, h;
                            if (!a.tb) {
                                f = (!a.rb && (a.rb = new J5d(a, i7, a)), a.rb);
                                h = new Usb(f.i);
                                for(e = new dMd(f); e.e != e.i.gc();){
                                    d = RD(bMd(e), 142);
                                    g = d.xe();
                                    c = RD(g == null ? rtb(h.f, null, d) : Ltb(h.i, g, d), 142);
                                    !!c && (g == null ? rtb(h.f, null, c) : Ltb(h.i, g, c));
                                }
                                a.tb = h;
                            }
                            return RD(Xjb(a.tb, b), 142);
                        }
                        function wYd(a, b) {
                            var c, d, e, f, g;
                            (a.i == null && rYd(a), a.i).length;
                            if (!a.p) {
                                g = new Usb((3 * a.g.i / 2 | 0) + 1);
                                for(e = new yMd(a.g); e.e != e.i.gc();){
                                    d = RD(xMd(e), 179);
                                    f = d.xe();
                                    c = RD(f == null ? rtb(g.f, null, d) : Ltb(g.i, f, d), 179);
                                    !!c && (f == null ? rtb(g.f, null, c) : Ltb(g.i, f, c));
                                }
                                a.p = g;
                            }
                            return RD(Xjb(a.p, b), 179);
                        }
                        function fFb(a, b, c, d, e) {
                            var f, g, h, i, j;
                            dFb(d + lz(c, c.ie()), e);
                            eFb(b, hFb(c));
                            f = c.f;
                            !!f && fFb(a, b, f, 'Caused by: ', false);
                            for(h = (c.k == null && (c.k = $C(rJ, Nve, 82, 0, 0, 1)), c.k), i = 0, j = h.length; i < j; ++i){
                                g = h[i];
                                fFb(a, b, g, 'Suppressed: ', false);
                            }
                            console.groupEnd != null && console.groupEnd.call(console);
                        }
                        function DKc(a, b, c, d) {
                            var e, f, g, h, i;
                            i = b.e;
                            h = i.length;
                            g = b.q.ug(i, c ? 0 : h - 1, c);
                            e = i[c ? 0 : h - 1];
                            g = g | CKc(a, e, c, d);
                            for(f = c ? 1 : h - 2; c ? f < h : f >= 0; f += c ? 1 : -1){
                                g = g | b.c.lg(i, f, c, d && !Heb(TD(mQb(b.j, (Ywc(), jwc)))) && !Heb(TD(mQb(b.j, (Ywc(), Owc)))));
                                g = g | b.q.ug(i, f, c);
                                g = g | CKc(a, i[f], c, d);
                            }
                            Ysb(a.c, b);
                            return g;
                        }
                        function F6b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            for(k = u2b(a.j), l = 0, m = k.length; l < m; ++l){
                                j = k[l];
                                if (c == (BEc(), yEc) || c == AEc) {
                                    i = s2b(j.g);
                                    for(e = i, f = 0, g = e.length; f < g; ++f){
                                        d = e[f];
                                        B6b(b, d) && X0b(d, true);
                                    }
                                }
                                if (c == zEc || c == AEc) {
                                    h = s2b(j.e);
                                    for(e = h, f = 0, g = e.length; f < g; ++f){
                                        d = e[f];
                                        A6b(b, d) && X0b(d, true);
                                    }
                                }
                            }
                        }
                        function uqc(a) {
                            var b, c;
                            b = null;
                            c = null;
                            switch(pqc(a).g){
                                case 1:
                                    b = (qpd(), Xod);
                                    c = ppd;
                                    break;
                                case 2:
                                    b = (qpd(), npd);
                                    c = Yod;
                                    break;
                                case 3:
                                    b = (qpd(), ppd);
                                    c = Xod;
                                    break;
                                case 4:
                                    b = (qpd(), Yod);
                                    c = npd;
                            }
                            Smc(a, RD(Lvb(KDb(RD(Qc(a.k, b), 15).Oc(), lqc)), 113));
                            Tmc(a, RD(Lvb(JDb(RD(Qc(a.k, c), 15).Oc(), lqc)), 113));
                        }
                        function r9b(a) {
                            var b, c, d, e, f, g;
                            e = RD(Vmb(a.j, 0), 12);
                            if (e.e.c.length + e.g.c.length == 0) a.n.a = 0;
                            else {
                                g = 0;
                                for(d = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                    new T3b(e),
                                    new _3b(e)
                                ]))); gs(d);){
                                    c = RD(hs(d), 12);
                                    g += c.i.n.a + c.n.a + c.a.a;
                                }
                                b = RD(mQb(a, (yCc(), zBc)), 8);
                                f = !b ? 0 : b.a;
                                a.n.a = g / (e.e.c.length + e.g.c.length) - f;
                            }
                        }
                        function Qdd(a, b) {
                            var c, d, e;
                            for(d = new Anb(b.a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 225);
                                RQb(RD(c.b, 68), ojd(ajd(RD(b.b, 68).c), RD(b.b, 68).a));
                                e = oRb(RD(b.b, 68).b, RD(c.b, 68).b);
                                e > 1 && (a.a = true);
                                QQb(RD(c.b, 68), $id(ajd(RD(b.b, 68).c), ijd(ojd(ajd(RD(c.b, 68).a), RD(b.b, 68).a), e)));
                                Odd(a, b);
                                Qdd(a, c);
                            }
                        }
                        function tYb(a) {
                            var b, c, d, e, f, g, h;
                            for(f = new Anb(a.a.a); f.a < f.c.c.length;){
                                d = RD(ynb(f), 194);
                                d.e = 0;
                                d.d.a.$b();
                            }
                            for(e = new Anb(a.a.a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 194);
                                for(c = d.a.a.ec().Kc(); c.Ob();){
                                    b = RD(c.Pb(), 86);
                                    for(h = b.f.Kc(); h.Ob();){
                                        g = RD(h.Pb(), 86);
                                        if (g.d != d) {
                                            Ysb(d.d, g);
                                            ++g.d.e;
                                        }
                                    }
                                }
                            }
                        }
                        function Hfc(a) {
                            var b, c, d, e, f, g, h, i;
                            i = a.j.c.length;
                            c = 0;
                            b = i;
                            e = 2 * i;
                            for(h = new Anb(a.j); h.a < h.c.c.length;){
                                g = RD(ynb(h), 12);
                                switch(g.j.g){
                                    case 2:
                                    case 4:
                                        g.p = -1;
                                        break;
                                    case 1:
                                    case 3:
                                        d = g.e.c.length;
                                        f = g.g.c.length;
                                        d > 0 && f > 0 ? g.p = b++ : d > 0 ? g.p = c++ : f > 0 ? g.p = e++ : g.p = c++;
                                }
                            }
                            yob();
                            _mb(a.j, new Lfc);
                        }
                        function zic(a) {
                            var b, c;
                            c = null;
                            b = RD(Vmb(a.g, 0), 18);
                            do {
                                c = b.d.i;
                                if (nQb(c, (Ywc(), wwc))) return RD(mQb(c, wwc), 12).i;
                                if (c.k != (r3b(), p3b) && gs(new is(Mr(a3b(c).a.Kc(), new ir)))) b = RD(hs(new is(Mr(a3b(c).a.Kc(), new ir))), 18);
                                else if (c.k != p3b) return null;
                            }while (!!c && c.k != (r3b(), p3b));
                            return c;
                        }
                        function sqc(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            h = b.j;
                            g = b.g;
                            i = RD(Vmb(h, h.c.length - 1), 113);
                            k = (tFb(0, h.c.length), RD(h.c[0], 113));
                            j = oqc(a, g, i, k);
                            for(f = 1; f < h.c.length; f++){
                                c = (tFb(f - 1, h.c.length), RD(h.c[f - 1], 113));
                                e = (tFb(f, h.c.length), RD(h.c[f], 113));
                                d = oqc(a, g, c, e);
                                if (d > j) {
                                    i = c;
                                    k = e;
                                    j = d;
                                }
                            }
                            b.a = k;
                            b.c = i;
                        }
                        function fMc(a, b, c) {
                            var d, e, f, g, h, i, j;
                            j = new yAb(new TMc(a));
                            for(g = cD(WC(xR, 1), XAe, 12, 0, [
                                b,
                                c
                            ]), h = 0, i = g.length; h < i; ++h){
                                f = g[h];
                                j.a.zc(f, (Geb(), Eeb));
                                for(e = new l4b(f.b); xnb(e.a) || xnb(e.b);){
                                    d = RD(xnb(e.a) ? ynb(e.a) : ynb(e.b), 18);
                                    d.c == d.d || rAb(j, f == d.c ? d.d : d.c);
                                }
                            }
                            return Qb(j), new dnb(j);
                        }
                        function rIb(a) {
                            if (!a.a.d || !a.a.e) throw Adb(new dgb((lfb(zN), zN.k + ' must have a source and target ' + (lfb(DN), DN.k) + ' specified.')));
                            if (a.a.d == a.a.e) throw Adb(new dgb('Network simplex does not support self-loops: ' + a.a + ' ' + a.a.d + ' ' + a.a.e));
                            EIb(a.a.d.g, a.a);
                            EIb(a.a.e.b, a.a);
                            return a.a;
                        }
                        function x6b(a, b) {
                            var c, d, e, f, g, h, i;
                            b.Ug('Constraints Postprocessor', 1);
                            g = 0;
                            for(f = new Anb(a.b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 30);
                                i = 0;
                                h = false;
                                for(d = new Anb(e.a); d.a < d.c.c.length;){
                                    c = RD(ynb(d), 10);
                                    if (c.k == (r3b(), p3b)) {
                                        h = true;
                                        pQb(c, (yCc(), VAc), sgb(g));
                                        pQb(c, mAc, sgb(i));
                                        ++i;
                                    }
                                }
                                h && ++g;
                            }
                            b.Vg();
                        }
                        function OTc(a, b, c) {
                            var d, e, f, g, h, i;
                            d = 0;
                            if (b.b != 0 && c.b != 0) {
                                f = Sub(b, 0);
                                g = Sub(c, 0);
                                h = Kfb(UD(evb(f)));
                                i = Kfb(UD(evb(g)));
                                e = true;
                                do {
                                    if (h > i - a.b && h < i + a.b) return -1;
                                    else h > i - a.a && h < i + a.a && ++d;
                                    h <= i && f.b != f.d.c ? h = Kfb(UD(evb(f))) : i <= h && g.b != g.d.c ? i = Kfb(UD(evb(g))) : e = false;
                                }while (e);
                            }
                            return d;
                        }
                        function G2c(a, b) {
                            var c, d;
                            Sed(a.a);
                            Ved(a.a, (x2c(), v2c), v2c);
                            Ved(a.a, w2c, w2c);
                            d = new ufd;
                            pfd(d, w2c, (g3c(), e3c));
                            dE(Gxd(b, ($4c(), I4c))) !== dE((g4c(), d4c)) && pfd(d, w2c, b3c);
                            Heb(TD(Gxd(b, T4c))) && pfd(d, w2c, f3c);
                            pfd(d, w2c, c3c);
                            Heb(TD(Gxd(b, V4c))) && nfd(d, w2c, d3c);
                            Ped(a.a, d);
                            c = Qed(a.a, b);
                            return c;
                        }
                        function W6b(a, b, c, d, e) {
                            var f, g, h, i;
                            i = (f = RD(mfb(E3), 9), new Fsb(f, RD(WEb(f, f.length), 9), 0));
                            for(h = new Anb(a.j); h.a < h.c.c.length;){
                                g = RD(ynb(h), 12);
                                if (b[g.p]) {
                                    X6b(g, b[g.p], d);
                                    zsb(i, g.j);
                                }
                            }
                            if (e) {
                                _6b(a, b, (qpd(), Xod), 2 * c, d);
                                _6b(a, b, ppd, 2 * c, d);
                            } else {
                                _6b(a, b, (qpd(), Yod), 2 * c, d);
                                _6b(a, b, npd, 2 * c, d);
                            }
                        }
                        function eec(a) {
                            var b, c;
                            for(c = new is(Mr(a3b(a).a.Kc(), new ir)); gs(c);){
                                b = RD(hs(c), 18);
                                if (b.d.i.k != (r3b(), n3b)) throw Adb(new Jed(nBe + X2b(a) + "' has its layer constraint set to LAST, but has at least one outgoing edge that " + ' does not go to a LAST_SEPARATE node. That must not happen.'));
                            }
                        }
                        function mHc(a, b, c) {
                            var d, e, f, g, h;
                            c.Ug('Longest path layering', 1);
                            a.a = b;
                            h = a.a.a;
                            a.b = $C(kE, Pwe, 28, h.c.length, 15, 1);
                            d = 0;
                            for(g = new Anb(h); g.a < g.c.c.length;){
                                e = RD(ynb(g), 10);
                                e.p = d;
                                a.b[d] = -1;
                                ++d;
                            }
                            for(f = new Anb(h); f.a < f.c.c.length;){
                                e = RD(ynb(f), 10);
                                oHc(a, e);
                            }
                            h.c.length = 0;
                            a.a = null;
                            a.b = null;
                            c.Vg();
                        }
                        function JUc(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m;
                            i = 0;
                            for(k = new Anb(a.a); k.a < k.c.c.length;){
                                j = RD(ynb(k), 10);
                                h = 0;
                                for(f = new is(Mr(Z2b(j).a.Kc(), new ir)); gs(f);){
                                    e = RD(hs(f), 18);
                                    l = K3b(e.c).b;
                                    m = K3b(e.d).b;
                                    h = $wnd.Math.max(h, $wnd.Math.abs(m - l));
                                }
                                i = $wnd.Math.max(i, h);
                            }
                            g = d * $wnd.Math.min(1, b / c) * i;
                            return g;
                        }
                        function J_c(a, b) {
                            var c, d, e, f, g;
                            g = RD(mQb(b, (h_c(), Y$c)), 433);
                            for(f = Sub(b.b, 0); f.b != f.d.c;){
                                e = RD(evb(f), 40);
                                if (a.b[e.g] == 0) {
                                    switch(g.g){
                                        case 0:
                                            K_c(a, e);
                                            break;
                                        case 1:
                                            I_c(a, e);
                                    }
                                    a.b[e.g] = 2;
                                }
                            }
                            for(d = Sub(a.a, 0); d.b != d.d.c;){
                                c = RD(evb(d), 65);
                                ze(c.b.d, c, true);
                                ze(c.c.b, c, true);
                            }
                            pQb(b, (q$c(), k$c), a.a);
                        }
                        function pse(a) {
                            var b;
                            b = new Rhb;
                            (a & 256) != 0 && (b.a += 'F', b);
                            (a & 128) != 0 && (b.a += 'H', b);
                            (a & 512) != 0 && (b.a += 'X', b);
                            (a & 2) != 0 && (b.a += 'i', b);
                            (a & 8) != 0 && (b.a += 'm', b);
                            (a & 4) != 0 && (b.a += 's', b);
                            (a & 32) != 0 && (b.a += 'u', b);
                            (a & 64) != 0 && (b.a += 'w', b);
                            (a & 16) != 0 && (b.a += 'x', b);
                            (a & gwe) != 0 && (b.a += ',', b);
                            return shb(b.a);
                        }
                        function W8c(a, b) {
                            var c, d, e, f, g, h;
                            b.Ug(bGe, 1);
                            e = RD(Gxd(a, (X7c(), N7c)), 107);
                            f = (!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a);
                            g = yad(f);
                            h = $wnd.Math.max(g.a, Kfb(UD(Gxd(a, (X6c(), U6c)))) - (e.b + e.c));
                            d = $wnd.Math.max(g.b, Kfb(UD(Gxd(a, R6c))) - (e.d + e.a));
                            c = d - g.b;
                            Ixd(a, M6c, c);
                            Ixd(a, O6c, h);
                            Ixd(a, N6c, d + c);
                            b.Vg();
                        }
                        function pke(a, b) {
                            nke();
                            var c, d, e, f;
                            if (!b) return mke;
                            else if (b == (nme(), kme) || (b == Ule || b == Sle || b == Tle) && a != Rle) return new wke(a, b);
                            else {
                                d = RD(b, 692);
                                c = d.$k();
                                if (!c) {
                                    Afe(Qee((lke(), jke), b));
                                    c = d.$k();
                                }
                                f = (!c.i && (c.i = new Tsb), c.i);
                                e = RD(Wd(qtb(f.f, a)), 2041);
                                !e && Zjb(f, a, e = new wke(a, b));
                                return e;
                            }
                        }
                        function jHb(a, b) {
                            var c, d;
                            d = rAb(a.b, b.b);
                            if (!d) throw Adb(new dgb('Invalid hitboxes for scanline constraint calculation.'));
                            (dHb(b.b, RD(tAb(a.b, b.b), 60)) || dHb(b.b, RD(sAb(a.b, b.b), 60))) && (gib(), String.fromCharCode(10));
                            a.a[b.b.f] = RD(vAb(a.b, b.b), 60);
                            c = RD(uAb(a.b, b.b), 60);
                            !!c && (a.a[c.f] = b.b);
                        }
                        function lTb(a, b, c) {
                            var d, e, f, g, h, i, j, k, l;
                            f = IGd(b, false, false);
                            j = ssd(f);
                            l = Kfb(UD(Gxd(b, (tSb(), mSb))));
                            e = jTb(j, l + a.a);
                            k = new ORb(e);
                            kQb(k, b);
                            Zjb(a.b, b, k);
                            ZEb(c.c, k);
                            i = (!b.n && (b.n = new C5d(I4, b, 1, 7)), b.n);
                            for(h = new dMd(i); h.e != h.i.gc();){
                                g = RD(bMd(h), 135);
                                d = nTb(a, g, true, 0, 0);
                                ZEb(c.c, d);
                            }
                            return k;
                        }
                        function Zec(a, b) {
                            var c, d, e, f, g, h, i;
                            e = new bnb;
                            for(c = 0; c <= a.j; c++){
                                d = new R4b(b);
                                d.p = a.j - c;
                                ZEb(e.c, d);
                            }
                            for(h = new Anb(a.p); h.a < h.c.c.length;){
                                g = RD(ynb(h), 10);
                                g3b(g, RD(Vmb(e, a.j - a.g[g.p]), 30));
                            }
                            f = new Anb(e);
                            while(f.a < f.c.c.length){
                                i = RD(ynb(f), 30);
                                i.a.c.length == 0 && znb(f);
                            }
                            b.b.c.length = 0;
                            Tmb(b.b, e);
                        }
                        function xfc(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            i = RD(mQb(a, (Ywc(), Awc)), 12);
                            j = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                i.i.n,
                                i.n,
                                i.a
                            ])).a;
                            k = a.i.n.b;
                            c = s2b(a.e);
                            for(e = c, f = 0, g = e.length; f < g; ++f){
                                d = e[f];
                                Z0b(d, i);
                                Oub(d.a, new rjd(j, k));
                                if (b) {
                                    h = RD(mQb(d, (yCc(), RAc)), 75);
                                    if (!h) {
                                        h = new Ejd;
                                        pQb(d, RAc, h);
                                    }
                                    Mub(h, new rjd(j, k));
                                }
                            }
                        }
                        function yfc(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            e = RD(mQb(a, (Ywc(), Awc)), 12);
                            j = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                e.i.n,
                                e.n,
                                e.a
                            ])).a;
                            k = a.i.n.b;
                            c = s2b(a.g);
                            for(g = c, h = 0, i = g.length; h < i; ++h){
                                f = g[h];
                                Y0b(f, e);
                                Nub(f.a, new rjd(j, k));
                                if (b) {
                                    d = RD(mQb(f, (yCc(), RAc)), 75);
                                    if (!d) {
                                        d = new Ejd;
                                        pQb(f, RAc, d);
                                    }
                                    Mub(d, new rjd(j, k));
                                }
                            }
                        }
                        function Khc(a) {
                            var b, c, d, e, f, g, h, i, j;
                            d = a.b;
                            f = d.e;
                            g = Cod(RD(mQb(d, (yCc(), BBc)), 101));
                            c = !!f && RD(mQb(f, (Ywc(), kwc)), 21).Hc((ovc(), hvc));
                            if (g || c) return;
                            for(j = (h = new glb(a.e).a.vc().Kc(), new llb(h)); j.a.Ob();){
                                i = (b = RD(j.a.Pb(), 44), RD(b.md(), 113));
                                if (i.a) {
                                    e = i.d;
                                    P3b(e, null);
                                    i.c = true;
                                    a.a = true;
                                }
                            }
                        }
                        function iic(a, b) {
                            var c, d, e, f;
                            b.Ug('Semi-Interactive Crossing Minimization Processor', 1);
                            c = false;
                            for(e = new Anb(a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 30);
                                f = MDb(PDb(CDb(CDb(new SDb(null, new Swb(d.a, 16)), new nic), new pic), new ric), new vic);
                                c = c | f.a != null;
                            }
                            c && pQb(a, (Ywc(), rwc), (Geb(), true));
                            b.Vg();
                        }
                        function rKc(a, b) {
                            var c, d, e, f, g, h;
                            a.b = new bnb;
                            a.d = RD(mQb(b, (Ywc(), Lwc)), 234);
                            a.e = Lwb(a.d);
                            f = new Yub;
                            e = dv(cD(WC(eR, 1), OAe, 36, 0, [
                                b
                            ]));
                            g = 0;
                            while(g < e.c.length){
                                d = (tFb(g, e.c.length), RD(e.c[g], 36));
                                d.p = g++;
                                c = new FJc(d, a.a, a.b);
                                Tmb(e, c.b);
                                Rmb(a.b, c);
                                c.s && (h = Sub(f, 0), cvb(h, c));
                            }
                            a.c = new _sb;
                            return f;
                        }
                        function yMb(a, b) {
                            var c, d, e, f, g, h;
                            for(g = RD(RD(Qc(a.r, b), 21), 87).Kc(); g.Ob();){
                                f = RD(g.Pb(), 117);
                                c = f.c ? QKb(f.c) : 0;
                                if (c > 0) {
                                    if (f.a) {
                                        h = f.b.Mf().a;
                                        if (c > h) {
                                            e = (c - h) / 2;
                                            f.d.b = e;
                                            f.d.c = e;
                                        }
                                    } else f.d.c = a.s + c;
                                } else if (Rod(a.u)) {
                                    d = wsd(f.b);
                                    d.c < 0 && (f.d.b = -d.c);
                                    d.c + d.b > f.b.Mf().a && (f.d.c = d.c + d.b - f.b.Mf().a);
                                }
                            }
                        }
                        function RUc(a, b) {
                            var c, d, e, f, g;
                            g = new bnb;
                            c = b;
                            do {
                                f = RD(Wjb(a.b, c), 131);
                                f.B = c.c;
                                f.D = c.d;
                                ZEb(g.c, f);
                                c = RD(Wjb(a.k, c), 18);
                            }while (c);
                            d = (tFb(0, g.c.length), RD(g.c[0], 131));
                            d.j = true;
                            d.A = RD(d.d.a.ec().Kc().Pb(), 18).c.i;
                            e = RD(Vmb(g, g.c.length - 1), 131);
                            e.q = true;
                            e.C = RD(e.d.a.ec().Kc().Pb(), 18).d.i;
                            return g;
                        }
                        function pPb(a) {
                            var b, c;
                            b = RD(a.a, 17).a;
                            c = RD(a.b, 17).a;
                            if (b >= 0) {
                                if (b == c) return new Ptd(sgb(-b - 1), sgb(-b - 1));
                                if (b == -c) return new Ptd(sgb(-b), sgb(c + 1));
                            }
                            if ($wnd.Math.abs(b) > $wnd.Math.abs(c)) {
                                if (b < 0) return new Ptd(sgb(-b), sgb(c));
                                return new Ptd(sgb(-b), sgb(c + 1));
                            }
                            return new Ptd(sgb(b + 1), sgb(c));
                        }
                        function H8b(a) {
                            var b, c;
                            c = RD(mQb(a, (yCc(), UAc)), 171);
                            b = RD(mQb(a, (Ywc(), owc)), 311);
                            if (c == (cxc(), $wc)) {
                                pQb(a, UAc, bxc);
                                pQb(a, owc, (Gvc(), Fvc));
                            } else if (c == axc) {
                                pQb(a, UAc, bxc);
                                pQb(a, owc, (Gvc(), Dvc));
                            } else if (b == (Gvc(), Fvc)) {
                                pQb(a, UAc, $wc);
                                pQb(a, owc, Evc);
                            } else if (b == Dvc) {
                                pQb(a, UAc, axc);
                                pQb(a, owc, Evc);
                            }
                        }
                        function dSc() {
                            dSc = geb;
                            bSc = new pSc;
                            ZRc = pfd(new ufd, (sXb(), pXb), (hcc(), Fbc));
                            aSc = nfd(pfd(new ufd, pXb, Tbc), rXb, Sbc);
                            cSc = mfd(mfd(rfd(nfd(pfd(new ufd, nXb, bcc), rXb, acc), qXb), _bc), ccc);
                            $Rc = nfd(pfd(pfd(pfd(new ufd, oXb, Ibc), qXb, Kbc), qXb, Lbc), rXb, Jbc);
                            _Rc = nfd(pfd(pfd(new ufd, qXb, Lbc), qXb, qbc), rXb, pbc);
                        }
                        function HUc() {
                            HUc = geb;
                            CUc = pfd(nfd(new ufd, (sXb(), rXb), (hcc(), tbc)), pXb, Fbc);
                            GUc = mfd(mfd(rfd(nfd(pfd(new ufd, nXb, bcc), rXb, acc), qXb), _bc), ccc);
                            DUc = nfd(pfd(pfd(pfd(new ufd, oXb, Ibc), qXb, Kbc), qXb, Lbc), rXb, Jbc);
                            FUc = pfd(pfd(new ufd, pXb, Tbc), rXb, Sbc);
                            EUc = nfd(pfd(pfd(new ufd, qXb, Lbc), qXb, qbc), rXb, pbc);
                        }
                        function eSc(a, b, c, d, e) {
                            var f, g;
                            if ((!W0b(b) && b.c.i.c == b.d.i.c || !djd(xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                e.i.n,
                                e.n,
                                e.a
                            ])), c)) && !W0b(b)) {
                                b.c == e ? hu(b.a, 0, new sjd(c)) : Mub(b.a, new sjd(c));
                                if (d && !Zsb(a.a, c)) {
                                    g = RD(mQb(b, (yCc(), RAc)), 75);
                                    if (!g) {
                                        g = new Ejd;
                                        pQb(b, RAc, g);
                                    }
                                    f = new sjd(c);
                                    Pub(g, f, g.c.b, g.c);
                                    Ysb(a.a, f);
                                }
                            }
                        }
                        function ht(a, b) {
                            var c, d, e, f;
                            f = Ydb(Ndb(cwe, qgb(Ydb(Ndb(b == null ? 0 : tb(b), dwe)), 15)));
                            c = f & a.b.length - 1;
                            e = null;
                            for(d = a.b[c]; d; e = d, d = d.a)if (d.d == f && Hb(d.i, b)) {
                                !e ? a.b[c] = d.a : e.a = d.a;
                                Ts(RD(Hvb(d.c), 604), RD(Hvb(d.f), 604));
                                Ss(RD(Hvb(d.b), 227), RD(Hvb(d.e), 227));
                                --a.f;
                                ++a.e;
                                return true;
                            }
                            return false;
                        }
                        function dec(a) {
                            var b, c;
                            for(c = new is(Mr(Z2b(a).a.Kc(), new ir)); gs(c);){
                                b = RD(hs(c), 18);
                                if (b.c.i.k != (r3b(), n3b)) throw Adb(new Jed(nBe + X2b(a) + "' has its layer constraint set to FIRST, but has at least one incoming edge that " + ' does not come from a FIRST_SEPARATE node. That must not happen.'));
                            }
                        }
                        function Twd(a, b, c) {
                            var d, e, f, g, h, i, j;
                            e = ggb(a.Db & 254);
                            if (e == 0) a.Eb = c;
                            else {
                                if (e == 1) {
                                    h = $C(jJ, rve, 1, 2, 5, 1);
                                    f = Xwd(a, b);
                                    if (f == 0) {
                                        h[0] = c;
                                        h[1] = a.Eb;
                                    } else {
                                        h[0] = a.Eb;
                                        h[1] = c;
                                    }
                                } else {
                                    h = $C(jJ, rve, 1, e + 1, 5, 1);
                                    g = SD(a.Eb);
                                    for(d = 2, i = 0, j = 0; d <= 128; d <<= 1)d == b ? h[j++] = c : (a.Db & d) != 0 && (h[j++] = g[i++]);
                                }
                                a.Eb = h;
                            }
                            a.Db |= b;
                        }
                        function vQb(a, b, c) {
                            var d, e, f, g;
                            this.b = new bnb;
                            e = 0;
                            d = 0;
                            for(g = new Anb(a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 176);
                                c && iPb(f);
                                Rmb(this.b, f);
                                e += f.o;
                                d += f.p;
                            }
                            if (this.b.c.length > 0) {
                                f = RD(Vmb(this.b, 0), 176);
                                e += f.o;
                                d += f.p;
                            }
                            e *= 2;
                            d *= 2;
                            b > 1 ? e = eE($wnd.Math.ceil(e * b)) : d = eE($wnd.Math.ceil(d / b));
                            this.a = new gQb(e, d);
                        }
                        function mkc(a, b, c, d, e, f) {
                            var g, h, i, j, k, l, m, n, o, p, q, r;
                            k = d;
                            if (b.j && b.o) {
                                n = RD(Wjb(a.f, b.A), 60);
                                p = n.d.c + n.d.b;
                                --k;
                            } else p = b.a.c + b.a.b;
                            l = e;
                            if (c.q && c.o) {
                                n = RD(Wjb(a.f, c.C), 60);
                                j = n.d.c;
                                ++l;
                            } else j = c.a.c;
                            q = j - p;
                            i = $wnd.Math.max(2, l - k);
                            h = q / i;
                            o = p + h;
                            for(m = k; m < l; ++m){
                                g = RD(f.Xb(m), 131);
                                r = g.a.b;
                                g.a.c = o - r / 2;
                                o += h;
                            }
                        }
                        function Wrc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m;
                            e = b ? new dsc : new fsc;
                            f = false;
                            do {
                                f = false;
                                j = b ? hv(a.b) : a.b;
                                for(i = j.Kc(); i.Ob();){
                                    h = RD(i.Pb(), 30);
                                    m = bv(h.a);
                                    b || hv(m);
                                    for(l = new Anb(m); l.a < l.c.c.length;){
                                        k = RD(ynb(l), 10);
                                        if (e.Mb(k)) {
                                            d = k;
                                            c = RD(mQb(k, (Ywc(), Wvc)), 313);
                                            g = b ? c.b : c.k;
                                            f = Urc(d, g, b, false);
                                        }
                                    }
                                }
                            }while (f);
                        }
                        function sMc(a, b, c, d, e, f) {
                            var g, h, i, j, k, l;
                            j = c.c.length;
                            f && (a.c = $C(kE, Pwe, 28, b.length, 15, 1));
                            for(g = e ? 0 : b.length - 1; e ? g < b.length : g >= 0; g += e ? 1 : -1){
                                h = b[g];
                                i = d == (qpd(), Xod) ? e ? b3b(h, d) : hv(b3b(h, d)) : e ? hv(b3b(h, d)) : b3b(h, d);
                                f && (a.c[h.p] = i.gc());
                                for(l = i.Kc(); l.Ob();){
                                    k = RD(l.Pb(), 12);
                                    a.d[k.p] = j++;
                                }
                                Tmb(c, i);
                            }
                        }
                        function AUc(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            f = Kfb(UD(a.b.Kc().Pb()));
                            j = Kfb(UD(fr(b.b)));
                            d = ijd(ajd(a.a), j - c);
                            e = ijd(ajd(b.a), c - f);
                            k = $id(d, e);
                            ijd(k, 1 / (j - f));
                            this.a = k;
                            this.b = new bnb;
                            h = true;
                            g = a.b.Kc();
                            g.Pb();
                            while(g.Ob()){
                                i = Kfb(UD(g.Pb()));
                                if (h && i - c > AEe) {
                                    this.b.Fc(c);
                                    h = false;
                                }
                                this.b.Fc(i);
                            }
                            h && this.b.Fc(c);
                        }
                        function mJb(a) {
                            var b, c, d, e;
                            pJb(a, a.n);
                            if (a.d.c.length > 0) {
                                Nnb(a.c);
                                while(xJb(a, RD(ynb(new Anb(a.e.a)), 125)) < a.e.a.c.length){
                                    b = rJb(a);
                                    e = b.e.e - b.d.e - b.a;
                                    b.e.j && (e = -e);
                                    for(d = new Anb(a.e.a); d.a < d.c.c.length;){
                                        c = RD(ynb(d), 125);
                                        c.j && (c.e += e);
                                    }
                                    Nnb(a.c);
                                }
                                Nnb(a.c);
                                uJb(a, RD(ynb(new Anb(a.e.a)), 125));
                                iJb(a);
                            }
                        }
                        function ned(a, b) {
                            hed();
                            var c, d;
                            c = ugd(ygd(), b.Pg());
                            if (c) {
                                d = c.j;
                                if (ZD(a, 207)) return xCd(RD(a, 27)) ? Csb(d, (Yhd(), Vhd)) || Csb(d, Whd) : Csb(d, (Yhd(), Vhd));
                                else if (ZD(a, 326)) return Csb(d, (Yhd(), Thd));
                                else if (ZD(a, 193)) return Csb(d, (Yhd(), Xhd));
                                else if (ZD(a, 366)) return Csb(d, (Yhd(), Uhd));
                            }
                            return true;
                        }
                        function Cge(a, b, c) {
                            var d, e, f, g, h, i;
                            e = c;
                            f = e.Lk();
                            if (qke(a.e, f)) {
                                if (f.Si()) {
                                    d = RD(a.g, 124);
                                    for(g = 0; g < a.i; ++g){
                                        h = d[g];
                                        if (pb(h, e) && g != b) throw Adb(new agb(LIe));
                                    }
                                }
                            } else {
                                i = pke(a.e.Dh(), f);
                                d = RD(a.g, 124);
                                for(g = 0; g < a.i; ++g){
                                    h = d[g];
                                    if (i.am(h.Lk()) && g != b) throw Adb(new agb(gLe));
                                }
                            }
                            return RD(eHd(a, b, c), 76);
                        }
                        function hz(d, b) {
                            if (b instanceof Object) try {
                                b.__java$exception = d;
                                if (navigator.userAgent.toLowerCase().indexOf('msie') != -1 && $doc.documentMode < 9) return;
                                var c = d;
                                Object.defineProperties(b, {
                                    cause: {
                                        get: function() {
                                            var a = c.he();
                                            return a && a.fe();
                                        }
                                    },
                                    suppressed: {
                                        get: function() {
                                            return c.ge();
                                        }
                                    }
                                });
                            } catch (a) {}
                        }
                        function tjb(a, b) {
                            var c, d, e, f, g;
                            d = b >> 5;
                            b &= 31;
                            if (d >= a.d) return a.e < 0 ? (Pib(), Jib) : (Pib(), Oib);
                            f = a.d - d;
                            e = $C(kE, Pwe, 28, f + 1, 15, 1);
                            ujb(e, f, a.a, d, b);
                            if (a.e < 0) {
                                for(c = 0; c < d && a.a[c] == 0; c++);
                                if (c < d || b > 0 && a.a[c] << 32 - b != 0) {
                                    for(c = 0; c < f && e[c] == -1; c++)e[c] = 0;
                                    c == f && ++f;
                                    ++e[c];
                                }
                            }
                            g = new cjb(a.e, f, e);
                            Rib(g);
                            return g;
                        }
                        function LSb(a) {
                            var b, c, d, e;
                            e = MCd(a);
                            c = new bTb(e);
                            d = new dTb(e);
                            b = new bnb;
                            Tmb(b, (!a.d && (a.d = new Yie(G4, a, 8, 5)), a.d));
                            Tmb(b, (!a.e && (a.e = new Yie(G4, a, 7, 4)), a.e));
                            return RD(zDb(GDb(CDb(new SDb(null, new Swb(b, 16)), c), d), sBb(new _Bb, new bCb, new yCb, new ACb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), wBb),
                                vBb
                            ]))), 21);
                        }
                        function Tdc(a, b) {
                            var c;
                            c = RD(mQb(a, (yCc(), xAc)), 283);
                            b.Ug('Label side selection (' + c + ')', 1);
                            switch(c.g){
                                case 0:
                                    Udc(a, (Pnd(), Lnd));
                                    break;
                                case 1:
                                    Udc(a, (Pnd(), Mnd));
                                    break;
                                case 2:
                                    Sdc(a, (Pnd(), Lnd));
                                    break;
                                case 3:
                                    Sdc(a, (Pnd(), Mnd));
                                    break;
                                case 4:
                                    Vdc(a, (Pnd(), Lnd));
                                    break;
                                case 5:
                                    Vdc(a, (Pnd(), Mnd));
                            }
                            b.Vg();
                        }
                        function qke(a, b) {
                            nke();
                            var c, d, e;
                            if (b.Jk()) return true;
                            else if (b.Ik() == -2) {
                                if (b == (Lle(), Jle) || b == Gle || b == Hle || b == Ile) return true;
                                else {
                                    e = a.Dh();
                                    if (BYd(e, b) >= 0) return false;
                                    else {
                                        c = Eee((lke(), jke), e, b);
                                        if (!c) return true;
                                        else {
                                            d = c.Ik();
                                            return (d > 1 || d == -1) && yfe(Qee(jke, c)) != 3;
                                        }
                                    }
                                }
                            } else return false;
                        }
                        function _4b(a, b, c, d) {
                            var e, f, g, h, i;
                            h = AGd(RD(QHd((!b.b && (b.b = new Yie(E4, b, 4, 7)), b.b), 0), 84));
                            i = AGd(RD(QHd((!b.c && (b.c = new Yie(E4, b, 5, 8)), b.c), 0), 84));
                            if (vCd(h) == vCd(i)) return null;
                            if (NGd(i, h)) return null;
                            g = kzd(b);
                            if (g == c) return d;
                            else {
                                f = RD(Wjb(a.a, g), 10);
                                if (f) {
                                    e = f.e;
                                    if (e) return e;
                                }
                            }
                            return null;
                        }
                        function uHc(a, b, c) {
                            var d, e, f, g, h;
                            c.Ug('Longest path to source layering', 1);
                            a.a = b;
                            h = a.a.a;
                            a.b = $C(kE, Pwe, 28, h.c.length, 15, 1);
                            d = 0;
                            for(g = new Anb(h); g.a < g.c.c.length;){
                                e = RD(ynb(g), 10);
                                e.p = d;
                                a.b[d] = -1;
                                ++d;
                            }
                            for(f = new Anb(h); f.a < f.c.c.length;){
                                e = RD(ynb(f), 10);
                                wHc(a, e);
                            }
                            h.c.length = 0;
                            a.a = null;
                            a.b = null;
                            c.Vg();
                        }
                        function BKc(a, b, c) {
                            var d, e, f, g, h, i;
                            d = pKc(c, a.length);
                            g = a[d];
                            f = qKc(c, g.length);
                            if (g[f].k != (r3b(), m3b)) return;
                            i = b.j;
                            for(e = 0; e < i.c.length; e++){
                                h = (tFb(e, i.c.length), RD(i.c[e], 12));
                                if ((c ? h.j == (qpd(), Xod) : h.j == (qpd(), ppd)) && Heb(TD(mQb(h, (Ywc(), nwc))))) {
                                    $mb(i, e, RD(mQb(g[f], (Ywc(), Awc)), 12));
                                    f += c ? 1 : -1;
                                }
                            }
                        }
                        function n8c(a, b) {
                            var c, d, e, f, g, h, i, j;
                            b.Ug('Greedy Width Approximator', 1);
                            c = Kfb(UD(Gxd(a, (X7c(), x7c))));
                            i = RD(Gxd(a, N7c), 107);
                            f = RD(Gxd(a, U7c), 394);
                            g = Heb(TD(Gxd(a, T7c)));
                            h = Kfb(UD(Gxd(a, Q7c)));
                            j = (!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a);
                            Bad(j);
                            e = new g8c(c, f, g);
                            d = c8c(e, j, h, i);
                            Ixd(a, (X6c(), W6c), d.c);
                            b.Vg();
                        }
                        function yKd(a) {
                            if (a.g == null) switch(a.p){
                                case 0:
                                    a.g = qKd(a) ? (Geb(), Feb) : (Geb(), Eeb);
                                    break;
                                case 1:
                                    a.g = $eb(rKd(a));
                                    break;
                                case 2:
                                    a.g = hfb(sKd(a));
                                    break;
                                case 3:
                                    a.g = tKd(a);
                                    break;
                                case 4:
                                    a.g = new Tfb(uKd(a));
                                    break;
                                case 6:
                                    a.g = Hgb(wKd(a));
                                    break;
                                case 5:
                                    a.g = sgb(vKd(a));
                                    break;
                                case 7:
                                    a.g = bhb(xKd(a));
                            }
                            return a.g;
                        }
                        function HKd(a) {
                            if (a.n == null) switch(a.p){
                                case 0:
                                    a.n = zKd(a) ? (Geb(), Feb) : (Geb(), Eeb);
                                    break;
                                case 1:
                                    a.n = $eb(AKd(a));
                                    break;
                                case 2:
                                    a.n = hfb(BKd(a));
                                    break;
                                case 3:
                                    a.n = CKd(a);
                                    break;
                                case 4:
                                    a.n = new Tfb(DKd(a));
                                    break;
                                case 6:
                                    a.n = Hgb(FKd(a));
                                    break;
                                case 5:
                                    a.n = sgb(EKd(a));
                                    break;
                                case 7:
                                    a.n = bhb(GKd(a));
                            }
                            return a.n;
                        }
                        function Pfe(a, b, c, d) {
                            var e, f, g, h, i;
                            h = (nke(), RD(b, 69).xk());
                            if (qke(a.e, b)) {
                                if (b.Si() && dge(a, b, d, ZD(b, 102) && (RD(b, 19).Bb & txe) != 0)) throw Adb(new agb(LIe));
                            } else {
                                i = pke(a.e.Dh(), b);
                                e = RD(a.g, 124);
                                for(g = 0; g < a.i; ++g){
                                    f = e[g];
                                    if (i.am(f.Lk())) throw Adb(new agb(gLe));
                                }
                            }
                            VGd(a, gge(a, b, c), h ? RD(d, 76) : oke(b, d));
                        }
                        function HGb(a) {
                            var b, c, d, e, f, g, h;
                            for(f = new Anb(a.a.a); f.a < f.c.c.length;){
                                d = RD(ynb(f), 316);
                                d.g = 0;
                                d.i = 0;
                                d.e.a.$b();
                            }
                            for(e = new Anb(a.a.a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 316);
                                for(c = d.a.a.ec().Kc(); c.Ob();){
                                    b = RD(c.Pb(), 60);
                                    for(h = b.c.Kc(); h.Ob();){
                                        g = RD(h.Pb(), 60);
                                        if (g.a != d) {
                                            Ysb(d.e, g);
                                            ++g.a.g;
                                            ++g.a.i;
                                        }
                                    }
                                }
                            }
                        }
                        function X8b(a) {
                            var b, c, d, e, f;
                            e = RD(mQb(a, (yCc(), lBc)), 21);
                            f = RD(mQb(a, oBc), 21);
                            c = new rjd(a.f.a + a.d.b + a.d.c, a.f.b + a.d.d + a.d.a);
                            b = new sjd(c);
                            if (e.Hc((Qpd(), Mpd))) {
                                d = RD(mQb(a, nBc), 8);
                                if (f.Hc((dqd(), Ypd))) {
                                    d.a <= 0 && (d.a = 20);
                                    d.b <= 0 && (d.b = 20);
                                }
                                b.a = $wnd.Math.max(c.a, d.a);
                                b.b = $wnd.Math.max(c.b, d.b);
                            }
                            Y8b(a, c, b);
                        }
                        function SYb(a, b) {
                            var c, d, e;
                            b.a ? (rAb(a.b, b.b), a.a[b.b.i] = RD(vAb(a.b, b.b), 86), c = RD(uAb(a.b, b.b), 86), !!c && (a.a[c.i] = b.b), undefined) : (d = RD(vAb(a.b, b.b), 86), !!d && d == a.a[b.b.i] && !!d.d && d.d != b.b.d && d.f.Fc(b.b), e = RD(uAb(a.b, b.b), 86), !!e && a.a[e.i] == b.b && !!e.d && e.d != b.b.d && b.b.f.Fc(e), wAb(a.b, b.b), undefined);
                        }
                        function Oec(a, b) {
                            var c, d, e, f, g, h;
                            f = a.d;
                            h = Kfb(UD(mQb(a, (yCc(), FAc))));
                            if (h < 0) {
                                h = 0;
                                pQb(a, FAc, h);
                            }
                            b.o.b = h;
                            g = $wnd.Math.floor(h / 2);
                            d = new R3b;
                            Q3b(d, (qpd(), ppd));
                            P3b(d, b);
                            d.n.b = g;
                            e = new R3b;
                            Q3b(e, Xod);
                            P3b(e, b);
                            e.n.b = g;
                            Z0b(a, d);
                            c = new a1b;
                            kQb(c, a);
                            pQb(c, RAc, null);
                            Y0b(c, e);
                            Z0b(c, f);
                            Nec(b, a, c);
                            Lec(a, c);
                            return c;
                        }
                        function URc(a) {
                            var b, c;
                            c = RD(mQb(a, (Ywc(), kwc)), 21);
                            b = new ufd;
                            if (c.Hc((ovc(), ivc))) {
                                ofd(b, ORc);
                                ofd(b, QRc);
                            }
                            if (c.Hc(kvc) || Heb(TD(mQb(a, (yCc(), GAc))))) {
                                ofd(b, QRc);
                                c.Hc(lvc) && ofd(b, RRc);
                            }
                            c.Hc(hvc) && ofd(b, NRc);
                            c.Hc(nvc) && ofd(b, SRc);
                            c.Hc(jvc) && ofd(b, PRc);
                            c.Hc(evc) && ofd(b, LRc);
                            c.Hc(gvc) && ofd(b, MRc);
                            return b;
                        }
                        function Qjb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m;
                            d = a.d;
                            f = b.d;
                            h = d + f;
                            i = a.e != b.e ? -1 : 1;
                            if (h == 2) {
                                k = Ndb(Cdb(a.a[0], yxe), Cdb(b.a[0], yxe));
                                m = Ydb(k);
                                l = Ydb(Udb(k, 32));
                                return l == 0 ? new ajb(i, m) : new cjb(i, 2, cD(WC(kE, 1), Pwe, 28, 15, [
                                    m,
                                    l
                                ]));
                            }
                            c = a.a;
                            e = b.a;
                            g = $C(kE, Pwe, 28, h, 15, 1);
                            Njb(c, d, e, f, g);
                            j = new cjb(i, h, g);
                            Rib(j);
                            return j;
                        }
                        function Uyb(a, b, c, d) {
                            var e, f;
                            if (!b) return c;
                            else {
                                e = a.a.Ne(c.d, b.d);
                                if (e == 0) {
                                    d.d = qlb(b, c.e);
                                    d.b = true;
                                    return b;
                                }
                                f = e < 0 ? 0 : 1;
                                b.a[f] = Uyb(a, b.a[f], c, d);
                                if (Vyb(b.a[f])) {
                                    if (Vyb(b.a[1 - f])) {
                                        b.b = true;
                                        b.a[0].b = false;
                                        b.a[1].b = false;
                                    } else Vyb(b.a[f].a[f]) ? b = azb(b, 1 - f) : Vyb(b.a[f].a[1 - f]) && (b = _yb(b, 1 - f));
                                }
                            }
                            return b;
                        }
                        function nKb(a, b, c) {
                            var d, e, f, g;
                            e = a.i;
                            d = a.n;
                            mKb(a, (ZJb(), WJb), e.c + d.b, c);
                            mKb(a, YJb, e.c + e.b - d.c - c[2], c);
                            g = e.b - d.b - d.c;
                            if (c[0] > 0) {
                                c[0] += a.d;
                                g -= c[0];
                            }
                            if (c[2] > 0) {
                                c[2] += a.d;
                                g -= c[2];
                            }
                            f = $wnd.Math.max(0, g);
                            c[1] = $wnd.Math.max(c[1], g);
                            mKb(a, XJb, e.c + d.b + c[0] - (c[1] - g) / 2, c);
                            if (b == XJb) {
                                a.c.b = f;
                                a.c.c = e.c + d.b + (f - g) / 2;
                            }
                        }
                        function D_b() {
                            this.c = $C(iE, vxe, 28, (qpd(), cD(WC(E3, 1), NAe, 64, 0, [
                                opd,
                                Yod,
                                Xod,
                                npd,
                                ppd
                            ])).length, 15, 1);
                            this.b = $C(iE, vxe, 28, cD(WC(E3, 1), NAe, 64, 0, [
                                opd,
                                Yod,
                                Xod,
                                npd,
                                ppd
                            ]).length, 15, 1);
                            this.a = $C(iE, vxe, 28, cD(WC(E3, 1), NAe, 64, 0, [
                                opd,
                                Yod,
                                Xod,
                                npd,
                                ppd
                            ]).length, 15, 1);
                            Lnb(this.c, oxe);
                            Lnb(this.b, pxe);
                            Lnb(this.a, pxe);
                        }
                        function rte(a, b, c) {
                            var d, e, f, g;
                            if (b <= c) {
                                e = b;
                                f = c;
                            } else {
                                e = c;
                                f = b;
                            }
                            d = 0;
                            if (a.b == null) {
                                a.b = $C(kE, Pwe, 28, 2, 15, 1);
                                a.b[0] = e;
                                a.b[1] = f;
                                a.c = true;
                            } else {
                                d = a.b.length;
                                if (a.b[d - 1] + 1 == e) {
                                    a.b[d - 1] = f;
                                    return;
                                }
                                g = $C(kE, Pwe, 28, d + 2, 15, 1);
                                hib(a.b, 0, g, 0, d);
                                a.b = g;
                                a.b[d - 1] >= e && (a.c = false, a.a = false);
                                a.b[d++] = e;
                                a.b[d] = f;
                                a.c || vte(a);
                            }
                        }
                        function Oqc(a, b, c) {
                            var d, e, f, g, h, i, j;
                            j = b.d;
                            a.a = new cnb(j.c.length);
                            a.c = new Tsb;
                            for(h = new Anb(j); h.a < h.c.c.length;){
                                g = RD(ynb(h), 105);
                                f = new USc(null);
                                Rmb(a.a, f);
                                Zjb(a.c, g, f);
                            }
                            a.b = new Tsb;
                            Mqc(a, b);
                            for(d = 0; d < j.c.length - 1; d++){
                                i = RD(Vmb(b.d, d), 105);
                                for(e = d + 1; e < j.c.length; e++)Pqc(a, i, RD(Vmb(b.d, e), 105), c);
                            }
                        }
                        function Q2c(a) {
                            var b, c, d, e, f;
                            e = new bnb;
                            b = new btb((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a));
                            for(d = new is(Mr(zGd(a).a.Kc(), new ir)); gs(d);){
                                c = RD(hs(d), 74);
                                if (!ZD(QHd((!c.b && (c.b = new Yie(E4, c, 4, 7)), c.b), 0), 193)) {
                                    f = AGd(RD(QHd((!c.c && (c.c = new Yie(E4, c, 5, 8)), c.c), 0), 84));
                                    b.a._b(f) || ZEb(e.c, f);
                                }
                            }
                            return e;
                        }
                        function Nqe(a, b, c) {
                            var d, e, f;
                            a.e = c;
                            a.d = 0;
                            a.b = 0;
                            a.f = 1;
                            a.i = b;
                            (a.e & 16) == 16 && (a.i = use(a.i));
                            a.j = a.i.length;
                            Mqe(a);
                            f = Qqe(a);
                            if (a.d != a.j) throw Adb(new Lqe(TId((Hde(), TIe))));
                            if (a.g) {
                                for(d = 0; d < a.g.a.c.length; d++){
                                    e = RD(eyb(a.g, d), 592);
                                    if (a.f <= e.a) throw Adb(new Lqe(TId((Hde(), UIe))));
                                }
                                a.g.a.c.length = 0;
                            }
                            return f;
                        }
                        function BNc(a, b) {
                            var c, d, e, f, g, h, i;
                            c = pxe;
                            h = (r3b(), p3b);
                            for(e = new Anb(b.a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 10);
                                f = d.k;
                                if (f != p3b) {
                                    g = UD(mQb(d, (Ywc(), Cwc)));
                                    if (g == null) {
                                        c = $wnd.Math.max(c, 0);
                                        d.n.b = c + aFc(a.a, f, h);
                                    } else d.n.b = (uFb(g), g);
                                }
                                i = aFc(a.a, f, h);
                                d.n.b < c + i + d.d.d && (d.n.b = c + i + d.d.d);
                                c = d.n.b + d.o.b + d.d.a;
                                h = f;
                            }
                        }
                        function w3c(a, b, c, d, e) {
                            var f, g, h, i, j, k;
                            !!a.d && a.d.Gg(e);
                            f = RD(e.Xb(0), 27);
                            if (u3c(a, c, f, false)) return true;
                            g = RD(e.Xb(e.gc() - 1), 27);
                            if (u3c(a, d, g, true)) return true;
                            if (p3c(a, e)) return true;
                            for(k = e.Kc(); k.Ob();){
                                j = RD(k.Pb(), 27);
                                for(i = b.Kc(); i.Ob();){
                                    h = RD(i.Pb(), 27);
                                    if (o3c(a, j, h)) return true;
                                }
                            }
                            return false;
                        }
                        function Ovd(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            m = b.c.length;
                            l = (j = a.Ih(c), RD(j >= 0 ? a.Lh(j, false, true) : Qvd(a, c, false), 61));
                            n: for(f = l.Kc(); f.Ob();){
                                e = RD(f.Pb(), 58);
                                for(k = 0; k < m; ++k){
                                    g = (tFb(k, b.c.length), RD(b.c[k], 76));
                                    i = g.md();
                                    h = g.Lk();
                                    d = e.Nh(h, false);
                                    if (i == null ? d != null : !pb(i, d)) continue n;
                                }
                                return e;
                            }
                            return null;
                        }
                        function o6b(a, b) {
                            var c, d, e, f, g, h, i;
                            b.Ug('Comment post-processing', 1);
                            for(f = new Anb(a.b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 30);
                                d = new bnb;
                                for(h = new Anb(e.a); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 10);
                                    i = RD(mQb(g, (Ywc(), Xwc)), 15);
                                    c = RD(mQb(g, Vvc), 15);
                                    if (!!i || !!c) {
                                        p6b(g, i, c);
                                        !!i && Tmb(d, i);
                                        !!c && Tmb(d, c);
                                    }
                                }
                                Tmb(e.a, d);
                            }
                            b.Vg();
                        }
                        function kac(a, b, c, d) {
                            var e, f, g, h;
                            e = RD(e3b(b, (qpd(), ppd)).Kc().Pb(), 12);
                            f = RD(e3b(b, Xod).Kc().Pb(), 12);
                            for(h = new Anb(a.j); h.a < h.c.c.length;){
                                g = RD(ynb(h), 12);
                                while(g.e.c.length != 0)Z0b(RD(Vmb(g.e, 0), 18), e);
                                while(g.g.c.length != 0)Y0b(RD(Vmb(g.g, 0), 18), f);
                            }
                            c || pQb(b, (Ywc(), vwc), null);
                            d || pQb(b, (Ywc(), wwc), null);
                        }
                        function IGd(a, b, c) {
                            var d, e;
                            if ((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a).i == 0) return EGd(a);
                            else {
                                d = RD(QHd((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a), 0), 166);
                                if (b) {
                                    sLd((!d.a && (d.a = new XZd(D4, d, 5)), d.a));
                                    Ozd(d, 0);
                                    Pzd(d, 0);
                                    Hzd(d, 0);
                                    Izd(d, 0);
                                }
                                if (c) {
                                    e = (!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a);
                                    while(e.i > 1)vLd(e, e.i - 1);
                                }
                                return d;
                            }
                        }
                        function Vdc(a, b) {
                            var c, d, e, f, g, h, i;
                            c = new wmb;
                            for(f = new Anb(a.b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 30);
                                i = true;
                                d = 0;
                                for(h = new Anb(e.a); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 10);
                                    switch(g.k.g){
                                        case 4:
                                            ++d;
                                        case 1:
                                            imb(c, g);
                                            break;
                                        case 0:
                                            Xdc(g, b);
                                        default:
                                            c.b == c.c || Wdc(c, d, i, false, b);
                                            i = false;
                                            d = 0;
                                    }
                                }
                                c.b == c.c || Wdc(c, d, i, true, b);
                            }
                        }
                        function iMc(a, b) {
                            var c, d, e, f, g, h;
                            c = 0;
                            for(h = new Anb(b); h.a < h.c.c.length;){
                                g = RD(ynb(h), 12);
                                $Lc(a.b, a.d[g.p]);
                                for(e = new l4b(g.b); xnb(e.a) || xnb(e.b);){
                                    d = RD(xnb(e.a) ? ynb(e.a) : ynb(e.b), 18);
                                    f = AMc(a, g == d.c ? d.d : d.c);
                                    if (f > a.d[g.p]) {
                                        c += ZLc(a.b, f);
                                        hmb(a.a, sgb(f));
                                    }
                                }
                                while(!nmb(a.a))XLc(a.b, RD(smb(a.a), 17).a);
                            }
                            return c;
                        }
                        function Uec(a) {
                            var b, c, d, e, f, g, h, i, j;
                            a.a = new e6b;
                            j = 0;
                            e = 0;
                            for(d = new Anb(a.i.b); d.a < d.c.c.length;){
                                b = RD(ynb(d), 30);
                                b.p = e;
                                for(i = new Anb(b.a); i.a < i.c.c.length;){
                                    h = RD(ynb(i), 10);
                                    h.p = j;
                                    ++j;
                                }
                                ++e;
                            }
                            f = a.r == (aEc(), TDc);
                            g = f ? Qec : Pec;
                            for(c = new Anb(a.i.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 30);
                                _mb(b.a, g);
                                d6b(a.a, sgb(b.p), b.a);
                            }
                        }
                        function zed(a, b, c) {
                            var d, e, f, g;
                            f = (!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a).i;
                            for(e = new dMd((!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a)); e.e != e.i.gc();){
                                d = RD(bMd(e), 27);
                                (!d.a && (d.a = new C5d(J4, d, 10, 11)), d.a).i == 0 || (f += zed(a, d, false));
                            }
                            if (c) {
                                g = vCd(b);
                                while(g){
                                    f += (!g.a && (g.a = new C5d(J4, g, 10, 11)), g.a).i;
                                    g = vCd(g);
                                }
                            }
                            return f;
                        }
                        function vLd(a, b) {
                            var c, d, e, f;
                            if (a.Pj()) {
                                d = null;
                                e = a.Qj();
                                a.Tj() && (d = a.Vj(a.$i(b), null));
                                c = a.Ij(4, f = THd(a, b), null, b, e);
                                if (a.Mj() && f != null) {
                                    d = a.Oj(f, d);
                                    if (!d) a.Jj(c);
                                    else {
                                        d.nj(c);
                                        d.oj();
                                    }
                                } else if (!d) a.Jj(c);
                                else {
                                    d.nj(c);
                                    d.oj();
                                }
                                return f;
                            } else {
                                f = THd(a, b);
                                if (a.Mj() && f != null) {
                                    d = a.Oj(f, null);
                                    !!d && d.oj();
                                }
                                return f;
                            }
                        }
                        function LNb(a) {
                            var b, c, d, e, f, g, h, i, j, k;
                            j = a.a;
                            b = new _sb;
                            i = 0;
                            for(d = new Anb(a.d); d.a < d.c.c.length;){
                                c = RD(ynb(d), 226);
                                k = 0;
                                tvb(c.b, new ONb);
                                for(g = Sub(c.b, 0); g.b != g.d.c;){
                                    f = RD(evb(g), 226);
                                    if (b.a._b(f)) {
                                        e = c.c;
                                        h = f.c;
                                        k < h.d + h.a + j && k + e.a + j > h.d && (k = h.d + h.a + j);
                                    }
                                }
                                c.c.d = k;
                                b.a.zc(c, b);
                                i = $wnd.Math.max(i, c.c.d + c.c.a);
                            }
                            return i;
                        }
                        function ovc() {
                            ovc = geb;
                            fvc = new pvc('COMMENTS', 0);
                            hvc = new pvc('EXTERNAL_PORTS', 1);
                            ivc = new pvc('HYPEREDGES', 2);
                            jvc = new pvc('HYPERNODES', 3);
                            kvc = new pvc('NON_FREE_PORTS', 4);
                            lvc = new pvc('NORTH_SOUTH_PORTS', 5);
                            nvc = new pvc(FBe, 6);
                            evc = new pvc('CENTER_LABELS', 7);
                            gvc = new pvc('END_LABELS', 8);
                            mvc = new pvc('PARTITIONS', 9);
                        }
                        function PA(a, b, c, d, e) {
                            if (d < 0) {
                                d = EA(a, e, cD(WC(qJ, 1), Nve, 2, 6, [
                                    Cwe,
                                    Dwe,
                                    Ewe,
                                    Fwe,
                                    Gwe,
                                    Hwe,
                                    Iwe,
                                    Jwe,
                                    Kwe,
                                    Lwe,
                                    Mwe,
                                    Nwe
                                ]), b);
                                d < 0 && (d = EA(a, e, cD(WC(qJ, 1), Nve, 2, 6, [
                                    'Jan',
                                    'Feb',
                                    'Mar',
                                    'Apr',
                                    Gwe,
                                    'Jun',
                                    'Jul',
                                    'Aug',
                                    'Sep',
                                    'Oct',
                                    'Nov',
                                    'Dec'
                                ]), b));
                                if (d < 0) return false;
                                c.k = d;
                                return true;
                            } else if (d > 0) {
                                c.k = d - 1;
                                return true;
                            }
                            return false;
                        }
                        function RA(a, b, c, d, e) {
                            if (d < 0) {
                                d = EA(a, e, cD(WC(qJ, 1), Nve, 2, 6, [
                                    Cwe,
                                    Dwe,
                                    Ewe,
                                    Fwe,
                                    Gwe,
                                    Hwe,
                                    Iwe,
                                    Jwe,
                                    Kwe,
                                    Lwe,
                                    Mwe,
                                    Nwe
                                ]), b);
                                d < 0 && (d = EA(a, e, cD(WC(qJ, 1), Nve, 2, 6, [
                                    'Jan',
                                    'Feb',
                                    'Mar',
                                    'Apr',
                                    Gwe,
                                    'Jun',
                                    'Jul',
                                    'Aug',
                                    'Sep',
                                    'Oct',
                                    'Nov',
                                    'Dec'
                                ]), b));
                                if (d < 0) return false;
                                c.k = d;
                                return true;
                            } else if (d > 0) {
                                c.k = d - 1;
                                return true;
                            }
                            return false;
                        }
                        function TA(a, b, c, d, e, f) {
                            var g, h, i, j;
                            h = 32;
                            if (d < 0) {
                                if (b[0] >= a.length) return false;
                                h = ihb(a, b[0]);
                                if (h != 43 && h != 45) return false;
                                ++b[0];
                                d = HA(a, b);
                                if (d < 0) return false;
                                h == 45 && (d = -d);
                            }
                            if (h == 32 && b[0] - c == 2 && e.b == 2) {
                                i = new uB;
                                j = i.q.getFullYear() - Owe + Owe - 80;
                                g = j % 100;
                                f.a = d == g;
                                d += (j / 100 | 0) * 100 + (d < g ? 100 : 0);
                            }
                            f.p = d;
                            return true;
                        }
                        function V4b(a, b) {
                            var c, d, e, f, g;
                            if (!vCd(a)) return;
                            g = RD(mQb(b, (yCc(), lBc)), 181);
                            dE(Gxd(a, BBc)) === dE((Bod(), Aod)) && Ixd(a, BBc, zod);
                            d = (lud(), new zud(vCd(a)));
                            f = new Fud(!vCd(a) ? null : new zud(vCd(a)), a);
                            e = GJb(d, f, false, true);
                            zsb(g, (Qpd(), Mpd));
                            c = RD(mQb(b, nBc), 8);
                            c.a = $wnd.Math.max(e.a, c.a);
                            c.b = $wnd.Math.max(e.b, c.b);
                        }
                        function cec(a, b, c) {
                            var d, e, f, g, h, i;
                            for(g = RD(mQb(a, (Ywc(), lwc)), 15).Kc(); g.Ob();){
                                f = RD(g.Pb(), 10);
                                switch(RD(mQb(f, (yCc(), UAc)), 171).g){
                                    case 2:
                                        g3b(f, b);
                                        break;
                                    case 4:
                                        g3b(f, c);
                                }
                                for(e = new is(Mr(W2b(f).a.Kc(), new ir)); gs(e);){
                                    d = RD(hs(e), 18);
                                    if (!!d.c && !!d.d) continue;
                                    h = !d.d;
                                    i = RD(mQb(d, Ewc), 12);
                                    h ? Z0b(d, i) : Y0b(d, i);
                                }
                            }
                        }
                        function epc() {
                            epc = geb;
                            Zoc = new fpc(_ye, 0, (qpd(), Yod), Yod);
                            apc = new fpc(bze, 1, npd, npd);
                            Yoc = new fpc(aze, 2, Xod, Xod);
                            dpc = new fpc(cze, 3, ppd, ppd);
                            _oc = new fpc('NORTH_WEST_CORNER', 4, ppd, Yod);
                            $oc = new fpc('NORTH_EAST_CORNER', 5, Yod, Xod);
                            cpc = new fpc('SOUTH_WEST_CORNER', 6, npd, ppd);
                            bpc = new fpc('SOUTH_EAST_CORNER', 7, Xod, npd);
                        }
                        function P2c(a) {
                            var b, c, d, e, f, g;
                            f = new _sb;
                            b = new btb((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a));
                            for(e = new is(Mr(zGd(a).a.Kc(), new ir)); gs(e);){
                                d = RD(hs(e), 74);
                                if (!ZD(QHd((!d.b && (d.b = new Yie(E4, d, 4, 7)), d.b), 0), 193)) {
                                    g = AGd(RD(QHd((!d.c && (d.c = new Yie(E4, d, 5, 8)), d.c), 0), 84));
                                    b.a._b(g) || (c = f.a.zc(g, f), c);
                                }
                            }
                            return f;
                        }
                        function tid() {
                            tid = geb;
                            sid = cD(WC(lE, 1), rxe, 28, 14, [
                                1,
                                1,
                                2,
                                6,
                                24,
                                120,
                                720,
                                5040,
                                40320,
                                362880,
                                3628800,
                                39916800,
                                479001600,
                                6227020800,
                                87178291200,
                                1307674368000,
                                {
                                    l: 3506176,
                                    m: 794077,
                                    h: 1
                                },
                                {
                                    l: 884736,
                                    m: 916411,
                                    h: 20
                                },
                                {
                                    l: 3342336,
                                    m: 3912489,
                                    h: 363
                                },
                                {
                                    l: 589824,
                                    m: 3034138,
                                    h: 6914
                                },
                                {
                                    l: 3407872,
                                    m: 1962506,
                                    h: 138294
                                }
                            ]);
                            $wnd.Math.pow(2, -65);
                        }
                        function Ljb() {
                            Ljb = geb;
                            var a, b;
                            Jjb = $C(uJ, Nve, 92, 32, 0, 1);
                            Kjb = $C(uJ, Nve, 92, 32, 0, 1);
                            a = 1;
                            for(b = 0; b <= 18; b++){
                                Jjb[b] = (Pib(), Ddb(a, 0) >= 0 ? jjb(a) : Xib(jjb(Odb(a))));
                                Kjb[b] = Jdb(Sdb(a, b), 0) ? jjb(Sdb(a, b)) : Xib(jjb(Odb(Sdb(a, b))));
                                a = Ndb(a, 5);
                            }
                            for(; b < Kjb.length; b++){
                                Jjb[b] = Wib(Jjb[b - 1], Jjb[1]);
                                Kjb[b] = Wib(Kjb[b - 1], (Pib(), Mib));
                            }
                        }
                        function tgc(a, b) {
                            var c, d, e, f, g;
                            if (a.c.length == 0) return new Ptd(sgb(0), sgb(0));
                            c = (tFb(0, a.c.length), RD(a.c[0], 12)).j;
                            g = 0;
                            f = b.g;
                            d = b.g + 1;
                            while(g < a.c.length - 1 && c.g < f){
                                ++g;
                                c = (tFb(g, a.c.length), RD(a.c[g], 12)).j;
                            }
                            e = g;
                            while(e < a.c.length - 1 && c.g < d){
                                ++e;
                                c = (tFb(g, a.c.length), RD(a.c[g], 12)).j;
                            }
                            return new Ptd(sgb(g), sgb(e));
                        }
                        function NJc(a, b, c, d) {
                            var e, f, g, h, i, j, k;
                            i = b3b(b, c);
                            (c == (qpd(), npd) || c == ppd) && (i = hv(i));
                            g = false;
                            do {
                                e = false;
                                for(f = 0; f < i.gc() - 1; f++){
                                    j = RD(i.Xb(f), 12);
                                    h = RD(i.Xb(f + 1), 12);
                                    if (OJc(a, j, h, d)) {
                                        g = true;
                                        CMc(a.a, RD(i.Xb(f), 12), RD(i.Xb(f + 1), 12));
                                        k = RD(i.Xb(f + 1), 12);
                                        i.hd(f + 1, RD(i.Xb(f), 12));
                                        i.hd(f, k);
                                        e = true;
                                    }
                                }
                            }while (e);
                            return g;
                        }
                        function lZc(a, b, c) {
                            var d, e, f, g;
                            c.Ug(MEe, 1);
                            e = RD(zDb(CDb(new SDb(null, new Swb(b.b, 16)), new pZc), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), vBb)
                            ]))), 15);
                            mZc(a, e, 0);
                            for(g = Sub(b.b, 0); g.b != g.d.c;){
                                f = RD(evb(g), 40);
                                d = Wjb(a.a, sgb(f.g)) != null ? RD(Wjb(a.a, sgb(f.g)), 17).a : 0;
                                pQb(f, (h_c(), f_c), sgb(d));
                            }
                            c.Vg();
                        }
                        function o3c(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            h = b.i - a.g / 2;
                            i = c.i - a.g / 2;
                            j = b.j - a.g / 2;
                            k = c.j - a.g / 2;
                            f = b.g + a.g;
                            g = c.g + a.g;
                            d = b.f + a.g;
                            e = c.f + a.g;
                            if (h < i + g && i < h && j < k + e && k < j) return true;
                            else if (i < h + f && h < i && k < j + d && j < k) return true;
                            else if (h < i + g && i < h && j < k && k < j + d) return true;
                            else if (i < h + f && h < i && j < k + e && k < j) return true;
                            return false;
                        }
                        function gdc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            f = b.c.length;
                            g = (tFb(c, b.c.length), RD(b.c[c], 293));
                            h = g.a.o.a;
                            l = g.c;
                            m = 0;
                            for(j = g.c; j <= g.f; j++){
                                if (h <= a.a[j]) return j;
                                k = a.a[j];
                                i = null;
                                for(e = c + 1; e < f; e++){
                                    d = (tFb(e, b.c.length), RD(b.c[e], 293));
                                    d.c <= j && d.f >= j && (i = d);
                                }
                                !!i && (k = $wnd.Math.max(k, i.a.o.a));
                                if (k > m) {
                                    l = j;
                                    m = k;
                                }
                            }
                            return l;
                        }
                        function SNb(a) {
                            var b, c, d, e, f, g, h;
                            f = new yAb(RD(Qb(new eOb), 50));
                            h = pxe;
                            for(c = new Anb(a.d); c.a < c.c.c.length;){
                                b = RD(ynb(c), 226);
                                h = b.c.c;
                                while(f.a.gc() != 0){
                                    g = RD(f.a.Tc(), 226);
                                    if (g.c.c + g.c.b < h) f.a.Bc(g);
                                    else break;
                                }
                                for(e = f.a.ec().Kc(); e.Ob();){
                                    d = RD(e.Pb(), 226);
                                    Mub(d.b, b);
                                    Mub(b.b, d);
                                }
                                f.a.zc(b, (Geb(), Eeb));
                            }
                        }
                        function sZc(a, b, c) {
                            var d, e, f, g, h;
                            if (!gr(b)) {
                                h = c.eh((ZD(b, 16) ? RD(b, 16).gc() : Kr(b.Kc())) / a.a | 0);
                                h.Ug(OEe, 1);
                                g = new vZc;
                                f = null;
                                for(e = b.Kc(); e.Ob();){
                                    d = RD(e.Pb(), 40);
                                    g = Al(cD(WC(cJ, 1), rve, 20, 0, [
                                        g,
                                        new dXc(d)
                                    ]));
                                    if (f) {
                                        pQb(f, (q$c(), l$c), d);
                                        pQb(d, b$c, f);
                                        if (_Wc(d) == _Wc(f)) {
                                            pQb(f, m$c, d);
                                            pQb(d, c$c, f);
                                        }
                                    }
                                    f = d;
                                }
                                h.Vg();
                                sZc(a, g, c);
                            }
                        }
                        function z1d(a, b) {
                            var c, d, e;
                            if (b == null) for(d = (!a.a && (a.a = new C5d(l7, a, 9, 5)), new dMd(a.a)); d.e != d.i.gc();){
                                c = RD(bMd(d), 694);
                                e = c.c;
                                if ((e == null ? c.zb : e) == null) return c;
                            }
                            else for(d = (!a.a && (a.a = new C5d(l7, a, 9, 5)), new dMd(a.a)); d.e != d.i.gc();){
                                c = RD(bMd(d), 694);
                                if (lhb(b, (e = c.c, e == null ? c.zb : e))) return c;
                            }
                            return null;
                        }
                        function BLb(a, b) {
                            var c;
                            c = null;
                            switch(b.g){
                                case 1:
                                    a.e.pf((umd(), Cld)) && (c = RD(a.e.of(Cld), 256));
                                    break;
                                case 3:
                                    a.e.pf((umd(), Dld)) && (c = RD(a.e.of(Dld), 256));
                                    break;
                                case 2:
                                    a.e.pf((umd(), Bld)) && (c = RD(a.e.of(Bld), 256));
                                    break;
                                case 4:
                                    a.e.pf((umd(), Eld)) && (c = RD(a.e.of(Eld), 256));
                            }
                            !c && (c = RD(a.e.of((umd(), zld)), 256));
                            return c;
                        }
                        function $5c(a, b, c) {
                            var d, e, f, g, h, i;
                            e = c;
                            f = 0;
                            for(h = new Anb(b); h.a < h.c.c.length;){
                                g = RD(ynb(h), 27);
                                Ixd(g, ($4c(), P4c), sgb(e++));
                                i = Q2c(g);
                                d = $wnd.Math.atan2(g.j + g.f / 2, g.i + g.g / 2);
                                d += d < 0 ? dFe : 0;
                                d < 0.7853981633974483 || d > FFe ? _mb(i, a.b) : d <= FFe && d > GFe ? _mb(i, a.d) : d <= GFe && d > HFe ? _mb(i, a.c) : d <= HFe && _mb(i, a.a);
                                f = $5c(a, i, f);
                            }
                            return e;
                        }
                        function sTc(a, b, c, d) {
                            var e, f, g, h, i, j;
                            e = (d.c + d.a) / 2;
                            Xub(b.j);
                            Mub(b.j, e);
                            Xub(c.e);
                            Mub(c.e, e);
                            j = new ATc;
                            for(h = new Anb(a.f); h.a < h.c.c.length;){
                                f = RD(ynb(h), 132);
                                i = f.a;
                                uTc(j, b, i);
                                uTc(j, c, i);
                            }
                            for(g = new Anb(a.k); g.a < g.c.c.length;){
                                f = RD(ynb(g), 132);
                                i = f.b;
                                uTc(j, b, i);
                                uTc(j, c, i);
                            }
                            j.b += 2;
                            j.a += nTc(b, a.q);
                            j.a += nTc(a.q, c);
                            return j;
                        }
                        function U_c(a, b, c) {
                            var d;
                            c.Ug('Processor arrange node', 1);
                            Heb(TD(mQb(b, (h_c(), G$c))));
                            d = RD(Lvb(DDb(CDb(new SDb(null, new Swb(b.b, 16)), new c0c))), 40);
                            a.a = RD(mQb(b, g_c), 353);
                            a.a == (s_c(), q_c) || a.a == p_c ? T_c(a, new mob(cD(WC(Z$, 1), NEe, 40, 0, [
                                d
                            ])), c.eh(1)) : a.a == o_c && S_c(a, new mob(cD(WC(Z$, 1), NEe, 40, 0, [
                                d
                            ])), c.eh(1));
                            c.Vg();
                        }
                        function X7c() {
                            X7c = geb;
                            x7c = new mGd((umd(), Dkd), 1.3);
                            G7c = new mGd(mld, (Geb(), false));
                            O7c = new A3b(15);
                            N7c = new mGd(tld, O7c);
                            Q7c = new mGd(fmd, 15);
                            y7c = Kkd;
                            F7c = kld;
                            H7c = nld;
                            I7c = pld;
                            E7c = ild;
                            J7c = sld;
                            P7c = Lld;
                            U7c = (u7c(), p7c);
                            T7c = o7c;
                            W7c = t7c;
                            V7c = r7c;
                            M7c = k7c;
                            L7c = j7c;
                            K7c = i7c;
                            S7c = n7c;
                            B7c = ald;
                            C7c = bld;
                            A7c = g7c;
                            z7c = f7c;
                            D7c = h7c;
                            R7c = m7c;
                        }
                        function MKb(a) {
                            var b, c, d, e, f, g, h;
                            c = a.i;
                            b = a.n;
                            h = c.d;
                            a.f == (vLb(), tLb) ? h += (c.a - a.e.b) / 2 : a.f == sLb && (h += c.a - a.e.b);
                            for(e = new Anb(a.d); e.a < e.c.c.length;){
                                d = RD(ynb(e), 187);
                                g = d.Mf();
                                f = new pjd;
                                f.b = h;
                                h += g.b + a.a;
                                switch(a.b.g){
                                    case 0:
                                        f.a = c.c + b.b;
                                        break;
                                    case 1:
                                        f.a = c.c + b.b + (c.b - g.a) / 2;
                                        break;
                                    case 2:
                                        f.a = c.c + c.b - b.c - g.a;
                                }
                                d.Of(f);
                            }
                        }
                        function OKb(a) {
                            var b, c, d, e, f, g, h;
                            c = a.i;
                            b = a.n;
                            h = c.c;
                            a.b == (EKb(), BKb) ? h += (c.b - a.e.a) / 2 : a.b == DKb && (h += c.b - a.e.a);
                            for(e = new Anb(a.d); e.a < e.c.c.length;){
                                d = RD(ynb(e), 187);
                                g = d.Mf();
                                f = new pjd;
                                f.a = h;
                                h += g.a + a.a;
                                switch(a.f.g){
                                    case 0:
                                        f.b = c.d + b.d;
                                        break;
                                    case 1:
                                        f.b = c.d + b.d + (c.a - g.b) / 2;
                                        break;
                                    case 2:
                                        f.b = c.d + c.a - b.a - g.b;
                                }
                                d.Of(f);
                            }
                        }
                        function U7b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o;
                            k = c.a.c;
                            g = c.a.c + c.a.b;
                            f = RD(Wjb(c.c, b), 468);
                            n = f.f;
                            o = f.a;
                            i = new rjd(k, n);
                            l = new rjd(g, o);
                            e = k;
                            c.p || (e += a.c);
                            e += c.F + c.v * a.b;
                            j = new rjd(e, n);
                            m = new rjd(e, o);
                            zjd(b.a, cD(WC(l3, 1), Nve, 8, 0, [
                                i,
                                j
                            ]));
                            h = c.d.a.gc() > 1;
                            if (h) {
                                d = new rjd(e, c.b);
                                Mub(b.a, d);
                            }
                            zjd(b.a, cD(WC(l3, 1), Nve, 8, 0, [
                                m,
                                l
                            ]));
                        }
                        function TGc(a, b, c) {
                            var d, e;
                            if (b < a.d.b.c.length) {
                                a.b = RD(Vmb(a.d.b, b), 30);
                                a.a = RD(Vmb(a.d.b, b - 1), 30);
                                a.c = b;
                            } else {
                                a.a = new R4b(a.d);
                                a.a.p = b - 1;
                                Rmb(a.d.b, a.a);
                                a.b = new R4b(a.d);
                                a.b.p = b;
                                Rmb(a.d.b, a.b);
                                a.c = b;
                            }
                            g3b(c, a.b);
                            for(e = new is(Mr(Z2b(c).a.Kc(), new ir)); gs(e);){
                                d = RD(hs(e), 18);
                                !d.c.i.c && d.c.i.k == (r3b(), n3b) && g3b(d.c.i, a.a);
                            }
                        }
                        function Gpd(a) {
                            Cgd(a, new Pfd($fd(Xfd(Zfd(Yfd(new agd, qHe), 'ELK Randomizer'), 'Distributes the nodes randomly on the plane, leading to very obfuscating layouts. Can be useful to demonstrate the power of "real" layout algorithms.'), new Jpd)));
                            Agd(a, qHe, Eze, Cpd);
                            Agd(a, qHe, _ze, 15);
                            Agd(a, qHe, bAe, sgb(0));
                            Agd(a, qHe, Dze, Yze);
                        }
                        function Gqe() {
                            Gqe = geb;
                            var a, b, c, d, e, f;
                            Eqe = $C(gE, YHe, 28, 255, 15, 1);
                            Fqe = $C(hE, zwe, 28, 16, 15, 1);
                            for(b = 0; b < 255; b++)Eqe[b] = -1;
                            for(c = 57; c >= 48; c--)Eqe[c] = c - 48 << 24 >> 24;
                            for(d = 70; d >= 65; d--)Eqe[d] = d - 65 + 10 << 24 >> 24;
                            for(e = 102; e >= 97; e--)Eqe[e] = e - 97 + 10 << 24 >> 24;
                            for(f = 0; f < 10; f++)Fqe[f] = 48 + f & Bwe;
                            for(a = 10; a <= 15; a++)Fqe[a] = 65 + a - 10 & Bwe;
                        }
                        function yYc(a, b) {
                            b.Ug('Process graph bounds', 1);
                            pQb(a, (q$c(), ZZc), Uvb(TCb(HDb(new SDb(null, new Swb(a.b, 16)), new DYc))));
                            pQb(a, _Zc, Uvb(TCb(HDb(new SDb(null, new Swb(a.b, 16)), new FYc))));
                            pQb(a, YZc, Uvb(SCb(HDb(new SDb(null, new Swb(a.b, 16)), new HYc))));
                            pQb(a, $Zc, Uvb(SCb(HDb(new SDb(null, new Swb(a.b, 16)), new JYc))));
                            b.Vg();
                        }
                        function PWb(a) {
                            var b, c, d, e, f;
                            e = RD(mQb(a, (yCc(), lBc)), 21);
                            f = RD(mQb(a, oBc), 21);
                            c = new rjd(a.f.a + a.d.b + a.d.c, a.f.b + a.d.d + a.d.a);
                            b = new sjd(c);
                            if (e.Hc((Qpd(), Mpd))) {
                                d = RD(mQb(a, nBc), 8);
                                if (f.Hc((dqd(), Ypd))) {
                                    d.a <= 0 && (d.a = 20);
                                    d.b <= 0 && (d.b = 20);
                                }
                                b.a = $wnd.Math.max(c.a, d.a);
                                b.b = $wnd.Math.max(c.b, d.b);
                            }
                            Heb(TD(mQb(a, mBc))) || QWb(a, c, b);
                        }
                        function lOc(a, b) {
                            var c, d, e, f;
                            for(f = b3b(b, (qpd(), npd)).Kc(); f.Ob();){
                                d = RD(f.Pb(), 12);
                                c = RD(mQb(d, (Ywc(), Iwc)), 10);
                                !!c && rIb(uIb(tIb(vIb(sIb(new wIb, 0), 0.1), a.i[b.p].d), a.i[c.p].a));
                            }
                            for(e = b3b(b, Yod).Kc(); e.Ob();){
                                d = RD(e.Pb(), 12);
                                c = RD(mQb(d, (Ywc(), Iwc)), 10);
                                !!c && rIb(uIb(tIb(vIb(sIb(new wIb, 0), 0.1), a.i[c.p].d), a.i[b.p].a));
                            }
                        }
                        function oYd(a) {
                            var b, c, d, e, f, g;
                            if (!a.c) {
                                g = new W$d;
                                b = iYd;
                                f = b.a.zc(a, b);
                                if (f == null) {
                                    for(d = new dMd(tYd(a)); d.e != d.i.gc();){
                                        c = RD(bMd(d), 89);
                                        e = i2d(c);
                                        ZD(e, 90) && YGd(g, oYd(RD(e, 29)));
                                        WGd(g, c);
                                    }
                                    b.a.Bc(a);
                                    b.a.gc() == 0 && undefined;
                                }
                                T$d(g);
                                VHd(g);
                                a.c = new N$d((RD(QHd(xYd((lTd(), kTd).o), 15), 19), g.i), g.g);
                                yYd(a).b &= -33;
                            }
                            return a.c;
                        }
                        function Dre(a) {
                            var b;
                            if (a.c != 10) throw Adb(new Lqe(TId((Hde(), VIe))));
                            b = a.a;
                            switch(b){
                                case 110:
                                    b = 10;
                                    break;
                                case 114:
                                    b = 13;
                                    break;
                                case 116:
                                    b = 9;
                                    break;
                                case 92:
                                case 124:
                                case 46:
                                case 94:
                                case 45:
                                case 63:
                                case 42:
                                case 43:
                                case 123:
                                case 125:
                                case 40:
                                case 41:
                                case 91:
                                case 93:
                                    break;
                                default:
                                    throw Adb(new Lqe(TId((Hde(), xJe))));
                            }
                            return b;
                        }
                        function GD(a) {
                            var b, c, d, e, f;
                            if (a.l == 0 && a.m == 0 && a.h == 0) return '0';
                            if (a.h == fxe && a.m == 0 && a.l == 0) return '-9223372036854775808';
                            if (a.h >> 19 != 0) return '-' + GD(xD(a));
                            c = a;
                            d = '';
                            while(!(c.l == 0 && c.m == 0 && c.h == 0)){
                                e = fD(ixe);
                                c = iD(c, e, true);
                                b = '' + FD(eD);
                                if (!(c.l == 0 && c.m == 0 && c.h == 0)) {
                                    f = 9 - b.length;
                                    for(; f > 0; f--)b = '0' + b;
                                }
                                d = b + d;
                            }
                            return d;
                        }
                        function tkc(a) {
                            var b, c, d, e, f, g, h;
                            b = false;
                            c = 0;
                            for(e = new Anb(a.d.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 30);
                                d.p = c++;
                                for(g = new Anb(d.a); g.a < g.c.c.length;){
                                    f = RD(ynb(g), 10);
                                    !b && !gr(W2b(f)) && (b = true);
                                }
                            }
                            h = ysb((Cmd(), Amd), cD(WC(s3, 1), jwe, 88, 0, [
                                ymd,
                                zmd
                            ]));
                            if (!b) {
                                zsb(h, Bmd);
                                zsb(h, xmd);
                            }
                            a.a = new dGb(h);
                            akb(a.f);
                            akb(a.b);
                            akb(a.e);
                            akb(a.g);
                        }
                        function Ftb() {
                            if (!Object.create || !Object.getOwnPropertyNames) return false;
                            var a = '__proto__';
                            var b = Object.create(null);
                            if (b[a] !== undefined) return false;
                            var c = Object.getOwnPropertyNames(b);
                            if (c.length != 0) return false;
                            b[a] = 42;
                            if (b[a] !== 42) return false;
                            if (Object.getOwnPropertyNames(b).length == 0) return false;
                            return true;
                        }
                        function c_b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l;
                            d = c.c;
                            e = c.d;
                            h = K3b(b.c);
                            i = K3b(b.d);
                            if (d == b.c) {
                                h = d_b(a, h, e);
                                i = e_b(b.d);
                            } else {
                                h = e_b(b.c);
                                i = d_b(a, i, e);
                            }
                            j = new Fjd(b.a);
                            Pub(j, h, j.a, j.a.a);
                            Pub(j, i, j.c.b, j.c);
                            g = b.c == d;
                            l = new E_b;
                            for(f = 0; f < j.b - 1; ++f){
                                k = new Ptd(RD(ju(j, f), 8), RD(ju(j, f + 1), 8));
                                g && f == 0 || !g && f == j.b - 2 ? l.b = k : Rmb(l.a, k);
                            }
                            return l;
                        }
                        function W1b(a, b) {
                            var c, d, e, f;
                            f = a.j.g - b.j.g;
                            if (f != 0) return f;
                            c = RD(mQb(a, (yCc(), CBc)), 17);
                            d = RD(mQb(b, CBc), 17);
                            if (!!c && !!d) {
                                e = c.a - d.a;
                                if (e != 0) return e;
                            }
                            switch(a.j.g){
                                case 1:
                                    return Qfb(a.n.a, b.n.a);
                                case 2:
                                    return Qfb(a.n.b, b.n.b);
                                case 3:
                                    return Qfb(b.n.a, a.n.a);
                                case 4:
                                    return Qfb(b.n.b, a.n.b);
                                default:
                                    throw Adb(new dgb(UAe));
                            }
                        }
                        function X9b(a, b, c, d) {
                            var e, f, g, h, i;
                            if (Kr((U9b(), new is(Mr(W2b(b).a.Kc(), new ir)))) >= a.a) return -1;
                            if (!W9b(b, c)) return -1;
                            if (gr(RD(d.Kb(b), 20))) return 1;
                            e = 0;
                            for(g = RD(d.Kb(b), 20).Kc(); g.Ob();){
                                f = RD(g.Pb(), 18);
                                i = f.c.i == b ? f.d.i : f.c.i;
                                h = X9b(a, i, c, d);
                                if (h == -1) return -1;
                                e = $wnd.Math.max(e, h);
                                if (e > a.c - 1) return -1;
                            }
                            return e + 1;
                        }
                        function _Gd(a, b) {
                            var c, d, e, f, g, h;
                            if (dE(b) === dE(a)) return true;
                            if (!ZD(b, 15)) return false;
                            d = RD(b, 15);
                            h = a.gc();
                            if (d.gc() != h) return false;
                            g = d.Kc();
                            if (a.Yi()) for(c = 0; c < h; ++c){
                                e = a.Vi(c);
                                f = g.Pb();
                                if (e == null ? f != null : !pb(e, f)) return false;
                            }
                            else for(c = 0; c < h; ++c){
                                e = a.Vi(c);
                                f = g.Pb();
                                if (dE(e) !== dE(f)) return false;
                            }
                            return true;
                        }
                        function RNd(a, b) {
                            var c, d, e, f, g, h;
                            if (a.f > 0) {
                                a._j();
                                if (b != null) for(f = 0; f < a.d.length; ++f){
                                    c = a.d[f];
                                    if (c) {
                                        d = RD(c.g, 379);
                                        h = c.i;
                                        for(g = 0; g < h; ++g){
                                            e = d[g];
                                            if (pb(b, e.md())) return true;
                                        }
                                    }
                                }
                                else for(f = 0; f < a.d.length; ++f){
                                    c = a.d[f];
                                    if (c) {
                                        d = RD(c.g, 379);
                                        h = c.i;
                                        for(g = 0; g < h; ++g){
                                            e = d[g];
                                            if (dE(b) === dE(e.md())) return true;
                                        }
                                    }
                                }
                            }
                            return false;
                        }
                        function see(a, b) {
                            var c, d, e;
                            c = b.qi(a.a);
                            if (c) {
                                e = WD($Nd((!c.b && (c.b = new SVd((JTd(), FTd), C8, c)), c.b), 'affiliation'));
                                if (e != null) {
                                    d = thb(e, Fhb(35));
                                    return d == -1 ? Lee(a, Uee(a, BXd(b.qk())), e) : d == 0 ? Lee(a, null, (BFb(1, e.length + 1), e.substr(1))) : Lee(a, (AFb(0, d, e.length), e.substr(0, d)), (BFb(d + 1, e.length + 1), e.substr(d + 1)));
                                }
                            }
                            return null;
                        }
                        function v9b(a, b, c) {
                            var d, e, f, g;
                            c.Ug('Orthogonally routing hierarchical port edges', 1);
                            a.a = 0;
                            d = y9b(b);
                            B9b(b, d);
                            A9b(a, b, d);
                            w9b(b);
                            e = RD(mQb(b, (yCc(), BBc)), 101);
                            f = b.b;
                            u9b((tFb(0, f.c.length), RD(f.c[0], 30)), e, b);
                            u9b(RD(Vmb(f, f.c.length - 1), 30), e, b);
                            g = b.b;
                            s9b((tFb(0, g.c.length), RD(g.c[0], 30)));
                            s9b(RD(Vmb(g, g.c.length - 1), 30));
                            c.Vg();
                        }
                        function JAd(a) {
                            switch(a){
                                case 48:
                                case 49:
                                case 50:
                                case 51:
                                case 52:
                                case 53:
                                case 54:
                                case 55:
                                case 56:
                                case 57:
                                    return a - 48 << 24 >> 24;
                                case 97:
                                case 98:
                                case 99:
                                case 100:
                                case 101:
                                case 102:
                                    return a - 97 + 10 << 24 >> 24;
                                case 65:
                                case 66:
                                case 67:
                                case 68:
                                case 69:
                                case 70:
                                    return a - 65 + 10 << 24 >> 24;
                                default:
                                    throw Adb(new Vgb('Invalid hexadecimal'));
                            }
                        }
                        function iIb() {
                            iIb = geb;
                            hIb = new jIb('SPIRAL', 0);
                            cIb = new jIb('LINE_BY_LINE', 1);
                            dIb = new jIb('MANHATTAN', 2);
                            bIb = new jIb('JITTER', 3);
                            fIb = new jIb('QUADRANTS_LINE_BY_LINE', 4);
                            gIb = new jIb('QUADRANTS_MANHATTAN', 5);
                            eIb = new jIb('QUADRANTS_JITTER', 6);
                            aIb = new jIb('COMBINE_LINE_BY_LINE_MANHATTAN', 7);
                            _Hb = new jIb('COMBINE_JITTER_MANHATTAN', 8);
                        }
                        function Urc(a, b, c, d) {
                            var e, f, g, h, i, j;
                            i = Zrc(a, c);
                            j = Zrc(b, c);
                            e = false;
                            while(!!i && !!j){
                                if (d || Xrc(i, j, c)) {
                                    g = Zrc(i, c);
                                    h = Zrc(j, c);
                                    asc(b);
                                    asc(a);
                                    f = i.c;
                                    Hec(i, false);
                                    Hec(j, false);
                                    if (c) {
                                        f3b(b, j.p, f);
                                        b.p = j.p;
                                        f3b(a, i.p + 1, f);
                                        a.p = i.p;
                                    } else {
                                        f3b(a, i.p, f);
                                        a.p = i.p;
                                        f3b(b, j.p + 1, f);
                                        b.p = j.p;
                                    }
                                    g3b(i, null);
                                    g3b(j, null);
                                    i = g;
                                    j = h;
                                    e = true;
                                } else break;
                            }
                            return e;
                        }
                        function aDc(a) {
                            switch(a.g){
                                case 0:
                                    return new XHc;
                                case 1:
                                    return new pHc;
                                case 3:
                                    return new GGc;
                                case 4:
                                    return new gHc;
                                case 5:
                                    return new jIc;
                                case 6:
                                    return new IHc;
                                case 2:
                                    return new xHc;
                                case 7:
                                    return new pGc;
                                case 8:
                                    return new YGc;
                                default:
                                    throw Adb(new agb('No implementation is available for the layerer ' + (a.f != null ? a.f : '' + a.g)));
                            }
                        }
                        function tIc(a, b, c, d) {
                            var e, f, g, h, i;
                            e = false;
                            f = false;
                            for(h = new Anb(d.j); h.a < h.c.c.length;){
                                g = RD(ynb(h), 12);
                                dE(mQb(g, (Ywc(), Awc))) === dE(c) && (g.g.c.length == 0 ? g.e.c.length == 0 || (e = true) : f = true);
                            }
                            i = 0;
                            e && e ^ f ? i = c.j == (qpd(), Yod) ? -a.e[d.c.p][d.p] : b - a.e[d.c.p][d.p] : f && e ^ f ? i = a.e[d.c.p][d.p] + 1 : e && f && (i = c.j == (qpd(), Yod) ? 0 : b / 2);
                            return i;
                        }
                        function lSd(a, b, c, d, e, f, g, h) {
                            var i, j, k;
                            i = 0;
                            b != null && (i ^= ohb(b.toLowerCase()));
                            c != null && (i ^= ohb(c));
                            d != null && (i ^= ohb(d));
                            g != null && (i ^= ohb(g));
                            h != null && (i ^= ohb(h));
                            for(j = 0, k = f.length; j < k; j++)i ^= ohb(f[j]);
                            a ? i |= 256 : i &= -257;
                            e ? i |= 16 : i &= -17;
                            this.f = i;
                            this.i = b == null ? null : (uFb(b), b);
                            this.a = c;
                            this.d = d;
                            this.j = f;
                            this.g = g;
                            this.e = h;
                        }
                        function d3b(a, b, c) {
                            var d, e;
                            e = null;
                            switch(b.g){
                                case 1:
                                    e = (J3b(), E3b);
                                    break;
                                case 2:
                                    e = (J3b(), G3b);
                            }
                            d = null;
                            switch(c.g){
                                case 1:
                                    d = (J3b(), F3b);
                                    break;
                                case 2:
                                    d = (J3b(), D3b);
                                    break;
                                case 3:
                                    d = (J3b(), H3b);
                                    break;
                                case 4:
                                    d = (J3b(), I3b);
                            }
                            return !!e && !!d ? dr(a.j, new Yb(new mob(cD(WC(pE, 1), rve, 178, 0, [
                                RD(Qb(e), 178),
                                RD(Qb(d), 178)
                            ])))) : (yob(), yob(), vob);
                        }
                        function K8b(a) {
                            var b, c, d;
                            b = RD(mQb(a, (yCc(), nBc)), 8);
                            pQb(a, nBc, new rjd(b.b, b.a));
                            switch(RD(mQb(a, Rzc), 255).g){
                                case 1:
                                    pQb(a, Rzc, (Rjd(), Qjd));
                                    break;
                                case 2:
                                    pQb(a, Rzc, (Rjd(), Mjd));
                                    break;
                                case 3:
                                    pQb(a, Rzc, (Rjd(), Ojd));
                                    break;
                                case 4:
                                    pQb(a, Rzc, (Rjd(), Pjd));
                            }
                            if ((!a.q ? (yob(), yob(), wob) : a.q)._b(IBc)) {
                                c = RD(mQb(a, IBc), 8);
                                d = c.a;
                                c.a = c.b;
                                c.b = d;
                            }
                        }
                        function Pmc(a, b, c, d, e, f) {
                            this.b = c;
                            this.d = e;
                            if (a >= b.length) throw Adb(new veb('Greedy SwitchDecider: Free layer not in graph.'));
                            this.c = b[a];
                            this.e = new DMc(d);
                            rMc(this.e, this.c, (qpd(), ppd));
                            this.i = new DMc(d);
                            rMc(this.i, this.c, Xod);
                            this.f = new Kmc(this.c);
                            this.a = !f && e.i && !e.s && this.c[0].k == (r3b(), m3b);
                            this.a && Nmc(this, a, b.length);
                        }
                        function $Mb(a, b) {
                            var c, d, e, f, g, h;
                            f = !a.B.Hc((dqd(), Wpd));
                            g = a.B.Hc(Zpd);
                            a.a = new wKb(g, f, a.c);
                            !!a.n && C2b(a.a.n, a.n);
                            cLb(a.g, (ZJb(), XJb), a.a);
                            if (!b) {
                                d = new dLb(1, f, a.c);
                                d.n.a = a.k;
                                Wrb(a.p, (qpd(), Yod), d);
                                e = new dLb(1, f, a.c);
                                e.n.d = a.k;
                                Wrb(a.p, npd, e);
                                h = new dLb(0, f, a.c);
                                h.n.c = a.k;
                                Wrb(a.p, ppd, h);
                                c = new dLb(0, f, a.c);
                                c.n.b = a.k;
                                Wrb(a.p, Xod, c);
                            }
                        }
                        function zkc(a) {
                            var b, c, d;
                            b = RD(mQb(a.d, (yCc(), yAc)), 223);
                            switch(b.g){
                                case 2:
                                    c = rkc(a);
                                    break;
                                case 3:
                                    c = (d = new bnb, FDb(CDb(GDb(EDb(EDb(new SDb(null, new Swb(a.d.b, 16)), new wlc), new ylc), new Alc), new Kkc), new Clc(d)), d);
                                    break;
                                default:
                                    throw Adb(new dgb('Compaction not supported for ' + b + ' edges.'));
                            }
                            ykc(a, c);
                            xgb(new Xkb(a.g), new ilc(a));
                        }
                        function qYc(a, b) {
                            var c, d, e, f, g, h, i;
                            b.Ug('Process directions', 1);
                            c = RD(mQb(a, (h_c(), H$c)), 88);
                            if (c != (Cmd(), xmd)) for(e = Sub(a.b, 0); e.b != e.d.c;){
                                d = RD(evb(e), 40);
                                h = RD(mQb(d, (q$c(), o$c)), 17).a;
                                i = RD(mQb(d, p$c), 17).a;
                                switch(c.g){
                                    case 4:
                                        i *= -1;
                                        break;
                                    case 1:
                                        f = h;
                                        h = i;
                                        i = f;
                                        break;
                                    case 2:
                                        g = h;
                                        h = -i;
                                        i = g;
                                }
                                pQb(d, o$c, sgb(h));
                                pQb(d, p$c, sgb(i));
                            }
                            b.Vg();
                        }
                        function led(a, b) {
                            var c;
                            c = new qQb;
                            !!b && kQb(c, RD(Wjb(a.a, H4), 96));
                            ZD(b, 422) && kQb(c, RD(Wjb(a.a, L4), 96));
                            if (ZD(b, 366)) {
                                kQb(c, RD(Wjb(a.a, I4), 96));
                                return c;
                            }
                            ZD(b, 84) && kQb(c, RD(Wjb(a.a, E4), 96));
                            if (ZD(b, 207)) {
                                kQb(c, RD(Wjb(a.a, J4), 96));
                                return c;
                            }
                            if (ZD(b, 193)) {
                                kQb(c, RD(Wjb(a.a, K4), 96));
                                return c;
                            }
                            ZD(b, 326) && kQb(c, RD(Wjb(a.a, G4), 96));
                            return c;
                        }
                        function a_b(a) {
                            var b, c, d, e, f, g, h, i;
                            i = new m_b;
                            for(h = new Anb(a.a); h.a < h.c.c.length;){
                                g = RD(ynb(h), 10);
                                if (g.k == (r3b(), m3b)) continue;
                                $$b(i, g, new pjd);
                                for(f = new is(Mr(a3b(g).a.Kc(), new ir)); gs(f);){
                                    e = RD(hs(f), 18);
                                    if (e.c.i.k == m3b || e.d.i.k == m3b) continue;
                                    for(d = Sub(e.a, 0); d.b != d.d.c;){
                                        c = RD(evb(d), 8);
                                        b = c;
                                        k_b(i, new eZb(b.a, b.b));
                                    }
                                }
                            }
                            return i;
                        }
                        function Kcd() {
                            Kcd = geb;
                            Jcd = new jGd(iGe);
                            Icd = (_cd(), $cd);
                            Hcd = new lGd(nGe, Icd);
                            Gcd = (ldd(), kdd);
                            Fcd = new lGd(jGe, Gcd);
                            Ecd = (Xbd(), Tbd);
                            Dcd = new lGd(kGe, Ecd);
                            zcd = new lGd(lGe, null);
                            Ccd = (Mbd(), Kbd);
                            Bcd = new lGd(mGe, Ccd);
                            vcd = (sbd(), rbd);
                            ucd = new lGd(oGe, vcd);
                            wcd = new lGd(pGe, (Geb(), false));
                            xcd = new lGd(qGe, sgb(64));
                            ycd = new lGd(rGe, true);
                            Acd = Lbd;
                        }
                        function eHc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            a.p = 1;
                            e = a.c;
                            l = new Iub;
                            for(k = c3b(a, (BEc(), zEc)).Kc(); k.Ob();){
                                j = RD(k.Pb(), 12);
                                for(d = new Anb(j.g); d.a < d.c.c.length;){
                                    c = RD(ynb(d), 18);
                                    i = c.d.i;
                                    if (a != i) {
                                        f = i.c;
                                        if (f.p <= e.p) {
                                            g = e.p + 1;
                                            if (g == b.b.c.length) {
                                                h = new R4b(b);
                                                h.p = g;
                                                Rmb(b.b, h);
                                                g3b(i, h);
                                            } else {
                                                h = RD(Vmb(b.b, g), 30);
                                                g3b(i, h);
                                            }
                                            l.a.zc(i, l);
                                        }
                                    }
                                }
                            }
                            return l;
                        }
                        function mXc(a, b) {
                            var c, d;
                            c = RD(mQb(a, (q$c(), TZc)), 15);
                            if (!c || c.gc() < 1) return null;
                            else if (c.gc() == 1) return RD(c.Xb(0), 40);
                            d = null;
                            switch(b.g){
                                case 2:
                                    d = RD(Lvb(KDb(c.Oc(), new mYc)), 40);
                                    break;
                                case 1:
                                    d = RD(Lvb(JDb(c.Oc(), new KXc)), 40);
                                    break;
                                case 4:
                                    d = RD(Lvb(KDb(c.Oc(), new OXc)), 40);
                                    break;
                                case 3:
                                    d = RD(Lvb(JDb(c.Oc(), new SXc)), 40);
                            }
                            return d;
                        }
                        function usc(a) {
                            var b, c, d, e, f, g;
                            if (a.a != null) return;
                            a.a = $C(xdb, Hye, 28, a.c.b.c.length, 16, 1);
                            a.a[0] = false;
                            if (nQb(a.c, (yCc(), wCc))) {
                                d = RD(mQb(a.c, wCc), 15);
                                for(c = d.Kc(); c.Ob();){
                                    b = RD(c.Pb(), 17).a;
                                    b > 0 && b < a.a.length && (a.a[b] = false);
                                }
                            } else {
                                g = new Anb(a.c.b);
                                g.a < g.c.c.length && ynb(g);
                                e = 1;
                                while(g.a < g.c.c.length){
                                    f = RD(ynb(g), 30);
                                    a.a[e++] = xsc(f);
                                }
                            }
                        }
                        function X6c() {
                            X6c = geb;
                            M6c = new jGd('additionalHeight');
                            N6c = new jGd('drawingHeight');
                            O6c = new jGd('drawingWidth');
                            R6c = new jGd('minHeight');
                            U6c = new jGd('minWidth');
                            V6c = new jGd('rows');
                            W6c = new jGd('targetWidth');
                            T6c = new kGd('minRowIncrease', 0);
                            Q6c = new kGd('maxRowIncrease', 0);
                            S6c = new kGd('minRowDecrease', 0);
                            P6c = new kGd('maxRowDecrease', 0);
                        }
                        function r$d(a, b) {
                            var c, d, e, f;
                            e = a.b;
                            switch(b){
                                case 1:
                                    a.b |= 1;
                                    a.b |= 4;
                                    a.b |= 8;
                                    break;
                                case 2:
                                    a.b |= 2;
                                    a.b |= 4;
                                    a.b |= 8;
                                    break;
                                case 4:
                                    a.b |= 1;
                                    a.b |= 2;
                                    a.b |= 4;
                                    a.b |= 8;
                                    break;
                                case 3:
                                    a.b |= 16;
                                    a.b |= 8;
                                    break;
                                case 0:
                                    a.b |= 32;
                                    a.b |= 16;
                                    a.b |= 8;
                                    a.b |= 1;
                                    a.b |= 2;
                                    a.b |= 4;
                                    break;
                            }
                            if (a.b != e && !!a.c) for(d = new dMd(a.c); d.e != d.i.gc();){
                                f = RD(bMd(d), 482);
                                c = yYd(f);
                                v$d(c, b);
                            }
                        }
                        function CKc(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o;
                            e = false;
                            for(g = b, h = 0, i = g.length; h < i; ++h){
                                f = g[h];
                                Heb((Geb(), f.e ? true : false)) && !RD(Vmb(a.b, f.e.p), 219).s && (e = e | (j = f.e, k = RD(Vmb(a.b, j.p), 219), l = k.e, m = qKc(c, l.length), n = l[m][0], n.k == (r3b(), m3b) ? l[m] = AKc(f, l[m], c ? (qpd(), ppd) : (qpd(), Xod)) : k.c.mg(l, c), o = DKc(a, k, c, d), BKc(k.e, k.o, c), o));
                            }
                            return e;
                        }
                        function Aed(a, b) {
                            var c, d, e, f, g;
                            f = (!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a).i;
                            for(e = new dMd((!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a)); e.e != e.i.gc();){
                                d = RD(bMd(e), 27);
                                if (dE(Gxd(d, (umd(), Xkd))) !== dE((Fnd(), End))) {
                                    g = RD(Gxd(b, Tld), 143);
                                    c = RD(Gxd(d, Tld), 143);
                                    (g == c || !!g && Nfd(g, c)) && (!d.a && (d.a = new C5d(J4, d, 10, 11)), d.a).i != 0 && (f += Aed(a, d));
                                }
                            }
                            return f;
                        }
                        function Toc(a) {
                            var b, c, d, e, f, g, h;
                            d = 0;
                            h = 0;
                            for(g = new Anb(a.d); g.a < g.c.c.length;){
                                f = RD(ynb(g), 105);
                                e = RD(zDb(CDb(new SDb(null, new Swb(f.j, 16)), new Cpc), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                    (xBb(), vBb)
                                ]))), 15);
                                c = null;
                                if (d <= h) {
                                    c = (qpd(), Yod);
                                    d += e.gc();
                                } else if (h < d) {
                                    c = (qpd(), npd);
                                    h += e.gc();
                                }
                                b = c;
                                FDb(GDb(e.Oc(), new qpc), new spc(b));
                            }
                        }
                        function D6b(a) {
                            var b, c, d, e, f;
                            f = new cnb(a.a.c.length);
                            for(e = new Anb(a.a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 10);
                                c = RD(mQb(d, (yCc(), UAc)), 171);
                                b = null;
                                switch(c.g){
                                    case 1:
                                    case 2:
                                        b = (huc(), guc);
                                        break;
                                    case 3:
                                    case 4:
                                        b = (huc(), euc);
                                }
                                if (b) {
                                    pQb(d, (Ywc(), bwc), (huc(), guc));
                                    b == euc ? F6b(d, c, (BEc(), yEc)) : b == guc && F6b(d, c, (BEc(), zEc));
                                } else ZEb(f.c, d);
                            }
                            return f;
                        }
                        function Snc(a) {
                            var b, c, d, e, f, g, h, i;
                            a.b = new hj(new mob((qpd(), cD(WC(E3, 1), NAe, 64, 0, [
                                opd,
                                Yod,
                                Xod,
                                npd,
                                ppd
                            ]))), new mob((joc(), cD(WC(UV, 1), jwe, 372, 0, [
                                ioc,
                                hoc,
                                goc
                            ]))));
                            for(g = cD(WC(E3, 1), NAe, 64, 0, [
                                opd,
                                Yod,
                                Xod,
                                npd,
                                ppd
                            ]), h = 0, i = g.length; h < i; ++h){
                                f = g[h];
                                for(c = cD(WC(UV, 1), jwe, 372, 0, [
                                    ioc,
                                    hoc,
                                    goc
                                ]), d = 0, e = c.length; d < e; ++d){
                                    b = c[d];
                                    aj(a.b, f, b, new bnb);
                                }
                            }
                        }
                        function BMb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            g = RD(RD(Qc(a.r, b), 21), 87);
                            h = a.u.Hc((Pod(), Nod));
                            c = a.u.Hc(Kod);
                            d = a.u.Hc(Jod);
                            j = a.u.Hc(Ood);
                            l = a.B.Hc((dqd(), cqd));
                            k = !c && !d && (j || g.gc() == 2);
                            yMb(a, b);
                            e = null;
                            i = null;
                            if (h) {
                                f = g.Kc();
                                e = RD(f.Pb(), 117);
                                i = e;
                                while(f.Ob())i = RD(f.Pb(), 117);
                                e.d.b = 0;
                                i.d.c = 0;
                                k && !e.a && (e.d.c = 0);
                            }
                            if (l) {
                                CMb(g);
                                if (h) {
                                    e.d.b = 0;
                                    i.d.c = 0;
                                }
                            }
                        }
                        function JNb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            g = RD(RD(Qc(a.r, b), 21), 87);
                            h = a.u.Hc((Pod(), Nod));
                            c = a.u.Hc(Kod);
                            d = a.u.Hc(Jod);
                            i = a.u.Hc(Ood);
                            l = a.B.Hc((dqd(), cqd));
                            j = !c && !d && (i || g.gc() == 2);
                            HNb(a, b);
                            k = null;
                            e = null;
                            if (h) {
                                f = g.Kc();
                                k = RD(f.Pb(), 117);
                                e = k;
                                while(f.Ob())e = RD(f.Pb(), 117);
                                k.d.d = 0;
                                e.d.a = 0;
                                j && !k.a && (k.d.a = 0);
                            }
                            if (l) {
                                KNb(g);
                                if (h) {
                                    k.d.d = 0;
                                    e.d.a = 0;
                                }
                            }
                        }
                        function ONc(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            e = b.k;
                            if (b.p >= 0) return false;
                            else {
                                b.p = c.b;
                                Rmb(c.e, b);
                            }
                            if (e == (r3b(), o3b) || e == q3b) for(g = new Anb(b.j); g.a < g.c.c.length;){
                                f = RD(ynb(g), 12);
                                for(k = (d = new Anb(new _3b(f).a.g), new c4b(d)); xnb(k.a);){
                                    j = RD(ynb(k.a), 18).d;
                                    h = j.i;
                                    i = h.k;
                                    if (b.c != h.c) {
                                        if (i == o3b || i == q3b) {
                                            if (ONc(a, h, c)) return true;
                                        }
                                    }
                                }
                            }
                            return true;
                        }
                        function GWd(a) {
                            var b;
                            if ((a.Db & 64) != 0) return cWd(a);
                            b = new Shb(cWd(a));
                            b.a += ' (changeable: ';
                            Ohb(b, (a.Bb & gwe) != 0);
                            b.a += ', volatile: ';
                            Ohb(b, (a.Bb & cKe) != 0);
                            b.a += ', transient: ';
                            Ohb(b, (a.Bb & qxe) != 0);
                            b.a += ', defaultValueLiteral: ';
                            Nhb(b, a.j);
                            b.a += ', unsettable: ';
                            Ohb(b, (a.Bb & bKe) != 0);
                            b.a += ', derived: ';
                            Ohb(b, (a.Bb & Ove) != 0);
                            b.a += ')';
                            return b.a;
                        }
                        function tee(a, b) {
                            var c, d, e, f, g;
                            e = b.qi(a.a);
                            if (e) {
                                d = (!e.b && (e.b = new SVd((JTd(), FTd), C8, e)), e.b);
                                c = WD($Nd(d, DKe));
                                if (c != null) {
                                    f = c.lastIndexOf('#');
                                    g = f == -1 ? Wee(a, b.jk(), c) : f == 0 ? Vee(a, null, (BFb(1, c.length + 1), c.substr(1))) : Vee(a, (AFb(0, f, c.length), c.substr(0, f)), (BFb(f + 1, c.length + 1), c.substr(f + 1)));
                                    if (ZD(g, 156)) return RD(g, 156);
                                }
                            }
                            return null;
                        }
                        function xee(a, b) {
                            var c, d, e, f, g;
                            d = b.qi(a.a);
                            if (d) {
                                c = (!d.b && (d.b = new SVd((JTd(), FTd), C8, d)), d.b);
                                f = WD($Nd(c, $Ke));
                                if (f != null) {
                                    e = f.lastIndexOf('#');
                                    g = e == -1 ? Wee(a, b.jk(), f) : e == 0 ? Vee(a, null, (BFb(1, f.length + 1), f.substr(1))) : Vee(a, (AFb(0, e, f.length), f.substr(0, e)), (BFb(e + 1, f.length + 1), f.substr(e + 1)));
                                    if (ZD(g, 156)) return RD(g, 156);
                                }
                            }
                            return null;
                        }
                        function rRb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m;
                            e = XPb(a.d);
                            g = RD(mQb(a.b, (tSb(), nSb)), 107);
                            h = g.b + g.c;
                            i = g.d + g.a;
                            k = e.d.a * a.e + h;
                            j = e.b.a * a.f + i;
                            RRb(a.b, new rjd(k, j));
                            for(m = new Anb(a.g); m.a < m.c.c.length;){
                                l = RD(ynb(m), 568);
                                b = l.g - e.a.a;
                                c = l.i - e.c.a;
                                d = $id(jjd(new rjd(b, c), l.a, l.b), ijd(njd(ajd(yRb(l.e)), l.d * l.a, l.c * l.b), -0.5));
                                f = zRb(l.e);
                                BRb(l.e, ojd(d, f));
                            }
                        }
                        function Xgc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m;
                            b.Ug('Restoring reversed edges', 1);
                            for(i = new Anb(a.b); i.a < i.c.c.length;){
                                h = RD(ynb(i), 30);
                                for(k = new Anb(h.a); k.a < k.c.c.length;){
                                    j = RD(ynb(k), 10);
                                    for(m = new Anb(j.j); m.a < m.c.c.length;){
                                        l = RD(ynb(m), 12);
                                        g = s2b(l.g);
                                        for(d = g, e = 0, f = d.length; e < f; ++e){
                                            c = d[e];
                                            Heb(TD(mQb(c, (Ywc(), Nwc)))) && X0b(c, false);
                                        }
                                    }
                                }
                            }
                            b.Vg();
                        }
                        function Zpc(a, b, c, d) {
                            var e, f, g, h, i;
                            i = $C(iE, Nve, 109, (qpd(), cD(WC(E3, 1), NAe, 64, 0, [
                                opd,
                                Yod,
                                Xod,
                                npd,
                                ppd
                            ])).length, 0, 2);
                            for(f = cD(WC(E3, 1), NAe, 64, 0, [
                                opd,
                                Yod,
                                Xod,
                                npd,
                                ppd
                            ]), g = 0, h = f.length; g < h; ++g){
                                e = f[g];
                                i[e.g] = $C(iE, vxe, 28, a.c[e.g], 15, 1);
                            }
                            _pc(i, a, Yod);
                            _pc(i, a, npd);
                            Ypc(i, a, Yod, b, c, d);
                            Ypc(i, a, Xod, b, c, d);
                            Ypc(i, a, npd, b, c, d);
                            Ypc(i, a, ppd, b, c, d);
                            return i;
                        }
                        function sLc(a, b, c) {
                            if (Ujb(a.a, b)) {
                                if (Zsb(RD(Wjb(a.a, b), 49), c)) return 1;
                            } else Zjb(a.a, b, new _sb);
                            if (Ujb(a.a, c)) {
                                if (Zsb(RD(Wjb(a.a, c), 49), b)) return -1;
                            } else Zjb(a.a, c, new _sb);
                            if (Ujb(a.b, b)) {
                                if (Zsb(RD(Wjb(a.b, b), 49), c)) return -1;
                            } else Zjb(a.b, b, new _sb);
                            if (Ujb(a.b, c)) {
                                if (Zsb(RD(Wjb(a.b, c), 49), b)) return 1;
                            } else Zjb(a.b, c, new _sb);
                            return 0;
                        }
                        function tMb(a) {
                            var b, c, d, e, f, g;
                            if (a.q == (Bod(), xod) || a.q == wod) return;
                            e = a.f.n.d + SJb(RD(Vrb(a.b, (qpd(), Yod)), 127)) + a.c;
                            b = a.f.n.a + SJb(RD(Vrb(a.b, npd), 127)) + a.c;
                            d = RD(Vrb(a.b, Xod), 127);
                            g = RD(Vrb(a.b, ppd), 127);
                            f = $wnd.Math.max(0, d.n.d - e);
                            f = $wnd.Math.max(f, g.n.d - e);
                            c = $wnd.Math.max(0, d.n.a - b);
                            c = $wnd.Math.max(c, g.n.a - b);
                            d.n.d = f;
                            g.n.d = f;
                            d.n.a = c;
                            g.n.a = c;
                        }
                        function Xfe(a, b, c, d) {
                            var e, f, g, h, i, j;
                            if (c == null) {
                                e = RD(a.g, 124);
                                for(h = 0; h < a.i; ++h){
                                    g = e[h];
                                    if (g.Lk() == b) return rLd(a, g, d);
                                }
                            }
                            f = (nke(), RD(b, 69).xk() ? RD(c, 76) : oke(b, c));
                            if (Mvd(a.e)) {
                                j = !pge(a, b);
                                d = qLd(a, f, d);
                                i = b.Jk() ? fge(a, 3, b, null, c, kge(a, b, c, ZD(b, 102) && (RD(b, 19).Bb & txe) != 0), j) : fge(a, 1, b, b.ik(), c, -1, j);
                                d ? d.nj(i) : d = i;
                            } else d = qLd(a, f, d);
                            return d;
                        }
                        function xgd() {
                            this.b = new gub;
                            this.d = new gub;
                            this.e = new gub;
                            this.c = new gub;
                            this.a = new Tsb;
                            this.f = new Tsb;
                            HId(l3, new Igd, new Kgd);
                            HId(k3, new ehd, new ghd);
                            HId(h3, new ihd, new khd);
                            HId(i3, new mhd, new ohd);
                            HId(l4, new qhd, new shd);
                            HId(VJ, new Mgd, new Ogd);
                            HId(PK, new Qgd, new Sgd);
                            HId(BK, new Ugd, new Wgd);
                            HId(MK, new Ygd, new $gd);
                            HId(DL, new ahd, new chd);
                        }
                        function hc(a, b) {
                            var c, d, e, f, g;
                            a = a == null ? vve : (uFb(a), a);
                            for(e = 0; e < b.length; e++)b[e] = ic(b[e]);
                            c = new cib;
                            g = 0;
                            d = 0;
                            while(d < b.length){
                                f = a.indexOf('%s', g);
                                if (f == -1) break;
                                c.a += '' + zhb(a == null ? vve : (uFb(a), a), g, f);
                                Yhb(c, b[d++]);
                                g = f + 2;
                            }
                            Xhb(c, a, g, a.length);
                            if (d < b.length) {
                                c.a += ' [';
                                Yhb(c, b[d++]);
                                while(d < b.length){
                                    c.a += pve;
                                    Yhb(c, b[d++]);
                                }
                                c.a += ']';
                            }
                            return c.a;
                        }
                        function kMc(a, b) {
                            var c, d, e, f, g, h, i;
                            c = 0;
                            for(i = new Anb(b); i.a < i.c.c.length;){
                                h = RD(ynb(i), 12);
                                $Lc(a.b, a.d[h.p]);
                                g = 0;
                                for(e = new l4b(h.b); xnb(e.a) || xnb(e.b);){
                                    d = RD(xnb(e.a) ? ynb(e.a) : ynb(e.b), 18);
                                    if (uMc(d)) {
                                        f = AMc(a, h == d.c ? d.d : d.c);
                                        if (f > a.d[h.p]) {
                                            c += ZLc(a.b, f);
                                            hmb(a.a, sgb(f));
                                        }
                                    } else ++g;
                                }
                                c += a.b.d * g;
                                while(!nmb(a.a))XLc(a.b, RD(smb(a.a), 17).a);
                            }
                            return c;
                        }
                        function pje(a) {
                            var b, c, d, e, f, g;
                            f = 0;
                            b = WVd(a);
                            !!b.kk() && (f |= 4);
                            (a.Bb & bKe) != 0 && (f |= 2);
                            if (ZD(a, 102)) {
                                c = RD(a, 19);
                                e = Z5d(c);
                                (c.Bb & QHe) != 0 && (f |= 32);
                                if (e) {
                                    AYd(uWd(e));
                                    f |= 8;
                                    g = e.t;
                                    (g > 1 || g == -1) && (f |= 16);
                                    (e.Bb & QHe) != 0 && (f |= 64);
                                }
                                (c.Bb & txe) != 0 && (f |= cKe);
                                f |= gwe;
                            } else if (ZD(b, 469)) f |= 512;
                            else {
                                d = b.kk();
                                !!d && (d.i & 1) != 0 && (f |= 256);
                            }
                            (a.Bb & 512) != 0 && (f |= 128);
                            return f;
                        }
                        function vke(a, b) {
                            var c;
                            if (a.f == tke) {
                                c = yfe(Qee((lke(), jke), b));
                                return a.e ? c == 4 && b != (Lle(), Jle) && b != (Lle(), Gle) && b != (Lle(), Hle) && b != (Lle(), Ile) : c == 2;
                            }
                            if (!!a.d && (a.d.Hc(b) || a.d.Hc(zfe(Qee((lke(), jke), b))) || a.d.Hc(Eee((lke(), jke), a.b, b)))) return true;
                            if (a.f) {
                                if (Xee((lke(), a.f), Bfe(Qee(jke, b)))) {
                                    c = yfe(Qee(jke, b));
                                    return a.e ? c == 4 : c == 2;
                                }
                            }
                            return false;
                        }
                        function oKc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n;
                            m = -1;
                            n = 0;
                            for(j = a, k = 0, l = j.length; k < l; ++k){
                                i = j[k];
                                for(f = i, g = 0, h = f.length; g < h; ++g){
                                    e = f[g];
                                    b = new urc(m == -1 ? a[0] : a[m], RD(mQb(Y2b(e), (yCc(), cAc)), 284), Bic(e), Heb(TD(mQb(Y2b(e), bAc))));
                                    for(c = 0; c < e.j.c.length; c++)for(d = c + 1; d < e.j.c.length; d++)prc(b, RD(Vmb(e.j, c), 12), RD(Vmb(e.j, d), 12)) > 0 && ++n;
                                }
                                ++m;
                            }
                            return n;
                        }
                        function S2c(a, b, c, d) {
                            var e, f, g, h, i, j, k, l;
                            g = RD(Gxd(c, (umd(), Qld)), 8);
                            i = g.a;
                            k = g.b + a;
                            e = $wnd.Math.atan2(k, i);
                            e < 0 && (e += dFe);
                            e += b;
                            e > dFe && (e -= dFe);
                            h = RD(Gxd(d, Qld), 8);
                            j = h.a;
                            l = h.b + a;
                            f = $wnd.Math.atan2(l, j);
                            f < 0 && (f += dFe);
                            f += b;
                            f > dFe && (f -= dFe);
                            return Zy(), bz(1.0E-10), $wnd.Math.abs(e - f) <= 1.0E-10 || e == f || isNaN(e) && isNaN(f) ? 0 : e < f ? -1 : e > f ? 1 : cz(isNaN(e), isNaN(f));
                        }
                        function PGb(a) {
                            var b, c, d, e, f, g, h;
                            h = new Tsb;
                            for(d = new Anb(a.a.b); d.a < d.c.c.length;){
                                b = RD(ynb(d), 60);
                                Zjb(h, b, new bnb);
                            }
                            for(e = new Anb(a.a.b); e.a < e.c.c.length;){
                                b = RD(ynb(e), 60);
                                b.i = pxe;
                                for(g = b.c.Kc(); g.Ob();){
                                    f = RD(g.Pb(), 60);
                                    RD(Wd(qtb(h.f, f)), 15).Fc(b);
                                }
                            }
                            for(c = new Anb(a.a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 60);
                                b.c.$b();
                                b.c = RD(Wd(qtb(h.f, b)), 15);
                            }
                            HGb(a);
                        }
                        function AYb(a) {
                            var b, c, d, e, f, g, h;
                            h = new Tsb;
                            for(d = new Anb(a.a.b); d.a < d.c.c.length;){
                                b = RD(ynb(d), 86);
                                Zjb(h, b, new bnb);
                            }
                            for(e = new Anb(a.a.b); e.a < e.c.c.length;){
                                b = RD(ynb(e), 86);
                                b.o = pxe;
                                for(g = b.f.Kc(); g.Ob();){
                                    f = RD(g.Pb(), 86);
                                    RD(Wd(qtb(h.f, f)), 15).Fc(b);
                                }
                            }
                            for(c = new Anb(a.a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 86);
                                b.f.$b();
                                b.f = RD(Wd(qtb(h.f, b)), 15);
                            }
                            tYb(a);
                        }
                        function WPb(a, b, c, d) {
                            var e, f;
                            VPb(a, b, c, d);
                            hQb(b, a.j - b.j + c);
                            iQb(b, a.k - b.k + d);
                            for(f = new Anb(b.f); f.a < f.c.c.length;){
                                e = RD(ynb(f), 334);
                                switch(e.a.g){
                                    case 0:
                                        eQb(a, b.g + e.b.a, 0, b.g + e.c.a, b.i - 1);
                                        break;
                                    case 1:
                                        eQb(a, b.g + b.o, b.i + e.b.a, a.o - 1, b.i + e.c.a);
                                        break;
                                    case 2:
                                        eQb(a, b.g + e.b.a, b.i + b.p, b.g + e.c.a, a.p - 1);
                                        break;
                                    default:
                                        eQb(a, 0, b.i + e.b.a, b.g - 1, b.i + e.c.a);
                                }
                            }
                        }
                        function $ec(a, b) {
                            var c, d, e, f, g, h, i, j;
                            f = new bnb;
                            b.b.c.length = 0;
                            c = RD(zDb(ODb(new SDb(null, new Swb(new Xkb(a.a.b), 1))), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), vBb)
                            ]))), 15);
                            for(e = c.Kc(); e.Ob();){
                                d = RD(e.Pb(), 17);
                                g = _5b(a.a, d);
                                if (g.b != 0) {
                                    h = new R4b(b);
                                    ZEb(f.c, h);
                                    h.p = d.a;
                                    for(j = Sub(g, 0); j.b != j.d.c;){
                                        i = RD(evb(j), 10);
                                        g3b(i, h);
                                    }
                                }
                            }
                            Tmb(b.b, f);
                        }
                        function TPb(b, c, d, e, f) {
                            var g, h, i;
                            try {
                                if (c >= b.o) throw Adb(new web);
                                i = c >> 5;
                                h = c & 31;
                                g = Sdb(1, Ydb(Sdb(h, 1)));
                                f ? b.n[d][i] = Rdb(b.n[d][i], g) : b.n[d][i] = Cdb(b.n[d][i], Qdb(g));
                                g = Sdb(g, 1);
                                e ? b.n[d][i] = Rdb(b.n[d][i], g) : b.n[d][i] = Cdb(b.n[d][i], Qdb(g));
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 333)) throw Adb(new veb(fze + b.o + '*' + b.p + gze + c + pve + d + hze));
                                else throw Adb(a);
                            }
                        }
                        function eMc(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m;
                            m = new yAb(new PMc(a));
                            for(h = cD(WC(jR, 1), WAe, 10, 0, [
                                b,
                                c
                            ]), i = 0, j = h.length; i < j; ++i){
                                g = h[i];
                                for(l = aMc(g, d).Kc(); l.Ob();){
                                    k = RD(l.Pb(), 12);
                                    for(f = new l4b(k.b); xnb(f.a) || xnb(f.b);){
                                        e = RD(xnb(f.a) ? ynb(f.a) : ynb(f.b), 18);
                                        if (!W0b(e)) {
                                            m.a.zc(k, (Geb(), Eeb));
                                            uMc(e) && rAb(m, k == e.c ? e.d : e.c);
                                        }
                                    }
                                }
                            }
                            return Qb(m), new dnb(m);
                        }
                        function w0c(a, b, c, d) {
                            var e, f, g;
                            if (b) {
                                f = Kfb(UD(mQb(b, (q$c(), j$c)))) + d;
                                g = c + Kfb(UD(mQb(b, d$c))) / 2;
                                pQb(b, o$c, sgb(Ydb(Hdb($wnd.Math.round(f)))));
                                pQb(b, p$c, sgb(Ydb(Hdb($wnd.Math.round(g)))));
                                b.d.b == 0 || w0c(a, RD(Hr((e = Sub(new dXc(b).a.d, 0), new gXc(e))), 40), c + Kfb(UD(mQb(b, d$c))) + a.b, d + Kfb(UD(mQb(b, g$c))));
                                mQb(b, m$c) != null && w0c(a, RD(mQb(b, m$c), 40), c, d);
                            }
                        }
                        function cdc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m;
                            i = Y2b(b.a);
                            e = Kfb(UD(mQb(i, (yCc(), XBc)))) * 2;
                            k = Kfb(UD(mQb(i, cCc)));
                            j = $wnd.Math.max(e, k);
                            f = $C(iE, vxe, 28, b.f - b.c + 1, 15, 1);
                            d = -j;
                            c = 0;
                            for(h = b.b.Kc(); h.Ob();){
                                g = RD(h.Pb(), 10);
                                d += a.a[g.c.p] + j;
                                f[c++] = d;
                            }
                            d += a.a[b.a.c.p] + j;
                            f[c++] = d;
                            for(m = new Anb(b.e); m.a < m.c.c.length;){
                                l = RD(ynb(m), 10);
                                d += a.a[l.c.p] + j;
                                f[c++] = d;
                            }
                            return f;
                        }
                        function Xud(a, b) {
                            var c, d, e, f;
                            f = RD(Gxd(a, (umd(), Old)), 64).g - RD(Gxd(b, Old), 64).g;
                            if (f != 0) return f;
                            c = RD(Gxd(a, Jld), 17);
                            d = RD(Gxd(b, Jld), 17);
                            if (!!c && !!d) {
                                e = c.a - d.a;
                                if (e != 0) return e;
                            }
                            switch(RD(Gxd(a, Old), 64).g){
                                case 1:
                                    return Qfb(a.i, b.i);
                                case 2:
                                    return Qfb(a.j, b.j);
                                case 3:
                                    return Qfb(b.i, a.i);
                                case 4:
                                    return Qfb(b.j, a.j);
                                default:
                                    throw Adb(new dgb(UAe));
                            }
                        }
                        function zCd(a) {
                            var b, c, d;
                            if ((a.Db & 64) != 0) return Fyd(a);
                            b = new dib(GHe);
                            c = a.k;
                            if (!c) {
                                !a.n && (a.n = new C5d(I4, a, 1, 7));
                                if (a.n.i > 0) {
                                    d = (!a.n && (a.n = new C5d(I4, a, 1, 7)), RD(QHd(a.n, 0), 135)).a;
                                    !d || Zhb(Zhb((b.a += ' "', b), d), '"');
                                }
                            } else Zhb(Zhb((b.a += ' "', b), c), '"');
                            Zhb(Uhb(Zhb(Uhb(Zhb(Uhb(Zhb(Uhb((b.a += ' (', b), a.i), ','), a.j), ' | '), a.g), ','), a.f), ')');
                            return b.a;
                        }
                        function OCd(a) {
                            var b, c, d;
                            if ((a.Db & 64) != 0) return Fyd(a);
                            b = new dib(HHe);
                            c = a.k;
                            if (!c) {
                                !a.n && (a.n = new C5d(I4, a, 1, 7));
                                if (a.n.i > 0) {
                                    d = (!a.n && (a.n = new C5d(I4, a, 1, 7)), RD(QHd(a.n, 0), 135)).a;
                                    !d || Zhb(Zhb((b.a += ' "', b), d), '"');
                                }
                            } else Zhb(Zhb((b.a += ' "', b), c), '"');
                            Zhb(Uhb(Zhb(Uhb(Zhb(Uhb(Zhb(Uhb((b.a += ' (', b), a.i), ','), a.j), ' | '), a.g), ','), a.f), ')');
                            return b.a;
                        }
                        function Xnc(a, b) {
                            var c, d, e, f, g;
                            b == (TEc(), QEc) && Eob(RD(Qc(a.a, (Bnc(), xnc)), 15));
                            for(e = RD(Qc(a.a, (Bnc(), xnc)), 15).Kc(); e.Ob();){
                                d = RD(e.Pb(), 105);
                                c = RD(Vmb(d.j, 0), 113).d.j;
                                f = new dnb(d.j);
                                _mb(f, new Boc);
                                switch(b.g){
                                    case 2:
                                        Pnc(a, f, c, (joc(), hoc), 1);
                                        break;
                                    case 1:
                                    case 0:
                                        g = Rnc(f);
                                        Pnc(a, new Rkb(f, 0, g), c, (joc(), hoc), 0);
                                        Pnc(a, new Rkb(f, g, f.c.length), c, hoc, 1);
                                }
                            }
                        }
                        function sgd(a, b) {
                            var c, d, e, f, g, h, i;
                            if (b == null || b.length == 0) return null;
                            e = RD(Xjb(a.a, b), 143);
                            if (!e) {
                                for(d = (h = new glb(a.b).a.vc().Kc(), new llb(h)); d.a.Ob();){
                                    c = (f = RD(d.a.Pb(), 44), RD(f.md(), 143));
                                    g = c.c;
                                    i = b.length;
                                    if (lhb(g.substr(g.length - i, i), b) && (b.length == g.length || ihb(g, g.length - b.length - 1) == 46)) {
                                        if (e) return null;
                                        e = c;
                                    }
                                }
                                !!e && $jb(a.a, b, e);
                            }
                            return e;
                        }
                        function HOb(a, b) {
                            var c, d, e, f;
                            c = new MOb;
                            d = RD(zDb(GDb(new SDb(null, new Swb(a.f, 16)), c), sBb(new _Bb, new bCb, new yCb, new ACb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), wBb),
                                vBb
                            ]))), 21);
                            e = d.gc();
                            d = RD(zDb(GDb(new SDb(null, new Swb(b.f, 16)), c), sBb(new _Bb, new bCb, new yCb, new ACb, cD(WC(QL, 1), jwe, 108, 0, [
                                wBb,
                                vBb
                            ]))), 21);
                            f = d.gc();
                            if (e < f) return -1;
                            if (e == f) return 0;
                            return 1;
                        }
                        function I8b(a) {
                            var b, c, d;
                            if (!nQb(a, (yCc(), dBc))) return;
                            d = RD(mQb(a, dBc), 21);
                            if (d.dc()) return;
                            c = (b = RD(mfb(A3), 9), new Fsb(b, RD(WEb(b, b.length), 9), 0));
                            d.Hc((dod(), $nd)) ? zsb(c, $nd) : zsb(c, _nd);
                            d.Hc(Ynd) || zsb(c, Ynd);
                            d.Hc(Xnd) ? zsb(c, cod) : d.Hc(Wnd) ? zsb(c, bod) : d.Hc(Znd) && zsb(c, aod);
                            d.Hc(cod) ? zsb(c, Xnd) : d.Hc(bod) ? zsb(c, Wnd) : d.Hc(aod) && zsb(c, Znd);
                            pQb(a, dBc, c);
                        }
                        function KLc(a) {
                            var b, c, d, e, f, g, h;
                            e = RD(mQb(a, (Ywc(), pwc)), 10);
                            d = a.j;
                            c = (tFb(0, d.c.length), RD(d.c[0], 12));
                            for(g = new Anb(e.j); g.a < g.c.c.length;){
                                f = RD(ynb(g), 12);
                                if (dE(f) === dE(mQb(c, Awc))) {
                                    if (f.j == (qpd(), Yod) && a.p > e.p) {
                                        Q3b(f, npd);
                                        if (f.d) {
                                            h = f.o.b;
                                            b = f.a.b;
                                            f.a.b = h - b;
                                        }
                                    } else if (f.j == npd && e.p > a.p) {
                                        Q3b(f, Yod);
                                        if (f.d) {
                                            h = f.o.b;
                                            b = f.a.b;
                                            f.a.b = -(h - b);
                                        }
                                    }
                                    break;
                                }
                            }
                            return e;
                        }
                        function nTb(a, b, c, d, e) {
                            var f, g, h, i, j, k, l;
                            if (!(ZD(b, 207) || ZD(b, 366) || ZD(b, 193))) throw Adb(new agb('Method only works for ElkNode-, ElkLabel and ElkPort-objects.'));
                            g = a.a / 2;
                            i = b.i + d - g;
                            k = b.j + e - g;
                            j = i + b.g + a.a;
                            l = k + b.f + a.a;
                            f = new Ejd;
                            Mub(f, new rjd(i, k));
                            Mub(f, new rjd(i, l));
                            Mub(f, new rjd(j, l));
                            Mub(f, new rjd(j, k));
                            h = new ORb(f);
                            kQb(h, b);
                            c && Zjb(a.b, b, h);
                            return h;
                        }
                        function w$b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            f = new rjd(b, c);
                            for(k = new Anb(a.a); k.a < k.c.c.length;){
                                j = RD(ynb(k), 10);
                                $id(j.n, f);
                                for(m = new Anb(j.j); m.a < m.c.c.length;){
                                    l = RD(ynb(m), 12);
                                    for(e = new Anb(l.g); e.a < e.c.c.length;){
                                        d = RD(ynb(e), 18);
                                        Cjd(d.a, f);
                                        g = RD(mQb(d, (yCc(), RAc)), 75);
                                        !!g && Cjd(g, f);
                                        for(i = new Anb(d.b); i.a < i.c.c.length;){
                                            h = RD(ynb(i), 72);
                                            $id(h.n, f);
                                        }
                                    }
                                }
                            }
                        }
                        function o2b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            f = new rjd(b, c);
                            for(k = new Anb(a.a); k.a < k.c.c.length;){
                                j = RD(ynb(k), 10);
                                $id(j.n, f);
                                for(m = new Anb(j.j); m.a < m.c.c.length;){
                                    l = RD(ynb(m), 12);
                                    for(e = new Anb(l.g); e.a < e.c.c.length;){
                                        d = RD(ynb(e), 18);
                                        Cjd(d.a, f);
                                        g = RD(mQb(d, (yCc(), RAc)), 75);
                                        !!g && Cjd(g, f);
                                        for(i = new Anb(d.b); i.a < i.c.c.length;){
                                            h = RD(ynb(i), 72);
                                            $id(h.n, f);
                                        }
                                    }
                                }
                            }
                        }
                        function X4b(a) {
                            if ((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b).i == 0) throw Adb(new Ked('Edges must have a source.'));
                            else if ((!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c).i == 0) throw Adb(new Ked('Edges must have a target.'));
                            else {
                                !a.b && (a.b = new Yie(E4, a, 4, 7));
                                if (!(a.b.i <= 1 && (!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c.i <= 1))) throw Adb(new Ked('Hyperedges are not supported.'));
                            }
                        }
                        function mKc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            l = 0;
                            f = new wmb;
                            hmb(f, b);
                            while(f.b != f.c){
                                i = RD(smb(f), 219);
                                j = 0;
                                k = RD(mQb(b.j, (yCc(), cAc)), 284);
                                g = Kfb(UD(mQb(b.j, Zzc)));
                                h = Kfb(UD(mQb(b.j, $zc)));
                                if (k != (kEc(), hEc)) {
                                    j += g * nKc(i.e, k);
                                    j += h * oKc(i.e);
                                }
                                l += PLc(i.d, i.e) + j;
                                for(e = new Anb(i.b); e.a < e.c.c.length;){
                                    d = RD(ynb(e), 36);
                                    c = RD(Vmb(a.b, d.p), 219);
                                    c.s || (l += lKc(a, c));
                                }
                            }
                            return l;
                        }
                        function Pib() {
                            Pib = geb;
                            var a;
                            Kib = new ajb(1, 1);
                            Mib = new ajb(1, 10);
                            Oib = new ajb(0, 0);
                            Jib = new ajb(-1, 1);
                            Lib = cD(WC(uJ, 1), Nve, 92, 0, [
                                Oib,
                                Kib,
                                new ajb(1, 2),
                                new ajb(1, 3),
                                new ajb(1, 4),
                                new ajb(1, 5),
                                new ajb(1, 6),
                                new ajb(1, 7),
                                new ajb(1, 8),
                                new ajb(1, 9),
                                Mib
                            ]);
                            Nib = $C(uJ, Nve, 92, 32, 0, 1);
                            for(a = 0; a < Nib.length; a++)Nib[a] = Jdb(Sdb(1, a), 0) ? jjb(Sdb(1, a)) : Xib(jjb(Odb(Sdb(1, a))));
                        }
                        function JJb(a, b, c, d, e, f, g) {
                            a.c = d.Lf().a;
                            a.d = d.Lf().b;
                            if (e) {
                                a.c += e.Lf().a;
                                a.d += e.Lf().b;
                            }
                            a.b = b.Mf().a;
                            a.a = b.Mf().b;
                            if (!e) c ? a.c -= g + b.Mf().a : a.c += d.Mf().a + g;
                            else switch(e.ag().g){
                                case 0:
                                case 2:
                                    a.c += e.Mf().a + g + f.a + g;
                                    break;
                                case 4:
                                    a.c -= g + f.a + g + b.Mf().a;
                                    break;
                                case 1:
                                    a.c += e.Mf().a + g;
                                    a.d -= g + f.b + g + b.Mf().b;
                                    break;
                                case 3:
                                    a.c += e.Mf().a + g;
                                    a.d += e.Mf().b + g + f.b + g;
                            }
                        }
                        function xdc(a, b) {
                            var c, d;
                            this.b = new bnb;
                            this.e = new bnb;
                            this.a = a;
                            this.d = b;
                            udc(this);
                            vdc(this);
                            this.b.dc() ? this.c = a.c.p : this.c = RD(this.b.Xb(0), 10).c.p;
                            this.e.c.length == 0 ? this.f = a.c.p : this.f = RD(Vmb(this.e, this.e.c.length - 1), 10).c.p;
                            for(d = RD(mQb(a, (Ywc(), Mwc)), 15).Kc(); d.Ob();){
                                c = RD(d.Pb(), 72);
                                if (nQb(c, (yCc(), uAc))) {
                                    this.d = RD(mQb(c, uAc), 232);
                                    break;
                                }
                            }
                        }
                        function erc(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            d = RD(Wjb(a.a, b), 49);
                            f = RD(Wjb(a.a, c), 49);
                            e = RD(Wjb(a.e, b), 49);
                            g = RD(Wjb(a.e, c), 49);
                            d.a.zc(c, d);
                            g.a.zc(b, g);
                            for(k = f.a.ec().Kc(); k.Ob();){
                                j = RD(k.Pb(), 10);
                                d.a.zc(j, d);
                                Ysb(RD(Wjb(a.e, j), 49), b);
                                ye(RD(Wjb(a.e, j), 49), e);
                            }
                            for(i = e.a.ec().Kc(); i.Ob();){
                                h = RD(i.Pb(), 10);
                                g.a.zc(h, g);
                                Ysb(RD(Wjb(a.a, h), 49), c);
                                ye(RD(Wjb(a.a, h), 49), f);
                            }
                        }
                        function uLc(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            d = RD(Wjb(a.a, b), 49);
                            f = RD(Wjb(a.a, c), 49);
                            e = RD(Wjb(a.b, b), 49);
                            g = RD(Wjb(a.b, c), 49);
                            d.a.zc(c, d);
                            g.a.zc(b, g);
                            for(k = f.a.ec().Kc(); k.Ob();){
                                j = RD(k.Pb(), 10);
                                d.a.zc(j, d);
                                Ysb(RD(Wjb(a.b, j), 49), b);
                                ye(RD(Wjb(a.b, j), 49), e);
                            }
                            for(i = e.a.ec().Kc(); i.Ob();){
                                h = RD(i.Pb(), 10);
                                g.a.zc(h, g);
                                Ysb(RD(Wjb(a.a, h), 49), c);
                                ye(RD(Wjb(a.a, h), 49), f);
                            }
                        }
                        function rrc(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            d = RD(Wjb(a.a, b), 49);
                            f = RD(Wjb(a.a, c), 49);
                            e = RD(Wjb(a.d, b), 49);
                            g = RD(Wjb(a.d, c), 49);
                            d.a.zc(c, d);
                            g.a.zc(b, g);
                            for(k = f.a.ec().Kc(); k.Ob();){
                                j = RD(k.Pb(), 12);
                                d.a.zc(j, d);
                                Ysb(RD(Wjb(a.d, j), 49), b);
                                ye(RD(Wjb(a.d, j), 49), e);
                            }
                            for(i = e.a.ec().Kc(); i.Ob();){
                                h = RD(i.Pb(), 12);
                                g.a.zc(h, g);
                                Ysb(RD(Wjb(a.a, h), 49), c);
                                ye(RD(Wjb(a.a, h), 49), f);
                            }
                        }
                        function lTc(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o;
                            f = c;
                            if (c < d) {
                                m = (n = new USc(a.p), o = new USc(a.p), ye(n.e, a.e), n.q = a.q, n.r = o, LSc(n), ye(o.j, a.j), o.r = n, LSc(o), new Ptd(n, o));
                                l = RD(m.a, 118);
                                k = RD(m.b, 118);
                                e = (tFb(f, b.c.length), RD(b.c[f], 339));
                                g = sTc(a, l, k, e);
                                for(j = c + 1; j <= d; j++){
                                    h = (tFb(j, b.c.length), RD(b.c[j], 339));
                                    i = sTc(a, l, k, h);
                                    if (qTc(h, i, e, g)) {
                                        e = h;
                                        g = i;
                                        f = j;
                                    }
                                }
                            }
                            return f;
                        }
                        function c8c(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o;
                            g = RD(QHd(b, 0), 27);
                            Dyd(g, 0);
                            Eyd(g, 0);
                            m = new bnb;
                            ZEb(m.c, g);
                            h = g;
                            f = new lad(a.a, g.g, g.f, (sad(), rad));
                            for(n = 1; n < b.i; n++){
                                o = RD(QHd(b, n), 27);
                                i = d8c(a, oad, o, h, f, m, c);
                                j = d8c(a, nad, o, h, f, m, c);
                                k = d8c(a, qad, o, h, f, m, c);
                                l = d8c(a, pad, o, h, f, m, c);
                                e = f8c(a, i, j, k, l, o, h, d);
                                Dyd(o, e.d);
                                Eyd(o, e.e);
                                kad(e, rad);
                                f = e;
                                h = o;
                                ZEb(m.c, o);
                            }
                            return f;
                        }
                        function yEd(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            k = null;
                            m = b;
                            l = pEd(a, DGd(c), m);
                            jyd(l, zDd(m, uIe));
                            g = wDd(m, kIe);
                            d = new MEd(a, l);
                            ODd(d.a, d.b, g);
                            h = wDd(m, lIe);
                            e = new NEd(a, l);
                            PDd(e.a, e.b, h);
                            if ((!l.b && (l.b = new Yie(E4, l, 4, 7)), l.b).i == 0 || (!l.c && (l.c = new Yie(E4, l, 5, 8)), l.c).i == 0) {
                                f = zDd(m, uIe);
                                i = yIe + f;
                                j = i + zIe;
                                throw Adb(new CDd(j));
                            }
                            GEd(m, l);
                            zEd(a, m, l);
                            k = CEd(a, m, l);
                            return k;
                        }
                        function pJb(a, b) {
                            var c, d, e, f, g, h, i;
                            e = $C(kE, Pwe, 28, a.e.a.c.length, 15, 1);
                            for(g = new Anb(a.e.a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 125);
                                e[f.d] += f.b.a.c.length;
                            }
                            h = gv(b);
                            while(h.b != 0){
                                f = RD(h.b == 0 ? null : (sFb(h.b != 0), Wub(h, h.a.a)), 125);
                                for(d = Nr(new Anb(f.g.a)); d.Ob();){
                                    c = RD(d.Pb(), 218);
                                    i = c.e;
                                    i.e = $wnd.Math.max(i.e, f.e + c.a);
                                    --e[i.d];
                                    e[i.d] == 0 && Pub(h, i, h.c.b, h.c);
                                }
                            }
                        }
                        function tJb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l;
                            c = qwe;
                            e = lve;
                            for(h = new Anb(a.e.a); h.a < h.c.c.length;){
                                f = RD(ynb(h), 125);
                                e = $wnd.Math.min(e, f.e);
                                c = $wnd.Math.max(c, f.e);
                            }
                            b = $C(kE, Pwe, 28, c - e + 1, 15, 1);
                            for(g = new Anb(a.e.a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 125);
                                f.e -= e;
                                ++b[f.e];
                            }
                            d = 0;
                            if (a.k != null) for(j = a.k, k = 0, l = j.length; k < l; ++k){
                                i = j[k];
                                b[d++] += i;
                                if (b.length == d) break;
                            }
                            return b;
                        }
                        function I0c(a, b) {
                            var c, d, e, f, g, h;
                            b.Ug('Edge routing', 1);
                            e = RD(mQb(a, (h_c(), K$c)), 392);
                            if (e == (LZc(), JZc)) G0c(a);
                            else if (e == IZc) {
                                RD(Lvb(DDb(CDb(new SDb(null, new Swb(a.b, 16)), new AWc))), 40);
                                f = Kfb(UD(mQb(a, $$c)));
                                g = Kfb(UD(mQb(a, J$c)));
                                h = RD(mQb(a, H$c), 88);
                                E0c(a, h, f);
                                F0c(a, h, f, g);
                                D0c(a, h, f, g);
                                for(d = Sub(a.a, 0); d.b != d.d.c;){
                                    c = RD(evb(d), 65);
                                    c.a.b < 2 && H0c(c);
                                }
                            }
                            b.Vg();
                        }
                        function IKd(a) {
                            switch(a.d){
                                case 9:
                                case 8:
                                    return true;
                                case 3:
                                case 5:
                                case 4:
                                case 6:
                                    return false;
                                case 7:
                                    return RD(HKd(a), 17).a == a.o;
                                case 1:
                                case 2:
                                    if (a.o == -2) return false;
                                    else switch(a.p){
                                        case 0:
                                        case 1:
                                        case 2:
                                        case 6:
                                        case 5:
                                        case 7:
                                            return Gdb(a.k, a.f);
                                        case 3:
                                        case 4:
                                            return a.j == a.e;
                                        default:
                                            return a.n == null ? a.g == null : pb(a.n, a.g);
                                    }
                                default:
                                    return false;
                            }
                        }
                        function Grc(a, b) {
                            var c, d, e;
                            b.Ug('Breaking Point Insertion', 1);
                            d = new ysc(a);
                            switch(RD(mQb(a, (yCc(), rCc)), 351).g){
                                case 2:
                                    e = new Ksc;
                                    break;
                                case 0:
                                    e = new zrc;
                                    break;
                                default:
                                    e = new Nsc;
                            }
                            c = e.og(a, d);
                            Heb(TD(mQb(a, tCc))) && (c = Frc(a, c));
                            if (!e.pg() && nQb(a, xCc)) switch(RD(mQb(a, xCc), 352).g){
                                case 2:
                                    c = Wsc(d, c);
                                    break;
                                case 1:
                                    c = Usc(d, c);
                            }
                            if (c.dc()) {
                                b.Vg();
                                return;
                            }
                            Drc(a, c);
                            b.Vg();
                        }
                        function oJc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l;
                            f = new cnb(b.c.length);
                            for(j = new Anb(b); j.a < j.c.c.length;){
                                g = RD(ynb(j), 10);
                                Rmb(f, a.b[g.c.p][g.p]);
                            }
                            jJc(a, f, c);
                            l = null;
                            while(l = kJc(f))lJc(a, RD(l.a, 239), RD(l.b, 239), f);
                            b.c.length = 0;
                            for(e = new Anb(f); e.a < e.c.c.length;){
                                d = RD(ynb(e), 239);
                                for(h = d.d, i = 0, k = h.length; i < k; ++i){
                                    g = h[i];
                                    ZEb(b.c, g);
                                    a.a[g.c.p][g.p].a = pJc(d.g, d.d[0]).a;
                                }
                            }
                        }
                        function wnd(a) {
                            Cgd(a, new Pfd($fd(Xfd(Zfd(Yfd(new agd, pHe), 'ELK Fixed'), 'Keeps the current layout as it is, without any automatic modification. Optional coordinates can be given for nodes and edge bend points.'), new znd)));
                            Agd(a, pHe, Eze, tnd);
                            Agd(a, pHe, fEe, iGd(und));
                            Agd(a, pHe, QGe, iGd(ond));
                            Agd(a, pHe, jAe, iGd(pnd));
                            Agd(a, pHe, CAe, iGd(rnd));
                            Agd(a, pHe, hAe, iGd(qnd));
                        }
                        function Do(a, b, c) {
                            var d, e, f, g, h;
                            d = Ydb(Ndb(cwe, qgb(Ydb(Ndb(b == null ? 0 : tb(b), dwe)), 15)));
                            h = Ydb(Ndb(cwe, qgb(Ydb(Ndb(c == null ? 0 : tb(c), dwe)), 15)));
                            f = Go(a, b, d);
                            if (!!f && h == f.f && Hb(c, f.i)) return c;
                            g = Ho(a, c, h);
                            if (g) throw Adb(new agb('value already present: ' + c));
                            e = new kp(b, d, c, h);
                            if (f) {
                                yo(a, f);
                                Bo(a, e, f);
                                f.e = null;
                                f.c = null;
                                return f.i;
                            } else {
                                Bo(a, e, null);
                                Fo(a);
                                return null;
                            }
                        }
                        function V7b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o;
                            k = c.a.c;
                            g = c.a.c + c.a.b;
                            f = RD(Wjb(c.c, b), 468);
                            n = f.f;
                            o = f.a;
                            f.b ? i = new rjd(g, n) : i = new rjd(k, n);
                            f.c ? l = new rjd(k, o) : l = new rjd(g, o);
                            e = k;
                            c.p || (e += a.c);
                            e += c.F + c.v * a.b;
                            j = new rjd(e, n);
                            m = new rjd(e, o);
                            zjd(b.a, cD(WC(l3, 1), Nve, 8, 0, [
                                i,
                                j
                            ]));
                            h = c.d.a.gc() > 1;
                            if (h) {
                                d = new rjd(e, c.b);
                                Mub(b.a, d);
                            }
                            zjd(b.a, cD(WC(l3, 1), Nve, 8, 0, [
                                m,
                                l
                            ]));
                        }
                        function aEc() {
                            aEc = geb;
                            $Dc = new bEc(LAe, 0);
                            VDc = new bEc('NIKOLOV', 1);
                            YDc = new bEc('NIKOLOV_PIXEL', 2);
                            WDc = new bEc('NIKOLOV_IMPROVED', 3);
                            XDc = new bEc('NIKOLOV_IMPROVED_PIXEL', 4);
                            SDc = new bEc('DUMMYNODE_PERCENTAGE', 5);
                            ZDc = new bEc('NODECOUNT_PERCENTAGE', 6);
                            _Dc = new bEc('NO_BOUNDARY', 7);
                            TDc = new bEc('MODEL_ORDER_LEFT_TO_RIGHT', 8);
                            UDc = new bEc('MODEL_ORDER_RIGHT_TO_LEFT', 9);
                        }
                        function use(a) {
                            var b, c, d, e, f;
                            d = a.length;
                            b = new Rhb;
                            f = 0;
                            while(f < d){
                                c = ihb(a, f++);
                                if (c == 9 || c == 10 || c == 12 || c == 13 || c == 32) continue;
                                if (c == 35) {
                                    while(f < d){
                                        c = ihb(a, f++);
                                        if (c == 13 || c == 10) break;
                                    }
                                    continue;
                                }
                                if (c == 92 && f < d) {
                                    if ((e = (BFb(f, a.length), a.charCodeAt(f))) == 35 || e == 9 || e == 10 || e == 12 || e == 13 || e == 32) {
                                        Jhb(b, e & Bwe);
                                        ++f;
                                    } else {
                                        b.a += '\\';
                                        Jhb(b, e & Bwe);
                                        ++f;
                                    }
                                } else Jhb(b, c & Bwe);
                            }
                            return b.a;
                        }
                        function D4c() {
                            D4c = geb;
                            n4c = new lGd(oFe, (Geb(), false));
                            t4c = new lGd(pFe, sgb(0));
                            u4c = new lGd(qFe, 0);
                            v4c = new lGd(rFe, false);
                            q4c = (g4c(), d4c);
                            p4c = new lGd(sFe, q4c);
                            sgb(0);
                            o4c = new lGd(tFe, sgb(1));
                            A4c = (t5c(), r5c);
                            z4c = new lGd(uFe, A4c);
                            C4c = (Y3c(), X3c);
                            B4c = new lGd(vFe, C4c);
                            s4c = (j5c(), i5c);
                            r4c = new lGd(wFe, s4c);
                            y4c = new lGd(xFe, 0);
                            w4c = new lGd(yFe, false);
                            x4c = new lGd(zFe, false);
                        }
                        function t3c(a, b) {
                            var c, d, e;
                            for(d = new Anb(b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 27);
                                Rc(a.a, c, c);
                                Rc(a.b, c, c);
                                e = Q2c(c);
                                if (e.c.length != 0) {
                                    !!a.d && a.d.Gg(e);
                                    Rc(a.a, c, (tFb(0, e.c.length), RD(e.c[0], 27)));
                                    Rc(a.b, c, RD(Vmb(e, e.c.length - 1), 27));
                                    while(N2c(e).c.length != 0){
                                        e = N2c(e);
                                        !!a.d && a.d.Gg(e);
                                        Rc(a.a, c, (tFb(0, e.c.length), RD(e.c[0], 27)));
                                        Rc(a.b, c, RD(Vmb(e, e.c.length - 1), 27));
                                    }
                                }
                            }
                        }
                        function jwd(a, b, c) {
                            var d, e, f, g, h, i;
                            if (!b) return null;
                            else {
                                if (c <= -1) {
                                    d = vYd(b.Dh(), -1 - c);
                                    if (ZD(d, 102)) return RD(d, 19);
                                    else {
                                        g = RD(b.Mh(d), 160);
                                        for(h = 0, i = g.gc(); h < i; ++h)if (dE(g.Ul(h)) === dE(a)) {
                                            e = g.Tl(h);
                                            if (ZD(e, 102)) {
                                                f = RD(e, 19);
                                                if ((f.Bb & QHe) != 0) return f;
                                            }
                                        }
                                        throw Adb(new dgb('The containment feature could not be located'));
                                    }
                                } else return Z5d(RD(vYd(a.Dh(), c), 19));
                            }
                        }
                        function Lqc(a) {
                            var b, c, d, e, f, g, h, i, j, k;
                            c = 0;
                            for(h = new Anb(a.d); h.a < h.c.c.length;){
                                g = RD(ynb(h), 105);
                                !!g.i && (g.i.c = c++);
                            }
                            b = YC(xdb, [
                                Nve,
                                Hye
                            ], [
                                183,
                                28
                            ], 16, [
                                c,
                                c
                            ], 2);
                            k = a.d;
                            for(e = 0; e < k.c.length; e++){
                                i = (tFb(e, k.c.length), RD(k.c[e], 105));
                                if (i.i) for(f = e + 1; f < k.c.length; f++){
                                    j = (tFb(f, k.c.length), RD(k.c[f], 105));
                                    if (j.i) {
                                        d = Qqc(i, j);
                                        b[i.i.c][j.i.c] = d;
                                        b[j.i.c][i.i.c] = d;
                                    }
                                }
                            }
                            return b;
                        }
                        function u7c() {
                            u7c = geb;
                            m7c = new lGd(LFe, (Geb(), false));
                            sgb(-1);
                            f7c = new lGd(MFe, sgb(-1));
                            sgb(-1);
                            g7c = new lGd(NFe, sgb(-1));
                            h7c = new lGd(OFe, false);
                            s7c = (z8c(), x8c);
                            r7c = new lGd(PFe, s7c);
                            t7c = new lGd(QFe, -1);
                            q7c = (_6c(), $6c);
                            p7c = new lGd(RFe, q7c);
                            o7c = new lGd(SFe, true);
                            l7c = (b9c(), $8c);
                            k7c = new lGd(TFe, l7c);
                            j7c = new lGd(UFe, false);
                            sgb(1);
                            i7c = new lGd(VFe, sgb(1));
                            n7c = new jGd(WFe);
                        }
                        function WYc() {
                            WYc = geb;
                            VYc = new XYc('ROOT_PROC', 0);
                            OYc = new XYc('FAN_PROC', 1);
                            SYc = new XYc('LEVEL_PROC', 2);
                            TYc = new XYc('NEIGHBORS_PROC', 3);
                            RYc = new XYc('LEVEL_HEIGHT', 4);
                            NYc = new XYc('DIRECTION_PROC', 5);
                            UYc = new XYc('NODE_POSITION_PROC', 6);
                            LYc = new XYc('COMPACTION_PROC', 7);
                            QYc = new XYc('LEVEL_COORDS', 8);
                            PYc = new XYc('GRAPH_BOUNDS_PROC', 9);
                            MYc = new XYc('DETREEIFYING_PROC', 10);
                        }
                        function Fee(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            l = zYd(b);
                            j = null;
                            e = false;
                            for(h = 0, k = tYd(l.a).i; h < k; ++h){
                                g = RD(N_d(l, h, (f = RD(QHd(tYd(l.a), h), 89), i = f.c, ZD(i, 90) ? RD(i, 29) : (JTd(), zTd))), 29);
                                c = Fee(a, g);
                                if (!c.dc()) {
                                    if (!j) j = c;
                                    else {
                                        if (!e) {
                                            e = true;
                                            j = new PSd(j);
                                        }
                                        j.Gc(c);
                                    }
                                }
                            }
                            d = Kee(a, b);
                            if (d.dc()) return !j ? (yob(), yob(), vob) : j;
                            else {
                                if (!j) return d;
                                else {
                                    e || (j = new PSd(j));
                                    j.Gc(d);
                                    return j;
                                }
                            }
                        }
                        function Gee(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            l = zYd(b);
                            j = null;
                            d = false;
                            for(h = 0, k = tYd(l.a).i; h < k; ++h){
                                f = RD(N_d(l, h, (e = RD(QHd(tYd(l.a), h), 89), i = e.c, ZD(i, 90) ? RD(i, 29) : (JTd(), zTd))), 29);
                                c = Gee(a, f);
                                if (!c.dc()) {
                                    if (!j) j = c;
                                    else {
                                        if (!d) {
                                            d = true;
                                            j = new PSd(j);
                                        }
                                        j.Gc(c);
                                    }
                                }
                            }
                            g = Nee(a, b);
                            if (g.dc()) return !j ? (yob(), yob(), vob) : j;
                            else {
                                if (!j) return g;
                                else {
                                    d || (j = new PSd(j));
                                    j.Gc(g);
                                    return j;
                                }
                            }
                        }
                        function _fe(a, b, c) {
                            var d, e, f, g, h, i;
                            if (ZD(b, 76)) return rLd(a, b, c);
                            else {
                                h = null;
                                f = null;
                                d = RD(a.g, 124);
                                for(g = 0; g < a.i; ++g){
                                    e = d[g];
                                    if (pb(b, e.md())) {
                                        f = e.Lk();
                                        if (ZD(f, 102) && (RD(f, 19).Bb & QHe) != 0) {
                                            h = e;
                                            break;
                                        }
                                    }
                                }
                                if (h) {
                                    if (Mvd(a.e)) {
                                        i = f.Jk() ? fge(a, 4, f, b, null, kge(a, f, b, ZD(f, 102) && (RD(f, 19).Bb & txe) != 0), true) : fge(a, f.tk() ? 2 : 1, f, b, f.ik(), -1, true);
                                        c ? c.nj(i) : c = i;
                                    }
                                    c = _fe(a, h, c);
                                }
                                return c;
                            }
                        }
                        function yge(a, b, c) {
                            var d, e, f, g;
                            g = pke(a.e.Dh(), b);
                            d = RD(a.g, 124);
                            nke();
                            if (RD(b, 69).xk()) for(f = 0; f < a.i; ++f){
                                e = d[f];
                                if (g.am(e.Lk())) {
                                    if (pb(e, c)) {
                                        vLd(a, f);
                                        return true;
                                    }
                                }
                            }
                            else if (c != null) for(f = 0; f < a.i; ++f){
                                e = d[f];
                                if (g.am(e.Lk())) {
                                    if (pb(c, e.md())) {
                                        vLd(a, f);
                                        return true;
                                    }
                                }
                            }
                            else for(f = 0; f < a.i; ++f){
                                e = d[f];
                                if (g.am(e.Lk())) {
                                    if (e.md() == null) {
                                        vLd(a, f);
                                        return true;
                                    }
                                }
                            }
                            return false;
                        }
                        function xcc(a, b) {
                            var c, d, e, f, g;
                            b.Ug('Node and Port Label Placement and Node Sizing', 1);
                            DJb((i1b(), new t1b(a, true, true, new Acc)));
                            if (RD(mQb(a, (Ywc(), kwc)), 21).Hc((ovc(), hvc))) {
                                f = RD(mQb(a, (yCc(), EBc)), 21);
                                e = f.Hc((Pod(), Mod));
                                g = Heb(TD(mQb(a, FBc)));
                                for(d = new Anb(a.b); d.a < d.c.c.length;){
                                    c = RD(ynb(d), 30);
                                    FDb(CDb(new SDb(null, new Swb(c.a, 16)), new Ccc), new Ecc(f, e, g));
                                }
                            }
                            b.Vg();
                        }
                        function SHc(a, b) {
                            var c, d, e, f, g;
                            a.c == null || a.c.length < b.c.length ? a.c = $C(xdb, Hye, 28, b.c.length, 16, 1) : Nnb(a.c);
                            a.a = new bnb;
                            d = 0;
                            for(g = new Anb(b); g.a < g.c.c.length;){
                                e = RD(ynb(g), 10);
                                e.p = d++;
                            }
                            c = new Yub;
                            for(f = new Anb(b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 10);
                                if (!a.c[e.p]) {
                                    THc(a, e);
                                    c.b == 0 || (sFb(c.b != 0), RD(c.a.a.c, 15)).gc() < a.a.c.length ? Nub(c, a.a) : Oub(c, a.a);
                                    a.a = new bnb;
                                }
                            }
                            return c;
                        }
                        function Ucd(a) {
                            Cgd(a, new Pfd($fd(Xfd(Zfd(Yfd(new agd, uGe), 'ELK SPOrE Overlap Removal'), 'A node overlap removal algorithm proposed by Nachmanson et al. in "Node overlap removal by growing a tree".'), new Xcd)));
                            Agd(a, uGe, iGe, iGd(Scd));
                            Agd(a, uGe, Eze, Qcd);
                            Agd(a, uGe, _ze, 8);
                            Agd(a, uGe, nGe, iGd(Rcd));
                            Agd(a, uGe, qGe, iGd(Ocd));
                            Agd(a, uGe, rGe, iGd(Pcd));
                            Agd(a, uGe, LDe, (Geb(), false));
                        }
                        function Dee(a, b) {
                            var c, d, e, f, g, h, i;
                            c = b.qi(a.a);
                            if (c) {
                                i = WD($Nd((!c.b && (c.b = new SVd((JTd(), FTd), C8, c)), c.b), cLe));
                                if (i != null) {
                                    d = new bnb;
                                    for(f = vhb(i, '\\w'), g = 0, h = f.length; g < h; ++g){
                                        e = f[g];
                                        lhb(e, '##other') ? Rmb(d, '!##' + Uee(a, BXd(b.qk()))) : lhb(e, '##local') ? (d.c.push(null), undefined) : lhb(e, aLe) ? Rmb(d, Uee(a, BXd(b.qk()))) : ZEb(d.c, e);
                                    }
                                    return d;
                                }
                            }
                            return yob(), yob(), vob;
                        }
                        function u$b(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n;
                            g = Zid(b.c, c, d);
                            for(l = new Anb(b.a); l.a < l.c.c.length;){
                                k = RD(ynb(l), 10);
                                $id(k.n, g);
                                for(n = new Anb(k.j); n.a < n.c.c.length;){
                                    m = RD(ynb(n), 12);
                                    for(f = new Anb(m.g); f.a < f.c.c.length;){
                                        e = RD(ynb(f), 18);
                                        Cjd(e.a, g);
                                        h = RD(mQb(e, (yCc(), RAc)), 75);
                                        !!h && Cjd(h, g);
                                        for(j = new Anb(e.b); j.a < j.c.c.length;){
                                            i = RD(ynb(j), 72);
                                            $id(i.n, g);
                                        }
                                    }
                                }
                                Rmb(a.a, k);
                                k.a = a;
                            }
                        }
                        function wYb(a) {
                            var b, c, d, e, f, g, h, i;
                            if (a.d) throw Adb(new dgb((lfb(eQ), lye + eQ.k + mye)));
                            a.c == (Cmd(), Amd) && vYb(a, ymd);
                            for(c = new Anb(a.a.a); c.a < c.c.c.length;){
                                b = RD(ynb(c), 194);
                                b.e = 0;
                            }
                            for(g = new Anb(a.a.b); g.a < g.c.c.length;){
                                f = RD(ynb(g), 86);
                                f.o = pxe;
                                for(e = f.f.Kc(); e.Ob();){
                                    d = RD(e.Pb(), 86);
                                    ++d.d.e;
                                }
                            }
                            LYb(a);
                            for(i = new Anb(a.a.b); i.a < i.c.c.length;){
                                h = RD(ynb(i), 86);
                                h.k = true;
                            }
                            return a;
                        }
                        function mnc(a, b) {
                            var c, d, e, f, g, h, i, j;
                            h = new Vmc(a);
                            c = new Yub;
                            Pub(c, b, c.c.b, c.c);
                            while(c.b != 0){
                                d = RD(c.b == 0 ? null : (sFb(c.b != 0), Wub(c, c.a.a)), 113);
                                d.d.p = 1;
                                for(g = new Anb(d.e); g.a < g.c.c.length;){
                                    e = RD(ynb(g), 340);
                                    Qmc(h, e);
                                    j = e.d;
                                    j.d.p == 0 && Pub(c, j, c.c.b, c.c);
                                }
                                for(f = new Anb(d.b); f.a < f.c.c.length;){
                                    e = RD(ynb(f), 340);
                                    Qmc(h, e);
                                    i = e.c;
                                    i.d.p == 0 && Pub(c, i, c.c.b, c.c);
                                }
                            }
                            return h;
                        }
                        function ksd(a) {
                            var b, c, d, e, f;
                            d = Kfb(UD(Gxd(a, (umd(), Uld))));
                            if (d == 1) return;
                            zyd(a, d * a.g, d * a.f);
                            c = cr(hr((!a.c && (a.c = new C5d(K4, a, 9, 9)), a.c), new Lsd));
                            for(f = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                (!a.n && (a.n = new C5d(I4, a, 1, 7)), a.n),
                                (!a.c && (a.c = new C5d(K4, a, 9, 9)), a.c),
                                c
                            ]))); gs(f);){
                                e = RD(hs(f), 422);
                                e.qh(d * e.nh(), d * e.oh());
                                e.ph(d * e.mh(), d * e.lh());
                                b = RD(e.of(Fld), 8);
                                if (b) {
                                    b.a *= d;
                                    b.b *= d;
                                }
                            }
                        }
                        function Qfe(a, b, c) {
                            var d, e, f, g, h;
                            g = (nke(), RD(b, 69).xk());
                            if (qke(a.e, b)) {
                                if (b.Si() && dge(a, b, c, ZD(b, 102) && (RD(b, 19).Bb & txe) != 0)) return false;
                            } else {
                                h = pke(a.e.Dh(), b);
                                d = RD(a.g, 124);
                                for(f = 0; f < a.i; ++f){
                                    e = d[f];
                                    if (h.am(e.Lk())) {
                                        if (g ? pb(e, c) : c == null ? e.md() == null : pb(c, e.md())) return false;
                                        else {
                                            RD(eHd(a, f, g ? RD(c, 76) : oke(b, c)), 76);
                                            return true;
                                        }
                                    }
                                }
                            }
                            return WGd(a, g ? RD(c, 76) : oke(b, c));
                        }
                        function _dc(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m;
                            for(g = new Anb(a.b); g.a < g.c.c.length;){
                                f = RD(ynb(g), 30);
                                m = t2b(f.a);
                                for(j = m, k = 0, l = j.length; k < l; ++k){
                                    i = j[k];
                                    switch(RD(mQb(i, (yCc(), UAc)), 171).g){
                                        case 1:
                                            dec(i);
                                            g3b(i, b);
                                            aec(i, true, d);
                                            break;
                                        case 3:
                                            eec(i);
                                            g3b(i, c);
                                            aec(i, false, e);
                                    }
                                }
                            }
                            h = new Jkb(a.b, 0);
                            while(h.b < h.d.gc())(sFb(h.b < h.d.gc()), RD(h.d.Xb(h.c = h.b++), 30)).a.c.length == 0 && Ckb(h);
                        }
                        function mjb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
                            n = b.length;
                            i = n;
                            BFb(0, b.length);
                            if (b.charCodeAt(0) == 45) {
                                l = -1;
                                m = 1;
                                --n;
                            } else {
                                l = 1;
                                m = 0;
                            }
                            f = (xjb(), wjb)[10];
                            e = n / f | 0;
                            q = n % f;
                            q != 0 && ++e;
                            h = $C(kE, Pwe, 28, e, 15, 1);
                            c = vjb[8];
                            g = 0;
                            o = m + (q == 0 ? f : q);
                            for(p = m; p < i; p = o, o = p + f){
                                d = Oeb((AFb(p, o, b.length), b.substr(p, o - p)), qwe, lve);
                                j = (Ljb(), Pjb(h, h, g, c));
                                j += Fjb(h, g, d);
                                h[g++] = j;
                            }
                            k = g;
                            a.e = l;
                            a.d = k;
                            a.a = h;
                            Rib(a);
                        }
                        function bPb(a, b) {
                            var c, d, e, f;
                            c = new gPb;
                            d = RD(zDb(GDb(new SDb(null, new Swb(a.f, 16)), c), sBb(new _Bb, new bCb, new yCb, new ACb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), wBb),
                                vBb
                            ]))), 21);
                            e = d.gc();
                            d = RD(zDb(GDb(new SDb(null, new Swb(b.f, 16)), c), sBb(new _Bb, new bCb, new yCb, new ACb, cD(WC(QL, 1), jwe, 108, 0, [
                                wBb,
                                vBb
                            ]))), 21);
                            f = d.gc();
                            e = e == 1 ? 1 : 0;
                            f = f == 1 ? 1 : 0;
                            if (e < f) return -1;
                            if (e == f) return 0;
                            return 1;
                        }
                        function p0b(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m;
                            h = a.i;
                            e = Heb(TD(mQb(h, (yCc(), NAc))));
                            k = 0;
                            d = 0;
                            for(j = new Anb(a.g); j.a < j.c.c.length;){
                                i = RD(ynb(j), 18);
                                g = W0b(i);
                                f = g && e && Heb(TD(mQb(i, OAc)));
                                m = i.d.i;
                                g && f ? ++d : g && !f ? ++k : Y2b(m).e == h ? ++d : ++k;
                            }
                            for(c = new Anb(a.e); c.a < c.c.c.length;){
                                b = RD(ynb(c), 18);
                                g = W0b(b);
                                f = g && e && Heb(TD(mQb(b, OAc)));
                                l = b.c.i;
                                g && f ? ++k : g && !f ? ++d : Y2b(l).e == h ? ++k : ++d;
                            }
                            return k - d;
                        }
                        function sQc(a, b, c, d) {
                            this.e = a;
                            this.k = RD(mQb(a, (Ywc(), Qwc)), 312);
                            this.g = $C(jR, WAe, 10, b, 0, 1);
                            this.b = $C(VI, Nve, 345, b, 7, 1);
                            this.a = $C(jR, WAe, 10, b, 0, 1);
                            this.d = $C(VI, Nve, 345, b, 7, 1);
                            this.j = $C(jR, WAe, 10, b, 0, 1);
                            this.i = $C(VI, Nve, 345, b, 7, 1);
                            this.p = $C(VI, Nve, 345, b, 7, 1);
                            this.n = $C(QI, Nve, 485, b, 8, 1);
                            Mnb(this.n, (Geb(), false));
                            this.f = $C(QI, Nve, 485, b, 8, 1);
                            Mnb(this.f, true);
                            this.o = c;
                            this.c = d;
                        }
                        function mdc(a, b) {
                            var c, d, e, f, g, h;
                            if (b.dc()) return;
                            if (RD(b.Xb(0), 293).d == (btc(), $sc)) ddc(a, b);
                            else for(d = b.Kc(); d.Ob();){
                                c = RD(d.Pb(), 293);
                                switch(c.d.g){
                                    case 5:
                                        _cc(a, c, fdc(a, c));
                                        break;
                                    case 0:
                                        _cc(a, c, (g = c.f - c.c + 1, h = (g - 1) / 2 | 0, c.c + h));
                                        break;
                                    case 4:
                                        _cc(a, c, hdc(a, c));
                                        break;
                                    case 2:
                                        ndc(c);
                                        _cc(a, c, (f = jdc(c), f ? c.c : c.f));
                                        break;
                                    case 1:
                                        ndc(c);
                                        _cc(a, c, (e = jdc(c), e ? c.f : c.c));
                                }
                                edc(c.a);
                            }
                        }
                        function zt(a, b, c, d) {
                            var e, f, g;
                            g = new Hu(b, c);
                            if (!a.a) {
                                a.a = a.e = g;
                                Zjb(a.b, b, new Gu(g));
                                ++a.c;
                            } else if (!d) {
                                RD(Hvb(a.e), 511).b = g;
                                g.d = a.e;
                                a.e = g;
                                e = RD(Wjb(a.b, b), 260);
                                if (!e) {
                                    Zjb(a.b, b, e = new Gu(g));
                                    ++a.c;
                                } else {
                                    ++e.a;
                                    f = e.c;
                                    f.c = g;
                                    g.e = f;
                                    e.c = g;
                                }
                            } else {
                                e = RD(Hvb(RD(Wjb(a.b, b), 260)), 260);
                                ++e.a;
                                g.d = d.d;
                                g.e = d.e;
                                g.b = d;
                                g.c = d;
                                !d.e ? e.b = g : d.e.c = g;
                                !d.d ? a.a = g : d.d.b = g;
                                d.d = g;
                                d.e = g;
                            }
                            ++a.d;
                            return g;
                        }
                        function lJb(a, b) {
                            var c, d, e, f, g;
                            b.Ug('Network simplex', 1);
                            if (a.e.a.c.length < 1) {
                                b.Vg();
                                return;
                            }
                            for(f = new Anb(a.e.a); f.a < f.c.c.length;){
                                e = RD(ynb(f), 125);
                                e.e = 0;
                            }
                            g = a.e.a.c.length >= 40;
                            g && wJb(a);
                            nJb(a);
                            mJb(a);
                            c = qJb(a);
                            d = 0;
                            while(!!c && d < a.f){
                                kJb(a, c, jJb(a, c));
                                c = qJb(a);
                                ++d;
                            }
                            g && vJb(a);
                            a.a ? hJb(a, tJb(a)) : tJb(a);
                            a.b = null;
                            a.d = null;
                            a.p = null;
                            a.c = null;
                            a.g = null;
                            a.i = null;
                            a.n = null;
                            a.o = null;
                            b.Vg();
                        }
                        function T7b(a, b) {
                            var c, d, e, f, g, h, i;
                            if (b.e) return;
                            b.e = true;
                            for(d = b.d.a.ec().Kc(); d.Ob();){
                                c = RD(d.Pb(), 18);
                                if (b.o && b.d.a.gc() <= 1) {
                                    g = b.a.c;
                                    h = b.a.c + b.a.b;
                                    i = new rjd(g + (h - g) / 2, b.b);
                                    Mub(RD(b.d.a.ec().Kc().Pb(), 18).a, i);
                                    continue;
                                }
                                e = RD(Wjb(b.c, c), 468);
                                if (e.b || e.c) {
                                    V7b(a, c, b);
                                    continue;
                                }
                                f = a.d == (lFc(), kFc) && (e.d || e.e) && _7b(a, b) && b.d.a.gc() <= 1;
                                f ? W7b(c, b) : U7b(a, c, b);
                            }
                            b.k && xgb(b.d, new m8b);
                        }
                        function A5c(a, b, c, d, e, f) {
                            var g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            m = f;
                            h = (d + e) / 2 + m;
                            q = c * $wnd.Math.cos(h);
                            r = c * $wnd.Math.sin(h);
                            s = q - b.g / 2;
                            t = r - b.f / 2;
                            Dyd(b, s);
                            Eyd(b, t);
                            l = a.a.Eg(b);
                            p = 2 * $wnd.Math.acos(c / c + a.c);
                            if (p < e - d) {
                                n = p / l;
                                g = (d + e - p) / 2;
                            } else {
                                n = (e - d) / l;
                                g = d;
                            }
                            o = Q2c(b);
                            if (a.e) {
                                a.e.Fg(a.d);
                                a.e.Gg(o);
                            }
                            for(j = new Anb(o); j.a < j.c.c.length;){
                                i = RD(ynb(j), 27);
                                k = a.a.Eg(i);
                                A5c(a, i, c + a.c, g, g + n * k, f);
                                g += n * k;
                            }
                        }
                        function zA(a, b, c) {
                            var d;
                            d = c.q.getMonth();
                            switch(b){
                                case 5:
                                    Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        'J',
                                        'F',
                                        'M',
                                        'A',
                                        'M',
                                        'J',
                                        'J',
                                        'A',
                                        'S',
                                        'O',
                                        'N',
                                        'D'
                                    ])[d]);
                                    break;
                                case 4:
                                    Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        Cwe,
                                        Dwe,
                                        Ewe,
                                        Fwe,
                                        Gwe,
                                        Hwe,
                                        Iwe,
                                        Jwe,
                                        Kwe,
                                        Lwe,
                                        Mwe,
                                        Nwe
                                    ])[d]);
                                    break;
                                case 3:
                                    Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        'Jan',
                                        'Feb',
                                        'Mar',
                                        'Apr',
                                        Gwe,
                                        'Jun',
                                        'Jul',
                                        'Aug',
                                        'Sep',
                                        'Oct',
                                        'Nov',
                                        'Dec'
                                    ])[d]);
                                    break;
                                default:
                                    UA(a, d + 1, b);
                            }
                        }
                        function ATb(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m;
                            i = new rjd(c, d);
                            ojd(i, RD(mQb(b, (JVb(), GVb)), 8));
                            for(m = new Anb(b.e); m.a < m.c.c.length;){
                                l = RD(ynb(m), 153);
                                $id(l.d, i);
                                Rmb(a.e, l);
                            }
                            for(h = new Anb(b.c); h.a < h.c.c.length;){
                                g = RD(ynb(h), 290);
                                for(f = new Anb(g.a); f.a < f.c.c.length;){
                                    e = RD(ynb(f), 250);
                                    $id(e.d, i);
                                }
                                Rmb(a.c, g);
                            }
                            for(k = new Anb(b.d); k.a < k.c.c.length;){
                                j = RD(ynb(k), 454);
                                $id(j.d, i);
                                Rmb(a.d, j);
                            }
                        }
                        function TFc(a, b) {
                            var c, d, e, f, g, h, i, j;
                            for(i = new Anb(b.j); i.a < i.c.c.length;){
                                h = RD(ynb(i), 12);
                                for(e = new l4b(h.b); xnb(e.a) || xnb(e.b);){
                                    d = RD(xnb(e.a) ? ynb(e.a) : ynb(e.b), 18);
                                    c = d.c == h ? d.d : d.c;
                                    f = c.i;
                                    if (b == f) continue;
                                    j = RD(mQb(d, (yCc(), KBc)), 17).a;
                                    j < 0 && (j = 0);
                                    g = f.p;
                                    if (a.b[g] == 0) {
                                        if (d.d == c) {
                                            a.a[g] -= j + 1;
                                            a.a[g] <= 0 && a.c[g] > 0 && Mub(a.f, f);
                                        } else {
                                            a.c[g] -= j + 1;
                                            a.c[g] <= 0 && a.a[g] > 0 && Mub(a.e, f);
                                        }
                                    }
                                }
                            }
                        }
                        function FVc(a, b, c, d) {
                            var e, f, g, h, i, j, k;
                            i = new rjd(c, d);
                            ojd(i, RD(mQb(b, (q$c(), SZc)), 8));
                            for(k = Sub(b.b, 0); k.b != k.d.c;){
                                j = RD(evb(k), 40);
                                $id(j.e, i);
                                Mub(a.b, j);
                            }
                            for(h = RD(zDb(BDb(new SDb(null, new Swb(b.a, 16))), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), vBb)
                            ]))), 15).Kc(); h.Ob();){
                                g = RD(h.Pb(), 65);
                                for(f = Sub(g.a, 0); f.b != f.d.c;){
                                    e = RD(evb(f), 8);
                                    e.a += i.a;
                                    e.b += i.b;
                                }
                                Mub(a.a, g);
                            }
                        }
                        function kWc(a, b) {
                            var c, d, e, f;
                            if (0 < (ZD(a, 16) ? RD(a, 16).gc() : Kr(a.Kc()))) {
                                e = b;
                                if (1 < e) {
                                    --e;
                                    f = new uWc;
                                    for(d = a.Kc(); d.Ob();){
                                        c = RD(d.Pb(), 40);
                                        f = Al(cD(WC(cJ, 1), rve, 20, 0, [
                                            f,
                                            new dXc(c)
                                        ]));
                                    }
                                    return kWc(f, e);
                                }
                                if (e < 0) {
                                    f = new xWc;
                                    for(d = a.Kc(); d.Ob();){
                                        c = RD(d.Pb(), 40);
                                        f = Al(cD(WC(cJ, 1), rve, 20, 0, [
                                            f,
                                            new dXc(c)
                                        ]));
                                    }
                                    if (0 < (ZD(f, 16) ? RD(f, 16).gc() : Kr(f.Kc()))) return kWc(f, e);
                                }
                            }
                            return RD(Hr(a.Kc()), 40);
                        }
                        function v0c(a, b, c) {
                            var d, e, f, g;
                            c.Ug('Processor order nodes', 2);
                            a.b = Kfb(UD(mQb(b, (h_c(), _$c))));
                            a.a = RD(mQb(b, H$c), 88);
                            if (a.a == (Cmd(), Amd)) {
                                a.a = xmd;
                                pQb(b, H$c, a.a);
                            }
                            e = new Yub;
                            for(g = Sub(b.b, 0); g.b != g.d.c;){
                                f = RD(evb(g), 40);
                                Heb(TD(mQb(f, (q$c(), n$c)))) && Pub(e, f, e.c.b, e.c);
                            }
                            d = (sFb(e.b != 0), RD(e.a.a.c, 40));
                            t0c(a, d);
                            c.fh(1);
                            w0c(a, d, 0 - Kfb(UD(mQb(d, (q$c(), d$c)))) / 2, 0);
                            c.fh(1);
                            c.Vg();
                        }
                        function dqd() {
                            dqd = geb;
                            Ypd = new eqd('DEFAULT_MINIMUM_SIZE', 0);
                            $pd = new eqd('MINIMUM_SIZE_ACCOUNTS_FOR_PADDING', 1);
                            Xpd = new eqd('COMPUTE_PADDING', 2);
                            _pd = new eqd('OUTSIDE_NODE_LABELS_OVERHANG', 3);
                            aqd = new eqd('PORTS_OVERHANG', 4);
                            cqd = new eqd('UNIFORM_PORT_SPACING', 5);
                            bqd = new eqd('SPACE_EFFICIENT_PORT_LABELS', 6);
                            Zpd = new eqd('FORCE_TABULAR_NODE_LABELS', 7);
                            Wpd = new eqd('ASYMMETRICAL', 8);
                        }
                        function Rje(a, b) {
                            var c, d, e, f, g, h, i, j;
                            if (!b) return null;
                            else {
                                c = (f = b.Dh(), !f ? null : BXd(f).wi().si(f));
                                if (c) {
                                    dub(a, b, c);
                                    e = b.Dh();
                                    for(i = 0, j = (e.i == null && rYd(e), e.i).length; i < j; ++i){
                                        h = (d = (e.i == null && rYd(e), e.i), i >= 0 && i < d.length ? d[i] : null);
                                        if (h.rk() && !h.sk()) {
                                            if (ZD(h, 331)) Tje(a, RD(h, 35), b, c);
                                            else {
                                                g = RD(h, 19);
                                                (g.Bb & QHe) != 0 && Vje(a, g, b, c);
                                            }
                                        }
                                    }
                                    b.Vh() && RD(c, 54).ei(RD(b, 54)._h());
                                }
                                return c;
                            }
                        }
                        function kJb(a, b, c) {
                            var d, e, f;
                            if (!b.f) throw Adb(new agb('Given leave edge is no tree edge.'));
                            if (c.f) throw Adb(new agb('Given enter edge is a tree edge already.'));
                            b.f = false;
                            $sb(a.p, b);
                            c.f = true;
                            Ysb(a.p, c);
                            d = c.e.e - c.d.e - c.a;
                            oJb(a, c.e, b) || (d = -d);
                            for(f = new Anb(a.e.a); f.a < f.c.c.length;){
                                e = RD(ynb(f), 125);
                                oJb(a, e, b) || (e.e += d);
                            }
                            a.j = 1;
                            Nnb(a.c);
                            uJb(a, RD(ynb(new Anb(a.e.a)), 125));
                            iJb(a);
                        }
                        function wIc(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n;
                            BIc(a, b, c);
                            f = b[c];
                            n = d ? (qpd(), ppd) : (qpd(), Xod);
                            if (xIc(b.length, c, d)) {
                                e = b[d ? c - 1 : c + 1];
                                sIc(a, e, d ? (BEc(), zEc) : (BEc(), yEc));
                                for(i = f, k = 0, m = i.length; k < m; ++k){
                                    g = i[k];
                                    vIc(a, g, n);
                                }
                                sIc(a, f, d ? (BEc(), yEc) : (BEc(), zEc));
                                for(h = e, j = 0, l = h.length; j < l; ++j){
                                    g = h[j];
                                    !!g.e || vIc(a, g, spd(n));
                                }
                            } else for(h = f, j = 0, l = h.length; j < l; ++j){
                                g = h[j];
                                vIc(a, g, n);
                            }
                            return false;
                        }
                        function erd(a, b, c, d, e) {
                            var f, g, h, i, j, k, l;
                            yob();
                            _mb(a, new Urd);
                            h = new Jkb(a, 0);
                            l = new bnb;
                            f = 0;
                            while(h.b < h.d.gc()){
                                g = (sFb(h.b < h.d.gc()), RD(h.d.Xb(h.c = h.b++), 163));
                                if (l.c.length != 0 && urd(g) * trd(g) > f * 2) {
                                    k = new zrd(l);
                                    j = urd(g) / trd(g);
                                    i = ird(k, b, new z3b, c, d, e, j);
                                    $id(hjd(k.e), i);
                                    l.c.length = 0;
                                    f = 0;
                                    ZEb(l.c, k);
                                    ZEb(l.c, g);
                                    f = urd(k) * trd(k) + urd(g) * trd(g);
                                } else {
                                    ZEb(l.c, g);
                                    f += urd(g) * trd(g);
                                }
                            }
                            return l;
                        }
                        function O9b(a, b) {
                            var c, d, e, f, g, h;
                            h = RD(mQb(b, (yCc(), BBc)), 101);
                            if (!(h == (Bod(), xod) || h == wod)) return;
                            e = new rjd(b.f.a + b.d.b + b.d.c, b.f.b + b.d.d + b.d.a).b;
                            for(g = new Anb(a.a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 10);
                                if (f.k != (r3b(), m3b)) continue;
                                c = RD(mQb(f, (Ywc(), hwc)), 64);
                                if (c != (qpd(), Xod) && c != ppd) continue;
                                d = Kfb(UD(mQb(f, Jwc)));
                                h == xod && (d *= e);
                                f.n.b = d - RD(mQb(f, zBc), 8).b;
                                U2b(f, false, true);
                            }
                        }
                        function uge(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o;
                            if (Mvd(a.e)) {
                                if (b != c) {
                                    e = RD(a.g, 124);
                                    n = e[c];
                                    g = n.Lk();
                                    if (qke(a.e, g)) {
                                        o = pke(a.e.Dh(), g);
                                        i = -1;
                                        h = -1;
                                        d = 0;
                                        for(j = 0, l = b > c ? b : c; j <= l; ++j)if (j == c) h = d++;
                                        else {
                                            f = e[j];
                                            k = o.am(f.Lk());
                                            j == b && (i = j == l && !k ? d - 1 : d);
                                            k && ++d;
                                        }
                                        m = RD(uLd(a, b, c), 76);
                                        h != i && eZd(a, new c4d(a.e, 7, g, sgb(h), n.md(), i));
                                        return m;
                                    }
                                }
                            } else return RD(SHd(a, b, c), 76);
                            return RD(uLd(a, b, c), 76);
                        }
                        function ugc(a, b) {
                            var c, d, e, f, g, h, i;
                            b.Ug('Port order processing', 1);
                            i = RD(mQb(a, (yCc(), HBc)), 430);
                            for(d = new Anb(a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 30);
                                for(f = new Anb(c.a); f.a < f.c.c.length;){
                                    e = RD(ynb(f), 10);
                                    g = RD(mQb(e, BBc), 101);
                                    h = e.j;
                                    if (g == (Bod(), vod) || g == xod || g == wod) {
                                        yob();
                                        _mb(h, mgc);
                                    } else if (g != zod && g != Aod) {
                                        yob();
                                        _mb(h, pgc);
                                        wgc(h);
                                        i == (sEc(), rEc) && _mb(h, ogc);
                                    }
                                    e.i = true;
                                    V2b(e);
                                }
                            }
                            b.Vg();
                        }
                        function VHc(a) {
                            var b, c, d, e, f, g, h, i;
                            i = new Tsb;
                            b = new BIb;
                            for(g = a.Kc(); g.Ob();){
                                e = RD(g.Pb(), 10);
                                h = eJb(fJb(new gJb, e), b);
                                rtb(i.f, e, h);
                            }
                            for(f = a.Kc(); f.Ob();){
                                e = RD(f.Pb(), 10);
                                for(d = new is(Mr(a3b(e).a.Kc(), new ir)); gs(d);){
                                    c = RD(hs(d), 18);
                                    if (W0b(c)) continue;
                                    rIb(uIb(tIb(sIb(vIb(new wIb, $wnd.Math.max(1, RD(mQb(c, (yCc(), LBc)), 17).a)), 1), RD(Wjb(i, c.c.i), 125)), RD(Wjb(i, c.d.i), 125)));
                                }
                            }
                            return b;
                        }
                        function TRc() {
                            TRc = geb;
                            ORc = pfd(new ufd, (sXb(), qXb), (hcc(), Bbc));
                            QRc = pfd(new ufd, pXb, Fbc);
                            RRc = nfd(pfd(new ufd, pXb, Tbc), rXb, Sbc);
                            NRc = nfd(pfd(pfd(new ufd, pXb, vbc), qXb, wbc), rXb, xbc);
                            SRc = mfd(mfd(rfd(nfd(pfd(new ufd, nXb, bcc), rXb, acc), qXb), _bc), ccc);
                            PRc = nfd(new ufd, rXb, Cbc);
                            LRc = nfd(pfd(pfd(pfd(new ufd, oXb, Ibc), qXb, Kbc), qXb, Lbc), rXb, Jbc);
                            MRc = nfd(pfd(pfd(new ufd, qXb, Lbc), qXb, qbc), rXb, pbc);
                        }
                        function lD(a, b, c, d, e, f) {
                            var g, h, i, j, k, l, m;
                            j = oD(b) - oD(a);
                            g = AD(b, j);
                            i = hD(0, 0, 0);
                            while(j >= 0){
                                h = rD(a, g);
                                if (h) {
                                    j < 22 ? (i.l |= 1 << j, undefined) : j < 44 ? (i.m |= 1 << j - 22, undefined) : (i.h |= 1 << j - 44, undefined);
                                    if (a.l == 0 && a.m == 0 && a.h == 0) break;
                                }
                                k = g.m;
                                l = g.h;
                                m = g.l;
                                g.h = l >>> 1;
                                g.m = k >>> 1 | (l & 1) << 21;
                                g.l = m >>> 1 | (k & 1) << 21;
                                --j;
                            }
                            c && nD(i);
                            if (f) {
                                if (d) {
                                    eD = xD(a);
                                    e && (eD = DD(eD, (MD(), KD)));
                                } else eD = hD(a.l, a.m, a.h);
                            }
                            return i;
                        }
                        function rIc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            j = a.e[b.c.p][b.p] + 1;
                            i = b.c.a.c.length + 1;
                            for(h = new Anb(a.a); h.a < h.c.c.length;){
                                g = RD(ynb(h), 12);
                                l = 0;
                                f = 0;
                                for(e = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                    new T3b(g),
                                    new _3b(g)
                                ]))); gs(e);){
                                    d = RD(hs(e), 12);
                                    if (d.i.c == b.c) {
                                        l += AIc(a, d.i) + 1;
                                        ++f;
                                    }
                                }
                                c = l / f;
                                k = g.j;
                                k == (qpd(), Xod) ? c < j ? a.f[g.p] = a.c - c : a.f[g.p] = a.b + (i - c) : k == ppd && (c < j ? a.f[g.p] = a.b + c : a.f[g.p] = a.c - (i - c));
                            }
                        }
                        function Oeb(a, b, c) {
                            var d, e, f, g, h;
                            if (a == null) throw Adb(new Vgb(vve));
                            f = a.length;
                            g = f > 0 && (BFb(0, a.length), a.charCodeAt(0) == 45 || (BFb(0, a.length), a.charCodeAt(0) == 43)) ? 1 : 0;
                            for(d = g; d < f; d++){
                                if (dfb((BFb(d, a.length), a.charCodeAt(d))) == -1) throw Adb(new Vgb(nxe + a + '"'));
                            }
                            h = parseInt(a, 10);
                            e = h < b;
                            if (isNaN(h)) throw Adb(new Vgb(nxe + a + '"'));
                            else if (e || h > c) throw Adb(new Vgb(nxe + a + '"'));
                            return h;
                        }
                        function Jqc(a) {
                            var b, c, d, e, f, g, h;
                            g = new Yub;
                            for(f = new Anb(a.a); f.a < f.c.c.length;){
                                e = RD(ynb(f), 118);
                                PSc(e, e.f.c.length);
                                QSc(e, e.k.c.length);
                                if (e.i == 0) {
                                    e.o = 0;
                                    Pub(g, e, g.c.b, g.c);
                                }
                            }
                            while(g.b != 0){
                                e = RD(g.b == 0 ? null : (sFb(g.b != 0), Wub(g, g.a.a)), 118);
                                d = e.o + 1;
                                for(c = new Anb(e.f); c.a < c.c.c.length;){
                                    b = RD(ynb(c), 132);
                                    h = b.a;
                                    RSc(h, $wnd.Math.max(h.o, d));
                                    QSc(h, h.i - 1);
                                    h.i == 0 && Pub(g, h, g.c.b, g.c);
                                }
                            }
                        }
                        function Ged(a) {
                            var b, c, d, e, f, g, h, i;
                            for(g = new Anb(a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 74);
                                d = AGd(RD(QHd((!f.b && (f.b = new Yie(E4, f, 4, 7)), f.b), 0), 84));
                                h = d.i;
                                i = d.j;
                                e = RD(QHd((!f.a && (f.a = new C5d(F4, f, 6, 6)), f.a), 0), 166);
                                Nzd(e, e.j + h, e.k + i);
                                Gzd(e, e.b + h, e.c + i);
                                for(c = new dMd((!e.a && (e.a = new XZd(D4, e, 5)), e.a)); c.e != c.i.gc();){
                                    b = RD(bMd(c), 377);
                                    Uxd(b, b.a + h, b.b + i);
                                }
                                Bjd(RD(Gxd(f, (umd(), cld)), 75), h, i);
                            }
                        }
                        function Ere(a) {
                            var b;
                            switch(a){
                                case 100:
                                    return Jre(OLe, true);
                                case 68:
                                    return Jre(OLe, false);
                                case 119:
                                    return Jre(PLe, true);
                                case 87:
                                    return Jre(PLe, false);
                                case 115:
                                    return Jre(QLe, true);
                                case 83:
                                    return Jre(QLe, false);
                                case 99:
                                    return Jre(RLe, true);
                                case 67:
                                    return Jre(RLe, false);
                                case 105:
                                    return Jre(SLe, true);
                                case 73:
                                    return Jre(SLe, false);
                                default:
                                    throw Adb(new yz((b = a, NLe + b.toString(16))));
                            }
                        }
                        function b_b(a) {
                            var b, c, d, e, f;
                            e = RD(Vmb(a.a, 0), 10);
                            b = new j3b(a);
                            Rmb(a.a, b);
                            b.o.a = $wnd.Math.max(1, e.o.a);
                            b.o.b = $wnd.Math.max(1, e.o.b);
                            b.n.a = e.n.a;
                            b.n.b = e.n.b;
                            switch(RD(mQb(e, (Ywc(), hwc)), 64).g){
                                case 4:
                                    b.n.a += 2;
                                    break;
                                case 1:
                                    b.n.b += 2;
                                    break;
                                case 2:
                                    b.n.a -= 2;
                                    break;
                                case 3:
                                    b.n.b -= 2;
                            }
                            d = new R3b;
                            P3b(d, b);
                            c = new a1b;
                            f = RD(Vmb(e.j, 0), 12);
                            Y0b(c, f);
                            Z0b(c, d);
                            $id(hjd(d.n), f.n);
                            $id(hjd(d.a), f.a);
                            return b;
                        }
                        function Wdc(a, b, c, d, e) {
                            if (c && (!d || (a.c - a.b & a.a.length - 1) > 1) && b == 1 && RD(a.a[a.b], 10).k == (r3b(), n3b)) Qdc(RD(a.a[a.b], 10), (Pnd(), Lnd));
                            else if (d && (!c || (a.c - a.b & a.a.length - 1) > 1) && b == 1 && RD(a.a[a.c - 1 & a.a.length - 1], 10).k == (r3b(), n3b)) Qdc(RD(a.a[a.c - 1 & a.a.length - 1], 10), (Pnd(), Mnd));
                            else if ((a.c - a.b & a.a.length - 1) == 2) {
                                Qdc(RD(omb(a), 10), (Pnd(), Lnd));
                                Qdc(RD(omb(a), 10), Mnd);
                            } else Ndc(a, e);
                            jmb(a);
                        }
                        function QVc(a, b, c) {
                            var d, e, f, g, h;
                            f = 0;
                            for(e = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); e.e != e.i.gc();){
                                d = RD(bMd(e), 27);
                                g = '';
                                (!d.n && (d.n = new C5d(I4, d, 1, 7)), d.n).i == 0 || (g = RD(QHd((!d.n && (d.n = new C5d(I4, d, 1, 7)), d.n), 0), 135).a);
                                h = new bXc(f++, b, g);
                                kQb(h, d);
                                pQb(h, (q$c(), h$c), d);
                                h.e.b = d.j + d.f / 2;
                                h.f.a = $wnd.Math.max(d.g, 1);
                                h.e.a = d.i + d.g / 2;
                                h.f.b = $wnd.Math.max(d.f, 1);
                                Mub(b.b, h);
                                rtb(c.f, d, h);
                            }
                        }
                        function L5b(a) {
                            var b, c, d, e, f;
                            d = RD(mQb(a, (Ywc(), Awc)), 27);
                            f = RD(Gxd(d, (yCc(), lBc)), 181).Hc((Qpd(), Ppd));
                            if (!a.e) {
                                e = RD(mQb(a, kwc), 21);
                                b = new rjd(a.f.a + a.d.b + a.d.c, a.f.b + a.d.d + a.d.a);
                                if (e.Hc((ovc(), hvc))) {
                                    Ixd(d, BBc, (Bod(), wod));
                                    Esd(d, b.a, b.b, false, true);
                                } else Heb(TD(Gxd(d, mBc))) || Esd(d, b.a, b.b, true, true);
                            }
                            f ? Ixd(d, lBc, xsb(Ppd)) : Ixd(d, lBc, (c = RD(mfb(H3), 9), new Fsb(c, RD(WEb(c, c.length), 9), 0)));
                        }
                        function JA(a, b, c) {
                            var d, e, f, g;
                            if (b[0] >= a.length) {
                                c.o = 0;
                                return true;
                            }
                            switch(ihb(a, b[0])){
                                case 43:
                                    e = 1;
                                    break;
                                case 45:
                                    e = -1;
                                    break;
                                default:
                                    c.o = 0;
                                    return true;
                            }
                            ++b[0];
                            f = b[0];
                            g = HA(a, b);
                            if (g == 0 && b[0] == f) return false;
                            if (b[0] < a.length && ihb(a, b[0]) == 58) {
                                d = g * 60;
                                ++b[0];
                                f = b[0];
                                g = HA(a, b);
                                if (g == 0 && b[0] == f) return false;
                                d += g;
                            } else {
                                d = g;
                                d < 24 && b[0] - f <= 2 ? d *= 60 : d = d % 100 + (d / 100 | 0) * 60;
                            }
                            d *= e;
                            c.o = -d;
                            return true;
                        }
                        function lnc(a) {
                            var b, c, d, e, f, g, h, i, j;
                            g = new bnb;
                            for(d = new is(Mr(a3b(a.b).a.Kc(), new ir)); gs(d);){
                                c = RD(hs(d), 18);
                                W0b(c) && Rmb(g, new knc(c, nnc(a, c.c), nnc(a, c.d)));
                            }
                            for(j = (f = new glb(a.e).a.vc().Kc(), new llb(f)); j.a.Ob();){
                                h = (b = RD(j.a.Pb(), 44), RD(b.md(), 113));
                                h.d.p = 0;
                            }
                            for(i = (e = new glb(a.e).a.vc().Kc(), new llb(e)); i.a.Ob();){
                                h = (b = RD(i.a.Pb(), 44), RD(b.md(), 113));
                                h.d.p == 0 && Rmb(a.d, mnc(a, h));
                            }
                        }
                        function e5b(a) {
                            var b, c, d, e, f, g, h;
                            f = MCd(a);
                            for(e = new dMd((!a.e && (a.e = new Yie(G4, a, 7, 4)), a.e)); e.e != e.i.gc();){
                                d = RD(bMd(e), 74);
                                h = AGd(RD(QHd((!d.c && (d.c = new Yie(E4, d, 5, 8)), d.c), 0), 84));
                                if (!NGd(h, f)) return true;
                            }
                            for(c = new dMd((!a.d && (a.d = new Yie(G4, a, 8, 5)), a.d)); c.e != c.i.gc();){
                                b = RD(bMd(c), 74);
                                g = AGd(RD(QHd((!b.b && (b.b = new Yie(E4, b, 4, 7)), b.b), 0), 84));
                                if (!NGd(g, f)) return true;
                            }
                            return false;
                        }
                        function jRc(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            for(g = new Anb(b.b); g.a < g.c.c.length;){
                                f = RD(ynb(g), 30);
                                for(j = new Anb(f.a); j.a < j.c.c.length;){
                                    i = RD(ynb(j), 10);
                                    k = new bnb;
                                    h = 0;
                                    for(d = new is(Mr(Z2b(i).a.Kc(), new ir)); gs(d);){
                                        c = RD(hs(d), 18);
                                        if (W0b(c) || !W0b(c) && c.c.i.c == c.d.i.c) continue;
                                        e = RD(mQb(c, (yCc(), MBc)), 17).a;
                                        if (e > h) {
                                            h = e;
                                            k.c.length = 0;
                                        }
                                        e == h && Rmb(k, new Ptd(c.c.i, c));
                                    }
                                    yob();
                                    _mb(k, a.c);
                                    Qmb(a.b, i.p, k);
                                }
                            }
                        }
                        function kRc(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            for(g = new Anb(b.b); g.a < g.c.c.length;){
                                f = RD(ynb(g), 30);
                                for(j = new Anb(f.a); j.a < j.c.c.length;){
                                    i = RD(ynb(j), 10);
                                    k = new bnb;
                                    h = 0;
                                    for(d = new is(Mr(a3b(i).a.Kc(), new ir)); gs(d);){
                                        c = RD(hs(d), 18);
                                        if (W0b(c) || !W0b(c) && c.c.i.c == c.d.i.c) continue;
                                        e = RD(mQb(c, (yCc(), MBc)), 17).a;
                                        if (e > h) {
                                            h = e;
                                            k.c.length = 0;
                                        }
                                        e == h && Rmb(k, new Ptd(c.d.i, c));
                                    }
                                    yob();
                                    _mb(k, a.c);
                                    Qmb(a.f, i.p, k);
                                }
                            }
                        }
                        function HVc(a, b) {
                            var c, d, e, f, g, h, i, j;
                            j = TD(mQb(b, (h_c(), Z$c)));
                            if (j == null || (uFb(j), j)) {
                                EVc(a, b);
                                e = new bnb;
                                for(i = Sub(b.b, 0); i.b != i.d.c;){
                                    g = RD(evb(i), 40);
                                    c = DVc(a, g, null);
                                    if (c) {
                                        kQb(c, b);
                                        ZEb(e.c, c);
                                    }
                                }
                                a.a = null;
                                a.b = null;
                                if (e.c.length > 1) for(d = new Anb(e); d.a < d.c.c.length;){
                                    c = RD(ynb(d), 121);
                                    f = 0;
                                    for(h = Sub(c.b, 0); h.b != h.d.c;){
                                        g = RD(evb(h), 40);
                                        g.g = f++;
                                    }
                                }
                                return e;
                            }
                            return dv(cD(WC(W$, 1), Jze, 121, 0, [
                                b
                            ]));
                        }
                        function hqc(a) {
                            var b, c, d, e, f, g, h, i;
                            i = new Ejd;
                            b = Sub(a, 0);
                            h = null;
                            c = RD(evb(b), 8);
                            e = RD(evb(b), 8);
                            while(b.b != b.d.c){
                                h = c;
                                c = e;
                                e = RD(evb(b), 8);
                                f = iqc(ojd(new rjd(h.a, h.b), c));
                                g = iqc(ojd(new rjd(e.a, e.b), c));
                                d = 10;
                                d = $wnd.Math.min(d, $wnd.Math.abs(f.a + f.b) / 2);
                                d = $wnd.Math.min(d, $wnd.Math.abs(g.a + g.b) / 2);
                                f.a = Lgb(f.a) * d;
                                f.b = Lgb(f.b) * d;
                                g.a = Lgb(g.a) * d;
                                g.b = Lgb(g.b) * d;
                                Mub(i, $id(f, c));
                                Mub(i, $id(g, c));
                            }
                            return i;
                        }
                        function wKc(a, b, c) {
                            var d, e, f, g, h, i;
                            c.Ug('Minimize Crossings ' + a.a, 1);
                            d = b.b.c.length == 0 || !QDb(CDb(new SDb(null, new Swb(b.b, 16)), new PAb(new XKc))).Bd((xDb(), wDb));
                            i = b.b.c.length == 1 && RD(Vmb(b.b, 0), 30).a.c.length == 1;
                            f = dE(mQb(b, (yCc(), IAc))) === dE((Fnd(), Cnd));
                            if (d || i && !f) {
                                c.Vg();
                                return;
                            }
                            e = rKc(a, b);
                            g = (h = RD(ju(e, 0), 219), h.c.kg() ? h.c.eg() ? new KKc(a) : new MKc(a) : new IKc(a));
                            sKc(e, g);
                            EKc(a);
                            c.Vg();
                        }
                        function xvd(a, b, c, d) {
                            var e, f, g, h, i;
                            g = a.Ph();
                            i = a.Jh();
                            e = null;
                            if (i) {
                                if (!!b && (jwd(a, b, c).Bb & txe) == 0) {
                                    d = rLd(i.El(), a, d);
                                    a.di(null);
                                    e = b.Qh();
                                } else i = null;
                            } else {
                                !!g && (i = g.Qh());
                                !!b && (e = b.Qh());
                            }
                            i != e && !!i && i.Il(a);
                            h = a.Fh();
                            a.Bh(b, c);
                            i != e && !!e && e.Hl(a);
                            if (a.vh() && a.wh()) {
                                if (!!g && h >= 0 && h != c) {
                                    f = new N3d(a, 1, h, g, null);
                                    !d ? d = f : d.nj(f);
                                }
                                if (c >= 0) {
                                    f = new N3d(a, 1, c, h == c ? g : null, b);
                                    !d ? d = f : d.nj(f);
                                }
                            }
                            return d;
                        }
                        function jSd(a) {
                            var b, c, d;
                            if (a.b == null) {
                                d = new Qhb;
                                if (a.i != null) {
                                    Nhb(d, a.i);
                                    d.a += ':';
                                }
                                if ((a.f & 256) != 0) {
                                    if ((a.f & 256) != 0 && a.a != null) {
                                        wSd(a.i) || (d.a += '//', d);
                                        Nhb(d, a.a);
                                    }
                                    if (a.d != null) {
                                        d.a += '/';
                                        Nhb(d, a.d);
                                    }
                                    (a.f & 16) != 0 && (d.a += '/', d);
                                    for(b = 0, c = a.j.length; b < c; b++){
                                        b != 0 && (d.a += '/', d);
                                        Nhb(d, a.j[b]);
                                    }
                                    if (a.g != null) {
                                        d.a += '?';
                                        Nhb(d, a.g);
                                    }
                                } else Nhb(d, a.a);
                                if (a.e != null) {
                                    d.a += '#';
                                    Nhb(d, a.e);
                                }
                                a.b = d.a;
                            }
                            return a.b;
                        }
                        function V8b(a, b) {
                            var c, d, e, f, g, h;
                            for(e = new Anb(b.a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 10);
                                f = mQb(d, (Ywc(), Awc));
                                if (ZD(f, 12)) {
                                    g = RD(f, 12);
                                    h = j2b(b, d, g.o.a, g.o.b);
                                    g.n.a = h.a;
                                    g.n.b = h.b;
                                    Q3b(g, RD(mQb(d, hwc), 64));
                                }
                            }
                            c = new rjd(b.f.a + b.d.b + b.d.c, b.f.b + b.d.d + b.d.a);
                            if (RD(mQb(b, (Ywc(), kwc)), 21).Hc((ovc(), hvc))) {
                                pQb(a, (yCc(), BBc), (Bod(), wod));
                                RD(mQb(Y2b(a), kwc), 21).Fc(kvc);
                                r2b(a, c, false);
                            } else r2b(a, c, true);
                        }
                        function Ffc(a, b, c, d, e) {
                            var f, g, h, i;
                            f = new j3b(a);
                            h3b(f, (r3b(), q3b));
                            pQb(f, (yCc(), BBc), (Bod(), wod));
                            pQb(f, (Ywc(), Awc), b.c.i);
                            g = new R3b;
                            pQb(g, Awc, b.c);
                            Q3b(g, e);
                            P3b(g, f);
                            pQb(b.c, Iwc, f);
                            h = new j3b(a);
                            h3b(h, q3b);
                            pQb(h, BBc, wod);
                            pQb(h, Awc, b.d.i);
                            i = new R3b;
                            pQb(i, Awc, b.d);
                            Q3b(i, e);
                            P3b(i, h);
                            pQb(b.d, Iwc, h);
                            Y0b(b, g);
                            Z0b(b, i);
                            wFb(0, c.c.length);
                            XEb(c.c, 0, f);
                            ZEb(d.c, h);
                            pQb(f, $vc, sgb(1));
                            pQb(h, $vc, sgb(1));
                        }
                        function Eo(a, b, c, d) {
                            var e, f, g, h, i;
                            i = Ydb(Ndb(cwe, qgb(Ydb(Ndb(b == null ? 0 : tb(b), dwe)), 15)));
                            e = Ydb(Ndb(cwe, qgb(Ydb(Ndb(c == null ? 0 : tb(c), dwe)), 15)));
                            h = Ho(a, b, i);
                            g = Go(a, c, e);
                            if (!!h && e == h.a && Hb(c, h.g)) return c;
                            else if (!!g && !d) throw Adb(new agb('key already present: ' + c));
                            !!h && yo(a, h);
                            !!g && yo(a, g);
                            f = new kp(c, e, b, i);
                            Bo(a, f, g);
                            if (g) {
                                g.e = null;
                                g.c = null;
                            }
                            if (h) {
                                h.e = null;
                                h.c = null;
                            }
                            Fo(a);
                            return !h ? null : h.g;
                        }
                        function Tjb(a, b, c) {
                            var d, e, f, g, h;
                            for(f = 0; f < b; f++){
                                d = 0;
                                for(h = f + 1; h < b; h++){
                                    d = Bdb(Bdb(Ndb(Cdb(a[f], yxe), Cdb(a[h], yxe)), Cdb(c[f + h], yxe)), Cdb(Ydb(d), yxe));
                                    c[f + h] = Ydb(d);
                                    d = Udb(d, 32);
                                }
                                c[f + b] = Ydb(d);
                            }
                            sjb(c, c, b << 1);
                            d = 0;
                            for(e = 0, g = 0; e < b; ++e, g++){
                                d = Bdb(Bdb(Ndb(Cdb(a[e], yxe), Cdb(a[e], yxe)), Cdb(c[g], yxe)), Cdb(Ydb(d), yxe));
                                c[g] = Ydb(d);
                                d = Udb(d, 32);
                                ++g;
                                d = Bdb(d, Cdb(c[g], yxe));
                                c[g] = Ydb(d);
                                d = Udb(d, 32);
                            }
                            return c;
                        }
                        function xOc(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            if (gr(b)) return;
                            i = Kfb(UD(hFc(c.c, (yCc(), fCc))));
                            j = RD(hFc(c.c, eCc), 140);
                            !j && (j = new P2b);
                            d = c.a;
                            e = null;
                            for(h = b.Kc(); h.Ob();){
                                g = RD(h.Pb(), 12);
                                k = 0;
                                if (!e) k = j.d;
                                else {
                                    k = i;
                                    k += e.o.b;
                                }
                                f = eJb(fJb(new gJb, g), a.f);
                                Zjb(a.k, g, f);
                                rIb(uIb(tIb(sIb(vIb(new wIb, 0), eE($wnd.Math.ceil(k))), d), f));
                                e = g;
                                d = f;
                            }
                            rIb(uIb(tIb(sIb(vIb(new wIb, 0), eE($wnd.Math.ceil(j.a + e.o.b))), d), c.d));
                        }
                        function K8c(a, b, c, d, e, f, g, h) {
                            var i, j, k, l, m, n;
                            n = false;
                            m = f - c.s;
                            k = c.t - b.f + (j = S9c(c, m, false), j.a);
                            if (d.g + h > m) return false;
                            l = (i = S9c(d, m, false), i.a);
                            if (k + h + l <= b.b) {
                                Q9c(c, f - c.s);
                                c.c = true;
                                Q9c(d, f - c.s);
                                U9c(d, c.s, c.t + c.d + h);
                                d.k = true;
                                aad(c.q, d);
                                n = true;
                                if (e) {
                                    Cad(b, d);
                                    d.j = b;
                                    if (a.c.length > g) {
                                        Fad((tFb(g, a.c.length), RD(a.c[g], 186)), d);
                                        (tFb(g, a.c.length), RD(a.c[g], 186)).a.c.length == 0 && Xmb(a, g);
                                    }
                                }
                            }
                            return n;
                        }
                        function Qfc(a, b) {
                            var c, d, e, f, g, h;
                            b.Ug('Partition midprocessing', 1);
                            e = new Tp;
                            FDb(CDb(new SDb(null, new Swb(a.a, 16)), new Ufc), new Wfc(e));
                            if (e.d == 0) return;
                            h = RD(zDb(ODb((f = e.i, new SDb(null, (!f ? e.i = new zf(e, e.c) : f).Nc()))), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), vBb)
                            ]))), 15);
                            d = h.Kc();
                            c = RD(d.Pb(), 17);
                            while(d.Ob()){
                                g = RD(d.Pb(), 17);
                                Pfc(RD(Qc(e, c), 21), RD(Qc(e, g), 21));
                                c = g;
                            }
                            b.Vg();
                        }
                        function G_b(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            if (b.p == 0) {
                                b.p = 1;
                                g = c;
                                if (!g) {
                                    e = new bnb;
                                    f = (d = RD(mfb(E3), 9), new Fsb(d, RD(WEb(d, d.length), 9), 0));
                                    g = new Ptd(e, f);
                                }
                                RD(g.a, 15).Fc(b);
                                b.k == (r3b(), m3b) && RD(g.b, 21).Fc(RD(mQb(b, (Ywc(), hwc)), 64));
                                for(i = new Anb(b.j); i.a < i.c.c.length;){
                                    h = RD(ynb(i), 12);
                                    for(k = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                        new T3b(h),
                                        new _3b(h)
                                    ]))); gs(k);){
                                        j = RD(hs(k), 12);
                                        G_b(a, j.i, g);
                                    }
                                }
                                return g;
                            }
                            return null;
                        }
                        function bAd(a, b) {
                            var c, d, e, f, g;
                            if (a.Ab) {
                                if (a.Ab) {
                                    g = a.Ab.i;
                                    if (g > 0) {
                                        e = RD(a.Ab.g, 2033);
                                        if (b == null) for(f = 0; f < g; ++f){
                                            c = e[f];
                                            if (c.d == null) return c;
                                        }
                                        else for(f = 0; f < g; ++f){
                                            c = e[f];
                                            if (lhb(b, c.d)) return c;
                                        }
                                    }
                                } else {
                                    if (b == null) for(d = new dMd(a.Ab); d.e != d.i.gc();){
                                        c = RD(bMd(d), 598);
                                        if (c.d == null) return c;
                                    }
                                    else for(d = new dMd(a.Ab); d.e != d.i.gc();){
                                        c = RD(bMd(d), 598);
                                        if (lhb(b, c.d)) return c;
                                    }
                                }
                            }
                            return null;
                        }
                        function RDd(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n, p, q, r, s, t, u, v;
                            n = qEd(a, EGd(b), e);
                            Jzd(n, zDd(e, uIe));
                            o = null;
                            p = e;
                            q = yDd(p, xIe);
                            r = new UEd(n);
                            WDd(r.a, q);
                            s = yDd(p, 'endPoint');
                            t = new YEd(n);
                            YDd(t.a, s);
                            u = wDd(p, nIe);
                            v = new _Ed(n);
                            ZDd(v.a, u);
                            l = zDd(e, pIe);
                            f = new QEd(a, n);
                            SDd(f.a, f.b, l);
                            m = zDd(e, oIe);
                            g = new REd(a, n);
                            TDd(g.a, g.b, m);
                            j = wDd(e, rIe);
                            h = new SEd(c, n);
                            UDd(h.b, h.a, j);
                            k = wDd(e, qIe);
                            i = new TEd(d, n);
                            VDd(i.b, i.a, k);
                        }
                        function q2b(a, b, c) {
                            var d, e, f, g, h;
                            h = null;
                            switch(b.g){
                                case 1:
                                    for(e = new Anb(a.j); e.a < e.c.c.length;){
                                        d = RD(ynb(e), 12);
                                        if (Heb(TD(mQb(d, (Ywc(), mwc))))) return d;
                                    }
                                    h = new R3b;
                                    pQb(h, (Ywc(), mwc), (Geb(), true));
                                    break;
                                case 2:
                                    for(g = new Anb(a.j); g.a < g.c.c.length;){
                                        f = RD(ynb(g), 12);
                                        if (Heb(TD(mQb(f, (Ywc(), Gwc))))) return f;
                                    }
                                    h = new R3b;
                                    pQb(h, (Ywc(), Gwc), (Geb(), true));
                            }
                            if (h) {
                                P3b(h, a);
                                Q3b(h, c);
                                d2b(h.n, a.o, c);
                            }
                            return h;
                        }
                        function d7b(a, b) {
                            var c, d, e, f, g, h;
                            h = -1;
                            g = new Yub;
                            for(d = new l4b(a.b); xnb(d.a) || xnb(d.b);){
                                c = RD(xnb(d.a) ? ynb(d.a) : ynb(d.b), 18);
                                h = $wnd.Math.max(h, Kfb(UD(mQb(c, (yCc(), FAc)))));
                                c.c == a ? FDb(CDb(new SDb(null, new Swb(c.b, 16)), new j7b), new l7b(g)) : FDb(CDb(new SDb(null, new Swb(c.b, 16)), new n7b), new p7b(g));
                                for(f = Sub(g, 0); f.b != f.d.c;){
                                    e = RD(evb(f), 72);
                                    nQb(e, (Ywc(), dwc)) || pQb(e, dwc, c);
                                }
                                Tmb(b, g);
                                Xub(g);
                            }
                            return h;
                        }
                        function _Tc(a, b, c, d, e) {
                            var f, g, h, i, j;
                            h = e ? d.b : d.a;
                            if (Zsb(a.a, d)) return;
                            j = h > c.s && h < c.c;
                            i = false;
                            if (c.e.b != 0 && c.j.b != 0) {
                                i = i | ($wnd.Math.abs(h - Kfb(UD(Qub(c.e)))) < Vze && $wnd.Math.abs(h - Kfb(UD(Qub(c.j)))) < Vze);
                                i = i | ($wnd.Math.abs(h - Kfb(UD(Rub(c.e)))) < Vze && $wnd.Math.abs(h - Kfb(UD(Rub(c.j)))) < Vze);
                            }
                            if (j || i) {
                                g = RD(mQb(b, (yCc(), RAc)), 75);
                                if (!g) {
                                    g = new Ejd;
                                    pQb(b, RAc, g);
                                }
                                f = new sjd(d);
                                Pub(g, f, g.c.b, g.c);
                                Ysb(a.a, f);
                            }
                        }
                        function ZPb(a, b, c, d) {
                            var e, f, g, h, i, j, k;
                            if (YPb(a, b, c, d)) return true;
                            else for(g = new Anb(b.f); g.a < g.c.c.length;){
                                f = RD(ynb(g), 334);
                                h = false;
                                i = a.j - b.j + c;
                                j = i + b.o;
                                k = a.k - b.k + d;
                                e = k + b.p;
                                switch(f.a.g){
                                    case 0:
                                        h = fQb(a, i + f.b.a, 0, i + f.c.a, k - 1);
                                        break;
                                    case 1:
                                        h = fQb(a, j, k + f.b.a, a.o - 1, k + f.c.a);
                                        break;
                                    case 2:
                                        h = fQb(a, i + f.b.a, e, i + f.c.a, a.p - 1);
                                        break;
                                    default:
                                        h = fQb(a, 0, k + f.b.a, i - 1, k + f.c.a);
                                }
                                if (h) return true;
                            }
                            return false;
                        }
                        function yZc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l;
                            c.Ug('Processor set coordinates', 1);
                            a.a = b.b.b == 0 ? 1 : b.b.b;
                            j = null;
                            d = Sub(b.b, 0);
                            while(!j && d.b != d.d.c){
                                l = RD(evb(d), 40);
                                if (Heb(TD(mQb(l, (q$c(), n$c))))) {
                                    j = l;
                                    i = l.e;
                                    i.a = RD(mQb(l, o$c), 17).a;
                                    i.b = RD(mQb(l, p$c), 17).a;
                                }
                            }
                            h = $Wc(j);
                            k = 1;
                            do {
                                h = zZc((e = h, c.eh(k), e));
                                k = h.b / a.a | 0;
                            }while (h.b != 0);
                            for(g = Sub(b.b, 0); g.b != g.d.c;){
                                f = RD(evb(g), 40);
                                ojd(f.e, new rjd(f.f.a / 2, f.f.b / 2));
                            }
                            c.Vg();
                        }
                        function uYc(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            c.Ug(MEe, 1);
                            akb(a.b);
                            akb(a.a);
                            h = null;
                            f = Sub(b.b, 0);
                            while(!h && f.b != f.d.c){
                                j = RD(evb(f), 40);
                                Heb(TD(mQb(j, (q$c(), n$c)))) && (h = j);
                            }
                            i = new Yub;
                            Pub(i, h, i.c.b, i.c);
                            tYc(a, i);
                            for(k = Sub(b.b, 0); k.b != k.d.c;){
                                j = RD(evb(k), 40);
                                g = WD(mQb(j, (q$c(), a$c)));
                                e = Xjb(a.b, g) != null ? RD(Xjb(a.b, g), 17).a : 0;
                                pQb(j, XZc, sgb(e));
                                d = 1 + (Xjb(a.a, g) != null ? RD(Xjb(a.a, g), 17).a : 0);
                                pQb(j, VZc, sgb(d));
                            }
                            c.Vg();
                        }
                        function ikd(a) {
                            Cgd(a, new Pfd($fd(Xfd(Zfd(Yfd(new agd, LGe), 'ELK Box'), 'Algorithm for packing of unconnected boxes, i.e. graphs without edges.'), new lkd)));
                            Agd(a, LGe, Eze, ekd);
                            Agd(a, LGe, _ze, 15);
                            Agd(a, LGe, $ze, sgb(0));
                            Agd(a, LGe, MGe, iGd($jd));
                            Agd(a, LGe, jAe, iGd(akd));
                            Agd(a, LGe, iAe, iGd(ckd));
                            Agd(a, LGe, Dze, KGe);
                            Agd(a, LGe, dAe, iGd(_jd));
                            Agd(a, LGe, CAe, iGd(bkd));
                            Agd(a, LGe, NGe, iGd(Yjd));
                            Agd(a, LGe, YDe, iGd(Zjd));
                        }
                        function c2b(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            e = a.i;
                            g = e.o.a;
                            f = e.o.b;
                            if (g <= 0 && f <= 0) return qpd(), opd;
                            j = a.n.a;
                            k = a.n.b;
                            h = a.o.a;
                            c = a.o.b;
                            switch(b.g){
                                case 2:
                                case 1:
                                    if (j < 0) return qpd(), ppd;
                                    else if (j + h > g) return qpd(), Xod;
                                    break;
                                case 4:
                                case 3:
                                    if (k < 0) return qpd(), Yod;
                                    else if (k + c > f) return qpd(), npd;
                            }
                            i = (j + h / 2) / g;
                            d = (k + c / 2) / f;
                            return i + d <= 1 && i - d <= 0 ? (qpd(), ppd) : i + d >= 1 && i - d >= 0 ? (qpd(), Xod) : d < 0.5 ? (qpd(), Yod) : (qpd(), npd);
                        }
                        function PNc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
                            c = false;
                            k = Kfb(UD(mQb(b, (yCc(), bCc))));
                            o = pwe * k;
                            for(e = new Anb(b.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 30);
                                j = new Anb(d.a);
                                f = RD(ynb(j), 10);
                                l = XNc(a.a[f.p]);
                                while(j.a < j.c.c.length){
                                    h = RD(ynb(j), 10);
                                    m = XNc(a.a[h.p]);
                                    if (l != m) {
                                        n = bFc(a.b, f, h);
                                        g = f.n.b + f.o.b + f.d.a + l.a + n;
                                        i = h.n.b - h.d.d + m.a;
                                        if (g > i + o) {
                                            p = l.g + m.g;
                                            m.a = (m.g * m.a + l.g * l.a) / p;
                                            m.g = p;
                                            l.f = m;
                                            c = true;
                                        }
                                    }
                                    f = h;
                                    l = m;
                                }
                            }
                            return c;
                        }
                        function MJb(a, b, c, d, e, f, g) {
                            var h, i, j, k, l, m;
                            m = new Tid;
                            for(j = b.Kc(); j.Ob();){
                                h = RD(j.Pb(), 853);
                                for(l = new Anb(h.Rf()); l.a < l.c.c.length;){
                                    k = RD(ynb(l), 187);
                                    if (dE(k.of((umd(), Qkd))) === dE((Omd(), Nmd))) {
                                        JJb(m, k, false, d, e, f, g);
                                        Sid(a, m);
                                    }
                                }
                            }
                            for(i = c.Kc(); i.Ob();){
                                h = RD(i.Pb(), 853);
                                for(l = new Anb(h.Rf()); l.a < l.c.c.length;){
                                    k = RD(ynb(l), 187);
                                    if (dE(k.of((umd(), Qkd))) === dE((Omd(), Mmd))) {
                                        JJb(m, k, true, d, e, f, g);
                                        Sid(a, m);
                                    }
                                }
                            }
                        }
                        function PVc(a, b, c) {
                            var d, e, f, g, h, i, j;
                            for(g = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); g.e != g.i.gc();){
                                f = RD(bMd(g), 27);
                                for(e = new is(Mr(zGd(f).a.Kc(), new ir)); gs(e);){
                                    d = RD(hs(e), 74);
                                    if (!nzd(d) && !nzd(d) && !ozd(d)) {
                                        i = RD(Wd(qtb(c.f, f)), 40);
                                        j = RD(Wjb(c, AGd(RD(QHd((!d.c && (d.c = new Yie(E4, d, 5, 8)), d.c), 0), 84))), 40);
                                        if (!!i && !!j) {
                                            h = new WWc(i, j);
                                            pQb(h, (q$c(), h$c), d);
                                            kQb(h, d);
                                            Mub(i.d, h);
                                            Mub(j.b, h);
                                            Mub(b.a, h);
                                        }
                                    }
                                }
                            }
                        }
                        function HNb(a, b) {
                            var c, d, e, f, g, h, i, j;
                            for(i = RD(RD(Qc(a.r, b), 21), 87).Kc(); i.Ob();){
                                h = RD(i.Pb(), 117);
                                e = h.c ? PKb(h.c) : 0;
                                if (e > 0) {
                                    if (h.a) {
                                        j = h.b.Mf().b;
                                        if (e > j) {
                                            if (a.v || h.c.d.c.length == 1) {
                                                g = (e - j) / 2;
                                                h.d.d = g;
                                                h.d.a = g;
                                            } else {
                                                c = RD(Vmb(h.c.d, 0), 187).Mf().b;
                                                d = (c - j) / 2;
                                                h.d.d = $wnd.Math.max(0, d);
                                                h.d.a = e - d - j;
                                            }
                                        }
                                    } else h.d.a = a.t + e;
                                } else if (Rod(a.u)) {
                                    f = wsd(h.b);
                                    f.d < 0 && (h.d.d = -f.d);
                                    f.d + f.a > h.b.Mf().b && (h.d.a = f.d + f.a - h.b.Mf().b);
                                }
                            }
                        }
                        function yVb() {
                            yVb = geb;
                            lVb = new mGd((umd(), Rld), sgb(1));
                            rVb = new mGd(fmd, 80);
                            qVb = new mGd($ld, 5);
                            ZUb = new mGd(Dkd, Yze);
                            mVb = new mGd(Sld, sgb(1));
                            pVb = new mGd(Vld, (Geb(), true));
                            iVb = new A3b(50);
                            hVb = new mGd(tld, iVb);
                            _Ub = ald;
                            jVb = Hld;
                            $Ub = new mGd(Pkd, false);
                            gVb = sld;
                            eVb = mld;
                            fVb = pld;
                            dVb = kld;
                            cVb = ild;
                            kVb = Lld;
                            bVb = (OUb(), HUb);
                            sVb = MUb;
                            aVb = GUb;
                            nVb = JUb;
                            oVb = LUb;
                            vVb = mmd;
                            xVb = qmd;
                            uVb = lmd;
                            tVb = kmd;
                            wVb = (mqd(), jqd);
                            new mGd(nmd, wVb);
                        }
                        function VC(a, b) {
                            var c;
                            switch(XC(a)){
                                case 6:
                                    return bE(b);
                                case 7:
                                    return _D(b);
                                case 8:
                                    return $D(b);
                                case 3:
                                    return Array.isArray(b) && (c = XC(b), !(c >= 14 && c <= 16));
                                case 11:
                                    return b != null && typeof b === kve;
                                case 12:
                                    return b != null && (typeof b === gve || typeof b == kve);
                                case 0:
                                    return QD(b, a.__elementTypeId$);
                                case 2:
                                    return cE(b) && !(b.Tm === keb);
                                case 1:
                                    return cE(b) && !(b.Tm === keb) || QD(b, a.__elementTypeId$);
                                default:
                                    return true;
                            }
                        }
                        function gNb(a) {
                            var b, c, d, e;
                            d = a.o;
                            RMb();
                            if (a.A.dc() || pb(a.A, QMb)) e = d.a;
                            else {
                                a.D ? e = $wnd.Math.max(d.a, ZKb(a.f)) : e = ZKb(a.f);
                                if (a.A.Hc((Qpd(), Npd)) && !a.B.Hc((dqd(), _pd))) {
                                    e = $wnd.Math.max(e, ZKb(RD(Vrb(a.p, (qpd(), Yod)), 252)));
                                    e = $wnd.Math.max(e, ZKb(RD(Vrb(a.p, npd), 252)));
                                }
                                b = TMb(a);
                                !!b && (e = $wnd.Math.max(e, b.a));
                            }
                            Heb(TD(a.e.Tf().of((umd(), mld)))) ? d.a = $wnd.Math.max(d.a, e) : d.a = e;
                            c = a.f.i;
                            c.c = 0;
                            c.b = e;
                            $Kb(a.f);
                        }
                        function oRb(a, b) {
                            var c, d, e, f;
                            d = $wnd.Math.min($wnd.Math.abs(a.c - (b.c + b.b)), $wnd.Math.abs(a.c + a.b - b.c));
                            f = $wnd.Math.min($wnd.Math.abs(a.d - (b.d + b.a)), $wnd.Math.abs(a.d + a.a - b.d));
                            c = $wnd.Math.abs(a.c + a.b / 2 - (b.c + b.b / 2));
                            if (c > a.b / 2 + b.b / 2) return 1;
                            e = $wnd.Math.abs(a.d + a.a / 2 - (b.d + b.a / 2));
                            if (e > a.a / 2 + b.a / 2) return 1;
                            if (c == 0 && e == 0) return 0;
                            if (c == 0) return f / e + 1;
                            if (e == 0) return d / c + 1;
                            return $wnd.Math.min(d / c, f / e) + 1;
                        }
                        function oWb(a, b) {
                            var c, d, e, f, g, h, i;
                            f = 0;
                            h = 0;
                            i = 0;
                            for(e = new Anb(a.f.e); e.a < e.c.c.length;){
                                d = RD(ynb(e), 153);
                                if (b == d) continue;
                                g = a.i[b.a][d.a];
                                f += g;
                                c = bjd(b.d, d.d);
                                c > 0 && a.d != (AWb(), zWb) && (h += g * (d.d.a + a.a[b.a][d.a] * (b.d.a - d.d.a) / c));
                                c > 0 && a.d != (AWb(), xWb) && (i += g * (d.d.b + a.a[b.a][d.a] * (b.d.b - d.d.b) / c));
                            }
                            switch(a.d.g){
                                case 1:
                                    return new rjd(h / f, b.d.b);
                                case 2:
                                    return new rjd(b.d.a, i / f);
                                default:
                                    return new rjd(h / f, i / f);
                            }
                        }
                        function xsd(a) {
                            var b, c, d, e, f, g;
                            c = (!a.a && (a.a = new XZd(D4, a, 5)), a.a).i + 2;
                            g = new cnb(c);
                            Rmb(g, new rjd(a.j, a.k));
                            FDb(new SDb(null, (!a.a && (a.a = new XZd(D4, a, 5)), new Swb(a.a, 16))), new Usd(g));
                            Rmb(g, new rjd(a.b, a.c));
                            b = 1;
                            while(b < g.c.length - 1){
                                d = (tFb(b - 1, g.c.length), RD(g.c[b - 1], 8));
                                e = (tFb(b, g.c.length), RD(g.c[b], 8));
                                f = (tFb(b + 1, g.c.length), RD(g.c[b + 1], 8));
                                d.a == e.a && e.a == f.a || d.b == e.b && e.b == f.b ? Xmb(g, b) : ++b;
                            }
                            return g;
                        }
                        function zgc(a, b) {
                            sgc();
                            var c, d, e, f, g;
                            g = RD(mQb(a.i, (yCc(), BBc)), 101);
                            f = a.j.g - b.j.g;
                            if (f != 0 || !(g == (Bod(), vod) || g == xod || g == wod)) return 0;
                            if (g == (Bod(), vod)) {
                                c = RD(mQb(a, CBc), 17);
                                d = RD(mQb(b, CBc), 17);
                                if (!!c && !!d) {
                                    e = c.a - d.a;
                                    if (e != 0) return e;
                                }
                            }
                            switch(a.j.g){
                                case 1:
                                    return Qfb(a.n.a, b.n.a);
                                case 2:
                                    return Qfb(a.n.b, b.n.b);
                                case 3:
                                    return Qfb(b.n.a, a.n.a);
                                case 4:
                                    return Qfb(b.n.b, a.n.b);
                                default:
                                    throw Adb(new dgb(UAe));
                            }
                        }
                        function Bkc(a, b) {
                            var c, d, e, f, g, h, i;
                            c = mGb(pGb(nGb(oGb(new qGb, b), new Vid(b.e)), kkc), a.a);
                            b.j.c.length == 0 || eGb(RD(Vmb(b.j, 0), 60).a, c);
                            i = new cHb;
                            Zjb(a.e, c, i);
                            g = new _sb;
                            h = new _sb;
                            for(f = new Anb(b.k); f.a < f.c.c.length;){
                                e = RD(ynb(f), 18);
                                Ysb(g, e.c);
                                Ysb(h, e.d);
                            }
                            d = g.a.gc() - h.a.gc();
                            if (d < 0) {
                                aHb(i, true, (Cmd(), ymd));
                                aHb(i, false, zmd);
                            } else if (d > 0) {
                                aHb(i, false, (Cmd(), ymd));
                                aHb(i, true, zmd);
                            }
                            Umb(b.g, new Elc(a, c));
                            Zjb(a.g, b, c);
                        }
                        function Ugb() {
                            Ugb = geb;
                            var a;
                            Qgb = cD(WC(kE, 1), Pwe, 28, 15, [
                                -1,
                                -1,
                                30,
                                19,
                                15,
                                13,
                                11,
                                11,
                                10,
                                9,
                                9,
                                8,
                                8,
                                8,
                                8,
                                7,
                                7,
                                7,
                                7,
                                7,
                                7,
                                7,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                5
                            ]);
                            Rgb = $C(kE, Pwe, 28, 37, 15, 1);
                            Sgb = cD(WC(kE, 1), Pwe, 28, 15, [
                                -1,
                                -1,
                                63,
                                40,
                                32,
                                28,
                                25,
                                23,
                                21,
                                20,
                                19,
                                19,
                                18,
                                18,
                                17,
                                17,
                                16,
                                16,
                                16,
                                15,
                                15,
                                15,
                                15,
                                14,
                                14,
                                14,
                                14,
                                14,
                                14,
                                13,
                                13,
                                13,
                                13,
                                13,
                                13,
                                13,
                                13
                            ]);
                            Tgb = $C(lE, rxe, 28, 37, 14, 1);
                            for(a = 2; a <= 36; a++){
                                Rgb[a] = eE($wnd.Math.pow(a, Qgb[a]));
                                Tgb[a] = Fdb(Sve, Rgb[a]);
                            }
                        }
                        function tsd(a) {
                            var b;
                            if ((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a).i != 1) throw Adb(new agb(tHe + (!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a).i));
                            b = new Ejd;
                            !!BGd(RD(QHd((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b), 0), 84)) && ye(b, usd(a, BGd(RD(QHd((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b), 0), 84)), false));
                            !!BGd(RD(QHd((!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c), 0), 84)) && ye(b, usd(a, BGd(RD(QHd((!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c), 0), 84)), true));
                            return b;
                        }
                        function zRc(a, b) {
                            var c, d, e, f, g;
                            b.d ? e = a.a.c == (wQc(), vQc) ? Z2b(b.b) : a3b(b.b) : e = a.a.c == (wQc(), uQc) ? Z2b(b.b) : a3b(b.b);
                            f = false;
                            for(d = new is(Mr(e.a.Kc(), new ir)); gs(d);){
                                c = RD(hs(d), 18);
                                g = Heb(a.a.f[a.a.g[b.b.p].p]);
                                if (!g && !W0b(c) && c.c.i.c == c.d.i.c) continue;
                                if (Heb(a.a.n[a.a.g[b.b.p].p]) || Heb(a.a.n[a.a.g[b.b.p].p])) continue;
                                f = true;
                                if (Zsb(a.b, a.a.g[rRc(c, b.b).p])) {
                                    b.c = true;
                                    b.a = c;
                                    return b;
                                }
                            }
                            b.c = f;
                            b.a = null;
                            return b;
                        }
                        function QJd(a, b, c) {
                            var d, e, f, g, h, i, j;
                            d = c.gc();
                            if (d == 0) return false;
                            else {
                                if (a.Pj()) {
                                    i = a.Qj();
                                    ZId(a, b, c);
                                    g = d == 1 ? a.Ij(3, null, c.Kc().Pb(), b, i) : a.Ij(5, null, c, b, i);
                                    if (a.Mj()) {
                                        h = d < 100 ? null : new gLd(d);
                                        f = b + d;
                                        for(e = b; e < f; ++e){
                                            j = a.xj(e);
                                            h = a.Nj(j, h);
                                            h;
                                        }
                                        if (!h) a.Jj(g);
                                        else {
                                            h.nj(g);
                                            h.oj();
                                        }
                                    } else a.Jj(g);
                                } else {
                                    ZId(a, b, c);
                                    if (a.Mj()) {
                                        h = d < 100 ? null : new gLd(d);
                                        f = b + d;
                                        for(e = b; e < f; ++e)h = a.Nj(a.xj(e), h);
                                        !!h && h.oj();
                                    }
                                }
                                return true;
                            }
                        }
                        function WJd(a, b, c) {
                            var d, e, f, g, h;
                            if (a.Pj()) {
                                e = null;
                                f = a.Qj();
                                d = a.Ij(1, h = (g = a.Dj(b, a.Zi(b, c)), g), c, b, f);
                                if (a.Mj() && !(a.Yi() && !!h ? pb(h, c) : dE(h) === dE(c))) {
                                    !!h && (e = a.Oj(h, e));
                                    e = a.Nj(c, e);
                                    if (!e) a.Jj(d);
                                    else {
                                        e.nj(d);
                                        e.oj();
                                    }
                                } else if (!e) a.Jj(d);
                                else {
                                    e.nj(d);
                                    e.oj();
                                }
                                return h;
                            } else {
                                h = (g = a.Dj(b, a.Zi(b, c)), g);
                                if (a.Mj() && !(a.Yi() && !!h ? pb(h, c) : dE(h) === dE(c))) {
                                    e = null;
                                    !!h && (e = a.Oj(h, null));
                                    e = a.Nj(c, e);
                                    !!e && e.oj();
                                }
                                return h;
                            }
                        }
                        function nUb(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            a.e = b;
                            a.f = RD(mQb(b, (JVb(), IVb)), 234);
                            eUb(b);
                            a.d = $wnd.Math.max(b.e.c.length * 16 + b.c.c.length, 256);
                            if (!Heb(TD(mQb(b, (yVb(), _Ub))))) {
                                k = a.e.e.c.length;
                                for(i = new Anb(b.e); i.a < i.c.c.length;){
                                    h = RD(ynb(i), 153);
                                    j = h.d;
                                    j.a = Iwb(a.f) * k;
                                    j.b = Iwb(a.f) * k;
                                }
                            }
                            c = b.b;
                            for(f = new Anb(b.c); f.a < f.c.c.length;){
                                e = RD(ynb(f), 290);
                                d = RD(mQb(e, oVb), 17).a;
                                if (d > 0) {
                                    for(g = 0; g < d; g++)Rmb(c, new WTb(e));
                                    YTb(e);
                                }
                            }
                        }
                        function NId(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o;
                            m = new OC(a.Zg());
                            sC(b, GIe, m);
                            if (c && !a.Xg().a.dc()) {
                                k = new MB;
                                sC(b, 'logs', k);
                                h = 0;
                                for(o = new Ppb(a.Xg().b.Kc()); o.b.Ob();){
                                    n = WD(o.b.Pb());
                                    l = new OC(n);
                                    JB(k, h);
                                    LB(k, h, l);
                                    ++h;
                                }
                            }
                            if (d) {
                                j = new hC(a.Wg());
                                sC(b, 'executionTime', j);
                            }
                            if (!a.Yg().a.dc()) {
                                g = new MB;
                                sC(b, iIe, g);
                                h = 0;
                                for(f = new Ppb(a.Yg().b.Kc()); f.b.Ob();){
                                    e = RD(f.b.Pb(), 871);
                                    i = new uC;
                                    JB(g, h);
                                    LB(g, h, i);
                                    NId(e, i, c, d);
                                    ++h;
                                }
                            }
                        }
                        function rue() {
                            rue = geb;
                            Gie();
                            que = new sue;
                            cD(WC(B7, 2), Nve, 381, 0, [
                                cD(WC(B7, 1), _Le, 600, 0, [
                                    new oue(wLe)
                                ])
                            ]);
                            cD(WC(B7, 2), Nve, 381, 0, [
                                cD(WC(B7, 1), _Le, 600, 0, [
                                    new oue(xLe)
                                ])
                            ]);
                            cD(WC(B7, 2), Nve, 381, 0, [
                                cD(WC(B7, 1), _Le, 600, 0, [
                                    new oue(yLe)
                                ]),
                                cD(WC(B7, 1), _Le, 600, 0, [
                                    new oue(xLe)
                                ])
                            ]);
                            new ejb('-1');
                            cD(WC(B7, 2), Nve, 381, 0, [
                                cD(WC(B7, 1), _Le, 600, 0, [
                                    new oue('\\c+')
                                ])
                            ]);
                            new ejb('0');
                            new ejb('0');
                            new ejb('1');
                            new ejb('0');
                            new ejb(ILe);
                        }
                        function wac(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            b.Ug('Hypernodes processing', 1);
                            for(e = new Anb(a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 30);
                                for(h = new Anb(d.a); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 10);
                                    if (Heb(TD(mQb(g, (yCc(), MAc)))) && g.j.c.length <= 2) {
                                        l = 0;
                                        k = 0;
                                        c = 0;
                                        f = 0;
                                        for(j = new Anb(g.j); j.a < j.c.c.length;){
                                            i = RD(ynb(j), 12);
                                            switch(i.j.g){
                                                case 1:
                                                    ++l;
                                                    break;
                                                case 2:
                                                    ++k;
                                                    break;
                                                case 3:
                                                    ++c;
                                                    break;
                                                case 4:
                                                    ++f;
                                            }
                                        }
                                        l == 0 && c == 0 && vac(a, g, f <= k);
                                    }
                                }
                            }
                            b.Vg();
                        }
                        function MUc(a, b, c, d, e) {
                            var f, g, h, i, j, k, l;
                            for(g = new Anb(b); g.a < g.c.c.length;){
                                f = RD(ynb(g), 18);
                                i = f.c;
                                if (c.a._b(i)) j = (dVc(), bVc);
                                else if (d.a._b(i)) j = (dVc(), cVc);
                                else throw Adb(new agb('Source port must be in one of the port sets.'));
                                k = f.d;
                                if (c.a._b(k)) l = (dVc(), bVc);
                                else if (d.a._b(k)) l = (dVc(), cVc);
                                else throw Adb(new agb('Target port must be in one of the port sets.'));
                                h = new wVc(f, j, l);
                                Zjb(a.b, f, h);
                                ZEb(e.c, h);
                            }
                        }
                        function i2d(a) {
                            var b, c;
                            if (!!a.c && a.c.Vh()) {
                                c = RD(a.c, 54);
                                a.c = RD(Vvd(a, c), 142);
                                if (a.c != c) {
                                    (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 9, 2, c, a.c));
                                    if (ZD(a.Cb, 411)) a.Db >> 16 == -15 && a.Cb.Yh() && pKd(new O3d(a.Cb, 9, 13, c, a.c, fZd(o4d(RD(a.Cb, 62)), a)));
                                    else if (ZD(a.Cb, 90)) {
                                        if (a.Db >> 16 == -23 && a.Cb.Yh()) {
                                            b = a.c;
                                            ZD(b, 90) || (b = (JTd(), zTd));
                                            ZD(c, 90) || (c = (JTd(), zTd));
                                            pKd(new O3d(a.Cb, 9, 10, c, b, fZd(tYd(RD(a.Cb, 29)), a)));
                                        }
                                    }
                                }
                            }
                            return a.c;
                        }
                        function lac(a, b, c) {
                            var d, e, f, g, h, i, j, k, l;
                            c.Ug('Hyperedge merging', 1);
                            jac(a, b);
                            i = new Jkb(b.b, 0);
                            while(i.b < i.d.gc()){
                                h = (sFb(i.b < i.d.gc()), RD(i.d.Xb(i.c = i.b++), 30));
                                k = h.a;
                                if (k.c.length == 0) continue;
                                d = null;
                                e = null;
                                f = null;
                                g = null;
                                for(j = 0; j < k.c.length; j++){
                                    d = (tFb(j, k.c.length), RD(k.c[j], 10));
                                    e = d.k;
                                    if (e == (r3b(), o3b) && g == o3b) {
                                        l = hac(d, f);
                                        if (l.a) {
                                            kac(d, f, l.b, l.c);
                                            tFb(j, k.c.length);
                                            $Eb(k.c, j, 1);
                                            --j;
                                            d = f;
                                            e = g;
                                        }
                                    }
                                    f = d;
                                    g = e;
                                }
                            }
                            c.Vg();
                        }
                        function U$d(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o;
                            if (b == c) return true;
                            else {
                                b = V$d(a, b);
                                c = V$d(a, c);
                                d = h2d(b);
                                if (d) {
                                    k = h2d(c);
                                    if (k != d) {
                                        if (!k) return false;
                                        else {
                                            i = d.mk();
                                            o = k.mk();
                                            return i == o && i != null;
                                        }
                                    } else {
                                        g = (!b.d && (b.d = new XZd(o7, b, 1)), b.d);
                                        f = g.i;
                                        m = (!c.d && (c.d = new XZd(o7, c, 1)), c.d);
                                        if (f == m.i) for(j = 0; j < f; ++j){
                                            e = RD(QHd(g, j), 89);
                                            l = RD(QHd(m, j), 89);
                                            if (!U$d(a, e, l)) return false;
                                        }
                                        return true;
                                    }
                                } else {
                                    h = b.e;
                                    n = c.e;
                                    return h == n;
                                }
                            }
                        }
                        function vge(a, b, c, d) {
                            var e, f, g, h, i, j, k, l;
                            if (qke(a.e, b)) {
                                l = pke(a.e.Dh(), b);
                                f = RD(a.g, 124);
                                k = null;
                                i = -1;
                                h = -1;
                                e = 0;
                                for(j = 0; j < a.i; ++j){
                                    g = f[j];
                                    if (l.am(g.Lk())) {
                                        e == c && (i = j);
                                        if (e == d) {
                                            h = j;
                                            k = g.md();
                                        }
                                        ++e;
                                    }
                                }
                                if (i == -1) throw Adb(new veb(MIe + c + NIe + e));
                                if (h == -1) throw Adb(new veb(OIe + d + NIe + e));
                                uLd(a, i, h);
                                Mvd(a.e) && eZd(a, fge(a, 7, b, sgb(d), k, c, true));
                                return k;
                            } else throw Adb(new agb('The feature must be many-valued to support move'));
                        }
                        function j2b(a, b, c, d) {
                            var e, f, g, h, i;
                            i = new sjd(b.n);
                            i.a += b.o.a / 2;
                            i.b += b.o.b / 2;
                            h = Kfb(UD(mQb(b, (yCc(), ABc))));
                            f = a.f;
                            g = a.d;
                            e = a.c;
                            switch(RD(mQb(b, (Ywc(), hwc)), 64).g){
                                case 1:
                                    i.a += g.b + e.a - c / 2;
                                    i.b = -d - h;
                                    b.n.b = -(g.d + h + e.b);
                                    break;
                                case 2:
                                    i.a = f.a + g.b + g.c + h;
                                    i.b += g.d + e.b - d / 2;
                                    b.n.a = f.a + g.c + h - e.a;
                                    break;
                                case 3:
                                    i.a += g.b + e.a - c / 2;
                                    i.b = f.b + g.d + g.a + h;
                                    b.n.b = f.b + g.a + h - e.b;
                                    break;
                                case 4:
                                    i.a = -c - h;
                                    i.b += g.d + e.b - d / 2;
                                    b.n.a = -(g.b + h + e.a);
                            }
                            return i;
                        }
                        function Z4b(a) {
                            var b, c, d, e, f, g;
                            d = new d1b;
                            kQb(d, a);
                            dE(mQb(d, (yCc(), rAc))) === dE((Cmd(), Amd)) && pQb(d, rAc, i2b(d));
                            if (mQb(d, (rid(), qid)) == null) {
                                g = RD(Lje(a), 167);
                                pQb(d, qid, fE(g.of(qid)));
                            }
                            pQb(d, (Ywc(), Awc), a);
                            pQb(d, kwc, (b = RD(mfb(iX), 9), new Fsb(b, RD(WEb(b, b.length), 9), 0)));
                            e = FJb((!vCd(a) || (lud(), new zud(vCd(a))), lud(), new Fud(!vCd(a) ? null : new zud(vCd(a)), a)), zmd);
                            f = RD(mQb(d, qBc), 107);
                            c = d.d;
                            B2b(c, f);
                            B2b(c, e);
                            return d;
                        }
                        function Nec(a, b, c) {
                            var d, e;
                            d = b.c.i;
                            e = c.d.i;
                            if (d.k == (r3b(), o3b)) {
                                pQb(a, (Ywc(), vwc), RD(mQb(d, vwc), 12));
                                pQb(a, wwc, RD(mQb(d, wwc), 12));
                                pQb(a, uwc, TD(mQb(d, uwc)));
                            } else if (d.k == n3b) {
                                pQb(a, (Ywc(), vwc), RD(mQb(d, vwc), 12));
                                pQb(a, wwc, RD(mQb(d, wwc), 12));
                                pQb(a, uwc, (Geb(), true));
                            } else if (e.k == n3b) {
                                pQb(a, (Ywc(), vwc), RD(mQb(e, vwc), 12));
                                pQb(a, wwc, RD(mQb(e, wwc), 12));
                                pQb(a, uwc, (Geb(), true));
                            } else {
                                pQb(a, (Ywc(), vwc), b.c);
                                pQb(a, wwc, c.d);
                            }
                        }
                        function wJb(a) {
                            var b, c, d, e, f, g, h;
                            a.o = new wmb;
                            d = new Yub;
                            for(g = new Anb(a.e.a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 125);
                                CIb(f).c.length == 1 && Pub(d, f, d.c.b, d.c);
                            }
                            while(d.b != 0){
                                f = RD(d.b == 0 ? null : (sFb(d.b != 0), Wub(d, d.a.a)), 125);
                                if (CIb(f).c.length == 0) continue;
                                b = RD(Vmb(CIb(f), 0), 218);
                                c = f.g.a.c.length > 0;
                                h = oIb(b, f);
                                c ? FIb(h.b, b) : FIb(h.g, b);
                                CIb(h).c.length == 1 && Pub(d, h, d.c.b, d.c);
                                e = new Ptd(f, b);
                                hmb(a.o, e);
                                Ymb(a.e.a, f);
                            }
                        }
                        function SQb(a, b) {
                            var c, d, e, f, g, h, i;
                            d = $wnd.Math.abs(Oid(a.b).a - Oid(b.b).a);
                            h = $wnd.Math.abs(Oid(a.b).b - Oid(b.b).b);
                            e = 0;
                            i = 0;
                            c = 1;
                            g = 1;
                            if (d > a.b.b / 2 + b.b.b / 2) {
                                e = $wnd.Math.min($wnd.Math.abs(a.b.c - (b.b.c + b.b.b)), $wnd.Math.abs(a.b.c + a.b.b - b.b.c));
                                c = 1 - e / d;
                            }
                            if (h > a.b.a / 2 + b.b.a / 2) {
                                i = $wnd.Math.min($wnd.Math.abs(a.b.d - (b.b.d + b.b.a)), $wnd.Math.abs(a.b.d + a.b.a - b.b.d));
                                g = 1 - i / h;
                            }
                            f = $wnd.Math.min(c, g);
                            return (1 - f) * $wnd.Math.sqrt(d * d + h * h);
                        }
                        function LUc(a) {
                            var b, c, d, e;
                            NUc(a, a.e, a.f, (dVc(), bVc), true, a.c, a.i);
                            NUc(a, a.e, a.f, bVc, false, a.c, a.i);
                            NUc(a, a.e, a.f, cVc, true, a.c, a.i);
                            NUc(a, a.e, a.f, cVc, false, a.c, a.i);
                            MUc(a, a.c, a.e, a.f, a.i);
                            d = new Jkb(a.i, 0);
                            while(d.b < d.d.gc()){
                                b = (sFb(d.b < d.d.gc()), RD(d.d.Xb(d.c = d.b++), 131));
                                e = new Jkb(a.i, d.b);
                                while(e.b < e.d.gc()){
                                    c = (sFb(e.b < e.d.gc()), RD(e.d.Xb(e.c = e.b++), 131));
                                    KUc(b, c);
                                }
                            }
                            WUc(a.i, RD(mQb(a.d, (Ywc(), Lwc)), 234));
                            ZUc(a.i);
                        }
                        function FXd(a, b) {
                            var c, d;
                            if (b != null) {
                                d = DXd(a);
                                if (d) {
                                    if ((d.i & 1) != 0) {
                                        if (d == xdb) return $D(b);
                                        else if (d == kE) return ZD(b, 17);
                                        else if (d == jE) return ZD(b, 161);
                                        else if (d == gE) return ZD(b, 222);
                                        else if (d == hE) return ZD(b, 180);
                                        else if (d == iE) return _D(b);
                                        else if (d == wdb) return ZD(b, 191);
                                        else if (d == lE) return ZD(b, 168);
                                    } else return PRd(), c = RD(Wjb(ORd, d), 57), !c || c.fk(b);
                                } else if (ZD(b, 58)) return a.dl(RD(b, 58));
                            }
                            return false;
                        }
                        function zqe() {
                            zqe = geb;
                            var a, b, c, d, e, f, g, h, i;
                            xqe = $C(gE, YHe, 28, 255, 15, 1);
                            yqe = $C(hE, zwe, 28, 64, 15, 1);
                            for(b = 0; b < 255; b++)xqe[b] = -1;
                            for(c = 90; c >= 65; c--)xqe[c] = c - 65 << 24 >> 24;
                            for(d = 122; d >= 97; d--)xqe[d] = d - 97 + 26 << 24 >> 24;
                            for(e = 57; e >= 48; e--)xqe[e] = e - 48 + 52 << 24 >> 24;
                            xqe[43] = 62;
                            xqe[47] = 63;
                            for(f = 0; f <= 25; f++)yqe[f] = 65 + f & Bwe;
                            for(g = 26, i = 0; g <= 51; ++g, i++)yqe[g] = 97 + i & Bwe;
                            for(a = 52, h = 0; a <= 61; ++a, h++)yqe[a] = 48 + h & Bwe;
                            yqe[62] = 43;
                            yqe[63] = 47;
                        }
                        function uib(a, b) {
                            var c, d, e, f, g, h;
                            e = xib(a);
                            h = xib(b);
                            if (e == h) {
                                if (a.e == b.e && a.a < 54 && b.a < 54) return a.f < b.f ? -1 : a.f > b.f ? 1 : 0;
                                d = a.e - b.e;
                                c = (a.d > 0 ? a.d : $wnd.Math.floor((a.a - 1) * xxe) + 1) - (b.d > 0 ? b.d : $wnd.Math.floor((b.a - 1) * xxe) + 1);
                                if (c > d + 1) return e;
                                else if (c < d - 1) return -e;
                                else {
                                    f = (!a.c && (a.c = ojb(Hdb(a.f))), a.c);
                                    g = (!b.c && (b.c = ojb(Hdb(b.f))), b.c);
                                    d < 0 ? f = Wib(f, Sjb(-d)) : d > 0 && (g = Wib(g, Sjb(d)));
                                    return Qib(f, g);
                                }
                            } else return e < h ? -1 : 1;
                        }
                        function pUb(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            c.Ug(Pze, 1);
                            a.vf(b);
                            f = 0;
                            while(a.xf(f) && !c.$g()){
                                a.wf();
                                for(k = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                    b.e,
                                    b.d,
                                    b.b
                                ]))); gs(k);){
                                    i = RD(hs(k), 309);
                                    for(h = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                        b.e,
                                        b.d,
                                        b.b
                                    ]))); gs(h);){
                                        g = RD(hs(h), 309);
                                        if (g != i) {
                                            e = a.uf(g, i);
                                            !!e && $id(i.c, e);
                                        }
                                    }
                                }
                                for(j = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                    b.e,
                                    b.d,
                                    b.b
                                ]))); gs(j);){
                                    i = RD(hs(j), 309);
                                    d = i.c;
                                    _id(d, -a.d, -a.d, a.d, a.d);
                                    $id(i.d, d);
                                    d.a = 0;
                                    d.b = 0;
                                }
                                ++f;
                            }
                            c.Vg();
                        }
                        function H$b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n;
                            if (a.dc()) return new pjd;
                            j = 0;
                            l = 0;
                            for(e = a.Kc(); e.Ob();){
                                d = RD(e.Pb(), 36);
                                f = d.f;
                                j = $wnd.Math.max(j, f.a);
                                l += f.a * f.b;
                            }
                            j = $wnd.Math.max(j, $wnd.Math.sqrt(l) * Kfb(UD(mQb(RD(a.Kc().Pb(), 36), (yCc(), Tzc)))));
                            m = 0;
                            n = 0;
                            i = 0;
                            c = b;
                            for(h = a.Kc(); h.Ob();){
                                g = RD(h.Pb(), 36);
                                k = g.f;
                                if (m + k.a > j) {
                                    m = 0;
                                    n += i + b;
                                    i = 0;
                                }
                                w$b(g, m, n);
                                c = $wnd.Math.max(c, m + k.a);
                                i = $wnd.Math.max(i, k.b);
                                m += k.a + b;
                            }
                            return new rjd(c + b, n + i + b);
                        }
                        function osd(a, b) {
                            var c, d, e, f, g, h, i;
                            if (!MCd(a)) throw Adb(new dgb(sHe));
                            d = MCd(a);
                            f = d.g;
                            e = d.f;
                            if (f <= 0 && e <= 0) return qpd(), opd;
                            h = a.i;
                            i = a.j;
                            switch(b.g){
                                case 2:
                                case 1:
                                    if (h < 0) return qpd(), ppd;
                                    else if (h + a.g > f) return qpd(), Xod;
                                    break;
                                case 4:
                                case 3:
                                    if (i < 0) return qpd(), Yod;
                                    else if (i + a.f > e) return qpd(), npd;
                            }
                            g = (h + a.g / 2) / f;
                            c = (i + a.f / 2) / e;
                            return g + c <= 1 && g - c <= 0 ? (qpd(), ppd) : g + c >= 1 && g - c >= 0 ? (qpd(), Xod) : c < 0.5 ? (qpd(), Yod) : (qpd(), npd);
                        }
                        function Djb(a, b, c, d, e) {
                            var f, g;
                            f = Bdb(Cdb(b[0], yxe), Cdb(d[0], yxe));
                            a[0] = Ydb(f);
                            f = Tdb(f, 32);
                            if (c >= e) {
                                for(g = 1; g < e; g++){
                                    f = Bdb(f, Bdb(Cdb(b[g], yxe), Cdb(d[g], yxe)));
                                    a[g] = Ydb(f);
                                    f = Tdb(f, 32);
                                }
                                for(; g < c; g++){
                                    f = Bdb(f, Cdb(b[g], yxe));
                                    a[g] = Ydb(f);
                                    f = Tdb(f, 32);
                                }
                            } else {
                                for(g = 1; g < c; g++){
                                    f = Bdb(f, Bdb(Cdb(b[g], yxe), Cdb(d[g], yxe)));
                                    a[g] = Ydb(f);
                                    f = Tdb(f, 32);
                                }
                                for(; g < e; g++){
                                    f = Bdb(f, Cdb(d[g], yxe));
                                    a[g] = Ydb(f);
                                    f = Tdb(f, 32);
                                }
                            }
                            Ddb(f, 0) != 0 && (a[g] = Ydb(f));
                        }
                        function yte(a) {
                            Vse();
                            var b, c, d, e, f, g;
                            if (a.e != 4 && a.e != 5) throw Adb(new agb('Token#complementRanges(): must be RANGE: ' + a.e));
                            f = a;
                            vte(f);
                            ste(f);
                            d = f.b.length + 2;
                            f.b[0] == 0 && (d -= 2);
                            c = f.b[f.b.length - 1];
                            c == MLe && (d -= 2);
                            e = (++Use, new xte(4));
                            e.b = $C(kE, Pwe, 28, d, 15, 1);
                            g = 0;
                            if (f.b[0] > 0) {
                                e.b[g++] = 0;
                                e.b[g++] = f.b[0] - 1;
                            }
                            for(b = 1; b < f.b.length - 2; b += 2){
                                e.b[g++] = f.b[b] + 1;
                                e.b[g++] = f.b[b + 1] - 1;
                            }
                            if (c != MLe) {
                                e.b[g++] = c + 1;
                                e.b[g] = MLe;
                            }
                            e.a = true;
                            return e;
                        }
                        function zac(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            b.Ug('Layer constraint edge reversal', 1);
                            for(g = new Anb(a.b); g.a < g.c.c.length;){
                                f = RD(ynb(g), 30);
                                k = -1;
                                c = new bnb;
                                j = t2b(f.a);
                                for(e = 0; e < j.length; e++){
                                    d = RD(mQb(j[e], (Ywc(), owc)), 311);
                                    if (k == -1) d != (Gvc(), Fvc) && (k = e);
                                    else if (d == (Gvc(), Fvc)) {
                                        g3b(j[e], null);
                                        f3b(j[e], k++, f);
                                    }
                                    d == (Gvc(), Dvc) && ZEb(c.c, j[e]);
                                }
                                for(i = new Anb(c); i.a < i.c.c.length;){
                                    h = RD(ynb(i), 10);
                                    g3b(h, null);
                                    g3b(h, f);
                                }
                            }
                            b.Vg();
                        }
                        function nLd(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            d = c.gc();
                            if (d == 0) return false;
                            else {
                                if (a.Pj()) {
                                    j = a.Qj();
                                    IHd(a, b, c);
                                    g = d == 1 ? a.Ij(3, null, c.Kc().Pb(), b, j) : a.Ij(5, null, c, b, j);
                                    if (a.Mj()) {
                                        h = d < 100 ? null : new gLd(d);
                                        f = b + d;
                                        for(e = b; e < f; ++e){
                                            k = a.g[e];
                                            h = a.Nj(k, h);
                                            h = a.Uj(k, h);
                                        }
                                        if (!h) a.Jj(g);
                                        else {
                                            h.nj(g);
                                            h.oj();
                                        }
                                    } else a.Jj(g);
                                } else {
                                    IHd(a, b, c);
                                    if (a.Mj()) {
                                        h = d < 100 ? null : new gLd(d);
                                        f = b + d;
                                        for(e = b; e < f; ++e){
                                            i = a.g[e];
                                            h = a.Nj(i, h);
                                        }
                                        !!h && h.oj();
                                    }
                                }
                                return true;
                            }
                        }
                        function m9b(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            b.Ug('Hierarchical port dummy size processing', 1);
                            i = new bnb;
                            k = new bnb;
                            d = Kfb(UD(mQb(a, (yCc(), UBc))));
                            c = d * 2;
                            for(f = new Anb(a.b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 30);
                                i.c.length = 0;
                                k.c.length = 0;
                                for(h = new Anb(e.a); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 10);
                                    if (g.k == (r3b(), m3b)) {
                                        j = RD(mQb(g, (Ywc(), hwc)), 64);
                                        j == (qpd(), Yod) ? ZEb(i.c, g) : j == npd && ZEb(k.c, g);
                                    }
                                }
                                n9b(i, true, c);
                                n9b(k, false, c);
                            }
                            b.Vg();
                        }
                        function wSc(a, b, c, d) {
                            var e, f, g, h, i;
                            for(g = new Anb(a.k); g.a < g.c.c.length;){
                                e = RD(ynb(g), 132);
                                if (!d || e.c == (fTc(), dTc)) {
                                    i = e.b;
                                    if (i.g < 0 && e.d > 0) {
                                        PSc(i, i.d - e.d);
                                        e.c == (fTc(), dTc) && NSc(i, i.a - e.d);
                                        i.d <= 0 && i.i > 0 && Pub(b, i, b.c.b, b.c);
                                    }
                                }
                            }
                            for(f = new Anb(a.f); f.a < f.c.c.length;){
                                e = RD(ynb(f), 132);
                                if (!d || e.c == (fTc(), dTc)) {
                                    h = e.a;
                                    if (h.g < 0 && e.d > 0) {
                                        QSc(h, h.i - e.d);
                                        e.c == (fTc(), dTc) && OSc(h, h.b - e.d);
                                        h.i <= 0 && h.d > 0 && Pub(c, h, c.c.b, c.c);
                                    }
                                }
                            }
                        }
                        function drd(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n;
                            yob();
                            _mb(a, new Mrd);
                            g = gv(a);
                            n = new bnb;
                            m = new bnb;
                            h = null;
                            i = 0;
                            while(g.b != 0){
                                f = RD(g.b == 0 ? null : (sFb(g.b != 0), Wub(g, g.a.a)), 163);
                                if (!h || urd(h) * trd(h) / 2 < urd(f) * trd(f)) {
                                    h = f;
                                    ZEb(n.c, f);
                                } else {
                                    i += urd(f) * trd(f);
                                    ZEb(m.c, f);
                                    if (m.c.length > 1 && (i > urd(h) * trd(h) / 2 || g.b == 0)) {
                                        l = new zrd(m);
                                        k = urd(h) / trd(h);
                                        j = ird(l, b, new z3b, c, d, e, k);
                                        $id(hjd(l.e), j);
                                        h = l;
                                        ZEb(n.c, l);
                                        i = 0;
                                        m.c.length = 0;
                                    }
                                }
                            }
                            Tmb(n, m);
                            return n;
                        }
                        function hib(a, b, c, d, e) {
                            gib();
                            var f, g, h, i, j, k, l;
                            vFb(a, 'src');
                            vFb(c, 'dest');
                            l = rb(a);
                            i = rb(c);
                            qFb((l.i & 4) != 0, 'srcType is not an array');
                            qFb((i.i & 4) != 0, 'destType is not an array');
                            k = l.c;
                            g = i.c;
                            qFb((k.i & 1) != 0 ? k == g : (g.i & 1) == 0, "Array types don't match");
                            iib(a, b, c, d, e);
                            if ((k.i & 1) == 0 && l != i) {
                                j = SD(a);
                                f = SD(c);
                                if (dE(a) === dE(c) && b < d) {
                                    b += e;
                                    for(h = d + e; h-- > d;)bD(f, h, j[--b]);
                                } else for(h = d + e; d < h;)bD(f, d++, j[b++]);
                            } else VEb(a, b, c, d, e, true);
                        }
                        function crd(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            b.Ug('Box layout', 2);
                            e = Mfb(UD(Gxd(a, (hkd(), gkd))));
                            f = RD(Gxd(a, dkd), 107);
                            c = Heb(TD(Gxd(a, $jd)));
                            d = Heb(TD(Gxd(a, _jd)));
                            switch(RD(Gxd(a, Yjd), 320).g){
                                case 0:
                                    g = (k = new dnb((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)), yob(), _mb(k, new prd(d)), k);
                                    h = vsd(a);
                                    i = UD(Gxd(a, Xjd));
                                    (i == null || (uFb(i), i) <= 0) && (i = 1.3);
                                    j = grd(g, e, f, h.a, h.b, c, (uFb(i), i));
                                    Esd(a, j.a, j.b, false, true);
                                    break;
                                default:
                                    hrd(a, e, f, c);
                            }
                            b.Vg();
                        }
                        function uUc(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n, o;
                            m = tUc(a, c);
                            for(i = 0; i < b; i++){
                                Ikb(e, c);
                                n = new bnb;
                                o = (sFb(d.b < d.d.gc()), RD(d.d.Xb(d.c = d.b++), 418));
                                for(k = m + i; k < a.b; k++){
                                    h = o;
                                    o = (sFb(d.b < d.d.gc()), RD(d.d.Xb(d.c = d.b++), 418));
                                    Rmb(n, new AUc(h, o, c));
                                }
                                for(l = m + i; l < a.b; l++){
                                    sFb(d.b > 0);
                                    d.a.Xb(d.c = --d.b);
                                    l > m + i && Ckb(d);
                                }
                                for(g = new Anb(n); g.a < g.c.c.length;){
                                    f = RD(ynb(g), 418);
                                    Ikb(d, f);
                                }
                                if (i < b - 1) for(j = m + i; j < a.b; j++){
                                    sFb(d.b > 0);
                                    d.a.Xb(d.c = --d.b);
                                }
                            }
                        }
                        function gte() {
                            Vse();
                            var a, b, c, d, e, f;
                            if (Fse) return Fse;
                            a = (++Use, new xte(4));
                            ute(a, hte(WLe, true));
                            wte(a, hte('M', true));
                            wte(a, hte('C', true));
                            f = (++Use, new xte(4));
                            for(d = 0; d < 11; d++)rte(f, d, d);
                            b = (++Use, new xte(4));
                            ute(b, hte('M', true));
                            rte(b, 4448, 4607);
                            rte(b, 65438, 65439);
                            e = (++Use, new iue(2));
                            hue(e, a);
                            hue(e, Ese);
                            c = (++Use, new iue(2));
                            c.Jm($se(f, hte('L', true)));
                            c.Jm(b);
                            c = (++Use, new Kte(3, c));
                            c = (++Use, new Qte(e, c));
                            Fse = c;
                            return Fse;
                        }
                        function vhb(a, b) {
                            var c, d, e, f, g, h, i, j;
                            c = new RegExp(b, 'g');
                            i = $C(qJ, Nve, 2, 0, 6, 1);
                            d = 0;
                            j = a;
                            f = null;
                            while(true){
                                h = c.exec(j);
                                if (h == null || j == '') {
                                    i[d] = j;
                                    break;
                                } else {
                                    g = h.index;
                                    i[d] = (AFb(0, g, j.length), j.substr(0, g));
                                    j = zhb(j, g + h[0].length, j.length);
                                    c.lastIndex = 0;
                                    if (f == j) {
                                        i[d] = (AFb(0, 1, j.length), j.substr(0, 1));
                                        j = (BFb(1, j.length + 1), j.substr(1));
                                    }
                                    f = j;
                                    ++d;
                                }
                            }
                            if (a.length > 0) {
                                e = i.length;
                                while(e > 0 && i[e - 1] == '')--e;
                                e < i.length && (i.length = e);
                            }
                            return i;
                        }
                        function h_c() {
                            h_c = geb;
                            U$c = new A3b(20);
                            T$c = new mGd((umd(), tld), U$c);
                            _$c = new mGd(fmd, 20);
                            $$c = new mGd(_ld, 3);
                            E$c = new mGd(Dkd, Yze);
                            X$c = new mGd(Rld, sgb(1));
                            Z$c = new mGd(Vld, (Geb(), true));
                            G$c = Mkd;
                            I$c = (Cmd(), Amd);
                            H$c = new mGd(Nkd, I$c);
                            L$c = ald;
                            M$c = bld;
                            O$c = kld;
                            P$c = mld;
                            Q$c = nld;
                            R$c = pld;
                            N$c = ild;
                            S$c = sld;
                            V$c = Lld;
                            g_c = (B$c(), z$c);
                            Y$c = w$c;
                            c_c = mmd;
                            e_c = qmd;
                            b_c = lmd;
                            a_c = kmd;
                            d_c = (mqd(), jqd);
                            new mGd(nmd, d_c);
                            W$c = v$c;
                            K$c = t$c;
                            f_c = y$c;
                            F$c = r$c;
                            J$c = s$c;
                        }
                        function bgd(a) {
                            var b, c;
                            b = WD(Gxd(a, (umd(), Akd)));
                            if (cgd(b, a)) return;
                            if (!Hxd(a, Tld) && ((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a).i != 0 || Heb(TD(Gxd(a, $kd))))) {
                                if (b == null || Dhb(b).length == 0) {
                                    if (!cgd(sxe, a)) {
                                        c = Zhb(Zhb(new dib('Unable to load default layout algorithm '), sxe), ' for unconfigured node ');
                                        Csd(a, c);
                                        throw Adb(new Jed(c.a));
                                    }
                                } else {
                                    c = Zhb(Zhb(new dib("Layout algorithm '"), b), "' not found for ");
                                    Csd(a, c);
                                    throw Adb(new Jed(c.a));
                                }
                            }
                        }
                        function $Kb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n;
                            c = a.i;
                            b = a.n;
                            if (a.b == 0) {
                                n = c.c + b.b;
                                m = c.b - b.b - b.c;
                                for(g = a.a, i = 0, k = g.length; i < k; ++i){
                                    e = g[i];
                                    dKb(e, n, m);
                                }
                            } else {
                                d = bLb(a, false);
                                dKb(a.a[0], c.c + b.b, d[0]);
                                dKb(a.a[2], c.c + c.b - b.c - d[2], d[2]);
                                l = c.b - b.b - b.c;
                                if (d[0] > 0) {
                                    l -= d[0] + a.c;
                                    d[0] += a.c;
                                }
                                d[2] > 0 && (l -= d[2] + a.c);
                                d[1] = $wnd.Math.max(d[1], l);
                                dKb(a.a[1], c.c + b.b + d[0] - (d[1] - l) / 2, d[1]);
                            }
                            for(f = a.a, h = 0, j = f.length; h < j; ++h){
                                e = f[h];
                                ZD(e, 336) && RD(e, 336).lf();
                            }
                        }
                        function iRc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l;
                            l = new hRc;
                            l.d = 0;
                            for(g = new Anb(a.b); g.a < g.c.c.length;){
                                f = RD(ynb(g), 30);
                                l.d += f.a.c.length;
                            }
                            d = 0;
                            e = 0;
                            l.a = $C(kE, Pwe, 28, a.b.c.length, 15, 1);
                            j = 0;
                            k = 0;
                            l.e = $C(kE, Pwe, 28, l.d, 15, 1);
                            for(c = new Anb(a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 30);
                                b.p = d++;
                                l.a[b.p] = e++;
                                k = 0;
                                for(i = new Anb(b.a); i.a < i.c.c.length;){
                                    h = RD(ynb(i), 10);
                                    h.p = j++;
                                    l.e[h.p] = k++;
                                }
                            }
                            l.c = new mRc(l);
                            l.b = ev(l.d);
                            jRc(l, a);
                            l.f = ev(l.d);
                            kRc(l, a);
                            return l;
                        }
                        function M9c(a, b) {
                            var c, d, e, f;
                            f = RD(Vmb(a.n, a.n.c.length - 1), 209).d;
                            a.p = $wnd.Math.min(a.p, b.g);
                            a.r = $wnd.Math.max(a.r, f);
                            a.g = $wnd.Math.max(a.g, b.g + (a.b.c.length == 1 ? 0 : a.i));
                            a.o = $wnd.Math.min(a.o, b.f);
                            a.e += b.f + (a.b.c.length == 1 ? 0 : a.i);
                            a.f = $wnd.Math.max(a.f, b.f);
                            e = a.n.c.length > 0 ? (a.n.c.length - 1) * a.i : 0;
                            for(d = new Anb(a.n); d.a < d.c.c.length;){
                                c = RD(ynb(d), 209);
                                e += c.a;
                            }
                            a.d = e;
                            a.a = a.e / a.b.c.length - a.i * ((a.b.c.length - 1) / a.b.c.length);
                            Ead(a.j);
                        }
                        function CTb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            k = TD(mQb(b, (yVb(), pVb)));
                            if (k == null || (uFb(k), k)) {
                                l = $C(xdb, Hye, 28, b.e.c.length, 16, 1);
                                g = yTb(b);
                                e = new Yub;
                                for(j = new Anb(b.e); j.a < j.c.c.length;){
                                    h = RD(ynb(j), 153);
                                    c = zTb(a, h, null, null, l, g);
                                    if (c) {
                                        kQb(c, b);
                                        Pub(e, c, e.c.b, e.c);
                                    }
                                }
                                if (e.b > 1) for(d = Sub(e, 0); d.b != d.d.c;){
                                    c = RD(evb(d), 235);
                                    f = 0;
                                    for(i = new Anb(c.e); i.a < i.c.c.length;){
                                        h = RD(ynb(i), 153);
                                        h.a = f++;
                                    }
                                }
                                return e;
                            }
                            return dv(cD(WC(tP, 1), Jze, 235, 0, [
                                b
                            ]));
                        }
                        function rYd(a) {
                            var b, c, d, e, f, g, h;
                            if (!a.g) {
                                h = new Z$d;
                                b = iYd;
                                g = b.a.zc(a, b);
                                if (g == null) {
                                    for(d = new dMd(zYd(a)); d.e != d.i.gc();){
                                        c = RD(bMd(d), 29);
                                        YGd(h, rYd(c));
                                    }
                                    b.a.Bc(a);
                                    b.a.gc() == 0 && undefined;
                                }
                                e = h.i;
                                for(f = (!a.s && (a.s = new C5d(y7, a, 21, 17)), new dMd(a.s)); f.e != f.i.gc(); ++e)BWd(RD(bMd(f), 462), e);
                                YGd(h, (!a.s && (a.s = new C5d(y7, a, 21, 17)), a.s));
                                VHd(h);
                                a.g = new R$d(a, h);
                                a.i = RD(h.g, 254);
                                a.i == null && (a.i = kYd);
                                a.p = null;
                                yYd(a).b &= -5;
                            }
                            return a.g;
                        }
                        function yee(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            c = b.qi(a.a);
                            if (c) {
                                i = WD($Nd((!c.b && (c.b = new SVd((JTd(), FTd), C8, c)), c.b), 'memberTypes'));
                                if (i != null) {
                                    j = new bnb;
                                    for(f = vhb(i, '\\w'), g = 0, h = f.length; g < h; ++g){
                                        e = f[g];
                                        d = e.lastIndexOf('#');
                                        k = d == -1 ? Wee(a, b.jk(), e) : d == 0 ? Vee(a, null, (BFb(1, e.length + 1), e.substr(1))) : Vee(a, (AFb(0, d, e.length), e.substr(0, d)), (BFb(d + 1, e.length + 1), e.substr(d + 1)));
                                        ZD(k, 156) && Rmb(j, RD(k, 156));
                                    }
                                    return j;
                                }
                            }
                            return yob(), yob(), vob;
                        }
                        function _Kb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o;
                            d = a.i;
                            c = a.n;
                            if (a.b == 0) {
                                b = aLb(a, false);
                                eKb(a.a[0], d.d + c.d, b[0]);
                                eKb(a.a[2], d.d + d.a - c.a - b[2], b[2]);
                                m = d.a - c.d - c.a;
                                l = m;
                                if (b[0] > 0) {
                                    b[0] += a.c;
                                    l -= b[0];
                                }
                                b[2] > 0 && (l -= b[2] + a.c);
                                b[1] = $wnd.Math.max(b[1], l);
                                eKb(a.a[1], d.d + c.d + b[0] - (b[1] - l) / 2, b[1]);
                            } else {
                                o = d.d + c.d;
                                n = d.a - c.d - c.a;
                                for(g = a.a, i = 0, k = g.length; i < k; ++i){
                                    e = g[i];
                                    eKb(e, o, n);
                                }
                            }
                            for(f = a.a, h = 0, j = f.length; h < j; ++h){
                                e = f[h];
                                ZD(e, 336) && RD(e, 336).mf();
                            }
                        }
                        function Erc(a) {
                            var b, c, d, e, f, g, h, i, j, k;
                            k = $C(kE, Pwe, 28, a.b.c.length + 1, 15, 1);
                            j = new _sb;
                            d = 0;
                            for(f = new Anb(a.b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 30);
                                k[d++] = j.a.gc();
                                for(i = new Anb(e.a); i.a < i.c.c.length;){
                                    g = RD(ynb(i), 10);
                                    for(c = new is(Mr(a3b(g).a.Kc(), new ir)); gs(c);){
                                        b = RD(hs(c), 18);
                                        j.a.zc(b, j);
                                    }
                                }
                                for(h = new Anb(e.a); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 10);
                                    for(c = new is(Mr(Z2b(g).a.Kc(), new ir)); gs(c);){
                                        b = RD(hs(c), 18);
                                        j.a.Bc(b);
                                    }
                                }
                            }
                            return k;
                        }
                        function dge(a, b, c, d) {
                            var e, f, g, h, i;
                            i = pke(a.e.Dh(), b);
                            e = RD(a.g, 124);
                            nke();
                            if (RD(b, 69).xk()) for(g = 0; g < a.i; ++g){
                                f = e[g];
                                if (i.am(f.Lk()) && pb(f, c)) return true;
                            }
                            else if (c != null) {
                                for(h = 0; h < a.i; ++h){
                                    f = e[h];
                                    if (i.am(f.Lk()) && pb(c, f.md())) return true;
                                }
                                if (d) for(g = 0; g < a.i; ++g){
                                    f = e[g];
                                    if (i.am(f.Lk()) && dE(c) === dE(Age(a, RD(f.md(), 58)))) return true;
                                }
                            } else for(g = 0; g < a.i; ++g){
                                f = e[g];
                                if (i.am(f.Lk()) && f.md() == null) return false;
                            }
                            return false;
                        }
                        function wee(a, b) {
                            var c, d, e, f, g, h;
                            c = b.qi(a.a);
                            if (c) {
                                h = WD($Nd((!c.b && (c.b = new SVd((JTd(), FTd), C8, c)), c.b), FIe));
                                if (h != null) {
                                    e = thb(h, Fhb(35));
                                    d = b.qk();
                                    if (e == -1) {
                                        g = Uee(a, BXd(d));
                                        f = h;
                                    } else if (e == 0) {
                                        g = null;
                                        f = (BFb(1, h.length + 1), h.substr(1));
                                    } else {
                                        g = (AFb(0, e, h.length), h.substr(0, e));
                                        f = (BFb(e + 1, h.length + 1), h.substr(e + 1));
                                    }
                                    switch(yfe(Qee(a, b))){
                                        case 2:
                                        case 3:
                                            return Jee(a, d, g, f);
                                        case 0:
                                        case 4:
                                        case 5:
                                        case 6:
                                            return Mee(a, d, g, f);
                                    }
                                }
                            }
                            return null;
                        }
                        function FQb(a, b, c, d) {
                            var e, f, g, h;
                            h = c;
                            for(g = new Anb(b.a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 225);
                                e = RD(f.b, 68);
                                if ($y(a.b.c, e.b.c + e.b.b) <= 0 && $y(e.b.c, a.b.c + a.b.b) <= 0 && $y(a.b.d, e.b.d + e.b.a) <= 0 && $y(e.b.d, a.b.d + a.b.a) <= 0) {
                                    if ($y(e.b.c, a.b.c + a.b.b) == 0 && d.a < 0 || $y(e.b.c + e.b.b, a.b.c) == 0 && d.a > 0 || $y(e.b.d, a.b.d + a.b.a) == 0 && d.b < 0 || $y(e.b.d + e.b.a, a.b.d) == 0 && d.b > 0) {
                                        h = 0;
                                        break;
                                    }
                                } else h = $wnd.Math.min(h, PQb(a, e, d));
                                h = $wnd.Math.min(h, FQb(a, f, h, d));
                            }
                            return h;
                        }
                        function lsd(a, b) {
                            var c, d, e, f, g, h, i;
                            if (a.b < 2) throw Adb(new agb('The vector chain must contain at least a source and a target point.'));
                            e = (sFb(a.b != 0), RD(a.a.a.c, 8));
                            Nzd(b, e.a, e.b);
                            i = new mMd((!b.a && (b.a = new XZd(D4, b, 5)), b.a));
                            g = Sub(a, 1);
                            while(g.a < a.b - 1){
                                h = RD(evb(g), 8);
                                if (i.e != i.i.gc()) c = RD(bMd(i), 377);
                                else {
                                    c = (bvd(), d = new Xxd, d);
                                    kMd(i, c);
                                }
                                Uxd(c, h.a, h.b);
                            }
                            while(i.e != i.i.gc()){
                                bMd(i);
                                cMd(i);
                            }
                            f = (sFb(a.b != 0), RD(a.c.b.c, 8));
                            Gzd(b, f.a, f.b);
                        }
                        function Ege(a, b, c, d) {
                            var e, f, g, h, i, j;
                            j = pke(a.e.Dh(), b);
                            g = RD(a.g, 124);
                            if (qke(a.e, b)) {
                                if (b.Si()) {
                                    f = kge(a, b, d, ZD(b, 102) && (RD(b, 19).Bb & txe) != 0);
                                    if (f >= 0 && f != c) throw Adb(new agb(LIe));
                                }
                                e = 0;
                                for(i = 0; i < a.i; ++i){
                                    h = g[i];
                                    if (j.am(h.Lk())) {
                                        if (e == c) return RD(eHd(a, i, (nke(), RD(b, 69).xk() ? RD(d, 76) : oke(b, d))), 76);
                                        ++e;
                                    }
                                }
                                throw Adb(new veb(HJe + c + NIe + e));
                            } else {
                                for(i = 0; i < a.i; ++i){
                                    h = g[i];
                                    if (j.am(h.Lk())) return nke(), RD(b, 69).xk() ? h : h.md();
                                }
                                return null;
                            }
                        }
                        function Epc(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            c = 0;
                            for(e = new Anb((tFb(0, a.c.length), RD(a.c[0], 105)).g.b.j); e.a < e.c.c.length;){
                                d = RD(ynb(e), 12);
                                d.p = c++;
                            }
                            b == (qpd(), Yod) ? _mb(a, new Mpc) : _mb(a, new Qpc);
                            h = 0;
                            k = a.c.length - 1;
                            while(h < k){
                                g = (tFb(h, a.c.length), RD(a.c[h], 105));
                                j = (tFb(k, a.c.length), RD(a.c[k], 105));
                                f = b == Yod ? g.c : g.a;
                                i = b == Yod ? j.a : j.c;
                                Gpc(g, b, (enc(), cnc), f);
                                Gpc(j, b, bnc, i);
                                ++h;
                                --k;
                            }
                            h == k && Gpc((tFb(h, a.c.length), RD(a.c[h], 105)), b, (enc(), anc), null);
                        }
                        function lJc(a, b, c, d) {
                            var e, f, g, h, i, j;
                            g = new zJc(a, b, c);
                            i = new Jkb(d, 0);
                            e = false;
                            while(i.b < i.d.gc()){
                                h = (sFb(i.b < i.d.gc()), RD(i.d.Xb(i.c = i.b++), 239));
                                if (h == b || h == c) Ckb(i);
                                else if (!e && Kfb(pJc(h.g, h.d[0]).a) > Kfb(pJc(g.g, g.d[0]).a)) {
                                    sFb(i.b > 0);
                                    i.a.Xb(i.c = --i.b);
                                    Ikb(i, g);
                                    e = true;
                                } else if (!!h.e && h.e.gc() > 0) {
                                    f = (!h.e && (h.e = new bnb), h.e).Mc(b);
                                    j = (!h.e && (h.e = new bnb), h.e).Mc(c);
                                    if (f || j) {
                                        (!h.e && (h.e = new bnb), h.e).Fc(g);
                                        ++g.c;
                                    }
                                }
                            }
                            e || ZEb(d.c, g);
                        }
                        function H3c(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                            l = a.a.i + a.a.g / 2;
                            m = a.a.i + a.a.g / 2;
                            o = b.i + b.g / 2;
                            q = b.j + b.f / 2;
                            h = new rjd(o, q);
                            j = RD(Gxd(b, (umd(), Qld)), 8);
                            j.a = j.a + l;
                            j.b = j.b + m;
                            f = (h.b - j.b) / (h.a - j.a);
                            d = h.b - f * h.a;
                            p = c.i + c.g / 2;
                            r = c.j + c.f / 2;
                            i = new rjd(p, r);
                            k = RD(Gxd(c, Qld), 8);
                            k.a = k.a + l;
                            k.b = k.b + m;
                            g = (i.b - k.b) / (i.a - k.a);
                            e = i.b - g * i.a;
                            n = (d - e) / (g - f);
                            if (j.a < n && h.a < n || n < j.a && n < h.a) return false;
                            else if (k.a < n && i.a < n || n < k.a && n < i.a) return false;
                            return true;
                        }
                        function GDd(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n;
                            m = RD(Wjb(a.c, b), 190);
                            if (!m) throw Adb(new CDd('Edge did not exist in input.'));
                            j = uDd(m);
                            f = cve((!b.a && (b.a = new C5d(F4, b, 6, 6)), b.a));
                            h = !f;
                            if (h) {
                                n = new MB;
                                c = new pFd(a, j, n);
                                ave((!b.a && (b.a = new C5d(F4, b, 6, 6)), b.a), c);
                                sC(m, mIe, n);
                            }
                            e = Hxd(b, (umd(), cld));
                            if (e) {
                                k = RD(Gxd(b, cld), 75);
                                g = !k || bve(k);
                                i = !g;
                                if (i) {
                                    l = new MB;
                                    d = new xFd(l);
                                    xgb(k, d);
                                    sC(m, 'junctionPoints', l);
                                }
                            }
                            sDd(m, 'container', kzd(b).k);
                            return null;
                        }
                        function fZc(a, b, c, d) {
                            var e, f, g, h, i, j;
                            if (!gr(b)) {
                                j = c.eh((ZD(b, 16) ? RD(b, 16).gc() : Kr(b.Kc())) / a.a | 0);
                                j.Ug(OEe, 1);
                                i = new iZc;
                                h = 0;
                                if (d == (Cmd(), ymd) || d == zmd) for(g = b.Kc(); g.Ob();){
                                    e = RD(g.Pb(), 40);
                                    i = Al(cD(WC(cJ, 1), rve, 20, 0, [
                                        i,
                                        new dXc(e)
                                    ]));
                                    h < e.f.a && (h = e.f.a);
                                }
                                else for(g = b.Kc(); g.Ob();){
                                    e = RD(g.Pb(), 40);
                                    i = Al(cD(WC(cJ, 1), rve, 20, 0, [
                                        i,
                                        new dXc(e)
                                    ]));
                                    h < e.f.b && (h = e.f.b);
                                }
                                for(f = b.Kc(); f.Ob();){
                                    e = RD(f.Pb(), 40);
                                    pQb(e, (q$c(), d$c), h);
                                }
                                j.Vg();
                                fZc(a, i, c, d);
                            }
                        }
                        function XFb(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            this.a = a;
                            this.b = b;
                            this.c = c;
                            this.e = dv(cD(WC($M, 1), rve, 177, 0, [
                                new TFb(a, b),
                                new TFb(b, c),
                                new TFb(c, a)
                            ]));
                            this.f = dv(cD(WC(l3, 1), Nve, 8, 0, [
                                a,
                                b,
                                c
                            ]));
                            this.d = (d = ojd(ajd(this.b), this.a), e = ojd(ajd(this.c), this.a), f = ojd(ajd(this.c), this.b), g = d.a * (this.a.a + this.b.a) + d.b * (this.a.b + this.b.b), h = e.a * (this.a.a + this.c.a) + e.b * (this.a.b + this.c.b), i = 2 * (d.a * f.b - d.b * f.a), j = (e.b * g - d.b * h) / i, k = (d.a * h - e.a * g) / i, new rjd(j, k));
                        }
                        function X0b(a, b) {
                            var c, d, e, f, g, h;
                            f = a.c;
                            g = a.d;
                            Y0b(a, null);
                            Z0b(a, null);
                            b && Heb(TD(mQb(g, (Ywc(), mwc)))) ? Y0b(a, q2b(g.i, (BEc(), zEc), (qpd(), Xod))) : Y0b(a, g);
                            b && Heb(TD(mQb(f, (Ywc(), Gwc)))) ? Z0b(a, q2b(f.i, (BEc(), yEc), (qpd(), ppd))) : Z0b(a, f);
                            for(d = new Anb(a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 72);
                                e = RD(mQb(c, (yCc(), wAc)), 278);
                                e == (Omd(), Nmd) ? pQb(c, wAc, Mmd) : e == Mmd && pQb(c, wAc, Nmd);
                            }
                            h = Heb(TD(mQb(a, (Ywc(), Nwc))));
                            pQb(a, Nwc, (Geb(), h ? false : true));
                            a.a = Ijd(a.a);
                        }
                        function lWc(a, b) {
                            var c, d, e, f, g;
                            c = jWc(RD(mQb(b, (h_c(), H$c)), 88));
                            if (a.b.b == 0) return null;
                            g = RD(zDb(GDb(new SDb(null, new Swb(a.b, 16)), new UWc), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), vBb)
                            ]))), 15);
                            f = RD(zDb(CDb(new SDb(null, new Swb(b.b, 16)), new CWc(g)), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                vBb
                            ]))), 15);
                            e = UD(Lvb(JDb(GDb(f.Oc(), new EWc(c)), (urb(), urb(), srb))));
                            d = RD(Lvb(DDb(CDb(f.Oc(), new GWc(c, e)))), 40);
                            return d;
                        }
                        function vOc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
                            c = eJb(new gJb, a.f);
                            j = a.i[b.c.i.p];
                            n = a.i[b.d.i.p];
                            i = b.c;
                            m = b.d;
                            h = i.a.b;
                            l = m.a.b;
                            j.b || (h += i.n.b);
                            n.b || (l += m.n.b);
                            k = eE($wnd.Math.max(0, h - l));
                            g = eE($wnd.Math.max(0, l - h));
                            o = (p = $wnd.Math.max(1, RD(mQb(b, (yCc(), MBc)), 17).a), q = hOc(b.c.i.k, b.d.i.k), p * q);
                            e = rIb(uIb(tIb(sIb(vIb(new wIb, o), g), c), RD(Wjb(a.k, b.c), 125)));
                            f = rIb(uIb(tIb(sIb(vIb(new wIb, o), k), c), RD(Wjb(a.k, b.d), 125)));
                            d = new QOc(e, f);
                            a.c[b.p] = d;
                        }
                        function MTb(a, b, c) {
                            var d, e, f, g, h, i;
                            d = 0;
                            for(f = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); f.e != f.i.gc();){
                                e = RD(bMd(f), 27);
                                g = '';
                                (!e.n && (e.n = new C5d(I4, e, 1, 7)), e.n).i == 0 || (g = RD(QHd((!e.n && (e.n = new C5d(I4, e, 1, 7)), e.n), 0), 135).a);
                                h = new lUb(g);
                                kQb(h, e);
                                pQb(h, (JVb(), HVb), e);
                                h.a = d++;
                                h.d.a = e.i + e.g / 2;
                                h.d.b = e.j + e.f / 2;
                                h.e.a = $wnd.Math.max(e.g, 1);
                                h.e.b = $wnd.Math.max(e.f, 1);
                                Rmb(b.e, h);
                                rtb(c.f, e, h);
                                i = RD(Gxd(e, (yVb(), jVb)), 101);
                                i == (Bod(), Aod) && (i = zod);
                            }
                        }
                        function bec(a, b) {
                            var c, d, e, f, g, h, i;
                            b.Ug('Layer constraint postprocessing', 1);
                            i = a.b;
                            if (i.c.length != 0) {
                                d = (tFb(0, i.c.length), RD(i.c[0], 30));
                                g = RD(Vmb(i, i.c.length - 1), 30);
                                c = new R4b(a);
                                f = new R4b(a);
                                _dc(a, d, g, c, f);
                                c.a.c.length == 0 || (wFb(0, i.c.length), XEb(i.c, 0, c));
                                f.a.c.length == 0 || ZEb(i.c, f);
                            }
                            if (nQb(a, (Ywc(), lwc))) {
                                e = new R4b(a);
                                h = new R4b(a);
                                cec(a, e, h);
                                e.a.c.length == 0 || (wFb(0, i.c.length), XEb(i.c, 0, e));
                                h.a.c.length == 0 || ZEb(i.c, h);
                            }
                            b.Vg();
                        }
                        function zte(a) {
                            var b, c, d;
                            switch(a){
                                case 91:
                                case 93:
                                case 45:
                                case 94:
                                case 44:
                                case 92:
                                    d = '\\' + String.fromCharCode(a & Bwe);
                                    break;
                                case 12:
                                    d = '\\f';
                                    break;
                                case 10:
                                    d = '\\n';
                                    break;
                                case 13:
                                    d = '\\r';
                                    break;
                                case 9:
                                    d = '\\t';
                                    break;
                                case 27:
                                    d = '\\e';
                                    break;
                                default:
                                    if (a < 32) {
                                        c = (b = a >>> 0, '0' + b.toString(16));
                                        d = '\\x' + zhb(c, c.length - 2, c.length);
                                    } else if (a >= txe) {
                                        c = (b = a >>> 0, '0' + b.toString(16));
                                        d = '\\v' + zhb(c, c.length - 6, c.length);
                                    } else d = '' + String.fromCharCode(a & Bwe);
                            }
                            return d;
                        }
                        function Ugc(a) {
                            var b, c, d;
                            if (Dod(RD(mQb(a, (yCc(), BBc)), 101))) for(c = new Anb(a.j); c.a < c.c.c.length;){
                                b = RD(ynb(c), 12);
                                b.j == (qpd(), opd) && (d = RD(mQb(b, (Ywc(), Iwc)), 10), d ? Q3b(b, RD(mQb(d, hwc), 64)) : b.e.c.length - b.g.c.length < 0 ? Q3b(b, Xod) : Q3b(b, ppd));
                            }
                            else {
                                for(c = new Anb(a.j); c.a < c.c.c.length;){
                                    b = RD(ynb(c), 12);
                                    d = RD(mQb(b, (Ywc(), Iwc)), 10);
                                    d ? Q3b(b, RD(mQb(d, hwc), 64)) : b.e.c.length - b.g.c.length < 0 ? Q3b(b, (qpd(), Xod)) : Q3b(b, (qpd(), ppd));
                                }
                                pQb(a, BBc, (Bod(), yod));
                            }
                        }
                        function wUc(a) {
                            var b, c, d, e, f, g;
                            this.e = new bnb;
                            this.a = new bnb;
                            for(c = a.b - 1; c < 3; c++)hu(a, 0, RD(ju(a, 0), 8));
                            if (a.b < 4) throw Adb(new agb('At (least dimension + 1) control points are necessary!'));
                            else {
                                this.b = 3;
                                this.d = true;
                                this.c = false;
                                rUc(this, a.b + this.b - 1);
                                g = new bnb;
                                f = new Anb(this.e);
                                for(b = 0; b < this.b - 1; b++)Rmb(g, UD(ynb(f)));
                                for(e = Sub(a, 0); e.b != e.d.c;){
                                    d = RD(evb(e), 8);
                                    Rmb(g, UD(ynb(f)));
                                    Rmb(this.a, new BUc(d, g));
                                    tFb(0, g.c.length);
                                    g.c.splice(0, 1);
                                }
                            }
                        }
                        function Sdc(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            for(f = new Anb(a.b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 30);
                                for(h = new Anb(e.a); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 10);
                                    if (g.k == (r3b(), n3b)) {
                                        i = (j = RD(hs(new is(Mr(Z2b(g).a.Kc(), new ir))), 18), k = RD(hs(new is(Mr(a3b(g).a.Kc(), new ir))), 18), !Heb(TD(mQb(j, (Ywc(), Nwc)))) || !Heb(TD(mQb(k, Nwc)))) ? b : Qnd(b);
                                        Qdc(g, i);
                                    }
                                    for(d = new is(Mr(a3b(g).a.Kc(), new ir)); gs(d);){
                                        c = RD(hs(d), 18);
                                        i = Heb(TD(mQb(c, (Ywc(), Nwc)))) ? Qnd(b) : b;
                                        Pdc(c, i);
                                    }
                                }
                            }
                        }
                        function V8c(a, b, c, d, e) {
                            var f, g, h;
                            if (c.f >= b.o && c.f <= b.f || b.a * 0.5 <= c.f && b.a * 1.5 >= c.f) {
                                g = RD(Vmb(b.n, b.n.c.length - 1), 209);
                                if (g.e + g.d + c.g + e <= d && (f = RD(Vmb(b.n, b.n.c.length - 1), 209), f.f - a.f + c.f <= a.b || a.a.c.length == 1)) {
                                    K9c(b, c);
                                    return true;
                                } else if (b.s + c.g <= d && (b.t + b.d + c.f + e <= a.b || a.a.c.length == 1)) {
                                    Rmb(b.b, c);
                                    h = RD(Vmb(b.n, b.n.c.length - 1), 209);
                                    Rmb(b.n, new _9c(b.s, h.f + h.a + b.i, b.i));
                                    W9c(RD(Vmb(b.n, b.n.c.length - 1), 209), c);
                                    M9c(b, c);
                                    return true;
                                }
                            }
                            return false;
                        }
                        function xLd(a, b, c) {
                            var d, e, f, g;
                            if (a.Pj()) {
                                e = null;
                                f = a.Qj();
                                d = a.Ij(1, g = UHd(a, b, c), c, b, f);
                                if (a.Mj() && !(a.Yi() && g != null ? pb(g, c) : dE(g) === dE(c))) {
                                    g != null && (e = a.Oj(g, e));
                                    e = a.Nj(c, e);
                                    a.Tj() && (e = a.Wj(g, c, e));
                                    if (!e) a.Jj(d);
                                    else {
                                        e.nj(d);
                                        e.oj();
                                    }
                                } else {
                                    a.Tj() && (e = a.Wj(g, c, e));
                                    if (!e) a.Jj(d);
                                    else {
                                        e.nj(d);
                                        e.oj();
                                    }
                                }
                                return g;
                            } else {
                                g = UHd(a, b, c);
                                if (a.Mj() && !(a.Yi() && g != null ? pb(g, c) : dE(g) === dE(c))) {
                                    e = null;
                                    g != null && (e = a.Oj(g, null));
                                    e = a.Nj(c, e);
                                    !!e && e.oj();
                                }
                                return g;
                            }
                        }
                        function Rsc(a, b) {
                            var c, d, e, f, g;
                            b.Ug('Path-Like Graph Wrapping', 1);
                            if (a.b.c.length == 0) {
                                b.Vg();
                                return;
                            }
                            e = new ysc(a);
                            g = (e.i == null && (e.i = tsc(e, new Asc)), Kfb(e.i) * e.f);
                            c = g / (e.i == null && (e.i = tsc(e, new Asc)), Kfb(e.i));
                            if (e.b > c) {
                                b.Vg();
                                return;
                            }
                            switch(RD(mQb(a, (yCc(), rCc)), 351).g){
                                case 2:
                                    f = new Ksc;
                                    break;
                                case 0:
                                    f = new zrc;
                                    break;
                                default:
                                    f = new Nsc;
                            }
                            d = f.og(a, e);
                            if (!f.pg()) switch(RD(mQb(a, xCc), 352).g){
                                case 2:
                                    d = Wsc(e, d);
                                    break;
                                case 1:
                                    d = Usc(e, d);
                            }
                            Qsc(a, e, d);
                            b.Vg();
                        }
                        function mB(a, b) {
                            var c, d, e, f, g, h, i, j;
                            b %= 24;
                            if (a.q.getHours() != b) {
                                d = new $wnd.Date(a.q.getTime());
                                d.setDate(d.getDate() + 1);
                                h = a.q.getTimezoneOffset() - d.getTimezoneOffset();
                                if (h > 0) {
                                    i = h / 60 | 0;
                                    j = h % 60;
                                    e = a.q.getDate();
                                    c = a.q.getHours();
                                    c + i >= 24 && ++e;
                                    f = new $wnd.Date(a.q.getFullYear(), a.q.getMonth(), e, b + i, a.q.getMinutes() + j, a.q.getSeconds(), a.q.getMilliseconds());
                                    a.q.setTime(f.getTime());
                                }
                            }
                            g = a.q.getTime();
                            a.q.setTime(g + 3600000);
                            a.q.getHours() != b && a.q.setTime(g);
                        }
                        function kKc(a, b) {
                            var c, d, e, f;
                            Nwb(a.d, a.e);
                            a.c.a.$b();
                            if (Kfb(UD(mQb(b.j, (yCc(), Zzc)))) != 0 || Kfb(UD(mQb(b.j, Zzc))) != 0) {
                                c = Hze;
                                dE(mQb(b.j, cAc)) !== dE((kEc(), hEc)) && pQb(b.j, (Ywc(), jwc), (Geb(), true));
                                f = RD(mQb(b.j, gCc), 17).a;
                                for(e = 0; e < f; e++){
                                    d = uKc(a, b);
                                    if (d < c) {
                                        c = d;
                                        xKc(a);
                                        if (c == 0) break;
                                    }
                                }
                            } else {
                                c = lve;
                                dE(mQb(b.j, cAc)) !== dE((kEc(), hEc)) && pQb(b.j, (Ywc(), jwc), (Geb(), true));
                                f = RD(mQb(b.j, gCc), 17).a;
                                for(e = 0; e < f; e++){
                                    d = vKc(a, b);
                                    if (d < c) {
                                        c = d;
                                        xKc(a);
                                        if (c == 0) break;
                                    }
                                }
                            }
                        }
                        function Vsc(a, b) {
                            var c, d, e, f, g, h, i, j;
                            g = new bnb;
                            h = 0;
                            c = 0;
                            i = 0;
                            while(h < b.c.length - 1 && c < a.gc()){
                                d = RD(a.Xb(c), 17).a + i;
                                while((tFb(h + 1, b.c.length), RD(b.c[h + 1], 17)).a < d)++h;
                                j = 0;
                                f = d - (tFb(h, b.c.length), RD(b.c[h], 17)).a;
                                e = (tFb(h + 1, b.c.length), RD(b.c[h + 1], 17)).a - d;
                                f > e && ++j;
                                Rmb(g, (tFb(h + j, b.c.length), RD(b.c[h + j], 17)));
                                i += (tFb(h + j, b.c.length), RD(b.c[h + j], 17)).a - d;
                                ++c;
                                while(c < a.gc() && RD(a.Xb(c), 17).a + i <= (tFb(h + j, b.c.length), RD(b.c[h + j], 17)).a)++c;
                                h += 1 + j;
                            }
                            return g;
                        }
                        function VGc(a, b) {
                            var c, d, e, f, g;
                            for(g = new is(Mr(Z2b(b).a.Kc(), new ir)); gs(g);){
                                f = RD(hs(g), 18);
                                if (a.f.b == 0) {
                                    e = f.c.i.k == (r3b(), p3b) && !!f.c.i.c && f.c.i.c.p == a.c;
                                    if (gs(new is(Mr(Z2b(f.c.i).a.Kc(), new ir)))) {
                                        c = RD(hs(new is(Mr(Z2b(f.c.i).a.Kc(), new ir))), 18).c.i.c;
                                        d = f.c.i.k == n3b && !!c && c.p == a.c;
                                    } else d = false;
                                } else {
                                    e = f.c.i.k == (r3b(), p3b) && f.c.i.p == a.c;
                                    d = f.c.i.k == n3b && RD(hs(new is(Mr(Z2b(f.c.i).a.Kc(), new ir))), 18).c.i.p == a.c;
                                }
                                if (e || d) return true;
                            }
                            return false;
                        }
                        function DHc(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            m = new bnb;
                            r = Xx(d);
                            q = b * a.a;
                            l = 0;
                            o = 0;
                            f = new _sb;
                            g = new _sb;
                            h = new bnb;
                            s = 0;
                            t = 0;
                            n = 0;
                            p = 0;
                            j = 0;
                            k = 0;
                            while(r.a.gc() != 0){
                                i = HHc(r, e, g);
                                if (i) {
                                    r.a.Bc(i);
                                    ZEb(h.c, i);
                                    f.a.zc(i, f);
                                    o = a.f[i.p];
                                    s += a.e[i.p] - o * a.b;
                                    l = a.c[i.p];
                                    t += l * a.b;
                                    k += o * a.b;
                                    p += a.e[i.p];
                                }
                                if (!i || r.a.gc() == 0 || s >= q && a.e[i.p] > o * a.b || t >= c * q) {
                                    ZEb(m.c, h);
                                    h = new bnb;
                                    ye(g, f);
                                    f.a.$b();
                                    j -= k;
                                    n = $wnd.Math.max(n, j * a.b + p);
                                    j += t;
                                    s = t;
                                    t = 0;
                                    k = 0;
                                    p = 0;
                                }
                            }
                            return new Ptd(n, m);
                        }
                        function pYd(a) {
                            var b, c, d, e, f, g, h;
                            if (!a.d) {
                                h = new v_d;
                                b = iYd;
                                f = b.a.zc(a, b);
                                if (f == null) {
                                    for(d = new dMd(zYd(a)); d.e != d.i.gc();){
                                        c = RD(bMd(d), 29);
                                        YGd(h, pYd(c));
                                    }
                                    b.a.Bc(a);
                                    b.a.gc() == 0 && undefined;
                                }
                                g = h.i;
                                for(e = (!a.q && (a.q = new C5d(s7, a, 11, 10)), new dMd(a.q)); e.e != e.i.gc(); ++g)RD(bMd(e), 411);
                                YGd(h, (!a.q && (a.q = new C5d(s7, a, 11, 10)), a.q));
                                VHd(h);
                                a.d = new N$d((RD(QHd(xYd((lTd(), kTd).o), 9), 19), h.i), h.g);
                                a.e = RD(h.g, 688);
                                a.e == null && (a.e = jYd);
                                yYd(a).b &= -17;
                            }
                            return a.d;
                        }
                        function kge(a, b, c, d) {
                            var e, f, g, h, i, j;
                            j = pke(a.e.Dh(), b);
                            i = 0;
                            e = RD(a.g, 124);
                            nke();
                            if (RD(b, 69).xk()) for(g = 0; g < a.i; ++g){
                                f = e[g];
                                if (j.am(f.Lk())) {
                                    if (pb(f, c)) return i;
                                    ++i;
                                }
                            }
                            else if (c != null) {
                                for(h = 0; h < a.i; ++h){
                                    f = e[h];
                                    if (j.am(f.Lk())) {
                                        if (pb(c, f.md())) return i;
                                        ++i;
                                    }
                                }
                                if (d) {
                                    i = 0;
                                    for(g = 0; g < a.i; ++g){
                                        f = e[g];
                                        if (j.am(f.Lk())) {
                                            if (dE(c) === dE(Age(a, RD(f.md(), 58)))) return i;
                                            ++i;
                                        }
                                    }
                                }
                            } else for(g = 0; g < a.i; ++g){
                                f = e[g];
                                if (j.am(f.Lk())) {
                                    if (f.md() == null) return i;
                                    ++i;
                                }
                            }
                            return -1;
                        }
                        function Xje(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p;
                            if (c.Xh(b)) {
                                k = (n = b, !n ? null : RD(d, 54).gi(n));
                                if (k) {
                                    p = c.Nh(b, a.a);
                                    o = b.t;
                                    if (o > 1 || o == -1) {
                                        l = RD(p, 71);
                                        m = RD(k, 71);
                                        if (l.dc()) m.$b();
                                        else {
                                            g = !!Z5d(b);
                                            f = 0;
                                            for(h = a.a ? l.Kc() : l.Ii(); h.Ob();){
                                                j = RD(h.Pb(), 58);
                                                e = RD(cub(a, j), 58);
                                                if (!e) {
                                                    if (a.b && !g) {
                                                        m.Gi(f, j);
                                                        ++f;
                                                    }
                                                } else {
                                                    if (g) {
                                                        i = m.dd(e);
                                                        i == -1 ? m.Gi(f, e) : f != i && m.Ui(f, e);
                                                    } else m.Gi(f, e);
                                                    ++f;
                                                }
                                            }
                                        }
                                    } else if (p == null) k.Wb(null);
                                    else {
                                        e = cub(a, p);
                                        e == null ? a.b && !Z5d(b) && k.Wb(p) : k.Wb(e);
                                    }
                                }
                            }
                        }
                        function V9b(a, b) {
                            var c, d, e, f, g, h, i, j;
                            c = new aac;
                            for(e = new is(Mr(Z2b(b).a.Kc(), new ir)); gs(e);){
                                d = RD(hs(e), 18);
                                if (W0b(d)) continue;
                                h = d.c.i;
                                if (W9b(h, T9b)) {
                                    j = X9b(a, h, T9b, S9b);
                                    if (j == -1) continue;
                                    c.b = $wnd.Math.max(c.b, j);
                                    !c.a && (c.a = new bnb);
                                    Rmb(c.a, h);
                                }
                            }
                            for(g = new is(Mr(a3b(b).a.Kc(), new ir)); gs(g);){
                                f = RD(hs(g), 18);
                                if (W0b(f)) continue;
                                i = f.d.i;
                                if (W9b(i, S9b)) {
                                    j = X9b(a, i, S9b, T9b);
                                    if (j == -1) continue;
                                    c.d = $wnd.Math.max(c.d, j);
                                    !c.c && (c.c = new bnb);
                                    Rmb(c.c, i);
                                }
                            }
                            return c;
                        }
                        function pcc(a, b, c, d) {
                            var e, f, g, h, i, j, k;
                            if (c.d.i == b.i) return;
                            e = new j3b(a);
                            h3b(e, (r3b(), o3b));
                            pQb(e, (Ywc(), Awc), c);
                            pQb(e, (yCc(), BBc), (Bod(), wod));
                            ZEb(d.c, e);
                            g = new R3b;
                            P3b(g, e);
                            Q3b(g, (qpd(), ppd));
                            h = new R3b;
                            P3b(h, e);
                            Q3b(h, Xod);
                            k = c.d;
                            Z0b(c, g);
                            f = new a1b;
                            kQb(f, c);
                            pQb(f, RAc, null);
                            Y0b(f, h);
                            Z0b(f, k);
                            j = new Jkb(c.b, 0);
                            while(j.b < j.d.gc()){
                                i = (sFb(j.b < j.d.gc()), RD(j.d.Xb(j.c = j.b++), 72));
                                if (dE(mQb(i, wAc)) === dE((Omd(), Mmd))) {
                                    pQb(i, dwc, c);
                                    Ckb(j);
                                    Rmb(f.b, i);
                                }
                            }
                            rcc(e, g, h);
                        }
                        function occ(a, b, c, d) {
                            var e, f, g, h, i, j, k;
                            if (c.c.i == b.i) return;
                            e = new j3b(a);
                            h3b(e, (r3b(), o3b));
                            pQb(e, (Ywc(), Awc), c);
                            pQb(e, (yCc(), BBc), (Bod(), wod));
                            ZEb(d.c, e);
                            g = new R3b;
                            P3b(g, e);
                            Q3b(g, (qpd(), ppd));
                            h = new R3b;
                            P3b(h, e);
                            Q3b(h, Xod);
                            Z0b(c, g);
                            f = new a1b;
                            kQb(f, c);
                            pQb(f, RAc, null);
                            Y0b(f, h);
                            Z0b(f, b);
                            rcc(e, g, h);
                            j = new Jkb(c.b, 0);
                            while(j.b < j.d.gc()){
                                i = (sFb(j.b < j.d.gc()), RD(j.d.Xb(j.c = j.b++), 72));
                                k = RD(mQb(i, wAc), 278);
                                if (k == (Omd(), Mmd)) {
                                    nQb(i, dwc) || pQb(i, dwc, c);
                                    Ckb(j);
                                    Rmb(f.b, i);
                                }
                            }
                        }
                        function Sjb(a) {
                            Ljb();
                            var b, c, d, e;
                            b = eE(a);
                            if (a < Kjb.length) return Kjb[b];
                            else if (a <= 50) return Yib((Pib(), Mib), b);
                            else if (a <= Awe) return Zib(Yib(Jjb[1], b), b);
                            if (a > 1000000) throw Adb(new teb('power of ten too big'));
                            if (a <= lve) return Zib(Yib(Jjb[1], b), b);
                            d = Yib(Jjb[1], lve);
                            e = d;
                            c = Hdb(a - lve);
                            b = eE(a % lve);
                            while(Ddb(c, lve) > 0){
                                e = Wib(e, d);
                                c = Vdb(c, lve);
                            }
                            e = Wib(e, Yib(Jjb[1], b));
                            e = Zib(e, lve);
                            c = Hdb(a - lve);
                            while(Ddb(c, lve) > 0){
                                e = Zib(e, lve);
                                c = Vdb(c, lve);
                            }
                            e = Zib(e, b);
                            return e;
                        }
                        function s9b(a) {
                            var b, c, d, e, f, g, h, i, j, k;
                            for(i = new Anb(a.a); i.a < i.c.c.length;){
                                h = RD(ynb(i), 10);
                                if (h.k != (r3b(), m3b)) continue;
                                e = RD(mQb(h, (Ywc(), hwc)), 64);
                                if (e == (qpd(), Xod) || e == ppd) for(d = new is(Mr(W2b(h).a.Kc(), new ir)); gs(d);){
                                    c = RD(hs(d), 18);
                                    b = c.a;
                                    if (b.b == 0) continue;
                                    j = c.c;
                                    if (j.i == h) {
                                        f = (sFb(b.b != 0), RD(b.a.a.c, 8));
                                        f.b = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                            j.i.n,
                                            j.n,
                                            j.a
                                        ])).b;
                                    }
                                    k = c.d;
                                    if (k.i == h) {
                                        g = (sFb(b.b != 0), RD(b.c.b.c, 8));
                                        g.b = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                            k.i.n,
                                            k.n,
                                            k.a
                                        ])).b;
                                    }
                                }
                            }
                        }
                        function Nlc(a, b, c, d) {
                            var e, f, g;
                            this.j = new bnb;
                            this.k = new bnb;
                            this.b = new bnb;
                            this.c = new bnb;
                            this.e = new Tid;
                            this.i = new Ejd;
                            this.f = new cHb;
                            this.d = new bnb;
                            this.g = new bnb;
                            Rmb(this.b, a);
                            Rmb(this.b, b);
                            this.e.c = $wnd.Math.min(a.a, b.a);
                            this.e.d = $wnd.Math.min(a.b, b.b);
                            this.e.b = $wnd.Math.abs(a.a - b.a);
                            this.e.a = $wnd.Math.abs(a.b - b.b);
                            e = RD(mQb(d, (yCc(), RAc)), 75);
                            if (e) for(g = Sub(e, 0); g.b != g.d.c;){
                                f = RD(evb(g), 8);
                                rGb(f.a, a.a) && Mub(this.i, f);
                            }
                            !!c && Rmb(this.j, c);
                            Rmb(this.k, d);
                        }
                        function vSc(a, b, c, d) {
                            var e, f, g, h, i, j, k;
                            h = -1;
                            for(k = new Anb(a); k.a < k.c.c.length;){
                                j = RD(ynb(k), 118);
                                j.g = h--;
                                e = Ydb(mDb(IDb(CDb(new SDb(null, new Swb(j.f, 16)), new xSc), new zSc)).d);
                                f = Ydb(mDb(IDb(CDb(new SDb(null, new Swb(j.k, 16)), new BSc), new DSc)).d);
                                g = e;
                                i = f;
                                if (!d) {
                                    g = Ydb(mDb(IDb(new SDb(null, new Swb(j.f, 16)), new FSc)).d);
                                    i = Ydb(mDb(IDb(new SDb(null, new Swb(j.k, 16)), new HSc)).d);
                                }
                                j.d = g;
                                j.a = e;
                                j.i = i;
                                j.b = f;
                                i == 0 ? Pub(c, j, c.c.b, c.c) : g == 0 && Pub(b, j, b.c.b, b.c);
                            }
                        }
                        function Qdc(a, b) {
                            var c, d, e, f, g, h;
                            if (a.k == (r3b(), n3b)) {
                                c = a.k == n3b && !QDb(CDb(RD(mQb(a, (Ywc(), Mwc)), 15).Oc(), new PAb(new x3b))).Bd((xDb(), wDb)) ? (Pnd(), Nnd) : b;
                                pQb(a, (Ywc(), swc), c);
                                if (c != (Pnd(), Mnd)) {
                                    d = RD(mQb(a, Awc), 18);
                                    h = Kfb(UD(mQb(d, (yCc(), FAc))));
                                    g = 0;
                                    if (c == Lnd) g = a.o.b - $wnd.Math.ceil(h / 2);
                                    else if (c == Nnd) {
                                        g = $wnd.Math.ceil(a.o.b - Kfb(UD(mQb(Y2b(a), VBc))) - h) / 2;
                                        a.o.b -= Kfb(UD(mQb(Y2b(a), VBc)));
                                        a.o.b -= h;
                                    }
                                    for(f = new Anb(a.j); f.a < f.c.c.length;){
                                        e = RD(ynb(f), 12);
                                        e.n.b = g;
                                    }
                                }
                            }
                        }
                        function XQc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l;
                            e = true;
                            for(g = new Anb(a.b); g.a < g.c.c.length;){
                                f = RD(ynb(g), 30);
                                j = pxe;
                                k = null;
                                for(i = new Anb(f.a); i.a < i.c.c.length;){
                                    h = RD(ynb(i), 10);
                                    l = Kfb(b.p[h.p]) + Kfb(b.d[h.p]) - h.d.d;
                                    d = Kfb(b.p[h.p]) + Kfb(b.d[h.p]) + h.o.b + h.d.a;
                                    if (l > j && d > j) {
                                        k = h;
                                        j = Kfb(b.p[h.p]) + Kfb(b.d[h.p]) + h.o.b + h.d.a;
                                    } else {
                                        e = false;
                                        c._g() && c.bh('bk node placement breaks on ' + h + ' which should have been after ' + k);
                                        break;
                                    }
                                }
                                if (!e) break;
                            }
                            c._g() && c.bh(b + ' is feasible: ' + e);
                            return e;
                        }
                        function Dfc(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m;
                            f = new j3b(a);
                            h3b(f, (r3b(), q3b));
                            pQb(f, (yCc(), BBc), (Bod(), wod));
                            e = 0;
                            if (b) {
                                g = new R3b;
                                pQb(g, (Ywc(), Awc), b);
                                pQb(f, Awc, b.i);
                                Q3b(g, (qpd(), ppd));
                                P3b(g, f);
                                m = s2b(b.e);
                                for(j = m, k = 0, l = j.length; k < l; ++k){
                                    i = j[k];
                                    Z0b(i, g);
                                }
                                pQb(b, Iwc, f);
                                ++e;
                            }
                            if (c) {
                                h = new R3b;
                                pQb(f, (Ywc(), Awc), c.i);
                                pQb(h, Awc, c);
                                Q3b(h, (qpd(), Xod));
                                P3b(h, f);
                                m = s2b(c.g);
                                for(j = m, k = 0, l = j.length; k < l; ++k){
                                    i = j[k];
                                    Y0b(i, h);
                                }
                                pQb(c, Iwc, f);
                                ++e;
                            }
                            pQb(f, (Ywc(), $vc), sgb(e));
                            ZEb(d.c, f);
                            return f;
                        }
                        function Bgd(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n;
                            for(c = (j = new glb(a.c.b).a.vc().Kc(), new llb(j)); c.a.Ob();){
                                b = (h = RD(c.a.Pb(), 44), RD(h.md(), 143));
                                e = b.a;
                                e == null && (e = '');
                                d = tgd(a.c, e);
                                !d && e.length == 0 && (d = Fgd(a));
                                !!d && !ze(d.c, b, false) && Mub(d.c, b);
                            }
                            for(g = Sub(a.a, 0); g.b != g.d.c;){
                                f = RD(evb(g), 487);
                                k = ugd(a.c, f.a);
                                n = ugd(a.c, f.b);
                                !!k && !!n && Mub(k.c, new Ptd(n, f.c));
                            }
                            Xub(a.a);
                            for(m = Sub(a.b, 0); m.b != m.d.c;){
                                l = RD(evb(m), 487);
                                b = rgd(a.c, l.a);
                                i = ugd(a.c, l.b);
                                !!b && !!i && Mfd(b, i, l.c);
                            }
                            Xub(a.b);
                        }
                        function QId(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n;
                            f = new vC(a);
                            g = new IEd;
                            e = (wo(g.g), wo(g.j), akb(g.b), wo(g.d), wo(g.i), akb(g.k), akb(g.c), akb(g.e), n = DEd(g, f, null), AEd(g, f), n);
                            if (b) {
                                j = new vC(b);
                                h = RId(j);
                                msd(e, cD(WC(j4, 1), rve, 536, 0, [
                                    h
                                ]));
                            }
                            m = false;
                            l = false;
                            if (c) {
                                j = new vC(c);
                                RIe in j.a && (m = qC(j, RIe).qe().a);
                                SIe in j.a && (l = qC(j, SIe).qe().a);
                            }
                            k = Kqd(Mqd(new Oqd, m), l);
                            Eed(new Hed, e, k);
                            RIe in f.a && sC(f, RIe, null);
                            if (m || l) {
                                i = new uC;
                                NId(k, i, m, l);
                                sC(f, RIe, i);
                            }
                            d = new nFd(g);
                            dve(new zId(e), d);
                        }
                        function FA(a, b, c) {
                            var d, e, f, g, h, i, j, k, l;
                            g = new DB;
                            j = cD(WC(kE, 1), Pwe, 28, 15, [
                                0
                            ]);
                            e = -1;
                            f = 0;
                            d = 0;
                            for(i = 0; i < a.b.c.length; ++i){
                                k = RD(Vmb(a.b, i), 443);
                                if (k.b > 0) {
                                    if (e < 0 && k.a) {
                                        e = i;
                                        f = j[0];
                                        d = 0;
                                    }
                                    if (e >= 0) {
                                        h = k.b;
                                        if (i == e) {
                                            h -= d++;
                                            if (h == 0) return 0;
                                        }
                                        if (!MA(b, j, k, h, g)) {
                                            i = e - 1;
                                            j[0] = f;
                                            continue;
                                        }
                                    } else {
                                        e = -1;
                                        if (!MA(b, j, k, 0, g)) return 0;
                                    }
                                } else {
                                    e = -1;
                                    if (ihb(k.c, 0) == 32) {
                                        l = j[0];
                                        KA(b, j);
                                        if (j[0] > l) continue;
                                    } else if (xhb(b, k.c, j[0])) {
                                        j[0] += k.c.length;
                                        continue;
                                    }
                                    return 0;
                                }
                            }
                            if (!CB(g, c)) return 0;
                            return j[0];
                        }
                        function qWb(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            k = new pwb(new GWb(c));
                            h = $C(xdb, Hye, 28, a.f.e.c.length, 16, 1);
                            Snb(h, h.length);
                            c[b.a] = 0;
                            for(j = new Anb(a.f.e); j.a < j.c.c.length;){
                                i = RD(ynb(j), 153);
                                i.a != b.a && (c[i.a] = lve);
                                zFb(lwb(k, i), Bxe);
                            }
                            while(k.b.c.length != 0){
                                l = RD(mwb(k), 153);
                                h[l.a] = true;
                                for(f = ru(new su(a.b, l), 0); f.c;){
                                    e = RD(Lu(f), 290);
                                    m = tWb(e, l);
                                    if (h[m.a]) continue;
                                    nQb(e, (dWb(), TVb)) ? g = Kfb(UD(mQb(e, TVb))) : g = a.c;
                                    d = c[l.a] + g;
                                    if (d < c[m.a]) {
                                        c[m.a] = d;
                                        nwb(k, m);
                                        zFb(lwb(k, m), Bxe);
                                    }
                                }
                            }
                        }
                        function iPb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o;
                            g = a.o;
                            d = $C(kE, Pwe, 28, g, 15, 1);
                            e = $C(kE, Pwe, 28, g, 15, 1);
                            c = a.p;
                            b = $C(kE, Pwe, 28, c, 15, 1);
                            f = $C(kE, Pwe, 28, c, 15, 1);
                            for(j = 0; j < g; j++){
                                l = 0;
                                while(l < c && !PPb(a, j, l))++l;
                                d[j] = l;
                            }
                            for(k = 0; k < g; k++){
                                l = c - 1;
                                while(l >= 0 && !PPb(a, k, l))--l;
                                e[k] = l;
                            }
                            for(n = 0; n < c; n++){
                                h = 0;
                                while(h < g && !PPb(a, h, n))++h;
                                b[n] = h;
                            }
                            for(o = 0; o < c; o++){
                                h = g - 1;
                                while(h >= 0 && !PPb(a, h, o))--h;
                                f[o] = h;
                            }
                            for(i = 0; i < g; i++)for(m = 0; m < c; m++)i < f[m] && i > b[m] && m < e[i] && m > d[i] && TPb(a, i, m, false, true);
                        }
                        function hUb(a) {
                            var b, c, d, e, f, g, h, i;
                            c = Heb(TD(mQb(a, (yVb(), $Ub))));
                            f = a.a.c.d;
                            h = a.a.d.d;
                            if (c) {
                                g = ijd(ojd(new rjd(h.a, h.b), f), 0.5);
                                i = ijd(ajd(a.e), 0.5);
                                b = ojd($id(new rjd(f.a, f.b), g), i);
                                mjd(a.d, b);
                            } else {
                                e = Kfb(UD(mQb(a.a, qVb)));
                                d = a.d;
                                if (f.a >= h.a) {
                                    if (f.b >= h.b) {
                                        d.a = h.a + (f.a - h.a) / 2 + e;
                                        d.b = h.b + (f.b - h.b) / 2 - e - a.e.b;
                                    } else {
                                        d.a = h.a + (f.a - h.a) / 2 + e;
                                        d.b = f.b + (h.b - f.b) / 2 + e;
                                    }
                                } else if (f.b >= h.b) {
                                    d.a = f.a + (h.a - f.a) / 2 + e;
                                    d.b = h.b + (f.b - h.b) / 2 + e;
                                } else {
                                    d.a = f.a + (h.a - f.a) / 2 + e;
                                    d.b = f.b + (h.b - f.b) / 2 - e - a.e.b;
                                }
                            }
                        }
                        function qYd(a) {
                            var b, c, d, e, f, g, h, i;
                            if (!a.f) {
                                i = new a_d;
                                h = new a_d;
                                b = iYd;
                                g = b.a.zc(a, b);
                                if (g == null) {
                                    for(f = new dMd(zYd(a)); f.e != f.i.gc();){
                                        e = RD(bMd(f), 29);
                                        YGd(i, qYd(e));
                                    }
                                    b.a.Bc(a);
                                    b.a.gc() == 0 && undefined;
                                }
                                for(d = (!a.s && (a.s = new C5d(y7, a, 21, 17)), new dMd(a.s)); d.e != d.i.gc();){
                                    c = RD(bMd(d), 179);
                                    ZD(c, 102) && WGd(h, RD(c, 19));
                                }
                                VHd(h);
                                a.r = new s_d(a, (RD(QHd(xYd((lTd(), kTd).o), 6), 19), h.i), h.g);
                                YGd(i, a.r);
                                VHd(i);
                                a.f = new N$d((RD(QHd(xYd(kTd.o), 5), 19), i.i), i.g);
                                yYd(a).b &= -3;
                            }
                            return a.f;
                        }
                        function uSb(a) {
                            Cgd(a, new Pfd($fd(Xfd(Zfd(Yfd(new agd, Aze), 'ELK DisCo'), 'Layouter for arranging unconnected subgraphs. The subgraphs themselves are, by default, not laid out.'), new xSb)));
                            Agd(a, Aze, Bze, iGd(sSb));
                            Agd(a, Aze, Cze, iGd(mSb));
                            Agd(a, Aze, Dze, iGd(hSb));
                            Agd(a, Aze, Eze, iGd(nSb));
                            Agd(a, Aze, Bye, iGd(qSb));
                            Agd(a, Aze, Cye, iGd(pSb));
                            Agd(a, Aze, Aye, iGd(rSb));
                            Agd(a, Aze, Dye, iGd(oSb));
                            Agd(a, Aze, vze, iGd(jSb));
                            Agd(a, Aze, wze, iGd(iSb));
                            Agd(a, Aze, xze, iGd(kSb));
                            Agd(a, Aze, yze, iGd(lSb));
                        }
                        function qAd() {
                            qAd = geb;
                            oAd = cD(WC(hE, 1), zwe, 28, 15, [
                                48,
                                49,
                                50,
                                51,
                                52,
                                53,
                                54,
                                55,
                                56,
                                57,
                                65,
                                66,
                                67,
                                68,
                                69,
                                70
                            ]);
                            pAd = new RegExp('[ \t\n\r\f]+');
                            try {
                                nAd = cD(WC(h8, 1), rve, 2114, 0, [
                                    new c2d((WA(), YA("yyyy-MM-dd'T'HH:mm:ss'.'SSSZ", _A(($A(), $A(), ZA))))),
                                    new c2d(YA("yyyy-MM-dd'T'HH:mm:ss'.'SSS", _A(ZA))),
                                    new c2d(YA("yyyy-MM-dd'T'HH:mm:ss", _A(ZA))),
                                    new c2d(YA("yyyy-MM-dd'T'HH:mm", _A(ZA))),
                                    new c2d(YA('yyyy-MM-dd', _A(ZA)))
                                ]);
                            } catch (a) {
                                a = zdb(a);
                                if (!ZD(a, 82)) throw Adb(a);
                            }
                        }
                        function uKc(a, b) {
                            var c, d, e, f;
                            e = Kwb(a.d, 1) != 0;
                            d = mKc(a, b);
                            if (d == 0 && Heb(TD(mQb(b.j, (Ywc(), jwc))))) return 0;
                            !Heb(TD(mQb(b.j, (Ywc(), jwc)))) && !Heb(TD(mQb(b.j, Owc))) || dE(mQb(b.j, (yCc(), cAc))) === dE((kEc(), hEc)) ? b.c.mg(b.e, e) : e = Heb(TD(mQb(b.j, jwc)));
                            DKc(a, b, e, true);
                            Heb(TD(mQb(b.j, Owc))) && pQb(b.j, Owc, (Geb(), false));
                            if (Heb(TD(mQb(b.j, jwc)))) {
                                pQb(b.j, jwc, (Geb(), false));
                                pQb(b.j, Owc, true);
                            }
                            c = mKc(a, b);
                            do {
                                yKc(a);
                                if (c == 0) return 0;
                                e = !e;
                                f = c;
                                DKc(a, b, e, false);
                                c = mKc(a, b);
                            }while (f > c);
                            return f;
                        }
                        function vKc(a, b) {
                            var c, d, e, f;
                            e = Kwb(a.d, 1) != 0;
                            d = lKc(a, b);
                            if (d == 0 && Heb(TD(mQb(b.j, (Ywc(), jwc))))) return 0;
                            !Heb(TD(mQb(b.j, (Ywc(), jwc)))) && !Heb(TD(mQb(b.j, Owc))) || dE(mQb(b.j, (yCc(), cAc))) === dE((kEc(), hEc)) ? b.c.mg(b.e, e) : e = Heb(TD(mQb(b.j, jwc)));
                            DKc(a, b, e, true);
                            Heb(TD(mQb(b.j, Owc))) && pQb(b.j, Owc, (Geb(), false));
                            if (Heb(TD(mQb(b.j, jwc)))) {
                                pQb(b.j, jwc, (Geb(), false));
                                pQb(b.j, Owc, true);
                            }
                            c = lKc(a, b);
                            do {
                                yKc(a);
                                if (c == 0) return 0;
                                e = !e;
                                f = c;
                                DKc(a, b, e, false);
                                c = lKc(a, b);
                            }while (f > c);
                            return f;
                        }
                        function Gid(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m;
                            i = ojd(new rjd(c.a, c.b), a);
                            j = i.a * b.b - i.b * b.a;
                            k = b.a * d.b - b.b * d.a;
                            l = (i.a * d.b - i.b * d.a) / k;
                            m = j / k;
                            if (k == 0) {
                                if (j == 0) {
                                    e = $id(new rjd(c.a, c.b), ijd(new rjd(d.a, d.b), 0.5));
                                    f = bjd(a, e);
                                    g = bjd($id(new rjd(a.a, a.b), b), e);
                                    h = $wnd.Math.sqrt(d.a * d.a + d.b * d.b) * 0.5;
                                    if (f < g && f <= h) return new rjd(a.a, a.b);
                                    if (g <= h) return $id(new rjd(a.a, a.b), b);
                                    return null;
                                } else return null;
                            } else return l >= 0 && l <= 1 && m >= 0 && m <= 1 ? $id(new rjd(a.a, a.b), ijd(new rjd(b.a, b.b), l)) : null;
                        }
                        function QWb(a, b, c) {
                            var d, e, f, g, h;
                            d = RD(mQb(a, (yCc(), dAc)), 21);
                            c.a > b.a && (d.Hc((ukd(), okd)) ? a.c.a += (c.a - b.a) / 2 : d.Hc(qkd) && (a.c.a += c.a - b.a));
                            c.b > b.b && (d.Hc((ukd(), skd)) ? a.c.b += (c.b - b.b) / 2 : d.Hc(rkd) && (a.c.b += c.b - b.b));
                            if (RD(mQb(a, (Ywc(), kwc)), 21).Hc((ovc(), hvc)) && (c.a > b.a || c.b > b.b)) for(h = new Anb(a.a); h.a < h.c.c.length;){
                                g = RD(ynb(h), 10);
                                if (g.k == (r3b(), m3b)) {
                                    e = RD(mQb(g, hwc), 64);
                                    e == (qpd(), Xod) ? g.n.a += c.a - b.a : e == npd && (g.n.b += c.b - b.b);
                                }
                            }
                            f = a.d;
                            a.f.a = c.a - f.b - f.c;
                            a.f.b = c.b - f.d - f.a;
                        }
                        function Y8b(a, b, c) {
                            var d, e, f, g, h;
                            d = RD(mQb(a, (yCc(), dAc)), 21);
                            c.a > b.a && (d.Hc((ukd(), okd)) ? a.c.a += (c.a - b.a) / 2 : d.Hc(qkd) && (a.c.a += c.a - b.a));
                            c.b > b.b && (d.Hc((ukd(), skd)) ? a.c.b += (c.b - b.b) / 2 : d.Hc(rkd) && (a.c.b += c.b - b.b));
                            if (RD(mQb(a, (Ywc(), kwc)), 21).Hc((ovc(), hvc)) && (c.a > b.a || c.b > b.b)) for(g = new Anb(a.a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 10);
                                if (f.k == (r3b(), m3b)) {
                                    e = RD(mQb(f, hwc), 64);
                                    e == (qpd(), Xod) ? f.n.a += c.a - b.a : e == npd && (f.n.b += c.b - b.b);
                                }
                            }
                            h = a.d;
                            a.f.a = c.a - h.b - h.c;
                            a.f.b = c.b - h.d - h.a;
                        }
                        function KQc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m;
                            b = bRc(a);
                            for(k = (h = new Xkb(b).a.vc().Kc(), new blb(h)); k.a.Ob();){
                                j = (e = RD(k.a.Pb(), 44), RD(e.ld(), 10));
                                l = 0;
                                m = 0;
                                l = j.d.d;
                                m = j.o.b + j.d.a;
                                a.d[j.p] = 0;
                                c = j;
                                while((f = a.a[c.p]) != j){
                                    d = dRc(c, f);
                                    i = 0;
                                    a.c == (wQc(), uQc) ? i = d.d.n.b + d.d.a.b - d.c.n.b - d.c.a.b : i = d.c.n.b + d.c.a.b - d.d.n.b - d.d.a.b;
                                    g = Kfb(a.d[c.p]) + i;
                                    a.d[f.p] = g;
                                    l = $wnd.Math.max(l, f.d.d - g);
                                    m = $wnd.Math.max(m, g + f.o.b + f.d.a);
                                    c = f;
                                }
                                c = j;
                                do {
                                    a.d[c.p] = Kfb(a.d[c.p]) + l;
                                    c = a.a[c.p];
                                }while (c != j);
                                a.b[j.p] = l + m;
                            }
                        }
                        function S9c(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            f = 0;
                            g = a.t;
                            e = 0;
                            d = 0;
                            i = 0;
                            m = 0;
                            l = 0;
                            if (c) {
                                a.n.c.length = 0;
                                Rmb(a.n, new _9c(a.s, a.t, a.i));
                            }
                            h = 0;
                            for(k = new Anb(a.b); k.a < k.c.c.length;){
                                j = RD(ynb(k), 27);
                                if (f + j.g + (h > 0 ? a.i : 0) > b && i > 0) {
                                    f = 0;
                                    g += i + a.i;
                                    e = $wnd.Math.max(e, m);
                                    d += i + a.i;
                                    i = 0;
                                    m = 0;
                                    if (c) {
                                        ++l;
                                        Rmb(a.n, new _9c(a.s, g, a.i));
                                    }
                                    h = 0;
                                }
                                m += j.g + (h > 0 ? a.i : 0);
                                i = $wnd.Math.max(i, j.f);
                                c && W9c(RD(Vmb(a.n, l), 209), j);
                                f += j.g + (h > 0 ? a.i : 0);
                                ++h;
                            }
                            e = $wnd.Math.max(e, m);
                            d += i;
                            if (c) {
                                a.r = e;
                                a.d = d;
                                Ead(a.j);
                            }
                            return new Uid(a.s, a.t, e, d);
                        }
                        function CRb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m;
                            a.b = false;
                            l = oxe;
                            i = pxe;
                            m = oxe;
                            j = pxe;
                            for(d = a.e.a.ec().Kc(); d.Ob();){
                                c = RD(d.Pb(), 272);
                                e = c.a;
                                l = $wnd.Math.min(l, e.c);
                                i = $wnd.Math.max(i, e.c + e.b);
                                m = $wnd.Math.min(m, e.d);
                                j = $wnd.Math.max(j, e.d + e.a);
                                for(g = new Anb(c.c); g.a < g.c.c.length;){
                                    f = RD(ynb(g), 407);
                                    b = f.a;
                                    if (b.a) {
                                        k = e.d + f.b.b;
                                        h = k + f.c;
                                        m = $wnd.Math.min(m, k);
                                        j = $wnd.Math.max(j, h);
                                    } else {
                                        k = e.c + f.b.a;
                                        h = k + f.c;
                                        l = $wnd.Math.min(l, k);
                                        i = $wnd.Math.max(i, h);
                                    }
                                }
                            }
                            a.a = new rjd(i - l, j - m);
                            a.c = new rjd(l + a.d.a, m + a.d.b);
                        }
                        function mYd(a) {
                            var b, c, d, e, f, g, h, i;
                            if (!a.a) {
                                a.o = null;
                                i = new e_d(a);
                                b = new i_d;
                                c = iYd;
                                h = c.a.zc(a, c);
                                if (h == null) {
                                    for(g = new dMd(zYd(a)); g.e != g.i.gc();){
                                        f = RD(bMd(g), 29);
                                        YGd(i, mYd(f));
                                    }
                                    c.a.Bc(a);
                                    c.a.gc() == 0 && undefined;
                                }
                                for(e = (!a.s && (a.s = new C5d(y7, a, 21, 17)), new dMd(a.s)); e.e != e.i.gc();){
                                    d = RD(bMd(e), 179);
                                    ZD(d, 331) && WGd(b, RD(d, 35));
                                }
                                VHd(b);
                                a.k = new n_d(a, (RD(QHd(xYd((lTd(), kTd).o), 7), 19), b.i), b.g);
                                YGd(i, a.k);
                                VHd(i);
                                a.a = new N$d((RD(QHd(xYd(kTd.o), 4), 19), i.i), i.g);
                                yYd(a).b &= -2;
                            }
                            return a.a;
                        }
                        function age(a, b, c, d) {
                            var e, f, g, h, i, j, k;
                            k = pke(a.e.Dh(), b);
                            e = 0;
                            f = RD(a.g, 124);
                            i = null;
                            nke();
                            if (RD(b, 69).xk()) for(h = 0; h < a.i; ++h){
                                g = f[h];
                                if (k.am(g.Lk())) {
                                    if (pb(g, c)) {
                                        i = g;
                                        break;
                                    }
                                    ++e;
                                }
                            }
                            else if (c != null) for(h = 0; h < a.i; ++h){
                                g = f[h];
                                if (k.am(g.Lk())) {
                                    if (pb(c, g.md())) {
                                        i = g;
                                        break;
                                    }
                                    ++e;
                                }
                            }
                            else for(h = 0; h < a.i; ++h){
                                g = f[h];
                                if (k.am(g.Lk())) {
                                    if (g.md() == null) {
                                        i = g;
                                        break;
                                    }
                                    ++e;
                                }
                            }
                            if (i) {
                                if (Mvd(a.e)) {
                                    j = b.Jk() ? new lle(a.e, 4, b, c, null, e, true) : fge(a, b.tk() ? 2 : 1, b, c, b.ik(), -1, true);
                                    d ? d.nj(j) : d = j;
                                }
                                d = _fe(a, i, d);
                            }
                            return d;
                        }
                        function d8c(a, b, c, d, e, f, g) {
                            var h, i, j, k, l, m, n, o, p;
                            o = 0;
                            p = 0;
                            i = e.c;
                            h = e.b;
                            k = c.f;
                            n = c.g;
                            switch(b.g){
                                case 0:
                                    o = d.i + d.g + g;
                                    a.c ? p = m8c(o, f, d, g) : p = d.j;
                                    m = $wnd.Math.max(i, o + n);
                                    j = $wnd.Math.max(h, p + k);
                                    break;
                                case 1:
                                    p = d.j + d.f + g;
                                    a.c ? o = l8c(p, f, d, g) : o = d.i;
                                    m = $wnd.Math.max(i, o + n);
                                    j = $wnd.Math.max(h, p + k);
                                    break;
                                case 2:
                                    o = i + g;
                                    p = 0;
                                    m = i + g + n;
                                    j = $wnd.Math.max(h, k);
                                    break;
                                case 3:
                                    o = 0;
                                    p = h + g;
                                    m = $wnd.Math.max(i, n);
                                    j = h + g + k;
                                    break;
                                default:
                                    throw Adb(new agb('IllegalPlacementOption.'));
                            }
                            l = new mad(a.a, m, j, b, o, p);
                            return l;
                        }
                        function g6b(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m;
                            h = a.d;
                            l = RD(mQb(a, (Ywc(), Xwc)), 15);
                            b = RD(mQb(a, Vvc), 15);
                            if (!l && !b) return;
                            f = Kfb(UD(hFc(a, (yCc(), QBc))));
                            g = Kfb(UD(hFc(a, RBc)));
                            m = 0;
                            if (l) {
                                j = 0;
                                for(e = l.Kc(); e.Ob();){
                                    d = RD(e.Pb(), 10);
                                    j = $wnd.Math.max(j, d.o.b);
                                    m += d.o.a;
                                }
                                m += f * (l.gc() - 1);
                                h.d += j + g;
                            }
                            c = 0;
                            if (b) {
                                j = 0;
                                for(e = b.Kc(); e.Ob();){
                                    d = RD(e.Pb(), 10);
                                    j = $wnd.Math.max(j, d.o.b);
                                    c += d.o.a;
                                }
                                c += f * (b.gc() - 1);
                                h.a += j + g;
                            }
                            i = $wnd.Math.max(m, c);
                            if (i > a.o.a) {
                                k = (i - a.o.a) / 2;
                                h.b = $wnd.Math.max(h.b, k);
                                h.c = $wnd.Math.max(h.c, k);
                            }
                        }
                        function RId(a) {
                            var b, c, d, e, f, g, h, i;
                            f = new med;
                            ied(f, (hed(), eed));
                            for(d = (e = oC(a, $C(qJ, Nve, 2, 0, 6, 1)), new Dkb(new mob(new CC(a, e).b))); d.b < d.d.gc();){
                                c = (sFb(d.b < d.d.gc()), WD(d.d.Xb(d.c = d.b++)));
                                g = vgd(LId, c);
                                if (g) {
                                    b = qC(a, c);
                                    b.te() ? h = b.te().a : b.qe() ? h = '' + b.qe().a : b.re() ? h = '' + b.re().a : h = b.Ib();
                                    i = zhd(g, h);
                                    if (i != null) {
                                        (Csb(g.j, (Yhd(), Vhd)) || Csb(g.j, Whd)) && oQb(ked(f, J4), g, i);
                                        Csb(g.j, Thd) && oQb(ked(f, G4), g, i);
                                        Csb(g.j, Xhd) && oQb(ked(f, K4), g, i);
                                        Csb(g.j, Uhd) && oQb(ked(f, I4), g, i);
                                    }
                                }
                            }
                            return f;
                        }
                        function ige(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            e = RD(a.g, 124);
                            if (qke(a.e, b)) return nke(), RD(b, 69).xk() ? new ole(b, a) : new Eke(b, a);
                            else {
                                j = pke(a.e.Dh(), b);
                                d = 0;
                                for(h = 0; h < a.i; ++h){
                                    f = e[h];
                                    g = f.Lk();
                                    if (j.am(g)) {
                                        nke();
                                        if (RD(b, 69).xk()) return f;
                                        else if (g == (Lle(), Jle) || g == Gle) {
                                            i = new dib(jeb(f.md()));
                                            while(++h < a.i){
                                                f = e[h];
                                                g = f.Lk();
                                                (g == Jle || g == Gle) && Zhb(i, jeb(f.md()));
                                            }
                                            return Ije(RD(b.Hk(), 156), i.a);
                                        } else {
                                            k = f.md();
                                            k != null && c && ZD(b, 102) && (RD(b, 19).Bb & txe) != 0 && (k = Bge(a, b, h, d, k));
                                            return k;
                                        }
                                    }
                                    ++d;
                                }
                                return b.ik();
                            }
                        }
                        function hge(a, b, c, d) {
                            var e, f, g, h, i, j;
                            i = pke(a.e.Dh(), b);
                            f = RD(a.g, 124);
                            if (qke(a.e, b)) {
                                e = 0;
                                for(h = 0; h < a.i; ++h){
                                    g = f[h];
                                    if (i.am(g.Lk())) {
                                        if (e == c) {
                                            nke();
                                            if (RD(b, 69).xk()) return g;
                                            else {
                                                j = g.md();
                                                j != null && d && ZD(b, 102) && (RD(b, 19).Bb & txe) != 0 && (j = Bge(a, b, h, e, j));
                                                return j;
                                            }
                                        }
                                        ++e;
                                    }
                                }
                                throw Adb(new veb(HJe + c + NIe + e));
                            } else {
                                e = 0;
                                for(h = 0; h < a.i; ++h){
                                    g = f[h];
                                    if (i.am(g.Lk())) {
                                        nke();
                                        if (RD(b, 69).xk()) return g;
                                        else {
                                            j = g.md();
                                            j != null && d && ZD(b, 102) && (RD(b, 19).Bb & txe) != 0 && (j = Bge(a, b, h, e, j));
                                            return j;
                                        }
                                    }
                                    ++e;
                                }
                                return b.ik();
                            }
                        }
                        function xjb() {
                            xjb = geb;
                            vjb = cD(WC(kE, 1), Pwe, 28, 15, [
                                qwe,
                                1162261467,
                                hwe,
                                1220703125,
                                362797056,
                                1977326743,
                                hwe,
                                387420489,
                                ixe,
                                214358881,
                                429981696,
                                815730721,
                                1475789056,
                                170859375,
                                268435456,
                                410338673,
                                612220032,
                                893871739,
                                1280000000,
                                1801088541,
                                113379904,
                                148035889,
                                191102976,
                                244140625,
                                308915776,
                                387420489,
                                481890304,
                                594823321,
                                729000000,
                                887503681,
                                hwe,
                                1291467969,
                                1544804416,
                                1838265625,
                                60466176
                            ]);
                            wjb = cD(WC(kE, 1), Pwe, 28, 15, [
                                -1,
                                -1,
                                31,
                                19,
                                15,
                                13,
                                11,
                                11,
                                10,
                                9,
                                9,
                                8,
                                8,
                                8,
                                8,
                                7,
                                7,
                                7,
                                7,
                                7,
                                7,
                                7,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                5
                            ]);
                        }
                        function Gjb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            g = a.e;
                            i = b.e;
                            if (i == 0) return a;
                            if (g == 0) return b.e == 0 ? b : new cjb(-b.e, b.d, b.a);
                            f = a.d;
                            h = b.d;
                            if (f + h == 2) {
                                c = Cdb(a.a[0], yxe);
                                d = Cdb(b.a[0], yxe);
                                g < 0 && (c = Odb(c));
                                i < 0 && (d = Odb(d));
                                return Pib(), Jdb(Vdb(c, d), 0) ? jjb(Vdb(c, d)) : Xib(jjb(Odb(Vdb(c, d))));
                            }
                            e = f != h ? f > h ? 1 : -1 : Ejb(a.a, b.a, f);
                            if (e == -1) {
                                l = -i;
                                k = g == i ? Hjb(b.a, h, a.a, f) : Cjb(b.a, h, a.a, f);
                            } else {
                                l = g;
                                if (g == i) {
                                    if (e == 0) return Pib(), Oib;
                                    k = Hjb(a.a, f, b.a, h);
                                } else k = Cjb(a.a, f, b.a, h);
                            }
                            j = new cjb(l, k.length, k);
                            Rib(j);
                            return j;
                        }
                        function c5b(a, b) {
                            var c, d, e, f;
                            f = Z4b(b);
                            !b.c && (b.c = new C5d(K4, b, 9, 9));
                            FDb(new SDb(null, (!b.c && (b.c = new C5d(K4, b, 9, 9)), new Swb(b.c, 16))), new s5b(f));
                            e = RD(mQb(f, (Ywc(), kwc)), 21);
                            Y4b(b, e);
                            if (e.Hc((ovc(), hvc))) for(d = new dMd((!b.c && (b.c = new C5d(K4, b, 9, 9)), b.c)); d.e != d.i.gc();){
                                c = RD(bMd(d), 123);
                                g5b(a, b, f, c);
                            }
                            RD(Gxd(b, (yCc(), lBc)), 181).gc() != 0 && V4b(b, f);
                            Heb(TD(mQb(f, sBc))) && e.Fc(mvc);
                            nQb(f, PBc) && HCc(new RCc(Kfb(UD(mQb(f, PBc)))), f);
                            dE(Gxd(b, IAc)) === dE((Fnd(), Cnd)) ? d5b(a, b, f) : b5b(a, b, f);
                            return f;
                        }
                        function Vrc(a) {
                            var b, c, d, e, f, g, h, i;
                            for(e = new Anb(a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 30);
                                for(g = new Anb(bv(d.a)); g.a < g.c.c.length;){
                                    f = RD(ynb(g), 10);
                                    if (Lrc(f)) {
                                        c = RD(mQb(f, (Ywc(), Wvc)), 313);
                                        if (!c.g && !!c.d) {
                                            b = c;
                                            i = c.d;
                                            while(i){
                                                Urc(i.i, i.k, false, true);
                                                asc(b.a);
                                                asc(i.i);
                                                asc(i.k);
                                                asc(i.b);
                                                Z0b(i.c, b.c.d);
                                                Z0b(b.c, null);
                                                g3b(b.a, null);
                                                g3b(i.i, null);
                                                g3b(i.k, null);
                                                g3b(i.b, null);
                                                h = new Jrc(b.i, i.a, b.e, i.j, i.f);
                                                h.k = b.k;
                                                h.n = b.n;
                                                h.b = b.b;
                                                h.c = i.c;
                                                h.g = b.g;
                                                h.d = i.d;
                                                pQb(b.i, Wvc, h);
                                                pQb(i.a, Wvc, h);
                                                i = i.d;
                                                b = h;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        function nue(a, b) {
                            var c, d, e, f, g, h, i;
                            if (a == null) return null;
                            f = a.length;
                            if (f == 0) return '';
                            i = $C(hE, zwe, 28, f, 15, 1);
                            AFb(0, f, a.length);
                            AFb(0, f, i.length);
                            nhb(a, 0, f, i, 0);
                            c = null;
                            h = b;
                            for(e = 0, g = 0; e < f; e++){
                                d = i[e];
                                Kqe();
                                if (d <= 32 && (Jqe[d] & 2) != 0) {
                                    if (h) {
                                        !c && (c = new Shb(a));
                                        Phb(c, e - g++);
                                    } else {
                                        h = b;
                                        if (d != 32) {
                                            !c && (c = new Shb(a));
                                            peb(c, e - g, e - g + 1, String.fromCharCode(32));
                                        }
                                    }
                                } else h = false;
                            }
                            if (h) {
                                if (!c) return AFb(0, f - 1, a.length), a.substr(0, f - 1);
                                else {
                                    f = c.a.length;
                                    return f > 0 ? zhb(c.a, 0, f - 1) : '';
                                }
                            } else return !c ? a : c.a;
                        }
                        function xic(a, b) {
                            var c, d, e, f, g, h, i;
                            b.Ug('Sort By Input Model ' + mQb(a, (yCc(), cAc)), 1);
                            e = 0;
                            for(d = new Anb(a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 30);
                                i = e == 0 ? 0 : e - 1;
                                h = RD(Vmb(a.b, i), 30);
                                for(g = new Anb(c.a); g.a < g.c.c.length;){
                                    f = RD(ynb(g), 10);
                                    if (dE(mQb(f, BBc)) !== dE((Bod(), vod)) && dE(mQb(f, BBc)) !== dE(wod)) {
                                        yob();
                                        _mb(f.j, new trc(h, RD(mQb(a, cAc), 284), Bic(f), Heb(TD(mQb(a, bAc)))));
                                        b.bh('Node ' + f + ' ports: ' + f.j);
                                    }
                                }
                                yob();
                                _mb(c.a, new frc(h, RD(mQb(a, cAc), 284), RD(mQb(a, _zc), 390)));
                                b.bh('Layer ' + e + ': ' + c);
                                ++e;
                            }
                            b.Vg();
                        }
                        function ute(a, b) {
                            var c, d, e, f, g;
                            g = RD(b, 138);
                            vte(a);
                            vte(g);
                            if (g.b == null) return;
                            a.c = true;
                            if (a.b == null) {
                                a.b = $C(kE, Pwe, 28, g.b.length, 15, 1);
                                hib(g.b, 0, a.b, 0, g.b.length);
                                return;
                            }
                            f = $C(kE, Pwe, 28, a.b.length + g.b.length, 15, 1);
                            for(c = 0, d = 0, e = 0; c < a.b.length || d < g.b.length;){
                                if (c >= a.b.length) {
                                    f[e++] = g.b[d++];
                                    f[e++] = g.b[d++];
                                } else if (d >= g.b.length) {
                                    f[e++] = a.b[c++];
                                    f[e++] = a.b[c++];
                                } else if (g.b[d] < a.b[c] || g.b[d] === a.b[c] && g.b[d + 1] < a.b[c + 1]) {
                                    f[e++] = g.b[d++];
                                    f[e++] = g.b[d++];
                                } else {
                                    f[e++] = a.b[c++];
                                    f[e++] = a.b[c++];
                                }
                            }
                            a.b = f;
                        }
                        function hac(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            c = Heb(TD(mQb(a, (Ywc(), uwc))));
                            h = Heb(TD(mQb(b, uwc)));
                            d = RD(mQb(a, vwc), 12);
                            i = RD(mQb(b, vwc), 12);
                            e = RD(mQb(a, wwc), 12);
                            j = RD(mQb(b, wwc), 12);
                            k = !!d && d == i;
                            l = !!e && e == j;
                            if (!c && !h) return new oac(RD(ynb(new Anb(a.j)), 12).p == RD(ynb(new Anb(b.j)), 12).p, k, l);
                            f = (!Heb(TD(mQb(a, uwc))) || Heb(TD(mQb(a, twc)))) && (!Heb(TD(mQb(b, uwc))) || Heb(TD(mQb(b, twc))));
                            g = (!Heb(TD(mQb(a, uwc))) || !Heb(TD(mQb(a, twc)))) && (!Heb(TD(mQb(b, uwc))) || !Heb(TD(mQb(b, twc))));
                            return new oac(k && f || l && g, k, l);
                        }
                        function N9c(a) {
                            var b, c, d, e, f, g, h, i;
                            d = 0;
                            c = 0;
                            i = new Yub;
                            b = 0;
                            for(h = new Anb(a.n); h.a < h.c.c.length;){
                                g = RD(ynb(h), 209);
                                if (g.c.c.length == 0) Pub(i, g, i.c.b, i.c);
                                else {
                                    d = $wnd.Math.max(d, g.d);
                                    c += g.a + (b > 0 ? a.i : 0);
                                }
                                ++b;
                            }
                            Ce(a.n, i);
                            a.d = c;
                            a.r = d;
                            a.g = 0;
                            a.f = 0;
                            a.e = 0;
                            a.o = oxe;
                            a.p = oxe;
                            for(f = new Anb(a.b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 27);
                                a.p = $wnd.Math.min(a.p, e.g);
                                a.g = $wnd.Math.max(a.g, e.g);
                                a.f = $wnd.Math.max(a.f, e.f);
                                a.o = $wnd.Math.min(a.o, e.f);
                                a.e += e.f + a.i;
                            }
                            a.a = a.e / a.b.c.length - a.i * ((a.b.c.length - 1) / a.b.c.length);
                            Ead(a.j);
                        }
                        function qzd(a) {
                            var b, c, d, e;
                            if ((a.Db & 64) != 0) return kyd(a);
                            b = new dib(BHe);
                            d = a.k;
                            if (!d) {
                                !a.n && (a.n = new C5d(I4, a, 1, 7));
                                if (a.n.i > 0) {
                                    e = (!a.n && (a.n = new C5d(I4, a, 1, 7)), RD(QHd(a.n, 0), 135)).a;
                                    !e || Zhb(Zhb((b.a += ' "', b), e), '"');
                                }
                            } else Zhb(Zhb((b.a += ' "', b), d), '"');
                            c = (!a.b && (a.b = new Yie(E4, a, 4, 7)), !(a.b.i <= 1 && (!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c.i <= 1)));
                            c ? (b.a += ' [', b) : (b.a += ' ', b);
                            Zhb(b, Eb(new Gb, new dMd(a.b)));
                            c && (b.a += ']', b);
                            b.a += SAe;
                            c && (b.a += '[', b);
                            Zhb(b, Eb(new Gb, new dMd(a.c)));
                            c && (b.a += ']', b);
                            return b.a;
                        }
                        function odc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
                            v = a.c;
                            w = b.c;
                            c = Wmb(v.a, a, 0);
                            d = Wmb(w.a, b, 0);
                            t = RD(c3b(a, (BEc(), yEc)).Kc().Pb(), 12);
                            C = RD(c3b(a, zEc).Kc().Pb(), 12);
                            u = RD(c3b(b, yEc).Kc().Pb(), 12);
                            D = RD(c3b(b, zEc).Kc().Pb(), 12);
                            r = s2b(t.e);
                            A = s2b(C.g);
                            s = s2b(u.e);
                            B = s2b(D.g);
                            f3b(a, d, w);
                            for(g = s, k = 0, o = g.length; k < o; ++k){
                                e = g[k];
                                Z0b(e, t);
                            }
                            for(h = B, l = 0, p = h.length; l < p; ++l){
                                e = h[l];
                                Y0b(e, C);
                            }
                            f3b(b, c, v);
                            for(i = r, m = 0, q = i.length; m < q; ++m){
                                e = i[m];
                                Z0b(e, u);
                            }
                            for(f = A, j = 0, n = f.length; j < n; ++j){
                                e = f[j];
                                Y0b(e, D);
                            }
                        }
                        function $2c(a) {
                            var b, c, d, e, f, g, h;
                            g = RD(Gxd(a, (u2c(), t2c)), 27);
                            for(d = new dMd((!g.e && (g.e = new Yie(G4, g, 7, 4)), g.e)); d.e != d.i.gc();){
                                c = RD(bMd(d), 74);
                                h = new rjd(RD(QHd((!c.a && (c.a = new C5d(F4, c, 6, 6)), c.a), 0), 166).j, RD(QHd((!c.a && (c.a = new C5d(F4, c, 6, 6)), c.a), 0), 166).k);
                                f = new rjd(RD(QHd((!c.a && (c.a = new C5d(F4, c, 6, 6)), c.a), 0), 166).b, RD(QHd((!c.a && (c.a = new C5d(F4, c, 6, 6)), c.a), 0), 166).c);
                                e = new rjd(f.a - h.a, f.b - h.b);
                                b = $wnd.Math.atan2(e.b, e.a);
                                RD(QHd((!c.c && (c.c = new Yie(E4, c, 5, 8)), c.c), 0), 84).qf(($4c(), W4c), b);
                            }
                        }
                        function o6c(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            b.Ug('Interactive Node Reorderer', 1);
                            k = (!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a);
                            h = new bnb;
                            for(e = new dMd(k); e.e != e.i.gc();){
                                c = RD(bMd(e), 27);
                                Hxd(c, (X7c(), A7c)) && ZEb(h.c, c);
                            }
                            for(f = new Anb(h); f.a < f.c.c.length;){
                                c = RD(ynb(f), 27);
                                dHd(k, c);
                            }
                            yob();
                            _mb(h, new s6c);
                            for(g = new Anb(h); g.a < g.c.c.length;){
                                c = RD(ynb(g), 27);
                                j = RD(Gxd(c, (X7c(), A7c)), 17).a;
                                j = $wnd.Math.min(j, k.i);
                                VGd(k, j, c);
                            }
                            i = 0;
                            for(d = new dMd(k); d.e != d.i.gc();){
                                c = RD(bMd(d), 27);
                                Ixd(c, (X7c(), z7c), sgb(i));
                                ++i;
                            }
                            b.Vg();
                        }
                        function PTc(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            if ($wnd.Math.abs(b.s - b.c) < Vze || $wnd.Math.abs(c.s - c.c) < Vze) return 0;
                            d = OTc(a, b.j, c.e);
                            e = OTc(a, c.j, b.e);
                            f = d == -1 || e == -1;
                            g = 0;
                            if (f) {
                                if (d == -1) {
                                    new bTc((fTc(), dTc), c, b, 1);
                                    ++g;
                                }
                                if (e == -1) {
                                    new bTc((fTc(), dTc), b, c, 1);
                                    ++g;
                                }
                            } else {
                                h = VTc(b.j, c.s, c.c);
                                h += VTc(c.e, b.s, b.c);
                                i = VTc(c.j, b.s, b.c);
                                i += VTc(b.e, c.s, c.c);
                                j = d + 16 * h;
                                k = e + 16 * i;
                                if (j < k) new bTc((fTc(), eTc), b, c, k - j);
                                else if (j > k) new bTc((fTc(), eTc), c, b, j - k);
                                else if (j > 0 && k > 0) {
                                    new bTc((fTc(), eTc), b, c, 0);
                                    new bTc(eTc, c, b, 0);
                                }
                            }
                            return g;
                        }
                        function pXc(a, b, c) {
                            var d, e, f;
                            a.a = new bnb;
                            for(f = Sub(b.b, 0); f.b != f.d.c;){
                                e = RD(evb(f), 40);
                                while(RD(mQb(e, (h_c(), f_c)), 17).a > a.a.c.length - 1)Rmb(a.a, new Ptd(Hze, KEe));
                                d = RD(mQb(e, f_c), 17).a;
                                if (c == (Cmd(), ymd) || c == zmd) {
                                    e.e.a < Kfb(UD(RD(Vmb(a.a, d), 42).a)) && Ntd(RD(Vmb(a.a, d), 42), e.e.a);
                                    e.e.a + e.f.a > Kfb(UD(RD(Vmb(a.a, d), 42).b)) && Otd(RD(Vmb(a.a, d), 42), e.e.a + e.f.a);
                                } else {
                                    e.e.b < Kfb(UD(RD(Vmb(a.a, d), 42).a)) && Ntd(RD(Vmb(a.a, d), 42), e.e.b);
                                    e.e.b + e.f.b > Kfb(UD(RD(Vmb(a.a, d), 42).b)) && Otd(RD(Vmb(a.a, d), 42), e.e.b + e.f.b);
                                }
                            }
                        }
                        function g2b(a, b, c, d) {
                            var e, f, g, h, i, j, k;
                            f = i2b(d);
                            h = Heb(TD(mQb(d, (yCc(), aBc))));
                            if ((h || Heb(TD(mQb(a, MAc)))) && !Dod(RD(mQb(a, BBc), 101))) {
                                e = vpd(f);
                                i = q2b(a, c, c == (BEc(), zEc) ? e : spd(e));
                            } else {
                                i = new R3b;
                                P3b(i, a);
                                if (b) {
                                    k = i.n;
                                    k.a = b.a - a.n.a;
                                    k.b = b.b - a.n.b;
                                    _id(k, 0, 0, a.o.a, a.o.b);
                                    Q3b(i, c2b(i, f));
                                } else {
                                    e = vpd(f);
                                    Q3b(i, c == (BEc(), zEc) ? e : spd(e));
                                }
                                g = RD(mQb(d, (Ywc(), kwc)), 21);
                                j = i.j;
                                switch(f.g){
                                    case 2:
                                    case 1:
                                        (j == (qpd(), Yod) || j == npd) && g.Fc((ovc(), lvc));
                                        break;
                                    case 4:
                                    case 3:
                                        (j == (qpd(), Xod) || j == ppd) && g.Fc((ovc(), lvc));
                                }
                            }
                            return i;
                        }
                        function VXb(a, b) {
                            var c, d, e, f, g, h;
                            for(g = new vkb(new mkb(a.f.b).a); g.b;){
                                f = tkb(g);
                                e = RD(f.ld(), 602);
                                if (b == 1) {
                                    if (e.Af() != (Cmd(), Bmd) && e.Af() != xmd) continue;
                                } else {
                                    if (e.Af() != (Cmd(), ymd) && e.Af() != zmd) continue;
                                }
                                d = RD(RD(f.md(), 42).b, 86);
                                h = RD(RD(f.md(), 42).a, 194);
                                c = h.c;
                                switch(e.Af().g){
                                    case 2:
                                        d.g.c = a.e.a;
                                        d.g.b = $wnd.Math.max(1, d.g.b + c);
                                        break;
                                    case 1:
                                        d.g.c = d.g.c + c;
                                        d.g.b = $wnd.Math.max(1, d.g.b - c);
                                        break;
                                    case 4:
                                        d.g.d = a.e.b;
                                        d.g.a = $wnd.Math.max(1, d.g.a + c);
                                        break;
                                    case 3:
                                        d.g.d = d.g.d + c;
                                        d.g.a = $wnd.Math.max(1, d.g.a - c);
                                }
                            }
                        }
                        function NNc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
                            h = $C(kE, Pwe, 28, b.b.c.length, 15, 1);
                            j = $C(hR, jwe, 273, b.b.c.length, 0, 1);
                            i = $C(jR, WAe, 10, b.b.c.length, 0, 1);
                            for(l = a.a, m = 0, n = l.length; m < n; ++m){
                                k = l[m];
                                p = 0;
                                for(g = new Anb(k.e); g.a < g.c.c.length;){
                                    e = RD(ynb(g), 10);
                                    d = Q4b(e.c);
                                    ++h[d];
                                    o = Kfb(UD(mQb(b, (yCc(), TBc))));
                                    h[d] > 0 && !!i[d] && (o = bFc(a.b, i[d], e));
                                    p = $wnd.Math.max(p, e.c.c.b + o);
                                }
                                for(f = new Anb(k.e); f.a < f.c.c.length;){
                                    e = RD(ynb(f), 10);
                                    e.n.b = p + e.d.d;
                                    c = e.c;
                                    c.c.b = p + e.d.d + e.o.b + e.d.a;
                                    j[Wmb(c.b.b, c, 0)] = e.k;
                                    i[Wmb(c.b.b, c, 0)] = e;
                                }
                            }
                        }
                        function M5c(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m;
                            for(d = new is(Mr(zGd(b).a.Kc(), new ir)); gs(d);){
                                c = RD(hs(d), 74);
                                if (!ZD(QHd((!c.b && (c.b = new Yie(E4, c, 4, 7)), c.b), 0), 193)) {
                                    i = AGd(RD(QHd((!c.c && (c.c = new Yie(E4, c, 5, 8)), c.c), 0), 84));
                                    if (!nzd(c)) {
                                        g = b.i + b.g / 2;
                                        h = b.j + b.f / 2;
                                        k = i.i + i.g / 2;
                                        l = i.j + i.f / 2;
                                        m = new pjd;
                                        m.a = k - g;
                                        m.b = l - h;
                                        f = new rjd(m.a, m.b);
                                        wid(f, b.g, b.f);
                                        m.a -= f.a;
                                        m.b -= f.b;
                                        g = k - m.a;
                                        h = l - m.b;
                                        j = new rjd(m.a, m.b);
                                        wid(j, i.g, i.f);
                                        m.a -= j.a;
                                        m.b -= j.b;
                                        k = g + m.a;
                                        l = h + m.b;
                                        e = IGd(c, true, true);
                                        Ozd(e, g);
                                        Pzd(e, h);
                                        Hzd(e, k);
                                        Izd(e, l);
                                        M5c(a, i);
                                    }
                                }
                            }
                        }
                        function ocd(a) {
                            Cgd(a, new Pfd($fd(Xfd(Zfd(Yfd(new agd, hGe), 'ELK SPOrE Compaction'), 'ShrinkTree is a compaction algorithm that maintains the topology of a layout. The relocation of diagram elements is based on contracting a spanning tree.'), new rcd)));
                            Agd(a, hGe, iGe, iGd(mcd));
                            Agd(a, hGe, jGe, iGd(jcd));
                            Agd(a, hGe, kGe, iGd(icd));
                            Agd(a, hGe, lGe, iGd(gcd));
                            Agd(a, hGe, mGe, iGd(hcd));
                            Agd(a, hGe, Eze, fcd);
                            Agd(a, hGe, _ze, 8);
                            Agd(a, hGe, nGe, iGd(lcd));
                            Agd(a, hGe, oGe, iGd(bcd));
                            Agd(a, hGe, pGe, iGd(ccd));
                            Agd(a, hGe, LDe, (Geb(), false));
                        }
                        function hQc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            b.Ug('Simple node placement', 1);
                            l = RD(mQb(a, (Ywc(), Qwc)), 312);
                            h = 0;
                            for(f = new Anb(a.b); f.a < f.c.c.length;){
                                d = RD(ynb(f), 30);
                                g = d.c;
                                g.b = 0;
                                c = null;
                                for(j = new Anb(d.a); j.a < j.c.c.length;){
                                    i = RD(ynb(j), 10);
                                    !!c && (g.b += _Ec(i, c, l.c));
                                    g.b += i.d.d + i.o.b + i.d.a;
                                    c = i;
                                }
                                h = $wnd.Math.max(h, g.b);
                            }
                            for(e = new Anb(a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 30);
                                g = d.c;
                                k = (h - g.b) / 2;
                                c = null;
                                for(j = new Anb(d.a); j.a < j.c.c.length;){
                                    i = RD(ynb(j), 10);
                                    !!c && (k += _Ec(i, c, l.c));
                                    k += i.d.d;
                                    i.n.b = k;
                                    k += i.o.b + i.d.a;
                                    c = i;
                                }
                            }
                            b.Vg();
                        }
                        function tqc(a, b) {
                            var c, d, e, f;
                            nqc(b.b.j);
                            FDb(GDb(new SDb(null, new Swb(b.d, 16)), new Eqc), new Gqc);
                            for(f = new Anb(b.d); f.a < f.c.c.length;){
                                e = RD(ynb(f), 105);
                                switch(e.e.g){
                                    case 0:
                                        c = RD(Vmb(e.j, 0), 113).d.j;
                                        Smc(e, RD(Lvb(KDb(RD(Qc(e.k, c), 15).Oc(), lqc)), 113));
                                        Tmc(e, RD(Lvb(JDb(RD(Qc(e.k, c), 15).Oc(), lqc)), 113));
                                        break;
                                    case 1:
                                        d = foc(e);
                                        Smc(e, RD(Lvb(KDb(RD(Qc(e.k, d[0]), 15).Oc(), lqc)), 113));
                                        Tmc(e, RD(Lvb(JDb(RD(Qc(e.k, d[1]), 15).Oc(), lqc)), 113));
                                        break;
                                    case 2:
                                        vqc(a, e);
                                        break;
                                    case 3:
                                        uqc(e);
                                        break;
                                    case 4:
                                        sqc(a, e);
                                }
                                qqc(e);
                            }
                            a.a = null;
                        }
                        function yRc(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            d = a.a.o == (EQc(), DQc) ? oxe : pxe;
                            h = zRc(a, new xRc(b, c));
                            if (!h.a && h.c) {
                                Mub(a.d, h);
                                return d;
                            } else if (h.a) {
                                e = h.a.c;
                                i = h.a.d;
                                if (c) {
                                    j = a.a.c == (wQc(), vQc) ? i : e;
                                    f = a.a.c == vQc ? e : i;
                                    g = a.a.g[f.i.p];
                                    k = Kfb(a.a.p[g.p]) + Kfb(a.a.d[f.i.p]) + f.n.b + f.a.b - Kfb(a.a.d[j.i.p]) - j.n.b - j.a.b;
                                } else {
                                    j = a.a.c == (wQc(), uQc) ? i : e;
                                    f = a.a.c == uQc ? e : i;
                                    k = Kfb(a.a.p[a.a.g[f.i.p].p]) + Kfb(a.a.d[f.i.p]) + f.n.b + f.a.b - Kfb(a.a.d[j.i.p]) - j.n.b - j.a.b;
                                }
                                a.a.n[a.a.g[e.i.p].p] = (Geb(), true);
                                a.a.n[a.a.g[i.i.p].p] = true;
                                return k;
                            }
                            return d;
                        }
                        function Sfe(a, b, c, d) {
                            var e, f, g, h, i, j, k, l;
                            if (d.gc() == 0) return false;
                            i = (nke(), RD(b, 69).xk());
                            g = i ? d : new ZHd(d.gc());
                            if (qke(a.e, b)) {
                                if (b.Si()) for(k = d.Kc(); k.Ob();){
                                    j = k.Pb();
                                    if (!dge(a, b, j, ZD(b, 102) && (RD(b, 19).Bb & txe) != 0)) {
                                        f = oke(b, j);
                                        g.Fc(f);
                                    }
                                }
                                else if (!i) for(k = d.Kc(); k.Ob();){
                                    j = k.Pb();
                                    f = oke(b, j);
                                    g.Fc(f);
                                }
                            } else {
                                l = pke(a.e.Dh(), b);
                                e = RD(a.g, 124);
                                for(h = 0; h < a.i; ++h){
                                    f = e[h];
                                    if (l.am(f.Lk())) throw Adb(new agb(gLe));
                                }
                                if (d.gc() > 1) throw Adb(new agb(gLe));
                                if (!i) {
                                    f = oke(b, d.Kc().Pb());
                                    g.Fc(f);
                                }
                            }
                            return XGd(a, gge(a, b, c), g);
                        }
                        function Fge(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            if (qke(a.e, b)) {
                                i = (nke(), RD(b, 69).xk() ? new ole(b, a) : new Eke(b, a));
                                bge(i.c, i.b);
                                Ake(i, RD(c, 16));
                            } else {
                                k = pke(a.e.Dh(), b);
                                d = RD(a.g, 124);
                                for(g = 0; g < a.i; ++g){
                                    e = d[g];
                                    f = e.Lk();
                                    if (k.am(f)) {
                                        if (f == (Lle(), Jle) || f == Gle) {
                                            j = Mge(a, b, c);
                                            h = g;
                                            j ? vLd(a, g) : ++g;
                                            while(g < a.i){
                                                e = d[g];
                                                f = e.Lk();
                                                f == Jle || f == Gle ? vLd(a, g) : ++g;
                                            }
                                            j || RD(eHd(a, h, oke(b, c)), 76);
                                        } else Mge(a, b, c) ? vLd(a, g) : RD(eHd(a, g, (nke(), RD(b, 69).xk() ? RD(c, 76) : oke(b, c))), 76);
                                        return;
                                    }
                                }
                                Mge(a, b, c) || WGd(a, (nke(), RD(b, 69).xk() ? RD(c, 76) : oke(b, c)));
                            }
                        }
                        function zPb(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            if (!pb(c, a.b)) {
                                a.b = c;
                                f = new CPb;
                                g = RD(zDb(GDb(new SDb(null, new Swb(c.f, 16)), f), sBb(new _Bb, new bCb, new yCb, new ACb, cD(WC(QL, 1), jwe, 108, 0, [
                                    (xBb(), wBb),
                                    vBb
                                ]))), 21);
                                a.e = true;
                                a.f = true;
                                a.c = true;
                                a.d = true;
                                e = g.Hc((IPb(), FPb));
                                d = g.Hc(GPb);
                                e && !d && (a.f = false);
                                !e && d && (a.d = false);
                                e = g.Hc(EPb);
                                d = g.Hc(HPb);
                                e && !d && (a.c = false);
                                !e && d && (a.e = false);
                            }
                            k = RD(a.a.Ve(b, c), 42);
                            i = RD(k.a, 17).a;
                            j = RD(k.b, 17).a;
                            h = false;
                            i < 0 ? a.c || (h = true) : a.e || (h = true);
                            j < 0 ? a.d || (h = true) : a.f || (h = true);
                            return h ? zPb(a, k, c) : k;
                        }
                        function yNc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
                            for(l = 0; l < b.length; l++){
                                for(h = a.Kc(); h.Ob();){
                                    f = RD(h.Pb(), 230);
                                    f.hg(l, b);
                                }
                                for(m = 0; m < b[l].length; m++){
                                    for(i = a.Kc(); i.Ob();){
                                        f = RD(i.Pb(), 230);
                                        f.ig(l, m, b);
                                    }
                                    p = b[l][m].j;
                                    for(n = 0; n < p.c.length; n++){
                                        for(j = a.Kc(); j.Ob();){
                                            f = RD(j.Pb(), 230);
                                            f.jg(l, m, n, b);
                                        }
                                        o = (tFb(n, p.c.length), RD(p.c[n], 12));
                                        c = 0;
                                        for(e = new l4b(o.b); xnb(e.a) || xnb(e.b);){
                                            d = RD(xnb(e.a) ? ynb(e.a) : ynb(e.b), 18);
                                            for(k = a.Kc(); k.Ob();){
                                                f = RD(k.Pb(), 230);
                                                f.gg(l, m, n, c++, d, b);
                                            }
                                        }
                                    }
                                }
                            }
                            for(g = a.Kc(); g.Ob();){
                                f = RD(g.Pb(), 230);
                                f.fg();
                            }
                        }
                        function $7b(a, b) {
                            var c, d, e, f, g, h, i;
                            a.b = Kfb(UD(mQb(b, (yCc(), UBc))));
                            a.c = Kfb(UD(mQb(b, XBc)));
                            a.d = RD(mQb(b, DAc), 350);
                            a.a = RD(mQb(b, Xzc), 282);
                            Y7b(b);
                            h = RD(zDb(CDb(CDb(EDb(EDb(new SDb(null, new Swb(b.b, 16)), new c8b), new e8b), new g8b), new i8b), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), vBb)
                            ]))), 15);
                            for(e = h.Kc(); e.Ob();){
                                c = RD(e.Pb(), 18);
                                g = RD(mQb(c, (Ywc(), Twc)), 15);
                                g.Jc(new k8b(a));
                                pQb(c, Twc, null);
                            }
                            for(d = h.Kc(); d.Ob();){
                                c = RD(d.Pb(), 18);
                                i = RD(mQb(c, (Ywc(), Uwc)), 18);
                                f = RD(mQb(c, Rwc), 15);
                                S7b(a, f, i);
                                pQb(c, Rwc, null);
                            }
                        }
                        function r2d(a, b) {
                            var c, d, e, f, g, h, i;
                            if (a.a) {
                                h = a.a.xe();
                                i = null;
                                if (h != null) b.a += '' + h;
                                else {
                                    g = a.a.mk();
                                    if (g != null) {
                                        f = qhb(g, Fhb(91));
                                        if (f != -1) {
                                            i = (BFb(f, g.length + 1), g.substr(f));
                                            b.a += '' + zhb(g == null ? vve : (uFb(g), g), 0, f);
                                        } else b.a += '' + g;
                                    }
                                }
                                if (!!a.d && a.d.i != 0) {
                                    e = true;
                                    b.a += '<';
                                    for(d = new dMd(a.d); d.e != d.i.gc();){
                                        c = RD(bMd(d), 89);
                                        e ? e = false : (b.a += pve, b);
                                        r2d(c, b);
                                    }
                                    b.a += '>';
                                }
                                i != null && (b.a += '' + i, b);
                            } else if (a.e) {
                                h = a.e.zb;
                                h != null && (b.a += '' + h, b);
                            } else {
                                b.a += '?';
                                if (a.b) {
                                    b.a += ' super ';
                                    r2d(a.b, b);
                                } else if (a.f) {
                                    b.a += ' extends ';
                                    r2d(a.f, b);
                                }
                            }
                        }
                        function Uae(a) {
                            a.b = null;
                            a.a = null;
                            a.o = null;
                            a.q = null;
                            a.v = null;
                            a.w = null;
                            a.B = null;
                            a.p = null;
                            a.Q = null;
                            a.R = null;
                            a.S = null;
                            a.T = null;
                            a.U = null;
                            a.V = null;
                            a.W = null;
                            a.bb = null;
                            a.eb = null;
                            a.ab = null;
                            a.H = null;
                            a.db = null;
                            a.c = null;
                            a.d = null;
                            a.f = null;
                            a.n = null;
                            a.r = null;
                            a.s = null;
                            a.u = null;
                            a.G = null;
                            a.J = null;
                            a.e = null;
                            a.j = null;
                            a.i = null;
                            a.g = null;
                            a.k = null;
                            a.t = null;
                            a.F = null;
                            a.I = null;
                            a.L = null;
                            a.M = null;
                            a.O = null;
                            a.P = null;
                            a.$ = null;
                            a.N = null;
                            a.Z = null;
                            a.cb = null;
                            a.K = null;
                            a.D = null;
                            a.A = null;
                            a.C = null;
                            a._ = null;
                            a.fb = null;
                            a.X = null;
                            a.Y = null;
                            a.gb = false;
                            a.hb = false;
                        }
                        function yib(a) {
                            var b, c, d, e;
                            d = Ajb((!a.c && (a.c = ojb(Hdb(a.f))), a.c), 0);
                            if (a.e == 0 || a.a == 0 && a.f != -1 && a.e < 0) return d;
                            b = xib(a) < 0 ? 1 : 0;
                            c = a.e;
                            e = (d.length, $wnd.Math.abs(eE(a.e)), new cib);
                            b == 1 && (e.a += '-', e);
                            if (a.e > 0) {
                                c -= d.length - b;
                                if (c >= 0) {
                                    e.a += '0.';
                                    for(; c > mib.length; c -= mib.length)$hb(e, mib);
                                    _hb(e, mib, eE(c));
                                    Zhb(e, (BFb(b, d.length + 1), d.substr(b)));
                                } else {
                                    c = b - c;
                                    Zhb(e, zhb(d, b, eE(c)));
                                    e.a += '.';
                                    Zhb(e, yhb(d, eE(c)));
                                }
                            } else {
                                Zhb(e, (BFb(b, d.length + 1), d.substr(b)));
                                for(; c < -mib.length; c += mib.length)$hb(e, mib);
                                _hb(e, mib, eE(-c));
                            }
                            return e.a;
                        }
                        function BOc(a) {
                            var b, c, d, e, f, g, h, i, j;
                            if (a.k != (r3b(), p3b)) return false;
                            if (a.j.c.length <= 1) return false;
                            f = RD(mQb(a, (yCc(), BBc)), 101);
                            if (f == (Bod(), wod)) return false;
                            e = (wDc(), (!a.q ? (yob(), yob(), wob) : a.q)._b(iBc) ? d = RD(mQb(a, iBc), 203) : d = RD(mQb(Y2b(a), jBc), 203), d);
                            if (e == uDc) return false;
                            if (!(e == tDc || e == sDc)) {
                                g = Kfb(UD(hFc(a, fCc)));
                                b = RD(mQb(a, eCc), 140);
                                !b && (b = new R2b(g, g, g, g));
                                j = b3b(a, (qpd(), ppd));
                                i = b.d + b.a + (j.gc() - 1) * g;
                                if (i > a.o.b) return false;
                                c = b3b(a, Xod);
                                h = b.d + b.a + (c.gc() - 1) * g;
                                if (h > a.o.b) return false;
                            }
                            return true;
                        }
                        function VRc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
                            b.Ug('Orthogonal edge routing', 1);
                            j = Kfb(UD(mQb(a, (yCc(), cCc))));
                            c = Kfb(UD(mQb(a, UBc)));
                            d = Kfb(UD(mQb(a, XBc)));
                            m = new TTc(0, c);
                            q = 0;
                            g = new Jkb(a.b, 0);
                            h = null;
                            k = null;
                            i = null;
                            l = null;
                            do {
                                k = g.b < g.d.gc() ? (sFb(g.b < g.d.gc()), RD(g.d.Xb(g.c = g.b++), 30)) : null;
                                l = !k ? null : k.a;
                                if (h) {
                                    p2b(h, q);
                                    q += h.c.a;
                                }
                                p = !h ? q : q + d;
                                o = STc(m, a, i, l, p);
                                e = !h || ar(i, (dSc(), bSc));
                                f = !k || ar(l, (dSc(), bSc));
                                if (o > 0) {
                                    n = (o - 1) * c;
                                    !!h && (n += d);
                                    !!k && (n += d);
                                    n < j && !e && !f && (n = j);
                                    q += n;
                                } else !e && !f && (q += j);
                                h = k;
                                i = l;
                            }while (k);
                            a.f.a = q;
                            b.Vg();
                        }
                        function tfe(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            k = null;
                            !!a.d && (k = RD(Xjb(a.d, b), 142));
                            if (!k) {
                                f = a.a.vi();
                                l = f.i;
                                if (!a.d || bkb(a.d) != l) {
                                    i = new Tsb;
                                    !!a.d && Ld(i, a.d);
                                    j = i.f.c + i.i.c;
                                    for(h = j; h < l; ++h){
                                        d = RD(QHd(f, h), 142);
                                        e = Oee(a.e, d).xe();
                                        c = RD(e == null ? rtb(i.f, null, d) : Ltb(i.i, e, d), 142);
                                        !!c && c != d && (e == null ? rtb(i.f, null, c) : Ltb(i.i, e, c));
                                    }
                                    if (i.f.c + i.i.c != l) for(g = 0; g < j; ++g){
                                        d = RD(QHd(f, g), 142);
                                        e = Oee(a.e, d).xe();
                                        c = RD(e == null ? rtb(i.f, null, d) : Ltb(i.i, e, d), 142);
                                        !!c && c != d && (e == null ? rtb(i.f, null, c) : Ltb(i.i, e, c));
                                    }
                                    a.d = i;
                                }
                                k = RD(Xjb(a.d, b), 142);
                            }
                            return k;
                        }
                        function w0b(a, b, c, d, e, f, g) {
                            var h, i, j, k, l, m, n;
                            l = Heb(TD(mQb(b, (yCc(), bBc))));
                            m = null;
                            f == (BEc(), yEc) && d.c.i == c ? m = d.c : f == zEc && d.d.i == c && (m = d.d);
                            j = g;
                            if (!j || !l || !!m) {
                                k = (qpd(), opd);
                                m ? k = m.j : Dod(RD(mQb(c, BBc), 101)) && (k = f == yEc ? ppd : Xod);
                                i = t0b(a, b, c, f, k, d);
                                h = s0b((Y2b(c), d));
                                if (f == yEc) {
                                    Y0b(h, RD(Vmb(i.j, 0), 12));
                                    Z0b(h, e);
                                } else {
                                    Y0b(h, e);
                                    Z0b(h, RD(Vmb(i.j, 0), 12));
                                }
                                j = new G0b(d, h, i, RD(mQb(i, (Ywc(), Awc)), 12), f, !m);
                            } else {
                                Rmb(j.e, d);
                                n = $wnd.Math.max(Kfb(UD(mQb(j.d, FAc))), Kfb(UD(mQb(d, FAc))));
                                pQb(j.d, FAc, n);
                            }
                            Rc(a.a, d, new J0b(j.d, b, f));
                            return j;
                        }
                        function gSd() {
                            gSd = geb;
                            var a;
                            fSd = new MSd;
                            _Rd = $C(qJ, Nve, 2, 0, 6, 1);
                            URd = Rdb(xSd(33, 58), xSd(1, 26));
                            VRd = Rdb(xSd(97, 122), xSd(65, 90));
                            WRd = xSd(48, 57);
                            SRd = Rdb(URd, 0);
                            TRd = Rdb(VRd, WRd);
                            XRd = Rdb(Rdb(0, xSd(1, 6)), xSd(33, 38));
                            YRd = Rdb(Rdb(WRd, xSd(65, 70)), xSd(97, 102));
                            cSd = Rdb(SRd, vSd("-_.!~*'()"));
                            dSd = Rdb(TRd, ySd("-_.!~*'()"));
                            vSd(MJe);
                            ySd(MJe);
                            Rdb(cSd, vSd(';:@&=+$,'));
                            Rdb(dSd, ySd(';:@&=+$,'));
                            ZRd = vSd(':/?#');
                            $Rd = ySd(':/?#');
                            aSd = vSd('/?#');
                            bSd = ySd('/?#');
                            a = new _sb;
                            a.a.zc('jar', a);
                            a.a.zc('zip', a);
                            a.a.zc('archive', a);
                            eSd = (yob(), new Lqb(a));
                        }
                        function t0b(a, b, c, d, e, f) {
                            var g, h, i, j, k, l;
                            g = null;
                            j = d == (BEc(), yEc) ? f.c : f.d;
                            i = i2b(b);
                            if (j.i == c) {
                                g = RD(Wjb(a.b, j), 10);
                                if (!g) {
                                    g = f2b(j, RD(mQb(c, (yCc(), BBc)), 101), e, p0b(j), null, j.n, j.o, i, b);
                                    pQb(g, (Ywc(), Awc), j);
                                    Zjb(a.b, j, g);
                                }
                            } else {
                                g = f2b((k = new qQb, l = Kfb(UD(mQb(b, (yCc(), TBc)))) / 2, oQb(k, ABc, l), k), RD(mQb(c, BBc), 101), e, d == yEc ? -1 : 1, null, new pjd, new rjd(0, 0), i, b);
                                h = u0b(g, c, d);
                                pQb(g, (Ywc(), Awc), h);
                                Zjb(a.b, h, g);
                            }
                            RD(mQb(b, (Ywc(), kwc)), 21).Fc((ovc(), hvc));
                            Dod(RD(mQb(b, (yCc(), BBc)), 101)) ? pQb(b, BBc, (Bod(), yod)) : pQb(b, BBc, (Bod(), zod));
                            return g;
                        }
                        function Yec(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o;
                            h = 0;
                            o = 0;
                            i = Fnb(a.g, a.g.length);
                            f = a.e;
                            g = a.j;
                            d = a.b;
                            e = a.c;
                            do {
                                n = 0;
                                for(k = new Anb(a.q); k.a < k.c.c.length;){
                                    j = RD(ynb(k), 10);
                                    m = Wec(a, j);
                                    c = true;
                                    (a.r == (aEc(), VDc) || a.r == YDc) && (c = Heb(TD(m.b)));
                                    if (RD(m.a, 17).a < 0 && c) {
                                        ++n;
                                        i = Fnb(a.g, a.g.length);
                                        a.e = a.e + RD(m.a, 17).a;
                                        o += f - a.e;
                                        f = a.e + RD(m.a, 17).a;
                                        g = a.j;
                                        d = bv(a.b);
                                        e = bv(a.c);
                                    } else {
                                        a.g = Fnb(i, i.length);
                                        a.e = f;
                                        a.b = (Qb(d), d ? new dnb(d) : cv(new Anb(d)));
                                        a.c = (Qb(e), e ? new dnb(e) : cv(new Anb(e)));
                                        a.j = g;
                                    }
                                }
                                ++h;
                                l = n != 0 && Heb(TD(b.Kb(new Ptd(sgb(o), sgb(h)))));
                            }while (l);
                        }
                        function e8c(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C;
                            g = a.f;
                            m = b.f;
                            h = g == (sad(), nad) || g == pad;
                            n = m == nad || m == pad;
                            i = g == oad || g == qad;
                            o = m == oad || m == qad;
                            j = g == oad || g == nad;
                            p = m == oad || m == nad;
                            if (h && n) return a.f == pad ? a : b;
                            else if (i && o) return a.f == qad ? a : b;
                            else if (j && p) {
                                if (g == oad) {
                                    l = a;
                                    k = b;
                                } else {
                                    l = b;
                                    k = a;
                                }
                                f = (q = c.j + c.f, r = l.e + d.f, s = $wnd.Math.max(q, r), t = s - $wnd.Math.min(c.j, l.e), u = l.d + d.g - c.i, u * t);
                                e = (v = c.i + c.g, w = k.d + d.g, A = $wnd.Math.max(v, w), B = A - $wnd.Math.min(c.i, k.d), C = k.e + d.f - c.j, B * C);
                                return f <= e ? a.f == oad ? a : b : a.f == nad ? a : b;
                            }
                            return a;
                        }
                        function t0c(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            pQb(b, (q$c(), g$c), 0);
                            i = RD(mQb(b, c$c), 40);
                            if (b.d.b == 0) {
                                if (i) {
                                    k = Kfb(UD(mQb(i, j$c))) + a.b + u0c(a, i, b);
                                    pQb(b, j$c, k);
                                } else pQb(b, j$c, 0);
                            } else {
                                for(d = (f = Sub(new dXc(b).a.d, 0), new gXc(f)); dvb(d.a);){
                                    c = RD(evb(d.a), 65).c;
                                    t0c(a, c);
                                }
                                h = RD(Hr((g = Sub(new dXc(b).a.d, 0), new gXc(g))), 40);
                                l = RD(Gr((e = Sub(new dXc(b).a.d, 0), new gXc(e))), 40);
                                j = (Kfb(UD(mQb(l, j$c))) + Kfb(UD(mQb(h, j$c)))) / 2;
                                if (i) {
                                    k = Kfb(UD(mQb(i, j$c))) + a.b + u0c(a, i, b);
                                    pQb(b, j$c, k);
                                    pQb(b, g$c, Kfb(UD(mQb(b, j$c))) - j);
                                    s0c(a, b);
                                } else pQb(b, j$c, j);
                            }
                        }
                        function nJb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l;
                            k = a.e.a.c.length;
                            for(g = new Anb(a.e.a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 125);
                                f.j = false;
                            }
                            a.i = $C(kE, Pwe, 28, k, 15, 1);
                            a.g = $C(kE, Pwe, 28, k, 15, 1);
                            a.n = new bnb;
                            e = 0;
                            l = new bnb;
                            for(i = new Anb(a.e.a); i.a < i.c.c.length;){
                                h = RD(ynb(i), 125);
                                h.d = e++;
                                h.b.a.c.length == 0 && Rmb(a.n, h);
                                Tmb(l, h.g);
                            }
                            b = 0;
                            for(d = new Anb(l); d.a < d.c.c.length;){
                                c = RD(ynb(d), 218);
                                c.c = b++;
                                c.f = false;
                            }
                            j = l.c.length;
                            if (a.b == null || a.b.length < j) {
                                a.b = $C(iE, vxe, 28, j, 15, 1);
                                a.c = $C(xdb, Hye, 28, j, 16, 1);
                            } else Nnb(a.c);
                            a.d = l;
                            a.p = new Jub(Sv(a.d.c.length));
                            a.j = 1;
                        }
                        function uWb(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            if (b.e.c.length <= 1) return;
                            a.f = b;
                            a.d = RD(mQb(a.f, (dWb(), UVb)), 391);
                            a.g = RD(mQb(a.f, YVb), 17).a;
                            a.e = Kfb(UD(mQb(a.f, VVb)));
                            a.c = Kfb(UD(mQb(a.f, TVb)));
                            At(a.b);
                            for(e = new Anb(a.f.c); e.a < e.c.c.length;){
                                d = RD(ynb(e), 290);
                                zt(a.b, d.c, d, null);
                                zt(a.b, d.d, d, null);
                            }
                            h = a.f.e.c.length;
                            a.a = YC(iE, [
                                Nve,
                                vxe
                            ], [
                                109,
                                28
                            ], 15, [
                                h,
                                h
                            ], 2);
                            for(j = new Anb(a.f.e); j.a < j.c.c.length;){
                                i = RD(ynb(j), 153);
                                qWb(a, i, a.a[i.a]);
                            }
                            a.i = YC(iE, [
                                Nve,
                                vxe
                            ], [
                                109,
                                28
                            ], 15, [
                                h,
                                h
                            ], 2);
                            for(f = 0; f < h; ++f)for(g = 0; g < h; ++g){
                                c = a.a[f][g];
                                k = 1 / (c * c);
                                a.i[f][g] = k;
                            }
                        }
                        function OWb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o;
                            h = b.ah();
                            h || b.Ug(Pze, 1);
                            c = RD(mQb(a, (Ywc(), Kwc)), 15);
                            g = 1 / c.gc();
                            if (b._g()) {
                                b.bh('ELK Layered uses the following ' + c.gc() + ' modules:');
                                n = 0;
                                for(m = c.Kc(); m.Ob();){
                                    k = RD(m.Pb(), 47);
                                    d = (n < 10 ? '0' : '') + n++;
                                    b.bh('   Slot ' + d + ': ' + nfb(rb(k)));
                                }
                            }
                            o = 0;
                            for(l = c.Kc(); l.Ob();){
                                k = RD(l.Pb(), 47);
                                if (b.$g()) return;
                                k.Kf(a, b.eh(g));
                                ++o;
                            }
                            for(f = new Anb(a.b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 30);
                                Tmb(a.a, e.a);
                                e.a.c.length = 0;
                            }
                            for(j = new Anb(a.a); j.a < j.c.c.length;){
                                i = RD(ynb(j), 10);
                                g3b(i, null);
                            }
                            a.b.c.length = 0;
                            h || b.Vg();
                        }
                        function y9b(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n;
                            j = new bnb;
                            if (!nQb(a, (Ywc(), fwc))) return j;
                            for(d = RD(mQb(a, fwc), 15).Kc(); d.Ob();){
                                b = RD(d.Pb(), 10);
                                x9b(b, a);
                                ZEb(j.c, b);
                            }
                            for(f = new Anb(a.b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 30);
                                for(h = new Anb(e.a); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 10);
                                    if (g.k != (r3b(), m3b)) continue;
                                    i = RD(mQb(g, gwc), 10);
                                    !!i && (k = new R3b, P3b(k, g), l = RD(mQb(g, hwc), 64), Q3b(k, l), m = RD(Vmb(i.j, 0), 12), n = new a1b, Y0b(n, k), Z0b(n, m), undefined);
                                }
                            }
                            for(c = new Anb(j); c.a < c.c.c.length;){
                                b = RD(ynb(c), 10);
                                g3b(b, RD(Vmb(a.b, a.b.c.length - 1), 30));
                            }
                            return j;
                        }
                        function U8c(a, b, c) {
                            var d, e, f, g, h, i, j, k, l;
                            l = new bnb;
                            k = new Had(0, c);
                            f = 0;
                            Cad(k, new V9c(0, 0, k, c));
                            e = 0;
                            for(j = new dMd(a); j.e != j.i.gc();){
                                i = RD(bMd(j), 27);
                                d = RD(Vmb(k.a, k.a.c.length - 1), 172);
                                h = e + i.g + (RD(Vmb(k.a, 0), 172).b.c.length == 0 ? 0 : c);
                                if (h > b || Heb(TD(Gxd(i, (X7c(), D7c))))) {
                                    e = 0;
                                    f += k.b + c;
                                    ZEb(l.c, k);
                                    k = new Had(f, c);
                                    d = new V9c(0, k.f, k, c);
                                    Cad(k, d);
                                    e = 0;
                                }
                                if (d.b.c.length == 0 || !Heb(TD(Gxd(vCd(i), (X7c(), L7c)))) && (i.f >= d.o && i.f <= d.f || d.a * 0.5 <= i.f && d.a * 1.5 >= i.f)) K9c(d, i);
                                else {
                                    g = new V9c(d.s + d.r + c, k.f, k, c);
                                    Cad(k, g);
                                    K9c(g, i);
                                }
                                e = i.i + i.g;
                            }
                            ZEb(l.c, k);
                            return l;
                        }
                        function ste(a) {
                            var b, c, d, e;
                            if (a.b == null || a.b.length <= 2) return;
                            if (a.a) return;
                            b = 0;
                            e = 0;
                            while(e < a.b.length){
                                if (b != e) {
                                    a.b[b] = a.b[e++];
                                    a.b[b + 1] = a.b[e++];
                                } else e += 2;
                                c = a.b[b + 1];
                                while(e < a.b.length){
                                    if (c + 1 < a.b[e]) break;
                                    if (c + 1 == a.b[e]) {
                                        a.b[b + 1] = a.b[e + 1];
                                        c = a.b[b + 1];
                                        e += 2;
                                    } else if (c >= a.b[e + 1]) e += 2;
                                    else if (c < a.b[e + 1]) {
                                        a.b[b + 1] = a.b[e + 1];
                                        c = a.b[b + 1];
                                        e += 2;
                                    } else throw Adb(new yz('Token#compactRanges(): Internel Error: [' + a.b[b] + ',' + a.b[b + 1] + '] [' + a.b[e] + ',' + a.b[e + 1] + ']'));
                                }
                                b += 2;
                            }
                            if (b != a.b.length) {
                                d = $C(kE, Pwe, 28, b, 15, 1);
                                hib(a.b, 0, d, 0, b);
                                a.b = d;
                            }
                            a.a = true;
                        }
                        function x0b(a, b) {
                            var c, d, e, f, g, h, i;
                            for(g = Ec(a.a).Kc(); g.Ob();){
                                f = RD(g.Pb(), 18);
                                if (f.b.c.length > 0) {
                                    d = new dnb(RD(Qc(a.a, f), 21));
                                    yob();
                                    _mb(d, new M0b(b));
                                    e = new Jkb(f.b, 0);
                                    while(e.b < e.d.gc()){
                                        c = (sFb(e.b < e.d.gc()), RD(e.d.Xb(e.c = e.b++), 72));
                                        h = -1;
                                        switch(RD(mQb(c, (yCc(), wAc)), 278).g){
                                            case 1:
                                                h = d.c.length - 1;
                                                break;
                                            case 0:
                                                h = v0b(d);
                                                break;
                                            case 2:
                                                h = 0;
                                        }
                                        if (h != -1) {
                                            i = (tFb(h, d.c.length), RD(d.c[h], 249));
                                            Rmb(i.b.b, c);
                                            RD(mQb(Y2b(i.b.c.i), (Ywc(), kwc)), 21).Fc((ovc(), gvc));
                                            RD(mQb(Y2b(i.b.c.i), kwc), 21).Fc(evc);
                                            Ckb(e);
                                            pQb(c, Dwc, f);
                                        }
                                    }
                                }
                                Y0b(f, null);
                                Z0b(f, null);
                            }
                        }
                        function wOb(a, b) {
                            var c, d, e, f;
                            c = new BOb;
                            d = RD(zDb(GDb(new SDb(null, new Swb(a.f, 16)), c), sBb(new _Bb, new bCb, new yCb, new ACb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), wBb),
                                vBb
                            ]))), 21);
                            e = d.gc();
                            e = e == 2 ? 1 : 0;
                            e == 1 && Gdb(Mdb(RD(zDb(CDb(d.Lc(), new DOb), PBb(Hgb(0), new uCb)), 168).a, 2), 0) && (e = 0);
                            d = RD(zDb(GDb(new SDb(null, new Swb(b.f, 16)), c), sBb(new _Bb, new bCb, new yCb, new ACb, cD(WC(QL, 1), jwe, 108, 0, [
                                wBb,
                                vBb
                            ]))), 21);
                            f = d.gc();
                            f = f == 2 ? 1 : 0;
                            f == 1 && Gdb(Mdb(RD(zDb(CDb(d.Lc(), new FOb), PBb(Hgb(0), new uCb)), 168).a, 2), 0) && (f = 0);
                            if (e < f) return -1;
                            if (e == f) return 0;
                            return 1;
                        }
                        function W4b(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m;
                            b = MCd(a);
                            f = Heb(TD(Gxd(b, (yCc(), NAc))));
                            k = 0;
                            e = 0;
                            for(j = new dMd((!a.e && (a.e = new Yie(G4, a, 7, 4)), a.e)); j.e != j.i.gc();){
                                i = RD(bMd(j), 74);
                                h = ozd(i);
                                g = h && f && Heb(TD(Gxd(i, OAc)));
                                m = AGd(RD(QHd((!i.c && (i.c = new Yie(E4, i, 5, 8)), i.c), 0), 84));
                                h && g ? ++e : h && !g ? ++k : vCd(m) == b || m == b ? ++e : ++k;
                            }
                            for(d = new dMd((!a.d && (a.d = new Yie(G4, a, 8, 5)), a.d)); d.e != d.i.gc();){
                                c = RD(bMd(d), 74);
                                h = ozd(c);
                                g = h && f && Heb(TD(Gxd(c, OAc)));
                                l = AGd(RD(QHd((!c.b && (c.b = new Yie(E4, c, 4, 7)), c.b), 0), 84));
                                h && g ? ++k : h && !g ? ++e : vCd(l) == b || l == b ? ++k : ++e;
                            }
                            return k - e;
                        }
                        function Jec(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n;
                            b.Ug('Edge splitting', 1);
                            if (a.b.c.length <= 2) {
                                b.Vg();
                                return;
                            }
                            f = new Jkb(a.b, 0);
                            g = (sFb(f.b < f.d.gc()), RD(f.d.Xb(f.c = f.b++), 30));
                            while(f.b < f.d.gc()){
                                e = g;
                                g = (sFb(f.b < f.d.gc()), RD(f.d.Xb(f.c = f.b++), 30));
                                for(i = new Anb(e.a); i.a < i.c.c.length;){
                                    h = RD(ynb(i), 10);
                                    for(k = new Anb(h.j); k.a < k.c.c.length;){
                                        j = RD(ynb(k), 12);
                                        for(d = new Anb(j.g); d.a < d.c.c.length;){
                                            c = RD(ynb(d), 18);
                                            m = c.d;
                                            l = m.i.c;
                                            l != e && l != g && Oec(c, (n = new j3b(a), h3b(n, (r3b(), o3b)), pQb(n, (Ywc(), Awc), c), pQb(n, (yCc(), BBc), (Bod(), wod)), g3b(n, g), n));
                                        }
                                    }
                                }
                            }
                            b.Vg();
                        }
                        function MLc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m;
                            k = new bnb;
                            m = new _sb;
                            g = b.b;
                            for(e = 0; e < g.c.length; e++){
                                j = (tFb(e, g.c.length), RD(g.c[e], 30)).a;
                                k.c.length = 0;
                                for(f = 0; f < j.c.length; f++){
                                    h = a.a[e][f];
                                    h.p = f;
                                    h.k == (r3b(), q3b) && ZEb(k.c, h);
                                    $mb(RD(Vmb(b.b, e), 30).a, f, h);
                                    h.j.c.length = 0;
                                    Tmb(h.j, RD(RD(Vmb(a.b, e), 15).Xb(f), 16));
                                    Cod(RD(mQb(h, (yCc(), BBc)), 101)) || pQb(h, BBc, (Bod(), vod));
                                }
                                for(d = new Anb(k); d.a < d.c.c.length;){
                                    c = RD(ynb(d), 10);
                                    l = KLc(c);
                                    m.a.zc(l, m);
                                    m.a.zc(c, m);
                                }
                            }
                            for(i = m.a.ec().Kc(); i.Ob();){
                                h = RD(i.Pb(), 10);
                                yob();
                                _mb(h.j, (sgc(), mgc));
                                h.i = true;
                                V2b(h);
                            }
                        }
                        function zib(a) {
                            var b, c, d, e, f;
                            if (a.g != null) return a.g;
                            if (a.a < 32) {
                                a.g = zjb(Hdb(a.f), eE(a.e));
                                return a.g;
                            }
                            e = Ajb((!a.c && (a.c = ojb(Hdb(a.f))), a.c), 0);
                            if (a.e == 0) return e;
                            b = (!a.c && (a.c = ojb(Hdb(a.f))), a.c).e < 0 ? 2 : 1;
                            c = e.length;
                            d = -a.e + c - b;
                            f = new bib;
                            f.a += '' + e;
                            if (a.e > 0 && d >= -6) {
                                if (d >= 0) aib(f, c - eE(a.e), String.fromCharCode(46));
                                else {
                                    peb(f, b - 1, b - 1, '0.');
                                    aib(f, b + 1, Ihb(mib, 0, -eE(d) - 1));
                                }
                            } else {
                                if (c - b >= 1) {
                                    aib(f, b, String.fromCharCode(46));
                                    ++c;
                                }
                                aib(f, c, String.fromCharCode(69));
                                d > 0 && aib(f, ++c, String.fromCharCode(43));
                                aib(f, ++c, '' + Zdb(Hdb(d)));
                            }
                            a.g = f.a;
                            return a.g;
                        }
                        function KNc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A;
                            d = Kfb(UD(mQb(b, (yCc(), hBc))));
                            v = RD(mQb(b, gCc), 17).a;
                            m = 4;
                            e = 3;
                            w = 20 / v;
                            n = false;
                            i = 0;
                            g = lve;
                            do {
                                f = i != 1;
                                l = i != 0;
                                A = 0;
                                for(q = a.a, s = 0, u = q.length; s < u; ++s){
                                    o = q[s];
                                    o.f = null;
                                    LNc(a, o, f, l, d);
                                    A += $wnd.Math.abs(o.a);
                                }
                                do h = PNc(a, b);
                                while (h);
                                for(p = a.a, r = 0, t = p.length; r < t; ++r){
                                    o = p[r];
                                    c = XNc(o).a;
                                    if (c != 0) for(k = new Anb(o.e); k.a < k.c.c.length;){
                                        j = RD(ynb(k), 10);
                                        j.n.b += c;
                                    }
                                }
                                if (i == 0 || i == 1) {
                                    --m;
                                    if (m <= 0 && (A < g || -m > v)) {
                                        i = 2;
                                        g = lve;
                                    } else if (i == 0) {
                                        i = 1;
                                        g = A;
                                    } else {
                                        i = 0;
                                        g = A;
                                    }
                                } else {
                                    n = A >= g || g - A < w;
                                    g = A;
                                    n && --e;
                                }
                            }while (!(n && e <= 0));
                        }
                        function LFb(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o;
                            o = new Tsb;
                            for(f = a.a.ec().Kc(); f.Ob();){
                                d = RD(f.Pb(), 177);
                                Zjb(o, d, c.af(d));
                            }
                            g = (Qb(a), a ? new dnb(a) : cv(a.a.ec().Kc()));
                            _mb(g, new NFb(o));
                            h = Xx(g);
                            i = new $Fb(b);
                            n = new Tsb;
                            rtb(n.f, b, i);
                            while(h.a.gc() != 0){
                                j = null;
                                k = null;
                                l = null;
                                for(e = h.a.ec().Kc(); e.Ob();){
                                    d = RD(e.Pb(), 177);
                                    if (Kfb(UD(Wd(qtb(o.f, d)))) <= oxe) {
                                        if (Ujb(n, d.a) && !Ujb(n, d.b)) {
                                            k = d.b;
                                            l = d.a;
                                            j = d;
                                            break;
                                        }
                                        if (Ujb(n, d.b)) {
                                            if (!Ujb(n, d.a)) {
                                                k = d.a;
                                                l = d.b;
                                                j = d;
                                                break;
                                            }
                                        }
                                    }
                                }
                                if (!j) break;
                                m = new $Fb(k);
                                Rmb(RD(Wd(qtb(n.f, l)), 225).a, m);
                                rtb(n.f, k, m);
                                h.a.Bc(j);
                            }
                            return i;
                        }
                        function MFc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n;
                            c.Ug('Depth-first cycle removal', 1);
                            l = b.a;
                            k = l.c.length;
                            a.c = new bnb;
                            a.d = $C(xdb, Hye, 28, k, 16, 1);
                            a.a = $C(xdb, Hye, 28, k, 16, 1);
                            a.b = new bnb;
                            g = 0;
                            for(j = new Anb(l); j.a < j.c.c.length;){
                                i = RD(ynb(j), 10);
                                i.p = g;
                                gr(Z2b(i)) && Rmb(a.c, i);
                                ++g;
                            }
                            for(n = new Anb(a.c); n.a < n.c.c.length;){
                                m = RD(ynb(n), 10);
                                LFc(a, m);
                            }
                            for(f = 0; f < k; f++)if (!a.d[f]) {
                                h = (tFb(f, l.c.length), RD(l.c[f], 10));
                                LFc(a, h);
                            }
                            for(e = new Anb(a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 18);
                                X0b(d, true);
                                pQb(b, (Ywc(), awc), (Geb(), true));
                            }
                            a.c = null;
                            a.d = null;
                            a.a = null;
                            a.b = null;
                            c.Vg();
                        }
                        function Kid(a, b) {
                            tid();
                            var c, d, e, f, g, h;
                            f = b.c - (a.c + a.b);
                            e = a.c - (b.c + b.b);
                            g = a.d - (b.d + b.a);
                            c = b.d - (a.d + a.a);
                            d = $wnd.Math.max(e, f);
                            h = $wnd.Math.max(g, c);
                            Zy();
                            bz(vEe);
                            if (($wnd.Math.abs(d) <= vEe || d == 0 || isNaN(d) && isNaN(0) ? 0 : d < 0 ? -1 : d > 0 ? 1 : cz(isNaN(d), isNaN(0))) >= 0 ^ (bz(vEe), ($wnd.Math.abs(h) <= vEe || h == 0 || isNaN(h) && isNaN(0) ? 0 : h < 0 ? -1 : h > 0 ? 1 : cz(isNaN(h), isNaN(0))) >= 0)) return $wnd.Math.max(h, d);
                            bz(vEe);
                            if (($wnd.Math.abs(d) <= vEe || d == 0 || isNaN(d) && isNaN(0) ? 0 : d < 0 ? -1 : d > 0 ? 1 : cz(isNaN(d), isNaN(0))) > 0) return $wnd.Math.sqrt(h * h + d * d);
                            return -$wnd.Math.sqrt(h * h + d * d);
                        }
                        function hue(a, b) {
                            var c, d, e, f, g, h;
                            if (!b) return;
                            !a.a && (a.a = new gyb);
                            if (a.e == 2) {
                                dyb(a.a, b);
                                return;
                            }
                            if (b.e == 1) {
                                for(e = 0; e < b.Pm(); e++)hue(a, b.Lm(e));
                                return;
                            }
                            h = a.a.a.c.length;
                            if (h == 0) {
                                dyb(a.a, b);
                                return;
                            }
                            g = RD(eyb(a.a, h - 1), 122);
                            if (!((g.e == 0 || g.e == 10) && (b.e == 0 || b.e == 10))) {
                                dyb(a.a, b);
                                return;
                            }
                            f = b.e == 0 ? 2 : b.Mm().length;
                            if (g.e == 0) {
                                c = new Rhb;
                                d = g.Km();
                                d >= txe ? Nhb(c, qse(d)) : Jhb(c, d & Bwe);
                                g = (++Use, new eue(10, null, 0));
                                fyb(a.a, g, h - 1);
                            } else {
                                c = (g.Mm().length, new Rhb);
                                Nhb(c, g.Mm());
                            }
                            if (b.e == 0) {
                                d = b.Km();
                                d >= txe ? Nhb(c, qse(d)) : Jhb(c, d & Bwe);
                            } else Nhb(c, b.Mm());
                            RD(g, 530).b = c.a;
                        }
                        function Qsc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
                            if (c.dc()) return;
                            h = 0;
                            m = 0;
                            d = c.Kc();
                            o = RD(d.Pb(), 17).a;
                            while(h < b.f){
                                if (h == o) {
                                    m = 0;
                                    d.Ob() ? o = RD(d.Pb(), 17).a : o = b.f + 1;
                                }
                                if (h != m) {
                                    q = RD(Vmb(a.b, h), 30);
                                    n = RD(Vmb(a.b, m), 30);
                                    p = bv(q.a);
                                    for(l = new Anb(p); l.a < l.c.c.length;){
                                        k = RD(ynb(l), 10);
                                        f3b(k, n.a.c.length, n);
                                        if (m == 0) {
                                            g = bv(Z2b(k));
                                            for(f = new Anb(g); f.a < f.c.c.length;){
                                                e = RD(ynb(f), 18);
                                                X0b(e, true);
                                                pQb(a, (Ywc(), awc), (Geb(), true));
                                                osc(a, e, 1);
                                            }
                                        }
                                    }
                                }
                                ++m;
                                ++h;
                            }
                            i = new Jkb(a.b, 0);
                            while(i.b < i.d.gc()){
                                j = (sFb(i.b < i.d.gc()), RD(i.d.Xb(i.c = i.b++), 30));
                                j.a.c.length == 0 && Ckb(i);
                            }
                        }
                        function Xjc(a, b, c) {
                            var d, e, f;
                            e = RD(mQb(b, (yCc(), Xzc)), 282);
                            if (e == ($uc(), Yuc)) return;
                            c.Ug('Horizontal Compaction', 1);
                            a.a = b;
                            f = new Ckc;
                            d = new VGb((f.d = b, f.c = RD(mQb(f.d, yAc), 223), tkc(f), Akc(f), zkc(f), f.a));
                            TGb(d, a.b);
                            switch(RD(mQb(b, Wzc), 431).g){
                                case 1:
                                    RGb(d, new Pic(a.a));
                                    break;
                                default:
                                    RGb(d, (FGb(), DGb));
                            }
                            switch(e.g){
                                case 1:
                                    KGb(d);
                                    break;
                                case 2:
                                    KGb(JGb(d, (Cmd(), zmd)));
                                    break;
                                case 3:
                                    KGb(SGb(JGb(KGb(d), (Cmd(), zmd)), new fkc));
                                    break;
                                case 4:
                                    KGb(SGb(JGb(KGb(d), (Cmd(), zmd)), new hkc(f)));
                                    break;
                                case 5:
                                    KGb(QGb(d, Vjc));
                            }
                            JGb(d, (Cmd(), ymd));
                            d.e = true;
                            qkc(f);
                            c.Vg();
                        }
                        function bqc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            g = b.b;
                            k = g.o;
                            i = g.d;
                            d = Kfb(UD(k2b(g, (yCc(), TBc))));
                            e = Kfb(UD(k2b(g, VBc)));
                            j = Kfb(UD(k2b(g, dCc)));
                            h = new T2b;
                            D2b(h, i.d, i.c, i.a, i.b);
                            m = Zpc(b, d, e, j);
                            for(r = new Anb(b.d); r.a < r.c.c.length;){
                                q = RD(ynb(r), 105);
                                for(o = q.f.a.ec().Kc(); o.Ob();){
                                    n = RD(o.Pb(), 340);
                                    f = n.a;
                                    l = Xpc(n);
                                    c = (s = new Ejd, Vpc(n, n.c, m, s), Upc(n, l, m, s), Vpc(n, n.d, m, s), s);
                                    c = a.ng(n, l, c);
                                    Xub(f.a);
                                    ye(f.a, c);
                                    FDb(new SDb(null, new Swb(c, 16)), new fqc(k, h));
                                }
                                p = q.i;
                                if (p) {
                                    aqc(q, p, m, e);
                                    t = new sjd(p.g);
                                    cqc(k, h, t);
                                    $id(t, p.j);
                                    cqc(k, h, t);
                                }
                            }
                            D2b(i, h.d, h.c, h.a, h.b);
                        }
                        function fNb(a) {
                            var b, c, d, e;
                            e = a.o;
                            RMb();
                            if (a.A.dc() || pb(a.A, QMb)) b = e.b;
                            else {
                                a.D ? b = $wnd.Math.max(e.b, YKb(a.f)) : b = YKb(a.f);
                                if (a.A.Hc((Qpd(), Npd)) && !a.B.Hc((dqd(), _pd))) {
                                    b = $wnd.Math.max(b, YKb(RD(Vrb(a.p, (qpd(), Xod)), 252)));
                                    b = $wnd.Math.max(b, YKb(RD(Vrb(a.p, ppd), 252)));
                                }
                                c = TMb(a);
                                !!c && (b = $wnd.Math.max(b, c.b));
                                if (a.A.Hc(Opd)) {
                                    if (a.q == (Bod(), xod) || a.q == wod) {
                                        b = $wnd.Math.max(b, SJb(RD(Vrb(a.b, (qpd(), Xod)), 127)));
                                        b = $wnd.Math.max(b, SJb(RD(Vrb(a.b, ppd), 127)));
                                    }
                                }
                            }
                            Heb(TD(a.e.Tf().of((umd(), mld)))) ? e.b = $wnd.Math.max(e.b, b) : e.b = b;
                            d = a.f.i;
                            d.d = 0;
                            d.a = b;
                            _Kb(a.f);
                        }
                        function f8c(a, b, c, d, e, f, g, h) {
                            var i, j, k, l;
                            i = dv(cD(WC(y1, 1), rve, 238, 0, [
                                b,
                                c,
                                d,
                                e
                            ]));
                            l = null;
                            switch(a.b.g){
                                case 1:
                                    l = dv(cD(WC(h1, 1), rve, 535, 0, [
                                        new r8c,
                                        new h8c,
                                        new j8c
                                    ]));
                                    break;
                                case 0:
                                    l = dv(cD(WC(h1, 1), rve, 535, 0, [
                                        new j8c,
                                        new h8c,
                                        new r8c
                                    ]));
                                    break;
                                case 2:
                                    l = dv(cD(WC(h1, 1), rve, 535, 0, [
                                        new h8c,
                                        new r8c,
                                        new j8c
                                    ]));
                            }
                            for(k = new Anb(l); k.a < k.c.c.length;){
                                j = RD(ynb(k), 535);
                                i.c.length > 1 && (i = j.Hg(i, a.a, h));
                            }
                            if (i.c.length == 1) return RD(Vmb(i, i.c.length - 1), 238);
                            if (i.c.length == 2) return e8c((tFb(0, i.c.length), RD(i.c[0], 238)), (tFb(1, i.c.length), RD(i.c[1], 238)), g, f);
                            return null;
                        }
                        function CZc(a, b, c) {
                            var d, e, f, g, h, i, j;
                            c.Ug('Find roots', 1);
                            a.a.c.length = 0;
                            for(e = Sub(b.b, 0); e.b != e.d.c;){
                                d = RD(evb(e), 40);
                                if (d.b.b == 0) {
                                    pQb(d, (q$c(), n$c), (Geb(), true));
                                    Rmb(a.a, d);
                                }
                            }
                            switch(a.a.c.length){
                                case 0:
                                    f = new bXc(0, b, 'DUMMY_ROOT');
                                    pQb(f, (q$c(), n$c), (Geb(), true));
                                    pQb(f, WZc, true);
                                    Mub(b.b, f);
                                    break;
                                case 1:
                                    break;
                                default:
                                    g = new bXc(0, b, IEe);
                                    for(i = new Anb(a.a); i.a < i.c.c.length;){
                                        h = RD(ynb(i), 40);
                                        j = new WWc(g, h);
                                        pQb(j, (q$c(), WZc), (Geb(), true));
                                        Mub(g.a.a, j);
                                        Mub(g.d, j);
                                        Mub(h.b, j);
                                        pQb(h, n$c, false);
                                    }
                                    pQb(g, (q$c(), n$c), (Geb(), true));
                                    pQb(g, WZc, true);
                                    Mub(b.b, g);
                            }
                            c.Vg();
                        }
                        function AQb(a) {
                            var b, c, d, e, f, g;
                            Umb(a.a, new GQb);
                            for(c = new Anb(a.a); c.a < c.c.c.length;){
                                b = RD(ynb(c), 225);
                                d = ojd(ajd(RD(a.b, 68).c), RD(b.b, 68).c);
                                if (wQb) {
                                    g = RD(a.b, 68).b;
                                    f = RD(b.b, 68).b;
                                    if ($wnd.Math.abs(d.a) >= $wnd.Math.abs(d.b)) {
                                        d.b = 0;
                                        f.d + f.a > g.d && f.d < g.d + g.a && kjd(d, $wnd.Math.max(g.c - (f.c + f.b), f.c - (g.c + g.b)));
                                    } else {
                                        d.a = 0;
                                        f.c + f.b > g.c && f.c < g.c + g.b && kjd(d, $wnd.Math.max(g.d - (f.d + f.a), f.d - (g.d + g.a)));
                                    }
                                } else kjd(d, SQb(RD(a.b, 68), RD(b.b, 68)));
                                e = $wnd.Math.sqrt(d.a * d.a + d.b * d.b);
                                e = CQb(xQb, b, e, d);
                                kjd(d, e);
                                RQb(RD(b.b, 68), d);
                                Umb(b.a, new IQb(d));
                                RD(xQb.b, 68);
                                BQb(xQb, yQb, b);
                            }
                        }
                        function tOc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o;
                            a.f = new BIb;
                            j = 0;
                            e = 0;
                            for(g = new Anb(a.e.b); g.a < g.c.c.length;){
                                f = RD(ynb(g), 30);
                                for(i = new Anb(f.a); i.a < i.c.c.length;){
                                    h = RD(ynb(i), 10);
                                    h.p = j++;
                                    for(d = new is(Mr(a3b(h).a.Kc(), new ir)); gs(d);){
                                        c = RD(hs(d), 18);
                                        c.p = e++;
                                    }
                                    b = BOc(h);
                                    for(m = new Anb(h.j); m.a < m.c.c.length;){
                                        l = RD(ynb(m), 12);
                                        if (b) {
                                            o = l.a.b;
                                            if (o != $wnd.Math.floor(o)) {
                                                k = o - Xdb(Hdb($wnd.Math.round(o)));
                                                l.a.b -= k;
                                            }
                                        }
                                        n = l.n.b + l.a.b;
                                        if (n != $wnd.Math.floor(n)) {
                                            k = n - Xdb(Hdb($wnd.Math.round(n)));
                                            l.n.b -= k;
                                        }
                                    }
                                }
                            }
                            a.g = j;
                            a.b = e;
                            a.i = $C(XY, rve, 412, j, 0, 1);
                            a.c = $C(WY, rve, 655, e, 0, 1);
                            a.d.a.$b();
                        }
                        function sLd(a) {
                            var b, c, d, e, f, g, h, i, j;
                            if (a.Pj()) {
                                i = a.Qj();
                                if (a.i > 0) {
                                    b = new zNd(a.i, a.g);
                                    c = a.i;
                                    f = c < 100 ? null : new gLd(c);
                                    if (a.Tj()) for(d = 0; d < a.i; ++d){
                                        g = a.g[d];
                                        f = a.Vj(g, f);
                                    }
                                    OHd(a);
                                    e = c == 1 ? a.Ij(4, QHd(b, 0), null, 0, i) : a.Ij(6, b, null, -1, i);
                                    if (a.Mj()) {
                                        for(d = new yMd(b); d.e != d.i.gc();)f = a.Oj(xMd(d), f);
                                        if (!f) a.Jj(e);
                                        else {
                                            f.nj(e);
                                            f.oj();
                                        }
                                    } else if (!f) a.Jj(e);
                                    else {
                                        f.nj(e);
                                        f.oj();
                                    }
                                } else {
                                    OHd(a);
                                    a.Jj(a.Ij(6, (yob(), vob), null, -1, i));
                                }
                            } else if (a.Mj()) {
                                if (a.i > 0) {
                                    h = a.g;
                                    j = a.i;
                                    OHd(a);
                                    f = j < 100 ? null : new gLd(j);
                                    for(d = 0; d < j; ++d){
                                        g = h[d];
                                        f = a.Oj(g, f);
                                    }
                                    !!f && f.oj();
                                } else OHd(a);
                            } else OHd(a);
                        }
                        function xVc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            rVc(this);
                            c == (dVc(), bVc) ? Ysb(this.r, a) : Ysb(this.w, a);
                            k = oxe;
                            j = pxe;
                            for(g = b.a.ec().Kc(); g.Ob();){
                                e = RD(g.Pb(), 42);
                                h = RD(e.a, 465);
                                d = RD(e.b, 18);
                                i = d.c;
                                i == a && (i = d.d);
                                h == bVc ? Ysb(this.r, i) : Ysb(this.w, i);
                                m = (qpd(), hpd).Hc(i.j) ? Kfb(UD(mQb(i, (Ywc(), Swc)))) : xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                    i.i.n,
                                    i.n,
                                    i.a
                                ])).b;
                                k = $wnd.Math.min(k, m);
                                j = $wnd.Math.max(j, m);
                            }
                            l = (qpd(), hpd).Hc(a.j) ? Kfb(UD(mQb(a, (Ywc(), Swc)))) : xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                a.i.n,
                                a.n,
                                a.a
                            ])).b;
                            vVc(this, l, k, j);
                            for(f = b.a.ec().Kc(); f.Ob();){
                                e = RD(f.Pb(), 42);
                                sVc(this, RD(e.b, 18));
                            }
                            this.o = false;
                        }
                        function wD(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
                            c = a.l & 8191;
                            d = a.l >> 13 | (a.m & 15) << 9;
                            e = a.m >> 4 & 8191;
                            f = a.m >> 17 | (a.h & 255) << 5;
                            g = (a.h & 1048320) >> 8;
                            h = b.l & 8191;
                            i = b.l >> 13 | (b.m & 15) << 9;
                            j = b.m >> 4 & 8191;
                            k = b.m >> 17 | (b.h & 255) << 5;
                            l = (b.h & 1048320) >> 8;
                            B = c * h;
                            C = d * h;
                            D = e * h;
                            F = f * h;
                            G = g * h;
                            if (i != 0) {
                                C += c * i;
                                D += d * i;
                                F += e * i;
                                G += f * i;
                            }
                            if (j != 0) {
                                D += c * j;
                                F += d * j;
                                G += e * j;
                            }
                            if (k != 0) {
                                F += c * k;
                                G += d * k;
                            }
                            l != 0 && (G += c * l);
                            n = B & dxe;
                            o = (C & 511) << 13;
                            m = n + o;
                            q = B >> 22;
                            r = C >> 9;
                            s = (D & 262143) << 4;
                            t = (F & 31) << 17;
                            p = q + r + s + t;
                            v = D >> 18;
                            w = F >> 5;
                            A = (G & 4095) << 8;
                            u = v + w + A;
                            p += m >> 22;
                            m &= dxe;
                            u += p >> 22;
                            p &= dxe;
                            u &= exe;
                            return hD(m, p, u);
                        }
                        function Fac(a) {
                            var b, c, d, e, f, g, h;
                            h = RD(Vmb(a.j, 0), 12);
                            if (h.g.c.length != 0 && h.e.c.length != 0) throw Adb(new dgb('Interactive layout does not support NORTH/SOUTH ports with incoming _and_ outgoing edges.'));
                            if (h.g.c.length != 0) {
                                f = oxe;
                                for(c = new Anb(h.g); c.a < c.c.c.length;){
                                    b = RD(ynb(c), 18);
                                    g = b.d.i;
                                    d = RD(mQb(g, (yCc(), _Ac)), 140);
                                    f = $wnd.Math.min(f, g.n.a - d.b);
                                }
                                return new cc(Qb(f));
                            }
                            if (h.e.c.length != 0) {
                                e = pxe;
                                for(c = new Anb(h.e); c.a < c.c.c.length;){
                                    b = RD(ynb(c), 18);
                                    g = b.c.i;
                                    d = RD(mQb(g, (yCc(), _Ac)), 140);
                                    e = $wnd.Math.max(e, g.n.a + g.o.a + d.c);
                                }
                                return new cc(Qb(e));
                            }
                            return wb(), wb(), vb;
                        }
                        function cZd(a, b) {
                            var c, d, e, f, g, h, i;
                            if (a.ol()) {
                                if (a.i > 4) {
                                    if (a.fk(b)) {
                                        if (a.al()) {
                                            e = RD(b, 54);
                                            d = e.Eh();
                                            i = d == a.e && (a.ml() ? e.yh(e.Fh(), a.il()) == a.jl() : -1 - e.Fh() == a.Lj());
                                            if (a.nl() && !i && !d && !!e.Jh()) for(f = 0; f < a.i; ++f){
                                                c = a.pl(RD(a.g[f], 58));
                                                if (dE(c) === dE(b)) return true;
                                            }
                                            return i;
                                        } else if (a.ml() && !a.ll()) {
                                            g = RD(b, 58).Mh(Z5d(RD(a.Lk(), 19)));
                                            if (dE(g) === dE(a.e)) return true;
                                            else if (g == null || !RD(g, 58).Vh()) return false;
                                        }
                                    } else return false;
                                }
                                h = PHd(a, b);
                                if (a.nl() && !h) for(f = 0; f < a.i; ++f){
                                    e = a.pl(RD(a.g[f], 58));
                                    if (dE(e) === dE(b)) return true;
                                }
                                return h;
                            } else return PHd(a, b);
                        }
                        function bGc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
                            c.Ug('Interactive cycle breaking', 1);
                            l = new bnb;
                            for(n = new Anb(b.a); n.a < n.c.c.length;){
                                m = RD(ynb(n), 10);
                                m.p = 1;
                                o = _2b(m).a;
                                for(k = c3b(m, (BEc(), zEc)).Kc(); k.Ob();){
                                    j = RD(k.Pb(), 12);
                                    for(f = new Anb(j.g); f.a < f.c.c.length;){
                                        d = RD(ynb(f), 18);
                                        p = d.d.i;
                                        if (p != m) {
                                            q = _2b(p).a;
                                            q < o && ZEb(l.c, d);
                                        }
                                    }
                                }
                            }
                            for(g = new Anb(l); g.a < g.c.c.length;){
                                d = RD(ynb(g), 18);
                                X0b(d, true);
                            }
                            l.c.length = 0;
                            for(i = new Anb(b.a); i.a < i.c.c.length;){
                                h = RD(ynb(i), 10);
                                h.p > 0 && aGc(a, h, l);
                            }
                            for(e = new Anb(l); e.a < e.c.c.length;){
                                d = RD(ynb(e), 18);
                                X0b(d, true);
                            }
                            l.c.length = 0;
                            c.Vg();
                        }
                        function mMc(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            c = 0;
                            k = new bnb;
                            for(h = new Anb(b); h.a < h.c.c.length;){
                                g = RD(ynb(h), 12);
                                $Lc(a.b, a.d[g.p]);
                                k.c.length = 0;
                                switch(g.i.k.g){
                                    case 0:
                                        d = RD(mQb(g, (Ywc(), Iwc)), 10);
                                        Umb(d.j, new XMc(k));
                                        break;
                                    case 1:
                                        Mvb(DDb(CDb(new SDb(null, new Swb(g.i.j, 16)), new ZMc(g))), new aNc(k));
                                        break;
                                    case 3:
                                        e = RD(mQb(g, (Ywc(), Awc)), 12);
                                        Rmb(k, new Ptd(e, sgb(g.e.c.length + g.g.c.length)));
                                }
                                for(j = new Anb(k); j.a < j.c.c.length;){
                                    i = RD(ynb(j), 42);
                                    f = AMc(a, RD(i.a, 12));
                                    if (f > a.d[g.p]) {
                                        c += ZLc(a.b, f) * RD(i.b, 17).a;
                                        hmb(a.a, sgb(f));
                                    }
                                }
                                while(!nmb(a.a))XLc(a.b, RD(smb(a.a), 17).a);
                            }
                            return c;
                        }
                        function x9b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            k = RD(mQb(a, (Ywc(), hwc)), 64);
                            d = RD(Vmb(a.j, 0), 12);
                            k == (qpd(), Yod) ? Q3b(d, npd) : k == npd && Q3b(d, Yod);
                            if (RD(mQb(b, (yCc(), lBc)), 181).Hc((Qpd(), Ppd))) {
                                i = Kfb(UD(mQb(a, _Bc)));
                                j = Kfb(UD(mQb(a, aCc)));
                                g = Kfb(UD(mQb(a, ZBc)));
                                h = RD(mQb(b, EBc), 21);
                                if (h.Hc((Pod(), Lod))) {
                                    c = j;
                                    l = a.o.a / 2 - d.n.a;
                                    for(f = new Anb(d.f); f.a < f.c.c.length;){
                                        e = RD(ynb(f), 72);
                                        e.n.b = c;
                                        e.n.a = l - e.o.a / 2;
                                        c += e.o.b + g;
                                    }
                                } else if (h.Hc(Nod)) for(f = new Anb(d.f); f.a < f.c.c.length;){
                                    e = RD(ynb(f), 72);
                                    e.n.a = i + a.o.a - d.n.a;
                                }
                                NJb(new PJb((i1b(), new t1b(b, false, false, new _1b))), new F1b(null, a, false));
                            }
                        }
                        function ykc(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            if (b.c.length == 0) return;
                            yob();
                            Ynb(b.c, b.c.length, null);
                            e = new Anb(b);
                            d = RD(ynb(e), 154);
                            while(e.a < e.c.c.length){
                                c = RD(ynb(e), 154);
                                if (rGb(d.e.c, c.e.c) && !(uGb(Mid(d.e).b, c.e.d) || uGb(Mid(c.e).b, d.e.d))) d = (Tmb(d.k, c.k), Tmb(d.b, c.b), Tmb(d.c, c.c), ye(d.i, c.i), Tmb(d.d, c.d), Tmb(d.j, c.j), f = $wnd.Math.min(d.e.c, c.e.c), g = $wnd.Math.min(d.e.d, c.e.d), h = $wnd.Math.max(d.e.c + d.e.b, c.e.c + c.e.b), i = h - f, j = $wnd.Math.max(d.e.d + d.e.a, c.e.d + c.e.a), k = j - g, Rid(d.e, f, g, i, k), $Gb(d.f, c.f), !d.a && (d.a = c.a), Tmb(d.g, c.g), Rmb(d.g, c), d);
                                else {
                                    Bkc(a, d);
                                    d = c;
                                }
                            }
                            Bkc(a, d);
                        }
                        function B0b(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
                            i = new bnb;
                            for(f = new Anb(b.a); f.a < f.c.c.length;){
                                e = RD(ynb(f), 10);
                                for(h = new Anb(e.j); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 12);
                                    k = null;
                                    for(t = s2b(g.g), u = 0, v = t.length; u < v; ++u){
                                        s = t[u];
                                        if (!n2b(s.d.i, c)) {
                                            r = w0b(a, b, c, s, s.c, (BEc(), zEc), k);
                                            r != k && ZEb(i.c, r);
                                            r.c && (k = r);
                                        }
                                    }
                                    j = null;
                                    for(o = s2b(g.e), p = 0, q = o.length; p < q; ++p){
                                        n = o[p];
                                        if (!n2b(n.c.i, c)) {
                                            r = w0b(a, b, c, n, n.d, (BEc(), yEc), j);
                                            r != j && ZEb(i.c, r);
                                            r.c && (j = r);
                                        }
                                    }
                                }
                            }
                            for(m = new Anb(i); m.a < m.c.c.length;){
                                l = RD(ynb(m), 453);
                                Wmb(b.a, l.a, 0) != -1 || Rmb(b.a, l.a);
                                l.c && ZEb(d.c, l);
                            }
                        }
                        function hrd(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p, q;
                            l = new sjd(RD(Gxd(a, (hkd(), bkd)), 8));
                            l.a = $wnd.Math.max(l.a - c.b - c.c, 0);
                            l.b = $wnd.Math.max(l.b - c.d - c.a, 0);
                            e = UD(Gxd(a, Xjd));
                            (e == null || (uFb(e), e) <= 0) && (e = 1.3);
                            h = new bnb;
                            for(o = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); o.e != o.i.gc();){
                                n = RD(bMd(o), 27);
                                g = new Ard(n);
                                ZEb(h.c, g);
                            }
                            m = RD(Gxd(a, Yjd), 320);
                            switch(m.g){
                                case 3:
                                    q = erd(h, b, l.a, l.b, (j = d, uFb(e), e, j));
                                    break;
                                case 1:
                                    q = drd(h, b, l.a, l.b, (k = d, uFb(e), e, k));
                                    break;
                                default:
                                    q = frd(h, b, l.a, l.b, (i = d, uFb(e), e, i));
                            }
                            f = new zrd(q);
                            p = ird(f, b, c, l.a, l.b, d, (uFb(e), e));
                            Esd(a, p.a, p.b, false, true);
                        }
                        function m2b(a, b, c, d) {
                            var e, f, g, h, i, j;
                            h = a.j;
                            if (h == (qpd(), opd) && b != (Bod(), zod) && b != (Bod(), Aod)) {
                                h = c2b(a, c);
                                Q3b(a, h);
                                !(!a.q ? (yob(), yob(), wob) : a.q)._b((yCc(), ABc)) && h != opd && (a.n.a != 0 || a.n.b != 0) && pQb(a, ABc, b2b(a, h));
                            }
                            if (b == (Bod(), xod)) {
                                j = 0;
                                switch(h.g){
                                    case 1:
                                    case 3:
                                        f = a.i.o.a;
                                        f > 0 && (j = a.n.a / f);
                                        break;
                                    case 2:
                                    case 4:
                                        e = a.i.o.b;
                                        e > 0 && (j = a.n.b / e);
                                }
                                pQb(a, (Ywc(), Jwc), j);
                            }
                            i = a.o;
                            g = a.a;
                            if (d) {
                                g.a = d.a;
                                g.b = d.b;
                                a.d = true;
                            } else if (b != zod && b != Aod && h != opd) switch(h.g){
                                case 1:
                                    g.a = i.a / 2;
                                    break;
                                case 2:
                                    g.a = i.a;
                                    g.b = i.b / 2;
                                    break;
                                case 3:
                                    g.a = i.a / 2;
                                    g.b = i.b;
                                    break;
                                case 4:
                                    g.b = i.b / 2;
                            }
                            else {
                                g.a = i.a / 2;
                                g.b = i.b / 2;
                            }
                        }
                        function VJd(a) {
                            var b, c, d, e, f, g, h, i, j, k;
                            if (a.Pj()) {
                                k = a.Ej();
                                i = a.Qj();
                                if (k > 0) {
                                    b = new $Hd(a.pj());
                                    c = k;
                                    f = c < 100 ? null : new gLd(c);
                                    aJd(a, c, b.g);
                                    e = c == 1 ? a.Ij(4, QHd(b, 0), null, 0, i) : a.Ij(6, b, null, -1, i);
                                    if (a.Mj()) {
                                        for(d = new dMd(b); d.e != d.i.gc();)f = a.Oj(bMd(d), f);
                                        if (!f) a.Jj(e);
                                        else {
                                            f.nj(e);
                                            f.oj();
                                        }
                                    } else if (!f) a.Jj(e);
                                    else {
                                        f.nj(e);
                                        f.oj();
                                    }
                                } else {
                                    aJd(a, a.Ej(), a.Fj());
                                    a.Jj(a.Ij(6, (yob(), vob), null, -1, i));
                                }
                            } else if (a.Mj()) {
                                k = a.Ej();
                                if (k > 0) {
                                    h = a.Fj();
                                    j = k;
                                    aJd(a, k, h);
                                    f = j < 100 ? null : new gLd(j);
                                    for(d = 0; d < j; ++d){
                                        g = h[d];
                                        f = a.Oj(g, f);
                                    }
                                    !!f && f.oj();
                                } else aJd(a, a.Ej(), a.Fj());
                            } else aJd(a, a.Ej(), a.Fj());
                        }
                        function frd(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n, o, p, q;
                            h = $C(iE, vxe, 28, a.c.length, 15, 1);
                            m = new pwb(new Qrd);
                            iwb(m, a);
                            j = 0;
                            p = new bnb;
                            while(m.b.c.length != 0){
                                g = RD(m.b.c.length == 0 ? null : Vmb(m.b, 0), 163);
                                if (j > 1 && urd(g) * trd(g) / 2 > h[0]) {
                                    f = 0;
                                    while(f < p.c.length - 1 && urd(g) * trd(g) / 2 > h[f])++f;
                                    o = new Rkb(p, 0, f + 1);
                                    l = new zrd(o);
                                    k = urd(g) / trd(g);
                                    i = ird(l, b, new z3b, c, d, e, k);
                                    $id(hjd(l.e), i);
                                    zFb(lwb(m, l), Bxe);
                                    n = new Rkb(p, f + 1, p.c.length);
                                    iwb(m, n);
                                    p.c.length = 0;
                                    j = 0;
                                    Pnb(h, h.length, 0);
                                } else {
                                    q = m.b.c.length == 0 ? null : Vmb(m.b, 0);
                                    q != null && owb(m, 0);
                                    j > 0 && (h[j] = h[j - 1]);
                                    h[j] += urd(g) * trd(g);
                                    ++j;
                                    ZEb(p.c, g);
                                }
                            }
                            return p;
                        }
                        function _nc(a, b) {
                            var c, d, e, f;
                            c = b.b;
                            f = new dnb(c.j);
                            e = 0;
                            d = c.j;
                            d.c.length = 0;
                            Nnc(RD($i(a.b, (qpd(), Yod), (joc(), ioc)), 15), c);
                            e = Onc(f, e, new Hoc, d);
                            Nnc(RD($i(a.b, Yod, hoc), 15), c);
                            e = Onc(f, e, new Joc, d);
                            Nnc(RD($i(a.b, Yod, goc), 15), c);
                            Nnc(RD($i(a.b, Xod, ioc), 15), c);
                            Nnc(RD($i(a.b, Xod, hoc), 15), c);
                            e = Onc(f, e, new Loc, d);
                            Nnc(RD($i(a.b, Xod, goc), 15), c);
                            Nnc(RD($i(a.b, npd, ioc), 15), c);
                            e = Onc(f, e, new Noc, d);
                            Nnc(RD($i(a.b, npd, hoc), 15), c);
                            e = Onc(f, e, new Poc, d);
                            Nnc(RD($i(a.b, npd, goc), 15), c);
                            Nnc(RD($i(a.b, ppd, ioc), 15), c);
                            e = Onc(f, e, new toc, d);
                            Nnc(RD($i(a.b, ppd, hoc), 15), c);
                            Nnc(RD($i(a.b, ppd, goc), 15), c);
                        }
                        function jJc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n;
                            for(h = new Anb(b); h.a < h.c.c.length;){
                                f = RD(ynb(h), 239);
                                f.e = null;
                                f.c = 0;
                            }
                            i = null;
                            for(g = new Anb(b); g.a < g.c.c.length;){
                                f = RD(ynb(g), 239);
                                l = f.d[0];
                                if (c && l.k != (r3b(), p3b)) continue;
                                for(n = RD(mQb(l, (Ywc(), qwc)), 15).Kc(); n.Ob();){
                                    m = RD(n.Pb(), 10);
                                    if (!c || m.k == (r3b(), p3b)) {
                                        (!f.e && (f.e = new bnb), f.e).Fc(a.b[m.c.p][m.p]);
                                        ++a.b[m.c.p][m.p].c;
                                    }
                                }
                                if (!c && l.k == (r3b(), p3b)) {
                                    if (i) for(k = RD(Qc(a.d, i), 21).Kc(); k.Ob();){
                                        j = RD(k.Pb(), 10);
                                        for(e = RD(Qc(a.d, l), 21).Kc(); e.Ob();){
                                            d = RD(e.Pb(), 10);
                                            wJc(a.b[j.c.p][j.p]).Fc(a.b[d.c.p][d.p]);
                                            ++a.b[d.c.p][d.p].c;
                                        }
                                    }
                                    i = l;
                                }
                            }
                        }
                        function iGc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
                            c.Ug('Model order cycle breaking', 1);
                            a.a = 0;
                            a.b = 0;
                            n = new bnb;
                            k = b.a.c.length;
                            for(j = new Anb(b.a); j.a < j.c.c.length;){
                                i = RD(ynb(j), 10);
                                nQb(i, (Ywc(), zwc)) && (k = $wnd.Math.max(k, RD(mQb(i, zwc), 17).a + 1));
                            }
                            for(p = new Anb(b.a); p.a < p.c.c.length;){
                                o = RD(ynb(p), 10);
                                g = hGc(a, o, k);
                                for(m = c3b(o, (BEc(), zEc)).Kc(); m.Ob();){
                                    l = RD(m.Pb(), 12);
                                    for(f = new Anb(l.g); f.a < f.c.c.length;){
                                        d = RD(ynb(f), 18);
                                        q = d.d.i;
                                        h = hGc(a, q, k);
                                        h < g && ZEb(n.c, d);
                                    }
                                }
                            }
                            for(e = new Anb(n); e.a < e.c.c.length;){
                                d = RD(ynb(e), 18);
                                X0b(d, true);
                                pQb(b, (Ywc(), awc), (Geb(), true));
                            }
                            n.c.length = 0;
                            c.Vg();
                        }
                        function qUb(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            g = b.d;
                            h = c.d;
                            while(g.a - h.a == 0 && g.b - h.b == 0){
                                i = false;
                                if (ZD(b, 250) && ZD(c, 250) && !i) {
                                    j = RD(b, 250).a;
                                    k = ojd(new sjd($Tb(j)), ZTb(j));
                                    d = 2;
                                    e = new rjd(k.a / $wnd.Math.sqrt(k.a * k.a + k.b * k.b) * d, -k.b / $wnd.Math.sqrt(k.a * k.a + k.b * k.b) * d);
                                    $id(g, e);
                                    l = RD(c, 250).a;
                                    m = ojd(new sjd($Tb(l)), ZTb(l));
                                    d = k == m ? -2 : 2;
                                    f = new rjd(m.a / $wnd.Math.sqrt(m.a * m.a + m.b * m.b) * d, -(m.b / $wnd.Math.sqrt(m.a * m.a + m.b * m.b)) * d);
                                    $id(g, f);
                                    i = true;
                                } else {
                                    g.a += Kwb(a, 26) * Kxe + Kwb(a, 27) * Lxe - 0.5;
                                    g.b += Kwb(a, 26) * Kxe + Kwb(a, 27) * Lxe - 0.5;
                                    h.a += Kwb(a, 26) * Kxe + Kwb(a, 27) * Lxe - 0.5;
                                    h.b += Kwb(a, 26) * Kxe + Kwb(a, 27) * Lxe - 0.5;
                                }
                            }
                        }
                        function NWb(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                            j = KWb(b);
                            q = RD(mQb(b, (yCc(), oAc)), 322);
                            xgb(j, new UWb(q));
                            r = RD(mQb(b, gAc), 299);
                            xgb(j, new WWb(r));
                            p = 0;
                            k = new bnb;
                            for(f = new Kmb(j); f.a != f.b;){
                                e = RD(Imb(f), 36);
                                cXb(a.c, e);
                                m = RD(mQb(e, (Ywc(), Kwc)), 15);
                                p += m.gc();
                                d = m.Kc();
                                Rmb(k, new Ptd(e, d));
                            }
                            c.Ug('Recursive hierarchical layout', p);
                            o = 0;
                            n = RD(RD(Vmb(k, k.c.length - 1), 42).b, 51);
                            while(n.Ob())for(i = new Anb(k); i.a < i.c.c.length;){
                                h = RD(ynb(i), 42);
                                m = RD(h.b, 51);
                                g = RD(h.a, 36);
                                while(m.Ob()){
                                    l = RD(m.Pb(), 47);
                                    if (ZD(l, 514)) {
                                        if (!g.e) {
                                            l.Kf(g, c.eh(1));
                                            ++o;
                                            break;
                                        } else break;
                                    } else {
                                        l.Kf(g, c.eh(1));
                                        ++o;
                                    }
                                }
                            }
                            c.Vg();
                        }
                        function Cec(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
                            b.Ug('Layer size calculation', 1);
                            k = oxe;
                            j = pxe;
                            e = false;
                            for(h = new Anb(a.b); h.a < h.c.c.length;){
                                g = RD(ynb(h), 30);
                                i = g.c;
                                i.a = 0;
                                i.b = 0;
                                if (g.a.c.length == 0) continue;
                                e = true;
                                for(m = new Anb(g.a); m.a < m.c.c.length;){
                                    l = RD(ynb(m), 10);
                                    o = l.o;
                                    n = l.d;
                                    i.a = $wnd.Math.max(i.a, o.a + n.b + n.c);
                                }
                                d = RD(Vmb(g.a, 0), 10);
                                p = d.n.b - d.d.d;
                                d.k == (r3b(), m3b) && (p -= RD(mQb(a, (yCc(), eCc)), 140).d);
                                f = RD(Vmb(g.a, g.a.c.length - 1), 10);
                                c = f.n.b + f.o.b + f.d.a;
                                f.k == m3b && (c += RD(mQb(a, (yCc(), eCc)), 140).a);
                                i.b = c - p;
                                k = $wnd.Math.min(k, p);
                                j = $wnd.Math.max(j, c);
                            }
                            if (!e) {
                                k = 0;
                                j = 0;
                            }
                            a.f.b = j - k;
                            a.c.b -= k;
                            b.Vg();
                        }
                        function p2b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                            f = 0;
                            g = 0;
                            for(j = new Anb(a.a); j.a < j.c.c.length;){
                                h = RD(ynb(j), 10);
                                f = $wnd.Math.max(f, h.d.b);
                                g = $wnd.Math.max(g, h.d.c);
                            }
                            for(i = new Anb(a.a); i.a < i.c.c.length;){
                                h = RD(ynb(i), 10);
                                c = RD(mQb(h, (yCc(), Rzc)), 255);
                                switch(c.g){
                                    case 1:
                                        o = 0;
                                        break;
                                    case 2:
                                        o = 1;
                                        break;
                                    case 5:
                                        o = 0.5;
                                        break;
                                    default:
                                        d = 0;
                                        l = 0;
                                        for(n = new Anb(h.j); n.a < n.c.c.length;){
                                            m = RD(ynb(n), 12);
                                            m.e.c.length == 0 || ++d;
                                            m.g.c.length == 0 || ++l;
                                        }
                                        d + l == 0 ? o = 0.5 : o = l / (d + l);
                                }
                                q = a.c;
                                k = h.o.a;
                                r = (q.a - k) * o;
                                o > 0.5 ? r -= g * 2 * (o - 0.5) : o < 0.5 && (r += f * 2 * (0.5 - o));
                                e = h.d.b;
                                r < e && (r = e);
                                p = h.d.c;
                                r > q.a - p - k && (r = q.a - p - k);
                                h.n.a = b + r;
                            }
                        }
                        function jec(a) {
                            var b, c, d, e, f;
                            d = RD(mQb(a, (yCc(), UAc)), 171);
                            if (d == (cxc(), $wc)) for(c = new is(Mr(Z2b(a).a.Kc(), new ir)); gs(c);){
                                b = RD(hs(c), 18);
                                if (!lec(b)) throw Adb(new Jed(nBe + X2b(a) + "' has its layer constraint set to FIRST_SEPARATE, but has at least one incoming edge. " + 'FIRST_SEPARATE nodes must not have incoming edges.'));
                            }
                            else if (d == axc) for(f = new is(Mr(a3b(a).a.Kc(), new ir)); gs(f);){
                                e = RD(hs(f), 18);
                                if (!lec(e)) throw Adb(new Jed(nBe + X2b(a) + "' has its layer constraint set to LAST_SEPARATE, but has at least one outgoing edge. " + 'LAST_SEPARATE nodes must not have outgoing edges.'));
                            }
                        }
                        function Qed(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o;
                            if (a.e && a.c.c < a.f) throw Adb(new dgb('Expected ' + a.f + ' phases to be configured; ' + 'only found ' + a.c.c));
                            k = RD(mfb(a.g), 9);
                            n = ev(a.f);
                            for(f = k, h = 0, j = f.length; h < j; ++h){
                                d = f[h];
                                l = RD(Med(a, d.g), 188);
                                l ? Rmb(n, RD(Ted(a, l), 106)) : (n.c.push(null), undefined);
                            }
                            o = new ufd;
                            FDb(CDb(GDb(CDb(new SDb(null, new Swb(n, 16)), new Zed), new _ed(b)), new bfd), new dfd(o));
                            ofd(o, a.a);
                            c = new bnb;
                            for(e = k, g = 0, i = e.length; g < i; ++g){
                                d = e[g];
                                Tmb(c, Ued(a, Ux(RD(Med(o, d.g), 20))));
                                m = RD(Vmb(n, d.g), 106);
                                !!m && ZEb(c.c, m);
                            }
                            Tmb(c, Ued(a, Ux(RD(Med(o, k[k.length - 1].g + 1), 20))));
                            return c;
                        }
                        function Frc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
                            m = new bnb;
                            e = new bnb;
                            p = null;
                            for(h = b.Kc(); h.Ob();){
                                g = RD(h.Pb(), 17);
                                f = new Trc(g.a);
                                ZEb(e.c, f);
                                if (p) {
                                    f.d = p;
                                    p.e = f;
                                }
                                p = f;
                            }
                            t = Erc(a);
                            for(k = 0; k < e.c.length; ++k){
                                n = null;
                                q = Src((tFb(0, e.c.length), RD(e.c[0], 661)));
                                c = null;
                                d = oxe;
                                for(l = 1; l < a.b.c.length; ++l){
                                    r = q ? $wnd.Math.abs(q.b - l) : $wnd.Math.abs(l - n.b) + 1;
                                    o = n ? $wnd.Math.abs(l - n.b) : r + 1;
                                    if (o < r) {
                                        j = n;
                                        i = o;
                                    } else {
                                        j = q;
                                        i = r;
                                    }
                                    s = (u = Kfb(UD(mQb(a, (yCc(), sCc)))), t[l] + $wnd.Math.pow(i, u));
                                    if (s < d) {
                                        d = s;
                                        c = j;
                                        c.c = l;
                                    }
                                    if (!!q && l == q.b) {
                                        n = q;
                                        q = Nrc(q);
                                    }
                                }
                                if (c) {
                                    Rmb(m, sgb(c.c));
                                    c.a = true;
                                    Orc(c);
                                }
                            }
                            yob();
                            Ynb(m.c, m.c.length, null);
                            return m;
                        }
                        function iD(a, b, c) {
                            var d, e, f, g, h, i;
                            if (b.l == 0 && b.m == 0 && b.h == 0) throw Adb(new teb('divide by zero'));
                            if (a.l == 0 && a.m == 0 && a.h == 0) {
                                c && (eD = hD(0, 0, 0));
                                return hD(0, 0, 0);
                            }
                            if (b.h == fxe && b.m == 0 && b.l == 0) return jD(a, c);
                            i = false;
                            if (b.h >> 19 != 0) {
                                b = xD(b);
                                i = !i;
                            }
                            g = pD(b);
                            f = false;
                            e = false;
                            d = false;
                            if (a.h == fxe && a.m == 0 && a.l == 0) {
                                e = true;
                                f = true;
                                if (g == -1) {
                                    a = gD((MD(), ID));
                                    d = true;
                                    i = !i;
                                } else {
                                    h = BD(a, g);
                                    i && nD(h);
                                    c && (eD = hD(0, 0, 0));
                                    return h;
                                }
                            } else if (a.h >> 19 != 0) {
                                f = true;
                                a = xD(a);
                                d = true;
                                i = !i;
                            }
                            if (g != -1) return kD(a, g, i, f, c);
                            if (uD(a, b) < 0) {
                                c && (f ? eD = xD(a) : eD = hD(a.l, a.m, a.h));
                                return hD(0, 0, 0);
                            }
                            return lD(d ? a : hD(a.l, a.m, a.h), b, i, f, e, c);
                        }
                        function Bjb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o;
                            g = a.e;
                            i = b.e;
                            if (g == 0) return b;
                            if (i == 0) return a;
                            f = a.d;
                            h = b.d;
                            if (f + h == 2) {
                                c = Cdb(a.a[0], yxe);
                                d = Cdb(b.a[0], yxe);
                                if (g == i) {
                                    k = Bdb(c, d);
                                    o = Ydb(k);
                                    n = Ydb(Udb(k, 32));
                                    return n == 0 ? new ajb(g, o) : new cjb(g, 2, cD(WC(kE, 1), Pwe, 28, 15, [
                                        o,
                                        n
                                    ]));
                                }
                                return Pib(), Jdb(g < 0 ? Vdb(d, c) : Vdb(c, d), 0) ? jjb(g < 0 ? Vdb(d, c) : Vdb(c, d)) : Xib(jjb(Odb(g < 0 ? Vdb(d, c) : Vdb(c, d))));
                            } else if (g == i) {
                                m = g;
                                l = f >= h ? Cjb(a.a, f, b.a, h) : Cjb(b.a, h, a.a, f);
                            } else {
                                e = f != h ? f > h ? 1 : -1 : Ejb(a.a, b.a, f);
                                if (e == 0) return Pib(), Oib;
                                if (e == 1) {
                                    m = g;
                                    l = Hjb(a.a, f, b.a, h);
                                } else {
                                    m = i;
                                    l = Hjb(b.a, h, a.a, f);
                                }
                            }
                            j = new cjb(m, l.length, l);
                            Rib(j);
                            return j;
                        }
                        function KUc(a, b) {
                            var c, d, e, f, g, h, i;
                            if (a.g > b.f || b.g > a.f) return;
                            c = 0;
                            d = 0;
                            for(g = a.w.a.ec().Kc(); g.Ob();){
                                e = RD(g.Pb(), 12);
                                AVc(xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                    e.i.n,
                                    e.n,
                                    e.a
                                ])).b, b.g, b.f) && ++c;
                            }
                            for(h = a.r.a.ec().Kc(); h.Ob();){
                                e = RD(h.Pb(), 12);
                                AVc(xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                    e.i.n,
                                    e.n,
                                    e.a
                                ])).b, b.g, b.f) && --c;
                            }
                            for(i = b.w.a.ec().Kc(); i.Ob();){
                                e = RD(i.Pb(), 12);
                                AVc(xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                    e.i.n,
                                    e.n,
                                    e.a
                                ])).b, a.g, a.f) && ++d;
                            }
                            for(f = b.r.a.ec().Kc(); f.Ob();){
                                e = RD(f.Pb(), 12);
                                AVc(xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                    e.i.n,
                                    e.n,
                                    e.a
                                ])).b, a.g, a.f) && --d;
                            }
                            if (c < d) new _Uc(a, b, d - c);
                            else if (d < c) new _Uc(b, a, c - d);
                            else {
                                new _Uc(b, a, 0);
                                new _Uc(a, b, 0);
                            }
                        }
                        function ASb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
                            j = b.c;
                            e = zRb(a.e);
                            l = ijd(njd(ajd(yRb(a.e)), a.d * a.a, a.c * a.b), -0.5);
                            c = e.a - l.a;
                            d = e.b - l.b;
                            g = b.a;
                            c = g.c - c;
                            d = g.d - d;
                            for(i = new Anb(j); i.a < i.c.c.length;){
                                h = RD(ynb(i), 407);
                                m = h.b;
                                n = c + m.a;
                                q = d + m.b;
                                o = eE(n / a.a);
                                r = eE(q / a.b);
                                f = h.a;
                                switch(f.g){
                                    case 0:
                                        k = (IPb(), FPb);
                                        break;
                                    case 1:
                                        k = (IPb(), EPb);
                                        break;
                                    case 2:
                                        k = (IPb(), GPb);
                                        break;
                                    default:
                                        k = (IPb(), HPb);
                                }
                                if (f.a) {
                                    s = eE((q + h.c) / a.b);
                                    Rmb(a.f, new lRb(k, sgb(r), sgb(s)));
                                    f == (IRb(), HRb) ? eQb(a, 0, r, o, s) : eQb(a, o, r, a.d - 1, s);
                                } else {
                                    p = eE((n + h.c) / a.a);
                                    Rmb(a.f, new lRb(k, sgb(o), sgb(p)));
                                    f == (IRb(), FRb) ? eQb(a, o, 0, p, r) : eQb(a, o, r, p, a.c - 1);
                                }
                            }
                        }
                        function Q$d(a) {
                            var b, c, d, e, f, g, h, i, j, k;
                            b = new Z$d;
                            c = new Z$d;
                            j = lhb(pKe, (e = bAd(a.b, qKe), !e ? null : WD($Nd((!e.b && (e.b = new SVd((JTd(), FTd), C8, e)), e.b), rKe))));
                            for(i = 0; i < a.i; ++i){
                                h = RD(a.g[i], 179);
                                if (ZD(h, 102)) {
                                    g = RD(h, 19);
                                    (g.Bb & QHe) != 0 ? ((g.Bb & Ove) == 0 || !j && (f = bAd(g, qKe), (!f ? null : WD($Nd((!f.b && (f.b = new SVd((JTd(), FTd), C8, f)), f.b), FIe))) == null)) && WGd(b, g) : (k = Z5d(g), !!k && (k.Bb & QHe) != 0 || ((g.Bb & Ove) == 0 || !j && (d = bAd(g, qKe), (!d ? null : WD($Nd((!d.b && (d.b = new SVd((JTd(), FTd), C8, d)), d.b), FIe))) == null)) && WGd(c, g));
                                } else {
                                    nke();
                                    if (RD(h, 69).xk()) {
                                        if (!h.sk()) {
                                            WGd(b, h);
                                            WGd(c, h);
                                        }
                                    }
                                }
                            }
                            VHd(b);
                            VHd(c);
                            a.a = RD(b.g, 254);
                            RD(c.g, 254);
                        }
                        function Eee(a, b, c) {
                            var d, e, f, g, h, i, j, k, l;
                            if (BYd(b, c) >= 0) return c;
                            switch(yfe(Qee(a, c))){
                                case 2:
                                    if (lhb('', Oee(a, c.qk()).xe())) {
                                        i = Bfe(Qee(a, c));
                                        h = Afe(Qee(a, c));
                                        k = Ree(a, b, i, h);
                                        if (k) return k;
                                        e = Fee(a, b);
                                        for(g = 0, l = e.gc(); g < l; ++g){
                                            k = RD(e.Xb(g), 179);
                                            if (Xee(Cfe(Qee(a, k)), i)) return k;
                                        }
                                    }
                                    return null;
                                case 4:
                                    if (lhb('', Oee(a, c.qk()).xe())) {
                                        for(d = c; d; d = xfe(Qee(a, d))){
                                            j = Bfe(Qee(a, d));
                                            h = Afe(Qee(a, d));
                                            k = See(a, b, j, h);
                                            if (k) return k;
                                        }
                                        i = Bfe(Qee(a, c));
                                        if (lhb(dLe, i)) return Tee(a, b);
                                        else {
                                            f = Gee(a, b);
                                            for(g = 0, l = f.gc(); g < l; ++g){
                                                k = RD(f.Xb(g), 179);
                                                if (Xee(Cfe(Qee(a, k)), i)) return k;
                                            }
                                        }
                                    }
                                    return null;
                                default:
                                    return null;
                            }
                        }
                        function Tfe(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            if (c.gc() == 0) return false;
                            h = (nke(), RD(b, 69).xk());
                            f = h ? c : new ZHd(c.gc());
                            if (qke(a.e, b)) {
                                if (b.Si()) for(j = c.Kc(); j.Ob();){
                                    i = j.Pb();
                                    if (!dge(a, b, i, ZD(b, 102) && (RD(b, 19).Bb & txe) != 0)) {
                                        e = oke(b, i);
                                        f.Hc(e) || f.Fc(e);
                                    }
                                }
                                else if (!h) for(j = c.Kc(); j.Ob();){
                                    i = j.Pb();
                                    e = oke(b, i);
                                    f.Fc(e);
                                }
                            } else {
                                if (c.gc() > 1) throw Adb(new agb(gLe));
                                k = pke(a.e.Dh(), b);
                                d = RD(a.g, 124);
                                for(g = 0; g < a.i; ++g){
                                    e = d[g];
                                    if (k.am(e.Lk())) {
                                        if (c.Hc(h ? e : e.md())) return false;
                                        else {
                                            for(j = c.Kc(); j.Ob();){
                                                i = j.Pb();
                                                RD(eHd(a, g, h ? RD(i, 76) : oke(b, i)), 76);
                                            }
                                            return true;
                                        }
                                    }
                                }
                                if (!h) {
                                    e = oke(b, c.Kc().Pb());
                                    f.Fc(e);
                                }
                            }
                            return YGd(a, f);
                        }
                        function QQc(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            k = new Yub;
                            for(h = (j = new glb(a.c).a.vc().Kc(), new llb(j)); h.a.Ob();){
                                f = (e = RD(h.a.Pb(), 44), RD(e.md(), 467));
                                f.b == 0 && Pub(k, f, k.c.b, k.c);
                            }
                            while(k.b != 0){
                                f = RD(k.b == 0 ? null : (sFb(k.b != 0), Wub(k, k.a.a)), 467);
                                f.a == null && (f.a = 0);
                                for(d = new Anb(f.d); d.a < d.c.c.length;){
                                    c = RD(ynb(d), 663);
                                    c.b.a == null ? c.b.a = Kfb(f.a) + c.a : b.o == (EQc(), CQc) ? c.b.a = $wnd.Math.min(Kfb(c.b.a), Kfb(f.a) + c.a) : c.b.a = $wnd.Math.max(Kfb(c.b.a), Kfb(f.a) + c.a);
                                    --c.b.b;
                                    c.b.b == 0 && Mub(k, c.b);
                                }
                            }
                            for(g = (i = new glb(a.c).a.vc().Kc(), new llb(i)); g.a.Ob();){
                                f = (e = RD(g.a.Pb(), 44), RD(e.md(), 467));
                                b.i[f.c.p] = f.a;
                            }
                        }
                        function kSc(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o;
                            k = c + b.c.c.a;
                            for(n = new Anb(b.j); n.a < n.c.c.length;){
                                m = RD(ynb(n), 12);
                                e = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                    m.i.n,
                                    m.n,
                                    m.a
                                ]));
                                if (b.k == (r3b(), q3b)) {
                                    h = RD(mQb(m, (Ywc(), Awc)), 12);
                                    e.a = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                        h.i.n,
                                        h.n,
                                        h.a
                                    ])).a;
                                    b.n.a = e.a;
                                }
                                g = new rjd(0, e.b);
                                if (m.j == (qpd(), Xod)) g.a = k;
                                else if (m.j == ppd) g.a = c;
                                else continue;
                                o = $wnd.Math.abs(e.a - g.a);
                                if (o <= d && !hSc(b)) continue;
                                f = m.g.c.length + m.e.c.length > 1;
                                for(j = new l4b(m.b); xnb(j.a) || xnb(j.b);){
                                    i = RD(xnb(j.a) ? ynb(j.a) : ynb(j.b), 18);
                                    l = i.c == m ? i.d : i.c;
                                    $wnd.Math.abs(xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                        l.i.n,
                                        l.n,
                                        l.a
                                    ])).b - g.b) > 1 && eSc(a, i, g, f, m);
                                }
                            }
                        }
                        function vUc(a) {
                            var b, c, d, e, f, g;
                            e = new Jkb(a.e, 0);
                            d = new Jkb(a.a, 0);
                            if (a.d) for(c = 0; c < a.b; c++){
                                sFb(e.b < e.d.gc());
                                e.d.Xb(e.c = e.b++);
                            }
                            else for(c = 0; c < a.b - 1; c++){
                                sFb(e.b < e.d.gc());
                                e.d.Xb(e.c = e.b++);
                                Ckb(e);
                            }
                            b = Kfb((sFb(e.b < e.d.gc()), UD(e.d.Xb(e.c = e.b++))));
                            while(a.f - b > AEe){
                                f = b;
                                g = 0;
                                while($wnd.Math.abs(b - f) < AEe){
                                    ++g;
                                    b = Kfb((sFb(e.b < e.d.gc()), UD(e.d.Xb(e.c = e.b++))));
                                    sFb(d.b < d.d.gc());
                                    d.d.Xb(d.c = d.b++);
                                }
                                if (g < a.b) {
                                    sFb(e.b > 0);
                                    e.a.Xb(e.c = --e.b);
                                    uUc(a, a.b - g, f, d, e);
                                    sFb(e.b < e.d.gc());
                                    e.d.Xb(e.c = e.b++);
                                }
                                sFb(d.b > 0);
                                d.a.Xb(d.c = --d.b);
                            }
                            if (!a.d) for(c = 0; c < a.b - 1; c++){
                                sFb(e.b < e.d.gc());
                                e.d.Xb(e.c = e.b++);
                                Ckb(e);
                            }
                            a.d = true;
                            a.c = true;
                        }
                        function nme() {
                            nme = geb;
                            Rle = (Qle(), Ple).b;
                            Ule = RD(QHd(xYd(Ple.b), 0), 35);
                            Sle = RD(QHd(xYd(Ple.b), 1), 35);
                            Tle = RD(QHd(xYd(Ple.b), 2), 35);
                            cme = Ple.bb;
                            RD(QHd(xYd(Ple.bb), 0), 35);
                            RD(QHd(xYd(Ple.bb), 1), 35);
                            eme = Ple.fb;
                            fme = RD(QHd(xYd(Ple.fb), 0), 35);
                            RD(QHd(xYd(Ple.fb), 1), 35);
                            RD(QHd(xYd(Ple.fb), 2), 19);
                            hme = Ple.qb;
                            kme = RD(QHd(xYd(Ple.qb), 0), 35);
                            RD(QHd(xYd(Ple.qb), 1), 19);
                            RD(QHd(xYd(Ple.qb), 2), 19);
                            ime = RD(QHd(xYd(Ple.qb), 3), 35);
                            jme = RD(QHd(xYd(Ple.qb), 4), 35);
                            mme = RD(QHd(xYd(Ple.qb), 6), 35);
                            lme = RD(QHd(xYd(Ple.qb), 5), 19);
                            Vle = Ple.j;
                            Wle = Ple.k;
                            Xle = Ple.q;
                            Yle = Ple.w;
                            Zle = Ple.B;
                            $le = Ple.A;
                            _le = Ple.C;
                            ame = Ple.D;
                            bme = Ple._;
                            dme = Ple.cb;
                            gme = Ple.hb;
                        }
                        function yIc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n;
                            a.c = 0;
                            a.b = 0;
                            d = 2 * b.c.a.c.length + 1;
                            o: for(l = c.Kc(); l.Ob();){
                                k = RD(l.Pb(), 12);
                                h = k.j == (qpd(), Yod) || k.j == npd;
                                n = 0;
                                if (h) {
                                    m = RD(mQb(k, (Ywc(), Iwc)), 10);
                                    if (!m) continue;
                                    n += tIc(a, d, k, m);
                                } else {
                                    for(j = new Anb(k.g); j.a < j.c.c.length;){
                                        i = RD(ynb(j), 18);
                                        e = i.d;
                                        if (e.i.c == b.c) {
                                            Rmb(a.a, k);
                                            continue o;
                                        } else n += a.g[e.p];
                                    }
                                    for(g = new Anb(k.e); g.a < g.c.c.length;){
                                        f = RD(ynb(g), 18);
                                        e = f.c;
                                        if (e.i.c == b.c) {
                                            Rmb(a.a, k);
                                            continue o;
                                        } else n -= a.g[e.p];
                                    }
                                }
                                if (k.e.c.length + k.g.c.length > 0) {
                                    a.f[k.p] = n / (k.e.c.length + k.g.c.length);
                                    a.c = $wnd.Math.min(a.c, a.f[k.p]);
                                    a.b = $wnd.Math.max(a.b, a.f[k.p]);
                                } else h && (a.f[k.p] = n);
                            }
                        }
                        function xne(a) {
                            a.b = null;
                            a.bb = null;
                            a.fb = null;
                            a.qb = null;
                            a.a = null;
                            a.c = null;
                            a.d = null;
                            a.e = null;
                            a.f = null;
                            a.n = null;
                            a.M = null;
                            a.L = null;
                            a.Q = null;
                            a.R = null;
                            a.K = null;
                            a.db = null;
                            a.eb = null;
                            a.g = null;
                            a.i = null;
                            a.j = null;
                            a.k = null;
                            a.gb = null;
                            a.o = null;
                            a.p = null;
                            a.q = null;
                            a.r = null;
                            a.$ = null;
                            a.ib = null;
                            a.S = null;
                            a.T = null;
                            a.t = null;
                            a.s = null;
                            a.u = null;
                            a.v = null;
                            a.w = null;
                            a.B = null;
                            a.A = null;
                            a.C = null;
                            a.D = null;
                            a.F = null;
                            a.G = null;
                            a.H = null;
                            a.I = null;
                            a.J = null;
                            a.P = null;
                            a.Z = null;
                            a.U = null;
                            a.V = null;
                            a.W = null;
                            a.X = null;
                            a.Y = null;
                            a._ = null;
                            a.ab = null;
                            a.cb = null;
                            a.hb = null;
                            a.nb = null;
                            a.lb = null;
                            a.mb = null;
                            a.ob = null;
                            a.pb = null;
                            a.jb = null;
                            a.kb = null;
                            a.N = false;
                            a.O = false;
                        }
                        function C8b(a, b, c) {
                            var d, e, f, g;
                            c.Ug('Graph transformation (' + a.a + ')', 1);
                            g = bv(b.a);
                            for(f = new Anb(b.b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 30);
                                Tmb(g, e.a);
                            }
                            d = RD(mQb(b, (yCc(), sAc)), 428);
                            if (d == ($tc(), Ytc)) switch(RD(mQb(b, rAc), 88).g){
                                case 2:
                                    q8b(b, g);
                                    break;
                                case 3:
                                    G8b(b, g);
                                    break;
                                case 4:
                                    if (a.a == (P8b(), O8b)) {
                                        G8b(b, g);
                                        r8b(b, g);
                                    } else {
                                        r8b(b, g);
                                        G8b(b, g);
                                    }
                            }
                            else if (a.a == (P8b(), O8b)) switch(RD(mQb(b, rAc), 88).g){
                                case 2:
                                    q8b(b, g);
                                    r8b(b, g);
                                    break;
                                case 3:
                                    G8b(b, g);
                                    q8b(b, g);
                                    break;
                                case 4:
                                    q8b(b, g);
                                    G8b(b, g);
                            }
                            else switch(RD(mQb(b, rAc), 88).g){
                                case 2:
                                    q8b(b, g);
                                    r8b(b, g);
                                    break;
                                case 3:
                                    q8b(b, g);
                                    G8b(b, g);
                                    break;
                                case 4:
                                    G8b(b, g);
                                    q8b(b, g);
                            }
                            c.Vg();
                        }
                        function AXb(a) {
                            var b, c, d, e, f, g, h, i;
                            for(f = new Anb(a.a.b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 86);
                                e.b.c = e.g.c;
                                e.b.d = e.g.d;
                            }
                            i = new rjd(oxe, oxe);
                            b = new rjd(pxe, pxe);
                            for(d = new Anb(a.a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 86);
                                i.a = $wnd.Math.min(i.a, c.g.c);
                                i.b = $wnd.Math.min(i.b, c.g.d);
                                b.a = $wnd.Math.max(b.a, c.g.c + c.g.b);
                                b.b = $wnd.Math.max(b.b, c.g.d + c.g.a);
                            }
                            for(h = Uc(a.c).a.nc(); h.Ob();){
                                g = RD(h.Pb(), 42);
                                c = RD(g.b, 86);
                                i.a = $wnd.Math.min(i.a, c.g.c);
                                i.b = $wnd.Math.min(i.b, c.g.d);
                                b.a = $wnd.Math.max(b.a, c.g.c + c.g.b);
                                b.b = $wnd.Math.max(b.b, c.g.d + c.g.a);
                            }
                            a.d = fjd(new rjd(i.a, i.b));
                            a.e = ojd(new rjd(b.a, b.b), i);
                            a.a.a.c.length = 0;
                            a.a.b.c.length = 0;
                        }
                        function LZb(a) {
                            CZb();
                            var b, c, d, e, f, g, h;
                            h = new EZb;
                            for(c = new Anb(a); c.a < c.c.c.length;){
                                b = RD(ynb(c), 148);
                                (!h.b || b.c >= h.b.c) && (h.b = b);
                                if (!h.c || b.c <= h.c.c) {
                                    h.d = h.c;
                                    h.c = b;
                                }
                                (!h.e || b.d >= h.e.d) && (h.e = b);
                                (!h.f || b.d <= h.f.d) && (h.f = b);
                            }
                            d = new PZb((nZb(), jZb));
                            t$b(a, AZb, new mob(cD(WC(wQ, 1), rve, 382, 0, [
                                d
                            ])));
                            g = new PZb(mZb);
                            t$b(a, zZb, new mob(cD(WC(wQ, 1), rve, 382, 0, [
                                g
                            ])));
                            e = new PZb(kZb);
                            t$b(a, yZb, new mob(cD(WC(wQ, 1), rve, 382, 0, [
                                e
                            ])));
                            f = new PZb(lZb);
                            t$b(a, xZb, new mob(cD(WC(wQ, 1), rve, 382, 0, [
                                f
                            ])));
                            FZb(d.c, jZb);
                            FZb(e.c, kZb);
                            FZb(f.c, lZb);
                            FZb(g.c, mZb);
                            h.a.c.length = 0;
                            Tmb(h.a, d.c);
                            Tmb(h.a, hv(e.c));
                            Tmb(h.a, f.c);
                            Tmb(h.a, hv(g.c));
                            return h;
                        }
                        function n9c(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o;
                            b.Ug(bGe, 1);
                            n = Kfb(UD(Gxd(a, (X6c(), W6c))));
                            g = Kfb(UD(Gxd(a, (X7c(), Q7c))));
                            h = RD(Gxd(a, N7c), 107);
                            Bad((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a));
                            k = U8c((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a), n, g);
                            !a.a && (a.a = new C5d(J4, a, 10, 11));
                            for(j = new Anb(k); j.a < j.c.c.length;){
                                i = RD(ynb(j), 186);
                                for(e = new Anb(i.a); e.a < e.c.c.length;){
                                    d = RD(ynb(e), 172);
                                    m = new had(d.s, d.t, Kfb(UD(Gxd(a, Q7c))));
                                    aad(m, d);
                                    Rmb(i.d, m);
                                }
                            }
                            l = zad(k, g);
                            o = $wnd.Math.max(l.a, Kfb(UD(Gxd(a, U6c))) - (h.b + h.c));
                            f = $wnd.Math.max(l.b, Kfb(UD(Gxd(a, R6c))) - (h.d + h.a));
                            c = f - l.b;
                            Ixd(a, M6c, c);
                            Ixd(a, O6c, o);
                            Ixd(a, N6c, f + c);
                            Ixd(a, V6c, k);
                            b.Vg();
                        }
                        function A9b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p;
                            j = new Iub;
                            k = new Iub;
                            o = new Iub;
                            p = new Iub;
                            i = Kfb(UD(mQb(b, (yCc(), bCc))));
                            f = Kfb(UD(mQb(b, TBc)));
                            for(h = new Anb(c); h.a < h.c.c.length;){
                                g = RD(ynb(h), 10);
                                l = RD(mQb(g, (Ywc(), hwc)), 64);
                                if (l == (qpd(), Yod)) {
                                    k.a.zc(g, k);
                                    for(e = new is(Mr(Z2b(g).a.Kc(), new ir)); gs(e);){
                                        d = RD(hs(e), 18);
                                        Ysb(j, d.c.i);
                                    }
                                } else if (l == npd) {
                                    p.a.zc(g, p);
                                    for(e = new is(Mr(Z2b(g).a.Kc(), new ir)); gs(e);){
                                        d = RD(hs(e), 18);
                                        Ysb(o, d.c.i);
                                    }
                                }
                            }
                            if (j.a.gc() != 0) {
                                m = new TTc(2, f);
                                n = STc(m, b, j, k, -i - b.c.b);
                                if (n > 0) {
                                    a.a = i + (n - 1) * f;
                                    b.c.b += a.a;
                                    b.f.b += a.a;
                                }
                            }
                            if (o.a.gc() != 0) {
                                m = new TTc(1, f);
                                n = STc(m, b, o, p, b.f.b + i - b.c.b);
                                n > 0 && (b.f.b += i + (n - 1) * f);
                            }
                        }
                        function osc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
                            k = Kfb(UD(mQb(a, (yCc(), WBc))));
                            d = Kfb(UD(mQb(a, nCc)));
                            m = new dtd;
                            pQb(m, WBc, k + d);
                            j = b;
                            r = j.d;
                            p = j.c.i;
                            s = j.d.i;
                            q = Q4b(p.c);
                            t = Q4b(s.c);
                            e = new bnb;
                            for(l = q; l <= t; l++){
                                h = new j3b(a);
                                h3b(h, (r3b(), o3b));
                                pQb(h, (Ywc(), Awc), j);
                                pQb(h, BBc, (Bod(), wod));
                                pQb(h, YBc, m);
                                n = RD(Vmb(a.b, l), 30);
                                l == q ? f3b(h, n.a.c.length - c, n) : g3b(h, n);
                                u = Kfb(UD(mQb(j, FAc)));
                                if (u < 0) {
                                    u = 0;
                                    pQb(j, FAc, u);
                                }
                                h.o.b = u;
                                o = $wnd.Math.floor(u / 2);
                                g = new R3b;
                                Q3b(g, (qpd(), ppd));
                                P3b(g, h);
                                g.n.b = o;
                                i = new R3b;
                                Q3b(i, Xod);
                                P3b(i, h);
                                i.n.b = o;
                                Z0b(j, g);
                                f = new a1b;
                                kQb(f, j);
                                pQb(f, RAc, null);
                                Y0b(f, i);
                                Z0b(f, r);
                                psc(h, j, f);
                                ZEb(e.c, f);
                                j = f;
                            }
                            return e;
                        }
                        function Hec(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            i = RD(e3b(a, (qpd(), ppd)).Kc().Pb(), 12).e;
                            n = RD(e3b(a, Xod).Kc().Pb(), 12).g;
                            h = i.c.length;
                            t = K3b(RD(Vmb(a.j, 0), 12));
                            while(h-- > 0){
                                p = (tFb(0, i.c.length), RD(i.c[0], 18));
                                e = (tFb(0, n.c.length), RD(n.c[0], 18));
                                s = e.d.e;
                                f = Wmb(s, e, 0);
                                $0b(p, e.d, f);
                                Y0b(e, null);
                                Z0b(e, null);
                                o = p.a;
                                b && Mub(o, new sjd(t));
                                for(d = Sub(e.a, 0); d.b != d.d.c;){
                                    c = RD(evb(d), 8);
                                    Mub(o, new sjd(c));
                                }
                                r = p.b;
                                for(m = new Anb(e.b); m.a < m.c.c.length;){
                                    l = RD(ynb(m), 72);
                                    ZEb(r.c, l);
                                }
                                q = RD(mQb(p, (yCc(), RAc)), 75);
                                g = RD(mQb(e, RAc), 75);
                                if (g) {
                                    if (!q) {
                                        q = new Ejd;
                                        pQb(p, RAc, q);
                                    }
                                    for(k = Sub(g, 0); k.b != k.d.c;){
                                        j = RD(evb(k), 8);
                                        Mub(q, new sjd(j));
                                    }
                                }
                            }
                        }
                        function $Qc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            p = b.b.c.length;
                            if (p < 3) return;
                            n = $C(kE, Pwe, 28, p, 15, 1);
                            l = 0;
                            for(k = new Anb(b.b); k.a < k.c.c.length;){
                                j = RD(ynb(k), 30);
                                n[l++] = j.a.c.length;
                            }
                            m = new Jkb(b.b, 2);
                            for(d = 1; d < p - 1; d++){
                                c = (sFb(m.b < m.d.gc()), RD(m.d.Xb(m.c = m.b++), 30));
                                o = new Anb(c.a);
                                f = 0;
                                h = 0;
                                for(i = 0; i < n[d + 1]; i++){
                                    t = RD(ynb(o), 10);
                                    if (i == n[d + 1] - 1 || ZQc(a, t, d + 1, d)) {
                                        g = n[d] - 1;
                                        ZQc(a, t, d + 1, d) && (g = a.c.e[RD(RD(RD(Vmb(a.c.b, t.p), 15).Xb(0), 42).a, 10).p]);
                                        while(h <= i){
                                            s = RD(Vmb(c.a, h), 10);
                                            if (!ZQc(a, s, d + 1, d)) for(r = RD(Vmb(a.c.b, s.p), 15).Kc(); r.Ob();){
                                                q = RD(r.Pb(), 42);
                                                e = a.c.e[RD(q.a, 10).p];
                                                (e < f || e > g) && Ysb(a.b, RD(q.b, 18));
                                            }
                                            ++h;
                                        }
                                        f = g;
                                    }
                                }
                            }
                        }
                        function zhd(b, c) {
                            var d;
                            if (c == null || lhb(c, vve)) return null;
                            if (c.length == 0 && b.k != (kid(), fid)) return null;
                            switch(b.k.g){
                                case 1:
                                    return mhb(c, FGe) ? (Geb(), Feb) : mhb(c, GGe) ? (Geb(), Eeb) : null;
                                case 2:
                                    try {
                                        return sgb(Oeb(c, qwe, lve));
                                    } catch (a) {
                                        a = zdb(a);
                                        if (ZD(a, 130)) return null;
                                        else throw Adb(a);
                                    }
                                case 4:
                                    try {
                                        return Neb(c);
                                    } catch (a) {
                                        a = zdb(a);
                                        if (ZD(a, 130)) return null;
                                        else throw Adb(a);
                                    }
                                case 3:
                                    return c;
                                case 5:
                                    uhd(b);
                                    return xhd(b, c);
                                case 6:
                                    uhd(b);
                                    return yhd(b, b.a, c);
                                case 7:
                                    try {
                                        d = whd(b);
                                        d.cg(c);
                                        return d;
                                    } catch (a) {
                                        a = zdb(a);
                                        if (ZD(a, 33)) return null;
                                        else throw Adb(a);
                                    }
                                default:
                                    throw Adb(new dgb('Invalid type set for this layout option.'));
                            }
                        }
                        function JKd(a) {
                            var b;
                            switch(a.d){
                                case 1:
                                    if (a.Sj()) return a.o != -2;
                                    break;
                                case 2:
                                    if (a.Sj()) return a.o == -2;
                                    break;
                                case 3:
                                case 5:
                                case 4:
                                case 6:
                                case 7:
                                    return a.o > -2;
                                default:
                                    return false;
                            }
                            b = a.Rj();
                            switch(a.p){
                                case 0:
                                    return b != null && Heb(TD(b)) != Pdb(a.k, 0);
                                case 1:
                                    return b != null && RD(b, 222).a != Ydb(a.k) << 24 >> 24;
                                case 2:
                                    return b != null && RD(b, 180).a != (Ydb(a.k) & Bwe);
                                case 6:
                                    return b != null && Pdb(RD(b, 168).a, a.k);
                                case 5:
                                    return b != null && RD(b, 17).a != Ydb(a.k);
                                case 7:
                                    return b != null && RD(b, 191).a != Ydb(a.k) << 16 >> 16;
                                case 3:
                                    return b != null && Kfb(UD(b)) != a.j;
                                case 4:
                                    return b != null && RD(b, 161).a != a.j;
                                default:
                                    return b == null ? a.n != null : !pb(b, a.n);
                            }
                        }
                        function N_d(a, b, c) {
                            var d, e, f, g;
                            if (a.ol() && a.nl()) {
                                g = O_d(a, RD(c, 58));
                                if (dE(g) !== dE(c)) {
                                    a.xj(b);
                                    a.Dj(b, P_d(a, b, g));
                                    if (a.al()) {
                                        f = (e = RD(c, 54), a.ml() ? a.kl() ? e.Th(a.b, Z5d(RD(vYd(Uwd(a.b), a.Lj()), 19)).n, RD(vYd(Uwd(a.b), a.Lj()).Hk(), 29).kk(), null) : e.Th(a.b, BYd(e.Dh(), Z5d(RD(vYd(Uwd(a.b), a.Lj()), 19))), null, null) : e.Th(a.b, -1 - a.Lj(), null, null));
                                        !RD(g, 54).Ph() && (f = (d = RD(g, 54), a.ml() ? a.kl() ? d.Rh(a.b, Z5d(RD(vYd(Uwd(a.b), a.Lj()), 19)).n, RD(vYd(Uwd(a.b), a.Lj()).Hk(), 29).kk(), f) : d.Rh(a.b, BYd(d.Dh(), Z5d(RD(vYd(Uwd(a.b), a.Lj()), 19))), null, f) : d.Rh(a.b, -1 - a.Lj(), null, f)));
                                        !!f && f.oj();
                                    }
                                    Mvd(a.b) && a.Jj(a.Ij(9, c, g, b, false));
                                    return g;
                                }
                            }
                            return c;
                        }
                        function iJb(a) {
                            var b, c, d, e, f, g, h, i, j, k;
                            d = new bnb;
                            for(g = new Anb(a.e.a); g.a < g.c.c.length;){
                                e = RD(ynb(g), 125);
                                k = 0;
                                e.k.c.length = 0;
                                for(c = new Anb(CIb(e)); c.a < c.c.c.length;){
                                    b = RD(ynb(c), 218);
                                    if (b.f) {
                                        Rmb(e.k, b);
                                        ++k;
                                    }
                                }
                                k == 1 && ZEb(d.c, e);
                            }
                            for(f = new Anb(d); f.a < f.c.c.length;){
                                e = RD(ynb(f), 125);
                                while(e.k.c.length == 1){
                                    j = RD(ynb(new Anb(e.k)), 218);
                                    a.b[j.c] = j.g;
                                    h = j.d;
                                    i = j.e;
                                    for(c = new Anb(CIb(e)); c.a < c.c.c.length;){
                                        b = RD(ynb(c), 218);
                                        pb(b, j) || (b.f ? h == b.d || i == b.e ? a.b[j.c] -= a.b[b.c] - b.g : a.b[j.c] += a.b[b.c] - b.g : e == h ? b.d == e ? a.b[j.c] += b.g : a.b[j.c] -= b.g : b.d == e ? a.b[j.c] -= b.g : a.b[j.c] += b.g);
                                    }
                                    Ymb(h.k, j);
                                    Ymb(i.k, j);
                                    h == e ? e = j.e : e = j.d;
                                }
                            }
                        }
                        function vMb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n;
                            c = RD(Vrb(a.b, b), 127);
                            i = RD(RD(Qc(a.r, b), 21), 87);
                            if (i.dc()) {
                                c.n.b = 0;
                                c.n.c = 0;
                                return;
                            }
                            j = a.u.Hc((Pod(), Lod));
                            g = 0;
                            h = i.Kc();
                            k = null;
                            l = 0;
                            m = 0;
                            while(h.Ob()){
                                d = RD(h.Pb(), 117);
                                e = Kfb(UD(d.b.of((tNb(), sNb))));
                                f = d.b.Mf().a;
                                a.A.Hc((Qpd(), Ppd)) && BMb(a, b);
                                if (!k) !!a.C && a.C.b > 0 && (g = $wnd.Math.max(g, zMb(a.C.b + d.d.b, e)));
                                else {
                                    n = m + k.d.c + a.w + d.d.b;
                                    g = $wnd.Math.max(g, (Zy(), bz(Tye), $wnd.Math.abs(l - e) <= Tye || l == e || isNaN(l) && isNaN(e) ? 0 : n / (e - l)));
                                }
                                k = d;
                                l = e;
                                m = f;
                            }
                            if (!!a.C && a.C.c > 0) {
                                n = m + a.C.c;
                                j && (n += k.d.c);
                                g = $wnd.Math.max(g, (Zy(), bz(Tye), $wnd.Math.abs(l - 1) <= Tye || l == 1 || isNaN(l) && isNaN(1) ? 0 : n / (1 - l)));
                            }
                            c.n.b = 0;
                            c.a.a = g;
                        }
                        function ENb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n;
                            c = RD(Vrb(a.b, b), 127);
                            i = RD(RD(Qc(a.r, b), 21), 87);
                            if (i.dc()) {
                                c.n.d = 0;
                                c.n.a = 0;
                                return;
                            }
                            j = a.u.Hc((Pod(), Lod));
                            g = 0;
                            a.A.Hc((Qpd(), Ppd)) && JNb(a, b);
                            h = i.Kc();
                            k = null;
                            m = 0;
                            l = 0;
                            while(h.Ob()){
                                d = RD(h.Pb(), 117);
                                f = Kfb(UD(d.b.of((tNb(), sNb))));
                                e = d.b.Mf().b;
                                if (!k) !!a.C && a.C.d > 0 && (g = $wnd.Math.max(g, zMb(a.C.d + d.d.d, f)));
                                else {
                                    n = l + k.d.a + a.w + d.d.d;
                                    g = $wnd.Math.max(g, (Zy(), bz(Tye), $wnd.Math.abs(m - f) <= Tye || m == f || isNaN(m) && isNaN(f) ? 0 : n / (f - m)));
                                }
                                k = d;
                                m = f;
                                l = e;
                            }
                            if (!!a.C && a.C.a > 0) {
                                n = l + a.C.a;
                                j && (n += k.d.a);
                                g = $wnd.Math.max(g, (Zy(), bz(Tye), $wnd.Math.abs(m - 1) <= Tye || m == 1 || isNaN(m) && isNaN(1) ? 0 : n / (1 - m)));
                            }
                            c.n.d = 0;
                            c.a.b = g;
                        }
                        function L8c(a, b, c, d, e, f, g, h) {
                            var i, j, k, l, m, n, o, p, q, r;
                            o = false;
                            j = dad(c.q, b.f + b.b - c.q.f);
                            n = d.f > b.b && h;
                            r = e - (c.q.e + j - g);
                            l = (i = S9c(d, r, false), i.a);
                            if (n && l > d.f) return false;
                            if (n) {
                                m = 0;
                                for(q = new Anb(b.d); q.a < q.c.c.length;){
                                    p = RD(ynb(q), 315);
                                    m += dad(p, d.f) + g;
                                }
                                r = e - m;
                            }
                            if (r < d.g) return false;
                            k = f == a.c.length - 1 && r >= (tFb(f, a.c.length), RD(a.c[f], 186)).e;
                            if (!n && l > b.b && !k) return false;
                            if (k || n || l <= b.b) {
                                if (k && l > b.b) {
                                    c.d = l;
                                    Q9c(c, P9c(c, l));
                                } else {
                                    ead(c.q, j);
                                    c.c = true;
                                }
                                Q9c(d, e - (c.s + c.r));
                                U9c(d, c.q.e + c.q.d, b.f);
                                Cad(b, d);
                                if (a.c.length > f) {
                                    Fad((tFb(f, a.c.length), RD(a.c[f], 186)), d);
                                    (tFb(f, a.c.length), RD(a.c[f], 186)).a.c.length == 0 && Xmb(a, f);
                                }
                                o = true;
                            }
                            return o;
                        }
                        function zJc(a, b, c) {
                            var d, e, f, g, h, i;
                            this.g = a;
                            h = b.d.length;
                            i = c.d.length;
                            this.d = $C(jR, WAe, 10, h + i, 0, 1);
                            for(g = 0; g < h; g++)this.d[g] = b.d[g];
                            for(f = 0; f < i; f++)this.d[h + f] = c.d[f];
                            if (b.e) {
                                this.e = gv(b.e);
                                this.e.Mc(c);
                                if (c.e) for(e = c.e.Kc(); e.Ob();){
                                    d = RD(e.Pb(), 239);
                                    if (d == b) continue;
                                    else this.e.Hc(d) ? --d.c : this.e.Fc(d);
                                }
                            } else if (c.e) {
                                this.e = gv(c.e);
                                this.e.Mc(b);
                            }
                            this.f = b.f + c.f;
                            this.a = b.a + c.a;
                            this.a > 0 ? xJc(this, this.f / this.a) : pJc(b.g, b.d[0]).a != null && pJc(c.g, c.d[0]).a != null ? xJc(this, (Kfb(pJc(b.g, b.d[0]).a) + Kfb(pJc(c.g, c.d[0]).a)) / 2) : pJc(b.g, b.d[0]).a != null ? xJc(this, pJc(b.g, b.d[0]).a) : pJc(c.g, c.d[0]).a != null && xJc(this, pJc(c.g, c.d[0]).a);
                        }
                        function DXb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            a.a = new fYb(wsb(s3));
                            for(d = new Anb(b.a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 855);
                                h = new iYb(cD(WC(bQ, 1), rve, 86, 0, []));
                                Rmb(a.a.a, h);
                                for(j = new Anb(c.d); j.a < j.c.c.length;){
                                    i = RD(ynb(j), 116);
                                    k = new IXb(a, i);
                                    CXb(k, RD(mQb(c.c, (Ywc(), ewc)), 21));
                                    if (!Ujb(a.g, c)) {
                                        Zjb(a.g, c, new rjd(i.c, i.d));
                                        Zjb(a.f, c, k);
                                    }
                                    Rmb(a.a.b, k);
                                    gYb(h, k);
                                }
                                for(g = new Anb(c.b); g.a < g.c.c.length;){
                                    f = RD(ynb(g), 602);
                                    k = new IXb(a, f.Df());
                                    Zjb(a.b, f, new Ptd(h, k));
                                    CXb(k, RD(mQb(c.c, (Ywc(), ewc)), 21));
                                    if (f.Bf()) {
                                        l = new JXb(a, f.Bf(), 1);
                                        CXb(l, RD(mQb(c.c, ewc), 21));
                                        e = new iYb(cD(WC(bQ, 1), rve, 86, 0, []));
                                        gYb(e, l);
                                        Rc(a.c, f.Af(), new Ptd(h, l));
                                    }
                                }
                            }
                            return a.a;
                        }
                        function gFc(a) {
                            var b;
                            this.a = a;
                            b = (r3b(), cD(WC(hR, 1), jwe, 273, 0, [
                                p3b,
                                o3b,
                                m3b,
                                q3b,
                                n3b,
                                l3b
                            ])).length;
                            this.b = YC(V5, [
                                Nve,
                                kEe
                            ], [
                                601,
                                149
                            ], 0, [
                                b,
                                b
                            ], 2);
                            this.c = YC(V5, [
                                Nve,
                                kEe
                            ], [
                                601,
                                149
                            ], 0, [
                                b,
                                b
                            ], 2);
                            fFc(this, p3b, (yCc(), bCc), cCc);
                            dFc(this, p3b, o3b, WBc, XBc);
                            cFc(this, p3b, q3b, WBc);
                            cFc(this, p3b, m3b, WBc);
                            dFc(this, p3b, n3b, bCc, cCc);
                            fFc(this, o3b, TBc, UBc);
                            cFc(this, o3b, q3b, TBc);
                            cFc(this, o3b, m3b, TBc);
                            dFc(this, o3b, n3b, WBc, XBc);
                            eFc(this, q3b, TBc);
                            cFc(this, q3b, m3b, TBc);
                            cFc(this, q3b, n3b, $Bc);
                            eFc(this, m3b, fCc);
                            dFc(this, m3b, n3b, aCc, _Bc);
                            fFc(this, n3b, TBc, TBc);
                            fFc(this, l3b, TBc, UBc);
                            dFc(this, l3b, p3b, WBc, XBc);
                            dFc(this, l3b, n3b, WBc, XBc);
                            dFc(this, l3b, o3b, WBc, XBc);
                        }
                        function zge(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
                            g = c.Lk();
                            if (ZD(g, 102) && (RD(g, 19).Bb & txe) != 0) {
                                m = RD(c.md(), 54);
                                p = Vvd(a.e, m);
                                if (p != m) {
                                    k = oke(g, p);
                                    MHd(a, b, Tge(a, b, k));
                                    l = null;
                                    if (Mvd(a.e)) {
                                        d = Eee((lke(), jke), a.e.Dh(), g);
                                        if (d != vYd(a.e.Dh(), a.c)) {
                                            q = pke(a.e.Dh(), g);
                                            h = 0;
                                            f = RD(a.g, 124);
                                            for(i = 0; i < b; ++i){
                                                e = f[i];
                                                q.am(e.Lk()) && ++h;
                                            }
                                            l = new lle(a.e, 9, d, m, p, h, false);
                                            l.nj(new P3d(a.e, 9, a.c, c, k, b, false));
                                        }
                                    }
                                    o = RD(g, 19);
                                    n = Z5d(o);
                                    if (n) {
                                        l = m.Th(a.e, BYd(m.Dh(), n), null, l);
                                        l = RD(p, 54).Rh(a.e, BYd(p.Dh(), n), null, l);
                                    } else if ((o.Bb & QHe) != 0) {
                                        j = -1 - BYd(a.e.Dh(), o);
                                        l = m.Th(a.e, j, null, null);
                                        !RD(p, 54).Ph() && (l = RD(p, 54).Rh(a.e, j, null, l));
                                    }
                                    !!l && l.oj();
                                    return k;
                                }
                            }
                            return c;
                        }
                        function SId(a) {
                            var b, c, d;
                            wgd(LId, cD(WC(B2, 1), rve, 134, 0, [
                                new vmd
                            ]));
                            c = new NB(a);
                            for(d = 0; d < c.a.length; ++d){
                                b = JB(c, d).te().a;
                                lhb(b, 'layered') ? wgd(LId, cD(WC(B2, 1), rve, 134, 0, [
                                    new Pzc
                                ])) : lhb(b, 'force') ? wgd(LId, cD(WC(B2, 1), rve, 134, 0, [
                                    new PUb
                                ])) : lhb(b, 'stress') ? wgd(LId, cD(WC(B2, 1), rve, 134, 0, [
                                    new RVb
                                ])) : lhb(b, 'mrtree') ? wgd(LId, cD(WC(B2, 1), rve, 134, 0, [
                                    new C$c
                                ])) : lhb(b, 'radial') ? wgd(LId, cD(WC(B2, 1), rve, 134, 0, [
                                    new E4c
                                ])) : lhb(b, 'disco') ? wgd(LId, cD(WC(B2, 1), rve, 134, 0, [
                                    new ZHb,
                                    new fSb
                                ])) : lhb(b, 'sporeOverlap') || lhb(b, 'sporeCompaction') ? wgd(LId, cD(WC(B2, 1), rve, 134, 0, [
                                    new Lcd
                                ])) : lhb(b, 'rectpacking') && wgd(LId, cD(WC(B2, 1), rve, 134, 0, [
                                    new v7c
                                ]));
                            }
                        }
                        function r2b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                            m = new sjd(a.o);
                            r = b.a / m.a;
                            h = b.b / m.b;
                            p = b.a - m.a;
                            f = b.b - m.b;
                            if (c) {
                                e = dE(mQb(a, (yCc(), BBc))) === dE((Bod(), wod));
                                for(o = new Anb(a.j); o.a < o.c.c.length;){
                                    n = RD(ynb(o), 12);
                                    switch(n.j.g){
                                        case 1:
                                            e || (n.n.a *= r);
                                            break;
                                        case 2:
                                            n.n.a += p;
                                            e || (n.n.b *= h);
                                            break;
                                        case 3:
                                            e || (n.n.a *= r);
                                            n.n.b += f;
                                            break;
                                        case 4:
                                            e || (n.n.b *= h);
                                    }
                                }
                            }
                            for(j = new Anb(a.b); j.a < j.c.c.length;){
                                i = RD(ynb(j), 72);
                                k = i.n.a + i.o.a / 2;
                                l = i.n.b + i.o.b / 2;
                                q = k / m.a;
                                g = l / m.b;
                                if (q + g >= 1) {
                                    if (q - g > 0 && l >= 0) {
                                        i.n.a += p;
                                        i.n.b += f * g;
                                    } else if (q - g < 0 && k >= 0) {
                                        i.n.a += p * q;
                                        i.n.b += f;
                                    }
                                }
                            }
                            a.o.a = b.a;
                            a.o.b = b.b;
                            pQb(a, (yCc(), lBc), (Qpd(), d = RD(mfb(H3), 9), new Fsb(d, RD(WEb(d, d.length), 9), 0)));
                        }
                        function ISd(a, b, c, d, e, f) {
                            var g;
                            if (!(b == null || !mSd(b, ZRd, $Rd))) throw Adb(new agb('invalid scheme: ' + b));
                            if (!a && !(c != null && qhb(c, Fhb(35)) == -1 && c.length > 0 && (BFb(0, c.length), c.charCodeAt(0) != 47))) throw Adb(new agb('invalid opaquePart: ' + c));
                            if (a && !(b != null && tpb(eSd, b.toLowerCase())) && !(c == null || !mSd(c, aSd, bSd))) throw Adb(new agb(NJe + c));
                            if (a && b != null && tpb(eSd, b.toLowerCase()) && !ESd(c)) throw Adb(new agb(NJe + c));
                            if (!FSd(d)) throw Adb(new agb('invalid device: ' + d));
                            if (!HSd(e)) {
                                g = e == null ? 'invalid segments: null' : 'invalid segment: ' + tSd(e);
                                throw Adb(new agb(g));
                            }
                            if (!(f == null || qhb(f, Fhb(35)) == -1)) throw Adb(new agb('invalid query: ' + f));
                        }
                        function WHc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                            c.Ug('Network simplex layering', 1);
                            a.b = b;
                            r = RD(mQb(b, (yCc(), gCc)), 17).a * 4;
                            q = a.b.a;
                            if (q.c.length < 1) {
                                c.Vg();
                                return;
                            }
                            f = SHc(a, q);
                            p = null;
                            for(e = Sub(f, 0); e.b != e.d.c;){
                                d = RD(evb(e), 15);
                                h = r * eE($wnd.Math.sqrt(d.gc()));
                                g = VHc(d);
                                lJb(yJb(AJb(zJb(CJb(g), h), p), true), c.eh(1));
                                m = a.b.b;
                                for(o = new Anb(g.a); o.a < o.c.c.length;){
                                    n = RD(ynb(o), 125);
                                    while(m.c.length <= n.e)Qmb(m, m.c.length, new R4b(a.b));
                                    k = RD(n.f, 10);
                                    g3b(k, RD(Vmb(m, n.e), 30));
                                }
                                if (f.b > 1) {
                                    p = $C(kE, Pwe, 28, a.b.b.c.length, 15, 1);
                                    l = 0;
                                    for(j = new Anb(a.b.b); j.a < j.c.c.length;){
                                        i = RD(ynb(j), 30);
                                        p[l++] = i.a.c.length;
                                    }
                                }
                            }
                            q.c.length = 0;
                            a.a = null;
                            a.b = null;
                            a.c = null;
                            c.Vg();
                        }
                        function tMc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            k = new bnb;
                            l = new wmb;
                            f = null;
                            e = 0;
                            for(d = 0; d < b.length; ++d){
                                c = b[d];
                                vMc(f, c) && (e = oMc(a, l, k, cMc, e));
                                nQb(c, (Ywc(), pwc)) && (f = RD(mQb(c, pwc), 10));
                                switch(c.k.g){
                                    case 0:
                                        for(i = lr(dr(b3b(c, (qpd(), Yod)), new eNc)); xc(i);){
                                            g = RD(yc(i), 12);
                                            a.d[g.p] = e++;
                                            ZEb(k.c, g);
                                        }
                                        e = oMc(a, l, k, cMc, e);
                                        for(j = lr(dr(b3b(c, npd), new eNc)); xc(j);){
                                            g = RD(yc(j), 12);
                                            a.d[g.p] = e++;
                                            ZEb(k.c, g);
                                        }
                                        break;
                                    case 3:
                                        if (!b3b(c, bMc).dc()) {
                                            g = RD(b3b(c, bMc).Xb(0), 12);
                                            a.d[g.p] = e++;
                                            ZEb(k.c, g);
                                        }
                                        b3b(c, cMc).dc() || hmb(l, c);
                                        break;
                                    case 1:
                                        for(h = b3b(c, (qpd(), ppd)).Kc(); h.Ob();){
                                            g = RD(h.Pb(), 12);
                                            a.d[g.p] = e++;
                                            ZEb(k.c, g);
                                        }
                                        b3b(c, Xod).Jc(new cNc(l, c));
                                }
                            }
                            oMc(a, l, k, cMc, e);
                            return k;
                        }
                        function vgd(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o;
                            if (b == null || b.length == 0) return null;
                            f = RD(Xjb(a.f, b), 23);
                            if (!f) {
                                for(e = (n = new glb(a.d).a.vc().Kc(), new llb(n)); e.a.Ob();){
                                    c = (g = RD(e.a.Pb(), 44), RD(g.md(), 23));
                                    h = c.f;
                                    o = b.length;
                                    if (lhb(h.substr(h.length - o, o), b) && (b.length == h.length || ihb(h, h.length - b.length - 1) == 46)) {
                                        if (f) return null;
                                        f = c;
                                    }
                                }
                                if (!f) for(d = (m = new glb(a.d).a.vc().Kc(), new llb(m)); d.a.Ob();){
                                    c = (g = RD(d.a.Pb(), 44), RD(g.md(), 23));
                                    l = c.g;
                                    if (l != null) for(i = l, j = 0, k = i.length; j < k; ++j){
                                        h = i[j];
                                        o = b.length;
                                        if (lhb(h.substr(h.length - o, o), b) && (b.length == h.length || ihb(h, h.length - b.length - 1) == 46)) {
                                            if (f) return null;
                                            f = c;
                                        }
                                    }
                                }
                                !!f && $jb(a.f, b, f);
                            }
                            return f;
                        }
                        function IA(a, b) {
                            var c, d, e, f, g;
                            c = new cib;
                            g = false;
                            for(f = 0; f < b.length; f++){
                                d = (BFb(f, b.length), b.charCodeAt(f));
                                if (d == 32) {
                                    wA(a, c, 0);
                                    c.a += ' ';
                                    wA(a, c, 0);
                                    while(f + 1 < b.length && (BFb(f + 1, b.length), b.charCodeAt(f + 1) == 32))++f;
                                    continue;
                                }
                                if (g) {
                                    if (d == 39) {
                                        if (f + 1 < b.length && (BFb(f + 1, b.length), b.charCodeAt(f + 1) == 39)) {
                                            c.a += String.fromCharCode(d);
                                            ++f;
                                        } else g = false;
                                    } else c.a += String.fromCharCode(d);
                                    continue;
                                }
                                if (qhb('GyMLdkHmsSEcDahKzZv', Fhb(d)) > 0) {
                                    wA(a, c, 0);
                                    c.a += String.fromCharCode(d);
                                    e = BA(b, f);
                                    wA(a, c, e);
                                    f += e - 1;
                                    continue;
                                }
                                if (d == 39) {
                                    if (f + 1 < b.length && (BFb(f + 1, b.length), b.charCodeAt(f + 1) == 39)) {
                                        c.a += "'";
                                        ++f;
                                    } else g = true;
                                } else c.a += String.fromCharCode(d);
                            }
                            wA(a, c, 0);
                            CA(a);
                        }
                        function tSc(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            t = Yx(a);
                            i = new bnb;
                            f = a.c.length;
                            j = f - 1;
                            k = f + 1;
                            while(t.a.gc() != 0){
                                while(c.b != 0){
                                    r = (sFb(c.b != 0), RD(Wub(c, c.a.a), 118));
                                    t.a.Bc(r);
                                    r.g = j--;
                                    wSc(r, b, c, d);
                                }
                                while(b.b != 0){
                                    s = (sFb(b.b != 0), RD(Wub(b, b.a.a), 118));
                                    t.a.Bc(s);
                                    s.g = k++;
                                    wSc(s, b, c, d);
                                }
                                h = qwe;
                                for(p = t.a.ec().Kc(); p.Ob();){
                                    o = RD(p.Pb(), 118);
                                    if (!d && o.b > 0 && o.a <= 0) {
                                        i.c.length = 0;
                                        ZEb(i.c, o);
                                        break;
                                    }
                                    n = o.i - o.d;
                                    if (n >= h) {
                                        if (n > h) {
                                            i.c.length = 0;
                                            h = n;
                                        }
                                        ZEb(i.c, o);
                                    }
                                }
                                if (i.c.length != 0) {
                                    g = RD(Vmb(i, Jwb(e, i.c.length)), 118);
                                    t.a.Bc(g);
                                    g.g = k++;
                                    wSc(g, b, c, d);
                                    i.c.length = 0;
                                }
                            }
                            q = a.c.length + 1;
                            for(m = new Anb(a); m.a < m.c.c.length;){
                                l = RD(ynb(m), 118);
                                l.g < f && (l.g = l.g + q);
                            }
                        }
                        function FJc(a, b, c) {
                            var d, e, f, g;
                            this.j = a;
                            this.e = c1b(a);
                            this.o = this.j.e;
                            this.i = !!this.o;
                            this.p = this.i ? RD(Vmb(c, Y2b(this.o).p), 219) : null;
                            e = RD(mQb(a, (Ywc(), kwc)), 21);
                            this.g = e.Hc((ovc(), hvc));
                            this.b = new bnb;
                            this.d = new RLc(this.e);
                            g = RD(mQb(this.j, Lwc), 234);
                            this.q = WJc(b, g, this.e);
                            this.k = new _Kc(this);
                            f = dv(cD(WC(QY, 1), rve, 230, 0, [
                                this,
                                this.d,
                                this.k,
                                this.q
                            ]));
                            if (b == (RKc(), OKc) && !Heb(TD(mQb(a, (yCc(), eAc))))) {
                                d = new qJc(this.e);
                                ZEb(f.c, d);
                                this.c = new UIc(d, g, RD(this.q, 413));
                            } else if (b == OKc && Heb(TD(mQb(a, (yCc(), eAc))))) {
                                d = new qJc(this.e);
                                ZEb(f.c, d);
                                this.c = new vLc(d, g, RD(this.q, 413));
                            } else this.c = new smc(b, this);
                            Rmb(f, this.c);
                            yNc(f, this.e);
                            this.s = $Kc(this.k);
                        }
                        function z0b(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n, o, p, q;
                            f = new bnb;
                            for(j = new Anb(d); j.a < j.c.c.length;){
                                h = RD(ynb(j), 453);
                                g = null;
                                if (h.f == (BEc(), zEc)) for(o = new Anb(h.e); o.a < o.c.c.length;){
                                    n = RD(ynb(o), 18);
                                    q = n.d.i;
                                    if (Y2b(q) == b) q0b(a, b, h, n, h.b, n.d);
                                    else if (!c || n2b(q, c)) r0b(a, b, h, d, n);
                                    else {
                                        m = w0b(a, b, c, n, h.b, zEc, g);
                                        m != g && ZEb(f.c, m);
                                        m.c && (g = m);
                                    }
                                }
                                else for(l = new Anb(h.e); l.a < l.c.c.length;){
                                    k = RD(ynb(l), 18);
                                    p = k.c.i;
                                    if (Y2b(p) == b) q0b(a, b, h, k, k.c, h.b);
                                    else if (!c || n2b(p, c)) continue;
                                    else {
                                        m = w0b(a, b, c, k, h.b, yEc, g);
                                        m != g && ZEb(f.c, m);
                                        m.c && (g = m);
                                    }
                                }
                            }
                            for(i = new Anb(f); i.a < i.c.c.length;){
                                h = RD(ynb(i), 453);
                                Wmb(b.a, h.a, 0) != -1 || Rmb(b.a, h.a);
                                h.c && ZEb(e.c, h);
                            }
                        }
                        function QXb(a) {
                            var b, c, d, e, f, g, h;
                            b = 0;
                            for(f = new Anb(a.b.a); f.a < f.c.c.length;){
                                d = RD(ynb(f), 194);
                                d.b = 0;
                                d.c = 0;
                            }
                            PXb(a, 0);
                            OXb(a, a.g);
                            uYb(a.c);
                            yYb(a.c);
                            c = (Cmd(), ymd);
                            wYb(qYb(vYb(wYb(qYb(vYb(wYb(vYb(a.c, c)), Fmd(c)))), c)));
                            vYb(a.c, ymd);
                            TXb(a, a.g);
                            UXb(a, 0);
                            VXb(a, 0);
                            WXb(a, 1);
                            PXb(a, 1);
                            OXb(a, a.d);
                            uYb(a.c);
                            for(g = new Anb(a.b.a); g.a < g.c.c.length;){
                                d = RD(ynb(g), 194);
                                b += $wnd.Math.abs(d.c);
                            }
                            for(h = new Anb(a.b.a); h.a < h.c.c.length;){
                                d = RD(ynb(h), 194);
                                d.b = 0;
                                d.c = 0;
                            }
                            c = Bmd;
                            wYb(qYb(vYb(wYb(qYb(vYb(wYb(yYb(vYb(a.c, c))), Fmd(c)))), c)));
                            vYb(a.c, ymd);
                            TXb(a, a.d);
                            UXb(a, 1);
                            VXb(a, 1);
                            WXb(a, 0);
                            yYb(a.c);
                            for(e = new Anb(a.b.a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 194);
                                b += $wnd.Math.abs(d.c);
                            }
                            return b;
                        }
                        function A0b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
                            if (!Heb(TD(mQb(c, (yCc(), NAc))))) return;
                            for(h = new Anb(c.j); h.a < h.c.c.length;){
                                g = RD(ynb(h), 12);
                                m = s2b(g.g);
                                for(j = m, k = 0, l = j.length; k < l; ++k){
                                    i = j[k];
                                    f = i.d.i == c;
                                    e = f && Heb(TD(mQb(i, OAc)));
                                    if (e) {
                                        o = i.c;
                                        n = RD(Wjb(a.b, o), 10);
                                        if (!n) {
                                            n = f2b(o, (Bod(), zod), o.j, -1, null, null, o.o, RD(mQb(b, rAc), 88), b);
                                            pQb(n, (Ywc(), Awc), o);
                                            Zjb(a.b, o, n);
                                            Rmb(b.a, n);
                                        }
                                        q = i.d;
                                        p = RD(Wjb(a.b, q), 10);
                                        if (!p) {
                                            p = f2b(q, (Bod(), zod), q.j, 1, null, null, q.o, RD(mQb(b, rAc), 88), b);
                                            pQb(p, (Ywc(), Awc), q);
                                            Zjb(a.b, q, p);
                                            Rmb(b.a, p);
                                        }
                                        d = s0b(i);
                                        Y0b(d, RD(Vmb(n.j, 0), 12));
                                        Z0b(d, RD(Vmb(p.j, 0), 12));
                                        Rc(a.a, i, new J0b(d, b, (BEc(), zEc)));
                                        RD(mQb(b, (Ywc(), kwc)), 21).Fc((ovc(), hvc));
                                    }
                                }
                            }
                        }
                        function OQc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m;
                            for(e = new Anb(a.a.b); e.a < e.c.c.length;){
                                c = RD(ynb(e), 30);
                                for(i = new Anb(c.a); i.a < i.c.c.length;){
                                    h = RD(ynb(i), 10);
                                    b.j[h.p] = h;
                                    b.i[h.p] = b.o == (EQc(), DQc) ? pxe : oxe;
                                }
                            }
                            akb(a.c);
                            g = a.a.b;
                            b.c == (wQc(), uQc) && (g = hv(g));
                            sRc(a.e, b, a.b);
                            Mnb(b.p, null);
                            for(f = g.Kc(); f.Ob();){
                                c = RD(f.Pb(), 30);
                                j = c.a;
                                b.o == (EQc(), DQc) && (j = hv(j));
                                for(m = j.Kc(); m.Ob();){
                                    l = RD(m.Pb(), 10);
                                    b.g[l.p] == l && PQc(a, l, b);
                                }
                            }
                            QQc(a, b);
                            for(d = g.Kc(); d.Ob();){
                                c = RD(d.Pb(), 30);
                                for(m = new Anb(c.a); m.a < m.c.c.length;){
                                    l = RD(ynb(m), 10);
                                    b.p[l.p] = b.p[b.g[l.p].p];
                                    if (l == b.g[l.p]) {
                                        k = Kfb(b.i[b.j[l.p].p]);
                                        (b.o == (EQc(), DQc) && k > pxe || b.o == CQc && k < oxe) && (b.p[l.p] = Kfb(b.p[l.p]) + k);
                                    }
                                }
                            }
                            a.e.xg();
                        }
                        function ldc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o;
                            c.Ug('Label dummy switching', 1);
                            d = RD(mQb(b, (yCc(), uAc)), 232);
                            $cc(b);
                            e = idc(b, d);
                            a.a = $C(iE, vxe, 28, b.b.c.length, 15, 1);
                            for(h = (btc(), cD(WC(ZW, 1), jwe, 232, 0, [
                                Zsc,
                                _sc,
                                Ysc,
                                $sc,
                                atc,
                                Xsc
                            ])), k = 0, n = h.length; k < n; ++k){
                                f = h[k];
                                if ((f == atc || f == Xsc || f == $sc) && !RD(Csb(e.a, f) ? e.b[f.g] : null, 15).dc()) {
                                    bdc(a, b);
                                    break;
                                }
                            }
                            for(i = cD(WC(ZW, 1), jwe, 232, 0, [
                                Zsc,
                                _sc,
                                Ysc,
                                $sc,
                                atc,
                                Xsc
                            ]), l = 0, o = i.length; l < o; ++l){
                                f = i[l];
                                f == atc || f == Xsc || f == $sc || mdc(a, RD(Csb(e.a, f) ? e.b[f.g] : null, 15));
                            }
                            for(g = cD(WC(ZW, 1), jwe, 232, 0, [
                                Zsc,
                                _sc,
                                Ysc,
                                $sc,
                                atc,
                                Xsc
                            ]), j = 0, m = g.length; j < m; ++j){
                                f = g[j];
                                (f == atc || f == Xsc || f == $sc) && mdc(a, RD(Csb(e.a, f) ? e.b[f.g] : null, 15));
                            }
                            a.a = null;
                            c.Vg();
                        }
                        function tte(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            j = b;
                            if (j.b == null || a.b == null) return;
                            vte(a);
                            ste(a);
                            vte(j);
                            ste(j);
                            c = $C(kE, Pwe, 28, a.b.length + j.b.length, 15, 1);
                            k = 0;
                            d = 0;
                            g = 0;
                            while(d < a.b.length && g < j.b.length){
                                e = a.b[d];
                                f = a.b[d + 1];
                                h = j.b[g];
                                i = j.b[g + 1];
                                if (f < h) d += 2;
                                else if (f >= h && e <= i) {
                                    if (h <= e && f <= i) {
                                        c[k++] = e;
                                        c[k++] = f;
                                        d += 2;
                                    } else if (h <= e) {
                                        c[k++] = e;
                                        c[k++] = i;
                                        a.b[d] = i + 1;
                                        g += 2;
                                    } else if (f <= i) {
                                        c[k++] = h;
                                        c[k++] = f;
                                        d += 2;
                                    } else {
                                        c[k++] = h;
                                        c[k++] = i;
                                        a.b[d] = i + 1;
                                    }
                                } else if (i < e) g += 2;
                                else throw Adb(new yz('Token#intersectRanges(): Internal Error: [' + a.b[d] + ',' + a.b[d + 1] + '] & [' + j.b[g] + ',' + j.b[g + 1] + ']'));
                            }
                            while(d < a.b.length){
                                c[k++] = a.b[d++];
                                c[k++] = a.b[d++];
                            }
                            a.b = $C(kE, Pwe, 28, k, 15, 1);
                            hib(c, 0, a.b, 0, k);
                        }
                        function RXb(a) {
                            var b, c, d, e, f, g, h;
                            b = new bnb;
                            a.g = new bnb;
                            a.d = new bnb;
                            for(g = new vkb(new mkb(a.f.b).a); g.b;){
                                f = tkb(g);
                                Rmb(b, RD(RD(f.md(), 42).b, 86));
                                Dmd(RD(f.ld(), 602).Af()) ? Rmb(a.d, RD(f.md(), 42)) : Rmb(a.g, RD(f.md(), 42));
                            }
                            OXb(a, a.d);
                            OXb(a, a.g);
                            a.c = new EYb(a.b);
                            CYb(a.c, (zXb(), yXb));
                            TXb(a, a.d);
                            TXb(a, a.g);
                            Tmb(b, a.c.a.b);
                            a.e = new rjd(oxe, oxe);
                            a.a = new rjd(pxe, pxe);
                            for(d = new Anb(b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 86);
                                a.e.a = $wnd.Math.min(a.e.a, c.g.c);
                                a.e.b = $wnd.Math.min(a.e.b, c.g.d);
                                a.a.a = $wnd.Math.max(a.a.a, c.g.c + c.g.b);
                                a.a.b = $wnd.Math.max(a.a.b, c.g.d + c.g.a);
                            }
                            BYb(a.c, new $Xb);
                            h = 0;
                            do {
                                e = QXb(a);
                                ++h;
                            }while ((h < 2 || e > pwe) && h < 10);
                            BYb(a.c, new bYb);
                            QXb(a);
                            xYb(a.c);
                            AXb(a.f);
                        }
                        function B9b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
                            c = RD(mQb(a, (yCc(), BBc)), 101);
                            g = a.f;
                            f = a.d;
                            h = g.a + f.b + f.c;
                            i = 0 - f.d - a.c.b;
                            k = g.b + f.d + f.a - a.c.b;
                            j = new bnb;
                            l = new bnb;
                            for(e = new Anb(b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 10);
                                switch(c.g){
                                    case 1:
                                    case 2:
                                    case 3:
                                        r9b(d);
                                        break;
                                    case 4:
                                        m = RD(mQb(d, zBc), 8);
                                        n = !m ? 0 : m.a;
                                        d.n.a = h * Kfb(UD(mQb(d, (Ywc(), Jwc)))) - n;
                                        U2b(d, true, false);
                                        break;
                                    case 5:
                                        o = RD(mQb(d, zBc), 8);
                                        p = !o ? 0 : o.a;
                                        d.n.a = Kfb(UD(mQb(d, (Ywc(), Jwc)))) - p;
                                        U2b(d, true, false);
                                        g.a = $wnd.Math.max(g.a, d.n.a + d.o.a / 2);
                                }
                                switch(RD(mQb(d, (Ywc(), hwc)), 64).g){
                                    case 1:
                                        d.n.b = i;
                                        ZEb(j.c, d);
                                        break;
                                    case 3:
                                        d.n.b = k;
                                        ZEb(l.c, d);
                                }
                            }
                            switch(c.g){
                                case 1:
                                case 2:
                                    t9b(j, a);
                                    t9b(l, a);
                                    break;
                                case 3:
                                    z9b(j, a);
                                    z9b(l, a);
                            }
                        }
                        function $Jc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m;
                            switch(a.k.g){
                                case 1:
                                    d = RD(mQb(a, (Ywc(), Awc)), 18);
                                    c = RD(mQb(d, Bwc), 75);
                                    !c ? c = new Ejd : Heb(TD(mQb(d, Nwc))) && (c = Ijd(c));
                                    j = RD(mQb(a, vwc), 12);
                                    if (j) {
                                        k = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                            j.i.n,
                                            j.n,
                                            j.a
                                        ]));
                                        if (b <= k.a) return k.b;
                                        Pub(c, k, c.a, c.a.a);
                                    }
                                    l = RD(mQb(a, wwc), 12);
                                    if (l) {
                                        m = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                            l.i.n,
                                            l.n,
                                            l.a
                                        ]));
                                        if (m.a <= b) return m.b;
                                        Pub(c, m, c.c.b, c.c);
                                    }
                                    if (c.b >= 2) {
                                        i = Sub(c, 0);
                                        g = RD(evb(i), 8);
                                        h = RD(evb(i), 8);
                                        while(h.a < b && i.b != i.d.c){
                                            g = h;
                                            h = RD(evb(i), 8);
                                        }
                                        return g.b + (b - g.a) / (h.a - g.a) * (h.b - g.b);
                                    }
                                    break;
                                case 3:
                                    f = RD(mQb(RD(Vmb(a.j, 0), 12), (Ywc(), Awc)), 12);
                                    e = f.i;
                                    switch(f.j.g){
                                        case 1:
                                            return e.n.b;
                                        case 3:
                                            return e.n.b + e.o.b;
                                    }
                            }
                            return _2b(a).b;
                        }
                        function Akc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l;
                            for(g = new Anb(a.d.b); g.a < g.c.c.length;){
                                f = RD(ynb(g), 30);
                                for(i = new Anb(f.a); i.a < i.c.c.length;){
                                    h = RD(ynb(i), 10);
                                    if (Heb(TD(mQb(h, (yCc(), Uzc))))) {
                                        if (!gr(W2b(h))) {
                                            d = RD(er(W2b(h)), 18);
                                            k = d.c.i;
                                            k == h && (k = d.d.i);
                                            l = new Ptd(k, ojd(ajd(h.n), k.n));
                                            Zjb(a.b, h, l);
                                            continue;
                                        }
                                    }
                                    e = new Uid(h.n.a - h.d.b, h.n.b - h.d.d, h.o.a + h.d.b + h.d.c, h.o.b + h.d.d + h.d.a);
                                    b = mGb(pGb(nGb(oGb(new qGb, h), e), jkc), a.a);
                                    gGb(hGb(iGb(new jGb, cD(WC(hN, 1), rve, 60, 0, [
                                        b
                                    ])), b), a.a);
                                    j = new cHb;
                                    Zjb(a.e, b, j);
                                    c = Kr(new is(Mr(Z2b(h).a.Kc(), new ir))) - Kr(new is(Mr(a3b(h).a.Kc(), new ir)));
                                    c < 0 ? aHb(j, true, (Cmd(), ymd)) : c > 0 && aHb(j, true, (Cmd(), zmd));
                                    h.k == (r3b(), m3b) && bHb(j);
                                    Zjb(a.f, h, b);
                                }
                            }
                        }
                        function OVc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
                            e = RD(mQb(a, (q$c(), h$c)), 27);
                            j = lve;
                            k = lve;
                            h = qwe;
                            i = qwe;
                            for(t = Sub(a.b, 0); t.b != t.d.c;){
                                r = RD(evb(t), 40);
                                n = r.e;
                                o = r.f;
                                j = $wnd.Math.min(j, n.a - o.a / 2);
                                k = $wnd.Math.min(k, n.b - o.b / 2);
                                h = $wnd.Math.max(h, n.a + o.a / 2);
                                i = $wnd.Math.max(i, n.b + o.b / 2);
                            }
                            m = RD(Gxd(e, (h_c(), T$c)), 107);
                            for(s = Sub(a.b, 0); s.b != s.d.c;){
                                r = RD(evb(s), 40);
                                l = mQb(r, h$c);
                                if (ZD(l, 207)) {
                                    f = RD(l, 27);
                                    Byd(f, r.e.a, r.e.b);
                                    zxd(f, r);
                                }
                            }
                            for(q = Sub(a.a, 0); q.b != q.d.c;){
                                p = RD(evb(q), 65);
                                d = RD(mQb(p, h$c), 74);
                                if (d) {
                                    b = p.a;
                                    c = IGd(d, true, true);
                                    lsd(b, c);
                                }
                            }
                            u = h - j + (m.b + m.c);
                            g = i - k + (m.d + m.a);
                            Heb(TD(Gxd(e, (umd(), mld)))) || Esd(e, u, g, false, false);
                            Ixd(e, Ikd, u - (m.b + m.c));
                            Ixd(e, Hkd, g - (m.d + m.a));
                        }
                        function Wec(a, b) {
                            var c, d, e, f, g, h, i, j, k, l;
                            i = true;
                            e = 0;
                            j = a.g[b.p];
                            k = b.o.b + a.o;
                            c = a.d[b.p][2];
                            $mb(a.b, j, sgb(RD(Vmb(a.b, j), 17).a - 1 + c));
                            $mb(a.c, j, Kfb(UD(Vmb(a.c, j))) - k + c * a.f);
                            ++j;
                            if (j >= a.j) {
                                ++a.j;
                                Rmb(a.b, sgb(1));
                                Rmb(a.c, k);
                            } else {
                                d = a.d[b.p][1];
                                $mb(a.b, j, sgb(RD(Vmb(a.b, j), 17).a + 1 - d));
                                $mb(a.c, j, Kfb(UD(Vmb(a.c, j))) + k - d * a.f);
                            }
                            (a.r == (aEc(), VDc) && (RD(Vmb(a.b, j), 17).a > a.k || RD(Vmb(a.b, j - 1), 17).a > a.k) || a.r == YDc && (Kfb(UD(Vmb(a.c, j))) > a.n || Kfb(UD(Vmb(a.c, j - 1))) > a.n)) && (i = false);
                            for(g = new is(Mr(Z2b(b).a.Kc(), new ir)); gs(g);){
                                f = RD(hs(g), 18);
                                h = f.c.i;
                                if (a.g[h.p] == j) {
                                    l = Wec(a, h);
                                    e = e + RD(l.a, 17).a;
                                    i = i && Heb(TD(l.b));
                                }
                            }
                            a.g[b.p] = j;
                            e = e + a.d[b.p][0];
                            return new Ptd(sgb(e), (Geb(), i ? true : false));
                        }
                        function cXb(a, b) {
                            var c, d, e, f, g;
                            c = Kfb(UD(mQb(b, (yCc(), TBc))));
                            c < 2 && pQb(b, TBc, 2);
                            d = RD(mQb(b, rAc), 88);
                            d == (Cmd(), Amd) && pQb(b, rAc, i2b(b));
                            e = RD(mQb(b, NBc), 17);
                            e.a == 0 ? pQb(b, (Ywc(), Lwc), new Owb) : pQb(b, (Ywc(), Lwc), new Pwb(e.a));
                            f = TD(mQb(b, gBc));
                            f == null && pQb(b, gBc, (Geb(), dE(mQb(b, yAc)) === dE((Ymd(), Umd)) ? true : false));
                            FDb(new SDb(null, new Swb(b.a, 16)), new fXb(a));
                            FDb(EDb(new SDb(null, new Swb(b.b, 16)), new hXb), new jXb(a));
                            g = new gFc(b);
                            pQb(b, (Ywc(), Qwc), g);
                            Sed(a.a);
                            Ved(a.a, (sXb(), nXb), RD(mQb(b, pAc), 188));
                            Ved(a.a, oXb, RD(mQb(b, $Ac), 188));
                            Ved(a.a, pXb, RD(mQb(b, oAc), 188));
                            Ved(a.a, qXb, RD(mQb(b, kBc), 188));
                            Ved(a.a, rXb, KRc(RD(mQb(b, yAc), 223)));
                            Ped(a.a, bXb(b));
                            pQb(b, Kwc, Qed(a.a, b));
                        }
                        function STc(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n, o, p, q, r;
                            l = new Tsb;
                            g = new bnb;
                            QTc(a, c, a.d.Ag(), g, l);
                            QTc(a, d, a.d.Bg(), g, l);
                            a.b = 0.2 * (p = RTc(EDb(new SDb(null, new Swb(g, 16)), new XTc)), q = RTc(EDb(new SDb(null, new Swb(g, 16)), new ZTc)), $wnd.Math.min(p, q));
                            f = 0;
                            for(h = 0; h < g.c.length - 1; h++){
                                i = (tFb(h, g.c.length), RD(g.c[h], 118));
                                for(o = h + 1; o < g.c.length; o++)f += PTc(a, i, (tFb(o, g.c.length), RD(g.c[o], 118)));
                            }
                            m = RD(mQb(b, (Ywc(), Lwc)), 234);
                            f >= 2 && (r = uSc(g, true, m), !a.e && (a.e = new xTc(a)), tTc(a.e, r, g, a.b), undefined);
                            UTc(g, m);
                            WTc(g);
                            n = -1;
                            for(k = new Anb(g); k.a < k.c.c.length;){
                                j = RD(ynb(k), 118);
                                if ($wnd.Math.abs(j.s - j.c) < Vze) continue;
                                n = $wnd.Math.max(n, j.o);
                                a.d.yg(j, e, a.c);
                            }
                            a.d.a.a.$b();
                            return n + 1;
                        }
                        function s0c(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
                            l = RD(Hr((g = Sub(new dXc(b).a.d, 0), new gXc(g))), 40);
                            o = l ? RD(mQb(l, (q$c(), b$c)), 40) : null;
                            e = 1;
                            while(!!l && !!o){
                                i = 0;
                                u = 0;
                                c = l;
                                d = o;
                                for(h = 0; h < e; h++){
                                    c = _Wc(c);
                                    d = _Wc(d);
                                    u += Kfb(UD(mQb(c, (q$c(), g$c))));
                                    i += Kfb(UD(mQb(d, g$c)));
                                }
                                t = Kfb(UD(mQb(o, (q$c(), j$c))));
                                s = Kfb(UD(mQb(l, j$c)));
                                m = u0c(a, l, o);
                                n = t + i + a.b + m - s - u;
                                if (0 < n) {
                                    j = b;
                                    k = 0;
                                    while(!!j && j != d){
                                        ++k;
                                        j = RD(mQb(j, c$c), 40);
                                    }
                                    if (j) {
                                        r = n / k;
                                        j = b;
                                        while(j != d){
                                            q = Kfb(UD(mQb(j, j$c))) + n;
                                            pQb(j, j$c, q);
                                            p = Kfb(UD(mQb(j, g$c))) + n;
                                            pQb(j, g$c, p);
                                            n -= r;
                                            j = RD(mQb(j, c$c), 40);
                                        }
                                    } else return;
                                }
                                ++e;
                                l.d.b == 0 ? l = kWc(new dXc(b), e) : l = RD(Hr((f = Sub(new dXc(l).a.d, 0), new gXc(f))), 40);
                                o = l ? RD(mQb(l, b$c), 40) : null;
                            }
                        }
                        function Lmc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
                            if (m = a.c[b], n = a.c[c], (o = RD(mQb(m, (Ywc(), qwc)), 15), !!o && o.gc() != 0 && o.Hc(n)) || (p = m.k != (r3b(), o3b) && n.k != o3b, q = RD(mQb(m, pwc), 10), r = RD(mQb(n, pwc), 10), s = q != r, t = !!q && q != m || !!r && r != n, u = Mmc(m, (qpd(), Yod)), v = Mmc(n, npd), t = t | (Mmc(m, npd) || Mmc(n, Yod)), w = t && s || u || v, p && w) || m.k == (r3b(), q3b) && n.k == p3b || n.k == (r3b(), q3b) && m.k == p3b) return false;
                            k = a.c[b];
                            f = a.c[c];
                            e = jMc(a.e, k, f, (qpd(), ppd));
                            i = jMc(a.i, k, f, Xod);
                            Cmc(a.f, k, f);
                            j = lmc(a.b, k, f) + RD(e.a, 17).a + RD(i.a, 17).a + a.f.d;
                            h = lmc(a.b, f, k) + RD(e.b, 17).a + RD(i.b, 17).a + a.f.b;
                            if (a.a) {
                                l = RD(mQb(k, Awc), 12);
                                g = RD(mQb(f, Awc), 12);
                                d = hMc(a.g, l, g);
                                j += RD(d.a, 17).a;
                                h += RD(d.b, 17).a;
                            }
                            return j > h;
                        }
                        function Iad(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
                            j = oxe;
                            k = oxe;
                            h = pxe;
                            i = pxe;
                            for(m = new Anb(b.i); m.a < m.c.c.length;){
                                l = RD(ynb(m), 68);
                                e = RD(RD(Wjb(a.g, l.a), 42).b, 27);
                                Byd(e, l.b.c, l.b.d);
                                j = $wnd.Math.min(j, e.i);
                                k = $wnd.Math.min(k, e.j);
                                h = $wnd.Math.max(h, e.i + e.g);
                                i = $wnd.Math.max(i, e.j + e.f);
                            }
                            n = RD(Gxd(a.c, (ncd(), ecd)), 107);
                            Esd(a.c, h - j + (n.b + n.c), i - k + (n.d + n.a), true, true);
                            Isd(a.c, -j + n.b, -k + n.d);
                            for(d = new dMd(uCd(a.c)); d.e != d.i.gc();){
                                c = RD(bMd(d), 74);
                                g = IGd(c, true, true);
                                o = JGd(c);
                                q = LGd(c);
                                p = new rjd(o.i + o.g / 2, o.j + o.f / 2);
                                f = new rjd(q.i + q.g / 2, q.j + q.f / 2);
                                r = ojd(new rjd(f.a, f.b), p);
                                wid(r, o.g, o.f);
                                $id(p, r);
                                s = ojd(new rjd(p.a, p.b), f);
                                wid(s, q.g, q.f);
                                $id(f, s);
                                Nzd(g, p.a, p.b);
                                Gzd(g, f.a, f.b);
                            }
                        }
                        function Tcc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o;
                            b.Ug('Label dummy removal', 1);
                            d = Kfb(UD(mQb(a, (yCc(), VBc))));
                            e = Kfb(UD(mQb(a, ZBc)));
                            j = RD(mQb(a, rAc), 88);
                            for(i = new Anb(a.b); i.a < i.c.c.length;){
                                h = RD(ynb(i), 30);
                                l = new Jkb(h.a, 0);
                                while(l.b < l.d.gc()){
                                    k = (sFb(l.b < l.d.gc()), RD(l.d.Xb(l.c = l.b++), 10));
                                    if (k.k == (r3b(), n3b)) {
                                        m = RD(mQb(k, (Ywc(), Awc)), 18);
                                        o = Kfb(UD(mQb(m, FAc)));
                                        g = dE(mQb(k, swc)) === dE((Pnd(), Mnd));
                                        c = new sjd(k.n);
                                        g && (c.b += o + d);
                                        f = new rjd(k.o.a, k.o.b + (k.k == n3b && !QDb(CDb(RD(mQb(k, Mwc), 15).Oc(), new PAb(new x3b))).Bd((xDb(), wDb)) ? 0 : -o - d));
                                        n = RD(mQb(k, Mwc), 15);
                                        j == (Cmd(), Bmd) || j == xmd ? Scc(n, c, e, f, g, j) : Rcc(n, c, e, f);
                                        Tmb(m.b, n);
                                        Hec(k, dE(mQb(a, yAc)) === dE((Ymd(), Vmd)));
                                        Ckb(l);
                                    }
                                }
                            }
                            b.Vg();
                        }
                        function ZBd(a) {
                            if (a.q) return;
                            a.q = true;
                            a.p = jBd(a, 0);
                            a.a = jBd(a, 1);
                            oBd(a.a, 0);
                            a.f = jBd(a, 2);
                            oBd(a.f, 1);
                            iBd(a.f, 2);
                            a.n = jBd(a, 3);
                            iBd(a.n, 3);
                            iBd(a.n, 4);
                            iBd(a.n, 5);
                            iBd(a.n, 6);
                            a.g = jBd(a, 4);
                            oBd(a.g, 7);
                            iBd(a.g, 8);
                            a.c = jBd(a, 5);
                            oBd(a.c, 7);
                            oBd(a.c, 8);
                            a.i = jBd(a, 6);
                            oBd(a.i, 9);
                            oBd(a.i, 10);
                            oBd(a.i, 11);
                            oBd(a.i, 12);
                            iBd(a.i, 13);
                            a.j = jBd(a, 7);
                            oBd(a.j, 9);
                            a.d = jBd(a, 8);
                            oBd(a.d, 3);
                            oBd(a.d, 4);
                            oBd(a.d, 5);
                            oBd(a.d, 6);
                            iBd(a.d, 7);
                            iBd(a.d, 8);
                            iBd(a.d, 9);
                            iBd(a.d, 10);
                            a.b = jBd(a, 9);
                            iBd(a.b, 0);
                            iBd(a.b, 1);
                            a.e = jBd(a, 10);
                            iBd(a.e, 1);
                            iBd(a.e, 2);
                            iBd(a.e, 3);
                            iBd(a.e, 4);
                            oBd(a.e, 5);
                            oBd(a.e, 6);
                            oBd(a.e, 7);
                            oBd(a.e, 8);
                            oBd(a.e, 9);
                            oBd(a.e, 10);
                            iBd(a.e, 11);
                            a.k = jBd(a, 11);
                            iBd(a.k, 0);
                            iBd(a.k, 1);
                            a.o = kBd(a, 12);
                            a.s = kBd(a, 13);
                        }
                        function CXb(a, b) {
                            b.dc() && JYb(a.j, true, true, true, true);
                            pb(b, (qpd(), cpd)) && JYb(a.j, true, true, true, false);
                            pb(b, Zod) && JYb(a.j, false, true, true, true);
                            pb(b, kpd) && JYb(a.j, true, true, false, true);
                            pb(b, mpd) && JYb(a.j, true, false, true, true);
                            pb(b, dpd) && JYb(a.j, false, true, true, false);
                            pb(b, $od) && JYb(a.j, false, true, false, true);
                            pb(b, lpd) && JYb(a.j, true, false, false, true);
                            pb(b, jpd) && JYb(a.j, true, false, true, false);
                            pb(b, hpd) && JYb(a.j, true, true, true, true);
                            pb(b, apd) && JYb(a.j, true, true, true, true);
                            pb(b, hpd) && JYb(a.j, true, true, true, true);
                            pb(b, _od) && JYb(a.j, true, true, true, true);
                            pb(b, ipd) && JYb(a.j, true, true, true, true);
                            pb(b, gpd) && JYb(a.j, true, true, true, true);
                            pb(b, fpd) && JYb(a.j, true, true, true, true);
                        }
                        function tAd(b, c, d) {
                            var e, f, g, h, i, j, k, l, m;
                            if (b.a != c.jk()) throw Adb(new agb(VHe + c.xe() + WHe));
                            e = Oee((lke(), jke), c).Jl();
                            if (e) return e.jk().wi().ri(e, d);
                            h = Oee(jke, c).Ll();
                            if (h) {
                                if (d == null) return null;
                                i = RD(d, 15);
                                if (i.dc()) return '';
                                m = new Qhb;
                                for(g = i.Kc(); g.Ob();){
                                    f = g.Pb();
                                    Nhb(m, h.jk().wi().ri(h, f));
                                    m.a += ' ';
                                }
                                return qeb(m, m.a.length - 1);
                            }
                            l = Oee(jke, c).Ml();
                            if (!l.dc()) {
                                for(k = l.Kc(); k.Ob();){
                                    j = RD(k.Pb(), 156);
                                    if (j.fk(d)) try {
                                        m = j.jk().wi().ri(j, d);
                                        if (m != null) return m;
                                    } catch (a) {
                                        a = zdb(a);
                                        if (!ZD(a, 103)) throw Adb(a);
                                    }
                                }
                                throw Adb(new agb("Invalid value: '" + d + "' for datatype :" + c.xe()));
                            }
                            RD(c, 847).ok();
                            return d == null ? null : ZD(d, 180) ? '' + RD(d, 180).a : rb(d) == qK ? a2d(nAd[0], RD(d, 206)) : jeb(d);
                        }
                        function ZUc(a) {
                            var b, c, d, e, f, g, h, i, j, k;
                            j = new Yub;
                            h = new Yub;
                            for(f = new Anb(a); f.a < f.c.c.length;){
                                d = RD(ynb(f), 131);
                                d.v = 0;
                                d.n = d.i.c.length;
                                d.u = d.t.c.length;
                                d.n == 0 && Pub(j, d, j.c.b, j.c);
                                d.u == 0 && d.r.a.gc() == 0 && Pub(h, d, h.c.b, h.c);
                            }
                            g = -1;
                            while(j.b != 0){
                                d = RD(ku(j, 0), 131);
                                for(c = new Anb(d.t); c.a < c.c.c.length;){
                                    b = RD(ynb(c), 274);
                                    k = b.b;
                                    k.v = $wnd.Math.max(k.v, d.v + 1);
                                    g = $wnd.Math.max(g, k.v);
                                    --k.n;
                                    k.n == 0 && Pub(j, k, j.c.b, j.c);
                                }
                            }
                            if (g > -1) {
                                for(e = Sub(h, 0); e.b != e.d.c;){
                                    d = RD(evb(e), 131);
                                    d.v = g;
                                }
                                while(h.b != 0){
                                    d = RD(ku(h, 0), 131);
                                    for(c = new Anb(d.i); c.a < c.c.c.length;){
                                        b = RD(ynb(c), 274);
                                        i = b.a;
                                        if (i.r.a.gc() != 0) continue;
                                        i.v = $wnd.Math.min(i.v, d.v - 1);
                                        --i.u;
                                        i.u == 0 && Pub(h, i, h.c.b, h.c);
                                    }
                                }
                            }
                        }
                        function WTc(a) {
                            var b, c, d, e, f, g, h, i, j, k;
                            j = new bnb;
                            h = new bnb;
                            for(g = new Anb(a); g.a < g.c.c.length;){
                                e = RD(ynb(g), 118);
                                PSc(e, e.f.c.length);
                                QSc(e, e.k.c.length);
                                e.d == 0 && ZEb(j.c, e);
                                e.i == 0 && e.e.b == 0 && ZEb(h.c, e);
                            }
                            d = -1;
                            while(j.c.length != 0){
                                e = RD(Xmb(j, 0), 118);
                                for(c = new Anb(e.k); c.a < c.c.c.length;){
                                    b = RD(ynb(c), 132);
                                    k = b.b;
                                    RSc(k, $wnd.Math.max(k.o, e.o + 1));
                                    d = $wnd.Math.max(d, k.o);
                                    PSc(k, k.d - 1);
                                    k.d == 0 && ZEb(j.c, k);
                                }
                            }
                            if (d > -1) {
                                for(f = new Anb(h); f.a < f.c.c.length;){
                                    e = RD(ynb(f), 118);
                                    e.o = d;
                                }
                                while(h.c.length != 0){
                                    e = RD(Xmb(h, 0), 118);
                                    for(c = new Anb(e.f); c.a < c.c.c.length;){
                                        b = RD(ynb(c), 132);
                                        i = b.a;
                                        if (i.e.b > 0) continue;
                                        RSc(i, $wnd.Math.min(i.o, e.o - 1));
                                        QSc(i, i.i - 1);
                                        i.i == 0 && ZEb(h.c, i);
                                    }
                                }
                            }
                        }
                        function Lid(a, b, c, d, e) {
                            var f, g, h, i;
                            i = oxe;
                            g = false;
                            h = Gid(a, ojd(new rjd(b.a, b.b), a), $id(new rjd(c.a, c.b), e), ojd(new rjd(d.a, d.b), c));
                            f = !!h && !($wnd.Math.abs(h.a - a.a) <= IGe && $wnd.Math.abs(h.b - a.b) <= IGe || $wnd.Math.abs(h.a - b.a) <= IGe && $wnd.Math.abs(h.b - b.b) <= IGe);
                            h = Gid(a, ojd(new rjd(b.a, b.b), a), c, e);
                            !!h && (($wnd.Math.abs(h.a - a.a) <= IGe && $wnd.Math.abs(h.b - a.b) <= IGe) == ($wnd.Math.abs(h.a - b.a) <= IGe && $wnd.Math.abs(h.b - b.b) <= IGe) || f ? i = $wnd.Math.min(i, ejd(ojd(h, c))) : g = true);
                            h = Gid(a, ojd(new rjd(b.a, b.b), a), d, e);
                            !!h && (g || ($wnd.Math.abs(h.a - a.a) <= IGe && $wnd.Math.abs(h.b - a.b) <= IGe) == ($wnd.Math.abs(h.a - b.a) <= IGe && $wnd.Math.abs(h.b - b.b) <= IGe) || f) && (i = $wnd.Math.min(i, ejd(ojd(h, d))));
                            return i;
                        }
                        function eWb(a) {
                            Cgd(a, new Pfd(Wfd($fd(Xfd(Zfd(Yfd(new agd, AAe), BAe), "Minimizes the stress within a layout using stress majorization. Stress exists if the euclidean distance between a pair of nodes doesn't match their graph theoretic distance, that is, the shortest path between the two nodes. The method allows to specify individual edge lengths."), new hWb), Zze)));
                            Agd(a, AAe, dAe, iGd(XVb));
                            Agd(a, AAe, fAe, (Geb(), true));
                            Agd(a, AAe, jAe, iGd($Vb));
                            Agd(a, AAe, CAe, iGd(_Vb));
                            Agd(a, AAe, iAe, iGd(aWb));
                            Agd(a, AAe, kAe, iGd(ZVb));
                            Agd(a, AAe, gAe, iGd(bWb));
                            Agd(a, AAe, lAe, iGd(cWb));
                            Agd(a, AAe, vAe, iGd(WVb));
                            Agd(a, AAe, xAe, iGd(UVb));
                            Agd(a, AAe, yAe, iGd(VVb));
                            Agd(a, AAe, zAe, iGd(YVb));
                            Agd(a, AAe, wAe, iGd(TVb));
                        }
                        function kJc(a) {
                            var b, c, d, e, f, g, h, i;
                            b = null;
                            for(d = new Anb(a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 239);
                                Kfb(pJc(c.g, c.d[0]).a);
                                c.b = null;
                                if (!!c.e && c.e.gc() > 0 && c.c == 0) {
                                    !b && (b = new bnb);
                                    ZEb(b.c, c);
                                }
                            }
                            if (b) while(b.c.length != 0){
                                c = RD(Xmb(b, 0), 239);
                                if (!!c.b && c.b.c.length > 0) for(f = (!c.b && (c.b = new bnb), new Anb(c.b)); f.a < f.c.c.length;){
                                    e = RD(ynb(f), 239);
                                    if (Mfb(pJc(e.g, e.d[0]).a) == Mfb(pJc(c.g, c.d[0]).a)) {
                                        if (Wmb(a, e, 0) > Wmb(a, c, 0)) return new Ptd(e, c);
                                    } else if (Kfb(pJc(e.g, e.d[0]).a) > Kfb(pJc(c.g, c.d[0]).a)) return new Ptd(e, c);
                                }
                                for(h = (!c.e && (c.e = new bnb), c.e).Kc(); h.Ob();){
                                    g = RD(h.Pb(), 239);
                                    i = (!g.b && (g.b = new bnb), g.b);
                                    wFb(0, i.c.length);
                                    XEb(i.c, 0, c);
                                    g.c == i.c.length && ZEb(b.c, g);
                                }
                            }
                            return null;
                        }
                        function _Jc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                            b.Ug('Interactive crossing minimization', 1);
                            g = 0;
                            for(f = new Anb(a.b); f.a < f.c.c.length;){
                                d = RD(ynb(f), 30);
                                d.p = g++;
                            }
                            m = c1b(a);
                            q = new ILc(m.length);
                            yNc(new mob(cD(WC(QY, 1), rve, 230, 0, [
                                q
                            ])), m);
                            p = 0;
                            g = 0;
                            for(e = new Anb(a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 30);
                                c = 0;
                                l = 0;
                                for(k = new Anb(d.a); k.a < k.c.c.length;){
                                    i = RD(ynb(k), 10);
                                    if (i.n.a > 0) {
                                        c += i.n.a + i.o.a / 2;
                                        ++l;
                                    }
                                    for(o = new Anb(i.j); o.a < o.c.c.length;){
                                        n = RD(ynb(o), 12);
                                        n.p = p++;
                                    }
                                }
                                l > 0 && (c /= l);
                                r = $C(iE, vxe, 28, d.a.c.length, 15, 1);
                                h = 0;
                                for(j = new Anb(d.a); j.a < j.c.c.length;){
                                    i = RD(ynb(j), 10);
                                    i.p = h++;
                                    r[i.p] = $Jc(i, c);
                                    i.k == (r3b(), o3b) && pQb(i, (Ywc(), Cwc), r[i.p]);
                                }
                                yob();
                                _mb(d.a, new eKc(r));
                                wIc(q, m, g, true);
                                ++g;
                            }
                            b.Vg();
                        }
                        function wte(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            if (b.e == 5) {
                                tte(a, b);
                                return;
                            }
                            j = b;
                            if (j.b == null || a.b == null) return;
                            vte(a);
                            ste(a);
                            vte(j);
                            ste(j);
                            c = $C(kE, Pwe, 28, a.b.length + j.b.length, 15, 1);
                            k = 0;
                            d = 0;
                            g = 0;
                            while(d < a.b.length && g < j.b.length){
                                e = a.b[d];
                                f = a.b[d + 1];
                                h = j.b[g];
                                i = j.b[g + 1];
                                if (f < h) {
                                    c[k++] = a.b[d++];
                                    c[k++] = a.b[d++];
                                } else if (f >= h && e <= i) {
                                    if (h <= e && f <= i) d += 2;
                                    else if (h <= e) {
                                        a.b[d] = i + 1;
                                        g += 2;
                                    } else if (f <= i) {
                                        c[k++] = e;
                                        c[k++] = h - 1;
                                        d += 2;
                                    } else {
                                        c[k++] = e;
                                        c[k++] = h - 1;
                                        a.b[d] = i + 1;
                                        g += 2;
                                    }
                                } else if (i < e) g += 2;
                                else throw Adb(new yz('Token#subtractRanges(): Internal Error: [' + a.b[d] + ',' + a.b[d + 1] + '] - [' + j.b[g] + ',' + j.b[g + 1] + ']'));
                            }
                            while(d < a.b.length){
                                c[k++] = a.b[d++];
                                c[k++] = a.b[d++];
                            }
                            a.b = $C(kE, Pwe, 28, k, 15, 1);
                            hib(c, 0, a.b, 0, k);
                        }
                        function oTb(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            h = IGd(b, false, false);
                            r = ssd(h);
                            d && (r = Ijd(r));
                            t = Kfb(UD(Gxd(b, (tSb(), mSb))));
                            q = (sFb(r.b != 0), RD(r.a.a.c, 8));
                            l = RD(ju(r, 1), 8);
                            if (r.b > 2) {
                                k = new bnb;
                                Tmb(k, new Rkb(r, 1, r.b));
                                f = jTb(k, t + a.a);
                                s = new ORb(f);
                                kQb(s, b);
                                ZEb(c.c, s);
                            } else d ? s = RD(Wjb(a.b, JGd(b)), 272) : s = RD(Wjb(a.b, LGd(b)), 272);
                            i = JGd(b);
                            d && (i = LGd(b));
                            g = qTb(q, i);
                            j = t + a.a;
                            if (g.a) {
                                j += $wnd.Math.abs(q.b - l.b);
                                p = new rjd(l.a, (l.b + q.b) / 2);
                            } else {
                                j += $wnd.Math.abs(q.a - l.a);
                                p = new rjd((l.a + q.a) / 2, l.b);
                            }
                            d ? Zjb(a.d, b, new QRb(s, g, p, j)) : Zjb(a.c, b, new QRb(s, g, p, j));
                            Zjb(a.b, b, s);
                            o = (!b.n && (b.n = new C5d(I4, b, 1, 7)), b.n);
                            for(n = new dMd(o); n.e != n.i.gc();){
                                m = RD(bMd(n), 135);
                                e = nTb(a, m, true, 0, 0);
                                ZEb(c.c, e);
                            }
                        }
                        function sMb(a) {
                            var b, c, d, e, f, g, h;
                            if (a.A.dc()) return;
                            if (a.A.Hc((Qpd(), Opd))) {
                                RD(Vrb(a.b, (qpd(), Yod)), 127).k = true;
                                RD(Vrb(a.b, npd), 127).k = true;
                                b = a.q != (Bod(), xod) && a.q != wod;
                                QJb(RD(Vrb(a.b, Xod), 127), b);
                                QJb(RD(Vrb(a.b, ppd), 127), b);
                                QJb(a.g, b);
                                if (a.A.Hc(Ppd)) {
                                    RD(Vrb(a.b, Yod), 127).j = true;
                                    RD(Vrb(a.b, npd), 127).j = true;
                                    RD(Vrb(a.b, Xod), 127).k = true;
                                    RD(Vrb(a.b, ppd), 127).k = true;
                                    a.g.k = true;
                                }
                            }
                            if (a.A.Hc(Npd)) {
                                a.a.j = true;
                                a.a.k = true;
                                a.g.j = true;
                                a.g.k = true;
                                h = a.B.Hc((dqd(), _pd));
                                for(e = nMb(), f = 0, g = e.length; f < g; ++f){
                                    d = e[f];
                                    c = RD(Vrb(a.i, d), 314);
                                    if (c) {
                                        if (jMb(d)) {
                                            c.j = true;
                                            c.k = true;
                                        } else {
                                            c.j = !h;
                                            c.k = !h;
                                        }
                                    }
                                }
                            }
                            if (a.A.Hc(Mpd) && a.B.Hc((dqd(), $pd))) {
                                a.g.j = true;
                                a.g.j = true;
                                if (!a.a.j) {
                                    a.a.j = true;
                                    a.a.k = true;
                                    a.a.e = true;
                                }
                            }
                        }
                        function eOc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                            for(d = new Anb(a.e.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 30);
                                for(f = new Anb(c.a); f.a < f.c.c.length;){
                                    e = RD(ynb(f), 10);
                                    n = a.i[e.p];
                                    j = n.a.e;
                                    i = n.d.e;
                                    e.n.b = j;
                                    r = i - j - e.o.b;
                                    b = BOc(e);
                                    m = (wDc(), (!e.q ? (yob(), yob(), wob) : e.q)._b((yCc(), iBc)) ? l = RD(mQb(e, iBc), 203) : l = RD(mQb(Y2b(e), jBc), 203), l);
                                    b && (m == tDc || m == sDc) && (e.o.b += r);
                                    if (b && (m == vDc || m == tDc || m == sDc)) {
                                        for(p = new Anb(e.j); p.a < p.c.c.length;){
                                            o = RD(ynb(p), 12);
                                            if ((qpd(), apd).Hc(o.j)) {
                                                k = RD(Wjb(a.k, o), 125);
                                                o.n.b = k.e - j;
                                            }
                                        }
                                        for(h = new Anb(e.b); h.a < h.c.c.length;){
                                            g = RD(ynb(h), 72);
                                            q = RD(mQb(e, dBc), 21);
                                            q.Hc((dod(), aod)) ? g.n.b += r : q.Hc(bod) && (g.n.b += r / 2);
                                        }
                                        (m == tDc || m == sDc) && b3b(e, (qpd(), npd)).Jc(new yPc(r));
                                    }
                                }
                            }
                        }
                        function qOc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            j = new bnb;
                            for(i = new Anb(b.a); i.a < i.c.c.length;){
                                g = RD(ynb(i), 10);
                                for(m = b3b(g, (qpd(), Xod)).Kc(); m.Ob();){
                                    l = RD(m.Pb(), 12);
                                    for(e = new Anb(l.g); e.a < e.c.c.length;){
                                        d = RD(ynb(e), 18);
                                        if (!W0b(d) && d.c.i.c == d.d.i.c || W0b(d) || d.d.i.c != c) continue;
                                        ZEb(j.c, d);
                                    }
                                }
                            }
                            for(h = hv(c.a).Kc(); h.Ob();){
                                g = RD(h.Pb(), 10);
                                for(m = b3b(g, (qpd(), ppd)).Kc(); m.Ob();){
                                    l = RD(m.Pb(), 12);
                                    for(e = new Anb(l.e); e.a < e.c.c.length;){
                                        d = RD(ynb(e), 18);
                                        if (!W0b(d) && d.c.i.c == d.d.i.c || W0b(d) || d.c.i.c != b) continue;
                                        if (j.c.length != 0) {
                                            k = new Jkb(j, j.c.length);
                                            f = (sFb(k.b > 0), RD(k.a.Xb(k.c = --k.b), 18));
                                            while(f != d && k.b > 0){
                                                a.a[f.p] = true;
                                                a.a[d.p] = true;
                                                f = (sFb(k.b > 0), RD(k.a.Xb(k.c = --k.b), 18));
                                            }
                                            k.b > 0 && Ckb(k);
                                        }
                                    }
                                }
                            }
                        }
                        function Zyb(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n;
                            if (!a.b) return false;
                            g = null;
                            m = null;
                            i = new Fzb(null, null);
                            e = 1;
                            i.a[1] = a.b;
                            l = i;
                            while(l.a[e]){
                                j = e;
                                h = m;
                                m = l;
                                l = l.a[e];
                                d = a.a.Ne(b, l.d);
                                e = d < 0 ? 0 : 1;
                                d == 0 && (!c.c || Fvb(l.e, c.d)) && (g = l);
                                if (!(!!l && l.b) && !Vyb(l.a[e])) {
                                    if (Vyb(l.a[1 - e])) m = m.a[j] = azb(l, e);
                                    else if (!Vyb(l.a[1 - e])) {
                                        n = m.a[1 - j];
                                        if (n) {
                                            if (!Vyb(n.a[1 - j]) && !Vyb(n.a[j])) {
                                                m.b = false;
                                                n.b = true;
                                                l.b = true;
                                            } else {
                                                f = h.a[1] == m ? 1 : 0;
                                                Vyb(n.a[j]) ? h.a[f] = _yb(m, j) : Vyb(n.a[1 - j]) && (h.a[f] = azb(m, j));
                                                l.b = h.a[f].b = true;
                                                h.a[f].a[0].b = false;
                                                h.a[f].a[1].b = false;
                                            }
                                        }
                                    }
                                }
                            }
                            if (g) {
                                c.b = true;
                                c.d = g.e;
                                if (l != g) {
                                    k = new Fzb(l.d, l.e);
                                    $yb(a, i, g, k);
                                    m == g && (m = k);
                                }
                                m.a[m.a[1] == l ? 1 : 0] = l.a[!l.a[0] ? 1 : 0];
                                --a.c;
                            }
                            a.b = i.a[1];
                            !!a.b && (a.b.b = false);
                            return c.b;
                        }
                        function Ilc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m;
                            for(e = new Anb(a.a.a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 60);
                                for(i = d.c.Kc(); i.Ob();){
                                    h = RD(i.Pb(), 60);
                                    if (d.a == h.a) continue;
                                    Dmd(a.a.d) ? l = a.a.g.ff(d, h) : l = a.a.g.gf(d, h);
                                    f = d.b.a + d.d.b + l - h.b.a;
                                    f = $wnd.Math.ceil(f);
                                    f = $wnd.Math.max(0, f);
                                    if (_jc(d, h)) {
                                        g = eJb(new gJb, a.d);
                                        j = eE($wnd.Math.ceil(h.b.a - d.b.a));
                                        b = j - (h.b.a - d.b.a);
                                        k = $jc(d).a;
                                        c = d;
                                        if (!k) {
                                            k = $jc(h).a;
                                            b = -b;
                                            c = h;
                                        }
                                        if (k) {
                                            c.b.a -= b;
                                            k.n.a -= b;
                                        }
                                        rIb(uIb(tIb(vIb(sIb(new wIb, $wnd.Math.max(0, j)), 1), g), a.c[d.a.d]));
                                        rIb(uIb(tIb(vIb(sIb(new wIb, $wnd.Math.max(0, -j)), 1), g), a.c[h.a.d]));
                                    } else {
                                        m = 1;
                                        (ZD(d.g, 154) && ZD(h.g, 10) || ZD(h.g, 154) && ZD(d.g, 10)) && (m = 2);
                                        rIb(uIb(tIb(vIb(sIb(new wIb, eE(f)), m), a.c[d.a.d]), a.c[h.a.d]));
                                    }
                                }
                            }
                        }
                        function PIc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            if (c) {
                                d = -1;
                                k = new Jkb(b, 0);
                                while(k.b < k.d.gc()){
                                    h = (sFb(k.b < k.d.gc()), RD(k.d.Xb(k.c = k.b++), 10));
                                    l = a.c[h.c.p][h.p].a;
                                    if (l == null) {
                                        g = d + 1;
                                        f = new Jkb(b, k.b);
                                        while(f.b < f.d.gc()){
                                            m = TIc(a, (sFb(f.b < f.d.gc()), RD(f.d.Xb(f.c = f.b++), 10))).a;
                                            if (m != null) {
                                                g = (uFb(m), m);
                                                break;
                                            }
                                        }
                                        l = (d + g) / 2;
                                        a.c[h.c.p][h.p].a = l;
                                        a.c[h.c.p][h.p].d = (uFb(l), l);
                                        a.c[h.c.p][h.p].b = 1;
                                    }
                                    d = (uFb(l), l);
                                }
                            } else {
                                e = 0;
                                for(j = new Anb(b); j.a < j.c.c.length;){
                                    h = RD(ynb(j), 10);
                                    a.c[h.c.p][h.p].a != null && (e = $wnd.Math.max(e, Kfb(a.c[h.c.p][h.p].a)));
                                }
                                e += 2;
                                for(i = new Anb(b); i.a < i.c.c.length;){
                                    h = RD(ynb(i), 10);
                                    if (a.c[h.c.p][h.p].a == null) {
                                        l = Kwb(a.i, 24) * Nxe * e - 1;
                                        a.c[h.c.p][h.p].a = l;
                                        a.c[h.c.p][h.p].d = l;
                                        a.c[h.c.p][h.p].b = 1;
                                    }
                                }
                            }
                        }
                        function xA(a, b, c) {
                            var d, e, f, g, h, i, j, k, l;
                            !c && (c = hB(b.q.getTimezoneOffset()));
                            e = (b.q.getTimezoneOffset() - c.a) * 60000;
                            h = new wB(Bdb(Hdb(b.q.getTime()), e));
                            i = h;
                            if (h.q.getTimezoneOffset() != b.q.getTimezoneOffset()) {
                                e > 0 ? e -= 86400000 : e += 86400000;
                                i = new wB(Bdb(Hdb(b.q.getTime()), e));
                            }
                            k = new cib;
                            j = a.a.length;
                            for(f = 0; f < j;){
                                d = ihb(a.a, f);
                                if (d >= 97 && d <= 122 || d >= 65 && d <= 90) {
                                    for(g = f + 1; g < j && ihb(a.a, g) == d; ++g);
                                    LA(k, d, g - f, h, i, c);
                                    f = g;
                                } else if (d == 39) {
                                    ++f;
                                    if (f < j && ihb(a.a, f) == 39) {
                                        k.a += "'";
                                        ++f;
                                        continue;
                                    }
                                    l = false;
                                    while(!l){
                                        g = f;
                                        while(g < j && ihb(a.a, g) != 39)++g;
                                        if (g >= j) throw Adb(new agb("Missing trailing '"));
                                        g + 1 < j && ihb(a.a, g + 1) == 39 ? ++g : l = true;
                                        Zhb(k, zhb(a.a, f, g));
                                        f = g + 1;
                                    }
                                } else {
                                    k.a += String.fromCharCode(d);
                                    ++f;
                                }
                            }
                            return k.a;
                        }
                        function abe() {
                            RRd(g7, new Ibe);
                            RRd(f7, new nce);
                            RRd(h7, new Uce);
                            RRd(i7, new kde);
                            RRd(k7, new nde);
                            RRd(m7, new qde);
                            RRd(l7, new tde);
                            RRd(n7, new wde);
                            RRd(p7, new ebe);
                            RRd(q7, new hbe);
                            RRd(r7, new kbe);
                            RRd(s7, new nbe);
                            RRd(t7, new qbe);
                            RRd(u7, new tbe);
                            RRd(v7, new wbe);
                            RRd(y7, new zbe);
                            RRd(A7, new Cbe);
                            RRd(C8, new Fbe);
                            RRd(o7, new Lbe);
                            RRd(z7, new Obe);
                            RRd(QI, new Rbe);
                            RRd(WC(gE, 1), new Ube);
                            RRd(RI, new Xbe);
                            RRd(SI, new $be);
                            RRd(qK, new bce);
                            RRd(T6, new ece);
                            RRd(VI, new hce);
                            RRd(Y6, new kce);
                            RRd(Z6, new qce);
                            RRd(Tbb, new tce);
                            RRd(Jbb, new wce);
                            RRd(ZI, new zce);
                            RRd(bJ, new Cce);
                            RRd(UI, new Fce);
                            RRd(eJ, new Ice);
                            RRd(VK, new Lce);
                            RRd(Aab, new Oce);
                            RRd(zab, new Rce);
                            RRd(lJ, new Xce);
                            RRd(qJ, new $ce);
                            RRd(a7, new bde);
                            RRd($6, new ede);
                        }
                        function Inb(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            if (a == null) return vve;
                            i = b.a.zc(a, b);
                            if (i != null) return '[...]';
                            c = new Jyb(pve, '[', ']');
                            for(e = a, f = 0, g = e.length; f < g; ++f){
                                d = e[f];
                                if (d != null && (rb(d).i & 4) != 0) {
                                    if (Array.isArray(d) && (k = XC(d), !(k >= 14 && k <= 16))) {
                                        if (b.a._b(d)) {
                                            !c.a ? c.a = new dib(c.d) : Zhb(c.a, c.b);
                                            Whb(c.a, '[...]');
                                        } else {
                                            h = SD(d);
                                            j = new btb(b);
                                            Gyb(c, Inb(h, j));
                                        }
                                    } else ZD(d, 183) ? Gyb(c, hob(RD(d, 183))) : ZD(d, 195) ? Gyb(c, aob(RD(d, 195))) : ZD(d, 201) ? Gyb(c, bob(RD(d, 201))) : ZD(d, 2111) ? Gyb(c, gob(RD(d, 2111))) : ZD(d, 53) ? Gyb(c, eob(RD(d, 53))) : ZD(d, 376) ? Gyb(c, fob(RD(d, 376))) : ZD(d, 846) ? Gyb(c, dob(RD(d, 846))) : ZD(d, 109) && Gyb(c, cob(RD(d, 109)));
                                } else Gyb(c, d == null ? vve : jeb(d));
                            }
                            return !c.a ? c.c : c.e.length == 0 ? c.a.a : c.a.a + ('' + c.e);
                        }
                        function KXd(a, b) {
                            var c, d, e, f;
                            f = a.F;
                            if (b == null) {
                                a.F = null;
                                yXd(a, null);
                            } else {
                                a.F = (uFb(b), b);
                                d = qhb(b, Fhb(60));
                                if (d != -1) {
                                    e = (AFb(0, d, b.length), b.substr(0, d));
                                    qhb(b, Fhb(46)) == -1 && !lhb(e, hve) && !lhb(e, dKe) && !lhb(e, eKe) && !lhb(e, fKe) && !lhb(e, gKe) && !lhb(e, hKe) && !lhb(e, iKe) && !lhb(e, jKe) && (e = kKe);
                                    c = thb(b, Fhb(62));
                                    c != -1 && (e += '' + (BFb(c + 1, b.length + 1), b.substr(c + 1)));
                                    yXd(a, e);
                                } else {
                                    e = b;
                                    if (qhb(b, Fhb(46)) == -1) {
                                        d = qhb(b, Fhb(91));
                                        d != -1 && (e = (AFb(0, d, b.length), b.substr(0, d)));
                                        if (!lhb(e, hve) && !lhb(e, dKe) && !lhb(e, eKe) && !lhb(e, fKe) && !lhb(e, gKe) && !lhb(e, hKe) && !lhb(e, iKe) && !lhb(e, jKe)) {
                                            e = kKe;
                                            d != -1 && (e += '' + (BFb(d, b.length + 1), b.substr(d)));
                                        } else e = b;
                                    }
                                    yXd(a, e);
                                    e == b && (a.F = a.D);
                                }
                            }
                            (a.Db & 4) != 0 && (a.Db & 1) == 0 && qvd(a, new N3d(a, 1, 5, f, b));
                        }
                        function Pvd(b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            j = c.length - 1;
                            i = (BFb(j, c.length), c.charCodeAt(j));
                            if (i == 93) {
                                h = qhb(c, Fhb(91));
                                if (h >= 0) {
                                    f = Uvd(b, (AFb(1, h, c.length), c.substr(1, h - 1)));
                                    l = (AFb(h + 1, j, c.length), c.substr(h + 1, j - (h + 1)));
                                    return Nvd(b, l, f);
                                }
                            } else {
                                d = -1;
                                _eb == null && (_eb = new RegExp('\\d'));
                                if (_eb.test(String.fromCharCode(i))) {
                                    d = uhb(c, Fhb(46), j - 1);
                                    if (d >= 0) {
                                        e = RD(Fvd(b, Zvd(b, (AFb(1, d, c.length), c.substr(1, d - 1))), false), 61);
                                        k = 0;
                                        try {
                                            k = Oeb((BFb(d + 1, c.length + 1), c.substr(d + 1)), qwe, lve);
                                        } catch (a) {
                                            a = zdb(a);
                                            if (ZD(a, 130)) {
                                                g = a;
                                                throw Adb(new RSd(g));
                                            } else throw Adb(a);
                                        }
                                        if (k < e.gc()) {
                                            m = e.Xb(k);
                                            ZD(m, 76) && (m = RD(m, 76).md());
                                            return RD(m, 58);
                                        }
                                    }
                                }
                                if (d < 0) return RD(Fvd(b, Zvd(b, (BFb(1, c.length + 1), c.substr(1))), false), 58);
                            }
                            return null;
                        }
                        function Jcc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
                            b.Ug('Label dummy insertions', 1);
                            l = new bnb;
                            g = Kfb(UD(mQb(a, (yCc(), VBc))));
                            j = Kfb(UD(mQb(a, ZBc)));
                            k = RD(mQb(a, rAc), 88);
                            for(n = new Anb(a.a); n.a < n.c.c.length;){
                                m = RD(ynb(n), 10);
                                for(f = new is(Mr(a3b(m).a.Kc(), new ir)); gs(f);){
                                    e = RD(hs(f), 18);
                                    if (e.c.i != e.d.i && br(e.b, Gcc)) {
                                        p = Kcc(e);
                                        o = ev(e.b.c.length);
                                        c = Icc(a, e, p, o);
                                        ZEb(l.c, c);
                                        d = c.o;
                                        h = new Jkb(e.b, 0);
                                        while(h.b < h.d.gc()){
                                            i = (sFb(h.b < h.d.gc()), RD(h.d.Xb(h.c = h.b++), 72));
                                            if (dE(mQb(i, wAc)) === dE((Omd(), Lmd))) {
                                                if (k == (Cmd(), Bmd) || k == xmd) {
                                                    d.a += i.o.a + j;
                                                    d.b = $wnd.Math.max(d.b, i.o.b);
                                                } else {
                                                    d.a = $wnd.Math.max(d.a, i.o.a);
                                                    d.b += i.o.b + j;
                                                }
                                                ZEb(o.c, i);
                                                Ckb(h);
                                            }
                                        }
                                        if (k == (Cmd(), Bmd) || k == xmd) {
                                            d.a -= j;
                                            d.b += g + p;
                                        } else d.b += g - j + p;
                                    }
                                }
                            }
                            Tmb(a.a, l);
                            b.Vg();
                        }
                        function H_b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o;
                            a.c = a.e;
                            o = TD(mQb(b, (yCc(), OBc)));
                            n = o == null || (uFb(o), o);
                            f = RD(mQb(b, (Ywc(), kwc)), 21).Hc((ovc(), hvc));
                            e = RD(mQb(b, BBc), 101);
                            c = !(e == (Bod(), vod) || e == xod || e == wod);
                            if (n && (c || !f)) {
                                for(l = new Anb(b.a); l.a < l.c.c.length;){
                                    j = RD(ynb(l), 10);
                                    j.p = 0;
                                }
                                m = new bnb;
                                for(k = new Anb(b.a); k.a < k.c.c.length;){
                                    j = RD(ynb(k), 10);
                                    d = G_b(a, j, null);
                                    if (d) {
                                        i = new d1b;
                                        kQb(i, b);
                                        pQb(i, ewc, RD(d.b, 21));
                                        C2b(i.d, b.d);
                                        pQb(i, nBc, null);
                                        for(h = RD(d.a, 15).Kc(); h.Ob();){
                                            g = RD(h.Pb(), 10);
                                            Rmb(i.a, g);
                                            g.a = i;
                                        }
                                        m.Fc(i);
                                    }
                                }
                                f && (dE(mQb(b, Yzc)) === dE((U$b(), Q$b)) ? a.c = a.b : dE(mQb(b, Yzc)) === dE(S$b) ? a.c = a.d : a.c = a.a);
                            } else m = new mob(cD(WC(eR, 1), OAe, 36, 0, [
                                b
                            ]));
                            dE(mQb(b, Yzc)) !== dE((U$b(), T$b)) && (yob(), m.jd(new K_b));
                            return m;
                        }
                        function o2d(a, b, c) {
                            var d, e, f, g, h, i, j;
                            j = a.c;
                            !b && (b = d2d);
                            a.c = b;
                            if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
                                i = new N3d(a, 1, 2, j, a.c);
                                !c ? c = i : c.nj(i);
                            }
                            if (j != b) {
                                if (ZD(a.Cb, 292)) {
                                    if (a.Db >> 16 == -10) c = RD(a.Cb, 292).Yk(b, c);
                                    else if (a.Db >> 16 == -15) {
                                        !b && (b = (JTd(), wTd));
                                        !j && (j = (JTd(), wTd));
                                        if (a.Cb.Yh()) {
                                            i = new P3d(a.Cb, 1, 13, j, b, fZd(o4d(RD(a.Cb, 62)), a), false);
                                            !c ? c = i : c.nj(i);
                                        }
                                    }
                                } else if (ZD(a.Cb, 90)) {
                                    if (a.Db >> 16 == -23) {
                                        ZD(b, 90) || (b = (JTd(), zTd));
                                        ZD(j, 90) || (j = (JTd(), zTd));
                                        if (a.Cb.Yh()) {
                                            i = new P3d(a.Cb, 1, 10, j, b, fZd(tYd(RD(a.Cb, 29)), a), false);
                                            !c ? c = i : c.nj(i);
                                        }
                                    }
                                } else if (ZD(a.Cb, 457)) {
                                    h = RD(a.Cb, 850);
                                    g = (!h.b && (h.b = new pae(new lae)), h.b);
                                    for(f = (d = new vkb(new mkb(g.a).a), new xae(d)); f.a.b;){
                                        e = RD(tkb(f.a).ld(), 89);
                                        c = o2d(e, k2d(e, h), c);
                                    }
                                }
                            }
                            return c;
                        }
                        function Y4b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m;
                            g = Heb(TD(Gxd(a, (yCc(), NAc))));
                            m = RD(Gxd(a, EBc), 21);
                            i = false;
                            j = false;
                            l = new dMd((!a.c && (a.c = new C5d(K4, a, 9, 9)), a.c));
                            while(l.e != l.i.gc() && (!i || !j)){
                                f = RD(bMd(l), 123);
                                h = 0;
                                for(e = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                    (!f.d && (f.d = new Yie(G4, f, 8, 5)), f.d),
                                    (!f.e && (f.e = new Yie(G4, f, 7, 4)), f.e)
                                ]))); gs(e);){
                                    d = RD(hs(e), 74);
                                    k = g && ozd(d) && Heb(TD(Gxd(d, OAc)));
                                    c = cZd((!d.b && (d.b = new Yie(E4, d, 4, 7)), d.b), f) ? a == vCd(AGd(RD(QHd((!d.c && (d.c = new Yie(E4, d, 5, 8)), d.c), 0), 84))) : a == vCd(AGd(RD(QHd((!d.b && (d.b = new Yie(E4, d, 4, 7)), d.b), 0), 84)));
                                    if (k || c) {
                                        ++h;
                                        if (h > 1) break;
                                    }
                                }
                                h > 0 ? i = true : m.Hc((Pod(), Lod)) && (!f.n && (f.n = new C5d(I4, f, 1, 7)), f.n).i > 0 && (i = true);
                                h > 1 && (j = true);
                            }
                            i && b.Fc((ovc(), hvc));
                            j && b.Fc((ovc(), ivc));
                        }
                        function Dsd(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m;
                            m = RD(Gxd(a, (umd(), kld)), 21);
                            if (m.dc()) return null;
                            h = 0;
                            g = 0;
                            if (m.Hc((Qpd(), Opd))) {
                                k = RD(Gxd(a, Hld), 101);
                                d = 2;
                                c = 2;
                                e = 2;
                                f = 2;
                                b = !vCd(a) ? RD(Gxd(a, Nkd), 88) : RD(Gxd(vCd(a), Nkd), 88);
                                for(j = new dMd((!a.c && (a.c = new C5d(K4, a, 9, 9)), a.c)); j.e != j.i.gc();){
                                    i = RD(bMd(j), 123);
                                    l = RD(Gxd(i, Old), 64);
                                    if (l == (qpd(), opd)) {
                                        l = osd(i, b);
                                        Ixd(i, Old, l);
                                    }
                                    if (k == (Bod(), wod)) switch(l.g){
                                        case 1:
                                            d = $wnd.Math.max(d, i.i + i.g);
                                            break;
                                        case 2:
                                            c = $wnd.Math.max(c, i.j + i.f);
                                            break;
                                        case 3:
                                            e = $wnd.Math.max(e, i.i + i.g);
                                            break;
                                        case 4:
                                            f = $wnd.Math.max(f, i.j + i.f);
                                    }
                                    else switch(l.g){
                                        case 1:
                                            d += i.g + 2;
                                            break;
                                        case 2:
                                            c += i.f + 2;
                                            break;
                                        case 3:
                                            e += i.g + 2;
                                            break;
                                        case 4:
                                            f += i.f + 2;
                                    }
                                }
                                h = $wnd.Math.max(d, e);
                                g = $wnd.Math.max(c, f);
                            }
                            return Esd(a, h, g, true, true);
                        }
                        function Rqc(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
                            s = RD(zDb(PDb(CDb(new SDb(null, new Swb(b.d, 16)), new Vqc(c)), new Xqc(c)), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), vBb)
                            ]))), 15);
                            l = lve;
                            k = qwe;
                            for(i = new Anb(b.b.j); i.a < i.c.c.length;){
                                h = RD(ynb(i), 12);
                                if (h.j == c) {
                                    l = $wnd.Math.min(l, h.p);
                                    k = $wnd.Math.max(k, h.p);
                                }
                            }
                            if (l == lve) for(g = 0; g < s.gc(); g++)Umc(RD(s.Xb(g), 105), c, g);
                            else {
                                t = $C(kE, Pwe, 28, e.length, 15, 1);
                                Qnb(t, t.length);
                                for(r = s.Kc(); r.Ob();){
                                    q = RD(r.Pb(), 105);
                                    f = RD(Wjb(a.b, q), 183);
                                    j = 0;
                                    for(p = l; p <= k; p++)f[p] && (j = $wnd.Math.max(j, d[p]));
                                    if (q.i) {
                                        n = q.i.c;
                                        u = new _sb;
                                        for(m = 0; m < e.length; m++)e[n][m] && Ysb(u, sgb(t[m]));
                                        while(Zsb(u, sgb(j)))++j;
                                    }
                                    Umc(q, c, j);
                                    for(o = l; o <= k; o++)f[o] && (d[o] = j + 1);
                                    !!q.i && (t[q.i.c] = j);
                                }
                            }
                        }
                        function wOc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
                            e = null;
                            for(d = new Anb(b.a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 10);
                                BOc(c) ? f = (h = eJb(fJb(new gJb, c), a.f), i = eJb(fJb(new gJb, c), a.f), j = new ROc(c, true, h, i), k = c.o.b, l = (wDc(), (!c.q ? (yob(), yob(), wob) : c.q)._b((yCc(), iBc)) ? m = RD(mQb(c, iBc), 203) : m = RD(mQb(Y2b(c), jBc), 203), m), n = 10000, l == sDc && (n = 1), o = rIb(uIb(tIb(sIb(vIb(new wIb, n), eE($wnd.Math.ceil(k))), h), i)), l == tDc && Ysb(a.d, o), xOc(a, hv(b3b(c, (qpd(), ppd))), j), xOc(a, b3b(c, Xod), j), j) : f = (p = eJb(fJb(new gJb, c), a.f), FDb(CDb(new SDb(null, new Swb(c.j, 16)), new cPc), new ePc(a, p)), new ROc(c, false, p, p));
                                a.i[c.p] = f;
                                if (e) {
                                    g = e.c.d.a + bFc(a.n, e.c, c) + c.d.d;
                                    e.b || (g += e.c.o.b);
                                    rIb(uIb(tIb(vIb(sIb(new wIb, eE($wnd.Math.ceil(g))), 0), e.d), f.a));
                                }
                                e = f;
                            }
                        }
                        function h_b(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n;
                            f = new t_b(b);
                            l = c_b(a, b, f);
                            n = $wnd.Math.max(Kfb(UD(mQb(b, (yCc(), FAc)))), 1);
                            for(k = new Anb(l.a); k.a < k.c.c.length;){
                                j = RD(ynb(k), 42);
                                i = g_b(RD(j.a, 8), RD(j.b, 8), n);
                                o = true;
                                o = o & l_b(c, new rjd(i.c, i.d));
                                o = o & l_b(c, Zid(new rjd(i.c, i.d), i.b, 0));
                                o = o & l_b(c, Zid(new rjd(i.c, i.d), 0, i.a));
                                l_b(c, Zid(new rjd(i.c, i.d), i.b, i.a));
                            }
                            m = f.d;
                            h = g_b(RD(l.b.a, 8), RD(l.b.b, 8), n);
                            if (m == (qpd(), ppd) || m == Xod) {
                                d.c[m.g] = $wnd.Math.min(d.c[m.g], h.d);
                                d.b[m.g] = $wnd.Math.max(d.b[m.g], h.d + h.a);
                            } else {
                                d.c[m.g] = $wnd.Math.min(d.c[m.g], h.c);
                                d.b[m.g] = $wnd.Math.max(d.b[m.g], h.c + h.b);
                            }
                            e = pxe;
                            g = f.c.i.d;
                            switch(m.g){
                                case 4:
                                    e = g.c;
                                    break;
                                case 2:
                                    e = g.b;
                                    break;
                                case 1:
                                    e = g.a;
                                    break;
                                case 3:
                                    e = g.d;
                            }
                            d.a[m.g] = $wnd.Math.max(d.a[m.g], e);
                            return f;
                        }
                        function W7b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
                            h = RD(Wjb(b.c, a), 468);
                            s = b.a.c;
                            i = b.a.c + b.a.b;
                            C = h.f;
                            D = h.a;
                            g = C < D;
                            p = new rjd(s, C);
                            t = new rjd(i, D);
                            e = (s + i) / 2;
                            q = new rjd(e, C);
                            u = new rjd(e, D);
                            f = X7b(a, C, D);
                            w = K3b(b.B);
                            A = new rjd(e, f);
                            B = K3b(b.D);
                            c = uid(cD(WC(l3, 1), Nve, 8, 0, [
                                w,
                                A,
                                B
                            ]));
                            n = false;
                            r = b.B.i;
                            if (!!r && !!r.c && h.d) {
                                j = g && r.p < r.c.a.c.length - 1 || !g && r.p > 0;
                                if (j) {
                                    if (j) {
                                        m = r.p;
                                        g ? ++m : --m;
                                        l = RD(Vmb(r.c.a, m), 10);
                                        d = Z7b(l);
                                        n = !(Did(d, w, c[0]) || yid(d, w, c[0]));
                                    }
                                } else n = true;
                            }
                            o = false;
                            v = b.D.i;
                            if (!!v && !!v.c && h.e) {
                                k = g && v.p > 0 || !g && v.p < v.c.a.c.length - 1;
                                if (k) {
                                    m = v.p;
                                    g ? --m : ++m;
                                    l = RD(Vmb(v.c.a, m), 10);
                                    d = Z7b(l);
                                    o = !(Did(d, c[0], B) || yid(d, c[0], B));
                                } else o = true;
                            }
                            n && o && Mub(a.a, A);
                            n || zjd(a.a, cD(WC(l3, 1), Nve, 8, 0, [
                                p,
                                q
                            ]));
                            o || zjd(a.a, cD(WC(l3, 1), Nve, 8, 0, [
                                u,
                                t
                            ]));
                        }
                        function MNc(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
                            n = b.c.length;
                            m = 0;
                            for(l = new Anb(a.b); l.a < l.c.c.length;){
                                k = RD(ynb(l), 30);
                                r = k.a;
                                if (r.c.length == 0) continue;
                                q = new Anb(r);
                                j = 0;
                                s = null;
                                e = RD(ynb(q), 10);
                                f = null;
                                while(e){
                                    f = RD(Vmb(b, e.p), 261);
                                    if (f.c >= 0) {
                                        i = null;
                                        h = new Jkb(k.a, j + 1);
                                        while(h.b < h.d.gc()){
                                            g = (sFb(h.b < h.d.gc()), RD(h.d.Xb(h.c = h.b++), 10));
                                            i = RD(Vmb(b, g.p), 261);
                                            if (i.d == f.d && i.c < f.c) break;
                                            else i = null;
                                        }
                                        if (i) {
                                            if (s) {
                                                $mb(d, e.p, sgb(RD(Vmb(d, e.p), 17).a - 1));
                                                RD(Vmb(c, s.p), 15).Mc(f);
                                            }
                                            f = YNc(f, e, n++);
                                            ZEb(b.c, f);
                                            Rmb(c, new bnb);
                                            if (s) {
                                                RD(Vmb(c, s.p), 15).Fc(f);
                                                Rmb(d, sgb(1));
                                            } else Rmb(d, sgb(0));
                                        }
                                    }
                                    o = null;
                                    if (q.a < q.c.c.length) {
                                        o = RD(ynb(q), 10);
                                        p = RD(Vmb(b, o.p), 261);
                                        RD(Vmb(c, e.p), 15).Fc(p);
                                        $mb(d, o.p, sgb(RD(Vmb(d, o.p), 17).a + 1));
                                    }
                                    f.d = m;
                                    f.c = j++;
                                    s = e;
                                    e = o;
                                }
                                ++m;
                            }
                        }
                        function I5b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n;
                            f = RD(mQb(a, (Ywc(), Awc)), 74);
                            if (!f) return;
                            d = a.a;
                            e = new sjd(c);
                            $id(e, M5b(a));
                            if (n2b(a.d.i, a.c.i)) {
                                m = a.c;
                                l = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                    m.n,
                                    m.a
                                ]));
                                ojd(l, c);
                            } else l = K3b(a.c);
                            Pub(d, l, d.a, d.a.a);
                            n = K3b(a.d);
                            mQb(a, Wwc) != null && $id(n, RD(mQb(a, Wwc), 8));
                            Pub(d, n, d.c.b, d.c);
                            Cjd(d, e);
                            g = IGd(f, true, true);
                            Kzd(g, RD(QHd((!f.b && (f.b = new Yie(E4, f, 4, 7)), f.b), 0), 84));
                            Lzd(g, RD(QHd((!f.c && (f.c = new Yie(E4, f, 5, 8)), f.c), 0), 84));
                            lsd(d, g);
                            for(k = new Anb(a.b); k.a < k.c.c.length;){
                                j = RD(ynb(k), 72);
                                h = RD(mQb(j, Awc), 135);
                                Cyd(h, j.o.a);
                                Ayd(h, j.o.b);
                                Byd(h, j.n.a + e.a, j.n.b + e.b);
                                Ixd(h, (Zcc(), Ycc), TD(mQb(j, Ycc)));
                            }
                            i = RD(mQb(a, (yCc(), RAc)), 75);
                            if (i) {
                                Cjd(i, e);
                                Ixd(f, RAc, i);
                            } else Ixd(f, RAc, null);
                            b == (Ymd(), Wmd) ? Ixd(f, yAc, Wmd) : Ixd(f, yAc, null);
                        }
                        function O3c(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
                            if (c.c.length != 0) {
                                o = new bnb;
                                for(n = new Anb(c); n.a < n.c.c.length;){
                                    m = RD(ynb(n), 27);
                                    Rmb(o, new rjd(m.i, m.j));
                                }
                                d.dh(b, 'Before removing overlaps');
                                while(p3c(a, c))n3c(a, c, false);
                                d.dh(b, 'After removing overlaps');
                                h = 0;
                                i = 0;
                                e = null;
                                if (c.c.length != 0) {
                                    e = (tFb(0, c.c.length), RD(c.c[0], 27));
                                    h = e.i - (tFb(0, o.c.length), RD(o.c[0], 8)).a;
                                    i = e.j - (tFb(0, o.c.length), RD(o.c[0], 8)).b;
                                }
                                g = $wnd.Math.sqrt(h * h + i * i);
                                l = M2c(c);
                                f = 1;
                                if (l.a.gc() != 0) {
                                    for(k = l.a.ec().Kc(); k.Ob();){
                                        j = RD(k.Pb(), 27);
                                        p = a.f;
                                        q = p.i + p.g / 2;
                                        r = p.j + p.f / 2;
                                        s = j.i + j.g / 2;
                                        t = j.j + j.f / 2;
                                        u = s - q;
                                        v = t - r;
                                        w = $wnd.Math.sqrt(u * u + v * v);
                                        A = u / w;
                                        B = v / w;
                                        Dyd(j, j.i + A * g);
                                        Eyd(j, j.j + B * g);
                                    }
                                    d.dh(b, 'Child movement ' + f);
                                    ++f;
                                }
                                !!a.a && a.a.Gg(new dnb(l));
                                O3c(a, b, new dnb(l), d);
                            }
                        }
                        function Fid(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            i = a;
                            k = ojd(new rjd(b.a, b.b), a);
                            j = c;
                            l = ojd(new rjd(d.a, d.b), c);
                            m = i.a;
                            q = i.b;
                            o = j.a;
                            s = j.b;
                            n = k.a;
                            r = k.b;
                            p = l.a;
                            t = l.b;
                            e = p * r - n * t;
                            Zy();
                            bz(vEe);
                            if ($wnd.Math.abs(0 - e) <= vEe || 0 == e || isNaN(0) && isNaN(e)) return false;
                            g = 1 / e * ((m - o) * r - (q - s) * n);
                            h = 1 / e * -(-(m - o) * t + (q - s) * p);
                            f = (bz(vEe), ($wnd.Math.abs(0 - g) <= vEe || 0 == g || isNaN(0) && isNaN(g) ? 0 : 0 < g ? -1 : 0 > g ? 1 : cz(isNaN(0), isNaN(g))) < 0 && (bz(vEe), ($wnd.Math.abs(g - 1) <= vEe || g == 1 || isNaN(g) && isNaN(1) ? 0 : g < 1 ? -1 : g > 1 ? 1 : cz(isNaN(g), isNaN(1))) < 0) && (bz(vEe), ($wnd.Math.abs(0 - h) <= vEe || 0 == h || isNaN(0) && isNaN(h) ? 0 : 0 < h ? -1 : 0 > h ? 1 : cz(isNaN(0), isNaN(h))) < 0) && (bz(vEe), ($wnd.Math.abs(h - 1) <= vEe || h == 1 || isNaN(h) && isNaN(1) ? 0 : h < 1 ? -1 : h > 1 ? 1 : cz(isNaN(h), isNaN(1))) < 0));
                            return f;
                        }
                        function EXd(b) {
                            var c, d, e, f;
                            d = b.D != null ? b.D : b.B;
                            c = qhb(d, Fhb(91));
                            if (c != -1) {
                                e = (AFb(0, c, d.length), d.substr(0, c));
                                f = new Qhb;
                                do f.a += '[';
                                while ((c = phb(d, 91, ++c)) != -1);
                                if (lhb(e, hve)) f.a += 'Z';
                                else if (lhb(e, dKe)) f.a += 'B';
                                else if (lhb(e, eKe)) f.a += 'C';
                                else if (lhb(e, fKe)) f.a += 'D';
                                else if (lhb(e, gKe)) f.a += 'F';
                                else if (lhb(e, hKe)) f.a += 'I';
                                else if (lhb(e, iKe)) f.a += 'J';
                                else if (lhb(e, jKe)) f.a += 'S';
                                else {
                                    f.a += 'L';
                                    f.a += '' + e;
                                    f.a += ';';
                                }
                                try {
                                    return null;
                                } catch (a) {
                                    a = zdb(a);
                                    if (!ZD(a, 63)) throw Adb(a);
                                }
                            } else if (qhb(d, Fhb(46)) == -1) {
                                if (lhb(d, hve)) return xdb;
                                else if (lhb(d, dKe)) return gE;
                                else if (lhb(d, eKe)) return hE;
                                else if (lhb(d, fKe)) return iE;
                                else if (lhb(d, gKe)) return jE;
                                else if (lhb(d, hKe)) return kE;
                                else if (lhb(d, iKe)) return lE;
                                else if (lhb(d, jKe)) return wdb;
                            }
                            return null;
                        }
                        function pTb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A;
                            a.e = b;
                            h = RSb(b);
                            w = new bnb;
                            for(d = new Anb(h); d.a < d.c.c.length;){
                                c = RD(ynb(d), 15);
                                A = new bnb;
                                ZEb(w.c, A);
                                i = new _sb;
                                for(o = c.Kc(); o.Ob();){
                                    n = RD(o.Pb(), 27);
                                    f = nTb(a, n, true, 0, 0);
                                    ZEb(A.c, f);
                                    p = n.i;
                                    q = n.j;
                                    new rjd(p, q);
                                    m = (!n.n && (n.n = new C5d(I4, n, 1, 7)), n.n);
                                    for(l = new dMd(m); l.e != l.i.gc();){
                                        j = RD(bMd(l), 135);
                                        e = nTb(a, j, false, p, q);
                                        ZEb(A.c, e);
                                    }
                                    v = (!n.c && (n.c = new C5d(K4, n, 9, 9)), n.c);
                                    for(s = new dMd(v); s.e != s.i.gc();){
                                        r = RD(bMd(s), 123);
                                        g = nTb(a, r, false, p, q);
                                        ZEb(A.c, g);
                                        t = r.i + p;
                                        u = r.j + q;
                                        m = (!r.n && (r.n = new C5d(I4, r, 1, 7)), r.n);
                                        for(k = new dMd(m); k.e != k.i.gc();){
                                            j = RD(bMd(k), 135);
                                            e = nTb(a, j, false, t, u);
                                            ZEb(A.c, e);
                                        }
                                    }
                                    ye(i, Ux(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                        zGd(n),
                                        yGd(n)
                                    ]))));
                                }
                                mTb(a, i, A);
                            }
                            a.f = new TRb(w);
                            kQb(a.f, b);
                            return a.f;
                        }
                        function Yje(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
                            for(l = new Dub(new wub(a)); l.c != l.d.a.d;){
                                k = Cub(l);
                                h = RD(k.d, 58);
                                b = RD(k.e, 58);
                                g = h.Dh();
                                for(p = 0, u = (g.i == null && rYd(g), g.i).length; p < u; ++p){
                                    j = (f = (g.i == null && rYd(g), g.i), p >= 0 && p < f.length ? f[p] : null);
                                    if (j.rk() && !j.sk()) {
                                        if (ZD(j, 102)) {
                                            i = RD(j, 19);
                                            (i.Bb & QHe) == 0 && (w = Z5d(i), !(!!w && (w.Bb & QHe) != 0)) && Xje(a, i, h, b);
                                        } else {
                                            nke();
                                            if (RD(j, 69).xk()) {
                                                c = (v = j, RD(!v ? null : RD(b, 54).gi(v), 160));
                                                if (c) {
                                                    n = RD(h.Mh(j), 160);
                                                    d = c.gc();
                                                    for(q = 0, o = n.gc(); q < o; ++q){
                                                        m = n.Tl(q);
                                                        if (ZD(m, 102)) {
                                                            t = n.Ul(q);
                                                            e = cub(a, t);
                                                            if (e == null && t != null) {
                                                                s = RD(m, 19);
                                                                if (!a.b || (s.Bb & QHe) != 0 || !!Z5d(s)) continue;
                                                                e = t;
                                                            }
                                                            if (!c.Ol(m, e)) {
                                                                for(r = 0; r < d; ++r)if (c.Tl(r) == m && dE(c.Ul(r)) === dE(e)) {
                                                                    c.Ti(c.gc() - 1, r);
                                                                    --d;
                                                                    break;
                                                                }
                                                            }
                                                        } else c.Ol(n.Tl(q), n.Ul(q));
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        function gIc(a, b, c) {
                            var d;
                            c.Ug('StretchWidth layering', 1);
                            if (b.a.c.length == 0) {
                                c.Vg();
                                return;
                            }
                            a.c = b;
                            a.t = 0;
                            a.u = 0;
                            a.i = oxe;
                            a.g = pxe;
                            a.d = Kfb(UD(mQb(b, (yCc(), TBc))));
                            aIc(a);
                            bIc(a);
                            $Hc(a);
                            fIc(a);
                            _Hc(a);
                            a.i = $wnd.Math.max(1, a.i);
                            a.g = $wnd.Math.max(1, a.g);
                            a.d = a.d / a.i;
                            a.f = a.g / a.i;
                            a.s = dIc(a);
                            d = new R4b(a.c);
                            Rmb(a.c.b, d);
                            a.r = bv(a.p);
                            a.n = Fnb(a.k, a.k.length);
                            while(a.r.c.length != 0){
                                a.o = hIc(a);
                                if (!a.o || cIc(a) && a.b.a.gc() != 0) {
                                    iIc(a, d);
                                    d = new R4b(a.c);
                                    Rmb(a.c.b, d);
                                    ye(a.a, a.b);
                                    a.b.a.$b();
                                    a.t = a.u;
                                    a.u = 0;
                                } else if (cIc(a)) {
                                    a.c.b.c.length = 0;
                                    d = new R4b(a.c);
                                    Rmb(a.c.b, d);
                                    a.t = 0;
                                    a.u = 0;
                                    a.b.a.$b();
                                    a.a.a.$b();
                                    ++a.f;
                                    a.r = bv(a.p);
                                    a.n = Fnb(a.k, a.k.length);
                                } else {
                                    g3b(a.o, d);
                                    Ymb(a.r, a.o);
                                    Ysb(a.b, a.o);
                                    a.t = a.t - a.k[a.o.p] * a.d + a.j[a.o.p];
                                    a.u += a.e[a.o.p] * a.d;
                                }
                            }
                            b.a.c.length = 0;
                            Eob(b.b);
                            c.Vg();
                        }
                        function sOc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l;
                            a.j = $C(kE, Pwe, 28, a.g, 15, 1);
                            a.o = new bnb;
                            FDb(EDb(new SDb(null, new Swb(a.e.b, 16)), new APc), new CPc(a));
                            a.a = $C(xdb, Hye, 28, a.b, 16, 1);
                            MDb(new SDb(null, new Swb(a.e.b, 16)), new RPc(a));
                            d = (l = new bnb, FDb(CDb(EDb(new SDb(null, new Swb(a.e.b, 16)), new HPc), new JPc(a)), new LPc(a, l)), l);
                            for(i = new Anb(d); i.a < i.c.c.length;){
                                h = RD(ynb(i), 515);
                                if (h.c.length <= 1) continue;
                                if (h.c.length == 2) {
                                    UOc(h);
                                    BOc((tFb(0, h.c.length), RD(h.c[0], 18)).d.i) || Rmb(a.o, h);
                                    continue;
                                }
                                if (TOc(h) || SOc(h, new FPc)) continue;
                                j = new Anb(h);
                                e = null;
                                while(j.a < j.c.c.length){
                                    b = RD(ynb(j), 18);
                                    c = a.c[b.p];
                                    !e || j.a >= j.c.c.length ? k = hOc((r3b(), p3b), o3b) : k = hOc((r3b(), o3b), o3b);
                                    k *= 2;
                                    f = c.a.g;
                                    c.a.g = $wnd.Math.max(f, f + (k - f));
                                    g = c.b.g;
                                    c.b.g = $wnd.Math.max(g, g + (k - g));
                                    e = b;
                                }
                            }
                        }
                        function qkc(a) {
                            var b, c, d, e;
                            FDb(CDb(new SDb(null, new Swb(a.a.b, 16)), new Qkc), new Skc);
                            okc(a);
                            FDb(CDb(new SDb(null, new Swb(a.a.b, 16)), new Ukc), new Wkc);
                            if (a.c == (Ymd(), Wmd)) {
                                FDb(CDb(EDb(new SDb(null, new Swb(new Xkb(a.f), 1)), new clc), new elc), new glc(a));
                                FDb(CDb(GDb(EDb(EDb(new SDb(null, new Swb(a.d.b, 16)), new klc), new mlc), new olc), new qlc), new slc(a));
                            }
                            e = new rjd(oxe, oxe);
                            b = new rjd(pxe, pxe);
                            for(d = new Anb(a.a.b); d.a < d.c.c.length;){
                                c = RD(ynb(d), 60);
                                e.a = $wnd.Math.min(e.a, c.d.c);
                                e.b = $wnd.Math.min(e.b, c.d.d);
                                b.a = $wnd.Math.max(b.a, c.d.c + c.d.b);
                                b.b = $wnd.Math.max(b.b, c.d.d + c.d.a);
                            }
                            $id(hjd(a.d.c), fjd(new rjd(e.a, e.b)));
                            $id(hjd(a.d.f), ojd(new rjd(b.a, b.b), e));
                            pkc(a, e, b);
                            akb(a.f);
                            akb(a.b);
                            akb(a.g);
                            akb(a.e);
                            a.a.a.c.length = 0;
                            a.a.b.c.length = 0;
                            a.a = null;
                            a.d = null;
                        }
                        function JGb(a, b) {
                            var c;
                            if (a.e) throw Adb(new dgb((lfb(lN), lye + lN.k + mye)));
                            if (!cGb(a.a, b)) throw Adb(new yz(nye + b + oye));
                            if (b == a.d) return a;
                            c = a.d;
                            a.d = b;
                            switch(c.g){
                                case 0:
                                    switch(b.g){
                                        case 2:
                                            GGb(a);
                                            break;
                                        case 1:
                                            OGb(a);
                                            GGb(a);
                                            break;
                                        case 4:
                                            UGb(a);
                                            GGb(a);
                                            break;
                                        case 3:
                                            UGb(a);
                                            OGb(a);
                                            GGb(a);
                                    }
                                    break;
                                case 2:
                                    switch(b.g){
                                        case 1:
                                            OGb(a);
                                            PGb(a);
                                            break;
                                        case 4:
                                            UGb(a);
                                            GGb(a);
                                            break;
                                        case 3:
                                            UGb(a);
                                            OGb(a);
                                            GGb(a);
                                    }
                                    break;
                                case 1:
                                    switch(b.g){
                                        case 2:
                                            OGb(a);
                                            PGb(a);
                                            break;
                                        case 4:
                                            OGb(a);
                                            UGb(a);
                                            GGb(a);
                                            break;
                                        case 3:
                                            OGb(a);
                                            UGb(a);
                                            OGb(a);
                                            GGb(a);
                                    }
                                    break;
                                case 4:
                                    switch(b.g){
                                        case 2:
                                            UGb(a);
                                            GGb(a);
                                            break;
                                        case 1:
                                            UGb(a);
                                            OGb(a);
                                            GGb(a);
                                            break;
                                        case 3:
                                            OGb(a);
                                            PGb(a);
                                    }
                                    break;
                                case 3:
                                    switch(b.g){
                                        case 2:
                                            OGb(a);
                                            UGb(a);
                                            GGb(a);
                                            break;
                                        case 1:
                                            OGb(a);
                                            UGb(a);
                                            OGb(a);
                                            GGb(a);
                                            break;
                                        case 4:
                                            OGb(a);
                                            PGb(a);
                                    }
                            }
                            return a;
                        }
                        function vYb(a, b) {
                            var c;
                            if (a.d) throw Adb(new dgb((lfb(eQ), lye + eQ.k + mye)));
                            if (!eYb(a.a, b)) throw Adb(new yz(nye + b + oye));
                            if (b == a.c) return a;
                            c = a.c;
                            a.c = b;
                            switch(c.g){
                                case 0:
                                    switch(b.g){
                                        case 2:
                                            sYb(a);
                                            break;
                                        case 1:
                                            zYb(a);
                                            sYb(a);
                                            break;
                                        case 4:
                                            DYb(a);
                                            sYb(a);
                                            break;
                                        case 3:
                                            DYb(a);
                                            zYb(a);
                                            sYb(a);
                                    }
                                    break;
                                case 2:
                                    switch(b.g){
                                        case 1:
                                            zYb(a);
                                            AYb(a);
                                            break;
                                        case 4:
                                            DYb(a);
                                            sYb(a);
                                            break;
                                        case 3:
                                            DYb(a);
                                            zYb(a);
                                            sYb(a);
                                    }
                                    break;
                                case 1:
                                    switch(b.g){
                                        case 2:
                                            zYb(a);
                                            AYb(a);
                                            break;
                                        case 4:
                                            zYb(a);
                                            DYb(a);
                                            sYb(a);
                                            break;
                                        case 3:
                                            zYb(a);
                                            DYb(a);
                                            zYb(a);
                                            sYb(a);
                                    }
                                    break;
                                case 4:
                                    switch(b.g){
                                        case 2:
                                            DYb(a);
                                            sYb(a);
                                            break;
                                        case 1:
                                            DYb(a);
                                            zYb(a);
                                            sYb(a);
                                            break;
                                        case 3:
                                            zYb(a);
                                            AYb(a);
                                    }
                                    break;
                                case 3:
                                    switch(b.g){
                                        case 2:
                                            zYb(a);
                                            DYb(a);
                                            sYb(a);
                                            break;
                                        case 1:
                                            zYb(a);
                                            DYb(a);
                                            zYb(a);
                                            sYb(a);
                                            break;
                                        case 4:
                                            zYb(a);
                                            AYb(a);
                                    }
                            }
                            return a;
                        }
                        function Csd(a, b) {
                            var c, d, e, f, g, h, i, j;
                            if (ZD(a.Eh(), 167)) {
                                Csd(RD(a.Eh(), 167), b);
                                b.a += ' > ';
                            } else b.a += 'Root ';
                            c = a.Dh().zb;
                            lhb(c.substr(0, 3), 'Elk') ? Zhb(b, (BFb(3, c.length + 1), c.substr(3))) : (b.a += '' + c, b);
                            e = a.jh();
                            if (e) {
                                Zhb((b.a += ' ', b), e);
                                return;
                            }
                            if (ZD(a, 366)) {
                                j = RD(a, 135).a;
                                if (j) {
                                    Zhb((b.a += ' ', b), j);
                                    return;
                                }
                            }
                            for(g = new dMd(a.kh()); g.e != g.i.gc();){
                                f = RD(bMd(g), 135);
                                j = f.a;
                                if (j) {
                                    Zhb((b.a += ' ', b), j);
                                    return;
                                }
                            }
                            if (ZD(a, 326)) {
                                d = RD(a, 74);
                                !d.b && (d.b = new Yie(E4, d, 4, 7));
                                if (d.b.i != 0 && (!d.c && (d.c = new Yie(E4, d, 5, 8)), d.c.i != 0)) {
                                    b.a += ' (';
                                    h = new mMd((!d.b && (d.b = new Yie(E4, d, 4, 7)), d.b));
                                    while(h.e != h.i.gc()){
                                        h.e > 0 && (b.a += pve, b);
                                        Csd(RD(bMd(h), 167), b);
                                    }
                                    b.a += SAe;
                                    i = new mMd((!d.c && (d.c = new Yie(E4, d, 5, 8)), d.c));
                                    while(i.e != i.i.gc()){
                                        i.e > 0 && (b.a += pve, b);
                                        Csd(RD(bMd(i), 167), b);
                                    }
                                    b.a += ')';
                                }
                            }
                        }
                        function LTb(a, b, c) {
                            var d, e, f, g, h, i, j, k;
                            for(i = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); i.e != i.i.gc();){
                                h = RD(bMd(i), 27);
                                for(e = new is(Mr(zGd(h).a.Kc(), new ir)); gs(e);){
                                    d = RD(hs(e), 74);
                                    !d.b && (d.b = new Yie(E4, d, 4, 7));
                                    if (!(d.b.i <= 1 && (!d.c && (d.c = new Yie(E4, d, 5, 8)), d.c.i <= 1))) throw Adb(new Ked('Graph must not contain hyperedges.'));
                                    if (!nzd(d) && h != AGd(RD(QHd((!d.c && (d.c = new Yie(E4, d, 5, 8)), d.c), 0), 84))) {
                                        j = new cUb;
                                        kQb(j, d);
                                        pQb(j, (JVb(), HVb), d);
                                        _Tb(j, RD(Wd(qtb(c.f, h)), 153));
                                        aUb(j, RD(Wjb(c, AGd(RD(QHd((!d.c && (d.c = new Yie(E4, d, 5, 8)), d.c), 0), 84))), 153));
                                        Rmb(b.c, j);
                                        for(g = new dMd((!d.n && (d.n = new C5d(I4, d, 1, 7)), d.n)); g.e != g.i.gc();){
                                            f = RD(bMd(g), 135);
                                            k = new iUb(j, f.a);
                                            kQb(k, f);
                                            pQb(k, HVb, f);
                                            k.e.a = $wnd.Math.max(f.g, 1);
                                            k.e.b = $wnd.Math.max(f.f, 1);
                                            hUb(k);
                                            Rmb(b.d, k);
                                        }
                                    }
                                }
                            }
                        }
                        function Vec(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            c.Ug('Node promotion heuristic', 1);
                            a.i = b;
                            a.r = RD(mQb(b, (yCc(), ZAc)), 243);
                            a.r != (aEc(), TDc) && a.r != UDc ? Tec(a) : Uec(a);
                            k = RD(mQb(a.i, YAc), 17).a;
                            f = new nfc;
                            switch(a.r.g){
                                case 2:
                                case 1:
                                    Yec(a, f);
                                    break;
                                case 3:
                                    a.r = _Dc;
                                    Yec(a, f);
                                    i = 0;
                                    for(h = new Anb(a.b); h.a < h.c.c.length;){
                                        g = RD(ynb(h), 17);
                                        i = $wnd.Math.max(i, g.a);
                                    }
                                    if (i > a.k) {
                                        a.r = VDc;
                                        Yec(a, f);
                                    }
                                    break;
                                case 4:
                                    a.r = _Dc;
                                    Yec(a, f);
                                    j = 0;
                                    for(e = new Anb(a.c); e.a < e.c.c.length;){
                                        d = UD(ynb(e));
                                        j = $wnd.Math.max(j, (uFb(d), d));
                                    }
                                    if (j > a.n) {
                                        a.r = YDc;
                                        Yec(a, f);
                                    }
                                    break;
                                case 6:
                                    m = eE($wnd.Math.ceil(a.g.length * k / 100));
                                    Yec(a, new qfc(m));
                                    break;
                                case 5:
                                    l = eE($wnd.Math.ceil(a.e * k / 100));
                                    Yec(a, new tfc(l));
                                    break;
                                case 8:
                                    Sec(a, true);
                                    break;
                                case 9:
                                    Sec(a, false);
                                    break;
                                default:
                                    Yec(a, f);
                            }
                            a.r != TDc && a.r != UDc ? Zec(a, b) : $ec(a, b);
                            c.Vg();
                        }
                        function $rc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            l = a.b;
                            k = new Jkb(l, 0);
                            Ikb(k, new R4b(a));
                            s = false;
                            g = 1;
                            while(k.b < k.d.gc()){
                                j = (sFb(k.b < k.d.gc()), RD(k.d.Xb(k.c = k.b++), 30));
                                p = (tFb(g, l.c.length), RD(l.c[g], 30));
                                q = bv(j.a);
                                r = q.c.length;
                                for(o = new Anb(q); o.a < o.c.c.length;){
                                    m = RD(ynb(o), 10);
                                    g3b(m, p);
                                }
                                if (s) {
                                    for(n = hv(q).Kc(); n.Ob();){
                                        m = RD(n.Pb(), 10);
                                        for(f = new Anb(bv(Z2b(m))); f.a < f.c.c.length;){
                                            e = RD(ynb(f), 18);
                                            X0b(e, true);
                                            pQb(a, (Ywc(), awc), (Geb(), true));
                                            d = osc(a, e, r);
                                            c = RD(mQb(m, Wvc), 313);
                                            t = RD(Vmb(d, d.c.length - 1), 18);
                                            c.k = t.c.i;
                                            c.n = t;
                                            c.b = e.d.i;
                                            c.c = e;
                                        }
                                    }
                                    s = false;
                                } else if (q.c.length != 0) {
                                    b = (tFb(0, q.c.length), RD(q.c[0], 10));
                                    if (b.k == (r3b(), l3b)) {
                                        s = true;
                                        g = -1;
                                    }
                                }
                                ++g;
                            }
                            h = new Jkb(a.b, 0);
                            while(h.b < h.d.gc()){
                                i = (sFb(h.b < h.d.gc()), RD(h.d.Xb(h.c = h.b++), 30));
                                i.a.c.length == 0 && Ckb(h);
                            }
                        }
                        function FJb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            l = new CLb(a);
                            _Mb(l, !(b == (Cmd(), Bmd) || b == xmd));
                            k = l.a;
                            m = new z3b;
                            for(e = (ZJb(), cD(WC(JN, 1), jwe, 237, 0, [
                                WJb,
                                XJb,
                                YJb
                            ])), g = 0, i = e.length; g < i; ++g){
                                c = e[g];
                                j = oKb(k, WJb, c);
                                !!j && (m.d = $wnd.Math.max(m.d, j.jf()));
                            }
                            for(d = cD(WC(JN, 1), jwe, 237, 0, [
                                WJb,
                                XJb,
                                YJb
                            ]), f = 0, h = d.length; f < h; ++f){
                                c = d[f];
                                j = oKb(k, YJb, c);
                                !!j && (m.a = $wnd.Math.max(m.a, j.jf()));
                            }
                            for(p = cD(WC(JN, 1), jwe, 237, 0, [
                                WJb,
                                XJb,
                                YJb
                            ]), r = 0, t = p.length; r < t; ++r){
                                n = p[r];
                                j = oKb(k, n, WJb);
                                !!j && (m.b = $wnd.Math.max(m.b, j.kf()));
                            }
                            for(o = cD(WC(JN, 1), jwe, 237, 0, [
                                WJb,
                                XJb,
                                YJb
                            ]), q = 0, s = o.length; q < s; ++q){
                                n = o[q];
                                j = oKb(k, n, YJb);
                                !!j && (m.c = $wnd.Math.max(m.c, j.kf()));
                            }
                            if (m.d > 0) {
                                m.d += k.n.d;
                                m.d += k.d;
                            }
                            if (m.a > 0) {
                                m.a += k.n.a;
                                m.a += k.d;
                            }
                            if (m.b > 0) {
                                m.b += k.n.b;
                                m.b += k.d;
                            }
                            if (m.c > 0) {
                                m.c += k.n.c;
                                m.c += k.d;
                            }
                            return m;
                        }
                        function u9b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o;
                            m = c.d;
                            l = c.c;
                            f = new rjd(c.f.a + c.d.b + c.d.c, c.f.b + c.d.d + c.d.a);
                            g = f.b;
                            for(j = new Anb(a.a); j.a < j.c.c.length;){
                                h = RD(ynb(j), 10);
                                if (h.k != (r3b(), m3b)) continue;
                                d = RD(mQb(h, (Ywc(), hwc)), 64);
                                e = RD(mQb(h, iwc), 8);
                                k = h.n;
                                switch(d.g){
                                    case 2:
                                        k.a = c.f.a + m.c - l.a;
                                        break;
                                    case 4:
                                        k.a = -l.a - m.b;
                                }
                                o = 0;
                                switch(d.g){
                                    case 2:
                                    case 4:
                                        if (b == (Bod(), xod)) {
                                            n = Kfb(UD(mQb(h, Jwc)));
                                            k.b = f.b * n - RD(mQb(h, (yCc(), zBc)), 8).b;
                                            o = k.b + e.b;
                                            U2b(h, false, true);
                                        } else if (b == wod) {
                                            k.b = Kfb(UD(mQb(h, Jwc))) - RD(mQb(h, (yCc(), zBc)), 8).b;
                                            o = k.b + e.b;
                                            U2b(h, false, true);
                                        }
                                }
                                g = $wnd.Math.max(g, o);
                            }
                            c.f.b += g - f.b;
                            for(i = new Anb(a.a); i.a < i.c.c.length;){
                                h = RD(ynb(i), 10);
                                if (h.k != (r3b(), m3b)) continue;
                                d = RD(mQb(h, (Ywc(), hwc)), 64);
                                k = h.n;
                                switch(d.g){
                                    case 1:
                                        k.b = -l.b - m.d;
                                        break;
                                    case 3:
                                        k.b = c.f.b + m.a - l.b;
                                }
                            }
                        }
                        function nNb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                            k = RD(RD(Qc(a.r, b), 21), 87);
                            if (k.gc() <= 2 || b == (qpd(), Xod) || b == (qpd(), ppd)) {
                                rNb(a, b);
                                return;
                            }
                            p = a.u.Hc((Pod(), Ood));
                            c = b == (qpd(), Yod) ? (mOb(), lOb) : (mOb(), iOb);
                            r = b == Yod ? (vLb(), sLb) : (vLb(), uLb);
                            d = WNb(_Nb(c), a.s);
                            q = b == Yod ? oxe : pxe;
                            for(j = k.Kc(); j.Ob();){
                                h = RD(j.Pb(), 117);
                                if (!h.c || h.c.d.c.length <= 0) continue;
                                o = h.b.Mf();
                                n = h.e;
                                l = h.c;
                                m = l.i;
                                m.b = (f = l.n, l.e.a + f.b + f.c);
                                m.a = (g = l.n, l.e.b + g.d + g.a);
                                if (p) {
                                    m.c = n.a - (e = l.n, l.e.a + e.b + e.c) - a.s;
                                    p = false;
                                } else m.c = n.a + o.a + a.s;
                                Ivb(r, Pye);
                                l.f = r;
                                RKb(l, (EKb(), DKb));
                                Rmb(d.d, new sOb(m, UNb(d, m)));
                                q = b == Yod ? $wnd.Math.min(q, n.b) : $wnd.Math.max(q, n.b + h.b.Mf().b);
                            }
                            q += b == Yod ? -a.t : a.t;
                            VNb((d.e = q, d));
                            for(i = k.Kc(); i.Ob();){
                                h = RD(i.Pb(), 117);
                                if (!h.c || h.c.d.c.length <= 0) continue;
                                m = h.c.i;
                                m.c -= h.e.a;
                                m.d -= h.e.b;
                            }
                        }
                        function D0b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            e = new bnb;
                            for(p = new Anb(b.a); p.a < p.c.c.length;){
                                o = RD(ynb(p), 10);
                                n = o.e;
                                if (n) {
                                    d = D0b(a, n, o);
                                    Tmb(e, d);
                                    A0b(a, n, o);
                                    if (RD(mQb(n, (Ywc(), kwc)), 21).Hc((ovc(), hvc))) {
                                        s = RD(mQb(o, (yCc(), BBc)), 101);
                                        m = RD(mQb(o, EBc), 181).Hc((Pod(), Lod));
                                        for(r = new Anb(o.j); r.a < r.c.c.length;){
                                            q = RD(ynb(r), 12);
                                            f = RD(Wjb(a.b, q), 10);
                                            if (!f) {
                                                f = f2b(q, s, q.j, -(q.e.c.length - q.g.c.length), null, new pjd, q.o, RD(mQb(n, rAc), 88), n);
                                                pQb(f, Awc, q);
                                                Zjb(a.b, q, f);
                                                Rmb(n.a, f);
                                            }
                                            g = RD(Vmb(f.j, 0), 12);
                                            for(k = new Anb(q.f); k.a < k.c.c.length;){
                                                j = RD(ynb(k), 72);
                                                h = new x2b;
                                                h.o.a = j.o.a;
                                                h.o.b = j.o.b;
                                                Rmb(g.f, h);
                                                if (!m) {
                                                    t = q.j;
                                                    l = 0;
                                                    Rod(RD(mQb(o, EBc), 21)) && (l = qsd(j.n, j.o, q.o, 0, t));
                                                    s == (Bod(), zod) || (qpd(), apd).Hc(t) ? h.o.a = l : h.o.b = l;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            i = new bnb;
                            z0b(a, b, c, e, i);
                            !!c && B0b(a, b, c, i);
                            return i;
                        }
                        function NIc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l;
                            if (a.c[b.c.p][b.p].e) return;
                            else a.c[b.c.p][b.p].e = true;
                            a.c[b.c.p][b.p].b = 0;
                            a.c[b.c.p][b.p].d = 0;
                            a.c[b.c.p][b.p].a = null;
                            for(k = new Anb(b.j); k.a < k.c.c.length;){
                                j = RD(ynb(k), 12);
                                l = c ? new T3b(j) : new _3b(j);
                                for(i = l.Kc(); i.Ob();){
                                    h = RD(i.Pb(), 12);
                                    g = h.i;
                                    if (g.c == b.c) {
                                        if (g != b) {
                                            NIc(a, g, c);
                                            a.c[b.c.p][b.p].b += a.c[g.c.p][g.p].b;
                                            a.c[b.c.p][b.p].d += a.c[g.c.p][g.p].d;
                                        }
                                    } else {
                                        a.c[b.c.p][b.p].d += a.g[h.p];
                                        ++a.c[b.c.p][b.p].b;
                                    }
                                }
                            }
                            f = RD(mQb(b, (Ywc(), Uvc)), 15);
                            if (f) for(e = f.Kc(); e.Ob();){
                                d = RD(e.Pb(), 10);
                                if (b.c == d.c) {
                                    NIc(a, d, c);
                                    a.c[b.c.p][b.p].b += a.c[d.c.p][d.p].b;
                                    a.c[b.c.p][b.p].d += a.c[d.c.p][d.p].d;
                                }
                            }
                            if (a.c[b.c.p][b.p].b > 0) {
                                a.c[b.c.p][b.p].d += Kwb(a.i, 24) * Nxe * 0.07000000029802322 - 0.03500000014901161;
                                a.c[b.c.p][b.p].a = a.c[b.c.p][b.p].d / a.c[b.c.p][b.p].b;
                            }
                        }
                        function D8b(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
                            for(o = new Anb(a); o.a < o.c.c.length;){
                                n = RD(ynb(o), 10);
                                E8b(n.n);
                                E8b(n.o);
                                F8b(n.f);
                                I8b(n);
                                K8b(n);
                                for(q = new Anb(n.j); q.a < q.c.c.length;){
                                    p = RD(ynb(q), 12);
                                    E8b(p.n);
                                    E8b(p.a);
                                    E8b(p.o);
                                    Q3b(p, J8b(p.j));
                                    f = RD(mQb(p, (yCc(), CBc)), 17);
                                    !!f && pQb(p, CBc, sgb(-f.a));
                                    for(e = new Anb(p.g); e.a < e.c.c.length;){
                                        d = RD(ynb(e), 18);
                                        for(c = Sub(d.a, 0); c.b != c.d.c;){
                                            b = RD(evb(c), 8);
                                            E8b(b);
                                        }
                                        i = RD(mQb(d, RAc), 75);
                                        if (i) for(h = Sub(i, 0); h.b != h.d.c;){
                                            g = RD(evb(h), 8);
                                            E8b(g);
                                        }
                                        for(l = new Anb(d.b); l.a < l.c.c.length;){
                                            j = RD(ynb(l), 72);
                                            E8b(j.n);
                                            E8b(j.o);
                                        }
                                    }
                                    for(m = new Anb(p.f); m.a < m.c.c.length;){
                                        j = RD(ynb(m), 72);
                                        E8b(j.n);
                                        E8b(j.o);
                                    }
                                }
                                if (n.k == (r3b(), m3b)) {
                                    pQb(n, (Ywc(), hwc), J8b(RD(mQb(n, hwc), 64)));
                                    H8b(n);
                                }
                                for(k = new Anb(n.b); k.a < k.c.c.length;){
                                    j = RD(ynb(k), 72);
                                    I8b(j);
                                    E8b(j.o);
                                    E8b(j.n);
                                }
                            }
                        }
                        function iEd(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
                            D = Wjb(a.e, d);
                            if (D == null) {
                                D = new uC;
                                n = RD(D, 190);
                                s = b + '_s';
                                t = s + e;
                                m = new OC(t);
                                sC(n, uIe, m);
                            }
                            C = RD(D, 190);
                            oDd(c, C);
                            G = new uC;
                            qDd(G, 'x', d.j);
                            qDd(G, 'y', d.k);
                            sC(C, xIe, G);
                            A = new uC;
                            qDd(A, 'x', d.b);
                            qDd(A, 'y', d.c);
                            sC(C, 'endPoint', A);
                            l = cve((!d.a && (d.a = new XZd(D4, d, 5)), d.a));
                            o = !l;
                            if (o) {
                                w = new MB;
                                f = new qFd(w);
                                xgb((!d.a && (d.a = new XZd(D4, d, 5)), d.a), f);
                                sC(C, nIe, w);
                            }
                            i = Dzd(d);
                            u = !!i;
                            u && rDd(a.a, C, pIe, KDd(a, Dzd(d)));
                            r = Ezd(d);
                            v = !!r;
                            v && rDd(a.a, C, oIe, KDd(a, Ezd(d)));
                            j = (!d.e && (d.e = new Yie(F4, d, 10, 9)), d.e).i == 0;
                            p = !j;
                            if (p) {
                                B = new MB;
                                g = new sFd(a, B);
                                xgb((!d.e && (d.e = new Yie(F4, d, 10, 9)), d.e), g);
                                sC(C, rIe, B);
                            }
                            k = (!d.g && (d.g = new Yie(F4, d, 9, 10)), d.g).i == 0;
                            q = !k;
                            if (q) {
                                F = new MB;
                                h = new uFd(a, F);
                                xgb((!d.g && (d.g = new Yie(F4, d, 9, 10)), d.g), h);
                                sC(C, qIe, F);
                            }
                        }
                        function XMb(a) {
                            RMb();
                            var b, c, d, e, f, g, h;
                            d = a.f.n;
                            for(g = ki(a.r).a.nc(); g.Ob();){
                                f = RD(g.Pb(), 117);
                                e = 0;
                                if (f.b.pf((umd(), Gld))) {
                                    e = Kfb(UD(f.b.of(Gld)));
                                    if (e < 0) switch(f.b.ag().g){
                                        case 1:
                                            d.d = $wnd.Math.max(d.d, -e);
                                            break;
                                        case 3:
                                            d.a = $wnd.Math.max(d.a, -e);
                                            break;
                                        case 2:
                                            d.c = $wnd.Math.max(d.c, -e);
                                            break;
                                        case 4:
                                            d.b = $wnd.Math.max(d.b, -e);
                                    }
                                }
                                if (Rod(a.u)) {
                                    b = rsd(f.b, e);
                                    h = !RD(a.e.of(pld), 181).Hc((dqd(), Wpd));
                                    c = false;
                                    switch(f.b.ag().g){
                                        case 1:
                                            c = b > d.d;
                                            d.d = $wnd.Math.max(d.d, b);
                                            if (h && c) {
                                                d.d = $wnd.Math.max(d.d, d.a);
                                                d.a = d.d + e;
                                            }
                                            break;
                                        case 3:
                                            c = b > d.a;
                                            d.a = $wnd.Math.max(d.a, b);
                                            if (h && c) {
                                                d.a = $wnd.Math.max(d.a, d.d);
                                                d.d = d.a + e;
                                            }
                                            break;
                                        case 2:
                                            c = b > d.c;
                                            d.c = $wnd.Math.max(d.c, b);
                                            if (h && c) {
                                                d.c = $wnd.Math.max(d.b, d.c);
                                                d.b = d.c + e;
                                            }
                                            break;
                                        case 4:
                                            c = b > d.b;
                                            d.b = $wnd.Math.max(d.b, b);
                                            if (h && c) {
                                                d.b = $wnd.Math.max(d.b, d.c);
                                                d.c = d.b + e;
                                            }
                                    }
                                }
                            }
                        }
                        function pA(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            j = '';
                            if (b.length == 0) return a.ne(ywe, wwe, -1, -1);
                            k = Dhb(b);
                            lhb(k.substr(0, 3), 'at ') && (k = (BFb(3, k.length + 1), k.substr(3)));
                            k = k.replace(/\[.*?\]/g, '');
                            g = k.indexOf('(');
                            if (g == -1) {
                                g = k.indexOf('@');
                                if (g == -1) {
                                    j = k;
                                    k = '';
                                } else {
                                    j = Dhb((BFb(g + 1, k.length + 1), k.substr(g + 1)));
                                    k = Dhb((AFb(0, g, k.length), k.substr(0, g)));
                                }
                            } else {
                                c = k.indexOf(')', g);
                                j = (AFb(g + 1, c, k.length), k.substr(g + 1, c - (g + 1)));
                                k = Dhb((AFb(0, g, k.length), k.substr(0, g)));
                            }
                            g = qhb(k, Fhb(46));
                            g != -1 && (k = (BFb(g + 1, k.length + 1), k.substr(g + 1)));
                            (k.length == 0 || lhb(k, 'Anonymous function')) && (k = wwe);
                            h = thb(j, Fhb(58));
                            e = uhb(j, Fhb(58), h - 1);
                            i = -1;
                            d = -1;
                            f = ywe;
                            if (h != -1 && e != -1) {
                                f = (AFb(0, e, j.length), j.substr(0, e));
                                i = jA((AFb(e + 1, h, j.length), j.substr(e + 1, h - (e + 1))));
                                d = jA((BFb(h + 1, j.length + 1), j.substr(h + 1)));
                            }
                            return a.ne(f, k, i, d);
                        }
                        function C6b(a) {
                            var b, c, d, e, f, g, h, i, j, k, l;
                            for(j = new Anb(a); j.a < j.c.c.length;){
                                i = RD(ynb(j), 10);
                                g = RD(mQb(i, (yCc(), UAc)), 171);
                                f = null;
                                switch(g.g){
                                    case 1:
                                    case 2:
                                        f = (huc(), guc);
                                        break;
                                    case 3:
                                    case 4:
                                        f = (huc(), euc);
                                }
                                if (f) {
                                    pQb(i, (Ywc(), bwc), (huc(), guc));
                                    f == euc ? F6b(i, g, (BEc(), yEc)) : f == guc && F6b(i, g, (BEc(), zEc));
                                } else if (Dod(RD(mQb(i, BBc), 101)) && i.j.c.length != 0) {
                                    b = true;
                                    for(l = new Anb(i.j); l.a < l.c.c.length;){
                                        k = RD(ynb(l), 12);
                                        if (!(k.j == (qpd(), Xod) && k.e.c.length - k.g.c.length > 0 || k.j == ppd && k.e.c.length - k.g.c.length < 0)) {
                                            b = false;
                                            break;
                                        }
                                        for(e = new Anb(k.g); e.a < e.c.c.length;){
                                            c = RD(ynb(e), 18);
                                            h = RD(mQb(c.d.i, UAc), 171);
                                            if (h == (cxc(), _wc) || h == axc) {
                                                b = false;
                                                break;
                                            }
                                        }
                                        for(d = new Anb(k.e); d.a < d.c.c.length;){
                                            c = RD(ynb(d), 18);
                                            h = RD(mQb(c.c.i, UAc), 171);
                                            if (h == (cxc(), Zwc) || h == $wc) {
                                                b = false;
                                                break;
                                            }
                                        }
                                    }
                                    b && F6b(i, g, (BEc(), AEc));
                                }
                            }
                        }
                        function LNc(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
                            w = 0;
                            n = 0;
                            for(l = new Anb(b.e); l.a < l.c.c.length;){
                                k = RD(ynb(l), 10);
                                m = 0;
                                h = 0;
                                i = c ? RD(mQb(k, HNc), 17).a : qwe;
                                r = d ? RD(mQb(k, INc), 17).a : qwe;
                                j = $wnd.Math.max(i, r);
                                for(t = new Anb(k.j); t.a < t.c.c.length;){
                                    s = RD(ynb(t), 12);
                                    u = k.n.b + s.n.b + s.a.b;
                                    if (d) for(g = new Anb(s.g); g.a < g.c.c.length;){
                                        f = RD(ynb(g), 18);
                                        p = f.d;
                                        o = p.i;
                                        if (b != a.a[o.p]) {
                                            q = $wnd.Math.max(RD(mQb(o, HNc), 17).a, RD(mQb(o, INc), 17).a);
                                            v = RD(mQb(f, (yCc(), MBc)), 17).a;
                                            if (v >= j && v >= q) {
                                                m += o.n.b + p.n.b + p.a.b - u;
                                                ++h;
                                            }
                                        }
                                    }
                                    if (c) for(g = new Anb(s.e); g.a < g.c.c.length;){
                                        f = RD(ynb(g), 18);
                                        p = f.c;
                                        o = p.i;
                                        if (b != a.a[o.p]) {
                                            q = $wnd.Math.max(RD(mQb(o, HNc), 17).a, RD(mQb(o, INc), 17).a);
                                            v = RD(mQb(f, (yCc(), MBc)), 17).a;
                                            if (v >= j && v >= q) {
                                                m += o.n.b + p.n.b + p.a.b - u;
                                                ++h;
                                            }
                                        }
                                    }
                                }
                                if (h > 0) {
                                    w += m / h;
                                    ++n;
                                }
                            }
                            if (n > 0) {
                                b.a = e * w / n;
                                b.g = n;
                            } else {
                                b.a = 0;
                                b.g = 0;
                            }
                        }
                        function hTb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A;
                            f = a.f.b;
                            m = f.a;
                            k = f.b;
                            o = a.e.g;
                            n = a.e.f;
                            zyd(a.e, f.a, f.b);
                            w = m / o;
                            A = k / n;
                            for(j = new dMd(iyd(a.e)); j.e != j.i.gc();){
                                i = RD(bMd(j), 135);
                                Dyd(i, i.i * w);
                                Eyd(i, i.j * A);
                            }
                            for(s = new dMd(wCd(a.e)); s.e != s.i.gc();){
                                r = RD(bMd(s), 123);
                                u = r.i;
                                v = r.j;
                                u > 0 && Dyd(r, u * w);
                                v > 0 && Eyd(r, v * A);
                            }
                            Bvb(a.b, new tTb);
                            b = new bnb;
                            for(h = new vkb(new mkb(a.c).a); h.b;){
                                g = tkb(h);
                                d = RD(g.ld(), 74);
                                c = RD(g.md(), 407).a;
                                e = IGd(d, false, false);
                                l = fTb(JGd(d), ssd(e), c);
                                lsd(l, e);
                                t = KGd(d);
                                if (!!t && Wmb(b, t, 0) == -1) {
                                    ZEb(b.c, t);
                                    gTb(t, (sFb(l.b != 0), RD(l.a.a.c, 8)), c);
                                }
                            }
                            for(q = new vkb(new mkb(a.d).a); q.b;){
                                p = tkb(q);
                                d = RD(p.ld(), 74);
                                c = RD(p.md(), 407).a;
                                e = IGd(d, false, false);
                                l = fTb(LGd(d), Ijd(ssd(e)), c);
                                l = Ijd(l);
                                lsd(l, e);
                                t = MGd(d);
                                if (!!t && Wmb(b, t, 0) == -1) {
                                    ZEb(b.c, t);
                                    gTb(t, (sFb(l.b != 0), RD(l.c.b.c, 8)), c);
                                }
                            }
                        }
                        function GJb(a, b, c, d) {
                            var e, f, g, h, i;
                            h = new CLb(b);
                            iNb(h, d);
                            e = true;
                            if (!!a && a.pf((umd(), Nkd))) {
                                f = RD(a.of((umd(), Nkd)), 88);
                                e = f == (Cmd(), Amd) || f == ymd || f == zmd;
                            }
                            $Mb(h, false);
                            Umb(h.e.Rf(), new dNb(h, false, e));
                            EMb(h, h.f, (ZJb(), WJb), (qpd(), Yod));
                            EMb(h, h.f, YJb, npd);
                            EMb(h, h.g, WJb, ppd);
                            EMb(h, h.g, YJb, Xod);
                            GMb(h, Yod);
                            GMb(h, npd);
                            FMb(h, Xod);
                            FMb(h, ppd);
                            RMb();
                            g = h.A.Hc((Qpd(), Mpd)) && h.B.Hc((dqd(), $pd)) ? SMb(h) : null;
                            !!g && uKb(h.a, g);
                            XMb(h);
                            xMb(h);
                            GNb(h);
                            sMb(h);
                            gNb(h);
                            yNb(h);
                            oNb(h, Yod);
                            oNb(h, npd);
                            tMb(h);
                            fNb(h);
                            if (!c) return h.o;
                            VMb(h);
                            CNb(h);
                            oNb(h, Xod);
                            oNb(h, ppd);
                            i = h.B.Hc((dqd(), _pd));
                            IMb(h, i, Yod);
                            IMb(h, i, npd);
                            JMb(h, i, Xod);
                            JMb(h, i, ppd);
                            FDb(new SDb(null, new Swb(new glb(h.i), 0)), new KMb);
                            FDb(CDb(new SDb(null, ki(h.r).a.oc()), new MMb), new OMb);
                            WMb(h);
                            h.e.Pf(h.o);
                            FDb(new SDb(null, ki(h.r).a.oc()), new YMb);
                            return h.o;
                        }
                        function LYb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p;
                            j = oxe;
                            for(d = new Anb(a.a.b); d.a < d.c.c.length;){
                                b = RD(ynb(d), 86);
                                j = $wnd.Math.min(j, b.d.f.g.c + b.e.a);
                            }
                            n = new Yub;
                            for(g = new Anb(a.a.a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 194);
                                f.i = j;
                                f.e == 0 && Pub(n, f, n.c.b, n.c);
                            }
                            while(n.b != 0){
                                f = RD(n.b == 0 ? null : (sFb(n.b != 0), Wub(n, n.a.a)), 194);
                                e = f.f.g.c;
                                for(m = f.a.a.ec().Kc(); m.Ob();){
                                    k = RD(m.Pb(), 86);
                                    p = f.i + k.e.a;
                                    k.d.g || k.g.c < p ? k.o = p : k.o = k.g.c;
                                }
                                e -= f.f.o;
                                f.b += e;
                                a.c == (Cmd(), zmd) || a.c == xmd ? f.c += e : f.c -= e;
                                for(l = f.a.a.ec().Kc(); l.Ob();){
                                    k = RD(l.Pb(), 86);
                                    for(i = k.f.Kc(); i.Ob();){
                                        h = RD(i.Pb(), 86);
                                        Dmd(a.c) ? o = a.f.yf(k, h) : o = a.f.zf(k, h);
                                        h.d.i = $wnd.Math.max(h.d.i, k.o + k.g.b + o - h.e.a);
                                        h.k || (h.d.i = $wnd.Math.max(h.d.i, h.g.c - h.e.a));
                                        --h.d.e;
                                        h.d.e == 0 && Mub(n, h.d);
                                    }
                                }
                            }
                            for(c = new Anb(a.a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 86);
                                b.g.c = b.o;
                            }
                        }
                        function vOb(a) {
                            var b, c, d, e, f, g, h, i;
                            h = a.b;
                            b = a.a;
                            switch(RD(mQb(a, (YHb(), UHb)), 435).g){
                                case 0:
                                    _mb(h, new Frb(new UOb));
                                    break;
                                case 1:
                                default:
                                    _mb(h, new Frb(new ZOb));
                            }
                            switch(RD(mQb(a, SHb), 436).g){
                                case 1:
                                    _mb(h, new POb);
                                    _mb(h, new cPb);
                                    _mb(h, new xOb);
                                    break;
                                case 0:
                                default:
                                    _mb(h, new POb);
                                    _mb(h, new IOb);
                            }
                            switch(RD(mQb(a, WHb), 257).g){
                                case 0:
                                    i = new wPb;
                                    break;
                                case 1:
                                    i = new qPb;
                                    break;
                                case 2:
                                    i = new tPb;
                                    break;
                                case 3:
                                    i = new nPb;
                                    break;
                                case 5:
                                    i = new APb(new tPb);
                                    break;
                                case 4:
                                    i = new APb(new qPb);
                                    break;
                                case 7:
                                    i = new kPb(new APb(new qPb), new APb(new tPb));
                                    break;
                                case 8:
                                    i = new kPb(new APb(new nPb), new APb(new tPb));
                                    break;
                                case 6:
                                default:
                                    i = new APb(new nPb);
                            }
                            for(g = new Anb(h); g.a < g.c.c.length;){
                                f = RD(ynb(g), 176);
                                d = 0;
                                e = 0;
                                c = new Ptd(sgb(d), sgb(e));
                                while(ZPb(b, f, d, e)){
                                    c = RD(i.Ve(c, f), 42);
                                    d = RD(c.a, 17).a;
                                    e = RD(c.b, 17).a;
                                }
                                WPb(b, f, d, e);
                            }
                        }
                        function T_c(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
                            c.Ug(_Ee, 1);
                            m = (q$c(), XZc);
                            a.a == (s_c(), p_c) && (m = VZc);
                            k = 0;
                            yob();
                            b.jd(new uGd(m));
                            f = b.gc();
                            h = b.fd(b.gc());
                            j = true;
                            while(j && h.Sb()){
                                s = RD(h.Ub(), 40);
                                RD(mQb(s, m), 17).a == 0 ? --f : j = false;
                            }
                            w = b.kd(0, f);
                            g = new Zub(w);
                            w = b.kd(f, b.gc());
                            i = new Zub(w);
                            if (g.b == 0) for(p = Sub(i, 0); p.b != p.d.c;){
                                o = RD(evb(p), 40);
                                pQb(o, i$c, sgb(k++));
                            }
                            else {
                                l = g.b;
                                for(v = Sub(g, 0); v.b != v.d.c;){
                                    u = RD(evb(v), 40);
                                    pQb(u, i$c, sgb(k++));
                                    d = $Wc(u);
                                    T_c(a, d, c.eh(1 / l | 0));
                                    tvb(d, Fob(new uGd(i$c)));
                                    n = new Yub;
                                    for(t = Sub(d, 0); t.b != t.d.c;){
                                        s = RD(evb(t), 40);
                                        for(r = Sub(u.d, 0); r.b != r.d.c;){
                                            q = RD(evb(r), 65);
                                            q.c == s && Pub(n, q, n.c.b, n.c);
                                        }
                                    }
                                    Xub(u.d);
                                    ye(u.d, n);
                                    h = Sub(i, i.b);
                                    e = u.d.b;
                                    j = true;
                                    while(0 < e && j && h.Sb()){
                                        s = RD(h.Ub(), 40);
                                        if (RD(mQb(s, m), 17).a == 0) {
                                            pQb(s, i$c, sgb(k++));
                                            --e;
                                            h.Qb();
                                        } else j = false;
                                    }
                                }
                            }
                            c.Vg();
                        }
                        function S3c(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n;
                            l = Kfb(UD(Gxd(a, ($4c(), W4c))));
                            if (Heb(TD(Gxd(a, U4c)))) {
                                k = RD(Gxd(a, (u2c(), t2c)), 27);
                                f = RD(QHd(mzd(RD(QHd((!k.e && (k.e = new Yie(G4, k, 7, 4)), k.e), (!k.e && (k.e = new Yie(G4, k, 7, 4)), k.e).i - 1), 74)), 0), 27);
                                d = RD(QHd(mzd(RD(QHd((!k.e && (k.e = new Yie(G4, k, 7, 4)), k.e), 0), 74)), 0), 27);
                                g = new rjd(f.i + f.g / 2, f.j + f.f / 2);
                                e = new rjd(d.i + d.g / 2, d.j + d.f / 2);
                                c = l;
                                c <= 0 && (c += dFe);
                                m = $wnd.Math.acos((g.a * e.a + g.b * e.b) / ($wnd.Math.sqrt(g.a * g.a + g.b * g.b) * $wnd.Math.sqrt(e.a * e.a + e.b * e.b)));
                                m <= 0 && (m += dFe);
                                b = $wnd.Math.atan2(g.b, g.a);
                                b <= 0 && (b += dFe);
                                l = FEe - (b - c + m / 2);
                            }
                            for(i = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); i.e != i.i.gc();){
                                h = RD(bMd(i), 27);
                                j = new rjd(h.i + h.g / 2, h.j + h.f / 2);
                                n = j.a * $wnd.Math.cos(l) - j.b * $wnd.Math.sin(l);
                                j.b = j.a * $wnd.Math.sin(l) + j.b * $wnd.Math.cos(l);
                                j.a = n;
                                Byd(h, j.a - h.g / 2, j.b - h.f / 2);
                            }
                        }
                        function qcc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            b.Ug('Inverted port preprocessing', 1);
                            k = a.b;
                            j = new Jkb(k, 0);
                            c = null;
                            t = new bnb;
                            while(j.b < j.d.gc()){
                                s = c;
                                c = (sFb(j.b < j.d.gc()), RD(j.d.Xb(j.c = j.b++), 30));
                                for(n = new Anb(t); n.a < n.c.c.length;){
                                    l = RD(ynb(n), 10);
                                    g3b(l, s);
                                }
                                t.c.length = 0;
                                for(o = new Anb(c.a); o.a < o.c.c.length;){
                                    l = RD(ynb(o), 10);
                                    if (l.k != (r3b(), p3b)) continue;
                                    if (!Dod(RD(mQb(l, (yCc(), BBc)), 101))) continue;
                                    for(r = d3b(l, (BEc(), yEc), (qpd(), Xod)).Kc(); r.Ob();){
                                        p = RD(r.Pb(), 12);
                                        i = p.e;
                                        h = RD(anb(i, $C(WQ, VAe, 18, i.c.length, 0, 1)), 483);
                                        for(e = h, f = 0, g = e.length; f < g; ++f){
                                            d = e[f];
                                            occ(a, p, d, t);
                                        }
                                    }
                                    for(q = d3b(l, zEc, ppd).Kc(); q.Ob();){
                                        p = RD(q.Pb(), 12);
                                        i = p.g;
                                        h = RD(anb(i, $C(WQ, VAe, 18, i.c.length, 0, 1)), 483);
                                        for(e = h, f = 0, g = e.length; f < g; ++f){
                                            d = e[f];
                                            pcc(a, p, d, t);
                                        }
                                    }
                                }
                            }
                            for(m = new Anb(t); m.a < m.c.c.length;){
                                l = RD(ynb(m), 10);
                                g3b(l, c);
                            }
                            b.Vg();
                        }
                        function NUc(a, b, c, d, e, f, g) {
                            var h, i, j, k, l, m, n, o, p, q, r, s, t;
                            m = null;
                            d == (dVc(), bVc) ? m = b : d == cVc && (m = c);
                            for(p = m.a.ec().Kc(); p.Ob();){
                                o = RD(p.Pb(), 12);
                                q = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                    o.i.n,
                                    o.n,
                                    o.a
                                ])).b;
                                t = new _sb;
                                h = new _sb;
                                for(j = new l4b(o.b); xnb(j.a) || xnb(j.b);){
                                    i = RD(xnb(j.a) ? ynb(j.a) : ynb(j.b), 18);
                                    if (Heb(TD(mQb(i, (Ywc(), Nwc)))) != e) continue;
                                    if (Wmb(f, i, 0) != -1) {
                                        i.d == o ? r = i.c : r = i.d;
                                        s = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                            r.i.n,
                                            r.n,
                                            r.a
                                        ])).b;
                                        if ($wnd.Math.abs(s - q) < 0.2) continue;
                                        s < q ? b.a._b(r) ? Ysb(t, new Ptd(bVc, i)) : Ysb(t, new Ptd(cVc, i)) : b.a._b(r) ? Ysb(h, new Ptd(bVc, i)) : Ysb(h, new Ptd(cVc, i));
                                    }
                                }
                                if (t.a.gc() > 1) {
                                    n = new xVc(o, t, d);
                                    xgb(t, new nVc(a, n));
                                    ZEb(g.c, n);
                                    for(l = t.a.ec().Kc(); l.Ob();){
                                        k = RD(l.Pb(), 42);
                                        Ymb(f, k.b);
                                    }
                                }
                                if (h.a.gc() > 1) {
                                    n = new xVc(o, h, d);
                                    xgb(h, new pVc(a, n));
                                    ZEb(g.c, n);
                                    for(l = h.a.ec().Kc(); l.Ob();){
                                        k = RD(l.Pb(), 42);
                                        Ymb(f, k.b);
                                    }
                                }
                            }
                        }
                        function p6b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                            p = a.n;
                            q = a.o;
                            m = a.d;
                            l = Kfb(UD(hFc(a, (yCc(), QBc))));
                            if (b) {
                                k = l * (b.gc() - 1);
                                n = 0;
                                for(i = b.Kc(); i.Ob();){
                                    g = RD(i.Pb(), 10);
                                    k += g.o.a;
                                    n = $wnd.Math.max(n, g.o.b);
                                }
                                r = p.a - (k - q.a) / 2;
                                f = p.b - m.d + n;
                                d = q.a / (b.gc() + 1);
                                e = d;
                                for(h = b.Kc(); h.Ob();){
                                    g = RD(h.Pb(), 10);
                                    g.n.a = r;
                                    g.n.b = f - g.o.b;
                                    r += g.o.a + l;
                                    j = n6b(g);
                                    j.n.a = g.o.a / 2 - j.a.a;
                                    j.n.b = g.o.b;
                                    o = RD(mQb(g, (Ywc(), Xvc)), 12);
                                    if (o.e.c.length + o.g.c.length == 1) {
                                        o.n.a = e - o.a.a;
                                        o.n.b = 0;
                                        P3b(o, a);
                                    }
                                    e += d;
                                }
                            }
                            if (c) {
                                k = l * (c.gc() - 1);
                                n = 0;
                                for(i = c.Kc(); i.Ob();){
                                    g = RD(i.Pb(), 10);
                                    k += g.o.a;
                                    n = $wnd.Math.max(n, g.o.b);
                                }
                                r = p.a - (k - q.a) / 2;
                                f = p.b + q.b + m.a - n;
                                d = q.a / (c.gc() + 1);
                                e = d;
                                for(h = c.Kc(); h.Ob();){
                                    g = RD(h.Pb(), 10);
                                    g.n.a = r;
                                    g.n.b = f;
                                    r += g.o.a + l;
                                    j = n6b(g);
                                    j.n.a = g.o.a / 2 - j.a.a;
                                    j.n.b = 0;
                                    o = RD(mQb(g, (Ywc(), Xvc)), 12);
                                    if (o.e.c.length + o.g.c.length == 1) {
                                        o.n.a = e - o.a.a;
                                        o.n.b = q.b;
                                        P3b(o, a);
                                    }
                                    e += d;
                                }
                            }
                        }
                        function Hac(a, b) {
                            var c, d, e, f, g, h;
                            if (!RD(mQb(b, (Ywc(), kwc)), 21).Hc((ovc(), hvc))) return;
                            for(h = new Anb(b.a); h.a < h.c.c.length;){
                                f = RD(ynb(h), 10);
                                if (f.k == (r3b(), p3b)) {
                                    e = RD(mQb(f, (yCc(), _Ac)), 140);
                                    a.c = $wnd.Math.min(a.c, f.n.a - e.b);
                                    a.a = $wnd.Math.max(a.a, f.n.a + f.o.a + e.c);
                                    a.d = $wnd.Math.min(a.d, f.n.b - e.d);
                                    a.b = $wnd.Math.max(a.b, f.n.b + f.o.b + e.a);
                                }
                            }
                            for(g = new Anb(b.a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 10);
                                if (f.k != (r3b(), p3b)) switch(f.k.g){
                                    case 2:
                                        d = RD(mQb(f, (yCc(), UAc)), 171);
                                        if (d == (cxc(), $wc)) {
                                            f.n.a = a.c - 10;
                                            Gac(f, new Oac).Jb(new Rac(f));
                                            break;
                                        }
                                        if (d == axc) {
                                            f.n.a = a.a + 10;
                                            Gac(f, new Uac).Jb(new Xac(f));
                                            break;
                                        }
                                        c = RD(mQb(f, owc), 311);
                                        if (c == (Gvc(), Fvc)) {
                                            Fac(f).Jb(new $ac(f));
                                            f.n.b = a.d - 10;
                                            break;
                                        }
                                        if (c == Dvc) {
                                            Fac(f).Jb(new bbc(f));
                                            f.n.b = a.b + 10;
                                            break;
                                        }
                                        break;
                                    default:
                                        throw Adb(new agb('The node type ' + f.k + ' is not supported by the ' + XS));
                                }
                            }
                        }
                        function g5b(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p, q;
                            i = new rjd(d.i + d.g / 2, d.j + d.f / 2);
                            n = W4b(d);
                            o = RD(Gxd(b, (yCc(), BBc)), 101);
                            q = RD(Gxd(d, GBc), 64);
                            if (!HPd(Fxd(d), ABc)) {
                                d.i == 0 && d.j == 0 ? p = 0 : p = nsd(d, q);
                                Ixd(d, ABc, p);
                            }
                            j = new rjd(b.g, b.f);
                            e = f2b(d, o, q, n, j, i, new rjd(d.g, d.f), RD(mQb(c, rAc), 88), c);
                            pQb(e, (Ywc(), Awc), d);
                            f = RD(Vmb(e.j, 0), 12);
                            O3b(f, e5b(d));
                            pQb(e, EBc, (Pod(), xsb(Nod)));
                            l = RD(Gxd(b, EBc), 181).Hc(Lod);
                            for(h = new dMd((!d.n && (d.n = new C5d(I4, d, 1, 7)), d.n)); h.e != h.i.gc();){
                                g = RD(bMd(h), 135);
                                if (!Heb(TD(Gxd(g, pBc))) && !!g.a) {
                                    m = h5b(g);
                                    Rmb(f.f, m);
                                    if (!l) {
                                        k = 0;
                                        Rod(RD(Gxd(b, EBc), 21)) && (k = qsd(new rjd(g.i, g.j), new rjd(g.g, g.f), new rjd(d.g, d.f), 0, q));
                                        switch(q.g){
                                            case 2:
                                            case 4:
                                                m.o.a = k;
                                                break;
                                            case 1:
                                            case 3:
                                                m.o.b = k;
                                        }
                                    }
                                }
                            }
                            pQb(e, _Bc, UD(Gxd(vCd(b), _Bc)));
                            pQb(e, aCc, UD(Gxd(vCd(b), aCc)));
                            pQb(e, ZBc, UD(Gxd(vCd(b), ZBc)));
                            Rmb(c.a, e);
                            Zjb(a.a, d, e);
                        }
                        function j5b(a, b, c, d, e, f) {
                            var g, h, i, j, k, l;
                            j = new R3b;
                            kQb(j, b);
                            Q3b(j, RD(Gxd(b, (yCc(), GBc)), 64));
                            pQb(j, (Ywc(), Awc), b);
                            P3b(j, c);
                            l = j.o;
                            l.a = b.g;
                            l.b = b.f;
                            k = j.n;
                            k.a = b.i;
                            k.b = b.j;
                            Zjb(a.a, b, j);
                            g = yDb(GDb(EDb(new SDb(null, (!b.e && (b.e = new Yie(G4, b, 7, 4)), new Swb(b.e, 16))), new w5b), new o5b), new y5b(b));
                            g || (g = yDb(GDb(EDb(new SDb(null, (!b.d && (b.d = new Yie(G4, b, 8, 5)), new Swb(b.d, 16))), new A5b), new q5b), new C5b(b)));
                            g || (g = yDb(new SDb(null, (!b.e && (b.e = new Yie(G4, b, 7, 4)), new Swb(b.e, 16))), new E5b));
                            pQb(j, nwc, (Geb(), g ? true : false));
                            m2b(j, f, e, RD(Gxd(b, zBc), 8));
                            for(i = new dMd((!b.n && (b.n = new C5d(I4, b, 1, 7)), b.n)); i.e != i.i.gc();){
                                h = RD(bMd(i), 135);
                                !Heb(TD(Gxd(h, pBc))) && !!h.a && Rmb(j.f, h5b(h));
                            }
                            switch(e.g){
                                case 2:
                                case 1:
                                    (j.j == (qpd(), Yod) || j.j == npd) && d.Fc((ovc(), lvc));
                                    break;
                                case 4:
                                case 3:
                                    (j.j == (qpd(), Xod) || j.j == ppd) && d.Fc((ovc(), lvc));
                            }
                            return j;
                        }
                        function dud(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
                            t = 0;
                            o = 0;
                            n = 0;
                            m = 1;
                            for(s = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); s.e != s.i.gc();){
                                q = RD(bMd(s), 27);
                                m += Kr(new is(Mr(zGd(q).a.Kc(), new ir)));
                                B = q.g;
                                o = $wnd.Math.max(o, B);
                                l = q.f;
                                n = $wnd.Math.max(n, l);
                                t += B * l;
                            }
                            p = (!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a).i;
                            g = t + 2 * d * d * m * p;
                            f = $wnd.Math.sqrt(g);
                            i = $wnd.Math.max(f * c, o);
                            h = $wnd.Math.max(f / c, n);
                            for(r = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); r.e != r.i.gc();){
                                q = RD(bMd(r), 27);
                                C = e.b + (Kwb(b, 26) * Kxe + Kwb(b, 27) * Lxe) * (i - q.g);
                                D = e.b + (Kwb(b, 26) * Kxe + Kwb(b, 27) * Lxe) * (h - q.f);
                                Dyd(q, C);
                                Eyd(q, D);
                            }
                            A = i + (e.b + e.c);
                            w = h + (e.d + e.a);
                            for(v = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); v.e != v.i.gc();){
                                u = RD(bMd(v), 27);
                                for(k = new is(Mr(zGd(u).a.Kc(), new ir)); gs(k);){
                                    j = RD(hs(k), 74);
                                    nzd(j) || cud(j, b, A, w);
                                }
                            }
                            A += e.b + e.c;
                            w += e.d + e.a;
                            Esd(a, A, w, false, true);
                        }
                        function s6b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                            b.Ug('Comment pre-processing', 1);
                            c = 0;
                            i = new Anb(a.a);
                            while(i.a < i.c.c.length){
                                h = RD(ynb(i), 10);
                                if (Heb(TD(mQb(h, (yCc(), Uzc))))) {
                                    ++c;
                                    e = 0;
                                    d = null;
                                    j = null;
                                    for(o = new Anb(h.j); o.a < o.c.c.length;){
                                        m = RD(ynb(o), 12);
                                        e += m.e.c.length + m.g.c.length;
                                        if (m.e.c.length == 1) {
                                            d = RD(Vmb(m.e, 0), 18);
                                            j = d.c;
                                        }
                                        if (m.g.c.length == 1) {
                                            d = RD(Vmb(m.g, 0), 18);
                                            j = d.d;
                                        }
                                    }
                                    if (e == 1 && j.e.c.length + j.g.c.length == 1 && !Heb(TD(mQb(j.i, Uzc)))) {
                                        t6b(h, d, j, j.i);
                                        znb(i);
                                    } else {
                                        r = new bnb;
                                        for(n = new Anb(h.j); n.a < n.c.c.length;){
                                            m = RD(ynb(n), 12);
                                            for(l = new Anb(m.g); l.a < l.c.c.length;){
                                                k = RD(ynb(l), 18);
                                                k.d.g.c.length == 0 || ZEb(r.c, k);
                                            }
                                            for(g = new Anb(m.e); g.a < g.c.c.length;){
                                                f = RD(ynb(g), 18);
                                                f.c.e.c.length == 0 || ZEb(r.c, f);
                                            }
                                        }
                                        for(q = new Anb(r); q.a < q.c.c.length;){
                                            p = RD(ynb(q), 18);
                                            X0b(p, true);
                                        }
                                    }
                                }
                            }
                            b._g() && b.bh('Found ' + c + ' comment boxes');
                            b.Vg();
                        }
                        function wke(a, b) {
                            uke();
                            var c, d, e, f, g, h, i;
                            this.a = new zke(this);
                            this.b = a;
                            this.c = b;
                            this.f = Cfe(Qee((lke(), jke), b));
                            if (this.f.dc()) {
                                if ((h = Tee(jke, a)) == b) {
                                    this.e = true;
                                    this.d = new bnb;
                                    this.f = new OSd;
                                    this.f.Fc(dLe);
                                    RD(tfe(Pee(jke, BXd(a)), ''), 29) == a && this.f.Fc(Uee(jke, BXd(a)));
                                    for(e = Gee(jke, a).Kc(); e.Ob();){
                                        d = RD(e.Pb(), 179);
                                        switch(yfe(Qee(jke, d))){
                                            case 4:
                                                this.d.Fc(d);
                                                break;
                                            case 5:
                                                this.f.Gc(Cfe(Qee(jke, d)));
                                                break;
                                        }
                                    }
                                } else {
                                    nke();
                                    if (RD(b, 69).xk()) {
                                        this.e = true;
                                        this.f = null;
                                        this.d = new bnb;
                                        for(g = 0, i = (a.i == null && rYd(a), a.i).length; g < i; ++g){
                                            d = (c = (a.i == null && rYd(a), a.i), g >= 0 && g < c.length ? c[g] : null);
                                            for(f = zfe(Qee(jke, d)); f; f = zfe(Qee(jke, f)))f == b && this.d.Fc(d);
                                        }
                                    } else if (yfe(Qee(jke, b)) == 1 && !!h) {
                                        this.f = null;
                                        this.d = (Lle(), Kle);
                                    } else {
                                        this.f = null;
                                        this.e = true;
                                        this.d = (yob(), new mpb(b));
                                    }
                                }
                            } else {
                                this.e = yfe(Qee(jke, b)) == 5;
                                this.f.Fb(tke) && (this.f = tke);
                            }
                        }
                        function qNb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o;
                            c = 0;
                            d = pNb(a, b);
                            m = a.s;
                            n = a.t;
                            for(j = RD(RD(Qc(a.r, b), 21), 87).Kc(); j.Ob();){
                                i = RD(j.Pb(), 117);
                                if (!i.c || i.c.d.c.length <= 0) continue;
                                o = i.b.Mf();
                                h = i.b.pf((umd(), Gld)) ? Kfb(UD(i.b.of(Gld))) : 0;
                                k = i.c;
                                l = k.i;
                                l.b = (g = k.n, k.e.a + g.b + g.c);
                                l.a = (f = k.n, k.e.b + f.d + f.a);
                                switch(b.g){
                                    case 1:
                                        l.c = i.a ? (o.a - l.b) / 2 : o.a + m;
                                        l.d = o.b + h + d;
                                        RKb(k, (EKb(), BKb));
                                        SKb(k, (vLb(), uLb));
                                        break;
                                    case 3:
                                        l.c = i.a ? (o.a - l.b) / 2 : o.a + m;
                                        l.d = -h - d - l.a;
                                        RKb(k, (EKb(), BKb));
                                        SKb(k, (vLb(), sLb));
                                        break;
                                    case 2:
                                        l.c = -h - d - l.b;
                                        if (i.a) {
                                            e = a.v ? l.a : RD(Vmb(k.d, 0), 187).Mf().b;
                                            l.d = (o.b - e) / 2;
                                        } else l.d = o.b + n;
                                        RKb(k, (EKb(), DKb));
                                        SKb(k, (vLb(), tLb));
                                        break;
                                    case 4:
                                        l.c = o.a + h + d;
                                        if (i.a) {
                                            e = a.v ? l.a : RD(Vmb(k.d, 0), 187).Mf().b;
                                            l.d = (o.b - e) / 2;
                                        } else l.d = o.b + n;
                                        RKb(k, (EKb(), CKb));
                                        SKb(k, (vLb(), tLb));
                                }
                                (b == (qpd(), Yod) || b == npd) && (c = $wnd.Math.max(c, l.a));
                            }
                            c > 0 && (RD(Vrb(a.b, b), 127).a.b = c);
                        }
                        function wcc(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p;
                            m = Kfb(UD(mQb(a, (yCc(), _Bc))));
                            n = Kfb(UD(mQb(a, aCc)));
                            l = Kfb(UD(mQb(a, ZBc)));
                            h = a.o;
                            f = RD(Vmb(a.j, 0), 12);
                            g = f.n;
                            p = ucc(f, l);
                            if (!p) return;
                            if (b.Hc((Pod(), Lod))) switch(RD(mQb(a, (Ywc(), hwc)), 64).g){
                                case 1:
                                    p.c = (h.a - p.b) / 2 - g.a;
                                    p.d = n;
                                    break;
                                case 3:
                                    p.c = (h.a - p.b) / 2 - g.a;
                                    p.d = -n - p.a;
                                    break;
                                case 2:
                                    if (c && f.e.c.length == 0 && f.g.c.length == 0) {
                                        k = d ? p.a : RD(Vmb(f.f, 0), 72).o.b;
                                        p.d = (h.b - k) / 2 - g.b;
                                    } else p.d = h.b + n - g.b;
                                    p.c = -m - p.b;
                                    break;
                                case 4:
                                    if (c && f.e.c.length == 0 && f.g.c.length == 0) {
                                        k = d ? p.a : RD(Vmb(f.f, 0), 72).o.b;
                                        p.d = (h.b - k) / 2 - g.b;
                                    } else p.d = h.b + n - g.b;
                                    p.c = m;
                            }
                            else if (b.Hc(Nod)) switch(RD(mQb(a, (Ywc(), hwc)), 64).g){
                                case 1:
                                case 3:
                                    p.c = g.a + m;
                                    break;
                                case 2:
                                case 4:
                                    if (c && !f.c) {
                                        k = d ? p.a : RD(Vmb(f.f, 0), 72).o.b;
                                        p.d = (h.b - k) / 2 - g.b;
                                    } else p.d = g.b + n;
                            }
                            e = p.d;
                            for(j = new Anb(f.f); j.a < j.c.c.length;){
                                i = RD(ynb(j), 72);
                                o = i.n;
                                o.a = p.c;
                                o.b = e;
                                e += i.o.b + l;
                            }
                        }
                        function w9b(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F;
                            w = new bnb;
                            for(o = new Anb(a.b); o.a < o.c.c.length;){
                                n = RD(ynb(o), 30);
                                for(r = new Anb(n.a); r.a < r.c.c.length;){
                                    p = RD(ynb(r), 10);
                                    if (p.k != (r3b(), m3b)) continue;
                                    if (!nQb(p, (Ywc(), gwc))) continue;
                                    s = null;
                                    u = null;
                                    t = null;
                                    for(C = new Anb(p.j); C.a < C.c.c.length;){
                                        B = RD(ynb(C), 12);
                                        switch(B.j.g){
                                            case 4:
                                                s = B;
                                                break;
                                            case 2:
                                                u = B;
                                                break;
                                            default:
                                                t = B;
                                        }
                                    }
                                    v = RD(Vmb(t.g, 0), 18);
                                    k = new Fjd(v.a);
                                    j = new sjd(t.n);
                                    $id(j, p.n);
                                    l = Sub(k, 0);
                                    cvb(l, j);
                                    A = Ijd(v.a);
                                    m = new sjd(t.n);
                                    $id(m, p.n);
                                    Pub(A, m, A.c.b, A.c);
                                    D = RD(mQb(p, gwc), 10);
                                    F = RD(Vmb(D.j, 0), 12);
                                    i = RD(anb(s.e, $C(WQ, VAe, 18, 0, 0, 1)), 483);
                                    for(d = i, f = 0, h = d.length; f < h; ++f){
                                        b = d[f];
                                        Z0b(b, F);
                                        Ajd(b.a, b.a.b, k);
                                    }
                                    i = s2b(u.g);
                                    for(c = i, e = 0, g = c.length; e < g; ++e){
                                        b = c[e];
                                        Y0b(b, F);
                                        Ajd(b.a, 0, A);
                                    }
                                    Y0b(v, null);
                                    Z0b(v, null);
                                    ZEb(w.c, p);
                                }
                            }
                            for(q = new Anb(w); q.a < q.c.c.length;){
                                p = RD(ynb(q), 10);
                                g3b(p, null);
                            }
                        }
                        function CLb(a) {
                            var b;
                            this.r = Ty(new FLb, new JLb);
                            this.b = new Zrb(RD(Qb(E3), 297));
                            this.p = new Zrb(RD(Qb(E3), 297));
                            this.i = new Zrb(RD(Qb(XN), 297));
                            this.e = a;
                            this.o = new sjd(a.Mf());
                            this.D = Heb(TD(a.of((umd(), mmd))));
                            this.F = a.Yf() || Heb(TD(a.of($kd)));
                            this.A = RD(a.of(kld), 21);
                            this.B = RD(a.of(pld), 21);
                            this.q = RD(a.of(Hld), 101);
                            this.u = RD(a.of(Lld), 21);
                            if (!Sod(this.u)) throw Adb(new Jed('Invalid port label placement: ' + this.u));
                            this.v = Heb(TD(a.of(Nld)));
                            this.j = RD(a.of(ild), 21);
                            if (!fod(this.j)) throw Adb(new Jed('Invalid node label placement: ' + this.j));
                            this.n = RD(ftd(a, gld), 107);
                            this.k = Kfb(UD(ftd(a, cmd)));
                            this.d = Kfb(UD(ftd(a, bmd)));
                            this.w = Kfb(UD(ftd(a, jmd)));
                            this.s = Kfb(UD(ftd(a, dmd)));
                            this.t = Kfb(UD(ftd(a, emd)));
                            this.C = RD(ftd(a, hmd), 140);
                            this.c = 2 * this.d;
                            b = !this.B.Hc((dqd(), Wpd));
                            this.f = new dLb(0, b, 0);
                            this.g = new dLb(1, b, 0);
                            cLb(this.f, (ZJb(), XJb), this.g);
                        }
                        function Dne() {
                            RRd(Vbb, new ioe);
                            RRd(Xbb, new Poe);
                            RRd(Ybb, new upe);
                            RRd(Zbb, new _pe);
                            RRd(qJ, new lqe);
                            RRd(WC(gE, 1), new oqe);
                            RRd(QI, new rqe);
                            RRd(RI, new uqe);
                            RRd(qJ, new Gne);
                            RRd(qJ, new Jne);
                            RRd(qJ, new Mne);
                            RRd(VI, new Pne);
                            RRd(qJ, new Sne);
                            RRd(QK, new Vne);
                            RRd(QK, new Yne);
                            RRd(qJ, new _ne);
                            RRd(ZI, new coe);
                            RRd(qJ, new foe);
                            RRd(qJ, new loe);
                            RRd(qJ, new ooe);
                            RRd(qJ, new roe);
                            RRd(qJ, new uoe);
                            RRd(WC(gE, 1), new xoe);
                            RRd(qJ, new Aoe);
                            RRd(qJ, new Doe);
                            RRd(QK, new Goe);
                            RRd(QK, new Joe);
                            RRd(qJ, new Moe);
                            RRd(bJ, new Soe);
                            RRd(qJ, new Voe);
                            RRd(eJ, new Yoe);
                            RRd(qJ, new _oe);
                            RRd(qJ, new cpe);
                            RRd(qJ, new fpe);
                            RRd(qJ, new ipe);
                            RRd(QK, new lpe);
                            RRd(QK, new ope);
                            RRd(qJ, new rpe);
                            RRd(qJ, new xpe);
                            RRd(qJ, new Ape);
                            RRd(qJ, new Dpe);
                            RRd(qJ, new Gpe);
                            RRd(qJ, new Jpe);
                            RRd(lJ, new Mpe);
                            RRd(qJ, new Ppe);
                            RRd(qJ, new Spe);
                            RRd(qJ, new Vpe);
                            RRd(lJ, new Ype);
                            RRd(eJ, new cqe);
                            RRd(qJ, new fqe);
                            RRd(bJ, new iqe);
                        }
                        function jsc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o;
                            k = new Ejd;
                            switch(a.a.g){
                                case 3:
                                    m = RD(mQb(b.e, (Ywc(), Twc)), 15);
                                    n = RD(mQb(b.j, Twc), 15);
                                    o = RD(mQb(b.f, Twc), 15);
                                    c = RD(mQb(b.e, Rwc), 15);
                                    d = RD(mQb(b.j, Rwc), 15);
                                    e = RD(mQb(b.f, Rwc), 15);
                                    g = new bnb;
                                    Tmb(g, m);
                                    n.Jc(new msc);
                                    Tmb(g, hv(n));
                                    Tmb(g, o);
                                    f = new bnb;
                                    Tmb(f, c);
                                    Tmb(f, hv(d));
                                    Tmb(f, e);
                                    pQb(b.f, Twc, g);
                                    pQb(b.f, Rwc, f);
                                    pQb(b.f, Uwc, b.f);
                                    pQb(b.e, Twc, null);
                                    pQb(b.e, Rwc, null);
                                    pQb(b.j, Twc, null);
                                    pQb(b.j, Rwc, null);
                                    break;
                                case 1:
                                    ye(k, b.e.a);
                                    Mub(k, b.i.n);
                                    ye(k, hv(b.j.a));
                                    Mub(k, b.a.n);
                                    ye(k, b.f.a);
                                    break;
                                default:
                                    ye(k, b.e.a);
                                    ye(k, hv(b.j.a));
                                    ye(k, b.f.a);
                            }
                            Xub(b.f.a);
                            ye(b.f.a, k);
                            Y0b(b.f, b.e.c);
                            h = RD(mQb(b.e, (yCc(), RAc)), 75);
                            j = RD(mQb(b.j, RAc), 75);
                            i = RD(mQb(b.f, RAc), 75);
                            if (!!h || !!j || !!i) {
                                l = new Ejd;
                                hsc(l, i);
                                hsc(l, j);
                                hsc(l, h);
                                pQb(b.f, RAc, l);
                            }
                            Y0b(b.j, null);
                            Z0b(b.j, null);
                            Y0b(b.e, null);
                            Z0b(b.e, null);
                            g3b(b.a, null);
                            g3b(b.i, null);
                            !!b.g && jsc(a, b.g);
                        }
                        function tib() {
                            tib = geb;
                            var a, b, c;
                            new Aib(1, 0);
                            new Aib(10, 0);
                            new Aib(0, 0);
                            lib = $C(tJ, Nve, 247, 11, 0, 1);
                            mib = $C(hE, zwe, 28, 100, 15, 1);
                            nib = cD(WC(iE, 1), vxe, 28, 15, [
                                1,
                                5,
                                25,
                                125,
                                625,
                                3125,
                                15625,
                                78125,
                                390625,
                                1953125,
                                9765625,
                                48828125,
                                244140625,
                                1220703125,
                                6103515625,
                                30517578125,
                                152587890625,
                                762939453125,
                                3814697265625,
                                19073486328125,
                                95367431640625,
                                476837158203125,
                                2384185791015625
                            ]);
                            oib = $C(kE, Pwe, 28, nib.length, 15, 1);
                            pib = cD(WC(iE, 1), vxe, 28, 15, [
                                1,
                                10,
                                100,
                                Awe,
                                10000,
                                wxe,
                                1000000,
                                10000000,
                                100000000,
                                ixe,
                                10000000000,
                                100000000000,
                                1000000000000,
                                10000000000000,
                                100000000000000,
                                1000000000000000,
                                10000000000000000
                            ]);
                            qib = $C(kE, Pwe, 28, pib.length, 15, 1);
                            rib = $C(tJ, Nve, 247, 11, 0, 1);
                            a = 0;
                            for(; a < rib.length; a++){
                                lib[a] = new Aib(a, 0);
                                rib[a] = new Aib(0, a);
                                mib[a] = 48;
                            }
                            for(; a < mib.length; a++)mib[a] = 48;
                            for(c = 0; c < oib.length; c++)oib[c] = Cib(nib[c]);
                            for(b = 0; b < qib.length; b++)qib[b] = Cib(pib[b]);
                            Ljb();
                        }
                        function Htb() {
                            function e() {
                                this.obj = this.createObject();
                            }
                            e.prototype.createObject = function(a) {
                                return Object.create(null);
                            };
                            e.prototype.get = function(a) {
                                return this.obj[a];
                            };
                            e.prototype.set = function(a, b) {
                                this.obj[a] = b;
                            };
                            e.prototype[Jxe] = function(a) {
                                delete this.obj[a];
                            };
                            e.prototype.keys = function() {
                                return Object.getOwnPropertyNames(this.obj);
                            };
                            e.prototype.entries = function() {
                                var b = this.keys();
                                var c = this;
                                var d = 0;
                                return {
                                    next: function() {
                                        if (d >= b.length) return {
                                            done: true
                                        };
                                        var a = b[d++];
                                        return {
                                            value: [
                                                a,
                                                c.get(a)
                                            ],
                                            done: false
                                        };
                                    }
                                };
                            };
                            if (!Ftb()) {
                                e.prototype.createObject = function() {
                                    return {};
                                };
                                e.prototype.get = function(a) {
                                    return this.obj[':' + a];
                                };
                                e.prototype.set = function(a, b) {
                                    this.obj[':' + a] = b;
                                };
                                e.prototype[Jxe] = function(a) {
                                    delete this.obj[':' + a];
                                };
                                e.prototype.keys = function() {
                                    var a = [];
                                    for(var b in this.obj)b.charCodeAt(0) == 58 && a.push(b.substring(1));
                                    return a;
                                };
                            }
                            return e;
                        }
                        function q$c() {
                            q$c = geb;
                            h$c = new jGd(rAe);
                            new jGd(sAe);
                            new kGd('DEPTH', sgb(0));
                            XZc = new kGd('FAN', sgb(0));
                            VZc = new kGd(QEe, sgb(0));
                            n$c = new kGd('ROOT', (Geb(), false));
                            b$c = new kGd('LEFTNEIGHBOR', null);
                            l$c = new kGd('RIGHTNEIGHBOR', null);
                            c$c = new kGd('LEFTSIBLING', null);
                            m$c = new kGd('RIGHTSIBLING', null);
                            WZc = new kGd('DUMMY', false);
                            new kGd('LEVEL', sgb(0));
                            k$c = new kGd('REMOVABLE_EDGES', new Yub);
                            o$c = new kGd('XCOOR', sgb(0));
                            p$c = new kGd('YCOOR', sgb(0));
                            d$c = new kGd('LEVELHEIGHT', 0);
                            f$c = new kGd('LEVELMIN', 0);
                            e$c = new kGd('LEVELMAX', 0);
                            ZZc = new kGd('GRAPH_XMIN', 0);
                            _Zc = new kGd('GRAPH_YMIN', 0);
                            YZc = new kGd('GRAPH_XMAX', 0);
                            $Zc = new kGd('GRAPH_YMAX', 0);
                            UZc = new kGd('COMPACT_LEVEL_ASCENSION', false);
                            TZc = new kGd('COMPACT_CONSTRAINTS', new bnb);
                            a$c = new kGd('ID', '');
                            i$c = new kGd('POSITION', sgb(0));
                            j$c = new kGd('PRELIM', 0);
                            g$c = new kGd('MODIFIER', 0);
                            SZc = new jGd(tAe);
                            RZc = new jGd(uAe);
                        }
                        function Bqe(a) {
                            zqe();
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
                            if (a == null) return null;
                            l = a.length * 8;
                            if (l == 0) return '';
                            h = l % 24;
                            n = l / 24 | 0;
                            m = h != 0 ? n + 1 : n;
                            f = null;
                            f = $C(hE, zwe, 28, m * 4, 15, 1);
                            j = 0;
                            k = 0;
                            b = 0;
                            c = 0;
                            d = 0;
                            g = 0;
                            e = 0;
                            for(i = 0; i < n; i++){
                                b = a[e++];
                                c = a[e++];
                                d = a[e++];
                                k = (c & 15) << 24 >> 24;
                                j = (b & 3) << 24 >> 24;
                                o = (b & -128) == 0 ? b >> 2 << 24 >> 24 : (b >> 2 ^ 192) << 24 >> 24;
                                p = (c & -128) == 0 ? c >> 4 << 24 >> 24 : (c >> 4 ^ 240) << 24 >> 24;
                                q = (d & -128) == 0 ? d >> 6 << 24 >> 24 : (d >> 6 ^ 252) << 24 >> 24;
                                f[g++] = yqe[o];
                                f[g++] = yqe[p | j << 4];
                                f[g++] = yqe[k << 2 | q];
                                f[g++] = yqe[d & 63];
                            }
                            if (h == 8) {
                                b = a[e];
                                j = (b & 3) << 24 >> 24;
                                o = (b & -128) == 0 ? b >> 2 << 24 >> 24 : (b >> 2 ^ 192) << 24 >> 24;
                                f[g++] = yqe[o];
                                f[g++] = yqe[j << 4];
                                f[g++] = 61;
                                f[g++] = 61;
                            } else if (h == 16) {
                                b = a[e];
                                c = a[e + 1];
                                k = (c & 15) << 24 >> 24;
                                j = (b & 3) << 24 >> 24;
                                o = (b & -128) == 0 ? b >> 2 << 24 >> 24 : (b >> 2 ^ 192) << 24 >> 24;
                                p = (c & -128) == 0 ? c >> 4 << 24 >> 24 : (c >> 4 ^ 240) << 24 >> 24;
                                f[g++] = yqe[o];
                                f[g++] = yqe[p | j << 4];
                                f[g++] = yqe[k << 2];
                                f[g++] = 61;
                            }
                            return Ihb(f, 0, f.length);
                        }
                        function CB(a, b) {
                            var c, d, e, f, g, h, i;
                            a.e == 0 && a.p > 0 && (a.p = -(a.p - 1));
                            a.p > qwe && tB(b, a.p - Owe);
                            g = b.q.getDate();
                            nB(b, 1);
                            a.k >= 0 && qB(b, a.k);
                            if (a.c >= 0) nB(b, a.c);
                            else if (a.k >= 0) {
                                i = new vB(b.q.getFullYear() - Owe, b.q.getMonth(), 35);
                                d = 35 - i.q.getDate();
                                nB(b, $wnd.Math.min(d, g));
                            } else nB(b, g);
                            a.f < 0 && (a.f = b.q.getHours());
                            a.b > 0 && a.f < 12 && (a.f += 12);
                            oB(b, a.f == 24 && a.g ? 0 : a.f);
                            a.j >= 0 && pB(b, a.j);
                            a.n >= 0 && rB(b, a.n);
                            a.i >= 0 && sB(b, Bdb(Ndb(Fdb(Hdb(b.q.getTime()), Awe), Awe), a.i));
                            if (a.a) {
                                e = new uB;
                                tB(e, e.q.getFullYear() - Owe - 80);
                                Ldb(Hdb(b.q.getTime()), Hdb(e.q.getTime())) && tB(b, e.q.getFullYear() - Owe + 100);
                            }
                            if (a.d >= 0) {
                                if (a.c == -1) {
                                    c = (7 + a.d - b.q.getDay()) % 7;
                                    c > 3 && (c -= 7);
                                    h = b.q.getMonth();
                                    nB(b, b.q.getDate() + c);
                                    b.q.getMonth() != h && nB(b, b.q.getDate() + (c > 0 ? -7 : 7));
                                } else {
                                    if (b.q.getDay() != a.d) return false;
                                }
                            }
                            if (a.o > qwe) {
                                f = b.q.getTimezoneOffset();
                                sB(b, Bdb(Hdb(b.q.getTime()), (a.o - f) * 60 * Awe));
                            }
                            return true;
                        }
                        function J5b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
                            e = mQb(b, (Ywc(), Awc));
                            if (!ZD(e, 207)) return;
                            o = RD(e, 27);
                            p = b.e;
                            m = new sjd(b.c);
                            f = b.d;
                            m.a += f.b;
                            m.b += f.d;
                            u = RD(Gxd(o, (yCc(), oBc)), 181);
                            if (Csb(u, (dqd(), Xpd))) {
                                n = RD(Gxd(o, qBc), 107);
                                E2b(n, f.a);
                                H2b(n, f.d);
                                F2b(n, f.b);
                                G2b(n, f.c);
                            }
                            c = new bnb;
                            for(k = new Anb(b.a); k.a < k.c.c.length;){
                                i = RD(ynb(k), 10);
                                if (ZD(mQb(i, Awc), 207)) K5b(i, m);
                                else if (ZD(mQb(i, Awc), 193) && !p) {
                                    d = RD(mQb(i, Awc), 123);
                                    s = j2b(b, i, d.g, d.f);
                                    Byd(d, s.a, s.b);
                                }
                                for(r = new Anb(i.j); r.a < r.c.c.length;){
                                    q = RD(ynb(r), 12);
                                    FDb(CDb(new SDb(null, new Swb(q.g, 16)), new Q5b(i)), new S5b(c));
                                }
                            }
                            if (p) for(r = new Anb(p.j); r.a < r.c.c.length;){
                                q = RD(ynb(r), 12);
                                FDb(CDb(new SDb(null, new Swb(q.g, 16)), new U5b(p)), new W5b(c));
                            }
                            t = RD(Gxd(o, yAc), 223);
                            for(h = new Anb(c); h.a < h.c.c.length;){
                                g = RD(ynb(h), 18);
                                I5b(g, t, m);
                            }
                            L5b(b);
                            for(j = new Anb(b.a); j.a < j.c.c.length;){
                                i = RD(ynb(j), 10);
                                l = i.e;
                                !!l && J5b(a, l);
                            }
                        }
                        function xNb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n;
                            if (RD(RD(Qc(a.r, b), 21), 87).dc()) return;
                            g = RD(Vrb(a.b, b), 127);
                            i = g.i;
                            h = g.n;
                            k = BLb(a, b);
                            d = i.b - h.b - h.c;
                            e = g.a.a;
                            f = i.c + h.b;
                            n = a.w;
                            if ((k == (pod(), mod) || k == ood) && RD(RD(Qc(a.r, b), 21), 87).gc() == 1) {
                                e = k == mod ? e - 2 * a.w : e;
                                k = lod;
                            }
                            if (d < e && !a.B.Hc((dqd(), aqd))) {
                                if (k == mod) {
                                    n += (d - e) / (RD(RD(Qc(a.r, b), 21), 87).gc() + 1);
                                    f += n;
                                } else n += (d - e) / (RD(RD(Qc(a.r, b), 21), 87).gc() - 1);
                            } else {
                                if (d < e) {
                                    e = k == mod ? e - 2 * a.w : e;
                                    k = lod;
                                }
                                switch(k.g){
                                    case 3:
                                        f += (d - e) / 2;
                                        break;
                                    case 4:
                                        f += d - e;
                                        break;
                                    case 0:
                                        c = (d - e) / (RD(RD(Qc(a.r, b), 21), 87).gc() + 1);
                                        n += $wnd.Math.max(0, c);
                                        f += n;
                                        break;
                                    case 1:
                                        c = (d - e) / (RD(RD(Qc(a.r, b), 21), 87).gc() - 1);
                                        n += $wnd.Math.max(0, c);
                                }
                            }
                            for(m = RD(RD(Qc(a.r, b), 21), 87).Kc(); m.Ob();){
                                l = RD(m.Pb(), 117);
                                l.e.a = f + l.d.b;
                                l.e.b = (j = l.b, j.pf((umd(), Gld)) ? j.ag() == (qpd(), Yod) ? -j.Mf().b - Kfb(UD(j.of(Gld))) : Kfb(UD(j.of(Gld))) : j.ag() == (qpd(), Yod) ? -j.Mf().b : 0);
                                f += l.d.b + l.b.Mf().a + l.d.c + n;
                            }
                        }
                        function BNb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o;
                            if (RD(RD(Qc(a.r, b), 21), 87).dc()) return;
                            g = RD(Vrb(a.b, b), 127);
                            i = g.i;
                            h = g.n;
                            l = BLb(a, b);
                            d = i.a - h.d - h.a;
                            e = g.a.b;
                            f = i.d + h.d;
                            o = a.w;
                            j = a.o.a;
                            if ((l == (pod(), mod) || l == ood) && RD(RD(Qc(a.r, b), 21), 87).gc() == 1) {
                                e = l == mod ? e - 2 * a.w : e;
                                l = lod;
                            }
                            if (d < e && !a.B.Hc((dqd(), aqd))) {
                                if (l == mod) {
                                    o += (d - e) / (RD(RD(Qc(a.r, b), 21), 87).gc() + 1);
                                    f += o;
                                } else o += (d - e) / (RD(RD(Qc(a.r, b), 21), 87).gc() - 1);
                            } else {
                                if (d < e) {
                                    e = l == mod ? e - 2 * a.w : e;
                                    l = lod;
                                }
                                switch(l.g){
                                    case 3:
                                        f += (d - e) / 2;
                                        break;
                                    case 4:
                                        f += d - e;
                                        break;
                                    case 0:
                                        c = (d - e) / (RD(RD(Qc(a.r, b), 21), 87).gc() + 1);
                                        o += $wnd.Math.max(0, c);
                                        f += o;
                                        break;
                                    case 1:
                                        c = (d - e) / (RD(RD(Qc(a.r, b), 21), 87).gc() - 1);
                                        o += $wnd.Math.max(0, c);
                                }
                            }
                            for(n = RD(RD(Qc(a.r, b), 21), 87).Kc(); n.Ob();){
                                m = RD(n.Pb(), 117);
                                m.e.a = (k = m.b, k.pf((umd(), Gld)) ? k.ag() == (qpd(), ppd) ? -k.Mf().a - Kfb(UD(k.of(Gld))) : j + Kfb(UD(k.of(Gld))) : k.ag() == (qpd(), ppd) ? -k.Mf().a : j);
                                m.e.b = f + m.d.d;
                                f += m.d.d + m.b.Mf().b + m.d.a + o;
                            }
                        }
                        function bZc(a, b) {
                            var c, d, e, f, g;
                            b.Ug('Processor determine the coords for each level', 1);
                            d = new bnb;
                            for(g = Sub(a.b, 0); g.b != g.d.c;){
                                e = RD(evb(g), 40);
                                while(RD(mQb(e, (h_c(), f_c)), 17).a > d.c.length - 1)Rmb(d, new Ptd(Hze, KEe));
                                c = RD(mQb(e, f_c), 17).a;
                                if (Dmd(RD(mQb(a, H$c), 88))) {
                                    e.e.a < Kfb(UD((tFb(c, d.c.length), RD(d.c[c], 42)).a)) && Ntd((tFb(c, d.c.length), RD(d.c[c], 42)), e.e.a);
                                    e.e.a + e.f.a > Kfb(UD((tFb(c, d.c.length), RD(d.c[c], 42)).b)) && Otd((tFb(c, d.c.length), RD(d.c[c], 42)), e.e.a + e.f.a);
                                } else {
                                    e.e.b < Kfb(UD((tFb(c, d.c.length), RD(d.c[c], 42)).a)) && Ntd((tFb(c, d.c.length), RD(d.c[c], 42)), e.e.b);
                                    e.e.b + e.f.b > Kfb(UD((tFb(c, d.c.length), RD(d.c[c], 42)).b)) && Otd((tFb(c, d.c.length), RD(d.c[c], 42)), e.e.b + e.f.b);
                                }
                            }
                            for(f = Sub(a.b, 0); f.b != f.d.c;){
                                e = RD(evb(f), 40);
                                c = RD(mQb(e, (h_c(), f_c)), 17).a;
                                pQb(e, (q$c(), f$c), UD((tFb(c, d.c.length), RD(d.c[c], 42)).a));
                                pQb(e, e$c, UD((tFb(c, d.c.length), RD(d.c[c], 42)).b));
                            }
                            b.Vg();
                        }
                        function Tec(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p;
                            a.o = Kfb(UD(mQb(a.i, (yCc(), bCc))));
                            a.f = Kfb(UD(mQb(a.i, XBc)));
                            a.j = a.i.b.c.length;
                            h = a.j - 1;
                            m = 0;
                            a.k = 0;
                            a.n = 0;
                            a.b = dv($C(bJ, Nve, 17, a.j, 0, 1));
                            a.c = dv($C(VI, Nve, 345, a.j, 7, 1));
                            for(g = new Anb(a.i.b); g.a < g.c.c.length;){
                                e = RD(ynb(g), 30);
                                e.p = h;
                                for(l = new Anb(e.a); l.a < l.c.c.length;){
                                    k = RD(ynb(l), 10);
                                    k.p = m;
                                    ++m;
                                }
                                --h;
                            }
                            a.g = $C(kE, Pwe, 28, m, 15, 1);
                            a.d = YC(kE, [
                                Nve,
                                Pwe
                            ], [
                                53,
                                28
                            ], 15, [
                                m,
                                3
                            ], 2);
                            a.p = new bnb;
                            a.q = new bnb;
                            b = 0;
                            a.e = 0;
                            for(f = new Anb(a.i.b); f.a < f.c.c.length;){
                                e = RD(ynb(f), 30);
                                h = e.p;
                                d = 0;
                                p = 0;
                                i = e.a.c.length;
                                j = 0;
                                for(l = new Anb(e.a); l.a < l.c.c.length;){
                                    k = RD(ynb(l), 10);
                                    m = k.p;
                                    a.g[m] = k.c.p;
                                    j += k.o.b + a.o;
                                    c = Kr(new is(Mr(Z2b(k).a.Kc(), new ir)));
                                    o = Kr(new is(Mr(a3b(k).a.Kc(), new ir)));
                                    a.d[m][0] = o - c;
                                    a.d[m][1] = c;
                                    a.d[m][2] = o;
                                    d += c;
                                    p += o;
                                    c > 0 && Rmb(a.q, k);
                                    Rmb(a.p, k);
                                }
                                b -= d;
                                n = i + b;
                                j += b * a.f;
                                $mb(a.b, h, sgb(n));
                                $mb(a.c, h, j);
                                a.k = $wnd.Math.max(a.k, n);
                                a.n = $wnd.Math.max(a.n, j);
                                a.e += b;
                                b += p;
                            }
                        }
                        function qpd() {
                            qpd = geb;
                            var a;
                            opd = new upd(Sye, 0);
                            Yod = new upd(_ye, 1);
                            Xod = new upd(aze, 2);
                            npd = new upd(bze, 3);
                            ppd = new upd(cze, 4);
                            bpd = (yob(), new Lqb((a = RD(mfb(E3), 9), new Fsb(a, RD(WEb(a, a.length), 9), 0))));
                            cpd = eq(ysb(Yod, cD(WC(E3, 1), NAe, 64, 0, [])));
                            Zod = eq(ysb(Xod, cD(WC(E3, 1), NAe, 64, 0, [])));
                            kpd = eq(ysb(npd, cD(WC(E3, 1), NAe, 64, 0, [])));
                            mpd = eq(ysb(ppd, cD(WC(E3, 1), NAe, 64, 0, [])));
                            hpd = eq(ysb(Yod, cD(WC(E3, 1), NAe, 64, 0, [
                                npd
                            ])));
                            apd = eq(ysb(Xod, cD(WC(E3, 1), NAe, 64, 0, [
                                ppd
                            ])));
                            jpd = eq(ysb(Yod, cD(WC(E3, 1), NAe, 64, 0, [
                                ppd
                            ])));
                            dpd = eq(ysb(Yod, cD(WC(E3, 1), NAe, 64, 0, [
                                Xod
                            ])));
                            lpd = eq(ysb(npd, cD(WC(E3, 1), NAe, 64, 0, [
                                ppd
                            ])));
                            $od = eq(ysb(Xod, cD(WC(E3, 1), NAe, 64, 0, [
                                npd
                            ])));
                            gpd = eq(ysb(Yod, cD(WC(E3, 1), NAe, 64, 0, [
                                Xod,
                                ppd
                            ])));
                            _od = eq(ysb(Xod, cD(WC(E3, 1), NAe, 64, 0, [
                                npd,
                                ppd
                            ])));
                            ipd = eq(ysb(Yod, cD(WC(E3, 1), NAe, 64, 0, [
                                npd,
                                ppd
                            ])));
                            epd = eq(ysb(Yod, cD(WC(E3, 1), NAe, 64, 0, [
                                Xod,
                                npd
                            ])));
                            fpd = eq(ysb(Yod, cD(WC(E3, 1), NAe, 64, 0, [
                                Xod,
                                npd,
                                ppd
                            ])));
                        }
                        function Gfc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A;
                            b.Ug(qBe, 1);
                            p = new bnb;
                            w = new bnb;
                            for(j = new Anb(a.b); j.a < j.c.c.length;){
                                i = RD(ynb(j), 30);
                                r = -1;
                                o = t2b(i.a);
                                for(l = o, m = 0, n = l.length; m < n; ++m){
                                    k = l[m];
                                    ++r;
                                    if (!(k.k == (r3b(), p3b) && Dod(RD(mQb(k, (yCc(), BBc)), 101)))) continue;
                                    Cod(RD(mQb(k, (yCc(), BBc)), 101)) || Hfc(k);
                                    pQb(k, (Ywc(), pwc), k);
                                    p.c.length = 0;
                                    w.c.length = 0;
                                    c = new bnb;
                                    u = new Yub;
                                    _q(u, e3b(k, (qpd(), Yod)));
                                    Efc(a, u, p, w, c);
                                    h = r;
                                    A = k;
                                    for(f = new Anb(p); f.a < f.c.c.length;){
                                        d = RD(ynb(f), 10);
                                        f3b(d, h, i);
                                        ++r;
                                        pQb(d, pwc, k);
                                        g = RD(Vmb(d.j, 0), 12);
                                        q = RD(mQb(g, Awc), 12);
                                        Heb(TD(mQb(q, Szc))) || RD(mQb(d, qwc), 15).Fc(A);
                                    }
                                    Xub(u);
                                    for(t = e3b(k, npd).Kc(); t.Ob();){
                                        s = RD(t.Pb(), 12);
                                        Pub(u, s, u.a, u.a.a);
                                    }
                                    Efc(a, u, w, null, c);
                                    v = k;
                                    for(e = new Anb(w); e.a < e.c.c.length;){
                                        d = RD(ynb(e), 10);
                                        f3b(d, ++r, i);
                                        pQb(d, pwc, k);
                                        g = RD(Vmb(d.j, 0), 12);
                                        q = RD(mQb(g, Awc), 12);
                                        Heb(TD(mQb(q, Szc))) || RD(mQb(v, qwc), 15).Fc(d);
                                    }
                                    c.c.length == 0 || pQb(k, Uvc, c);
                                }
                            }
                            b.Vg();
                        }
                        function tYc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            if (b.b != 0) {
                                n = new Yub;
                                h = null;
                                o = null;
                                d = eE($wnd.Math.floor($wnd.Math.log(b.b) * $wnd.Math.LOG10E) + 1);
                                i = 0;
                                for(t = Sub(b, 0); t.b != t.d.c;){
                                    r = RD(evb(t), 40);
                                    if (dE(o) !== dE(mQb(r, (q$c(), a$c)))) {
                                        o = WD(mQb(r, a$c));
                                        i = 0;
                                    }
                                    o != null ? h = o + wYc(i++, d) : h = wYc(i++, d);
                                    pQb(r, a$c, h);
                                    for(q = (e = Sub(new dXc(r).a.d, 0), new gXc(e)); dvb(q.a);){
                                        p = RD(evb(q.a), 65).c;
                                        Pub(n, p, n.c.b, n.c);
                                        pQb(p, a$c, h);
                                    }
                                }
                                m = new Tsb;
                                for(g = 0; g < h.length - d; g++)for(s = Sub(b, 0); s.b != s.d.c;){
                                    r = RD(evb(s), 40);
                                    j = zhb(WD(mQb(r, (q$c(), a$c))), 0, g + 1);
                                    c = (j == null ? Wd(qtb(m.f, null)) : Ktb(m.i, j)) != null ? RD(j == null ? Wd(qtb(m.f, null)) : Ktb(m.i, j), 17).a + 1 : 1;
                                    $jb(m, j, sgb(c));
                                }
                                for(l = new vkb(new mkb(m).a); l.b;){
                                    k = tkb(l);
                                    f = sgb(Wjb(a.a, k.ld()) != null ? RD(Wjb(a.a, k.ld()), 17).a : 0);
                                    $jb(a.a, WD(k.ld()), sgb(RD(k.md(), 17).a + f.a));
                                    f = RD(Wjb(a.b, k.ld()), 17);
                                    (!f || f.a < RD(k.md(), 17).a) && $jb(a.b, WD(k.ld()), RD(k.md(), 17));
                                }
                                tYc(a, n);
                            }
                        }
                        function Hpc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m;
                            c = null;
                            i = null;
                            e = RD(mQb(a.b, (yCc(), CAc)), 349);
                            if (e == (TEc(), REc)) {
                                c = new bnb;
                                i = new bnb;
                            }
                            for(h = new Anb(a.d); h.a < h.c.c.length;){
                                g = RD(ynb(h), 105);
                                f = g.i;
                                if (!f) continue;
                                switch(g.e.g){
                                    case 0:
                                        b = RD(Nsb(new Osb(g.b)), 64);
                                        e == REc && b == (qpd(), Yod) ? ZEb(c.c, g) : e == REc && b == (qpd(), npd) ? ZEb(i.c, g) : Fpc(g, b);
                                        break;
                                    case 1:
                                        j = g.a.d.j;
                                        k = g.c.d.j;
                                        j == (qpd(), Yod) ? Gpc(g, Yod, (enc(), bnc), g.a) : k == Yod ? Gpc(g, Yod, (enc(), cnc), g.c) : j == npd ? Gpc(g, npd, (enc(), cnc), g.a) : k == npd && Gpc(g, npd, (enc(), bnc), g.c);
                                        break;
                                    case 2:
                                    case 3:
                                        d = g.b;
                                        Csb(d, (qpd(), Yod)) ? Csb(d, npd) ? Csb(d, ppd) ? Csb(d, Xod) || Gpc(g, Yod, (enc(), cnc), g.c) : Gpc(g, Yod, (enc(), bnc), g.a) : Gpc(g, Yod, (enc(), anc), null) : Gpc(g, npd, (enc(), anc), null);
                                        break;
                                    case 4:
                                        l = g.a.d.j;
                                        m = g.a.d.j;
                                        l == (qpd(), Yod) || m == Yod ? Gpc(g, npd, (enc(), anc), null) : Gpc(g, Yod, (enc(), anc), null);
                                }
                            }
                            if (c) {
                                c.c.length == 0 || Epc(c, (qpd(), Yod));
                                i.c.length == 0 || Epc(i, (qpd(), npd));
                            }
                        }
                        function oGc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                            c.Ug('Breadth first model order layering', 1);
                            a.a = b;
                            q = new bnb;
                            for(p = new Anb(a.a.a); p.a < p.c.c.length;){
                                n = RD(ynb(p), 10);
                                n.k == (r3b(), p3b) && ZEb(q.c, n);
                            }
                            yob();
                            _mb(q, new tGc);
                            i = true;
                            e = new R4b(a.a);
                            d = null;
                            Rmb(a.a.b, e);
                            for(o = new Anb(q); o.a < o.c.c.length;){
                                n = RD(ynb(o), 10);
                                if (i) {
                                    g3b(n, e);
                                    i = false;
                                } else {
                                    for(h = new is(Mr(Z2b(n).a.Kc(), new ir)); gs(h);){
                                        f = RD(hs(h), 18);
                                        if (f.c.i.k == (r3b(), p3b) && f.c.i.c == e || f.c.i.k == n3b && RD(hs(new is(Mr(Z2b(f.c.i).a.Kc(), new ir))), 18).c.i.c == e) {
                                            d = new R4b(a.a);
                                            Rmb(a.a.b, d);
                                            e = new R4b(a.a);
                                            Rmb(a.a.b, e);
                                        }
                                    }
                                    for(g = new is(Mr(Z2b(n).a.Kc(), new ir)); gs(g);){
                                        f = RD(hs(g), 18);
                                        f.c.i.k == (r3b(), n3b) && !f.c.i.c && g3b(f.c.i, d);
                                    }
                                    g3b(n, e);
                                }
                            }
                            a.a.a.c.length = 0;
                            r = new bnb;
                            for(l = new Anb(a.a.b); l.a < l.c.c.length;){
                                j = RD(ynb(l), 30);
                                j.a.c.length == 0 && ZEb(r.c, j);
                            }
                            Ce(a.a.b, r);
                            m = 0;
                            for(k = new Anb(a.a.b); k.a < k.c.c.length;){
                                j = RD(ynb(k), 30);
                                j.p = m;
                                ++m;
                            }
                            c.Vg();
                        }
                        function K5b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
                            d = RD(mQb(a, (Ywc(), Awc)), 27);
                            o = RD(mQb(a, (yCc(), mAc)), 17).a;
                            f = RD(mQb(a, VAc), 17).a;
                            Ixd(d, mAc, sgb(o));
                            Ixd(d, VAc, sgb(f));
                            Dyd(d, a.n.a + b.a);
                            Eyd(d, a.n.b + b.b);
                            if (RD(Gxd(d, lBc), 181).gc() != 0 || !!a.e || dE(mQb(Y2b(a), kBc)) === dE((JDc(), HDc)) && xDc((wDc(), (!a.q ? (yob(), yob(), wob) : a.q)._b(iBc) ? m = RD(mQb(a, iBc), 203) : m = RD(mQb(Y2b(a), jBc), 203), m))) {
                                Cyd(d, a.o.a);
                                Ayd(d, a.o.b);
                            }
                            for(l = new Anb(a.j); l.a < l.c.c.length;){
                                j = RD(ynb(l), 12);
                                p = mQb(j, Awc);
                                if (ZD(p, 193)) {
                                    e = RD(p, 123);
                                    Byd(e, j.n.a, j.n.b);
                                    Ixd(e, GBc, j.j);
                                }
                            }
                            n = RD(mQb(a, dBc), 181).gc() != 0;
                            for(i = new Anb(a.b); i.a < i.c.c.length;){
                                g = RD(ynb(i), 72);
                                if (n || RD(mQb(g, dBc), 181).gc() != 0) {
                                    c = RD(mQb(g, Awc), 135);
                                    zyd(c, g.o.a, g.o.b);
                                    Byd(c, g.n.a, g.n.b);
                                }
                            }
                            if (!Rod(RD(mQb(a, EBc), 21))) for(k = new Anb(a.j); k.a < k.c.c.length;){
                                j = RD(ynb(k), 12);
                                for(h = new Anb(j.f); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 72);
                                    c = RD(mQb(g, Awc), 135);
                                    Cyd(c, g.o.a);
                                    Ayd(c, g.o.b);
                                    Byd(c, g.n.a, g.n.b);
                                }
                            }
                        }
                        function X2c(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C;
                            b.Ug('Calculate Graph Size', 1);
                            b.dh(a, eFe);
                            l = Hze;
                            m = Hze;
                            j = fFe;
                            k = fFe;
                            for(p = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); p.e != p.i.gc();){
                                n = RD(bMd(p), 27);
                                s = n.i;
                                t = n.j;
                                C = n.g;
                                h = n.f;
                                i = RD(Gxd(n, (umd(), eld)), 140);
                                l = $wnd.Math.min(l, s - i.b);
                                m = $wnd.Math.min(m, t - i.d);
                                j = $wnd.Math.max(j, s + C + i.c);
                                k = $wnd.Math.max(k, t + h + i.a);
                            }
                            r = RD(Gxd(a, (umd(), tld)), 107);
                            q = new rjd(l - r.b, m - r.d);
                            B = j - l + (r.b + r.c);
                            g = k - m + (r.d + r.a);
                            if (Heb(TD(Gxd(a, ($4c(), G4c))))) {
                                u = RD(Gxd(a, (u2c(), t2c)), 27);
                                v = RD(Gxd(u, eld), 140);
                                w = u.i + u.g / 2 + (v.b + v.c) / 2 - q.a;
                                A = u.j + u.f / 2 + (v.d + v.a) / 2 - q.b;
                                e = B - w;
                                f = g - A;
                                if (e < B / 2) {
                                    c = e - w;
                                    B += c;
                                    q.a -= c;
                                } else {
                                    c = w - e;
                                    B += c;
                                }
                                if (f < g / 2) {
                                    d = f - A;
                                    g += d;
                                    q.b -= d;
                                } else {
                                    d = A - f;
                                    g += d;
                                }
                            }
                            for(o = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); o.e != o.i.gc();){
                                n = RD(bMd(o), 27);
                                Dyd(n, n.i - q.a);
                                Eyd(n, n.j - q.b);
                            }
                            if (!Heb(TD(Gxd(a, mld)))) {
                                Cyd(a, B);
                                Ayd(a, g);
                            }
                            Ixd(a, Ikd, B - (r.b + r.c));
                            Ixd(a, Hkd, g - (r.d + r.a));
                            b.dh(a, gFe);
                        }
                        function IUc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n;
                            a.e.a.$b();
                            a.f.a.$b();
                            a.c.c.length = 0;
                            a.i.c.length = 0;
                            a.g.a.$b();
                            if (b) for(g = new Anb(b.a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 10);
                                for(l = e3b(f, (qpd(), Xod)).Kc(); l.Ob();){
                                    k = RD(l.Pb(), 12);
                                    Ysb(a.e, k);
                                    for(e = new Anb(k.g); e.a < e.c.c.length;){
                                        d = RD(ynb(e), 18);
                                        if (W0b(d)) continue;
                                        Rmb(a.c, d);
                                        OUc(a, d);
                                        h = d.c.i.k;
                                        (h == (r3b(), p3b) || h == q3b || h == m3b || h == l3b) && Rmb(a.j, d);
                                        n = d.d;
                                        m = n.i.c;
                                        m == c ? Ysb(a.f, n) : m == b ? Ysb(a.e, n) : Ymb(a.c, d);
                                    }
                                }
                            }
                            if (c) for(g = new Anb(c.a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 10);
                                for(j = new Anb(f.j); j.a < j.c.c.length;){
                                    i = RD(ynb(j), 12);
                                    for(e = new Anb(i.g); e.a < e.c.c.length;){
                                        d = RD(ynb(e), 18);
                                        W0b(d) && Ysb(a.g, d);
                                    }
                                }
                                for(l = e3b(f, (qpd(), ppd)).Kc(); l.Ob();){
                                    k = RD(l.Pb(), 12);
                                    Ysb(a.f, k);
                                    for(e = new Anb(k.g); e.a < e.c.c.length;){
                                        d = RD(ynb(e), 18);
                                        if (W0b(d)) continue;
                                        Rmb(a.c, d);
                                        OUc(a, d);
                                        h = d.c.i.k;
                                        (h == (r3b(), p3b) || h == q3b || h == m3b || h == l3b) && Rmb(a.j, d);
                                        n = d.d;
                                        m = n.i.c;
                                        m == c ? Ysb(a.f, n) : m == b ? Ysb(a.e, n) : Ymb(a.c, d);
                                    }
                                }
                            }
                        }
                        function iSc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
                            c.Ug('Polyline edge routing', 1);
                            q = Kfb(UD(mQb(b, (yCc(), AAc))));
                            n = Kfb(UD(mQb(b, cCc)));
                            e = Kfb(UD(mQb(b, UBc)));
                            d = $wnd.Math.min(1, e / n);
                            t = 0;
                            i = 0;
                            if (b.b.c.length != 0) {
                                u = fSc(RD(Vmb(b.b, 0), 30));
                                t = 0.4 * d * u;
                            }
                            h = new Jkb(b.b, 0);
                            while(h.b < h.d.gc()){
                                g = (sFb(h.b < h.d.gc()), RD(h.d.Xb(h.c = h.b++), 30));
                                f = ar(g, bSc);
                                f && t > 0 && (t -= n);
                                p2b(g, t);
                                k = 0;
                                for(m = new Anb(g.a); m.a < m.c.c.length;){
                                    l = RD(ynb(m), 10);
                                    j = 0;
                                    for(p = new is(Mr(a3b(l).a.Kc(), new ir)); gs(p);){
                                        o = RD(hs(p), 18);
                                        r = K3b(o.c).b;
                                        s = K3b(o.d).b;
                                        if (g == o.d.i.c && !W0b(o)) {
                                            jSc(o, t, 0.4 * d * $wnd.Math.abs(r - s));
                                            if (o.c.j == (qpd(), ppd)) {
                                                r = 0;
                                                s = 0;
                                            }
                                        }
                                        j = $wnd.Math.max(j, $wnd.Math.abs(s - r));
                                    }
                                    switch(l.k.g){
                                        case 0:
                                        case 4:
                                        case 1:
                                        case 3:
                                        case 5:
                                            kSc(a, l, t, q);
                                    }
                                    k = $wnd.Math.max(k, j);
                                }
                                if (h.b < h.d.gc()) {
                                    u = fSc((sFb(h.b < h.d.gc()), RD(h.d.Xb(h.c = h.b++), 30)));
                                    k = $wnd.Math.max(k, u);
                                    sFb(h.b > 0);
                                    h.a.Xb(h.c = --h.b);
                                }
                                i = 0.4 * d * k;
                                !f && h.b < h.d.gc() && (i += n);
                                t += g.c.a + i;
                            }
                            a.a.a.$b();
                            b.f.a = t;
                            c.Vg();
                        }
                        function GGd(a) {
                            var b, c, d, e, f;
                            Ivb(a, IIe);
                            switch((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b).i + (!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c).i){
                                case 0:
                                    throw Adb(new agb('The edge must have at least one source or target.'));
                                case 1:
                                    return (!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b).i == 0 ? vCd(AGd(RD(QHd((!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c), 0), 84))) : vCd(AGd(RD(QHd((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b), 0), 84)));
                            }
                            if ((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b).i == 1 && (!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c).i == 1) {
                                e = AGd(RD(QHd((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b), 0), 84));
                                f = AGd(RD(QHd((!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c), 0), 84));
                                if (vCd(e) == vCd(f)) return vCd(e);
                                else if (e == vCd(f)) return e;
                                else if (f == vCd(e)) return f;
                            }
                            d = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                (!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b),
                                (!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c)
                            ])));
                            b = AGd(RD(hs(d), 84));
                            while(gs(d)){
                                c = AGd(RD(hs(d), 84));
                                if (c != b && !NGd(c, b)) {
                                    if (vCd(c) == vCd(b)) b = vCd(c);
                                    else {
                                        b = HGd(b, c);
                                        if (!b) return null;
                                    }
                                }
                            }
                            return b;
                        }
                        function _zd(b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
                            n = c.length;
                            if (n > 0) {
                                j = (BFb(0, c.length), c.charCodeAt(0));
                                if (j != 64) {
                                    if (j == 37) {
                                        m = c.lastIndexOf('%');
                                        k = false;
                                        if (m != 0 && (m == n - 1 || (k = (BFb(m + 1, c.length), c.charCodeAt(m + 1) == 46)))) {
                                            h = (AFb(1, m, c.length), c.substr(1, m - 1));
                                            u = lhb('%', h) ? null : oSd(h);
                                            e = 0;
                                            if (k) try {
                                                e = Oeb((BFb(m + 2, c.length + 1), c.substr(m + 2)), qwe, lve);
                                            } catch (a) {
                                                a = zdb(a);
                                                if (ZD(a, 130)) {
                                                    i = a;
                                                    throw Adb(new RSd(i));
                                                } else throw Adb(a);
                                            }
                                            for(r = P2d(b.Gh()); r.Ob();){
                                                p = k3d(r);
                                                if (ZD(p, 519)) {
                                                    f = RD(p, 598);
                                                    t = f.d;
                                                    if ((u == null ? t == null : lhb(u, t)) && e-- == 0) return f;
                                                }
                                            }
                                            return null;
                                        }
                                    }
                                    l = c.lastIndexOf('.');
                                    o = l == -1 ? c : (AFb(0, l, c.length), c.substr(0, l));
                                    d = 0;
                                    if (l != -1) try {
                                        d = Oeb((BFb(l + 1, c.length + 1), c.substr(l + 1)), qwe, lve);
                                    } catch (a) {
                                        a = zdb(a);
                                        if (ZD(a, 130)) o = c;
                                        else throw Adb(a);
                                    }
                                    o = lhb('%', o) ? null : oSd(o);
                                    for(q = P2d(b.Gh()); q.Ob();){
                                        p = k3d(q);
                                        if (ZD(p, 197)) {
                                            g = RD(p, 197);
                                            s = g.xe();
                                            if ((o == null ? s == null : lhb(o, s)) && d-- == 0) return g;
                                        }
                                    }
                                    return null;
                                }
                            }
                            return Pvd(b, c);
                        }
                        function Hlc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
                            k = new Tsb;
                            i = new Tp;
                            for(d = new Anb(a.a.a.b); d.a < d.c.c.length;){
                                b = RD(ynb(d), 60);
                                j = Zjc(b);
                                if (j) rtb(k.f, j, b);
                                else {
                                    s = $jc(b);
                                    if (s) for(f = new Anb(s.k); f.a < f.c.c.length;){
                                        e = RD(ynb(f), 18);
                                        Rc(i, e, b);
                                    }
                                }
                            }
                            for(c = new Anb(a.a.a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 60);
                                j = Zjc(b);
                                if (j) for(h = new is(Mr(a3b(j).a.Kc(), new ir)); gs(h);){
                                    g = RD(hs(h), 18);
                                    if (W0b(g)) continue;
                                    o = g.c;
                                    r = g.d;
                                    if ((qpd(), hpd).Hc(g.c.j) && hpd.Hc(g.d.j)) continue;
                                    p = RD(Wjb(k, g.d.i), 60);
                                    rIb(uIb(tIb(vIb(sIb(new wIb, 0), 100), a.c[b.a.d]), a.c[p.a.d]));
                                    if (o.j == ppd && q4b((J3b(), G3b, o))) for(m = RD(Qc(i, g), 21).Kc(); m.Ob();){
                                        l = RD(m.Pb(), 60);
                                        if (l.d.c < b.d.c) {
                                            n = a.c[l.a.d];
                                            q = a.c[b.a.d];
                                            if (n == q) continue;
                                            rIb(uIb(tIb(vIb(sIb(new wIb, 1), 100), n), q));
                                        }
                                    }
                                    if (r.j == Xod && v4b((J3b(), E3b, r))) for(m = RD(Qc(i, g), 21).Kc(); m.Ob();){
                                        l = RD(m.Pb(), 60);
                                        if (l.d.c > b.d.c) {
                                            n = a.c[b.a.d];
                                            q = a.c[l.a.d];
                                            if (n == q) continue;
                                            rIb(uIb(tIb(vIb(sIb(new wIb, 1), 100), n), q));
                                        }
                                    }
                                }
                            }
                        }
                        function mNb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
                            m = RD(RD(Qc(a.r, b), 21), 87);
                            if (b == (qpd(), Xod) || b == ppd) {
                                qNb(a, b);
                                return;
                            }
                            f = b == Yod ? (mOb(), iOb) : (mOb(), lOb);
                            u = b == Yod ? (vLb(), uLb) : (vLb(), sLb);
                            c = RD(Vrb(a.b, b), 127);
                            d = c.i;
                            e = d.c + Hid(cD(WC(iE, 1), vxe, 28, 15, [
                                c.n.b,
                                a.C.b,
                                a.k
                            ]));
                            r = d.c + d.b - Hid(cD(WC(iE, 1), vxe, 28, 15, [
                                c.n.c,
                                a.C.c,
                                a.k
                            ]));
                            g = WNb(_Nb(f), a.t);
                            s = b == Yod ? pxe : oxe;
                            for(l = m.Kc(); l.Ob();){
                                j = RD(l.Pb(), 117);
                                if (!j.c || j.c.d.c.length <= 0) continue;
                                q = j.b.Mf();
                                p = j.e;
                                n = j.c;
                                o = n.i;
                                o.b = (i = n.n, n.e.a + i.b + i.c);
                                o.a = (h = n.n, n.e.b + h.d + h.a);
                                Ivb(u, Pye);
                                n.f = u;
                                RKb(n, (EKb(), DKb));
                                o.c = p.a - (o.b - q.a) / 2;
                                v = $wnd.Math.min(e, p.a);
                                w = $wnd.Math.max(r, p.a + q.a);
                                o.c < v ? o.c = v : o.c + o.b > w && (o.c = w - o.b);
                                Rmb(g.d, new sOb(o, UNb(g, o)));
                                s = b == Yod ? $wnd.Math.max(s, p.b + j.b.Mf().b) : $wnd.Math.min(s, p.b);
                            }
                            s += b == Yod ? a.t : -a.t;
                            t = VNb((g.e = s, g));
                            t > 0 && (RD(Vrb(a.b, b), 127).a.b = t);
                            for(k = m.Kc(); k.Ob();){
                                j = RD(k.Pb(), 117);
                                if (!j.c || j.c.d.c.length <= 0) continue;
                                o = j.c.i;
                                o.c -= j.e.a;
                                o.d -= j.e.b;
                            }
                        }
                        function JSb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n;
                            b = new Tsb;
                            for(i = new dMd(a); i.e != i.i.gc();){
                                h = RD(bMd(i), 27);
                                c = new _sb;
                                Zjb(FSb, h, c);
                                n = new TSb;
                                e = RD(zDb(new SDb(null, new Twb(new is(Mr(yGd(h).a.Kc(), new ir)))), OBb(n, tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                    (xBb(), vBb)
                                ])))), 85);
                                ISb(c, RD(e.xc((Geb(), true)), 16), new VSb);
                                d = RD(zDb(CDb(RD(e.xc(false), 15).Lc(), new XSb), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                    vBb
                                ]))), 15);
                                for(g = d.Kc(); g.Ob();){
                                    f = RD(g.Pb(), 74);
                                    m = KGd(f);
                                    if (m) {
                                        j = RD(Wd(qtb(b.f, m)), 21);
                                        if (!j) {
                                            j = LSb(m);
                                            rtb(b.f, m, j);
                                        }
                                        ye(c, j);
                                    }
                                }
                                e = RD(zDb(new SDb(null, new Twb(new is(Mr(zGd(h).a.Kc(), new ir)))), OBb(n, tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                    vBb
                                ])))), 85);
                                ISb(c, RD(e.xc(true), 16), new ZSb);
                                d = RD(zDb(CDb(RD(e.xc(false), 15).Lc(), new _Sb), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                    vBb
                                ]))), 15);
                                for(l = d.Kc(); l.Ob();){
                                    k = RD(l.Pb(), 74);
                                    m = MGd(k);
                                    if (m) {
                                        j = RD(Wd(qtb(b.f, m)), 21);
                                        if (!j) {
                                            j = LSb(m);
                                            rtb(b.f, m, j);
                                        }
                                        ye(c, j);
                                    }
                                }
                            }
                        }
                        function zjb(a, b) {
                            xjb();
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
                            i = Ddb(a, 0) < 0;
                            i && (a = Odb(a));
                            if (Ddb(a, 0) == 0) switch(b){
                                case 0:
                                    return '0';
                                case 1:
                                    return zxe;
                                case 2:
                                    return '0.00';
                                case 3:
                                    return '0.000';
                                case 4:
                                    return '0.0000';
                                case 5:
                                    return '0.00000';
                                case 6:
                                    return '0.000000';
                                default:
                                    n = new bib;
                                    b < 0 ? (n.a += '0E+', n) : (n.a += '0E', n);
                                    n.a += b == qwe ? '2147483648' : '' + -b;
                                    return n.a;
                            }
                            k = 18;
                            l = $C(hE, zwe, 28, k + 1, 15, 1);
                            c = k;
                            p = a;
                            do {
                                j = p;
                                p = Fdb(p, 10);
                                l[--c] = Ydb(Bdb(48, Vdb(j, Ndb(p, 10)))) & Bwe;
                            }while (Ddb(p, 0) != 0);
                            e = Vdb(Vdb(Vdb(k, c), b), 1);
                            if (b == 0) {
                                i && (l[--c] = 45);
                                return Ihb(l, c, k - c);
                            }
                            if (b > 0 && Ddb(e, -6) >= 0) {
                                if (Ddb(e, 0) >= 0) {
                                    f = c + Ydb(e);
                                    for(h = k - 1; h >= f; h--)l[h + 1] = l[h];
                                    l[++f] = 46;
                                    i && (l[--c] = 45);
                                    return Ihb(l, c, k - c + 1);
                                }
                                for(g = 2; Ldb(g, Bdb(Odb(e), 1)); g++)l[--c] = 48;
                                l[--c] = 46;
                                l[--c] = 48;
                                i && (l[--c] = 45);
                                return Ihb(l, c, k - c);
                            }
                            o = c + 1;
                            d = k;
                            m = new cib;
                            i && (m.a += '-', m);
                            if (d - o >= 1) {
                                Thb(m, l[c]);
                                m.a += '.';
                                m.a += Ihb(l, c + 1, k - c - 1);
                            } else m.a += Ihb(l, c, k - c);
                            m.a += 'E';
                            Ddb(e, 0) > 0 && (m.a += '+', m);
                            m.a += '' + Zdb(e);
                            return m.a;
                        }
                        function Esd(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
                            q = new rjd(a.g, a.f);
                            p = vsd(a);
                            p.a = $wnd.Math.max(p.a, b);
                            p.b = $wnd.Math.max(p.b, c);
                            w = p.a / q.a;
                            k = p.b / q.b;
                            u = p.a - q.a;
                            i = p.b - q.b;
                            if (d) {
                                g = !vCd(a) ? RD(Gxd(a, (umd(), Nkd)), 88) : RD(Gxd(vCd(a), (umd(), Nkd)), 88);
                                h = dE(Gxd(a, (umd(), Hld))) === dE((Bod(), wod));
                                for(s = new dMd((!a.c && (a.c = new C5d(K4, a, 9, 9)), a.c)); s.e != s.i.gc();){
                                    r = RD(bMd(s), 123);
                                    t = RD(Gxd(r, Old), 64);
                                    if (t == (qpd(), opd)) {
                                        t = osd(r, g);
                                        Ixd(r, Old, t);
                                    }
                                    switch(t.g){
                                        case 1:
                                            h || Dyd(r, r.i * w);
                                            break;
                                        case 2:
                                            Dyd(r, r.i + u);
                                            h || Eyd(r, r.j * k);
                                            break;
                                        case 3:
                                            h || Dyd(r, r.i * w);
                                            Eyd(r, r.j + i);
                                            break;
                                        case 4:
                                            h || Eyd(r, r.j * k);
                                    }
                                }
                            }
                            zyd(a, p.a, p.b);
                            if (e) for(m = new dMd((!a.n && (a.n = new C5d(I4, a, 1, 7)), a.n)); m.e != m.i.gc();){
                                l = RD(bMd(m), 135);
                                n = l.i + l.g / 2;
                                o = l.j + l.f / 2;
                                v = n / q.a;
                                j = o / q.b;
                                if (v + j >= 1) {
                                    if (v - j > 0 && o >= 0) {
                                        Dyd(l, l.i + u);
                                        Eyd(l, l.j + i * j);
                                    } else if (v - j < 0 && n >= 0) {
                                        Dyd(l, l.i + u * v);
                                        Eyd(l, l.j + i);
                                    }
                                }
                            }
                            Ixd(a, (umd(), kld), (Qpd(), f = RD(mfb(H3), 9), new Fsb(f, RD(WEb(f, f.length), 9), 0)));
                            return new rjd(w, k);
                        }
                        function _4c(a) {
                            Cgd(a, new Pfd(Wfd($fd(Xfd(Zfd(Yfd(new agd, CFe), 'ELK Radial'), 'A radial layout provider which is based on the algorithm of Peter Eades published in "Drawing free trees.", published by International Institute for Advanced Study of Social Information Science, Fujitsu Limited in 1991. The radial layouter takes a tree and places the nodes in radial order around the root. The nodes of the same tree level are placed on the same radius.'), new c5c), CFe)));
                            Agd(a, CFe, fEe, iGd(R4c));
                            Agd(a, CFe, _ze, iGd(Y4c));
                            Agd(a, CFe, jAe, iGd(K4c));
                            Agd(a, CFe, CAe, iGd(L4c));
                            Agd(a, CFe, iAe, iGd(M4c));
                            Agd(a, CFe, kAe, iGd(J4c));
                            Agd(a, CFe, gAe, iGd(N4c));
                            Agd(a, CFe, lAe, iGd(Q4c));
                            Agd(a, CFe, tFe, iGd(H4c));
                            Agd(a, CFe, sFe, iGd(I4c));
                            Agd(a, CFe, rFe, iGd(T4c));
                            Agd(a, CFe, xFe, iGd(W4c));
                            Agd(a, CFe, yFe, iGd(U4c));
                            Agd(a, CFe, zFe, iGd(V4c));
                            Agd(a, CFe, wFe, iGd(O4c));
                            Agd(a, CFe, pFe, iGd(P4c));
                            Agd(a, CFe, qFe, iGd(S4c));
                            Agd(a, CFe, uFe, iGd(X4c));
                            Agd(a, CFe, vFe, iGd(Z4c));
                            Agd(a, CFe, oFe, iGd(G4c));
                        }
                        function Peb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l;
                            if (a == null) throw Adb(new Vgb(vve));
                            j = a;
                            f = a.length;
                            i = false;
                            if (f > 0) {
                                b = (BFb(0, a.length), a.charCodeAt(0));
                                if (b == 45 || b == 43) {
                                    a = (BFb(1, a.length + 1), a.substr(1));
                                    --f;
                                    i = b == 45;
                                }
                            }
                            if (f == 0) throw Adb(new Vgb(nxe + j + '"'));
                            while(a.length > 0 && (BFb(0, a.length), a.charCodeAt(0) == 48)){
                                a = (BFb(1, a.length + 1), a.substr(1));
                                --f;
                            }
                            if (f > (Ugb(), Sgb)[10]) throw Adb(new Vgb(nxe + j + '"'));
                            for(e = 0; e < f; e++){
                                if (dfb((BFb(e, a.length), a.charCodeAt(e))) == -1) throw Adb(new Vgb(nxe + j + '"'));
                            }
                            l = 0;
                            g = Qgb[10];
                            k = Rgb[10];
                            h = Odb(Tgb[10]);
                            c = true;
                            d = f % g;
                            if (d > 0) {
                                l = -parseInt((AFb(0, d, a.length), a.substr(0, d)), 10);
                                a = (BFb(d, a.length + 1), a.substr(d));
                                f -= d;
                                c = false;
                            }
                            while(f >= g){
                                d = parseInt((AFb(0, g, a.length), a.substr(0, g)), 10);
                                a = (BFb(g, a.length + 1), a.substr(g));
                                f -= g;
                                if (c) c = false;
                                else {
                                    if (Ddb(l, h) < 0) throw Adb(new Vgb(nxe + j + '"'));
                                    l = Ndb(l, k);
                                }
                                l = Vdb(l, d);
                            }
                            if (Ddb(l, 0) > 0) throw Adb(new Vgb(nxe + j + '"'));
                            if (!i) {
                                l = Odb(l);
                                if (Ddb(l, 0) < 0) throw Adb(new Vgb(nxe + j + '"'));
                            }
                            return l;
                        }
                        function oSd(a) {
                            gSd();
                            var b, c, d, e, f, g, h, i;
                            if (a == null) return null;
                            e = qhb(a, Fhb(37));
                            if (e < 0) return a;
                            else {
                                i = new dib((AFb(0, e, a.length), a.substr(0, e)));
                                b = $C(gE, YHe, 28, 4, 15, 1);
                                h = 0;
                                d = 0;
                                for(g = a.length; e < g; e++){
                                    BFb(e, a.length);
                                    if (a.charCodeAt(e) == 37 && a.length > e + 2 && zSd((BFb(e + 1, a.length), a.charCodeAt(e + 1)), XRd, YRd) && zSd((BFb(e + 2, a.length), a.charCodeAt(e + 2)), XRd, YRd)) {
                                        c = DSd((BFb(e + 1, a.length), a.charCodeAt(e + 1)), (BFb(e + 2, a.length), a.charCodeAt(e + 2)));
                                        e += 2;
                                        if (d > 0) (c & 192) == 128 ? b[h++] = c << 24 >> 24 : d = 0;
                                        else if (c >= 128) {
                                            if ((c & 224) == 192) {
                                                b[h++] = c << 24 >> 24;
                                                d = 2;
                                            } else if ((c & 240) == 224) {
                                                b[h++] = c << 24 >> 24;
                                                d = 3;
                                            } else if ((c & 248) == 240) {
                                                b[h++] = c << 24 >> 24;
                                                d = 4;
                                            }
                                        }
                                        if (d > 0) {
                                            if (h == d) {
                                                switch(h){
                                                    case 2:
                                                        Thb(i, ((b[0] & 31) << 6 | b[1] & 63) & Bwe);
                                                        break;
                                                    case 3:
                                                        Thb(i, ((b[0] & 15) << 12 | (b[1] & 63) << 6 | b[2] & 63) & Bwe);
                                                        break;
                                                }
                                                h = 0;
                                                d = 0;
                                            }
                                        } else {
                                            for(f = 0; f < h; ++f)Thb(i, b[f] & Bwe);
                                            h = 0;
                                            i.a += String.fromCharCode(c);
                                        }
                                    } else {
                                        for(f = 0; f < h; ++f)Thb(i, b[f] & Bwe);
                                        h = 0;
                                        Thb(i, (BFb(e, a.length), a.charCodeAt(e)));
                                    }
                                }
                                return i.a;
                            }
                        }
                        function atd(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o;
                            n = vCd(AGd(RD(QHd((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b), 0), 84)));
                            o = vCd(AGd(RD(QHd((!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c), 0), 84)));
                            l = n == o;
                            h = new pjd;
                            b = RD(Gxd(a, (vnd(), ond)), 75);
                            if (!!b && b.b >= 2) {
                                if ((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a).i == 0) {
                                    c = (bvd(), e = new Rzd, e);
                                    WGd((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a), c);
                                } else if ((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a).i > 1) {
                                    m = new mMd((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a));
                                    while(m.e != m.i.gc())cMd(m);
                                }
                                lsd(b, RD(QHd((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a), 0), 166));
                            }
                            if (l) for(d = new dMd((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a)); d.e != d.i.gc();){
                                c = RD(bMd(d), 166);
                                for(j = new dMd((!c.a && (c.a = new XZd(D4, c, 5)), c.a)); j.e != j.i.gc();){
                                    i = RD(bMd(j), 377);
                                    h.a = $wnd.Math.max(h.a, i.a);
                                    h.b = $wnd.Math.max(h.b, i.b);
                                }
                            }
                            for(g = new dMd((!a.n && (a.n = new C5d(I4, a, 1, 7)), a.n)); g.e != g.i.gc();){
                                f = RD(bMd(g), 135);
                                k = RD(Gxd(f, und), 8);
                                !!k && Byd(f, k.a, k.b);
                                if (l) {
                                    h.a = $wnd.Math.max(h.a, f.i + f.g);
                                    h.b = $wnd.Math.max(h.b, f.j + f.f);
                                }
                            }
                            return h;
                        }
                        function MA(a, b, c, d, e) {
                            var f, g, h;
                            KA(a, b);
                            g = b[0];
                            f = ihb(c.c, 0);
                            h = -1;
                            if (DA(c)) {
                                if (d > 0) {
                                    if (g + d > a.length) return false;
                                    h = HA((AFb(0, g + d, a.length), a.substr(0, g + d)), b);
                                } else h = HA(a, b);
                            }
                            switch(f){
                                case 71:
                                    h = EA(a, g, cD(WC(qJ, 1), Nve, 2, 6, [
                                        Qwe,
                                        Rwe
                                    ]), b);
                                    e.e = h;
                                    return true;
                                case 77:
                                    return PA(a, b, e, h, g);
                                case 76:
                                    return RA(a, b, e, h, g);
                                case 69:
                                    return NA(a, b, g, e);
                                case 99:
                                    return QA(a, b, g, e);
                                case 97:
                                    h = EA(a, g, cD(WC(qJ, 1), Nve, 2, 6, [
                                        'AM',
                                        'PM'
                                    ]), b);
                                    e.b = h;
                                    return true;
                                case 121:
                                    return TA(a, b, g, h, c, e);
                                case 100:
                                    if (h <= 0) return false;
                                    e.c = h;
                                    return true;
                                case 83:
                                    if (h < 0) return false;
                                    return OA(h, g, b[0], e);
                                case 104:
                                    h == 12 && (h = 0);
                                case 75:
                                case 72:
                                    if (h < 0) return false;
                                    e.f = h;
                                    e.g = false;
                                    return true;
                                case 107:
                                    if (h < 0) return false;
                                    e.f = h;
                                    e.g = true;
                                    return true;
                                case 109:
                                    if (h < 0) return false;
                                    e.j = h;
                                    return true;
                                case 115:
                                    if (h < 0) return false;
                                    e.n = h;
                                    return true;
                                case 90:
                                    if (g < a.length && (BFb(g, a.length), a.charCodeAt(g) == 90)) {
                                        ++b[0];
                                        e.o = 0;
                                        return true;
                                    }
                                case 122:
                                case 118:
                                    return SA(a, g, b, e);
                                default:
                                    return false;
                            }
                        }
                        function YQc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
                            t = b.c.length;
                            e = new sQc(a.a, c, null, null);
                            B = $C(iE, vxe, 28, t, 15, 1);
                            p = $C(iE, vxe, 28, t, 15, 1);
                            o = $C(iE, vxe, 28, t, 15, 1);
                            q = 0;
                            for(h = 0; h < t; h++){
                                p[h] = lve;
                                o[h] = qwe;
                            }
                            for(i = 0; i < t; i++){
                                d = (tFb(i, b.c.length), RD(b.c[i], 185));
                                B[i] = qQc(d);
                                B[q] > B[i] && (q = i);
                                for(l = new Anb(a.a.b); l.a < l.c.c.length;){
                                    k = RD(ynb(l), 30);
                                    for(s = new Anb(k.a); s.a < s.c.c.length;){
                                        r = RD(ynb(s), 10);
                                        w = Kfb(d.p[r.p]) + Kfb(d.d[r.p]);
                                        p[i] = $wnd.Math.min(p[i], w);
                                        o[i] = $wnd.Math.max(o[i], w + r.o.b);
                                    }
                                }
                            }
                            A = $C(iE, vxe, 28, t, 15, 1);
                            for(j = 0; j < t; j++)(tFb(j, b.c.length), RD(b.c[j], 185)).o == (EQc(), CQc) ? A[j] = p[q] - p[j] : A[j] = o[q] - o[j];
                            f = $C(iE, vxe, 28, t, 15, 1);
                            for(n = new Anb(a.a.b); n.a < n.c.c.length;){
                                m = RD(ynb(n), 30);
                                for(v = new Anb(m.a); v.a < v.c.c.length;){
                                    u = RD(ynb(v), 10);
                                    for(g = 0; g < t; g++)f[g] = Kfb((tFb(g, b.c.length), RD(b.c[g], 185)).p[u.p]) + Kfb((tFb(g, b.c.length), RD(b.c[g], 185)).d[u.p]) + A[g];
                                    bFb(f, heb(iob.prototype.Me, iob, []));
                                    e.p[u.p] = (f[1] + f[2]) / 2;
                                    e.d[u.p] = 0;
                                }
                            }
                            return e;
                        }
                        function X6b(a, b, c) {
                            var d, e, f, g, h;
                            d = b.i;
                            f = a.i.o;
                            e = a.i.d;
                            h = a.n;
                            g = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                h,
                                a.a
                            ]));
                            switch(a.j.g){
                                case 1:
                                    SKb(b, (vLb(), sLb));
                                    d.d = -e.d - c - d.a;
                                    if (RD(RD(Vmb(b.d, 0), 187).of((Ywc(), swc)), 291) == (Pnd(), Lnd)) {
                                        RKb(b, (EKb(), DKb));
                                        d.c = g.a - Kfb(UD(mQb(a, ywc))) - c - d.b;
                                    } else {
                                        RKb(b, (EKb(), CKb));
                                        d.c = g.a + Kfb(UD(mQb(a, ywc))) + c;
                                    }
                                    break;
                                case 2:
                                    RKb(b, (EKb(), CKb));
                                    d.c = f.a + e.c + c;
                                    if (RD(RD(Vmb(b.d, 0), 187).of((Ywc(), swc)), 291) == (Pnd(), Lnd)) {
                                        SKb(b, (vLb(), sLb));
                                        d.d = g.b - Kfb(UD(mQb(a, ywc))) - c - d.a;
                                    } else {
                                        SKb(b, (vLb(), uLb));
                                        d.d = g.b + Kfb(UD(mQb(a, ywc))) + c;
                                    }
                                    break;
                                case 3:
                                    SKb(b, (vLb(), uLb));
                                    d.d = f.b + e.a + c;
                                    if (RD(RD(Vmb(b.d, 0), 187).of((Ywc(), swc)), 291) == (Pnd(), Lnd)) {
                                        RKb(b, (EKb(), DKb));
                                        d.c = g.a - Kfb(UD(mQb(a, ywc))) - c - d.b;
                                    } else {
                                        RKb(b, (EKb(), CKb));
                                        d.c = g.a + Kfb(UD(mQb(a, ywc))) + c;
                                    }
                                    break;
                                case 4:
                                    RKb(b, (EKb(), DKb));
                                    d.c = -e.b - c - d.b;
                                    if (RD(RD(Vmb(b.d, 0), 187).of((Ywc(), swc)), 291) == (Pnd(), Lnd)) {
                                        SKb(b, (vLb(), sLb));
                                        d.d = g.b - Kfb(UD(mQb(a, ywc))) - c - d.a;
                                    } else {
                                        SKb(b, (vLb(), uLb));
                                        d.d = g.b + Kfb(UD(mQb(a, ywc))) + c;
                                    }
                            }
                        }
                        function Q8c(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p;
                            c.Ug(AFe, 1);
                            !b.a && (b.a = new C5d(J4, b, 10, 11));
                            d = Kfb(UD(Gxd(b, (X7c(), x7c))));
                            k = Kfb(UD(Gxd(b, Q7c)));
                            m = RD(Gxd(b, N7c), 107);
                            n = new m9c(d, k);
                            f = l9c(n, b, m);
                            P8c(b, n);
                            h = RD(Gxd(b, K7c), 17).a;
                            while(h > 1){
                                e = N8c(b);
                                l = f.g;
                                o = RD(Gxd(b, N7c), 107);
                                p = Kfb(UD(Gxd(b, x7c)));
                                (!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a).i > 1 && Kfb(UD(Gxd(b, (X6c(), T6c)))) != oxe && (f.c + (o.b + o.c)) / (f.b + (o.d + o.a)) < p ? Ixd(e, (X6c(), W6c), Kfb(UD(Gxd(b, W6c))) + Kfb(UD(Gxd(b, T6c)))) : (!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a).i > 1 && Kfb(UD(Gxd(b, (X6c(), S6c)))) != oxe && (f.c + (o.b + o.c)) / (f.b + (o.d + o.a)) > p && Ixd(e, (X6c(), W6c), $wnd.Math.max(Kfb(UD(Gxd(b, U6c))), Kfb(UD(Gxd(e, W6c))) - Kfb(UD(Gxd(b, S6c)))));
                                n = new m9c(d, k);
                                i = l9c(n, e, m);
                                j = i.g;
                                if (j >= l && j == j) {
                                    for(g = 0; g < (!e.a && (e.a = new C5d(J4, e, 10, 11)), e.a).i; g++)O8c(a, RD(QHd((!e.a && (e.a = new C5d(J4, e, 10, 11)), e.a), g), 27), RD(QHd((!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a), g), 27));
                                    P8c(b, n);
                                    jad(f, i.c);
                                    iad(f, i.b);
                                }
                                --h;
                            }
                            Ixd(b, (X6c(), N6c), f.b);
                            Ixd(b, O6c, f.c);
                            c.Vg();
                        }
                        function fHc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
                            b.Ug('Interactive node layering', 1);
                            c = new bnb;
                            for(m = new Anb(a.a); m.a < m.c.c.length;){
                                k = RD(ynb(m), 10);
                                i = k.n.a;
                                h = i + k.o.a;
                                h = $wnd.Math.max(i + 1, h);
                                s = new Jkb(c, 0);
                                d = null;
                                while(s.b < s.d.gc()){
                                    q = (sFb(s.b < s.d.gc()), RD(s.d.Xb(s.c = s.b++), 578));
                                    if (q.c >= h) {
                                        sFb(s.b > 0);
                                        s.a.Xb(s.c = --s.b);
                                        break;
                                    } else if (q.a > i) {
                                        if (!d) {
                                            Rmb(q.b, k);
                                            q.c = $wnd.Math.min(q.c, i);
                                            q.a = $wnd.Math.max(q.a, h);
                                            d = q;
                                        } else {
                                            Tmb(d.b, q.b);
                                            d.a = $wnd.Math.max(d.a, q.a);
                                            Ckb(s);
                                        }
                                    }
                                }
                                if (!d) {
                                    d = new jHc;
                                    d.c = i;
                                    d.a = h;
                                    Ikb(s, d);
                                    Rmb(d.b, k);
                                }
                            }
                            g = a.b;
                            j = 0;
                            for(r = new Anb(c); r.a < r.c.c.length;){
                                q = RD(ynb(r), 578);
                                e = new R4b(a);
                                e.p = j++;
                                ZEb(g.c, e);
                                for(n = new Anb(q.b); n.a < n.c.c.length;){
                                    k = RD(ynb(n), 10);
                                    g3b(k, e);
                                    k.p = 0;
                                }
                            }
                            for(l = new Anb(a.a); l.a < l.c.c.length;){
                                k = RD(ynb(l), 10);
                                if (k.p == 0) {
                                    p = eHc(k, a);
                                    while(p.a.gc() != 0){
                                        o = RD(p.a.ec().Kc().Pb(), 10);
                                        p.a.Bc(o);
                                        ye(p, eHc(o, a));
                                    }
                                }
                            }
                            f = new Jkb(g, 0);
                            while(f.b < f.d.gc())(sFb(f.b < f.d.gc()), RD(f.d.Xb(f.c = f.b++), 30)).a.c.length == 0 && Ckb(f);
                            a.a.c.length = 0;
                            b.Vg();
                        }
                        function grd(a, b, c, d, e, f, g) {
                            var h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
                            n = 0;
                            D = 0;
                            for(i = new Anb(a); i.a < i.c.c.length;){
                                h = RD(ynb(i), 27);
                                Dsd(h);
                                n = $wnd.Math.max(n, h.g);
                                D += h.g * h.f;
                            }
                            o = D / a.c.length;
                            C = ard(a, o);
                            D += a.c.length * C;
                            n = $wnd.Math.max(n, $wnd.Math.sqrt(D * g)) + c.b;
                            H = c.b;
                            I = c.d;
                            m = 0;
                            k = c.b + c.c;
                            B = new Yub;
                            Mub(B, sgb(0));
                            w = new Yub;
                            j = new Jkb(a, 0);
                            while(j.b < j.d.gc()){
                                h = (sFb(j.b < j.d.gc()), RD(j.d.Xb(j.c = j.b++), 27));
                                G = h.g;
                                l = h.f;
                                if (H + G > n) {
                                    if (f) {
                                        Oub(w, m);
                                        Oub(B, sgb(j.b - 1));
                                    }
                                    H = c.b;
                                    I += m + b;
                                    m = 0;
                                    k = $wnd.Math.max(k, c.b + c.c + G);
                                }
                                Dyd(h, H);
                                Eyd(h, I);
                                k = $wnd.Math.max(k, H + G + c.c);
                                m = $wnd.Math.max(m, l);
                                H += G + b;
                            }
                            k = $wnd.Math.max(k, d);
                            F = I + m + c.a;
                            if (F < e) {
                                m += e - F;
                                F = e;
                            }
                            if (f) {
                                H = c.b;
                                j = new Jkb(a, 0);
                                Oub(B, sgb(a.c.length));
                                A = Sub(B, 0);
                                r = RD(evb(A), 17).a;
                                Oub(w, m);
                                v = Sub(w, 0);
                                u = 0;
                                while(j.b < j.d.gc()){
                                    if (j.b == r) {
                                        H = c.b;
                                        u = Kfb(UD(evb(v)));
                                        r = RD(evb(A), 17).a;
                                    }
                                    h = (sFb(j.b < j.d.gc()), RD(j.d.Xb(j.c = j.b++), 27));
                                    s = h.f;
                                    Ayd(h, u);
                                    p = u;
                                    if (j.b == r) {
                                        q = k - H - c.c;
                                        t = h.g;
                                        Cyd(h, q);
                                        Jsd(h, new rjd(q, p), new rjd(t, s));
                                    }
                                    H += h.g + b;
                                }
                            }
                            return new rjd(k, F);
                        }
                        function h0b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C;
                            b.Ug('Compound graph postprocessor', 1);
                            c = Heb(TD(mQb(a, (yCc(), mCc))));
                            h = RD(mQb(a, (Ywc(), _vc)), 229);
                            k = new _sb;
                            for(r = h.ec().Kc(); r.Ob();){
                                q = RD(r.Pb(), 18);
                                g = new dnb(h.cc(q));
                                yob();
                                _mb(g, new M0b(a));
                                v = H0b((tFb(0, g.c.length), RD(g.c[0], 249)));
                                A = I0b(RD(Vmb(g, g.c.length - 1), 249));
                                t = v.i;
                                n2b(A.i, t) ? s = t.e : s = Y2b(t);
                                l = i0b(q, g);
                                Xub(q.a);
                                m = null;
                                for(f = new Anb(g); f.a < f.c.c.length;){
                                    e = RD(ynb(f), 249);
                                    p = new pjd;
                                    e2b(p, e.a, s);
                                    n = e.b;
                                    d = new Ejd;
                                    Ajd(d, 0, n.a);
                                    Cjd(d, p);
                                    u = new sjd(K3b(n.c));
                                    w = new sjd(K3b(n.d));
                                    $id(u, p);
                                    $id(w, p);
                                    if (m) {
                                        d.b == 0 ? o = w : o = (sFb(d.b != 0), RD(d.a.a.c, 8));
                                        B = $wnd.Math.abs(m.a - o.a) > Vze;
                                        C = $wnd.Math.abs(m.b - o.b) > Vze;
                                        (!c && B && C || c && (B || C)) && Mub(q.a, u);
                                    }
                                    ye(q.a, d);
                                    d.b == 0 ? m = u : m = (sFb(d.b != 0), RD(d.c.b.c, 8));
                                    j0b(n, l, p);
                                    if (I0b(e) == A) {
                                        if (Y2b(A.i) != e.a) {
                                            p = new pjd;
                                            e2b(p, Y2b(A.i), s);
                                        }
                                        pQb(q, Wwc, p);
                                    }
                                    k0b(n, q, s);
                                    k.a.zc(n, k);
                                }
                                Y0b(q, v);
                                Z0b(q, A);
                            }
                            for(j = k.a.ec().Kc(); j.Ob();){
                                i = RD(j.Pb(), 18);
                                Y0b(i, null);
                                Z0b(i, null);
                            }
                            b.Vg();
                        }
                        function lXc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m;
                            e = RD(mQb(a, (h_c(), H$c)), 88);
                            k = e == (Cmd(), ymd) || e == zmd ? xmd : zmd;
                            c = RD(zDb(CDb(new SDb(null, new Swb(a.b, 16)), new $Xc), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), vBb)
                            ]))), 15);
                            i = RD(zDb(GDb(c.Oc(), new aYc(b)), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                vBb
                            ]))), 15);
                            i.Gc(RD(zDb(GDb(c.Oc(), new cYc(b)), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                vBb
                            ]))), 16));
                            i.jd(new eYc(k));
                            m = new yAb(new iYc(e));
                            d = new Tsb;
                            for(h = i.Kc(); h.Ob();){
                                g = RD(h.Pb(), 240);
                                j = RD(g.a, 40);
                                if (Heb(TD(g.c))) {
                                    m.a.zc(j, (Geb(), Eeb));
                                    new zAb(m.a.Zc(j, false)).a.gc() > 0 && Zjb(d, j, RD(new zAb(m.a.Zc(j, false)).a.Vc(), 40));
                                    new zAb(m.a.ad(j, true)).a.gc() > 1 && Zjb(d, nXc(m, j), j);
                                } else {
                                    if (new zAb(m.a.Zc(j, false)).a.gc() > 0) {
                                        f = RD(new zAb(m.a.Zc(j, false)).a.Vc(), 40);
                                        dE(f) === dE(Wd(qtb(d.f, j))) && RD(mQb(j, (q$c(), TZc)), 15).Fc(f);
                                    }
                                    if (new zAb(m.a.ad(j, true)).a.gc() > 1) {
                                        l = nXc(m, j);
                                        dE(Wd(qtb(d.f, l))) === dE(j) && RD(mQb(l, (q$c(), TZc)), 15).Fc(j);
                                    }
                                    m.a.Bc(j);
                                }
                            }
                        }
                        function BTb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
                            if (a.gc() == 1) return RD(a.Xb(0), 235);
                            else if (a.gc() <= 0) return new gUb;
                            for(e = a.Kc(); e.Ob();){
                                c = RD(e.Pb(), 235);
                                o = 0;
                                k = lve;
                                l = lve;
                                i = qwe;
                                j = qwe;
                                for(n = new Anb(c.e); n.a < n.c.c.length;){
                                    m = RD(ynb(n), 153);
                                    o += RD(mQb(m, (yVb(), lVb)), 17).a;
                                    k = $wnd.Math.min(k, m.d.a - m.e.a / 2);
                                    l = $wnd.Math.min(l, m.d.b - m.e.b / 2);
                                    i = $wnd.Math.max(i, m.d.a + m.e.a / 2);
                                    j = $wnd.Math.max(j, m.d.b + m.e.b / 2);
                                }
                                pQb(c, (yVb(), lVb), sgb(o));
                                pQb(c, (JVb(), GVb), new rjd(k, l));
                                pQb(c, FVb, new rjd(i, j));
                            }
                            yob();
                            a.jd(new FTb);
                            p = new gUb;
                            kQb(p, RD(a.Xb(0), 96));
                            h = 0;
                            s = 0;
                            for(f = a.Kc(); f.Ob();){
                                c = RD(f.Pb(), 235);
                                q = ojd(ajd(RD(mQb(c, (JVb(), FVb)), 8)), RD(mQb(c, GVb), 8));
                                h = $wnd.Math.max(h, q.a);
                                s += q.a * q.b;
                            }
                            h = $wnd.Math.max(h, $wnd.Math.sqrt(s) * Kfb(UD(mQb(p, (yVb(), ZUb)))));
                            r = Kfb(UD(mQb(p, rVb)));
                            t = 0;
                            u = 0;
                            g = 0;
                            b = r;
                            for(d = a.Kc(); d.Ob();){
                                c = RD(d.Pb(), 235);
                                q = ojd(ajd(RD(mQb(c, (JVb(), FVb)), 8)), RD(mQb(c, GVb), 8));
                                if (t + q.a > h) {
                                    t = 0;
                                    u += g + r;
                                    g = 0;
                                }
                                ATb(p, c, t, u);
                                b = $wnd.Math.max(b, t + q.a);
                                g = $wnd.Math.max(g, q.b);
                                t += q.a + r;
                            }
                            return p;
                        }
                        function Aqe(a) {
                            zqe();
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
                            if (a == null) return null;
                            f = Ahb(a);
                            o = Dqe(f);
                            if (o % 4 != 0) return null;
                            p = o / 4 | 0;
                            if (p == 0) return $C(gE, YHe, 28, 0, 15, 1);
                            l = null;
                            b = 0;
                            c = 0;
                            d = 0;
                            e = 0;
                            g = 0;
                            h = 0;
                            i = 0;
                            j = 0;
                            n = 0;
                            m = 0;
                            k = 0;
                            l = $C(gE, YHe, 28, p * 3, 15, 1);
                            for(; n < p - 1; n++){
                                if (!Cqe(g = f[k++]) || !Cqe(h = f[k++]) || !Cqe(i = f[k++]) || !Cqe(j = f[k++])) return null;
                                b = xqe[g];
                                c = xqe[h];
                                d = xqe[i];
                                e = xqe[j];
                                l[m++] = (b << 2 | c >> 4) << 24 >> 24;
                                l[m++] = ((c & 15) << 4 | d >> 2 & 15) << 24 >> 24;
                                l[m++] = (d << 6 | e) << 24 >> 24;
                            }
                            if (!Cqe(g = f[k++]) || !Cqe(h = f[k++])) return null;
                            b = xqe[g];
                            c = xqe[h];
                            i = f[k++];
                            j = f[k++];
                            if (xqe[i] == -1 || xqe[j] == -1) {
                                if (i == 61 && j == 61) {
                                    if ((c & 15) != 0) return null;
                                    q = $C(gE, YHe, 28, n * 3 + 1, 15, 1);
                                    hib(l, 0, q, 0, n * 3);
                                    q[m] = (b << 2 | c >> 4) << 24 >> 24;
                                    return q;
                                } else if (i != 61 && j == 61) {
                                    d = xqe[i];
                                    if ((d & 3) != 0) return null;
                                    q = $C(gE, YHe, 28, n * 3 + 2, 15, 1);
                                    hib(l, 0, q, 0, n * 3);
                                    q[m++] = (b << 2 | c >> 4) << 24 >> 24;
                                    q[m] = ((c & 15) << 4 | d >> 2 & 15) << 24 >> 24;
                                    return q;
                                } else return null;
                            } else {
                                d = xqe[i];
                                e = xqe[j];
                                l[m++] = (b << 2 | c >> 4) << 24 >> 24;
                                l[m++] = ((c & 15) << 4 | d >> 2 & 15) << 24 >> 24;
                                l[m++] = (d << 6 | e) << 24 >> 24;
                            }
                            return l;
                        }
                        function wfc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
                            b.Ug(qBe, 1);
                            o = RD(mQb(a, (yCc(), yAc)), 223);
                            for(e = new Anb(a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 30);
                                j = t2b(d.a);
                                for(g = j, h = 0, i = g.length; h < i; ++h){
                                    f = g[h];
                                    if (f.k != (r3b(), q3b)) continue;
                                    if (o == (Ymd(), Wmd)) for(l = new Anb(f.j); l.a < l.c.c.length;){
                                        k = RD(ynb(l), 12);
                                        k.e.c.length == 0 || zfc(k);
                                        k.g.c.length == 0 || Afc(k);
                                    }
                                    else if (ZD(mQb(f, (Ywc(), Awc)), 18)) {
                                        q = RD(mQb(f, Awc), 18);
                                        r = RD(e3b(f, (qpd(), ppd)).Kc().Pb(), 12);
                                        s = RD(e3b(f, Xod).Kc().Pb(), 12);
                                        t = RD(mQb(r, Awc), 12);
                                        u = RD(mQb(s, Awc), 12);
                                        Y0b(q, u);
                                        Z0b(q, t);
                                        v = new sjd(s.i.n);
                                        v.a = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                            u.i.n,
                                            u.n,
                                            u.a
                                        ])).a;
                                        Mub(q.a, v);
                                        v = new sjd(r.i.n);
                                        v.a = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                            t.i.n,
                                            t.n,
                                            t.a
                                        ])).a;
                                        Mub(q.a, v);
                                    } else {
                                        if (f.j.c.length >= 2) {
                                            p = true;
                                            m = new Anb(f.j);
                                            c = RD(ynb(m), 12);
                                            n = null;
                                            while(m.a < m.c.c.length){
                                                n = c;
                                                c = RD(ynb(m), 12);
                                                if (!pb(mQb(n, Awc), mQb(c, Awc))) {
                                                    p = false;
                                                    break;
                                                }
                                            }
                                        } else p = false;
                                        for(l = new Anb(f.j); l.a < l.c.c.length;){
                                            k = RD(ynb(l), 12);
                                            k.e.c.length == 0 || xfc(k, p);
                                            k.g.c.length == 0 || yfc(k, p);
                                        }
                                    }
                                    g3b(f, null);
                                }
                            }
                            b.Vg();
                        }
                        function LQc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
                            for(h = new Anb(a.a.b); h.a < h.c.c.length;){
                                f = RD(ynb(h), 30);
                                for(t = new Anb(f.a); t.a < t.c.c.length;){
                                    s = RD(ynb(t), 10);
                                    b.g[s.p] = s;
                                    b.a[s.p] = s;
                                    b.d[s.p] = 0;
                                }
                            }
                            i = a.a.b;
                            b.c == (wQc(), uQc) && (i = hv(i));
                            for(g = i.Kc(); g.Ob();){
                                f = RD(g.Pb(), 30);
                                n = -1;
                                m = f.a;
                                if (b.o == (EQc(), DQc)) {
                                    n = lve;
                                    m = hv(m);
                                }
                                for(v = m.Kc(); v.Ob();){
                                    u = RD(v.Pb(), 10);
                                    l = null;
                                    b.c == uQc ? l = RD(Vmb(a.b.f, u.p), 15) : l = RD(Vmb(a.b.b, u.p), 15);
                                    if (l.gc() > 0) {
                                        d = l.gc();
                                        j = eE($wnd.Math.floor((d + 1) / 2)) - 1;
                                        e = eE($wnd.Math.ceil((d + 1) / 2)) - 1;
                                        if (b.o == DQc) {
                                            for(k = e; k >= j; k--)if (b.a[u.p] == u) {
                                                p = RD(l.Xb(k), 42);
                                                o = RD(p.a, 10);
                                                if (!Zsb(c, p.b) && n > a.b.e[o.p]) {
                                                    b.a[o.p] = u;
                                                    b.g[u.p] = b.g[o.p];
                                                    b.a[u.p] = b.g[u.p];
                                                    b.f[b.g[u.p].p] = (Geb(), Heb(b.f[b.g[u.p].p]) & u.k == (r3b(), o3b) ? true : false);
                                                    n = a.b.e[o.p];
                                                }
                                            }
                                        } else {
                                            for(k = j; k <= e; k++)if (b.a[u.p] == u) {
                                                r = RD(l.Xb(k), 42);
                                                q = RD(r.a, 10);
                                                if (!Zsb(c, r.b) && n < a.b.e[q.p]) {
                                                    b.a[q.p] = u;
                                                    b.g[u.p] = b.g[q.p];
                                                    b.a[u.p] = b.g[u.p];
                                                    b.f[b.g[u.p].p] = (Geb(), Heb(b.f[b.g[u.p].p]) & u.k == (r3b(), o3b) ? true : false);
                                                    n = a.b.e[q.p];
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        function iOc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
                            t = a.c[(tFb(0, b.c.length), RD(b.c[0], 18)).p];
                            A = a.c[(tFb(1, b.c.length), RD(b.c[1], 18)).p];
                            if (t.a.e.e - t.a.a - (t.b.e.e - t.b.a) == 0 && A.a.e.e - A.a.a - (A.b.e.e - A.b.a) == 0) return false;
                            r = t.b.e.f;
                            if (!ZD(r, 10)) return false;
                            q = RD(r, 10);
                            v = a.i[q.p];
                            w = !q.c ? -1 : Wmb(q.c.a, q, 0);
                            f = oxe;
                            if (w > 0) {
                                e = RD(Vmb(q.c.a, w - 1), 10);
                                g = a.i[e.p];
                                B = $wnd.Math.ceil(bFc(a.n, e, q));
                                f = v.a.e - q.d.d - (g.a.e + e.o.b + e.d.a) - B;
                            }
                            j = oxe;
                            if (w < q.c.a.c.length - 1) {
                                i = RD(Vmb(q.c.a, w + 1), 10);
                                k = a.i[i.p];
                                B = $wnd.Math.ceil(bFc(a.n, i, q));
                                j = k.a.e - i.d.d - (v.a.e + q.o.b + q.d.a) - B;
                            }
                            if (c && (Zy(), bz(vEe), $wnd.Math.abs(f - j) <= vEe || f == j || isNaN(f) && isNaN(j))) return true;
                            d = GOc(t.a);
                            h = -GOc(t.b);
                            l = -GOc(A.a);
                            s = GOc(A.b);
                            p = t.a.e.e - t.a.a - (t.b.e.e - t.b.a) > 0 && A.a.e.e - A.a.a - (A.b.e.e - A.b.a) < 0;
                            o = t.a.e.e - t.a.a - (t.b.e.e - t.b.a) < 0 && A.a.e.e - A.a.a - (A.b.e.e - A.b.a) > 0;
                            n = t.a.e.e + t.b.a < A.b.e.e + A.a.a;
                            m = t.a.e.e + t.b.a > A.b.e.e + A.a.a;
                            u = 0;
                            !p && !o && (m ? f + l > 0 ? u = l : j - d > 0 && (u = d) : n && (f + h > 0 ? u = h : j - s > 0 && (u = s)));
                            v.a.e += u;
                            v.b && (v.d.e += u);
                            return false;
                        }
                        function OJb(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            d = new Uid(b.Lf().a, b.Lf().b, b.Mf().a, b.Mf().b);
                            e = new Tid;
                            if (a.c) for(g = new Anb(b.Rf()); g.a < g.c.c.length;){
                                f = RD(ynb(g), 187);
                                e.c = f.Lf().a + b.Lf().a;
                                e.d = f.Lf().b + b.Lf().b;
                                e.b = f.Mf().a;
                                e.a = f.Mf().b;
                                Sid(d, e);
                            }
                            for(j = new Anb(b.Xf()); j.a < j.c.c.length;){
                                i = RD(ynb(j), 852);
                                k = i.Lf().a + b.Lf().a;
                                l = i.Lf().b + b.Lf().b;
                                if (a.e) {
                                    e.c = k;
                                    e.d = l;
                                    e.b = i.Mf().a;
                                    e.a = i.Mf().b;
                                    Sid(d, e);
                                }
                                if (a.d) for(g = new Anb(i.Rf()); g.a < g.c.c.length;){
                                    f = RD(ynb(g), 187);
                                    e.c = f.Lf().a + k;
                                    e.d = f.Lf().b + l;
                                    e.b = f.Mf().a;
                                    e.a = f.Mf().b;
                                    Sid(d, e);
                                }
                                if (a.b) {
                                    m = new rjd(-c, -c);
                                    if (RD(b.of((umd(), Lld)), 181).Hc((Pod(), Nod))) for(g = new Anb(i.Rf()); g.a < g.c.c.length;){
                                        f = RD(ynb(g), 187);
                                        m.a += f.Mf().a + c;
                                        m.b += f.Mf().b + c;
                                    }
                                    m.a = $wnd.Math.max(m.a, 0);
                                    m.b = $wnd.Math.max(m.b, 0);
                                    MJb(d, i.Wf(), i.Uf(), b, i, m, c);
                                }
                            }
                            a.b && MJb(d, b.Wf(), b.Uf(), b, null, null, c);
                            h = new S2b(b.Vf());
                            h.d = $wnd.Math.max(0, b.Lf().b - d.d);
                            h.a = $wnd.Math.max(0, d.d + d.a - (b.Lf().b + b.Mf().b));
                            h.b = $wnd.Math.max(0, b.Lf().a - d.c);
                            h.c = $wnd.Math.max(0, d.c + d.b - (b.Lf().a + b.Mf().a));
                            b.Zf(h);
                        }
                        function Mz() {
                            var a = [
                                '\\u0000',
                                '\\u0001',
                                '\\u0002',
                                '\\u0003',
                                '\\u0004',
                                '\\u0005',
                                '\\u0006',
                                '\\u0007',
                                '\\b',
                                '\\t',
                                '\\n',
                                '\\u000B',
                                '\\f',
                                '\\r',
                                '\\u000E',
                                '\\u000F',
                                '\\u0010',
                                '\\u0011',
                                '\\u0012',
                                '\\u0013',
                                '\\u0014',
                                '\\u0015',
                                '\\u0016',
                                '\\u0017',
                                '\\u0018',
                                '\\u0019',
                                '\\u001A',
                                '\\u001B',
                                '\\u001C',
                                '\\u001D',
                                '\\u001E',
                                '\\u001F'
                            ];
                            a[34] = '\\"';
                            a[92] = '\\\\';
                            a[173] = '\\u00ad';
                            a[1536] = '\\u0600';
                            a[1537] = '\\u0601';
                            a[1538] = '\\u0602';
                            a[1539] = '\\u0603';
                            a[1757] = '\\u06dd';
                            a[1807] = '\\u070f';
                            a[6068] = '\\u17b4';
                            a[6069] = '\\u17b5';
                            a[8203] = '\\u200b';
                            a[8204] = '\\u200c';
                            a[8205] = '\\u200d';
                            a[8206] = '\\u200e';
                            a[8207] = '\\u200f';
                            a[8232] = '\\u2028';
                            a[8233] = '\\u2029';
                            a[8234] = '\\u202a';
                            a[8235] = '\\u202b';
                            a[8236] = '\\u202c';
                            a[8237] = '\\u202d';
                            a[8238] = '\\u202e';
                            a[8288] = '\\u2060';
                            a[8289] = '\\u2061';
                            a[8290] = '\\u2062';
                            a[8291] = '\\u2063';
                            a[8292] = '\\u2064';
                            a[8298] = '\\u206a';
                            a[8299] = '\\u206b';
                            a[8300] = '\\u206c';
                            a[8301] = '\\u206d';
                            a[8302] = '\\u206e';
                            a[8303] = '\\u206f';
                            a[65279] = '\\ufeff';
                            a[65529] = '\\ufff9';
                            a[65530] = '\\ufffa';
                            a[65531] = '\\ufffb';
                            return a;
                        }
                        function zVb(a) {
                            Cgd(a, new Pfd(_fd(Wfd($fd(Xfd(Zfd(Yfd(new agd, Zze), 'ELK Force'), 'Force-based algorithm provided by the Eclipse Layout Kernel. Implements methods that follow physical analogies by simulating forces that move the nodes into a balanced distribution. Currently the original Eades model and the Fruchterman - Reingold model are supported.'), new CVb), Zze), ysb((aGd(), ZFd), cD(WC(T5, 1), jwe, 245, 0, [
                                XFd
                            ])))));
                            Agd(a, Zze, $ze, sgb(1));
                            Agd(a, Zze, _ze, 80);
                            Agd(a, Zze, aAe, 5);
                            Agd(a, Zze, Dze, Yze);
                            Agd(a, Zze, bAe, sgb(1));
                            Agd(a, Zze, cAe, (Geb(), true));
                            Agd(a, Zze, Eze, iVb);
                            Agd(a, Zze, dAe, iGd(_Ub));
                            Agd(a, Zze, eAe, iGd(jVb));
                            Agd(a, Zze, fAe, false);
                            Agd(a, Zze, gAe, iGd(gVb));
                            Agd(a, Zze, hAe, iGd(eVb));
                            Agd(a, Zze, iAe, iGd(fVb));
                            Agd(a, Zze, jAe, iGd(dVb));
                            Agd(a, Zze, kAe, iGd(cVb));
                            Agd(a, Zze, lAe, iGd(kVb));
                            Agd(a, Zze, Rze, iGd(bVb));
                            Agd(a, Zze, Uze, iGd(sVb));
                            Agd(a, Zze, Sze, iGd(aVb));
                            Agd(a, Zze, Wze, iGd(nVb));
                            Agd(a, Zze, Tze, iGd(oVb));
                            Agd(a, Zze, mAe, iGd(vVb));
                            Agd(a, Zze, nAe, iGd(xVb));
                            Agd(a, Zze, oAe, iGd(uVb));
                            Agd(a, Zze, pAe, iGd(tVb));
                            Agd(a, Zze, qAe, wVb);
                        }
                        function hte(a, b) {
                            Vse();
                            var c, d, e, f, g, h, i, j, k, l, m, n, o;
                            if (bkb(wse) == 0) {
                                l = $C(qdb, Nve, 122, yse.length, 0, 1);
                                for(g = 0; g < l.length; g++)l[g] = (++Use, new xte(4));
                                d = new Rhb;
                                for(f = 0; f < vse.length; f++){
                                    k = (++Use, new xte(4));
                                    if (f < 84) {
                                        h = f * 2;
                                        n = (BFb(h, XLe.length), XLe.charCodeAt(h));
                                        m = (BFb(h + 1, XLe.length), XLe.charCodeAt(h + 1));
                                        rte(k, n, m);
                                    } else {
                                        h = (f - 84) * 2;
                                        rte(k, zse[h], zse[h + 1]);
                                    }
                                    i = vse[f];
                                    lhb(i, 'Specials') && rte(k, 65520, 65533);
                                    if (lhb(i, VLe)) {
                                        rte(k, 983040, 1048573);
                                        rte(k, 1048576, 1114109);
                                    }
                                    $jb(wse, i, k);
                                    $jb(xse, i, yte(k));
                                    j = d.a.length;
                                    0 < j ? d.a = zhb(d.a, 0, 0) : 0 > j && (d.a += Hhb($C(hE, zwe, 28, -j, 15, 1)));
                                    d.a += 'Is';
                                    if (qhb(i, Fhb(32)) >= 0) for(e = 0; e < i.length; e++){
                                        BFb(e, i.length);
                                        i.charCodeAt(e) != 32 && Jhb(d, (BFb(e, i.length), i.charCodeAt(e)));
                                    }
                                    else d.a += '' + i;
                                    lte(d.a, i, true);
                                }
                                lte(WLe, 'Cn', false);
                                lte(YLe, 'Cn', true);
                                c = (++Use, new xte(4));
                                rte(c, 0, MLe);
                                $jb(wse, 'ALL', c);
                                $jb(xse, 'ALL', yte(c));
                                !Ase && (Ase = new Tsb);
                                $jb(Ase, WLe, WLe);
                                !Ase && (Ase = new Tsb);
                                $jb(Ase, YLe, YLe);
                                !Ase && (Ase = new Tsb);
                                $jb(Ase, 'ALL', 'ALL');
                            }
                            o = b ? RD(Xjb(wse, a), 138) : RD(Xjb(xse, a), 138);
                            return o;
                        }
                        function i_c(a) {
                            Cgd(a, new Pfd(_fd(Wfd($fd(Xfd(Zfd(Yfd(new agd, ZEe), 'ELK Mr. Tree'), "Tree-based algorithm provided by the Eclipse Layout Kernel. Computes a spanning tree of the input graph and arranges all nodes according to the resulting parent-children hierarchy. I pity the fool who doesn't use Mr. Tree Layout."), new l_c), $Ee), xsb((aGd(), WFd)))));
                            Agd(a, ZEe, Eze, U$c);
                            Agd(a, ZEe, _ze, 20);
                            Agd(a, ZEe, ADe, 3);
                            Agd(a, ZEe, Dze, Yze);
                            Agd(a, ZEe, $ze, sgb(1));
                            Agd(a, ZEe, cAe, (Geb(), true));
                            Agd(a, ZEe, LDe, iGd(G$c));
                            Agd(a, ZEe, PDe, I$c);
                            Agd(a, ZEe, dAe, iGd(L$c));
                            Agd(a, ZEe, iEe, iGd(M$c));
                            Agd(a, ZEe, jAe, iGd(O$c));
                            Agd(a, ZEe, hAe, iGd(P$c));
                            Agd(a, ZEe, CAe, iGd(Q$c));
                            Agd(a, ZEe, iAe, iGd(R$c));
                            Agd(a, ZEe, kAe, iGd(N$c));
                            Agd(a, ZEe, gAe, iGd(S$c));
                            Agd(a, ZEe, lAe, iGd(V$c));
                            Agd(a, ZEe, VEe, iGd(g_c));
                            Agd(a, ZEe, XEe, iGd(Y$c));
                            Agd(a, ZEe, mAe, iGd(c_c));
                            Agd(a, ZEe, nAe, iGd(e_c));
                            Agd(a, ZEe, oAe, iGd(b_c));
                            Agd(a, ZEe, pAe, iGd(a_c));
                            Agd(a, ZEe, qAe, d_c);
                            Agd(a, ZEe, UEe, iGd(W$c));
                            Agd(a, ZEe, WEe, iGd(K$c));
                            Agd(a, ZEe, TEe, iGd(f_c));
                            Agd(a, ZEe, REe, iGd(F$c));
                            Agd(a, ZEe, SEe, iGd(J$c));
                        }
                        function rNb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m;
                            j = RD(RD(Qc(a.r, b), 21), 87);
                            g = UMb(a, b);
                            c = a.u.Hc((Pod(), Jod));
                            for(i = j.Kc(); i.Ob();){
                                h = RD(i.Pb(), 117);
                                if (!h.c || h.c.d.c.length <= 0) continue;
                                m = h.b.Mf();
                                k = h.c;
                                l = k.i;
                                l.b = (f = k.n, k.e.a + f.b + f.c);
                                l.a = (e = k.n, k.e.b + e.d + e.a);
                                switch(b.g){
                                    case 1:
                                        if (h.a) {
                                            l.c = (m.a - l.b) / 2;
                                            RKb(k, (EKb(), BKb));
                                        } else if (g || c) {
                                            l.c = -l.b - a.s;
                                            RKb(k, (EKb(), DKb));
                                        } else {
                                            l.c = m.a + a.s;
                                            RKb(k, (EKb(), CKb));
                                        }
                                        l.d = -l.a - a.t;
                                        SKb(k, (vLb(), sLb));
                                        break;
                                    case 3:
                                        if (h.a) {
                                            l.c = (m.a - l.b) / 2;
                                            RKb(k, (EKb(), BKb));
                                        } else if (g || c) {
                                            l.c = -l.b - a.s;
                                            RKb(k, (EKb(), DKb));
                                        } else {
                                            l.c = m.a + a.s;
                                            RKb(k, (EKb(), CKb));
                                        }
                                        l.d = m.b + a.t;
                                        SKb(k, (vLb(), uLb));
                                        break;
                                    case 2:
                                        if (h.a) {
                                            d = a.v ? l.a : RD(Vmb(k.d, 0), 187).Mf().b;
                                            l.d = (m.b - d) / 2;
                                            SKb(k, (vLb(), tLb));
                                        } else if (g || c) {
                                            l.d = -l.a - a.t;
                                            SKb(k, (vLb(), sLb));
                                        } else {
                                            l.d = m.b + a.t;
                                            SKb(k, (vLb(), uLb));
                                        }
                                        l.c = m.a + a.s;
                                        RKb(k, (EKb(), CKb));
                                        break;
                                    case 4:
                                        if (h.a) {
                                            d = a.v ? l.a : RD(Vmb(k.d, 0), 187).Mf().b;
                                            l.d = (m.b - d) / 2;
                                            SKb(k, (vLb(), tLb));
                                        } else if (g || c) {
                                            l.d = -l.a - a.t;
                                            SKb(k, (vLb(), sLb));
                                        } else {
                                            l.d = m.b + a.t;
                                            SKb(k, (vLb(), uLb));
                                        }
                                        l.c = -l.b - a.s;
                                        RKb(k, (EKb(), DKb));
                                }
                                g = false;
                            }
                        }
                        function t6b(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
                            m = false;
                            l = false;
                            if (Dod(RD(mQb(d, (yCc(), BBc)), 101))) {
                                g = false;
                                h = false;
                                t: for(o = new Anb(d.j); o.a < o.c.c.length;){
                                    n = RD(ynb(o), 12);
                                    for(q = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                        new T3b(n),
                                        new _3b(n)
                                    ]))); gs(q);){
                                        p = RD(hs(q), 12);
                                        if (!Heb(TD(mQb(p.i, Uzc)))) {
                                            if (n.j == (qpd(), Yod)) {
                                                g = true;
                                                break t;
                                            }
                                            if (n.j == npd) {
                                                h = true;
                                                break t;
                                            }
                                        }
                                    }
                                }
                                m = h && !g;
                                l = g && !h;
                            }
                            if (!m && !l && d.b.c.length != 0) {
                                k = 0;
                                for(j = new Anb(d.b); j.a < j.c.c.length;){
                                    i = RD(ynb(j), 72);
                                    k += i.n.b + i.o.b / 2;
                                }
                                k /= d.b.c.length;
                                s = k >= d.o.b / 2;
                            } else s = !l;
                            if (s) {
                                r = RD(mQb(d, (Ywc(), Xwc)), 15);
                                if (!r) {
                                    f = new bnb;
                                    pQb(d, Xwc, f);
                                } else if (m) f = r;
                                else {
                                    e = RD(mQb(d, Vvc), 15);
                                    if (!e) {
                                        f = new bnb;
                                        pQb(d, Vvc, f);
                                    } else r.gc() <= e.gc() ? f = r : f = e;
                                }
                            } else {
                                e = RD(mQb(d, (Ywc(), Vvc)), 15);
                                if (!e) {
                                    f = new bnb;
                                    pQb(d, Vvc, f);
                                } else if (l) f = e;
                                else {
                                    r = RD(mQb(d, Xwc), 15);
                                    if (!r) {
                                        f = new bnb;
                                        pQb(d, Xwc, f);
                                    } else e.gc() <= r.gc() ? f = e : f = r;
                                }
                            }
                            f.Fc(a);
                            pQb(a, (Ywc(), Xvc), c);
                            if (b.d == c) {
                                Z0b(b, null);
                                c.e.c.length + c.g.c.length == 0 && P3b(c, null);
                                u6b(c);
                            } else {
                                Y0b(b, null);
                                c.e.c.length + c.g.c.length == 0 && P3b(c, null);
                            }
                            Xub(b.a);
                        }
                        function GHc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
                            c.Ug('MinWidth layering', 1);
                            n = b.b;
                            A = b.a;
                            I = RD(mQb(b, (yCc(), WAc)), 17).a;
                            h = RD(mQb(b, XAc), 17).a;
                            a.b = Kfb(UD(mQb(b, TBc)));
                            a.d = oxe;
                            for(u = new Anb(A); u.a < u.c.c.length;){
                                s = RD(ynb(u), 10);
                                if (s.k != (r3b(), p3b)) continue;
                                D = s.o.b;
                                a.d = $wnd.Math.min(a.d, D);
                            }
                            a.d = $wnd.Math.max(1, a.d);
                            B = A.c.length;
                            a.c = $C(kE, Pwe, 28, B, 15, 1);
                            a.f = $C(kE, Pwe, 28, B, 15, 1);
                            a.e = $C(iE, vxe, 28, B, 15, 1);
                            j = 0;
                            a.a = 0;
                            for(v = new Anb(A); v.a < v.c.c.length;){
                                s = RD(ynb(v), 10);
                                s.p = j++;
                                a.c[s.p] = EHc(Z2b(s));
                                a.f[s.p] = EHc(a3b(s));
                                a.e[s.p] = s.o.b / a.d;
                                a.a += a.e[s.p];
                            }
                            a.b /= a.d;
                            a.a /= B;
                            w = FHc(A);
                            _mb(A, Fob(new MHc(a)));
                            p = oxe;
                            o = lve;
                            g = null;
                            H = I;
                            G = I;
                            f = h;
                            e = h;
                            if (I < 0) {
                                H = RD(BHc.a.Id(), 17).a;
                                G = RD(BHc.b.Id(), 17).a;
                            }
                            if (h < 0) {
                                f = RD(AHc.a.Id(), 17).a;
                                e = RD(AHc.b.Id(), 17).a;
                            }
                            for(F = H; F <= G; F++)for(d = f; d <= e; d++){
                                C = DHc(a, F, d, A, w);
                                r = Kfb(UD(C.a));
                                m = RD(C.b, 15);
                                q = m.gc();
                                if (r < p || r == p && q < o) {
                                    p = r;
                                    o = q;
                                    g = m;
                                }
                            }
                            for(l = g.Kc(); l.Ob();){
                                k = RD(l.Pb(), 15);
                                i = new R4b(b);
                                for(t = k.Kc(); t.Ob();){
                                    s = RD(t.Pb(), 10);
                                    g3b(s, i);
                                }
                                ZEb(n.c, i);
                            }
                            Eob(n);
                            A.c.length = 0;
                            c.Vg();
                        }
                        function UUc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
                            c.Ug('Spline edge routing', 1);
                            if (b.b.c.length == 0) {
                                b.f.a = 0;
                                c.Vg();
                                return;
                            }
                            s = Kfb(UD(mQb(b, (yCc(), cCc))));
                            h = Kfb(UD(mQb(b, XBc)));
                            g = Kfb(UD(mQb(b, UBc)));
                            r = RD(mQb(b, DAc), 350);
                            B = r == (lFc(), kFc);
                            A = Kfb(UD(mQb(b, EAc)));
                            a.d = b;
                            a.j.c.length = 0;
                            a.a.c.length = 0;
                            akb(a.k);
                            i = RD(Vmb(b.b, 0), 30);
                            k = ar(i.a, (dSc(), bSc));
                            o = RD(Vmb(b.b, b.b.c.length - 1), 30);
                            l = ar(o.a, bSc);
                            p = new Anb(b.b);
                            q = null;
                            G = 0;
                            do {
                                t = p.a < p.c.c.length ? RD(ynb(p), 30) : null;
                                IUc(a, q, t);
                                LUc(a);
                                C = cwb(nDb(IDb(CDb(new SDb(null, new Swb(a.i, 16)), new jVc), new lVc)));
                                F = 0;
                                u = G;
                                m = !q || k && q == i;
                                n = !t || l && t == o;
                                if (C > 0) {
                                    j = 0;
                                    !!q && (j += h);
                                    j += (C - 1) * g;
                                    !!t && (j += h);
                                    B && !!t && (j = $wnd.Math.max(j, JUc(t, g, s, A)));
                                    if (j < s && !m && !n) {
                                        F = (s - j) / 2;
                                        j = s;
                                    }
                                    u += j;
                                } else !m && !n && (u += s);
                                !!t && p2b(t, u);
                                for(w = new Anb(a.i); w.a < w.c.c.length;){
                                    v = RD(ynb(w), 131);
                                    v.a.c = G;
                                    v.a.b = u - G;
                                    v.F = F;
                                    v.p = !q;
                                }
                                Tmb(a.a, a.i);
                                G = u;
                                !!t && (G += t.c.a);
                                q = t;
                                m = n;
                            }while (t);
                            for(e = new Anb(a.j); e.a < e.c.c.length;){
                                d = RD(ynb(e), 18);
                                f = PUc(a, d);
                                pQb(d, (Ywc(), Rwc), f);
                                D = RUc(a, d);
                                pQb(d, Twc, D);
                            }
                            b.f.a = G;
                            a.d = null;
                            c.Vg();
                        }
                        function Z9b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
                            a.b = b;
                            a.a = RD(mQb(b, (yCc(), JAc)), 17).a;
                            a.c = RD(mQb(b, LAc), 17).a;
                            a.c == 0 && (a.c = lve);
                            q = new Jkb(b.b, 0);
                            while(q.b < q.d.gc()){
                                p = (sFb(q.b < q.d.gc()), RD(q.d.Xb(q.c = q.b++), 30));
                                h = new bnb;
                                k = -1;
                                u = -1;
                                for(t = new Anb(p.a); t.a < t.c.c.length;){
                                    s = RD(ynb(t), 10);
                                    if (Kr((U9b(), new is(Mr(W2b(s).a.Kc(), new ir)))) >= a.a) {
                                        d = V9b(a, s);
                                        k = $wnd.Math.max(k, d.b);
                                        u = $wnd.Math.max(u, d.d);
                                        Rmb(h, new Ptd(s, d));
                                    }
                                }
                                B = new bnb;
                                for(j = 0; j < k; ++j)Qmb(B, 0, (sFb(q.b > 0), q.a.Xb(q.c = --q.b), C = new R4b(a.b), Ikb(q, C), sFb(q.b < q.d.gc()), q.d.Xb(q.c = q.b++), C));
                                for(g = new Anb(h); g.a < g.c.c.length;){
                                    e = RD(ynb(g), 42);
                                    n = RD(e.b, 580).a;
                                    if (!n) continue;
                                    for(m = new Anb(n); m.a < m.c.c.length;){
                                        l = RD(ynb(m), 10);
                                        Y9b(a, l, S9b, B);
                                    }
                                }
                                c = new bnb;
                                for(i = 0; i < u; ++i)Rmb(c, (D = new R4b(a.b), Ikb(q, D), D));
                                for(f = new Anb(h); f.a < f.c.c.length;){
                                    e = RD(ynb(f), 42);
                                    A = RD(e.b, 580).c;
                                    if (!A) continue;
                                    for(w = new Anb(A); w.a < w.c.c.length;){
                                        v = RD(ynb(w), 10);
                                        Y9b(a, v, T9b, c);
                                    }
                                }
                            }
                            r = new Jkb(b.b, 0);
                            while(r.b < r.d.gc()){
                                o = (sFb(r.b < r.d.gc()), RD(r.d.Xb(r.c = r.b++), 30));
                                o.a.c.length == 0 && Ckb(r);
                            }
                        }
                        function wLd(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
                            p = a.i != 0;
                            t = false;
                            r = null;
                            if (Mvd(a.e)) {
                                k = b.gc();
                                if (k > 0) {
                                    m = k < 100 ? null : new gLd(k);
                                    j = new $Hd(b);
                                    o = j.g;
                                    r = $C(kE, Pwe, 28, k, 15, 1);
                                    d = 0;
                                    u = new ZHd(k);
                                    for(e = 0; e < a.i; ++e){
                                        h = a.g[e];
                                        n = h;
                                        v: for(s = 0; s < 2; ++s){
                                            for(i = k; --i >= 0;)if (n != null ? pb(n, o[i]) : dE(n) === dE(o[i])) {
                                                if (r.length <= d) {
                                                    q = r;
                                                    r = $C(kE, Pwe, 28, 2 * r.length, 15, 1);
                                                    hib(q, 0, r, 0, d);
                                                }
                                                r[d++] = e;
                                                WGd(u, o[i]);
                                                break v;
                                            }
                                            n;
                                            if (dE(n) === dE(h)) break;
                                        }
                                    }
                                    j = u;
                                    o = u.g;
                                    k = d;
                                    if (d > r.length) {
                                        q = r;
                                        r = $C(kE, Pwe, 28, d, 15, 1);
                                        hib(q, 0, r, 0, d);
                                    }
                                    if (d > 0) {
                                        t = true;
                                        for(f = 0; f < d; ++f){
                                            n = o[f];
                                            m = Kge(a, RD(n, 76), m);
                                        }
                                        for(g = d; --g >= 0;)THd(a, r[g]);
                                        if (d != k) {
                                            for(e = k; --e >= d;)THd(j, e);
                                            q = r;
                                            r = $C(kE, Pwe, 28, d, 15, 1);
                                            hib(q, 0, r, 0, d);
                                        }
                                        b = j;
                                    }
                                }
                            } else {
                                b = aHd(a, b);
                                for(e = a.i; --e >= 0;)if (b.Hc(a.g[e])) {
                                    THd(a, e);
                                    t = true;
                                }
                            }
                            if (t) {
                                if (r != null) {
                                    c = b.gc();
                                    l = c == 1 ? dZd(a, 4, b.Kc().Pb(), null, r[0], p) : dZd(a, 6, b, r, r[0], p);
                                    m = c < 100 ? null : new gLd(c);
                                    for(e = b.Kc(); e.Ob();){
                                        n = e.Pb();
                                        m = oge(a, RD(n, 76), m);
                                    }
                                    if (!m) qvd(a.e, l);
                                    else {
                                        m.nj(l);
                                        m.oj();
                                    }
                                } else {
                                    m = tLd(b.gc());
                                    for(e = b.Kc(); e.Ob();){
                                        n = e.Pb();
                                        m = oge(a, RD(n, 76), m);
                                    }
                                    !!m && m.oj();
                                }
                                return true;
                            } else return false;
                        }
                        function i_b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            c = new p_b(b);
                            c.a || b_b(b);
                            j = a_b(b);
                            i = new Tp;
                            q = new D_b;
                            for(p = new Anb(b.a); p.a < p.c.c.length;){
                                o = RD(ynb(p), 10);
                                for(e = new is(Mr(a3b(o).a.Kc(), new ir)); gs(e);){
                                    d = RD(hs(e), 18);
                                    if (d.c.i.k == (r3b(), m3b) || d.d.i.k == m3b) {
                                        k = h_b(a, d, j, q);
                                        Rc(i, f_b(k.d), k.a);
                                    }
                                }
                            }
                            g = new bnb;
                            for(t = RD(mQb(c.c, (Ywc(), ewc)), 21).Kc(); t.Ob();){
                                s = RD(t.Pb(), 64);
                                n = q.c[s.g];
                                m = q.b[s.g];
                                h = q.a[s.g];
                                f = null;
                                r = null;
                                switch(s.g){
                                    case 4:
                                        f = new Uid(a.d.a, n, j.b.a - a.d.a, m - n);
                                        r = new Uid(a.d.a, n, h, m - n);
                                        l_b(j, new rjd(f.c + f.b, f.d));
                                        l_b(j, new rjd(f.c + f.b, f.d + f.a));
                                        break;
                                    case 2:
                                        f = new Uid(j.a.a, n, a.c.a - j.a.a, m - n);
                                        r = new Uid(a.c.a - h, n, h, m - n);
                                        l_b(j, new rjd(f.c, f.d));
                                        l_b(j, new rjd(f.c, f.d + f.a));
                                        break;
                                    case 1:
                                        f = new Uid(n, a.d.b, m - n, j.b.b - a.d.b);
                                        r = new Uid(n, a.d.b, m - n, h);
                                        l_b(j, new rjd(f.c, f.d + f.a));
                                        l_b(j, new rjd(f.c + f.b, f.d + f.a));
                                        break;
                                    case 3:
                                        f = new Uid(n, j.a.b, m - n, a.c.b - j.a.b);
                                        r = new Uid(n, a.c.b - h, m - n, h);
                                        l_b(j, new rjd(f.c, f.d));
                                        l_b(j, new rjd(f.c + f.b, f.d));
                                }
                                if (f) {
                                    l = new y_b;
                                    l.d = s;
                                    l.b = f;
                                    l.c = r;
                                    l.a = Ux(RD(Qc(i, f_b(s)), 21));
                                    ZEb(g.c, l);
                                }
                            }
                            Tmb(c.b, g);
                            c.d = DZb(LZb(j));
                            return c;
                        }
                        function PQc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p;
                            if (c.p[b.p] != null) return;
                            h = true;
                            c.p[b.p] = 0;
                            g = b;
                            p = c.o == (EQc(), CQc) ? pxe : oxe;
                            do {
                                e = a.b.e[g.p];
                                f = g.c.a.c.length;
                                if (c.o == CQc && e > 0 || c.o == DQc && e < f - 1) {
                                    i = null;
                                    j = null;
                                    c.o == DQc ? i = RD(Vmb(g.c.a, e + 1), 10) : i = RD(Vmb(g.c.a, e - 1), 10);
                                    j = c.g[i.p];
                                    PQc(a, j, c);
                                    p = a.e.wg(p, b, g);
                                    c.j[b.p] == b && (c.j[b.p] = c.j[j.p]);
                                    if (c.j[b.p] == c.j[j.p]) {
                                        o = bFc(a.d, g, i);
                                        if (c.o == DQc) {
                                            d = Kfb(c.p[b.p]);
                                            l = Kfb(c.p[j.p]) + Kfb(c.d[i.p]) - i.d.d - o - g.d.a - g.o.b - Kfb(c.d[g.p]);
                                            if (h) {
                                                h = false;
                                                c.p[b.p] = $wnd.Math.min(l, p);
                                            } else c.p[b.p] = $wnd.Math.min(d, $wnd.Math.min(l, p));
                                        } else {
                                            d = Kfb(c.p[b.p]);
                                            l = Kfb(c.p[j.p]) + Kfb(c.d[i.p]) + i.o.b + i.d.a + o + g.d.d - Kfb(c.d[g.p]);
                                            if (h) {
                                                h = false;
                                                c.p[b.p] = $wnd.Math.max(l, p);
                                            } else c.p[b.p] = $wnd.Math.max(d, $wnd.Math.max(l, p));
                                        }
                                    } else {
                                        o = Kfb(UD(mQb(a.a, (yCc(), bCc))));
                                        n = NQc(a, c.j[b.p]);
                                        k = NQc(a, c.j[j.p]);
                                        if (c.o == DQc) {
                                            m = Kfb(c.p[b.p]) + Kfb(c.d[g.p]) + g.o.b + g.d.a + o - (Kfb(c.p[j.p]) + Kfb(c.d[i.p]) - i.d.d);
                                            TQc(n, k, m);
                                        } else {
                                            m = Kfb(c.p[b.p]) + Kfb(c.d[g.p]) - g.d.d - Kfb(c.p[j.p]) - Kfb(c.d[i.p]) - i.o.b - i.d.a - o;
                                            TQc(n, k, m);
                                        }
                                    }
                                } else p = a.e.wg(p, b, g);
                                g = c.a[g.p];
                            }while (g != b);
                            qRc(a.e, b);
                        }
                        function $Kc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C;
                            c = Kfb(UD(mQb(a.a.j, (yCc(), iAc))));
                            if (c < -1 || !a.a.i || Cod(RD(mQb(a.a.o, BBc), 101)) || b3b(a.a.o, (qpd(), Xod)).gc() < 2 && b3b(a.a.o, ppd).gc() < 2) return true;
                            if (a.a.c.kg()) return false;
                            v = 0;
                            u = 0;
                            t = new bnb;
                            for(i = a.a.e, j = 0, k = i.length; j < k; ++j){
                                h = i[j];
                                for(m = h, n = 0, p = m.length; n < p; ++n){
                                    l = m[n];
                                    if (l.k == (r3b(), q3b)) {
                                        ZEb(t.c, l);
                                        continue;
                                    }
                                    d = a.b[l.c.p][l.p];
                                    if (l.k == m3b) {
                                        d.b = 1;
                                        RD(mQb(l, (Ywc(), Awc)), 12).j == (qpd(), Xod) && (u += d.a);
                                    } else {
                                        C = b3b(l, (qpd(), ppd));
                                        C.dc() || !br(C, new lLc) ? d.c = 1 : (e = b3b(l, Xod), (e.dc() || !br(e, new hLc)) && (v += d.a));
                                    }
                                    for(g = new is(Mr(a3b(l).a.Kc(), new ir)); gs(g);){
                                        f = RD(hs(g), 18);
                                        v += d.c;
                                        u += d.b;
                                        B = f.d.i;
                                        ZKc(a, d, B);
                                    }
                                    r = Al(cD(WC(cJ, 1), rve, 20, 0, [
                                        b3b(l, (qpd(), Yod)),
                                        b3b(l, npd)
                                    ]));
                                    for(A = new is(new Il(r.a.length, r.a)); gs(A);){
                                        w = RD(hs(A), 12);
                                        s = RD(mQb(w, (Ywc(), Iwc)), 10);
                                        if (s) {
                                            v += d.c;
                                            u += d.b;
                                            ZKc(a, d, s);
                                        }
                                    }
                                }
                                for(o = new Anb(t); o.a < o.c.c.length;){
                                    l = RD(ynb(o), 10);
                                    d = a.b[l.c.p][l.p];
                                    for(g = new is(Mr(a3b(l).a.Kc(), new ir)); gs(g);){
                                        f = RD(hs(g), 18);
                                        v += d.c;
                                        u += d.b;
                                        B = f.d.i;
                                        ZKc(a, d, B);
                                    }
                                }
                                t.c.length = 0;
                            }
                            b = v + u;
                            q = b == 0 ? oxe : (v - u) / b;
                            return q >= c;
                        }
                        function zEd(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
                            t = b;
                            s = new Tp;
                            u = new Tp;
                            k = wDd(t, mIe);
                            d = new OEd(a, c, s, u);
                            QDd(d.a, d.b, d.c, d.d, k);
                            i = (A = s.i, !A ? s.i = new zf(s, s.c) : A);
                            for(C = i.Kc(); C.Ob();){
                                B = RD(C.Pb(), 166);
                                e = RD(Qc(s, B), 21);
                                for(p = e.Kc(); p.Ob();){
                                    o = p.Pb();
                                    v = RD(Ao(a.d, o), 166);
                                    if (v) {
                                        h = (!B.e && (B.e = new Yie(F4, B, 10, 9)), B.e);
                                        WGd(h, v);
                                    } else {
                                        g = zDd(t, uIe);
                                        m = AIe + o + BIe + g;
                                        n = m + zIe;
                                        throw Adb(new CDd(n));
                                    }
                                }
                            }
                            j = (w = u.i, !w ? u.i = new zf(u, u.c) : w);
                            for(F = j.Kc(); F.Ob();){
                                D = RD(F.Pb(), 166);
                                f = RD(Qc(u, D), 21);
                                for(r = f.Kc(); r.Ob();){
                                    q = r.Pb();
                                    v = RD(Ao(a.d, q), 166);
                                    if (v) {
                                        l = (!D.g && (D.g = new Yie(F4, D, 9, 10)), D.g);
                                        WGd(l, v);
                                    } else {
                                        g = zDd(t, uIe);
                                        m = AIe + q + BIe + g;
                                        n = m + zIe;
                                        throw Adb(new CDd(n));
                                    }
                                }
                            }
                            !c.b && (c.b = new Yie(E4, c, 4, 7));
                            if (c.b.i != 0 && (!c.c && (c.c = new Yie(E4, c, 5, 8)), c.c.i != 0) && (!c.b && (c.b = new Yie(E4, c, 4, 7)), c.b.i <= 1 && (!c.c && (c.c = new Yie(E4, c, 5, 8)), c.c.i <= 1)) && (!c.a && (c.a = new C5d(F4, c, 6, 6)), c.a).i == 1) {
                                G = RD(QHd((!c.a && (c.a = new C5d(F4, c, 6, 6)), c.a), 0), 166);
                                if (!Dzd(G) && !Ezd(G)) {
                                    Kzd(G, RD(QHd((!c.b && (c.b = new Yie(E4, c, 4, 7)), c.b), 0), 84));
                                    Lzd(G, RD(QHd((!c.c && (c.c = new Yie(E4, c, 5, 8)), c.c), 0), 84));
                                }
                            }
                        }
                        function QNc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
                            for(t = a.a, u = 0, v = t.length; u < v; ++u){
                                s = t[u];
                                j = lve;
                                k = lve;
                                for(o = new Anb(s.e); o.a < o.c.c.length;){
                                    m = RD(ynb(o), 10);
                                    g = !m.c ? -1 : Wmb(m.c.a, m, 0);
                                    if (g > 0) {
                                        l = RD(Vmb(m.c.a, g - 1), 10);
                                        B = bFc(a.b, m, l);
                                        q = m.n.b - m.d.d - (l.n.b + l.o.b + l.d.a + B);
                                    } else q = m.n.b - m.d.d;
                                    j = $wnd.Math.min(q, j);
                                    if (g < m.c.a.c.length - 1) {
                                        l = RD(Vmb(m.c.a, g + 1), 10);
                                        B = bFc(a.b, m, l);
                                        r = l.n.b - l.d.d - (m.n.b + m.o.b + m.d.a + B);
                                    } else r = 2 * m.n.b;
                                    k = $wnd.Math.min(r, k);
                                }
                                i = lve;
                                f = false;
                                e = RD(Vmb(s.e, 0), 10);
                                for(D = new Anb(e.j); D.a < D.c.c.length;){
                                    C = RD(ynb(D), 12);
                                    p = e.n.b + C.n.b + C.a.b;
                                    for(d = new Anb(C.e); d.a < d.c.c.length;){
                                        c = RD(ynb(d), 18);
                                        w = c.c;
                                        b = w.i.n.b + w.n.b + w.a.b - p;
                                        if ($wnd.Math.abs(b) < $wnd.Math.abs(i) && $wnd.Math.abs(b) < (b < 0 ? j : k)) {
                                            i = b;
                                            f = true;
                                        }
                                    }
                                }
                                h = RD(Vmb(s.e, s.e.c.length - 1), 10);
                                for(A = new Anb(h.j); A.a < A.c.c.length;){
                                    w = RD(ynb(A), 12);
                                    p = h.n.b + w.n.b + w.a.b;
                                    for(d = new Anb(w.g); d.a < d.c.c.length;){
                                        c = RD(ynb(d), 18);
                                        C = c.d;
                                        b = C.i.n.b + C.n.b + C.a.b - p;
                                        if ($wnd.Math.abs(b) < $wnd.Math.abs(i) && $wnd.Math.abs(b) < (b < 0 ? j : k)) {
                                            i = b;
                                            f = true;
                                        }
                                    }
                                }
                                if (f && i != 0) for(n = new Anb(s.e); n.a < n.c.c.length;){
                                    m = RD(ynb(n), 10);
                                    m.n.b += i;
                                }
                            }
                        }
                        function vac(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                            d = new bnb;
                            e = lve;
                            f = lve;
                            g = lve;
                            if (c) {
                                e = a.f.a;
                                for(p = new Anb(b.j); p.a < p.c.c.length;){
                                    o = RD(ynb(p), 12);
                                    for(i = new Anb(o.g); i.a < i.c.c.length;){
                                        h = RD(ynb(i), 18);
                                        if (h.a.b != 0) {
                                            k = RD(Qub(h.a), 8);
                                            if (k.a < e) {
                                                f = e - k.a;
                                                g = lve;
                                                d.c.length = 0;
                                                e = k.a;
                                            }
                                            if (k.a <= e) {
                                                ZEb(d.c, h);
                                                h.a.b > 1 && (g = $wnd.Math.min(g, $wnd.Math.abs(RD(ju(h.a, 1), 8).b - k.b)));
                                            }
                                        }
                                    }
                                }
                            } else for(p = new Anb(b.j); p.a < p.c.c.length;){
                                o = RD(ynb(p), 12);
                                for(i = new Anb(o.e); i.a < i.c.c.length;){
                                    h = RD(ynb(i), 18);
                                    if (h.a.b != 0) {
                                        m = RD(Rub(h.a), 8);
                                        if (m.a > e) {
                                            f = m.a - e;
                                            g = lve;
                                            d.c.length = 0;
                                            e = m.a;
                                        }
                                        if (m.a >= e) {
                                            ZEb(d.c, h);
                                            h.a.b > 1 && (g = $wnd.Math.min(g, $wnd.Math.abs(RD(ju(h.a, h.a.b - 2), 8).b - m.b)));
                                        }
                                    }
                                }
                            }
                            if (d.c.length != 0 && f > b.o.a / 2 && g > b.o.b / 2) {
                                n = new R3b;
                                P3b(n, b);
                                Q3b(n, (qpd(), Yod));
                                n.n.a = b.o.a / 2;
                                r = new R3b;
                                P3b(r, b);
                                Q3b(r, npd);
                                r.n.a = b.o.a / 2;
                                r.n.b = b.o.b;
                                for(i = new Anb(d); i.a < i.c.c.length;){
                                    h = RD(ynb(i), 18);
                                    if (c) {
                                        j = RD(Uub(h.a), 8);
                                        q = h.a.b == 0 ? K3b(h.d) : RD(Qub(h.a), 8);
                                        q.b >= j.b ? Y0b(h, r) : Y0b(h, n);
                                    } else {
                                        j = RD(Vub(h.a), 8);
                                        q = h.a.b == 0 ? K3b(h.c) : RD(Rub(h.a), 8);
                                        q.b >= j.b ? Z0b(h, r) : Z0b(h, n);
                                    }
                                    l = RD(mQb(h, (yCc(), RAc)), 75);
                                    !!l && ze(l, j, true);
                                }
                                b.n.a = e - b.o.a / 2;
                            }
                        }
                        function E0c(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            for(h = Sub(a.b, 0); h.b != h.d.c;){
                                g = RD(evb(h), 40);
                                if (lhb(g.c, IEe)) continue;
                                j = iWc(g, a);
                                b == (Cmd(), ymd) || b == zmd ? _mb(j, new D1c) : _mb(j, new H1c);
                                i = j.c.length;
                                for(d = 0; d < i; d++){
                                    k = (tFb(d, j.c.length), RD(j.c[d], 65)).c;
                                    lhb(k.c, 'n11') && o0;
                                    if (Heb(TD(mQb(g, (q$c(), UZc)))) && !mWc((tFb(d, j.c.length), RD(j.c[d], 65)), a)) continue;
                                    e = i == 1 ? 0.5 : (d + 1) / (i + 1);
                                    if (b == ymd) {
                                        f = Kfb(UD(mQb(g, f$c)));
                                        m = g.e.b + g.f.b * e;
                                        Nub((tFb(d, j.c.length), RD(j.c[d], 65)).a, new rjd($wnd.Math.min(f, g.e.a - c), m));
                                        Nub((tFb(d, j.c.length), RD(j.c[d], 65)).a, new rjd(g.e.a, m));
                                    } else if (b == zmd) {
                                        f = Kfb(UD(mQb(g, e$c))) + c;
                                        m = g.e.b + g.f.b * e;
                                        Nub((tFb(d, j.c.length), RD(j.c[d], 65)).a, new rjd(f, m));
                                        Nub((tFb(d, j.c.length), RD(j.c[d], 65)).a, new rjd(g.e.a + g.f.a, m));
                                    } else if (b == Bmd) {
                                        f = Kfb(UD(mQb(g, f$c)));
                                        l = g.e.a + g.f.a * e;
                                        Nub((tFb(d, j.c.length), RD(j.c[d], 65)).a, new rjd(l, $wnd.Math.min(g.e.b - c, f)));
                                        Nub((tFb(d, j.c.length), RD(j.c[d], 65)).a, new rjd(l, g.e.b));
                                    } else {
                                        f = Kfb(UD(mQb(g, e$c))) + c;
                                        l = g.e.a + g.f.a * e;
                                        Nub((tFb(d, j.c.length), RD(j.c[d], 65)).a, new rjd(l, f));
                                        Nub((tFb(d, j.c.length), RD(j.c[d], 65)).a, new rjd(l, g.e.b + g.f.b));
                                    }
                                }
                            }
                        }
                        function f2b(a, b, c, d, e, f, g, h, i) {
                            var j, k, l, m, n, o, p;
                            n = c;
                            k = new j3b(i);
                            h3b(k, (r3b(), m3b));
                            pQb(k, (Ywc(), iwc), g);
                            pQb(k, (yCc(), BBc), (Bod(), wod));
                            p = Kfb(UD(a.of(ABc)));
                            pQb(k, ABc, p);
                            l = new R3b;
                            P3b(l, k);
                            if (!(b != zod && b != Aod)) {
                                d >= 0 ? n = vpd(h) : n = spd(vpd(h));
                                a.qf(GBc, n);
                            }
                            j = new pjd;
                            m = false;
                            if (a.pf(zBc)) {
                                mjd(j, RD(a.of(zBc), 8));
                                m = true;
                            } else ljd(j, g.a / 2, g.b / 2);
                            switch(n.g){
                                case 4:
                                    pQb(k, UAc, (cxc(), $wc));
                                    pQb(k, bwc, (huc(), guc));
                                    k.o.b = g.b;
                                    p < 0 && (k.o.a = -p);
                                    Q3b(l, (qpd(), Xod));
                                    m || (j.a = g.a);
                                    j.a -= g.a;
                                    break;
                                case 2:
                                    pQb(k, UAc, (cxc(), axc));
                                    pQb(k, bwc, (huc(), euc));
                                    k.o.b = g.b;
                                    p < 0 && (k.o.a = -p);
                                    Q3b(l, (qpd(), ppd));
                                    m || (j.a = 0);
                                    break;
                                case 1:
                                    pQb(k, owc, (Gvc(), Fvc));
                                    k.o.a = g.a;
                                    p < 0 && (k.o.b = -p);
                                    Q3b(l, (qpd(), npd));
                                    m || (j.b = g.b);
                                    j.b -= g.b;
                                    break;
                                case 3:
                                    pQb(k, owc, (Gvc(), Dvc));
                                    k.o.a = g.a;
                                    p < 0 && (k.o.b = -p);
                                    Q3b(l, (qpd(), Yod));
                                    m || (j.b = 0);
                            }
                            mjd(l.n, j);
                            pQb(k, zBc, j);
                            if (b == vod || b == xod || b == wod) {
                                o = 0;
                                if (b == vod && a.pf(CBc)) switch(n.g){
                                    case 1:
                                    case 2:
                                        o = RD(a.of(CBc), 17).a;
                                        break;
                                    case 3:
                                    case 4:
                                        o = -RD(a.of(CBc), 17).a;
                                }
                                else switch(n.g){
                                    case 4:
                                    case 2:
                                        o = f.b;
                                        b == xod && (o /= e.b);
                                        break;
                                    case 1:
                                    case 3:
                                        o = f.a;
                                        b == xod && (o /= e.a);
                                }
                                pQb(k, Jwc, o);
                            }
                            pQb(k, hwc, n);
                            return k;
                        }
                        function OId() {
                            MId();
                            function h(f) {
                                var g = this;
                                this.dispatch = function(a) {
                                    var b = a.data;
                                    switch(b.cmd){
                                        case 'algorithms':
                                            var c = PId((yob(), new xpb(new glb(LId.b))));
                                            f.postMessage({
                                                id: b.id,
                                                data: c
                                            });
                                            break;
                                        case 'categories':
                                            var d = PId((yob(), new xpb(new glb(LId.c))));
                                            f.postMessage({
                                                id: b.id,
                                                data: d
                                            });
                                            break;
                                        case 'options':
                                            var e = PId((yob(), new xpb(new glb(LId.d))));
                                            f.postMessage({
                                                id: b.id,
                                                data: e
                                            });
                                            break;
                                        case 'register':
                                            SId(b.algorithms);
                                            f.postMessage({
                                                id: b.id
                                            });
                                            break;
                                        case 'layout':
                                            QId(b.graph, b.layoutOptions || {}, b.options || {});
                                            f.postMessage({
                                                id: b.id,
                                                data: b.graph
                                            });
                                            break;
                                    }
                                };
                                this.saveDispatch = function(b) {
                                    try {
                                        g.dispatch(b);
                                    } catch (a) {
                                        f.postMessage({
                                            id: b.data.id,
                                            error: a
                                        });
                                    }
                                };
                            }
                            function j(b) {
                                var c = this;
                                this.dispatcher = new h({
                                    postMessage: function(a) {
                                        c.onmessage({
                                            data: a
                                        });
                                    }
                                });
                                this.postMessage = function(a) {
                                    setTimeout(function() {
                                        c.dispatcher.saveDispatch({
                                            data: a
                                        });
                                    }, 0);
                                };
                            }
                            if (typeof document === Yxe && typeof self !== Yxe) {
                                var i = new h(self);
                                self.onmessage = i.saveDispatch;
                            } else if (typeof module1 !== Yxe && module1.exports) {
                                Object.defineProperty(exports, '__esModule', {
                                    value: true
                                });
                                module1.exports = {
                                    'default': j,
                                    Worker: j
                                };
                            }
                        }
                        function i5b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            k = new j3b(c);
                            kQb(k, b);
                            pQb(k, (Ywc(), Awc), b);
                            k.o.a = b.g;
                            k.o.b = b.f;
                            k.n.a = b.i;
                            k.n.b = b.j;
                            Rmb(c.a, k);
                            Zjb(a.a, b, k);
                            ((!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a).i != 0 || Heb(TD(Gxd(b, (yCc(), NAc))))) && pQb(k, Yvc, (Geb(), true));
                            j = RD(mQb(c, kwc), 21);
                            l = RD(mQb(k, (yCc(), BBc)), 101);
                            l == (Bod(), Aod) ? pQb(k, BBc, zod) : l != zod && j.Fc((ovc(), kvc));
                            m = 0;
                            d = RD(mQb(c, rAc), 88);
                            for(i = new dMd((!b.c && (b.c = new C5d(K4, b, 9, 9)), b.c)); i.e != i.i.gc();){
                                h = RD(bMd(i), 123);
                                e = vCd(b);
                                (dE(Gxd(e, cAc)) !== dE((kEc(), hEc)) || dE(Gxd(e, pAc)) === dE((Ptc(), Otc)) || dE(Gxd(e, pAc)) === dE((Ptc(), Mtc)) || Heb(TD(Gxd(e, eAc))) || dE(Gxd(e, Yzc)) !== dE((U$b(), T$b)) || dE(Gxd(e, ZAc)) === dE((aEc(), TDc)) || dE(Gxd(e, ZAc)) === dE((aEc(), UDc)) || dE(Gxd(e, $Ac)) === dE((_Cc(), SCc)) || dE(Gxd(e, $Ac)) === dE((_Cc(), UCc))) && !Heb(TD(Gxd(b, aAc))) && Ixd(h, zwc, sgb(m++));
                                Heb(TD(Gxd(h, pBc))) || j5b(a, h, k, j, d, l);
                            }
                            for(g = new dMd((!b.n && (b.n = new C5d(I4, b, 1, 7)), b.n)); g.e != g.i.gc();){
                                f = RD(bMd(g), 135);
                                !Heb(TD(Gxd(f, pBc))) && !!f.a && Rmb(k.b, h5b(f));
                            }
                            Heb(TD(mQb(k, Uzc))) && j.Fc((ovc(), fvc));
                            if (Heb(TD(mQb(k, MAc)))) {
                                j.Fc((ovc(), jvc));
                                j.Fc(ivc);
                                pQb(k, BBc, zod);
                            }
                            return k;
                        }
                        function ird(a, b, c, d, e, f, g) {
                            var h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
                            p = 0;
                            D = 0;
                            for(j = new Anb(a.b); j.a < j.c.c.length;){
                                i = RD(ynb(j), 163);
                                !!i.c && Dsd(i.c);
                                p = $wnd.Math.max(p, urd(i));
                                D += urd(i) * trd(i);
                            }
                            q = D / a.b.c.length;
                            C = brd(a.b, q);
                            D += a.b.c.length * C;
                            p = $wnd.Math.max(p, $wnd.Math.sqrt(D * g)) + c.b;
                            H = c.b;
                            I = c.d;
                            n = 0;
                            l = c.b + c.c;
                            B = new Yub;
                            Mub(B, sgb(0));
                            w = new Yub;
                            k = new Jkb(a.b, 0);
                            o = null;
                            h = new bnb;
                            while(k.b < k.d.gc()){
                                i = (sFb(k.b < k.d.gc()), RD(k.d.Xb(k.c = k.b++), 163));
                                G = urd(i);
                                m = trd(i);
                                if (H + G > p) {
                                    if (f) {
                                        Oub(w, n);
                                        Oub(B, sgb(k.b - 1));
                                        Rmb(a.d, o);
                                        h.c.length = 0;
                                    }
                                    H = c.b;
                                    I += n + b;
                                    n = 0;
                                    l = $wnd.Math.max(l, c.b + c.c + G);
                                }
                                ZEb(h.c, i);
                                xrd(i, H, I);
                                l = $wnd.Math.max(l, H + G + c.c);
                                n = $wnd.Math.max(n, m);
                                H += G + b;
                                o = i;
                            }
                            Tmb(a.a, h);
                            Rmb(a.d, RD(Vmb(h, h.c.length - 1), 163));
                            l = $wnd.Math.max(l, d);
                            F = I + n + c.a;
                            if (F < e) {
                                n += e - F;
                                F = e;
                            }
                            if (f) {
                                H = c.b;
                                k = new Jkb(a.b, 0);
                                Oub(B, sgb(a.b.c.length));
                                A = Sub(B, 0);
                                s = RD(evb(A), 17).a;
                                Oub(w, n);
                                v = Sub(w, 0);
                                u = 0;
                                while(k.b < k.d.gc()){
                                    if (k.b == s) {
                                        H = c.b;
                                        u = Kfb(UD(evb(v)));
                                        s = RD(evb(A), 17).a;
                                    }
                                    i = (sFb(k.b < k.d.gc()), RD(k.d.Xb(k.c = k.b++), 163));
                                    vrd(i, u);
                                    if (k.b == s) {
                                        r = l - H - c.c;
                                        t = urd(i);
                                        wrd(i, r);
                                        yrd(i, (r - t) / 2, 0);
                                    }
                                    H += urd(i) + b;
                                }
                            }
                            return new rjd(l, F);
                        }
                        function zne(a) {
                            if (a.N) return;
                            a.N = true;
                            a.b = jBd(a, 0);
                            iBd(a.b, 0);
                            iBd(a.b, 1);
                            iBd(a.b, 2);
                            a.bb = jBd(a, 1);
                            iBd(a.bb, 0);
                            iBd(a.bb, 1);
                            a.fb = jBd(a, 2);
                            iBd(a.fb, 3);
                            iBd(a.fb, 4);
                            oBd(a.fb, 5);
                            a.qb = jBd(a, 3);
                            iBd(a.qb, 0);
                            oBd(a.qb, 1);
                            oBd(a.qb, 2);
                            iBd(a.qb, 3);
                            iBd(a.qb, 4);
                            oBd(a.qb, 5);
                            iBd(a.qb, 6);
                            a.a = kBd(a, 4);
                            a.c = kBd(a, 5);
                            a.d = kBd(a, 6);
                            a.e = kBd(a, 7);
                            a.f = kBd(a, 8);
                            a.g = kBd(a, 9);
                            a.i = kBd(a, 10);
                            a.j = kBd(a, 11);
                            a.k = kBd(a, 12);
                            a.n = kBd(a, 13);
                            a.o = kBd(a, 14);
                            a.p = kBd(a, 15);
                            a.q = kBd(a, 16);
                            a.s = kBd(a, 17);
                            a.r = kBd(a, 18);
                            a.t = kBd(a, 19);
                            a.u = kBd(a, 20);
                            a.v = kBd(a, 21);
                            a.w = kBd(a, 22);
                            a.B = kBd(a, 23);
                            a.A = kBd(a, 24);
                            a.C = kBd(a, 25);
                            a.D = kBd(a, 26);
                            a.F = kBd(a, 27);
                            a.G = kBd(a, 28);
                            a.H = kBd(a, 29);
                            a.J = kBd(a, 30);
                            a.I = kBd(a, 31);
                            a.K = kBd(a, 32);
                            a.M = kBd(a, 33);
                            a.L = kBd(a, 34);
                            a.P = kBd(a, 35);
                            a.Q = kBd(a, 36);
                            a.R = kBd(a, 37);
                            a.S = kBd(a, 38);
                            a.T = kBd(a, 39);
                            a.U = kBd(a, 40);
                            a.V = kBd(a, 41);
                            a.X = kBd(a, 42);
                            a.W = kBd(a, 43);
                            a.Y = kBd(a, 44);
                            a.Z = kBd(a, 45);
                            a.$ = kBd(a, 46);
                            a._ = kBd(a, 47);
                            a.ab = kBd(a, 48);
                            a.cb = kBd(a, 49);
                            a.db = kBd(a, 50);
                            a.eb = kBd(a, 51);
                            a.gb = kBd(a, 52);
                            a.hb = kBd(a, 53);
                            a.ib = kBd(a, 54);
                            a.jb = kBd(a, 55);
                            a.kb = kBd(a, 56);
                            a.lb = kBd(a, 57);
                            a.mb = kBd(a, 58);
                            a.nb = kBd(a, 59);
                            a.ob = kBd(a, 60);
                            a.pb = kBd(a, 61);
                        }
                        function w8b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
                            s = 0;
                            if (b.f.a == 0) for(q = new Anb(a); q.a < q.c.c.length;){
                                o = RD(ynb(q), 10);
                                s = $wnd.Math.max(s, o.n.a + o.o.a + o.d.c);
                            }
                            else s = b.f.a - b.c.a;
                            s -= b.c.a;
                            for(p = new Anb(a); p.a < p.c.c.length;){
                                o = RD(ynb(p), 10);
                                x8b(o.n, s - o.o.a);
                                y8b(o.f);
                                u8b(o);
                                (!o.q ? (yob(), yob(), wob) : o.q)._b((yCc(), IBc)) && x8b(RD(mQb(o, IBc), 8), s - o.o.a);
                                switch(RD(mQb(o, Rzc), 255).g){
                                    case 1:
                                        pQb(o, Rzc, (Rjd(), Pjd));
                                        break;
                                    case 2:
                                        pQb(o, Rzc, (Rjd(), Ojd));
                                }
                                r = o.o;
                                for(u = new Anb(o.j); u.a < u.c.c.length;){
                                    t = RD(ynb(u), 12);
                                    x8b(t.n, r.a - t.o.a);
                                    x8b(t.a, t.o.a);
                                    Q3b(t, o8b(t.j));
                                    g = RD(mQb(t, CBc), 17);
                                    !!g && pQb(t, CBc, sgb(-g.a));
                                    for(f = new Anb(t.g); f.a < f.c.c.length;){
                                        e = RD(ynb(f), 18);
                                        for(d = Sub(e.a, 0); d.b != d.d.c;){
                                            c = RD(evb(d), 8);
                                            c.a = s - c.a;
                                        }
                                        j = RD(mQb(e, RAc), 75);
                                        if (j) for(i = Sub(j, 0); i.b != i.d.c;){
                                            h = RD(evb(i), 8);
                                            h.a = s - h.a;
                                        }
                                        for(m = new Anb(e.b); m.a < m.c.c.length;){
                                            k = RD(ynb(m), 72);
                                            x8b(k.n, s - k.o.a);
                                        }
                                    }
                                    for(n = new Anb(t.f); n.a < n.c.c.length;){
                                        k = RD(ynb(n), 72);
                                        x8b(k.n, t.o.a - k.o.a);
                                    }
                                }
                                if (o.k == (r3b(), m3b)) {
                                    pQb(o, (Ywc(), hwc), o8b(RD(mQb(o, hwc), 64)));
                                    t8b(o);
                                }
                                for(l = new Anb(o.b); l.a < l.c.c.length;){
                                    k = RD(ynb(l), 72);
                                    u8b(k);
                                    x8b(k.n, r.a - k.o.a);
                                }
                            }
                        }
                        function z8b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
                            s = 0;
                            if (b.f.b == 0) for(q = new Anb(a); q.a < q.c.c.length;){
                                o = RD(ynb(q), 10);
                                s = $wnd.Math.max(s, o.n.b + o.o.b + o.d.a);
                            }
                            else s = b.f.b - b.c.b;
                            s -= b.c.b;
                            for(p = new Anb(a); p.a < p.c.c.length;){
                                o = RD(ynb(p), 10);
                                A8b(o.n, s - o.o.b);
                                B8b(o.f);
                                v8b(o);
                                (!o.q ? (yob(), yob(), wob) : o.q)._b((yCc(), IBc)) && A8b(RD(mQb(o, IBc), 8), s - o.o.b);
                                switch(RD(mQb(o, Rzc), 255).g){
                                    case 3:
                                        pQb(o, Rzc, (Rjd(), Mjd));
                                        break;
                                    case 4:
                                        pQb(o, Rzc, (Rjd(), Qjd));
                                }
                                r = o.o;
                                for(u = new Anb(o.j); u.a < u.c.c.length;){
                                    t = RD(ynb(u), 12);
                                    A8b(t.n, r.b - t.o.b);
                                    A8b(t.a, t.o.b);
                                    Q3b(t, p8b(t.j));
                                    g = RD(mQb(t, CBc), 17);
                                    !!g && pQb(t, CBc, sgb(-g.a));
                                    for(f = new Anb(t.g); f.a < f.c.c.length;){
                                        e = RD(ynb(f), 18);
                                        for(d = Sub(e.a, 0); d.b != d.d.c;){
                                            c = RD(evb(d), 8);
                                            c.b = s - c.b;
                                        }
                                        j = RD(mQb(e, RAc), 75);
                                        if (j) for(i = Sub(j, 0); i.b != i.d.c;){
                                            h = RD(evb(i), 8);
                                            h.b = s - h.b;
                                        }
                                        for(m = new Anb(e.b); m.a < m.c.c.length;){
                                            k = RD(ynb(m), 72);
                                            A8b(k.n, s - k.o.b);
                                        }
                                    }
                                    for(n = new Anb(t.f); n.a < n.c.c.length;){
                                        k = RD(ynb(n), 72);
                                        A8b(k.n, t.o.b - k.o.b);
                                    }
                                }
                                if (o.k == (r3b(), m3b)) {
                                    pQb(o, (Ywc(), hwc), p8b(RD(mQb(o, hwc), 64)));
                                    s8b(o);
                                }
                                for(l = new Anb(o.b); l.a < l.c.c.length;){
                                    k = RD(ynb(l), 72);
                                    v8b(k);
                                    A8b(k.n, r.b - k.o.b);
                                }
                            }
                        }
                        function Drc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H;
                            s = new Jkb(a.b, 0);
                            k = b.Kc();
                            o = 0;
                            j = RD(k.Pb(), 17).a;
                            v = 0;
                            c = new _sb;
                            A = new Iub;
                            while(s.b < s.d.gc()){
                                r = (sFb(s.b < s.d.gc()), RD(s.d.Xb(s.c = s.b++), 30));
                                for(u = new Anb(r.a); u.a < u.c.c.length;){
                                    t = RD(ynb(u), 10);
                                    for(n = new is(Mr(a3b(t).a.Kc(), new ir)); gs(n);){
                                        l = RD(hs(n), 18);
                                        A.a.zc(l, A);
                                    }
                                    for(m = new is(Mr(Z2b(t).a.Kc(), new ir)); gs(m);){
                                        l = RD(hs(m), 18);
                                        A.a.Bc(l);
                                    }
                                }
                                if (o + 1 == j) {
                                    e = new R4b(a);
                                    Ikb(s, e);
                                    f = new R4b(a);
                                    Ikb(s, f);
                                    for(C = A.a.ec().Kc(); C.Ob();){
                                        B = RD(C.Pb(), 18);
                                        if (!c.a._b(B)) {
                                            ++v;
                                            c.a.zc(B, c);
                                        }
                                        g = new j3b(a);
                                        pQb(g, (yCc(), BBc), (Bod(), yod));
                                        g3b(g, e);
                                        h3b(g, (r3b(), l3b));
                                        p = new R3b;
                                        P3b(p, g);
                                        Q3b(p, (qpd(), ppd));
                                        D = new R3b;
                                        P3b(D, g);
                                        Q3b(D, Xod);
                                        d = new j3b(a);
                                        pQb(d, BBc, yod);
                                        g3b(d, f);
                                        h3b(d, l3b);
                                        q = new R3b;
                                        P3b(q, d);
                                        Q3b(q, ppd);
                                        F = new R3b;
                                        P3b(F, d);
                                        Q3b(F, Xod);
                                        w = new a1b;
                                        Y0b(w, B.c);
                                        Z0b(w, p);
                                        pQb(w, (Ywc(), zwc), RD(mQb(B, zwc), 17));
                                        H = new a1b;
                                        Y0b(H, D);
                                        Z0b(H, q);
                                        pQb(H, zwc, RD(mQb(B, zwc), 17));
                                        Y0b(B, F);
                                        h = new Jrc(g, d, w, H, B);
                                        pQb(g, Wvc, h);
                                        pQb(d, Wvc, h);
                                        G = w.c.i;
                                        if (G.k == l3b) {
                                            i = RD(mQb(G, Wvc), 313);
                                            i.d = h;
                                            h.g = i;
                                        }
                                    }
                                    if (k.Ob()) j = RD(k.Pb(), 17).a;
                                    else break;
                                }
                                ++o;
                            }
                            return sgb(v);
                        }
                        function rkc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
                            p = new bnb;
                            for(m = new Anb(a.d.b); m.a < m.c.c.length;){
                                l = RD(ynb(m), 30);
                                for(o = new Anb(l.a); o.a < o.c.c.length;){
                                    n = RD(ynb(o), 10);
                                    e = RD(Wjb(a.f, n), 60);
                                    for(i = new is(Mr(a3b(n).a.Kc(), new ir)); gs(i);){
                                        g = RD(hs(i), 18);
                                        d = Sub(g.a, 0);
                                        j = true;
                                        k = null;
                                        if (d.b != d.d.c) {
                                            b = RD(evb(d), 8);
                                            c = null;
                                            if (g.c.j == (qpd(), Yod)) {
                                                q = new Nlc(b, new rjd(b.a, e.d.d), e, g);
                                                q.f.a = true;
                                                q.a = g.c;
                                                ZEb(p.c, q);
                                            }
                                            if (g.c.j == npd) {
                                                q = new Nlc(b, new rjd(b.a, e.d.d + e.d.a), e, g);
                                                q.f.d = true;
                                                q.a = g.c;
                                                ZEb(p.c, q);
                                            }
                                            while(d.b != d.d.c){
                                                c = RD(evb(d), 8);
                                                if (!rGb(b.b, c.b)) {
                                                    k = new Nlc(b, c, null, g);
                                                    ZEb(p.c, k);
                                                    if (j) {
                                                        j = false;
                                                        if (c.b < e.d.d) k.f.a = true;
                                                        else if (c.b > e.d.d + e.d.a) k.f.d = true;
                                                        else {
                                                            k.f.d = true;
                                                            k.f.a = true;
                                                        }
                                                    }
                                                }
                                                d.b != d.d.c && (b = c);
                                            }
                                            if (k) {
                                                f = RD(Wjb(a.f, g.d.i), 60);
                                                if (b.b < f.d.d) k.f.a = true;
                                                else if (b.b > f.d.d + f.d.a) k.f.d = true;
                                                else {
                                                    k.f.d = true;
                                                    k.f.a = true;
                                                }
                                            }
                                        }
                                    }
                                    for(h = new is(Mr(Z2b(n).a.Kc(), new ir)); gs(h);){
                                        g = RD(hs(h), 18);
                                        if (g.a.b != 0) {
                                            b = RD(Rub(g.a), 8);
                                            if (g.d.j == (qpd(), Yod)) {
                                                q = new Nlc(b, new rjd(b.a, e.d.d), e, g);
                                                q.f.a = true;
                                                q.a = g.d;
                                                ZEb(p.c, q);
                                            }
                                            if (g.d.j == npd) {
                                                q = new Nlc(b, new rjd(b.a, e.d.d + e.d.a), e, g);
                                                q.f.d = true;
                                                q.a = g.d;
                                                ZEb(p.c, q);
                                            }
                                        }
                                    }
                                }
                            }
                            return p;
                        }
                        function Nvd(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m;
                            i = new bnb;
                            l = b.length;
                            g = $5d(c);
                            for(j = 0; j < l; ++j){
                                k = rhb(b, Fhb(61), j);
                                d = wvd(g, (AFb(j, k, b.length), b.substr(j, k - j)));
                                e = iXd(d);
                                f = e.jk().wi();
                                switch(ihb(b, ++k)){
                                    case 39:
                                        h = phb(b, 39, ++k);
                                        Rmb(i, new KTd(d, lwd((AFb(k, h, b.length), b.substr(k, h - k)), f, e)));
                                        j = h + 1;
                                        break;
                                    case 34:
                                        h = phb(b, 34, ++k);
                                        Rmb(i, new KTd(d, lwd((AFb(k, h, b.length), b.substr(k, h - k)), f, e)));
                                        j = h + 1;
                                        break;
                                    case 91:
                                        m = new bnb;
                                        Rmb(i, new KTd(d, m));
                                        n: for(;;){
                                            switch(ihb(b, ++k)){
                                                case 39:
                                                    h = phb(b, 39, ++k);
                                                    Rmb(m, lwd((AFb(k, h, b.length), b.substr(k, h - k)), f, e));
                                                    k = h + 1;
                                                    break;
                                                case 34:
                                                    h = phb(b, 34, ++k);
                                                    Rmb(m, lwd((AFb(k, h, b.length), b.substr(k, h - k)), f, e));
                                                    k = h + 1;
                                                    break;
                                                case 110:
                                                    ++k;
                                                    if (b.indexOf('ull', k) == k) m.c.push(null);
                                                    else throw Adb(new yz(MHe));
                                                    k += 3;
                                                    break;
                                            }
                                            if (k < l) switch(BFb(k, b.length), b.charCodeAt(k)){
                                                case 44:
                                                    break;
                                                case 93:
                                                    break n;
                                                default:
                                                    throw Adb(new yz('Expecting , or ]'));
                                            }
                                            else break;
                                        }
                                        j = k + 1;
                                        break;
                                    case 110:
                                        ++k;
                                        if (b.indexOf('ull', k) == k) Rmb(i, new KTd(d, null));
                                        else throw Adb(new yz(MHe));
                                        j = k + 3;
                                        break;
                                }
                                if (j < l) {
                                    BFb(j, b.length);
                                    if (b.charCodeAt(j) != 44) throw Adb(new yz('Expecting ,'));
                                } else break;
                            }
                            return Ovd(a, i, c);
                        }
                        function Oqe(a) {
                            var b, c, d, e, f;
                            b = a.c;
                            f = null;
                            switch(b){
                                case 6:
                                    return a.Em();
                                case 13:
                                    return a.Fm();
                                case 23:
                                    return a.wm();
                                case 22:
                                    return a.Bm();
                                case 18:
                                    return a.ym();
                                case 8:
                                    Mqe(a);
                                    f = (Vse(), Dse);
                                    break;
                                case 9:
                                    return a.em(true);
                                case 19:
                                    return a.fm();
                                case 10:
                                    switch(a.a){
                                        case 100:
                                        case 68:
                                        case 119:
                                        case 87:
                                        case 115:
                                        case 83:
                                            f = a.dm(a.a);
                                            Mqe(a);
                                            return f;
                                        case 101:
                                        case 102:
                                        case 110:
                                        case 114:
                                        case 116:
                                        case 117:
                                        case 118:
                                        case 120:
                                            c = a.cm();
                                            c < txe ? f = (Vse(), Vse(), ++Use, new Hte(0, c)) : f = cte(qse(c));
                                            break;
                                        case 99:
                                            return a.om();
                                        case 67:
                                            return a.jm();
                                        case 105:
                                            return a.rm();
                                        case 73:
                                            return a.km();
                                        case 103:
                                            return a.pm();
                                        case 88:
                                            return a.lm();
                                        case 49:
                                        case 50:
                                        case 51:
                                        case 52:
                                        case 53:
                                        case 54:
                                        case 55:
                                        case 56:
                                        case 57:
                                            return a.gm();
                                        case 80:
                                        case 112:
                                            f = Sqe(a, a.a);
                                            if (!f) throw Adb(new Lqe(TId((Hde(), hJe))));
                                            break;
                                        default:
                                            f = Yse(a.a);
                                    }
                                    Mqe(a);
                                    break;
                                case 0:
                                    if (a.a == 93 || a.a == 123 || a.a == 125) throw Adb(new Lqe(TId((Hde(), gJe))));
                                    f = Yse(a.a);
                                    d = a.a;
                                    Mqe(a);
                                    if ((d & 64512) == uxe && a.c == 0 && (a.a & 64512) == 56320) {
                                        e = $C(hE, zwe, 28, 2, 15, 1);
                                        e[0] = d & Bwe;
                                        e[1] = a.a & Bwe;
                                        f = bte(cte(Ihb(e, 0, e.length)), 0);
                                        Mqe(a);
                                    }
                                    break;
                                default:
                                    throw Adb(new Lqe(TId((Hde(), gJe))));
                            }
                            return f;
                        }
                        function WUc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F;
                            C = new Yub;
                            w = new Yub;
                            q = -1;
                            for(i = new Anb(a); i.a < i.c.c.length;){
                                g = RD(ynb(i), 131);
                                g.s = q--;
                                k = 0;
                                t = 0;
                                for(f = new Anb(g.t); f.a < f.c.c.length;){
                                    d = RD(ynb(f), 274);
                                    t += d.c;
                                }
                                for(e = new Anb(g.i); e.a < e.c.c.length;){
                                    d = RD(ynb(e), 274);
                                    k += d.c;
                                }
                                g.n = k;
                                g.u = t;
                                t == 0 ? Pub(w, g, w.c.b, w.c) : k == 0 && Pub(C, g, C.c.b, C.c);
                            }
                            F = Xx(a);
                            l = a.c.length;
                            p = l + 1;
                            r = l - 1;
                            n = new bnb;
                            while(F.a.gc() != 0){
                                while(w.b != 0){
                                    v = (sFb(w.b != 0), RD(Wub(w, w.a.a), 131));
                                    F.a.Bc(v);
                                    v.s = r--;
                                    $Uc(v, C, w);
                                }
                                while(C.b != 0){
                                    A = (sFb(C.b != 0), RD(Wub(C, C.a.a), 131));
                                    F.a.Bc(A);
                                    A.s = p++;
                                    $Uc(A, C, w);
                                }
                                o = qwe;
                                for(j = F.a.ec().Kc(); j.Ob();){
                                    g = RD(j.Pb(), 131);
                                    s = g.u - g.n;
                                    if (s >= o) {
                                        if (s > o) {
                                            n.c.length = 0;
                                            o = s;
                                        }
                                        ZEb(n.c, g);
                                    }
                                }
                                if (n.c.length != 0) {
                                    m = RD(Vmb(n, Jwb(b, n.c.length)), 131);
                                    F.a.Bc(m);
                                    m.s = p++;
                                    $Uc(m, C, w);
                                    n.c.length = 0;
                                }
                            }
                            u = a.c.length + 1;
                            for(h = new Anb(a); h.a < h.c.c.length;){
                                g = RD(ynb(h), 131);
                                g.s < l && (g.s += u);
                            }
                            for(B = new Anb(a); B.a < B.c.c.length;){
                                A = RD(ynb(B), 131);
                                c = new Jkb(A.t, 0);
                                while(c.b < c.d.gc()){
                                    d = (sFb(c.b < c.d.gc()), RD(c.d.Xb(c.c = c.b++), 274));
                                    D = d.b;
                                    if (A.s > D.s) {
                                        Ckb(c);
                                        Ymb(D.i, d);
                                        if (d.c > 0) {
                                            d.a = D;
                                            Rmb(D.t, d);
                                            d.b = A;
                                            Rmb(A.i, d);
                                        }
                                    }
                                }
                            }
                        }
                        function Efc(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F;
                            p = new cnb(b.b);
                            u = new cnb(b.b);
                            m = new cnb(b.b);
                            B = new cnb(b.b);
                            q = new cnb(b.b);
                            for(A = Sub(b, 0); A.b != A.d.c;){
                                v = RD(evb(A), 12);
                                for(h = new Anb(v.g); h.a < h.c.c.length;){
                                    f = RD(ynb(h), 18);
                                    if (f.c.i == f.d.i) {
                                        if (v.j == f.d.j) {
                                            ZEb(B.c, f);
                                            continue;
                                        } else if (v.j == (qpd(), Yod) && f.d.j == npd) {
                                            ZEb(q.c, f);
                                            continue;
                                        }
                                    }
                                }
                            }
                            for(i = new Anb(q); i.a < i.c.c.length;){
                                f = RD(ynb(i), 18);
                                Ffc(a, f, c, d, (qpd(), Xod));
                            }
                            for(g = new Anb(B); g.a < g.c.c.length;){
                                f = RD(ynb(g), 18);
                                C = new j3b(a);
                                h3b(C, (r3b(), q3b));
                                pQb(C, (yCc(), BBc), (Bod(), wod));
                                pQb(C, (Ywc(), Awc), f);
                                D = new R3b;
                                pQb(D, Awc, f.d);
                                Q3b(D, (qpd(), ppd));
                                P3b(D, C);
                                F = new R3b;
                                pQb(F, Awc, f.c);
                                Q3b(F, Xod);
                                P3b(F, C);
                                pQb(f.c, Iwc, C);
                                pQb(f.d, Iwc, C);
                                Y0b(f, null);
                                Z0b(f, null);
                                ZEb(c.c, C);
                                pQb(C, $vc, sgb(2));
                            }
                            for(w = Sub(b, 0); w.b != w.d.c;){
                                v = RD(evb(w), 12);
                                j = v.e.c.length > 0;
                                r = v.g.c.length > 0;
                                j && r ? ZEb(m.c, v) : j ? ZEb(p.c, v) : r && ZEb(u.c, v);
                            }
                            for(o = new Anb(p); o.a < o.c.c.length;){
                                n = RD(ynb(o), 12);
                                Rmb(e, Dfc(a, n, null, c));
                            }
                            for(t = new Anb(u); t.a < t.c.c.length;){
                                s = RD(ynb(t), 12);
                                Rmb(e, Dfc(a, null, s, c));
                            }
                            for(l = new Anb(m); l.a < l.c.c.length;){
                                k = RD(ynb(l), 12);
                                Rmb(e, Dfc(a, k, k, c));
                            }
                        }
                        function psd(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            m = oxe;
                            n = oxe;
                            k = 0;
                            l = 0;
                            i = new bnb;
                            for(h = new dMd((!a.b && (a.b = new C5d(G4, a, 12, 3)), a.b)); h.e != h.i.gc();){
                                f = RD(bMd(h), 74);
                                i = Al(cD(WC(cJ, 1), rve, 20, 0, [
                                    i,
                                    (!f.n && (f.n = new C5d(I4, f, 1, 7)), f.n)
                                ]));
                            }
                            for(t = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                (!a.n && (a.n = new C5d(I4, a, 1, 7)), a.n),
                                (!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a),
                                i
                            ]))); gs(t);){
                                s = RD(hs(t), 422);
                                j = RD(s.of((umd(), eld)), 140);
                                m > s.nh() - j.b && (m = s.nh() - j.b);
                                n > s.oh() - j.d && (n = s.oh() - j.d);
                                k < s.nh() + s.mh() + j.c && (k = s.nh() + s.mh() + j.c);
                                l < s.oh() + s.lh() + j.a && (l = s.oh() + s.lh() + j.a);
                            }
                            for(g = new dMd((!a.b && (a.b = new C5d(G4, a, 12, 3)), a.b)); g.e != g.i.gc();){
                                f = RD(bMd(g), 74);
                                for(r = new dMd((!f.a && (f.a = new C5d(F4, f, 6, 6)), f.a)); r.e != r.i.gc();){
                                    q = RD(bMd(r), 166);
                                    o = q.j;
                                    d = q.b;
                                    p = q.k;
                                    e = q.c;
                                    m = $wnd.Math.min(m, o);
                                    m = $wnd.Math.min(m, d);
                                    k = $wnd.Math.max(k, o);
                                    k = $wnd.Math.max(k, d);
                                    n = $wnd.Math.min(n, p);
                                    n = $wnd.Math.min(n, e);
                                    l = $wnd.Math.max(l, p);
                                    l = $wnd.Math.max(l, e);
                                    for(c = new dMd((!q.a && (q.a = new XZd(D4, q, 5)), q.a)); c.e != c.i.gc();){
                                        b = RD(bMd(c), 377);
                                        m = $wnd.Math.min(m, b.a);
                                        k = $wnd.Math.max(k, b.a);
                                        n = $wnd.Math.min(n, b.b);
                                        l = $wnd.Math.max(l, b.b);
                                    }
                                }
                            }
                            Ixd(a, (umd(), Ikd), k - m);
                            Ixd(a, Hkd, l - n);
                        }
                        function uOc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l;
                            c.Ug('Network simplex node placement', 1);
                            a.e = b;
                            a.n = RD(mQb(b, (Ywc(), Qwc)), 312);
                            tOc(a);
                            fOc(a);
                            FDb(EDb(new SDb(null, new Swb(a.e.b, 16)), new iPc), new kPc(a));
                            FDb(CDb(EDb(CDb(EDb(new SDb(null, new Swb(a.e.b, 16)), new ZPc), new _Pc), new bQc), new dQc), new gPc(a));
                            if (Heb(TD(mQb(a.e, (yCc(), gBc))))) {
                                g = c.eh(1);
                                g.Ug('Straight Edges Pre-Processing', 1);
                                sOc(a);
                                g.Vg();
                            }
                            AIb(a.f);
                            f = RD(mQb(b, gCc), 17).a * a.f.a.c.length;
                            lJb(yJb(zJb(CJb(a.f), f), false), c.eh(1));
                            if (a.d.a.gc() != 0) {
                                g = c.eh(1);
                                g.Ug('Flexible Where Space Processing', 1);
                                h = RD(Lvb(KDb(GDb(new SDb(null, new Swb(a.f.a, 16)), new mPc), new IOc)), 17).a;
                                i = RD(Lvb(JDb(GDb(new SDb(null, new Swb(a.f.a, 16)), new oPc), new MOc)), 17).a;
                                j = i - h;
                                k = eJb(new gJb, a.f);
                                l = eJb(new gJb, a.f);
                                rIb(uIb(tIb(sIb(vIb(new wIb, 20000), j), k), l));
                                FDb(CDb(CDb(_nb(a.i), new qPc), new sPc), new uPc(h, k, j, l));
                                for(e = a.d.a.ec().Kc(); e.Ob();){
                                    d = RD(e.Pb(), 218);
                                    d.g = 1;
                                }
                                lJb(yJb(zJb(CJb(a.f), f), false), g.eh(1));
                                g.Vg();
                            }
                            if (Heb(TD(mQb(b, gBc)))) {
                                g = c.eh(1);
                                g.Ug('Straight Edges Post-Processing', 1);
                                rOc(a);
                                g.Vg();
                            }
                            eOc(a);
                            a.e = null;
                            a.f = null;
                            a.i = null;
                            a.c = null;
                            akb(a.k);
                            a.j = null;
                            a.a = null;
                            a.o = null;
                            a.d.a.$b();
                            c.Vg();
                        }
                        function XGc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            c.Ug('Depth first model order layering', 1);
                            a.d = b;
                            q = new bnb;
                            for(p = new Anb(a.d.a); p.a < p.c.c.length;){
                                n = RD(ynb(p), 10);
                                n.k == (r3b(), p3b) && ZEb(q.c, n);
                            }
                            yob();
                            _mb(q, new aHc);
                            g = true;
                            a.b = new R4b(a.d);
                            a.a = null;
                            Rmb(a.d.b, a.b);
                            a.b.p = 0;
                            a.c = 0;
                            a.f = new Yub;
                            for(o = new Anb(q); o.a < o.c.c.length;){
                                n = RD(ynb(o), 10);
                                if (g) {
                                    g3b(n, a.b);
                                    g = false;
                                } else if (VGc(a, n)) {
                                    m = a.c;
                                    m = UGc(m, n);
                                    d = m + 2;
                                    k = m - a.c;
                                    if (a.f.b == 0) TGc(a, d, n);
                                    else if (k > 0) {
                                        for(t = Sub(a.f, 0); t.b != t.d.c;){
                                            s = RD(evb(t), 10);
                                            s.p += m - a.e;
                                        }
                                        WGc(a);
                                        Xub(a.f);
                                        TGc(a, d, n);
                                    } else {
                                        Mub(a.f, n);
                                        n.p = d;
                                        a.e = $wnd.Math.max(a.e, d);
                                        for(f = new is(Mr(Z2b(n).a.Kc(), new ir)); gs(f);){
                                            e = RD(hs(f), 18);
                                            if (!e.c.i.c && e.c.i.k == (r3b(), n3b)) {
                                                Mub(a.f, e.c.i);
                                                e.c.i.p = d - 1;
                                            }
                                        }
                                        a.c = d;
                                    }
                                } else {
                                    WGc(a);
                                    Xub(a.f);
                                    d = 0;
                                    if (gs(new is(Mr(Z2b(n).a.Kc(), new ir)))) {
                                        m = 0;
                                        m = UGc(m, n);
                                        d = m + 2;
                                        TGc(a, d, n);
                                    } else {
                                        Mub(a.f, n);
                                        n.p = 0;
                                        a.e = $wnd.Math.max(a.e, 0);
                                        a.b = RD(Vmb(a.d.b, 0), 30);
                                        a.c = 0;
                                    }
                                }
                            }
                            a.f.b == 0 || WGc(a);
                            a.d.a.c.length = 0;
                            r = new bnb;
                            for(j = new Anb(a.d.b); j.a < j.c.c.length;){
                                h = RD(ynb(j), 30);
                                h.a.c.length == 0 && ZEb(r.c, h);
                            }
                            Ce(a.d.b, r);
                            l = 0;
                            for(i = new Anb(a.d.b); i.a < i.c.c.length;){
                                h = RD(ynb(i), 30);
                                h.p = l;
                                ++l;
                            }
                            c.Vg();
                        }
                        function EEd(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K;
                            D = null;
                            G = b;
                            F = pEd(a, DGd(c), G);
                            jyd(F, zDd(G, uIe));
                            H = RD(Ao(a.g, tDd(qC(G, bIe))), 27);
                            m = qC(G, 'sourcePort');
                            d = null;
                            !!m && (d = tDd(m));
                            I = RD(Ao(a.j, d), 123);
                            if (!H) {
                                h = uDd(G);
                                o = "An edge must have a source node (edge id: '" + h;
                                p = o + zIe;
                                throw Adb(new CDd(p));
                            }
                            if (!!I && !Hb(MCd(I), H)) {
                                i = zDd(G, uIe);
                                q = "The source port of an edge must be a port of the edge's source node (edge id: '" + i;
                                r = q + zIe;
                                throw Adb(new CDd(r));
                            }
                            B = (!F.b && (F.b = new Yie(E4, F, 4, 7)), F.b);
                            f = null;
                            I ? f = I : f = H;
                            WGd(B, f);
                            J = RD(Ao(a.g, tDd(qC(G, CIe))), 27);
                            n = qC(G, 'targetPort');
                            e = null;
                            !!n && (e = tDd(n));
                            K = RD(Ao(a.j, e), 123);
                            if (!J) {
                                l = uDd(G);
                                s = "An edge must have a target node (edge id: '" + l;
                                t = s + zIe;
                                throw Adb(new CDd(t));
                            }
                            if (!!K && !Hb(MCd(K), J)) {
                                j = zDd(G, uIe);
                                u = "The target port of an edge must be a port of the edge's target node (edge id: '" + j;
                                v = u + zIe;
                                throw Adb(new CDd(v));
                            }
                            C = (!F.c && (F.c = new Yie(E4, F, 5, 8)), F.c);
                            g = null;
                            K ? g = K : g = J;
                            WGd(C, g);
                            if ((!F.b && (F.b = new Yie(E4, F, 4, 7)), F.b).i == 0 || (!F.c && (F.c = new Yie(E4, F, 5, 8)), F.c).i == 0) {
                                k = zDd(G, uIe);
                                w = yIe + k;
                                A = w + zIe;
                                throw Adb(new CDd(A));
                            }
                            GEd(G, F);
                            FEd(G, F);
                            D = CEd(a, G, F);
                            return D;
                        }
                        function JTb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
                            n = RD(mQb(a, (JVb(), HVb)), 27);
                            t = lve;
                            u = lve;
                            r = qwe;
                            s = qwe;
                            for(w = new Anb(a.e); w.a < w.c.c.length;){
                                v = RD(ynb(w), 153);
                                F = v.d;
                                G = v.e;
                                t = $wnd.Math.min(t, F.a - G.a / 2);
                                u = $wnd.Math.min(u, F.b - G.b / 2);
                                r = $wnd.Math.max(r, F.a + G.a / 2);
                                s = $wnd.Math.max(s, F.b + G.b / 2);
                            }
                            for(c = new Anb(a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 250);
                                F = b.d;
                                G = b.e;
                                t = $wnd.Math.min(t, F.a - G.a / 2);
                                u = $wnd.Math.min(u, F.b - G.b / 2);
                                r = $wnd.Math.max(r, F.a + G.a / 2);
                                s = $wnd.Math.max(s, F.b + G.b / 2);
                            }
                            D = RD(Gxd(n, (yVb(), hVb)), 107);
                            C = new rjd(D.b - t, D.d - u);
                            for(j = new Anb(a.e); j.a < j.c.c.length;){
                                i = RD(ynb(j), 153);
                                B = mQb(i, HVb);
                                if (ZD(B, 207)) {
                                    p = RD(B, 27);
                                    A = $id(new sjd(i.d), C);
                                    Byd(p, A.a - p.g / 2, A.b - p.f / 2);
                                }
                            }
                            for(f = new Anb(a.c); f.a < f.c.c.length;){
                                e = RD(ynb(f), 290);
                                l = RD(mQb(e, HVb), 74);
                                m = IGd(l, true, true);
                                H = new sjd(ZTb(e));
                                $id(H, C);
                                Nzd(m, H.a, H.b);
                                Umb(e.a, new OTb(C, m));
                                d = new sjd($Tb(e));
                                $id(d, C);
                                Gzd(m, d.a, d.b);
                            }
                            for(h = new Anb(a.d); h.a < h.c.c.length;){
                                g = RD(ynb(h), 454);
                                o = RD(mQb(g, HVb), 135);
                                q = $id(new sjd(g.d), C);
                                Byd(o, q.a, q.b);
                            }
                            I = r - t + (D.b + D.c);
                            k = s - u + (D.d + D.a);
                            Heb(TD(Gxd(n, (umd(), mld)))) || Esd(n, I, k, false, true);
                            Ixd(n, Ikd, I - (D.b + D.c));
                            Ixd(n, Hkd, k - (D.d + D.a));
                        }
                        function F$b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
                            l = H$b(B$b(a, (qpd(), bpd)), b);
                            o = G$b(B$b(a, cpd), b);
                            u = G$b(B$b(a, kpd), b);
                            B = I$b(B$b(a, mpd), b);
                            m = I$b(B$b(a, Zod), b);
                            s = G$b(B$b(a, jpd), b);
                            p = G$b(B$b(a, dpd), b);
                            w = G$b(B$b(a, lpd), b);
                            v = G$b(B$b(a, $od), b);
                            C = I$b(B$b(a, apd), b);
                            r = G$b(B$b(a, hpd), b);
                            t = G$b(B$b(a, gpd), b);
                            A = G$b(B$b(a, _od), b);
                            D = I$b(B$b(a, ipd), b);
                            n = I$b(B$b(a, epd), b);
                            q = G$b(B$b(a, fpd), b);
                            c = Hid(cD(WC(iE, 1), vxe, 28, 15, [
                                s.a,
                                B.a,
                                w.a,
                                D.a
                            ]));
                            d = Hid(cD(WC(iE, 1), vxe, 28, 15, [
                                o.a,
                                l.a,
                                u.a,
                                q.a
                            ]));
                            e = r.a;
                            f = Hid(cD(WC(iE, 1), vxe, 28, 15, [
                                p.a,
                                m.a,
                                v.a,
                                n.a
                            ]));
                            j = Hid(cD(WC(iE, 1), vxe, 28, 15, [
                                s.b,
                                o.b,
                                p.b,
                                t.b
                            ]));
                            i = Hid(cD(WC(iE, 1), vxe, 28, 15, [
                                B.b,
                                l.b,
                                m.b,
                                q.b
                            ]));
                            k = C.b;
                            h = Hid(cD(WC(iE, 1), vxe, 28, 15, [
                                w.b,
                                u.b,
                                v.b,
                                A.b
                            ]));
                            x$b(B$b(a, bpd), c + e, j + k);
                            x$b(B$b(a, fpd), c + e, j + k);
                            x$b(B$b(a, cpd), c + e, 0);
                            x$b(B$b(a, kpd), c + e, j + k + i);
                            x$b(B$b(a, mpd), 0, j + k);
                            x$b(B$b(a, Zod), c + e + d, j + k);
                            x$b(B$b(a, dpd), c + e + d, 0);
                            x$b(B$b(a, lpd), 0, j + k + i);
                            x$b(B$b(a, $od), c + e + d, j + k + i);
                            x$b(B$b(a, apd), 0, j);
                            x$b(B$b(a, hpd), c, 0);
                            x$b(B$b(a, _od), 0, j + k + i);
                            x$b(B$b(a, epd), c + e + d, 0);
                            g = new pjd;
                            g.a = Hid(cD(WC(iE, 1), vxe, 28, 15, [
                                c + d + e + f,
                                C.a,
                                t.a,
                                A.a
                            ]));
                            g.b = Hid(cD(WC(iE, 1), vxe, 28, 15, [
                                j + i + k + h,
                                r.b,
                                D.b,
                                n.b
                            ]));
                            return g;
                        }
                        function EFb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
                            s = new rjd(oxe, oxe);
                            b = new rjd(pxe, pxe);
                            for(B = new Anb(a); B.a < B.c.c.length;){
                                A = RD(ynb(B), 8);
                                s.a = $wnd.Math.min(s.a, A.a);
                                s.b = $wnd.Math.min(s.b, A.b);
                                b.a = $wnd.Math.max(b.a, A.a);
                                b.b = $wnd.Math.max(b.b, A.b);
                            }
                            m = new rjd(b.a - s.a, b.b - s.b);
                            j = new rjd(s.a - 50, s.b - m.a - 50);
                            k = new rjd(s.a - 50, b.b + m.a + 50);
                            l = new rjd(b.a + m.b / 2 + 50, s.b + m.b / 2);
                            n = new XFb(j, k, l);
                            w = new _sb;
                            f = new bnb;
                            c = new bnb;
                            w.a.zc(n, w);
                            for(D = new Anb(a); D.a < D.c.c.length;){
                                C = RD(ynb(D), 8);
                                f.c.length = 0;
                                for(v = w.a.ec().Kc(); v.Ob();){
                                    t = RD(v.Pb(), 317);
                                    d = t.d;
                                    bjd(d, t.a);
                                    $y(bjd(t.d, C), bjd(t.d, t.a)) < 0 && ZEb(f.c, t);
                                }
                                c.c.length = 0;
                                for(u = new Anb(f); u.a < u.c.c.length;){
                                    t = RD(ynb(u), 317);
                                    for(q = new Anb(t.e); q.a < q.c.c.length;){
                                        o = RD(ynb(q), 177);
                                        g = true;
                                        for(i = new Anb(f); i.a < i.c.c.length;){
                                            h = RD(ynb(i), 317);
                                            h != t && (Fvb(o, Vmb(h.e, 0)) || Fvb(o, Vmb(h.e, 1)) || Fvb(o, Vmb(h.e, 2))) && (g = false);
                                        }
                                        g && ZEb(c.c, o);
                                    }
                                }
                                Ve(w, f);
                                xgb(w, new FFb);
                                for(p = new Anb(c); p.a < p.c.c.length;){
                                    o = RD(ynb(p), 177);
                                    Ysb(w, new XFb(C, o.a, o.b));
                                }
                            }
                            r = new _sb;
                            xgb(w, new HFb(r));
                            e = r.a.ec().Kc();
                            while(e.Ob()){
                                o = RD(e.Pb(), 177);
                                (WFb(n, o.a) || WFb(n, o.b)) && e.Qb();
                            }
                            xgb(r, new JFb);
                            return r;
                        }
                        function pvd() {
                            pvd = geb;
                            dvd();
                            ovd = cvd.a;
                            RD(QHd(xYd(cvd.a), 0), 19);
                            ivd = cvd.f;
                            RD(QHd(xYd(cvd.f), 0), 19);
                            RD(QHd(xYd(cvd.f), 1), 35);
                            nvd = cvd.n;
                            RD(QHd(xYd(cvd.n), 0), 35);
                            RD(QHd(xYd(cvd.n), 1), 35);
                            RD(QHd(xYd(cvd.n), 2), 35);
                            RD(QHd(xYd(cvd.n), 3), 35);
                            jvd = cvd.g;
                            RD(QHd(xYd(cvd.g), 0), 19);
                            RD(QHd(xYd(cvd.g), 1), 35);
                            fvd = cvd.c;
                            RD(QHd(xYd(cvd.c), 0), 19);
                            RD(QHd(xYd(cvd.c), 1), 19);
                            kvd = cvd.i;
                            RD(QHd(xYd(cvd.i), 0), 19);
                            RD(QHd(xYd(cvd.i), 1), 19);
                            RD(QHd(xYd(cvd.i), 2), 19);
                            RD(QHd(xYd(cvd.i), 3), 19);
                            RD(QHd(xYd(cvd.i), 4), 35);
                            lvd = cvd.j;
                            RD(QHd(xYd(cvd.j), 0), 19);
                            gvd = cvd.d;
                            RD(QHd(xYd(cvd.d), 0), 19);
                            RD(QHd(xYd(cvd.d), 1), 19);
                            RD(QHd(xYd(cvd.d), 2), 19);
                            RD(QHd(xYd(cvd.d), 3), 19);
                            RD(QHd(xYd(cvd.d), 4), 35);
                            RD(QHd(xYd(cvd.d), 5), 35);
                            RD(QHd(xYd(cvd.d), 6), 35);
                            RD(QHd(xYd(cvd.d), 7), 35);
                            evd = cvd.b;
                            RD(QHd(xYd(cvd.b), 0), 35);
                            RD(QHd(xYd(cvd.b), 1), 35);
                            hvd = cvd.e;
                            RD(QHd(xYd(cvd.e), 0), 35);
                            RD(QHd(xYd(cvd.e), 1), 35);
                            RD(QHd(xYd(cvd.e), 2), 35);
                            RD(QHd(xYd(cvd.e), 3), 35);
                            RD(QHd(xYd(cvd.e), 4), 19);
                            RD(QHd(xYd(cvd.e), 5), 19);
                            RD(QHd(xYd(cvd.e), 6), 19);
                            RD(QHd(xYd(cvd.e), 7), 19);
                            RD(QHd(xYd(cvd.e), 8), 19);
                            RD(QHd(xYd(cvd.e), 9), 19);
                            RD(QHd(xYd(cvd.e), 10), 35);
                            mvd = cvd.k;
                            RD(QHd(xYd(cvd.k), 0), 35);
                            RD(QHd(xYd(cvd.k), 1), 35);
                        }
                        function Pqe(a) {
                            var b, c, d, e, f;
                            b = a.c;
                            switch(b){
                                case 11:
                                    return a.vm();
                                case 12:
                                    return a.xm();
                                case 14:
                                    return a.zm();
                                case 15:
                                    return a.Cm();
                                case 16:
                                    return a.Am();
                                case 17:
                                    return a.Dm();
                                case 21:
                                    Mqe(a);
                                    return Vse(), Vse(), Ese;
                                case 10:
                                    switch(a.a){
                                        case 65:
                                            return a.hm();
                                        case 90:
                                            return a.mm();
                                        case 122:
                                            return a.tm();
                                        case 98:
                                            return a.nm();
                                        case 66:
                                            return a.im();
                                        case 60:
                                            return a.sm();
                                        case 62:
                                            return a.qm();
                                    }
                            }
                            f = Oqe(a);
                            b = a.c;
                            switch(b){
                                case 3:
                                    return a.Im(f);
                                case 4:
                                    return a.Gm(f);
                                case 5:
                                    return a.Hm(f);
                                case 0:
                                    if (a.a == 123 && a.d < a.j) {
                                        e = a.d;
                                        d = 0;
                                        c = -1;
                                        if ((b = ihb(a.i, e++)) >= 48 && b <= 57) {
                                            d = b - 48;
                                            while(e < a.j && (b = ihb(a.i, e++)) >= 48 && b <= 57){
                                                d = d * 10 + b - 48;
                                                if (d < 0) throw Adb(new Lqe(TId((Hde(), CJe))));
                                            }
                                        } else throw Adb(new Lqe(TId((Hde(), yJe))));
                                        c = d;
                                        if (b == 44) {
                                            if (e >= a.j) throw Adb(new Lqe(TId((Hde(), AJe))));
                                            else if ((b = ihb(a.i, e++)) >= 48 && b <= 57) {
                                                c = b - 48;
                                                while(e < a.j && (b = ihb(a.i, e++)) >= 48 && b <= 57){
                                                    c = c * 10 + b - 48;
                                                    if (c < 0) throw Adb(new Lqe(TId((Hde(), CJe))));
                                                }
                                                if (d > c) throw Adb(new Lqe(TId((Hde(), BJe))));
                                            } else c = -1;
                                        }
                                        if (b != 125) throw Adb(new Lqe(TId((Hde(), zJe))));
                                        if (a.bm(e)) {
                                            f = (Vse(), Vse(), ++Use, new Kte(9, f));
                                            a.d = e + 1;
                                        } else {
                                            f = (Vse(), Vse(), ++Use, new Kte(3, f));
                                            a.d = e;
                                        }
                                        f.Om(d);
                                        f.Nm(c);
                                        Mqe(a);
                                    }
                            }
                            return f;
                        }
                        function bXb(a) {
                            var b, c, d, e, f;
                            c = RD(mQb(a, (Ywc(), kwc)), 21);
                            b = vfd(YWb);
                            e = RD(mQb(a, (yCc(), IAc)), 346);
                            e == (Fnd(), Cnd) && ofd(b, ZWb);
                            Heb(TD(mQb(a, GAc))) ? pfd(b, (sXb(), nXb), (hcc(), Zbc)) : pfd(b, (sXb(), pXb), (hcc(), Zbc));
                            mQb(a, (rid(), qid)) != null && ofd(b, $Wb);
                            (Heb(TD(mQb(a, PAc))) || Heb(TD(mQb(a, HAc)))) && nfd(b, (sXb(), rXb), (hcc(), lbc));
                            switch(RD(mQb(a, rAc), 88).g){
                                case 2:
                                case 3:
                                case 4:
                                    nfd(pfd(b, (sXb(), nXb), (hcc(), nbc)), rXb, mbc);
                            }
                            c.Hc((ovc(), fvc)) && nfd(pfd(pfd(b, (sXb(), nXb), (hcc(), kbc)), qXb, ibc), rXb, jbc);
                            dE(mQb(a, ZAc)) !== dE((aEc(), $Dc)) && pfd(b, (sXb(), pXb), (hcc(), Rbc));
                            if (c.Hc(mvc)) {
                                pfd(b, (sXb(), nXb), (hcc(), Xbc));
                                pfd(b, oXb, Vbc);
                                pfd(b, pXb, Wbc);
                            }
                            dE(mQb(a, Xzc)) !== dE(($uc(), Yuc)) && dE(mQb(a, yAc)) !== dE((Ymd(), Vmd)) && nfd(b, (sXb(), rXb), (hcc(), Abc));
                            Heb(TD(mQb(a, KAc))) && pfd(b, (sXb(), pXb), (hcc(), zbc));
                            Heb(TD(mQb(a, nAc))) && pfd(b, (sXb(), pXb), (hcc(), dcc));
                            if (eXb(a)) {
                                dE(mQb(a, IAc)) === dE(Cnd) ? d = RD(mQb(a, gAc), 299) : d = RD(mQb(a, hAc), 299);
                                f = d == (xvc(), vvc) ? (hcc(), Ubc) : (hcc(), gcc);
                                pfd(b, (sXb(), qXb), f);
                            }
                            switch(RD(mQb(a, vCc), 388).g){
                                case 1:
                                    pfd(b, (sXb(), qXb), (hcc(), ecc));
                                    break;
                                case 2:
                                    nfd(pfd(pfd(b, (sXb(), pXb), (hcc(), ebc)), qXb, fbc), rXb, gbc);
                            }
                            dE(mQb(a, cAc)) !== dE((kEc(), hEc)) && pfd(b, (sXb(), pXb), (hcc(), fcc));
                            return b;
                        }
                        function crc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            if (Ujb(a.a, b)) {
                                if (Zsb(RD(Wjb(a.a, b), 49), c)) return 1;
                            } else Zjb(a.a, b, new _sb);
                            if (Ujb(a.a, c)) {
                                if (Zsb(RD(Wjb(a.a, c), 49), b)) return -1;
                            } else Zjb(a.a, c, new _sb);
                            if (Ujb(a.e, b)) {
                                if (Zsb(RD(Wjb(a.e, b), 49), c)) return -1;
                            } else Zjb(a.e, b, new _sb);
                            if (Ujb(a.e, c)) {
                                if (Zsb(RD(Wjb(a.a, c), 49), b)) return 1;
                            } else Zjb(a.e, c, new _sb);
                            if (a.c == (kEc(), iEc) || !nQb(b, (Ywc(), zwc)) || !nQb(c, (Ywc(), zwc))) {
                                l = null;
                                for(j = new Anb(b.j); j.a < j.c.c.length;){
                                    h = RD(ynb(j), 12);
                                    h.e.c.length == 0 || RD(Vmb(h.e, 0), 18).c.i.c != b.c && (l = RD(Vmb(h.e, 0), 18).c);
                                }
                                n = null;
                                for(i = new Anb(c.j); i.a < i.c.c.length;){
                                    h = RD(ynb(i), 12);
                                    h.e.c.length == 0 || RD(Vmb(h.e, 0), 18).c.i.c != c.c && (n = RD(Vmb(h.e, 0), 18).c);
                                }
                                if (!!l && !!n) {
                                    k = l.i;
                                    m = n.i;
                                    if (!!k && k == m) {
                                        for(p = new Anb(k.j); p.a < p.c.c.length;){
                                            o = RD(ynb(p), 12);
                                            if (o == l) {
                                                erc(a, c, b);
                                                return -1;
                                            } else if (o == n) {
                                                erc(a, b, c);
                                                return 1;
                                            }
                                        }
                                        return hgb(drc(a, b), drc(a, c));
                                    }
                                    for(r = a.d, s = 0, t = r.length; s < t; ++s){
                                        q = r[s];
                                        if (q == k) {
                                            erc(a, c, b);
                                            return -1;
                                        } else if (q == m) {
                                            erc(a, b, c);
                                            return 1;
                                        }
                                    }
                                }
                                if (!nQb(b, (Ywc(), zwc)) || !nQb(c, zwc)) {
                                    e = drc(a, b);
                                    g = drc(a, c);
                                    e > g ? erc(a, b, c) : erc(a, c, b);
                                    return e < g ? -1 : e > g ? 1 : 0;
                                }
                            }
                            d = RD(mQb(b, (Ywc(), zwc)), 17).a;
                            f = RD(mQb(c, zwc), 17).a;
                            d > f ? erc(a, b, c) : erc(a, c, b);
                            return d < f ? -1 : d > f ? 1 : 0;
                        }
                        function uAd(b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                            if (d == null) return null;
                            if (b.a != c.jk()) throw Adb(new agb(VHe + c.xe() + WHe));
                            if (ZD(c, 469)) {
                                r = z1d(RD(c, 685), d);
                                if (!r) throw Adb(new agb(XHe + d + "' is not a valid enumerator of '" + c.xe() + "'"));
                                return r;
                            }
                            switch(Oee((lke(), jke), c).Nl()){
                                case 2:
                                    d = nue(d, false);
                                    break;
                                case 3:
                                    d = nue(d, true);
                                    break;
                            }
                            e = Oee(jke, c).Jl();
                            if (e) return e.jk().wi().ti(e, d);
                            n = Oee(jke, c).Ll();
                            if (n) {
                                r = new bnb;
                                for(k = xAd(d), l = 0, m = k.length; l < m; ++l){
                                    j = k[l];
                                    Rmb(r, n.jk().wi().ti(n, j));
                                }
                                return r;
                            }
                            q = Oee(jke, c).Ml();
                            if (!q.dc()) {
                                for(p = q.Kc(); p.Ob();){
                                    o = RD(p.Pb(), 156);
                                    try {
                                        r = o.jk().wi().ti(o, d);
                                        if (r != null) return r;
                                    } catch (a) {
                                        a = zdb(a);
                                        if (!ZD(a, 63)) throw Adb(a);
                                    }
                                }
                                throw Adb(new agb(XHe + d + "' does not match any member types of the union datatype '" + c.xe() + "'"));
                            }
                            RD(c, 847).ok();
                            f = Qje(c.kk());
                            if (!f) return null;
                            if (f == SI) {
                                h = 0;
                                try {
                                    h = Oeb(d, qwe, lve) & Bwe;
                                } catch (a) {
                                    a = zdb(a);
                                    if (ZD(a, 130)) {
                                        g = Ahb(d);
                                        h = g[0];
                                    } else throw Adb(a);
                                }
                                return hfb(h);
                            }
                            if (f == qK) {
                                for(i = 0; i < nAd.length; ++i)try {
                                    return b2d(nAd[i], d);
                                } catch (a) {
                                    a = zdb(a);
                                    if (!ZD(a, 33)) throw Adb(a);
                                }
                                throw Adb(new agb(XHe + d + "' is not a date formatted string of the form yyyy-MM-dd'T'HH:mm:ss'.'SSSZ or a valid subset thereof"));
                            }
                            throw Adb(new agb(XHe + d + "' is invalid. "));
                        }
                        function z$b() {
                            z$b = geb;
                            y$b = new Tp;
                            Rc(y$b, (qpd(), bpd), fpd);
                            Rc(y$b, mpd, fpd);
                            Rc(y$b, mpd, ipd);
                            Rc(y$b, Zod, epd);
                            Rc(y$b, Zod, fpd);
                            Rc(y$b, cpd, fpd);
                            Rc(y$b, cpd, gpd);
                            Rc(y$b, kpd, _od);
                            Rc(y$b, kpd, fpd);
                            Rc(y$b, hpd, apd);
                            Rc(y$b, hpd, fpd);
                            Rc(y$b, hpd, gpd);
                            Rc(y$b, hpd, _od);
                            Rc(y$b, apd, hpd);
                            Rc(y$b, apd, ipd);
                            Rc(y$b, apd, epd);
                            Rc(y$b, apd, fpd);
                            Rc(y$b, jpd, jpd);
                            Rc(y$b, jpd, gpd);
                            Rc(y$b, jpd, ipd);
                            Rc(y$b, dpd, dpd);
                            Rc(y$b, dpd, gpd);
                            Rc(y$b, dpd, epd);
                            Rc(y$b, lpd, lpd);
                            Rc(y$b, lpd, _od);
                            Rc(y$b, lpd, ipd);
                            Rc(y$b, $od, $od);
                            Rc(y$b, $od, _od);
                            Rc(y$b, $od, epd);
                            Rc(y$b, gpd, cpd);
                            Rc(y$b, gpd, hpd);
                            Rc(y$b, gpd, jpd);
                            Rc(y$b, gpd, dpd);
                            Rc(y$b, gpd, fpd);
                            Rc(y$b, gpd, gpd);
                            Rc(y$b, gpd, ipd);
                            Rc(y$b, gpd, epd);
                            Rc(y$b, _od, kpd);
                            Rc(y$b, _od, hpd);
                            Rc(y$b, _od, lpd);
                            Rc(y$b, _od, $od);
                            Rc(y$b, _od, _od);
                            Rc(y$b, _od, ipd);
                            Rc(y$b, _od, epd);
                            Rc(y$b, _od, fpd);
                            Rc(y$b, ipd, mpd);
                            Rc(y$b, ipd, apd);
                            Rc(y$b, ipd, jpd);
                            Rc(y$b, ipd, lpd);
                            Rc(y$b, ipd, gpd);
                            Rc(y$b, ipd, _od);
                            Rc(y$b, ipd, ipd);
                            Rc(y$b, ipd, fpd);
                            Rc(y$b, epd, Zod);
                            Rc(y$b, epd, apd);
                            Rc(y$b, epd, dpd);
                            Rc(y$b, epd, $od);
                            Rc(y$b, epd, gpd);
                            Rc(y$b, epd, _od);
                            Rc(y$b, epd, epd);
                            Rc(y$b, epd, fpd);
                            Rc(y$b, fpd, bpd);
                            Rc(y$b, fpd, mpd);
                            Rc(y$b, fpd, Zod);
                            Rc(y$b, fpd, cpd);
                            Rc(y$b, fpd, kpd);
                            Rc(y$b, fpd, hpd);
                            Rc(y$b, fpd, apd);
                            Rc(y$b, fpd, gpd);
                            Rc(y$b, fpd, _od);
                            Rc(y$b, fpd, ipd);
                            Rc(y$b, fpd, epd);
                            Rc(y$b, fpd, fpd);
                        }
                        function _$b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
                            a.d = new rjd(oxe, oxe);
                            a.c = new rjd(pxe, pxe);
                            for(m = b.Kc(); m.Ob();){
                                k = RD(m.Pb(), 36);
                                for(t = new Anb(k.a); t.a < t.c.c.length;){
                                    s = RD(ynb(t), 10);
                                    a.d.a = $wnd.Math.min(a.d.a, s.n.a - s.d.b);
                                    a.d.b = $wnd.Math.min(a.d.b, s.n.b - s.d.d);
                                    a.c.a = $wnd.Math.max(a.c.a, s.n.a + s.o.a + s.d.c);
                                    a.c.b = $wnd.Math.max(a.c.b, s.n.b + s.o.b + s.d.a);
                                }
                            }
                            h = new q_b;
                            for(l = b.Kc(); l.Ob();){
                                k = RD(l.Pb(), 36);
                                d = i_b(a, k);
                                Rmb(h.a, d);
                                d.a = d.a | !RD(mQb(d.c, (Ywc(), ewc)), 21).dc();
                            }
                            a.b = (NXb(), B = new XXb, B.f = new EXb(c), B.b = DXb(B.f, h), B);
                            RXb((o = a.b, new Oqd, o));
                            a.e = new pjd;
                            a.a = a.b.f.e;
                            for(g = new Anb(h.a); g.a < g.c.c.length;){
                                e = RD(ynb(g), 855);
                                u = SXb(a.b, e);
                                o2b(e.c, u.a, u.b);
                                for(q = new Anb(e.c.a); q.a < q.c.c.length;){
                                    p = RD(ynb(q), 10);
                                    if (p.k == (r3b(), m3b)) {
                                        r = d_b(a, p.n, RD(mQb(p, (Ywc(), hwc)), 64));
                                        $id(hjd(p.n), r);
                                    }
                                }
                            }
                            for(f = new Anb(h.a); f.a < f.c.c.length;){
                                e = RD(ynb(f), 855);
                                for(j = new Anb(o_b(e)); j.a < j.c.c.length;){
                                    i = RD(ynb(j), 18);
                                    A = new Fjd(i.a);
                                    hu(A, 0, K3b(i.c));
                                    Mub(A, K3b(i.d));
                                    n = null;
                                    for(w = Sub(A, 0); w.b != w.d.c;){
                                        v = RD(evb(w), 8);
                                        if (!n) {
                                            n = v;
                                            continue;
                                        }
                                        if (_y(n.a, v.a)) {
                                            a.e.a = $wnd.Math.min(a.e.a, n.a);
                                            a.a.a = $wnd.Math.max(a.a.a, n.a);
                                        } else if (_y(n.b, v.b)) {
                                            a.e.b = $wnd.Math.min(a.e.b, n.b);
                                            a.a.b = $wnd.Math.max(a.a.b, n.b);
                                        }
                                        n = v;
                                    }
                                }
                            }
                            fjd(a.e);
                            $id(a.a, a.e);
                        }
                        function vib(a, b) {
                            var c, d, e, f, g, h, i, j;
                            c = 0;
                            g = 0;
                            f = b.length;
                            h = null;
                            j = new cib;
                            if (g < f && (BFb(g, b.length), b.charCodeAt(g) == 43)) {
                                ++g;
                                ++c;
                                if (g < f && (BFb(g, b.length), b.charCodeAt(g) == 43 || (BFb(g, b.length), b.charCodeAt(g) == 45))) throw Adb(new Vgb(nxe + b + '"'));
                            }
                            while(g < f && (BFb(g, b.length), b.charCodeAt(g) != 46) && (BFb(g, b.length), b.charCodeAt(g) != 101) && (BFb(g, b.length), b.charCodeAt(g) != 69))++g;
                            j.a += '' + zhb(b == null ? vve : (uFb(b), b), c, g);
                            if (g < f && (BFb(g, b.length), b.charCodeAt(g) == 46)) {
                                ++g;
                                c = g;
                                while(g < f && (BFb(g, b.length), b.charCodeAt(g) != 101) && (BFb(g, b.length), b.charCodeAt(g) != 69))++g;
                                a.e = g - c;
                                j.a += '' + zhb(b == null ? vve : (uFb(b), b), c, g);
                            } else a.e = 0;
                            if (g < f && (BFb(g, b.length), b.charCodeAt(g) == 101 || (BFb(g, b.length), b.charCodeAt(g) == 69))) {
                                ++g;
                                c = g;
                                if (g < f && (BFb(g, b.length), b.charCodeAt(g) == 43)) {
                                    ++g;
                                    g < f && (BFb(g, b.length), b.charCodeAt(g) != 45) && ++c;
                                }
                                h = (AFb(c, f, b.length), b.substr(c, f - c));
                                a.e = a.e - Oeb(h, qwe, lve);
                                if (a.e != eE(a.e)) throw Adb(new Vgb('Scale out of range.'));
                            }
                            i = j.a;
                            if (i.length < 16) {
                                a.f = (sib == null && (sib = new RegExp('^[+-]?\\d*$', 'i')), sib.test(i) ? parseInt(i, 10) : NaN);
                                if (isNaN(a.f)) throw Adb(new Vgb(nxe + b + '"'));
                                a.a = Cib(a.f);
                            } else wib(a, new ejb(i));
                            a.d = j.a.length;
                            for(e = 0; e < j.a.length; ++e){
                                d = ihb(j.a, e);
                                if (d != 45 && d != 48) break;
                                --a.d;
                            }
                            a.d == 0 && (a.d = 1);
                        }
                        function Wae(a) {
                            _Ad(a.b, AKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                CKe,
                                'ConsistentTransient'
                            ]));
                            _Ad(a.a, AKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                CKe,
                                'WellFormedSourceURI'
                            ]));
                            _Ad(a.o, AKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                CKe,
                                'InterfaceIsAbstract AtMostOneID UniqueFeatureNames UniqueOperationSignatures NoCircularSuperTypes WellFormedMapEntryClass ConsistentSuperTypes DisjointFeatureAndOperationSignatures'
                            ]));
                            _Ad(a.p, AKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                CKe,
                                'WellFormedInstanceTypeName UniqueTypeParameterNames'
                            ]));
                            _Ad(a.v, AKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                CKe,
                                'UniqueEnumeratorNames UniqueEnumeratorLiterals'
                            ]));
                            _Ad(a.R, AKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                CKe,
                                'WellFormedName'
                            ]));
                            _Ad(a.T, AKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                CKe,
                                'UniqueParameterNames UniqueTypeParameterNames NoRepeatingVoid'
                            ]));
                            _Ad(a.U, AKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                CKe,
                                'WellFormedNsURI WellFormedNsPrefix UniqueSubpackageNames UniqueClassifierNames UniqueNsURIs'
                            ]));
                            _Ad(a.W, AKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                CKe,
                                'ConsistentOpposite SingleContainer ConsistentKeys ConsistentUnique ConsistentContainer'
                            ]));
                            _Ad(a.bb, AKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                CKe,
                                'ValidDefaultValueLiteral'
                            ]));
                            _Ad(a.eb, AKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                CKe,
                                'ValidLowerBound ValidUpperBound ConsistentBounds ValidType'
                            ]));
                            _Ad(a.H, AKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                CKe,
                                'ConsistentType ConsistentBounds ConsistentArguments'
                            ]));
                        }
                        function S7b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C;
                            if (b.dc()) return;
                            e = new Ejd;
                            h = c ? c : RD(b.Xb(0), 18);
                            o = h.c;
                            HUc();
                            m = o.i.k;
                            if (!(m == (r3b(), p3b) || m == q3b || m == m3b || m == l3b)) throw Adb(new agb('The target node of the edge must be a normal node or a northSouthPort.'));
                            Oub(e, xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                o.i.n,
                                o.n,
                                o.a
                            ])));
                            if ((qpd(), hpd).Hc(o.j)) {
                                q = Kfb(UD(mQb(o, (Ywc(), Swc))));
                                l = new rjd(xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                    o.i.n,
                                    o.n,
                                    o.a
                                ])).a, q);
                                Pub(e, l, e.c.b, e.c);
                            }
                            k = null;
                            d = false;
                            i = b.Kc();
                            while(i.Ob()){
                                g = RD(i.Pb(), 18);
                                f = g.a;
                                if (f.b != 0) {
                                    if (d) {
                                        j = ijd($id(k, (sFb(f.b != 0), RD(f.a.a.c, 8))), 0.5);
                                        Pub(e, j, e.c.b, e.c);
                                        d = false;
                                    } else d = true;
                                    k = ajd((sFb(f.b != 0), RD(f.c.b.c, 8)));
                                    ye(e, f);
                                    Xub(f);
                                }
                            }
                            p = h.d;
                            if (hpd.Hc(p.j)) {
                                q = Kfb(UD(mQb(p, (Ywc(), Swc))));
                                l = new rjd(xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                    p.i.n,
                                    p.n,
                                    p.a
                                ])).a, q);
                                Pub(e, l, e.c.b, e.c);
                            }
                            Oub(e, xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                p.i.n,
                                p.n,
                                p.a
                            ])));
                            a.d == (lFc(), iFc) && (r = (sFb(e.b != 0), RD(e.a.a.c, 8)), s = RD(ju(e, 1), 8), t = new qjd(BVc(o.j)), t.a *= 5, t.b *= 5, u = ojd(new rjd(s.a, s.b), r), v = new rjd(R7b(t.a, u.a), R7b(t.b, u.b)), $id(v, r), w = Sub(e, 1), cvb(w, v), A = (sFb(e.b != 0), RD(e.c.b.c, 8)), B = RD(ju(e, e.b - 2), 8), t = new qjd(BVc(p.j)), t.a *= 5, t.b *= 5, u = ojd(new rjd(B.a, B.b), A), C = new rjd(R7b(t.a, u.a), R7b(t.b, u.b)), $id(C, A), hu(e, e.b - 1, C), undefined);
                            n = new wUc(e);
                            ye(h.a, sUc(n));
                        }
                        function cud(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K, L, M, N, O, P;
                            t = RD(QHd((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b), 0), 84);
                            v = t.nh();
                            w = t.oh();
                            u = t.mh() / 2;
                            p = t.lh() / 2;
                            if (ZD(t, 193)) {
                                s = RD(t, 123);
                                v += MCd(s).i;
                                v += MCd(s).i;
                            }
                            v += u;
                            w += p;
                            F = RD(QHd((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b), 0), 84);
                            H = F.nh();
                            I = F.oh();
                            G = F.mh() / 2;
                            A = F.lh() / 2;
                            if (ZD(F, 193)) {
                                D = RD(F, 123);
                                H += MCd(D).i;
                                H += MCd(D).i;
                            }
                            H += G;
                            I += A;
                            if ((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a).i == 0) {
                                h = (bvd(), j = new Rzd, j);
                                WGd((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a), h);
                            } else if ((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a).i > 1) {
                                o = new mMd((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a));
                                while(o.e != o.i.gc())cMd(o);
                            }
                            g = RD(QHd((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a), 0), 166);
                            q = H;
                            H > v + u ? q = v + u : H < v - u && (q = v - u);
                            r = I;
                            I > w + p ? r = w + p : I < w - p && (r = w - p);
                            q > v - u && q < v + u && r > w - p && r < w + p && (q = v + u);
                            Ozd(g, q);
                            Pzd(g, r);
                            B = v;
                            v > H + G ? B = H + G : v < H - G && (B = H - G);
                            C = w;
                            w > I + A ? C = I + A : w < I - A && (C = I - A);
                            B > H - G && B < H + G && C > I - A && C < I + A && (C = I + A);
                            Hzd(g, B);
                            Izd(g, C);
                            sLd((!g.a && (g.a = new XZd(D4, g, 5)), g.a));
                            f = Jwb(b, 5);
                            t == F && ++f;
                            L = B - q;
                            O = C - r;
                            J = $wnd.Math.sqrt(L * L + O * O);
                            l = J * 0.20000000298023224;
                            M = L / (f + 1);
                            P = O / (f + 1);
                            K = q;
                            N = r;
                            for(k = 0; k < f; k++){
                                K += M;
                                N += P;
                                m = K + Kwb(b, 24) * Nxe * l - l / 2;
                                m < 0 ? m = 1 : m > c && (m = c - 1);
                                n = N + Kwb(b, 24) * Nxe * l - l / 2;
                                n < 0 ? n = 1 : n > d && (n = d - 1);
                                e = (bvd(), i = new Xxd, i);
                                Vxd(e, m);
                                Wxd(e, n);
                                WGd((!g.a && (g.a = new XZd(D4, g, 5)), g.a), e);
                            }
                        }
                        function Y7c(a) {
                            Cgd(a, new Pfd($fd(Xfd(Zfd(Yfd(new agd, $Fe), 'ELK Rectangle Packing'), 'Algorithm for packing of unconnected boxes, i.e. graphs without edges. The given order of the boxes is always preserved and the main reading direction of the boxes is left to right. The algorithm is divided into two phases. One phase approximates the width in which the rectangles can be placed. The next phase places the rectangles in rows using the previously calculated width as bounding width and bundles rectangles with a similar height in blocks. A compaction step reduces the size of the drawing. Finally, the rectangles are expanded to fill their bounding box and eliminate empty unused spaces.'), new _7c)));
                            Agd(a, $Fe, Dze, 1.3);
                            Agd(a, $Fe, hAe, (Geb(), false));
                            Agd(a, $Fe, Eze, O7c);
                            Agd(a, $Fe, _ze, 15);
                            Agd(a, $Fe, YDe, iGd(y7c));
                            Agd(a, $Fe, jAe, iGd(F7c));
                            Agd(a, $Fe, CAe, iGd(H7c));
                            Agd(a, $Fe, iAe, iGd(I7c));
                            Agd(a, $Fe, kAe, iGd(E7c));
                            Agd(a, $Fe, gAe, iGd(J7c));
                            Agd(a, $Fe, lAe, iGd(P7c));
                            Agd(a, $Fe, RFe, iGd(U7c));
                            Agd(a, $Fe, SFe, iGd(T7c));
                            Agd(a, $Fe, QFe, iGd(W7c));
                            Agd(a, $Fe, PFe, iGd(V7c));
                            Agd(a, $Fe, TFe, iGd(M7c));
                            Agd(a, $Fe, UFe, iGd(L7c));
                            Agd(a, $Fe, VFe, iGd(K7c));
                            Agd(a, $Fe, WFe, iGd(S7c));
                            Agd(a, $Fe, dAe, iGd(B7c));
                            Agd(a, $Fe, iEe, iGd(C7c));
                            Agd(a, $Fe, NFe, iGd(A7c));
                            Agd(a, $Fe, MFe, iGd(z7c));
                            Agd(a, $Fe, OFe, iGd(D7c));
                            Agd(a, $Fe, LFe, iGd(R7c));
                        }
                        function Ajb(a, b) {
                            xjb();
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H;
                            B = a.e;
                            o = a.d;
                            e = a.a;
                            if (B == 0) switch(b){
                                case 0:
                                    return '0';
                                case 1:
                                    return zxe;
                                case 2:
                                    return '0.00';
                                case 3:
                                    return '0.000';
                                case 4:
                                    return '0.0000';
                                case 5:
                                    return '0.00000';
                                case 6:
                                    return '0.000000';
                                default:
                                    w = new bib;
                                    b < 0 ? (w.a += '0E+', w) : (w.a += '0E', w);
                                    w.a += -b;
                                    return w.a;
                            }
                            t = o * 10 + 1 + 7;
                            u = $C(hE, zwe, 28, t + 1, 15, 1);
                            c = t;
                            if (o == 1) {
                                h = e[0];
                                if (h < 0) {
                                    H = Cdb(h, yxe);
                                    do {
                                        p = H;
                                        H = Fdb(H, 10);
                                        u[--c] = 48 + Ydb(Vdb(p, Ndb(H, 10))) & Bwe;
                                    }while (Ddb(H, 0) != 0);
                                } else {
                                    H = h;
                                    do {
                                        p = H;
                                        H = H / 10 | 0;
                                        u[--c] = 48 + (p - H * 10) & Bwe;
                                    }while (H != 0);
                                }
                            } else {
                                D = $C(kE, Pwe, 28, o, 15, 1);
                                G = o;
                                hib(e, 0, D, 0, G);
                                I: while(true){
                                    A = 0;
                                    for(j = G - 1; j >= 0; j--){
                                        F = Bdb(Sdb(A, 32), Cdb(D[j], yxe));
                                        r = yjb(F);
                                        D[j] = Ydb(r);
                                        A = Ydb(Tdb(r, 32));
                                    }
                                    s = Ydb(A);
                                    q = c;
                                    do u[--c] = 48 + s % 10 & Bwe;
                                    while ((s = s / 10 | 0) != 0 && c != 0);
                                    d = 9 - q + c;
                                    for(i = 0; i < d && c > 0; i++)u[--c] = 48;
                                    l = G - 1;
                                    for(; D[l] == 0; l--){
                                        if (l == 0) break I;
                                    }
                                    G = l + 1;
                                }
                                while(u[c] == 48)++c;
                            }
                            n = B < 0;
                            g = t - c - b - 1;
                            if (b == 0) {
                                n && (u[--c] = 45);
                                return Ihb(u, c, t - c);
                            }
                            if (b > 0 && g >= -6) {
                                if (g >= 0) {
                                    k = c + g;
                                    for(m = t - 1; m >= k; m--)u[m + 1] = u[m];
                                    u[++k] = 46;
                                    n && (u[--c] = 45);
                                    return Ihb(u, c, t - c + 1);
                                }
                                for(l = 2; l < -g + 1; l++)u[--c] = 48;
                                u[--c] = 46;
                                u[--c] = 48;
                                n && (u[--c] = 45);
                                return Ihb(u, c, t - c);
                            }
                            C = c + 1;
                            f = t;
                            v = new cib;
                            n && (v.a += '-', v);
                            if (f - C >= 1) {
                                Thb(v, u[c]);
                                v.a += '.';
                                v.a += Ihb(u, c + 1, t - c - 1);
                            } else v.a += Ihb(u, c, t - c);
                            v.a += 'E';
                            g > 0 && (v.a += '+', v);
                            v.a += '' + g;
                            return v.a;
                        }
                        function Jad(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
                            a.c = b;
                            a.g = new Tsb;
                            c = (lud(), new zud(a.c));
                            d = new PJb(c);
                            LJb(d);
                            t = WD(Gxd(a.c, (ncd(), gcd)));
                            i = RD(Gxd(a.c, icd), 324);
                            v = RD(Gxd(a.c, jcd), 437);
                            g = RD(Gxd(a.c, bcd), 490);
                            u = RD(Gxd(a.c, hcd), 438);
                            a.j = Kfb(UD(Gxd(a.c, kcd)));
                            h = a.a;
                            switch(i.g){
                                case 0:
                                    h = a.a;
                                    break;
                                case 1:
                                    h = a.b;
                                    break;
                                case 2:
                                    h = a.i;
                                    break;
                                case 3:
                                    h = a.e;
                                    break;
                                case 4:
                                    h = a.f;
                                    break;
                                default:
                                    throw Adb(new agb(eGe + (i.f != null ? i.f : '' + i.g)));
                            }
                            a.d = new qbd(h, v, g);
                            pQb(a.d, (OQb(), MQb), TD(Gxd(a.c, dcd)));
                            a.d.c = Heb(TD(Gxd(a.c, ccd)));
                            if (tCd(a.c).i == 0) return a.d;
                            for(l = new dMd(tCd(a.c)); l.e != l.i.gc();){
                                k = RD(bMd(l), 27);
                                n = k.g / 2;
                                m = k.f / 2;
                                w = new rjd(k.i + n, k.j + m);
                                while(Ujb(a.g, w))Zid(w, ($wnd.Math.random() - 0.5) * Vze, ($wnd.Math.random() - 0.5) * Vze);
                                p = RD(Gxd(k, (umd(), eld)), 140);
                                q = new TQb(w, new Uid(w.a - n - a.j / 2 - p.b, w.b - m - a.j / 2 - p.d, k.g + a.j + (p.b + p.c), k.f + a.j + (p.d + p.a)));
                                Rmb(a.d.i, q);
                                Zjb(a.g, w, new Ptd(q, k));
                            }
                            switch(u.g){
                                case 0:
                                    if (t == null) a.d.d = RD(Vmb(a.d.i, 0), 68);
                                    else for(s = new Anb(a.d.i); s.a < s.c.c.length;){
                                        q = RD(ynb(s), 68);
                                        o = RD(RD(Wjb(a.g, q.a), 42).b, 27).jh();
                                        o != null && lhb(o, t) && (a.d.d = q);
                                    }
                                    break;
                                case 1:
                                    e = new rjd(a.c.g, a.c.f);
                                    e.a *= 0.5;
                                    e.b *= 0.5;
                                    Zid(e, a.c.i, a.c.j);
                                    f = oxe;
                                    for(r = new Anb(a.d.i); r.a < r.c.c.length;){
                                        q = RD(ynb(r), 68);
                                        j = bjd(q.a, e);
                                        if (j < f) {
                                            f = j;
                                            a.d.d = q;
                                        }
                                    }
                                    break;
                                default:
                                    throw Adb(new agb(eGe + (u.f != null ? u.f : '' + u.g)));
                            }
                            return a.d;
                        }
                        function b5b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
                            m = 0;
                            for(e = new dMd((!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a)); e.e != e.i.gc();){
                                d = RD(bMd(e), 27);
                                if (!Heb(TD(Gxd(d, (yCc(), pBc))))) {
                                    k = vCd(d);
                                    if ((dE(Gxd(k, cAc)) !== dE((kEc(), hEc)) || dE(Gxd(k, pAc)) === dE((Ptc(), Otc)) || dE(Gxd(k, pAc)) === dE((Ptc(), Mtc)) || Heb(TD(Gxd(k, eAc))) || dE(Gxd(k, Yzc)) !== dE((U$b(), T$b)) || dE(Gxd(k, ZAc)) === dE((aEc(), TDc)) || dE(Gxd(k, ZAc)) === dE((aEc(), UDc)) || dE(Gxd(k, $Ac)) === dE((_Cc(), SCc)) || dE(Gxd(k, $Ac)) === dE((_Cc(), UCc))) && !Heb(TD(Gxd(d, aAc)))) {
                                        Ixd(d, (Ywc(), zwc), sgb(m));
                                        ++m;
                                    }
                                    i5b(a, d, c);
                                }
                            }
                            m = 0;
                            for(j = new dMd((!b.b && (b.b = new C5d(G4, b, 12, 3)), b.b)); j.e != j.i.gc();){
                                h = RD(bMd(j), 74);
                                if (dE(Gxd(b, (yCc(), cAc))) !== dE((kEc(), hEc)) || dE(Gxd(b, pAc)) === dE((Ptc(), Otc)) || dE(Gxd(b, pAc)) === dE((Ptc(), Mtc)) || Heb(TD(Gxd(b, eAc))) || dE(Gxd(b, Yzc)) !== dE((U$b(), T$b)) || dE(Gxd(b, ZAc)) === dE((aEc(), TDc)) || dE(Gxd(b, ZAc)) === dE((aEc(), UDc)) || dE(Gxd(b, $Ac)) === dE((_Cc(), SCc)) || dE(Gxd(b, $Ac)) === dE((_Cc(), UCc))) {
                                    Ixd(h, (Ywc(), zwc), sgb(m));
                                    ++m;
                                }
                                p = JGd(h);
                                q = LGd(h);
                                l = Heb(TD(Gxd(p, NAc)));
                                o = !Heb(TD(Gxd(h, pBc)));
                                n = l && ozd(h) && Heb(TD(Gxd(h, OAc)));
                                f = vCd(p) == b && vCd(p) == vCd(q);
                                g = (vCd(p) == b && q == b) ^ (vCd(q) == b && p == b);
                                o && !n && (g || f) && f5b(a, h, b, c);
                            }
                            if (vCd(b)) for(i = new dMd(uCd(vCd(b))); i.e != i.i.gc();){
                                h = RD(bMd(i), 74);
                                p = JGd(h);
                                if (p == b && ozd(h)) {
                                    n = Heb(TD(Gxd(p, (yCc(), NAc)))) && Heb(TD(Gxd(h, OAc)));
                                    n && f5b(a, h, b, c);
                                }
                            }
                        }
                        function SFc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K, L;
                            c.Ug('Greedy cycle removal', 1);
                            t = b.a;
                            L = t.c.length;
                            a.a = $C(kE, Pwe, 28, L, 15, 1);
                            a.c = $C(kE, Pwe, 28, L, 15, 1);
                            a.b = $C(kE, Pwe, 28, L, 15, 1);
                            j = 0;
                            for(r = new Anb(t); r.a < r.c.c.length;){
                                p = RD(ynb(r), 10);
                                p.p = j;
                                for(C = new Anb(p.j); C.a < C.c.c.length;){
                                    w = RD(ynb(C), 12);
                                    for(h = new Anb(w.e); h.a < h.c.c.length;){
                                        d = RD(ynb(h), 18);
                                        if (d.c.i == p) continue;
                                        G = RD(mQb(d, (yCc(), KBc)), 17).a;
                                        a.a[j] += G > 0 ? G + 1 : 1;
                                    }
                                    for(g = new Anb(w.g); g.a < g.c.c.length;){
                                        d = RD(ynb(g), 18);
                                        if (d.d.i == p) continue;
                                        G = RD(mQb(d, (yCc(), KBc)), 17).a;
                                        a.c[j] += G > 0 ? G + 1 : 1;
                                    }
                                }
                                a.c[j] == 0 ? Mub(a.e, p) : a.a[j] == 0 && Mub(a.f, p);
                                ++j;
                            }
                            o = -1;
                            n = 1;
                            l = new bnb;
                            a.d = RD(mQb(b, (Ywc(), Lwc)), 234);
                            while(L > 0){
                                while(a.e.b != 0){
                                    I = RD(Uub(a.e), 10);
                                    a.b[I.p] = o--;
                                    TFc(a, I);
                                    --L;
                                }
                                while(a.f.b != 0){
                                    J = RD(Uub(a.f), 10);
                                    a.b[J.p] = n++;
                                    TFc(a, J);
                                    --L;
                                }
                                if (L > 0) {
                                    m = qwe;
                                    for(s = new Anb(t); s.a < s.c.c.length;){
                                        p = RD(ynb(s), 10);
                                        if (a.b[p.p] == 0) {
                                            u = a.c[p.p] - a.a[p.p];
                                            if (u >= m) {
                                                if (u > m) {
                                                    l.c.length = 0;
                                                    m = u;
                                                }
                                                ZEb(l.c, p);
                                            }
                                        }
                                    }
                                    k = a.sg(l);
                                    a.b[k.p] = n++;
                                    TFc(a, k);
                                    --L;
                                }
                            }
                            H = t.c.length + 1;
                            for(j = 0; j < t.c.length; j++)a.b[j] < 0 && (a.b[j] += H);
                            for(q = new Anb(t); q.a < q.c.c.length;){
                                p = RD(ynb(q), 10);
                                F = u2b(p.j);
                                for(A = F, B = 0, D = A.length; B < D; ++B){
                                    w = A[B];
                                    v = s2b(w.g);
                                    for(e = v, f = 0, i = e.length; f < i; ++f){
                                        d = e[f];
                                        K = d.d.i.p;
                                        if (a.b[p.p] > a.b[K]) {
                                            X0b(d, true);
                                            pQb(b, awc, (Geb(), true));
                                        }
                                    }
                                }
                            }
                            a.a = null;
                            a.c = null;
                            a.b = null;
                            Xub(a.f);
                            Xub(a.e);
                            c.Vg();
                        }
                        function usd(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
                            v = RD(QHd((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a), 0), 166);
                            k = new Ejd;
                            u = new Tsb;
                            w = xsd(v);
                            rtb(u.f, v, w);
                            m = new Tsb;
                            d = new Yub;
                            for(o = Fl(Al(cD(WC(cJ, 1), rve, 20, 0, [
                                (!b.d && (b.d = new Yie(G4, b, 8, 5)), b.d),
                                (!b.e && (b.e = new Yie(G4, b, 7, 4)), b.e)
                            ]))); gs(o);){
                                n = RD(hs(o), 74);
                                if ((!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a).i != 1) throw Adb(new agb(tHe + (!a.a && (a.a = new C5d(F4, a, 6, 6)), a.a).i));
                                if (n != a) {
                                    q = RD(QHd((!n.a && (n.a = new C5d(F4, n, 6, 6)), n.a), 0), 166);
                                    Pub(d, q, d.c.b, d.c);
                                    p = RD(Wd(qtb(u.f, q)), 13);
                                    if (!p) {
                                        p = xsd(q);
                                        rtb(u.f, q, p);
                                    }
                                    l = c ? ojd(new sjd(RD(Vmb(w, w.c.length - 1), 8)), RD(Vmb(p, p.c.length - 1), 8)) : ojd(new sjd((tFb(0, w.c.length), RD(w.c[0], 8))), (tFb(0, p.c.length), RD(p.c[0], 8)));
                                    rtb(m.f, q, l);
                                }
                            }
                            if (d.b != 0) {
                                r = RD(Vmb(w, c ? w.c.length - 1 : 0), 8);
                                for(j = 1; j < w.c.length; j++){
                                    s = RD(Vmb(w, c ? w.c.length - 1 - j : j), 8);
                                    e = Sub(d, 0);
                                    while(e.b != e.d.c){
                                        q = RD(evb(e), 166);
                                        p = RD(Wd(qtb(u.f, q)), 13);
                                        if (p.c.length <= j) gvb(e);
                                        else {
                                            t = $id(new sjd(RD(Vmb(p, c ? p.c.length - 1 - j : j), 8)), RD(Wd(qtb(m.f, q)), 8));
                                            if (s.a != t.a || s.b != t.b) {
                                                f = s.a - r.a;
                                                h = s.b - r.b;
                                                g = t.a - r.a;
                                                i = t.b - r.b;
                                                g * h == i * f && (f == 0 || isNaN(f) ? f : f < 0 ? -1 : 1) == (g == 0 || isNaN(g) ? g : g < 0 ? -1 : 1) && (h == 0 || isNaN(h) ? h : h < 0 ? -1 : 1) == (i == 0 || isNaN(i) ? i : i < 0 ? -1 : 1) ? ($wnd.Math.abs(f) < $wnd.Math.abs(g) || $wnd.Math.abs(h) < $wnd.Math.abs(i)) && Pub(k, s, k.c.b, k.c) : j > 1 && Pub(k, r, k.c.b, k.c);
                                                gvb(e);
                                            }
                                        }
                                    }
                                    r = s;
                                }
                            }
                            return k;
                        }
                        function S_c(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
                            c.Ug(_Ee, 1);
                            D = RD(zDb(CDb(new SDb(null, new Swb(b, 16)), new e0c), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), vBb)
                            ]))), 15);
                            k = RD(zDb(CDb(new SDb(null, new Swb(b, 16)), new g0c(b)), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                vBb
                            ]))), 15);
                            o = RD(zDb(CDb(new SDb(null, new Swb(b, 16)), new i0c(b)), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                vBb
                            ]))), 15);
                            p = $C(Z$, NEe, 40, b.gc(), 0, 1);
                            for(g = 0; g < k.gc(); g++){
                                e = RD(k.Xb(g), 40);
                                C = RD(mQb(e, (h_c(), W$c)), 17).a;
                                if (C >= 0 && C < k.gc() && !p[C]) {
                                    p[C] = e;
                                    k.gd(g);
                                    --g;
                                }
                            }
                            for(h = 0; h < k.gc(); h++){
                                e = RD(k.Xb(h), 40);
                                C = RD(mQb(e, (h_c(), W$c)), 17).a;
                                for(m = 0;; m++){
                                    n = C + m;
                                    if (n < p.length && n >= 0 && !p[n]) {
                                        p[n] = e;
                                        k.gd(h);
                                        --h;
                                        break;
                                    }
                                    n = C - m;
                                    if (n < p.length && n >= 0 && !p[n]) {
                                        p[n] = e;
                                        k.gd(h);
                                        --h;
                                        break;
                                    }
                                }
                            }
                            o.jd(new k0c);
                            for(i = p.length - 1; i >= 0; i--)if (!p[i] && !o.dc()) {
                                p[i] = RD(o.Xb(0), 40);
                                o.gd(0);
                            }
                            for(j = 0; j < p.length; j++)if (!p[j] && !D.dc()) {
                                p[j] = RD(D.Xb(0), 40);
                                D.gd(0);
                            }
                            for(f = 0; f < p.length; f++)pQb(p[f], (q$c(), i$c), sgb(f));
                            l = RD(RDb(CDb(new SDb(null, new Swb(b, 16)), new o0c), new a0c), 534);
                            for(w = l, A = 0, B = w.length; A < B; ++A){
                                v = w[A];
                                d = $Wc(v);
                                S_c(a, d, c.eh(1 / l.length | 0));
                                yob();
                                tvb(d, new uGd((q$c(), i$c)));
                                q = new Yub;
                                for(u = Sub(d, 0); u.b != u.d.c;){
                                    t = RD(evb(u), 40);
                                    for(s = Sub(v.d, 0); s.b != s.d.c;){
                                        r = RD(evb(s), 65);
                                        r.c == t && Pub(q, r, q.c.b, q.c);
                                    }
                                }
                                Xub(v.d);
                                ye(v.d, q);
                            }
                            c.Vg();
                        }
                        function jTb(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                            d = new bnb;
                            h = new bnb;
                            q = b / 2;
                            n = a.gc();
                            e = RD(a.Xb(0), 8);
                            r = RD(a.Xb(1), 8);
                            o = kTb(e.a, e.b, r.a, r.b, q);
                            Rmb(d, (tFb(0, o.c.length), RD(o.c[0], 8)));
                            Rmb(h, (tFb(1, o.c.length), RD(o.c[1], 8)));
                            for(j = 2; j < n; j++){
                                p = e;
                                e = r;
                                r = RD(a.Xb(j), 8);
                                o = kTb(e.a, e.b, p.a, p.b, q);
                                Rmb(d, (tFb(1, o.c.length), RD(o.c[1], 8)));
                                Rmb(h, (tFb(0, o.c.length), RD(o.c[0], 8)));
                                o = kTb(e.a, e.b, r.a, r.b, q);
                                Rmb(d, (tFb(0, o.c.length), RD(o.c[0], 8)));
                                Rmb(h, (tFb(1, o.c.length), RD(o.c[1], 8)));
                            }
                            o = kTb(r.a, r.b, e.a, e.b, q);
                            Rmb(d, (tFb(1, o.c.length), RD(o.c[1], 8)));
                            Rmb(h, (tFb(0, o.c.length), RD(o.c[0], 8)));
                            c = new Ejd;
                            g = new bnb;
                            Mub(c, (tFb(0, d.c.length), RD(d.c[0], 8)));
                            for(k = 1; k < d.c.length - 2; k += 2){
                                f = (tFb(k, d.c.length), RD(d.c[k], 8));
                                m = iTb((tFb(k - 1, d.c.length), RD(d.c[k - 1], 8)), f, (tFb(k + 1, d.c.length), RD(d.c[k + 1], 8)), (tFb(k + 2, d.c.length), RD(d.c[k + 2], 8)));
                                !isFinite(m.a) || !isFinite(m.b) ? Pub(c, f, c.c.b, c.c) : Pub(c, m, c.c.b, c.c);
                            }
                            Mub(c, RD(Vmb(d, d.c.length - 1), 8));
                            Rmb(g, (tFb(0, h.c.length), RD(h.c[0], 8)));
                            for(l = 1; l < h.c.length - 2; l += 2){
                                f = (tFb(l, h.c.length), RD(h.c[l], 8));
                                m = iTb((tFb(l - 1, h.c.length), RD(h.c[l - 1], 8)), f, (tFb(l + 1, h.c.length), RD(h.c[l + 1], 8)), (tFb(l + 2, h.c.length), RD(h.c[l + 2], 8)));
                                !isFinite(m.a) || !isFinite(m.b) ? ZEb(g.c, f) : ZEb(g.c, m);
                            }
                            Rmb(g, RD(Vmb(h, h.c.length - 1), 8));
                            for(i = g.c.length - 1; i >= 0; i--)Mub(c, (tFb(i, g.c.length), RD(g.c[i], 8)));
                            return c;
                        }
                        function l9c(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
                            t = Kfb(UD(Gxd(b, (X6c(), W6c))));
                            n = Kfb(UD(Gxd(b, U6c)));
                            m = Kfb(UD(Gxd(b, R6c)));
                            Bad((!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a));
                            r = U8c((!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a), t, a.b);
                            for(q = 0; q < r.c.length; q++){
                                i = (tFb(q, r.c.length), RD(r.c[q], 186));
                                if (q != 0) {
                                    o = (tFb(q - 1, r.c.length), RD(r.c[q - 1], 186));
                                    Gad(i, o.f + o.b + a.b);
                                }
                                p = J8c(q, r, t, a.b, Heb(TD(Gxd(b, (X7c(), L7c)))));
                                if (Heb(TD(p.b))) {
                                    for(f = new Anb(i.a); f.a < f.c.c.length;){
                                        e = RD(ynb(f), 172);
                                        e.c = false;
                                        e.k = false;
                                        N9c(e);
                                    }
                                    i.d = new bnb;
                                    i.e = t;
                                    --q;
                                } else {
                                    k9c(a, i);
                                    if (q + 1 < r.c.length) {
                                        a.e = $wnd.Math.max(i.e + a.b + RD(Vmb((tFb(q + 1, r.c.length), RD(r.c[q + 1], 186)).a, 0), 172).r - t, a.c);
                                        a.f = $wnd.Math.min(i.e + a.b + RD(Vmb((tFb(q + 1, r.c.length), RD(r.c[q + 1], 186)).a, 0), 172).r - t, a.d);
                                        if (i.d.c.length != 0) {
                                            a.c = $wnd.Math.max(a.c, RD(Vmb(i.d, i.d.c.length - 1), 315).d + (i.d.c.length <= 1 ? 0 : a.b));
                                            a.d = $wnd.Math.min(a.c, RD(Vmb(i.d, i.d.c.length - 1), 315).d + (i.d.c.length <= 1 ? 0 : a.b));
                                        }
                                    }
                                    if (r.c.length == 1) {
                                        l = RD(Vmb(i.d, i.d.c.length - 1), 315);
                                        k = RD(Vmb(l.a, l.a.c.length - 1), 172);
                                        for(h = new Anb(k.n); h.a < h.c.c.length;){
                                            g = RD(ynb(h), 209);
                                            a.c = $wnd.Math.max(a.c, k.r - g.d);
                                            a.d = $wnd.Math.min(a.d, k.r - g.d);
                                            a.e = $wnd.Math.max(a.e, g.d + a.b);
                                            a.f = $wnd.Math.min(a.f, g.d + a.b);
                                        }
                                    }
                                }
                            }
                            s = zad(r, a.b);
                            u = $wnd.Math.max(s.a, n - (c.b + c.c));
                            j = $wnd.Math.max(s.b, m - (c.d + c.a));
                            d = j - s.b;
                            Ixd(b, M6c, d);
                            Ixd(b, V6c, r);
                            return new lad(a.a, u, s.b + d, (sad(), rad));
                        }
                        function e9b(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
                            A = RD(mQb(a, (yCc(), BBc)), 101);
                            if (!(A != (Bod(), zod) && A != Aod)) return;
                            o = a.b;
                            n = o.c.length;
                            k = new cnb((dk(n + 2, lwe), dz(Bdb(Bdb(5, n + 2), (n + 2) / 10 | 0))));
                            p = new cnb((dk(n + 2, lwe), dz(Bdb(Bdb(5, n + 2), (n + 2) / 10 | 0))));
                            Rmb(k, new Tsb);
                            Rmb(k, new Tsb);
                            Rmb(p, new bnb);
                            Rmb(p, new bnb);
                            w = new bnb;
                            for(b = 0; b < n; b++){
                                c = (tFb(b, o.c.length), RD(o.c[b], 30));
                                B = (tFb(b, k.c.length), RD(k.c[b], 85));
                                q = new Tsb;
                                ZEb(k.c, q);
                                D = (tFb(b, p.c.length), RD(p.c[b], 15));
                                s = new bnb;
                                ZEb(p.c, s);
                                for(e = new Anb(c.a); e.a < e.c.c.length;){
                                    d = RD(ynb(e), 10);
                                    if (a9b(d)) {
                                        ZEb(w.c, d);
                                        continue;
                                    }
                                    for(j = new is(Mr(Z2b(d).a.Kc(), new ir)); gs(j);){
                                        h = RD(hs(j), 18);
                                        F = h.c.i;
                                        if (!a9b(F)) continue;
                                        C = RD(B.xc(mQb(F, (Ywc(), Awc))), 10);
                                        if (!C) {
                                            C = _8b(a, F);
                                            B.zc(mQb(F, Awc), C);
                                            D.Fc(C);
                                        }
                                        Y0b(h, RD(Vmb(C.j, 1), 12));
                                    }
                                    for(i = new is(Mr(a3b(d).a.Kc(), new ir)); gs(i);){
                                        h = RD(hs(i), 18);
                                        G = h.d.i;
                                        if (!a9b(G)) continue;
                                        r = RD(Wjb(q, mQb(G, (Ywc(), Awc))), 10);
                                        if (!r) {
                                            r = _8b(a, G);
                                            Zjb(q, mQb(G, Awc), r);
                                            ZEb(s.c, r);
                                        }
                                        Z0b(h, RD(Vmb(r.j, 0), 12));
                                    }
                                }
                            }
                            for(l = 0; l < p.c.length; l++){
                                t = (tFb(l, p.c.length), RD(p.c[l], 15));
                                if (t.dc()) continue;
                                m = null;
                                if (l == 0) {
                                    m = new R4b(a);
                                    wFb(0, o.c.length);
                                    XEb(o.c, 0, m);
                                } else if (l == k.c.length - 1) {
                                    m = new R4b(a);
                                    ZEb(o.c, m);
                                } else m = (tFb(l - 1, o.c.length), RD(o.c[l - 1], 30));
                                for(g = t.Kc(); g.Ob();){
                                    f = RD(g.Pb(), 10);
                                    g3b(f, m);
                                }
                            }
                            for(v = new Anb(w); v.a < v.c.c.length;){
                                u = RD(ynb(v), 10);
                                g3b(u, null);
                            }
                            pQb(a, (Ywc(), fwc), w);
                        }
                        function SNc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K;
                            I = new bnb;
                            for(o = new Anb(b.b); o.a < o.c.c.length;){
                                m = RD(ynb(o), 30);
                                for(v = new Anb(m.a); v.a < v.c.c.length;){
                                    u = RD(ynb(v), 10);
                                    u.p = -1;
                                    l = qwe;
                                    B = qwe;
                                    for(D = new Anb(u.j); D.a < D.c.c.length;){
                                        C = RD(ynb(D), 12);
                                        for(e = new Anb(C.e); e.a < e.c.c.length;){
                                            c = RD(ynb(e), 18);
                                            F = RD(mQb(c, (yCc(), MBc)), 17).a;
                                            l = $wnd.Math.max(l, F);
                                        }
                                        for(d = new Anb(C.g); d.a < d.c.c.length;){
                                            c = RD(ynb(d), 18);
                                            F = RD(mQb(c, (yCc(), MBc)), 17).a;
                                            B = $wnd.Math.max(B, F);
                                        }
                                    }
                                    pQb(u, HNc, sgb(l));
                                    pQb(u, INc, sgb(B));
                                }
                            }
                            r = 0;
                            for(n = new Anb(b.b); n.a < n.c.c.length;){
                                m = RD(ynb(n), 30);
                                for(v = new Anb(m.a); v.a < v.c.c.length;){
                                    u = RD(ynb(v), 10);
                                    if (u.p < 0) {
                                        H = new ZNc;
                                        H.b = r++;
                                        ONc(a, u, H);
                                        ZEb(I.c, H);
                                    }
                                }
                            }
                            A = ev(I.c.length);
                            k = ev(I.c.length);
                            for(g = 0; g < I.c.length; g++){
                                Rmb(A, new bnb);
                                Rmb(k, sgb(0));
                            }
                            MNc(b, I, A, k);
                            J = RD(anb(I, $C(SY, uEe, 261, I.c.length, 0, 1)), 854);
                            w = RD(anb(A, $C(QK, Ize, 15, A.c.length, 0, 1)), 198);
                            j = $C(kE, Pwe, 28, k.c.length, 15, 1);
                            for(h = 0; h < j.length; h++)j[h] = (tFb(h, k.c.length), RD(k.c[h], 17)).a;
                            s = 0;
                            t = new bnb;
                            for(i = 0; i < J.length; i++)j[i] == 0 && ZEb(t.c, J[i]);
                            q = $C(kE, Pwe, 28, J.length, 15, 1);
                            while(t.c.length != 0){
                                H = RD(Xmb(t, 0), 261);
                                q[H.b] = s++;
                                while(!w[H.b].dc()){
                                    K = RD(w[H.b].gd(0), 261);
                                    --j[K.b];
                                    j[K.b] == 0 && ZEb(t.c, K);
                                }
                            }
                            a.a = $C(SY, uEe, 261, J.length, 0, 1);
                            for(f = 0; f < J.length; f++){
                                p = J[f];
                                G = q[f];
                                a.a[G] = p;
                                p.b = G;
                                for(v = new Anb(p.e); v.a < v.c.c.length;){
                                    u = RD(ynb(v), 10);
                                    u.p = G;
                                }
                            }
                            return a.a;
                        }
                        function J8c(a, b, c, d, e) {
                            var f, g, h, i, j, k, l, m, n, o, p, q, r;
                            p = false;
                            i = false;
                            m = a + 1;
                            o = (tFb(a, b.c.length), RD(b.c[a], 186));
                            h = o.a;
                            j = null;
                            for(g = 0; g < o.a.c.length; g++){
                                f = (tFb(g, h.c.length), RD(h.c[g], 172));
                                if (f.c) continue;
                                if (f.b.c.length == 0) {
                                    gib();
                                    String.fromCharCode(10);
                                    Fad(o, f);
                                    --g;
                                    p = true;
                                    continue;
                                }
                                if (!f.k) {
                                    !!j && gad(j);
                                    j = new had(!j ? 0 : j.e + j.d + d, o.f, d);
                                    U9c(f, j.e + j.d, o.f);
                                    Rmb(o.d, j);
                                    aad(j, f);
                                    f.k = true;
                                }
                                k = null;
                                k = (r = null, g < o.a.c.length - 1 ? r = RD(Vmb(o.a, g + 1), 172) : m < b.c.length && (tFb(m, b.c.length), RD(b.c[m], 186)).a.c.length != 0 && (r = RD(Vmb((tFb(m, b.c.length), RD(b.c[m], 186)).a, 0), 172)), r);
                                q = false;
                                !!k && (q = !pb(k.j, o));
                                if (k) {
                                    if (k.b.c.length != 0 && !Heb(TD(RD(Vmb(k.b, 0), 27).of((X7c(), D7c))))) {
                                        Q9c(f, c - f.s);
                                        gad(f.q);
                                        p = p | I8c(o, f, k, c, d);
                                    } else {
                                        Fad(o, k);
                                        break;
                                    }
                                    if (k.b.c.length == 0) {
                                        b.c.length > m && Fad((tFb(m, b.c.length), RD(b.c[m], 186)), k);
                                        k = null;
                                        while(b.c.length > m && (tFb(m, b.c.length), RD(b.c[m], 186)).a.c.length == 0)Ymb(b, (tFb(m, b.c.length), b.c[m]));
                                    }
                                    if (!k) {
                                        --g;
                                        continue;
                                    }
                                    if (!Heb(TD(RD(Vmb(k.b, 0), 27).of((X7c(), D7c)))) && K8c(b, o, f, k, q, c, m, d)) {
                                        p = true;
                                        continue;
                                    }
                                    if (q) {
                                        n = o.b;
                                        l = k.f;
                                        if (!Heb(TD(RD(Vmb(k.b, 0), 27).of(D7c))) && L8c(b, o, f, k, c, m, d, e)) {
                                            p = true;
                                            if (n < l) {
                                                i = true;
                                                k.j = o;
                                                break;
                                            }
                                            continue;
                                        } else if (M8c(o, f)) {
                                            f.c = true;
                                            p = true;
                                            continue;
                                        }
                                    } else if (M8c(o, f)) {
                                        f.c = true;
                                        p = true;
                                        continue;
                                    }
                                    if (p) continue;
                                }
                                if (M8c(o, f)) {
                                    f.c = true;
                                    p = true;
                                    !!k && (k.k = false);
                                    continue;
                                } else gad(f.q);
                            }
                            return new Ptd((Geb(), p ? true : false), i ? true : false);
                        }
                        function yCc() {
                            yCc = geb;
                            QBc = (umd(), Wld);
                            RBc = Xld;
                            SBc = Yld;
                            TBc = Zld;
                            VBc = $ld;
                            WBc = _ld;
                            ZBc = bmd;
                            _Bc = dmd;
                            aCc = emd;
                            $Bc = cmd;
                            bCc = fmd;
                            dCc = gmd;
                            fCc = jmd;
                            YBc = amd;
                            PBc = (Ozc(), ezc);
                            UBc = fzc;
                            XBc = gzc;
                            cCc = hzc;
                            JBc = new mGd(Rld, sgb(0));
                            KBc = bzc;
                            LBc = czc;
                            MBc = dzc;
                            vCc = Fzc;
                            nCc = kzc;
                            oCc = nzc;
                            rCc = vzc;
                            pCc = qzc;
                            qCc = szc;
                            xCc = Kzc;
                            wCc = Hzc;
                            tCc = Bzc;
                            sCc = zzc;
                            uCc = Dzc;
                            iBc = Uyc;
                            jBc = Vyc;
                            DAc = dyc;
                            EAc = gyc;
                            jCc = mmd;
                            lCc = qmd;
                            iCc = lmd;
                            hCc = kmd;
                            kCc = (mqd(), jqd);
                            new mGd(nmd, kCc);
                            rBc = new A3b(12);
                            qBc = new mGd(tld, rBc);
                            zAc = (Ymd(), Umd);
                            yAc = new mGd(Skd, zAc);
                            ABc = new mGd(Gld, 0);
                            NBc = new mGd(Sld, sgb(1));
                            Tzc = new mGd(Dkd, Yze);
                            pBc = rld;
                            BBc = Hld;
                            GBc = Old;
                            qAc = Mkd;
                            Rzc = Bkd;
                            IAc = Xkd;
                            OBc = new mGd(Vld, (Geb(), true));
                            NAc = $kd;
                            OAc = _kd;
                            lBc = kld;
                            oBc = pld;
                            mBc = mld;
                            tAc = (Cmd(), Amd);
                            rAc = new mGd(Nkd, tAc);
                            dBc = ild;
                            cBc = gld;
                            EBc = Lld;
                            DBc = Kld;
                            FBc = Nld;
                            uBc = (pod(), ood);
                            new mGd(zld, uBc);
                            wBc = Cld;
                            xBc = Dld;
                            yBc = Eld;
                            vBc = Bld;
                            mCc = jzc;
                            $Ac = Fyc;
                            ZAc = Dyc;
                            gCc = izc;
                            UAc = vyc;
                            pAc = Rxc;
                            oAc = Pxc;
                            eAc = yxc;
                            fAc = zxc;
                            hAc = Exc;
                            gAc = Axc;
                            nAc = Nxc;
                            aBc = Hyc;
                            bBc = Iyc;
                            QAc = oyc;
                            kBc = Zyc;
                            fBc = Myc;
                            GAc = jyc;
                            hBc = Syc;
                            BAc = _xc;
                            CAc = byc;
                            dAc = Kkd;
                            eBc = Jyc;
                            Xzc = mxc;
                            Wzc = kxc;
                            Vzc = jxc;
                            KAc = myc;
                            JAc = lyc;
                            LAc = nyc;
                            nBc = nld;
                            RAc = cld;
                            FAc = Ukd;
                            wAc = Qkd;
                            vAc = Pkd;
                            iAc = Hxc;
                            CBc = Jld;
                            Uzc = Jkd;
                            MAc = Zkd;
                            zBc = Fld;
                            sBc = vld;
                            tBc = xld;
                            WAc = yyc;
                            XAc = Ayc;
                            IBc = Qld;
                            Szc = ixc;
                            YAc = Cyc;
                            xAc = Xxc;
                            uAc = Vxc;
                            _Ac = eld;
                            SAc = syc;
                            gBc = Pyc;
                            eCc = hmd;
                            sAc = Txc;
                            HBc = _yc;
                            AAc = Zxc;
                            jAc = Jxc;
                            kAc = Kxc;
                            TAc = uyc;
                            lAc = Lxc;
                            PAc = bld;
                            VAc = xyc;
                            mAc = Mxc;
                            cAc = wxc;
                            _zc = sxc;
                            Zzc = qxc;
                            $zc = rxc;
                            aAc = uxc;
                            Yzc = oxc;
                            bAc = vxc;
                            HAc = kyc;
                        }
                        function Mqe(a) {
                            var b, c, d;
                            if (a.d >= a.j) {
                                a.a = -1;
                                a.c = 1;
                                return;
                            }
                            b = ihb(a.i, a.d++);
                            a.a = b;
                            if (a.b == 1) {
                                switch(b){
                                    case 92:
                                        d = 10;
                                        if (a.d >= a.j) throw Adb(new Lqe(TId((Hde(), VIe))));
                                        a.a = ihb(a.i, a.d++);
                                        break;
                                    case 45:
                                        if ((a.e & 512) == 512 && a.d < a.j && ihb(a.i, a.d) == 91) {
                                            ++a.d;
                                            d = 24;
                                        } else d = 0;
                                        break;
                                    case 91:
                                        if ((a.e & 512) != 512 && a.d < a.j && ihb(a.i, a.d) == 58) {
                                            ++a.d;
                                            d = 20;
                                            break;
                                        }
                                    default:
                                        if ((b & 64512) == uxe && a.d < a.j) {
                                            c = ihb(a.i, a.d);
                                            if ((c & 64512) == 56320) {
                                                a.a = txe + (b - uxe << 10) + c - 56320;
                                                ++a.d;
                                            }
                                        }
                                        d = 0;
                                }
                                a.c = d;
                                return;
                            }
                            switch(b){
                                case 124:
                                    d = 2;
                                    break;
                                case 42:
                                    d = 3;
                                    break;
                                case 43:
                                    d = 4;
                                    break;
                                case 63:
                                    d = 5;
                                    break;
                                case 41:
                                    d = 7;
                                    break;
                                case 46:
                                    d = 8;
                                    break;
                                case 91:
                                    d = 9;
                                    break;
                                case 94:
                                    d = 11;
                                    break;
                                case 36:
                                    d = 12;
                                    break;
                                case 40:
                                    d = 6;
                                    if (a.d >= a.j) break;
                                    if (ihb(a.i, a.d) != 63) break;
                                    if (++a.d >= a.j) throw Adb(new Lqe(TId((Hde(), WIe))));
                                    b = ihb(a.i, a.d++);
                                    switch(b){
                                        case 58:
                                            d = 13;
                                            break;
                                        case 61:
                                            d = 14;
                                            break;
                                        case 33:
                                            d = 15;
                                            break;
                                        case 91:
                                            d = 19;
                                            break;
                                        case 62:
                                            d = 18;
                                            break;
                                        case 60:
                                            if (a.d >= a.j) throw Adb(new Lqe(TId((Hde(), WIe))));
                                            b = ihb(a.i, a.d++);
                                            if (b == 61) d = 16;
                                            else if (b == 33) d = 17;
                                            else throw Adb(new Lqe(TId((Hde(), XIe))));
                                            break;
                                        case 35:
                                            while(a.d < a.j){
                                                b = ihb(a.i, a.d++);
                                                if (b == 41) break;
                                            }
                                            if (b != 41) throw Adb(new Lqe(TId((Hde(), YIe))));
                                            d = 21;
                                            break;
                                        default:
                                            if (b == 45 || 97 <= b && b <= 122 || 65 <= b && b <= 90) {
                                                --a.d;
                                                d = 22;
                                                break;
                                            } else if (b == 40) {
                                                d = 23;
                                                break;
                                            }
                                            throw Adb(new Lqe(TId((Hde(), WIe))));
                                    }
                                    break;
                                case 92:
                                    d = 10;
                                    if (a.d >= a.j) throw Adb(new Lqe(TId((Hde(), VIe))));
                                    a.a = ihb(a.i, a.d++);
                                    break;
                                default:
                                    d = 0;
                            }
                            a.c = d;
                        }
                        function oXc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
                            c.Ug('Process compaction', 1);
                            if (!Heb(TD(mQb(b, (h_c(), F$c))))) return;
                            e = RD(mQb(b, H$c), 88);
                            n = Kfb(UD(mQb(b, _$c)));
                            pXc(a, b, e);
                            lXc(b, n / 2 / 2);
                            o = b.b;
                            tvb(o, new EXc(e));
                            for(j = Sub(o, 0); j.b != j.d.c;){
                                i = RD(evb(j), 40);
                                if (!Heb(TD(mQb(i, (q$c(), n$c))))) {
                                    d = mXc(i, e);
                                    p = lWc(i, b);
                                    l = 0;
                                    m = 0;
                                    if (d) {
                                        q = d.e;
                                        switch(e.g){
                                            case 2:
                                                l = q.a - n - i.f.a;
                                                p.e.a - n - i.f.a < l && (l = p.e.a - n - i.f.a);
                                                m = l + i.f.a;
                                                break;
                                            case 1:
                                                l = q.a + d.f.a + n;
                                                p.e.a + n > l && (l = p.e.a + p.f.a + n);
                                                m = l + i.f.a;
                                                break;
                                            case 4:
                                                l = q.b - n - i.f.b;
                                                p.e.b - n - i.f.b < l && (l = p.e.b - n - i.f.b);
                                                m = l + i.f.b;
                                                break;
                                            case 3:
                                                l = q.b + d.f.b + n;
                                                p.e.b + n > l && (l = p.e.b + p.f.b + n);
                                                m = l + i.f.b;
                                        }
                                    } else if (p) switch(e.g){
                                        case 2:
                                            l = p.e.a - n - i.f.a;
                                            m = l + i.f.a;
                                            break;
                                        case 1:
                                            l = p.e.a + p.f.a + n;
                                            m = l + i.f.a;
                                            break;
                                        case 4:
                                            l = p.e.b - n - i.f.b;
                                            m = l + i.f.b;
                                            break;
                                        case 3:
                                            l = p.e.b + p.f.b + n;
                                            m = l + i.f.b;
                                    }
                                    if (dE(mQb(b, K$c)) === dE((LZc(), IZc))) {
                                        f = l;
                                        g = m;
                                        h = DDb(CDb(new SDb(null, new Swb(a.a, 16)), new IXc(f, g)));
                                        if (h.a != null) e == (Cmd(), ymd) || e == zmd ? i.e.a = l : i.e.b = l;
                                        else {
                                            e == (Cmd(), ymd) || e == Bmd ? h = DDb(CDb(NDb(new SDb(null, new Swb(a.a, 16))), new WXc(f))) : h = DDb(CDb(NDb(new SDb(null, new Swb(a.a, 16))), new YXc(f)));
                                            h.a != null && (e == ymd || e == zmd ? i.e.a = Kfb(UD((sFb(h.a != null), RD(h.a, 42)).a)) : i.e.b = Kfb(UD((sFb(h.a != null), RD(h.a, 42)).a)));
                                        }
                                        if (h.a != null) {
                                            k = Wmb(a.a, (sFb(h.a != null), h.a), 0);
                                            if (k > 0 && k != RD(mQb(i, f_c), 17).a) {
                                                pQb(i, UZc, (Geb(), true));
                                                pQb(i, f_c, sgb(k));
                                            }
                                        }
                                    } else e == (Cmd(), ymd) || e == zmd ? i.e.a = l : i.e.b = l;
                                }
                            }
                            c.Vg();
                        }
                        function Fre(a) {
                            var b, c, d, e, f, g, h, i, j;
                            a.b = 1;
                            Mqe(a);
                            b = null;
                            if (a.c == 0 && a.a == 94) {
                                Mqe(a);
                                b = (Vse(), Vse(), ++Use, new xte(4));
                                rte(b, 0, MLe);
                                h = (++Use, new xte(4));
                            } else h = (Vse(), Vse(), ++Use, new xte(4));
                            e = true;
                            while((j = a.c) != 1){
                                if (j == 0 && a.a == 93 && !e) {
                                    if (b) {
                                        wte(b, h);
                                        h = b;
                                    }
                                    break;
                                }
                                c = a.a;
                                d = false;
                                if (j == 10) switch(c){
                                    case 100:
                                    case 68:
                                    case 119:
                                    case 87:
                                    case 115:
                                    case 83:
                                        ute(h, Ere(c));
                                        d = true;
                                        break;
                                    case 105:
                                    case 73:
                                    case 99:
                                    case 67:
                                        c = (ute(h, Ere(c)), -1);
                                        c < 0 && (d = true);
                                        break;
                                    case 112:
                                    case 80:
                                        i = Sqe(a, c);
                                        if (!i) throw Adb(new Lqe(TId((Hde(), hJe))));
                                        ute(h, i);
                                        d = true;
                                        break;
                                    default:
                                        c = Dre(a);
                                }
                                else if (j == 24 && !e) {
                                    if (b) {
                                        wte(b, h);
                                        h = b;
                                    }
                                    f = Fre(a);
                                    wte(h, f);
                                    if (a.c != 0 || a.a != 93) throw Adb(new Lqe(TId((Hde(), lJe))));
                                    break;
                                }
                                Mqe(a);
                                if (!d) {
                                    if (j == 0) {
                                        if (c == 91) throw Adb(new Lqe(TId((Hde(), mJe))));
                                        if (c == 93) throw Adb(new Lqe(TId((Hde(), nJe))));
                                        if (c == 45 && !e && a.a != 93) throw Adb(new Lqe(TId((Hde(), oJe))));
                                    }
                                    if (a.c != 0 || a.a != 45 || c == 45 && e) rte(h, c, c);
                                    else {
                                        Mqe(a);
                                        if ((j = a.c) == 1) throw Adb(new Lqe(TId((Hde(), jJe))));
                                        if (j == 0 && a.a == 93) {
                                            rte(h, c, c);
                                            rte(h, 45, 45);
                                        } else if (j == 0 && a.a == 93 || j == 24) throw Adb(new Lqe(TId((Hde(), oJe))));
                                        else {
                                            g = a.a;
                                            if (j == 0) {
                                                if (g == 91) throw Adb(new Lqe(TId((Hde(), mJe))));
                                                if (g == 93) throw Adb(new Lqe(TId((Hde(), nJe))));
                                                if (g == 45) throw Adb(new Lqe(TId((Hde(), oJe))));
                                            } else j == 10 && (g = Dre(a));
                                            Mqe(a);
                                            if (c > g) throw Adb(new Lqe(TId((Hde(), rJe))));
                                            rte(h, c, g);
                                        }
                                    }
                                }
                                e = false;
                            }
                            if (a.c == 1) throw Adb(new Lqe(TId((Hde(), jJe))));
                            vte(h);
                            ste(h);
                            a.b = 0;
                            Mqe(a);
                            return h;
                        }
                        function EGc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
                            c.Ug('Coffman-Graham Layering', 1);
                            if (b.a.c.length == 0) {
                                c.Vg();
                                return;
                            }
                            v = RD(mQb(b, (yCc(), SAc)), 17).a;
                            i = 0;
                            g = 0;
                            for(m = new Anb(b.a); m.a < m.c.c.length;){
                                l = RD(ynb(m), 10);
                                l.p = i++;
                                for(f = new is(Mr(a3b(l).a.Kc(), new ir)); gs(f);){
                                    e = RD(hs(f), 18);
                                    e.p = g++;
                                }
                            }
                            a.d = $C(xdb, Hye, 28, i, 16, 1);
                            a.a = $C(xdb, Hye, 28, g, 16, 1);
                            a.b = $C(kE, Pwe, 28, i, 15, 1);
                            a.e = $C(kE, Pwe, 28, i, 15, 1);
                            a.f = $C(kE, Pwe, 28, i, 15, 1);
                            Nc(a.c);
                            FGc(a, b);
                            o = new pwb(new JGc(a));
                            for(u = new Anb(b.a); u.a < u.c.c.length;){
                                s = RD(ynb(u), 10);
                                for(f = new is(Mr(Z2b(s).a.Kc(), new ir)); gs(f);){
                                    e = RD(hs(f), 18);
                                    a.a[e.p] || ++a.b[s.p];
                                }
                                a.b[s.p] == 0 && zFb(lwb(o, s), Bxe);
                            }
                            h = 0;
                            while(o.b.c.length != 0){
                                s = RD(mwb(o), 10);
                                a.f[s.p] = h++;
                                for(f = new is(Mr(a3b(s).a.Kc(), new ir)); gs(f);){
                                    e = RD(hs(f), 18);
                                    if (a.a[e.p]) continue;
                                    q = e.d.i;
                                    --a.b[q.p];
                                    Rc(a.c, q, sgb(a.f[s.p]));
                                    a.b[q.p] == 0 && zFb(lwb(o, q), Bxe);
                                }
                            }
                            n = new pwb(new NGc(a));
                            for(t = new Anb(b.a); t.a < t.c.c.length;){
                                s = RD(ynb(t), 10);
                                for(f = new is(Mr(a3b(s).a.Kc(), new ir)); gs(f);){
                                    e = RD(hs(f), 18);
                                    a.a[e.p] || ++a.e[s.p];
                                }
                                a.e[s.p] == 0 && zFb(lwb(n, s), Bxe);
                            }
                            k = new bnb;
                            d = BGc(b, k);
                            while(n.b.c.length != 0){
                                r = RD(mwb(n), 10);
                                (d.a.c.length >= v || !zGc(r, d)) && (d = BGc(b, k));
                                g3b(r, d);
                                for(f = new is(Mr(Z2b(r).a.Kc(), new ir)); gs(f);){
                                    e = RD(hs(f), 18);
                                    if (a.a[e.p]) continue;
                                    p = e.c.i;
                                    --a.e[p.p];
                                    a.e[p.p] == 0 && zFb(lwb(n, p), Bxe);
                                }
                            }
                            for(j = k.c.length - 1; j >= 0; --j)Rmb(b.b, (tFb(j, k.c.length), RD(k.c[j], 30)));
                            b.a.c.length = 0;
                            c.Vg();
                        }
                        function Sec(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
                            u = false;
                            do {
                                u = false;
                                for(f = b ? new Xkb(a.a.b).a.gc() - 2 : 1; b ? f >= 0 : f < new Xkb(a.a.b).a.gc(); f += b ? -1 : 1){
                                    e = _5b(a.a, sgb(f));
                                    for(n = 0; n < e.b; n++){
                                        l = RD(ju(e, n), 10);
                                        if (!nQb(l, (Ywc(), zwc))) continue;
                                        if (a6b(a.a, sgb(f)) && a.r == (aEc(), TDc) || b6b(a.a, sgb(f)) && a.r == (aEc(), UDc)) continue;
                                        t = true;
                                        for(r = 0; r < e.b; r++){
                                            q = RD(ju(e, r), 10);
                                            nQb(q, zwc) && (b && RD(mQb(l, zwc), 17).a < RD(mQb(q, zwc), 17).a || !b && RD(mQb(l, zwc), 17).a > RD(mQb(q, zwc), 17).a) && (t = false);
                                        }
                                        if (!t) continue;
                                        i = b ? f + 1 : f - 1;
                                        h = _5b(a.a, sgb(i));
                                        g = false;
                                        s = true;
                                        d = false;
                                        for(k = Sub(h, 0); k.b != k.d.c;){
                                            j = RD(evb(k), 10);
                                            if (nQb(j, zwc)) {
                                                if (j.p != l.p) {
                                                    g = g | (b ? RD(mQb(j, zwc), 17).a < RD(mQb(l, zwc), 17).a : RD(mQb(j, zwc), 17).a > RD(mQb(l, zwc), 17).a);
                                                    s = false;
                                                }
                                            } else if (!g && s) {
                                                if (j.k == (r3b(), n3b)) {
                                                    d = true;
                                                    b ? m = RD(hs(new is(Mr(Z2b(j).a.Kc(), new ir))), 18).c.i : m = RD(hs(new is(Mr(a3b(j).a.Kc(), new ir))), 18).d.i;
                                                    if (m == l) {
                                                        b ? c = RD(hs(new is(Mr(a3b(j).a.Kc(), new ir))), 18).d.i : c = RD(hs(new is(Mr(Z2b(j).a.Kc(), new ir))), 18).c.i;
                                                        (b ? RD($5b(a.a, c), 17).a - RD($5b(a.a, m), 17).a : RD($5b(a.a, m), 17).a - RD($5b(a.a, c), 17).a) <= 2 && (s = false);
                                                    }
                                                }
                                            }
                                        }
                                        if (d && s) {
                                            b ? c = RD(hs(new is(Mr(a3b(l).a.Kc(), new ir))), 18).d.i : c = RD(hs(new is(Mr(Z2b(l).a.Kc(), new ir))), 18).c.i;
                                            (b ? RD($5b(a.a, c), 17).a - RD($5b(a.a, l), 17).a : RD($5b(a.a, l), 17).a - RD($5b(a.a, c), 17).a) <= 2 && c.k == (r3b(), p3b) && (s = false);
                                        }
                                        if (g || s) {
                                            p = Xec(a, l, b);
                                            while(p.a.gc() != 0){
                                                o = RD(p.a.ec().Kc().Pb(), 10);
                                                p.a.Bc(o);
                                                ye(p, Xec(a, o, b));
                                            }
                                            --n;
                                            u = true;
                                        }
                                    }
                                }
                            }while (u);
                        }
                        function Xae(a) {
                            _Ad(a.c, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'http://www.w3.org/2001/XMLSchema#decimal'
                            ]));
                            _Ad(a.d, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'http://www.w3.org/2001/XMLSchema#integer'
                            ]));
                            _Ad(a.e, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'http://www.w3.org/2001/XMLSchema#boolean'
                            ]));
                            _Ad(a.f, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'EBoolean',
                                GIe,
                                'EBoolean:Object'
                            ]));
                            _Ad(a.i, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'http://www.w3.org/2001/XMLSchema#byte'
                            ]));
                            _Ad(a.g, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'http://www.w3.org/2001/XMLSchema#hexBinary'
                            ]));
                            _Ad(a.j, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'EByte',
                                GIe,
                                'EByte:Object'
                            ]));
                            _Ad(a.n, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'EChar',
                                GIe,
                                'EChar:Object'
                            ]));
                            _Ad(a.t, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'http://www.w3.org/2001/XMLSchema#double'
                            ]));
                            _Ad(a.u, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'EDouble',
                                GIe,
                                'EDouble:Object'
                            ]));
                            _Ad(a.F, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'http://www.w3.org/2001/XMLSchema#float'
                            ]));
                            _Ad(a.G, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'EFloat',
                                GIe,
                                'EFloat:Object'
                            ]));
                            _Ad(a.I, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'http://www.w3.org/2001/XMLSchema#int'
                            ]));
                            _Ad(a.J, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'EInt',
                                GIe,
                                'EInt:Object'
                            ]));
                            _Ad(a.N, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'http://www.w3.org/2001/XMLSchema#long'
                            ]));
                            _Ad(a.O, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'ELong',
                                GIe,
                                'ELong:Object'
                            ]));
                            _Ad(a.Z, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'http://www.w3.org/2001/XMLSchema#short'
                            ]));
                            _Ad(a.$, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'EShort',
                                GIe,
                                'EShort:Object'
                            ]));
                            _Ad(a._, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                DKe,
                                'http://www.w3.org/2001/XMLSchema#string'
                            ]));
                        }
                        function C0c(a, b, c, d, e, f, g) {
                            var h, i, j, k, l, m, n, o;
                            m = RD(d.a, 17).a;
                            n = RD(d.b, 17).a;
                            l = a.b;
                            o = a.c;
                            h = 0;
                            k = 0;
                            if (b == (Cmd(), ymd) || b == zmd) {
                                k = Uvb(QCb(HDb(GDb(new SDb(null, new Swb(c.b, 16)), new b2c), new b1c)));
                                if (l.e.b + l.f.b / 2 > k) {
                                    j = ++n;
                                    h = Kfb(UD(Lvb(JDb(GDb(new SDb(null, new Swb(c.b, 16)), new d2c(e, j)), new d1c))));
                                } else {
                                    i = ++m;
                                    h = Kfb(UD(Lvb(KDb(GDb(new SDb(null, new Swb(c.b, 16)), new f2c(e, i)), new h1c))));
                                }
                            } else {
                                k = Uvb(QCb(HDb(GDb(new SDb(null, new Swb(c.b, 16)), new x1c), new l1c)));
                                if (l.e.a + l.f.a / 2 > k) {
                                    j = ++n;
                                    h = Kfb(UD(Lvb(JDb(GDb(new SDb(null, new Swb(c.b, 16)), new z1c(e, j)), new n1c))));
                                } else {
                                    i = ++m;
                                    h = Kfb(UD(Lvb(KDb(GDb(new SDb(null, new Swb(c.b, 16)), new B1c(e, i)), new r1c))));
                                }
                            }
                            if (b == ymd) {
                                Oub(a.a, new rjd(Kfb(UD(mQb(l, (q$c(), f$c)))) - e, h));
                                Oub(a.a, new rjd(o.e.a + o.f.a + e + f, h));
                                Oub(a.a, new rjd(o.e.a + o.f.a + e + f, o.e.b + o.f.b / 2));
                                Oub(a.a, new rjd(o.e.a + o.f.a, o.e.b + o.f.b / 2));
                            } else if (b == zmd) {
                                Oub(a.a, new rjd(Kfb(UD(mQb(l, (q$c(), e$c)))) + e, l.e.b + l.f.b / 2));
                                Oub(a.a, new rjd(l.e.a + l.f.a + e, h));
                                Oub(a.a, new rjd(o.e.a - e - f, h));
                                Oub(a.a, new rjd(o.e.a - e - f, o.e.b + o.f.b / 2));
                                Oub(a.a, new rjd(o.e.a, o.e.b + o.f.b / 2));
                            } else if (b == Bmd) {
                                Oub(a.a, new rjd(h, Kfb(UD(mQb(l, (q$c(), f$c)))) - e));
                                Oub(a.a, new rjd(h, o.e.b + o.f.b + e + f));
                                Oub(a.a, new rjd(o.e.a + o.f.a / 2, o.e.b + o.f.b + e + f));
                                Oub(a.a, new rjd(o.e.a + o.f.a / 2, o.e.b + o.f.b + e));
                            } else {
                                a.a.b == 0 || (RD(Rub(a.a), 8).b = Kfb(UD(mQb(l, (q$c(), e$c)))) + e * RD(g.b, 17).a);
                                Oub(a.a, new rjd(h, Kfb(UD(mQb(l, (q$c(), e$c)))) + e * RD(g.b, 17).a));
                                Oub(a.a, new rjd(h, o.e.b - e * RD(g.a, 17).a - f));
                            }
                            return new Ptd(sgb(m), sgb(n));
                        }
                        function ASd(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n;
                            g = true;
                            l = null;
                            d = null;
                            e = null;
                            b = false;
                            n = _Rd;
                            j = null;
                            f = null;
                            h = 0;
                            i = sSd(a, h, ZRd, $Rd);
                            if (i < a.length && (BFb(i, a.length), a.charCodeAt(i) == 58)) {
                                l = (AFb(h, i, a.length), a.substr(h, i - h));
                                h = i + 1;
                            }
                            c = l != null && tpb(eSd, l.toLowerCase());
                            if (c) {
                                i = a.lastIndexOf('!/');
                                if (i == -1) throw Adb(new agb('no archive separator'));
                                g = true;
                                d = zhb(a, h, ++i);
                                h = i;
                            } else if (h >= 0 && lhb(a.substr(h, 2), '//')) {
                                h += 2;
                                i = sSd(a, h, aSd, bSd);
                                d = (AFb(h, i, a.length), a.substr(h, i - h));
                                h = i;
                            } else if (l != null && (h == a.length || (BFb(h, a.length), a.charCodeAt(h) != 47))) {
                                g = false;
                                i = rhb(a, Fhb(35), h);
                                i == -1 && (i = a.length);
                                d = (AFb(h, i, a.length), a.substr(h, i - h));
                                h = i;
                            }
                            if (!c && h < a.length && (BFb(h, a.length), a.charCodeAt(h) == 47)) {
                                i = sSd(a, h + 1, aSd, bSd);
                                k = (AFb(h + 1, i, a.length), a.substr(h + 1, i - (h + 1)));
                                if (k.length > 0 && ihb(k, k.length - 1) == 58) {
                                    e = k;
                                    h = i;
                                }
                            }
                            if (h < a.length && (BFb(h, a.length), a.charCodeAt(h) == 47)) {
                                ++h;
                                b = true;
                            }
                            if (h < a.length && (BFb(h, a.length), a.charCodeAt(h) != 63) && (BFb(h, a.length), a.charCodeAt(h) != 35)) {
                                m = new bnb;
                                while(h < a.length && (BFb(h, a.length), a.charCodeAt(h) != 63) && (BFb(h, a.length), a.charCodeAt(h) != 35)){
                                    i = sSd(a, h, aSd, bSd);
                                    Rmb(m, (AFb(h, i, a.length), a.substr(h, i - h)));
                                    h = i;
                                    h < a.length && (BFb(h, a.length), a.charCodeAt(h) == 47) && (BSd(a, ++h) || (m.c.push(''), undefined));
                                }
                                n = $C(qJ, Nve, 2, m.c.length, 6, 1);
                                anb(m, n);
                            }
                            if (h < a.length && (BFb(h, a.length), a.charCodeAt(h) == 63)) {
                                i = phb(a, 35, ++h);
                                i == -1 && (i = a.length);
                                j = (AFb(h, i, a.length), a.substr(h, i - h));
                                h = i;
                            }
                            h < a.length && (f = yhb(a, ++h));
                            ISd(g, l, d, e, n, j);
                            return new lSd(g, l, d, e, b, n, j, f);
                        }
                        function P_b() {
                            P_b = geb;
                            z$b();
                            O_b = new Tp;
                            Rc(O_b, (qpd(), cpd), bpd);
                            Rc(O_b, mpd, bpd);
                            Rc(O_b, dpd, bpd);
                            Rc(O_b, jpd, bpd);
                            Rc(O_b, ipd, bpd);
                            Rc(O_b, gpd, bpd);
                            Rc(O_b, jpd, cpd);
                            Rc(O_b, bpd, Zod);
                            Rc(O_b, cpd, Zod);
                            Rc(O_b, mpd, Zod);
                            Rc(O_b, dpd, Zod);
                            Rc(O_b, hpd, Zod);
                            Rc(O_b, jpd, Zod);
                            Rc(O_b, ipd, Zod);
                            Rc(O_b, gpd, Zod);
                            Rc(O_b, apd, Zod);
                            Rc(O_b, bpd, kpd);
                            Rc(O_b, cpd, kpd);
                            Rc(O_b, Zod, kpd);
                            Rc(O_b, mpd, kpd);
                            Rc(O_b, dpd, kpd);
                            Rc(O_b, hpd, kpd);
                            Rc(O_b, jpd, kpd);
                            Rc(O_b, apd, kpd);
                            Rc(O_b, lpd, kpd);
                            Rc(O_b, ipd, kpd);
                            Rc(O_b, epd, kpd);
                            Rc(O_b, gpd, kpd);
                            Rc(O_b, cpd, mpd);
                            Rc(O_b, dpd, mpd);
                            Rc(O_b, jpd, mpd);
                            Rc(O_b, gpd, mpd);
                            Rc(O_b, cpd, dpd);
                            Rc(O_b, mpd, dpd);
                            Rc(O_b, jpd, dpd);
                            Rc(O_b, dpd, dpd);
                            Rc(O_b, ipd, dpd);
                            Rc(O_b, bpd, $od);
                            Rc(O_b, cpd, $od);
                            Rc(O_b, Zod, $od);
                            Rc(O_b, kpd, $od);
                            Rc(O_b, mpd, $od);
                            Rc(O_b, dpd, $od);
                            Rc(O_b, hpd, $od);
                            Rc(O_b, jpd, $od);
                            Rc(O_b, lpd, $od);
                            Rc(O_b, apd, $od);
                            Rc(O_b, gpd, $od);
                            Rc(O_b, ipd, $od);
                            Rc(O_b, fpd, $od);
                            Rc(O_b, bpd, lpd);
                            Rc(O_b, cpd, lpd);
                            Rc(O_b, Zod, lpd);
                            Rc(O_b, mpd, lpd);
                            Rc(O_b, dpd, lpd);
                            Rc(O_b, hpd, lpd);
                            Rc(O_b, jpd, lpd);
                            Rc(O_b, apd, lpd);
                            Rc(O_b, gpd, lpd);
                            Rc(O_b, epd, lpd);
                            Rc(O_b, fpd, lpd);
                            Rc(O_b, cpd, apd);
                            Rc(O_b, mpd, apd);
                            Rc(O_b, dpd, apd);
                            Rc(O_b, jpd, apd);
                            Rc(O_b, lpd, apd);
                            Rc(O_b, gpd, apd);
                            Rc(O_b, ipd, apd);
                            Rc(O_b, bpd, _od);
                            Rc(O_b, cpd, _od);
                            Rc(O_b, Zod, _od);
                            Rc(O_b, mpd, _od);
                            Rc(O_b, dpd, _od);
                            Rc(O_b, hpd, _od);
                            Rc(O_b, jpd, _od);
                            Rc(O_b, apd, _od);
                            Rc(O_b, gpd, _od);
                            Rc(O_b, cpd, ipd);
                            Rc(O_b, Zod, ipd);
                            Rc(O_b, kpd, ipd);
                            Rc(O_b, dpd, ipd);
                            Rc(O_b, bpd, epd);
                            Rc(O_b, cpd, epd);
                            Rc(O_b, kpd, epd);
                            Rc(O_b, mpd, epd);
                            Rc(O_b, dpd, epd);
                            Rc(O_b, hpd, epd);
                            Rc(O_b, jpd, epd);
                            Rc(O_b, jpd, fpd);
                            Rc(O_b, dpd, fpd);
                            Rc(O_b, apd, bpd);
                            Rc(O_b, apd, mpd);
                            Rc(O_b, apd, Zod);
                            Rc(O_b, hpd, bpd);
                            Rc(O_b, hpd, cpd);
                            Rc(O_b, hpd, kpd);
                        }
                        function _Qc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
                            c.Ug('Brandes & Koepf node placement', 1);
                            a.a = b;
                            a.c = iRc(b);
                            d = RD(mQb(b, (yCc(), fBc)), 281);
                            n = Heb(TD(mQb(b, gBc)));
                            a.d = d == (Ouc(), Luc) && !n || d == Iuc;
                            $Qc(a, b);
                            v = null;
                            w = null;
                            r = null;
                            s = null;
                            q = (dk(4, iwe), new cnb(4));
                            switch(RD(mQb(b, fBc), 281).g){
                                case 3:
                                    r = new sQc(b, a.c.d, (EQc(), CQc), (wQc(), uQc));
                                    ZEb(q.c, r);
                                    break;
                                case 1:
                                    s = new sQc(b, a.c.d, (EQc(), DQc), (wQc(), uQc));
                                    ZEb(q.c, s);
                                    break;
                                case 4:
                                    v = new sQc(b, a.c.d, (EQc(), CQc), (wQc(), vQc));
                                    ZEb(q.c, v);
                                    break;
                                case 2:
                                    w = new sQc(b, a.c.d, (EQc(), DQc), (wQc(), vQc));
                                    ZEb(q.c, w);
                                    break;
                                default:
                                    r = new sQc(b, a.c.d, (EQc(), CQc), (wQc(), uQc));
                                    s = new sQc(b, a.c.d, DQc, uQc);
                                    v = new sQc(b, a.c.d, CQc, vQc);
                                    w = new sQc(b, a.c.d, DQc, vQc);
                                    ZEb(q.c, v);
                                    ZEb(q.c, w);
                                    ZEb(q.c, r);
                                    ZEb(q.c, s);
                            }
                            e = new MQc(b, a.c);
                            for(h = new Anb(q); h.a < h.c.c.length;){
                                f = RD(ynb(h), 185);
                                LQc(e, f, a.b);
                                KQc(f);
                            }
                            m = new RQc(b, a.c);
                            for(i = new Anb(q); i.a < i.c.c.length;){
                                f = RD(ynb(i), 185);
                                OQc(m, f);
                            }
                            if (c._g()) for(j = new Anb(q); j.a < j.c.c.length;){
                                f = RD(ynb(j), 185);
                                c.bh(f + ' size is ' + qQc(f));
                            }
                            l = null;
                            if (a.d) {
                                k = YQc(a, q, a.c.d);
                                XQc(b, k, c) && (l = k);
                            }
                            if (!l) for(j = new Anb(q); j.a < j.c.c.length;){
                                f = RD(ynb(j), 185);
                                XQc(b, f, c) && (!l || qQc(l) > qQc(f)) && (l = f);
                            }
                            !l && (l = (tFb(0, q.c.length), RD(q.c[0], 185)));
                            for(p = new Anb(b.b); p.a < p.c.c.length;){
                                o = RD(ynb(p), 30);
                                for(u = new Anb(o.a); u.a < u.c.c.length;){
                                    t = RD(ynb(u), 10);
                                    t.n.b = Kfb(l.p[t.p]) + Kfb(l.d[t.p]);
                                }
                            }
                            if (c._g()) {
                                c.bh('Chosen node placement: ' + l);
                                c.bh('Blocks: ' + bRc(l));
                                c.bh('Classes: ' + cRc(l, c));
                                c.bh('Marked edges: ' + a.b);
                            }
                            for(g = new Anb(q); g.a < g.c.c.length;){
                                f = RD(ynb(g), 185);
                                f.g = null;
                                f.b = null;
                                f.a = null;
                                f.d = null;
                                f.j = null;
                                f.i = null;
                                f.p = null;
                            }
                            gRc(a.c);
                            a.b.a.$b();
                            c.Vg();
                        }
                        function GVc(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
                            if (a.c.length == 1) {
                                CVc((tFb(0, a.c.length), RD(a.c[0], 121)));
                                return tFb(0, a.c.length), RD(a.c[0], 121);
                            } else if (a.c.length <= 0) return new YWc;
                            for(i = new Anb(a); i.a < i.c.c.length;){
                                g = RD(ynb(i), 121);
                                s = 0;
                                o = lve;
                                p = lve;
                                m = qwe;
                                n = qwe;
                                for(r = Sub(g.b, 0); r.b != r.d.c;){
                                    q = RD(evb(r), 40);
                                    s += RD(mQb(q, (h_c(), X$c)), 17).a;
                                    o = $wnd.Math.min(o, q.e.a);
                                    p = $wnd.Math.min(p, q.e.b);
                                    m = $wnd.Math.max(m, q.e.a + q.f.a);
                                    n = $wnd.Math.max(n, q.e.b + q.f.b);
                                }
                                pQb(g, (h_c(), X$c), sgb(s));
                                pQb(g, (q$c(), SZc), new rjd(o, p));
                                pQb(g, RZc, new rjd(m, n));
                            }
                            yob();
                            _mb(a, new KVc);
                            v = new YWc;
                            kQb(v, (tFb(0, a.c.length), RD(a.c[0], 96)));
                            l = 0;
                            D = 0;
                            for(j = new Anb(a); j.a < j.c.c.length;){
                                g = RD(ynb(j), 121);
                                w = ojd(ajd(RD(mQb(g, (q$c(), RZc)), 8)), RD(mQb(g, SZc), 8));
                                l = $wnd.Math.max(l, w.a);
                                D += w.a * w.b;
                            }
                            l = $wnd.Math.max(l, $wnd.Math.sqrt(D) * Kfb(UD(mQb(v, (h_c(), E$c)))));
                            A = Kfb(UD(mQb(v, _$c)));
                            F = 0;
                            G = 0;
                            k = 0;
                            b = A;
                            for(h = new Anb(a); h.a < h.c.c.length;){
                                g = RD(ynb(h), 121);
                                w = ojd(ajd(RD(mQb(g, (q$c(), RZc)), 8)), RD(mQb(g, SZc), 8));
                                if (F + w.a > l) {
                                    F = 0;
                                    G += k + A;
                                    k = 0;
                                }
                                FVc(v, g, F, G);
                                b = $wnd.Math.max(b, F + w.a);
                                k = $wnd.Math.max(k, w.b);
                                F += w.a + A;
                            }
                            u = new Tsb;
                            c = new Tsb;
                            for(C = new Anb(a); C.a < C.c.c.length;){
                                B = RD(ynb(C), 121);
                                d = Heb(TD(mQb(B, (umd(), Mkd))));
                                t = !B.q ? wob : B.q;
                                for(f = t.vc().Kc(); f.Ob();){
                                    e = RD(f.Pb(), 44);
                                    if (Ujb(u, e.ld())) {
                                        if (dE(RD(e.ld(), 149).Sg()) !== dE(e.md())) {
                                            if (d && Ujb(c, e.ld())) {
                                                gib();
                                                RD(e.ld(), 149).Pg();
                                                String.fromCharCode(10);
                                            } else {
                                                Zjb(u, RD(e.ld(), 149), e.md());
                                                pQb(v, RD(e.ld(), 149), e.md());
                                                d && Zjb(c, RD(e.ld(), 149), e.md());
                                            }
                                        }
                                    } else {
                                        Zjb(u, RD(e.ld(), 149), e.md());
                                        pQb(v, RD(e.ld(), 149), e.md());
                                    }
                                }
                            }
                            CVc(v);
                            return v;
                        }
                        function f7d(a, b) {
                            switch(a.e){
                                case 0:
                                case 2:
                                case 4:
                                case 6:
                                case 42:
                                case 44:
                                case 46:
                                case 48:
                                case 8:
                                case 10:
                                case 12:
                                case 14:
                                case 16:
                                case 18:
                                case 20:
                                case 22:
                                case 24:
                                case 26:
                                case 28:
                                case 30:
                                case 32:
                                case 34:
                                case 36:
                                case 38:
                                    return new sje(a.b, a.a, b, a.c);
                                case 1:
                                    return new _Zd(a.a, b, BYd(b.Dh(), a.c));
                                case 43:
                                    return new lie(a.a, b, BYd(b.Dh(), a.c));
                                case 3:
                                    return new XZd(a.a, b, BYd(b.Dh(), a.c));
                                case 45:
                                    return new iie(a.a, b, BYd(b.Dh(), a.c));
                                case 41:
                                    return new DVd(RD(WVd(a.c), 29), a.a, b, BYd(b.Dh(), a.c));
                                case 50:
                                    return new Cje(RD(WVd(a.c), 29), a.a, b, BYd(b.Dh(), a.c));
                                case 5:
                                    return new oie(a.a, b, BYd(b.Dh(), a.c), a.d.n);
                                case 47:
                                    return new sie(a.a, b, BYd(b.Dh(), a.c), a.d.n);
                                case 7:
                                    return new C5d(a.a, b, BYd(b.Dh(), a.c), a.d.n);
                                case 49:
                                    return new G5d(a.a, b, BYd(b.Dh(), a.c), a.d.n);
                                case 9:
                                    return new gie(a.a, b, BYd(b.Dh(), a.c));
                                case 11:
                                    return new eie(a.a, b, BYd(b.Dh(), a.c));
                                case 13:
                                    return new aie(a.a, b, BYd(b.Dh(), a.c));
                                case 15:
                                    return new Kfe(a.a, b, BYd(b.Dh(), a.c));
                                case 17:
                                    return new Cie(a.a, b, BYd(b.Dh(), a.c));
                                case 19:
                                    return new zie(a.a, b, BYd(b.Dh(), a.c));
                                case 21:
                                    return new vie(a.a, b, BYd(b.Dh(), a.c));
                                case 23:
                                    return new PZd(a.a, b, BYd(b.Dh(), a.c));
                                case 25:
                                    return new bje(a.a, b, BYd(b.Dh(), a.c), a.d.n);
                                case 27:
                                    return new Yie(a.a, b, BYd(b.Dh(), a.c), a.d.n);
                                case 29:
                                    return new Tie(a.a, b, BYd(b.Dh(), a.c), a.d.n);
                                case 31:
                                    return new Nie(a.a, b, BYd(b.Dh(), a.c), a.d.n);
                                case 33:
                                    return new $ie(a.a, b, BYd(b.Dh(), a.c), a.d.n);
                                case 35:
                                    return new Vie(a.a, b, BYd(b.Dh(), a.c), a.d.n);
                                case 37:
                                    return new Pie(a.a, b, BYd(b.Dh(), a.c), a.d.n);
                                case 39:
                                    return new Iie(a.a, b, BYd(b.Dh(), a.c), a.d.n);
                                case 40:
                                    return new Uge(b, BYd(b.Dh(), a.c));
                                default:
                                    throw Adb(new yz('Unknown feature style: ' + a.e));
                            }
                        }
                        function h2c(a) {
                            var b, c, d, e, f, g, h, i;
                            f = 0;
                            e = a.a.b;
                            for(i = Sub(a.a, 0); i.b != i.d.c;){
                                h = RD(evb(i), 240);
                                g = (f + 1) / (e + 1);
                                if (!a.c && !a.d) return;
                                else if (!!a.c && !a.d) {
                                    a.g = true;
                                    if (a.b == (Cmd(), ymd)) {
                                        d = a.c.e.b + a.c.f.b + a.e * (f + 1);
                                        b = new rjd(Kfb(UD(mQb(a.c, (q$c(), e$c)))) + a.e, d);
                                        c = new rjd(Kfb(UD(mQb(a.c, f$c))) - a.e, d);
                                    } else if (a.b == zmd) {
                                        d = a.c.e.b + a.c.f.b + a.e * (f + 1);
                                        b = new rjd(Kfb(UD(mQb(a.c, (q$c(), f$c)))) - a.e, d);
                                        c = new rjd(Kfb(UD(mQb(a.c, e$c))) + a.e, d);
                                    } else if (a.b == Bmd) {
                                        d = a.c.e.a + a.c.f.a + a.e * (f + 1);
                                        b = new rjd(d, Kfb(UD(mQb(a.c, (q$c(), e$c)))) + a.e);
                                        c = new rjd(d, Kfb(UD(mQb(a.c, f$c))) - a.e);
                                    } else {
                                        d = a.c.e.a + a.c.f.a + a.e * (f + 1);
                                        b = new rjd(d, Kfb(UD(mQb(a.c, (q$c(), f$c)))) - a.e);
                                        c = new rjd(d, Kfb(UD(mQb(a.c, e$c))) + a.e);
                                    }
                                } else if (!!a.c && !!a.d) {
                                    if (a.b == (Cmd(), ymd)) {
                                        d = a.d.e.b * g + (a.c.e.b + a.c.f.b) * (1 - g);
                                        b = new rjd(Kfb(UD(mQb(a.c, (q$c(), e$c)))) + a.e, d);
                                        c = new rjd(Kfb(UD(mQb(a.c, f$c))) - a.e, d);
                                    } else if (a.b == zmd) {
                                        d = a.d.e.b * g + (a.c.e.b + a.c.f.b) * (1 - g);
                                        b = new rjd(Kfb(UD(mQb(a.c, (q$c(), f$c)))) - a.e, d);
                                        c = new rjd(Kfb(UD(mQb(a.c, e$c))) + a.e, d);
                                    } else if (a.b == Bmd) {
                                        d = a.d.e.a * g + (a.c.e.a + a.c.f.a) * (1 - g);
                                        b = new rjd(d, Kfb(UD(mQb(a.c, (q$c(), e$c)))) + a.e);
                                        c = new rjd(d, Kfb(UD(mQb(a.c, f$c))) - a.e);
                                    } else {
                                        d = a.d.e.a * g + (a.c.e.a + a.c.f.a) * (1 - g);
                                        b = new rjd(d, Kfb(UD(mQb(a.c, (q$c(), f$c)))) - a.e);
                                        c = new rjd(d, Kfb(UD(mQb(a.c, e$c))) + a.e);
                                    }
                                } else {
                                    a.f = true;
                                    if (a.b == (Cmd(), ymd)) {
                                        d = a.d.e.b - a.e * (f + 1);
                                        b = new rjd(Kfb(UD(mQb(a.d, (q$c(), e$c)))) + a.e, d);
                                        c = new rjd(Kfb(UD(mQb(a.d, f$c))) - a.e, d);
                                    } else if (a.b == zmd) {
                                        d = a.d.e.b - a.e * (f + 1);
                                        b = new rjd(Kfb(UD(mQb(a.d, (q$c(), f$c)))) - a.e, d);
                                        c = new rjd(Kfb(UD(mQb(a.d, e$c))) + a.e, d);
                                    } else if (a.b == Bmd) {
                                        d = a.d.e.a - a.e * (f + 1);
                                        b = new rjd(d, Kfb(UD(mQb(a.d, (q$c(), e$c)))) + a.e);
                                        c = new rjd(d, Kfb(UD(mQb(a.d, f$c))) - a.e);
                                    } else {
                                        d = a.d.e.a - a.e * (f + 1);
                                        b = new rjd(d, Kfb(UD(mQb(a.d, (q$c(), f$c)))) - a.e);
                                        c = new rjd(d, Kfb(UD(mQb(a.d, e$c))) + a.e);
                                    }
                                }
                                RD(h.a, 8).a = b.a;
                                RD(h.a, 8).b = b.b;
                                h.b.a = c.a;
                                h.b.b = c.b;
                                ++f;
                            }
                        }
                        function LA(a, b, c, d, e, f) {
                            var g, h, i, j, k, l, m, n, o, p, q, r;
                            switch(b){
                                case 71:
                                    h = d.q.getFullYear() - Owe >= -1900 ? 1 : 0;
                                    c >= 4 ? Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        Qwe,
                                        Rwe
                                    ])[h]) : Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        'BC',
                                        'AD'
                                    ])[h]);
                                    break;
                                case 121:
                                    AA(a, c, d);
                                    break;
                                case 77:
                                    zA(a, c, d);
                                    break;
                                case 107:
                                    i = e.q.getHours();
                                    i == 0 ? UA(a, 24, c) : UA(a, i, c);
                                    break;
                                case 83:
                                    yA(a, c, e);
                                    break;
                                case 69:
                                    k = d.q.getDay();
                                    c == 5 ? Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        'S',
                                        'M',
                                        'T',
                                        'W',
                                        'T',
                                        'F',
                                        'S'
                                    ])[k]) : c == 4 ? Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        Swe,
                                        Twe,
                                        Uwe,
                                        Vwe,
                                        Wwe,
                                        Xwe,
                                        Ywe
                                    ])[k]) : Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        'Sun',
                                        'Mon',
                                        'Tue',
                                        'Wed',
                                        'Thu',
                                        'Fri',
                                        'Sat'
                                    ])[k]);
                                    break;
                                case 97:
                                    e.q.getHours() >= 12 && e.q.getHours() < 24 ? Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        'AM',
                                        'PM'
                                    ])[1]) : Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        'AM',
                                        'PM'
                                    ])[0]);
                                    break;
                                case 104:
                                    l = e.q.getHours() % 12;
                                    l == 0 ? UA(a, 12, c) : UA(a, l, c);
                                    break;
                                case 75:
                                    m = e.q.getHours() % 12;
                                    UA(a, m, c);
                                    break;
                                case 72:
                                    n = e.q.getHours();
                                    UA(a, n, c);
                                    break;
                                case 99:
                                    o = d.q.getDay();
                                    c == 5 ? Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        'S',
                                        'M',
                                        'T',
                                        'W',
                                        'T',
                                        'F',
                                        'S'
                                    ])[o]) : c == 4 ? Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        Swe,
                                        Twe,
                                        Uwe,
                                        Vwe,
                                        Wwe,
                                        Xwe,
                                        Ywe
                                    ])[o]) : c == 3 ? Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        'Sun',
                                        'Mon',
                                        'Tue',
                                        'Wed',
                                        'Thu',
                                        'Fri',
                                        'Sat'
                                    ])[o]) : UA(a, o, 1);
                                    break;
                                case 76:
                                    p = d.q.getMonth();
                                    c == 5 ? Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        'J',
                                        'F',
                                        'M',
                                        'A',
                                        'M',
                                        'J',
                                        'J',
                                        'A',
                                        'S',
                                        'O',
                                        'N',
                                        'D'
                                    ])[p]) : c == 4 ? Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        Cwe,
                                        Dwe,
                                        Ewe,
                                        Fwe,
                                        Gwe,
                                        Hwe,
                                        Iwe,
                                        Jwe,
                                        Kwe,
                                        Lwe,
                                        Mwe,
                                        Nwe
                                    ])[p]) : c == 3 ? Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        'Jan',
                                        'Feb',
                                        'Mar',
                                        'Apr',
                                        Gwe,
                                        'Jun',
                                        'Jul',
                                        'Aug',
                                        'Sep',
                                        'Oct',
                                        'Nov',
                                        'Dec'
                                    ])[p]) : UA(a, p + 1, c);
                                    break;
                                case 81:
                                    q = d.q.getMonth() / 3 | 0;
                                    c < 4 ? Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        'Q1',
                                        'Q2',
                                        'Q3',
                                        'Q4'
                                    ])[q]) : Zhb(a, cD(WC(qJ, 1), Nve, 2, 6, [
                                        '1st quarter',
                                        '2nd quarter',
                                        '3rd quarter',
                                        '4th quarter'
                                    ])[q]);
                                    break;
                                case 100:
                                    r = d.q.getDate();
                                    UA(a, r, c);
                                    break;
                                case 109:
                                    j = e.q.getMinutes();
                                    UA(a, j, c);
                                    break;
                                case 115:
                                    g = e.q.getSeconds();
                                    UA(a, g, c);
                                    break;
                                case 122:
                                    c < 4 ? Zhb(a, f.c[0]) : Zhb(a, f.c[1]);
                                    break;
                                case 118:
                                    Zhb(a, f.b);
                                    break;
                                case 90:
                                    c < 3 ? Zhb(a, cB(f)) : c == 3 ? Zhb(a, bB(f)) : Zhb(a, eB(f.a));
                                    break;
                                default:
                                    return false;
                            }
                            return true;
                        }
                        function f5b(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H;
                            X4b(b);
                            i = RD(QHd((!b.b && (b.b = new Yie(E4, b, 4, 7)), b.b), 0), 84);
                            k = RD(QHd((!b.c && (b.c = new Yie(E4, b, 5, 8)), b.c), 0), 84);
                            h = AGd(i);
                            j = AGd(k);
                            g = (!b.a && (b.a = new C5d(F4, b, 6, 6)), b.a).i == 0 ? null : RD(QHd((!b.a && (b.a = new C5d(F4, b, 6, 6)), b.a), 0), 166);
                            A = RD(Wjb(a.a, h), 10);
                            F = RD(Wjb(a.a, j), 10);
                            B = null;
                            G = null;
                            if (ZD(i, 193)) {
                                w = RD(Wjb(a.a, i), 305);
                                if (ZD(w, 12)) B = RD(w, 12);
                                else if (ZD(w, 10)) {
                                    A = RD(w, 10);
                                    B = RD(Vmb(A.j, 0), 12);
                                }
                            }
                            if (ZD(k, 193)) {
                                D = RD(Wjb(a.a, k), 305);
                                if (ZD(D, 12)) G = RD(D, 12);
                                else if (ZD(D, 10)) {
                                    F = RD(D, 10);
                                    G = RD(Vmb(F.j, 0), 12);
                                }
                            }
                            if (!A || !F) throw Adb(new Ked('The source or the target of edge ' + b + ' could not be found. ' + 'This usually happens when an edge connects a node laid out by ELK Layered to a node in ' + 'another level of hierarchy laid out by either another instance of ELK Layered or another ' + 'layout algorithm alltogether. The former can be solved by setting the hierarchyHandling ' + 'option to INCLUDE_CHILDREN.'));
                            p = new a1b;
                            kQb(p, b);
                            pQb(p, (Ywc(), Awc), b);
                            pQb(p, (yCc(), RAc), null);
                            n = RD(mQb(d, kwc), 21);
                            A == F && n.Fc((ovc(), nvc));
                            if (!B) {
                                v = (BEc(), zEc);
                                C = null;
                                if (!!g && Dod(RD(mQb(A, BBc), 101))) {
                                    C = new rjd(g.j, g.k);
                                    Fsd(C, kzd(b));
                                    Gsd(C, c);
                                    if (NGd(j, h)) {
                                        v = yEc;
                                        $id(C, A.n);
                                    }
                                }
                                B = g2b(A, C, v, d);
                            }
                            if (!G) {
                                v = (BEc(), yEc);
                                H = null;
                                if (!!g && Dod(RD(mQb(F, BBc), 101))) {
                                    H = new rjd(g.b, g.c);
                                    Fsd(H, kzd(b));
                                    Gsd(H, c);
                                }
                                G = g2b(F, H, v, Y2b(F));
                            }
                            Y0b(p, B);
                            Z0b(p, G);
                            (B.e.c.length > 1 || B.g.c.length > 1 || G.e.c.length > 1 || G.g.c.length > 1) && n.Fc((ovc(), ivc));
                            for(m = new dMd((!b.n && (b.n = new C5d(I4, b, 1, 7)), b.n)); m.e != m.i.gc();){
                                l = RD(bMd(m), 135);
                                if (!Heb(TD(Gxd(l, pBc))) && !!l.a) {
                                    q = h5b(l);
                                    Rmb(p.b, q);
                                    switch(RD(mQb(q, wAc), 278).g){
                                        case 1:
                                        case 2:
                                            n.Fc((ovc(), gvc));
                                            break;
                                        case 0:
                                            n.Fc((ovc(), evc));
                                            pQb(q, wAc, (Omd(), Lmd));
                                    }
                                }
                            }
                            f = RD(mQb(d, oAc), 322);
                            r = RD(mQb(d, kBc), 323);
                            e = f == (stc(), ptc) || r == (JDc(), FDc);
                            if (!!g && (!g.a && (g.a = new XZd(D4, g, 5)), g.a).i != 0 && e) {
                                s = ssd(g);
                                o = new Ejd;
                                for(u = Sub(s, 0); u.b != u.d.c;){
                                    t = RD(evb(u), 8);
                                    Mub(o, new sjd(t));
                                }
                                pQb(p, Bwc, o);
                            }
                            return p;
                        }
                        function F0c(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
                            C = 0;
                            D = 0;
                            A = new Tsb;
                            v = RD(Lvb(JDb(GDb(new SDb(null, new Swb(a.b, 16)), new v1c), new Z0c)), 17).a + 1;
                            B = $C(kE, Pwe, 28, v, 15, 1);
                            q = $C(kE, Pwe, 28, v, 15, 1);
                            for(p = 0; p < v; p++){
                                B[p] = 0;
                                q[p] = 0;
                            }
                            i = RD(zDb(BDb(new SDb(null, new Swb(a.a, 16))), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                (xBb(), vBb)
                            ]))), 15);
                            for(k = i.Kc(); k.Ob();){
                                j = RD(k.Pb(), 65);
                                G = RD(mQb(j.b, (h_c(), f_c)), 17).a;
                                I = RD(mQb(j.c, f_c), 17).a;
                                u = I - G;
                                if (u > 1) for(h = G + 1; h < I; h++){
                                    l = h;
                                    w = RD(zDb(CDb(new SDb(null, new Swb(a.b, 16)), new P1c(l)), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                        vBb
                                    ]))), 15);
                                    o = 0;
                                    if (b == (Cmd(), ymd) || b == zmd) {
                                        w.jd(new V1c);
                                        for(o = 0; o < w.gc(); o++){
                                            r = (h - G) / (I - G);
                                            if (RD(w.Xb(o), 40).e.b > j.b.e.b * (1 - r) + j.c.e.b * r) break;
                                        }
                                        if (w.gc() > 0) {
                                            H = j.a.b == 0 ? ajd(j.b.e) : RD(Rub(j.a), 8);
                                            t = $id(ajd(RD(w.Xb(w.gc() - 1), 40).e), RD(w.Xb(w.gc() - 1), 40).f);
                                            m = $id(ajd(RD(w.Xb(0), 40).e), RD(w.Xb(0), 40).f);
                                            if (o >= w.gc() - 1 && H.b > t.b && j.c.e.b > t.b) continue;
                                            if (o <= 0 && H.b < m.a && j.c.e.b < m.b) continue;
                                        }
                                    } else {
                                        w.jd(new Z1c);
                                        for(o = 0; o < w.gc(); o++){
                                            r = (h - G) / (I - G);
                                            if (RD(w.Xb(o), 40).e.a > j.b.e.a * (1 - r) + j.c.e.a * r) break;
                                        }
                                        if (w.gc() > 0) {
                                            H = j.a.b == 0 ? ajd(j.b.e) : RD(Rub(j.a), 8);
                                            t = $id(ajd(RD(w.Xb(w.gc() - 1), 40).e), RD(w.Xb(w.gc() - 1), 40).f);
                                            m = $id(ajd(RD(w.Xb(0), 40).e), RD(w.Xb(0), 40).f);
                                            if (o >= w.gc() - 1 && H.a > t.a && j.c.e.a > t.a) continue;
                                            if (o <= 0 && H.a < m.a && j.c.e.a < m.a) continue;
                                        }
                                    }
                                    e = new pjd;
                                    f = new pjd;
                                    Mub(j.a, e);
                                    Mub(j.a, f);
                                    g = new gud(e, f, j);
                                    s = Rdb(Sdb(h, 32), Cdb(o, yxe));
                                    if (Ujb(A, Hgb(s))) {
                                        n = RD(Wjb(A, Hgb(s)), 675);
                                        Mub(n.a, g);
                                        Dmd(n.b) ? tvb(n.a, new l2c) : tvb(n.a, new p2c);
                                        h2c(n);
                                    } else {
                                        n = new i2c(o == 0 ? null : RD(w.Xb(o - 1), 40), o == w.gc() ? null : RD(w.Xb(o), 40), g, a);
                                        Zjb(A, Hgb(s), n);
                                    }
                                    if (b == ymd || b == zmd) {
                                        n.f && n.d.e.b <= Kfb(UD(mQb(a, (q$c(), _Zc)))) && ++C;
                                        n.g && n.c.e.b + n.c.f.b >= Kfb(UD(mQb(a, (q$c(), $Zc)))) && ++D;
                                    } else {
                                        n.f && n.d.e.a <= Kfb(UD(mQb(a, (q$c(), ZZc)))) && ++C;
                                        n.g && n.c.e.a + n.c.f.a >= Kfb(UD(mQb(a, (q$c(), YZc)))) && ++D;
                                    }
                                }
                                else if (u == 0) H0c(j);
                                else if (u < 0) {
                                    ++B[G];
                                    ++q[I];
                                    F = C0c(j, b, a, new Ptd(sgb(C), sgb(D)), c, d, new Ptd(sgb(q[I]), sgb(B[G])));
                                    C = RD(F.a, 17).a;
                                    D = RD(F.b, 17).a;
                                }
                            }
                        }
                        function qrc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
                            d = b;
                            i = c;
                            if (a.b && d.j == (qpd(), ppd) && i.j == (qpd(), ppd)) {
                                s = d;
                                d = i;
                                i = s;
                            }
                            if (Ujb(a.a, d)) {
                                if (Zsb(RD(Wjb(a.a, d), 49), i)) return 1;
                            } else Zjb(a.a, d, new _sb);
                            if (Ujb(a.a, i)) {
                                if (Zsb(RD(Wjb(a.a, i), 49), d)) return -1;
                            } else Zjb(a.a, i, new _sb);
                            if (Ujb(a.d, d)) {
                                if (Zsb(RD(Wjb(a.d, d), 49), i)) return -1;
                            } else Zjb(a.d, d, new _sb);
                            if (Ujb(a.d, i)) {
                                if (Zsb(RD(Wjb(a.a, i), 49), d)) return 1;
                            } else Zjb(a.d, i, new _sb);
                            if (d.j != i.j) {
                                r = yrc(d.j, i.j);
                                r == -1 ? rrc(a, i, d) : rrc(a, d, i);
                                return r;
                            }
                            if (d.e.c.length != 0 && i.e.c.length != 0) {
                                if (a.b) {
                                    r = orc(d, i);
                                    if (r != 0) {
                                        r == -1 ? rrc(a, i, d) : r == 1 && rrc(a, d, i);
                                        return r;
                                    }
                                }
                                f = RD(Vmb(d.e, 0), 18).c.i;
                                k = RD(Vmb(i.e, 0), 18).c.i;
                                if (f == k) {
                                    e = RD(mQb(RD(Vmb(d.e, 0), 18), (Ywc(), zwc)), 17).a;
                                    j = RD(mQb(RD(Vmb(i.e, 0), 18), zwc), 17).a;
                                    e > j ? rrc(a, d, i) : rrc(a, i, d);
                                    return e < j ? -1 : e > j ? 1 : 0;
                                }
                                for(o = a.c, p = 0, q = o.length; p < q; ++p){
                                    n = o[p];
                                    if (n == f) {
                                        rrc(a, d, i);
                                        return 1;
                                    } else if (n == k) {
                                        rrc(a, i, d);
                                        return -1;
                                    }
                                }
                            }
                            if (d.g.c.length != 0 && i.g.c.length != 0) {
                                h = RD(mQb(d, (Ywc(), xwc)), 10);
                                m = RD(mQb(i, xwc), 10);
                                if (a.e == (kEc(), jEc) && !!h && !!m && nQb(h, zwc) && nQb(m, zwc)) {
                                    e = RD(mQb(h, zwc), 17).a;
                                    j = RD(mQb(m, zwc), 17).a;
                                    e > j ? rrc(a, d, i) : rrc(a, i, d);
                                    return e < j ? -1 : e > j ? 1 : 0;
                                }
                                if (a.b) {
                                    r = orc(d, i);
                                    if (r != 0) {
                                        r == -1 ? rrc(a, i, d) : r == 1 && rrc(a, d, i);
                                        return r;
                                    }
                                }
                                g = 0;
                                l = 0;
                                nQb(RD(Vmb(d.g, 0), 18), zwc) && (g = RD(mQb(RD(Vmb(d.g, 0), 18), zwc), 17).a);
                                nQb(RD(Vmb(i.g, 0), 18), zwc) && (l = RD(mQb(RD(Vmb(d.g, 0), 18), zwc), 17).a);
                                if (!!h && h == m) {
                                    if (Heb(TD(mQb(RD(Vmb(d.g, 0), 18), Nwc))) && !Heb(TD(mQb(RD(Vmb(i.g, 0), 18), Nwc)))) {
                                        rrc(a, d, i);
                                        return 1;
                                    } else if (!Heb(TD(mQb(RD(Vmb(d.g, 0), 18), Nwc))) && Heb(TD(mQb(RD(Vmb(i.g, 0), 18), Nwc)))) {
                                        rrc(a, i, d);
                                        return -1;
                                    }
                                    g > l ? rrc(a, d, i) : rrc(a, i, d);
                                    return g < l ? -1 : g > l ? 1 : 0;
                                }
                                if (a.f) {
                                    a.f._b(h) && (g = RD(a.f.xc(h), 17).a);
                                    a.f._b(m) && (l = RD(a.f.xc(m), 17).a);
                                }
                                g > l ? rrc(a, d, i) : rrc(a, i, d);
                                return g < l ? -1 : g > l ? 1 : 0;
                            }
                            if (d.e.c.length != 0 && i.g.c.length != 0) {
                                rrc(a, d, i);
                                return 1;
                            } else if (d.g.c.length != 0 && i.e.c.length != 0) {
                                rrc(a, i, d);
                                return -1;
                            } else if (nQb(d, (Ywc(), zwc)) && nQb(i, zwc)) {
                                e = RD(mQb(d, zwc), 17).a;
                                j = RD(mQb(i, zwc), 17).a;
                                e > j ? rrc(a, d, i) : rrc(a, i, d);
                                return e < j ? -1 : e > j ? 1 : 0;
                            } else {
                                rrc(a, i, d);
                                return -1;
                            }
                        }
                        function Yae(a) {
                            if (a.gb) return;
                            a.gb = true;
                            a.b = jBd(a, 0);
                            iBd(a.b, 18);
                            oBd(a.b, 19);
                            a.a = jBd(a, 1);
                            iBd(a.a, 1);
                            oBd(a.a, 2);
                            oBd(a.a, 3);
                            oBd(a.a, 4);
                            oBd(a.a, 5);
                            a.o = jBd(a, 2);
                            iBd(a.o, 8);
                            iBd(a.o, 9);
                            oBd(a.o, 10);
                            oBd(a.o, 11);
                            oBd(a.o, 12);
                            oBd(a.o, 13);
                            oBd(a.o, 14);
                            oBd(a.o, 15);
                            oBd(a.o, 16);
                            oBd(a.o, 17);
                            oBd(a.o, 18);
                            oBd(a.o, 19);
                            oBd(a.o, 20);
                            oBd(a.o, 21);
                            oBd(a.o, 22);
                            oBd(a.o, 23);
                            nBd(a.o);
                            nBd(a.o);
                            nBd(a.o);
                            nBd(a.o);
                            nBd(a.o);
                            nBd(a.o);
                            nBd(a.o);
                            nBd(a.o);
                            nBd(a.o);
                            nBd(a.o);
                            a.p = jBd(a, 3);
                            iBd(a.p, 2);
                            iBd(a.p, 3);
                            iBd(a.p, 4);
                            iBd(a.p, 5);
                            oBd(a.p, 6);
                            oBd(a.p, 7);
                            nBd(a.p);
                            nBd(a.p);
                            a.q = jBd(a, 4);
                            iBd(a.q, 8);
                            a.v = jBd(a, 5);
                            oBd(a.v, 9);
                            nBd(a.v);
                            nBd(a.v);
                            nBd(a.v);
                            a.w = jBd(a, 6);
                            iBd(a.w, 2);
                            iBd(a.w, 3);
                            iBd(a.w, 4);
                            oBd(a.w, 5);
                            a.B = jBd(a, 7);
                            oBd(a.B, 1);
                            nBd(a.B);
                            nBd(a.B);
                            nBd(a.B);
                            a.Q = jBd(a, 8);
                            oBd(a.Q, 0);
                            nBd(a.Q);
                            a.R = jBd(a, 9);
                            iBd(a.R, 1);
                            a.S = jBd(a, 10);
                            nBd(a.S);
                            nBd(a.S);
                            nBd(a.S);
                            nBd(a.S);
                            nBd(a.S);
                            nBd(a.S);
                            nBd(a.S);
                            nBd(a.S);
                            nBd(a.S);
                            nBd(a.S);
                            nBd(a.S);
                            nBd(a.S);
                            nBd(a.S);
                            nBd(a.S);
                            nBd(a.S);
                            a.T = jBd(a, 11);
                            oBd(a.T, 10);
                            oBd(a.T, 11);
                            oBd(a.T, 12);
                            oBd(a.T, 13);
                            oBd(a.T, 14);
                            nBd(a.T);
                            nBd(a.T);
                            a.U = jBd(a, 12);
                            iBd(a.U, 2);
                            iBd(a.U, 3);
                            oBd(a.U, 4);
                            oBd(a.U, 5);
                            oBd(a.U, 6);
                            oBd(a.U, 7);
                            nBd(a.U);
                            a.V = jBd(a, 13);
                            oBd(a.V, 10);
                            a.W = jBd(a, 14);
                            iBd(a.W, 18);
                            iBd(a.W, 19);
                            iBd(a.W, 20);
                            oBd(a.W, 21);
                            oBd(a.W, 22);
                            oBd(a.W, 23);
                            a.bb = jBd(a, 15);
                            iBd(a.bb, 10);
                            iBd(a.bb, 11);
                            iBd(a.bb, 12);
                            iBd(a.bb, 13);
                            iBd(a.bb, 14);
                            iBd(a.bb, 15);
                            iBd(a.bb, 16);
                            oBd(a.bb, 17);
                            nBd(a.bb);
                            nBd(a.bb);
                            a.eb = jBd(a, 16);
                            iBd(a.eb, 2);
                            iBd(a.eb, 3);
                            iBd(a.eb, 4);
                            iBd(a.eb, 5);
                            iBd(a.eb, 6);
                            iBd(a.eb, 7);
                            oBd(a.eb, 8);
                            oBd(a.eb, 9);
                            a.ab = jBd(a, 17);
                            iBd(a.ab, 0);
                            iBd(a.ab, 1);
                            a.H = jBd(a, 18);
                            oBd(a.H, 0);
                            oBd(a.H, 1);
                            oBd(a.H, 2);
                            oBd(a.H, 3);
                            oBd(a.H, 4);
                            oBd(a.H, 5);
                            nBd(a.H);
                            a.db = jBd(a, 19);
                            oBd(a.db, 2);
                            a.c = kBd(a, 20);
                            a.d = kBd(a, 21);
                            a.e = kBd(a, 22);
                            a.f = kBd(a, 23);
                            a.i = kBd(a, 24);
                            a.g = kBd(a, 25);
                            a.j = kBd(a, 26);
                            a.k = kBd(a, 27);
                            a.n = kBd(a, 28);
                            a.r = kBd(a, 29);
                            a.s = kBd(a, 30);
                            a.t = kBd(a, 31);
                            a.u = kBd(a, 32);
                            a.fb = kBd(a, 33);
                            a.A = kBd(a, 34);
                            a.C = kBd(a, 35);
                            a.D = kBd(a, 36);
                            a.F = kBd(a, 37);
                            a.G = kBd(a, 38);
                            a.I = kBd(a, 39);
                            a.J = kBd(a, 40);
                            a.L = kBd(a, 41);
                            a.M = kBd(a, 42);
                            a.N = kBd(a, 43);
                            a.O = kBd(a, 44);
                            a.P = kBd(a, 45);
                            a.X = kBd(a, 46);
                            a.Y = kBd(a, 47);
                            a.Z = kBd(a, 48);
                            a.$ = kBd(a, 49);
                            a._ = kBd(a, 50);
                            a.cb = kBd(a, 51);
                            a.K = kBd(a, 52);
                        }
                        function d5b(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
                            g = new Yub;
                            w = RD(mQb(c, (yCc(), rAc)), 88);
                            p = 0;
                            ye(g, (!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a));
                            while(g.b != 0){
                                k = RD(g.b == 0 ? null : (sFb(g.b != 0), Wub(g, g.a.a)), 27);
                                j = vCd(k);
                                (dE(Gxd(j, cAc)) !== dE((kEc(), hEc)) || dE(Gxd(j, pAc)) === dE((Ptc(), Otc)) || dE(Gxd(j, pAc)) === dE((Ptc(), Mtc)) || Heb(TD(Gxd(j, eAc))) || dE(Gxd(j, Yzc)) !== dE((U$b(), T$b)) || dE(Gxd(j, ZAc)) === dE((aEc(), TDc)) || dE(Gxd(j, ZAc)) === dE((aEc(), UDc)) || dE(Gxd(j, $Ac)) === dE((_Cc(), SCc)) || dE(Gxd(j, $Ac)) === dE((_Cc(), UCc))) && !Heb(TD(Gxd(k, aAc))) && Ixd(k, (Ywc(), zwc), sgb(p++));
                                r = !Heb(TD(Gxd(k, pBc)));
                                if (r) {
                                    m = (!k.a && (k.a = new C5d(J4, k, 10, 11)), k.a).i != 0;
                                    o = a5b(k);
                                    n = dE(Gxd(k, IAc)) === dE((Fnd(), Cnd));
                                    G = !Hxd(k, (umd(), Akd)) || khb(WD(Gxd(k, Akd)));
                                    u = null;
                                    if (G && n && (m || o)) {
                                        u = Z4b(k);
                                        pQb(u, rAc, w);
                                        nQb(u, PBc) && HCc(new RCc(Kfb(UD(mQb(u, PBc)))), u);
                                        if (RD(Gxd(k, lBc), 181).gc() != 0) {
                                            l = u;
                                            FDb(new SDb(null, (!k.c && (k.c = new C5d(K4, k, 9, 9)), new Swb(k.c, 16))), new u5b(l));
                                            V4b(k, u);
                                        }
                                    }
                                    A = c;
                                    B = RD(Wjb(a.a, vCd(k)), 10);
                                    !!B && (A = B.e);
                                    t = i5b(a, k, A);
                                    if (u) {
                                        t.e = u;
                                        u.e = t;
                                        ye(g, (!k.a && (k.a = new C5d(J4, k, 10, 11)), k.a));
                                    }
                                }
                            }
                            p = 0;
                            Pub(g, b, g.c.b, g.c);
                            while(g.b != 0){
                                f = RD(g.b == 0 ? null : (sFb(g.b != 0), Wub(g, g.a.a)), 27);
                                for(i = new dMd((!f.b && (f.b = new C5d(G4, f, 12, 3)), f.b)); i.e != i.i.gc();){
                                    h = RD(bMd(i), 74);
                                    X4b(h);
                                    (dE(Gxd(b, cAc)) !== dE((kEc(), hEc)) || dE(Gxd(b, pAc)) === dE((Ptc(), Otc)) || dE(Gxd(b, pAc)) === dE((Ptc(), Mtc)) || Heb(TD(Gxd(b, eAc))) || dE(Gxd(b, Yzc)) !== dE((U$b(), T$b)) || dE(Gxd(b, ZAc)) === dE((aEc(), TDc)) || dE(Gxd(b, ZAc)) === dE((aEc(), UDc)) || dE(Gxd(b, $Ac)) === dE((_Cc(), SCc)) || dE(Gxd(b, $Ac)) === dE((_Cc(), UCc))) && Ixd(h, (Ywc(), zwc), sgb(p++));
                                    D = AGd(RD(QHd((!h.b && (h.b = new Yie(E4, h, 4, 7)), h.b), 0), 84));
                                    F = AGd(RD(QHd((!h.c && (h.c = new Yie(E4, h, 5, 8)), h.c), 0), 84));
                                    if (Heb(TD(Gxd(h, pBc))) || Heb(TD(Gxd(D, pBc))) || Heb(TD(Gxd(F, pBc)))) continue;
                                    q = ozd(h) && Heb(TD(Gxd(D, NAc))) && Heb(TD(Gxd(h, OAc)));
                                    v = f;
                                    q || NGd(F, D) ? v = D : NGd(D, F) && (v = F);
                                    A = c;
                                    B = RD(Wjb(a.a, v), 10);
                                    !!B && (A = B.e);
                                    s = f5b(a, h, v, A);
                                    pQb(s, (Ywc(), Zvc), _4b(a, h, b, c));
                                }
                                n = dE(Gxd(f, IAc)) === dE((Fnd(), Cnd));
                                if (n) for(e = new dMd((!f.a && (f.a = new C5d(J4, f, 10, 11)), f.a)); e.e != e.i.gc();){
                                    d = RD(bMd(e), 27);
                                    G = !Hxd(d, (umd(), Akd)) || khb(WD(Gxd(d, Akd)));
                                    C = dE(Gxd(d, IAc)) === dE(Cnd);
                                    G && C && Pub(g, d, g.c.b, g.c);
                                }
                            }
                        }
                        function Ywc() {
                            Ywc = geb;
                            var a, b;
                            Awc = new jGd(rAe);
                            Zvc = new jGd('coordinateOrigin');
                            Kwc = new jGd('processors');
                            Yvc = new kGd('compoundNode', (Geb(), false));
                            nwc = new kGd('insideConnections', false);
                            Bwc = new jGd('originalBendpoints');
                            Cwc = new jGd('originalDummyNodePosition');
                            Dwc = new jGd('originalLabelEdge');
                            Mwc = new jGd('representedLabels');
                            cwc = new jGd('endLabels');
                            dwc = new jGd('endLabel.origin');
                            swc = new kGd('labelSide', (Pnd(), Ond));
                            ywc = new kGd('maxEdgeThickness', 0);
                            Nwc = new kGd('reversed', false);
                            Lwc = new jGd(sAe);
                            vwc = new kGd('longEdgeSource', null);
                            wwc = new kGd('longEdgeTarget', null);
                            uwc = new kGd('longEdgeHasLabelDummies', false);
                            twc = new kGd('longEdgeBeforeLabelDummy', false);
                            bwc = new kGd('edgeConstraint', (huc(), fuc));
                            pwc = new jGd('inLayerLayoutUnit');
                            owc = new kGd('inLayerConstraint', (Gvc(), Evc));
                            qwc = new kGd('inLayerSuccessorConstraint', new bnb);
                            rwc = new kGd('inLayerSuccessorConstraintBetweenNonDummies', false);
                            Iwc = new jGd('portDummy');
                            $vc = new kGd('crossingHint', sgb(0));
                            kwc = new kGd('graphProperties', (b = RD(mfb(iX), 9), new Fsb(b, RD(WEb(b, b.length), 9), 0)));
                            hwc = new kGd('externalPortSide', (qpd(), opd));
                            iwc = new kGd('externalPortSize', new pjd);
                            fwc = new jGd('externalPortReplacedDummies');
                            gwc = new jGd('externalPortReplacedDummy');
                            ewc = new kGd('externalPortConnections', (a = RD(mfb(E3), 9), new Fsb(a, RD(WEb(a, a.length), 9), 0)));
                            Jwc = new kGd(Xye, 0);
                            Uvc = new jGd('barycenterAssociates');
                            Xwc = new jGd('TopSideComments');
                            Vvc = new jGd('BottomSideComments');
                            Xvc = new jGd('CommentConnectionPort');
                            mwc = new kGd('inputCollect', false);
                            Gwc = new kGd('outputCollect', false);
                            awc = new kGd('cyclic', false);
                            _vc = new jGd('crossHierarchyMap');
                            Wwc = new jGd('targetOffset');
                            new kGd('splineLabelSize', new pjd);
                            Qwc = new jGd('spacings');
                            Hwc = new kGd('partitionConstraint', false);
                            Wvc = new jGd('breakingPoint.info');
                            Uwc = new jGd('splines.survivingEdge');
                            Twc = new jGd('splines.route.start');
                            Rwc = new jGd('splines.edgeChain');
                            Fwc = new jGd('originalPortConstraints');
                            Pwc = new jGd('selfLoopHolder');
                            Swc = new jGd('splines.nsPortY');
                            zwc = new jGd('modelOrder');
                            xwc = new jGd('longEdgeTargetNode');
                            jwc = new kGd(GBe, false);
                            Owc = new kGd(GBe, false);
                            lwc = new jGd('layerConstraints.hiddenNodes');
                            Ewc = new jGd('layerConstraints.opposidePort');
                            Vwc = new jGd('targetNode.modelOrder');
                        }
                        function D0c(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o;
                            for(l = Sub(a.b, 0); l.b != l.d.c;){
                                k = RD(evb(l), 40);
                                if (lhb(k.c, IEe)) continue;
                                f = RD(zDb(new SDb(null, new Swb(hWc(k, a), 16)), tBb(new ZBb, new XBb, new wCb, cD(WC(QL, 1), jwe, 108, 0, [
                                    (xBb(), vBb)
                                ]))), 15);
                                b == (Cmd(), ymd) || b == zmd ? f.jd(new L1c) : f.jd(new R1c);
                                o = f.gc();
                                for(e = 0; e < o; e++){
                                    g = o == 1 ? 0.5 : (1 + e) / (o + 1);
                                    if (b == ymd) {
                                        j = Kfb(UD(mQb(k, (q$c(), e$c))));
                                        if (k.e.a + k.f.a + d < j) Oub(RD(f.Xb(e), 65).a, new rjd(j + c, k.e.b + k.f.b * g));
                                        else if (RD(f.Xb(e), 65).a.b > 0) {
                                            h = RD(Rub(RD(f.Xb(e), 65).a), 8).a;
                                            m = k.e.a + k.f.a / 2;
                                            i = RD(Rub(RD(f.Xb(e), 65).a), 8).b;
                                            n = k.e.b + k.f.b / 2;
                                            d > 0 && $wnd.Math.abs(i - n) / ($wnd.Math.abs(h - m) / 40) > 50 && (n > i ? Oub(RD(f.Xb(e), 65).a, new rjd(k.e.a + k.f.a + d / 5.3, k.e.b + k.f.b * g - d / 2)) : Oub(RD(f.Xb(e), 65).a, new rjd(k.e.a + k.f.a + d / 5.3, k.e.b + k.f.b * g + d / 2)));
                                        }
                                        Oub(RD(f.Xb(e), 65).a, new rjd(k.e.a + k.f.a, k.e.b + k.f.b * g));
                                    } else if (b == zmd) {
                                        j = Kfb(UD(mQb(k, (q$c(), f$c))));
                                        if (k.e.a - d > j) Oub(RD(f.Xb(e), 65).a, new rjd(j - c, k.e.b + k.f.b * g));
                                        else if (RD(f.Xb(e), 65).a.b > 0) {
                                            h = RD(Rub(RD(f.Xb(e), 65).a), 8).a;
                                            m = k.e.a + k.f.a / 2;
                                            i = RD(Rub(RD(f.Xb(e), 65).a), 8).b;
                                            n = k.e.b + k.f.b / 2;
                                            d > 0 && $wnd.Math.abs(i - n) / ($wnd.Math.abs(h - m) / 40) > 50 && (n > i ? Oub(RD(f.Xb(e), 65).a, new rjd(k.e.a - d / 5.3, k.e.b + k.f.b * g - d / 2)) : Oub(RD(f.Xb(e), 65).a, new rjd(k.e.a - d / 5.3, k.e.b + k.f.b * g + d / 2)));
                                        }
                                        Oub(RD(f.Xb(e), 65).a, new rjd(k.e.a, k.e.b + k.f.b * g));
                                    } else if (b == Bmd) {
                                        j = Kfb(UD(mQb(k, (q$c(), e$c))));
                                        if (k.e.b + k.f.b + d < j) Oub(RD(f.Xb(e), 65).a, new rjd(k.e.a + k.f.a * g, j + c));
                                        else if (RD(f.Xb(e), 65).a.b > 0) {
                                            h = RD(Rub(RD(f.Xb(e), 65).a), 8).a;
                                            m = k.e.a + k.f.a / 2;
                                            i = RD(Rub(RD(f.Xb(e), 65).a), 8).b;
                                            n = k.e.b + k.f.b / 2;
                                            d > 0 && $wnd.Math.abs(h - m) / ($wnd.Math.abs(i - n) / 40) > 50 && (m > h ? Oub(RD(f.Xb(e), 65).a, new rjd(k.e.a + k.f.a * g - d / 2, k.e.b + d / 5.3 + k.f.b)) : Oub(RD(f.Xb(e), 65).a, new rjd(k.e.a + k.f.a * g + d / 2, k.e.b + d / 5.3 + k.f.b)));
                                        }
                                        Oub(RD(f.Xb(e), 65).a, new rjd(k.e.a + k.f.a * g, k.e.b + k.f.b));
                                    } else {
                                        j = Kfb(UD(mQb(k, (q$c(), f$c))));
                                        if (mWc(RD(f.Xb(e), 65), a)) Oub(RD(f.Xb(e), 65).a, new rjd(k.e.a + k.f.a * g, RD(Rub(RD(f.Xb(e), 65).a), 8).b));
                                        else if (k.e.b - d > j) Oub(RD(f.Xb(e), 65).a, new rjd(k.e.a + k.f.a * g, j - c));
                                        else if (RD(f.Xb(e), 65).a.b > 0) {
                                            h = RD(Rub(RD(f.Xb(e), 65).a), 8).a;
                                            m = k.e.a + k.f.a / 2;
                                            i = RD(Rub(RD(f.Xb(e), 65).a), 8).b;
                                            n = k.e.b + k.f.b / 2;
                                            d > 0 && $wnd.Math.abs(h - m) / ($wnd.Math.abs(i - n) / 40) > 50 && (m > h ? Oub(RD(f.Xb(e), 65).a, new rjd(k.e.a + k.f.a * g - d / 2, k.e.b - d / 5.3)) : Oub(RD(f.Xb(e), 65).a, new rjd(k.e.a + k.f.a * g + d / 2, k.e.b - d / 5.3)));
                                        }
                                        Oub(RD(f.Xb(e), 65).a, new rjd(k.e.a + k.f.a * g, k.e.b));
                                    }
                                }
                            }
                        }
                        function umd() {
                            umd = geb;
                            var a, b;
                            Akd = new jGd(OGe);
                            Tld = new jGd(PGe);
                            Ckd = (Rjd(), Ljd);
                            Bkd = new lGd(MDe, Ckd);
                            new Xsd;
                            Dkd = new lGd(Dze, null);
                            Ekd = new jGd(QGe);
                            Lkd = (ukd(), ysb(tkd, cD(WC(q3, 1), jwe, 298, 0, [
                                pkd
                            ])));
                            Kkd = new lGd(YDe, Lkd);
                            Mkd = new lGd(LDe, (Geb(), false));
                            Okd = (Cmd(), Amd);
                            Nkd = new lGd(PDe, Okd);
                            Tkd = (Ymd(), Xmd);
                            Skd = new lGd(kDe, Tkd);
                            Wkd = new lGd(MGe, false);
                            Ykd = (Fnd(), Dnd);
                            Xkd = new lGd(fDe, Ykd);
                            uld = new A3b(12);
                            tld = new lGd(Eze, uld);
                            ald = new lGd(dAe, false);
                            bld = new lGd(iEe, false);
                            sld = new lGd(gAe, false);
                            Ild = (Bod(), Aod);
                            Hld = new lGd(eAe, Ild);
                            Qld = new jGd(fEe);
                            Rld = new jGd($ze);
                            Sld = new jGd(bAe);
                            Vld = new jGd(cAe);
                            dld = new Ejd;
                            cld = new lGd(ZDe, dld);
                            Jkd = new lGd(aEe, false);
                            Zkd = new lGd(bEe, false);
                            new jGd(RGe);
                            fld = new P2b;
                            eld = new lGd(gEe, fld);
                            rld = new lGd(JDe, false);
                            new Xsd;
                            Uld = new lGd(SGe, 1);
                            Ikd = new jGd(TGe);
                            Hkd = new jGd(UGe);
                            mmd = new lGd(mAe, false);
                            new lGd(VGe, true);
                            sgb(0);
                            new lGd(WGe, sgb(100));
                            new lGd(XGe, false);
                            sgb(0);
                            new lGd(YGe, sgb(4000));
                            sgb(0);
                            new lGd(ZGe, sgb(400));
                            new lGd($Ge, false);
                            new lGd(_Ge, false);
                            new lGd(aHe, true);
                            new lGd(bHe, false);
                            Gkd = (Grd(), Frd);
                            Fkd = new lGd(NGe, Gkd);
                            Wld = new lGd(xDe, 10);
                            Xld = new lGd(yDe, 10);
                            Yld = new lGd(Bze, 20);
                            Zld = new lGd(zDe, 10);
                            $ld = new lGd(aAe, 2);
                            _ld = new lGd(ADe, 10);
                            bmd = new lGd(BDe, 0);
                            cmd = new lGd(EDe, 5);
                            dmd = new lGd(CDe, 1);
                            emd = new lGd(DDe, 1);
                            fmd = new lGd(_ze, 20);
                            gmd = new lGd(FDe, 10);
                            jmd = new lGd(GDe, 10);
                            amd = new jGd(HDe);
                            imd = new Q2b;
                            hmd = new lGd(hEe, imd);
                            xld = new jGd(eEe);
                            wld = false;
                            vld = new lGd(dEe, wld);
                            hld = new A3b(5);
                            gld = new lGd(QDe, hld);
                            jld = (dod(), b = RD(mfb(A3), 9), new Fsb(b, RD(WEb(b, b.length), 9), 0));
                            ild = new lGd(kAe, jld);
                            Ald = (pod(), mod);
                            zld = new lGd(TDe, Ald);
                            Cld = new jGd(UDe);
                            Dld = new jGd(VDe);
                            Eld = new jGd(WDe);
                            Bld = new jGd(XDe);
                            lld = (a = RD(mfb(H3), 9), new Fsb(a, RD(WEb(a, a.length), 9), 0));
                            kld = new lGd(jAe, lld);
                            qld = xsb((dqd(), Ypd));
                            pld = new lGd(iAe, qld);
                            old = new rjd(0, 0);
                            nld = new lGd(CAe, old);
                            mld = new lGd(hAe, false);
                            Rkd = (Omd(), Lmd);
                            Qkd = new lGd($De, Rkd);
                            Pkd = new lGd(fAe, false);
                            new jGd(cHe);
                            sgb(1);
                            new lGd(dHe, null);
                            Fld = new jGd(cEe);
                            Jld = new jGd(_De);
                            Pld = (qpd(), opd);
                            Old = new lGd(KDe, Pld);
                            Gld = new jGd(IDe);
                            Mld = (Pod(), xsb(Nod));
                            Lld = new lGd(lAe, Mld);
                            Kld = new lGd(RDe, false);
                            Nld = new lGd(SDe, true);
                            new Xsd;
                            qmd = new lGd(nAe, 1);
                            smd = new lGd(eHe, null);
                            lmd = new lGd(oAe, 150);
                            kmd = new lGd(pAe, 1.414);
                            nmd = new lGd(qAe, null);
                            omd = new lGd(fHe, 1);
                            $kd = new lGd(NDe, false);
                            _kd = new lGd(ODe, false);
                            Ukd = new lGd(Cze, 1);
                            Vkd = (ind(), gnd);
                            new lGd(gHe, Vkd);
                            yld = true;
                            rmd = (mqd(), jqd);
                            tmd = jqd;
                            pmd = jqd;
                        }
                        function hcc() {
                            hcc = geb;
                            nbc = new icc('DIRECTION_PREPROCESSOR', 0);
                            kbc = new icc('COMMENT_PREPROCESSOR', 1);
                            obc = new icc('EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER', 2);
                            Ebc = new icc('INTERACTIVE_EXTERNAL_PORT_POSITIONER', 3);
                            Xbc = new icc('PARTITION_PREPROCESSOR', 4);
                            Ibc = new icc('LABEL_DUMMY_INSERTER', 5);
                            bcc = new icc('SELF_LOOP_PREPROCESSOR', 6);
                            Nbc = new icc('LAYER_CONSTRAINT_PREPROCESSOR', 7);
                            Vbc = new icc('PARTITION_MIDPROCESSOR', 8);
                            zbc = new icc('HIGH_DEGREE_NODE_LAYER_PROCESSOR', 9);
                            Rbc = new icc('NODE_PROMOTION', 10);
                            Mbc = new icc('LAYER_CONSTRAINT_POSTPROCESSOR', 11);
                            Wbc = new icc('PARTITION_POSTPROCESSOR', 12);
                            vbc = new icc('HIERARCHICAL_PORT_CONSTRAINT_PROCESSOR', 13);
                            dcc = new icc('SEMI_INTERACTIVE_CROSSMIN_PROCESSOR', 14);
                            ebc = new icc('BREAKING_POINT_INSERTER', 15);
                            Qbc = new icc('LONG_EDGE_SPLITTER', 16);
                            Zbc = new icc('PORT_SIDE_PROCESSOR', 17);
                            Fbc = new icc('INVERTED_PORT_PROCESSOR', 18);
                            Ybc = new icc('PORT_LIST_SORTER', 19);
                            fcc = new icc('SORT_BY_INPUT_ORDER_OF_MODEL', 20);
                            Tbc = new icc('NORTH_SOUTH_PORT_PREPROCESSOR', 21);
                            fbc = new icc('BREAKING_POINT_PROCESSOR', 22);
                            Ubc = new icc(jBe, 23);
                            gcc = new icc(kBe, 24);
                            _bc = new icc('SELF_LOOP_PORT_RESTORER', 25);
                            ecc = new icc('SINGLE_EDGE_GRAPH_WRAPPER', 26);
                            Gbc = new icc('IN_LAYER_CONSTRAINT_PROCESSOR', 27);
                            sbc = new icc('END_NODE_PORT_LABEL_MANAGEMENT_PROCESSOR', 28);
                            Hbc = new icc('LABEL_AND_NODE_SIZE_PROCESSOR', 29);
                            Dbc = new icc('INNERMOST_NODE_MARGIN_CALCULATOR', 30);
                            ccc = new icc('SELF_LOOP_ROUTER', 31);
                            ibc = new icc('COMMENT_NODE_MARGIN_CALCULATOR', 32);
                            qbc = new icc('END_LABEL_PREPROCESSOR', 33);
                            Kbc = new icc('LABEL_DUMMY_SWITCHER', 34);
                            hbc = new icc('CENTER_LABEL_MANAGEMENT_PROCESSOR', 35);
                            Lbc = new icc('LABEL_SIDE_SELECTOR', 36);
                            Bbc = new icc('HYPEREDGE_DUMMY_MERGER', 37);
                            wbc = new icc('HIERARCHICAL_PORT_DUMMY_SIZE_PROCESSOR', 38);
                            Obc = new icc('LAYER_SIZE_AND_GRAPH_HEIGHT_CALCULATOR', 39);
                            ybc = new icc('HIERARCHICAL_PORT_POSITION_PROCESSOR', 40);
                            lbc = new icc('CONSTRAINTS_POSTPROCESSOR', 41);
                            jbc = new icc('COMMENT_POSTPROCESSOR', 42);
                            Cbc = new icc('HYPERNODE_PROCESSOR', 43);
                            xbc = new icc('HIERARCHICAL_PORT_ORTHOGONAL_EDGE_ROUTER', 44);
                            Pbc = new icc('LONG_EDGE_JOINER', 45);
                            acc = new icc('SELF_LOOP_POSTPROCESSOR', 46);
                            gbc = new icc('BREAKING_POINT_REMOVER', 47);
                            Sbc = new icc('NORTH_SOUTH_PORT_POSTPROCESSOR', 48);
                            Abc = new icc('HORIZONTAL_COMPACTOR', 49);
                            Jbc = new icc('LABEL_DUMMY_REMOVER', 50);
                            tbc = new icc('FINAL_SPLINE_BENDPOINTS_CALCULATOR', 51);
                            rbc = new icc('END_LABEL_SORTER', 52);
                            $bc = new icc('REVERSED_EDGE_RESTORER', 53);
                            pbc = new icc('END_LABEL_POSTPROCESSOR', 54);
                            ubc = new icc('HIERARCHICAL_NODE_RESIZER', 55);
                            mbc = new icc('DIRECTION_POSTPROCESSOR', 56);
                        }
                        function Ozc() {
                            Ozc = geb;
                            Uxc = ($tc(), Ytc);
                            Txc = new lGd(HBe, Uxc);
                            jyc = new lGd(IBe, (Geb(), false));
                            pyc = (Ovc(), Mvc);
                            oyc = new lGd(JBe, pyc);
                            Hyc = new lGd(KBe, false);
                            Iyc = new lGd(LBe, true);
                            ixc = new lGd(MBe, false);
                            azc = (sEc(), qEc);
                            _yc = new lGd(NBe, azc);
                            sgb(1);
                            izc = new lGd(OBe, sgb(7));
                            jzc = new lGd(PBe, false);
                            kyc = new lGd(QBe, false);
                            Sxc = (Ptc(), Ltc);
                            Rxc = new lGd(RBe, Sxc);
                            Gyc = (_Cc(), ZCc);
                            Fyc = new lGd(SBe, Gyc);
                            wyc = (cxc(), bxc);
                            vyc = new lGd(TBe, wyc);
                            sgb(-1);
                            uyc = new lGd(UBe, null);
                            sgb(-1);
                            xyc = new lGd(VBe, sgb(-1));
                            sgb(-1);
                            yyc = new lGd(WBe, sgb(4));
                            sgb(-1);
                            Ayc = new lGd(XBe, sgb(2));
                            Eyc = (aEc(), $Dc);
                            Dyc = new lGd(YBe, Eyc);
                            sgb(0);
                            Cyc = new lGd(ZBe, sgb(0));
                            syc = new lGd($Be, sgb(lve));
                            Qxc = (stc(), qtc);
                            Pxc = new lGd(_Be, Qxc);
                            yxc = new lGd(aCe, false);
                            Hxc = new lGd(bCe, 0.1);
                            Nxc = new lGd(cCe, false);
                            Jxc = new lGd(dCe, null);
                            Kxc = new lGd(eCe, null);
                            sgb(-1);
                            Lxc = new lGd(fCe, null);
                            sgb(-1);
                            Mxc = new lGd(gCe, sgb(-1));
                            sgb(0);
                            zxc = new lGd(hCe, sgb(40));
                            Fxc = (xvc(), wvc);
                            Exc = new lGd(iCe, Fxc);
                            Bxc = uvc;
                            Axc = new lGd(jCe, Bxc);
                            $yc = (JDc(), EDc);
                            Zyc = new lGd(kCe, $yc);
                            Pyc = new jGd(lCe);
                            Kyc = (Cuc(), Auc);
                            Jyc = new lGd(mCe, Kyc);
                            Nyc = (Ouc(), Luc);
                            Myc = new lGd(nCe, Nyc);
                            new Xsd;
                            Syc = new lGd(oCe, 0.3);
                            Uyc = new jGd(pCe);
                            Wyc = (wDc(), uDc);
                            Vyc = new lGd(qCe, Wyc);
                            ayc = (KEc(), IEc);
                            _xc = new lGd(rCe, ayc);
                            cyc = (TEc(), SEc);
                            byc = new lGd(sCe, cyc);
                            eyc = (lFc(), kFc);
                            dyc = new lGd(tCe, eyc);
                            gyc = new lGd(uCe, 0.2);
                            Zxc = new lGd(vCe, 2);
                            ezc = new lGd(wCe, null);
                            gzc = new lGd(xCe, 10);
                            fzc = new lGd(yCe, 10);
                            hzc = new lGd(zCe, 20);
                            sgb(0);
                            bzc = new lGd(ACe, sgb(0));
                            sgb(0);
                            czc = new lGd(BCe, sgb(0));
                            sgb(0);
                            dzc = new lGd(CCe, sgb(0));
                            jxc = new lGd(DCe, false);
                            nxc = ($uc(), Yuc);
                            mxc = new lGd(ECe, nxc);
                            lxc = (jtc(), itc);
                            kxc = new lGd(FCe, lxc);
                            myc = new lGd(GCe, false);
                            sgb(0);
                            lyc = new lGd(HCe, sgb(16));
                            sgb(0);
                            nyc = new lGd(ICe, sgb(5));
                            Gzc = (DFc(), BFc);
                            Fzc = new lGd(JCe, Gzc);
                            kzc = new lGd(KCe, 10);
                            nzc = new lGd(LCe, 1);
                            wzc = (Etc(), Dtc);
                            vzc = new lGd(MCe, wzc);
                            qzc = new jGd(NCe);
                            tzc = sgb(1);
                            sgb(0);
                            szc = new lGd(OCe, tzc);
                            Lzc = (uFc(), rFc);
                            Kzc = new lGd(PCe, Lzc);
                            Hzc = new jGd(QCe);
                            Bzc = new lGd(RCe, true);
                            zzc = new lGd(SCe, 2);
                            Dzc = new lGd(TCe, true);
                            Yxc = (tuc(), ruc);
                            Xxc = new lGd(UCe, Yxc);
                            Wxc = (btc(), Zsc);
                            Vxc = new lGd(VCe, Wxc);
                            xxc = (kEc(), hEc);
                            wxc = new lGd(WCe, xxc);
                            vxc = new lGd(XCe, false);
                            uxc = new lGd(YCe, false);
                            pxc = (U$b(), T$b);
                            oxc = new lGd(ZCe, pxc);
                            txc = (lDc(), iDc);
                            sxc = new lGd($Ce, txc);
                            qxc = new lGd(_Ce, 0);
                            rxc = new lGd(aDe, 0);
                            ryc = Ntc;
                            qyc = ptc;
                            zyc = YCc;
                            Byc = YCc;
                            tyc = TCc;
                            Ixc = (Fnd(), Cnd);
                            Oxc = qtc;
                            Gxc = qtc;
                            Cxc = qtc;
                            Dxc = Cnd;
                            Qyc = HDc;
                            Ryc = EDc;
                            Lyc = EDc;
                            Oyc = EDc;
                            Tyc = GDc;
                            Yyc = HDc;
                            Xyc = HDc;
                            fyc = (Ymd(), Wmd);
                            hyc = Wmd;
                            iyc = kFc;
                            $xc = Vmd;
                            lzc = CFc;
                            mzc = AFc;
                            ozc = CFc;
                            pzc = AFc;
                            xzc = CFc;
                            yzc = AFc;
                            rzc = Ctc;
                            uzc = Dtc;
                            Mzc = CFc;
                            Nzc = AFc;
                            Izc = CFc;
                            Jzc = AFc;
                            Czc = AFc;
                            Azc = AFc;
                            Ezc = AFc;
                        }
                        function iNc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z, $, ab, bb, cb, db, eb, fb, gb, hb, ib, jb, kb, lb;
                            cb = 0;
                            for(H = b, K = 0, N = H.length; K < N; ++K){
                                F = H[K];
                                for(V = new Anb(F.j); V.a < V.c.c.length;){
                                    U = RD(ynb(V), 12);
                                    X = 0;
                                    for(h = new Anb(U.g); h.a < h.c.c.length;){
                                        g = RD(ynb(h), 18);
                                        F.c != g.d.i.c && ++X;
                                    }
                                    X > 0 && (a.a[U.p] = cb++);
                                }
                            }
                            hb = 0;
                            for(I = c, L = 0, O = I.length; L < O; ++L){
                                F = I[L];
                                P = 0;
                                for(V = new Anb(F.j); V.a < V.c.c.length;){
                                    U = RD(ynb(V), 12);
                                    if (U.j == (qpd(), Yod)) for(h = new Anb(U.e); h.a < h.c.c.length;){
                                        g = RD(ynb(h), 18);
                                        if (F.c != g.c.i.c) {
                                            ++P;
                                            break;
                                        }
                                    }
                                    else break;
                                }
                                R = 0;
                                Y = new Jkb(F.j, F.j.c.length);
                                while(Y.b > 0){
                                    U = (sFb(Y.b > 0), RD(Y.a.Xb(Y.c = --Y.b), 12));
                                    X = 0;
                                    for(h = new Anb(U.e); h.a < h.c.c.length;){
                                        g = RD(ynb(h), 18);
                                        F.c != g.c.i.c && ++X;
                                    }
                                    if (X > 0) {
                                        if (U.j == (qpd(), Yod)) {
                                            a.a[U.p] = hb;
                                            ++hb;
                                        } else {
                                            a.a[U.p] = hb + P + R;
                                            ++R;
                                        }
                                    }
                                }
                                hb += R;
                            }
                            W = new Tsb;
                            o = new Iub;
                            for(G = b, J = 0, M = G.length; J < M; ++J){
                                F = G[J];
                                for(fb = new Anb(F.j); fb.a < fb.c.c.length;){
                                    eb = RD(ynb(fb), 12);
                                    for(h = new Anb(eb.g); h.a < h.c.c.length;){
                                        g = RD(ynb(h), 18);
                                        jb = g.d;
                                        if (F.c != jb.i.c) {
                                            db = RD(Wd(qtb(W.f, eb)), 478);
                                            ib = RD(Wd(qtb(W.f, jb)), 478);
                                            if (!db && !ib) {
                                                n = new lNc;
                                                o.a.zc(n, o);
                                                Rmb(n.a, g);
                                                Rmb(n.d, eb);
                                                rtb(W.f, eb, n);
                                                Rmb(n.d, jb);
                                                rtb(W.f, jb, n);
                                            } else if (!db) {
                                                Rmb(ib.a, g);
                                                Rmb(ib.d, eb);
                                                rtb(W.f, eb, ib);
                                            } else if (!ib) {
                                                Rmb(db.a, g);
                                                Rmb(db.d, jb);
                                                rtb(W.f, jb, db);
                                            } else if (db == ib) Rmb(db.a, g);
                                            else {
                                                Rmb(db.a, g);
                                                for(T = new Anb(ib.d); T.a < T.c.c.length;){
                                                    S = RD(ynb(T), 12);
                                                    rtb(W.f, S, db);
                                                }
                                                Tmb(db.a, ib.a);
                                                Tmb(db.d, ib.d);
                                                o.a.Bc(ib);
                                            }
                                        }
                                    }
                                }
                            }
                            p = RD(Ee(o, $C(OY, {
                                3: 1,
                                4: 1,
                                5: 1,
                                2045: 1
                            }, 478, o.a.gc(), 0, 1)), 2045);
                            D = b[0].c;
                            bb = c[0].c;
                            for(k = p, l = 0, m = k.length; l < m; ++l){
                                j = k[l];
                                j.e = cb;
                                j.f = hb;
                                for(V = new Anb(j.d); V.a < V.c.c.length;){
                                    U = RD(ynb(V), 12);
                                    Z = a.a[U.p];
                                    if (U.i.c == D) {
                                        Z < j.e && (j.e = Z);
                                        Z > j.b && (j.b = Z);
                                    } else if (U.i.c == bb) {
                                        Z < j.f && (j.f = Z);
                                        Z > j.c && (j.c = Z);
                                    }
                                }
                            }
                            Wnb(p, 0, p.length, null);
                            gb = $C(kE, Pwe, 28, p.length, 15, 1);
                            d = $C(kE, Pwe, 28, hb + 1, 15, 1);
                            for(r = 0; r < p.length; r++){
                                gb[r] = p[r].f;
                                d[gb[r]] = 1;
                            }
                            f = 0;
                            for(s = 0; s < d.length; s++)d[s] == 1 ? d[s] = f : --f;
                            $ = 0;
                            for(t = 0; t < gb.length; t++){
                                gb[t] += d[gb[t]];
                                $ = $wnd.Math.max($, gb[t] + 1);
                            }
                            i = 1;
                            while(i < $)i *= 2;
                            lb = 2 * i - 1;
                            i -= 1;
                            kb = $C(kE, Pwe, 28, lb, 15, 1);
                            e = 0;
                            for(B = 0; B < gb.length; B++){
                                A = gb[B] + i;
                                ++kb[A];
                                while(A > 0){
                                    A % 2 > 0 && (e += kb[A + 1]);
                                    A = (A - 1) / 2 | 0;
                                    ++kb[A];
                                }
                            }
                            C = $C(NY, rve, 374, p.length * 2, 0, 1);
                            for(u = 0; u < p.length; u++){
                                C[2 * u] = new oNc(p[u], p[u].e, p[u].b, (sNc(), rNc));
                                C[2 * u + 1] = new oNc(p[u], p[u].b, p[u].e, qNc);
                            }
                            Wnb(C, 0, C.length, null);
                            Q = 0;
                            for(v = 0; v < C.length; v++)switch(C[v].d.g){
                                case 0:
                                    ++Q;
                                    break;
                                case 1:
                                    --Q;
                                    e += Q;
                            }
                            ab = $C(NY, rve, 374, p.length * 2, 0, 1);
                            for(w = 0; w < p.length; w++){
                                ab[2 * w] = new oNc(p[w], p[w].f, p[w].c, (sNc(), rNc));
                                ab[2 * w + 1] = new oNc(p[w], p[w].c, p[w].f, qNc);
                            }
                            Wnb(ab, 0, ab.length, null);
                            Q = 0;
                            for(q = 0; q < ab.length; q++)switch(ab[q].d.g){
                                case 0:
                                    ++Q;
                                    break;
                                case 1:
                                    --Q;
                                    e += Q;
                            }
                            return e;
                        }
                        function Vse() {
                            Vse = geb;
                            Ese = new Wse(7);
                            Gse = (++Use, new Hte(8, 94));
                            ++Use;
                            new Hte(8, 64);
                            Hse = (++Use, new Hte(8, 36));
                            Nse = (++Use, new Hte(8, 65));
                            Ose = (++Use, new Hte(8, 122));
                            Pse = (++Use, new Hte(8, 90));
                            Sse = (++Use, new Hte(8, 98));
                            Lse = (++Use, new Hte(8, 66));
                            Qse = (++Use, new Hte(8, 60));
                            Tse = (++Use, new Hte(8, 62));
                            Dse = new Wse(11);
                            Bse = (++Use, new xte(4));
                            rte(Bse, 48, 57);
                            Rse = (++Use, new xte(4));
                            rte(Rse, 48, 57);
                            rte(Rse, 65, 90);
                            rte(Rse, 95, 95);
                            rte(Rse, 97, 122);
                            Mse = (++Use, new xte(4));
                            rte(Mse, 9, 9);
                            rte(Mse, 10, 10);
                            rte(Mse, 12, 12);
                            rte(Mse, 13, 13);
                            rte(Mse, 32, 32);
                            Ise = yte(Bse);
                            Kse = yte(Rse);
                            Jse = yte(Mse);
                            wse = new Tsb;
                            xse = new Tsb;
                            yse = cD(WC(qJ, 1), Nve, 2, 6, [
                                'Cn',
                                'Lu',
                                'Ll',
                                'Lt',
                                'Lm',
                                'Lo',
                                'Mn',
                                'Me',
                                'Mc',
                                'Nd',
                                'Nl',
                                'No',
                                'Zs',
                                'Zl',
                                'Zp',
                                'Cc',
                                'Cf',
                                null,
                                'Co',
                                'Cs',
                                'Pd',
                                'Ps',
                                'Pe',
                                'Pc',
                                'Po',
                                'Sm',
                                'Sc',
                                'Sk',
                                'So',
                                'Pi',
                                'Pf',
                                'L',
                                'M',
                                'N',
                                'Z',
                                'C',
                                'P',
                                'S'
                            ]);
                            vse = cD(WC(qJ, 1), Nve, 2, 6, [
                                'Basic Latin',
                                'Latin-1 Supplement',
                                'Latin Extended-A',
                                'Latin Extended-B',
                                'IPA Extensions',
                                'Spacing Modifier Letters',
                                'Combining Diacritical Marks',
                                'Greek',
                                'Cyrillic',
                                'Armenian',
                                'Hebrew',
                                'Arabic',
                                'Syriac',
                                'Thaana',
                                'Devanagari',
                                'Bengali',
                                'Gurmukhi',
                                'Gujarati',
                                'Oriya',
                                'Tamil',
                                'Telugu',
                                'Kannada',
                                'Malayalam',
                                'Sinhala',
                                'Thai',
                                'Lao',
                                'Tibetan',
                                'Myanmar',
                                'Georgian',
                                'Hangul Jamo',
                                'Ethiopic',
                                'Cherokee',
                                'Unified Canadian Aboriginal Syllabics',
                                'Ogham',
                                'Runic',
                                'Khmer',
                                'Mongolian',
                                'Latin Extended Additional',
                                'Greek Extended',
                                'General Punctuation',
                                'Superscripts and Subscripts',
                                'Currency Symbols',
                                'Combining Marks for Symbols',
                                'Letterlike Symbols',
                                'Number Forms',
                                'Arrows',
                                'Mathematical Operators',
                                'Miscellaneous Technical',
                                'Control Pictures',
                                'Optical Character Recognition',
                                'Enclosed Alphanumerics',
                                'Box Drawing',
                                'Block Elements',
                                'Geometric Shapes',
                                'Miscellaneous Symbols',
                                'Dingbats',
                                'Braille Patterns',
                                'CJK Radicals Supplement',
                                'Kangxi Radicals',
                                'Ideographic Description Characters',
                                'CJK Symbols and Punctuation',
                                'Hiragana',
                                'Katakana',
                                'Bopomofo',
                                'Hangul Compatibility Jamo',
                                'Kanbun',
                                'Bopomofo Extended',
                                'Enclosed CJK Letters and Months',
                                'CJK Compatibility',
                                'CJK Unified Ideographs Extension A',
                                'CJK Unified Ideographs',
                                'Yi Syllables',
                                'Yi Radicals',
                                'Hangul Syllables',
                                VLe,
                                'CJK Compatibility Ideographs',
                                'Alphabetic Presentation Forms',
                                'Arabic Presentation Forms-A',
                                'Combining Half Marks',
                                'CJK Compatibility Forms',
                                'Small Form Variants',
                                'Arabic Presentation Forms-B',
                                'Specials',
                                'Halfwidth and Fullwidth Forms',
                                'Old Italic',
                                'Gothic',
                                'Deseret',
                                'Byzantine Musical Symbols',
                                'Musical Symbols',
                                'Mathematical Alphanumeric Symbols',
                                'CJK Unified Ideographs Extension B',
                                'CJK Compatibility Ideographs Supplement',
                                'Tags'
                            ]);
                            zse = cD(WC(kE, 1), Pwe, 28, 15, [
                                66304,
                                66351,
                                66352,
                                66383,
                                66560,
                                66639,
                                118784,
                                119039,
                                119040,
                                119295,
                                119808,
                                120831,
                                131072,
                                173782,
                                194560,
                                195103,
                                917504,
                                917631
                            ]);
                        }
                        function hMb() {
                            hMb = geb;
                            eMb = new kMb('OUT_T_L', 0, (EKb(), CKb), (vLb(), sLb), (ZJb(), WJb), WJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb((dod(), _nd), cD(WC(A3, 1), jwe, 95, 0, [
                                    cod,
                                    Xnd
                                ]))
                            ]));
                            dMb = new kMb('OUT_T_C', 1, BKb, sLb, WJb, XJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb(_nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    cod,
                                    Wnd
                                ])),
                                ysb(_nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    cod,
                                    Wnd,
                                    Ynd
                                ]))
                            ]));
                            fMb = new kMb('OUT_T_R', 2, DKb, sLb, WJb, YJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb(_nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    cod,
                                    Znd
                                ]))
                            ]));
                            XLb = new kMb('OUT_B_L', 3, CKb, uLb, YJb, WJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb(_nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    aod,
                                    Xnd
                                ]))
                            ]));
                            WLb = new kMb('OUT_B_C', 4, BKb, uLb, YJb, XJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb(_nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    aod,
                                    Wnd
                                ])),
                                ysb(_nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    aod,
                                    Wnd,
                                    Ynd
                                ]))
                            ]));
                            YLb = new kMb('OUT_B_R', 5, DKb, uLb, YJb, YJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb(_nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    aod,
                                    Znd
                                ]))
                            ]));
                            _Lb = new kMb('OUT_L_T', 6, DKb, uLb, WJb, WJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb(_nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    Xnd,
                                    cod,
                                    Ynd
                                ]))
                            ]));
                            $Lb = new kMb('OUT_L_C', 7, DKb, tLb, XJb, WJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb(_nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    Xnd,
                                    bod
                                ])),
                                ysb(_nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    Xnd,
                                    bod,
                                    Ynd
                                ]))
                            ]));
                            ZLb = new kMb('OUT_L_B', 8, DKb, sLb, YJb, WJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb(_nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    Xnd,
                                    aod,
                                    Ynd
                                ]))
                            ]));
                            cMb = new kMb('OUT_R_T', 9, CKb, uLb, WJb, YJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb(_nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    Znd,
                                    cod,
                                    Ynd
                                ]))
                            ]));
                            bMb = new kMb('OUT_R_C', 10, CKb, tLb, XJb, YJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb(_nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    Znd,
                                    bod
                                ])),
                                ysb(_nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    Znd,
                                    bod,
                                    Ynd
                                ]))
                            ]));
                            aMb = new kMb('OUT_R_B', 11, CKb, sLb, YJb, YJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb(_nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    Znd,
                                    aod,
                                    Ynd
                                ]))
                            ]));
                            ULb = new kMb('IN_T_L', 12, CKb, uLb, WJb, WJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    cod,
                                    Xnd
                                ])),
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    cod,
                                    Xnd,
                                    Ynd
                                ]))
                            ]));
                            TLb = new kMb('IN_T_C', 13, BKb, uLb, WJb, XJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    cod,
                                    Wnd
                                ])),
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    cod,
                                    Wnd,
                                    Ynd
                                ]))
                            ]));
                            VLb = new kMb('IN_T_R', 14, DKb, uLb, WJb, YJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    cod,
                                    Znd
                                ])),
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    cod,
                                    Znd,
                                    Ynd
                                ]))
                            ]));
                            RLb = new kMb('IN_C_L', 15, CKb, tLb, XJb, WJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    bod,
                                    Xnd
                                ])),
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    bod,
                                    Xnd,
                                    Ynd
                                ]))
                            ]));
                            QLb = new kMb('IN_C_C', 16, BKb, tLb, XJb, XJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    bod,
                                    Wnd
                                ])),
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    bod,
                                    Wnd,
                                    Ynd
                                ]))
                            ]));
                            SLb = new kMb('IN_C_R', 17, DKb, tLb, XJb, YJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    bod,
                                    Znd
                                ])),
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    bod,
                                    Znd,
                                    Ynd
                                ]))
                            ]));
                            OLb = new kMb('IN_B_L', 18, CKb, sLb, YJb, WJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    aod,
                                    Xnd
                                ])),
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    aod,
                                    Xnd,
                                    Ynd
                                ]))
                            ]));
                            NLb = new kMb('IN_B_C', 19, BKb, sLb, YJb, XJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    aod,
                                    Wnd
                                ])),
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    aod,
                                    Wnd,
                                    Ynd
                                ]))
                            ]));
                            PLb = new kMb('IN_B_R', 20, DKb, sLb, YJb, YJb, cD(WC(bL, 1), rve, 21, 0, [
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    aod,
                                    Znd
                                ])),
                                ysb($nd, cD(WC(A3, 1), jwe, 95, 0, [
                                    aod,
                                    Znd,
                                    Ynd
                                ]))
                            ]));
                            gMb = new kMb(Sye, 21, null, null, null, null, cD(WC(bL, 1), rve, 21, 0, []));
                        }
                        function JTd() {
                            JTd = geb;
                            nTd = (lTd(), kTd).b;
                            RD(QHd(xYd(kTd.b), 0), 35);
                            RD(QHd(xYd(kTd.b), 1), 19);
                            mTd = kTd.a;
                            RD(QHd(xYd(kTd.a), 0), 35);
                            RD(QHd(xYd(kTd.a), 1), 19);
                            RD(QHd(xYd(kTd.a), 2), 19);
                            RD(QHd(xYd(kTd.a), 3), 19);
                            RD(QHd(xYd(kTd.a), 4), 19);
                            oTd = kTd.o;
                            RD(QHd(xYd(kTd.o), 0), 35);
                            RD(QHd(xYd(kTd.o), 1), 35);
                            qTd = RD(QHd(xYd(kTd.o), 2), 19);
                            RD(QHd(xYd(kTd.o), 3), 19);
                            RD(QHd(xYd(kTd.o), 4), 19);
                            RD(QHd(xYd(kTd.o), 5), 19);
                            RD(QHd(xYd(kTd.o), 6), 19);
                            RD(QHd(xYd(kTd.o), 7), 19);
                            RD(QHd(xYd(kTd.o), 8), 19);
                            RD(QHd(xYd(kTd.o), 9), 19);
                            RD(QHd(xYd(kTd.o), 10), 19);
                            RD(QHd(xYd(kTd.o), 11), 19);
                            RD(QHd(xYd(kTd.o), 12), 19);
                            RD(QHd(xYd(kTd.o), 13), 19);
                            RD(QHd(xYd(kTd.o), 14), 19);
                            RD(QHd(xYd(kTd.o), 15), 19);
                            RD(QHd(uYd(kTd.o), 0), 62);
                            RD(QHd(uYd(kTd.o), 1), 62);
                            RD(QHd(uYd(kTd.o), 2), 62);
                            RD(QHd(uYd(kTd.o), 3), 62);
                            RD(QHd(uYd(kTd.o), 4), 62);
                            RD(QHd(uYd(kTd.o), 5), 62);
                            RD(QHd(uYd(kTd.o), 6), 62);
                            RD(QHd(uYd(kTd.o), 7), 62);
                            RD(QHd(uYd(kTd.o), 8), 62);
                            RD(QHd(uYd(kTd.o), 9), 62);
                            pTd = kTd.p;
                            RD(QHd(xYd(kTd.p), 0), 35);
                            RD(QHd(xYd(kTd.p), 1), 35);
                            RD(QHd(xYd(kTd.p), 2), 35);
                            RD(QHd(xYd(kTd.p), 3), 35);
                            RD(QHd(xYd(kTd.p), 4), 19);
                            RD(QHd(xYd(kTd.p), 5), 19);
                            RD(QHd(uYd(kTd.p), 0), 62);
                            RD(QHd(uYd(kTd.p), 1), 62);
                            rTd = kTd.q;
                            RD(QHd(xYd(kTd.q), 0), 35);
                            sTd = kTd.v;
                            RD(QHd(xYd(kTd.v), 0), 19);
                            RD(QHd(uYd(kTd.v), 0), 62);
                            RD(QHd(uYd(kTd.v), 1), 62);
                            RD(QHd(uYd(kTd.v), 2), 62);
                            tTd = kTd.w;
                            RD(QHd(xYd(kTd.w), 0), 35);
                            RD(QHd(xYd(kTd.w), 1), 35);
                            RD(QHd(xYd(kTd.w), 2), 35);
                            RD(QHd(xYd(kTd.w), 3), 19);
                            uTd = kTd.B;
                            RD(QHd(xYd(kTd.B), 0), 19);
                            RD(QHd(uYd(kTd.B), 0), 62);
                            RD(QHd(uYd(kTd.B), 1), 62);
                            RD(QHd(uYd(kTd.B), 2), 62);
                            xTd = kTd.Q;
                            RD(QHd(xYd(kTd.Q), 0), 19);
                            RD(QHd(uYd(kTd.Q), 0), 62);
                            yTd = kTd.R;
                            RD(QHd(xYd(kTd.R), 0), 35);
                            zTd = kTd.S;
                            RD(QHd(uYd(kTd.S), 0), 62);
                            RD(QHd(uYd(kTd.S), 1), 62);
                            RD(QHd(uYd(kTd.S), 2), 62);
                            RD(QHd(uYd(kTd.S), 3), 62);
                            RD(QHd(uYd(kTd.S), 4), 62);
                            RD(QHd(uYd(kTd.S), 5), 62);
                            RD(QHd(uYd(kTd.S), 6), 62);
                            RD(QHd(uYd(kTd.S), 7), 62);
                            RD(QHd(uYd(kTd.S), 8), 62);
                            RD(QHd(uYd(kTd.S), 9), 62);
                            RD(QHd(uYd(kTd.S), 10), 62);
                            RD(QHd(uYd(kTd.S), 11), 62);
                            RD(QHd(uYd(kTd.S), 12), 62);
                            RD(QHd(uYd(kTd.S), 13), 62);
                            RD(QHd(uYd(kTd.S), 14), 62);
                            ATd = kTd.T;
                            RD(QHd(xYd(kTd.T), 0), 19);
                            RD(QHd(xYd(kTd.T), 2), 19);
                            BTd = RD(QHd(xYd(kTd.T), 3), 19);
                            RD(QHd(xYd(kTd.T), 4), 19);
                            RD(QHd(uYd(kTd.T), 0), 62);
                            RD(QHd(uYd(kTd.T), 1), 62);
                            RD(QHd(xYd(kTd.T), 1), 19);
                            CTd = kTd.U;
                            RD(QHd(xYd(kTd.U), 0), 35);
                            RD(QHd(xYd(kTd.U), 1), 35);
                            RD(QHd(xYd(kTd.U), 2), 19);
                            RD(QHd(xYd(kTd.U), 3), 19);
                            RD(QHd(xYd(kTd.U), 4), 19);
                            RD(QHd(xYd(kTd.U), 5), 19);
                            RD(QHd(uYd(kTd.U), 0), 62);
                            DTd = kTd.V;
                            RD(QHd(xYd(kTd.V), 0), 19);
                            ETd = kTd.W;
                            RD(QHd(xYd(kTd.W), 0), 35);
                            RD(QHd(xYd(kTd.W), 1), 35);
                            RD(QHd(xYd(kTd.W), 2), 35);
                            RD(QHd(xYd(kTd.W), 3), 19);
                            RD(QHd(xYd(kTd.W), 4), 19);
                            RD(QHd(xYd(kTd.W), 5), 19);
                            GTd = kTd.bb;
                            RD(QHd(xYd(kTd.bb), 0), 35);
                            RD(QHd(xYd(kTd.bb), 1), 35);
                            RD(QHd(xYd(kTd.bb), 2), 35);
                            RD(QHd(xYd(kTd.bb), 3), 35);
                            RD(QHd(xYd(kTd.bb), 4), 35);
                            RD(QHd(xYd(kTd.bb), 5), 35);
                            RD(QHd(xYd(kTd.bb), 6), 35);
                            RD(QHd(xYd(kTd.bb), 7), 19);
                            RD(QHd(uYd(kTd.bb), 0), 62);
                            RD(QHd(uYd(kTd.bb), 1), 62);
                            HTd = kTd.eb;
                            RD(QHd(xYd(kTd.eb), 0), 35);
                            RD(QHd(xYd(kTd.eb), 1), 35);
                            RD(QHd(xYd(kTd.eb), 2), 35);
                            RD(QHd(xYd(kTd.eb), 3), 35);
                            RD(QHd(xYd(kTd.eb), 4), 35);
                            RD(QHd(xYd(kTd.eb), 5), 35);
                            RD(QHd(xYd(kTd.eb), 6), 19);
                            RD(QHd(xYd(kTd.eb), 7), 19);
                            FTd = kTd.ab;
                            RD(QHd(xYd(kTd.ab), 0), 35);
                            RD(QHd(xYd(kTd.ab), 1), 35);
                            vTd = kTd.H;
                            RD(QHd(xYd(kTd.H), 0), 19);
                            RD(QHd(xYd(kTd.H), 1), 19);
                            RD(QHd(xYd(kTd.H), 2), 19);
                            RD(QHd(xYd(kTd.H), 3), 19);
                            RD(QHd(xYd(kTd.H), 4), 19);
                            RD(QHd(xYd(kTd.H), 5), 19);
                            RD(QHd(uYd(kTd.H), 0), 62);
                            ITd = kTd.db;
                            RD(QHd(xYd(kTd.db), 0), 19);
                            wTd = kTd.M;
                        }
                        function Ane(a) {
                            var b;
                            if (a.O) return;
                            a.O = true;
                            PAd(a, 'type');
                            CBd(a, 'ecore.xml.type');
                            DBd(a, dLe);
                            b = RD(N5d((YSd(), XSd), dLe), 2044);
                            WGd(zYd(a.fb), a.b);
                            vBd(a.b, Vbb, 'AnyType', false, false, true);
                            tBd(RD(QHd(xYd(a.b), 0), 35), a.wb.D, pKe, null, 0, -1, Vbb, false, false, true, false, false, false);
                            tBd(RD(QHd(xYd(a.b), 1), 35), a.wb.D, 'any', null, 0, -1, Vbb, true, true, true, false, false, true);
                            tBd(RD(QHd(xYd(a.b), 2), 35), a.wb.D, 'anyAttribute', null, 0, -1, Vbb, false, false, true, false, false, false);
                            vBd(a.bb, Xbb, iLe, false, false, true);
                            tBd(RD(QHd(xYd(a.bb), 0), 35), a.gb, 'data', null, 0, 1, Xbb, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.bb), 1), 35), a.gb, CIe, null, 1, 1, Xbb, false, false, true, false, true, false);
                            vBd(a.fb, Ybb, jLe, false, false, true);
                            tBd(RD(QHd(xYd(a.fb), 0), 35), b.gb, 'rawValue', null, 0, 1, Ybb, true, true, true, false, true, true);
                            tBd(RD(QHd(xYd(a.fb), 1), 35), b.a, aIe, null, 0, 1, Ybb, true, true, true, false, true, true);
                            zBd(RD(QHd(xYd(a.fb), 2), 19), a.wb.q, null, 'instanceType', 1, 1, Ybb, false, false, true, false, false, false, false);
                            vBd(a.qb, Zbb, kLe, false, false, true);
                            tBd(RD(QHd(xYd(a.qb), 0), 35), a.wb.D, pKe, null, 0, -1, null, false, false, true, false, false, false);
                            zBd(RD(QHd(xYd(a.qb), 1), 19), a.wb.ab, null, 'xMLNSPrefixMap', 0, -1, null, true, false, true, true, false, false, false);
                            zBd(RD(QHd(xYd(a.qb), 2), 19), a.wb.ab, null, 'xSISchemaLocation', 0, -1, null, true, false, true, true, false, false, false);
                            tBd(RD(QHd(xYd(a.qb), 3), 35), a.gb, 'cDATA', null, 0, -2, null, true, true, true, false, false, true);
                            tBd(RD(QHd(xYd(a.qb), 4), 35), a.gb, 'comment', null, 0, -2, null, true, true, true, false, false, true);
                            zBd(RD(QHd(xYd(a.qb), 5), 19), a.bb, null, KLe, 0, -2, null, true, true, true, true, false, false, true);
                            tBd(RD(QHd(xYd(a.qb), 6), 35), a.gb, hIe, null, 0, -2, null, true, true, true, false, false, true);
                            xBd(a.a, jJ, 'AnySimpleType', true);
                            xBd(a.c, qJ, 'AnyURI', true);
                            xBd(a.d, WC(gE, 1), 'Base64Binary', true);
                            xBd(a.e, xdb, 'Boolean', true);
                            xBd(a.f, QI, 'BooleanObject', true);
                            xBd(a.g, gE, 'Byte', true);
                            xBd(a.i, RI, 'ByteObject', true);
                            xBd(a.j, qJ, 'Date', true);
                            xBd(a.k, qJ, 'DateTime', true);
                            xBd(a.n, tJ, 'Decimal', true);
                            xBd(a.o, iE, 'Double', true);
                            xBd(a.p, VI, 'DoubleObject', true);
                            xBd(a.q, qJ, 'Duration', true);
                            xBd(a.s, QK, 'ENTITIES', true);
                            xBd(a.r, QK, 'ENTITIESBase', true);
                            xBd(a.t, qJ, qLe, true);
                            xBd(a.u, jE, 'Float', true);
                            xBd(a.v, ZI, 'FloatObject', true);
                            xBd(a.w, qJ, 'GDay', true);
                            xBd(a.B, qJ, 'GMonth', true);
                            xBd(a.A, qJ, 'GMonthDay', true);
                            xBd(a.C, qJ, 'GYear', true);
                            xBd(a.D, qJ, 'GYearMonth', true);
                            xBd(a.F, WC(gE, 1), 'HexBinary', true);
                            xBd(a.G, qJ, 'ID', true);
                            xBd(a.H, qJ, 'IDREF', true);
                            xBd(a.J, QK, 'IDREFS', true);
                            xBd(a.I, QK, 'IDREFSBase', true);
                            xBd(a.K, kE, 'Int', true);
                            xBd(a.M, uJ, 'Integer', true);
                            xBd(a.L, bJ, 'IntObject', true);
                            xBd(a.P, qJ, 'Language', true);
                            xBd(a.Q, lE, 'Long', true);
                            xBd(a.R, eJ, 'LongObject', true);
                            xBd(a.S, qJ, 'Name', true);
                            xBd(a.T, qJ, rLe, true);
                            xBd(a.U, uJ, 'NegativeInteger', true);
                            xBd(a.V, qJ, BLe, true);
                            xBd(a.X, QK, 'NMTOKENS', true);
                            xBd(a.W, QK, 'NMTOKENSBase', true);
                            xBd(a.Y, uJ, 'NonNegativeInteger', true);
                            xBd(a.Z, uJ, 'NonPositiveInteger', true);
                            xBd(a.$, qJ, 'NormalizedString', true);
                            xBd(a._, qJ, 'NOTATION', true);
                            xBd(a.ab, qJ, 'PositiveInteger', true);
                            xBd(a.cb, qJ, 'QName', true);
                            xBd(a.db, wdb, 'Short', true);
                            xBd(a.eb, lJ, 'ShortObject', true);
                            xBd(a.gb, qJ, uwe, true);
                            xBd(a.hb, qJ, 'Time', true);
                            xBd(a.ib, qJ, 'Token', true);
                            xBd(a.jb, wdb, 'UnsignedByte', true);
                            xBd(a.kb, lJ, 'UnsignedByteObject', true);
                            xBd(a.lb, lE, 'UnsignedInt', true);
                            xBd(a.mb, eJ, 'UnsignedIntObject', true);
                            xBd(a.nb, uJ, 'UnsignedLong', true);
                            xBd(a.ob, kE, 'UnsignedShort', true);
                            xBd(a.pb, bJ, 'UnsignedShortObject', true);
                            pBd(a, dLe);
                            yne(a);
                        }
                        function Fed(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z, $, ab;
                            if (d.$g()) return yob(), yob(), vob;
                            if (Heb(TD(Gxd(b, (umd(), rld))))) return yob(), yob(), vob;
                            A = (!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a).i != 0;
                            C = Ded(b);
                            B = !C.dc();
                            if (A || B) {
                                e = RD(Gxd(b, Tld), 143);
                                if (!e) throw Adb(new Jed('Resolved algorithm is not set; apply a LayoutAlgorithmResolver before computing layout.'));
                                Y = Ofd(e, (aGd(), YFd));
                                Bed(b);
                                if (!A && B && !Y) return yob(), yob(), vob;
                                t = new bnb;
                                if (dE(Gxd(b, Xkd)) === dE((Fnd(), Cnd)) && (Ofd(e, VFd) || Ofd(e, UFd))) {
                                    if (Heb(TD(Gxd(b, mmd)))) throw Adb(new Jed('Topdown layout cannot be used together with hierarchy handling.'));
                                    M = Aed(a, b);
                                    N = new Yub;
                                    ye(N, (!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a));
                                    while(N.b != 0){
                                        K = RD(N.b == 0 ? null : (sFb(N.b != 0), Wub(N, N.a.a)), 27);
                                        Bed(K);
                                        X = dE(Gxd(K, Xkd)) === dE(End);
                                        if (X || Hxd(K, Akd) && !Nfd(e, Gxd(K, Tld))) {
                                            q = Fed(a, K, c, d);
                                            Tmb(t, q);
                                            Ixd(K, Xkd, End);
                                            ksd(K);
                                        } else ye(N, (!K.a && (K.a = new C5d(J4, K, 10, 11)), K.a));
                                    }
                                } else {
                                    M = (!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a).i;
                                    if (Heb(TD(Gxd(b, mmd)))) {
                                        Z = d.eh(1);
                                        Z.Ug(yGe, 1);
                                        if (Gxd(b, nmd) == null) throw Adb(new Jed(b.k + ' has not been assigned a top-down node type.'));
                                        if (RD(Gxd(b, nmd), 280) == (mqd(), jqd) || RD(Gxd(b, nmd), 280) == lqd) for(s = new dMd((!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a)); s.e != s.i.gc();){
                                            r = RD(bMd(s), 27);
                                            J = RD(Gxd(r, Tld), 143);
                                            (!r.a && (r.a = new C5d(J4, r, 10, 11)), r.a).i > 0 && ltd(J.f);
                                            if (Gxd(r, smd) != null) {
                                                h = RD(Gxd(r, smd), 347);
                                                W = h.Tg(r);
                                                zyd(r, $wnd.Math.max(r.g, W.a), $wnd.Math.max(r.f, W.b));
                                            }
                                        }
                                        O = RD(Gxd(b, tld), 107);
                                        n = b.g - (O.b + O.c);
                                        m = b.f - (O.d + O.a);
                                        Z.bh('Available Child Area: (' + n + '|' + m + ')');
                                        Ixd(b, Dkd, n / m);
                                        Ced(b, e, d.eh(M));
                                        if (RD(Gxd(b, nmd), 280) == lqd) {
                                            psd(b);
                                            zyd(b, O.b + Kfb(UD(Gxd(b, Ikd))) + O.c, O.d + Kfb(UD(Gxd(b, Hkd))) + O.a);
                                        }
                                        Z.bh('Executed layout algorithm: ' + WD(Gxd(b, Akd)) + ' on node ' + b.k);
                                        if (RD(Gxd(b, nmd), 280) == jqd) {
                                            if (n < 0 || m < 0) throw Adb(new Jed('The size defined by the parent parallel node is too small for the space provided by the paddings of the child hierarchical node. ' + b.k));
                                            Hxd(b, Ikd) || Hxd(b, Hkd) || psd(b);
                                            p = Kfb(UD(Gxd(b, Ikd)));
                                            o = Kfb(UD(Gxd(b, Hkd)));
                                            Z.bh('Desired Child Area: (' + p + '|' + o + ')');
                                            Q = n / p;
                                            R = m / o;
                                            P = $wnd.Math.min(Q, $wnd.Math.min(R, Kfb(UD(Gxd(b, omd)))));
                                            Ixd(b, qmd, P);
                                            Z.bh(b.k + ' -- Local Scale Factor (X|Y): (' + Q + '|' + R + ')');
                                            u = RD(Gxd(b, Kkd), 21);
                                            f = 0;
                                            g = 0;
                                            P < Q && (u.Hc((ukd(), okd)) ? f = (n / 2 - p * P / 2) / P : u.Hc(qkd) && (f = (n - p * P) / P));
                                            P < R && (u.Hc((ukd(), skd)) ? g = (m / 2 - o * P / 2) / P : u.Hc(rkd) && (g = (m - o * P) / P));
                                            $ = f + (O.b / P - O.b);
                                            ab = g + (O.d / P - O.d);
                                            Z.bh('Shift: (' + $ + '|' + ab + ')');
                                            for(L = new dMd((!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a)); L.e != L.i.gc();){
                                                K = RD(bMd(L), 27);
                                                Dyd(K, K.i + $);
                                                Eyd(K, K.j + ab);
                                            }
                                            for(w = new dMd((!b.b && (b.b = new C5d(G4, b, 12, 3)), b.b)); w.e != w.i.gc();){
                                                v = RD(bMd(w), 74);
                                                for(T = new dMd((!v.a && (v.a = new C5d(F4, v, 6, 6)), v.a)); T.e != T.i.gc();){
                                                    S = RD(bMd(T), 166);
                                                    Nzd(S, S.j + $, S.k + ab);
                                                    Gzd(S, S.b + $, S.c + ab);
                                                    for(j = new dMd((!S.a && (S.a = new XZd(D4, S, 5)), S.a)); j.e != j.i.gc();){
                                                        i = RD(bMd(j), 377);
                                                        Uxd(i, i.a + $, i.b + ab);
                                                    }
                                                }
                                                for(I = new dMd((!v.n && (v.n = new C5d(I4, v, 1, 7)), v.n)); I.e != I.i.gc();){
                                                    H = RD(bMd(I), 135);
                                                    Byd(H, H.i + $, H.j + ab);
                                                }
                                                G = RD(Gxd(v, cld), 75);
                                                for(F = Sub(G, 0); F.b != F.d.c;){
                                                    D = RD(evb(F), 8);
                                                    D.a += $;
                                                    D.b += ab;
                                                }
                                                Ixd(v, cld, G);
                                            }
                                        }
                                        Z.Vg();
                                    }
                                    for(l = new dMd((!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a)); l.e != l.i.gc();){
                                        k = RD(bMd(l), 27);
                                        q = Fed(a, k, c, d);
                                        Tmb(t, q);
                                        ksd(k);
                                    }
                                }
                                if (d.$g()) return yob(), yob(), vob;
                                for(V = new Anb(t); V.a < V.c.c.length;){
                                    U = RD(ynb(V), 74);
                                    Ixd(U, rld, (Geb(), true));
                                }
                                Heb(TD(Gxd(b, mmd))) || Ced(b, e, d.eh(M));
                                Ged(t);
                                return B && Y ? C : (yob(), yob(), vob);
                            } else return yob(), yob(), vob;
                        }
                        function Jre(a, b) {
                            var c, d;
                            if (!Bre) {
                                Bre = new Tsb;
                                Cre = new Tsb;
                                d = (Vse(), Vse(), ++Use, new xte(4));
                                ose(d, '\t\n\r\r  ');
                                $jb(Bre, QLe, d);
                                $jb(Cre, QLe, yte(d));
                                d = (++Use, new xte(4));
                                ose(d, TLe);
                                $jb(Bre, OLe, d);
                                $jb(Cre, OLe, yte(d));
                                d = (++Use, new xte(4));
                                ose(d, TLe);
                                $jb(Bre, OLe, d);
                                $jb(Cre, OLe, yte(d));
                                d = (++Use, new xte(4));
                                ose(d, ULe);
                                ute(d, RD(Xjb(Bre, OLe), 122));
                                $jb(Bre, PLe, d);
                                $jb(Cre, PLe, yte(d));
                                d = (++Use, new xte(4));
                                ose(d, '-.0:AZ__az\xB7\xB7\xC0\xD6\xD8\xF6\xF8\u0131\u0134\u013E\u0141\u0148\u014A\u017E\u0180\u01C3\u01CD\u01F0\u01F4\u01F5\u01FA\u0217\u0250\u02A8\u02BB\u02C1\u02D0\u02D1\u0300\u0345\u0360\u0361\u0386\u038A\u038C\u038C\u038E\u03A1\u03A3\u03CE\u03D0\u03D6\u03DA\u03DA\u03DC\u03DC\u03DE\u03DE\u03E0\u03E0\u03E2\u03F3\u0401\u040C\u040E\u044F\u0451\u045C\u045E\u0481\u0483\u0486\u0490\u04C4\u04C7\u04C8\u04CB\u04CC\u04D0\u04EB\u04EE\u04F5\u04F8\u04F9\u0531\u0556\u0559\u0559\u0561\u0586\u0591\u05A1\u05A3\u05B9\u05BB\u05BD\u05BF\u05BF\u05C1\u05C2\u05C4\u05C4\u05D0\u05EA\u05F0\u05F2\u0621\u063A\u0640\u0652\u0660\u0669\u0670\u06B7\u06BA\u06BE\u06C0\u06CE\u06D0\u06D3\u06D5\u06E8\u06EA\u06ED\u06F0\u06F9\u0901\u0903\u0905\u0939\u093C\u094D\u0951\u0954\u0958\u0963\u0966\u096F\u0981\u0983\u0985\u098C\u098F\u0990\u0993\u09A8\u09AA\u09B0\u09B2\u09B2\u09B6\u09B9\u09BC\u09BC\u09BE\u09C4\u09C7\u09C8\u09CB\u09CD\u09D7\u09D7\u09DC\u09DD\u09DF\u09E3\u09E6\u09F1\u0A02\u0A02\u0A05\u0A0A\u0A0F\u0A10\u0A13\u0A28\u0A2A\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3C\u0A3E\u0A42\u0A47\u0A48\u0A4B\u0A4D\u0A59\u0A5C\u0A5E\u0A5E\u0A66\u0A74\u0A81\u0A83\u0A85\u0A8B\u0A8D\u0A8D\u0A8F\u0A91\u0A93\u0AA8\u0AAA\u0AB0\u0AB2\u0AB3\u0AB5\u0AB9\u0ABC\u0AC5\u0AC7\u0AC9\u0ACB\u0ACD\u0AE0\u0AE0\u0AE6\u0AEF\u0B01\u0B03\u0B05\u0B0C\u0B0F\u0B10\u0B13\u0B28\u0B2A\u0B30\u0B32\u0B33\u0B36\u0B39\u0B3C\u0B43\u0B47\u0B48\u0B4B\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F\u0B61\u0B66\u0B6F\u0B82\u0B83\u0B85\u0B8A\u0B8E\u0B90\u0B92\u0B95\u0B99\u0B9A\u0B9C\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8\u0BAA\u0BAE\u0BB5\u0BB7\u0BB9\u0BBE\u0BC2\u0BC6\u0BC8\u0BCA\u0BCD\u0BD7\u0BD7\u0BE7\u0BEF\u0C01\u0C03\u0C05\u0C0C\u0C0E\u0C10\u0C12\u0C28\u0C2A\u0C33\u0C35\u0C39\u0C3E\u0C44\u0C46\u0C48\u0C4A\u0C4D\u0C55\u0C56\u0C60\u0C61\u0C66\u0C6F\u0C82\u0C83\u0C85\u0C8C\u0C8E\u0C90\u0C92\u0CA8\u0CAA\u0CB3\u0CB5\u0CB9\u0CBE\u0CC4\u0CC6\u0CC8\u0CCA\u0CCD\u0CD5\u0CD6\u0CDE\u0CDE\u0CE0\u0CE1\u0CE6\u0CEF\u0D02\u0D03\u0D05\u0D0C\u0D0E\u0D10\u0D12\u0D28\u0D2A\u0D39\u0D3E\u0D43\u0D46\u0D48\u0D4A\u0D4D\u0D57\u0D57\u0D60\u0D61\u0D66\u0D6F\u0E01\u0E2E\u0E30\u0E3A\u0E40\u0E4E\u0E50\u0E59\u0E81\u0E82\u0E84\u0E84\u0E87\u0E88\u0E8A\u0E8A\u0E8D\u0E8D\u0E94\u0E97\u0E99\u0E9F\u0EA1\u0EA3\u0EA5\u0EA5\u0EA7\u0EA7\u0EAA\u0EAB\u0EAD\u0EAE\u0EB0\u0EB9\u0EBB\u0EBD\u0EC0\u0EC4\u0EC6\u0EC6\u0EC8\u0ECD\u0ED0\u0ED9\u0F18\u0F19\u0F20\u0F29\u0F35\u0F35\u0F37\u0F37\u0F39\u0F39\u0F3E\u0F47\u0F49\u0F69\u0F71\u0F84\u0F86\u0F8B\u0F90\u0F95\u0F97\u0F97\u0F99\u0FAD\u0FB1\u0FB7\u0FB9\u0FB9\u10A0\u10C5\u10D0\u10F6\u1100\u1100\u1102\u1103\u1105\u1107\u1109\u1109\u110B\u110C\u110E\u1112\u113C\u113C\u113E\u113E\u1140\u1140\u114C\u114C\u114E\u114E\u1150\u1150\u1154\u1155\u1159\u1159\u115F\u1161\u1163\u1163\u1165\u1165\u1167\u1167\u1169\u1169\u116D\u116E\u1172\u1173\u1175\u1175\u119E\u119E\u11A8\u11A8\u11AB\u11AB\u11AE\u11AF\u11B7\u11B8\u11BA\u11BA\u11BC\u11C2\u11EB\u11EB\u11F0\u11F0\u11F9\u11F9\u1E00\u1E9B\u1EA0\u1EF9\u1F00\u1F15\u1F18\u1F1D\u1F20\u1F45\u1F48\u1F4D\u1F50\u1F57\u1F59\u1F59\u1F5B\u1F5B\u1F5D\u1F5D\u1F5F\u1F7D\u1F80\u1FB4\u1FB6\u1FBC\u1FBE\u1FBE\u1FC2\u1FC4\u1FC6\u1FCC\u1FD0\u1FD3\u1FD6\u1FDB\u1FE0\u1FEC\u1FF2\u1FF4\u1FF6\u1FFC\u20D0\u20DC\u20E1\u20E1\u2126\u2126\u212A\u212B\u212E\u212E\u2180\u2182\u3005\u3005\u3007\u3007\u3021\u302F\u3031\u3035\u3041\u3094\u3099\u309A\u309D\u309E\u30A1\u30FA\u30FC\u30FE\u3105\u312C\u4E00\u9FA5\uAC00\uD7A3');
                                $jb(Bre, RLe, d);
                                $jb(Cre, RLe, yte(d));
                                d = (++Use, new xte(4));
                                ose(d, ULe);
                                rte(d, 95, 95);
                                rte(d, 58, 58);
                                $jb(Bre, SLe, d);
                                $jb(Cre, SLe, yte(d));
                            }
                            c = b ? RD(Xjb(Bre, a), 138) : RD(Xjb(Cre, a), 138);
                            return c;
                        }
                        function zCc(a) {
                            Cgd(a, new Pfd(_fd(Wfd($fd(Xfd(Zfd(Yfd(new agd, sxe), 'ELK Layered'), 'Layer-based algorithm provided by the Eclipse Layout Kernel. Arranges as many edges as possible into one direction by placing nodes into subsequent layers. This implementation supports different routing styles (straight, orthogonal, splines); if orthogonal routing is selected, arbitrary port constraints are respected, thus enabling the layout of block diagrams such as actor-oriented models or circuit schematics. Furthermore, full layout of compound graphs with cross-hierarchy edges is supported when the respective option is activated on the top level.'), new CCc), sxe), ysb((aGd(), _Fd), cD(WC(T5, 1), jwe, 245, 0, [
                                YFd,
                                ZFd,
                                XFd,
                                $Fd,
                                VFd,
                                UFd
                            ])))));
                            Agd(a, sxe, xDe, iGd(QBc));
                            Agd(a, sxe, yDe, iGd(RBc));
                            Agd(a, sxe, Bze, iGd(SBc));
                            Agd(a, sxe, zDe, iGd(TBc));
                            Agd(a, sxe, aAe, iGd(VBc));
                            Agd(a, sxe, ADe, iGd(WBc));
                            Agd(a, sxe, BDe, iGd(ZBc));
                            Agd(a, sxe, CDe, iGd(_Bc));
                            Agd(a, sxe, DDe, iGd(aCc));
                            Agd(a, sxe, EDe, iGd($Bc));
                            Agd(a, sxe, _ze, iGd(bCc));
                            Agd(a, sxe, FDe, iGd(dCc));
                            Agd(a, sxe, GDe, iGd(fCc));
                            Agd(a, sxe, HDe, iGd(YBc));
                            Agd(a, sxe, wCe, iGd(PBc));
                            Agd(a, sxe, yCe, iGd(UBc));
                            Agd(a, sxe, xCe, iGd(XBc));
                            Agd(a, sxe, zCe, iGd(cCc));
                            Agd(a, sxe, $ze, sgb(0));
                            Agd(a, sxe, ACe, iGd(KBc));
                            Agd(a, sxe, BCe, iGd(LBc));
                            Agd(a, sxe, CCe, iGd(MBc));
                            Agd(a, sxe, JCe, iGd(vCc));
                            Agd(a, sxe, KCe, iGd(nCc));
                            Agd(a, sxe, LCe, iGd(oCc));
                            Agd(a, sxe, MCe, iGd(rCc));
                            Agd(a, sxe, NCe, iGd(pCc));
                            Agd(a, sxe, OCe, iGd(qCc));
                            Agd(a, sxe, PCe, iGd(xCc));
                            Agd(a, sxe, QCe, iGd(wCc));
                            Agd(a, sxe, RCe, iGd(tCc));
                            Agd(a, sxe, SCe, iGd(sCc));
                            Agd(a, sxe, TCe, iGd(uCc));
                            Agd(a, sxe, pCe, iGd(iBc));
                            Agd(a, sxe, qCe, iGd(jBc));
                            Agd(a, sxe, tCe, iGd(DAc));
                            Agd(a, sxe, uCe, iGd(EAc));
                            Agd(a, sxe, mAe, iGd(jCc));
                            Agd(a, sxe, nAe, iGd(lCc));
                            Agd(a, sxe, oAe, iGd(iCc));
                            Agd(a, sxe, pAe, iGd(hCc));
                            Agd(a, sxe, qAe, kCc);
                            Agd(a, sxe, Eze, rBc);
                            Agd(a, sxe, kDe, zAc);
                            Agd(a, sxe, IDe, 0);
                            Agd(a, sxe, bAe, sgb(1));
                            Agd(a, sxe, Dze, Yze);
                            Agd(a, sxe, JDe, iGd(pBc));
                            Agd(a, sxe, eAe, iGd(BBc));
                            Agd(a, sxe, KDe, iGd(GBc));
                            Agd(a, sxe, LDe, iGd(qAc));
                            Agd(a, sxe, MDe, iGd(Rzc));
                            Agd(a, sxe, fDe, iGd(IAc));
                            Agd(a, sxe, cAe, (Geb(), true));
                            Agd(a, sxe, NDe, iGd(NAc));
                            Agd(a, sxe, ODe, iGd(OAc));
                            Agd(a, sxe, jAe, iGd(lBc));
                            Agd(a, sxe, iAe, iGd(oBc));
                            Agd(a, sxe, hAe, iGd(mBc));
                            Agd(a, sxe, PDe, tAc);
                            Agd(a, sxe, kAe, iGd(dBc));
                            Agd(a, sxe, QDe, iGd(cBc));
                            Agd(a, sxe, lAe, iGd(EBc));
                            Agd(a, sxe, RDe, iGd(DBc));
                            Agd(a, sxe, SDe, iGd(FBc));
                            Agd(a, sxe, TDe, uBc);
                            Agd(a, sxe, UDe, iGd(wBc));
                            Agd(a, sxe, VDe, iGd(xBc));
                            Agd(a, sxe, WDe, iGd(yBc));
                            Agd(a, sxe, XDe, iGd(vBc));
                            Agd(a, sxe, PBe, iGd(mCc));
                            Agd(a, sxe, SBe, iGd($Ac));
                            Agd(a, sxe, YBe, iGd(ZAc));
                            Agd(a, sxe, OBe, iGd(gCc));
                            Agd(a, sxe, TBe, iGd(UAc));
                            Agd(a, sxe, RBe, iGd(pAc));
                            Agd(a, sxe, _Be, iGd(oAc));
                            Agd(a, sxe, aCe, iGd(eAc));
                            Agd(a, sxe, hCe, iGd(fAc));
                            Agd(a, sxe, iCe, iGd(hAc));
                            Agd(a, sxe, jCe, iGd(gAc));
                            Agd(a, sxe, cCe, iGd(nAc));
                            Agd(a, sxe, KBe, iGd(aBc));
                            Agd(a, sxe, LBe, iGd(bBc));
                            Agd(a, sxe, JBe, iGd(QAc));
                            Agd(a, sxe, kCe, iGd(kBc));
                            Agd(a, sxe, nCe, iGd(fBc));
                            Agd(a, sxe, IBe, iGd(GAc));
                            Agd(a, sxe, oCe, iGd(hBc));
                            Agd(a, sxe, rCe, iGd(BAc));
                            Agd(a, sxe, sCe, iGd(CAc));
                            Agd(a, sxe, YDe, iGd(dAc));
                            Agd(a, sxe, mCe, iGd(eBc));
                            Agd(a, sxe, ECe, iGd(Xzc));
                            Agd(a, sxe, FCe, iGd(Wzc));
                            Agd(a, sxe, DCe, iGd(Vzc));
                            Agd(a, sxe, GCe, iGd(KAc));
                            Agd(a, sxe, HCe, iGd(JAc));
                            Agd(a, sxe, ICe, iGd(LAc));
                            Agd(a, sxe, CAe, iGd(nBc));
                            Agd(a, sxe, ZDe, iGd(RAc));
                            Agd(a, sxe, Cze, iGd(FAc));
                            Agd(a, sxe, $De, iGd(wAc));
                            Agd(a, sxe, fAe, iGd(vAc));
                            Agd(a, sxe, bCe, iGd(iAc));
                            Agd(a, sxe, _De, iGd(CBc));
                            Agd(a, sxe, aEe, iGd(Uzc));
                            Agd(a, sxe, bEe, iGd(MAc));
                            Agd(a, sxe, cEe, iGd(zBc));
                            Agd(a, sxe, dEe, iGd(sBc));
                            Agd(a, sxe, eEe, iGd(tBc));
                            Agd(a, sxe, WBe, iGd(WAc));
                            Agd(a, sxe, XBe, iGd(XAc));
                            Agd(a, sxe, fEe, iGd(IBc));
                            Agd(a, sxe, MBe, iGd(Szc));
                            Agd(a, sxe, ZBe, iGd(YAc));
                            Agd(a, sxe, UCe, iGd(xAc));
                            Agd(a, sxe, VCe, iGd(uAc));
                            Agd(a, sxe, gEe, iGd(_Ac));
                            Agd(a, sxe, $Be, iGd(SAc));
                            Agd(a, sxe, lCe, iGd(gBc));
                            Agd(a, sxe, hEe, iGd(eCc));
                            Agd(a, sxe, HBe, iGd(sAc));
                            Agd(a, sxe, NBe, iGd(HBc));
                            Agd(a, sxe, vCe, iGd(AAc));
                            Agd(a, sxe, dCe, iGd(jAc));
                            Agd(a, sxe, eCe, iGd(kAc));
                            Agd(a, sxe, UBe, iGd(TAc));
                            Agd(a, sxe, fCe, iGd(lAc));
                            Agd(a, sxe, iEe, iGd(PAc));
                            Agd(a, sxe, VBe, iGd(VAc));
                            Agd(a, sxe, gCe, iGd(mAc));
                            Agd(a, sxe, WCe, iGd(cAc));
                            Agd(a, sxe, $Ce, iGd(_zc));
                            Agd(a, sxe, _Ce, iGd(Zzc));
                            Agd(a, sxe, aDe, iGd($zc));
                            Agd(a, sxe, YCe, iGd(aAc));
                            Agd(a, sxe, ZCe, iGd(Yzc));
                            Agd(a, sxe, XCe, iGd(bAc));
                            Agd(a, sxe, QBe, iGd(HAc));
                        }
                        function yne(a) {
                            _Ad(a.a, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'anySimpleType'
                            ]));
                            _Ad(a.b, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'anyType',
                                rKe,
                                pKe
                            ]));
                            _Ad(RD(QHd(xYd(a.b), 0), 35), qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                rKe,
                                YKe,
                                GIe,
                                ':mixed'
                            ]));
                            _Ad(RD(QHd(xYd(a.b), 1), 35), qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                rKe,
                                YKe,
                                cLe,
                                eLe,
                                GIe,
                                ':1',
                                nLe,
                                'lax'
                            ]));
                            _Ad(RD(QHd(xYd(a.b), 2), 35), qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                rKe,
                                WKe,
                                cLe,
                                eLe,
                                GIe,
                                ':2',
                                nLe,
                                'lax'
                            ]));
                            _Ad(a.c, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'anyURI',
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.d, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'base64Binary',
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.e, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                hve,
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.f, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'boolean:Object',
                                DKe,
                                hve
                            ]));
                            _Ad(a.g, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                dKe
                            ]));
                            _Ad(a.i, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'byte:Object',
                                DKe,
                                dKe
                            ]));
                            _Ad(a.j, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'date',
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.k, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'dateTime',
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.n, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'decimal',
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.o, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                fKe,
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.p, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'double:Object',
                                DKe,
                                fKe
                            ]));
                            _Ad(a.q, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'duration',
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.s, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'ENTITIES',
                                DKe,
                                oLe,
                                pLe,
                                '1'
                            ]));
                            _Ad(a.r, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                oLe,
                                $Ke,
                                qLe
                            ]));
                            _Ad(a.t, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                qLe,
                                DKe,
                                rLe
                            ]));
                            _Ad(a.u, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                gKe,
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.v, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'float:Object',
                                DKe,
                                gKe
                            ]));
                            _Ad(a.w, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'gDay',
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.B, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'gMonth',
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.A, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'gMonthDay',
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.C, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'gYear',
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.D, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'gYearMonth',
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.F, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'hexBinary',
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.G, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'ID',
                                DKe,
                                rLe
                            ]));
                            _Ad(a.H, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'IDREF',
                                DKe,
                                rLe
                            ]));
                            _Ad(a.J, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'IDREFS',
                                DKe,
                                sLe,
                                pLe,
                                '1'
                            ]));
                            _Ad(a.I, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                sLe,
                                $Ke,
                                'IDREF'
                            ]));
                            _Ad(a.K, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                hKe
                            ]));
                            _Ad(a.M, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                tLe
                            ]));
                            _Ad(a.L, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'int:Object',
                                DKe,
                                hKe
                            ]));
                            _Ad(a.P, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'language',
                                DKe,
                                uLe,
                                vLe,
                                wLe
                            ]));
                            _Ad(a.Q, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                iKe
                            ]));
                            _Ad(a.R, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'long:Object',
                                DKe,
                                iKe
                            ]));
                            _Ad(a.S, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'Name',
                                DKe,
                                uLe,
                                vLe,
                                xLe
                            ]));
                            _Ad(a.T, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                rLe,
                                DKe,
                                'Name',
                                vLe,
                                yLe
                            ]));
                            _Ad(a.U, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'negativeInteger',
                                DKe,
                                zLe,
                                ALe,
                                '-1'
                            ]));
                            _Ad(a.V, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                BLe,
                                DKe,
                                uLe,
                                vLe,
                                '\\c+'
                            ]));
                            _Ad(a.X, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'NMTOKENS',
                                DKe,
                                CLe,
                                pLe,
                                '1'
                            ]));
                            _Ad(a.W, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                CLe,
                                $Ke,
                                BLe
                            ]));
                            _Ad(a.Y, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                DLe,
                                DKe,
                                tLe,
                                ELe,
                                '0'
                            ]));
                            _Ad(a.Z, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                zLe,
                                DKe,
                                tLe,
                                ALe,
                                '0'
                            ]));
                            _Ad(a.$, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                FLe,
                                DKe,
                                jve,
                                bLe,
                                'replace'
                            ]));
                            _Ad(a._, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'NOTATION',
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.ab, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'positiveInteger',
                                DKe,
                                DLe,
                                ELe,
                                '1'
                            ]));
                            _Ad(a.bb, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'processingInstruction_._type',
                                rKe,
                                'empty'
                            ]));
                            _Ad(RD(QHd(xYd(a.bb), 0), 35), qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                rKe,
                                VKe,
                                GIe,
                                'data'
                            ]));
                            _Ad(RD(QHd(xYd(a.bb), 1), 35), qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                rKe,
                                VKe,
                                GIe,
                                CIe
                            ]));
                            _Ad(a.cb, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'QName',
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.db, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                jKe
                            ]));
                            _Ad(a.eb, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'short:Object',
                                DKe,
                                jKe
                            ]));
                            _Ad(a.fb, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'simpleAnyType',
                                rKe,
                                UKe
                            ]));
                            _Ad(RD(QHd(xYd(a.fb), 0), 35), qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                ':3',
                                rKe,
                                UKe
                            ]));
                            _Ad(RD(QHd(xYd(a.fb), 1), 35), qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                ':4',
                                rKe,
                                UKe
                            ]));
                            _Ad(RD(QHd(xYd(a.fb), 2), 19), qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                ':5',
                                rKe,
                                UKe
                            ]));
                            _Ad(a.gb, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                jve,
                                bLe,
                                'preserve'
                            ]));
                            _Ad(a.hb, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'time',
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.ib, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                uLe,
                                DKe,
                                FLe,
                                bLe,
                                ZKe
                            ]));
                            _Ad(a.jb, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                GLe,
                                ALe,
                                '255',
                                ELe,
                                '0'
                            ]));
                            _Ad(a.kb, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'unsignedByte:Object',
                                DKe,
                                GLe
                            ]));
                            _Ad(a.lb, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                HLe,
                                ALe,
                                '4294967295',
                                ELe,
                                '0'
                            ]));
                            _Ad(a.mb, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'unsignedInt:Object',
                                DKe,
                                HLe
                            ]));
                            _Ad(a.nb, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'unsignedLong',
                                DKe,
                                DLe,
                                ALe,
                                ILe,
                                ELe,
                                '0'
                            ]));
                            _Ad(a.ob, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                JLe,
                                ALe,
                                '65535',
                                ELe,
                                '0'
                            ]));
                            _Ad(a.pb, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                'unsignedShort:Object',
                                DKe,
                                JLe
                            ]));
                            _Ad(a.qb, qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                GIe,
                                '',
                                rKe,
                                pKe
                            ]));
                            _Ad(RD(QHd(xYd(a.qb), 0), 35), qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                rKe,
                                YKe,
                                GIe,
                                ':mixed'
                            ]));
                            _Ad(RD(QHd(xYd(a.qb), 1), 19), qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                rKe,
                                VKe,
                                GIe,
                                'xmlns:prefix'
                            ]));
                            _Ad(RD(QHd(xYd(a.qb), 2), 19), qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                rKe,
                                VKe,
                                GIe,
                                'xsi:schemaLocation'
                            ]));
                            _Ad(RD(QHd(xYd(a.qb), 3), 35), qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                rKe,
                                XKe,
                                GIe,
                                'cDATA',
                                _Ke,
                                aLe
                            ]));
                            _Ad(RD(QHd(xYd(a.qb), 4), 35), qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                rKe,
                                XKe,
                                GIe,
                                'comment',
                                _Ke,
                                aLe
                            ]));
                            _Ad(RD(QHd(xYd(a.qb), 5), 19), qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                rKe,
                                XKe,
                                GIe,
                                KLe,
                                _Ke,
                                aLe
                            ]));
                            _Ad(RD(QHd(xYd(a.qb), 6), 35), qKe, cD(WC(qJ, 1), Nve, 2, 6, [
                                rKe,
                                XKe,
                                GIe,
                                hIe,
                                _Ke,
                                aLe
                            ]));
                        }
                        function TId(a) {
                            return lhb('_UI_EMFDiagnostic_marker', a) ? 'EMF Problem' : lhb('_UI_CircularContainment_diagnostic', a) ? 'An object may not circularly contain itself' : lhb(TIe, a) ? 'Wrong character.' : lhb(UIe, a) ? 'Invalid reference number.' : lhb(VIe, a) ? 'A character is required after \\.' : lhb(WIe, a) ? "'?' is not expected.  '(?:' or '(?=' or '(?!' or '(?<' or '(?#' or '(?>'?" : lhb(XIe, a) ? "'(?<' or '(?<!' is expected." : lhb(YIe, a) ? 'A comment is not terminated.' : lhb(ZIe, a) ? "')' is expected." : lhb($Ie, a) ? 'Unexpected end of the pattern in a modifier group.' : lhb(_Ie, a) ? "':' is expected." : lhb(aJe, a) ? 'Unexpected end of the pattern in a conditional group.' : lhb(bJe, a) ? 'A back reference or an anchor or a lookahead or a look-behind is expected in a conditional pattern.' : lhb(cJe, a) ? 'There are more than three choices in a conditional group.' : lhb(dJe, a) ? 'A character in U+0040-U+005f must follow \\c.' : lhb(eJe, a) ? "A '{' is required before a character category." : lhb(fJe, a) ? "A property name is not closed by '}'." : lhb(gJe, a) ? 'Unexpected meta character.' : lhb(hJe, a) ? 'Unknown property.' : lhb(iJe, a) ? "A POSIX character class must be closed by ':]'." : lhb(jJe, a) ? 'Unexpected end of the pattern in a character class.' : lhb(kJe, a) ? 'Unknown name for a POSIX character class.' : lhb('parser.cc.4', a) ? "'-' is invalid here." : lhb(lJe, a) ? "']' is expected." : lhb(mJe, a) ? "'[' is invalid in a character class.  Write '\\['." : lhb(nJe, a) ? "']' is invalid in a character class.  Write '\\]'." : lhb(oJe, a) ? "'-' is an invalid character range. Write '\\-'." : lhb(pJe, a) ? "'[' is expected." : lhb(qJe, a) ? "')' or '-[' or '+[' or '&[' is expected." : lhb(rJe, a) ? 'The range end code point is less than the start code point.' : lhb(sJe, a) ? 'Invalid Unicode hex notation.' : lhb(tJe, a) ? 'Overflow in a hex notation.' : lhb(uJe, a) ? "'\\x{' must be closed by '}'." : lhb(vJe, a) ? 'Invalid Unicode code point.' : lhb(wJe, a) ? 'An anchor must not be here.' : lhb(xJe, a) ? 'This expression is not supported in the current option setting.' : lhb(yJe, a) ? 'Invalid quantifier. A digit is expected.' : lhb(zJe, a) ? "Invalid quantifier. Invalid quantity or a '}' is missing." : lhb(AJe, a) ? "Invalid quantifier. A digit or '}' is expected." : lhb(BJe, a) ? 'Invalid quantifier. A min quantity must be <= a max quantity.' : lhb(CJe, a) ? 'Invalid quantifier. A quantity value overflow.' : lhb('_UI_PackageRegistry_extensionpoint', a) ? 'Ecore Package Registry for Generated Packages' : lhb('_UI_DynamicPackageRegistry_extensionpoint', a) ? 'Ecore Package Registry for Dynamic Packages' : lhb('_UI_FactoryRegistry_extensionpoint', a) ? 'Ecore Factory Override Registry' : lhb('_UI_URIExtensionParserRegistry_extensionpoint', a) ? 'URI Extension Parser Registry' : lhb('_UI_URIProtocolParserRegistry_extensionpoint', a) ? 'URI Protocol Parser Registry' : lhb('_UI_URIContentParserRegistry_extensionpoint', a) ? 'URI Content Parser Registry' : lhb('_UI_ContentHandlerRegistry_extensionpoint', a) ? 'Content Handler Registry' : lhb('_UI_URIMappingRegistry_extensionpoint', a) ? 'URI Converter Mapping Registry' : lhb('_UI_PackageRegistryImplementation_extensionpoint', a) ? 'Ecore Package Registry Implementation' : lhb('_UI_ValidationDelegateRegistry_extensionpoint', a) ? 'Validation Delegate Registry' : lhb('_UI_SettingDelegateRegistry_extensionpoint', a) ? 'Feature Setting Delegate Factory Registry' : lhb('_UI_InvocationDelegateRegistry_extensionpoint', a) ? 'Operation Invocation Delegate Factory Registry' : lhb('_UI_EClassInterfaceNotAbstract_diagnostic', a) ? 'A class that is an interface must also be abstract' : lhb('_UI_EClassNoCircularSuperTypes_diagnostic', a) ? 'A class may not be a super type of itself' : lhb('_UI_EClassNotWellFormedMapEntryNoInstanceClassName_diagnostic', a) ? "A class that inherits from a map entry class must have instance class name 'java.util.Map$Entry'" : lhb('_UI_EReferenceOppositeOfOppositeInconsistent_diagnostic', a) ? 'The opposite of the opposite may not be a reference different from this one' : lhb('_UI_EReferenceOppositeNotFeatureOfType_diagnostic', a) ? "The opposite must be a feature of the reference's type" : lhb('_UI_EReferenceTransientOppositeNotTransient_diagnostic', a) ? 'The opposite of a transient reference must be transient if it is proxy resolving' : lhb('_UI_EReferenceOppositeBothContainment_diagnostic', a) ? 'The opposite of a containment reference must not be a containment reference' : lhb('_UI_EReferenceConsistentUnique_diagnostic', a) ? 'A containment or bidirectional reference must be unique if its upper bound is different from 1' : lhb('_UI_ETypedElementNoType_diagnostic', a) ? 'The typed element must have a type' : lhb('_UI_EAttributeNoDataType_diagnostic', a) ? 'The generic attribute type must not refer to a class' : lhb('_UI_EReferenceNoClass_diagnostic', a) ? 'The generic reference type must not refer to a data type' : lhb('_UI_EGenericTypeNoTypeParameterAndClassifier_diagnostic', a) ? "A generic type can't refer to both a type parameter and a classifier" : lhb('_UI_EGenericTypeNoClass_diagnostic', a) ? 'A generic super type must refer to a class' : lhb('_UI_EGenericTypeNoTypeParameterOrClassifier_diagnostic', a) ? 'A generic type in this context must refer to a classifier or a type parameter' : lhb('_UI_EGenericTypeBoundsOnlyForTypeArgument_diagnostic', a) ? 'A generic type may have bounds only when used as a type argument' : lhb('_UI_EGenericTypeNoUpperAndLowerBound_diagnostic', a) ? 'A generic type must not have both a lower and an upper bound' : lhb('_UI_EGenericTypeNoTypeParameterOrClassifierAndBound_diagnostic', a) ? 'A generic type with bounds must not also refer to a type parameter or classifier' : lhb('_UI_EGenericTypeNoArguments_diagnostic', a) ? 'A generic type may have arguments only if it refers to a classifier' : lhb('_UI_EGenericTypeOutOfScopeTypeParameter_diagnostic', a) ? 'A generic type may only refer to a type parameter that is in scope' : a;
                        }
                        function $Bd(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p;
                            if (a.r) return;
                            a.r = true;
                            PAd(a, 'graph');
                            CBd(a, 'graph');
                            DBd(a, $He);
                            eBd(a.o, 'T');
                            WGd(zYd(a.a), a.p);
                            WGd(zYd(a.f), a.a);
                            WGd(zYd(a.n), a.f);
                            WGd(zYd(a.g), a.n);
                            WGd(zYd(a.c), a.n);
                            WGd(zYd(a.i), a.c);
                            WGd(zYd(a.j), a.c);
                            WGd(zYd(a.d), a.f);
                            WGd(zYd(a.e), a.a);
                            vBd(a.p, U5, kze, true, true, false);
                            o = bBd(a.p, a.p, 'setProperty');
                            p = fBd(o);
                            j = lBd(a.o);
                            k = (c = (d = new s2d, d), c);
                            WGd((!j.d && (j.d = new XZd(o7, j, 1)), j.d), k);
                            l = mBd(p);
                            n2d(k, l);
                            dBd(o, j, _He);
                            j = mBd(p);
                            dBd(o, j, aIe);
                            o = bBd(a.p, null, 'getProperty');
                            p = fBd(o);
                            j = lBd(a.o);
                            k = mBd(p);
                            WGd((!j.d && (j.d = new XZd(o7, j, 1)), j.d), k);
                            dBd(o, j, _He);
                            j = mBd(p);
                            n = XVd(o, j, null);
                            !!n && n.oj();
                            o = bBd(a.p, a.wb.e, 'hasProperty');
                            j = lBd(a.o);
                            k = (e = (f = new s2d, f), e);
                            WGd((!j.d && (j.d = new XZd(o7, j, 1)), j.d), k);
                            dBd(o, j, _He);
                            o = bBd(a.p, a.p, 'copyProperties');
                            cBd(o, a.p, bIe);
                            o = bBd(a.p, null, 'getAllProperties');
                            j = lBd(a.wb.P);
                            k = lBd(a.o);
                            WGd((!j.d && (j.d = new XZd(o7, j, 1)), j.d), k);
                            l = (g = (h = new s2d, h), g);
                            WGd((!k.d && (k.d = new XZd(o7, k, 1)), k.d), l);
                            k = lBd(a.wb.M);
                            WGd((!j.d && (j.d = new XZd(o7, j, 1)), j.d), k);
                            m = XVd(o, j, null);
                            !!m && m.oj();
                            vBd(a.a, C4, xHe, true, false, true);
                            zBd(RD(QHd(xYd(a.a), 0), 19), a.k, null, cIe, 0, -1, C4, false, false, true, true, false, false, false);
                            vBd(a.f, H4, zHe, true, false, true);
                            zBd(RD(QHd(xYd(a.f), 0), 19), a.g, RD(QHd(xYd(a.g), 0), 19), 'labels', 0, -1, H4, false, false, true, true, false, false, false);
                            tBd(RD(QHd(xYd(a.f), 1), 35), a.wb._, dIe, null, 0, 1, H4, false, false, true, false, true, false);
                            vBd(a.n, L4, 'ElkShape', true, false, true);
                            tBd(RD(QHd(xYd(a.n), 0), 35), a.wb.t, eIe, zxe, 1, 1, L4, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.n), 1), 35), a.wb.t, fIe, zxe, 1, 1, L4, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.n), 2), 35), a.wb.t, 'x', zxe, 1, 1, L4, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.n), 3), 35), a.wb.t, 'y', zxe, 1, 1, L4, false, false, true, false, true, false);
                            o = bBd(a.n, null, 'setDimensions');
                            cBd(o, a.wb.t, fIe);
                            cBd(o, a.wb.t, eIe);
                            o = bBd(a.n, null, 'setLocation');
                            cBd(o, a.wb.t, 'x');
                            cBd(o, a.wb.t, 'y');
                            vBd(a.g, I4, FHe, false, false, true);
                            zBd(RD(QHd(xYd(a.g), 0), 19), a.f, RD(QHd(xYd(a.f), 0), 19), gIe, 0, 1, I4, false, false, true, false, false, false, false);
                            tBd(RD(QHd(xYd(a.g), 1), 35), a.wb._, hIe, '', 0, 1, I4, false, false, true, false, true, false);
                            vBd(a.c, E4, AHe, true, false, true);
                            zBd(RD(QHd(xYd(a.c), 0), 19), a.d, RD(QHd(xYd(a.d), 1), 19), 'outgoingEdges', 0, -1, E4, false, false, true, false, true, false, false);
                            zBd(RD(QHd(xYd(a.c), 1), 19), a.d, RD(QHd(xYd(a.d), 2), 19), 'incomingEdges', 0, -1, E4, false, false, true, false, true, false, false);
                            vBd(a.i, J4, GHe, false, false, true);
                            zBd(RD(QHd(xYd(a.i), 0), 19), a.j, RD(QHd(xYd(a.j), 0), 19), 'ports', 0, -1, J4, false, false, true, true, false, false, false);
                            zBd(RD(QHd(xYd(a.i), 1), 19), a.i, RD(QHd(xYd(a.i), 2), 19), iIe, 0, -1, J4, false, false, true, true, false, false, false);
                            zBd(RD(QHd(xYd(a.i), 2), 19), a.i, RD(QHd(xYd(a.i), 1), 19), gIe, 0, 1, J4, false, false, true, false, false, false, false);
                            zBd(RD(QHd(xYd(a.i), 3), 19), a.d, RD(QHd(xYd(a.d), 0), 19), 'containedEdges', 0, -1, J4, false, false, true, true, false, false, false);
                            tBd(RD(QHd(xYd(a.i), 4), 35), a.wb.e, jIe, null, 0, 1, J4, true, true, false, false, true, true);
                            vBd(a.j, K4, HHe, false, false, true);
                            zBd(RD(QHd(xYd(a.j), 0), 19), a.i, RD(QHd(xYd(a.i), 0), 19), gIe, 0, 1, K4, false, false, true, false, false, false, false);
                            vBd(a.d, G4, BHe, false, false, true);
                            zBd(RD(QHd(xYd(a.d), 0), 19), a.i, RD(QHd(xYd(a.i), 3), 19), 'containingNode', 0, 1, G4, false, false, true, false, false, false, false);
                            zBd(RD(QHd(xYd(a.d), 1), 19), a.c, RD(QHd(xYd(a.c), 0), 19), kIe, 0, -1, G4, false, false, true, false, true, false, false);
                            zBd(RD(QHd(xYd(a.d), 2), 19), a.c, RD(QHd(xYd(a.c), 1), 19), lIe, 0, -1, G4, false, false, true, false, true, false, false);
                            zBd(RD(QHd(xYd(a.d), 3), 19), a.e, RD(QHd(xYd(a.e), 5), 19), mIe, 0, -1, G4, false, false, true, true, false, false, false);
                            tBd(RD(QHd(xYd(a.d), 4), 35), a.wb.e, 'hyperedge', null, 0, 1, G4, true, true, false, false, true, true);
                            tBd(RD(QHd(xYd(a.d), 5), 35), a.wb.e, jIe, null, 0, 1, G4, true, true, false, false, true, true);
                            tBd(RD(QHd(xYd(a.d), 6), 35), a.wb.e, 'selfloop', null, 0, 1, G4, true, true, false, false, true, true);
                            tBd(RD(QHd(xYd(a.d), 7), 35), a.wb.e, 'connected', null, 0, 1, G4, true, true, false, false, true, true);
                            vBd(a.b, D4, yHe, false, false, true);
                            tBd(RD(QHd(xYd(a.b), 0), 35), a.wb.t, 'x', zxe, 1, 1, D4, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.b), 1), 35), a.wb.t, 'y', zxe, 1, 1, D4, false, false, true, false, true, false);
                            o = bBd(a.b, null, 'set');
                            cBd(o, a.wb.t, 'x');
                            cBd(o, a.wb.t, 'y');
                            vBd(a.e, F4, CHe, false, false, true);
                            tBd(RD(QHd(xYd(a.e), 0), 35), a.wb.t, 'startX', null, 0, 1, F4, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.e), 1), 35), a.wb.t, 'startY', null, 0, 1, F4, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.e), 2), 35), a.wb.t, 'endX', null, 0, 1, F4, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.e), 3), 35), a.wb.t, 'endY', null, 0, 1, F4, false, false, true, false, true, false);
                            zBd(RD(QHd(xYd(a.e), 4), 19), a.b, null, nIe, 0, -1, F4, false, false, true, true, false, false, false);
                            zBd(RD(QHd(xYd(a.e), 5), 19), a.d, RD(QHd(xYd(a.d), 3), 19), gIe, 0, 1, F4, false, false, true, false, false, false, false);
                            zBd(RD(QHd(xYd(a.e), 6), 19), a.c, null, oIe, 0, 1, F4, false, false, true, false, true, false, false);
                            zBd(RD(QHd(xYd(a.e), 7), 19), a.c, null, pIe, 0, 1, F4, false, false, true, false, true, false, false);
                            zBd(RD(QHd(xYd(a.e), 8), 19), a.e, RD(QHd(xYd(a.e), 9), 19), qIe, 0, -1, F4, false, false, true, false, true, false, false);
                            zBd(RD(QHd(xYd(a.e), 9), 19), a.e, RD(QHd(xYd(a.e), 8), 19), rIe, 0, -1, F4, false, false, true, false, true, false, false);
                            tBd(RD(QHd(xYd(a.e), 10), 35), a.wb._, dIe, null, 0, 1, F4, false, false, true, false, true, false);
                            o = bBd(a.e, null, 'setStartLocation');
                            cBd(o, a.wb.t, 'x');
                            cBd(o, a.wb.t, 'y');
                            o = bBd(a.e, null, 'setEndLocation');
                            cBd(o, a.wb.t, 'x');
                            cBd(o, a.wb.t, 'y');
                            vBd(a.k, UK, 'ElkPropertyToValueMapEntry', false, false, false);
                            j = lBd(a.o);
                            k = (i = (b = new s2d, b), i);
                            WGd((!j.d && (j.d = new XZd(o7, j, 1)), j.d), k);
                            uBd(RD(QHd(xYd(a.k), 0), 35), j, 'key', UK, false, false, true, false);
                            tBd(RD(QHd(xYd(a.k), 1), 35), a.s, aIe, null, 0, 1, UK, false, false, true, false, true, false);
                            xBd(a.o, V5, 'IProperty', true);
                            xBd(a.s, jJ, 'PropertyValue', true);
                            pBd(a, $He);
                        }
                        function Kqe() {
                            Kqe = geb;
                            Jqe = $C(gE, YHe, 28, txe, 15, 1);
                            Jqe[9] = 35;
                            Jqe[10] = 19;
                            Jqe[13] = 19;
                            Jqe[32] = 51;
                            Jqe[33] = 49;
                            Jqe[34] = 33;
                            Knb(Jqe, 35, 38, 49);
                            Jqe[38] = 1;
                            Knb(Jqe, 39, 45, 49);
                            Knb(Jqe, 45, 47, -71);
                            Jqe[47] = 49;
                            Knb(Jqe, 48, 58, -71);
                            Jqe[58] = 61;
                            Jqe[59] = 49;
                            Jqe[60] = 1;
                            Jqe[61] = 49;
                            Jqe[62] = 33;
                            Knb(Jqe, 63, 65, 49);
                            Knb(Jqe, 65, 91, -3);
                            Knb(Jqe, 91, 93, 33);
                            Jqe[93] = 1;
                            Jqe[94] = 33;
                            Jqe[95] = -3;
                            Jqe[96] = 33;
                            Knb(Jqe, 97, 123, -3);
                            Knb(Jqe, 123, 183, 33);
                            Jqe[183] = -87;
                            Knb(Jqe, 184, 192, 33);
                            Knb(Jqe, 192, 215, -19);
                            Jqe[215] = 33;
                            Knb(Jqe, 216, 247, -19);
                            Jqe[247] = 33;
                            Knb(Jqe, 248, 306, -19);
                            Knb(Jqe, 306, 308, 33);
                            Knb(Jqe, 308, 319, -19);
                            Knb(Jqe, 319, 321, 33);
                            Knb(Jqe, 321, 329, -19);
                            Jqe[329] = 33;
                            Knb(Jqe, 330, 383, -19);
                            Jqe[383] = 33;
                            Knb(Jqe, 384, 452, -19);
                            Knb(Jqe, 452, 461, 33);
                            Knb(Jqe, 461, 497, -19);
                            Knb(Jqe, 497, 500, 33);
                            Knb(Jqe, 500, 502, -19);
                            Knb(Jqe, 502, 506, 33);
                            Knb(Jqe, 506, 536, -19);
                            Knb(Jqe, 536, 592, 33);
                            Knb(Jqe, 592, 681, -19);
                            Knb(Jqe, 681, 699, 33);
                            Knb(Jqe, 699, 706, -19);
                            Knb(Jqe, 706, 720, 33);
                            Knb(Jqe, 720, 722, -87);
                            Knb(Jqe, 722, 768, 33);
                            Knb(Jqe, 768, 838, -87);
                            Knb(Jqe, 838, 864, 33);
                            Knb(Jqe, 864, 866, -87);
                            Knb(Jqe, 866, 902, 33);
                            Jqe[902] = -19;
                            Jqe[903] = -87;
                            Knb(Jqe, 904, 907, -19);
                            Jqe[907] = 33;
                            Jqe[908] = -19;
                            Jqe[909] = 33;
                            Knb(Jqe, 910, 930, -19);
                            Jqe[930] = 33;
                            Knb(Jqe, 931, 975, -19);
                            Jqe[975] = 33;
                            Knb(Jqe, 976, 983, -19);
                            Knb(Jqe, 983, 986, 33);
                            Jqe[986] = -19;
                            Jqe[987] = 33;
                            Jqe[988] = -19;
                            Jqe[989] = 33;
                            Jqe[990] = -19;
                            Jqe[991] = 33;
                            Jqe[992] = -19;
                            Jqe[993] = 33;
                            Knb(Jqe, 994, 1012, -19);
                            Knb(Jqe, 1012, 1025, 33);
                            Knb(Jqe, 1025, 1037, -19);
                            Jqe[1037] = 33;
                            Knb(Jqe, 1038, 1104, -19);
                            Jqe[1104] = 33;
                            Knb(Jqe, 1105, 1117, -19);
                            Jqe[1117] = 33;
                            Knb(Jqe, 1118, 1154, -19);
                            Jqe[1154] = 33;
                            Knb(Jqe, 1155, 1159, -87);
                            Knb(Jqe, 1159, 1168, 33);
                            Knb(Jqe, 1168, 1221, -19);
                            Knb(Jqe, 1221, 1223, 33);
                            Knb(Jqe, 1223, 1225, -19);
                            Knb(Jqe, 1225, 1227, 33);
                            Knb(Jqe, 1227, 1229, -19);
                            Knb(Jqe, 1229, 1232, 33);
                            Knb(Jqe, 1232, 1260, -19);
                            Knb(Jqe, 1260, 1262, 33);
                            Knb(Jqe, 1262, 1270, -19);
                            Knb(Jqe, 1270, 1272, 33);
                            Knb(Jqe, 1272, 1274, -19);
                            Knb(Jqe, 1274, 1329, 33);
                            Knb(Jqe, 1329, 1367, -19);
                            Knb(Jqe, 1367, 1369, 33);
                            Jqe[1369] = -19;
                            Knb(Jqe, 1370, 1377, 33);
                            Knb(Jqe, 1377, 1415, -19);
                            Knb(Jqe, 1415, 1425, 33);
                            Knb(Jqe, 1425, 1442, -87);
                            Jqe[1442] = 33;
                            Knb(Jqe, 1443, 1466, -87);
                            Jqe[1466] = 33;
                            Knb(Jqe, 1467, 1470, -87);
                            Jqe[1470] = 33;
                            Jqe[1471] = -87;
                            Jqe[1472] = 33;
                            Knb(Jqe, 1473, 1475, -87);
                            Jqe[1475] = 33;
                            Jqe[1476] = -87;
                            Knb(Jqe, 1477, 1488, 33);
                            Knb(Jqe, 1488, 1515, -19);
                            Knb(Jqe, 1515, 1520, 33);
                            Knb(Jqe, 1520, 1523, -19);
                            Knb(Jqe, 1523, 1569, 33);
                            Knb(Jqe, 1569, 1595, -19);
                            Knb(Jqe, 1595, 1600, 33);
                            Jqe[1600] = -87;
                            Knb(Jqe, 1601, 1611, -19);
                            Knb(Jqe, 1611, 1619, -87);
                            Knb(Jqe, 1619, 1632, 33);
                            Knb(Jqe, 1632, 1642, -87);
                            Knb(Jqe, 1642, 1648, 33);
                            Jqe[1648] = -87;
                            Knb(Jqe, 1649, 1720, -19);
                            Knb(Jqe, 1720, 1722, 33);
                            Knb(Jqe, 1722, 1727, -19);
                            Jqe[1727] = 33;
                            Knb(Jqe, 1728, 1743, -19);
                            Jqe[1743] = 33;
                            Knb(Jqe, 1744, 1748, -19);
                            Jqe[1748] = 33;
                            Jqe[1749] = -19;
                            Knb(Jqe, 1750, 1765, -87);
                            Knb(Jqe, 1765, 1767, -19);
                            Knb(Jqe, 1767, 1769, -87);
                            Jqe[1769] = 33;
                            Knb(Jqe, 1770, 1774, -87);
                            Knb(Jqe, 1774, 1776, 33);
                            Knb(Jqe, 1776, 1786, -87);
                            Knb(Jqe, 1786, 2305, 33);
                            Knb(Jqe, 2305, 2308, -87);
                            Jqe[2308] = 33;
                            Knb(Jqe, 2309, 2362, -19);
                            Knb(Jqe, 2362, 2364, 33);
                            Jqe[2364] = -87;
                            Jqe[2365] = -19;
                            Knb(Jqe, 2366, 2382, -87);
                            Knb(Jqe, 2382, 2385, 33);
                            Knb(Jqe, 2385, 2389, -87);
                            Knb(Jqe, 2389, 2392, 33);
                            Knb(Jqe, 2392, 2402, -19);
                            Knb(Jqe, 2402, 2404, -87);
                            Knb(Jqe, 2404, 2406, 33);
                            Knb(Jqe, 2406, 2416, -87);
                            Knb(Jqe, 2416, 2433, 33);
                            Knb(Jqe, 2433, 2436, -87);
                            Jqe[2436] = 33;
                            Knb(Jqe, 2437, 2445, -19);
                            Knb(Jqe, 2445, 2447, 33);
                            Knb(Jqe, 2447, 2449, -19);
                            Knb(Jqe, 2449, 2451, 33);
                            Knb(Jqe, 2451, 2473, -19);
                            Jqe[2473] = 33;
                            Knb(Jqe, 2474, 2481, -19);
                            Jqe[2481] = 33;
                            Jqe[2482] = -19;
                            Knb(Jqe, 2483, 2486, 33);
                            Knb(Jqe, 2486, 2490, -19);
                            Knb(Jqe, 2490, 2492, 33);
                            Jqe[2492] = -87;
                            Jqe[2493] = 33;
                            Knb(Jqe, 2494, 2501, -87);
                            Knb(Jqe, 2501, 2503, 33);
                            Knb(Jqe, 2503, 2505, -87);
                            Knb(Jqe, 2505, 2507, 33);
                            Knb(Jqe, 2507, 2510, -87);
                            Knb(Jqe, 2510, 2519, 33);
                            Jqe[2519] = -87;
                            Knb(Jqe, 2520, 2524, 33);
                            Knb(Jqe, 2524, 2526, -19);
                            Jqe[2526] = 33;
                            Knb(Jqe, 2527, 2530, -19);
                            Knb(Jqe, 2530, 2532, -87);
                            Knb(Jqe, 2532, 2534, 33);
                            Knb(Jqe, 2534, 2544, -87);
                            Knb(Jqe, 2544, 2546, -19);
                            Knb(Jqe, 2546, 2562, 33);
                            Jqe[2562] = -87;
                            Knb(Jqe, 2563, 2565, 33);
                            Knb(Jqe, 2565, 2571, -19);
                            Knb(Jqe, 2571, 2575, 33);
                            Knb(Jqe, 2575, 2577, -19);
                            Knb(Jqe, 2577, 2579, 33);
                            Knb(Jqe, 2579, 2601, -19);
                            Jqe[2601] = 33;
                            Knb(Jqe, 2602, 2609, -19);
                            Jqe[2609] = 33;
                            Knb(Jqe, 2610, 2612, -19);
                            Jqe[2612] = 33;
                            Knb(Jqe, 2613, 2615, -19);
                            Jqe[2615] = 33;
                            Knb(Jqe, 2616, 2618, -19);
                            Knb(Jqe, 2618, 2620, 33);
                            Jqe[2620] = -87;
                            Jqe[2621] = 33;
                            Knb(Jqe, 2622, 2627, -87);
                            Knb(Jqe, 2627, 2631, 33);
                            Knb(Jqe, 2631, 2633, -87);
                            Knb(Jqe, 2633, 2635, 33);
                            Knb(Jqe, 2635, 2638, -87);
                            Knb(Jqe, 2638, 2649, 33);
                            Knb(Jqe, 2649, 2653, -19);
                            Jqe[2653] = 33;
                            Jqe[2654] = -19;
                            Knb(Jqe, 2655, 2662, 33);
                            Knb(Jqe, 2662, 2674, -87);
                            Knb(Jqe, 2674, 2677, -19);
                            Knb(Jqe, 2677, 2689, 33);
                            Knb(Jqe, 2689, 2692, -87);
                            Jqe[2692] = 33;
                            Knb(Jqe, 2693, 2700, -19);
                            Jqe[2700] = 33;
                            Jqe[2701] = -19;
                            Jqe[2702] = 33;
                            Knb(Jqe, 2703, 2706, -19);
                            Jqe[2706] = 33;
                            Knb(Jqe, 2707, 2729, -19);
                            Jqe[2729] = 33;
                            Knb(Jqe, 2730, 2737, -19);
                            Jqe[2737] = 33;
                            Knb(Jqe, 2738, 2740, -19);
                            Jqe[2740] = 33;
                            Knb(Jqe, 2741, 2746, -19);
                            Knb(Jqe, 2746, 2748, 33);
                            Jqe[2748] = -87;
                            Jqe[2749] = -19;
                            Knb(Jqe, 2750, 2758, -87);
                            Jqe[2758] = 33;
                            Knb(Jqe, 2759, 2762, -87);
                            Jqe[2762] = 33;
                            Knb(Jqe, 2763, 2766, -87);
                            Knb(Jqe, 2766, 2784, 33);
                            Jqe[2784] = -19;
                            Knb(Jqe, 2785, 2790, 33);
                            Knb(Jqe, 2790, 2800, -87);
                            Knb(Jqe, 2800, 2817, 33);
                            Knb(Jqe, 2817, 2820, -87);
                            Jqe[2820] = 33;
                            Knb(Jqe, 2821, 2829, -19);
                            Knb(Jqe, 2829, 2831, 33);
                            Knb(Jqe, 2831, 2833, -19);
                            Knb(Jqe, 2833, 2835, 33);
                            Knb(Jqe, 2835, 2857, -19);
                            Jqe[2857] = 33;
                            Knb(Jqe, 2858, 2865, -19);
                            Jqe[2865] = 33;
                            Knb(Jqe, 2866, 2868, -19);
                            Knb(Jqe, 2868, 2870, 33);
                            Knb(Jqe, 2870, 2874, -19);
                            Knb(Jqe, 2874, 2876, 33);
                            Jqe[2876] = -87;
                            Jqe[2877] = -19;
                            Knb(Jqe, 2878, 2884, -87);
                            Knb(Jqe, 2884, 2887, 33);
                            Knb(Jqe, 2887, 2889, -87);
                            Knb(Jqe, 2889, 2891, 33);
                            Knb(Jqe, 2891, 2894, -87);
                            Knb(Jqe, 2894, 2902, 33);
                            Knb(Jqe, 2902, 2904, -87);
                            Knb(Jqe, 2904, 2908, 33);
                            Knb(Jqe, 2908, 2910, -19);
                            Jqe[2910] = 33;
                            Knb(Jqe, 2911, 2914, -19);
                            Knb(Jqe, 2914, 2918, 33);
                            Knb(Jqe, 2918, 2928, -87);
                            Knb(Jqe, 2928, 2946, 33);
                            Knb(Jqe, 2946, 2948, -87);
                            Jqe[2948] = 33;
                            Knb(Jqe, 2949, 2955, -19);
                            Knb(Jqe, 2955, 2958, 33);
                            Knb(Jqe, 2958, 2961, -19);
                            Jqe[2961] = 33;
                            Knb(Jqe, 2962, 2966, -19);
                            Knb(Jqe, 2966, 2969, 33);
                            Knb(Jqe, 2969, 2971, -19);
                            Jqe[2971] = 33;
                            Jqe[2972] = -19;
                            Jqe[2973] = 33;
                            Knb(Jqe, 2974, 2976, -19);
                            Knb(Jqe, 2976, 2979, 33);
                            Knb(Jqe, 2979, 2981, -19);
                            Knb(Jqe, 2981, 2984, 33);
                            Knb(Jqe, 2984, 2987, -19);
                            Knb(Jqe, 2987, 2990, 33);
                            Knb(Jqe, 2990, 2998, -19);
                            Jqe[2998] = 33;
                            Knb(Jqe, 2999, 3002, -19);
                            Knb(Jqe, 3002, 3006, 33);
                            Knb(Jqe, 3006, 3011, -87);
                            Knb(Jqe, 3011, 3014, 33);
                            Knb(Jqe, 3014, 3017, -87);
                            Jqe[3017] = 33;
                            Knb(Jqe, 3018, 3022, -87);
                            Knb(Jqe, 3022, 3031, 33);
                            Jqe[3031] = -87;
                            Knb(Jqe, 3032, 3047, 33);
                            Knb(Jqe, 3047, 3056, -87);
                            Knb(Jqe, 3056, 3073, 33);
                            Knb(Jqe, 3073, 3076, -87);
                            Jqe[3076] = 33;
                            Knb(Jqe, 3077, 3085, -19);
                            Jqe[3085] = 33;
                            Knb(Jqe, 3086, 3089, -19);
                            Jqe[3089] = 33;
                            Knb(Jqe, 3090, 3113, -19);
                            Jqe[3113] = 33;
                            Knb(Jqe, 3114, 3124, -19);
                            Jqe[3124] = 33;
                            Knb(Jqe, 3125, 3130, -19);
                            Knb(Jqe, 3130, 3134, 33);
                            Knb(Jqe, 3134, 3141, -87);
                            Jqe[3141] = 33;
                            Knb(Jqe, 3142, 3145, -87);
                            Jqe[3145] = 33;
                            Knb(Jqe, 3146, 3150, -87);
                            Knb(Jqe, 3150, 3157, 33);
                            Knb(Jqe, 3157, 3159, -87);
                            Knb(Jqe, 3159, 3168, 33);
                            Knb(Jqe, 3168, 3170, -19);
                            Knb(Jqe, 3170, 3174, 33);
                            Knb(Jqe, 3174, 3184, -87);
                            Knb(Jqe, 3184, 3202, 33);
                            Knb(Jqe, 3202, 3204, -87);
                            Jqe[3204] = 33;
                            Knb(Jqe, 3205, 3213, -19);
                            Jqe[3213] = 33;
                            Knb(Jqe, 3214, 3217, -19);
                            Jqe[3217] = 33;
                            Knb(Jqe, 3218, 3241, -19);
                            Jqe[3241] = 33;
                            Knb(Jqe, 3242, 3252, -19);
                            Jqe[3252] = 33;
                            Knb(Jqe, 3253, 3258, -19);
                            Knb(Jqe, 3258, 3262, 33);
                            Knb(Jqe, 3262, 3269, -87);
                            Jqe[3269] = 33;
                            Knb(Jqe, 3270, 3273, -87);
                            Jqe[3273] = 33;
                            Knb(Jqe, 3274, 3278, -87);
                            Knb(Jqe, 3278, 3285, 33);
                            Knb(Jqe, 3285, 3287, -87);
                            Knb(Jqe, 3287, 3294, 33);
                            Jqe[3294] = -19;
                            Jqe[3295] = 33;
                            Knb(Jqe, 3296, 3298, -19);
                            Knb(Jqe, 3298, 3302, 33);
                            Knb(Jqe, 3302, 3312, -87);
                            Knb(Jqe, 3312, 3330, 33);
                            Knb(Jqe, 3330, 3332, -87);
                            Jqe[3332] = 33;
                            Knb(Jqe, 3333, 3341, -19);
                            Jqe[3341] = 33;
                            Knb(Jqe, 3342, 3345, -19);
                            Jqe[3345] = 33;
                            Knb(Jqe, 3346, 3369, -19);
                            Jqe[3369] = 33;
                            Knb(Jqe, 3370, 3386, -19);
                            Knb(Jqe, 3386, 3390, 33);
                            Knb(Jqe, 3390, 3396, -87);
                            Knb(Jqe, 3396, 3398, 33);
                            Knb(Jqe, 3398, 3401, -87);
                            Jqe[3401] = 33;
                            Knb(Jqe, 3402, 3406, -87);
                            Knb(Jqe, 3406, 3415, 33);
                            Jqe[3415] = -87;
                            Knb(Jqe, 3416, 3424, 33);
                            Knb(Jqe, 3424, 3426, -19);
                            Knb(Jqe, 3426, 3430, 33);
                            Knb(Jqe, 3430, 3440, -87);
                            Knb(Jqe, 3440, 3585, 33);
                            Knb(Jqe, 3585, 3631, -19);
                            Jqe[3631] = 33;
                            Jqe[3632] = -19;
                            Jqe[3633] = -87;
                            Knb(Jqe, 3634, 3636, -19);
                            Knb(Jqe, 3636, 3643, -87);
                            Knb(Jqe, 3643, 3648, 33);
                            Knb(Jqe, 3648, 3654, -19);
                            Knb(Jqe, 3654, 3663, -87);
                            Jqe[3663] = 33;
                            Knb(Jqe, 3664, 3674, -87);
                            Knb(Jqe, 3674, 3713, 33);
                            Knb(Jqe, 3713, 3715, -19);
                            Jqe[3715] = 33;
                            Jqe[3716] = -19;
                            Knb(Jqe, 3717, 3719, 33);
                            Knb(Jqe, 3719, 3721, -19);
                            Jqe[3721] = 33;
                            Jqe[3722] = -19;
                            Knb(Jqe, 3723, 3725, 33);
                            Jqe[3725] = -19;
                            Knb(Jqe, 3726, 3732, 33);
                            Knb(Jqe, 3732, 3736, -19);
                            Jqe[3736] = 33;
                            Knb(Jqe, 3737, 3744, -19);
                            Jqe[3744] = 33;
                            Knb(Jqe, 3745, 3748, -19);
                            Jqe[3748] = 33;
                            Jqe[3749] = -19;
                            Jqe[3750] = 33;
                            Jqe[3751] = -19;
                            Knb(Jqe, 3752, 3754, 33);
                            Knb(Jqe, 3754, 3756, -19);
                            Jqe[3756] = 33;
                            Knb(Jqe, 3757, 3759, -19);
                            Jqe[3759] = 33;
                            Jqe[3760] = -19;
                            Jqe[3761] = -87;
                            Knb(Jqe, 3762, 3764, -19);
                            Knb(Jqe, 3764, 3770, -87);
                            Jqe[3770] = 33;
                            Knb(Jqe, 3771, 3773, -87);
                            Jqe[3773] = -19;
                            Knb(Jqe, 3774, 3776, 33);
                            Knb(Jqe, 3776, 3781, -19);
                            Jqe[3781] = 33;
                            Jqe[3782] = -87;
                            Jqe[3783] = 33;
                            Knb(Jqe, 3784, 3790, -87);
                            Knb(Jqe, 3790, 3792, 33);
                            Knb(Jqe, 3792, 3802, -87);
                            Knb(Jqe, 3802, 3864, 33);
                            Knb(Jqe, 3864, 3866, -87);
                            Knb(Jqe, 3866, 3872, 33);
                            Knb(Jqe, 3872, 3882, -87);
                            Knb(Jqe, 3882, 3893, 33);
                            Jqe[3893] = -87;
                            Jqe[3894] = 33;
                            Jqe[3895] = -87;
                            Jqe[3896] = 33;
                            Jqe[3897] = -87;
                            Knb(Jqe, 3898, 3902, 33);
                            Knb(Jqe, 3902, 3904, -87);
                            Knb(Jqe, 3904, 3912, -19);
                            Jqe[3912] = 33;
                            Knb(Jqe, 3913, 3946, -19);
                            Knb(Jqe, 3946, 3953, 33);
                            Knb(Jqe, 3953, 3973, -87);
                            Jqe[3973] = 33;
                            Knb(Jqe, 3974, 3980, -87);
                            Knb(Jqe, 3980, 3984, 33);
                            Knb(Jqe, 3984, 3990, -87);
                            Jqe[3990] = 33;
                            Jqe[3991] = -87;
                            Jqe[3992] = 33;
                            Knb(Jqe, 3993, 4014, -87);
                            Knb(Jqe, 4014, 4017, 33);
                            Knb(Jqe, 4017, 4024, -87);
                            Jqe[4024] = 33;
                            Jqe[4025] = -87;
                            Knb(Jqe, 4026, 4256, 33);
                            Knb(Jqe, 4256, 4294, -19);
                            Knb(Jqe, 4294, 4304, 33);
                            Knb(Jqe, 4304, 4343, -19);
                            Knb(Jqe, 4343, 4352, 33);
                            Jqe[4352] = -19;
                            Jqe[4353] = 33;
                            Knb(Jqe, 4354, 4356, -19);
                            Jqe[4356] = 33;
                            Knb(Jqe, 4357, 4360, -19);
                            Jqe[4360] = 33;
                            Jqe[4361] = -19;
                            Jqe[4362] = 33;
                            Knb(Jqe, 4363, 4365, -19);
                            Jqe[4365] = 33;
                            Knb(Jqe, 4366, 4371, -19);
                            Knb(Jqe, 4371, 4412, 33);
                            Jqe[4412] = -19;
                            Jqe[4413] = 33;
                            Jqe[4414] = -19;
                            Jqe[4415] = 33;
                            Jqe[4416] = -19;
                            Knb(Jqe, 4417, 4428, 33);
                            Jqe[4428] = -19;
                            Jqe[4429] = 33;
                            Jqe[4430] = -19;
                            Jqe[4431] = 33;
                            Jqe[4432] = -19;
                            Knb(Jqe, 4433, 4436, 33);
                            Knb(Jqe, 4436, 4438, -19);
                            Knb(Jqe, 4438, 4441, 33);
                            Jqe[4441] = -19;
                            Knb(Jqe, 4442, 4447, 33);
                            Knb(Jqe, 4447, 4450, -19);
                            Jqe[4450] = 33;
                            Jqe[4451] = -19;
                            Jqe[4452] = 33;
                            Jqe[4453] = -19;
                            Jqe[4454] = 33;
                            Jqe[4455] = -19;
                            Jqe[4456] = 33;
                            Jqe[4457] = -19;
                            Knb(Jqe, 4458, 4461, 33);
                            Knb(Jqe, 4461, 4463, -19);
                            Knb(Jqe, 4463, 4466, 33);
                            Knb(Jqe, 4466, 4468, -19);
                            Jqe[4468] = 33;
                            Jqe[4469] = -19;
                            Knb(Jqe, 4470, 4510, 33);
                            Jqe[4510] = -19;
                            Knb(Jqe, 4511, 4520, 33);
                            Jqe[4520] = -19;
                            Knb(Jqe, 4521, 4523, 33);
                            Jqe[4523] = -19;
                            Knb(Jqe, 4524, 4526, 33);
                            Knb(Jqe, 4526, 4528, -19);
                            Knb(Jqe, 4528, 4535, 33);
                            Knb(Jqe, 4535, 4537, -19);
                            Jqe[4537] = 33;
                            Jqe[4538] = -19;
                            Jqe[4539] = 33;
                            Knb(Jqe, 4540, 4547, -19);
                            Knb(Jqe, 4547, 4587, 33);
                            Jqe[4587] = -19;
                            Knb(Jqe, 4588, 4592, 33);
                            Jqe[4592] = -19;
                            Knb(Jqe, 4593, 4601, 33);
                            Jqe[4601] = -19;
                            Knb(Jqe, 4602, 7680, 33);
                            Knb(Jqe, 7680, 7836, -19);
                            Knb(Jqe, 7836, 7840, 33);
                            Knb(Jqe, 7840, 7930, -19);
                            Knb(Jqe, 7930, 7936, 33);
                            Knb(Jqe, 7936, 7958, -19);
                            Knb(Jqe, 7958, 7960, 33);
                            Knb(Jqe, 7960, 7966, -19);
                            Knb(Jqe, 7966, 7968, 33);
                            Knb(Jqe, 7968, 8006, -19);
                            Knb(Jqe, 8006, 8008, 33);
                            Knb(Jqe, 8008, 8014, -19);
                            Knb(Jqe, 8014, 8016, 33);
                            Knb(Jqe, 8016, 8024, -19);
                            Jqe[8024] = 33;
                            Jqe[8025] = -19;
                            Jqe[8026] = 33;
                            Jqe[8027] = -19;
                            Jqe[8028] = 33;
                            Jqe[8029] = -19;
                            Jqe[8030] = 33;
                            Knb(Jqe, 8031, 8062, -19);
                            Knb(Jqe, 8062, 8064, 33);
                            Knb(Jqe, 8064, 8117, -19);
                            Jqe[8117] = 33;
                            Knb(Jqe, 8118, 8125, -19);
                            Jqe[8125] = 33;
                            Jqe[8126] = -19;
                            Knb(Jqe, 8127, 8130, 33);
                            Knb(Jqe, 8130, 8133, -19);
                            Jqe[8133] = 33;
                            Knb(Jqe, 8134, 8141, -19);
                            Knb(Jqe, 8141, 8144, 33);
                            Knb(Jqe, 8144, 8148, -19);
                            Knb(Jqe, 8148, 8150, 33);
                            Knb(Jqe, 8150, 8156, -19);
                            Knb(Jqe, 8156, 8160, 33);
                            Knb(Jqe, 8160, 8173, -19);
                            Knb(Jqe, 8173, 8178, 33);
                            Knb(Jqe, 8178, 8181, -19);
                            Jqe[8181] = 33;
                            Knb(Jqe, 8182, 8189, -19);
                            Knb(Jqe, 8189, 8400, 33);
                            Knb(Jqe, 8400, 8413, -87);
                            Knb(Jqe, 8413, 8417, 33);
                            Jqe[8417] = -87;
                            Knb(Jqe, 8418, 8486, 33);
                            Jqe[8486] = -19;
                            Knb(Jqe, 8487, 8490, 33);
                            Knb(Jqe, 8490, 8492, -19);
                            Knb(Jqe, 8492, 8494, 33);
                            Jqe[8494] = -19;
                            Knb(Jqe, 8495, 8576, 33);
                            Knb(Jqe, 8576, 8579, -19);
                            Knb(Jqe, 8579, 12293, 33);
                            Jqe[12293] = -87;
                            Jqe[12294] = 33;
                            Jqe[12295] = -19;
                            Knb(Jqe, 12296, 12321, 33);
                            Knb(Jqe, 12321, 12330, -19);
                            Knb(Jqe, 12330, 12336, -87);
                            Jqe[12336] = 33;
                            Knb(Jqe, 12337, 12342, -87);
                            Knb(Jqe, 12342, 12353, 33);
                            Knb(Jqe, 12353, 12437, -19);
                            Knb(Jqe, 12437, 12441, 33);
                            Knb(Jqe, 12441, 12443, -87);
                            Knb(Jqe, 12443, 12445, 33);
                            Knb(Jqe, 12445, 12447, -87);
                            Knb(Jqe, 12447, 12449, 33);
                            Knb(Jqe, 12449, 12539, -19);
                            Jqe[12539] = 33;
                            Knb(Jqe, 12540, 12543, -87);
                            Knb(Jqe, 12543, 12549, 33);
                            Knb(Jqe, 12549, 12589, -19);
                            Knb(Jqe, 12589, 19968, 33);
                            Knb(Jqe, 19968, 40870, -19);
                            Knb(Jqe, 40870, 44032, 33);
                            Knb(Jqe, 44032, 55204, -19);
                            Knb(Jqe, 55204, uxe, 33);
                            Knb(Jqe, 57344, 65534, 33);
                        }
                        function Zae(a) {
                            var b, c, d, e, f, g, h;
                            if (a.hb) return;
                            a.hb = true;
                            PAd(a, 'ecore');
                            CBd(a, 'ecore');
                            DBd(a, AKe);
                            eBd(a.fb, 'E');
                            eBd(a.L, 'T');
                            eBd(a.P, 'K');
                            eBd(a.P, 'V');
                            eBd(a.cb, 'E');
                            WGd(zYd(a.b), a.bb);
                            WGd(zYd(a.a), a.Q);
                            WGd(zYd(a.o), a.p);
                            WGd(zYd(a.p), a.R);
                            WGd(zYd(a.q), a.p);
                            WGd(zYd(a.v), a.q);
                            WGd(zYd(a.w), a.R);
                            WGd(zYd(a.B), a.Q);
                            WGd(zYd(a.R), a.Q);
                            WGd(zYd(a.T), a.eb);
                            WGd(zYd(a.U), a.R);
                            WGd(zYd(a.V), a.eb);
                            WGd(zYd(a.W), a.bb);
                            WGd(zYd(a.bb), a.eb);
                            WGd(zYd(a.eb), a.R);
                            WGd(zYd(a.db), a.R);
                            vBd(a.b, g7, RJe, false, false, true);
                            tBd(RD(QHd(xYd(a.b), 0), 35), a.e, 'iD', null, 0, 1, g7, false, false, true, false, true, false);
                            zBd(RD(QHd(xYd(a.b), 1), 19), a.q, null, 'eAttributeType', 1, 1, g7, true, true, false, false, true, false, true);
                            vBd(a.a, f7, OJe, false, false, true);
                            tBd(RD(QHd(xYd(a.a), 0), 35), a._, bIe, null, 0, 1, f7, false, false, true, false, true, false);
                            zBd(RD(QHd(xYd(a.a), 1), 19), a.ab, null, 'details', 0, -1, f7, false, false, true, true, false, false, false);
                            zBd(RD(QHd(xYd(a.a), 2), 19), a.Q, RD(QHd(xYd(a.Q), 0), 19), 'eModelElement', 0, 1, f7, true, false, true, false, false, false, false);
                            zBd(RD(QHd(xYd(a.a), 3), 19), a.S, null, 'contents', 0, -1, f7, false, false, true, true, false, false, false);
                            zBd(RD(QHd(xYd(a.a), 4), 19), a.S, null, 'references', 0, -1, f7, false, false, true, false, true, false, false);
                            vBd(a.o, h7, 'EClass', false, false, true);
                            tBd(RD(QHd(xYd(a.o), 0), 35), a.e, 'abstract', null, 0, 1, h7, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.o), 1), 35), a.e, 'interface', null, 0, 1, h7, false, false, true, false, true, false);
                            zBd(RD(QHd(xYd(a.o), 2), 19), a.o, null, 'eSuperTypes', 0, -1, h7, false, false, true, false, true, true, false);
                            zBd(RD(QHd(xYd(a.o), 3), 19), a.T, RD(QHd(xYd(a.T), 0), 19), 'eOperations', 0, -1, h7, false, false, true, true, false, false, false);
                            zBd(RD(QHd(xYd(a.o), 4), 19), a.b, null, 'eAllAttributes', 0, -1, h7, true, true, false, false, true, false, true);
                            zBd(RD(QHd(xYd(a.o), 5), 19), a.W, null, 'eAllReferences', 0, -1, h7, true, true, false, false, true, false, true);
                            zBd(RD(QHd(xYd(a.o), 6), 19), a.W, null, 'eReferences', 0, -1, h7, true, true, false, false, true, false, true);
                            zBd(RD(QHd(xYd(a.o), 7), 19), a.b, null, 'eAttributes', 0, -1, h7, true, true, false, false, true, false, true);
                            zBd(RD(QHd(xYd(a.o), 8), 19), a.W, null, 'eAllContainments', 0, -1, h7, true, true, false, false, true, false, true);
                            zBd(RD(QHd(xYd(a.o), 9), 19), a.T, null, 'eAllOperations', 0, -1, h7, true, true, false, false, true, false, true);
                            zBd(RD(QHd(xYd(a.o), 10), 19), a.bb, null, 'eAllStructuralFeatures', 0, -1, h7, true, true, false, false, true, false, true);
                            zBd(RD(QHd(xYd(a.o), 11), 19), a.o, null, 'eAllSuperTypes', 0, -1, h7, true, true, false, false, true, false, true);
                            zBd(RD(QHd(xYd(a.o), 12), 19), a.b, null, 'eIDAttribute', 0, 1, h7, true, true, false, false, false, false, true);
                            zBd(RD(QHd(xYd(a.o), 13), 19), a.bb, RD(QHd(xYd(a.bb), 7), 19), 'eStructuralFeatures', 0, -1, h7, false, false, true, true, false, false, false);
                            zBd(RD(QHd(xYd(a.o), 14), 19), a.H, null, 'eGenericSuperTypes', 0, -1, h7, false, false, true, true, false, true, false);
                            zBd(RD(QHd(xYd(a.o), 15), 19), a.H, null, 'eAllGenericSuperTypes', 0, -1, h7, true, true, false, false, true, false, true);
                            h = yBd(RD(QHd(uYd(a.o), 0), 62), a.e, 'isSuperTypeOf');
                            cBd(h, a.o, 'someClass');
                            yBd(RD(QHd(uYd(a.o), 1), 62), a.I, 'getFeatureCount');
                            h = yBd(RD(QHd(uYd(a.o), 2), 62), a.bb, EKe);
                            cBd(h, a.I, 'featureID');
                            h = yBd(RD(QHd(uYd(a.o), 3), 62), a.I, FKe);
                            cBd(h, a.bb, GKe);
                            h = yBd(RD(QHd(uYd(a.o), 4), 62), a.bb, EKe);
                            cBd(h, a._, 'featureName');
                            yBd(RD(QHd(uYd(a.o), 5), 62), a.I, 'getOperationCount');
                            h = yBd(RD(QHd(uYd(a.o), 6), 62), a.T, 'getEOperation');
                            cBd(h, a.I, 'operationID');
                            h = yBd(RD(QHd(uYd(a.o), 7), 62), a.I, HKe);
                            cBd(h, a.T, IKe);
                            h = yBd(RD(QHd(uYd(a.o), 8), 62), a.T, 'getOverride');
                            cBd(h, a.T, IKe);
                            h = yBd(RD(QHd(uYd(a.o), 9), 62), a.H, 'getFeatureType');
                            cBd(h, a.bb, GKe);
                            vBd(a.p, i7, SJe, true, false, true);
                            tBd(RD(QHd(xYd(a.p), 0), 35), a._, 'instanceClassName', null, 0, 1, i7, false, true, true, true, true, false);
                            b = lBd(a.L);
                            c = Vae();
                            WGd((!b.d && (b.d = new XZd(o7, b, 1)), b.d), c);
                            uBd(RD(QHd(xYd(a.p), 1), 35), b, 'instanceClass', i7, true, true, false, true);
                            tBd(RD(QHd(xYd(a.p), 2), 35), a.M, JKe, null, 0, 1, i7, true, true, false, false, true, true);
                            tBd(RD(QHd(xYd(a.p), 3), 35), a._, 'instanceTypeName', null, 0, 1, i7, false, true, true, true, true, false);
                            zBd(RD(QHd(xYd(a.p), 4), 19), a.U, RD(QHd(xYd(a.U), 3), 19), 'ePackage', 0, 1, i7, true, false, false, false, true, false, false);
                            zBd(RD(QHd(xYd(a.p), 5), 19), a.db, null, KKe, 0, -1, i7, false, false, true, true, true, false, false);
                            h = yBd(RD(QHd(uYd(a.p), 0), 62), a.e, LKe);
                            cBd(h, a.M, gve);
                            yBd(RD(QHd(uYd(a.p), 1), 62), a.I, 'getClassifierID');
                            vBd(a.q, k7, 'EDataType', false, false, true);
                            tBd(RD(QHd(xYd(a.q), 0), 35), a.e, 'serializable', FGe, 0, 1, k7, false, false, true, false, true, false);
                            vBd(a.v, m7, 'EEnum', false, false, true);
                            zBd(RD(QHd(xYd(a.v), 0), 19), a.w, RD(QHd(xYd(a.w), 3), 19), 'eLiterals', 0, -1, m7, false, false, true, true, false, false, false);
                            h = yBd(RD(QHd(uYd(a.v), 0), 62), a.w, MKe);
                            cBd(h, a._, GIe);
                            h = yBd(RD(QHd(uYd(a.v), 1), 62), a.w, MKe);
                            cBd(h, a.I, aIe);
                            h = yBd(RD(QHd(uYd(a.v), 2), 62), a.w, 'getEEnumLiteralByLiteral');
                            cBd(h, a._, 'literal');
                            vBd(a.w, l7, TJe, false, false, true);
                            tBd(RD(QHd(xYd(a.w), 0), 35), a.I, aIe, null, 0, 1, l7, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.w), 1), 35), a.A, 'instance', null, 0, 1, l7, true, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.w), 2), 35), a._, 'literal', null, 0, 1, l7, false, false, true, false, true, false);
                            zBd(RD(QHd(xYd(a.w), 3), 19), a.v, RD(QHd(xYd(a.v), 0), 19), 'eEnum', 0, 1, l7, true, false, false, false, false, false, false);
                            vBd(a.B, n7, 'EFactory', false, false, true);
                            zBd(RD(QHd(xYd(a.B), 0), 19), a.U, RD(QHd(xYd(a.U), 2), 19), 'ePackage', 1, 1, n7, true, false, true, false, false, false, false);
                            h = yBd(RD(QHd(uYd(a.B), 0), 62), a.S, 'create');
                            cBd(h, a.o, 'eClass');
                            h = yBd(RD(QHd(uYd(a.B), 1), 62), a.M, 'createFromString');
                            cBd(h, a.q, 'eDataType');
                            cBd(h, a._, 'literalValue');
                            h = yBd(RD(QHd(uYd(a.B), 2), 62), a._, 'convertToString');
                            cBd(h, a.q, 'eDataType');
                            cBd(h, a.M, 'instanceValue');
                            vBd(a.Q, p7, DHe, true, false, true);
                            zBd(RD(QHd(xYd(a.Q), 0), 19), a.a, RD(QHd(xYd(a.a), 2), 19), 'eAnnotations', 0, -1, p7, false, false, true, true, false, false, false);
                            h = yBd(RD(QHd(uYd(a.Q), 0), 62), a.a, 'getEAnnotation');
                            cBd(h, a._, bIe);
                            vBd(a.R, q7, EHe, true, false, true);
                            tBd(RD(QHd(xYd(a.R), 0), 35), a._, GIe, null, 0, 1, q7, false, false, true, false, true, false);
                            vBd(a.S, r7, 'EObject', false, false, true);
                            yBd(RD(QHd(uYd(a.S), 0), 62), a.o, 'eClass');
                            yBd(RD(QHd(uYd(a.S), 1), 62), a.e, 'eIsProxy');
                            yBd(RD(QHd(uYd(a.S), 2), 62), a.X, 'eResource');
                            yBd(RD(QHd(uYd(a.S), 3), 62), a.S, 'eContainer');
                            yBd(RD(QHd(uYd(a.S), 4), 62), a.bb, 'eContainingFeature');
                            yBd(RD(QHd(uYd(a.S), 5), 62), a.W, 'eContainmentFeature');
                            h = yBd(RD(QHd(uYd(a.S), 6), 62), null, 'eContents');
                            b = lBd(a.fb);
                            c = lBd(a.S);
                            WGd((!b.d && (b.d = new XZd(o7, b, 1)), b.d), c);
                            e = XVd(h, b, null);
                            !!e && e.oj();
                            h = yBd(RD(QHd(uYd(a.S), 7), 62), null, 'eAllContents');
                            b = lBd(a.cb);
                            c = lBd(a.S);
                            WGd((!b.d && (b.d = new XZd(o7, b, 1)), b.d), c);
                            f = XVd(h, b, null);
                            !!f && f.oj();
                            h = yBd(RD(QHd(uYd(a.S), 8), 62), null, 'eCrossReferences');
                            b = lBd(a.fb);
                            c = lBd(a.S);
                            WGd((!b.d && (b.d = new XZd(o7, b, 1)), b.d), c);
                            g = XVd(h, b, null);
                            !!g && g.oj();
                            h = yBd(RD(QHd(uYd(a.S), 9), 62), a.M, 'eGet');
                            cBd(h, a.bb, GKe);
                            h = yBd(RD(QHd(uYd(a.S), 10), 62), a.M, 'eGet');
                            cBd(h, a.bb, GKe);
                            cBd(h, a.e, 'resolve');
                            h = yBd(RD(QHd(uYd(a.S), 11), 62), null, 'eSet');
                            cBd(h, a.bb, GKe);
                            cBd(h, a.M, 'newValue');
                            h = yBd(RD(QHd(uYd(a.S), 12), 62), a.e, 'eIsSet');
                            cBd(h, a.bb, GKe);
                            h = yBd(RD(QHd(uYd(a.S), 13), 62), null, 'eUnset');
                            cBd(h, a.bb, GKe);
                            h = yBd(RD(QHd(uYd(a.S), 14), 62), a.M, 'eInvoke');
                            cBd(h, a.T, IKe);
                            b = lBd(a.fb);
                            c = Vae();
                            WGd((!b.d && (b.d = new XZd(o7, b, 1)), b.d), c);
                            dBd(h, b, 'arguments');
                            aBd(h, a.K);
                            vBd(a.T, s7, VJe, false, false, true);
                            zBd(RD(QHd(xYd(a.T), 0), 19), a.o, RD(QHd(xYd(a.o), 3), 19), NKe, 0, 1, s7, true, false, false, false, false, false, false);
                            zBd(RD(QHd(xYd(a.T), 1), 19), a.db, null, KKe, 0, -1, s7, false, false, true, true, true, false, false);
                            zBd(RD(QHd(xYd(a.T), 2), 19), a.V, RD(QHd(xYd(a.V), 0), 19), 'eParameters', 0, -1, s7, false, false, true, true, false, false, false);
                            zBd(RD(QHd(xYd(a.T), 3), 19), a.p, null, 'eExceptions', 0, -1, s7, false, false, true, false, true, true, false);
                            zBd(RD(QHd(xYd(a.T), 4), 19), a.H, null, 'eGenericExceptions', 0, -1, s7, false, false, true, true, false, true, false);
                            yBd(RD(QHd(uYd(a.T), 0), 62), a.I, HKe);
                            h = yBd(RD(QHd(uYd(a.T), 1), 62), a.e, 'isOverrideOf');
                            cBd(h, a.T, 'someOperation');
                            vBd(a.U, t7, 'EPackage', false, false, true);
                            tBd(RD(QHd(xYd(a.U), 0), 35), a._, 'nsURI', null, 0, 1, t7, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.U), 1), 35), a._, 'nsPrefix', null, 0, 1, t7, false, false, true, false, true, false);
                            zBd(RD(QHd(xYd(a.U), 2), 19), a.B, RD(QHd(xYd(a.B), 0), 19), 'eFactoryInstance', 1, 1, t7, true, false, true, false, false, false, false);
                            zBd(RD(QHd(xYd(a.U), 3), 19), a.p, RD(QHd(xYd(a.p), 4), 19), 'eClassifiers', 0, -1, t7, false, false, true, true, true, false, false);
                            zBd(RD(QHd(xYd(a.U), 4), 19), a.U, RD(QHd(xYd(a.U), 5), 19), 'eSubpackages', 0, -1, t7, false, false, true, true, true, false, false);
                            zBd(RD(QHd(xYd(a.U), 5), 19), a.U, RD(QHd(xYd(a.U), 4), 19), 'eSuperPackage', 0, 1, t7, true, false, false, false, true, false, false);
                            h = yBd(RD(QHd(uYd(a.U), 0), 62), a.p, 'getEClassifier');
                            cBd(h, a._, GIe);
                            vBd(a.V, u7, WJe, false, false, true);
                            zBd(RD(QHd(xYd(a.V), 0), 19), a.T, RD(QHd(xYd(a.T), 2), 19), 'eOperation', 0, 1, u7, true, false, false, false, false, false, false);
                            vBd(a.W, v7, XJe, false, false, true);
                            tBd(RD(QHd(xYd(a.W), 0), 35), a.e, 'containment', null, 0, 1, v7, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.W), 1), 35), a.e, 'container', null, 0, 1, v7, true, true, false, false, true, true);
                            tBd(RD(QHd(xYd(a.W), 2), 35), a.e, 'resolveProxies', FGe, 0, 1, v7, false, false, true, false, true, false);
                            zBd(RD(QHd(xYd(a.W), 3), 19), a.W, null, 'eOpposite', 0, 1, v7, false, false, true, false, true, false, false);
                            zBd(RD(QHd(xYd(a.W), 4), 19), a.o, null, 'eReferenceType', 1, 1, v7, true, true, false, false, true, false, true);
                            zBd(RD(QHd(xYd(a.W), 5), 19), a.b, null, 'eKeys', 0, -1, v7, false, false, true, false, true, false, false);
                            vBd(a.bb, y7, QJe, true, false, true);
                            tBd(RD(QHd(xYd(a.bb), 0), 35), a.e, 'changeable', FGe, 0, 1, y7, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.bb), 1), 35), a.e, 'volatile', null, 0, 1, y7, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.bb), 2), 35), a.e, 'transient', null, 0, 1, y7, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.bb), 3), 35), a._, 'defaultValueLiteral', null, 0, 1, y7, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.bb), 4), 35), a.M, JKe, null, 0, 1, y7, true, true, false, false, true, true);
                            tBd(RD(QHd(xYd(a.bb), 5), 35), a.e, 'unsettable', null, 0, 1, y7, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.bb), 6), 35), a.e, 'derived', null, 0, 1, y7, false, false, true, false, true, false);
                            zBd(RD(QHd(xYd(a.bb), 7), 19), a.o, RD(QHd(xYd(a.o), 13), 19), NKe, 0, 1, y7, true, false, false, false, false, false, false);
                            yBd(RD(QHd(uYd(a.bb), 0), 62), a.I, FKe);
                            h = yBd(RD(QHd(uYd(a.bb), 1), 62), null, 'getContainerClass');
                            b = lBd(a.L);
                            c = Vae();
                            WGd((!b.d && (b.d = new XZd(o7, b, 1)), b.d), c);
                            d = XVd(h, b, null);
                            !!d && d.oj();
                            vBd(a.eb, A7, PJe, true, false, true);
                            tBd(RD(QHd(xYd(a.eb), 0), 35), a.e, 'ordered', FGe, 0, 1, A7, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.eb), 1), 35), a.e, 'unique', FGe, 0, 1, A7, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.eb), 2), 35), a.I, 'lowerBound', null, 0, 1, A7, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.eb), 3), 35), a.I, 'upperBound', '1', 0, 1, A7, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.eb), 4), 35), a.e, 'many', null, 0, 1, A7, true, true, false, false, true, true);
                            tBd(RD(QHd(xYd(a.eb), 5), 35), a.e, 'required', null, 0, 1, A7, true, true, false, false, true, true);
                            zBd(RD(QHd(xYd(a.eb), 6), 19), a.p, null, 'eType', 0, 1, A7, false, true, true, false, true, true, false);
                            zBd(RD(QHd(xYd(a.eb), 7), 19), a.H, null, 'eGenericType', 0, 1, A7, false, true, true, true, false, true, false);
                            vBd(a.ab, UK, 'EStringToStringMapEntry', false, false, false);
                            tBd(RD(QHd(xYd(a.ab), 0), 35), a._, 'key', null, 0, 1, UK, false, false, true, false, true, false);
                            tBd(RD(QHd(xYd(a.ab), 1), 35), a._, aIe, null, 0, 1, UK, false, false, true, false, true, false);
                            vBd(a.H, o7, UJe, false, false, true);
                            zBd(RD(QHd(xYd(a.H), 0), 19), a.H, null, 'eUpperBound', 0, 1, o7, false, false, true, true, false, false, false);
                            zBd(RD(QHd(xYd(a.H), 1), 19), a.H, null, 'eTypeArguments', 0, -1, o7, false, false, true, true, false, false, false);
                            zBd(RD(QHd(xYd(a.H), 2), 19), a.p, null, 'eRawType', 1, 1, o7, true, false, false, false, true, false, true);
                            zBd(RD(QHd(xYd(a.H), 3), 19), a.H, null, 'eLowerBound', 0, 1, o7, false, false, true, true, false, false, false);
                            zBd(RD(QHd(xYd(a.H), 4), 19), a.db, null, 'eTypeParameter', 0, 1, o7, false, false, true, false, false, false, false);
                            zBd(RD(QHd(xYd(a.H), 5), 19), a.p, null, 'eClassifier', 0, 1, o7, false, false, true, false, true, false, false);
                            h = yBd(RD(QHd(uYd(a.H), 0), 62), a.e, LKe);
                            cBd(h, a.M, gve);
                            vBd(a.db, z7, YJe, false, false, true);
                            zBd(RD(QHd(xYd(a.db), 0), 19), a.H, null, 'eBounds', 0, -1, z7, false, false, true, true, false, false, false);
                            xBd(a.c, tJ, 'EBigDecimal', true);
                            xBd(a.d, uJ, 'EBigInteger', true);
                            xBd(a.e, xdb, 'EBoolean', true);
                            xBd(a.f, QI, 'EBooleanObject', true);
                            xBd(a.i, gE, 'EByte', true);
                            xBd(a.g, WC(gE, 1), 'EByteArray', true);
                            xBd(a.j, RI, 'EByteObject', true);
                            xBd(a.k, hE, 'EChar', true);
                            xBd(a.n, SI, 'ECharacterObject', true);
                            xBd(a.r, qK, 'EDate', true);
                            xBd(a.s, T6, 'EDiagnosticChain', false);
                            xBd(a.t, iE, 'EDouble', true);
                            xBd(a.u, VI, 'EDoubleObject', true);
                            xBd(a.fb, Y6, 'EEList', false);
                            xBd(a.A, Z6, 'EEnumerator', false);
                            xBd(a.C, Tbb, 'EFeatureMap', false);
                            xBd(a.D, Jbb, 'EFeatureMapEntry', false);
                            xBd(a.F, jE, 'EFloat', true);
                            xBd(a.G, ZI, 'EFloatObject', true);
                            xBd(a.I, kE, 'EInt', true);
                            xBd(a.J, bJ, 'EIntegerObject', true);
                            xBd(a.L, UI, 'EJavaClass', true);
                            xBd(a.M, jJ, 'EJavaObject', true);
                            xBd(a.N, lE, 'ELong', true);
                            xBd(a.O, eJ, 'ELongObject', true);
                            xBd(a.P, VK, 'EMap', false);
                            xBd(a.X, Aab, 'EResource', false);
                            xBd(a.Y, zab, 'EResourceSet', false);
                            xBd(a.Z, wdb, 'EShort', true);
                            xBd(a.$, lJ, 'EShortObject', true);
                            xBd(a._, qJ, 'EString', true);
                            xBd(a.cb, a7, 'ETreeIterator', false);
                            xBd(a.K, $6, 'EInvocationTargetException', false);
                            pBd(a, AKe);
                        }
                        var gve = 'object', hve = 'boolean', ive = 'number', jve = 'string', kve = 'function', lve = 2147483647, mve = 'java.lang', nve = {
                            3: 1
                        }, ove = 'com.google.common.base', pve = ', ', qve = '%s (%s) must not be negative', rve = {
                            3: 1,
                            4: 1,
                            5: 1
                        }, sve = 'negative size: ', tve = 'no calls to next() since the last call to remove()', uve = 'Optional.of(', vve = 'null', wve = {
                            204: 1,
                            51: 1
                        }, xve = 'com.google.common.collect', yve = {
                            204: 1,
                            51: 1,
                            128: 1
                        }, zve = {
                            229: 1,
                            3: 1
                        }, Ave = {
                            51: 1
                        }, Bve = 'java.util', Cve = {
                            85: 1
                        }, Dve = {
                            20: 1,
                            31: 1,
                            16: 1
                        }, Eve = 2063, Fve = {
                            20: 1,
                            31: 1,
                            16: 1,
                            21: 1
                        }, Gve = {
                            85: 1,
                            139: 1,
                            133: 1
                        }, Hve = {
                            20: 1,
                            31: 1,
                            16: 1,
                            21: 1,
                            87: 1
                        }, Ive = {
                            20: 1,
                            31: 1,
                            16: 1,
                            277: 1,
                            21: 1,
                            87: 1
                        }, Jve = {
                            51: 1,
                            128: 1
                        }, Kve = {
                            358: 1,
                            44: 1
                        }, Lve = 'AbstractMapEntry', Mve = 'expectedValuesPerKey', Nve = {
                            3: 1,
                            6: 1,
                            4: 1,
                            5: 1
                        }, Ove = 16384, Pve = {
                            159: 1
                        }, Qve = {
                            41: 1
                        }, Rve = {
                            202: 1
                        }, Sve = {
                            l: 4194303,
                            m: 4194303,
                            h: 524287
                        }, Tve = {
                            253: 1,
                            3: 1,
                            34: 1
                        }, Uve = 'range unbounded on this side', Vve = {
                            20: 1
                        }, Wve = {
                            20: 1,
                            16: 1
                        }, Xve = {
                            3: 1,
                            20: 1,
                            31: 1,
                            16: 1
                        }, Yve = {
                            307: 1,
                            3: 1,
                            20: 1,
                            31: 1,
                            16: 1,
                            15: 1,
                            59: 1
                        }, Zve = {
                            3: 1,
                            4: 1,
                            5: 1,
                            173: 1
                        }, $ve = {
                            3: 1,
                            85: 1
                        }, _ve = {
                            20: 1,
                            16: 1,
                            21: 1
                        }, awe = {
                            3: 1,
                            20: 1,
                            31: 1,
                            16: 1,
                            21: 1
                        }, bwe = {
                            20: 1,
                            16: 1,
                            21: 1,
                            87: 1
                        }, cwe = 461845907, dwe = -862048943, ewe = {
                            3: 1,
                            6: 1,
                            4: 1,
                            5: 1,
                            173: 1
                        }, fwe = 'expectedSize', gwe = 1024, hwe = 1073741824, iwe = 'initialArraySize', jwe = {
                            3: 1,
                            6: 1,
                            4: 1,
                            9: 1,
                            5: 1
                        }, kwe = {
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1
                        }, lwe = 'arraySize', mwe = {
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            59: 1
                        }, nwe = {
                            46: 1
                        }, owe = {
                            380: 1
                        }, pwe = 1.0E-4, qwe = -2147483648, rwe = '__noinit__', swe = {
                            3: 1,
                            103: 1,
                            63: 1,
                            82: 1
                        }, twe = 'com.google.gwt.core.client.impl', uwe = 'String', vwe = 'com.google.gwt.core.client', wwe = 'anonymous', xwe = 'fnStack', ywe = 'Unknown', zwe = {
                            201: 1,
                            3: 1,
                            4: 1
                        }, Awe = 1000, Bwe = 65535, Cwe = 'January', Dwe = 'February', Ewe = 'March', Fwe = 'April', Gwe = 'May', Hwe = 'June', Iwe = 'July', Jwe = 'August', Kwe = 'September', Lwe = 'October', Mwe = 'November', Nwe = 'December', Owe = 1900, Pwe = {
                            53: 1,
                            3: 1,
                            4: 1
                        }, Qwe = 'Before Christ', Rwe = 'Anno Domini', Swe = 'Sunday', Twe = 'Monday', Uwe = 'Tuesday', Vwe = 'Wednesday', Wwe = 'Thursday', Xwe = 'Friday', Ywe = 'Saturday', Zwe = 'com.google.gwt.i18n.shared', $we = 'DateTimeFormat', _we = 'com.google.gwt.i18n.client', axe = 'DefaultDateTimeFormatInfo', bxe = {
                            3: 1,
                            4: 1,
                            34: 1,
                            206: 1
                        }, cxe = 'com.google.gwt.json.client', dxe = 4194303, exe = 1048575, fxe = 524288, gxe = 4194304, hxe = 17592186044416, ixe = 1000000000, jxe = -17592186044416, kxe = 'java.io', lxe = {
                            3: 1,
                            103: 1,
                            77: 1,
                            63: 1,
                            82: 1
                        }, mxe = {
                            3: 1,
                            296: 1,
                            82: 1
                        }, nxe = 'For input string: "', oxe = Infinity, pxe = -Infinity, qxe = 4096, rxe = {
                            3: 1,
                            4: 1,
                            376: 1
                        }, sxe = 'org.eclipse.elk.layered', txe = 65536, uxe = 55296, vxe = {
                            109: 1,
                            3: 1,
                            4: 1
                        }, wxe = 100000, xxe = 0.3010299956639812, yxe = 4294967295, zxe = '0.0', Axe = {
                            44: 1
                        }, Bxe = 'Unable to add element to queue', Cxe = {
                            3: 1,
                            4: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            13: 1,
                            16: 1,
                            15: 1,
                            59: 1
                        }, Dxe = {
                            3: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            59: 1
                        }, Exe = {
                            20: 1,
                            16: 1,
                            15: 1
                        }, Fxe = {
                            3: 1,
                            50: 1
                        }, Gxe = {
                            189: 1
                        }, Hxe = {
                            3: 1,
                            4: 1,
                            85: 1
                        }, Ixe = {
                            3: 1,
                            4: 1,
                            20: 1,
                            31: 1,
                            16: 1,
                            49: 1,
                            21: 1
                        }, Jxe = 'delete', Kxe = 1.4901161193847656E-8, Lxe = 1.1102230246251565E-16, Mxe = 15525485, Nxe = 5.9604644775390625E-8, Oxe = 16777216, Pxe = 16777215, Qxe = ', length: ', Rxe = {
                            3: 1,
                            4: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            59: 1
                        }, Sxe = 'subMap: ', Txe = ' less than ', Uxe = {
                            3: 1,
                            34: 1,
                            22: 1,
                            304: 1
                        }, Vxe = 'java.util.function', Wxe = 'java.util.logging', Xxe = {
                            3: 1,
                            4: 1,
                            5: 1,
                            856: 1
                        }, Yxe = 'undefined', Zxe = 'java.util.stream', $xe = {
                            533: 1,
                            687: 1
                        }, _xe = 'fromIndex: ', aye = ' > toIndex: ', bye = ', toIndex: ', cye = 'Index: ', dye = ', Size: ', eye = 'org.eclipse.elk.alg.common', fye = {
                            50: 1
                        }, gye = 'org.eclipse.elk.alg.common.compaction', hye = 'Scanline/EventHandler', iye = 'org.eclipse.elk.alg.common.compaction.oned', jye = 'CNode belongs to another CGroup.', kye = 'ISpacingsHandler/1', lye = 'The ', mye = ' instance has been finished already.', nye = 'The direction ', oye = ' is not supported by the CGraph instance.', pye = 'OneDimensionalCompactor', qye = 'OneDimensionalCompactor/lambda$0$Type', rye = 'Quadruplet', sye = 'ScanlineConstraintCalculator', tye = 'ScanlineConstraintCalculator/ConstraintsScanlineHandler', uye = 'ScanlineConstraintCalculator/ConstraintsScanlineHandler/lambda$0$Type', vye = 'ScanlineConstraintCalculator/Timestamp', wye = 'ScanlineConstraintCalculator/lambda$0$Type', xye = {
                            178: 1,
                            46: 1
                        }, yye = 'org.eclipse.elk.alg.common.compaction.options', zye = 'org.eclipse.elk.core.data', Aye = 'org.eclipse.elk.polyomino.traversalStrategy', Bye = 'org.eclipse.elk.polyomino.lowLevelSort', Cye = 'org.eclipse.elk.polyomino.highLevelSort', Dye = 'org.eclipse.elk.polyomino.fill', Eye = {
                            134: 1
                        }, Fye = 'polyomino', Gye = 'org.eclipse.elk.alg.common.networksimplex', Hye = {
                            183: 1,
                            3: 1,
                            4: 1
                        }, Iye = 'org.eclipse.elk.alg.common.nodespacing', Jye = 'org.eclipse.elk.alg.common.nodespacing.cellsystem', Kye = 'CENTER', Lye = {
                            217: 1,
                            336: 1
                        }, Mye = {
                            3: 1,
                            4: 1,
                            5: 1,
                            603: 1
                        }, Nye = 'LEFT', Oye = 'RIGHT', Pye = 'Vertical alignment cannot be null', Qye = 'BOTTOM', Rye = 'org.eclipse.elk.alg.common.nodespacing.internal', Sye = 'UNDEFINED', Tye = 0.01, Uye = 'org.eclipse.elk.alg.common.nodespacing.internal.algorithm', Vye = 'LabelPlacer/lambda$0$Type', Wye = 'LabelPlacer/lambda$1$Type', Xye = 'portRatioOrPosition', Yye = 'org.eclipse.elk.alg.common.overlaps', Zye = 'DOWN', $ye = 'org.eclipse.elk.alg.common.polyomino', _ye = 'NORTH', aze = 'EAST', bze = 'SOUTH', cze = 'WEST', dze = 'org.eclipse.elk.alg.common.polyomino.structures', eze = 'Direction', fze = 'Grid is only of size ', gze = '. Requested point (', hze = ') is out of bounds.', ize = ' Given center based coordinates were (', jze = 'org.eclipse.elk.graph.properties', kze = 'IPropertyHolder', lze = {
                            3: 1,
                            96: 1,
                            137: 1
                        }, mze = 'org.eclipse.elk.alg.common.spore', nze = 'org.eclipse.elk.alg.common.utils', oze = {
                            205: 1
                        }, pze = 'org.eclipse.elk.core', qze = 'Connected Components Compaction', rze = 'org.eclipse.elk.alg.disco', sze = 'org.eclipse.elk.alg.disco.graph', tze = 'org.eclipse.elk.alg.disco.options', uze = 'CompactionStrategy', vze = 'org.eclipse.elk.disco.componentCompaction.strategy', wze = 'org.eclipse.elk.disco.componentCompaction.componentLayoutAlgorithm', xze = 'org.eclipse.elk.disco.debug.discoGraph', yze = 'org.eclipse.elk.disco.debug.discoPolys', zze = 'componentCompaction', Aze = 'org.eclipse.elk.disco', Bze = 'org.eclipse.elk.spacing.componentComponent', Cze = 'org.eclipse.elk.edge.thickness', Dze = 'org.eclipse.elk.aspectRatio', Eze = 'org.eclipse.elk.padding', Fze = 'org.eclipse.elk.alg.disco.transform', Gze = 1.5707963267948966, Hze = 1.7976931348623157E308, Ize = {
                            3: 1,
                            4: 1,
                            5: 1,
                            198: 1
                        }, Jze = {
                            3: 1,
                            6: 1,
                            4: 1,
                            5: 1,
                            100: 1,
                            115: 1
                        }, Kze = 'org.eclipse.elk.alg.force', Lze = 'ComponentsProcessor', Mze = 'ComponentsProcessor/1', Nze = 'ElkGraphImporter/lambda$0$Type', Oze = 'org.eclipse.elk.alg.force.graph', Pze = 'Component Layout', Qze = 'org.eclipse.elk.alg.force.model', Rze = 'org.eclipse.elk.force.model', Sze = 'org.eclipse.elk.force.iterations', Tze = 'org.eclipse.elk.force.repulsivePower', Uze = 'org.eclipse.elk.force.temperature', Vze = 0.001, Wze = 'org.eclipse.elk.force.repulsion', Xze = 'org.eclipse.elk.alg.force.options', Yze = 1.600000023841858, Zze = 'org.eclipse.elk.force', $ze = 'org.eclipse.elk.priority', _ze = 'org.eclipse.elk.spacing.nodeNode', aAe = 'org.eclipse.elk.spacing.edgeLabel', bAe = 'org.eclipse.elk.randomSeed', cAe = 'org.eclipse.elk.separateConnectedComponents', dAe = 'org.eclipse.elk.interactive', eAe = 'org.eclipse.elk.portConstraints', fAe = 'org.eclipse.elk.edgeLabels.inline', gAe = 'org.eclipse.elk.omitNodeMicroLayout', hAe = 'org.eclipse.elk.nodeSize.fixedGraphSize', iAe = 'org.eclipse.elk.nodeSize.options', jAe = 'org.eclipse.elk.nodeSize.constraints', kAe = 'org.eclipse.elk.nodeLabels.placement', lAe = 'org.eclipse.elk.portLabels.placement', mAe = 'org.eclipse.elk.topdownLayout', nAe = 'org.eclipse.elk.topdown.scaleFactor', oAe = 'org.eclipse.elk.topdown.hierarchicalNodeWidth', pAe = 'org.eclipse.elk.topdown.hierarchicalNodeAspectRatio', qAe = 'org.eclipse.elk.topdown.nodeType', rAe = 'origin', sAe = 'random', tAe = 'boundingBox.upLeft', uAe = 'boundingBox.lowRight', vAe = 'org.eclipse.elk.stress.fixed', wAe = 'org.eclipse.elk.stress.desiredEdgeLength', xAe = 'org.eclipse.elk.stress.dimension', yAe = 'org.eclipse.elk.stress.epsilon', zAe = 'org.eclipse.elk.stress.iterationLimit', AAe = 'org.eclipse.elk.stress', BAe = 'ELK Stress', CAe = 'org.eclipse.elk.nodeSize.minimum', DAe = 'org.eclipse.elk.alg.force.stress', EAe = 'Layered layout', FAe = 'org.eclipse.elk.alg.layered', GAe = 'org.eclipse.elk.alg.layered.compaction.components', HAe = 'org.eclipse.elk.alg.layered.compaction.oned', IAe = 'org.eclipse.elk.alg.layered.compaction.oned.algs', JAe = 'org.eclipse.elk.alg.layered.compaction.recthull', KAe = 'org.eclipse.elk.alg.layered.components', LAe = 'NONE', MAe = 'MODEL_ORDER', NAe = {
                            3: 1,
                            6: 1,
                            4: 1,
                            9: 1,
                            5: 1,
                            126: 1
                        }, OAe = {
                            3: 1,
                            6: 1,
                            4: 1,
                            5: 1,
                            150: 1,
                            100: 1,
                            115: 1
                        }, PAe = 'org.eclipse.elk.alg.layered.compound', QAe = {
                            47: 1
                        }, RAe = 'org.eclipse.elk.alg.layered.graph', SAe = ' -> ', TAe = 'Not supported by LGraph', UAe = 'Port side is undefined', VAe = {
                            3: 1,
                            6: 1,
                            4: 1,
                            5: 1,
                            483: 1,
                            150: 1,
                            100: 1,
                            115: 1
                        }, WAe = {
                            3: 1,
                            6: 1,
                            4: 1,
                            5: 1,
                            150: 1,
                            199: 1,
                            210: 1,
                            100: 1,
                            115: 1
                        }, XAe = {
                            3: 1,
                            6: 1,
                            4: 1,
                            5: 1,
                            150: 1,
                            2042: 1,
                            210: 1,
                            100: 1,
                            115: 1
                        }, YAe = '([{"\' \t\r\n', ZAe = ')]}"\' \t\r\n', $Ae = 'The given string contains parts that cannot be parsed as numbers.', _Ae = 'org.eclipse.elk.core.math', aBe = {
                            3: 1,
                            4: 1,
                            140: 1,
                            214: 1,
                            423: 1
                        }, bBe = {
                            3: 1,
                            4: 1,
                            107: 1,
                            214: 1,
                            423: 1
                        }, cBe = 'org.eclipse.elk.alg.layered.graph.transform', dBe = 'ElkGraphImporter', eBe = 'ElkGraphImporter/lambda$1$Type', fBe = 'ElkGraphImporter/lambda$2$Type', gBe = 'ElkGraphImporter/lambda$4$Type', hBe = 'org.eclipse.elk.alg.layered.intermediate', iBe = 'Node margin calculation', jBe = 'ONE_SIDED_GREEDY_SWITCH', kBe = 'TWO_SIDED_GREEDY_SWITCH', lBe = 'No implementation is available for the layout processor ', mBe = 'IntermediateProcessorStrategy', nBe = "Node '", oBe = 'FIRST_SEPARATE', pBe = 'LAST_SEPARATE', qBe = 'Odd port side processing', rBe = 'org.eclipse.elk.alg.layered.intermediate.compaction', sBe = 'org.eclipse.elk.alg.layered.intermediate.greedyswitch', tBe = 'org.eclipse.elk.alg.layered.p3order.counting', uBe = {
                            230: 1
                        }, vBe = 'org.eclipse.elk.alg.layered.intermediate.loops', wBe = 'org.eclipse.elk.alg.layered.intermediate.loops.ordering', xBe = 'org.eclipse.elk.alg.layered.intermediate.loops.routing', yBe = 'org.eclipse.elk.alg.layered.intermediate.preserveorder', zBe = 'org.eclipse.elk.alg.layered.intermediate.wrapping', ABe = 'org.eclipse.elk.alg.layered.options', BBe = 'INTERACTIVE', CBe = 'GREEDY', DBe = 'DEPTH_FIRST', EBe = 'EDGE_LENGTH', FBe = 'SELF_LOOPS', GBe = 'firstTryWithInitialOrder', HBe = 'org.eclipse.elk.layered.directionCongruency', IBe = 'org.eclipse.elk.layered.feedbackEdges', JBe = 'org.eclipse.elk.layered.interactiveReferencePoint', KBe = 'org.eclipse.elk.layered.mergeEdges', LBe = 'org.eclipse.elk.layered.mergeHierarchyEdges', MBe = 'org.eclipse.elk.layered.allowNonFlowPortsToSwitchSides', NBe = 'org.eclipse.elk.layered.portSortingStrategy', OBe = 'org.eclipse.elk.layered.thoroughness', PBe = 'org.eclipse.elk.layered.unnecessaryBendpoints', QBe = 'org.eclipse.elk.layered.generatePositionAndLayerIds', RBe = 'org.eclipse.elk.layered.cycleBreaking.strategy', SBe = 'org.eclipse.elk.layered.layering.strategy', TBe = 'org.eclipse.elk.layered.layering.layerConstraint', UBe = 'org.eclipse.elk.layered.layering.layerChoiceConstraint', VBe = 'org.eclipse.elk.layered.layering.layerId', WBe = 'org.eclipse.elk.layered.layering.minWidth.upperBoundOnWidth', XBe = 'org.eclipse.elk.layered.layering.minWidth.upperLayerEstimationScalingFactor', YBe = 'org.eclipse.elk.layered.layering.nodePromotion.strategy', ZBe = 'org.eclipse.elk.layered.layering.nodePromotion.maxIterations', $Be = 'org.eclipse.elk.layered.layering.coffmanGraham.layerBound', _Be = 'org.eclipse.elk.layered.crossingMinimization.strategy', aCe = 'org.eclipse.elk.layered.crossingMinimization.forceNodeModelOrder', bCe = 'org.eclipse.elk.layered.crossingMinimization.hierarchicalSweepiness', cCe = 'org.eclipse.elk.layered.crossingMinimization.semiInteractive', dCe = 'org.eclipse.elk.layered.crossingMinimization.inLayerPredOf', eCe = 'org.eclipse.elk.layered.crossingMinimization.inLayerSuccOf', fCe = 'org.eclipse.elk.layered.crossingMinimization.positionChoiceConstraint', gCe = 'org.eclipse.elk.layered.crossingMinimization.positionId', hCe = 'org.eclipse.elk.layered.crossingMinimization.greedySwitch.activationThreshold', iCe = 'org.eclipse.elk.layered.crossingMinimization.greedySwitch.type', jCe = 'org.eclipse.elk.layered.crossingMinimization.greedySwitchHierarchical.type', kCe = 'org.eclipse.elk.layered.nodePlacement.strategy', lCe = 'org.eclipse.elk.layered.nodePlacement.favorStraightEdges', mCe = 'org.eclipse.elk.layered.nodePlacement.bk.edgeStraightening', nCe = 'org.eclipse.elk.layered.nodePlacement.bk.fixedAlignment', oCe = 'org.eclipse.elk.layered.nodePlacement.linearSegments.deflectionDampening', pCe = 'org.eclipse.elk.layered.nodePlacement.networkSimplex.nodeFlexibility', qCe = 'org.eclipse.elk.layered.nodePlacement.networkSimplex.nodeFlexibility.default', rCe = 'org.eclipse.elk.layered.edgeRouting.selfLoopDistribution', sCe = 'org.eclipse.elk.layered.edgeRouting.selfLoopOrdering', tCe = 'org.eclipse.elk.layered.edgeRouting.splines.mode', uCe = 'org.eclipse.elk.layered.edgeRouting.splines.sloppy.layerSpacingFactor', vCe = 'org.eclipse.elk.layered.edgeRouting.polyline.slopedEdgeZoneWidth', wCe = 'org.eclipse.elk.layered.spacing.baseValue', xCe = 'org.eclipse.elk.layered.spacing.edgeNodeBetweenLayers', yCe = 'org.eclipse.elk.layered.spacing.edgeEdgeBetweenLayers', zCe = 'org.eclipse.elk.layered.spacing.nodeNodeBetweenLayers', ACe = 'org.eclipse.elk.layered.priority.direction', BCe = 'org.eclipse.elk.layered.priority.shortness', CCe = 'org.eclipse.elk.layered.priority.straightness', DCe = 'org.eclipse.elk.layered.compaction.connectedComponents', ECe = 'org.eclipse.elk.layered.compaction.postCompaction.strategy', FCe = 'org.eclipse.elk.layered.compaction.postCompaction.constraints', GCe = 'org.eclipse.elk.layered.highDegreeNodes.treatment', HCe = 'org.eclipse.elk.layered.highDegreeNodes.threshold', ICe = 'org.eclipse.elk.layered.highDegreeNodes.treeHeight', JCe = 'org.eclipse.elk.layered.wrapping.strategy', KCe = 'org.eclipse.elk.layered.wrapping.additionalEdgeSpacing', LCe = 'org.eclipse.elk.layered.wrapping.correctionFactor', MCe = 'org.eclipse.elk.layered.wrapping.cutting.strategy', NCe = 'org.eclipse.elk.layered.wrapping.cutting.cuts', OCe = 'org.eclipse.elk.layered.wrapping.cutting.msd.freedom', PCe = 'org.eclipse.elk.layered.wrapping.validify.strategy', QCe = 'org.eclipse.elk.layered.wrapping.validify.forbiddenIndices', RCe = 'org.eclipse.elk.layered.wrapping.multiEdge.improveCuts', SCe = 'org.eclipse.elk.layered.wrapping.multiEdge.distancePenalty', TCe = 'org.eclipse.elk.layered.wrapping.multiEdge.improveWrappedEdges', UCe = 'org.eclipse.elk.layered.edgeLabels.sideSelection', VCe = 'org.eclipse.elk.layered.edgeLabels.centerLabelPlacementStrategy', WCe = 'org.eclipse.elk.layered.considerModelOrder.strategy', XCe = 'org.eclipse.elk.layered.considerModelOrder.portModelOrder', YCe = 'org.eclipse.elk.layered.considerModelOrder.noModelOrder', ZCe = 'org.eclipse.elk.layered.considerModelOrder.components', $Ce = 'org.eclipse.elk.layered.considerModelOrder.longEdgeStrategy', _Ce = 'org.eclipse.elk.layered.considerModelOrder.crossingCounterNodeInfluence', aDe = 'org.eclipse.elk.layered.considerModelOrder.crossingCounterPortInfluence', bDe = 'layering', cDe = 'layering.minWidth', dDe = 'layering.nodePromotion', eDe = 'crossingMinimization', fDe = 'org.eclipse.elk.hierarchyHandling', gDe = 'crossingMinimization.greedySwitch', hDe = 'nodePlacement', iDe = 'nodePlacement.bk', jDe = 'edgeRouting', kDe = 'org.eclipse.elk.edgeRouting', lDe = 'spacing', mDe = 'priority', nDe = 'compaction', oDe = 'compaction.postCompaction', pDe = 'Specifies whether and how post-process compaction is applied.', qDe = 'highDegreeNodes', rDe = 'wrapping', sDe = 'wrapping.cutting', tDe = 'wrapping.validify', uDe = 'wrapping.multiEdge', vDe = 'edgeLabels', wDe = 'considerModelOrder', xDe = 'org.eclipse.elk.spacing.commentComment', yDe = 'org.eclipse.elk.spacing.commentNode', zDe = 'org.eclipse.elk.spacing.edgeEdge', ADe = 'org.eclipse.elk.spacing.edgeNode', BDe = 'org.eclipse.elk.spacing.labelLabel', CDe = 'org.eclipse.elk.spacing.labelPortHorizontal', DDe = 'org.eclipse.elk.spacing.labelPortVertical', EDe = 'org.eclipse.elk.spacing.labelNode', FDe = 'org.eclipse.elk.spacing.nodeSelfLoop', GDe = 'org.eclipse.elk.spacing.portPort', HDe = 'org.eclipse.elk.spacing.individual', IDe = 'org.eclipse.elk.port.borderOffset', JDe = 'org.eclipse.elk.noLayout', KDe = 'org.eclipse.elk.port.side', LDe = 'org.eclipse.elk.debugMode', MDe = 'org.eclipse.elk.alignment', NDe = 'org.eclipse.elk.insideSelfLoops.activate', ODe = 'org.eclipse.elk.insideSelfLoops.yo', PDe = 'org.eclipse.elk.direction', QDe = 'org.eclipse.elk.nodeLabels.padding', RDe = 'org.eclipse.elk.portLabels.nextToPortIfPossible', SDe = 'org.eclipse.elk.portLabels.treatAsGroup', TDe = 'org.eclipse.elk.portAlignment.default', UDe = 'org.eclipse.elk.portAlignment.north', VDe = 'org.eclipse.elk.portAlignment.south', WDe = 'org.eclipse.elk.portAlignment.west', XDe = 'org.eclipse.elk.portAlignment.east', YDe = 'org.eclipse.elk.contentAlignment', ZDe = 'org.eclipse.elk.junctionPoints', $De = 'org.eclipse.elk.edgeLabels.placement', _De = 'org.eclipse.elk.port.index', aEe = 'org.eclipse.elk.commentBox', bEe = 'org.eclipse.elk.hypernode', cEe = 'org.eclipse.elk.port.anchor', dEe = 'org.eclipse.elk.partitioning.activate', eEe = 'org.eclipse.elk.partitioning.partition', fEe = 'org.eclipse.elk.position', gEe = 'org.eclipse.elk.margins', hEe = 'org.eclipse.elk.spacing.portsSurrounding', iEe = 'org.eclipse.elk.interactiveLayout', jEe = 'org.eclipse.elk.core.util', kEe = {
                            3: 1,
                            4: 1,
                            5: 1,
                            601: 1
                        }, lEe = 'NETWORK_SIMPLEX', mEe = 'SIMPLE', nEe = {
                            106: 1,
                            47: 1
                        }, oEe = 'org.eclipse.elk.alg.layered.p1cycles', pEe = 'org.eclipse.elk.alg.layered.p2layers', qEe = {
                            413: 1,
                            230: 1
                        }, rEe = {
                            846: 1,
                            3: 1,
                            4: 1
                        }, sEe = 'org.eclipse.elk.alg.layered.p3order', tEe = 'org.eclipse.elk.alg.layered.p4nodes', uEe = {
                            3: 1,
                            4: 1,
                            5: 1,
                            854: 1
                        }, vEe = 1.0E-5, wEe = 'org.eclipse.elk.alg.layered.p4nodes.bk', xEe = 'org.eclipse.elk.alg.layered.p5edges', yEe = 'org.eclipse.elk.alg.layered.p5edges.orthogonal', zEe = 'org.eclipse.elk.alg.layered.p5edges.orthogonal.direction', AEe = 1.0E-6, BEe = 'org.eclipse.elk.alg.layered.p5edges.splines', CEe = 0.09999999999999998, DEe = 1.0E-8, EEe = 4.71238898038469, FEe = 3.141592653589793, GEe = 'org.eclipse.elk.alg.mrtree', HEe = 0.10000000149011612, IEe = 'SUPER_ROOT', JEe = 'org.eclipse.elk.alg.mrtree.graph', KEe = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000, LEe = 'org.eclipse.elk.alg.mrtree.intermediate', MEe = 'Processor compute fanout', NEe = {
                            3: 1,
                            6: 1,
                            4: 1,
                            5: 1,
                            534: 1,
                            100: 1,
                            115: 1
                        }, OEe = 'Set neighbors in level', PEe = 'org.eclipse.elk.alg.mrtree.options', QEe = 'DESCENDANTS', REe = 'org.eclipse.elk.mrtree.compaction', SEe = 'org.eclipse.elk.mrtree.edgeEndTextureLength', TEe = 'org.eclipse.elk.mrtree.treeLevel', UEe = 'org.eclipse.elk.mrtree.positionConstraint', VEe = 'org.eclipse.elk.mrtree.weighting', WEe = 'org.eclipse.elk.mrtree.edgeRoutingMode', XEe = 'org.eclipse.elk.mrtree.searchOrder', YEe = 'Position Constraint', ZEe = 'org.eclipse.elk.mrtree', $Ee = 'org.eclipse.elk.tree', _Ee = 'Processor arrange level', aFe = 'org.eclipse.elk.alg.mrtree.p2order', bFe = 'org.eclipse.elk.alg.mrtree.p4route', cFe = 'org.eclipse.elk.alg.radial', dFe = 6.283185307179586, eFe = 'Before', fFe = 4.9E-324, gFe = 'After', hFe = 'org.eclipse.elk.alg.radial.intermediate', iFe = 'COMPACTION', jFe = 'org.eclipse.elk.alg.radial.intermediate.compaction', kFe = {
                            3: 1,
                            4: 1,
                            5: 1,
                            100: 1
                        }, lFe = 'org.eclipse.elk.alg.radial.intermediate.optimization', mFe = 'No implementation is available for the layout option ', nFe = 'org.eclipse.elk.alg.radial.options', oFe = 'org.eclipse.elk.radial.centerOnRoot', pFe = 'org.eclipse.elk.radial.orderId', qFe = 'org.eclipse.elk.radial.radius', rFe = 'org.eclipse.elk.radial.rotate', sFe = 'org.eclipse.elk.radial.compactor', tFe = 'org.eclipse.elk.radial.compactionStepSize', uFe = 'org.eclipse.elk.radial.sorter', vFe = 'org.eclipse.elk.radial.wedgeCriteria', wFe = 'org.eclipse.elk.radial.optimizationCriteria', xFe = 'org.eclipse.elk.radial.rotation.targetAngle', yFe = 'org.eclipse.elk.radial.rotation.computeAdditionalWedgeSpace', zFe = 'org.eclipse.elk.radial.rotation.outgoingEdgeAngles', AFe = 'Compaction', BFe = 'rotation', CFe = 'org.eclipse.elk.radial', DFe = 'org.eclipse.elk.alg.radial.p1position.wedge', EFe = 'org.eclipse.elk.alg.radial.sorting', FFe = 5.497787143782138, GFe = 3.9269908169872414, HFe = 2.356194490192345, IFe = 'org.eclipse.elk.alg.rectpacking', JFe = 'org.eclipse.elk.alg.rectpacking.intermediate', KFe = 'org.eclipse.elk.alg.rectpacking.options', LFe = 'org.eclipse.elk.rectpacking.trybox', MFe = 'org.eclipse.elk.rectpacking.currentPosition', NFe = 'org.eclipse.elk.rectpacking.desiredPosition', OFe = 'org.eclipse.elk.rectpacking.inNewRow', PFe = 'org.eclipse.elk.rectpacking.widthApproximation.strategy', QFe = 'org.eclipse.elk.rectpacking.widthApproximation.targetWidth', RFe = 'org.eclipse.elk.rectpacking.widthApproximation.optimizationGoal', SFe = 'org.eclipse.elk.rectpacking.widthApproximation.lastPlaceShift', TFe = 'org.eclipse.elk.rectpacking.packing.strategy', UFe = 'org.eclipse.elk.rectpacking.packing.compaction.rowHeightReevaluation', VFe = 'org.eclipse.elk.rectpacking.packing.compaction.iterations', WFe = 'org.eclipse.elk.rectpacking.whiteSpaceElimination.strategy', XFe = 'widthApproximation', YFe = 'Compaction Strategy', ZFe = 'packing.compaction', $Fe = 'org.eclipse.elk.rectpacking', _Fe = 'org.eclipse.elk.alg.rectpacking.p1widthapproximation', aGe = 'org.eclipse.elk.alg.rectpacking.p2packing', bGe = 'No Compaction', cGe = 'org.eclipse.elk.alg.rectpacking.p3whitespaceelimination', dGe = 'org.eclipse.elk.alg.rectpacking.util', eGe = 'No implementation available for ', fGe = 'org.eclipse.elk.alg.spore', gGe = 'org.eclipse.elk.alg.spore.options', hGe = 'org.eclipse.elk.sporeCompaction', iGe = 'org.eclipse.elk.underlyingLayoutAlgorithm', jGe = 'org.eclipse.elk.processingOrder.treeConstruction', kGe = 'org.eclipse.elk.processingOrder.spanningTreeCostFunction', lGe = 'org.eclipse.elk.processingOrder.preferredRoot', mGe = 'org.eclipse.elk.processingOrder.rootSelection', nGe = 'org.eclipse.elk.structure.structureExtractionStrategy', oGe = 'org.eclipse.elk.compaction.compactionStrategy', pGe = 'org.eclipse.elk.compaction.orthogonal', qGe = 'org.eclipse.elk.overlapRemoval.maxIterations', rGe = 'org.eclipse.elk.overlapRemoval.runScanline', sGe = 'processingOrder', tGe = 'overlapRemoval', uGe = 'org.eclipse.elk.sporeOverlap', vGe = 'org.eclipse.elk.alg.spore.p1structure', wGe = 'org.eclipse.elk.alg.spore.p2processingorder', xGe = 'org.eclipse.elk.alg.spore.p3execution', yGe = 'Topdown Layout', zGe = 'Invalid index: ', AGe = 'org.eclipse.elk.core.alg', BGe = {
                            341: 1
                        }, CGe = {
                            295: 1
                        }, DGe = 'Make sure its type is registered with the ', EGe = ' utility class.', FGe = 'true', GGe = 'false', HGe = "Couldn't clone property '", IGe = 0.05, JGe = 'org.eclipse.elk.core.options', KGe = 1.2999999523162842, LGe = 'org.eclipse.elk.box', MGe = 'org.eclipse.elk.expandNodes', NGe = 'org.eclipse.elk.box.packingMode', OGe = 'org.eclipse.elk.algorithm', PGe = 'org.eclipse.elk.resolvedAlgorithm', QGe = 'org.eclipse.elk.bendPoints', RGe = 'org.eclipse.elk.labelManager', SGe = 'org.eclipse.elk.scaleFactor', TGe = 'org.eclipse.elk.childAreaWidth', UGe = 'org.eclipse.elk.childAreaHeight', VGe = 'org.eclipse.elk.animate', WGe = 'org.eclipse.elk.animTimeFactor', XGe = 'org.eclipse.elk.layoutAncestors', YGe = 'org.eclipse.elk.maxAnimTime', ZGe = 'org.eclipse.elk.minAnimTime', $Ge = 'org.eclipse.elk.progressBar', _Ge = 'org.eclipse.elk.validateGraph', aHe = 'org.eclipse.elk.validateOptions', bHe = 'org.eclipse.elk.zoomToFit', cHe = 'org.eclipse.elk.font.name', dHe = 'org.eclipse.elk.font.size', eHe = 'org.eclipse.elk.topdown.sizeApproximator', fHe = 'org.eclipse.elk.topdown.scaleCap', gHe = 'org.eclipse.elk.edge.type', hHe = 'partitioning', iHe = 'nodeLabels', jHe = 'portAlignment', kHe = 'nodeSize', lHe = 'port', mHe = 'portLabels', nHe = 'topdown', oHe = 'insideSelfLoops', pHe = 'org.eclipse.elk.fixed', qHe = 'org.eclipse.elk.random', rHe = {
                            3: 1,
                            34: 1,
                            22: 1,
                            347: 1
                        }, sHe = 'port must have a parent node to calculate the port side', tHe = 'The edge needs to have exactly one edge section. Found: ', uHe = 'org.eclipse.elk.core.util.adapters', vHe = 'org.eclipse.emf.ecore', wHe = 'org.eclipse.elk.graph', xHe = 'EMapPropertyHolder', yHe = 'ElkBendPoint', zHe = 'ElkGraphElement', AHe = 'ElkConnectableShape', BHe = 'ElkEdge', CHe = 'ElkEdgeSection', DHe = 'EModelElement', EHe = 'ENamedElement', FHe = 'ElkLabel', GHe = 'ElkNode', HHe = 'ElkPort', IHe = {
                            94: 1,
                            93: 1
                        }, JHe = 'org.eclipse.emf.common.notify.impl', KHe = "The feature '", LHe = "' is not a valid changeable feature", MHe = 'Expecting null', NHe = "' is not a valid feature", OHe = 'The feature ID', PHe = ' is not a valid feature ID', QHe = 32768, RHe = {
                            110: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            54: 1,
                            99: 1
                        }, SHe = 'org.eclipse.emf.ecore.impl', THe = 'org.eclipse.elk.graph.impl', UHe = 'Recursive containment not allowed for ', VHe = "The datatype '", WHe = "' is not a valid classifier", XHe = "The value '", YHe = {
                            195: 1,
                            3: 1,
                            4: 1
                        }, ZHe = "The class '", $He = 'http://www.eclipse.org/elk/ElkGraph', _He = 'property', aIe = 'value', bIe = 'source', cIe = 'properties', dIe = 'identifier', eIe = 'height', fIe = 'width', gIe = 'parent', hIe = 'text', iIe = 'children', jIe = 'hierarchical', kIe = 'sources', lIe = 'targets', mIe = 'sections', nIe = 'bendPoints', oIe = 'outgoingShape', pIe = 'incomingShape', qIe = 'outgoingSections', rIe = 'incomingSections', sIe = 'org.eclipse.emf.common.util', tIe = 'Severe implementation error in the Json to ElkGraph importer.', uIe = 'id', vIe = 'org.eclipse.elk.graph.json', wIe = 'Unhandled parameter types: ', xIe = 'startPoint', yIe = "An edge must have at least one source and one target (edge id: '", zIe = "').", AIe = 'Referenced edge section does not exist: ', BIe = " (edge id: '", CIe = 'target', DIe = 'sourcePoint', EIe = 'targetPoint', FIe = 'group', GIe = 'name', HIe = 'connectableShape cannot be null', IIe = 'edge cannot be null', JIe = "Passed edge is not 'simple'.", KIe = 'org.eclipse.elk.graph.util', LIe = "The 'no duplicates' constraint is violated", MIe = 'targetIndex=', NIe = ', size=', OIe = 'sourceIndex=', PIe = {
                            3: 1,
                            4: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            59: 1,
                            70: 1,
                            66: 1,
                            61: 1
                        }, QIe = {
                            3: 1,
                            4: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            51: 1,
                            15: 1,
                            59: 1,
                            70: 1,
                            66: 1,
                            61: 1,
                            596: 1
                        }, RIe = 'logging', SIe = 'measureExecutionTime', TIe = 'parser.parse.1', UIe = 'parser.parse.2', VIe = 'parser.next.1', WIe = 'parser.next.2', XIe = 'parser.next.3', YIe = 'parser.next.4', ZIe = 'parser.factor.1', $Ie = 'parser.factor.2', _Ie = 'parser.factor.3', aJe = 'parser.factor.4', bJe = 'parser.factor.5', cJe = 'parser.factor.6', dJe = 'parser.atom.1', eJe = 'parser.atom.2', fJe = 'parser.atom.3', gJe = 'parser.atom.4', hJe = 'parser.atom.5', iJe = 'parser.cc.1', jJe = 'parser.cc.2', kJe = 'parser.cc.3', lJe = 'parser.cc.5', mJe = 'parser.cc.6', nJe = 'parser.cc.7', oJe = 'parser.cc.8', pJe = 'parser.ope.1', qJe = 'parser.ope.2', rJe = 'parser.ope.3', sJe = 'parser.descape.1', tJe = 'parser.descape.2', uJe = 'parser.descape.3', vJe = 'parser.descape.4', wJe = 'parser.descape.5', xJe = 'parser.process.1', yJe = 'parser.quantifier.1', zJe = 'parser.quantifier.2', AJe = 'parser.quantifier.3', BJe = 'parser.quantifier.4', CJe = 'parser.quantifier.5', DJe = 'org.eclipse.emf.common.notify', EJe = {
                            424: 1,
                            686: 1
                        }, FJe = {
                            3: 1,
                            4: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            70: 1,
                            61: 1
                        }, GJe = {
                            378: 1,
                            152: 1
                        }, HJe = 'index=', IJe = {
                            3: 1,
                            4: 1,
                            5: 1,
                            129: 1
                        }, JJe = {
                            3: 1,
                            4: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            59: 1,
                            70: 1,
                            61: 1
                        }, KJe = {
                            3: 1,
                            6: 1,
                            4: 1,
                            5: 1,
                            198: 1
                        }, LJe = {
                            3: 1,
                            4: 1,
                            5: 1,
                            173: 1,
                            379: 1
                        }, MJe = ';/?:@&=+$,', NJe = 'invalid authority: ', OJe = 'EAnnotation', PJe = 'ETypedElement', QJe = 'EStructuralFeature', RJe = 'EAttribute', SJe = 'EClassifier', TJe = 'EEnumLiteral', UJe = 'EGenericType', VJe = 'EOperation', WJe = 'EParameter', XJe = 'EReference', YJe = 'ETypeParameter', ZJe = 'org.eclipse.emf.ecore.util', $Je = {
                            79: 1
                        }, _Je = {
                            3: 1,
                            20: 1,
                            16: 1,
                            15: 1,
                            61: 1,
                            597: 1,
                            79: 1,
                            71: 1,
                            97: 1
                        }, aKe = 'org.eclipse.emf.ecore.util.FeatureMap$Entry', bKe = 8192, cKe = 2048, dKe = 'byte', eKe = 'char', fKe = 'double', gKe = 'float', hKe = 'int', iKe = 'long', jKe = 'short', kKe = 'java.lang.Object', lKe = {
                            3: 1,
                            4: 1,
                            5: 1,
                            254: 1
                        }, mKe = {
                            3: 1,
                            4: 1,
                            5: 1,
                            688: 1
                        }, nKe = {
                            3: 1,
                            4: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            59: 1,
                            70: 1,
                            66: 1,
                            61: 1,
                            71: 1
                        }, oKe = {
                            3: 1,
                            4: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            59: 1,
                            70: 1,
                            66: 1,
                            61: 1,
                            79: 1,
                            71: 1,
                            97: 1
                        }, pKe = 'mixed', qKe = 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', rKe = 'kind', sKe = {
                            3: 1,
                            4: 1,
                            5: 1,
                            689: 1
                        }, tKe = {
                            3: 1,
                            4: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            70: 1,
                            61: 1,
                            79: 1,
                            71: 1,
                            97: 1
                        }, uKe = {
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            61: 1,
                            71: 1
                        }, vKe = {
                            51: 1,
                            128: 1,
                            287: 1
                        }, wKe = {
                            76: 1,
                            343: 1
                        }, xKe = "The value of type '", yKe = "' must be of type '", zKe = 1352, AKe = 'http://www.eclipse.org/emf/2002/Ecore', BKe = -32768, CKe = 'constraints', DKe = 'baseType', EKe = 'getEStructuralFeature', FKe = 'getFeatureID', GKe = 'feature', HKe = 'getOperationID', IKe = 'operation', JKe = 'defaultValue', KKe = 'eTypeParameters', LKe = 'isInstance', MKe = 'getEEnumLiteral', NKe = 'eContainingClass', OKe = {
                            57: 1
                        }, PKe = {
                            3: 1,
                            4: 1,
                            5: 1,
                            124: 1
                        }, QKe = 'org.eclipse.emf.ecore.resource', RKe = {
                            94: 1,
                            93: 1,
                            599: 1,
                            2034: 1
                        }, SKe = 'org.eclipse.emf.ecore.resource.impl', TKe = 'unspecified', UKe = 'simple', VKe = 'attribute', WKe = 'attributeWildcard', XKe = 'element', YKe = 'elementWildcard', ZKe = 'collapse', $Ke = 'itemType', _Ke = 'namespace', aLe = '##targetNamespace', bLe = 'whiteSpace', cLe = 'wildcards', dLe = 'http://www.eclipse.org/emf/2003/XMLType', eLe = '##any', fLe = 'uninitialized', gLe = 'The multiplicity constraint is violated', hLe = 'org.eclipse.emf.ecore.xml.type', iLe = 'ProcessingInstruction', jLe = 'SimpleAnyType', kLe = 'XMLTypeDocumentRoot', lLe = 'org.eclipse.emf.ecore.xml.type.impl', mLe = 'INF', nLe = 'processing', oLe = 'ENTITIES_._base', pLe = 'minLength', qLe = 'ENTITY', rLe = 'NCName', sLe = 'IDREFS_._base', tLe = 'integer', uLe = 'token', vLe = 'pattern', wLe = '[a-zA-Z]{1,8}(-[a-zA-Z0-9]{1,8})*', xLe = '\\i\\c*', yLe = '[\\i-[:]][\\c-[:]]*', zLe = 'nonPositiveInteger', ALe = 'maxInclusive', BLe = 'NMTOKEN', CLe = 'NMTOKENS_._base', DLe = 'nonNegativeInteger', ELe = 'minInclusive', FLe = 'normalizedString', GLe = 'unsignedByte', HLe = 'unsignedInt', ILe = '18446744073709551615', JLe = 'unsignedShort', KLe = 'processingInstruction', LLe = 'org.eclipse.emf.ecore.xml.type.internal', MLe = 1114111, NLe = 'Internal Error: shorthands: \\u', OLe = 'xml:isDigit', PLe = 'xml:isWord', QLe = 'xml:isSpace', RLe = 'xml:isNameChar', SLe = 'xml:isInitialNameChar', TLe = '09\u0660\u0669\u06F0\u06F9\u0966\u096F\u09E6\u09EF\u0A66\u0A6F\u0AE6\u0AEF\u0B66\u0B6F\u0BE7\u0BEF\u0C66\u0C6F\u0CE6\u0CEF\u0D66\u0D6F\u0E50\u0E59\u0ED0\u0ED9\u0F20\u0F29', ULe = 'AZaz\xC0\xD6\xD8\xF6\xF8\u0131\u0134\u013E\u0141\u0148\u014A\u017E\u0180\u01C3\u01CD\u01F0\u01F4\u01F5\u01FA\u0217\u0250\u02A8\u02BB\u02C1\u0386\u0386\u0388\u038A\u038C\u038C\u038E\u03A1\u03A3\u03CE\u03D0\u03D6\u03DA\u03DA\u03DC\u03DC\u03DE\u03DE\u03E0\u03E0\u03E2\u03F3\u0401\u040C\u040E\u044F\u0451\u045C\u045E\u0481\u0490\u04C4\u04C7\u04C8\u04CB\u04CC\u04D0\u04EB\u04EE\u04F5\u04F8\u04F9\u0531\u0556\u0559\u0559\u0561\u0586\u05D0\u05EA\u05F0\u05F2\u0621\u063A\u0641\u064A\u0671\u06B7\u06BA\u06BE\u06C0\u06CE\u06D0\u06D3\u06D5\u06D5\u06E5\u06E6\u0905\u0939\u093D\u093D\u0958\u0961\u0985\u098C\u098F\u0990\u0993\u09A8\u09AA\u09B0\u09B2\u09B2\u09B6\u09B9\u09DC\u09DD\u09DF\u09E1\u09F0\u09F1\u0A05\u0A0A\u0A0F\u0A10\u0A13\u0A28\u0A2A\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59\u0A5C\u0A5E\u0A5E\u0A72\u0A74\u0A85\u0A8B\u0A8D\u0A8D\u0A8F\u0A91\u0A93\u0AA8\u0AAA\u0AB0\u0AB2\u0AB3\u0AB5\u0AB9\u0ABD\u0ABD\u0AE0\u0AE0\u0B05\u0B0C\u0B0F\u0B10\u0B13\u0B28\u0B2A\u0B30\u0B32\u0B33\u0B36\u0B39\u0B3D\u0B3D\u0B5C\u0B5D\u0B5F\u0B61\u0B85\u0B8A\u0B8E\u0B90\u0B92\u0B95\u0B99\u0B9A\u0B9C\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8\u0BAA\u0BAE\u0BB5\u0BB7\u0BB9\u0C05\u0C0C\u0C0E\u0C10\u0C12\u0C28\u0C2A\u0C33\u0C35\u0C39\u0C60\u0C61\u0C85\u0C8C\u0C8E\u0C90\u0C92\u0CA8\u0CAA\u0CB3\u0CB5\u0CB9\u0CDE\u0CDE\u0CE0\u0CE1\u0D05\u0D0C\u0D0E\u0D10\u0D12\u0D28\u0D2A\u0D39\u0D60\u0D61\u0E01\u0E2E\u0E30\u0E30\u0E32\u0E33\u0E40\u0E45\u0E81\u0E82\u0E84\u0E84\u0E87\u0E88\u0E8A\u0E8A\u0E8D\u0E8D\u0E94\u0E97\u0E99\u0E9F\u0EA1\u0EA3\u0EA5\u0EA5\u0EA7\u0EA7\u0EAA\u0EAB\u0EAD\u0EAE\u0EB0\u0EB0\u0EB2\u0EB3\u0EBD\u0EBD\u0EC0\u0EC4\u0F40\u0F47\u0F49\u0F69\u10A0\u10C5\u10D0\u10F6\u1100\u1100\u1102\u1103\u1105\u1107\u1109\u1109\u110B\u110C\u110E\u1112\u113C\u113C\u113E\u113E\u1140\u1140\u114C\u114C\u114E\u114E\u1150\u1150\u1154\u1155\u1159\u1159\u115F\u1161\u1163\u1163\u1165\u1165\u1167\u1167\u1169\u1169\u116D\u116E\u1172\u1173\u1175\u1175\u119E\u119E\u11A8\u11A8\u11AB\u11AB\u11AE\u11AF\u11B7\u11B8\u11BA\u11BA\u11BC\u11C2\u11EB\u11EB\u11F0\u11F0\u11F9\u11F9\u1E00\u1E9B\u1EA0\u1EF9\u1F00\u1F15\u1F18\u1F1D\u1F20\u1F45\u1F48\u1F4D\u1F50\u1F57\u1F59\u1F59\u1F5B\u1F5B\u1F5D\u1F5D\u1F5F\u1F7D\u1F80\u1FB4\u1FB6\u1FBC\u1FBE\u1FBE\u1FC2\u1FC4\u1FC6\u1FCC\u1FD0\u1FD3\u1FD6\u1FDB\u1FE0\u1FEC\u1FF2\u1FF4\u1FF6\u1FFC\u2126\u2126\u212A\u212B\u212E\u212E\u2180\u2182\u3007\u3007\u3021\u3029\u3041\u3094\u30A1\u30FA\u3105\u312C\u4E00\u9FA5\uAC00\uD7A3', VLe = 'Private Use', WLe = 'ASSIGNED', XLe = '\x00\x7F\x80\xFF\u0100\u017F\u0180\u024F\u0250\u02AF\u02B0\u02FF\u0300\u036F\u0370\u03FF\u0400\u04FF\u0530\u058F\u0590\u05FF\u0600\u06FF\u0700\u074F\u0780\u07BF\u0900\u097F\u0980\u09FF\u0A00\u0A7F\u0A80\u0AFF\u0B00\u0B7F\u0B80\u0BFF\u0C00\u0C7F\u0C80\u0CFF\u0D00\u0D7F\u0D80\u0DFF\u0E00\u0E7F\u0E80\u0EFF\u0F00\u0FFF\u1000\u109F\u10A0\u10FF\u1100\u11FF\u1200\u137F\u13A0\u13FF\u1400\u167F\u1680\u169F\u16A0\u16FF\u1780\u17FF\u1800\u18AF\u1E00\u1EFF\u1F00\u1FFF\u2000\u206F\u2070\u209F\u20A0\u20CF\u20D0\u20FF\u2100\u214F\u2150\u218F\u2190\u21FF\u2200\u22FF\u2300\u23FF\u2400\u243F\u2440\u245F\u2460\u24FF\u2500\u257F\u2580\u259F\u25A0\u25FF\u2600\u26FF\u2700\u27BF\u2800\u28FF\u2E80\u2EFF\u2F00\u2FDF\u2FF0\u2FFF\u3000\u303F\u3040\u309F\u30A0\u30FF\u3100\u312F\u3130\u318F\u3190\u319F\u31A0\u31BF\u3200\u32FF\u3300\u33FF\u3400\u4DB5\u4E00\u9FFF\uA000\uA48F\uA490\uA4CF\uAC00\uD7A3\uE000\uF8FF\uF900\uFAFF\uFB00\uFB4F\uFB50\uFDFF\uFE20\uFE2F\uFE30\uFE4F\uFE50\uFE6F\uFE70\uFEFE\uFEFF\uFEFF\uFF00\uFFEF', YLe = 'UNASSIGNED', ZLe = {
                            3: 1,
                            122: 1
                        }, $Le = 'org.eclipse.emf.ecore.xml.type.util', _Le = {
                            3: 1,
                            4: 1,
                            5: 1,
                            381: 1
                        }, aMe = 'org.eclipse.xtext.xbase.lib', bMe = 'Cannot add elements to a Range', cMe = 'Cannot set elements in a Range', dMe = 'Cannot remove elements from a Range', eMe = 'user.agent';
                        var _, eeb, _db, ydb = -1;
                        $wnd.goog = $wnd.goog || {};
                        $wnd.goog.global = $wnd.goog.global || $wnd;
                        eeb = {};
                        feb(1, null, {}, nb);
                        _.Fb = function ob(a) {
                            return mb(this, a);
                        };
                        _.Gb = function qb() {
                            return this.Rm;
                        };
                        _.Hb = function sb() {
                            return kFb(this);
                        };
                        _.Ib = function ub() {
                            var a;
                            return nfb(rb(this)) + '@' + (a = tb(this) >>> 0, a.toString(16));
                        };
                        _.equals = function(a) {
                            return this.Fb(a);
                        };
                        _.hashCode = function() {
                            return this.Hb();
                        };
                        _.toString = function() {
                            return this.Ib();
                        };
                        var ND, OD, PD;
                        feb(297, 1, {
                            297: 1,
                            2124: 1
                        }, pfb);
                        _.ve = function qfb(a) {
                            var b;
                            b = new pfb;
                            b.i = 4;
                            a > 1 ? b.c = xfb(this, a - 1) : b.c = this;
                            return b;
                        };
                        _.we = function wfb() {
                            lfb(this);
                            return this.b;
                        };
                        _.xe = function yfb() {
                            return nfb(this);
                        };
                        _.ye = function Afb() {
                            return lfb(this), this.k;
                        };
                        _.ze = function Cfb() {
                            return (this.i & 4) != 0;
                        };
                        _.Ae = function Dfb() {
                            return (this.i & 1) != 0;
                        };
                        _.Ib = function Gfb() {
                            return ofb(this);
                        };
                        _.i = 0;
                        var kfb = 1;
                        var jJ = sfb(mve, 'Object', 1);
                        var UI = sfb(mve, 'Class', 297);
                        feb(2096, 1, nve);
                        var oE = sfb(ove, 'Optional', 2096);
                        feb(1191, 2096, nve, xb);
                        _.Fb = function yb(a) {
                            return a === this;
                        };
                        _.Hb = function zb() {
                            return 2040732332;
                        };
                        _.Ib = function Ab() {
                            return 'Optional.absent()';
                        };
                        _.Jb = function Bb(a) {
                            Qb(a);
                            return wb(), vb;
                        };
                        var vb;
                        var mE = sfb(ove, 'Absent', 1191);
                        feb(636, 1, {}, Gb);
                        var nE = sfb(ove, 'Joiner', 636);
                        var pE = ufb(ove, 'Predicate');
                        feb(589, 1, {
                            178: 1,
                            589: 1,
                            3: 1,
                            46: 1
                        }, Yb);
                        _.Mb = function ac(a) {
                            return Xb(this, a);
                        };
                        _.Lb = function Zb(a) {
                            return Xb(this, a);
                        };
                        _.Fb = function $b(a) {
                            var b;
                            if (ZD(a, 589)) {
                                b = RD(a, 589);
                                return Rt(this.a, b.a);
                            }
                            return false;
                        };
                        _.Hb = function _b() {
                            return Cob(this.a) + 306654252;
                        };
                        _.Ib = function bc() {
                            return Wb(this.a);
                        };
                        var qE = sfb(ove, 'Predicates/AndPredicate', 589);
                        feb(419, 2096, {
                            419: 1,
                            3: 1
                        }, cc);
                        _.Fb = function dc(a) {
                            var b;
                            if (ZD(a, 419)) {
                                b = RD(a, 419);
                                return pb(this.a, b.a);
                            }
                            return false;
                        };
                        _.Hb = function ec() {
                            return 1502476572 + tb(this.a);
                        };
                        _.Ib = function fc() {
                            return uve + this.a + ')';
                        };
                        _.Jb = function gc(a) {
                            return new cc(Rb(a.Kb(this.a), 'the Function passed to Optional.transform() must not return null.'));
                        };
                        var rE = sfb(ove, 'Present', 419);
                        feb(204, 1, wve);
                        _.Nb = function kc(a) {
                            Ztb(this, a);
                        };
                        _.Qb = function lc() {
                            jc();
                        };
                        var eI = sfb(xve, 'UnmodifiableIterator', 204);
                        feb(2076, 204, yve);
                        _.Qb = function nc() {
                            jc();
                        };
                        _.Rb = function mc(a) {
                            throw Adb(new jib);
                        };
                        _.Wb = function oc(a) {
                            throw Adb(new jib);
                        };
                        var fI = sfb(xve, 'UnmodifiableListIterator', 2076);
                        feb(399, 2076, yve);
                        _.Ob = function rc() {
                            return this.c < this.d;
                        };
                        _.Sb = function sc() {
                            return this.c > 0;
                        };
                        _.Pb = function tc() {
                            if (this.c >= this.d) throw Adb(new Dvb);
                            return this.Xb(this.c++);
                        };
                        _.Tb = function uc() {
                            return this.c;
                        };
                        _.Ub = function vc() {
                            if (this.c <= 0) throw Adb(new Dvb);
                            return this.Xb(--this.c);
                        };
                        _.Vb = function wc() {
                            return this.c - 1;
                        };
                        _.c = 0;
                        _.d = 0;
                        var sE = sfb(xve, 'AbstractIndexedListIterator', 399);
                        feb(713, 204, wve);
                        _.Ob = function Ac() {
                            return xc(this);
                        };
                        _.Pb = function Bc() {
                            return yc(this);
                        };
                        _.e = 1;
                        var tE = sfb(xve, 'AbstractIterator', 713);
                        feb(2084, 1, {
                            229: 1
                        });
                        _.Zb = function Hc() {
                            var a;
                            return a = this.f, !a ? this.f = this.ac() : a;
                        };
                        _.Fb = function Ic(a) {
                            return xw(this, a);
                        };
                        _.Hb = function Jc() {
                            return tb(this.Zb());
                        };
                        _.dc = function Kc() {
                            return this.gc() == 0;
                        };
                        _.ec = function Lc() {
                            return Ec(this);
                        };
                        _.Ib = function Mc() {
                            return jeb(this.Zb());
                        };
                        var YE = sfb(xve, 'AbstractMultimap', 2084);
                        feb(742, 2084, zve);
                        _.$b = function Xc() {
                            Nc(this);
                        };
                        _._b = function Yc(a) {
                            return Oc(this, a);
                        };
                        _.ac = function Zc() {
                            return new ne(this, this.c);
                        };
                        _.ic = function $c(a) {
                            return this.hc();
                        };
                        _.bc = function _c() {
                            return new zf(this, this.c);
                        };
                        _.jc = function ad() {
                            return this.mc(this.hc());
                        };
                        _.kc = function bd() {
                            return new Hd(this);
                        };
                        _.lc = function cd() {
                            return ek(this.c.vc().Nc(), new hh, 64, this.d);
                        };
                        _.cc = function dd(a) {
                            return Qc(this, a);
                        };
                        _.fc = function gd(a) {
                            return Sc(this, a);
                        };
                        _.gc = function hd() {
                            return this.d;
                        };
                        _.mc = function jd(a) {
                            return yob(), new xpb(a);
                        };
                        _.nc = function kd() {
                            return new Dd(this);
                        };
                        _.oc = function ld() {
                            return ek(this.c.Cc().Nc(), new Fd, 64, this.d);
                        };
                        _.pc = function md(a, b) {
                            return new lg(this, a, b, null);
                        };
                        _.d = 0;
                        var TE = sfb(xve, 'AbstractMapBasedMultimap', 742);
                        feb(1696, 742, zve);
                        _.hc = function pd() {
                            return new cnb(this.a);
                        };
                        _.jc = function qd() {
                            return yob(), yob(), vob;
                        };
                        _.cc = function sd(a) {
                            return RD(Qc(this, a), 15);
                        };
                        _.fc = function ud(a) {
                            return RD(Sc(this, a), 15);
                        };
                        _.Zb = function od() {
                            return nd(this);
                        };
                        _.Fb = function rd(a) {
                            return xw(this, a);
                        };
                        _.qc = function td(a) {
                            return RD(Qc(this, a), 15);
                        };
                        _.rc = function vd(a) {
                            return RD(Sc(this, a), 15);
                        };
                        _.mc = function wd(a) {
                            return Hob(RD(a, 15));
                        };
                        _.pc = function xd(a, b) {
                            return Vc(this, a, RD(b, 15), null);
                        };
                        var uE = sfb(xve, 'AbstractListMultimap', 1696);
                        feb(748, 1, Ave);
                        _.Nb = function zd(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function Ad() {
                            return this.c.Ob() || this.e.Ob();
                        };
                        _.Pb = function Bd() {
                            var a;
                            if (!this.e.Ob()) {
                                a = RD(this.c.Pb(), 44);
                                this.b = a.ld();
                                this.a = RD(a.md(), 16);
                                this.e = this.a.Kc();
                            }
                            return this.sc(this.b, this.e.Pb());
                        };
                        _.Qb = function Cd() {
                            this.e.Qb();
                            RD(Hvb(this.a), 16).dc() && this.c.Qb();
                            --this.d.d;
                        };
                        var CE = sfb(xve, 'AbstractMapBasedMultimap/Itr', 748);
                        feb(1129, 748, Ave, Dd);
                        _.sc = function Ed(a, b) {
                            return b;
                        };
                        var vE = sfb(xve, 'AbstractMapBasedMultimap/1', 1129);
                        feb(1130, 1, {}, Fd);
                        _.Kb = function Gd(a) {
                            return RD(a, 16).Nc();
                        };
                        var wE = sfb(xve, 'AbstractMapBasedMultimap/1methodref$spliterator$Type', 1130);
                        feb(1131, 748, Ave, Hd);
                        _.sc = function Id(a, b) {
                            return new gp(a, b);
                        };
                        var xE = sfb(xve, 'AbstractMapBasedMultimap/2', 1131);
                        var VK = ufb(Bve, 'Map');
                        feb(2065, 1, Cve);
                        _.wc = function Td(a) {
                            Bvb(this, a);
                        };
                        _.yc = function $d(a, b, c) {
                            return Cvb(this, a, b, c);
                        };
                        _.$b = function Od() {
                            this.vc().$b();
                        };
                        _.tc = function Pd(a) {
                            return Jd(this, a);
                        };
                        _._b = function Qd(a) {
                            return !!Kd(this, a, false);
                        };
                        _.uc = function Rd(a) {
                            var b, c, d;
                            for(c = this.vc().Kc(); c.Ob();){
                                b = RD(c.Pb(), 44);
                                d = b.md();
                                if (dE(a) === dE(d) || a != null && pb(a, d)) return true;
                            }
                            return false;
                        };
                        _.Fb = function Sd(a) {
                            var b, c, d;
                            if (a === this) return true;
                            if (!ZD(a, 85)) return false;
                            d = RD(a, 85);
                            if (this.gc() != d.gc()) return false;
                            for(c = d.vc().Kc(); c.Ob();){
                                b = RD(c.Pb(), 44);
                                if (!this.tc(b)) return false;
                            }
                            return true;
                        };
                        _.xc = function Ud(a) {
                            return Wd(Kd(this, a, false));
                        };
                        _.Hb = function Xd() {
                            return Bob(this.vc());
                        };
                        _.dc = function Yd() {
                            return this.gc() == 0;
                        };
                        _.ec = function Zd() {
                            return new Xkb(this);
                        };
                        _.zc = function _d(a, b) {
                            throw Adb(new kib('Put not supported on this map'));
                        };
                        _.Ac = function ae(a) {
                            Ld(this, a);
                        };
                        _.Bc = function be(a) {
                            return Wd(Kd(this, a, true));
                        };
                        _.gc = function ce() {
                            return this.vc().gc();
                        };
                        _.Ib = function de() {
                            return Md(this);
                        };
                        _.Cc = function ee() {
                            return new glb(this);
                        };
                        var KJ = sfb(Bve, 'AbstractMap', 2065);
                        feb(2085, 2065, Cve);
                        _.bc = function ge() {
                            return new rf(this);
                        };
                        _.vc = function he() {
                            return fe(this);
                        };
                        _.ec = function ie() {
                            var a;
                            a = this.g;
                            return !a ? this.g = this.bc() : a;
                        };
                        _.Cc = function je() {
                            var a;
                            a = this.i;
                            return !a ? this.i = new nw(this) : a;
                        };
                        var uH = sfb(xve, 'Maps/ViewCachingAbstractMap', 2085);
                        feb(402, 2085, Cve, ne);
                        _.xc = function se(a) {
                            return ke(this, a);
                        };
                        _.Bc = function ve(a) {
                            return le(this, a);
                        };
                        _.$b = function oe() {
                            this.d == this.e.c ? this.e.$b() : Ar(new mf(this));
                        };
                        _._b = function pe(a) {
                            return Wv(this.d, a);
                        };
                        _.Ec = function qe() {
                            return new df(this);
                        };
                        _.Dc = function() {
                            return this.Ec();
                        };
                        _.Fb = function re(a) {
                            return this === a || pb(this.d, a);
                        };
                        _.Hb = function te() {
                            return tb(this.d);
                        };
                        _.ec = function ue() {
                            return this.e.ec();
                        };
                        _.gc = function we() {
                            return this.d.gc();
                        };
                        _.Ib = function xe() {
                            return jeb(this.d);
                        };
                        var BE = sfb(xve, 'AbstractMapBasedMultimap/AsMap', 402);
                        var cJ = ufb(mve, 'Iterable');
                        feb(31, 1, Dve);
                        _.Jc = function Le(a) {
                            xgb(this, a);
                        };
                        _.Lc = function Ne() {
                            return this.Oc();
                        };
                        _.Nc = function Pe() {
                            return new Swb(this, 0);
                        };
                        _.Oc = function Qe() {
                            return new SDb(null, this.Nc());
                        };
                        _.Fc = function Ge(a) {
                            throw Adb(new kib('Add not supported on this collection'));
                        };
                        _.Gc = function He(a) {
                            return ye(this, a);
                        };
                        _.$b = function Ie() {
                            Ae(this);
                        };
                        _.Hc = function Je(a) {
                            return ze(this, a, false);
                        };
                        _.Ic = function Ke(a) {
                            return Be(this, a);
                        };
                        _.dc = function Me() {
                            return this.gc() == 0;
                        };
                        _.Mc = function Oe(a) {
                            return ze(this, a, true);
                        };
                        _.Pc = function Re() {
                            return De(this);
                        };
                        _.Qc = function Se(a) {
                            return Ee(this, a);
                        };
                        _.Ib = function Te() {
                            return Fe(this);
                        };
                        var vJ = sfb(Bve, 'AbstractCollection', 31);
                        var bL = ufb(Bve, 'Set');
                        feb(Eve, 31, Fve);
                        _.Nc = function Ye() {
                            return new Swb(this, 1);
                        };
                        _.Fb = function We(a) {
                            return Ue(this, a);
                        };
                        _.Hb = function Xe() {
                            return Bob(this);
                        };
                        var RJ = sfb(Bve, 'AbstractSet', Eve);
                        feb(2068, Eve, Fve);
                        var UH = sfb(xve, 'Sets/ImprovedAbstractSet', 2068);
                        feb(2069, 2068, Fve);
                        _.$b = function $e() {
                            this.Rc().$b();
                        };
                        _.Hc = function _e(a) {
                            return Ze(this, a);
                        };
                        _.dc = function af() {
                            return this.Rc().dc();
                        };
                        _.Mc = function bf(a) {
                            var b;
                            if (this.Hc(a) && ZD(a, 44)) {
                                b = RD(a, 44);
                                return this.Rc().ec().Mc(b.ld());
                            }
                            return false;
                        };
                        _.gc = function cf() {
                            return this.Rc().gc();
                        };
                        var nH = sfb(xve, 'Maps/EntrySet', 2069);
                        feb(1127, 2069, Fve, df);
                        _.Hc = function ef(a) {
                            return Nk(this.a.d.vc(), a);
                        };
                        _.Kc = function ff() {
                            return new mf(this.a);
                        };
                        _.Rc = function gf() {
                            return this.a;
                        };
                        _.Mc = function hf(a) {
                            var b;
                            if (!Nk(this.a.d.vc(), a)) return false;
                            b = RD(Hvb(RD(a, 44)), 44);
                            Tc(this.a.e, b.ld());
                            return true;
                        };
                        _.Nc = function jf() {
                            return gk(this.a.d.vc().Nc(), new kf(this.a));
                        };
                        var zE = sfb(xve, 'AbstractMapBasedMultimap/AsMap/AsMapEntries', 1127);
                        feb(1128, 1, {}, kf);
                        _.Kb = function lf(a) {
                            return me(this.a, RD(a, 44));
                        };
                        var yE = sfb(xve, 'AbstractMapBasedMultimap/AsMap/AsMapEntries/0methodref$wrapEntry$Type', 1128);
                        feb(746, 1, Ave, mf);
                        _.Nb = function nf(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function pf() {
                            var a;
                            return a = RD(this.b.Pb(), 44), this.a = RD(a.md(), 16), me(this.c, a);
                        };
                        _.Ob = function of() {
                            return this.b.Ob();
                        };
                        _.Qb = function qf() {
                            Vb(!!this.a);
                            this.b.Qb();
                            this.c.e.d -= this.a.gc();
                            this.a.$b();
                            this.a = null;
                        };
                        var AE = sfb(xve, 'AbstractMapBasedMultimap/AsMap/AsMapIterator', 746);
                        feb(542, 2068, Fve, rf);
                        _.$b = function sf() {
                            this.b.$b();
                        };
                        _.Hc = function tf(a) {
                            return this.b._b(a);
                        };
                        _.Jc = function uf(a) {
                            Qb(a);
                            this.b.wc(new lw(a));
                        };
                        _.dc = function vf() {
                            return this.b.dc();
                        };
                        _.Kc = function wf() {
                            return new aw(this.b.vc().Kc());
                        };
                        _.Mc = function xf(a) {
                            if (this.b._b(a)) {
                                this.b.Bc(a);
                                return true;
                            }
                            return false;
                        };
                        _.gc = function yf() {
                            return this.b.gc();
                        };
                        var rH = sfb(xve, 'Maps/KeySet', 542);
                        feb(327, 542, Fve, zf);
                        _.$b = function Af() {
                            var a;
                            Ar((a = this.b.vc().Kc(), new Hf(this, a)));
                        };
                        _.Ic = function Bf(a) {
                            return this.b.ec().Ic(a);
                        };
                        _.Fb = function Cf(a) {
                            return this === a || pb(this.b.ec(), a);
                        };
                        _.Hb = function Df() {
                            return tb(this.b.ec());
                        };
                        _.Kc = function Ef() {
                            var a;
                            return a = this.b.vc().Kc(), new Hf(this, a);
                        };
                        _.Mc = function Ff(a) {
                            var b, c;
                            c = 0;
                            b = RD(this.b.Bc(a), 16);
                            if (b) {
                                c = b.gc();
                                b.$b();
                                this.a.d -= c;
                            }
                            return c > 0;
                        };
                        _.Nc = function Gf() {
                            return this.b.ec().Nc();
                        };
                        var EE = sfb(xve, 'AbstractMapBasedMultimap/KeySet', 327);
                        feb(747, 1, Ave, Hf);
                        _.Nb = function If(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function Jf() {
                            return this.c.Ob();
                        };
                        _.Pb = function Kf() {
                            this.a = RD(this.c.Pb(), 44);
                            return this.a.ld();
                        };
                        _.Qb = function Lf() {
                            var a;
                            Vb(!!this.a);
                            a = RD(this.a.md(), 16);
                            this.c.Qb();
                            this.b.a.d -= a.gc();
                            a.$b();
                            this.a = null;
                        };
                        var DE = sfb(xve, 'AbstractMapBasedMultimap/KeySet/1', 747);
                        feb(503, 402, {
                            85: 1,
                            133: 1
                        }, Mf);
                        _.bc = function Nf() {
                            return this.Sc();
                        };
                        _.ec = function Qf() {
                            return this.Uc();
                        };
                        _.Sc = function Of() {
                            return new eg(this.c, this.Wc());
                        };
                        _.Tc = function Pf() {
                            return this.Wc().Tc();
                        };
                        _.Uc = function Rf() {
                            var a;
                            return a = this.b, !a ? this.b = this.Sc() : a;
                        };
                        _.Vc = function Sf() {
                            return this.Wc().Vc();
                        };
                        _.Wc = function Tf() {
                            return RD(this.d, 133);
                        };
                        var IE = sfb(xve, 'AbstractMapBasedMultimap/SortedAsMap', 503);
                        feb(446, 503, Gve, Uf);
                        _.bc = function Wf() {
                            return new gg(this.a, RD(RD(this.d, 133), 139));
                        };
                        _.Sc = function Xf() {
                            return new gg(this.a, RD(RD(this.d, 133), 139));
                        };
                        _.ec = function _f() {
                            var a;
                            return a = this.b, RD(!a ? this.b = new gg(this.a, RD(RD(this.d, 133), 139)) : a, 277);
                        };
                        _.Uc = function ag() {
                            var a;
                            return a = this.b, RD(!a ? this.b = new gg(this.a, RD(RD(this.d, 133), 139)) : a, 277);
                        };
                        _.Wc = function cg() {
                            return RD(RD(this.d, 133), 139);
                        };
                        _.Xc = function Vf(a) {
                            return RD(RD(this.d, 133), 139).Xc(a);
                        };
                        _.Yc = function Yf(a) {
                            return RD(RD(this.d, 133), 139).Yc(a);
                        };
                        _.Zc = function Zf(a, b) {
                            return new Uf(this.a, RD(RD(this.d, 133), 139).Zc(a, b));
                        };
                        _.$c = function $f(a) {
                            return RD(RD(this.d, 133), 139).$c(a);
                        };
                        _._c = function bg(a) {
                            return RD(RD(this.d, 133), 139)._c(a);
                        };
                        _.ad = function dg(a, b) {
                            return new Uf(this.a, RD(RD(this.d, 133), 139).ad(a, b));
                        };
                        var FE = sfb(xve, 'AbstractMapBasedMultimap/NavigableAsMap', 446);
                        feb(502, 327, Hve, eg);
                        _.Nc = function fg() {
                            return this.b.ec().Nc();
                        };
                        var JE = sfb(xve, 'AbstractMapBasedMultimap/SortedKeySet', 502);
                        feb(401, 502, Ive, gg);
                        var GE = sfb(xve, 'AbstractMapBasedMultimap/NavigableKeySet', 401);
                        feb(551, 31, Dve, lg);
                        _.Fc = function mg(a) {
                            var b, c;
                            ig(this);
                            c = this.d.dc();
                            b = this.d.Fc(a);
                            if (b) {
                                ++this.f.d;
                                c && hg(this);
                            }
                            return b;
                        };
                        _.Gc = function ng(a) {
                            var b, c, d;
                            if (a.dc()) return false;
                            d = (ig(this), this.d.gc());
                            b = this.d.Gc(a);
                            if (b) {
                                c = this.d.gc();
                                this.f.d += c - d;
                                d == 0 && hg(this);
                            }
                            return b;
                        };
                        _.$b = function og() {
                            var a;
                            a = (ig(this), this.d.gc());
                            if (a == 0) return;
                            this.d.$b();
                            this.f.d -= a;
                            jg(this);
                        };
                        _.Hc = function pg(a) {
                            ig(this);
                            return this.d.Hc(a);
                        };
                        _.Ic = function qg(a) {
                            ig(this);
                            return this.d.Ic(a);
                        };
                        _.Fb = function rg(a) {
                            if (a === this) return true;
                            ig(this);
                            return pb(this.d, a);
                        };
                        _.Hb = function sg() {
                            ig(this);
                            return tb(this.d);
                        };
                        _.Kc = function tg() {
                            ig(this);
                            return new Og(this);
                        };
                        _.Mc = function ug(a) {
                            var b;
                            ig(this);
                            b = this.d.Mc(a);
                            if (b) {
                                --this.f.d;
                                jg(this);
                            }
                            return b;
                        };
                        _.gc = function vg() {
                            return kg(this);
                        };
                        _.Nc = function wg() {
                            return ig(this), this.d.Nc();
                        };
                        _.Ib = function xg() {
                            ig(this);
                            return jeb(this.d);
                        };
                        var LE = sfb(xve, 'AbstractMapBasedMultimap/WrappedCollection', 551);
                        var QK = ufb(Bve, 'List');
                        feb(744, 551, {
                            20: 1,
                            31: 1,
                            16: 1,
                            15: 1
                        }, yg);
                        _.jd = function Hg(a) {
                            tvb(this, a);
                        };
                        _.Nc = function Ig() {
                            return ig(this), this.d.Nc();
                        };
                        _.bd = function zg(a, b) {
                            var c;
                            ig(this);
                            c = this.d.dc();
                            RD(this.d, 15).bd(a, b);
                            ++this.a.d;
                            c && hg(this);
                        };
                        _.cd = function Ag(a, b) {
                            var c, d, e;
                            if (b.dc()) return false;
                            e = (ig(this), this.d.gc());
                            c = RD(this.d, 15).cd(a, b);
                            if (c) {
                                d = this.d.gc();
                                this.a.d += d - e;
                                e == 0 && hg(this);
                            }
                            return c;
                        };
                        _.Xb = function Bg(a) {
                            ig(this);
                            return RD(this.d, 15).Xb(a);
                        };
                        _.dd = function Cg(a) {
                            ig(this);
                            return RD(this.d, 15).dd(a);
                        };
                        _.ed = function Dg() {
                            ig(this);
                            return new Ug(this);
                        };
                        _.fd = function Eg(a) {
                            ig(this);
                            return new Vg(this, a);
                        };
                        _.gd = function Fg(a) {
                            var b;
                            ig(this);
                            b = RD(this.d, 15).gd(a);
                            --this.a.d;
                            jg(this);
                            return b;
                        };
                        _.hd = function Gg(a, b) {
                            ig(this);
                            return RD(this.d, 15).hd(a, b);
                        };
                        _.kd = function Jg(a, b) {
                            ig(this);
                            return Vc(this.a, this.e, RD(this.d, 15).kd(a, b), !this.b ? this : this.b);
                        };
                        var NE = sfb(xve, 'AbstractMapBasedMultimap/WrappedList', 744);
                        feb(1126, 744, {
                            20: 1,
                            31: 1,
                            16: 1,
                            15: 1,
                            59: 1
                        }, Kg);
                        var HE = sfb(xve, 'AbstractMapBasedMultimap/RandomAccessWrappedList', 1126);
                        feb(628, 1, Ave, Og);
                        _.Nb = function Qg(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function Rg() {
                            Ng(this);
                            return this.b.Ob();
                        };
                        _.Pb = function Sg() {
                            Ng(this);
                            return this.b.Pb();
                        };
                        _.Qb = function Tg() {
                            Mg(this);
                        };
                        var KE = sfb(xve, 'AbstractMapBasedMultimap/WrappedCollection/WrappedIterator', 628);
                        feb(745, 628, Jve, Ug, Vg);
                        _.Qb = function _g() {
                            Mg(this);
                        };
                        _.Rb = function Wg(a) {
                            var b;
                            b = kg(this.a) == 0;
                            (Ng(this), RD(this.b, 128)).Rb(a);
                            ++this.a.a.d;
                            b && hg(this.a);
                        };
                        _.Sb = function Xg() {
                            return (Ng(this), RD(this.b, 128)).Sb();
                        };
                        _.Tb = function Yg() {
                            return (Ng(this), RD(this.b, 128)).Tb();
                        };
                        _.Ub = function Zg() {
                            return (Ng(this), RD(this.b, 128)).Ub();
                        };
                        _.Vb = function $g() {
                            return (Ng(this), RD(this.b, 128)).Vb();
                        };
                        _.Wb = function ah(a) {
                            (Ng(this), RD(this.b, 128)).Wb(a);
                        };
                        var ME = sfb(xve, 'AbstractMapBasedMultimap/WrappedList/WrappedListIterator', 745);
                        feb(743, 551, Hve, bh);
                        _.Nc = function dh() {
                            return ig(this), this.d.Nc();
                        };
                        var QE = sfb(xve, 'AbstractMapBasedMultimap/WrappedSortedSet', 743);
                        feb(1125, 743, Ive, eh);
                        var OE = sfb(xve, 'AbstractMapBasedMultimap/WrappedNavigableSet', 1125);
                        feb(1124, 551, Fve, fh);
                        _.Nc = function gh() {
                            return ig(this), this.d.Nc();
                        };
                        var PE = sfb(xve, 'AbstractMapBasedMultimap/WrappedSet', 1124);
                        feb(1133, 1, {}, hh);
                        _.Kb = function ih(a) {
                            return fd(RD(a, 44));
                        };
                        var RE = sfb(xve, 'AbstractMapBasedMultimap/lambda$1$Type', 1133);
                        feb(1132, 1, {}, jh);
                        _.Kb = function kh(a) {
                            return new gp(this.a, a);
                        };
                        var SE = sfb(xve, 'AbstractMapBasedMultimap/lambda$2$Type', 1132);
                        var UK = ufb(Bve, 'Map/Entry');
                        feb(358, 1, Kve);
                        _.Fb = function lh(a) {
                            var b;
                            if (ZD(a, 44)) {
                                b = RD(a, 44);
                                return Hb(this.ld(), b.ld()) && Hb(this.md(), b.md());
                            }
                            return false;
                        };
                        _.Hb = function mh() {
                            var a, b;
                            a = this.ld();
                            b = this.md();
                            return (a == null ? 0 : tb(a)) ^ (b == null ? 0 : tb(b));
                        };
                        _.nd = function nh(a) {
                            throw Adb(new jib);
                        };
                        _.Ib = function oh() {
                            return this.ld() + '=' + this.md();
                        };
                        var UE = sfb(xve, Lve, 358);
                        feb(2086, 31, Dve);
                        _.$b = function ph() {
                            this.od().$b();
                        };
                        _.Hc = function qh(a) {
                            var b;
                            if (ZD(a, 44)) {
                                b = RD(a, 44);
                                return Cc(this.od(), b.ld(), b.md());
                            }
                            return false;
                        };
                        _.Mc = function rh(a) {
                            var b;
                            if (ZD(a, 44)) {
                                b = RD(a, 44);
                                return Gc(this.od(), b.ld(), b.md());
                            }
                            return false;
                        };
                        _.gc = function sh() {
                            return this.od().d;
                        };
                        var yH = sfb(xve, 'Multimaps/Entries', 2086);
                        feb(749, 2086, Dve, th);
                        _.Kc = function uh() {
                            return this.a.kc();
                        };
                        _.od = function vh() {
                            return this.a;
                        };
                        _.Nc = function wh() {
                            return this.a.lc();
                        };
                        var VE = sfb(xve, 'AbstractMultimap/Entries', 749);
                        feb(750, 749, Fve, xh);
                        _.Nc = function Ah() {
                            return this.a.lc();
                        };
                        _.Fb = function yh(a) {
                            return Rx(this, a);
                        };
                        _.Hb = function zh() {
                            return Sx(this);
                        };
                        var WE = sfb(xve, 'AbstractMultimap/EntrySet', 750);
                        feb(751, 31, Dve, Bh);
                        _.$b = function Ch() {
                            this.a.$b();
                        };
                        _.Hc = function Dh(a) {
                            return Dc(this.a, a);
                        };
                        _.Kc = function Eh() {
                            return this.a.nc();
                        };
                        _.gc = function Fh() {
                            return this.a.d;
                        };
                        _.Nc = function Gh() {
                            return this.a.oc();
                        };
                        var XE = sfb(xve, 'AbstractMultimap/Values', 751);
                        feb(2087, 31, {
                            849: 1,
                            20: 1,
                            31: 1,
                            16: 1
                        });
                        _.Jc = function Oh(a) {
                            Qb(a);
                            Ih(this).Jc(new lx(a));
                        };
                        _.Nc = function Sh() {
                            var a;
                            return a = Ih(this).Nc(), ek(a, new sx, 64 | a.yd() & 1296, this.a.d);
                        };
                        _.Fc = function Kh(a) {
                            Hh();
                            return true;
                        };
                        _.Gc = function Lh(a) {
                            return Qb(this), Qb(a), ZD(a, 552) ? nx(RD(a, 849)) : !a.dc() && xr(this, a.Kc());
                        };
                        _.Hc = function Mh(a) {
                            var b;
                            return b = RD(Xv(nd(this.a), a), 16), (!b ? 0 : b.gc()) > 0;
                        };
                        _.Fb = function Nh(a) {
                            return ox(this, a);
                        };
                        _.Hb = function Ph() {
                            return tb(Ih(this));
                        };
                        _.dc = function Qh() {
                            return Ih(this).dc();
                        };
                        _.Mc = function Rh(a) {
                            return Rw(this, a, 1) > 0;
                        };
                        _.Ib = function Th() {
                            return jeb(Ih(this));
                        };
                        var $E = sfb(xve, 'AbstractMultiset', 2087);
                        feb(2089, 2068, Fve);
                        _.$b = function Uh() {
                            Nc(this.a.a);
                        };
                        _.Hc = function Vh(a) {
                            var b, c;
                            if (ZD(a, 504)) {
                                c = RD(a, 425);
                                if (RD(c.a.md(), 16).gc() <= 0) return false;
                                b = Qw(this.a, c.a.ld());
                                return b == RD(c.a.md(), 16).gc();
                            }
                            return false;
                        };
                        _.Mc = function Wh(a) {
                            var b, c, d, e;
                            if (ZD(a, 504)) {
                                c = RD(a, 425);
                                b = c.a.ld();
                                d = RD(c.a.md(), 16).gc();
                                if (d != 0) {
                                    e = this.a;
                                    return qx(e, b, d);
                                }
                            }
                            return false;
                        };
                        var IH = sfb(xve, 'Multisets/EntrySet', 2089);
                        feb(1139, 2089, Fve, Xh);
                        _.Kc = function Yh() {
                            return new _w(fe(nd(this.a.a)).Kc());
                        };
                        _.gc = function Zh() {
                            return nd(this.a.a).gc();
                        };
                        var ZE = sfb(xve, 'AbstractMultiset/EntrySet', 1139);
                        feb(627, 742, zve);
                        _.hc = function ai() {
                            return this.pd();
                        };
                        _.jc = function bi() {
                            return this.qd();
                        };
                        _.cc = function ei(a) {
                            return this.rd(a);
                        };
                        _.fc = function gi(a) {
                            return this.sd(a);
                        };
                        _.Zb = function _h() {
                            var a;
                            return a = this.f, !a ? this.f = this.ac() : a;
                        };
                        _.qd = function ci() {
                            return yob(), yob(), xob;
                        };
                        _.Fb = function di(a) {
                            return xw(this, a);
                        };
                        _.rd = function fi(a) {
                            return RD(Qc(this, a), 21);
                        };
                        _.sd = function hi(a) {
                            return RD(Sc(this, a), 21);
                        };
                        _.mc = function ii(a) {
                            return yob(), new Lqb(RD(a, 21));
                        };
                        _.pc = function ji(a, b) {
                            return new fh(this, a, RD(b, 21));
                        };
                        var _E = sfb(xve, 'AbstractSetMultimap', 627);
                        feb(1723, 627, zve);
                        _.hc = function mi() {
                            return new yAb(this.b);
                        };
                        _.pd = function ni() {
                            return new yAb(this.b);
                        };
                        _.jc = function oi() {
                            return Zx(new yAb(this.b));
                        };
                        _.qd = function pi() {
                            return Zx(new yAb(this.b));
                        };
                        _.cc = function qi(a) {
                            return RD(RD(Qc(this, a), 21), 87);
                        };
                        _.rd = function ri(a) {
                            return RD(RD(Qc(this, a), 21), 87);
                        };
                        _.fc = function si(a) {
                            return RD(RD(Sc(this, a), 21), 87);
                        };
                        _.sd = function ti(a) {
                            return RD(RD(Sc(this, a), 21), 87);
                        };
                        _.mc = function ui(a) {
                            return ZD(a, 277) ? Zx(RD(a, 277)) : (yob(), new jrb(RD(a, 87)));
                        };
                        _.Zb = function li() {
                            var a;
                            return a = this.f, !a ? this.f = ZD(this.c, 139) ? new Uf(this, RD(this.c, 139)) : ZD(this.c, 133) ? new Mf(this, RD(this.c, 133)) : new ne(this, this.c) : a;
                        };
                        _.pc = function vi(a, b) {
                            return ZD(b, 277) ? new eh(this, a, RD(b, 277)) : new bh(this, a, RD(b, 87));
                        };
                        var bF = sfb(xve, 'AbstractSortedSetMultimap', 1723);
                        feb(1724, 1723, zve);
                        _.Zb = function xi() {
                            var a;
                            return a = this.f, RD(RD(!a ? this.f = ZD(this.c, 139) ? new Uf(this, RD(this.c, 139)) : ZD(this.c, 133) ? new Mf(this, RD(this.c, 133)) : new ne(this, this.c) : a, 133), 139);
                        };
                        _.ec = function zi() {
                            var a;
                            return a = this.i, RD(RD(!a ? this.i = ZD(this.c, 139) ? new gg(this, RD(this.c, 139)) : ZD(this.c, 133) ? new eg(this, RD(this.c, 133)) : new zf(this, this.c) : a, 87), 277);
                        };
                        _.bc = function yi() {
                            return ZD(this.c, 139) ? new gg(this, RD(this.c, 139)) : ZD(this.c, 133) ? new eg(this, RD(this.c, 133)) : new zf(this, this.c);
                        };
                        var aF = sfb(xve, 'AbstractSortedKeySortedSetMultimap', 1724);
                        feb(2109, 1, {
                            2046: 1
                        });
                        _.Fb = function Ai(a) {
                            return Qy(this, a);
                        };
                        _.Hb = function Bi() {
                            var a;
                            return Bob((a = this.g, !a ? this.g = new Di(this) : a));
                        };
                        _.Ib = function Ci() {
                            var a;
                            return Md((a = this.f, !a ? this.f = new Zj(this) : a));
                        };
                        var eF = sfb(xve, 'AbstractTable', 2109);
                        feb(679, Eve, Fve, Di);
                        _.$b = function Ei() {
                            Xi();
                        };
                        _.Hc = function Fi(a) {
                            var b, c;
                            if (ZD(a, 479)) {
                                b = RD(a, 697);
                                c = RD(Xv(bj(this.a), Qm(b.c.e, b.b)), 85);
                                return !!c && Nk(c.vc(), new gp(Qm(b.c.c, b.a), Ui(b.c, b.b, b.a)));
                            }
                            return false;
                        };
                        _.Kc = function Gi() {
                            return Vi(this.a);
                        };
                        _.Mc = function Hi(a) {
                            var b, c;
                            if (ZD(a, 479)) {
                                b = RD(a, 697);
                                c = RD(Xv(bj(this.a), Qm(b.c.e, b.b)), 85);
                                return !!c && Ok(c.vc(), new gp(Qm(b.c.c, b.a), Ui(b.c, b.b, b.a)));
                            }
                            return false;
                        };
                        _.gc = function Ii() {
                            return dj(this.a);
                        };
                        _.Nc = function Ji() {
                            return Wi(this.a);
                        };
                        var cF = sfb(xve, 'AbstractTable/CellSet', 679);
                        feb(2025, 31, Dve, Ki);
                        _.$b = function Li() {
                            Xi();
                        };
                        _.Hc = function Mi(a) {
                            return Yi(this.a, a);
                        };
                        _.Kc = function Ni() {
                            return fj(this.a);
                        };
                        _.gc = function Oi() {
                            return dj(this.a);
                        };
                        _.Nc = function Pi() {
                            return gj(this.a);
                        };
                        var dF = sfb(xve, 'AbstractTable/Values', 2025);
                        feb(1697, 1696, zve);
                        var fF = sfb(xve, 'ArrayListMultimapGwtSerializationDependencies', 1697);
                        feb(520, 1697, zve, Ri, Si);
                        _.hc = function Ti() {
                            return new cnb(this.a);
                        };
                        _.a = 0;
                        var gF = sfb(xve, 'ArrayListMultimap', 520);
                        feb(678, 2109, {
                            678: 1,
                            2046: 1,
                            3: 1
                        }, hj);
                        var sF = sfb(xve, 'ArrayTable', 678);
                        feb(2021, 399, yve, ij);
                        _.Xb = function jj(a) {
                            return new pj(this.a, a);
                        };
                        var hF = sfb(xve, 'ArrayTable/1', 2021);
                        feb(2022, 1, {}, kj);
                        _.td = function lj(a) {
                            return new pj(this.a, a);
                        };
                        var iF = sfb(xve, 'ArrayTable/1methodref$getCell$Type', 2022);
                        feb(2110, 1, {
                            697: 1
                        });
                        _.Fb = function mj(a) {
                            var b;
                            if (a === this) return true;
                            if (ZD(a, 479)) {
                                b = RD(a, 697);
                                return Hb(Qm(this.c.e, this.b), Qm(b.c.e, b.b)) && Hb(Qm(this.c.c, this.a), Qm(b.c.c, b.a)) && Hb(Ui(this.c, this.b, this.a), Ui(b.c, b.b, b.a));
                            }
                            return false;
                        };
                        _.Hb = function nj() {
                            return Tnb(cD(WC(jJ, 1), rve, 1, 5, [
                                Qm(this.c.e, this.b),
                                Qm(this.c.c, this.a),
                                Ui(this.c, this.b, this.a)
                            ]));
                        };
                        _.Ib = function oj() {
                            return '(' + Qm(this.c.e, this.b) + ',' + Qm(this.c.c, this.a) + ')=' + Ui(this.c, this.b, this.a);
                        };
                        var bI = sfb(xve, 'Tables/AbstractCell', 2110);
                        feb(479, 2110, {
                            479: 1,
                            697: 1
                        }, pj);
                        _.a = 0;
                        _.b = 0;
                        _.d = 0;
                        var jF = sfb(xve, 'ArrayTable/2', 479);
                        feb(2024, 1, {}, qj);
                        _.td = function rj(a) {
                            return _i(this.a, a);
                        };
                        var kF = sfb(xve, 'ArrayTable/2methodref$getValue$Type', 2024);
                        feb(2023, 399, yve, sj);
                        _.Xb = function tj(a) {
                            return _i(this.a, a);
                        };
                        var lF = sfb(xve, 'ArrayTable/3', 2023);
                        feb(2077, 2065, Cve);
                        _.$b = function vj() {
                            Ar(this.kc());
                        };
                        _.vc = function wj() {
                            return new gw(this);
                        };
                        _.lc = function xj() {
                            return new Uwb(this.kc(), this.gc());
                        };
                        var pH = sfb(xve, 'Maps/IteratorBasedAbstractMap', 2077);
                        feb(842, 2077, Cve);
                        _.$b = function Bj() {
                            throw Adb(new jib);
                        };
                        _._b = function Cj(a) {
                            return En(this.c, a);
                        };
                        _.kc = function Dj() {
                            return new Rj(this, this.c.b.c.gc());
                        };
                        _.lc = function Ej() {
                            return fk(this.c.b.c.gc(), 16, new Lj(this));
                        };
                        _.xc = function Fj(a) {
                            var b;
                            b = RD(Fn(this.c, a), 17);
                            return !b ? null : this.vd(b.a);
                        };
                        _.dc = function Gj() {
                            return this.c.b.c.dc();
                        };
                        _.ec = function Hj() {
                            return hn(this.c);
                        };
                        _.zc = function Ij(a, b) {
                            var c;
                            c = RD(Fn(this.c, a), 17);
                            if (!c) throw Adb(new agb(this.ud() + ' ' + a + ' not in ' + hn(this.c)));
                            return this.wd(c.a, b);
                        };
                        _.Bc = function Jj(a) {
                            throw Adb(new jib);
                        };
                        _.gc = function Kj() {
                            return this.c.b.c.gc();
                        };
                        var pF = sfb(xve, 'ArrayTable/ArrayMap', 842);
                        feb(2020, 1, {}, Lj);
                        _.td = function Mj(a) {
                            return yj(this.a, a);
                        };
                        var mF = sfb(xve, 'ArrayTable/ArrayMap/0methodref$getEntry$Type', 2020);
                        feb(2018, 358, Kve, Nj);
                        _.ld = function Oj() {
                            return zj(this.a, this.b);
                        };
                        _.md = function Pj() {
                            return this.a.vd(this.b);
                        };
                        _.nd = function Qj(a) {
                            return this.a.wd(this.b, a);
                        };
                        _.b = 0;
                        var nF = sfb(xve, 'ArrayTable/ArrayMap/1', 2018);
                        feb(2019, 399, yve, Rj);
                        _.Xb = function Sj(a) {
                            return yj(this.a, a);
                        };
                        var oF = sfb(xve, 'ArrayTable/ArrayMap/2', 2019);
                        feb(2017, 842, Cve, Tj);
                        _.ud = function Uj() {
                            return 'Column';
                        };
                        _.vd = function Vj(a) {
                            return Ui(this.b, this.a, a);
                        };
                        _.wd = function Wj(a, b) {
                            return cj(this.b, this.a, a, b);
                        };
                        _.a = 0;
                        var rF = sfb(xve, 'ArrayTable/Row', 2017);
                        feb(843, 842, Cve, Zj);
                        _.vd = function _j(a) {
                            return new Tj(this.a, a);
                        };
                        _.zc = function ak(a, b) {
                            return RD(b, 85), Xj();
                        };
                        _.wd = function bk(a, b) {
                            return RD(b, 85), Yj();
                        };
                        _.ud = function $j() {
                            return 'Row';
                        };
                        var qF = sfb(xve, 'ArrayTable/RowMap', 843);
                        feb(1157, 1, Pve, hk);
                        _.Ad = function lk(a) {
                            return (this.a.yd() & -262 & a) != 0;
                        };
                        _.yd = function ik() {
                            return this.a.yd() & -262;
                        };
                        _.zd = function jk() {
                            return this.a.zd();
                        };
                        _.Nb = function kk(a) {
                            this.a.Nb(new pk(a, this.b));
                        };
                        _.Bd = function mk(a) {
                            return this.a.Bd(new nk(a, this.b));
                        };
                        var yF = sfb(xve, 'CollectSpliterators/1', 1157);
                        feb(1158, 1, Qve, nk);
                        _.Cd = function ok(a) {
                            this.a.Cd(this.b.Kb(a));
                        };
                        var tF = sfb(xve, 'CollectSpliterators/1/lambda$0$Type', 1158);
                        feb(1159, 1, Qve, pk);
                        _.Cd = function qk(a) {
                            this.a.Cd(this.b.Kb(a));
                        };
                        var uF = sfb(xve, 'CollectSpliterators/1/lambda$1$Type', 1159);
                        feb(1154, 1, Pve, rk);
                        _.Ad = function vk(a) {
                            return ((16464 | this.b) & a) != 0;
                        };
                        _.yd = function sk() {
                            return 16464 | this.b;
                        };
                        _.zd = function tk() {
                            return this.a.zd();
                        };
                        _.Nb = function uk(a) {
                            this.a.Qe(new zk(a, this.c));
                        };
                        _.Bd = function wk(a) {
                            return this.a.Re(new xk(a, this.c));
                        };
                        _.b = 0;
                        var xF = sfb(xve, 'CollectSpliterators/1WithCharacteristics', 1154);
                        feb(1155, 1, Rve, xk);
                        _.Dd = function yk(a) {
                            this.a.Cd(this.b.td(a));
                        };
                        var vF = sfb(xve, 'CollectSpliterators/1WithCharacteristics/lambda$0$Type', 1155);
                        feb(1156, 1, Rve, zk);
                        _.Dd = function Ak(a) {
                            this.a.Cd(this.b.td(a));
                        };
                        var wF = sfb(xve, 'CollectSpliterators/1WithCharacteristics/lambda$1$Type', 1156);
                        feb(1150, 1, Pve);
                        _.Ad = function Gk(a) {
                            return (this.a & a) != 0;
                        };
                        _.yd = function Dk() {
                            return this.a;
                        };
                        _.zd = function Ek() {
                            !!this.e && (this.b = Kgb(this.b, this.e.zd()));
                            return Kgb(this.b, 0);
                        };
                        _.Nb = function Fk(a) {
                            if (this.e) {
                                this.e.Nb(a);
                                this.e = null;
                            }
                            this.c.Nb(new Kk(this, a));
                            this.b = 0;
                        };
                        _.Bd = function Hk(a) {
                            while(true){
                                if (!!this.e && this.e.Bd(a)) {
                                    Pdb(this.b, Sve) && (this.b = Vdb(this.b, 1));
                                    return true;
                                } else this.e = null;
                                if (!this.c.Bd(new Ik(this))) return false;
                            }
                        };
                        _.a = 0;
                        _.b = 0;
                        var CF = sfb(xve, 'CollectSpliterators/FlatMapSpliterator', 1150);
                        feb(1152, 1, Qve, Ik);
                        _.Cd = function Jk(a) {
                            Bk(this.a, a);
                        };
                        var zF = sfb(xve, 'CollectSpliterators/FlatMapSpliterator/lambda$0$Type', 1152);
                        feb(1153, 1, Qve, Kk);
                        _.Cd = function Lk(a) {
                            Ck(this.a, this.b, a);
                        };
                        var AF = sfb(xve, 'CollectSpliterators/FlatMapSpliterator/lambda$1$Type', 1153);
                        feb(1151, 1150, Pve, Mk);
                        var BF = sfb(xve, 'CollectSpliterators/FlatMapSpliteratorOfObject', 1151);
                        feb(253, 1, Tve);
                        _.Fd = function Sk(a) {
                            return this.Ed(RD(a, 253));
                        };
                        _.Ed = function Rk(a) {
                            var b;
                            if (a == (kl(), jl)) return 1;
                            if (a == (Wk(), Vk)) return -1;
                            b = (ux(), Leb(this.a, a.a));
                            if (b != 0) return b;
                            return ZD(this, 526) == ZD(a, 526) ? 0 : ZD(this, 526) ? 1 : -1;
                        };
                        _.Id = function Tk() {
                            return this.a;
                        };
                        _.Fb = function Uk(a) {
                            return Pk(this, a);
                        };
                        var HF = sfb(xve, 'Cut', 253);
                        feb(1823, 253, Tve, Xk);
                        _.Ed = function Yk(a) {
                            return a == this ? 0 : 1;
                        };
                        _.Gd = function Zk(a) {
                            throw Adb(new Ceb);
                        };
                        _.Hd = function $k(a) {
                            a.a += '+\u221E)';
                        };
                        _.Id = function _k() {
                            throw Adb(new dgb(Uve));
                        };
                        _.Hb = function al() {
                            return gib(), jFb(this);
                        };
                        _.Jd = function bl(a) {
                            return false;
                        };
                        _.Ib = function cl() {
                            return '+\u221E';
                        };
                        var Vk;
                        var DF = sfb(xve, 'Cut/AboveAll', 1823);
                        feb(526, 253, {
                            253: 1,
                            526: 1,
                            3: 1,
                            34: 1
                        }, dl);
                        _.Gd = function el(a) {
                            Yhb((a.a += '(', a), this.a);
                        };
                        _.Hd = function fl(a) {
                            Thb(Yhb(a, this.a), 93);
                        };
                        _.Hb = function gl() {
                            return ~tb(this.a);
                        };
                        _.Jd = function hl(a) {
                            return ux(), Leb(this.a, a) < 0;
                        };
                        _.Ib = function il() {
                            return '/' + this.a + '\\';
                        };
                        var EF = sfb(xve, 'Cut/AboveValue', 526);
                        feb(1822, 253, Tve, ll);
                        _.Ed = function ml(a) {
                            return a == this ? 0 : -1;
                        };
                        _.Gd = function nl(a) {
                            a.a += '(-\u221E';
                        };
                        _.Hd = function ol(a) {
                            throw Adb(new Ceb);
                        };
                        _.Id = function pl() {
                            throw Adb(new dgb(Uve));
                        };
                        _.Hb = function ql() {
                            return gib(), jFb(this);
                        };
                        _.Jd = function rl(a) {
                            return true;
                        };
                        _.Ib = function sl() {
                            return '-\u221E';
                        };
                        var jl;
                        var FF = sfb(xve, 'Cut/BelowAll', 1822);
                        feb(1824, 253, Tve, tl);
                        _.Gd = function ul(a) {
                            Yhb((a.a += '[', a), this.a);
                        };
                        _.Hd = function vl(a) {
                            Thb(Yhb(a, this.a), 41);
                        };
                        _.Hb = function wl() {
                            return tb(this.a);
                        };
                        _.Jd = function xl(a) {
                            return ux(), Leb(this.a, a) <= 0;
                        };
                        _.Ib = function yl() {
                            return '\\' + this.a + '/';
                        };
                        var GF = sfb(xve, 'Cut/BelowValue', 1824);
                        feb(547, 1, Vve);
                        _.Jc = function Bl(a) {
                            xgb(this, a);
                        };
                        _.Ib = function Cl() {
                            return Lr(RD(Rb(this, 'use Optional.orNull() instead of Optional.or(null)'), 20).Kc());
                        };
                        var LF = sfb(xve, 'FluentIterable', 547);
                        feb(442, 547, Vve, Dl);
                        _.Kc = function El() {
                            return new is(Mr(this.a.Kc(), new ir));
                        };
                        var IF = sfb(xve, 'FluentIterable/2', 442);
                        feb(1059, 547, Vve, Gl);
                        _.Kc = function Hl() {
                            return Fl(this);
                        };
                        var KF = sfb(xve, 'FluentIterable/3', 1059);
                        feb(724, 399, yve, Il);
                        _.Xb = function Jl(a) {
                            return this.a[a].Kc();
                        };
                        var JF = sfb(xve, 'FluentIterable/3/1', 724);
                        feb(2070, 1, {});
                        _.Ib = function Kl() {
                            return jeb(this.Kd().b);
                        };
                        var SF = sfb(xve, 'ForwardingObject', 2070);
                        feb(2071, 2070, Wve);
                        _.Kd = function Ql() {
                            return this.Ld();
                        };
                        _.Jc = function Rl(a) {
                            xgb(this, a);
                        };
                        _.Lc = function Ul() {
                            return this.Oc();
                        };
                        _.Nc = function Xl() {
                            return new Swb(this, 0);
                        };
                        _.Oc = function Yl() {
                            return new SDb(null, this.Nc());
                        };
                        _.Fc = function Ll(a) {
                            return this.Ld(), qpb();
                        };
                        _.Gc = function Ml(a) {
                            return this.Ld(), rpb();
                        };
                        _.$b = function Nl() {
                            this.Ld(), spb();
                        };
                        _.Hc = function Ol(a) {
                            return this.Ld().Hc(a);
                        };
                        _.Ic = function Pl(a) {
                            return this.Ld().Ic(a);
                        };
                        _.dc = function Sl() {
                            return this.Ld().b.dc();
                        };
                        _.Kc = function Tl() {
                            return this.Ld().Kc();
                        };
                        _.Mc = function Vl(a) {
                            return this.Ld(), vpb();
                        };
                        _.gc = function Wl() {
                            return this.Ld().b.gc();
                        };
                        _.Pc = function Zl() {
                            return this.Ld().Pc();
                        };
                        _.Qc = function $l(a) {
                            return this.Ld().Qc(a);
                        };
                        var MF = sfb(xve, 'ForwardingCollection', 2071);
                        feb(2078, 31, Xve);
                        _.Kc = function gm() {
                            return this.Od();
                        };
                        _.Fc = function am(a) {
                            throw Adb(new jib);
                        };
                        _.Gc = function bm(a) {
                            throw Adb(new jib);
                        };
                        _.Md = function cm() {
                            var a;
                            a = this.c;
                            return !a ? this.c = this.Nd() : a;
                        };
                        _.$b = function dm() {
                            throw Adb(new jib);
                        };
                        _.Hc = function em(a) {
                            return a != null && ze(this, a, false);
                        };
                        _.Nd = function fm() {
                            switch(this.gc()){
                                case 0:
                                    return tm(), tm(), sm;
                                case 1:
                                    return tm(), new Dy(Qb(this.Od().Pb()));
                                default:
                                    return new Fx(this, this.Pc());
                            }
                        };
                        _.Mc = function hm(a) {
                            throw Adb(new jib);
                        };
                        var lG = sfb(xve, 'ImmutableCollection', 2078);
                        feb(727, 2078, Xve, im);
                        _.Kc = function nm() {
                            return Nr(this.a.Kc());
                        };
                        _.Hc = function jm(a) {
                            return a != null && this.a.Hc(a);
                        };
                        _.Ic = function km(a) {
                            return this.a.Ic(a);
                        };
                        _.dc = function lm() {
                            return this.a.dc();
                        };
                        _.Od = function mm() {
                            return Nr(this.a.Kc());
                        };
                        _.gc = function om() {
                            return this.a.gc();
                        };
                        _.Pc = function pm() {
                            return this.a.Pc();
                        };
                        _.Qc = function qm(a) {
                            return this.a.Qc(a);
                        };
                        _.Ib = function rm() {
                            return jeb(this.a);
                        };
                        var NF = sfb(xve, 'ForwardingImmutableCollection', 727);
                        feb(307, 2078, Yve);
                        _.Kc = function Em() {
                            return this.Od();
                        };
                        _.ed = function Fm() {
                            return this.Pd(0);
                        };
                        _.fd = function Hm(a) {
                            return this.Pd(a);
                        };
                        _.jd = function Lm(a) {
                            tvb(this, a);
                        };
                        _.Nc = function Mm() {
                            return new Swb(this, 16);
                        };
                        _.kd = function Om(a, b) {
                            return this.Qd(a, b);
                        };
                        _.bd = function wm(a, b) {
                            throw Adb(new jib);
                        };
                        _.cd = function xm(a, b) {
                            throw Adb(new jib);
                        };
                        _.Md = function ym() {
                            return this;
                        };
                        _.Fb = function Am(a) {
                            return $u(this, a);
                        };
                        _.Hb = function Bm() {
                            return _u(this);
                        };
                        _.dd = function Cm(a) {
                            return a == null ? -1 : av(this, a);
                        };
                        _.Od = function Dm() {
                            return this.Pd(0);
                        };
                        _.Pd = function Gm(a) {
                            return um(this, a);
                        };
                        _.gd = function Jm(a) {
                            throw Adb(new jib);
                        };
                        _.hd = function Km(a, b) {
                            throw Adb(new jib);
                        };
                        _.Qd = function Nm(a, b) {
                            var c;
                            return Pm((c = new pv(this), new Rkb(c, a, b)));
                        };
                        var sm;
                        var qG = sfb(xve, 'ImmutableList', 307);
                        feb(2105, 307, Yve);
                        _.Kc = function Zm() {
                            return Nr(this.Rd().Kc());
                        };
                        _.kd = function an(a, b) {
                            return Pm(this.Rd().kd(a, b));
                        };
                        _.Hc = function Rm(a) {
                            return a != null && this.Rd().Hc(a);
                        };
                        _.Ic = function Sm(a) {
                            return this.Rd().Ic(a);
                        };
                        _.Fb = function Tm(a) {
                            return pb(this.Rd(), a);
                        };
                        _.Xb = function Um(a) {
                            return Qm(this, a);
                        };
                        _.Hb = function Vm() {
                            return tb(this.Rd());
                        };
                        _.dd = function Wm(a) {
                            return this.Rd().dd(a);
                        };
                        _.dc = function Xm() {
                            return this.Rd().dc();
                        };
                        _.Od = function Ym() {
                            return Nr(this.Rd().Kc());
                        };
                        _.gc = function $m() {
                            return this.Rd().gc();
                        };
                        _.Qd = function _m(a, b) {
                            return Pm(this.Rd().kd(a, b));
                        };
                        _.Pc = function bn() {
                            return this.Rd().Qc($C(jJ, rve, 1, this.Rd().gc(), 5, 1));
                        };
                        _.Qc = function cn(a) {
                            return this.Rd().Qc(a);
                        };
                        _.Ib = function dn() {
                            return jeb(this.Rd());
                        };
                        var OF = sfb(xve, 'ForwardingImmutableList', 2105);
                        feb(729, 1, $ve);
                        _.vc = function pn() {
                            return gn(this);
                        };
                        _.wc = function rn(a) {
                            Bvb(this, a);
                        };
                        _.ec = function vn() {
                            return hn(this);
                        };
                        _.yc = function wn(a, b, c) {
                            return Cvb(this, a, b, c);
                        };
                        _.Cc = function Dn() {
                            return this.Vd();
                        };
                        _.$b = function kn() {
                            throw Adb(new jib);
                        };
                        _._b = function ln(a) {
                            return this.xc(a) != null;
                        };
                        _.uc = function mn(a) {
                            return this.Vd().Hc(a);
                        };
                        _.Td = function nn() {
                            return new xq(this);
                        };
                        _.Ud = function on() {
                            return new Gq(this);
                        };
                        _.Fb = function qn(a) {
                            return Tv(this, a);
                        };
                        _.Hb = function tn() {
                            return gn(this).Hb();
                        };
                        _.dc = function un() {
                            return this.gc() == 0;
                        };
                        _.zc = function zn(a, b) {
                            return jn();
                        };
                        _.Bc = function An(a) {
                            throw Adb(new jib);
                        };
                        _.Ib = function Bn() {
                            return Zv(this);
                        };
                        _.Vd = function Cn() {
                            if (this.e) return this.e;
                            return this.e = this.Ud();
                        };
                        _.c = null;
                        _.d = null;
                        _.e = null;
                        var en;
                        var AG = sfb(xve, 'ImmutableMap', 729);
                        feb(730, 729, $ve);
                        _._b = function Hn(a) {
                            return En(this, a);
                        };
                        _.uc = function In(a) {
                            return pqb(this.b, a);
                        };
                        _.Sd = function Jn() {
                            return go(new Xn(this));
                        };
                        _.Td = function Kn() {
                            return go(sqb(this.b));
                        };
                        _.Ud = function Ln() {
                            return _l(), new im(tqb(this.b));
                        };
                        _.Fb = function Mn(a) {
                            return rqb(this.b, a);
                        };
                        _.xc = function Nn(a) {
                            return Fn(this, a);
                        };
                        _.Hb = function On() {
                            return tb(this.b.c);
                        };
                        _.dc = function Pn() {
                            return this.b.c.dc();
                        };
                        _.gc = function Qn() {
                            return this.b.c.gc();
                        };
                        _.Ib = function Rn() {
                            return jeb(this.b.c);
                        };
                        var QF = sfb(xve, 'ForwardingImmutableMap', 730);
                        feb(2072, 2071, _ve);
                        _.Kd = function Sn() {
                            return this.Wd();
                        };
                        _.Ld = function Tn() {
                            return this.Wd();
                        };
                        _.Nc = function Wn() {
                            return new Swb(this, 1);
                        };
                        _.Fb = function Un(a) {
                            return a === this || this.Wd().Fb(a);
                        };
                        _.Hb = function Vn() {
                            return this.Wd().Hb();
                        };
                        var TF = sfb(xve, 'ForwardingSet', 2072);
                        feb(1085, 2072, _ve, Xn);
                        _.Kd = function Zn() {
                            return qqb(this.a.b);
                        };
                        _.Ld = function $n() {
                            return qqb(this.a.b);
                        };
                        _.Hc = function Yn(b) {
                            if (ZD(b, 44) && RD(b, 44).ld() == null) return false;
                            try {
                                return Pqb(qqb(this.a.b), b);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 212)) return false;
                                else throw Adb(a);
                            }
                        };
                        _.Wd = function _n() {
                            return qqb(this.a.b);
                        };
                        _.Qc = function ao(a) {
                            var b;
                            b = Qqb(qqb(this.a.b), a);
                            qqb(this.a.b).b.gc() < b.length && bD(b, qqb(this.a.b).b.gc(), null);
                            return b;
                        };
                        var PF = sfb(xve, 'ForwardingImmutableMap/1', 1085);
                        feb(2079, 2078, awe);
                        _.Kc = function eo() {
                            return this.Od();
                        };
                        _.Nc = function fo() {
                            return new Swb(this, 1);
                        };
                        _.Fb = function bo(a) {
                            return Rx(this, a);
                        };
                        _.Hb = function co() {
                            return Sx(this);
                        };
                        var CG = sfb(xve, 'ImmutableSet', 2079);
                        feb(719, 2079, awe);
                        _.Kc = function no() {
                            return Nr(new Ppb(this.a.b.Kc()));
                        };
                        _.Hc = function io(a) {
                            return a != null && tpb(this.a, a);
                        };
                        _.Ic = function jo(a) {
                            return upb(this.a, a);
                        };
                        _.Hb = function ko() {
                            return tb(this.a.b);
                        };
                        _.dc = function lo() {
                            return this.a.b.dc();
                        };
                        _.Od = function mo() {
                            return Nr(new Ppb(this.a.b.Kc()));
                        };
                        _.gc = function oo() {
                            return this.a.b.gc();
                        };
                        _.Pc = function po() {
                            return this.a.b.Pc();
                        };
                        _.Qc = function qo(a) {
                            return wpb(this.a, a);
                        };
                        _.Ib = function ro() {
                            return jeb(this.a.b);
                        };
                        var RF = sfb(xve, 'ForwardingImmutableSet', 719);
                        feb(2073, 2072, bwe);
                        _.Kd = function so() {
                            return this.b;
                        };
                        _.Ld = function to() {
                            return this.b;
                        };
                        _.Wd = function uo() {
                            return this.b;
                        };
                        _.Nc = function vo() {
                            return new $wb(this);
                        };
                        var UF = sfb(xve, 'ForwardingSortedSet', 2073);
                        feb(543, 2077, $ve, Io);
                        _.Ac = function Ro(a) {
                            Ld(this, a);
                        };
                        _.Cc = function Uo() {
                            var a;
                            return a = this.d, new Gp(!a ? this.d = new mp(this) : a);
                        };
                        _.$b = function Jo() {
                            wo(this);
                        };
                        _._b = function Ko(a) {
                            return !!Go(this, a, Ydb(Ndb(cwe, qgb(Ydb(Ndb(a == null ? 0 : tb(a), dwe)), 15))));
                        };
                        _.uc = function Lo(a) {
                            return xo(this, a);
                        };
                        _.kc = function Mo() {
                            return new ap(this, this);
                        };
                        _.wc = function No(a) {
                            zo(this, a);
                        };
                        _.xc = function Oo(a) {
                            return Ao(this, a);
                        };
                        _.ec = function Po() {
                            return new Np(this);
                        };
                        _.zc = function Qo(a, b) {
                            return Do(this, a, b);
                        };
                        _.Bc = function So(a) {
                            var b;
                            b = Go(this, a, Ydb(Ndb(cwe, qgb(Ydb(Ndb(a == null ? 0 : tb(a), dwe)), 15))));
                            if (!b) return null;
                            else {
                                yo(this, b);
                                b.e = null;
                                b.c = null;
                                return b.i;
                            }
                        };
                        _.gc = function To() {
                            return this.i;
                        };
                        _.xd = function Vo() {
                            var a;
                            return a = this.d, new Gp(!a ? this.d = new mp(this) : a);
                        };
                        _.f = 0;
                        _.g = 0;
                        _.i = 0;
                        var fG = sfb(xve, 'HashBiMap', 543);
                        feb(544, 1, Ave);
                        _.Nb = function Yo(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function Zo() {
                            return Wo(this);
                        };
                        _.Pb = function $o() {
                            var a;
                            if (!Wo(this)) throw Adb(new Dvb);
                            a = RD(Hvb(this.c), 303);
                            this.c = a.c;
                            this.f = a;
                            --this.d;
                            return this.Xd(a);
                        };
                        _.Qb = function _o() {
                            if (this.e.g != this.b) throw Adb(new Jrb);
                            if (!this.f) throw Adb(new dgb(tve));
                            yo(this.e, this.f);
                            this.b = this.e.g;
                            this.f = null;
                        };
                        _.b = 0;
                        _.d = 0;
                        _.f = null;
                        var cG = sfb(xve, 'HashBiMap/Itr', 544);
                        feb(1023, 544, Ave, ap);
                        _.Xd = function bp(a) {
                            return new cp(this, a);
                        };
                        var WF = sfb(xve, 'HashBiMap/1', 1023);
                        feb(gwe, 358, Kve, cp);
                        _.ld = function dp() {
                            return this.a.g;
                        };
                        _.md = function ep() {
                            return this.a.i;
                        };
                        _.nd = function fp(a) {
                            var b, c, d;
                            c = this.a.i;
                            d = Ydb(Ndb(cwe, qgb(Ydb(Ndb(a == null ? 0 : tb(a), dwe)), 15)));
                            if (d == this.a.f && (dE(a) === dE(c) || a != null && pb(a, c))) return a;
                            Nb(!Ho(this.b.a, a, d), a);
                            yo(this.b.a, this.a);
                            b = new kp(this.a.g, this.a.a, a, d);
                            Bo(this.b.a, b, this.a);
                            this.a.e = null;
                            this.a.c = null;
                            this.b.b = this.b.a.g;
                            this.b.f == this.a && (this.b.f = b);
                            this.a = b;
                            return c;
                        };
                        var VF = sfb(xve, 'HashBiMap/1/MapEntry', gwe);
                        feb(246, 358, {
                            358: 1,
                            246: 1,
                            3: 1,
                            44: 1
                        }, gp);
                        _.ld = function hp() {
                            return this.g;
                        };
                        _.md = function ip() {
                            return this.i;
                        };
                        _.nd = function jp(a) {
                            throw Adb(new jib);
                        };
                        var mG = sfb(xve, 'ImmutableEntry', 246);
                        feb(303, 246, {
                            358: 1,
                            303: 1,
                            246: 1,
                            3: 1,
                            44: 1
                        }, kp);
                        _.a = 0;
                        _.f = 0;
                        var XF = sfb(xve, 'HashBiMap/BiEntry', 303);
                        feb(619, 2077, $ve, mp);
                        _.Ac = function vp(a) {
                            Ld(this, a);
                        };
                        _.Cc = function yp() {
                            return new Np(this.a);
                        };
                        _.$b = function np() {
                            wo(this.a);
                        };
                        _._b = function op(a) {
                            return xo(this.a, a);
                        };
                        _.kc = function pp() {
                            return new Ap(this, this.a);
                        };
                        _.wc = function qp(a) {
                            Qb(a);
                            zo(this.a, new Lp(a));
                        };
                        _.xc = function rp(a) {
                            return lp(this, a);
                        };
                        _.ec = function sp() {
                            return new Gp(this);
                        };
                        _.zc = function up(a, b) {
                            return Eo(this.a, a, b, false);
                        };
                        _.Bc = function wp(a) {
                            var b;
                            b = Ho(this.a, a, Ydb(Ndb(cwe, qgb(Ydb(Ndb(a == null ? 0 : tb(a), dwe)), 15))));
                            if (!b) return null;
                            else {
                                yo(this.a, b);
                                b.e = null;
                                b.c = null;
                                return b.g;
                            }
                        };
                        _.gc = function xp() {
                            return this.a.i;
                        };
                        _.xd = function zp() {
                            return new Np(this.a);
                        };
                        var bG = sfb(xve, 'HashBiMap/Inverse', 619);
                        feb(1020, 544, Ave, Ap);
                        _.Xd = function Bp(a) {
                            return new Cp(this, a);
                        };
                        var ZF = sfb(xve, 'HashBiMap/Inverse/1', 1020);
                        feb(1021, 358, Kve, Cp);
                        _.ld = function Dp() {
                            return this.a.i;
                        };
                        _.md = function Ep() {
                            return this.a.g;
                        };
                        _.nd = function Fp(a) {
                            var b, c, d;
                            d = this.a.g;
                            b = Ydb(Ndb(cwe, qgb(Ydb(Ndb(a == null ? 0 : tb(a), dwe)), 15)));
                            if (b == this.a.a && (dE(a) === dE(d) || a != null && pb(a, d))) return a;
                            Nb(!Go(this.b.a.a, a, b), a);
                            yo(this.b.a.a, this.a);
                            c = new kp(a, b, this.a.i, this.a.f);
                            this.a = c;
                            Bo(this.b.a.a, c, null);
                            this.b.b = this.b.a.a.g;
                            return d;
                        };
                        var YF = sfb(xve, 'HashBiMap/Inverse/1/InverseEntry', 1021);
                        feb(620, 542, Fve, Gp);
                        _.Kc = function Hp() {
                            return new Jp(this.a.a);
                        };
                        _.Mc = function Ip(a) {
                            var b;
                            b = Ho(this.a.a, a, Ydb(Ndb(cwe, qgb(Ydb(Ndb(a == null ? 0 : tb(a), dwe)), 15))));
                            if (!b) return false;
                            else {
                                yo(this.a.a, b);
                                return true;
                            }
                        };
                        var _F = sfb(xve, 'HashBiMap/Inverse/InverseKeySet', 620);
                        feb(1019, 544, Ave, Jp);
                        _.Xd = function Kp(a) {
                            return a.i;
                        };
                        var $F = sfb(xve, 'HashBiMap/Inverse/InverseKeySet/1', 1019);
                        feb(1022, 1, {}, Lp);
                        _.Yd = function Mp(a, b) {
                            tp(this.a, a, b);
                        };
                        var aG = sfb(xve, 'HashBiMap/Inverse/lambda$0$Type', 1022);
                        feb(618, 542, Fve, Np);
                        _.Kc = function Op() {
                            return new Qp(this.a);
                        };
                        _.Mc = function Pp(a) {
                            var b;
                            b = Go(this.a, a, Ydb(Ndb(cwe, qgb(Ydb(Ndb(a == null ? 0 : tb(a), dwe)), 15))));
                            if (!b) return false;
                            else {
                                yo(this.a, b);
                                b.e = null;
                                b.c = null;
                                return true;
                            }
                        };
                        var eG = sfb(xve, 'HashBiMap/KeySet', 618);
                        feb(1018, 544, Ave, Qp);
                        _.Xd = function Rp(a) {
                            return a.g;
                        };
                        var dG = sfb(xve, 'HashBiMap/KeySet/1', 1018);
                        feb(1123, 627, zve);
                        var gG = sfb(xve, 'HashMultimapGwtSerializationDependencies', 1123);
                        feb(271, 1123, zve, Tp);
                        _.hc = function Up() {
                            return new atb(Sv(this.a));
                        };
                        _.pd = function Vp() {
                            return new atb(Sv(this.a));
                        };
                        _.a = 2;
                        var hG = sfb(xve, 'HashMultimap', 271);
                        feb(2097, 307, Yve);
                        _.Hc = function Yp(a) {
                            return this.Zd().Hc(a);
                        };
                        _.dc = function Zp() {
                            return this.Zd().dc();
                        };
                        _.gc = function $p() {
                            return this.Zd().gc();
                        };
                        var iG = sfb(xve, 'ImmutableAsList', 2097);
                        feb(2030, 730, $ve);
                        _.Vd = function aq() {
                            return _l(), new Fy(this.a);
                        };
                        _.Cc = function bq() {
                            return _l(), new Fy(this.a);
                        };
                        _.xd = function cq() {
                            return _l(), new Fy(this.a);
                        };
                        var jG = sfb(xve, 'ImmutableBiMap', 2030);
                        feb(2075, 1, {});
                        var kG = sfb(xve, 'ImmutableCollection/Builder', 2075);
                        feb(1035, 719, awe, dq);
                        var nG = sfb(xve, 'ImmutableEnumSet', 1035);
                        feb(980, 399, yve, fq);
                        _.Xb = function gq(a) {
                            return this.a.Xb(a);
                        };
                        var oG = sfb(xve, 'ImmutableList/1', 980);
                        feb(979, 2075, {}, hq);
                        var pG = sfb(xve, 'ImmutableList/Builder', 979);
                        feb(623, 204, wve, iq);
                        _.Ob = function jq() {
                            return this.a.Ob();
                        };
                        _.Pb = function kq() {
                            return RD(this.a.Pb(), 44).ld();
                        };
                        var rG = sfb(xve, 'ImmutableMap/1', 623);
                        feb(1054, 1, {}, lq);
                        _.Kb = function mq(a) {
                            return RD(a, 44).ld();
                        };
                        var sG = sfb(xve, 'ImmutableMap/2methodref$getKey$Type', 1054);
                        feb(1053, 1, {}, oq);
                        var tG = sfb(xve, 'ImmutableMap/Builder', 1053);
                        feb(2098, 2079, awe);
                        _.Md = function pq() {
                            var a;
                            return a = this.b, !a ? this.b = new Xq(this) : a;
                        };
                        _.Nd = function qq() {
                            return new Fx(this, Ee(this, $C(jJ, rve, 1, this.gc(), 5, 1)));
                        };
                        var BG = sfb(xve, 'ImmutableSet/CachingAsList', 2098);
                        feb(2099, 2098, awe);
                        _.Kc = function uq() {
                            var a;
                            return a = gn(this.a).Od(), new iq(a);
                        };
                        _.Nd = function rq() {
                            return new Xq(this);
                        };
                        _.Jc = function sq(a) {
                            var b, c;
                            Qb(a);
                            c = this.gc();
                            for(b = 0; b < c; b++)a.Cd(RD(gn(this.a).Md().Xb(b), 44).ld());
                        };
                        _.Od = function tq() {
                            var a;
                            return a = this.b, um(!a ? this.b = new Xq(this) : a, 0);
                        };
                        _.Nc = function vq() {
                            return fk(this.gc(), 1296, new Vq(this));
                        };
                        var FG = sfb(xve, 'IndexedImmutableSet', 2099);
                        feb(1230, 2099, awe, xq);
                        _.Kc = function Bq() {
                            var a;
                            return a = gn(this.a).Od(), new iq(a);
                        };
                        _.Hc = function yq(a) {
                            return this.a._b(a);
                        };
                        _.Jc = function zq(a) {
                            Qb(a);
                            Bvb(this.a, new Eq(a));
                        };
                        _.Od = function Aq() {
                            var a;
                            return a = gn(this.a).Od(), new iq(a);
                        };
                        _.gc = function Cq() {
                            return this.a.gc();
                        };
                        _.Nc = function Dq() {
                            return gk(gn(this.a).Nc(), new lq);
                        };
                        var vG = sfb(xve, 'ImmutableMapKeySet', 1230);
                        feb(1231, 1, {}, Eq);
                        _.Yd = function Fq(a, b) {
                            _l();
                            this.a.Cd(a);
                        };
                        var uG = sfb(xve, 'ImmutableMapKeySet/lambda$0$Type', 1231);
                        feb(1227, 2078, Xve, Gq);
                        _.Kc = function Kq() {
                            return new Pq(this);
                        };
                        _.Md = function Hq() {
                            var a;
                            a = gn(this.a).Md();
                            return new Sq(this, a);
                        };
                        _.Hc = function Iq(a) {
                            return a != null && Br(new Pq(this), a);
                        };
                        _.Od = function Jq() {
                            return new Pq(this);
                        };
                        _.gc = function Lq() {
                            return this.a.gc();
                        };
                        _.Nc = function Mq() {
                            return gk(gn(this.a).Nc(), new Nq);
                        };
                        var zG = sfb(xve, 'ImmutableMapValues', 1227);
                        feb(1228, 1, {}, Nq);
                        _.Kb = function Oq(a) {
                            return RD(a, 44).md();
                        };
                        var wG = sfb(xve, 'ImmutableMapValues/0methodref$getValue$Type', 1228);
                        feb(637, 204, wve, Pq);
                        _.Ob = function Qq() {
                            return this.a.Ob();
                        };
                        _.Pb = function Rq() {
                            return RD(this.a.Pb(), 44).md();
                        };
                        var xG = sfb(xve, 'ImmutableMapValues/1', 637);
                        feb(1229, 2097, Yve, Sq);
                        _.Zd = function Tq() {
                            return this.a;
                        };
                        _.Xb = function Uq(a) {
                            return RD(this.b.Xb(a), 44).md();
                        };
                        var yG = sfb(xve, 'ImmutableMapValues/2', 1229);
                        feb(1232, 1, {}, Vq);
                        _.td = function Wq(a) {
                            return wq(this.a, a);
                        };
                        var DG = sfb(xve, 'IndexedImmutableSet/0methodref$get$Type', 1232);
                        feb(638, 2097, Yve, Xq);
                        _.Zd = function Yq() {
                            return this.a;
                        };
                        _.Xb = function Zq(a) {
                            return wq(this.a, a);
                        };
                        _.gc = function $q() {
                            return this.a.a.gc();
                        };
                        var EG = sfb(xve, 'IndexedImmutableSet/1', 638);
                        feb(43, 1, {}, ir);
                        _.Kb = function jr(a) {
                            return RD(a, 20).Kc();
                        };
                        _.Fb = function kr(a) {
                            return this === a;
                        };
                        var GG = sfb(xve, 'Iterables/10', 43);
                        feb(1055, 547, Vve, mr);
                        _.Jc = function nr(a) {
                            Qb(a);
                            this.b.Jc(new qr(this.a, a));
                        };
                        _.Kc = function or() {
                            return lr(this);
                        };
                        var IG = sfb(xve, 'Iterables/4', 1055);
                        feb(1056, 1, Qve, qr);
                        _.Cd = function rr(a) {
                            pr(this.b, this.a, a);
                        };
                        var HG = sfb(xve, 'Iterables/4/lambda$0$Type', 1056);
                        feb(1057, 547, Vve, sr);
                        _.Jc = function tr(a) {
                            Qb(a);
                            xgb(this.a, new vr(a, this.b));
                        };
                        _.Kc = function ur() {
                            return Mr(new dMd(this.a), this.b);
                        };
                        var KG = sfb(xve, 'Iterables/5', 1057);
                        feb(1058, 1, Qve, vr);
                        _.Cd = function wr(a) {
                            this.a.Cd(Ksd(a));
                        };
                        var JG = sfb(xve, 'Iterables/5/lambda$0$Type', 1058);
                        feb(1087, 204, wve, Or);
                        _.Ob = function Pr() {
                            return this.a.Ob();
                        };
                        _.Pb = function Qr() {
                            return this.a.Pb();
                        };
                        var LG = sfb(xve, 'Iterators/1', 1087);
                        feb(1088, 713, wve, Rr);
                        _.Yb = function Sr() {
                            var a;
                            while(this.b.Ob()){
                                a = this.b.Pb();
                                if (this.a.Lb(a)) return a;
                            }
                            return this.e = 2, null;
                        };
                        var MG = sfb(xve, 'Iterators/5', 1088);
                        feb(497, 1, Ave);
                        _.Nb = function Ur(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function Vr() {
                            return this.b.Ob();
                        };
                        _.Pb = function Wr() {
                            return this.$d(this.b.Pb());
                        };
                        _.Qb = function Xr() {
                            this.b.Qb();
                        };
                        var cI = sfb(xve, 'TransformedIterator', 497);
                        feb(1089, 497, Ave, Yr);
                        _.$d = function Zr(a) {
                            return this.a.Kb(a);
                        };
                        var NG = sfb(xve, 'Iterators/6', 1089);
                        feb(732, 204, wve, $r);
                        _.Ob = function _r() {
                            return !this.a;
                        };
                        _.Pb = function as() {
                            if (this.a) throw Adb(new Dvb);
                            this.a = true;
                            return this.b;
                        };
                        _.a = false;
                        var OG = sfb(xve, 'Iterators/9', 732);
                        feb(1086, 399, yve, ds);
                        _.Xb = function es(a) {
                            return this.a[this.b + a];
                        };
                        _.b = 0;
                        var bs;
                        var PG = sfb(xve, 'Iterators/ArrayItr', 1086);
                        feb(38, 1, {
                            38: 1,
                            51: 1
                        }, is);
                        _.Nb = function js(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function ks() {
                            return gs(this);
                        };
                        _.Pb = function ls() {
                            return hs(this);
                        };
                        _.Qb = function ms() {
                            if (!this.c) throw Adb(new dgb(tve));
                            this.c.Qb();
                            this.c = null;
                        };
                        var QG = sfb(xve, 'Iterators/ConcatenatedIterator', 38);
                        feb(22, 1, {
                            3: 1,
                            34: 1,
                            22: 1
                        });
                        _.Fd = function rs(a) {
                            return ns(this, RD(a, 22));
                        };
                        _.Fb = function ts(a) {
                            return this === a;
                        };
                        _.Hb = function us() {
                            return kFb(this);
                        };
                        _.Ib = function vs() {
                            return ps(this);
                        };
                        _.g = 0;
                        var WI = sfb(mve, 'Enum', 22);
                        feb(549, 22, {
                            549: 1,
                            3: 1,
                            34: 1,
                            22: 1,
                            51: 1
                        }, As);
                        _.Nb = function Bs(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function Cs() {
                            return false;
                        };
                        _.Pb = function Ds() {
                            throw Adb(new Dvb);
                        };
                        _.Qb = function Es() {
                            Vb(false);
                        };
                        var ys;
                        var RG = tfb(xve, 'Iterators/EmptyModifiableIterator', 549, WI, Gs, Fs);
                        var Hs;
                        feb(1907, 627, zve);
                        var XG = sfb(xve, 'LinkedHashMultimapGwtSerializationDependencies', 1907);
                        feb(1908, 1907, zve, Ks);
                        _.hc = function Ms() {
                            return new Jub(Sv(this.b));
                        };
                        _.$b = function Ls() {
                            Nc(this);
                            Ss(this.a, this.a);
                        };
                        _.pd = function Ns() {
                            return new Jub(Sv(this.b));
                        };
                        _.ic = function Os(a) {
                            return new it(this, a, this.b);
                        };
                        _.kc = function Ps() {
                            return new Zs(this);
                        };
                        _.lc = function Qs() {
                            var a;
                            return new Swb((a = this.g, RD(!a ? this.g = new xh(this) : a, 21)), 17);
                        };
                        _.ec = function Rs() {
                            var a;
                            return a = this.i, !a ? this.i = new zf(this, this.c) : a;
                        };
                        _.nc = function Us() {
                            return new cw(new Zs(this));
                        };
                        _.oc = function Vs() {
                            var a;
                            return gk(new Swb((a = this.g, RD(!a ? this.g = new xh(this) : a, 21)), 17), new Ws);
                        };
                        _.b = 2;
                        var YG = sfb(xve, 'LinkedHashMultimap', 1908);
                        feb(1911, 1, {}, Ws);
                        _.Kb = function Xs(a) {
                            return RD(a, 44).md();
                        };
                        var SG = sfb(xve, 'LinkedHashMultimap/0methodref$getValue$Type', 1911);
                        feb(834, 1, Ave, Zs);
                        _.Nb = function $s(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function at() {
                            return Ys(this);
                        };
                        _.Ob = function _s() {
                            return this.a != this.b.a;
                        };
                        _.Qb = function bt() {
                            Vb(!!this.c);
                            Gc(this.b, this.c.g, this.c.i);
                            this.c = null;
                        };
                        var TG = sfb(xve, 'LinkedHashMultimap/1', 834);
                        feb(227, 246, {
                            358: 1,
                            246: 1,
                            227: 1,
                            604: 1,
                            3: 1,
                            44: 1
                        }, ct);
                        _._d = function dt() {
                            return RD(Hvb(this.f), 604);
                        };
                        _.ae = function et(a) {
                            this.c = a;
                        };
                        _.be = function ft(a) {
                            this.f = a;
                        };
                        _.d = 0;
                        var UG = sfb(xve, 'LinkedHashMultimap/ValueEntry', 227);
                        feb(1909, 2068, {
                            604: 1,
                            20: 1,
                            31: 1,
                            16: 1,
                            21: 1
                        }, it);
                        _.Fc = function jt(a) {
                            var b, c, d, e, f;
                            f = Ydb(Ndb(cwe, qgb(Ydb(Ndb(a == null ? 0 : tb(a), dwe)), 15)));
                            b = f & this.b.length - 1;
                            e = this.b[b];
                            for(c = e; c; c = c.a){
                                if (c.d == f && Hb(c.i, a)) return false;
                            }
                            d = new ct(this.c, a, f, e);
                            Ts(this.d, d);
                            d.f = this;
                            this.d = d;
                            Ss(RD(Hvb(this.g.a.b), 227), d);
                            Ss(d, this.g.a);
                            this.b[b] = d;
                            ++this.f;
                            ++this.e;
                            gt(this);
                            return true;
                        };
                        _.$b = function kt() {
                            var a, b;
                            Mnb(this.b, null);
                            this.f = 0;
                            for(a = this.a; a != this; a = a._d()){
                                b = RD(a, 227);
                                Ss(RD(Hvb(b.b), 227), RD(Hvb(b.e), 227));
                            }
                            this.a = this;
                            this.d = this;
                            ++this.e;
                        };
                        _.Hc = function lt(a) {
                            var b, c;
                            c = Ydb(Ndb(cwe, qgb(Ydb(Ndb(a == null ? 0 : tb(a), dwe)), 15)));
                            for(b = this.b[c & this.b.length - 1]; b; b = b.a){
                                if (b.d == c && Hb(b.i, a)) return true;
                            }
                            return false;
                        };
                        _.Jc = function mt(a) {
                            var b;
                            Qb(a);
                            for(b = this.a; b != this; b = b._d())a.Cd(RD(b, 227).i);
                        };
                        _._d = function nt() {
                            return this.a;
                        };
                        _.Kc = function ot() {
                            return new ut(this);
                        };
                        _.Mc = function pt(a) {
                            return ht(this, a);
                        };
                        _.ae = function qt(a) {
                            this.d = a;
                        };
                        _.be = function rt(a) {
                            this.a = a;
                        };
                        _.gc = function st() {
                            return this.f;
                        };
                        _.e = 0;
                        _.f = 0;
                        var WG = sfb(xve, 'LinkedHashMultimap/ValueSet', 1909);
                        feb(1910, 1, Ave, ut);
                        _.Nb = function vt(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function wt() {
                            return tt(this), this.b != this.c;
                        };
                        _.Pb = function xt() {
                            var a, b;
                            tt(this);
                            if (this.b == this.c) throw Adb(new Dvb);
                            a = RD(this.b, 227);
                            b = a.i;
                            this.d = a;
                            this.b = RD(Hvb(a.f), 604);
                            return b;
                        };
                        _.Qb = function yt() {
                            tt(this);
                            Vb(!!this.d);
                            ht(this.c, this.d.i);
                            this.a = this.c.e;
                            this.d = null;
                        };
                        _.a = 0;
                        var VG = sfb(xve, 'LinkedHashMultimap/ValueSet/1', 1910);
                        feb(780, 2084, zve, Et);
                        _.Zb = function Ft() {
                            var a;
                            return a = this.f, !a ? this.f = new zw(this) : a;
                        };
                        _.Fb = function Kt(a) {
                            return xw(this, a);
                        };
                        _.cc = function Lt(a) {
                            return new su(this, a);
                        };
                        _.fc = function Ot(a) {
                            return Ct(this, a);
                        };
                        _.$b = function Gt() {
                            At(this);
                        };
                        _._b = function Ht(a) {
                            return Bt(this, a);
                        };
                        _.ac = function It() {
                            return new zw(this);
                        };
                        _.bc = function Jt() {
                            return new vu(this);
                        };
                        _.qc = function Mt(a) {
                            return new su(this, a);
                        };
                        _.dc = function Nt() {
                            return !this.a;
                        };
                        _.rc = function Pt(a) {
                            return Ct(this, a);
                        };
                        _.gc = function Qt() {
                            return this.d;
                        };
                        _.c = 0;
                        _.d = 0;
                        var dH = sfb(xve, 'LinkedListMultimap', 780);
                        feb(56, 31, kwe);
                        _.jd = function eu(a) {
                            tvb(this, a);
                        };
                        _.Nc = function fu() {
                            return new Swb(this, 16);
                        };
                        _.bd = function Tt(a, b) {
                            throw Adb(new kib('Add not supported on this list'));
                        };
                        _.Fc = function Ut(a) {
                            this.bd(this.gc(), a);
                            return true;
                        };
                        _.cd = function Vt(a, b) {
                            var c, d, e;
                            uFb(b);
                            c = false;
                            for(e = b.Kc(); e.Ob();){
                                d = e.Pb();
                                this.bd(a++, d);
                                c = true;
                            }
                            return c;
                        };
                        _.$b = function Wt() {
                            this.ce(0, this.gc());
                        };
                        _.Fb = function Xt(a) {
                            return Rt(this, a);
                        };
                        _.Hb = function Yt() {
                            return Cob(this);
                        };
                        _.dd = function Zt(a) {
                            return St(this, a);
                        };
                        _.Kc = function $t() {
                            return new Dkb(this);
                        };
                        _.ed = function _t() {
                            return this.fd(0);
                        };
                        _.fd = function au(a) {
                            return new Jkb(this, a);
                        };
                        _.gd = function bu(a) {
                            throw Adb(new kib('Remove not supported on this list'));
                        };
                        _.ce = function cu(a, b) {
                            var c, d;
                            d = this.fd(a);
                            for(c = a; c < b; ++c){
                                d.Pb();
                                d.Qb();
                            }
                        };
                        _.hd = function du(a, b) {
                            throw Adb(new kib('Set not supported on this list'));
                        };
                        _.kd = function gu(a, b) {
                            return new Rkb(this, a, b);
                        };
                        _.j = 0;
                        var CJ = sfb(Bve, 'AbstractList', 56);
                        feb(2062, 56, kwe);
                        _.bd = function lu(a, b) {
                            hu(this, a, b);
                        };
                        _.cd = function mu(a, b) {
                            return iu(this, a, b);
                        };
                        _.Xb = function nu(a) {
                            return ju(this, a);
                        };
                        _.Kc = function ou() {
                            return this.fd(0);
                        };
                        _.gd = function pu(a) {
                            return ku(this, a);
                        };
                        _.hd = function qu(b, c) {
                            var d, e;
                            d = this.fd(b);
                            try {
                                e = d.Pb();
                                d.Wb(c);
                                return e;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 112)) throw Adb(new veb("Can't set element " + b));
                                else throw Adb(a);
                            }
                        };
                        var QJ = sfb(Bve, 'AbstractSequentialList', 2062);
                        feb(646, 2062, kwe, su);
                        _.fd = function tu(a) {
                            return ru(this, a);
                        };
                        _.gc = function uu() {
                            var a;
                            a = RD(Wjb(this.a.b, this.b), 260);
                            return !a ? 0 : a.a;
                        };
                        var $G = sfb(xve, 'LinkedListMultimap/1', 646);
                        feb(1316, 2068, Fve, vu);
                        _.Hc = function wu(a) {
                            return Bt(this.a, a);
                        };
                        _.Kc = function xu() {
                            return new Bu(this.a);
                        };
                        _.Mc = function yu(a) {
                            return !Ct(this.a, a).a.dc();
                        };
                        _.gc = function zu() {
                            return bkb(this.a.b);
                        };
                        var ZG = sfb(xve, 'LinkedListMultimap/1KeySetImpl', 1316);
                        feb(1315, 1, Ave, Bu);
                        _.Nb = function Cu(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function Du() {
                            Au(this);
                            return !!this.c;
                        };
                        _.Pb = function Eu() {
                            Au(this);
                            if (!this.c) throw Adb(new Dvb);
                            this.a = this.c;
                            Ysb(this.d, this.a.a);
                            do this.c = this.c.b;
                            while (!!this.c && !Ysb(this.d, this.c.a));
                            return this.a.a;
                        };
                        _.Qb = function Fu() {
                            Au(this);
                            Vb(!!this.a);
                            Ar(new Nu(this.e, this.a.a));
                            this.a = null;
                            this.b = this.e.c;
                        };
                        _.b = 0;
                        var _G = sfb(xve, 'LinkedListMultimap/DistinctKeyIterator', 1315);
                        feb(260, 1, {
                            260: 1
                        }, Gu);
                        _.a = 0;
                        var aH = sfb(xve, 'LinkedListMultimap/KeyList', 260);
                        feb(511, 358, {
                            358: 1,
                            511: 1,
                            44: 1
                        }, Hu);
                        _.ld = function Iu() {
                            return this.a;
                        };
                        _.md = function Ju() {
                            return this.f;
                        };
                        _.nd = function Ku(a) {
                            var b;
                            b = this.f;
                            this.f = a;
                            return b;
                        };
                        var bH = sfb(xve, 'LinkedListMultimap/Node', 511);
                        feb(566, 1, Jve, Nu, Ou);
                        _.Nb = function Qu(a) {
                            Ztb(this, a);
                        };
                        _.Rb = function Pu(a) {
                            this.e = zt(this.f, this.b, a, this.c);
                            ++this.d;
                            this.a = null;
                        };
                        _.Ob = function Ru() {
                            return !!this.c;
                        };
                        _.Sb = function Su() {
                            return !!this.e;
                        };
                        _.Pb = function Tu() {
                            return Lu(this);
                        };
                        _.Tb = function Uu() {
                            return this.d;
                        };
                        _.Ub = function Vu() {
                            return Mu(this);
                        };
                        _.Vb = function Wu() {
                            return this.d - 1;
                        };
                        _.Qb = function Xu() {
                            Vb(!!this.a);
                            if (this.a != this.c) {
                                this.e = this.a.e;
                                --this.d;
                            } else this.c = this.a.c;
                            Dt(this.f, this.a);
                            this.a = null;
                        };
                        _.Wb = function Yu(a) {
                            Ub(!!this.a);
                            this.a.f = a;
                        };
                        _.d = 0;
                        var cH = sfb(xve, 'LinkedListMultimap/ValueForKeyIterator', 566);
                        feb(1031, 56, kwe);
                        _.bd = function iv(a, b) {
                            this.a.bd(a, b);
                        };
                        _.cd = function jv(a, b) {
                            return this.a.cd(a, b);
                        };
                        _.Hc = function kv(a) {
                            return this.a.Hc(a);
                        };
                        _.Xb = function lv(a) {
                            return this.a.Xb(a);
                        };
                        _.gd = function mv(a) {
                            return this.a.gd(a);
                        };
                        _.hd = function nv(a, b) {
                            return this.a.hd(a, b);
                        };
                        _.gc = function ov() {
                            return this.a.gc();
                        };
                        var fH = sfb(xve, 'Lists/AbstractListWrapper', 1031);
                        feb(1032, 1031, mwe);
                        var gH = sfb(xve, 'Lists/RandomAccessListWrapper', 1032);
                        feb(1034, 1032, mwe, pv);
                        _.fd = function qv(a) {
                            return this.a.fd(a);
                        };
                        var eH = sfb(xve, 'Lists/1', 1034);
                        feb(441, 56, {
                            441: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1
                        }, uv);
                        _.bd = function vv(a, b) {
                            this.a.bd(tv(this, a), b);
                        };
                        _.$b = function wv() {
                            this.a.$b();
                        };
                        _.Xb = function xv(a) {
                            return this.a.Xb(sv(this, a));
                        };
                        _.Kc = function yv() {
                            return rv(this, 0);
                        };
                        _.fd = function zv(a) {
                            return rv(this, a);
                        };
                        _.gd = function Av(a) {
                            return this.a.gd(sv(this, a));
                        };
                        _.ce = function Bv(a, b) {
                            (Tb(a, b, this.a.gc()), hv(this.a.kd(tv(this, b), tv(this, a)))).$b();
                        };
                        _.hd = function Cv(a, b) {
                            return this.a.hd(sv(this, a), b);
                        };
                        _.gc = function Dv() {
                            return this.a.gc();
                        };
                        _.kd = function Ev(a, b) {
                            return Tb(a, b, this.a.gc()), hv(this.a.kd(tv(this, b), tv(this, a)));
                        };
                        var jH = sfb(xve, 'Lists/ReverseList', 441);
                        feb(1030, 441, {
                            441: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            59: 1
                        }, Fv);
                        var hH = sfb(xve, 'Lists/RandomAccessReverseList', 1030);
                        feb(1033, 1, Jve, Gv);
                        _.Nb = function Iv(a) {
                            Ztb(this, a);
                        };
                        _.Rb = function Hv(a) {
                            this.c.Rb(a);
                            this.c.Ub();
                            this.a = false;
                        };
                        _.Ob = function Jv() {
                            return this.c.Sb();
                        };
                        _.Sb = function Kv() {
                            return this.c.Ob();
                        };
                        _.Pb = function Lv() {
                            if (!this.c.Sb()) throw Adb(new Dvb);
                            this.a = true;
                            return this.c.Ub();
                        };
                        _.Tb = function Mv() {
                            return tv(this.b, this.c.Tb());
                        };
                        _.Ub = function Nv() {
                            if (!this.c.Ob()) throw Adb(new Dvb);
                            this.a = true;
                            return this.c.Pb();
                        };
                        _.Vb = function Ov() {
                            return tv(this.b, this.c.Tb()) - 1;
                        };
                        _.Qb = function Pv() {
                            Vb(this.a);
                            this.c.Qb();
                            this.a = false;
                        };
                        _.Wb = function Qv(a) {
                            Ub(this.a);
                            this.c.Wb(a);
                        };
                        _.a = false;
                        var iH = sfb(xve, 'Lists/ReverseList/1', 1033);
                        feb(440, 497, Ave, aw);
                        _.$d = function bw(a) {
                            return _v(a);
                        };
                        var kH = sfb(xve, 'Maps/1', 440);
                        feb(712, 497, Ave, cw);
                        _.$d = function dw(a) {
                            return RD(a, 44).md();
                        };
                        var lH = sfb(xve, 'Maps/2', 712);
                        feb(975, 497, Ave, ew);
                        _.$d = function fw(a) {
                            return new gp(a, Mw(this.a, a));
                        };
                        var mH = sfb(xve, 'Maps/3', 975);
                        feb(972, 2069, Fve, gw);
                        _.Jc = function hw(a) {
                            uj(this.a, a);
                        };
                        _.Kc = function iw() {
                            return this.a.kc();
                        };
                        _.Rc = function jw() {
                            return this.a;
                        };
                        _.Nc = function kw() {
                            return this.a.lc();
                        };
                        var oH = sfb(xve, 'Maps/IteratorBasedAbstractMap/1', 972);
                        feb(973, 1, {}, lw);
                        _.Yd = function mw(a, b) {
                            this.a.Cd(a);
                        };
                        var qH = sfb(xve, 'Maps/KeySet/lambda$0$Type', 973);
                        feb(971, 31, Dve, nw);
                        _.$b = function ow() {
                            this.a.$b();
                        };
                        _.Hc = function pw(a) {
                            return this.a.uc(a);
                        };
                        _.Jc = function qw(a) {
                            Qb(a);
                            this.a.wc(new vw(a));
                        };
                        _.dc = function rw() {
                            return this.a.dc();
                        };
                        _.Kc = function sw() {
                            return new cw(this.a.vc().Kc());
                        };
                        _.Mc = function tw(b) {
                            var c, d;
                            try {
                                return ze(this, b, true);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 48)) {
                                    for(d = this.a.vc().Kc(); d.Ob();){
                                        c = RD(d.Pb(), 44);
                                        if (Hb(b, c.md())) {
                                            this.a.Bc(c.ld());
                                            return true;
                                        }
                                    }
                                    return false;
                                } else throw Adb(a);
                            }
                        };
                        _.gc = function uw() {
                            return this.a.gc();
                        };
                        var tH = sfb(xve, 'Maps/Values', 971);
                        feb(974, 1, {}, vw);
                        _.Yd = function ww(a, b) {
                            this.a.Cd(b);
                        };
                        var sH = sfb(xve, 'Maps/Values/lambda$0$Type', 974);
                        feb(752, 2085, Cve, zw);
                        _.xc = function Dw(a) {
                            return this.a._b(a) ? this.a.cc(a) : null;
                        };
                        _.Bc = function Gw(a) {
                            return this.a._b(a) ? this.a.fc(a) : null;
                        };
                        _.$b = function Aw() {
                            this.a.$b();
                        };
                        _._b = function Bw(a) {
                            return this.a._b(a);
                        };
                        _.Ec = function Cw() {
                            return new Iw(this);
                        };
                        _.Dc = function() {
                            return this.Ec();
                        };
                        _.dc = function Ew() {
                            return this.a.dc();
                        };
                        _.ec = function Fw() {
                            return this.a.ec();
                        };
                        _.gc = function Hw() {
                            return this.a.ec().gc();
                        };
                        var xH = sfb(xve, 'Multimaps/AsMap', 752);
                        feb(1134, 2069, Fve, Iw);
                        _.Kc = function Jw() {
                            return Rv(this.a.a.ec(), new Nw(this));
                        };
                        _.Rc = function Kw() {
                            return this.a;
                        };
                        _.Mc = function Lw(a) {
                            var b;
                            if (!Ze(this, a)) return false;
                            b = RD(Hvb(RD(a, 44)), 44);
                            yw(this.a, b.ld());
                            return true;
                        };
                        var wH = sfb(xve, 'Multimaps/AsMap/EntrySet', 1134);
                        feb(1138, 1, {}, Nw);
                        _.Kb = function Ow(a) {
                            return Mw(this, a);
                        };
                        _.Fb = function Pw(a) {
                            return this === a;
                        };
                        var vH = sfb(xve, 'Multimaps/AsMap/EntrySet/1', 1138);
                        feb(552, 2087, {
                            552: 1,
                            849: 1,
                            20: 1,
                            31: 1,
                            16: 1
                        }, Sw);
                        _.$b = function Tw() {
                            Nc(this.a);
                        };
                        _.Hc = function Uw(a) {
                            return Oc(this.a, a);
                        };
                        _.Jc = function Vw(a) {
                            Qb(a);
                            xgb(Pc(this.a), new fx(a));
                        };
                        _.Kc = function Ww() {
                            return new aw(Pc(this.a).a.kc());
                        };
                        _.gc = function Xw() {
                            return this.a.d;
                        };
                        _.Nc = function Yw() {
                            return gk(Pc(this.a).Nc(), new Zw);
                        };
                        var DH = sfb(xve, 'Multimaps/Keys', 552);
                        feb(1136, 1, {}, Zw);
                        _.Kb = function $w(a) {
                            return RD(a, 44).ld();
                        };
                        var zH = sfb(xve, 'Multimaps/Keys/0methodref$getKey$Type', 1136);
                        feb(1135, 497, Ave, _w);
                        _.$d = function ax(a) {
                            return new ex(RD(a, 44));
                        };
                        var BH = sfb(xve, 'Multimaps/Keys/1', 1135);
                        feb(2088, 1, {
                            425: 1
                        });
                        _.Fb = function bx(a) {
                            var b;
                            if (ZD(a, 504)) {
                                b = RD(a, 425);
                                return RD(this.a.md(), 16).gc() == RD(b.a.md(), 16).gc() && Hb(this.a.ld(), b.a.ld());
                            }
                            return false;
                        };
                        _.Hb = function cx() {
                            var a;
                            a = this.a.ld();
                            return (a == null ? 0 : tb(a)) ^ RD(this.a.md(), 16).gc();
                        };
                        _.Ib = function dx() {
                            var a, b;
                            b = Ghb(this.a.ld());
                            a = RD(this.a.md(), 16).gc();
                            return a == 1 ? b : b + ' x ' + a;
                        };
                        var HH = sfb(xve, 'Multisets/AbstractEntry', 2088);
                        feb(504, 2088, {
                            504: 1,
                            425: 1
                        }, ex);
                        var AH = sfb(xve, 'Multimaps/Keys/1/1', 504);
                        feb(1137, 1, Qve, fx);
                        _.Cd = function gx(a) {
                            this.a.Cd(RD(a, 44).ld());
                        };
                        var CH = sfb(xve, 'Multimaps/Keys/lambda$1$Type', 1137);
                        feb(1140, 1, Qve, jx);
                        _.Cd = function kx(a) {
                            hx(RD(a, 425));
                        };
                        var EH = sfb(xve, 'Multiset/lambda$0$Type', 1140);
                        feb(753, 1, Qve, lx);
                        _.Cd = function mx(a) {
                            ix(this.a, RD(a, 425));
                        };
                        var FH = sfb(xve, 'Multiset/lambda$1$Type', 753);
                        feb(1141, 1, {}, rx);
                        var GH = sfb(xve, 'Multisets/0methodref$add$Type', 1141);
                        feb(754, 1, {}, sx);
                        _.Kb = function tx(a) {
                            return px(RD(a, 425));
                        };
                        var JH = sfb(xve, 'Multisets/lambda$1$Type', 754);
                        feb(2106, 1, nve);
                        var KH = sfb(xve, 'RangeGwtSerializationDependencies', 2106);
                        feb(521, 2106, {
                            178: 1,
                            521: 1,
                            3: 1,
                            46: 1
                        }, wx);
                        _.Lb = function xx(a) {
                            return vx(this, RD(a, 34));
                        };
                        _.Mb = function Bx(a) {
                            return vx(this, RD(a, 34));
                        };
                        _.Fb = function zx(a) {
                            var b;
                            if (ZD(a, 521)) {
                                b = RD(a, 521);
                                return Pk(this.a, b.a) && Pk(this.b, b.b);
                            }
                            return false;
                        };
                        _.Hb = function Ax() {
                            return this.a.Hb() * 31 + this.b.Hb();
                        };
                        _.Ib = function Cx() {
                            return Dx(this.a, this.b);
                        };
                        var LH = sfb(xve, 'Range', 521);
                        feb(654, 2097, Yve, Fx);
                        _.fd = function Jx(a) {
                            return um(this.b, a);
                        };
                        _.Zd = function Gx() {
                            return this.a;
                        };
                        _.Xb = function Hx(a) {
                            return Qm(this.b, a);
                        };
                        _.Pd = function Ix(a) {
                            return um(this.b, a);
                        };
                        var MH = sfb(xve, 'RegularImmutableAsList', 654);
                        feb(656, 2105, Yve, Kx);
                        _.Rd = function Lx() {
                            return this.a;
                        };
                        var NH = sfb(xve, 'RegularImmutableList', 656);
                        feb(548, 730, $ve, Mx, Nx);
                        var OH = sfb(xve, 'RegularImmutableMap', 548);
                        feb(731, 719, awe, Qx);
                        var Ox;
                        var PH = sfb(xve, 'RegularImmutableSet', 731);
                        feb(2074, Eve, Fve);
                        _.Kc = function by() {
                            return new oy(this.a, this.b);
                        };
                        _.Fc = function $x(a) {
                            throw Adb(new jib);
                        };
                        _.Gc = function _x(a) {
                            throw Adb(new jib);
                        };
                        _.$b = function ay() {
                            throw Adb(new jib);
                        };
                        _.Mc = function cy(a) {
                            throw Adb(new jib);
                        };
                        var VH = sfb(xve, 'Sets/SetView', 2074);
                        feb(976, 2074, Fve, ey);
                        _.Kc = function iy() {
                            return new oy(this.a, this.b);
                        };
                        _.Hc = function fy(a) {
                            return Bsb(this.a, a) && this.b.Hc(a);
                        };
                        _.Ic = function gy(a) {
                            return Be(this.a, a) && this.b.Ic(a);
                        };
                        _.dc = function hy() {
                            return Aob(this.b, this.a);
                        };
                        _.Lc = function jy() {
                            return CDb(new SDb(null, new Swb(this.a, 1)), new qy(this.b));
                        };
                        _.gc = function ky() {
                            return dy(this);
                        };
                        _.Oc = function ly() {
                            return CDb(new SDb(null, new Swb(this.a, 1)), new my(this.b));
                        };
                        var TH = sfb(xve, 'Sets/2', 976);
                        feb(977, 1, nwe, my);
                        _.Mb = function ny(a) {
                            return this.a.Hc(a);
                        };
                        var QH = sfb(xve, 'Sets/2/0methodref$contains$Type', 977);
                        feb(714, 713, wve, oy);
                        _.Yb = function py() {
                            var a;
                            while(Msb(this.a)){
                                a = Nsb(this.a);
                                if (this.c.Hc(a)) return a;
                            }
                            return this.e = 2, null;
                        };
                        var RH = sfb(xve, 'Sets/2/1', 714);
                        feb(978, 1, nwe, qy);
                        _.Mb = function ry(a) {
                            return this.a.Hc(a);
                        };
                        var SH = sfb(xve, 'Sets/2/1methodref$contains$Type', 978);
                        feb(616, 2073, {
                            616: 1,
                            3: 1,
                            20: 1,
                            16: 1,
                            277: 1,
                            21: 1,
                            87: 1
                        }, sy);
                        _.Kd = function ty() {
                            return this.b;
                        };
                        _.Ld = function uy() {
                            return this.b;
                        };
                        _.Wd = function vy() {
                            return this.b;
                        };
                        _.Jc = function wy(a) {
                            this.a.Jc(a);
                        };
                        _.Lc = function xy() {
                            return this.a.Lc();
                        };
                        _.Oc = function yy() {
                            return this.a.Oc();
                        };
                        var WH = sfb(xve, 'Sets/UnmodifiableNavigableSet', 616);
                        feb(2031, 2030, $ve, zy);
                        _.Vd = function Ay() {
                            return _l(), new Fy(this.a);
                        };
                        _.Cc = function By() {
                            return _l(), new Fy(this.a);
                        };
                        _.xd = function Cy() {
                            return _l(), new Fy(this.a);
                        };
                        var XH = sfb(xve, 'SingletonImmutableBiMap', 2031);
                        feb(657, 2105, Yve, Dy);
                        _.Rd = function Ey() {
                            return this.a;
                        };
                        var YH = sfb(xve, 'SingletonImmutableList', 657);
                        feb(363, 2079, awe, Fy);
                        _.Kc = function Iy() {
                            return new $r(this.a);
                        };
                        _.Hc = function Gy(a) {
                            return pb(this.a, a);
                        };
                        _.Od = function Hy() {
                            return new $r(this.a);
                        };
                        _.gc = function Jy() {
                            return 1;
                        };
                        var ZH = sfb(xve, 'SingletonImmutableSet', 363);
                        feb(1148, 1, {}, My);
                        _.Kb = function Ny(a) {
                            return RD(a, 159);
                        };
                        var _H = sfb(xve, 'Streams/lambda$0$Type', 1148);
                        feb(1149, 1, owe, Oy);
                        _.de = function Py() {
                            Ky(this.a);
                        };
                        var aI = sfb(xve, 'Streams/lambda$1$Type', 1149);
                        feb(1725, 1724, zve, Ry);
                        _.Zb = function Sy() {
                            var a;
                            return a = this.f, RD(RD(!a ? this.f = ZD(this.c, 139) ? new Uf(this, RD(this.c, 139)) : ZD(this.c, 133) ? new Mf(this, RD(this.c, 133)) : new ne(this, this.c) : a, 133), 139);
                        };
                        _.hc = function Vy() {
                            return new yAb(this.b);
                        };
                        _.pd = function Wy() {
                            return new yAb(this.b);
                        };
                        _.ec = function Yy() {
                            var a;
                            return a = this.i, RD(RD(!a ? this.i = ZD(this.c, 139) ? new gg(this, RD(this.c, 139)) : ZD(this.c, 133) ? new eg(this, RD(this.c, 133)) : new zf(this, this.c) : a, 87), 277);
                        };
                        _.ac = function Uy() {
                            return ZD(this.c, 139) ? new Uf(this, RD(this.c, 139)) : ZD(this.c, 133) ? new Mf(this, RD(this.c, 133)) : new ne(this, this.c);
                        };
                        _.ic = function Xy(a) {
                            a == null && this.a.Ne(a, a);
                            return new yAb(this.b);
                        };
                        var dI = sfb(xve, 'TreeMultimap', 1725);
                        feb(82, 1, {
                            3: 1,
                            82: 1
                        });
                        _.ee = function pz(a) {
                            return new Error(a);
                        };
                        _.fe = function rz() {
                            return this.e;
                        };
                        _.ge = function sz() {
                            var a, b, c;
                            c = (this.k == null && (this.k = $C(rJ, Nve, 82, 0, 0, 1)), this.k);
                            b = $C(jJ, rve, 1, c.length, 5, 1);
                            for(a = 0; a < c.length; a++)b[a] = c[a].e;
                            return b;
                        };
                        _.he = function tz() {
                            return this.f;
                        };
                        _.ie = function uz() {
                            return this.g;
                        };
                        _.je = function vz() {
                            kz(this, qz(this.ee(lz(this, this.g))));
                            gA(this);
                        };
                        _.Ib = function wz() {
                            return lz(this, this.ie());
                        };
                        _.e = rwe;
                        _.i = false;
                        _.n = true;
                        var rJ = sfb(mve, 'Throwable', 82);
                        feb(103, 82, {
                            3: 1,
                            103: 1,
                            82: 1
                        });
                        var YI = sfb(mve, 'Exception', 103);
                        feb(63, 103, swe, xz, yz);
                        var kJ = sfb(mve, 'RuntimeException', 63);
                        feb(607, 63, swe);
                        var dJ = sfb(mve, 'JsException', 607);
                        feb(875, 607, swe);
                        var jI = sfb(twe, 'JavaScriptExceptionBase', 875);
                        feb(486, 875, {
                            486: 1,
                            3: 1,
                            103: 1,
                            63: 1,
                            82: 1
                        }, Cz);
                        _.ie = function Fz() {
                            Bz(this);
                            return this.c;
                        };
                        _.ke = function Gz() {
                            return dE(this.b) === dE(zz) ? null : this.b;
                        };
                        var zz;
                        var gI = sfb(vwe, 'JavaScriptException', 486);
                        var hI = sfb(vwe, 'JavaScriptObject$', 0);
                        var Jz;
                        feb(2047, 1, {});
                        var iI = sfb(vwe, 'Scheduler', 2047);
                        var Nz = 0, Oz = 0, Pz = -1;
                        feb(902, 2047, {}, bA);
                        var Zz;
                        var kI = sfb(twe, 'SchedulerImpl', 902);
                        var eA;
                        feb(2058, 1, {});
                        var oI = sfb(twe, 'StackTraceCreator/Collector', 2058);
                        feb(876, 2058, {}, mA);
                        _.le = function nA(a) {
                            var b = {}, j;
                            var c = [];
                            a[xwe] = c;
                            var d = arguments.callee.caller;
                            while(d){
                                var e = (fA(), d.name || (d.name = iA(d.toString())));
                                c.push(e);
                                var f = ':' + e;
                                var g = b[f];
                                if (g) {
                                    var h, i;
                                    for(h = 0, i = g.length; h < i; h++){
                                        if (g[h] === d) return;
                                    }
                                }
                                (g || (b[f] = [])).push(d);
                                d = d.caller;
                            }
                        };
                        _.me = function oA(a) {
                            var b, c, d, e;
                            d = (fA(), a && a[xwe] ? a[xwe] : []);
                            c = d.length;
                            e = $C(mJ, Nve, 319, c, 0, 1);
                            for(b = 0; b < c; b++)e[b] = new ehb(d[b], null, -1);
                            return e;
                        };
                        var lI = sfb(twe, 'StackTraceCreator/CollectorLegacy', 876);
                        feb(2059, 2058, {});
                        _.le = function qA(a) {};
                        _.ne = function rA(a, b, c, d) {
                            return new ehb(b, a + '@' + d, c < 0 ? -1 : c);
                        };
                        _.me = function sA(a) {
                            var b, c, d, e, f, g;
                            e = kA(a);
                            f = $C(mJ, Nve, 319, 0, 0, 1);
                            b = 0;
                            d = e.length;
                            if (d == 0) return f;
                            g = pA(this, e[0]);
                            lhb(g.d, wwe) || (f[b++] = g);
                            for(c = 1; c < d; c++)f[b++] = pA(this, e[c]);
                            return f;
                        };
                        var nI = sfb(twe, 'StackTraceCreator/CollectorModern', 2059);
                        feb(877, 2059, {}, tA);
                        _.ne = function uA(a, b, c, d) {
                            return new ehb(b, a, -1);
                        };
                        var mI = sfb(twe, 'StackTraceCreator/CollectorModernNoSourceMap', 877);
                        feb(1064, 1, {});
                        var vI = sfb(Zwe, $we, 1064);
                        feb(624, 1064, {
                            624: 1
                        }, XA);
                        var VA;
                        var pI = sfb(_we, $we, 624);
                        feb(2101, 1, {});
                        var wI = sfb(Zwe, axe, 2101);
                        feb(2102, 2101, {});
                        var qI = sfb(_we, axe, 2102);
                        feb(1120, 1, {}, aB);
                        var ZA;
                        var rI = sfb(_we, 'LocaleInfo', 1120);
                        feb(2027, 1, {}, dB);
                        _.a = 0;
                        var sI = sfb(_we, 'TimeZone', 2027);
                        feb(1293, 2102, {}, jB);
                        var tI = sfb('com.google.gwt.i18n.client.impl.cldr', 'DateTimeFormatInfoImpl', 1293);
                        feb(443, 1, {
                            443: 1
                        }, kB);
                        _.a = false;
                        _.b = 0;
                        var uI = sfb(Zwe, 'DateTimeFormat/PatternPart', 443);
                        feb(206, 1, bxe, uB, vB, wB);
                        _.Fd = function xB(a) {
                            return lB(this, RD(a, 206));
                        };
                        _.Fb = function yB(a) {
                            return ZD(a, 206) && Gdb(Hdb(this.q.getTime()), Hdb(RD(a, 206).q.getTime()));
                        };
                        _.Hb = function zB() {
                            var a;
                            a = Hdb(this.q.getTime());
                            return Ydb($db(a, Udb(a, 32)));
                        };
                        _.Ib = function BB() {
                            var a, b, c;
                            c = -this.q.getTimezoneOffset();
                            a = (c >= 0 ? '+' : '') + (c / 60 | 0);
                            b = AB($wnd.Math.abs(c) % 60);
                            return (Mrb(), Krb)[this.q.getDay()] + ' ' + Lrb[this.q.getMonth()] + ' ' + AB(this.q.getDate()) + ' ' + AB(this.q.getHours()) + ':' + AB(this.q.getMinutes()) + ':' + AB(this.q.getSeconds()) + ' GMT' + a + b + ' ' + this.q.getFullYear();
                        };
                        var qK = sfb(Bve, 'Date', 206);
                        feb(2015, 206, bxe, DB);
                        _.a = false;
                        _.b = 0;
                        _.c = 0;
                        _.d = 0;
                        _.e = 0;
                        _.f = 0;
                        _.g = false;
                        _.i = 0;
                        _.j = 0;
                        _.k = 0;
                        _.n = 0;
                        _.o = 0;
                        _.p = 0;
                        var xI = sfb('com.google.gwt.i18n.shared.impl', 'DateRecord', 2015);
                        feb(2064, 1, {});
                        _.pe = function EB() {
                            return null;
                        };
                        _.qe = function FB() {
                            return null;
                        };
                        _.re = function GB() {
                            return null;
                        };
                        _.se = function HB() {
                            return null;
                        };
                        _.te = function IB() {
                            return null;
                        };
                        var GI = sfb(cxe, 'JSONValue', 2064);
                        feb(221, 2064, {
                            221: 1
                        }, MB, NB);
                        _.Fb = function OB(a) {
                            if (!ZD(a, 221)) return false;
                            return Hz(this.a, RD(a, 221).a);
                        };
                        _.oe = function PB() {
                            return TB;
                        };
                        _.Hb = function QB() {
                            return Iz(this.a);
                        };
                        _.pe = function RB() {
                            return this;
                        };
                        _.Ib = function SB() {
                            var a, b, c;
                            c = new dib('[');
                            for(b = 0, a = this.a.length; b < a; b++){
                                b > 0 && (c.a += ',', c);
                                Yhb(c, JB(this, b));
                            }
                            c.a += ']';
                            return c.a;
                        };
                        var yI = sfb(cxe, 'JSONArray', 221);
                        feb(493, 2064, {
                            493: 1
                        }, XB);
                        _.oe = function YB() {
                            return _B;
                        };
                        _.qe = function ZB() {
                            return this;
                        };
                        _.Ib = function $B() {
                            return Geb(), '' + this.a;
                        };
                        _.a = false;
                        var UB, VB;
                        var zI = sfb(cxe, 'JSONBoolean', 493);
                        feb(997, 63, swe, aC);
                        var AI = sfb(cxe, 'JSONException', 997);
                        feb(1036, 2064, {}, dC);
                        _.oe = function eC() {
                            return gC;
                        };
                        _.Ib = function fC() {
                            return vve;
                        };
                        var bC;
                        var BI = sfb(cxe, 'JSONNull', 1036);
                        feb(263, 2064, {
                            263: 1
                        }, hC);
                        _.Fb = function iC(a) {
                            if (!ZD(a, 263)) return false;
                            return this.a == RD(a, 263).a;
                        };
                        _.oe = function jC() {
                            return nC;
                        };
                        _.Hb = function kC() {
                            return Nfb(this.a);
                        };
                        _.re = function lC() {
                            return this;
                        };
                        _.Ib = function mC() {
                            return this.a + '';
                        };
                        _.a = 0;
                        var CI = sfb(cxe, 'JSONNumber', 263);
                        feb(190, 2064, {
                            190: 1
                        }, uC, vC);
                        _.Fb = function wC(a) {
                            if (!ZD(a, 190)) return false;
                            return Hz(this.a, RD(a, 190).a);
                        };
                        _.oe = function xC() {
                            return BC;
                        };
                        _.Hb = function yC() {
                            return Iz(this.a);
                        };
                        _.se = function zC() {
                            return this;
                        };
                        _.Ib = function AC() {
                            var a, b, c, d, e, f, g;
                            g = new dib('{');
                            a = true;
                            f = oC(this, $C(qJ, Nve, 2, 0, 6, 1));
                            for(c = f, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                a ? a = false : (g.a += pve, g);
                                Zhb(g, Lz(b));
                                g.a += ':';
                                Yhb(g, qC(this, b));
                            }
                            g.a += '}';
                            return g.a;
                        };
                        var EI = sfb(cxe, 'JSONObject', 190);
                        feb(605, Eve, Fve, CC);
                        _.Hc = function DC(a) {
                            return bE(a) && pC(this.a, WD(a));
                        };
                        _.Kc = function EC() {
                            return new Dkb(new mob(this.b));
                        };
                        _.gc = function FC() {
                            return this.b.length;
                        };
                        var DI = sfb(cxe, 'JSONObject/1', 605);
                        var GC;
                        feb(211, 2064, {
                            211: 1
                        }, OC);
                        _.Fb = function PC(a) {
                            if (!ZD(a, 211)) return false;
                            return lhb(this.a, RD(a, 211).a);
                        };
                        _.oe = function QC() {
                            return UC;
                        };
                        _.Hb = function RC() {
                            return ohb(this.a);
                        };
                        _.te = function SC() {
                            return this;
                        };
                        _.Ib = function TC() {
                            return Lz(this.a);
                        };
                        var FI = sfb(cxe, 'JSONString', 211);
                        var eD;
                        var ID, JD, KD, LD;
                        feb(2060, 1, {
                            533: 1
                        });
                        var II = sfb(kxe, 'OutputStream', 2060);
                        feb(2061, 2060, {
                            533: 1
                        });
                        var HI = sfb(kxe, 'FilterOutputStream', 2061);
                        feb(878, 2061, {
                            533: 1
                        }, oeb);
                        var JI = sfb(kxe, 'PrintStream', 878);
                        feb(427, 1, {
                            484: 1
                        });
                        _.Ib = function seb() {
                            return this.a;
                        };
                        var KI = sfb(mve, 'AbstractStringBuilder', 427);
                        feb(538, 63, swe, teb);
                        var LI = sfb(mve, 'ArithmeticException', 538);
                        feb(77, 63, lxe, ueb, veb);
                        var aJ = sfb(mve, 'IndexOutOfBoundsException', 77);
                        feb(333, 77, {
                            3: 1,
                            333: 1,
                            103: 1,
                            77: 1,
                            63: 1,
                            82: 1
                        }, web, xeb);
                        var MI = sfb(mve, 'ArrayIndexOutOfBoundsException', 333);
                        feb(537, 63, swe, yeb, zeb);
                        var NI = sfb(mve, 'ArrayStoreException', 537);
                        feb(296, 82, mxe, Aeb);
                        var XI = sfb(mve, 'Error', 296);
                        feb(200, 296, mxe, Ceb, Deb);
                        var OI = sfb(mve, 'AssertionError', 200);
                        ND = {
                            3: 1,
                            485: 1,
                            34: 1
                        };
                        var Eeb, Feb;
                        var QI = sfb(mve, 'Boolean', 485);
                        feb(242, 1, {
                            3: 1,
                            242: 1
                        });
                        var Meb;
                        var iJ = sfb(mve, 'Number', 242);
                        feb(222, 242, {
                            3: 1,
                            222: 1,
                            34: 1,
                            242: 1
                        }, Seb);
                        _.Fd = function Teb(a) {
                            return Reb(this, RD(a, 222));
                        };
                        _.ue = function Ueb() {
                            return this.a;
                        };
                        _.Fb = function Veb(a) {
                            return ZD(a, 222) && RD(a, 222).a == this.a;
                        };
                        _.Hb = function Web() {
                            return this.a;
                        };
                        _.Ib = function Xeb() {
                            return '' + this.a;
                        };
                        _.a = 0;
                        var RI = sfb(mve, 'Byte', 222);
                        var Yeb;
                        feb(180, 1, {
                            3: 1,
                            180: 1,
                            34: 1
                        }, bfb);
                        _.Fd = function cfb(a) {
                            return afb(this, RD(a, 180));
                        };
                        _.Fb = function efb(a) {
                            return ZD(a, 180) && RD(a, 180).a == this.a;
                        };
                        _.Hb = function ffb() {
                            return this.a;
                        };
                        _.Ib = function gfb() {
                            return String.fromCharCode(this.a);
                        };
                        _.a = 0;
                        var _eb;
                        var SI = sfb(mve, 'Character', 180);
                        var ifb;
                        feb(212, 63, {
                            3: 1,
                            212: 1,
                            103: 1,
                            63: 1,
                            82: 1
                        }, Hfb, Ifb);
                        var TI = sfb(mve, 'ClassCastException', 212);
                        OD = {
                            3: 1,
                            34: 1,
                            345: 1,
                            242: 1
                        };
                        var VI = sfb(mve, 'Double', 345);
                        feb(161, 242, {
                            3: 1,
                            34: 1,
                            161: 1,
                            242: 1
                        }, Tfb, Ufb);
                        _.Fd = function Vfb(a) {
                            return Sfb(this, RD(a, 161));
                        };
                        _.ue = function Wfb() {
                            return this.a;
                        };
                        _.Fb = function Xfb(a) {
                            return ZD(a, 161) && Lfb(this.a, RD(a, 161).a);
                        };
                        _.Hb = function Yfb() {
                            return eE(this.a);
                        };
                        _.Ib = function $fb() {
                            return '' + this.a;
                        };
                        _.a = 0;
                        var ZI = sfb(mve, 'Float', 161);
                        feb(33, 63, {
                            3: 1,
                            103: 1,
                            33: 1,
                            63: 1,
                            82: 1
                        }, _fb, agb, bgb);
                        var $I = sfb(mve, 'IllegalArgumentException', 33);
                        feb(73, 63, swe, cgb, dgb);
                        var _I = sfb(mve, 'IllegalStateException', 73);
                        feb(17, 242, {
                            3: 1,
                            34: 1,
                            17: 1,
                            242: 1
                        }, fgb);
                        _.Fd = function igb(a) {
                            return egb(this, RD(a, 17));
                        };
                        _.ue = function jgb() {
                            return this.a;
                        };
                        _.Fb = function kgb(a) {
                            return ZD(a, 17) && RD(a, 17).a == this.a;
                        };
                        _.Hb = function lgb() {
                            return this.a;
                        };
                        _.Ib = function rgb() {
                            return '' + this.a;
                        };
                        _.a = 0;
                        var bJ = sfb(mve, 'Integer', 17);
                        var tgb;
                        var vgb;
                        feb(168, 242, {
                            3: 1,
                            34: 1,
                            168: 1,
                            242: 1
                        }, zgb);
                        _.Fd = function Bgb(a) {
                            return ygb(this, RD(a, 168));
                        };
                        _.ue = function Cgb() {
                            return Xdb(this.a);
                        };
                        _.Fb = function Dgb(a) {
                            return ZD(a, 168) && Gdb(RD(a, 168).a, this.a);
                        };
                        _.Hb = function Egb() {
                            return Fgb(this.a);
                        };
                        _.Ib = function Ggb() {
                            return '' + Zdb(this.a);
                        };
                        _.a = 0;
                        var eJ = sfb(mve, 'Long', 168);
                        var Igb;
                        feb(2140, 1, {});
                        feb(1904, 63, swe, Mgb);
                        var fJ = sfb(mve, 'NegativeArraySizeException', 1904);
                        feb(169, 607, {
                            3: 1,
                            103: 1,
                            169: 1,
                            63: 1,
                            82: 1
                        }, Ngb, Ogb);
                        _.ee = function Pgb(a) {
                            return new TypeError(a);
                        };
                        var gJ = sfb(mve, 'NullPointerException', 169);
                        var Qgb, Rgb, Sgb, Tgb;
                        feb(130, 33, {
                            3: 1,
                            103: 1,
                            33: 1,
                            130: 1,
                            63: 1,
                            82: 1
                        }, Vgb);
                        var hJ = sfb(mve, 'NumberFormatException', 130);
                        feb(191, 242, {
                            3: 1,
                            34: 1,
                            242: 1,
                            191: 1
                        }, Xgb);
                        _.Fd = function Ygb(a) {
                            return Wgb(this, RD(a, 191));
                        };
                        _.ue = function Zgb() {
                            return this.a;
                        };
                        _.Fb = function $gb(a) {
                            return ZD(a, 191) && RD(a, 191).a == this.a;
                        };
                        _.Hb = function _gb() {
                            return this.a;
                        };
                        _.Ib = function ahb() {
                            return '' + this.a;
                        };
                        _.a = 0;
                        var lJ = sfb(mve, 'Short', 191);
                        var chb;
                        feb(319, 1, {
                            3: 1,
                            319: 1
                        }, ehb);
                        _.Fb = function fhb(a) {
                            var b;
                            if (ZD(a, 319)) {
                                b = RD(a, 319);
                                return this.c == b.c && this.d == b.d && this.a == b.a && this.b == b.b;
                            }
                            return false;
                        };
                        _.Hb = function ghb() {
                            return Tnb(cD(WC(jJ, 1), rve, 1, 5, [
                                sgb(this.c),
                                this.a,
                                this.d,
                                this.b
                            ]));
                        };
                        _.Ib = function hhb() {
                            return this.a + '.' + this.d + '(' + (this.b != null ? this.b : 'Unknown Source') + (this.c >= 0 ? ':' + this.c : '') + ')';
                        };
                        _.c = 0;
                        var mJ = sfb(mve, 'StackTraceElement', 319);
                        PD = {
                            3: 1,
                            484: 1,
                            34: 1,
                            2: 1
                        };
                        var qJ = sfb(mve, uwe, 2);
                        feb(111, 427, {
                            484: 1
                        }, Qhb, Rhb, Shb);
                        var nJ = sfb(mve, 'StringBuffer', 111);
                        feb(104, 427, {
                            484: 1
                        }, bib, cib, dib);
                        var oJ = sfb(mve, 'StringBuilder', 104);
                        feb(702, 77, lxe, eib);
                        var pJ = sfb(mve, 'StringIndexOutOfBoundsException', 702);
                        feb(2145, 1, {});
                        var fib;
                        feb(48, 63, {
                            3: 1,
                            103: 1,
                            63: 1,
                            82: 1,
                            48: 1
                        }, jib, kib);
                        var sJ = sfb(mve, 'UnsupportedOperationException', 48);
                        feb(247, 242, {
                            3: 1,
                            34: 1,
                            242: 1,
                            247: 1
                        }, Aib, Bib);
                        _.Fd = function Eib(a) {
                            return uib(this, RD(a, 247));
                        };
                        _.ue = function Fib() {
                            return Neb(zib(this));
                        };
                        _.Fb = function Gib(a) {
                            var b;
                            if (this === a) return true;
                            if (ZD(a, 247)) {
                                b = RD(a, 247);
                                return this.e == b.e && uib(this, b) == 0;
                            }
                            return false;
                        };
                        _.Hb = function Hib() {
                            var a;
                            if (this.b != 0) return this.b;
                            if (this.a < 54) {
                                a = Hdb(this.f);
                                this.b = Ydb(Cdb(a, -1));
                                this.b = 33 * this.b + Ydb(Cdb(Tdb(a, 32), -1));
                                this.b = 17 * this.b + eE(this.e);
                                return this.b;
                            }
                            this.b = 17 * Vib(this.c) + eE(this.e);
                            return this.b;
                        };
                        _.Ib = function Iib() {
                            return zib(this);
                        };
                        _.a = 0;
                        _.b = 0;
                        _.d = 0;
                        _.e = 0;
                        _.f = 0;
                        var lib, mib, nib, oib, pib, qib, rib, sib;
                        var tJ = sfb('java.math', 'BigDecimal', 247);
                        feb(92, 242, {
                            3: 1,
                            34: 1,
                            242: 1,
                            92: 1
                        }, ajb, bjb, cjb, djb, ejb);
                        _.Fd = function gjb(a) {
                            return Qib(this, RD(a, 92));
                        };
                        _.ue = function hjb() {
                            return Neb(Ajb(this, 0));
                        };
                        _.Fb = function ijb(a) {
                            return Sib(this, a);
                        };
                        _.Hb = function ljb() {
                            return Vib(this);
                        };
                        _.Ib = function njb() {
                            return Ajb(this, 0);
                        };
                        _.b = -2;
                        _.c = 0;
                        _.d = 0;
                        _.e = 0;
                        var Jib, Kib, Lib, Mib, Nib, Oib;
                        var uJ = sfb('java.math', 'BigInteger', 92);
                        var vjb, wjb;
                        var Jjb, Kjb;
                        feb(498, 2065, Cve);
                        _.$b = function dkb() {
                            akb(this);
                        };
                        _._b = function ekb(a) {
                            return Ujb(this, a);
                        };
                        _.uc = function fkb(a) {
                            return Vjb(this, a, this.i) || Vjb(this, a, this.f);
                        };
                        _.vc = function gkb() {
                            return new mkb(this);
                        };
                        _.xc = function hkb(a) {
                            return Wjb(this, a);
                        };
                        _.zc = function ikb(a, b) {
                            return Zjb(this, a, b);
                        };
                        _.Bc = function jkb(a) {
                            return _jb(this, a);
                        };
                        _.gc = function kkb() {
                            return bkb(this);
                        };
                        _.g = 0;
                        var yJ = sfb(Bve, 'AbstractHashMap', 498);
                        feb(267, Eve, Fve, mkb);
                        _.$b = function nkb() {
                            this.a.$b();
                        };
                        _.Hc = function okb(a) {
                            return lkb(this, a);
                        };
                        _.Kc = function pkb() {
                            return new vkb(this.a);
                        };
                        _.Mc = function qkb(a) {
                            var b;
                            if (lkb(this, a)) {
                                b = RD(a, 44).ld();
                                this.a.Bc(b);
                                return true;
                            }
                            return false;
                        };
                        _.gc = function rkb() {
                            return this.a.gc();
                        };
                        var xJ = sfb(Bve, 'AbstractHashMap/EntrySet', 267);
                        feb(268, 1, Ave, vkb);
                        _.Nb = function wkb(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function ykb() {
                            return tkb(this);
                        };
                        _.Ob = function xkb() {
                            return this.b;
                        };
                        _.Qb = function zkb() {
                            ukb(this);
                        };
                        _.b = false;
                        _.d = 0;
                        var wJ = sfb(Bve, 'AbstractHashMap/EntrySetIterator', 268);
                        feb(426, 1, Ave, Dkb);
                        _.Nb = function Ekb(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function Fkb() {
                            return Akb(this);
                        };
                        _.Pb = function Gkb() {
                            return Bkb(this);
                        };
                        _.Qb = function Hkb() {
                            Ckb(this);
                        };
                        _.b = 0;
                        _.c = -1;
                        var zJ = sfb(Bve, 'AbstractList/IteratorImpl', 426);
                        feb(98, 426, Jve, Jkb);
                        _.Qb = function Pkb() {
                            Ckb(this);
                        };
                        _.Rb = function Kkb(a) {
                            Ikb(this, a);
                        };
                        _.Sb = function Lkb() {
                            return this.b > 0;
                        };
                        _.Tb = function Mkb() {
                            return this.b;
                        };
                        _.Ub = function Nkb() {
                            return sFb(this.b > 0), this.a.Xb(this.c = --this.b);
                        };
                        _.Vb = function Okb() {
                            return this.b - 1;
                        };
                        _.Wb = function Qkb(a) {
                            yFb(this.c != -1);
                            this.a.hd(this.c, a);
                        };
                        var AJ = sfb(Bve, 'AbstractList/ListIteratorImpl', 98);
                        feb(244, 56, kwe, Rkb);
                        _.bd = function Skb(a, b) {
                            wFb(a, this.b);
                            this.c.bd(this.a + a, b);
                            ++this.b;
                        };
                        _.Xb = function Tkb(a) {
                            tFb(a, this.b);
                            return this.c.Xb(this.a + a);
                        };
                        _.gd = function Ukb(a) {
                            var b;
                            tFb(a, this.b);
                            b = this.c.gd(this.a + a);
                            --this.b;
                            return b;
                        };
                        _.hd = function Vkb(a, b) {
                            tFb(a, this.b);
                            return this.c.hd(this.a + a, b);
                        };
                        _.gc = function Wkb() {
                            return this.b;
                        };
                        _.a = 0;
                        _.b = 0;
                        var BJ = sfb(Bve, 'AbstractList/SubList', 244);
                        feb(266, Eve, Fve, Xkb);
                        _.$b = function Ykb() {
                            this.a.$b();
                        };
                        _.Hc = function Zkb(a) {
                            return this.a._b(a);
                        };
                        _.Kc = function $kb() {
                            var a;
                            return a = this.a.vc().Kc(), new blb(a);
                        };
                        _.Mc = function _kb(a) {
                            if (this.a._b(a)) {
                                this.a.Bc(a);
                                return true;
                            }
                            return false;
                        };
                        _.gc = function alb() {
                            return this.a.gc();
                        };
                        var EJ = sfb(Bve, 'AbstractMap/1', 266);
                        feb(541, 1, Ave, blb);
                        _.Nb = function clb(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function dlb() {
                            return this.a.Ob();
                        };
                        _.Pb = function elb() {
                            var a;
                            return a = RD(this.a.Pb(), 44), a.ld();
                        };
                        _.Qb = function flb() {
                            this.a.Qb();
                        };
                        var DJ = sfb(Bve, 'AbstractMap/1/1', 541);
                        feb(231, 31, Dve, glb);
                        _.$b = function hlb() {
                            this.a.$b();
                        };
                        _.Hc = function ilb(a) {
                            return this.a.uc(a);
                        };
                        _.Kc = function jlb() {
                            var a;
                            return a = this.a.vc().Kc(), new llb(a);
                        };
                        _.gc = function klb() {
                            return this.a.gc();
                        };
                        var GJ = sfb(Bve, 'AbstractMap/2', 231);
                        feb(301, 1, Ave, llb);
                        _.Nb = function mlb(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function nlb() {
                            return this.a.Ob();
                        };
                        _.Pb = function olb() {
                            var a;
                            return a = RD(this.a.Pb(), 44), a.md();
                        };
                        _.Qb = function plb() {
                            this.a.Qb();
                        };
                        var FJ = sfb(Bve, 'AbstractMap/2/1', 301);
                        feb(494, 1, {
                            494: 1,
                            44: 1
                        });
                        _.Fb = function rlb(a) {
                            var b;
                            if (!ZD(a, 44)) return false;
                            b = RD(a, 44);
                            return Fvb(this.d, b.ld()) && Fvb(this.e, b.md());
                        };
                        _.ld = function slb() {
                            return this.d;
                        };
                        _.md = function tlb() {
                            return this.e;
                        };
                        _.Hb = function ulb() {
                            return Gvb(this.d) ^ Gvb(this.e);
                        };
                        _.nd = function vlb(a) {
                            return qlb(this, a);
                        };
                        _.Ib = function wlb() {
                            return this.d + '=' + this.e;
                        };
                        var HJ = sfb(Bve, 'AbstractMap/AbstractEntry', 494);
                        feb(397, 494, {
                            494: 1,
                            397: 1,
                            44: 1
                        }, xlb);
                        var IJ = sfb(Bve, 'AbstractMap/SimpleEntry', 397);
                        feb(2082, 1, Axe);
                        _.Fb = function ylb(a) {
                            var b;
                            if (!ZD(a, 44)) return false;
                            b = RD(a, 44);
                            return Fvb(this.ld(), b.ld()) && Fvb(this.md(), b.md());
                        };
                        _.Hb = function zlb() {
                            return Gvb(this.ld()) ^ Gvb(this.md());
                        };
                        _.Ib = function Alb() {
                            return this.ld() + '=' + this.md();
                        };
                        var JJ = sfb(Bve, Lve, 2082);
                        feb(2090, 2065, Gve);
                        _.Xc = function Dlb(a) {
                            return Vd(this.Ee(a));
                        };
                        _.tc = function Elb(a) {
                            return Blb(this, a);
                        };
                        _._b = function Flb(a) {
                            return Clb(this, a);
                        };
                        _.vc = function Glb() {
                            return new Plb(this);
                        };
                        _.Tc = function Hlb() {
                            return Klb(this.Ge());
                        };
                        _.Yc = function Ilb(a) {
                            return Vd(this.He(a));
                        };
                        _.xc = function Jlb(a) {
                            var b;
                            b = a;
                            return Wd(this.Fe(b));
                        };
                        _.$c = function Llb(a) {
                            return Vd(this.Ie(a));
                        };
                        _.ec = function Mlb() {
                            return new Ulb(this);
                        };
                        _.Vc = function Nlb() {
                            return Klb(this.Je());
                        };
                        _._c = function Olb(a) {
                            return Vd(this.Ke(a));
                        };
                        var OJ = sfb(Bve, 'AbstractNavigableMap', 2090);
                        feb(629, Eve, Fve, Plb);
                        _.Hc = function Qlb(a) {
                            return ZD(a, 44) && Blb(this.b, RD(a, 44));
                        };
                        _.Kc = function Rlb() {
                            return this.b.De();
                        };
                        _.Mc = function Slb(a) {
                            var b;
                            if (ZD(a, 44)) {
                                b = RD(a, 44);
                                return this.b.Le(b);
                            }
                            return false;
                        };
                        _.gc = function Tlb() {
                            return this.b.gc();
                        };
                        var LJ = sfb(Bve, 'AbstractNavigableMap/EntrySet', 629);
                        feb(1146, Eve, Ive, Ulb);
                        _.Nc = function $lb() {
                            return new $wb(this);
                        };
                        _.$b = function Vlb() {
                            this.a.$b();
                        };
                        _.Hc = function Wlb(a) {
                            return Clb(this.a, a);
                        };
                        _.Kc = function Xlb() {
                            var a;
                            a = this.a.vc().b.De();
                            return new _lb(a);
                        };
                        _.Mc = function Ylb(a) {
                            if (Clb(this.a, a)) {
                                this.a.Bc(a);
                                return true;
                            }
                            return false;
                        };
                        _.gc = function Zlb() {
                            return this.a.gc();
                        };
                        var NJ = sfb(Bve, 'AbstractNavigableMap/NavigableKeySet', 1146);
                        feb(1147, 1, Ave, _lb);
                        _.Nb = function amb(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function bmb() {
                            return Akb(this.a.a);
                        };
                        _.Pb = function cmb() {
                            var a;
                            a = vzb(this.a);
                            return a.ld();
                        };
                        _.Qb = function dmb() {
                            wzb(this.a);
                        };
                        var MJ = sfb(Bve, 'AbstractNavigableMap/NavigableKeySet/1', 1147);
                        feb(2103, 31, Dve);
                        _.Fc = function emb(a) {
                            return zFb(lwb(this, a), Bxe), true;
                        };
                        _.Gc = function fmb(a) {
                            uFb(a);
                            mFb(a != this, "Can't add a queue to itself");
                            return ye(this, a);
                        };
                        _.$b = function gmb() {
                            while(mwb(this) != null);
                        };
                        var PJ = sfb(Bve, 'AbstractQueue', 2103);
                        feb(310, 31, {
                            4: 1,
                            20: 1,
                            31: 1,
                            16: 1
                        }, wmb, xmb);
                        _.Fc = function ymb(a) {
                            return imb(this, a), true;
                        };
                        _.$b = function Amb() {
                            jmb(this);
                        };
                        _.Hc = function Bmb(a) {
                            return kmb(new Kmb(this), a);
                        };
                        _.dc = function Cmb() {
                            return nmb(this);
                        };
                        _.Kc = function Dmb() {
                            return new Kmb(this);
                        };
                        _.Mc = function Emb(a) {
                            return qmb(new Kmb(this), a);
                        };
                        _.gc = function Fmb() {
                            return this.c - this.b & this.a.length - 1;
                        };
                        _.Nc = function Gmb() {
                            return new Swb(this, 272);
                        };
                        _.Qc = function Hmb(a) {
                            var b;
                            b = this.c - this.b & this.a.length - 1;
                            a.length < b && (a = cFb(new Array(b), a));
                            lmb(this, a, b);
                            a.length > b && bD(a, b, null);
                            return a;
                        };
                        _.b = 0;
                        _.c = 0;
                        var TJ = sfb(Bve, 'ArrayDeque', 310);
                        feb(459, 1, Ave, Kmb);
                        _.Nb = function Lmb(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function Mmb() {
                            return this.a != this.b;
                        };
                        _.Pb = function Nmb() {
                            return Imb(this);
                        };
                        _.Qb = function Omb() {
                            Jmb(this);
                        };
                        _.a = 0;
                        _.b = 0;
                        _.c = -1;
                        var SJ = sfb(Bve, 'ArrayDeque/IteratorImpl', 459);
                        feb(13, 56, Cxe, bnb, cnb, dnb);
                        _.bd = function enb(a, b) {
                            Qmb(this, a, b);
                        };
                        _.Fc = function fnb(a) {
                            return Rmb(this, a);
                        };
                        _.cd = function gnb(a, b) {
                            return Smb(this, a, b);
                        };
                        _.Gc = function hnb(a) {
                            return Tmb(this, a);
                        };
                        _.$b = function inb() {
                            aFb(this.c, 0);
                        };
                        _.Hc = function jnb(a) {
                            return Wmb(this, a, 0) != -1;
                        };
                        _.Jc = function knb(a) {
                            Umb(this, a);
                        };
                        _.Xb = function lnb(a) {
                            return Vmb(this, a);
                        };
                        _.dd = function mnb(a) {
                            return Wmb(this, a, 0);
                        };
                        _.dc = function nnb() {
                            return this.c.length == 0;
                        };
                        _.Kc = function onb() {
                            return new Anb(this);
                        };
                        _.gd = function pnb(a) {
                            return Xmb(this, a);
                        };
                        _.Mc = function qnb(a) {
                            return Ymb(this, a);
                        };
                        _.ce = function rnb(a, b) {
                            Zmb(this, a, b);
                        };
                        _.hd = function snb(a, b) {
                            return $mb(this, a, b);
                        };
                        _.gc = function tnb() {
                            return this.c.length;
                        };
                        _.jd = function unb(a) {
                            _mb(this, a);
                        };
                        _.Pc = function vnb() {
                            return UEb(this.c);
                        };
                        _.Qc = function wnb(a) {
                            return anb(this, a);
                        };
                        var VJ = sfb(Bve, 'ArrayList', 13);
                        feb(7, 1, Ave, Anb);
                        _.Nb = function Bnb(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function Cnb() {
                            return xnb(this);
                        };
                        _.Pb = function Dnb() {
                            return ynb(this);
                        };
                        _.Qb = function Enb() {
                            znb(this);
                        };
                        _.a = 0;
                        _.b = -1;
                        var UJ = sfb(Bve, 'ArrayList/1', 7);
                        feb(2112, $wnd.Function, {}, iob);
                        _.Me = function job(a, b) {
                            return Qfb(a, b);
                        };
                        feb(151, 56, Dxe, mob);
                        _.Hc = function nob(a) {
                            return St(this, a) != -1;
                        };
                        _.Jc = function oob(a) {
                            var b, c, d, e;
                            uFb(a);
                            for(c = this.a, d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                a.Cd(b);
                            }
                        };
                        _.Xb = function pob(a) {
                            return kob(this, a);
                        };
                        _.hd = function qob(a, b) {
                            var c;
                            c = (tFb(a, this.a.length), this.a[a]);
                            bD(this.a, a, b);
                            return c;
                        };
                        _.gc = function rob() {
                            return this.a.length;
                        };
                        _.jd = function sob(a) {
                            Ynb(this.a, this.a.length, a);
                        };
                        _.Pc = function tob() {
                            return lob(this, $C(jJ, rve, 1, this.a.length, 5, 1));
                        };
                        _.Qc = function uob(a) {
                            return lob(this, a);
                        };
                        var WJ = sfb(Bve, 'Arrays/ArrayList', 151);
                        var vob, wob, xob;
                        feb(953, 56, Dxe, Job);
                        _.Hc = function Kob(a) {
                            return false;
                        };
                        _.Xb = function Lob(a) {
                            return Iob(a);
                        };
                        _.Kc = function Mob() {
                            return yob(), Qob(), Pob;
                        };
                        _.ed = function Nob() {
                            return yob(), Qob(), Pob;
                        };
                        _.gc = function Oob() {
                            return 0;
                        };
                        var YJ = sfb(Bve, 'Collections/EmptyList', 953);
                        feb(954, 1, Jve, Rob);
                        _.Nb = function Tob(a) {
                            Ztb(this, a);
                        };
                        _.Rb = function Sob(a) {
                            throw Adb(new jib);
                        };
                        _.Ob = function Uob() {
                            return false;
                        };
                        _.Sb = function Vob() {
                            return false;
                        };
                        _.Pb = function Wob() {
                            throw Adb(new Dvb);
                        };
                        _.Tb = function Xob() {
                            return 0;
                        };
                        _.Ub = function Yob() {
                            throw Adb(new Dvb);
                        };
                        _.Vb = function Zob() {
                            return -1;
                        };
                        _.Qb = function $ob() {
                            throw Adb(new cgb);
                        };
                        _.Wb = function _ob(a) {
                            throw Adb(new cgb);
                        };
                        var Pob;
                        var XJ = sfb(Bve, 'Collections/EmptyListIterator', 954);
                        feb(956, 2065, $ve, apb);
                        _._b = function bpb(a) {
                            return false;
                        };
                        _.uc = function cpb(a) {
                            return false;
                        };
                        _.vc = function dpb() {
                            return yob(), xob;
                        };
                        _.xc = function epb(a) {
                            return null;
                        };
                        _.ec = function fpb() {
                            return yob(), xob;
                        };
                        _.gc = function gpb() {
                            return 0;
                        };
                        _.Cc = function hpb() {
                            return yob(), vob;
                        };
                        var ZJ = sfb(Bve, 'Collections/EmptyMap', 956);
                        feb(955, Eve, awe, ipb);
                        _.Hc = function jpb(a) {
                            return false;
                        };
                        _.Kc = function kpb() {
                            return yob(), Qob(), Pob;
                        };
                        _.gc = function lpb() {
                            return 0;
                        };
                        var $J = sfb(Bve, 'Collections/EmptySet', 955);
                        feb(608, 56, {
                            3: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1
                        }, mpb);
                        _.Hc = function npb(a) {
                            return Fvb(this.a, a);
                        };
                        _.Xb = function opb(a) {
                            tFb(a, 1);
                            return this.a;
                        };
                        _.gc = function ppb() {
                            return 1;
                        };
                        var _J = sfb(Bve, 'Collections/SingletonList', 608);
                        feb(384, 1, Wve, xpb);
                        _.Jc = function Dpb(a) {
                            xgb(this, a);
                        };
                        _.Lc = function Gpb() {
                            return new SDb(null, this.Nc());
                        };
                        _.Nc = function Jpb() {
                            return new Swb(this, 0);
                        };
                        _.Oc = function Kpb() {
                            return new SDb(null, this.Nc());
                        };
                        _.Fc = function ypb(a) {
                            return qpb();
                        };
                        _.Gc = function zpb(a) {
                            return rpb();
                        };
                        _.$b = function Apb() {
                            spb();
                        };
                        _.Hc = function Bpb(a) {
                            return tpb(this, a);
                        };
                        _.Ic = function Cpb(a) {
                            return upb(this, a);
                        };
                        _.dc = function Epb() {
                            return this.b.dc();
                        };
                        _.Kc = function Fpb() {
                            return new Ppb(this.b.Kc());
                        };
                        _.Mc = function Hpb(a) {
                            return vpb();
                        };
                        _.gc = function Ipb() {
                            return this.b.gc();
                        };
                        _.Pc = function Lpb() {
                            return this.b.Pc();
                        };
                        _.Qc = function Mpb(a) {
                            return wpb(this, a);
                        };
                        _.Ib = function Npb() {
                            return jeb(this.b);
                        };
                        var bK = sfb(Bve, 'Collections/UnmodifiableCollection', 384);
                        feb(383, 1, Ave, Ppb);
                        _.Nb = function Qpb(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function Rpb() {
                            return this.b.Ob();
                        };
                        _.Pb = function Spb() {
                            return this.b.Pb();
                        };
                        _.Qb = function Tpb() {
                            Opb();
                        };
                        var aK = sfb(Bve, 'Collections/UnmodifiableCollectionIterator', 383);
                        feb(540, 384, Exe, Upb);
                        _.Nc = function fqb() {
                            return new Swb(this, 16);
                        };
                        _.bd = function Vpb(a, b) {
                            throw Adb(new jib);
                        };
                        _.cd = function Wpb(a, b) {
                            throw Adb(new jib);
                        };
                        _.Fb = function Xpb(a) {
                            return pb(this.a, a);
                        };
                        _.Xb = function Ypb(a) {
                            return this.a.Xb(a);
                        };
                        _.Hb = function Zpb() {
                            return tb(this.a);
                        };
                        _.dd = function $pb(a) {
                            return this.a.dd(a);
                        };
                        _.dc = function _pb() {
                            return this.a.dc();
                        };
                        _.ed = function aqb() {
                            return new hqb(this.a.fd(0));
                        };
                        _.fd = function bqb(a) {
                            return new hqb(this.a.fd(a));
                        };
                        _.gd = function cqb(a) {
                            throw Adb(new jib);
                        };
                        _.hd = function dqb(a, b) {
                            throw Adb(new jib);
                        };
                        _.jd = function eqb(a) {
                            throw Adb(new jib);
                        };
                        _.kd = function gqb(a, b) {
                            return new Upb(this.a.kd(a, b));
                        };
                        var dK = sfb(Bve, 'Collections/UnmodifiableList', 540);
                        feb(705, 383, Jve, hqb);
                        _.Qb = function nqb() {
                            Opb();
                        };
                        _.Rb = function iqb(a) {
                            throw Adb(new jib);
                        };
                        _.Sb = function jqb() {
                            return this.a.Sb();
                        };
                        _.Tb = function kqb() {
                            return this.a.Tb();
                        };
                        _.Ub = function lqb() {
                            return this.a.Ub();
                        };
                        _.Vb = function mqb() {
                            return this.a.Vb();
                        };
                        _.Wb = function oqb(a) {
                            throw Adb(new jib);
                        };
                        var cK = sfb(Bve, 'Collections/UnmodifiableListIterator', 705);
                        feb(609, 1, Cve, uqb);
                        _.wc = function Aqb(a) {
                            Bvb(this, a);
                        };
                        _.yc = function Fqb(a, b, c) {
                            return Cvb(this, a, b, c);
                        };
                        _.$b = function vqb() {
                            throw Adb(new jib);
                        };
                        _._b = function wqb(a) {
                            return this.c._b(a);
                        };
                        _.uc = function xqb(a) {
                            return pqb(this, a);
                        };
                        _.vc = function yqb() {
                            return qqb(this);
                        };
                        _.Fb = function zqb(a) {
                            return rqb(this, a);
                        };
                        _.xc = function Bqb(a) {
                            return this.c.xc(a);
                        };
                        _.Hb = function Cqb() {
                            return tb(this.c);
                        };
                        _.dc = function Dqb() {
                            return this.c.dc();
                        };
                        _.ec = function Eqb() {
                            return sqb(this);
                        };
                        _.zc = function Gqb(a, b) {
                            throw Adb(new jib);
                        };
                        _.Bc = function Hqb(a) {
                            throw Adb(new jib);
                        };
                        _.gc = function Iqb() {
                            return this.c.gc();
                        };
                        _.Ib = function Jqb() {
                            return jeb(this.c);
                        };
                        _.Cc = function Kqb() {
                            return tqb(this);
                        };
                        var hK = sfb(Bve, 'Collections/UnmodifiableMap', 609);
                        feb(396, 384, _ve, Lqb);
                        _.Nc = function Oqb() {
                            return new Swb(this, 1);
                        };
                        _.Fb = function Mqb(a) {
                            return pb(this.b, a);
                        };
                        _.Hb = function Nqb() {
                            return tb(this.b);
                        };
                        var jK = sfb(Bve, 'Collections/UnmodifiableSet', 396);
                        feb(957, 396, _ve, Sqb);
                        _.Hc = function Tqb(a) {
                            return Pqb(this, a);
                        };
                        _.Ic = function Uqb(a) {
                            return this.b.Ic(a);
                        };
                        _.Kc = function Vqb() {
                            var a;
                            a = this.b.Kc();
                            return new Yqb(a);
                        };
                        _.Pc = function Wqb() {
                            var a;
                            a = this.b.Pc();
                            Rqb(a, a.length);
                            return a;
                        };
                        _.Qc = function Xqb(a) {
                            return Qqb(this, a);
                        };
                        var gK = sfb(Bve, 'Collections/UnmodifiableMap/UnmodifiableEntrySet', 957);
                        feb(958, 1, Ave, Yqb);
                        _.Nb = function Zqb(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function _qb() {
                            return new brb(RD(this.a.Pb(), 44));
                        };
                        _.Ob = function $qb() {
                            return this.a.Ob();
                        };
                        _.Qb = function arb() {
                            throw Adb(new jib);
                        };
                        var eK = sfb(Bve, 'Collections/UnmodifiableMap/UnmodifiableEntrySet/1', 958);
                        feb(703, 1, Axe, brb);
                        _.Fb = function crb(a) {
                            return this.a.Fb(a);
                        };
                        _.ld = function drb() {
                            return this.a.ld();
                        };
                        _.md = function erb() {
                            return this.a.md();
                        };
                        _.Hb = function frb() {
                            return this.a.Hb();
                        };
                        _.nd = function grb(a) {
                            throw Adb(new jib);
                        };
                        _.Ib = function hrb() {
                            return jeb(this.a);
                        };
                        var fK = sfb(Bve, 'Collections/UnmodifiableMap/UnmodifiableEntrySet/UnmodifiableEntry', 703);
                        feb(610, 540, {
                            20: 1,
                            16: 1,
                            15: 1,
                            59: 1
                        }, irb);
                        var iK = sfb(Bve, 'Collections/UnmodifiableRandomAccessList', 610);
                        feb(704, 396, bwe, jrb);
                        _.Nc = function mrb() {
                            return new $wb(this);
                        };
                        _.Fb = function krb(a) {
                            return pb(this.a, a);
                        };
                        _.Hb = function lrb() {
                            return tb(this.a);
                        };
                        var kK = sfb(Bve, 'Collections/UnmodifiableSortedSet', 704);
                        feb(858, 1, Fxe, nrb);
                        _.Ne = function orb(a, b) {
                            var c;
                            return c = ygc(RD(a, 12), RD(b, 12)), c != 0 ? c : zgc(RD(a, 12), RD(b, 12));
                        };
                        _.Fb = function prb(a) {
                            return this === a;
                        };
                        _.Oe = function qrb() {
                            return new Frb(this);
                        };
                        var lK = sfb(Bve, 'Comparator/lambda$0$Type', 858);
                        var rrb, srb, trb;
                        feb(769, 1, Fxe, wrb);
                        _.Ne = function xrb(a, b) {
                            return vrb(RD(a, 34), RD(b, 34));
                        };
                        _.Fb = function yrb(a) {
                            return this === a;
                        };
                        _.Oe = function zrb() {
                            return urb(), trb;
                        };
                        var mK = sfb(Bve, 'Comparators/NaturalOrderComparator', 769);
                        feb(1226, 1, Fxe, Brb);
                        _.Ne = function Crb(a, b) {
                            return Arb(RD(a, 34), RD(b, 34));
                        };
                        _.Fb = function Drb(a) {
                            return this === a;
                        };
                        _.Oe = function Erb() {
                            return urb(), srb;
                        };
                        var nK = sfb(Bve, 'Comparators/ReverseNaturalOrderComparator', 1226);
                        feb(52, 1, Fxe, Frb);
                        _.Fb = function Hrb(a) {
                            return this === a;
                        };
                        _.Ne = function Grb(a, b) {
                            return this.a.Ne(b, a);
                        };
                        _.Oe = function Irb() {
                            return this.a;
                        };
                        var oK = sfb(Bve, 'Comparators/ReversedComparator', 52);
                        feb(175, 63, swe, Jrb);
                        var pK = sfb(Bve, 'ConcurrentModificationException', 175);
                        var Krb, Lrb;
                        feb(1948, 1, Gxe, Prb);
                        _.Pe = function Qrb(a) {
                            Nrb(this, a);
                        };
                        _.Ib = function Rrb() {
                            return 'DoubleSummaryStatistics[count = ' + Zdb(this.a) + ', avg = ' + (Idb(this.a, 0) ? Orb(this) / Xdb(this.a) : 0) + ', min = ' + this.c + ', max = ' + this.b + ', sum = ' + Orb(this) + ']';
                        };
                        _.a = 0;
                        _.b = pxe;
                        _.c = oxe;
                        _.d = 0;
                        _.e = 0;
                        _.f = 0;
                        var rK = sfb(Bve, 'DoubleSummaryStatistics', 1948);
                        feb(1868, 63, swe, Srb);
                        var sK = sfb(Bve, 'EmptyStackException', 1868);
                        feb(461, 2065, Cve, Zrb);
                        _.zc = function dsb(a, b) {
                            return Xrb(this, a, b);
                        };
                        _.$b = function $rb() {
                            Trb(this);
                        };
                        _._b = function _rb(a) {
                            return Urb(this, a);
                        };
                        _.uc = function asb(a) {
                            var b, c;
                            for(c = new Osb(this.a); c.a < c.c.a.length;){
                                b = Nsb(c);
                                if (Fvb(a, this.b[b.g])) return true;
                            }
                            return false;
                        };
                        _.vc = function bsb() {
                            return new hsb(this);
                        };
                        _.xc = function csb(a) {
                            return Vrb(this, a);
                        };
                        _.Bc = function esb(a) {
                            return Yrb(this, a);
                        };
                        _.gc = function fsb() {
                            return this.a.c;
                        };
                        var wK = sfb(Bve, 'EnumMap', 461);
                        feb(1340, Eve, Fve, hsb);
                        _.$b = function isb() {
                            Trb(this.a);
                        };
                        _.Hc = function jsb(a) {
                            return gsb(this, a);
                        };
                        _.Kc = function ksb() {
                            return new nsb(this.a);
                        };
                        _.Mc = function lsb(a) {
                            var b;
                            if (gsb(this, a)) {
                                b = RD(a, 44).ld();
                                Yrb(this.a, b);
                                return true;
                            }
                            return false;
                        };
                        _.gc = function msb() {
                            return this.a.a.c;
                        };
                        var uK = sfb(Bve, 'EnumMap/EntrySet', 1340);
                        feb(1341, 1, Ave, nsb);
                        _.Nb = function osb(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function qsb() {
                            return this.b = Nsb(this.a), new ssb(this.c, this.b);
                        };
                        _.Ob = function psb() {
                            return Msb(this.a);
                        };
                        _.Qb = function rsb() {
                            yFb(!!this.b);
                            Yrb(this.c, this.b);
                            this.b = null;
                        };
                        var tK = sfb(Bve, 'EnumMap/EntrySetIterator', 1341);
                        feb(1342, 2082, Axe, ssb);
                        _.ld = function tsb() {
                            return this.a;
                        };
                        _.md = function usb() {
                            return this.b.b[this.a.g];
                        };
                        _.nd = function vsb(a) {
                            return _Eb(this.b.b, this.a.g, a);
                        };
                        var vK = sfb(Bve, 'EnumMap/MapEntry', 1342);
                        feb(181, Eve, {
                            20: 1,
                            31: 1,
                            16: 1,
                            181: 1,
                            21: 1
                        });
                        var zK = sfb(Bve, 'EnumSet', 181);
                        feb(162, 181, {
                            20: 1,
                            31: 1,
                            16: 1,
                            181: 1,
                            162: 1,
                            21: 1
                        }, Fsb);
                        _.Fc = function Gsb(a) {
                            return zsb(this, RD(a, 22));
                        };
                        _.Hc = function Hsb(a) {
                            return Bsb(this, a);
                        };
                        _.Kc = function Isb() {
                            return new Osb(this);
                        };
                        _.Mc = function Jsb(a) {
                            return Dsb(this, a);
                        };
                        _.gc = function Ksb() {
                            return this.c;
                        };
                        _.c = 0;
                        var yK = sfb(Bve, 'EnumSet/EnumSetImpl', 162);
                        feb(356, 1, Ave, Osb);
                        _.Nb = function Psb(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function Rsb() {
                            return Nsb(this);
                        };
                        _.Ob = function Qsb() {
                            return Msb(this);
                        };
                        _.Qb = function Ssb() {
                            yFb(this.b != -1);
                            bD(this.c.b, this.b, null);
                            --this.c.c;
                            this.b = -1;
                        };
                        _.a = -1;
                        _.b = -1;
                        var xK = sfb(Bve, 'EnumSet/EnumSetImpl/IteratorImpl', 356);
                        feb(45, 498, Hxe, Tsb, Usb, Vsb);
                        _.Be = function Wsb(a, b) {
                            return dE(a) === dE(b) || a != null && pb(a, b);
                        };
                        _.Ce = function Xsb(a) {
                            var b;
                            if (a == null) return 0;
                            b = tb(a);
                            return b | 0;
                        };
                        var AK = sfb(Bve, 'HashMap', 45);
                        feb(49, Eve, Ixe, _sb, atb, btb);
                        _.Fc = function dtb(a) {
                            return Ysb(this, a);
                        };
                        _.$b = function etb() {
                            this.a.$b();
                        };
                        _.Hc = function ftb(a) {
                            return Zsb(this, a);
                        };
                        _.dc = function gtb() {
                            return this.a.gc() == 0;
                        };
                        _.Kc = function htb() {
                            return this.a.ec().Kc();
                        };
                        _.Mc = function itb(a) {
                            return $sb(this, a);
                        };
                        _.gc = function jtb() {
                            return this.a.gc();
                        };
                        var BK = sfb(Bve, 'HashSet', 49);
                        feb(1897, 1, Rve, ltb);
                        _.Dd = function mtb(a) {
                            ktb(this, a);
                        };
                        _.Ib = function ntb() {
                            return 'IntSummaryStatistics[count = ' + Zdb(this.a) + ', avg = ' + (Idb(this.a, 0) ? Xdb(this.d) / Xdb(this.a) : 0) + ', min = ' + this.c + ', max = ' + this.b + ', sum = ' + Zdb(this.d) + ']';
                        };
                        _.a = 0;
                        _.b = qwe;
                        _.c = lve;
                        _.d = 0;
                        var CK = sfb(Bve, 'IntSummaryStatistics', 1897);
                        feb(1062, 1, Vve, ttb);
                        _.Jc = function utb(a) {
                            xgb(this, a);
                        };
                        _.Kc = function vtb() {
                            return new wtb(this);
                        };
                        _.c = 0;
                        var EK = sfb(Bve, 'InternalHashCodeMap', 1062);
                        feb(726, 1, Ave, wtb);
                        _.Nb = function xtb(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function ztb() {
                            return this.d = this.a[this.c++], this.d;
                        };
                        _.Ob = function ytb() {
                            var a;
                            if (this.c < this.a.length) return true;
                            a = this.b.next();
                            if (!a.done) {
                                this.a = a.value[1];
                                this.c = 0;
                                return true;
                            }
                            return false;
                        };
                        _.Qb = function Atb() {
                            stb(this.e, this.d.ld());
                            this.c != 0 && --this.c;
                        };
                        _.c = 0;
                        _.d = null;
                        var DK = sfb(Bve, 'InternalHashCodeMap/1', 726);
                        var Dtb;
                        feb(1060, 1, Vve, Ntb);
                        _.Jc = function Otb(a) {
                            xgb(this, a);
                        };
                        _.Kc = function Ptb() {
                            return new Qtb(this);
                        };
                        _.c = 0;
                        _.d = 0;
                        var HK = sfb(Bve, 'InternalStringMap', 1060);
                        feb(725, 1, Ave, Qtb);
                        _.Nb = function Rtb(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function Ttb() {
                            return this.c = this.a, this.a = this.b.next(), new Vtb(this.d, this.c, this.d.d);
                        };
                        _.Ob = function Stb() {
                            return !this.a.done;
                        };
                        _.Qb = function Utb() {
                            Mtb(this.d, this.c.value[0]);
                        };
                        var FK = sfb(Bve, 'InternalStringMap/1', 725);
                        feb(1061, 2082, Axe, Vtb);
                        _.ld = function Wtb() {
                            return this.b.value[0];
                        };
                        _.md = function Xtb() {
                            if (this.a.d != this.c) return Ktb(this.a, this.b.value[0]);
                            return this.b.value[1];
                        };
                        _.nd = function Ytb(a) {
                            return Ltb(this.a, this.b.value[0], a);
                        };
                        _.c = 0;
                        var GK = sfb(Bve, 'InternalStringMap/2', 1061);
                        feb(215, 45, Hxe, gub, hub);
                        _.$b = function iub() {
                            aub(this);
                        };
                        _._b = function jub(a) {
                            return bub(this, a);
                        };
                        _.uc = function kub(a) {
                            var b;
                            b = this.d.a;
                            while(b != this.d){
                                if (Fvb(b.e, a)) return true;
                                b = b.a;
                            }
                            return false;
                        };
                        _.vc = function lub() {
                            return new wub(this);
                        };
                        _.xc = function mub(a) {
                            return cub(this, a);
                        };
                        _.zc = function nub(a, b) {
                            return dub(this, a, b);
                        };
                        _.Bc = function oub(a) {
                            return fub(this, a);
                        };
                        _.gc = function pub() {
                            return bkb(this.e);
                        };
                        _.c = false;
                        var LK = sfb(Bve, 'LinkedHashMap', 215);
                        feb(400, 397, {
                            494: 1,
                            397: 1,
                            400: 1,
                            44: 1
                        }, tub, uub);
                        var IK = sfb(Bve, 'LinkedHashMap/ChainEntry', 400);
                        feb(715, Eve, Fve, wub);
                        _.$b = function xub() {
                            aub(this.a);
                        };
                        _.Hc = function yub(a) {
                            return vub(this, a);
                        };
                        _.Kc = function zub() {
                            return new Dub(this);
                        };
                        _.Mc = function Aub(a) {
                            var b;
                            if (vub(this, a)) {
                                b = RD(a, 44).ld();
                                fub(this.a, b);
                                return true;
                            }
                            return false;
                        };
                        _.gc = function Bub() {
                            return bkb(this.a.e);
                        };
                        var KK = sfb(Bve, 'LinkedHashMap/EntrySet', 715);
                        feb(716, 1, Ave, Dub);
                        _.Nb = function Eub(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function Gub() {
                            return Cub(this);
                        };
                        _.Ob = function Fub() {
                            return this.c != this.d.a.d;
                        };
                        _.Qb = function Hub() {
                            yFb(!!this.a);
                            rFb(this.d.a.e.g, this.b);
                            rub(this.a);
                            _jb(this.d.a.e, this.a.d);
                            this.b = this.d.a.e.g;
                            this.a = null;
                        };
                        _.b = 0;
                        var JK = sfb(Bve, 'LinkedHashMap/EntrySet/EntryIterator', 716);
                        feb(174, 49, Ixe, Iub, Jub, Kub);
                        var MK = sfb(Bve, 'LinkedHashSet', 174);
                        feb(67, 2062, {
                            3: 1,
                            4: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            67: 1,
                            15: 1
                        }, Yub, Zub);
                        _.Fc = function $ub(a) {
                            return Mub(this, a);
                        };
                        _.$b = function _ub() {
                            Xub(this);
                        };
                        _.fd = function avb(a) {
                            return Sub(this, a);
                        };
                        _.gc = function bvb() {
                            return this.b;
                        };
                        _.b = 0;
                        var PK = sfb(Bve, 'LinkedList', 67);
                        feb(981, 1, Jve, hvb);
                        _.Nb = function jvb(a) {
                            Ztb(this, a);
                        };
                        _.Rb = function ivb(a) {
                            cvb(this, a);
                        };
                        _.Ob = function kvb() {
                            return dvb(this);
                        };
                        _.Sb = function lvb() {
                            return this.b.b != this.d.a;
                        };
                        _.Pb = function mvb() {
                            return evb(this);
                        };
                        _.Tb = function nvb() {
                            return this.a;
                        };
                        _.Ub = function ovb() {
                            return fvb(this);
                        };
                        _.Vb = function pvb() {
                            return this.a - 1;
                        };
                        _.Qb = function qvb() {
                            gvb(this);
                        };
                        _.Wb = function rvb(a) {
                            yFb(!!this.c);
                            this.c.c = a;
                        };
                        _.a = 0;
                        _.c = null;
                        var NK = sfb(Bve, 'LinkedList/ListIteratorImpl', 981);
                        feb(617, 1, {}, svb);
                        var OK = sfb(Bve, 'LinkedList/Node', 617);
                        feb(2057, 1, {});
                        var uvb, vvb;
                        var TK = sfb(Bve, 'Locale', 2057);
                        feb(873, 2057, {}, xvb);
                        _.Ib = function yvb() {
                            return '';
                        };
                        var RK = sfb(Bve, 'Locale/1', 873);
                        feb(874, 2057, {}, zvb);
                        _.Ib = function Avb() {
                            return 'unknown';
                        };
                        var SK = sfb(Bve, 'Locale/4', 874);
                        feb(112, 63, {
                            3: 1,
                            103: 1,
                            63: 1,
                            82: 1,
                            112: 1
                        }, Dvb, Evb);
                        var WK = sfb(Bve, 'NoSuchElementException', 112);
                        feb(475, 1, {
                            475: 1
                        }, Ovb);
                        _.Fb = function Pvb(a) {
                            var b;
                            if (a === this) return true;
                            if (!ZD(a, 475)) return false;
                            b = RD(a, 475);
                            return Fvb(this.a, b.a);
                        };
                        _.Hb = function Qvb() {
                            return Gvb(this.a);
                        };
                        _.Ib = function Rvb() {
                            return this.a != null ? uve + Ghb(this.a) + ')' : 'Optional.empty()';
                        };
                        var Jvb;
                        var ZK = sfb(Bve, 'Optional', 475);
                        feb(414, 1, {
                            414: 1
                        }, Xvb, Yvb);
                        _.Fb = function Zvb(a) {
                            var b;
                            if (a === this) return true;
                            if (!ZD(a, 414)) return false;
                            b = RD(a, 414);
                            return this.a == b.a && Qfb(this.b, b.b) == 0;
                        };
                        _.Hb = function $vb() {
                            return this.a ? eE(this.b) : 0;
                        };
                        _.Ib = function _vb() {
                            return this.a ? 'OptionalDouble.of(' + ('' + this.b) + ')' : 'OptionalDouble.empty()';
                        };
                        _.a = false;
                        _.b = 0;
                        var Svb;
                        var XK = sfb(Bve, 'OptionalDouble', 414);
                        feb(524, 1, {
                            524: 1
                        }, dwb, ewb);
                        _.Fb = function fwb(a) {
                            var b;
                            if (a === this) return true;
                            if (!ZD(a, 524)) return false;
                            b = RD(a, 524);
                            return this.a == b.a && hgb(this.b, b.b) == 0;
                        };
                        _.Hb = function gwb() {
                            return this.a ? this.b : 0;
                        };
                        _.Ib = function hwb() {
                            return this.a ? 'OptionalInt.of(' + ('' + this.b) + ')' : 'OptionalInt.empty()';
                        };
                        _.a = false;
                        _.b = 0;
                        var awb;
                        var YK = sfb(Bve, 'OptionalInt', 524);
                        feb(510, 2103, Dve, pwb);
                        _.Gc = function qwb(a) {
                            return iwb(this, a);
                        };
                        _.$b = function rwb() {
                            aFb(this.b.c, 0);
                        };
                        _.Hc = function swb(a) {
                            return (a == null ? -1 : Wmb(this.b, a, 0)) != -1;
                        };
                        _.Kc = function twb() {
                            return new zwb(this);
                        };
                        _.Mc = function uwb(a) {
                            return nwb(this, a);
                        };
                        _.gc = function vwb() {
                            return this.b.c.length;
                        };
                        _.Nc = function wwb() {
                            return new Swb(this, 256);
                        };
                        _.Pc = function xwb() {
                            return UEb(this.b.c);
                        };
                        _.Qc = function ywb(a) {
                            return anb(this.b, a);
                        };
                        var _K = sfb(Bve, 'PriorityQueue', 510);
                        feb(1296, 1, Ave, zwb);
                        _.Nb = function Awb(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function Bwb() {
                            return this.a < this.c.b.c.length;
                        };
                        _.Pb = function Cwb() {
                            sFb(this.a < this.c.b.c.length);
                            this.b = this.a++;
                            return Vmb(this.c.b, this.b);
                        };
                        _.Qb = function Dwb() {
                            yFb(this.b != -1);
                            owb(this.c, this.a = this.b);
                            this.b = -1;
                        };
                        _.a = 0;
                        _.b = -1;
                        var $K = sfb(Bve, 'PriorityQueue/1', 1296);
                        feb(234, 1, {
                            234: 1
                        }, Owb, Pwb);
                        _.a = 0;
                        _.b = 0;
                        var Ewb, Fwb, Gwb = 0;
                        var aL = sfb(Bve, 'Random', 234);
                        feb(25, 1, Pve, Swb, Twb, Uwb);
                        _.Ad = function Ywb(a) {
                            return (this.a & a) != 0;
                        };
                        _.yd = function Vwb() {
                            return this.a;
                        };
                        _.zd = function Wwb() {
                            Qwb(this);
                            return this.c;
                        };
                        _.Nb = function Xwb(a) {
                            Qwb(this);
                            this.d.Nb(a);
                        };
                        _.Bd = function Zwb(a) {
                            return Rwb(this, a);
                        };
                        _.a = 0;
                        _.c = 0;
                        var qL = sfb(Bve, 'Spliterators/IteratorSpliterator', 25);
                        feb(495, 25, Pve, $wb);
                        var cL = sfb(Bve, 'SortedSet/1', 495);
                        feb(611, 1, Gxe, axb);
                        _.Pe = function bxb(a) {
                            this.a.Cd(a);
                        };
                        var dL = sfb(Bve, 'Spliterator/OfDouble/0methodref$accept$Type', 611);
                        feb(612, 1, Gxe, cxb);
                        _.Pe = function dxb(a) {
                            this.a.Cd(a);
                        };
                        var eL = sfb(Bve, 'Spliterator/OfDouble/1methodref$accept$Type', 612);
                        feb(613, 1, Rve, exb);
                        _.Dd = function fxb(a) {
                            this.a.Cd(sgb(a));
                        };
                        var fL = sfb(Bve, 'Spliterator/OfInt/2methodref$accept$Type', 613);
                        feb(614, 1, Rve, gxb);
                        _.Dd = function hxb(a) {
                            this.a.Cd(sgb(a));
                        };
                        var gL = sfb(Bve, 'Spliterator/OfInt/3methodref$accept$Type', 614);
                        feb(625, 1, Pve);
                        _.Nb = function nxb(a) {
                            _wb(this, a);
                        };
                        _.Ad = function oxb(a) {
                            return (this.d & a) != 0;
                        };
                        _.yd = function lxb() {
                            return this.d;
                        };
                        _.zd = function mxb() {
                            return this.e;
                        };
                        _.d = 0;
                        _.e = 0;
                        var mL = sfb(Bve, 'Spliterators/BaseSpliterator', 625);
                        feb(736, 625, Pve);
                        _.Qe = function qxb(a) {
                            ixb(this, a);
                        };
                        _.Nb = function rxb(a) {
                            ZD(a, 189) ? ixb(this, RD(a, 189)) : ixb(this, new cxb(a));
                        };
                        _.Bd = function sxb(a) {
                            return ZD(a, 189) ? this.Re(RD(a, 189)) : this.Re(new axb(a));
                        };
                        var hL = sfb(Bve, 'Spliterators/AbstractDoubleSpliterator', 736);
                        feb(735, 625, Pve);
                        _.Qe = function uxb(a) {
                            ixb(this, a);
                        };
                        _.Nb = function vxb(a) {
                            ZD(a, 202) ? ixb(this, RD(a, 202)) : ixb(this, new gxb(a));
                        };
                        _.Bd = function wxb(a) {
                            return ZD(a, 202) ? this.Re(RD(a, 202)) : this.Re(new exb(a));
                        };
                        var iL = sfb(Bve, 'Spliterators/AbstractIntSpliterator', 735);
                        feb(500, 625, Pve);
                        var jL = sfb(Bve, 'Spliterators/AbstractSpliterator', 500);
                        feb(706, 1, Pve);
                        _.Nb = function Dxb(a) {
                            _wb(this, a);
                        };
                        _.Ad = function Exb(a) {
                            return (this.b & a) != 0;
                        };
                        _.yd = function Bxb() {
                            return this.b;
                        };
                        _.zd = function Cxb() {
                            return this.d - this.c;
                        };
                        _.b = 0;
                        _.c = 0;
                        _.d = 0;
                        var lL = sfb(Bve, 'Spliterators/BaseArraySpliterator', 706);
                        feb(960, 706, Pve, Gxb);
                        _.Se = function Hxb(a, b) {
                            Fxb(this, RD(a, 41), b);
                        };
                        _.Nb = function Ixb(a) {
                            yxb(this, a);
                        };
                        _.Bd = function Jxb(a) {
                            return zxb(this, a);
                        };
                        var kL = sfb(Bve, 'Spliterators/ArraySpliterator', 960);
                        feb(707, 706, Pve, Lxb);
                        _.Se = function Nxb(a, b) {
                            Kxb(this, RD(a, 189), b);
                        };
                        _.Qe = function Oxb(a) {
                            yxb(this, a);
                        };
                        _.Nb = function Pxb(a) {
                            ZD(a, 189) ? yxb(this, RD(a, 189)) : yxb(this, new cxb(a));
                        };
                        _.Re = function Qxb(a) {
                            return zxb(this, a);
                        };
                        _.Bd = function Rxb(a) {
                            return ZD(a, 189) ? zxb(this, RD(a, 189)) : zxb(this, new axb(a));
                        };
                        var nL = sfb(Bve, 'Spliterators/DoubleArraySpliterator', 707);
                        feb(2066, 1, Pve);
                        _.Nb = function Wxb(a) {
                            _wb(this, a);
                        };
                        _.Ad = function Xxb(a) {
                            return (16448 & a) != 0;
                        };
                        _.yd = function Uxb() {
                            return 16448;
                        };
                        _.zd = function Vxb() {
                            return 0;
                        };
                        var Sxb;
                        var pL = sfb(Bve, 'Spliterators/EmptySpliterator', 2066);
                        feb(959, 2066, Pve, $xb);
                        _.Qe = function _xb(a) {
                            Yxb(a);
                        };
                        _.Nb = function ayb(a) {
                            ZD(a, 202) ? Yxb(RD(a, 202)) : Yxb(new gxb(a));
                        };
                        _.Re = function byb(a) {
                            return Zxb(a);
                        };
                        _.Bd = function cyb(a) {
                            return ZD(a, 202) ? Zxb(RD(a, 202)) : Zxb(new exb(a));
                        };
                        var oL = sfb(Bve, 'Spliterators/EmptySpliterator/OfInt', 959);
                        feb(588, 56, Rxe, gyb);
                        _.bd = function hyb(a, b) {
                            lyb(a, this.a.c.length + 1);
                            Qmb(this.a, a, b);
                        };
                        _.Fc = function iyb(a) {
                            return Rmb(this.a, a);
                        };
                        _.cd = function jyb(a, b) {
                            lyb(a, this.a.c.length + 1);
                            return Smb(this.a, a, b);
                        };
                        _.Gc = function kyb(a) {
                            return Tmb(this.a, a);
                        };
                        _.$b = function myb() {
                            aFb(this.a.c, 0);
                        };
                        _.Hc = function nyb(a) {
                            return Wmb(this.a, a, 0) != -1;
                        };
                        _.Ic = function oyb(a) {
                            return Be(this.a, a);
                        };
                        _.Jc = function pyb(a) {
                            Umb(this.a, a);
                        };
                        _.Xb = function qyb(a) {
                            return lyb(a, this.a.c.length), Vmb(this.a, a);
                        };
                        _.dd = function ryb(a) {
                            return Wmb(this.a, a, 0);
                        };
                        _.dc = function syb() {
                            return this.a.c.length == 0;
                        };
                        _.Kc = function tyb() {
                            return new Anb(this.a);
                        };
                        _.gd = function uyb(a) {
                            return lyb(a, this.a.c.length), Xmb(this.a, a);
                        };
                        _.ce = function vyb(a, b) {
                            Zmb(this.a, a, b);
                        };
                        _.hd = function wyb(a, b) {
                            return lyb(a, this.a.c.length), $mb(this.a, a, b);
                        };
                        _.gc = function xyb() {
                            return this.a.c.length;
                        };
                        _.jd = function yyb(a) {
                            _mb(this.a, a);
                        };
                        _.kd = function zyb(a, b) {
                            return new Rkb(this.a, a, b);
                        };
                        _.Pc = function Ayb() {
                            return UEb(this.a.c);
                        };
                        _.Qc = function Byb(a) {
                            return anb(this.a, a);
                        };
                        _.Ib = function Cyb() {
                            return Fe(this.a);
                        };
                        var EL = sfb(Bve, 'Vector', 588);
                        feb(824, 588, Rxe, Fyb);
                        var rL = sfb(Bve, 'Stack', 824);
                        feb(213, 1, {
                            213: 1
                        }, Jyb);
                        _.Ib = function Kyb() {
                            return Iyb(this);
                        };
                        var sL = sfb(Bve, 'StringJoiner', 213);
                        feb(553, 2090, {
                            3: 1,
                            85: 1,
                            139: 1,
                            133: 1
                        }, dzb, ezb);
                        _.$b = function fzb() {
                            Lyb(this);
                        };
                        _.De = function gzb() {
                            return new xzb(this);
                        };
                        _.vc = function hzb() {
                            return new Dzb(this);
                        };
                        _.Ee = function izb(a) {
                            return Pyb(this, a, true);
                        };
                        _.Fe = function jzb(a) {
                            return Myb(this, a);
                        };
                        _.Ge = function kzb() {
                            return Nyb(this);
                        };
                        _.He = function lzb(a) {
                            return Qyb(this, a, true);
                        };
                        _.Ie = function mzb(a) {
                            return Pyb(this, a, false);
                        };
                        _.Je = function nzb() {
                            return Oyb(this);
                        };
                        _.Ke = function ozb(a) {
                            return Qyb(this, a, false);
                        };
                        _.Zc = function pzb(a, b) {
                            return Ryb(this, a, b);
                        };
                        _.zc = function qzb(a, b) {
                            return Wyb(this, a, b);
                        };
                        _.Bc = function rzb(a) {
                            return Xyb(this, a);
                        };
                        _.Le = function szb(a) {
                            return Yyb(this, a);
                        };
                        _.gc = function tzb() {
                            return this.c;
                        };
                        _.ad = function uzb(a, b) {
                            return czb(this, a, b);
                        };
                        _.c = 0;
                        var CL = sfb(Bve, 'TreeMap', 553);
                        feb(554, 1, Ave, xzb, yzb);
                        _.Nb = function zzb(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function Bzb() {
                            return vzb(this);
                        };
                        _.Ob = function Azb() {
                            return Akb(this.a);
                        };
                        _.Qb = function Czb() {
                            wzb(this);
                        };
                        var tL = sfb(Bve, 'TreeMap/EntryIterator', 554);
                        feb(1142, 629, Fve, Dzb);
                        _.$b = function Ezb() {
                            Lyb(this.a);
                        };
                        var uL = sfb(Bve, 'TreeMap/EntrySet', 1142);
                        feb(447, 397, {
                            494: 1,
                            397: 1,
                            44: 1,
                            447: 1
                        }, Fzb);
                        _.b = false;
                        var vL = sfb(Bve, 'TreeMap/Node', 447);
                        feb(630, 1, {}, Gzb);
                        _.Ib = function Hzb() {
                            return 'State: mv=' + this.c + ' value=' + this.d + ' done=' + this.a + ' found=' + this.b;
                        };
                        _.a = false;
                        _.b = false;
                        _.c = false;
                        var wL = sfb(Bve, 'TreeMap/State', 630);
                        feb(631, 2090, Gve, Kzb);
                        _.De = function Lzb() {
                            return new yzb(this.c, this.f, this.b, this.a, this.e, this.d);
                        };
                        _.vc = function Mzb() {
                            return new Plb(this);
                        };
                        _.Ee = function Nzb(a) {
                            return Izb(this, Pyb(this.c, a, true));
                        };
                        _.Fe = function Ozb(a) {
                            return Izb(this, Myb(this.c, a));
                        };
                        _.Ge = function Pzb() {
                            var a;
                            return this.f.Te() ? this.a ? a = Pyb(this.c, this.b, true) : a = Pyb(this.c, this.b, false) : a = Nyb(this.c), !!a && Jzb(this, a.d) ? a : null;
                        };
                        _.He = function Qzb(a) {
                            return Izb(this, Qyb(this.c, a, true));
                        };
                        _.Ie = function Rzb(a) {
                            return Izb(this, Pyb(this.c, a, false));
                        };
                        _.Je = function Szb() {
                            var a;
                            this.f.Ue() ? this.d ? a = Qyb(this.c, this.e, true) : a = Qyb(this.c, this.e, false) : a = Oyb(this.c);
                            return !!a && Jzb(this, a.d) ? a : null;
                        };
                        _.Ke = function Tzb(a) {
                            return Izb(this, Qyb(this.c, a, false));
                        };
                        _.Zc = function Uzb(a, b) {
                            if (this.f.Ue() && this.c.a.Ne(a, this.e) > 0) throw Adb(new agb(Sxe + a + ' greater than ' + this.e));
                            return this.f.Te() ? bzb(this.c, this.b, this.a, a, b) : Ryb(this.c, a, b);
                        };
                        _.zc = function Vzb(a, b) {
                            if (!Tyb(this.c, this.f, a, this.b, this.a, this.e, this.d)) throw Adb(new agb(a + ' outside the range ' + this.b + ' to ' + this.e));
                            return Wyb(this.c, a, b);
                        };
                        _.Bc = function Wzb(a) {
                            var b;
                            b = a;
                            if (!Tyb(this.c, this.f, b, this.b, this.a, this.e, this.d)) return null;
                            return Xyb(this.c, b);
                        };
                        _.Le = function Xzb(a) {
                            return Jzb(this, a.ld()) && Yyb(this.c, a);
                        };
                        _.gc = function Yzb() {
                            var a, b, c;
                            this.f.Te() ? this.a ? b = Pyb(this.c, this.b, true) : b = Pyb(this.c, this.b, false) : b = Nyb(this.c);
                            if (!(!!b && Jzb(this, b.d) ? b : null)) return 0;
                            a = 0;
                            for(c = new yzb(this.c, this.f, this.b, this.a, this.e, this.d); Akb(c.a); c.b = RD(Bkb(c.a), 44))++a;
                            return a;
                        };
                        _.ad = function Zzb(a, b) {
                            if (this.f.Te() && this.c.a.Ne(a, this.b) < 0) throw Adb(new agb(Sxe + a + Txe + this.b));
                            return this.f.Ue() ? bzb(this.c, a, b, this.e, this.d) : czb(this.c, a, b);
                        };
                        _.a = false;
                        _.d = false;
                        var BL = sfb(Bve, 'TreeMap/SubMap', 631);
                        feb(304, 22, Uxe, dAb);
                        _.Te = function eAb() {
                            return false;
                        };
                        _.Ue = function fAb() {
                            return false;
                        };
                        var $zb, _zb, aAb, bAb;
                        var AL = tfb(Bve, 'TreeMap/SubMapType', 304, WI, hAb, gAb);
                        feb(1143, 304, Uxe, iAb);
                        _.Ue = function jAb() {
                            return true;
                        };
                        var xL = tfb(Bve, 'TreeMap/SubMapType/1', 1143, AL, null, null);
                        feb(1144, 304, Uxe, kAb);
                        _.Te = function lAb() {
                            return true;
                        };
                        _.Ue = function mAb() {
                            return true;
                        };
                        var yL = tfb(Bve, 'TreeMap/SubMapType/2', 1144, AL, null, null);
                        feb(1145, 304, Uxe, nAb);
                        _.Te = function oAb() {
                            return true;
                        };
                        var zL = tfb(Bve, 'TreeMap/SubMapType/3', 1145, AL, null, null);
                        var pAb;
                        feb(157, Eve, {
                            3: 1,
                            20: 1,
                            31: 1,
                            16: 1,
                            277: 1,
                            21: 1,
                            87: 1,
                            157: 1
                        }, xAb, yAb, zAb);
                        _.Nc = function GAb() {
                            return new $wb(this);
                        };
                        _.Fc = function AAb(a) {
                            return rAb(this, a);
                        };
                        _.$b = function BAb() {
                            this.a.$b();
                        };
                        _.Hc = function CAb(a) {
                            return this.a._b(a);
                        };
                        _.Kc = function DAb() {
                            return this.a.ec().Kc();
                        };
                        _.Mc = function EAb(a) {
                            return wAb(this, a);
                        };
                        _.gc = function FAb() {
                            return this.a.gc();
                        };
                        var DL = sfb(Bve, 'TreeSet', 157);
                        feb(1082, 1, {}, JAb);
                        _.Ve = function KAb(a, b) {
                            return HAb(this.a, a, b);
                        };
                        var FL = sfb(Vxe, 'BinaryOperator/lambda$0$Type', 1082);
                        feb(1083, 1, {}, LAb);
                        _.Ve = function MAb(a, b) {
                            return IAb(this.a, a, b);
                        };
                        var GL = sfb(Vxe, 'BinaryOperator/lambda$1$Type', 1083);
                        feb(952, 1, {}, NAb);
                        _.Kb = function OAb(a) {
                            return a;
                        };
                        var HL = sfb(Vxe, 'Function/lambda$0$Type', 952);
                        feb(395, 1, nwe, PAb);
                        _.Mb = function QAb(a) {
                            return !this.a.Mb(a);
                        };
                        var IL = sfb(Vxe, 'Predicate/lambda$2$Type', 395);
                        feb(581, 1, {
                            581: 1
                        });
                        var JL = sfb(Wxe, 'Handler', 581);
                        feb(2107, 1, nve);
                        _.xe = function TAb() {
                            return 'DUMMY';
                        };
                        _.Ib = function UAb() {
                            return this.xe();
                        };
                        var RAb;
                        var LL = sfb(Wxe, 'Level', 2107);
                        feb(1706, 2107, nve, VAb);
                        _.xe = function WAb() {
                            return 'INFO';
                        };
                        var KL = sfb(Wxe, 'Level/LevelInfo', 1706);
                        feb(1843, 1, {}, $Ab);
                        var XAb;
                        var ML = sfb(Wxe, 'LogManager', 1843);
                        feb(1896, 1, nve, aBb);
                        _.b = null;
                        var NL = sfb(Wxe, 'LogRecord', 1896);
                        feb(525, 1, {
                            525: 1
                        }, oBb);
                        _.e = false;
                        var bBb = false, cBb = false, dBb = false, eBb = false, fBb = false;
                        var OL = sfb(Wxe, 'Logger', 525);
                        feb(835, 581, {
                            581: 1
                        }, rBb);
                        var PL = sfb(Wxe, 'SimpleConsoleLogHandler', 835);
                        feb(108, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            108: 1
                        }, yBb);
                        var uBb, vBb, wBb;
                        var QL = tfb(Zxe, 'Collector/Characteristics', 108, WI, ABb, zBb);
                        var BBb;
                        feb(758, 1, {}, DBb);
                        var RL = sfb(Zxe, 'CollectorImpl', 758);
                        feb(1074, 1, {}, RBb);
                        _.Ve = function SBb(a, b) {
                            return Hyb(RD(a, 213), RD(b, 213));
                        };
                        var SL = sfb(Zxe, 'Collectors/10methodref$merge$Type', 1074);
                        feb(1075, 1, {}, TBb);
                        _.Kb = function UBb(a) {
                            return Iyb(RD(a, 213));
                        };
                        var TL = sfb(Zxe, 'Collectors/11methodref$toString$Type', 1075);
                        feb(1076, 1, {}, VBb);
                        _.Kb = function WBb(a) {
                            return Geb(), SSb(a) ? true : false;
                        };
                        var UL = sfb(Zxe, 'Collectors/12methodref$test$Type', 1076);
                        feb(144, 1, {}, XBb);
                        _.Yd = function YBb(a, b) {
                            RD(a, 16).Fc(b);
                        };
                        var VL = sfb(Zxe, 'Collectors/20methodref$add$Type', 144);
                        feb(146, 1, {}, ZBb);
                        _.Xe = function $Bb() {
                            return new bnb;
                        };
                        var WL = sfb(Zxe, 'Collectors/21methodref$ctor$Type', 146);
                        feb(359, 1, {}, _Bb);
                        _.Xe = function aCb() {
                            return new _sb;
                        };
                        var XL = sfb(Zxe, 'Collectors/23methodref$ctor$Type', 359);
                        feb(360, 1, {}, bCb);
                        _.Yd = function cCb(a, b) {
                            Ysb(RD(a, 49), b);
                        };
                        var YL = sfb(Zxe, 'Collectors/24methodref$add$Type', 360);
                        feb(1069, 1, {}, dCb);
                        _.Ve = function eCb(a, b) {
                            return EBb(RD(a, 15), RD(b, 16));
                        };
                        var ZL = sfb(Zxe, 'Collectors/4methodref$addAll$Type', 1069);
                        feb(1073, 1, {}, fCb);
                        _.Yd = function gCb(a, b) {
                            Gyb(RD(a, 213), RD(b, 484));
                        };
                        var $L = sfb(Zxe, 'Collectors/9methodref$add$Type', 1073);
                        feb(1072, 1, {}, hCb);
                        _.Xe = function iCb() {
                            return new Jyb(this.a, this.b, this.c);
                        };
                        var _L = sfb(Zxe, 'Collectors/lambda$15$Type', 1072);
                        feb(1077, 1, {}, jCb);
                        _.Xe = function kCb() {
                            var a;
                            return a = new gub, dub(a, (Geb(), false), new bnb), dub(a, true, new bnb), a;
                        };
                        var aM = sfb(Zxe, 'Collectors/lambda$22$Type', 1077);
                        feb(1078, 1, {}, lCb);
                        _.Xe = function mCb() {
                            return cD(WC(jJ, 1), rve, 1, 5, [
                                this.a
                            ]);
                        };
                        var bM = sfb(Zxe, 'Collectors/lambda$25$Type', 1078);
                        feb(1079, 1, {}, nCb);
                        _.Yd = function oCb(a, b) {
                            GBb(this.a, SD(a));
                        };
                        var cM = sfb(Zxe, 'Collectors/lambda$26$Type', 1079);
                        feb(1080, 1, {}, pCb);
                        _.Ve = function qCb(a, b) {
                            return HBb(this.a, SD(a), SD(b));
                        };
                        var dM = sfb(Zxe, 'Collectors/lambda$27$Type', 1080);
                        feb(1081, 1, {}, rCb);
                        _.Kb = function sCb(a) {
                            return SD(a)[0];
                        };
                        var eM = sfb(Zxe, 'Collectors/lambda$28$Type', 1081);
                        feb(728, 1, {}, uCb);
                        _.Ve = function vCb(a, b) {
                            return tCb(a, b);
                        };
                        var fM = sfb(Zxe, 'Collectors/lambda$4$Type', 728);
                        feb(145, 1, {}, wCb);
                        _.Ve = function xCb(a, b) {
                            return JBb(RD(a, 16), RD(b, 16));
                        };
                        var gM = sfb(Zxe, 'Collectors/lambda$42$Type', 145);
                        feb(361, 1, {}, yCb);
                        _.Ve = function zCb(a, b) {
                            return KBb(RD(a, 49), RD(b, 49));
                        };
                        var hM = sfb(Zxe, 'Collectors/lambda$50$Type', 361);
                        feb(362, 1, {}, ACb);
                        _.Kb = function BCb(a) {
                            return RD(a, 49);
                        };
                        var iM = sfb(Zxe, 'Collectors/lambda$51$Type', 362);
                        feb(1068, 1, {}, CCb);
                        _.Yd = function DCb(a, b) {
                            LBb(this.a, RD(a, 85), b);
                        };
                        var jM = sfb(Zxe, 'Collectors/lambda$7$Type', 1068);
                        feb(1070, 1, {}, ECb);
                        _.Ve = function FCb(a, b) {
                            return NBb(RD(a, 85), RD(b, 85), new dCb);
                        };
                        var kM = sfb(Zxe, 'Collectors/lambda$8$Type', 1070);
                        feb(1071, 1, {}, GCb);
                        _.Kb = function HCb(a) {
                            return MBb(this.a, RD(a, 85));
                        };
                        var lM = sfb(Zxe, 'Collectors/lambda$9$Type', 1071);
                        feb(550, 1, {});
                        _.$e = function OCb() {
                            ICb(this);
                        };
                        _.d = false;
                        var TM = sfb(Zxe, 'TerminatableStream', 550);
                        feb(827, 550, $xe, WCb);
                        _.$e = function XCb() {
                            ICb(this);
                        };
                        var qM = sfb(Zxe, 'DoubleStreamImpl', 827);
                        feb(1847, 736, Pve, $Cb);
                        _.Re = function aDb(a) {
                            return ZCb(this, RD(a, 189));
                        };
                        _.a = null;
                        var nM = sfb(Zxe, 'DoubleStreamImpl/2', 1847);
                        feb(1848, 1, Gxe, bDb);
                        _.Pe = function cDb(a) {
                            _Cb(this.a, a);
                        };
                        var mM = sfb(Zxe, 'DoubleStreamImpl/2/lambda$0$Type', 1848);
                        feb(1845, 1, Gxe, dDb);
                        _.Pe = function eDb(a) {
                            YCb(this.a, a);
                        };
                        var oM = sfb(Zxe, 'DoubleStreamImpl/lambda$0$Type', 1845);
                        feb(1846, 1, Gxe, fDb);
                        _.Pe = function gDb(a) {
                            Nrb(this.a, a);
                        };
                        var pM = sfb(Zxe, 'DoubleStreamImpl/lambda$2$Type', 1846);
                        feb(1397, 735, Pve, kDb);
                        _.Re = function lDb(a) {
                            return jDb(this, RD(a, 202));
                        };
                        _.a = 0;
                        _.b = 0;
                        _.c = 0;
                        var rM = sfb(Zxe, 'IntStream/5', 1397);
                        feb(806, 550, $xe, oDb);
                        _.$e = function pDb() {
                            ICb(this);
                        };
                        _._e = function qDb() {
                            return LCb(this), this.a;
                        };
                        var vM = sfb(Zxe, 'IntStreamImpl', 806);
                        feb(807, 550, $xe, rDb);
                        _.$e = function sDb() {
                            ICb(this);
                        };
                        _._e = function tDb() {
                            return LCb(this), Txb(), Sxb;
                        };
                        var sM = sfb(Zxe, 'IntStreamImpl/Empty', 807);
                        feb(1687, 1, Rve, uDb);
                        _.Dd = function vDb(a) {
                            ktb(this.a, a);
                        };
                        var uM = sfb(Zxe, 'IntStreamImpl/lambda$4$Type', 1687);
                        var RM = ufb(Zxe, 'Stream');
                        feb(26, 550, {
                            533: 1,
                            687: 1,
                            848: 1
                        }, SDb);
                        _.$e = function TDb() {
                            ICb(this);
                        };
                        var wDb;
                        var QM = sfb(Zxe, 'StreamImpl', 26);
                        feb(1102, 500, Pve, YDb);
                        _.Bd = function ZDb(a) {
                            while(WDb(this)){
                                if (this.a.Bd(a)) return true;
                                else {
                                    ICb(this.b);
                                    this.b = null;
                                    this.a = null;
                                }
                            }
                            return false;
                        };
                        var xM = sfb(Zxe, 'StreamImpl/1', 1102);
                        feb(1103, 1, Qve, $Db);
                        _.Cd = function _Db(a) {
                            XDb(this.a, RD(a, 848));
                        };
                        var wM = sfb(Zxe, 'StreamImpl/1/lambda$0$Type', 1103);
                        feb(1104, 1, nwe, aEb);
                        _.Mb = function bEb(a) {
                            return Ysb(this.a, a);
                        };
                        var yM = sfb(Zxe, 'StreamImpl/1methodref$add$Type', 1104);
                        feb(1105, 500, Pve, cEb);
                        _.Bd = function dEb(a) {
                            var b;
                            if (!this.a) {
                                b = new bnb;
                                this.b.a.Nb(new eEb(b));
                                yob();
                                _mb(b, this.c);
                                this.a = new Swb(b, 16);
                            }
                            return Rwb(this.a, a);
                        };
                        _.a = null;
                        var AM = sfb(Zxe, 'StreamImpl/5', 1105);
                        feb(1106, 1, Qve, eEb);
                        _.Cd = function fEb(a) {
                            Rmb(this.a, a);
                        };
                        var zM = sfb(Zxe, 'StreamImpl/5/2methodref$add$Type', 1106);
                        feb(737, 500, Pve, hEb);
                        _.Bd = function iEb(a) {
                            this.b = false;
                            while(!this.b && this.c.Bd(new jEb(this, a)));
                            return this.b;
                        };
                        _.b = false;
                        var CM = sfb(Zxe, 'StreamImpl/FilterSpliterator', 737);
                        feb(1096, 1, Qve, jEb);
                        _.Cd = function kEb(a) {
                            gEb(this.a, this.b, a);
                        };
                        var BM = sfb(Zxe, 'StreamImpl/FilterSpliterator/lambda$0$Type', 1096);
                        feb(1091, 736, Pve, nEb);
                        _.Re = function oEb(a) {
                            return mEb(this, RD(a, 189));
                        };
                        var EM = sfb(Zxe, 'StreamImpl/MapToDoubleSpliterator', 1091);
                        feb(1095, 1, Qve, pEb);
                        _.Cd = function qEb(a) {
                            lEb(this.a, this.b, a);
                        };
                        var DM = sfb(Zxe, 'StreamImpl/MapToDoubleSpliterator/lambda$0$Type', 1095);
                        feb(1090, 735, Pve, tEb);
                        _.Re = function uEb(a) {
                            return sEb(this, RD(a, 202));
                        };
                        var GM = sfb(Zxe, 'StreamImpl/MapToIntSpliterator', 1090);
                        feb(1094, 1, Qve, vEb);
                        _.Cd = function wEb(a) {
                            rEb(this.a, this.b, a);
                        };
                        var FM = sfb(Zxe, 'StreamImpl/MapToIntSpliterator/lambda$0$Type', 1094);
                        feb(734, 500, Pve, zEb);
                        _.Bd = function AEb(a) {
                            return yEb(this, a);
                        };
                        var IM = sfb(Zxe, 'StreamImpl/MapToObjSpliterator', 734);
                        feb(1093, 1, Qve, BEb);
                        _.Cd = function CEb(a) {
                            xEb(this.a, this.b, a);
                        };
                        var HM = sfb(Zxe, 'StreamImpl/MapToObjSpliterator/lambda$0$Type', 1093);
                        feb(1092, 500, Pve, DEb);
                        _.Bd = function EEb(a) {
                            while(Idb(this.b, 0)){
                                if (!this.a.Bd(new FEb)) return false;
                                this.b = Vdb(this.b, 1);
                            }
                            return this.a.Bd(a);
                        };
                        _.b = 0;
                        var KM = sfb(Zxe, 'StreamImpl/SkipSpliterator', 1092);
                        feb(1097, 1, Qve, FEb);
                        _.Cd = function GEb(a) {};
                        var JM = sfb(Zxe, 'StreamImpl/SkipSpliterator/lambda$0$Type', 1097);
                        feb(626, 1, Qve, IEb);
                        _.Cd = function JEb(a) {
                            HEb(this, a);
                        };
                        var LM = sfb(Zxe, 'StreamImpl/ValueConsumer', 626);
                        feb(1098, 1, Qve, KEb);
                        _.Cd = function LEb(a) {
                            xDb();
                        };
                        var MM = sfb(Zxe, 'StreamImpl/lambda$0$Type', 1098);
                        feb(1099, 1, Qve, MEb);
                        _.Cd = function NEb(a) {
                            xDb();
                        };
                        var NM = sfb(Zxe, 'StreamImpl/lambda$1$Type', 1099);
                        feb(1100, 1, {}, OEb);
                        _.Ve = function PEb(a, b) {
                            return UDb(this.a, a, b);
                        };
                        var OM = sfb(Zxe, 'StreamImpl/lambda$4$Type', 1100);
                        feb(1101, 1, Qve, QEb);
                        _.Cd = function REb(a) {
                            VDb(this.b, this.a, a);
                        };
                        var PM = sfb(Zxe, 'StreamImpl/lambda$5$Type', 1101);
                        feb(1107, 1, Qve, SEb);
                        _.Cd = function TEb(a) {
                            PCb(this.a, RD(a, 380));
                        };
                        var SM = sfb(Zxe, 'TerminatableStream/lambda$0$Type', 1107);
                        feb(2142, 1, {});
                        feb(2014, 1, {}, gFb);
                        var UM = sfb('javaemul.internal', 'ConsoleLogger', 2014);
                        var iFb = 0;
                        feb(2134, 1, {});
                        feb(1830, 1, Qve, FFb);
                        _.Cd = function GFb(a) {
                            RD(a, 317);
                        };
                        var VM = sfb(eye, 'BowyerWatsonTriangulation/lambda$0$Type', 1830);
                        feb(1831, 1, Qve, HFb);
                        _.Cd = function IFb(a) {
                            ye(this.a, RD(a, 317).e);
                        };
                        var WM = sfb(eye, 'BowyerWatsonTriangulation/lambda$1$Type', 1831);
                        feb(1832, 1, Qve, JFb);
                        _.Cd = function KFb(a) {
                            RD(a, 177);
                        };
                        var XM = sfb(eye, 'BowyerWatsonTriangulation/lambda$2$Type', 1832);
                        feb(1827, 1, fye, NFb);
                        _.Ne = function OFb(a, b) {
                            return MFb(this.a, RD(a, 177), RD(b, 177));
                        };
                        _.Fb = function PFb(a) {
                            return this === a;
                        };
                        _.Oe = function QFb() {
                            return new Frb(this);
                        };
                        var YM = sfb(eye, 'NaiveMinST/lambda$0$Type', 1827);
                        feb(449, 1, {}, SFb);
                        var ZM = sfb(eye, 'NodeMicroLayout', 449);
                        feb(177, 1, {
                            177: 1
                        }, TFb);
                        _.Fb = function UFb(a) {
                            var b;
                            if (ZD(a, 177)) {
                                b = RD(a, 177);
                                return Fvb(this.a, b.a) && Fvb(this.b, b.b) || Fvb(this.a, b.b) && Fvb(this.b, b.a);
                            } else return false;
                        };
                        _.Hb = function VFb() {
                            return Gvb(this.a) + Gvb(this.b);
                        };
                        var $M = sfb(eye, 'TEdge', 177);
                        feb(317, 1, {
                            317: 1
                        }, XFb);
                        _.Fb = function YFb(a) {
                            var b;
                            if (ZD(a, 317)) {
                                b = RD(a, 317);
                                return WFb(this, b.a) && WFb(this, b.b) && WFb(this, b.c);
                            } else return false;
                        };
                        _.Hb = function ZFb() {
                            return Gvb(this.a) + Gvb(this.b) + Gvb(this.c);
                        };
                        var _M = sfb(eye, 'TTriangle', 317);
                        feb(225, 1, {
                            225: 1
                        }, $Fb);
                        var aN = sfb(eye, 'Tree', 225);
                        feb(1218, 1, {}, aGb);
                        var cN = sfb(gye, 'Scanline', 1218);
                        var bN = ufb(gye, hye);
                        feb(1758, 1, {}, dGb);
                        var dN = sfb(iye, 'CGraph', 1758);
                        feb(316, 1, {
                            316: 1
                        }, fGb);
                        _.b = 0;
                        _.c = 0;
                        _.d = 0;
                        _.g = 0;
                        _.i = 0;
                        _.k = pxe;
                        var fN = sfb(iye, 'CGroup', 316);
                        feb(830, 1, {}, jGb);
                        var eN = sfb(iye, 'CGroup/CGroupBuilder', 830);
                        feb(60, 1, {
                            60: 1
                        }, kGb);
                        _.Ib = function lGb() {
                            var a;
                            if (this.j) return WD(this.j.Kb(this));
                            return lfb(hN), hN.o + '@' + (a = kFb(this) >>> 0, a.toString(16));
                        };
                        _.f = 0;
                        _.i = pxe;
                        var hN = sfb(iye, 'CNode', 60);
                        feb(829, 1, {}, qGb);
                        var gN = sfb(iye, 'CNode/CNodeBuilder', 829);
                        var vGb;
                        feb(1590, 1, {}, xGb);
                        _.ff = function yGb(a, b) {
                            return 0;
                        };
                        _.gf = function zGb(a, b) {
                            return 0;
                        };
                        var iN = sfb(iye, kye, 1590);
                        feb(1853, 1, {}, AGb);
                        _.cf = function BGb(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p;
                            j = oxe;
                            for(d = new Anb(a.a.b); d.a < d.c.c.length;){
                                b = RD(ynb(d), 60);
                                j = $wnd.Math.min(j, b.a.j.d.c + b.b.a);
                            }
                            n = new Yub;
                            for(g = new Anb(a.a.a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 316);
                                f.k = j;
                                f.g == 0 && Pub(n, f, n.c.b, n.c);
                            }
                            while(n.b != 0){
                                f = RD(n.b == 0 ? null : (sFb(n.b != 0), Wub(n, n.a.a)), 316);
                                e = f.j.d.c;
                                for(m = f.a.a.ec().Kc(); m.Ob();){
                                    k = RD(m.Pb(), 60);
                                    p = f.k + k.b.a;
                                    !LGb(a, f, a.d) || k.d.c < p ? k.i = p : k.i = k.d.c;
                                }
                                e -= f.j.i;
                                f.b += e;
                                a.d == (Cmd(), zmd) || a.d == xmd ? f.c += e : f.c -= e;
                                for(l = f.a.a.ec().Kc(); l.Ob();){
                                    k = RD(l.Pb(), 60);
                                    for(i = k.c.Kc(); i.Ob();){
                                        h = RD(i.Pb(), 60);
                                        Dmd(a.d) ? o = a.g.ff(k, h) : o = a.g.gf(k, h);
                                        h.a.k = $wnd.Math.max(h.a.k, k.i + k.d.b + o - h.b.a);
                                        MGb(a, h, a.d) && (h.a.k = $wnd.Math.max(h.a.k, h.d.c - h.b.a));
                                        --h.a.g;
                                        h.a.g == 0 && Mub(n, h.a);
                                    }
                                }
                            }
                            for(c = new Anb(a.a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 60);
                                b.d.c = b.i;
                            }
                        };
                        var jN = sfb(iye, 'LongestPathCompaction', 1853);
                        feb(1756, 1, {}, VGb);
                        _.e = false;
                        var CGb, DGb, EGb;
                        var lN = sfb(iye, pye, 1756);
                        feb(1757, 1, Qve, WGb);
                        _.Cd = function XGb(a) {
                            NGb(this.a, RD(a, 42));
                        };
                        var kN = sfb(iye, qye, 1757);
                        feb(1854, 1, {}, YGb);
                        _.df = function ZGb(a) {
                            var b, c, d, e, f, g, h;
                            for(c = new Anb(a.a.b); c.a < c.c.c.length;){
                                b = RD(ynb(c), 60);
                                b.c.$b();
                            }
                            for(e = new Anb(a.a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 60);
                                for(g = new Anb(a.a.b); g.a < g.c.c.length;){
                                    f = RD(ynb(g), 60);
                                    if (d == f) continue;
                                    if (!!d.a && d.a == f.a) continue;
                                    Dmd(a.d) ? h = a.g.gf(d, f) : h = a.g.ff(d, f);
                                    (f.d.c > d.d.c || d.d.c == f.d.c && d.d.b < f.d.b) && sGb(f.d.d + f.d.a + h, d.d.d) && uGb(f.d.d, d.d.d + d.d.a + h) && d.c.Fc(f);
                                }
                            }
                        };
                        var mN = sfb(iye, 'QuadraticConstraintCalculation', 1854);
                        feb(529, 1, {
                            529: 1
                        }, cHb);
                        _.a = false;
                        _.b = false;
                        _.c = false;
                        _.d = false;
                        var nN = sfb(iye, rye, 529);
                        feb(817, 1, {}, fHb);
                        _.df = function gHb(a) {
                            this.c = a;
                            eHb(this, new xHb);
                        };
                        var tN = sfb(iye, sye, 817);
                        feb(1784, 1, {
                            693: 1
                        }, lHb);
                        _.bf = function mHb(a) {
                            iHb(this, RD(a, 473));
                        };
                        var pN = sfb(iye, tye, 1784);
                        feb(1785, 1, fye, oHb);
                        _.Ne = function pHb(a, b) {
                            return nHb(RD(a, 60), RD(b, 60));
                        };
                        _.Fb = function qHb(a) {
                            return this === a;
                        };
                        _.Oe = function rHb() {
                            return new Frb(this);
                        };
                        var oN = sfb(iye, uye, 1785);
                        feb(473, 1, {
                            473: 1
                        }, sHb);
                        _.a = false;
                        var qN = sfb(iye, vye, 473);
                        feb(1786, 1, fye, tHb);
                        _.Ne = function uHb(a, b) {
                            return hHb(RD(a, 473), RD(b, 473));
                        };
                        _.Fb = function vHb(a) {
                            return this === a;
                        };
                        _.Oe = function wHb() {
                            return new Frb(this);
                        };
                        var rN = sfb(iye, wye, 1786);
                        feb(1787, 1, xye, xHb);
                        _.Lb = function yHb(a) {
                            return RD(a, 60), true;
                        };
                        _.Fb = function zHb(a) {
                            return this === a;
                        };
                        _.Mb = function AHb(a) {
                            return RD(a, 60), true;
                        };
                        var sN = sfb(iye, 'ScanlineConstraintCalculator/lambda$1$Type', 1787);
                        feb(436, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            436: 1
                        }, EHb);
                        var BHb, CHb;
                        var uN = tfb(yye, 'HighLevelSortingCriterion', 436, WI, GHb, FHb);
                        var HHb;
                        feb(435, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            435: 1
                        }, MHb);
                        var JHb, KHb;
                        var vN = tfb(yye, 'LowLevelSortingCriterion', 435, WI, OHb, NHb);
                        var PHb;
                        var B2 = ufb(zye, 'ILayoutMetaDataProvider');
                        feb(864, 1, Eye, ZHb);
                        _.hf = function $Hb(a) {
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, Aye), Fye), 'Polyomino Traversal Strategy'), 'Traversal strategy for trying different candidate positions for polyominoes.'), XHb), (kid(), eid)), xN), xsb((Yhd(), Whd)))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, Bye), Fye), 'Polyomino Secondary Sorting Criterion'), 'Possible secondary sorting criteria for the processing order of polyominoes. They are used when polyominoes are equal according to the primary sorting criterion HighLevelSortingCriterion.'), VHb), eid), vN), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, Cye), Fye), 'Polyomino Primary Sorting Criterion'), 'Possible primary sorting criteria for the processing order of polyominoes.'), THb), eid), uN), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, Dye), Fye), 'Fill Polyominoes'), 'Use the Profile Fill algorithm to fill polyominoes to prevent small polyominoes from being placed inside of big polyominoes with large holes. Might increase packing area.'), (Geb(), true)), cid), QI), xsb(Whd))));
                        };
                        var RHb, SHb, THb, UHb, VHb, WHb, XHb;
                        var wN = sfb(yye, 'PolyominoOptions', 864);
                        feb(257, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            257: 1
                        }, jIb);
                        var _Hb, aIb, bIb, cIb, dIb, eIb, fIb, gIb, hIb;
                        var xN = tfb(yye, 'TraversalStrategy', 257, WI, lIb, kIb);
                        var mIb;
                        feb(218, 1, {
                            218: 1
                        }, pIb);
                        _.Ib = function qIb() {
                            return 'NEdge[id=' + this.b + ' w=' + this.g + ' d=' + this.a + ']';
                        };
                        _.a = 1;
                        _.b = 0;
                        _.c = 0;
                        _.f = false;
                        _.g = 0;
                        var zN = sfb(Gye, 'NEdge', 218);
                        feb(182, 1, {}, wIb);
                        var yN = sfb(Gye, 'NEdge/NEdgeBuilder', 182);
                        feb(662, 1, {}, BIb);
                        var AN = sfb(Gye, 'NGraph', 662);
                        feb(125, 1, {
                            125: 1
                        }, DIb);
                        _.c = -1;
                        _.d = 0;
                        _.e = 0;
                        _.i = -1;
                        _.j = false;
                        var DN = sfb(Gye, 'NNode', 125);
                        feb(808, 1, Exe, GIb);
                        _.Jc = function OIb(a) {
                            xgb(this, a);
                        };
                        _.Lc = function VIb() {
                            return new SDb(null, new Swb(this, 16));
                        };
                        _.jd = function $Ib(a) {
                            tvb(this, a);
                        };
                        _.Nc = function _Ib() {
                            return new Swb(this, 16);
                        };
                        _.Oc = function aJb() {
                            return new SDb(null, new Swb(this, 16));
                        };
                        _.bd = function HIb(a, b) {
                            ++this.b;
                            Qmb(this.a, a, b);
                        };
                        _.Fc = function IIb(a) {
                            return EIb(this, a);
                        };
                        _.cd = function JIb(a, b) {
                            ++this.b;
                            return Smb(this.a, a, b);
                        };
                        _.Gc = function KIb(a) {
                            ++this.b;
                            return Tmb(this.a, a);
                        };
                        _.$b = function LIb() {
                            ++this.b;
                            aFb(this.a.c, 0);
                        };
                        _.Hc = function MIb(a) {
                            return Wmb(this.a, a, 0) != -1;
                        };
                        _.Ic = function NIb(a) {
                            return Be(this.a, a);
                        };
                        _.Xb = function PIb(a) {
                            return Vmb(this.a, a);
                        };
                        _.dd = function QIb(a) {
                            return Wmb(this.a, a, 0);
                        };
                        _.dc = function RIb() {
                            return this.a.c.length == 0;
                        };
                        _.Kc = function SIb() {
                            return Nr(new Anb(this.a));
                        };
                        _.ed = function TIb() {
                            throw Adb(new jib);
                        };
                        _.fd = function UIb(a) {
                            throw Adb(new jib);
                        };
                        _.gd = function WIb(a) {
                            ++this.b;
                            return Xmb(this.a, a);
                        };
                        _.Mc = function XIb(a) {
                            return FIb(this, a);
                        };
                        _.hd = function YIb(a, b) {
                            ++this.b;
                            return $mb(this.a, a, b);
                        };
                        _.gc = function ZIb() {
                            return this.a.c.length;
                        };
                        _.kd = function bJb(a, b) {
                            return new Rkb(this.a, a, b);
                        };
                        _.Pc = function cJb() {
                            return UEb(this.a.c);
                        };
                        _.Qc = function dJb(a) {
                            return anb(this.a, a);
                        };
                        _.b = 0;
                        var BN = sfb(Gye, 'NNode/ChangeAwareArrayList', 808);
                        feb(275, 1, {}, gJb);
                        var CN = sfb(Gye, 'NNode/NNodeBuilder', 275);
                        feb(1695, 1, {}, BJb);
                        _.a = false;
                        _.f = lve;
                        _.j = 0;
                        var EN = sfb(Gye, 'NetworkSimplex', 1695);
                        feb(1314, 1, Qve, HJb);
                        _.Cd = function IJb(a) {
                            GJb(this.a, RD(a, 695), true, false);
                        };
                        var FN = sfb(Iye, 'NodeLabelAndSizeCalculator/lambda$0$Type', 1314);
                        feb(565, 1, {}, PJb);
                        _.b = true;
                        _.c = true;
                        _.d = true;
                        _.e = true;
                        var GN = sfb(Iye, 'NodeMarginCalculator', 565);
                        feb(217, 1, {
                            217: 1
                        });
                        _.j = false;
                        _.k = false;
                        var IN = sfb(Jye, 'Cell', 217);
                        feb(127, 217, {
                            127: 1,
                            217: 1
                        }, TJb);
                        _.jf = function UJb() {
                            return SJb(this);
                        };
                        _.kf = function VJb() {
                            var a;
                            a = this.n;
                            return this.a.a + a.b + a.c;
                        };
                        var HN = sfb(Jye, 'AtomicCell', 127);
                        feb(237, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            237: 1
                        }, $Jb);
                        var WJb, XJb, YJb;
                        var JN = tfb(Jye, 'ContainerArea', 237, WI, aKb, _Jb);
                        var bKb;
                        feb(336, 217, Lye);
                        var KN = sfb(Jye, 'ContainerCell', 336);
                        feb(1538, 336, Lye, wKb);
                        _.jf = function xKb() {
                            var a;
                            a = 0;
                            this.e ? this.b ? a = this.b.b : !!this.a[1][1] && (a = this.a[1][1].jf()) : a = vKb(this, rKb(this, true));
                            return a > 0 ? a + this.n.d + this.n.a : 0;
                        };
                        _.kf = function yKb() {
                            var a, b, c, d, e;
                            e = 0;
                            if (this.e) this.b ? e = this.b.a : !!this.a[1][1] && (e = this.a[1][1].kf());
                            else if (this.g) e = vKb(this, pKb(this, null, true));
                            else for(b = (ZJb(), cD(WC(JN, 1), jwe, 237, 0, [
                                WJb,
                                XJb,
                                YJb
                            ])), c = 0, d = b.length; c < d; ++c){
                                a = b[c];
                                e = $wnd.Math.max(e, vKb(this, pKb(this, a, true)));
                            }
                            return e > 0 ? e + this.n.b + this.n.c : 0;
                        };
                        _.lf = function zKb() {
                            var a, b, c, d, e;
                            if (this.g) {
                                a = pKb(this, null, false);
                                for(c = (ZJb(), cD(WC(JN, 1), jwe, 237, 0, [
                                    WJb,
                                    XJb,
                                    YJb
                                ])), d = 0, e = c.length; d < e; ++d){
                                    b = c[d];
                                    nKb(this, b, a);
                                }
                            } else for(c = (ZJb(), cD(WC(JN, 1), jwe, 237, 0, [
                                WJb,
                                XJb,
                                YJb
                            ])), d = 0, e = c.length; d < e; ++d){
                                b = c[d];
                                a = pKb(this, b, false);
                                nKb(this, b, a);
                            }
                        };
                        _.mf = function AKb() {
                            var a, b, c, d;
                            b = this.i;
                            a = this.n;
                            d = rKb(this, false);
                            lKb(this, (ZJb(), WJb), b.d + a.d, d);
                            lKb(this, YJb, b.d + b.a - a.a - d[2], d);
                            c = b.a - a.d - a.a;
                            if (d[0] > 0) {
                                d[0] += this.d;
                                c -= d[0];
                            }
                            if (d[2] > 0) {
                                d[2] += this.d;
                                c -= d[2];
                            }
                            this.c.a = $wnd.Math.max(0, c);
                            this.c.d = b.d + a.d + (this.c.a - c) / 2;
                            d[1] = $wnd.Math.max(d[1], c);
                            lKb(this, XJb, b.d + a.d + d[0] - (d[1] - c) / 2, d);
                        };
                        _.b = null;
                        _.d = 0;
                        _.e = false;
                        _.f = false;
                        _.g = false;
                        var iKb = 0, jKb = 0;
                        var LN = sfb(Jye, 'GridContainerCell', 1538);
                        feb(471, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            471: 1
                        }, FKb);
                        var BKb, CKb, DKb;
                        var MN = tfb(Jye, 'HorizontalLabelAlignment', 471, WI, HKb, GKb);
                        var IKb;
                        feb(314, 217, {
                            217: 1,
                            314: 1
                        }, TKb, UKb, VKb);
                        _.jf = function WKb() {
                            return PKb(this);
                        };
                        _.kf = function XKb() {
                            return QKb(this);
                        };
                        _.a = 0;
                        _.c = false;
                        var NN = sfb(Jye, 'LabelCell', 314);
                        feb(252, 336, {
                            217: 1,
                            336: 1,
                            252: 1
                        }, dLb);
                        _.jf = function eLb() {
                            return YKb(this);
                        };
                        _.kf = function fLb() {
                            return ZKb(this);
                        };
                        _.lf = function iLb() {
                            $Kb(this);
                        };
                        _.mf = function jLb() {
                            _Kb(this);
                        };
                        _.b = 0;
                        _.c = 0;
                        _.d = false;
                        var SN = sfb(Jye, 'StripContainerCell', 252);
                        feb(1691, 1, nwe, kLb);
                        _.Mb = function lLb(a) {
                            return gLb(RD(a, 217));
                        };
                        var ON = sfb(Jye, 'StripContainerCell/lambda$0$Type', 1691);
                        feb(1692, 1, {}, mLb);
                        _.Ye = function nLb(a) {
                            return RD(a, 217).kf();
                        };
                        var PN = sfb(Jye, 'StripContainerCell/lambda$1$Type', 1692);
                        feb(1693, 1, nwe, oLb);
                        _.Mb = function pLb(a) {
                            return hLb(RD(a, 217));
                        };
                        var QN = sfb(Jye, 'StripContainerCell/lambda$2$Type', 1693);
                        feb(1694, 1, {}, qLb);
                        _.Ye = function rLb(a) {
                            return RD(a, 217).jf();
                        };
                        var RN = sfb(Jye, 'StripContainerCell/lambda$3$Type', 1694);
                        feb(472, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            472: 1
                        }, wLb);
                        var sLb, tLb, uLb;
                        var TN = tfb(Jye, 'VerticalLabelAlignment', 472, WI, yLb, xLb);
                        var zLb;
                        feb(800, 1, {}, CLb);
                        _.c = 0;
                        _.d = 0;
                        _.k = 0;
                        _.s = 0;
                        _.t = 0;
                        _.v = false;
                        _.w = 0;
                        _.D = false;
                        _.F = false;
                        var WN = sfb(Rye, 'NodeContext', 800);
                        feb(1536, 1, fye, FLb);
                        _.Ne = function GLb(a, b) {
                            return ELb(RD(a, 64), RD(b, 64));
                        };
                        _.Fb = function HLb(a) {
                            return this === a;
                        };
                        _.Oe = function ILb() {
                            return new Frb(this);
                        };
                        var UN = sfb(Rye, 'NodeContext/0methodref$comparePortSides$Type', 1536);
                        feb(1537, 1, fye, JLb);
                        _.Ne = function KLb(a, b) {
                            return DLb(RD(a, 117), RD(b, 117));
                        };
                        _.Fb = function LLb(a) {
                            return this === a;
                        };
                        _.Oe = function MLb() {
                            return new Frb(this);
                        };
                        var VN = sfb(Rye, 'NodeContext/1methodref$comparePortContexts$Type', 1537);
                        feb(164, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            164: 1
                        }, kMb);
                        var NLb, OLb, PLb, QLb, RLb, SLb, TLb, ULb, VLb, WLb, XLb, YLb, ZLb, $Lb, _Lb, aMb, bMb, cMb, dMb, eMb, fMb, gMb;
                        var XN = tfb(Rye, 'NodeLabelLocation', 164, WI, nMb, mMb);
                        var oMb;
                        feb(117, 1, {
                            117: 1
                        }, rMb);
                        _.a = false;
                        var YN = sfb(Rye, 'PortContext', 117);
                        feb(1541, 1, Qve, KMb);
                        _.Cd = function LMb(a) {
                            NKb(RD(a, 314));
                        };
                        var ZN = sfb(Uye, Vye, 1541);
                        feb(1542, 1, nwe, MMb);
                        _.Mb = function NMb(a) {
                            return !!RD(a, 117).c;
                        };
                        var $N = sfb(Uye, Wye, 1542);
                        feb(1543, 1, Qve, OMb);
                        _.Cd = function PMb(a) {
                            NKb(RD(a, 117).c);
                        };
                        var _N = sfb(Uye, 'LabelPlacer/lambda$2$Type', 1543);
                        var QMb;
                        feb(1540, 1, Qve, YMb);
                        _.Cd = function ZMb(a) {
                            RMb();
                            qMb(RD(a, 117));
                        };
                        var aO = sfb(Uye, 'NodeLabelAndSizeUtilities/lambda$0$Type', 1540);
                        feb(801, 1, Qve, dNb);
                        _.Cd = function eNb(a) {
                            bNb(this.b, this.c, this.a, RD(a, 187));
                        };
                        _.a = false;
                        _.c = false;
                        var bO = sfb(Uye, 'NodeLabelCellCreator/lambda$0$Type', 801);
                        feb(1539, 1, Qve, kNb);
                        _.Cd = function lNb(a) {
                            jNb(this.a, RD(a, 187));
                        };
                        var cO = sfb(Uye, 'PortContextCreator/lambda$0$Type', 1539);
                        var sNb;
                        feb(1902, 1, {}, MNb);
                        var eO = sfb(Yye, 'GreedyRectangleStripOverlapRemover', 1902);
                        feb(1903, 1, fye, ONb);
                        _.Ne = function PNb(a, b) {
                            return NNb(RD(a, 226), RD(b, 226));
                        };
                        _.Fb = function QNb(a) {
                            return this === a;
                        };
                        _.Oe = function RNb() {
                            return new Frb(this);
                        };
                        var dO = sfb(Yye, 'GreedyRectangleStripOverlapRemover/0methodref$compareByYCoordinate$Type', 1903);
                        feb(1849, 1, {}, YNb);
                        _.a = 5;
                        _.e = 0;
                        var kO = sfb(Yye, 'RectangleStripOverlapRemover', 1849);
                        feb(1850, 1, fye, aOb);
                        _.Ne = function bOb(a, b) {
                            return ZNb(RD(a, 226), RD(b, 226));
                        };
                        _.Fb = function cOb(a) {
                            return this === a;
                        };
                        _.Oe = function dOb() {
                            return new Frb(this);
                        };
                        var fO = sfb(Yye, 'RectangleStripOverlapRemover/0methodref$compareLeftRectangleBorders$Type', 1850);
                        feb(1852, 1, fye, eOb);
                        _.Ne = function fOb(a, b) {
                            return $Nb(RD(a, 226), RD(b, 226));
                        };
                        _.Fb = function gOb(a) {
                            return this === a;
                        };
                        _.Oe = function hOb() {
                            return new Frb(this);
                        };
                        var gO = sfb(Yye, 'RectangleStripOverlapRemover/1methodref$compareRightRectangleBorders$Type', 1852);
                        feb(417, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            417: 1
                        }, nOb);
                        var iOb, jOb, kOb, lOb;
                        var hO = tfb(Yye, 'RectangleStripOverlapRemover/OverlapRemovalDirection', 417, WI, pOb, oOb);
                        var qOb;
                        feb(226, 1, {
                            226: 1
                        }, sOb);
                        var iO = sfb(Yye, 'RectangleStripOverlapRemover/RectangleNode', 226);
                        feb(1851, 1, Qve, tOb);
                        _.Cd = function uOb(a) {
                            TNb(this.a, RD(a, 226));
                        };
                        var jO = sfb(Yye, 'RectangleStripOverlapRemover/lambda$1$Type', 1851);
                        feb(1323, 1, fye, xOb);
                        _.Ne = function yOb(a, b) {
                            return wOb(RD(a, 176), RD(b, 176));
                        };
                        _.Fb = function zOb(a) {
                            return this === a;
                        };
                        _.Oe = function AOb() {
                            return new Frb(this);
                        };
                        var oO = sfb($ye, 'PolyominoCompactor/CornerCasesGreaterThanRestComparator', 1323);
                        feb(1326, 1, {}, BOb);
                        _.Kb = function COb(a) {
                            return RD(a, 334).a;
                        };
                        var lO = sfb($ye, 'PolyominoCompactor/CornerCasesGreaterThanRestComparator/lambda$0$Type', 1326);
                        feb(1327, 1, nwe, DOb);
                        _.Mb = function EOb(a) {
                            return RD(a, 332).a;
                        };
                        var mO = sfb($ye, 'PolyominoCompactor/CornerCasesGreaterThanRestComparator/lambda$1$Type', 1327);
                        feb(1328, 1, nwe, FOb);
                        _.Mb = function GOb(a) {
                            return RD(a, 332).a;
                        };
                        var nO = sfb($ye, 'PolyominoCompactor/CornerCasesGreaterThanRestComparator/lambda$2$Type', 1328);
                        feb(1321, 1, fye, IOb);
                        _.Ne = function JOb(a, b) {
                            return HOb(RD(a, 176), RD(b, 176));
                        };
                        _.Fb = function KOb(a) {
                            return this === a;
                        };
                        _.Oe = function LOb() {
                            return new Frb(this);
                        };
                        var qO = sfb($ye, 'PolyominoCompactor/MinNumOfExtensionDirectionsComparator', 1321);
                        feb(1324, 1, {}, MOb);
                        _.Kb = function NOb(a) {
                            return RD(a, 334).a;
                        };
                        var pO = sfb($ye, 'PolyominoCompactor/MinNumOfExtensionDirectionsComparator/lambda$0$Type', 1324);
                        feb(781, 1, fye, POb);
                        _.Ne = function QOb(a, b) {
                            return OOb(RD(a, 176), RD(b, 176));
                        };
                        _.Fb = function ROb(a) {
                            return this === a;
                        };
                        _.Oe = function SOb() {
                            return new Frb(this);
                        };
                        var rO = sfb($ye, 'PolyominoCompactor/MinNumOfExtensionsComparator', 781);
                        feb(1319, 1, fye, UOb);
                        _.Ne = function VOb(a, b) {
                            return TOb(RD(a, 330), RD(b, 330));
                        };
                        _.Fb = function WOb(a) {
                            return this === a;
                        };
                        _.Oe = function XOb() {
                            return new Frb(this);
                        };
                        var tO = sfb($ye, 'PolyominoCompactor/MinPerimeterComparator', 1319);
                        feb(1320, 1, fye, ZOb);
                        _.Ne = function $Ob(a, b) {
                            return YOb(RD(a, 330), RD(b, 330));
                        };
                        _.Fb = function _Ob(a) {
                            return this === a;
                        };
                        _.Oe = function aPb() {
                            return new Frb(this);
                        };
                        var sO = sfb($ye, 'PolyominoCompactor/MinPerimeterComparatorWithShape', 1320);
                        feb(1322, 1, fye, cPb);
                        _.Ne = function dPb(a, b) {
                            return bPb(RD(a, 176), RD(b, 176));
                        };
                        _.Fb = function ePb(a) {
                            return this === a;
                        };
                        _.Oe = function fPb() {
                            return new Frb(this);
                        };
                        var vO = sfb($ye, 'PolyominoCompactor/SingleExtensionSideGreaterThanRestComparator', 1322);
                        feb(1325, 1, {}, gPb);
                        _.Kb = function hPb(a) {
                            return RD(a, 334).a;
                        };
                        var uO = sfb($ye, 'PolyominoCompactor/SingleExtensionSideGreaterThanRestComparator/lambda$0$Type', 1325);
                        feb(782, 1, {}, kPb);
                        _.Ve = function lPb(a, b) {
                            return jPb(this, RD(a, 42), RD(b, 176));
                        };
                        var wO = sfb($ye, 'SuccessorCombination', 782);
                        feb(649, 1, {}, nPb);
                        _.Ve = function oPb(a, b) {
                            var c;
                            return mPb((c = RD(a, 42), RD(b, 176), c));
                        };
                        var xO = sfb($ye, 'SuccessorJitter', 649);
                        feb(648, 1, {}, qPb);
                        _.Ve = function rPb(a, b) {
                            var c;
                            return pPb((c = RD(a, 42), RD(b, 176), c));
                        };
                        var yO = sfb($ye, 'SuccessorLineByLine', 648);
                        feb(573, 1, {}, tPb);
                        _.Ve = function uPb(a, b) {
                            var c;
                            return sPb((c = RD(a, 42), RD(b, 176), c));
                        };
                        var zO = sfb($ye, 'SuccessorManhattan', 573);
                        feb(1344, 1, {}, wPb);
                        _.Ve = function xPb(a, b) {
                            var c;
                            return vPb((c = RD(a, 42), RD(b, 176), c));
                        };
                        var AO = sfb($ye, 'SuccessorMaxNormWindingInMathPosSense', 1344);
                        feb(409, 1, {}, APb);
                        _.Ve = function BPb(a, b) {
                            return yPb(this, a, b);
                        };
                        _.c = false;
                        _.d = false;
                        _.e = false;
                        _.f = false;
                        var CO = sfb($ye, 'SuccessorQuadrantsGeneric', 409);
                        feb(1345, 1, {}, CPb);
                        _.Kb = function DPb(a) {
                            return RD(a, 334).a;
                        };
                        var BO = sfb($ye, 'SuccessorQuadrantsGeneric/lambda$0$Type', 1345);
                        feb(332, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            332: 1
                        }, JPb);
                        _.a = false;
                        var EPb, FPb, GPb, HPb;
                        var DO = tfb(dze, eze, 332, WI, LPb, KPb);
                        var MPb;
                        feb(1317, 1, {});
                        _.Ib = function UPb() {
                            var a, b, c, d, e, f;
                            c = ' ';
                            a = sgb(0);
                            for(e = 0; e < this.o; e++){
                                c += '' + a.a;
                                a = sgb(OPb(a.a));
                            }
                            c += '\n';
                            a = sgb(0);
                            for(f = 0; f < this.p; f++){
                                c += '' + a.a;
                                a = sgb(OPb(a.a));
                                for(d = 0; d < this.o; d++){
                                    b = SPb(this, d, f);
                                    Ddb(b, 0) == 0 ? c += '_' : Ddb(b, 1) == 0 ? c += 'X' : c += '0';
                                }
                                c += '\n';
                            }
                            return zhb(c, 0, c.length - 1);
                        };
                        _.o = 0;
                        _.p = 0;
                        var HO = sfb(dze, 'TwoBitGrid', 1317);
                        feb(330, 1317, {
                            330: 1
                        }, gQb);
                        _.j = 0;
                        _.k = 0;
                        var EO = sfb(dze, 'PlanarGrid', 330);
                        feb(176, 330, {
                            330: 1,
                            176: 1
                        });
                        _.g = 0;
                        _.i = 0;
                        var FO = sfb(dze, 'Polyomino', 176);
                        var U5 = ufb(jze, kze);
                        feb(137, 1, lze, qQb);
                        _.qf = function uQb(a, b) {
                            return oQb(this, a, b);
                        };
                        _.nf = function rQb() {
                            return lQb(this);
                        };
                        _.of = function sQb(a) {
                            return mQb(this, a);
                        };
                        _.pf = function tQb(a) {
                            return nQb(this, a);
                        };
                        var W5 = sfb(jze, 'MapPropertyHolder', 137);
                        feb(1318, 137, lze, vQb);
                        var GO = sfb(dze, 'Polyominoes', 1318);
                        var wQb = false, xQb, yQb;
                        feb(1828, 1, Qve, GQb);
                        _.Cd = function HQb(a) {
                            AQb(RD(a, 225));
                        };
                        var IO = sfb(mze, 'DepthFirstCompaction/0methodref$compactTree$Type', 1828);
                        feb(825, 1, Qve, IQb);
                        _.Cd = function JQb(a) {
                            DQb(this.a, RD(a, 225));
                        };
                        var JO = sfb(mze, 'DepthFirstCompaction/lambda$1$Type', 825);
                        feb(1829, 1, Qve, KQb);
                        _.Cd = function LQb(a) {
                            EQb(this.a, this.b, this.c, RD(a, 225));
                        };
                        var KO = sfb(mze, 'DepthFirstCompaction/lambda$2$Type', 1829);
                        var MQb, NQb;
                        feb(68, 1, {
                            68: 1
                        }, TQb);
                        var LO = sfb(mze, 'Node', 68);
                        feb(1214, 1, {}, WQb);
                        var QO = sfb(mze, 'ScanlineOverlapCheck', 1214);
                        feb(1215, 1, {
                            693: 1
                        }, $Qb);
                        _.bf = function _Qb(a) {
                            YQb(this, RD(a, 451));
                        };
                        var NO = sfb(mze, 'ScanlineOverlapCheck/OverlapsScanlineHandler', 1215);
                        feb(1216, 1, fye, bRb);
                        _.Ne = function cRb(a, b) {
                            return aRb(RD(a, 68), RD(b, 68));
                        };
                        _.Fb = function dRb(a) {
                            return this === a;
                        };
                        _.Oe = function eRb() {
                            return new Frb(this);
                        };
                        var MO = sfb(mze, 'ScanlineOverlapCheck/OverlapsScanlineHandler/lambda$0$Type', 1216);
                        feb(451, 1, {
                            451: 1
                        }, fRb);
                        _.a = false;
                        var OO = sfb(mze, 'ScanlineOverlapCheck/Timestamp', 451);
                        feb(1217, 1, fye, gRb);
                        _.Ne = function hRb(a, b) {
                            return XQb(RD(a, 451), RD(b, 451));
                        };
                        _.Fb = function iRb(a) {
                            return this === a;
                        };
                        _.Oe = function jRb() {
                            return new Frb(this);
                        };
                        var PO = sfb(mze, 'ScanlineOverlapCheck/lambda$0$Type', 1217);
                        feb(557, 1, {}, kRb);
                        var RO = sfb(nze, 'SVGImage', 557);
                        feb(334, 1, {
                            334: 1
                        }, lRb);
                        _.Ib = function mRb() {
                            return '(' + this.a + pve + this.b + pve + this.c + ')';
                        };
                        var SO = sfb(nze, 'UniqueTriple', 334);
                        feb(205, 1, oze);
                        var f2 = sfb(pze, 'AbstractLayoutProvider', 205);
                        feb(1114, 205, oze, pRb);
                        _.rf = function qRb(a, b) {
                            var c, d, e, f;
                            b.Ug(qze, 1);
                            this.a = Kfb(UD(Gxd(a, (tSb(), sSb))));
                            if (Hxd(a, iSb)) {
                                e = WD(Gxd(a, iSb));
                                c = sgd(ygd(), e);
                                if (c) {
                                    d = RD(ltd(c.f), 205);
                                    d.rf(a, b.eh(1));
                                }
                            }
                            f = new rTb(this.a);
                            this.b = pTb(f, a);
                            switch(RD(Gxd(a, (eSb(), aSb)), 489).g){
                                case 0:
                                    sRb(new wRb, this.b);
                                    Ixd(a, lSb, mQb(this.b, lSb));
                                    break;
                                default:
                                    gib();
                                    String.fromCharCode(10);
                            }
                            hTb(f);
                            Ixd(a, kSb, this.b);
                            b.Vg();
                        };
                        _.a = 0;
                        var TO = sfb(rze, 'DisCoLayoutProvider', 1114);
                        feb(1208, 1, {}, wRb);
                        _.c = false;
                        _.e = 0;
                        _.f = 0;
                        var UO = sfb(rze, 'DisCoPolyominoCompactor', 1208);
                        feb(567, 1, {
                            567: 1
                        }, DRb);
                        _.b = true;
                        var VO = sfb(sze, 'DCComponent', 567);
                        feb(406, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            406: 1
                        }, JRb);
                        _.a = false;
                        var ERb, FRb, GRb, HRb;
                        var WO = tfb(sze, 'DCDirection', 406, WI, LRb, KRb);
                        var MRb;
                        feb(272, 137, {
                            3: 1,
                            272: 1,
                            96: 1,
                            137: 1
                        }, ORb);
                        var XO = sfb(sze, 'DCElement', 272);
                        feb(407, 1, {
                            407: 1
                        }, QRb);
                        _.c = 0;
                        var YO = sfb(sze, 'DCExtension', 407);
                        feb(762, 137, lze, TRb);
                        var ZO = sfb(sze, 'DCGraph', 762);
                        feb(489, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            489: 1
                        }, WRb);
                        var URb;
                        var $O = tfb(tze, uze, 489, WI, YRb, XRb);
                        var ZRb;
                        feb(865, 1, Eye, fSb);
                        _.hf = function gSb(a) {
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, vze), zze), 'Connected Components Compaction Strategy'), 'Strategy for packing different connected components in order to save space and enhance readability of a graph.'), bSb), (kid(), eid)), $O), xsb((Yhd(), Whd)))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, wze), zze), 'Connected Components Layout Algorithm'), "A layout algorithm that is to be applied to each connected component before the components themselves are compacted. If unspecified, the positions of the components' nodes are not altered."), iid), qJ), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, xze), 'debug'), 'DCGraph'), 'Access to the DCGraph is intended for the debug view,'), hid), jJ), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, yze), 'debug'), 'List of Polyominoes'), 'Access to the polyominoes is intended for the debug view,'), hid), jJ), xsb(Whd))));
                            uSb((new vSb, a));
                        };
                        var _Rb, aSb, bSb, cSb, dSb;
                        var _O = sfb(tze, 'DisCoMetaDataProvider', 865);
                        feb(1010, 1, Eye, vSb);
                        _.hf = function wSb(a) {
                            uSb(a);
                        };
                        var hSb, iSb, jSb, kSb, lSb, mSb, nSb, oSb, pSb, qSb, rSb, sSb;
                        var bP = sfb(tze, 'DisCoOptions', 1010);
                        feb(1011, 1, {}, xSb);
                        _.sf = function ySb() {
                            var a;
                            return a = new pRb, a;
                        };
                        _.tf = function zSb(a) {};
                        var aP = sfb(tze, 'DisCoOptions/DiscoFactory', 1011);
                        feb(568, 176, {
                            330: 1,
                            176: 1,
                            568: 1
                        }, DSb);
                        _.a = 0;
                        _.b = 0;
                        _.c = 0;
                        _.d = 0;
                        var cP = sfb('org.eclipse.elk.alg.disco.structures', 'DCPolyomino', 568);
                        var ESb, FSb, GSb;
                        feb(1286, 1, nwe, TSb);
                        _.Mb = function USb(a) {
                            return SSb(a);
                        };
                        var dP = sfb(Fze, 'ElkGraphComponentsProcessor/lambda$0$Type', 1286);
                        feb(1287, 1, {}, VSb);
                        _.Kb = function WSb(a) {
                            return HSb(), JGd(RD(a, 74));
                        };
                        var eP = sfb(Fze, 'ElkGraphComponentsProcessor/lambda$1$Type', 1287);
                        feb(1288, 1, nwe, XSb);
                        _.Mb = function YSb(a) {
                            return NSb(RD(a, 74));
                        };
                        var fP = sfb(Fze, 'ElkGraphComponentsProcessor/lambda$2$Type', 1288);
                        feb(1289, 1, {}, ZSb);
                        _.Kb = function $Sb(a) {
                            return HSb(), LGd(RD(a, 74));
                        };
                        var gP = sfb(Fze, 'ElkGraphComponentsProcessor/lambda$3$Type', 1289);
                        feb(1290, 1, nwe, _Sb);
                        _.Mb = function aTb(a) {
                            return OSb(RD(a, 74));
                        };
                        var hP = sfb(Fze, 'ElkGraphComponentsProcessor/lambda$4$Type', 1290);
                        feb(1291, 1, nwe, bTb);
                        _.Mb = function cTb(a) {
                            return PSb(this.a, RD(a, 74));
                        };
                        var iP = sfb(Fze, 'ElkGraphComponentsProcessor/lambda$5$Type', 1291);
                        feb(1292, 1, {}, dTb);
                        _.Kb = function eTb(a) {
                            return QSb(this.a, RD(a, 74));
                        };
                        var jP = sfb(Fze, 'ElkGraphComponentsProcessor/lambda$6$Type', 1292);
                        feb(1205, 1, {}, rTb);
                        _.a = 0;
                        var mP = sfb(Fze, 'ElkGraphTransformer', 1205);
                        feb(1206, 1, {}, tTb);
                        _.Yd = function uTb(a, b) {
                            sTb(this, RD(a, 167), RD(b, 272));
                        };
                        var lP = sfb(Fze, 'ElkGraphTransformer/OffsetApplier', 1206);
                        feb(1207, 1, Qve, wTb);
                        _.Cd = function xTb(a) {
                            vTb(this, RD(a, 8));
                        };
                        var kP = sfb(Fze, 'ElkGraphTransformer/OffsetApplier/OffSetToChainApplier', 1207);
                        feb(760, 1, {}, DTb);
                        var oP = sfb(Kze, Lze, 760);
                        feb(1195, 1, fye, FTb);
                        _.Ne = function GTb(a, b) {
                            return ETb(RD(a, 235), RD(b, 235));
                        };
                        _.Fb = function HTb(a) {
                            return this === a;
                        };
                        _.Oe = function ITb() {
                            return new Frb(this);
                        };
                        var nP = sfb(Kze, Mze, 1195);
                        feb(1196, 1, Qve, OTb);
                        _.Cd = function PTb(a) {
                            NTb(this.b, this.a, RD(a, 250));
                        };
                        var pP = sfb(Kze, Nze, 1196);
                        feb(738, 205, oze, TTb);
                        _.rf = function UTb(a, b) {
                            QTb(this, a, b);
                        };
                        var qP = sfb(Kze, 'ForceLayoutProvider', 738);
                        feb(309, 137, {
                            3: 1,
                            309: 1,
                            96: 1,
                            137: 1
                        });
                        var wP = sfb(Oze, 'FParticle', 309);
                        feb(250, 309, {
                            3: 1,
                            250: 1,
                            309: 1,
                            96: 1,
                            137: 1
                        }, WTb);
                        _.Ib = function XTb() {
                            var a;
                            if (this.a) {
                                a = Wmb(this.a.a, this, 0);
                                return a >= 0 ? 'b' + a + '[' + bUb(this.a) + ']' : 'b[' + bUb(this.a) + ']';
                            }
                            return 'b_' + kFb(this);
                        };
                        var rP = sfb(Oze, 'FBendpoint', 250);
                        feb(290, 137, {
                            3: 1,
                            290: 1,
                            96: 1,
                            137: 1
                        }, cUb);
                        _.Ib = function dUb() {
                            return bUb(this);
                        };
                        var sP = sfb(Oze, 'FEdge', 290);
                        feb(235, 137, {
                            3: 1,
                            235: 1,
                            96: 1,
                            137: 1
                        }, gUb);
                        var tP = sfb(Oze, 'FGraph', 235);
                        feb(454, 309, {
                            3: 1,
                            454: 1,
                            309: 1,
                            96: 1,
                            137: 1
                        }, iUb);
                        _.Ib = function jUb() {
                            return this.b == null || this.b.length == 0 ? 'l[' + bUb(this.a) + ']' : 'l_' + this.b;
                        };
                        var uP = sfb(Oze, 'FLabel', 454);
                        feb(153, 309, {
                            3: 1,
                            153: 1,
                            309: 1,
                            96: 1,
                            137: 1
                        }, lUb);
                        _.Ib = function mUb() {
                            return kUb(this);
                        };
                        _.a = 0;
                        var vP = sfb(Oze, 'FNode', 153);
                        feb(2100, 1, {});
                        _.vf = function rUb(a) {
                            nUb(this, a);
                        };
                        _.wf = function sUb() {
                            oUb(this);
                        };
                        _.d = 0;
                        var xP = sfb(Qze, 'AbstractForceModel', 2100);
                        feb(641, 2100, {
                            641: 1
                        }, tUb);
                        _.uf = function vUb(a, b) {
                            var c, d, e, f, g;
                            qUb(this.f, a, b);
                            e = ojd(ajd(b.d), a.d);
                            g = $wnd.Math.sqrt(e.a * e.a + e.b * e.b);
                            d = $wnd.Math.max(0, g - ejd(a.e) / 2 - ejd(b.e) / 2);
                            c = fUb(this.e, a, b);
                            c > 0 ? f = -uUb(d, this.c) * c : f = yUb(d, this.b) * RD(mQb(a, (yVb(), lVb)), 17).a;
                            ijd(e, f / g);
                            return e;
                        };
                        _.vf = function wUb(a) {
                            nUb(this, a);
                            this.a = RD(mQb(a, (yVb(), aVb)), 17).a;
                            this.c = Kfb(UD(mQb(a, rVb)));
                            this.b = Kfb(UD(mQb(a, nVb)));
                        };
                        _.xf = function xUb(a) {
                            return a < this.a;
                        };
                        _.a = 0;
                        _.b = 0;
                        _.c = 0;
                        var yP = sfb(Qze, 'EadesModel', 641);
                        feb(642, 2100, {
                            642: 1
                        }, zUb);
                        _.uf = function BUb(a, b) {
                            var c, d, e, f, g;
                            qUb(this.f, a, b);
                            e = ojd(ajd(b.d), a.d);
                            g = $wnd.Math.sqrt(e.a * e.a + e.b * e.b);
                            d = $wnd.Math.max(0, g - ejd(a.e) / 2 - ejd(b.e) / 2);
                            f = FUb(d, this.a) * RD(mQb(a, (yVb(), lVb)), 17).a;
                            c = fUb(this.e, a, b);
                            c > 0 && (f -= AUb(d, this.a) * c);
                            ijd(e, f * this.b / g);
                            return e;
                        };
                        _.vf = function CUb(a) {
                            var b, c, d, e, f, g, h;
                            nUb(this, a);
                            this.b = Kfb(UD(mQb(a, (yVb(), sVb))));
                            this.c = this.b / RD(mQb(a, aVb), 17).a;
                            d = a.e.c.length;
                            f = 0;
                            e = 0;
                            for(h = new Anb(a.e); h.a < h.c.c.length;){
                                g = RD(ynb(h), 153);
                                f += g.e.a;
                                e += g.e.b;
                            }
                            b = f * e;
                            c = Kfb(UD(mQb(a, rVb))) * Tye;
                            this.a = $wnd.Math.sqrt(b / (2 * d)) * c;
                        };
                        _.wf = function DUb() {
                            oUb(this);
                            this.b -= this.c;
                        };
                        _.xf = function EUb(a) {
                            return this.b > 0;
                        };
                        _.a = 0;
                        _.b = 0;
                        _.c = 0;
                        var zP = sfb(Qze, 'FruchtermanReingoldModel', 642);
                        feb(860, 1, Eye, PUb);
                        _.hf = function QUb(a) {
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, Rze), ''), 'Force Model'), 'Determines the model for force calculation.'), IUb), (kid(), eid)), BP), xsb((Yhd(), Whd)))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, Sze), ''), 'Iterations'), 'The number of iterations on the force model.'), sgb(300)), gid), bJ), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, Tze), ''), 'Repulsive Power'), 'Determines how many bend points are added to the edge; such bend points are regarded as repelling particles in the force model'), sgb(0)), gid), bJ), xsb(Thd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, Uze), ''), 'FR Temperature'), 'The temperature is used as a scaling factor for particle displacements.'), Vze), did), VI), xsb(Whd))));
                            zgd(a, Uze, Rze, NUb);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, Wze), ''), 'Eades Repulsion'), "Factor for repulsive forces in Eades' model."), 5), did), VI), xsb(Whd))));
                            zgd(a, Wze, Rze, KUb);
                            zVb((new AVb, a));
                        };
                        var GUb, HUb, IUb, JUb, KUb, LUb, MUb, NUb;
                        var AP = sfb(Xze, 'ForceMetaDataProvider', 860);
                        feb(432, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            432: 1
                        }, UUb);
                        var RUb, SUb;
                        var BP = tfb(Xze, 'ForceModelStrategy', 432, WI, WUb, VUb);
                        var XUb;
                        feb(Awe, 1, Eye, AVb);
                        _.hf = function BVb(a) {
                            zVb(a);
                        };
                        var ZUb, $Ub, _Ub, aVb, bVb, cVb, dVb, eVb, fVb, gVb, hVb, iVb, jVb, kVb, lVb, mVb, nVb, oVb, pVb, qVb, rVb, sVb, tVb, uVb, vVb, wVb, xVb;
                        var DP = sfb(Xze, 'ForceOptions', Awe);
                        feb(1001, 1, {}, CVb);
                        _.sf = function DVb() {
                            var a;
                            return a = new TTb, a;
                        };
                        _.tf = function EVb(a) {};
                        var CP = sfb(Xze, 'ForceOptions/ForceFactory', 1001);
                        var FVb, GVb, HVb, IVb;
                        feb(861, 1, Eye, RVb);
                        _.hf = function SVb(a) {
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, vAe), ''), 'Fixed Position'), 'Prevent that the node is moved by the layout algorithm.'), (Geb(), false)), (kid(), cid)), QI), xsb((Yhd(), Vhd)))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, wAe), ''), 'Desired Edge Length'), 'Either specified for parent nodes or for individual edges, where the latter takes higher precedence.'), 100), did), VI), ysb(Whd, cD(WC(d3, 1), jwe, 170, 0, [
                                Thd
                            ])))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, xAe), ''), 'Layout Dimension'), 'Dimensions that are permitted to be altered during layout.'), MVb), eid), JP), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, yAe), ''), 'Stress Epsilon'), 'Termination criterion for the iterative process.'), Vze), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, zAe), ''), 'Iteration Limit'), "Maximum number of performed iterations. Takes higher precedence than 'epsilon'."), sgb(lve)), gid), bJ), xsb(Whd))));
                            eWb((new fWb, a));
                        };
                        var KVb, LVb, MVb, NVb, OVb, PVb;
                        var EP = sfb(Xze, 'StressMetaDataProvider', 861);
                        feb(1004, 1, Eye, fWb);
                        _.hf = function gWb(a) {
                            eWb(a);
                        };
                        var TVb, UVb, VVb, WVb, XVb, YVb, ZVb, $Vb, _Vb, aWb, bWb, cWb;
                        var GP = sfb(Xze, 'StressOptions', 1004);
                        feb(1005, 1, {}, hWb);
                        _.sf = function iWb() {
                            var a;
                            return a = new kWb, a;
                        };
                        _.tf = function jWb(a) {};
                        var FP = sfb(Xze, 'StressOptions/StressFactory', 1005);
                        feb(1110, 205, oze, kWb);
                        _.rf = function lWb(a, b) {
                            var c, d, e, f, g;
                            b.Ug(BAe, 1);
                            Heb(TD(Gxd(a, (dWb(), XVb)))) ? Heb(TD(Gxd(a, bWb))) || RFb((c = new SFb((lud(), new zud(a))), c)) : QTb(new TTb, a, b.eh(1));
                            e = KTb(a);
                            d = CTb(this.a, e);
                            for(g = d.Kc(); g.Ob();){
                                f = RD(g.Pb(), 235);
                                if (f.e.c.length <= 1) continue;
                                uWb(this.b, f);
                                sWb(this.b);
                                Umb(f.d, new mWb);
                            }
                            e = BTb(d);
                            JTb(e);
                            b.Vg();
                        };
                        var IP = sfb(DAe, 'StressLayoutProvider', 1110);
                        feb(1111, 1, Qve, mWb);
                        _.Cd = function nWb(a) {
                            hUb(RD(a, 454));
                        };
                        var HP = sfb(DAe, 'StressLayoutProvider/lambda$0$Type', 1111);
                        feb(1002, 1, {}, vWb);
                        _.c = 0;
                        _.e = 0;
                        _.g = 0;
                        var LP = sfb(DAe, 'StressMajorization', 1002);
                        feb(391, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            391: 1
                        }, BWb);
                        var xWb, yWb, zWb;
                        var JP = tfb(DAe, 'StressMajorization/Dimension', 391, WI, DWb, CWb);
                        var EWb;
                        feb(1003, 1, fye, GWb);
                        _.Ne = function HWb(a, b) {
                            return wWb(this.a, RD(a, 153), RD(b, 153));
                        };
                        _.Fb = function IWb(a) {
                            return this === a;
                        };
                        _.Oe = function JWb() {
                            return new Frb(this);
                        };
                        var KP = sfb(DAe, 'StressMajorization/lambda$0$Type', 1003);
                        feb(1192, 1, {}, RWb);
                        var OP = sfb(FAe, 'ElkLayered', 1192);
                        feb(1193, 1, Qve, UWb);
                        _.Cd = function VWb(a) {
                            SWb(this.a, RD(a, 36));
                        };
                        var MP = sfb(FAe, 'ElkLayered/lambda$0$Type', 1193);
                        feb(1194, 1, Qve, WWb);
                        _.Cd = function XWb(a) {
                            TWb(this.a, RD(a, 36));
                        };
                        var NP = sfb(FAe, 'ElkLayered/lambda$1$Type', 1194);
                        feb(1281, 1, {}, dXb);
                        var YWb, ZWb, $Wb;
                        var SP = sfb(FAe, 'GraphConfigurator', 1281);
                        feb(770, 1, Qve, fXb);
                        _.Cd = function gXb(a) {
                            aXb(this.a, RD(a, 10));
                        };
                        var PP = sfb(FAe, 'GraphConfigurator/lambda$0$Type', 770);
                        feb(771, 1, {}, hXb);
                        _.Kb = function iXb(a) {
                            return _Wb(), new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var QP = sfb(FAe, 'GraphConfigurator/lambda$1$Type', 771);
                        feb(772, 1, Qve, jXb);
                        _.Cd = function kXb(a) {
                            aXb(this.a, RD(a, 10));
                        };
                        var RP = sfb(FAe, 'GraphConfigurator/lambda$2$Type', 772);
                        feb(1109, 205, oze, lXb);
                        _.rf = function mXb(a, b) {
                            var c;
                            c = c5b(new k5b, a);
                            dE(Gxd(a, (yCc(), IAc))) === dE((Fnd(), Cnd)) ? LWb(this.a, c, b) : MWb(this.a, c, b);
                            b.$g() || J5b(new N5b, c);
                        };
                        var TP = sfb(FAe, 'LayeredLayoutProvider', 1109);
                        feb(367, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            367: 1
                        }, tXb);
                        var nXb, oXb, pXb, qXb, rXb;
                        var UP = tfb(FAe, 'LayeredPhases', 367, WI, vXb, uXb);
                        var wXb;
                        feb(1717, 1, {}, EXb);
                        _.i = 0;
                        var yXb;
                        var XP = sfb(GAe, 'ComponentsToCGraphTransformer', 1717);
                        var jYb;
                        feb(1718, 1, {}, FXb);
                        _.yf = function GXb(a, b) {
                            return $wnd.Math.min(a.a != null ? Kfb(a.a) : a.c.i, b.a != null ? Kfb(b.a) : b.c.i);
                        };
                        _.zf = function HXb(a, b) {
                            return $wnd.Math.min(a.a != null ? Kfb(a.a) : a.c.i, b.a != null ? Kfb(b.a) : b.c.i);
                        };
                        var VP = sfb(GAe, 'ComponentsToCGraphTransformer/1', 1718);
                        feb(86, 1, {
                            86: 1
                        });
                        _.i = 0;
                        _.k = true;
                        _.o = pxe;
                        var bQ = sfb(HAe, 'CNode', 86);
                        feb(470, 86, {
                            470: 1,
                            86: 1
                        }, IXb, JXb);
                        _.Ib = function KXb() {
                            return '';
                        };
                        var WP = sfb(GAe, 'ComponentsToCGraphTransformer/CRectNode', 470);
                        feb(1688, 1, {}, XXb);
                        var LXb, MXb;
                        var $P = sfb(GAe, 'OneDimensionalComponentsCompaction', 1688);
                        feb(1689, 1, {}, $Xb);
                        _.Kb = function _Xb(a) {
                            return YXb(RD(a, 42));
                        };
                        _.Fb = function aYb(a) {
                            return this === a;
                        };
                        var YP = sfb(GAe, 'OneDimensionalComponentsCompaction/lambda$0$Type', 1689);
                        feb(1690, 1, {}, bYb);
                        _.Kb = function cYb(a) {
                            return ZXb(RD(a, 42));
                        };
                        _.Fb = function dYb(a) {
                            return this === a;
                        };
                        var ZP = sfb(GAe, 'OneDimensionalComponentsCompaction/lambda$1$Type', 1690);
                        feb(1720, 1, {}, fYb);
                        var _P = sfb(HAe, 'CGraph', 1720);
                        feb(194, 1, {
                            194: 1
                        }, iYb);
                        _.b = 0;
                        _.c = 0;
                        _.e = 0;
                        _.g = true;
                        _.i = pxe;
                        var aQ = sfb(HAe, 'CGroup', 194);
                        feb(1719, 1, {}, lYb);
                        _.yf = function mYb(a, b) {
                            return $wnd.Math.max(a.a != null ? Kfb(a.a) : a.c.i, b.a != null ? Kfb(b.a) : b.c.i);
                        };
                        _.zf = function nYb(a, b) {
                            return $wnd.Math.max(a.a != null ? Kfb(a.a) : a.c.i, b.a != null ? Kfb(b.a) : b.c.i);
                        };
                        var cQ = sfb(HAe, kye, 1719);
                        feb(1721, 1, {}, EYb);
                        _.d = false;
                        var oYb;
                        var eQ = sfb(HAe, pye, 1721);
                        feb(1722, 1, {}, FYb);
                        _.Kb = function GYb(a) {
                            return pYb(), Geb(), RD(RD(a, 42).a, 86).d.e != 0 ? true : false;
                        };
                        _.Fb = function HYb(a) {
                            return this === a;
                        };
                        var dQ = sfb(HAe, qye, 1722);
                        feb(833, 1, {}, KYb);
                        _.a = false;
                        _.b = false;
                        _.c = false;
                        _.d = false;
                        var fQ = sfb(HAe, rye, 833);
                        feb(1898, 1, {}, QYb);
                        var kQ = sfb(IAe, sye, 1898);
                        var wQ = ufb(JAe, hye);
                        feb(1899, 1, {
                            382: 1
                        }, UYb);
                        _.bf = function VYb(a) {
                            SYb(this, RD(a, 476));
                        };
                        var hQ = sfb(IAe, tye, 1899);
                        feb(Owe, 1, fye, XYb);
                        _.Ne = function YYb(a, b) {
                            return WYb(RD(a, 86), RD(b, 86));
                        };
                        _.Fb = function ZYb(a) {
                            return this === a;
                        };
                        _.Oe = function $Yb() {
                            return new Frb(this);
                        };
                        var gQ = sfb(IAe, uye, Owe);
                        feb(476, 1, {
                            476: 1
                        }, _Yb);
                        _.a = false;
                        var iQ = sfb(IAe, vye, 476);
                        feb(1901, 1, fye, aZb);
                        _.Ne = function bZb(a, b) {
                            return RYb(RD(a, 476), RD(b, 476));
                        };
                        _.Fb = function cZb(a) {
                            return this === a;
                        };
                        _.Oe = function dZb() {
                            return new Frb(this);
                        };
                        var jQ = sfb(IAe, wye, 1901);
                        feb(148, 1, {
                            148: 1
                        }, eZb, fZb);
                        _.Fb = function gZb(a) {
                            var b;
                            if (a == null) return false;
                            if (mQ != rb(a)) return false;
                            b = RD(a, 148);
                            return Fvb(this.c, b.c) && Fvb(this.d, b.d);
                        };
                        _.Hb = function hZb() {
                            return Tnb(cD(WC(jJ, 1), rve, 1, 5, [
                                this.c,
                                this.d
                            ]));
                        };
                        _.Ib = function iZb() {
                            return '(' + this.c + pve + this.d + (this.a ? 'cx' : '') + this.b + ')';
                        };
                        _.a = true;
                        _.c = 0;
                        _.d = 0;
                        var mQ = sfb(JAe, 'Point', 148);
                        feb(416, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            416: 1
                        }, qZb);
                        var jZb, kZb, lZb, mZb;
                        var lQ = tfb(JAe, 'Point/Quadrant', 416, WI, uZb, tZb);
                        var vZb;
                        feb(1708, 1, {}, EZb);
                        _.b = null;
                        _.c = null;
                        _.d = null;
                        _.e = null;
                        _.f = null;
                        var xZb, yZb, zZb, AZb, BZb;
                        var vQ = sfb(JAe, 'RectilinearConvexHull', 1708);
                        feb(583, 1, {
                            382: 1
                        }, PZb);
                        _.bf = function QZb(a) {
                            OZb(this, RD(a, 148));
                        };
                        _.b = 0;
                        var MZb;
                        var oQ = sfb(JAe, 'RectilinearConvexHull/MaximalElementsEventHandler', 583);
                        feb(1710, 1, fye, SZb);
                        _.Ne = function TZb(a, b) {
                            return RZb(UD(a), UD(b));
                        };
                        _.Fb = function UZb(a) {
                            return this === a;
                        };
                        _.Oe = function VZb() {
                            return new Frb(this);
                        };
                        var nQ = sfb(JAe, 'RectilinearConvexHull/MaximalElementsEventHandler/lambda$0$Type', 1710);
                        feb(1709, 1, {
                            382: 1
                        }, XZb);
                        _.bf = function YZb(a) {
                            WZb(this, RD(a, 148));
                        };
                        _.a = 0;
                        _.b = null;
                        _.c = null;
                        _.d = null;
                        _.e = null;
                        var pQ = sfb(JAe, 'RectilinearConvexHull/RectangleEventHandler', 1709);
                        feb(1711, 1, fye, ZZb);
                        _.Ne = function $Zb(a, b) {
                            return GZb(RD(a, 148), RD(b, 148));
                        };
                        _.Fb = function _Zb(a) {
                            return this === a;
                        };
                        _.Oe = function a$b() {
                            return new Frb(this);
                        };
                        var qQ = sfb(JAe, 'RectilinearConvexHull/lambda$0$Type', 1711);
                        feb(1712, 1, fye, b$b);
                        _.Ne = function c$b(a, b) {
                            return HZb(RD(a, 148), RD(b, 148));
                        };
                        _.Fb = function d$b(a) {
                            return this === a;
                        };
                        _.Oe = function e$b() {
                            return new Frb(this);
                        };
                        var rQ = sfb(JAe, 'RectilinearConvexHull/lambda$1$Type', 1712);
                        feb(1713, 1, fye, f$b);
                        _.Ne = function g$b(a, b) {
                            return IZb(RD(a, 148), RD(b, 148));
                        };
                        _.Fb = function h$b(a) {
                            return this === a;
                        };
                        _.Oe = function i$b() {
                            return new Frb(this);
                        };
                        var sQ = sfb(JAe, 'RectilinearConvexHull/lambda$2$Type', 1713);
                        feb(1714, 1, fye, j$b);
                        _.Ne = function k$b(a, b) {
                            return JZb(RD(a, 148), RD(b, 148));
                        };
                        _.Fb = function l$b(a) {
                            return this === a;
                        };
                        _.Oe = function m$b() {
                            return new Frb(this);
                        };
                        var tQ = sfb(JAe, 'RectilinearConvexHull/lambda$3$Type', 1714);
                        feb(1715, 1, fye, n$b);
                        _.Ne = function o$b(a, b) {
                            return KZb(RD(a, 148), RD(b, 148));
                        };
                        _.Fb = function p$b(a) {
                            return this === a;
                        };
                        _.Oe = function q$b() {
                            return new Frb(this);
                        };
                        var uQ = sfb(JAe, 'RectilinearConvexHull/lambda$4$Type', 1715);
                        feb(1716, 1, {}, s$b);
                        var xQ = sfb(JAe, 'Scanline', 1716);
                        feb(2104, 1, {});
                        var yQ = sfb(KAe, 'AbstractGraphPlacer', 2104);
                        feb(335, 1, {
                            335: 1
                        }, C$b);
                        _.Ff = function D$b(a) {
                            if (this.Gf(a)) {
                                Rc(this.b, RD(mQb(a, (Ywc(), ewc)), 21), a);
                                return true;
                            } else return false;
                        };
                        _.Gf = function E$b(a) {
                            var b, c, d, e;
                            b = RD(mQb(a, (Ywc(), ewc)), 21);
                            e = RD(Qc(y$b, b), 21);
                            for(d = e.Kc(); d.Ob();){
                                c = RD(d.Pb(), 21);
                                if (!RD(Qc(this.b, c), 15).dc()) return false;
                            }
                            return true;
                        };
                        var y$b;
                        var BQ = sfb(KAe, 'ComponentGroup', 335);
                        feb(779, 2104, {}, J$b);
                        _.Hf = function K$b(a) {
                            var b, c;
                            for(c = new Anb(this.a); c.a < c.c.c.length;){
                                b = RD(ynb(c), 335);
                                if (b.Ff(a)) return;
                            }
                            Rmb(this.a, new C$b(a));
                        };
                        _.Ef = function L$b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o;
                            this.a.c.length = 0;
                            b.a.c.length = 0;
                            if (a.dc()) {
                                b.f.a = 0;
                                b.f.b = 0;
                                return;
                            }
                            g = RD(a.Xb(0), 36);
                            kQb(b, g);
                            for(e = a.Kc(); e.Ob();){
                                d = RD(e.Pb(), 36);
                                this.Hf(d);
                            }
                            o = new pjd;
                            f = Kfb(UD(mQb(g, (yCc(), SBc))));
                            for(j = new Anb(this.a); j.a < j.c.c.length;){
                                h = RD(ynb(j), 335);
                                k = F$b(h, f);
                                x$b(Uc(h.b), o.a, o.b);
                                o.a += k.a;
                                o.b += k.b;
                            }
                            b.f.a = o.a - f;
                            b.f.b = o.b - f;
                            if (Heb(TD(mQb(g, Vzc))) && dE(mQb(g, yAc)) === dE((Ymd(), Umd))) {
                                for(n = a.Kc(); n.Ob();){
                                    l = RD(n.Pb(), 36);
                                    w$b(l, l.c.a, l.c.b);
                                }
                                c = new j_b;
                                _$b(c, a, f);
                                for(m = a.Kc(); m.Ob();){
                                    l = RD(m.Pb(), 36);
                                    $id(hjd(l.c), c.e);
                                }
                                $id(hjd(b.f), c.a);
                            }
                            for(i = new Anb(this.a); i.a < i.c.c.length;){
                                h = RD(ynb(i), 335);
                                v$b(b, Uc(h.b));
                            }
                        };
                        var zQ = sfb(KAe, 'ComponentGroupGraphPlacer', 779);
                        feb(1312, 779, {}, N$b);
                        _.Hf = function O$b(a) {
                            M$b(this, a);
                        };
                        _.Ef = function P$b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
                            this.a.c.length = 0;
                            b.a.c.length = 0;
                            if (a.dc()) {
                                b.f.a = 0;
                                b.f.b = 0;
                                return;
                            }
                            g = RD(a.Xb(0), 36);
                            kQb(b, g);
                            for(e = a.Kc(); e.Ob();){
                                d = RD(e.Pb(), 36);
                                M$b(this, d);
                            }
                            t = new pjd;
                            s = new pjd;
                            p = new pjd;
                            o = new pjd;
                            f = Kfb(UD(mQb(g, (yCc(), SBc))));
                            for(j = new Anb(this.a); j.a < j.c.c.length;){
                                h = RD(ynb(j), 335);
                                if (Dmd(RD(mQb(b, (umd(), Nkd)), 88))) {
                                    p.a = t.a;
                                    for(r = new aw(Pc(Fc(h.b).a).a.kc()); r.b.Ob();){
                                        q = RD(_v(r.b.Pb()), 21);
                                        if (q.Hc((qpd(), Yod))) {
                                            p.a = s.a;
                                            break;
                                        }
                                    }
                                } else if (Emd(RD(mQb(b, Nkd), 88))) {
                                    p.b = t.b;
                                    for(r = new aw(Pc(Fc(h.b).a).a.kc()); r.b.Ob();){
                                        q = RD(_v(r.b.Pb()), 21);
                                        if (q.Hc((qpd(), ppd))) {
                                            p.b = s.b;
                                            break;
                                        }
                                    }
                                }
                                k = F$b(RD(h, 579), f);
                                x$b(Uc(h.b), p.a, p.b);
                                if (Dmd(RD(mQb(b, Nkd), 88))) {
                                    s.a = p.a + k.a;
                                    o.a = $wnd.Math.max(o.a, s.a);
                                    for(r = new aw(Pc(Fc(h.b).a).a.kc()); r.b.Ob();){
                                        q = RD(_v(r.b.Pb()), 21);
                                        if (q.Hc((qpd(), npd))) {
                                            t.a = p.a + k.a;
                                            break;
                                        }
                                    }
                                    s.b = p.b + k.b;
                                    p.b = s.b;
                                    o.b = $wnd.Math.max(o.b, p.b);
                                } else if (Emd(RD(mQb(b, Nkd), 88))) {
                                    s.b = p.b + k.b;
                                    o.b = $wnd.Math.max(o.b, s.b);
                                    for(r = new aw(Pc(Fc(h.b).a).a.kc()); r.b.Ob();){
                                        q = RD(_v(r.b.Pb()), 21);
                                        if (q.Hc((qpd(), Xod))) {
                                            t.b = p.b + k.b;
                                            break;
                                        }
                                    }
                                    s.a = p.a + k.a;
                                    p.a = s.a;
                                    o.a = $wnd.Math.max(o.a, p.a);
                                }
                            }
                            b.f.a = o.a - f;
                            b.f.b = o.b - f;
                            if (Heb(TD(mQb(g, Vzc))) && dE(mQb(g, yAc)) === dE((Ymd(), Umd))) {
                                for(n = a.Kc(); n.Ob();){
                                    l = RD(n.Pb(), 36);
                                    w$b(l, l.c.a, l.c.b);
                                }
                                c = new j_b;
                                _$b(c, a, f);
                                for(m = a.Kc(); m.Ob();){
                                    l = RD(m.Pb(), 36);
                                    $id(hjd(l.c), c.e);
                                }
                                $id(hjd(b.f), c.a);
                            }
                            for(i = new Anb(this.a); i.a < i.c.c.length;){
                                h = RD(ynb(i), 335);
                                v$b(b, Uc(h.b));
                            }
                        };
                        var AQ = sfb(KAe, 'ComponentGroupModelOrderGraphPlacer', 1312);
                        feb(389, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            389: 1
                        }, V$b);
                        var Q$b, R$b, S$b, T$b;
                        var CQ = tfb(KAe, 'ComponentOrderingStrategy', 389, WI, X$b, W$b);
                        var Y$b;
                        feb(659, 1, {}, j_b);
                        var KQ = sfb(KAe, 'ComponentsCompactor', 659);
                        feb(1533, 13, Cxe, m_b);
                        _.Fc = function n_b(a) {
                            return k_b(this, RD(a, 148));
                        };
                        var DQ = sfb(KAe, 'ComponentsCompactor/Hullpoints', 1533);
                        feb(1530, 1, {
                            855: 1
                        }, p_b);
                        _.a = false;
                        var EQ = sfb(KAe, 'ComponentsCompactor/InternalComponent', 1530);
                        feb(1529, 1, Vve, q_b);
                        _.Jc = function r_b(a) {
                            xgb(this, a);
                        };
                        _.Kc = function s_b() {
                            return new Anb(this.a);
                        };
                        var FQ = sfb(KAe, 'ComponentsCompactor/InternalConnectedComponents', 1529);
                        feb(1532, 1, {
                            602: 1
                        }, t_b);
                        _.Bf = function v_b() {
                            return null;
                        };
                        _.Cf = function w_b() {
                            return this.a;
                        };
                        _.Af = function u_b() {
                            return f_b(this.d);
                        };
                        _.Df = function x_b() {
                            return this.b;
                        };
                        var GQ = sfb(KAe, 'ComponentsCompactor/InternalExternalExtension', 1532);
                        feb(1531, 1, {
                            602: 1
                        }, y_b);
                        _.Cf = function B_b() {
                            return this.a;
                        };
                        _.Af = function z_b() {
                            return f_b(this.d);
                        };
                        _.Bf = function A_b() {
                            return this.c;
                        };
                        _.Df = function C_b() {
                            return this.b;
                        };
                        var HQ = sfb(KAe, 'ComponentsCompactor/InternalUnionExternalExtension', 1531);
                        feb(1535, 1, {}, D_b);
                        var IQ = sfb(KAe, 'ComponentsCompactor/OuterSegments', 1535);
                        feb(1534, 1, {}, E_b);
                        var JQ = sfb(KAe, 'ComponentsCompactor/Segments', 1534);
                        feb(1282, 1, {}, I_b);
                        var MQ = sfb(KAe, Lze, 1282);
                        feb(1283, 1, fye, K_b);
                        _.Ne = function L_b(a, b) {
                            return J_b(RD(a, 36), RD(b, 36));
                        };
                        _.Fb = function M_b(a) {
                            return this === a;
                        };
                        _.Oe = function N_b() {
                            return new Frb(this);
                        };
                        var LQ = sfb(KAe, 'ComponentsProcessor/lambda$0$Type', 1283);
                        feb(579, 335, {
                            335: 1,
                            579: 1
                        }, S_b);
                        _.Ff = function T_b(a) {
                            return Q_b(this, a);
                        };
                        _.Gf = function U_b(a) {
                            return R_b(this, a);
                        };
                        var O_b;
                        var NQ = sfb(KAe, 'ModelOrderComponentGroup', 579);
                        feb(1310, 2104, {}, V_b);
                        _.Ef = function W_b(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m;
                            if (a.gc() == 1) {
                                l = RD(a.Xb(0), 36);
                                if (l != b) {
                                    b.a.c.length = 0;
                                    u$b(b, l, 0, 0);
                                    kQb(b, l);
                                    C2b(b.d, l.d);
                                    b.f.a = l.f.a;
                                    b.f.b = l.f.b;
                                }
                                return;
                            } else if (a.dc()) {
                                b.a.c.length = 0;
                                b.f.a = 0;
                                b.f.b = 0;
                                return;
                            }
                            this.Jf(a, b);
                            e = RD(a.Xb(0), 36);
                            b.a.c.length = 0;
                            kQb(b, e);
                            j = 0;
                            m = 0;
                            for(g = a.Kc(); g.Ob();){
                                f = RD(g.Pb(), 36);
                                k = f.f;
                                j = $wnd.Math.max(j, k.a);
                                m += k.a * k.b;
                            }
                            j = $wnd.Math.max(j, $wnd.Math.sqrt(m) * Kfb(UD(mQb(b, (yCc(), Tzc)))));
                            d = Kfb(UD(mQb(b, SBc)));
                            this.If(a, b, j, d);
                            if (Heb(TD(mQb(e, Vzc)))) {
                                c = new j_b;
                                _$b(c, a, d);
                                for(i = a.Kc(); i.Ob();){
                                    h = RD(i.Pb(), 36);
                                    $id(hjd(h.c), c.e);
                                }
                                $id(hjd(b.f), c.a);
                            }
                            v$b(b, a);
                        };
                        _.If = function X_b(a, b, c, d) {
                            var e, f, g, h, i, j, k, l;
                            k = 0;
                            l = 0;
                            h = 0;
                            e = d;
                            for(g = a.Kc(); g.Ob();){
                                f = RD(g.Pb(), 36);
                                j = f.f;
                                if (k + j.a > c) {
                                    k = 0;
                                    l += h + d;
                                    h = 0;
                                }
                                i = f.c;
                                w$b(f, k + i.a, l + i.b);
                                hjd(i);
                                e = $wnd.Math.max(e, k + j.a);
                                h = $wnd.Math.max(h, j.b);
                                k += j.a + d;
                            }
                            b.f.a = e;
                            b.f.b = l + h;
                        };
                        _.Jf = function Y_b(a, b) {
                            var c, d, e, f, g;
                            if (dE(mQb(b, (yCc(), Yzc))) === dE((U$b(), T$b))) {
                                for(d = a.Kc(); d.Ob();){
                                    c = RD(d.Pb(), 36);
                                    g = 0;
                                    for(f = new Anb(c.a); f.a < f.c.c.length;){
                                        e = RD(ynb(f), 10);
                                        g += RD(mQb(e, JBc), 17).a;
                                    }
                                    c.p = g;
                                }
                                yob();
                                a.jd(new b0b);
                            }
                        };
                        var QQ = sfb(KAe, 'SimpleRowGraphPlacer', 1310);
                        feb(1313, 1310, {}, Z_b);
                        _.If = function $_b(a, b, c, d) {
                            var e, f, g, h, i, j, k, l, m, n;
                            m = 0;
                            n = 0;
                            h = 0;
                            e = d;
                            i = null;
                            l = 0;
                            for(g = a.Kc(); g.Ob();){
                                f = RD(g.Pb(), 36);
                                k = f.f;
                                if (m + k.a > c && !RD(mQb(f, (Ywc(), ewc)), 21).Hc((qpd(), Yod)) || !!i && RD(mQb(i, (Ywc(), ewc)), 21).Hc((qpd(), Xod)) || RD(mQb(f, (Ywc(), ewc)), 21).Hc((qpd(), ppd))) {
                                    m = l;
                                    n += h + d;
                                    h = 0;
                                }
                                j = f.c;
                                RD(mQb(f, (Ywc(), ewc)), 21).Hc((qpd(), Yod)) && (m = e + d);
                                w$b(f, m + j.a, n + j.b);
                                e = $wnd.Math.max(e, m + k.a);
                                RD(mQb(f, ewc), 21).Hc(npd) && (l = $wnd.Math.max(l, m + k.a + d));
                                hjd(j);
                                h = $wnd.Math.max(h, k.b);
                                m += k.a + d;
                                i = f;
                            }
                            b.f.a = e;
                            b.f.b = n + h;
                        };
                        _.Jf = function __b(a, b) {};
                        var OQ = sfb(KAe, 'ModelOrderRowGraphPlacer', 1313);
                        feb(1311, 1, fye, b0b);
                        _.Ne = function c0b(a, b) {
                            return a0b(RD(a, 36), RD(b, 36));
                        };
                        _.Fb = function d0b(a) {
                            return this === a;
                        };
                        _.Oe = function e0b() {
                            return new Frb(this);
                        };
                        var PQ = sfb(KAe, 'SimpleRowGraphPlacer/1', 1311);
                        var f0b;
                        feb(1280, 1, xye, l0b);
                        _.Lb = function m0b(a) {
                            var b;
                            return b = RD(mQb(RD(a, 249).b, (yCc(), RAc)), 75), !!b && b.b != 0;
                        };
                        _.Fb = function n0b(a) {
                            return this === a;
                        };
                        _.Mb = function o0b(a) {
                            var b;
                            return b = RD(mQb(RD(a, 249).b, (yCc(), RAc)), 75), !!b && b.b != 0;
                        };
                        var RQ = sfb(PAe, 'CompoundGraphPostprocessor/1', 1280);
                        feb(1279, 1, QAe, E0b);
                        _.Kf = function F0b(a, b) {
                            y0b(this, RD(a, 36), b);
                        };
                        var TQ = sfb(PAe, 'CompoundGraphPreprocessor', 1279);
                        feb(453, 1, {
                            453: 1
                        }, G0b);
                        _.c = false;
                        var SQ = sfb(PAe, 'CompoundGraphPreprocessor/ExternalPort', 453);
                        feb(249, 1, {
                            249: 1
                        }, J0b);
                        _.Ib = function K0b() {
                            return ps(this.c) + ':' + _0b(this.b);
                        };
                        var VQ = sfb(PAe, 'CrossHierarchyEdge', 249);
                        feb(777, 1, fye, M0b);
                        _.Ne = function N0b(a, b) {
                            return L0b(this, RD(a, 249), RD(b, 249));
                        };
                        _.Fb = function O0b(a) {
                            return this === a;
                        };
                        _.Oe = function Q0b() {
                            return new Frb(this);
                        };
                        var UQ = sfb(PAe, 'CrossHierarchyEdgeComparator', 777);
                        feb(305, 137, {
                            3: 1,
                            305: 1,
                            96: 1,
                            137: 1
                        });
                        _.p = 0;
                        var dR = sfb(RAe, 'LGraphElement', 305);
                        feb(18, 305, {
                            3: 1,
                            18: 1,
                            305: 1,
                            96: 1,
                            137: 1
                        }, a1b);
                        _.Ib = function b1b() {
                            return _0b(this);
                        };
                        var WQ = sfb(RAe, 'LEdge', 18);
                        feb(36, 305, {
                            3: 1,
                            20: 1,
                            36: 1,
                            305: 1,
                            96: 1,
                            137: 1
                        }, d1b);
                        _.Jc = function e1b(a) {
                            xgb(this, a);
                        };
                        _.Kc = function f1b() {
                            return new Anb(this.b);
                        };
                        _.Ib = function g1b() {
                            if (this.b.c.length == 0) return 'G-unlayered' + Fe(this.a);
                            else if (this.a.c.length == 0) return 'G-layered' + Fe(this.b);
                            return 'G[layerless' + Fe(this.a) + ', layers' + Fe(this.b) + ']';
                        };
                        var eR = sfb(RAe, 'LGraph', 36);
                        var h1b;
                        feb(666, 1, {});
                        _.Lf = function j1b() {
                            return this.e.n;
                        };
                        _.of = function k1b(a) {
                            return mQb(this.e, a);
                        };
                        _.Mf = function l1b() {
                            return this.e.o;
                        };
                        _.Nf = function m1b() {
                            return this.e.p;
                        };
                        _.pf = function n1b(a) {
                            return nQb(this.e, a);
                        };
                        _.Of = function o1b(a) {
                            this.e.n.a = a.a;
                            this.e.n.b = a.b;
                        };
                        _.Pf = function p1b(a) {
                            this.e.o.a = a.a;
                            this.e.o.b = a.b;
                        };
                        _.Qf = function q1b(a) {
                            this.e.p = a;
                        };
                        var XQ = sfb(RAe, 'LGraphAdapters/AbstractLShapeAdapter', 666);
                        feb(474, 1, {
                            853: 1
                        }, r1b);
                        _.Rf = function s1b() {
                            var a, b;
                            if (!this.b) {
                                this.b = ev(this.a.b.c.length);
                                for(b = new Anb(this.a.b); b.a < b.c.c.length;){
                                    a = RD(ynb(b), 72);
                                    Rmb(this.b, new D1b(a));
                                }
                            }
                            return this.b;
                        };
                        _.b = null;
                        var YQ = sfb(RAe, 'LGraphAdapters/LEdgeAdapter', 474);
                        feb(665, 1, {}, t1b);
                        _.Sf = function u1b() {
                            var a, b, c, d, e, f;
                            if (!this.b) {
                                this.b = new bnb;
                                for(d = new Anb(this.a.b); d.a < d.c.c.length;){
                                    c = RD(ynb(d), 30);
                                    for(f = new Anb(c.a); f.a < f.c.c.length;){
                                        e = RD(ynb(f), 10);
                                        if (this.c.Mb(e)) {
                                            Rmb(this.b, new F1b(this, e, this.e));
                                            if (this.d) {
                                                if (nQb(e, (Ywc(), Xwc))) for(b = RD(mQb(e, Xwc), 15).Kc(); b.Ob();){
                                                    a = RD(b.Pb(), 10);
                                                    Rmb(this.b, new F1b(this, a, false));
                                                }
                                                if (nQb(e, Vvc)) for(b = RD(mQb(e, Vvc), 15).Kc(); b.Ob();){
                                                    a = RD(b.Pb(), 10);
                                                    Rmb(this.b, new F1b(this, a, false));
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            return this.b;
                        };
                        _.Lf = function v1b() {
                            throw Adb(new kib(TAe));
                        };
                        _.of = function w1b(a) {
                            return mQb(this.a, a);
                        };
                        _.Mf = function x1b() {
                            return this.a.f;
                        };
                        _.Nf = function y1b() {
                            return this.a.p;
                        };
                        _.pf = function z1b(a) {
                            return nQb(this.a, a);
                        };
                        _.Of = function A1b(a) {
                            throw Adb(new kib(TAe));
                        };
                        _.Pf = function B1b(a) {
                            this.a.f.a = a.a;
                            this.a.f.b = a.b;
                        };
                        _.Qf = function C1b(a) {
                            this.a.p = a;
                        };
                        _.b = null;
                        _.d = false;
                        _.e = false;
                        var ZQ = sfb(RAe, 'LGraphAdapters/LGraphAdapter', 665);
                        feb(585, 666, {
                            187: 1
                        }, D1b);
                        var $Q = sfb(RAe, 'LGraphAdapters/LLabelAdapter', 585);
                        feb(584, 666, {
                            695: 1
                        }, F1b);
                        _.Tf = function G1b() {
                            return this.b;
                        };
                        _.Uf = function H1b() {
                            return yob(), yob(), vob;
                        };
                        _.Rf = function I1b() {
                            var a, b;
                            if (!this.a) {
                                this.a = ev(RD(this.e, 10).b.c.length);
                                for(b = new Anb(RD(this.e, 10).b); b.a < b.c.c.length;){
                                    a = RD(ynb(b), 72);
                                    Rmb(this.a, new D1b(a));
                                }
                            }
                            return this.a;
                        };
                        _.Vf = function J1b() {
                            var a;
                            a = RD(this.e, 10).d;
                            return new R2b(a.d, a.c, a.a, a.b);
                        };
                        _.Wf = function K1b() {
                            return yob(), yob(), vob;
                        };
                        _.Xf = function L1b() {
                            var a, b;
                            if (!this.c) {
                                this.c = ev(RD(this.e, 10).j.c.length);
                                for(b = new Anb(RD(this.e, 10).j); b.a < b.c.c.length;){
                                    a = RD(ynb(b), 12);
                                    Rmb(this.c, new Q1b(a, this.d));
                                }
                            }
                            return this.c;
                        };
                        _.Yf = function M1b() {
                            return Heb(TD(mQb(RD(this.e, 10), (Ywc(), Yvc))));
                        };
                        _.Zf = function N1b(a) {
                            RD(this.e, 10).d.b = a.b;
                            RD(this.e, 10).d.d = a.d;
                            RD(this.e, 10).d.c = a.c;
                            RD(this.e, 10).d.a = a.a;
                        };
                        _.$f = function O1b(a) {
                            RD(this.e, 10).f.b = a.b;
                            RD(this.e, 10).f.d = a.d;
                            RD(this.e, 10).f.c = a.c;
                            RD(this.e, 10).f.a = a.a;
                        };
                        _._f = function P1b() {
                            E1b(this, (i1b(), h1b));
                        };
                        _.a = null;
                        _.b = null;
                        _.c = null;
                        _.d = false;
                        var _Q = sfb(RAe, 'LGraphAdapters/LNodeAdapter', 584);
                        feb(1788, 666, {
                            852: 1
                        }, Q1b);
                        _.Uf = function R1b() {
                            var a, b, c, d, e, f, g, h;
                            if (this.d && RD(this.e, 12).i.k == (r3b(), q3b)) return yob(), yob(), vob;
                            else if (!this.a) {
                                this.a = new bnb;
                                for(c = new Anb(RD(this.e, 12).e); c.a < c.c.c.length;){
                                    a = RD(ynb(c), 18);
                                    Rmb(this.a, new r1b(a));
                                }
                                if (this.d) {
                                    d = RD(mQb(RD(this.e, 12), (Ywc(), Iwc)), 10);
                                    if (d) for(b = new is(Mr(Z2b(d).a.Kc(), new ir)); gs(b);){
                                        a = RD(hs(b), 18);
                                        Rmb(this.a, new r1b(a));
                                    }
                                }
                                if (nQb(RD(this.e, 12).i, (Ywc(), Pwc))) {
                                    g = RD(mQb(RD(this.e, 12).i, Pwc), 337);
                                    h = RD(cub(g.e, this.e), 113);
                                    if (h) for(f = new Anb(h.b); f.a < f.c.c.length;){
                                        e = RD(ynb(f), 340);
                                        Rmb(this.a, new r1b(e.a));
                                    }
                                }
                            }
                            return this.a;
                        };
                        _.Rf = function S1b() {
                            var a, b;
                            if (!this.b) {
                                this.b = ev(RD(this.e, 12).f.c.length);
                                for(b = new Anb(RD(this.e, 12).f); b.a < b.c.c.length;){
                                    a = RD(ynb(b), 72);
                                    Rmb(this.b, new D1b(a));
                                }
                            }
                            return this.b;
                        };
                        _.Wf = function T1b() {
                            var a, b, c, d, e, f, g, h;
                            if (this.d && RD(this.e, 12).i.k == (r3b(), q3b)) return yob(), yob(), vob;
                            else if (!this.c) {
                                this.c = new bnb;
                                for(c = new Anb(RD(this.e, 12).g); c.a < c.c.c.length;){
                                    a = RD(ynb(c), 18);
                                    Rmb(this.c, new r1b(a));
                                }
                                if (this.d) {
                                    d = RD(mQb(RD(this.e, 12), (Ywc(), Iwc)), 10);
                                    if (d) for(b = new is(Mr(a3b(d).a.Kc(), new ir)); gs(b);){
                                        a = RD(hs(b), 18);
                                        Rmb(this.c, new r1b(a));
                                    }
                                }
                                if (nQb(RD(this.e, 12).i, (Ywc(), Pwc))) {
                                    g = RD(mQb(RD(this.e, 12).i, Pwc), 337);
                                    h = RD(cub(g.e, this.e), 113);
                                    if (h) for(f = new Anb(h.e); f.a < f.c.c.length;){
                                        e = RD(ynb(f), 340);
                                        Rmb(this.c, new r1b(e.a));
                                    }
                                }
                            }
                            return this.c;
                        };
                        _.ag = function U1b() {
                            return RD(this.e, 12).j;
                        };
                        _.bg = function V1b() {
                            return Heb(TD(mQb(RD(this.e, 12), (Ywc(), nwc))));
                        };
                        _.a = null;
                        _.b = null;
                        _.c = null;
                        _.d = false;
                        var aR = sfb(RAe, 'LGraphAdapters/LPortAdapter', 1788);
                        feb(1789, 1, fye, X1b);
                        _.Ne = function Y1b(a, b) {
                            return W1b(RD(a, 12), RD(b, 12));
                        };
                        _.Fb = function Z1b(a) {
                            return this === a;
                        };
                        _.Oe = function $1b() {
                            return new Frb(this);
                        };
                        var bR = sfb(RAe, 'LGraphAdapters/PortComparator', 1789);
                        feb(818, 1, nwe, _1b);
                        _.Mb = function a2b(a) {
                            return RD(a, 10), i1b(), true;
                        };
                        var cR = sfb(RAe, 'LGraphAdapters/lambda$0$Type', 818);
                        feb(404, 305, {
                            3: 1,
                            305: 1,
                            404: 1,
                            96: 1,
                            137: 1
                        });
                        var yR = sfb(RAe, 'LShape', 404);
                        feb(72, 404, {
                            3: 1,
                            305: 1,
                            72: 1,
                            404: 1,
                            96: 1,
                            137: 1
                        }, x2b, y2b);
                        _.Ib = function z2b() {
                            var a;
                            a = w2b(this);
                            return a == null ? 'label' : 'l_' + a;
                        };
                        var fR = sfb(RAe, 'LLabel', 72);
                        feb(214, 1, {
                            3: 1,
                            4: 1,
                            214: 1,
                            423: 1
                        });
                        _.Fb = function K2b(a) {
                            var b;
                            if (ZD(a, 214)) {
                                b = RD(a, 214);
                                return this.d == b.d && this.a == b.a && this.b == b.b && this.c == b.c;
                            } else return false;
                        };
                        _.Hb = function L2b() {
                            var a, b;
                            a = Nfb(this.b) << 16;
                            a |= Nfb(this.a) & Bwe;
                            b = Nfb(this.c) << 16;
                            b |= Nfb(this.d) & Bwe;
                            return a ^ b;
                        };
                        _.cg = function N2b(b) {
                            var c, d, e, f, g, h, i, j, k, l, m;
                            g = 0;
                            while(g < b.length && M2b((BFb(g, b.length), b.charCodeAt(g)), YAe))++g;
                            c = b.length;
                            while(c > 0 && M2b((BFb(c - 1, b.length), b.charCodeAt(c - 1)), ZAe))--c;
                            if (g < c) {
                                l = vhb((AFb(g, c, b.length), b.substr(g, c - g)), ',|;');
                                try {
                                    for(i = l, j = 0, k = i.length; j < k; ++j){
                                        h = i[j];
                                        f = vhb(h, '=');
                                        if (f.length != 2) throw Adb(new agb('Expecting a list of key-value pairs.'));
                                        e = Dhb(f[0]);
                                        m = Neb(Dhb(f[1]));
                                        lhb(e, 'top') ? this.d = m : lhb(e, 'left') ? this.b = m : lhb(e, 'bottom') ? this.a = m : lhb(e, 'right') && (this.c = m);
                                    }
                                } catch (a) {
                                    a = zdb(a);
                                    if (ZD(a, 130)) {
                                        d = a;
                                        throw Adb(new agb($Ae + d));
                                    } else throw Adb(a);
                                }
                            }
                        };
                        _.Ib = function O2b() {
                            return '[top=' + this.d + ',left=' + this.b + ',bottom=' + this.a + ',right=' + this.c + ']';
                        };
                        _.a = 0;
                        _.b = 0;
                        _.c = 0;
                        _.d = 0;
                        var m3 = sfb(_Ae, 'Spacing', 214);
                        feb(140, 214, aBe, P2b, Q2b, R2b, S2b);
                        var h3 = sfb(_Ae, 'ElkMargin', 140);
                        feb(660, 140, aBe, T2b);
                        var gR = sfb(RAe, 'LMargin', 660);
                        feb(10, 404, {
                            3: 1,
                            305: 1,
                            10: 1,
                            404: 1,
                            96: 1,
                            137: 1
                        }, j3b);
                        _.Ib = function k3b() {
                            return i3b(this);
                        };
                        _.i = false;
                        var jR = sfb(RAe, 'LNode', 10);
                        feb(273, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            273: 1
                        }, s3b);
                        var l3b, m3b, n3b, o3b, p3b, q3b;
                        var hR = tfb(RAe, 'LNode/NodeType', 273, WI, u3b, t3b);
                        var v3b;
                        feb(775, 1, nwe, x3b);
                        _.Mb = function y3b(a) {
                            return Heb(TD(mQb(RD(a, 72), (yCc(), vAc))));
                        };
                        var iR = sfb(RAe, 'LNode/lambda$0$Type', 775);
                        feb(107, 214, bBe, z3b, A3b, B3b);
                        var i3 = sfb(_Ae, 'ElkPadding', 107);
                        feb(778, 107, bBe, C3b);
                        var kR = sfb(RAe, 'LPadding', 778);
                        feb(12, 404, {
                            3: 1,
                            305: 1,
                            12: 1,
                            404: 1,
                            96: 1,
                            137: 1
                        }, R3b);
                        _.Ib = function S3b() {
                            var a, b, c;
                            a = new bib;
                            Zhb((a.a += 'p_', a), M3b(this));
                            !!this.i && Zhb(Yhb((a.a += '[', a), this.i), ']');
                            if (this.e.c.length == 1 && this.g.c.length == 0 && RD(Vmb(this.e, 0), 18).c != this) {
                                b = RD(Vmb(this.e, 0), 18).c;
                                Zhb((a.a += ' << ', a), M3b(b));
                                Zhb(Yhb((a.a += '[', a), b.i), ']');
                            }
                            if (this.e.c.length == 0 && this.g.c.length == 1 && RD(Vmb(this.g, 0), 18).d != this) {
                                c = RD(Vmb(this.g, 0), 18).d;
                                Zhb((a.a += ' >> ', a), M3b(c));
                                Zhb(Yhb((a.a += '[', a), c.i), ']');
                            }
                            return a.a;
                        };
                        _.c = true;
                        _.d = false;
                        var D3b, E3b, F3b, G3b, H3b, I3b;
                        var xR = sfb(RAe, 'LPort', 12);
                        feb(408, 1, Vve, T3b);
                        _.Jc = function U3b(a) {
                            xgb(this, a);
                        };
                        _.Kc = function V3b() {
                            var a;
                            a = new Anb(this.a.e);
                            return new W3b(a);
                        };
                        var mR = sfb(RAe, 'LPort/1', 408);
                        feb(1309, 1, Ave, W3b);
                        _.Nb = function X3b(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function Z3b() {
                            return RD(ynb(this.a), 18).c;
                        };
                        _.Ob = function Y3b() {
                            return xnb(this.a);
                        };
                        _.Qb = function $3b() {
                            znb(this.a);
                        };
                        var lR = sfb(RAe, 'LPort/1/1', 1309);
                        feb(369, 1, Vve, _3b);
                        _.Jc = function a4b(a) {
                            xgb(this, a);
                        };
                        _.Kc = function b4b() {
                            var a;
                            return a = new Anb(this.a.g), new c4b(a);
                        };
                        var oR = sfb(RAe, 'LPort/2', 369);
                        feb(776, 1, Ave, c4b);
                        _.Nb = function d4b(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function f4b() {
                            return RD(ynb(this.a), 18).d;
                        };
                        _.Ob = function e4b() {
                            return xnb(this.a);
                        };
                        _.Qb = function g4b() {
                            znb(this.a);
                        };
                        var nR = sfb(RAe, 'LPort/2/1', 776);
                        feb(1302, 1, Vve, h4b);
                        _.Jc = function i4b(a) {
                            xgb(this, a);
                        };
                        _.Kc = function j4b() {
                            return new l4b(this);
                        };
                        var qR = sfb(RAe, 'LPort/CombineIter', 1302);
                        feb(208, 1, Ave, l4b);
                        _.Nb = function m4b(a) {
                            Ztb(this, a);
                        };
                        _.Qb = function p4b() {
                            $tb();
                        };
                        _.Ob = function n4b() {
                            return k4b(this);
                        };
                        _.Pb = function o4b() {
                            return xnb(this.a) ? ynb(this.a) : ynb(this.b);
                        };
                        var pR = sfb(RAe, 'LPort/CombineIter/1', 208);
                        feb(1303, 1, xye, r4b);
                        _.Lb = function s4b(a) {
                            return q4b(a);
                        };
                        _.Fb = function t4b(a) {
                            return this === a;
                        };
                        _.Mb = function u4b(a) {
                            return J3b(), RD(a, 12).g.c.length != 0;
                        };
                        var rR = sfb(RAe, 'LPort/lambda$0$Type', 1303);
                        feb(1304, 1, xye, w4b);
                        _.Lb = function x4b(a) {
                            return v4b(a);
                        };
                        _.Fb = function y4b(a) {
                            return this === a;
                        };
                        _.Mb = function z4b(a) {
                            return J3b(), RD(a, 12).e.c.length != 0;
                        };
                        var sR = sfb(RAe, 'LPort/lambda$1$Type', 1304);
                        feb(1305, 1, xye, A4b);
                        _.Lb = function B4b(a) {
                            return J3b(), RD(a, 12).j == (qpd(), Yod);
                        };
                        _.Fb = function C4b(a) {
                            return this === a;
                        };
                        _.Mb = function D4b(a) {
                            return J3b(), RD(a, 12).j == (qpd(), Yod);
                        };
                        var tR = sfb(RAe, 'LPort/lambda$2$Type', 1305);
                        feb(1306, 1, xye, E4b);
                        _.Lb = function F4b(a) {
                            return J3b(), RD(a, 12).j == (qpd(), Xod);
                        };
                        _.Fb = function G4b(a) {
                            return this === a;
                        };
                        _.Mb = function H4b(a) {
                            return J3b(), RD(a, 12).j == (qpd(), Xod);
                        };
                        var uR = sfb(RAe, 'LPort/lambda$3$Type', 1306);
                        feb(1307, 1, xye, I4b);
                        _.Lb = function J4b(a) {
                            return J3b(), RD(a, 12).j == (qpd(), npd);
                        };
                        _.Fb = function K4b(a) {
                            return this === a;
                        };
                        _.Mb = function L4b(a) {
                            return J3b(), RD(a, 12).j == (qpd(), npd);
                        };
                        var vR = sfb(RAe, 'LPort/lambda$4$Type', 1307);
                        feb(1308, 1, xye, M4b);
                        _.Lb = function N4b(a) {
                            return J3b(), RD(a, 12).j == (qpd(), ppd);
                        };
                        _.Fb = function O4b(a) {
                            return this === a;
                        };
                        _.Mb = function P4b(a) {
                            return J3b(), RD(a, 12).j == (qpd(), ppd);
                        };
                        var wR = sfb(RAe, 'LPort/lambda$5$Type', 1308);
                        feb(30, 305, {
                            3: 1,
                            20: 1,
                            305: 1,
                            30: 1,
                            96: 1,
                            137: 1
                        }, R4b);
                        _.Jc = function S4b(a) {
                            xgb(this, a);
                        };
                        _.Kc = function T4b() {
                            return new Anb(this.a);
                        };
                        _.Ib = function U4b() {
                            return 'L_' + Wmb(this.b.b, this, 0) + Fe(this.a);
                        };
                        var zR = sfb(RAe, 'Layer', 30);
                        feb(1330, 1, {}, k5b);
                        var JR = sfb(cBe, dBe, 1330);
                        feb(1334, 1, {}, o5b);
                        _.Kb = function p5b(a) {
                            return AGd(RD(a, 84));
                        };
                        var AR = sfb(cBe, 'ElkGraphImporter/0methodref$connectableShapeToNode$Type', 1334);
                        feb(1337, 1, {}, q5b);
                        _.Kb = function r5b(a) {
                            return AGd(RD(a, 84));
                        };
                        var BR = sfb(cBe, 'ElkGraphImporter/1methodref$connectableShapeToNode$Type', 1337);
                        feb(1331, 1, Qve, s5b);
                        _.Cd = function t5b(a) {
                            $4b(this.a, RD(a, 123));
                        };
                        var CR = sfb(cBe, Nze, 1331);
                        feb(1332, 1, Qve, u5b);
                        _.Cd = function v5b(a) {
                            $4b(this.a, RD(a, 123));
                        };
                        var DR = sfb(cBe, eBe, 1332);
                        feb(1333, 1, {}, w5b);
                        _.Kb = function x5b(a) {
                            return new SDb(null, new Swb(mzd(RD(a, 74)), 16));
                        };
                        var ER = sfb(cBe, fBe, 1333);
                        feb(1335, 1, nwe, y5b);
                        _.Mb = function z5b(a) {
                            return l5b(this.a, RD(a, 27));
                        };
                        var FR = sfb(cBe, gBe, 1335);
                        feb(1336, 1, {}, A5b);
                        _.Kb = function B5b(a) {
                            return new SDb(null, new Swb(lzd(RD(a, 74)), 16));
                        };
                        var GR = sfb(cBe, 'ElkGraphImporter/lambda$5$Type', 1336);
                        feb(1338, 1, nwe, C5b);
                        _.Mb = function D5b(a) {
                            return m5b(this.a, RD(a, 27));
                        };
                        var HR = sfb(cBe, 'ElkGraphImporter/lambda$7$Type', 1338);
                        feb(1339, 1, nwe, E5b);
                        _.Mb = function F5b(a) {
                            return n5b(RD(a, 74));
                        };
                        var IR = sfb(cBe, 'ElkGraphImporter/lambda$8$Type', 1339);
                        feb(1297, 1, {}, N5b);
                        var G5b;
                        var OR = sfb(cBe, 'ElkGraphLayoutTransferrer', 1297);
                        feb(1298, 1, nwe, Q5b);
                        _.Mb = function R5b(a) {
                            return O5b(this.a, RD(a, 18));
                        };
                        var KR = sfb(cBe, 'ElkGraphLayoutTransferrer/lambda$0$Type', 1298);
                        feb(1299, 1, Qve, S5b);
                        _.Cd = function T5b(a) {
                            H5b();
                            Rmb(this.a, RD(a, 18));
                        };
                        var LR = sfb(cBe, 'ElkGraphLayoutTransferrer/lambda$1$Type', 1299);
                        feb(1300, 1, nwe, U5b);
                        _.Mb = function V5b(a) {
                            return P5b(this.a, RD(a, 18));
                        };
                        var MR = sfb(cBe, 'ElkGraphLayoutTransferrer/lambda$2$Type', 1300);
                        feb(1301, 1, Qve, W5b);
                        _.Cd = function X5b(a) {
                            H5b();
                            Rmb(this.a, RD(a, 18));
                        };
                        var NR = sfb(cBe, 'ElkGraphLayoutTransferrer/lambda$3$Type', 1301);
                        feb(819, 1, {}, e6b);
                        var PR = sfb(hBe, 'BiLinkedHashMultiMap', 819);
                        feb(1550, 1, QAe, h6b);
                        _.Kf = function i6b(a, b) {
                            f6b(RD(a, 36), b);
                        };
                        var SR = sfb(hBe, 'CommentNodeMarginCalculator', 1550);
                        feb(1551, 1, {}, j6b);
                        _.Kb = function k6b(a) {
                            return new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var QR = sfb(hBe, 'CommentNodeMarginCalculator/lambda$0$Type', 1551);
                        feb(1552, 1, Qve, l6b);
                        _.Cd = function m6b(a) {
                            g6b(RD(a, 10));
                        };
                        var RR = sfb(hBe, 'CommentNodeMarginCalculator/lambda$1$Type', 1552);
                        feb(1553, 1, QAe, q6b);
                        _.Kf = function r6b(a, b) {
                            o6b(RD(a, 36), b);
                        };
                        var TR = sfb(hBe, 'CommentPostprocessor', 1553);
                        feb(1554, 1, QAe, v6b);
                        _.Kf = function w6b(a, b) {
                            s6b(RD(a, 36), b);
                        };
                        var UR = sfb(hBe, 'CommentPreprocessor', 1554);
                        feb(1555, 1, QAe, y6b);
                        _.Kf = function z6b(a, b) {
                            x6b(RD(a, 36), b);
                        };
                        var VR = sfb(hBe, 'ConstraintsPostprocessor', 1555);
                        feb(1556, 1, QAe, G6b);
                        _.Kf = function H6b(a, b) {
                            E6b(RD(a, 36), b);
                        };
                        var WR = sfb(hBe, 'EdgeAndLayerConstraintEdgeReverser', 1556);
                        feb(1557, 1, QAe, K6b);
                        _.Kf = function M6b(a, b) {
                            I6b(RD(a, 36), b);
                        };
                        var $R = sfb(hBe, 'EndLabelPostprocessor', 1557);
                        feb(1558, 1, {}, N6b);
                        _.Kb = function O6b(a) {
                            return new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var XR = sfb(hBe, 'EndLabelPostprocessor/lambda$0$Type', 1558);
                        feb(1559, 1, nwe, P6b);
                        _.Mb = function Q6b(a) {
                            return L6b(RD(a, 10));
                        };
                        var YR = sfb(hBe, 'EndLabelPostprocessor/lambda$1$Type', 1559);
                        feb(1560, 1, Qve, R6b);
                        _.Cd = function S6b(a) {
                            J6b(RD(a, 10));
                        };
                        var ZR = sfb(hBe, 'EndLabelPostprocessor/lambda$2$Type', 1560);
                        feb(1561, 1, QAe, b7b);
                        _.Kf = function e7b(a, b) {
                            Z6b(RD(a, 36), b);
                        };
                        var fS = sfb(hBe, 'EndLabelPreprocessor', 1561);
                        feb(1562, 1, {}, f7b);
                        _.Kb = function g7b(a) {
                            return new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var _R = sfb(hBe, 'EndLabelPreprocessor/lambda$0$Type', 1562);
                        feb(1563, 1, Qve, h7b);
                        _.Cd = function i7b(a) {
                            V6b(this.a, this.b, this.c, RD(a, 10));
                        };
                        _.a = 0;
                        _.b = 0;
                        _.c = false;
                        var aS = sfb(hBe, 'EndLabelPreprocessor/lambda$1$Type', 1563);
                        feb(1564, 1, nwe, j7b);
                        _.Mb = function k7b(a) {
                            return dE(mQb(RD(a, 72), (yCc(), wAc))) === dE((Omd(), Nmd));
                        };
                        var bS = sfb(hBe, 'EndLabelPreprocessor/lambda$2$Type', 1564);
                        feb(1565, 1, Qve, l7b);
                        _.Cd = function m7b(a) {
                            Mub(this.a, RD(a, 72));
                        };
                        var cS = sfb(hBe, 'EndLabelPreprocessor/lambda$3$Type', 1565);
                        feb(1566, 1, nwe, n7b);
                        _.Mb = function o7b(a) {
                            return dE(mQb(RD(a, 72), (yCc(), wAc))) === dE((Omd(), Mmd));
                        };
                        var dS = sfb(hBe, 'EndLabelPreprocessor/lambda$4$Type', 1566);
                        feb(1567, 1, Qve, p7b);
                        _.Cd = function q7b(a) {
                            Mub(this.a, RD(a, 72));
                        };
                        var eS = sfb(hBe, 'EndLabelPreprocessor/lambda$5$Type', 1567);
                        feb(1615, 1, QAe, z7b);
                        _.Kf = function A7b(a, b) {
                            w7b(RD(a, 36), b);
                        };
                        var r7b;
                        var nS = sfb(hBe, 'EndLabelSorter', 1615);
                        feb(1616, 1, fye, C7b);
                        _.Ne = function D7b(a, b) {
                            return B7b(RD(a, 466), RD(b, 466));
                        };
                        _.Fb = function E7b(a) {
                            return this === a;
                        };
                        _.Oe = function F7b() {
                            return new Frb(this);
                        };
                        var gS = sfb(hBe, 'EndLabelSorter/1', 1616);
                        feb(466, 1, {
                            466: 1
                        }, G7b);
                        var hS = sfb(hBe, 'EndLabelSorter/LabelGroup', 466);
                        feb(1617, 1, {}, H7b);
                        _.Kb = function I7b(a) {
                            return s7b(), new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var iS = sfb(hBe, 'EndLabelSorter/lambda$0$Type', 1617);
                        feb(1618, 1, nwe, J7b);
                        _.Mb = function K7b(a) {
                            return s7b(), RD(a, 10).k == (r3b(), p3b);
                        };
                        var jS = sfb(hBe, 'EndLabelSorter/lambda$1$Type', 1618);
                        feb(1619, 1, Qve, L7b);
                        _.Cd = function M7b(a) {
                            x7b(RD(a, 10));
                        };
                        var kS = sfb(hBe, 'EndLabelSorter/lambda$2$Type', 1619);
                        feb(1620, 1, nwe, N7b);
                        _.Mb = function O7b(a) {
                            return s7b(), dE(mQb(RD(a, 72), (yCc(), wAc))) === dE((Omd(), Mmd));
                        };
                        var lS = sfb(hBe, 'EndLabelSorter/lambda$3$Type', 1620);
                        feb(1621, 1, nwe, P7b);
                        _.Mb = function Q7b(a) {
                            return s7b(), dE(mQb(RD(a, 72), (yCc(), wAc))) === dE((Omd(), Nmd));
                        };
                        var mS = sfb(hBe, 'EndLabelSorter/lambda$4$Type', 1621);
                        feb(1568, 1, QAe, a8b);
                        _.Kf = function b8b(a, b) {
                            $7b(this, RD(a, 36));
                        };
                        _.b = 0;
                        _.c = 0;
                        var uS = sfb(hBe, 'FinalSplineBendpointsCalculator', 1568);
                        feb(1569, 1, {}, c8b);
                        _.Kb = function d8b(a) {
                            return new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var oS = sfb(hBe, 'FinalSplineBendpointsCalculator/lambda$0$Type', 1569);
                        feb(1570, 1, {}, e8b);
                        _.Kb = function f8b(a) {
                            return new SDb(null, new Twb(new is(Mr(a3b(RD(a, 10)).a.Kc(), new ir))));
                        };
                        var pS = sfb(hBe, 'FinalSplineBendpointsCalculator/lambda$1$Type', 1570);
                        feb(1571, 1, nwe, g8b);
                        _.Mb = function h8b(a) {
                            return !W0b(RD(a, 18));
                        };
                        var qS = sfb(hBe, 'FinalSplineBendpointsCalculator/lambda$2$Type', 1571);
                        feb(1572, 1, nwe, i8b);
                        _.Mb = function j8b(a) {
                            return nQb(RD(a, 18), (Ywc(), Twc));
                        };
                        var rS = sfb(hBe, 'FinalSplineBendpointsCalculator/lambda$3$Type', 1572);
                        feb(1573, 1, Qve, k8b);
                        _.Cd = function l8b(a) {
                            T7b(this.a, RD(a, 131));
                        };
                        var sS = sfb(hBe, 'FinalSplineBendpointsCalculator/lambda$4$Type', 1573);
                        feb(1574, 1, Qve, m8b);
                        _.Cd = function n8b(a) {
                            Eob(RD(a, 18).a);
                        };
                        var tS = sfb(hBe, 'FinalSplineBendpointsCalculator/lambda$5$Type', 1574);
                        feb(803, 1, QAe, L8b);
                        _.Kf = function M8b(a, b) {
                            C8b(this, RD(a, 36), b);
                        };
                        var wS = sfb(hBe, 'GraphTransformer', 803);
                        feb(517, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            517: 1
                        }, Q8b);
                        var N8b, O8b;
                        var vS = tfb(hBe, 'GraphTransformer/Mode', 517, WI, S8b, R8b);
                        var T8b;
                        feb(1575, 1, QAe, Z8b);
                        _.Kf = function $8b(a, b) {
                            W8b(RD(a, 36), b);
                        };
                        var xS = sfb(hBe, 'HierarchicalNodeResizingProcessor', 1575);
                        feb(1576, 1, QAe, f9b);
                        _.Kf = function g9b(a, b) {
                            b9b(RD(a, 36), b);
                        };
                        var zS = sfb(hBe, 'HierarchicalPortConstraintProcessor', 1576);
                        feb(1577, 1, fye, i9b);
                        _.Ne = function j9b(a, b) {
                            return h9b(RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function k9b(a) {
                            return this === a;
                        };
                        _.Oe = function l9b() {
                            return new Frb(this);
                        };
                        var yS = sfb(hBe, 'HierarchicalPortConstraintProcessor/NodeComparator', 1577);
                        feb(1578, 1, QAe, o9b);
                        _.Kf = function p9b(a, b) {
                            m9b(RD(a, 36), b);
                        };
                        var AS = sfb(hBe, 'HierarchicalPortDummySizeProcessor', 1578);
                        feb(1579, 1, QAe, C9b);
                        _.Kf = function D9b(a, b) {
                            v9b(this, RD(a, 36), b);
                        };
                        _.a = 0;
                        var DS = sfb(hBe, 'HierarchicalPortOrthogonalEdgeRouter', 1579);
                        feb(1580, 1, fye, F9b);
                        _.Ne = function G9b(a, b) {
                            return E9b(RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function H9b(a) {
                            return this === a;
                        };
                        _.Oe = function I9b() {
                            return new Frb(this);
                        };
                        var BS = sfb(hBe, 'HierarchicalPortOrthogonalEdgeRouter/1', 1580);
                        feb(1581, 1, fye, K9b);
                        _.Ne = function L9b(a, b) {
                            return J9b(RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function M9b(a) {
                            return this === a;
                        };
                        _.Oe = function N9b() {
                            return new Frb(this);
                        };
                        var CS = sfb(hBe, 'HierarchicalPortOrthogonalEdgeRouter/2', 1581);
                        feb(1582, 1, QAe, Q9b);
                        _.Kf = function R9b(a, b) {
                            P9b(RD(a, 36), b);
                        };
                        var ES = sfb(hBe, 'HierarchicalPortPositionProcessor', 1582);
                        feb(1583, 1, QAe, $9b);
                        _.Kf = function _9b(a, b) {
                            Z9b(this, RD(a, 36));
                        };
                        _.a = 0;
                        _.c = 0;
                        var S9b, T9b;
                        var IS = sfb(hBe, 'HighDegreeNodeLayeringProcessor', 1583);
                        feb(580, 1, {
                            580: 1
                        }, aac);
                        _.b = -1;
                        _.d = -1;
                        var FS = sfb(hBe, 'HighDegreeNodeLayeringProcessor/HighDegreeNodeInformation', 580);
                        feb(1584, 1, {}, bac);
                        _.Kb = function cac(a) {
                            return U9b(), Z2b(RD(a, 10));
                        };
                        _.Fb = function dac(a) {
                            return this === a;
                        };
                        var GS = sfb(hBe, 'HighDegreeNodeLayeringProcessor/lambda$0$Type', 1584);
                        feb(1585, 1, {}, eac);
                        _.Kb = function fac(a) {
                            return U9b(), a3b(RD(a, 10));
                        };
                        _.Fb = function gac(a) {
                            return this === a;
                        };
                        var HS = sfb(hBe, 'HighDegreeNodeLayeringProcessor/lambda$1$Type', 1585);
                        feb(1591, 1, QAe, mac);
                        _.Kf = function nac(a, b) {
                            lac(this, RD(a, 36), b);
                        };
                        var NS = sfb(hBe, 'HyperedgeDummyMerger', 1591);
                        feb(804, 1, {}, oac);
                        _.a = false;
                        _.b = false;
                        _.c = false;
                        var JS = sfb(hBe, 'HyperedgeDummyMerger/MergeState', 804);
                        feb(1592, 1, {}, pac);
                        _.Kb = function qac(a) {
                            return new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var KS = sfb(hBe, 'HyperedgeDummyMerger/lambda$0$Type', 1592);
                        feb(1593, 1, {}, rac);
                        _.Kb = function sac(a) {
                            return new SDb(null, new Swb(RD(a, 10).j, 16));
                        };
                        var LS = sfb(hBe, 'HyperedgeDummyMerger/lambda$1$Type', 1593);
                        feb(1594, 1, Qve, tac);
                        _.Cd = function uac(a) {
                            RD(a, 12).p = -1;
                        };
                        var MS = sfb(hBe, 'HyperedgeDummyMerger/lambda$2$Type', 1594);
                        feb(1595, 1, QAe, xac);
                        _.Kf = function yac(a, b) {
                            wac(RD(a, 36), b);
                        };
                        var OS = sfb(hBe, 'HypernodesProcessor', 1595);
                        feb(1596, 1, QAe, Aac);
                        _.Kf = function Bac(a, b) {
                            zac(RD(a, 36), b);
                        };
                        var PS = sfb(hBe, 'InLayerConstraintProcessor', 1596);
                        feb(1597, 1, QAe, Dac);
                        _.Kf = function Eac(a, b) {
                            Cac(RD(a, 36), b);
                        };
                        var QS = sfb(hBe, 'InnermostNodeMarginCalculator', 1597);
                        feb(1598, 1, QAe, Iac);
                        _.Kf = function Nac(a, b) {
                            Hac(this, RD(a, 36));
                        };
                        _.a = pxe;
                        _.b = pxe;
                        _.c = oxe;
                        _.d = oxe;
                        var XS = sfb(hBe, 'InteractiveExternalPortPositioner', 1598);
                        feb(1599, 1, {}, Oac);
                        _.Kb = function Pac(a) {
                            return RD(a, 18).d.i;
                        };
                        _.Fb = function Qac(a) {
                            return this === a;
                        };
                        var RS = sfb(hBe, 'InteractiveExternalPortPositioner/lambda$0$Type', 1599);
                        feb(1600, 1, {}, Rac);
                        _.Kb = function Sac(a) {
                            return Jac(this.a, UD(a));
                        };
                        _.Fb = function Tac(a) {
                            return this === a;
                        };
                        var SS = sfb(hBe, 'InteractiveExternalPortPositioner/lambda$1$Type', 1600);
                        feb(1601, 1, {}, Uac);
                        _.Kb = function Vac(a) {
                            return RD(a, 18).c.i;
                        };
                        _.Fb = function Wac(a) {
                            return this === a;
                        };
                        var TS = sfb(hBe, 'InteractiveExternalPortPositioner/lambda$2$Type', 1601);
                        feb(1602, 1, {}, Xac);
                        _.Kb = function Yac(a) {
                            return Kac(this.a, UD(a));
                        };
                        _.Fb = function Zac(a) {
                            return this === a;
                        };
                        var US = sfb(hBe, 'InteractiveExternalPortPositioner/lambda$3$Type', 1602);
                        feb(1603, 1, {}, $ac);
                        _.Kb = function _ac(a) {
                            return Lac(this.a, UD(a));
                        };
                        _.Fb = function abc(a) {
                            return this === a;
                        };
                        var VS = sfb(hBe, 'InteractiveExternalPortPositioner/lambda$4$Type', 1603);
                        feb(1604, 1, {}, bbc);
                        _.Kb = function cbc(a) {
                            return Mac(this.a, UD(a));
                        };
                        _.Fb = function dbc(a) {
                            return this === a;
                        };
                        var WS = sfb(hBe, 'InteractiveExternalPortPositioner/lambda$5$Type', 1604);
                        feb(81, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            81: 1,
                            196: 1
                        }, icc);
                        _.dg = function jcc() {
                            switch(this.g){
                                case 15:
                                    return new Hrc;
                                case 22:
                                    return new bsc;
                                case 47:
                                    return new ksc;
                                case 28:
                                case 35:
                                    return new Ldc;
                                case 32:
                                    return new h6b;
                                case 42:
                                    return new q6b;
                                case 1:
                                    return new v6b;
                                case 41:
                                    return new y6b;
                                case 56:
                                    return new L8b((P8b(), O8b));
                                case 0:
                                    return new L8b((P8b(), N8b));
                                case 2:
                                    return new G6b;
                                case 54:
                                    return new K6b;
                                case 33:
                                    return new b7b;
                                case 51:
                                    return new a8b;
                                case 55:
                                    return new Z8b;
                                case 13:
                                    return new f9b;
                                case 38:
                                    return new o9b;
                                case 44:
                                    return new C9b;
                                case 40:
                                    return new Q9b;
                                case 9:
                                    return new $9b;
                                case 49:
                                    return new Yjc;
                                case 37:
                                    return new mac;
                                case 43:
                                    return new xac;
                                case 27:
                                    return new Aac;
                                case 30:
                                    return new Dac;
                                case 3:
                                    return new Iac;
                                case 18:
                                    return new scc;
                                case 29:
                                    return new ycc;
                                case 5:
                                    return new Lcc;
                                case 50:
                                    return new Ucc;
                                case 34:
                                    return new pdc;
                                case 36:
                                    return new Zdc;
                                case 52:
                                    return new z7b;
                                case 11:
                                    return new fec;
                                case 7:
                                    return new pec;
                                case 39:
                                    return new Dec;
                                case 45:
                                    return new Gec;
                                case 16:
                                    return new Kec;
                                case 10:
                                    return new _ec;
                                case 48:
                                    return new Bfc;
                                case 21:
                                    return new Ifc;
                                case 23:
                                    return new FKc((RKc(), PKc));
                                case 8:
                                    return new Rfc;
                                case 12:
                                    return new Zfc;
                                case 4:
                                    return new cgc;
                                case 19:
                                    return new xgc;
                                case 17:
                                    return new Vgc;
                                case 53:
                                    return new Ygc;
                                case 6:
                                    return new Nhc;
                                case 25:
                                    return new ahc;
                                case 46:
                                    return new rhc;
                                case 31:
                                    return new Yhc;
                                case 14:
                                    return new jic;
                                case 26:
                                    return new Ssc;
                                case 20:
                                    return new yic;
                                case 24:
                                    return new FKc((RKc(), QKc));
                                default:
                                    throw Adb(new agb(lBe + (this.f != null ? this.f : '' + this.g)));
                            }
                        };
                        var ebc, fbc, gbc, hbc, ibc, jbc, kbc, lbc, mbc, nbc, obc, pbc, qbc, rbc, sbc, tbc, ubc, vbc, wbc, xbc, ybc, zbc, Abc, Bbc, Cbc, Dbc, Ebc, Fbc, Gbc, Hbc, Ibc, Jbc, Kbc, Lbc, Mbc, Nbc, Obc, Pbc, Qbc, Rbc, Sbc, Tbc, Ubc, Vbc, Wbc, Xbc, Ybc, Zbc, $bc, _bc, acc, bcc, ccc, dcc, ecc, fcc, gcc;
                        var YS = tfb(hBe, mBe, 81, WI, lcc, kcc);
                        var mcc;
                        feb(1605, 1, QAe, scc);
                        _.Kf = function tcc(a, b) {
                            qcc(RD(a, 36), b);
                        };
                        var ZS = sfb(hBe, 'InvertedPortProcessor', 1605);
                        feb(1606, 1, QAe, ycc);
                        _.Kf = function zcc(a, b) {
                            xcc(RD(a, 36), b);
                        };
                        var bT = sfb(hBe, 'LabelAndNodeSizeProcessor', 1606);
                        feb(1607, 1, nwe, Acc);
                        _.Mb = function Bcc(a) {
                            return RD(a, 10).k == (r3b(), p3b);
                        };
                        var $S = sfb(hBe, 'LabelAndNodeSizeProcessor/lambda$0$Type', 1607);
                        feb(1608, 1, nwe, Ccc);
                        _.Mb = function Dcc(a) {
                            return RD(a, 10).k == (r3b(), m3b);
                        };
                        var _S = sfb(hBe, 'LabelAndNodeSizeProcessor/lambda$1$Type', 1608);
                        feb(1609, 1, Qve, Ecc);
                        _.Cd = function Fcc(a) {
                            vcc(this.b, this.a, this.c, RD(a, 10));
                        };
                        _.a = false;
                        _.c = false;
                        var aT = sfb(hBe, 'LabelAndNodeSizeProcessor/lambda$2$Type', 1609);
                        feb(1610, 1, QAe, Lcc);
                        _.Kf = function Mcc(a, b) {
                            Jcc(RD(a, 36), b);
                        };
                        var Gcc;
                        var dT = sfb(hBe, 'LabelDummyInserter', 1610);
                        feb(1611, 1, xye, Ncc);
                        _.Lb = function Occ(a) {
                            return dE(mQb(RD(a, 72), (yCc(), wAc))) === dE((Omd(), Lmd));
                        };
                        _.Fb = function Pcc(a) {
                            return this === a;
                        };
                        _.Mb = function Qcc(a) {
                            return dE(mQb(RD(a, 72), (yCc(), wAc))) === dE((Omd(), Lmd));
                        };
                        var cT = sfb(hBe, 'LabelDummyInserter/1', 1611);
                        feb(1612, 1, QAe, Ucc);
                        _.Kf = function Vcc(a, b) {
                            Tcc(RD(a, 36), b);
                        };
                        var fT = sfb(hBe, 'LabelDummyRemover', 1612);
                        feb(1613, 1, nwe, Wcc);
                        _.Mb = function Xcc(a) {
                            return Heb(TD(mQb(RD(a, 72), (yCc(), vAc))));
                        };
                        var eT = sfb(hBe, 'LabelDummyRemover/lambda$0$Type', 1613);
                        feb(1378, 1, QAe, pdc);
                        _.Kf = function tdc(a, b) {
                            ldc(this, RD(a, 36), b);
                        };
                        _.a = null;
                        var Ycc;
                        var mT = sfb(hBe, 'LabelDummySwitcher', 1378);
                        feb(293, 1, {
                            293: 1
                        }, xdc);
                        _.c = 0;
                        _.d = null;
                        _.f = 0;
                        var gT = sfb(hBe, 'LabelDummySwitcher/LabelDummyInfo', 293);
                        feb(1379, 1, {}, ydc);
                        _.Kb = function zdc(a) {
                            return Zcc(), new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var hT = sfb(hBe, 'LabelDummySwitcher/lambda$0$Type', 1379);
                        feb(1380, 1, nwe, Adc);
                        _.Mb = function Bdc(a) {
                            return Zcc(), RD(a, 10).k == (r3b(), n3b);
                        };
                        var iT = sfb(hBe, 'LabelDummySwitcher/lambda$1$Type', 1380);
                        feb(1381, 1, {}, Cdc);
                        _.Kb = function Ddc(a) {
                            return qdc(this.a, RD(a, 10));
                        };
                        var jT = sfb(hBe, 'LabelDummySwitcher/lambda$2$Type', 1381);
                        feb(1382, 1, Qve, Edc);
                        _.Cd = function Fdc(a) {
                            rdc(this.a, RD(a, 293));
                        };
                        var kT = sfb(hBe, 'LabelDummySwitcher/lambda$3$Type', 1382);
                        feb(1383, 1, fye, Gdc);
                        _.Ne = function Hdc(a, b) {
                            return sdc(RD(a, 293), RD(b, 293));
                        };
                        _.Fb = function Idc(a) {
                            return this === a;
                        };
                        _.Oe = function Jdc() {
                            return new Frb(this);
                        };
                        var lT = sfb(hBe, 'LabelDummySwitcher/lambda$4$Type', 1383);
                        feb(802, 1, QAe, Ldc);
                        _.Kf = function Mdc(a, b) {
                            Kdc(RD(a, 36), b);
                        };
                        var nT = sfb(hBe, 'LabelManagementProcessor', 802);
                        feb(1614, 1, QAe, Zdc);
                        _.Kf = function $dc(a, b) {
                            Tdc(RD(a, 36), b);
                        };
                        var oT = sfb(hBe, 'LabelSideSelector', 1614);
                        feb(1622, 1, QAe, fec);
                        _.Kf = function gec(a, b) {
                            bec(RD(a, 36), b);
                        };
                        var pT = sfb(hBe, 'LayerConstraintPostprocessor', 1622);
                        feb(1623, 1, QAe, pec);
                        _.Kf = function qec(a, b) {
                            nec(RD(a, 36), b);
                        };
                        var hec;
                        var rT = sfb(hBe, 'LayerConstraintPreprocessor', 1623);
                        feb(371, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            371: 1
                        }, xec);
                        var rec, sec, tec, uec;
                        var qT = tfb(hBe, 'LayerConstraintPreprocessor/HiddenNodeConnections', 371, WI, zec, yec);
                        var Aec;
                        feb(1624, 1, QAe, Dec);
                        _.Kf = function Eec(a, b) {
                            Cec(RD(a, 36), b);
                        };
                        var sT = sfb(hBe, 'LayerSizeAndGraphHeightCalculator', 1624);
                        feb(1625, 1, QAe, Gec);
                        _.Kf = function Iec(a, b) {
                            Fec(RD(a, 36), b);
                        };
                        var tT = sfb(hBe, 'LongEdgeJoiner', 1625);
                        feb(1626, 1, QAe, Kec);
                        _.Kf = function Mec(a, b) {
                            Jec(RD(a, 36), b);
                        };
                        var uT = sfb(hBe, 'LongEdgeSplitter', 1626);
                        feb(1627, 1, QAe, _ec);
                        _.Kf = function cfc(a, b) {
                            Vec(this, RD(a, 36), b);
                        };
                        _.e = 0;
                        _.f = 0;
                        _.j = 0;
                        _.k = 0;
                        _.n = 0;
                        _.o = 0;
                        var Pec, Qec;
                        var AT = sfb(hBe, 'NodePromotion', 1627);
                        feb(1628, 1, fye, efc);
                        _.Ne = function ffc(a, b) {
                            return dfc(RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function gfc(a) {
                            return this === a;
                        };
                        _.Oe = function hfc() {
                            return new Frb(this);
                        };
                        var vT = sfb(hBe, 'NodePromotion/1', 1628);
                        feb(1629, 1, fye, jfc);
                        _.Ne = function kfc(a, b) {
                            return ifc(RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function lfc(a) {
                            return this === a;
                        };
                        _.Oe = function mfc() {
                            return new Frb(this);
                        };
                        var wT = sfb(hBe, 'NodePromotion/2', 1629);
                        feb(1630, 1, {}, nfc);
                        _.Kb = function ofc(a) {
                            return RD(a, 42), Rec(), Geb(), true;
                        };
                        _.Fb = function pfc(a) {
                            return this === a;
                        };
                        var xT = sfb(hBe, 'NodePromotion/lambda$0$Type', 1630);
                        feb(1631, 1, {}, qfc);
                        _.Kb = function rfc(a) {
                            return afc(this.a, RD(a, 42));
                        };
                        _.Fb = function sfc(a) {
                            return this === a;
                        };
                        _.a = 0;
                        var yT = sfb(hBe, 'NodePromotion/lambda$1$Type', 1631);
                        feb(1632, 1, {}, tfc);
                        _.Kb = function ufc(a) {
                            return bfc(this.a, RD(a, 42));
                        };
                        _.Fb = function vfc(a) {
                            return this === a;
                        };
                        _.a = 0;
                        var zT = sfb(hBe, 'NodePromotion/lambda$2$Type', 1632);
                        feb(1633, 1, QAe, Bfc);
                        _.Kf = function Cfc(a, b) {
                            wfc(RD(a, 36), b);
                        };
                        var BT = sfb(hBe, 'NorthSouthPortPostprocessor', 1633);
                        feb(1634, 1, QAe, Ifc);
                        _.Kf = function Kfc(a, b) {
                            Gfc(RD(a, 36), b);
                        };
                        var DT = sfb(hBe, 'NorthSouthPortPreprocessor', 1634);
                        feb(1635, 1, fye, Lfc);
                        _.Ne = function Mfc(a, b) {
                            return Jfc(RD(a, 12), RD(b, 12));
                        };
                        _.Fb = function Nfc(a) {
                            return this === a;
                        };
                        _.Oe = function Ofc() {
                            return new Frb(this);
                        };
                        var CT = sfb(hBe, 'NorthSouthPortPreprocessor/lambda$0$Type', 1635);
                        feb(1636, 1, QAe, Rfc);
                        _.Kf = function Tfc(a, b) {
                            Qfc(RD(a, 36), b);
                        };
                        var GT = sfb(hBe, 'PartitionMidprocessor', 1636);
                        feb(1637, 1, nwe, Ufc);
                        _.Mb = function Vfc(a) {
                            return nQb(RD(a, 10), (yCc(), tBc));
                        };
                        var ET = sfb(hBe, 'PartitionMidprocessor/lambda$0$Type', 1637);
                        feb(1638, 1, Qve, Wfc);
                        _.Cd = function Xfc(a) {
                            Sfc(this.a, RD(a, 10));
                        };
                        var FT = sfb(hBe, 'PartitionMidprocessor/lambda$1$Type', 1638);
                        feb(1639, 1, QAe, Zfc);
                        _.Kf = function $fc(a, b) {
                            Yfc(RD(a, 36), b);
                        };
                        var HT = sfb(hBe, 'PartitionPostprocessor', 1639);
                        feb(1640, 1, QAe, cgc);
                        _.Kf = function dgc(a, b) {
                            agc(RD(a, 36), b);
                        };
                        var MT = sfb(hBe, 'PartitionPreprocessor', 1640);
                        feb(1641, 1, nwe, egc);
                        _.Mb = function fgc(a) {
                            return nQb(RD(a, 10), (yCc(), tBc));
                        };
                        var IT = sfb(hBe, 'PartitionPreprocessor/lambda$0$Type', 1641);
                        feb(1642, 1, {}, ggc);
                        _.Kb = function hgc(a) {
                            return new SDb(null, new Twb(new is(Mr(a3b(RD(a, 10)).a.Kc(), new ir))));
                        };
                        var JT = sfb(hBe, 'PartitionPreprocessor/lambda$1$Type', 1642);
                        feb(1643, 1, nwe, igc);
                        _.Mb = function jgc(a) {
                            return _fc(RD(a, 18));
                        };
                        var KT = sfb(hBe, 'PartitionPreprocessor/lambda$2$Type', 1643);
                        feb(1644, 1, Qve, kgc);
                        _.Cd = function lgc(a) {
                            bgc(RD(a, 18));
                        };
                        var LT = sfb(hBe, 'PartitionPreprocessor/lambda$3$Type', 1644);
                        feb(1645, 1, QAe, xgc);
                        _.Kf = function Bgc(a, b) {
                            ugc(RD(a, 36), b);
                        };
                        var mgc, ngc, ogc, pgc, qgc, rgc;
                        var ST = sfb(hBe, 'PortListSorter', 1645);
                        feb(1648, 1, fye, Dgc);
                        _.Ne = function Egc(a, b) {
                            return ygc(RD(a, 12), RD(b, 12));
                        };
                        _.Fb = function Fgc(a) {
                            return this === a;
                        };
                        _.Oe = function Ggc() {
                            return new Frb(this);
                        };
                        var NT = sfb(hBe, 'PortListSorter/lambda$0$Type', 1648);
                        feb(1650, 1, fye, Hgc);
                        _.Ne = function Igc(a, b) {
                            return zgc(RD(a, 12), RD(b, 12));
                        };
                        _.Fb = function Jgc(a) {
                            return this === a;
                        };
                        _.Oe = function Kgc() {
                            return new Frb(this);
                        };
                        var OT = sfb(hBe, 'PortListSorter/lambda$1$Type', 1650);
                        feb(1646, 1, {}, Lgc);
                        _.Kb = function Mgc(a) {
                            return sgc(), RD(a, 12).e;
                        };
                        var PT = sfb(hBe, 'PortListSorter/lambda$2$Type', 1646);
                        feb(1647, 1, {}, Ngc);
                        _.Kb = function Ogc(a) {
                            return sgc(), RD(a, 12).g;
                        };
                        var QT = sfb(hBe, 'PortListSorter/lambda$3$Type', 1647);
                        feb(1649, 1, fye, Pgc);
                        _.Ne = function Qgc(a, b) {
                            return Agc(RD(a, 12), RD(b, 12));
                        };
                        _.Fb = function Rgc(a) {
                            return this === a;
                        };
                        _.Oe = function Sgc() {
                            return new Frb(this);
                        };
                        var RT = sfb(hBe, 'PortListSorter/lambda$4$Type', 1649);
                        feb(1651, 1, QAe, Vgc);
                        _.Kf = function Wgc(a, b) {
                            Tgc(RD(a, 36), b);
                        };
                        var TT = sfb(hBe, 'PortSideProcessor', 1651);
                        feb(1652, 1, QAe, Ygc);
                        _.Kf = function Zgc(a, b) {
                            Xgc(RD(a, 36), b);
                        };
                        var UT = sfb(hBe, 'ReversedEdgeRestorer', 1652);
                        feb(1657, 1, QAe, ahc);
                        _.Kf = function bhc(a, b) {
                            $gc(this, RD(a, 36), b);
                        };
                        var _T = sfb(hBe, 'SelfLoopPortRestorer', 1657);
                        feb(1658, 1, {}, chc);
                        _.Kb = function dhc(a) {
                            return new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var VT = sfb(hBe, 'SelfLoopPortRestorer/lambda$0$Type', 1658);
                        feb(1659, 1, nwe, ehc);
                        _.Mb = function fhc(a) {
                            return RD(a, 10).k == (r3b(), p3b);
                        };
                        var WT = sfb(hBe, 'SelfLoopPortRestorer/lambda$1$Type', 1659);
                        feb(1660, 1, nwe, ghc);
                        _.Mb = function hhc(a) {
                            return nQb(RD(a, 10), (Ywc(), Pwc));
                        };
                        var XT = sfb(hBe, 'SelfLoopPortRestorer/lambda$2$Type', 1660);
                        feb(1661, 1, {}, ihc);
                        _.Kb = function jhc(a) {
                            return RD(mQb(RD(a, 10), (Ywc(), Pwc)), 337);
                        };
                        var YT = sfb(hBe, 'SelfLoopPortRestorer/lambda$3$Type', 1661);
                        feb(1662, 1, Qve, khc);
                        _.Cd = function lhc(a) {
                            _gc(this.a, RD(a, 337));
                        };
                        var ZT = sfb(hBe, 'SelfLoopPortRestorer/lambda$4$Type', 1662);
                        feb(805, 1, Qve, mhc);
                        _.Cd = function nhc(a) {
                            Rmc(RD(a, 105));
                        };
                        var $T = sfb(hBe, 'SelfLoopPortRestorer/lambda$5$Type', 805);
                        feb(1663, 1, QAe, rhc);
                        _.Kf = function thc(a, b) {
                            ohc(RD(a, 36), b);
                        };
                        var iU = sfb(hBe, 'SelfLoopPostProcessor', 1663);
                        feb(1664, 1, {}, uhc);
                        _.Kb = function vhc(a) {
                            return new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var aU = sfb(hBe, 'SelfLoopPostProcessor/lambda$0$Type', 1664);
                        feb(1665, 1, nwe, whc);
                        _.Mb = function xhc(a) {
                            return RD(a, 10).k == (r3b(), p3b);
                        };
                        var bU = sfb(hBe, 'SelfLoopPostProcessor/lambda$1$Type', 1665);
                        feb(1666, 1, nwe, yhc);
                        _.Mb = function zhc(a) {
                            return nQb(RD(a, 10), (Ywc(), Pwc));
                        };
                        var cU = sfb(hBe, 'SelfLoopPostProcessor/lambda$2$Type', 1666);
                        feb(1667, 1, Qve, Ahc);
                        _.Cd = function Bhc(a) {
                            phc(RD(a, 10));
                        };
                        var dU = sfb(hBe, 'SelfLoopPostProcessor/lambda$3$Type', 1667);
                        feb(1668, 1, {}, Chc);
                        _.Kb = function Dhc(a) {
                            return new SDb(null, new Swb(RD(a, 105).f, 1));
                        };
                        var eU = sfb(hBe, 'SelfLoopPostProcessor/lambda$4$Type', 1668);
                        feb(1669, 1, Qve, Ehc);
                        _.Cd = function Fhc(a) {
                            qhc(this.a, RD(a, 340));
                        };
                        var fU = sfb(hBe, 'SelfLoopPostProcessor/lambda$5$Type', 1669);
                        feb(1670, 1, nwe, Ghc);
                        _.Mb = function Hhc(a) {
                            return !!RD(a, 105).i;
                        };
                        var gU = sfb(hBe, 'SelfLoopPostProcessor/lambda$6$Type', 1670);
                        feb(1671, 1, Qve, Ihc);
                        _.Cd = function Jhc(a) {
                            shc(this.a, RD(a, 105));
                        };
                        var hU = sfb(hBe, 'SelfLoopPostProcessor/lambda$7$Type', 1671);
                        feb(1653, 1, QAe, Nhc);
                        _.Kf = function Ohc(a, b) {
                            Mhc(RD(a, 36), b);
                        };
                        var mU = sfb(hBe, 'SelfLoopPreProcessor', 1653);
                        feb(1654, 1, {}, Phc);
                        _.Kb = function Qhc(a) {
                            return new SDb(null, new Swb(RD(a, 105).f, 1));
                        };
                        var jU = sfb(hBe, 'SelfLoopPreProcessor/lambda$0$Type', 1654);
                        feb(1655, 1, {}, Rhc);
                        _.Kb = function Shc(a) {
                            return RD(a, 340).a;
                        };
                        var kU = sfb(hBe, 'SelfLoopPreProcessor/lambda$1$Type', 1655);
                        feb(1656, 1, Qve, Thc);
                        _.Cd = function Uhc(a) {
                            Lhc(RD(a, 18));
                        };
                        var lU = sfb(hBe, 'SelfLoopPreProcessor/lambda$2$Type', 1656);
                        feb(1672, 1, QAe, Yhc);
                        _.Kf = function Zhc(a, b) {
                            Whc(this, RD(a, 36), b);
                        };
                        var sU = sfb(hBe, 'SelfLoopRouter', 1672);
                        feb(1673, 1, {}, $hc);
                        _.Kb = function _hc(a) {
                            return new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var nU = sfb(hBe, 'SelfLoopRouter/lambda$0$Type', 1673);
                        feb(1674, 1, nwe, aic);
                        _.Mb = function bic(a) {
                            return RD(a, 10).k == (r3b(), p3b);
                        };
                        var oU = sfb(hBe, 'SelfLoopRouter/lambda$1$Type', 1674);
                        feb(1675, 1, nwe, cic);
                        _.Mb = function dic(a) {
                            return nQb(RD(a, 10), (Ywc(), Pwc));
                        };
                        var pU = sfb(hBe, 'SelfLoopRouter/lambda$2$Type', 1675);
                        feb(1676, 1, {}, eic);
                        _.Kb = function fic(a) {
                            return RD(mQb(RD(a, 10), (Ywc(), Pwc)), 337);
                        };
                        var qU = sfb(hBe, 'SelfLoopRouter/lambda$3$Type', 1676);
                        feb(1677, 1, Qve, gic);
                        _.Cd = function hic(a) {
                            Vhc(this.a, this.b, RD(a, 337));
                        };
                        var rU = sfb(hBe, 'SelfLoopRouter/lambda$4$Type', 1677);
                        feb(1678, 1, QAe, jic);
                        _.Kf = function mic(a, b) {
                            iic(RD(a, 36), b);
                        };
                        var xU = sfb(hBe, 'SemiInteractiveCrossMinProcessor', 1678);
                        feb(1679, 1, nwe, nic);
                        _.Mb = function oic(a) {
                            return RD(a, 10).k == (r3b(), p3b);
                        };
                        var tU = sfb(hBe, 'SemiInteractiveCrossMinProcessor/lambda$0$Type', 1679);
                        feb(1680, 1, nwe, pic);
                        _.Mb = function qic(a) {
                            return lQb(RD(a, 10))._b((yCc(), IBc));
                        };
                        var uU = sfb(hBe, 'SemiInteractiveCrossMinProcessor/lambda$1$Type', 1680);
                        feb(1681, 1, fye, ric);
                        _.Ne = function sic(a, b) {
                            return kic(RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function tic(a) {
                            return this === a;
                        };
                        _.Oe = function uic() {
                            return new Frb(this);
                        };
                        var vU = sfb(hBe, 'SemiInteractiveCrossMinProcessor/lambda$2$Type', 1681);
                        feb(1682, 1, {}, vic);
                        _.Ve = function wic(a, b) {
                            return lic(RD(a, 10), RD(b, 10));
                        };
                        var wU = sfb(hBe, 'SemiInteractiveCrossMinProcessor/lambda$3$Type', 1682);
                        feb(1684, 1, QAe, yic);
                        _.Kf = function Cic(a, b) {
                            xic(RD(a, 36), b);
                        };
                        var AU = sfb(hBe, 'SortByInputModelProcessor', 1684);
                        feb(1685, 1, nwe, Dic);
                        _.Mb = function Eic(a) {
                            return RD(a, 12).g.c.length != 0;
                        };
                        var yU = sfb(hBe, 'SortByInputModelProcessor/lambda$0$Type', 1685);
                        feb(1686, 1, Qve, Fic);
                        _.Cd = function Gic(a) {
                            Aic(this.a, RD(a, 12));
                        };
                        var zU = sfb(hBe, 'SortByInputModelProcessor/lambda$1$Type', 1686);
                        feb(1759, 817, {}, Pic);
                        _.df = function Qic(a) {
                            var b, c, d, e;
                            this.c = a;
                            switch(this.a.g){
                                case 2:
                                    b = new bnb;
                                    FDb(CDb(new SDb(null, new Swb(this.c.a.b, 16)), new Rjc), new Tjc(this, b));
                                    eHb(this, new Zic);
                                    Umb(b, new bjc);
                                    b.c.length = 0;
                                    FDb(CDb(new SDb(null, new Swb(this.c.a.b, 16)), new djc), new fjc(b));
                                    eHb(this, new jjc);
                                    Umb(b, new njc);
                                    b.c.length = 0;
                                    c = Wvb(TCb(HDb(new SDb(null, new Swb(this.c.a.b, 16)), new pjc(this))), new rjc);
                                    FDb(new SDb(null, new Swb(this.c.a.a, 16)), new vjc(c, b));
                                    eHb(this, new zjc);
                                    Umb(b, new Djc);
                                    b.c.length = 0;
                                    break;
                                case 3:
                                    d = new bnb;
                                    eHb(this, new Ric);
                                    e = Wvb(TCb(HDb(new SDb(null, new Swb(this.c.a.b, 16)), new Vic(this))), new tjc);
                                    FDb(CDb(new SDb(null, new Swb(this.c.a.b, 16)), new Fjc), new Hjc(e, d));
                                    eHb(this, new Ljc);
                                    Umb(d, new Pjc);
                                    d.c.length = 0;
                                    break;
                                default:
                                    throw Adb(new Ied);
                            }
                        };
                        _.b = 0;
                        var ZU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation', 1759);
                        feb(1760, 1, xye, Ric);
                        _.Lb = function Sic(a) {
                            return ZD(RD(a, 60).g, 154);
                        };
                        _.Fb = function Tic(a) {
                            return this === a;
                        };
                        _.Mb = function Uic(a) {
                            return ZD(RD(a, 60).g, 154);
                        };
                        var BU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$0$Type', 1760);
                        feb(1761, 1, {}, Vic);
                        _.Ye = function Wic(a) {
                            return Jic(this.a, RD(a, 60));
                        };
                        var CU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$1$Type', 1761);
                        feb(1769, 1, owe, Xic);
                        _.de = function Yic() {
                            Iic(this.a, this.b, -1);
                        };
                        _.b = 0;
                        var DU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$10$Type', 1769);
                        feb(1771, 1, xye, Zic);
                        _.Lb = function $ic(a) {
                            return ZD(RD(a, 60).g, 154);
                        };
                        _.Fb = function _ic(a) {
                            return this === a;
                        };
                        _.Mb = function ajc(a) {
                            return ZD(RD(a, 60).g, 154);
                        };
                        var EU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$11$Type', 1771);
                        feb(1772, 1, Qve, bjc);
                        _.Cd = function cjc(a) {
                            RD(a, 380).de();
                        };
                        var FU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$12$Type', 1772);
                        feb(1773, 1, nwe, djc);
                        _.Mb = function ejc(a) {
                            return ZD(RD(a, 60).g, 10);
                        };
                        var GU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$13$Type', 1773);
                        feb(1775, 1, Qve, fjc);
                        _.Cd = function gjc(a) {
                            Kic(this.a, RD(a, 60));
                        };
                        var HU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$14$Type', 1775);
                        feb(1774, 1, owe, hjc);
                        _.de = function ijc() {
                            Iic(this.b, this.a, -1);
                        };
                        _.a = 0;
                        var IU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$15$Type', 1774);
                        feb(1776, 1, xye, jjc);
                        _.Lb = function kjc(a) {
                            return ZD(RD(a, 60).g, 10);
                        };
                        _.Fb = function ljc(a) {
                            return this === a;
                        };
                        _.Mb = function mjc(a) {
                            return ZD(RD(a, 60).g, 10);
                        };
                        var JU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$16$Type', 1776);
                        feb(1777, 1, Qve, njc);
                        _.Cd = function ojc(a) {
                            RD(a, 380).de();
                        };
                        var KU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$17$Type', 1777);
                        feb(1778, 1, {}, pjc);
                        _.Ye = function qjc(a) {
                            return Lic(this.a, RD(a, 60));
                        };
                        var LU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$18$Type', 1778);
                        feb(1779, 1, {}, rjc);
                        _.We = function sjc() {
                            return 0;
                        };
                        var MU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$19$Type', 1779);
                        feb(1762, 1, {}, tjc);
                        _.We = function ujc() {
                            return 0;
                        };
                        var NU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$2$Type', 1762);
                        feb(1781, 1, Qve, vjc);
                        _.Cd = function wjc(a) {
                            Mic(this.a, this.b, RD(a, 316));
                        };
                        _.a = 0;
                        var OU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$20$Type', 1781);
                        feb(1780, 1, owe, xjc);
                        _.de = function yjc() {
                            Hic(this.a, this.b, -1);
                        };
                        _.b = 0;
                        var PU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$21$Type', 1780);
                        feb(1782, 1, xye, zjc);
                        _.Lb = function Ajc(a) {
                            return RD(a, 60), true;
                        };
                        _.Fb = function Bjc(a) {
                            return this === a;
                        };
                        _.Mb = function Cjc(a) {
                            return RD(a, 60), true;
                        };
                        var QU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$22$Type', 1782);
                        feb(1783, 1, Qve, Djc);
                        _.Cd = function Ejc(a) {
                            RD(a, 380).de();
                        };
                        var RU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$23$Type', 1783);
                        feb(1763, 1, nwe, Fjc);
                        _.Mb = function Gjc(a) {
                            return ZD(RD(a, 60).g, 10);
                        };
                        var SU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$3$Type', 1763);
                        feb(1765, 1, Qve, Hjc);
                        _.Cd = function Ijc(a) {
                            Nic(this.a, this.b, RD(a, 60));
                        };
                        _.a = 0;
                        var TU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$4$Type', 1765);
                        feb(1764, 1, owe, Jjc);
                        _.de = function Kjc() {
                            Iic(this.b, this.a, -1);
                        };
                        _.a = 0;
                        var UU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$5$Type', 1764);
                        feb(1766, 1, xye, Ljc);
                        _.Lb = function Mjc(a) {
                            return RD(a, 60), true;
                        };
                        _.Fb = function Njc(a) {
                            return this === a;
                        };
                        _.Mb = function Ojc(a) {
                            return RD(a, 60), true;
                        };
                        var VU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$6$Type', 1766);
                        feb(1767, 1, Qve, Pjc);
                        _.Cd = function Qjc(a) {
                            RD(a, 380).de();
                        };
                        var WU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$7$Type', 1767);
                        feb(1768, 1, nwe, Rjc);
                        _.Mb = function Sjc(a) {
                            return ZD(RD(a, 60).g, 154);
                        };
                        var XU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$8$Type', 1768);
                        feb(1770, 1, Qve, Tjc);
                        _.Cd = function Ujc(a) {
                            Oic(this.a, this.b, RD(a, 60));
                        };
                        var YU = sfb(rBe, 'EdgeAwareScanlineConstraintCalculation/lambda$9$Type', 1770);
                        feb(1586, 1, QAe, Yjc);
                        _.Kf = function bkc(a, b) {
                            Xjc(this, RD(a, 36), b);
                        };
                        var Vjc;
                        var bV = sfb(rBe, 'HorizontalGraphCompactor', 1586);
                        feb(1587, 1, {}, ckc);
                        _.ff = function dkc(a, b) {
                            var c, d, e;
                            if (_jc(a, b)) return 0;
                            c = Zjc(a);
                            d = Zjc(b);
                            if (!!c && c.k == (r3b(), m3b) || !!d && d.k == (r3b(), m3b)) return 0;
                            e = RD(mQb(this.a.a, (Ywc(), Qwc)), 312);
                            return ZEc(e, c ? c.k : (r3b(), o3b), d ? d.k : (r3b(), o3b));
                        };
                        _.gf = function ekc(a, b) {
                            var c, d, e;
                            if (_jc(a, b)) return 1;
                            c = Zjc(a);
                            d = Zjc(b);
                            e = RD(mQb(this.a.a, (Ywc(), Qwc)), 312);
                            return aFc(e, c ? c.k : (r3b(), o3b), d ? d.k : (r3b(), o3b));
                        };
                        var $U = sfb(rBe, 'HorizontalGraphCompactor/1', 1587);
                        feb(1588, 1, {}, fkc);
                        _.ef = function gkc(a, b) {
                            return Wjc(), a.a.i == 0;
                        };
                        var _U = sfb(rBe, 'HorizontalGraphCompactor/lambda$0$Type', 1588);
                        feb(1589, 1, {}, hkc);
                        _.ef = function ikc(a, b) {
                            return akc(this.a, a, b);
                        };
                        var aV = sfb(rBe, 'HorizontalGraphCompactor/lambda$1$Type', 1589);
                        feb(1730, 1, {}, Ckc);
                        var jkc, kkc;
                        var BV = sfb(rBe, 'LGraphToCGraphTransformer', 1730);
                        feb(1738, 1, nwe, Kkc);
                        _.Mb = function Lkc(a) {
                            return a != null;
                        };
                        var cV = sfb(rBe, 'LGraphToCGraphTransformer/0methodref$nonNull$Type', 1738);
                        feb(1731, 1, {}, Mkc);
                        _.Kb = function Nkc(a) {
                            return lkc(), jeb(mQb(RD(RD(a, 60).g, 10), (Ywc(), Awc)));
                        };
                        var dV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$0$Type', 1731);
                        feb(1732, 1, {}, Okc);
                        _.Kb = function Pkc(a) {
                            return lkc(), Mlc(RD(RD(a, 60).g, 154));
                        };
                        var eV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$1$Type', 1732);
                        feb(1741, 1, nwe, Qkc);
                        _.Mb = function Rkc(a) {
                            return lkc(), ZD(RD(a, 60).g, 10);
                        };
                        var fV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$10$Type', 1741);
                        feb(1742, 1, Qve, Skc);
                        _.Cd = function Tkc(a) {
                            Dkc(RD(a, 60));
                        };
                        var gV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$11$Type', 1742);
                        feb(1743, 1, nwe, Ukc);
                        _.Mb = function Vkc(a) {
                            return lkc(), ZD(RD(a, 60).g, 154);
                        };
                        var hV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$12$Type', 1743);
                        feb(1747, 1, Qve, Wkc);
                        _.Cd = function Xkc(a) {
                            Ekc(RD(a, 60));
                        };
                        var iV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$13$Type', 1747);
                        feb(1744, 1, Qve, Ykc);
                        _.Cd = function Zkc(a) {
                            Fkc(this.a, RD(a, 8));
                        };
                        _.a = 0;
                        var jV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$14$Type', 1744);
                        feb(1745, 1, Qve, $kc);
                        _.Cd = function _kc(a) {
                            Gkc(this.a, RD(a, 116));
                        };
                        _.a = 0;
                        var kV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$15$Type', 1745);
                        feb(1746, 1, Qve, alc);
                        _.Cd = function blc(a) {
                            Hkc(this.a, RD(a, 8));
                        };
                        _.a = 0;
                        var lV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$16$Type', 1746);
                        feb(1748, 1, {}, clc);
                        _.Kb = function dlc(a) {
                            return lkc(), new SDb(null, new Twb(new is(Mr(a3b(RD(a, 10)).a.Kc(), new ir))));
                        };
                        var mV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$17$Type', 1748);
                        feb(1749, 1, nwe, elc);
                        _.Mb = function flc(a) {
                            return lkc(), W0b(RD(a, 18));
                        };
                        var nV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$18$Type', 1749);
                        feb(1750, 1, Qve, glc);
                        _.Cd = function hlc(a) {
                            ukc(this.a, RD(a, 18));
                        };
                        var oV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$19$Type', 1750);
                        feb(1734, 1, Qve, ilc);
                        _.Cd = function jlc(a) {
                            vkc(this.a, RD(a, 154));
                        };
                        var pV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$2$Type', 1734);
                        feb(1751, 1, {}, klc);
                        _.Kb = function llc(a) {
                            return lkc(), new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var qV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$20$Type', 1751);
                        feb(1752, 1, {}, mlc);
                        _.Kb = function nlc(a) {
                            return lkc(), new SDb(null, new Twb(new is(Mr(a3b(RD(a, 10)).a.Kc(), new ir))));
                        };
                        var rV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$21$Type', 1752);
                        feb(1753, 1, {}, olc);
                        _.Kb = function plc(a) {
                            return lkc(), RD(mQb(RD(a, 18), (Ywc(), Twc)), 15);
                        };
                        var sV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$22$Type', 1753);
                        feb(1754, 1, nwe, qlc);
                        _.Mb = function rlc(a) {
                            return Ikc(RD(a, 15));
                        };
                        var tV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$23$Type', 1754);
                        feb(1755, 1, Qve, slc);
                        _.Cd = function tlc(a) {
                            nkc(this.a, RD(a, 15));
                        };
                        var uV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$24$Type', 1755);
                        feb(1733, 1, Qve, ulc);
                        _.Cd = function vlc(a) {
                            wkc(this.a, this.b, RD(a, 154));
                        };
                        var vV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$3$Type', 1733);
                        feb(1735, 1, {}, wlc);
                        _.Kb = function xlc(a) {
                            return lkc(), new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var wV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$4$Type', 1735);
                        feb(1736, 1, {}, ylc);
                        _.Kb = function zlc(a) {
                            return lkc(), new SDb(null, new Twb(new is(Mr(a3b(RD(a, 10)).a.Kc(), new ir))));
                        };
                        var xV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$5$Type', 1736);
                        feb(1737, 1, {}, Alc);
                        _.Kb = function Blc(a) {
                            return lkc(), RD(mQb(RD(a, 18), (Ywc(), Twc)), 15);
                        };
                        var yV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$6$Type', 1737);
                        feb(1739, 1, Qve, Clc);
                        _.Cd = function Dlc(a) {
                            Jkc(this.a, RD(a, 15));
                        };
                        var zV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$8$Type', 1739);
                        feb(1740, 1, Qve, Elc);
                        _.Cd = function Flc(a) {
                            xkc(this.a, this.b, RD(a, 154));
                        };
                        var AV = sfb(rBe, 'LGraphToCGraphTransformer/lambda$9$Type', 1740);
                        feb(1729, 1, {}, Jlc);
                        _.cf = function Klc(a) {
                            var b, c, d, e, f;
                            this.a = a;
                            this.d = new BIb;
                            this.c = $C(DN, rve, 125, this.a.a.a.c.length, 0, 1);
                            this.b = 0;
                            for(c = new Anb(this.a.a.a); c.a < c.c.c.length;){
                                b = RD(ynb(c), 316);
                                b.d = this.b;
                                f = eJb(fJb(new gJb, b), this.d);
                                this.c[this.b] = f;
                                ++this.b;
                            }
                            Ilc(this);
                            Hlc(this);
                            Glc(this);
                            lJb(CJb(this.d), new Oqd);
                            for(e = new Anb(this.a.a.b); e.a < e.c.c.length;){
                                d = RD(ynb(e), 60);
                                d.d.c = this.c[d.a.d].e + d.b.a;
                            }
                        };
                        _.b = 0;
                        var CV = sfb(rBe, 'NetworkSimplexCompaction', 1729);
                        feb(154, 1, {
                            34: 1,
                            154: 1
                        }, Nlc);
                        _.Fd = function Olc(a) {
                            return Llc(this, RD(a, 154));
                        };
                        _.Ib = function Plc() {
                            return Mlc(this);
                        };
                        var DV = sfb(rBe, 'VerticalSegment', 154);
                        feb(841, 1, {}, Ylc);
                        _.c = 0;
                        _.e = 0;
                        _.i = 0;
                        var GV = sfb(sBe, 'BetweenLayerEdgeTwoNodeCrossingsCounter', 841);
                        feb(677, 1, {
                            677: 1
                        }, dmc);
                        _.Ib = function emc() {
                            return 'AdjacencyList [node=' + this.d + ', adjacencies= ' + this.a + ']';
                        };
                        _.b = 0;
                        _.c = 0;
                        _.f = 0;
                        var FV = sfb(sBe, 'BetweenLayerEdgeTwoNodeCrossingsCounter/AdjacencyList', 677);
                        feb(294, 1, {
                            34: 1,
                            294: 1
                        }, hmc);
                        _.Fd = function imc(a) {
                            return fmc(this, RD(a, 294));
                        };
                        _.Ib = function jmc() {
                            return 'Adjacency [position=' + this.c + ', cardinality=' + this.a + ', currentCardinality=' + this.b + ']';
                        };
                        _.a = 0;
                        _.b = 0;
                        _.c = 0;
                        var EV = sfb(sBe, 'BetweenLayerEdgeTwoNodeCrossingsCounter/AdjacencyList/Adjacency', 294);
                        feb(2026, 1, {}, mmc);
                        _.b = 0;
                        _.e = false;
                        var HV = sfb(sBe, 'CrossingMatrixFiller', 2026);
                        var QY = ufb(tBe, 'IInitializable');
                        feb(1867, 1, uBe, smc);
                        _.gg = function vmc(a, b, c, d, e, f) {};
                        _.ig = function xmc(a, b, c) {};
                        _.eg = function tmc() {
                            return this.c != (RKc(), PKc);
                        };
                        _.fg = function umc() {
                            this.e = $C(kE, Pwe, 28, this.d, 15, 1);
                        };
                        _.hg = function wmc(a, b) {
                            b[a][0].c.p = a;
                        };
                        _.jg = function ymc(a, b, c, d) {
                            ++this.d;
                        };
                        _.kg = function zmc() {
                            return true;
                        };
                        _.lg = function Amc(a, b, c, d) {
                            omc(this, a, b, c);
                            return nmc(this, b);
                        };
                        _.mg = function Bmc(a, b) {
                            var c;
                            c = pmc(b, a.length);
                            omc(this, a, c, b);
                            return qmc(this, c);
                        };
                        _.d = 0;
                        var IV = sfb(sBe, 'GreedySwitchHeuristic', 1867);
                        feb(2029, 1, {}, Kmc);
                        _.b = 0;
                        _.d = 0;
                        var JV = sfb(sBe, 'NorthSouthEdgeNeighbouringNodeCrossingsCounter', 2029);
                        feb(2016, 1, {}, Pmc);
                        _.a = false;
                        var KV = sfb(sBe, 'SwitchDecider', 2016);
                        feb(105, 1, {
                            105: 1
                        }, Vmc);
                        _.a = null;
                        _.c = null;
                        _.i = null;
                        var NV = sfb(vBe, 'SelfHyperLoop', 105);
                        feb(2013, 1, {}, _mc);
                        _.c = 0;
                        _.e = 0;
                        var MV = sfb(vBe, 'SelfHyperLoopLabels', 2013);
                        feb(421, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            421: 1
                        }, fnc);
                        var anc, bnc, cnc, dnc;
                        var LV = tfb(vBe, 'SelfHyperLoopLabels/Alignment', 421, WI, hnc, gnc);
                        var inc;
                        feb(340, 1, {
                            340: 1
                        }, knc);
                        var OV = sfb(vBe, 'SelfLoopEdge', 340);
                        feb(337, 1, {
                            337: 1
                        }, onc);
                        _.a = false;
                        var QV = sfb(vBe, 'SelfLoopHolder', 337);
                        feb(1790, 1, nwe, qnc);
                        _.Mb = function rnc(a) {
                            return W0b(RD(a, 18));
                        };
                        var PV = sfb(vBe, 'SelfLoopHolder/lambda$0$Type', 1790);
                        feb(113, 1, {
                            113: 1
                        }, tnc);
                        _.a = false;
                        _.c = false;
                        var SV = sfb(vBe, 'SelfLoopPort', 113);
                        feb(1855, 1, nwe, unc);
                        _.Mb = function vnc(a) {
                            return W0b(RD(a, 18));
                        };
                        var RV = sfb(vBe, 'SelfLoopPort/lambda$0$Type', 1855);
                        feb(375, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            375: 1
                        }, Cnc);
                        var wnc, xnc, ync, znc, Anc;
                        var TV = tfb(vBe, 'SelfLoopType', 375, WI, Fnc, Enc);
                        var Gnc;
                        feb(1798, 1, {}, boc);
                        var Inc, Jnc, Knc, Lnc;
                        var gW = sfb(wBe, 'PortRestorer', 1798);
                        feb(372, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            372: 1
                        }, koc);
                        var goc, hoc, ioc;
                        var UV = tfb(wBe, 'PortRestorer/PortSideArea', 372, WI, moc, loc);
                        var noc;
                        feb(1799, 1, {}, poc);
                        _.Kb = function qoc(a) {
                            return Mnc(), RD(a, 15).Oc();
                        };
                        var VV = sfb(wBe, 'PortRestorer/lambda$0$Type', 1799);
                        feb(1800, 1, Qve, roc);
                        _.Cd = function soc(a) {
                            Mnc();
                            RD(a, 113).c = false;
                        };
                        var WV = sfb(wBe, 'PortRestorer/lambda$1$Type', 1800);
                        feb(1809, 1, nwe, toc);
                        _.Mb = function uoc(a) {
                            return Mnc(), RD(a, 12).j == (qpd(), ppd);
                        };
                        var XV = sfb(wBe, 'PortRestorer/lambda$10$Type', 1809);
                        feb(1810, 1, {}, voc);
                        _.Kb = function woc(a) {
                            return Mnc(), RD(a, 113).d;
                        };
                        var YV = sfb(wBe, 'PortRestorer/lambda$11$Type', 1810);
                        feb(1811, 1, Qve, xoc);
                        _.Cd = function yoc(a) {
                            coc(this.a, RD(a, 12));
                        };
                        var ZV = sfb(wBe, 'PortRestorer/lambda$12$Type', 1811);
                        feb(1801, 1, Qve, zoc);
                        _.Cd = function Aoc(a) {
                            doc(this.a, RD(a, 105));
                        };
                        var $V = sfb(wBe, 'PortRestorer/lambda$2$Type', 1801);
                        feb(1802, 1, fye, Boc);
                        _.Ne = function Coc(a, b) {
                            return eoc(RD(a, 113), RD(b, 113));
                        };
                        _.Fb = function Doc(a) {
                            return this === a;
                        };
                        _.Oe = function Eoc() {
                            return new Frb(this);
                        };
                        var _V = sfb(wBe, 'PortRestorer/lambda$3$Type', 1802);
                        feb(1803, 1, nwe, Foc);
                        _.Mb = function Goc(a) {
                            return Mnc(), RD(a, 113).c;
                        };
                        var aW = sfb(wBe, 'PortRestorer/lambda$4$Type', 1803);
                        feb(1804, 1, nwe, Hoc);
                        _.Mb = function Ioc(a) {
                            return Tnc(RD(a, 12));
                        };
                        var bW = sfb(wBe, 'PortRestorer/lambda$5$Type', 1804);
                        feb(1805, 1, nwe, Joc);
                        _.Mb = function Koc(a) {
                            return Mnc(), RD(a, 12).j == (qpd(), Yod);
                        };
                        var cW = sfb(wBe, 'PortRestorer/lambda$6$Type', 1805);
                        feb(1806, 1, nwe, Loc);
                        _.Mb = function Moc(a) {
                            return Mnc(), RD(a, 12).j == (qpd(), Xod);
                        };
                        var dW = sfb(wBe, 'PortRestorer/lambda$7$Type', 1806);
                        feb(1807, 1, nwe, Noc);
                        _.Mb = function Ooc(a) {
                            return Unc(RD(a, 12));
                        };
                        var eW = sfb(wBe, 'PortRestorer/lambda$8$Type', 1807);
                        feb(1808, 1, nwe, Poc);
                        _.Mb = function Qoc(a) {
                            return Mnc(), RD(a, 12).j == (qpd(), npd);
                        };
                        var fW = sfb(wBe, 'PortRestorer/lambda$9$Type', 1808);
                        feb(276, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            276: 1
                        }, fpc);
                        var Yoc, Zoc, $oc, _oc, apc, bpc, cpc, dpc;
                        var hW = tfb(wBe, 'PortSideAssigner/Target', 276, WI, hpc, gpc);
                        var ipc;
                        feb(1791, 1, {}, kpc);
                        _.Kb = function lpc(a) {
                            return CDb(new SDb(null, new Swb(RD(a, 105).j, 16)), new Cpc);
                        };
                        var iW = sfb(wBe, 'PortSideAssigner/lambda$1$Type', 1791);
                        feb(1792, 1, {}, mpc);
                        _.Kb = function npc(a) {
                            return RD(a, 113).d;
                        };
                        var jW = sfb(wBe, 'PortSideAssigner/lambda$2$Type', 1792);
                        feb(1793, 1, Qve, opc);
                        _.Cd = function ppc(a) {
                            Q3b(RD(a, 12), (qpd(), Yod));
                        };
                        var kW = sfb(wBe, 'PortSideAssigner/lambda$3$Type', 1793);
                        feb(1794, 1, {}, qpc);
                        _.Kb = function rpc(a) {
                            return RD(a, 113).d;
                        };
                        var lW = sfb(wBe, 'PortSideAssigner/lambda$4$Type', 1794);
                        feb(1795, 1, Qve, spc);
                        _.Cd = function tpc(a) {
                            Voc(this.a, RD(a, 12));
                        };
                        var mW = sfb(wBe, 'PortSideAssigner/lambda$5$Type', 1795);
                        feb(1796, 1, fye, upc);
                        _.Ne = function vpc(a, b) {
                            return Woc(RD(a, 105), RD(b, 105));
                        };
                        _.Fb = function wpc(a) {
                            return this === a;
                        };
                        _.Oe = function xpc() {
                            return new Frb(this);
                        };
                        var nW = sfb(wBe, 'PortSideAssigner/lambda$6$Type', 1796);
                        feb(1797, 1, fye, ypc);
                        _.Ne = function zpc(a, b) {
                            return Xoc(RD(a, 113), RD(b, 113));
                        };
                        _.Fb = function Apc(a) {
                            return this === a;
                        };
                        _.Oe = function Bpc() {
                            return new Frb(this);
                        };
                        var oW = sfb(wBe, 'PortSideAssigner/lambda$7$Type', 1797);
                        feb(820, 1, nwe, Cpc);
                        _.Mb = function Dpc(a) {
                            return RD(a, 113).c;
                        };
                        var pW = sfb(wBe, 'PortSideAssigner/lambda$8$Type', 820);
                        feb(2108, 1, {});
                        var qW = sfb(xBe, 'AbstractSelfLoopRouter', 2108);
                        feb(1816, 1, fye, Mpc);
                        _.Ne = function Npc(a, b) {
                            return Kpc(RD(a, 105), RD(b, 105));
                        };
                        _.Fb = function Opc(a) {
                            return this === a;
                        };
                        _.Oe = function Ppc() {
                            return new Frb(this);
                        };
                        var rW = sfb(xBe, Vye, 1816);
                        feb(1817, 1, fye, Qpc);
                        _.Ne = function Rpc(a, b) {
                            return Lpc(RD(a, 105), RD(b, 105));
                        };
                        _.Fb = function Spc(a) {
                            return this === a;
                        };
                        _.Oe = function Tpc() {
                            return new Frb(this);
                        };
                        var sW = sfb(xBe, Wye, 1817);
                        feb(1856, 2108, {}, dqc);
                        _.ng = function eqc(a, b, c) {
                            return c;
                        };
                        var uW = sfb(xBe, 'OrthogonalSelfLoopRouter', 1856);
                        feb(1858, 1, Qve, fqc);
                        _.Cd = function gqc(a) {
                            cqc(this.b, this.a, RD(a, 8));
                        };
                        var tW = sfb(xBe, 'OrthogonalSelfLoopRouter/lambda$0$Type', 1858);
                        feb(1857, 1856, {}, jqc);
                        _.ng = function kqc(a, b, c) {
                            var d, e;
                            d = a.c.d;
                            hu(c, 0, $id(ajd(d.n), d.a));
                            e = a.d.d;
                            Mub(c, $id(ajd(e.n), e.a));
                            return hqc(c);
                        };
                        var vW = sfb(xBe, 'PolylineSelfLoopRouter', 1857);
                        feb(1812, 1, {}, yqc);
                        _.a = null;
                        var lqc;
                        var zW = sfb(xBe, 'RoutingDirector', 1812);
                        feb(1813, 1, fye, Aqc);
                        _.Ne = function Bqc(a, b) {
                            return zqc(RD(a, 113), RD(b, 113));
                        };
                        _.Fb = function Cqc(a) {
                            return this === a;
                        };
                        _.Oe = function Dqc() {
                            return new Frb(this);
                        };
                        var wW = sfb(xBe, 'RoutingDirector/lambda$0$Type', 1813);
                        feb(1814, 1, {}, Eqc);
                        _.Kb = function Fqc(a) {
                            return mqc(), RD(a, 105).j;
                        };
                        var xW = sfb(xBe, 'RoutingDirector/lambda$1$Type', 1814);
                        feb(1815, 1, Qve, Gqc);
                        _.Cd = function Hqc(a) {
                            mqc();
                            RD(a, 15).jd(lqc);
                        };
                        var yW = sfb(xBe, 'RoutingDirector/lambda$2$Type', 1815);
                        feb(1818, 1, {}, Sqc);
                        var CW = sfb(xBe, 'RoutingSlotAssigner', 1818);
                        feb(1819, 1, nwe, Vqc);
                        _.Mb = function Wqc(a) {
                            return Tqc(this.a, RD(a, 105));
                        };
                        var AW = sfb(xBe, 'RoutingSlotAssigner/lambda$0$Type', 1819);
                        feb(1820, 1, fye, Xqc);
                        _.Ne = function Yqc(a, b) {
                            return Uqc(this.a, RD(a, 105), RD(b, 105));
                        };
                        _.Fb = function Zqc(a) {
                            return this === a;
                        };
                        _.Oe = function $qc() {
                            return new Frb(this);
                        };
                        var BW = sfb(xBe, 'RoutingSlotAssigner/lambda$1$Type', 1820);
                        feb(1859, 1856, {}, arc);
                        _.ng = function brc(a, b, c) {
                            var d, e, f, g;
                            d = Kfb(UD(k2b(a.b.g.b, (yCc(), VBc))));
                            g = new Gjd(cD(WC(l3, 1), Nve, 8, 0, [
                                (f = a.c.d, $id(new sjd(f.n), f.a))
                            ]));
                            _qc(a, b, c, g, d);
                            Mub(g, (e = a.d.d, $id(new sjd(e.n), e.a)));
                            return sUc(new wUc(g));
                        };
                        var DW = sfb(xBe, 'SplineSelfLoopRouter', 1859);
                        feb(586, 1, fye, frc, hrc);
                        _.Ne = function irc(a, b) {
                            return crc(this, RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function jrc(a) {
                            return this === a;
                        };
                        _.Oe = function krc() {
                            return new Frb(this);
                        };
                        var FW = sfb(yBe, 'ModelOrderNodeComparator', 586);
                        feb(1821, 1, nwe, lrc);
                        _.Mb = function mrc(a) {
                            return RD(a, 12).e.c.length != 0;
                        };
                        var EW = sfb(yBe, 'ModelOrderNodeComparator/lambda$0$Type', 1821);
                        feb(821, 1, fye, trc, urc);
                        _.Ne = function vrc(a, b) {
                            return prc(this, a, b);
                        };
                        _.Fb = function wrc(a) {
                            return this === a;
                        };
                        _.Oe = function xrc() {
                            return new Frb(this);
                        };
                        _.b = false;
                        var GW = sfb(yBe, 'ModelOrderPortComparator', 821);
                        feb(815, 1, {}, zrc);
                        _.og = function Brc(a, b) {
                            var c, d, e, f;
                            e = Arc(b);
                            c = new bnb;
                            f = b.f / e;
                            for(d = 1; d < e; ++d)Rmb(c, sgb(Ydb(Hdb($wnd.Math.round(d * f)))));
                            return c;
                        };
                        _.pg = function Crc() {
                            return false;
                        };
                        var HW = sfb(zBe, 'ARDCutIndexHeuristic', 815);
                        feb(1544, 1, QAe, Hrc);
                        _.Kf = function Irc(a, b) {
                            Grc(RD(a, 36), b);
                        };
                        var KW = sfb(zBe, 'BreakingPointInserter', 1544);
                        feb(313, 1, {
                            313: 1
                        }, Jrc);
                        _.Ib = function Mrc() {
                            var a;
                            a = new bib;
                            a.a += 'BPInfo[';
                            a.a += '\n\tstart=';
                            Yhb(a, this.i);
                            a.a += '\n\tend=';
                            Yhb(a, this.a);
                            a.a += '\n\tnodeStartEdge=';
                            Yhb(a, this.e);
                            a.a += '\n\tstartEndEdge=';
                            Yhb(a, this.j);
                            a.a += '\n\toriginalEdge=';
                            Yhb(a, this.f);
                            a.a += '\n\tstartInLayerDummy=';
                            Yhb(a, this.k);
                            a.a += '\n\tstartInLayerEdge=';
                            Yhb(a, this.n);
                            a.a += '\n\tendInLayerDummy=';
                            Yhb(a, this.b);
                            a.a += '\n\tendInLayerEdge=';
                            Yhb(a, this.c);
                            return a.a;
                        };
                        var IW = sfb(zBe, 'BreakingPointInserter/BPInfo', 313);
                        feb(661, 1, {
                            661: 1
                        }, Trc);
                        _.a = false;
                        _.b = 0;
                        _.c = 0;
                        var JW = sfb(zBe, 'BreakingPointInserter/Cut', 661);
                        feb(1545, 1, QAe, bsc);
                        _.Kf = function csc(a, b) {
                            _rc(RD(a, 36), b);
                        };
                        var NW = sfb(zBe, 'BreakingPointProcessor', 1545);
                        feb(1546, 1, nwe, dsc);
                        _.Mb = function esc(a) {
                            return Krc(RD(a, 10));
                        };
                        var LW = sfb(zBe, 'BreakingPointProcessor/0methodref$isEnd$Type', 1546);
                        feb(1547, 1, nwe, fsc);
                        _.Mb = function gsc(a) {
                            return Lrc(RD(a, 10));
                        };
                        var MW = sfb(zBe, 'BreakingPointProcessor/1methodref$isStart$Type', 1547);
                        feb(1548, 1, QAe, ksc);
                        _.Kf = function lsc(a, b) {
                            isc(this, RD(a, 36), b);
                        };
                        var PW = sfb(zBe, 'BreakingPointRemover', 1548);
                        feb(1549, 1, Qve, msc);
                        _.Cd = function nsc(a) {
                            RD(a, 131).k = true;
                        };
                        var OW = sfb(zBe, 'BreakingPointRemover/lambda$0$Type', 1549);
                        feb(811, 1, {}, ysc);
                        _.b = 0;
                        _.e = 0;
                        _.f = 0;
                        _.j = 0;
                        var VW = sfb(zBe, 'GraphStats', 811);
                        feb(812, 1, {}, Asc);
                        _.Ve = function Bsc(a, b) {
                            return $wnd.Math.max(Kfb(UD(a)), Kfb(UD(b)));
                        };
                        var QW = sfb(zBe, 'GraphStats/0methodref$max$Type', 812);
                        feb(813, 1, {}, Csc);
                        _.Ve = function Dsc(a, b) {
                            return $wnd.Math.max(Kfb(UD(a)), Kfb(UD(b)));
                        };
                        var RW = sfb(zBe, 'GraphStats/2methodref$max$Type', 813);
                        feb(1726, 1, {}, Esc);
                        _.Ve = function Fsc(a, b) {
                            return zsc(UD(a), UD(b));
                        };
                        var SW = sfb(zBe, 'GraphStats/lambda$1$Type', 1726);
                        feb(1727, 1, {}, Gsc);
                        _.Kb = function Hsc(a) {
                            return ssc(this.a, RD(a, 30));
                        };
                        var TW = sfb(zBe, 'GraphStats/lambda$2$Type', 1727);
                        feb(1728, 1, {}, Isc);
                        _.Kb = function Jsc(a) {
                            return rsc(this.a, RD(a, 30));
                        };
                        var UW = sfb(zBe, 'GraphStats/lambda$6$Type', 1728);
                        feb(814, 1, {}, Ksc);
                        _.og = function Lsc(a, b) {
                            var c;
                            c = RD(mQb(a, (yCc(), pCc)), 15);
                            return c ? c : (yob(), yob(), vob);
                        };
                        _.pg = function Msc() {
                            return false;
                        };
                        var WW = sfb(zBe, 'ICutIndexCalculator/ManualCutIndexCalculator', 814);
                        feb(816, 1, {}, Nsc);
                        _.og = function Osc(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
                            u = (b.n == null && vsc(b), b.n);
                            i = (b.d == null && vsc(b), b.d);
                            t = $C(iE, vxe, 28, u.length, 15, 1);
                            t[0] = u[0];
                            r = u[0];
                            for(j = 1; j < u.length; j++){
                                t[j] = t[j - 1] + u[j];
                                r += u[j];
                            }
                            e = Arc(b) - 1;
                            g = RD(mQb(a, (yCc(), qCc)), 17).a;
                            d = pxe;
                            c = new bnb;
                            for(m = $wnd.Math.max(0, e - g); m <= $wnd.Math.min(b.f - 1, e + g); m++){
                                p = r / (m + 1);
                                q = 0;
                                k = 1;
                                f = new bnb;
                                s = pxe;
                                l = 0;
                                h = 0;
                                o = i[0];
                                if (m == 0) {
                                    s = r;
                                    h = (b.g == null && (b.g = qsc(b, new Csc)), Kfb(b.g));
                                } else {
                                    while(k < b.f){
                                        if (t[k - 1] - q >= p) {
                                            Rmb(f, sgb(k));
                                            s = $wnd.Math.max(s, t[k - 1] - l);
                                            h += o;
                                            q += t[k - 1] - q;
                                            l = t[k - 1];
                                            o = i[k];
                                        }
                                        o = $wnd.Math.max(o, i[k]);
                                        ++k;
                                    }
                                    h += o;
                                }
                                n = $wnd.Math.min(1 / s, 1 / b.b / h);
                                if (n > d) {
                                    d = n;
                                    c = f;
                                }
                            }
                            return c;
                        };
                        _.pg = function Psc() {
                            return false;
                        };
                        var XW = sfb(zBe, 'MSDCutIndexHeuristic', 816);
                        feb(1683, 1, QAe, Ssc);
                        _.Kf = function Tsc(a, b) {
                            Rsc(RD(a, 36), b);
                        };
                        var YW = sfb(zBe, 'SingleEdgeGraphWrapper', 1683);
                        feb(232, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            232: 1
                        }, ctc);
                        var Xsc, Ysc, Zsc, $sc, _sc, atc;
                        var ZW = tfb(ABe, 'CenterEdgeLabelPlacementStrategy', 232, WI, etc, dtc);
                        var ftc;
                        feb(431, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            431: 1
                        }, ktc);
                        var htc, itc;
                        var $W = tfb(ABe, 'ConstraintCalculationStrategy', 431, WI, mtc, ltc);
                        var ntc;
                        feb(322, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            322: 1,
                            188: 1,
                            196: 1
                        }, utc);
                        _.dg = function wtc() {
                            return ttc(this);
                        };
                        _.qg = function vtc() {
                            return ttc(this);
                        };
                        var ptc, qtc, rtc;
                        var _W = tfb(ABe, 'CrossingMinimizationStrategy', 322, WI, ytc, xtc);
                        var ztc;
                        feb(351, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            351: 1
                        }, Ftc);
                        var Btc, Ctc, Dtc;
                        var aX = tfb(ABe, 'CuttingStrategy', 351, WI, Htc, Gtc);
                        var Itc;
                        feb(348, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            348: 1,
                            188: 1,
                            196: 1
                        }, Rtc);
                        _.dg = function Ttc() {
                            return Qtc(this);
                        };
                        _.qg = function Stc() {
                            return Qtc(this);
                        };
                        var Ktc, Ltc, Mtc, Ntc, Otc;
                        var bX = tfb(ABe, 'CycleBreakingStrategy', 348, WI, Vtc, Utc);
                        var Wtc;
                        feb(428, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            428: 1
                        }, _tc);
                        var Ytc, Ztc;
                        var cX = tfb(ABe, 'DirectionCongruency', 428, WI, buc, auc);
                        var cuc;
                        feb(460, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            460: 1
                        }, iuc);
                        var euc, fuc, guc;
                        var dX = tfb(ABe, 'EdgeConstraint', 460, WI, kuc, juc);
                        var luc;
                        feb(283, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            283: 1
                        }, vuc);
                        var nuc, ouc, puc, quc, ruc, suc;
                        var eX = tfb(ABe, 'EdgeLabelSideSelection', 283, WI, xuc, wuc);
                        var yuc;
                        feb(488, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            488: 1
                        }, Duc);
                        var Auc, Buc;
                        var fX = tfb(ABe, 'EdgeStraighteningStrategy', 488, WI, Fuc, Euc);
                        var Guc;
                        feb(281, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            281: 1
                        }, Puc);
                        var Iuc, Juc, Kuc, Luc, Muc, Nuc;
                        var gX = tfb(ABe, 'FixedAlignment', 281, WI, Ruc, Quc);
                        var Suc;
                        feb(282, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            282: 1
                        }, _uc);
                        var Uuc, Vuc, Wuc, Xuc, Yuc, Zuc;
                        var hX = tfb(ABe, 'GraphCompactionStrategy', 282, WI, bvc, avc);
                        var cvc;
                        feb(259, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            259: 1
                        }, pvc);
                        var evc, fvc, gvc, hvc, ivc, jvc, kvc, lvc, mvc, nvc;
                        var iX = tfb(ABe, 'GraphProperties', 259, WI, rvc, qvc);
                        var svc;
                        feb(299, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            299: 1
                        }, yvc);
                        var uvc, vvc, wvc;
                        var jX = tfb(ABe, 'GreedySwitchType', 299, WI, Avc, zvc);
                        var Bvc;
                        feb(311, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            311: 1
                        }, Hvc);
                        var Dvc, Evc, Fvc;
                        var kX = tfb(ABe, 'InLayerConstraint', 311, WI, Jvc, Ivc);
                        var Kvc;
                        feb(429, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            429: 1
                        }, Pvc);
                        var Mvc, Nvc;
                        var lX = tfb(ABe, 'InteractiveReferencePoint', 429, WI, Rvc, Qvc);
                        var Svc;
                        var Uvc, Vvc, Wvc, Xvc, Yvc, Zvc, $vc, _vc, awc, bwc, cwc, dwc, ewc, fwc, gwc, hwc, iwc, jwc, kwc, lwc, mwc, nwc, owc, pwc, qwc, rwc, swc, twc, uwc, vwc, wwc, xwc, ywc, zwc, Awc, Bwc, Cwc, Dwc, Ewc, Fwc, Gwc, Hwc, Iwc, Jwc, Kwc, Lwc, Mwc, Nwc, Owc, Pwc, Qwc, Rwc, Swc, Twc, Uwc, Vwc, Wwc, Xwc;
                        feb(171, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            171: 1
                        }, dxc);
                        var Zwc, $wc, _wc, axc, bxc;
                        var mX = tfb(ABe, 'LayerConstraint', 171, WI, fxc, exc);
                        var gxc;
                        feb(859, 1, Eye, Pzc);
                        _.hf = function Qzc(a) {
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, HBe), ''), 'Direction Congruency'), 'Specifies how drawings of the same graph with different layout directions compare to each other: either a natural reading direction is preserved or the drawings are rotated versions of each other.'), Uxc), (kid(), eid)), cX), xsb((Yhd(), Whd)))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, IBe), ''), 'Feedback Edges'), 'Whether feedback edges should be highlighted by routing around the nodes.'), (Geb(), false)), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, JBe), ''), 'Interactive Reference Point'), 'Determines which point of a node is considered by interactive layout phases.'), pyc), eid), lX), xsb(Whd))));
                            zgd(a, JBe, RBe, ryc);
                            zgd(a, JBe, _Be, qyc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, KBe), ''), 'Merge Edges'), 'Edges that have no ports are merged so they touch the connected nodes at the same points. When this option is disabled, one port is created for each edge directly connected to a node. When it is enabled, all such incoming edges share an input port, and all outgoing edges share an output port.'), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, LBe), ''), 'Merge Hierarchy-Crossing Edges'), 'If hierarchical layout is active, hierarchy-crossing edges use as few hierarchical ports as possible. They are broken by the algorithm, with hierarchical ports inserted as required. Usually, one such port is created for each edge at each hierarchy crossing point. With this option set to true, we try to create as few hierarchical ports as possible in the process. In particular, all edges that form a hyperedge can share a port.'), true), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Nhd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, MBe), ''), 'Allow Non-Flow Ports To Switch Sides'), "Specifies whether non-flow ports may switch sides if their node's port constraints are either FIXED_SIDE or FIXED_ORDER. A non-flow port is a port on a side that is not part of the currently configured layout flow. For instance, given a left-to-right layout direction, north and south ports would be considered non-flow ports. Further note that the underlying criterium whether to switch sides or not solely relies on the minimization of edge crossings. Hence, edge length and other aesthetics criteria are not addressed."), false), cid), QI), xsb(Xhd)), cD(WC(qJ, 1), Nve, 2, 6, [
                                'org.eclipse.elk.layered.northOrSouthPort'
                            ]))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, NBe), ''), 'Port Sorting Strategy'), "Only relevant for nodes with FIXED_SIDE port constraints. Determines the way a node's ports are distributed on the sides of a node if their order is not prescribed. The option is set on parent nodes."), azc), eid), xX), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, OBe), ''), 'Thoroughness'), 'How much effort should be spent to produce a nice layout.'), sgb(7)), gid), bJ), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, PBe), ''), 'Add Unnecessary Bendpoints'), 'Adds bend points even if an edge does not change direction. If true, each long edge dummy will contribute a bend point to its edges and hierarchy-crossing edges will always get a bend point where they cross hierarchy boundaries. By default, bend points are only added where an edge changes direction.'), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, QBe), ''), 'Generate Position and Layer IDs'), 'If enabled position id and layer id are generated, which are usually only used internally when setting the interactiveLayout option. This option should be specified on the root node.'), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, RBe), 'cycleBreaking'), 'Cycle Breaking Strategy'), 'Strategy for cycle breaking. Cycle breaking looks for cycles in the graph and determines which edges to reverse to break the cycles. Reversed edges will end up pointing to the opposite direction of regular edges (that is, reversed edges will point left if edges usually point right).'), Sxc), eid), bX), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, SBe), bDe), 'Node Layering Strategy'), 'Strategy for node layering.'), Gyc), eid), rX), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, TBe), bDe), 'Layer Constraint'), 'Determines a constraint on the placement of the node regarding the layering.'), wyc), eid), mX), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, UBe), bDe), 'Layer Choice Constraint'), "Allows to set a constraint regarding the layer placement of a node. Let i be the value of teh constraint. Assumed the drawing has n layers and i < n. If set to i, it expresses that the node should be placed in i-th layer. Should i>=n be true then the node is placed in the last layer of the drawing. Note that this option is not part of any of ELK Layered's default configurations but is only evaluated as part of the `InteractiveLayeredGraphVisitor`, which must be applied manually or used via the `DiagramLayoutEngine."), null), gid), bJ), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, VBe), bDe), 'Layer ID'), 'Layer identifier that was calculated by ELK Layered for a node. This is only generated if interactiveLayot or generatePositionAndLayerIds is set.'), sgb(-1)), gid), bJ), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, WBe), cDe), 'Upper Bound On Width [MinWidth Layerer]'), "Defines a loose upper bound on the width of the MinWidth layerer. If set to '-1' multiple values are tested and the best result is selected."), sgb(4)), gid), bJ), xsb(Whd))));
                            zgd(a, WBe, SBe, zyc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, XBe), cDe), 'Upper Layer Estimation Scaling Factor [MinWidth Layerer]'), "Multiplied with Upper Bound On Width for defining an upper bound on the width of layers which haven't been determined yet, but whose maximum width had been (roughly) estimated by the MinWidth algorithm. Compensates for too high estimations. If set to '-1' multiple values are tested and the best result is selected."), sgb(2)), gid), bJ), xsb(Whd))));
                            zgd(a, XBe, SBe, Byc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, YBe), dDe), 'Node Promotion Strategy'), 'Reduces number of dummy nodes after layering phase (if possible).'), Eyc), eid), vX), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, ZBe), dDe), 'Max Node Promotion Iterations'), 'Limits the number of iterations for node promotion.'), sgb(0)), gid), bJ), xsb(Whd))));
                            zgd(a, ZBe, YBe, null);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, $Be), 'layering.coffmanGraham'), 'Layer Bound'), 'The maximum number of nodes allowed per layer.'), sgb(lve)), gid), bJ), xsb(Whd))));
                            zgd(a, $Be, SBe, tyc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, _Be), eDe), 'Crossing Minimization Strategy'), 'Strategy for crossing minimization.'), Qxc), eid), _W), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, aCe), eDe), 'Force Node Model Order'), 'The node order given by the model does not change to produce a better layout. E.g. if node A is before node B in the model this is not changed during crossing minimization. This assumes that the node model order is already respected before crossing minimization. This can be achieved by setting considerModelOrder.strategy to NODES_AND_EDGES.'), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, bCe), eDe), 'Hierarchical Sweepiness'), 'How likely it is to use cross-hierarchy (1) vs bottom-up (-1).'), 0.1), did), VI), xsb(Whd))));
                            zgd(a, bCe, fDe, Ixc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, cCe), eDe), 'Semi-Interactive Crossing Minimization'), "Preserves the order of nodes within a layer but still minimizes crossings between edges connecting long edge dummies. Derives the desired order from positions specified by the 'org.eclipse.elk.position' layout option. Requires a crossing minimization strategy that is able to process 'in-layer' constraints."), false), cid), QI), xsb(Whd))));
                            zgd(a, cCe, _Be, Oxc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, dCe), eDe), 'In Layer Predecessor of'), "Allows to set a constraint which specifies of which node the current node is the predecessor. If set to 's' then the node is the predecessor of 's' and is in the same layer"), null), iid), qJ), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, eCe), eDe), 'In Layer Successor of'), "Allows to set a constraint which specifies of which node the current node is the successor. If set to 's' then the node is the successor of 's' and is in the same layer"), null), iid), qJ), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, fCe), eDe), 'Position Choice Constraint'), "Allows to set a constraint regarding the position placement of a node in a layer. Assumed the layer in which the node placed includes n other nodes and i < n. If set to i, it expresses that the node should be placed at the i-th position. Should i>=n be true then the node is placed at the last position in the layer. Note that this option is not part of any of ELK Layered's default configurations but is only evaluated as part of the `InteractiveLayeredGraphVisitor`, which must be applied manually or used via the `DiagramLayoutEngine."), null), gid), bJ), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, gCe), eDe), 'Position ID'), 'Position within a layer that was determined by ELK Layered for a node. This is only generated if interactiveLayot or generatePositionAndLayerIds is set.'), sgb(-1)), gid), bJ), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, hCe), gDe), 'Greedy Switch Activation Threshold'), "By default it is decided automatically if the greedy switch is activated or not. The decision is based on whether the size of the input graph (without dummy nodes) is smaller than the value of this option. A '0' enforces the activation."), sgb(40)), gid), bJ), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, iCe), gDe), 'Greedy Switch Crossing Minimization'), "Greedy Switch strategy for crossing minimization. The greedy switch heuristic is executed after the regular crossing minimization as a post-processor. Note that if 'hierarchyHandling' is set to 'INCLUDE_CHILDREN', the 'greedySwitchHierarchical.type' option must be used."), Fxc), eid), jX), xsb(Whd))));
                            zgd(a, iCe, _Be, Gxc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, jCe), 'crossingMinimization.greedySwitchHierarchical'), 'Greedy Switch Crossing Minimization (hierarchical)'), "Activates the greedy switch heuristic in case hierarchical layout is used. The differences to the non-hierarchical case (see 'greedySwitch.type') are: 1) greedy switch is inactive by default, 3) only the option value set on the node at which hierarchical layout starts is relevant, and 2) if it's activated by the user, it properly addresses hierarchy-crossing edges."), Bxc), eid), jX), xsb(Whd))));
                            zgd(a, jCe, _Be, Cxc);
                            zgd(a, jCe, fDe, Dxc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, kCe), hDe), 'Node Placement Strategy'), 'Strategy for node placement.'), $yc), eid), uX), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, lCe), hDe), 'Favor Straight Edges Over Balancing'), "Favor straight edges over a balanced node placement. The default behavior is determined automatically based on the used 'edgeRouting'. For an orthogonal style it is set to true, for all other styles to false."), cid), QI), xsb(Whd))));
                            zgd(a, lCe, kCe, Qyc);
                            zgd(a, lCe, kCe, Ryc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, mCe), iDe), 'BK Edge Straightening'), "Specifies whether the Brandes Koepf node placer tries to increase the number of straight edges at the expense of diagram size. There is a subtle difference to the 'favorStraightEdges' option, which decides whether a balanced placement of the nodes is desired, or not. In bk terms this means combining the four alignments into a single balanced one, or not. This option on the other hand tries to straighten additional edges during the creation of each of the four alignments."), Kyc), eid), fX), xsb(Whd))));
                            zgd(a, mCe, kCe, Lyc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, nCe), iDe), 'BK Fixed Alignment'), 'Tells the BK node placer to use a certain alignment (out of its four) instead of the one producing the smallest height, or the combination of all four.'), Nyc), eid), gX), xsb(Whd))));
                            zgd(a, nCe, kCe, Oyc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, oCe), 'nodePlacement.linearSegments'), 'Linear Segments Deflection Dampening'), 'Dampens the movement of nodes to keep the diagram from getting too large.'), 0.3), did), VI), xsb(Whd))));
                            zgd(a, oCe, kCe, Tyc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, pCe), 'nodePlacement.networkSimplex'), 'Node Flexibility'), "Aims at shorter and straighter edges. Two configurations are possible: (a) allow ports to move freely on the side they are assigned to (the order is always defined beforehand), (b) additionally allow to enlarge a node wherever it helps. If this option is not configured for a node, the 'nodeFlexibility.default' value is used, which is specified for the node's parent."), eid), tX), xsb(Vhd))));
                            zgd(a, pCe, kCe, Yyc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, qCe), 'nodePlacement.networkSimplex.nodeFlexibility'), 'Node Flexibility Default'), "Default value of the 'nodeFlexibility' option for the children of a hierarchical node."), Wyc), eid), tX), xsb(Whd))));
                            zgd(a, qCe, kCe, Xyc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, rCe), jDe), 'Self-Loop Distribution'), 'Alter the distribution of the loops around the node. It only takes effect for PortConstraints.FREE.'), ayc), eid), zX), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, sCe), jDe), 'Self-Loop Ordering'), 'Alter the ordering of the loops they can either be stacked or sequenced. It only takes effect for PortConstraints.FREE.'), cyc), eid), AX), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, tCe), 'edgeRouting.splines'), 'Spline Routing Mode'), 'Specifies the way control points are assembled for each individual edge. CONSERVATIVE ensures that edges are properly routed around the nodes but feels rather orthogonal at times. SLOPPY uses fewer control points to obtain curvier edge routes but may result in edges overlapping nodes.'), eyc), eid), CX), xsb(Whd))));
                            zgd(a, tCe, kDe, fyc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, uCe), 'edgeRouting.splines.sloppy'), 'Sloppy Spline Layer Spacing Factor'), 'Spacing factor for routing area between layers when using sloppy spline routing.'), 0.2), did), VI), xsb(Whd))));
                            zgd(a, uCe, kDe, hyc);
                            zgd(a, uCe, tCe, iyc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, vCe), 'edgeRouting.polyline'), 'Sloped Edge Zone Width'), 'Width of the strip to the left and to the right of each layer where the polyline edge router is allowed to refrain from ensuring that edges are routed horizontally. This prevents awkward bend points for nodes that extent almost to the edge of their layer.'), 2), did), VI), xsb(Whd))));
                            zgd(a, vCe, kDe, $xc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, wCe), lDe), 'Spacing Base Value'), "An optional base value for all other layout options of the 'spacing' group. It can be used to conveniently alter the overall 'spaciousness' of the drawing. Whenever an explicit value is set for the other layout options, this base value will have no effect. The base value is not inherited, i.e. it must be set for each hierarchical node."), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, xCe), lDe), 'Edge Node Between Layers Spacing'), "The spacing to be preserved between nodes and edges that are routed next to the node's layer. For the spacing between nodes and edges that cross the node's layer 'spacing.edgeNode' is used."), 10), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, yCe), lDe), 'Edge Edge Between Layer Spacing'), "Spacing to be preserved between pairs of edges that are routed between the same pair of layers. Note that 'spacing.edgeEdge' is used for the spacing between pairs of edges crossing the same layer."), 10), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, zCe), lDe), 'Node Node Between Layers Spacing'), "The spacing to be preserved between any pair of nodes of two adjacent layers. Note that 'spacing.nodeNode' is used for the spacing between nodes within the layer itself."), 20), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, ACe), mDe), 'Direction Priority'), 'Defines how important it is to have a certain edge point into the direction of the overall layout. This option is evaluated during the cycle breaking phase.'), sgb(0)), gid), bJ), xsb(Thd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, BCe), mDe), 'Shortness Priority'), 'Defines how important it is to keep an edge as short as possible. This option is evaluated during the layering phase.'), sgb(0)), gid), bJ), xsb(Thd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, CCe), mDe), 'Straightness Priority'), 'Defines how important it is to keep an edge straight, i.e. aligned with one of the two axes. This option is evaluated during node placement.'), sgb(0)), gid), bJ), xsb(Thd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, DCe), nDe), qze), 'Tries to further compact components (disconnected sub-graphs).'), false), cid), QI), xsb(Whd))));
                            zgd(a, DCe, cAe, true);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, ECe), oDe), 'Post Compaction Strategy'), pDe), nxc), eid), hX), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, FCe), oDe), 'Post Compaction Constraint Calculation'), pDe), lxc), eid), $W), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, GCe), qDe), 'High Degree Node Treatment'), 'Makes room around high degree nodes to place leafs and trees.'), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, HCe), qDe), 'High Degree Node Threshold'), 'Whether a node is considered to have a high degree.'), sgb(16)), gid), bJ), xsb(Whd))));
                            zgd(a, HCe, GCe, true);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, ICe), qDe), 'High Degree Node Maximum Tree Height'), 'Maximum height of a subtree connected to a high degree node to be moved to separate layers.'), sgb(5)), gid), bJ), xsb(Whd))));
                            zgd(a, ICe, GCe, true);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, JCe), rDe), 'Graph Wrapping Strategy'), "For certain graphs and certain prescribed drawing areas it may be desirable to split the laid out graph into chunks that are placed side by side. The edges that connect different chunks are 'wrapped' around from the end of one chunk to the start of the other chunk. The points between the chunks are referred to as 'cuts'."), Gzc), eid), EX), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, KCe), rDe), 'Additional Wrapped Edges Spacing'), 'To visually separate edges that are wrapped from regularly routed edges an additional spacing value can be specified in form of this layout option. The spacing is added to the regular edgeNode spacing.'), 10), did), VI), xsb(Whd))));
                            zgd(a, KCe, JCe, lzc);
                            zgd(a, KCe, JCe, mzc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, LCe), rDe), 'Correction Factor for Wrapping'), "At times and for certain types of graphs the executed wrapping may produce results that are consistently biased in the same fashion: either wrapping to often or to rarely. This factor can be used to correct the bias. Internally, it is simply multiplied with the 'aspect ratio' layout option."), 1), did), VI), xsb(Whd))));
                            zgd(a, LCe, JCe, ozc);
                            zgd(a, LCe, JCe, pzc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, MCe), sDe), 'Cutting Strategy'), 'The strategy by which the layer indexes are determined at which the layering crumbles into chunks.'), wzc), eid), aX), xsb(Whd))));
                            zgd(a, MCe, JCe, xzc);
                            zgd(a, MCe, JCe, yzc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, NCe), sDe), 'Manually Specified Cuts'), 'Allows the user to specify her own cuts for a certain graph.'), hid), QK), xsb(Whd))));
                            zgd(a, NCe, MCe, rzc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, OCe), 'wrapping.cutting.msd'), 'MSD Freedom'), 'The MSD cutting strategy starts with an initial guess on the number of chunks the graph should be split into. The freedom specifies how much the strategy may deviate from this guess. E.g. if an initial number of 3 is computed, a freedom of 1 allows 2, 3, and 4 cuts.'), tzc), gid), bJ), xsb(Whd))));
                            zgd(a, OCe, MCe, uzc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, PCe), tDe), 'Validification Strategy'), 'When wrapping graphs, one can specify indices that are not allowed as split points. The validification strategy makes sure every computed split point is allowed.'), Lzc), eid), DX), xsb(Whd))));
                            zgd(a, PCe, JCe, Mzc);
                            zgd(a, PCe, JCe, Nzc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, QCe), tDe), 'Valid Indices for Wrapping'), null), hid), QK), xsb(Whd))));
                            zgd(a, QCe, JCe, Izc);
                            zgd(a, QCe, JCe, Jzc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, RCe), uDe), 'Improve Cuts'), 'For general graphs it is important that not too many edges wrap backwards. Thus a compromise between evenly-distributed cuts and the total number of cut edges is sought.'), true), cid), QI), xsb(Whd))));
                            zgd(a, RCe, JCe, Czc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, SCe), uDe), 'Distance Penalty When Improving Cuts'), null), 2), did), VI), xsb(Whd))));
                            zgd(a, SCe, JCe, Azc);
                            zgd(a, SCe, RCe, true);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, TCe), uDe), 'Improve Wrapped Edges'), 'The initial wrapping is performed in a very simple way. As a consequence, edges that wrap from one chunk to another may be unnecessarily long. Activating this option tries to shorten such edges.'), true), cid), QI), xsb(Whd))));
                            zgd(a, TCe, JCe, Ezc);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, UCe), vDe), 'Edge Label Side Selection'), 'Method to decide on edge label sides.'), Yxc), eid), eX), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, VCe), vDe), 'Edge Center Label Placement Strategy'), 'Determines in which layer center labels of long edges should be placed.'), Wxc), eid), ZW), ysb(Whd, cD(WC(d3, 1), jwe, 170, 0, [
                                Uhd
                            ])))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, WCe), wDe), 'Consider Model Order'), 'Preserves the order of nodes and edges in the model file if this does not lead to additional edge crossings. Depending on the strategy this is not always possible since the node and edge order might be conflicting.'), xxc), eid), wX), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, XCe), wDe), 'Consider Port Order'), 'If disabled the port order of output ports is derived from the edge order and input ports are ordered by their incoming connections. If enabled all ports are ordered by the port model order.'), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, YCe), wDe), 'No Model Order'), 'Set on a node to not set a model order for this node even though it is a real node.'), false), cid), QI), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, ZCe), wDe), 'Consider Model Order for Components'), 'If set to NONE the usual ordering strategy (by cumulative node priority and size of nodes) is used. INSIDE_PORT_SIDES orders the components with external ports only inside the groups with the same port side. FORCE_MODEL_ORDER enforces the mode order on components. This option might produce bad alignments and sub optimal drawings in terms of used area since the ordering should be respected.'), pxc), eid), CQ), xsb(Whd))));
                            zgd(a, ZCe, cAe, null);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, $Ce), wDe), 'Long Edge Ordering Strategy'), 'Indicates whether long edges are sorted under, over, or equal to nodes that have no connection to a previous layer in a left-to-right or right-to-left layout. Under and over changes to right and left in a vertical layout.'), txc), eid), sX), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, _Ce), wDe), 'Crossing Counter Node Order Influence'), 'Indicates with what percentage (1 for 100%) violations of the node model order are weighted against the crossings e.g. a value of 0.5 means two model order violations are as important as on edge crossing. This allows some edge crossings in favor of preserving the model order. It is advised to set this value to a very small positive value (e.g. 0.001) to have minimal crossing and a optimal node order. Defaults to no influence (0).'), 0), did), VI), xsb(Whd))));
                            zgd(a, _Ce, WCe, null);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, aDe), wDe), 'Crossing Counter Port Order Influence'), 'Indicates with what percentage (1 for 100%) violations of the port model order are weighted against the crossings e.g. a value of 0.5 means two model order violations are as important as on edge crossing. This allows some edge crossings in favor of preserving the model order. It is advised to set this value to a very small positive value (e.g. 0.001) to have minimal crossing and a optimal port order. Defaults to no influence (0).'), 0), did), VI), xsb(Whd))));
                            zgd(a, aDe, WCe, null);
                            zCc((new ACc, a));
                        };
                        var ixc, jxc, kxc, lxc, mxc, nxc, oxc, pxc, qxc, rxc, sxc, txc, uxc, vxc, wxc, xxc, yxc, zxc, Axc, Bxc, Cxc, Dxc, Exc, Fxc, Gxc, Hxc, Ixc, Jxc, Kxc, Lxc, Mxc, Nxc, Oxc, Pxc, Qxc, Rxc, Sxc, Txc, Uxc, Vxc, Wxc, Xxc, Yxc, Zxc, $xc, _xc, ayc, byc, cyc, dyc, eyc, fyc, gyc, hyc, iyc, jyc, kyc, lyc, myc, nyc, oyc, pyc, qyc, ryc, syc, tyc, uyc, vyc, wyc, xyc, yyc, zyc, Ayc, Byc, Cyc, Dyc, Eyc, Fyc, Gyc, Hyc, Iyc, Jyc, Kyc, Lyc, Myc, Nyc, Oyc, Pyc, Qyc, Ryc, Syc, Tyc, Uyc, Vyc, Wyc, Xyc, Yyc, Zyc, $yc, _yc, azc, bzc, czc, dzc, ezc, fzc, gzc, hzc, izc, jzc, kzc, lzc, mzc, nzc, ozc, pzc, qzc, rzc, szc, tzc, uzc, vzc, wzc, xzc, yzc, zzc, Azc, Bzc, Czc, Dzc, Ezc, Fzc, Gzc, Hzc, Izc, Jzc, Kzc, Lzc, Mzc, Nzc;
                        var nX = sfb(ABe, 'LayeredMetaDataProvider', 859);
                        feb(998, 1, Eye, ACc);
                        _.hf = function BCc(a) {
                            zCc(a);
                        };
                        var Rzc, Szc, Tzc, Uzc, Vzc, Wzc, Xzc, Yzc, Zzc, $zc, _zc, aAc, bAc, cAc, dAc, eAc, fAc, gAc, hAc, iAc, jAc, kAc, lAc, mAc, nAc, oAc, pAc, qAc, rAc, sAc, tAc, uAc, vAc, wAc, xAc, yAc, zAc, AAc, BAc, CAc, DAc, EAc, FAc, GAc, HAc, IAc, JAc, KAc, LAc, MAc, NAc, OAc, PAc, QAc, RAc, SAc, TAc, UAc, VAc, WAc, XAc, YAc, ZAc, $Ac, _Ac, aBc, bBc, cBc, dBc, eBc, fBc, gBc, hBc, iBc, jBc, kBc, lBc, mBc, nBc, oBc, pBc, qBc, rBc, sBc, tBc, uBc, vBc, wBc, xBc, yBc, zBc, ABc, BBc, CBc, DBc, EBc, FBc, GBc, HBc, IBc, JBc, KBc, LBc, MBc, NBc, OBc, PBc, QBc, RBc, SBc, TBc, UBc, VBc, WBc, XBc, YBc, ZBc, $Bc, _Bc, aCc, bCc, cCc, dCc, eCc, fCc, gCc, hCc, iCc, jCc, kCc, lCc, mCc, nCc, oCc, pCc, qCc, rCc, sCc, tCc, uCc, vCc, wCc, xCc;
                        var pX = sfb(ABe, 'LayeredOptions', 998);
                        feb(999, 1, {}, CCc);
                        _.sf = function DCc() {
                            var a;
                            return a = new lXb, a;
                        };
                        _.tf = function ECc(a) {};
                        var oX = sfb(ABe, 'LayeredOptions/LayeredFactory', 999);
                        feb(1391, 1, {});
                        _.a = 0;
                        var FCc;
                        var b4 = sfb(jEe, 'ElkSpacings/AbstractSpacingsBuilder', 1391);
                        feb(792, 1391, {}, RCc);
                        var OCc, PCc;
                        var qX = sfb(ABe, 'LayeredSpacings/LayeredSpacingsBuilder', 792);
                        feb(265, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            265: 1,
                            188: 1,
                            196: 1
                        }, bDc);
                        _.dg = function dDc() {
                            return aDc(this);
                        };
                        _.qg = function cDc() {
                            return aDc(this);
                        };
                        var SCc, TCc, UCc, VCc, WCc, XCc, YCc, ZCc, $Cc;
                        var rX = tfb(ABe, 'LayeringStrategy', 265, WI, fDc, eDc);
                        var gDc;
                        feb(390, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            390: 1
                        }, nDc);
                        var iDc, jDc, kDc;
                        var sX = tfb(ABe, 'LongEdgeOrderingStrategy', 390, WI, pDc, oDc);
                        var qDc;
                        feb(203, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            203: 1
                        }, yDc);
                        var sDc, tDc, uDc, vDc;
                        var tX = tfb(ABe, 'NodeFlexibility', 203, WI, BDc, ADc);
                        var CDc;
                        feb(323, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            323: 1,
                            188: 1,
                            196: 1
                        }, LDc);
                        _.dg = function NDc() {
                            return KDc(this);
                        };
                        _.qg = function MDc() {
                            return KDc(this);
                        };
                        var EDc, FDc, GDc, HDc, IDc;
                        var uX = tfb(ABe, 'NodePlacementStrategy', 323, WI, PDc, ODc);
                        var QDc;
                        feb(243, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            243: 1
                        }, bEc);
                        var SDc, TDc, UDc, VDc, WDc, XDc, YDc, ZDc, $Dc, _Dc;
                        var vX = tfb(ABe, 'NodePromotionStrategy', 243, WI, dEc, cEc);
                        var eEc;
                        feb(284, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            284: 1
                        }, lEc);
                        var gEc, hEc, iEc, jEc;
                        var wX = tfb(ABe, 'OrderingStrategy', 284, WI, nEc, mEc);
                        var oEc;
                        feb(430, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            430: 1
                        }, tEc);
                        var qEc, rEc;
                        var xX = tfb(ABe, 'PortSortingStrategy', 430, WI, vEc, uEc);
                        var wEc;
                        feb(463, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            463: 1
                        }, CEc);
                        var yEc, zEc, AEc;
                        var yX = tfb(ABe, 'PortType', 463, WI, EEc, DEc);
                        var FEc;
                        feb(387, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            387: 1
                        }, LEc);
                        var HEc, IEc, JEc;
                        var zX = tfb(ABe, 'SelfLoopDistributionStrategy', 387, WI, NEc, MEc);
                        var OEc;
                        feb(349, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            349: 1
                        }, UEc);
                        var QEc, REc, SEc;
                        var AX = tfb(ABe, 'SelfLoopOrderingStrategy', 349, WI, WEc, VEc);
                        var XEc;
                        feb(312, 1, {
                            312: 1
                        }, gFc);
                        var BX = sfb(ABe, 'Spacings', 312);
                        feb(350, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            350: 1
                        }, mFc);
                        var iFc, jFc, kFc;
                        var CX = tfb(ABe, 'SplineRoutingMode', 350, WI, oFc, nFc);
                        var pFc;
                        feb(352, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            352: 1
                        }, vFc);
                        var rFc, sFc, tFc;
                        var DX = tfb(ABe, 'ValidifyStrategy', 352, WI, xFc, wFc);
                        var yFc;
                        feb(388, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            388: 1
                        }, EFc);
                        var AFc, BFc, CFc;
                        var EX = tfb(ABe, 'WrappingStrategy', 388, WI, GFc, FFc);
                        var HFc;
                        feb(1398, 1, nEe, NFc);
                        _.rg = function OFc(a) {
                            return RD(a, 36), JFc;
                        };
                        _.Kf = function PFc(a, b) {
                            MFc(this, RD(a, 36), b);
                        };
                        var JFc;
                        var FX = sfb(oEe, 'DepthFirstCycleBreaker', 1398);
                        feb(793, 1, nEe, UFc);
                        _.rg = function WFc(a) {
                            return RD(a, 36), QFc;
                        };
                        _.Kf = function XFc(a, b) {
                            SFc(this, RD(a, 36), b);
                        };
                        _.sg = function VFc(a) {
                            return RD(Vmb(a, Jwb(this.d, a.c.length)), 10);
                        };
                        var QFc;
                        var GX = sfb(oEe, 'GreedyCycleBreaker', 793);
                        feb(1401, 793, nEe, YFc);
                        _.sg = function ZFc(a) {
                            var b, c, d, e;
                            e = null;
                            b = lve;
                            for(d = new Anb(a); d.a < d.c.c.length;){
                                c = RD(ynb(d), 10);
                                if (nQb(c, (Ywc(), zwc)) && RD(mQb(c, zwc), 17).a < b) {
                                    b = RD(mQb(c, zwc), 17).a;
                                    e = c;
                                }
                            }
                            if (!e) return RD(Vmb(a, Jwb(this.d, a.c.length)), 10);
                            return e;
                        };
                        var HX = sfb(oEe, 'GreedyModelOrderCycleBreaker', 1401);
                        feb(1399, 1, nEe, cGc);
                        _.rg = function dGc(a) {
                            return RD(a, 36), $Fc;
                        };
                        _.Kf = function eGc(a, b) {
                            bGc(this, RD(a, 36), b);
                        };
                        var $Fc;
                        var IX = sfb(oEe, 'InteractiveCycleBreaker', 1399);
                        feb(1400, 1, nEe, jGc);
                        _.rg = function kGc(a) {
                            return RD(a, 36), fGc;
                        };
                        _.Kf = function lGc(a, b) {
                            iGc(this, RD(a, 36), b);
                        };
                        _.a = 0;
                        _.b = 0;
                        var fGc;
                        var JX = sfb(oEe, 'ModelOrderCycleBreaker', 1400);
                        feb(1413, 1, nEe, pGc);
                        _.rg = function qGc(a) {
                            return RD(a, 36), mGc;
                        };
                        _.Kf = function sGc(a, b) {
                            oGc(this, RD(a, 36), b);
                        };
                        var mGc;
                        var LX = sfb(pEe, 'BreadthFirstModelOrderLayerer', 1413);
                        feb(1414, 1, fye, tGc);
                        _.Ne = function uGc(a, b) {
                            return rGc(RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function vGc(a) {
                            return this === a;
                        };
                        _.Oe = function wGc() {
                            return new Frb(this);
                        };
                        var KX = sfb(pEe, 'BreadthFirstModelOrderLayerer/lambda$0$Type', 1414);
                        feb(1404, 1, nEe, GGc);
                        _.rg = function HGc(a) {
                            return RD(a, 36), xGc;
                        };
                        _.Kf = function IGc(a, b) {
                            EGc(this, RD(a, 36), b);
                        };
                        var xGc;
                        var OX = sfb(pEe, 'CoffmanGrahamLayerer', 1404);
                        feb(1405, 1, fye, JGc);
                        _.Ne = function KGc(a, b) {
                            return AGc(this.a, RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function LGc(a) {
                            return this === a;
                        };
                        _.Oe = function MGc() {
                            return new Frb(this);
                        };
                        var MX = sfb(pEe, 'CoffmanGrahamLayerer/0methodref$compareNodesInTopo$Type', 1405);
                        feb(1406, 1, fye, NGc);
                        _.Ne = function OGc(a, b) {
                            return DGc(this.a, RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function PGc(a) {
                            return this === a;
                        };
                        _.Oe = function QGc() {
                            return new Frb(this);
                        };
                        var NX = sfb(pEe, 'CoffmanGrahamLayerer/lambda$1$Type', 1406);
                        feb(1415, 1, nEe, YGc);
                        _.rg = function ZGc(a) {
                            return RD(a, 36), RGc;
                        };
                        _.Kf = function _Gc(a, b) {
                            XGc(this, RD(a, 36), b);
                        };
                        _.c = 0;
                        _.e = 0;
                        var RGc;
                        var QX = sfb(pEe, 'DepthFirstModelOrderLayerer', 1415);
                        feb(1416, 1, fye, aHc);
                        _.Ne = function bHc(a, b) {
                            return $Gc(RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function cHc(a) {
                            return this === a;
                        };
                        _.Oe = function dHc() {
                            return new Frb(this);
                        };
                        var PX = sfb(pEe, 'DepthFirstModelOrderLayerer/lambda$0$Type', 1416);
                        feb(1407, 1, nEe, gHc);
                        _.rg = function hHc(a) {
                            return RD(a, 36), pfd(pfd(pfd(new ufd, (sXb(), nXb), (hcc(), Ebc)), oXb, Nbc), pXb, Mbc);
                        };
                        _.Kf = function iHc(a, b) {
                            fHc(RD(a, 36), b);
                        };
                        var SX = sfb(pEe, 'InteractiveLayerer', 1407);
                        feb(578, 1, {
                            578: 1
                        }, jHc);
                        _.a = 0;
                        _.c = 0;
                        var RX = sfb(pEe, 'InteractiveLayerer/LayerSpan', 578);
                        feb(1403, 1, nEe, pHc);
                        _.rg = function qHc(a) {
                            return RD(a, 36), kHc;
                        };
                        _.Kf = function rHc(a, b) {
                            mHc(this, RD(a, 36), b);
                        };
                        var kHc;
                        var TX = sfb(pEe, 'LongestPathLayerer', 1403);
                        feb(1412, 1, nEe, xHc);
                        _.rg = function yHc(a) {
                            return RD(a, 36), sHc;
                        };
                        _.Kf = function zHc(a, b) {
                            uHc(this, RD(a, 36), b);
                        };
                        var sHc;
                        var UX = sfb(pEe, 'LongestPathSourceLayerer', 1412);
                        feb(1410, 1, nEe, IHc);
                        _.rg = function JHc(a) {
                            return RD(a, 36), pfd(pfd(pfd(new ufd, (sXb(), nXb), (hcc(), obc)), oXb, Nbc), pXb, Mbc);
                        };
                        _.Kf = function KHc(a, b) {
                            GHc(this, RD(a, 36), b);
                        };
                        _.a = 0;
                        _.b = 0;
                        _.d = 0;
                        var AHc, BHc;
                        var WX = sfb(pEe, 'MinWidthLayerer', 1410);
                        feb(1411, 1, fye, MHc);
                        _.Ne = function NHc(a, b) {
                            return LHc(this, RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function OHc(a) {
                            return this === a;
                        };
                        _.Oe = function PHc() {
                            return new Frb(this);
                        };
                        var VX = sfb(pEe, 'MinWidthLayerer/MinOutgoingEdgesComparator', 1411);
                        feb(1402, 1, nEe, XHc);
                        _.rg = function YHc(a) {
                            return RD(a, 36), QHc;
                        };
                        _.Kf = function ZHc(a, b) {
                            WHc(this, RD(a, 36), b);
                        };
                        var QHc;
                        var XX = sfb(pEe, 'NetworkSimplexLayerer', 1402);
                        feb(1408, 1, nEe, jIc);
                        _.rg = function kIc(a) {
                            return RD(a, 36), pfd(pfd(pfd(new ufd, (sXb(), nXb), (hcc(), obc)), oXb, Nbc), pXb, Mbc);
                        };
                        _.Kf = function lIc(a, b) {
                            gIc(this, RD(a, 36), b);
                        };
                        _.d = 0;
                        _.f = 0;
                        _.g = 0;
                        _.i = 0;
                        _.s = 0;
                        _.t = 0;
                        _.u = 0;
                        var ZX = sfb(pEe, 'StretchWidthLayerer', 1408);
                        feb(1409, 1, fye, nIc);
                        _.Ne = function oIc(a, b) {
                            return mIc(RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function pIc(a) {
                            return this === a;
                        };
                        _.Oe = function qIc() {
                            return new Frb(this);
                        };
                        var YX = sfb(pEe, 'StretchWidthLayerer/1', 1409);
                        feb(413, 1, qEe);
                        _.gg = function FIc(a, b, c, d, e, f) {};
                        _.ug = function DIc(a, b, c) {
                            return wIc(this, a, b, c);
                        };
                        _.fg = function EIc() {
                            this.g = $C(jE, rEe, 28, this.d, 15, 1);
                            this.f = $C(jE, rEe, 28, this.d, 15, 1);
                        };
                        _.hg = function GIc(a, b) {
                            this.e[a] = $C(kE, Pwe, 28, b[a].length, 15, 1);
                        };
                        _.ig = function HIc(a, b, c) {
                            var d;
                            d = c[a][b];
                            d.p = b;
                            this.e[a][b] = b;
                        };
                        _.jg = function IIc(a, b, c, d) {
                            RD(Vmb(d[a][b].j, c), 12).p = this.d++;
                        };
                        _.b = 0;
                        _.c = 0;
                        _.d = 0;
                        var _X = sfb(sEe, 'AbstractBarycenterPortDistributor', 413);
                        feb(1698, 1, fye, JIc);
                        _.Ne = function KIc(a, b) {
                            return zIc(this.a, RD(a, 12), RD(b, 12));
                        };
                        _.Fb = function LIc(a) {
                            return this === a;
                        };
                        _.Oe = function MIc() {
                            return new Frb(this);
                        };
                        var $X = sfb(sEe, 'AbstractBarycenterPortDistributor/lambda$0$Type', 1698);
                        feb(832, 1, uBe, UIc);
                        _.gg = function XIc(a, b, c, d, e, f) {};
                        _.ig = function ZIc(a, b, c) {};
                        _.jg = function $Ic(a, b, c, d) {};
                        _.eg = function VIc() {
                            return false;
                        };
                        _.fg = function WIc() {
                            this.c = this.e.a;
                            this.g = this.f.g;
                        };
                        _.hg = function YIc(a, b) {
                            b[a][0].c.p = a;
                        };
                        _.kg = function _Ic() {
                            return false;
                        };
                        _.vg = function aJc(a, b, c, d) {
                            if (c) RIc(this, a);
                            else {
                                OIc(this, a, d);
                                PIc(this, a, b);
                            }
                            if (a.c.length > 1) {
                                Heb(TD(mQb(Y2b((tFb(0, a.c.length), RD(a.c[0], 10))), (yCc(), eAc)))) ? wLc(a, this.d, RD(this, 669)) : (yob(), _mb(a, this.d));
                                nJc(this.e, a);
                            }
                        };
                        _.lg = function bJc(a, b, c, d) {
                            var e, f, g, h, i, j, k;
                            if (b != SIc(c, a.length)) {
                                f = a[b - (c ? 1 : -1)];
                                sIc(this.f, f, c ? (BEc(), zEc) : (BEc(), yEc));
                            }
                            e = a[b][0];
                            k = !d || e.k == (r3b(), m3b);
                            j = dv(a[b]);
                            this.vg(j, k, false, c);
                            g = 0;
                            for(i = new Anb(j); i.a < i.c.c.length;){
                                h = RD(ynb(i), 10);
                                a[b][g++] = h;
                            }
                            return false;
                        };
                        _.mg = function cJc(a, b) {
                            var c, d, e, f, g;
                            g = SIc(b, a.length);
                            f = dv(a[g]);
                            this.vg(f, false, true, b);
                            c = 0;
                            for(e = new Anb(f); e.a < e.c.c.length;){
                                d = RD(ynb(e), 10);
                                a[g][c++] = d;
                            }
                            return false;
                        };
                        var cY = sfb(sEe, 'BarycenterHeuristic', 832);
                        feb(667, 1, {
                            667: 1
                        }, dJc);
                        _.Ib = function eJc() {
                            return 'BarycenterState [node=' + this.c + ', summedWeight=' + this.d + ', degree=' + this.b + ', barycenter=' + this.a + ', visited=' + this.e + ']';
                        };
                        _.b = 0;
                        _.d = 0;
                        _.e = false;
                        var aY = sfb(sEe, 'BarycenterHeuristic/BarycenterState', 667);
                        feb(1865, 1, fye, fJc);
                        _.Ne = function gJc(a, b) {
                            return QIc(this.a, RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function hJc(a) {
                            return this === a;
                        };
                        _.Oe = function iJc() {
                            return new Frb(this);
                        };
                        var bY = sfb(sEe, 'BarycenterHeuristic/lambda$0$Type', 1865);
                        feb(831, 1, uBe, qJc);
                        _.fg = function rJc() {};
                        _.gg = function sJc(a, b, c, d, e, f) {};
                        _.jg = function vJc(a, b, c, d) {};
                        _.hg = function tJc(a, b) {
                            this.a[a] = $C(aY, {
                                3: 1,
                                4: 1,
                                5: 1,
                                2117: 1
                            }, 667, b[a].length, 0, 1);
                            this.b[a] = $C(dY, {
                                3: 1,
                                4: 1,
                                5: 1,
                                2118: 1
                            }, 239, b[a].length, 0, 1);
                        };
                        _.ig = function uJc(a, b, c) {
                            mJc(this, c[a][b], true);
                        };
                        _.c = false;
                        var fY = sfb(sEe, 'ForsterConstraintResolver', 831);
                        feb(239, 1, {
                            239: 1
                        }, yJc, zJc);
                        _.Ib = function AJc() {
                            var a, b;
                            b = new bib;
                            b.a += '[';
                            for(a = 0; a < this.d.length; a++){
                                Zhb(b, i3b(this.d[a]));
                                pJc(this.g, this.d[0]).a != null && Zhb(Zhb((b.a += '<', b), Pfb(pJc(this.g, this.d[0]).a)), '>');
                                a < this.d.length - 1 && (b.a += pve, b);
                            }
                            return (b.a += ']', b).a;
                        };
                        _.a = 0;
                        _.c = 0;
                        _.f = 0;
                        var dY = sfb(sEe, 'ForsterConstraintResolver/ConstraintGroup', 239);
                        feb(1860, 1, Qve, BJc);
                        _.Cd = function CJc(a) {
                            mJc(this.a, RD(a, 10), false);
                        };
                        var eY = sfb(sEe, 'ForsterConstraintResolver/lambda$0$Type', 1860);
                        feb(219, 1, {
                            219: 1,
                            230: 1
                        }, FJc);
                        _.gg = function HJc(a, b, c, d, e, f) {};
                        _.hg = function IJc(a, b) {};
                        _.fg = function GJc() {
                            this.r = $C(kE, Pwe, 28, this.n, 15, 1);
                        };
                        _.ig = function JJc(a, b, c) {
                            var d, e;
                            e = c[a][b];
                            d = e.e;
                            !!d && Rmb(this.b, d);
                        };
                        _.jg = function KJc(a, b, c, d) {
                            ++this.n;
                        };
                        _.Ib = function LJc() {
                            return Inb(this.e, new _sb);
                        };
                        _.g = false;
                        _.i = false;
                        _.n = 0;
                        _.s = false;
                        var gY = sfb(sEe, 'GraphInfoHolder', 219);
                        feb(1905, 1, uBe, PJc);
                        _.gg = function SJc(a, b, c, d, e, f) {};
                        _.hg = function TJc(a, b) {};
                        _.jg = function VJc(a, b, c, d) {};
                        _.ug = function QJc(a, b, c) {
                            c && b > 0 ? (pMc(this.a, a[b - 1], a[b]), undefined) : !c && b < a.length - 1 ? (pMc(this.a, a[b], a[b + 1]), undefined) : rMc(this.a, a[b], c ? (qpd(), ppd) : (qpd(), Xod));
                            return MJc(this, a, b, c);
                        };
                        _.fg = function RJc() {
                            this.d = $C(kE, Pwe, 28, this.c, 15, 1);
                            this.a = new DMc(this.d);
                        };
                        _.ig = function UJc(a, b, c) {
                            var d;
                            d = c[a][b];
                            this.c += d.j.c.length;
                        };
                        _.c = 0;
                        var hY = sfb(sEe, 'GreedyPortDistributor', 1905);
                        feb(1421, 1, nEe, aKc);
                        _.rg = function bKc(a) {
                            return ZJc(RD(a, 36));
                        };
                        _.Kf = function cKc(a, b) {
                            _Jc(RD(a, 36), b);
                        };
                        var XJc;
                        var jY = sfb(sEe, 'InteractiveCrossingMinimizer', 1421);
                        feb(1422, 1, fye, eKc);
                        _.Ne = function fKc(a, b) {
                            return dKc(this, RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function gKc(a) {
                            return this === a;
                        };
                        _.Oe = function hKc() {
                            return new Frb(this);
                        };
                        var iY = sfb(sEe, 'InteractiveCrossingMinimizer/1', 1422);
                        feb(514, 1, {
                            514: 1,
                            106: 1,
                            47: 1
                        }, FKc);
                        _.rg = function GKc(a) {
                            var b;
                            return RD(a, 36), b = vfd(iKc), pfd(b, (sXb(), pXb), (hcc(), Ybc)), b;
                        };
                        _.Kf = function HKc(a, b) {
                            wKc(this, RD(a, 36), b);
                        };
                        _.e = 0;
                        var iKc;
                        var pY = sfb(sEe, 'LayerSweepCrossingMinimizer', 514);
                        feb(1418, 1, Qve, IKc);
                        _.Cd = function JKc(a) {
                            kKc(this.a, RD(a, 219));
                        };
                        var kY = sfb(sEe, 'LayerSweepCrossingMinimizer/0methodref$compareDifferentRandomizedLayouts$Type', 1418);
                        feb(1419, 1, Qve, KKc);
                        _.Cd = function LKc(a) {
                            tKc(this.a, RD(a, 219));
                        };
                        var lY = sfb(sEe, 'LayerSweepCrossingMinimizer/1methodref$minimizeCrossingsNoCounter$Type', 1419);
                        feb(1420, 1, Qve, MKc);
                        _.Cd = function NKc(a) {
                            vKc(this.a, RD(a, 219));
                        };
                        var mY = sfb(sEe, 'LayerSweepCrossingMinimizer/2methodref$minimizeCrossingsWithCounter$Type', 1420);
                        feb(464, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            464: 1
                        }, SKc);
                        var OKc, PKc, QKc;
                        var nY = tfb(sEe, 'LayerSweepCrossingMinimizer/CrossMinType', 464, WI, UKc, TKc);
                        var VKc;
                        feb(1417, 1, nwe, XKc);
                        _.Mb = function YKc(a) {
                            return jKc(), RD(a, 30).a.c.length == 0;
                        };
                        var oY = sfb(sEe, 'LayerSweepCrossingMinimizer/lambda$0$Type', 1417);
                        feb(1862, 1, uBe, _Kc);
                        _.fg = function aLc() {};
                        _.gg = function bLc(a, b, c, d, e, f) {};
                        _.jg = function eLc(a, b, c, d) {};
                        _.hg = function cLc(a, b) {
                            b[a][0].c.p = a;
                            this.b[a] = $C(qY, {
                                3: 1,
                                4: 1,
                                5: 1,
                                2043: 1
                            }, 668, b[a].length, 0, 1);
                        };
                        _.ig = function dLc(a, b, c) {
                            var d;
                            d = c[a][b];
                            d.p = b;
                            bD(this.b[a], b, new fLc);
                        };
                        var tY = sfb(sEe, 'LayerSweepTypeDecider', 1862);
                        feb(668, 1, {
                            668: 1
                        }, fLc);
                        _.Ib = function gLc() {
                            return 'NodeInfo [connectedEdges=' + this.a + ', hierarchicalInfluence=' + this.b + ', randomInfluence=' + this.c + ']';
                        };
                        _.a = 0;
                        _.b = 0;
                        _.c = 0;
                        var qY = sfb(sEe, 'LayerSweepTypeDecider/NodeInfo', 668);
                        feb(1863, 1, xye, hLc);
                        _.Lb = function iLc(a) {
                            return k4b(new l4b(RD(a, 12).b));
                        };
                        _.Fb = function jLc(a) {
                            return this === a;
                        };
                        _.Mb = function kLc(a) {
                            return k4b(new l4b(RD(a, 12).b));
                        };
                        var rY = sfb(sEe, 'LayerSweepTypeDecider/lambda$0$Type', 1863);
                        feb(1864, 1, xye, lLc);
                        _.Lb = function mLc(a) {
                            return k4b(new l4b(RD(a, 12).b));
                        };
                        _.Fb = function nLc(a) {
                            return this === a;
                        };
                        _.Mb = function oLc(a) {
                            return k4b(new l4b(RD(a, 12).b));
                        };
                        var sY = sfb(sEe, 'LayerSweepTypeDecider/lambda$1$Type', 1864);
                        feb(1906, 413, qEe, pLc);
                        _.tg = function qLc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l;
                            j = this.g;
                            switch(c.g){
                                case 1:
                                    d = 0;
                                    e = 0;
                                    for(i = new Anb(a.j); i.a < i.c.c.length;){
                                        g = RD(ynb(i), 12);
                                        if (g.e.c.length != 0) {
                                            ++d;
                                            g.j == (qpd(), Yod) && ++e;
                                        }
                                    }
                                    f = b + e;
                                    l = b + d;
                                    for(h = c3b(a, (BEc(), yEc)).Kc(); h.Ob();){
                                        g = RD(h.Pb(), 12);
                                        if (g.j == (qpd(), Yod)) {
                                            j[g.p] = f;
                                            --f;
                                        } else {
                                            j[g.p] = l;
                                            --l;
                                        }
                                    }
                                    return d;
                                case 2:
                                    k = 0;
                                    for(h = c3b(a, (BEc(), zEc)).Kc(); h.Ob();){
                                        g = RD(h.Pb(), 12);
                                        ++k;
                                        j[g.p] = b + k;
                                    }
                                    return k;
                                default:
                                    throw Adb(new _fb);
                            }
                        };
                        var uY = sfb(sEe, 'LayerTotalPortDistributor', 1906);
                        feb(669, 832, {
                            669: 1,
                            230: 1
                        }, vLc);
                        _.vg = function xLc(a, b, c, d) {
                            if (c) RIc(this, a);
                            else {
                                OIc(this, a, d);
                                PIc(this, a, b);
                            }
                            if (a.c.length > 1) {
                                Heb(TD(mQb(Y2b((tFb(0, a.c.length), RD(a.c[0], 10))), (yCc(), eAc)))) ? wLc(a, this.d, this) : (yob(), _mb(a, this.d));
                                Heb(TD(mQb(Y2b((tFb(0, a.c.length), RD(a.c[0], 10))), eAc))) || nJc(this.e, a);
                            }
                        };
                        var wY = sfb(sEe, 'ModelOrderBarycenterHeuristic', 669);
                        feb(1866, 1, fye, yLc);
                        _.Ne = function zLc(a, b) {
                            return tLc(this.a, RD(a, 10), RD(b, 10));
                        };
                        _.Fb = function ALc(a) {
                            return this === a;
                        };
                        _.Oe = function BLc() {
                            return new Frb(this);
                        };
                        var vY = sfb(sEe, 'ModelOrderBarycenterHeuristic/lambda$0$Type', 1866);
                        feb(1423, 1, nEe, FLc);
                        _.rg = function GLc(a) {
                            var b;
                            return RD(a, 36), b = vfd(CLc), pfd(b, (sXb(), pXb), (hcc(), Ybc)), b;
                        };
                        _.Kf = function HLc(a, b) {
                            ELc((RD(a, 36), b));
                        };
                        var CLc;
                        var xY = sfb(sEe, 'NoCrossingMinimizer', 1423);
                        feb(809, 413, qEe, ILc);
                        _.tg = function JLc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n;
                            l = this.g;
                            switch(c.g){
                                case 1:
                                    e = 0;
                                    f = 0;
                                    for(k = new Anb(a.j); k.a < k.c.c.length;){
                                        i = RD(ynb(k), 12);
                                        if (i.e.c.length != 0) {
                                            ++e;
                                            i.j == (qpd(), Yod) && ++f;
                                        }
                                    }
                                    d = 1 / (e + 1);
                                    g = b + f * d;
                                    n = b + 1 - d;
                                    for(j = c3b(a, (BEc(), yEc)).Kc(); j.Ob();){
                                        i = RD(j.Pb(), 12);
                                        if (i.j == (qpd(), Yod)) {
                                            l[i.p] = g;
                                            g -= d;
                                        } else {
                                            l[i.p] = n;
                                            n -= d;
                                        }
                                    }
                                    break;
                                case 2:
                                    h = 0;
                                    for(k = new Anb(a.j); k.a < k.c.c.length;){
                                        i = RD(ynb(k), 12);
                                        i.g.c.length == 0 || ++h;
                                    }
                                    d = 1 / (h + 1);
                                    m = b + d;
                                    for(j = c3b(a, (BEc(), zEc)).Kc(); j.Ob();){
                                        i = RD(j.Pb(), 12);
                                        l[i.p] = m;
                                        m += d;
                                    }
                                    break;
                                default:
                                    throw Adb(new agb('Port type is undefined'));
                            }
                            return 1;
                        };
                        var yY = sfb(sEe, 'NodeRelativePortDistributor', 809);
                        feb(822, 1, {}, NLc, OLc);
                        var zY = sfb(sEe, 'SweepCopy', 822);
                        feb(1861, 1, uBe, RLc);
                        _.hg = function ULc(a, b) {};
                        _.fg = function SLc() {
                            var a;
                            a = $C(kE, Pwe, 28, this.f, 15, 1);
                            this.d = new jNc(a);
                            this.a = new DMc(a);
                        };
                        _.gg = function TLc(a, b, c, d, e, f) {
                            var g;
                            g = RD(Vmb(f[a][b].j, c), 12);
                            e.c == g && e.c.i.c == e.d.i.c && ++this.e[a];
                        };
                        _.ig = function VLc(a, b, c) {
                            var d;
                            d = c[a][b];
                            this.c[a] = this.c[a] | d.k == (r3b(), q3b);
                        };
                        _.jg = function WLc(a, b, c, d) {
                            var e;
                            e = RD(Vmb(d[a][b].j, c), 12);
                            e.p = this.f++;
                            e.g.c.length + e.e.c.length > 1 && (e.j == (qpd(), Xod) ? this.b[a] = true : e.j == ppd && a > 0 && (this.b[a - 1] = true));
                        };
                        _.f = 0;
                        var AY = sfb(tBe, 'AllCrossingsCounter', 1861);
                        feb(595, 1, {}, _Lc);
                        _.b = 0;
                        _.d = 0;
                        var BY = sfb(tBe, 'BinaryIndexedTree', 595);
                        feb(532, 1, {}, DMc);
                        var bMc, cMc;
                        var LY = sfb(tBe, 'CrossingsCounter', 532);
                        feb(1950, 1, fye, HMc);
                        _.Ne = function IMc(a, b) {
                            return wMc(this.a, RD(a, 12), RD(b, 12));
                        };
                        _.Fb = function JMc(a) {
                            return this === a;
                        };
                        _.Oe = function KMc() {
                            return new Frb(this);
                        };
                        var CY = sfb(tBe, 'CrossingsCounter/lambda$0$Type', 1950);
                        feb(1951, 1, fye, LMc);
                        _.Ne = function MMc(a, b) {
                            return xMc(this.a, RD(a, 12), RD(b, 12));
                        };
                        _.Fb = function NMc(a) {
                            return this === a;
                        };
                        _.Oe = function OMc() {
                            return new Frb(this);
                        };
                        var DY = sfb(tBe, 'CrossingsCounter/lambda$1$Type', 1951);
                        feb(1952, 1, fye, PMc);
                        _.Ne = function QMc(a, b) {
                            return yMc(this.a, RD(a, 12), RD(b, 12));
                        };
                        _.Fb = function RMc(a) {
                            return this === a;
                        };
                        _.Oe = function SMc() {
                            return new Frb(this);
                        };
                        var EY = sfb(tBe, 'CrossingsCounter/lambda$2$Type', 1952);
                        feb(1953, 1, fye, TMc);
                        _.Ne = function UMc(a, b) {
                            return zMc(this.a, RD(a, 12), RD(b, 12));
                        };
                        _.Fb = function VMc(a) {
                            return this === a;
                        };
                        _.Oe = function WMc() {
                            return new Frb(this);
                        };
                        var FY = sfb(tBe, 'CrossingsCounter/lambda$3$Type', 1953);
                        feb(1954, 1, Qve, XMc);
                        _.Cd = function YMc(a) {
                            EMc(this.a, RD(a, 12));
                        };
                        var GY = sfb(tBe, 'CrossingsCounter/lambda$4$Type', 1954);
                        feb(1955, 1, nwe, ZMc);
                        _.Mb = function $Mc(a) {
                            return FMc(this.a, RD(a, 12));
                        };
                        var HY = sfb(tBe, 'CrossingsCounter/lambda$5$Type', 1955);
                        feb(1956, 1, Qve, aNc);
                        _.Cd = function bNc(a) {
                            _Mc(this, a);
                        };
                        var IY = sfb(tBe, 'CrossingsCounter/lambda$6$Type', 1956);
                        feb(1957, 1, Qve, cNc);
                        _.Cd = function dNc(a) {
                            var b;
                            dMc();
                            hmb(this.b, (b = this.a, RD(a, 12), b));
                        };
                        var JY = sfb(tBe, 'CrossingsCounter/lambda$7$Type', 1957);
                        feb(839, 1, xye, eNc);
                        _.Lb = function fNc(a) {
                            return dMc(), nQb(RD(a, 12), (Ywc(), Iwc));
                        };
                        _.Fb = function gNc(a) {
                            return this === a;
                        };
                        _.Mb = function hNc(a) {
                            return dMc(), nQb(RD(a, 12), (Ywc(), Iwc));
                        };
                        var KY = sfb(tBe, 'CrossingsCounter/lambda$8$Type', 839);
                        feb(1949, 1, {}, jNc);
                        var PY = sfb(tBe, 'HyperedgeCrossingsCounter', 1949);
                        feb(478, 1, {
                            34: 1,
                            478: 1
                        }, lNc);
                        _.Fd = function mNc(a) {
                            return kNc(this, RD(a, 478));
                        };
                        _.b = 0;
                        _.c = 0;
                        _.e = 0;
                        _.f = 0;
                        var OY = sfb(tBe, 'HyperedgeCrossingsCounter/Hyperedge', 478);
                        feb(374, 1, {
                            34: 1,
                            374: 1
                        }, oNc);
                        _.Fd = function pNc(a) {
                            return nNc(this, RD(a, 374));
                        };
                        _.b = 0;
                        _.c = 0;
                        var NY = sfb(tBe, 'HyperedgeCrossingsCounter/HyperedgeCorner', 374);
                        feb(531, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            531: 1
                        }, tNc);
                        var qNc, rNc;
                        var MY = tfb(tBe, 'HyperedgeCrossingsCounter/HyperedgeCorner/Type', 531, WI, vNc, uNc);
                        var wNc;
                        feb(1425, 1, nEe, DNc);
                        _.rg = function ENc(a) {
                            return RD(mQb(RD(a, 36), (Ywc(), kwc)), 21).Hc((ovc(), hvc)) ? zNc : null;
                        };
                        _.Kf = function FNc(a, b) {
                            CNc(this, RD(a, 36), b);
                        };
                        var zNc;
                        var RY = sfb(tEe, 'InteractiveNodePlacer', 1425);
                        feb(1426, 1, nEe, TNc);
                        _.rg = function UNc(a) {
                            return RD(mQb(RD(a, 36), (Ywc(), kwc)), 21).Hc((ovc(), hvc)) ? GNc : null;
                        };
                        _.Kf = function VNc(a, b) {
                            RNc(this, RD(a, 36), b);
                        };
                        var GNc, HNc, INc;
                        var TY = sfb(tEe, 'LinearSegmentsNodePlacer', 1426);
                        feb(261, 1, {
                            34: 1,
                            261: 1
                        }, ZNc);
                        _.Fd = function $Nc(a) {
                            return WNc(this, RD(a, 261));
                        };
                        _.Fb = function _Nc(a) {
                            var b;
                            if (ZD(a, 261)) {
                                b = RD(a, 261);
                                return this.b == b.b;
                            }
                            return false;
                        };
                        _.Hb = function aOc() {
                            return this.b;
                        };
                        _.Ib = function bOc() {
                            return 'ls' + Fe(this.e);
                        };
                        _.a = 0;
                        _.b = 0;
                        _.c = -1;
                        _.d = -1;
                        _.g = 0;
                        var SY = sfb(tEe, 'LinearSegmentsNodePlacer/LinearSegment', 261);
                        feb(1428, 1, nEe, yOc);
                        _.rg = function zOc(a) {
                            return RD(mQb(RD(a, 36), (Ywc(), kwc)), 21).Hc((ovc(), hvc)) ? cOc : null;
                        };
                        _.Kf = function HOc(a, b) {
                            uOc(this, RD(a, 36), b);
                        };
                        _.b = 0;
                        _.g = 0;
                        var cOc;
                        var DZ = sfb(tEe, 'NetworkSimplexPlacer', 1428);
                        feb(1447, 1, fye, IOc);
                        _.Ne = function JOc(a, b) {
                            return hgb(RD(a, 17).a, RD(b, 17).a);
                        };
                        _.Fb = function KOc(a) {
                            return this === a;
                        };
                        _.Oe = function LOc() {
                            return new Frb(this);
                        };
                        var UY = sfb(tEe, 'NetworkSimplexPlacer/0methodref$compare$Type', 1447);
                        feb(1449, 1, fye, MOc);
                        _.Ne = function NOc(a, b) {
                            return hgb(RD(a, 17).a, RD(b, 17).a);
                        };
                        _.Fb = function OOc(a) {
                            return this === a;
                        };
                        _.Oe = function POc() {
                            return new Frb(this);
                        };
                        var VY = sfb(tEe, 'NetworkSimplexPlacer/1methodref$compare$Type', 1449);
                        feb(655, 1, {
                            655: 1
                        }, QOc);
                        var WY = sfb(tEe, 'NetworkSimplexPlacer/EdgeRep', 655);
                        feb(412, 1, {
                            412: 1
                        }, ROc);
                        _.b = false;
                        var XY = sfb(tEe, 'NetworkSimplexPlacer/NodeRep', 412);
                        feb(515, 13, {
                            3: 1,
                            4: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            13: 1,
                            16: 1,
                            15: 1,
                            59: 1,
                            515: 1
                        }, VOc);
                        var aZ = sfb(tEe, 'NetworkSimplexPlacer/Path', 515);
                        feb(1429, 1, {}, WOc);
                        _.Kb = function XOc(a) {
                            return RD(a, 18).d.i.k;
                        };
                        var YY = sfb(tEe, 'NetworkSimplexPlacer/Path/lambda$0$Type', 1429);
                        feb(1430, 1, nwe, YOc);
                        _.Mb = function ZOc(a) {
                            return RD(a, 273) == (r3b(), o3b);
                        };
                        var ZY = sfb(tEe, 'NetworkSimplexPlacer/Path/lambda$1$Type', 1430);
                        feb(1431, 1, {}, $Oc);
                        _.Kb = function _Oc(a) {
                            return RD(a, 18).d.i;
                        };
                        var $Y = sfb(tEe, 'NetworkSimplexPlacer/Path/lambda$2$Type', 1431);
                        feb(1432, 1, nwe, aPc);
                        _.Mb = function bPc(a) {
                            return EPc(zDc(RD(a, 10)));
                        };
                        var _Y = sfb(tEe, 'NetworkSimplexPlacer/Path/lambda$3$Type', 1432);
                        feb(1433, 1, nwe, cPc);
                        _.Mb = function dPc(a) {
                            return DOc(RD(a, 12));
                        };
                        var bZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$0$Type', 1433);
                        feb(1434, 1, Qve, ePc);
                        _.Cd = function fPc(a) {
                            jOc(this.a, this.b, RD(a, 12));
                        };
                        var cZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$1$Type', 1434);
                        feb(1443, 1, Qve, gPc);
                        _.Cd = function hPc(a) {
                            kOc(this.a, RD(a, 18));
                        };
                        var dZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$10$Type', 1443);
                        feb(1444, 1, {}, iPc);
                        _.Kb = function jPc(a) {
                            return dOc(), new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var eZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$11$Type', 1444);
                        feb(1445, 1, Qve, kPc);
                        _.Cd = function lPc(a) {
                            lOc(this.a, RD(a, 10));
                        };
                        var fZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$12$Type', 1445);
                        feb(1446, 1, {}, mPc);
                        _.Kb = function nPc(a) {
                            return dOc(), sgb(RD(a, 125).e);
                        };
                        var gZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$13$Type', 1446);
                        feb(1448, 1, {}, oPc);
                        _.Kb = function pPc(a) {
                            return dOc(), sgb(RD(a, 125).e);
                        };
                        var hZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$15$Type', 1448);
                        feb(1450, 1, nwe, qPc);
                        _.Mb = function rPc(a) {
                            return dOc(), RD(a, 412).c.k == (r3b(), p3b);
                        };
                        var iZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$17$Type', 1450);
                        feb(1451, 1, nwe, sPc);
                        _.Mb = function tPc(a) {
                            return dOc(), RD(a, 412).c.j.c.length > 1;
                        };
                        var jZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$18$Type', 1451);
                        feb(1452, 1, Qve, uPc);
                        _.Cd = function vPc(a) {
                            EOc(this.c, this.b, this.d, this.a, RD(a, 412));
                        };
                        _.c = 0;
                        _.d = 0;
                        var kZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$19$Type', 1452);
                        feb(1435, 1, {}, wPc);
                        _.Kb = function xPc(a) {
                            return dOc(), new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var lZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$2$Type', 1435);
                        feb(1453, 1, Qve, yPc);
                        _.Cd = function zPc(a) {
                            FOc(this.a, RD(a, 12));
                        };
                        _.a = 0;
                        var mZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$20$Type', 1453);
                        feb(1454, 1, {}, APc);
                        _.Kb = function BPc(a) {
                            return dOc(), new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var nZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$21$Type', 1454);
                        feb(1455, 1, Qve, CPc);
                        _.Cd = function DPc(a) {
                            mOc(this.a, RD(a, 10));
                        };
                        var oZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$22$Type', 1455);
                        feb(1456, 1, nwe, FPc);
                        _.Mb = function GPc(a) {
                            return EPc(a);
                        };
                        var pZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$23$Type', 1456);
                        feb(1457, 1, {}, HPc);
                        _.Kb = function IPc(a) {
                            return dOc(), new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var qZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$24$Type', 1457);
                        feb(1458, 1, nwe, JPc);
                        _.Mb = function KPc(a) {
                            return nOc(this.a, RD(a, 10));
                        };
                        var rZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$25$Type', 1458);
                        feb(1459, 1, Qve, LPc);
                        _.Cd = function MPc(a) {
                            oOc(this.a, this.b, RD(a, 10));
                        };
                        var sZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$26$Type', 1459);
                        feb(1460, 1, nwe, NPc);
                        _.Mb = function OPc(a) {
                            return dOc(), !W0b(RD(a, 18));
                        };
                        var tZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$27$Type', 1460);
                        feb(1461, 1, nwe, PPc);
                        _.Mb = function QPc(a) {
                            return dOc(), !W0b(RD(a, 18));
                        };
                        var uZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$28$Type', 1461);
                        feb(1462, 1, {}, RPc);
                        _.Ve = function SPc(a, b) {
                            return pOc(this.a, RD(a, 30), RD(b, 30));
                        };
                        var vZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$29$Type', 1462);
                        feb(1436, 1, {}, TPc);
                        _.Kb = function UPc(a) {
                            return dOc(), new SDb(null, new Twb(new is(Mr(a3b(RD(a, 10)).a.Kc(), new ir))));
                        };
                        var wZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$3$Type', 1436);
                        feb(1437, 1, nwe, VPc);
                        _.Mb = function WPc(a) {
                            return dOc(), COc(RD(a, 18));
                        };
                        var xZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$4$Type', 1437);
                        feb(1438, 1, Qve, XPc);
                        _.Cd = function YPc(a) {
                            vOc(this.a, RD(a, 18));
                        };
                        var yZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$5$Type', 1438);
                        feb(1439, 1, {}, ZPc);
                        _.Kb = function $Pc(a) {
                            return dOc(), new SDb(null, new Swb(RD(a, 30).a, 16));
                        };
                        var zZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$6$Type', 1439);
                        feb(1440, 1, nwe, _Pc);
                        _.Mb = function aQc(a) {
                            return dOc(), RD(a, 10).k == (r3b(), p3b);
                        };
                        var AZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$7$Type', 1440);
                        feb(1441, 1, {}, bQc);
                        _.Kb = function cQc(a) {
                            return dOc(), new SDb(null, new Twb(new is(Mr(W2b(RD(a, 10)).a.Kc(), new ir))));
                        };
                        var BZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$8$Type', 1441);
                        feb(1442, 1, nwe, dQc);
                        _.Mb = function eQc(a) {
                            return dOc(), V0b(RD(a, 18));
                        };
                        var CZ = sfb(tEe, 'NetworkSimplexPlacer/lambda$9$Type', 1442);
                        feb(1424, 1, nEe, iQc);
                        _.rg = function jQc(a) {
                            return RD(mQb(RD(a, 36), (Ywc(), kwc)), 21).Hc((ovc(), hvc)) ? fQc : null;
                        };
                        _.Kf = function kQc(a, b) {
                            hQc(RD(a, 36), b);
                        };
                        var fQc;
                        var EZ = sfb(tEe, 'SimpleNodePlacer', 1424);
                        feb(185, 1, {
                            185: 1
                        }, sQc);
                        _.Ib = function tQc() {
                            var a;
                            a = '';
                            this.c == (wQc(), vQc) ? a += Oye : this.c == uQc && (a += Nye);
                            this.o == (EQc(), CQc) ? a += Zye : this.o == DQc ? a += 'UP' : a += 'BALANCED';
                            return a;
                        };
                        var HZ = sfb(wEe, 'BKAlignedLayout', 185);
                        feb(523, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            523: 1
                        }, xQc);
                        var uQc, vQc;
                        var FZ = tfb(wEe, 'BKAlignedLayout/HDirection', 523, WI, zQc, yQc);
                        var AQc;
                        feb(522, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            522: 1
                        }, FQc);
                        var CQc, DQc;
                        var GZ = tfb(wEe, 'BKAlignedLayout/VDirection', 522, WI, HQc, GQc);
                        var IQc;
                        feb(1699, 1, {}, MQc);
                        var IZ = sfb(wEe, 'BKAligner', 1699);
                        feb(1702, 1, {}, RQc);
                        var LZ = sfb(wEe, 'BKCompactor', 1702);
                        feb(663, 1, {
                            663: 1
                        }, SQc);
                        _.a = 0;
                        var JZ = sfb(wEe, 'BKCompactor/ClassEdge', 663);
                        feb(467, 1, {
                            467: 1
                        }, UQc);
                        _.a = null;
                        _.b = 0;
                        var KZ = sfb(wEe, 'BKCompactor/ClassNode', 467);
                        feb(1427, 1, nEe, aRc);
                        _.rg = function eRc(a) {
                            return RD(mQb(RD(a, 36), (Ywc(), kwc)), 21).Hc((ovc(), hvc)) ? VQc : null;
                        };
                        _.Kf = function fRc(a, b) {
                            _Qc(this, RD(a, 36), b);
                        };
                        _.d = false;
                        var VQc;
                        var MZ = sfb(wEe, 'BKNodePlacer', 1427);
                        feb(1700, 1, {}, hRc);
                        _.d = 0;
                        var OZ = sfb(wEe, 'NeighborhoodInformation', 1700);
                        feb(1701, 1, fye, mRc);
                        _.Ne = function nRc(a, b) {
                            return lRc(this, RD(a, 42), RD(b, 42));
                        };
                        _.Fb = function oRc(a) {
                            return this === a;
                        };
                        _.Oe = function pRc() {
                            return new Frb(this);
                        };
                        var NZ = sfb(wEe, 'NeighborhoodInformation/NeighborComparator', 1701);
                        feb(823, 1, {});
                        var SZ = sfb(wEe, 'ThresholdStrategy', 823);
                        feb(1825, 823, {}, uRc);
                        _.wg = function vRc(a, b, c) {
                            return this.a.o == (EQc(), DQc) ? oxe : pxe;
                        };
                        _.xg = function wRc() {};
                        var PZ = sfb(wEe, 'ThresholdStrategy/NullThresholdStrategy', 1825);
                        feb(587, 1, {
                            587: 1
                        }, xRc);
                        _.c = false;
                        _.d = false;
                        var QZ = sfb(wEe, 'ThresholdStrategy/Postprocessable', 587);
                        feb(1826, 823, {}, BRc);
                        _.wg = function CRc(a, b, c) {
                            var d, e, f;
                            e = b == c;
                            d = this.a.a[c.p] == b;
                            if (!(e || d)) return a;
                            f = a;
                            if (this.a.c == (wQc(), vQc)) {
                                e && (f = yRc(this, b, true));
                                !isNaN(f) && !isFinite(f) && d && (f = yRc(this, c, false));
                            } else {
                                e && (f = yRc(this, b, true));
                                !isNaN(f) && !isFinite(f) && d && (f = yRc(this, c, false));
                            }
                            return f;
                        };
                        _.xg = function DRc() {
                            var a, b, c, d, e;
                            while(this.d.b != 0){
                                e = RD(Tub(this.d), 587);
                                d = zRc(this, e);
                                if (!d.a) continue;
                                a = d.a;
                                c = Heb(this.a.f[this.a.g[e.b.p].p]);
                                if (!c && !W0b(a) && a.c.i.c == a.d.i.c) continue;
                                b = ARc(this, e);
                                b || Eyb(this.e, e);
                            }
                            while(this.e.a.c.length != 0)ARc(this, RD(Dyb(this.e), 587));
                        };
                        var RZ = sfb(wEe, 'ThresholdStrategy/SimpleThresholdStrategy', 1826);
                        feb(645, 1, {
                            645: 1,
                            188: 1,
                            196: 1
                        }, HRc);
                        _.dg = function JRc() {
                            return GRc(this);
                        };
                        _.qg = function IRc() {
                            return GRc(this);
                        };
                        var ERc;
                        var TZ = sfb(xEe, 'EdgeRouterFactory', 645);
                        feb(1485, 1, nEe, WRc);
                        _.rg = function XRc(a) {
                            return URc(RD(a, 36));
                        };
                        _.Kf = function YRc(a, b) {
                            VRc(RD(a, 36), b);
                        };
                        var LRc, MRc, NRc, ORc, PRc, QRc, RRc, SRc;
                        var UZ = sfb(xEe, 'OrthogonalEdgeRouter', 1485);
                        feb(1478, 1, nEe, lSc);
                        _.rg = function mSc(a) {
                            return gSc(RD(a, 36));
                        };
                        _.Kf = function nSc(a, b) {
                            iSc(this, RD(a, 36), b);
                        };
                        var ZRc, $Rc, _Rc, aSc, bSc, cSc;
                        var WZ = sfb(xEe, 'PolylineEdgeRouter', 1478);
                        feb(1479, 1, xye, pSc);
                        _.Lb = function qSc(a) {
                            return oSc(RD(a, 10));
                        };
                        _.Fb = function rSc(a) {
                            return this === a;
                        };
                        _.Mb = function sSc(a) {
                            return oSc(RD(a, 10));
                        };
                        var VZ = sfb(xEe, 'PolylineEdgeRouter/1', 1479);
                        feb(1872, 1, nwe, xSc);
                        _.Mb = function ySc(a) {
                            return RD(a, 132).c == (fTc(), dTc);
                        };
                        var XZ = sfb(yEe, 'HyperEdgeCycleDetector/lambda$0$Type', 1872);
                        feb(1873, 1, {}, zSc);
                        _.Ze = function ASc(a) {
                            return RD(a, 132).d;
                        };
                        var YZ = sfb(yEe, 'HyperEdgeCycleDetector/lambda$1$Type', 1873);
                        feb(1874, 1, nwe, BSc);
                        _.Mb = function CSc(a) {
                            return RD(a, 132).c == (fTc(), dTc);
                        };
                        var ZZ = sfb(yEe, 'HyperEdgeCycleDetector/lambda$2$Type', 1874);
                        feb(1875, 1, {}, DSc);
                        _.Ze = function ESc(a) {
                            return RD(a, 132).d;
                        };
                        var $Z = sfb(yEe, 'HyperEdgeCycleDetector/lambda$3$Type', 1875);
                        feb(1876, 1, {}, FSc);
                        _.Ze = function GSc(a) {
                            return RD(a, 132).d;
                        };
                        var _Z = sfb(yEe, 'HyperEdgeCycleDetector/lambda$4$Type', 1876);
                        feb(1877, 1, {}, HSc);
                        _.Ze = function ISc(a) {
                            return RD(a, 132).d;
                        };
                        var a$ = sfb(yEe, 'HyperEdgeCycleDetector/lambda$5$Type', 1877);
                        feb(118, 1, {
                            34: 1,
                            118: 1
                        }, USc);
                        _.Fd = function VSc(a) {
                            return KSc(this, RD(a, 118));
                        };
                        _.Fb = function WSc(a) {
                            var b;
                            if (ZD(a, 118)) {
                                b = RD(a, 118);
                                return this.g == b.g;
                            }
                            return false;
                        };
                        _.Hb = function XSc() {
                            return this.g;
                        };
                        _.Ib = function ZSc() {
                            var a, b, c, d;
                            a = new dib('{');
                            d = new Anb(this.n);
                            while(d.a < d.c.c.length){
                                c = RD(ynb(d), 12);
                                b = X2b(c.i);
                                b == null && (b = 'n' + $2b(c.i));
                                a.a += '' + b;
                                d.a < d.c.c.length && (a.a += ',', a);
                            }
                            a.a += '}';
                            return a.a;
                        };
                        _.a = 0;
                        _.b = 0;
                        _.c = NaN;
                        _.d = 0;
                        _.g = 0;
                        _.i = 0;
                        _.o = 0;
                        _.s = NaN;
                        var l$ = sfb(yEe, 'HyperEdgeSegment', 118);
                        feb(132, 1, {
                            132: 1
                        }, bTc);
                        _.Ib = function cTc() {
                            return this.a + '->' + this.b + ' (' + os(this.c) + ')';
                        };
                        _.d = 0;
                        var c$ = sfb(yEe, 'HyperEdgeSegmentDependency', 132);
                        feb(528, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            528: 1
                        }, gTc);
                        var dTc, eTc;
                        var b$ = tfb(yEe, 'HyperEdgeSegmentDependency/DependencyType', 528, WI, iTc, hTc);
                        var jTc;
                        feb(1878, 1, {}, xTc);
                        var k$ = sfb(yEe, 'HyperEdgeSegmentSplitter', 1878);
                        feb(1879, 1, {}, ATc);
                        _.a = 0;
                        _.b = 0;
                        var d$ = sfb(yEe, 'HyperEdgeSegmentSplitter/AreaRating', 1879);
                        feb(339, 1, {
                            339: 1
                        }, BTc);
                        _.a = 0;
                        _.b = 0;
                        _.c = 0;
                        var e$ = sfb(yEe, 'HyperEdgeSegmentSplitter/FreeArea', 339);
                        feb(1880, 1, fye, CTc);
                        _.Ne = function DTc(a, b) {
                            return zTc(RD(a, 118), RD(b, 118));
                        };
                        _.Fb = function ETc(a) {
                            return this === a;
                        };
                        _.Oe = function FTc() {
                            return new Frb(this);
                        };
                        var f$ = sfb(yEe, 'HyperEdgeSegmentSplitter/lambda$0$Type', 1880);
                        feb(1881, 1, Qve, GTc);
                        _.Cd = function HTc(a) {
                            rTc(this.a, this.d, this.c, this.b, RD(a, 118));
                        };
                        _.b = 0;
                        var g$ = sfb(yEe, 'HyperEdgeSegmentSplitter/lambda$1$Type', 1881);
                        feb(1882, 1, {}, ITc);
                        _.Kb = function JTc(a) {
                            return new SDb(null, new Swb(RD(a, 118).e, 16));
                        };
                        var h$ = sfb(yEe, 'HyperEdgeSegmentSplitter/lambda$2$Type', 1882);
                        feb(1883, 1, {}, KTc);
                        _.Kb = function LTc(a) {
                            return new SDb(null, new Swb(RD(a, 118).j, 16));
                        };
                        var i$ = sfb(yEe, 'HyperEdgeSegmentSplitter/lambda$3$Type', 1883);
                        feb(1884, 1, {}, MTc);
                        _.Ye = function NTc(a) {
                            return Kfb(UD(a));
                        };
                        var j$ = sfb(yEe, 'HyperEdgeSegmentSplitter/lambda$4$Type', 1884);
                        feb(664, 1, {}, TTc);
                        _.a = 0;
                        _.b = 0;
                        _.c = 0;
                        var o$ = sfb(yEe, 'OrthogonalRoutingGenerator', 664);
                        feb(1703, 1, {}, XTc);
                        _.Kb = function YTc(a) {
                            return new SDb(null, new Swb(RD(a, 118).e, 16));
                        };
                        var m$ = sfb(yEe, 'OrthogonalRoutingGenerator/lambda$0$Type', 1703);
                        feb(1704, 1, {}, ZTc);
                        _.Kb = function $Tc(a) {
                            return new SDb(null, new Swb(RD(a, 118).j, 16));
                        };
                        var n$ = sfb(yEe, 'OrthogonalRoutingGenerator/lambda$1$Type', 1704);
                        feb(670, 1, {});
                        var p$ = sfb(zEe, 'BaseRoutingDirectionStrategy', 670);
                        feb(1870, 670, {}, cUc);
                        _.yg = function dUc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p;
                            if (!!a.r && !a.q) return;
                            k = b + a.o * c;
                            for(j = new Anb(a.n); j.a < j.c.c.length;){
                                i = RD(ynb(j), 12);
                                l = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                    i.i.n,
                                    i.n,
                                    i.a
                                ])).a;
                                for(h = new Anb(i.g); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 18);
                                    if (!W0b(g)) {
                                        o = g.d;
                                        p = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                            o.i.n,
                                            o.n,
                                            o.a
                                        ])).a;
                                        if ($wnd.Math.abs(l - p) > Vze) {
                                            f = k;
                                            e = a;
                                            d = new rjd(l, f);
                                            Mub(g.a, d);
                                            _Tc(this, g, e, d, false);
                                            m = a.r;
                                            if (m) {
                                                n = Kfb(UD(ju(m.e, 0)));
                                                d = new rjd(n, f);
                                                Mub(g.a, d);
                                                _Tc(this, g, e, d, false);
                                                f = b + m.o * c;
                                                e = m;
                                                d = new rjd(n, f);
                                                Mub(g.a, d);
                                                _Tc(this, g, e, d, false);
                                            }
                                            d = new rjd(p, f);
                                            Mub(g.a, d);
                                            _Tc(this, g, e, d, false);
                                        }
                                    }
                                }
                            }
                        };
                        _.zg = function eUc(a) {
                            return a.i.n.a + a.n.a + a.a.a;
                        };
                        _.Ag = function fUc() {
                            return qpd(), npd;
                        };
                        _.Bg = function gUc() {
                            return qpd(), Yod;
                        };
                        var q$ = sfb(zEe, 'NorthToSouthRoutingStrategy', 1870);
                        feb(1871, 670, {}, hUc);
                        _.yg = function iUc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p;
                            if (!!a.r && !a.q) return;
                            k = b - a.o * c;
                            for(j = new Anb(a.n); j.a < j.c.c.length;){
                                i = RD(ynb(j), 12);
                                l = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                    i.i.n,
                                    i.n,
                                    i.a
                                ])).a;
                                for(h = new Anb(i.g); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 18);
                                    if (!W0b(g)) {
                                        o = g.d;
                                        p = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                            o.i.n,
                                            o.n,
                                            o.a
                                        ])).a;
                                        if ($wnd.Math.abs(l - p) > Vze) {
                                            f = k;
                                            e = a;
                                            d = new rjd(l, f);
                                            Mub(g.a, d);
                                            _Tc(this, g, e, d, false);
                                            m = a.r;
                                            if (m) {
                                                n = Kfb(UD(ju(m.e, 0)));
                                                d = new rjd(n, f);
                                                Mub(g.a, d);
                                                _Tc(this, g, e, d, false);
                                                f = b - m.o * c;
                                                e = m;
                                                d = new rjd(n, f);
                                                Mub(g.a, d);
                                                _Tc(this, g, e, d, false);
                                            }
                                            d = new rjd(p, f);
                                            Mub(g.a, d);
                                            _Tc(this, g, e, d, false);
                                        }
                                    }
                                }
                            }
                        };
                        _.zg = function jUc(a) {
                            return a.i.n.a + a.n.a + a.a.a;
                        };
                        _.Ag = function kUc() {
                            return qpd(), Yod;
                        };
                        _.Bg = function lUc() {
                            return qpd(), npd;
                        };
                        var r$ = sfb(zEe, 'SouthToNorthRoutingStrategy', 1871);
                        feb(1869, 670, {}, mUc);
                        _.yg = function nUc(a, b, c) {
                            var d, e, f, g, h, i, j, k, l, m, n, o, p;
                            if (!!a.r && !a.q) return;
                            k = b + a.o * c;
                            for(j = new Anb(a.n); j.a < j.c.c.length;){
                                i = RD(ynb(j), 12);
                                l = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                    i.i.n,
                                    i.n,
                                    i.a
                                ])).b;
                                for(h = new Anb(i.g); h.a < h.c.c.length;){
                                    g = RD(ynb(h), 18);
                                    if (!W0b(g)) {
                                        o = g.d;
                                        p = xjd(cD(WC(l3, 1), Nve, 8, 0, [
                                            o.i.n,
                                            o.n,
                                            o.a
                                        ])).b;
                                        if ($wnd.Math.abs(l - p) > Vze) {
                                            f = k;
                                            e = a;
                                            d = new rjd(f, l);
                                            Mub(g.a, d);
                                            _Tc(this, g, e, d, true);
                                            m = a.r;
                                            if (m) {
                                                n = Kfb(UD(ju(m.e, 0)));
                                                d = new rjd(f, n);
                                                Mub(g.a, d);
                                                _Tc(this, g, e, d, true);
                                                f = b + m.o * c;
                                                e = m;
                                                d = new rjd(f, n);
                                                Mub(g.a, d);
                                                _Tc(this, g, e, d, true);
                                            }
                                            d = new rjd(f, p);
                                            Mub(g.a, d);
                                            _Tc(this, g, e, d, true);
                                        }
                                    }
                                }
                            }
                        };
                        _.zg = function oUc(a) {
                            return a.i.n.b + a.n.b + a.a.b;
                        };
                        _.Ag = function pUc() {
                            return qpd(), Xod;
                        };
                        _.Bg = function qUc() {
                            return qpd(), ppd;
                        };
                        var s$ = sfb(zEe, 'WestToEastRoutingStrategy', 1869);
                        feb(828, 1, {}, wUc);
                        _.Ib = function xUc() {
                            return Fe(this.a);
                        };
                        _.b = 0;
                        _.c = false;
                        _.d = false;
                        _.f = 0;
                        var u$ = sfb(BEe, 'NubSpline', 828);
                        feb(418, 1, {
                            418: 1
                        }, AUc, BUc);
                        var t$ = sfb(BEe, 'NubSpline/PolarCP', 418);
                        feb(1480, 1, nEe, VUc);
                        _.rg = function XUc(a) {
                            return QUc(RD(a, 36));
                        };
                        _.Kf = function YUc(a, b) {
                            UUc(this, RD(a, 36), b);
                        };
                        var CUc, DUc, EUc, FUc, GUc;
                        var B$ = sfb(BEe, 'SplineEdgeRouter', 1480);
                        feb(274, 1, {
                            274: 1
                        }, _Uc);
                        _.Ib = function aVc() {
                            return this.a + ' ->(' + this.c + ') ' + this.b;
                        };
                        _.c = 0;
                        var v$ = sfb(BEe, 'SplineEdgeRouter/Dependency', 274);
                        feb(465, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            465: 1
                        }, eVc);
                        var bVc, cVc;
                        var w$ = tfb(BEe, 'SplineEdgeRouter/SideToProcess', 465, WI, gVc, fVc);
                        var hVc;
                        feb(1481, 1, nwe, jVc);
                        _.Mb = function kVc(a) {
                            return HUc(), !RD(a, 131).o;
                        };
                        var x$ = sfb(BEe, 'SplineEdgeRouter/lambda$0$Type', 1481);
                        feb(1482, 1, {}, lVc);
                        _.Ze = function mVc(a) {
                            return HUc(), RD(a, 131).v + 1;
                        };
                        var y$ = sfb(BEe, 'SplineEdgeRouter/lambda$1$Type', 1482);
                        feb(1483, 1, Qve, nVc);
                        _.Cd = function oVc(a) {
                            SUc(this.a, this.b, RD(a, 42));
                        };
                        var z$ = sfb(BEe, 'SplineEdgeRouter/lambda$2$Type', 1483);
                        feb(1484, 1, Qve, pVc);
                        _.Cd = function qVc(a) {
                            TUc(this.a, this.b, RD(a, 42));
                        };
                        var A$ = sfb(BEe, 'SplineEdgeRouter/lambda$3$Type', 1484);
                        feb(131, 1, {
                            34: 1,
                            131: 1
                        }, wVc, xVc);
                        _.Fd = function yVc(a) {
                            return uVc(this, RD(a, 131));
                        };
                        _.b = 0;
                        _.e = false;
                        _.f = 0;
                        _.g = 0;
                        _.j = false;
                        _.k = false;
                        _.n = 0;
                        _.o = false;
                        _.p = false;
                        _.q = false;
                        _.s = 0;
                        _.u = 0;
                        _.v = 0;
                        _.F = 0;
                        var D$ = sfb(BEe, 'SplineSegment', 131);
                        feb(468, 1, {
                            468: 1
                        }, zVc);
                        _.a = 0;
                        _.b = false;
                        _.c = false;
                        _.d = false;
                        _.e = false;
                        _.f = 0;
                        var C$ = sfb(BEe, 'SplineSegment/EdgeInformation', 468);
                        feb(1198, 1, {}, IVc);
                        var F$ = sfb(GEe, Lze, 1198);
                        feb(1199, 1, fye, KVc);
                        _.Ne = function LVc(a, b) {
                            return JVc(RD(a, 121), RD(b, 121));
                        };
                        _.Fb = function MVc(a) {
                            return this === a;
                        };
                        _.Oe = function NVc() {
                            return new Frb(this);
                        };
                        var E$ = sfb(GEe, Mze, 1199);
                        feb(1197, 1, {}, TVc);
                        var G$ = sfb(GEe, 'MrTree', 1197);
                        feb(405, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            405: 1,
                            188: 1,
                            196: 1
                        }, $Vc);
                        _.dg = function aWc() {
                            return ZVc(this);
                        };
                        _.qg = function _Vc() {
                            return ZVc(this);
                        };
                        var UVc, VVc, WVc, XVc;
                        var H$ = tfb(GEe, 'TreeLayoutPhases', 405, WI, cWc, bWc);
                        var dWc;
                        feb(1112, 205, oze, fWc);
                        _.rf = function gWc(a, b) {
                            var c, d, e, f, g, h, i, j;
                            Heb(TD(Gxd(a, (h_c(), S$c)))) || RFb((c = new SFb((lud(), new zud(a))), c));
                            g = b.eh(HEe);
                            g.Ug('build tGraph', 1);
                            h = (i = new YWc, kQb(i, a), pQb(i, (q$c(), h$c), a), j = new Tsb, QVc(a, i, j), PVc(a, i, j), i);
                            g.Vg();
                            g = b.eh(HEe);
                            g.Ug('Split graph', 1);
                            f = HVc(this.a, h);
                            g.Vg();
                            for(e = new Anb(f); e.a < e.c.c.length;){
                                d = RD(ynb(e), 121);
                                RVc(this.b, d, b.eh(0.5999999940395355 / f.c.length));
                            }
                            g = b.eh(HEe);
                            g.Ug('Pack components', 1);
                            h = GVc(f);
                            g.Vg();
                            g = b.eh(HEe);
                            g.Ug('Apply layout results', 1);
                            OVc(h);
                            g.Vg();
                        };
                        var I$ = sfb(GEe, 'TreeLayoutProvider', 1112);
                        feb(1894, 1, Vve, uWc);
                        _.Jc = function vWc(a) {
                            xgb(this, a);
                        };
                        _.Kc = function wWc() {
                            return yob(), Qob(), Pob;
                        };
                        var J$ = sfb(GEe, 'TreeUtil/1', 1894);
                        feb(1895, 1, Vve, xWc);
                        _.Jc = function yWc(a) {
                            xgb(this, a);
                        };
                        _.Kc = function zWc() {
                            return yob(), Qob(), Pob;
                        };
                        var K$ = sfb(GEe, 'TreeUtil/2', 1895);
                        feb(1885, 1, nwe, AWc);
                        _.Mb = function BWc(a) {
                            return Heb(TD(mQb(RD(a, 40), (q$c(), n$c))));
                        };
                        var L$ = sfb(GEe, 'TreeUtil/lambda$0$Type', 1885);
                        feb(1891, 1, nwe, CWc);
                        _.Mb = function DWc(a) {
                            return this.a.Hc(RD(a, 40));
                        };
                        var M$ = sfb(GEe, 'TreeUtil/lambda$10$Type', 1891);
                        feb(1892, 1, {}, EWc);
                        _.Kb = function FWc(a) {
                            return nWc(this.a, RD(a, 40));
                        };
                        var N$ = sfb(GEe, 'TreeUtil/lambda$11$Type', 1892);
                        feb(1893, 1, nwe, GWc);
                        _.Mb = function HWc(a) {
                            return oWc(this.a, this.b, RD(a, 40));
                        };
                        var O$ = sfb(GEe, 'TreeUtil/lambda$12$Type', 1893);
                        feb(1886, 1, nwe, IWc);
                        _.Mb = function JWc(a) {
                            return pWc(this.a, RD(a, 65));
                        };
                        var P$ = sfb(GEe, 'TreeUtil/lambda$3$Type', 1886);
                        feb(1887, 1, fye, KWc);
                        _.Ne = function LWc(a, b) {
                            return qWc(RD(a, 65), RD(b, 65));
                        };
                        _.Fb = function MWc(a) {
                            return this === a;
                        };
                        _.Oe = function NWc() {
                            return new Frb(this);
                        };
                        var Q$ = sfb(GEe, 'TreeUtil/lambda$4$Type', 1887);
                        feb(1888, 1, nwe, OWc);
                        _.Mb = function PWc(a) {
                            return rWc(this.a, RD(a, 65));
                        };
                        var R$ = sfb(GEe, 'TreeUtil/lambda$7$Type', 1888);
                        feb(1889, 1, fye, QWc);
                        _.Ne = function RWc(a, b) {
                            return sWc(RD(a, 65), RD(b, 65));
                        };
                        _.Fb = function SWc(a) {
                            return this === a;
                        };
                        _.Oe = function TWc() {
                            return new Frb(this);
                        };
                        var S$ = sfb(GEe, 'TreeUtil/lambda$8$Type', 1889);
                        feb(1890, 1, {}, UWc);
                        _.Kb = function VWc(a) {
                            return RD(a, 65).b;
                        };
                        var T$ = sfb(GEe, 'TreeUtil/lambda$9$Type', 1890);
                        feb(508, 137, {
                            3: 1,
                            508: 1,
                            96: 1,
                            137: 1
                        });
                        _.g = 0;
                        var V$ = sfb(JEe, 'TGraphElement', 508);
                        feb(65, 508, {
                            3: 1,
                            65: 1,
                            508: 1,
                            96: 1,
                            137: 1
                        }, WWc);
                        _.Ib = function XWc() {
                            return !!this.b && !!this.c ? aXc(this.b) + '->' + aXc(this.c) : 'e_' + tb(this);
                        };
                        var U$ = sfb(JEe, 'TEdge', 65);
                        feb(121, 137, {
                            3: 1,
                            121: 1,
                            96: 1,
                            137: 1
                        }, YWc);
                        _.Ib = function ZWc() {
                            var a, b, c, d, e;
                            e = null;
                            for(d = Sub(this.b, 0); d.b != d.d.c;){
                                c = RD(evb(d), 40);
                                e += (c.c == null || c.c.length == 0 ? 'n_' + c.g : 'n_' + c.c) + '\n';
                            }
                            for(b = Sub(this.a, 0); b.b != b.d.c;){
                                a = RD(evb(b), 65);
                                e += (!!a.b && !!a.c ? aXc(a.b) + '->' + aXc(a.c) : 'e_' + tb(a)) + '\n';
                            }
                            return e;
                        };
                        var W$ = sfb(JEe, 'TGraph', 121);
                        feb(643, 508, {
                            3: 1,
                            508: 1,
                            643: 1,
                            96: 1,
                            137: 1
                        });
                        var $$ = sfb(JEe, 'TShape', 643);
                        feb(40, 643, {
                            3: 1,
                            508: 1,
                            40: 1,
                            643: 1,
                            96: 1,
                            137: 1
                        }, bXc);
                        _.Ib = function cXc() {
                            return aXc(this);
                        };
                        var Z$ = sfb(JEe, 'TNode', 40);
                        feb(236, 1, Vve, dXc);
                        _.Jc = function eXc(a) {
                            xgb(this, a);
                        };
                        _.Kc = function fXc() {
                            var a;
                            return a = Sub(this.a.d, 0), new gXc(a);
                        };
                        var Y$ = sfb(JEe, 'TNode/2', 236);
                        feb(329, 1, Ave, gXc);
                        _.Nb = function hXc(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function jXc() {
                            return RD(evb(this.a), 65).c;
                        };
                        _.Ob = function iXc() {
                            return dvb(this.a);
                        };
                        _.Qb = function kXc() {
                            gvb(this.a);
                        };
                        var X$ = sfb(JEe, 'TNode/2/1', 329);
                        feb(1923, 1, QAe, qXc);
                        _.Kf = function DXc(a, b) {
                            oXc(this, RD(a, 121), b);
                        };
                        var m_ = sfb(LEe, 'CompactionProcessor', 1923);
                        feb(1924, 1, fye, EXc);
                        _.Ne = function FXc(a, b) {
                            return rXc(this.a, RD(a, 40), RD(b, 40));
                        };
                        _.Fb = function GXc(a) {
                            return this === a;
                        };
                        _.Oe = function HXc() {
                            return new Frb(this);
                        };
                        var _$ = sfb(LEe, 'CompactionProcessor/lambda$0$Type', 1924);
                        feb(1925, 1, nwe, IXc);
                        _.Mb = function JXc(a) {
                            return sXc(this.b, this.a, RD(a, 42));
                        };
                        _.a = 0;
                        _.b = 0;
                        var a_ = sfb(LEe, 'CompactionProcessor/lambda$1$Type', 1925);
                        feb(1934, 1, fye, KXc);
                        _.Ne = function LXc(a, b) {
                            return tXc(RD(a, 40), RD(b, 40));
                        };
                        _.Fb = function MXc(a) {
                            return this === a;
                        };
                        _.Oe = function NXc() {
                            return new Frb(this);
                        };
                        var b_ = sfb(LEe, 'CompactionProcessor/lambda$10$Type', 1934);
                        feb(1935, 1, fye, OXc);
                        _.Ne = function PXc(a, b) {
                            return uXc(RD(a, 40), RD(b, 40));
                        };
                        _.Fb = function QXc(a) {
                            return this === a;
                        };
                        _.Oe = function RXc() {
                            return new Frb(this);
                        };
                        var c_ = sfb(LEe, 'CompactionProcessor/lambda$11$Type', 1935);
                        feb(1936, 1, fye, SXc);
                        _.Ne = function TXc(a, b) {
                            return vXc(RD(a, 40), RD(b, 40));
                        };
                        _.Fb = function UXc(a) {
                            return this === a;
                        };
                        _.Oe = function VXc() {
                            return new Frb(this);
                        };
                        var d_ = sfb(LEe, 'CompactionProcessor/lambda$12$Type', 1936);
                        feb(1926, 1, nwe, WXc);
                        _.Mb = function XXc(a) {
                            return wXc(this.a, RD(a, 42));
                        };
                        _.a = 0;
                        var e_ = sfb(LEe, 'CompactionProcessor/lambda$2$Type', 1926);
                        feb(1927, 1, nwe, YXc);
                        _.Mb = function ZXc(a) {
                            return xXc(this.a, RD(a, 42));
                        };
                        _.a = 0;
                        var f_ = sfb(LEe, 'CompactionProcessor/lambda$3$Type', 1927);
                        feb(1928, 1, nwe, $Xc);
                        _.Mb = function _Xc(a) {
                            return RD(a, 40).c.indexOf(IEe) == -1;
                        };
                        var g_ = sfb(LEe, 'CompactionProcessor/lambda$4$Type', 1928);
                        feb(1929, 1, {}, aYc);
                        _.Kb = function bYc(a) {
                            return yXc(this.a, RD(a, 40));
                        };
                        _.a = 0;
                        var h_ = sfb(LEe, 'CompactionProcessor/lambda$5$Type', 1929);
                        feb(1930, 1, {}, cYc);
                        _.Kb = function dYc(a) {
                            return zXc(this.a, RD(a, 40));
                        };
                        _.a = 0;
                        var i_ = sfb(LEe, 'CompactionProcessor/lambda$6$Type', 1930);
                        feb(1931, 1, fye, eYc);
                        _.Ne = function fYc(a, b) {
                            return AXc(this.a, RD(a, 240), RD(b, 240));
                        };
                        _.Fb = function gYc(a) {
                            return this === a;
                        };
                        _.Oe = function hYc() {
                            return new Frb(this);
                        };
                        var j_ = sfb(LEe, 'CompactionProcessor/lambda$7$Type', 1931);
                        feb(1932, 1, fye, iYc);
                        _.Ne = function jYc(a, b) {
                            return BXc(this.a, RD(a, 40), RD(b, 40));
                        };
                        _.Fb = function kYc(a) {
                            return this === a;
                        };
                        _.Oe = function lYc() {
                            return new Frb(this);
                        };
                        var k_ = sfb(LEe, 'CompactionProcessor/lambda$8$Type', 1932);
                        feb(1933, 1, fye, mYc);
                        _.Ne = function nYc(a, b) {
                            return CXc(RD(a, 40), RD(b, 40));
                        };
                        _.Fb = function oYc(a) {
                            return this === a;
                        };
                        _.Oe = function pYc() {
                            return new Frb(this);
                        };
                        var l_ = sfb(LEe, 'CompactionProcessor/lambda$9$Type', 1933);
                        feb(1921, 1, QAe, rYc);
                        _.Kf = function sYc(a, b) {
                            qYc(RD(a, 121), b);
                        };
                        var n_ = sfb(LEe, 'DirectionProcessor', 1921);
                        feb(1913, 1, QAe, vYc);
                        _.Kf = function xYc(a, b) {
                            uYc(this, RD(a, 121), b);
                        };
                        var o_ = sfb(LEe, 'FanProcessor', 1913);
                        feb(1937, 1, QAe, zYc);
                        _.Kf = function CYc(a, b) {
                            yYc(RD(a, 121), b);
                        };
                        var t_ = sfb(LEe, 'GraphBoundsProcessor', 1937);
                        feb(1938, 1, {}, DYc);
                        _.Ye = function EYc(a) {
                            return RD(a, 40).e.a;
                        };
                        var p_ = sfb(LEe, 'GraphBoundsProcessor/lambda$0$Type', 1938);
                        feb(1939, 1, {}, FYc);
                        _.Ye = function GYc(a) {
                            return RD(a, 40).e.b;
                        };
                        var q_ = sfb(LEe, 'GraphBoundsProcessor/lambda$1$Type', 1939);
                        feb(1940, 1, {}, HYc);
                        _.Ye = function IYc(a) {
                            return AYc(RD(a, 40));
                        };
                        var r_ = sfb(LEe, 'GraphBoundsProcessor/lambda$2$Type', 1940);
                        feb(1941, 1, {}, JYc);
                        _.Ye = function KYc(a) {
                            return BYc(RD(a, 40));
                        };
                        var s_ = sfb(LEe, 'GraphBoundsProcessor/lambda$3$Type', 1941);
                        feb(262, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            262: 1,
                            196: 1
                        }, XYc);
                        _.dg = function YYc() {
                            switch(this.g){
                                case 0:
                                    return new DZc;
                                case 1:
                                    return new vYc;
                                case 2:
                                    return new nZc;
                                case 3:
                                    return new tZc;
                                case 4:
                                    return new gZc;
                                case 8:
                                    return new cZc;
                                case 5:
                                    return new rYc;
                                case 6:
                                    return new AZc;
                                case 7:
                                    return new qXc;
                                case 9:
                                    return new zYc;
                                case 10:
                                    return new GZc;
                                default:
                                    throw Adb(new agb(lBe + (this.f != null ? this.f : '' + this.g)));
                            }
                        };
                        var LYc, MYc, NYc, OYc, PYc, QYc, RYc, SYc, TYc, UYc, VYc;
                        var u_ = tfb(LEe, mBe, 262, WI, $Yc, ZYc);
                        var _Yc;
                        feb(1920, 1, QAe, cZc);
                        _.Kf = function dZc(a, b) {
                            bZc(RD(a, 121), b);
                        };
                        var v_ = sfb(LEe, 'LevelCoordinatesProcessor', 1920);
                        feb(1918, 1, QAe, gZc);
                        _.Kf = function hZc(a, b) {
                            eZc(this, RD(a, 121), b);
                        };
                        _.a = 0;
                        var x_ = sfb(LEe, 'LevelHeightProcessor', 1918);
                        feb(1919, 1, Vve, iZc);
                        _.Jc = function jZc(a) {
                            xgb(this, a);
                        };
                        _.Kc = function kZc() {
                            return yob(), Qob(), Pob;
                        };
                        var w_ = sfb(LEe, 'LevelHeightProcessor/1', 1919);
                        feb(1914, 1, QAe, nZc);
                        _.Kf = function oZc(a, b) {
                            lZc(this, RD(a, 121), b);
                        };
                        var z_ = sfb(LEe, 'LevelProcessor', 1914);
                        feb(1915, 1, nwe, pZc);
                        _.Mb = function qZc(a) {
                            return Heb(TD(mQb(RD(a, 40), (q$c(), n$c))));
                        };
                        var y_ = sfb(LEe, 'LevelProcessor/lambda$0$Type', 1915);
                        feb(1916, 1, QAe, tZc);
                        _.Kf = function uZc(a, b) {
                            rZc(this, RD(a, 121), b);
                        };
                        _.a = 0;
                        var B_ = sfb(LEe, 'NeighborsProcessor', 1916);
                        feb(1917, 1, Vve, vZc);
                        _.Jc = function wZc(a) {
                            xgb(this, a);
                        };
                        _.Kc = function xZc() {
                            return yob(), Qob(), Pob;
                        };
                        var A_ = sfb(LEe, 'NeighborsProcessor/1', 1917);
                        feb(1922, 1, QAe, AZc);
                        _.Kf = function BZc(a, b) {
                            yZc(this, RD(a, 121), b);
                        };
                        _.a = 0;
                        var C_ = sfb(LEe, 'NodePositionProcessor', 1922);
                        feb(1912, 1, QAe, DZc);
                        _.Kf = function EZc(a, b) {
                            CZc(this, RD(a, 121), b);
                        };
                        var D_ = sfb(LEe, 'RootProcessor', 1912);
                        feb(1942, 1, QAe, GZc);
                        _.Kf = function HZc(a, b) {
                            FZc(RD(a, 121), b);
                        };
                        var E_ = sfb(LEe, 'Untreeifyer', 1942);
                        feb(392, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            392: 1
                        }, MZc);
                        var IZc, JZc, KZc;
                        var F_ = tfb(PEe, 'EdgeRoutingMode', 392, WI, OZc, NZc);
                        var PZc;
                        var RZc, SZc, TZc, UZc, VZc, WZc, XZc, YZc, ZZc, $Zc, _Zc, a$c, b$c, c$c, d$c, e$c, f$c, g$c, h$c, i$c, j$c, k$c, l$c, m$c, n$c, o$c, p$c;
                        feb(862, 1, Eye, C$c);
                        _.hf = function D$c(a) {
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, REe), ''), YEe), 'Turns on Tree compaction which decreases the size of the whole tree by placing nodes of multiple levels in one large level'), (Geb(), false)), (kid(), cid)), QI), xsb((Yhd(), Whd)))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, SEe), ''), 'Edge End Texture Length'), 'Should be set to the length of the texture at the end of an edge. This value can be used to improve the Edge Routing.'), 7), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, TEe), ''), 'Tree Level'), 'The index for the tree level the node is in'), sgb(0)), gid), bJ), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, UEe), ''), YEe), 'When set to a positive number this option will force the algorithm to place the node to the specified position within the trees layer if weighting is set to constraint'), sgb(-1)), gid), bJ), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, VEe), ''), 'Weighting of Nodes'), 'Which weighting to use when computing a node order.'), A$c), eid), J_), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, WEe), ''), 'Edge Routing Mode'), 'Chooses an Edge Routing algorithm.'), u$c), eid), F_), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, XEe), ''), 'Search Order'), 'Which search order to use when computing a spanning tree.'), x$c), eid), K_), xsb(Whd))));
                            i_c((new j_c, a));
                        };
                        var r$c, s$c, t$c, u$c, v$c, w$c, x$c, y$c, z$c, A$c;
                        var G_ = sfb(PEe, 'MrTreeMetaDataProvider', 862);
                        feb(1006, 1, Eye, j_c);
                        _.hf = function k_c(a) {
                            i_c(a);
                        };
                        var E$c, F$c, G$c, H$c, I$c, J$c, K$c, L$c, M$c, N$c, O$c, P$c, Q$c, R$c, S$c, T$c, U$c, V$c, W$c, X$c, Y$c, Z$c, $$c, _$c, a_c, b_c, c_c, d_c, e_c, f_c, g_c;
                        var I_ = sfb(PEe, 'MrTreeOptions', 1006);
                        feb(1007, 1, {}, l_c);
                        _.sf = function m_c() {
                            var a;
                            return a = new fWc, a;
                        };
                        _.tf = function n_c(a) {};
                        var H_ = sfb(PEe, 'MrTreeOptions/MrtreeFactory', 1007);
                        feb(353, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            353: 1
                        }, t_c);
                        var o_c, p_c, q_c, r_c;
                        var J_ = tfb(PEe, 'OrderWeighting', 353, WI, v_c, u_c);
                        var w_c;
                        feb(433, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            433: 1
                        }, B_c);
                        var y_c, z_c;
                        var K_ = tfb(PEe, 'TreeifyingOrder', 433, WI, D_c, C_c);
                        var E_c;
                        feb(1486, 1, nEe, N_c);
                        _.rg = function O_c(a) {
                            return RD(a, 121), G_c;
                        };
                        _.Kf = function P_c(a, b) {
                            M_c(this, RD(a, 121), b);
                        };
                        var G_c;
                        var L_ = sfb('org.eclipse.elk.alg.mrtree.p1treeify', 'DFSTreeifyer', 1486);
                        feb(1487, 1, nEe, V_c);
                        _.rg = function W_c(a) {
                            return RD(a, 121), Q_c;
                        };
                        _.Kf = function $_c(a, b) {
                            U_c(this, RD(a, 121), b);
                        };
                        var Q_c;
                        var T_ = sfb(aFe, 'NodeOrderer', 1487);
                        feb(1494, 1, {}, a0c);
                        _.td = function b0c(a) {
                            return __c(a);
                        };
                        var M_ = sfb(aFe, 'NodeOrderer/0methodref$lambda$6$Type', 1494);
                        feb(1488, 1, nwe, c0c);
                        _.Mb = function d0c(a) {
                            return R_c(), Heb(TD(mQb(RD(a, 40), (q$c(), n$c))));
                        };
                        var N_ = sfb(aFe, 'NodeOrderer/lambda$0$Type', 1488);
                        feb(1489, 1, nwe, e0c);
                        _.Mb = function f0c(a) {
                            return R_c(), RD(mQb(RD(a, 40), (h_c(), W$c)), 17).a < 0;
                        };
                        var O_ = sfb(aFe, 'NodeOrderer/lambda$1$Type', 1489);
                        feb(1490, 1, nwe, g0c);
                        _.Mb = function h0c(a) {
                            return X_c(this.a, RD(a, 40));
                        };
                        var P_ = sfb(aFe, 'NodeOrderer/lambda$2$Type', 1490);
                        feb(1491, 1, nwe, i0c);
                        _.Mb = function j0c(a) {
                            return Y_c(this.a, RD(a, 40));
                        };
                        var Q_ = sfb(aFe, 'NodeOrderer/lambda$3$Type', 1491);
                        feb(1492, 1, fye, k0c);
                        _.Ne = function l0c(a, b) {
                            return Z_c(RD(a, 40), RD(b, 40));
                        };
                        _.Fb = function m0c(a) {
                            return this === a;
                        };
                        _.Oe = function n0c() {
                            return new Frb(this);
                        };
                        var R_ = sfb(aFe, 'NodeOrderer/lambda$4$Type', 1492);
                        feb(1493, 1, nwe, o0c);
                        _.Mb = function p0c(a) {
                            return R_c(), RD(mQb(RD(a, 40), (q$c(), XZc)), 17).a != 0;
                        };
                        var S_ = sfb(aFe, 'NodeOrderer/lambda$5$Type', 1493);
                        feb(1495, 1, nEe, x0c);
                        _.rg = function y0c(a) {
                            return RD(a, 121), q0c;
                        };
                        _.Kf = function z0c(a, b) {
                            v0c(this, RD(a, 121), b);
                        };
                        _.b = 0;
                        var q0c;
                        var U_ = sfb('org.eclipse.elk.alg.mrtree.p3place', 'NodePlacer', 1495);
                        feb(1496, 1, nEe, J0c);
                        _.rg = function K0c(a) {
                            return RD(a, 121), A0c;
                        };
                        _.Kf = function Y0c(a, b) {
                            I0c(RD(a, 121), b);
                        };
                        var A0c;
                        var o0 = sfb(bFe, 'EdgeRouter', 1496);
                        feb(1498, 1, fye, Z0c);
                        _.Ne = function $0c(a, b) {
                            return hgb(RD(a, 17).a, RD(b, 17).a);
                        };
                        _.Fb = function _0c(a) {
                            return this === a;
                        };
                        _.Oe = function a1c() {
                            return new Frb(this);
                        };
                        var V_ = sfb(bFe, 'EdgeRouter/0methodref$compare$Type', 1498);
                        feb(1503, 1, {}, b1c);
                        _.Ye = function c1c(a) {
                            return Kfb(UD(a));
                        };
                        var W_ = sfb(bFe, 'EdgeRouter/1methodref$doubleValue$Type', 1503);
                        feb(1505, 1, fye, d1c);
                        _.Ne = function e1c(a, b) {
                            return Qfb(Kfb(UD(a)), Kfb(UD(b)));
                        };
                        _.Fb = function f1c(a) {
                            return this === a;
                        };
                        _.Oe = function g1c() {
                            return new Frb(this);
                        };
                        var X_ = sfb(bFe, 'EdgeRouter/2methodref$compare$Type', 1505);
                        feb(1507, 1, fye, h1c);
                        _.Ne = function i1c(a, b) {
                            return Qfb(Kfb(UD(a)), Kfb(UD(b)));
                        };
                        _.Fb = function j1c(a) {
                            return this === a;
                        };
                        _.Oe = function k1c() {
                            return new Frb(this);
                        };
                        var Y_ = sfb(bFe, 'EdgeRouter/3methodref$compare$Type', 1507);
                        feb(1509, 1, {}, l1c);
                        _.Ye = function m1c(a) {
                            return Kfb(UD(a));
                        };
                        var Z_ = sfb(bFe, 'EdgeRouter/4methodref$doubleValue$Type', 1509);
                        feb(1511, 1, fye, n1c);
                        _.Ne = function o1c(a, b) {
                            return Qfb(Kfb(UD(a)), Kfb(UD(b)));
                        };
                        _.Fb = function p1c(a) {
                            return this === a;
                        };
                        _.Oe = function q1c() {
                            return new Frb(this);
                        };
                        var $_ = sfb(bFe, 'EdgeRouter/5methodref$compare$Type', 1511);
                        feb(1513, 1, fye, r1c);
                        _.Ne = function s1c(a, b) {
                            return Qfb(Kfb(UD(a)), Kfb(UD(b)));
                        };
                        _.Fb = function t1c(a) {
                            return this === a;
                        };
                        _.Oe = function u1c() {
                            return new Frb(this);
                        };
                        var __ = sfb(bFe, 'EdgeRouter/6methodref$compare$Type', 1513);
                        feb(1497, 1, {}, v1c);
                        _.Kb = function w1c(a) {
                            return B0c(), RD(mQb(RD(a, 40), (h_c(), f_c)), 17);
                        };
                        var a0 = sfb(bFe, 'EdgeRouter/lambda$0$Type', 1497);
                        feb(1508, 1, {}, x1c);
                        _.Kb = function y1c(a) {
                            return L0c(RD(a, 40));
                        };
                        var b0 = sfb(bFe, 'EdgeRouter/lambda$11$Type', 1508);
                        feb(1510, 1, {}, z1c);
                        _.Kb = function A1c(a) {
                            return M0c(this.b, this.a, RD(a, 40));
                        };
                        _.a = 0;
                        _.b = 0;
                        var c0 = sfb(bFe, 'EdgeRouter/lambda$13$Type', 1510);
                        feb(1512, 1, {}, B1c);
                        _.Kb = function C1c(a) {
                            return N0c(this.b, this.a, RD(a, 40));
                        };
                        _.a = 0;
                        _.b = 0;
                        var d0 = sfb(bFe, 'EdgeRouter/lambda$15$Type', 1512);
                        feb(1514, 1, fye, D1c);
                        _.Ne = function E1c(a, b) {
                            return O0c(RD(a, 65), RD(b, 65));
                        };
                        _.Fb = function F1c(a) {
                            return this === a;
                        };
                        _.Oe = function G1c() {
                            return new Frb(this);
                        };
                        var e0 = sfb(bFe, 'EdgeRouter/lambda$17$Type', 1514);
                        feb(1515, 1, fye, H1c);
                        _.Ne = function I1c(a, b) {
                            return P0c(RD(a, 65), RD(b, 65));
                        };
                        _.Fb = function J1c(a) {
                            return this === a;
                        };
                        _.Oe = function K1c() {
                            return new Frb(this);
                        };
                        var f0 = sfb(bFe, 'EdgeRouter/lambda$18$Type', 1515);
                        feb(1516, 1, fye, L1c);
                        _.Ne = function M1c(a, b) {
                            return Q0c(RD(a, 65), RD(b, 65));
                        };
                        _.Fb = function N1c(a) {
                            return this === a;
                        };
                        _.Oe = function O1c() {
                            return new Frb(this);
                        };
                        var g0 = sfb(bFe, 'EdgeRouter/lambda$19$Type', 1516);
                        feb(1499, 1, nwe, P1c);
                        _.Mb = function Q1c(a) {
                            return R0c(this.a, RD(a, 40));
                        };
                        _.a = 0;
                        var h0 = sfb(bFe, 'EdgeRouter/lambda$2$Type', 1499);
                        feb(1517, 1, fye, R1c);
                        _.Ne = function S1c(a, b) {
                            return S0c(RD(a, 65), RD(b, 65));
                        };
                        _.Fb = function T1c(a) {
                            return this === a;
                        };
                        _.Oe = function U1c() {
                            return new Frb(this);
                        };
                        var i0 = sfb(bFe, 'EdgeRouter/lambda$20$Type', 1517);
                        feb(1500, 1, fye, V1c);
                        _.Ne = function W1c(a, b) {
                            return T0c(RD(a, 40), RD(b, 40));
                        };
                        _.Fb = function X1c(a) {
                            return this === a;
                        };
                        _.Oe = function Y1c() {
                            return new Frb(this);
                        };
                        var j0 = sfb(bFe, 'EdgeRouter/lambda$3$Type', 1500);
                        feb(1501, 1, fye, Z1c);
                        _.Ne = function $1c(a, b) {
                            return U0c(RD(a, 40), RD(b, 40));
                        };
                        _.Fb = function _1c(a) {
                            return this === a;
                        };
                        _.Oe = function a2c() {
                            return new Frb(this);
                        };
                        var k0 = sfb(bFe, 'EdgeRouter/lambda$4$Type', 1501);
                        feb(1502, 1, {}, b2c);
                        _.Kb = function c2c(a) {
                            return V0c(RD(a, 40));
                        };
                        var l0 = sfb(bFe, 'EdgeRouter/lambda$5$Type', 1502);
                        feb(1504, 1, {}, d2c);
                        _.Kb = function e2c(a) {
                            return W0c(this.b, this.a, RD(a, 40));
                        };
                        _.a = 0;
                        _.b = 0;
                        var m0 = sfb(bFe, 'EdgeRouter/lambda$7$Type', 1504);
                        feb(1506, 1, {}, f2c);
                        _.Kb = function g2c(a) {
                            return X0c(this.b, this.a, RD(a, 40));
                        };
                        _.a = 0;
                        _.b = 0;
                        var n0 = sfb(bFe, 'EdgeRouter/lambda$9$Type', 1506);
                        feb(675, 1, {
                            675: 1
                        }, i2c);
                        _.e = 0;
                        _.f = false;
                        _.g = false;
                        var r0 = sfb(bFe, 'MultiLevelEdgeNodeNodeGap', 675);
                        feb(1943, 1, fye, l2c);
                        _.Ne = function m2c(a, b) {
                            return j2c(RD(a, 240), RD(b, 240));
                        };
                        _.Fb = function n2c(a) {
                            return this === a;
                        };
                        _.Oe = function o2c() {
                            return new Frb(this);
                        };
                        var p0 = sfb(bFe, 'MultiLevelEdgeNodeNodeGap/lambda$0$Type', 1943);
                        feb(1944, 1, fye, p2c);
                        _.Ne = function q2c(a, b) {
                            return k2c(RD(a, 240), RD(b, 240));
                        };
                        _.Fb = function r2c(a) {
                            return this === a;
                        };
                        _.Oe = function s2c() {
                            return new Frb(this);
                        };
                        var q0 = sfb(bFe, 'MultiLevelEdgeNodeNodeGap/lambda$1$Type', 1944);
                        var t2c;
                        feb(501, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            501: 1,
                            188: 1,
                            196: 1
                        }, z2c);
                        _.dg = function B2c() {
                            return y2c(this);
                        };
                        _.qg = function A2c() {
                            return y2c(this);
                        };
                        var v2c, w2c;
                        var s0 = tfb(cFe, 'RadialLayoutPhases', 501, WI, D2c, C2c);
                        var E2c;
                        feb(1113, 205, oze, H2c);
                        _.rf = function I2c(a, b) {
                            var c, d, e, f, g, h;
                            c = G2c(this, a);
                            b.Ug('Radial layout', c.c.length);
                            Heb(TD(Gxd(a, ($4c(), N4c)))) || RFb((d = new SFb((lud(), new zud(a))), d));
                            h = K2c(a);
                            Ixd(a, (u2c(), t2c), h);
                            if (!h) throw Adb(new agb('The given graph is not a tree!'));
                            e = Kfb(UD(Gxd(a, S4c)));
                            e == 0 && (e = J2c(a));
                            Ixd(a, S4c, e);
                            for(g = new Anb(G2c(this, a)); g.a < g.c.c.length;){
                                f = RD(ynb(g), 47);
                                f.Kf(a, b.eh(1));
                            }
                            b.Vg();
                        };
                        var t0 = sfb(cFe, 'RadialLayoutProvider', 1113);
                        feb(556, 1, fye, T2c);
                        _.Ne = function U2c(a, b) {
                            return S2c(this.a, this.b, RD(a, 27), RD(b, 27));
                        };
                        _.Fb = function V2c(a) {
                            return this === a;
                        };
                        _.Oe = function W2c() {
                            return new Frb(this);
                        };
                        _.a = 0;
                        _.b = 0;
                        var u0 = sfb(cFe, 'RadialUtil/lambda$0$Type', 556);
                        feb(1395, 1, QAe, Y2c);
                        _.Kf = function Z2c(a, b) {
                            X2c(RD(a, 27), b);
                        };
                        var v0 = sfb(hFe, 'CalculateGraphSize', 1395);
                        feb(1396, 1, QAe, _2c);
                        _.Kf = function a3c(a, b) {
                            $2c(RD(a, 27));
                        };
                        var w0 = sfb(hFe, 'EdgeAngleCalculator', 1396);
                        feb(368, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            368: 1,
                            196: 1
                        }, h3c);
                        _.dg = function i3c() {
                            switch(this.g){
                                case 0:
                                    return new Q3c;
                                case 1:
                                    return new A3c;
                                case 2:
                                    return new U3c;
                                case 3:
                                    return new Y2c;
                                case 4:
                                    return new _2c;
                                default:
                                    throw Adb(new agb(lBe + (this.f != null ? this.f : '' + this.g)));
                            }
                        };
                        var b3c, c3c, d3c, e3c, f3c;
                        var x0 = tfb(hFe, mBe, 368, WI, k3c, j3c);
                        var l3c;
                        feb(653, 1, {});
                        _.e = 1;
                        _.g = 0;
                        var y0 = sfb(jFe, 'AbstractRadiusExtensionCompaction', 653);
                        feb(1834, 653, {}, x3c);
                        _.Cg = function y3c(a) {
                            var b, c, d, e, f, g, h, i, j;
                            this.c = RD(Gxd(a, (u2c(), t2c)), 27);
                            r3c(this, this.c);
                            this.d = u5c(RD(Gxd(a, ($4c(), X4c)), 300));
                            i = RD(Gxd(a, H4c), 17);
                            !!i && q3c(this, i.a);
                            h = UD(Gxd(a, (umd(), fmd)));
                            s3c(this, (uFb(h), h));
                            j = Q2c(this.c);
                            !!this.d && this.d.Gg(j);
                            t3c(this, j);
                            g = new mob(cD(WC(J4, 1), kFe, 27, 0, [
                                this.c
                            ]));
                            for(c = 0; c < 2; c++)for(b = 0; b < j.c.length; b++){
                                e = new mob(cD(WC(J4, 1), kFe, 27, 0, [
                                    (tFb(b, j.c.length), RD(j.c[b], 27))
                                ]));
                                f = b < j.c.length - 1 ? (tFb(b + 1, j.c.length), RD(j.c[b + 1], 27)) : (tFb(0, j.c.length), RD(j.c[0], 27));
                                d = b == 0 ? RD(Vmb(j, j.c.length - 1), 27) : (tFb(b - 1, j.c.length), RD(j.c[b - 1], 27));
                                v3c(this, (tFb(b, j.c.length), RD(j.c[b], 27), g), d, f, e);
                            }
                        };
                        var z0 = sfb(jFe, 'AnnulusWedgeCompaction', 1834);
                        feb(1393, 1, QAe, A3c);
                        _.Kf = function B3c(a, b) {
                            z3c(RD(a, 27), b);
                        };
                        var A0 = sfb(jFe, 'GeneralCompactor', 1393);
                        feb(1833, 653, {}, F3c);
                        _.Cg = function G3c(a) {
                            var b, c, d, e;
                            c = RD(Gxd(a, (u2c(), t2c)), 27);
                            this.f = c;
                            this.b = u5c(RD(Gxd(a, ($4c(), X4c)), 300));
                            e = RD(Gxd(a, H4c), 17);
                            !!e && q3c(this, e.a);
                            d = UD(Gxd(a, (umd(), fmd)));
                            s3c(this, (uFb(d), d));
                            b = Q2c(c);
                            !!this.b && this.b.Gg(b);
                            D3c(this, b);
                        };
                        _.a = 0;
                        var B0 = sfb(jFe, 'RadialCompaction', 1833);
                        feb(1842, 1, {}, I3c);
                        _.Dg = function J3c(a) {
                            var b, c, d, e, f, g;
                            this.a = a;
                            b = 0;
                            g = Q2c(a);
                            d = 0;
                            for(f = new Anb(g); f.a < f.c.c.length;){
                                e = RD(ynb(f), 27);
                                ++d;
                                for(c = d; c < g.c.length; c++)H3c(this, e, (tFb(c, g.c.length), RD(g.c[c], 27))) && (b += 1);
                            }
                            return b;
                        };
                        var C0 = sfb(lFe, 'CrossingMinimizationPosition', 1842);
                        feb(1840, 1, {}, K3c);
                        _.Dg = function L3c(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n;
                            d = 0;
                            for(c = new is(Mr(zGd(a).a.Kc(), new ir)); gs(c);){
                                b = RD(hs(c), 74);
                                h = AGd(RD(QHd((!b.c && (b.c = new Yie(E4, b, 5, 8)), b.c), 0), 84));
                                j = h.i + h.g / 2;
                                k = h.j + h.f / 2;
                                e = a.i + a.g / 2;
                                f = a.j + a.f / 2;
                                l = new pjd;
                                l.a = j - e;
                                l.b = k - f;
                                g = new rjd(l.a, l.b);
                                wid(g, a.g, a.f);
                                l.a -= g.a;
                                l.b -= g.b;
                                e = j - l.a;
                                f = k - l.b;
                                i = new rjd(l.a, l.b);
                                wid(i, h.g, h.f);
                                l.a -= i.a;
                                l.b -= i.b;
                                j = e + l.a;
                                k = f + l.b;
                                m = j - e;
                                n = k - f;
                                d += $wnd.Math.sqrt(m * m + n * n);
                            }
                            return d;
                        };
                        var D0 = sfb(lFe, 'EdgeLengthOptimization', 1840);
                        feb(1841, 1, {}, M3c);
                        _.Dg = function N3c(a) {
                            var b, c, d, e, f, g, h, i, j, k, l;
                            d = 0;
                            for(c = new is(Mr(zGd(a).a.Kc(), new ir)); gs(c);){
                                b = RD(hs(c), 74);
                                h = AGd(RD(QHd((!b.c && (b.c = new Yie(E4, b, 5, 8)), b.c), 0), 84));
                                i = h.i + h.g / 2;
                                j = h.j + h.f / 2;
                                e = RD(Gxd(h, (umd(), Qld)), 8);
                                f = a.i + e.a + a.g / 2;
                                g = a.j + e.b + a.f;
                                k = i - f;
                                l = j - g;
                                d += $wnd.Math.sqrt(k * k + l * l);
                            }
                            return d;
                        };
                        var E0 = sfb(lFe, 'EdgeLengthPositionOptimization', 1841);
                        feb(1392, 653, QAe, Q3c);
                        _.Kf = function R3c(a, b) {
                            P3c(this, RD(a, 27), b);
                        };
                        var F0 = sfb('org.eclipse.elk.alg.radial.intermediate.overlaps', 'RadiusExtensionOverlapRemoval', 1392);
                        feb(1394, 1, QAe, U3c);
                        _.Kf = function V3c(a, b) {
                            T3c(RD(a, 27), b);
                        };
                        var G0 = sfb('org.eclipse.elk.alg.radial.intermediate.rotation', 'GeneralRotator', 1394);
                        feb(434, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            434: 1
                        }, $3c);
                        var W3c, X3c;
                        var H0 = tfb(nFe, 'AnnulusWedgeCriteria', 434, WI, a4c, _3c);
                        var b4c;
                        feb(393, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            393: 1
                        }, i4c);
                        var d4c, e4c, f4c;
                        var I0 = tfb(nFe, uze, 393, WI, k4c, j4c);
                        var l4c;
                        feb(863, 1, Eye, E4c);
                        _.hf = function F4c(a) {
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, oFe), ''), 'Center On Root'), 'Centers the layout on the root of the tree i.e. so that the central node is also the center node of the final layout. This introduces additional whitespace.'), (Geb(), false)), (kid(), cid)), QI), xsb((Yhd(), Whd)))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, pFe), ''), 'Order ID'), 'The id can be used to define an order for nodes of one radius. This can be used to sort them in the layer accordingly.'), sgb(0)), gid), bJ), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, qFe), ''), 'Radius'), 'The radius option can be used to set the initial radius for the radial layouter.'), 0), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, rFe), ''), 'Rotate'), 'The rotate option determines whether a rotation of the layout should be performed.'), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, sFe), ''), AFe), 'With the compacter option it can be determined how compaction on the graph is done. It can be chosen between none, the radial compaction or the compaction of wedges separately.'), q4c), eid), I0), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, tFe), ''), 'Compaction Step Size'), 'Determine the size of steps with which the compaction is done. Step size 1 correlates to a compaction of 1 pixel per Iteration.'), sgb(1)), gid), bJ), xsb(Whd))));
                            zgd(a, tFe, sFe, null);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, uFe), ''), 'Sorter'), 'Sort the nodes per radius according to the sorting algorithm. The strategies are none, by the given order id, or sorting them by polar coordinates.'), A4c), eid), N0), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, vFe), ''), 'Annulus Wedge Criteria'), 'Determine how the wedge for the node placement is calculated. It can be chosen between wedge determination by the number of leaves or by the maximum sum of diagonals.'), C4c), eid), H0), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, wFe), ''), 'Translation Optimization'), 'Find the optimal translation of the nodes of the first radii according to this criteria. For example edge crossings can be minimized.'), s4c), eid), M0), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, xFe), BFe), 'Target Angle'), 'The angle in radians that the layout should be rotated to after layout.'), 0), did), VI), xsb(Whd))));
                            zgd(a, xFe, rFe, null);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, yFe), BFe), 'Additional Wedge Space'), 'If set to true, modifies the target angle by rotating further such that space is left for an edge to pass in between the nodes. This option should only be used in conjunction with top-down layout.'), false), cid), QI), xsb(Whd))));
                            zgd(a, yFe, rFe, null);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, zFe), BFe), 'Outgoing Edge Angles'), 'Calculate the required angle of connected nodes to leave space for an incoming edge. This option should only be used in conjunction with top-down layout.'), false), cid), QI), xsb(Whd))));
                            _4c((new a5c, a));
                        };
                        var n4c, o4c, p4c, q4c, r4c, s4c, t4c, u4c, v4c, w4c, x4c, y4c, z4c, A4c, B4c, C4c;
                        var J0 = sfb(nFe, 'RadialMetaDataProvider', 863);
                        feb(1008, 1, Eye, a5c);
                        _.hf = function b5c(a) {
                            _4c(a);
                        };
                        var G4c, H4c, I4c, J4c, K4c, L4c, M4c, N4c, O4c, P4c, Q4c, R4c, S4c, T4c, U4c, V4c, W4c, X4c, Y4c, Z4c;
                        var L0 = sfb(nFe, 'RadialOptions', 1008);
                        feb(1009, 1, {}, c5c);
                        _.sf = function d5c() {
                            var a;
                            return a = new H2c, a;
                        };
                        _.tf = function e5c(a) {};
                        var K0 = sfb(nFe, 'RadialOptions/RadialFactory', 1009);
                        feb(354, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            354: 1
                        }, l5c);
                        var f5c, g5c, h5c, i5c;
                        var M0 = tfb(nFe, 'RadialTranslationStrategy', 354, WI, n5c, m5c);
                        var o5c;
                        feb(300, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            300: 1
                        }, v5c);
                        var q5c, r5c, s5c;
                        var N0 = tfb(nFe, 'SortingStrategy', 300, WI, x5c, w5c);
                        var y5c;
                        feb(1476, 1, nEe, D5c);
                        _.rg = function E5c(a) {
                            return RD(a, 27), null;
                        };
                        _.Kf = function F5c(a, b) {
                            B5c(this, RD(a, 27), b);
                        };
                        _.c = 0;
                        var O0 = sfb('org.eclipse.elk.alg.radial.p1position', 'EadesRadial', 1476);
                        feb(1838, 1, {}, G5c);
                        _.Eg = function H5c(a) {
                            return O2c(a);
                        };
                        var P0 = sfb(DFe, 'AnnulusWedgeByLeafs', 1838);
                        feb(1839, 1, {}, J5c);
                        _.Eg = function K5c(a) {
                            return I5c(this, a);
                        };
                        var Q0 = sfb(DFe, 'AnnulusWedgeByNodeSpace', 1839);
                        feb(1477, 1, nEe, N5c);
                        _.rg = function O5c(a) {
                            return RD(a, 27), null;
                        };
                        _.Kf = function P5c(a, b) {
                            L5c(this, RD(a, 27), b);
                        };
                        var R0 = sfb('org.eclipse.elk.alg.radial.p2routing', 'StraightLineEdgeRouter', 1477);
                        feb(826, 1, {}, R5c);
                        _.Fg = function S5c(a) {};
                        _.Gg = function U5c(a) {
                            Q5c(this, a);
                        };
                        var T0 = sfb(EFe, 'IDSorter', 826);
                        feb(1837, 1, fye, V5c);
                        _.Ne = function W5c(a, b) {
                            return T5c(RD(a, 27), RD(b, 27));
                        };
                        _.Fb = function X5c(a) {
                            return this === a;
                        };
                        _.Oe = function Y5c() {
                            return new Frb(this);
                        };
                        var S0 = sfb(EFe, 'IDSorter/lambda$0$Type', 1837);
                        feb(1836, 1, {}, _5c);
                        _.Fg = function a6c(a) {
                            Z5c(this, a);
                        };
                        _.Gg = function b6c(a) {
                            var b;
                            if (!a.dc()) {
                                if (!this.e) {
                                    b = L2c(RD(a.Xb(0), 27));
                                    Z5c(this, b);
                                }
                                Q5c(this.e, a);
                            }
                        };
                        var U0 = sfb(EFe, 'PolarCoordinateSorter', 1836);
                        feb(445, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            445: 1
                        }, g6c);
                        var c6c, d6c, e6c;
                        var V0 = tfb(IFe, 'RectPackingLayoutPhases', 445, WI, i6c, h6c);
                        var j6c;
                        feb(1118, 205, oze, l6c);
                        _.rf = function n6c(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
                            b.Ug('Rectangle Packing', 1);
                            l = RD(Gxd(a, (X7c(), N7c)), 107);
                            i = Heb(TD(Gxd(a, G7c)));
                            k = Kfb(UD(Gxd(a, Q7c)));
                            C = Heb(TD(Gxd(a, R7c)));
                            t = (!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a);
                            Heb(TD(Gxd(a, J7c))) || RFb((e = new SFb((lud(), new zud(a))), e));
                            B = false;
                            if (C && t.i >= 3) {
                                v = RD(QHd(t, 0), 27);
                                w = RD(QHd(t, 1), 27);
                                f = 0;
                                while(f + 2 < t.i){
                                    u = v;
                                    v = w;
                                    w = RD(QHd(t, f + 2), 27);
                                    if (u.f >= v.f + w.f + k || w.f >= u.f + v.f + k) {
                                        B = true;
                                        break;
                                    } else ++f;
                                }
                            } else B = true;
                            if (!B) {
                                m = t.i;
                                for(h = new dMd(t); h.e != h.i.gc();){
                                    g = RD(bMd(h), 27);
                                    Ixd(g, (umd(), Rld), sgb(m));
                                    --m;
                                }
                                crd(a, new Oqd);
                                b.Vg();
                                return;
                            }
                            c = (Sed(this.a), Ved(this.a, (f6c(), c6c), RD(Gxd(a, V7c), 188)), Ved(this.a, d6c, RD(Gxd(a, M7c), 188)), Ved(this.a, e6c, RD(Gxd(a, S7c), 188)), Ped(this.a, (D = new ufd, pfd(D, c6c, (z6c(), y6c)), pfd(D, d6c, x6c), Heb(TD(Gxd(a, B7c))) && pfd(D, c6c, w6c), D)), Qed(this.a, a));
                            j = 1 / c.c.length;
                            A = 0;
                            for(o = new Anb(c); o.a < o.c.c.length;){
                                n = RD(ynb(o), 47);
                                if (b.$g()) return;
                                n.Kf(a, b.eh(j));
                                ++A;
                            }
                            q = 0;
                            p = 0;
                            for(s = new dMd(t); s.e != s.i.gc();){
                                r = RD(bMd(s), 27);
                                q = $wnd.Math.max(q, r.i + r.g);
                                p = $wnd.Math.max(p, r.j + r.f);
                            }
                            Jsd(a, new rjd(Kfb(UD(Gxd(a, (X6c(), O6c)))), Kfb(UD(Gxd(a, N6c)))), new rjd(q, p));
                            m6c(t, l);
                            i || Esd(a, Kfb(UD(Gxd(a, O6c))) + (l.b + l.c), Kfb(UD(Gxd(a, N6c))) + (l.d + l.a), false, true);
                            Heb(TD(Gxd(a, J7c))) || RFb((d = new SFb((lud(), new zud(a))), d));
                            b.Vg();
                        };
                        var W0 = sfb(IFe, 'RectPackingLayoutProvider', 1118);
                        feb(1518, 1, QAe, p6c);
                        _.Kf = function r6c(a, b) {
                            o6c(RD(a, 27), b);
                        };
                        var Y0 = sfb(JFe, 'InteractiveNodeReorderer', 1518);
                        feb(1519, 1, fye, s6c);
                        _.Ne = function t6c(a, b) {
                            return q6c(RD(a, 27), RD(b, 27));
                        };
                        _.Fb = function u6c(a) {
                            return this === a;
                        };
                        _.Oe = function v6c() {
                            return new Frb(this);
                        };
                        var X0 = sfb(JFe, 'InteractiveNodeReorderer/lambda$0$Type', 1519);
                        feb(456, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            456: 1,
                            196: 1
                        }, A6c);
                        _.dg = function B6c() {
                            switch(this.g){
                                case 0:
                                    return new p6c;
                                case 1:
                                    return new K6c;
                                case 2:
                                    return new H6c;
                            }
                            return null;
                        };
                        var w6c, x6c, y6c;
                        var Z0 = tfb(JFe, mBe, 456, WI, D6c, C6c);
                        var E6c;
                        feb(1521, 1, QAe, H6c);
                        _.Kf = function I6c(a, b) {
                            G6c(RD(a, 27), b);
                        };
                        var $0 = sfb(JFe, 'MinSizePostProcessor', 1521);
                        feb(1520, 1, QAe, K6c);
                        _.Kf = function L6c(a, b) {
                            J6c(RD(a, 27), b);
                        };
                        var _0 = sfb(JFe, 'MinSizePreProcessor', 1520);
                        var M6c, N6c, O6c, P6c, Q6c, R6c, S6c, T6c, U6c, V6c, W6c;
                        feb(394, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            394: 1
                        }, a7c);
                        var Y6c, Z6c, $6c;
                        var a1 = tfb(KFe, 'OptimizationGoal', 394, WI, c7c, b7c);
                        var d7c;
                        feb(867, 1, Eye, v7c);
                        _.hf = function w7c(a) {
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, LFe), ''), 'Try box layout first'), 'Whether one should check whether the regions are stackable to see whether box layout would do the job. For example, nodes with the same height are not stackable inside a row. Therefore, box layout will perform better and faster.'), (Geb(), false)), (kid(), cid)), QI), xsb((Yhd(), Whd)))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, MFe), ''), 'Current position of a node in the order of nodes'), 'The rectangles are ordered. Normally according to their definition the the model. This option specifies the current position of a node.'), sgb(-1)), gid), bJ), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, NFe), ''), 'Desired index of node'), 'The rectangles are ordered. Normally according to their definition the the model. This option allows to specify a desired position that has preference over the original position.'), sgb(-1)), gid), bJ), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, OFe), ''), 'In new Row'), 'If set to true this node begins in a new row. Consequently this node cannot be moved in a previous layer during compaction. Width approximation does does not take this into account.'), false), cid), QI), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, PFe), XFe), 'Width Approximation Strategy'), 'Strategy for finding an initial width of the drawing.'), s7c), eid), l1), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, QFe), XFe), 'Target Width'), 'Option to place the rectangles in the given target width instead of approximating the width using the desired aspect ratio. The padding is not included in this. Meaning a drawing will have width of targetwidth + horizontal padding.'), -1), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, RFe), XFe), 'Optimization Goal'), 'Optimization goal for approximation of the bounding box given by the first iteration. Determines whether layout is sorted by the maximum scaling, aspect ratio, or area. Depending on the strategy the aspect ratio might be nearly ignored.'), q7c), eid), a1), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, SFe), XFe), 'Shift Last Placed.'), 'When placing a rectangle behind or below the last placed rectangle in the first iteration, it is sometimes possible to shift the rectangle further to the left or right, resulting in less whitespace. True (default) enables the shift and false disables it. Disabling the shift produces a greater approximated area by the first iteration and a layout, when using ONLY the first iteration (default not the case), where it is sometimes impossible to implement a size transformation of rectangles that will fill the bounding box and eliminate empty spaces.'), true), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, TFe), 'packing'), YFe), 'Strategy for finding an initial placement on nodes.'), l7c), eid), o1), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, UFe), ZFe), 'Row Height Reevaluation'), 'During the compaction step the height of a row is normally not changed. If this options is set, the blocks of other rows might be added if they exceed the row height. If this is the case the whole row has to be packed again to be optimal regarding the new row height. This option should, therefore, be used with care since it might be computation heavy.'), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, VFe), ZFe), 'Compaction iterations'), 'Defines the number of compaction iterations. E.g. if set to 2 the width is initially approximated, then the drawing is compacted and based on the resulting drawing the target width is decreased or increased and a second compaction step is executed and the result compared to the first one. The best run is used based on the scale measure.'), sgb(1)), gid), bJ), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, WFe), 'whiteSpaceElimination'), 'White Space Approximation Strategy'), 'Strategy for expanding nodes such that whitespace in the parent is eliminated.'), eid), t1), xsb(Whd))));
                            Y7c((new Z7c, a));
                        };
                        var f7c, g7c, h7c, i7c, j7c, k7c, l7c, m7c, n7c, o7c, p7c, q7c, r7c, s7c, t7c;
                        var b1 = sfb(KFe, 'RectPackingMetaDataProvider', 867);
                        feb(1016, 1, Eye, Z7c);
                        _.hf = function $7c(a) {
                            Y7c(a);
                        };
                        var x7c, y7c, z7c, A7c, B7c, C7c, D7c, E7c, F7c, G7c, H7c, I7c, J7c, K7c, L7c, M7c, N7c, O7c, P7c, Q7c, R7c, S7c, T7c, U7c, V7c, W7c;
                        var d1 = sfb(KFe, 'RectPackingOptions', 1016);
                        feb(1017, 1, {}, _7c);
                        _.sf = function a8c() {
                            var a;
                            return a = new l6c, a;
                        };
                        _.tf = function b8c(a) {};
                        var c1 = sfb(KFe, 'RectPackingOptions/RectpackingFactory', 1017);
                        feb(1705, 1, {}, g8c);
                        _.a = 0;
                        _.c = false;
                        var e1 = sfb(_Fe, 'AreaApproximation', 1705);
                        var h1 = ufb(_Fe, 'BestCandidateFilter');
                        feb(673, 1, {
                            535: 1
                        }, h8c);
                        _.Hg = function i8c(a, b, c) {
                            var d, e, f, g, h, i;
                            i = new bnb;
                            f = oxe;
                            for(h = new Anb(a); h.a < h.c.c.length;){
                                g = RD(ynb(h), 238);
                                f = $wnd.Math.min(f, (g.c + (c.b + c.c)) * (g.b + (c.d + c.a)));
                            }
                            for(e = new Anb(a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 238);
                                (d.c + (c.b + c.c)) * (d.b + (c.d + c.a)) == f && ZEb(i.c, d);
                            }
                            return i;
                        };
                        var f1 = sfb(_Fe, 'AreaFilter', 673);
                        feb(674, 1, {
                            535: 1
                        }, j8c);
                        _.Hg = function k8c(a, b, c) {
                            var d, e, f, g, h, i;
                            h = new bnb;
                            i = oxe;
                            for(g = new Anb(a); g.a < g.c.c.length;){
                                f = RD(ynb(g), 238);
                                i = $wnd.Math.min(i, $wnd.Math.abs((f.c + (c.b + c.c)) / (f.b + (c.d + c.a)) - b));
                            }
                            for(e = new Anb(a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 238);
                                $wnd.Math.abs((d.c + (c.b + c.c)) / (d.b + (c.d + c.a)) - b) == i && ZEb(h.c, d);
                            }
                            return h;
                        };
                        var g1 = sfb(_Fe, 'AspectRatioFilter', 674);
                        feb(1469, 1, nEe, o8c);
                        _.rg = function p8c(a) {
                            return RD(a, 27), null;
                        };
                        _.Kf = function q8c(a, b) {
                            n8c(RD(a, 27), b);
                        };
                        var i1 = sfb(_Fe, 'GreedyWidthApproximator', 1469);
                        feb(672, 1, {
                            535: 1
                        }, r8c);
                        _.Hg = function s8c(a, b, c) {
                            var d, e, f, g, h, i;
                            i = new bnb;
                            f = pxe;
                            for(h = new Anb(a); h.a < h.c.c.length;){
                                g = RD(ynb(h), 238);
                                f = $wnd.Math.max(f, Aad(g.c + (c.b + c.c), g.b + (c.d + c.a), g.a));
                            }
                            for(e = new Anb(a); e.a < e.c.c.length;){
                                d = RD(ynb(e), 238);
                                Aad(d.c + (c.b + c.c), d.b + (c.d + c.a), d.a) == f && ZEb(i.c, d);
                            }
                            return i;
                        };
                        var j1 = sfb(_Fe, 'ScaleMeasureFilter', 672);
                        feb(1470, 1, nEe, u8c);
                        _.rg = function v8c(a) {
                            return RD(a, 27), null;
                        };
                        _.Kf = function w8c(a, b) {
                            t8c(RD(a, 27), b);
                        };
                        var k1 = sfb(_Fe, 'TargetWidthWidthApproximator', 1470);
                        feb(491, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            491: 1,
                            188: 1,
                            196: 1
                        }, B8c);
                        _.dg = function D8c() {
                            return A8c(this);
                        };
                        _.qg = function C8c() {
                            return A8c(this);
                        };
                        var x8c, y8c;
                        var l1 = tfb(_Fe, 'WidthApproximationStrategy', 491, WI, F8c, E8c);
                        var G8c;
                        feb(1471, 1, nEe, R8c);
                        _.rg = function S8c(a) {
                            return RD(a, 27), null;
                        };
                        _.Kf = function T8c(a, b) {
                            Q8c(this, RD(a, 27), b);
                        };
                        var m1 = sfb(aGe, 'Compactor', 1471);
                        feb(1473, 1, nEe, X8c);
                        _.rg = function Y8c(a) {
                            return RD(a, 27), null;
                        };
                        _.Kf = function Z8c(a, b) {
                            W8c(RD(a, 27), b);
                        };
                        var n1 = sfb(aGe, 'NoPlacement', 1473);
                        feb(439, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            439: 1,
                            188: 1,
                            196: 1
                        }, d9c);
                        _.dg = function f9c() {
                            return c9c(this);
                        };
                        _.qg = function e9c() {
                            return c9c(this);
                        };
                        var $8c, _8c, a9c;
                        var o1 = tfb(aGe, 'PackingStrategy', 439, WI, h9c, g9c);
                        var i9c;
                        feb(810, 1, {}, m9c);
                        _.a = 0;
                        _.b = 0;
                        _.c = 0;
                        _.d = oxe;
                        _.e = 0;
                        _.f = oxe;
                        var p1 = sfb(aGe, 'RowFillingAndCompaction', 810);
                        feb(1472, 1, nEe, o9c);
                        _.rg = function p9c(a) {
                            return RD(a, 27), null;
                        };
                        _.Kf = function q9c(a, b) {
                            n9c(RD(a, 27), b);
                        };
                        var q1 = sfb(aGe, 'SimplePlacement', 1472);
                        feb(1474, 1, nEe, s9c);
                        _.rg = function t9c(a) {
                            return RD(a, 27), null;
                        };
                        _.Kf = function u9c(a, b) {
                            this.Ig(RD(a, 27), b);
                        };
                        _.Ig = function v9c(a, b) {
                            r9c(a, b);
                        };
                        var r1 = sfb(cGe, 'EqualWhitespaceEliminator', 1474);
                        feb(1475, 1474, nEe, x9c);
                        _.Ig = function y9c(a, b) {
                            var c, d, e, f, g;
                            b.Ug('To Aspect Ratio Whitesapce Eliminator', 1);
                            g = Kfb(UD(Gxd(a, (X6c(), O6c))));
                            f = Kfb(UD(Gxd(a, N6c)));
                            e = Kfb(UD(Gxd(a, (X7c(), x7c))));
                            c = Kfb(UD(Gxd(a, M6c)));
                            d = g / f;
                            if (d < e) {
                                g = f * e;
                                Ixd(a, O6c, g);
                            } else {
                                c += g / e - f;
                                Ixd(a, M6c, c);
                                Ixd(a, N6c, f + c);
                            }
                            r9c(a, b);
                            b.Vg();
                        };
                        var s1 = sfb(cGe, 'ToAspectratioNodeExpander', 1475);
                        feb(492, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            492: 1,
                            188: 1,
                            196: 1
                        }, D9c);
                        _.dg = function F9c() {
                            return C9c(this);
                        };
                        _.qg = function E9c() {
                            return C9c(this);
                        };
                        var z9c, A9c;
                        var t1 = tfb(cGe, 'WhiteSpaceEliminationStrategy', 492, WI, H9c, G9c);
                        var I9c;
                        feb(172, 1, {
                            172: 1
                        }, V9c);
                        _.a = 0;
                        _.c = false;
                        _.d = 0;
                        _.e = 0;
                        _.f = 0;
                        _.g = 0;
                        _.i = 0;
                        _.k = false;
                        _.o = oxe;
                        _.p = oxe;
                        _.r = 0;
                        _.s = 0;
                        _.t = 0;
                        var w1 = sfb(dGe, 'Block', 172);
                        feb(209, 1, {
                            209: 1
                        }, _9c);
                        _.a = 0;
                        _.b = 0;
                        _.d = 0;
                        _.e = 0;
                        _.f = 0;
                        var u1 = sfb(dGe, 'BlockRow', 209);
                        feb(315, 1, {
                            315: 1
                        }, had);
                        _.b = 0;
                        _.c = 0;
                        _.d = 0;
                        _.e = 0;
                        _.f = 0;
                        var v1 = sfb(dGe, 'BlockStack', 315);
                        feb(238, 1, {
                            238: 1
                        }, lad, mad);
                        _.a = 0;
                        _.b = 0;
                        _.c = 0;
                        _.d = 0;
                        _.e = 0;
                        _.g = 0;
                        var y1 = sfb(dGe, 'DrawingData', 238);
                        feb(373, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            373: 1
                        }, tad);
                        var nad, oad, pad, qad, rad;
                        var x1 = tfb(dGe, 'DrawingDataDescriptor', 373, WI, vad, uad);
                        var wad;
                        feb(186, 1, {
                            186: 1
                        }, Had);
                        _.b = 0;
                        _.c = 0;
                        _.e = 0;
                        _.f = 0;
                        var z1 = sfb(dGe, 'RectRow', 186);
                        feb(763, 1, {}, Pad);
                        _.j = 0;
                        var F1 = sfb(fGe, dBe, 763);
                        feb(1209, 1, {}, Qad);
                        _.af = function Rad(a) {
                            return bjd(a.a, a.b);
                        };
                        var A1 = sfb(fGe, Nze, 1209);
                        feb(1210, 1, {}, Sad);
                        _.af = function Tad(a) {
                            return Kad(this.a, a);
                        };
                        var B1 = sfb(fGe, eBe, 1210);
                        feb(1211, 1, {}, Uad);
                        _.af = function Vad(a) {
                            return Lad(this.a, a);
                        };
                        var C1 = sfb(fGe, fBe, 1211);
                        feb(1212, 1, {}, Wad);
                        _.af = function Xad(a) {
                            return Mad(this.a, a);
                        };
                        var D1 = sfb(fGe, 'ElkGraphImporter/lambda$3$Type', 1212);
                        feb(1213, 1, {}, Yad);
                        _.af = function Zad(a) {
                            return Nad(this.a, a);
                        };
                        var E1 = sfb(fGe, gBe, 1213);
                        feb(1115, 205, oze, $ad);
                        _.rf = function abd(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n;
                            if (Hxd(a, (ncd(), mcd))) {
                                n = WD(Gxd(a, (Tcd(), Scd)));
                                f = sgd(ygd(), n);
                                if (f) {
                                    g = RD(ltd(f.f), 205);
                                    g.rf(a, b.eh(1));
                                }
                            }
                            Ixd(a, hcd, (Mbd(), Kbd));
                            Ixd(a, icd, (Xbd(), Ubd));
                            Ixd(a, jcd, (ldd(), kdd));
                            h = RD(Gxd(a, (Tcd(), Ocd)), 17).a;
                            b.Ug('Overlap removal', 1);
                            Heb(TD(Gxd(a, Ncd)));
                            i = new _sb;
                            j = new cbd(i);
                            d = new Pad;
                            c = Jad(d, a);
                            k = true;
                            e = 0;
                            while(e < h && k){
                                if (Heb(TD(Gxd(a, Pcd)))) {
                                    i.a.$b();
                                    VQb(new WQb(j), c.i);
                                    if (i.a.gc() == 0) break;
                                    c.e = i;
                                }
                                Sed(this.b);
                                Ved(this.b, (gbd(), dbd), (_cd(), $cd));
                                Ved(this.b, ebd, c.g);
                                Ved(this.b, fbd, (Cbd(), Bbd));
                                this.a = Qed(this.b, c);
                                for(m = new Anb(this.a); m.a < m.c.c.length;){
                                    l = RD(ynb(m), 47);
                                    l.Kf(c, b.eh(1));
                                }
                                Oad(d, c);
                                k = Heb(TD(mQb(c, (OQb(), NQb))));
                                ++e;
                            }
                            Iad(d, c);
                            b.Vg();
                        };
                        var H1 = sfb(fGe, 'OverlapRemovalLayoutProvider', 1115);
                        feb(1116, 1, {}, cbd);
                        var G1 = sfb(fGe, 'OverlapRemovalLayoutProvider/lambda$0$Type', 1116);
                        feb(444, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            444: 1
                        }, hbd);
                        var dbd, ebd, fbd;
                        var I1 = tfb(fGe, 'SPOrEPhases', 444, WI, jbd, ibd);
                        var kbd;
                        feb(1219, 1, {}, nbd);
                        var K1 = sfb(fGe, 'ShrinkTree', 1219);
                        feb(1117, 205, oze, obd);
                        _.rf = function pbd(a, b) {
                            var c, d, e, f, g;
                            if (Hxd(a, (ncd(), mcd))) {
                                g = WD(Gxd(a, mcd));
                                e = sgd(ygd(), g);
                                if (e) {
                                    f = RD(ltd(e.f), 205);
                                    f.rf(a, b.eh(1));
                                }
                            }
                            d = new Pad;
                            c = Jad(d, a);
                            mbd(this.a, c, b.eh(1));
                            Iad(d, c);
                        };
                        var J1 = sfb(fGe, 'ShrinkTreeLayoutProvider', 1117);
                        feb(306, 137, {
                            3: 1,
                            306: 1,
                            96: 1,
                            137: 1
                        }, qbd);
                        _.c = false;
                        var L1 = sfb('org.eclipse.elk.alg.spore.graph', 'Graph', 306);
                        feb(490, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            490: 1,
                            188: 1,
                            196: 1
                        }, ubd);
                        _.dg = function wbd() {
                            return tbd(this);
                        };
                        _.qg = function vbd() {
                            return tbd(this);
                        };
                        var rbd;
                        var M1 = tfb(gGe, uze, 490, WI, ybd, xbd);
                        var zbd;
                        feb(558, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            558: 1,
                            188: 1,
                            196: 1
                        }, Dbd);
                        _.dg = function Fbd() {
                            return new Tdd;
                        };
                        _.qg = function Ebd() {
                            return new Tdd;
                        };
                        var Bbd;
                        var N1 = tfb(gGe, 'OverlapRemovalStrategy', 558, WI, Hbd, Gbd);
                        var Ibd;
                        feb(438, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            438: 1
                        }, Nbd);
                        var Kbd, Lbd;
                        var O1 = tfb(gGe, 'RootSelection', 438, WI, Pbd, Obd);
                        var Qbd;
                        feb(324, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            324: 1
                        }, Ybd);
                        var Sbd, Tbd, Ubd, Vbd, Wbd;
                        var P1 = tfb(gGe, 'SpanningTreeCostFunction', 324, WI, $bd, Zbd);
                        var _bd;
                        feb(1014, 1, Eye, pcd);
                        _.hf = function qcd(a) {
                            ocd(a);
                        };
                        var bcd, ccd, dcd, ecd, fcd, gcd, hcd, icd, jcd, kcd, lcd, mcd;
                        var R1 = sfb(gGe, 'SporeCompactionOptions', 1014);
                        feb(1015, 1, {}, rcd);
                        _.sf = function scd() {
                            var a;
                            return a = new obd, a;
                        };
                        _.tf = function tcd(a) {};
                        var Q1 = sfb(gGe, 'SporeCompactionOptions/SporeCompactionFactory', 1015);
                        feb(866, 1, Eye, Lcd);
                        _.hf = function Mcd(a) {
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, iGe), ''), 'Underlying Layout Algorithm'), 'A layout algorithm that is applied to the graph before it is compacted. If this is null, nothing is applied before compaction.'), (kid(), iid)), qJ), xsb((Yhd(), Whd)))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, nGe), 'structure'), 'Structure Extraction Strategy'), 'This option defines what kind of triangulation or other partitioning of the plane is applied to the vertices.'), Icd), eid), V1), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, jGe), sGe), 'Tree Construction Strategy'), 'Whether a minimum spanning tree or a maximum spanning tree should be constructed.'), Gcd), eid), W1), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, kGe), sGe), 'Cost Function for Spanning Tree'), 'The cost function is used in the creation of the spanning tree.'), Ecd), eid), P1), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, lGe), sGe), 'Root node for spanning tree construction'), 'The identifier of the node that is preferred as the root of the spanning tree. If this is null, the first node is chosen.'), null), iid), qJ), xsb(Whd))));
                            zgd(a, lGe, mGe, Acd);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, mGe), sGe), 'Root selection for spanning tree'), 'This sets the method used to select a root node for the construction of a spanning tree'), Ccd), eid), O1), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, oGe), nDe), YFe), 'This option defines how the compaction is applied.'), vcd), eid), M1), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, pGe), nDe), 'Orthogonal Compaction'), 'Restricts the translation of nodes to orthogonal directions in the compaction phase.'), (Geb(), false)), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, qGe), tGe), 'Upper limit for iterations of overlap removal'), null), sgb(64)), gid), bJ), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, rGe), tGe), 'Whether to run a supplementary scanline overlap check.'), null), true), cid), QI), xsb(Whd))));
                            Ucd((new Vcd, a));
                            ocd((new pcd, a));
                        };
                        var ucd, vcd, wcd, xcd, ycd, zcd, Acd, Bcd, Ccd, Dcd, Ecd, Fcd, Gcd, Hcd, Icd, Jcd;
                        var S1 = sfb(gGe, 'SporeMetaDataProvider', 866);
                        feb(1012, 1, Eye, Vcd);
                        _.hf = function Wcd(a) {
                            Ucd(a);
                        };
                        var Ncd, Ocd, Pcd, Qcd, Rcd, Scd;
                        var U1 = sfb(gGe, 'SporeOverlapRemovalOptions', 1012);
                        feb(1013, 1, {}, Xcd);
                        _.sf = function Ycd() {
                            var a;
                            return a = new $ad, a;
                        };
                        _.tf = function Zcd(a) {};
                        var T1 = sfb(gGe, 'SporeOverlapRemovalOptions/SporeOverlapFactory', 1013);
                        feb(539, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            539: 1,
                            188: 1,
                            196: 1
                        }, cdd);
                        _.dg = function edd() {
                            return bdd(this);
                        };
                        _.qg = function ddd() {
                            return bdd(this);
                        };
                        var $cd;
                        var V1 = tfb(gGe, 'StructureExtractionStrategy', 539, WI, gdd, fdd);
                        var hdd;
                        feb(437, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            437: 1,
                            188: 1,
                            196: 1
                        }, ndd);
                        _.dg = function pdd() {
                            return mdd(this);
                        };
                        _.qg = function odd() {
                            return mdd(this);
                        };
                        var jdd, kdd;
                        var W1 = tfb(gGe, 'TreeConstructionStrategy', 437, WI, rdd, qdd);
                        var sdd;
                        feb(1463, 1, nEe, vdd);
                        _.rg = function wdd(a) {
                            return RD(a, 306), new ufd;
                        };
                        _.Kf = function xdd(a, b) {
                            udd(RD(a, 306), b);
                        };
                        var Y1 = sfb(vGe, 'DelaunayTriangulationPhase', 1463);
                        feb(1464, 1, Qve, ydd);
                        _.Cd = function zdd(a) {
                            Rmb(this.a, RD(a, 68).a);
                        };
                        var X1 = sfb(vGe, 'DelaunayTriangulationPhase/lambda$0$Type', 1464);
                        feb(794, 1, nEe, Ddd);
                        _.rg = function Edd(a) {
                            return RD(a, 306), new ufd;
                        };
                        _.Kf = function Fdd(a, b) {
                            this.Jg(RD(a, 306), b);
                        };
                        _.Jg = function Gdd(a, b) {
                            var c, d, e;
                            b.Ug('Minimum spanning tree construction', 1);
                            a.d ? d = a.d.a : d = RD(Vmb(a.i, 0), 68).a;
                            Heb(TD(mQb(a, (OQb(), MQb)))) ? e = LFb(a.e, d, (c = a.b, c)) : e = LFb(a.e, d, a.b);
                            Bdd(this, e, a);
                            b.Vg();
                        };
                        var a2 = sfb(wGe, 'MinSTPhase', 794);
                        feb(1466, 794, nEe, Hdd);
                        _.Jg = function Jdd(a, b) {
                            var c, d, e, f;
                            b.Ug('Maximum spanning tree construction', 1);
                            c = new Kdd(a);
                            a.d ? e = a.d.c : e = RD(Vmb(a.i, 0), 68).c;
                            Heb(TD(mQb(a, (OQb(), MQb)))) ? f = LFb(a.e, e, (d = c, d)) : f = LFb(a.e, e, c);
                            Bdd(this, f, a);
                            b.Vg();
                        };
                        var $1 = sfb(wGe, 'MaxSTPhase', 1466);
                        feb(1467, 1, {}, Kdd);
                        _.af = function Ldd(a) {
                            return Idd(this.a, a);
                        };
                        var Z1 = sfb(wGe, 'MaxSTPhase/lambda$0$Type', 1467);
                        feb(1465, 1, Qve, Mdd);
                        _.Cd = function Ndd(a) {
                            Cdd(this.a, RD(a, 68));
                        };
                        var _1 = sfb(wGe, 'MinSTPhase/lambda$0$Type', 1465);
                        feb(796, 1, nEe, Tdd);
                        _.rg = function Udd(a) {
                            return RD(a, 306), new ufd;
                        };
                        _.Kf = function Vdd(a, b) {
                            Sdd(this, RD(a, 306), b);
                        };
                        _.a = false;
                        var c2 = sfb(xGe, 'GrowTreePhase', 796);
                        feb(797, 1, Qve, Wdd);
                        _.Cd = function Xdd(a) {
                            Rdd(this.a, this.b, this.c, RD(a, 225));
                        };
                        var b2 = sfb(xGe, 'GrowTreePhase/lambda$0$Type', 797);
                        feb(1468, 1, nEe, _dd);
                        _.rg = function aed(a) {
                            return RD(a, 306), new ufd;
                        };
                        _.Kf = function bed(a, b) {
                            $dd(this, RD(a, 306), b);
                        };
                        var e2 = sfb(xGe, 'ShrinkTreeCompactionPhase', 1468);
                        feb(795, 1, Qve, ced);
                        _.Cd = function ded(a) {
                            Zdd(this.a, this.b, this.c, RD(a, 225));
                        };
                        var d2 = sfb(xGe, 'ShrinkTreeCompactionPhase/lambda$0$Type', 795);
                        var j4 = ufb(jEe, 'IGraphElementVisitor');
                        feb(872, 1, {
                            536: 1
                        }, med);
                        _.Kg = function ped(a) {
                            var b;
                            b = led(this, a);
                            kQb(b, RD(Wjb(this.b, a), 96));
                            jed(this, a, b);
                        };
                        var eed, fed, ged;
                        var l2 = sfb(pze, 'LayoutConfigurator', 872);
                        var g2 = ufb(pze, 'LayoutConfigurator/IPropertyHolderOptionFilter');
                        feb(944, 1, {
                            2032: 1
                        }, qed);
                        _.Lg = function red(a, b) {
                            return hed(), !a.pf(b);
                        };
                        var h2 = sfb(pze, 'LayoutConfigurator/lambda$0$Type', 944);
                        feb(943, 1, {
                            845: 1
                        }, sed);
                        _.Mg = function ted(a, b) {
                            return hed(), !a.pf(b);
                        };
                        var i2 = sfb(pze, 'LayoutConfigurator/lambda$1$Type', 943);
                        feb(945, 1, {
                            2032: 1
                        }, ved);
                        _.Lg = function wed(a, b) {
                            return ued(a, b);
                        };
                        var j2 = sfb(pze, 'LayoutConfigurator/lambda$2$Type', 945);
                        feb(946, 1, nwe, xed);
                        _.Mb = function yed(a) {
                            return oed(this.a, this.b, RD(a, 2032));
                        };
                        var k2 = sfb(pze, 'LayoutConfigurator/lambda$3$Type', 946);
                        feb(869, 1, {}, Hed);
                        var m2 = sfb(pze, 'RecursiveGraphLayoutEngine', 869);
                        feb(224, 63, swe, Ied, Jed);
                        var n2 = sfb(pze, 'UnsupportedConfigurationException', 224);
                        feb(370, 63, swe, Ked);
                        var o2 = sfb(pze, 'UnsupportedGraphException', 370);
                        feb(761, 1, {});
                        var N3 = sfb(jEe, 'AbstractRandomListAccessor', 761);
                        feb(450, 761, {}, Wed);
                        _.Ng = function Yed() {
                            return null;
                        };
                        _.d = true;
                        _.e = true;
                        _.f = 0;
                        var u2 = sfb(AGe, 'AlgorithmAssembler', 450);
                        feb(1200, 1, nwe, Zed);
                        _.Mb = function $ed(a) {
                            return !!RD(a, 106);
                        };
                        var p2 = sfb(AGe, 'AlgorithmAssembler/lambda$0$Type', 1200);
                        feb(1201, 1, {}, _ed);
                        _.Kb = function afd(a) {
                            return Xed(this.a, RD(a, 106));
                        };
                        var q2 = sfb(AGe, 'AlgorithmAssembler/lambda$1$Type', 1201);
                        feb(1202, 1, nwe, bfd);
                        _.Mb = function cfd(a) {
                            return !!RD(a, 80);
                        };
                        var r2 = sfb(AGe, 'AlgorithmAssembler/lambda$2$Type', 1202);
                        feb(1203, 1, Qve, dfd);
                        _.Cd = function efd(a) {
                            ofd(this.a, RD(a, 80));
                        };
                        var s2 = sfb(AGe, 'AlgorithmAssembler/lambda$3$Type', 1203);
                        feb(1204, 1, Qve, ffd);
                        _.Cd = function gfd(a) {
                            Red(this.a, this.b, RD(a, 196));
                        };
                        var t2 = sfb(AGe, 'AlgorithmAssembler/lambda$4$Type', 1204);
                        feb(1343, 1, fye, ifd);
                        _.Ne = function jfd(a, b) {
                            return hfd(RD(a, 196), RD(b, 196));
                        };
                        _.Fb = function kfd(a) {
                            return this === a;
                        };
                        _.Oe = function lfd() {
                            return new Frb(this);
                        };
                        var v2 = sfb(AGe, 'EnumBasedFactoryComparator', 1343);
                        feb(80, 761, {
                            80: 1
                        }, ufd);
                        _.Ng = function wfd() {
                            return new _sb;
                        };
                        _.a = 0;
                        var w2 = sfb(AGe, 'LayoutProcessorConfiguration', 80);
                        feb(1025, 1, {
                            536: 1
                        }, Bfd);
                        _.Kg = function Ffd(a) {
                            Bvb(yfd, new Kfd(a));
                        };
                        var xfd, yfd, zfd;
                        var A2 = sfb(zye, 'DeprecatedLayoutOptionReplacer', 1025);
                        feb(1026, 1, Qve, Gfd);
                        _.Cd = function Hfd(a) {
                            Cfd(RD(a, 167));
                        };
                        var x2 = sfb(zye, 'DeprecatedLayoutOptionReplacer/lambda$0$Type', 1026);
                        feb(1027, 1, Qve, Ifd);
                        _.Cd = function Jfd(a) {
                            Dfd(RD(a, 167));
                        };
                        var y2 = sfb(zye, 'DeprecatedLayoutOptionReplacer/lambda$1$Type', 1027);
                        feb(1028, 1, {}, Kfd);
                        _.Yd = function Lfd(a, b) {
                            Efd(this.a, RD(a, 149), RD(b, 41));
                        };
                        var z2 = sfb(zye, 'DeprecatedLayoutOptionReplacer/lambda$2$Type', 1028);
                        feb(143, 1, {
                            701: 1,
                            143: 1
                        }, Pfd);
                        _.Fb = function Qfd(a) {
                            return Nfd(this, a);
                        };
                        _.Og = function Rfd() {
                            return this.b;
                        };
                        _.Pg = function Sfd() {
                            return this.c;
                        };
                        _.xe = function Tfd() {
                            return this.e;
                        };
                        _.Hb = function Ufd() {
                            return ohb(this.c);
                        };
                        _.Ib = function Vfd() {
                            return 'Layout Algorithm: ' + this.c;
                        };
                        var D2 = sfb(zye, 'LayoutAlgorithmData', 143);
                        feb(269, 1, {}, agd);
                        var C2 = sfb(zye, 'LayoutAlgorithmData/Builder', 269);
                        feb(1029, 1, {
                            536: 1
                        }, dgd);
                        _.Kg = function egd(a) {
                            ZD(a, 207) && !Heb(TD(a.of((umd(), rld)))) && bgd(RD(a, 27));
                        };
                        var E2 = sfb(zye, 'LayoutAlgorithmResolver', 1029);
                        feb(233, 1, {
                            701: 1,
                            233: 1
                        }, fgd);
                        _.Fb = function ggd(a) {
                            if (ZD(a, 233)) return lhb(this.b, RD(a, 233).b);
                            return false;
                        };
                        _.Og = function hgd() {
                            return this.a;
                        };
                        _.Pg = function igd() {
                            return this.b;
                        };
                        _.xe = function jgd() {
                            return this.d;
                        };
                        _.Hb = function kgd() {
                            return ohb(this.b);
                        };
                        _.Ib = function lgd() {
                            return 'Layout Type: ' + this.b;
                        };
                        var G2 = sfb(zye, 'LayoutCategoryData', 233);
                        feb(357, 1, {}, pgd);
                        var F2 = sfb(zye, 'LayoutCategoryData/Builder', 357);
                        feb(879, 1, {}, xgd);
                        var qgd;
                        var b3 = sfb(zye, 'LayoutMetaDataService', 879);
                        feb(880, 1, {}, Ggd);
                        var I2 = sfb(zye, 'LayoutMetaDataService/Registry', 880);
                        feb(487, 1, {
                            487: 1
                        }, Hgd);
                        var H2 = sfb(zye, 'LayoutMetaDataService/Registry/Triple', 487);
                        feb(881, 1, BGe, Igd);
                        _.Qg = function Jgd() {
                            return new pjd;
                        };
                        var J2 = sfb(zye, 'LayoutMetaDataService/lambda$0$Type', 881);
                        feb(882, 1, CGe, Kgd);
                        _.Rg = function Lgd(a) {
                            return ajd(RD(a, 8));
                        };
                        var K2 = sfb(zye, 'LayoutMetaDataService/lambda$1$Type', 882);
                        feb(891, 1, BGe, Mgd);
                        _.Qg = function Ngd() {
                            return new bnb;
                        };
                        var L2 = sfb(zye, 'LayoutMetaDataService/lambda$10$Type', 891);
                        feb(892, 1, CGe, Ogd);
                        _.Rg = function Pgd(a) {
                            return new dnb(RD(a, 13));
                        };
                        var M2 = sfb(zye, 'LayoutMetaDataService/lambda$11$Type', 892);
                        feb(893, 1, BGe, Qgd);
                        _.Qg = function Rgd() {
                            return new Yub;
                        };
                        var N2 = sfb(zye, 'LayoutMetaDataService/lambda$12$Type', 893);
                        feb(894, 1, CGe, Sgd);
                        _.Rg = function Tgd(a) {
                            return gv(RD(a, 67));
                        };
                        var O2 = sfb(zye, 'LayoutMetaDataService/lambda$13$Type', 894);
                        feb(895, 1, BGe, Ugd);
                        _.Qg = function Vgd() {
                            return new _sb;
                        };
                        var P2 = sfb(zye, 'LayoutMetaDataService/lambda$14$Type', 895);
                        feb(896, 1, CGe, Wgd);
                        _.Rg = function Xgd(a) {
                            return Ux(RD(a, 49));
                        };
                        var Q2 = sfb(zye, 'LayoutMetaDataService/lambda$15$Type', 896);
                        feb(897, 1, BGe, Ygd);
                        _.Qg = function Zgd() {
                            return new Iub;
                        };
                        var R2 = sfb(zye, 'LayoutMetaDataService/lambda$16$Type', 897);
                        feb(898, 1, CGe, $gd);
                        _.Rg = function _gd(a) {
                            return Xx(RD(a, 49));
                        };
                        var S2 = sfb(zye, 'LayoutMetaDataService/lambda$17$Type', 898);
                        feb(899, 1, BGe, ahd);
                        _.Qg = function bhd() {
                            return new xAb;
                        };
                        var T2 = sfb(zye, 'LayoutMetaDataService/lambda$18$Type', 899);
                        feb(900, 1, CGe, chd);
                        _.Rg = function dhd(a) {
                            return Yx(RD(a, 157));
                        };
                        var U2 = sfb(zye, 'LayoutMetaDataService/lambda$19$Type', 900);
                        feb(883, 1, BGe, ehd);
                        _.Qg = function fhd() {
                            return new Ejd;
                        };
                        var V2 = sfb(zye, 'LayoutMetaDataService/lambda$2$Type', 883);
                        feb(884, 1, CGe, ghd);
                        _.Rg = function hhd(a) {
                            return new Fjd(RD(a, 75));
                        };
                        var W2 = sfb(zye, 'LayoutMetaDataService/lambda$3$Type', 884);
                        feb(885, 1, BGe, ihd);
                        _.Qg = function jhd() {
                            return new P2b;
                        };
                        var X2 = sfb(zye, 'LayoutMetaDataService/lambda$4$Type', 885);
                        feb(886, 1, CGe, khd);
                        _.Rg = function lhd(a) {
                            return new S2b(RD(a, 140));
                        };
                        var Y2 = sfb(zye, 'LayoutMetaDataService/lambda$5$Type', 886);
                        feb(887, 1, BGe, mhd);
                        _.Qg = function nhd() {
                            return new z3b;
                        };
                        var Z2 = sfb(zye, 'LayoutMetaDataService/lambda$6$Type', 887);
                        feb(888, 1, CGe, ohd);
                        _.Rg = function phd(a) {
                            return new B3b(RD(a, 107));
                        };
                        var $2 = sfb(zye, 'LayoutMetaDataService/lambda$7$Type', 888);
                        feb(889, 1, BGe, qhd);
                        _.Qg = function rhd() {
                            return new dtd;
                        };
                        var _2 = sfb(zye, 'LayoutMetaDataService/lambda$8$Type', 889);
                        feb(890, 1, CGe, shd);
                        _.Rg = function thd(a) {
                            return new etd(RD(a, 385));
                        };
                        var a3 = sfb(zye, 'LayoutMetaDataService/lambda$9$Type', 890);
                        var V5 = ufb(jze, 'IProperty');
                        feb(23, 1, {
                            34: 1,
                            701: 1,
                            23: 1,
                            149: 1
                        }, Ahd);
                        _.Fd = function Bhd(a) {
                            return vhd(this, RD(a, 149));
                        };
                        _.Fb = function Chd(a) {
                            return ZD(a, 23) ? lhb(this.f, RD(a, 23).f) : ZD(a, 149) && lhb(this.f, RD(a, 149).Pg());
                        };
                        _.Sg = function Dhd() {
                            var a;
                            if (ZD(this.b, 4)) {
                                a = FId(this.b);
                                if (a == null) throw Adb(new dgb(HGe + this.f + "'. " + "Make sure it's type is registered with the " + (lfb(b6), b6.k) + EGe));
                                return a;
                            } else return this.b;
                        };
                        _.Og = function Ehd() {
                            return this.d;
                        };
                        _.Pg = function Fhd() {
                            return this.f;
                        };
                        _.xe = function Ghd() {
                            return this.i;
                        };
                        _.Hb = function Hhd() {
                            return ohb(this.f);
                        };
                        _.Ib = function Ihd() {
                            return 'Layout Option: ' + this.f;
                        };
                        var f3 = sfb(zye, 'LayoutOptionData', 23);
                        feb(24, 1, {}, Shd);
                        var c3 = sfb(zye, 'LayoutOptionData/Builder', 24);
                        feb(170, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            170: 1
                        }, Zhd);
                        var Thd, Uhd, Vhd, Whd, Xhd;
                        var d3 = tfb(zye, 'LayoutOptionData/Target', 170, WI, _hd, $hd);
                        var aid;
                        feb(285, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            285: 1
                        }, lid);
                        var cid, did, eid, fid, gid, hid, iid, jid;
                        var e3 = tfb(zye, 'LayoutOptionData/Type', 285, WI, nid, mid);
                        var oid;
                        var qid;
                        var sid;
                        feb(116, 1, {
                            116: 1
                        }, Tid, Uid, Vid);
                        _.Fb = function Wid(a) {
                            var b;
                            if (a == null || !ZD(a, 116)) return false;
                            b = RD(a, 116);
                            return Fvb(this.c, b.c) && Fvb(this.d, b.d) && Fvb(this.b, b.b) && Fvb(this.a, b.a);
                        };
                        _.Hb = function Xid() {
                            return Tnb(cD(WC(jJ, 1), rve, 1, 5, [
                                this.c,
                                this.d,
                                this.b,
                                this.a
                            ]));
                        };
                        _.Ib = function Yid() {
                            return 'Rect[x=' + this.c + ',y=' + this.d + ',w=' + this.b + ',h=' + this.a + ']';
                        };
                        _.a = 0;
                        _.b = 0;
                        _.c = 0;
                        _.d = 0;
                        var j3 = sfb(_Ae, 'ElkRectangle', 116);
                        feb(8, 1, {
                            3: 1,
                            4: 1,
                            8: 1,
                            423: 1
                        }, pjd, qjd, rjd, sjd);
                        _.Fb = function tjd(a) {
                            return djd(this, a);
                        };
                        _.Hb = function ujd() {
                            return Nfb(this.a) + pgb(Nfb(this.b));
                        };
                        _.cg = function wjd(b) {
                            var c, d, e, f;
                            e = 0;
                            while(e < b.length && vjd((BFb(e, b.length), b.charCodeAt(e)), YAe))++e;
                            c = b.length;
                            while(c > 0 && vjd((BFb(c - 1, b.length), b.charCodeAt(c - 1)), ZAe))--c;
                            if (e >= c) throw Adb(new agb('The given string does not contain any numbers.'));
                            f = vhb((AFb(e, c, b.length), b.substr(e, c - e)), ',|;|\r|\n');
                            if (f.length != 2) throw Adb(new agb('Exactly two numbers are expected, ' + f.length + ' were found.'));
                            try {
                                this.a = Neb(Dhb(f[0]));
                                this.b = Neb(Dhb(f[1]));
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 130)) {
                                    d = a;
                                    throw Adb(new agb($Ae + d));
                                } else throw Adb(a);
                            }
                        };
                        _.Ib = function yjd() {
                            return '(' + this.a + ',' + this.b + ')';
                        };
                        _.a = 0;
                        _.b = 0;
                        var l3 = sfb(_Ae, 'KVector', 8);
                        feb(75, 67, {
                            3: 1,
                            4: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            67: 1,
                            15: 1,
                            75: 1,
                            423: 1
                        }, Ejd, Fjd, Gjd);
                        _.Pc = function Jjd() {
                            return Djd(this);
                        };
                        _.cg = function Hjd(b) {
                            var c, d, e, f, g, h;
                            e = vhb(b, ',|;|\\(|\\)|\\[|\\]|\\{|\\}| |\t|\n');
                            Xub(this);
                            try {
                                d = 0;
                                g = 0;
                                f = 0;
                                h = 0;
                                while(d < e.length){
                                    if (e[d] != null && Dhb(e[d]).length > 0) {
                                        g % 2 == 0 ? f = Neb(e[d]) : h = Neb(e[d]);
                                        g > 0 && g % 2 != 0 && Mub(this, new rjd(f, h));
                                        ++g;
                                    }
                                    ++d;
                                }
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 130)) {
                                    c = a;
                                    throw Adb(new agb('The given string does not match the expected format for vectors.' + c));
                                } else throw Adb(a);
                            }
                        };
                        _.Ib = function Kjd() {
                            var a, b, c;
                            a = new dib('(');
                            b = Sub(this, 0);
                            while(b.b != b.d.c){
                                c = RD(evb(b), 8);
                                Zhb(a, c.a + ',' + c.b);
                                b.b != b.d.c && (a.a += '; ', a);
                            }
                            return (a.a += ')', a).a;
                        };
                        var k3 = sfb(_Ae, 'KVectorChain', 75);
                        feb(255, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            255: 1
                        }, Sjd);
                        var Ljd, Mjd, Njd, Ojd, Pjd, Qjd;
                        var n3 = tfb(JGe, 'Alignment', 255, WI, Ujd, Tjd);
                        var Vjd;
                        feb(991, 1, Eye, jkd);
                        _.hf = function kkd(a) {
                            ikd(a);
                        };
                        var Xjd, Yjd, Zjd, $jd, _jd, akd, bkd, ckd, dkd, ekd, fkd, gkd;
                        var p3 = sfb(JGe, 'BoxLayouterOptions', 991);
                        feb(992, 1, {}, lkd);
                        _.sf = function mkd() {
                            var a;
                            return a = new jrd, a;
                        };
                        _.tf = function nkd(a) {};
                        var o3 = sfb(JGe, 'BoxLayouterOptions/BoxFactory', 992);
                        feb(298, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            298: 1
                        }, vkd);
                        var okd, pkd, qkd, rkd, skd, tkd;
                        var q3 = tfb(JGe, 'ContentAlignment', 298, WI, xkd, wkd);
                        var ykd;
                        feb(699, 1, Eye, vmd);
                        _.hf = function wmd(a) {
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, OGe), ''), 'Layout Algorithm'), 'Select a specific layout algorithm.'), (kid(), iid)), qJ), xsb((Yhd(), Whd)))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, PGe), ''), 'Resolved Layout Algorithm'), 'Meta data associated with the selected algorithm.'), hid), D2), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, MDe), ''), 'Alignment'), 'Alignment of the selected node relative to other nodes; the exact meaning depends on the used algorithm.'), Ckd), eid), n3), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, Dze), ''), 'Aspect Ratio'), 'The desired aspect ratio of the drawing, that is the quotient of width by height.'), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, QGe), ''), 'Bend Points'), "A fixed list of bend points for the edge. This is used by the 'Fixed Layout' algorithm to specify a pre-defined routing for an edge. The vector chain must include the source point, any bend points, and the target point, so it must have at least two points."), hid), k3), xsb(Thd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, YDe), ''), 'Content Alignment'), 'Specifies how the content of a node are aligned. Each node can individually control the alignment of its contents. I.e. if a node should be aligned top left in its parent node, the parent node should specify that option.'), Lkd), fid), q3), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, LDe), ''), 'Debug Mode'), 'Whether additional debug information shall be generated.'), (Geb(), false)), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, PDe), ''), eze), 'Overall direction of edges: horizontal (right / left) or vertical (down / up).'), Okd), eid), s3), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, kDe), ''), 'Edge Routing'), 'What kind of edge routing style should be applied for the content of a parent node. Algorithms may also set this option to single edges in order to mark them as splines. The bend point list of edges with this option set to SPLINES must be interpreted as control points for a piecewise cubic spline.'), Tkd), eid), u3), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, MGe), ''), 'Expand Nodes'), 'If active, nodes are expanded to fill the area of their parent.'), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, fDe), ''), 'Hierarchy Handling'), "Determines whether separate layout runs are triggered for different compound nodes in a hierarchical graph. Setting a node's hierarchy handling to `INCLUDE_CHILDREN` will lay out that node and all of its descendants in a single layout run, until a descendant is encountered which has its hierarchy handling set to `SEPARATE_CHILDREN`. In general, `SEPARATE_CHILDREN` will ensure that a new layout run is triggered for a node with that setting. Including multiple levels of hierarchy in a single layout run may allow cross-hierarchical edges to be laid out properly. If the root node is set to `INHERIT` (or not set at all), the default behavior is `SEPARATE_CHILDREN`."), Ykd), eid), y3), ysb(Whd, cD(WC(d3, 1), jwe, 170, 0, [
                                Vhd
                            ])))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, Eze), ''), 'Padding'), "The padding to be left to a parent element's border when placing child elements. This can also serve as an output option of a layout algorithm if node size calculation is setup appropriately."), uld), hid), i3), ysb(Whd, cD(WC(d3, 1), jwe, 170, 0, [
                                Vhd
                            ])))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, dAe), ''), 'Interactive'), 'Whether the algorithm should be run in interactive mode for the content of a parent node. What this means exactly depends on how the specific algorithm interprets this option. Usually in the interactive mode algorithms try to modify the current layout as little as possible.'), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, iEe), ''), 'interactive Layout'), 'Whether the graph should be changeable interactively and by setting constraints'), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, gAe), ''), 'Omit Node Micro Layout'), "Node micro layout comprises the computation of node dimensions (if requested), the placement of ports and their labels, and the placement of node labels. The functionality is implemented independent of any specific layout algorithm and shouldn't have any negative impact on the layout algorithm's performance itself. Yet, if any unforeseen behavior occurs, this option allows to deactivate the micro layout."), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, eAe), ''), 'Port Constraints'), 'Defines constraints of the position of the ports of a node.'), Ild), eid), C3), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, fEe), ''), 'Position'), "The position of a node, port, or label. This is used by the 'Fixed Layout' algorithm to specify a pre-defined position."), hid), l3), ysb(Vhd, cD(WC(d3, 1), jwe, 170, 0, [
                                Xhd,
                                Uhd
                            ])))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, $ze), ''), 'Priority'), 'Defines the priority of an object; its meaning depends on the specific layout algorithm and the context where it is used.'), gid), bJ), ysb(Vhd, cD(WC(d3, 1), jwe, 170, 0, [
                                Thd
                            ])))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, bAe), ''), 'Randomization Seed'), 'Seed used for pseudo-random number generators to control the layout algorithm. If the value is 0, the seed shall be determined pseudo-randomly (e.g. from the system time).'), gid), bJ), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, cAe), ''), 'Separate Connected Components'), 'Whether each connected component should be processed separately.'), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, ZDe), ''), 'Junction Points'), 'This option is not used as option, but as output of the layout algorithms. It is attached to edges and determines the points where junction symbols should be drawn in order to represent hyperedges with orthogonal routing. Whether such points are computed depends on the chosen layout algorithm and edge routing style. The points are put into the vector chain with no specific order.'), dld), hid), k3), xsb(Thd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, aEe), ''), 'Comment Box'), 'Whether the node should be regarded as a comment box instead of a regular node. In that case its placement should be similar to how labels are handled. Any edges incident to a comment box specify to which graph elements the comment is related.'), false), cid), QI), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, bEe), ''), 'Hypernode'), 'Whether the node should be handled as a hypernode.'), false), cid), QI), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, RGe), ''), 'Label Manager'), "Label managers can shorten labels upon a layout algorithm's request."), hid), g3), ysb(Whd, cD(WC(d3, 1), jwe, 170, 0, [
                                Uhd
                            ])))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, gEe), ''), 'Margins'), "Margins define additional space around the actual bounds of a graph element. For instance, ports or labels being placed on the outside of a node's border might introduce such a margin. The margin is used to guarantee non-overlap of other graph elements with those ports or labels."), fld), hid), h3), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, JDe), ''), 'No Layout'), "No layout is done for the associated element. This is used to mark parts of a diagram to avoid their inclusion in the layout graph, or to mark parts of the layout graph to prevent layout engines from processing them. If you wish to exclude the contents of a compound node from automatic layout, while the node itself is still considered on its own layer, use the 'Fixed Layout' algorithm for that node."), false), cid), QI), ysb(Vhd, cD(WC(d3, 1), jwe, 170, 0, [
                                Thd,
                                Xhd,
                                Uhd
                            ])))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, SGe), ''), 'Scale Factor'), "The scaling factor to be applied to the corresponding node in recursive layout. It causes the corresponding node's size to be adjusted, and its ports and labels to be sized and placed accordingly after the layout of that node has been determined (and before the node itself and its siblings are arranged). The scaling is not reverted afterwards, so the resulting layout graph contains the adjusted size and position data. This option is currently not supported if 'Layout Hierarchy' is set."), 1), did), VI), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, TGe), ''), 'Child Area Width'), 'The width of the area occupied by the laid out children of a node.'), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, UGe), ''), 'Child Area Height'), 'The height of the area occupied by the laid out children of a node.'), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, mAe), ''), yGe), "Turns topdown layout on and off. If this option is enabled, hierarchical layout will be computed first for the root node and then for its children recursively. Layouts are then scaled down to fit the area provided by their parents. Graphs must follow a certain structure for topdown layout to work properly. {@link TopdownNodeTypes.PARALLEL_NODE} nodes must have children of type {@link TopdownNodeTypes.HIERARCHICAL_NODE} and must define {@link topdown.hierarchicalNodeWidth} and {@link topdown.hierarchicalNodeAspectRatio} for their children. Furthermore they need to be laid out using an algorithm that is a {@link TopdownLayoutProvider}. Hierarchical nodes can also be parents of other hierarchical nodes and can optionally use a {@link TopdownSizeApproximator} to dynamically set sizes during topdown layout. In this case {@link topdown.hierarchicalNodeWidth} and {@link topdown.hierarchicalNodeAspectRatio} should be set on the node itself rather than the parent. The values are then used by the size approximator as base values. Hierarchical nodes require the layout option {@link nodeSize.fixedGraphSize} to be true to prevent the algorithm used there from resizing the hierarchical node. This option is not supported if 'Hierarchy Handling' is set to 'INCLUDE_CHILDREN'"), false), cid), QI), xsb(Whd))));
                            zgd(a, mAe, qAe, null);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, VGe), ''), 'Animate'), 'Whether the shift from the old layout to the new computed layout shall be animated.'), true), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, WGe), ''), 'Animation Time Factor'), "Factor for computation of animation time. The higher the value, the longer the animation time. If the value is 0, the resulting time is always equal to the minimum defined by 'Minimal Animation Time'."), sgb(100)), gid), bJ), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, XGe), ''), 'Layout Ancestors'), 'Whether the hierarchy levels on the path from the selected element to the root of the diagram shall be included in the layout process.'), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, YGe), ''), 'Maximal Animation Time'), 'The maximal time for animations, in milliseconds.'), sgb(4000)), gid), bJ), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, ZGe), ''), 'Minimal Animation Time'), 'The minimal time for animations, in milliseconds.'), sgb(400)), gid), bJ), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, $Ge), ''), 'Progress Bar'), 'Whether a progress bar shall be displayed during layout computations.'), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, _Ge), ''), 'Validate Graph'), 'Whether the graph shall be validated before any layout algorithm is applied. If this option is enabled and at least one error is found, the layout process is aborted and a message is shown to the user.'), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, aHe), ''), 'Validate Options'), 'Whether layout options shall be validated before any layout algorithm is applied. If this option is enabled and at least one error is found, the layout process is aborted and a message is shown to the user.'), true), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, bHe), ''), 'Zoom to Fit'), 'Whether the zoom level shall be set to view the whole diagram after layout.'), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, NGe), 'box'), 'Box Layout Mode'), 'Configures the packing mode used by the {@link BoxLayoutProvider}. If SIMPLE is not required (neither priorities are used nor the interactive mode), GROUP_DEC can improve the packing and decrease the area. GROUP_MIXED and GROUP_INC may, in very specific scenarios, work better.'), Gkd), eid), R3), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, xDe), lDe), 'Comment Comment Spacing'), 'Spacing to be preserved between a comment box and other comment boxes connected to the same node. The space left between comment boxes of different nodes is controlled by the node-node spacing.'), 10), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, yDe), lDe), 'Comment Node Spacing'), 'Spacing to be preserved between a node and its connected comment boxes. The space left between a node and the comments of another node is controlled by the node-node spacing.'), 10), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, Bze), lDe), 'Components Spacing'), "Spacing to be preserved between pairs of connected components. This option is only relevant if 'separateConnectedComponents' is activated."), 20), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, zDe), lDe), 'Edge Spacing'), 'Spacing to be preserved between any two edges. Note that while this can somewhat easily be satisfied for the segments of orthogonally drawn edges, it is harder for general polylines or splines.'), 10), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, aAe), lDe), 'Edge Label Spacing'), "The minimal distance to be preserved between a label and the edge it is associated with. Note that the placement of a label is influenced by the 'edgelabels.placement' option."), 2), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, ADe), lDe), 'Edge Node Spacing'), 'Spacing to be preserved between nodes and edges.'), 10), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, BDe), lDe), 'Label Spacing'), 'Determines the amount of space to be left between two labels of the same graph element.'), 0), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, EDe), lDe), 'Label Node Spacing'), "Spacing to be preserved between labels and the border of node they are associated with. Note that the placement of a label is influenced by the 'nodelabels.placement' option."), 5), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, CDe), lDe), 'Horizontal spacing between Label and Port'), "Horizontal spacing to be preserved between labels and the ports they are associated with. Note that the placement of a label is influenced by the 'portlabels.placement' option."), 1), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, DDe), lDe), 'Vertical spacing between Label and Port'), "Vertical spacing to be preserved between labels and the ports they are associated with. Note that the placement of a label is influenced by the 'portlabels.placement' option."), 1), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, _ze), lDe), 'Node Spacing'), 'The minimal distance to be preserved between each two nodes.'), 20), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, FDe), lDe), 'Node Self Loop Spacing'), 'Spacing to be preserved between a node and its self loops.'), 10), did), VI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, GDe), lDe), 'Port Spacing'), 'Spacing between pairs of ports of the same node.'), 10), did), VI), ysb(Whd, cD(WC(d3, 1), jwe, 170, 0, [
                                Vhd
                            ])))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, HDe), lDe), 'Individual Spacing'), "Allows to specify individual spacing values for graph elements that shall be different from the value specified for the element's parent."), hid), l4), ysb(Vhd, cD(WC(d3, 1), jwe, 170, 0, [
                                Thd,
                                Xhd,
                                Uhd
                            ])))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, hEe), lDe), 'Additional Port Space'), 'Additional space around the sets of ports on each node side. For each side of a node, this option can reserve additional space before and after the ports on each side. For example, a top spacing of 20 makes sure that the first port on the western and eastern side is 20 units away from the northern border.'), imd), hid), h3), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, eEe), hHe), 'Layout Partition'), 'Partition to which the node belongs. This requires Layout Partitioning to be active. Nodes with lower partition IDs will appear to the left of nodes with higher partition IDs (assuming a left-to-right layout direction).'), gid), bJ), ysb(Whd, cD(WC(d3, 1), jwe, 170, 0, [
                                Vhd
                            ])))));
                            zgd(a, eEe, dEe, yld);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, dEe), hHe), 'Layout Partitioning'), 'Whether to activate partitioned layout. This will allow to group nodes through the Layout Partition option. a pair of nodes with different partition indices is then placed such that the node with lower index is placed to the left of the other node (with left-to-right layout direction). Depending on the layout algorithm, this may only be guaranteed to work if all nodes have a layout partition configured, or at least if edges that cross partitions are not part of a partition-crossing cycle.'), wld), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, QDe), iHe), 'Node Label Padding'), 'Define padding for node labels that are placed inside of a node.'), hld), hid), i3), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, kAe), iHe), 'Node Label Placement'), "Hints for where node labels are to be placed; if empty, the node label's position is not modified."), jld), fid), A3), ysb(Vhd, cD(WC(d3, 1), jwe, 170, 0, [
                                Uhd
                            ])))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, TDe), jHe), 'Port Alignment'), 'Defines the default port distribution for a node. May be overridden for each side individually.'), Ald), eid), B3), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, UDe), jHe), 'Port Alignment (North)'), "Defines how ports on the northern side are placed, overriding the node's general port alignment."), eid), B3), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, VDe), jHe), 'Port Alignment (South)'), "Defines how ports on the southern side are placed, overriding the node's general port alignment."), eid), B3), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, WDe), jHe), 'Port Alignment (West)'), "Defines how ports on the western side are placed, overriding the node's general port alignment."), eid), B3), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, XDe), jHe), 'Port Alignment (East)'), "Defines how ports on the eastern side are placed, overriding the node's general port alignment."), eid), B3), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, jAe), kHe), 'Node Size Constraints'), "What should be taken into account when calculating a node's size. Empty size constraints specify that a node's size is already fixed and should not be changed."), lld), fid), H3), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, iAe), kHe), 'Node Size Options'), 'Options modifying the behavior of the size constraints set on a node. Each member of the set specifies something that should be taken into account when calculating node sizes. The empty set corresponds to no further modifications.'), qld), fid), I3), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, CAe), kHe), 'Node Size Minimum'), 'The minimal size to which a node can be reduced.'), old), hid), l3), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, hAe), kHe), 'Fixed Graph Size'), "By default, the fixed layout provider will enlarge a graph until it is large enough to contain its children. If this option is set, it won't do so."), false), cid), QI), xsb(Whd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, $De), vDe), 'Edge Label Placement'), 'Gives a hint on where to put edge labels.'), Rkd), eid), t3), xsb(Uhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, fAe), vDe), 'Inline Edge Labels'), "If true, an edge label is placed directly on its edge. May only apply to center edge labels. This kind of label placement is only advisable if the label's rendering is such that it is not crossed by its edge and thus stays legible."), false), cid), QI), xsb(Uhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, cHe), 'font'), 'Font Name'), 'Font name used for a label.'), iid), qJ), xsb(Uhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, dHe), 'font'), 'Font Size'), 'Font size used for a label.'), gid), bJ), xsb(Uhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, cEe), lHe), 'Port Anchor Offset'), 'The offset to the port position where connections shall be attached.'), hid), l3), xsb(Xhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, _De), lHe), 'Port Index'), "The index of a port in the fixed order around a node. The order is assumed as clockwise, starting with the leftmost port on the top side. This option must be set if 'Port Constraints' is set to FIXED_ORDER and no specific positions are given for the ports. Additionally, the option 'Port Side' must be defined in this case."), gid), bJ), xsb(Xhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, KDe), lHe), 'Port Side'), "The side of a node on which a port is situated. This option must be set if 'Port Constraints' is set to FIXED_SIDE or FIXED_ORDER and no specific positions are given for the ports."), Pld), eid), E3), xsb(Xhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Khd(Ohd(Lhd(Mhd(new Shd, IDe), lHe), 'Port Border Offset'), "The offset of ports on the node border. With a positive offset the port is moved outside of the node, while with a negative offset the port is moved towards the inside. An offset of 0 means that the port is placed directly on the node border, i.e. if the port side is north, the port's south border touches the nodes's north border; if the port side is east, the port's west border touches the nodes's east border; if the port side is south, the port's north border touches the node's south border; if the port side is west, the port's east border touches the node's west border."), did), VI), xsb(Xhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, lAe), mHe), 'Port Label Placement'), "Decides on a placement method for port labels; if empty, the node label's position is not modified."), Mld), fid), D3), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, RDe), mHe), 'Port Labels Next to Port'), "Use 'portLabels.placement': NEXT_TO_PORT_OF_POSSIBLE."), false), cid), QI), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, SDe), mHe), 'Treat Port Labels as Group'), 'If this option is true (default), the labels of a port will be treated as a group when it comes to centering them next to their port. If this option is false, only the first label will be centered next to the port, with the others being placed below. This only applies to labels of eastern and western ports and will have no effect if labels are not placed next to their port.'), true), cid), QI), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, nAe), nHe), 'Topdown Scale Factor'), "The scaling factor to be applied to the nodes laid out within the node in recursive topdown layout. The difference to 'Scale Factor' is that the node itself is not scaled. This value has to be set on hierarchical nodes."), 1), did), VI), xsb(Whd))));
                            zgd(a, nAe, qAe, rmd);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, eHe), nHe), 'Topdown Size Approximator'), 'The size approximator to be used to set sizes of hierarchical nodes during topdown layout. The default value is null, which results in nodes keeping whatever size is defined for them e.g. through parent parallel node or by manually setting the size.'), null), eid), M3), xsb(Vhd))));
                            zgd(a, eHe, qAe, tmd);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, oAe), nHe), 'Topdown Hierarchical Node Width'), 'The fixed size of a hierarchical node when using topdown layout. If this value is set on a parallel node it applies to its children, when set on a hierarchical node it applies to the node itself.'), 150), did), VI), ysb(Whd, cD(WC(d3, 1), jwe, 170, 0, [
                                Vhd
                            ])))));
                            zgd(a, oAe, qAe, null);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, pAe), nHe), 'Topdown Hierarchical Node Aspect Ratio'), 'The fixed aspect ratio of a hierarchical node when using topdown layout. Default is 1/sqrt(2). If this value is set on a parallel node it applies to its children, when set on a hierarchical node it applies to the node itself.'), 1.414), did), VI), ysb(Whd, cD(WC(d3, 1), jwe, 170, 0, [
                                Vhd
                            ])))));
                            zgd(a, pAe, qAe, null);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, qAe), nHe), 'Topdown Node Type'), 'The different node types used for topdown layout. If the node type is set to {@link TopdownNodeTypes.PARALLEL_NODE} the algorithm must be set to a {@link TopdownLayoutProvider} such as {@link TopdownPacking}. The {@link nodeSize.fixedGraphSize} option is technically only required for hierarchical nodes.'), null), eid), J3), xsb(Vhd))));
                            zgd(a, qAe, hAe, null);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, fHe), nHe), 'Topdown Scale Cap'), 'Determines the upper limit for the topdown scale factor. The default value is 1.0 which ensures that nested children never end up appearing larger than their parents in terms of unit sizes such as the font size. If the limit is larger, nodes will fully utilize the available space, but it is counteriniuitive for inner nodes to have a larger scale than outer nodes.'), 1), did), VI), xsb(Whd))));
                            zgd(a, fHe, qAe, pmd);
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, NDe), oHe), 'Activate Inside Self Loops'), "Whether this node allows to route self loops inside of it instead of around it. If set to true, this will make the node a compound node if it isn't already, and will require the layout algorithm to support compound nodes with hierarchical ports."), false), cid), QI), xsb(Vhd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, ODe), oHe), 'Inside Self Loop'), 'Whether a self loop should be routed inside a node instead of around that node.'), false), cid), QI), xsb(Thd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, Cze), 'edge'), 'Edge Thickness'), 'The thickness of an edge. This is a hint on the line width used to draw an edge, possibly requiring more space to be reserved for it.'), 1), did), VI), xsb(Thd))));
                            Egd(a, new Ahd(Qhd(Phd(Rhd(Jhd(Khd(Ohd(Lhd(Mhd(new Shd, gHe), 'edge'), 'Edge Type'), 'The type of an edge. This is usually used for UML class diagrams, where associations must be handled differently from generalizations.'), Vkd), eid), v3), xsb(Thd))));
                            Dgd(a, new fgd(mgd(ogd(ngd(new pgd, sxe), 'Layered'), 'The layer-based method was introduced by Sugiyama, Tagawa and Toda in 1981. It emphasizes the direction of edges by pointing as many edges as possible into the same direction. The nodes are arranged in layers, which are sometimes called "hierarchies", and then reordered such that the number of edge crossings is minimized. Afterwards, concrete coordinates are computed for the nodes and edge bend points.')));
                            Dgd(a, new fgd(mgd(ogd(ngd(new pgd, 'org.eclipse.elk.orthogonal'), 'Orthogonal'), 'Orthogonal methods that follow the "topology-shape-metrics" approach by Batini, Nardelli and Tamassia \'86. The first phase determines the topology of the drawing by applying a planarization technique, which results in a planar representation of the graph. The orthogonal shape is computed in the second phase, which aims at minimizing the number of edge bends, and is called orthogonalization. The third phase leads to concrete coordinates for nodes and edge bend points by applying a compaction method, thus defining the metrics.')));
                            Dgd(a, new fgd(mgd(ogd(ngd(new pgd, Zze), 'Force'), 'Layout algorithms that follow physical analogies by simulating a system of attractive and repulsive forces. The first successful method of this kind was proposed by Eades in 1984.')));
                            Dgd(a, new fgd(mgd(ogd(ngd(new pgd, 'org.eclipse.elk.circle'), 'Circle'), 'Circular layout algorithms emphasize cycles or biconnected components of a graph by arranging them in circles. This is useful if a drawing is desired where such components are clearly grouped, or where cycles are shown as prominent OPTIONS of the graph.')));
                            Dgd(a, new fgd(mgd(ogd(ngd(new pgd, $Ee), 'Tree'), 'Specialized layout methods for trees, i.e. acyclic graphs. The regular structure of graphs that have no undirected cycles can be emphasized using an algorithm of this type.')));
                            Dgd(a, new fgd(mgd(ogd(ngd(new pgd, 'org.eclipse.elk.planar'), 'Planar'), 'Algorithms that require a planar or upward planar graph. Most of these algorithms are theoretically interesting, but not practically usable.')));
                            Dgd(a, new fgd(mgd(ogd(ngd(new pgd, CFe), 'Radial'), 'Radial layout algorithms usually position the nodes of the graph on concentric circles.')));
                            wnd((new xnd, a));
                            ikd((new jkd, a));
                            Gpd((new Hpd, a));
                        };
                        var Akd, Bkd, Ckd, Dkd, Ekd, Fkd, Gkd, Hkd, Ikd, Jkd, Kkd, Lkd, Mkd, Nkd, Okd, Pkd, Qkd, Rkd, Skd, Tkd, Ukd, Vkd, Wkd, Xkd, Ykd, Zkd, $kd, _kd, ald, bld, cld, dld, eld, fld, gld, hld, ild, jld, kld, lld, mld, nld, old, pld, qld, rld, sld, tld, uld, vld, wld, xld, yld, zld, Ald, Bld, Cld, Dld, Eld, Fld, Gld, Hld, Ild, Jld, Kld, Lld, Mld, Nld, Old, Pld, Qld, Rld, Sld, Tld, Uld, Vld, Wld, Xld, Yld, Zld, $ld, _ld, amd, bmd, cmd, dmd, emd, fmd, gmd, hmd, imd, jmd, kmd, lmd, mmd, nmd, omd, pmd, qmd, rmd, smd, tmd;
                        var r3 = sfb(JGe, 'CoreOptions', 699);
                        feb(88, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            88: 1
                        }, Gmd);
                        var xmd, ymd, zmd, Amd, Bmd;
                        var s3 = tfb(JGe, eze, 88, WI, Imd, Hmd);
                        var Jmd;
                        feb(278, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            278: 1
                        }, Pmd);
                        var Lmd, Mmd, Nmd;
                        var t3 = tfb(JGe, 'EdgeLabelPlacement', 278, WI, Rmd, Qmd);
                        var Smd;
                        feb(223, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            223: 1
                        }, Zmd);
                        var Umd, Vmd, Wmd, Xmd;
                        var u3 = tfb(JGe, 'EdgeRouting', 223, WI, _md, $md);
                        var and;
                        feb(321, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            321: 1
                        }, jnd);
                        var cnd, dnd, end, fnd, gnd, hnd;
                        var v3 = tfb(JGe, 'EdgeType', 321, WI, lnd, knd);
                        var mnd;
                        feb(989, 1, Eye, xnd);
                        _.hf = function ynd(a) {
                            wnd(a);
                        };
                        var ond, pnd, qnd, rnd, snd, tnd, und;
                        var x3 = sfb(JGe, 'FixedLayouterOptions', 989);
                        feb(990, 1, {}, znd);
                        _.sf = function And() {
                            var a;
                            return a = new btd, a;
                        };
                        _.tf = function Bnd(a) {};
                        var w3 = sfb(JGe, 'FixedLayouterOptions/FixedFactory', 990);
                        feb(346, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            346: 1
                        }, Gnd);
                        var Cnd, Dnd, End;
                        var y3 = tfb(JGe, 'HierarchyHandling', 346, WI, Ind, Hnd);
                        var Jnd;
                        feb(291, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            291: 1
                        }, Rnd);
                        var Lnd, Mnd, Nnd, Ond;
                        var z3 = tfb(JGe, 'LabelSide', 291, WI, Tnd, Snd);
                        var Und;
                        feb(95, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            95: 1
                        }, eod);
                        var Wnd, Xnd, Ynd, Znd, $nd, _nd, aod, bod, cod;
                        var A3 = tfb(JGe, 'NodeLabelPlacement', 95, WI, hod, god);
                        var iod;
                        feb(256, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            256: 1
                        }, qod);
                        var kod, lod, mod, nod, ood;
                        var B3 = tfb(JGe, 'PortAlignment', 256, WI, sod, rod);
                        var tod;
                        feb(101, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            101: 1
                        }, Eod);
                        var vod, wod, xod, yod, zod, Aod;
                        var C3 = tfb(JGe, 'PortConstraints', 101, WI, God, Fod);
                        var Hod;
                        feb(279, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            279: 1
                        }, Qod);
                        var Jod, Kod, Lod, Mod, Nod, Ood;
                        var D3 = tfb(JGe, 'PortLabelPlacement', 279, WI, Uod, Tod);
                        var Vod;
                        feb(64, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            64: 1
                        }, upd);
                        var Xod, Yod, Zod, $od, _od, apd, bpd, cpd, dpd, epd, fpd, gpd, hpd, ipd, jpd, kpd, lpd, mpd, npd, opd, ppd;
                        var E3 = tfb(JGe, 'PortSide', 64, WI, xpd, wpd);
                        var ypd;
                        feb(993, 1, Eye, Hpd);
                        _.hf = function Ipd(a) {
                            Gpd(a);
                        };
                        var Apd, Bpd, Cpd, Dpd, Epd;
                        var G3 = sfb(JGe, 'RandomLayouterOptions', 993);
                        feb(994, 1, {}, Jpd);
                        _.sf = function Kpd() {
                            var a;
                            return a = new eud, a;
                        };
                        _.tf = function Lpd(a) {};
                        var F3 = sfb(JGe, 'RandomLayouterOptions/RandomFactory', 994);
                        feb(386, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            386: 1
                        }, Rpd);
                        var Mpd, Npd, Opd, Ppd;
                        var H3 = tfb(JGe, 'SizeConstraint', 386, WI, Tpd, Spd);
                        var Upd;
                        feb(264, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            264: 1
                        }, eqd);
                        var Wpd, Xpd, Ypd, Zpd, $pd, _pd, aqd, bqd, cqd;
                        var I3 = tfb(JGe, 'SizeOptions', 264, WI, gqd, fqd);
                        var hqd;
                        feb(280, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            280: 1
                        }, nqd);
                        var jqd, kqd, lqd;
                        var J3 = tfb(JGe, 'TopdownNodeTypes', 280, WI, pqd, oqd);
                        var qqd;
                        feb(347, 22, rHe);
                        var sqd, tqd;
                        var M3 = tfb(JGe, 'TopdownSizeApproximator', 347, WI, xqd, wqd);
                        feb(987, 347, rHe, zqd);
                        _.Tg = function Aqd(a) {
                            return yqd(a);
                        };
                        var K3 = tfb(JGe, 'TopdownSizeApproximator/1', 987, M3, null, null);
                        feb(988, 347, rHe, Bqd);
                        _.Tg = function Cqd(b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
                            c = RD(Gxd(b, (umd(), Tld)), 143);
                            A = (bvd(), o = new ACd, o);
                            zxd(A, b);
                            B = new Tsb;
                            for(g = new dMd((!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a)); g.e != g.i.gc();){
                                e = RD(bMd(g), 27);
                                t = (n = new ACd, n);
                                yCd(t, A);
                                zxd(t, e);
                                D = yqd(e);
                                zyd(t, $wnd.Math.max(e.g, D.a), $wnd.Math.max(e.f, D.b));
                                rtb(B.f, e, t);
                            }
                            for(f = new dMd((!b.a && (b.a = new C5d(J4, b, 10, 11)), b.a)); f.e != f.i.gc();){
                                e = RD(bMd(f), 27);
                                for(l = new dMd((!e.e && (e.e = new Yie(G4, e, 7, 4)), e.e)); l.e != l.i.gc();){
                                    k = RD(bMd(l), 74);
                                    v = RD(Wd(qtb(B.f, e)), 27);
                                    w = RD(Wjb(B, QHd((!k.c && (k.c = new Yie(E4, k, 5, 8)), k.c), 0)), 27);
                                    u = (m = new rzd, m);
                                    WGd((!u.b && (u.b = new Yie(E4, u, 4, 7)), u.b), v);
                                    WGd((!u.c && (u.c = new Yie(E4, u, 5, 8)), u.c), w);
                                    pzd(u, vCd(v));
                                    zxd(u, k);
                                }
                            }
                            q = RD(ltd(c.f), 205);
                            try {
                                q.rf(A, new ztd);
                                mtd(c.f, q);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 103)) {
                                    p = a;
                                    throw Adb(p);
                                } else throw Adb(a);
                            }
                            Hxd(A, Ikd) || Hxd(A, Hkd) || psd(A);
                            j = Kfb(UD(Gxd(A, Ikd)));
                            i = Kfb(UD(Gxd(A, Hkd)));
                            h = j / i;
                            d = Kfb(UD(Gxd(A, lmd))) * $wnd.Math.sqrt((!A.a && (A.a = new C5d(J4, A, 10, 11)), A.a).i);
                            C = RD(Gxd(A, tld), 107);
                            s = C.b + C.c + 1;
                            r = C.d + C.a + 1;
                            return new rjd($wnd.Math.max(s, d), $wnd.Math.max(r, d / h));
                        };
                        var L3 = tfb(JGe, 'TopdownSizeApproximator/2', 988, M3, null, null);
                        var Dqd;
                        feb(344, 1, {
                            871: 1
                        }, Oqd);
                        _.Ug = function Pqd(a, b) {
                            return Fqd(this, a, b);
                        };
                        _.Vg = function Qqd() {
                            Hqd(this);
                        };
                        _.Wg = function Rqd() {
                            return this.q;
                        };
                        _.Xg = function Sqd() {
                            return !this.f ? null : Hob(this.f);
                        };
                        _.Yg = function Tqd() {
                            return Hob(this.a);
                        };
                        _.Zg = function Uqd() {
                            return this.p;
                        };
                        _.$g = function Vqd() {
                            return false;
                        };
                        _._g = function Wqd() {
                            return this.n;
                        };
                        _.ah = function Xqd() {
                            return this.p != null && !this.b;
                        };
                        _.bh = function Yqd(a) {
                            var b;
                            if (this.n) {
                                b = a;
                                Rmb(this.f, b);
                            }
                        };
                        _.dh = function Zqd(a, b) {
                            var c, d;
                            this.n && !!a && Jqd(this, (c = new Zje, d = Rje(c, a), Yje(c), d), (ttd(), qtd));
                        };
                        _.eh = function $qd(a) {
                            var b;
                            if (this.b) return null;
                            else {
                                b = Gqd(this, this.g);
                                Mub(this.a, b);
                                b.i = this;
                                this.d = a;
                                return b;
                            }
                        };
                        _.fh = function _qd(a) {
                            a > 0 && !this.b && Iqd(this, a);
                        };
                        _.b = false;
                        _.c = 0;
                        _.d = -1;
                        _.e = null;
                        _.f = null;
                        _.g = -1;
                        _.j = false;
                        _.k = false;
                        _.n = false;
                        _.o = 0;
                        _.q = 0;
                        _.r = 0;
                        var O3 = sfb(jEe, 'BasicProgressMonitor', 344);
                        feb(717, 205, oze, jrd);
                        _.rf = function nrd(a, b) {
                            crd(a, b);
                        };
                        var V3 = sfb(jEe, 'BoxLayoutProvider', 717);
                        feb(983, 1, fye, prd);
                        _.Ne = function qrd(a, b) {
                            return ord(this, RD(a, 27), RD(b, 27));
                        };
                        _.Fb = function rrd(a) {
                            return this === a;
                        };
                        _.Oe = function srd() {
                            return new Frb(this);
                        };
                        _.a = false;
                        var P3 = sfb(jEe, 'BoxLayoutProvider/1', 983);
                        feb(163, 1, {
                            163: 1
                        }, zrd, Ard);
                        _.Ib = function Brd() {
                            return this.c ? zCd(this.c) : Fe(this.b);
                        };
                        var Q3 = sfb(jEe, 'BoxLayoutProvider/Group', 163);
                        feb(320, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            320: 1
                        }, Hrd);
                        var Crd, Drd, Erd, Frd;
                        var R3 = tfb(jEe, 'BoxLayoutProvider/PackingMode', 320, WI, Jrd, Ird);
                        var Krd;
                        feb(984, 1, fye, Mrd);
                        _.Ne = function Nrd(a, b) {
                            return krd(RD(a, 163), RD(b, 163));
                        };
                        _.Fb = function Ord(a) {
                            return this === a;
                        };
                        _.Oe = function Prd() {
                            return new Frb(this);
                        };
                        var S3 = sfb(jEe, 'BoxLayoutProvider/lambda$0$Type', 984);
                        feb(985, 1, fye, Qrd);
                        _.Ne = function Rrd(a, b) {
                            return lrd(RD(a, 163), RD(b, 163));
                        };
                        _.Fb = function Srd(a) {
                            return this === a;
                        };
                        _.Oe = function Trd() {
                            return new Frb(this);
                        };
                        var T3 = sfb(jEe, 'BoxLayoutProvider/lambda$1$Type', 985);
                        feb(986, 1, fye, Urd);
                        _.Ne = function Vrd(a, b) {
                            return mrd(RD(a, 163), RD(b, 163));
                        };
                        _.Fb = function Wrd(a) {
                            return this === a;
                        };
                        _.Oe = function Xrd() {
                            return new Frb(this);
                        };
                        var U3 = sfb(jEe, 'BoxLayoutProvider/lambda$2$Type', 986);
                        feb(1384, 1, {
                            845: 1
                        }, Yrd);
                        _.Mg = function Zrd(a, b) {
                            return GCc(), !ZD(b, 167) || ued((hed(), ged, RD(a, 167)), b);
                        };
                        var W3 = sfb(jEe, 'ElkSpacings/AbstractSpacingsBuilder/lambda$0$Type', 1384);
                        feb(1385, 1, Qve, $rd);
                        _.Cd = function _rd(a) {
                            JCc(this.a, RD(a, 149));
                        };
                        var X3 = sfb(jEe, 'ElkSpacings/AbstractSpacingsBuilder/lambda$1$Type', 1385);
                        feb(1386, 1, Qve, asd);
                        _.Cd = function bsd(a) {
                            RD(a, 96);
                            GCc();
                        };
                        var Y3 = sfb(jEe, 'ElkSpacings/AbstractSpacingsBuilder/lambda$2$Type', 1386);
                        feb(1390, 1, Qve, csd);
                        _.Cd = function dsd(a) {
                            KCc(this.a, RD(a, 96));
                        };
                        var Z3 = sfb(jEe, 'ElkSpacings/AbstractSpacingsBuilder/lambda$3$Type', 1390);
                        feb(1388, 1, nwe, esd);
                        _.Mb = function fsd(a) {
                            return LCc(this.a, this.b, RD(a, 149));
                        };
                        var $3 = sfb(jEe, 'ElkSpacings/AbstractSpacingsBuilder/lambda$4$Type', 1388);
                        feb(1387, 1, nwe, gsd);
                        _.Mb = function hsd(a) {
                            return NCc(this.a, this.b, RD(a, 845));
                        };
                        var _3 = sfb(jEe, 'ElkSpacings/AbstractSpacingsBuilder/lambda$5$Type', 1387);
                        feb(1389, 1, Qve, isd);
                        _.Cd = function jsd(a) {
                            MCc(this.a, this.b, RD(a, 149));
                        };
                        var a4 = sfb(jEe, 'ElkSpacings/AbstractSpacingsBuilder/lambda$6$Type', 1389);
                        feb(947, 1, {}, Lsd);
                        _.Kb = function Msd(a) {
                            return Ksd(a);
                        };
                        _.Fb = function Nsd(a) {
                            return this === a;
                        };
                        var c4 = sfb(jEe, 'ElkUtil/lambda$0$Type', 947);
                        feb(948, 1, Qve, Osd);
                        _.Cd = function Psd(a) {
                            ysd(this.a, this.b, RD(a, 74));
                        };
                        _.a = 0;
                        _.b = 0;
                        var d4 = sfb(jEe, 'ElkUtil/lambda$1$Type', 948);
                        feb(949, 1, Qve, Qsd);
                        _.Cd = function Rsd(a) {
                            zsd(this.a, this.b, RD(a, 166));
                        };
                        _.a = 0;
                        _.b = 0;
                        var e4 = sfb(jEe, 'ElkUtil/lambda$2$Type', 949);
                        feb(950, 1, Qve, Ssd);
                        _.Cd = function Tsd(a) {
                            Asd(this.a, this.b, RD(a, 135));
                        };
                        _.a = 0;
                        _.b = 0;
                        var f4 = sfb(jEe, 'ElkUtil/lambda$3$Type', 950);
                        feb(951, 1, Qve, Usd);
                        _.Cd = function Vsd(a) {
                            Bsd(this.a, RD(a, 377));
                        };
                        var g4 = sfb(jEe, 'ElkUtil/lambda$4$Type', 951);
                        feb(325, 1, {
                            34: 1,
                            325: 1
                        }, Xsd);
                        _.Fd = function Ysd(a) {
                            return Wsd(this, RD(a, 242));
                        };
                        _.Fb = function Zsd(a) {
                            var b;
                            if (ZD(a, 325)) {
                                b = RD(a, 325);
                                return this.a == b.a;
                            }
                            return false;
                        };
                        _.Hb = function $sd() {
                            return eE(this.a);
                        };
                        _.Ib = function _sd() {
                            return this.a + ' (exclusive)';
                        };
                        _.a = 0;
                        var h4 = sfb(jEe, 'ExclusiveBounds/ExclusiveLowerBound', 325);
                        feb(1119, 205, oze, btd);
                        _.rf = function ctd(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
                            b.Ug('Fixed Layout', 1);
                            f = RD(Gxd(a, (umd(), Skd)), 223);
                            l = 0;
                            m = 0;
                            for(s = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); s.e != s.i.gc();){
                                q = RD(bMd(s), 27);
                                B = RD(Gxd(q, (vnd(), und)), 8);
                                if (B) {
                                    Byd(q, B.a, B.b);
                                    if (RD(Gxd(q, pnd), 181).Hc((Qpd(), Mpd))) {
                                        n = RD(Gxd(q, rnd), 8);
                                        n.a > 0 && n.b > 0 && Esd(q, n.a, n.b, true, true);
                                    }
                                }
                                l = $wnd.Math.max(l, q.i + q.g);
                                m = $wnd.Math.max(m, q.j + q.f);
                                for(j = new dMd((!q.n && (q.n = new C5d(I4, q, 1, 7)), q.n)); j.e != j.i.gc();){
                                    h = RD(bMd(j), 135);
                                    B = RD(Gxd(h, und), 8);
                                    !!B && Byd(h, B.a, B.b);
                                    l = $wnd.Math.max(l, q.i + h.i + h.g);
                                    m = $wnd.Math.max(m, q.j + h.j + h.f);
                                }
                                for(v = new dMd((!q.c && (q.c = new C5d(K4, q, 9, 9)), q.c)); v.e != v.i.gc();){
                                    u = RD(bMd(v), 123);
                                    B = RD(Gxd(u, und), 8);
                                    !!B && Byd(u, B.a, B.b);
                                    w = q.i + u.i;
                                    A = q.j + u.j;
                                    l = $wnd.Math.max(l, w + u.g);
                                    m = $wnd.Math.max(m, A + u.f);
                                    for(i = new dMd((!u.n && (u.n = new C5d(I4, u, 1, 7)), u.n)); i.e != i.i.gc();){
                                        h = RD(bMd(i), 135);
                                        B = RD(Gxd(h, und), 8);
                                        !!B && Byd(h, B.a, B.b);
                                        l = $wnd.Math.max(l, w + h.i + h.g);
                                        m = $wnd.Math.max(m, A + h.j + h.f);
                                    }
                                }
                                for(e = new is(Mr(zGd(q).a.Kc(), new ir)); gs(e);){
                                    c = RD(hs(e), 74);
                                    k = atd(c);
                                    l = $wnd.Math.max(l, k.a);
                                    m = $wnd.Math.max(m, k.b);
                                }
                                for(d = new is(Mr(yGd(q).a.Kc(), new ir)); gs(d);){
                                    c = RD(hs(d), 74);
                                    if (vCd(JGd(c)) != a) {
                                        k = atd(c);
                                        l = $wnd.Math.max(l, k.a);
                                        m = $wnd.Math.max(m, k.b);
                                    }
                                }
                            }
                            if (f == (Ymd(), Umd)) for(r = new dMd((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a)); r.e != r.i.gc();){
                                q = RD(bMd(r), 27);
                                for(d = new is(Mr(zGd(q).a.Kc(), new ir)); gs(d);){
                                    c = RD(hs(d), 74);
                                    g = tsd(c);
                                    g.b == 0 ? Ixd(c, cld, null) : Ixd(c, cld, g);
                                }
                            }
                            if (!Heb(TD(Gxd(a, (vnd(), qnd))))) {
                                t = RD(Gxd(a, snd), 107);
                                p = l + t.b + t.c;
                                o = m + t.d + t.a;
                                Esd(a, p, o, true, true);
                            }
                            b.Vg();
                        };
                        var i4 = sfb(jEe, 'FixedLayoutProvider', 1119);
                        feb(385, 137, {
                            3: 1,
                            423: 1,
                            385: 1,
                            96: 1,
                            137: 1
                        }, dtd, etd);
                        _.cg = function htd(b) {
                            var c, d, e, f, g, h, i, j, k;
                            if (!b) return;
                            try {
                                j = vhb(b, ';,;');
                                for(g = j, h = 0, i = g.length; h < i; ++h){
                                    f = g[h];
                                    d = vhb(f, '\\:');
                                    e = vgd(ygd(), d[0]);
                                    if (!e) throw Adb(new agb('Invalid option id: ' + d[0]));
                                    k = zhd(e, d[1]);
                                    if (k == null) throw Adb(new agb('Invalid option value: ' + d[1]));
                                    k == null ? (!this.q && (this.q = new Tsb), _jb(this.q, e)) : (!this.q && (this.q = new Tsb), Zjb(this.q, e, k));
                                }
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 103)) {
                                    c = a;
                                    throw Adb(new bgb(c));
                                } else throw Adb(a);
                            }
                        };
                        _.Ib = function itd() {
                            var a;
                            a = WD(zDb(GDb((!this.q ? (yob(), yob(), wob) : this.q).vc().Oc(), new jtd), sBb(new hCb, new fCb, new RBb, new TBb, cD(WC(QL, 1), jwe, 108, 0, []))));
                            return a;
                        };
                        var l4 = sfb(jEe, 'IndividualSpacings', 385);
                        feb(982, 1, {}, jtd);
                        _.Kb = function ktd(a) {
                            return gtd(RD(a, 44));
                        };
                        var k4 = sfb(jEe, 'IndividualSpacings/lambda$0$Type', 982);
                        feb(718, 1, {}, ntd);
                        _.c = 0;
                        var m4 = sfb(jEe, 'InstancePool', 718);
                        feb(1835, 1, {}, otd);
                        var o4 = sfb(jEe, 'LoggedGraph', 1835);
                        feb(415, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            415: 1
                        }, utd);
                        var ptd, qtd, rtd, std;
                        var n4 = tfb(jEe, 'LoggedGraph/Type', 415, WI, wtd, vtd);
                        var xtd;
                        feb(1063, 1, {
                            871: 1
                        }, ztd);
                        _.Ug = function Atd(a, b) {
                            return false;
                        };
                        _.Vg = function Btd() {};
                        _.Wg = function Ctd() {
                            return 0;
                        };
                        _.Xg = function Dtd() {
                            return null;
                        };
                        _.Yg = function Etd() {
                            return null;
                        };
                        _.Zg = function Ftd() {
                            return null;
                        };
                        _.$g = function Gtd() {
                            return false;
                        };
                        _._g = function Htd() {
                            return false;
                        };
                        _.ah = function Itd() {
                            return false;
                        };
                        _.bh = function Jtd(a) {};
                        _.dh = function Ktd(a, b) {};
                        _.eh = function Ltd(a) {
                            return this;
                        };
                        _.fh = function Mtd(a) {};
                        var p4 = sfb(jEe, 'NullElkProgressMonitor', 1063);
                        feb(42, 1, {
                            20: 1,
                            42: 1
                        }, Ptd);
                        _.Jc = function Rtd(a) {
                            xgb(this, a);
                        };
                        _.Fb = function Qtd(a) {
                            var b, c, d;
                            if (ZD(a, 42)) {
                                c = RD(a, 42);
                                b = this.a == null ? c.a == null : pb(this.a, c.a);
                                d = this.b == null ? c.b == null : pb(this.b, c.b);
                                return b && d;
                            } else return false;
                        };
                        _.Hb = function Std() {
                            var a, b, c, d, e, f;
                            c = this.a == null ? 0 : tb(this.a);
                            a = c & Bwe;
                            b = c & -65536;
                            f = this.b == null ? 0 : tb(this.b);
                            d = f & Bwe;
                            e = f & -65536;
                            return a ^ e >> 16 & Bwe | b ^ d << 16;
                        };
                        _.Kc = function Ttd() {
                            return new Vtd(this);
                        };
                        _.Ib = function Utd() {
                            return this.a == null && this.b == null ? 'pair(null,null)' : this.a == null ? 'pair(null,' + jeb(this.b) + ')' : this.b == null ? 'pair(' + jeb(this.a) + ',null)' : 'pair(' + jeb(this.a) + ',' + jeb(this.b) + ')';
                        };
                        var r4 = sfb(jEe, 'Pair', 42);
                        feb(995, 1, Ave, Vtd);
                        _.Nb = function Wtd(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function Xtd() {
                            return !this.c && (!this.b && this.a.a != null || this.a.b != null);
                        };
                        _.Pb = function Ytd() {
                            if (!this.c && !this.b && this.a.a != null) {
                                this.b = true;
                                return this.a.a;
                            } else if (!this.c && this.a.b != null) {
                                this.c = true;
                                return this.a.b;
                            }
                            throw Adb(new Dvb);
                        };
                        _.Qb = function Ztd() {
                            this.c && this.a.b != null ? this.a.b = null : this.b && this.a.a != null && (this.a.a = null);
                            throw Adb(new cgb);
                        };
                        _.b = false;
                        _.c = false;
                        var q4 = sfb(jEe, 'Pair/1', 995);
                        feb(455, 1, {
                            455: 1
                        }, $td);
                        _.Fb = function _td(a) {
                            return Fvb(this.a, RD(a, 455).a) && Fvb(this.c, RD(a, 455).c) && Fvb(this.d, RD(a, 455).d) && Fvb(this.b, RD(a, 455).b);
                        };
                        _.Hb = function aud() {
                            return Tnb(cD(WC(jJ, 1), rve, 1, 5, [
                                this.a,
                                this.c,
                                this.d,
                                this.b
                            ]));
                        };
                        _.Ib = function bud() {
                            return '(' + this.a + pve + this.c + pve + this.d + pve + this.b + ')';
                        };
                        var s4 = sfb(jEe, 'Quadruple', 455);
                        feb(1108, 205, oze, eud);
                        _.rf = function fud(a, b) {
                            var c, d, e, f, g;
                            b.Ug('Random Layout', 1);
                            if ((!a.a && (a.a = new C5d(J4, a, 10, 11)), a.a).i == 0) {
                                b.Vg();
                                return;
                            }
                            f = RD(Gxd(a, (Fpd(), Dpd)), 17);
                            !!f && f.a != 0 ? e = new Pwb(f.a) : e = new Owb;
                            c = Mfb(UD(Gxd(a, Apd)));
                            g = Mfb(UD(Gxd(a, Epd)));
                            d = RD(Gxd(a, Bpd), 107);
                            dud(a, e, c, g, d);
                            b.Vg();
                        };
                        var t4 = sfb(jEe, 'RandomLayoutProvider', 1108);
                        feb(240, 1, {
                            240: 1
                        }, gud);
                        _.Fb = function hud(a) {
                            return Fvb(this.a, RD(a, 240).a) && Fvb(this.b, RD(a, 240).b) && Fvb(this.c, RD(a, 240).c);
                        };
                        _.Hb = function iud() {
                            return Tnb(cD(WC(jJ, 1), rve, 1, 5, [
                                this.a,
                                this.b,
                                this.c
                            ]));
                        };
                        _.Ib = function jud() {
                            return '(' + this.a + pve + this.b + pve + this.c + ')';
                        };
                        var u4 = sfb(jEe, 'Triple', 240);
                        var kud;
                        feb(562, 1, {});
                        _.Lf = function oud() {
                            return new rjd(this.f.i, this.f.j);
                        };
                        _.of = function pud(a) {
                            if (hGd(a, (umd(), Gld))) return Gxd(this.f, mud);
                            return Gxd(this.f, a);
                        };
                        _.Mf = function qud() {
                            return new rjd(this.f.g, this.f.f);
                        };
                        _.Nf = function rud() {
                            return this.g;
                        };
                        _.pf = function sud(a) {
                            return Hxd(this.f, a);
                        };
                        _.Of = function tud(a) {
                            Dyd(this.f, a.a);
                            Eyd(this.f, a.b);
                        };
                        _.Pf = function uud(a) {
                            Cyd(this.f, a.a);
                            Ayd(this.f, a.b);
                        };
                        _.Qf = function vud(a) {
                            this.g = a;
                        };
                        _.g = 0;
                        var mud;
                        var v4 = sfb(uHe, 'ElkGraphAdapters/AbstractElkGraphElementAdapter', 562);
                        feb(563, 1, {
                            853: 1
                        }, wud);
                        _.Rf = function xud() {
                            var a, b;
                            if (!this.b) {
                                this.b = fv(iyd(this.a).i);
                                for(b = new dMd(iyd(this.a)); b.e != b.i.gc();){
                                    a = RD(bMd(b), 135);
                                    Rmb(this.b, new Bud(a));
                                }
                            }
                            return this.b;
                        };
                        _.b = null;
                        var w4 = sfb(uHe, 'ElkGraphAdapters/ElkEdgeAdapter', 563);
                        feb(289, 562, {}, zud);
                        _.Sf = function Aud() {
                            return yud(this);
                        };
                        _.a = null;
                        var x4 = sfb(uHe, 'ElkGraphAdapters/ElkGraphAdapter', 289);
                        feb(640, 562, {
                            187: 1
                        }, Bud);
                        var y4 = sfb(uHe, 'ElkGraphAdapters/ElkLabelAdapter', 640);
                        feb(639, 562, {
                            695: 1
                        }, Fud);
                        _.Rf = function Iud() {
                            return Cud(this);
                        };
                        _.Vf = function Jud() {
                            var a;
                            return a = RD(Gxd(this.f, (umd(), eld)), 140), !a && (a = new P2b), a;
                        };
                        _.Xf = function Lud() {
                            return Dud(this);
                        };
                        _.Zf = function Nud(a) {
                            var b;
                            b = new S2b(a);
                            Ixd(this.f, (umd(), eld), b);
                        };
                        _.$f = function Oud(a) {
                            Ixd(this.f, (umd(), tld), new B3b(a));
                        };
                        _.Tf = function Gud() {
                            return this.d;
                        };
                        _.Uf = function Hud() {
                            var a, b;
                            if (!this.a) {
                                this.a = new bnb;
                                for(b = new is(Mr(yGd(RD(this.f, 27)).a.Kc(), new ir)); gs(b);){
                                    a = RD(hs(b), 74);
                                    Rmb(this.a, new wud(a));
                                }
                            }
                            return this.a;
                        };
                        _.Wf = function Kud() {
                            var a, b;
                            if (!this.c) {
                                this.c = new bnb;
                                for(b = new is(Mr(zGd(RD(this.f, 27)).a.Kc(), new ir)); gs(b);){
                                    a = RD(hs(b), 74);
                                    Rmb(this.c, new wud(a));
                                }
                            }
                            return this.c;
                        };
                        _.Yf = function Mud() {
                            return tCd(RD(this.f, 27)).i != 0 || Heb(TD(RD(this.f, 27).of((umd(), $kd))));
                        };
                        _._f = function Pud() {
                            Eud(this, (lud(), kud));
                        };
                        _.a = null;
                        _.b = null;
                        _.c = null;
                        _.d = null;
                        _.e = null;
                        var z4 = sfb(uHe, 'ElkGraphAdapters/ElkNodeAdapter', 639);
                        feb(1284, 562, {
                            852: 1
                        }, Rud);
                        _.Rf = function Tud() {
                            return Qud(this);
                        };
                        _.Uf = function Sud() {
                            var a, b;
                            if (!this.a) {
                                this.a = ev(RD(this.f, 123).hh().i);
                                for(b = new dMd(RD(this.f, 123).hh()); b.e != b.i.gc();){
                                    a = RD(bMd(b), 74);
                                    Rmb(this.a, new wud(a));
                                }
                            }
                            return this.a;
                        };
                        _.Wf = function Uud() {
                            var a, b;
                            if (!this.c) {
                                this.c = ev(RD(this.f, 123).ih().i);
                                for(b = new dMd(RD(this.f, 123).ih()); b.e != b.i.gc();){
                                    a = RD(bMd(b), 74);
                                    Rmb(this.c, new wud(a));
                                }
                            }
                            return this.c;
                        };
                        _.ag = function Vud() {
                            return RD(RD(this.f, 123).of((umd(), Old)), 64);
                        };
                        _.bg = function Wud() {
                            var a, b, c, d, e, f, g, h;
                            d = MCd(RD(this.f, 123));
                            for(c = new dMd(RD(this.f, 123).ih()); c.e != c.i.gc();){
                                a = RD(bMd(c), 74);
                                for(h = new dMd((!a.c && (a.c = new Yie(E4, a, 5, 8)), a.c)); h.e != h.i.gc();){
                                    g = RD(bMd(h), 84);
                                    if (NGd(AGd(g), d)) return true;
                                    else if (AGd(g) == d && Heb(TD(Gxd(a, (umd(), _kd))))) return true;
                                }
                            }
                            for(b = new dMd(RD(this.f, 123).hh()); b.e != b.i.gc();){
                                a = RD(bMd(b), 74);
                                for(f = new dMd((!a.b && (a.b = new Yie(E4, a, 4, 7)), a.b)); f.e != f.i.gc();){
                                    e = RD(bMd(f), 84);
                                    if (NGd(AGd(e), d)) return true;
                                }
                            }
                            return false;
                        };
                        _.a = null;
                        _.b = null;
                        _.c = null;
                        var A4 = sfb(uHe, 'ElkGraphAdapters/ElkPortAdapter', 1284);
                        feb(1285, 1, fye, Yud);
                        _.Ne = function Zud(a, b) {
                            return Xud(RD(a, 123), RD(b, 123));
                        };
                        _.Fb = function $ud(a) {
                            return this === a;
                        };
                        _.Oe = function _ud() {
                            return new Frb(this);
                        };
                        var B4 = sfb(uHe, 'ElkGraphAdapters/PortComparator', 1285);
                        var r7 = ufb(vHe, 'EObject');
                        var C4 = ufb(wHe, xHe);
                        var D4 = ufb(wHe, yHe);
                        var H4 = ufb(wHe, zHe);
                        var L4 = ufb(wHe, 'ElkShape');
                        var E4 = ufb(wHe, AHe);
                        var G4 = ufb(wHe, BHe);
                        var F4 = ufb(wHe, CHe);
                        var p7 = ufb(vHe, DHe);
                        var n7 = ufb(vHe, 'EFactory');
                        var avd;
                        var q7 = ufb(vHe, EHe);
                        var t7 = ufb(vHe, 'EPackage');
                        var cvd;
                        var evd, fvd, gvd, hvd, ivd, jvd, kvd, lvd, mvd, nvd, ovd;
                        var I4 = ufb(wHe, FHe);
                        var J4 = ufb(wHe, GHe);
                        var K4 = ufb(wHe, HHe);
                        feb(93, 1, IHe);
                        _.th = function rvd() {
                            this.uh();
                            return null;
                        };
                        _.uh = function svd() {
                            return null;
                        };
                        _.vh = function tvd() {
                            return this.uh(), false;
                        };
                        _.wh = function uvd() {
                            return false;
                        };
                        _.xh = function vvd(a) {
                            qvd(this, a);
                        };
                        var g6 = sfb(JHe, 'BasicNotifierImpl', 93);
                        feb(99, 93, RHe);
                        _.Yh = function Dwd() {
                            return Mvd(this);
                        };
                        _.yh = function bwd(a, b) {
                            return a;
                        };
                        _.zh = function cwd() {
                            throw Adb(new jib);
                        };
                        _.Ah = function dwd(a) {
                            var b;
                            return b = Z5d(RD(vYd(this.Dh(), this.Fh()), 19)), this.Ph().Th(this, b.n, b.f, a);
                        };
                        _.Bh = function ewd(a, b) {
                            throw Adb(new jib);
                        };
                        _.Ch = function fwd(a, b, c) {
                            return xvd(this, a, b, c);
                        };
                        _.Dh = function gwd() {
                            var a;
                            if (this.zh()) {
                                a = this.zh().Nk();
                                if (a) return a;
                            }
                            return this.ii();
                        };
                        _.Eh = function hwd() {
                            return yvd(this);
                        };
                        _.Fh = function iwd() {
                            throw Adb(new jib);
                        };
                        _.Gh = function kwd() {
                            var a, b;
                            b = this.$h().Ok();
                            !b && this.zh().Tk(b = (N2d(), a = P$d(rYd(this.Dh())), a == null ? M2d : new Q2d(this, a)));
                            return b;
                        };
                        _.Hh = function mwd(a, b) {
                            return a;
                        };
                        _.Ih = function nwd(a) {
                            var b;
                            b = a.pk();
                            return !b ? BYd(this.Dh(), a) : a.Lj();
                        };
                        _.Jh = function owd() {
                            var a;
                            a = this.zh();
                            return !a ? null : a.Qk();
                        };
                        _.Kh = function pwd() {
                            return !this.zh() ? null : this.zh().Nk();
                        };
                        _.Lh = function qwd(a, b, c) {
                            return Dvd(this, a, b, c);
                        };
                        _.Mh = function rwd(a) {
                            return Evd(this, a);
                        };
                        _.Nh = function swd(a, b) {
                            return Fvd(this, a, b);
                        };
                        _.Oh = function twd() {
                            var a;
                            a = this.zh();
                            return !!a && a.Rk();
                        };
                        _.Ph = function uwd() {
                            throw Adb(new jib);
                        };
                        _.Qh = function vwd() {
                            return Hvd(this);
                        };
                        _.Rh = function wwd(a, b, c, d) {
                            return Ivd(this, a, b, d);
                        };
                        _.Sh = function xwd(a, b, c) {
                            var d;
                            return d = RD(vYd(this.Dh(), b), 69), d.wk().zk(this, this.hi(), b - this.ji(), a, c);
                        };
                        _.Th = function ywd(a, b, c, d) {
                            return Jvd(this, a, b, d);
                        };
                        _.Uh = function zwd(a, b, c) {
                            var d;
                            return d = RD(vYd(this.Dh(), b), 69), d.wk().Ak(this, this.hi(), b - this.ji(), a, c);
                        };
                        _.Vh = function Awd() {
                            return !!this.zh() && !!this.zh().Pk();
                        };
                        _.Wh = function Bwd(a) {
                            return Kvd(this, a);
                        };
                        _.Xh = function Cwd(a) {
                            return Lvd(this, a);
                        };
                        _.Zh = function Ewd(a) {
                            return Pvd(this, a);
                        };
                        _.$h = function Fwd() {
                            throw Adb(new jib);
                        };
                        _._h = function Gwd() {
                            return !this.zh() ? null : this.zh().Pk();
                        };
                        _.ai = function Hwd() {
                            return Hvd(this);
                        };
                        _.bi = function Iwd(a, b) {
                            Wvd(this, a, b);
                        };
                        _.ci = function Jwd(a) {
                            this.$h().Sk(a);
                        };
                        _.di = function Kwd(a) {
                            this.$h().Vk(a);
                        };
                        _.ei = function Lwd(a) {
                            this.$h().Uk(a);
                        };
                        _.fi = function Mwd(a, b) {
                            var c, d, e, f;
                            f = this.Jh();
                            if (!!f && !!a) {
                                b = rLd(f.El(), this, b);
                                f.Il(this);
                            }
                            d = this.Ph();
                            if (d) {
                                if ((jwd(this, this.Ph(), this.Fh()).Bb & txe) != 0) {
                                    e = d.Qh();
                                    !!e && (!a ? e.Hl(this) : !f && e.Il(this));
                                } else {
                                    b = (c = this.Fh(), c >= 0 ? this.Ah(b) : this.Ph().Th(this, -1 - c, null, b));
                                    b = this.Ch(null, -1, b);
                                }
                            }
                            this.di(a);
                            return b;
                        };
                        _.gi = function Nwd(a) {
                            var b, c, d, e, f, g, h, i;
                            c = this.Dh();
                            f = BYd(c, a);
                            b = this.ji();
                            if (f >= b) return RD(a, 69).wk().Dk(this, this.hi(), f - b);
                            else if (f <= -1) {
                                g = Eee((lke(), jke), c, a);
                                if (g) {
                                    nke();
                                    RD(g, 69).xk() || (g = zfe(Qee(jke, g)));
                                    e = (d = this.Ih(g), RD(d >= 0 ? this.Lh(d, true, true) : Qvd(this, g, true), 160));
                                    i = g.Ik();
                                    if (i > 1 || i == -1) return RD(RD(e, 220).Sl(a, false), 79);
                                } else throw Adb(new agb(KHe + a.xe() + NHe));
                            } else if (a.Jk()) return d = this.Ih(a), RD(d >= 0 ? this.Lh(d, false, true) : Qvd(this, a, false), 79);
                            h = new NTd(this, a);
                            return h;
                        };
                        _.hi = function Owd() {
                            return Yvd(this);
                        };
                        _.ii = function Pwd() {
                            return (lTd(), kTd).S;
                        };
                        _.ji = function Qwd() {
                            return AYd(this.ii());
                        };
                        _.ki = function Rwd(a) {
                            $vd(this, a);
                        };
                        _.Ib = function Swd() {
                            return awd(this);
                        };
                        var G7 = sfb(SHe, 'BasicEObjectImpl', 99);
                        var ZSd;
                        feb(119, 99, {
                            110: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            119: 1
                        });
                        _.li = function _wd(a) {
                            var b;
                            b = Vwd(this);
                            return b[a];
                        };
                        _.mi = function axd(a, b) {
                            var c;
                            c = Vwd(this);
                            bD(c, a, b);
                        };
                        _.ni = function bxd(a) {
                            var b;
                            b = Vwd(this);
                            bD(b, a, null);
                        };
                        _.th = function cxd() {
                            return RD(Ywd(this, 4), 129);
                        };
                        _.uh = function dxd() {
                            throw Adb(new jib);
                        };
                        _.vh = function exd() {
                            return (this.Db & 4) != 0;
                        };
                        _.zh = function fxd() {
                            throw Adb(new jib);
                        };
                        _.oi = function gxd(a) {
                            $wd(this, 2, a);
                        };
                        _.Bh = function hxd(a, b) {
                            this.Db = b << 16 | this.Db & 255;
                            this.oi(a);
                        };
                        _.Dh = function ixd() {
                            return Uwd(this);
                        };
                        _.Fh = function jxd() {
                            return this.Db >> 16;
                        };
                        _.Gh = function kxd() {
                            var a, b;
                            return N2d(), b = P$d(rYd((a = RD(Ywd(this, 16), 29), !a ? this.ii() : a))), b == null ? M2d : new Q2d(this, b);
                        };
                        _.wh = function lxd() {
                            return (this.Db & 1) == 0;
                        };
                        _.Jh = function mxd() {
                            return RD(Ywd(this, 128), 2034);
                        };
                        _.Kh = function nxd() {
                            return RD(Ywd(this, 16), 29);
                        };
                        _.Oh = function oxd() {
                            return (this.Db & 32) != 0;
                        };
                        _.Ph = function pxd() {
                            return RD(Ywd(this, 2), 54);
                        };
                        _.Vh = function qxd() {
                            return (this.Db & 64) != 0;
                        };
                        _.$h = function rxd() {
                            throw Adb(new jib);
                        };
                        _._h = function sxd() {
                            return RD(Ywd(this, 64), 288);
                        };
                        _.ci = function txd(a) {
                            $wd(this, 16, a);
                        };
                        _.di = function uxd(a) {
                            $wd(this, 128, a);
                        };
                        _.ei = function vxd(a) {
                            $wd(this, 64, a);
                        };
                        _.hi = function wxd() {
                            return Wwd(this);
                        };
                        _.Db = 0;
                        var xab = sfb(SHe, 'MinimalEObjectImpl', 119);
                        feb(120, 119, {
                            110: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            119: 1,
                            120: 1
                        });
                        _.oi = function xxd(a) {
                            this.Cb = a;
                        };
                        _.Ph = function yxd() {
                            return this.Cb;
                        };
                        var wab = sfb(SHe, 'MinimalEObjectImpl/Container', 120);
                        feb(2083, 120, {
                            110: 1,
                            342: 1,
                            96: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            119: 1,
                            120: 1
                        });
                        _.Lh = function Jxd(a, b, c) {
                            return Axd(this, a, b, c);
                        };
                        _.Uh = function Kxd(a, b, c) {
                            return Bxd(this, a, b, c);
                        };
                        _.Wh = function Lxd(a) {
                            return Cxd(this, a);
                        };
                        _.bi = function Mxd(a, b) {
                            Dxd(this, a, b);
                        };
                        _.ii = function Nxd() {
                            return pvd(), ovd;
                        };
                        _.ki = function Oxd(a) {
                            Exd(this, a);
                        };
                        _.nf = function Pxd() {
                            return Fxd(this);
                        };
                        _.gh = function Qxd() {
                            return !this.o && (this.o = new DVd((pvd(), mvd), X4, this, 0)), this.o;
                        };
                        _.of = function Rxd(a) {
                            return Gxd(this, a);
                        };
                        _.pf = function Sxd(a) {
                            return Hxd(this, a);
                        };
                        _.qf = function Txd(a, b) {
                            return Ixd(this, a, b);
                        };
                        var M4 = sfb(THe, 'EMapPropertyHolderImpl', 2083);
                        feb(572, 120, {
                            110: 1,
                            377: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            119: 1,
                            120: 1
                        }, Xxd);
                        _.Lh = function Yxd(a, b, c) {
                            switch(a){
                                case 0:
                                    return this.a;
                                case 1:
                                    return this.b;
                            }
                            return Dvd(this, a, b, c);
                        };
                        _.Wh = function Zxd(a) {
                            switch(a){
                                case 0:
                                    return this.a != 0;
                                case 1:
                                    return this.b != 0;
                            }
                            return Kvd(this, a);
                        };
                        _.bi = function $xd(a, b) {
                            switch(a){
                                case 0:
                                    Vxd(this, Kfb(UD(b)));
                                    return;
                                case 1:
                                    Wxd(this, Kfb(UD(b)));
                                    return;
                            }
                            Wvd(this, a, b);
                        };
                        _.ii = function _xd() {
                            return pvd(), evd;
                        };
                        _.ki = function ayd(a) {
                            switch(a){
                                case 0:
                                    Vxd(this, 0);
                                    return;
                                case 1:
                                    Wxd(this, 0);
                                    return;
                            }
                            $vd(this, a);
                        };
                        _.Ib = function byd() {
                            var a;
                            if ((this.Db & 64) != 0) return awd(this);
                            a = new Shb(awd(this));
                            a.a += ' (x: ';
                            Khb(a, this.a);
                            a.a += ', y: ';
                            Khb(a, this.b);
                            a.a += ')';
                            return a.a;
                        };
                        _.a = 0;
                        _.b = 0;
                        var N4 = sfb(THe, 'ElkBendPointImpl', 572);
                        feb(739, 2083, {
                            110: 1,
                            342: 1,
                            167: 1,
                            96: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            119: 1,
                            120: 1
                        });
                        _.Lh = function lyd(a, b, c) {
                            return cyd(this, a, b, c);
                        };
                        _.Sh = function myd(a, b, c) {
                            return dyd(this, a, b, c);
                        };
                        _.Uh = function nyd(a, b, c) {
                            return eyd(this, a, b, c);
                        };
                        _.Wh = function oyd(a) {
                            return fyd(this, a);
                        };
                        _.bi = function pyd(a, b) {
                            gyd(this, a, b);
                        };
                        _.ii = function qyd() {
                            return pvd(), ivd;
                        };
                        _.ki = function ryd(a) {
                            hyd(this, a);
                        };
                        _.jh = function syd() {
                            return this.k;
                        };
                        _.kh = function tyd() {
                            return iyd(this);
                        };
                        _.Ib = function uyd() {
                            return kyd(this);
                        };
                        _.k = null;
                        var R4 = sfb(THe, 'ElkGraphElementImpl', 739);
                        feb(740, 739, {
                            110: 1,
                            342: 1,
                            167: 1,
                            422: 1,
                            96: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            119: 1,
                            120: 1
                        });
                        _.Lh = function Gyd(a, b, c) {
                            return vyd(this, a, b, c);
                        };
                        _.Wh = function Hyd(a) {
                            return wyd(this, a);
                        };
                        _.bi = function Iyd(a, b) {
                            xyd(this, a, b);
                        };
                        _.ii = function Jyd() {
                            return pvd(), nvd;
                        };
                        _.ki = function Kyd(a) {
                            yyd(this, a);
                        };
                        _.lh = function Lyd() {
                            return this.f;
                        };
                        _.mh = function Myd() {
                            return this.g;
                        };
                        _.nh = function Nyd() {
                            return this.i;
                        };
                        _.oh = function Oyd() {
                            return this.j;
                        };
                        _.ph = function Pyd(a, b) {
                            zyd(this, a, b);
                        };
                        _.qh = function Qyd(a, b) {
                            Byd(this, a, b);
                        };
                        _.rh = function Ryd(a) {
                            Dyd(this, a);
                        };
                        _.sh = function Syd(a) {
                            Eyd(this, a);
                        };
                        _.Ib = function Tyd() {
                            return Fyd(this);
                        };
                        _.f = 0;
                        _.g = 0;
                        _.i = 0;
                        _.j = 0;
                        var Y4 = sfb(THe, 'ElkShapeImpl', 740);
                        feb(741, 740, {
                            110: 1,
                            342: 1,
                            84: 1,
                            167: 1,
                            422: 1,
                            96: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            119: 1,
                            120: 1
                        });
                        _.Lh = function _yd(a, b, c) {
                            return Uyd(this, a, b, c);
                        };
                        _.Sh = function azd(a, b, c) {
                            return Vyd(this, a, b, c);
                        };
                        _.Uh = function bzd(a, b, c) {
                            return Wyd(this, a, b, c);
                        };
                        _.Wh = function czd(a) {
                            return Xyd(this, a);
                        };
                        _.bi = function dzd(a, b) {
                            Yyd(this, a, b);
                        };
                        _.ii = function ezd() {
                            return pvd(), fvd;
                        };
                        _.ki = function fzd(a) {
                            Zyd(this, a);
                        };
                        _.hh = function gzd() {
                            return !this.d && (this.d = new Yie(G4, this, 8, 5)), this.d;
                        };
                        _.ih = function hzd() {
                            return !this.e && (this.e = new Yie(G4, this, 7, 4)), this.e;
                        };
                        var O4 = sfb(THe, 'ElkConnectableShapeImpl', 741);
                        feb(326, 739, {
                            110: 1,
                            342: 1,
                            74: 1,
                            167: 1,
                            326: 1,
                            96: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            119: 1,
                            120: 1
                        }, rzd);
                        _.Ah = function szd(a) {
                            return jzd(this, a);
                        };
                        _.Lh = function tzd(a, b, c) {
                            switch(a){
                                case 3:
                                    return kzd(this);
                                case 4:
                                    return !this.b && (this.b = new Yie(E4, this, 4, 7)), this.b;
                                case 5:
                                    return !this.c && (this.c = new Yie(E4, this, 5, 8)), this.c;
                                case 6:
                                    return !this.a && (this.a = new C5d(F4, this, 6, 6)), this.a;
                                case 7:
                                    return Geb(), !this.b && (this.b = new Yie(E4, this, 4, 7)), this.b.i <= 1 && (!this.c && (this.c = new Yie(E4, this, 5, 8)), this.c.i <= 1) ? false : true;
                                case 8:
                                    return Geb(), nzd(this) ? true : false;
                                case 9:
                                    return Geb(), ozd(this) ? true : false;
                                case 10:
                                    return Geb(), !this.b && (this.b = new Yie(E4, this, 4, 7)), this.b.i != 0 && (!this.c && (this.c = new Yie(E4, this, 5, 8)), this.c.i != 0) ? true : false;
                            }
                            return cyd(this, a, b, c);
                        };
                        _.Sh = function uzd(a, b, c) {
                            var d;
                            switch(b){
                                case 3:
                                    !!this.Cb && (c = (d = this.Db >> 16, d >= 0 ? jzd(this, c) : this.Cb.Th(this, -1 - d, null, c)));
                                    return izd(this, RD(a, 27), c);
                                case 4:
                                    return !this.b && (this.b = new Yie(E4, this, 4, 7)), qLd(this.b, a, c);
                                case 5:
                                    return !this.c && (this.c = new Yie(E4, this, 5, 8)), qLd(this.c, a, c);
                                case 6:
                                    return !this.a && (this.a = new C5d(F4, this, 6, 6)), qLd(this.a, a, c);
                            }
                            return dyd(this, a, b, c);
                        };
                        _.Uh = function vzd(a, b, c) {
                            switch(b){
                                case 3:
                                    return izd(this, null, c);
                                case 4:
                                    return !this.b && (this.b = new Yie(E4, this, 4, 7)), rLd(this.b, a, c);
                                case 5:
                                    return !this.c && (this.c = new Yie(E4, this, 5, 8)), rLd(this.c, a, c);
                                case 6:
                                    return !this.a && (this.a = new C5d(F4, this, 6, 6)), rLd(this.a, a, c);
                            }
                            return eyd(this, a, b, c);
                        };
                        _.Wh = function wzd(a) {
                            switch(a){
                                case 3:
                                    return !!kzd(this);
                                case 4:
                                    return !!this.b && this.b.i != 0;
                                case 5:
                                    return !!this.c && this.c.i != 0;
                                case 6:
                                    return !!this.a && this.a.i != 0;
                                case 7:
                                    return !this.b && (this.b = new Yie(E4, this, 4, 7)), !(this.b.i <= 1 && (!this.c && (this.c = new Yie(E4, this, 5, 8)), this.c.i <= 1));
                                case 8:
                                    return nzd(this);
                                case 9:
                                    return ozd(this);
                                case 10:
                                    return !this.b && (this.b = new Yie(E4, this, 4, 7)), this.b.i != 0 && (!this.c && (this.c = new Yie(E4, this, 5, 8)), this.c.i != 0);
                            }
                            return fyd(this, a);
                        };
                        _.bi = function xzd(a, b) {
                            switch(a){
                                case 3:
                                    pzd(this, RD(b, 27));
                                    return;
                                case 4:
                                    !this.b && (this.b = new Yie(E4, this, 4, 7));
                                    sLd(this.b);
                                    !this.b && (this.b = new Yie(E4, this, 4, 7));
                                    YGd(this.b, RD(b, 16));
                                    return;
                                case 5:
                                    !this.c && (this.c = new Yie(E4, this, 5, 8));
                                    sLd(this.c);
                                    !this.c && (this.c = new Yie(E4, this, 5, 8));
                                    YGd(this.c, RD(b, 16));
                                    return;
                                case 6:
                                    !this.a && (this.a = new C5d(F4, this, 6, 6));
                                    sLd(this.a);
                                    !this.a && (this.a = new C5d(F4, this, 6, 6));
                                    YGd(this.a, RD(b, 16));
                                    return;
                            }
                            gyd(this, a, b);
                        };
                        _.ii = function yzd() {
                            return pvd(), gvd;
                        };
                        _.ki = function zzd(a) {
                            switch(a){
                                case 3:
                                    pzd(this, null);
                                    return;
                                case 4:
                                    !this.b && (this.b = new Yie(E4, this, 4, 7));
                                    sLd(this.b);
                                    return;
                                case 5:
                                    !this.c && (this.c = new Yie(E4, this, 5, 8));
                                    sLd(this.c);
                                    return;
                                case 6:
                                    !this.a && (this.a = new C5d(F4, this, 6, 6));
                                    sLd(this.a);
                                    return;
                            }
                            hyd(this, a);
                        };
                        _.Ib = function Azd() {
                            return qzd(this);
                        };
                        var P4 = sfb(THe, 'ElkEdgeImpl', 326);
                        feb(452, 2083, {
                            110: 1,
                            342: 1,
                            166: 1,
                            452: 1,
                            96: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            119: 1,
                            120: 1
                        }, Rzd);
                        _.Ah = function Szd(a) {
                            return Czd(this, a);
                        };
                        _.Lh = function Tzd(a, b, c) {
                            switch(a){
                                case 1:
                                    return this.j;
                                case 2:
                                    return this.k;
                                case 3:
                                    return this.b;
                                case 4:
                                    return this.c;
                                case 5:
                                    return !this.a && (this.a = new XZd(D4, this, 5)), this.a;
                                case 6:
                                    return Fzd(this);
                                case 7:
                                    if (b) return Ezd(this);
                                    return this.i;
                                case 8:
                                    if (b) return Dzd(this);
                                    return this.f;
                                case 9:
                                    return !this.g && (this.g = new Yie(F4, this, 9, 10)), this.g;
                                case 10:
                                    return !this.e && (this.e = new Yie(F4, this, 10, 9)), this.e;
                                case 11:
                                    return this.d;
                            }
                            return Axd(this, a, b, c);
                        };
                        _.Sh = function Uzd(a, b, c) {
                            var d, e, f;
                            switch(b){
                                case 6:
                                    !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? Czd(this, c) : this.Cb.Th(this, -1 - e, null, c)));
                                    return Bzd(this, RD(a, 74), c);
                                case 9:
                                    return !this.g && (this.g = new Yie(F4, this, 9, 10)), qLd(this.g, a, c);
                                case 10:
                                    return !this.e && (this.e = new Yie(F4, this, 10, 9)), qLd(this.e, a, c);
                            }
                            return f = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (pvd(), hvd) : d), b), 69), f.wk().zk(this, Wwd(this), b - AYd((pvd(), hvd)), a, c);
                        };
                        _.Uh = function Vzd(a, b, c) {
                            switch(b){
                                case 5:
                                    return !this.a && (this.a = new XZd(D4, this, 5)), rLd(this.a, a, c);
                                case 6:
                                    return Bzd(this, null, c);
                                case 9:
                                    return !this.g && (this.g = new Yie(F4, this, 9, 10)), rLd(this.g, a, c);
                                case 10:
                                    return !this.e && (this.e = new Yie(F4, this, 10, 9)), rLd(this.e, a, c);
                            }
                            return Bxd(this, a, b, c);
                        };
                        _.Wh = function Wzd(a) {
                            switch(a){
                                case 1:
                                    return this.j != 0;
                                case 2:
                                    return this.k != 0;
                                case 3:
                                    return this.b != 0;
                                case 4:
                                    return this.c != 0;
                                case 5:
                                    return !!this.a && this.a.i != 0;
                                case 6:
                                    return !!Fzd(this);
                                case 7:
                                    return !!this.i;
                                case 8:
                                    return !!this.f;
                                case 9:
                                    return !!this.g && this.g.i != 0;
                                case 10:
                                    return !!this.e && this.e.i != 0;
                                case 11:
                                    return this.d != null;
                            }
                            return Cxd(this, a);
                        };
                        _.bi = function Xzd(a, b) {
                            switch(a){
                                case 1:
                                    Ozd(this, Kfb(UD(b)));
                                    return;
                                case 2:
                                    Pzd(this, Kfb(UD(b)));
                                    return;
                                case 3:
                                    Hzd(this, Kfb(UD(b)));
                                    return;
                                case 4:
                                    Izd(this, Kfb(UD(b)));
                                    return;
                                case 5:
                                    !this.a && (this.a = new XZd(D4, this, 5));
                                    sLd(this.a);
                                    !this.a && (this.a = new XZd(D4, this, 5));
                                    YGd(this.a, RD(b, 16));
                                    return;
                                case 6:
                                    Mzd(this, RD(b, 74));
                                    return;
                                case 7:
                                    Lzd(this, RD(b, 84));
                                    return;
                                case 8:
                                    Kzd(this, RD(b, 84));
                                    return;
                                case 9:
                                    !this.g && (this.g = new Yie(F4, this, 9, 10));
                                    sLd(this.g);
                                    !this.g && (this.g = new Yie(F4, this, 9, 10));
                                    YGd(this.g, RD(b, 16));
                                    return;
                                case 10:
                                    !this.e && (this.e = new Yie(F4, this, 10, 9));
                                    sLd(this.e);
                                    !this.e && (this.e = new Yie(F4, this, 10, 9));
                                    YGd(this.e, RD(b, 16));
                                    return;
                                case 11:
                                    Jzd(this, WD(b));
                                    return;
                            }
                            Dxd(this, a, b);
                        };
                        _.ii = function Yzd() {
                            return pvd(), hvd;
                        };
                        _.ki = function Zzd(a) {
                            switch(a){
                                case 1:
                                    Ozd(this, 0);
                                    return;
                                case 2:
                                    Pzd(this, 0);
                                    return;
                                case 3:
                                    Hzd(this, 0);
                                    return;
                                case 4:
                                    Izd(this, 0);
                                    return;
                                case 5:
                                    !this.a && (this.a = new XZd(D4, this, 5));
                                    sLd(this.a);
                                    return;
                                case 6:
                                    Mzd(this, null);
                                    return;
                                case 7:
                                    Lzd(this, null);
                                    return;
                                case 8:
                                    Kzd(this, null);
                                    return;
                                case 9:
                                    !this.g && (this.g = new Yie(F4, this, 9, 10));
                                    sLd(this.g);
                                    return;
                                case 10:
                                    !this.e && (this.e = new Yie(F4, this, 10, 9));
                                    sLd(this.e);
                                    return;
                                case 11:
                                    Jzd(this, null);
                                    return;
                            }
                            Exd(this, a);
                        };
                        _.Ib = function $zd() {
                            return Qzd(this);
                        };
                        _.b = 0;
                        _.c = 0;
                        _.d = null;
                        _.j = 0;
                        _.k = 0;
                        var Q4 = sfb(THe, 'ElkEdgeSectionImpl', 452);
                        feb(158, 120, {
                            110: 1,
                            94: 1,
                            93: 1,
                            155: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            119: 1,
                            120: 1
                        });
                        _.Lh = function cAd(a, b, c) {
                            var d;
                            if (a == 0) return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                            return zvd(this, a - AYd(this.ii()), vYd((d = RD(Ywd(this, 16), 29), !d ? this.ii() : d), a), b, c);
                        };
                        _.Sh = function dAd(a, b, c) {
                            var d, e;
                            if (b == 0) return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), qLd(this.Ab, a, c);
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? this.ii() : d), b), 69), e.wk().zk(this, Wwd(this), b - AYd(this.ii()), a, c);
                        };
                        _.Uh = function eAd(a, b, c) {
                            var d, e;
                            if (b == 0) return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), rLd(this.Ab, a, c);
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? this.ii() : d), b), 69), e.wk().Ak(this, Wwd(this), b - AYd(this.ii()), a, c);
                        };
                        _.Wh = function fAd(a) {
                            var b;
                            if (a == 0) return !!this.Ab && this.Ab.i != 0;
                            return Avd(this, a - AYd(this.ii()), vYd((b = RD(Ywd(this, 16), 29), !b ? this.ii() : b), a));
                        };
                        _.Zh = function gAd(a) {
                            return _zd(this, a);
                        };
                        _.bi = function hAd(a, b) {
                            var c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                            }
                            Bvd(this, a - AYd(this.ii()), vYd((c = RD(Ywd(this, 16), 29), !c ? this.ii() : c), a), b);
                        };
                        _.di = function iAd(a) {
                            $wd(this, 128, a);
                        };
                        _.ii = function jAd() {
                            return JTd(), xTd;
                        };
                        _.ki = function kAd(a) {
                            var b;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                            }
                            Cvd(this, a - AYd(this.ii()), vYd((b = RD(Ywd(this, 16), 29), !b ? this.ii() : b), a));
                        };
                        _.pi = function lAd() {
                            this.Bb |= 1;
                        };
                        _.qi = function mAd(a) {
                            return bAd(this, a);
                        };
                        _.Bb = 0;
                        var k8 = sfb(SHe, 'EModelElementImpl', 158);
                        feb(720, 158, {
                            110: 1,
                            94: 1,
                            93: 1,
                            480: 1,
                            155: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            119: 1,
                            120: 1
                        }, yAd);
                        _.ri = function zAd(a, b) {
                            return tAd(this, a, b);
                        };
                        _.si = function AAd(a) {
                            var b, c, d, e, f;
                            if (this.a != BXd(a) || (a.Bb & 256) != 0) throw Adb(new agb(ZHe + a.zb + WHe));
                            for(d = zYd(a); tYd(d.a).i != 0;){
                                c = RD(N_d(d, 0, (b = RD(QHd(tYd(d.a), 0), 89), f = b.c, ZD(f, 90) ? RD(f, 29) : (JTd(), zTd))), 29);
                                if (DXd(c)) {
                                    e = BXd(c).wi().si(c);
                                    RD(e, 54).ci(a);
                                    return e;
                                }
                                d = zYd(c);
                            }
                            return (a.D != null ? a.D : a.B) == 'java.util.Map$Entry' ? new LUd(a) : new zUd(a);
                        };
                        _.ti = function BAd(a, b) {
                            return uAd(this, a, b);
                        };
                        _.Lh = function CAd(a, b, c) {
                            var d;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.a;
                            }
                            return zvd(this, a - AYd((JTd(), uTd)), vYd((d = RD(Ywd(this, 16), 29), !d ? uTd : d), a), b, c);
                        };
                        _.Sh = function DAd(a, b, c) {
                            var d, e;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), qLd(this.Ab, a, c);
                                case 1:
                                    !!this.a && (c = RD(this.a, 54).Th(this, 4, t7, c));
                                    return rAd(this, RD(a, 241), c);
                            }
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), uTd) : d), b), 69), e.wk().zk(this, Wwd(this), b - AYd((JTd(), uTd)), a, c);
                        };
                        _.Uh = function EAd(a, b, c) {
                            var d, e;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), rLd(this.Ab, a, c);
                                case 1:
                                    return rAd(this, null, c);
                            }
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), uTd) : d), b), 69), e.wk().Ak(this, Wwd(this), b - AYd((JTd(), uTd)), a, c);
                        };
                        _.Wh = function FAd(a) {
                            var b;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return !!this.a;
                            }
                            return Avd(this, a - AYd((JTd(), uTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? uTd : b), a));
                        };
                        _.bi = function GAd(a, b) {
                            var c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                                case 1:
                                    wAd(this, RD(b, 241));
                                    return;
                            }
                            Bvd(this, a - AYd((JTd(), uTd)), vYd((c = RD(Ywd(this, 16), 29), !c ? uTd : c), a), b);
                        };
                        _.ii = function HAd() {
                            return JTd(), uTd;
                        };
                        _.ki = function IAd(a) {
                            var b;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                                case 1:
                                    wAd(this, null);
                                    return;
                            }
                            Cvd(this, a - AYd((JTd(), uTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? uTd : b), a));
                        };
                        var nAd, oAd, pAd;
                        var i8 = sfb(SHe, 'EFactoryImpl', 720);
                        feb(1037, 720, {
                            110: 1,
                            2113: 1,
                            94: 1,
                            93: 1,
                            480: 1,
                            155: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            119: 1,
                            120: 1
                        }, KAd);
                        _.ri = function LAd(a, b) {
                            switch(a.hk()){
                                case 12:
                                    return RD(b, 149).Pg();
                                case 13:
                                    return jeb(b);
                                default:
                                    throw Adb(new agb(VHe + a.xe() + WHe));
                            }
                        };
                        _.si = function MAd(a) {
                            var b, c, d, e, f, g, h, i;
                            switch(a.G == -1 && (a.G = (b = BXd(a), b ? fZd(b.vi(), a) : -1)), a.G){
                                case 4:
                                    return f = new hCd, f;
                                case 6:
                                    return g = new ACd, g;
                                case 7:
                                    return h = new PCd, h;
                                case 8:
                                    return d = new rzd, d;
                                case 9:
                                    return c = new Xxd, c;
                                case 10:
                                    return e = new Rzd, e;
                                case 11:
                                    return i = new _Cd, i;
                                default:
                                    throw Adb(new agb(ZHe + a.zb + WHe));
                            }
                        };
                        _.ti = function NAd(a, b) {
                            switch(a.hk()){
                                case 13:
                                case 12:
                                    return null;
                                default:
                                    throw Adb(new agb(VHe + a.xe() + WHe));
                            }
                        };
                        var S4 = sfb(THe, 'ElkGraphFactoryImpl', 1037);
                        feb(448, 158, {
                            110: 1,
                            94: 1,
                            93: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            119: 1,
                            120: 1
                        });
                        _.Gh = function RAd() {
                            var a, b;
                            b = (a = RD(Ywd(this, 16), 29), P$d(rYd(!a ? this.ii() : a)));
                            return b == null ? (N2d(), N2d(), M2d) : new e3d(this, b);
                        };
                        _.Lh = function SAd(a, b, c) {
                            var d;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.xe();
                            }
                            return zvd(this, a - AYd(this.ii()), vYd((d = RD(Ywd(this, 16), 29), !d ? this.ii() : d), a), b, c);
                        };
                        _.Wh = function TAd(a) {
                            var b;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return this.zb != null;
                            }
                            return Avd(this, a - AYd(this.ii()), vYd((b = RD(Ywd(this, 16), 29), !b ? this.ii() : b), a));
                        };
                        _.bi = function UAd(a, b) {
                            var c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                                case 1:
                                    this.ui(WD(b));
                                    return;
                            }
                            Bvd(this, a - AYd(this.ii()), vYd((c = RD(Ywd(this, 16), 29), !c ? this.ii() : c), a), b);
                        };
                        _.ii = function VAd() {
                            return JTd(), yTd;
                        };
                        _.ki = function WAd(a) {
                            var b;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                                case 1:
                                    this.ui(null);
                                    return;
                            }
                            Cvd(this, a - AYd(this.ii()), vYd((b = RD(Ywd(this, 16), 29), !b ? this.ii() : b), a));
                        };
                        _.xe = function XAd() {
                            return this.zb;
                        };
                        _.ui = function YAd(a) {
                            PAd(this, a);
                        };
                        _.Ib = function ZAd() {
                            return QAd(this);
                        };
                        _.zb = null;
                        var o8 = sfb(SHe, 'ENamedElementImpl', 448);
                        feb(184, 448, {
                            110: 1,
                            94: 1,
                            93: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            241: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            184: 1,
                            119: 1,
                            120: 1,
                            690: 1
                        }, EBd);
                        _.Ah = function GBd(a) {
                            return qBd(this, a);
                        };
                        _.Lh = function HBd(a, b, c) {
                            var d;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.zb;
                                case 2:
                                    return this.yb;
                                case 3:
                                    return this.xb;
                                case 4:
                                    return this.sb;
                                case 5:
                                    return !this.rb && (this.rb = new J5d(this, i7, this)), this.rb;
                                case 6:
                                    return !this.vb && (this.vb = new G5d(t7, this, 6, 7)), this.vb;
                                case 7:
                                    if (b) return this.Db >> 16 == 7 ? RD(this.Cb, 241) : null;
                                    return gBd(this);
                            }
                            return zvd(this, a - AYd((JTd(), CTd)), vYd((d = RD(Ywd(this, 16), 29), !d ? CTd : d), a), b, c);
                        };
                        _.Sh = function IBd(a, b, c) {
                            var d, e, f;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), qLd(this.Ab, a, c);
                                case 4:
                                    !!this.sb && (c = RD(this.sb, 54).Th(this, 1, n7, c));
                                    return hBd(this, RD(a, 480), c);
                                case 5:
                                    return !this.rb && (this.rb = new J5d(this, i7, this)), qLd(this.rb, a, c);
                                case 6:
                                    return !this.vb && (this.vb = new G5d(t7, this, 6, 7)), qLd(this.vb, a, c);
                                case 7:
                                    !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? qBd(this, c) : this.Cb.Th(this, -1 - e, null, c)));
                                    return xvd(this, a, 7, c);
                            }
                            return f = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), CTd) : d), b), 69), f.wk().zk(this, Wwd(this), b - AYd((JTd(), CTd)), a, c);
                        };
                        _.Uh = function JBd(a, b, c) {
                            var d, e;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), rLd(this.Ab, a, c);
                                case 4:
                                    return hBd(this, null, c);
                                case 5:
                                    return !this.rb && (this.rb = new J5d(this, i7, this)), rLd(this.rb, a, c);
                                case 6:
                                    return !this.vb && (this.vb = new G5d(t7, this, 6, 7)), rLd(this.vb, a, c);
                                case 7:
                                    return xvd(this, null, 7, c);
                            }
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), CTd) : d), b), 69), e.wk().Ak(this, Wwd(this), b - AYd((JTd(), CTd)), a, c);
                        };
                        _.Wh = function KBd(a) {
                            var b;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return this.zb != null;
                                case 2:
                                    return this.yb != null;
                                case 3:
                                    return this.xb != null;
                                case 4:
                                    return !!this.sb;
                                case 5:
                                    return !!this.rb && this.rb.i != 0;
                                case 6:
                                    return !!this.vb && this.vb.i != 0;
                                case 7:
                                    return !!gBd(this);
                            }
                            return Avd(this, a - AYd((JTd(), CTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? CTd : b), a));
                        };
                        _.Zh = function LBd(a) {
                            var b;
                            b = sBd(this, a);
                            return b ? b : _zd(this, a);
                        };
                        _.bi = function MBd(a, b) {
                            var c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                                case 1:
                                    PAd(this, WD(b));
                                    return;
                                case 2:
                                    DBd(this, WD(b));
                                    return;
                                case 3:
                                    CBd(this, WD(b));
                                    return;
                                case 4:
                                    BBd(this, RD(b, 480));
                                    return;
                                case 5:
                                    !this.rb && (this.rb = new J5d(this, i7, this));
                                    sLd(this.rb);
                                    !this.rb && (this.rb = new J5d(this, i7, this));
                                    YGd(this.rb, RD(b, 16));
                                    return;
                                case 6:
                                    !this.vb && (this.vb = new G5d(t7, this, 6, 7));
                                    sLd(this.vb);
                                    !this.vb && (this.vb = new G5d(t7, this, 6, 7));
                                    YGd(this.vb, RD(b, 16));
                                    return;
                            }
                            Bvd(this, a - AYd((JTd(), CTd)), vYd((c = RD(Ywd(this, 16), 29), !c ? CTd : c), a), b);
                        };
                        _.ei = function NBd(a) {
                            var b, c;
                            if (!!a && !!this.rb) for(c = new dMd(this.rb); c.e != c.i.gc();){
                                b = bMd(c);
                                ZD(b, 364) && (RD(b, 364).w = null);
                            }
                            $wd(this, 64, a);
                        };
                        _.ii = function OBd() {
                            return JTd(), CTd;
                        };
                        _.ki = function PBd(a) {
                            var b;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                                case 1:
                                    PAd(this, null);
                                    return;
                                case 2:
                                    DBd(this, null);
                                    return;
                                case 3:
                                    CBd(this, null);
                                    return;
                                case 4:
                                    BBd(this, null);
                                    return;
                                case 5:
                                    !this.rb && (this.rb = new J5d(this, i7, this));
                                    sLd(this.rb);
                                    return;
                                case 6:
                                    !this.vb && (this.vb = new G5d(t7, this, 6, 7));
                                    sLd(this.vb);
                                    return;
                            }
                            Cvd(this, a - AYd((JTd(), CTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? CTd : b), a));
                        };
                        _.pi = function QBd() {
                            rBd(this);
                        };
                        _.vi = function RBd() {
                            return !this.rb && (this.rb = new J5d(this, i7, this)), this.rb;
                        };
                        _.wi = function SBd() {
                            return this.sb;
                        };
                        _.xi = function TBd() {
                            return this.ub;
                        };
                        _.yi = function UBd() {
                            return this.xb;
                        };
                        _.zi = function VBd() {
                            return this.yb;
                        };
                        _.Ai = function WBd(a) {
                            this.ub = a;
                        };
                        _.Ib = function XBd() {
                            var a;
                            if ((this.Db & 64) != 0) return QAd(this);
                            a = new Shb(QAd(this));
                            a.a += ' (nsURI: ';
                            Nhb(a, this.yb);
                            a.a += ', nsPrefix: ';
                            Nhb(a, this.xb);
                            a.a += ')';
                            return a.a;
                        };
                        _.xb = null;
                        _.yb = null;
                        var $Ad;
                        var y8 = sfb(SHe, 'EPackageImpl', 184);
                        feb(569, 184, {
                            110: 1,
                            2115: 1,
                            569: 1,
                            94: 1,
                            93: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            241: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            184: 1,
                            119: 1,
                            120: 1,
                            690: 1
                        }, _Bd);
                        _.q = false;
                        _.r = false;
                        var YBd = false;
                        var T4 = sfb(THe, 'ElkGraphPackageImpl', 569);
                        feb(366, 740, {
                            110: 1,
                            342: 1,
                            167: 1,
                            135: 1,
                            422: 1,
                            366: 1,
                            96: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            119: 1,
                            120: 1
                        }, hCd);
                        _.Ah = function iCd(a) {
                            return cCd(this, a);
                        };
                        _.Lh = function jCd(a, b, c) {
                            switch(a){
                                case 7:
                                    return dCd(this);
                                case 8:
                                    return this.a;
                            }
                            return vyd(this, a, b, c);
                        };
                        _.Sh = function kCd(a, b, c) {
                            var d;
                            switch(b){
                                case 7:
                                    !!this.Cb && (c = (d = this.Db >> 16, d >= 0 ? cCd(this, c) : this.Cb.Th(this, -1 - d, null, c)));
                                    return bCd(this, RD(a, 167), c);
                            }
                            return dyd(this, a, b, c);
                        };
                        _.Uh = function lCd(a, b, c) {
                            if (b == 7) return bCd(this, null, c);
                            return eyd(this, a, b, c);
                        };
                        _.Wh = function mCd(a) {
                            switch(a){
                                case 7:
                                    return !!dCd(this);
                                case 8:
                                    return !lhb('', this.a);
                            }
                            return wyd(this, a);
                        };
                        _.bi = function nCd(a, b) {
                            switch(a){
                                case 7:
                                    eCd(this, RD(b, 167));
                                    return;
                                case 8:
                                    fCd(this, WD(b));
                                    return;
                            }
                            xyd(this, a, b);
                        };
                        _.ii = function oCd() {
                            return pvd(), jvd;
                        };
                        _.ki = function pCd(a) {
                            switch(a){
                                case 7:
                                    eCd(this, null);
                                    return;
                                case 8:
                                    fCd(this, '');
                                    return;
                            }
                            yyd(this, a);
                        };
                        _.Ib = function qCd() {
                            return gCd(this);
                        };
                        _.a = '';
                        var U4 = sfb(THe, 'ElkLabelImpl', 366);
                        feb(207, 741, {
                            110: 1,
                            342: 1,
                            84: 1,
                            167: 1,
                            27: 1,
                            422: 1,
                            207: 1,
                            96: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            119: 1,
                            120: 1
                        }, ACd);
                        _.Ah = function BCd(a) {
                            return sCd(this, a);
                        };
                        _.Lh = function CCd(a, b, c) {
                            switch(a){
                                case 9:
                                    return !this.c && (this.c = new C5d(K4, this, 9, 9)), this.c;
                                case 10:
                                    return !this.a && (this.a = new C5d(J4, this, 10, 11)), this.a;
                                case 11:
                                    return vCd(this);
                                case 12:
                                    return !this.b && (this.b = new C5d(G4, this, 12, 3)), this.b;
                                case 13:
                                    return Geb(), !this.a && (this.a = new C5d(J4, this, 10, 11)), this.a.i > 0 ? true : false;
                            }
                            return Uyd(this, a, b, c);
                        };
                        _.Sh = function DCd(a, b, c) {
                            var d;
                            switch(b){
                                case 9:
                                    return !this.c && (this.c = new C5d(K4, this, 9, 9)), qLd(this.c, a, c);
                                case 10:
                                    return !this.a && (this.a = new C5d(J4, this, 10, 11)), qLd(this.a, a, c);
                                case 11:
                                    !!this.Cb && (c = (d = this.Db >> 16, d >= 0 ? sCd(this, c) : this.Cb.Th(this, -1 - d, null, c)));
                                    return rCd(this, RD(a, 27), c);
                                case 12:
                                    return !this.b && (this.b = new C5d(G4, this, 12, 3)), qLd(this.b, a, c);
                            }
                            return Vyd(this, a, b, c);
                        };
                        _.Uh = function ECd(a, b, c) {
                            switch(b){
                                case 9:
                                    return !this.c && (this.c = new C5d(K4, this, 9, 9)), rLd(this.c, a, c);
                                case 10:
                                    return !this.a && (this.a = new C5d(J4, this, 10, 11)), rLd(this.a, a, c);
                                case 11:
                                    return rCd(this, null, c);
                                case 12:
                                    return !this.b && (this.b = new C5d(G4, this, 12, 3)), rLd(this.b, a, c);
                            }
                            return Wyd(this, a, b, c);
                        };
                        _.Wh = function FCd(a) {
                            switch(a){
                                case 9:
                                    return !!this.c && this.c.i != 0;
                                case 10:
                                    return !!this.a && this.a.i != 0;
                                case 11:
                                    return !!vCd(this);
                                case 12:
                                    return !!this.b && this.b.i != 0;
                                case 13:
                                    return !this.a && (this.a = new C5d(J4, this, 10, 11)), this.a.i > 0;
                            }
                            return Xyd(this, a);
                        };
                        _.bi = function GCd(a, b) {
                            switch(a){
                                case 9:
                                    !this.c && (this.c = new C5d(K4, this, 9, 9));
                                    sLd(this.c);
                                    !this.c && (this.c = new C5d(K4, this, 9, 9));
                                    YGd(this.c, RD(b, 16));
                                    return;
                                case 10:
                                    !this.a && (this.a = new C5d(J4, this, 10, 11));
                                    sLd(this.a);
                                    !this.a && (this.a = new C5d(J4, this, 10, 11));
                                    YGd(this.a, RD(b, 16));
                                    return;
                                case 11:
                                    yCd(this, RD(b, 27));
                                    return;
                                case 12:
                                    !this.b && (this.b = new C5d(G4, this, 12, 3));
                                    sLd(this.b);
                                    !this.b && (this.b = new C5d(G4, this, 12, 3));
                                    YGd(this.b, RD(b, 16));
                                    return;
                            }
                            Yyd(this, a, b);
                        };
                        _.ii = function HCd() {
                            return pvd(), kvd;
                        };
                        _.ki = function ICd(a) {
                            switch(a){
                                case 9:
                                    !this.c && (this.c = new C5d(K4, this, 9, 9));
                                    sLd(this.c);
                                    return;
                                case 10:
                                    !this.a && (this.a = new C5d(J4, this, 10, 11));
                                    sLd(this.a);
                                    return;
                                case 11:
                                    yCd(this, null);
                                    return;
                                case 12:
                                    !this.b && (this.b = new C5d(G4, this, 12, 3));
                                    sLd(this.b);
                                    return;
                            }
                            Zyd(this, a);
                        };
                        _.Ib = function JCd() {
                            return zCd(this);
                        };
                        var V4 = sfb(THe, 'ElkNodeImpl', 207);
                        feb(193, 741, {
                            110: 1,
                            342: 1,
                            84: 1,
                            167: 1,
                            123: 1,
                            422: 1,
                            193: 1,
                            96: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            119: 1,
                            120: 1
                        }, PCd);
                        _.Ah = function QCd(a) {
                            return LCd(this, a);
                        };
                        _.Lh = function RCd(a, b, c) {
                            if (a == 9) return MCd(this);
                            return Uyd(this, a, b, c);
                        };
                        _.Sh = function SCd(a, b, c) {
                            var d;
                            switch(b){
                                case 9:
                                    !!this.Cb && (c = (d = this.Db >> 16, d >= 0 ? LCd(this, c) : this.Cb.Th(this, -1 - d, null, c)));
                                    return KCd(this, RD(a, 27), c);
                            }
                            return Vyd(this, a, b, c);
                        };
                        _.Uh = function TCd(a, b, c) {
                            if (b == 9) return KCd(this, null, c);
                            return Wyd(this, a, b, c);
                        };
                        _.Wh = function UCd(a) {
                            if (a == 9) return !!MCd(this);
                            return Xyd(this, a);
                        };
                        _.bi = function VCd(a, b) {
                            switch(a){
                                case 9:
                                    NCd(this, RD(b, 27));
                                    return;
                            }
                            Yyd(this, a, b);
                        };
                        _.ii = function WCd() {
                            return pvd(), lvd;
                        };
                        _.ki = function XCd(a) {
                            switch(a){
                                case 9:
                                    NCd(this, null);
                                    return;
                            }
                            Zyd(this, a);
                        };
                        _.Ib = function YCd() {
                            return OCd(this);
                        };
                        var W4 = sfb(THe, 'ElkPortImpl', 193);
                        var O6 = ufb(sIe, 'BasicEMap/Entry');
                        feb(1122, 120, {
                            110: 1,
                            44: 1,
                            94: 1,
                            93: 1,
                            136: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            119: 1,
                            120: 1
                        }, _Cd);
                        _.Fb = function fDd(a) {
                            return this === a;
                        };
                        _.ld = function hDd() {
                            return this.b;
                        };
                        _.Hb = function jDd() {
                            return kFb(this);
                        };
                        _.Di = function lDd(a) {
                            ZCd(this, RD(a, 149));
                        };
                        _.Lh = function aDd(a, b, c) {
                            switch(a){
                                case 0:
                                    return this.b;
                                case 1:
                                    return this.c;
                            }
                            return Dvd(this, a, b, c);
                        };
                        _.Wh = function bDd(a) {
                            switch(a){
                                case 0:
                                    return !!this.b;
                                case 1:
                                    return this.c != null;
                            }
                            return Kvd(this, a);
                        };
                        _.bi = function cDd(a, b) {
                            switch(a){
                                case 0:
                                    ZCd(this, RD(b, 149));
                                    return;
                                case 1:
                                    $Cd(this, b);
                                    return;
                            }
                            Wvd(this, a, b);
                        };
                        _.ii = function dDd() {
                            return pvd(), mvd;
                        };
                        _.ki = function eDd(a) {
                            switch(a){
                                case 0:
                                    ZCd(this, null);
                                    return;
                                case 1:
                                    $Cd(this, null);
                                    return;
                            }
                            $vd(this, a);
                        };
                        _.Bi = function gDd() {
                            var a;
                            if (this.a == -1) {
                                a = this.b;
                                this.a = !a ? 0 : tb(a);
                            }
                            return this.a;
                        };
                        _.md = function iDd() {
                            return this.c;
                        };
                        _.Ci = function kDd(a) {
                            this.a = a;
                        };
                        _.nd = function mDd(a) {
                            var b;
                            b = this.c;
                            $Cd(this, a);
                            return b;
                        };
                        _.Ib = function nDd() {
                            var a;
                            if ((this.Db & 64) != 0) return awd(this);
                            a = new bib;
                            Zhb(Zhb(Zhb(a, this.b ? this.b.Pg() : vve), SAe), Ghb(this.c));
                            return a.a;
                        };
                        _.a = -1;
                        _.c = null;
                        var X4 = sfb(THe, 'ElkPropertyToValueMapEntryImpl', 1122);
                        feb(996, 1, {}, BDd);
                        var Z4 = sfb(vIe, 'JsonAdapter', 996);
                        feb(216, 63, swe, CDd);
                        var $4 = sfb(vIe, 'JsonImportException', 216);
                        feb(868, 1, {}, IEd);
                        var O5 = sfb(vIe, 'JsonImporter', 868);
                        feb(903, 1, {}, JEd);
                        var _4 = sfb(vIe, 'JsonImporter/lambda$0$Type', 903);
                        feb(904, 1, {}, KEd);
                        var a5 = sfb(vIe, 'JsonImporter/lambda$1$Type', 904);
                        feb(912, 1, {}, LEd);
                        var b5 = sfb(vIe, 'JsonImporter/lambda$10$Type', 912);
                        feb(914, 1, {}, MEd);
                        var c5 = sfb(vIe, 'JsonImporter/lambda$11$Type', 914);
                        feb(915, 1, {}, NEd);
                        var d5 = sfb(vIe, 'JsonImporter/lambda$12$Type', 915);
                        feb(921, 1, {}, OEd);
                        var e5 = sfb(vIe, 'JsonImporter/lambda$13$Type', 921);
                        feb(920, 1, {}, PEd);
                        var f5 = sfb(vIe, 'JsonImporter/lambda$14$Type', 920);
                        feb(916, 1, {}, QEd);
                        var g5 = sfb(vIe, 'JsonImporter/lambda$15$Type', 916);
                        feb(917, 1, {}, REd);
                        var h5 = sfb(vIe, 'JsonImporter/lambda$16$Type', 917);
                        feb(918, 1, {}, SEd);
                        var i5 = sfb(vIe, 'JsonImporter/lambda$17$Type', 918);
                        feb(919, 1, {}, TEd);
                        var j5 = sfb(vIe, 'JsonImporter/lambda$18$Type', 919);
                        feb(924, 1, {}, UEd);
                        var k5 = sfb(vIe, 'JsonImporter/lambda$19$Type', 924);
                        feb(905, 1, {}, VEd);
                        var l5 = sfb(vIe, 'JsonImporter/lambda$2$Type', 905);
                        feb(922, 1, {}, WEd);
                        var m5 = sfb(vIe, 'JsonImporter/lambda$20$Type', 922);
                        feb(923, 1, {}, XEd);
                        var n5 = sfb(vIe, 'JsonImporter/lambda$21$Type', 923);
                        feb(927, 1, {}, YEd);
                        var o5 = sfb(vIe, 'JsonImporter/lambda$22$Type', 927);
                        feb(925, 1, {}, ZEd);
                        var p5 = sfb(vIe, 'JsonImporter/lambda$23$Type', 925);
                        feb(926, 1, {}, $Ed);
                        var q5 = sfb(vIe, 'JsonImporter/lambda$24$Type', 926);
                        feb(929, 1, {}, _Ed);
                        var r5 = sfb(vIe, 'JsonImporter/lambda$25$Type', 929);
                        feb(928, 1, {}, aFd);
                        var s5 = sfb(vIe, 'JsonImporter/lambda$26$Type', 928);
                        feb(930, 1, Qve, bFd);
                        _.Cd = function cFd(a) {
                            _Dd(this.b, this.a, WD(a));
                        };
                        var t5 = sfb(vIe, 'JsonImporter/lambda$27$Type', 930);
                        feb(931, 1, Qve, dFd);
                        _.Cd = function eFd(a) {
                            aEd(this.b, this.a, WD(a));
                        };
                        var u5 = sfb(vIe, 'JsonImporter/lambda$28$Type', 931);
                        feb(932, 1, {}, fFd);
                        var v5 = sfb(vIe, 'JsonImporter/lambda$29$Type', 932);
                        feb(908, 1, {}, gFd);
                        var w5 = sfb(vIe, 'JsonImporter/lambda$3$Type', 908);
                        feb(933, 1, {}, hFd);
                        var x5 = sfb(vIe, 'JsonImporter/lambda$30$Type', 933);
                        feb(934, 1, {}, iFd);
                        var y5 = sfb(vIe, 'JsonImporter/lambda$31$Type', 934);
                        feb(935, 1, {}, jFd);
                        var z5 = sfb(vIe, 'JsonImporter/lambda$32$Type', 935);
                        feb(936, 1, {}, kFd);
                        var A5 = sfb(vIe, 'JsonImporter/lambda$33$Type', 936);
                        feb(937, 1, {}, lFd);
                        var B5 = sfb(vIe, 'JsonImporter/lambda$34$Type', 937);
                        feb(870, 1, {}, nFd);
                        var C5 = sfb(vIe, 'JsonImporter/lambda$35$Type', 870);
                        feb(941, 1, {}, pFd);
                        var D5 = sfb(vIe, 'JsonImporter/lambda$36$Type', 941);
                        feb(938, 1, Qve, qFd);
                        _.Cd = function rFd(a) {
                            jEd(this.a, RD(a, 377));
                        };
                        var E5 = sfb(vIe, 'JsonImporter/lambda$37$Type', 938);
                        feb(939, 1, Qve, sFd);
                        _.Cd = function tFd(a) {
                            kEd(this.a, this.b, RD(a, 166));
                        };
                        var F5 = sfb(vIe, 'JsonImporter/lambda$38$Type', 939);
                        feb(940, 1, Qve, uFd);
                        _.Cd = function vFd(a) {
                            lEd(this.a, this.b, RD(a, 166));
                        };
                        var G5 = sfb(vIe, 'JsonImporter/lambda$39$Type', 940);
                        feb(906, 1, {}, wFd);
                        var H5 = sfb(vIe, 'JsonImporter/lambda$4$Type', 906);
                        feb(942, 1, Qve, xFd);
                        _.Cd = function yFd(a) {
                            mEd(this.a, RD(a, 8));
                        };
                        var I5 = sfb(vIe, 'JsonImporter/lambda$40$Type', 942);
                        feb(907, 1, {}, zFd);
                        var J5 = sfb(vIe, 'JsonImporter/lambda$5$Type', 907);
                        feb(911, 1, {}, AFd);
                        var K5 = sfb(vIe, 'JsonImporter/lambda$6$Type', 911);
                        feb(909, 1, {}, BFd);
                        var L5 = sfb(vIe, 'JsonImporter/lambda$7$Type', 909);
                        feb(910, 1, {}, CFd);
                        var M5 = sfb(vIe, 'JsonImporter/lambda$8$Type', 910);
                        feb(913, 1, {}, DFd);
                        var N5 = sfb(vIe, 'JsonImporter/lambda$9$Type', 913);
                        feb(961, 1, Qve, MFd);
                        _.Cd = function NFd(a) {
                            oDd(this.a, new OC(WD(a)));
                        };
                        var P5 = sfb(vIe, 'JsonMetaDataConverter/lambda$0$Type', 961);
                        feb(962, 1, Qve, OFd);
                        _.Cd = function PFd(a) {
                            IFd(this.a, RD(a, 245));
                        };
                        var Q5 = sfb(vIe, 'JsonMetaDataConverter/lambda$1$Type', 962);
                        feb(963, 1, Qve, QFd);
                        _.Cd = function RFd(a) {
                            JFd(this.a, RD(a, 143));
                        };
                        var R5 = sfb(vIe, 'JsonMetaDataConverter/lambda$2$Type', 963);
                        feb(964, 1, Qve, SFd);
                        _.Cd = function TFd(a) {
                            KFd(this.a, RD(a, 170));
                        };
                        var S5 = sfb(vIe, 'JsonMetaDataConverter/lambda$3$Type', 964);
                        feb(245, 22, {
                            3: 1,
                            34: 1,
                            22: 1,
                            245: 1
                        }, bGd);
                        var UFd, VFd, WFd, XFd, YFd, ZFd, $Fd, _Fd;
                        var T5 = tfb(jze, 'GraphFeature', 245, WI, dGd, cGd);
                        var eGd;
                        feb(11, 1, {
                            34: 1,
                            149: 1
                        }, jGd, kGd, lGd, mGd);
                        _.Fd = function nGd(a) {
                            return gGd(this, RD(a, 149));
                        };
                        _.Fb = function oGd(a) {
                            return hGd(this, a);
                        };
                        _.Sg = function pGd() {
                            return iGd(this);
                        };
                        _.Pg = function qGd() {
                            return this.b;
                        };
                        _.Hb = function rGd() {
                            return ohb(this.b);
                        };
                        _.Ib = function sGd() {
                            return this.b;
                        };
                        var Y5 = sfb(jze, 'Property', 11);
                        feb(671, 1, fye, uGd);
                        _.Ne = function vGd(a, b) {
                            return tGd(this, RD(a, 96), RD(b, 96));
                        };
                        _.Fb = function wGd(a) {
                            return this === a;
                        };
                        _.Oe = function xGd() {
                            return new Frb(this);
                        };
                        var X5 = sfb(jze, 'PropertyHolderComparator', 671);
                        feb(709, 1, Ave, QGd);
                        _.Nb = function RGd(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function TGd() {
                            return PGd(this);
                        };
                        _.Qb = function UGd() {
                            $tb();
                        };
                        _.Ob = function SGd() {
                            return !!this.a;
                        };
                        var Z5 = sfb(KIe, 'ElkGraphUtil/AncestorIterator', 709);
                        var Y6 = ufb(sIe, 'EList');
                        feb(70, 56, {
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            70: 1,
                            61: 1
                        });
                        _.bd = function hHd(a, b) {
                            VGd(this, a, b);
                        };
                        _.Fc = function iHd(a) {
                            return WGd(this, a);
                        };
                        _.cd = function jHd(a, b) {
                            return XGd(this, a, b);
                        };
                        _.Gc = function kHd(a) {
                            return YGd(this, a);
                        };
                        _.Ii = function lHd() {
                            return new yMd(this);
                        };
                        _.Ji = function mHd() {
                            return new BMd(this);
                        };
                        _.Ki = function nHd(a) {
                            return ZGd(this, a);
                        };
                        _.Li = function oHd() {
                            return true;
                        };
                        _.Mi = function pHd(a, b) {};
                        _.Ni = function qHd() {};
                        _.Oi = function rHd(a, b) {
                            $Gd(this, a, b);
                        };
                        _.Pi = function sHd(a, b, c) {};
                        _.Qi = function tHd(a, b) {};
                        _.Ri = function uHd(a, b, c) {};
                        _.Fb = function vHd(a) {
                            return _Gd(this, a);
                        };
                        _.Hb = function wHd() {
                            return cHd(this);
                        };
                        _.Si = function xHd() {
                            return false;
                        };
                        _.Kc = function yHd() {
                            return new dMd(this);
                        };
                        _.ed = function zHd() {
                            return new mMd(this);
                        };
                        _.fd = function AHd(a) {
                            var b;
                            b = this.gc();
                            if (a < 0 || a > b) throw Adb(new aMd(a, b));
                            return new nMd(this, a);
                        };
                        _.Ui = function BHd(a, b) {
                            this.Ti(a, this.dd(b));
                        };
                        _.Mc = function CHd(a) {
                            return dHd(this, a);
                        };
                        _.Wi = function DHd(a, b) {
                            return b;
                        };
                        _.hd = function EHd(a, b) {
                            return eHd(this, a, b);
                        };
                        _.Ib = function FHd() {
                            return fHd(this);
                        };
                        _.Yi = function GHd() {
                            return true;
                        };
                        _.Zi = function HHd(a, b) {
                            return gHd(this, b);
                        };
                        var u6 = sfb(sIe, 'AbstractEList', 70);
                        feb(66, 70, PIe, YHd, ZHd, $Hd);
                        _.Ei = function _Hd(a, b) {
                            return IHd(this, a, b);
                        };
                        _.Fi = function aId(a) {
                            return JHd(this, a);
                        };
                        _.Gi = function bId(a, b) {
                            KHd(this, a, b);
                        };
                        _.Hi = function cId(a) {
                            LHd(this, a);
                        };
                        _.$i = function dId(a) {
                            return NHd(this, a);
                        };
                        _.$b = function eId() {
                            OHd(this);
                        };
                        _.Hc = function fId(a) {
                            return PHd(this, a);
                        };
                        _.Xb = function gId(a) {
                            return QHd(this, a);
                        };
                        _._i = function hId(a) {
                            var b, c, d;
                            ++this.j;
                            c = this.g == null ? 0 : this.g.length;
                            if (a > c) {
                                d = this.g;
                                b = c + (c / 2 | 0) + 4;
                                b < a && (b = a);
                                this.g = this.aj(b);
                                d != null && hib(d, 0, this.g, 0, this.i);
                            }
                        };
                        _.dd = function iId(a) {
                            return RHd(this, a);
                        };
                        _.dc = function jId() {
                            return this.i == 0;
                        };
                        _.Ti = function kId(a, b) {
                            return SHd(this, a, b);
                        };
                        _.aj = function lId(a) {
                            return $C(jJ, rve, 1, a, 5, 1);
                        };
                        _.Vi = function mId(a) {
                            return this.g[a];
                        };
                        _.gd = function nId(a) {
                            return THd(this, a);
                        };
                        _.Xi = function oId(a, b) {
                            return UHd(this, a, b);
                        };
                        _.gc = function pId() {
                            return this.i;
                        };
                        _.Pc = function qId() {
                            return WHd(this);
                        };
                        _.Qc = function rId(a) {
                            return XHd(this, a);
                        };
                        _.i = 0;
                        var D6 = sfb(sIe, 'BasicEList', 66);
                        var a7 = ufb(sIe, 'TreeIterator');
                        feb(708, 66, QIe);
                        _.Nb = function vId(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function wId() {
                            return this.g == null && !this.c ? sId(this) : this.g == null || this.i != 0 && RD(this.g[this.i - 1], 51).Ob();
                        };
                        _.Pb = function xId() {
                            return tId(this);
                        };
                        _.Qb = function yId() {
                            if (!this.e) throw Adb(new dgb('There is no valid object to remove.'));
                            this.e.Qb();
                        };
                        _.c = false;
                        var v6 = sfb(sIe, 'AbstractTreeIterator', 708);
                        feb(700, 708, QIe, zId);
                        _.bj = function AId(a) {
                            var b;
                            b = RD(a, 58).Gh().Kc();
                            ZD(b, 287) && RD(b, 287).wl(new BId);
                            return b;
                        };
                        var _5 = sfb(KIe, 'ElkGraphUtil/PropertiesSkippingTreeIterator', 700);
                        feb(965, 1, {}, BId);
                        var $5 = sfb(KIe, 'ElkGraphUtil/PropertiesSkippingTreeIterator/1', 965);
                        var CId, DId;
                        var b6 = sfb(KIe, 'ElkReflect', null);
                        feb(901, 1, CGe, JId);
                        _.Rg = function KId(a) {
                            return EId(), Asb(RD(a, 181));
                        };
                        var a6 = sfb(KIe, 'ElkReflect/lambda$0$Type', 901);
                        var LId;
                        var _6 = ufb(sIe, 'ResourceLocator');
                        feb(1065, 1, {});
                        var S6 = sfb(sIe, 'DelegatingResourceLocator', 1065);
                        feb(1066, 1065, {});
                        var c6 = sfb('org.eclipse.emf.common', 'EMFPlugin', 1066);
                        var d6 = ufb(DJe, 'Adapter');
                        var e6 = ufb(DJe, 'Notification');
                        feb(1174, 1, EJe);
                        _.cj = function VId() {
                            return this.d;
                        };
                        _.dj = function WId(a) {};
                        _.ej = function XId(a) {
                            this.d = a;
                        };
                        _.fj = function YId(a) {
                            this.d == a && (this.d = null);
                        };
                        _.d = null;
                        var f6 = sfb(JHe, 'AdapterImpl', 1174);
                        feb(2093, 70, FJe);
                        _.Ei = function dJd(a, b) {
                            return ZId(this, a, b);
                        };
                        _.Fi = function eJd(a) {
                            var b, c, d;
                            ++this.j;
                            if (a.dc()) return false;
                            else {
                                b = this.Ej();
                                for(d = a.Kc(); d.Ob();){
                                    c = d.Pb();
                                    this.rj(this.Zi(b, c));
                                    ++b;
                                }
                                return true;
                            }
                        };
                        _.Gi = function fJd(a, b) {
                            $Id(this, a, b);
                        };
                        _.Hi = function gJd(a) {
                            _Id(this, a);
                        };
                        _.pj = function hJd() {
                            return this.sj();
                        };
                        _.$b = function iJd() {
                            aJd(this, this.Ej(), this.Fj());
                        };
                        _.Hc = function jJd(a) {
                            return this.uj(a);
                        };
                        _.Ic = function kJd(a) {
                            return this.vj(a);
                        };
                        _.qj = function lJd(a, b) {
                            this.Bj().Um();
                        };
                        _.rj = function mJd(a) {
                            this.Bj().Um();
                        };
                        _.sj = function nJd() {
                            return this.Bj();
                        };
                        _.tj = function oJd() {
                            this.Bj().Um();
                        };
                        _.uj = function pJd(a) {
                            return this.Bj().Um();
                        };
                        _.vj = function qJd(a) {
                            return this.Bj().Um();
                        };
                        _.wj = function rJd(a) {
                            return this.Bj().Um();
                        };
                        _.xj = function sJd(a) {
                            return this.Bj().Um();
                        };
                        _.yj = function tJd() {
                            return this.Bj().Um();
                        };
                        _.zj = function uJd(a) {
                            return this.Bj().Um();
                        };
                        _.Aj = function vJd() {
                            return this.Bj().Um();
                        };
                        _.Cj = function wJd(a) {
                            return this.Bj().Um();
                        };
                        _.Dj = function xJd(a, b) {
                            return this.Bj().Um();
                        };
                        _.Ej = function yJd() {
                            return this.Bj().Um();
                        };
                        _.Fj = function zJd() {
                            return this.Bj().Um();
                        };
                        _.Gj = function AJd(a) {
                            return this.Bj().Um();
                        };
                        _.Hj = function BJd() {
                            return this.Bj().Um();
                        };
                        _.Fb = function CJd(a) {
                            return this.wj(a);
                        };
                        _.Xb = function DJd(a) {
                            return this.Wi(a, this.xj(a));
                        };
                        _.Hb = function EJd() {
                            return this.yj();
                        };
                        _.dd = function FJd(a) {
                            return this.zj(a);
                        };
                        _.dc = function GJd() {
                            return this.Aj();
                        };
                        _.Ti = function HJd(a, b) {
                            return bJd(this, a, b);
                        };
                        _.Vi = function IJd(a) {
                            return this.xj(a);
                        };
                        _.gd = function JJd(a) {
                            return cJd(this, a);
                        };
                        _.Mc = function KJd(a) {
                            var b;
                            b = this.dd(a);
                            if (b >= 0) {
                                this.gd(b);
                                return true;
                            } else return false;
                        };
                        _.Xi = function LJd(a, b) {
                            return this.Dj(a, this.Zi(a, b));
                        };
                        _.gc = function MJd() {
                            return this.Ej();
                        };
                        _.Pc = function NJd() {
                            return this.Fj();
                        };
                        _.Qc = function OJd(a) {
                            return this.Gj(a);
                        };
                        _.Ib = function PJd() {
                            return this.Hj();
                        };
                        var R6 = sfb(sIe, 'DelegatingEList', 2093);
                        feb(2094, 2093, FJe);
                        _.Ei = function XJd(a, b) {
                            return QJd(this, a, b);
                        };
                        _.Fi = function YJd(a) {
                            return this.Ei(this.Ej(), a);
                        };
                        _.Gi = function ZJd(a, b) {
                            RJd(this, a, b);
                        };
                        _.Hi = function $Jd(a) {
                            SJd(this, a);
                        };
                        _.Li = function _Jd() {
                            return !this.Mj();
                        };
                        _.$b = function aKd() {
                            VJd(this);
                        };
                        _.Ij = function bKd(a, b, c, d, e) {
                            return new aLd(this, a, b, c, d, e);
                        };
                        _.Jj = function cKd(a) {
                            qvd(this.jj(), a);
                        };
                        _.Kj = function dKd() {
                            return null;
                        };
                        _.Lj = function eKd() {
                            return -1;
                        };
                        _.jj = function fKd() {
                            return null;
                        };
                        _.Mj = function gKd() {
                            return false;
                        };
                        _.Nj = function hKd(a, b) {
                            return b;
                        };
                        _.Oj = function iKd(a, b) {
                            return b;
                        };
                        _.Pj = function jKd() {
                            return false;
                        };
                        _.Qj = function kKd() {
                            return !this.Aj();
                        };
                        _.Ti = function lKd(a, b) {
                            var c, d;
                            if (this.Pj()) {
                                d = this.Qj();
                                c = bJd(this, a, b);
                                this.Jj(this.Ij(7, sgb(b), c, a, d));
                                return c;
                            } else return bJd(this, a, b);
                        };
                        _.gd = function mKd(a) {
                            var b, c, d, e;
                            if (this.Pj()) {
                                c = null;
                                d = this.Qj();
                                b = this.Ij(4, e = cJd(this, a), null, a, d);
                                if (this.Mj() && !!e) {
                                    c = this.Oj(e, c);
                                    if (!c) this.Jj(b);
                                    else {
                                        c.nj(b);
                                        c.oj();
                                    }
                                } else if (!c) this.Jj(b);
                                else {
                                    c.nj(b);
                                    c.oj();
                                }
                                return e;
                            } else {
                                e = cJd(this, a);
                                if (this.Mj() && !!e) {
                                    c = this.Oj(e, null);
                                    !!c && c.oj();
                                }
                                return e;
                            }
                        };
                        _.Xi = function nKd(a, b) {
                            return WJd(this, a, b);
                        };
                        var i6 = sfb(JHe, 'DelegatingNotifyingListImpl', 2094);
                        feb(152, 1, GJe);
                        _.nj = function PKd(a) {
                            return oKd(this, a);
                        };
                        _.oj = function QKd() {
                            pKd(this);
                        };
                        _.gj = function RKd() {
                            return this.d;
                        };
                        _.Kj = function SKd() {
                            return null;
                        };
                        _.Rj = function TKd() {
                            return null;
                        };
                        _.hj = function UKd(a) {
                            return -1;
                        };
                        _.ij = function VKd() {
                            return yKd(this);
                        };
                        _.jj = function WKd() {
                            return null;
                        };
                        _.kj = function XKd() {
                            return HKd(this);
                        };
                        _.lj = function YKd() {
                            return this.o < 0 ? this.o < -2 ? -2 - this.o - 1 : -1 : this.o;
                        };
                        _.Sj = function ZKd() {
                            return false;
                        };
                        _.mj = function $Kd(a) {
                            var b, c, d, e, f, g, h, i, j, k, l;
                            switch(this.d){
                                case 1:
                                case 2:
                                    e = a.gj();
                                    switch(e){
                                        case 1:
                                        case 2:
                                            f = a.jj();
                                            if (dE(f) === dE(this.jj()) && this.hj(null) == a.hj(null)) {
                                                this.g = a.ij();
                                                a.gj() == 1 && (this.d = 1);
                                                return true;
                                            }
                                    }
                                case 4:
                                    e = a.gj();
                                    switch(e){
                                        case 4:
                                            f = a.jj();
                                            if (dE(f) === dE(this.jj()) && this.hj(null) == a.hj(null)) {
                                                j = JKd(this);
                                                i = this.o < 0 ? this.o < -2 ? -2 - this.o - 1 : -1 : this.o;
                                                g = a.lj();
                                                this.d = 6;
                                                l = new ZHd(2);
                                                if (i <= g) {
                                                    WGd(l, this.n);
                                                    WGd(l, a.kj());
                                                    this.g = cD(WC(kE, 1), Pwe, 28, 15, [
                                                        this.o = i,
                                                        g + 1
                                                    ]);
                                                } else {
                                                    WGd(l, a.kj());
                                                    WGd(l, this.n);
                                                    this.g = cD(WC(kE, 1), Pwe, 28, 15, [
                                                        this.o = g,
                                                        i
                                                    ]);
                                                }
                                                this.n = l;
                                                j || (this.o = -2 - this.o - 1);
                                                return true;
                                            }
                                            break;
                                    }
                                    break;
                                case 6:
                                    e = a.gj();
                                    switch(e){
                                        case 4:
                                            f = a.jj();
                                            if (dE(f) === dE(this.jj()) && this.hj(null) == a.hj(null)) {
                                                j = JKd(this);
                                                g = a.lj();
                                                k = RD(this.g, 53);
                                                d = $C(kE, Pwe, 28, k.length + 1, 15, 1);
                                                b = 0;
                                                while(b < k.length){
                                                    h = k[b];
                                                    if (h <= g) {
                                                        d[b++] = h;
                                                        ++g;
                                                    } else break;
                                                }
                                                c = RD(this.n, 15);
                                                c.bd(b, a.kj());
                                                d[b] = g;
                                                while(++b < d.length)d[b] = k[b - 1];
                                                this.g = d;
                                                j || (this.o = -2 - d[0]);
                                                return true;
                                            }
                                            break;
                                    }
                                    break;
                            }
                            return false;
                        };
                        _.Ib = function _Kd() {
                            var a, b, c, d;
                            d = new Shb(nfb(this.Rm) + '@' + (b = tb(this) >>> 0, b.toString(16)));
                            d.a += ' (eventType: ';
                            switch(this.d){
                                case 1:
                                    d.a += 'SET';
                                    break;
                                case 2:
                                    d.a += 'UNSET';
                                    break;
                                case 3:
                                    d.a += 'ADD';
                                    break;
                                case 5:
                                    d.a += 'ADD_MANY';
                                    break;
                                case 4:
                                    d.a += 'REMOVE';
                                    break;
                                case 6:
                                    d.a += 'REMOVE_MANY';
                                    break;
                                case 7:
                                    d.a += 'MOVE';
                                    break;
                                case 8:
                                    d.a += 'REMOVING_ADAPTER';
                                    break;
                                case 9:
                                    d.a += 'RESOLVE';
                                    break;
                                default:
                                    Lhb(d, this.d);
                                    break;
                            }
                            IKd(this) && (d.a += ', touch: true', d);
                            d.a += ', position: ';
                            Lhb(d, this.o < 0 ? this.o < -2 ? -2 - this.o - 1 : -1 : this.o);
                            d.a += ', notifier: ';
                            Mhb(d, this.jj());
                            d.a += ', feature: ';
                            Mhb(d, this.Kj());
                            d.a += ', oldValue: ';
                            Mhb(d, HKd(this));
                            d.a += ', newValue: ';
                            if (this.d == 6 && ZD(this.g, 53)) {
                                c = RD(this.g, 53);
                                d.a += '[';
                                for(a = 0; a < c.length;){
                                    d.a += c[a];
                                    ++a < c.length && (d.a += pve, d);
                                }
                                d.a += ']';
                            } else Mhb(d, yKd(this));
                            d.a += ', isTouch: ';
                            Ohb(d, IKd(this));
                            d.a += ', wasSet: ';
                            Ohb(d, JKd(this));
                            d.a += ')';
                            return d.a;
                        };
                        _.d = 0;
                        _.e = 0;
                        _.f = 0;
                        _.j = 0;
                        _.k = 0;
                        _.o = 0;
                        _.p = 0;
                        var k6 = sfb(JHe, 'NotificationImpl', 152);
                        feb(1188, 152, GJe, aLd);
                        _.Kj = function bLd() {
                            return this.a.Kj();
                        };
                        _.hj = function cLd(a) {
                            return this.a.Lj();
                        };
                        _.jj = function dLd() {
                            return this.a.jj();
                        };
                        var h6 = sfb(JHe, 'DelegatingNotifyingListImpl/1', 1188);
                        feb(251, 66, PIe, fLd, gLd);
                        _.Fc = function hLd(a) {
                            return eLd(this, RD(a, 378));
                        };
                        _.nj = function iLd(a) {
                            return eLd(this, a);
                        };
                        _.oj = function jLd() {
                            var a, b, c;
                            for(a = 0; a < this.i; ++a){
                                b = RD(this.g[a], 378);
                                c = b.jj();
                                c != null && b.gj() != -1 && RD(c, 94).xh(b);
                            }
                        };
                        _.aj = function kLd(a) {
                            return $C(e6, rve, 378, a, 0, 1);
                        };
                        var j6 = sfb(JHe, 'NotificationChainImpl', 251);
                        feb(1524, 93, IHe);
                        _.uh = function lLd() {
                            return this.e;
                        };
                        _.wh = function mLd() {
                            return (this.f & 1) != 0;
                        };
                        _.f = 1;
                        var l6 = sfb(JHe, 'NotifierImpl', 1524);
                        feb(2091, 66, PIe);
                        _.Ei = function yLd(a, b) {
                            return nLd(this, a, b);
                        };
                        _.Fi = function zLd(a) {
                            return this.Ei(this.i, a);
                        };
                        _.Gi = function ALd(a, b) {
                            oLd(this, a, b);
                        };
                        _.Hi = function BLd(a) {
                            pLd(this, a);
                        };
                        _.Li = function CLd() {
                            return !this.Mj();
                        };
                        _.$b = function DLd() {
                            sLd(this);
                        };
                        _.Ij = function ELd(a, b, c, d, e) {
                            return new VLd(this, a, b, c, d, e);
                        };
                        _.Jj = function FLd(a) {
                            qvd(this.jj(), a);
                        };
                        _.Kj = function GLd() {
                            return null;
                        };
                        _.Lj = function HLd() {
                            return -1;
                        };
                        _.jj = function ILd() {
                            return null;
                        };
                        _.Mj = function JLd() {
                            return false;
                        };
                        _.Tj = function KLd() {
                            return false;
                        };
                        _.Nj = function LLd(a, b) {
                            return b;
                        };
                        _.Oj = function MLd(a, b) {
                            return b;
                        };
                        _.Pj = function NLd() {
                            return false;
                        };
                        _.Qj = function OLd() {
                            return this.i != 0;
                        };
                        _.Ti = function PLd(a, b) {
                            return uLd(this, a, b);
                        };
                        _.gd = function QLd(a) {
                            return vLd(this, a);
                        };
                        _.Xi = function RLd(a, b) {
                            return xLd(this, a, b);
                        };
                        _.Uj = function SLd(a, b) {
                            return b;
                        };
                        _.Vj = function TLd(a, b) {
                            return b;
                        };
                        _.Wj = function ULd(a, b, c) {
                            return c;
                        };
                        var n6 = sfb(JHe, 'NotifyingListImpl', 2091);
                        feb(1187, 152, GJe, VLd);
                        _.Kj = function WLd() {
                            return this.a.Kj();
                        };
                        _.hj = function XLd(a) {
                            return this.a.Lj();
                        };
                        _.jj = function YLd() {
                            return this.a.jj();
                        };
                        var m6 = sfb(JHe, 'NotifyingListImpl/1', 1187);
                        feb(966, 66, PIe, ZLd);
                        _.Hc = function $Ld(a) {
                            if (this.i > 10) {
                                if (!this.b || this.c.j != this.a) {
                                    this.b = new btb(this);
                                    this.a = this.j;
                                }
                                return Zsb(this.b, a);
                            } else return PHd(this, a);
                        };
                        _.Yi = function _Ld() {
                            return true;
                        };
                        _.a = 0;
                        var o6 = sfb(sIe, 'AbstractEList/1', 966);
                        feb(302, 77, lxe, aMd);
                        var p6 = sfb(sIe, 'AbstractEList/BasicIndexOutOfBoundsException', 302);
                        feb(37, 1, Ave, dMd);
                        _.Nb = function gMd(a) {
                            Ztb(this, a);
                        };
                        _.Xj = function eMd() {
                            if (this.i.j != this.f) throw Adb(new Jrb);
                        };
                        _.Yj = function fMd() {
                            return bMd(this);
                        };
                        _.Ob = function hMd() {
                            return this.e != this.i.gc();
                        };
                        _.Pb = function iMd() {
                            return this.Yj();
                        };
                        _.Qb = function jMd() {
                            cMd(this);
                        };
                        _.e = 0;
                        _.f = 0;
                        _.g = -1;
                        var q6 = sfb(sIe, 'AbstractEList/EIterator', 37);
                        feb(286, 37, Jve, mMd, nMd);
                        _.Qb = function vMd() {
                            cMd(this);
                        };
                        _.Rb = function oMd(a) {
                            kMd(this, a);
                        };
                        _.Zj = function pMd() {
                            var b;
                            try {
                                b = this.d.Xb(--this.e);
                                this.Xj();
                                this.g = this.e;
                                return b;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) {
                                    this.Xj();
                                    throw Adb(new Dvb);
                                } else throw Adb(a);
                            }
                        };
                        _.$j = function qMd(a) {
                            lMd(this, a);
                        };
                        _.Sb = function rMd() {
                            return this.e != 0;
                        };
                        _.Tb = function sMd() {
                            return this.e;
                        };
                        _.Ub = function tMd() {
                            return this.Zj();
                        };
                        _.Vb = function uMd() {
                            return this.e - 1;
                        };
                        _.Wb = function wMd(a) {
                            this.$j(a);
                        };
                        var r6 = sfb(sIe, 'AbstractEList/EListIterator', 286);
                        feb(355, 37, Ave, yMd);
                        _.Yj = function zMd() {
                            return xMd(this);
                        };
                        _.Qb = function AMd() {
                            throw Adb(new jib);
                        };
                        var s6 = sfb(sIe, 'AbstractEList/NonResolvingEIterator', 355);
                        feb(398, 286, Jve, BMd, CMd);
                        _.Rb = function DMd(a) {
                            throw Adb(new jib);
                        };
                        _.Yj = function EMd() {
                            var b;
                            try {
                                b = this.c.Vi(this.e);
                                this.Xj();
                                this.g = this.e++;
                                return b;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) {
                                    this.Xj();
                                    throw Adb(new Dvb);
                                } else throw Adb(a);
                            }
                        };
                        _.Zj = function FMd() {
                            var b;
                            try {
                                b = this.c.Vi(--this.e);
                                this.Xj();
                                this.g = this.e;
                                return b;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) {
                                    this.Xj();
                                    throw Adb(new Dvb);
                                } else throw Adb(a);
                            }
                        };
                        _.Qb = function GMd() {
                            throw Adb(new jib);
                        };
                        _.Wb = function HMd(a) {
                            throw Adb(new jib);
                        };
                        var t6 = sfb(sIe, 'AbstractEList/NonResolvingEListIterator', 398);
                        feb(2080, 70, JJe);
                        _.Ei = function PMd(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m;
                            e = b.gc();
                            if (e != 0) {
                                j = RD(Ywd(this.a, 4), 129);
                                k = j == null ? 0 : j.length;
                                m = k + e;
                                d = NMd(this, m);
                                l = k - a;
                                l > 0 && hib(j, a, d, a + e, l);
                                i = b.Kc();
                                for(g = 0; g < e; ++g){
                                    h = i.Pb();
                                    c = a + g;
                                    LMd(d, c, gHd(this, h));
                                }
                                Bde(this, d);
                                for(f = 0; f < e; ++f){
                                    h = d[a];
                                    this.Mi(a, h);
                                    ++a;
                                }
                                return true;
                            } else {
                                ++this.j;
                                return false;
                            }
                        };
                        _.Fi = function QMd(a) {
                            var b, c, d, e, f, g, h, i, j;
                            d = a.gc();
                            if (d != 0) {
                                i = (c = RD(Ywd(this.a, 4), 129), c == null ? 0 : c.length);
                                j = i + d;
                                b = NMd(this, j);
                                h = a.Kc();
                                for(f = i; f < j; ++f){
                                    g = h.Pb();
                                    LMd(b, f, gHd(this, g));
                                }
                                Bde(this, b);
                                for(e = i; e < j; ++e){
                                    g = b[e];
                                    this.Mi(e, g);
                                }
                                return true;
                            } else {
                                ++this.j;
                                return false;
                            }
                        };
                        _.Gi = function RMd(a, b) {
                            var c, d, e, f;
                            d = RD(Ywd(this.a, 4), 129);
                            e = d == null ? 0 : d.length;
                            c = NMd(this, e + 1);
                            f = gHd(this, b);
                            a != e && hib(d, a, c, a + 1, e - a);
                            bD(c, a, f);
                            Bde(this, c);
                            this.Mi(a, b);
                        };
                        _.Hi = function SMd(a) {
                            var b, c, d;
                            d = (c = RD(Ywd(this.a, 4), 129), c == null ? 0 : c.length);
                            b = NMd(this, d + 1);
                            LMd(b, d, gHd(this, a));
                            Bde(this, b);
                            this.Mi(d, a);
                        };
                        _.Ii = function TMd() {
                            return new sNd(this);
                        };
                        _.Ji = function UMd() {
                            return new vNd(this);
                        };
                        _.Ki = function VMd(a) {
                            var b, c;
                            c = (b = RD(Ywd(this.a, 4), 129), b == null ? 0 : b.length);
                            if (a < 0 || a > c) throw Adb(new aMd(a, c));
                            return new wNd(this, a);
                        };
                        _.$b = function WMd() {
                            var a, b;
                            ++this.j;
                            a = RD(Ywd(this.a, 4), 129);
                            b = a == null ? 0 : a.length;
                            Bde(this, null);
                            $Gd(this, b, a);
                        };
                        _.Hc = function XMd(a) {
                            var b, c, d, e, f;
                            b = RD(Ywd(this.a, 4), 129);
                            if (b != null) {
                                if (a != null) for(d = b, e = 0, f = d.length; e < f; ++e){
                                    c = d[e];
                                    if (pb(a, c)) return true;
                                }
                                else for(d = b, e = 0, f = d.length; e < f; ++e){
                                    c = d[e];
                                    if (dE(c) === dE(a)) return true;
                                }
                            }
                            return false;
                        };
                        _.Xb = function YMd(a) {
                            var b, c;
                            b = RD(Ywd(this.a, 4), 129);
                            c = b == null ? 0 : b.length;
                            if (a >= c) throw Adb(new aMd(a, c));
                            return b[a];
                        };
                        _.dd = function ZMd(a) {
                            var b, c, d;
                            b = RD(Ywd(this.a, 4), 129);
                            if (b != null) {
                                if (a != null) for(c = 0, d = b.length; c < d; ++c){
                                    if (pb(a, b[c])) return c;
                                }
                                else for(c = 0, d = b.length; c < d; ++c){
                                    if (dE(b[c]) === dE(a)) return c;
                                }
                            }
                            return -1;
                        };
                        _.dc = function $Md() {
                            return RD(Ywd(this.a, 4), 129) == null;
                        };
                        _.Kc = function _Md() {
                            return new jNd(this);
                        };
                        _.ed = function aNd() {
                            return new nNd(this);
                        };
                        _.fd = function bNd(a) {
                            var b, c;
                            c = (b = RD(Ywd(this.a, 4), 129), b == null ? 0 : b.length);
                            if (a < 0 || a > c) throw Adb(new aMd(a, c));
                            return new oNd(this, a);
                        };
                        _.Ti = function cNd(a, b) {
                            var c, d, e;
                            c = MMd(this);
                            e = c == null ? 0 : c.length;
                            if (a >= e) throw Adb(new veb(MIe + a + NIe + e));
                            if (b >= e) throw Adb(new veb(OIe + b + NIe + e));
                            d = c[b];
                            if (a != b) {
                                a < b ? hib(c, a, c, a + 1, b - a) : hib(c, b + 1, c, b, a - b);
                                bD(c, a, d);
                                Bde(this, c);
                            }
                            return d;
                        };
                        _.Vi = function dNd(a) {
                            return RD(Ywd(this.a, 4), 129)[a];
                        };
                        _.gd = function eNd(a) {
                            return OMd(this, a);
                        };
                        _.Xi = function fNd(a, b) {
                            var c, d;
                            c = MMd(this);
                            d = c[a];
                            LMd(c, a, gHd(this, b));
                            Bde(this, c);
                            return d;
                        };
                        _.gc = function gNd() {
                            var a;
                            return a = RD(Ywd(this.a, 4), 129), a == null ? 0 : a.length;
                        };
                        _.Pc = function hNd() {
                            var a, b, c;
                            a = RD(Ywd(this.a, 4), 129);
                            c = a == null ? 0 : a.length;
                            b = $C(d6, IJe, 424, c, 0, 1);
                            c > 0 && hib(a, 0, b, 0, c);
                            return b;
                        };
                        _.Qc = function iNd(a) {
                            var b, c, d;
                            b = RD(Ywd(this.a, 4), 129);
                            d = b == null ? 0 : b.length;
                            if (d > 0) {
                                if (a.length < d) {
                                    c = IMd(rb(a).c, d);
                                    a = c;
                                }
                                hib(b, 0, a, 0, d);
                            }
                            a.length > d && bD(a, d, null);
                            return a;
                        };
                        var JMd;
                        var A6 = sfb(sIe, 'ArrayDelegatingEList', 2080);
                        feb(1051, 37, Ave, jNd);
                        _.Xj = function kNd() {
                            if (this.b.j != this.f || dE(RD(Ywd(this.b.a, 4), 129)) !== dE(this.a)) throw Adb(new Jrb);
                        };
                        _.Qb = function lNd() {
                            cMd(this);
                            this.a = RD(Ywd(this.b.a, 4), 129);
                        };
                        var w6 = sfb(sIe, 'ArrayDelegatingEList/EIterator', 1051);
                        feb(722, 286, Jve, nNd, oNd);
                        _.Xj = function pNd() {
                            if (this.b.j != this.f || dE(RD(Ywd(this.b.a, 4), 129)) !== dE(this.a)) throw Adb(new Jrb);
                        };
                        _.$j = function qNd(a) {
                            lMd(this, a);
                            this.a = RD(Ywd(this.b.a, 4), 129);
                        };
                        _.Qb = function rNd() {
                            cMd(this);
                            this.a = RD(Ywd(this.b.a, 4), 129);
                        };
                        var x6 = sfb(sIe, 'ArrayDelegatingEList/EListIterator', 722);
                        feb(1052, 355, Ave, sNd);
                        _.Xj = function tNd() {
                            if (this.b.j != this.f || dE(RD(Ywd(this.b.a, 4), 129)) !== dE(this.a)) throw Adb(new Jrb);
                        };
                        var y6 = sfb(sIe, 'ArrayDelegatingEList/NonResolvingEIterator', 1052);
                        feb(723, 398, Jve, vNd, wNd);
                        _.Xj = function xNd() {
                            if (this.b.j != this.f || dE(RD(Ywd(this.b.a, 4), 129)) !== dE(this.a)) throw Adb(new Jrb);
                        };
                        var z6 = sfb(sIe, 'ArrayDelegatingEList/NonResolvingEListIterator', 723);
                        feb(615, 302, lxe, yNd);
                        var B6 = sfb(sIe, 'BasicEList/BasicIndexOutOfBoundsException', 615);
                        feb(710, 66, PIe, zNd);
                        _.bd = function ANd(a, b) {
                            throw Adb(new jib);
                        };
                        _.Fc = function BNd(a) {
                            throw Adb(new jib);
                        };
                        _.cd = function CNd(a, b) {
                            throw Adb(new jib);
                        };
                        _.Gc = function DNd(a) {
                            throw Adb(new jib);
                        };
                        _.$b = function ENd() {
                            throw Adb(new jib);
                        };
                        _._i = function FNd(a) {
                            throw Adb(new jib);
                        };
                        _.Kc = function GNd() {
                            return this.Ii();
                        };
                        _.ed = function HNd() {
                            return this.Ji();
                        };
                        _.fd = function INd(a) {
                            return this.Ki(a);
                        };
                        _.Ti = function JNd(a, b) {
                            throw Adb(new jib);
                        };
                        _.Ui = function KNd(a, b) {
                            throw Adb(new jib);
                        };
                        _.gd = function LNd(a) {
                            throw Adb(new jib);
                        };
                        _.Mc = function MNd(a) {
                            throw Adb(new jib);
                        };
                        _.hd = function NNd(a, b) {
                            throw Adb(new jib);
                        };
                        var C6 = sfb(sIe, 'BasicEList/UnmodifiableEList', 710);
                        feb(721, 1, {
                            3: 1,
                            20: 1,
                            16: 1,
                            15: 1,
                            61: 1,
                            597: 1
                        });
                        _.bd = function mOd(a, b) {
                            ONd(this, a, RD(b, 44));
                        };
                        _.Fc = function nOd(a) {
                            return PNd(this, RD(a, 44));
                        };
                        _.Jc = function vOd(a) {
                            xgb(this, a);
                        };
                        _.Xb = function wOd(a) {
                            return RD(QHd(this.c, a), 136);
                        };
                        _.Ti = function FOd(a, b) {
                            return RD(this.c.Ti(a, b), 44);
                        };
                        _.Ui = function GOd(a, b) {
                            eOd(this, a, RD(b, 44));
                        };
                        _.Lc = function JOd() {
                            return new SDb(null, new Swb(this, 16));
                        };
                        _.gd = function KOd(a) {
                            return RD(this.c.gd(a), 44);
                        };
                        _.hd = function MOd(a, b) {
                            return kOd(this, a, RD(b, 44));
                        };
                        _.jd = function OOd(a) {
                            tvb(this, a);
                        };
                        _.Nc = function POd() {
                            return new Swb(this, 16);
                        };
                        _.Oc = function QOd() {
                            return new SDb(null, new Swb(this, 16));
                        };
                        _.cd = function oOd(a, b) {
                            return this.c.cd(a, b);
                        };
                        _.Gc = function pOd(a) {
                            return this.c.Gc(a);
                        };
                        _.$b = function qOd() {
                            this.c.$b();
                        };
                        _.Hc = function rOd(a) {
                            return this.c.Hc(a);
                        };
                        _.Ic = function sOd(a) {
                            return Be(this.c, a);
                        };
                        _._j = function tOd() {
                            var a, b, c;
                            if (this.d == null) {
                                this.d = $C(D6, KJe, 66, 2 * this.f + 1, 0, 1);
                                c = this.e;
                                this.f = 0;
                                for(b = this.c.Kc(); b.e != b.i.gc();){
                                    a = RD(b.Yj(), 136);
                                    UNd(this, a);
                                }
                                this.e = c;
                            }
                        };
                        _.Fb = function uOd(a) {
                            return ZNd(this, a);
                        };
                        _.Hb = function xOd() {
                            return cHd(this.c);
                        };
                        _.dd = function yOd(a) {
                            return this.c.dd(a);
                        };
                        _.ak = function zOd() {
                            this.c = new YOd(this);
                        };
                        _.dc = function AOd() {
                            return this.f == 0;
                        };
                        _.Kc = function BOd() {
                            return this.c.Kc();
                        };
                        _.ed = function COd() {
                            return this.c.ed();
                        };
                        _.fd = function DOd(a) {
                            return this.c.fd(a);
                        };
                        _.bk = function EOd() {
                            return dOd(this);
                        };
                        _.ck = function HOd(a, b, c) {
                            return new ZPd(a, b, c);
                        };
                        _.dk = function IOd() {
                            return new cPd;
                        };
                        _.Mc = function LOd(a) {
                            return hOd(this, a);
                        };
                        _.gc = function NOd() {
                            return this.f;
                        };
                        _.kd = function ROd(a, b) {
                            return new Rkb(this.c, a, b);
                        };
                        _.Pc = function SOd() {
                            return this.c.Pc();
                        };
                        _.Qc = function TOd(a) {
                            return this.c.Qc(a);
                        };
                        _.Ib = function UOd() {
                            return fHd(this.c);
                        };
                        _.e = 0;
                        _.f = 0;
                        var Q6 = sfb(sIe, 'BasicEMap', 721);
                        feb(1046, 66, PIe, YOd);
                        _.Mi = function ZOd(a, b) {
                            VOd(this, RD(b, 136));
                        };
                        _.Pi = function _Od(a, b, c) {
                            var d;
                            ++(d = this, RD(b, 136), d).a.e;
                        };
                        _.Qi = function aPd(a, b) {
                            WOd(this, RD(b, 136));
                        };
                        _.Ri = function bPd(a, b, c) {
                            XOd(this, RD(b, 136), RD(c, 136));
                        };
                        _.Oi = function $Od(a, b) {
                            TNd(this.a);
                        };
                        var E6 = sfb(sIe, 'BasicEMap/1', 1046);
                        feb(1047, 66, PIe, cPd);
                        _.aj = function dPd(a) {
                            return $C(N6, LJe, 621, a, 0, 1);
                        };
                        var F6 = sfb(sIe, 'BasicEMap/2', 1047);
                        feb(1048, Eve, Fve, ePd);
                        _.$b = function fPd() {
                            this.a.c.$b();
                        };
                        _.Hc = function gPd(a) {
                            return QNd(this.a, a);
                        };
                        _.Kc = function hPd() {
                            return this.a.f == 0 ? (jQd(), iQd.a) : new DPd(this.a);
                        };
                        _.Mc = function iPd(a) {
                            var b;
                            b = this.a.f;
                            jOd(this.a, a);
                            return this.a.f != b;
                        };
                        _.gc = function jPd() {
                            return this.a.f;
                        };
                        var G6 = sfb(sIe, 'BasicEMap/3', 1048);
                        feb(1049, 31, Dve, kPd);
                        _.$b = function lPd() {
                            this.a.c.$b();
                        };
                        _.Hc = function mPd(a) {
                            return RNd(this.a, a);
                        };
                        _.Kc = function nPd() {
                            return this.a.f == 0 ? (jQd(), iQd.a) : new FPd(this.a);
                        };
                        _.gc = function oPd() {
                            return this.a.f;
                        };
                        var H6 = sfb(sIe, 'BasicEMap/4', 1049);
                        feb(1050, Eve, Fve, qPd);
                        _.$b = function rPd() {
                            this.a.c.$b();
                        };
                        _.Hc = function sPd(a) {
                            var b, c, d, e, f, g, h, i, j;
                            if (this.a.f > 0 && ZD(a, 44)) {
                                this.a._j();
                                i = RD(a, 44);
                                h = i.ld();
                                e = h == null ? 0 : tb(h);
                                f = bOd(this.a, e);
                                b = this.a.d[f];
                                if (b) {
                                    c = RD(b.g, 379);
                                    j = b.i;
                                    for(g = 0; g < j; ++g){
                                        d = c[g];
                                        if (d.Bi() == e && d.Fb(i)) return true;
                                    }
                                }
                            }
                            return false;
                        };
                        _.Kc = function tPd() {
                            return this.a.f == 0 ? (jQd(), iQd.a) : new xPd(this.a);
                        };
                        _.Mc = function uPd(a) {
                            return pPd(this, a);
                        };
                        _.gc = function vPd() {
                            return this.a.f;
                        };
                        var I6 = sfb(sIe, 'BasicEMap/5', 1050);
                        feb(622, 1, Ave, xPd);
                        _.Nb = function yPd(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function zPd() {
                            return this.b != -1;
                        };
                        _.Pb = function APd() {
                            var a;
                            if (this.f.e != this.c) throw Adb(new Jrb);
                            if (this.b == -1) throw Adb(new Dvb);
                            this.d = this.a;
                            this.e = this.b;
                            wPd(this);
                            a = RD(this.f.d[this.d].g[this.e], 136);
                            return this.ek(a);
                        };
                        _.Qb = function BPd() {
                            if (this.f.e != this.c) throw Adb(new Jrb);
                            if (this.e == -1) throw Adb(new cgb);
                            this.f.c.Mc(QHd(this.f.d[this.d], this.e));
                            this.c = this.f.e;
                            this.e = -1;
                            this.a == this.d && this.b != -1 && --this.b;
                        };
                        _.ek = function CPd(a) {
                            return a;
                        };
                        _.a = 0;
                        _.b = -1;
                        _.c = 0;
                        _.d = 0;
                        _.e = 0;
                        var J6 = sfb(sIe, 'BasicEMap/BasicEMapIterator', 622);
                        feb(1044, 622, Ave, DPd);
                        _.ek = function EPd(a) {
                            return a.ld();
                        };
                        var K6 = sfb(sIe, 'BasicEMap/BasicEMapKeyIterator', 1044);
                        feb(1045, 622, Ave, FPd);
                        _.ek = function GPd(a) {
                            return a.md();
                        };
                        var L6 = sfb(sIe, 'BasicEMap/BasicEMapValueIterator', 1045);
                        feb(1043, 1, Cve, IPd);
                        _.wc = function OPd(a) {
                            Bvb(this, a);
                        };
                        _.yc = function TPd(a, b, c) {
                            return Cvb(this, a, b, c);
                        };
                        _.$b = function JPd() {
                            this.a.c.$b();
                        };
                        _._b = function KPd(a) {
                            return HPd(this, a);
                        };
                        _.uc = function LPd(a) {
                            return RNd(this.a, a);
                        };
                        _.vc = function MPd() {
                            return YNd(this.a);
                        };
                        _.Fb = function NPd(a) {
                            return ZNd(this.a, a);
                        };
                        _.xc = function PPd(a) {
                            return $Nd(this.a, a);
                        };
                        _.Hb = function QPd() {
                            return cHd(this.a.c);
                        };
                        _.dc = function RPd() {
                            return this.a.f == 0;
                        };
                        _.ec = function SPd() {
                            return cOd(this.a);
                        };
                        _.zc = function UPd(a, b) {
                            return fOd(this.a, a, b);
                        };
                        _.Bc = function VPd(a) {
                            return jOd(this.a, a);
                        };
                        _.gc = function WPd() {
                            return this.a.f;
                        };
                        _.Ib = function XPd() {
                            return fHd(this.a.c);
                        };
                        _.Cc = function YPd() {
                            return lOd(this.a);
                        };
                        var M6 = sfb(sIe, 'BasicEMap/DelegatingMap', 1043);
                        feb(621, 1, {
                            44: 1,
                            136: 1,
                            621: 1
                        }, ZPd);
                        _.Fb = function $Pd(a) {
                            var b;
                            if (ZD(a, 44)) {
                                b = RD(a, 44);
                                return (this.b != null ? pb(this.b, b.ld()) : dE(this.b) === dE(b.ld())) && (this.c != null ? pb(this.c, b.md()) : dE(this.c) === dE(b.md()));
                            } else return false;
                        };
                        _.Bi = function _Pd() {
                            return this.a;
                        };
                        _.ld = function aQd() {
                            return this.b;
                        };
                        _.md = function bQd() {
                            return this.c;
                        };
                        _.Hb = function cQd() {
                            return this.a ^ (this.c == null ? 0 : tb(this.c));
                        };
                        _.Ci = function dQd(a) {
                            this.a = a;
                        };
                        _.Di = function eQd(a) {
                            throw Adb(new xz);
                        };
                        _.nd = function fQd(a) {
                            var b;
                            b = this.c;
                            this.c = a;
                            return b;
                        };
                        _.Ib = function gQd() {
                            return this.b + '->' + this.c;
                        };
                        _.a = 0;
                        var N6 = sfb(sIe, 'BasicEMap/EntryImpl', 621);
                        feb(546, 1, {}, hQd);
                        var P6 = sfb(sIe, 'BasicEMap/View', 546);
                        var iQd;
                        feb(783, 1, {});
                        _.Fb = function xQd(a) {
                            return Rt((yob(), vob), a);
                        };
                        _.Hb = function yQd() {
                            return Cob((yob(), vob));
                        };
                        _.Ib = function zQd() {
                            return Fe((yob(), vob));
                        };
                        var V6 = sfb(sIe, 'ECollections/BasicEmptyUnmodifiableEList', 783);
                        feb(1348, 1, Jve, AQd);
                        _.Nb = function CQd(a) {
                            Ztb(this, a);
                        };
                        _.Rb = function BQd(a) {
                            throw Adb(new jib);
                        };
                        _.Ob = function DQd() {
                            return false;
                        };
                        _.Sb = function EQd() {
                            return false;
                        };
                        _.Pb = function FQd() {
                            throw Adb(new Dvb);
                        };
                        _.Tb = function GQd() {
                            return 0;
                        };
                        _.Ub = function HQd() {
                            throw Adb(new Dvb);
                        };
                        _.Vb = function IQd() {
                            return -1;
                        };
                        _.Qb = function JQd() {
                            throw Adb(new jib);
                        };
                        _.Wb = function KQd(a) {
                            throw Adb(new jib);
                        };
                        var U6 = sfb(sIe, 'ECollections/BasicEmptyUnmodifiableEList/1', 1348);
                        feb(1346, 783, {
                            20: 1,
                            16: 1,
                            15: 1,
                            61: 1
                        }, LQd);
                        _.bd = function MQd(a, b) {
                            mQd();
                        };
                        _.Fc = function NQd(a) {
                            return nQd();
                        };
                        _.cd = function OQd(a, b) {
                            return oQd();
                        };
                        _.Gc = function PQd(a) {
                            return pQd();
                        };
                        _.$b = function QQd() {
                            qQd();
                        };
                        _.Hc = function RQd(a) {
                            return false;
                        };
                        _.Ic = function SQd(a) {
                            return false;
                        };
                        _.Jc = function TQd(a) {
                            xgb(this, a);
                        };
                        _.Xb = function UQd(a) {
                            return Iob((yob(), vob, a)), null;
                        };
                        _.dd = function VQd(a) {
                            return -1;
                        };
                        _.dc = function WQd() {
                            return true;
                        };
                        _.Kc = function XQd() {
                            return this.a;
                        };
                        _.ed = function YQd() {
                            return this.a;
                        };
                        _.fd = function ZQd(a) {
                            return this.a;
                        };
                        _.Ti = function $Qd(a, b) {
                            return rQd();
                        };
                        _.Ui = function _Qd(a, b) {
                            sQd();
                        };
                        _.Lc = function aRd() {
                            return new SDb(null, new Swb(this, 16));
                        };
                        _.gd = function bRd(a) {
                            return tQd();
                        };
                        _.Mc = function cRd(a) {
                            return uQd();
                        };
                        _.hd = function dRd(a, b) {
                            return vQd();
                        };
                        _.gc = function eRd() {
                            return 0;
                        };
                        _.jd = function fRd(a) {
                            tvb(this, a);
                        };
                        _.Nc = function gRd() {
                            return new Swb(this, 16);
                        };
                        _.Oc = function hRd() {
                            return new SDb(null, new Swb(this, 16));
                        };
                        _.kd = function iRd(a, b) {
                            return yob(), new Rkb(vob, a, b);
                        };
                        _.Pc = function jRd() {
                            return De((yob(), vob));
                        };
                        _.Qc = function kRd(a) {
                            return yob(), Ee(vob, a);
                        };
                        var W6 = sfb(sIe, 'ECollections/EmptyUnmodifiableEList', 1346);
                        feb(1347, 783, {
                            20: 1,
                            16: 1,
                            15: 1,
                            61: 1,
                            597: 1
                        }, lRd);
                        _.bd = function mRd(a, b) {
                            mQd();
                        };
                        _.Fc = function nRd(a) {
                            return nQd();
                        };
                        _.cd = function oRd(a, b) {
                            return oQd();
                        };
                        _.Gc = function pRd(a) {
                            return pQd();
                        };
                        _.$b = function qRd() {
                            qQd();
                        };
                        _.Hc = function rRd(a) {
                            return false;
                        };
                        _.Ic = function sRd(a) {
                            return false;
                        };
                        _.Jc = function tRd(a) {
                            xgb(this, a);
                        };
                        _.Xb = function uRd(a) {
                            return Iob((yob(), vob, a)), null;
                        };
                        _.dd = function vRd(a) {
                            return -1;
                        };
                        _.dc = function wRd() {
                            return true;
                        };
                        _.Kc = function xRd() {
                            return this.a;
                        };
                        _.ed = function yRd() {
                            return this.a;
                        };
                        _.fd = function zRd(a) {
                            return this.a;
                        };
                        _.Ti = function BRd(a, b) {
                            return rQd();
                        };
                        _.Ui = function CRd(a, b) {
                            sQd();
                        };
                        _.Lc = function DRd() {
                            return new SDb(null, new Swb(this, 16));
                        };
                        _.gd = function ERd(a) {
                            return tQd();
                        };
                        _.Mc = function FRd(a) {
                            return uQd();
                        };
                        _.hd = function GRd(a, b) {
                            return vQd();
                        };
                        _.gc = function HRd() {
                            return 0;
                        };
                        _.jd = function IRd(a) {
                            tvb(this, a);
                        };
                        _.Nc = function JRd() {
                            return new Swb(this, 16);
                        };
                        _.Oc = function KRd() {
                            return new SDb(null, new Swb(this, 16));
                        };
                        _.kd = function LRd(a, b) {
                            return yob(), new Rkb(vob, a, b);
                        };
                        _.Pc = function MRd() {
                            return De((yob(), vob));
                        };
                        _.Qc = function NRd(a) {
                            return yob(), Ee(vob, a);
                        };
                        _.bk = function ARd() {
                            return yob(), yob(), wob;
                        };
                        var X6 = sfb(sIe, 'ECollections/EmptyUnmodifiableEMap', 1347);
                        var Z6 = ufb(sIe, 'Enumerator');
                        var ORd;
                        feb(288, 1, {
                            288: 1
                        }, lSd);
                        _.Fb = function pSd(a) {
                            var b;
                            if (this === a) return true;
                            if (!ZD(a, 288)) return false;
                            b = RD(a, 288);
                            return this.f == b.f && rSd(this.i, b.i) && qSd(this.a, (this.f & 256) != 0 ? (b.f & 256) != 0 ? b.a : null : (b.f & 256) != 0 ? null : b.a) && qSd(this.d, b.d) && qSd(this.g, b.g) && qSd(this.e, b.e) && iSd(this, b);
                        };
                        _.Hb = function uSd() {
                            return this.f;
                        };
                        _.Ib = function CSd() {
                            return jSd(this);
                        };
                        _.f = 0;
                        var SRd = 0, TRd = 0, URd = 0, VRd = 0, WRd = 0, XRd = 0, YRd = 0, ZRd = 0, $Rd = 0, _Rd, aSd = 0, bSd = 0, cSd = 0, dSd = 0, eSd, fSd;
                        var c7 = sfb(sIe, 'URI', 288);
                        feb(1121, 45, Hxe, MSd);
                        _.zc = function NSd(a, b) {
                            return RD($jb(this, WD(a), RD(b, 288)), 288);
                        };
                        var b7 = sfb(sIe, 'URI/URICache', 1121);
                        feb(506, 66, PIe, OSd, PSd);
                        _.Si = function QSd() {
                            return true;
                        };
                        var d7 = sfb(sIe, 'UniqueEList', 506);
                        feb(590, 63, swe, RSd);
                        var e7 = sfb(sIe, 'WrappedException', 590);
                        var f7 = ufb(vHe, OJe);
                        var A7 = ufb(vHe, PJe);
                        var y7 = ufb(vHe, QJe);
                        var g7 = ufb(vHe, RJe);
                        var i7 = ufb(vHe, SJe);
                        var h7 = ufb(vHe, 'EClass');
                        var k7 = ufb(vHe, 'EDataType');
                        var SSd;
                        feb(1233, 45, Hxe, VSd);
                        _.xc = function WSd(a) {
                            return bE(a) ? Xjb(this, a) : Wd(qtb(this.f, a));
                        };
                        var j7 = sfb(vHe, 'EDataType/Internal/ConversionDelegate/Factory/Registry/Impl', 1233);
                        var m7 = ufb(vHe, 'EEnum');
                        var l7 = ufb(vHe, TJe);
                        var o7 = ufb(vHe, UJe);
                        var s7 = ufb(vHe, VJe);
                        var XSd;
                        var u7 = ufb(vHe, WJe);
                        var v7 = ufb(vHe, XJe);
                        feb(1042, 1, {}, _Sd);
                        _.Ib = function aTd() {
                            return 'NIL';
                        };
                        var w7 = sfb(vHe, 'EStructuralFeature/Internal/DynamicValueHolder/1', 1042);
                        var bTd;
                        feb(1041, 45, Hxe, eTd);
                        _.xc = function fTd(a) {
                            return bE(a) ? Xjb(this, a) : Wd(qtb(this.f, a));
                        };
                        var x7 = sfb(vHe, 'EStructuralFeature/Internal/SettingDelegate/Factory/Registry/Impl', 1041);
                        var z7 = ufb(vHe, YJe);
                        var B7 = ufb(vHe, 'EValidator/PatternMatcher');
                        var gTd;
                        var iTd;
                        var kTd;
                        var mTd, nTd, oTd, pTd, qTd, rTd, sTd, tTd, uTd, vTd, wTd, xTd, yTd, zTd, ATd, BTd, CTd, DTd, ETd, FTd, GTd, HTd, ITd;
                        var Jbb = ufb(ZJe, 'FeatureMap/Entry');
                        feb(545, 1, {
                            76: 1
                        }, KTd);
                        _.Lk = function LTd() {
                            return this.a;
                        };
                        _.md = function MTd() {
                            return this.b;
                        };
                        var C7 = sfb(SHe, 'BasicEObjectImpl/1', 545);
                        feb(1040, 1, $Je, NTd);
                        _.Fk = function OTd(a) {
                            return Fvd(this.a, this.b, a);
                        };
                        _.Qj = function PTd() {
                            return Lvd(this.a, this.b);
                        };
                        _.Wb = function QTd(a) {
                            Xvd(this.a, this.b, a);
                        };
                        _.Gk = function RTd() {
                            _vd(this.a, this.b);
                        };
                        var D7 = sfb(SHe, 'BasicEObjectImpl/4', 1040);
                        feb(2081, 1, {
                            114: 1
                        });
                        _.Mk = function UTd(a) {
                            this.e = a == 0 ? STd : $C(jJ, rve, 1, a, 5, 1);
                        };
                        _.li = function VTd(a) {
                            return this.e[a];
                        };
                        _.mi = function WTd(a, b) {
                            this.e[a] = b;
                        };
                        _.ni = function XTd(a) {
                            this.e[a] = null;
                        };
                        _.Nk = function YTd() {
                            return this.c;
                        };
                        _.Ok = function ZTd() {
                            throw Adb(new jib);
                        };
                        _.Pk = function $Td() {
                            throw Adb(new jib);
                        };
                        _.Qk = function _Td() {
                            return this.d;
                        };
                        _.Rk = function aUd() {
                            return this.e != null;
                        };
                        _.Sk = function bUd(a) {
                            this.c = a;
                        };
                        _.Tk = function cUd(a) {
                            throw Adb(new jib);
                        };
                        _.Uk = function dUd(a) {
                            throw Adb(new jib);
                        };
                        _.Vk = function eUd(a) {
                            this.d = a;
                        };
                        var STd;
                        var E7 = sfb(SHe, 'BasicEObjectImpl/EPropertiesHolderBaseImpl', 2081);
                        feb(192, 2081, {
                            114: 1
                        }, fUd);
                        _.Ok = function gUd() {
                            return this.a;
                        };
                        _.Pk = function hUd() {
                            return this.b;
                        };
                        _.Tk = function iUd(a) {
                            this.a = a;
                        };
                        _.Uk = function jUd(a) {
                            this.b = a;
                        };
                        var F7 = sfb(SHe, 'BasicEObjectImpl/EPropertiesHolderImpl', 192);
                        feb(516, 99, RHe, kUd);
                        _.uh = function lUd() {
                            return this.f;
                        };
                        _.zh = function mUd() {
                            return this.k;
                        };
                        _.Bh = function nUd(a, b) {
                            this.g = a;
                            this.i = b;
                        };
                        _.Dh = function oUd() {
                            return (this.j & 2) == 0 ? this.ii() : this.$h().Nk();
                        };
                        _.Fh = function pUd() {
                            return this.i;
                        };
                        _.wh = function qUd() {
                            return (this.j & 1) != 0;
                        };
                        _.Ph = function rUd() {
                            return this.g;
                        };
                        _.Vh = function sUd() {
                            return (this.j & 4) != 0;
                        };
                        _.$h = function tUd() {
                            return !this.k && (this.k = new fUd), this.k;
                        };
                        _.ci = function uUd(a) {
                            this.$h().Sk(a);
                            a ? this.j |= 2 : this.j &= -3;
                        };
                        _.ei = function vUd(a) {
                            this.$h().Uk(a);
                            a ? this.j |= 4 : this.j &= -5;
                        };
                        _.ii = function wUd() {
                            return (lTd(), kTd).S;
                        };
                        _.i = 0;
                        _.j = 1;
                        var q8 = sfb(SHe, 'EObjectImpl', 516);
                        feb(798, 516, {
                            110: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1
                        }, zUd);
                        _.li = function AUd(a) {
                            return this.e[a];
                        };
                        _.mi = function BUd(a, b) {
                            this.e[a] = b;
                        };
                        _.ni = function CUd(a) {
                            this.e[a] = null;
                        };
                        _.Dh = function DUd() {
                            return this.d;
                        };
                        _.Ih = function EUd(a) {
                            return BYd(this.d, a);
                        };
                        _.Kh = function FUd() {
                            return this.d;
                        };
                        _.Oh = function GUd() {
                            return this.e != null;
                        };
                        _.$h = function HUd() {
                            !this.k && (this.k = new VUd);
                            return this.k;
                        };
                        _.ci = function IUd(a) {
                            this.d = a;
                        };
                        _.hi = function JUd() {
                            var a;
                            if (this.e == null) {
                                a = AYd(this.d);
                                this.e = a == 0 ? xUd : $C(jJ, rve, 1, a, 5, 1);
                            }
                            return this;
                        };
                        _.ji = function KUd() {
                            return 0;
                        };
                        var xUd;
                        var J7 = sfb(SHe, 'DynamicEObjectImpl', 798);
                        feb(1522, 798, {
                            110: 1,
                            44: 1,
                            94: 1,
                            93: 1,
                            136: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1
                        }, LUd);
                        _.Fb = function NUd(a) {
                            return this === a;
                        };
                        _.Hb = function RUd() {
                            return kFb(this);
                        };
                        _.ci = function MUd(a) {
                            this.d = a;
                            this.b = wYd(a, 'key');
                            this.c = wYd(a, aIe);
                        };
                        _.Bi = function OUd() {
                            var a;
                            if (this.a == -1) {
                                a = Gvd(this, this.b);
                                this.a = a == null ? 0 : tb(a);
                            }
                            return this.a;
                        };
                        _.ld = function PUd() {
                            return Gvd(this, this.b);
                        };
                        _.md = function QUd() {
                            return Gvd(this, this.c);
                        };
                        _.Ci = function SUd(a) {
                            this.a = a;
                        };
                        _.Di = function TUd(a) {
                            Xvd(this, this.b, a);
                        };
                        _.nd = function UUd(a) {
                            var b;
                            b = Gvd(this, this.c);
                            Xvd(this, this.c, a);
                            return b;
                        };
                        _.a = 0;
                        var H7 = sfb(SHe, 'DynamicEObjectImpl/BasicEMapEntry', 1522);
                        feb(1523, 1, {
                            114: 1
                        }, VUd);
                        _.Mk = function WUd(a) {
                            throw Adb(new jib);
                        };
                        _.li = function XUd(a) {
                            throw Adb(new jib);
                        };
                        _.mi = function YUd(a, b) {
                            throw Adb(new jib);
                        };
                        _.ni = function ZUd(a) {
                            throw Adb(new jib);
                        };
                        _.Nk = function $Ud() {
                            throw Adb(new jib);
                        };
                        _.Ok = function _Ud() {
                            return this.a;
                        };
                        _.Pk = function aVd() {
                            return this.b;
                        };
                        _.Qk = function bVd() {
                            return this.c;
                        };
                        _.Rk = function cVd() {
                            throw Adb(new jib);
                        };
                        _.Sk = function dVd(a) {
                            throw Adb(new jib);
                        };
                        _.Tk = function eVd(a) {
                            this.a = a;
                        };
                        _.Uk = function fVd(a) {
                            this.b = a;
                        };
                        _.Vk = function gVd(a) {
                            this.c = a;
                        };
                        var I7 = sfb(SHe, 'DynamicEObjectImpl/DynamicEPropertiesHolderImpl', 1523);
                        feb(519, 158, {
                            110: 1,
                            94: 1,
                            93: 1,
                            598: 1,
                            155: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            519: 1,
                            158: 1,
                            119: 1,
                            120: 1
                        }, pVd);
                        _.Ah = function qVd(a) {
                            return iVd(this, a);
                        };
                        _.Lh = function rVd(a, b, c) {
                            var d;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.d;
                                case 2:
                                    return c ? (!this.b && (this.b = new SVd((JTd(), FTd), C8, this)), this.b) : (!this.b && (this.b = new SVd((JTd(), FTd), C8, this)), dOd(this.b));
                                case 3:
                                    return kVd(this);
                                case 4:
                                    return !this.a && (this.a = new XZd(r7, this, 4)), this.a;
                                case 5:
                                    return !this.c && (this.c = new zie(r7, this, 5)), this.c;
                            }
                            return zvd(this, a - AYd((JTd(), mTd)), vYd((d = RD(Ywd(this, 16), 29), !d ? mTd : d), a), b, c);
                        };
                        _.Sh = function sVd(a, b, c) {
                            var d, e, f;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), qLd(this.Ab, a, c);
                                case 3:
                                    !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? iVd(this, c) : this.Cb.Th(this, -1 - e, null, c)));
                                    return hVd(this, RD(a, 155), c);
                            }
                            return f = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), mTd) : d), b), 69), f.wk().zk(this, Wwd(this), b - AYd((JTd(), mTd)), a, c);
                        };
                        _.Uh = function tVd(a, b, c) {
                            var d, e;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), rLd(this.Ab, a, c);
                                case 2:
                                    return !this.b && (this.b = new SVd((JTd(), FTd), C8, this)), BVd(this.b, a, c);
                                case 3:
                                    return hVd(this, null, c);
                                case 4:
                                    return !this.a && (this.a = new XZd(r7, this, 4)), rLd(this.a, a, c);
                            }
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), mTd) : d), b), 69), e.wk().Ak(this, Wwd(this), b - AYd((JTd(), mTd)), a, c);
                        };
                        _.Wh = function uVd(a) {
                            var b;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return this.d != null;
                                case 2:
                                    return !!this.b && this.b.f != 0;
                                case 3:
                                    return !!kVd(this);
                                case 4:
                                    return !!this.a && this.a.i != 0;
                                case 5:
                                    return !!this.c && this.c.i != 0;
                            }
                            return Avd(this, a - AYd((JTd(), mTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? mTd : b), a));
                        };
                        _.bi = function vVd(a, b) {
                            var c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                                case 1:
                                    mVd(this, WD(b));
                                    return;
                                case 2:
                                    !this.b && (this.b = new SVd((JTd(), FTd), C8, this));
                                    CVd(this.b, b);
                                    return;
                                case 3:
                                    lVd(this, RD(b, 155));
                                    return;
                                case 4:
                                    !this.a && (this.a = new XZd(r7, this, 4));
                                    sLd(this.a);
                                    !this.a && (this.a = new XZd(r7, this, 4));
                                    YGd(this.a, RD(b, 16));
                                    return;
                                case 5:
                                    !this.c && (this.c = new zie(r7, this, 5));
                                    sLd(this.c);
                                    !this.c && (this.c = new zie(r7, this, 5));
                                    YGd(this.c, RD(b, 16));
                                    return;
                            }
                            Bvd(this, a - AYd((JTd(), mTd)), vYd((c = RD(Ywd(this, 16), 29), !c ? mTd : c), a), b);
                        };
                        _.ii = function wVd() {
                            return JTd(), mTd;
                        };
                        _.ki = function xVd(a) {
                            var b;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                                case 1:
                                    nVd(this, null);
                                    return;
                                case 2:
                                    !this.b && (this.b = new SVd((JTd(), FTd), C8, this));
                                    this.b.c.$b();
                                    return;
                                case 3:
                                    lVd(this, null);
                                    return;
                                case 4:
                                    !this.a && (this.a = new XZd(r7, this, 4));
                                    sLd(this.a);
                                    return;
                                case 5:
                                    !this.c && (this.c = new zie(r7, this, 5));
                                    sLd(this.c);
                                    return;
                            }
                            Cvd(this, a - AYd((JTd(), mTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? mTd : b), a));
                        };
                        _.Ib = function yVd() {
                            return oVd(this);
                        };
                        _.d = null;
                        var L7 = sfb(SHe, 'EAnnotationImpl', 519);
                        feb(141, 721, _Je, DVd);
                        _.Gi = function EVd(a, b) {
                            zVd(this, a, RD(b, 44));
                        };
                        _.Wk = function FVd(a, b) {
                            return AVd(this, RD(a, 44), b);
                        };
                        _.$i = function GVd(a) {
                            return RD(RD(this.c, 71).$i(a), 136);
                        };
                        _.Ii = function HVd() {
                            return RD(this.c, 71).Ii();
                        };
                        _.Ji = function IVd() {
                            return RD(this.c, 71).Ji();
                        };
                        _.Ki = function JVd(a) {
                            return RD(this.c, 71).Ki(a);
                        };
                        _.Xk = function KVd(a, b) {
                            return BVd(this, a, b);
                        };
                        _.Fk = function LVd(a) {
                            return RD(this.c, 79).Fk(a);
                        };
                        _.ak = function MVd() {};
                        _.Qj = function NVd() {
                            return RD(this.c, 79).Qj();
                        };
                        _.ck = function OVd(a, b, c) {
                            var d;
                            d = RD(BXd(this.b).wi().si(this.b), 136);
                            d.Ci(a);
                            d.Di(b);
                            d.nd(c);
                            return d;
                        };
                        _.dk = function PVd() {
                            return new uje(this);
                        };
                        _.Wb = function QVd(a) {
                            CVd(this, a);
                        };
                        _.Gk = function RVd() {
                            RD(this.c, 79).Gk();
                        };
                        var Dbb = sfb(ZJe, 'EcoreEMap', 141);
                        feb(165, 141, _Je, SVd);
                        _._j = function TVd() {
                            var a, b, c, d, e, f;
                            if (this.d == null) {
                                f = $C(D6, KJe, 66, 2 * this.f + 1, 0, 1);
                                for(c = this.c.Kc(); c.e != c.i.gc();){
                                    b = RD(c.Yj(), 136);
                                    d = b.Bi();
                                    e = (d & lve) % f.length;
                                    a = f[e];
                                    !a && (a = f[e] = new uje(this));
                                    a.Fc(b);
                                }
                                this.d = f;
                            }
                        };
                        var K7 = sfb(SHe, 'EAnnotationImpl/1', 165);
                        feb(292, 448, {
                            110: 1,
                            94: 1,
                            93: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            114: 1,
                            481: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            292: 1,
                            119: 1,
                            120: 1
                        });
                        _.Lh = function eWd(a, b, c) {
                            var d, e;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.zb;
                                case 2:
                                    return Geb(), (this.Bb & 256) != 0 ? true : false;
                                case 3:
                                    return Geb(), (this.Bb & 512) != 0 ? true : false;
                                case 4:
                                    return sgb(this.s);
                                case 5:
                                    return sgb(this.t);
                                case 6:
                                    return Geb(), this.Jk() ? true : false;
                                case 7:
                                    return Geb(), e = this.s, e >= 1 ? true : false;
                                case 8:
                                    if (b) return WVd(this);
                                    return this.r;
                                case 9:
                                    return this.q;
                            }
                            return zvd(this, a - AYd(this.ii()), vYd((d = RD(Ywd(this, 16), 29), !d ? this.ii() : d), a), b, c);
                        };
                        _.Uh = function fWd(a, b, c) {
                            var d, e;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), rLd(this.Ab, a, c);
                                case 9:
                                    return VVd(this, c);
                            }
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? this.ii() : d), b), 69), e.wk().Ak(this, Wwd(this), b - AYd(this.ii()), a, c);
                        };
                        _.Wh = function gWd(a) {
                            var b, c;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return this.zb != null;
                                case 2:
                                    return (this.Bb & 256) == 0;
                                case 3:
                                    return (this.Bb & 512) == 0;
                                case 4:
                                    return this.s != 0;
                                case 5:
                                    return this.t != 1;
                                case 6:
                                    return this.Jk();
                                case 7:
                                    return c = this.s, c >= 1;
                                case 8:
                                    return !!this.r && !this.q.e && j2d(this.q).i == 0;
                                case 9:
                                    return !!this.q && !(!!this.r && !this.q.e && j2d(this.q).i == 0);
                            }
                            return Avd(this, a - AYd(this.ii()), vYd((b = RD(Ywd(this, 16), 29), !b ? this.ii() : b), a));
                        };
                        _.bi = function hWd(a, b) {
                            var c, d;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                                case 1:
                                    this.ui(WD(b));
                                    return;
                                case 2:
                                    _Vd(this, Heb(TD(b)));
                                    return;
                                case 3:
                                    aWd(this, Heb(TD(b)));
                                    return;
                                case 4:
                                    $Vd(this, RD(b, 17).a);
                                    return;
                                case 5:
                                    this.Zk(RD(b, 17).a);
                                    return;
                                case 8:
                                    YVd(this, RD(b, 142));
                                    return;
                                case 9:
                                    d = XVd(this, RD(b, 89), null);
                                    !!d && d.oj();
                                    return;
                            }
                            Bvd(this, a - AYd(this.ii()), vYd((c = RD(Ywd(this, 16), 29), !c ? this.ii() : c), a), b);
                        };
                        _.ii = function iWd() {
                            return JTd(), HTd;
                        };
                        _.ki = function jWd(a) {
                            var b, c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                                case 1:
                                    this.ui(null);
                                    return;
                                case 2:
                                    _Vd(this, true);
                                    return;
                                case 3:
                                    aWd(this, true);
                                    return;
                                case 4:
                                    $Vd(this, 0);
                                    return;
                                case 5:
                                    this.Zk(1);
                                    return;
                                case 8:
                                    YVd(this, null);
                                    return;
                                case 9:
                                    c = XVd(this, null, null);
                                    !!c && c.oj();
                                    return;
                            }
                            Cvd(this, a - AYd(this.ii()), vYd((b = RD(Ywd(this, 16), 29), !b ? this.ii() : b), a));
                        };
                        _.pi = function kWd() {
                            WVd(this);
                            this.Bb |= 1;
                        };
                        _.Hk = function lWd() {
                            return WVd(this);
                        };
                        _.Ik = function mWd() {
                            return this.t;
                        };
                        _.Jk = function nWd() {
                            var a;
                            return a = this.t, a > 1 || a == -1;
                        };
                        _.Si = function oWd() {
                            return (this.Bb & 512) != 0;
                        };
                        _.Yk = function pWd(a, b) {
                            return ZVd(this, a, b);
                        };
                        _.Zk = function qWd(a) {
                            bWd(this, a);
                        };
                        _.Ib = function rWd() {
                            return cWd(this);
                        };
                        _.s = 0;
                        _.t = 1;
                        var A9 = sfb(SHe, 'ETypedElementImpl', 292);
                        feb(462, 292, {
                            110: 1,
                            94: 1,
                            93: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            179: 1,
                            69: 1,
                            114: 1,
                            481: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            462: 1,
                            292: 1,
                            119: 1,
                            120: 1,
                            692: 1
                        });
                        _.Ah = function IWd(a) {
                            return sWd(this, a);
                        };
                        _.Lh = function JWd(a, b, c) {
                            var d, e;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.zb;
                                case 2:
                                    return Geb(), (this.Bb & 256) != 0 ? true : false;
                                case 3:
                                    return Geb(), (this.Bb & 512) != 0 ? true : false;
                                case 4:
                                    return sgb(this.s);
                                case 5:
                                    return sgb(this.t);
                                case 6:
                                    return Geb(), this.Jk() ? true : false;
                                case 7:
                                    return Geb(), e = this.s, e >= 1 ? true : false;
                                case 8:
                                    if (b) return WVd(this);
                                    return this.r;
                                case 9:
                                    return this.q;
                                case 10:
                                    return Geb(), (this.Bb & gwe) != 0 ? true : false;
                                case 11:
                                    return Geb(), (this.Bb & cKe) != 0 ? true : false;
                                case 12:
                                    return Geb(), (this.Bb & qxe) != 0 ? true : false;
                                case 13:
                                    return this.j;
                                case 14:
                                    return tWd(this);
                                case 15:
                                    return Geb(), (this.Bb & bKe) != 0 ? true : false;
                                case 16:
                                    return Geb(), (this.Bb & Ove) != 0 ? true : false;
                                case 17:
                                    return uWd(this);
                            }
                            return zvd(this, a - AYd(this.ii()), vYd((d = RD(Ywd(this, 16), 29), !d ? this.ii() : d), a), b, c);
                        };
                        _.Sh = function KWd(a, b, c) {
                            var d, e, f;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), qLd(this.Ab, a, c);
                                case 17:
                                    !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? sWd(this, c) : this.Cb.Th(this, -1 - e, null, c)));
                                    return xvd(this, a, 17, c);
                            }
                            return f = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? this.ii() : d), b), 69), f.wk().zk(this, Wwd(this), b - AYd(this.ii()), a, c);
                        };
                        _.Uh = function LWd(a, b, c) {
                            var d, e;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), rLd(this.Ab, a, c);
                                case 9:
                                    return VVd(this, c);
                                case 17:
                                    return xvd(this, null, 17, c);
                            }
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? this.ii() : d), b), 69), e.wk().Ak(this, Wwd(this), b - AYd(this.ii()), a, c);
                        };
                        _.Wh = function MWd(a) {
                            var b, c;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return this.zb != null;
                                case 2:
                                    return (this.Bb & 256) == 0;
                                case 3:
                                    return (this.Bb & 512) == 0;
                                case 4:
                                    return this.s != 0;
                                case 5:
                                    return this.t != 1;
                                case 6:
                                    return this.Jk();
                                case 7:
                                    return c = this.s, c >= 1;
                                case 8:
                                    return !!this.r && !this.q.e && j2d(this.q).i == 0;
                                case 9:
                                    return !!this.q && !(!!this.r && !this.q.e && j2d(this.q).i == 0);
                                case 10:
                                    return (this.Bb & gwe) == 0;
                                case 11:
                                    return (this.Bb & cKe) != 0;
                                case 12:
                                    return (this.Bb & qxe) != 0;
                                case 13:
                                    return this.j != null;
                                case 14:
                                    return tWd(this) != null;
                                case 15:
                                    return (this.Bb & bKe) != 0;
                                case 16:
                                    return (this.Bb & Ove) != 0;
                                case 17:
                                    return !!uWd(this);
                            }
                            return Avd(this, a - AYd(this.ii()), vYd((b = RD(Ywd(this, 16), 29), !b ? this.ii() : b), a));
                        };
                        _.bi = function NWd(a, b) {
                            var c, d;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                                case 1:
                                    CWd(this, WD(b));
                                    return;
                                case 2:
                                    _Vd(this, Heb(TD(b)));
                                    return;
                                case 3:
                                    aWd(this, Heb(TD(b)));
                                    return;
                                case 4:
                                    $Vd(this, RD(b, 17).a);
                                    return;
                                case 5:
                                    this.Zk(RD(b, 17).a);
                                    return;
                                case 8:
                                    YVd(this, RD(b, 142));
                                    return;
                                case 9:
                                    d = XVd(this, RD(b, 89), null);
                                    !!d && d.oj();
                                    return;
                                case 10:
                                    xWd(this, Heb(TD(b)));
                                    return;
                                case 11:
                                    FWd(this, Heb(TD(b)));
                                    return;
                                case 12:
                                    DWd(this, Heb(TD(b)));
                                    return;
                                case 13:
                                    yWd(this, WD(b));
                                    return;
                                case 15:
                                    EWd(this, Heb(TD(b)));
                                    return;
                                case 16:
                                    AWd(this, Heb(TD(b)));
                                    return;
                            }
                            Bvd(this, a - AYd(this.ii()), vYd((c = RD(Ywd(this, 16), 29), !c ? this.ii() : c), a), b);
                        };
                        _.ii = function OWd() {
                            return JTd(), GTd;
                        };
                        _.ki = function PWd(a) {
                            var b, c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                                case 1:
                                    ZD(this.Cb, 90) && v$d(yYd(RD(this.Cb, 90)), 4);
                                    PAd(this, null);
                                    return;
                                case 2:
                                    _Vd(this, true);
                                    return;
                                case 3:
                                    aWd(this, true);
                                    return;
                                case 4:
                                    $Vd(this, 0);
                                    return;
                                case 5:
                                    this.Zk(1);
                                    return;
                                case 8:
                                    YVd(this, null);
                                    return;
                                case 9:
                                    c = XVd(this, null, null);
                                    !!c && c.oj();
                                    return;
                                case 10:
                                    xWd(this, true);
                                    return;
                                case 11:
                                    FWd(this, false);
                                    return;
                                case 12:
                                    DWd(this, false);
                                    return;
                                case 13:
                                    this.i = null;
                                    zWd(this, null);
                                    return;
                                case 15:
                                    EWd(this, false);
                                    return;
                                case 16:
                                    AWd(this, false);
                                    return;
                            }
                            Cvd(this, a - AYd(this.ii()), vYd((b = RD(Ywd(this, 16), 29), !b ? this.ii() : b), a));
                        };
                        _.pi = function QWd() {
                            Afe(Qee((lke(), jke), this));
                            WVd(this);
                            this.Bb |= 1;
                        };
                        _.pk = function RWd() {
                            return this.f;
                        };
                        _.ik = function SWd() {
                            return tWd(this);
                        };
                        _.qk = function TWd() {
                            return uWd(this);
                        };
                        _.uk = function UWd() {
                            return null;
                        };
                        _.$k = function VWd() {
                            return this.k;
                        };
                        _.Lj = function WWd() {
                            return this.n;
                        };
                        _.vk = function XWd() {
                            return vWd(this);
                        };
                        _.wk = function YWd() {
                            var a, b, c, d, e, f, g, h, i;
                            if (!this.p) {
                                c = uWd(this);
                                (c.i == null && rYd(c), c.i).length;
                                d = this.uk();
                                !!d && AYd(uWd(d));
                                e = WVd(this);
                                g = e.kk();
                                a = !g ? null : (g.i & 1) != 0 ? g == xdb ? QI : g == kE ? bJ : g == jE ? ZI : g == iE ? VI : g == lE ? eJ : g == wdb ? lJ : g == gE ? RI : SI : g;
                                b = tWd(this);
                                h = e.ik();
                                Mje(this);
                                (this.Bb & Ove) != 0 && (!!(f = Tee((lke(), jke), c)) && f != this || !!(f = zfe(Qee(jke, this)))) ? this.p = new Z6d(this, f) : this.Jk() ? this.al() ? !d ? (this.Bb & bKe) != 0 ? !a ? this.bl() ? this.p = new i7d(42, this) : this.p = new i7d(0, this) : a == UK ? this.p = new g7d(50, O6, this) : this.bl() ? this.p = new g7d(43, a, this) : this.p = new g7d(1, a, this) : !a ? this.bl() ? this.p = new i7d(44, this) : this.p = new i7d(2, this) : a == UK ? this.p = new g7d(41, O6, this) : this.bl() ? this.p = new g7d(45, a, this) : this.p = new g7d(3, a, this) : (this.Bb & bKe) != 0 ? !a ? this.bl() ? this.p = new j7d(46, this, d) : this.p = new j7d(4, this, d) : this.bl() ? this.p = new h7d(47, a, this, d) : this.p = new h7d(5, a, this, d) : !a ? this.bl() ? this.p = new j7d(48, this, d) : this.p = new j7d(6, this, d) : this.bl() ? this.p = new h7d(49, a, this, d) : this.p = new h7d(7, a, this, d) : ZD(e, 156) ? a == Jbb ? this.p = new i7d(40, this) : (this.Bb & 512) != 0 ? (this.Bb & bKe) != 0 ? !a ? this.p = new i7d(8, this) : this.p = new g7d(9, a, this) : !a ? this.p = new i7d(10, this) : this.p = new g7d(11, a, this) : (this.Bb & bKe) != 0 ? !a ? this.p = new i7d(12, this) : this.p = new g7d(13, a, this) : !a ? this.p = new i7d(14, this) : this.p = new g7d(15, a, this) : !d ? this.bl() ? (this.Bb & bKe) != 0 ? !a ? this.p = new i7d(16, this) : this.p = new g7d(17, a, this) : !a ? this.p = new i7d(18, this) : this.p = new g7d(19, a, this) : (this.Bb & bKe) != 0 ? !a ? this.p = new i7d(20, this) : this.p = new g7d(21, a, this) : !a ? this.p = new i7d(22, this) : this.p = new g7d(23, a, this) : (i = d.t, i > 1 || i == -1 ? this.bl() ? (this.Bb & bKe) != 0 ? !a ? this.p = new j7d(24, this, d) : this.p = new h7d(25, a, this, d) : !a ? this.p = new j7d(26, this, d) : this.p = new h7d(27, a, this, d) : (this.Bb & bKe) != 0 ? !a ? this.p = new j7d(28, this, d) : this.p = new h7d(29, a, this, d) : !a ? this.p = new j7d(30, this, d) : this.p = new h7d(31, a, this, d) : this.bl() ? (this.Bb & bKe) != 0 ? !a ? this.p = new j7d(32, this, d) : this.p = new h7d(33, a, this, d) : !a ? this.p = new j7d(34, this, d) : this.p = new h7d(35, a, this, d) : (this.Bb & bKe) != 0 ? !a ? this.p = new j7d(36, this, d) : this.p = new h7d(37, a, this, d) : !a ? this.p = new j7d(38, this, d) : this.p = new h7d(39, a, this, d)) : this._k() ? this.bl() ? this.p = new K7d(RD(e, 29), this, d) : this.p = new C7d(RD(e, 29), this, d) : ZD(e, 156) ? a == Jbb ? this.p = new i7d(40, this) : (this.Bb & bKe) != 0 ? !a ? this.p = new J8d(RD(e, 156), b, h, this) : this.p = new L8d(b, h, this, (a8d(), g == kE ? Y7d : g == xdb ? T7d : g == lE ? Z7d : g == jE ? X7d : g == iE ? W7d : g == wdb ? _7d : g == gE ? U7d : g == hE ? V7d : $7d)) : !a ? this.p = new C8d(RD(e, 156), b, h, this) : this.p = new E8d(b, h, this, (a8d(), g == kE ? Y7d : g == xdb ? T7d : g == lE ? Z7d : g == jE ? X7d : g == iE ? W7d : g == wdb ? _7d : g == gE ? U7d : g == hE ? V7d : $7d)) : this.al() ? !d ? (this.Bb & bKe) != 0 ? this.bl() ? this.p = new d9d(RD(e, 29), this) : this.p = new b9d(RD(e, 29), this) : this.bl() ? this.p = new _8d(RD(e, 29), this) : this.p = new Z8d(RD(e, 29), this) : (this.Bb & bKe) != 0 ? this.bl() ? this.p = new l9d(RD(e, 29), this, d) : this.p = new j9d(RD(e, 29), this, d) : this.bl() ? this.p = new h9d(RD(e, 29), this, d) : this.p = new f9d(RD(e, 29), this, d) : this.bl() ? !d ? (this.Bb & bKe) != 0 ? this.p = new p9d(RD(e, 29), this) : this.p = new n9d(RD(e, 29), this) : (this.Bb & bKe) != 0 ? this.p = new t9d(RD(e, 29), this, d) : this.p = new r9d(RD(e, 29), this, d) : !d ? (this.Bb & bKe) != 0 ? this.p = new v9d(RD(e, 29), this) : this.p = new N8d(RD(e, 29), this) : (this.Bb & bKe) != 0 ? this.p = new z9d(RD(e, 29), this, d) : this.p = new x9d(RD(e, 29), this, d);
                            }
                            return this.p;
                        };
                        _.rk = function ZWd() {
                            return (this.Bb & gwe) != 0;
                        };
                        _._k = function $Wd() {
                            return false;
                        };
                        _.al = function _Wd() {
                            return false;
                        };
                        _.sk = function aXd() {
                            return (this.Bb & Ove) != 0;
                        };
                        _.xk = function bXd() {
                            return wWd(this);
                        };
                        _.bl = function cXd() {
                            return false;
                        };
                        _.tk = function dXd() {
                            return (this.Bb & bKe) != 0;
                        };
                        _.cl = function eXd(a) {
                            this.k = a;
                        };
                        _.ui = function fXd(a) {
                            CWd(this, a);
                        };
                        _.Ib = function gXd() {
                            return GWd(this);
                        };
                        _.e = false;
                        _.n = 0;
                        var s9 = sfb(SHe, 'EStructuralFeatureImpl', 462);
                        feb(331, 462, {
                            110: 1,
                            94: 1,
                            93: 1,
                            35: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            179: 1,
                            69: 1,
                            114: 1,
                            481: 1,
                            54: 1,
                            99: 1,
                            331: 1,
                            158: 1,
                            462: 1,
                            292: 1,
                            119: 1,
                            120: 1,
                            692: 1
                        }, mXd);
                        _.Lh = function nXd(a, b, c) {
                            var d, e;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.zb;
                                case 2:
                                    return Geb(), (this.Bb & 256) != 0 ? true : false;
                                case 3:
                                    return Geb(), (this.Bb & 512) != 0 ? true : false;
                                case 4:
                                    return sgb(this.s);
                                case 5:
                                    return sgb(this.t);
                                case 6:
                                    return Geb(), jXd(this) ? true : false;
                                case 7:
                                    return Geb(), e = this.s, e >= 1 ? true : false;
                                case 8:
                                    if (b) return WVd(this);
                                    return this.r;
                                case 9:
                                    return this.q;
                                case 10:
                                    return Geb(), (this.Bb & gwe) != 0 ? true : false;
                                case 11:
                                    return Geb(), (this.Bb & cKe) != 0 ? true : false;
                                case 12:
                                    return Geb(), (this.Bb & qxe) != 0 ? true : false;
                                case 13:
                                    return this.j;
                                case 14:
                                    return tWd(this);
                                case 15:
                                    return Geb(), (this.Bb & bKe) != 0 ? true : false;
                                case 16:
                                    return Geb(), (this.Bb & Ove) != 0 ? true : false;
                                case 17:
                                    return uWd(this);
                                case 18:
                                    return Geb(), (this.Bb & QHe) != 0 ? true : false;
                                case 19:
                                    if (b) return iXd(this);
                                    return hXd(this);
                            }
                            return zvd(this, a - AYd((JTd(), nTd)), vYd((d = RD(Ywd(this, 16), 29), !d ? nTd : d), a), b, c);
                        };
                        _.Wh = function oXd(a) {
                            var b, c;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return this.zb != null;
                                case 2:
                                    return (this.Bb & 256) == 0;
                                case 3:
                                    return (this.Bb & 512) == 0;
                                case 4:
                                    return this.s != 0;
                                case 5:
                                    return this.t != 1;
                                case 6:
                                    return jXd(this);
                                case 7:
                                    return c = this.s, c >= 1;
                                case 8:
                                    return !!this.r && !this.q.e && j2d(this.q).i == 0;
                                case 9:
                                    return !!this.q && !(!!this.r && !this.q.e && j2d(this.q).i == 0);
                                case 10:
                                    return (this.Bb & gwe) == 0;
                                case 11:
                                    return (this.Bb & cKe) != 0;
                                case 12:
                                    return (this.Bb & qxe) != 0;
                                case 13:
                                    return this.j != null;
                                case 14:
                                    return tWd(this) != null;
                                case 15:
                                    return (this.Bb & bKe) != 0;
                                case 16:
                                    return (this.Bb & Ove) != 0;
                                case 17:
                                    return !!uWd(this);
                                case 18:
                                    return (this.Bb & QHe) != 0;
                                case 19:
                                    return !!hXd(this);
                            }
                            return Avd(this, a - AYd((JTd(), nTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? nTd : b), a));
                        };
                        _.bi = function pXd(a, b) {
                            var c, d;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                                case 1:
                                    CWd(this, WD(b));
                                    return;
                                case 2:
                                    _Vd(this, Heb(TD(b)));
                                    return;
                                case 3:
                                    aWd(this, Heb(TD(b)));
                                    return;
                                case 4:
                                    $Vd(this, RD(b, 17).a);
                                    return;
                                case 5:
                                    lXd(this, RD(b, 17).a);
                                    return;
                                case 8:
                                    YVd(this, RD(b, 142));
                                    return;
                                case 9:
                                    d = XVd(this, RD(b, 89), null);
                                    !!d && d.oj();
                                    return;
                                case 10:
                                    xWd(this, Heb(TD(b)));
                                    return;
                                case 11:
                                    FWd(this, Heb(TD(b)));
                                    return;
                                case 12:
                                    DWd(this, Heb(TD(b)));
                                    return;
                                case 13:
                                    yWd(this, WD(b));
                                    return;
                                case 15:
                                    EWd(this, Heb(TD(b)));
                                    return;
                                case 16:
                                    AWd(this, Heb(TD(b)));
                                    return;
                                case 18:
                                    kXd(this, Heb(TD(b)));
                                    return;
                            }
                            Bvd(this, a - AYd((JTd(), nTd)), vYd((c = RD(Ywd(this, 16), 29), !c ? nTd : c), a), b);
                        };
                        _.ii = function qXd() {
                            return JTd(), nTd;
                        };
                        _.ki = function rXd(a) {
                            var b, c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                                case 1:
                                    ZD(this.Cb, 90) && v$d(yYd(RD(this.Cb, 90)), 4);
                                    PAd(this, null);
                                    return;
                                case 2:
                                    _Vd(this, true);
                                    return;
                                case 3:
                                    aWd(this, true);
                                    return;
                                case 4:
                                    $Vd(this, 0);
                                    return;
                                case 5:
                                    this.b = 0;
                                    bWd(this, 1);
                                    return;
                                case 8:
                                    YVd(this, null);
                                    return;
                                case 9:
                                    c = XVd(this, null, null);
                                    !!c && c.oj();
                                    return;
                                case 10:
                                    xWd(this, true);
                                    return;
                                case 11:
                                    FWd(this, false);
                                    return;
                                case 12:
                                    DWd(this, false);
                                    return;
                                case 13:
                                    this.i = null;
                                    zWd(this, null);
                                    return;
                                case 15:
                                    EWd(this, false);
                                    return;
                                case 16:
                                    AWd(this, false);
                                    return;
                                case 18:
                                    kXd(this, false);
                                    return;
                            }
                            Cvd(this, a - AYd((JTd(), nTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? nTd : b), a));
                        };
                        _.pi = function sXd() {
                            iXd(this);
                            Afe(Qee((lke(), jke), this));
                            WVd(this);
                            this.Bb |= 1;
                        };
                        _.Jk = function tXd() {
                            return jXd(this);
                        };
                        _.Yk = function uXd(a, b) {
                            this.b = 0;
                            this.a = null;
                            return ZVd(this, a, b);
                        };
                        _.Zk = function vXd(a) {
                            lXd(this, a);
                        };
                        _.Ib = function wXd() {
                            var a;
                            if ((this.Db & 64) != 0) return GWd(this);
                            a = new Shb(GWd(this));
                            a.a += ' (iD: ';
                            Ohb(a, (this.Bb & QHe) != 0);
                            a.a += ')';
                            return a.a;
                        };
                        _.b = 0;
                        var M7 = sfb(SHe, 'EAttributeImpl', 331);
                        feb(364, 448, {
                            110: 1,
                            94: 1,
                            93: 1,
                            142: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            364: 1,
                            158: 1,
                            119: 1,
                            120: 1,
                            691: 1
                        });
                        _.dl = function NXd(a) {
                            return a.Dh() == this;
                        };
                        _.Ah = function OXd(a) {
                            return AXd(this, a);
                        };
                        _.Bh = function PXd(a, b) {
                            this.w = null;
                            this.Db = b << 16 | this.Db & 255;
                            this.Cb = a;
                        };
                        _.Lh = function QXd(a, b, c) {
                            var d;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.zb;
                                case 2:
                                    return this.D != null ? this.D : this.B;
                                case 3:
                                    return DXd(this);
                                case 4:
                                    return this.ik();
                                case 5:
                                    return this.F;
                                case 6:
                                    if (b) return BXd(this);
                                    return xXd(this);
                                case 7:
                                    return !this.A && (this.A = new iie(z7, this, 7)), this.A;
                            }
                            return zvd(this, a - AYd(this.ii()), vYd((d = RD(Ywd(this, 16), 29), !d ? this.ii() : d), a), b, c);
                        };
                        _.Sh = function RXd(a, b, c) {
                            var d, e, f;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), qLd(this.Ab, a, c);
                                case 6:
                                    !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? AXd(this, c) : this.Cb.Th(this, -1 - e, null, c)));
                                    return xvd(this, a, 6, c);
                            }
                            return f = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? this.ii() : d), b), 69), f.wk().zk(this, Wwd(this), b - AYd(this.ii()), a, c);
                        };
                        _.Uh = function SXd(a, b, c) {
                            var d, e;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), rLd(this.Ab, a, c);
                                case 6:
                                    return xvd(this, null, 6, c);
                                case 7:
                                    return !this.A && (this.A = new iie(z7, this, 7)), rLd(this.A, a, c);
                            }
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? this.ii() : d), b), 69), e.wk().Ak(this, Wwd(this), b - AYd(this.ii()), a, c);
                        };
                        _.Wh = function TXd(a) {
                            var b;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return this.zb != null;
                                case 2:
                                    return this.D != null && this.D == this.F;
                                case 3:
                                    return !!DXd(this);
                                case 4:
                                    return this.ik() != null;
                                case 5:
                                    return this.F != null && this.F != this.D && this.F != this.B;
                                case 6:
                                    return !!xXd(this);
                                case 7:
                                    return !!this.A && this.A.i != 0;
                            }
                            return Avd(this, a - AYd(this.ii()), vYd((b = RD(Ywd(this, 16), 29), !b ? this.ii() : b), a));
                        };
                        _.bi = function UXd(a, b) {
                            var c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                                case 1:
                                    LXd(this, WD(b));
                                    return;
                                case 2:
                                    IXd(this, WD(b));
                                    return;
                                case 5:
                                    KXd(this, WD(b));
                                    return;
                                case 7:
                                    !this.A && (this.A = new iie(z7, this, 7));
                                    sLd(this.A);
                                    !this.A && (this.A = new iie(z7, this, 7));
                                    YGd(this.A, RD(b, 16));
                                    return;
                            }
                            Bvd(this, a - AYd(this.ii()), vYd((c = RD(Ywd(this, 16), 29), !c ? this.ii() : c), a), b);
                        };
                        _.ii = function VXd() {
                            return JTd(), pTd;
                        };
                        _.ki = function WXd(a) {
                            var b;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                                case 1:
                                    ZD(this.Cb, 184) && (RD(this.Cb, 184).tb = null);
                                    PAd(this, null);
                                    return;
                                case 2:
                                    yXd(this, null);
                                    zXd(this, this.D);
                                    return;
                                case 5:
                                    KXd(this, null);
                                    return;
                                case 7:
                                    !this.A && (this.A = new iie(z7, this, 7));
                                    sLd(this.A);
                                    return;
                            }
                            Cvd(this, a - AYd(this.ii()), vYd((b = RD(Ywd(this, 16), 29), !b ? this.ii() : b), a));
                        };
                        _.hk = function XXd() {
                            var a;
                            return this.G == -1 && (this.G = (a = BXd(this), a ? fZd(a.vi(), this) : -1)), this.G;
                        };
                        _.ik = function YXd() {
                            return null;
                        };
                        _.jk = function ZXd() {
                            return BXd(this);
                        };
                        _.el = function $Xd() {
                            return this.v;
                        };
                        _.kk = function _Xd() {
                            return DXd(this);
                        };
                        _.lk = function aYd() {
                            return this.D != null ? this.D : this.B;
                        };
                        _.mk = function bYd() {
                            return this.F;
                        };
                        _.fk = function cYd(a) {
                            return FXd(this, a);
                        };
                        _.fl = function dYd(a) {
                            this.v = a;
                        };
                        _.gl = function eYd(a) {
                            GXd(this, a);
                        };
                        _.hl = function fYd(a) {
                            this.C = a;
                        };
                        _.ui = function gYd(a) {
                            LXd(this, a);
                        };
                        _.Ib = function hYd() {
                            return MXd(this);
                        };
                        _.C = null;
                        _.D = null;
                        _.G = -1;
                        var c8 = sfb(SHe, 'EClassifierImpl', 364);
                        feb(90, 364, {
                            110: 1,
                            94: 1,
                            93: 1,
                            29: 1,
                            142: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            90: 1,
                            364: 1,
                            158: 1,
                            482: 1,
                            119: 1,
                            120: 1,
                            691: 1
                        }, HYd);
                        _.dl = function IYd(a) {
                            return DYd(this, a.Dh());
                        };
                        _.Lh = function JYd(a, b, c) {
                            var d;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.zb;
                                case 2:
                                    return this.D != null ? this.D : this.B;
                                case 3:
                                    return DXd(this);
                                case 4:
                                    return null;
                                case 5:
                                    return this.F;
                                case 6:
                                    if (b) return BXd(this);
                                    return xXd(this);
                                case 7:
                                    return !this.A && (this.A = new iie(z7, this, 7)), this.A;
                                case 8:
                                    return Geb(), (this.Bb & 256) != 0 ? true : false;
                                case 9:
                                    return Geb(), (this.Bb & 512) != 0 ? true : false;
                                case 10:
                                    return zYd(this);
                                case 11:
                                    return !this.q && (this.q = new C5d(s7, this, 11, 10)), this.q;
                                case 12:
                                    return mYd(this);
                                case 13:
                                    return qYd(this);
                                case 14:
                                    return qYd(this), this.r;
                                case 15:
                                    return mYd(this), this.k;
                                case 16:
                                    return nYd(this);
                                case 17:
                                    return pYd(this);
                                case 18:
                                    return rYd(this);
                                case 19:
                                    return sYd(this);
                                case 20:
                                    return mYd(this), this.o;
                                case 21:
                                    return !this.s && (this.s = new C5d(y7, this, 21, 17)), this.s;
                                case 22:
                                    return tYd(this);
                                case 23:
                                    return oYd(this);
                            }
                            return zvd(this, a - AYd((JTd(), oTd)), vYd((d = RD(Ywd(this, 16), 29), !d ? oTd : d), a), b, c);
                        };
                        _.Sh = function KYd(a, b, c) {
                            var d, e, f;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), qLd(this.Ab, a, c);
                                case 6:
                                    !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? AXd(this, c) : this.Cb.Th(this, -1 - e, null, c)));
                                    return xvd(this, a, 6, c);
                                case 11:
                                    return !this.q && (this.q = new C5d(s7, this, 11, 10)), qLd(this.q, a, c);
                                case 21:
                                    return !this.s && (this.s = new C5d(y7, this, 21, 17)), qLd(this.s, a, c);
                            }
                            return f = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), oTd) : d), b), 69), f.wk().zk(this, Wwd(this), b - AYd((JTd(), oTd)), a, c);
                        };
                        _.Uh = function LYd(a, b, c) {
                            var d, e;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), rLd(this.Ab, a, c);
                                case 6:
                                    return xvd(this, null, 6, c);
                                case 7:
                                    return !this.A && (this.A = new iie(z7, this, 7)), rLd(this.A, a, c);
                                case 11:
                                    return !this.q && (this.q = new C5d(s7, this, 11, 10)), rLd(this.q, a, c);
                                case 21:
                                    return !this.s && (this.s = new C5d(y7, this, 21, 17)), rLd(this.s, a, c);
                                case 22:
                                    return rLd(tYd(this), a, c);
                            }
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), oTd) : d), b), 69), e.wk().Ak(this, Wwd(this), b - AYd((JTd(), oTd)), a, c);
                        };
                        _.Wh = function MYd(a) {
                            var b;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return this.zb != null;
                                case 2:
                                    return this.D != null && this.D == this.F;
                                case 3:
                                    return !!DXd(this);
                                case 4:
                                    return false;
                                case 5:
                                    return this.F != null && this.F != this.D && this.F != this.B;
                                case 6:
                                    return !!xXd(this);
                                case 7:
                                    return !!this.A && this.A.i != 0;
                                case 8:
                                    return (this.Bb & 256) != 0;
                                case 9:
                                    return (this.Bb & 512) != 0;
                                case 10:
                                    return !!this.u && tYd(this.u.a).i != 0 && !(!!this.n && d$d(this.n));
                                case 11:
                                    return !!this.q && this.q.i != 0;
                                case 12:
                                    return mYd(this).i != 0;
                                case 13:
                                    return qYd(this).i != 0;
                                case 14:
                                    return qYd(this), this.r.i != 0;
                                case 15:
                                    return mYd(this), this.k.i != 0;
                                case 16:
                                    return nYd(this).i != 0;
                                case 17:
                                    return pYd(this).i != 0;
                                case 18:
                                    return rYd(this).i != 0;
                                case 19:
                                    return sYd(this).i != 0;
                                case 20:
                                    return mYd(this), !!this.o;
                                case 21:
                                    return !!this.s && this.s.i != 0;
                                case 22:
                                    return !!this.n && d$d(this.n);
                                case 23:
                                    return oYd(this).i != 0;
                            }
                            return Avd(this, a - AYd((JTd(), oTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? oTd : b), a));
                        };
                        _.Zh = function NYd(a) {
                            var b;
                            b = this.i == null || !!this.q && this.q.i != 0 ? null : wYd(this, a);
                            return b ? b : _zd(this, a);
                        };
                        _.bi = function OYd(a, b) {
                            var c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                                case 1:
                                    LXd(this, WD(b));
                                    return;
                                case 2:
                                    IXd(this, WD(b));
                                    return;
                                case 5:
                                    KXd(this, WD(b));
                                    return;
                                case 7:
                                    !this.A && (this.A = new iie(z7, this, 7));
                                    sLd(this.A);
                                    !this.A && (this.A = new iie(z7, this, 7));
                                    YGd(this.A, RD(b, 16));
                                    return;
                                case 8:
                                    EYd(this, Heb(TD(b)));
                                    return;
                                case 9:
                                    FYd(this, Heb(TD(b)));
                                    return;
                                case 10:
                                    VJd(zYd(this));
                                    YGd(zYd(this), RD(b, 16));
                                    return;
                                case 11:
                                    !this.q && (this.q = new C5d(s7, this, 11, 10));
                                    sLd(this.q);
                                    !this.q && (this.q = new C5d(s7, this, 11, 10));
                                    YGd(this.q, RD(b, 16));
                                    return;
                                case 21:
                                    !this.s && (this.s = new C5d(y7, this, 21, 17));
                                    sLd(this.s);
                                    !this.s && (this.s = new C5d(y7, this, 21, 17));
                                    YGd(this.s, RD(b, 16));
                                    return;
                                case 22:
                                    sLd(tYd(this));
                                    YGd(tYd(this), RD(b, 16));
                                    return;
                            }
                            Bvd(this, a - AYd((JTd(), oTd)), vYd((c = RD(Ywd(this, 16), 29), !c ? oTd : c), a), b);
                        };
                        _.ii = function PYd() {
                            return JTd(), oTd;
                        };
                        _.ki = function QYd(a) {
                            var b;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                                case 1:
                                    ZD(this.Cb, 184) && (RD(this.Cb, 184).tb = null);
                                    PAd(this, null);
                                    return;
                                case 2:
                                    yXd(this, null);
                                    zXd(this, this.D);
                                    return;
                                case 5:
                                    KXd(this, null);
                                    return;
                                case 7:
                                    !this.A && (this.A = new iie(z7, this, 7));
                                    sLd(this.A);
                                    return;
                                case 8:
                                    EYd(this, false);
                                    return;
                                case 9:
                                    FYd(this, false);
                                    return;
                                case 10:
                                    !!this.u && VJd(this.u);
                                    return;
                                case 11:
                                    !this.q && (this.q = new C5d(s7, this, 11, 10));
                                    sLd(this.q);
                                    return;
                                case 21:
                                    !this.s && (this.s = new C5d(y7, this, 21, 17));
                                    sLd(this.s);
                                    return;
                                case 22:
                                    !!this.n && sLd(this.n);
                                    return;
                            }
                            Cvd(this, a - AYd((JTd(), oTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? oTd : b), a));
                        };
                        _.pi = function RYd() {
                            var a, b;
                            mYd(this);
                            qYd(this);
                            nYd(this);
                            pYd(this);
                            rYd(this);
                            sYd(this);
                            oYd(this);
                            OHd(q$d(yYd(this)));
                            if (this.s) for(a = 0, b = this.s.i; a < b; ++a)aAd(QHd(this.s, a));
                            if (this.q) for(a = 0, b = this.q.i; a < b; ++a)aAd(QHd(this.q, a));
                            Oee((lke(), jke), this).xe();
                            this.Bb |= 1;
                        };
                        _.Ib = function SYd() {
                            return GYd(this);
                        };
                        _.k = null;
                        _.r = null;
                        var iYd, jYd, kYd;
                        var b8 = sfb(SHe, 'EClassImpl', 90);
                        feb(2092, 2091, nKe);
                        _.Ei = function TYd(a, b) {
                            return nLd(this, a, b);
                        };
                        _.Fi = function UYd(a) {
                            return nLd(this, this.i, a);
                        };
                        _.Gi = function VYd(a, b) {
                            oLd(this, a, b);
                        };
                        _.Hi = function WYd(a) {
                            pLd(this, a);
                        };
                        _.Wk = function XYd(a, b) {
                            return qLd(this, a, b);
                        };
                        _.$i = function YYd(a) {
                            return NHd(this, a);
                        };
                        _.Xk = function aZd(a, b) {
                            return rLd(this, a, b);
                        };
                        _.Xi = function bZd(a, b) {
                            return xLd(this, a, b);
                        };
                        _.Ii = function ZYd() {
                            return new yMd(this);
                        };
                        _.Ji = function $Yd() {
                            return new BMd(this);
                        };
                        _.Ki = function _Yd(a) {
                            return ZGd(this, a);
                        };
                        var Ubb = sfb(ZJe, 'NotifyingInternalEListImpl', 2092);
                        feb(632, 2092, oKe);
                        _.Hc = function lZd(a) {
                            return cZd(this, a);
                        };
                        _.Ij = function mZd(a, b, c, d, e) {
                            return dZd(this, a, b, c, d, e);
                        };
                        _.Jj = function nZd(a) {
                            eZd(this, a);
                        };
                        _.Fk = function oZd(a) {
                            return this;
                        };
                        _.Lk = function pZd() {
                            return vYd(this.e.Dh(), this.Lj());
                        };
                        _.Kj = function qZd() {
                            return this.Lk();
                        };
                        _.Lj = function rZd() {
                            return BYd(this.e.Dh(), this.Lk());
                        };
                        _.il = function sZd() {
                            return RD(this.Lk().Hk(), 29).kk();
                        };
                        _.jl = function tZd() {
                            return Z5d(RD(this.Lk(), 19)).n;
                        };
                        _.jj = function uZd() {
                            return this.e;
                        };
                        _.kl = function vZd() {
                            return true;
                        };
                        _.ll = function wZd() {
                            return false;
                        };
                        _.ml = function xZd() {
                            return false;
                        };
                        _.nl = function yZd() {
                            return false;
                        };
                        _.dd = function zZd(a) {
                            return fZd(this, a);
                        };
                        _.Nj = function AZd(a, b) {
                            var c;
                            return c = RD(a, 54), this.ml() ? this.kl() ? c.Rh(this.e, this.jl(), this.il(), b) : c.Rh(this.e, BYd(c.Dh(), Z5d(RD(this.Lk(), 19))), null, b) : c.Rh(this.e, -1 - this.Lj(), null, b);
                        };
                        _.Oj = function BZd(a, b) {
                            var c;
                            return c = RD(a, 54), this.ml() ? this.kl() ? c.Th(this.e, this.jl(), this.il(), b) : c.Th(this.e, BYd(c.Dh(), Z5d(RD(this.Lk(), 19))), null, b) : c.Th(this.e, -1 - this.Lj(), null, b);
                        };
                        _.al = function CZd() {
                            return false;
                        };
                        _.ol = function DZd() {
                            return true;
                        };
                        _.fk = function EZd(a) {
                            return QRd(this.d, a);
                        };
                        _.Pj = function FZd() {
                            return Mvd(this.e);
                        };
                        _.Qj = function GZd() {
                            return this.i != 0;
                        };
                        _.aj = function HZd(a) {
                            return IMd(this.d, a);
                        };
                        _.Wi = function IZd(a, b) {
                            return this.ol() && this.nl() ? gZd(this, a, RD(b, 58)) : b;
                        };
                        _.pl = function JZd(a) {
                            return a.Vh() ? Vvd(this.e, RD(a, 54)) : a;
                        };
                        _.Wb = function KZd(a) {
                            hZd(this, a);
                        };
                        _.Pc = function LZd() {
                            return iZd(this);
                        };
                        _.Qc = function MZd(a) {
                            var b;
                            if (this.nl()) for(b = this.i - 1; b >= 0; --b)QHd(this, b);
                            return XHd(this, a);
                        };
                        _.Gk = function NZd() {
                            sLd(this);
                        };
                        _.Zi = function OZd(a, b) {
                            return jZd(this, a, b);
                        };
                        var ybb = sfb(ZJe, 'EcoreEList', 632);
                        feb(505, 632, oKe, PZd);
                        _.Li = function QZd() {
                            return false;
                        };
                        _.Lj = function RZd() {
                            return this.c;
                        };
                        _.Mj = function SZd() {
                            return false;
                        };
                        _.ol = function TZd() {
                            return true;
                        };
                        _.Si = function UZd() {
                            return true;
                        };
                        _.Wi = function VZd(a, b) {
                            return b;
                        };
                        _.Yi = function WZd() {
                            return false;
                        };
                        _.c = 0;
                        var ibb = sfb(ZJe, 'EObjectEList', 505);
                        feb(83, 505, oKe, XZd);
                        _.Mj = function YZd() {
                            return true;
                        };
                        _.ml = function ZZd() {
                            return false;
                        };
                        _.al = function $Zd() {
                            return true;
                        };
                        var cbb = sfb(ZJe, 'EObjectContainmentEList', 83);
                        feb(555, 83, oKe, _Zd);
                        _.Ni = function a$d() {
                            this.b = true;
                        };
                        _.Qj = function b$d() {
                            return this.b;
                        };
                        _.Gk = function c$d() {
                            var a;
                            sLd(this);
                            if (Mvd(this.e)) {
                                a = this.b;
                                this.b = false;
                                qvd(this.e, new Q3d(this.e, 2, this.c, a, false));
                            } else this.b = false;
                        };
                        _.b = false;
                        var bbb = sfb(ZJe, 'EObjectContainmentEList/Unsettable', 555);
                        feb(1161, 555, oKe, h$d);
                        _.Ti = function l$d(a, b) {
                            var c, d;
                            return c = RD(uLd(this, a, b), 89), Mvd(this.e) && eZd(this, new c4d(this.a, 7, (JTd(), qTd), sgb(b), (d = c.c, ZD(d, 90) ? RD(d, 29) : zTd), a)), c;
                        };
                        _.Uj = function m$d(a, b) {
                            return e$d(this, RD(a, 89), b);
                        };
                        _.Vj = function n$d(a, b) {
                            return f$d(this, RD(a, 89), b);
                        };
                        _.Wj = function o$d(a, b, c) {
                            return g$d(this, RD(a, 89), RD(b, 89), c);
                        };
                        _.Ij = function i$d(a, b, c, d, e) {
                            switch(a){
                                case 3:
                                    return dZd(this, a, b, c, d, this.i > 1);
                                case 5:
                                    return dZd(this, a, b, c, d, this.i - RD(c, 15).gc() > 0);
                                default:
                                    return new P3d(this.e, a, this.c, b, c, d, true);
                            }
                        };
                        _.Tj = function j$d() {
                            return true;
                        };
                        _.Qj = function k$d() {
                            return d$d(this);
                        };
                        _.Gk = function p$d() {
                            sLd(this);
                        };
                        var S7 = sfb(SHe, 'EClassImpl/1', 1161);
                        feb(1175, 1174, EJe);
                        _.dj = function t$d(a) {
                            var b, c, d, e, f, g, h;
                            c = a.gj();
                            if (c != 8) {
                                d = s$d(a);
                                if (d == 0) switch(c){
                                    case 1:
                                    case 9:
                                        h = a.kj();
                                        if (h != null) {
                                            b = yYd(RD(h, 482));
                                            !b.c && (b.c = new X9d);
                                            dHd(b.c, a.jj());
                                        }
                                        g = a.ij();
                                        if (g != null) {
                                            e = RD(g, 482);
                                            if ((e.Bb & 1) == 0) {
                                                b = yYd(e);
                                                !b.c && (b.c = new X9d);
                                                WGd(b.c, RD(a.jj(), 29));
                                            }
                                        }
                                        break;
                                    case 3:
                                        g = a.ij();
                                        if (g != null) {
                                            e = RD(g, 482);
                                            if ((e.Bb & 1) == 0) {
                                                b = yYd(e);
                                                !b.c && (b.c = new X9d);
                                                WGd(b.c, RD(a.jj(), 29));
                                            }
                                        }
                                        break;
                                    case 5:
                                        g = a.ij();
                                        if (g != null) for(f = RD(g, 16).Kc(); f.Ob();){
                                            e = RD(f.Pb(), 482);
                                            if ((e.Bb & 1) == 0) {
                                                b = yYd(e);
                                                !b.c && (b.c = new X9d);
                                                WGd(b.c, RD(a.jj(), 29));
                                            }
                                        }
                                        break;
                                    case 4:
                                        h = a.kj();
                                        if (h != null) {
                                            e = RD(h, 482);
                                            if ((e.Bb & 1) == 0) {
                                                b = yYd(e);
                                                !b.c && (b.c = new X9d);
                                                dHd(b.c, a.jj());
                                            }
                                        }
                                        break;
                                    case 6:
                                        h = a.kj();
                                        if (h != null) for(f = RD(h, 16).Kc(); f.Ob();){
                                            e = RD(f.Pb(), 482);
                                            if ((e.Bb & 1) == 0) {
                                                b = yYd(e);
                                                !b.c && (b.c = new X9d);
                                                dHd(b.c, a.jj());
                                            }
                                        }
                                        break;
                                }
                                this.ql(d);
                            }
                        };
                        _.ql = function u$d(a) {
                            r$d(this, a);
                        };
                        _.b = 63;
                        var u9 = sfb(SHe, 'ESuperAdapter', 1175);
                        feb(1176, 1175, EJe, w$d);
                        _.ql = function x$d(a) {
                            v$d(this, a);
                        };
                        var N7 = sfb(SHe, 'EClassImpl/10', 1176);
                        feb(1165, 710, oKe);
                        _.Ei = function y$d(a, b) {
                            return IHd(this, a, b);
                        };
                        _.Fi = function z$d(a) {
                            return JHd(this, a);
                        };
                        _.Gi = function A$d(a, b) {
                            KHd(this, a, b);
                        };
                        _.Hi = function B$d(a) {
                            LHd(this, a);
                        };
                        _.$i = function D$d(a) {
                            return NHd(this, a);
                        };
                        _.Xi = function L$d(a, b) {
                            return UHd(this, a, b);
                        };
                        _.Wk = function C$d(a, b) {
                            throw Adb(new jib);
                        };
                        _.Ii = function E$d() {
                            return new yMd(this);
                        };
                        _.Ji = function F$d() {
                            return new BMd(this);
                        };
                        _.Ki = function G$d(a) {
                            return ZGd(this, a);
                        };
                        _.Xk = function H$d(a, b) {
                            throw Adb(new jib);
                        };
                        _.Fk = function I$d(a) {
                            return this;
                        };
                        _.Qj = function J$d() {
                            return this.i != 0;
                        };
                        _.Wb = function K$d(a) {
                            throw Adb(new jib);
                        };
                        _.Gk = function M$d() {
                            throw Adb(new jib);
                        };
                        var xbb = sfb(ZJe, 'EcoreEList/UnmodifiableEList', 1165);
                        feb(328, 1165, oKe, N$d);
                        _.Yi = function O$d() {
                            return false;
                        };
                        var wbb = sfb(ZJe, 'EcoreEList/UnmodifiableEList/FastCompare', 328);
                        feb(1168, 328, oKe, R$d);
                        _.dd = function S$d(a) {
                            var b, c, d;
                            if (ZD(a, 179)) {
                                b = RD(a, 179);
                                c = b.Lj();
                                if (c != -1) for(d = this.i; c < d; ++c){
                                    if (dE(this.g[c]) === dE(a)) return c;
                                }
                            }
                            return -1;
                        };
                        var O7 = sfb(SHe, 'EClassImpl/1EAllStructuralFeaturesList', 1168);
                        feb(1162, 506, PIe, W$d);
                        _.aj = function X$d(a) {
                            return $C(o7, sKe, 89, a, 0, 1);
                        };
                        _.Yi = function Y$d() {
                            return false;
                        };
                        var P7 = sfb(SHe, 'EClassImpl/1EGenericSuperTypeEList', 1162);
                        feb(633, 506, PIe, Z$d);
                        _.aj = function $$d(a) {
                            return $C(y7, lKe, 179, a, 0, 1);
                        };
                        _.Yi = function _$d() {
                            return false;
                        };
                        var Q7 = sfb(SHe, 'EClassImpl/1EStructuralFeatureUniqueEList', 633);
                        feb(755, 506, PIe, a_d);
                        _.aj = function b_d(a) {
                            return $C(v7, lKe, 19, a, 0, 1);
                        };
                        _.Yi = function c_d() {
                            return false;
                        };
                        var R7 = sfb(SHe, 'EClassImpl/1ReferenceList', 755);
                        feb(1163, 506, PIe, e_d);
                        _.Mi = function f_d(a, b) {
                            d_d(this, RD(b, 35));
                        };
                        _.aj = function g_d(a) {
                            return $C(g7, lKe, 35, a, 0, 1);
                        };
                        _.Yi = function h_d() {
                            return false;
                        };
                        var T7 = sfb(SHe, 'EClassImpl/2', 1163);
                        feb(1164, 506, PIe, i_d);
                        _.aj = function j_d(a) {
                            return $C(g7, lKe, 35, a, 0, 1);
                        };
                        _.Yi = function k_d() {
                            return false;
                        };
                        var U7 = sfb(SHe, 'EClassImpl/3', 1164);
                        feb(1166, 328, oKe, n_d);
                        _.Fc = function o_d(a) {
                            return l_d(this, RD(a, 35));
                        };
                        _.Hi = function p_d(a) {
                            m_d(this, RD(a, 35));
                        };
                        var V7 = sfb(SHe, 'EClassImpl/4', 1166);
                        feb(1167, 328, oKe, s_d);
                        _.Fc = function t_d(a) {
                            return q_d(this, RD(a, 19));
                        };
                        _.Hi = function u_d(a) {
                            r_d(this, RD(a, 19));
                        };
                        var W7 = sfb(SHe, 'EClassImpl/5', 1167);
                        feb(1169, 506, PIe, v_d);
                        _.aj = function w_d(a) {
                            return $C(s7, mKe, 62, a, 0, 1);
                        };
                        _.Yi = function x_d() {
                            return false;
                        };
                        var X7 = sfb(SHe, 'EClassImpl/6', 1169);
                        feb(1170, 506, PIe, y_d);
                        _.aj = function z_d(a) {
                            return $C(v7, lKe, 19, a, 0, 1);
                        };
                        _.Yi = function A_d() {
                            return false;
                        };
                        var Y7 = sfb(SHe, 'EClassImpl/7', 1170);
                        feb(2095, 2094, {
                            3: 1,
                            4: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            70: 1,
                            61: 1,
                            71: 1
                        });
                        _.Ei = function B_d(a, b) {
                            return QJd(this, a, b);
                        };
                        _.Fi = function C_d(a) {
                            return QJd(this, this.Ej(), a);
                        };
                        _.Gi = function D_d(a, b) {
                            RJd(this, a, b);
                        };
                        _.Hi = function E_d(a) {
                            SJd(this, a);
                        };
                        _.Wk = function F_d(a, b) {
                            return TJd(this, a, b);
                        };
                        _.Xk = function L_d(a, b) {
                            return UJd(this, a, b);
                        };
                        _.Xi = function M_d(a, b) {
                            return WJd(this, a, b);
                        };
                        _.$i = function G_d(a) {
                            return this.xj(a);
                        };
                        _.Ii = function H_d() {
                            return new yMd(this);
                        };
                        _.pj = function I_d() {
                            return this.sj();
                        };
                        _.Ji = function J_d() {
                            return new BMd(this);
                        };
                        _.Ki = function K_d(a) {
                            return ZGd(this, a);
                        };
                        var Qab = sfb(ZJe, 'DelegatingNotifyingInternalEListImpl', 2095);
                        feb(756, 2095, tKe);
                        _.Li = function R_d() {
                            var a;
                            a = vYd(Uwd(this.b), this.Lj()).Hk();
                            return ZD(a, 156) && !ZD(a, 469) && (a.kk().i & 1) == 0;
                        };
                        _.Hc = function S_d(a) {
                            var b, c, d, e, f, g, h, i;
                            if (this.ol()) {
                                i = this.Ej();
                                if (i > 4) {
                                    if (this.fk(a)) {
                                        if (this.al()) {
                                            d = RD(a, 54);
                                            c = d.Eh();
                                            h = c == this.b && (this.ml() ? d.yh(d.Fh(), RD(vYd(Uwd(this.b), this.Lj()).Hk(), 29).kk()) == Z5d(RD(vYd(Uwd(this.b), this.Lj()), 19)).n : -1 - d.Fh() == this.Lj());
                                            if (this.nl() && !h && !c && !!d.Jh()) for(e = 0; e < i; ++e){
                                                b = O_d(this, this.xj(e));
                                                if (dE(b) === dE(a)) return true;
                                            }
                                            return h;
                                        } else if (this.ml() && !this.ll()) {
                                            f = RD(a, 58).Mh(Z5d(RD(vYd(Uwd(this.b), this.Lj()), 19)));
                                            if (dE(f) === dE(this.b)) return true;
                                            else if (f == null || !RD(f, 58).Vh()) return false;
                                        }
                                    } else return false;
                                }
                                g = this.uj(a);
                                if (this.nl() && !g) for(e = 0; e < i; ++e){
                                    d = O_d(this, this.xj(e));
                                    if (dE(d) === dE(a)) return true;
                                }
                                return g;
                            } else return this.uj(a);
                        };
                        _.Ij = function T_d(a, b, c, d, e) {
                            return new P3d(this.b, a, this.Lj(), b, c, d, e);
                        };
                        _.Jj = function U_d(a) {
                            qvd(this.b, a);
                        };
                        _.Fk = function V_d(a) {
                            return this;
                        };
                        _.Kj = function W_d() {
                            return vYd(Uwd(this.b), this.Lj());
                        };
                        _.Lj = function X_d() {
                            return BYd(Uwd(this.b), vYd(Uwd(this.b), this.Lj()));
                        };
                        _.jj = function Y_d() {
                            return this.b;
                        };
                        _.kl = function Z_d() {
                            return !!vYd(Uwd(this.b), this.Lj()).Hk().kk();
                        };
                        _.Mj = function $_d() {
                            var a, b;
                            b = vYd(Uwd(this.b), this.Lj());
                            if (ZD(b, 102)) {
                                a = RD(b, 19);
                                return (a.Bb & QHe) != 0 || !!Z5d(RD(b, 19));
                            } else return false;
                        };
                        _.ll = function __d() {
                            var a, b, c, d;
                            b = vYd(Uwd(this.b), this.Lj());
                            if (ZD(b, 102)) {
                                a = RD(b, 19);
                                c = Z5d(a);
                                return !!c && (d = c.t, d > 1 || d == -1);
                            } else return false;
                        };
                        _.ml = function a0d() {
                            var a, b, c;
                            b = vYd(Uwd(this.b), this.Lj());
                            if (ZD(b, 102)) {
                                a = RD(b, 19);
                                c = Z5d(a);
                                return !!c;
                            } else return false;
                        };
                        _.nl = function b0d() {
                            var a, b;
                            b = vYd(Uwd(this.b), this.Lj());
                            if (ZD(b, 102)) {
                                a = RD(b, 19);
                                return (a.Bb & txe) != 0;
                            } else return false;
                        };
                        _.dd = function c0d(a) {
                            var b, c, d, e;
                            d = this.zj(a);
                            if (d >= 0) return d;
                            if (this.ol()) for(c = 0, e = this.Ej(); c < e; ++c){
                                b = O_d(this, this.xj(c));
                                if (dE(b) === dE(a)) return c;
                            }
                            return -1;
                        };
                        _.Nj = function d0d(a, b) {
                            var c;
                            return c = RD(a, 54), this.ml() ? this.kl() ? c.Rh(this.b, Z5d(RD(vYd(Uwd(this.b), this.Lj()), 19)).n, RD(vYd(Uwd(this.b), this.Lj()).Hk(), 29).kk(), b) : c.Rh(this.b, BYd(c.Dh(), Z5d(RD(vYd(Uwd(this.b), this.Lj()), 19))), null, b) : c.Rh(this.b, -1 - this.Lj(), null, b);
                        };
                        _.Oj = function e0d(a, b) {
                            var c;
                            return c = RD(a, 54), this.ml() ? this.kl() ? c.Th(this.b, Z5d(RD(vYd(Uwd(this.b), this.Lj()), 19)).n, RD(vYd(Uwd(this.b), this.Lj()).Hk(), 29).kk(), b) : c.Th(this.b, BYd(c.Dh(), Z5d(RD(vYd(Uwd(this.b), this.Lj()), 19))), null, b) : c.Th(this.b, -1 - this.Lj(), null, b);
                        };
                        _.al = function f0d() {
                            var a, b;
                            b = vYd(Uwd(this.b), this.Lj());
                            if (ZD(b, 102)) {
                                a = RD(b, 19);
                                return (a.Bb & QHe) != 0;
                            } else return false;
                        };
                        _.ol = function g0d() {
                            return ZD(vYd(Uwd(this.b), this.Lj()).Hk(), 90);
                        };
                        _.fk = function h0d(a) {
                            return vYd(Uwd(this.b), this.Lj()).Hk().fk(a);
                        };
                        _.Pj = function i0d() {
                            return Mvd(this.b);
                        };
                        _.Qj = function j0d() {
                            return !this.Aj();
                        };
                        _.Si = function k0d() {
                            return vYd(Uwd(this.b), this.Lj()).Si();
                        };
                        _.Wi = function l0d(a, b) {
                            return N_d(this, a, b);
                        };
                        _.Wb = function m0d(a) {
                            VJd(this);
                            YGd(this, RD(a, 15));
                        };
                        _.Pc = function n0d() {
                            var a;
                            if (this.nl()) for(a = this.Ej() - 1; a >= 0; --a)N_d(this, a, this.xj(a));
                            return this.Fj();
                        };
                        _.Qc = function o0d(a) {
                            var b;
                            if (this.nl()) for(b = this.Ej() - 1; b >= 0; --b)N_d(this, b, this.xj(b));
                            return this.Gj(a);
                        };
                        _.Gk = function p0d() {
                            VJd(this);
                        };
                        _.Zi = function q0d(a, b) {
                            return P_d(this, a, b);
                        };
                        var Pab = sfb(ZJe, 'DelegatingEcoreEList', 756);
                        feb(1171, 756, tKe, w0d);
                        _.qj = function z0d(a, b) {
                            r0d(this, a, RD(b, 29));
                        };
                        _.rj = function A0d(a) {
                            s0d(this, RD(a, 29));
                        };
                        _.xj = function G0d(a) {
                            var b, c;
                            return b = RD(QHd(tYd(this.a), a), 89), c = b.c, ZD(c, 90) ? RD(c, 29) : (JTd(), zTd);
                        };
                        _.Cj = function L0d(a) {
                            var b, c;
                            return b = RD(vLd(tYd(this.a), a), 89), c = b.c, ZD(c, 90) ? RD(c, 29) : (JTd(), zTd);
                        };
                        _.Dj = function M0d(a, b) {
                            return u0d(this, a, RD(b, 29));
                        };
                        _.Li = function x0d() {
                            return false;
                        };
                        _.Ij = function y0d(a, b, c, d, e) {
                            return null;
                        };
                        _.sj = function B0d() {
                            return new c1d(this);
                        };
                        _.tj = function C0d() {
                            sLd(tYd(this.a));
                        };
                        _.uj = function D0d(a) {
                            return t0d(this, a);
                        };
                        _.vj = function E0d(a) {
                            var b, c;
                            for(c = a.Kc(); c.Ob();){
                                b = c.Pb();
                                if (!t0d(this, b)) return false;
                            }
                            return true;
                        };
                        _.wj = function F0d(a) {
                            var b, c, d;
                            if (ZD(a, 15)) {
                                d = RD(a, 15);
                                if (d.gc() == tYd(this.a).i) {
                                    for(b = d.Kc(), c = new dMd(this); b.Ob();){
                                        if (dE(b.Pb()) !== dE(bMd(c))) return false;
                                    }
                                    return true;
                                }
                            }
                            return false;
                        };
                        _.yj = function H0d() {
                            var a, b, c, d, e;
                            c = 1;
                            for(b = new dMd(tYd(this.a)); b.e != b.i.gc();){
                                a = RD(bMd(b), 89);
                                d = (e = a.c, ZD(e, 90) ? RD(e, 29) : (JTd(), zTd));
                                c = 31 * c + (!d ? 0 : kFb(d));
                            }
                            return c;
                        };
                        _.zj = function I0d(a) {
                            var b, c, d, e;
                            d = 0;
                            for(c = new dMd(tYd(this.a)); c.e != c.i.gc();){
                                b = RD(bMd(c), 89);
                                if (dE(a) === dE((e = b.c, ZD(e, 90) ? RD(e, 29) : (JTd(), zTd)))) return d;
                                ++d;
                            }
                            return -1;
                        };
                        _.Aj = function J0d() {
                            return tYd(this.a).i == 0;
                        };
                        _.Bj = function K0d() {
                            return null;
                        };
                        _.Ej = function N0d() {
                            return tYd(this.a).i;
                        };
                        _.Fj = function O0d() {
                            var a, b, c, d, e, f;
                            f = tYd(this.a).i;
                            e = $C(jJ, rve, 1, f, 5, 1);
                            c = 0;
                            for(b = new dMd(tYd(this.a)); b.e != b.i.gc();){
                                a = RD(bMd(b), 89);
                                e[c++] = (d = a.c, ZD(d, 90) ? RD(d, 29) : (JTd(), zTd));
                            }
                            return e;
                        };
                        _.Gj = function P0d(a) {
                            var b, c, d, e, f, g, h;
                            h = tYd(this.a).i;
                            if (a.length < h) {
                                e = IMd(rb(a).c, h);
                                a = e;
                            }
                            a.length > h && bD(a, h, null);
                            d = 0;
                            for(c = new dMd(tYd(this.a)); c.e != c.i.gc();){
                                b = RD(bMd(c), 89);
                                f = (g = b.c, ZD(g, 90) ? RD(g, 29) : (JTd(), zTd));
                                bD(a, d++, f);
                            }
                            return a;
                        };
                        _.Hj = function Q0d() {
                            var a, b, c, d, e;
                            e = new Qhb;
                            e.a += '[';
                            a = tYd(this.a);
                            for(b = 0, d = tYd(this.a).i; b < d;){
                                Nhb(e, Ghb((c = RD(QHd(a, b), 89).c, ZD(c, 90) ? RD(c, 29) : (JTd(), zTd))));
                                ++b < d && (e.a += pve, e);
                            }
                            e.a += ']';
                            return e.a;
                        };
                        _.Jj = function R0d(a) {};
                        _.Lj = function S0d() {
                            return 10;
                        };
                        _.kl = function T0d() {
                            return true;
                        };
                        _.Mj = function U0d() {
                            return false;
                        };
                        _.ll = function V0d() {
                            return false;
                        };
                        _.ml = function W0d() {
                            return false;
                        };
                        _.nl = function X0d() {
                            return true;
                        };
                        _.al = function Y0d() {
                            return false;
                        };
                        _.ol = function Z0d() {
                            return true;
                        };
                        _.fk = function $0d(a) {
                            return ZD(a, 90);
                        };
                        _.Qj = function _0d() {
                            return CYd(this.a);
                        };
                        _.Si = function a1d() {
                            return true;
                        };
                        _.Yi = function b1d() {
                            return true;
                        };
                        var $7 = sfb(SHe, 'EClassImpl/8', 1171);
                        feb(1172, 2062, kwe, c1d);
                        _.fd = function d1d(a) {
                            return ZGd(this.a, a);
                        };
                        _.gc = function e1d() {
                            return tYd(this.a.a).i;
                        };
                        var Z7 = sfb(SHe, 'EClassImpl/8/1', 1172);
                        feb(1173, 506, PIe, f1d);
                        _.aj = function g1d(a) {
                            return $C(i7, rve, 142, a, 0, 1);
                        };
                        _.Yi = function h1d() {
                            return false;
                        };
                        var _7 = sfb(SHe, 'EClassImpl/9', 1173);
                        feb(1160, 49, Ixe, i1d);
                        var a8 = sfb(SHe, 'EClassImpl/MyHashSet', 1160);
                        feb(577, 364, {
                            110: 1,
                            94: 1,
                            93: 1,
                            142: 1,
                            156: 1,
                            847: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            364: 1,
                            158: 1,
                            119: 1,
                            120: 1,
                            691: 1
                        }, k1d);
                        _.Lh = function l1d(a, b, c) {
                            var d;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.zb;
                                case 2:
                                    return this.D != null ? this.D : this.B;
                                case 3:
                                    return DXd(this);
                                case 4:
                                    return this.ik();
                                case 5:
                                    return this.F;
                                case 6:
                                    if (b) return BXd(this);
                                    return xXd(this);
                                case 7:
                                    return !this.A && (this.A = new iie(z7, this, 7)), this.A;
                                case 8:
                                    return Geb(), (this.Bb & 256) != 0 ? true : false;
                            }
                            return zvd(this, a - AYd(this.ii()), vYd((d = RD(Ywd(this, 16), 29), !d ? this.ii() : d), a), b, c);
                        };
                        _.Wh = function m1d(a) {
                            var b;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return this.zb != null;
                                case 2:
                                    return this.D != null && this.D == this.F;
                                case 3:
                                    return !!DXd(this);
                                case 4:
                                    return this.ik() != null;
                                case 5:
                                    return this.F != null && this.F != this.D && this.F != this.B;
                                case 6:
                                    return !!xXd(this);
                                case 7:
                                    return !!this.A && this.A.i != 0;
                                case 8:
                                    return (this.Bb & 256) == 0;
                            }
                            return Avd(this, a - AYd(this.ii()), vYd((b = RD(Ywd(this, 16), 29), !b ? this.ii() : b), a));
                        };
                        _.bi = function n1d(a, b) {
                            var c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                                case 1:
                                    LXd(this, WD(b));
                                    return;
                                case 2:
                                    IXd(this, WD(b));
                                    return;
                                case 5:
                                    KXd(this, WD(b));
                                    return;
                                case 7:
                                    !this.A && (this.A = new iie(z7, this, 7));
                                    sLd(this.A);
                                    !this.A && (this.A = new iie(z7, this, 7));
                                    YGd(this.A, RD(b, 16));
                                    return;
                                case 8:
                                    j1d(this, Heb(TD(b)));
                                    return;
                            }
                            Bvd(this, a - AYd(this.ii()), vYd((c = RD(Ywd(this, 16), 29), !c ? this.ii() : c), a), b);
                        };
                        _.ii = function o1d() {
                            return JTd(), rTd;
                        };
                        _.ki = function p1d(a) {
                            var b;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                                case 1:
                                    ZD(this.Cb, 184) && (RD(this.Cb, 184).tb = null);
                                    PAd(this, null);
                                    return;
                                case 2:
                                    yXd(this, null);
                                    zXd(this, this.D);
                                    return;
                                case 5:
                                    KXd(this, null);
                                    return;
                                case 7:
                                    !this.A && (this.A = new iie(z7, this, 7));
                                    sLd(this.A);
                                    return;
                                case 8:
                                    j1d(this, true);
                                    return;
                            }
                            Cvd(this, a - AYd(this.ii()), vYd((b = RD(Ywd(this, 16), 29), !b ? this.ii() : b), a));
                        };
                        _.pi = function q1d() {
                            Oee((lke(), jke), this).xe();
                            this.Bb |= 1;
                        };
                        _.ok = function r1d() {
                            var a, b, c;
                            if (!this.c) {
                                a = Kje(BXd(this));
                                if (!a.dc()) for(c = a.Kc(); c.Ob();){
                                    b = WD(c.Pb());
                                    !!bAd(this, b) && Jje(this);
                                }
                            }
                            return this.b;
                        };
                        _.ik = function s1d() {
                            var b;
                            if (!this.e) {
                                b = null;
                                try {
                                    b = DXd(this);
                                } catch (a) {
                                    a = zdb(a);
                                    if (!ZD(a, 103)) throw Adb(a);
                                }
                                this.d = null;
                                !!b && (b.i & 1) != 0 && (b == xdb ? this.d = (Geb(), Eeb) : b == kE ? this.d = sgb(0) : b == jE ? this.d = new Tfb(0) : b == iE ? this.d = 0 : b == lE ? this.d = Hgb(0) : b == wdb ? this.d = bhb(0) : b == gE ? this.d = $eb(0) : this.d = hfb(0));
                                this.e = true;
                            }
                            return this.d;
                        };
                        _.nk = function t1d() {
                            return (this.Bb & 256) != 0;
                        };
                        _.rl = function u1d(a) {
                            a && (this.D = 'org.eclipse.emf.common.util.AbstractEnumerator');
                        };
                        _.gl = function v1d(a) {
                            GXd(this, a);
                            this.rl(a);
                        };
                        _.hl = function w1d(a) {
                            this.C = a;
                            this.e = false;
                        };
                        _.Ib = function x1d() {
                            var a;
                            if ((this.Db & 64) != 0) return MXd(this);
                            a = new Shb(MXd(this));
                            a.a += ' (serializable: ';
                            Ohb(a, (this.Bb & 256) != 0);
                            a.a += ')';
                            return a.a;
                        };
                        _.c = false;
                        _.d = null;
                        _.e = false;
                        var d8 = sfb(SHe, 'EDataTypeImpl', 577);
                        feb(469, 577, {
                            110: 1,
                            94: 1,
                            93: 1,
                            142: 1,
                            156: 1,
                            847: 1,
                            685: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            364: 1,
                            469: 1,
                            158: 1,
                            119: 1,
                            120: 1,
                            691: 1
                        }, A1d);
                        _.Lh = function B1d(a, b, c) {
                            var d;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.zb;
                                case 2:
                                    return this.D != null ? this.D : this.B;
                                case 3:
                                    return DXd(this);
                                case 4:
                                    return y1d(this);
                                case 5:
                                    return this.F;
                                case 6:
                                    if (b) return BXd(this);
                                    return xXd(this);
                                case 7:
                                    return !this.A && (this.A = new iie(z7, this, 7)), this.A;
                                case 8:
                                    return Geb(), (this.Bb & 256) != 0 ? true : false;
                                case 9:
                                    return !this.a && (this.a = new C5d(l7, this, 9, 5)), this.a;
                            }
                            return zvd(this, a - AYd((JTd(), sTd)), vYd((d = RD(Ywd(this, 16), 29), !d ? sTd : d), a), b, c);
                        };
                        _.Sh = function C1d(a, b, c) {
                            var d, e, f;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), qLd(this.Ab, a, c);
                                case 6:
                                    !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? AXd(this, c) : this.Cb.Th(this, -1 - e, null, c)));
                                    return xvd(this, a, 6, c);
                                case 9:
                                    return !this.a && (this.a = new C5d(l7, this, 9, 5)), qLd(this.a, a, c);
                            }
                            return f = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), sTd) : d), b), 69), f.wk().zk(this, Wwd(this), b - AYd((JTd(), sTd)), a, c);
                        };
                        _.Uh = function D1d(a, b, c) {
                            var d, e;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), rLd(this.Ab, a, c);
                                case 6:
                                    return xvd(this, null, 6, c);
                                case 7:
                                    return !this.A && (this.A = new iie(z7, this, 7)), rLd(this.A, a, c);
                                case 9:
                                    return !this.a && (this.a = new C5d(l7, this, 9, 5)), rLd(this.a, a, c);
                            }
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), sTd) : d), b), 69), e.wk().Ak(this, Wwd(this), b - AYd((JTd(), sTd)), a, c);
                        };
                        _.Wh = function E1d(a) {
                            var b;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return this.zb != null;
                                case 2:
                                    return this.D != null && this.D == this.F;
                                case 3:
                                    return !!DXd(this);
                                case 4:
                                    return !!y1d(this);
                                case 5:
                                    return this.F != null && this.F != this.D && this.F != this.B;
                                case 6:
                                    return !!xXd(this);
                                case 7:
                                    return !!this.A && this.A.i != 0;
                                case 8:
                                    return (this.Bb & 256) == 0;
                                case 9:
                                    return !!this.a && this.a.i != 0;
                            }
                            return Avd(this, a - AYd((JTd(), sTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? sTd : b), a));
                        };
                        _.bi = function F1d(a, b) {
                            var c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                                case 1:
                                    LXd(this, WD(b));
                                    return;
                                case 2:
                                    IXd(this, WD(b));
                                    return;
                                case 5:
                                    KXd(this, WD(b));
                                    return;
                                case 7:
                                    !this.A && (this.A = new iie(z7, this, 7));
                                    sLd(this.A);
                                    !this.A && (this.A = new iie(z7, this, 7));
                                    YGd(this.A, RD(b, 16));
                                    return;
                                case 8:
                                    j1d(this, Heb(TD(b)));
                                    return;
                                case 9:
                                    !this.a && (this.a = new C5d(l7, this, 9, 5));
                                    sLd(this.a);
                                    !this.a && (this.a = new C5d(l7, this, 9, 5));
                                    YGd(this.a, RD(b, 16));
                                    return;
                            }
                            Bvd(this, a - AYd((JTd(), sTd)), vYd((c = RD(Ywd(this, 16), 29), !c ? sTd : c), a), b);
                        };
                        _.ii = function G1d() {
                            return JTd(), sTd;
                        };
                        _.ki = function H1d(a) {
                            var b;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                                case 1:
                                    ZD(this.Cb, 184) && (RD(this.Cb, 184).tb = null);
                                    PAd(this, null);
                                    return;
                                case 2:
                                    yXd(this, null);
                                    zXd(this, this.D);
                                    return;
                                case 5:
                                    KXd(this, null);
                                    return;
                                case 7:
                                    !this.A && (this.A = new iie(z7, this, 7));
                                    sLd(this.A);
                                    return;
                                case 8:
                                    j1d(this, true);
                                    return;
                                case 9:
                                    !this.a && (this.a = new C5d(l7, this, 9, 5));
                                    sLd(this.a);
                                    return;
                            }
                            Cvd(this, a - AYd((JTd(), sTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? sTd : b), a));
                        };
                        _.pi = function I1d() {
                            var a, b;
                            if (this.a) for(a = 0, b = this.a.i; a < b; ++a)aAd(QHd(this.a, a));
                            Oee((lke(), jke), this).xe();
                            this.Bb |= 1;
                        };
                        _.ik = function J1d() {
                            return y1d(this);
                        };
                        _.fk = function K1d(a) {
                            if (a != null) return true;
                            return false;
                        };
                        _.rl = function L1d(a) {};
                        var e8 = sfb(SHe, 'EEnumImpl', 469);
                        feb(582, 448, {
                            110: 1,
                            94: 1,
                            93: 1,
                            2039: 1,
                            694: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            582: 1,
                            158: 1,
                            119: 1,
                            120: 1
                        }, R1d);
                        _.xe = function $1d() {
                            return this.zb;
                        };
                        _.Ah = function S1d(a) {
                            return M1d(this, a);
                        };
                        _.Lh = function T1d(a, b, c) {
                            var d, e;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.zb;
                                case 2:
                                    return sgb(this.d);
                                case 3:
                                    return this.b ? this.b : this.a;
                                case 4:
                                    return e = this.c, e == null ? this.zb : e;
                                case 5:
                                    return this.Db >> 16 == 5 ? RD(this.Cb, 685) : null;
                            }
                            return zvd(this, a - AYd((JTd(), tTd)), vYd((d = RD(Ywd(this, 16), 29), !d ? tTd : d), a), b, c);
                        };
                        _.Sh = function U1d(a, b, c) {
                            var d, e, f;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), qLd(this.Ab, a, c);
                                case 5:
                                    !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? M1d(this, c) : this.Cb.Th(this, -1 - e, null, c)));
                                    return xvd(this, a, 5, c);
                            }
                            return f = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), tTd) : d), b), 69), f.wk().zk(this, Wwd(this), b - AYd((JTd(), tTd)), a, c);
                        };
                        _.Uh = function V1d(a, b, c) {
                            var d, e;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), rLd(this.Ab, a, c);
                                case 5:
                                    return xvd(this, null, 5, c);
                            }
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), tTd) : d), b), 69), e.wk().Ak(this, Wwd(this), b - AYd((JTd(), tTd)), a, c);
                        };
                        _.Wh = function W1d(a) {
                            var b;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return this.zb != null;
                                case 2:
                                    return this.d != 0;
                                case 3:
                                    return !!this.b;
                                case 4:
                                    return this.c != null;
                                case 5:
                                    return !!(this.Db >> 16 == 5 ? RD(this.Cb, 685) : null);
                            }
                            return Avd(this, a - AYd((JTd(), tTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? tTd : b), a));
                        };
                        _.bi = function X1d(a, b) {
                            var c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                                case 1:
                                    PAd(this, WD(b));
                                    return;
                                case 2:
                                    Q1d(this, RD(b, 17).a);
                                    return;
                                case 3:
                                    O1d(this, RD(b, 2039));
                                    return;
                                case 4:
                                    P1d(this, WD(b));
                                    return;
                            }
                            Bvd(this, a - AYd((JTd(), tTd)), vYd((c = RD(Ywd(this, 16), 29), !c ? tTd : c), a), b);
                        };
                        _.ii = function Y1d() {
                            return JTd(), tTd;
                        };
                        _.ki = function Z1d(a) {
                            var b;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                                case 1:
                                    PAd(this, null);
                                    return;
                                case 2:
                                    Q1d(this, 0);
                                    return;
                                case 3:
                                    O1d(this, null);
                                    return;
                                case 4:
                                    P1d(this, null);
                                    return;
                            }
                            Cvd(this, a - AYd((JTd(), tTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? tTd : b), a));
                        };
                        _.Ib = function _1d() {
                            var a;
                            return a = this.c, a == null ? this.zb : a;
                        };
                        _.b = null;
                        _.c = null;
                        _.d = 0;
                        var f8 = sfb(SHe, 'EEnumLiteralImpl', 582);
                        var h8 = ufb(SHe, 'EFactoryImpl/InternalEDateTimeFormat');
                        feb(499, 1, {
                            2114: 1
                        }, c2d);
                        var g8 = sfb(SHe, 'EFactoryImpl/1ClientInternalEDateTimeFormat', 499);
                        feb(248, 120, {
                            110: 1,
                            94: 1,
                            93: 1,
                            89: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            248: 1,
                            119: 1,
                            120: 1
                        }, s2d);
                        _.Ch = function t2d(a, b, c) {
                            var d;
                            c = xvd(this, a, b, c);
                            if (!!this.e && ZD(a, 179)) {
                                d = k2d(this, this.e);
                                d != this.c && (c = o2d(this, d, c));
                            }
                            return c;
                        };
                        _.Lh = function u2d(a, b, c) {
                            var d;
                            switch(a){
                                case 0:
                                    return this.f;
                                case 1:
                                    return !this.d && (this.d = new XZd(o7, this, 1)), this.d;
                                case 2:
                                    if (b) return i2d(this);
                                    return this.c;
                                case 3:
                                    return this.b;
                                case 4:
                                    return this.e;
                                case 5:
                                    if (b) return h2d(this);
                                    return this.a;
                            }
                            return zvd(this, a - AYd((JTd(), vTd)), vYd((d = RD(Ywd(this, 16), 29), !d ? vTd : d), a), b, c);
                        };
                        _.Uh = function v2d(a, b, c) {
                            var d, e;
                            switch(b){
                                case 0:
                                    return g2d(this, null, c);
                                case 1:
                                    return !this.d && (this.d = new XZd(o7, this, 1)), rLd(this.d, a, c);
                                case 3:
                                    return e2d(this, null, c);
                            }
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), vTd) : d), b), 69), e.wk().Ak(this, Wwd(this), b - AYd((JTd(), vTd)), a, c);
                        };
                        _.Wh = function w2d(a) {
                            var b;
                            switch(a){
                                case 0:
                                    return !!this.f;
                                case 1:
                                    return !!this.d && this.d.i != 0;
                                case 2:
                                    return !!this.c;
                                case 3:
                                    return !!this.b;
                                case 4:
                                    return !!this.e;
                                case 5:
                                    return !!this.a;
                            }
                            return Avd(this, a - AYd((JTd(), vTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? vTd : b), a));
                        };
                        _.bi = function x2d(a, b) {
                            var c;
                            switch(a){
                                case 0:
                                    q2d(this, RD(b, 89));
                                    return;
                                case 1:
                                    !this.d && (this.d = new XZd(o7, this, 1));
                                    sLd(this.d);
                                    !this.d && (this.d = new XZd(o7, this, 1));
                                    YGd(this.d, RD(b, 16));
                                    return;
                                case 3:
                                    n2d(this, RD(b, 89));
                                    return;
                                case 4:
                                    p2d(this, RD(b, 850));
                                    return;
                                case 5:
                                    l2d(this, RD(b, 142));
                                    return;
                            }
                            Bvd(this, a - AYd((JTd(), vTd)), vYd((c = RD(Ywd(this, 16), 29), !c ? vTd : c), a), b);
                        };
                        _.ii = function y2d() {
                            return JTd(), vTd;
                        };
                        _.ki = function z2d(a) {
                            var b;
                            switch(a){
                                case 0:
                                    q2d(this, null);
                                    return;
                                case 1:
                                    !this.d && (this.d = new XZd(o7, this, 1));
                                    sLd(this.d);
                                    return;
                                case 3:
                                    n2d(this, null);
                                    return;
                                case 4:
                                    p2d(this, null);
                                    return;
                                case 5:
                                    l2d(this, null);
                                    return;
                            }
                            Cvd(this, a - AYd((JTd(), vTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? vTd : b), a));
                        };
                        _.Ib = function A2d() {
                            var a;
                            a = new dib(awd(this));
                            a.a += ' (expression: ';
                            r2d(this, a);
                            a.a += ')';
                            return a.a;
                        };
                        var d2d;
                        var j8 = sfb(SHe, 'EGenericTypeImpl', 248);
                        feb(2067, 2062, uKe);
                        _.Gi = function C2d(a, b) {
                            B2d(this, a, b);
                        };
                        _.Wk = function D2d(a, b) {
                            B2d(this, this.gc(), a);
                            return b;
                        };
                        _.$i = function E2d(a) {
                            return ju(this.pj(), a);
                        };
                        _.Ii = function F2d() {
                            return this.Ji();
                        };
                        _.pj = function G2d() {
                            return new mee(this);
                        };
                        _.Ji = function H2d() {
                            return this.Ki(0);
                        };
                        _.Ki = function I2d(a) {
                            return this.pj().fd(a);
                        };
                        _.Xk = function J2d(a, b) {
                            ze(this, a, true);
                            return b;
                        };
                        _.Ti = function K2d(a, b) {
                            var c, d;
                            d = ku(this, b);
                            c = this.fd(a);
                            c.Rb(d);
                            return d;
                        };
                        _.Ui = function L2d(a, b) {
                            var c;
                            ze(this, b, true);
                            c = this.fd(a);
                            c.Rb(b);
                        };
                        var Gab = sfb(ZJe, 'AbstractSequentialInternalEList', 2067);
                        feb(496, 2067, uKe, Q2d);
                        _.$i = function R2d(a) {
                            return ju(this.pj(), a);
                        };
                        _.Ii = function S2d() {
                            if (this.b == null) return j3d(), j3d(), i3d;
                            return this.sl();
                        };
                        _.pj = function T2d() {
                            return new Whe(this.a, this.b);
                        };
                        _.Ji = function U2d() {
                            if (this.b == null) return j3d(), j3d(), i3d;
                            return this.sl();
                        };
                        _.Ki = function V2d(a) {
                            var b, c;
                            if (this.b == null) {
                                if (a < 0 || a > 1) throw Adb(new veb(HJe + a + ', size=0'));
                                return j3d(), j3d(), i3d;
                            }
                            c = this.sl();
                            for(b = 0; b < a; ++b)k3d(c);
                            return c;
                        };
                        _.dc = function W2d() {
                            var a, b, c, d, e, f;
                            if (this.b != null) for(c = 0; c < this.b.length; ++c){
                                a = this.b[c];
                                if (!this.vl() || this.a.Xh(a)) {
                                    f = this.a.Nh(a, false);
                                    nke();
                                    if (RD(a, 69).xk()) {
                                        b = RD(f, 160);
                                        for(d = 0, e = b.gc(); d < e; ++d){
                                            if (O2d(b.Tl(d)) && b.Ul(d) != null) return false;
                                        }
                                    } else if (a.Jk()) {
                                        if (!RD(f, 16).dc()) return false;
                                    } else if (f != null) return false;
                                }
                            }
                            return true;
                        };
                        _.Kc = function X2d() {
                            return P2d(this);
                        };
                        _.fd = function Y2d(a) {
                            var b, c;
                            if (this.b == null) {
                                if (a != 0) throw Adb(new veb(HJe + a + ', size=0'));
                                return j3d(), j3d(), i3d;
                            }
                            c = this.ul() ? this.tl() : this.sl();
                            for(b = 0; b < a; ++b)k3d(c);
                            return c;
                        };
                        _.Ti = function Z2d(a, b) {
                            throw Adb(new jib);
                        };
                        _.Ui = function $2d(a, b) {
                            throw Adb(new jib);
                        };
                        _.sl = function _2d() {
                            return new p3d(this.a, this.b);
                        };
                        _.tl = function a3d() {
                            return new D3d(this.a, this.b);
                        };
                        _.ul = function b3d() {
                            return true;
                        };
                        _.gc = function c3d() {
                            var a, b, c, d, e, f, g;
                            e = 0;
                            if (this.b != null) for(c = 0; c < this.b.length; ++c){
                                a = this.b[c];
                                if (!this.vl() || this.a.Xh(a)) {
                                    g = this.a.Nh(a, false);
                                    nke();
                                    if (RD(a, 69).xk()) {
                                        b = RD(g, 160);
                                        for(d = 0, f = b.gc(); d < f; ++d)O2d(b.Tl(d)) && b.Ul(d) != null && ++e;
                                    } else a.Jk() ? e += RD(g, 16).gc() : g != null && ++e;
                                }
                            }
                            return e;
                        };
                        _.vl = function d3d() {
                            return true;
                        };
                        var M2d;
                        var Wab = sfb(ZJe, 'EContentsEList', 496);
                        feb(1177, 496, uKe, e3d);
                        _.sl = function f3d() {
                            return new H3d(this.a, this.b);
                        };
                        _.tl = function g3d() {
                            return new F3d(this.a, this.b);
                        };
                        _.vl = function h3d() {
                            return false;
                        };
                        var n8 = sfb(SHe, 'ENamedElementImpl/1', 1177);
                        feb(287, 1, vKe, p3d);
                        _.Nb = function s3d(a) {
                            Ztb(this, a);
                        };
                        _.Rb = function q3d(a) {
                            throw Adb(new jib);
                        };
                        _.wl = function r3d(a) {
                            if (this.g != 0 || !!this.e) throw Adb(new dgb('Iterator already in use or already filtered'));
                            this.e = a;
                        };
                        _.Ob = function t3d() {
                            var a, b, c, d, e, f;
                            switch(this.g){
                                case 3:
                                case 2:
                                    return true;
                                case 1:
                                    return false;
                                case -3:
                                    !this.p ? ++this.n : this.p.Pb();
                                default:
                                    if (!this.k || (!this.p ? !l3d(this) : !m3d(this, this.p))) {
                                        while(this.d < this.c.length){
                                            b = this.c[this.d++];
                                            if ((!this.e || b.pk() != C4 || b.Lj() != 0) && (!this.vl() || this.b.Xh(b))) {
                                                f = this.b.Nh(b, this.ul());
                                                this.f = (nke(), RD(b, 69).xk());
                                                if (this.f || b.Jk()) {
                                                    if (this.ul()) {
                                                        d = RD(f, 15);
                                                        this.k = d;
                                                    } else {
                                                        d = RD(f, 71);
                                                        this.k = this.j = d;
                                                    }
                                                    if (ZD(this.k, 59)) {
                                                        this.p = null;
                                                        this.o = this.k.gc();
                                                        this.n = 0;
                                                    } else this.p = !this.j ? this.k.ed() : this.j.Ji();
                                                    if (!this.p ? l3d(this) : m3d(this, this.p)) {
                                                        e = !this.p ? !this.j ? this.k.Xb(this.n++) : this.j.$i(this.n++) : this.p.Pb();
                                                        if (this.f) {
                                                            a = RD(e, 76);
                                                            a.Lk();
                                                            c = a.md();
                                                            this.i = c;
                                                        } else {
                                                            c = e;
                                                            this.i = c;
                                                        }
                                                        this.g = 3;
                                                        return true;
                                                    }
                                                } else if (f != null) {
                                                    this.k = null;
                                                    this.p = null;
                                                    c = f;
                                                    this.i = c;
                                                    this.g = 2;
                                                    return true;
                                                }
                                            }
                                        }
                                        this.k = null;
                                        this.p = null;
                                        this.f = false;
                                        this.g = 1;
                                        return false;
                                    } else {
                                        e = !this.p ? !this.j ? this.k.Xb(this.n++) : this.j.$i(this.n++) : this.p.Pb();
                                        if (this.f) {
                                            a = RD(e, 76);
                                            a.Lk();
                                            c = a.md();
                                            this.i = c;
                                        } else {
                                            c = e;
                                            this.i = c;
                                        }
                                        this.g = 3;
                                        return true;
                                    }
                            }
                        };
                        _.Sb = function u3d() {
                            var a, b, c, d, e, f;
                            switch(this.g){
                                case -3:
                                case -2:
                                    return true;
                                case -1:
                                    return false;
                                case 3:
                                    !this.p ? --this.n : this.p.Ub();
                                default:
                                    if (!this.k || (!this.p ? !n3d(this) : !o3d(this, this.p))) {
                                        while(this.d > 0){
                                            b = this.c[--this.d];
                                            if ((!this.e || b.pk() != C4 || b.Lj() != 0) && (!this.vl() || this.b.Xh(b))) {
                                                f = this.b.Nh(b, this.ul());
                                                this.f = (nke(), RD(b, 69).xk());
                                                if (this.f || b.Jk()) {
                                                    if (this.ul()) {
                                                        d = RD(f, 15);
                                                        this.k = d;
                                                    } else {
                                                        d = RD(f, 71);
                                                        this.k = this.j = d;
                                                    }
                                                    if (ZD(this.k, 59)) {
                                                        this.o = this.k.gc();
                                                        this.n = this.o;
                                                    } else this.p = !this.j ? this.k.fd(this.k.gc()) : this.j.Ki(this.k.gc());
                                                    if (!this.p ? n3d(this) : o3d(this, this.p)) {
                                                        e = !this.p ? !this.j ? this.k.Xb(--this.n) : this.j.$i(--this.n) : this.p.Ub();
                                                        if (this.f) {
                                                            a = RD(e, 76);
                                                            a.Lk();
                                                            c = a.md();
                                                            this.i = c;
                                                        } else {
                                                            c = e;
                                                            this.i = c;
                                                        }
                                                        this.g = -3;
                                                        return true;
                                                    }
                                                } else if (f != null) {
                                                    this.k = null;
                                                    this.p = null;
                                                    c = f;
                                                    this.i = c;
                                                    this.g = -2;
                                                    return true;
                                                }
                                            }
                                        }
                                        this.k = null;
                                        this.p = null;
                                        this.g = -1;
                                        return false;
                                    } else {
                                        e = !this.p ? !this.j ? this.k.Xb(--this.n) : this.j.$i(--this.n) : this.p.Ub();
                                        if (this.f) {
                                            a = RD(e, 76);
                                            a.Lk();
                                            c = a.md();
                                            this.i = c;
                                        } else {
                                            c = e;
                                            this.i = c;
                                        }
                                        this.g = -3;
                                        return true;
                                    }
                            }
                        };
                        _.Pb = function v3d() {
                            return k3d(this);
                        };
                        _.Tb = function w3d() {
                            return this.a;
                        };
                        _.Ub = function x3d() {
                            var a;
                            if (this.g < -1 || this.Sb()) {
                                --this.a;
                                this.g = 0;
                                a = this.i;
                                this.Sb();
                                return a;
                            } else throw Adb(new Dvb);
                        };
                        _.Vb = function y3d() {
                            return this.a - 1;
                        };
                        _.Qb = function z3d() {
                            throw Adb(new jib);
                        };
                        _.ul = function A3d() {
                            return false;
                        };
                        _.Wb = function B3d(a) {
                            throw Adb(new jib);
                        };
                        _.vl = function C3d() {
                            return true;
                        };
                        _.a = 0;
                        _.d = 0;
                        _.f = false;
                        _.g = 0;
                        _.n = 0;
                        _.o = 0;
                        var i3d;
                        var Uab = sfb(ZJe, 'EContentsEList/FeatureIteratorImpl', 287);
                        feb(711, 287, vKe, D3d);
                        _.ul = function E3d() {
                            return true;
                        };
                        var Vab = sfb(ZJe, 'EContentsEList/ResolvingFeatureIteratorImpl', 711);
                        feb(1178, 711, vKe, F3d);
                        _.vl = function G3d() {
                            return false;
                        };
                        var l8 = sfb(SHe, 'ENamedElementImpl/1/1', 1178);
                        feb(1179, 287, vKe, H3d);
                        _.vl = function I3d() {
                            return false;
                        };
                        var m8 = sfb(SHe, 'ENamedElementImpl/1/2', 1179);
                        feb(39, 152, GJe, L3d, M3d, N3d, O3d, P3d, Q3d, R3d, S3d, T3d, U3d, V3d, W3d, X3d, Y3d, Z3d, $3d, _3d, a4d, b4d, c4d, d4d, e4d, f4d, g4d, h4d);
                        _.Kj = function i4d() {
                            return K3d(this);
                        };
                        _.Rj = function j4d() {
                            var a;
                            a = K3d(this);
                            if (a) return a.ik();
                            return null;
                        };
                        _.hj = function k4d(a) {
                            this.b == -1 && !!this.a && (this.b = this.c.Hh(this.a.Lj(), this.a.pk()));
                            return this.c.yh(this.b, a);
                        };
                        _.jj = function l4d() {
                            return this.c;
                        };
                        _.Sj = function m4d() {
                            var a;
                            a = K3d(this);
                            if (a) return a.tk();
                            return false;
                        };
                        _.b = -1;
                        var p8 = sfb(SHe, 'ENotificationImpl', 39);
                        feb(411, 292, {
                            110: 1,
                            94: 1,
                            93: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            62: 1,
                            114: 1,
                            481: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            411: 1,
                            292: 1,
                            119: 1,
                            120: 1
                        }, q4d);
                        _.Ah = function r4d(a) {
                            return n4d(this, a);
                        };
                        _.Lh = function s4d(a, b, c) {
                            var d, e, f;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.zb;
                                case 2:
                                    return Geb(), (this.Bb & 256) != 0 ? true : false;
                                case 3:
                                    return Geb(), (this.Bb & 512) != 0 ? true : false;
                                case 4:
                                    return sgb(this.s);
                                case 5:
                                    return sgb(this.t);
                                case 6:
                                    return Geb(), f = this.t, f > 1 || f == -1 ? true : false;
                                case 7:
                                    return Geb(), e = this.s, e >= 1 ? true : false;
                                case 8:
                                    if (b) return WVd(this);
                                    return this.r;
                                case 9:
                                    return this.q;
                                case 10:
                                    return this.Db >> 16 == 10 ? RD(this.Cb, 29) : null;
                                case 11:
                                    return !this.d && (this.d = new iie(z7, this, 11)), this.d;
                                case 12:
                                    return !this.c && (this.c = new C5d(u7, this, 12, 10)), this.c;
                                case 13:
                                    return !this.a && (this.a = new F4d(this, this)), this.a;
                                case 14:
                                    return o4d(this);
                            }
                            return zvd(this, a - AYd((JTd(), ATd)), vYd((d = RD(Ywd(this, 16), 29), !d ? ATd : d), a), b, c);
                        };
                        _.Sh = function t4d(a, b, c) {
                            var d, e, f;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), qLd(this.Ab, a, c);
                                case 10:
                                    !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? n4d(this, c) : this.Cb.Th(this, -1 - e, null, c)));
                                    return xvd(this, a, 10, c);
                                case 12:
                                    return !this.c && (this.c = new C5d(u7, this, 12, 10)), qLd(this.c, a, c);
                            }
                            return f = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), ATd) : d), b), 69), f.wk().zk(this, Wwd(this), b - AYd((JTd(), ATd)), a, c);
                        };
                        _.Uh = function u4d(a, b, c) {
                            var d, e;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), rLd(this.Ab, a, c);
                                case 9:
                                    return VVd(this, c);
                                case 10:
                                    return xvd(this, null, 10, c);
                                case 11:
                                    return !this.d && (this.d = new iie(z7, this, 11)), rLd(this.d, a, c);
                                case 12:
                                    return !this.c && (this.c = new C5d(u7, this, 12, 10)), rLd(this.c, a, c);
                                case 14:
                                    return rLd(o4d(this), a, c);
                            }
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), ATd) : d), b), 69), e.wk().Ak(this, Wwd(this), b - AYd((JTd(), ATd)), a, c);
                        };
                        _.Wh = function v4d(a) {
                            var b, c, d;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return this.zb != null;
                                case 2:
                                    return (this.Bb & 256) == 0;
                                case 3:
                                    return (this.Bb & 512) == 0;
                                case 4:
                                    return this.s != 0;
                                case 5:
                                    return this.t != 1;
                                case 6:
                                    return d = this.t, d > 1 || d == -1;
                                case 7:
                                    return c = this.s, c >= 1;
                                case 8:
                                    return !!this.r && !this.q.e && j2d(this.q).i == 0;
                                case 9:
                                    return !!this.q && !(!!this.r && !this.q.e && j2d(this.q).i == 0);
                                case 10:
                                    return !!(this.Db >> 16 == 10 ? RD(this.Cb, 29) : null);
                                case 11:
                                    return !!this.d && this.d.i != 0;
                                case 12:
                                    return !!this.c && this.c.i != 0;
                                case 13:
                                    return !!this.a && o4d(this.a.a).i != 0 && !(!!this.b && o5d(this.b));
                                case 14:
                                    return !!this.b && o5d(this.b);
                            }
                            return Avd(this, a - AYd((JTd(), ATd)), vYd((b = RD(Ywd(this, 16), 29), !b ? ATd : b), a));
                        };
                        _.bi = function w4d(a, b) {
                            var c, d;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                                case 1:
                                    PAd(this, WD(b));
                                    return;
                                case 2:
                                    _Vd(this, Heb(TD(b)));
                                    return;
                                case 3:
                                    aWd(this, Heb(TD(b)));
                                    return;
                                case 4:
                                    $Vd(this, RD(b, 17).a);
                                    return;
                                case 5:
                                    bWd(this, RD(b, 17).a);
                                    return;
                                case 8:
                                    YVd(this, RD(b, 142));
                                    return;
                                case 9:
                                    d = XVd(this, RD(b, 89), null);
                                    !!d && d.oj();
                                    return;
                                case 11:
                                    !this.d && (this.d = new iie(z7, this, 11));
                                    sLd(this.d);
                                    !this.d && (this.d = new iie(z7, this, 11));
                                    YGd(this.d, RD(b, 16));
                                    return;
                                case 12:
                                    !this.c && (this.c = new C5d(u7, this, 12, 10));
                                    sLd(this.c);
                                    !this.c && (this.c = new C5d(u7, this, 12, 10));
                                    YGd(this.c, RD(b, 16));
                                    return;
                                case 13:
                                    !this.a && (this.a = new F4d(this, this));
                                    VJd(this.a);
                                    !this.a && (this.a = new F4d(this, this));
                                    YGd(this.a, RD(b, 16));
                                    return;
                                case 14:
                                    sLd(o4d(this));
                                    YGd(o4d(this), RD(b, 16));
                                    return;
                            }
                            Bvd(this, a - AYd((JTd(), ATd)), vYd((c = RD(Ywd(this, 16), 29), !c ? ATd : c), a), b);
                        };
                        _.ii = function x4d() {
                            return JTd(), ATd;
                        };
                        _.ki = function y4d(a) {
                            var b, c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                                case 1:
                                    PAd(this, null);
                                    return;
                                case 2:
                                    _Vd(this, true);
                                    return;
                                case 3:
                                    aWd(this, true);
                                    return;
                                case 4:
                                    $Vd(this, 0);
                                    return;
                                case 5:
                                    bWd(this, 1);
                                    return;
                                case 8:
                                    YVd(this, null);
                                    return;
                                case 9:
                                    c = XVd(this, null, null);
                                    !!c && c.oj();
                                    return;
                                case 11:
                                    !this.d && (this.d = new iie(z7, this, 11));
                                    sLd(this.d);
                                    return;
                                case 12:
                                    !this.c && (this.c = new C5d(u7, this, 12, 10));
                                    sLd(this.c);
                                    return;
                                case 13:
                                    !!this.a && VJd(this.a);
                                    return;
                                case 14:
                                    !!this.b && sLd(this.b);
                                    return;
                            }
                            Cvd(this, a - AYd((JTd(), ATd)), vYd((b = RD(Ywd(this, 16), 29), !b ? ATd : b), a));
                        };
                        _.pi = function z4d() {
                            var a, b;
                            if (this.c) for(a = 0, b = this.c.i; a < b; ++a)aAd(QHd(this.c, a));
                            WVd(this);
                            this.Bb |= 1;
                        };
                        var u8 = sfb(SHe, 'EOperationImpl', 411);
                        feb(513, 756, tKe, F4d);
                        _.qj = function I4d(a, b) {
                            A4d(this, a, RD(b, 142));
                        };
                        _.rj = function J4d(a) {
                            B4d(this, RD(a, 142));
                        };
                        _.xj = function P4d(a) {
                            var b, c;
                            return b = RD(QHd(o4d(this.a), a), 89), c = b.c, c ? c : (JTd(), wTd);
                        };
                        _.Cj = function U4d(a) {
                            var b, c;
                            return b = RD(vLd(o4d(this.a), a), 89), c = b.c, c ? c : (JTd(), wTd);
                        };
                        _.Dj = function V4d(a, b) {
                            return D4d(this, a, RD(b, 142));
                        };
                        _.Li = function G4d() {
                            return false;
                        };
                        _.Ij = function H4d(a, b, c, d, e) {
                            return null;
                        };
                        _.sj = function K4d() {
                            return new l5d(this);
                        };
                        _.tj = function L4d() {
                            sLd(o4d(this.a));
                        };
                        _.uj = function M4d(a) {
                            return C4d(this, a);
                        };
                        _.vj = function N4d(a) {
                            var b, c;
                            for(c = a.Kc(); c.Ob();){
                                b = c.Pb();
                                if (!C4d(this, b)) return false;
                            }
                            return true;
                        };
                        _.wj = function O4d(a) {
                            var b, c, d;
                            if (ZD(a, 15)) {
                                d = RD(a, 15);
                                if (d.gc() == o4d(this.a).i) {
                                    for(b = d.Kc(), c = new dMd(this); b.Ob();){
                                        if (dE(b.Pb()) !== dE(bMd(c))) return false;
                                    }
                                    return true;
                                }
                            }
                            return false;
                        };
                        _.yj = function Q4d() {
                            var a, b, c, d, e;
                            c = 1;
                            for(b = new dMd(o4d(this.a)); b.e != b.i.gc();){
                                a = RD(bMd(b), 89);
                                d = (e = a.c, e ? e : (JTd(), wTd));
                                c = 31 * c + (!d ? 0 : tb(d));
                            }
                            return c;
                        };
                        _.zj = function R4d(a) {
                            var b, c, d, e;
                            d = 0;
                            for(c = new dMd(o4d(this.a)); c.e != c.i.gc();){
                                b = RD(bMd(c), 89);
                                if (dE(a) === dE((e = b.c, e ? e : (JTd(), wTd)))) return d;
                                ++d;
                            }
                            return -1;
                        };
                        _.Aj = function S4d() {
                            return o4d(this.a).i == 0;
                        };
                        _.Bj = function T4d() {
                            return null;
                        };
                        _.Ej = function W4d() {
                            return o4d(this.a).i;
                        };
                        _.Fj = function X4d() {
                            var a, b, c, d, e, f;
                            f = o4d(this.a).i;
                            e = $C(jJ, rve, 1, f, 5, 1);
                            c = 0;
                            for(b = new dMd(o4d(this.a)); b.e != b.i.gc();){
                                a = RD(bMd(b), 89);
                                e[c++] = (d = a.c, d ? d : (JTd(), wTd));
                            }
                            return e;
                        };
                        _.Gj = function Y4d(a) {
                            var b, c, d, e, f, g, h;
                            h = o4d(this.a).i;
                            if (a.length < h) {
                                e = IMd(rb(a).c, h);
                                a = e;
                            }
                            a.length > h && bD(a, h, null);
                            d = 0;
                            for(c = new dMd(o4d(this.a)); c.e != c.i.gc();){
                                b = RD(bMd(c), 89);
                                f = (g = b.c, g ? g : (JTd(), wTd));
                                bD(a, d++, f);
                            }
                            return a;
                        };
                        _.Hj = function Z4d() {
                            var a, b, c, d, e;
                            e = new Qhb;
                            e.a += '[';
                            a = o4d(this.a);
                            for(b = 0, d = o4d(this.a).i; b < d;){
                                Nhb(e, Ghb((c = RD(QHd(a, b), 89).c, c ? c : (JTd(), wTd))));
                                ++b < d && (e.a += pve, e);
                            }
                            e.a += ']';
                            return e.a;
                        };
                        _.Jj = function $4d(a) {};
                        _.Lj = function _4d() {
                            return 13;
                        };
                        _.kl = function a5d() {
                            return true;
                        };
                        _.Mj = function b5d() {
                            return false;
                        };
                        _.ll = function c5d() {
                            return false;
                        };
                        _.ml = function d5d() {
                            return false;
                        };
                        _.nl = function e5d() {
                            return true;
                        };
                        _.al = function f5d() {
                            return false;
                        };
                        _.ol = function g5d() {
                            return true;
                        };
                        _.fk = function h5d(a) {
                            return ZD(a, 142);
                        };
                        _.Qj = function i5d() {
                            return p4d(this.a);
                        };
                        _.Si = function j5d() {
                            return true;
                        };
                        _.Yi = function k5d() {
                            return true;
                        };
                        var s8 = sfb(SHe, 'EOperationImpl/1', 513);
                        feb(1376, 2062, kwe, l5d);
                        _.fd = function m5d(a) {
                            return ZGd(this.a, a);
                        };
                        _.gc = function n5d() {
                            return o4d(this.a.a).i;
                        };
                        var r8 = sfb(SHe, 'EOperationImpl/1/1', 1376);
                        feb(1377, 555, oKe, s5d);
                        _.Ti = function w5d(a, b) {
                            var c, d;
                            return c = RD(uLd(this, a, b), 89), Mvd(this.e) && eZd(this, new c4d(this.a, 7, (JTd(), BTd), sgb(b), (d = c.c, d ? d : wTd), a)), c;
                        };
                        _.Uj = function x5d(a, b) {
                            return p5d(this, RD(a, 89), b);
                        };
                        _.Vj = function y5d(a, b) {
                            return q5d(this, RD(a, 89), b);
                        };
                        _.Wj = function z5d(a, b, c) {
                            return r5d(this, RD(a, 89), RD(b, 89), c);
                        };
                        _.Ij = function t5d(a, b, c, d, e) {
                            switch(a){
                                case 3:
                                    return dZd(this, a, b, c, d, this.i > 1);
                                case 5:
                                    return dZd(this, a, b, c, d, this.i - RD(c, 15).gc() > 0);
                                default:
                                    return new P3d(this.e, a, this.c, b, c, d, true);
                            }
                        };
                        _.Tj = function u5d() {
                            return true;
                        };
                        _.Qj = function v5d() {
                            return o5d(this);
                        };
                        _.Gk = function A5d() {
                            sLd(this);
                        };
                        var t8 = sfb(SHe, 'EOperationImpl/2', 1377);
                        feb(507, 1, {
                            2037: 1,
                            507: 1
                        }, B5d);
                        var v8 = sfb(SHe, 'EPackageImpl/1', 507);
                        feb(14, 83, oKe, C5d);
                        _.il = function D5d() {
                            return this.d;
                        };
                        _.jl = function E5d() {
                            return this.b;
                        };
                        _.ml = function F5d() {
                            return true;
                        };
                        _.b = 0;
                        var gbb = sfb(ZJe, 'EObjectContainmentWithInverseEList', 14);
                        feb(365, 14, oKe, G5d);
                        _.nl = function H5d() {
                            return true;
                        };
                        _.Wi = function I5d(a, b) {
                            return gZd(this, a, RD(b, 58));
                        };
                        var dbb = sfb(ZJe, 'EObjectContainmentWithInverseEList/Resolving', 365);
                        feb(308, 365, oKe, J5d);
                        _.Ni = function K5d() {
                            this.a.tb = null;
                        };
                        var w8 = sfb(SHe, 'EPackageImpl/2', 308);
                        feb(1278, 1, {}, L5d);
                        var x8 = sfb(SHe, 'EPackageImpl/3', 1278);
                        feb(733, 45, Hxe, O5d);
                        _._b = function P5d(a) {
                            return bE(a) ? Yjb(this, a) : !!qtb(this.f, a);
                        };
                        var z8 = sfb(SHe, 'EPackageRegistryImpl', 733);
                        feb(518, 292, {
                            110: 1,
                            94: 1,
                            93: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            2116: 1,
                            114: 1,
                            481: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            518: 1,
                            292: 1,
                            119: 1,
                            120: 1
                        }, R5d);
                        _.Ah = function S5d(a) {
                            return Q5d(this, a);
                        };
                        _.Lh = function T5d(a, b, c) {
                            var d, e, f;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.zb;
                                case 2:
                                    return Geb(), (this.Bb & 256) != 0 ? true : false;
                                case 3:
                                    return Geb(), (this.Bb & 512) != 0 ? true : false;
                                case 4:
                                    return sgb(this.s);
                                case 5:
                                    return sgb(this.t);
                                case 6:
                                    return Geb(), f = this.t, f > 1 || f == -1 ? true : false;
                                case 7:
                                    return Geb(), e = this.s, e >= 1 ? true : false;
                                case 8:
                                    if (b) return WVd(this);
                                    return this.r;
                                case 9:
                                    return this.q;
                                case 10:
                                    return this.Db >> 16 == 10 ? RD(this.Cb, 62) : null;
                            }
                            return zvd(this, a - AYd((JTd(), DTd)), vYd((d = RD(Ywd(this, 16), 29), !d ? DTd : d), a), b, c);
                        };
                        _.Sh = function U5d(a, b, c) {
                            var d, e, f;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), qLd(this.Ab, a, c);
                                case 10:
                                    !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? Q5d(this, c) : this.Cb.Th(this, -1 - e, null, c)));
                                    return xvd(this, a, 10, c);
                            }
                            return f = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), DTd) : d), b), 69), f.wk().zk(this, Wwd(this), b - AYd((JTd(), DTd)), a, c);
                        };
                        _.Uh = function V5d(a, b, c) {
                            var d, e;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), rLd(this.Ab, a, c);
                                case 9:
                                    return VVd(this, c);
                                case 10:
                                    return xvd(this, null, 10, c);
                            }
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), DTd) : d), b), 69), e.wk().Ak(this, Wwd(this), b - AYd((JTd(), DTd)), a, c);
                        };
                        _.Wh = function W5d(a) {
                            var b, c, d;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return this.zb != null;
                                case 2:
                                    return (this.Bb & 256) == 0;
                                case 3:
                                    return (this.Bb & 512) == 0;
                                case 4:
                                    return this.s != 0;
                                case 5:
                                    return this.t != 1;
                                case 6:
                                    return d = this.t, d > 1 || d == -1;
                                case 7:
                                    return c = this.s, c >= 1;
                                case 8:
                                    return !!this.r && !this.q.e && j2d(this.q).i == 0;
                                case 9:
                                    return !!this.q && !(!!this.r && !this.q.e && j2d(this.q).i == 0);
                                case 10:
                                    return !!(this.Db >> 16 == 10 ? RD(this.Cb, 62) : null);
                            }
                            return Avd(this, a - AYd((JTd(), DTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? DTd : b), a));
                        };
                        _.ii = function X5d() {
                            return JTd(), DTd;
                        };
                        var A8 = sfb(SHe, 'EParameterImpl', 518);
                        feb(102, 462, {
                            110: 1,
                            94: 1,
                            93: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            19: 1,
                            179: 1,
                            69: 1,
                            114: 1,
                            481: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            102: 1,
                            462: 1,
                            292: 1,
                            119: 1,
                            120: 1,
                            692: 1
                        }, d6d);
                        _.Lh = function e6d(a, b, c) {
                            var d, e, f, g;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.zb;
                                case 2:
                                    return Geb(), (this.Bb & 256) != 0 ? true : false;
                                case 3:
                                    return Geb(), (this.Bb & 512) != 0 ? true : false;
                                case 4:
                                    return sgb(this.s);
                                case 5:
                                    return sgb(this.t);
                                case 6:
                                    return Geb(), g = this.t, g > 1 || g == -1 ? true : false;
                                case 7:
                                    return Geb(), e = this.s, e >= 1 ? true : false;
                                case 8:
                                    if (b) return WVd(this);
                                    return this.r;
                                case 9:
                                    return this.q;
                                case 10:
                                    return Geb(), (this.Bb & gwe) != 0 ? true : false;
                                case 11:
                                    return Geb(), (this.Bb & cKe) != 0 ? true : false;
                                case 12:
                                    return Geb(), (this.Bb & qxe) != 0 ? true : false;
                                case 13:
                                    return this.j;
                                case 14:
                                    return tWd(this);
                                case 15:
                                    return Geb(), (this.Bb & bKe) != 0 ? true : false;
                                case 16:
                                    return Geb(), (this.Bb & Ove) != 0 ? true : false;
                                case 17:
                                    return uWd(this);
                                case 18:
                                    return Geb(), (this.Bb & QHe) != 0 ? true : false;
                                case 19:
                                    return Geb(), f = Z5d(this), !!f && (f.Bb & QHe) != 0 ? true : false;
                                case 20:
                                    return Geb(), (this.Bb & txe) != 0 ? true : false;
                                case 21:
                                    if (b) return Z5d(this);
                                    return this.b;
                                case 22:
                                    if (b) return $5d(this);
                                    return Y5d(this);
                                case 23:
                                    return !this.a && (this.a = new zie(g7, this, 23)), this.a;
                            }
                            return zvd(this, a - AYd((JTd(), ETd)), vYd((d = RD(Ywd(this, 16), 29), !d ? ETd : d), a), b, c);
                        };
                        _.Wh = function f6d(a) {
                            var b, c, d, e;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return this.zb != null;
                                case 2:
                                    return (this.Bb & 256) == 0;
                                case 3:
                                    return (this.Bb & 512) == 0;
                                case 4:
                                    return this.s != 0;
                                case 5:
                                    return this.t != 1;
                                case 6:
                                    return e = this.t, e > 1 || e == -1;
                                case 7:
                                    return c = this.s, c >= 1;
                                case 8:
                                    return !!this.r && !this.q.e && j2d(this.q).i == 0;
                                case 9:
                                    return !!this.q && !(!!this.r && !this.q.e && j2d(this.q).i == 0);
                                case 10:
                                    return (this.Bb & gwe) == 0;
                                case 11:
                                    return (this.Bb & cKe) != 0;
                                case 12:
                                    return (this.Bb & qxe) != 0;
                                case 13:
                                    return this.j != null;
                                case 14:
                                    return tWd(this) != null;
                                case 15:
                                    return (this.Bb & bKe) != 0;
                                case 16:
                                    return (this.Bb & Ove) != 0;
                                case 17:
                                    return !!uWd(this);
                                case 18:
                                    return (this.Bb & QHe) != 0;
                                case 19:
                                    return d = Z5d(this), !!d && (d.Bb & QHe) != 0;
                                case 20:
                                    return (this.Bb & txe) == 0;
                                case 21:
                                    return !!this.b;
                                case 22:
                                    return !!Y5d(this);
                                case 23:
                                    return !!this.a && this.a.i != 0;
                            }
                            return Avd(this, a - AYd((JTd(), ETd)), vYd((b = RD(Ywd(this, 16), 29), !b ? ETd : b), a));
                        };
                        _.bi = function g6d(a, b) {
                            var c, d;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                                case 1:
                                    CWd(this, WD(b));
                                    return;
                                case 2:
                                    _Vd(this, Heb(TD(b)));
                                    return;
                                case 3:
                                    aWd(this, Heb(TD(b)));
                                    return;
                                case 4:
                                    $Vd(this, RD(b, 17).a);
                                    return;
                                case 5:
                                    bWd(this, RD(b, 17).a);
                                    return;
                                case 8:
                                    YVd(this, RD(b, 142));
                                    return;
                                case 9:
                                    d = XVd(this, RD(b, 89), null);
                                    !!d && d.oj();
                                    return;
                                case 10:
                                    xWd(this, Heb(TD(b)));
                                    return;
                                case 11:
                                    FWd(this, Heb(TD(b)));
                                    return;
                                case 12:
                                    DWd(this, Heb(TD(b)));
                                    return;
                                case 13:
                                    yWd(this, WD(b));
                                    return;
                                case 15:
                                    EWd(this, Heb(TD(b)));
                                    return;
                                case 16:
                                    AWd(this, Heb(TD(b)));
                                    return;
                                case 18:
                                    _5d(this, Heb(TD(b)));
                                    return;
                                case 20:
                                    c6d(this, Heb(TD(b)));
                                    return;
                                case 21:
                                    b6d(this, RD(b, 19));
                                    return;
                                case 23:
                                    !this.a && (this.a = new zie(g7, this, 23));
                                    sLd(this.a);
                                    !this.a && (this.a = new zie(g7, this, 23));
                                    YGd(this.a, RD(b, 16));
                                    return;
                            }
                            Bvd(this, a - AYd((JTd(), ETd)), vYd((c = RD(Ywd(this, 16), 29), !c ? ETd : c), a), b);
                        };
                        _.ii = function h6d() {
                            return JTd(), ETd;
                        };
                        _.ki = function i6d(a) {
                            var b, c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                                case 1:
                                    ZD(this.Cb, 90) && v$d(yYd(RD(this.Cb, 90)), 4);
                                    PAd(this, null);
                                    return;
                                case 2:
                                    _Vd(this, true);
                                    return;
                                case 3:
                                    aWd(this, true);
                                    return;
                                case 4:
                                    $Vd(this, 0);
                                    return;
                                case 5:
                                    bWd(this, 1);
                                    return;
                                case 8:
                                    YVd(this, null);
                                    return;
                                case 9:
                                    c = XVd(this, null, null);
                                    !!c && c.oj();
                                    return;
                                case 10:
                                    xWd(this, true);
                                    return;
                                case 11:
                                    FWd(this, false);
                                    return;
                                case 12:
                                    DWd(this, false);
                                    return;
                                case 13:
                                    this.i = null;
                                    zWd(this, null);
                                    return;
                                case 15:
                                    EWd(this, false);
                                    return;
                                case 16:
                                    AWd(this, false);
                                    return;
                                case 18:
                                    a6d(this, false);
                                    ZD(this.Cb, 90) && v$d(yYd(RD(this.Cb, 90)), 2);
                                    return;
                                case 20:
                                    c6d(this, true);
                                    return;
                                case 21:
                                    b6d(this, null);
                                    return;
                                case 23:
                                    !this.a && (this.a = new zie(g7, this, 23));
                                    sLd(this.a);
                                    return;
                            }
                            Cvd(this, a - AYd((JTd(), ETd)), vYd((b = RD(Ywd(this, 16), 29), !b ? ETd : b), a));
                        };
                        _.pi = function j6d() {
                            $5d(this);
                            Afe(Qee((lke(), jke), this));
                            WVd(this);
                            this.Bb |= 1;
                        };
                        _.uk = function k6d() {
                            return Z5d(this);
                        };
                        _._k = function l6d() {
                            var a;
                            return a = Z5d(this), !!a && (a.Bb & QHe) != 0;
                        };
                        _.al = function m6d() {
                            return (this.Bb & QHe) != 0;
                        };
                        _.bl = function n6d() {
                            return (this.Bb & txe) != 0;
                        };
                        _.Yk = function o6d(a, b) {
                            this.c = null;
                            return ZVd(this, a, b);
                        };
                        _.Ib = function p6d() {
                            var a;
                            if ((this.Db & 64) != 0) return GWd(this);
                            a = new Shb(GWd(this));
                            a.a += ' (containment: ';
                            Ohb(a, (this.Bb & QHe) != 0);
                            a.a += ', resolveProxies: ';
                            Ohb(a, (this.Bb & txe) != 0);
                            a.a += ')';
                            return a.a;
                        };
                        var B8 = sfb(SHe, 'EReferenceImpl', 102);
                        feb(561, 120, {
                            110: 1,
                            44: 1,
                            94: 1,
                            93: 1,
                            136: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            561: 1,
                            119: 1,
                            120: 1
                        }, v6d);
                        _.Fb = function B6d(a) {
                            return this === a;
                        };
                        _.ld = function D6d() {
                            return this.b;
                        };
                        _.md = function E6d() {
                            return this.c;
                        };
                        _.Hb = function F6d() {
                            return kFb(this);
                        };
                        _.Di = function H6d(a) {
                            q6d(this, WD(a));
                        };
                        _.nd = function I6d(a) {
                            return u6d(this, WD(a));
                        };
                        _.Lh = function w6d(a, b, c) {
                            var d;
                            switch(a){
                                case 0:
                                    return this.b;
                                case 1:
                                    return this.c;
                            }
                            return zvd(this, a - AYd((JTd(), FTd)), vYd((d = RD(Ywd(this, 16), 29), !d ? FTd : d), a), b, c);
                        };
                        _.Wh = function x6d(a) {
                            var b;
                            switch(a){
                                case 0:
                                    return this.b != null;
                                case 1:
                                    return this.c != null;
                            }
                            return Avd(this, a - AYd((JTd(), FTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? FTd : b), a));
                        };
                        _.bi = function y6d(a, b) {
                            var c;
                            switch(a){
                                case 0:
                                    r6d(this, WD(b));
                                    return;
                                case 1:
                                    t6d(this, WD(b));
                                    return;
                            }
                            Bvd(this, a - AYd((JTd(), FTd)), vYd((c = RD(Ywd(this, 16), 29), !c ? FTd : c), a), b);
                        };
                        _.ii = function z6d() {
                            return JTd(), FTd;
                        };
                        _.ki = function A6d(a) {
                            var b;
                            switch(a){
                                case 0:
                                    s6d(this, null);
                                    return;
                                case 1:
                                    t6d(this, null);
                                    return;
                            }
                            Cvd(this, a - AYd((JTd(), FTd)), vYd((b = RD(Ywd(this, 16), 29), !b ? FTd : b), a));
                        };
                        _.Bi = function C6d() {
                            var a;
                            if (this.a == -1) {
                                a = this.b;
                                this.a = a == null ? 0 : ohb(a);
                            }
                            return this.a;
                        };
                        _.Ci = function G6d(a) {
                            this.a = a;
                        };
                        _.Ib = function J6d() {
                            var a;
                            if ((this.Db & 64) != 0) return awd(this);
                            a = new Shb(awd(this));
                            a.a += ' (key: ';
                            Nhb(a, this.b);
                            a.a += ', value: ';
                            Nhb(a, this.c);
                            a.a += ')';
                            return a.a;
                        };
                        _.a = -1;
                        _.b = null;
                        _.c = null;
                        var C8 = sfb(SHe, 'EStringToStringMapEntryImpl', 561);
                        var Ibb = ufb(ZJe, 'FeatureMap/Entry/Internal');
                        feb(576, 1, wKe);
                        _.xl = function M6d(a) {
                            return this.yl(RD(a, 54));
                        };
                        _.yl = function N6d(a) {
                            return this.xl(a);
                        };
                        _.Fb = function O6d(a) {
                            var b, c;
                            if (this === a) return true;
                            else if (ZD(a, 76)) {
                                b = RD(a, 76);
                                if (b.Lk() == this.c) {
                                    c = this.md();
                                    return c == null ? b.md() == null : pb(c, b.md());
                                } else return false;
                            } else return false;
                        };
                        _.Lk = function P6d() {
                            return this.c;
                        };
                        _.Hb = function Q6d() {
                            var a;
                            a = this.md();
                            return tb(this.c) ^ (a == null ? 0 : tb(a));
                        };
                        _.Ib = function R6d() {
                            var a, b;
                            a = this.c;
                            b = BXd(a.qk()).yi();
                            a.xe();
                            return (b != null && b.length != 0 ? b + ':' + a.xe() : a.xe()) + '=' + this.md();
                        };
                        var D8 = sfb(SHe, 'EStructuralFeatureImpl/BasicFeatureMapEntry', 576);
                        feb(791, 576, wKe, U6d);
                        _.yl = function V6d(a) {
                            return new U6d(this.c, a);
                        };
                        _.md = function W6d() {
                            return this.a;
                        };
                        _.zl = function X6d(a, b, c) {
                            return S6d(this, a, this.a, b, c);
                        };
                        _.Al = function Y6d(a, b, c) {
                            return T6d(this, a, this.a, b, c);
                        };
                        var E8 = sfb(SHe, 'EStructuralFeatureImpl/ContainmentUpdatingFeatureMapEntry', 791);
                        feb(1350, 1, {}, Z6d);
                        _.yk = function $6d(a, b, c, d, e) {
                            var f;
                            f = RD(Evd(a, this.b), 220);
                            return f.Yl(this.a).Fk(d);
                        };
                        _.zk = function _6d(a, b, c, d, e) {
                            var f;
                            f = RD(Evd(a, this.b), 220);
                            return f.Pl(this.a, d, e);
                        };
                        _.Ak = function a7d(a, b, c, d, e) {
                            var f;
                            f = RD(Evd(a, this.b), 220);
                            return f.Ql(this.a, d, e);
                        };
                        _.Bk = function b7d(a, b, c) {
                            var d;
                            d = RD(Evd(a, this.b), 220);
                            return d.Yl(this.a).Qj();
                        };
                        _.Ck = function c7d(a, b, c, d) {
                            var e;
                            e = RD(Evd(a, this.b), 220);
                            e.Yl(this.a).Wb(d);
                        };
                        _.Dk = function d7d(a, b, c) {
                            return RD(Evd(a, this.b), 220).Yl(this.a);
                        };
                        _.Ek = function e7d(a, b, c) {
                            var d;
                            d = RD(Evd(a, this.b), 220);
                            d.Yl(this.a).Gk();
                        };
                        var F8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateFeatureMapDelegator', 1350);
                        feb(91, 1, {}, g7d, h7d, i7d, j7d);
                        _.yk = function k7d(a, b, c, d, e) {
                            var f;
                            f = b.li(c);
                            f == null && b.mi(c, f = f7d(this, a));
                            if (!e) switch(this.e){
                                case 50:
                                case 41:
                                    return RD(f, 597).bk();
                                case 40:
                                    return RD(f, 220).Vl();
                            }
                            return f;
                        };
                        _.zk = function l7d(a, b, c, d, e) {
                            var f, g;
                            g = b.li(c);
                            g == null && b.mi(c, g = f7d(this, a));
                            f = RD(g, 71).Wk(d, e);
                            return f;
                        };
                        _.Ak = function m7d(a, b, c, d, e) {
                            var f;
                            f = b.li(c);
                            f != null && (e = RD(f, 71).Xk(d, e));
                            return e;
                        };
                        _.Bk = function n7d(a, b, c) {
                            var d;
                            d = b.li(c);
                            return d != null && RD(d, 79).Qj();
                        };
                        _.Ck = function o7d(a, b, c, d) {
                            var e;
                            e = RD(b.li(c), 79);
                            !e && b.mi(c, e = f7d(this, a));
                            e.Wb(d);
                        };
                        _.Dk = function p7d(a, b, c) {
                            var d, e;
                            e = b.li(c);
                            e == null && b.mi(c, e = f7d(this, a));
                            if (ZD(e, 79)) return RD(e, 79);
                            else {
                                d = RD(b.li(c), 15);
                                return new I9d(d);
                            }
                        };
                        _.Ek = function q7d(a, b, c) {
                            var d;
                            d = RD(b.li(c), 79);
                            !d && b.mi(c, d = f7d(this, a));
                            d.Gk();
                        };
                        _.b = 0;
                        _.e = 0;
                        var G8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateMany', 91);
                        feb(512, 1, {});
                        _.zk = function u7d(a, b, c, d, e) {
                            throw Adb(new jib);
                        };
                        _.Ak = function v7d(a, b, c, d, e) {
                            throw Adb(new jib);
                        };
                        _.Dk = function w7d(a, b, c) {
                            return new x7d(this, a, b, c);
                        };
                        var r7d;
                        var n9 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingle', 512);
                        feb(1367, 1, $Je, x7d);
                        _.Fk = function y7d(a) {
                            return this.a.yk(this.c, this.d, this.b, a, true);
                        };
                        _.Qj = function z7d() {
                            return this.a.Bk(this.c, this.d, this.b);
                        };
                        _.Wb = function A7d(a) {
                            this.a.Ck(this.c, this.d, this.b, a);
                        };
                        _.Gk = function B7d() {
                            this.a.Ek(this.c, this.d, this.b);
                        };
                        _.b = 0;
                        var H8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingle/1', 1367);
                        feb(784, 512, {}, C7d);
                        _.yk = function D7d(a, b, c, d, e) {
                            return jwd(a, a.Ph(), a.Fh()) == this.b ? this.bl() && d ? yvd(a) : a.Ph() : null;
                        };
                        _.zk = function E7d(a, b, c, d, e) {
                            var f, g;
                            !!a.Ph() && (e = (f = a.Fh(), f >= 0 ? a.Ah(e) : a.Ph().Th(a, -1 - f, null, e)));
                            g = BYd(a.Dh(), this.e);
                            return a.Ch(d, g, e);
                        };
                        _.Ak = function F7d(a, b, c, d, e) {
                            var f;
                            f = BYd(a.Dh(), this.e);
                            return a.Ch(null, f, e);
                        };
                        _.Bk = function G7d(a, b, c) {
                            var d;
                            d = BYd(a.Dh(), this.e);
                            return !!a.Ph() && a.Fh() == d;
                        };
                        _.Ck = function H7d(a, b, c, d) {
                            var e, f, g, h, i;
                            if (d != null && !FXd(this.a, d)) throw Adb(new Ifb(xKe + (ZD(d, 58) ? GYd(RD(d, 58).Dh()) : ofb(rb(d))) + yKe + this.a + "'"));
                            e = a.Ph();
                            g = BYd(a.Dh(), this.e);
                            if (dE(d) !== dE(e) || a.Fh() != g && d != null) {
                                if (Oje(a, RD(d, 58))) throw Adb(new agb(UHe + a.Ib()));
                                i = null;
                                !!e && (i = (f = a.Fh(), f >= 0 ? a.Ah(i) : a.Ph().Th(a, -1 - f, null, i)));
                                h = RD(d, 54);
                                !!h && (i = h.Rh(a, BYd(h.Dh(), this.b), null, i));
                                i = a.Ch(h, g, i);
                                !!i && i.oj();
                            } else a.vh() && a.wh() && qvd(a, new N3d(a, 1, g, d, d));
                        };
                        _.Ek = function I7d(a, b, c) {
                            var d, e, f, g;
                            d = a.Ph();
                            if (d) {
                                g = (e = a.Fh(), e >= 0 ? a.Ah(null) : a.Ph().Th(a, -1 - e, null, null));
                                f = BYd(a.Dh(), this.e);
                                g = a.Ch(null, f, g);
                                !!g && g.oj();
                            } else a.vh() && a.wh() && qvd(a, new b4d(a, 1, this.e, null, null));
                        };
                        _.bl = function J7d() {
                            return false;
                        };
                        var J8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleContainer', 784);
                        feb(1351, 784, {}, K7d);
                        _.bl = function L7d() {
                            return true;
                        };
                        var I8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleContainerResolving', 1351);
                        feb(574, 512, {});
                        _.yk = function O7d(a, b, c, d, e) {
                            var f;
                            return f = b.li(c), f == null ? this.b : dE(f) === dE(r7d) ? null : f;
                        };
                        _.Bk = function P7d(a, b, c) {
                            var d;
                            d = b.li(c);
                            return d != null && (dE(d) === dE(r7d) || !pb(d, this.b));
                        };
                        _.Ck = function Q7d(a, b, c, d) {
                            var e, f;
                            if (a.vh() && a.wh()) {
                                e = (f = b.li(c), f == null ? this.b : dE(f) === dE(r7d) ? null : f);
                                if (d == null) {
                                    if (this.c != null) {
                                        b.mi(c, null);
                                        d = this.b;
                                    } else this.b != null ? b.mi(c, r7d) : b.mi(c, null);
                                } else {
                                    this.Bl(d);
                                    b.mi(c, d);
                                }
                                qvd(a, this.d.Cl(a, 1, this.e, e, d));
                            } else if (d == null) this.c != null ? b.mi(c, null) : this.b != null ? b.mi(c, r7d) : b.mi(c, null);
                            else {
                                this.Bl(d);
                                b.mi(c, d);
                            }
                        };
                        _.Ek = function R7d(a, b, c) {
                            var d, e;
                            if (a.vh() && a.wh()) {
                                d = (e = b.li(c), e == null ? this.b : dE(e) === dE(r7d) ? null : e);
                                b.ni(c);
                                qvd(a, this.d.Cl(a, 1, this.e, d, this.b));
                            } else b.ni(c);
                        };
                        _.Bl = function S7d(a) {
                            throw Adb(new Hfb);
                        };
                        var Y8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData', 574);
                        feb(zKe, 1, {}, b8d);
                        _.Cl = function c8d(a, b, c, d, e) {
                            return new b4d(a, b, c, d, e);
                        };
                        _.Dl = function d8d(a, b, c, d, e, f) {
                            return new d4d(a, b, c, d, e, f);
                        };
                        var T7d, U7d, V7d, W7d, X7d, Y7d, Z7d, $7d, _7d;
                        var S8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator', zKe);
                        feb(1368, zKe, {}, e8d);
                        _.Cl = function f8d(a, b, c, d, e) {
                            return new g4d(a, b, c, Heb(TD(d)), Heb(TD(e)));
                        };
                        _.Dl = function g8d(a, b, c, d, e, f) {
                            return new h4d(a, b, c, Heb(TD(d)), Heb(TD(e)), f);
                        };
                        var K8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/1', 1368);
                        feb(1369, zKe, {}, h8d);
                        _.Cl = function i8d(a, b, c, d, e) {
                            return new R3d(a, b, c, RD(d, 222).a, RD(e, 222).a);
                        };
                        _.Dl = function j8d(a, b, c, d, e, f) {
                            return new S3d(a, b, c, RD(d, 222).a, RD(e, 222).a, f);
                        };
                        var L8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/2', 1369);
                        feb(1370, zKe, {}, k8d);
                        _.Cl = function l8d(a, b, c, d, e) {
                            return new T3d(a, b, c, RD(d, 180).a, RD(e, 180).a);
                        };
                        _.Dl = function m8d(a, b, c, d, e, f) {
                            return new U3d(a, b, c, RD(d, 180).a, RD(e, 180).a, f);
                        };
                        var M8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/3', 1370);
                        feb(1371, zKe, {}, n8d);
                        _.Cl = function o8d(a, b, c, d, e) {
                            return new V3d(a, b, c, Kfb(UD(d)), Kfb(UD(e)));
                        };
                        _.Dl = function p8d(a, b, c, d, e, f) {
                            return new W3d(a, b, c, Kfb(UD(d)), Kfb(UD(e)), f);
                        };
                        var N8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/4', 1371);
                        feb(1372, zKe, {}, q8d);
                        _.Cl = function r8d(a, b, c, d, e) {
                            return new X3d(a, b, c, RD(d, 161).a, RD(e, 161).a);
                        };
                        _.Dl = function s8d(a, b, c, d, e, f) {
                            return new Y3d(a, b, c, RD(d, 161).a, RD(e, 161).a, f);
                        };
                        var O8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/5', 1372);
                        feb(1373, zKe, {}, t8d);
                        _.Cl = function u8d(a, b, c, d, e) {
                            return new Z3d(a, b, c, RD(d, 17).a, RD(e, 17).a);
                        };
                        _.Dl = function v8d(a, b, c, d, e, f) {
                            return new $3d(a, b, c, RD(d, 17).a, RD(e, 17).a, f);
                        };
                        var P8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/6', 1373);
                        feb(1374, zKe, {}, w8d);
                        _.Cl = function x8d(a, b, c, d, e) {
                            return new _3d(a, b, c, RD(d, 168).a, RD(e, 168).a);
                        };
                        _.Dl = function y8d(a, b, c, d, e, f) {
                            return new a4d(a, b, c, RD(d, 168).a, RD(e, 168).a, f);
                        };
                        var Q8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/7', 1374);
                        feb(1375, zKe, {}, z8d);
                        _.Cl = function A8d(a, b, c, d, e) {
                            return new e4d(a, b, c, RD(d, 191).a, RD(e, 191).a);
                        };
                        _.Dl = function B8d(a, b, c, d, e, f) {
                            return new f4d(a, b, c, RD(d, 191).a, RD(e, 191).a, f);
                        };
                        var R8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/8', 1375);
                        feb(1353, 574, {}, C8d);
                        _.Bl = function D8d(a) {
                            if (!this.a.fk(a)) throw Adb(new Ifb(xKe + rb(a) + yKe + this.a + "'"));
                        };
                        var T8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleDataDynamic', 1353);
                        feb(1354, 574, {}, E8d);
                        _.Bl = function F8d(a) {};
                        var U8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleDataStatic', 1354);
                        feb(785, 574, {});
                        _.Bk = function G8d(a, b, c) {
                            var d;
                            d = b.li(c);
                            return d != null;
                        };
                        _.Ck = function H8d(a, b, c, d) {
                            var e, f;
                            if (a.vh() && a.wh()) {
                                e = true;
                                f = b.li(c);
                                if (f == null) {
                                    e = false;
                                    f = this.b;
                                } else dE(f) === dE(r7d) && (f = null);
                                if (d == null) {
                                    if (this.c != null) {
                                        b.mi(c, null);
                                        d = this.b;
                                    } else b.mi(c, r7d);
                                } else {
                                    this.Bl(d);
                                    b.mi(c, d);
                                }
                                qvd(a, this.d.Dl(a, 1, this.e, f, d, !e));
                            } else if (d == null) this.c != null ? b.mi(c, null) : b.mi(c, r7d);
                            else {
                                this.Bl(d);
                                b.mi(c, d);
                            }
                        };
                        _.Ek = function I8d(a, b, c) {
                            var d, e;
                            if (a.vh() && a.wh()) {
                                d = true;
                                e = b.li(c);
                                if (e == null) {
                                    d = false;
                                    e = this.b;
                                } else dE(e) === dE(r7d) && (e = null);
                                b.ni(c);
                                qvd(a, this.d.Dl(a, 2, this.e, e, this.b, d));
                            } else b.ni(c);
                        };
                        var X8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleDataUnsettable', 785);
                        feb(1355, 785, {}, J8d);
                        _.Bl = function K8d(a) {
                            if (!this.a.fk(a)) throw Adb(new Ifb(xKe + rb(a) + yKe + this.a + "'"));
                        };
                        var V8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleDataUnsettableDynamic', 1355);
                        feb(1356, 785, {}, L8d);
                        _.Bl = function M8d(a) {};
                        var W8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleDataUnsettableStatic', 1356);
                        feb(410, 512, {}, N8d);
                        _.yk = function P8d(a, b, c, d, e) {
                            var f, g, h, i, j;
                            j = b.li(c);
                            if (this.tk() && dE(j) === dE(r7d)) return null;
                            else if (this.bl() && d && j != null) {
                                h = RD(j, 54);
                                if (h.Vh()) {
                                    i = Vvd(a, h);
                                    if (h != i) {
                                        if (!FXd(this.a, i)) throw Adb(new Ifb(xKe + rb(i) + yKe + this.a + "'"));
                                        b.mi(c, j = i);
                                        if (this.al()) {
                                            f = RD(i, 54);
                                            g = h.Th(a, !this.b ? -1 - BYd(a.Dh(), this.e) : BYd(h.Dh(), this.b), null, null);
                                            !f.Ph() && (g = f.Rh(a, !this.b ? -1 - BYd(a.Dh(), this.e) : BYd(f.Dh(), this.b), null, g));
                                            !!g && g.oj();
                                        }
                                        a.vh() && a.wh() && qvd(a, new b4d(a, 9, this.e, h, i));
                                    }
                                }
                                return j;
                            } else return j;
                        };
                        _.zk = function Q8d(a, b, c, d, e) {
                            var f, g;
                            g = b.li(c);
                            dE(g) === dE(r7d) && (g = null);
                            b.mi(c, d);
                            if (this.Mj()) {
                                if (dE(g) !== dE(d) && g != null) {
                                    f = RD(g, 54);
                                    e = f.Th(a, BYd(f.Dh(), this.b), null, e);
                                }
                            } else this.al() && g != null && (e = RD(g, 54).Th(a, -1 - BYd(a.Dh(), this.e), null, e));
                            if (a.vh() && a.wh()) {
                                !e && (e = new gLd(4));
                                e.nj(new b4d(a, 1, this.e, g, d));
                            }
                            return e;
                        };
                        _.Ak = function R8d(a, b, c, d, e) {
                            var f;
                            f = b.li(c);
                            dE(f) === dE(r7d) && (f = null);
                            b.ni(c);
                            if (a.vh() && a.wh()) {
                                !e && (e = new gLd(4));
                                this.tk() ? e.nj(new b4d(a, 2, this.e, f, null)) : e.nj(new b4d(a, 1, this.e, f, null));
                            }
                            return e;
                        };
                        _.Bk = function S8d(a, b, c) {
                            var d;
                            d = b.li(c);
                            return d != null;
                        };
                        _.Ck = function T8d(a, b, c, d) {
                            var e, f, g, h, i;
                            if (d != null && !FXd(this.a, d)) throw Adb(new Ifb(xKe + (ZD(d, 58) ? GYd(RD(d, 58).Dh()) : ofb(rb(d))) + yKe + this.a + "'"));
                            i = b.li(c);
                            h = i != null;
                            this.tk() && dE(i) === dE(r7d) && (i = null);
                            g = null;
                            if (this.Mj()) {
                                if (dE(i) !== dE(d)) {
                                    if (i != null) {
                                        e = RD(i, 54);
                                        g = e.Th(a, BYd(e.Dh(), this.b), null, g);
                                    }
                                    if (d != null) {
                                        e = RD(d, 54);
                                        g = e.Rh(a, BYd(e.Dh(), this.b), null, g);
                                    }
                                }
                            } else if (this.al()) {
                                if (dE(i) !== dE(d)) {
                                    i != null && (g = RD(i, 54).Th(a, -1 - BYd(a.Dh(), this.e), null, g));
                                    d != null && (g = RD(d, 54).Rh(a, -1 - BYd(a.Dh(), this.e), null, g));
                                }
                            }
                            d == null && this.tk() ? b.mi(c, r7d) : b.mi(c, d);
                            if (a.vh() && a.wh()) {
                                f = new d4d(a, 1, this.e, i, d, this.tk() && !h);
                                if (!g) qvd(a, f);
                                else {
                                    g.nj(f);
                                    g.oj();
                                }
                            } else !!g && g.oj();
                        };
                        _.Ek = function U8d(a, b, c) {
                            var d, e, f, g, h;
                            h = b.li(c);
                            g = h != null;
                            this.tk() && dE(h) === dE(r7d) && (h = null);
                            f = null;
                            if (h != null) {
                                if (this.Mj()) {
                                    d = RD(h, 54);
                                    f = d.Th(a, BYd(d.Dh(), this.b), null, f);
                                } else this.al() && (f = RD(h, 54).Th(a, -1 - BYd(a.Dh(), this.e), null, f));
                            }
                            b.ni(c);
                            if (a.vh() && a.wh()) {
                                e = new d4d(a, this.tk() ? 2 : 1, this.e, h, null, g);
                                if (!f) qvd(a, e);
                                else {
                                    f.nj(e);
                                    f.oj();
                                }
                            } else !!f && f.oj();
                        };
                        _.Mj = function V8d() {
                            return false;
                        };
                        _.al = function W8d() {
                            return false;
                        };
                        _.bl = function X8d() {
                            return false;
                        };
                        _.tk = function Y8d() {
                            return false;
                        };
                        var m9 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObject', 410);
                        feb(575, 410, {}, Z8d);
                        _.al = function $8d() {
                            return true;
                        };
                        var e9 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainment', 575);
                        feb(1359, 575, {}, _8d);
                        _.bl = function a9d() {
                            return true;
                        };
                        var Z8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentResolving', 1359);
                        feb(787, 575, {}, b9d);
                        _.tk = function c9d() {
                            return true;
                        };
                        var _8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentUnsettable', 787);
                        feb(1361, 787, {}, d9d);
                        _.bl = function e9d() {
                            return true;
                        };
                        var $8 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentUnsettableResolving', 1361);
                        feb(650, 575, {}, f9d);
                        _.Mj = function g9d() {
                            return true;
                        };
                        var d9 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverse', 650);
                        feb(1360, 650, {}, h9d);
                        _.bl = function i9d() {
                            return true;
                        };
                        var a9 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverseResolving', 1360);
                        feb(788, 650, {}, j9d);
                        _.tk = function k9d() {
                            return true;
                        };
                        var c9 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettable', 788);
                        feb(1362, 788, {}, l9d);
                        _.bl = function m9d() {
                            return true;
                        };
                        var b9 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettableResolving', 1362);
                        feb(651, 410, {}, n9d);
                        _.bl = function o9d() {
                            return true;
                        };
                        var i9 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolving', 651);
                        feb(1363, 651, {}, p9d);
                        _.tk = function q9d() {
                            return true;
                        };
                        var f9 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolvingUnsettable', 1363);
                        feb(789, 651, {}, r9d);
                        _.Mj = function s9d() {
                            return true;
                        };
                        var h9 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolvingWithInverse', 789);
                        feb(1364, 789, {}, t9d);
                        _.tk = function u9d() {
                            return true;
                        };
                        var g9 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolvingWithInverseUnsettable', 1364);
                        feb(1357, 410, {}, v9d);
                        _.tk = function w9d() {
                            return true;
                        };
                        var j9 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectUnsettable', 1357);
                        feb(786, 410, {}, x9d);
                        _.Mj = function y9d() {
                            return true;
                        };
                        var l9 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectWithInverse', 786);
                        feb(1358, 786, {}, z9d);
                        _.tk = function A9d() {
                            return true;
                        };
                        var k9 = sfb(SHe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectWithInverseUnsettable', 1358);
                        feb(790, 576, wKe, D9d);
                        _.yl = function E9d(a) {
                            return new D9d(this.a, this.c, a);
                        };
                        _.md = function F9d() {
                            return this.b;
                        };
                        _.zl = function G9d(a, b, c) {
                            return B9d(this, a, this.b, c);
                        };
                        _.Al = function H9d(a, b, c) {
                            return C9d(this, a, this.b, c);
                        };
                        var o9 = sfb(SHe, 'EStructuralFeatureImpl/InverseUpdatingFeatureMapEntry', 790);
                        feb(1365, 1, $Je, I9d);
                        _.Fk = function J9d(a) {
                            return this.a;
                        };
                        _.Qj = function K9d() {
                            return ZD(this.a, 97) ? RD(this.a, 97).Qj() : !this.a.dc();
                        };
                        _.Wb = function L9d(a) {
                            this.a.$b();
                            this.a.Gc(RD(a, 15));
                        };
                        _.Gk = function M9d() {
                            ZD(this.a, 97) ? RD(this.a, 97).Gk() : this.a.$b();
                        };
                        var p9 = sfb(SHe, 'EStructuralFeatureImpl/SettingMany', 1365);
                        feb(1366, 576, wKe, N9d);
                        _.xl = function O9d(a) {
                            return new S9d((nme(), mme), this.b.ri(this.a, a));
                        };
                        _.md = function P9d() {
                            return null;
                        };
                        _.zl = function Q9d(a, b, c) {
                            return c;
                        };
                        _.Al = function R9d(a, b, c) {
                            return c;
                        };
                        var q9 = sfb(SHe, 'EStructuralFeatureImpl/SimpleContentFeatureMapEntry', 1366);
                        feb(652, 576, wKe, S9d);
                        _.xl = function T9d(a) {
                            return new S9d(this.c, a);
                        };
                        _.md = function U9d() {
                            return this.a;
                        };
                        _.zl = function V9d(a, b, c) {
                            return c;
                        };
                        _.Al = function W9d(a, b, c) {
                            return c;
                        };
                        var r9 = sfb(SHe, 'EStructuralFeatureImpl/SimpleFeatureMapEntry', 652);
                        feb(403, 506, PIe, X9d);
                        _.aj = function Y9d(a) {
                            return $C(h7, rve, 29, a, 0, 1);
                        };
                        _.Yi = function Z9d() {
                            return false;
                        };
                        var t9 = sfb(SHe, 'ESuperAdapter/1', 403);
                        feb(457, 448, {
                            110: 1,
                            94: 1,
                            93: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            114: 1,
                            850: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            457: 1,
                            119: 1,
                            120: 1
                        }, _9d);
                        _.Lh = function aae(a, b, c) {
                            var d;
                            switch(a){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), this.Ab;
                                case 1:
                                    return this.zb;
                                case 2:
                                    return !this.a && (this.a = new iae(this, o7, this)), this.a;
                            }
                            return zvd(this, a - AYd((JTd(), ITd)), vYd((d = RD(Ywd(this, 16), 29), !d ? ITd : d), a), b, c);
                        };
                        _.Uh = function bae(a, b, c) {
                            var d, e;
                            switch(b){
                                case 0:
                                    return !this.Ab && (this.Ab = new C5d(f7, this, 0, 3)), rLd(this.Ab, a, c);
                                case 2:
                                    return !this.a && (this.a = new iae(this, o7, this)), rLd(this.a, a, c);
                            }
                            return e = RD(vYd((d = RD(Ywd(this, 16), 29), !d ? (JTd(), ITd) : d), b), 69), e.wk().Ak(this, Wwd(this), b - AYd((JTd(), ITd)), a, c);
                        };
                        _.Wh = function cae(a) {
                            var b;
                            switch(a){
                                case 0:
                                    return !!this.Ab && this.Ab.i != 0;
                                case 1:
                                    return this.zb != null;
                                case 2:
                                    return !!this.a && this.a.i != 0;
                            }
                            return Avd(this, a - AYd((JTd(), ITd)), vYd((b = RD(Ywd(this, 16), 29), !b ? ITd : b), a));
                        };
                        _.bi = function dae(a, b) {
                            var c;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    YGd(this.Ab, RD(b, 16));
                                    return;
                                case 1:
                                    PAd(this, WD(b));
                                    return;
                                case 2:
                                    !this.a && (this.a = new iae(this, o7, this));
                                    sLd(this.a);
                                    !this.a && (this.a = new iae(this, o7, this));
                                    YGd(this.a, RD(b, 16));
                                    return;
                            }
                            Bvd(this, a - AYd((JTd(), ITd)), vYd((c = RD(Ywd(this, 16), 29), !c ? ITd : c), a), b);
                        };
                        _.ii = function eae() {
                            return JTd(), ITd;
                        };
                        _.ki = function fae(a) {
                            var b;
                            switch(a){
                                case 0:
                                    !this.Ab && (this.Ab = new C5d(f7, this, 0, 3));
                                    sLd(this.Ab);
                                    return;
                                case 1:
                                    PAd(this, null);
                                    return;
                                case 2:
                                    !this.a && (this.a = new iae(this, o7, this));
                                    sLd(this.a);
                                    return;
                            }
                            Cvd(this, a - AYd((JTd(), ITd)), vYd((b = RD(Ywd(this, 16), 29), !b ? ITd : b), a));
                        };
                        var z9 = sfb(SHe, 'ETypeParameterImpl', 457);
                        feb(458, 83, oKe, iae);
                        _.Nj = function jae(a, b) {
                            return gae(this, RD(a, 89), b);
                        };
                        _.Oj = function kae(a, b) {
                            return hae(this, RD(a, 89), b);
                        };
                        var v9 = sfb(SHe, 'ETypeParameterImpl/1', 458);
                        feb(647, 45, Hxe, lae);
                        _.ec = function mae() {
                            return new pae(this);
                        };
                        var y9 = sfb(SHe, 'ETypeParameterImpl/2', 647);
                        feb(570, Eve, Fve, pae);
                        _.Fc = function qae(a) {
                            return nae(this, RD(a, 89));
                        };
                        _.Gc = function rae(a) {
                            var b, c, d;
                            d = false;
                            for(c = a.Kc(); c.Ob();){
                                b = RD(c.Pb(), 89);
                                Zjb(this.a, b, '') == null && (d = true);
                            }
                            return d;
                        };
                        _.$b = function sae() {
                            akb(this.a);
                        };
                        _.Hc = function tae(a) {
                            return Ujb(this.a, a);
                        };
                        _.Kc = function uae() {
                            var a;
                            return a = new vkb(new mkb(this.a).a), new xae(a);
                        };
                        _.Mc = function vae(a) {
                            return oae(this, a);
                        };
                        _.gc = function wae() {
                            return bkb(this.a);
                        };
                        var x9 = sfb(SHe, 'ETypeParameterImpl/2/1', 570);
                        feb(571, 1, Ave, xae);
                        _.Nb = function yae(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function Aae() {
                            return RD(tkb(this.a).ld(), 89);
                        };
                        _.Ob = function zae() {
                            return this.a.b;
                        };
                        _.Qb = function Bae() {
                            ukb(this.a);
                        };
                        var w9 = sfb(SHe, 'ETypeParameterImpl/2/1/1', 571);
                        feb(1329, 45, Hxe, Cae);
                        _._b = function Dae(a) {
                            return bE(a) ? Yjb(this, a) : !!qtb(this.f, a);
                        };
                        _.xc = function Eae(a) {
                            var b, c;
                            b = bE(a) ? Xjb(this, a) : Wd(qtb(this.f, a));
                            if (ZD(b, 851)) {
                                c = RD(b, 851);
                                b = c.Kk();
                                Zjb(this, RD(a, 241), b);
                                return b;
                            } else return b != null ? b : a == null ? (Gie(), Fie) : null;
                        };
                        var B9 = sfb(SHe, 'EValidatorRegistryImpl', 1329);
                        feb(1349, 720, {
                            110: 1,
                            94: 1,
                            93: 1,
                            480: 1,
                            155: 1,
                            58: 1,
                            114: 1,
                            2040: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            119: 1,
                            120: 1
                        }, Mae);
                        _.ri = function Nae(a, b) {
                            switch(a.hk()){
                                case 21:
                                case 22:
                                case 23:
                                case 24:
                                case 26:
                                case 31:
                                case 32:
                                case 37:
                                case 38:
                                case 39:
                                case 40:
                                case 43:
                                case 44:
                                case 48:
                                case 49:
                                case 20:
                                    return b == null ? null : jeb(b);
                                case 25:
                                    return Gae(b);
                                case 27:
                                    return Hae(b);
                                case 28:
                                    return Iae(b);
                                case 29:
                                    return b == null ? null : a2d(nAd[0], RD(b, 206));
                                case 41:
                                    return b == null ? '' : nfb(RD(b, 297));
                                case 42:
                                    return jeb(b);
                                case 50:
                                    return WD(b);
                                default:
                                    throw Adb(new agb(VHe + a.xe() + WHe));
                            }
                        };
                        _.si = function Oae(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
                            switch(a.G == -1 && (a.G = (m = BXd(a), m ? fZd(m.vi(), a) : -1)), a.G){
                                case 0:
                                    return c = new mXd, c;
                                case 1:
                                    return b = new pVd, b;
                                case 2:
                                    return d = new HYd, d;
                                case 4:
                                    return e = new k1d, e;
                                case 5:
                                    return f = new A1d, f;
                                case 6:
                                    return g = new R1d, g;
                                case 7:
                                    return h = new yAd, h;
                                case 10:
                                    return j = new kUd, j;
                                case 11:
                                    return k = new q4d, k;
                                case 12:
                                    return l = new EBd, l;
                                case 13:
                                    return n = new R5d, n;
                                case 14:
                                    return o = new d6d, o;
                                case 17:
                                    return p = new v6d, p;
                                case 18:
                                    return i = new s2d, i;
                                case 19:
                                    return q = new _9d, q;
                                default:
                                    throw Adb(new agb(ZHe + a.zb + WHe));
                            }
                        };
                        _.ti = function Pae(a, b) {
                            switch(a.hk()){
                                case 20:
                                    return b == null ? null : new Bib(b);
                                case 21:
                                    return b == null ? null : new ejb(b);
                                case 23:
                                case 22:
                                    return b == null ? null : Fae(b);
                                case 26:
                                case 24:
                                    return b == null ? null : $eb(Oeb(b, -128, 127) << 24 >> 24);
                                case 25:
                                    return vAd(b);
                                case 27:
                                    return Jae(b);
                                case 28:
                                    return Kae(b);
                                case 29:
                                    return Lae(b);
                                case 32:
                                case 31:
                                    return b == null ? null : Neb(b);
                                case 38:
                                case 37:
                                    return b == null ? null : new Ufb(b);
                                case 40:
                                case 39:
                                    return b == null ? null : sgb(Oeb(b, qwe, lve));
                                case 41:
                                    return null;
                                case 42:
                                    return b == null ? null : null;
                                case 44:
                                case 43:
                                    return b == null ? null : Hgb(Peb(b));
                                case 49:
                                case 48:
                                    return b == null ? null : bhb(Oeb(b, BKe, 32767) << 16 >> 16);
                                case 50:
                                    return b;
                                default:
                                    throw Adb(new agb(VHe + a.xe() + WHe));
                            }
                        };
                        var C9 = sfb(SHe, 'EcoreFactoryImpl', 1349);
                        feb(560, 184, {
                            110: 1,
                            94: 1,
                            93: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            241: 1,
                            114: 1,
                            2038: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            184: 1,
                            560: 1,
                            119: 1,
                            120: 1,
                            690: 1
                        }, $ae);
                        _.gb = false;
                        _.hb = false;
                        var Rae, Sae = false;
                        var tab = sfb(SHe, 'EcorePackageImpl', 560);
                        feb(1234, 1, {
                            851: 1
                        }, cbe);
                        _.Kk = function dbe() {
                            return fke(), eke;
                        };
                        var N9 = sfb(SHe, 'EcorePackageImpl/1', 1234);
                        feb(1243, 1, OKe, ebe);
                        _.fk = function fbe(a) {
                            return ZD(a, 155);
                        };
                        _.gk = function gbe(a) {
                            return $C(p7, rve, 155, a, 0, 1);
                        };
                        var D9 = sfb(SHe, 'EcorePackageImpl/10', 1243);
                        feb(1244, 1, OKe, hbe);
                        _.fk = function ibe(a) {
                            return ZD(a, 197);
                        };
                        _.gk = function jbe(a) {
                            return $C(q7, rve, 197, a, 0, 1);
                        };
                        var E9 = sfb(SHe, 'EcorePackageImpl/11', 1244);
                        feb(1245, 1, OKe, kbe);
                        _.fk = function lbe(a) {
                            return ZD(a, 58);
                        };
                        _.gk = function mbe(a) {
                            return $C(r7, rve, 58, a, 0, 1);
                        };
                        var F9 = sfb(SHe, 'EcorePackageImpl/12', 1245);
                        feb(1246, 1, OKe, nbe);
                        _.fk = function obe(a) {
                            return ZD(a, 411);
                        };
                        _.gk = function pbe(a) {
                            return $C(s7, mKe, 62, a, 0, 1);
                        };
                        var G9 = sfb(SHe, 'EcorePackageImpl/13', 1246);
                        feb(1247, 1, OKe, qbe);
                        _.fk = function rbe(a) {
                            return ZD(a, 241);
                        };
                        _.gk = function sbe(a) {
                            return $C(t7, rve, 241, a, 0, 1);
                        };
                        var H9 = sfb(SHe, 'EcorePackageImpl/14', 1247);
                        feb(1248, 1, OKe, tbe);
                        _.fk = function ube(a) {
                            return ZD(a, 518);
                        };
                        _.gk = function vbe(a) {
                            return $C(u7, rve, 2116, a, 0, 1);
                        };
                        var I9 = sfb(SHe, 'EcorePackageImpl/15', 1248);
                        feb(1249, 1, OKe, wbe);
                        _.fk = function xbe(a) {
                            return ZD(a, 102);
                        };
                        _.gk = function ybe(a) {
                            return $C(v7, lKe, 19, a, 0, 1);
                        };
                        var J9 = sfb(SHe, 'EcorePackageImpl/16', 1249);
                        feb(1250, 1, OKe, zbe);
                        _.fk = function Abe(a) {
                            return ZD(a, 179);
                        };
                        _.gk = function Bbe(a) {
                            return $C(y7, lKe, 179, a, 0, 1);
                        };
                        var K9 = sfb(SHe, 'EcorePackageImpl/17', 1250);
                        feb(1251, 1, OKe, Cbe);
                        _.fk = function Dbe(a) {
                            return ZD(a, 481);
                        };
                        _.gk = function Ebe(a) {
                            return $C(A7, rve, 481, a, 0, 1);
                        };
                        var L9 = sfb(SHe, 'EcorePackageImpl/18', 1251);
                        feb(1252, 1, OKe, Fbe);
                        _.fk = function Gbe(a) {
                            return ZD(a, 561);
                        };
                        _.gk = function Hbe(a) {
                            return $C(C8, LJe, 561, a, 0, 1);
                        };
                        var M9 = sfb(SHe, 'EcorePackageImpl/19', 1252);
                        feb(1235, 1, OKe, Ibe);
                        _.fk = function Jbe(a) {
                            return ZD(a, 331);
                        };
                        _.gk = function Kbe(a) {
                            return $C(g7, lKe, 35, a, 0, 1);
                        };
                        var Y9 = sfb(SHe, 'EcorePackageImpl/2', 1235);
                        feb(1253, 1, OKe, Lbe);
                        _.fk = function Mbe(a) {
                            return ZD(a, 248);
                        };
                        _.gk = function Nbe(a) {
                            return $C(o7, sKe, 89, a, 0, 1);
                        };
                        var O9 = sfb(SHe, 'EcorePackageImpl/20', 1253);
                        feb(1254, 1, OKe, Obe);
                        _.fk = function Pbe(a) {
                            return ZD(a, 457);
                        };
                        _.gk = function Qbe(a) {
                            return $C(z7, rve, 850, a, 0, 1);
                        };
                        var P9 = sfb(SHe, 'EcorePackageImpl/21', 1254);
                        feb(1255, 1, OKe, Rbe);
                        _.fk = function Sbe(a) {
                            return $D(a);
                        };
                        _.gk = function Tbe(a) {
                            return $C(QI, Nve, 485, a, 8, 1);
                        };
                        var Q9 = sfb(SHe, 'EcorePackageImpl/22', 1255);
                        feb(1256, 1, OKe, Ube);
                        _.fk = function Vbe(a) {
                            return ZD(a, 195);
                        };
                        _.gk = function Wbe(a) {
                            return $C(gE, Nve, 195, a, 0, 2);
                        };
                        var R9 = sfb(SHe, 'EcorePackageImpl/23', 1256);
                        feb(1257, 1, OKe, Xbe);
                        _.fk = function Ybe(a) {
                            return ZD(a, 222);
                        };
                        _.gk = function Zbe(a) {
                            return $C(RI, Nve, 222, a, 0, 1);
                        };
                        var S9 = sfb(SHe, 'EcorePackageImpl/24', 1257);
                        feb(1258, 1, OKe, $be);
                        _.fk = function _be(a) {
                            return ZD(a, 180);
                        };
                        _.gk = function ace(a) {
                            return $C(SI, Nve, 180, a, 0, 1);
                        };
                        var T9 = sfb(SHe, 'EcorePackageImpl/25', 1258);
                        feb(1259, 1, OKe, bce);
                        _.fk = function cce(a) {
                            return ZD(a, 206);
                        };
                        _.gk = function dce(a) {
                            return $C(qK, Nve, 206, a, 0, 1);
                        };
                        var U9 = sfb(SHe, 'EcorePackageImpl/26', 1259);
                        feb(1260, 1, OKe, ece);
                        _.fk = function fce(a) {
                            return false;
                        };
                        _.gk = function gce(a) {
                            return $C(T6, rve, 2215, a, 0, 1);
                        };
                        var V9 = sfb(SHe, 'EcorePackageImpl/27', 1260);
                        feb(1261, 1, OKe, hce);
                        _.fk = function ice(a) {
                            return _D(a);
                        };
                        _.gk = function jce(a) {
                            return $C(VI, Nve, 345, a, 7, 1);
                        };
                        var W9 = sfb(SHe, 'EcorePackageImpl/28', 1261);
                        feb(1262, 1, OKe, kce);
                        _.fk = function lce(a) {
                            return ZD(a, 61);
                        };
                        _.gk = function mce(a) {
                            return $C(Y6, Ize, 61, a, 0, 1);
                        };
                        var X9 = sfb(SHe, 'EcorePackageImpl/29', 1262);
                        feb(1236, 1, OKe, nce);
                        _.fk = function oce(a) {
                            return ZD(a, 519);
                        };
                        _.gk = function pce(a) {
                            return $C(f7, {
                                3: 1,
                                4: 1,
                                5: 1,
                                2033: 1
                            }, 598, a, 0, 1);
                        };
                        var hab = sfb(SHe, 'EcorePackageImpl/3', 1236);
                        feb(1263, 1, OKe, qce);
                        _.fk = function rce(a) {
                            return ZD(a, 582);
                        };
                        _.gk = function sce(a) {
                            return $C(Z6, rve, 2039, a, 0, 1);
                        };
                        var Z9 = sfb(SHe, 'EcorePackageImpl/30', 1263);
                        feb(1264, 1, OKe, tce);
                        _.fk = function uce(a) {
                            return ZD(a, 160);
                        };
                        _.gk = function vce(a) {
                            return $C(Tbb, Ize, 160, a, 0, 1);
                        };
                        var $9 = sfb(SHe, 'EcorePackageImpl/31', 1264);
                        feb(1265, 1, OKe, wce);
                        _.fk = function xce(a) {
                            return ZD(a, 76);
                        };
                        _.gk = function yce(a) {
                            return $C(Jbb, PKe, 76, a, 0, 1);
                        };
                        var _9 = sfb(SHe, 'EcorePackageImpl/32', 1265);
                        feb(1266, 1, OKe, zce);
                        _.fk = function Ace(a) {
                            return ZD(a, 161);
                        };
                        _.gk = function Bce(a) {
                            return $C(ZI, Nve, 161, a, 0, 1);
                        };
                        var aab = sfb(SHe, 'EcorePackageImpl/33', 1266);
                        feb(1267, 1, OKe, Cce);
                        _.fk = function Dce(a) {
                            return ZD(a, 17);
                        };
                        _.gk = function Ece(a) {
                            return $C(bJ, Nve, 17, a, 0, 1);
                        };
                        var bab = sfb(SHe, 'EcorePackageImpl/34', 1267);
                        feb(1268, 1, OKe, Fce);
                        _.fk = function Gce(a) {
                            return ZD(a, 297);
                        };
                        _.gk = function Hce(a) {
                            return $C(UI, rve, 297, a, 0, 1);
                        };
                        var cab = sfb(SHe, 'EcorePackageImpl/35', 1268);
                        feb(1269, 1, OKe, Ice);
                        _.fk = function Jce(a) {
                            return ZD(a, 168);
                        };
                        _.gk = function Kce(a) {
                            return $C(eJ, Nve, 168, a, 0, 1);
                        };
                        var dab = sfb(SHe, 'EcorePackageImpl/36', 1269);
                        feb(1270, 1, OKe, Lce);
                        _.fk = function Mce(a) {
                            return ZD(a, 85);
                        };
                        _.gk = function Nce(a) {
                            return $C(VK, rve, 85, a, 0, 1);
                        };
                        var eab = sfb(SHe, 'EcorePackageImpl/37', 1270);
                        feb(1271, 1, OKe, Oce);
                        _.fk = function Pce(a) {
                            return ZD(a, 599);
                        };
                        _.gk = function Qce(a) {
                            return $C(Aab, rve, 599, a, 0, 1);
                        };
                        var fab = sfb(SHe, 'EcorePackageImpl/38', 1271);
                        feb(1272, 1, OKe, Rce);
                        _.fk = function Sce(a) {
                            return false;
                        };
                        _.gk = function Tce(a) {
                            return $C(zab, rve, 2216, a, 0, 1);
                        };
                        var gab = sfb(SHe, 'EcorePackageImpl/39', 1272);
                        feb(1237, 1, OKe, Uce);
                        _.fk = function Vce(a) {
                            return ZD(a, 90);
                        };
                        _.gk = function Wce(a) {
                            return $C(h7, rve, 29, a, 0, 1);
                        };
                        var nab = sfb(SHe, 'EcorePackageImpl/4', 1237);
                        feb(1273, 1, OKe, Xce);
                        _.fk = function Yce(a) {
                            return ZD(a, 191);
                        };
                        _.gk = function Zce(a) {
                            return $C(lJ, Nve, 191, a, 0, 1);
                        };
                        var iab = sfb(SHe, 'EcorePackageImpl/40', 1273);
                        feb(1274, 1, OKe, $ce);
                        _.fk = function _ce(a) {
                            return bE(a);
                        };
                        _.gk = function ade(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var jab = sfb(SHe, 'EcorePackageImpl/41', 1274);
                        feb(1275, 1, OKe, bde);
                        _.fk = function cde(a) {
                            return ZD(a, 596);
                        };
                        _.gk = function dde(a) {
                            return $C(a7, rve, 596, a, 0, 1);
                        };
                        var kab = sfb(SHe, 'EcorePackageImpl/42', 1275);
                        feb(1276, 1, OKe, ede);
                        _.fk = function fde(a) {
                            return false;
                        };
                        _.gk = function gde(a) {
                            return $C($6, Nve, 2217, a, 0, 1);
                        };
                        var lab = sfb(SHe, 'EcorePackageImpl/43', 1276);
                        feb(1277, 1, OKe, hde);
                        _.fk = function ide(a) {
                            return ZD(a, 44);
                        };
                        _.gk = function jde(a) {
                            return $C(UK, Zve, 44, a, 0, 1);
                        };
                        var mab = sfb(SHe, 'EcorePackageImpl/44', 1277);
                        feb(1238, 1, OKe, kde);
                        _.fk = function lde(a) {
                            return ZD(a, 142);
                        };
                        _.gk = function mde(a) {
                            return $C(i7, rve, 142, a, 0, 1);
                        };
                        var oab = sfb(SHe, 'EcorePackageImpl/5', 1238);
                        feb(1239, 1, OKe, nde);
                        _.fk = function ode(a) {
                            return ZD(a, 156);
                        };
                        _.gk = function pde(a) {
                            return $C(k7, rve, 156, a, 0, 1);
                        };
                        var pab = sfb(SHe, 'EcorePackageImpl/6', 1239);
                        feb(1240, 1, OKe, qde);
                        _.fk = function rde(a) {
                            return ZD(a, 469);
                        };
                        _.gk = function sde(a) {
                            return $C(m7, rve, 685, a, 0, 1);
                        };
                        var qab = sfb(SHe, 'EcorePackageImpl/7', 1240);
                        feb(1241, 1, OKe, tde);
                        _.fk = function ude(a) {
                            return ZD(a, 582);
                        };
                        _.gk = function vde(a) {
                            return $C(l7, rve, 694, a, 0, 1);
                        };
                        var rab = sfb(SHe, 'EcorePackageImpl/8', 1241);
                        feb(1242, 1, OKe, wde);
                        _.fk = function xde(a) {
                            return ZD(a, 480);
                        };
                        _.gk = function yde(a) {
                            return $C(n7, rve, 480, a, 0, 1);
                        };
                        var sab = sfb(SHe, 'EcorePackageImpl/9', 1242);
                        feb(1038, 2080, JJe, Cde);
                        _.Mi = function Dde(a, b) {
                            zde(this, RD(b, 424));
                        };
                        _.Qi = function Ede(a, b) {
                            Ade(this, a, RD(b, 424));
                        };
                        var vab = sfb(SHe, 'MinimalEObjectImpl/1ArrayDelegatingAdapterList', 1038);
                        feb(1039, 152, GJe, Fde);
                        _.jj = function Gde() {
                            return this.a.a;
                        };
                        var uab = sfb(SHe, 'MinimalEObjectImpl/1ArrayDelegatingAdapterList/1', 1039);
                        feb(1067, 1066, {}, Ide);
                        var yab = sfb('org.eclipse.emf.ecore.plugin', 'EcorePlugin', 1067);
                        var Aab = ufb(QKe, 'Resource');
                        feb(799, 1524, RKe);
                        _.Hl = function Mde(a) {};
                        _.Il = function Nde(a) {};
                        _.El = function Ode() {
                            return !this.a && (this.a = new Zde(this)), this.a;
                        };
                        _.Fl = function Pde(a) {
                            var b, c, d, e, f;
                            d = a.length;
                            if (d > 0) {
                                BFb(0, a.length);
                                if (a.charCodeAt(0) == 47) {
                                    f = new cnb(4);
                                    e = 1;
                                    for(b = 1; b < d; ++b){
                                        BFb(b, a.length);
                                        if (a.charCodeAt(b) == 47) {
                                            Rmb(f, e == b ? '' : (AFb(e, b, a.length), a.substr(e, b - e)));
                                            e = b + 1;
                                        }
                                    }
                                    Rmb(f, (BFb(e, a.length + 1), a.substr(e)));
                                    return Jde(this, f);
                                } else {
                                    BFb(d - 1, a.length);
                                    if (a.charCodeAt(d - 1) == 63) {
                                        c = uhb(a, Fhb(63), d - 2);
                                        c > 0 && (a = (AFb(0, c, a.length), a.substr(0, c)));
                                    }
                                }
                            }
                            return Kde(this, a);
                        };
                        _.Gl = function Qde() {
                            return this.c;
                        };
                        _.Ib = function Rde() {
                            var a;
                            return nfb(this.Rm) + '@' + (a = tb(this) >>> 0, a.toString(16)) + " uri='" + this.d + "'";
                        };
                        _.b = false;
                        var Eab = sfb(SKe, 'ResourceImpl', 799);
                        feb(1525, 799, RKe, Sde);
                        var Bab = sfb(SKe, 'BinaryResourceImpl', 1525);
                        feb(1190, 708, QIe);
                        _.bj = function Vde(a) {
                            return ZD(a, 58) ? Tde(this, RD(a, 58)) : ZD(a, 599) ? new dMd(RD(a, 599).El()) : dE(a) === dE(this.f) ? RD(a, 16).Kc() : (jQd(), iQd.a);
                        };
                        _.Ob = function Wde() {
                            return Ude(this);
                        };
                        _.a = false;
                        var Ebb = sfb(ZJe, 'EcoreUtil/ContentTreeIterator', 1190);
                        feb(1526, 1190, QIe, Xde);
                        _.bj = function Yde(a) {
                            return dE(a) === dE(this.f) ? RD(a, 15).Kc() : new _je(RD(a, 58));
                        };
                        var Cab = sfb(SKe, 'ResourceImpl/5', 1526);
                        feb(658, 2092, nKe, Zde);
                        _.Hc = function $de(a) {
                            return this.i <= 4 ? PHd(this, a) : ZD(a, 54) && RD(a, 54).Jh() == this.a;
                        };
                        _.Mi = function _de(a, b) {
                            a == this.i - 1 && (this.a.b || (this.a.b = true));
                        };
                        _.Oi = function aee(a, b) {
                            a == 0 ? this.a.b || (this.a.b = true) : $Gd(this, a, b);
                        };
                        _.Qi = function bee(a, b) {};
                        _.Ri = function cee(a, b, c) {};
                        _.Lj = function dee() {
                            return 2;
                        };
                        _.jj = function eee() {
                            return this.a;
                        };
                        _.Mj = function fee() {
                            return true;
                        };
                        _.Nj = function gee(a, b) {
                            var c;
                            c = RD(a, 54);
                            b = c.fi(this.a, b);
                            return b;
                        };
                        _.Oj = function hee(a, b) {
                            var c;
                            c = RD(a, 54);
                            return c.fi(null, b);
                        };
                        _.Pj = function iee() {
                            return false;
                        };
                        _.Si = function jee() {
                            return true;
                        };
                        _.aj = function kee(a) {
                            return $C(r7, rve, 58, a, 0, 1);
                        };
                        _.Yi = function lee() {
                            return false;
                        };
                        var Dab = sfb(SKe, 'ResourceImpl/ContentsEList', 658);
                        feb(970, 2062, kwe, mee);
                        _.fd = function nee(a) {
                            return this.a.Ki(a);
                        };
                        _.gc = function oee() {
                            return this.a.gc();
                        };
                        var Fab = sfb(ZJe, 'AbstractSequentialInternalEList/1', 970);
                        var hke, ike, jke, kke;
                        feb(634, 1, {}, Yee);
                        var pee, qee;
                        var Lab = sfb(ZJe, 'BasicExtendedMetaData', 634);
                        feb(1181, 1, {}, afe);
                        _.Jl = function bfe() {
                            return null;
                        };
                        _.Kl = function cfe() {
                            this.a == -2 && $ee(this, uee(this.d, this.b));
                            return this.a;
                        };
                        _.Ll = function dfe() {
                            return null;
                        };
                        _.Ml = function efe() {
                            return yob(), yob(), vob;
                        };
                        _.xe = function ffe() {
                            this.c == fLe && _ee(this, zee(this.d, this.b));
                            return this.c;
                        };
                        _.Nl = function gfe() {
                            return 0;
                        };
                        _.a = -2;
                        _.c = fLe;
                        var Hab = sfb(ZJe, 'BasicExtendedMetaData/EClassExtendedMetaDataImpl', 1181);
                        feb(1182, 1, {}, mfe);
                        _.Jl = function nfe() {
                            this.a == (ree(), pee) && hfe(this, tee(this.f, this.b));
                            return this.a;
                        };
                        _.Kl = function ofe() {
                            return 0;
                        };
                        _.Ll = function pfe() {
                            this.c == (ree(), pee) && ife(this, xee(this.f, this.b));
                            return this.c;
                        };
                        _.Ml = function qfe() {
                            !this.d && jfe(this, yee(this.f, this.b));
                            return this.d;
                        };
                        _.xe = function rfe() {
                            this.e == fLe && kfe(this, zee(this.f, this.b));
                            return this.e;
                        };
                        _.Nl = function sfe() {
                            this.g == -2 && lfe(this, Cee(this.f, this.b));
                            return this.g;
                        };
                        _.e = fLe;
                        _.g = -2;
                        var Iab = sfb(ZJe, 'BasicExtendedMetaData/EDataTypeExtendedMetaDataImpl', 1182);
                        feb(1180, 1, {}, wfe);
                        _.b = false;
                        _.c = false;
                        var Jab = sfb(ZJe, 'BasicExtendedMetaData/EPackageExtendedMetaDataImpl', 1180);
                        feb(1183, 1, {}, Jfe);
                        _.c = -2;
                        _.e = fLe;
                        _.f = fLe;
                        var Kab = sfb(ZJe, 'BasicExtendedMetaData/EStructuralFeatureExtendedMetaDataImpl', 1183);
                        feb(593, 632, oKe, Kfe);
                        _.Lj = function Lfe() {
                            return this.c;
                        };
                        _.ol = function Mfe() {
                            return false;
                        };
                        _.Wi = function Nfe(a, b) {
                            return b;
                        };
                        _.c = 0;
                        var Yab = sfb(ZJe, 'EDataTypeEList', 593);
                        var Tbb = ufb(ZJe, 'FeatureMap');
                        feb(78, 593, {
                            3: 1,
                            4: 1,
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            59: 1,
                            70: 1,
                            66: 1,
                            61: 1,
                            79: 1,
                            160: 1,
                            220: 1,
                            2036: 1,
                            71: 1,
                            97: 1
                        }, Uge);
                        _.bd = function Vge(a, b) {
                            Ofe(this, a, RD(b, 76));
                        };
                        _.Fc = function Wge(a) {
                            return Rfe(this, RD(a, 76));
                        };
                        _.Hi = function _ge(a) {
                            Wfe(this, RD(a, 76));
                        };
                        _.Nj = function khe(a, b) {
                            return mge(this, RD(a, 76), b);
                        };
                        _.Oj = function lhe(a, b) {
                            return oge(this, RD(a, 76), b);
                        };
                        _.Ti = function nhe(a, b) {
                            return uge(this, a, b);
                        };
                        _.Wi = function phe(a, b) {
                            return zge(this, a, RD(b, 76));
                        };
                        _.hd = function rhe(a, b) {
                            return Cge(this, a, RD(b, 76));
                        };
                        _.Uj = function vhe(a, b) {
                            return Ige(this, RD(a, 76), b);
                        };
                        _.Vj = function whe(a, b) {
                            return Kge(this, RD(a, 76), b);
                        };
                        _.Wj = function xhe(a, b, c) {
                            return Lge(this, RD(a, 76), RD(b, 76), c);
                        };
                        _.Zi = function zhe(a, b) {
                            return Tge(this, a, RD(b, 76));
                        };
                        _.Ol = function Xge(a, b) {
                            return Qfe(this, a, b);
                        };
                        _.cd = function Yge(a, b) {
                            var c, d, e, f, g, h, i, j, k;
                            j = new ZHd(b.gc());
                            for(e = b.Kc(); e.Ob();){
                                d = RD(e.Pb(), 76);
                                f = d.Lk();
                                if (qke(this.e, f)) (!f.Si() || !cge(this, f, d.md()) && !PHd(j, d)) && WGd(j, d);
                                else {
                                    k = pke(this.e.Dh(), f);
                                    c = RD(this.g, 124);
                                    g = true;
                                    for(h = 0; h < this.i; ++h){
                                        i = c[h];
                                        if (k.am(i.Lk())) {
                                            RD(eHd(this, h, d), 76);
                                            g = false;
                                            break;
                                        }
                                    }
                                    g && WGd(j, d);
                                }
                            }
                            return XGd(this, a, j);
                        };
                        _.Gc = function Zge(a) {
                            var b, c, d, e, f, g, h, i, j;
                            i = new ZHd(a.gc());
                            for(d = a.Kc(); d.Ob();){
                                c = RD(d.Pb(), 76);
                                e = c.Lk();
                                if (qke(this.e, e)) (!e.Si() || !cge(this, e, c.md()) && !PHd(i, c)) && WGd(i, c);
                                else {
                                    j = pke(this.e.Dh(), e);
                                    b = RD(this.g, 124);
                                    f = true;
                                    for(g = 0; g < this.i; ++g){
                                        h = b[g];
                                        if (j.am(h.Lk())) {
                                            RD(eHd(this, g, c), 76);
                                            f = false;
                                            break;
                                        }
                                    }
                                    f && WGd(i, c);
                                }
                            }
                            return YGd(this, i);
                        };
                        _.Fi = function $ge(a) {
                            this.j = -1;
                            return nLd(this, this.i, a);
                        };
                        _.Pl = function ahe(a, b, c) {
                            return Xfe(this, a, b, c);
                        };
                        _.Xk = function bhe(a, b) {
                            return _fe(this, a, b);
                        };
                        _.Ql = function che(a, b, c) {
                            return age(this, a, b, c);
                        };
                        _.Rl = function dhe() {
                            return this;
                        };
                        _.Sl = function ehe(a, b) {
                            return ige(this, a, b);
                        };
                        _.Tl = function fhe(a) {
                            return RD(QHd(this, a), 76).Lk();
                        };
                        _.Ul = function ghe(a) {
                            return RD(QHd(this, a), 76).md();
                        };
                        _.Vl = function hhe() {
                            return this.b;
                        };
                        _.Mj = function ihe() {
                            return true;
                        };
                        _.Tj = function jhe() {
                            return true;
                        };
                        _.Wl = function mhe(a) {
                            return !pge(this, a);
                        };
                        _.aj = function ohe(a) {
                            return $C(Ibb, PKe, 343, a, 0, 1);
                        };
                        _.pl = function qhe(a) {
                            return Age(this, a);
                        };
                        _.Wb = function she(a) {
                            Dge(this, a);
                        };
                        _.Xl = function the(a, b) {
                            Fge(this, a, b);
                        };
                        _.Yl = function uhe(a) {
                            return Gge(this, a);
                        };
                        _.Zl = function yhe(a) {
                            Sge(this, a);
                        };
                        var Oab = sfb(ZJe, 'BasicFeatureMap', 78);
                        feb(1960, 1, Jve);
                        _.Nb = function Fhe(a) {
                            Ztb(this, a);
                        };
                        _.Rb = function Ehe(b) {
                            if (this.g == -1) throw Adb(new cgb);
                            Ahe(this);
                            try {
                                Pfe(this.e, this.b, this.a, b);
                                this.d = this.e.j;
                                Dhe(this);
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) throw Adb(new Jrb);
                                else throw Adb(a);
                            }
                        };
                        _.Ob = function Ghe() {
                            return Bhe(this);
                        };
                        _.Sb = function Hhe() {
                            return Che(this);
                        };
                        _.Pb = function Ihe() {
                            return Dhe(this);
                        };
                        _.Tb = function Jhe() {
                            return this.a;
                        };
                        _.Ub = function Khe() {
                            var a;
                            if (Che(this)) {
                                Ahe(this);
                                this.g = --this.a;
                                if (this.ul()) {
                                    a = Bge(this.e, this.b, this.c, this.a, this.j);
                                    this.j = a;
                                }
                                this.i = 0;
                                return this.j;
                            } else throw Adb(new Dvb);
                        };
                        _.Vb = function Lhe() {
                            return this.a - 1;
                        };
                        _.Qb = function Mhe() {
                            if (this.g == -1) throw Adb(new cgb);
                            Ahe(this);
                            try {
                                xge(this.e, this.b, this.g);
                                this.d = this.e.j;
                                if (this.g < this.a) {
                                    --this.a;
                                    --this.c;
                                }
                                --this.g;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) throw Adb(new Jrb);
                                else throw Adb(a);
                            }
                        };
                        _.ul = function Nhe() {
                            return false;
                        };
                        _.Wb = function Ohe(b) {
                            if (this.g == -1) throw Adb(new cgb);
                            Ahe(this);
                            try {
                                Ege(this.e, this.b, this.g, b);
                                this.d = this.e.j;
                            } catch (a) {
                                a = zdb(a);
                                if (ZD(a, 77)) throw Adb(new Jrb);
                                else throw Adb(a);
                            }
                        };
                        _.a = 0;
                        _.c = 0;
                        _.d = 0;
                        _.f = false;
                        _.g = 0;
                        _.i = 0;
                        var Lbb = sfb(ZJe, 'FeatureMapUtil/BasicFeatureEIterator', 1960);
                        feb(420, 1960, Jve, Phe);
                        _.$l = function Qhe() {
                            var a, b, c;
                            c = this.e.i;
                            a = RD(this.e.g, 124);
                            while(this.c < c){
                                b = a[this.c];
                                if (this.k.am(b.Lk())) {
                                    this.j = this.f ? b : b.md();
                                    this.i = 2;
                                    return true;
                                }
                                ++this.c;
                            }
                            this.i = 1;
                            this.g = -1;
                            return false;
                        };
                        _._l = function Rhe() {
                            var a, b;
                            a = RD(this.e.g, 124);
                            while(--this.c >= 0){
                                b = a[this.c];
                                if (this.k.am(b.Lk())) {
                                    this.j = this.f ? b : b.md();
                                    this.i = -2;
                                    return true;
                                }
                            }
                            this.i = -1;
                            this.g = -1;
                            return false;
                        };
                        var Mab = sfb(ZJe, 'BasicFeatureMap/FeatureEIterator', 420);
                        feb(676, 420, Jve, She);
                        _.ul = function The() {
                            return true;
                        };
                        var Nab = sfb(ZJe, 'BasicFeatureMap/ResolvingFeatureEIterator', 676);
                        feb(968, 496, uKe, Uhe);
                        _.pj = function Vhe() {
                            return this;
                        };
                        var Rab = sfb(ZJe, 'EContentsEList/1', 968);
                        feb(969, 496, uKe, Whe);
                        _.ul = function Xhe() {
                            return false;
                        };
                        var Sab = sfb(ZJe, 'EContentsEList/2', 969);
                        feb(967, 287, vKe, Yhe);
                        _.wl = function Zhe(a) {};
                        _.Ob = function $he() {
                            return false;
                        };
                        _.Sb = function _he() {
                            return false;
                        };
                        var Tab = sfb(ZJe, 'EContentsEList/FeatureIteratorImpl/1', 967);
                        feb(840, 593, oKe, aie);
                        _.Ni = function bie() {
                            this.a = true;
                        };
                        _.Qj = function cie() {
                            return this.a;
                        };
                        _.Gk = function die() {
                            var a;
                            sLd(this);
                            if (Mvd(this.e)) {
                                a = this.a;
                                this.a = false;
                                qvd(this.e, new Q3d(this.e, 2, this.c, a, false));
                            } else this.a = false;
                        };
                        _.a = false;
                        var Xab = sfb(ZJe, 'EDataTypeEList/Unsettable', 840);
                        feb(1958, 593, oKe, eie);
                        _.Si = function fie() {
                            return true;
                        };
                        var $ab = sfb(ZJe, 'EDataTypeUniqueEList', 1958);
                        feb(1959, 840, oKe, gie);
                        _.Si = function hie() {
                            return true;
                        };
                        var Zab = sfb(ZJe, 'EDataTypeUniqueEList/Unsettable', 1959);
                        feb(147, 83, oKe, iie);
                        _.nl = function jie() {
                            return true;
                        };
                        _.Wi = function kie(a, b) {
                            return gZd(this, a, RD(b, 58));
                        };
                        var _ab = sfb(ZJe, 'EObjectContainmentEList/Resolving', 147);
                        feb(1184, 555, oKe, lie);
                        _.nl = function mie() {
                            return true;
                        };
                        _.Wi = function nie(a, b) {
                            return gZd(this, a, RD(b, 58));
                        };
                        var abb = sfb(ZJe, 'EObjectContainmentEList/Unsettable/Resolving', 1184);
                        feb(766, 14, oKe, oie);
                        _.Ni = function pie() {
                            this.a = true;
                        };
                        _.Qj = function qie() {
                            return this.a;
                        };
                        _.Gk = function rie() {
                            var a;
                            sLd(this);
                            if (Mvd(this.e)) {
                                a = this.a;
                                this.a = false;
                                qvd(this.e, new Q3d(this.e, 2, this.c, a, false));
                            } else this.a = false;
                        };
                        _.a = false;
                        var fbb = sfb(ZJe, 'EObjectContainmentWithInverseEList/Unsettable', 766);
                        feb(1222, 766, oKe, sie);
                        _.nl = function tie() {
                            return true;
                        };
                        _.Wi = function uie(a, b) {
                            return gZd(this, a, RD(b, 58));
                        };
                        var ebb = sfb(ZJe, 'EObjectContainmentWithInverseEList/Unsettable/Resolving', 1222);
                        feb(757, 505, oKe, vie);
                        _.Ni = function wie() {
                            this.a = true;
                        };
                        _.Qj = function xie() {
                            return this.a;
                        };
                        _.Gk = function yie() {
                            var a;
                            sLd(this);
                            if (Mvd(this.e)) {
                                a = this.a;
                                this.a = false;
                                qvd(this.e, new Q3d(this.e, 2, this.c, a, false));
                            } else this.a = false;
                        };
                        _.a = false;
                        var hbb = sfb(ZJe, 'EObjectEList/Unsettable', 757);
                        feb(338, 505, oKe, zie);
                        _.nl = function Aie() {
                            return true;
                        };
                        _.Wi = function Bie(a, b) {
                            return gZd(this, a, RD(b, 58));
                        };
                        var kbb = sfb(ZJe, 'EObjectResolvingEList', 338);
                        feb(1844, 757, oKe, Cie);
                        _.nl = function Die() {
                            return true;
                        };
                        _.Wi = function Eie(a, b) {
                            return gZd(this, a, RD(b, 58));
                        };
                        var jbb = sfb(ZJe, 'EObjectResolvingEList/Unsettable', 1844);
                        feb(1527, 1, {}, Hie);
                        var Fie;
                        var lbb = sfb(ZJe, 'EObjectValidator', 1527);
                        feb(559, 505, oKe, Iie);
                        _.il = function Jie() {
                            return this.d;
                        };
                        _.jl = function Kie() {
                            return this.b;
                        };
                        _.Mj = function Lie() {
                            return true;
                        };
                        _.ml = function Mie() {
                            return true;
                        };
                        _.b = 0;
                        var pbb = sfb(ZJe, 'EObjectWithInverseEList', 559);
                        feb(1225, 559, oKe, Nie);
                        _.ll = function Oie() {
                            return true;
                        };
                        var mbb = sfb(ZJe, 'EObjectWithInverseEList/ManyInverse', 1225);
                        feb(635, 559, oKe, Pie);
                        _.Ni = function Qie() {
                            this.a = true;
                        };
                        _.Qj = function Rie() {
                            return this.a;
                        };
                        _.Gk = function Sie() {
                            var a;
                            sLd(this);
                            if (Mvd(this.e)) {
                                a = this.a;
                                this.a = false;
                                qvd(this.e, new Q3d(this.e, 2, this.c, a, false));
                            } else this.a = false;
                        };
                        _.a = false;
                        var obb = sfb(ZJe, 'EObjectWithInverseEList/Unsettable', 635);
                        feb(1224, 635, oKe, Tie);
                        _.ll = function Uie() {
                            return true;
                        };
                        var nbb = sfb(ZJe, 'EObjectWithInverseEList/Unsettable/ManyInverse', 1224);
                        feb(767, 559, oKe, Vie);
                        _.nl = function Wie() {
                            return true;
                        };
                        _.Wi = function Xie(a, b) {
                            return gZd(this, a, RD(b, 58));
                        };
                        var tbb = sfb(ZJe, 'EObjectWithInverseResolvingEList', 767);
                        feb(32, 767, oKe, Yie);
                        _.ll = function Zie() {
                            return true;
                        };
                        var qbb = sfb(ZJe, 'EObjectWithInverseResolvingEList/ManyInverse', 32);
                        feb(768, 635, oKe, $ie);
                        _.nl = function _ie() {
                            return true;
                        };
                        _.Wi = function aje(a, b) {
                            return gZd(this, a, RD(b, 58));
                        };
                        var sbb = sfb(ZJe, 'EObjectWithInverseResolvingEList/Unsettable', 768);
                        feb(1223, 768, oKe, bje);
                        _.ll = function cje() {
                            return true;
                        };
                        var rbb = sfb(ZJe, 'EObjectWithInverseResolvingEList/Unsettable/ManyInverse', 1223);
                        feb(1185, 632, oKe);
                        _.Li = function dje() {
                            return (this.b & 1792) == 0;
                        };
                        _.Ni = function eje() {
                            this.b |= 1;
                        };
                        _.kl = function fje() {
                            return (this.b & 4) != 0;
                        };
                        _.Mj = function gje() {
                            return (this.b & 40) != 0;
                        };
                        _.ll = function hje() {
                            return (this.b & 16) != 0;
                        };
                        _.ml = function ije() {
                            return (this.b & 8) != 0;
                        };
                        _.nl = function jje() {
                            return (this.b & cKe) != 0;
                        };
                        _.al = function kje() {
                            return (this.b & 32) != 0;
                        };
                        _.ol = function lje() {
                            return (this.b & gwe) != 0;
                        };
                        _.fk = function mje(a) {
                            return !this.d ? this.Lk().Hk().fk(a) : QRd(this.d, a);
                        };
                        _.Qj = function nje() {
                            return (this.b & 2) != 0 ? (this.b & 1) != 0 : this.i != 0;
                        };
                        _.Si = function oje() {
                            return (this.b & 128) != 0;
                        };
                        _.Gk = function qje() {
                            var a;
                            sLd(this);
                            if ((this.b & 2) != 0) {
                                if (Mvd(this.e)) {
                                    a = (this.b & 1) != 0;
                                    this.b &= -2;
                                    eZd(this, new Q3d(this.e, 2, BYd(this.e.Dh(), this.Lk()), a, false));
                                } else this.b &= -2;
                            }
                        };
                        _.Yi = function rje() {
                            return (this.b & 1536) == 0;
                        };
                        _.b = 0;
                        var vbb = sfb(ZJe, 'EcoreEList/Generic', 1185);
                        feb(1186, 1185, oKe, sje);
                        _.Lk = function tje() {
                            return this.a;
                        };
                        var ubb = sfb(ZJe, 'EcoreEList/Dynamic', 1186);
                        feb(765, 66, PIe, uje);
                        _.aj = function vje(a) {
                            return IMd(this.a.a, a);
                        };
                        var zbb = sfb(ZJe, 'EcoreEMap/1', 765);
                        feb(764, 83, oKe, wje);
                        _.Mi = function xje(a, b) {
                            UNd(this.b, RD(b, 136));
                        };
                        _.Oi = function yje(a, b) {
                            TNd(this.b);
                        };
                        _.Pi = function zje(a, b, c) {
                            var d;
                            ++(d = this.b, RD(b, 136), d).e;
                        };
                        _.Qi = function Aje(a, b) {
                            VNd(this.b, RD(b, 136));
                        };
                        _.Ri = function Bje(a, b, c) {
                            VNd(this.b, RD(c, 136));
                            dE(c) === dE(b) && RD(c, 136).Ci(aOd(RD(b, 136).ld()));
                            UNd(this.b, RD(b, 136));
                        };
                        var Abb = sfb(ZJe, 'EcoreEMap/DelegateEObjectContainmentEList', 764);
                        feb(1220, 141, _Je, Cje);
                        var Cbb = sfb(ZJe, 'EcoreEMap/Unsettable', 1220);
                        feb(1221, 764, oKe, Dje);
                        _.Ni = function Eje() {
                            this.a = true;
                        };
                        _.Qj = function Fje() {
                            return this.a;
                        };
                        _.Gk = function Gje() {
                            var a;
                            sLd(this);
                            if (Mvd(this.e)) {
                                a = this.a;
                                this.a = false;
                                qvd(this.e, new Q3d(this.e, 2, this.c, a, false));
                            } else this.a = false;
                        };
                        _.a = false;
                        var Bbb = sfb(ZJe, 'EcoreEMap/Unsettable/UnsettableDelegateEObjectContainmentEList', 1221);
                        feb(1189, 215, Hxe, Zje);
                        _.a = false;
                        _.b = false;
                        var Fbb = sfb(ZJe, 'EcoreUtil/Copier', 1189);
                        feb(759, 1, Ave, _je);
                        _.Nb = function ake(a) {
                            Ztb(this, a);
                        };
                        _.Ob = function bke() {
                            return $je(this);
                        };
                        _.Pb = function cke() {
                            var a;
                            $je(this);
                            a = this.b;
                            this.b = null;
                            return a;
                        };
                        _.Qb = function dke() {
                            this.a.Qb();
                        };
                        var Gbb = sfb(ZJe, 'EcoreUtil/ProperContentIterator', 759);
                        feb(1528, 1527, {}, gke);
                        var eke;
                        var Hbb = sfb(ZJe, 'EcoreValidator', 1528);
                        var mke;
                        var Sbb = ufb(ZJe, 'FeatureMapUtil/Validator');
                        feb(1295, 1, {
                            2041: 1
                        }, rke);
                        _.am = function ske(a) {
                            return true;
                        };
                        var Kbb = sfb(ZJe, 'FeatureMapUtil/1', 1295);
                        feb(773, 1, {
                            2041: 1
                        }, wke);
                        _.am = function xke(a) {
                            var b;
                            if (this.c == a) return true;
                            b = TD(Wjb(this.a, a));
                            if (b == null) {
                                if (vke(this, a)) {
                                    yke(this.a, a, (Geb(), Feb));
                                    return true;
                                } else {
                                    yke(this.a, a, (Geb(), Eeb));
                                    return false;
                                }
                            } else return b == (Geb(), Feb);
                        };
                        _.e = false;
                        var tke;
                        var Nbb = sfb(ZJe, 'FeatureMapUtil/BasicValidator', 773);
                        feb(774, 45, Hxe, zke);
                        var Mbb = sfb(ZJe, 'FeatureMapUtil/BasicValidator/Cache', 774);
                        feb(509, 56, {
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            61: 1,
                            79: 1,
                            71: 1,
                            97: 1
                        }, Eke);
                        _.bd = function Fke(a, b) {
                            Pfe(this.c, this.b, a, b);
                        };
                        _.Fc = function Gke(a) {
                            return Qfe(this.c, this.b, a);
                        };
                        _.cd = function Hke(a, b) {
                            return Sfe(this.c, this.b, a, b);
                        };
                        _.Gc = function Ike(a) {
                            return Ake(this, a);
                        };
                        _.Gi = function Jke(a, b) {
                            Ufe(this.c, this.b, a, b);
                        };
                        _.Wk = function Kke(a, b) {
                            return Xfe(this.c, this.b, a, b);
                        };
                        _.$i = function Lke(a) {
                            return hge(this.c, this.b, a, false);
                        };
                        _.Ii = function Mke() {
                            return Yfe(this.c, this.b);
                        };
                        _.Ji = function Nke() {
                            return Zfe(this.c, this.b);
                        };
                        _.Ki = function Oke(a) {
                            return $fe(this.c, this.b, a);
                        };
                        _.Xk = function Pke(a, b) {
                            return Bke(this, a, b);
                        };
                        _.$b = function Qke() {
                            Cke(this);
                        };
                        _.Hc = function Rke(a) {
                            return cge(this.c, this.b, a);
                        };
                        _.Ic = function Ske(a) {
                            return ege(this.c, this.b, a);
                        };
                        _.Xb = function Tke(a) {
                            return hge(this.c, this.b, a, true);
                        };
                        _.Fk = function Uke(a) {
                            return this;
                        };
                        _.dd = function Vke(a) {
                            return jge(this.c, this.b, a);
                        };
                        _.dc = function Wke() {
                            return Dke(this);
                        };
                        _.Qj = function Xke() {
                            return !pge(this.c, this.b);
                        };
                        _.Kc = function Yke() {
                            return qge(this.c, this.b);
                        };
                        _.ed = function Zke() {
                            return sge(this.c, this.b);
                        };
                        _.fd = function $ke(a) {
                            return tge(this.c, this.b, a);
                        };
                        _.Ti = function _ke(a, b) {
                            return vge(this.c, this.b, a, b);
                        };
                        _.Ui = function ale(a, b) {
                            wge(this.c, this.b, a, b);
                        };
                        _.gd = function ble(a) {
                            return xge(this.c, this.b, a);
                        };
                        _.Mc = function cle(a) {
                            return yge(this.c, this.b, a);
                        };
                        _.hd = function dle(a, b) {
                            return Ege(this.c, this.b, a, b);
                        };
                        _.Wb = function ele(a) {
                            bge(this.c, this.b);
                            Ake(this, RD(a, 15));
                        };
                        _.gc = function fle() {
                            return Nge(this.c, this.b);
                        };
                        _.Pc = function gle() {
                            return Oge(this.c, this.b);
                        };
                        _.Qc = function hle(a) {
                            return Qge(this.c, this.b, a);
                        };
                        _.Ib = function ile() {
                            var a, b;
                            b = new Qhb;
                            b.a += '[';
                            for(a = Yfe(this.c, this.b); Bhe(a);){
                                Nhb(b, Ghb(Dhe(a)));
                                Bhe(a) && (b.a += pve, b);
                            }
                            b.a += ']';
                            return b.a;
                        };
                        _.Gk = function jle() {
                            bge(this.c, this.b);
                        };
                        var Obb = sfb(ZJe, 'FeatureMapUtil/FeatureEList', 509);
                        feb(644, 39, GJe, lle);
                        _.hj = function mle(a) {
                            return kle(this, a);
                        };
                        _.mj = function nle(a) {
                            var b, c, d, e, f, g, h;
                            switch(this.d){
                                case 1:
                                case 2:
                                    f = a.jj();
                                    if (dE(f) === dE(this.c) && kle(this, null) == a.hj(null)) {
                                        this.g = a.ij();
                                        a.gj() == 1 && (this.d = 1);
                                        return true;
                                    }
                                    break;
                                case 3:
                                    e = a.gj();
                                    switch(e){
                                        case 3:
                                            f = a.jj();
                                            if (dE(f) === dE(this.c) && kle(this, null) == a.hj(null)) {
                                                this.d = 5;
                                                b = new ZHd(2);
                                                WGd(b, this.g);
                                                WGd(b, a.ij());
                                                this.g = b;
                                                return true;
                                            }
                                            break;
                                    }
                                    break;
                                case 5:
                                    e = a.gj();
                                    switch(e){
                                        case 3:
                                            f = a.jj();
                                            if (dE(f) === dE(this.c) && kle(this, null) == a.hj(null)) {
                                                c = RD(this.g, 16);
                                                c.Fc(a.ij());
                                                return true;
                                            }
                                            break;
                                    }
                                    break;
                                case 4:
                                    e = a.gj();
                                    switch(e){
                                        case 3:
                                            f = a.jj();
                                            if (dE(f) === dE(this.c) && kle(this, null) == a.hj(null)) {
                                                this.d = 1;
                                                this.g = a.ij();
                                                return true;
                                            }
                                            break;
                                        case 4:
                                            f = a.jj();
                                            if (dE(f) === dE(this.c) && kle(this, null) == a.hj(null)) {
                                                this.d = 6;
                                                h = new ZHd(2);
                                                WGd(h, this.n);
                                                WGd(h, a.kj());
                                                this.n = h;
                                                g = cD(WC(kE, 1), Pwe, 28, 15, [
                                                    this.o,
                                                    a.lj()
                                                ]);
                                                this.g = g;
                                                return true;
                                            }
                                            break;
                                    }
                                    break;
                                case 6:
                                    e = a.gj();
                                    switch(e){
                                        case 4:
                                            f = a.jj();
                                            if (dE(f) === dE(this.c) && kle(this, null) == a.hj(null)) {
                                                c = RD(this.n, 16);
                                                c.Fc(a.kj());
                                                g = RD(this.g, 53);
                                                d = $C(kE, Pwe, 28, g.length + 1, 15, 1);
                                                hib(g, 0, d, 0, g.length);
                                                d[g.length] = a.lj();
                                                this.g = d;
                                                return true;
                                            }
                                            break;
                                    }
                                    break;
                            }
                            return false;
                        };
                        var Pbb = sfb(ZJe, 'FeatureMapUtil/FeatureENotificationImpl', 644);
                        feb(564, 509, {
                            20: 1,
                            31: 1,
                            56: 1,
                            16: 1,
                            15: 1,
                            61: 1,
                            79: 1,
                            160: 1,
                            220: 1,
                            2036: 1,
                            71: 1,
                            97: 1
                        }, ole);
                        _.Ol = function ple(a, b) {
                            return Qfe(this.c, a, b);
                        };
                        _.Pl = function qle(a, b, c) {
                            return Xfe(this.c, a, b, c);
                        };
                        _.Ql = function rle(a, b, c) {
                            return age(this.c, a, b, c);
                        };
                        _.Rl = function sle() {
                            return this;
                        };
                        _.Sl = function tle(a, b) {
                            return ige(this.c, a, b);
                        };
                        _.Tl = function ule(a) {
                            return RD(hge(this.c, this.b, a, false), 76).Lk();
                        };
                        _.Ul = function vle(a) {
                            return RD(hge(this.c, this.b, a, false), 76).md();
                        };
                        _.Vl = function wle() {
                            return this.a;
                        };
                        _.Wl = function xle(a) {
                            return !pge(this.c, a);
                        };
                        _.Xl = function yle(a, b) {
                            Fge(this.c, a, b);
                        };
                        _.Yl = function zle(a) {
                            return Gge(this.c, a);
                        };
                        _.Zl = function Ale(a) {
                            Sge(this.c, a);
                        };
                        var Qbb = sfb(ZJe, 'FeatureMapUtil/FeatureFeatureMap', 564);
                        feb(1294, 1, $Je, Ble);
                        _.Fk = function Cle(a) {
                            return hge(this.b, this.a, -1, a);
                        };
                        _.Qj = function Dle() {
                            return !pge(this.b, this.a);
                        };
                        _.Wb = function Ele(a) {
                            Fge(this.b, this.a, a);
                        };
                        _.Gk = function Fle() {
                            bge(this.b, this.a);
                        };
                        var Rbb = sfb(ZJe, 'FeatureMapUtil/FeatureValue', 1294);
                        var Gle, Hle, Ile, Jle, Kle;
                        var Vbb = ufb(hLe, 'AnyType');
                        feb(680, 63, swe, Mle);
                        var Wbb = sfb(hLe, 'InvalidDatatypeValueException', 680);
                        var Xbb = ufb(hLe, iLe);
                        var Ybb = ufb(hLe, jLe);
                        var Zbb = ufb(hLe, kLe);
                        var Nle;
                        var Ple;
                        var Rle, Sle, Tle, Ule, Vle, Wle, Xle, Yle, Zle, $le, _le, ame, bme, cme, dme, eme, fme, gme, hme, ime, jme, kme, lme, mme;
                        feb(844, 516, {
                            110: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            54: 1,
                            99: 1,
                            857: 1
                        }, ome);
                        _.Lh = function pme(a, b, c) {
                            switch(a){
                                case 0:
                                    if (c) return !this.c && (this.c = new Uge(this, 0)), this.c;
                                    return !this.c && (this.c = new Uge(this, 0)), this.c.b;
                                case 1:
                                    if (c) return !this.c && (this.c = new Uge(this, 0)), RD(rge(this.c, (nme(), Sle)), 160);
                                    return (!this.c && (this.c = new Uge(this, 0)), RD(RD(rge(this.c, (nme(), Sle)), 160), 220)).Vl();
                                case 2:
                                    if (c) return !this.b && (this.b = new Uge(this, 2)), this.b;
                                    return !this.b && (this.b = new Uge(this, 2)), this.b.b;
                            }
                            return zvd(this, a - AYd(this.ii()), vYd((this.j & 2) == 0 ? this.ii() : (!this.k && (this.k = new fUd), this.k).Nk(), a), b, c);
                        };
                        _.Uh = function qme(a, b, c) {
                            var d;
                            switch(b){
                                case 0:
                                    return !this.c && (this.c = new Uge(this, 0)), _fe(this.c, a, c);
                                case 1:
                                    return (!this.c && (this.c = new Uge(this, 0)), RD(RD(rge(this.c, (nme(), Sle)), 160), 71)).Xk(a, c);
                                case 2:
                                    return !this.b && (this.b = new Uge(this, 2)), _fe(this.b, a, c);
                            }
                            return d = RD(vYd((this.j & 2) == 0 ? this.ii() : (!this.k && (this.k = new fUd), this.k).Nk(), b), 69), d.wk().Ak(this, Yvd(this), b - AYd(this.ii()), a, c);
                        };
                        _.Wh = function rme(a) {
                            switch(a){
                                case 0:
                                    return !!this.c && this.c.i != 0;
                                case 1:
                                    return !(!this.c && (this.c = new Uge(this, 0)), RD(rge(this.c, (nme(), Sle)), 160)).dc();
                                case 2:
                                    return !!this.b && this.b.i != 0;
                            }
                            return Avd(this, a - AYd(this.ii()), vYd((this.j & 2) == 0 ? this.ii() : (!this.k && (this.k = new fUd), this.k).Nk(), a));
                        };
                        _.bi = function sme(a, b) {
                            switch(a){
                                case 0:
                                    !this.c && (this.c = new Uge(this, 0));
                                    Dge(this.c, b);
                                    return;
                                case 1:
                                    (!this.c && (this.c = new Uge(this, 0)), RD(RD(rge(this.c, (nme(), Sle)), 160), 220)).Wb(b);
                                    return;
                                case 2:
                                    !this.b && (this.b = new Uge(this, 2));
                                    Dge(this.b, b);
                                    return;
                            }
                            Bvd(this, a - AYd(this.ii()), vYd((this.j & 2) == 0 ? this.ii() : (!this.k && (this.k = new fUd), this.k).Nk(), a), b);
                        };
                        _.ii = function tme() {
                            return nme(), Rle;
                        };
                        _.ki = function ume(a) {
                            switch(a){
                                case 0:
                                    !this.c && (this.c = new Uge(this, 0));
                                    sLd(this.c);
                                    return;
                                case 1:
                                    (!this.c && (this.c = new Uge(this, 0)), RD(rge(this.c, (nme(), Sle)), 160)).$b();
                                    return;
                                case 2:
                                    !this.b && (this.b = new Uge(this, 2));
                                    sLd(this.b);
                                    return;
                            }
                            Cvd(this, a - AYd(this.ii()), vYd((this.j & 2) == 0 ? this.ii() : (!this.k && (this.k = new fUd), this.k).Nk(), a));
                        };
                        _.Ib = function vme() {
                            var a;
                            if ((this.j & 4) != 0) return awd(this);
                            a = new Shb(awd(this));
                            a.a += ' (mixed: ';
                            Mhb(a, this.c);
                            a.a += ', anyAttribute: ';
                            Mhb(a, this.b);
                            a.a += ')';
                            return a.a;
                        };
                        var $bb = sfb(lLe, 'AnyTypeImpl', 844);
                        feb(681, 516, {
                            110: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            54: 1,
                            99: 1,
                            2119: 1,
                            681: 1
                        }, yme);
                        _.Lh = function zme(a, b, c) {
                            switch(a){
                                case 0:
                                    return this.a;
                                case 1:
                                    return this.b;
                            }
                            return zvd(this, a - AYd((nme(), cme)), vYd((this.j & 2) == 0 ? cme : (!this.k && (this.k = new fUd), this.k).Nk(), a), b, c);
                        };
                        _.Wh = function Ame(a) {
                            switch(a){
                                case 0:
                                    return this.a != null;
                                case 1:
                                    return this.b != null;
                            }
                            return Avd(this, a - AYd((nme(), cme)), vYd((this.j & 2) == 0 ? cme : (!this.k && (this.k = new fUd), this.k).Nk(), a));
                        };
                        _.bi = function Bme(a, b) {
                            switch(a){
                                case 0:
                                    wme(this, WD(b));
                                    return;
                                case 1:
                                    xme(this, WD(b));
                                    return;
                            }
                            Bvd(this, a - AYd((nme(), cme)), vYd((this.j & 2) == 0 ? cme : (!this.k && (this.k = new fUd), this.k).Nk(), a), b);
                        };
                        _.ii = function Cme() {
                            return nme(), cme;
                        };
                        _.ki = function Dme(a) {
                            switch(a){
                                case 0:
                                    this.a = null;
                                    return;
                                case 1:
                                    this.b = null;
                                    return;
                            }
                            Cvd(this, a - AYd((nme(), cme)), vYd((this.j & 2) == 0 ? cme : (!this.k && (this.k = new fUd), this.k).Nk(), a));
                        };
                        _.Ib = function Eme() {
                            var a;
                            if ((this.j & 4) != 0) return awd(this);
                            a = new Shb(awd(this));
                            a.a += ' (data: ';
                            Nhb(a, this.a);
                            a.a += ', target: ';
                            Nhb(a, this.b);
                            a.a += ')';
                            return a.a;
                        };
                        _.a = null;
                        _.b = null;
                        var _bb = sfb(lLe, 'ProcessingInstructionImpl', 681);
                        feb(682, 844, {
                            110: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            54: 1,
                            99: 1,
                            857: 1,
                            2120: 1,
                            682: 1
                        }, Hme);
                        _.Lh = function Ime(a, b, c) {
                            switch(a){
                                case 0:
                                    if (c) return !this.c && (this.c = new Uge(this, 0)), this.c;
                                    return !this.c && (this.c = new Uge(this, 0)), this.c.b;
                                case 1:
                                    if (c) return !this.c && (this.c = new Uge(this, 0)), RD(rge(this.c, (nme(), Sle)), 160);
                                    return (!this.c && (this.c = new Uge(this, 0)), RD(RD(rge(this.c, (nme(), Sle)), 160), 220)).Vl();
                                case 2:
                                    if (c) return !this.b && (this.b = new Uge(this, 2)), this.b;
                                    return !this.b && (this.b = new Uge(this, 2)), this.b.b;
                                case 3:
                                    return !this.c && (this.c = new Uge(this, 0)), WD(ige(this.c, (nme(), fme), true));
                                case 4:
                                    return Ije(this.a, (!this.c && (this.c = new Uge(this, 0)), WD(ige(this.c, (nme(), fme), true))));
                                case 5:
                                    return this.a;
                            }
                            return zvd(this, a - AYd((nme(), eme)), vYd((this.j & 2) == 0 ? eme : (!this.k && (this.k = new fUd), this.k).Nk(), a), b, c);
                        };
                        _.Wh = function Jme(a) {
                            switch(a){
                                case 0:
                                    return !!this.c && this.c.i != 0;
                                case 1:
                                    return !(!this.c && (this.c = new Uge(this, 0)), RD(rge(this.c, (nme(), Sle)), 160)).dc();
                                case 2:
                                    return !!this.b && this.b.i != 0;
                                case 3:
                                    return !this.c && (this.c = new Uge(this, 0)), WD(ige(this.c, (nme(), fme), true)) != null;
                                case 4:
                                    return Ije(this.a, (!this.c && (this.c = new Uge(this, 0)), WD(ige(this.c, (nme(), fme), true)))) != null;
                                case 5:
                                    return !!this.a;
                            }
                            return Avd(this, a - AYd((nme(), eme)), vYd((this.j & 2) == 0 ? eme : (!this.k && (this.k = new fUd), this.k).Nk(), a));
                        };
                        _.bi = function Kme(a, b) {
                            switch(a){
                                case 0:
                                    !this.c && (this.c = new Uge(this, 0));
                                    Dge(this.c, b);
                                    return;
                                case 1:
                                    (!this.c && (this.c = new Uge(this, 0)), RD(RD(rge(this.c, (nme(), Sle)), 160), 220)).Wb(b);
                                    return;
                                case 2:
                                    !this.b && (this.b = new Uge(this, 2));
                                    Dge(this.b, b);
                                    return;
                                case 3:
                                    Gme(this, WD(b));
                                    return;
                                case 4:
                                    Gme(this, Hje(this.a, b));
                                    return;
                                case 5:
                                    Fme(this, RD(b, 156));
                                    return;
                            }
                            Bvd(this, a - AYd((nme(), eme)), vYd((this.j & 2) == 0 ? eme : (!this.k && (this.k = new fUd), this.k).Nk(), a), b);
                        };
                        _.ii = function Lme() {
                            return nme(), eme;
                        };
                        _.ki = function Mme(a) {
                            switch(a){
                                case 0:
                                    !this.c && (this.c = new Uge(this, 0));
                                    sLd(this.c);
                                    return;
                                case 1:
                                    (!this.c && (this.c = new Uge(this, 0)), RD(rge(this.c, (nme(), Sle)), 160)).$b();
                                    return;
                                case 2:
                                    !this.b && (this.b = new Uge(this, 2));
                                    sLd(this.b);
                                    return;
                                case 3:
                                    !this.c && (this.c = new Uge(this, 0));
                                    Fge(this.c, (nme(), fme), null);
                                    return;
                                case 4:
                                    Gme(this, Hje(this.a, null));
                                    return;
                                case 5:
                                    this.a = null;
                                    return;
                            }
                            Cvd(this, a - AYd((nme(), eme)), vYd((this.j & 2) == 0 ? eme : (!this.k && (this.k = new fUd), this.k).Nk(), a));
                        };
                        var acb = sfb(lLe, 'SimpleAnyTypeImpl', 682);
                        feb(683, 516, {
                            110: 1,
                            94: 1,
                            93: 1,
                            58: 1,
                            54: 1,
                            99: 1,
                            2121: 1,
                            683: 1
                        }, Nme);
                        _.Lh = function Ome(a, b, c) {
                            switch(a){
                                case 0:
                                    if (c) return !this.a && (this.a = new Uge(this, 0)), this.a;
                                    return !this.a && (this.a = new Uge(this, 0)), this.a.b;
                                case 1:
                                    return c ? (!this.b && (this.b = new DVd((JTd(), FTd), C8, this, 1)), this.b) : (!this.b && (this.b = new DVd((JTd(), FTd), C8, this, 1)), dOd(this.b));
                                case 2:
                                    return c ? (!this.c && (this.c = new DVd((JTd(), FTd), C8, this, 2)), this.c) : (!this.c && (this.c = new DVd((JTd(), FTd), C8, this, 2)), dOd(this.c));
                                case 3:
                                    return !this.a && (this.a = new Uge(this, 0)), rge(this.a, (nme(), ime));
                                case 4:
                                    return !this.a && (this.a = new Uge(this, 0)), rge(this.a, (nme(), jme));
                                case 5:
                                    return !this.a && (this.a = new Uge(this, 0)), rge(this.a, (nme(), lme));
                                case 6:
                                    return !this.a && (this.a = new Uge(this, 0)), rge(this.a, (nme(), mme));
                            }
                            return zvd(this, a - AYd((nme(), hme)), vYd((this.j & 2) == 0 ? hme : (!this.k && (this.k = new fUd), this.k).Nk(), a), b, c);
                        };
                        _.Uh = function Pme(a, b, c) {
                            var d;
                            switch(b){
                                case 0:
                                    return !this.a && (this.a = new Uge(this, 0)), _fe(this.a, a, c);
                                case 1:
                                    return !this.b && (this.b = new DVd((JTd(), FTd), C8, this, 1)), BVd(this.b, a, c);
                                case 2:
                                    return !this.c && (this.c = new DVd((JTd(), FTd), C8, this, 2)), BVd(this.c, a, c);
                                case 5:
                                    return !this.a && (this.a = new Uge(this, 0)), Bke(rge(this.a, (nme(), lme)), a, c);
                            }
                            return d = RD(vYd((this.j & 2) == 0 ? (nme(), hme) : (!this.k && (this.k = new fUd), this.k).Nk(), b), 69), d.wk().Ak(this, Yvd(this), b - AYd((nme(), hme)), a, c);
                        };
                        _.Wh = function Qme(a) {
                            switch(a){
                                case 0:
                                    return !!this.a && this.a.i != 0;
                                case 1:
                                    return !!this.b && this.b.f != 0;
                                case 2:
                                    return !!this.c && this.c.f != 0;
                                case 3:
                                    return !this.a && (this.a = new Uge(this, 0)), !Dke(rge(this.a, (nme(), ime)));
                                case 4:
                                    return !this.a && (this.a = new Uge(this, 0)), !Dke(rge(this.a, (nme(), jme)));
                                case 5:
                                    return !this.a && (this.a = new Uge(this, 0)), !Dke(rge(this.a, (nme(), lme)));
                                case 6:
                                    return !this.a && (this.a = new Uge(this, 0)), !Dke(rge(this.a, (nme(), mme)));
                            }
                            return Avd(this, a - AYd((nme(), hme)), vYd((this.j & 2) == 0 ? hme : (!this.k && (this.k = new fUd), this.k).Nk(), a));
                        };
                        _.bi = function Rme(a, b) {
                            switch(a){
                                case 0:
                                    !this.a && (this.a = new Uge(this, 0));
                                    Dge(this.a, b);
                                    return;
                                case 1:
                                    !this.b && (this.b = new DVd((JTd(), FTd), C8, this, 1));
                                    CVd(this.b, b);
                                    return;
                                case 2:
                                    !this.c && (this.c = new DVd((JTd(), FTd), C8, this, 2));
                                    CVd(this.c, b);
                                    return;
                                case 3:
                                    !this.a && (this.a = new Uge(this, 0));
                                    Cke(rge(this.a, (nme(), ime)));
                                    !this.a && (this.a = new Uge(this, 0));
                                    Ake(rge(this.a, ime), RD(b, 16));
                                    return;
                                case 4:
                                    !this.a && (this.a = new Uge(this, 0));
                                    Cke(rge(this.a, (nme(), jme)));
                                    !this.a && (this.a = new Uge(this, 0));
                                    Ake(rge(this.a, jme), RD(b, 16));
                                    return;
                                case 5:
                                    !this.a && (this.a = new Uge(this, 0));
                                    Cke(rge(this.a, (nme(), lme)));
                                    !this.a && (this.a = new Uge(this, 0));
                                    Ake(rge(this.a, lme), RD(b, 16));
                                    return;
                                case 6:
                                    !this.a && (this.a = new Uge(this, 0));
                                    Cke(rge(this.a, (nme(), mme)));
                                    !this.a && (this.a = new Uge(this, 0));
                                    Ake(rge(this.a, mme), RD(b, 16));
                                    return;
                            }
                            Bvd(this, a - AYd((nme(), hme)), vYd((this.j & 2) == 0 ? hme : (!this.k && (this.k = new fUd), this.k).Nk(), a), b);
                        };
                        _.ii = function Sme() {
                            return nme(), hme;
                        };
                        _.ki = function Tme(a) {
                            switch(a){
                                case 0:
                                    !this.a && (this.a = new Uge(this, 0));
                                    sLd(this.a);
                                    return;
                                case 1:
                                    !this.b && (this.b = new DVd((JTd(), FTd), C8, this, 1));
                                    this.b.c.$b();
                                    return;
                                case 2:
                                    !this.c && (this.c = new DVd((JTd(), FTd), C8, this, 2));
                                    this.c.c.$b();
                                    return;
                                case 3:
                                    !this.a && (this.a = new Uge(this, 0));
                                    Cke(rge(this.a, (nme(), ime)));
                                    return;
                                case 4:
                                    !this.a && (this.a = new Uge(this, 0));
                                    Cke(rge(this.a, (nme(), jme)));
                                    return;
                                case 5:
                                    !this.a && (this.a = new Uge(this, 0));
                                    Cke(rge(this.a, (nme(), lme)));
                                    return;
                                case 6:
                                    !this.a && (this.a = new Uge(this, 0));
                                    Cke(rge(this.a, (nme(), mme)));
                                    return;
                            }
                            Cvd(this, a - AYd((nme(), hme)), vYd((this.j & 2) == 0 ? hme : (!this.k && (this.k = new fUd), this.k).Nk(), a));
                        };
                        _.Ib = function Ume() {
                            var a;
                            if ((this.j & 4) != 0) return awd(this);
                            a = new Shb(awd(this));
                            a.a += ' (mixed: ';
                            Mhb(a, this.a);
                            a.a += ')';
                            return a.a;
                        };
                        var bcb = sfb(lLe, 'XMLTypeDocumentRootImpl', 683);
                        feb(2028, 720, {
                            110: 1,
                            94: 1,
                            93: 1,
                            480: 1,
                            155: 1,
                            58: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            119: 1,
                            120: 1,
                            2122: 1
                        }, rne);
                        _.ri = function sne(a, b) {
                            switch(a.hk()){
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                case 16:
                                case 22:
                                case 23:
                                case 24:
                                case 25:
                                case 26:
                                case 32:
                                case 33:
                                case 34:
                                case 36:
                                case 37:
                                case 44:
                                case 45:
                                case 50:
                                case 51:
                                case 53:
                                case 55:
                                case 56:
                                case 57:
                                case 58:
                                case 60:
                                case 61:
                                case 4:
                                    return b == null ? null : jeb(b);
                                case 19:
                                case 28:
                                case 29:
                                case 35:
                                case 38:
                                case 39:
                                case 41:
                                case 46:
                                case 52:
                                case 54:
                                case 5:
                                    return WD(b);
                                case 6:
                                    return _me(RD(b, 195));
                                case 12:
                                case 47:
                                case 49:
                                case 11:
                                    return tAd(this, a, b);
                                case 13:
                                    return b == null ? null : yib(RD(b, 247));
                                case 15:
                                case 14:
                                    return b == null ? null : ane(Kfb(UD(b)));
                                case 17:
                                    return bne((nme(), b));
                                case 18:
                                    return bne(b);
                                case 21:
                                case 20:
                                    return b == null ? null : cne(RD(b, 161).a);
                                case 27:
                                    return dne(RD(b, 195));
                                case 30:
                                    return ene((nme(), RD(b, 15)));
                                case 31:
                                    return ene(RD(b, 15));
                                case 40:
                                    return hne((nme(), b));
                                case 42:
                                    return fne((nme(), b));
                                case 43:
                                    return fne(b);
                                case 59:
                                case 48:
                                    return gne((nme(), b));
                                default:
                                    throw Adb(new agb(VHe + a.xe() + WHe));
                            }
                        };
                        _.si = function tne(a) {
                            var b, c, d, e, f;
                            switch(a.G == -1 && (a.G = (c = BXd(a), c ? fZd(c.vi(), a) : -1)), a.G){
                                case 0:
                                    return b = new ome, b;
                                case 1:
                                    return d = new yme, d;
                                case 2:
                                    return e = new Hme, e;
                                case 3:
                                    return f = new Nme, f;
                                default:
                                    throw Adb(new agb(ZHe + a.zb + WHe));
                            }
                        };
                        _.ti = function une(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                            switch(a.hk()){
                                case 5:
                                case 52:
                                case 4:
                                    return b;
                                case 6:
                                    return ine(b);
                                case 8:
                                case 7:
                                    return b == null ? null : $me(b);
                                case 9:
                                    return b == null ? null : $eb(Oeb((d = nue(b, true), d.length > 0 && (BFb(0, d.length), d.charCodeAt(0) == 43) ? (BFb(1, d.length + 1), d.substr(1)) : d), -128, 127) << 24 >> 24);
                                case 10:
                                    return b == null ? null : $eb(Oeb((e = nue(b, true), e.length > 0 && (BFb(0, e.length), e.charCodeAt(0) == 43) ? (BFb(1, e.length + 1), e.substr(1)) : e), -128, 127) << 24 >> 24);
                                case 11:
                                    return WD(uAd(this, (nme(), Vle), b));
                                case 12:
                                    return WD(uAd(this, (nme(), Wle), b));
                                case 13:
                                    return b == null ? null : new Bib(nue(b, true));
                                case 15:
                                case 14:
                                    return jne(b);
                                case 16:
                                    return WD(uAd(this, (nme(), Xle), b));
                                case 17:
                                    return kne((nme(), b));
                                case 18:
                                    return kne(b);
                                case 28:
                                case 29:
                                case 35:
                                case 38:
                                case 39:
                                case 41:
                                case 54:
                                case 19:
                                    return nue(b, true);
                                case 21:
                                case 20:
                                    return lne(b);
                                case 22:
                                    return WD(uAd(this, (nme(), Yle), b));
                                case 23:
                                    return WD(uAd(this, (nme(), Zle), b));
                                case 24:
                                    return WD(uAd(this, (nme(), $le), b));
                                case 25:
                                    return WD(uAd(this, (nme(), _le), b));
                                case 26:
                                    return WD(uAd(this, (nme(), ame), b));
                                case 27:
                                    return mne(b);
                                case 30:
                                    return nne((nme(), b));
                                case 31:
                                    return nne(b);
                                case 32:
                                    return b == null ? null : sgb(Oeb((k = nue(b, true), k.length > 0 && (BFb(0, k.length), k.charCodeAt(0) == 43) ? (BFb(1, k.length + 1), k.substr(1)) : k), qwe, lve));
                                case 33:
                                    return b == null ? null : new ejb((l = nue(b, true), l.length > 0 && (BFb(0, l.length), l.charCodeAt(0) == 43) ? (BFb(1, l.length + 1), l.substr(1)) : l));
                                case 34:
                                    return b == null ? null : sgb(Oeb((m = nue(b, true), m.length > 0 && (BFb(0, m.length), m.charCodeAt(0) == 43) ? (BFb(1, m.length + 1), m.substr(1)) : m), qwe, lve));
                                case 36:
                                    return b == null ? null : Hgb(Peb((n = nue(b, true), n.length > 0 && (BFb(0, n.length), n.charCodeAt(0) == 43) ? (BFb(1, n.length + 1), n.substr(1)) : n)));
                                case 37:
                                    return b == null ? null : Hgb(Peb((o = nue(b, true), o.length > 0 && (BFb(0, o.length), o.charCodeAt(0) == 43) ? (BFb(1, o.length + 1), o.substr(1)) : o)));
                                case 40:
                                    return qne((nme(), b));
                                case 42:
                                    return one((nme(), b));
                                case 43:
                                    return one(b);
                                case 44:
                                    return b == null ? null : new ejb((p = nue(b, true), p.length > 0 && (BFb(0, p.length), p.charCodeAt(0) == 43) ? (BFb(1, p.length + 1), p.substr(1)) : p));
                                case 45:
                                    return b == null ? null : new ejb((q = nue(b, true), q.length > 0 && (BFb(0, q.length), q.charCodeAt(0) == 43) ? (BFb(1, q.length + 1), q.substr(1)) : q));
                                case 46:
                                    return nue(b, false);
                                case 47:
                                    return WD(uAd(this, (nme(), bme), b));
                                case 59:
                                case 48:
                                    return pne((nme(), b));
                                case 49:
                                    return WD(uAd(this, (nme(), dme), b));
                                case 50:
                                    return b == null ? null : bhb(Oeb((r = nue(b, true), r.length > 0 && (BFb(0, r.length), r.charCodeAt(0) == 43) ? (BFb(1, r.length + 1), r.substr(1)) : r), BKe, 32767) << 16 >> 16);
                                case 51:
                                    return b == null ? null : bhb(Oeb((f = nue(b, true), f.length > 0 && (BFb(0, f.length), f.charCodeAt(0) == 43) ? (BFb(1, f.length + 1), f.substr(1)) : f), BKe, 32767) << 16 >> 16);
                                case 53:
                                    return WD(uAd(this, (nme(), gme), b));
                                case 55:
                                    return b == null ? null : bhb(Oeb((g = nue(b, true), g.length > 0 && (BFb(0, g.length), g.charCodeAt(0) == 43) ? (BFb(1, g.length + 1), g.substr(1)) : g), BKe, 32767) << 16 >> 16);
                                case 56:
                                    return b == null ? null : bhb(Oeb((h = nue(b, true), h.length > 0 && (BFb(0, h.length), h.charCodeAt(0) == 43) ? (BFb(1, h.length + 1), h.substr(1)) : h), BKe, 32767) << 16 >> 16);
                                case 57:
                                    return b == null ? null : Hgb(Peb((i = nue(b, true), i.length > 0 && (BFb(0, i.length), i.charCodeAt(0) == 43) ? (BFb(1, i.length + 1), i.substr(1)) : i)));
                                case 58:
                                    return b == null ? null : Hgb(Peb((j = nue(b, true), j.length > 0 && (BFb(0, j.length), j.charCodeAt(0) == 43) ? (BFb(1, j.length + 1), j.substr(1)) : j)));
                                case 60:
                                    return b == null ? null : sgb(Oeb((c = nue(b, true), c.length > 0 && (BFb(0, c.length), c.charCodeAt(0) == 43) ? (BFb(1, c.length + 1), c.substr(1)) : c), qwe, lve));
                                case 61:
                                    return b == null ? null : sgb(Oeb(nue(b, true), qwe, lve));
                                default:
                                    throw Adb(new agb(VHe + a.xe() + WHe));
                            }
                        };
                        var Vme, Wme, Xme, Yme;
                        var ccb = sfb(lLe, 'XMLTypeFactoryImpl', 2028);
                        feb(594, 184, {
                            110: 1,
                            94: 1,
                            93: 1,
                            155: 1,
                            197: 1,
                            58: 1,
                            241: 1,
                            114: 1,
                            54: 1,
                            99: 1,
                            158: 1,
                            184: 1,
                            119: 1,
                            120: 1,
                            690: 1,
                            2044: 1,
                            594: 1
                        }, Bne);
                        _.N = false;
                        _.O = false;
                        var wne = false;
                        var bdb = sfb(lLe, 'XMLTypePackageImpl', 594);
                        feb(1961, 1, {
                            851: 1
                        }, Ene);
                        _.Kk = function Fne() {
                            return rue(), que;
                        };
                        var ncb = sfb(lLe, 'XMLTypePackageImpl/1', 1961);
                        feb(1970, 1, OKe, Gne);
                        _.fk = function Hne(a) {
                            return bE(a);
                        };
                        _.gk = function Ine(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var dcb = sfb(lLe, 'XMLTypePackageImpl/10', 1970);
                        feb(1971, 1, OKe, Jne);
                        _.fk = function Kne(a) {
                            return bE(a);
                        };
                        _.gk = function Lne(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var ecb = sfb(lLe, 'XMLTypePackageImpl/11', 1971);
                        feb(1972, 1, OKe, Mne);
                        _.fk = function Nne(a) {
                            return bE(a);
                        };
                        _.gk = function One(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var fcb = sfb(lLe, 'XMLTypePackageImpl/12', 1972);
                        feb(1973, 1, OKe, Pne);
                        _.fk = function Qne(a) {
                            return _D(a);
                        };
                        _.gk = function Rne(a) {
                            return $C(VI, Nve, 345, a, 7, 1);
                        };
                        var gcb = sfb(lLe, 'XMLTypePackageImpl/13', 1973);
                        feb(1974, 1, OKe, Sne);
                        _.fk = function Tne(a) {
                            return bE(a);
                        };
                        _.gk = function Une(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var hcb = sfb(lLe, 'XMLTypePackageImpl/14', 1974);
                        feb(1975, 1, OKe, Vne);
                        _.fk = function Wne(a) {
                            return ZD(a, 15);
                        };
                        _.gk = function Xne(a) {
                            return $C(QK, Ize, 15, a, 0, 1);
                        };
                        var icb = sfb(lLe, 'XMLTypePackageImpl/15', 1975);
                        feb(1976, 1, OKe, Yne);
                        _.fk = function Zne(a) {
                            return ZD(a, 15);
                        };
                        _.gk = function $ne(a) {
                            return $C(QK, Ize, 15, a, 0, 1);
                        };
                        var jcb = sfb(lLe, 'XMLTypePackageImpl/16', 1976);
                        feb(1977, 1, OKe, _ne);
                        _.fk = function aoe(a) {
                            return bE(a);
                        };
                        _.gk = function boe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var kcb = sfb(lLe, 'XMLTypePackageImpl/17', 1977);
                        feb(1978, 1, OKe, coe);
                        _.fk = function doe(a) {
                            return ZD(a, 161);
                        };
                        _.gk = function eoe(a) {
                            return $C(ZI, Nve, 161, a, 0, 1);
                        };
                        var lcb = sfb(lLe, 'XMLTypePackageImpl/18', 1978);
                        feb(1979, 1, OKe, foe);
                        _.fk = function goe(a) {
                            return bE(a);
                        };
                        _.gk = function hoe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var mcb = sfb(lLe, 'XMLTypePackageImpl/19', 1979);
                        feb(1962, 1, OKe, ioe);
                        _.fk = function joe(a) {
                            return ZD(a, 857);
                        };
                        _.gk = function koe(a) {
                            return $C(Vbb, rve, 857, a, 0, 1);
                        };
                        var ycb = sfb(lLe, 'XMLTypePackageImpl/2', 1962);
                        feb(1980, 1, OKe, loe);
                        _.fk = function moe(a) {
                            return bE(a);
                        };
                        _.gk = function noe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var ocb = sfb(lLe, 'XMLTypePackageImpl/20', 1980);
                        feb(1981, 1, OKe, ooe);
                        _.fk = function poe(a) {
                            return bE(a);
                        };
                        _.gk = function qoe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var pcb = sfb(lLe, 'XMLTypePackageImpl/21', 1981);
                        feb(1982, 1, OKe, roe);
                        _.fk = function soe(a) {
                            return bE(a);
                        };
                        _.gk = function toe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var qcb = sfb(lLe, 'XMLTypePackageImpl/22', 1982);
                        feb(1983, 1, OKe, uoe);
                        _.fk = function voe(a) {
                            return bE(a);
                        };
                        _.gk = function woe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var rcb = sfb(lLe, 'XMLTypePackageImpl/23', 1983);
                        feb(1984, 1, OKe, xoe);
                        _.fk = function yoe(a) {
                            return ZD(a, 195);
                        };
                        _.gk = function zoe(a) {
                            return $C(gE, Nve, 195, a, 0, 2);
                        };
                        var scb = sfb(lLe, 'XMLTypePackageImpl/24', 1984);
                        feb(1985, 1, OKe, Aoe);
                        _.fk = function Boe(a) {
                            return bE(a);
                        };
                        _.gk = function Coe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var tcb = sfb(lLe, 'XMLTypePackageImpl/25', 1985);
                        feb(1986, 1, OKe, Doe);
                        _.fk = function Eoe(a) {
                            return bE(a);
                        };
                        _.gk = function Foe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var ucb = sfb(lLe, 'XMLTypePackageImpl/26', 1986);
                        feb(1987, 1, OKe, Goe);
                        _.fk = function Hoe(a) {
                            return ZD(a, 15);
                        };
                        _.gk = function Ioe(a) {
                            return $C(QK, Ize, 15, a, 0, 1);
                        };
                        var vcb = sfb(lLe, 'XMLTypePackageImpl/27', 1987);
                        feb(1988, 1, OKe, Joe);
                        _.fk = function Koe(a) {
                            return ZD(a, 15);
                        };
                        _.gk = function Loe(a) {
                            return $C(QK, Ize, 15, a, 0, 1);
                        };
                        var wcb = sfb(lLe, 'XMLTypePackageImpl/28', 1988);
                        feb(1989, 1, OKe, Moe);
                        _.fk = function Noe(a) {
                            return bE(a);
                        };
                        _.gk = function Ooe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var xcb = sfb(lLe, 'XMLTypePackageImpl/29', 1989);
                        feb(1963, 1, OKe, Poe);
                        _.fk = function Qoe(a) {
                            return ZD(a, 681);
                        };
                        _.gk = function Roe(a) {
                            return $C(Xbb, rve, 2119, a, 0, 1);
                        };
                        var Jcb = sfb(lLe, 'XMLTypePackageImpl/3', 1963);
                        feb(1990, 1, OKe, Soe);
                        _.fk = function Toe(a) {
                            return ZD(a, 17);
                        };
                        _.gk = function Uoe(a) {
                            return $C(bJ, Nve, 17, a, 0, 1);
                        };
                        var zcb = sfb(lLe, 'XMLTypePackageImpl/30', 1990);
                        feb(1991, 1, OKe, Voe);
                        _.fk = function Woe(a) {
                            return bE(a);
                        };
                        _.gk = function Xoe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Acb = sfb(lLe, 'XMLTypePackageImpl/31', 1991);
                        feb(1992, 1, OKe, Yoe);
                        _.fk = function Zoe(a) {
                            return ZD(a, 168);
                        };
                        _.gk = function $oe(a) {
                            return $C(eJ, Nve, 168, a, 0, 1);
                        };
                        var Bcb = sfb(lLe, 'XMLTypePackageImpl/32', 1992);
                        feb(1993, 1, OKe, _oe);
                        _.fk = function ape(a) {
                            return bE(a);
                        };
                        _.gk = function bpe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Ccb = sfb(lLe, 'XMLTypePackageImpl/33', 1993);
                        feb(1994, 1, OKe, cpe);
                        _.fk = function dpe(a) {
                            return bE(a);
                        };
                        _.gk = function epe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Dcb = sfb(lLe, 'XMLTypePackageImpl/34', 1994);
                        feb(1995, 1, OKe, fpe);
                        _.fk = function gpe(a) {
                            return bE(a);
                        };
                        _.gk = function hpe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Ecb = sfb(lLe, 'XMLTypePackageImpl/35', 1995);
                        feb(1996, 1, OKe, ipe);
                        _.fk = function jpe(a) {
                            return bE(a);
                        };
                        _.gk = function kpe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Fcb = sfb(lLe, 'XMLTypePackageImpl/36', 1996);
                        feb(1997, 1, OKe, lpe);
                        _.fk = function mpe(a) {
                            return ZD(a, 15);
                        };
                        _.gk = function npe(a) {
                            return $C(QK, Ize, 15, a, 0, 1);
                        };
                        var Gcb = sfb(lLe, 'XMLTypePackageImpl/37', 1997);
                        feb(1998, 1, OKe, ope);
                        _.fk = function ppe(a) {
                            return ZD(a, 15);
                        };
                        _.gk = function qpe(a) {
                            return $C(QK, Ize, 15, a, 0, 1);
                        };
                        var Hcb = sfb(lLe, 'XMLTypePackageImpl/38', 1998);
                        feb(1999, 1, OKe, rpe);
                        _.fk = function spe(a) {
                            return bE(a);
                        };
                        _.gk = function tpe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Icb = sfb(lLe, 'XMLTypePackageImpl/39', 1999);
                        feb(1964, 1, OKe, upe);
                        _.fk = function vpe(a) {
                            return ZD(a, 682);
                        };
                        _.gk = function wpe(a) {
                            return $C(Ybb, rve, 2120, a, 0, 1);
                        };
                        var Ucb = sfb(lLe, 'XMLTypePackageImpl/4', 1964);
                        feb(2000, 1, OKe, xpe);
                        _.fk = function ype(a) {
                            return bE(a);
                        };
                        _.gk = function zpe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Kcb = sfb(lLe, 'XMLTypePackageImpl/40', 2000);
                        feb(2001, 1, OKe, Ape);
                        _.fk = function Bpe(a) {
                            return bE(a);
                        };
                        _.gk = function Cpe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Lcb = sfb(lLe, 'XMLTypePackageImpl/41', 2001);
                        feb(2002, 1, OKe, Dpe);
                        _.fk = function Epe(a) {
                            return bE(a);
                        };
                        _.gk = function Fpe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Mcb = sfb(lLe, 'XMLTypePackageImpl/42', 2002);
                        feb(2003, 1, OKe, Gpe);
                        _.fk = function Hpe(a) {
                            return bE(a);
                        };
                        _.gk = function Ipe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Ncb = sfb(lLe, 'XMLTypePackageImpl/43', 2003);
                        feb(2004, 1, OKe, Jpe);
                        _.fk = function Kpe(a) {
                            return bE(a);
                        };
                        _.gk = function Lpe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Ocb = sfb(lLe, 'XMLTypePackageImpl/44', 2004);
                        feb(2005, 1, OKe, Mpe);
                        _.fk = function Npe(a) {
                            return ZD(a, 191);
                        };
                        _.gk = function Ope(a) {
                            return $C(lJ, Nve, 191, a, 0, 1);
                        };
                        var Pcb = sfb(lLe, 'XMLTypePackageImpl/45', 2005);
                        feb(2006, 1, OKe, Ppe);
                        _.fk = function Qpe(a) {
                            return bE(a);
                        };
                        _.gk = function Rpe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Qcb = sfb(lLe, 'XMLTypePackageImpl/46', 2006);
                        feb(2007, 1, OKe, Spe);
                        _.fk = function Tpe(a) {
                            return bE(a);
                        };
                        _.gk = function Upe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Rcb = sfb(lLe, 'XMLTypePackageImpl/47', 2007);
                        feb(2008, 1, OKe, Vpe);
                        _.fk = function Wpe(a) {
                            return bE(a);
                        };
                        _.gk = function Xpe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Scb = sfb(lLe, 'XMLTypePackageImpl/48', 2008);
                        feb(2009, 1, OKe, Ype);
                        _.fk = function Zpe(a) {
                            return ZD(a, 191);
                        };
                        _.gk = function $pe(a) {
                            return $C(lJ, Nve, 191, a, 0, 1);
                        };
                        var Tcb = sfb(lLe, 'XMLTypePackageImpl/49', 2009);
                        feb(1965, 1, OKe, _pe);
                        _.fk = function aqe(a) {
                            return ZD(a, 683);
                        };
                        _.gk = function bqe(a) {
                            return $C(Zbb, rve, 2121, a, 0, 1);
                        };
                        var Ycb = sfb(lLe, 'XMLTypePackageImpl/5', 1965);
                        feb(2010, 1, OKe, cqe);
                        _.fk = function dqe(a) {
                            return ZD(a, 168);
                        };
                        _.gk = function eqe(a) {
                            return $C(eJ, Nve, 168, a, 0, 1);
                        };
                        var Vcb = sfb(lLe, 'XMLTypePackageImpl/50', 2010);
                        feb(2011, 1, OKe, fqe);
                        _.fk = function gqe(a) {
                            return bE(a);
                        };
                        _.gk = function hqe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Wcb = sfb(lLe, 'XMLTypePackageImpl/51', 2011);
                        feb(2012, 1, OKe, iqe);
                        _.fk = function jqe(a) {
                            return ZD(a, 17);
                        };
                        _.gk = function kqe(a) {
                            return $C(bJ, Nve, 17, a, 0, 1);
                        };
                        var Xcb = sfb(lLe, 'XMLTypePackageImpl/52', 2012);
                        feb(1966, 1, OKe, lqe);
                        _.fk = function mqe(a) {
                            return bE(a);
                        };
                        _.gk = function nqe(a) {
                            return $C(qJ, Nve, 2, a, 6, 1);
                        };
                        var Zcb = sfb(lLe, 'XMLTypePackageImpl/6', 1966);
                        feb(1967, 1, OKe, oqe);
                        _.fk = function pqe(a) {
                            return ZD(a, 195);
                        };
                        _.gk = function qqe(a) {
                            return $C(gE, Nve, 195, a, 0, 2);
                        };
                        var $cb = sfb(lLe, 'XMLTypePackageImpl/7', 1967);
                        feb(1968, 1, OKe, rqe);
                        _.fk = function sqe(a) {
                            return $D(a);
                        };
                        _.gk = function tqe(a) {
                            return $C(QI, Nve, 485, a, 8, 1);
                        };
                        var _cb = sfb(lLe, 'XMLTypePackageImpl/8', 1968);
                        feb(1969, 1, OKe, uqe);
                        _.fk = function vqe(a) {
                            return ZD(a, 222);
                        };
                        _.gk = function wqe(a) {
                            return $C(RI, Nve, 222, a, 0, 1);
                        };
                        var adb = sfb(lLe, 'XMLTypePackageImpl/9', 1969);
                        var xqe, yqe;
                        var Eqe, Fqe;
                        var Jqe;
                        feb(55, 63, swe, Lqe);
                        var cdb = sfb(LLe, 'RegEx/ParseException', 55);
                        feb(836, 1, {}, Tqe);
                        _.bm = function Uqe(a) {
                            return a < this.j && ihb(this.i, a) == 63;
                        };
                        _.cm = function Vqe() {
                            var a, b, c, d, e;
                            if (this.c != 10) throw Adb(new Lqe(TId((Hde(), VIe))));
                            a = this.a;
                            switch(a){
                                case 101:
                                    a = 27;
                                    break;
                                case 102:
                                    a = 12;
                                    break;
                                case 110:
                                    a = 10;
                                    break;
                                case 114:
                                    a = 13;
                                    break;
                                case 116:
                                    a = 9;
                                    break;
                                case 120:
                                    Mqe(this);
                                    if (this.c != 0) throw Adb(new Lqe(TId((Hde(), sJe))));
                                    if (this.a == 123) {
                                        e = 0;
                                        c = 0;
                                        do {
                                            Mqe(this);
                                            if (this.c != 0) throw Adb(new Lqe(TId((Hde(), sJe))));
                                            if ((e = Xqe(this.a)) < 0) break;
                                            if (c > c * 16) throw Adb(new Lqe(TId((Hde(), tJe))));
                                            c = c * 16 + e;
                                        }while (true);
                                        if (this.a != 125) throw Adb(new Lqe(TId((Hde(), uJe))));
                                        if (c > MLe) throw Adb(new Lqe(TId((Hde(), vJe))));
                                        a = c;
                                    } else {
                                        e = 0;
                                        if (this.c != 0 || (e = Xqe(this.a)) < 0) throw Adb(new Lqe(TId((Hde(), sJe))));
                                        c = e;
                                        Mqe(this);
                                        if (this.c != 0 || (e = Xqe(this.a)) < 0) throw Adb(new Lqe(TId((Hde(), sJe))));
                                        c = c * 16 + e;
                                        a = c;
                                    }
                                    break;
                                case 117:
                                    d = 0;
                                    Mqe(this);
                                    if (this.c != 0 || (d = Xqe(this.a)) < 0) throw Adb(new Lqe(TId((Hde(), sJe))));
                                    b = d;
                                    Mqe(this);
                                    if (this.c != 0 || (d = Xqe(this.a)) < 0) throw Adb(new Lqe(TId((Hde(), sJe))));
                                    b = b * 16 + d;
                                    Mqe(this);
                                    if (this.c != 0 || (d = Xqe(this.a)) < 0) throw Adb(new Lqe(TId((Hde(), sJe))));
                                    b = b * 16 + d;
                                    Mqe(this);
                                    if (this.c != 0 || (d = Xqe(this.a)) < 0) throw Adb(new Lqe(TId((Hde(), sJe))));
                                    b = b * 16 + d;
                                    a = b;
                                    break;
                                case 118:
                                    Mqe(this);
                                    if (this.c != 0 || (d = Xqe(this.a)) < 0) throw Adb(new Lqe(TId((Hde(), sJe))));
                                    b = d;
                                    Mqe(this);
                                    if (this.c != 0 || (d = Xqe(this.a)) < 0) throw Adb(new Lqe(TId((Hde(), sJe))));
                                    b = b * 16 + d;
                                    Mqe(this);
                                    if (this.c != 0 || (d = Xqe(this.a)) < 0) throw Adb(new Lqe(TId((Hde(), sJe))));
                                    b = b * 16 + d;
                                    Mqe(this);
                                    if (this.c != 0 || (d = Xqe(this.a)) < 0) throw Adb(new Lqe(TId((Hde(), sJe))));
                                    b = b * 16 + d;
                                    Mqe(this);
                                    if (this.c != 0 || (d = Xqe(this.a)) < 0) throw Adb(new Lqe(TId((Hde(), sJe))));
                                    b = b * 16 + d;
                                    Mqe(this);
                                    if (this.c != 0 || (d = Xqe(this.a)) < 0) throw Adb(new Lqe(TId((Hde(), sJe))));
                                    b = b * 16 + d;
                                    if (b > MLe) throw Adb(new Lqe(TId((Hde(), 'parser.descappe.4'))));
                                    a = b;
                                    break;
                                case 65:
                                case 90:
                                case 122:
                                    throw Adb(new Lqe(TId((Hde(), wJe))));
                            }
                            return a;
                        };
                        _.dm = function Wqe(a) {
                            var b, c;
                            switch(a){
                                case 100:
                                    c = (this.e & 32) == 32 ? hte('Nd', true) : (Vse(), Bse);
                                    break;
                                case 68:
                                    c = (this.e & 32) == 32 ? hte('Nd', false) : (Vse(), Ise);
                                    break;
                                case 119:
                                    c = (this.e & 32) == 32 ? hte('IsWord', true) : (Vse(), Rse);
                                    break;
                                case 87:
                                    c = (this.e & 32) == 32 ? hte('IsWord', false) : (Vse(), Kse);
                                    break;
                                case 115:
                                    c = (this.e & 32) == 32 ? hte('IsSpace', true) : (Vse(), Mse);
                                    break;
                                case 83:
                                    c = (this.e & 32) == 32 ? hte('IsSpace', false) : (Vse(), Jse);
                                    break;
                                default:
                                    throw Adb(new yz((b = a, NLe + b.toString(16))));
                            }
                            return c;
                        };
                        _.em = function Yqe(a) {
                            var b, c, d, e, f, g, h, i, j, k, l, m;
                            this.b = 1;
                            Mqe(this);
                            b = null;
                            if (this.c == 0 && this.a == 94) {
                                Mqe(this);
                                if (a) k = (Vse(), Vse(), ++Use, new xte(5));
                                else {
                                    b = (Vse(), Vse(), ++Use, new xte(4));
                                    rte(b, 0, MLe);
                                    k = (++Use, new xte(4));
                                }
                            } else k = (Vse(), Vse(), ++Use, new xte(4));
                            e = true;
                            while((m = this.c) != 1){
                                if (m == 0 && this.a == 93 && !e) break;
                                e = false;
                                c = this.a;
                                d = false;
                                if (m == 10) switch(c){
                                    case 100:
                                    case 68:
                                    case 119:
                                    case 87:
                                    case 115:
                                    case 83:
                                        ute(k, this.dm(c));
                                        d = true;
                                        break;
                                    case 105:
                                    case 73:
                                    case 99:
                                    case 67:
                                        c = this.um(k, c);
                                        c < 0 && (d = true);
                                        break;
                                    case 112:
                                    case 80:
                                        l = Sqe(this, c);
                                        if (!l) throw Adb(new Lqe(TId((Hde(), hJe))));
                                        ute(k, l);
                                        d = true;
                                        break;
                                    default:
                                        c = this.cm();
                                }
                                else if (m == 20) {
                                    g = phb(this.i, 58, this.d);
                                    if (g < 0) throw Adb(new Lqe(TId((Hde(), iJe))));
                                    h = true;
                                    if (ihb(this.i, this.d) == 94) {
                                        ++this.d;
                                        h = false;
                                    }
                                    f = zhb(this.i, this.d, g);
                                    i = ite(f, h, (this.e & 512) == 512);
                                    if (!i) throw Adb(new Lqe(TId((Hde(), kJe))));
                                    ute(k, i);
                                    d = true;
                                    if (g + 1 >= this.j || ihb(this.i, g + 1) != 93) throw Adb(new Lqe(TId((Hde(), iJe))));
                                    this.d = g + 2;
                                }
                                Mqe(this);
                                if (!d) {
                                    if (this.c != 0 || this.a != 45) rte(k, c, c);
                                    else {
                                        Mqe(this);
                                        if ((m = this.c) == 1) throw Adb(new Lqe(TId((Hde(), jJe))));
                                        if (m == 0 && this.a == 93) {
                                            rte(k, c, c);
                                            rte(k, 45, 45);
                                        } else {
                                            j = this.a;
                                            m == 10 && (j = this.cm());
                                            Mqe(this);
                                            rte(k, c, j);
                                        }
                                    }
                                }
                                (this.e & gwe) == gwe && this.c == 0 && this.a == 44 && Mqe(this);
                            }
                            if (this.c == 1) throw Adb(new Lqe(TId((Hde(), jJe))));
                            if (b) {
                                wte(b, k);
                                k = b;
                            }
                            vte(k);
                            ste(k);
                            this.b = 0;
                            Mqe(this);
                            return k;
                        };
                        _.fm = function Zqe() {
                            var a, b, c, d;
                            c = this.em(false);
                            while((d = this.c) != 7){
                                a = this.a;
                                if (d == 0 && (a == 45 || a == 38) || d == 4) {
                                    Mqe(this);
                                    if (this.c != 9) throw Adb(new Lqe(TId((Hde(), pJe))));
                                    b = this.em(false);
                                    if (d == 4) ute(c, b);
                                    else if (a == 45) wte(c, b);
                                    else if (a == 38) tte(c, b);
                                    else throw Adb(new yz('ASSERT'));
                                } else throw Adb(new Lqe(TId((Hde(), qJe))));
                            }
                            Mqe(this);
                            return c;
                        };
                        _.gm = function $qe() {
                            var a, b;
                            a = this.a - 48;
                            b = (Vse(), Vse(), ++Use, new eue(12, null, a));
                            !this.g && (this.g = new gyb);
                            dyb(this.g, new Bte(a));
                            Mqe(this);
                            return b;
                        };
                        _.hm = function _qe() {
                            Mqe(this);
                            return Vse(), Nse;
                        };
                        _.im = function are() {
                            Mqe(this);
                            return Vse(), Lse;
                        };
                        _.jm = function bre() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.km = function cre() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.lm = function dre() {
                            Mqe(this);
                            return fte();
                        };
                        _.mm = function ere() {
                            Mqe(this);
                            return Vse(), Pse;
                        };
                        _.nm = function fre() {
                            Mqe(this);
                            return Vse(), Sse;
                        };
                        _.om = function gre() {
                            var a;
                            if (this.d >= this.j || ((a = ihb(this.i, this.d++)) & 65504) != 64) throw Adb(new Lqe(TId((Hde(), dJe))));
                            Mqe(this);
                            return Vse(), Vse(), ++Use, new Hte(0, a - 64);
                        };
                        _.pm = function hre() {
                            Mqe(this);
                            return gte();
                        };
                        _.qm = function ire() {
                            Mqe(this);
                            return Vse(), Tse;
                        };
                        _.rm = function jre() {
                            var a;
                            a = (Vse(), Vse(), ++Use, new Hte(0, 105));
                            Mqe(this);
                            return a;
                        };
                        _.sm = function kre() {
                            Mqe(this);
                            return Vse(), Qse;
                        };
                        _.tm = function lre() {
                            Mqe(this);
                            return Vse(), Ose;
                        };
                        _.um = function mre(a, b) {
                            return this.cm();
                        };
                        _.vm = function nre() {
                            Mqe(this);
                            return Vse(), Gse;
                        };
                        _.wm = function ore() {
                            var a, b, c, d, e;
                            if (this.d + 1 >= this.j) throw Adb(new Lqe(TId((Hde(), aJe))));
                            d = -1;
                            b = null;
                            a = ihb(this.i, this.d);
                            if (49 <= a && a <= 57) {
                                d = a - 48;
                                !this.g && (this.g = new gyb);
                                dyb(this.g, new Bte(d));
                                ++this.d;
                                if (ihb(this.i, this.d) != 41) throw Adb(new Lqe(TId((Hde(), ZIe))));
                                ++this.d;
                            } else {
                                a == 63 && --this.d;
                                Mqe(this);
                                b = Pqe(this);
                                switch(b.e){
                                    case 20:
                                    case 21:
                                    case 22:
                                    case 23:
                                        break;
                                    case 8:
                                        if (this.c != 7) throw Adb(new Lqe(TId((Hde(), ZIe))));
                                        break;
                                    default:
                                        throw Adb(new Lqe(TId((Hde(), bJe))));
                                }
                            }
                            Mqe(this);
                            e = Qqe(this);
                            c = null;
                            if (e.e == 2) {
                                if (e.Pm() != 2) throw Adb(new Lqe(TId((Hde(), cJe))));
                                c = e.Lm(1);
                                e = e.Lm(0);
                            }
                            if (this.c != 7) throw Adb(new Lqe(TId((Hde(), ZIe))));
                            Mqe(this);
                            return Vse(), Vse(), ++Use, new Ute(d, b, e, c);
                        };
                        _.xm = function pre() {
                            Mqe(this);
                            return Vse(), Hse;
                        };
                        _.ym = function qre() {
                            var a;
                            Mqe(this);
                            a = _se(24, Qqe(this));
                            if (this.c != 7) throw Adb(new Lqe(TId((Hde(), ZIe))));
                            Mqe(this);
                            return a;
                        };
                        _.zm = function rre() {
                            var a;
                            Mqe(this);
                            a = _se(20, Qqe(this));
                            if (this.c != 7) throw Adb(new Lqe(TId((Hde(), ZIe))));
                            Mqe(this);
                            return a;
                        };
                        _.Am = function sre() {
                            var a;
                            Mqe(this);
                            a = _se(22, Qqe(this));
                            if (this.c != 7) throw Adb(new Lqe(TId((Hde(), ZIe))));
                            Mqe(this);
                            return a;
                        };
                        _.Bm = function tre() {
                            var a, b, c, d, e;
                            a = 0;
                            c = 0;
                            b = -1;
                            while(this.d < this.j){
                                b = ihb(this.i, this.d);
                                e = rse(b);
                                if (e == 0) break;
                                a |= e;
                                ++this.d;
                            }
                            if (this.d >= this.j) throw Adb(new Lqe(TId((Hde(), $Ie))));
                            if (b == 45) {
                                ++this.d;
                                while(this.d < this.j){
                                    b = ihb(this.i, this.d);
                                    e = rse(b);
                                    if (e == 0) break;
                                    c |= e;
                                    ++this.d;
                                }
                                if (this.d >= this.j) throw Adb(new Lqe(TId((Hde(), $Ie))));
                            }
                            if (b == 58) {
                                ++this.d;
                                Mqe(this);
                                d = ate(Qqe(this), a, c);
                                if (this.c != 7) throw Adb(new Lqe(TId((Hde(), ZIe))));
                                Mqe(this);
                            } else if (b == 41) {
                                ++this.d;
                                Mqe(this);
                                d = ate(Qqe(this), a, c);
                            } else throw Adb(new Lqe(TId((Hde(), _Ie))));
                            return d;
                        };
                        _.Cm = function ure() {
                            var a;
                            Mqe(this);
                            a = _se(21, Qqe(this));
                            if (this.c != 7) throw Adb(new Lqe(TId((Hde(), ZIe))));
                            Mqe(this);
                            return a;
                        };
                        _.Dm = function vre() {
                            var a;
                            Mqe(this);
                            a = _se(23, Qqe(this));
                            if (this.c != 7) throw Adb(new Lqe(TId((Hde(), ZIe))));
                            Mqe(this);
                            return a;
                        };
                        _.Em = function wre() {
                            var a, b;
                            Mqe(this);
                            a = this.f++;
                            b = bte(Qqe(this), a);
                            if (this.c != 7) throw Adb(new Lqe(TId((Hde(), ZIe))));
                            Mqe(this);
                            return b;
                        };
                        _.Fm = function xre() {
                            var a;
                            Mqe(this);
                            a = bte(Qqe(this), 0);
                            if (this.c != 7) throw Adb(new Lqe(TId((Hde(), ZIe))));
                            Mqe(this);
                            return a;
                        };
                        _.Gm = function yre(a) {
                            Mqe(this);
                            if (this.c == 5) {
                                Mqe(this);
                                return $se(a, (Vse(), Vse(), ++Use, new Kte(9, a)));
                            } else return $se(a, (Vse(), Vse(), ++Use, new Kte(3, a)));
                        };
                        _.Hm = function zre(a) {
                            var b;
                            Mqe(this);
                            b = (Vse(), Vse(), ++Use, new iue(2));
                            if (this.c == 5) {
                                Mqe(this);
                                hue(b, Ese);
                                hue(b, a);
                            } else {
                                hue(b, a);
                                hue(b, Ese);
                            }
                            return b;
                        };
                        _.Im = function Are(a) {
                            Mqe(this);
                            if (this.c == 5) {
                                Mqe(this);
                                return Vse(), Vse(), ++Use, new Kte(9, a);
                            } else return Vse(), Vse(), ++Use, new Kte(3, a);
                        };
                        _.a = 0;
                        _.b = 0;
                        _.c = 0;
                        _.d = 0;
                        _.e = 0;
                        _.f = 1;
                        _.g = null;
                        _.j = 0;
                        var gdb = sfb(LLe, 'RegEx/RegexParser', 836);
                        feb(1947, 836, {}, Gre);
                        _.bm = function Hre(a) {
                            return false;
                        };
                        _.cm = function Ire() {
                            return Dre(this);
                        };
                        _.dm = function Kre(a) {
                            return Ere(a);
                        };
                        _.em = function Lre(a) {
                            return Fre(this);
                        };
                        _.fm = function Mre() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.gm = function Nre() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.hm = function Ore() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.im = function Pre() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.jm = function Qre() {
                            Mqe(this);
                            return Ere(67);
                        };
                        _.km = function Rre() {
                            Mqe(this);
                            return Ere(73);
                        };
                        _.lm = function Sre() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.mm = function Tre() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.nm = function Ure() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.om = function Vre() {
                            Mqe(this);
                            return Ere(99);
                        };
                        _.pm = function Wre() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.qm = function Xre() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.rm = function Yre() {
                            Mqe(this);
                            return Ere(105);
                        };
                        _.sm = function Zre() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.tm = function $re() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.um = function _re(a, b) {
                            return ute(a, Ere(b)), -1;
                        };
                        _.vm = function ase() {
                            Mqe(this);
                            return Vse(), Vse(), ++Use, new Hte(0, 94);
                        };
                        _.wm = function bse() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.xm = function cse() {
                            Mqe(this);
                            return Vse(), Vse(), ++Use, new Hte(0, 36);
                        };
                        _.ym = function dse() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.zm = function ese() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.Am = function fse() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.Bm = function gse() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.Cm = function hse() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.Dm = function ise() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.Em = function jse() {
                            var a;
                            Mqe(this);
                            a = bte(Qqe(this), 0);
                            if (this.c != 7) throw Adb(new Lqe(TId((Hde(), ZIe))));
                            Mqe(this);
                            return a;
                        };
                        _.Fm = function kse() {
                            throw Adb(new Lqe(TId((Hde(), xJe))));
                        };
                        _.Gm = function lse(a) {
                            Mqe(this);
                            return $se(a, (Vse(), Vse(), ++Use, new Kte(3, a)));
                        };
                        _.Hm = function mse(a) {
                            var b;
                            Mqe(this);
                            b = (Vse(), Vse(), ++Use, new iue(2));
                            hue(b, a);
                            hue(b, Ese);
                            return b;
                        };
                        _.Im = function nse(a) {
                            Mqe(this);
                            return Vse(), Vse(), ++Use, new Kte(3, a);
                        };
                        var Bre = null, Cre = null;
                        var ddb = sfb(LLe, 'RegEx/ParserForXMLSchema', 1947);
                        feb(122, 1, ZLe, Wse);
                        _.Jm = function Xse(a) {
                            throw Adb(new yz('Not supported.'));
                        };
                        _.Km = function dte() {
                            return -1;
                        };
                        _.Lm = function ete(a) {
                            return null;
                        };
                        _.Mm = function jte() {
                            return null;
                        };
                        _.Nm = function mte(a) {};
                        _.Om = function nte(a) {};
                        _.Pm = function ote() {
                            return 0;
                        };
                        _.Ib = function pte() {
                            return this.Qm(0);
                        };
                        _.Qm = function qte(a) {
                            return this.e == 11 ? '.' : '';
                        };
                        _.e = 0;
                        var vse, wse, xse, yse, zse, Ase = null, Bse, Cse = null, Dse, Ese, Fse = null, Gse, Hse, Ise, Jse, Kse, Lse, Mse, Nse, Ose, Pse, Qse, Rse, Sse, Tse, Use = 0;
                        var qdb = sfb(LLe, 'RegEx/Token', 122);
                        feb(138, 122, {
                            3: 1,
                            138: 1,
                            122: 1
                        }, xte);
                        _.Qm = function Ate(a) {
                            var b, c, d;
                            if (this.e == 4) {
                                if (this == Dse) c = '.';
                                else if (this == Bse) c = '\\d';
                                else if (this == Rse) c = '\\w';
                                else if (this == Mse) c = '\\s';
                                else {
                                    d = new Qhb;
                                    d.a += '[';
                                    for(b = 0; b < this.b.length; b += 2){
                                        (a & gwe) != 0 && b > 0 && (d.a += ',', d);
                                        if (this.b[b] === this.b[b + 1]) Nhb(d, zte(this.b[b]));
                                        else {
                                            Nhb(d, zte(this.b[b]));
                                            d.a += '-';
                                            Nhb(d, zte(this.b[b + 1]));
                                        }
                                    }
                                    d.a += ']';
                                    c = d.a;
                                }
                            } else {
                                if (this == Ise) c = '\\D';
                                else if (this == Kse) c = '\\W';
                                else if (this == Jse) c = '\\S';
                                else {
                                    d = new Qhb;
                                    d.a += '[^';
                                    for(b = 0; b < this.b.length; b += 2){
                                        (a & gwe) != 0 && b > 0 && (d.a += ',', d);
                                        if (this.b[b] === this.b[b + 1]) Nhb(d, zte(this.b[b]));
                                        else {
                                            Nhb(d, zte(this.b[b]));
                                            d.a += '-';
                                            Nhb(d, zte(this.b[b + 1]));
                                        }
                                    }
                                    d.a += ']';
                                    c = d.a;
                                }
                            }
                            return c;
                        };
                        _.a = false;
                        _.c = false;
                        var edb = sfb(LLe, 'RegEx/RangeToken', 138);
                        feb(592, 1, {
                            592: 1
                        }, Bte);
                        _.a = 0;
                        var fdb = sfb(LLe, 'RegEx/RegexParser/ReferencePosition', 592);
                        feb(591, 1, {
                            3: 1,
                            591: 1
                        }, Dte);
                        _.Fb = function Ete(a) {
                            var b;
                            if (a == null) return false;
                            if (!ZD(a, 591)) return false;
                            b = RD(a, 591);
                            return lhb(this.b, b.b) && this.a == b.a;
                        };
                        _.Hb = function Fte() {
                            return ohb(this.b + '/' + pse(this.a));
                        };
                        _.Ib = function Gte() {
                            return this.c.Qm(this.a);
                        };
                        _.a = 0;
                        var hdb = sfb(LLe, 'RegEx/RegularExpression', 591);
                        feb(228, 122, ZLe, Hte);
                        _.Km = function Ite() {
                            return this.a;
                        };
                        _.Qm = function Jte(a) {
                            var b, c, d;
                            switch(this.e){
                                case 0:
                                    switch(this.a){
                                        case 124:
                                        case 42:
                                        case 43:
                                        case 63:
                                        case 40:
                                        case 41:
                                        case 46:
                                        case 91:
                                        case 123:
                                        case 92:
                                            d = '\\' + XD(this.a & Bwe);
                                            break;
                                        case 12:
                                            d = '\\f';
                                            break;
                                        case 10:
                                            d = '\\n';
                                            break;
                                        case 13:
                                            d = '\\r';
                                            break;
                                        case 9:
                                            d = '\\t';
                                            break;
                                        case 27:
                                            d = '\\e';
                                            break;
                                        default:
                                            if (this.a >= txe) {
                                                c = (b = this.a >>> 0, '0' + b.toString(16));
                                                d = '\\v' + zhb(c, c.length - 6, c.length);
                                            } else d = '' + XD(this.a & Bwe);
                                    }
                                    break;
                                case 8:
                                    this == Gse || this == Hse ? d = '' + XD(this.a & Bwe) : d = '\\' + XD(this.a & Bwe);
                                    break;
                                default:
                                    d = null;
                            }
                            return d;
                        };
                        _.a = 0;
                        var idb = sfb(LLe, 'RegEx/Token/CharToken', 228);
                        feb(318, 122, ZLe, Kte);
                        _.Lm = function Lte(a) {
                            return this.a;
                        };
                        _.Nm = function Mte(a) {
                            this.b = a;
                        };
                        _.Om = function Nte(a) {
                            this.c = a;
                        };
                        _.Pm = function Ote() {
                            return 1;
                        };
                        _.Qm = function Pte(a) {
                            var b;
                            if (this.e == 3) {
                                if (this.c < 0 && this.b < 0) b = this.a.Qm(a) + '*';
                                else if (this.c == this.b) b = this.a.Qm(a) + '{' + this.c + '}';
                                else if (this.c >= 0 && this.b >= 0) b = this.a.Qm(a) + '{' + this.c + ',' + this.b + '}';
                                else if (this.c >= 0 && this.b < 0) b = this.a.Qm(a) + '{' + this.c + ',}';
                                else throw Adb(new yz('Token#toString(): CLOSURE ' + this.c + pve + this.b));
                            } else {
                                if (this.c < 0 && this.b < 0) b = this.a.Qm(a) + '*?';
                                else if (this.c == this.b) b = this.a.Qm(a) + '{' + this.c + '}?';
                                else if (this.c >= 0 && this.b >= 0) b = this.a.Qm(a) + '{' + this.c + ',' + this.b + '}?';
                                else if (this.c >= 0 && this.b < 0) b = this.a.Qm(a) + '{' + this.c + ',}?';
                                else throw Adb(new yz('Token#toString(): NONGREEDYCLOSURE ' + this.c + pve + this.b));
                            }
                            return b;
                        };
                        _.b = 0;
                        _.c = 0;
                        var jdb = sfb(LLe, 'RegEx/Token/ClosureToken', 318);
                        feb(837, 122, ZLe, Qte);
                        _.Lm = function Rte(a) {
                            return a == 0 ? this.a : this.b;
                        };
                        _.Pm = function Ste() {
                            return 2;
                        };
                        _.Qm = function Tte(a) {
                            var b;
                            this.b.e == 3 && this.b.Lm(0) == this.a ? b = this.a.Qm(a) + '+' : this.b.e == 9 && this.b.Lm(0) == this.a ? b = this.a.Qm(a) + '+?' : b = this.a.Qm(a) + ('' + this.b.Qm(a));
                            return b;
                        };
                        var kdb = sfb(LLe, 'RegEx/Token/ConcatToken', 837);
                        feb(1945, 122, ZLe, Ute);
                        _.Lm = function Vte(a) {
                            if (a == 0) return this.d;
                            if (a == 1) return this.b;
                            throw Adb(new yz('Internal Error: ' + a));
                        };
                        _.Pm = function Wte() {
                            return !this.b ? 1 : 2;
                        };
                        _.Qm = function Xte(a) {
                            var b;
                            this.c > 0 ? b = '(?(' + this.c + ')' : this.a.e == 8 ? b = '(?(' + this.a + ')' : b = '(?' + this.a;
                            !this.b ? b += this.d + ')' : b += this.d + '|' + this.b + ')';
                            return b;
                        };
                        _.c = 0;
                        var ldb = sfb(LLe, 'RegEx/Token/ConditionToken', 1945);
                        feb(1946, 122, ZLe, Yte);
                        _.Lm = function Zte(a) {
                            return this.b;
                        };
                        _.Pm = function $te() {
                            return 1;
                        };
                        _.Qm = function _te(a) {
                            return '(?' + (this.a == 0 ? '' : pse(this.a)) + (this.c == 0 ? '' : pse(this.c)) + ':' + this.b.Qm(a) + ')';
                        };
                        _.a = 0;
                        _.c = 0;
                        var mdb = sfb(LLe, 'RegEx/Token/ModifierToken', 1946);
                        feb(838, 122, ZLe, aue);
                        _.Lm = function bue(a) {
                            return this.a;
                        };
                        _.Pm = function cue() {
                            return 1;
                        };
                        _.Qm = function due(a) {
                            var b;
                            b = null;
                            switch(this.e){
                                case 6:
                                    this.b == 0 ? b = '(?:' + this.a.Qm(a) + ')' : b = '(' + this.a.Qm(a) + ')';
                                    break;
                                case 20:
                                    b = '(?=' + this.a.Qm(a) + ')';
                                    break;
                                case 21:
                                    b = '(?!' + this.a.Qm(a) + ')';
                                    break;
                                case 22:
                                    b = '(?<=' + this.a.Qm(a) + ')';
                                    break;
                                case 23:
                                    b = '(?<!' + this.a.Qm(a) + ')';
                                    break;
                                case 24:
                                    b = '(?>' + this.a.Qm(a) + ')';
                            }
                            return b;
                        };
                        _.b = 0;
                        var ndb = sfb(LLe, 'RegEx/Token/ParenToken', 838);
                        feb(530, 122, {
                            3: 1,
                            122: 1,
                            530: 1
                        }, eue);
                        _.Mm = function fue() {
                            return this.b;
                        };
                        _.Qm = function gue(a) {
                            return this.e == 12 ? '\\' + this.a : tse(this.b);
                        };
                        _.a = 0;
                        var odb = sfb(LLe, 'RegEx/Token/StringToken', 530);
                        feb(477, 122, ZLe, iue);
                        _.Jm = function jue(a) {
                            hue(this, a);
                        };
                        _.Lm = function kue(a) {
                            return RD(eyb(this.a, a), 122);
                        };
                        _.Pm = function lue() {
                            return !this.a ? 0 : this.a.a.c.length;
                        };
                        _.Qm = function mue(a) {
                            var b, c, d, e, f;
                            if (this.e == 1) {
                                if (this.a.a.c.length == 2) {
                                    b = RD(eyb(this.a, 0), 122);
                                    c = RD(eyb(this.a, 1), 122);
                                    c.e == 3 && c.Lm(0) == b ? e = b.Qm(a) + '+' : c.e == 9 && c.Lm(0) == b ? e = b.Qm(a) + '+?' : e = b.Qm(a) + ('' + c.Qm(a));
                                } else {
                                    f = new Qhb;
                                    for(d = 0; d < this.a.a.c.length; d++)Nhb(f, RD(eyb(this.a, d), 122).Qm(a));
                                    e = f.a;
                                }
                                return e;
                            }
                            if (this.a.a.c.length == 2 && RD(eyb(this.a, 1), 122).e == 7) e = RD(eyb(this.a, 0), 122).Qm(a) + '?';
                            else if (this.a.a.c.length == 2 && RD(eyb(this.a, 0), 122).e == 7) e = RD(eyb(this.a, 1), 122).Qm(a) + '??';
                            else {
                                f = new Qhb;
                                Nhb(f, RD(eyb(this.a, 0), 122).Qm(a));
                                for(d = 1; d < this.a.a.c.length; d++){
                                    f.a += '|';
                                    Nhb(f, RD(eyb(this.a, d), 122).Qm(a));
                                }
                                e = f.a;
                            }
                            return e;
                        };
                        var pdb = sfb(LLe, 'RegEx/Token/UnionToken', 477);
                        feb(527, 1, {
                            600: 1
                        }, oue);
                        _.Ib = function pue() {
                            return this.a.b;
                        };
                        var rdb = sfb($Le, 'XMLTypeUtil/PatternMatcherImpl', 527);
                        feb(1707, 1527, {}, sue);
                        var que;
                        var sdb = sfb($Le, 'XMLTypeValidator', 1707);
                        feb(270, 1, Vve, vue);
                        _.Jc = function wue(a) {
                            xgb(this, a);
                        };
                        _.Kc = function xue() {
                            return (this.b - this.a) * this.c < 0 ? tue : new Rue(this);
                        };
                        _.a = 0;
                        _.b = 0;
                        _.c = 0;
                        var tue;
                        var vdb = sfb(aMe, 'ExclusiveRange', 270);
                        feb(1084, 1, Jve, Cue);
                        _.Rb = function Due(a) {
                            RD(a, 17);
                            yue();
                        };
                        _.Nb = function Eue(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function Hue() {
                            return zue();
                        };
                        _.Ub = function Jue() {
                            return Aue();
                        };
                        _.Wb = function Mue(a) {
                            RD(a, 17);
                            Bue();
                        };
                        _.Ob = function Fue() {
                            return false;
                        };
                        _.Sb = function Gue() {
                            return false;
                        };
                        _.Tb = function Iue() {
                            return -1;
                        };
                        _.Vb = function Kue() {
                            return -1;
                        };
                        _.Qb = function Lue() {
                            throw Adb(new kib(dMe));
                        };
                        var tdb = sfb(aMe, 'ExclusiveRange/1', 1084);
                        feb(258, 1, Jve, Rue);
                        _.Rb = function Sue(a) {
                            RD(a, 17);
                            Nue();
                        };
                        _.Nb = function Tue(a) {
                            Ztb(this, a);
                        };
                        _.Pb = function Wue() {
                            return Oue(this);
                        };
                        _.Ub = function Yue() {
                            return Pue(this);
                        };
                        _.Wb = function _ue(a) {
                            RD(a, 17);
                            Que();
                        };
                        _.Ob = function Uue() {
                            return this.c.c < 0 ? this.a >= this.c.b : this.a <= this.c.b;
                        };
                        _.Sb = function Vue() {
                            return this.b > 0;
                        };
                        _.Tb = function Xue() {
                            return this.b;
                        };
                        _.Vb = function Zue() {
                            return this.b - 1;
                        };
                        _.Qb = function $ue() {
                            throw Adb(new kib(dMe));
                        };
                        _.a = 0;
                        _.b = 0;
                        var udb = sfb(aMe, 'ExclusiveRange/RangeIterator', 258);
                        var hE = vfb(eKe, 'C');
                        var kE = vfb(hKe, 'I');
                        var xdb = vfb(hve, 'Z');
                        var lE = vfb(iKe, 'J');
                        var gE = vfb(dKe, 'B');
                        var iE = vfb(fKe, 'D');
                        var jE = vfb(gKe, 'F');
                        var wdb = vfb(jKe, 'S');
                        var g3 = ufb('org.eclipse.elk.core.labels', 'ILabelManager');
                        var T6 = ufb(sIe, 'DiagnosticChain');
                        var zab = ufb(QKe, 'ResourceSet');
                        var $6 = sfb(sIe, 'InvocationTargetException', null);
                        var fve = (Qz(), Tz);
                        var gwtOnLoad = gwtOnLoad = ceb;
                        aeb(leb);
                        deb('permProps', [
                            [
                                [
                                    'locale',
                                    'default'
                                ],
                                [
                                    eMe,
                                    'gecko1_8'
                                ]
                            ],
                            [
                                [
                                    'locale',
                                    'default'
                                ],
                                [
                                    eMe,
                                    'safari'
                                ]
                            ]
                        ]);
                        // --------------    RUN GWT INITIALIZATION CODE    -------------- 
                        gwtOnLoad(null, 'elk', null);
                    }).call(this);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        3: [
            function(require1, module1, exports) {
                'use strict';
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _possibleConstructorReturn(self1, call) {
                    if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return call && (typeof call === "object" || typeof call === "function") ? call : self1;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                /*******************************************************************************
 * Copyright (c) 2021 Kiel University and others.
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 * 
 * SPDX-License-Identifier: EPL-2.0
 *******************************************************************************/ var ELK = require1('./elk-api.js').default;
                var ELKNode = function(_ELK) {
                    _inherits(ELKNode, _ELK);
                    function ELKNode() {
                        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        _classCallCheck(this, ELKNode);
                        var optionsClone = Object.assign({}, options);
                        var workerThreadsExist = false;
                        try {
                            require1.resolve('web-worker');
                            workerThreadsExist = true;
                        } catch (e) {}
                        // user requested a worker
                        if (options.workerUrl) {
                            if (workerThreadsExist) {
                                var Worker1 = require1('web-worker');
                                optionsClone.workerFactory = function(url) {
                                    return new Worker1(url);
                                };
                            } else console.warn('Web worker requested but \'web-worker\' package not installed. \nConsider installing the package or pass your own \'workerFactory\' to ELK\'s constructor.\n... Falling back to non-web worker version.');
                        }
                        // unless no other workerFactory is registered, use the fake worker
                        if (!optionsClone.workerFactory) {
                            var _require = require1('./elk-worker.min.js'), _Worker = _require.Worker;
                            optionsClone.workerFactory = function(url) {
                                return new _Worker(url);
                            };
                        }
                        return _possibleConstructorReturn(this, (ELKNode.__proto__ || Object.getPrototypeOf(ELKNode)).call(this, optionsClone));
                    }
                    return ELKNode;
                }(ELK);
                Object.defineProperty(module1.exports, "__esModule", {
                    value: true
                });
                module1.exports = ELKNode;
                ELKNode.default = ELKNode;
            },
            {
                "./elk-api.js": 1,
                "./elk-worker.min.js": 2,
                "web-worker": 4
            }
        ],
        4: [
            function(require1, module1, exports) {
                /**
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ module1.exports = Worker;
            },
            {}
        ]
    }, {}, [
        3
    ])(3);
});

});

parcelRegister("7l4g1", function(module, exports) {
"use strict";
function $557dcc03fa7b5dc4$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$557dcc03fa7b5dc4$var$__export((parcelRequire("k8Zr7")));

$557dcc03fa7b5dc4$var$__export((parcelRequire("iSn6X")));

$557dcc03fa7b5dc4$var$__export((parcelRequire("2tXhu")));

$557dcc03fa7b5dc4$var$__export((parcelRequire("jcvgO")));

$557dcc03fa7b5dc4$var$__export((parcelRequire("hncMr")));

$557dcc03fa7b5dc4$var$__export((parcelRequire("7Zh26")));

$557dcc03fa7b5dc4$var$__export((parcelRequire("7Nh9M")));

$557dcc03fa7b5dc4$var$__export((parcelRequire("cM6Dg")));

$557dcc03fa7b5dc4$var$__export((parcelRequire("7PlJY")));

$557dcc03fa7b5dc4$var$__export((parcelRequire("cakcO")));

$557dcc03fa7b5dc4$var$__export((parcelRequire("862i5")));

$557dcc03fa7b5dc4$var$__export((parcelRequire("5sPP5")));

$557dcc03fa7b5dc4$var$__export((parcelRequire("3Ag7S")));

$557dcc03fa7b5dc4$var$__export((parcelRequire("6PjXM")));

$557dcc03fa7b5dc4$var$__export((parcelRequire("avbEL")));

$557dcc03fa7b5dc4$var$__export((parcelRequire("2rXqV")));

});
parcelRegister("k8Zr7", function(module, exports) {
"use strict";
var $eaa435fc3bc76794$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7Nh9M = parcelRequire("7Nh9M");
var $eaa435fc3bc76794$var$LayoutAdaptor = function(_super) {
    $eaa435fc3bc76794$var$__extends(LayoutAdaptor, _super);
    function LayoutAdaptor(options) {
        var _this = _super.call(this) || this;
        var self = _this;
        var o = options;
        if (o.trigger) _this.trigger = o.trigger;
        if (o.kick) _this.kick = o.kick;
        if (o.drag) _this.drag = o.drag;
        if (o.on) _this.on = o.on;
        _this.dragstart = _this.dragStart = $7Nh9M.Layout.dragStart;
        _this.dragend = _this.dragEnd = $7Nh9M.Layout.dragEnd;
        return _this;
    }
    LayoutAdaptor.prototype.trigger = function(e) {};
    LayoutAdaptor.prototype.kick = function() {};
    LayoutAdaptor.prototype.drag = function() {};
    LayoutAdaptor.prototype.on = function(eventType, listener) {
        return this;
    };
    return LayoutAdaptor;
}($7Nh9M.Layout);
module.exports.LayoutAdaptor = $eaa435fc3bc76794$var$LayoutAdaptor;
function $eaa435fc3bc76794$var$adaptor(options) {
    return new $eaa435fc3bc76794$var$LayoutAdaptor(options);
}
module.exports.adaptor = $eaa435fc3bc76794$var$adaptor;

});
parcelRegister("7Nh9M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cakcO = parcelRequire("cakcO");

var $7PlJY = parcelRequire("7PlJY");

var $2tXhu = parcelRequire("2tXhu");

var $3Ag7S = parcelRequire("3Ag7S");

var $6PjXM = parcelRequire("6PjXM");

var $jcvgO = parcelRequire("jcvgO");

var $7Zh26 = parcelRequire("7Zh26");
var $5aca6af9562b8a15$var$EventType;
(function(EventType) {
    EventType[EventType["start"] = 0] = "start";
    EventType[EventType["tick"] = 1] = "tick";
    EventType[EventType["end"] = 2] = "end";
})($5aca6af9562b8a15$var$EventType = module.exports.EventType || (module.exports.EventType = {}));
function $5aca6af9562b8a15$var$isGroup(g) {
    return typeof g.leaves !== 'undefined' || typeof g.groups !== 'undefined';
}
var $5aca6af9562b8a15$var$Layout = function() {
    function Layout() {
        var _this = this;
        this._canvasSize = [
            1,
            1
        ];
        this._linkDistance = 20;
        this._defaultNodeSize = 10;
        this._linkLengthCalculator = null;
        this._linkType = null;
        this._avoidOverlaps = false;
        this._handleDisconnected = true;
        this._running = false;
        this._nodes = [];
        this._groups = [];
        this._rootGroup = null;
        this._links = [];
        this._constraints = [];
        this._distanceMatrix = null;
        this._descent = null;
        this._directedLinkConstraints = null;
        this._threshold = 0.01;
        this._visibilityGraph = null;
        this._groupCompactness = 1e-6;
        this.event = null;
        this.linkAccessor = {
            getSourceIndex: Layout.getSourceIndex,
            getTargetIndex: Layout.getTargetIndex,
            setLength: Layout.setLinkLength,
            getType: function(l) {
                return typeof _this._linkType === "function" ? _this._linkType(l) : 0;
            }
        };
    }
    Layout.prototype.on = function(e, listener) {
        if (!this.event) this.event = {};
        if (typeof e === 'string') this.event[$5aca6af9562b8a15$var$EventType[e]] = listener;
        else this.event[e] = listener;
        return this;
    };
    Layout.prototype.trigger = function(e) {
        if (this.event && typeof this.event[e.type] !== 'undefined') this.event[e.type](e);
    };
    Layout.prototype.kick = function() {
        while(!this.tick());
    };
    Layout.prototype.tick = function() {
        if (this._alpha < this._threshold) {
            this._running = false;
            this.trigger({
                type: $5aca6af9562b8a15$var$EventType.end,
                alpha: this._alpha = 0,
                stress: this._lastStress
            });
            return true;
        }
        var n = this._nodes.length, m = this._links.length;
        var o, i;
        this._descent.locks.clear();
        for(i = 0; i < n; ++i){
            o = this._nodes[i];
            if (o.fixed) {
                if (typeof o.px === 'undefined' || typeof o.py === 'undefined') {
                    o.px = o.x;
                    o.py = o.y;
                }
                var p = [
                    o.px,
                    o.py
                ];
                this._descent.locks.add(i, p);
            }
        }
        var s1 = this._descent.rungeKutta();
        if (s1 === 0) this._alpha = 0;
        else if (typeof this._lastStress !== 'undefined') this._alpha = s1;
        this._lastStress = s1;
        this.updateNodePositions();
        this.trigger({
            type: $5aca6af9562b8a15$var$EventType.tick,
            alpha: this._alpha,
            stress: this._lastStress
        });
        return false;
    };
    Layout.prototype.updateNodePositions = function() {
        var x = this._descent.x[0], y = this._descent.x[1];
        var o, i = this._nodes.length;
        while(i--){
            o = this._nodes[i];
            o.x = x[i];
            o.y = y[i];
        }
    };
    Layout.prototype.nodes = function(v) {
        if (!v) {
            if (this._nodes.length === 0 && this._links.length > 0) {
                var n = 0;
                this._links.forEach(function(l) {
                    n = Math.max(n, l.source, l.target);
                });
                this._nodes = new Array(++n);
                for(var i = 0; i < n; ++i)this._nodes[i] = {};
            }
            return this._nodes;
        }
        this._nodes = v;
        return this;
    };
    Layout.prototype.groups = function(x) {
        var _this = this;
        if (!x) return this._groups;
        this._groups = x;
        this._rootGroup = {};
        this._groups.forEach(function(g) {
            if (typeof g.padding === "undefined") g.padding = 1;
            if (typeof g.leaves !== "undefined") g.leaves.forEach(function(v, i) {
                if (typeof v === 'number') (g.leaves[i] = _this._nodes[v]).parent = g;
            });
            if (typeof g.groups !== "undefined") g.groups.forEach(function(gi, i) {
                if (typeof gi === 'number') (g.groups[i] = _this._groups[gi]).parent = g;
            });
        });
        this._rootGroup.leaves = this._nodes.filter(function(v) {
            return typeof v.parent === 'undefined';
        });
        this._rootGroup.groups = this._groups.filter(function(g) {
            return typeof g.parent === 'undefined';
        });
        return this;
    };
    Layout.prototype.powerGraphGroups = function(f) {
        var g = $cakcO.getGroups(this._nodes, this._links, this.linkAccessor, this._rootGroup);
        this.groups(g.groups);
        f(g);
        return this;
    };
    Layout.prototype.avoidOverlaps = function(v) {
        if (!arguments.length) return this._avoidOverlaps;
        this._avoidOverlaps = v;
        return this;
    };
    Layout.prototype.handleDisconnected = function(v) {
        if (!arguments.length) return this._handleDisconnected;
        this._handleDisconnected = v;
        return this;
    };
    Layout.prototype.flowLayout = function(axis, minSeparation) {
        if (!arguments.length) axis = 'y';
        this._directedLinkConstraints = {
            axis: axis,
            getMinSeparation: typeof minSeparation === 'number' ? function() {
                return minSeparation;
            } : minSeparation
        };
        return this;
    };
    Layout.prototype.links = function(x) {
        if (!arguments.length) return this._links;
        this._links = x;
        return this;
    };
    Layout.prototype.constraints = function(c) {
        if (!arguments.length) return this._constraints;
        this._constraints = c;
        return this;
    };
    Layout.prototype.distanceMatrix = function(d) {
        if (!arguments.length) return this._distanceMatrix;
        this._distanceMatrix = d;
        return this;
    };
    Layout.prototype.size = function(x) {
        if (!x) return this._canvasSize;
        this._canvasSize = x;
        return this;
    };
    Layout.prototype.defaultNodeSize = function(x) {
        if (!x) return this._defaultNodeSize;
        this._defaultNodeSize = x;
        return this;
    };
    Layout.prototype.groupCompactness = function(x) {
        if (!x) return this._groupCompactness;
        this._groupCompactness = x;
        return this;
    };
    Layout.prototype.linkDistance = function(x) {
        if (!x) return this._linkDistance;
        this._linkDistance = typeof x === "function" ? x : +x;
        this._linkLengthCalculator = null;
        return this;
    };
    Layout.prototype.linkType = function(f) {
        this._linkType = f;
        return this;
    };
    Layout.prototype.convergenceThreshold = function(x) {
        if (!x) return this._threshold;
        this._threshold = typeof x === "function" ? x : +x;
        return this;
    };
    Layout.prototype.alpha = function(x) {
        if (!arguments.length) return this._alpha;
        else {
            x = +x;
            if (this._alpha) {
                if (x > 0) this._alpha = x;
                else this._alpha = 0;
            } else if (x > 0) {
                if (!this._running) {
                    this._running = true;
                    this.trigger({
                        type: $5aca6af9562b8a15$var$EventType.start,
                        alpha: this._alpha = x
                    });
                    this.kick();
                }
            }
            return this;
        }
    };
    Layout.prototype.getLinkLength = function(link) {
        return typeof this._linkDistance === "function" ? +this._linkDistance(link) : this._linkDistance;
    };
    Layout.setLinkLength = function(link, length) {
        link.length = length;
    };
    Layout.prototype.getLinkType = function(link) {
        return typeof this._linkType === "function" ? this._linkType(link) : 0;
    };
    Layout.prototype.symmetricDiffLinkLengths = function(idealLength, w) {
        var _this = this;
        if (w === void 0) w = 1;
        this.linkDistance(function(l) {
            return idealLength * l.length;
        });
        this._linkLengthCalculator = function() {
            return $7PlJY.symmetricDiffLinkLengths(_this._links, _this.linkAccessor, w);
        };
        return this;
    };
    Layout.prototype.jaccardLinkLengths = function(idealLength, w) {
        var _this = this;
        if (w === void 0) w = 1;
        this.linkDistance(function(l) {
            return idealLength * l.length;
        });
        this._linkLengthCalculator = function() {
            return $7PlJY.jaccardLinkLengths(_this._links, _this.linkAccessor, w);
        };
        return this;
    };
    Layout.prototype.start = function(initialUnconstrainedIterations, initialUserConstraintIterations, initialAllConstraintsIterations, gridSnapIterations, keepRunning, centerGraph) {
        var _this = this;
        if (initialUnconstrainedIterations === void 0) initialUnconstrainedIterations = 0;
        if (initialUserConstraintIterations === void 0) initialUserConstraintIterations = 0;
        if (initialAllConstraintsIterations === void 0) initialAllConstraintsIterations = 0;
        if (gridSnapIterations === void 0) gridSnapIterations = 0;
        if (keepRunning === void 0) keepRunning = true;
        if (centerGraph === void 0) centerGraph = true;
        var i, j, n = this.nodes().length, N = n + 2 * this._groups.length, m = this._links.length, w = this._canvasSize[0], h = this._canvasSize[1];
        var x = new Array(N), y = new Array(N);
        var G = null;
        var ao = this._avoidOverlaps;
        this._nodes.forEach(function(v, i) {
            v.index = i;
            if (typeof v.x === 'undefined') v.x = w / 2, v.y = h / 2;
            x[i] = v.x, y[i] = v.y;
        });
        if (this._linkLengthCalculator) this._linkLengthCalculator();
        var distances;
        if (this._distanceMatrix) distances = this._distanceMatrix;
        else {
            distances = new $6PjXM.Calculator(N, this._links, Layout.getSourceIndex, Layout.getTargetIndex, function(l) {
                return _this.getLinkLength(l);
            }).DistanceMatrix();
            G = $2tXhu.Descent.createSquareMatrix(N, function() {
                return 2;
            });
            this._links.forEach(function(l) {
                if (typeof l.source == "number") l.source = _this._nodes[l.source];
                if (typeof l.target == "number") l.target = _this._nodes[l.target];
            });
            this._links.forEach(function(e) {
                var u = Layout.getSourceIndex(e), v = Layout.getTargetIndex(e);
                G[u][v] = G[v][u] = e.weight || 1;
            });
        }
        var D = $2tXhu.Descent.createSquareMatrix(N, function(i, j) {
            return distances[i][j];
        });
        if (this._rootGroup && typeof this._rootGroup.groups !== 'undefined') {
            var i = n;
            var addAttraction = function(i, j, strength, idealDistance) {
                G[i][j] = G[j][i] = strength;
                D[i][j] = D[j][i] = idealDistance;
            };
            this._groups.forEach(function(g) {
                addAttraction(i, i + 1, _this._groupCompactness, 0.1);
                x[i] = 0, y[i++] = 0;
                x[i] = 0, y[i++] = 0;
            });
        } else this._rootGroup = {
            leaves: this._nodes,
            groups: []
        };
        var curConstraints = this._constraints || [];
        if (this._directedLinkConstraints) {
            this.linkAccessor.getMinSeparation = this._directedLinkConstraints.getMinSeparation;
            curConstraints = curConstraints.concat($7PlJY.generateDirectedEdgeConstraints(n, this._links, this._directedLinkConstraints.axis, this.linkAccessor));
        }
        this.avoidOverlaps(false);
        this._descent = new $2tXhu.Descent([
            x,
            y
        ], D);
        this._descent.locks.clear();
        for(var i = 0; i < n; ++i){
            var o = this._nodes[i];
            if (o.fixed) {
                o.px = o.x;
                o.py = o.y;
                var p = [
                    o.x,
                    o.y
                ];
                this._descent.locks.add(i, p);
            }
        }
        this._descent.threshold = this._threshold;
        this.initialLayout(initialUnconstrainedIterations, x, y);
        if (curConstraints.length > 0) this._descent.project = new $3Ag7S.Projection(this._nodes, this._groups, this._rootGroup, curConstraints).projectFunctions();
        this._descent.run(initialUserConstraintIterations);
        this.separateOverlappingComponents(w, h, centerGraph);
        this.avoidOverlaps(ao);
        if (ao) {
            this._nodes.forEach(function(v, i) {
                v.x = x[i], v.y = y[i];
            });
            this._descent.project = new $3Ag7S.Projection(this._nodes, this._groups, this._rootGroup, curConstraints, true).projectFunctions();
            this._nodes.forEach(function(v, i) {
                x[i] = v.x, y[i] = v.y;
            });
        }
        this._descent.G = G;
        this._descent.run(initialAllConstraintsIterations);
        if (gridSnapIterations) {
            this._descent.snapStrength = 1000;
            this._descent.snapGridSize = this._nodes[0].width;
            this._descent.numGridSnapNodes = n;
            this._descent.scaleSnapByMaxH = n != N;
            var G0 = $2tXhu.Descent.createSquareMatrix(N, function(i, j) {
                if (i >= n || j >= n) return G[i][j];
                return 0;
            });
            this._descent.G = G0;
            this._descent.run(gridSnapIterations);
        }
        this.updateNodePositions();
        this.separateOverlappingComponents(w, h, centerGraph);
        return keepRunning ? this.resume() : this;
    };
    Layout.prototype.initialLayout = function(iterations, x, y) {
        if (this._groups.length > 0 && iterations > 0) {
            var n = this._nodes.length;
            var edges = this._links.map(function(e) {
                return {
                    source: e.source.index,
                    target: e.target.index
                };
            });
            var vs = this._nodes.map(function(v) {
                return {
                    index: v.index
                };
            });
            this._groups.forEach(function(g, i) {
                vs.push({
                    index: g.index = n + i
                });
            });
            this._groups.forEach(function(g, i) {
                if (typeof g.leaves !== 'undefined') g.leaves.forEach(function(v) {
                    return edges.push({
                        source: g.index,
                        target: v.index
                    });
                });
                if (typeof g.groups !== 'undefined') g.groups.forEach(function(gg) {
                    return edges.push({
                        source: g.index,
                        target: gg.index
                    });
                });
            });
            new Layout().size(this.size()).nodes(vs).links(edges).avoidOverlaps(false).linkDistance(this.linkDistance()).symmetricDiffLinkLengths(5).convergenceThreshold(1e-4).start(iterations, 0, 0, 0, false);
            this._nodes.forEach(function(v) {
                x[v.index] = vs[v.index].x;
                y[v.index] = vs[v.index].y;
            });
        } else this._descent.run(iterations);
    };
    Layout.prototype.separateOverlappingComponents = function(width, height, centerGraph) {
        var _this = this;
        if (centerGraph === void 0) centerGraph = true;
        if (!this._distanceMatrix && this._handleDisconnected) {
            var x_1 = this._descent.x[0], y_1 = this._descent.x[1];
            this._nodes.forEach(function(v, i) {
                v.x = x_1[i], v.y = y_1[i];
            });
            var graphs = $7Zh26.separateGraphs(this._nodes, this._links);
            $7Zh26.applyPacking(graphs, width, height, this._defaultNodeSize, 1, centerGraph);
            this._nodes.forEach(function(v, i) {
                _this._descent.x[0][i] = v.x, _this._descent.x[1][i] = v.y;
                if (v.bounds) {
                    v.bounds.setXCentre(v.x);
                    v.bounds.setYCentre(v.y);
                }
            });
        }
    };
    Layout.prototype.resume = function() {
        return this.alpha(0.1);
    };
    Layout.prototype.stop = function() {
        return this.alpha(0);
    };
    Layout.prototype.prepareEdgeRouting = function(nodeMargin) {
        if (nodeMargin === void 0) nodeMargin = 0;
        this._visibilityGraph = new $jcvgO.TangentVisibilityGraph(this._nodes.map(function(v) {
            return v.bounds.inflate(-nodeMargin).vertices();
        }));
    };
    Layout.prototype.routeEdge = function(edge, ah, draw) {
        if (ah === void 0) ah = 5;
        var lineData = [];
        var vg2 = new $jcvgO.TangentVisibilityGraph(this._visibilityGraph.P, {
            V: this._visibilityGraph.V,
            E: this._visibilityGraph.E
        }), port1 = {
            x: edge.source.x,
            y: edge.source.y
        }, port2 = {
            x: edge.target.x,
            y: edge.target.y
        }, start = vg2.addPoint(port1, edge.source.index), end = vg2.addPoint(port2, edge.target.index);
        vg2.addEdgeIfVisible(port1, port2, edge.source.index, edge.target.index);
        if (typeof draw !== 'undefined') draw(vg2);
        var sourceInd = function(e) {
            return e.source.id;
        }, targetInd = function(e) {
            return e.target.id;
        }, length = function(e) {
            return e.length();
        }, spCalc = new $6PjXM.Calculator(vg2.V.length, vg2.E, sourceInd, targetInd, length), shortestPath = spCalc.PathFromNodeToNode(start.id, end.id);
        if (shortestPath.length === 1 || shortestPath.length === vg2.V.length) {
            var route = $3Ag7S.makeEdgeBetween(edge.source.innerBounds, edge.target.innerBounds, ah);
            lineData = [
                route.sourceIntersection,
                route.arrowStart
            ];
        } else {
            var n = shortestPath.length - 2, p = vg2.V[shortestPath[n]].p, q = vg2.V[shortestPath[0]].p, lineData = [
                edge.source.innerBounds.rayIntersection(p.x, p.y)
            ];
            for(var i = n; i >= 0; --i)lineData.push(vg2.V[shortestPath[i]].p);
            lineData.push($3Ag7S.makeEdgeTo(q, edge.target.innerBounds, ah));
        }
        return lineData;
    };
    Layout.getSourceIndex = function(e) {
        return typeof e.source === 'number' ? e.source : e.source.index;
    };
    Layout.getTargetIndex = function(e) {
        return typeof e.target === 'number' ? e.target : e.target.index;
    };
    Layout.linkId = function(e) {
        return Layout.getSourceIndex(e) + "-" + Layout.getTargetIndex(e);
    };
    Layout.dragStart = function(d) {
        if ($5aca6af9562b8a15$var$isGroup(d)) Layout.storeOffset(d, Layout.dragOrigin(d));
        else {
            Layout.stopNode(d);
            d.fixed |= 2;
        }
    };
    Layout.stopNode = function(v) {
        v.px = v.x;
        v.py = v.y;
    };
    Layout.storeOffset = function(d, origin) {
        if (typeof d.leaves !== 'undefined') d.leaves.forEach(function(v) {
            v.fixed |= 2;
            Layout.stopNode(v);
            v._dragGroupOffsetX = v.x - origin.x;
            v._dragGroupOffsetY = v.y - origin.y;
        });
        if (typeof d.groups !== 'undefined') d.groups.forEach(function(g) {
            return Layout.storeOffset(g, origin);
        });
    };
    Layout.dragOrigin = function(d) {
        if ($5aca6af9562b8a15$var$isGroup(d)) return {
            x: d.bounds.cx(),
            y: d.bounds.cy()
        };
        else return d;
    };
    Layout.drag = function(d, position) {
        if ($5aca6af9562b8a15$var$isGroup(d)) {
            if (typeof d.leaves !== 'undefined') d.leaves.forEach(function(v) {
                d.bounds.setXCentre(position.x);
                d.bounds.setYCentre(position.y);
                v.px = v._dragGroupOffsetX + position.x;
                v.py = v._dragGroupOffsetY + position.y;
            });
            if (typeof d.groups !== 'undefined') d.groups.forEach(function(g) {
                return Layout.drag(g, position);
            });
        } else {
            d.px = position.x;
            d.py = position.y;
        }
    };
    Layout.dragEnd = function(d) {
        if ($5aca6af9562b8a15$var$isGroup(d)) {
            if (typeof d.leaves !== 'undefined') d.leaves.forEach(function(v) {
                Layout.dragEnd(v);
                delete v._dragGroupOffsetX;
                delete v._dragGroupOffsetY;
            });
            if (typeof d.groups !== 'undefined') d.groups.forEach(Layout.dragEnd);
        } else d.fixed &= -7;
    };
    Layout.mouseOver = function(d) {
        d.fixed |= 4;
        d.px = d.x, d.py = d.y;
    };
    Layout.mouseOut = function(d) {
        d.fixed &= -5;
    };
    return Layout;
}();
module.exports.Layout = $5aca6af9562b8a15$var$Layout;

});
parcelRegister("cakcO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8db6179f0934604e$var$PowerEdge = function() {
    function PowerEdge(source, target, type) {
        this.source = source;
        this.target = target;
        this.type = type;
    }
    return PowerEdge;
}();
module.exports.PowerEdge = $8db6179f0934604e$var$PowerEdge;
var $8db6179f0934604e$var$Configuration = function() {
    function Configuration(n, edges, linkAccessor, rootGroup) {
        var _this = this;
        this.linkAccessor = linkAccessor;
        this.modules = new Array(n);
        this.roots = [];
        if (rootGroup) this.initModulesFromGroup(rootGroup);
        else {
            this.roots.push(new $8db6179f0934604e$var$ModuleSet());
            for(var i = 0; i < n; ++i)this.roots[0].add(this.modules[i] = new $8db6179f0934604e$var$Module(i));
        }
        this.R = edges.length;
        edges.forEach(function(e) {
            var s = _this.modules[linkAccessor.getSourceIndex(e)], t = _this.modules[linkAccessor.getTargetIndex(e)], type = linkAccessor.getType(e);
            s.outgoing.add(type, t);
            t.incoming.add(type, s);
        });
    }
    Configuration.prototype.initModulesFromGroup = function(group) {
        var moduleSet = new $8db6179f0934604e$var$ModuleSet();
        this.roots.push(moduleSet);
        for(var i = 0; i < group.leaves.length; ++i){
            var node = group.leaves[i];
            var module = new $8db6179f0934604e$var$Module(node.id);
            this.modules[node.id] = module;
            moduleSet.add(module);
        }
        if (group.groups) for(var j = 0; j < group.groups.length; ++j){
            var child = group.groups[j];
            var definition = {};
            for(var prop in child)if (prop !== "leaves" && prop !== "groups" && child.hasOwnProperty(prop)) definition[prop] = child[prop];
            moduleSet.add(new $8db6179f0934604e$var$Module(-1 - j, new $8db6179f0934604e$var$LinkSets(), new $8db6179f0934604e$var$LinkSets(), this.initModulesFromGroup(child), definition));
        }
        return moduleSet;
    };
    Configuration.prototype.merge = function(a, b, k) {
        if (k === void 0) k = 0;
        var inInt = a.incoming.intersection(b.incoming), outInt = a.outgoing.intersection(b.outgoing);
        var children = new $8db6179f0934604e$var$ModuleSet();
        children.add(a);
        children.add(b);
        var m = new $8db6179f0934604e$var$Module(this.modules.length, outInt, inInt, children);
        this.modules.push(m);
        var update = function(s, i, o) {
            s.forAll(function(ms, linktype) {
                ms.forAll(function(n) {
                    var nls = n[i];
                    nls.add(linktype, m);
                    nls.remove(linktype, a);
                    nls.remove(linktype, b);
                    a[o].remove(linktype, n);
                    b[o].remove(linktype, n);
                });
            });
        };
        update(outInt, "incoming", "outgoing");
        update(inInt, "outgoing", "incoming");
        this.R -= inInt.count() + outInt.count();
        this.roots[k].remove(a);
        this.roots[k].remove(b);
        this.roots[k].add(m);
        return m;
    };
    Configuration.prototype.rootMerges = function(k) {
        if (k === void 0) k = 0;
        var rs = this.roots[k].modules();
        var n = rs.length;
        var merges = new Array(n * (n - 1));
        var ctr = 0;
        for(var i = 0, i_ = n - 1; i < i_; ++i)for(var j = i + 1; j < n; ++j){
            var a = rs[i], b = rs[j];
            merges[ctr] = {
                id: ctr,
                nEdges: this.nEdges(a, b),
                a: a,
                b: b
            };
            ctr++;
        }
        return merges;
    };
    Configuration.prototype.greedyMerge = function() {
        for(var i = 0; i < this.roots.length; ++i){
            if (this.roots[i].modules().length < 2) continue;
            var ms = this.rootMerges(i).sort(function(a, b) {
                return a.nEdges == b.nEdges ? a.id - b.id : a.nEdges - b.nEdges;
            });
            var m = ms[0];
            if (m.nEdges >= this.R) continue;
            this.merge(m.a, m.b, i);
            return true;
        }
    };
    Configuration.prototype.nEdges = function(a, b) {
        var inInt = a.incoming.intersection(b.incoming), outInt = a.outgoing.intersection(b.outgoing);
        return this.R - inInt.count() - outInt.count();
    };
    Configuration.prototype.getGroupHierarchy = function(retargetedEdges) {
        var _this = this;
        var groups = [];
        var root = {};
        $8db6179f0934604e$var$toGroups(this.roots[0], root, groups);
        var es = this.allEdges();
        es.forEach(function(e) {
            var a = _this.modules[e.source];
            var b = _this.modules[e.target];
            retargetedEdges.push(new $8db6179f0934604e$var$PowerEdge(typeof a.gid === "undefined" ? e.source : groups[a.gid], typeof b.gid === "undefined" ? e.target : groups[b.gid], e.type));
        });
        return groups;
    };
    Configuration.prototype.allEdges = function() {
        var es = [];
        Configuration.getEdges(this.roots[0], es);
        return es;
    };
    Configuration.getEdges = function(modules, es) {
        modules.forAll(function(m) {
            m.getEdges(es);
            Configuration.getEdges(m.children, es);
        });
    };
    return Configuration;
}();
module.exports.Configuration = $8db6179f0934604e$var$Configuration;
function $8db6179f0934604e$var$toGroups(modules, group, groups) {
    modules.forAll(function(m) {
        if (m.isLeaf()) {
            if (!group.leaves) group.leaves = [];
            group.leaves.push(m.id);
        } else {
            var g = group;
            m.gid = groups.length;
            if (!m.isIsland() || m.isPredefined()) {
                g = {
                    id: m.gid
                };
                if (m.isPredefined()) for(var prop in m.definition)g[prop] = m.definition[prop];
                if (!group.groups) group.groups = [];
                group.groups.push(m.gid);
                groups.push(g);
            }
            $8db6179f0934604e$var$toGroups(m.children, g, groups);
        }
    });
}
var $8db6179f0934604e$var$Module = function() {
    function Module(id, outgoing, incoming, children, definition) {
        if (outgoing === void 0) outgoing = new $8db6179f0934604e$var$LinkSets();
        if (incoming === void 0) incoming = new $8db6179f0934604e$var$LinkSets();
        if (children === void 0) children = new $8db6179f0934604e$var$ModuleSet();
        this.id = id;
        this.outgoing = outgoing;
        this.incoming = incoming;
        this.children = children;
        this.definition = definition;
    }
    Module.prototype.getEdges = function(es) {
        var _this = this;
        this.outgoing.forAll(function(ms, edgetype) {
            ms.forAll(function(target) {
                es.push(new $8db6179f0934604e$var$PowerEdge(_this.id, target.id, edgetype));
            });
        });
    };
    Module.prototype.isLeaf = function() {
        return this.children.count() === 0;
    };
    Module.prototype.isIsland = function() {
        return this.outgoing.count() === 0 && this.incoming.count() === 0;
    };
    Module.prototype.isPredefined = function() {
        return typeof this.definition !== "undefined";
    };
    return Module;
}();
module.exports.Module = $8db6179f0934604e$var$Module;
function $8db6179f0934604e$var$intersection(m, n) {
    var i = {};
    for(var v in m)if (v in n) i[v] = m[v];
    return i;
}
var $8db6179f0934604e$var$ModuleSet = function() {
    function ModuleSet() {
        this.table = {};
    }
    ModuleSet.prototype.count = function() {
        return Object.keys(this.table).length;
    };
    ModuleSet.prototype.intersection = function(other) {
        var result = new ModuleSet();
        result.table = $8db6179f0934604e$var$intersection(this.table, other.table);
        return result;
    };
    ModuleSet.prototype.intersectionCount = function(other) {
        return this.intersection(other).count();
    };
    ModuleSet.prototype.contains = function(id) {
        return id in this.table;
    };
    ModuleSet.prototype.add = function(m) {
        this.table[m.id] = m;
    };
    ModuleSet.prototype.remove = function(m) {
        delete this.table[m.id];
    };
    ModuleSet.prototype.forAll = function(f) {
        for(var mid in this.table)f(this.table[mid]);
    };
    ModuleSet.prototype.modules = function() {
        var vs = [];
        this.forAll(function(m) {
            if (!m.isPredefined()) vs.push(m);
        });
        return vs;
    };
    return ModuleSet;
}();
module.exports.ModuleSet = $8db6179f0934604e$var$ModuleSet;
var $8db6179f0934604e$var$LinkSets = function() {
    function LinkSets() {
        this.sets = {};
        this.n = 0;
    }
    LinkSets.prototype.count = function() {
        return this.n;
    };
    LinkSets.prototype.contains = function(id) {
        var result = false;
        this.forAllModules(function(m) {
            if (!result && m.id == id) result = true;
        });
        return result;
    };
    LinkSets.prototype.add = function(linktype, m) {
        var s = linktype in this.sets ? this.sets[linktype] : this.sets[linktype] = new $8db6179f0934604e$var$ModuleSet();
        s.add(m);
        ++this.n;
    };
    LinkSets.prototype.remove = function(linktype, m) {
        var ms = this.sets[linktype];
        ms.remove(m);
        if (ms.count() === 0) delete this.sets[linktype];
        --this.n;
    };
    LinkSets.prototype.forAll = function(f) {
        for(var linktype in this.sets)f(this.sets[linktype], Number(linktype));
    };
    LinkSets.prototype.forAllModules = function(f) {
        this.forAll(function(ms, lt) {
            return ms.forAll(f);
        });
    };
    LinkSets.prototype.intersection = function(other) {
        var result = new LinkSets();
        this.forAll(function(ms, lt) {
            if (lt in other.sets) {
                var i = ms.intersection(other.sets[lt]), n = i.count();
                if (n > 0) {
                    result.sets[lt] = i;
                    result.n += n;
                }
            }
        });
        return result;
    };
    return LinkSets;
}();
module.exports.LinkSets = $8db6179f0934604e$var$LinkSets;
function $8db6179f0934604e$var$intersectionCount(m, n) {
    return Object.keys($8db6179f0934604e$var$intersection(m, n)).length;
}
function $8db6179f0934604e$var$getGroups(nodes, links, la, rootGroup) {
    var n = nodes.length, c = new $8db6179f0934604e$var$Configuration(n, links, la, rootGroup);
    while(c.greedyMerge());
    var powerEdges = [];
    var g = c.getGroupHierarchy(powerEdges);
    powerEdges.forEach(function(e) {
        var f = function(end) {
            var g = e[end];
            if (typeof g == "number") e[end] = nodes[g];
        };
        f("source");
        f("target");
    });
    return {
        groups: g,
        powerEdges: powerEdges
    };
}
module.exports.getGroups = $8db6179f0934604e$var$getGroups;

});

parcelRegister("7PlJY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $5b2e2904daa17b42$var$unionCount(a, b) {
    var u = {};
    for(var i in a)u[i] = {};
    for(var i in b)u[i] = {};
    return Object.keys(u).length;
}
function $5b2e2904daa17b42$var$intersectionCount(a, b) {
    var n = 0;
    for(var i in a)if (typeof b[i] !== 'undefined') ++n;
    return n;
}
function $5b2e2904daa17b42$var$getNeighbours(links, la) {
    var neighbours = {};
    var addNeighbours = function(u, v) {
        if (typeof neighbours[u] === 'undefined') neighbours[u] = {};
        neighbours[u][v] = {};
    };
    links.forEach(function(e) {
        var u = la.getSourceIndex(e), v = la.getTargetIndex(e);
        addNeighbours(u, v);
        addNeighbours(v, u);
    });
    return neighbours;
}
function $5b2e2904daa17b42$var$computeLinkLengths(links, w, f, la) {
    var neighbours = $5b2e2904daa17b42$var$getNeighbours(links, la);
    links.forEach(function(l) {
        var a = neighbours[la.getSourceIndex(l)];
        var b = neighbours[la.getTargetIndex(l)];
        la.setLength(l, 1 + w * f(a, b));
    });
}
function $5b2e2904daa17b42$var$symmetricDiffLinkLengths(links, la, w) {
    if (w === void 0) w = 1;
    $5b2e2904daa17b42$var$computeLinkLengths(links, w, function(a, b) {
        return Math.sqrt($5b2e2904daa17b42$var$unionCount(a, b) - $5b2e2904daa17b42$var$intersectionCount(a, b));
    }, la);
}
module.exports.symmetricDiffLinkLengths = $5b2e2904daa17b42$var$symmetricDiffLinkLengths;
function $5b2e2904daa17b42$var$jaccardLinkLengths(links, la, w) {
    if (w === void 0) w = 1;
    $5b2e2904daa17b42$var$computeLinkLengths(links, w, function(a, b) {
        return Math.min(Object.keys(a).length, Object.keys(b).length) < 1.1 ? 0 : $5b2e2904daa17b42$var$intersectionCount(a, b) / $5b2e2904daa17b42$var$unionCount(a, b);
    }, la);
}
module.exports.jaccardLinkLengths = $5b2e2904daa17b42$var$jaccardLinkLengths;
function $5b2e2904daa17b42$var$generateDirectedEdgeConstraints(n, links, axis, la) {
    var components = $5b2e2904daa17b42$var$stronglyConnectedComponents(n, links, la);
    var nodes = {};
    components.forEach(function(c, i) {
        return c.forEach(function(v) {
            return nodes[v] = i;
        });
    });
    var constraints = [];
    links.forEach(function(l) {
        var ui = la.getSourceIndex(l), vi = la.getTargetIndex(l), u = nodes[ui], v = nodes[vi];
        if (u !== v) constraints.push({
            axis: axis,
            left: ui,
            right: vi,
            gap: la.getMinSeparation(l)
        });
    });
    return constraints;
}
module.exports.generateDirectedEdgeConstraints = $5b2e2904daa17b42$var$generateDirectedEdgeConstraints;
function $5b2e2904daa17b42$var$stronglyConnectedComponents(numVertices, edges, la) {
    var nodes = [];
    var index = 0;
    var stack = [];
    var components = [];
    function strongConnect(v) {
        v.index = v.lowlink = index++;
        stack.push(v);
        v.onStack = true;
        for(var _i = 0, _a = v.out; _i < _a.length; _i++){
            var w = _a[_i];
            if (typeof w.index === 'undefined') {
                strongConnect(w);
                v.lowlink = Math.min(v.lowlink, w.lowlink);
            } else if (w.onStack) v.lowlink = Math.min(v.lowlink, w.index);
        }
        if (v.lowlink === v.index) {
            var component = [];
            while(stack.length){
                w = stack.pop();
                w.onStack = false;
                component.push(w);
                if (w === v) break;
            }
            components.push(component.map(function(v) {
                return v.id;
            }));
        }
    }
    for(var i = 0; i < numVertices; i++)nodes.push({
        id: i,
        out: []
    });
    for(var _i = 0, edges_1 = edges; _i < edges_1.length; _i++){
        var e = edges_1[_i];
        var v_1 = nodes[la.getSourceIndex(e)], w = nodes[la.getTargetIndex(e)];
        v_1.out.push(w);
    }
    for(var _a = 0, nodes_1 = nodes; _a < nodes_1.length; _a++){
        var v = nodes_1[_a];
        if (typeof v.index === 'undefined') strongConnect(v);
    }
    return components;
}
module.exports.stronglyConnectedComponents = $5b2e2904daa17b42$var$stronglyConnectedComponents;

});

parcelRegister("2tXhu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1cec462b70f98cbf$var$Locks = function() {
    function Locks() {
        this.locks = {};
    }
    Locks.prototype.add = function(id, x) {
        this.locks[id] = x;
    };
    Locks.prototype.clear = function() {
        this.locks = {};
    };
    Locks.prototype.isEmpty = function() {
        for(var l in this.locks)return false;
        return true;
    };
    Locks.prototype.apply = function(f) {
        for(var l in this.locks)f(Number(l), this.locks[l]);
    };
    return Locks;
}();
module.exports.Locks = $1cec462b70f98cbf$var$Locks;
var $1cec462b70f98cbf$var$Descent = function() {
    function Descent(x, D, G) {
        if (G === void 0) G = null;
        this.D = D;
        this.G = G;
        this.threshold = 0.0001;
        this.numGridSnapNodes = 0;
        this.snapGridSize = 100;
        this.snapStrength = 1000;
        this.scaleSnapByMaxH = false;
        this.random = new $1cec462b70f98cbf$var$PseudoRandom();
        this.project = null;
        this.x = x;
        this.k = x.length;
        var n = this.n = x[0].length;
        this.H = new Array(this.k);
        this.g = new Array(this.k);
        this.Hd = new Array(this.k);
        this.a = new Array(this.k);
        this.b = new Array(this.k);
        this.c = new Array(this.k);
        this.d = new Array(this.k);
        this.e = new Array(this.k);
        this.ia = new Array(this.k);
        this.ib = new Array(this.k);
        this.xtmp = new Array(this.k);
        this.locks = new $1cec462b70f98cbf$var$Locks();
        this.minD = Number.MAX_VALUE;
        var i = n, j;
        while(i--){
            j = n;
            while(--j > i){
                var d = D[i][j];
                if (d > 0 && d < this.minD) this.minD = d;
            }
        }
        if (this.minD === Number.MAX_VALUE) this.minD = 1;
        i = this.k;
        while(i--){
            this.g[i] = new Array(n);
            this.H[i] = new Array(n);
            j = n;
            while(j--)this.H[i][j] = new Array(n);
            this.Hd[i] = new Array(n);
            this.a[i] = new Array(n);
            this.b[i] = new Array(n);
            this.c[i] = new Array(n);
            this.d[i] = new Array(n);
            this.e[i] = new Array(n);
            this.ia[i] = new Array(n);
            this.ib[i] = new Array(n);
            this.xtmp[i] = new Array(n);
        }
    }
    Descent.createSquareMatrix = function(n, f) {
        var M = new Array(n);
        for(var i = 0; i < n; ++i){
            M[i] = new Array(n);
            for(var j = 0; j < n; ++j)M[i][j] = f(i, j);
        }
        return M;
    };
    Descent.prototype.offsetDir = function() {
        var _this = this;
        var u = new Array(this.k);
        var l = 0;
        for(var i = 0; i < this.k; ++i){
            var x = u[i] = this.random.getNextBetween(0.01, 1) - 0.5;
            l += x * x;
        }
        l = Math.sqrt(l);
        return u.map(function(x) {
            return x *= _this.minD / l;
        });
    };
    Descent.prototype.computeDerivatives = function(x) {
        var _this = this;
        var n = this.n;
        if (n < 1) return;
        var i;
        var d = new Array(this.k);
        var d2 = new Array(this.k);
        var Huu = new Array(this.k);
        var maxH = 0;
        for(var u = 0; u < n; ++u){
            for(i = 0; i < this.k; ++i)Huu[i] = this.g[i][u] = 0;
            for(var v = 0; v < n; ++v){
                if (u === v) continue;
                var maxDisplaces = n;
                while(maxDisplaces--){
                    var sd2 = 0;
                    for(i = 0; i < this.k; ++i){
                        var dx = d[i] = x[i][u] - x[i][v];
                        sd2 += d2[i] = dx * dx;
                    }
                    if (sd2 > 1e-9) break;
                    var rd = this.offsetDir();
                    for(i = 0; i < this.k; ++i)x[i][v] += rd[i];
                }
                var l = Math.sqrt(sd2);
                var D = this.D[u][v];
                var weight = this.G != null ? this.G[u][v] : 1;
                if (weight > 1 && l > D || !isFinite(D)) {
                    for(i = 0; i < this.k; ++i)this.H[i][u][v] = 0;
                    continue;
                }
                if (weight > 1) weight = 1;
                var D2 = D * D;
                var gs = 2 * weight * (l - D) / (D2 * l);
                var l3 = l * l * l;
                var hs = 2 * -weight / (D2 * l3);
                if (!isFinite(gs)) console.log(gs);
                for(i = 0; i < this.k; ++i){
                    this.g[i][u] += d[i] * gs;
                    Huu[i] -= this.H[i][u][v] = hs * (l3 + D * (d2[i] - sd2) + l * sd2);
                }
            }
            for(i = 0; i < this.k; ++i)maxH = Math.max(maxH, this.H[i][u][u] = Huu[i]);
        }
        var r = this.snapGridSize / 2;
        var g = this.snapGridSize;
        var w = this.snapStrength;
        var k = w / (r * r);
        var numNodes = this.numGridSnapNodes;
        for(var u = 0; u < numNodes; ++u)for(i = 0; i < this.k; ++i){
            var xiu = this.x[i][u];
            var m = xiu / g;
            var f = m % 1;
            var q = m - f;
            var a = Math.abs(f);
            var dx = a <= 0.5 ? xiu - q * g : xiu > 0 ? xiu - (q + 1) * g : xiu - (q - 1) * g;
            if (-r < dx && dx <= r) {
                if (this.scaleSnapByMaxH) {
                    this.g[i][u] += maxH * k * dx;
                    this.H[i][u][u] += maxH * k;
                } else {
                    this.g[i][u] += k * dx;
                    this.H[i][u][u] += k;
                }
            }
        }
        if (!this.locks.isEmpty()) this.locks.apply(function(u, p) {
            for(i = 0; i < _this.k; ++i){
                _this.H[i][u][u] += maxH;
                _this.g[i][u] -= maxH * (p[i] - x[i][u]);
            }
        });
    };
    Descent.dotProd = function(a, b) {
        var x = 0, i = a.length;
        while(i--)x += a[i] * b[i];
        return x;
    };
    Descent.rightMultiply = function(m, v, r) {
        var i = m.length;
        while(i--)r[i] = Descent.dotProd(m[i], v);
    };
    Descent.prototype.computeStepSize = function(d) {
        var numerator = 0, denominator = 0;
        for(var i = 0; i < this.k; ++i){
            numerator += Descent.dotProd(this.g[i], d[i]);
            Descent.rightMultiply(this.H[i], d[i], this.Hd[i]);
            denominator += Descent.dotProd(d[i], this.Hd[i]);
        }
        if (denominator === 0 || !isFinite(denominator)) return 0;
        return 1 * numerator / denominator;
    };
    Descent.prototype.reduceStress = function() {
        this.computeDerivatives(this.x);
        var alpha = this.computeStepSize(this.g);
        for(var i = 0; i < this.k; ++i)this.takeDescentStep(this.x[i], this.g[i], alpha);
        return this.computeStress();
    };
    Descent.copy = function(a, b) {
        var m = a.length, n = b[0].length;
        for(var i = 0; i < m; ++i)for(var j = 0; j < n; ++j)b[i][j] = a[i][j];
    };
    Descent.prototype.stepAndProject = function(x0, r, d, stepSize) {
        Descent.copy(x0, r);
        this.takeDescentStep(r[0], d[0], stepSize);
        if (this.project) this.project[0](x0[0], x0[1], r[0]);
        this.takeDescentStep(r[1], d[1], stepSize);
        if (this.project) this.project[1](r[0], x0[1], r[1]);
        for(var i = 2; i < this.k; i++)this.takeDescentStep(r[i], d[i], stepSize);
    };
    Descent.mApply = function(m, n, f) {
        var i = m;
        while(i-- > 0){
            var j = n;
            while(j-- > 0)f(i, j);
        }
    };
    Descent.prototype.matrixApply = function(f) {
        Descent.mApply(this.k, this.n, f);
    };
    Descent.prototype.computeNextPosition = function(x0, r) {
        var _this = this;
        this.computeDerivatives(x0);
        var alpha = this.computeStepSize(this.g);
        this.stepAndProject(x0, r, this.g, alpha);
        if (this.project) {
            this.matrixApply(function(i, j) {
                return _this.e[i][j] = x0[i][j] - r[i][j];
            });
            var beta = this.computeStepSize(this.e);
            beta = Math.max(0.2, Math.min(beta, 1));
            this.stepAndProject(x0, r, this.e, beta);
        }
    };
    Descent.prototype.run = function(iterations) {
        var stress = Number.MAX_VALUE, converged = false;
        while(!converged && iterations-- > 0){
            var s = this.rungeKutta();
            converged = Math.abs(stress / s - 1) < this.threshold;
            stress = s;
        }
        return stress;
    };
    Descent.prototype.rungeKutta = function() {
        var _this = this;
        this.computeNextPosition(this.x, this.a);
        Descent.mid(this.x, this.a, this.ia);
        this.computeNextPosition(this.ia, this.b);
        Descent.mid(this.x, this.b, this.ib);
        this.computeNextPosition(this.ib, this.c);
        this.computeNextPosition(this.c, this.d);
        var disp = 0;
        this.matrixApply(function(i, j) {
            var x = (_this.a[i][j] + 2.0 * _this.b[i][j] + 2.0 * _this.c[i][j] + _this.d[i][j]) / 6.0, d = _this.x[i][j] - x;
            disp += d * d;
            _this.x[i][j] = x;
        });
        return disp;
    };
    Descent.mid = function(a, b, m) {
        Descent.mApply(a.length, a[0].length, function(i, j) {
            return m[i][j] = a[i][j] + (b[i][j] - a[i][j]) / 2.0;
        });
    };
    Descent.prototype.takeDescentStep = function(x, d, stepSize) {
        for(var i = 0; i < this.n; ++i)x[i] = x[i] - stepSize * d[i];
    };
    Descent.prototype.computeStress = function() {
        var stress = 0;
        for(var u = 0, nMinus1 = this.n - 1; u < nMinus1; ++u)for(var v = u + 1, n = this.n; v < n; ++v){
            var l = 0;
            for(var i = 0; i < this.k; ++i){
                var dx = this.x[i][u] - this.x[i][v];
                l += dx * dx;
            }
            l = Math.sqrt(l);
            var d = this.D[u][v];
            if (!isFinite(d)) continue;
            var rl = d - l;
            var d2 = d * d;
            stress += rl * rl / d2;
        }
        return stress;
    };
    Descent.zeroDistance = 1e-10;
    return Descent;
}();
module.exports.Descent = $1cec462b70f98cbf$var$Descent;
var $1cec462b70f98cbf$var$PseudoRandom = function() {
    function PseudoRandom(seed) {
        if (seed === void 0) seed = 1;
        this.seed = seed;
        this.a = 214013;
        this.c = 2531011;
        this.m = 2147483648;
        this.range = 32767;
    }
    PseudoRandom.prototype.getNext = function() {
        this.seed = (this.seed * this.a + this.c) % this.m;
        return (this.seed >> 16) / this.range;
    };
    PseudoRandom.prototype.getNextBetween = function(min, max) {
        return min + this.getNext() * (max - min);
    };
    return PseudoRandom;
}();
module.exports.PseudoRandom = $1cec462b70f98cbf$var$PseudoRandom;

});

parcelRegister("3Ag7S", function(module, exports) {
"use strict";
var $29c13e2f6e2f4cd3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $avbEL = parcelRequire("avbEL");

var $5sPP5 = parcelRequire("5sPP5");
function $29c13e2f6e2f4cd3$var$computeGroupBounds(g) {
    g.bounds = typeof g.leaves !== "undefined" ? g.leaves.reduce(function(r, c) {
        return c.bounds.union(r);
    }, $29c13e2f6e2f4cd3$var$Rectangle.empty()) : $29c13e2f6e2f4cd3$var$Rectangle.empty();
    if (typeof g.groups !== "undefined") g.bounds = g.groups.reduce(function(r, c) {
        return $29c13e2f6e2f4cd3$var$computeGroupBounds(c).union(r);
    }, g.bounds);
    g.bounds = g.bounds.inflate(g.padding);
    return g.bounds;
}
module.exports.computeGroupBounds = $29c13e2f6e2f4cd3$var$computeGroupBounds;
var $29c13e2f6e2f4cd3$var$Rectangle = function() {
    function Rectangle(x, X, y, Y) {
        this.x = x;
        this.X = X;
        this.y = y;
        this.Y = Y;
    }
    Rectangle.empty = function() {
        return new Rectangle(Number.POSITIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.POSITIVE_INFINITY, Number.NEGATIVE_INFINITY);
    };
    Rectangle.prototype.cx = function() {
        return (this.x + this.X) / 2;
    };
    Rectangle.prototype.cy = function() {
        return (this.y + this.Y) / 2;
    };
    Rectangle.prototype.overlapX = function(r) {
        var ux = this.cx(), vx = r.cx();
        if (ux <= vx && r.x < this.X) return this.X - r.x;
        if (vx <= ux && this.x < r.X) return r.X - this.x;
        return 0;
    };
    Rectangle.prototype.overlapY = function(r) {
        var uy = this.cy(), vy = r.cy();
        if (uy <= vy && r.y < this.Y) return this.Y - r.y;
        if (vy <= uy && this.y < r.Y) return r.Y - this.y;
        return 0;
    };
    Rectangle.prototype.setXCentre = function(cx) {
        var dx = cx - this.cx();
        this.x += dx;
        this.X += dx;
    };
    Rectangle.prototype.setYCentre = function(cy) {
        var dy = cy - this.cy();
        this.y += dy;
        this.Y += dy;
    };
    Rectangle.prototype.width = function() {
        return this.X - this.x;
    };
    Rectangle.prototype.height = function() {
        return this.Y - this.y;
    };
    Rectangle.prototype.union = function(r) {
        return new Rectangle(Math.min(this.x, r.x), Math.max(this.X, r.X), Math.min(this.y, r.y), Math.max(this.Y, r.Y));
    };
    Rectangle.prototype.lineIntersections = function(x1, y1, x2, y2) {
        var sides = [
            [
                this.x,
                this.y,
                this.X,
                this.y
            ],
            [
                this.X,
                this.y,
                this.X,
                this.Y
            ],
            [
                this.X,
                this.Y,
                this.x,
                this.Y
            ],
            [
                this.x,
                this.Y,
                this.x,
                this.y
            ]
        ];
        var intersections = [];
        for(var i = 0; i < 4; ++i){
            var r = Rectangle.lineIntersection(x1, y1, x2, y2, sides[i][0], sides[i][1], sides[i][2], sides[i][3]);
            if (r !== null) intersections.push({
                x: r.x,
                y: r.y
            });
        }
        return intersections;
    };
    Rectangle.prototype.rayIntersection = function(x2, y2) {
        var ints = this.lineIntersections(this.cx(), this.cy(), x2, y2);
        return ints.length > 0 ? ints[0] : null;
    };
    Rectangle.prototype.vertices = function() {
        return [
            {
                x: this.x,
                y: this.y
            },
            {
                x: this.X,
                y: this.y
            },
            {
                x: this.X,
                y: this.Y
            },
            {
                x: this.x,
                y: this.Y
            }
        ];
    };
    Rectangle.lineIntersection = function(x1, y1, x2, y2, x3, y3, x4, y4) {
        var dx12 = x2 - x1, dx34 = x4 - x3, dy12 = y2 - y1, dy34 = y4 - y3, denominator = dy34 * dx12 - dx34 * dy12;
        if (denominator == 0) return null;
        var dx31 = x1 - x3, dy31 = y1 - y3, numa = dx34 * dy31 - dy34 * dx31, a = numa / denominator, numb = dx12 * dy31 - dy12 * dx31, b = numb / denominator;
        if (a >= 0 && a <= 1 && b >= 0 && b <= 1) return {
            x: x1 + a * dx12,
            y: y1 + a * dy12
        };
        return null;
    };
    Rectangle.prototype.inflate = function(pad) {
        return new Rectangle(this.x - pad, this.X + pad, this.y - pad, this.Y + pad);
    };
    return Rectangle;
}();
module.exports.Rectangle = $29c13e2f6e2f4cd3$var$Rectangle;
function $29c13e2f6e2f4cd3$var$makeEdgeBetween(source, target, ah) {
    var si = source.rayIntersection(target.cx(), target.cy()) || {
        x: source.cx(),
        y: source.cy()
    }, ti = target.rayIntersection(source.cx(), source.cy()) || {
        x: target.cx(),
        y: target.cy()
    }, dx = ti.x - si.x, dy = ti.y - si.y, l = Math.sqrt(dx * dx + dy * dy), al = l - ah;
    return {
        sourceIntersection: si,
        targetIntersection: ti,
        arrowStart: {
            x: si.x + al * dx / l,
            y: si.y + al * dy / l
        }
    };
}
module.exports.makeEdgeBetween = $29c13e2f6e2f4cd3$var$makeEdgeBetween;
function $29c13e2f6e2f4cd3$var$makeEdgeTo(s, target, ah) {
    var ti = target.rayIntersection(s.x, s.y);
    if (!ti) ti = {
        x: target.cx(),
        y: target.cy()
    };
    var dx = ti.x - s.x, dy = ti.y - s.y, l = Math.sqrt(dx * dx + dy * dy);
    return {
        x: ti.x - ah * dx / l,
        y: ti.y - ah * dy / l
    };
}
module.exports.makeEdgeTo = $29c13e2f6e2f4cd3$var$makeEdgeTo;
var $29c13e2f6e2f4cd3$var$Node = function() {
    function Node(v, r, pos) {
        this.v = v;
        this.r = r;
        this.pos = pos;
        this.prev = $29c13e2f6e2f4cd3$var$makeRBTree();
        this.next = $29c13e2f6e2f4cd3$var$makeRBTree();
    }
    return Node;
}();
var $29c13e2f6e2f4cd3$var$Event = function() {
    function Event(isOpen, v, pos) {
        this.isOpen = isOpen;
        this.v = v;
        this.pos = pos;
    }
    return Event;
}();
function $29c13e2f6e2f4cd3$var$compareEvents(a, b) {
    if (a.pos > b.pos) return 1;
    if (a.pos < b.pos) return -1;
    if (a.isOpen) return -1;
    if (b.isOpen) return 1;
    return 0;
}
function $29c13e2f6e2f4cd3$var$makeRBTree() {
    return new $5sPP5.RBTree(function(a, b) {
        return a.pos - b.pos;
    });
}
var $29c13e2f6e2f4cd3$var$xRect = {
    getCentre: function(r) {
        return r.cx();
    },
    getOpen: function(r) {
        return r.y;
    },
    getClose: function(r) {
        return r.Y;
    },
    getSize: function(r) {
        return r.width();
    },
    makeRect: function(open, close, center, size) {
        return new $29c13e2f6e2f4cd3$var$Rectangle(center - size / 2, center + size / 2, open, close);
    },
    findNeighbours: $29c13e2f6e2f4cd3$var$findXNeighbours
};
var $29c13e2f6e2f4cd3$var$yRect = {
    getCentre: function(r) {
        return r.cy();
    },
    getOpen: function(r) {
        return r.x;
    },
    getClose: function(r) {
        return r.X;
    },
    getSize: function(r) {
        return r.height();
    },
    makeRect: function(open, close, center, size) {
        return new $29c13e2f6e2f4cd3$var$Rectangle(open, close, center - size / 2, center + size / 2);
    },
    findNeighbours: $29c13e2f6e2f4cd3$var$findYNeighbours
};
function $29c13e2f6e2f4cd3$var$generateGroupConstraints(root, f, minSep, isContained) {
    if (isContained === void 0) isContained = false;
    var padding = root.padding, gn = typeof root.groups !== 'undefined' ? root.groups.length : 0, ln = typeof root.leaves !== 'undefined' ? root.leaves.length : 0, childConstraints = !gn ? [] : root.groups.reduce(function(ccs, g) {
        return ccs.concat($29c13e2f6e2f4cd3$var$generateGroupConstraints(g, f, minSep, true));
    }, []), n = (isContained ? 2 : 0) + ln + gn, vs = new Array(n), rs = new Array(n), i = 0, add = function(r, v) {
        rs[i] = r;
        vs[i++] = v;
    };
    if (isContained) {
        var b = root.bounds, c = f.getCentre(b), s = f.getSize(b) / 2, open = f.getOpen(b), close = f.getClose(b), min = c - s + padding / 2, max = c + s - padding / 2;
        root.minVar.desiredPosition = min;
        add(f.makeRect(open, close, min, padding), root.minVar);
        root.maxVar.desiredPosition = max;
        add(f.makeRect(open, close, max, padding), root.maxVar);
    }
    if (ln) root.leaves.forEach(function(l) {
        return add(l.bounds, l.variable);
    });
    if (gn) root.groups.forEach(function(g) {
        var b = g.bounds;
        add(f.makeRect(f.getOpen(b), f.getClose(b), f.getCentre(b), f.getSize(b)), g.minVar);
    });
    var cs = $29c13e2f6e2f4cd3$var$generateConstraints(rs, vs, f, minSep);
    if (gn) {
        vs.forEach(function(v) {
            v.cOut = [], v.cIn = [];
        });
        cs.forEach(function(c) {
            c.left.cOut.push(c), c.right.cIn.push(c);
        });
        root.groups.forEach(function(g) {
            var gapAdjustment = (g.padding - f.getSize(g.bounds)) / 2;
            g.minVar.cIn.forEach(function(c) {
                return c.gap += gapAdjustment;
            });
            g.minVar.cOut.forEach(function(c) {
                c.left = g.maxVar;
                c.gap += gapAdjustment;
            });
        });
    }
    return childConstraints.concat(cs);
}
function $29c13e2f6e2f4cd3$var$generateConstraints(rs, vars, rect, minSep) {
    var i, n = rs.length;
    var N = 2 * n;
    console.assert(vars.length >= n);
    var events = new Array(N);
    for(i = 0; i < n; ++i){
        var r = rs[i];
        var v = new $29c13e2f6e2f4cd3$var$Node(vars[i], r, rect.getCentre(r));
        events[i] = new $29c13e2f6e2f4cd3$var$Event(true, v, rect.getOpen(r));
        events[i + n] = new $29c13e2f6e2f4cd3$var$Event(false, v, rect.getClose(r));
    }
    events.sort($29c13e2f6e2f4cd3$var$compareEvents);
    var cs = new Array();
    var scanline = $29c13e2f6e2f4cd3$var$makeRBTree();
    for(i = 0; i < N; ++i){
        var e = events[i];
        var v = e.v;
        if (e.isOpen) {
            scanline.insert(v);
            rect.findNeighbours(v, scanline);
        } else {
            scanline.remove(v);
            var makeConstraint = function(l, r) {
                var sep = (rect.getSize(l.r) + rect.getSize(r.r)) / 2 + minSep;
                cs.push(new $avbEL.Constraint(l.v, r.v, sep));
            };
            var visitNeighbours = function(forward, reverse, mkcon) {
                var u, it = v[forward].iterator();
                while((u = it[forward]()) !== null){
                    mkcon(u, v);
                    u[reverse].remove(v);
                }
            };
            visitNeighbours("prev", "next", function(u, v) {
                return makeConstraint(u, v);
            });
            visitNeighbours("next", "prev", function(u, v) {
                return makeConstraint(v, u);
            });
        }
    }
    console.assert(scanline.size === 0);
    return cs;
}
function $29c13e2f6e2f4cd3$var$findXNeighbours(v, scanline) {
    var f = function(forward, reverse) {
        var it = scanline.findIter(v);
        var u;
        while((u = it[forward]()) !== null){
            var uovervX = u.r.overlapX(v.r);
            if (uovervX <= 0 || uovervX <= u.r.overlapY(v.r)) {
                v[forward].insert(u);
                u[reverse].insert(v);
            }
            if (uovervX <= 0) break;
        }
    };
    f("next", "prev");
    f("prev", "next");
}
function $29c13e2f6e2f4cd3$var$findYNeighbours(v, scanline) {
    var f = function(forward, reverse) {
        var u = scanline.findIter(v)[forward]();
        if (u !== null && u.r.overlapX(v.r) > 0) {
            v[forward].insert(u);
            u[reverse].insert(v);
        }
    };
    f("next", "prev");
    f("prev", "next");
}
function $29c13e2f6e2f4cd3$var$generateXConstraints(rs, vars) {
    return $29c13e2f6e2f4cd3$var$generateConstraints(rs, vars, $29c13e2f6e2f4cd3$var$xRect, 1e-6);
}
module.exports.generateXConstraints = $29c13e2f6e2f4cd3$var$generateXConstraints;
function $29c13e2f6e2f4cd3$var$generateYConstraints(rs, vars) {
    return $29c13e2f6e2f4cd3$var$generateConstraints(rs, vars, $29c13e2f6e2f4cd3$var$yRect, 1e-6);
}
module.exports.generateYConstraints = $29c13e2f6e2f4cd3$var$generateYConstraints;
function $29c13e2f6e2f4cd3$var$generateXGroupConstraints(root) {
    return $29c13e2f6e2f4cd3$var$generateGroupConstraints(root, $29c13e2f6e2f4cd3$var$xRect, 1e-6);
}
module.exports.generateXGroupConstraints = $29c13e2f6e2f4cd3$var$generateXGroupConstraints;
function $29c13e2f6e2f4cd3$var$generateYGroupConstraints(root) {
    return $29c13e2f6e2f4cd3$var$generateGroupConstraints(root, $29c13e2f6e2f4cd3$var$yRect, 1e-6);
}
module.exports.generateYGroupConstraints = $29c13e2f6e2f4cd3$var$generateYGroupConstraints;
function $29c13e2f6e2f4cd3$var$removeOverlaps(rs) {
    var vs = rs.map(function(r) {
        return new $avbEL.Variable(r.cx());
    });
    var cs = $29c13e2f6e2f4cd3$var$generateXConstraints(rs, vs);
    var solver = new $avbEL.Solver(vs, cs);
    solver.solve();
    vs.forEach(function(v, i) {
        return rs[i].setXCentre(v.position());
    });
    vs = rs.map(function(r) {
        return new $avbEL.Variable(r.cy());
    });
    cs = $29c13e2f6e2f4cd3$var$generateYConstraints(rs, vs);
    solver = new $avbEL.Solver(vs, cs);
    solver.solve();
    vs.forEach(function(v, i) {
        return rs[i].setYCentre(v.position());
    });
}
module.exports.removeOverlaps = $29c13e2f6e2f4cd3$var$removeOverlaps;
var $29c13e2f6e2f4cd3$var$IndexedVariable = function(_super) {
    $29c13e2f6e2f4cd3$var$__extends(IndexedVariable, _super);
    function IndexedVariable(index, w) {
        var _this = _super.call(this, 0, w) || this;
        _this.index = index;
        return _this;
    }
    return IndexedVariable;
}($avbEL.Variable);
module.exports.IndexedVariable = $29c13e2f6e2f4cd3$var$IndexedVariable;
var $29c13e2f6e2f4cd3$var$Projection = function() {
    function Projection(nodes, groups, rootGroup, constraints, avoidOverlaps) {
        var _this = this;
        if (rootGroup === void 0) rootGroup = null;
        if (constraints === void 0) constraints = null;
        if (avoidOverlaps === void 0) avoidOverlaps = false;
        this.nodes = nodes;
        this.groups = groups;
        this.rootGroup = rootGroup;
        this.avoidOverlaps = avoidOverlaps;
        this.variables = nodes.map(function(v, i) {
            return v.variable = new $29c13e2f6e2f4cd3$var$IndexedVariable(i, 1);
        });
        if (constraints) this.createConstraints(constraints);
        if (avoidOverlaps && rootGroup && typeof rootGroup.groups !== 'undefined') {
            nodes.forEach(function(v) {
                if (!v.width || !v.height) {
                    v.bounds = new $29c13e2f6e2f4cd3$var$Rectangle(v.x, v.x, v.y, v.y);
                    return;
                }
                var w2 = v.width / 2, h2 = v.height / 2;
                v.bounds = new $29c13e2f6e2f4cd3$var$Rectangle(v.x - w2, v.x + w2, v.y - h2, v.y + h2);
            });
            $29c13e2f6e2f4cd3$var$computeGroupBounds(rootGroup);
            var i = nodes.length;
            groups.forEach(function(g) {
                _this.variables[i] = g.minVar = new $29c13e2f6e2f4cd3$var$IndexedVariable(i++, typeof g.stiffness !== "undefined" ? g.stiffness : 0.01);
                _this.variables[i] = g.maxVar = new $29c13e2f6e2f4cd3$var$IndexedVariable(i++, typeof g.stiffness !== "undefined" ? g.stiffness : 0.01);
            });
        }
    }
    Projection.prototype.createSeparation = function(c) {
        return new $avbEL.Constraint(this.nodes[c.left].variable, this.nodes[c.right].variable, c.gap, typeof c.equality !== "undefined" ? c.equality : false);
    };
    Projection.prototype.makeFeasible = function(c) {
        var _this = this;
        if (!this.avoidOverlaps) return;
        var axis = 'x', dim = 'width';
        if (c.axis === 'x') axis = 'y', dim = 'height';
        var vs = c.offsets.map(function(o) {
            return _this.nodes[o.node];
        }).sort(function(a, b) {
            return a[axis] - b[axis];
        });
        var p = null;
        vs.forEach(function(v) {
            if (p) {
                var nextPos = p[axis] + p[dim];
                if (nextPos > v[axis]) v[axis] = nextPos;
            }
            p = v;
        });
    };
    Projection.prototype.createAlignment = function(c) {
        var _this = this;
        var u = this.nodes[c.offsets[0].node].variable;
        this.makeFeasible(c);
        var cs = c.axis === 'x' ? this.xConstraints : this.yConstraints;
        c.offsets.slice(1).forEach(function(o) {
            var v = _this.nodes[o.node].variable;
            cs.push(new $avbEL.Constraint(u, v, o.offset, true));
        });
    };
    Projection.prototype.createConstraints = function(constraints) {
        var _this = this;
        var isSep = function(c) {
            return typeof c.type === 'undefined' || c.type === 'separation';
        };
        this.xConstraints = constraints.filter(function(c) {
            return c.axis === "x" && isSep(c);
        }).map(function(c) {
            return _this.createSeparation(c);
        });
        this.yConstraints = constraints.filter(function(c) {
            return c.axis === "y" && isSep(c);
        }).map(function(c) {
            return _this.createSeparation(c);
        });
        constraints.filter(function(c) {
            return c.type === 'alignment';
        }).forEach(function(c) {
            return _this.createAlignment(c);
        });
    };
    Projection.prototype.setupVariablesAndBounds = function(x0, y0, desired, getDesired) {
        this.nodes.forEach(function(v, i) {
            if (v.fixed) {
                v.variable.weight = v.fixedWeight ? v.fixedWeight : 1000;
                desired[i] = getDesired(v);
            } else v.variable.weight = 1;
            var w = (v.width || 0) / 2, h = (v.height || 0) / 2;
            var ix = x0[i], iy = y0[i];
            v.bounds = new $29c13e2f6e2f4cd3$var$Rectangle(ix - w, ix + w, iy - h, iy + h);
        });
    };
    Projection.prototype.xProject = function(x0, y0, x) {
        if (!this.rootGroup && !(this.avoidOverlaps || this.xConstraints)) return;
        this.project(x0, y0, x0, x, function(v) {
            return v.px;
        }, this.xConstraints, $29c13e2f6e2f4cd3$var$generateXGroupConstraints, function(v) {
            return v.bounds.setXCentre(x[v.variable.index] = v.variable.position());
        }, function(g) {
            var xmin = x[g.minVar.index] = g.minVar.position();
            var xmax = x[g.maxVar.index] = g.maxVar.position();
            var p2 = g.padding / 2;
            g.bounds.x = xmin - p2;
            g.bounds.X = xmax + p2;
        });
    };
    Projection.prototype.yProject = function(x0, y0, y) {
        if (!this.rootGroup && !this.yConstraints) return;
        this.project(x0, y0, y0, y, function(v) {
            return v.py;
        }, this.yConstraints, $29c13e2f6e2f4cd3$var$generateYGroupConstraints, function(v) {
            return v.bounds.setYCentre(y[v.variable.index] = v.variable.position());
        }, function(g) {
            var ymin = y[g.minVar.index] = g.minVar.position();
            var ymax = y[g.maxVar.index] = g.maxVar.position();
            var p2 = g.padding / 2;
            g.bounds.y = ymin - p2;
            g.bounds.Y = ymax + p2;
        });
    };
    Projection.prototype.projectFunctions = function() {
        var _this = this;
        return [
            function(x0, y0, x) {
                return _this.xProject(x0, y0, x);
            },
            function(x0, y0, y) {
                return _this.yProject(x0, y0, y);
            }
        ];
    };
    Projection.prototype.project = function(x0, y0, start, desired, getDesired, cs, generateConstraints, updateNodeBounds, updateGroupBounds) {
        this.setupVariablesAndBounds(x0, y0, desired, getDesired);
        if (this.rootGroup && this.avoidOverlaps) {
            $29c13e2f6e2f4cd3$var$computeGroupBounds(this.rootGroup);
            cs = cs.concat(generateConstraints(this.rootGroup));
        }
        this.solve(this.variables, cs, start, desired);
        this.nodes.forEach(updateNodeBounds);
        if (this.rootGroup && this.avoidOverlaps) {
            this.groups.forEach(updateGroupBounds);
            $29c13e2f6e2f4cd3$var$computeGroupBounds(this.rootGroup);
        }
    };
    Projection.prototype.solve = function(vs, cs, starting, desired) {
        var solver = new $avbEL.Solver(vs, cs);
        solver.setStartingPositions(starting);
        solver.setDesiredPositions(desired);
        solver.solve();
    };
    return Projection;
}();
module.exports.Projection = $29c13e2f6e2f4cd3$var$Projection;

});
parcelRegister("avbEL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7a55d75cf7009bf6$var$PositionStats = function() {
    function PositionStats(scale) {
        this.scale = scale;
        this.AB = 0;
        this.AD = 0;
        this.A2 = 0;
    }
    PositionStats.prototype.addVariable = function(v) {
        var ai = this.scale / v.scale;
        var bi = v.offset / v.scale;
        var wi = v.weight;
        this.AB += wi * ai * bi;
        this.AD += wi * ai * v.desiredPosition;
        this.A2 += wi * ai * ai;
    };
    PositionStats.prototype.getPosn = function() {
        return (this.AD - this.AB) / this.A2;
    };
    return PositionStats;
}();
module.exports.PositionStats = $7a55d75cf7009bf6$var$PositionStats;
var $7a55d75cf7009bf6$var$Constraint = function() {
    function Constraint(left, right, gap, equality) {
        if (equality === void 0) equality = false;
        this.left = left;
        this.right = right;
        this.gap = gap;
        this.equality = equality;
        this.active = false;
        this.unsatisfiable = false;
        this.left = left;
        this.right = right;
        this.gap = gap;
        this.equality = equality;
    }
    Constraint.prototype.slack = function() {
        return this.unsatisfiable ? Number.MAX_VALUE : this.right.scale * this.right.position() - this.gap - this.left.scale * this.left.position();
    };
    return Constraint;
}();
module.exports.Constraint = $7a55d75cf7009bf6$var$Constraint;
var $7a55d75cf7009bf6$var$Variable = function() {
    function Variable(desiredPosition, weight, scale) {
        if (weight === void 0) weight = 1;
        if (scale === void 0) scale = 1;
        this.desiredPosition = desiredPosition;
        this.weight = weight;
        this.scale = scale;
        this.offset = 0;
    }
    Variable.prototype.dfdv = function() {
        return 2.0 * this.weight * (this.position() - this.desiredPosition);
    };
    Variable.prototype.position = function() {
        return (this.block.ps.scale * this.block.posn + this.offset) / this.scale;
    };
    Variable.prototype.visitNeighbours = function(prev, f) {
        var ff = function(c, next) {
            return c.active && prev !== next && f(c, next);
        };
        this.cOut.forEach(function(c) {
            return ff(c, c.right);
        });
        this.cIn.forEach(function(c) {
            return ff(c, c.left);
        });
    };
    return Variable;
}();
module.exports.Variable = $7a55d75cf7009bf6$var$Variable;
var $7a55d75cf7009bf6$var$Block = function() {
    function Block(v) {
        this.vars = [];
        v.offset = 0;
        this.ps = new $7a55d75cf7009bf6$var$PositionStats(v.scale);
        this.addVariable(v);
    }
    Block.prototype.addVariable = function(v) {
        v.block = this;
        this.vars.push(v);
        this.ps.addVariable(v);
        this.posn = this.ps.getPosn();
    };
    Block.prototype.updateWeightedPosition = function() {
        this.ps.AB = this.ps.AD = this.ps.A2 = 0;
        for(var i = 0, n = this.vars.length; i < n; ++i)this.ps.addVariable(this.vars[i]);
        this.posn = this.ps.getPosn();
    };
    Block.prototype.compute_lm = function(v, u, postAction) {
        var _this = this;
        var dfdv = v.dfdv();
        v.visitNeighbours(u, function(c, next) {
            var _dfdv = _this.compute_lm(next, v, postAction);
            if (next === c.right) {
                dfdv += _dfdv * c.left.scale;
                c.lm = _dfdv;
            } else {
                dfdv += _dfdv * c.right.scale;
                c.lm = -_dfdv;
            }
            postAction(c);
        });
        return dfdv / v.scale;
    };
    Block.prototype.populateSplitBlock = function(v, prev) {
        var _this = this;
        v.visitNeighbours(prev, function(c, next) {
            next.offset = v.offset + (next === c.right ? c.gap : -c.gap);
            _this.addVariable(next);
            _this.populateSplitBlock(next, v);
        });
    };
    Block.prototype.traverse = function(visit, acc, v, prev) {
        var _this = this;
        if (v === void 0) v = this.vars[0];
        if (prev === void 0) prev = null;
        v.visitNeighbours(prev, function(c, next) {
            acc.push(visit(c));
            _this.traverse(visit, acc, next, v);
        });
    };
    Block.prototype.findMinLM = function() {
        var m = null;
        this.compute_lm(this.vars[0], null, function(c) {
            if (!c.equality && (m === null || c.lm < m.lm)) m = c;
        });
        return m;
    };
    Block.prototype.findMinLMBetween = function(lv, rv) {
        this.compute_lm(lv, null, function() {});
        var m = null;
        this.findPath(lv, null, rv, function(c, next) {
            if (!c.equality && c.right === next && (m === null || c.lm < m.lm)) m = c;
        });
        return m;
    };
    Block.prototype.findPath = function(v, prev, to, visit) {
        var _this = this;
        var endFound = false;
        v.visitNeighbours(prev, function(c, next) {
            if (!endFound && (next === to || _this.findPath(next, v, to, visit))) {
                endFound = true;
                visit(c, next);
            }
        });
        return endFound;
    };
    Block.prototype.isActiveDirectedPathBetween = function(u, v) {
        if (u === v) return true;
        var i = u.cOut.length;
        while(i--){
            var c = u.cOut[i];
            if (c.active && this.isActiveDirectedPathBetween(c.right, v)) return true;
        }
        return false;
    };
    Block.split = function(c) {
        c.active = false;
        return [
            Block.createSplitBlock(c.left),
            Block.createSplitBlock(c.right)
        ];
    };
    Block.createSplitBlock = function(startVar) {
        var b = new Block(startVar);
        b.populateSplitBlock(startVar, null);
        return b;
    };
    Block.prototype.splitBetween = function(vl, vr) {
        var c = this.findMinLMBetween(vl, vr);
        if (c !== null) {
            var bs = Block.split(c);
            return {
                constraint: c,
                lb: bs[0],
                rb: bs[1]
            };
        }
        return null;
    };
    Block.prototype.mergeAcross = function(b, c, dist) {
        c.active = true;
        for(var i = 0, n = b.vars.length; i < n; ++i){
            var v = b.vars[i];
            v.offset += dist;
            this.addVariable(v);
        }
        this.posn = this.ps.getPosn();
    };
    Block.prototype.cost = function() {
        var sum = 0, i = this.vars.length;
        while(i--){
            var v = this.vars[i], d = v.position() - v.desiredPosition;
            sum += d * d * v.weight;
        }
        return sum;
    };
    return Block;
}();
module.exports.Block = $7a55d75cf7009bf6$var$Block;
var $7a55d75cf7009bf6$var$Blocks = function() {
    function Blocks(vs) {
        this.vs = vs;
        var n = vs.length;
        this.list = new Array(n);
        while(n--){
            var b = new $7a55d75cf7009bf6$var$Block(vs[n]);
            this.list[n] = b;
            b.blockInd = n;
        }
    }
    Blocks.prototype.cost = function() {
        var sum = 0, i = this.list.length;
        while(i--)sum += this.list[i].cost();
        return sum;
    };
    Blocks.prototype.insert = function(b) {
        b.blockInd = this.list.length;
        this.list.push(b);
    };
    Blocks.prototype.remove = function(b) {
        var last = this.list.length - 1;
        var swapBlock = this.list[last];
        this.list.length = last;
        if (b !== swapBlock) {
            this.list[b.blockInd] = swapBlock;
            swapBlock.blockInd = b.blockInd;
        }
    };
    Blocks.prototype.merge = function(c) {
        var l = c.left.block, r = c.right.block;
        var dist = c.right.offset - c.left.offset - c.gap;
        if (l.vars.length < r.vars.length) {
            r.mergeAcross(l, c, dist);
            this.remove(l);
        } else {
            l.mergeAcross(r, c, -dist);
            this.remove(r);
        }
    };
    Blocks.prototype.forEach = function(f) {
        this.list.forEach(f);
    };
    Blocks.prototype.updateBlockPositions = function() {
        this.list.forEach(function(b) {
            return b.updateWeightedPosition();
        });
    };
    Blocks.prototype.split = function(inactive) {
        var _this = this;
        this.updateBlockPositions();
        this.list.forEach(function(b) {
            var v = b.findMinLM();
            if (v !== null && v.lm < $7a55d75cf7009bf6$var$Solver.LAGRANGIAN_TOLERANCE) {
                b = v.left.block;
                $7a55d75cf7009bf6$var$Block.split(v).forEach(function(nb) {
                    return _this.insert(nb);
                });
                _this.remove(b);
                inactive.push(v);
            }
        });
    };
    return Blocks;
}();
module.exports.Blocks = $7a55d75cf7009bf6$var$Blocks;
var $7a55d75cf7009bf6$var$Solver = function() {
    function Solver(vs, cs) {
        this.vs = vs;
        this.cs = cs;
        this.vs = vs;
        vs.forEach(function(v) {
            v.cIn = [], v.cOut = [];
        });
        this.cs = cs;
        cs.forEach(function(c) {
            c.left.cOut.push(c);
            c.right.cIn.push(c);
        });
        this.inactive = cs.map(function(c) {
            c.active = false;
            return c;
        });
        this.bs = null;
    }
    Solver.prototype.cost = function() {
        return this.bs.cost();
    };
    Solver.prototype.setStartingPositions = function(ps) {
        this.inactive = this.cs.map(function(c) {
            c.active = false;
            return c;
        });
        this.bs = new $7a55d75cf7009bf6$var$Blocks(this.vs);
        this.bs.forEach(function(b, i) {
            return b.posn = ps[i];
        });
    };
    Solver.prototype.setDesiredPositions = function(ps) {
        this.vs.forEach(function(v, i) {
            return v.desiredPosition = ps[i];
        });
    };
    Solver.prototype.mostViolated = function() {
        var minSlack = Number.MAX_VALUE, v = null, l = this.inactive, n = l.length, deletePoint = n;
        for(var i = 0; i < n; ++i){
            var c = l[i];
            if (c.unsatisfiable) continue;
            var slack = c.slack();
            if (c.equality || slack < minSlack) {
                minSlack = slack;
                v = c;
                deletePoint = i;
                if (c.equality) break;
            }
        }
        if (deletePoint !== n && (minSlack < Solver.ZERO_UPPERBOUND && !v.active || v.equality)) {
            l[deletePoint] = l[n - 1];
            l.length = n - 1;
        }
        return v;
    };
    Solver.prototype.satisfy = function() {
        if (this.bs == null) this.bs = new $7a55d75cf7009bf6$var$Blocks(this.vs);
        this.bs.split(this.inactive);
        var v = null;
        while((v = this.mostViolated()) && (v.equality || v.slack() < Solver.ZERO_UPPERBOUND && !v.active)){
            var lb = v.left.block, rb = v.right.block;
            if (lb !== rb) this.bs.merge(v);
            else {
                if (lb.isActiveDirectedPathBetween(v.right, v.left)) {
                    v.unsatisfiable = true;
                    continue;
                }
                var split = lb.splitBetween(v.left, v.right);
                if (split !== null) {
                    this.bs.insert(split.lb);
                    this.bs.insert(split.rb);
                    this.bs.remove(lb);
                    this.inactive.push(split.constraint);
                } else {
                    v.unsatisfiable = true;
                    continue;
                }
                if (v.slack() >= 0) this.inactive.push(v);
                else this.bs.merge(v);
            }
        }
    };
    Solver.prototype.solve = function() {
        this.satisfy();
        var lastcost = Number.MAX_VALUE, cost = this.bs.cost();
        while(Math.abs(lastcost - cost) > 0.0001){
            this.satisfy();
            lastcost = cost;
            cost = this.bs.cost();
        }
        return cost;
    };
    Solver.LAGRANGIAN_TOLERANCE = -0.0001;
    Solver.ZERO_UPPERBOUND = -0.0000000001;
    return Solver;
}();
module.exports.Solver = $7a55d75cf7009bf6$var$Solver;
function $7a55d75cf7009bf6$var$removeOverlapInOneDimension(spans, lowerBound, upperBound) {
    var vs = spans.map(function(s) {
        return new $7a55d75cf7009bf6$var$Variable(s.desiredCenter);
    });
    var cs = [];
    var n = spans.length;
    for(var i = 0; i < n - 1; i++){
        var left = spans[i], right = spans[i + 1];
        cs.push(new $7a55d75cf7009bf6$var$Constraint(vs[i], vs[i + 1], (left.size + right.size) / 2));
    }
    var leftMost = vs[0], rightMost = vs[n - 1], leftMostSize = spans[0].size / 2, rightMostSize = spans[n - 1].size / 2;
    var vLower = null, vUpper = null;
    if (lowerBound) {
        vLower = new $7a55d75cf7009bf6$var$Variable(lowerBound, leftMost.weight * 1000);
        vs.push(vLower);
        cs.push(new $7a55d75cf7009bf6$var$Constraint(vLower, leftMost, leftMostSize));
    }
    if (upperBound) {
        vUpper = new $7a55d75cf7009bf6$var$Variable(upperBound, rightMost.weight * 1000);
        vs.push(vUpper);
        cs.push(new $7a55d75cf7009bf6$var$Constraint(rightMost, vUpper, rightMostSize));
    }
    var solver = new $7a55d75cf7009bf6$var$Solver(vs, cs);
    solver.solve();
    return {
        newCenters: vs.slice(0, spans.length).map(function(v) {
            return v.position();
        }),
        lowerBound: vLower ? vLower.position() : leftMost.position() - leftMostSize,
        upperBound: vUpper ? vUpper.position() : rightMost.position() + rightMostSize
    };
}
module.exports.removeOverlapInOneDimension = $7a55d75cf7009bf6$var$removeOverlapInOneDimension;

});

parcelRegister("5sPP5", function(module, exports) {
"use strict";
var $3fa7c4416d41cd8b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3fa7c4416d41cd8b$var$TreeBase = function() {
    function TreeBase() {
        this.findIter = function(data) {
            var res = this._root;
            var iter = this.iterator();
            while(res !== null){
                var c = this._comparator(data, res.data);
                if (c === 0) {
                    iter._cursor = res;
                    return iter;
                } else {
                    iter._ancestors.push(res);
                    res = res.get_child(c > 0);
                }
            }
            return null;
        };
    }
    TreeBase.prototype.clear = function() {
        this._root = null;
        this.size = 0;
    };
    TreeBase.prototype.find = function(data) {
        var res = this._root;
        while(res !== null){
            var c = this._comparator(data, res.data);
            if (c === 0) return res.data;
            else res = res.get_child(c > 0);
        }
        return null;
    };
    TreeBase.prototype.lowerBound = function(data) {
        return this._bound(data, this._comparator);
    };
    TreeBase.prototype.upperBound = function(data) {
        var cmp = this._comparator;
        function reverse_cmp(a, b) {
            return cmp(b, a);
        }
        return this._bound(data, reverse_cmp);
    };
    TreeBase.prototype.min = function() {
        var res = this._root;
        if (res === null) return null;
        while(res.left !== null)res = res.left;
        return res.data;
    };
    TreeBase.prototype.max = function() {
        var res = this._root;
        if (res === null) return null;
        while(res.right !== null)res = res.right;
        return res.data;
    };
    TreeBase.prototype.iterator = function() {
        return new $3fa7c4416d41cd8b$var$Iterator(this);
    };
    TreeBase.prototype.each = function(cb) {
        var it = this.iterator(), data;
        while((data = it.next()) !== null)cb(data);
    };
    TreeBase.prototype.reach = function(cb) {
        var it = this.iterator(), data;
        while((data = it.prev()) !== null)cb(data);
    };
    TreeBase.prototype._bound = function(data, cmp) {
        var cur = this._root;
        var iter = this.iterator();
        while(cur !== null){
            var c = this._comparator(data, cur.data);
            if (c === 0) {
                iter._cursor = cur;
                return iter;
            }
            iter._ancestors.push(cur);
            cur = cur.get_child(c > 0);
        }
        for(var i = iter._ancestors.length - 1; i >= 0; --i){
            cur = iter._ancestors[i];
            if (cmp(data, cur.data) > 0) {
                iter._cursor = cur;
                iter._ancestors.length = i;
                return iter;
            }
        }
        iter._ancestors.length = 0;
        return iter;
    };
    return TreeBase;
}();
module.exports.TreeBase = $3fa7c4416d41cd8b$var$TreeBase;
var $3fa7c4416d41cd8b$var$Iterator = function() {
    function Iterator(tree) {
        this._tree = tree;
        this._ancestors = [];
        this._cursor = null;
    }
    Iterator.prototype.data = function() {
        return this._cursor !== null ? this._cursor.data : null;
    };
    Iterator.prototype.next = function() {
        if (this._cursor === null) {
            var root = this._tree._root;
            if (root !== null) this._minNode(root);
        } else if (this._cursor.right === null) {
            var save;
            do {
                save = this._cursor;
                if (this._ancestors.length) this._cursor = this._ancestors.pop();
                else {
                    this._cursor = null;
                    break;
                }
            }while (this._cursor.right === save);
        } else {
            this._ancestors.push(this._cursor);
            this._minNode(this._cursor.right);
        }
        return this._cursor !== null ? this._cursor.data : null;
    };
    Iterator.prototype.prev = function() {
        if (this._cursor === null) {
            var root = this._tree._root;
            if (root !== null) this._maxNode(root);
        } else if (this._cursor.left === null) {
            var save;
            do {
                save = this._cursor;
                if (this._ancestors.length) this._cursor = this._ancestors.pop();
                else {
                    this._cursor = null;
                    break;
                }
            }while (this._cursor.left === save);
        } else {
            this._ancestors.push(this._cursor);
            this._maxNode(this._cursor.left);
        }
        return this._cursor !== null ? this._cursor.data : null;
    };
    Iterator.prototype._minNode = function(start) {
        while(start.left !== null){
            this._ancestors.push(start);
            start = start.left;
        }
        this._cursor = start;
    };
    Iterator.prototype._maxNode = function(start) {
        while(start.right !== null){
            this._ancestors.push(start);
            start = start.right;
        }
        this._cursor = start;
    };
    return Iterator;
}();
module.exports.Iterator = $3fa7c4416d41cd8b$var$Iterator;
var $3fa7c4416d41cd8b$var$Node = function() {
    function Node(data) {
        this.data = data;
        this.left = null;
        this.right = null;
        this.red = true;
    }
    Node.prototype.get_child = function(dir) {
        return dir ? this.right : this.left;
    };
    Node.prototype.set_child = function(dir, val) {
        if (dir) this.right = val;
        else this.left = val;
    };
    return Node;
}();
var $3fa7c4416d41cd8b$var$RBTree = function(_super) {
    $3fa7c4416d41cd8b$var$__extends(RBTree, _super);
    function RBTree(comparator) {
        var _this = _super.call(this) || this;
        _this._root = null;
        _this._comparator = comparator;
        _this.size = 0;
        return _this;
    }
    RBTree.prototype.insert = function(data) {
        var ret = false;
        if (this._root === null) {
            this._root = new $3fa7c4416d41cd8b$var$Node(data);
            ret = true;
            this.size++;
        } else {
            var head = new $3fa7c4416d41cd8b$var$Node(undefined);
            var dir = false;
            var last = false;
            var gp = null;
            var ggp = head;
            var p = null;
            var node = this._root;
            ggp.right = this._root;
            while(true){
                if (node === null) {
                    node = new $3fa7c4416d41cd8b$var$Node(data);
                    p.set_child(dir, node);
                    ret = true;
                    this.size++;
                } else if (RBTree.is_red(node.left) && RBTree.is_red(node.right)) {
                    node.red = true;
                    node.left.red = false;
                    node.right.red = false;
                }
                if (RBTree.is_red(node) && RBTree.is_red(p)) {
                    var dir2 = ggp.right === gp;
                    if (node === p.get_child(last)) ggp.set_child(dir2, RBTree.single_rotate(gp, !last));
                    else ggp.set_child(dir2, RBTree.double_rotate(gp, !last));
                }
                var cmp = this._comparator(node.data, data);
                if (cmp === 0) break;
                last = dir;
                dir = cmp < 0;
                if (gp !== null) ggp = gp;
                gp = p;
                p = node;
                node = node.get_child(dir);
            }
            this._root = head.right;
        }
        this._root.red = false;
        return ret;
    };
    RBTree.prototype.remove = function(data) {
        if (this._root === null) return false;
        var head = new $3fa7c4416d41cd8b$var$Node(undefined);
        var node = head;
        node.right = this._root;
        var p = null;
        var gp = null;
        var found = null;
        var dir = true;
        while(node.get_child(dir) !== null){
            var last = dir;
            gp = p;
            p = node;
            node = node.get_child(dir);
            var cmp = this._comparator(data, node.data);
            dir = cmp > 0;
            if (cmp === 0) found = node;
            if (!RBTree.is_red(node) && !RBTree.is_red(node.get_child(dir))) {
                if (RBTree.is_red(node.get_child(!dir))) {
                    var sr = RBTree.single_rotate(node, dir);
                    p.set_child(last, sr);
                    p = sr;
                } else if (!RBTree.is_red(node.get_child(!dir))) {
                    var sibling = p.get_child(!last);
                    if (sibling !== null) {
                        if (!RBTree.is_red(sibling.get_child(!last)) && !RBTree.is_red(sibling.get_child(last))) {
                            p.red = false;
                            sibling.red = true;
                            node.red = true;
                        } else {
                            var dir2 = gp.right === p;
                            if (RBTree.is_red(sibling.get_child(last))) gp.set_child(dir2, RBTree.double_rotate(p, last));
                            else if (RBTree.is_red(sibling.get_child(!last))) gp.set_child(dir2, RBTree.single_rotate(p, last));
                            var gpc = gp.get_child(dir2);
                            gpc.red = true;
                            node.red = true;
                            gpc.left.red = false;
                            gpc.right.red = false;
                        }
                    }
                }
            }
        }
        if (found !== null) {
            found.data = node.data;
            p.set_child(p.right === node, node.get_child(node.left === null));
            this.size--;
        }
        this._root = head.right;
        if (this._root !== null) this._root.red = false;
        return found !== null;
    };
    RBTree.is_red = function(node) {
        return node !== null && node.red;
    };
    RBTree.single_rotate = function(root, dir) {
        var save = root.get_child(!dir);
        root.set_child(!dir, save.get_child(dir));
        save.set_child(dir, root);
        root.red = true;
        save.red = false;
        return save;
    };
    RBTree.double_rotate = function(root, dir) {
        root.set_child(!dir, RBTree.single_rotate(root.get_child(!dir), !dir));
        return RBTree.single_rotate(root, dir);
    };
    return RBTree;
}($3fa7c4416d41cd8b$var$TreeBase);
module.exports.RBTree = $3fa7c4416d41cd8b$var$RBTree;

});


parcelRegister("6PjXM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $862i5 = parcelRequire("862i5");
var $4f86fdc3e14a8be7$var$Neighbour = function() {
    function Neighbour(id, distance) {
        this.id = id;
        this.distance = distance;
    }
    return Neighbour;
}();
var $4f86fdc3e14a8be7$var$Node = function() {
    function Node(id) {
        this.id = id;
        this.neighbours = [];
    }
    return Node;
}();
var $4f86fdc3e14a8be7$var$QueueEntry = function() {
    function QueueEntry(node, prev, d) {
        this.node = node;
        this.prev = prev;
        this.d = d;
    }
    return QueueEntry;
}();
var $4f86fdc3e14a8be7$var$Calculator = function() {
    function Calculator(n, es, getSourceIndex, getTargetIndex, getLength) {
        this.n = n;
        this.es = es;
        this.neighbours = new Array(this.n);
        var i = this.n;
        while(i--)this.neighbours[i] = new $4f86fdc3e14a8be7$var$Node(i);
        i = this.es.length;
        while(i--){
            var e = this.es[i];
            var u = getSourceIndex(e), v = getTargetIndex(e);
            var d = getLength(e);
            this.neighbours[u].neighbours.push(new $4f86fdc3e14a8be7$var$Neighbour(v, d));
            this.neighbours[v].neighbours.push(new $4f86fdc3e14a8be7$var$Neighbour(u, d));
        }
    }
    Calculator.prototype.DistanceMatrix = function() {
        var D = new Array(this.n);
        for(var i = 0; i < this.n; ++i)D[i] = this.dijkstraNeighbours(i);
        return D;
    };
    Calculator.prototype.DistancesFromNode = function(start) {
        return this.dijkstraNeighbours(start);
    };
    Calculator.prototype.PathFromNodeToNode = function(start, end) {
        return this.dijkstraNeighbours(start, end);
    };
    Calculator.prototype.PathFromNodeToNodeWithPrevCost = function(start, end, prevCost) {
        var q = new $862i5.PriorityQueue(function(a, b) {
            return a.d <= b.d;
        }), u = this.neighbours[start], qu = new $4f86fdc3e14a8be7$var$QueueEntry(u, null, 0), visitedFrom = {};
        q.push(qu);
        while(!q.empty()){
            qu = q.pop();
            u = qu.node;
            if (u.id === end) break;
            var i = u.neighbours.length;
            while(i--){
                var neighbour = u.neighbours[i], v = this.neighbours[neighbour.id];
                if (qu.prev && v.id === qu.prev.node.id) continue;
                var viduid = v.id + ',' + u.id;
                if (viduid in visitedFrom && visitedFrom[viduid] <= qu.d) continue;
                var cc = qu.prev ? prevCost(qu.prev.node.id, u.id, v.id) : 0, t = qu.d + neighbour.distance + cc;
                visitedFrom[viduid] = t;
                q.push(new $4f86fdc3e14a8be7$var$QueueEntry(v, qu, t));
            }
        }
        var path = [];
        while(qu.prev){
            qu = qu.prev;
            path.push(qu.node.id);
        }
        return path;
    };
    Calculator.prototype.dijkstraNeighbours = function(start, dest) {
        if (dest === void 0) dest = -1;
        var q = new $862i5.PriorityQueue(function(a, b) {
            return a.d <= b.d;
        }), i = this.neighbours.length, d = new Array(i);
        while(i--){
            var node = this.neighbours[i];
            node.d = i === start ? 0 : Number.POSITIVE_INFINITY;
            node.q = q.push(node);
        }
        while(!q.empty()){
            var u = q.pop();
            d[u.id] = u.d;
            if (u.id === dest) {
                var path = [];
                var v = u;
                while(typeof v.prev !== 'undefined'){
                    path.push(v.prev.id);
                    v = v.prev;
                }
                return path;
            }
            i = u.neighbours.length;
            while(i--){
                var neighbour = u.neighbours[i];
                var v = this.neighbours[neighbour.id];
                var t = u.d + neighbour.distance;
                if (u.d !== Number.MAX_VALUE && v.d > t) {
                    v.d = t;
                    v.prev = u;
                    q.reduceKey(v.q, v, function(e, q) {
                        return e.q = q;
                    });
                }
            }
        }
        return d;
    };
    return Calculator;
}();
module.exports.Calculator = $4f86fdc3e14a8be7$var$Calculator;

});
parcelRegister("862i5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5e50a92b159987cb$var$PairingHeap = function() {
    function PairingHeap(elem) {
        this.elem = elem;
        this.subheaps = [];
    }
    PairingHeap.prototype.toString = function(selector) {
        var str = "", needComma = false;
        for(var i = 0; i < this.subheaps.length; ++i){
            var subheap = this.subheaps[i];
            if (!subheap.elem) {
                needComma = false;
                continue;
            }
            if (needComma) str = str + ",";
            str = str + subheap.toString(selector);
            needComma = true;
        }
        if (str !== "") str = "(" + str + ")";
        return (this.elem ? selector(this.elem) : "") + str;
    };
    PairingHeap.prototype.forEach = function(f) {
        if (!this.empty()) {
            f(this.elem, this);
            this.subheaps.forEach(function(s) {
                return s.forEach(f);
            });
        }
    };
    PairingHeap.prototype.count = function() {
        return this.empty() ? 0 : 1 + this.subheaps.reduce(function(n, h) {
            return n + h.count();
        }, 0);
    };
    PairingHeap.prototype.min = function() {
        return this.elem;
    };
    PairingHeap.prototype.empty = function() {
        return this.elem == null;
    };
    PairingHeap.prototype.contains = function(h) {
        if (this === h) return true;
        for(var i = 0; i < this.subheaps.length; i++){
            if (this.subheaps[i].contains(h)) return true;
        }
        return false;
    };
    PairingHeap.prototype.isHeap = function(lessThan) {
        var _this = this;
        return this.subheaps.every(function(h) {
            return lessThan(_this.elem, h.elem) && h.isHeap(lessThan);
        });
    };
    PairingHeap.prototype.insert = function(obj, lessThan) {
        return this.merge(new PairingHeap(obj), lessThan);
    };
    PairingHeap.prototype.merge = function(heap2, lessThan) {
        if (this.empty()) return heap2;
        else if (heap2.empty()) return this;
        else if (lessThan(this.elem, heap2.elem)) {
            this.subheaps.push(heap2);
            return this;
        } else {
            heap2.subheaps.push(this);
            return heap2;
        }
    };
    PairingHeap.prototype.removeMin = function(lessThan) {
        if (this.empty()) return null;
        else return this.mergePairs(lessThan);
    };
    PairingHeap.prototype.mergePairs = function(lessThan) {
        if (this.subheaps.length == 0) return new PairingHeap(null);
        else if (this.subheaps.length == 1) return this.subheaps[0];
        else {
            var firstPair = this.subheaps.pop().merge(this.subheaps.pop(), lessThan);
            var remaining = this.mergePairs(lessThan);
            return firstPair.merge(remaining, lessThan);
        }
    };
    PairingHeap.prototype.decreaseKey = function(subheap, newValue, setHeapNode, lessThan) {
        var newHeap = subheap.removeMin(lessThan);
        subheap.elem = newHeap.elem;
        subheap.subheaps = newHeap.subheaps;
        if (setHeapNode !== null && newHeap.elem !== null) setHeapNode(subheap.elem, subheap);
        var pairingNode = new PairingHeap(newValue);
        if (setHeapNode !== null) setHeapNode(newValue, pairingNode);
        return this.merge(pairingNode, lessThan);
    };
    return PairingHeap;
}();
module.exports.PairingHeap = $5e50a92b159987cb$var$PairingHeap;
var $5e50a92b159987cb$var$PriorityQueue = function() {
    function PriorityQueue(lessThan) {
        this.lessThan = lessThan;
    }
    PriorityQueue.prototype.top = function() {
        if (this.empty()) return null;
        return this.root.elem;
    };
    PriorityQueue.prototype.push = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var pairingNode;
        for(var i = 0, arg; arg = args[i]; ++i){
            pairingNode = new $5e50a92b159987cb$var$PairingHeap(arg);
            this.root = this.empty() ? pairingNode : this.root.merge(pairingNode, this.lessThan);
        }
        return pairingNode;
    };
    PriorityQueue.prototype.empty = function() {
        return !this.root || !this.root.elem;
    };
    PriorityQueue.prototype.isHeap = function() {
        return this.root.isHeap(this.lessThan);
    };
    PriorityQueue.prototype.forEach = function(f) {
        this.root.forEach(f);
    };
    PriorityQueue.prototype.pop = function() {
        if (this.empty()) return null;
        var obj = this.root.min();
        this.root = this.root.removeMin(this.lessThan);
        return obj;
    };
    PriorityQueue.prototype.reduceKey = function(heapNode, newKey, setHeapNode) {
        if (setHeapNode === void 0) setHeapNode = null;
        this.root = this.root.decreaseKey(heapNode, newKey, setHeapNode, this.lessThan);
    };
    PriorityQueue.prototype.toString = function(selector) {
        return this.root.toString(selector);
    };
    PriorityQueue.prototype.count = function() {
        return this.root.count();
    };
    return PriorityQueue;
}();
module.exports.PriorityQueue = $5e50a92b159987cb$var$PriorityQueue;

});


parcelRegister("jcvgO", function(module, exports) {
"use strict";
var $dfa764e5b7165555$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ag7S = parcelRequire("3Ag7S");
var $dfa764e5b7165555$var$Point = function() {
    function Point() {}
    return Point;
}();
module.exports.Point = $dfa764e5b7165555$var$Point;
var $dfa764e5b7165555$var$LineSegment = function() {
    function LineSegment(x1, y1, x2, y2) {
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
    }
    return LineSegment;
}();
module.exports.LineSegment = $dfa764e5b7165555$var$LineSegment;
var $dfa764e5b7165555$var$PolyPoint = function(_super) {
    $dfa764e5b7165555$var$__extends(PolyPoint, _super);
    function PolyPoint() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PolyPoint;
}($dfa764e5b7165555$var$Point);
module.exports.PolyPoint = $dfa764e5b7165555$var$PolyPoint;
function $dfa764e5b7165555$var$isLeft(P0, P1, P2) {
    return (P1.x - P0.x) * (P2.y - P0.y) - (P2.x - P0.x) * (P1.y - P0.y);
}
module.exports.isLeft = $dfa764e5b7165555$var$isLeft;
function $dfa764e5b7165555$var$above(p, vi, vj) {
    return $dfa764e5b7165555$var$isLeft(p, vi, vj) > 0;
}
function $dfa764e5b7165555$var$below(p, vi, vj) {
    return $dfa764e5b7165555$var$isLeft(p, vi, vj) < 0;
}
function $dfa764e5b7165555$var$ConvexHull(S) {
    var P = S.slice(0).sort(function(a, b) {
        return a.x !== b.x ? b.x - a.x : b.y - a.y;
    });
    var n = S.length, i;
    var minmin = 0;
    var xmin = P[0].x;
    for(i = 1; i < n; ++i){
        if (P[i].x !== xmin) break;
    }
    var minmax = i - 1;
    var H = [];
    H.push(P[minmin]);
    if (minmax === n - 1) {
        if (P[minmax].y !== P[minmin].y) H.push(P[minmax]);
    } else {
        var maxmin, maxmax = n - 1;
        var xmax = P[n - 1].x;
        for(i = n - 2; i >= 0; i--)if (P[i].x !== xmax) break;
        maxmin = i + 1;
        i = minmax;
        while(++i <= maxmin){
            if ($dfa764e5b7165555$var$isLeft(P[minmin], P[maxmin], P[i]) >= 0 && i < maxmin) continue;
            while(H.length > 1){
                if ($dfa764e5b7165555$var$isLeft(H[H.length - 2], H[H.length - 1], P[i]) > 0) break;
                else H.length -= 1;
            }
            if (i != minmin) H.push(P[i]);
        }
        if (maxmax != maxmin) H.push(P[maxmax]);
        var bot = H.length;
        i = maxmin;
        while(--i >= minmax){
            if ($dfa764e5b7165555$var$isLeft(P[maxmax], P[minmax], P[i]) >= 0 && i > minmax) continue;
            while(H.length > bot){
                if ($dfa764e5b7165555$var$isLeft(H[H.length - 2], H[H.length - 1], P[i]) > 0) break;
                else H.length -= 1;
            }
            if (i != minmin) H.push(P[i]);
        }
    }
    return H;
}
module.exports.ConvexHull = $dfa764e5b7165555$var$ConvexHull;
function $dfa764e5b7165555$var$clockwiseRadialSweep(p, P, f) {
    P.slice(0).sort(function(a, b) {
        return Math.atan2(a.y - p.y, a.x - p.x) - Math.atan2(b.y - p.y, b.x - p.x);
    }).forEach(f);
}
module.exports.clockwiseRadialSweep = $dfa764e5b7165555$var$clockwiseRadialSweep;
function $dfa764e5b7165555$var$nextPolyPoint(p, ps) {
    if (p.polyIndex === ps.length - 1) return ps[0];
    return ps[p.polyIndex + 1];
}
function $dfa764e5b7165555$var$prevPolyPoint(p, ps) {
    if (p.polyIndex === 0) return ps[ps.length - 1];
    return ps[p.polyIndex - 1];
}
function $dfa764e5b7165555$var$tangent_PointPolyC(P, V) {
    var Vclosed = V.slice(0);
    Vclosed.push(V[0]);
    return {
        rtan: $dfa764e5b7165555$var$Rtangent_PointPolyC(P, Vclosed),
        ltan: $dfa764e5b7165555$var$Ltangent_PointPolyC(P, Vclosed)
    };
}
function $dfa764e5b7165555$var$Rtangent_PointPolyC(P, V) {
    var n = V.length - 1;
    var a, b, c;
    var upA, dnC;
    if ($dfa764e5b7165555$var$below(P, V[1], V[0]) && !$dfa764e5b7165555$var$above(P, V[n - 1], V[0])) return 0;
    for(a = 0, b = n;;){
        if (b - a === 1) {
            if ($dfa764e5b7165555$var$above(P, V[a], V[b])) return a;
            else return b;
        }
        c = Math.floor((a + b) / 2);
        dnC = $dfa764e5b7165555$var$below(P, V[c + 1], V[c]);
        if (dnC && !$dfa764e5b7165555$var$above(P, V[c - 1], V[c])) return c;
        upA = $dfa764e5b7165555$var$above(P, V[a + 1], V[a]);
        if (upA) {
            if (dnC) b = c;
            else if ($dfa764e5b7165555$var$above(P, V[a], V[c])) b = c;
            else a = c;
        } else {
            if (!dnC) a = c;
            else if ($dfa764e5b7165555$var$below(P, V[a], V[c])) b = c;
            else a = c;
        }
    }
}
function $dfa764e5b7165555$var$Ltangent_PointPolyC(P, V) {
    var n = V.length - 1;
    var a, b, c;
    var dnA, dnC;
    if ($dfa764e5b7165555$var$above(P, V[n - 1], V[0]) && !$dfa764e5b7165555$var$below(P, V[1], V[0])) return 0;
    for(a = 0, b = n;;){
        if (b - a === 1) {
            if ($dfa764e5b7165555$var$below(P, V[a], V[b])) return a;
            else return b;
        }
        c = Math.floor((a + b) / 2);
        dnC = $dfa764e5b7165555$var$below(P, V[c + 1], V[c]);
        if ($dfa764e5b7165555$var$above(P, V[c - 1], V[c]) && !dnC) return c;
        dnA = $dfa764e5b7165555$var$below(P, V[a + 1], V[a]);
        if (dnA) {
            if (!dnC) b = c;
            else if ($dfa764e5b7165555$var$below(P, V[a], V[c])) b = c;
            else a = c;
        } else {
            if (dnC) a = c;
            else if ($dfa764e5b7165555$var$above(P, V[a], V[c])) b = c;
            else a = c;
        }
    }
}
function $dfa764e5b7165555$var$tangent_PolyPolyC(V, W, t1, t2, cmp1, cmp2) {
    var ix1, ix2;
    ix1 = t1(W[0], V);
    ix2 = t2(V[ix1], W);
    var done = false;
    while(!done){
        done = true;
        while(true){
            if (ix1 === V.length - 1) ix1 = 0;
            if (cmp1(W[ix2], V[ix1], V[ix1 + 1])) break;
            ++ix1;
        }
        while(true){
            if (ix2 === 0) ix2 = W.length - 1;
            if (cmp2(V[ix1], W[ix2], W[ix2 - 1])) break;
            --ix2;
            done = false;
        }
    }
    return {
        t1: ix1,
        t2: ix2
    };
}
module.exports.tangent_PolyPolyC = $dfa764e5b7165555$var$tangent_PolyPolyC;
function $dfa764e5b7165555$var$LRtangent_PolyPolyC(V, W) {
    var rl = $dfa764e5b7165555$var$RLtangent_PolyPolyC(W, V);
    return {
        t1: rl.t2,
        t2: rl.t1
    };
}
module.exports.LRtangent_PolyPolyC = $dfa764e5b7165555$var$LRtangent_PolyPolyC;
function $dfa764e5b7165555$var$RLtangent_PolyPolyC(V, W) {
    return $dfa764e5b7165555$var$tangent_PolyPolyC(V, W, $dfa764e5b7165555$var$Rtangent_PointPolyC, $dfa764e5b7165555$var$Ltangent_PointPolyC, $dfa764e5b7165555$var$above, $dfa764e5b7165555$var$below);
}
module.exports.RLtangent_PolyPolyC = $dfa764e5b7165555$var$RLtangent_PolyPolyC;
function $dfa764e5b7165555$var$LLtangent_PolyPolyC(V, W) {
    return $dfa764e5b7165555$var$tangent_PolyPolyC(V, W, $dfa764e5b7165555$var$Ltangent_PointPolyC, $dfa764e5b7165555$var$Ltangent_PointPolyC, $dfa764e5b7165555$var$below, $dfa764e5b7165555$var$below);
}
module.exports.LLtangent_PolyPolyC = $dfa764e5b7165555$var$LLtangent_PolyPolyC;
function $dfa764e5b7165555$var$RRtangent_PolyPolyC(V, W) {
    return $dfa764e5b7165555$var$tangent_PolyPolyC(V, W, $dfa764e5b7165555$var$Rtangent_PointPolyC, $dfa764e5b7165555$var$Rtangent_PointPolyC, $dfa764e5b7165555$var$above, $dfa764e5b7165555$var$above);
}
module.exports.RRtangent_PolyPolyC = $dfa764e5b7165555$var$RRtangent_PolyPolyC;
var $dfa764e5b7165555$var$BiTangent = function() {
    function BiTangent(t1, t2) {
        this.t1 = t1;
        this.t2 = t2;
    }
    return BiTangent;
}();
module.exports.BiTangent = $dfa764e5b7165555$var$BiTangent;
var $dfa764e5b7165555$var$BiTangents = function() {
    function BiTangents() {}
    return BiTangents;
}();
module.exports.BiTangents = $dfa764e5b7165555$var$BiTangents;
var $dfa764e5b7165555$var$TVGPoint = function(_super) {
    $dfa764e5b7165555$var$__extends(TVGPoint, _super);
    function TVGPoint() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TVGPoint;
}($dfa764e5b7165555$var$Point);
module.exports.TVGPoint = $dfa764e5b7165555$var$TVGPoint;
var $dfa764e5b7165555$var$VisibilityVertex = function() {
    function VisibilityVertex(id, polyid, polyvertid, p) {
        this.id = id;
        this.polyid = polyid;
        this.polyvertid = polyvertid;
        this.p = p;
        p.vv = this;
    }
    return VisibilityVertex;
}();
module.exports.VisibilityVertex = $dfa764e5b7165555$var$VisibilityVertex;
var $dfa764e5b7165555$var$VisibilityEdge = function() {
    function VisibilityEdge(source, target) {
        this.source = source;
        this.target = target;
    }
    VisibilityEdge.prototype.length = function() {
        var dx = this.source.p.x - this.target.p.x;
        var dy = this.source.p.y - this.target.p.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    return VisibilityEdge;
}();
module.exports.VisibilityEdge = $dfa764e5b7165555$var$VisibilityEdge;
var $dfa764e5b7165555$var$TangentVisibilityGraph = function() {
    function TangentVisibilityGraph(P, g0) {
        this.P = P;
        this.V = [];
        this.E = [];
        if (!g0) {
            var n = P.length;
            for(var i = 0; i < n; i++){
                var p = P[i];
                for(var j = 0; j < p.length; ++j){
                    var pj = p[j], vv = new $dfa764e5b7165555$var$VisibilityVertex(this.V.length, i, j, pj);
                    this.V.push(vv);
                    if (j > 0) this.E.push(new $dfa764e5b7165555$var$VisibilityEdge(p[j - 1].vv, vv));
                }
                if (p.length > 1) this.E.push(new $dfa764e5b7165555$var$VisibilityEdge(p[0].vv, p[p.length - 1].vv));
            }
            for(var i = 0; i < n - 1; i++){
                var Pi = P[i];
                for(var j = i + 1; j < n; j++){
                    var Pj = P[j], t = $dfa764e5b7165555$var$tangents(Pi, Pj);
                    for(var q in t){
                        var c = t[q], source = Pi[c.t1], target = Pj[c.t2];
                        this.addEdgeIfVisible(source, target, i, j);
                    }
                }
            }
        } else {
            this.V = g0.V.slice(0);
            this.E = g0.E.slice(0);
        }
    }
    TangentVisibilityGraph.prototype.addEdgeIfVisible = function(u, v, i1, i2) {
        if (!this.intersectsPolys(new $dfa764e5b7165555$var$LineSegment(u.x, u.y, v.x, v.y), i1, i2)) this.E.push(new $dfa764e5b7165555$var$VisibilityEdge(u.vv, v.vv));
    };
    TangentVisibilityGraph.prototype.addPoint = function(p, i1) {
        var n = this.P.length;
        this.V.push(new $dfa764e5b7165555$var$VisibilityVertex(this.V.length, n, 0, p));
        for(var i = 0; i < n; ++i){
            if (i === i1) continue;
            var poly = this.P[i], t = $dfa764e5b7165555$var$tangent_PointPolyC(p, poly);
            this.addEdgeIfVisible(p, poly[t.ltan], i1, i);
            this.addEdgeIfVisible(p, poly[t.rtan], i1, i);
        }
        return p.vv;
    };
    TangentVisibilityGraph.prototype.intersectsPolys = function(l, i1, i2) {
        for(var i = 0, n = this.P.length; i < n; ++i){
            if (i != i1 && i != i2 && $dfa764e5b7165555$var$intersects(l, this.P[i]).length > 0) return true;
        }
        return false;
    };
    return TangentVisibilityGraph;
}();
module.exports.TangentVisibilityGraph = $dfa764e5b7165555$var$TangentVisibilityGraph;
function $dfa764e5b7165555$var$intersects(l, P) {
    var ints = [];
    for(var i = 1, n = P.length; i < n; ++i){
        var int = $3Ag7S.Rectangle.lineIntersection(l.x1, l.y1, l.x2, l.y2, P[i - 1].x, P[i - 1].y, P[i].x, P[i].y);
        if (int) ints.push(int);
    }
    return ints;
}
function $dfa764e5b7165555$var$tangents(V, W) {
    var m = V.length - 1, n = W.length - 1;
    var bt = new $dfa764e5b7165555$var$BiTangents();
    for(var i = 0; i < m; ++i)for(var j = 0; j < n; ++j){
        var v1 = V[i == 0 ? m - 1 : i - 1];
        var v2 = V[i];
        var v3 = V[i + 1];
        var w1 = W[j == 0 ? n - 1 : j - 1];
        var w2 = W[j];
        var w3 = W[j + 1];
        var v1v2w2 = $dfa764e5b7165555$var$isLeft(v1, v2, w2);
        var v2w1w2 = $dfa764e5b7165555$var$isLeft(v2, w1, w2);
        var v2w2w3 = $dfa764e5b7165555$var$isLeft(v2, w2, w3);
        var w1w2v2 = $dfa764e5b7165555$var$isLeft(w1, w2, v2);
        var w2v1v2 = $dfa764e5b7165555$var$isLeft(w2, v1, v2);
        var w2v2v3 = $dfa764e5b7165555$var$isLeft(w2, v2, v3);
        if (v1v2w2 >= 0 && v2w1w2 >= 0 && v2w2w3 < 0 && w1w2v2 >= 0 && w2v1v2 >= 0 && w2v2v3 < 0) bt.ll = new $dfa764e5b7165555$var$BiTangent(i, j);
        else if (v1v2w2 <= 0 && v2w1w2 <= 0 && v2w2w3 > 0 && w1w2v2 <= 0 && w2v1v2 <= 0 && w2v2v3 > 0) bt.rr = new $dfa764e5b7165555$var$BiTangent(i, j);
        else if (v1v2w2 <= 0 && v2w1w2 > 0 && v2w2w3 <= 0 && w1w2v2 >= 0 && w2v1v2 < 0 && w2v2v3 >= 0) bt.rl = new $dfa764e5b7165555$var$BiTangent(i, j);
        else if (v1v2w2 >= 0 && v2w1w2 < 0 && v2w2w3 >= 0 && w1w2v2 <= 0 && w2v1v2 > 0 && w2v2v3 <= 0) bt.lr = new $dfa764e5b7165555$var$BiTangent(i, j);
    }
    return bt;
}
module.exports.tangents = $dfa764e5b7165555$var$tangents;
function $dfa764e5b7165555$var$isPointInsidePoly(p, poly) {
    for(var i = 1, n = poly.length; i < n; ++i)if ($dfa764e5b7165555$var$below(poly[i - 1], poly[i], p)) return false;
    return true;
}
function $dfa764e5b7165555$var$isAnyPInQ(p, q) {
    return !p.every(function(v) {
        return !$dfa764e5b7165555$var$isPointInsidePoly(v, q);
    });
}
function $dfa764e5b7165555$var$polysOverlap(p, q) {
    if ($dfa764e5b7165555$var$isAnyPInQ(p, q)) return true;
    if ($dfa764e5b7165555$var$isAnyPInQ(q, p)) return true;
    for(var i = 1, n = p.length; i < n; ++i){
        var v = p[i], u = p[i - 1];
        if ($dfa764e5b7165555$var$intersects(new $dfa764e5b7165555$var$LineSegment(u.x, u.y, v.x, v.y), q).length > 0) return true;
    }
    return false;
}
module.exports.polysOverlap = $dfa764e5b7165555$var$polysOverlap;

});

parcelRegister("7Zh26", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5d0b71459f4e0023$var$packingOptions = {
    PADDING: 10,
    GOLDEN_SECTION: (1 + Math.sqrt(5)) / 2,
    FLOAT_EPSILON: 0.0001,
    MAX_INERATIONS: 100
};
function $5d0b71459f4e0023$var$applyPacking(graphs, w, h, node_size, desired_ratio, centerGraph) {
    if (desired_ratio === void 0) desired_ratio = 1;
    if (centerGraph === void 0) centerGraph = true;
    var init_x = 0, init_y = 0, svg_width = w, svg_height = h, desired_ratio = typeof desired_ratio !== 'undefined' ? desired_ratio : 1, node_size = typeof node_size !== 'undefined' ? node_size : 0, real_width = 0, real_height = 0, min_width = 0, global_bottom = 0, line = [];
    if (graphs.length == 0) return;
    calculate_bb(graphs);
    apply(graphs, desired_ratio);
    if (centerGraph) put_nodes_to_right_positions(graphs);
    function calculate_bb(graphs) {
        graphs.forEach(function(g) {
            calculate_single_bb(g);
        });
        function calculate_single_bb(graph) {
            var min_x = Number.MAX_VALUE, min_y = Number.MAX_VALUE, max_x = 0, max_y = 0;
            graph.array.forEach(function(v) {
                var w = typeof v.width !== 'undefined' ? v.width : node_size;
                var h = typeof v.height !== 'undefined' ? v.height : node_size;
                w /= 2;
                h /= 2;
                max_x = Math.max(v.x + w, max_x);
                min_x = Math.min(v.x - w, min_x);
                max_y = Math.max(v.y + h, max_y);
                min_y = Math.min(v.y - h, min_y);
            });
            graph.width = max_x - min_x;
            graph.height = max_y - min_y;
        }
    }
    function put_nodes_to_right_positions(graphs) {
        graphs.forEach(function(g) {
            var center = {
                x: 0,
                y: 0
            };
            g.array.forEach(function(node) {
                center.x += node.x;
                center.y += node.y;
            });
            center.x /= g.array.length;
            center.y /= g.array.length;
            var corner = {
                x: center.x - g.width / 2,
                y: center.y - g.height / 2
            };
            var offset = {
                x: g.x - corner.x + svg_width / 2 - real_width / 2,
                y: g.y - corner.y + svg_height / 2 - real_height / 2
            };
            g.array.forEach(function(node) {
                node.x += offset.x;
                node.y += offset.y;
            });
        });
    }
    function apply(data, desired_ratio) {
        var curr_best_f = Number.POSITIVE_INFINITY;
        var curr_best = 0;
        data.sort(function(a, b) {
            return b.height - a.height;
        });
        min_width = data.reduce(function(a, b) {
            return a.width < b.width ? a.width : b.width;
        });
        var left = x1 = min_width;
        var right = x2 = get_entire_width(data);
        var iterationCounter = 0;
        var f_x1 = Number.MAX_VALUE;
        var f_x2 = Number.MAX_VALUE;
        var flag = -1;
        var dx = Number.MAX_VALUE;
        var df = Number.MAX_VALUE;
        while(dx > min_width || df > $5d0b71459f4e0023$var$packingOptions.FLOAT_EPSILON){
            if (flag != 1) {
                var x1 = right - (right - left) / $5d0b71459f4e0023$var$packingOptions.GOLDEN_SECTION;
                var f_x1 = step(data, x1);
            }
            if (flag != 0) {
                var x2 = left + (right - left) / $5d0b71459f4e0023$var$packingOptions.GOLDEN_SECTION;
                var f_x2 = step(data, x2);
            }
            dx = Math.abs(x1 - x2);
            df = Math.abs(f_x1 - f_x2);
            if (f_x1 < curr_best_f) {
                curr_best_f = f_x1;
                curr_best = x1;
            }
            if (f_x2 < curr_best_f) {
                curr_best_f = f_x2;
                curr_best = x2;
            }
            if (f_x1 > f_x2) {
                left = x1;
                x1 = x2;
                f_x1 = f_x2;
                flag = 1;
            } else {
                right = x2;
                x2 = x1;
                f_x2 = f_x1;
                flag = 0;
            }
            if (iterationCounter++ > 100) break;
        }
        step(data, curr_best);
    }
    function step(data, max_width) {
        line = [];
        real_width = 0;
        real_height = 0;
        global_bottom = init_y;
        for(var i = 0; i < data.length; i++){
            var o = data[i];
            put_rect(o, max_width);
        }
        return Math.abs(get_real_ratio() - desired_ratio);
    }
    function put_rect(rect, max_width) {
        var parent = undefined;
        for(var i = 0; i < line.length; i++)if (line[i].space_left >= rect.height && line[i].x + line[i].width + rect.width + $5d0b71459f4e0023$var$packingOptions.PADDING - max_width <= $5d0b71459f4e0023$var$packingOptions.FLOAT_EPSILON) {
            parent = line[i];
            break;
        }
        line.push(rect);
        if (parent !== undefined) {
            rect.x = parent.x + parent.width + $5d0b71459f4e0023$var$packingOptions.PADDING;
            rect.y = parent.bottom;
            rect.space_left = rect.height;
            rect.bottom = rect.y;
            parent.space_left -= rect.height + $5d0b71459f4e0023$var$packingOptions.PADDING;
            parent.bottom += rect.height + $5d0b71459f4e0023$var$packingOptions.PADDING;
        } else {
            rect.y = global_bottom;
            global_bottom += rect.height + $5d0b71459f4e0023$var$packingOptions.PADDING;
            rect.x = init_x;
            rect.bottom = rect.y;
            rect.space_left = rect.height;
        }
        if (rect.y + rect.height - real_height > -$5d0b71459f4e0023$var$packingOptions.FLOAT_EPSILON) real_height = rect.y + rect.height - init_y;
        if (rect.x + rect.width - real_width > -$5d0b71459f4e0023$var$packingOptions.FLOAT_EPSILON) real_width = rect.x + rect.width - init_x;
    }
    function get_entire_width(data) {
        var width = 0;
        data.forEach(function(d) {
            return width += d.width + $5d0b71459f4e0023$var$packingOptions.PADDING;
        });
        return width;
    }
    function get_real_ratio() {
        return real_width / real_height;
    }
}
module.exports.applyPacking = $5d0b71459f4e0023$var$applyPacking;
function $5d0b71459f4e0023$var$separateGraphs(nodes, links) {
    var marks = {};
    var ways = {};
    var graphs = [];
    var clusters = 0;
    for(var i = 0; i < links.length; i++){
        var link = links[i];
        var n1 = link.source;
        var n2 = link.target;
        if (ways[n1.index]) ways[n1.index].push(n2);
        else ways[n1.index] = [
            n2
        ];
        if (ways[n2.index]) ways[n2.index].push(n1);
        else ways[n2.index] = [
            n1
        ];
    }
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (marks[node.index]) continue;
        explore_node(node, true);
    }
    function explore_node(n, is_new) {
        if (marks[n.index] !== undefined) return;
        if (is_new) {
            clusters++;
            graphs.push({
                array: []
            });
        }
        marks[n.index] = clusters;
        graphs[clusters - 1].array.push(n);
        var adjacent = ways[n.index];
        if (!adjacent) return;
        for(var j = 0; j < adjacent.length; j++)explore_node(adjacent[j], false);
    }
    return graphs;
}
module.exports.separateGraphs = $5d0b71459f4e0023$var$separateGraphs;

});



parcelRegister("iSn6X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j3AxH = parcelRequire("j3AxH");

var $kWmCB = parcelRequire("kWmCB");
function $dbdf328c49a5424d$var$d3adaptor(d3Context) {
    if (!d3Context || $dbdf328c49a5424d$var$isD3V3(d3Context)) return new $j3AxH.D3StyleLayoutAdaptor();
    return new $kWmCB.D3StyleLayoutAdaptor(d3Context);
}
module.exports.d3adaptor = $dbdf328c49a5424d$var$d3adaptor;
function $dbdf328c49a5424d$var$isD3V3(d3Context) {
    var v3exp = /^3\./;
    return d3Context.version && d3Context.version.match(v3exp) !== null;
}

});
parcelRegister("j3AxH", function(module, exports) {
"use strict";
var $ddfaa4bba4b27f61$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7Nh9M = parcelRequire("7Nh9M");
var $ddfaa4bba4b27f61$var$D3StyleLayoutAdaptor = function(_super) {
    $ddfaa4bba4b27f61$var$__extends(D3StyleLayoutAdaptor, _super);
    function D3StyleLayoutAdaptor() {
        var _this = _super.call(this) || this;
        _this.event = d3.dispatch($7Nh9M.EventType[$7Nh9M.EventType.start], $7Nh9M.EventType[$7Nh9M.EventType.tick], $7Nh9M.EventType[$7Nh9M.EventType.end]);
        var d3layout = _this;
        var drag;
        _this.drag = function() {
            if (!drag) var drag = d3.behavior.drag().origin($7Nh9M.Layout.dragOrigin).on("dragstart.d3adaptor", $7Nh9M.Layout.dragStart).on("drag.d3adaptor", function(d) {
                $7Nh9M.Layout.drag(d, d3.event);
                d3layout.resume();
            }).on("dragend.d3adaptor", $7Nh9M.Layout.dragEnd);
            if (!arguments.length) return drag;
            this.call(drag);
        };
        return _this;
    }
    D3StyleLayoutAdaptor.prototype.trigger = function(e) {
        var d3event = {
            type: $7Nh9M.EventType[e.type],
            alpha: e.alpha,
            stress: e.stress
        };
        this.event[d3event.type](d3event);
    };
    D3StyleLayoutAdaptor.prototype.kick = function() {
        var _this = this;
        d3.timer(function() {
            return _super.prototype.tick.call(_this);
        });
    };
    D3StyleLayoutAdaptor.prototype.on = function(eventType, listener) {
        if (typeof eventType === 'string') this.event.on(eventType, listener);
        else this.event.on($7Nh9M.EventType[eventType], listener);
        return this;
    };
    return D3StyleLayoutAdaptor;
}($7Nh9M.Layout);
module.exports.D3StyleLayoutAdaptor = $ddfaa4bba4b27f61$var$D3StyleLayoutAdaptor;
function $ddfaa4bba4b27f61$var$d3adaptor() {
    return new $ddfaa4bba4b27f61$var$D3StyleLayoutAdaptor();
}
module.exports.d3adaptor = $ddfaa4bba4b27f61$var$d3adaptor;

});

parcelRegister("kWmCB", function(module, exports) {
"use strict";
var $f3eac598732c44f5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7Nh9M = parcelRequire("7Nh9M");
var $f3eac598732c44f5$var$D3StyleLayoutAdaptor = function(_super) {
    $f3eac598732c44f5$var$__extends(D3StyleLayoutAdaptor, _super);
    function D3StyleLayoutAdaptor(d3Context) {
        var _this = _super.call(this) || this;
        _this.d3Context = d3Context;
        _this.event = d3Context.dispatch($7Nh9M.EventType[$7Nh9M.EventType.start], $7Nh9M.EventType[$7Nh9M.EventType.tick], $7Nh9M.EventType[$7Nh9M.EventType.end]);
        var d3layout = _this;
        var drag;
        _this.drag = function() {
            if (!drag) var drag = d3Context.drag().subject($7Nh9M.Layout.dragOrigin).on("start.d3adaptor", $7Nh9M.Layout.dragStart).on("drag.d3adaptor", function(d) {
                $7Nh9M.Layout.drag(d, d3Context.event);
                d3layout.resume();
            }).on("end.d3adaptor", $7Nh9M.Layout.dragEnd);
            if (!arguments.length) return drag;
            arguments[0].call(drag);
        };
        return _this;
    }
    D3StyleLayoutAdaptor.prototype.trigger = function(e) {
        var d3event = {
            type: $7Nh9M.EventType[e.type],
            alpha: e.alpha,
            stress: e.stress
        };
        this.event.call(d3event.type, d3event);
    };
    D3StyleLayoutAdaptor.prototype.kick = function() {
        var _this = this;
        var t = this.d3Context.timer(function() {
            return _super.prototype.tick.call(_this) && t.stop();
        });
    };
    D3StyleLayoutAdaptor.prototype.on = function(eventType, listener) {
        if (typeof eventType === 'string') this.event.on(eventType, listener);
        else this.event.on($7Nh9M.EventType[eventType], listener);
        return this;
    };
    return D3StyleLayoutAdaptor;
}($7Nh9M.Layout);
module.exports.D3StyleLayoutAdaptor = $f3eac598732c44f5$var$D3StyleLayoutAdaptor;

});


parcelRegister("hncMr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ag7S = parcelRequire("3Ag7S");

var $avbEL = parcelRequire("avbEL");

var $6PjXM = parcelRequire("6PjXM");
var $ca5e7f893d814187$var$NodeWrapper = function() {
    function NodeWrapper(id, rect, children) {
        this.id = id;
        this.rect = rect;
        this.children = children;
        this.leaf = typeof children === 'undefined' || children.length === 0;
    }
    return NodeWrapper;
}();
module.exports.NodeWrapper = $ca5e7f893d814187$var$NodeWrapper;
var $ca5e7f893d814187$var$Vert = function() {
    function Vert(id, x, y, node, line) {
        if (node === void 0) node = null;
        if (line === void 0) line = null;
        this.id = id;
        this.x = x;
        this.y = y;
        this.node = node;
        this.line = line;
    }
    return Vert;
}();
module.exports.Vert = $ca5e7f893d814187$var$Vert;
var $ca5e7f893d814187$var$LongestCommonSubsequence = function() {
    function LongestCommonSubsequence(s, t) {
        this.s = s;
        this.t = t;
        var mf = LongestCommonSubsequence.findMatch(s, t);
        var tr = t.slice(0).reverse();
        var mr = LongestCommonSubsequence.findMatch(s, tr);
        if (mf.length >= mr.length) {
            this.length = mf.length;
            this.si = mf.si;
            this.ti = mf.ti;
            this.reversed = false;
        } else {
            this.length = mr.length;
            this.si = mr.si;
            this.ti = t.length - mr.ti - mr.length;
            this.reversed = true;
        }
    }
    LongestCommonSubsequence.findMatch = function(s, t) {
        var m = s.length;
        var n = t.length;
        var match = {
            length: 0,
            si: -1,
            ti: -1
        };
        var l = new Array(m);
        for(var i = 0; i < m; i++){
            l[i] = new Array(n);
            for(var j = 0; j < n; j++)if (s[i] === t[j]) {
                var v = l[i][j] = i === 0 || j === 0 ? 1 : l[i - 1][j - 1] + 1;
                if (v > match.length) {
                    match.length = v;
                    match.si = i - v + 1;
                    match.ti = j - v + 1;
                }
            } else l[i][j] = 0;
        }
        return match;
    };
    LongestCommonSubsequence.prototype.getSequence = function() {
        return this.length >= 0 ? this.s.slice(this.si, this.si + this.length) : [];
    };
    return LongestCommonSubsequence;
}();
module.exports.LongestCommonSubsequence = $ca5e7f893d814187$var$LongestCommonSubsequence;
var $ca5e7f893d814187$var$GridRouter = function() {
    function GridRouter(originalnodes, accessor, groupPadding) {
        var _this = this;
        if (groupPadding === void 0) groupPadding = 12;
        this.originalnodes = originalnodes;
        this.groupPadding = groupPadding;
        this.leaves = null;
        this.nodes = originalnodes.map(function(v, i) {
            return new $ca5e7f893d814187$var$NodeWrapper(i, accessor.getBounds(v), accessor.getChildren(v));
        });
        this.leaves = this.nodes.filter(function(v) {
            return v.leaf;
        });
        this.groups = this.nodes.filter(function(g) {
            return !g.leaf;
        });
        this.cols = this.getGridLines('x');
        this.rows = this.getGridLines('y');
        this.groups.forEach(function(v) {
            return v.children.forEach(function(c) {
                return _this.nodes[c].parent = v;
            });
        });
        this.root = {
            children: []
        };
        this.nodes.forEach(function(v) {
            if (typeof v.parent === 'undefined') {
                v.parent = _this.root;
                _this.root.children.push(v.id);
            }
            v.ports = [];
        });
        this.backToFront = this.nodes.slice(0);
        this.backToFront.sort(function(x, y) {
            return _this.getDepth(x) - _this.getDepth(y);
        });
        var frontToBackGroups = this.backToFront.slice(0).reverse().filter(function(g) {
            return !g.leaf;
        });
        frontToBackGroups.forEach(function(v) {
            var r = $3Ag7S.Rectangle.empty();
            v.children.forEach(function(c) {
                return r = r.union(_this.nodes[c].rect);
            });
            v.rect = r.inflate(_this.groupPadding);
        });
        var colMids = this.midPoints(this.cols.map(function(r) {
            return r.pos;
        }));
        var rowMids = this.midPoints(this.rows.map(function(r) {
            return r.pos;
        }));
        var rowx = colMids[0], rowX = colMids[colMids.length - 1];
        var coly = rowMids[0], colY = rowMids[rowMids.length - 1];
        var hlines = this.rows.map(function(r) {
            return {
                x1: rowx,
                x2: rowX,
                y1: r.pos,
                y2: r.pos
            };
        }).concat(rowMids.map(function(m) {
            return {
                x1: rowx,
                x2: rowX,
                y1: m,
                y2: m
            };
        }));
        var vlines = this.cols.map(function(c) {
            return {
                x1: c.pos,
                x2: c.pos,
                y1: coly,
                y2: colY
            };
        }).concat(colMids.map(function(m) {
            return {
                x1: m,
                x2: m,
                y1: coly,
                y2: colY
            };
        }));
        var lines = hlines.concat(vlines);
        lines.forEach(function(l) {
            return l.verts = [];
        });
        this.verts = [];
        this.edges = [];
        hlines.forEach(function(h) {
            return vlines.forEach(function(v) {
                var p = new $ca5e7f893d814187$var$Vert(_this.verts.length, v.x1, h.y1);
                h.verts.push(p);
                v.verts.push(p);
                _this.verts.push(p);
                var i = _this.backToFront.length;
                while(i-- > 0){
                    var node = _this.backToFront[i], r = node.rect;
                    var dx = Math.abs(p.x - r.cx()), dy = Math.abs(p.y - r.cy());
                    if (dx < r.width() / 2 && dy < r.height() / 2) {
                        p.node = node;
                        break;
                    }
                }
            });
        });
        lines.forEach(function(l, li) {
            _this.nodes.forEach(function(v, i) {
                v.rect.lineIntersections(l.x1, l.y1, l.x2, l.y2).forEach(function(intersect, j) {
                    var p = new $ca5e7f893d814187$var$Vert(_this.verts.length, intersect.x, intersect.y, v, l);
                    _this.verts.push(p);
                    l.verts.push(p);
                    v.ports.push(p);
                });
            });
            var isHoriz = Math.abs(l.y1 - l.y2) < 0.1;
            var delta = function(a, b) {
                return isHoriz ? b.x - a.x : b.y - a.y;
            };
            l.verts.sort(delta);
            for(var i = 1; i < l.verts.length; i++){
                var u = l.verts[i - 1], v = l.verts[i];
                if (u.node && u.node === v.node && u.node.leaf) continue;
                _this.edges.push({
                    source: u.id,
                    target: v.id,
                    length: Math.abs(delta(u, v))
                });
            }
        });
    }
    GridRouter.prototype.avg = function(a) {
        return a.reduce(function(x, y) {
            return x + y;
        }) / a.length;
    };
    GridRouter.prototype.getGridLines = function(axis) {
        var columns = [];
        var ls = this.leaves.slice(0, this.leaves.length);
        while(ls.length > 0){
            var overlapping = ls.filter(function(v) {
                return v.rect['overlap' + axis.toUpperCase()](ls[0].rect);
            });
            var col = {
                nodes: overlapping,
                pos: this.avg(overlapping.map(function(v) {
                    return v.rect['c' + axis]();
                }))
            };
            columns.push(col);
            col.nodes.forEach(function(v) {
                return ls.splice(ls.indexOf(v), 1);
            });
        }
        columns.sort(function(a, b) {
            return a.pos - b.pos;
        });
        return columns;
    };
    GridRouter.prototype.getDepth = function(v) {
        var depth = 0;
        while(v.parent !== this.root){
            depth++;
            v = v.parent;
        }
        return depth;
    };
    GridRouter.prototype.midPoints = function(a) {
        var gap = a[1] - a[0];
        var mids = [
            a[0] - gap / 2
        ];
        for(var i = 1; i < a.length; i++)mids.push((a[i] + a[i - 1]) / 2);
        mids.push(a[a.length - 1] + gap / 2);
        return mids;
    };
    GridRouter.prototype.findLineage = function(v) {
        var lineage = [
            v
        ];
        do {
            v = v.parent;
            lineage.push(v);
        }while (v !== this.root);
        return lineage.reverse();
    };
    GridRouter.prototype.findAncestorPathBetween = function(a, b) {
        var aa = this.findLineage(a), ba = this.findLineage(b), i = 0;
        while(aa[i] === ba[i])i++;
        return {
            commonAncestor: aa[i - 1],
            lineages: aa.slice(i).concat(ba.slice(i))
        };
    };
    GridRouter.prototype.siblingObstacles = function(a, b) {
        var _this = this;
        var path = this.findAncestorPathBetween(a, b);
        var lineageLookup = {};
        path.lineages.forEach(function(v) {
            return lineageLookup[v.id] = {};
        });
        var obstacles = path.commonAncestor.children.filter(function(v) {
            return !(v in lineageLookup);
        });
        path.lineages.filter(function(v) {
            return v.parent !== path.commonAncestor;
        }).forEach(function(v) {
            return obstacles = obstacles.concat(v.parent.children.filter(function(c) {
                return c !== v.id;
            }));
        });
        return obstacles.map(function(v) {
            return _this.nodes[v];
        });
    };
    GridRouter.getSegmentSets = function(routes, x, y) {
        var vsegments = [];
        for(var ei = 0; ei < routes.length; ei++){
            var route = routes[ei];
            for(var si = 0; si < route.length; si++){
                var s = route[si];
                s.edgeid = ei;
                s.i = si;
                var sdx = s[1][x] - s[0][x];
                if (Math.abs(sdx) < 0.1) vsegments.push(s);
            }
        }
        vsegments.sort(function(a, b) {
            return a[0][x] - b[0][x];
        });
        var vsegmentsets = [];
        var segmentset = null;
        for(var i = 0; i < vsegments.length; i++){
            var s = vsegments[i];
            if (!segmentset || Math.abs(s[0][x] - segmentset.pos) > 0.1) {
                segmentset = {
                    pos: s[0][x],
                    segments: []
                };
                vsegmentsets.push(segmentset);
            }
            segmentset.segments.push(s);
        }
        return vsegmentsets;
    };
    GridRouter.nudgeSegs = function(x, y, routes, segments, leftOf, gap) {
        var n = segments.length;
        if (n <= 1) return;
        var vs = segments.map(function(s) {
            return new $avbEL.Variable(s[0][x]);
        });
        var cs = [];
        for(var i = 0; i < n; i++)for(var j = 0; j < n; j++){
            if (i === j) continue;
            var s1 = segments[i], s2 = segments[j], e1 = s1.edgeid, e2 = s2.edgeid, lind = -1, rind = -1;
            if (x == 'x') {
                if (leftOf(e1, e2)) {
                    if (s1[0][y] < s1[1][y]) lind = j, rind = i;
                    else lind = i, rind = j;
                }
            } else if (leftOf(e1, e2)) {
                if (s1[0][y] < s1[1][y]) lind = i, rind = j;
                else lind = j, rind = i;
            }
            if (lind >= 0) cs.push(new $avbEL.Constraint(vs[lind], vs[rind], gap));
        }
        var solver = new $avbEL.Solver(vs, cs);
        solver.solve();
        vs.forEach(function(v, i) {
            var s = segments[i];
            var pos = v.position();
            s[0][x] = s[1][x] = pos;
            var route = routes[s.edgeid];
            if (s.i > 0) route[s.i - 1][1][x] = pos;
            if (s.i < route.length - 1) route[s.i + 1][0][x] = pos;
        });
    };
    GridRouter.nudgeSegments = function(routes, x, y, leftOf, gap) {
        var vsegmentsets = GridRouter.getSegmentSets(routes, x, y);
        for(var i = 0; i < vsegmentsets.length; i++){
            var ss = vsegmentsets[i];
            var events = [];
            for(var j = 0; j < ss.segments.length; j++){
                var s = ss.segments[j];
                events.push({
                    type: 0,
                    s: s,
                    pos: Math.min(s[0][y], s[1][y])
                });
                events.push({
                    type: 1,
                    s: s,
                    pos: Math.max(s[0][y], s[1][y])
                });
            }
            events.sort(function(a, b) {
                return a.pos - b.pos + a.type - b.type;
            });
            var open = [];
            var openCount = 0;
            events.forEach(function(e) {
                if (e.type === 0) {
                    open.push(e.s);
                    openCount++;
                } else openCount--;
                if (openCount == 0) {
                    GridRouter.nudgeSegs(x, y, routes, open, leftOf, gap);
                    open = [];
                }
            });
        }
    };
    GridRouter.prototype.routeEdges = function(edges, nudgeGap, source, target) {
        var _this = this;
        var routePaths = edges.map(function(e) {
            return _this.route(source(e), target(e));
        });
        var order = GridRouter.orderEdges(routePaths);
        var routes = routePaths.map(function(e) {
            return GridRouter.makeSegments(e);
        });
        GridRouter.nudgeSegments(routes, 'x', 'y', order, nudgeGap);
        GridRouter.nudgeSegments(routes, 'y', 'x', order, nudgeGap);
        GridRouter.unreverseEdges(routes, routePaths);
        return routes;
    };
    GridRouter.unreverseEdges = function(routes, routePaths) {
        routes.forEach(function(segments, i) {
            var path = routePaths[i];
            if (path.reversed) {
                segments.reverse();
                segments.forEach(function(segment) {
                    segment.reverse();
                });
            }
        });
    };
    GridRouter.angleBetween2Lines = function(line1, line2) {
        var angle1 = Math.atan2(line1[0].y - line1[1].y, line1[0].x - line1[1].x);
        var angle2 = Math.atan2(line2[0].y - line2[1].y, line2[0].x - line2[1].x);
        var diff = angle1 - angle2;
        if (diff > Math.PI || diff < -Math.PI) diff = angle2 - angle1;
        return diff;
    };
    GridRouter.isLeft = function(a, b, c) {
        return (b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x) <= 0;
    };
    GridRouter.getOrder = function(pairs) {
        var outgoing = {};
        for(var i = 0; i < pairs.length; i++){
            var p = pairs[i];
            if (typeof outgoing[p.l] === 'undefined') outgoing[p.l] = {};
            outgoing[p.l][p.r] = true;
        }
        return function(l, r) {
            return typeof outgoing[l] !== 'undefined' && outgoing[l][r];
        };
    };
    GridRouter.orderEdges = function(edges) {
        var edgeOrder = [];
        for(var i = 0; i < edges.length - 1; i++)for(var j = i + 1; j < edges.length; j++){
            var e = edges[i], f = edges[j], lcs = new $ca5e7f893d814187$var$LongestCommonSubsequence(e, f);
            var u, vi, vj;
            if (lcs.length === 0) continue;
            if (lcs.reversed) {
                f.reverse();
                f.reversed = true;
                lcs = new $ca5e7f893d814187$var$LongestCommonSubsequence(e, f);
            }
            if ((lcs.si <= 0 || lcs.ti <= 0) && (lcs.si + lcs.length >= e.length || lcs.ti + lcs.length >= f.length)) {
                edgeOrder.push({
                    l: i,
                    r: j
                });
                continue;
            }
            if (lcs.si + lcs.length >= e.length || lcs.ti + lcs.length >= f.length) {
                u = e[lcs.si + 1];
                vj = e[lcs.si - 1];
                vi = f[lcs.ti - 1];
            } else {
                u = e[lcs.si + lcs.length - 2];
                vi = e[lcs.si + lcs.length];
                vj = f[lcs.ti + lcs.length];
            }
            if (GridRouter.isLeft(u, vi, vj)) edgeOrder.push({
                l: j,
                r: i
            });
            else edgeOrder.push({
                l: i,
                r: j
            });
        }
        return GridRouter.getOrder(edgeOrder);
    };
    GridRouter.makeSegments = function(path) {
        function copyPoint(p) {
            return {
                x: p.x,
                y: p.y
            };
        }
        var isStraight = function(a, b, c) {
            return Math.abs((b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x)) < 0.001;
        };
        var segments = [];
        var a = copyPoint(path[0]);
        for(var i = 1; i < path.length; i++){
            var b = copyPoint(path[i]), c = i < path.length - 1 ? path[i + 1] : null;
            if (!c || !isStraight(a, b, c)) {
                segments.push([
                    a,
                    b
                ]);
                a = b;
            }
        }
        return segments;
    };
    GridRouter.prototype.route = function(s, t) {
        var _this = this;
        var source = this.nodes[s], target = this.nodes[t];
        this.obstacles = this.siblingObstacles(source, target);
        var obstacleLookup = {};
        this.obstacles.forEach(function(o) {
            return obstacleLookup[o.id] = o;
        });
        this.passableEdges = this.edges.filter(function(e) {
            var u = _this.verts[e.source], v = _this.verts[e.target];
            return !(u.node && u.node.id in obstacleLookup || v.node && v.node.id in obstacleLookup);
        });
        for(var i = 1; i < source.ports.length; i++){
            var u = source.ports[0].id;
            var v = source.ports[i].id;
            this.passableEdges.push({
                source: u,
                target: v,
                length: 0
            });
        }
        for(var i = 1; i < target.ports.length; i++){
            var u = target.ports[0].id;
            var v = target.ports[i].id;
            this.passableEdges.push({
                source: u,
                target: v,
                length: 0
            });
        }
        var getSource = function(e) {
            return e.source;
        }, getTarget = function(e) {
            return e.target;
        }, getLength = function(e) {
            return e.length;
        };
        var shortestPathCalculator = new $6PjXM.Calculator(this.verts.length, this.passableEdges, getSource, getTarget, getLength);
        var bendPenalty = function(u, v, w) {
            var a = _this.verts[u], b = _this.verts[v], c = _this.verts[w];
            var dx = Math.abs(c.x - a.x), dy = Math.abs(c.y - a.y);
            if (a.node === source && a.node === b.node || b.node === target && b.node === c.node) return 0;
            return dx > 1 && dy > 1 ? 1000 : 0;
        };
        var shortestPath = shortestPathCalculator.PathFromNodeToNodeWithPrevCost(source.ports[0].id, target.ports[0].id, bendPenalty);
        var pathPoints = shortestPath.reverse().map(function(vi) {
            return _this.verts[vi];
        });
        pathPoints.push(this.nodes[target.id].ports[0]);
        return pathPoints.filter(function(v, i) {
            return !(i < pathPoints.length - 1 && pathPoints[i + 1].node === source && v.node === source || i > 0 && v.node === target && pathPoints[i - 1].node === target);
        });
    };
    GridRouter.getRoutePath = function(route, cornerradius, arrowwidth, arrowheight) {
        var result = {
            routepath: 'M ' + route[0][0].x + ' ' + route[0][0].y + ' ',
            arrowpath: ''
        };
        if (route.length > 1) for(var i = 0; i < route.length; i++){
            var li = route[i];
            var x = li[1].x, y = li[1].y;
            var dx = x - li[0].x;
            var dy = y - li[0].y;
            if (i < route.length - 1) {
                if (Math.abs(dx) > 0) x -= dx / Math.abs(dx) * cornerradius;
                else y -= dy / Math.abs(dy) * cornerradius;
                result.routepath += 'L ' + x + ' ' + y + ' ';
                var l = route[i + 1];
                var x0 = l[0].x, y0 = l[0].y;
                var x1 = l[1].x;
                var y1 = l[1].y;
                dx = x1 - x0;
                dy = y1 - y0;
                var angle = GridRouter.angleBetween2Lines(li, l) < 0 ? 1 : 0;
                var x2, y2;
                if (Math.abs(dx) > 0) {
                    x2 = x0 + dx / Math.abs(dx) * cornerradius;
                    y2 = y0;
                } else {
                    x2 = x0;
                    y2 = y0 + dy / Math.abs(dy) * cornerradius;
                }
                var cx = Math.abs(x2 - x);
                var cy = Math.abs(y2 - y);
                result.routepath += 'A ' + cx + ' ' + cy + ' 0 0 ' + angle + ' ' + x2 + ' ' + y2 + ' ';
            } else {
                var arrowtip = [
                    x,
                    y
                ];
                var arrowcorner1, arrowcorner2;
                if (Math.abs(dx) > 0) {
                    x -= dx / Math.abs(dx) * arrowheight;
                    arrowcorner1 = [
                        x,
                        y + arrowwidth
                    ];
                    arrowcorner2 = [
                        x,
                        y - arrowwidth
                    ];
                } else {
                    y -= dy / Math.abs(dy) * arrowheight;
                    arrowcorner1 = [
                        x + arrowwidth,
                        y
                    ];
                    arrowcorner2 = [
                        x - arrowwidth,
                        y
                    ];
                }
                result.routepath += 'L ' + x + ' ' + y + ' ';
                if (arrowheight > 0) result.arrowpath = 'M ' + arrowtip[0] + ' ' + arrowtip[1] + ' L ' + arrowcorner1[0] + ' ' + arrowcorner1[1] + ' L ' + arrowcorner2[0] + ' ' + arrowcorner2[1];
            }
        }
        else {
            var li = route[0];
            var x = li[1].x, y = li[1].y;
            var dx = x - li[0].x;
            var dy = y - li[0].y;
            var arrowtip = [
                x,
                y
            ];
            var arrowcorner1, arrowcorner2;
            if (Math.abs(dx) > 0) {
                x -= dx / Math.abs(dx) * arrowheight;
                arrowcorner1 = [
                    x,
                    y + arrowwidth
                ];
                arrowcorner2 = [
                    x,
                    y - arrowwidth
                ];
            } else {
                y -= dy / Math.abs(dy) * arrowheight;
                arrowcorner1 = [
                    x + arrowwidth,
                    y
                ];
                arrowcorner2 = [
                    x - arrowwidth,
                    y
                ];
            }
            result.routepath += 'L ' + x + ' ' + y + ' ';
            if (arrowheight > 0) result.arrowpath = 'M ' + arrowtip[0] + ' ' + arrowtip[1] + ' L ' + arrowcorner1[0] + ' ' + arrowcorner1[1] + ' L ' + arrowcorner2[0] + ' ' + arrowcorner2[1];
        }
        return result;
    };
    return GridRouter;
}();
module.exports.GridRouter = $ca5e7f893d814187$var$GridRouter;

});

parcelRegister("cM6Dg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6PjXM = parcelRequire("6PjXM");

var $2tXhu = parcelRequire("2tXhu");

var $3Ag7S = parcelRequire("3Ag7S");

var $7PlJY = parcelRequire("7PlJY");
var $94cf1cc2f31890d2$var$Link3D = function() {
    function Link3D(source, target) {
        this.source = source;
        this.target = target;
    }
    Link3D.prototype.actualLength = function(x) {
        var _this = this;
        return Math.sqrt(x.reduce(function(c, v) {
            var dx = v[_this.target] - v[_this.source];
            return c + dx * dx;
        }, 0));
    };
    return Link3D;
}();
module.exports.Link3D = $94cf1cc2f31890d2$var$Link3D;
var $94cf1cc2f31890d2$var$Node3D = function() {
    function Node3D(x, y, z) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (z === void 0) z = 0;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    return Node3D;
}();
module.exports.Node3D = $94cf1cc2f31890d2$var$Node3D;
var $94cf1cc2f31890d2$var$Layout3D = function() {
    function Layout3D(nodes, links, idealLinkLength) {
        var _this = this;
        if (idealLinkLength === void 0) idealLinkLength = 1;
        this.nodes = nodes;
        this.links = links;
        this.idealLinkLength = idealLinkLength;
        this.constraints = null;
        this.useJaccardLinkLengths = true;
        this.result = new Array(Layout3D.k);
        for(var i = 0; i < Layout3D.k; ++i)this.result[i] = new Array(nodes.length);
        nodes.forEach(function(v, i) {
            for(var _i = 0, _a = Layout3D.dims; _i < _a.length; _i++){
                var dim = _a[_i];
                if (typeof v[dim] == 'undefined') v[dim] = Math.random();
            }
            _this.result[0][i] = v.x;
            _this.result[1][i] = v.y;
            _this.result[2][i] = v.z;
        });
    }
    Layout3D.prototype.linkLength = function(l) {
        return l.actualLength(this.result);
    };
    Layout3D.prototype.start = function(iterations) {
        var _this = this;
        if (iterations === void 0) iterations = 100;
        var n = this.nodes.length;
        var linkAccessor = new $94cf1cc2f31890d2$var$LinkAccessor();
        if (this.useJaccardLinkLengths) $7PlJY.jaccardLinkLengths(this.links, linkAccessor, 1.5);
        this.links.forEach(function(e) {
            return e.length *= _this.idealLinkLength;
        });
        var distanceMatrix = new $6PjXM.Calculator(n, this.links, function(e) {
            return e.source;
        }, function(e) {
            return e.target;
        }, function(e) {
            return e.length;
        }).DistanceMatrix();
        var D = $2tXhu.Descent.createSquareMatrix(n, function(i, j) {
            return distanceMatrix[i][j];
        });
        var G = $2tXhu.Descent.createSquareMatrix(n, function() {
            return 2;
        });
        this.links.forEach(function(_a) {
            var source = _a.source, target = _a.target;
            return G[source][target] = G[target][source] = 1;
        });
        this.descent = new $2tXhu.Descent(this.result, D);
        this.descent.threshold = 1e-3;
        this.descent.G = G;
        if (this.constraints) this.descent.project = new $3Ag7S.Projection(this.nodes, null, null, this.constraints).projectFunctions();
        for(var i = 0; i < this.nodes.length; i++){
            var v = this.nodes[i];
            if (v.fixed) this.descent.locks.add(i, [
                v.x,
                v.y,
                v.z
            ]);
        }
        this.descent.run(iterations);
        return this;
    };
    Layout3D.prototype.tick = function() {
        this.descent.locks.clear();
        for(var i = 0; i < this.nodes.length; i++){
            var v = this.nodes[i];
            if (v.fixed) this.descent.locks.add(i, [
                v.x,
                v.y,
                v.z
            ]);
        }
        return this.descent.rungeKutta();
    };
    Layout3D.dims = [
        'x',
        'y',
        'z'
    ];
    Layout3D.k = Layout3D.dims.length;
    return Layout3D;
}();
module.exports.Layout3D = $94cf1cc2f31890d2$var$Layout3D;
var $94cf1cc2f31890d2$var$LinkAccessor = function() {
    function LinkAccessor() {}
    LinkAccessor.prototype.getSourceIndex = function(e) {
        return e.source;
    };
    LinkAccessor.prototype.getTargetIndex = function(e) {
        return e.target;
    };
    LinkAccessor.prototype.getLength = function(e) {
        return e.length;
    };
    LinkAccessor.prototype.setLength = function(e, l) {
        e.length = l;
    };
    return LinkAccessor;
}();

});

parcelRegister("2rXqV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7Nh9M = parcelRequire("7Nh9M");

var $hncMr = parcelRequire("hncMr");
function $1c8c349cd68a7dfd$var$gridify(pgLayout, nudgeGap, margin, groupMargin) {
    pgLayout.cola.start(0, 0, 0, 10, false);
    var gridrouter = $1c8c349cd68a7dfd$var$route(pgLayout.cola.nodes(), pgLayout.cola.groups(), margin, groupMargin);
    return gridrouter.routeEdges(pgLayout.powerGraph.powerEdges, nudgeGap, function(e) {
        return e.source.routerNode.id;
    }, function(e) {
        return e.target.routerNode.id;
    });
}
module.exports.gridify = $1c8c349cd68a7dfd$var$gridify;
function $1c8c349cd68a7dfd$var$route(nodes, groups, margin, groupMargin) {
    nodes.forEach(function(d) {
        d.routerNode = {
            name: d.name,
            bounds: d.bounds.inflate(-margin)
        };
    });
    groups.forEach(function(d) {
        d.routerNode = {
            bounds: d.bounds.inflate(-groupMargin),
            children: (typeof d.groups !== 'undefined' ? d.groups.map(function(c) {
                return nodes.length + c.id;
            }) : []).concat(typeof d.leaves !== 'undefined' ? d.leaves.map(function(c) {
                return c.index;
            }) : [])
        };
    });
    var gridRouterNodes = nodes.concat(groups).map(function(d, i) {
        d.routerNode.id = i;
        return d.routerNode;
    });
    return new $hncMr.GridRouter(gridRouterNodes, {
        getChildren: function(v) {
            return v.children;
        },
        getBounds: function(v) {
            return v.bounds;
        }
    }, margin - groupMargin);
}
function $1c8c349cd68a7dfd$var$powerGraphGridLayout(graph, size, grouppadding) {
    var powerGraph;
    graph.nodes.forEach(function(v, i) {
        return v.index = i;
    });
    new $7Nh9M.Layout().avoidOverlaps(false).nodes(graph.nodes).links(graph.links).powerGraphGroups(function(d) {
        powerGraph = d;
        powerGraph.groups.forEach(function(v) {
            return v.padding = grouppadding;
        });
    });
    var n = graph.nodes.length;
    var edges = [];
    var vs = graph.nodes.slice(0);
    vs.forEach(function(v, i) {
        return v.index = i;
    });
    powerGraph.groups.forEach(function(g) {
        var sourceInd = g.index = g.id + n;
        vs.push(g);
        if (typeof g.leaves !== 'undefined') g.leaves.forEach(function(v) {
            return edges.push({
                source: sourceInd,
                target: v.index
            });
        });
        if (typeof g.groups !== 'undefined') g.groups.forEach(function(gg) {
            return edges.push({
                source: sourceInd,
                target: gg.id + n
            });
        });
    });
    powerGraph.powerEdges.forEach(function(e) {
        edges.push({
            source: e.source.index,
            target: e.target.index
        });
    });
    new $7Nh9M.Layout().size(size).nodes(vs).links(edges).avoidOverlaps(false).linkDistance(30).symmetricDiffLinkLengths(5).convergenceThreshold(1e-4).start(100, 0, 0, 0, false);
    return {
        cola: new $7Nh9M.Layout().convergenceThreshold(1e-3).size(size).avoidOverlaps(true).nodes(graph.nodes).links(graph.links).groupCompactness(1e-4).linkDistance(30).symmetricDiffLinkLengths(5).powerGraphGroups(function(d) {
            powerGraph = d;
            powerGraph.groups.forEach(function(v) {
                v.padding = grouppadding;
            });
        }).start(50, 0, 100, 0, false),
        powerGraph: powerGraph
    };
}
module.exports.powerGraphGridLayout = $1c8c349cd68a7dfd$var$powerGraphGridLayout;

});


parcelRegister("46LIa", function(module, exports) {

(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory((parcelRequire("awvmd")));
})(module.exports, function(__WEBPACK_EXTERNAL_MODULE_0__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 6);
    /******/ }([
        /* 0 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_0__;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * This class implements data and functionality required for AVSDF layout per
 * circle.
 *
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ var LGraph = __webpack_require__(0).LGraph;
            // -----------------------------------------------------------------------------
            // Section: Initializations
            // -----------------------------------------------------------------------------
            function AVSDFCircle(parent, graphMgr, vObject) {
                LGraph.call(this, parent, graphMgr, vObject);
                this.inOrder = undefined;
                this.currentIndex = 0;
                this.nodeSeparation = undefined;
                this.stack = [];
                this.perimeter = 0;
                this.centerX = 0;
                this.centerY = 0;
                this.radius = 0;
            }
            AVSDFCircle.prototype = Object.create(LGraph.prototype);
            for(var property in LGraph)AVSDFCircle[property] = LGraph[property];
            AVSDFCircle.prototype.initOrdering = function() {
                this.inOrder = [];
            };
            // -----------------------------------------------------------------------------
            // Section: Accessor Functions
            // -----------------------------------------------------------------------------
            // This function returns the array in which the nodes of this circle are kept in order.
            AVSDFCircle.prototype.getOrder = function() {
                return this.inOrder;
            };
            // This function returns the x-coordinate of the center of this circle.
            AVSDFCircle.prototype.getCenterX = function() {
                return this.centerX;
            };
            // This function returns the y-coordinate of the center of this circle.
            AVSDFCircle.prototype.getCenterY = function() {
                return this.centerY;
            };
            // This function returns the radius of this circle.
            AVSDFCircle.prototype.getRadius = function() {
                return this.radius;
            };
            // This function returns the total number of vertices of this circle.
            AVSDFCircle.prototype.getSize = function() {
                return this.getNodes().length;
            };
            // This function calculates and returns the total number of crossings in this
            // circle by adding up the crossing number of individual nodes on it.
            AVSDFCircle.prototype.getTotalCrossingOfCircle = function() {
                var self = this;
                var crossingNumber = 0;
                for(var node in self.inOrder){
                    var nodeCrossing = node.getTotalCrossingOfEdges();
                    if (nodeCrossing === -1) return -1;
                    crossingNumber += nodeCrossing;
                }
                return crossingNumber / 4;
            };
            // This function checks whether or not all of the vertices of this circle are
            // assigned an index on the circle.
            AVSDFCircle.prototype.hasFinishedOrdering = function() {
                return this.currentIndex === this.getNodes().length;
            };
            // This function returns the node separation of this circle.
            AVSDFCircle.prototype.getNodeSeparation = function() {
                return this.nodeSeparation;
            };
            // This function sets the node separation of this circle.
            AVSDFCircle.prototype.setNodeSeparation = function(nodeSeparation) {
                this.nodeSeparation = nodeSeparation;
            };
            // -----------------------------------------------------------------------------
            // Section: Remaining Functions
            // -----------------------------------------------------------------------------
            // This function traverses the vertices of this circle and corrects the angle
            // of the vertices with respect to their circle indices.
            AVSDFCircle.prototype.correctAngles = function() {
                var self = this;
                self.currentIndex = 0;
                self.inOrder.forEach(function(node) {
                    return self.putInOrder(node);
                });
            };
            // This function puts the given node on the circle in the current order and
            // sets its angle appropriately.
            AVSDFCircle.prototype.putInOrder = function(node) {
                var self = this;
                var nodes = self.getNodes();
                // Note that id attribute of a node is added before
                // AVSDFLayout is called
                var found = false;
                for(var i = 0; i < nodes.length; i++)if (nodes[i].id == node.id) {
                    found = true;
                    break;
                }
                if (!found) throw "The node must be a member of LGraph";
                self.inOrder[self.currentIndex] = node;
                node.setIndex(self.currentIndex);
                if (self.currentIndex === 0) node.setAngle(0.0);
                else node.setAngle(self.inOrder[self.currentIndex - 1].getAngle() + 2 * Math.PI * (node.getDiagonal() / 2 + self.nodeSeparation + self.inOrder[self.currentIndex - 1].getDiagonal() / 2) / self.perimeter);
                self.currentIndex++;
            };
            // This function returns the next node to be placed on this circle with
            // respect to the AVSDF algorithm.
            AVSDFCircle.prototype.findNodeToPlace = function() {
                var self = this;
                var sDegreeNode = undefined;
                // Find the smallest degree vertex if the stack is empty
                if (self.stack.length === 0) sDegreeNode = self.findUnorderedSmallestDegreeNode();
                else {
                    var foundUnorderNode = false;
                    while(!foundUnorderNode && !(self.stack.length === 0)){
                        sDegreeNode = self.stack.pop();
                        foundUnorderNode = !sDegreeNode.isOrdered();
                    }
                    if (!foundUnorderNode) sDegreeNode = undefined;
                }
                // If no unordered vertex is found in the stack, find one
                // from the remaining ones
                if (sDegreeNode === undefined) sDegreeNode = self.findUnorderedSmallestDegreeNode();
                // Add the unordered neighbors of this node to the stack
                if (sDegreeNode !== undefined) {
                    var neighbors = sDegreeNode.getNeighborsSortedByDegree();
                    for(var i = neighbors.length - 1; i >= 0; i--){
                        var neighbor = neighbors[i];
                        if (!neighbor.isOrdered()) self.stack.push(neighbor);
                    }
                }
                return sDegreeNode;
            };
            // This function calculates the radius of this circle with respect to the sizes
            // of the vertices and the node separation parameter.
            AVSDFCircle.prototype.calculateRadius = function() {
                var self = this;
                var totalDiagonal = 0;
                self.getNodes().forEach(function(node) {
                    return totalDiagonal += Math.sqrt(node.getWidth() * node.getWidth() + node.getHeight() * node.getHeight());
                });
                self.perimeter = totalDiagonal + self.getNodes().length * self.nodeSeparation;
                var radius = self.perimeter / (2 * Math.PI);
                // Check here for possible error
                self.getParent().setWidth(2 * radius);
                self.getParent().setHeight(2 * radius);
                self.getParent().setCenter(self.getParent().getWidth(), self.getParent().getHeight());
                self.centerX = self.getParent().getCenterX();
                self.centerY = self.getParent().getCenterY();
                self.radius = self.getParent().getHeight() / 2;
            };
            // This function calculates the total number of crossings of all vertices of
            // this circle.
            AVSDFCircle.prototype.calculateEdgeCrossingsOfNodes = function() {
                this.getNodes().forEach(function(node) {
                    return node.calculateTotalCrossing();
                });
            };
            // This function sets the index of each vertex to its position in inOrder
            // array. Note that index of a node can be different from its place in the
            // array due to crossing reduction phase of the AVSDF algorithm. It loads
            // old index values to vertices due to an increase in the number of
            // crossings with the new indices.
            AVSDFCircle.prototype.loadOldIndicesOfNodes = function() {
                //this.inOrder.forEach( (node,index) => node.setIndex(index));
                var self = this;
                for(var i = 0; i < this.inOrder.length; i++)self.inOrder[i].setIndex(i);
            };
            // This function sets the position of each node in inOrder array to its index.
            // Note that index of a node can be different from its place in the inOrder
            // array due to crossing reduction phase of the AVSDF algorithm. This function
            // puts the nodes to their new index values in inOrder array due to a
            // decrease in the number of crossings with the new indices.
            AVSDFCircle.prototype.reOrderVertices = function() {
                var self = this;
                this.getNodes().forEach(function(node) {
                    return self.inOrder[node.getIndex()] = node;
                });
            };
            // This function finds and returns the unordered smallest degree vertex on
            // this circle.
            AVSDFCircle.prototype.findUnorderedSmallestDegreeNode = function() {
                var minDegree = Number.MAX_SAFE_INTEGER;
                var sDegreeNode = void 0;
                this.getNodes().forEach(function(node) {
                    if (node.getDegree() < minDegree && !node.isOrdered()) {
                        minDegree = node.getDegree();
                        sDegreeNode = node;
                    }
                });
                return sDegreeNode;
            };
            module1.exports = AVSDFCircle;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LayoutConstants = __webpack_require__(0).LayoutConstants;
            function AVSDFConstants() {}
            // AVSDFConstants inherits properties in LayoutConstants
            for(var prop in LayoutConstants)AVSDFConstants[prop] = LayoutConstants[prop];
            AVSDFConstants.DEFAULT_NODE_SEPARATION = 60;
            module1.exports = AVSDFConstants;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * This class implements data and functionality required for AVSDF layout per
 * edge.
 *

 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ var LEdge = __webpack_require__(0).LEdge;
            // -----------------------------------------------------------------------------
            // Section: Initializations
            // -----------------------------------------------------------------------------
            function AVSDFEdge(source, target, vEdge) {
                LEdge.call(this, source, target, vEdge);
            }
            AVSDFEdge.prototype = Object.create(LEdge.prototype);
            for(var properties in LEdge)AVSDFEdge[properties] = LEdge[properties];
            // -----------------------------------------------------------------------------
            // Section: Accessor Functions
            // -----------------------------------------------------------------------------
            // The function getOtherEnd returns the other end of this edge.
            AVSDFEdge.prototype.getOtherEnd = function(node) {
                return LEdge.prototype.getOtherEnd(node);
            };
            // -----------------------------------------------------------------------------
            // Section: Remaining Functions
            // -----------------------------------------------------------------------------
            // This function checks whether this edge crosses with the input edge. It
            // returns false, if any of the vertices those edges are incident to are not
            // yet placed on the circle.
            AVSDFEdge.prototype.crossesWithEdge = function(otherEdge) {
                var self = this;
                var sourcePos = self.getSource().getIndex();
                var targetPos = self.getTarget().getIndex();
                var otherSourcePos = otherEdge.getSource().getIndex();
                var otherTargetPos = otherEdge.getTarget().getIndex();
                // if any of the vertices those two edges are not yet placed
                if (sourcePos === -1 || targetPos === -1 || otherSourcePos === -1 || otherTargetPos === -1) return false;
                var otherSourceDist = otherEdge.getSource().getCircDistWithTheNode(self.getSource());
                var otherTargetDist = otherEdge.getTarget().getCircDistWithTheNode(self.getSource());
                var thisTargetDist = self.getTarget().getCircDistWithTheNode(self.getSource());
                if (thisTargetDist < Math.max(otherSourceDist, otherTargetDist) && thisTargetDist > Math.min(otherSourceDist, otherTargetDist) && otherTargetDist !== 0 && otherSourceDist !== 0) return true;
                return false;
            };
            // This function returns 1 if this edge crosses with the input edge, 0
            // otherwise.
            AVSDFEdge.prototype.crossingWithEdge = function(otherEdge) {
                var self = this;
                var result = self.crossesWithEdge(otherEdge);
                return result ? 1 : 0;
            };
            // This function calculates the total number of crossings of this edge with
            // all the edges given in the input list.
            AVSDFEdge.prototype.calculateTotalCrossingWithList = function(edgeList) {
                var self = this;
                var totalCrossing = 0;
                edgeList.forEach(function(edge) {
                    return totalCrossing += self.crossingWithEdge(edge);
                });
                return totalCrossing;
            };
            module1.exports = AVSDFEdge;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * This class implements data and functionality required for AVSDF layout per
 * node.
 *
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ var LNode = __webpack_require__(0).LNode;
            var Quicksort = __webpack_require__(0).Quicksort;
            // -----------------------------------------------------------------------------
            // Section: Initializations
            // -----------------------------------------------------------------------------
            function AVSDFNode(gm, vNode, loc, size) {
                // Constructor 1: AVSDFNode(gm, vNode, loc, size)
                if (loc !== undefined && size !== undefined) LNode.call(this, gm, vNode, loc, size);
                else LNode.call(this, gm, vNode);
                // Angle of this node on the owner circle in radians
                this.angle = 0;
                // Index of this node on the owner circle
                this.circleIndex = -1;
                // Total number of crossings of the edges this node is incident to
                this.totalCrossingOfEdges = -1;
                // Whether the current edge crossing number is valid or it needs to be
                // recalculated
                this.isCrossingNumberValid = false;
            }
            AVSDFNode.prototype = Object.create(LNode.prototype);
            for(var properties in LNode)AVSDFNode[properties] = LNode[properties];
            // -----------------------------------------------------------------------------
            // Section: Accessor Functions
            // -----------------------------------------------------------------------------
            // This function returns the circle this node is owned by.
            AVSDFNode.prototype.getCircle = function() {
                return this.getOwner();
            };
            // This function sets the index of this node on the circle, and sets the
            // crossing number invalid. Due to the index change of the node; it needs to
            // be recalculated.
            AVSDFNode.prototype.setIndex = function(index) {
                this.circleIndex = index;
                this.isCrossingNumberValid = false;
            };
            // This function returns the index of this node in the ordering of its owner
            // circle. Here -1 means that the vertex is not yet placed on its owner
            //circle.
            AVSDFNode.prototype.getIndex = function() {
                return this.circleIndex;
            };
            // This function returns the array of the neigbors of this node sorted in
            // ascending order.
            AVSDFNode.prototype.getNeighborsSortedByDegree = function() {
                var self = this;
                var result = Array.from(self.getNeighborsList());
                result = result.filter(function(node) {
                    return node.getIndex() === -1;
                });
                result.sort(function(a, b) {
                    return a.getDegree() - b.getDegree();
                });
                return result;
            };
            // This function returns the degree of this node.
            AVSDFNode.prototype.getDegree = function() {
                return this.getEdges().length;
            };
            // This function returns whether or not this node is currently placed on its
            // owner circle.
            AVSDFNode.prototype.isOrdered = function() {
                return this.getIndex() > -1;
            };
            // This function sets the angle of this node w.r.t. its owner circle. Here
            // the angle value is in radian.
            AVSDFNode.prototype.setAngle = function(angle) {
                this.angle = angle;
            };
            // This function returns the angle of this node w.r.t. its owner circle. Here
            // the angle value is in radian.
            AVSDFNode.prototype.getAngle = function() {
                return this.angle;
            };
            // This function returns the index difference of this node with the input
            // node. Note that the index difference cannot be negative if both nodes are
            // placed on the circle. Here -1 means at least one of the nodes are not yet
            // placed on the circle.
            AVSDFNode.prototype.getCircDistWithTheNode = function(refNode) {
                var self = this;
                var otherIndex = refNode.getIndex();
                if (otherIndex === -1 || self.getIndex() === -1) return -1;
                var diff = self.getIndex() - otherIndex;
                if (diff < 0) diff += self.getCircle().getSize();
                return diff;
            };
            // This function finds the number of edge crossings between the edges of
            // this node and the edges of the input one.
            AVSDFNode.prototype.getCrossingNumberWithNode = function(otherNode) {
                var self = this;
                var totalCrossing = 0;
                self.getEdges().forEach(function(edge) {
                    otherNode.getEdges().forEach(function(otherEdge) {
                        totalCrossing += edge.crossingWithEdge(otherEdge);
                    });
                });
                return totalCrossing;
            };
            // This function returns the total number of edge crossings. If the previously
            // calculated value is not valid due to an index change on the circle, then
            // a recalculation is performed.
            AVSDFNode.prototype.getTotalCrossingOfEdges = function() {
                var self = this;
                if (!self.isCrossingNumberValid) {
                    self.calculateTotalCrossing();
                    self.isCrossingNumberValid = true;
                }
                return self.totalCrossingOfEdges;
            };
            // -----------------------------------------------------------------------------
            // Section: Remaining Functions
            // -----------------------------------------------------------------------------
            // This function calculates the total number of crossings the edges of this
            // node cause.
            AVSDFNode.prototype.calculateTotalCrossing = function() {
                var self = this;
                var temp_crossing_count = 0;
                var temp_edge_list = [];
                temp_edge_list.push.apply(temp_edge_list, self.getCircle().getEdges());
                temp_edge_list = temp_edge_list.filter(function(ele) {
                    return self.getEdges().indexOf(ele) < 0;
                });
                self.getEdges().forEach(function(edge) {
                    return temp_crossing_count += edge.calculateTotalCrossingWithList(temp_edge_list);
                });
                self.totalCrossingOfEdges = temp_crossing_count;
            };
            module1.exports = AVSDFNode;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * This class implements the overall layout process for the AVSDF algorithm
 * (Circular Drawing Algorithm by He and Sykora).
 *
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ var Layout = __webpack_require__(0).Layout;
            var AVSDFConstants = __webpack_require__(2);
            var AVSDFCircle = __webpack_require__(1);
            var AVSDFNode = __webpack_require__(4);
            var AVSDFEdge = __webpack_require__(3);
            // -----------------------------------------------------------------------------
            // Section: Initializations
            // -----------------------------------------------------------------------------
            // Constructor
            function AVSDFLayout() {
                Layout.call(this);
                this.nodeSeparation = AVSDFConstants.DEFAULT_NODE_SEPARATION;
            }
            AVSDFLayout.prototype = Object.create(Layout.prototype);
            for(var property in Layout)AVSDFLayout[property] = Layout[property];
            AVSDFLayout.prototype.newGraph = function(vObject) {
                this.avsdfCircle = new AVSDFCircle(null, this.graphManager, vObject);
                return this.avsdfCircle;
            };
            AVSDFLayout.prototype.newNode = function(vNode) {
                return new AVSDFNode(this.graphManager, vNode);
            };
            AVSDFLayout.prototype.newEdge = function(vEdge) {
                return new AVSDFEdge(null, null, vEdge);
            };
            // -----------------------------------------------------------------------------
            // Section: Accessor Functions
            // -----------------------------------------------------------------------------
            // This function returns the position data for all nodes
            AVSDFLayout.prototype.getPositionsData = function() {
                var allNodes = this.graphManager.getAllNodes();
                var pData = {};
                for(var i = 0; i < allNodes.length; i++){
                    var rect = allNodes[i].rect;
                    var id = allNodes[i].id;
                    pData[id] = {
                        id: id,
                        x: rect.getCenterX(),
                        y: rect.getCenterY(),
                        w: rect.width,
                        h: rect.height
                    };
                }
                return pData;
            };
            // -----------------------------------------------------------------------------
            // Section: Layout Related
            // -----------------------------------------------------------------------------
            /**
 * This function performs layout on constructed l-level graph.
 * It returns true on success, false otherwise.
 * Important!: If you want to see the results of this function then, after this function is called, you have to calculate
 * and set the positions of every node. To do this call updateNodeCoordinates. However, updateNodeAngles on the other
 * hand is not needed (redundant) for this function.
 */ AVSDFLayout.prototype.layout = function() {
                var self = this;
                // Check if graph contains any compound structures
                if (self.graphManager.getGraphs().length > 1) return false;
                var clusterGraph = this.avsdfCircle; // Fixed reference, but now it is a bit redundant
                clusterGraph.setNodeSeparation(this.nodeSeparation);
                clusterGraph.calculateRadius();
                clusterGraph.initOrdering();
                while(!clusterGraph.hasFinishedOrdering()){
                    var node = clusterGraph.findNodeToPlace();
                    clusterGraph.putInOrder(node);
                }
                return true;
            };
            // This function updates the angle (in radians) property of AVSDFNode elements in the circle
            AVSDFLayout.prototype.updateNodeAngles = function() {
                this.graphManager.getRoot().correctAngles(); //AVSDFCircle object
            };
            // This function traverses the vertices of the graph and sets their correct coordinates with respect to the owner circle.
            AVSDFLayout.prototype.updateNodeCoordinates = function() {
                var clusterGraph = this.graphManager.getRoot();
                clusterGraph.getNodes().forEach(function(node) {
                    node.setCenter(clusterGraph.getCenterX() + clusterGraph.getRadius() * Math.cos(node.getAngle()), clusterGraph.getCenterY() + clusterGraph.getRadius() * Math.sin(node.getAngle()));
                });
            };
            // -----------------------------------------------------------------------------
            // Section: Post Processing
            // -----------------------------------------------------------------------------
            /**
 * This method implements the post processing step of the algorithm, which
 * tries to minimize the number of edges further with respect to the local
 * adjusting algorithm described by He and Sykora.
 */ AVSDFLayout.prototype.initPostProcess = function() {
                this.avsdfCircle.calculateEdgeCrossingsOfNodes();
                var list = this.avsdfCircle.getNodes();
                list.sort(function(a, b) {
                    return b.getTotalCrossingOfEdges() - a.getTotalCrossingOfEdges();
                });
                return list;
            };
            AVSDFLayout.prototype.oneStepPostProcess = function(node) {
                var self = this;
                var currentCrossingNumber = node.getTotalCrossingOfEdges();
                var newCrossingNumber = void 0;
                var neighbours = Array.from(node.getNeighborsList());
                for(var j = 0; j < neighbours.length; j++){
                    var neighbour = neighbours[j];
                    var oldIndex = node.getIndex();
                    var newIndex = (neighbour.getIndex() + 1) % self.avsdfCircle.getSize();
                    if (oldIndex !== newIndex) {
                        node.setIndex(newIndex);
                        if (oldIndex < node.getIndex()) oldIndex += self.avsdfCircle.getSize();
                        var index = node.getIndex();
                        while(index < oldIndex){
                            var temp = self.avsdfCircle.getOrder()[index % self.avsdfCircle.getSize()];
                            temp.setIndex((temp.getIndex() + 1) % self.avsdfCircle.getSize());
                            index += 1;
                        }
                        node.calculateTotalCrossing();
                        newCrossingNumber = node.getTotalCrossingOfEdges();
                        if (newCrossingNumber >= currentCrossingNumber) self.avsdfCircle.loadOldIndicesOfNodes();
                        else {
                            self.avsdfCircle.reOrderVertices();
                            currentCrossingNumber = newCrossingNumber;
                        }
                    }
                }
            };
            module1.exports = AVSDFLayout;
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var avsdfBase = {};
            avsdfBase.layoutBase = __webpack_require__(0);
            avsdfBase.AVSDFConstants = __webpack_require__(2);
            avsdfBase.AVSDFEdge = __webpack_require__(3);
            avsdfBase.AVSDFCircle = __webpack_require__(1);
            avsdfBase.AVSDFLayout = __webpack_require__(5);
            avsdfBase.AVSDFNode = __webpack_require__(4);
            module1.exports = avsdfBase;
        /***/ }
    ]);
});

});
parcelRegister("awvmd", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 26);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function LayoutConstants() {}
            /**
 * Layout Quality: 0:draft, 1:default, 2:proof
 */ LayoutConstants.QUALITY = 1;
            /**
 * Default parameters
 */ LayoutConstants.DEFAULT_CREATE_BENDS_AS_NEEDED = false;
            LayoutConstants.DEFAULT_INCREMENTAL = false;
            LayoutConstants.DEFAULT_ANIMATION_ON_LAYOUT = true;
            LayoutConstants.DEFAULT_ANIMATION_DURING_LAYOUT = false;
            LayoutConstants.DEFAULT_ANIMATION_PERIOD = 50;
            LayoutConstants.DEFAULT_UNIFORM_LEAF_NODE_SIZES = false;
            // -----------------------------------------------------------------------------
            // Section: General other constants
            // -----------------------------------------------------------------------------
            /*
 * Margins of a graph to be applied on bouding rectangle of its contents. We
 * assume margins on all four sides to be uniform.
 */ LayoutConstants.DEFAULT_GRAPH_MARGIN = 15;
            /*
 * Whether to consider labels in node dimensions or not
 */ LayoutConstants.NODE_DIMENSIONS_INCLUDE_LABELS = false;
            /*
 * Default dimension of a non-compound node.
 */ LayoutConstants.SIMPLE_NODE_SIZE = 40;
            /*
 * Default dimension of a non-compound node.
 */ LayoutConstants.SIMPLE_NODE_HALF_SIZE = LayoutConstants.SIMPLE_NODE_SIZE / 2;
            /*
 * Empty compound node size. When a compound node is empty, its both
 * dimensions should be of this value.
 */ LayoutConstants.EMPTY_COMPOUND_NODE_SIZE = 40;
            /*
 * Minimum length that an edge should take during layout
 */ LayoutConstants.MIN_EDGE_LENGTH = 1;
            /*
 * World boundaries that layout operates on
 */ LayoutConstants.WORLD_BOUNDARY = 1000000;
            /*
 * World boundaries that random positioning can be performed with
 */ LayoutConstants.INITIAL_WORLD_BOUNDARY = LayoutConstants.WORLD_BOUNDARY / 1000;
            /*
 * Coordinates of the world center
 */ LayoutConstants.WORLD_CENTER_X = 1200;
            LayoutConstants.WORLD_CENTER_Y = 900;
            module1.exports = LayoutConstants;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LGraphObject = __webpack_require__(2);
            var IGeometry = __webpack_require__(8);
            var IMath = __webpack_require__(9);
            function LEdge(source, target, vEdge) {
                LGraphObject.call(this, vEdge);
                this.isOverlapingSourceAndTarget = false;
                this.vGraphObject = vEdge;
                this.bendpoints = [];
                this.source = source;
                this.target = target;
            }
            LEdge.prototype = Object.create(LGraphObject.prototype);
            for(var prop in LGraphObject)LEdge[prop] = LGraphObject[prop];
            LEdge.prototype.getSource = function() {
                return this.source;
            };
            LEdge.prototype.getTarget = function() {
                return this.target;
            };
            LEdge.prototype.isInterGraph = function() {
                return this.isInterGraph;
            };
            LEdge.prototype.getLength = function() {
                return this.length;
            };
            LEdge.prototype.isOverlapingSourceAndTarget = function() {
                return this.isOverlapingSourceAndTarget;
            };
            LEdge.prototype.getBendpoints = function() {
                return this.bendpoints;
            };
            LEdge.prototype.getLca = function() {
                return this.lca;
            };
            LEdge.prototype.getSourceInLca = function() {
                return this.sourceInLca;
            };
            LEdge.prototype.getTargetInLca = function() {
                return this.targetInLca;
            };
            LEdge.prototype.getOtherEnd = function(node) {
                if (this.source === node) return this.target;
                else if (this.target === node) return this.source;
                else throw "Node is not incident with this edge";
            };
            LEdge.prototype.getOtherEndInGraph = function(node, graph) {
                var otherEnd = this.getOtherEnd(node);
                var root = graph.getGraphManager().getRoot();
                while(true){
                    if (otherEnd.getOwner() == graph) return otherEnd;
                    if (otherEnd.getOwner() == root) break;
                    otherEnd = otherEnd.getOwner().getParent();
                }
                return null;
            };
            LEdge.prototype.updateLength = function() {
                var clipPointCoordinates = new Array(4);
                this.isOverlapingSourceAndTarget = IGeometry.getIntersection(this.target.getRect(), this.source.getRect(), clipPointCoordinates);
                if (!this.isOverlapingSourceAndTarget) {
                    this.lengthX = clipPointCoordinates[0] - clipPointCoordinates[2];
                    this.lengthY = clipPointCoordinates[1] - clipPointCoordinates[3];
                    if (Math.abs(this.lengthX) < 1.0) this.lengthX = IMath.sign(this.lengthX);
                    if (Math.abs(this.lengthY) < 1.0) this.lengthY = IMath.sign(this.lengthY);
                    this.length = Math.sqrt(this.lengthX * this.lengthX + this.lengthY * this.lengthY);
                }
            };
            LEdge.prototype.updateLengthSimple = function() {
                this.lengthX = this.target.getCenterX() - this.source.getCenterX();
                this.lengthY = this.target.getCenterY() - this.source.getCenterY();
                if (Math.abs(this.lengthX) < 1.0) this.lengthX = IMath.sign(this.lengthX);
                if (Math.abs(this.lengthY) < 1.0) this.lengthY = IMath.sign(this.lengthY);
                this.length = Math.sqrt(this.lengthX * this.lengthX + this.lengthY * this.lengthY);
            };
            module1.exports = LEdge;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function LGraphObject(vGraphObject) {
                this.vGraphObject = vGraphObject;
            }
            module1.exports = LGraphObject;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LGraphObject = __webpack_require__(2);
            var Integer = __webpack_require__(10);
            var RectangleD = __webpack_require__(13);
            var LayoutConstants = __webpack_require__(0);
            var RandomSeed = __webpack_require__(16);
            var PointD = __webpack_require__(4);
            function LNode(gm, loc, size, vNode) {
                //Alternative constructor 1 : LNode(LGraphManager gm, Point loc, Dimension size, Object vNode)
                if (size == null && vNode == null) vNode = loc;
                LGraphObject.call(this, vNode);
                //Alternative constructor 2 : LNode(Layout layout, Object vNode)
                if (gm.graphManager != null) gm = gm.graphManager;
                this.estimatedSize = Integer.MIN_VALUE;
                this.inclusionTreeDepth = Integer.MAX_VALUE;
                this.vGraphObject = vNode;
                this.edges = [];
                this.graphManager = gm;
                if (size != null && loc != null) this.rect = new RectangleD(loc.x, loc.y, size.width, size.height);
                else this.rect = new RectangleD();
            }
            LNode.prototype = Object.create(LGraphObject.prototype);
            for(var prop in LGraphObject)LNode[prop] = LGraphObject[prop];
            LNode.prototype.getEdges = function() {
                return this.edges;
            };
            LNode.prototype.getChild = function() {
                return this.child;
            };
            LNode.prototype.getOwner = function() {
                //  if (this.owner != null) {
                //    if (!(this.owner == null || this.owner.getNodes().indexOf(this) > -1)) {
                //      throw "assert failed";
                //    }
                //  }
                return this.owner;
            };
            LNode.prototype.getWidth = function() {
                return this.rect.width;
            };
            LNode.prototype.setWidth = function(width) {
                this.rect.width = width;
            };
            LNode.prototype.getHeight = function() {
                return this.rect.height;
            };
            LNode.prototype.setHeight = function(height) {
                this.rect.height = height;
            };
            LNode.prototype.getCenterX = function() {
                return this.rect.x + this.rect.width / 2;
            };
            LNode.prototype.getCenterY = function() {
                return this.rect.y + this.rect.height / 2;
            };
            LNode.prototype.getCenter = function() {
                return new PointD(this.rect.x + this.rect.width / 2, this.rect.y + this.rect.height / 2);
            };
            LNode.prototype.getLocation = function() {
                return new PointD(this.rect.x, this.rect.y);
            };
            LNode.prototype.getRect = function() {
                return this.rect;
            };
            LNode.prototype.getDiagonal = function() {
                return Math.sqrt(this.rect.width * this.rect.width + this.rect.height * this.rect.height);
            };
            /**
 * This method returns half the diagonal length of this node.
 */ LNode.prototype.getHalfTheDiagonal = function() {
                return Math.sqrt(this.rect.height * this.rect.height + this.rect.width * this.rect.width) / 2;
            };
            LNode.prototype.setRect = function(upperLeft, dimension) {
                this.rect.x = upperLeft.x;
                this.rect.y = upperLeft.y;
                this.rect.width = dimension.width;
                this.rect.height = dimension.height;
            };
            LNode.prototype.setCenter = function(cx, cy) {
                this.rect.x = cx - this.rect.width / 2;
                this.rect.y = cy - this.rect.height / 2;
            };
            LNode.prototype.setLocation = function(x, y) {
                this.rect.x = x;
                this.rect.y = y;
            };
            LNode.prototype.moveBy = function(dx, dy) {
                this.rect.x += dx;
                this.rect.y += dy;
            };
            LNode.prototype.getEdgeListToNode = function(to) {
                var edgeList = [];
                var edge;
                var self = this;
                self.edges.forEach(function(edge) {
                    if (edge.target == to) {
                        if (edge.source != self) throw "Incorrect edge source!";
                        edgeList.push(edge);
                    }
                });
                return edgeList;
            };
            LNode.prototype.getEdgesBetween = function(other) {
                var edgeList = [];
                var edge;
                var self = this;
                self.edges.forEach(function(edge) {
                    if (!(edge.source == self || edge.target == self)) throw "Incorrect edge source and/or target";
                    if (edge.target == other || edge.source == other) edgeList.push(edge);
                });
                return edgeList;
            };
            LNode.prototype.getNeighborsList = function() {
                var neighbors = new Set();
                var self = this;
                self.edges.forEach(function(edge) {
                    if (edge.source == self) neighbors.add(edge.target);
                    else {
                        if (edge.target != self) throw "Incorrect incidency!";
                        neighbors.add(edge.source);
                    }
                });
                return neighbors;
            };
            LNode.prototype.withChildren = function() {
                var withNeighborsList = new Set();
                var childNode;
                var children;
                withNeighborsList.add(this);
                if (this.child != null) {
                    var nodes = this.child.getNodes();
                    for(var i = 0; i < nodes.length; i++){
                        childNode = nodes[i];
                        children = childNode.withChildren();
                        children.forEach(function(node) {
                            withNeighborsList.add(node);
                        });
                    }
                }
                return withNeighborsList;
            };
            LNode.prototype.getNoOfChildren = function() {
                var noOfChildren = 0;
                var childNode;
                if (this.child == null) noOfChildren = 1;
                else {
                    var nodes = this.child.getNodes();
                    for(var i = 0; i < nodes.length; i++){
                        childNode = nodes[i];
                        noOfChildren += childNode.getNoOfChildren();
                    }
                }
                if (noOfChildren == 0) noOfChildren = 1;
                return noOfChildren;
            };
            LNode.prototype.getEstimatedSize = function() {
                if (this.estimatedSize == Integer.MIN_VALUE) throw "assert failed";
                return this.estimatedSize;
            };
            LNode.prototype.calcEstimatedSize = function() {
                if (this.child == null) return this.estimatedSize = (this.rect.width + this.rect.height) / 2;
                else {
                    this.estimatedSize = this.child.calcEstimatedSize();
                    this.rect.width = this.estimatedSize;
                    this.rect.height = this.estimatedSize;
                    return this.estimatedSize;
                }
            };
            LNode.prototype.scatter = function() {
                var randomCenterX;
                var randomCenterY;
                var minX = -LayoutConstants.INITIAL_WORLD_BOUNDARY;
                var maxX = LayoutConstants.INITIAL_WORLD_BOUNDARY;
                randomCenterX = LayoutConstants.WORLD_CENTER_X + RandomSeed.nextDouble() * (maxX - minX) + minX;
                var minY = -LayoutConstants.INITIAL_WORLD_BOUNDARY;
                var maxY = LayoutConstants.INITIAL_WORLD_BOUNDARY;
                randomCenterY = LayoutConstants.WORLD_CENTER_Y + RandomSeed.nextDouble() * (maxY - minY) + minY;
                this.rect.x = randomCenterX;
                this.rect.y = randomCenterY;
            };
            LNode.prototype.updateBounds = function() {
                if (this.getChild() == null) throw "assert failed";
                if (this.getChild().getNodes().length != 0) {
                    // wrap the children nodes by re-arranging the boundaries
                    var childGraph = this.getChild();
                    childGraph.updateBounds(true);
                    this.rect.x = childGraph.getLeft();
                    this.rect.y = childGraph.getTop();
                    this.setWidth(childGraph.getRight() - childGraph.getLeft());
                    this.setHeight(childGraph.getBottom() - childGraph.getTop());
                    // Update compound bounds considering its label properties    
                    if (LayoutConstants.NODE_DIMENSIONS_INCLUDE_LABELS) {
                        var width = childGraph.getRight() - childGraph.getLeft();
                        var height = childGraph.getBottom() - childGraph.getTop();
                        if (this.labelWidth > width) {
                            this.rect.x -= (this.labelWidth - width) / 2;
                            this.setWidth(this.labelWidth);
                        }
                        if (this.labelHeight > height) {
                            if (this.labelPos == "center") this.rect.y -= (this.labelHeight - height) / 2;
                            else if (this.labelPos == "top") this.rect.y -= this.labelHeight - height;
                            this.setHeight(this.labelHeight);
                        }
                    }
                }
            };
            LNode.prototype.getInclusionTreeDepth = function() {
                if (this.inclusionTreeDepth == Integer.MAX_VALUE) throw "assert failed";
                return this.inclusionTreeDepth;
            };
            LNode.prototype.transform = function(trans) {
                var left = this.rect.x;
                if (left > LayoutConstants.WORLD_BOUNDARY) left = LayoutConstants.WORLD_BOUNDARY;
                else if (left < -LayoutConstants.WORLD_BOUNDARY) left = -LayoutConstants.WORLD_BOUNDARY;
                var top = this.rect.y;
                if (top > LayoutConstants.WORLD_BOUNDARY) top = LayoutConstants.WORLD_BOUNDARY;
                else if (top < -LayoutConstants.WORLD_BOUNDARY) top = -LayoutConstants.WORLD_BOUNDARY;
                var leftTop = new PointD(left, top);
                var vLeftTop = trans.inverseTransformPoint(leftTop);
                this.setLocation(vLeftTop.x, vLeftTop.y);
            };
            LNode.prototype.getLeft = function() {
                return this.rect.x;
            };
            LNode.prototype.getRight = function() {
                return this.rect.x + this.rect.width;
            };
            LNode.prototype.getTop = function() {
                return this.rect.y;
            };
            LNode.prototype.getBottom = function() {
                return this.rect.y + this.rect.height;
            };
            LNode.prototype.getParent = function() {
                if (this.owner == null) return null;
                return this.owner.getParent();
            };
            module1.exports = LNode;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function PointD(x, y) {
                if (x == null && y == null) {
                    this.x = 0;
                    this.y = 0;
                } else {
                    this.x = x;
                    this.y = y;
                }
            }
            PointD.prototype.getX = function() {
                return this.x;
            };
            PointD.prototype.getY = function() {
                return this.y;
            };
            PointD.prototype.setX = function(x) {
                this.x = x;
            };
            PointD.prototype.setY = function(y) {
                this.y = y;
            };
            PointD.prototype.getDifference = function(pt) {
                return new DimensionD(this.x - pt.x, this.y - pt.y);
            };
            PointD.prototype.getCopy = function() {
                return new PointD(this.x, this.y);
            };
            PointD.prototype.translate = function(dim) {
                this.x += dim.width;
                this.y += dim.height;
                return this;
            };
            module1.exports = PointD;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LGraphObject = __webpack_require__(2);
            var Integer = __webpack_require__(10);
            var LayoutConstants = __webpack_require__(0);
            var LGraphManager = __webpack_require__(6);
            var LNode = __webpack_require__(3);
            var LEdge = __webpack_require__(1);
            var RectangleD = __webpack_require__(13);
            var Point1 = __webpack_require__(12);
            var LinkedList = __webpack_require__(11);
            function LGraph(parent, obj2, vGraph) {
                LGraphObject.call(this, vGraph);
                this.estimatedSize = Integer.MIN_VALUE;
                this.margin = LayoutConstants.DEFAULT_GRAPH_MARGIN;
                this.edges = [];
                this.nodes = [];
                this.isConnected = false;
                this.parent = parent;
                if (obj2 != null && obj2 instanceof LGraphManager) this.graphManager = obj2;
                else if (obj2 != null && obj2 instanceof Layout) this.graphManager = obj2.graphManager;
            }
            LGraph.prototype = Object.create(LGraphObject.prototype);
            for(var prop in LGraphObject)LGraph[prop] = LGraphObject[prop];
            LGraph.prototype.getNodes = function() {
                return this.nodes;
            };
            LGraph.prototype.getEdges = function() {
                return this.edges;
            };
            LGraph.prototype.getGraphManager = function() {
                return this.graphManager;
            };
            LGraph.prototype.getParent = function() {
                return this.parent;
            };
            LGraph.prototype.getLeft = function() {
                return this.left;
            };
            LGraph.prototype.getRight = function() {
                return this.right;
            };
            LGraph.prototype.getTop = function() {
                return this.top;
            };
            LGraph.prototype.getBottom = function() {
                return this.bottom;
            };
            LGraph.prototype.isConnected = function() {
                return this.isConnected;
            };
            LGraph.prototype.add = function(obj1, sourceNode, targetNode) {
                if (sourceNode == null && targetNode == null) {
                    var newNode = obj1;
                    if (this.graphManager == null) throw "Graph has no graph mgr!";
                    if (this.getNodes().indexOf(newNode) > -1) throw "Node already in graph!";
                    newNode.owner = this;
                    this.getNodes().push(newNode);
                    return newNode;
                } else {
                    var newEdge = obj1;
                    if (!(this.getNodes().indexOf(sourceNode) > -1 && this.getNodes().indexOf(targetNode) > -1)) throw "Source or target not in graph!";
                    if (!(sourceNode.owner == targetNode.owner && sourceNode.owner == this)) throw "Both owners must be this graph!";
                    if (sourceNode.owner != targetNode.owner) return null;
                    // set source and target
                    newEdge.source = sourceNode;
                    newEdge.target = targetNode;
                    // set as intra-graph edge
                    newEdge.isInterGraph = false;
                    // add to graph edge list
                    this.getEdges().push(newEdge);
                    // add to incidency lists
                    sourceNode.edges.push(newEdge);
                    if (targetNode != sourceNode) targetNode.edges.push(newEdge);
                    return newEdge;
                }
            };
            LGraph.prototype.remove = function(obj) {
                var node = obj;
                if (obj instanceof LNode) {
                    if (node == null) throw "Node is null!";
                    if (!(node.owner != null && node.owner == this)) throw "Owner graph is invalid!";
                    if (this.graphManager == null) throw "Owner graph manager is invalid!";
                    // remove incident edges first (make a copy to do it safely)
                    var edgesToBeRemoved = node.edges.slice();
                    var edge;
                    var s = edgesToBeRemoved.length;
                    for(var i = 0; i < s; i++){
                        edge = edgesToBeRemoved[i];
                        if (edge.isInterGraph) this.graphManager.remove(edge);
                        else edge.source.owner.remove(edge);
                    }
                    // now the node itself
                    var index = this.nodes.indexOf(node);
                    if (index == -1) throw "Node not in owner node list!";
                    this.nodes.splice(index, 1);
                } else if (obj instanceof LEdge) {
                    var edge = obj;
                    if (edge == null) throw "Edge is null!";
                    if (!(edge.source != null && edge.target != null)) throw "Source and/or target is null!";
                    if (!(edge.source.owner != null && edge.target.owner != null && edge.source.owner == this && edge.target.owner == this)) throw "Source and/or target owner is invalid!";
                    var sourceIndex = edge.source.edges.indexOf(edge);
                    var targetIndex = edge.target.edges.indexOf(edge);
                    if (!(sourceIndex > -1 && targetIndex > -1)) throw "Source and/or target doesn't know this edge!";
                    edge.source.edges.splice(sourceIndex, 1);
                    if (edge.target != edge.source) edge.target.edges.splice(targetIndex, 1);
                    var index = edge.source.owner.getEdges().indexOf(edge);
                    if (index == -1) throw "Not in owner's edge list!";
                    edge.source.owner.getEdges().splice(index, 1);
                }
            };
            LGraph.prototype.updateLeftTop = function() {
                var top = Integer.MAX_VALUE;
                var left = Integer.MAX_VALUE;
                var nodeTop;
                var nodeLeft;
                var margin;
                var nodes = this.getNodes();
                var s = nodes.length;
                for(var i = 0; i < s; i++){
                    var lNode = nodes[i];
                    nodeTop = lNode.getTop();
                    nodeLeft = lNode.getLeft();
                    if (top > nodeTop) top = nodeTop;
                    if (left > nodeLeft) left = nodeLeft;
                }
                // Do we have any nodes in this graph?
                if (top == Integer.MAX_VALUE) return null;
                if (nodes[0].getParent().paddingLeft != undefined) margin = nodes[0].getParent().paddingLeft;
                else margin = this.margin;
                this.left = left - margin;
                this.top = top - margin;
                // Apply the margins and return the result
                return new Point1(this.left, this.top);
            };
            LGraph.prototype.updateBounds = function(recursive) {
                // calculate bounds
                var left = Integer.MAX_VALUE;
                var right = -Integer.MAX_VALUE;
                var top = Integer.MAX_VALUE;
                var bottom = -Integer.MAX_VALUE;
                var nodeLeft;
                var nodeRight;
                var nodeTop;
                var nodeBottom;
                var margin;
                var nodes = this.nodes;
                var s = nodes.length;
                for(var i = 0; i < s; i++){
                    var lNode = nodes[i];
                    if (recursive && lNode.child != null) lNode.updateBounds();
                    nodeLeft = lNode.getLeft();
                    nodeRight = lNode.getRight();
                    nodeTop = lNode.getTop();
                    nodeBottom = lNode.getBottom();
                    if (left > nodeLeft) left = nodeLeft;
                    if (right < nodeRight) right = nodeRight;
                    if (top > nodeTop) top = nodeTop;
                    if (bottom < nodeBottom) bottom = nodeBottom;
                }
                var boundingRect = new RectangleD(left, top, right - left, bottom - top);
                if (left == Integer.MAX_VALUE) {
                    this.left = this.parent.getLeft();
                    this.right = this.parent.getRight();
                    this.top = this.parent.getTop();
                    this.bottom = this.parent.getBottom();
                }
                if (nodes[0].getParent().paddingLeft != undefined) margin = nodes[0].getParent().paddingLeft;
                else margin = this.margin;
                this.left = boundingRect.x - margin;
                this.right = boundingRect.x + boundingRect.width + margin;
                this.top = boundingRect.y - margin;
                this.bottom = boundingRect.y + boundingRect.height + margin;
            };
            LGraph.calculateBounds = function(nodes) {
                var left = Integer.MAX_VALUE;
                var right = -Integer.MAX_VALUE;
                var top = Integer.MAX_VALUE;
                var bottom = -Integer.MAX_VALUE;
                var nodeLeft;
                var nodeRight;
                var nodeTop;
                var nodeBottom;
                var s = nodes.length;
                for(var i = 0; i < s; i++){
                    var lNode = nodes[i];
                    nodeLeft = lNode.getLeft();
                    nodeRight = lNode.getRight();
                    nodeTop = lNode.getTop();
                    nodeBottom = lNode.getBottom();
                    if (left > nodeLeft) left = nodeLeft;
                    if (right < nodeRight) right = nodeRight;
                    if (top > nodeTop) top = nodeTop;
                    if (bottom < nodeBottom) bottom = nodeBottom;
                }
                var boundingRect = new RectangleD(left, top, right - left, bottom - top);
                return boundingRect;
            };
            LGraph.prototype.getInclusionTreeDepth = function() {
                if (this == this.graphManager.getRoot()) return 1;
                else return this.parent.getInclusionTreeDepth();
            };
            LGraph.prototype.getEstimatedSize = function() {
                if (this.estimatedSize == Integer.MIN_VALUE) throw "assert failed";
                return this.estimatedSize;
            };
            LGraph.prototype.calcEstimatedSize = function() {
                var size = 0;
                var nodes = this.nodes;
                var s = nodes.length;
                for(var i = 0; i < s; i++){
                    var lNode = nodes[i];
                    size += lNode.calcEstimatedSize();
                }
                if (size == 0) this.estimatedSize = LayoutConstants.EMPTY_COMPOUND_NODE_SIZE;
                else this.estimatedSize = size / Math.sqrt(this.nodes.length);
                return this.estimatedSize;
            };
            LGraph.prototype.updateConnected = function() {
                var self = this;
                if (this.nodes.length == 0) {
                    this.isConnected = true;
                    return;
                }
                var queue = new LinkedList();
                var visited = new Set();
                var currentNode = this.nodes[0];
                var neighborEdges;
                var currentNeighbor;
                var childrenOfNode = currentNode.withChildren();
                childrenOfNode.forEach(function(node) {
                    queue.push(node);
                    visited.add(node);
                });
                while(queue.length !== 0){
                    currentNode = queue.shift();
                    // Traverse all neighbors of this node
                    neighborEdges = currentNode.getEdges();
                    var size = neighborEdges.length;
                    for(var i = 0; i < size; i++){
                        var neighborEdge = neighborEdges[i];
                        currentNeighbor = neighborEdge.getOtherEndInGraph(currentNode, this);
                        // Add unvisited neighbors to the list to visit
                        if (currentNeighbor != null && !visited.has(currentNeighbor)) {
                            var childrenOfNeighbor = currentNeighbor.withChildren();
                            childrenOfNeighbor.forEach(function(node) {
                                queue.push(node);
                                visited.add(node);
                            });
                        }
                    }
                }
                this.isConnected = false;
                if (visited.size >= this.nodes.length) {
                    var noOfVisitedInThisGraph = 0;
                    visited.forEach(function(visitedNode) {
                        if (visitedNode.owner == self) noOfVisitedInThisGraph++;
                    });
                    if (noOfVisitedInThisGraph == this.nodes.length) this.isConnected = true;
                }
            };
            module1.exports = LGraph;
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LGraph;
            var LEdge = __webpack_require__(1);
            function LGraphManager(layout) {
                LGraph = __webpack_require__(5); // It may be better to initilize this out of this function but it gives an error (Right-hand side of 'instanceof' is not callable) now.
                this.layout = layout;
                this.graphs = [];
                this.edges = [];
            }
            LGraphManager.prototype.addRoot = function() {
                var ngraph = this.layout.newGraph();
                var nnode = this.layout.newNode(null);
                var root = this.add(ngraph, nnode);
                this.setRootGraph(root);
                return this.rootGraph;
            };
            LGraphManager.prototype.add = function(newGraph, parentNode, newEdge, sourceNode, targetNode) {
                //there are just 2 parameters are passed then it adds an LGraph else it adds an LEdge
                if (newEdge == null && sourceNode == null && targetNode == null) {
                    if (newGraph == null) throw "Graph is null!";
                    if (parentNode == null) throw "Parent node is null!";
                    if (this.graphs.indexOf(newGraph) > -1) throw "Graph already in this graph mgr!";
                    this.graphs.push(newGraph);
                    if (newGraph.parent != null) throw "Already has a parent!";
                    if (parentNode.child != null) throw "Already has a child!";
                    newGraph.parent = parentNode;
                    parentNode.child = newGraph;
                    return newGraph;
                } else {
                    //change the order of the parameters
                    targetNode = newEdge;
                    sourceNode = parentNode;
                    newEdge = newGraph;
                    var sourceGraph = sourceNode.getOwner();
                    var targetGraph = targetNode.getOwner();
                    if (!(sourceGraph != null && sourceGraph.getGraphManager() == this)) throw "Source not in this graph mgr!";
                    if (!(targetGraph != null && targetGraph.getGraphManager() == this)) throw "Target not in this graph mgr!";
                    if (sourceGraph == targetGraph) {
                        newEdge.isInterGraph = false;
                        return sourceGraph.add(newEdge, sourceNode, targetNode);
                    } else {
                        newEdge.isInterGraph = true;
                        // set source and target
                        newEdge.source = sourceNode;
                        newEdge.target = targetNode;
                        // add edge to inter-graph edge list
                        if (this.edges.indexOf(newEdge) > -1) throw "Edge already in inter-graph edge list!";
                        this.edges.push(newEdge);
                        // add edge to source and target incidency lists
                        if (!(newEdge.source != null && newEdge.target != null)) throw "Edge source and/or target is null!";
                        if (!(newEdge.source.edges.indexOf(newEdge) == -1 && newEdge.target.edges.indexOf(newEdge) == -1)) throw "Edge already in source and/or target incidency list!";
                        newEdge.source.edges.push(newEdge);
                        newEdge.target.edges.push(newEdge);
                        return newEdge;
                    }
                }
            };
            LGraphManager.prototype.remove = function(lObj) {
                if (lObj instanceof LGraph) {
                    var graph = lObj;
                    if (graph.getGraphManager() != this) throw "Graph not in this graph mgr";
                    if (!(graph == this.rootGraph || graph.parent != null && graph.parent.graphManager == this)) throw "Invalid parent node!";
                    // first the edges (make a copy to do it safely)
                    var edgesToBeRemoved = [];
                    edgesToBeRemoved = edgesToBeRemoved.concat(graph.getEdges());
                    var edge;
                    var s = edgesToBeRemoved.length;
                    for(var i = 0; i < s; i++){
                        edge = edgesToBeRemoved[i];
                        graph.remove(edge);
                    }
                    // then the nodes (make a copy to do it safely)
                    var nodesToBeRemoved = [];
                    nodesToBeRemoved = nodesToBeRemoved.concat(graph.getNodes());
                    var node;
                    s = nodesToBeRemoved.length;
                    for(var i = 0; i < s; i++){
                        node = nodesToBeRemoved[i];
                        graph.remove(node);
                    }
                    // check if graph is the root
                    if (graph == this.rootGraph) this.setRootGraph(null);
                    // now remove the graph itself
                    var index = this.graphs.indexOf(graph);
                    this.graphs.splice(index, 1);
                    // also reset the parent of the graph
                    graph.parent = null;
                } else if (lObj instanceof LEdge) {
                    edge = lObj;
                    if (edge == null) throw "Edge is null!";
                    if (!edge.isInterGraph) throw "Not an inter-graph edge!";
                    if (!(edge.source != null && edge.target != null)) throw "Source and/or target is null!";
                    // remove edge from source and target nodes' incidency lists
                    if (!(edge.source.edges.indexOf(edge) != -1 && edge.target.edges.indexOf(edge) != -1)) throw "Source and/or target doesn't know this edge!";
                    var index = edge.source.edges.indexOf(edge);
                    edge.source.edges.splice(index, 1);
                    index = edge.target.edges.indexOf(edge);
                    edge.target.edges.splice(index, 1);
                    // remove edge from owner graph manager's inter-graph edge list
                    if (!(edge.source.owner != null && edge.source.owner.getGraphManager() != null)) throw "Edge owner graph or owner graph manager is null!";
                    if (edge.source.owner.getGraphManager().edges.indexOf(edge) == -1) throw "Not in owner graph manager's edge list!";
                    var index = edge.source.owner.getGraphManager().edges.indexOf(edge);
                    edge.source.owner.getGraphManager().edges.splice(index, 1);
                }
            };
            LGraphManager.prototype.updateBounds = function() {
                this.rootGraph.updateBounds(true);
            };
            LGraphManager.prototype.getGraphs = function() {
                return this.graphs;
            };
            LGraphManager.prototype.getAllNodes = function() {
                if (this.allNodes == null) {
                    var nodeList = [];
                    var graphs = this.getGraphs();
                    var s = graphs.length;
                    for(var i = 0; i < s; i++)nodeList = nodeList.concat(graphs[i].getNodes());
                    this.allNodes = nodeList;
                }
                return this.allNodes;
            };
            LGraphManager.prototype.resetAllNodes = function() {
                this.allNodes = null;
            };
            LGraphManager.prototype.resetAllEdges = function() {
                this.allEdges = null;
            };
            LGraphManager.prototype.resetAllNodesToApplyGravitation = function() {
                this.allNodesToApplyGravitation = null;
            };
            LGraphManager.prototype.getAllEdges = function() {
                if (this.allEdges == null) {
                    var edgeList = [];
                    var graphs = this.getGraphs();
                    var s = graphs.length;
                    for(var i = 0; i < graphs.length; i++)edgeList = edgeList.concat(graphs[i].getEdges());
                    edgeList = edgeList.concat(this.edges);
                    this.allEdges = edgeList;
                }
                return this.allEdges;
            };
            LGraphManager.prototype.getAllNodesToApplyGravitation = function() {
                return this.allNodesToApplyGravitation;
            };
            LGraphManager.prototype.setAllNodesToApplyGravitation = function(nodeList) {
                if (this.allNodesToApplyGravitation != null) throw "assert failed";
                this.allNodesToApplyGravitation = nodeList;
            };
            LGraphManager.prototype.getRoot = function() {
                return this.rootGraph;
            };
            LGraphManager.prototype.setRootGraph = function(graph) {
                if (graph.getGraphManager() != this) throw "Root not in this graph mgr!";
                this.rootGraph = graph;
                // root graph must have a root node associated with it for convenience
                if (graph.parent == null) graph.parent = this.layout.newNode("Root node");
            };
            LGraphManager.prototype.getLayout = function() {
                return this.layout;
            };
            LGraphManager.prototype.isOneAncestorOfOther = function(firstNode, secondNode) {
                if (!(firstNode != null && secondNode != null)) throw "assert failed";
                if (firstNode == secondNode) return true;
                // Is second node an ancestor of the first one?
                var ownerGraph = firstNode.getOwner();
                var parentNode;
                do {
                    parentNode = ownerGraph.getParent();
                    if (parentNode == null) break;
                    if (parentNode == secondNode) return true;
                    ownerGraph = parentNode.getOwner();
                    if (ownerGraph == null) break;
                }while (true);
                // Is first node an ancestor of the second one?
                ownerGraph = secondNode.getOwner();
                do {
                    parentNode = ownerGraph.getParent();
                    if (parentNode == null) break;
                    if (parentNode == firstNode) return true;
                    ownerGraph = parentNode.getOwner();
                    if (ownerGraph == null) break;
                }while (true);
                return false;
            };
            LGraphManager.prototype.calcLowestCommonAncestors = function() {
                var edge;
                var sourceNode;
                var targetNode;
                var sourceAncestorGraph;
                var targetAncestorGraph;
                var edges = this.getAllEdges();
                var s = edges.length;
                for(var i = 0; i < s; i++){
                    edge = edges[i];
                    sourceNode = edge.source;
                    targetNode = edge.target;
                    edge.lca = null;
                    edge.sourceInLca = sourceNode;
                    edge.targetInLca = targetNode;
                    if (sourceNode == targetNode) {
                        edge.lca = sourceNode.getOwner();
                        continue;
                    }
                    sourceAncestorGraph = sourceNode.getOwner();
                    while(edge.lca == null){
                        edge.targetInLca = targetNode;
                        targetAncestorGraph = targetNode.getOwner();
                        while(edge.lca == null){
                            if (targetAncestorGraph == sourceAncestorGraph) {
                                edge.lca = targetAncestorGraph;
                                break;
                            }
                            if (targetAncestorGraph == this.rootGraph) break;
                            if (edge.lca != null) throw "assert failed";
                            edge.targetInLca = targetAncestorGraph.getParent();
                            targetAncestorGraph = edge.targetInLca.getOwner();
                        }
                        if (sourceAncestorGraph == this.rootGraph) break;
                        if (edge.lca == null) {
                            edge.sourceInLca = sourceAncestorGraph.getParent();
                            sourceAncestorGraph = edge.sourceInLca.getOwner();
                        }
                    }
                    if (edge.lca == null) throw "assert failed";
                }
            };
            LGraphManager.prototype.calcLowestCommonAncestor = function(firstNode, secondNode) {
                if (firstNode == secondNode) return firstNode.getOwner();
                var firstOwnerGraph = firstNode.getOwner();
                do {
                    if (firstOwnerGraph == null) break;
                    var secondOwnerGraph = secondNode.getOwner();
                    do {
                        if (secondOwnerGraph == null) break;
                        if (secondOwnerGraph == firstOwnerGraph) return secondOwnerGraph;
                        secondOwnerGraph = secondOwnerGraph.getParent().getOwner();
                    }while (true);
                    firstOwnerGraph = firstOwnerGraph.getParent().getOwner();
                }while (true);
                return firstOwnerGraph;
            };
            LGraphManager.prototype.calcInclusionTreeDepths = function(graph, depth) {
                if (graph == null && depth == null) {
                    graph = this.rootGraph;
                    depth = 1;
                }
                var node;
                var nodes = graph.getNodes();
                var s = nodes.length;
                for(var i = 0; i < s; i++){
                    node = nodes[i];
                    node.inclusionTreeDepth = depth;
                    if (node.child != null) this.calcInclusionTreeDepths(node.child, depth + 1);
                }
            };
            LGraphManager.prototype.includesInvalidEdge = function() {
                var edge;
                var s = this.edges.length;
                for(var i = 0; i < s; i++){
                    edge = this.edges[i];
                    if (this.isOneAncestorOfOther(edge.source, edge.target)) return true;
                }
                return false;
            };
            module1.exports = LGraphManager;
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LayoutConstants = __webpack_require__(0);
            function FDLayoutConstants() {}
            //FDLayoutConstants inherits static props in LayoutConstants
            for(var prop in LayoutConstants)FDLayoutConstants[prop] = LayoutConstants[prop];
            FDLayoutConstants.MAX_ITERATIONS = 2500;
            FDLayoutConstants.DEFAULT_EDGE_LENGTH = 50;
            FDLayoutConstants.DEFAULT_SPRING_STRENGTH = 0.45;
            FDLayoutConstants.DEFAULT_REPULSION_STRENGTH = 4500.0;
            FDLayoutConstants.DEFAULT_GRAVITY_STRENGTH = 0.4;
            FDLayoutConstants.DEFAULT_COMPOUND_GRAVITY_STRENGTH = 1.0;
            FDLayoutConstants.DEFAULT_GRAVITY_RANGE_FACTOR = 3.8;
            FDLayoutConstants.DEFAULT_COMPOUND_GRAVITY_RANGE_FACTOR = 1.5;
            FDLayoutConstants.DEFAULT_USE_SMART_IDEAL_EDGE_LENGTH_CALCULATION = true;
            FDLayoutConstants.DEFAULT_USE_SMART_REPULSION_RANGE_CALCULATION = true;
            FDLayoutConstants.DEFAULT_COOLING_FACTOR_INCREMENTAL = 0.3;
            FDLayoutConstants.COOLING_ADAPTATION_FACTOR = 0.33;
            FDLayoutConstants.ADAPTATION_LOWER_NODE_LIMIT = 1000;
            FDLayoutConstants.ADAPTATION_UPPER_NODE_LIMIT = 5000;
            FDLayoutConstants.MAX_NODE_DISPLACEMENT_INCREMENTAL = 100.0;
            FDLayoutConstants.MAX_NODE_DISPLACEMENT = FDLayoutConstants.MAX_NODE_DISPLACEMENT_INCREMENTAL * 3;
            FDLayoutConstants.MIN_REPULSION_DIST = FDLayoutConstants.DEFAULT_EDGE_LENGTH / 10.0;
            FDLayoutConstants.CONVERGENCE_CHECK_PERIOD = 100;
            FDLayoutConstants.PER_LEVEL_IDEAL_EDGE_LENGTH_FACTOR = 0.1;
            FDLayoutConstants.MIN_EDGE_LENGTH = 1;
            FDLayoutConstants.GRID_CALCULATION_CHECK_PERIOD = 10;
            module1.exports = FDLayoutConstants;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * This class maintains a list of static geometry related utility methods.
 *
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ var Point1 = __webpack_require__(12);
            function IGeometry() {}
            /**
 * This method calculates *half* the amount in x and y directions of the two
 * input rectangles needed to separate them keeping their respective
 * positioning, and returns the result in the input array. An input
 * separation buffer added to the amount in both directions. We assume that
 * the two rectangles do intersect.
 */ IGeometry.calcSeparationAmount = function(rectA, rectB, overlapAmount, separationBuffer) {
                if (!rectA.intersects(rectB)) throw "assert failed";
                var directions = new Array(2);
                this.decideDirectionsForOverlappingNodes(rectA, rectB, directions);
                overlapAmount[0] = Math.min(rectA.getRight(), rectB.getRight()) - Math.max(rectA.x, rectB.x);
                overlapAmount[1] = Math.min(rectA.getBottom(), rectB.getBottom()) - Math.max(rectA.y, rectB.y);
                // update the overlapping amounts for the following cases:
                if (rectA.getX() <= rectB.getX() && rectA.getRight() >= rectB.getRight()) /* Case x.1:
    *
    * rectA
    * 	|                       |
    * 	|        _________      |
    * 	|        |       |      |
    * 	|________|_______|______|
    * 			 |       |
    *           |       |
    *        rectB
    */ overlapAmount[0] += Math.min(rectB.getX() - rectA.getX(), rectA.getRight() - rectB.getRight());
                else if (rectB.getX() <= rectA.getX() && rectB.getRight() >= rectA.getRight()) /* Case x.2:
    *
    * rectB
    * 	|                       |
    * 	|        _________      |
    * 	|        |       |      |
    * 	|________|_______|______|
    * 			 |       |
    *           |       |
    *        rectA
    */ overlapAmount[0] += Math.min(rectA.getX() - rectB.getX(), rectB.getRight() - rectA.getRight());
                if (rectA.getY() <= rectB.getY() && rectA.getBottom() >= rectB.getBottom()) /* Case y.1:
     *          ________ rectA
     *         |
     *         |
     *   ______|____  rectB
     *         |    |
     *         |    |
     *   ______|____|
     *         |
     *         |
     *         |________
     *
     */ overlapAmount[1] += Math.min(rectB.getY() - rectA.getY(), rectA.getBottom() - rectB.getBottom());
                else if (rectB.getY() <= rectA.getY() && rectB.getBottom() >= rectA.getBottom()) /* Case y.2:
    *          ________ rectB
    *         |
    *         |
    *   ______|____  rectA
    *         |    |
    *         |    |
    *   ______|____|
    *         |
    *         |
    *         |________
    *
    */ overlapAmount[1] += Math.min(rectA.getY() - rectB.getY(), rectB.getBottom() - rectA.getBottom());
                // find slope of the line passes two centers
                var slope = Math.abs((rectB.getCenterY() - rectA.getCenterY()) / (rectB.getCenterX() - rectA.getCenterX()));
                // if centers are overlapped
                if (rectB.getCenterY() === rectA.getCenterY() && rectB.getCenterX() === rectA.getCenterX()) // assume the slope is 1 (45 degree)
                slope = 1.0;
                var moveByY = slope * overlapAmount[0];
                var moveByX = overlapAmount[1] / slope;
                if (overlapAmount[0] < moveByX) moveByX = overlapAmount[0];
                else moveByY = overlapAmount[1];
                // return half the amount so that if each rectangle is moved by these
                // amounts in opposite directions, overlap will be resolved
                overlapAmount[0] = -1 * directions[0] * (moveByX / 2 + separationBuffer);
                overlapAmount[1] = -1 * directions[1] * (moveByY / 2 + separationBuffer);
            };
            /**
 * This method decides the separation direction of overlapping nodes
 *
 * if directions[0] = -1, then rectA goes left
 * if directions[0] = 1,  then rectA goes right
 * if directions[1] = -1, then rectA goes up
 * if directions[1] = 1,  then rectA goes down
 */ IGeometry.decideDirectionsForOverlappingNodes = function(rectA, rectB, directions) {
                if (rectA.getCenterX() < rectB.getCenterX()) directions[0] = -1;
                else directions[0] = 1;
                if (rectA.getCenterY() < rectB.getCenterY()) directions[1] = -1;
                else directions[1] = 1;
            };
            /**
 * This method calculates the intersection (clipping) points of the two
 * input rectangles with line segment defined by the centers of these two
 * rectangles. The clipping points are saved in the input double array and
 * whether or not the two rectangles overlap is returned.
 */ IGeometry.getIntersection2 = function(rectA, rectB, result) {
                //result[0-1] will contain clipPoint of rectA, result[2-3] will contain clipPoint of rectB
                var p1x = rectA.getCenterX();
                var p1y = rectA.getCenterY();
                var p2x = rectB.getCenterX();
                var p2y = rectB.getCenterY();
                //if two rectangles intersect, then clipping points are centers
                if (rectA.intersects(rectB)) {
                    result[0] = p1x;
                    result[1] = p1y;
                    result[2] = p2x;
                    result[3] = p2y;
                    return true;
                }
                //variables for rectA
                var topLeftAx = rectA.getX();
                var topLeftAy = rectA.getY();
                var topRightAx = rectA.getRight();
                var bottomLeftAx = rectA.getX();
                var bottomLeftAy = rectA.getBottom();
                var bottomRightAx = rectA.getRight();
                var halfWidthA = rectA.getWidthHalf();
                var halfHeightA = rectA.getHeightHalf();
                //variables for rectB
                var topLeftBx = rectB.getX();
                var topLeftBy = rectB.getY();
                var topRightBx = rectB.getRight();
                var bottomLeftBx = rectB.getX();
                var bottomLeftBy = rectB.getBottom();
                var bottomRightBx = rectB.getRight();
                var halfWidthB = rectB.getWidthHalf();
                var halfHeightB = rectB.getHeightHalf();
                //flag whether clipping points are found
                var clipPointAFound = false;
                var clipPointBFound = false;
                // line is vertical
                if (p1x === p2x) {
                    if (p1y > p2y) {
                        result[0] = p1x;
                        result[1] = topLeftAy;
                        result[2] = p2x;
                        result[3] = bottomLeftBy;
                        return false;
                    } else if (p1y < p2y) {
                        result[0] = p1x;
                        result[1] = bottomLeftAy;
                        result[2] = p2x;
                        result[3] = topLeftBy;
                        return false;
                    }
                } else if (p1y === p2y) {
                    if (p1x > p2x) {
                        result[0] = topLeftAx;
                        result[1] = p1y;
                        result[2] = topRightBx;
                        result[3] = p2y;
                        return false;
                    } else if (p1x < p2x) {
                        result[0] = topRightAx;
                        result[1] = p1y;
                        result[2] = topLeftBx;
                        result[3] = p2y;
                        return false;
                    }
                } else {
                    //slopes of rectA's and rectB's diagonals
                    var slopeA = rectA.height / rectA.width;
                    var slopeB = rectB.height / rectB.width;
                    //slope of line between center of rectA and center of rectB
                    var slopePrime = (p2y - p1y) / (p2x - p1x);
                    var cardinalDirectionA = void 0;
                    var cardinalDirectionB = void 0;
                    var tempPointAx = void 0;
                    var tempPointAy = void 0;
                    var tempPointBx = void 0;
                    var tempPointBy = void 0;
                    //determine whether clipping point is the corner of nodeA
                    if (-slopeA === slopePrime) {
                        if (p1x > p2x) {
                            result[0] = bottomLeftAx;
                            result[1] = bottomLeftAy;
                            clipPointAFound = true;
                        } else {
                            result[0] = topRightAx;
                            result[1] = topLeftAy;
                            clipPointAFound = true;
                        }
                    } else if (slopeA === slopePrime) {
                        if (p1x > p2x) {
                            result[0] = topLeftAx;
                            result[1] = topLeftAy;
                            clipPointAFound = true;
                        } else {
                            result[0] = bottomRightAx;
                            result[1] = bottomLeftAy;
                            clipPointAFound = true;
                        }
                    }
                    //determine whether clipping point is the corner of nodeB
                    if (-slopeB === slopePrime) {
                        if (p2x > p1x) {
                            result[2] = bottomLeftBx;
                            result[3] = bottomLeftBy;
                            clipPointBFound = true;
                        } else {
                            result[2] = topRightBx;
                            result[3] = topLeftBy;
                            clipPointBFound = true;
                        }
                    } else if (slopeB === slopePrime) {
                        if (p2x > p1x) {
                            result[2] = topLeftBx;
                            result[3] = topLeftBy;
                            clipPointBFound = true;
                        } else {
                            result[2] = bottomRightBx;
                            result[3] = bottomLeftBy;
                            clipPointBFound = true;
                        }
                    }
                    //if both clipping points are corners
                    if (clipPointAFound && clipPointBFound) return false;
                    //determine Cardinal Direction of rectangles
                    if (p1x > p2x) {
                        if (p1y > p2y) {
                            cardinalDirectionA = this.getCardinalDirection(slopeA, slopePrime, 4);
                            cardinalDirectionB = this.getCardinalDirection(slopeB, slopePrime, 2);
                        } else {
                            cardinalDirectionA = this.getCardinalDirection(-slopeA, slopePrime, 3);
                            cardinalDirectionB = this.getCardinalDirection(-slopeB, slopePrime, 1);
                        }
                    } else if (p1y > p2y) {
                        cardinalDirectionA = this.getCardinalDirection(-slopeA, slopePrime, 1);
                        cardinalDirectionB = this.getCardinalDirection(-slopeB, slopePrime, 3);
                    } else {
                        cardinalDirectionA = this.getCardinalDirection(slopeA, slopePrime, 2);
                        cardinalDirectionB = this.getCardinalDirection(slopeB, slopePrime, 4);
                    }
                    //calculate clipping Point if it is not found before
                    if (!clipPointAFound) switch(cardinalDirectionA){
                        case 1:
                            tempPointAy = topLeftAy;
                            tempPointAx = p1x + -halfHeightA / slopePrime;
                            result[0] = tempPointAx;
                            result[1] = tempPointAy;
                            break;
                        case 2:
                            tempPointAx = bottomRightAx;
                            tempPointAy = p1y + halfWidthA * slopePrime;
                            result[0] = tempPointAx;
                            result[1] = tempPointAy;
                            break;
                        case 3:
                            tempPointAy = bottomLeftAy;
                            tempPointAx = p1x + halfHeightA / slopePrime;
                            result[0] = tempPointAx;
                            result[1] = tempPointAy;
                            break;
                        case 4:
                            tempPointAx = bottomLeftAx;
                            tempPointAy = p1y + -halfWidthA * slopePrime;
                            result[0] = tempPointAx;
                            result[1] = tempPointAy;
                            break;
                    }
                    if (!clipPointBFound) switch(cardinalDirectionB){
                        case 1:
                            tempPointBy = topLeftBy;
                            tempPointBx = p2x + -halfHeightB / slopePrime;
                            result[2] = tempPointBx;
                            result[3] = tempPointBy;
                            break;
                        case 2:
                            tempPointBx = bottomRightBx;
                            tempPointBy = p2y + halfWidthB * slopePrime;
                            result[2] = tempPointBx;
                            result[3] = tempPointBy;
                            break;
                        case 3:
                            tempPointBy = bottomLeftBy;
                            tempPointBx = p2x + halfHeightB / slopePrime;
                            result[2] = tempPointBx;
                            result[3] = tempPointBy;
                            break;
                        case 4:
                            tempPointBx = bottomLeftBx;
                            tempPointBy = p2y + -halfWidthB * slopePrime;
                            result[2] = tempPointBx;
                            result[3] = tempPointBy;
                            break;
                    }
                }
                return false;
            };
            /**
 * This method returns in which cardinal direction does input point stays
 * 1: North
 * 2: East
 * 3: South
 * 4: West
 */ IGeometry.getCardinalDirection = function(slope, slopePrime, line) {
                if (slope > slopePrime) return line;
                else return 1 + line % 4;
            };
            /**
 * This method calculates the intersection of the two lines defined by
 * point pairs (s1,s2) and (f1,f2).
 */ IGeometry.getIntersection = function(s1, s2, f1, f2) {
                if (f2 == null) return this.getIntersection2(s1, s2, f1);
                var x1 = s1.x;
                var y1 = s1.y;
                var x2 = s2.x;
                var y2 = s2.y;
                var x3 = f1.x;
                var y3 = f1.y;
                var x4 = f2.x;
                var y4 = f2.y;
                var x = void 0, y = void 0; // intersection point
                var a1 = void 0, a2 = void 0, b1 = void 0, b2 = void 0, c1 = void 0, c2 = void 0; // coefficients of line eqns.
                var denom = void 0;
                a1 = y2 - y1;
                b1 = x1 - x2;
                c1 = x2 * y1 - x1 * y2; // { a1*x + b1*y + c1 = 0 is line 1 }
                a2 = y4 - y3;
                b2 = x3 - x4;
                c2 = x4 * y3 - x3 * y4; // { a2*x + b2*y + c2 = 0 is line 2 }
                denom = a1 * b2 - a2 * b1;
                if (denom === 0) return null;
                x = (b1 * c2 - b2 * c1) / denom;
                y = (a2 * c1 - a1 * c2) / denom;
                return new Point1(x, y);
            };
            /**
 * This method finds and returns the angle of the vector from the + x-axis
 * in clockwise direction (compatible w/ Java coordinate system!).
 */ IGeometry.angleOfVector = function(Cx, Cy, Nx, Ny) {
                var C_angle = void 0;
                if (Cx !== Nx) {
                    C_angle = Math.atan((Ny - Cy) / (Nx - Cx));
                    if (Nx < Cx) C_angle += Math.PI;
                    else if (Ny < Cy) C_angle += this.TWO_PI;
                } else if (Ny < Cy) C_angle = this.ONE_AND_HALF_PI; // 270 degrees
                else C_angle = this.HALF_PI; // 90 degrees
                return C_angle;
            };
            /**
 * This method checks whether the given two line segments (one with point
 * p1 and p2, the other with point p3 and p4) intersect at a point other
 * than these points.
 */ IGeometry.doIntersect = function(p1, p2, p3, p4) {
                var a = p1.x;
                var b = p1.y;
                var c = p2.x;
                var d = p2.y;
                var p = p3.x;
                var q = p3.y;
                var r = p4.x;
                var s = p4.y;
                var det = (c - a) * (s - q) - (r - p) * (d - b);
                if (det === 0) return false;
                else {
                    var lambda = ((s - q) * (r - a) + (p - r) * (s - b)) / det;
                    var gamma = ((b - d) * (r - a) + (c - a) * (s - b)) / det;
                    return 0 < lambda && lambda < 1 && 0 < gamma && gamma < 1;
                }
            };
            // -----------------------------------------------------------------------------
            // Section: Class Constants
            // -----------------------------------------------------------------------------
            /**
 * Some useful pre-calculated constants
 */ IGeometry.HALF_PI = 0.5 * Math.PI;
            IGeometry.ONE_AND_HALF_PI = 1.5 * Math.PI;
            IGeometry.TWO_PI = 2.0 * Math.PI;
            IGeometry.THREE_PI = 3.0 * Math.PI;
            module1.exports = IGeometry;
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function IMath() {}
            /**
 * This method returns the sign of the input value.
 */ IMath.sign = function(value) {
                if (value > 0) return 1;
                else if (value < 0) return -1;
                else return 0;
            };
            IMath.floor = function(value) {
                return value < 0 ? Math.ceil(value) : Math.floor(value);
            };
            IMath.ceil = function(value) {
                return value < 0 ? Math.floor(value) : Math.ceil(value);
            };
            module1.exports = IMath;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function Integer() {}
            Integer.MAX_VALUE = 2147483647;
            Integer.MIN_VALUE = -2147483648;
            module1.exports = Integer;
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var nodeFrom = function nodeFrom(value) {
                return {
                    value: value,
                    next: null,
                    prev: null
                };
            };
            var add = function add(prev, node, next, list) {
                if (prev !== null) prev.next = node;
                else list.head = node;
                if (next !== null) next.prev = node;
                else list.tail = node;
                node.prev = prev;
                node.next = next;
                list.length++;
                return node;
            };
            var _remove = function _remove(node, list) {
                var prev = node.prev, next = node.next;
                if (prev !== null) prev.next = next;
                else list.head = next;
                if (next !== null) next.prev = prev;
                else list.tail = prev;
                node.prev = node.next = null;
                list.length--;
                return node;
            };
            var LinkedList = function() {
                function LinkedList(vals) {
                    var _this = this;
                    _classCallCheck(this, LinkedList);
                    this.length = 0;
                    this.head = null;
                    this.tail = null;
                    if (vals != null) vals.forEach(function(v) {
                        return _this.push(v);
                    });
                }
                _createClass(LinkedList, [
                    {
                        key: "size",
                        value: function size() {
                            return this.length;
                        }
                    },
                    {
                        key: "insertBefore",
                        value: function insertBefore(val, otherNode) {
                            return add(otherNode.prev, nodeFrom(val), otherNode, this);
                        }
                    },
                    {
                        key: "insertAfter",
                        value: function insertAfter(val, otherNode) {
                            return add(otherNode, nodeFrom(val), otherNode.next, this);
                        }
                    },
                    {
                        key: "insertNodeBefore",
                        value: function insertNodeBefore(newNode, otherNode) {
                            return add(otherNode.prev, newNode, otherNode, this);
                        }
                    },
                    {
                        key: "insertNodeAfter",
                        value: function insertNodeAfter(newNode, otherNode) {
                            return add(otherNode, newNode, otherNode.next, this);
                        }
                    },
                    {
                        key: "push",
                        value: function push(val) {
                            return add(this.tail, nodeFrom(val), null, this);
                        }
                    },
                    {
                        key: "unshift",
                        value: function unshift(val) {
                            return add(null, nodeFrom(val), this.head, this);
                        }
                    },
                    {
                        key: "remove",
                        value: function remove(node) {
                            return _remove(node, this);
                        }
                    },
                    {
                        key: "pop",
                        value: function pop() {
                            return _remove(this.tail, this).value;
                        }
                    },
                    {
                        key: "popNode",
                        value: function popNode() {
                            return _remove(this.tail, this);
                        }
                    },
                    {
                        key: "shift",
                        value: function shift() {
                            return _remove(this.head, this).value;
                        }
                    },
                    {
                        key: "shiftNode",
                        value: function shiftNode() {
                            return _remove(this.head, this);
                        }
                    },
                    {
                        key: "get_object_at",
                        value: function get_object_at(index) {
                            if (index <= this.length()) {
                                var i = 1;
                                var current = this.head;
                                while(i < index){
                                    current = current.next;
                                    i++;
                                }
                                return current.value;
                            }
                        }
                    },
                    {
                        key: "set_object_at",
                        value: function set_object_at(index, value) {
                            if (index <= this.length()) {
                                var i = 1;
                                var current = this.head;
                                while(i < index){
                                    current = current.next;
                                    i++;
                                }
                                current.value = value;
                            }
                        }
                    }
                ]);
                return LinkedList;
            }();
            module1.exports = LinkedList;
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /*
 *This class is the javascript implementation of the Point.java class in jdk
 */ function Point1(x, y, p) {
                this.x = null;
                this.y = null;
                if (x == null && y == null && p == null) {
                    this.x = 0;
                    this.y = 0;
                } else if (typeof x == 'number' && typeof y == 'number' && p == null) {
                    this.x = x;
                    this.y = y;
                } else if (x.constructor.name == 'Point' && y == null && p == null) {
                    p = x;
                    this.x = p.x;
                    this.y = p.y;
                }
            }
            Point1.prototype.getX = function() {
                return this.x;
            };
            Point1.prototype.getY = function() {
                return this.y;
            };
            Point1.prototype.getLocation = function() {
                return new Point1(this.x, this.y);
            };
            Point1.prototype.setLocation = function(x, y, p) {
                if (x.constructor.name == 'Point' && y == null && p == null) {
                    p = x;
                    this.setLocation(p.x, p.y);
                } else if (typeof x == 'number' && typeof y == 'number' && p == null) {
                    //if both parameters are integer just move (x,y) location
                    if (parseInt(x) == x && parseInt(y) == y) this.move(x, y);
                    else {
                        this.x = Math.floor(x + 0.5);
                        this.y = Math.floor(y + 0.5);
                    }
                }
            };
            Point1.prototype.move = function(x, y) {
                this.x = x;
                this.y = y;
            };
            Point1.prototype.translate = function(dx, dy) {
                this.x += dx;
                this.y += dy;
            };
            Point1.prototype.equals = function(obj) {
                if (obj.constructor.name == "Point") {
                    var pt = obj;
                    return this.x == pt.x && this.y == pt.y;
                }
                return this == obj;
            };
            Point1.prototype.toString = function() {
                return new Point1().constructor.name + "[x=" + this.x + ",y=" + this.y + "]";
            };
            module1.exports = Point1;
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function RectangleD(x, y, width, height) {
                this.x = 0;
                this.y = 0;
                this.width = 0;
                this.height = 0;
                if (x != null && y != null && width != null && height != null) {
                    this.x = x;
                    this.y = y;
                    this.width = width;
                    this.height = height;
                }
            }
            RectangleD.prototype.getX = function() {
                return this.x;
            };
            RectangleD.prototype.setX = function(x) {
                this.x = x;
            };
            RectangleD.prototype.getY = function() {
                return this.y;
            };
            RectangleD.prototype.setY = function(y) {
                this.y = y;
            };
            RectangleD.prototype.getWidth = function() {
                return this.width;
            };
            RectangleD.prototype.setWidth = function(width) {
                this.width = width;
            };
            RectangleD.prototype.getHeight = function() {
                return this.height;
            };
            RectangleD.prototype.setHeight = function(height) {
                this.height = height;
            };
            RectangleD.prototype.getRight = function() {
                return this.x + this.width;
            };
            RectangleD.prototype.getBottom = function() {
                return this.y + this.height;
            };
            RectangleD.prototype.intersects = function(a) {
                if (this.getRight() < a.x) return false;
                if (this.getBottom() < a.y) return false;
                if (a.getRight() < this.x) return false;
                if (a.getBottom() < this.y) return false;
                return true;
            };
            RectangleD.prototype.getCenterX = function() {
                return this.x + this.width / 2;
            };
            RectangleD.prototype.getMinX = function() {
                return this.getX();
            };
            RectangleD.prototype.getMaxX = function() {
                return this.getX() + this.width;
            };
            RectangleD.prototype.getCenterY = function() {
                return this.y + this.height / 2;
            };
            RectangleD.prototype.getMinY = function() {
                return this.getY();
            };
            RectangleD.prototype.getMaxY = function() {
                return this.getY() + this.height;
            };
            RectangleD.prototype.getWidthHalf = function() {
                return this.width / 2;
            };
            RectangleD.prototype.getHeightHalf = function() {
                return this.height / 2;
            };
            module1.exports = RectangleD;
        /***/ },
        /* 14 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            function UniqueIDGeneretor() {}
            UniqueIDGeneretor.lastID = 0;
            UniqueIDGeneretor.createID = function(obj) {
                if (UniqueIDGeneretor.isPrimitive(obj)) return obj;
                if (obj.uniqueID != null) return obj.uniqueID;
                obj.uniqueID = UniqueIDGeneretor.getString();
                UniqueIDGeneretor.lastID++;
                return obj.uniqueID;
            };
            UniqueIDGeneretor.getString = function(id) {
                if (id == null) id = UniqueIDGeneretor.lastID;
                return "Object#" + id + "";
            };
            UniqueIDGeneretor.isPrimitive = function(arg) {
                var type = typeof arg === "undefined" ? "undefined" : _typeof(arg);
                return arg == null || type != "object" && type != "function";
            };
            module1.exports = UniqueIDGeneretor;
        /***/ },
        /* 15 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function _toConsumableArray(arr) {
                if (Array.isArray(arr)) {
                    for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                    return arr2;
                } else return Array.from(arr);
            }
            var LayoutConstants = __webpack_require__(0);
            var LGraphManager = __webpack_require__(6);
            var LNode = __webpack_require__(3);
            var LEdge = __webpack_require__(1);
            var LGraph = __webpack_require__(5);
            var PointD = __webpack_require__(4);
            var Transform = __webpack_require__(17);
            var Emitter = __webpack_require__(27);
            function Layout1(isRemoteUse) {
                Emitter.call(this);
                //Layout Quality: 0:draft, 1:default, 2:proof
                this.layoutQuality = LayoutConstants.QUALITY;
                //Whether layout should create bendpoints as needed or not
                this.createBendsAsNeeded = LayoutConstants.DEFAULT_CREATE_BENDS_AS_NEEDED;
                //Whether layout should be incremental or not
                this.incremental = LayoutConstants.DEFAULT_INCREMENTAL;
                //Whether we animate from before to after layout node positions
                this.animationOnLayout = LayoutConstants.DEFAULT_ANIMATION_ON_LAYOUT;
                //Whether we animate the layout process or not
                this.animationDuringLayout = LayoutConstants.DEFAULT_ANIMATION_DURING_LAYOUT;
                //Number iterations that should be done between two successive animations
                this.animationPeriod = LayoutConstants.DEFAULT_ANIMATION_PERIOD;
                /**
   * Whether or not leaf nodes (non-compound nodes) are of uniform sizes. When
   * they are, both spring and repulsion forces between two leaf nodes can be
   * calculated without the expensive clipping point calculations, resulting
   * in major speed-up.
   */ this.uniformLeafNodeSizes = LayoutConstants.DEFAULT_UNIFORM_LEAF_NODE_SIZES;
                /**
   * This is used for creation of bendpoints by using dummy nodes and edges.
   * Maps an LEdge to its dummy bendpoint path.
   */ this.edgeToDummyNodes = new Map();
                this.graphManager = new LGraphManager(this);
                this.isLayoutFinished = false;
                this.isSubLayout = false;
                this.isRemoteUse = false;
                if (isRemoteUse != null) this.isRemoteUse = isRemoteUse;
            }
            Layout1.RANDOM_SEED = 1;
            Layout1.prototype = Object.create(Emitter.prototype);
            Layout1.prototype.getGraphManager = function() {
                return this.graphManager;
            };
            Layout1.prototype.getAllNodes = function() {
                return this.graphManager.getAllNodes();
            };
            Layout1.prototype.getAllEdges = function() {
                return this.graphManager.getAllEdges();
            };
            Layout1.prototype.getAllNodesToApplyGravitation = function() {
                return this.graphManager.getAllNodesToApplyGravitation();
            };
            Layout1.prototype.newGraphManager = function() {
                var gm = new LGraphManager(this);
                this.graphManager = gm;
                return gm;
            };
            Layout1.prototype.newGraph = function(vGraph) {
                return new LGraph(null, this.graphManager, vGraph);
            };
            Layout1.prototype.newNode = function(vNode) {
                return new LNode(this.graphManager, vNode);
            };
            Layout1.prototype.newEdge = function(vEdge) {
                return new LEdge(null, null, vEdge);
            };
            Layout1.prototype.checkLayoutSuccess = function() {
                return this.graphManager.getRoot() == null || this.graphManager.getRoot().getNodes().length == 0 || this.graphManager.includesInvalidEdge();
            };
            Layout1.prototype.runLayout = function() {
                this.isLayoutFinished = false;
                if (this.tilingPreLayout) this.tilingPreLayout();
                this.initParameters();
                var isLayoutSuccessfull;
                if (this.checkLayoutSuccess()) isLayoutSuccessfull = false;
                else isLayoutSuccessfull = this.layout();
                if (LayoutConstants.ANIMATE === 'during') // If this is a 'during' layout animation. Layout is not finished yet. 
                // We need to perform these in index.js when layout is really finished.
                return false;
                if (isLayoutSuccessfull) {
                    if (!this.isSubLayout) this.doPostLayout();
                }
                if (this.tilingPostLayout) this.tilingPostLayout();
                this.isLayoutFinished = true;
                return isLayoutSuccessfull;
            };
            /**
 * This method performs the operations required after layout.
 */ Layout1.prototype.doPostLayout = function() {
                //assert !isSubLayout : "Should not be called on sub-layout!";
                // Propagate geometric changes to v-level objects
                if (!this.incremental) this.transform();
                this.update();
            };
            /**
 * This method updates the geometry of the target graph according to
 * calculated layout.
 */ Layout1.prototype.update2 = function() {
                // update bend points
                if (this.createBendsAsNeeded) {
                    this.createBendpointsFromDummyNodes();
                    // reset all edges, since the topology has changed
                    this.graphManager.resetAllEdges();
                }
                // perform edge, node and root updates if layout is not called
                // remotely
                if (!this.isRemoteUse) {
                    // update all edges
                    var edge;
                    var allEdges = this.graphManager.getAllEdges();
                    for(var i = 0; i < allEdges.length; i++)edge = allEdges[i];
                    // recursively update nodes
                    var node;
                    var nodes = this.graphManager.getRoot().getNodes();
                    for(var i = 0; i < nodes.length; i++)node = nodes[i];
                    // update root graph
                    this.update(this.graphManager.getRoot());
                }
            };
            Layout1.prototype.update = function(obj) {
                if (obj == null) this.update2();
                else if (obj instanceof LNode) {
                    var node = obj;
                    if (node.getChild() != null) {
                        // since node is compound, recursively update child nodes
                        var nodes = node.getChild().getNodes();
                        for(var i = 0; i < nodes.length; i++)update(nodes[i]);
                    }
                    // if the l-level node is associated with a v-level graph object,
                    // then it is assumed that the v-level node implements the
                    // interface Updatable.
                    if (node.vGraphObject != null) {
                        // cast to Updatable without any type check
                        var vNode = node.vGraphObject;
                        // call the update method of the interface
                        vNode.update(node);
                    }
                } else if (obj instanceof LEdge) {
                    var edge = obj;
                    // if the l-level edge is associated with a v-level graph object,
                    // then it is assumed that the v-level edge implements the
                    // interface Updatable.
                    if (edge.vGraphObject != null) {
                        // cast to Updatable without any type check
                        var vEdge = edge.vGraphObject;
                        // call the update method of the interface
                        vEdge.update(edge);
                    }
                } else if (obj instanceof LGraph) {
                    var graph = obj;
                    // if the l-level graph is associated with a v-level graph object,
                    // then it is assumed that the v-level object implements the
                    // interface Updatable.
                    if (graph.vGraphObject != null) {
                        // cast to Updatable without any type check
                        var vGraph = graph.vGraphObject;
                        // call the update method of the interface
                        vGraph.update(graph);
                    }
                }
            };
            /**
 * This method is used to set all layout parameters to default values
 * determined at compile time.
 */ Layout1.prototype.initParameters = function() {
                if (!this.isSubLayout) {
                    this.layoutQuality = LayoutConstants.QUALITY;
                    this.animationDuringLayout = LayoutConstants.DEFAULT_ANIMATION_DURING_LAYOUT;
                    this.animationPeriod = LayoutConstants.DEFAULT_ANIMATION_PERIOD;
                    this.animationOnLayout = LayoutConstants.DEFAULT_ANIMATION_ON_LAYOUT;
                    this.incremental = LayoutConstants.DEFAULT_INCREMENTAL;
                    this.createBendsAsNeeded = LayoutConstants.DEFAULT_CREATE_BENDS_AS_NEEDED;
                    this.uniformLeafNodeSizes = LayoutConstants.DEFAULT_UNIFORM_LEAF_NODE_SIZES;
                }
                if (this.animationDuringLayout) this.animationOnLayout = false;
            };
            Layout1.prototype.transform = function(newLeftTop) {
                if (newLeftTop == undefined) this.transform(new PointD(0, 0));
                else {
                    // create a transformation object (from Eclipse to layout). When an
                    // inverse transform is applied, we get upper-left coordinate of the
                    // drawing or the root graph at given input coordinate (some margins
                    // already included in calculation of left-top).
                    var trans = new Transform();
                    var leftTop = this.graphManager.getRoot().updateLeftTop();
                    if (leftTop != null) {
                        trans.setWorldOrgX(newLeftTop.x);
                        trans.setWorldOrgY(newLeftTop.y);
                        trans.setDeviceOrgX(leftTop.x);
                        trans.setDeviceOrgY(leftTop.y);
                        var nodes = this.getAllNodes();
                        var node;
                        for(var i = 0; i < nodes.length; i++){
                            node = nodes[i];
                            node.transform(trans);
                        }
                    }
                }
            };
            Layout1.prototype.positionNodesRandomly = function(graph) {
                if (graph == undefined) {
                    //assert !this.incremental;
                    this.positionNodesRandomly(this.getGraphManager().getRoot());
                    this.getGraphManager().getRoot().updateBounds(true);
                } else {
                    var lNode;
                    var childGraph;
                    var nodes = graph.getNodes();
                    for(var i = 0; i < nodes.length; i++){
                        lNode = nodes[i];
                        childGraph = lNode.getChild();
                        if (childGraph == null) lNode.scatter();
                        else if (childGraph.getNodes().length == 0) lNode.scatter();
                        else {
                            this.positionNodesRandomly(childGraph);
                            lNode.updateBounds();
                        }
                    }
                }
            };
            /**
 * This method returns a list of trees where each tree is represented as a
 * list of l-nodes. The method returns a list of size 0 when:
 * - The graph is not flat or
 * - One of the component(s) of the graph is not a tree.
 */ Layout1.prototype.getFlatForest = function() {
                var flatForest = [];
                var isForest = true;
                // Quick reference for all nodes in the graph manager associated with
                // this layout. The list should not be changed.
                var allNodes = this.graphManager.getRoot().getNodes();
                // First be sure that the graph is flat
                var isFlat = true;
                for(var i = 0; i < allNodes.length; i++)if (allNodes[i].getChild() != null) isFlat = false;
                // Return empty forest if the graph is not flat.
                if (!isFlat) return flatForest;
                // Run BFS for each component of the graph.
                var visited = new Set();
                var toBeVisited = [];
                var parents = new Map();
                var unProcessedNodes = [];
                unProcessedNodes = unProcessedNodes.concat(allNodes);
                // Each iteration of this loop finds a component of the graph and
                // decides whether it is a tree or not. If it is a tree, adds it to the
                // forest and continued with the next component.
                while(unProcessedNodes.length > 0 && isForest){
                    toBeVisited.push(unProcessedNodes[0]);
                    // Start the BFS. Each iteration of this loop visits a node in a
                    // BFS manner.
                    while(toBeVisited.length > 0 && isForest){
                        //pool operation
                        var currentNode = toBeVisited[0];
                        toBeVisited.splice(0, 1);
                        visited.add(currentNode);
                        // Traverse all neighbors of this node
                        var neighborEdges = currentNode.getEdges();
                        for(var i = 0; i < neighborEdges.length; i++){
                            var currentNeighbor = neighborEdges[i].getOtherEnd(currentNode);
                            // If BFS is not growing from this neighbor.
                            if (parents.get(currentNode) != currentNeighbor) {
                                // We haven't previously visited this neighbor.
                                if (!visited.has(currentNeighbor)) {
                                    toBeVisited.push(currentNeighbor);
                                    parents.set(currentNeighbor, currentNode);
                                } else {
                                    isForest = false;
                                    break;
                                }
                            }
                        }
                    }
                    // The graph contains a component that is not a tree. Empty
                    // previously found trees. The method will end.
                    if (!isForest) flatForest = [];
                    else {
                        var temp = [].concat(_toConsumableArray(visited));
                        flatForest.push(temp);
                        //flatForest = flatForest.concat(temp);
                        //unProcessedNodes.removeAll(visited);
                        for(var i = 0; i < temp.length; i++){
                            var value = temp[i];
                            var index = unProcessedNodes.indexOf(value);
                            if (index > -1) unProcessedNodes.splice(index, 1);
                        }
                        visited = new Set();
                        parents = new Map();
                    }
                }
                return flatForest;
            };
            /**
 * This method creates dummy nodes (an l-level node with minimal dimensions)
 * for the given edge (one per bendpoint). The existing l-level structure
 * is updated accordingly.
 */ Layout1.prototype.createDummyNodesForBendpoints = function(edge) {
                var dummyNodes = [];
                var prev = edge.source;
                var graph = this.graphManager.calcLowestCommonAncestor(edge.source, edge.target);
                for(var i = 0; i < edge.bendpoints.length; i++){
                    // create new dummy node
                    var dummyNode = this.newNode(null);
                    dummyNode.setRect(new Point(0, 0), new Dimension(1, 1));
                    graph.add(dummyNode);
                    // create new dummy edge between prev and dummy node
                    var dummyEdge = this.newEdge(null);
                    this.graphManager.add(dummyEdge, prev, dummyNode);
                    dummyNodes.add(dummyNode);
                    prev = dummyNode;
                }
                var dummyEdge = this.newEdge(null);
                this.graphManager.add(dummyEdge, prev, edge.target);
                this.edgeToDummyNodes.set(edge, dummyNodes);
                // remove real edge from graph manager if it is inter-graph
                if (edge.isInterGraph()) this.graphManager.remove(edge);
                else graph.remove(edge);
                return dummyNodes;
            };
            /**
 * This method creates bendpoints for edges from the dummy nodes
 * at l-level.
 */ Layout1.prototype.createBendpointsFromDummyNodes = function() {
                var edges = [];
                edges = edges.concat(this.graphManager.getAllEdges());
                edges = [].concat(_toConsumableArray(this.edgeToDummyNodes.keys())).concat(edges);
                for(var k = 0; k < edges.length; k++){
                    var lEdge = edges[k];
                    if (lEdge.bendpoints.length > 0) {
                        var path = this.edgeToDummyNodes.get(lEdge);
                        for(var i = 0; i < path.length; i++){
                            var dummyNode = path[i];
                            var p = new PointD(dummyNode.getCenterX(), dummyNode.getCenterY());
                            // update bendpoint's location according to dummy node
                            var ebp = lEdge.bendpoints.get(i);
                            ebp.x = p.x;
                            ebp.y = p.y;
                            // remove the dummy node, dummy edges incident with this
                            // dummy node is also removed (within the remove method)
                            dummyNode.getOwner().remove(dummyNode);
                        }
                        // add the real edge to graph
                        this.graphManager.add(lEdge, lEdge.source, lEdge.target);
                    }
                }
            };
            Layout1.transform = function(sliderValue, defaultValue, minDiv, maxMul) {
                if (minDiv != undefined && maxMul != undefined) {
                    var value = defaultValue;
                    if (sliderValue <= 50) {
                        var minValue = defaultValue / minDiv;
                        value -= (defaultValue - minValue) / 50 * (50 - sliderValue);
                    } else {
                        var maxValue = defaultValue * maxMul;
                        value += (maxValue - defaultValue) / 50 * (sliderValue - 50);
                    }
                    return value;
                } else {
                    var a, b;
                    if (sliderValue <= 50) {
                        a = 9.0 * defaultValue / 500.0;
                        b = defaultValue / 10.0;
                    } else {
                        a = 9.0 * defaultValue / 50.0;
                        b = -8 * defaultValue;
                    }
                    return a * sliderValue + b;
                }
            };
            /**
 * This method finds and returns the center of the given nodes, assuming
 * that the given nodes form a tree in themselves.
 */ Layout1.findCenterOfTree = function(nodes) {
                var list = [];
                list = list.concat(nodes);
                var removedNodes = [];
                var remainingDegrees = new Map();
                var foundCenter = false;
                var centerNode = null;
                if (list.length == 1 || list.length == 2) {
                    foundCenter = true;
                    centerNode = list[0];
                }
                for(var i = 0; i < list.length; i++){
                    var node = list[i];
                    var degree = node.getNeighborsList().size;
                    remainingDegrees.set(node, node.getNeighborsList().size);
                    if (degree == 1) removedNodes.push(node);
                }
                var tempList = [];
                tempList = tempList.concat(removedNodes);
                while(!foundCenter){
                    var tempList2 = [];
                    tempList2 = tempList2.concat(tempList);
                    tempList = [];
                    for(var i = 0; i < list.length; i++){
                        var node = list[i];
                        var index = list.indexOf(node);
                        if (index >= 0) list.splice(index, 1);
                        var neighbours = node.getNeighborsList();
                        neighbours.forEach(function(neighbour) {
                            if (removedNodes.indexOf(neighbour) < 0) {
                                var otherDegree = remainingDegrees.get(neighbour);
                                var newDegree = otherDegree - 1;
                                if (newDegree == 1) tempList.push(neighbour);
                                remainingDegrees.set(neighbour, newDegree);
                            }
                        });
                    }
                    removedNodes = removedNodes.concat(tempList);
                    if (list.length == 1 || list.length == 2) {
                        foundCenter = true;
                        centerNode = list[0];
                    }
                }
                return centerNode;
            };
            /**
 * During the coarsening process, this layout may be referenced by two graph managers
 * this setter function grants access to change the currently being used graph manager
 */ Layout1.prototype.setGraphManager = function(gm) {
                this.graphManager = gm;
            };
            module1.exports = Layout1;
        /***/ },
        /* 16 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function RandomSeed() {}
            // adapted from: https://stackoverflow.com/a/19303725
            RandomSeed.seed = 1;
            RandomSeed.x = 0;
            RandomSeed.nextDouble = function() {
                RandomSeed.x = Math.sin(RandomSeed.seed++) * 10000;
                return RandomSeed.x - Math.floor(RandomSeed.x);
            };
            module1.exports = RandomSeed;
        /***/ },
        /* 17 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var PointD = __webpack_require__(4);
            function Transform(x, y) {
                this.lworldOrgX = 0.0;
                this.lworldOrgY = 0.0;
                this.ldeviceOrgX = 0.0;
                this.ldeviceOrgY = 0.0;
                this.lworldExtX = 1.0;
                this.lworldExtY = 1.0;
                this.ldeviceExtX = 1.0;
                this.ldeviceExtY = 1.0;
            }
            Transform.prototype.getWorldOrgX = function() {
                return this.lworldOrgX;
            };
            Transform.prototype.setWorldOrgX = function(wox) {
                this.lworldOrgX = wox;
            };
            Transform.prototype.getWorldOrgY = function() {
                return this.lworldOrgY;
            };
            Transform.prototype.setWorldOrgY = function(woy) {
                this.lworldOrgY = woy;
            };
            Transform.prototype.getWorldExtX = function() {
                return this.lworldExtX;
            };
            Transform.prototype.setWorldExtX = function(wex) {
                this.lworldExtX = wex;
            };
            Transform.prototype.getWorldExtY = function() {
                return this.lworldExtY;
            };
            Transform.prototype.setWorldExtY = function(wey) {
                this.lworldExtY = wey;
            };
            /* Device related */ Transform.prototype.getDeviceOrgX = function() {
                return this.ldeviceOrgX;
            };
            Transform.prototype.setDeviceOrgX = function(dox) {
                this.ldeviceOrgX = dox;
            };
            Transform.prototype.getDeviceOrgY = function() {
                return this.ldeviceOrgY;
            };
            Transform.prototype.setDeviceOrgY = function(doy) {
                this.ldeviceOrgY = doy;
            };
            Transform.prototype.getDeviceExtX = function() {
                return this.ldeviceExtX;
            };
            Transform.prototype.setDeviceExtX = function(dex) {
                this.ldeviceExtX = dex;
            };
            Transform.prototype.getDeviceExtY = function() {
                return this.ldeviceExtY;
            };
            Transform.prototype.setDeviceExtY = function(dey) {
                this.ldeviceExtY = dey;
            };
            Transform.prototype.transformX = function(x) {
                var xDevice = 0.0;
                var worldExtX = this.lworldExtX;
                if (worldExtX != 0.0) xDevice = this.ldeviceOrgX + (x - this.lworldOrgX) * this.ldeviceExtX / worldExtX;
                return xDevice;
            };
            Transform.prototype.transformY = function(y) {
                var yDevice = 0.0;
                var worldExtY = this.lworldExtY;
                if (worldExtY != 0.0) yDevice = this.ldeviceOrgY + (y - this.lworldOrgY) * this.ldeviceExtY / worldExtY;
                return yDevice;
            };
            Transform.prototype.inverseTransformX = function(x) {
                var xWorld = 0.0;
                var deviceExtX = this.ldeviceExtX;
                if (deviceExtX != 0.0) xWorld = this.lworldOrgX + (x - this.ldeviceOrgX) * this.lworldExtX / deviceExtX;
                return xWorld;
            };
            Transform.prototype.inverseTransformY = function(y) {
                var yWorld = 0.0;
                var deviceExtY = this.ldeviceExtY;
                if (deviceExtY != 0.0) yWorld = this.lworldOrgY + (y - this.ldeviceOrgY) * this.lworldExtY / deviceExtY;
                return yWorld;
            };
            Transform.prototype.inverseTransformPoint = function(inPoint) {
                var outPoint = new PointD(this.inverseTransformX(inPoint.x), this.inverseTransformY(inPoint.y));
                return outPoint;
            };
            module1.exports = Transform;
        /***/ },
        /* 18 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function _toConsumableArray(arr) {
                if (Array.isArray(arr)) {
                    for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                    return arr2;
                } else return Array.from(arr);
            }
            var Layout1 = __webpack_require__(15);
            var FDLayoutConstants = __webpack_require__(7);
            var LayoutConstants = __webpack_require__(0);
            var IGeometry = __webpack_require__(8);
            var IMath = __webpack_require__(9);
            function FDLayout() {
                Layout1.call(this);
                this.useSmartIdealEdgeLengthCalculation = FDLayoutConstants.DEFAULT_USE_SMART_IDEAL_EDGE_LENGTH_CALCULATION;
                this.idealEdgeLength = FDLayoutConstants.DEFAULT_EDGE_LENGTH;
                this.springConstant = FDLayoutConstants.DEFAULT_SPRING_STRENGTH;
                this.repulsionConstant = FDLayoutConstants.DEFAULT_REPULSION_STRENGTH;
                this.gravityConstant = FDLayoutConstants.DEFAULT_GRAVITY_STRENGTH;
                this.compoundGravityConstant = FDLayoutConstants.DEFAULT_COMPOUND_GRAVITY_STRENGTH;
                this.gravityRangeFactor = FDLayoutConstants.DEFAULT_GRAVITY_RANGE_FACTOR;
                this.compoundGravityRangeFactor = FDLayoutConstants.DEFAULT_COMPOUND_GRAVITY_RANGE_FACTOR;
                this.displacementThresholdPerNode = 3.0 * FDLayoutConstants.DEFAULT_EDGE_LENGTH / 100;
                this.coolingFactor = FDLayoutConstants.DEFAULT_COOLING_FACTOR_INCREMENTAL;
                this.initialCoolingFactor = FDLayoutConstants.DEFAULT_COOLING_FACTOR_INCREMENTAL;
                this.totalDisplacement = 0.0;
                this.oldTotalDisplacement = 0.0;
                this.maxIterations = FDLayoutConstants.MAX_ITERATIONS;
            }
            FDLayout.prototype = Object.create(Layout1.prototype);
            for(var prop in Layout1)FDLayout[prop] = Layout1[prop];
            FDLayout.prototype.initParameters = function() {
                Layout1.prototype.initParameters.call(this, arguments);
                this.totalIterations = 0;
                this.notAnimatedIterations = 0;
                this.useFRGridVariant = FDLayoutConstants.DEFAULT_USE_SMART_REPULSION_RANGE_CALCULATION;
                this.grid = [];
            };
            FDLayout.prototype.calcIdealEdgeLengths = function() {
                var edge;
                var lcaDepth;
                var source;
                var target;
                var sizeOfSourceInLca;
                var sizeOfTargetInLca;
                var allEdges = this.getGraphManager().getAllEdges();
                for(var i = 0; i < allEdges.length; i++){
                    edge = allEdges[i];
                    edge.idealLength = this.idealEdgeLength;
                    if (edge.isInterGraph) {
                        source = edge.getSource();
                        target = edge.getTarget();
                        sizeOfSourceInLca = edge.getSourceInLca().getEstimatedSize();
                        sizeOfTargetInLca = edge.getTargetInLca().getEstimatedSize();
                        if (this.useSmartIdealEdgeLengthCalculation) edge.idealLength += sizeOfSourceInLca + sizeOfTargetInLca - 2 * LayoutConstants.SIMPLE_NODE_SIZE;
                        lcaDepth = edge.getLca().getInclusionTreeDepth();
                        edge.idealLength += FDLayoutConstants.DEFAULT_EDGE_LENGTH * FDLayoutConstants.PER_LEVEL_IDEAL_EDGE_LENGTH_FACTOR * (source.getInclusionTreeDepth() + target.getInclusionTreeDepth() - 2 * lcaDepth);
                    }
                }
            };
            FDLayout.prototype.initSpringEmbedder = function() {
                var s = this.getAllNodes().length;
                if (this.incremental) {
                    if (s > FDLayoutConstants.ADAPTATION_LOWER_NODE_LIMIT) this.coolingFactor = Math.max(this.coolingFactor * FDLayoutConstants.COOLING_ADAPTATION_FACTOR, this.coolingFactor - (s - FDLayoutConstants.ADAPTATION_LOWER_NODE_LIMIT) / (FDLayoutConstants.ADAPTATION_UPPER_NODE_LIMIT - FDLayoutConstants.ADAPTATION_LOWER_NODE_LIMIT) * this.coolingFactor * (1 - FDLayoutConstants.COOLING_ADAPTATION_FACTOR));
                    this.maxNodeDisplacement = FDLayoutConstants.MAX_NODE_DISPLACEMENT_INCREMENTAL;
                } else {
                    if (s > FDLayoutConstants.ADAPTATION_LOWER_NODE_LIMIT) this.coolingFactor = Math.max(FDLayoutConstants.COOLING_ADAPTATION_FACTOR, 1.0 - (s - FDLayoutConstants.ADAPTATION_LOWER_NODE_LIMIT) / (FDLayoutConstants.ADAPTATION_UPPER_NODE_LIMIT - FDLayoutConstants.ADAPTATION_LOWER_NODE_LIMIT) * (1 - FDLayoutConstants.COOLING_ADAPTATION_FACTOR));
                    else this.coolingFactor = 1.0;
                    this.initialCoolingFactor = this.coolingFactor;
                    this.maxNodeDisplacement = FDLayoutConstants.MAX_NODE_DISPLACEMENT;
                }
                this.maxIterations = Math.max(this.getAllNodes().length * 5, this.maxIterations);
                this.totalDisplacementThreshold = this.displacementThresholdPerNode * this.getAllNodes().length;
                this.repulsionRange = this.calcRepulsionRange();
            };
            FDLayout.prototype.calcSpringForces = function() {
                var lEdges = this.getAllEdges();
                var edge;
                for(var i = 0; i < lEdges.length; i++){
                    edge = lEdges[i];
                    this.calcSpringForce(edge, edge.idealLength);
                }
            };
            FDLayout.prototype.calcRepulsionForces = function() {
                var gridUpdateAllowed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var forceToNodeSurroundingUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var i, j;
                var nodeA, nodeB;
                var lNodes = this.getAllNodes();
                var processedNodeSet;
                if (this.useFRGridVariant) {
                    if (this.totalIterations % FDLayoutConstants.GRID_CALCULATION_CHECK_PERIOD == 1 && gridUpdateAllowed) this.updateGrid();
                    processedNodeSet = new Set();
                    // calculate repulsion forces between each nodes and its surrounding
                    for(i = 0; i < lNodes.length; i++){
                        nodeA = lNodes[i];
                        this.calculateRepulsionForceOfANode(nodeA, processedNodeSet, gridUpdateAllowed, forceToNodeSurroundingUpdate);
                        processedNodeSet.add(nodeA);
                    }
                } else for(i = 0; i < lNodes.length; i++){
                    nodeA = lNodes[i];
                    for(j = i + 1; j < lNodes.length; j++){
                        nodeB = lNodes[j];
                        // If both nodes are not members of the same graph, skip.
                        if (nodeA.getOwner() != nodeB.getOwner()) continue;
                        this.calcRepulsionForce(nodeA, nodeB);
                    }
                }
            };
            FDLayout.prototype.calcGravitationalForces = function() {
                var node;
                var lNodes = this.getAllNodesToApplyGravitation();
                for(var i = 0; i < lNodes.length; i++){
                    node = lNodes[i];
                    this.calcGravitationalForce(node);
                }
            };
            FDLayout.prototype.moveNodes = function() {
                var lNodes = this.getAllNodes();
                var node;
                for(var i = 0; i < lNodes.length; i++){
                    node = lNodes[i];
                    node.move();
                }
            };
            FDLayout.prototype.calcSpringForce = function(edge, idealLength) {
                var sourceNode = edge.getSource();
                var targetNode = edge.getTarget();
                var length;
                var springForce;
                var springForceX;
                var springForceY;
                // Update edge length
                if (this.uniformLeafNodeSizes && sourceNode.getChild() == null && targetNode.getChild() == null) edge.updateLengthSimple();
                else {
                    edge.updateLength();
                    if (edge.isOverlapingSourceAndTarget) return;
                }
                length = edge.getLength();
                if (length == 0) return;
                // Calculate spring forces
                springForce = this.springConstant * (length - idealLength);
                // Project force onto x and y axes
                springForceX = springForce * (edge.lengthX / length);
                springForceY = springForce * (edge.lengthY / length);
                // Apply forces on the end nodes
                sourceNode.springForceX += springForceX;
                sourceNode.springForceY += springForceY;
                targetNode.springForceX -= springForceX;
                targetNode.springForceY -= springForceY;
            };
            FDLayout.prototype.calcRepulsionForce = function(nodeA, nodeB) {
                var rectA = nodeA.getRect();
                var rectB = nodeB.getRect();
                var overlapAmount = new Array(2);
                var clipPoints = new Array(4);
                var distanceX;
                var distanceY;
                var distanceSquared;
                var distance;
                var repulsionForce;
                var repulsionForceX;
                var repulsionForceY;
                if (rectA.intersects(rectB)) {
                    // calculate separation amount in x and y directions
                    IGeometry.calcSeparationAmount(rectA, rectB, overlapAmount, FDLayoutConstants.DEFAULT_EDGE_LENGTH / 2.0);
                    repulsionForceX = 2 * overlapAmount[0];
                    repulsionForceY = 2 * overlapAmount[1];
                    var childrenConstant = nodeA.noOfChildren * nodeB.noOfChildren / (nodeA.noOfChildren + nodeB.noOfChildren);
                    // Apply forces on the two nodes
                    nodeA.repulsionForceX -= childrenConstant * repulsionForceX;
                    nodeA.repulsionForceY -= childrenConstant * repulsionForceY;
                    nodeB.repulsionForceX += childrenConstant * repulsionForceX;
                    nodeB.repulsionForceY += childrenConstant * repulsionForceY;
                } else {
                    // calculate distance
                    if (this.uniformLeafNodeSizes && nodeA.getChild() == null && nodeB.getChild() == null) {
                        distanceX = rectB.getCenterX() - rectA.getCenterX();
                        distanceY = rectB.getCenterY() - rectA.getCenterY();
                    } else {
                        IGeometry.getIntersection(rectA, rectB, clipPoints);
                        distanceX = clipPoints[2] - clipPoints[0];
                        distanceY = clipPoints[3] - clipPoints[1];
                    }
                    // No repulsion range. FR grid variant should take care of this.
                    if (Math.abs(distanceX) < FDLayoutConstants.MIN_REPULSION_DIST) distanceX = IMath.sign(distanceX) * FDLayoutConstants.MIN_REPULSION_DIST;
                    if (Math.abs(distanceY) < FDLayoutConstants.MIN_REPULSION_DIST) distanceY = IMath.sign(distanceY) * FDLayoutConstants.MIN_REPULSION_DIST;
                    distanceSquared = distanceX * distanceX + distanceY * distanceY;
                    distance = Math.sqrt(distanceSquared);
                    repulsionForce = this.repulsionConstant * nodeA.noOfChildren * nodeB.noOfChildren / distanceSquared;
                    // Project force onto x and y axes
                    repulsionForceX = repulsionForce * distanceX / distance;
                    repulsionForceY = repulsionForce * distanceY / distance;
                    // Apply forces on the two nodes    
                    nodeA.repulsionForceX -= repulsionForceX;
                    nodeA.repulsionForceY -= repulsionForceY;
                    nodeB.repulsionForceX += repulsionForceX;
                    nodeB.repulsionForceY += repulsionForceY;
                }
            };
            FDLayout.prototype.calcGravitationalForce = function(node) {
                var ownerGraph;
                var ownerCenterX;
                var ownerCenterY;
                var distanceX;
                var distanceY;
                var absDistanceX;
                var absDistanceY;
                var estimatedSize;
                ownerGraph = node.getOwner();
                ownerCenterX = (ownerGraph.getRight() + ownerGraph.getLeft()) / 2;
                ownerCenterY = (ownerGraph.getTop() + ownerGraph.getBottom()) / 2;
                distanceX = node.getCenterX() - ownerCenterX;
                distanceY = node.getCenterY() - ownerCenterY;
                absDistanceX = Math.abs(distanceX) + node.getWidth() / 2;
                absDistanceY = Math.abs(distanceY) + node.getHeight() / 2;
                if (node.getOwner() == this.graphManager.getRoot()) {
                    estimatedSize = ownerGraph.getEstimatedSize() * this.gravityRangeFactor;
                    if (absDistanceX > estimatedSize || absDistanceY > estimatedSize) {
                        node.gravitationForceX = -this.gravityConstant * distanceX;
                        node.gravitationForceY = -this.gravityConstant * distanceY;
                    }
                } else {
                    estimatedSize = ownerGraph.getEstimatedSize() * this.compoundGravityRangeFactor;
                    if (absDistanceX > estimatedSize || absDistanceY > estimatedSize) {
                        node.gravitationForceX = -this.gravityConstant * distanceX * this.compoundGravityConstant;
                        node.gravitationForceY = -this.gravityConstant * distanceY * this.compoundGravityConstant;
                    }
                }
            };
            FDLayout.prototype.isConverged = function() {
                var converged;
                var oscilating = false;
                if (this.totalIterations > this.maxIterations / 3) oscilating = Math.abs(this.totalDisplacement - this.oldTotalDisplacement) < 2;
                converged = this.totalDisplacement < this.totalDisplacementThreshold;
                this.oldTotalDisplacement = this.totalDisplacement;
                return converged || oscilating;
            };
            FDLayout.prototype.animate = function() {
                if (this.animationDuringLayout && !this.isSubLayout) {
                    if (this.notAnimatedIterations == this.animationPeriod) {
                        this.update();
                        this.notAnimatedIterations = 0;
                    } else this.notAnimatedIterations++;
                }
            };
            //This method calculates the number of children (weight) for all nodes
            FDLayout.prototype.calcNoOfChildrenForAllNodes = function() {
                var node;
                var allNodes = this.graphManager.getAllNodes();
                for(var i = 0; i < allNodes.length; i++){
                    node = allNodes[i];
                    node.noOfChildren = node.getNoOfChildren();
                }
            };
            // -----------------------------------------------------------------------------
            // Section: FR-Grid Variant Repulsion Force Calculation
            // -----------------------------------------------------------------------------
            FDLayout.prototype.calcGrid = function(graph) {
                var sizeX = 0;
                var sizeY = 0;
                sizeX = parseInt(Math.ceil((graph.getRight() - graph.getLeft()) / this.repulsionRange));
                sizeY = parseInt(Math.ceil((graph.getBottom() - graph.getTop()) / this.repulsionRange));
                var grid = new Array(sizeX);
                for(var i = 0; i < sizeX; i++)grid[i] = new Array(sizeY);
                for(var i = 0; i < sizeX; i++)for(var j = 0; j < sizeY; j++)grid[i][j] = new Array();
                return grid;
            };
            FDLayout.prototype.addNodeToGrid = function(v, left, top) {
                var startX = 0;
                var finishX = 0;
                var startY = 0;
                var finishY = 0;
                startX = parseInt(Math.floor((v.getRect().x - left) / this.repulsionRange));
                finishX = parseInt(Math.floor((v.getRect().width + v.getRect().x - left) / this.repulsionRange));
                startY = parseInt(Math.floor((v.getRect().y - top) / this.repulsionRange));
                finishY = parseInt(Math.floor((v.getRect().height + v.getRect().y - top) / this.repulsionRange));
                for(var i = startX; i <= finishX; i++)for(var j = startY; j <= finishY; j++){
                    this.grid[i][j].push(v);
                    v.setGridCoordinates(startX, finishX, startY, finishY);
                }
            };
            FDLayout.prototype.updateGrid = function() {
                var i;
                var nodeA;
                var lNodes = this.getAllNodes();
                this.grid = this.calcGrid(this.graphManager.getRoot());
                // put all nodes to proper grid cells
                for(i = 0; i < lNodes.length; i++){
                    nodeA = lNodes[i];
                    this.addNodeToGrid(nodeA, this.graphManager.getRoot().getLeft(), this.graphManager.getRoot().getTop());
                }
            };
            FDLayout.prototype.calculateRepulsionForceOfANode = function(nodeA, processedNodeSet, gridUpdateAllowed, forceToNodeSurroundingUpdate) {
                if (this.totalIterations % FDLayoutConstants.GRID_CALCULATION_CHECK_PERIOD == 1 && gridUpdateAllowed || forceToNodeSurroundingUpdate) {
                    var surrounding = new Set();
                    nodeA.surrounding = new Array();
                    var nodeB;
                    var grid = this.grid;
                    for(var i = nodeA.startX - 1; i < nodeA.finishX + 2; i++)for(var j = nodeA.startY - 1; j < nodeA.finishY + 2; j++){
                        if (!(i < 0 || j < 0 || i >= grid.length || j >= grid[0].length)) for(var k = 0; k < grid[i][j].length; k++){
                            nodeB = grid[i][j][k];
                            // If both nodes are not members of the same graph, 
                            // or both nodes are the same, skip.
                            if (nodeA.getOwner() != nodeB.getOwner() || nodeA == nodeB) continue;
                            // check if the repulsion force between
                            // nodeA and nodeB has already been calculated
                            if (!processedNodeSet.has(nodeB) && !surrounding.has(nodeB)) {
                                var distanceX = Math.abs(nodeA.getCenterX() - nodeB.getCenterX()) - (nodeA.getWidth() / 2 + nodeB.getWidth() / 2);
                                var distanceY = Math.abs(nodeA.getCenterY() - nodeB.getCenterY()) - (nodeA.getHeight() / 2 + nodeB.getHeight() / 2);
                                // if the distance between nodeA and nodeB 
                                // is less then calculation range
                                if (distanceX <= this.repulsionRange && distanceY <= this.repulsionRange) //then add nodeB to surrounding of nodeA
                                surrounding.add(nodeB);
                            }
                        }
                    }
                    nodeA.surrounding = [].concat(_toConsumableArray(surrounding));
                }
                for(i = 0; i < nodeA.surrounding.length; i++)this.calcRepulsionForce(nodeA, nodeA.surrounding[i]);
            };
            FDLayout.prototype.calcRepulsionRange = function() {
                return 0.0;
            };
            module1.exports = FDLayout;
        /***/ },
        /* 19 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LEdge = __webpack_require__(1);
            var FDLayoutConstants = __webpack_require__(7);
            function FDLayoutEdge(source, target, vEdge) {
                LEdge.call(this, source, target, vEdge);
                this.idealLength = FDLayoutConstants.DEFAULT_EDGE_LENGTH;
            }
            FDLayoutEdge.prototype = Object.create(LEdge.prototype);
            for(var prop in LEdge)FDLayoutEdge[prop] = LEdge[prop];
            module1.exports = FDLayoutEdge;
        /***/ },
        /* 20 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LNode = __webpack_require__(3);
            function FDLayoutNode(gm, loc, size, vNode) {
                // alternative constructor is handled inside LNode
                LNode.call(this, gm, loc, size, vNode);
                //Spring, repulsion and gravitational forces acting on this node
                this.springForceX = 0;
                this.springForceY = 0;
                this.repulsionForceX = 0;
                this.repulsionForceY = 0;
                this.gravitationForceX = 0;
                this.gravitationForceY = 0;
                //Amount by which this node is to be moved in this iteration
                this.displacementX = 0;
                this.displacementY = 0;
                //Start and finish grid coordinates that this node is fallen into
                this.startX = 0;
                this.finishX = 0;
                this.startY = 0;
                this.finishY = 0;
                //Geometric neighbors of this node
                this.surrounding = [];
            }
            FDLayoutNode.prototype = Object.create(LNode.prototype);
            for(var prop in LNode)FDLayoutNode[prop] = LNode[prop];
            FDLayoutNode.prototype.setGridCoordinates = function(_startX, _finishX, _startY, _finishY) {
                this.startX = _startX;
                this.finishX = _finishX;
                this.startY = _startY;
                this.finishY = _finishY;
            };
            module1.exports = FDLayoutNode;
        /***/ },
        /* 21 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function DimensionD1(width, height) {
                this.width = 0;
                this.height = 0;
                if (width !== null && height !== null) {
                    this.height = height;
                    this.width = width;
                }
            }
            DimensionD1.prototype.getWidth = function() {
                return this.width;
            };
            DimensionD1.prototype.setWidth = function(width) {
                this.width = width;
            };
            DimensionD1.prototype.getHeight = function() {
                return this.height;
            };
            DimensionD1.prototype.setHeight = function(height) {
                this.height = height;
            };
            module1.exports = DimensionD1;
        /***/ },
        /* 22 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var UniqueIDGeneretor = __webpack_require__(14);
            function HashMap() {
                this.map = {};
                this.keys = [];
            }
            HashMap.prototype.put = function(key, value) {
                var theId = UniqueIDGeneretor.createID(key);
                if (!this.contains(theId)) {
                    this.map[theId] = value;
                    this.keys.push(key);
                }
            };
            HashMap.prototype.contains = function(key) {
                var theId = UniqueIDGeneretor.createID(key);
                return this.map[key] != null;
            };
            HashMap.prototype.get = function(key) {
                var theId = UniqueIDGeneretor.createID(key);
                return this.map[theId];
            };
            HashMap.prototype.keySet = function() {
                return this.keys;
            };
            module1.exports = HashMap;
        /***/ },
        /* 23 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var UniqueIDGeneretor = __webpack_require__(14);
            function HashSet() {
                this.set = {};
            }
            HashSet.prototype.add = function(obj) {
                var theId = UniqueIDGeneretor.createID(obj);
                if (!this.contains(theId)) this.set[theId] = obj;
            };
            HashSet.prototype.remove = function(obj) {
                delete this.set[UniqueIDGeneretor.createID(obj)];
            };
            HashSet.prototype.clear = function() {
                this.set = {};
            };
            HashSet.prototype.contains = function(obj) {
                return this.set[UniqueIDGeneretor.createID(obj)] == obj;
            };
            HashSet.prototype.isEmpty = function() {
                return this.size() === 0;
            };
            HashSet.prototype.size = function() {
                return Object.keys(this.set).length;
            };
            //concats this.set to the given list
            HashSet.prototype.addAllTo = function(list) {
                var keys = Object.keys(this.set);
                var length = keys.length;
                for(var i = 0; i < length; i++)list.push(this.set[keys[i]]);
            };
            HashSet.prototype.size = function() {
                return Object.keys(this.set).length;
            };
            HashSet.prototype.addAll = function(list) {
                var s = list.length;
                for(var i = 0; i < s; i++){
                    var v = list[i];
                    this.add(v);
                }
            };
            module1.exports = HashSet;
        /***/ },
        /* 24 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /**
 * A classic Quicksort algorithm with Hoare's partition
 * - Works also on LinkedList objects
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ var LinkedList = __webpack_require__(11);
            var Quicksort = function() {
                function Quicksort(A, compareFunction) {
                    _classCallCheck(this, Quicksort);
                    if (compareFunction !== null || compareFunction !== undefined) this.compareFunction = this._defaultCompareFunction;
                    var length = void 0;
                    if (A instanceof LinkedList) length = A.size();
                    else length = A.length;
                    this._quicksort(A, 0, length - 1);
                }
                _createClass(Quicksort, [
                    {
                        key: '_quicksort',
                        value: function _quicksort(A, p, r) {
                            if (p < r) {
                                var q = this._partition(A, p, r);
                                this._quicksort(A, p, q);
                                this._quicksort(A, q + 1, r);
                            }
                        }
                    },
                    {
                        key: '_partition',
                        value: function _partition(A, p, r) {
                            var x = this._get(A, p);
                            var i = p;
                            var j = r;
                            while(true){
                                while(this.compareFunction(x, this._get(A, j)))j--;
                                while(this.compareFunction(this._get(A, i), x))i++;
                                if (i < j) {
                                    this._swap(A, i, j);
                                    i++;
                                    j--;
                                } else return j;
                            }
                        }
                    },
                    {
                        key: '_get',
                        value: function _get(object, index) {
                            if (object instanceof LinkedList) return object.get_object_at(index);
                            else return object[index];
                        }
                    },
                    {
                        key: '_set',
                        value: function _set(object, index, value) {
                            if (object instanceof LinkedList) object.set_object_at(index, value);
                            else object[index] = value;
                        }
                    },
                    {
                        key: '_swap',
                        value: function _swap(A, i, j) {
                            var temp = this._get(A, i);
                            this._set(A, i, this._get(A, j));
                            this._set(A, j, temp);
                        }
                    },
                    {
                        key: '_defaultCompareFunction',
                        value: function _defaultCompareFunction(a, b) {
                            return b > a;
                        }
                    }
                ]);
                return Quicksort;
            }();
            module1.exports = Quicksort;
        /***/ },
        /* 25 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /**
 *   Needleman-Wunsch algorithm is an procedure to compute the optimal global alignment of two string
 *   sequences by S.B.Needleman and C.D.Wunsch (1970).
 *
 *   Aside from the inputs, you can assign the scores for,
 *   - Match: The two characters at the current index are same.
 *   - Mismatch: The two characters at the current index are different.
 *   - Insertion/Deletion(gaps): The best alignment involves one letter aligning to a gap in the other string.
 */ var NeedlemanWunsch = function() {
                function NeedlemanWunsch(sequence1, sequence2) {
                    var match_score = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var mismatch_penalty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
                    var gap_penalty = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
                    _classCallCheck(this, NeedlemanWunsch);
                    this.sequence1 = sequence1;
                    this.sequence2 = sequence2;
                    this.match_score = match_score;
                    this.mismatch_penalty = mismatch_penalty;
                    this.gap_penalty = gap_penalty;
                    // Just the remove redundancy
                    this.iMax = sequence1.length + 1;
                    this.jMax = sequence2.length + 1;
                    // Grid matrix of scores
                    this.grid = new Array(this.iMax);
                    for(var i = 0; i < this.iMax; i++){
                        this.grid[i] = new Array(this.jMax);
                        for(var j = 0; j < this.jMax; j++)this.grid[i][j] = 0;
                    }
                    // Traceback matrix (2D array, each cell is an array of boolean values for [`Diag`, `Up`, `Left`] positions)
                    this.tracebackGrid = new Array(this.iMax);
                    for(var _i = 0; _i < this.iMax; _i++){
                        this.tracebackGrid[_i] = new Array(this.jMax);
                        for(var _j = 0; _j < this.jMax; _j++)this.tracebackGrid[_i][_j] = [
                            null,
                            null,
                            null
                        ];
                    }
                    // The aligned sequences (return multiple possibilities)
                    this.alignments = [];
                    // Final alignment score
                    this.score = -1;
                    // Calculate scores and tracebacks
                    this.computeGrids();
                }
                _createClass(NeedlemanWunsch, [
                    {
                        key: "getScore",
                        value: function getScore() {
                            return this.score;
                        }
                    },
                    {
                        key: "getAlignments",
                        value: function getAlignments() {
                            return this.alignments;
                        }
                    },
                    {
                        key: "computeGrids",
                        value: function computeGrids() {
                            // Fill in the first row
                            for(var j = 1; j < this.jMax; j++){
                                this.grid[0][j] = this.grid[0][j - 1] + this.gap_penalty;
                                this.tracebackGrid[0][j] = [
                                    false,
                                    false,
                                    true
                                ];
                            }
                            // Fill in the first column
                            for(var i = 1; i < this.iMax; i++){
                                this.grid[i][0] = this.grid[i - 1][0] + this.gap_penalty;
                                this.tracebackGrid[i][0] = [
                                    false,
                                    true,
                                    false
                                ];
                            }
                            // Fill the rest of the grid
                            for(var _i2 = 1; _i2 < this.iMax; _i2++)for(var _j2 = 1; _j2 < this.jMax; _j2++){
                                // Find the max score(s) among [`Diag`, `Up`, `Left`]
                                var diag = void 0;
                                if (this.sequence1[_i2 - 1] === this.sequence2[_j2 - 1]) diag = this.grid[_i2 - 1][_j2 - 1] + this.match_score;
                                else diag = this.grid[_i2 - 1][_j2 - 1] + this.mismatch_penalty;
                                var up = this.grid[_i2 - 1][_j2] + this.gap_penalty;
                                var left = this.grid[_i2][_j2 - 1] + this.gap_penalty;
                                // If there exists multiple max values, capture them for multiple paths
                                var maxOf = [
                                    diag,
                                    up,
                                    left
                                ];
                                var indices = this.arrayAllMaxIndexes(maxOf);
                                // Update Grids
                                this.grid[_i2][_j2] = maxOf[indices[0]];
                                this.tracebackGrid[_i2][_j2] = [
                                    indices.includes(0),
                                    indices.includes(1),
                                    indices.includes(2)
                                ];
                            }
                            // Update alignment score
                            this.score = this.grid[this.iMax - 1][this.jMax - 1];
                        }
                    },
                    {
                        key: "alignmentTraceback",
                        value: function alignmentTraceback() {
                            var inProcessAlignments = [];
                            inProcessAlignments.push({
                                pos: [
                                    this.sequence1.length,
                                    this.sequence2.length
                                ],
                                seq1: "",
                                seq2: ""
                            });
                            while(inProcessAlignments[0]){
                                var current = inProcessAlignments[0];
                                var directions = this.tracebackGrid[current.pos[0]][current.pos[1]];
                                if (directions[0]) inProcessAlignments.push({
                                    pos: [
                                        current.pos[0] - 1,
                                        current.pos[1] - 1
                                    ],
                                    seq1: this.sequence1[current.pos[0] - 1] + current.seq1,
                                    seq2: this.sequence2[current.pos[1] - 1] + current.seq2
                                });
                                if (directions[1]) inProcessAlignments.push({
                                    pos: [
                                        current.pos[0] - 1,
                                        current.pos[1]
                                    ],
                                    seq1: this.sequence1[current.pos[0] - 1] + current.seq1,
                                    seq2: '-' + current.seq2
                                });
                                if (directions[2]) inProcessAlignments.push({
                                    pos: [
                                        current.pos[0],
                                        current.pos[1] - 1
                                    ],
                                    seq1: '-' + current.seq1,
                                    seq2: this.sequence2[current.pos[1] - 1] + current.seq2
                                });
                                if (current.pos[0] === 0 && current.pos[1] === 0) this.alignments.push({
                                    sequence1: current.seq1,
                                    sequence2: current.seq2
                                });
                                inProcessAlignments.shift();
                            }
                            return this.alignments;
                        }
                    },
                    {
                        key: "getAllIndexes",
                        value: function getAllIndexes(arr, val) {
                            var indexes = [], i = -1;
                            while((i = arr.indexOf(val, i + 1)) !== -1)indexes.push(i);
                            return indexes;
                        }
                    },
                    {
                        key: "arrayAllMaxIndexes",
                        value: function arrayAllMaxIndexes(array) {
                            return this.getAllIndexes(array, Math.max.apply(null, array));
                        }
                    }
                ]);
                return NeedlemanWunsch;
            }();
            module1.exports = NeedlemanWunsch;
        /***/ },
        /* 26 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var layoutBase = function layoutBase() {
                return;
            };
            layoutBase.FDLayout = __webpack_require__(18);
            layoutBase.FDLayoutConstants = __webpack_require__(7);
            layoutBase.FDLayoutEdge = __webpack_require__(19);
            layoutBase.FDLayoutNode = __webpack_require__(20);
            layoutBase.DimensionD = __webpack_require__(21);
            layoutBase.HashMap = __webpack_require__(22);
            layoutBase.HashSet = __webpack_require__(23);
            layoutBase.IGeometry = __webpack_require__(8);
            layoutBase.IMath = __webpack_require__(9);
            layoutBase.Integer = __webpack_require__(10);
            layoutBase.Point = __webpack_require__(12);
            layoutBase.PointD = __webpack_require__(4);
            layoutBase.RandomSeed = __webpack_require__(16);
            layoutBase.RectangleD = __webpack_require__(13);
            layoutBase.Transform = __webpack_require__(17);
            layoutBase.UniqueIDGeneretor = __webpack_require__(14);
            layoutBase.Quicksort = __webpack_require__(24);
            layoutBase.LinkedList = __webpack_require__(11);
            layoutBase.LGraphObject = __webpack_require__(2);
            layoutBase.LGraph = __webpack_require__(5);
            layoutBase.LEdge = __webpack_require__(1);
            layoutBase.LGraphManager = __webpack_require__(6);
            layoutBase.LNode = __webpack_require__(3);
            layoutBase.Layout = __webpack_require__(15);
            layoutBase.LayoutConstants = __webpack_require__(0);
            layoutBase.NeedlemanWunsch = __webpack_require__(25);
            module1.exports = layoutBase;
        /***/ },
        /* 27 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function Emitter() {
                this.listeners = [];
            }
            var p = Emitter.prototype;
            p.addListener = function(event, callback) {
                this.listeners.push({
                    event: event,
                    callback: callback
                });
            };
            p.removeListener = function(event, callback) {
                for(var i = this.listeners.length; i >= 0; i--){
                    var l = this.listeners[i];
                    if (l.event === event && l.callback === callback) this.listeners.splice(i, 1);
                }
            };
            p.emit = function(event, data) {
                for(var i = 0; i < this.listeners.length; i++){
                    var l = this.listeners[i];
                    if (event === l.event) l.callback(data);
                }
            };
            module1.exports = Emitter;
        /***/ }
    ]);
});

});


parcelRegister("54IE7", function(module, exports) {

(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory((parcelRequire("awvmd")));
})(module.exports, function(__WEBPACK_EXTERNAL_MODULE_0__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 7);
    /******/ }([
        /* 0 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_0__;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var FDLayoutConstants = __webpack_require__(0).FDLayoutConstants;
            function CoSEConstants() {}
            //CoSEConstants inherits static props in FDLayoutConstants
            for(var prop in FDLayoutConstants)CoSEConstants[prop] = FDLayoutConstants[prop];
            CoSEConstants.DEFAULT_USE_MULTI_LEVEL_SCALING = false;
            CoSEConstants.DEFAULT_RADIAL_SEPARATION = FDLayoutConstants.DEFAULT_EDGE_LENGTH;
            CoSEConstants.DEFAULT_COMPONENT_SEPERATION = 60;
            CoSEConstants.TILE = true;
            CoSEConstants.TILING_PADDING_VERTICAL = 10;
            CoSEConstants.TILING_PADDING_HORIZONTAL = 10;
            CoSEConstants.TREE_REDUCTION_ON_INCREMENTAL = false; // make this true when cose is used incrementally as a part of other non-incremental layout
            module1.exports = CoSEConstants;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var FDLayoutEdge = __webpack_require__(0).FDLayoutEdge;
            function CoSEEdge(source, target, vEdge) {
                FDLayoutEdge.call(this, source, target, vEdge);
            }
            CoSEEdge.prototype = Object.create(FDLayoutEdge.prototype);
            for(var prop in FDLayoutEdge)CoSEEdge[prop] = FDLayoutEdge[prop];
            module1.exports = CoSEEdge;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LGraph = __webpack_require__(0).LGraph;
            function CoSEGraph(parent, graphMgr, vGraph) {
                LGraph.call(this, parent, graphMgr, vGraph);
            }
            CoSEGraph.prototype = Object.create(LGraph.prototype);
            for(var prop in LGraph)CoSEGraph[prop] = LGraph[prop];
            module1.exports = CoSEGraph;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LGraphManager = __webpack_require__(0).LGraphManager;
            function CoSEGraphManager(layout) {
                LGraphManager.call(this, layout);
            }
            CoSEGraphManager.prototype = Object.create(LGraphManager.prototype);
            for(var prop in LGraphManager)CoSEGraphManager[prop] = LGraphManager[prop];
            module1.exports = CoSEGraphManager;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var FDLayoutNode = __webpack_require__(0).FDLayoutNode;
            var IMath = __webpack_require__(0).IMath;
            function CoSENode(gm, loc, size, vNode) {
                FDLayoutNode.call(this, gm, loc, size, vNode);
            }
            CoSENode.prototype = Object.create(FDLayoutNode.prototype);
            for(var prop in FDLayoutNode)CoSENode[prop] = FDLayoutNode[prop];
            CoSENode.prototype.move = function() {
                var layout = this.graphManager.getLayout();
                this.displacementX = layout.coolingFactor * (this.springForceX + this.repulsionForceX + this.gravitationForceX) / this.noOfChildren;
                this.displacementY = layout.coolingFactor * (this.springForceY + this.repulsionForceY + this.gravitationForceY) / this.noOfChildren;
                if (Math.abs(this.displacementX) > layout.coolingFactor * layout.maxNodeDisplacement) this.displacementX = layout.coolingFactor * layout.maxNodeDisplacement * IMath.sign(this.displacementX);
                if (Math.abs(this.displacementY) > layout.coolingFactor * layout.maxNodeDisplacement) this.displacementY = layout.coolingFactor * layout.maxNodeDisplacement * IMath.sign(this.displacementY);
                // a simple node, just move it
                if (this.child == null) this.moveBy(this.displacementX, this.displacementY);
                else if (this.child.getNodes().length == 0) this.moveBy(this.displacementX, this.displacementY);
                else this.propogateDisplacementToChildren(this.displacementX, this.displacementY);
                layout.totalDisplacement += Math.abs(this.displacementX) + Math.abs(this.displacementY);
                this.springForceX = 0;
                this.springForceY = 0;
                this.repulsionForceX = 0;
                this.repulsionForceY = 0;
                this.gravitationForceX = 0;
                this.gravitationForceY = 0;
                this.displacementX = 0;
                this.displacementY = 0;
            };
            CoSENode.prototype.propogateDisplacementToChildren = function(dX, dY) {
                var nodes = this.getChild().getNodes();
                var node;
                for(var i = 0; i < nodes.length; i++){
                    node = nodes[i];
                    if (node.getChild() == null) {
                        node.moveBy(dX, dY);
                        node.displacementX += dX;
                        node.displacementY += dY;
                    } else node.propogateDisplacementToChildren(dX, dY);
                }
            };
            CoSENode.prototype.setPred1 = function(pred11) {
                this.pred1 = pred11;
            };
            CoSENode.prototype.getPred1 = function() {
                return pred1;
            };
            CoSENode.prototype.getPred2 = function() {
                return pred2;
            };
            CoSENode.prototype.setNext = function(next1) {
                this.next = next1;
            };
            CoSENode.prototype.getNext = function() {
                return next;
            };
            CoSENode.prototype.setProcessed = function(processed1) {
                this.processed = processed1;
            };
            CoSENode.prototype.isProcessed = function() {
                return processed;
            };
            module1.exports = CoSENode;
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var FDLayout = __webpack_require__(0).FDLayout;
            var CoSEGraphManager = __webpack_require__(4);
            var CoSEGraph = __webpack_require__(3);
            var CoSENode = __webpack_require__(5);
            var CoSEEdge = __webpack_require__(2);
            var CoSEConstants = __webpack_require__(1);
            var FDLayoutConstants = __webpack_require__(0).FDLayoutConstants;
            var LayoutConstants = __webpack_require__(0).LayoutConstants;
            var Point = __webpack_require__(0).Point;
            var PointD = __webpack_require__(0).PointD;
            var Layout = __webpack_require__(0).Layout;
            var Integer = __webpack_require__(0).Integer;
            var IGeometry = __webpack_require__(0).IGeometry;
            var LGraph = __webpack_require__(0).LGraph;
            var Transform = __webpack_require__(0).Transform;
            function CoSELayout() {
                FDLayout.call(this);
                this.toBeTiled = {}; // Memorize if a node is to be tiled or is tiled
            }
            CoSELayout.prototype = Object.create(FDLayout.prototype);
            for(var prop in FDLayout)CoSELayout[prop] = FDLayout[prop];
            CoSELayout.prototype.newGraphManager = function() {
                var gm = new CoSEGraphManager(this);
                this.graphManager = gm;
                return gm;
            };
            CoSELayout.prototype.newGraph = function(vGraph) {
                return new CoSEGraph(null, this.graphManager, vGraph);
            };
            CoSELayout.prototype.newNode = function(vNode) {
                return new CoSENode(this.graphManager, vNode);
            };
            CoSELayout.prototype.newEdge = function(vEdge) {
                return new CoSEEdge(null, null, vEdge);
            };
            CoSELayout.prototype.initParameters = function() {
                FDLayout.prototype.initParameters.call(this, arguments);
                if (!this.isSubLayout) {
                    if (CoSEConstants.DEFAULT_EDGE_LENGTH < 10) this.idealEdgeLength = 10;
                    else this.idealEdgeLength = CoSEConstants.DEFAULT_EDGE_LENGTH;
                    this.useSmartIdealEdgeLengthCalculation = CoSEConstants.DEFAULT_USE_SMART_IDEAL_EDGE_LENGTH_CALCULATION;
                    this.springConstant = FDLayoutConstants.DEFAULT_SPRING_STRENGTH;
                    this.repulsionConstant = FDLayoutConstants.DEFAULT_REPULSION_STRENGTH;
                    this.gravityConstant = FDLayoutConstants.DEFAULT_GRAVITY_STRENGTH;
                    this.compoundGravityConstant = FDLayoutConstants.DEFAULT_COMPOUND_GRAVITY_STRENGTH;
                    this.gravityRangeFactor = FDLayoutConstants.DEFAULT_GRAVITY_RANGE_FACTOR;
                    this.compoundGravityRangeFactor = FDLayoutConstants.DEFAULT_COMPOUND_GRAVITY_RANGE_FACTOR;
                    // variables for tree reduction support
                    this.prunedNodesAll = [];
                    this.growTreeIterations = 0;
                    this.afterGrowthIterations = 0;
                    this.isTreeGrowing = false;
                    this.isGrowthFinished = false;
                    // variables for cooling
                    this.coolingCycle = 0;
                    this.maxCoolingCycle = this.maxIterations / FDLayoutConstants.CONVERGENCE_CHECK_PERIOD;
                    this.finalTemperature = FDLayoutConstants.CONVERGENCE_CHECK_PERIOD / this.maxIterations;
                    this.coolingAdjuster = 1;
                }
            };
            CoSELayout.prototype.layout = function() {
                var createBendsAsNeeded = LayoutConstants.DEFAULT_CREATE_BENDS_AS_NEEDED;
                if (createBendsAsNeeded) {
                    this.createBendpoints();
                    this.graphManager.resetAllEdges();
                }
                this.level = 0;
                return this.classicLayout();
            };
            CoSELayout.prototype.classicLayout = function() {
                this.nodesWithGravity = this.calculateNodesToApplyGravitationTo();
                this.graphManager.setAllNodesToApplyGravitation(this.nodesWithGravity);
                this.calcNoOfChildrenForAllNodes();
                this.graphManager.calcLowestCommonAncestors();
                this.graphManager.calcInclusionTreeDepths();
                this.graphManager.getRoot().calcEstimatedSize();
                this.calcIdealEdgeLengths();
                if (!this.incremental) {
                    var forest = this.getFlatForest();
                    // The graph associated with this layout is flat and a forest
                    if (forest.length > 0) this.positionNodesRadially(forest);
                    else {
                        // Reduce the trees when incremental mode is not enabled and graph is not a forest 
                        this.reduceTrees();
                        // Update nodes that gravity will be applied
                        this.graphManager.resetAllNodesToApplyGravitation();
                        var allNodes = new Set(this.getAllNodes());
                        var intersection = this.nodesWithGravity.filter(function(x) {
                            return allNodes.has(x);
                        });
                        this.graphManager.setAllNodesToApplyGravitation(intersection);
                        this.positionNodesRandomly();
                    }
                } else if (CoSEConstants.TREE_REDUCTION_ON_INCREMENTAL) {
                    // Reduce the trees in incremental mode if only this constant is set to true 
                    this.reduceTrees();
                    // Update nodes that gravity will be applied
                    this.graphManager.resetAllNodesToApplyGravitation();
                    var allNodes = new Set(this.getAllNodes());
                    var intersection = this.nodesWithGravity.filter(function(x) {
                        return allNodes.has(x);
                    });
                    this.graphManager.setAllNodesToApplyGravitation(intersection);
                }
                this.initSpringEmbedder();
                this.runSpringEmbedder();
                return true;
            };
            CoSELayout.prototype.tick = function() {
                this.totalIterations++;
                if (this.totalIterations === this.maxIterations && !this.isTreeGrowing && !this.isGrowthFinished) {
                    if (this.prunedNodesAll.length > 0) this.isTreeGrowing = true;
                    else return true;
                }
                if (this.totalIterations % FDLayoutConstants.CONVERGENCE_CHECK_PERIOD == 0 && !this.isTreeGrowing && !this.isGrowthFinished) {
                    if (this.isConverged()) {
                        if (this.prunedNodesAll.length > 0) this.isTreeGrowing = true;
                        else return true;
                    }
                    this.coolingCycle++;
                    if (this.layoutQuality == 0) // quality - "draft"
                    this.coolingAdjuster = this.coolingCycle;
                    else if (this.layoutQuality == 1) // quality - "default"
                    this.coolingAdjuster = this.coolingCycle / 3;
                    // cooling schedule is based on http://www.btluke.com/simanf1.html -> cooling schedule 3
                    this.coolingFactor = Math.max(this.initialCoolingFactor - Math.pow(this.coolingCycle, Math.log(100 * (this.initialCoolingFactor - this.finalTemperature)) / Math.log(this.maxCoolingCycle)) / 100 * this.coolingAdjuster, this.finalTemperature);
                    this.animationPeriod = Math.ceil(this.initialAnimationPeriod * Math.sqrt(this.coolingFactor));
                }
                // Operations while tree is growing again 
                if (this.isTreeGrowing) {
                    if (this.growTreeIterations % 10 == 0) {
                        if (this.prunedNodesAll.length > 0) {
                            this.graphManager.updateBounds();
                            this.updateGrid();
                            this.growTree(this.prunedNodesAll);
                            // Update nodes that gravity will be applied
                            this.graphManager.resetAllNodesToApplyGravitation();
                            var allNodes = new Set(this.getAllNodes());
                            var intersection = this.nodesWithGravity.filter(function(x) {
                                return allNodes.has(x);
                            });
                            this.graphManager.setAllNodesToApplyGravitation(intersection);
                            this.graphManager.updateBounds();
                            this.updateGrid();
                            this.coolingFactor = FDLayoutConstants.DEFAULT_COOLING_FACTOR_INCREMENTAL;
                        } else {
                            this.isTreeGrowing = false;
                            this.isGrowthFinished = true;
                        }
                    }
                    this.growTreeIterations++;
                }
                // Operations after growth is finished
                if (this.isGrowthFinished) {
                    if (this.isConverged()) return true;
                    if (this.afterGrowthIterations % 10 == 0) {
                        this.graphManager.updateBounds();
                        this.updateGrid();
                    }
                    this.coolingFactor = FDLayoutConstants.DEFAULT_COOLING_FACTOR_INCREMENTAL * ((100 - this.afterGrowthIterations) / 100);
                    this.afterGrowthIterations++;
                }
                var gridUpdateAllowed = !this.isTreeGrowing && !this.isGrowthFinished;
                var forceToNodeSurroundingUpdate = this.growTreeIterations % 10 == 1 && this.isTreeGrowing || this.afterGrowthIterations % 10 == 1 && this.isGrowthFinished;
                this.totalDisplacement = 0;
                this.graphManager.updateBounds();
                this.calcSpringForces();
                this.calcRepulsionForces(gridUpdateAllowed, forceToNodeSurroundingUpdate);
                this.calcGravitationalForces();
                this.moveNodes();
                this.animate();
                return false; // Layout is not ended yet return false
            };
            CoSELayout.prototype.getPositionsData = function() {
                var allNodes = this.graphManager.getAllNodes();
                var pData = {};
                for(var i = 0; i < allNodes.length; i++){
                    var rect = allNodes[i].rect;
                    var id = allNodes[i].id;
                    pData[id] = {
                        id: id,
                        x: rect.getCenterX(),
                        y: rect.getCenterY(),
                        w: rect.width,
                        h: rect.height
                    };
                }
                return pData;
            };
            CoSELayout.prototype.runSpringEmbedder = function() {
                this.initialAnimationPeriod = 25;
                this.animationPeriod = this.initialAnimationPeriod;
                var layoutEnded = false;
                // If aminate option is 'during' signal that layout is supposed to start iterating
                if (FDLayoutConstants.ANIMATE === 'during') this.emit('layoutstarted');
                else {
                    // If aminate option is 'during' tick() function will be called on index.js
                    while(!layoutEnded)layoutEnded = this.tick();
                    this.graphManager.updateBounds();
                }
            };
            CoSELayout.prototype.calculateNodesToApplyGravitationTo = function() {
                var nodeList = [];
                var graph;
                var graphs = this.graphManager.getGraphs();
                var size = graphs.length;
                var i;
                for(i = 0; i < size; i++){
                    graph = graphs[i];
                    graph.updateConnected();
                    if (!graph.isConnected) nodeList = nodeList.concat(graph.getNodes());
                }
                return nodeList;
            };
            CoSELayout.prototype.createBendpoints = function() {
                var edges = [];
                edges = edges.concat(this.graphManager.getAllEdges());
                var visited = new Set();
                var i;
                for(i = 0; i < edges.length; i++){
                    var edge = edges[i];
                    if (!visited.has(edge)) {
                        var source = edge.getSource();
                        var target = edge.getTarget();
                        if (source == target) {
                            edge.getBendpoints().push(new PointD());
                            edge.getBendpoints().push(new PointD());
                            this.createDummyNodesForBendpoints(edge);
                            visited.add(edge);
                        } else {
                            var edgeList = [];
                            edgeList = edgeList.concat(source.getEdgeListToNode(target));
                            edgeList = edgeList.concat(target.getEdgeListToNode(source));
                            if (!visited.has(edgeList[0])) {
                                if (edgeList.length > 1) {
                                    var k;
                                    for(k = 0; k < edgeList.length; k++){
                                        var multiEdge = edgeList[k];
                                        multiEdge.getBendpoints().push(new PointD());
                                        this.createDummyNodesForBendpoints(multiEdge);
                                    }
                                }
                                edgeList.forEach(function(edge) {
                                    visited.add(edge);
                                });
                            }
                        }
                    }
                    if (visited.size == edges.length) break;
                }
            };
            CoSELayout.prototype.positionNodesRadially = function(forest) {
                // We tile the trees to a grid row by row; first tree starts at (0,0)
                var currentStartingPoint = new Point(0, 0);
                var numberOfColumns = Math.ceil(Math.sqrt(forest.length));
                var height = 0;
                var currentY = 0;
                var currentX = 0;
                var point = new PointD(0, 0);
                for(var i = 0; i < forest.length; i++){
                    if (i % numberOfColumns == 0) {
                        // Start of a new row, make the x coordinate 0, increment the
                        // y coordinate with the max height of the previous row
                        currentX = 0;
                        currentY = height;
                        if (i != 0) currentY += CoSEConstants.DEFAULT_COMPONENT_SEPERATION;
                        height = 0;
                    }
                    var tree = forest[i];
                    // Find the center of the tree
                    var centerNode = Layout.findCenterOfTree(tree);
                    // Set the staring point of the next tree
                    currentStartingPoint.x = currentX;
                    currentStartingPoint.y = currentY;
                    // Do a radial layout starting with the center
                    point = CoSELayout.radialLayout(tree, centerNode, currentStartingPoint);
                    if (point.y > height) height = Math.floor(point.y);
                    currentX = Math.floor(point.x + CoSEConstants.DEFAULT_COMPONENT_SEPERATION);
                }
                this.transform(new PointD(LayoutConstants.WORLD_CENTER_X - point.x / 2, LayoutConstants.WORLD_CENTER_Y - point.y / 2));
            };
            CoSELayout.radialLayout = function(tree, centerNode, startingPoint) {
                var radialSep = Math.max(this.maxDiagonalInTree(tree), CoSEConstants.DEFAULT_RADIAL_SEPARATION);
                CoSELayout.branchRadialLayout(centerNode, null, 0, 359, 0, radialSep);
                var bounds = LGraph.calculateBounds(tree);
                var transform = new Transform();
                transform.setDeviceOrgX(bounds.getMinX());
                transform.setDeviceOrgY(bounds.getMinY());
                transform.setWorldOrgX(startingPoint.x);
                transform.setWorldOrgY(startingPoint.y);
                for(var i = 0; i < tree.length; i++){
                    var node = tree[i];
                    node.transform(transform);
                }
                var bottomRight = new PointD(bounds.getMaxX(), bounds.getMaxY());
                return transform.inverseTransformPoint(bottomRight);
            };
            CoSELayout.branchRadialLayout = function(node, parentOfNode, startAngle, endAngle, distance, radialSeparation) {
                // First, position this node by finding its angle.
                var halfInterval = (endAngle - startAngle + 1) / 2;
                if (halfInterval < 0) halfInterval += 180;
                var nodeAngle = (halfInterval + startAngle) % 360;
                var teta = nodeAngle * IGeometry.TWO_PI / 360;
                // Make polar to java cordinate conversion.
                var cos_teta = Math.cos(teta);
                var x_ = distance * Math.cos(teta);
                var y_ = distance * Math.sin(teta);
                node.setCenter(x_, y_);
                // Traverse all neighbors of this node and recursively call this
                // function.
                var neighborEdges = [];
                neighborEdges = neighborEdges.concat(node.getEdges());
                var childCount = neighborEdges.length;
                if (parentOfNode != null) childCount--;
                var branchCount = 0;
                var incEdgesCount = neighborEdges.length;
                var startIndex;
                var edges = node.getEdgesBetween(parentOfNode);
                // If there are multiple edges, prune them until there remains only one
                // edge.
                while(edges.length > 1){
                    //neighborEdges.remove(edges.remove(0));
                    var temp = edges[0];
                    edges.splice(0, 1);
                    var index = neighborEdges.indexOf(temp);
                    if (index >= 0) neighborEdges.splice(index, 1);
                    incEdgesCount--;
                    childCount--;
                }
                if (parentOfNode != null) //assert edges.length == 1;
                startIndex = (neighborEdges.indexOf(edges[0]) + 1) % incEdgesCount;
                else startIndex = 0;
                var stepAngle = Math.abs(endAngle - startAngle) / childCount;
                for(var i = startIndex; branchCount != childCount; i = ++i % incEdgesCount){
                    var currentNeighbor = neighborEdges[i].getOtherEnd(node);
                    // Don't back traverse to root node in current tree.
                    if (currentNeighbor == parentOfNode) continue;
                    var childStartAngle = (startAngle + branchCount * stepAngle) % 360;
                    var childEndAngle = (childStartAngle + stepAngle) % 360;
                    CoSELayout.branchRadialLayout(currentNeighbor, node, childStartAngle, childEndAngle, distance + radialSeparation, radialSeparation);
                    branchCount++;
                }
            };
            CoSELayout.maxDiagonalInTree = function(tree) {
                var maxDiagonal = Integer.MIN_VALUE;
                for(var i = 0; i < tree.length; i++){
                    var node = tree[i];
                    var diagonal = node.getDiagonal();
                    if (diagonal > maxDiagonal) maxDiagonal = diagonal;
                }
                return maxDiagonal;
            };
            CoSELayout.prototype.calcRepulsionRange = function() {
                // formula is 2 x (level + 1) x idealEdgeLength
                return 2 * (this.level + 1) * this.idealEdgeLength;
            };
            // Tiling methods
            // Group zero degree members whose parents are not to be tiled, create dummy parents where needed and fill memberGroups by their dummp parent id's
            CoSELayout.prototype.groupZeroDegreeMembers = function() {
                var self = this;
                // array of [parent_id x oneDegreeNode_id]
                var tempMemberGroups = {}; // A temporary map of parent node and its zero degree members
                this.memberGroups = {}; // A map of dummy parent node and its zero degree members whose parents are not to be tiled
                this.idToDummyNode = {}; // A map of id to dummy node 
                var zeroDegree = []; // List of zero degree nodes whose parents are not to be tiled
                var allNodes = this.graphManager.getAllNodes();
                // Fill zero degree list
                for(var i = 0; i < allNodes.length; i++){
                    var node = allNodes[i];
                    var parent = node.getParent();
                    // If a node has zero degree and its parent is not to be tiled if exists add that node to zeroDegres list
                    if (this.getNodeDegreeWithChildren(node) === 0 && (parent.id == undefined || !this.getToBeTiled(parent))) zeroDegree.push(node);
                }
                // Create a map of parent node and its zero degree members
                for(var i = 0; i < zeroDegree.length; i++){
                    var node = zeroDegree[i]; // Zero degree node itself
                    var p_id = node.getParent().id; // Parent id
                    if (typeof tempMemberGroups[p_id] === "undefined") tempMemberGroups[p_id] = [];
                    tempMemberGroups[p_id] = tempMemberGroups[p_id].concat(node); // Push node to the list belongs to its parent in tempMemberGroups
                }
                // If there are at least two nodes at a level, create a dummy compound for them
                Object.keys(tempMemberGroups).forEach(function(p_id) {
                    if (tempMemberGroups[p_id].length > 1) {
                        var dummyCompoundId = "DummyCompound_" + p_id; // The id of dummy compound which will be created soon
                        self.memberGroups[dummyCompoundId] = tempMemberGroups[p_id]; // Add dummy compound to memberGroups
                        var parent = tempMemberGroups[p_id][0].getParent(); // The parent of zero degree nodes will be the parent of new dummy compound
                        // Create a dummy compound with calculated id
                        var dummyCompound = new CoSENode(self.graphManager);
                        dummyCompound.id = dummyCompoundId;
                        dummyCompound.paddingLeft = parent.paddingLeft || 0;
                        dummyCompound.paddingRight = parent.paddingRight || 0;
                        dummyCompound.paddingBottom = parent.paddingBottom || 0;
                        dummyCompound.paddingTop = parent.paddingTop || 0;
                        self.idToDummyNode[dummyCompoundId] = dummyCompound;
                        var dummyParentGraph = self.getGraphManager().add(self.newGraph(), dummyCompound);
                        var parentGraph = parent.getChild();
                        // Add dummy compound to parent the graph
                        parentGraph.add(dummyCompound);
                        // For each zero degree node in this level remove it from its parent graph and add it to the graph of dummy parent
                        for(var i = 0; i < tempMemberGroups[p_id].length; i++){
                            var node = tempMemberGroups[p_id][i];
                            parentGraph.remove(node);
                            dummyParentGraph.add(node);
                        }
                    }
                });
            };
            CoSELayout.prototype.clearCompounds = function() {
                var childGraphMap = {};
                var idToNode = {};
                // Get compound ordering by finding the inner one first
                this.performDFSOnCompounds();
                for(var i = 0; i < this.compoundOrder.length; i++){
                    idToNode[this.compoundOrder[i].id] = this.compoundOrder[i];
                    childGraphMap[this.compoundOrder[i].id] = [].concat(this.compoundOrder[i].getChild().getNodes());
                    // Remove children of compounds
                    this.graphManager.remove(this.compoundOrder[i].getChild());
                    this.compoundOrder[i].child = null;
                }
                this.graphManager.resetAllNodes();
                // Tile the removed children
                this.tileCompoundMembers(childGraphMap, idToNode);
            };
            CoSELayout.prototype.clearZeroDegreeMembers = function() {
                var self = this;
                var tiledZeroDegreePack = this.tiledZeroDegreePack = [];
                Object.keys(this.memberGroups).forEach(function(id) {
                    var compoundNode = self.idToDummyNode[id]; // Get the dummy compound
                    tiledZeroDegreePack[id] = self.tileNodes(self.memberGroups[id], compoundNode.paddingLeft + compoundNode.paddingRight);
                    // Set the width and height of the dummy compound as calculated
                    compoundNode.rect.width = tiledZeroDegreePack[id].width;
                    compoundNode.rect.height = tiledZeroDegreePack[id].height;
                });
            };
            CoSELayout.prototype.repopulateCompounds = function() {
                for(var i = this.compoundOrder.length - 1; i >= 0; i--){
                    var lCompoundNode = this.compoundOrder[i];
                    var id = lCompoundNode.id;
                    var horizontalMargin = lCompoundNode.paddingLeft;
                    var verticalMargin = lCompoundNode.paddingTop;
                    this.adjustLocations(this.tiledMemberPack[id], lCompoundNode.rect.x, lCompoundNode.rect.y, horizontalMargin, verticalMargin);
                }
            };
            CoSELayout.prototype.repopulateZeroDegreeMembers = function() {
                var self = this;
                var tiledPack = this.tiledZeroDegreePack;
                Object.keys(tiledPack).forEach(function(id) {
                    var compoundNode = self.idToDummyNode[id]; // Get the dummy compound by its id
                    var horizontalMargin = compoundNode.paddingLeft;
                    var verticalMargin = compoundNode.paddingTop;
                    // Adjust the positions of nodes wrt its compound
                    self.adjustLocations(tiledPack[id], compoundNode.rect.x, compoundNode.rect.y, horizontalMargin, verticalMargin);
                });
            };
            CoSELayout.prototype.getToBeTiled = function(node) {
                var id = node.id;
                //firstly check the previous results
                if (this.toBeTiled[id] != null) return this.toBeTiled[id];
                //only compound nodes are to be tiled
                var childGraph = node.getChild();
                if (childGraph == null) {
                    this.toBeTiled[id] = false;
                    return false;
                }
                var children = childGraph.getNodes(); // Get the children nodes
                //a compound node is not to be tiled if all of its compound children are not to be tiled
                for(var i = 0; i < children.length; i++){
                    var theChild = children[i];
                    if (this.getNodeDegree(theChild) > 0) {
                        this.toBeTiled[id] = false;
                        return false;
                    }
                    //pass the children not having the compound structure
                    if (theChild.getChild() == null) {
                        this.toBeTiled[theChild.id] = false;
                        continue;
                    }
                    if (!this.getToBeTiled(theChild)) {
                        this.toBeTiled[id] = false;
                        return false;
                    }
                }
                this.toBeTiled[id] = true;
                return true;
            };
            // Get degree of a node depending of its edges and independent of its children
            CoSELayout.prototype.getNodeDegree = function(node) {
                var id = node.id;
                var edges = node.getEdges();
                var degree = 0;
                // For the edges connected
                for(var i = 0; i < edges.length; i++){
                    var edge = edges[i];
                    if (edge.getSource().id !== edge.getTarget().id) degree = degree + 1;
                }
                return degree;
            };
            // Get degree of a node with its children
            CoSELayout.prototype.getNodeDegreeWithChildren = function(node) {
                var degree = this.getNodeDegree(node);
                if (node.getChild() == null) return degree;
                var children = node.getChild().getNodes();
                for(var i = 0; i < children.length; i++){
                    var child = children[i];
                    degree += this.getNodeDegreeWithChildren(child);
                }
                return degree;
            };
            CoSELayout.prototype.performDFSOnCompounds = function() {
                this.compoundOrder = [];
                this.fillCompexOrderByDFS(this.graphManager.getRoot().getNodes());
            };
            CoSELayout.prototype.fillCompexOrderByDFS = function(children) {
                for(var i = 0; i < children.length; i++){
                    var child = children[i];
                    if (child.getChild() != null) this.fillCompexOrderByDFS(child.getChild().getNodes());
                    if (this.getToBeTiled(child)) this.compoundOrder.push(child);
                }
            };
            /**
* This method places each zero degree member wrt given (x,y) coordinates (top left).
*/ CoSELayout.prototype.adjustLocations = function(organization, x, y, compoundHorizontalMargin, compoundVerticalMargin) {
                x += compoundHorizontalMargin;
                y += compoundVerticalMargin;
                var left = x;
                for(var i = 0; i < organization.rows.length; i++){
                    var row = organization.rows[i];
                    x = left;
                    var maxHeight = 0;
                    for(var j = 0; j < row.length; j++){
                        var lnode = row[j];
                        lnode.rect.x = x; // + lnode.rect.width / 2;
                        lnode.rect.y = y; // + lnode.rect.height / 2;
                        x += lnode.rect.width + organization.horizontalPadding;
                        if (lnode.rect.height > maxHeight) maxHeight = lnode.rect.height;
                    }
                    y += maxHeight + organization.verticalPadding;
                }
            };
            CoSELayout.prototype.tileCompoundMembers = function(childGraphMap, idToNode) {
                var self = this;
                this.tiledMemberPack = [];
                Object.keys(childGraphMap).forEach(function(id) {
                    // Get the compound node
                    var compoundNode = idToNode[id];
                    self.tiledMemberPack[id] = self.tileNodes(childGraphMap[id], compoundNode.paddingLeft + compoundNode.paddingRight);
                    compoundNode.rect.width = self.tiledMemberPack[id].width;
                    compoundNode.rect.height = self.tiledMemberPack[id].height;
                });
            };
            CoSELayout.prototype.tileNodes = function(nodes, minWidth) {
                var verticalPadding = CoSEConstants.TILING_PADDING_VERTICAL;
                var horizontalPadding = CoSEConstants.TILING_PADDING_HORIZONTAL;
                var organization = {
                    rows: [],
                    rowWidth: [],
                    rowHeight: [],
                    width: 0,
                    height: minWidth,
                    verticalPadding: verticalPadding,
                    horizontalPadding: horizontalPadding
                };
                // Sort the nodes in ascending order of their areas
                nodes.sort(function(n1, n2) {
                    if (n1.rect.width * n1.rect.height > n2.rect.width * n2.rect.height) return -1;
                    if (n1.rect.width * n1.rect.height < n2.rect.width * n2.rect.height) return 1;
                    return 0;
                });
                // Create the organization -> tile members
                for(var i = 0; i < nodes.length; i++){
                    var lNode = nodes[i];
                    if (organization.rows.length == 0) this.insertNodeToRow(organization, lNode, 0, minWidth);
                    else if (this.canAddHorizontal(organization, lNode.rect.width, lNode.rect.height)) this.insertNodeToRow(organization, lNode, this.getShortestRowIndex(organization), minWidth);
                    else this.insertNodeToRow(organization, lNode, organization.rows.length, minWidth);
                    this.shiftToLastRow(organization);
                }
                return organization;
            };
            CoSELayout.prototype.insertNodeToRow = function(organization, node, rowIndex, minWidth) {
                var minCompoundSize = minWidth;
                // Add new row if needed
                if (rowIndex == organization.rows.length) {
                    var secondDimension = [];
                    organization.rows.push(secondDimension);
                    organization.rowWidth.push(minCompoundSize);
                    organization.rowHeight.push(0);
                }
                // Update row width
                var w = organization.rowWidth[rowIndex] + node.rect.width;
                if (organization.rows[rowIndex].length > 0) w += organization.horizontalPadding;
                organization.rowWidth[rowIndex] = w;
                // Update compound width
                if (organization.width < w) organization.width = w;
                // Update height
                var h = node.rect.height;
                if (rowIndex > 0) h += organization.verticalPadding;
                var extraHeight = 0;
                if (h > organization.rowHeight[rowIndex]) {
                    extraHeight = organization.rowHeight[rowIndex];
                    organization.rowHeight[rowIndex] = h;
                    extraHeight = organization.rowHeight[rowIndex] - extraHeight;
                }
                organization.height += extraHeight;
                // Insert node
                organization.rows[rowIndex].push(node);
            };
            //Scans the rows of an organization and returns the one with the min width
            CoSELayout.prototype.getShortestRowIndex = function(organization) {
                var r = -1;
                var min = Number.MAX_VALUE;
                for(var i = 0; i < organization.rows.length; i++)if (organization.rowWidth[i] < min) {
                    r = i;
                    min = organization.rowWidth[i];
                }
                return r;
            };
            //Scans the rows of an organization and returns the one with the max width
            CoSELayout.prototype.getLongestRowIndex = function(organization) {
                var r = -1;
                var max = Number.MIN_VALUE;
                for(var i = 0; i < organization.rows.length; i++)if (organization.rowWidth[i] > max) {
                    r = i;
                    max = organization.rowWidth[i];
                }
                return r;
            };
            /**
* This method checks whether adding extra width to the organization violates
* the aspect ratio(1) or not.
*/ CoSELayout.prototype.canAddHorizontal = function(organization, extraWidth, extraHeight) {
                var sri = this.getShortestRowIndex(organization);
                if (sri < 0) return true;
                var min = organization.rowWidth[sri];
                if (min + organization.horizontalPadding + extraWidth <= organization.width) return true;
                var hDiff = 0;
                // Adding to an existing row
                if (organization.rowHeight[sri] < extraHeight) {
                    if (sri > 0) hDiff = extraHeight + organization.verticalPadding - organization.rowHeight[sri];
                }
                var add_to_row_ratio;
                if (organization.width - min >= extraWidth + organization.horizontalPadding) add_to_row_ratio = (organization.height + hDiff) / (min + extraWidth + organization.horizontalPadding);
                else add_to_row_ratio = (organization.height + hDiff) / organization.width;
                // Adding a new row for this node
                hDiff = extraHeight + organization.verticalPadding;
                var add_new_row_ratio;
                if (organization.width < extraWidth) add_new_row_ratio = (organization.height + hDiff) / extraWidth;
                else add_new_row_ratio = (organization.height + hDiff) / organization.width;
                if (add_new_row_ratio < 1) add_new_row_ratio = 1 / add_new_row_ratio;
                if (add_to_row_ratio < 1) add_to_row_ratio = 1 / add_to_row_ratio;
                return add_to_row_ratio < add_new_row_ratio;
            };
            //If moving the last node from the longest row and adding it to the last
            //row makes the bounding box smaller, do it.
            CoSELayout.prototype.shiftToLastRow = function(organization) {
                var longest = this.getLongestRowIndex(organization);
                var last = organization.rowWidth.length - 1;
                var row = organization.rows[longest];
                var node = row[row.length - 1];
                var diff = node.width + organization.horizontalPadding;
                // Check if there is enough space on the last row
                if (organization.width - organization.rowWidth[last] > diff && longest != last) {
                    // Remove the last element of the longest row
                    row.splice(-1, 1);
                    // Push it to the last row
                    organization.rows[last].push(node);
                    organization.rowWidth[longest] = organization.rowWidth[longest] - diff;
                    organization.rowWidth[last] = organization.rowWidth[last] + diff;
                    organization.width = organization.rowWidth[instance.getLongestRowIndex(organization)];
                    // Update heights of the organization
                    var maxHeight = Number.MIN_VALUE;
                    for(var i = 0; i < row.length; i++)if (row[i].height > maxHeight) maxHeight = row[i].height;
                    if (longest > 0) maxHeight += organization.verticalPadding;
                    var prevTotal = organization.rowHeight[longest] + organization.rowHeight[last];
                    organization.rowHeight[longest] = maxHeight;
                    if (organization.rowHeight[last] < node.height + organization.verticalPadding) organization.rowHeight[last] = node.height + organization.verticalPadding;
                    var finalTotal = organization.rowHeight[longest] + organization.rowHeight[last];
                    organization.height += finalTotal - prevTotal;
                    this.shiftToLastRow(organization);
                }
            };
            CoSELayout.prototype.tilingPreLayout = function() {
                if (CoSEConstants.TILE) {
                    // Find zero degree nodes and create a compound for each level
                    this.groupZeroDegreeMembers();
                    // Tile and clear children of each compound
                    this.clearCompounds();
                    // Separately tile and clear zero degree nodes for each level
                    this.clearZeroDegreeMembers();
                }
            };
            CoSELayout.prototype.tilingPostLayout = function() {
                if (CoSEConstants.TILE) {
                    this.repopulateZeroDegreeMembers();
                    this.repopulateCompounds();
                }
            };
            // -----------------------------------------------------------------------------
            // Section: Tree Reduction methods
            // -----------------------------------------------------------------------------
            // Reduce trees 
            CoSELayout.prototype.reduceTrees = function() {
                var prunedNodesAll = [];
                var containsLeaf = true;
                var node;
                while(containsLeaf){
                    var allNodes = this.graphManager.getAllNodes();
                    var prunedNodesInStepTemp = [];
                    containsLeaf = false;
                    for(var i = 0; i < allNodes.length; i++){
                        node = allNodes[i];
                        if (node.getEdges().length == 1 && !node.getEdges()[0].isInterGraph && node.getChild() == null) {
                            prunedNodesInStepTemp.push([
                                node,
                                node.getEdges()[0],
                                node.getOwner()
                            ]);
                            containsLeaf = true;
                        }
                    }
                    if (containsLeaf == true) {
                        var prunedNodesInStep = [];
                        for(var j = 0; j < prunedNodesInStepTemp.length; j++)if (prunedNodesInStepTemp[j][0].getEdges().length == 1) {
                            prunedNodesInStep.push(prunedNodesInStepTemp[j]);
                            prunedNodesInStepTemp[j][0].getOwner().remove(prunedNodesInStepTemp[j][0]);
                        }
                        prunedNodesAll.push(prunedNodesInStep);
                        this.graphManager.resetAllNodes();
                        this.graphManager.resetAllEdges();
                    }
                }
                this.prunedNodesAll = prunedNodesAll;
            };
            // Grow tree one step 
            CoSELayout.prototype.growTree = function(prunedNodesAll) {
                var lengthOfPrunedNodesInStep = prunedNodesAll.length;
                var prunedNodesInStep = prunedNodesAll[lengthOfPrunedNodesInStep - 1];
                var nodeData;
                for(var i = 0; i < prunedNodesInStep.length; i++){
                    nodeData = prunedNodesInStep[i];
                    this.findPlaceforPrunedNode(nodeData);
                    nodeData[2].add(nodeData[0]);
                    nodeData[2].add(nodeData[1], nodeData[1].source, nodeData[1].target);
                }
                prunedNodesAll.splice(prunedNodesAll.length - 1, 1);
                this.graphManager.resetAllNodes();
                this.graphManager.resetAllEdges();
            };
            // Find an appropriate position to replace pruned node, this method can be improved
            CoSELayout.prototype.findPlaceforPrunedNode = function(nodeData) {
                var gridForPrunedNode;
                var nodeToConnect;
                var prunedNode = nodeData[0];
                if (prunedNode == nodeData[1].source) nodeToConnect = nodeData[1].target;
                else nodeToConnect = nodeData[1].source;
                var startGridX = nodeToConnect.startX;
                var finishGridX = nodeToConnect.finishX;
                var startGridY = nodeToConnect.startY;
                var finishGridY = nodeToConnect.finishY;
                var upNodeCount = 0;
                var downNodeCount = 0;
                var rightNodeCount = 0;
                var leftNodeCount = 0;
                var controlRegions = [
                    upNodeCount,
                    rightNodeCount,
                    downNodeCount,
                    leftNodeCount
                ];
                if (startGridY > 0) for(var i = startGridX; i <= finishGridX; i++)controlRegions[0] += this.grid[i][startGridY - 1].length + this.grid[i][startGridY].length - 1;
                if (finishGridX < this.grid.length - 1) for(var i = startGridY; i <= finishGridY; i++)controlRegions[1] += this.grid[finishGridX + 1][i].length + this.grid[finishGridX][i].length - 1;
                if (finishGridY < this.grid[0].length - 1) for(var i = startGridX; i <= finishGridX; i++)controlRegions[2] += this.grid[i][finishGridY + 1].length + this.grid[i][finishGridY].length - 1;
                if (startGridX > 0) for(var i = startGridY; i <= finishGridY; i++)controlRegions[3] += this.grid[startGridX - 1][i].length + this.grid[startGridX][i].length - 1;
                var min = Integer.MAX_VALUE;
                var minCount;
                var minIndex;
                for(var j = 0; j < controlRegions.length; j++){
                    if (controlRegions[j] < min) {
                        min = controlRegions[j];
                        minCount = 1;
                        minIndex = j;
                    } else if (controlRegions[j] == min) minCount++;
                }
                if (minCount == 3 && min == 0) {
                    if (controlRegions[0] == 0 && controlRegions[1] == 0 && controlRegions[2] == 0) gridForPrunedNode = 1;
                    else if (controlRegions[0] == 0 && controlRegions[1] == 0 && controlRegions[3] == 0) gridForPrunedNode = 0;
                    else if (controlRegions[0] == 0 && controlRegions[2] == 0 && controlRegions[3] == 0) gridForPrunedNode = 3;
                    else if (controlRegions[1] == 0 && controlRegions[2] == 0 && controlRegions[3] == 0) gridForPrunedNode = 2;
                } else if (minCount == 2 && min == 0) {
                    var random = Math.floor(Math.random() * 2);
                    if (controlRegions[0] == 0 && controlRegions[1] == 0) {
                        if (random == 0) gridForPrunedNode = 0;
                        else gridForPrunedNode = 1;
                    } else if (controlRegions[0] == 0 && controlRegions[2] == 0) {
                        if (random == 0) gridForPrunedNode = 0;
                        else gridForPrunedNode = 2;
                    } else if (controlRegions[0] == 0 && controlRegions[3] == 0) {
                        if (random == 0) gridForPrunedNode = 0;
                        else gridForPrunedNode = 3;
                    } else if (controlRegions[1] == 0 && controlRegions[2] == 0) {
                        if (random == 0) gridForPrunedNode = 1;
                        else gridForPrunedNode = 2;
                    } else if (controlRegions[1] == 0 && controlRegions[3] == 0) {
                        if (random == 0) gridForPrunedNode = 1;
                        else gridForPrunedNode = 3;
                    } else if (random == 0) gridForPrunedNode = 2;
                    else gridForPrunedNode = 3;
                } else if (minCount == 4 && min == 0) {
                    var random = Math.floor(Math.random() * 4);
                    gridForPrunedNode = random;
                } else gridForPrunedNode = minIndex;
                if (gridForPrunedNode == 0) prunedNode.setCenter(nodeToConnect.getCenterX(), nodeToConnect.getCenterY() - nodeToConnect.getHeight() / 2 - FDLayoutConstants.DEFAULT_EDGE_LENGTH - prunedNode.getHeight() / 2);
                else if (gridForPrunedNode == 1) prunedNode.setCenter(nodeToConnect.getCenterX() + nodeToConnect.getWidth() / 2 + FDLayoutConstants.DEFAULT_EDGE_LENGTH + prunedNode.getWidth() / 2, nodeToConnect.getCenterY());
                else if (gridForPrunedNode == 2) prunedNode.setCenter(nodeToConnect.getCenterX(), nodeToConnect.getCenterY() + nodeToConnect.getHeight() / 2 + FDLayoutConstants.DEFAULT_EDGE_LENGTH + prunedNode.getHeight() / 2);
                else prunedNode.setCenter(nodeToConnect.getCenterX() - nodeToConnect.getWidth() / 2 - FDLayoutConstants.DEFAULT_EDGE_LENGTH - prunedNode.getWidth() / 2, nodeToConnect.getCenterY());
            };
            module1.exports = CoSELayout;
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var coseBase = {};
            coseBase.layoutBase = __webpack_require__(0);
            coseBase.CoSEConstants = __webpack_require__(1);
            coseBase.CoSEEdge = __webpack_require__(2);
            coseBase.CoSEGraph = __webpack_require__(3);
            coseBase.CoSEGraphManager = __webpack_require__(4);
            coseBase.CoSELayout = __webpack_require__(6);
            coseBase.CoSENode = __webpack_require__(5);
            module1.exports = coseBase;
        /***/ }
    ]);
});

});

parcelRegister("ex9m6", function(module, exports) {

(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory((parcelRequire("g2Xm1")));
})(module.exports, function(__WEBPACK_EXTERNAL_MODULE__551__) {
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ 45: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                var coseBase = {};
                coseBase.layoutBase = __webpack_require__(551);
                coseBase.CoSEConstants = __webpack_require__(806);
                coseBase.CoSEEdge = __webpack_require__(767);
                coseBase.CoSEGraph = __webpack_require__(880);
                coseBase.CoSEGraphManager = __webpack_require__(578);
                coseBase.CoSELayout = __webpack_require__(765);
                coseBase.CoSENode = __webpack_require__(991);
                coseBase.ConstraintHandler = __webpack_require__(902);
                module1.exports = coseBase;
            /***/ },
            /***/ 806: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                var FDLayoutConstants = __webpack_require__(551).FDLayoutConstants;
                function CoSEConstants() {}
                //CoSEConstants inherits static props in FDLayoutConstants
                for(var prop in FDLayoutConstants)CoSEConstants[prop] = FDLayoutConstants[prop];
                CoSEConstants.DEFAULT_USE_MULTI_LEVEL_SCALING = false;
                CoSEConstants.DEFAULT_RADIAL_SEPARATION = FDLayoutConstants.DEFAULT_EDGE_LENGTH;
                CoSEConstants.DEFAULT_COMPONENT_SEPERATION = 60;
                CoSEConstants.TILE = true;
                CoSEConstants.TILING_PADDING_VERTICAL = 10;
                CoSEConstants.TILING_PADDING_HORIZONTAL = 10;
                CoSEConstants.TRANSFORM_ON_CONSTRAINT_HANDLING = true;
                CoSEConstants.ENFORCE_CONSTRAINTS = true;
                CoSEConstants.APPLY_LAYOUT = true;
                CoSEConstants.RELAX_MOVEMENT_ON_CONSTRAINTS = true;
                CoSEConstants.TREE_REDUCTION_ON_INCREMENTAL = true; // this should be set to false if there will be a constraint
                // This constant is for differentiating whether actual layout algorithm that uses cose-base wants to apply only incremental layout or 
                // an incremental layout on top of a randomized layout. If it is only incremental layout, then this constant should be true.
                CoSEConstants.PURE_INCREMENTAL = CoSEConstants.DEFAULT_INCREMENTAL;
                module1.exports = CoSEConstants;
            /***/ },
            /***/ 767: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                var FDLayoutEdge = __webpack_require__(551).FDLayoutEdge;
                function CoSEEdge(source, target, vEdge) {
                    FDLayoutEdge.call(this, source, target, vEdge);
                }
                CoSEEdge.prototype = Object.create(FDLayoutEdge.prototype);
                for(var prop in FDLayoutEdge)CoSEEdge[prop] = FDLayoutEdge[prop];
                module1.exports = CoSEEdge;
            /***/ },
            /***/ 880: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                var LGraph = __webpack_require__(551).LGraph;
                function CoSEGraph(parent, graphMgr, vGraph) {
                    LGraph.call(this, parent, graphMgr, vGraph);
                }
                CoSEGraph.prototype = Object.create(LGraph.prototype);
                for(var prop in LGraph)CoSEGraph[prop] = LGraph[prop];
                module1.exports = CoSEGraph;
            /***/ },
            /***/ 578: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                var LGraphManager = __webpack_require__(551).LGraphManager;
                function CoSEGraphManager(layout) {
                    LGraphManager.call(this, layout);
                }
                CoSEGraphManager.prototype = Object.create(LGraphManager.prototype);
                for(var prop in LGraphManager)CoSEGraphManager[prop] = LGraphManager[prop];
                module1.exports = CoSEGraphManager;
            /***/ },
            /***/ 765: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                var FDLayout = __webpack_require__(551).FDLayout;
                var CoSEGraphManager = __webpack_require__(578);
                var CoSEGraph = __webpack_require__(880);
                var CoSENode = __webpack_require__(991);
                var CoSEEdge = __webpack_require__(767);
                var CoSEConstants = __webpack_require__(806);
                var ConstraintHandler = __webpack_require__(902);
                var FDLayoutConstants = __webpack_require__(551).FDLayoutConstants;
                var LayoutConstants = __webpack_require__(551).LayoutConstants;
                var Point = __webpack_require__(551).Point;
                var PointD = __webpack_require__(551).PointD;
                var DimensionD = __webpack_require__(551).DimensionD;
                var Layout = __webpack_require__(551).Layout;
                var Integer = __webpack_require__(551).Integer;
                var IGeometry = __webpack_require__(551).IGeometry;
                var LGraph = __webpack_require__(551).LGraph;
                var Transform = __webpack_require__(551).Transform;
                var LinkedList = __webpack_require__(551).LinkedList;
                function CoSELayout() {
                    FDLayout.call(this);
                    this.toBeTiled = {}; // Memorize if a node is to be tiled or is tiled
                    this.constraints = {}; // keep layout constraints
                }
                CoSELayout.prototype = Object.create(FDLayout.prototype);
                for(var prop in FDLayout)CoSELayout[prop] = FDLayout[prop];
                CoSELayout.prototype.newGraphManager = function() {
                    var gm = new CoSEGraphManager(this);
                    this.graphManager = gm;
                    return gm;
                };
                CoSELayout.prototype.newGraph = function(vGraph) {
                    return new CoSEGraph(null, this.graphManager, vGraph);
                };
                CoSELayout.prototype.newNode = function(vNode) {
                    return new CoSENode(this.graphManager, vNode);
                };
                CoSELayout.prototype.newEdge = function(vEdge) {
                    return new CoSEEdge(null, null, vEdge);
                };
                CoSELayout.prototype.initParameters = function() {
                    FDLayout.prototype.initParameters.call(this, arguments);
                    if (!this.isSubLayout) {
                        if (CoSEConstants.DEFAULT_EDGE_LENGTH < 10) this.idealEdgeLength = 10;
                        else this.idealEdgeLength = CoSEConstants.DEFAULT_EDGE_LENGTH;
                        this.useSmartIdealEdgeLengthCalculation = CoSEConstants.DEFAULT_USE_SMART_IDEAL_EDGE_LENGTH_CALCULATION;
                        this.gravityConstant = FDLayoutConstants.DEFAULT_GRAVITY_STRENGTH;
                        this.compoundGravityConstant = FDLayoutConstants.DEFAULT_COMPOUND_GRAVITY_STRENGTH;
                        this.gravityRangeFactor = FDLayoutConstants.DEFAULT_GRAVITY_RANGE_FACTOR;
                        this.compoundGravityRangeFactor = FDLayoutConstants.DEFAULT_COMPOUND_GRAVITY_RANGE_FACTOR;
                        // variables for tree reduction support
                        this.prunedNodesAll = [];
                        this.growTreeIterations = 0;
                        this.afterGrowthIterations = 0;
                        this.isTreeGrowing = false;
                        this.isGrowthFinished = false;
                    }
                };
                // This method is used to set CoSE related parameters used by spring embedder.
                CoSELayout.prototype.initSpringEmbedder = function() {
                    FDLayout.prototype.initSpringEmbedder.call(this);
                    // variables for cooling
                    this.coolingCycle = 0;
                    this.maxCoolingCycle = this.maxIterations / FDLayoutConstants.CONVERGENCE_CHECK_PERIOD;
                    this.finalTemperature = 0.04;
                    this.coolingAdjuster = 1;
                };
                CoSELayout.prototype.layout = function() {
                    var createBendsAsNeeded = LayoutConstants.DEFAULT_CREATE_BENDS_AS_NEEDED;
                    if (createBendsAsNeeded) {
                        this.createBendpoints();
                        this.graphManager.resetAllEdges();
                    }
                    this.level = 0;
                    return this.classicLayout();
                };
                CoSELayout.prototype.classicLayout = function() {
                    this.nodesWithGravity = this.calculateNodesToApplyGravitationTo();
                    this.graphManager.setAllNodesToApplyGravitation(this.nodesWithGravity);
                    this.calcNoOfChildrenForAllNodes();
                    this.graphManager.calcLowestCommonAncestors();
                    this.graphManager.calcInclusionTreeDepths();
                    this.graphManager.getRoot().calcEstimatedSize();
                    this.calcIdealEdgeLengths();
                    if (!this.incremental) {
                        var forest = this.getFlatForest();
                        // The graph associated with this layout is flat and a forest
                        if (forest.length > 0) this.positionNodesRadially(forest);
                        else {
                            // Reduce the trees when incremental mode is not enabled and graph is not a forest 
                            this.reduceTrees();
                            // Update nodes that gravity will be applied
                            this.graphManager.resetAllNodesToApplyGravitation();
                            var allNodes = new Set(this.getAllNodes());
                            var intersection = this.nodesWithGravity.filter(function(x) {
                                return allNodes.has(x);
                            });
                            this.graphManager.setAllNodesToApplyGravitation(intersection);
                            this.positionNodesRandomly();
                        }
                    } else if (CoSEConstants.TREE_REDUCTION_ON_INCREMENTAL) {
                        // Reduce the trees in incremental mode if only this constant is set to true 
                        this.reduceTrees();
                        // Update nodes that gravity will be applied
                        this.graphManager.resetAllNodesToApplyGravitation();
                        var allNodes = new Set(this.getAllNodes());
                        var intersection = this.nodesWithGravity.filter(function(x) {
                            return allNodes.has(x);
                        });
                        this.graphManager.setAllNodesToApplyGravitation(intersection);
                    }
                    if (Object.keys(this.constraints).length > 0) {
                        ConstraintHandler.handleConstraints(this);
                        this.initConstraintVariables();
                    }
                    this.initSpringEmbedder();
                    if (CoSEConstants.APPLY_LAYOUT) this.runSpringEmbedder();
                    return true;
                };
                CoSELayout.prototype.tick = function() {
                    this.totalIterations++;
                    if (this.totalIterations === this.maxIterations && !this.isTreeGrowing && !this.isGrowthFinished) {
                        if (this.prunedNodesAll.length > 0) this.isTreeGrowing = true;
                        else return true;
                    }
                    if (this.totalIterations % FDLayoutConstants.CONVERGENCE_CHECK_PERIOD == 0 && !this.isTreeGrowing && !this.isGrowthFinished) {
                        if (this.isConverged()) {
                            if (this.prunedNodesAll.length > 0) this.isTreeGrowing = true;
                            else return true;
                        }
                        this.coolingCycle++;
                        if (this.layoutQuality == 0) // quality - "draft"
                        this.coolingAdjuster = this.coolingCycle;
                        else if (this.layoutQuality == 1) // quality - "default"
                        this.coolingAdjuster = this.coolingCycle / 3;
                        // cooling schedule is based on http://www.btluke.com/simanf1.html -> cooling schedule 3
                        this.coolingFactor = Math.max(this.initialCoolingFactor - Math.pow(this.coolingCycle, Math.log(100 * (this.initialCoolingFactor - this.finalTemperature)) / Math.log(this.maxCoolingCycle)) / 100 * this.coolingAdjuster, this.finalTemperature);
                        this.animationPeriod = Math.ceil(this.initialAnimationPeriod * Math.sqrt(this.coolingFactor));
                    }
                    // Operations while tree is growing again 
                    if (this.isTreeGrowing) {
                        if (this.growTreeIterations % 10 == 0) {
                            if (this.prunedNodesAll.length > 0) {
                                this.graphManager.updateBounds();
                                this.updateGrid();
                                this.growTree(this.prunedNodesAll);
                                // Update nodes that gravity will be applied
                                this.graphManager.resetAllNodesToApplyGravitation();
                                var allNodes = new Set(this.getAllNodes());
                                var intersection = this.nodesWithGravity.filter(function(x) {
                                    return allNodes.has(x);
                                });
                                this.graphManager.setAllNodesToApplyGravitation(intersection);
                                this.graphManager.updateBounds();
                                this.updateGrid();
                                if (CoSEConstants.PURE_INCREMENTAL) this.coolingFactor = FDLayoutConstants.DEFAULT_COOLING_FACTOR_INCREMENTAL / 2;
                                else this.coolingFactor = FDLayoutConstants.DEFAULT_COOLING_FACTOR_INCREMENTAL;
                            } else {
                                this.isTreeGrowing = false;
                                this.isGrowthFinished = true;
                            }
                        }
                        this.growTreeIterations++;
                    }
                    // Operations after growth is finished
                    if (this.isGrowthFinished) {
                        if (this.isConverged()) return true;
                        if (this.afterGrowthIterations % 10 == 0) {
                            this.graphManager.updateBounds();
                            this.updateGrid();
                        }
                        if (CoSEConstants.PURE_INCREMENTAL) this.coolingFactor = FDLayoutConstants.DEFAULT_COOLING_FACTOR_INCREMENTAL / 2 * ((100 - this.afterGrowthIterations) / 100);
                        else this.coolingFactor = FDLayoutConstants.DEFAULT_COOLING_FACTOR_INCREMENTAL * ((100 - this.afterGrowthIterations) / 100);
                        this.afterGrowthIterations++;
                    }
                    var gridUpdateAllowed = !this.isTreeGrowing && !this.isGrowthFinished;
                    var forceToNodeSurroundingUpdate = this.growTreeIterations % 10 == 1 && this.isTreeGrowing || this.afterGrowthIterations % 10 == 1 && this.isGrowthFinished;
                    this.totalDisplacement = 0;
                    this.graphManager.updateBounds();
                    this.calcSpringForces();
                    this.calcRepulsionForces(gridUpdateAllowed, forceToNodeSurroundingUpdate);
                    this.calcGravitationalForces();
                    this.moveNodes();
                    this.animate();
                    return false; // Layout is not ended yet return false
                };
                CoSELayout.prototype.getPositionsData = function() {
                    var allNodes = this.graphManager.getAllNodes();
                    var pData = {};
                    for(var i = 0; i < allNodes.length; i++){
                        var rect = allNodes[i].rect;
                        var id = allNodes[i].id;
                        pData[id] = {
                            id: id,
                            x: rect.getCenterX(),
                            y: rect.getCenterY(),
                            w: rect.width,
                            h: rect.height
                        };
                    }
                    return pData;
                };
                CoSELayout.prototype.runSpringEmbedder = function() {
                    this.initialAnimationPeriod = 25;
                    this.animationPeriod = this.initialAnimationPeriod;
                    var layoutEnded = false;
                    // If aminate option is 'during' signal that layout is supposed to start iterating
                    if (FDLayoutConstants.ANIMATE === 'during') this.emit('layoutstarted');
                    else {
                        // If aminate option is 'during' tick() function will be called on index.js
                        while(!layoutEnded)layoutEnded = this.tick();
                        this.graphManager.updateBounds();
                    }
                };
                // overrides moveNodes method in FDLayout
                CoSELayout.prototype.moveNodes = function() {
                    var lNodes = this.getAllNodes();
                    var node;
                    // calculate displacement for each node 
                    for(var i = 0; i < lNodes.length; i++){
                        node = lNodes[i];
                        node.calculateDisplacement();
                    }
                    if (Object.keys(this.constraints).length > 0) this.updateDisplacements();
                    // move each node
                    for(var i = 0; i < lNodes.length; i++){
                        node = lNodes[i];
                        node.move();
                    }
                };
                // constraint related methods: initConstraintVariables and updateDisplacements
                // initialize constraint related variables
                CoSELayout.prototype.initConstraintVariables = function() {
                    var self = this;
                    this.idToNodeMap = new Map();
                    this.fixedNodeSet = new Set();
                    var allNodes = this.graphManager.getAllNodes();
                    // fill idToNodeMap
                    for(var i = 0; i < allNodes.length; i++){
                        var node = allNodes[i];
                        this.idToNodeMap.set(node.id, node);
                    }
                    // calculate fixed node weight for given compound node
                    var calculateCompoundWeight = function calculateCompoundWeight(compoundNode) {
                        var nodes = compoundNode.getChild().getNodes();
                        var node;
                        var fixedNodeWeight = 0;
                        for(var i = 0; i < nodes.length; i++){
                            node = nodes[i];
                            if (node.getChild() == null) {
                                if (self.fixedNodeSet.has(node.id)) fixedNodeWeight += 100;
                            } else fixedNodeWeight += calculateCompoundWeight(node);
                        }
                        return fixedNodeWeight;
                    };
                    if (this.constraints.fixedNodeConstraint) {
                        // fill fixedNodeSet
                        this.constraints.fixedNodeConstraint.forEach(function(nodeData) {
                            self.fixedNodeSet.add(nodeData.nodeId);
                        });
                        // assign fixed node weights to compounds if they contain fixed nodes
                        var allNodes = this.graphManager.getAllNodes();
                        var node;
                        for(var i = 0; i < allNodes.length; i++){
                            node = allNodes[i];
                            if (node.getChild() != null) {
                                var fixedNodeWeight = calculateCompoundWeight(node);
                                if (fixedNodeWeight > 0) node.fixedNodeWeight = fixedNodeWeight;
                            }
                        }
                    }
                    if (this.constraints.relativePlacementConstraint) {
                        var nodeToDummyForVerticalAlignment = new Map();
                        var nodeToDummyForHorizontalAlignment = new Map();
                        this.dummyToNodeForVerticalAlignment = new Map();
                        this.dummyToNodeForHorizontalAlignment = new Map();
                        this.fixedNodesOnHorizontal = new Set();
                        this.fixedNodesOnVertical = new Set();
                        // fill maps and sets
                        this.fixedNodeSet.forEach(function(nodeId) {
                            self.fixedNodesOnHorizontal.add(nodeId);
                            self.fixedNodesOnVertical.add(nodeId);
                        });
                        if (this.constraints.alignmentConstraint) {
                            if (this.constraints.alignmentConstraint.vertical) {
                                var verticalAlignment = this.constraints.alignmentConstraint.vertical;
                                for(var i = 0; i < verticalAlignment.length; i++){
                                    this.dummyToNodeForVerticalAlignment.set("dummy" + i, []);
                                    verticalAlignment[i].forEach(function(nodeId) {
                                        nodeToDummyForVerticalAlignment.set(nodeId, "dummy" + i);
                                        self.dummyToNodeForVerticalAlignment.get("dummy" + i).push(nodeId);
                                        if (self.fixedNodeSet.has(nodeId)) self.fixedNodesOnHorizontal.add("dummy" + i);
                                    });
                                }
                            }
                            if (this.constraints.alignmentConstraint.horizontal) {
                                var horizontalAlignment = this.constraints.alignmentConstraint.horizontal;
                                for(var i = 0; i < horizontalAlignment.length; i++){
                                    this.dummyToNodeForHorizontalAlignment.set("dummy" + i, []);
                                    horizontalAlignment[i].forEach(function(nodeId) {
                                        nodeToDummyForHorizontalAlignment.set(nodeId, "dummy" + i);
                                        self.dummyToNodeForHorizontalAlignment.get("dummy" + i).push(nodeId);
                                        if (self.fixedNodeSet.has(nodeId)) self.fixedNodesOnVertical.add("dummy" + i);
                                    });
                                }
                            }
                        }
                        if (CoSEConstants.RELAX_MOVEMENT_ON_CONSTRAINTS) {
                            this.shuffle = function(array) {
                                var j, x, i;
                                for(i = array.length - 1; i >= 2 * array.length / 3; i--){
                                    j = Math.floor(Math.random() * (i + 1));
                                    x = array[i];
                                    array[i] = array[j];
                                    array[j] = x;
                                }
                                return array;
                            };
                            this.nodesInRelativeHorizontal = [];
                            this.nodesInRelativeVertical = [];
                            this.nodeToRelativeConstraintMapHorizontal = new Map();
                            this.nodeToRelativeConstraintMapVertical = new Map();
                            this.nodeToTempPositionMapHorizontal = new Map();
                            this.nodeToTempPositionMapVertical = new Map();
                            // fill arrays and maps
                            this.constraints.relativePlacementConstraint.forEach(function(constraint) {
                                if (constraint.left) {
                                    var nodeIdLeft = nodeToDummyForVerticalAlignment.has(constraint.left) ? nodeToDummyForVerticalAlignment.get(constraint.left) : constraint.left;
                                    var nodeIdRight = nodeToDummyForVerticalAlignment.has(constraint.right) ? nodeToDummyForVerticalAlignment.get(constraint.right) : constraint.right;
                                    if (!self.nodesInRelativeHorizontal.includes(nodeIdLeft)) {
                                        self.nodesInRelativeHorizontal.push(nodeIdLeft);
                                        self.nodeToRelativeConstraintMapHorizontal.set(nodeIdLeft, []);
                                        if (self.dummyToNodeForVerticalAlignment.has(nodeIdLeft)) self.nodeToTempPositionMapHorizontal.set(nodeIdLeft, self.idToNodeMap.get(self.dummyToNodeForVerticalAlignment.get(nodeIdLeft)[0]).getCenterX());
                                        else self.nodeToTempPositionMapHorizontal.set(nodeIdLeft, self.idToNodeMap.get(nodeIdLeft).getCenterX());
                                    }
                                    if (!self.nodesInRelativeHorizontal.includes(nodeIdRight)) {
                                        self.nodesInRelativeHorizontal.push(nodeIdRight);
                                        self.nodeToRelativeConstraintMapHorizontal.set(nodeIdRight, []);
                                        if (self.dummyToNodeForVerticalAlignment.has(nodeIdRight)) self.nodeToTempPositionMapHorizontal.set(nodeIdRight, self.idToNodeMap.get(self.dummyToNodeForVerticalAlignment.get(nodeIdRight)[0]).getCenterX());
                                        else self.nodeToTempPositionMapHorizontal.set(nodeIdRight, self.idToNodeMap.get(nodeIdRight).getCenterX());
                                    }
                                    self.nodeToRelativeConstraintMapHorizontal.get(nodeIdLeft).push({
                                        right: nodeIdRight,
                                        gap: constraint.gap
                                    });
                                    self.nodeToRelativeConstraintMapHorizontal.get(nodeIdRight).push({
                                        left: nodeIdLeft,
                                        gap: constraint.gap
                                    });
                                } else {
                                    var nodeIdTop = nodeToDummyForHorizontalAlignment.has(constraint.top) ? nodeToDummyForHorizontalAlignment.get(constraint.top) : constraint.top;
                                    var nodeIdBottom = nodeToDummyForHorizontalAlignment.has(constraint.bottom) ? nodeToDummyForHorizontalAlignment.get(constraint.bottom) : constraint.bottom;
                                    if (!self.nodesInRelativeVertical.includes(nodeIdTop)) {
                                        self.nodesInRelativeVertical.push(nodeIdTop);
                                        self.nodeToRelativeConstraintMapVertical.set(nodeIdTop, []);
                                        if (self.dummyToNodeForHorizontalAlignment.has(nodeIdTop)) self.nodeToTempPositionMapVertical.set(nodeIdTop, self.idToNodeMap.get(self.dummyToNodeForHorizontalAlignment.get(nodeIdTop)[0]).getCenterY());
                                        else self.nodeToTempPositionMapVertical.set(nodeIdTop, self.idToNodeMap.get(nodeIdTop).getCenterY());
                                    }
                                    if (!self.nodesInRelativeVertical.includes(nodeIdBottom)) {
                                        self.nodesInRelativeVertical.push(nodeIdBottom);
                                        self.nodeToRelativeConstraintMapVertical.set(nodeIdBottom, []);
                                        if (self.dummyToNodeForHorizontalAlignment.has(nodeIdBottom)) self.nodeToTempPositionMapVertical.set(nodeIdBottom, self.idToNodeMap.get(self.dummyToNodeForHorizontalAlignment.get(nodeIdBottom)[0]).getCenterY());
                                        else self.nodeToTempPositionMapVertical.set(nodeIdBottom, self.idToNodeMap.get(nodeIdBottom).getCenterY());
                                    }
                                    self.nodeToRelativeConstraintMapVertical.get(nodeIdTop).push({
                                        bottom: nodeIdBottom,
                                        gap: constraint.gap
                                    });
                                    self.nodeToRelativeConstraintMapVertical.get(nodeIdBottom).push({
                                        top: nodeIdTop,
                                        gap: constraint.gap
                                    });
                                }
                            });
                        } else {
                            var subGraphOnHorizontal = new Map(); // subgraph from vertical RP constraints
                            var subGraphOnVertical = new Map(); // subgraph from vertical RP constraints
                            // construct subgraphs from relative placement constraints 
                            this.constraints.relativePlacementConstraint.forEach(function(constraint) {
                                if (constraint.left) {
                                    var left = nodeToDummyForVerticalAlignment.has(constraint.left) ? nodeToDummyForVerticalAlignment.get(constraint.left) : constraint.left;
                                    var right = nodeToDummyForVerticalAlignment.has(constraint.right) ? nodeToDummyForVerticalAlignment.get(constraint.right) : constraint.right;
                                    if (subGraphOnHorizontal.has(left)) subGraphOnHorizontal.get(left).push(right);
                                    else subGraphOnHorizontal.set(left, [
                                        right
                                    ]);
                                    if (subGraphOnHorizontal.has(right)) subGraphOnHorizontal.get(right).push(left);
                                    else subGraphOnHorizontal.set(right, [
                                        left
                                    ]);
                                } else {
                                    var top = nodeToDummyForHorizontalAlignment.has(constraint.top) ? nodeToDummyForHorizontalAlignment.get(constraint.top) : constraint.top;
                                    var bottom = nodeToDummyForHorizontalAlignment.has(constraint.bottom) ? nodeToDummyForHorizontalAlignment.get(constraint.bottom) : constraint.bottom;
                                    if (subGraphOnVertical.has(top)) subGraphOnVertical.get(top).push(bottom);
                                    else subGraphOnVertical.set(top, [
                                        bottom
                                    ]);
                                    if (subGraphOnVertical.has(bottom)) subGraphOnVertical.get(bottom).push(top);
                                    else subGraphOnVertical.set(bottom, [
                                        top
                                    ]);
                                }
                            });
                            // function to construct components from a given graph 
                            // also returns an array that keeps whether each component contains fixed node
                            var constructComponents = function constructComponents(graph, fixedNodes) {
                                var components = [];
                                var isFixed = [];
                                var queue = new LinkedList();
                                var visited = new Set();
                                var count = 0;
                                graph.forEach(function(value, key) {
                                    if (!visited.has(key)) {
                                        components[count] = [];
                                        isFixed[count] = false;
                                        var currentNode = key;
                                        queue.push(currentNode);
                                        visited.add(currentNode);
                                        components[count].push(currentNode);
                                        while(queue.length != 0){
                                            currentNode = queue.shift();
                                            if (fixedNodes.has(currentNode)) isFixed[count] = true;
                                            var neighbors = graph.get(currentNode);
                                            neighbors.forEach(function(neighbor) {
                                                if (!visited.has(neighbor)) {
                                                    queue.push(neighbor);
                                                    visited.add(neighbor);
                                                    components[count].push(neighbor);
                                                }
                                            });
                                        }
                                        count++;
                                    }
                                });
                                return {
                                    components: components,
                                    isFixed: isFixed
                                };
                            };
                            var resultOnHorizontal = constructComponents(subGraphOnHorizontal, self.fixedNodesOnHorizontal);
                            this.componentsOnHorizontal = resultOnHorizontal.components;
                            this.fixedComponentsOnHorizontal = resultOnHorizontal.isFixed;
                            var resultOnVertical = constructComponents(subGraphOnVertical, self.fixedNodesOnVertical);
                            this.componentsOnVertical = resultOnVertical.components;
                            this.fixedComponentsOnVertical = resultOnVertical.isFixed;
                        }
                    }
                };
                // updates node displacements based on constraints
                CoSELayout.prototype.updateDisplacements = function() {
                    var self = this;
                    if (this.constraints.fixedNodeConstraint) this.constraints.fixedNodeConstraint.forEach(function(nodeData) {
                        var fixedNode = self.idToNodeMap.get(nodeData.nodeId);
                        fixedNode.displacementX = 0;
                        fixedNode.displacementY = 0;
                    });
                    if (this.constraints.alignmentConstraint) {
                        if (this.constraints.alignmentConstraint.vertical) {
                            var allVerticalAlignments = this.constraints.alignmentConstraint.vertical;
                            for(var i = 0; i < allVerticalAlignments.length; i++){
                                var totalDisplacementX = 0;
                                for(var j = 0; j < allVerticalAlignments[i].length; j++){
                                    if (this.fixedNodeSet.has(allVerticalAlignments[i][j])) {
                                        totalDisplacementX = 0;
                                        break;
                                    }
                                    totalDisplacementX += this.idToNodeMap.get(allVerticalAlignments[i][j]).displacementX;
                                }
                                var averageDisplacementX = totalDisplacementX / allVerticalAlignments[i].length;
                                for(var j = 0; j < allVerticalAlignments[i].length; j++)this.idToNodeMap.get(allVerticalAlignments[i][j]).displacementX = averageDisplacementX;
                            }
                        }
                        if (this.constraints.alignmentConstraint.horizontal) {
                            var allHorizontalAlignments = this.constraints.alignmentConstraint.horizontal;
                            for(var i = 0; i < allHorizontalAlignments.length; i++){
                                var totalDisplacementY = 0;
                                for(var j = 0; j < allHorizontalAlignments[i].length; j++){
                                    if (this.fixedNodeSet.has(allHorizontalAlignments[i][j])) {
                                        totalDisplacementY = 0;
                                        break;
                                    }
                                    totalDisplacementY += this.idToNodeMap.get(allHorizontalAlignments[i][j]).displacementY;
                                }
                                var averageDisplacementY = totalDisplacementY / allHorizontalAlignments[i].length;
                                for(var j = 0; j < allHorizontalAlignments[i].length; j++)this.idToNodeMap.get(allHorizontalAlignments[i][j]).displacementY = averageDisplacementY;
                            }
                        }
                    }
                    if (this.constraints.relativePlacementConstraint) {
                        if (CoSEConstants.RELAX_MOVEMENT_ON_CONSTRAINTS) {
                            // shuffle array to randomize node processing order
                            if (this.totalIterations % 10 == 0) {
                                this.shuffle(this.nodesInRelativeHorizontal);
                                this.shuffle(this.nodesInRelativeVertical);
                            }
                            this.nodesInRelativeHorizontal.forEach(function(nodeId) {
                                if (!self.fixedNodesOnHorizontal.has(nodeId)) {
                                    var displacement = 0;
                                    if (self.dummyToNodeForVerticalAlignment.has(nodeId)) displacement = self.idToNodeMap.get(self.dummyToNodeForVerticalAlignment.get(nodeId)[0]).displacementX;
                                    else displacement = self.idToNodeMap.get(nodeId).displacementX;
                                    self.nodeToRelativeConstraintMapHorizontal.get(nodeId).forEach(function(constraint) {
                                        if (constraint.right) {
                                            var diff = self.nodeToTempPositionMapHorizontal.get(constraint.right) - self.nodeToTempPositionMapHorizontal.get(nodeId) - displacement;
                                            if (diff < constraint.gap) displacement -= constraint.gap - diff;
                                        } else {
                                            var diff = self.nodeToTempPositionMapHorizontal.get(nodeId) - self.nodeToTempPositionMapHorizontal.get(constraint.left) + displacement;
                                            if (diff < constraint.gap) displacement += constraint.gap - diff;
                                        }
                                    });
                                    self.nodeToTempPositionMapHorizontal.set(nodeId, self.nodeToTempPositionMapHorizontal.get(nodeId) + displacement);
                                    if (self.dummyToNodeForVerticalAlignment.has(nodeId)) self.dummyToNodeForVerticalAlignment.get(nodeId).forEach(function(nodeId) {
                                        self.idToNodeMap.get(nodeId).displacementX = displacement;
                                    });
                                    else self.idToNodeMap.get(nodeId).displacementX = displacement;
                                }
                            });
                            this.nodesInRelativeVertical.forEach(function(nodeId) {
                                if (!self.fixedNodesOnHorizontal.has(nodeId)) {
                                    var displacement = 0;
                                    if (self.dummyToNodeForHorizontalAlignment.has(nodeId)) displacement = self.idToNodeMap.get(self.dummyToNodeForHorizontalAlignment.get(nodeId)[0]).displacementY;
                                    else displacement = self.idToNodeMap.get(nodeId).displacementY;
                                    self.nodeToRelativeConstraintMapVertical.get(nodeId).forEach(function(constraint) {
                                        if (constraint.bottom) {
                                            var diff = self.nodeToTempPositionMapVertical.get(constraint.bottom) - self.nodeToTempPositionMapVertical.get(nodeId) - displacement;
                                            if (diff < constraint.gap) displacement -= constraint.gap - diff;
                                        } else {
                                            var diff = self.nodeToTempPositionMapVertical.get(nodeId) - self.nodeToTempPositionMapVertical.get(constraint.top) + displacement;
                                            if (diff < constraint.gap) displacement += constraint.gap - diff;
                                        }
                                    });
                                    self.nodeToTempPositionMapVertical.set(nodeId, self.nodeToTempPositionMapVertical.get(nodeId) + displacement);
                                    if (self.dummyToNodeForHorizontalAlignment.has(nodeId)) self.dummyToNodeForHorizontalAlignment.get(nodeId).forEach(function(nodeId) {
                                        self.idToNodeMap.get(nodeId).displacementY = displacement;
                                    });
                                    else self.idToNodeMap.get(nodeId).displacementY = displacement;
                                }
                            });
                        } else {
                            for(var i = 0; i < this.componentsOnHorizontal.length; i++){
                                var component = this.componentsOnHorizontal[i];
                                if (this.fixedComponentsOnHorizontal[i]) {
                                    for(var j = 0; j < component.length; j++)if (this.dummyToNodeForVerticalAlignment.has(component[j])) this.dummyToNodeForVerticalAlignment.get(component[j]).forEach(function(nodeId) {
                                        self.idToNodeMap.get(nodeId).displacementX = 0;
                                    });
                                    else this.idToNodeMap.get(component[j]).displacementX = 0;
                                } else {
                                    var sum = 0;
                                    var count = 0;
                                    for(var j = 0; j < component.length; j++)if (this.dummyToNodeForVerticalAlignment.has(component[j])) {
                                        var actualNodes = this.dummyToNodeForVerticalAlignment.get(component[j]);
                                        sum += actualNodes.length * this.idToNodeMap.get(actualNodes[0]).displacementX;
                                        count += actualNodes.length;
                                    } else {
                                        sum += this.idToNodeMap.get(component[j]).displacementX;
                                        count++;
                                    }
                                    var averageDisplacement = sum / count;
                                    for(var j = 0; j < component.length; j++)if (this.dummyToNodeForVerticalAlignment.has(component[j])) this.dummyToNodeForVerticalAlignment.get(component[j]).forEach(function(nodeId) {
                                        self.idToNodeMap.get(nodeId).displacementX = averageDisplacement;
                                    });
                                    else this.idToNodeMap.get(component[j]).displacementX = averageDisplacement;
                                }
                            }
                            for(var i = 0; i < this.componentsOnVertical.length; i++){
                                var component = this.componentsOnVertical[i];
                                if (this.fixedComponentsOnVertical[i]) {
                                    for(var j = 0; j < component.length; j++)if (this.dummyToNodeForHorizontalAlignment.has(component[j])) this.dummyToNodeForHorizontalAlignment.get(component[j]).forEach(function(nodeId) {
                                        self.idToNodeMap.get(nodeId).displacementY = 0;
                                    });
                                    else this.idToNodeMap.get(component[j]).displacementY = 0;
                                } else {
                                    var sum = 0;
                                    var count = 0;
                                    for(var j = 0; j < component.length; j++)if (this.dummyToNodeForHorizontalAlignment.has(component[j])) {
                                        var actualNodes = this.dummyToNodeForHorizontalAlignment.get(component[j]);
                                        sum += actualNodes.length * this.idToNodeMap.get(actualNodes[0]).displacementY;
                                        count += actualNodes.length;
                                    } else {
                                        sum += this.idToNodeMap.get(component[j]).displacementY;
                                        count++;
                                    }
                                    var averageDisplacement = sum / count;
                                    for(var j = 0; j < component.length; j++)if (this.dummyToNodeForHorizontalAlignment.has(component[j])) this.dummyToNodeForHorizontalAlignment.get(component[j]).forEach(function(nodeId) {
                                        self.idToNodeMap.get(nodeId).displacementY = averageDisplacement;
                                    });
                                    else this.idToNodeMap.get(component[j]).displacementY = averageDisplacement;
                                }
                            }
                        }
                    }
                };
                CoSELayout.prototype.calculateNodesToApplyGravitationTo = function() {
                    var nodeList = [];
                    var graph;
                    var graphs = this.graphManager.getGraphs();
                    var size = graphs.length;
                    var i;
                    for(i = 0; i < size; i++){
                        graph = graphs[i];
                        graph.updateConnected();
                        if (!graph.isConnected) nodeList = nodeList.concat(graph.getNodes());
                    }
                    return nodeList;
                };
                CoSELayout.prototype.createBendpoints = function() {
                    var edges = [];
                    edges = edges.concat(this.graphManager.getAllEdges());
                    var visited = new Set();
                    var i;
                    for(i = 0; i < edges.length; i++){
                        var edge = edges[i];
                        if (!visited.has(edge)) {
                            var source = edge.getSource();
                            var target = edge.getTarget();
                            if (source == target) {
                                edge.getBendpoints().push(new PointD());
                                edge.getBendpoints().push(new PointD());
                                this.createDummyNodesForBendpoints(edge);
                                visited.add(edge);
                            } else {
                                var edgeList = [];
                                edgeList = edgeList.concat(source.getEdgeListToNode(target));
                                edgeList = edgeList.concat(target.getEdgeListToNode(source));
                                if (!visited.has(edgeList[0])) {
                                    if (edgeList.length > 1) {
                                        var k;
                                        for(k = 0; k < edgeList.length; k++){
                                            var multiEdge = edgeList[k];
                                            multiEdge.getBendpoints().push(new PointD());
                                            this.createDummyNodesForBendpoints(multiEdge);
                                        }
                                    }
                                    edgeList.forEach(function(edge) {
                                        visited.add(edge);
                                    });
                                }
                            }
                        }
                        if (visited.size == edges.length) break;
                    }
                };
                CoSELayout.prototype.positionNodesRadially = function(forest) {
                    // We tile the trees to a grid row by row; first tree starts at (0,0)
                    var currentStartingPoint = new Point(0, 0);
                    var numberOfColumns = Math.ceil(Math.sqrt(forest.length));
                    var height = 0;
                    var currentY = 0;
                    var currentX = 0;
                    var point = new PointD(0, 0);
                    for(var i = 0; i < forest.length; i++){
                        if (i % numberOfColumns == 0) {
                            // Start of a new row, make the x coordinate 0, increment the
                            // y coordinate with the max height of the previous row
                            currentX = 0;
                            currentY = height;
                            if (i != 0) currentY += CoSEConstants.DEFAULT_COMPONENT_SEPERATION;
                            height = 0;
                        }
                        var tree = forest[i];
                        // Find the center of the tree
                        var centerNode = Layout.findCenterOfTree(tree);
                        // Set the staring point of the next tree
                        currentStartingPoint.x = currentX;
                        currentStartingPoint.y = currentY;
                        // Do a radial layout starting with the center
                        point = CoSELayout.radialLayout(tree, centerNode, currentStartingPoint);
                        if (point.y > height) height = Math.floor(point.y);
                        currentX = Math.floor(point.x + CoSEConstants.DEFAULT_COMPONENT_SEPERATION);
                    }
                    this.transform(new PointD(LayoutConstants.WORLD_CENTER_X - point.x / 2, LayoutConstants.WORLD_CENTER_Y - point.y / 2));
                };
                CoSELayout.radialLayout = function(tree, centerNode, startingPoint) {
                    var radialSep = Math.max(this.maxDiagonalInTree(tree), CoSEConstants.DEFAULT_RADIAL_SEPARATION);
                    CoSELayout.branchRadialLayout(centerNode, null, 0, 359, 0, radialSep);
                    var bounds = LGraph.calculateBounds(tree);
                    var transform = new Transform();
                    transform.setDeviceOrgX(bounds.getMinX());
                    transform.setDeviceOrgY(bounds.getMinY());
                    transform.setWorldOrgX(startingPoint.x);
                    transform.setWorldOrgY(startingPoint.y);
                    for(var i = 0; i < tree.length; i++){
                        var node = tree[i];
                        node.transform(transform);
                    }
                    var bottomRight = new PointD(bounds.getMaxX(), bounds.getMaxY());
                    return transform.inverseTransformPoint(bottomRight);
                };
                CoSELayout.branchRadialLayout = function(node, parentOfNode, startAngle, endAngle, distance, radialSeparation) {
                    // First, position this node by finding its angle.
                    var halfInterval = (endAngle - startAngle + 1) / 2;
                    if (halfInterval < 0) halfInterval += 180;
                    var nodeAngle = (halfInterval + startAngle) % 360;
                    var teta = nodeAngle * IGeometry.TWO_PI / 360;
                    // Make polar to java cordinate conversion.
                    var cos_teta = Math.cos(teta);
                    var x_ = distance * Math.cos(teta);
                    var y_ = distance * Math.sin(teta);
                    node.setCenter(x_, y_);
                    // Traverse all neighbors of this node and recursively call this
                    // function.
                    var neighborEdges = [];
                    neighborEdges = neighborEdges.concat(node.getEdges());
                    var childCount = neighborEdges.length;
                    if (parentOfNode != null) childCount--;
                    var branchCount = 0;
                    var incEdgesCount = neighborEdges.length;
                    var startIndex;
                    var edges = node.getEdgesBetween(parentOfNode);
                    // If there are multiple edges, prune them until there remains only one
                    // edge.
                    while(edges.length > 1){
                        //neighborEdges.remove(edges.remove(0));
                        var temp = edges[0];
                        edges.splice(0, 1);
                        var index = neighborEdges.indexOf(temp);
                        if (index >= 0) neighborEdges.splice(index, 1);
                        incEdgesCount--;
                        childCount--;
                    }
                    if (parentOfNode != null) //assert edges.length == 1;
                    startIndex = (neighborEdges.indexOf(edges[0]) + 1) % incEdgesCount;
                    else startIndex = 0;
                    var stepAngle = Math.abs(endAngle - startAngle) / childCount;
                    for(var i = startIndex; branchCount != childCount; i = ++i % incEdgesCount){
                        var currentNeighbor = neighborEdges[i].getOtherEnd(node);
                        // Don't back traverse to root node in current tree.
                        if (currentNeighbor == parentOfNode) continue;
                        var childStartAngle = (startAngle + branchCount * stepAngle) % 360;
                        var childEndAngle = (childStartAngle + stepAngle) % 360;
                        CoSELayout.branchRadialLayout(currentNeighbor, node, childStartAngle, childEndAngle, distance + radialSeparation, radialSeparation);
                        branchCount++;
                    }
                };
                CoSELayout.maxDiagonalInTree = function(tree) {
                    var maxDiagonal = Integer.MIN_VALUE;
                    for(var i = 0; i < tree.length; i++){
                        var node = tree[i];
                        var diagonal = node.getDiagonal();
                        if (diagonal > maxDiagonal) maxDiagonal = diagonal;
                    }
                    return maxDiagonal;
                };
                CoSELayout.prototype.calcRepulsionRange = function() {
                    // formula is 2 x (level + 1) x idealEdgeLength
                    return 2 * (this.level + 1) * this.idealEdgeLength;
                };
                // Tiling methods
                // Group zero degree members whose parents are not to be tiled, create dummy parents where needed and fill memberGroups by their dummp parent id's
                CoSELayout.prototype.groupZeroDegreeMembers = function() {
                    var self = this;
                    // array of [parent_id x oneDegreeNode_id]
                    var tempMemberGroups = {}; // A temporary map of parent node and its zero degree members
                    this.memberGroups = {}; // A map of dummy parent node and its zero degree members whose parents are not to be tiled
                    this.idToDummyNode = {}; // A map of id to dummy node 
                    var zeroDegree = []; // List of zero degree nodes whose parents are not to be tiled
                    var allNodes = this.graphManager.getAllNodes();
                    // Fill zero degree list
                    for(var i = 0; i < allNodes.length; i++){
                        var node = allNodes[i];
                        var parent = node.getParent();
                        // If a node has zero degree and its parent is not to be tiled if exists add that node to zeroDegres list
                        if (this.getNodeDegreeWithChildren(node) === 0 && (parent.id == undefined || !this.getToBeTiled(parent))) zeroDegree.push(node);
                    }
                    // Create a map of parent node and its zero degree members
                    for(var i = 0; i < zeroDegree.length; i++){
                        var node = zeroDegree[i]; // Zero degree node itself
                        var p_id = node.getParent().id; // Parent id
                        if (typeof tempMemberGroups[p_id] === "undefined") tempMemberGroups[p_id] = [];
                        tempMemberGroups[p_id] = tempMemberGroups[p_id].concat(node); // Push node to the list belongs to its parent in tempMemberGroups
                    }
                    // If there are at least two nodes at a level, create a dummy compound for them
                    Object.keys(tempMemberGroups).forEach(function(p_id) {
                        if (tempMemberGroups[p_id].length > 1) {
                            var dummyCompoundId = "DummyCompound_" + p_id; // The id of dummy compound which will be created soon
                            self.memberGroups[dummyCompoundId] = tempMemberGroups[p_id]; // Add dummy compound to memberGroups
                            var parent = tempMemberGroups[p_id][0].getParent(); // The parent of zero degree nodes will be the parent of new dummy compound
                            // Create a dummy compound with calculated id
                            var dummyCompound = new CoSENode(self.graphManager);
                            dummyCompound.id = dummyCompoundId;
                            dummyCompound.paddingLeft = parent.paddingLeft || 0;
                            dummyCompound.paddingRight = parent.paddingRight || 0;
                            dummyCompound.paddingBottom = parent.paddingBottom || 0;
                            dummyCompound.paddingTop = parent.paddingTop || 0;
                            self.idToDummyNode[dummyCompoundId] = dummyCompound;
                            var dummyParentGraph = self.getGraphManager().add(self.newGraph(), dummyCompound);
                            var parentGraph = parent.getChild();
                            // Add dummy compound to parent the graph
                            parentGraph.add(dummyCompound);
                            // For each zero degree node in this level remove it from its parent graph and add it to the graph of dummy parent
                            for(var i = 0; i < tempMemberGroups[p_id].length; i++){
                                var node = tempMemberGroups[p_id][i];
                                parentGraph.remove(node);
                                dummyParentGraph.add(node);
                            }
                        }
                    });
                };
                CoSELayout.prototype.clearCompounds = function() {
                    var childGraphMap = {};
                    var idToNode = {};
                    // Get compound ordering by finding the inner one first
                    this.performDFSOnCompounds();
                    for(var i = 0; i < this.compoundOrder.length; i++){
                        idToNode[this.compoundOrder[i].id] = this.compoundOrder[i];
                        childGraphMap[this.compoundOrder[i].id] = [].concat(this.compoundOrder[i].getChild().getNodes());
                        // Remove children of compounds
                        this.graphManager.remove(this.compoundOrder[i].getChild());
                        this.compoundOrder[i].child = null;
                    }
                    this.graphManager.resetAllNodes();
                    // Tile the removed children
                    this.tileCompoundMembers(childGraphMap, idToNode);
                };
                CoSELayout.prototype.clearZeroDegreeMembers = function() {
                    var self = this;
                    var tiledZeroDegreePack = this.tiledZeroDegreePack = [];
                    Object.keys(this.memberGroups).forEach(function(id) {
                        var compoundNode = self.idToDummyNode[id]; // Get the dummy compound
                        tiledZeroDegreePack[id] = self.tileNodes(self.memberGroups[id], compoundNode.paddingLeft + compoundNode.paddingRight);
                        // Set the width and height of the dummy compound as calculated
                        compoundNode.rect.width = tiledZeroDegreePack[id].width;
                        compoundNode.rect.height = tiledZeroDegreePack[id].height;
                        compoundNode.setCenter(tiledZeroDegreePack[id].centerX, tiledZeroDegreePack[id].centerY);
                        // compound left and top margings for labels
                        // when node labels are included, these values may be set to different values below and are used in tilingPostLayout,
                        // otherwise they stay as zero
                        compoundNode.labelMarginLeft = 0;
                        compoundNode.labelMarginTop = 0;
                        // Update compound bounds considering its label properties and set label margins for left and top
                        if (CoSEConstants.NODE_DIMENSIONS_INCLUDE_LABELS) {
                            var width = compoundNode.rect.width;
                            var height = compoundNode.rect.height;
                            if (compoundNode.labelWidth) {
                                if (compoundNode.labelPosHorizontal == "left") {
                                    compoundNode.rect.x -= compoundNode.labelWidth;
                                    compoundNode.setWidth(width + compoundNode.labelWidth);
                                    compoundNode.labelMarginLeft = compoundNode.labelWidth;
                                } else if (compoundNode.labelPosHorizontal == "center" && compoundNode.labelWidth > width) {
                                    compoundNode.rect.x -= (compoundNode.labelWidth - width) / 2;
                                    compoundNode.setWidth(compoundNode.labelWidth);
                                    compoundNode.labelMarginLeft = (compoundNode.labelWidth - width) / 2;
                                } else if (compoundNode.labelPosHorizontal == "right") compoundNode.setWidth(width + compoundNode.labelWidth);
                            }
                            if (compoundNode.labelHeight) {
                                if (compoundNode.labelPosVertical == "top") {
                                    compoundNode.rect.y -= compoundNode.labelHeight;
                                    compoundNode.setHeight(height + compoundNode.labelHeight);
                                    compoundNode.labelMarginTop = compoundNode.labelHeight;
                                } else if (compoundNode.labelPosVertical == "center" && compoundNode.labelHeight > height) {
                                    compoundNode.rect.y -= (compoundNode.labelHeight - height) / 2;
                                    compoundNode.setHeight(compoundNode.labelHeight);
                                    compoundNode.labelMarginTop = (compoundNode.labelHeight - height) / 2;
                                } else if (compoundNode.labelPosVertical == "bottom") compoundNode.setHeight(height + compoundNode.labelHeight);
                            }
                        }
                    });
                };
                CoSELayout.prototype.repopulateCompounds = function() {
                    for(var i = this.compoundOrder.length - 1; i >= 0; i--){
                        var lCompoundNode = this.compoundOrder[i];
                        var id = lCompoundNode.id;
                        var horizontalMargin = lCompoundNode.paddingLeft;
                        var verticalMargin = lCompoundNode.paddingTop;
                        var labelMarginLeft = lCompoundNode.labelMarginLeft;
                        var labelMarginTop = lCompoundNode.labelMarginTop;
                        this.adjustLocations(this.tiledMemberPack[id], lCompoundNode.rect.x, lCompoundNode.rect.y, horizontalMargin, verticalMargin, labelMarginLeft, labelMarginTop);
                    }
                };
                CoSELayout.prototype.repopulateZeroDegreeMembers = function() {
                    var self = this;
                    var tiledPack = this.tiledZeroDegreePack;
                    Object.keys(tiledPack).forEach(function(id) {
                        var compoundNode = self.idToDummyNode[id]; // Get the dummy compound by its id
                        var horizontalMargin = compoundNode.paddingLeft;
                        var verticalMargin = compoundNode.paddingTop;
                        var labelMarginLeft = compoundNode.labelMarginLeft;
                        var labelMarginTop = compoundNode.labelMarginTop;
                        // Adjust the positions of nodes wrt its compound
                        self.adjustLocations(tiledPack[id], compoundNode.rect.x, compoundNode.rect.y, horizontalMargin, verticalMargin, labelMarginLeft, labelMarginTop);
                    });
                };
                CoSELayout.prototype.getToBeTiled = function(node) {
                    var id = node.id;
                    //firstly check the previous results
                    if (this.toBeTiled[id] != null) return this.toBeTiled[id];
                    //only compound nodes are to be tiled
                    var childGraph = node.getChild();
                    if (childGraph == null) {
                        this.toBeTiled[id] = false;
                        return false;
                    }
                    var children = childGraph.getNodes(); // Get the children nodes
                    //a compound node is not to be tiled if all of its compound children are not to be tiled
                    for(var i = 0; i < children.length; i++){
                        var theChild = children[i];
                        if (this.getNodeDegree(theChild) > 0) {
                            this.toBeTiled[id] = false;
                            return false;
                        }
                        //pass the children not having the compound structure
                        if (theChild.getChild() == null) {
                            this.toBeTiled[theChild.id] = false;
                            continue;
                        }
                        if (!this.getToBeTiled(theChild)) {
                            this.toBeTiled[id] = false;
                            return false;
                        }
                    }
                    this.toBeTiled[id] = true;
                    return true;
                };
                // Get degree of a node depending of its edges and independent of its children
                CoSELayout.prototype.getNodeDegree = function(node) {
                    var id = node.id;
                    var edges = node.getEdges();
                    var degree = 0;
                    // For the edges connected
                    for(var i = 0; i < edges.length; i++){
                        var edge = edges[i];
                        if (edge.getSource().id !== edge.getTarget().id) degree = degree + 1;
                    }
                    return degree;
                };
                // Get degree of a node with its children
                CoSELayout.prototype.getNodeDegreeWithChildren = function(node) {
                    var degree = this.getNodeDegree(node);
                    if (node.getChild() == null) return degree;
                    var children = node.getChild().getNodes();
                    for(var i = 0; i < children.length; i++){
                        var child = children[i];
                        degree += this.getNodeDegreeWithChildren(child);
                    }
                    return degree;
                };
                CoSELayout.prototype.performDFSOnCompounds = function() {
                    this.compoundOrder = [];
                    this.fillCompexOrderByDFS(this.graphManager.getRoot().getNodes());
                };
                CoSELayout.prototype.fillCompexOrderByDFS = function(children) {
                    for(var i = 0; i < children.length; i++){
                        var child = children[i];
                        if (child.getChild() != null) this.fillCompexOrderByDFS(child.getChild().getNodes());
                        if (this.getToBeTiled(child)) this.compoundOrder.push(child);
                    }
                };
                /**
* This method places each zero degree member wrt given (x,y) coordinates (top left).
*/ CoSELayout.prototype.adjustLocations = function(organization, x, y, compoundHorizontalMargin, compoundVerticalMargin, compoundLabelMarginLeft, compoundLabelMarginTop) {
                    x += compoundHorizontalMargin + compoundLabelMarginLeft;
                    y += compoundVerticalMargin + compoundLabelMarginTop;
                    var left = x;
                    for(var i = 0; i < organization.rows.length; i++){
                        var row = organization.rows[i];
                        x = left;
                        var maxHeight = 0;
                        for(var j = 0; j < row.length; j++){
                            var lnode = row[j];
                            lnode.rect.x = x; // + lnode.rect.width / 2;
                            lnode.rect.y = y; // + lnode.rect.height / 2;
                            x += lnode.rect.width + organization.horizontalPadding;
                            if (lnode.rect.height > maxHeight) maxHeight = lnode.rect.height;
                        }
                        y += maxHeight + organization.verticalPadding;
                    }
                };
                CoSELayout.prototype.tileCompoundMembers = function(childGraphMap, idToNode) {
                    var self = this;
                    this.tiledMemberPack = [];
                    Object.keys(childGraphMap).forEach(function(id) {
                        // Get the compound node
                        var compoundNode = idToNode[id];
                        self.tiledMemberPack[id] = self.tileNodes(childGraphMap[id], compoundNode.paddingLeft + compoundNode.paddingRight);
                        compoundNode.rect.width = self.tiledMemberPack[id].width;
                        compoundNode.rect.height = self.tiledMemberPack[id].height;
                        compoundNode.setCenter(self.tiledMemberPack[id].centerX, self.tiledMemberPack[id].centerY);
                        // compound left and top margings for labels
                        // when node labels are included, these values may be set to different values below and are used in tilingPostLayout,
                        // otherwise they stay as zero
                        compoundNode.labelMarginLeft = 0;
                        compoundNode.labelMarginTop = 0;
                        // Update compound bounds considering its label properties and set label margins for left and top
                        if (CoSEConstants.NODE_DIMENSIONS_INCLUDE_LABELS) {
                            var width = compoundNode.rect.width;
                            var height = compoundNode.rect.height;
                            if (compoundNode.labelWidth) {
                                if (compoundNode.labelPosHorizontal == "left") {
                                    compoundNode.rect.x -= compoundNode.labelWidth;
                                    compoundNode.setWidth(width + compoundNode.labelWidth);
                                    compoundNode.labelMarginLeft = compoundNode.labelWidth;
                                } else if (compoundNode.labelPosHorizontal == "center" && compoundNode.labelWidth > width) {
                                    compoundNode.rect.x -= (compoundNode.labelWidth - width) / 2;
                                    compoundNode.setWidth(compoundNode.labelWidth);
                                    compoundNode.labelMarginLeft = (compoundNode.labelWidth - width) / 2;
                                } else if (compoundNode.labelPosHorizontal == "right") compoundNode.setWidth(width + compoundNode.labelWidth);
                            }
                            if (compoundNode.labelHeight) {
                                if (compoundNode.labelPosVertical == "top") {
                                    compoundNode.rect.y -= compoundNode.labelHeight;
                                    compoundNode.setHeight(height + compoundNode.labelHeight);
                                    compoundNode.labelMarginTop = compoundNode.labelHeight;
                                } else if (compoundNode.labelPosVertical == "center" && compoundNode.labelHeight > height) {
                                    compoundNode.rect.y -= (compoundNode.labelHeight - height) / 2;
                                    compoundNode.setHeight(compoundNode.labelHeight);
                                    compoundNode.labelMarginTop = (compoundNode.labelHeight - height) / 2;
                                } else if (compoundNode.labelPosVertical == "bottom") compoundNode.setHeight(height + compoundNode.labelHeight);
                            }
                        }
                    });
                };
                CoSELayout.prototype.tileNodes = function(nodes, minWidth) {
                    var horizontalOrg = this.tileNodesByFavoringDim(nodes, minWidth, true);
                    var verticalOrg = this.tileNodesByFavoringDim(nodes, minWidth, false);
                    var horizontalRatio = this.getOrgRatio(horizontalOrg);
                    var verticalRatio = this.getOrgRatio(verticalOrg);
                    var bestOrg;
                    // the best ratio is the one that is closer to 1 since the ratios are already normalized
                    // and the best organization is the one that has the best ratio
                    if (verticalRatio < horizontalRatio) bestOrg = verticalOrg;
                    else bestOrg = horizontalOrg;
                    return bestOrg;
                };
                // get the width/height ratio of the organization that is normalized so that it will not be less than 1
                CoSELayout.prototype.getOrgRatio = function(organization) {
                    // get dimensions and calculate the initial ratio
                    var width = organization.width;
                    var height = organization.height;
                    var ratio = width / height;
                    // if the initial ratio is less then 1 then inverse it
                    if (ratio < 1) ratio = 1 / ratio;
                    // return the normalized ratio
                    return ratio;
                };
                /*
 * Calculates the ideal width for the rows. This method assumes that
 * each node has the same sizes and calculates the ideal row width that
 * approximates a square shaped complex accordingly. However, since nodes would
 * have different sizes some rows would have different sizes and the resulting
 * shape would not be an exact square.
 */ CoSELayout.prototype.calcIdealRowWidth = function(members, favorHorizontalDim) {
                    // To approximate a square shaped complex we need to make complex width equal to complex height.
                    // To achieve this we need to solve the following equation system for hc:
                    // (x + bx) * hc - bx = (y + by) * vc - by, hc * vc = n
                    // where x is the avarage width of the nodes, y is the avarage height of nodes
                    // bx and by are the buffer sizes in horizontal and vertical dimensions accordingly,
                    // hc and vc are the number of rows in horizontal and vertical dimensions
                    // n is number of members.
                    var verticalPadding = CoSEConstants.TILING_PADDING_VERTICAL;
                    var horizontalPadding = CoSEConstants.TILING_PADDING_HORIZONTAL;
                    // number of members
                    var membersSize = members.length;
                    // sum of the width of all members
                    var totalWidth = 0;
                    // sum of the height of all members
                    var totalHeight = 0;
                    var maxWidth = 0;
                    // traverse all members to calculate total width and total height and get the maximum members width
                    members.forEach(function(node) {
                        totalWidth += node.getWidth();
                        totalHeight += node.getHeight();
                        if (node.getWidth() > maxWidth) maxWidth = node.getWidth();
                    });
                    // average width of the members
                    var averageWidth = totalWidth / membersSize;
                    // average height of the members
                    var averageHeight = totalHeight / membersSize;
                    // solving the initial equation system for the hc yields the following second degree equation:
                    // hc^2 * (x+bx) + hc * (by - bx) - n * (y + by) = 0
                    // the delta value to solve the equation above for hc
                    var delta = Math.pow(verticalPadding - horizontalPadding, 2) + 4 * (averageWidth + horizontalPadding) * (averageHeight + verticalPadding) * membersSize;
                    // solve the equation using delta value to calculate the horizontal count
                    // that represents the number of nodes in an ideal row
                    var horizontalCountDouble = (horizontalPadding - verticalPadding + Math.sqrt(delta)) / (2 * (averageWidth + horizontalPadding));
                    // round the calculated horizontal count up or down according to the favored dimension
                    var horizontalCount;
                    if (favorHorizontalDim) {
                        horizontalCount = Math.ceil(horizontalCountDouble);
                        // if horizontalCount count is not a float value then both of rounding to floor and ceil
                        // will yield the same values. Instead of repeating the same calculation try going up
                        // while favoring horizontal dimension in such cases
                        if (horizontalCount == horizontalCountDouble) horizontalCount++;
                    } else horizontalCount = Math.floor(horizontalCountDouble);
                    // ideal width to be calculated
                    var idealWidth = horizontalCount * (averageWidth + horizontalPadding) - horizontalPadding;
                    // if max width is bigger than calculated ideal width reset ideal width to it
                    if (maxWidth > idealWidth) idealWidth = maxWidth;
                    // add the left-right margins to the ideal row width
                    idealWidth += horizontalPadding * 2;
                    // return the ideal row width1
                    return idealWidth;
                };
                CoSELayout.prototype.tileNodesByFavoringDim = function(nodes, minWidth, favorHorizontalDim) {
                    var verticalPadding = CoSEConstants.TILING_PADDING_VERTICAL;
                    var horizontalPadding = CoSEConstants.TILING_PADDING_HORIZONTAL;
                    var tilingCompareBy = CoSEConstants.TILING_COMPARE_BY;
                    var organization = {
                        rows: [],
                        rowWidth: [],
                        rowHeight: [],
                        width: 0,
                        height: minWidth,
                        verticalPadding: verticalPadding,
                        horizontalPadding: horizontalPadding,
                        centerX: 0,
                        centerY: 0
                    };
                    if (tilingCompareBy) organization.idealRowWidth = this.calcIdealRowWidth(nodes, favorHorizontalDim);
                    var getNodeArea = function getNodeArea(n) {
                        return n.rect.width * n.rect.height;
                    };
                    var areaCompareFcn = function areaCompareFcn(n1, n2) {
                        return getNodeArea(n2) - getNodeArea(n1);
                    };
                    // Sort the nodes in descending order of their areas
                    nodes.sort(function(n1, n2) {
                        var cmpBy = areaCompareFcn;
                        if (organization.idealRowWidth) {
                            cmpBy = tilingCompareBy;
                            return cmpBy(n1.id, n2.id);
                        }
                        return cmpBy(n1, n2);
                    });
                    // Create the organization -> calculate compound center
                    var sumCenterX = 0;
                    var sumCenterY = 0;
                    for(var i = 0; i < nodes.length; i++){
                        var lNode = nodes[i];
                        sumCenterX += lNode.getCenterX();
                        sumCenterY += lNode.getCenterY();
                    }
                    organization.centerX = sumCenterX / nodes.length;
                    organization.centerY = sumCenterY / nodes.length;
                    // Create the organization -> tile members
                    for(var i = 0; i < nodes.length; i++){
                        var lNode = nodes[i];
                        if (organization.rows.length == 0) this.insertNodeToRow(organization, lNode, 0, minWidth);
                        else if (this.canAddHorizontal(organization, lNode.rect.width, lNode.rect.height)) {
                            var rowIndex = organization.rows.length - 1;
                            if (!organization.idealRowWidth) rowIndex = this.getShortestRowIndex(organization);
                            this.insertNodeToRow(organization, lNode, rowIndex, minWidth);
                        } else this.insertNodeToRow(organization, lNode, organization.rows.length, minWidth);
                        this.shiftToLastRow(organization);
                    }
                    return organization;
                };
                CoSELayout.prototype.insertNodeToRow = function(organization, node, rowIndex, minWidth) {
                    var minCompoundSize = minWidth;
                    // Add new row if needed
                    if (rowIndex == organization.rows.length) {
                        var secondDimension = [];
                        organization.rows.push(secondDimension);
                        organization.rowWidth.push(minCompoundSize);
                        organization.rowHeight.push(0);
                    }
                    // Update row width
                    var w = organization.rowWidth[rowIndex] + node.rect.width;
                    if (organization.rows[rowIndex].length > 0) w += organization.horizontalPadding;
                    organization.rowWidth[rowIndex] = w;
                    // Update compound width
                    if (organization.width < w) organization.width = w;
                    // Update height
                    var h = node.rect.height;
                    if (rowIndex > 0) h += organization.verticalPadding;
                    var extraHeight = 0;
                    if (h > organization.rowHeight[rowIndex]) {
                        extraHeight = organization.rowHeight[rowIndex];
                        organization.rowHeight[rowIndex] = h;
                        extraHeight = organization.rowHeight[rowIndex] - extraHeight;
                    }
                    organization.height += extraHeight;
                    // Insert node
                    organization.rows[rowIndex].push(node);
                };
                //Scans the rows of an organization and returns the one with the min width
                CoSELayout.prototype.getShortestRowIndex = function(organization) {
                    var r = -1;
                    var min = Number.MAX_VALUE;
                    for(var i = 0; i < organization.rows.length; i++)if (organization.rowWidth[i] < min) {
                        r = i;
                        min = organization.rowWidth[i];
                    }
                    return r;
                };
                //Scans the rows of an organization and returns the one with the max width
                CoSELayout.prototype.getLongestRowIndex = function(organization) {
                    var r = -1;
                    var max = Number.MIN_VALUE;
                    for(var i = 0; i < organization.rows.length; i++)if (organization.rowWidth[i] > max) {
                        r = i;
                        max = organization.rowWidth[i];
                    }
                    return r;
                };
                /**
* This method checks whether adding extra width to the organization violates
* the aspect ratio(1) or not.
*/ CoSELayout.prototype.canAddHorizontal = function(organization, extraWidth, extraHeight) {
                    // if there is an ideal row width specified use it instead of checking the aspect ratio
                    if (organization.idealRowWidth) {
                        var lastRowIndex = organization.rows.length - 1;
                        var lastRowWidth = organization.rowWidth[lastRowIndex];
                        // check and return if ideal row width will be exceed if the node is added to the row
                        return lastRowWidth + extraWidth + organization.horizontalPadding <= organization.idealRowWidth;
                    }
                    var sri = this.getShortestRowIndex(organization);
                    if (sri < 0) return true;
                    var min = organization.rowWidth[sri];
                    if (min + organization.horizontalPadding + extraWidth <= organization.width) return true;
                    var hDiff = 0;
                    // Adding to an existing row
                    if (organization.rowHeight[sri] < extraHeight) {
                        if (sri > 0) hDiff = extraHeight + organization.verticalPadding - organization.rowHeight[sri];
                    }
                    var add_to_row_ratio;
                    if (organization.width - min >= extraWidth + organization.horizontalPadding) add_to_row_ratio = (organization.height + hDiff) / (min + extraWidth + organization.horizontalPadding);
                    else add_to_row_ratio = (organization.height + hDiff) / organization.width;
                    // Adding a new row for this node
                    hDiff = extraHeight + organization.verticalPadding;
                    var add_new_row_ratio;
                    if (organization.width < extraWidth) add_new_row_ratio = (organization.height + hDiff) / extraWidth;
                    else add_new_row_ratio = (organization.height + hDiff) / organization.width;
                    if (add_new_row_ratio < 1) add_new_row_ratio = 1 / add_new_row_ratio;
                    if (add_to_row_ratio < 1) add_to_row_ratio = 1 / add_to_row_ratio;
                    return add_to_row_ratio < add_new_row_ratio;
                };
                //If moving the last node from the longest row and adding it to the last
                //row makes the bounding box smaller, do it.
                CoSELayout.prototype.shiftToLastRow = function(organization) {
                    var longest = this.getLongestRowIndex(organization);
                    var last = organization.rowWidth.length - 1;
                    var row = organization.rows[longest];
                    var node = row[row.length - 1];
                    var diff = node.width + organization.horizontalPadding;
                    // Check if there is enough space on the last row
                    if (organization.width - organization.rowWidth[last] > diff && longest != last) {
                        // Remove the last element of the longest row
                        row.splice(-1, 1);
                        // Push it to the last row
                        organization.rows[last].push(node);
                        organization.rowWidth[longest] = organization.rowWidth[longest] - diff;
                        organization.rowWidth[last] = organization.rowWidth[last] + diff;
                        organization.width = organization.rowWidth[instance.getLongestRowIndex(organization)];
                        // Update heights of the organization
                        var maxHeight = Number.MIN_VALUE;
                        for(var i = 0; i < row.length; i++)if (row[i].height > maxHeight) maxHeight = row[i].height;
                        if (longest > 0) maxHeight += organization.verticalPadding;
                        var prevTotal = organization.rowHeight[longest] + organization.rowHeight[last];
                        organization.rowHeight[longest] = maxHeight;
                        if (organization.rowHeight[last] < node.height + organization.verticalPadding) organization.rowHeight[last] = node.height + organization.verticalPadding;
                        var finalTotal = organization.rowHeight[longest] + organization.rowHeight[last];
                        organization.height += finalTotal - prevTotal;
                        this.shiftToLastRow(organization);
                    }
                };
                CoSELayout.prototype.tilingPreLayout = function() {
                    if (CoSEConstants.TILE) {
                        // Find zero degree nodes and create a compound for each level
                        this.groupZeroDegreeMembers();
                        // Tile and clear children of each compound
                        this.clearCompounds();
                        // Separately tile and clear zero degree nodes for each level
                        this.clearZeroDegreeMembers();
                    }
                };
                CoSELayout.prototype.tilingPostLayout = function() {
                    if (CoSEConstants.TILE) {
                        this.repopulateZeroDegreeMembers();
                        this.repopulateCompounds();
                    }
                };
                // -----------------------------------------------------------------------------
                // Section: Tree Reduction methods
                // -----------------------------------------------------------------------------
                // Reduce trees 
                CoSELayout.prototype.reduceTrees = function() {
                    var prunedNodesAll = [];
                    var containsLeaf = true;
                    var node;
                    while(containsLeaf){
                        var allNodes = this.graphManager.getAllNodes();
                        var prunedNodesInStepTemp = [];
                        containsLeaf = false;
                        for(var i = 0; i < allNodes.length; i++){
                            node = allNodes[i];
                            if (node.getEdges().length == 1 && !node.getEdges()[0].isInterGraph && node.getChild() == null) {
                                if (CoSEConstants.PURE_INCREMENTAL) {
                                    var otherEnd = node.getEdges()[0].getOtherEnd(node);
                                    var relativePosition = new DimensionD(node.getCenterX() - otherEnd.getCenterX(), node.getCenterY() - otherEnd.getCenterY());
                                    prunedNodesInStepTemp.push([
                                        node,
                                        node.getEdges()[0],
                                        node.getOwner(),
                                        relativePosition
                                    ]);
                                } else prunedNodesInStepTemp.push([
                                    node,
                                    node.getEdges()[0],
                                    node.getOwner()
                                ]);
                                containsLeaf = true;
                            }
                        }
                        if (containsLeaf == true) {
                            var prunedNodesInStep = [];
                            for(var j = 0; j < prunedNodesInStepTemp.length; j++)if (prunedNodesInStepTemp[j][0].getEdges().length == 1) {
                                prunedNodesInStep.push(prunedNodesInStepTemp[j]);
                                prunedNodesInStepTemp[j][0].getOwner().remove(prunedNodesInStepTemp[j][0]);
                            }
                            prunedNodesAll.push(prunedNodesInStep);
                            this.graphManager.resetAllNodes();
                            this.graphManager.resetAllEdges();
                        }
                    }
                    this.prunedNodesAll = prunedNodesAll;
                };
                // Grow tree one step 
                CoSELayout.prototype.growTree = function(prunedNodesAll) {
                    var lengthOfPrunedNodesInStep = prunedNodesAll.length;
                    var prunedNodesInStep = prunedNodesAll[lengthOfPrunedNodesInStep - 1];
                    var nodeData;
                    for(var i = 0; i < prunedNodesInStep.length; i++){
                        nodeData = prunedNodesInStep[i];
                        this.findPlaceforPrunedNode(nodeData);
                        nodeData[2].add(nodeData[0]);
                        nodeData[2].add(nodeData[1], nodeData[1].source, nodeData[1].target);
                    }
                    prunedNodesAll.splice(prunedNodesAll.length - 1, 1);
                    this.graphManager.resetAllNodes();
                    this.graphManager.resetAllEdges();
                };
                // Find an appropriate position to replace pruned node, this method can be improved
                CoSELayout.prototype.findPlaceforPrunedNode = function(nodeData) {
                    var gridForPrunedNode;
                    var nodeToConnect;
                    var prunedNode = nodeData[0];
                    if (prunedNode == nodeData[1].source) nodeToConnect = nodeData[1].target;
                    else nodeToConnect = nodeData[1].source;
                    if (CoSEConstants.PURE_INCREMENTAL) prunedNode.setCenter(nodeToConnect.getCenterX() + nodeData[3].getWidth(), nodeToConnect.getCenterY() + nodeData[3].getHeight());
                    else {
                        var startGridX = nodeToConnect.startX;
                        var finishGridX = nodeToConnect.finishX;
                        var startGridY = nodeToConnect.startY;
                        var finishGridY = nodeToConnect.finishY;
                        var upNodeCount = 0;
                        var downNodeCount = 0;
                        var rightNodeCount = 0;
                        var leftNodeCount = 0;
                        var controlRegions = [
                            upNodeCount,
                            rightNodeCount,
                            downNodeCount,
                            leftNodeCount
                        ];
                        if (startGridY > 0) for(var i = startGridX; i <= finishGridX; i++)controlRegions[0] += this.grid[i][startGridY - 1].length + this.grid[i][startGridY].length - 1;
                        if (finishGridX < this.grid.length - 1) for(var i = startGridY; i <= finishGridY; i++)controlRegions[1] += this.grid[finishGridX + 1][i].length + this.grid[finishGridX][i].length - 1;
                        if (finishGridY < this.grid[0].length - 1) for(var i = startGridX; i <= finishGridX; i++)controlRegions[2] += this.grid[i][finishGridY + 1].length + this.grid[i][finishGridY].length - 1;
                        if (startGridX > 0) for(var i = startGridY; i <= finishGridY; i++)controlRegions[3] += this.grid[startGridX - 1][i].length + this.grid[startGridX][i].length - 1;
                        var min = Integer.MAX_VALUE;
                        var minCount;
                        var minIndex;
                        for(var j = 0; j < controlRegions.length; j++){
                            if (controlRegions[j] < min) {
                                min = controlRegions[j];
                                minCount = 1;
                                minIndex = j;
                            } else if (controlRegions[j] == min) minCount++;
                        }
                        if (minCount == 3 && min == 0) {
                            if (controlRegions[0] == 0 && controlRegions[1] == 0 && controlRegions[2] == 0) gridForPrunedNode = 1;
                            else if (controlRegions[0] == 0 && controlRegions[1] == 0 && controlRegions[3] == 0) gridForPrunedNode = 0;
                            else if (controlRegions[0] == 0 && controlRegions[2] == 0 && controlRegions[3] == 0) gridForPrunedNode = 3;
                            else if (controlRegions[1] == 0 && controlRegions[2] == 0 && controlRegions[3] == 0) gridForPrunedNode = 2;
                        } else if (minCount == 2 && min == 0) {
                            var random = Math.floor(Math.random() * 2);
                            if (controlRegions[0] == 0 && controlRegions[1] == 0) {
                                if (random == 0) gridForPrunedNode = 0;
                                else gridForPrunedNode = 1;
                            } else if (controlRegions[0] == 0 && controlRegions[2] == 0) {
                                if (random == 0) gridForPrunedNode = 0;
                                else gridForPrunedNode = 2;
                            } else if (controlRegions[0] == 0 && controlRegions[3] == 0) {
                                if (random == 0) gridForPrunedNode = 0;
                                else gridForPrunedNode = 3;
                            } else if (controlRegions[1] == 0 && controlRegions[2] == 0) {
                                if (random == 0) gridForPrunedNode = 1;
                                else gridForPrunedNode = 2;
                            } else if (controlRegions[1] == 0 && controlRegions[3] == 0) {
                                if (random == 0) gridForPrunedNode = 1;
                                else gridForPrunedNode = 3;
                            } else if (random == 0) gridForPrunedNode = 2;
                            else gridForPrunedNode = 3;
                        } else if (minCount == 4 && min == 0) {
                            var random = Math.floor(Math.random() * 4);
                            gridForPrunedNode = random;
                        } else gridForPrunedNode = minIndex;
                        if (gridForPrunedNode == 0) prunedNode.setCenter(nodeToConnect.getCenterX(), nodeToConnect.getCenterY() - nodeToConnect.getHeight() / 2 - FDLayoutConstants.DEFAULT_EDGE_LENGTH - prunedNode.getHeight() / 2);
                        else if (gridForPrunedNode == 1) prunedNode.setCenter(nodeToConnect.getCenterX() + nodeToConnect.getWidth() / 2 + FDLayoutConstants.DEFAULT_EDGE_LENGTH + prunedNode.getWidth() / 2, nodeToConnect.getCenterY());
                        else if (gridForPrunedNode == 2) prunedNode.setCenter(nodeToConnect.getCenterX(), nodeToConnect.getCenterY() + nodeToConnect.getHeight() / 2 + FDLayoutConstants.DEFAULT_EDGE_LENGTH + prunedNode.getHeight() / 2);
                        else prunedNode.setCenter(nodeToConnect.getCenterX() - nodeToConnect.getWidth() / 2 - FDLayoutConstants.DEFAULT_EDGE_LENGTH - prunedNode.getWidth() / 2, nodeToConnect.getCenterY());
                    }
                };
                module1.exports = CoSELayout;
            /***/ },
            /***/ 991: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                var FDLayoutNode = __webpack_require__(551).FDLayoutNode;
                var IMath = __webpack_require__(551).IMath;
                function CoSENode(gm, loc, size, vNode) {
                    FDLayoutNode.call(this, gm, loc, size, vNode);
                }
                CoSENode.prototype = Object.create(FDLayoutNode.prototype);
                for(var prop in FDLayoutNode)CoSENode[prop] = FDLayoutNode[prop];
                CoSENode.prototype.calculateDisplacement = function() {
                    var layout = this.graphManager.getLayout();
                    // this check is for compound nodes that contain fixed nodes
                    if (this.getChild() != null && this.fixedNodeWeight) {
                        this.displacementX += layout.coolingFactor * (this.springForceX + this.repulsionForceX + this.gravitationForceX) / this.fixedNodeWeight;
                        this.displacementY += layout.coolingFactor * (this.springForceY + this.repulsionForceY + this.gravitationForceY) / this.fixedNodeWeight;
                    } else {
                        this.displacementX += layout.coolingFactor * (this.springForceX + this.repulsionForceX + this.gravitationForceX) / this.noOfChildren;
                        this.displacementY += layout.coolingFactor * (this.springForceY + this.repulsionForceY + this.gravitationForceY) / this.noOfChildren;
                    }
                    if (Math.abs(this.displacementX) > layout.coolingFactor * layout.maxNodeDisplacement) this.displacementX = layout.coolingFactor * layout.maxNodeDisplacement * IMath.sign(this.displacementX);
                    if (Math.abs(this.displacementY) > layout.coolingFactor * layout.maxNodeDisplacement) this.displacementY = layout.coolingFactor * layout.maxNodeDisplacement * IMath.sign(this.displacementY);
                    // non-empty compound node, propogate movement to children as well
                    if (this.child && this.child.getNodes().length > 0) this.propogateDisplacementToChildren(this.displacementX, this.displacementY);
                };
                CoSENode.prototype.propogateDisplacementToChildren = function(dX, dY) {
                    var nodes = this.getChild().getNodes();
                    var node;
                    for(var i = 0; i < nodes.length; i++){
                        node = nodes[i];
                        if (node.getChild() == null) {
                            node.displacementX += dX;
                            node.displacementY += dY;
                        } else node.propogateDisplacementToChildren(dX, dY);
                    }
                };
                CoSENode.prototype.move = function() {
                    var layout = this.graphManager.getLayout();
                    // a simple node or an empty compound node, move it
                    if (this.child == null || this.child.getNodes().length == 0) {
                        this.moveBy(this.displacementX, this.displacementY);
                        layout.totalDisplacement += Math.abs(this.displacementX) + Math.abs(this.displacementY);
                    }
                    this.springForceX = 0;
                    this.springForceY = 0;
                    this.repulsionForceX = 0;
                    this.repulsionForceY = 0;
                    this.gravitationForceX = 0;
                    this.gravitationForceY = 0;
                    this.displacementX = 0;
                    this.displacementY = 0;
                };
                CoSENode.prototype.setPred1 = function(pred11) {
                    this.pred1 = pred11;
                };
                CoSENode.prototype.getPred1 = function() {
                    return pred1;
                };
                CoSENode.prototype.getPred2 = function() {
                    return pred2;
                };
                CoSENode.prototype.setNext = function(next1) {
                    this.next = next1;
                };
                CoSENode.prototype.getNext = function() {
                    return next;
                };
                CoSENode.prototype.setProcessed = function(processed1) {
                    this.processed = processed1;
                };
                CoSENode.prototype.isProcessed = function() {
                    return processed;
                };
                module1.exports = CoSENode;
            /***/ },
            /***/ 902: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                function _toConsumableArray(arr) {
                    if (Array.isArray(arr)) {
                        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                        return arr2;
                    } else return Array.from(arr);
                }
                var CoSEConstants = __webpack_require__(806);
                var LinkedList = __webpack_require__(551).LinkedList;
                var Matrix = __webpack_require__(551).Matrix;
                var SVD = __webpack_require__(551).SVD;
                function ConstraintHandler() {}
                ConstraintHandler.handleConstraints = function(layout) {
                    //  let layout = this.graphManager.getLayout();
                    // get constraints from layout
                    var constraints = {};
                    constraints.fixedNodeConstraint = layout.constraints.fixedNodeConstraint;
                    constraints.alignmentConstraint = layout.constraints.alignmentConstraint;
                    constraints.relativePlacementConstraint = layout.constraints.relativePlacementConstraint;
                    var idToNodeMap = new Map();
                    var nodeIndexes = new Map();
                    var xCoords = [];
                    var yCoords = [];
                    var allNodes = layout.getAllNodes();
                    var index = 0;
                    // fill index map and coordinates
                    for(var i = 0; i < allNodes.length; i++){
                        var node = allNodes[i];
                        if (node.getChild() == null) {
                            nodeIndexes.set(node.id, index++);
                            xCoords.push(node.getCenterX());
                            yCoords.push(node.getCenterY());
                            idToNodeMap.set(node.id, node);
                        }
                    }
                    // if there exists relative placement constraint without gap value, set it to default 
                    if (constraints.relativePlacementConstraint) constraints.relativePlacementConstraint.forEach(function(constraint) {
                        if (!constraint.gap && constraint.gap != 0) {
                            if (constraint.left) constraint.gap = CoSEConstants.DEFAULT_EDGE_LENGTH + idToNodeMap.get(constraint.left).getWidth() / 2 + idToNodeMap.get(constraint.right).getWidth() / 2;
                            else constraint.gap = CoSEConstants.DEFAULT_EDGE_LENGTH + idToNodeMap.get(constraint.top).getHeight() / 2 + idToNodeMap.get(constraint.bottom).getHeight() / 2;
                        }
                    });
                    /* auxiliary functions */ // calculate difference between two position objects
                    var calculatePositionDiff = function calculatePositionDiff(pos1, pos2) {
                        return {
                            x: pos1.x - pos2.x,
                            y: pos1.y - pos2.y
                        };
                    };
                    // calculate average position of the nodes
                    var calculateAvgPosition = function calculateAvgPosition(nodeIdSet) {
                        var xPosSum = 0;
                        var yPosSum = 0;
                        nodeIdSet.forEach(function(nodeId) {
                            xPosSum += xCoords[nodeIndexes.get(nodeId)];
                            yPosSum += yCoords[nodeIndexes.get(nodeId)];
                        });
                        return {
                            x: xPosSum / nodeIdSet.size,
                            y: yPosSum / nodeIdSet.size
                        };
                    };
                    // find an appropriate positioning for the nodes in a given graph according to relative placement constraints
                    // this function also takes the fixed nodes and alignment constraints into account
                    // graph: dag to be evaluated, direction: "horizontal" or "vertical", 
                    // fixedNodes: set of fixed nodes to consider during evaluation, dummyPositions: appropriate coordinates of the dummy nodes  
                    var findAppropriatePositionForRelativePlacement = function findAppropriatePositionForRelativePlacement(graph, direction, fixedNodes, dummyPositions, componentSources) {
                        // find union of two sets
                        function setUnion(setA, setB) {
                            var union = new Set(setA);
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = setB[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var elem = _step.value;
                                    union.add(elem);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            return union;
                        }
                        // find indegree count for each node
                        var inDegrees = new Map();
                        graph.forEach(function(value, key) {
                            inDegrees.set(key, 0);
                        });
                        graph.forEach(function(value, key) {
                            value.forEach(function(adjacent) {
                                inDegrees.set(adjacent.id, inDegrees.get(adjacent.id) + 1);
                            });
                        });
                        var positionMap = new Map(); // keeps the position for each node
                        var pastMap = new Map(); // keeps the predecessors(past) of a node
                        var queue = new LinkedList();
                        inDegrees.forEach(function(value, key) {
                            if (value == 0) {
                                queue.push(key);
                                if (!fixedNodes) {
                                    if (direction == "horizontal") positionMap.set(key, nodeIndexes.has(key) ? xCoords[nodeIndexes.get(key)] : dummyPositions.get(key));
                                    else positionMap.set(key, nodeIndexes.has(key) ? yCoords[nodeIndexes.get(key)] : dummyPositions.get(key));
                                }
                            } else positionMap.set(key, Number.NEGATIVE_INFINITY);
                            if (fixedNodes) pastMap.set(key, new Set([
                                key
                            ]));
                        });
                        // align sources of each component in enforcement phase
                        if (fixedNodes) componentSources.forEach(function(component) {
                            var fixedIds = [];
                            component.forEach(function(nodeId) {
                                if (fixedNodes.has(nodeId)) fixedIds.push(nodeId);
                            });
                            if (fixedIds.length > 0) {
                                var position = 0;
                                fixedIds.forEach(function(fixedId) {
                                    if (direction == "horizontal") {
                                        positionMap.set(fixedId, nodeIndexes.has(fixedId) ? xCoords[nodeIndexes.get(fixedId)] : dummyPositions.get(fixedId));
                                        position += positionMap.get(fixedId);
                                    } else {
                                        positionMap.set(fixedId, nodeIndexes.has(fixedId) ? yCoords[nodeIndexes.get(fixedId)] : dummyPositions.get(fixedId));
                                        position += positionMap.get(fixedId);
                                    }
                                });
                                position = position / fixedIds.length;
                                component.forEach(function(nodeId) {
                                    if (!fixedNodes.has(nodeId)) positionMap.set(nodeId, position);
                                });
                            } else {
                                var _position = 0;
                                component.forEach(function(nodeId) {
                                    if (direction == "horizontal") _position += nodeIndexes.has(nodeId) ? xCoords[nodeIndexes.get(nodeId)] : dummyPositions.get(nodeId);
                                    else _position += nodeIndexes.has(nodeId) ? yCoords[nodeIndexes.get(nodeId)] : dummyPositions.get(nodeId);
                                });
                                _position = _position / component.length;
                                component.forEach(function(nodeId) {
                                    positionMap.set(nodeId, _position);
                                });
                            }
                        });
                        // calculate positions of the nodes
                        var _loop = function _loop() {
                            var currentNode = queue.shift();
                            var neighbors = graph.get(currentNode);
                            neighbors.forEach(function(neighbor) {
                                if (positionMap.get(neighbor.id) < positionMap.get(currentNode) + neighbor.gap) {
                                    if (fixedNodes && fixedNodes.has(neighbor.id)) {
                                        var fixedPosition = void 0;
                                        if (direction == "horizontal") fixedPosition = nodeIndexes.has(neighbor.id) ? xCoords[nodeIndexes.get(neighbor.id)] : dummyPositions.get(neighbor.id);
                                        else fixedPosition = nodeIndexes.has(neighbor.id) ? yCoords[nodeIndexes.get(neighbor.id)] : dummyPositions.get(neighbor.id);
                                        positionMap.set(neighbor.id, fixedPosition); // TODO: may do unnecessary work
                                        if (fixedPosition < positionMap.get(currentNode) + neighbor.gap) {
                                            var diff = positionMap.get(currentNode) + neighbor.gap - fixedPosition;
                                            pastMap.get(currentNode).forEach(function(nodeId) {
                                                positionMap.set(nodeId, positionMap.get(nodeId) - diff);
                                            });
                                        }
                                    } else positionMap.set(neighbor.id, positionMap.get(currentNode) + neighbor.gap);
                                }
                                inDegrees.set(neighbor.id, inDegrees.get(neighbor.id) - 1);
                                if (inDegrees.get(neighbor.id) == 0) queue.push(neighbor.id);
                                if (fixedNodes) pastMap.set(neighbor.id, setUnion(pastMap.get(currentNode), pastMap.get(neighbor.id)));
                            });
                        };
                        while(queue.length != 0)_loop();
                        // readjust position of the nodes after enforcement
                        if (fixedNodes) {
                            // find indegree count for each node
                            var sinkNodes = new Set();
                            graph.forEach(function(value, key) {
                                if (value.length == 0) sinkNodes.add(key);
                            });
                            var _components = [];
                            pastMap.forEach(function(value, key) {
                                if (sinkNodes.has(key)) {
                                    var isFixedComponent = false;
                                    var _iteratorNormalCompletion2 = true;
                                    var _didIteratorError2 = false;
                                    var _iteratorError2 = undefined;
                                    try {
                                        for(var _iterator2 = value[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                            var nodeId = _step2.value;
                                            if (fixedNodes.has(nodeId)) isFixedComponent = true;
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                                        } finally{
                                            if (_didIteratorError2) throw _iteratorError2;
                                        }
                                    }
                                    if (!isFixedComponent) {
                                        var isExist = false;
                                        var existAt = void 0;
                                        _components.forEach(function(component, index) {
                                            if (component.has([].concat(_toConsumableArray(value))[0])) {
                                                isExist = true;
                                                existAt = index;
                                            }
                                        });
                                        if (!isExist) _components.push(new Set(value));
                                        else value.forEach(function(ele) {
                                            _components[existAt].add(ele);
                                        });
                                    }
                                }
                            });
                            _components.forEach(function(component, index) {
                                var minBefore = Number.POSITIVE_INFINITY;
                                var minAfter = Number.POSITIVE_INFINITY;
                                var maxBefore = Number.NEGATIVE_INFINITY;
                                var maxAfter = Number.NEGATIVE_INFINITY;
                                var _iteratorNormalCompletion3 = true;
                                var _didIteratorError3 = false;
                                var _iteratorError3 = undefined;
                                try {
                                    for(var _iterator3 = component[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                        var nodeId = _step3.value;
                                        var posBefore = void 0;
                                        if (direction == "horizontal") posBefore = nodeIndexes.has(nodeId) ? xCoords[nodeIndexes.get(nodeId)] : dummyPositions.get(nodeId);
                                        else posBefore = nodeIndexes.has(nodeId) ? yCoords[nodeIndexes.get(nodeId)] : dummyPositions.get(nodeId);
                                        var posAfter = positionMap.get(nodeId);
                                        if (posBefore < minBefore) minBefore = posBefore;
                                        if (posBefore > maxBefore) maxBefore = posBefore;
                                        if (posAfter < minAfter) minAfter = posAfter;
                                        if (posAfter > maxAfter) maxAfter = posAfter;
                                    }
                                } catch (err) {
                                    _didIteratorError3 = true;
                                    _iteratorError3 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion3 && _iterator3.return) _iterator3.return();
                                    } finally{
                                        if (_didIteratorError3) throw _iteratorError3;
                                    }
                                }
                                var diff = (minBefore + maxBefore) / 2 - (minAfter + maxAfter) / 2;
                                var _iteratorNormalCompletion4 = true;
                                var _didIteratorError4 = false;
                                var _iteratorError4 = undefined;
                                try {
                                    for(var _iterator4 = component[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                                        var _nodeId = _step4.value;
                                        positionMap.set(_nodeId, positionMap.get(_nodeId) + diff);
                                    }
                                } catch (err) {
                                    _didIteratorError4 = true;
                                    _iteratorError4 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion4 && _iterator4.return) _iterator4.return();
                                    } finally{
                                        if (_didIteratorError4) throw _iteratorError4;
                                    }
                                }
                            });
                        }
                        return positionMap;
                    };
                    // find transformation based on rel. placement constraints if there are both alignment and rel. placement constraints
                    // or if there are only rel. placement contraints where the largest component isn't sufficiently large
                    var applyReflectionForRelativePlacement = function applyReflectionForRelativePlacement(relativePlacementConstraints) {
                        // variables to count votes
                        var reflectOnY = 0, notReflectOnY = 0;
                        var reflectOnX = 0, notReflectOnX = 0;
                        relativePlacementConstraints.forEach(function(constraint) {
                            if (constraint.left) xCoords[nodeIndexes.get(constraint.left)] - xCoords[nodeIndexes.get(constraint.right)] >= 0 ? reflectOnY++ : notReflectOnY++;
                            else yCoords[nodeIndexes.get(constraint.top)] - yCoords[nodeIndexes.get(constraint.bottom)] >= 0 ? reflectOnX++ : notReflectOnX++;
                        });
                        if (reflectOnY > notReflectOnY && reflectOnX > notReflectOnX) for(var _i = 0; _i < nodeIndexes.size; _i++){
                            xCoords[_i] = -1 * xCoords[_i];
                            yCoords[_i] = -1 * yCoords[_i];
                        }
                        else if (reflectOnY > notReflectOnY) for(var _i2 = 0; _i2 < nodeIndexes.size; _i2++)xCoords[_i2] = -1 * xCoords[_i2];
                        else if (reflectOnX > notReflectOnX) for(var _i3 = 0; _i3 < nodeIndexes.size; _i3++)yCoords[_i3] = -1 * yCoords[_i3];
                    };
                    // find weakly connected components in undirected graph
                    var findComponents = function findComponents(graph) {
                        // find weakly connected components in dag
                        var components = [];
                        var queue = new LinkedList();
                        var visited = new Set();
                        var count = 0;
                        graph.forEach(function(value, key) {
                            if (!visited.has(key)) {
                                components[count] = [];
                                var _currentNode = key;
                                queue.push(_currentNode);
                                visited.add(_currentNode);
                                components[count].push(_currentNode);
                                while(queue.length != 0){
                                    _currentNode = queue.shift();
                                    var neighbors = graph.get(_currentNode);
                                    neighbors.forEach(function(neighbor) {
                                        if (!visited.has(neighbor.id)) {
                                            queue.push(neighbor.id);
                                            visited.add(neighbor.id);
                                            components[count].push(neighbor.id);
                                        }
                                    });
                                }
                                count++;
                            }
                        });
                        return components;
                    };
                    // return undirected version of given dag
                    var dagToUndirected = function dagToUndirected(dag) {
                        var undirected = new Map();
                        dag.forEach(function(value, key) {
                            undirected.set(key, []);
                        });
                        dag.forEach(function(value, key) {
                            value.forEach(function(adjacent) {
                                undirected.get(key).push(adjacent);
                                undirected.get(adjacent.id).push({
                                    id: key,
                                    gap: adjacent.gap,
                                    direction: adjacent.direction
                                });
                            });
                        });
                        return undirected;
                    };
                    // return reversed (directions inverted) version of given dag
                    var dagToReversed = function dagToReversed(dag) {
                        var reversed = new Map();
                        dag.forEach(function(value, key) {
                            reversed.set(key, []);
                        });
                        dag.forEach(function(value, key) {
                            value.forEach(function(adjacent) {
                                reversed.get(adjacent.id).push({
                                    id: key,
                                    gap: adjacent.gap,
                                    direction: adjacent.direction
                                });
                            });
                        });
                        return reversed;
                    };
                    /****  apply transformation to the initial draft layout to better align with constrained nodes ****/ // solve the Orthogonal Procrustean Problem to rotate and/or reflect initial draft layout
                    // here we follow the solution in Chapter 20.2 of Borg, I. & Groenen, P. (2005) Modern Multidimensional Scaling: Theory and Applications 
                    /* construct source and target configurations */ var targetMatrix = []; // A - target configuration
                    var sourceMatrix = []; // B - source configuration 
                    var standardTransformation = false; // false for no transformation, true for standart (Procrustes) transformation (rotation and/or reflection)
                    var reflectionType = false; // false/true for reflection check, 'reflectOnX', 'reflectOnY' or 'reflectOnBoth' for reflection type if necessary
                    var fixedNodes = new Set();
                    var dag = new Map(); // adjacency list to keep directed acyclic graph (dag) that consists of relative placement constraints
                    var dagUndirected = new Map(); // undirected version of the dag
                    var components = []; // weakly connected components
                    // fill fixedNodes collection to use later
                    if (constraints.fixedNodeConstraint) constraints.fixedNodeConstraint.forEach(function(nodeData) {
                        fixedNodes.add(nodeData.nodeId);
                    });
                    // construct dag from relative placement constraints 
                    if (constraints.relativePlacementConstraint) {
                        // construct both directed and undirected version of the dag
                        constraints.relativePlacementConstraint.forEach(function(constraint) {
                            if (constraint.left) {
                                if (dag.has(constraint.left)) dag.get(constraint.left).push({
                                    id: constraint.right,
                                    gap: constraint.gap,
                                    direction: "horizontal"
                                });
                                else dag.set(constraint.left, [
                                    {
                                        id: constraint.right,
                                        gap: constraint.gap,
                                        direction: "horizontal"
                                    }
                                ]);
                                if (!dag.has(constraint.right)) dag.set(constraint.right, []);
                            } else {
                                if (dag.has(constraint.top)) dag.get(constraint.top).push({
                                    id: constraint.bottom,
                                    gap: constraint.gap,
                                    direction: "vertical"
                                });
                                else dag.set(constraint.top, [
                                    {
                                        id: constraint.bottom,
                                        gap: constraint.gap,
                                        direction: "vertical"
                                    }
                                ]);
                                if (!dag.has(constraint.bottom)) dag.set(constraint.bottom, []);
                            }
                        });
                        dagUndirected = dagToUndirected(dag);
                        components = findComponents(dagUndirected);
                    }
                    if (CoSEConstants.TRANSFORM_ON_CONSTRAINT_HANDLING) {
                        // first check fixed node constraint
                        if (constraints.fixedNodeConstraint && constraints.fixedNodeConstraint.length > 1) {
                            constraints.fixedNodeConstraint.forEach(function(nodeData, i) {
                                targetMatrix[i] = [
                                    nodeData.position.x,
                                    nodeData.position.y
                                ];
                                sourceMatrix[i] = [
                                    xCoords[nodeIndexes.get(nodeData.nodeId)],
                                    yCoords[nodeIndexes.get(nodeData.nodeId)]
                                ];
                            });
                            standardTransformation = true;
                        } else if (constraints.alignmentConstraint) (function() {
                            // then check alignment constraint
                            var count = 0;
                            if (constraints.alignmentConstraint.vertical) {
                                var verticalAlign = constraints.alignmentConstraint.vertical;
                                var _loop2 = function _loop2(_i4) {
                                    var alignmentSet = new Set();
                                    verticalAlign[_i4].forEach(function(nodeId) {
                                        alignmentSet.add(nodeId);
                                    });
                                    var intersection = new Set([].concat(_toConsumableArray(alignmentSet)).filter(function(x) {
                                        return fixedNodes.has(x);
                                    }));
                                    var xPos = void 0;
                                    if (intersection.size > 0) xPos = xCoords[nodeIndexes.get(intersection.values().next().value)];
                                    else xPos = calculateAvgPosition(alignmentSet).x;
                                    verticalAlign[_i4].forEach(function(nodeId) {
                                        targetMatrix[count] = [
                                            xPos,
                                            yCoords[nodeIndexes.get(nodeId)]
                                        ];
                                        sourceMatrix[count] = [
                                            xCoords[nodeIndexes.get(nodeId)],
                                            yCoords[nodeIndexes.get(nodeId)]
                                        ];
                                        count++;
                                    });
                                };
                                for(var _i4 = 0; _i4 < verticalAlign.length; _i4++)_loop2(_i4);
                                standardTransformation = true;
                            }
                            if (constraints.alignmentConstraint.horizontal) {
                                var horizontalAlign = constraints.alignmentConstraint.horizontal;
                                var _loop3 = function _loop3(_i5) {
                                    var alignmentSet = new Set();
                                    horizontalAlign[_i5].forEach(function(nodeId) {
                                        alignmentSet.add(nodeId);
                                    });
                                    var intersection = new Set([].concat(_toConsumableArray(alignmentSet)).filter(function(x) {
                                        return fixedNodes.has(x);
                                    }));
                                    var yPos = void 0;
                                    if (intersection.size > 0) yPos = xCoords[nodeIndexes.get(intersection.values().next().value)];
                                    else yPos = calculateAvgPosition(alignmentSet).y;
                                    horizontalAlign[_i5].forEach(function(nodeId) {
                                        targetMatrix[count] = [
                                            xCoords[nodeIndexes.get(nodeId)],
                                            yPos
                                        ];
                                        sourceMatrix[count] = [
                                            xCoords[nodeIndexes.get(nodeId)],
                                            yCoords[nodeIndexes.get(nodeId)]
                                        ];
                                        count++;
                                    });
                                };
                                for(var _i5 = 0; _i5 < horizontalAlign.length; _i5++)_loop3(_i5);
                                standardTransformation = true;
                            }
                            if (constraints.relativePlacementConstraint) reflectionType = true;
                        })();
                        else if (constraints.relativePlacementConstraint) {
                            // finally check relative placement constraint
                            // find largest component in dag
                            var largestComponentSize = 0;
                            var largestComponentIndex = 0;
                            for(var _i6 = 0; _i6 < components.length; _i6++)if (components[_i6].length > largestComponentSize) {
                                largestComponentSize = components[_i6].length;
                                largestComponentIndex = _i6;
                            }
                            // if largest component isn't dominant, then take the votes for reflection
                            if (largestComponentSize < dagUndirected.size / 2) {
                                applyReflectionForRelativePlacement(constraints.relativePlacementConstraint);
                                standardTransformation = false;
                                reflectionType = false;
                            } else {
                                // use largest component for transformation
                                // construct horizontal and vertical subgraphs in the largest component
                                var subGraphOnHorizontal = new Map();
                                var subGraphOnVertical = new Map();
                                var constraintsInlargestComponent = [];
                                components[largestComponentIndex].forEach(function(nodeId) {
                                    dag.get(nodeId).forEach(function(adjacent) {
                                        if (adjacent.direction == "horizontal") {
                                            if (subGraphOnHorizontal.has(nodeId)) subGraphOnHorizontal.get(nodeId).push(adjacent);
                                            else subGraphOnHorizontal.set(nodeId, [
                                                adjacent
                                            ]);
                                            if (!subGraphOnHorizontal.has(adjacent.id)) subGraphOnHorizontal.set(adjacent.id, []);
                                            constraintsInlargestComponent.push({
                                                left: nodeId,
                                                right: adjacent.id
                                            });
                                        } else {
                                            if (subGraphOnVertical.has(nodeId)) subGraphOnVertical.get(nodeId).push(adjacent);
                                            else subGraphOnVertical.set(nodeId, [
                                                adjacent
                                            ]);
                                            if (!subGraphOnVertical.has(adjacent.id)) subGraphOnVertical.set(adjacent.id, []);
                                            constraintsInlargestComponent.push({
                                                top: nodeId,
                                                bottom: adjacent.id
                                            });
                                        }
                                    });
                                });
                                applyReflectionForRelativePlacement(constraintsInlargestComponent);
                                reflectionType = false;
                                // calculate appropriate positioning for subgraphs
                                var positionMapHorizontal = findAppropriatePositionForRelativePlacement(subGraphOnHorizontal, "horizontal");
                                var positionMapVertical = findAppropriatePositionForRelativePlacement(subGraphOnVertical, "vertical");
                                // construct source and target configuration
                                components[largestComponentIndex].forEach(function(nodeId, i) {
                                    sourceMatrix[i] = [
                                        xCoords[nodeIndexes.get(nodeId)],
                                        yCoords[nodeIndexes.get(nodeId)]
                                    ];
                                    targetMatrix[i] = [];
                                    if (positionMapHorizontal.has(nodeId)) targetMatrix[i][0] = positionMapHorizontal.get(nodeId);
                                    else targetMatrix[i][0] = xCoords[nodeIndexes.get(nodeId)];
                                    if (positionMapVertical.has(nodeId)) targetMatrix[i][1] = positionMapVertical.get(nodeId);
                                    else targetMatrix[i][1] = yCoords[nodeIndexes.get(nodeId)];
                                });
                                standardTransformation = true;
                            }
                        }
                        // if transformation is required, then calculate and apply transformation matrix
                        if (standardTransformation) {
                            /* calculate transformation matrix */ var transformationMatrix = void 0;
                            var targetMatrixTranspose = Matrix.transpose(targetMatrix); // A'
                            var sourceMatrixTranspose = Matrix.transpose(sourceMatrix); // B'
                            // centralize transpose matrices
                            for(var _i7 = 0; _i7 < targetMatrixTranspose.length; _i7++){
                                targetMatrixTranspose[_i7] = Matrix.multGamma(targetMatrixTranspose[_i7]);
                                sourceMatrixTranspose[_i7] = Matrix.multGamma(sourceMatrixTranspose[_i7]);
                            }
                            // do actual calculation for transformation matrix
                            var tempMatrix = Matrix.multMat(targetMatrixTranspose, Matrix.transpose(sourceMatrixTranspose)); // tempMatrix = A'B
                            var SVDResult = SVD.svd(tempMatrix); // SVD(A'B) = USV', svd function returns U, S and V 
                            transformationMatrix = Matrix.multMat(SVDResult.V, Matrix.transpose(SVDResult.U)); // transformationMatrix = T = VU'
                            /* apply found transformation matrix to obtain final draft layout */ for(var _i8 = 0; _i8 < nodeIndexes.size; _i8++){
                                var temp1 = [
                                    xCoords[_i8],
                                    yCoords[_i8]
                                ];
                                var temp2 = [
                                    transformationMatrix[0][0],
                                    transformationMatrix[1][0]
                                ];
                                var temp3 = [
                                    transformationMatrix[0][1],
                                    transformationMatrix[1][1]
                                ];
                                xCoords[_i8] = Matrix.dotProduct(temp1, temp2);
                                yCoords[_i8] = Matrix.dotProduct(temp1, temp3);
                            }
                            // applied only both alignment and rel. placement constraints exist
                            if (reflectionType) applyReflectionForRelativePlacement(constraints.relativePlacementConstraint);
                        }
                    }
                    if (CoSEConstants.ENFORCE_CONSTRAINTS) {
                        /****  enforce constraints on the transformed draft layout ****/ /* first enforce fixed node constraint */ if (constraints.fixedNodeConstraint && constraints.fixedNodeConstraint.length > 0) {
                            var translationAmount = {
                                x: 0,
                                y: 0
                            };
                            constraints.fixedNodeConstraint.forEach(function(nodeData, i) {
                                var posInTheory = {
                                    x: xCoords[nodeIndexes.get(nodeData.nodeId)],
                                    y: yCoords[nodeIndexes.get(nodeData.nodeId)]
                                };
                                var posDesired = nodeData.position;
                                var posDiff = calculatePositionDiff(posDesired, posInTheory);
                                translationAmount.x += posDiff.x;
                                translationAmount.y += posDiff.y;
                            });
                            translationAmount.x /= constraints.fixedNodeConstraint.length;
                            translationAmount.y /= constraints.fixedNodeConstraint.length;
                            xCoords.forEach(function(value, i) {
                                xCoords[i] += translationAmount.x;
                            });
                            yCoords.forEach(function(value, i) {
                                yCoords[i] += translationAmount.y;
                            });
                            constraints.fixedNodeConstraint.forEach(function(nodeData) {
                                xCoords[nodeIndexes.get(nodeData.nodeId)] = nodeData.position.x;
                                yCoords[nodeIndexes.get(nodeData.nodeId)] = nodeData.position.y;
                            });
                        }
                        /* then enforce alignment constraint */ if (constraints.alignmentConstraint) {
                            if (constraints.alignmentConstraint.vertical) {
                                var xAlign = constraints.alignmentConstraint.vertical;
                                var _loop4 = function _loop4(_i9) {
                                    var alignmentSet = new Set();
                                    xAlign[_i9].forEach(function(nodeId) {
                                        alignmentSet.add(nodeId);
                                    });
                                    var intersection = new Set([].concat(_toConsumableArray(alignmentSet)).filter(function(x) {
                                        return fixedNodes.has(x);
                                    }));
                                    var xPos = void 0;
                                    if (intersection.size > 0) xPos = xCoords[nodeIndexes.get(intersection.values().next().value)];
                                    else xPos = calculateAvgPosition(alignmentSet).x;
                                    alignmentSet.forEach(function(nodeId) {
                                        if (!fixedNodes.has(nodeId)) xCoords[nodeIndexes.get(nodeId)] = xPos;
                                    });
                                };
                                for(var _i9 = 0; _i9 < xAlign.length; _i9++)_loop4(_i9);
                            }
                            if (constraints.alignmentConstraint.horizontal) {
                                var yAlign = constraints.alignmentConstraint.horizontal;
                                var _loop5 = function _loop5(_i10) {
                                    var alignmentSet = new Set();
                                    yAlign[_i10].forEach(function(nodeId) {
                                        alignmentSet.add(nodeId);
                                    });
                                    var intersection = new Set([].concat(_toConsumableArray(alignmentSet)).filter(function(x) {
                                        return fixedNodes.has(x);
                                    }));
                                    var yPos = void 0;
                                    if (intersection.size > 0) yPos = yCoords[nodeIndexes.get(intersection.values().next().value)];
                                    else yPos = calculateAvgPosition(alignmentSet).y;
                                    alignmentSet.forEach(function(nodeId) {
                                        if (!fixedNodes.has(nodeId)) yCoords[nodeIndexes.get(nodeId)] = yPos;
                                    });
                                };
                                for(var _i10 = 0; _i10 < yAlign.length; _i10++)_loop5(_i10);
                            }
                        }
                        /* finally enforce relative placement constraint */ if (constraints.relativePlacementConstraint) (function() {
                            var nodeToDummyForVerticalAlignment = new Map();
                            var nodeToDummyForHorizontalAlignment = new Map();
                            var dummyToNodeForVerticalAlignment = new Map();
                            var dummyToNodeForHorizontalAlignment = new Map();
                            var dummyPositionsForVerticalAlignment = new Map();
                            var dummyPositionsForHorizontalAlignment = new Map();
                            var fixedNodesOnHorizontal = new Set();
                            var fixedNodesOnVertical = new Set();
                            // fill maps and sets      
                            fixedNodes.forEach(function(nodeId) {
                                fixedNodesOnHorizontal.add(nodeId);
                                fixedNodesOnVertical.add(nodeId);
                            });
                            if (constraints.alignmentConstraint) {
                                if (constraints.alignmentConstraint.vertical) {
                                    var verticalAlignment = constraints.alignmentConstraint.vertical;
                                    var _loop6 = function _loop6(_i11) {
                                        dummyToNodeForVerticalAlignment.set("dummy" + _i11, []);
                                        verticalAlignment[_i11].forEach(function(nodeId) {
                                            nodeToDummyForVerticalAlignment.set(nodeId, "dummy" + _i11);
                                            dummyToNodeForVerticalAlignment.get("dummy" + _i11).push(nodeId);
                                            if (fixedNodes.has(nodeId)) fixedNodesOnHorizontal.add("dummy" + _i11);
                                        });
                                        dummyPositionsForVerticalAlignment.set("dummy" + _i11, xCoords[nodeIndexes.get(verticalAlignment[_i11][0])]);
                                    };
                                    for(var _i11 = 0; _i11 < verticalAlignment.length; _i11++)_loop6(_i11);
                                }
                                if (constraints.alignmentConstraint.horizontal) {
                                    var horizontalAlignment = constraints.alignmentConstraint.horizontal;
                                    var _loop7 = function _loop7(_i12) {
                                        dummyToNodeForHorizontalAlignment.set("dummy" + _i12, []);
                                        horizontalAlignment[_i12].forEach(function(nodeId) {
                                            nodeToDummyForHorizontalAlignment.set(nodeId, "dummy" + _i12);
                                            dummyToNodeForHorizontalAlignment.get("dummy" + _i12).push(nodeId);
                                            if (fixedNodes.has(nodeId)) fixedNodesOnVertical.add("dummy" + _i12);
                                        });
                                        dummyPositionsForHorizontalAlignment.set("dummy" + _i12, yCoords[nodeIndexes.get(horizontalAlignment[_i12][0])]);
                                    };
                                    for(var _i12 = 0; _i12 < horizontalAlignment.length; _i12++)_loop7(_i12);
                                }
                            }
                            // construct horizontal and vertical dags (subgraphs) from overall dag
                            var dagOnHorizontal = new Map();
                            var dagOnVertical = new Map();
                            var _loop8 = function _loop8(nodeId) {
                                dag.get(nodeId).forEach(function(adjacent) {
                                    var sourceId = void 0;
                                    var targetNode = void 0;
                                    if (adjacent["direction"] == "horizontal") {
                                        sourceId = nodeToDummyForVerticalAlignment.get(nodeId) ? nodeToDummyForVerticalAlignment.get(nodeId) : nodeId;
                                        if (nodeToDummyForVerticalAlignment.get(adjacent.id)) targetNode = {
                                            id: nodeToDummyForVerticalAlignment.get(adjacent.id),
                                            gap: adjacent.gap,
                                            direction: adjacent.direction
                                        };
                                        else targetNode = adjacent;
                                        if (dagOnHorizontal.has(sourceId)) dagOnHorizontal.get(sourceId).push(targetNode);
                                        else dagOnHorizontal.set(sourceId, [
                                            targetNode
                                        ]);
                                        if (!dagOnHorizontal.has(targetNode.id)) dagOnHorizontal.set(targetNode.id, []);
                                    } else {
                                        sourceId = nodeToDummyForHorizontalAlignment.get(nodeId) ? nodeToDummyForHorizontalAlignment.get(nodeId) : nodeId;
                                        if (nodeToDummyForHorizontalAlignment.get(adjacent.id)) targetNode = {
                                            id: nodeToDummyForHorizontalAlignment.get(adjacent.id),
                                            gap: adjacent.gap,
                                            direction: adjacent.direction
                                        };
                                        else targetNode = adjacent;
                                        if (dagOnVertical.has(sourceId)) dagOnVertical.get(sourceId).push(targetNode);
                                        else dagOnVertical.set(sourceId, [
                                            targetNode
                                        ]);
                                        if (!dagOnVertical.has(targetNode.id)) dagOnVertical.set(targetNode.id, []);
                                    }
                                });
                            };
                            var _iteratorNormalCompletion5 = true;
                            var _didIteratorError5 = false;
                            var _iteratorError5 = undefined;
                            try {
                                for(var _iterator5 = dag.keys()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                                    var nodeId = _step5.value;
                                    _loop8(nodeId);
                                }
                            // find source nodes of each component in horizontal and vertical dags
                            } catch (err) {
                                _didIteratorError5 = true;
                                _iteratorError5 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion5 && _iterator5.return) _iterator5.return();
                                } finally{
                                    if (_didIteratorError5) throw _iteratorError5;
                                }
                            }
                            var undirectedOnHorizontal = dagToUndirected(dagOnHorizontal);
                            var undirectedOnVertical = dagToUndirected(dagOnVertical);
                            var componentsOnHorizontal = findComponents(undirectedOnHorizontal);
                            var componentsOnVertical = findComponents(undirectedOnVertical);
                            var reversedDagOnHorizontal = dagToReversed(dagOnHorizontal);
                            var reversedDagOnVertical = dagToReversed(dagOnVertical);
                            var componentSourcesOnHorizontal = [];
                            var componentSourcesOnVertical = [];
                            componentsOnHorizontal.forEach(function(component, index) {
                                componentSourcesOnHorizontal[index] = [];
                                component.forEach(function(nodeId) {
                                    if (reversedDagOnHorizontal.get(nodeId).length == 0) componentSourcesOnHorizontal[index].push(nodeId);
                                });
                            });
                            componentsOnVertical.forEach(function(component, index) {
                                componentSourcesOnVertical[index] = [];
                                component.forEach(function(nodeId) {
                                    if (reversedDagOnVertical.get(nodeId).length == 0) componentSourcesOnVertical[index].push(nodeId);
                                });
                            });
                            // calculate appropriate positioning for subgraphs
                            var positionMapHorizontal = findAppropriatePositionForRelativePlacement(dagOnHorizontal, "horizontal", fixedNodesOnHorizontal, dummyPositionsForVerticalAlignment, componentSourcesOnHorizontal);
                            var positionMapVertical = findAppropriatePositionForRelativePlacement(dagOnVertical, "vertical", fixedNodesOnVertical, dummyPositionsForHorizontalAlignment, componentSourcesOnVertical);
                            // update positions of the nodes based on relative placement constraints
                            var _loop9 = function _loop9(key) {
                                if (dummyToNodeForVerticalAlignment.get(key)) dummyToNodeForVerticalAlignment.get(key).forEach(function(nodeId) {
                                    xCoords[nodeIndexes.get(nodeId)] = positionMapHorizontal.get(key);
                                });
                                else xCoords[nodeIndexes.get(key)] = positionMapHorizontal.get(key);
                            };
                            var _iteratorNormalCompletion6 = true;
                            var _didIteratorError6 = false;
                            var _iteratorError6 = undefined;
                            try {
                                for(var _iterator6 = positionMapHorizontal.keys()[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true){
                                    var key = _step6.value;
                                    _loop9(key);
                                }
                            } catch (err) {
                                _didIteratorError6 = true;
                                _iteratorError6 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion6 && _iterator6.return) _iterator6.return();
                                } finally{
                                    if (_didIteratorError6) throw _iteratorError6;
                                }
                            }
                            var _loop10 = function _loop10(key) {
                                if (dummyToNodeForHorizontalAlignment.get(key)) dummyToNodeForHorizontalAlignment.get(key).forEach(function(nodeId) {
                                    yCoords[nodeIndexes.get(nodeId)] = positionMapVertical.get(key);
                                });
                                else yCoords[nodeIndexes.get(key)] = positionMapVertical.get(key);
                            };
                            var _iteratorNormalCompletion7 = true;
                            var _didIteratorError7 = false;
                            var _iteratorError7 = undefined;
                            try {
                                for(var _iterator7 = positionMapVertical.keys()[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true){
                                    var key = _step7.value;
                                    _loop10(key);
                                }
                            } catch (err) {
                                _didIteratorError7 = true;
                                _iteratorError7 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion7 && _iterator7.return) _iterator7.return();
                                } finally{
                                    if (_didIteratorError7) throw _iteratorError7;
                                }
                            }
                        })();
                    }
                    // assign new coordinates to nodes after constraint handling
                    for(var _i13 = 0; _i13 < allNodes.length; _i13++){
                        var _node = allNodes[_i13];
                        if (_node.getChild() == null) _node.setCenter(xCoords[nodeIndexes.get(_node.id)], yCoords[nodeIndexes.get(_node.id)]);
                    }
                };
                module1.exports = ConstraintHandler;
            /***/ },
            /***/ 551: /***/ (module1)=>{
                module1.exports = __WEBPACK_EXTERNAL_MODULE__551__;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__(45);
        /******/ /******/ return __webpack_exports__;
    /******/ })();
});

});
parcelRegister("g2Xm1", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 28);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function LayoutConstants() {}
            /**
 * Layout Quality: 0:draft, 1:default, 2:proof
 */ LayoutConstants.QUALITY = 1;
            /**
 * Default parameters
 */ LayoutConstants.DEFAULT_CREATE_BENDS_AS_NEEDED = false;
            LayoutConstants.DEFAULT_INCREMENTAL = false;
            LayoutConstants.DEFAULT_ANIMATION_ON_LAYOUT = true;
            LayoutConstants.DEFAULT_ANIMATION_DURING_LAYOUT = false;
            LayoutConstants.DEFAULT_ANIMATION_PERIOD = 50;
            LayoutConstants.DEFAULT_UNIFORM_LEAF_NODE_SIZES = false;
            // -----------------------------------------------------------------------------
            // Section: General other constants
            // -----------------------------------------------------------------------------
            /*
 * Margins of a graph to be applied on bouding rectangle of its contents. We
 * assume margins on all four sides to be uniform.
 */ LayoutConstants.DEFAULT_GRAPH_MARGIN = 15;
            /*
 * Whether to consider labels in node dimensions or not
 */ LayoutConstants.NODE_DIMENSIONS_INCLUDE_LABELS = false;
            /*
 * Default dimension of a non-compound node.
 */ LayoutConstants.SIMPLE_NODE_SIZE = 40;
            /*
 * Default dimension of a non-compound node.
 */ LayoutConstants.SIMPLE_NODE_HALF_SIZE = LayoutConstants.SIMPLE_NODE_SIZE / 2;
            /*
 * Empty compound node size. When a compound node is empty, its both
 * dimensions should be of this value.
 */ LayoutConstants.EMPTY_COMPOUND_NODE_SIZE = 40;
            /*
 * Minimum length that an edge should take during layout
 */ LayoutConstants.MIN_EDGE_LENGTH = 1;
            /*
 * World boundaries that layout operates on
 */ LayoutConstants.WORLD_BOUNDARY = 1000000;
            /*
 * World boundaries that random positioning can be performed with
 */ LayoutConstants.INITIAL_WORLD_BOUNDARY = LayoutConstants.WORLD_BOUNDARY / 1000;
            /*
 * Coordinates of the world center
 */ LayoutConstants.WORLD_CENTER_X = 1200;
            LayoutConstants.WORLD_CENTER_Y = 900;
            module1.exports = LayoutConstants;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LGraphObject = __webpack_require__(2);
            var IGeometry = __webpack_require__(8);
            var IMath = __webpack_require__(9);
            function LEdge(source, target, vEdge) {
                LGraphObject.call(this, vEdge);
                this.isOverlapingSourceAndTarget = false;
                this.vGraphObject = vEdge;
                this.bendpoints = [];
                this.source = source;
                this.target = target;
            }
            LEdge.prototype = Object.create(LGraphObject.prototype);
            for(var prop in LGraphObject)LEdge[prop] = LGraphObject[prop];
            LEdge.prototype.getSource = function() {
                return this.source;
            };
            LEdge.prototype.getTarget = function() {
                return this.target;
            };
            LEdge.prototype.isInterGraph = function() {
                return this.isInterGraph;
            };
            LEdge.prototype.getLength = function() {
                return this.length;
            };
            LEdge.prototype.isOverlapingSourceAndTarget = function() {
                return this.isOverlapingSourceAndTarget;
            };
            LEdge.prototype.getBendpoints = function() {
                return this.bendpoints;
            };
            LEdge.prototype.getLca = function() {
                return this.lca;
            };
            LEdge.prototype.getSourceInLca = function() {
                return this.sourceInLca;
            };
            LEdge.prototype.getTargetInLca = function() {
                return this.targetInLca;
            };
            LEdge.prototype.getOtherEnd = function(node) {
                if (this.source === node) return this.target;
                else if (this.target === node) return this.source;
                else throw "Node is not incident with this edge";
            };
            LEdge.prototype.getOtherEndInGraph = function(node, graph) {
                var otherEnd = this.getOtherEnd(node);
                var root = graph.getGraphManager().getRoot();
                while(true){
                    if (otherEnd.getOwner() == graph) return otherEnd;
                    if (otherEnd.getOwner() == root) break;
                    otherEnd = otherEnd.getOwner().getParent();
                }
                return null;
            };
            LEdge.prototype.updateLength = function() {
                var clipPointCoordinates = new Array(4);
                this.isOverlapingSourceAndTarget = IGeometry.getIntersection(this.target.getRect(), this.source.getRect(), clipPointCoordinates);
                if (!this.isOverlapingSourceAndTarget) {
                    this.lengthX = clipPointCoordinates[0] - clipPointCoordinates[2];
                    this.lengthY = clipPointCoordinates[1] - clipPointCoordinates[3];
                    if (Math.abs(this.lengthX) < 1.0) this.lengthX = IMath.sign(this.lengthX);
                    if (Math.abs(this.lengthY) < 1.0) this.lengthY = IMath.sign(this.lengthY);
                    this.length = Math.sqrt(this.lengthX * this.lengthX + this.lengthY * this.lengthY);
                }
            };
            LEdge.prototype.updateLengthSimple = function() {
                this.lengthX = this.target.getCenterX() - this.source.getCenterX();
                this.lengthY = this.target.getCenterY() - this.source.getCenterY();
                if (Math.abs(this.lengthX) < 1.0) this.lengthX = IMath.sign(this.lengthX);
                if (Math.abs(this.lengthY) < 1.0) this.lengthY = IMath.sign(this.lengthY);
                this.length = Math.sqrt(this.lengthX * this.lengthX + this.lengthY * this.lengthY);
            };
            module1.exports = LEdge;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function LGraphObject(vGraphObject) {
                this.vGraphObject = vGraphObject;
            }
            module1.exports = LGraphObject;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LGraphObject = __webpack_require__(2);
            var Integer = __webpack_require__(10);
            var RectangleD = __webpack_require__(13);
            var LayoutConstants = __webpack_require__(0);
            var RandomSeed = __webpack_require__(16);
            var PointD = __webpack_require__(5);
            function LNode(gm, loc, size, vNode) {
                //Alternative constructor 1 : LNode(LGraphManager gm, Point loc, Dimension size, Object vNode)
                if (size == null && vNode == null) vNode = loc;
                LGraphObject.call(this, vNode);
                //Alternative constructor 2 : LNode(Layout layout, Object vNode)
                if (gm.graphManager != null) gm = gm.graphManager;
                this.estimatedSize = Integer.MIN_VALUE;
                this.inclusionTreeDepth = Integer.MAX_VALUE;
                this.vGraphObject = vNode;
                this.edges = [];
                this.graphManager = gm;
                if (size != null && loc != null) this.rect = new RectangleD(loc.x, loc.y, size.width, size.height);
                else this.rect = new RectangleD();
            }
            LNode.prototype = Object.create(LGraphObject.prototype);
            for(var prop in LGraphObject)LNode[prop] = LGraphObject[prop];
            LNode.prototype.getEdges = function() {
                return this.edges;
            };
            LNode.prototype.getChild = function() {
                return this.child;
            };
            LNode.prototype.getOwner = function() {
                //  if (this.owner != null) {
                //    if (!(this.owner == null || this.owner.getNodes().indexOf(this) > -1)) {
                //      throw "assert failed";
                //    }
                //  }
                return this.owner;
            };
            LNode.prototype.getWidth = function() {
                return this.rect.width;
            };
            LNode.prototype.setWidth = function(width) {
                this.rect.width = width;
            };
            LNode.prototype.getHeight = function() {
                return this.rect.height;
            };
            LNode.prototype.setHeight = function(height) {
                this.rect.height = height;
            };
            LNode.prototype.getCenterX = function() {
                return this.rect.x + this.rect.width / 2;
            };
            LNode.prototype.getCenterY = function() {
                return this.rect.y + this.rect.height / 2;
            };
            LNode.prototype.getCenter = function() {
                return new PointD(this.rect.x + this.rect.width / 2, this.rect.y + this.rect.height / 2);
            };
            LNode.prototype.getLocation = function() {
                return new PointD(this.rect.x, this.rect.y);
            };
            LNode.prototype.getRect = function() {
                return this.rect;
            };
            LNode.prototype.getDiagonal = function() {
                return Math.sqrt(this.rect.width * this.rect.width + this.rect.height * this.rect.height);
            };
            /**
 * This method returns half the diagonal length of this node.
 */ LNode.prototype.getHalfTheDiagonal = function() {
                return Math.sqrt(this.rect.height * this.rect.height + this.rect.width * this.rect.width) / 2;
            };
            LNode.prototype.setRect = function(upperLeft, dimension) {
                this.rect.x = upperLeft.x;
                this.rect.y = upperLeft.y;
                this.rect.width = dimension.width;
                this.rect.height = dimension.height;
            };
            LNode.prototype.setCenter = function(cx, cy) {
                this.rect.x = cx - this.rect.width / 2;
                this.rect.y = cy - this.rect.height / 2;
            };
            LNode.prototype.setLocation = function(x, y) {
                this.rect.x = x;
                this.rect.y = y;
            };
            LNode.prototype.moveBy = function(dx, dy) {
                this.rect.x += dx;
                this.rect.y += dy;
            };
            LNode.prototype.getEdgeListToNode = function(to) {
                var edgeList = [];
                var edge;
                var self = this;
                self.edges.forEach(function(edge) {
                    if (edge.target == to) {
                        if (edge.source != self) throw "Incorrect edge source!";
                        edgeList.push(edge);
                    }
                });
                return edgeList;
            };
            LNode.prototype.getEdgesBetween = function(other) {
                var edgeList = [];
                var edge;
                var self = this;
                self.edges.forEach(function(edge) {
                    if (!(edge.source == self || edge.target == self)) throw "Incorrect edge source and/or target";
                    if (edge.target == other || edge.source == other) edgeList.push(edge);
                });
                return edgeList;
            };
            LNode.prototype.getNeighborsList = function() {
                var neighbors = new Set();
                var self = this;
                self.edges.forEach(function(edge) {
                    if (edge.source == self) neighbors.add(edge.target);
                    else {
                        if (edge.target != self) throw "Incorrect incidency!";
                        neighbors.add(edge.source);
                    }
                });
                return neighbors;
            };
            LNode.prototype.withChildren = function() {
                var withNeighborsList = new Set();
                var childNode;
                var children;
                withNeighborsList.add(this);
                if (this.child != null) {
                    var nodes = this.child.getNodes();
                    for(var i = 0; i < nodes.length; i++){
                        childNode = nodes[i];
                        children = childNode.withChildren();
                        children.forEach(function(node) {
                            withNeighborsList.add(node);
                        });
                    }
                }
                return withNeighborsList;
            };
            LNode.prototype.getNoOfChildren = function() {
                var noOfChildren = 0;
                var childNode;
                if (this.child == null) noOfChildren = 1;
                else {
                    var nodes = this.child.getNodes();
                    for(var i = 0; i < nodes.length; i++){
                        childNode = nodes[i];
                        noOfChildren += childNode.getNoOfChildren();
                    }
                }
                if (noOfChildren == 0) noOfChildren = 1;
                return noOfChildren;
            };
            LNode.prototype.getEstimatedSize = function() {
                if (this.estimatedSize == Integer.MIN_VALUE) throw "assert failed";
                return this.estimatedSize;
            };
            LNode.prototype.calcEstimatedSize = function() {
                if (this.child == null) return this.estimatedSize = (this.rect.width + this.rect.height) / 2;
                else {
                    this.estimatedSize = this.child.calcEstimatedSize();
                    this.rect.width = this.estimatedSize;
                    this.rect.height = this.estimatedSize;
                    return this.estimatedSize;
                }
            };
            LNode.prototype.scatter = function() {
                var randomCenterX;
                var randomCenterY;
                var minX = -LayoutConstants.INITIAL_WORLD_BOUNDARY;
                var maxX = LayoutConstants.INITIAL_WORLD_BOUNDARY;
                randomCenterX = LayoutConstants.WORLD_CENTER_X + RandomSeed.nextDouble() * (maxX - minX) + minX;
                var minY = -LayoutConstants.INITIAL_WORLD_BOUNDARY;
                var maxY = LayoutConstants.INITIAL_WORLD_BOUNDARY;
                randomCenterY = LayoutConstants.WORLD_CENTER_Y + RandomSeed.nextDouble() * (maxY - minY) + minY;
                this.rect.x = randomCenterX;
                this.rect.y = randomCenterY;
            };
            LNode.prototype.updateBounds = function() {
                if (this.getChild() == null) throw "assert failed";
                if (this.getChild().getNodes().length != 0) {
                    // wrap the children nodes by re-arranging the boundaries
                    var childGraph = this.getChild();
                    childGraph.updateBounds(true);
                    this.rect.x = childGraph.getLeft();
                    this.rect.y = childGraph.getTop();
                    this.setWidth(childGraph.getRight() - childGraph.getLeft());
                    this.setHeight(childGraph.getBottom() - childGraph.getTop());
                    // Update compound bounds considering its label properties    
                    if (LayoutConstants.NODE_DIMENSIONS_INCLUDE_LABELS) {
                        var width = childGraph.getRight() - childGraph.getLeft();
                        var height = childGraph.getBottom() - childGraph.getTop();
                        if (this.labelWidth) {
                            if (this.labelPosHorizontal == "left") {
                                this.rect.x -= this.labelWidth;
                                this.setWidth(width + this.labelWidth);
                            } else if (this.labelPosHorizontal == "center" && this.labelWidth > width) {
                                this.rect.x -= (this.labelWidth - width) / 2;
                                this.setWidth(this.labelWidth);
                            } else if (this.labelPosHorizontal == "right") this.setWidth(width + this.labelWidth);
                        }
                        if (this.labelHeight) {
                            if (this.labelPosVertical == "top") {
                                this.rect.y -= this.labelHeight;
                                this.setHeight(height + this.labelHeight);
                            } else if (this.labelPosVertical == "center" && this.labelHeight > height) {
                                this.rect.y -= (this.labelHeight - height) / 2;
                                this.setHeight(this.labelHeight);
                            } else if (this.labelPosVertical == "bottom") this.setHeight(height + this.labelHeight);
                        }
                    }
                }
            };
            LNode.prototype.getInclusionTreeDepth = function() {
                if (this.inclusionTreeDepth == Integer.MAX_VALUE) throw "assert failed";
                return this.inclusionTreeDepth;
            };
            LNode.prototype.transform = function(trans) {
                var left = this.rect.x;
                if (left > LayoutConstants.WORLD_BOUNDARY) left = LayoutConstants.WORLD_BOUNDARY;
                else if (left < -LayoutConstants.WORLD_BOUNDARY) left = -LayoutConstants.WORLD_BOUNDARY;
                var top = this.rect.y;
                if (top > LayoutConstants.WORLD_BOUNDARY) top = LayoutConstants.WORLD_BOUNDARY;
                else if (top < -LayoutConstants.WORLD_BOUNDARY) top = -LayoutConstants.WORLD_BOUNDARY;
                var leftTop = new PointD(left, top);
                var vLeftTop = trans.inverseTransformPoint(leftTop);
                this.setLocation(vLeftTop.x, vLeftTop.y);
            };
            LNode.prototype.getLeft = function() {
                return this.rect.x;
            };
            LNode.prototype.getRight = function() {
                return this.rect.x + this.rect.width;
            };
            LNode.prototype.getTop = function() {
                return this.rect.y;
            };
            LNode.prototype.getBottom = function() {
                return this.rect.y + this.rect.height;
            };
            LNode.prototype.getParent = function() {
                if (this.owner == null) return null;
                return this.owner.getParent();
            };
            module1.exports = LNode;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LayoutConstants = __webpack_require__(0);
            function FDLayoutConstants() {}
            //FDLayoutConstants inherits static props in LayoutConstants
            for(var prop in LayoutConstants)FDLayoutConstants[prop] = LayoutConstants[prop];
            FDLayoutConstants.MAX_ITERATIONS = 2500;
            FDLayoutConstants.DEFAULT_EDGE_LENGTH = 50;
            FDLayoutConstants.DEFAULT_SPRING_STRENGTH = 0.45;
            FDLayoutConstants.DEFAULT_REPULSION_STRENGTH = 4500.0;
            FDLayoutConstants.DEFAULT_GRAVITY_STRENGTH = 0.4;
            FDLayoutConstants.DEFAULT_COMPOUND_GRAVITY_STRENGTH = 1.0;
            FDLayoutConstants.DEFAULT_GRAVITY_RANGE_FACTOR = 3.8;
            FDLayoutConstants.DEFAULT_COMPOUND_GRAVITY_RANGE_FACTOR = 1.5;
            FDLayoutConstants.DEFAULT_USE_SMART_IDEAL_EDGE_LENGTH_CALCULATION = true;
            FDLayoutConstants.DEFAULT_USE_SMART_REPULSION_RANGE_CALCULATION = true;
            FDLayoutConstants.DEFAULT_COOLING_FACTOR_INCREMENTAL = 0.3;
            FDLayoutConstants.COOLING_ADAPTATION_FACTOR = 0.33;
            FDLayoutConstants.ADAPTATION_LOWER_NODE_LIMIT = 1000;
            FDLayoutConstants.ADAPTATION_UPPER_NODE_LIMIT = 5000;
            FDLayoutConstants.MAX_NODE_DISPLACEMENT_INCREMENTAL = 100.0;
            FDLayoutConstants.MAX_NODE_DISPLACEMENT = FDLayoutConstants.MAX_NODE_DISPLACEMENT_INCREMENTAL * 3;
            FDLayoutConstants.MIN_REPULSION_DIST = FDLayoutConstants.DEFAULT_EDGE_LENGTH / 10.0;
            FDLayoutConstants.CONVERGENCE_CHECK_PERIOD = 100;
            FDLayoutConstants.PER_LEVEL_IDEAL_EDGE_LENGTH_FACTOR = 0.1;
            FDLayoutConstants.MIN_EDGE_LENGTH = 1;
            FDLayoutConstants.GRID_CALCULATION_CHECK_PERIOD = 10;
            module1.exports = FDLayoutConstants;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function PointD(x, y) {
                if (x == null && y == null) {
                    this.x = 0;
                    this.y = 0;
                } else {
                    this.x = x;
                    this.y = y;
                }
            }
            PointD.prototype.getX = function() {
                return this.x;
            };
            PointD.prototype.getY = function() {
                return this.y;
            };
            PointD.prototype.setX = function(x) {
                this.x = x;
            };
            PointD.prototype.setY = function(y) {
                this.y = y;
            };
            PointD.prototype.getDifference = function(pt) {
                return new DimensionD(this.x - pt.x, this.y - pt.y);
            };
            PointD.prototype.getCopy = function() {
                return new PointD(this.x, this.y);
            };
            PointD.prototype.translate = function(dim) {
                this.x += dim.width;
                this.y += dim.height;
                return this;
            };
            module1.exports = PointD;
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LGraphObject = __webpack_require__(2);
            var Integer = __webpack_require__(10);
            var LayoutConstants = __webpack_require__(0);
            var LGraphManager = __webpack_require__(7);
            var LNode = __webpack_require__(3);
            var LEdge = __webpack_require__(1);
            var RectangleD = __webpack_require__(13);
            var Point1 = __webpack_require__(12);
            var LinkedList = __webpack_require__(11);
            function LGraph(parent, obj2, vGraph) {
                LGraphObject.call(this, vGraph);
                this.estimatedSize = Integer.MIN_VALUE;
                this.margin = LayoutConstants.DEFAULT_GRAPH_MARGIN;
                this.edges = [];
                this.nodes = [];
                this.isConnected = false;
                this.parent = parent;
                if (obj2 != null && obj2 instanceof LGraphManager) this.graphManager = obj2;
                else if (obj2 != null && obj2 instanceof Layout) this.graphManager = obj2.graphManager;
            }
            LGraph.prototype = Object.create(LGraphObject.prototype);
            for(var prop in LGraphObject)LGraph[prop] = LGraphObject[prop];
            LGraph.prototype.getNodes = function() {
                return this.nodes;
            };
            LGraph.prototype.getEdges = function() {
                return this.edges;
            };
            LGraph.prototype.getGraphManager = function() {
                return this.graphManager;
            };
            LGraph.prototype.getParent = function() {
                return this.parent;
            };
            LGraph.prototype.getLeft = function() {
                return this.left;
            };
            LGraph.prototype.getRight = function() {
                return this.right;
            };
            LGraph.prototype.getTop = function() {
                return this.top;
            };
            LGraph.prototype.getBottom = function() {
                return this.bottom;
            };
            LGraph.prototype.isConnected = function() {
                return this.isConnected;
            };
            LGraph.prototype.add = function(obj1, sourceNode, targetNode) {
                if (sourceNode == null && targetNode == null) {
                    var newNode = obj1;
                    if (this.graphManager == null) throw "Graph has no graph mgr!";
                    if (this.getNodes().indexOf(newNode) > -1) throw "Node already in graph!";
                    newNode.owner = this;
                    this.getNodes().push(newNode);
                    return newNode;
                } else {
                    var newEdge = obj1;
                    if (!(this.getNodes().indexOf(sourceNode) > -1 && this.getNodes().indexOf(targetNode) > -1)) throw "Source or target not in graph!";
                    if (!(sourceNode.owner == targetNode.owner && sourceNode.owner == this)) throw "Both owners must be this graph!";
                    if (sourceNode.owner != targetNode.owner) return null;
                    // set source and target
                    newEdge.source = sourceNode;
                    newEdge.target = targetNode;
                    // set as intra-graph edge
                    newEdge.isInterGraph = false;
                    // add to graph edge list
                    this.getEdges().push(newEdge);
                    // add to incidency lists
                    sourceNode.edges.push(newEdge);
                    if (targetNode != sourceNode) targetNode.edges.push(newEdge);
                    return newEdge;
                }
            };
            LGraph.prototype.remove = function(obj) {
                var node = obj;
                if (obj instanceof LNode) {
                    if (node == null) throw "Node is null!";
                    if (!(node.owner != null && node.owner == this)) throw "Owner graph is invalid!";
                    if (this.graphManager == null) throw "Owner graph manager is invalid!";
                    // remove incident edges first (make a copy to do it safely)
                    var edgesToBeRemoved = node.edges.slice();
                    var edge;
                    var s = edgesToBeRemoved.length;
                    for(var i = 0; i < s; i++){
                        edge = edgesToBeRemoved[i];
                        if (edge.isInterGraph) this.graphManager.remove(edge);
                        else edge.source.owner.remove(edge);
                    }
                    // now the node itself
                    var index = this.nodes.indexOf(node);
                    if (index == -1) throw "Node not in owner node list!";
                    this.nodes.splice(index, 1);
                } else if (obj instanceof LEdge) {
                    var edge = obj;
                    if (edge == null) throw "Edge is null!";
                    if (!(edge.source != null && edge.target != null)) throw "Source and/or target is null!";
                    if (!(edge.source.owner != null && edge.target.owner != null && edge.source.owner == this && edge.target.owner == this)) throw "Source and/or target owner is invalid!";
                    var sourceIndex = edge.source.edges.indexOf(edge);
                    var targetIndex = edge.target.edges.indexOf(edge);
                    if (!(sourceIndex > -1 && targetIndex > -1)) throw "Source and/or target doesn't know this edge!";
                    edge.source.edges.splice(sourceIndex, 1);
                    if (edge.target != edge.source) edge.target.edges.splice(targetIndex, 1);
                    var index = edge.source.owner.getEdges().indexOf(edge);
                    if (index == -1) throw "Not in owner's edge list!";
                    edge.source.owner.getEdges().splice(index, 1);
                }
            };
            LGraph.prototype.updateLeftTop = function() {
                var top = Integer.MAX_VALUE;
                var left = Integer.MAX_VALUE;
                var nodeTop;
                var nodeLeft;
                var margin;
                var nodes = this.getNodes();
                var s = nodes.length;
                for(var i = 0; i < s; i++){
                    var lNode = nodes[i];
                    nodeTop = lNode.getTop();
                    nodeLeft = lNode.getLeft();
                    if (top > nodeTop) top = nodeTop;
                    if (left > nodeLeft) left = nodeLeft;
                }
                // Do we have any nodes in this graph?
                if (top == Integer.MAX_VALUE) return null;
                if (nodes[0].getParent().paddingLeft != undefined) margin = nodes[0].getParent().paddingLeft;
                else margin = this.margin;
                this.left = left - margin;
                this.top = top - margin;
                // Apply the margins and return the result
                return new Point1(this.left, this.top);
            };
            LGraph.prototype.updateBounds = function(recursive) {
                // calculate bounds
                var left = Integer.MAX_VALUE;
                var right = -Integer.MAX_VALUE;
                var top = Integer.MAX_VALUE;
                var bottom = -Integer.MAX_VALUE;
                var nodeLeft;
                var nodeRight;
                var nodeTop;
                var nodeBottom;
                var margin;
                var nodes = this.nodes;
                var s = nodes.length;
                for(var i = 0; i < s; i++){
                    var lNode = nodes[i];
                    if (recursive && lNode.child != null) lNode.updateBounds();
                    nodeLeft = lNode.getLeft();
                    nodeRight = lNode.getRight();
                    nodeTop = lNode.getTop();
                    nodeBottom = lNode.getBottom();
                    if (left > nodeLeft) left = nodeLeft;
                    if (right < nodeRight) right = nodeRight;
                    if (top > nodeTop) top = nodeTop;
                    if (bottom < nodeBottom) bottom = nodeBottom;
                }
                var boundingRect = new RectangleD(left, top, right - left, bottom - top);
                if (left == Integer.MAX_VALUE) {
                    this.left = this.parent.getLeft();
                    this.right = this.parent.getRight();
                    this.top = this.parent.getTop();
                    this.bottom = this.parent.getBottom();
                }
                if (nodes[0].getParent().paddingLeft != undefined) margin = nodes[0].getParent().paddingLeft;
                else margin = this.margin;
                this.left = boundingRect.x - margin;
                this.right = boundingRect.x + boundingRect.width + margin;
                this.top = boundingRect.y - margin;
                this.bottom = boundingRect.y + boundingRect.height + margin;
            };
            LGraph.calculateBounds = function(nodes) {
                var left = Integer.MAX_VALUE;
                var right = -Integer.MAX_VALUE;
                var top = Integer.MAX_VALUE;
                var bottom = -Integer.MAX_VALUE;
                var nodeLeft;
                var nodeRight;
                var nodeTop;
                var nodeBottom;
                var s = nodes.length;
                for(var i = 0; i < s; i++){
                    var lNode = nodes[i];
                    nodeLeft = lNode.getLeft();
                    nodeRight = lNode.getRight();
                    nodeTop = lNode.getTop();
                    nodeBottom = lNode.getBottom();
                    if (left > nodeLeft) left = nodeLeft;
                    if (right < nodeRight) right = nodeRight;
                    if (top > nodeTop) top = nodeTop;
                    if (bottom < nodeBottom) bottom = nodeBottom;
                }
                var boundingRect = new RectangleD(left, top, right - left, bottom - top);
                return boundingRect;
            };
            LGraph.prototype.getInclusionTreeDepth = function() {
                if (this == this.graphManager.getRoot()) return 1;
                else return this.parent.getInclusionTreeDepth();
            };
            LGraph.prototype.getEstimatedSize = function() {
                if (this.estimatedSize == Integer.MIN_VALUE) throw "assert failed";
                return this.estimatedSize;
            };
            LGraph.prototype.calcEstimatedSize = function() {
                var size = 0;
                var nodes = this.nodes;
                var s = nodes.length;
                for(var i = 0; i < s; i++){
                    var lNode = nodes[i];
                    size += lNode.calcEstimatedSize();
                }
                if (size == 0) this.estimatedSize = LayoutConstants.EMPTY_COMPOUND_NODE_SIZE;
                else this.estimatedSize = size / Math.sqrt(this.nodes.length);
                return this.estimatedSize;
            };
            LGraph.prototype.updateConnected = function() {
                var self = this;
                if (this.nodes.length == 0) {
                    this.isConnected = true;
                    return;
                }
                var queue = new LinkedList();
                var visited = new Set();
                var currentNode = this.nodes[0];
                var neighborEdges;
                var currentNeighbor;
                var childrenOfNode = currentNode.withChildren();
                childrenOfNode.forEach(function(node) {
                    queue.push(node);
                    visited.add(node);
                });
                while(queue.length !== 0){
                    currentNode = queue.shift();
                    // Traverse all neighbors of this node
                    neighborEdges = currentNode.getEdges();
                    var size = neighborEdges.length;
                    for(var i = 0; i < size; i++){
                        var neighborEdge = neighborEdges[i];
                        currentNeighbor = neighborEdge.getOtherEndInGraph(currentNode, this);
                        // Add unvisited neighbors to the list to visit
                        if (currentNeighbor != null && !visited.has(currentNeighbor)) {
                            var childrenOfNeighbor = currentNeighbor.withChildren();
                            childrenOfNeighbor.forEach(function(node) {
                                queue.push(node);
                                visited.add(node);
                            });
                        }
                    }
                }
                this.isConnected = false;
                if (visited.size >= this.nodes.length) {
                    var noOfVisitedInThisGraph = 0;
                    visited.forEach(function(visitedNode) {
                        if (visitedNode.owner == self) noOfVisitedInThisGraph++;
                    });
                    if (noOfVisitedInThisGraph == this.nodes.length) this.isConnected = true;
                }
            };
            module1.exports = LGraph;
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LGraph;
            var LEdge = __webpack_require__(1);
            function LGraphManager(layout) {
                LGraph = __webpack_require__(6); // It may be better to initilize this out of this function but it gives an error (Right-hand side of 'instanceof' is not callable) now.
                this.layout = layout;
                this.graphs = [];
                this.edges = [];
            }
            LGraphManager.prototype.addRoot = function() {
                var ngraph = this.layout.newGraph();
                var nnode = this.layout.newNode(null);
                var root = this.add(ngraph, nnode);
                this.setRootGraph(root);
                return this.rootGraph;
            };
            LGraphManager.prototype.add = function(newGraph, parentNode, newEdge, sourceNode, targetNode) {
                //there are just 2 parameters are passed then it adds an LGraph else it adds an LEdge
                if (newEdge == null && sourceNode == null && targetNode == null) {
                    if (newGraph == null) throw "Graph is null!";
                    if (parentNode == null) throw "Parent node is null!";
                    if (this.graphs.indexOf(newGraph) > -1) throw "Graph already in this graph mgr!";
                    this.graphs.push(newGraph);
                    if (newGraph.parent != null) throw "Already has a parent!";
                    if (parentNode.child != null) throw "Already has a child!";
                    newGraph.parent = parentNode;
                    parentNode.child = newGraph;
                    return newGraph;
                } else {
                    //change the order of the parameters
                    targetNode = newEdge;
                    sourceNode = parentNode;
                    newEdge = newGraph;
                    var sourceGraph = sourceNode.getOwner();
                    var targetGraph = targetNode.getOwner();
                    if (!(sourceGraph != null && sourceGraph.getGraphManager() == this)) throw "Source not in this graph mgr!";
                    if (!(targetGraph != null && targetGraph.getGraphManager() == this)) throw "Target not in this graph mgr!";
                    if (sourceGraph == targetGraph) {
                        newEdge.isInterGraph = false;
                        return sourceGraph.add(newEdge, sourceNode, targetNode);
                    } else {
                        newEdge.isInterGraph = true;
                        // set source and target
                        newEdge.source = sourceNode;
                        newEdge.target = targetNode;
                        // add edge to inter-graph edge list
                        if (this.edges.indexOf(newEdge) > -1) throw "Edge already in inter-graph edge list!";
                        this.edges.push(newEdge);
                        // add edge to source and target incidency lists
                        if (!(newEdge.source != null && newEdge.target != null)) throw "Edge source and/or target is null!";
                        if (!(newEdge.source.edges.indexOf(newEdge) == -1 && newEdge.target.edges.indexOf(newEdge) == -1)) throw "Edge already in source and/or target incidency list!";
                        newEdge.source.edges.push(newEdge);
                        newEdge.target.edges.push(newEdge);
                        return newEdge;
                    }
                }
            };
            LGraphManager.prototype.remove = function(lObj) {
                if (lObj instanceof LGraph) {
                    var graph = lObj;
                    if (graph.getGraphManager() != this) throw "Graph not in this graph mgr";
                    if (!(graph == this.rootGraph || graph.parent != null && graph.parent.graphManager == this)) throw "Invalid parent node!";
                    // first the edges (make a copy to do it safely)
                    var edgesToBeRemoved = [];
                    edgesToBeRemoved = edgesToBeRemoved.concat(graph.getEdges());
                    var edge;
                    var s = edgesToBeRemoved.length;
                    for(var i = 0; i < s; i++){
                        edge = edgesToBeRemoved[i];
                        graph.remove(edge);
                    }
                    // then the nodes (make a copy to do it safely)
                    var nodesToBeRemoved = [];
                    nodesToBeRemoved = nodesToBeRemoved.concat(graph.getNodes());
                    var node;
                    s = nodesToBeRemoved.length;
                    for(var i = 0; i < s; i++){
                        node = nodesToBeRemoved[i];
                        graph.remove(node);
                    }
                    // check if graph is the root
                    if (graph == this.rootGraph) this.setRootGraph(null);
                    // now remove the graph itself
                    var index = this.graphs.indexOf(graph);
                    this.graphs.splice(index, 1);
                    // also reset the parent of the graph
                    graph.parent = null;
                } else if (lObj instanceof LEdge) {
                    edge = lObj;
                    if (edge == null) throw "Edge is null!";
                    if (!edge.isInterGraph) throw "Not an inter-graph edge!";
                    if (!(edge.source != null && edge.target != null)) throw "Source and/or target is null!";
                    // remove edge from source and target nodes' incidency lists
                    if (!(edge.source.edges.indexOf(edge) != -1 && edge.target.edges.indexOf(edge) != -1)) throw "Source and/or target doesn't know this edge!";
                    var index = edge.source.edges.indexOf(edge);
                    edge.source.edges.splice(index, 1);
                    index = edge.target.edges.indexOf(edge);
                    edge.target.edges.splice(index, 1);
                    // remove edge from owner graph manager's inter-graph edge list
                    if (!(edge.source.owner != null && edge.source.owner.getGraphManager() != null)) throw "Edge owner graph or owner graph manager is null!";
                    if (edge.source.owner.getGraphManager().edges.indexOf(edge) == -1) throw "Not in owner graph manager's edge list!";
                    var index = edge.source.owner.getGraphManager().edges.indexOf(edge);
                    edge.source.owner.getGraphManager().edges.splice(index, 1);
                }
            };
            LGraphManager.prototype.updateBounds = function() {
                this.rootGraph.updateBounds(true);
            };
            LGraphManager.prototype.getGraphs = function() {
                return this.graphs;
            };
            LGraphManager.prototype.getAllNodes = function() {
                if (this.allNodes == null) {
                    var nodeList = [];
                    var graphs = this.getGraphs();
                    var s = graphs.length;
                    for(var i = 0; i < s; i++)nodeList = nodeList.concat(graphs[i].getNodes());
                    this.allNodes = nodeList;
                }
                return this.allNodes;
            };
            LGraphManager.prototype.resetAllNodes = function() {
                this.allNodes = null;
            };
            LGraphManager.prototype.resetAllEdges = function() {
                this.allEdges = null;
            };
            LGraphManager.prototype.resetAllNodesToApplyGravitation = function() {
                this.allNodesToApplyGravitation = null;
            };
            LGraphManager.prototype.getAllEdges = function() {
                if (this.allEdges == null) {
                    var edgeList = [];
                    var graphs = this.getGraphs();
                    var s = graphs.length;
                    for(var i = 0; i < graphs.length; i++)edgeList = edgeList.concat(graphs[i].getEdges());
                    edgeList = edgeList.concat(this.edges);
                    this.allEdges = edgeList;
                }
                return this.allEdges;
            };
            LGraphManager.prototype.getAllNodesToApplyGravitation = function() {
                return this.allNodesToApplyGravitation;
            };
            LGraphManager.prototype.setAllNodesToApplyGravitation = function(nodeList) {
                if (this.allNodesToApplyGravitation != null) throw "assert failed";
                this.allNodesToApplyGravitation = nodeList;
            };
            LGraphManager.prototype.getRoot = function() {
                return this.rootGraph;
            };
            LGraphManager.prototype.setRootGraph = function(graph) {
                if (graph.getGraphManager() != this) throw "Root not in this graph mgr!";
                this.rootGraph = graph;
                // root graph must have a root node associated with it for convenience
                if (graph.parent == null) graph.parent = this.layout.newNode("Root node");
            };
            LGraphManager.prototype.getLayout = function() {
                return this.layout;
            };
            LGraphManager.prototype.isOneAncestorOfOther = function(firstNode, secondNode) {
                if (!(firstNode != null && secondNode != null)) throw "assert failed";
                if (firstNode == secondNode) return true;
                // Is second node an ancestor of the first one?
                var ownerGraph = firstNode.getOwner();
                var parentNode;
                do {
                    parentNode = ownerGraph.getParent();
                    if (parentNode == null) break;
                    if (parentNode == secondNode) return true;
                    ownerGraph = parentNode.getOwner();
                    if (ownerGraph == null) break;
                }while (true);
                // Is first node an ancestor of the second one?
                ownerGraph = secondNode.getOwner();
                do {
                    parentNode = ownerGraph.getParent();
                    if (parentNode == null) break;
                    if (parentNode == firstNode) return true;
                    ownerGraph = parentNode.getOwner();
                    if (ownerGraph == null) break;
                }while (true);
                return false;
            };
            LGraphManager.prototype.calcLowestCommonAncestors = function() {
                var edge;
                var sourceNode;
                var targetNode;
                var sourceAncestorGraph;
                var targetAncestorGraph;
                var edges = this.getAllEdges();
                var s = edges.length;
                for(var i = 0; i < s; i++){
                    edge = edges[i];
                    sourceNode = edge.source;
                    targetNode = edge.target;
                    edge.lca = null;
                    edge.sourceInLca = sourceNode;
                    edge.targetInLca = targetNode;
                    if (sourceNode == targetNode) {
                        edge.lca = sourceNode.getOwner();
                        continue;
                    }
                    sourceAncestorGraph = sourceNode.getOwner();
                    while(edge.lca == null){
                        edge.targetInLca = targetNode;
                        targetAncestorGraph = targetNode.getOwner();
                        while(edge.lca == null){
                            if (targetAncestorGraph == sourceAncestorGraph) {
                                edge.lca = targetAncestorGraph;
                                break;
                            }
                            if (targetAncestorGraph == this.rootGraph) break;
                            if (edge.lca != null) throw "assert failed";
                            edge.targetInLca = targetAncestorGraph.getParent();
                            targetAncestorGraph = edge.targetInLca.getOwner();
                        }
                        if (sourceAncestorGraph == this.rootGraph) break;
                        if (edge.lca == null) {
                            edge.sourceInLca = sourceAncestorGraph.getParent();
                            sourceAncestorGraph = edge.sourceInLca.getOwner();
                        }
                    }
                    if (edge.lca == null) throw "assert failed";
                }
            };
            LGraphManager.prototype.calcLowestCommonAncestor = function(firstNode, secondNode) {
                if (firstNode == secondNode) return firstNode.getOwner();
                var firstOwnerGraph = firstNode.getOwner();
                do {
                    if (firstOwnerGraph == null) break;
                    var secondOwnerGraph = secondNode.getOwner();
                    do {
                        if (secondOwnerGraph == null) break;
                        if (secondOwnerGraph == firstOwnerGraph) return secondOwnerGraph;
                        secondOwnerGraph = secondOwnerGraph.getParent().getOwner();
                    }while (true);
                    firstOwnerGraph = firstOwnerGraph.getParent().getOwner();
                }while (true);
                return firstOwnerGraph;
            };
            LGraphManager.prototype.calcInclusionTreeDepths = function(graph, depth) {
                if (graph == null && depth == null) {
                    graph = this.rootGraph;
                    depth = 1;
                }
                var node;
                var nodes = graph.getNodes();
                var s = nodes.length;
                for(var i = 0; i < s; i++){
                    node = nodes[i];
                    node.inclusionTreeDepth = depth;
                    if (node.child != null) this.calcInclusionTreeDepths(node.child, depth + 1);
                }
            };
            LGraphManager.prototype.includesInvalidEdge = function() {
                var edge;
                var edgesToRemove = [];
                var s = this.edges.length;
                for(var i = 0; i < s; i++){
                    edge = this.edges[i];
                    if (this.isOneAncestorOfOther(edge.source, edge.target)) edgesToRemove.push(edge);
                }
                // Remove invalid edges from graph manager
                for(var i = 0; i < edgesToRemove.length; i++)this.remove(edgesToRemove[i]);
                // Invalid edges are cleared, so return false
                return false;
            };
            module1.exports = LGraphManager;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * This class maintains a list of static geometry related utility methods.
 *
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ var Point1 = __webpack_require__(12);
            function IGeometry() {}
            /**
 * This method calculates *half* the amount in x and y directions of the two
 * input rectangles needed to separate them keeping their respective
 * positioning, and returns the result in the input array. An input
 * separation buffer added to the amount in both directions. We assume that
 * the two rectangles do intersect.
 */ IGeometry.calcSeparationAmount = function(rectA, rectB, overlapAmount, separationBuffer) {
                if (!rectA.intersects(rectB)) throw "assert failed";
                var directions = new Array(2);
                this.decideDirectionsForOverlappingNodes(rectA, rectB, directions);
                overlapAmount[0] = Math.min(rectA.getRight(), rectB.getRight()) - Math.max(rectA.x, rectB.x);
                overlapAmount[1] = Math.min(rectA.getBottom(), rectB.getBottom()) - Math.max(rectA.y, rectB.y);
                // update the overlapping amounts for the following cases:
                if (rectA.getX() <= rectB.getX() && rectA.getRight() >= rectB.getRight()) /* Case x.1:
    *
    * rectA
    * 	|                       |
    * 	|        _________      |
    * 	|        |       |      |
    * 	|________|_______|______|
    * 			 |       |
    *           |       |
    *        rectB
    */ overlapAmount[0] += Math.min(rectB.getX() - rectA.getX(), rectA.getRight() - rectB.getRight());
                else if (rectB.getX() <= rectA.getX() && rectB.getRight() >= rectA.getRight()) /* Case x.2:
    *
    * rectB
    * 	|                       |
    * 	|        _________      |
    * 	|        |       |      |
    * 	|________|_______|______|
    * 			 |       |
    *           |       |
    *        rectA
    */ overlapAmount[0] += Math.min(rectA.getX() - rectB.getX(), rectB.getRight() - rectA.getRight());
                if (rectA.getY() <= rectB.getY() && rectA.getBottom() >= rectB.getBottom()) /* Case y.1:
     *          ________ rectA
     *         |
     *         |
     *   ______|____  rectB
     *         |    |
     *         |    |
     *   ______|____|
     *         |
     *         |
     *         |________
     *
     */ overlapAmount[1] += Math.min(rectB.getY() - rectA.getY(), rectA.getBottom() - rectB.getBottom());
                else if (rectB.getY() <= rectA.getY() && rectB.getBottom() >= rectA.getBottom()) /* Case y.2:
    *          ________ rectB
    *         |
    *         |
    *   ______|____  rectA
    *         |    |
    *         |    |
    *   ______|____|
    *         |
    *         |
    *         |________
    *
    */ overlapAmount[1] += Math.min(rectA.getY() - rectB.getY(), rectB.getBottom() - rectA.getBottom());
                // find slope of the line passes two centers
                var slope = Math.abs((rectB.getCenterY() - rectA.getCenterY()) / (rectB.getCenterX() - rectA.getCenterX()));
                // if centers are overlapped
                if (rectB.getCenterY() === rectA.getCenterY() && rectB.getCenterX() === rectA.getCenterX()) // assume the slope is 1 (45 degree)
                slope = 1.0;
                var moveByY = slope * overlapAmount[0];
                var moveByX = overlapAmount[1] / slope;
                if (overlapAmount[0] < moveByX) moveByX = overlapAmount[0];
                else moveByY = overlapAmount[1];
                // return half the amount so that if each rectangle is moved by these
                // amounts in opposite directions, overlap will be resolved
                overlapAmount[0] = -1 * directions[0] * (moveByX / 2 + separationBuffer);
                overlapAmount[1] = -1 * directions[1] * (moveByY / 2 + separationBuffer);
            };
            /**
 * This method decides the separation direction of overlapping nodes
 *
 * if directions[0] = -1, then rectA goes left
 * if directions[0] = 1,  then rectA goes right
 * if directions[1] = -1, then rectA goes up
 * if directions[1] = 1,  then rectA goes down
 */ IGeometry.decideDirectionsForOverlappingNodes = function(rectA, rectB, directions) {
                if (rectA.getCenterX() < rectB.getCenterX()) directions[0] = -1;
                else directions[0] = 1;
                if (rectA.getCenterY() < rectB.getCenterY()) directions[1] = -1;
                else directions[1] = 1;
            };
            /**
 * This method calculates the intersection (clipping) points of the two
 * input rectangles with line segment defined by the centers of these two
 * rectangles. The clipping points are saved in the input double array and
 * whether or not the two rectangles overlap is returned.
 */ IGeometry.getIntersection2 = function(rectA, rectB, result) {
                //result[0-1] will contain clipPoint of rectA, result[2-3] will contain clipPoint of rectB
                var p1x = rectA.getCenterX();
                var p1y = rectA.getCenterY();
                var p2x = rectB.getCenterX();
                var p2y = rectB.getCenterY();
                //if two rectangles intersect, then clipping points are centers
                if (rectA.intersects(rectB)) {
                    result[0] = p1x;
                    result[1] = p1y;
                    result[2] = p2x;
                    result[3] = p2y;
                    return true;
                }
                //variables for rectA
                var topLeftAx = rectA.getX();
                var topLeftAy = rectA.getY();
                var topRightAx = rectA.getRight();
                var bottomLeftAx = rectA.getX();
                var bottomLeftAy = rectA.getBottom();
                var bottomRightAx = rectA.getRight();
                var halfWidthA = rectA.getWidthHalf();
                var halfHeightA = rectA.getHeightHalf();
                //variables for rectB
                var topLeftBx = rectB.getX();
                var topLeftBy = rectB.getY();
                var topRightBx = rectB.getRight();
                var bottomLeftBx = rectB.getX();
                var bottomLeftBy = rectB.getBottom();
                var bottomRightBx = rectB.getRight();
                var halfWidthB = rectB.getWidthHalf();
                var halfHeightB = rectB.getHeightHalf();
                //flag whether clipping points are found
                var clipPointAFound = false;
                var clipPointBFound = false;
                // line is vertical
                if (p1x === p2x) {
                    if (p1y > p2y) {
                        result[0] = p1x;
                        result[1] = topLeftAy;
                        result[2] = p2x;
                        result[3] = bottomLeftBy;
                        return false;
                    } else if (p1y < p2y) {
                        result[0] = p1x;
                        result[1] = bottomLeftAy;
                        result[2] = p2x;
                        result[3] = topLeftBy;
                        return false;
                    }
                } else if (p1y === p2y) {
                    if (p1x > p2x) {
                        result[0] = topLeftAx;
                        result[1] = p1y;
                        result[2] = topRightBx;
                        result[3] = p2y;
                        return false;
                    } else if (p1x < p2x) {
                        result[0] = topRightAx;
                        result[1] = p1y;
                        result[2] = topLeftBx;
                        result[3] = p2y;
                        return false;
                    }
                } else {
                    //slopes of rectA's and rectB's diagonals
                    var slopeA = rectA.height / rectA.width;
                    var slopeB = rectB.height / rectB.width;
                    //slope of line between center of rectA and center of rectB
                    var slopePrime = (p2y - p1y) / (p2x - p1x);
                    var cardinalDirectionA = void 0;
                    var cardinalDirectionB = void 0;
                    var tempPointAx = void 0;
                    var tempPointAy = void 0;
                    var tempPointBx = void 0;
                    var tempPointBy = void 0;
                    //determine whether clipping point is the corner of nodeA
                    if (-slopeA === slopePrime) {
                        if (p1x > p2x) {
                            result[0] = bottomLeftAx;
                            result[1] = bottomLeftAy;
                            clipPointAFound = true;
                        } else {
                            result[0] = topRightAx;
                            result[1] = topLeftAy;
                            clipPointAFound = true;
                        }
                    } else if (slopeA === slopePrime) {
                        if (p1x > p2x) {
                            result[0] = topLeftAx;
                            result[1] = topLeftAy;
                            clipPointAFound = true;
                        } else {
                            result[0] = bottomRightAx;
                            result[1] = bottomLeftAy;
                            clipPointAFound = true;
                        }
                    }
                    //determine whether clipping point is the corner of nodeB
                    if (-slopeB === slopePrime) {
                        if (p2x > p1x) {
                            result[2] = bottomLeftBx;
                            result[3] = bottomLeftBy;
                            clipPointBFound = true;
                        } else {
                            result[2] = topRightBx;
                            result[3] = topLeftBy;
                            clipPointBFound = true;
                        }
                    } else if (slopeB === slopePrime) {
                        if (p2x > p1x) {
                            result[2] = topLeftBx;
                            result[3] = topLeftBy;
                            clipPointBFound = true;
                        } else {
                            result[2] = bottomRightBx;
                            result[3] = bottomLeftBy;
                            clipPointBFound = true;
                        }
                    }
                    //if both clipping points are corners
                    if (clipPointAFound && clipPointBFound) return false;
                    //determine Cardinal Direction of rectangles
                    if (p1x > p2x) {
                        if (p1y > p2y) {
                            cardinalDirectionA = this.getCardinalDirection(slopeA, slopePrime, 4);
                            cardinalDirectionB = this.getCardinalDirection(slopeB, slopePrime, 2);
                        } else {
                            cardinalDirectionA = this.getCardinalDirection(-slopeA, slopePrime, 3);
                            cardinalDirectionB = this.getCardinalDirection(-slopeB, slopePrime, 1);
                        }
                    } else if (p1y > p2y) {
                        cardinalDirectionA = this.getCardinalDirection(-slopeA, slopePrime, 1);
                        cardinalDirectionB = this.getCardinalDirection(-slopeB, slopePrime, 3);
                    } else {
                        cardinalDirectionA = this.getCardinalDirection(slopeA, slopePrime, 2);
                        cardinalDirectionB = this.getCardinalDirection(slopeB, slopePrime, 4);
                    }
                    //calculate clipping Point if it is not found before
                    if (!clipPointAFound) switch(cardinalDirectionA){
                        case 1:
                            tempPointAy = topLeftAy;
                            tempPointAx = p1x + -halfHeightA / slopePrime;
                            result[0] = tempPointAx;
                            result[1] = tempPointAy;
                            break;
                        case 2:
                            tempPointAx = bottomRightAx;
                            tempPointAy = p1y + halfWidthA * slopePrime;
                            result[0] = tempPointAx;
                            result[1] = tempPointAy;
                            break;
                        case 3:
                            tempPointAy = bottomLeftAy;
                            tempPointAx = p1x + halfHeightA / slopePrime;
                            result[0] = tempPointAx;
                            result[1] = tempPointAy;
                            break;
                        case 4:
                            tempPointAx = bottomLeftAx;
                            tempPointAy = p1y + -halfWidthA * slopePrime;
                            result[0] = tempPointAx;
                            result[1] = tempPointAy;
                            break;
                    }
                    if (!clipPointBFound) switch(cardinalDirectionB){
                        case 1:
                            tempPointBy = topLeftBy;
                            tempPointBx = p2x + -halfHeightB / slopePrime;
                            result[2] = tempPointBx;
                            result[3] = tempPointBy;
                            break;
                        case 2:
                            tempPointBx = bottomRightBx;
                            tempPointBy = p2y + halfWidthB * slopePrime;
                            result[2] = tempPointBx;
                            result[3] = tempPointBy;
                            break;
                        case 3:
                            tempPointBy = bottomLeftBy;
                            tempPointBx = p2x + halfHeightB / slopePrime;
                            result[2] = tempPointBx;
                            result[3] = tempPointBy;
                            break;
                        case 4:
                            tempPointBx = bottomLeftBx;
                            tempPointBy = p2y + -halfWidthB * slopePrime;
                            result[2] = tempPointBx;
                            result[3] = tempPointBy;
                            break;
                    }
                }
                return false;
            };
            /**
 * This method returns in which cardinal direction does input point stays
 * 1: North
 * 2: East
 * 3: South
 * 4: West
 */ IGeometry.getCardinalDirection = function(slope, slopePrime, line) {
                if (slope > slopePrime) return line;
                else return 1 + line % 4;
            };
            /**
 * This method calculates the intersection of the two lines defined by
 * point pairs (s1,s2) and (f1,f2).
 */ IGeometry.getIntersection = function(s1, s2, f1, f2) {
                if (f2 == null) return this.getIntersection2(s1, s2, f1);
                var x1 = s1.x;
                var y1 = s1.y;
                var x2 = s2.x;
                var y2 = s2.y;
                var x3 = f1.x;
                var y3 = f1.y;
                var x4 = f2.x;
                var y4 = f2.y;
                var x = void 0, y = void 0; // intersection point
                var a1 = void 0, a2 = void 0, b1 = void 0, b2 = void 0, c1 = void 0, c2 = void 0; // coefficients of line eqns.
                var denom = void 0;
                a1 = y2 - y1;
                b1 = x1 - x2;
                c1 = x2 * y1 - x1 * y2; // { a1*x + b1*y + c1 = 0 is line 1 }
                a2 = y4 - y3;
                b2 = x3 - x4;
                c2 = x4 * y3 - x3 * y4; // { a2*x + b2*y + c2 = 0 is line 2 }
                denom = a1 * b2 - a2 * b1;
                if (denom === 0) return null;
                x = (b1 * c2 - b2 * c1) / denom;
                y = (a2 * c1 - a1 * c2) / denom;
                return new Point1(x, y);
            };
            /**
 * This method finds and returns the angle of the vector from the + x-axis
 * in clockwise direction (compatible w/ Java coordinate system!).
 */ IGeometry.angleOfVector = function(Cx, Cy, Nx, Ny) {
                var C_angle = void 0;
                if (Cx !== Nx) {
                    C_angle = Math.atan((Ny - Cy) / (Nx - Cx));
                    if (Nx < Cx) C_angle += Math.PI;
                    else if (Ny < Cy) C_angle += this.TWO_PI;
                } else if (Ny < Cy) C_angle = this.ONE_AND_HALF_PI; // 270 degrees
                else C_angle = this.HALF_PI; // 90 degrees
                return C_angle;
            };
            /**
 * This method checks whether the given two line segments (one with point
 * p1 and p2, the other with point p3 and p4) intersect at a point other
 * than these points.
 */ IGeometry.doIntersect = function(p1, p2, p3, p4) {
                var a = p1.x;
                var b = p1.y;
                var c = p2.x;
                var d = p2.y;
                var p = p3.x;
                var q = p3.y;
                var r = p4.x;
                var s = p4.y;
                var det = (c - a) * (s - q) - (r - p) * (d - b);
                if (det === 0) return false;
                else {
                    var lambda = ((s - q) * (r - a) + (p - r) * (s - b)) / det;
                    var gamma = ((b - d) * (r - a) + (c - a) * (s - b)) / det;
                    return 0 < lambda && lambda < 1 && 0 < gamma && gamma < 1;
                }
            };
            /**
 * This method checks and calculates the intersection of 
 * a line segment and a circle.
 */ IGeometry.findCircleLineIntersections = function(Ex, Ey, Lx, Ly, Cx, Cy, r) {
                // E is the starting point of the ray,
                // L is the end point of the ray,
                // C is the center of sphere you're testing against
                // r is the radius of that sphere
                // Compute:
                // d = L - E ( Direction vector of ray, from start to end )
                // f = E - C ( Vector from center sphere to ray start )
                // Then the intersection is found by..
                // P = E + t * d
                // This is a parametric equation:
                // Px = Ex + tdx
                // Py = Ey + tdy
                // get a, b, c values
                var a = (Lx - Ex) * (Lx - Ex) + (Ly - Ey) * (Ly - Ey);
                var b = 2 * ((Ex - Cx) * (Lx - Ex) + (Ey - Cy) * (Ly - Ey));
                var c = (Ex - Cx) * (Ex - Cx) + (Ey - Cy) * (Ey - Cy) - r * r;
                // get discriminant
                var disc = b * b - 4 * a * c;
                if (disc >= 0) {
                    // insert into quadratic formula
                    var t1 = (-b + Math.sqrt(b * b - 4 * a * c)) / (2 * a);
                    var t2 = (-b - Math.sqrt(b * b - 4 * a * c)) / (2 * a);
                    var intersections = null;
                    if (t1 >= 0 && t1 <= 1) // t1 is the intersection, and it's closer than t2
                    // (since t1 uses -b - discriminant)
                    // Impale, Poke
                    return [
                        t1
                    ];
                    // here t1 didn't intersect so we are either started
                    // inside the sphere or completely past it
                    if (t2 >= 0 && t2 <= 1) // ExitWound
                    return [
                        t2
                    ];
                    return intersections;
                } else return null;
            };
            // -----------------------------------------------------------------------------
            // Section: Class Constants
            // -----------------------------------------------------------------------------
            /**
 * Some useful pre-calculated constants
 */ IGeometry.HALF_PI = 0.5 * Math.PI;
            IGeometry.ONE_AND_HALF_PI = 1.5 * Math.PI;
            IGeometry.TWO_PI = 2.0 * Math.PI;
            IGeometry.THREE_PI = 3.0 * Math.PI;
            module1.exports = IGeometry;
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function IMath() {}
            /**
 * This method returns the sign of the input value.
 */ IMath.sign = function(value) {
                if (value > 0) return 1;
                else if (value < 0) return -1;
                else return 0;
            };
            IMath.floor = function(value) {
                return value < 0 ? Math.ceil(value) : Math.floor(value);
            };
            IMath.ceil = function(value) {
                return value < 0 ? Math.floor(value) : Math.ceil(value);
            };
            module1.exports = IMath;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function Integer() {}
            Integer.MAX_VALUE = 2147483647;
            Integer.MIN_VALUE = -2147483648;
            module1.exports = Integer;
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var nodeFrom = function nodeFrom(value) {
                return {
                    value: value,
                    next: null,
                    prev: null
                };
            };
            var add = function add(prev, node, next, list) {
                if (prev !== null) prev.next = node;
                else list.head = node;
                if (next !== null) next.prev = node;
                else list.tail = node;
                node.prev = prev;
                node.next = next;
                list.length++;
                return node;
            };
            var _remove = function _remove(node, list) {
                var prev = node.prev, next = node.next;
                if (prev !== null) prev.next = next;
                else list.head = next;
                if (next !== null) next.prev = prev;
                else list.tail = prev;
                node.prev = node.next = null;
                list.length--;
                return node;
            };
            var LinkedList = function() {
                function LinkedList(vals) {
                    var _this = this;
                    _classCallCheck(this, LinkedList);
                    this.length = 0;
                    this.head = null;
                    this.tail = null;
                    if (vals != null) vals.forEach(function(v) {
                        return _this.push(v);
                    });
                }
                _createClass(LinkedList, [
                    {
                        key: "size",
                        value: function size() {
                            return this.length;
                        }
                    },
                    {
                        key: "insertBefore",
                        value: function insertBefore(val, otherNode) {
                            return add(otherNode.prev, nodeFrom(val), otherNode, this);
                        }
                    },
                    {
                        key: "insertAfter",
                        value: function insertAfter(val, otherNode) {
                            return add(otherNode, nodeFrom(val), otherNode.next, this);
                        }
                    },
                    {
                        key: "insertNodeBefore",
                        value: function insertNodeBefore(newNode, otherNode) {
                            return add(otherNode.prev, newNode, otherNode, this);
                        }
                    },
                    {
                        key: "insertNodeAfter",
                        value: function insertNodeAfter(newNode, otherNode) {
                            return add(otherNode, newNode, otherNode.next, this);
                        }
                    },
                    {
                        key: "push",
                        value: function push(val) {
                            return add(this.tail, nodeFrom(val), null, this);
                        }
                    },
                    {
                        key: "unshift",
                        value: function unshift(val) {
                            return add(null, nodeFrom(val), this.head, this);
                        }
                    },
                    {
                        key: "remove",
                        value: function remove(node) {
                            return _remove(node, this);
                        }
                    },
                    {
                        key: "pop",
                        value: function pop() {
                            return _remove(this.tail, this).value;
                        }
                    },
                    {
                        key: "popNode",
                        value: function popNode() {
                            return _remove(this.tail, this);
                        }
                    },
                    {
                        key: "shift",
                        value: function shift() {
                            return _remove(this.head, this).value;
                        }
                    },
                    {
                        key: "shiftNode",
                        value: function shiftNode() {
                            return _remove(this.head, this);
                        }
                    },
                    {
                        key: "get_object_at",
                        value: function get_object_at(index) {
                            if (index <= this.length()) {
                                var i = 1;
                                var current = this.head;
                                while(i < index){
                                    current = current.next;
                                    i++;
                                }
                                return current.value;
                            }
                        }
                    },
                    {
                        key: "set_object_at",
                        value: function set_object_at(index, value) {
                            if (index <= this.length()) {
                                var i = 1;
                                var current = this.head;
                                while(i < index){
                                    current = current.next;
                                    i++;
                                }
                                current.value = value;
                            }
                        }
                    }
                ]);
                return LinkedList;
            }();
            module1.exports = LinkedList;
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /*
 *This class is the javascript implementation of the Point.java class in jdk
 */ function Point1(x, y, p) {
                this.x = null;
                this.y = null;
                if (x == null && y == null && p == null) {
                    this.x = 0;
                    this.y = 0;
                } else if (typeof x == 'number' && typeof y == 'number' && p == null) {
                    this.x = x;
                    this.y = y;
                } else if (x.constructor.name == 'Point' && y == null && p == null) {
                    p = x;
                    this.x = p.x;
                    this.y = p.y;
                }
            }
            Point1.prototype.getX = function() {
                return this.x;
            };
            Point1.prototype.getY = function() {
                return this.y;
            };
            Point1.prototype.getLocation = function() {
                return new Point1(this.x, this.y);
            };
            Point1.prototype.setLocation = function(x, y, p) {
                if (x.constructor.name == 'Point' && y == null && p == null) {
                    p = x;
                    this.setLocation(p.x, p.y);
                } else if (typeof x == 'number' && typeof y == 'number' && p == null) {
                    //if both parameters are integer just move (x,y) location
                    if (parseInt(x) == x && parseInt(y) == y) this.move(x, y);
                    else {
                        this.x = Math.floor(x + 0.5);
                        this.y = Math.floor(y + 0.5);
                    }
                }
            };
            Point1.prototype.move = function(x, y) {
                this.x = x;
                this.y = y;
            };
            Point1.prototype.translate = function(dx, dy) {
                this.x += dx;
                this.y += dy;
            };
            Point1.prototype.equals = function(obj) {
                if (obj.constructor.name == "Point") {
                    var pt = obj;
                    return this.x == pt.x && this.y == pt.y;
                }
                return this == obj;
            };
            Point1.prototype.toString = function() {
                return new Point1().constructor.name + "[x=" + this.x + ",y=" + this.y + "]";
            };
            module1.exports = Point1;
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function RectangleD(x, y, width, height) {
                this.x = 0;
                this.y = 0;
                this.width = 0;
                this.height = 0;
                if (x != null && y != null && width != null && height != null) {
                    this.x = x;
                    this.y = y;
                    this.width = width;
                    this.height = height;
                }
            }
            RectangleD.prototype.getX = function() {
                return this.x;
            };
            RectangleD.prototype.setX = function(x) {
                this.x = x;
            };
            RectangleD.prototype.getY = function() {
                return this.y;
            };
            RectangleD.prototype.setY = function(y) {
                this.y = y;
            };
            RectangleD.prototype.getWidth = function() {
                return this.width;
            };
            RectangleD.prototype.setWidth = function(width) {
                this.width = width;
            };
            RectangleD.prototype.getHeight = function() {
                return this.height;
            };
            RectangleD.prototype.setHeight = function(height) {
                this.height = height;
            };
            RectangleD.prototype.getRight = function() {
                return this.x + this.width;
            };
            RectangleD.prototype.getBottom = function() {
                return this.y + this.height;
            };
            RectangleD.prototype.intersects = function(a) {
                if (this.getRight() < a.x) return false;
                if (this.getBottom() < a.y) return false;
                if (a.getRight() < this.x) return false;
                if (a.getBottom() < this.y) return false;
                return true;
            };
            RectangleD.prototype.getCenterX = function() {
                return this.x + this.width / 2;
            };
            RectangleD.prototype.getMinX = function() {
                return this.getX();
            };
            RectangleD.prototype.getMaxX = function() {
                return this.getX() + this.width;
            };
            RectangleD.prototype.getCenterY = function() {
                return this.y + this.height / 2;
            };
            RectangleD.prototype.getMinY = function() {
                return this.getY();
            };
            RectangleD.prototype.getMaxY = function() {
                return this.getY() + this.height;
            };
            RectangleD.prototype.getWidthHalf = function() {
                return this.width / 2;
            };
            RectangleD.prototype.getHeightHalf = function() {
                return this.height / 2;
            };
            module1.exports = RectangleD;
        /***/ },
        /* 14 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            function UniqueIDGeneretor() {}
            UniqueIDGeneretor.lastID = 0;
            UniqueIDGeneretor.createID = function(obj) {
                if (UniqueIDGeneretor.isPrimitive(obj)) return obj;
                if (obj.uniqueID != null) return obj.uniqueID;
                obj.uniqueID = UniqueIDGeneretor.getString();
                UniqueIDGeneretor.lastID++;
                return obj.uniqueID;
            };
            UniqueIDGeneretor.getString = function(id) {
                if (id == null) id = UniqueIDGeneretor.lastID;
                return "Object#" + id + "";
            };
            UniqueIDGeneretor.isPrimitive = function(arg) {
                var type = typeof arg === "undefined" ? "undefined" : _typeof(arg);
                return arg == null || type != "object" && type != "function";
            };
            module1.exports = UniqueIDGeneretor;
        /***/ },
        /* 15 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function _toConsumableArray(arr) {
                if (Array.isArray(arr)) {
                    for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                    return arr2;
                } else return Array.from(arr);
            }
            var LayoutConstants = __webpack_require__(0);
            var LGraphManager = __webpack_require__(7);
            var LNode = __webpack_require__(3);
            var LEdge = __webpack_require__(1);
            var LGraph = __webpack_require__(6);
            var PointD = __webpack_require__(5);
            var Transform = __webpack_require__(17);
            var Emitter = __webpack_require__(29);
            function Layout1(isRemoteUse) {
                Emitter.call(this);
                //Layout Quality: 0:draft, 1:default, 2:proof
                this.layoutQuality = LayoutConstants.QUALITY;
                //Whether layout should create bendpoints as needed or not
                this.createBendsAsNeeded = LayoutConstants.DEFAULT_CREATE_BENDS_AS_NEEDED;
                //Whether layout should be incremental or not
                this.incremental = LayoutConstants.DEFAULT_INCREMENTAL;
                //Whether we animate from before to after layout node positions
                this.animationOnLayout = LayoutConstants.DEFAULT_ANIMATION_ON_LAYOUT;
                //Whether we animate the layout process or not
                this.animationDuringLayout = LayoutConstants.DEFAULT_ANIMATION_DURING_LAYOUT;
                //Number iterations that should be done between two successive animations
                this.animationPeriod = LayoutConstants.DEFAULT_ANIMATION_PERIOD;
                /**
   * Whether or not leaf nodes (non-compound nodes) are of uniform sizes. When
   * they are, both spring and repulsion forces between two leaf nodes can be
   * calculated without the expensive clipping point calculations, resulting
   * in major speed-up.
   */ this.uniformLeafNodeSizes = LayoutConstants.DEFAULT_UNIFORM_LEAF_NODE_SIZES;
                /**
   * This is used for creation of bendpoints by using dummy nodes and edges.
   * Maps an LEdge to its dummy bendpoint path.
   */ this.edgeToDummyNodes = new Map();
                this.graphManager = new LGraphManager(this);
                this.isLayoutFinished = false;
                this.isSubLayout = false;
                this.isRemoteUse = false;
                if (isRemoteUse != null) this.isRemoteUse = isRemoteUse;
            }
            Layout1.RANDOM_SEED = 1;
            Layout1.prototype = Object.create(Emitter.prototype);
            Layout1.prototype.getGraphManager = function() {
                return this.graphManager;
            };
            Layout1.prototype.getAllNodes = function() {
                return this.graphManager.getAllNodes();
            };
            Layout1.prototype.getAllEdges = function() {
                return this.graphManager.getAllEdges();
            };
            Layout1.prototype.getAllNodesToApplyGravitation = function() {
                return this.graphManager.getAllNodesToApplyGravitation();
            };
            Layout1.prototype.newGraphManager = function() {
                var gm = new LGraphManager(this);
                this.graphManager = gm;
                return gm;
            };
            Layout1.prototype.newGraph = function(vGraph) {
                return new LGraph(null, this.graphManager, vGraph);
            };
            Layout1.prototype.newNode = function(vNode) {
                return new LNode(this.graphManager, vNode);
            };
            Layout1.prototype.newEdge = function(vEdge) {
                return new LEdge(null, null, vEdge);
            };
            Layout1.prototype.checkLayoutSuccess = function() {
                return this.graphManager.getRoot() == null || this.graphManager.getRoot().getNodes().length == 0 || this.graphManager.includesInvalidEdge();
            };
            Layout1.prototype.runLayout = function() {
                this.isLayoutFinished = false;
                if (this.tilingPreLayout) this.tilingPreLayout();
                this.initParameters();
                var isLayoutSuccessfull;
                if (this.checkLayoutSuccess()) isLayoutSuccessfull = false;
                else isLayoutSuccessfull = this.layout();
                if (LayoutConstants.ANIMATE === 'during') // If this is a 'during' layout animation. Layout is not finished yet. 
                // We need to perform these in index.js when layout is really finished.
                return false;
                if (isLayoutSuccessfull) {
                    if (!this.isSubLayout) this.doPostLayout();
                }
                if (this.tilingPostLayout) this.tilingPostLayout();
                this.isLayoutFinished = true;
                return isLayoutSuccessfull;
            };
            /**
 * This method performs the operations required after layout.
 */ Layout1.prototype.doPostLayout = function() {
                //assert !isSubLayout : "Should not be called on sub-layout!";
                // Propagate geometric changes to v-level objects
                if (!this.incremental) this.transform();
                this.update();
            };
            /**
 * This method updates the geometry of the target graph according to
 * calculated layout.
 */ Layout1.prototype.update2 = function() {
                // update bend points
                if (this.createBendsAsNeeded) {
                    this.createBendpointsFromDummyNodes();
                    // reset all edges, since the topology has changed
                    this.graphManager.resetAllEdges();
                }
                // perform edge, node and root updates if layout is not called
                // remotely
                if (!this.isRemoteUse) {
                    // update all edges
                    var edge;
                    var allEdges = this.graphManager.getAllEdges();
                    for(var i = 0; i < allEdges.length; i++)edge = allEdges[i];
                    // recursively update nodes
                    var node;
                    var nodes = this.graphManager.getRoot().getNodes();
                    for(var i = 0; i < nodes.length; i++)node = nodes[i];
                    // update root graph
                    this.update(this.graphManager.getRoot());
                }
            };
            Layout1.prototype.update = function(obj) {
                if (obj == null) this.update2();
                else if (obj instanceof LNode) {
                    var node = obj;
                    if (node.getChild() != null) {
                        // since node is compound, recursively update child nodes
                        var nodes = node.getChild().getNodes();
                        for(var i = 0; i < nodes.length; i++)update(nodes[i]);
                    }
                    // if the l-level node is associated with a v-level graph object,
                    // then it is assumed that the v-level node implements the
                    // interface Updatable.
                    if (node.vGraphObject != null) {
                        // cast to Updatable without any type check
                        var vNode = node.vGraphObject;
                        // call the update method of the interface
                        vNode.update(node);
                    }
                } else if (obj instanceof LEdge) {
                    var edge = obj;
                    // if the l-level edge is associated with a v-level graph object,
                    // then it is assumed that the v-level edge implements the
                    // interface Updatable.
                    if (edge.vGraphObject != null) {
                        // cast to Updatable without any type check
                        var vEdge = edge.vGraphObject;
                        // call the update method of the interface
                        vEdge.update(edge);
                    }
                } else if (obj instanceof LGraph) {
                    var graph = obj;
                    // if the l-level graph is associated with a v-level graph object,
                    // then it is assumed that the v-level object implements the
                    // interface Updatable.
                    if (graph.vGraphObject != null) {
                        // cast to Updatable without any type check
                        var vGraph = graph.vGraphObject;
                        // call the update method of the interface
                        vGraph.update(graph);
                    }
                }
            };
            /**
 * This method is used to set all layout parameters to default values
 * determined at compile time.
 */ Layout1.prototype.initParameters = function() {
                if (!this.isSubLayout) {
                    this.layoutQuality = LayoutConstants.QUALITY;
                    this.animationDuringLayout = LayoutConstants.DEFAULT_ANIMATION_DURING_LAYOUT;
                    this.animationPeriod = LayoutConstants.DEFAULT_ANIMATION_PERIOD;
                    this.animationOnLayout = LayoutConstants.DEFAULT_ANIMATION_ON_LAYOUT;
                    this.incremental = LayoutConstants.DEFAULT_INCREMENTAL;
                    this.createBendsAsNeeded = LayoutConstants.DEFAULT_CREATE_BENDS_AS_NEEDED;
                    this.uniformLeafNodeSizes = LayoutConstants.DEFAULT_UNIFORM_LEAF_NODE_SIZES;
                }
                if (this.animationDuringLayout) this.animationOnLayout = false;
            };
            Layout1.prototype.transform = function(newLeftTop) {
                if (newLeftTop == undefined) this.transform(new PointD(0, 0));
                else {
                    // create a transformation object (from Eclipse to layout). When an
                    // inverse transform is applied, we get upper-left coordinate of the
                    // drawing or the root graph at given input coordinate (some margins
                    // already included in calculation of left-top).
                    var trans = new Transform();
                    var leftTop = this.graphManager.getRoot().updateLeftTop();
                    if (leftTop != null) {
                        trans.setWorldOrgX(newLeftTop.x);
                        trans.setWorldOrgY(newLeftTop.y);
                        trans.setDeviceOrgX(leftTop.x);
                        trans.setDeviceOrgY(leftTop.y);
                        var nodes = this.getAllNodes();
                        var node;
                        for(var i = 0; i < nodes.length; i++){
                            node = nodes[i];
                            node.transform(trans);
                        }
                    }
                }
            };
            Layout1.prototype.positionNodesRandomly = function(graph) {
                if (graph == undefined) {
                    //assert !this.incremental;
                    this.positionNodesRandomly(this.getGraphManager().getRoot());
                    this.getGraphManager().getRoot().updateBounds(true);
                } else {
                    var lNode;
                    var childGraph;
                    var nodes = graph.getNodes();
                    for(var i = 0; i < nodes.length; i++){
                        lNode = nodes[i];
                        childGraph = lNode.getChild();
                        if (childGraph == null) lNode.scatter();
                        else if (childGraph.getNodes().length == 0) lNode.scatter();
                        else {
                            this.positionNodesRandomly(childGraph);
                            lNode.updateBounds();
                        }
                    }
                }
            };
            /**
 * This method returns a list of trees where each tree is represented as a
 * list of l-nodes. The method returns a list of size 0 when:
 * - The graph is not flat or
 * - One of the component(s) of the graph is not a tree.
 */ Layout1.prototype.getFlatForest = function() {
                var flatForest = [];
                var isForest = true;
                // Quick reference for all nodes in the graph manager associated with
                // this layout. The list should not be changed.
                var allNodes = this.graphManager.getRoot().getNodes();
                // First be sure that the graph is flat
                var isFlat = true;
                for(var i = 0; i < allNodes.length; i++)if (allNodes[i].getChild() != null) isFlat = false;
                // Return empty forest if the graph is not flat.
                if (!isFlat) return flatForest;
                // Run BFS for each component of the graph.
                var visited = new Set();
                var toBeVisited = [];
                var parents = new Map();
                var unProcessedNodes = [];
                unProcessedNodes = unProcessedNodes.concat(allNodes);
                // Each iteration of this loop finds a component of the graph and
                // decides whether it is a tree or not. If it is a tree, adds it to the
                // forest and continued with the next component.
                while(unProcessedNodes.length > 0 && isForest){
                    toBeVisited.push(unProcessedNodes[0]);
                    // Start the BFS. Each iteration of this loop visits a node in a
                    // BFS manner.
                    while(toBeVisited.length > 0 && isForest){
                        //pool operation
                        var currentNode = toBeVisited[0];
                        toBeVisited.splice(0, 1);
                        visited.add(currentNode);
                        // Traverse all neighbors of this node
                        var neighborEdges = currentNode.getEdges();
                        for(var i = 0; i < neighborEdges.length; i++){
                            var currentNeighbor = neighborEdges[i].getOtherEnd(currentNode);
                            // If BFS is not growing from this neighbor.
                            if (parents.get(currentNode) != currentNeighbor) {
                                // We haven't previously visited this neighbor.
                                if (!visited.has(currentNeighbor)) {
                                    toBeVisited.push(currentNeighbor);
                                    parents.set(currentNeighbor, currentNode);
                                } else {
                                    isForest = false;
                                    break;
                                }
                            }
                        }
                    }
                    // The graph contains a component that is not a tree. Empty
                    // previously found trees. The method will end.
                    if (!isForest) flatForest = [];
                    else {
                        var temp = [].concat(_toConsumableArray(visited));
                        flatForest.push(temp);
                        //flatForest = flatForest.concat(temp);
                        //unProcessedNodes.removeAll(visited);
                        for(var i = 0; i < temp.length; i++){
                            var value = temp[i];
                            var index = unProcessedNodes.indexOf(value);
                            if (index > -1) unProcessedNodes.splice(index, 1);
                        }
                        visited = new Set();
                        parents = new Map();
                    }
                }
                return flatForest;
            };
            /**
 * This method creates dummy nodes (an l-level node with minimal dimensions)
 * for the given edge (one per bendpoint). The existing l-level structure
 * is updated accordingly.
 */ Layout1.prototype.createDummyNodesForBendpoints = function(edge) {
                var dummyNodes = [];
                var prev = edge.source;
                var graph = this.graphManager.calcLowestCommonAncestor(edge.source, edge.target);
                for(var i = 0; i < edge.bendpoints.length; i++){
                    // create new dummy node
                    var dummyNode = this.newNode(null);
                    dummyNode.setRect(new Point(0, 0), new Dimension(1, 1));
                    graph.add(dummyNode);
                    // create new dummy edge between prev and dummy node
                    var dummyEdge = this.newEdge(null);
                    this.graphManager.add(dummyEdge, prev, dummyNode);
                    dummyNodes.add(dummyNode);
                    prev = dummyNode;
                }
                var dummyEdge = this.newEdge(null);
                this.graphManager.add(dummyEdge, prev, edge.target);
                this.edgeToDummyNodes.set(edge, dummyNodes);
                // remove real edge from graph manager if it is inter-graph
                if (edge.isInterGraph()) this.graphManager.remove(edge);
                else graph.remove(edge);
                return dummyNodes;
            };
            /**
 * This method creates bendpoints for edges from the dummy nodes
 * at l-level.
 */ Layout1.prototype.createBendpointsFromDummyNodes = function() {
                var edges = [];
                edges = edges.concat(this.graphManager.getAllEdges());
                edges = [].concat(_toConsumableArray(this.edgeToDummyNodes.keys())).concat(edges);
                for(var k = 0; k < edges.length; k++){
                    var lEdge = edges[k];
                    if (lEdge.bendpoints.length > 0) {
                        var path = this.edgeToDummyNodes.get(lEdge);
                        for(var i = 0; i < path.length; i++){
                            var dummyNode = path[i];
                            var p = new PointD(dummyNode.getCenterX(), dummyNode.getCenterY());
                            // update bendpoint's location according to dummy node
                            var ebp = lEdge.bendpoints.get(i);
                            ebp.x = p.x;
                            ebp.y = p.y;
                            // remove the dummy node, dummy edges incident with this
                            // dummy node is also removed (within the remove method)
                            dummyNode.getOwner().remove(dummyNode);
                        }
                        // add the real edge to graph
                        this.graphManager.add(lEdge, lEdge.source, lEdge.target);
                    }
                }
            };
            Layout1.transform = function(sliderValue, defaultValue, minDiv, maxMul) {
                if (minDiv != undefined && maxMul != undefined) {
                    var value = defaultValue;
                    if (sliderValue <= 50) {
                        var minValue = defaultValue / minDiv;
                        value -= (defaultValue - minValue) / 50 * (50 - sliderValue);
                    } else {
                        var maxValue = defaultValue * maxMul;
                        value += (maxValue - defaultValue) / 50 * (sliderValue - 50);
                    }
                    return value;
                } else {
                    var a, b;
                    if (sliderValue <= 50) {
                        a = 9.0 * defaultValue / 500.0;
                        b = defaultValue / 10.0;
                    } else {
                        a = 9.0 * defaultValue / 50.0;
                        b = -8 * defaultValue;
                    }
                    return a * sliderValue + b;
                }
            };
            /**
 * This method finds and returns the center of the given nodes, assuming
 * that the given nodes form a tree in themselves.
 */ Layout1.findCenterOfTree = function(nodes) {
                var list = [];
                list = list.concat(nodes);
                var removedNodes = [];
                var remainingDegrees = new Map();
                var foundCenter = false;
                var centerNode = null;
                if (list.length == 1 || list.length == 2) {
                    foundCenter = true;
                    centerNode = list[0];
                }
                for(var i = 0; i < list.length; i++){
                    var node = list[i];
                    var degree = node.getNeighborsList().size;
                    remainingDegrees.set(node, node.getNeighborsList().size);
                    if (degree == 1) removedNodes.push(node);
                }
                var tempList = [];
                tempList = tempList.concat(removedNodes);
                while(!foundCenter){
                    var tempList2 = [];
                    tempList2 = tempList2.concat(tempList);
                    tempList = [];
                    for(var i = 0; i < list.length; i++){
                        var node = list[i];
                        var index = list.indexOf(node);
                        if (index >= 0) list.splice(index, 1);
                        var neighbours = node.getNeighborsList();
                        neighbours.forEach(function(neighbour) {
                            if (removedNodes.indexOf(neighbour) < 0) {
                                var otherDegree = remainingDegrees.get(neighbour);
                                var newDegree = otherDegree - 1;
                                if (newDegree == 1) tempList.push(neighbour);
                                remainingDegrees.set(neighbour, newDegree);
                            }
                        });
                    }
                    removedNodes = removedNodes.concat(tempList);
                    if (list.length == 1 || list.length == 2) {
                        foundCenter = true;
                        centerNode = list[0];
                    }
                }
                return centerNode;
            };
            /**
 * During the coarsening process, this layout may be referenced by two graph managers
 * this setter function grants access to change the currently being used graph manager
 */ Layout1.prototype.setGraphManager = function(gm) {
                this.graphManager = gm;
            };
            module1.exports = Layout1;
        /***/ },
        /* 16 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function RandomSeed() {}
            // adapted from: https://stackoverflow.com/a/19303725
            RandomSeed.seed = 1;
            RandomSeed.x = 0;
            RandomSeed.nextDouble = function() {
                RandomSeed.x = Math.sin(RandomSeed.seed++) * 10000;
                return RandomSeed.x - Math.floor(RandomSeed.x);
            };
            module1.exports = RandomSeed;
        /***/ },
        /* 17 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var PointD = __webpack_require__(5);
            function Transform(x, y) {
                this.lworldOrgX = 0.0;
                this.lworldOrgY = 0.0;
                this.ldeviceOrgX = 0.0;
                this.ldeviceOrgY = 0.0;
                this.lworldExtX = 1.0;
                this.lworldExtY = 1.0;
                this.ldeviceExtX = 1.0;
                this.ldeviceExtY = 1.0;
            }
            Transform.prototype.getWorldOrgX = function() {
                return this.lworldOrgX;
            };
            Transform.prototype.setWorldOrgX = function(wox) {
                this.lworldOrgX = wox;
            };
            Transform.prototype.getWorldOrgY = function() {
                return this.lworldOrgY;
            };
            Transform.prototype.setWorldOrgY = function(woy) {
                this.lworldOrgY = woy;
            };
            Transform.prototype.getWorldExtX = function() {
                return this.lworldExtX;
            };
            Transform.prototype.setWorldExtX = function(wex) {
                this.lworldExtX = wex;
            };
            Transform.prototype.getWorldExtY = function() {
                return this.lworldExtY;
            };
            Transform.prototype.setWorldExtY = function(wey) {
                this.lworldExtY = wey;
            };
            /* Device related */ Transform.prototype.getDeviceOrgX = function() {
                return this.ldeviceOrgX;
            };
            Transform.prototype.setDeviceOrgX = function(dox) {
                this.ldeviceOrgX = dox;
            };
            Transform.prototype.getDeviceOrgY = function() {
                return this.ldeviceOrgY;
            };
            Transform.prototype.setDeviceOrgY = function(doy) {
                this.ldeviceOrgY = doy;
            };
            Transform.prototype.getDeviceExtX = function() {
                return this.ldeviceExtX;
            };
            Transform.prototype.setDeviceExtX = function(dex) {
                this.ldeviceExtX = dex;
            };
            Transform.prototype.getDeviceExtY = function() {
                return this.ldeviceExtY;
            };
            Transform.prototype.setDeviceExtY = function(dey) {
                this.ldeviceExtY = dey;
            };
            Transform.prototype.transformX = function(x) {
                var xDevice = 0.0;
                var worldExtX = this.lworldExtX;
                if (worldExtX != 0.0) xDevice = this.ldeviceOrgX + (x - this.lworldOrgX) * this.ldeviceExtX / worldExtX;
                return xDevice;
            };
            Transform.prototype.transformY = function(y) {
                var yDevice = 0.0;
                var worldExtY = this.lworldExtY;
                if (worldExtY != 0.0) yDevice = this.ldeviceOrgY + (y - this.lworldOrgY) * this.ldeviceExtY / worldExtY;
                return yDevice;
            };
            Transform.prototype.inverseTransformX = function(x) {
                var xWorld = 0.0;
                var deviceExtX = this.ldeviceExtX;
                if (deviceExtX != 0.0) xWorld = this.lworldOrgX + (x - this.ldeviceOrgX) * this.lworldExtX / deviceExtX;
                return xWorld;
            };
            Transform.prototype.inverseTransformY = function(y) {
                var yWorld = 0.0;
                var deviceExtY = this.ldeviceExtY;
                if (deviceExtY != 0.0) yWorld = this.lworldOrgY + (y - this.ldeviceOrgY) * this.lworldExtY / deviceExtY;
                return yWorld;
            };
            Transform.prototype.inverseTransformPoint = function(inPoint) {
                var outPoint = new PointD(this.inverseTransformX(inPoint.x), this.inverseTransformY(inPoint.y));
                return outPoint;
            };
            module1.exports = Transform;
        /***/ },
        /* 18 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function _toConsumableArray(arr) {
                if (Array.isArray(arr)) {
                    for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                    return arr2;
                } else return Array.from(arr);
            }
            var Layout1 = __webpack_require__(15);
            var FDLayoutConstants = __webpack_require__(4);
            var LayoutConstants = __webpack_require__(0);
            var IGeometry = __webpack_require__(8);
            var IMath = __webpack_require__(9);
            function FDLayout() {
                Layout1.call(this);
                this.useSmartIdealEdgeLengthCalculation = FDLayoutConstants.DEFAULT_USE_SMART_IDEAL_EDGE_LENGTH_CALCULATION;
                this.gravityConstant = FDLayoutConstants.DEFAULT_GRAVITY_STRENGTH;
                this.compoundGravityConstant = FDLayoutConstants.DEFAULT_COMPOUND_GRAVITY_STRENGTH;
                this.gravityRangeFactor = FDLayoutConstants.DEFAULT_GRAVITY_RANGE_FACTOR;
                this.compoundGravityRangeFactor = FDLayoutConstants.DEFAULT_COMPOUND_GRAVITY_RANGE_FACTOR;
                this.displacementThresholdPerNode = 3.0 * FDLayoutConstants.DEFAULT_EDGE_LENGTH / 100;
                this.coolingFactor = FDLayoutConstants.DEFAULT_COOLING_FACTOR_INCREMENTAL;
                this.initialCoolingFactor = FDLayoutConstants.DEFAULT_COOLING_FACTOR_INCREMENTAL;
                this.totalDisplacement = 0.0;
                this.oldTotalDisplacement = 0.0;
                this.maxIterations = FDLayoutConstants.MAX_ITERATIONS;
            }
            FDLayout.prototype = Object.create(Layout1.prototype);
            for(var prop in Layout1)FDLayout[prop] = Layout1[prop];
            FDLayout.prototype.initParameters = function() {
                Layout1.prototype.initParameters.call(this, arguments);
                this.totalIterations = 0;
                this.notAnimatedIterations = 0;
                this.useFRGridVariant = FDLayoutConstants.DEFAULT_USE_SMART_REPULSION_RANGE_CALCULATION;
                this.grid = [];
            };
            FDLayout.prototype.calcIdealEdgeLengths = function() {
                var edge;
                var originalIdealLength;
                var lcaDepth;
                var source;
                var target;
                var sizeOfSourceInLca;
                var sizeOfTargetInLca;
                var allEdges = this.getGraphManager().getAllEdges();
                for(var i = 0; i < allEdges.length; i++){
                    edge = allEdges[i];
                    originalIdealLength = edge.idealLength;
                    if (edge.isInterGraph) {
                        source = edge.getSource();
                        target = edge.getTarget();
                        sizeOfSourceInLca = edge.getSourceInLca().getEstimatedSize();
                        sizeOfTargetInLca = edge.getTargetInLca().getEstimatedSize();
                        if (this.useSmartIdealEdgeLengthCalculation) edge.idealLength += sizeOfSourceInLca + sizeOfTargetInLca - 2 * LayoutConstants.SIMPLE_NODE_SIZE;
                        lcaDepth = edge.getLca().getInclusionTreeDepth();
                        edge.idealLength += originalIdealLength * FDLayoutConstants.PER_LEVEL_IDEAL_EDGE_LENGTH_FACTOR * (source.getInclusionTreeDepth() + target.getInclusionTreeDepth() - 2 * lcaDepth);
                    }
                }
            };
            FDLayout.prototype.initSpringEmbedder = function() {
                var s = this.getAllNodes().length;
                if (this.incremental) {
                    if (s > FDLayoutConstants.ADAPTATION_LOWER_NODE_LIMIT) this.coolingFactor = Math.max(this.coolingFactor * FDLayoutConstants.COOLING_ADAPTATION_FACTOR, this.coolingFactor - (s - FDLayoutConstants.ADAPTATION_LOWER_NODE_LIMIT) / (FDLayoutConstants.ADAPTATION_UPPER_NODE_LIMIT - FDLayoutConstants.ADAPTATION_LOWER_NODE_LIMIT) * this.coolingFactor * (1 - FDLayoutConstants.COOLING_ADAPTATION_FACTOR));
                    this.maxNodeDisplacement = FDLayoutConstants.MAX_NODE_DISPLACEMENT_INCREMENTAL;
                } else {
                    if (s > FDLayoutConstants.ADAPTATION_LOWER_NODE_LIMIT) this.coolingFactor = Math.max(FDLayoutConstants.COOLING_ADAPTATION_FACTOR, 1.0 - (s - FDLayoutConstants.ADAPTATION_LOWER_NODE_LIMIT) / (FDLayoutConstants.ADAPTATION_UPPER_NODE_LIMIT - FDLayoutConstants.ADAPTATION_LOWER_NODE_LIMIT) * (1 - FDLayoutConstants.COOLING_ADAPTATION_FACTOR));
                    else this.coolingFactor = 1.0;
                    this.initialCoolingFactor = this.coolingFactor;
                    this.maxNodeDisplacement = FDLayoutConstants.MAX_NODE_DISPLACEMENT;
                }
                this.maxIterations = Math.max(this.getAllNodes().length * 5, this.maxIterations);
                // Reassign this attribute by using new constant value
                this.displacementThresholdPerNode = 3.0 * FDLayoutConstants.DEFAULT_EDGE_LENGTH / 100;
                this.totalDisplacementThreshold = this.displacementThresholdPerNode * this.getAllNodes().length;
                this.repulsionRange = this.calcRepulsionRange();
            };
            FDLayout.prototype.calcSpringForces = function() {
                var lEdges = this.getAllEdges();
                var edge;
                for(var i = 0; i < lEdges.length; i++){
                    edge = lEdges[i];
                    this.calcSpringForce(edge, edge.idealLength);
                }
            };
            FDLayout.prototype.calcRepulsionForces = function() {
                var gridUpdateAllowed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var forceToNodeSurroundingUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var i, j;
                var nodeA, nodeB;
                var lNodes = this.getAllNodes();
                var processedNodeSet;
                if (this.useFRGridVariant) {
                    if (this.totalIterations % FDLayoutConstants.GRID_CALCULATION_CHECK_PERIOD == 1 && gridUpdateAllowed) this.updateGrid();
                    processedNodeSet = new Set();
                    // calculate repulsion forces between each nodes and its surrounding
                    for(i = 0; i < lNodes.length; i++){
                        nodeA = lNodes[i];
                        this.calculateRepulsionForceOfANode(nodeA, processedNodeSet, gridUpdateAllowed, forceToNodeSurroundingUpdate);
                        processedNodeSet.add(nodeA);
                    }
                } else for(i = 0; i < lNodes.length; i++){
                    nodeA = lNodes[i];
                    for(j = i + 1; j < lNodes.length; j++){
                        nodeB = lNodes[j];
                        // If both nodes are not members of the same graph, skip.
                        if (nodeA.getOwner() != nodeB.getOwner()) continue;
                        this.calcRepulsionForce(nodeA, nodeB);
                    }
                }
            };
            FDLayout.prototype.calcGravitationalForces = function() {
                var node;
                var lNodes = this.getAllNodesToApplyGravitation();
                for(var i = 0; i < lNodes.length; i++){
                    node = lNodes[i];
                    this.calcGravitationalForce(node);
                }
            };
            FDLayout.prototype.moveNodes = function() {
                var lNodes = this.getAllNodes();
                var node;
                for(var i = 0; i < lNodes.length; i++){
                    node = lNodes[i];
                    node.move();
                }
            };
            FDLayout.prototype.calcSpringForce = function(edge, idealLength) {
                var sourceNode = edge.getSource();
                var targetNode = edge.getTarget();
                var length;
                var springForce;
                var springForceX;
                var springForceY;
                // Update edge length
                if (this.uniformLeafNodeSizes && sourceNode.getChild() == null && targetNode.getChild() == null) edge.updateLengthSimple();
                else {
                    edge.updateLength();
                    if (edge.isOverlapingSourceAndTarget) return;
                }
                length = edge.getLength();
                if (length == 0) return;
                // Calculate spring forces
                springForce = edge.edgeElasticity * (length - idealLength);
                // Project force onto x and y axes
                springForceX = springForce * (edge.lengthX / length);
                springForceY = springForce * (edge.lengthY / length);
                // Apply forces on the end nodes
                sourceNode.springForceX += springForceX;
                sourceNode.springForceY += springForceY;
                targetNode.springForceX -= springForceX;
                targetNode.springForceY -= springForceY;
            };
            FDLayout.prototype.calcRepulsionForce = function(nodeA, nodeB) {
                var rectA = nodeA.getRect();
                var rectB = nodeB.getRect();
                var overlapAmount = new Array(2);
                var clipPoints = new Array(4);
                var distanceX;
                var distanceY;
                var distanceSquared;
                var distance;
                var repulsionForce;
                var repulsionForceX;
                var repulsionForceY;
                if (rectA.intersects(rectB)) {
                    // calculate separation amount in x and y directions
                    IGeometry.calcSeparationAmount(rectA, rectB, overlapAmount, FDLayoutConstants.DEFAULT_EDGE_LENGTH / 2.0);
                    repulsionForceX = 2 * overlapAmount[0];
                    repulsionForceY = 2 * overlapAmount[1];
                    var childrenConstant = nodeA.noOfChildren * nodeB.noOfChildren / (nodeA.noOfChildren + nodeB.noOfChildren);
                    // Apply forces on the two nodes
                    nodeA.repulsionForceX -= childrenConstant * repulsionForceX;
                    nodeA.repulsionForceY -= childrenConstant * repulsionForceY;
                    nodeB.repulsionForceX += childrenConstant * repulsionForceX;
                    nodeB.repulsionForceY += childrenConstant * repulsionForceY;
                } else {
                    // calculate distance
                    if (this.uniformLeafNodeSizes && nodeA.getChild() == null && nodeB.getChild() == null) {
                        distanceX = rectB.getCenterX() - rectA.getCenterX();
                        distanceY = rectB.getCenterY() - rectA.getCenterY();
                    } else {
                        IGeometry.getIntersection(rectA, rectB, clipPoints);
                        distanceX = clipPoints[2] - clipPoints[0];
                        distanceY = clipPoints[3] - clipPoints[1];
                    }
                    // No repulsion range. FR grid variant should take care of this.
                    if (Math.abs(distanceX) < FDLayoutConstants.MIN_REPULSION_DIST) distanceX = IMath.sign(distanceX) * FDLayoutConstants.MIN_REPULSION_DIST;
                    if (Math.abs(distanceY) < FDLayoutConstants.MIN_REPULSION_DIST) distanceY = IMath.sign(distanceY) * FDLayoutConstants.MIN_REPULSION_DIST;
                    distanceSquared = distanceX * distanceX + distanceY * distanceY;
                    distance = Math.sqrt(distanceSquared);
                    // Here we use half of the nodes' repulsion values for backward compatibility
                    repulsionForce = (nodeA.nodeRepulsion / 2 + nodeB.nodeRepulsion / 2) * nodeA.noOfChildren * nodeB.noOfChildren / distanceSquared;
                    // Project force onto x and y axes
                    repulsionForceX = repulsionForce * distanceX / distance;
                    repulsionForceY = repulsionForce * distanceY / distance;
                    // Apply forces on the two nodes    
                    nodeA.repulsionForceX -= repulsionForceX;
                    nodeA.repulsionForceY -= repulsionForceY;
                    nodeB.repulsionForceX += repulsionForceX;
                    nodeB.repulsionForceY += repulsionForceY;
                }
            };
            FDLayout.prototype.calcGravitationalForce = function(node) {
                var ownerGraph;
                var ownerCenterX;
                var ownerCenterY;
                var distanceX;
                var distanceY;
                var absDistanceX;
                var absDistanceY;
                var estimatedSize;
                ownerGraph = node.getOwner();
                ownerCenterX = (ownerGraph.getRight() + ownerGraph.getLeft()) / 2;
                ownerCenterY = (ownerGraph.getTop() + ownerGraph.getBottom()) / 2;
                distanceX = node.getCenterX() - ownerCenterX;
                distanceY = node.getCenterY() - ownerCenterY;
                absDistanceX = Math.abs(distanceX) + node.getWidth() / 2;
                absDistanceY = Math.abs(distanceY) + node.getHeight() / 2;
                if (node.getOwner() == this.graphManager.getRoot()) {
                    estimatedSize = ownerGraph.getEstimatedSize() * this.gravityRangeFactor;
                    if (absDistanceX > estimatedSize || absDistanceY > estimatedSize) {
                        node.gravitationForceX = -this.gravityConstant * distanceX;
                        node.gravitationForceY = -this.gravityConstant * distanceY;
                    }
                } else {
                    estimatedSize = ownerGraph.getEstimatedSize() * this.compoundGravityRangeFactor;
                    if (absDistanceX > estimatedSize || absDistanceY > estimatedSize) {
                        node.gravitationForceX = -this.gravityConstant * distanceX * this.compoundGravityConstant;
                        node.gravitationForceY = -this.gravityConstant * distanceY * this.compoundGravityConstant;
                    }
                }
            };
            FDLayout.prototype.isConverged = function() {
                var converged;
                var oscilating = false;
                if (this.totalIterations > this.maxIterations / 3) oscilating = Math.abs(this.totalDisplacement - this.oldTotalDisplacement) < 2;
                converged = this.totalDisplacement < this.totalDisplacementThreshold;
                this.oldTotalDisplacement = this.totalDisplacement;
                return converged || oscilating;
            };
            FDLayout.prototype.animate = function() {
                if (this.animationDuringLayout && !this.isSubLayout) {
                    if (this.notAnimatedIterations == this.animationPeriod) {
                        this.update();
                        this.notAnimatedIterations = 0;
                    } else this.notAnimatedIterations++;
                }
            };
            //This method calculates the number of children (weight) for all nodes
            FDLayout.prototype.calcNoOfChildrenForAllNodes = function() {
                var node;
                var allNodes = this.graphManager.getAllNodes();
                for(var i = 0; i < allNodes.length; i++){
                    node = allNodes[i];
                    node.noOfChildren = node.getNoOfChildren();
                }
            };
            // -----------------------------------------------------------------------------
            // Section: FR-Grid Variant Repulsion Force Calculation
            // -----------------------------------------------------------------------------
            FDLayout.prototype.calcGrid = function(graph) {
                var sizeX = 0;
                var sizeY = 0;
                sizeX = parseInt(Math.ceil((graph.getRight() - graph.getLeft()) / this.repulsionRange));
                sizeY = parseInt(Math.ceil((graph.getBottom() - graph.getTop()) / this.repulsionRange));
                var grid = new Array(sizeX);
                for(var i = 0; i < sizeX; i++)grid[i] = new Array(sizeY);
                for(var i = 0; i < sizeX; i++)for(var j = 0; j < sizeY; j++)grid[i][j] = new Array();
                return grid;
            };
            FDLayout.prototype.addNodeToGrid = function(v, left, top) {
                var startX = 0;
                var finishX = 0;
                var startY = 0;
                var finishY = 0;
                startX = parseInt(Math.floor((v.getRect().x - left) / this.repulsionRange));
                finishX = parseInt(Math.floor((v.getRect().width + v.getRect().x - left) / this.repulsionRange));
                startY = parseInt(Math.floor((v.getRect().y - top) / this.repulsionRange));
                finishY = parseInt(Math.floor((v.getRect().height + v.getRect().y - top) / this.repulsionRange));
                for(var i = startX; i <= finishX; i++)for(var j = startY; j <= finishY; j++){
                    this.grid[i][j].push(v);
                    v.setGridCoordinates(startX, finishX, startY, finishY);
                }
            };
            FDLayout.prototype.updateGrid = function() {
                var i;
                var nodeA;
                var lNodes = this.getAllNodes();
                this.grid = this.calcGrid(this.graphManager.getRoot());
                // put all nodes to proper grid cells
                for(i = 0; i < lNodes.length; i++){
                    nodeA = lNodes[i];
                    this.addNodeToGrid(nodeA, this.graphManager.getRoot().getLeft(), this.graphManager.getRoot().getTop());
                }
            };
            FDLayout.prototype.calculateRepulsionForceOfANode = function(nodeA, processedNodeSet, gridUpdateAllowed, forceToNodeSurroundingUpdate) {
                if (this.totalIterations % FDLayoutConstants.GRID_CALCULATION_CHECK_PERIOD == 1 && gridUpdateAllowed || forceToNodeSurroundingUpdate) {
                    var surrounding = new Set();
                    nodeA.surrounding = new Array();
                    var nodeB;
                    var grid = this.grid;
                    for(var i = nodeA.startX - 1; i < nodeA.finishX + 2; i++)for(var j = nodeA.startY - 1; j < nodeA.finishY + 2; j++){
                        if (!(i < 0 || j < 0 || i >= grid.length || j >= grid[0].length)) for(var k = 0; k < grid[i][j].length; k++){
                            nodeB = grid[i][j][k];
                            // If both nodes are not members of the same graph, 
                            // or both nodes are the same, skip.
                            if (nodeA.getOwner() != nodeB.getOwner() || nodeA == nodeB) continue;
                            // check if the repulsion force between
                            // nodeA and nodeB has already been calculated
                            if (!processedNodeSet.has(nodeB) && !surrounding.has(nodeB)) {
                                var distanceX = Math.abs(nodeA.getCenterX() - nodeB.getCenterX()) - (nodeA.getWidth() / 2 + nodeB.getWidth() / 2);
                                var distanceY = Math.abs(nodeA.getCenterY() - nodeB.getCenterY()) - (nodeA.getHeight() / 2 + nodeB.getHeight() / 2);
                                // if the distance between nodeA and nodeB 
                                // is less then calculation range
                                if (distanceX <= this.repulsionRange && distanceY <= this.repulsionRange) //then add nodeB to surrounding of nodeA
                                surrounding.add(nodeB);
                            }
                        }
                    }
                    nodeA.surrounding = [].concat(_toConsumableArray(surrounding));
                }
                for(i = 0; i < nodeA.surrounding.length; i++)this.calcRepulsionForce(nodeA, nodeA.surrounding[i]);
            };
            FDLayout.prototype.calcRepulsionRange = function() {
                return 0.0;
            };
            module1.exports = FDLayout;
        /***/ },
        /* 19 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LEdge = __webpack_require__(1);
            var FDLayoutConstants = __webpack_require__(4);
            function FDLayoutEdge(source, target, vEdge) {
                LEdge.call(this, source, target, vEdge);
                // Ideal length and elasticity value for this edge
                this.idealLength = FDLayoutConstants.DEFAULT_EDGE_LENGTH;
                this.edgeElasticity = FDLayoutConstants.DEFAULT_SPRING_STRENGTH;
            }
            FDLayoutEdge.prototype = Object.create(LEdge.prototype);
            for(var prop in LEdge)FDLayoutEdge[prop] = LEdge[prop];
            module1.exports = FDLayoutEdge;
        /***/ },
        /* 20 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LNode = __webpack_require__(3);
            var FDLayoutConstants = __webpack_require__(4);
            function FDLayoutNode(gm, loc, size, vNode) {
                // alternative constructor is handled inside LNode
                LNode.call(this, gm, loc, size, vNode);
                // Repulsion value of this node
                this.nodeRepulsion = FDLayoutConstants.DEFAULT_REPULSION_STRENGTH;
                //Spring, repulsion and gravitational forces acting on this node
                this.springForceX = 0;
                this.springForceY = 0;
                this.repulsionForceX = 0;
                this.repulsionForceY = 0;
                this.gravitationForceX = 0;
                this.gravitationForceY = 0;
                //Amount by which this node is to be moved in this iteration
                this.displacementX = 0;
                this.displacementY = 0;
                //Start and finish grid coordinates that this node is fallen into
                this.startX = 0;
                this.finishX = 0;
                this.startY = 0;
                this.finishY = 0;
                //Geometric neighbors of this node
                this.surrounding = [];
            }
            FDLayoutNode.prototype = Object.create(LNode.prototype);
            for(var prop in LNode)FDLayoutNode[prop] = LNode[prop];
            FDLayoutNode.prototype.setGridCoordinates = function(_startX, _finishX, _startY, _finishY) {
                this.startX = _startX;
                this.finishX = _finishX;
                this.startY = _startY;
                this.finishY = _finishY;
            };
            module1.exports = FDLayoutNode;
        /***/ },
        /* 21 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function DimensionD1(width, height) {
                this.width = 0;
                this.height = 0;
                if (width !== null && height !== null) {
                    this.height = height;
                    this.width = width;
                }
            }
            DimensionD1.prototype.getWidth = function() {
                return this.width;
            };
            DimensionD1.prototype.setWidth = function(width) {
                this.width = width;
            };
            DimensionD1.prototype.getHeight = function() {
                return this.height;
            };
            DimensionD1.prototype.setHeight = function(height) {
                this.height = height;
            };
            module1.exports = DimensionD1;
        /***/ },
        /* 22 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var UniqueIDGeneretor = __webpack_require__(14);
            function HashMap() {
                this.map = {};
                this.keys = [];
            }
            HashMap.prototype.put = function(key, value) {
                var theId = UniqueIDGeneretor.createID(key);
                if (!this.contains(theId)) {
                    this.map[theId] = value;
                    this.keys.push(key);
                }
            };
            HashMap.prototype.contains = function(key) {
                var theId = UniqueIDGeneretor.createID(key);
                return this.map[key] != null;
            };
            HashMap.prototype.get = function(key) {
                var theId = UniqueIDGeneretor.createID(key);
                return this.map[theId];
            };
            HashMap.prototype.keySet = function() {
                return this.keys;
            };
            module1.exports = HashMap;
        /***/ },
        /* 23 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var UniqueIDGeneretor = __webpack_require__(14);
            function HashSet() {
                this.set = {};
            }
            HashSet.prototype.add = function(obj) {
                var theId = UniqueIDGeneretor.createID(obj);
                if (!this.contains(theId)) this.set[theId] = obj;
            };
            HashSet.prototype.remove = function(obj) {
                delete this.set[UniqueIDGeneretor.createID(obj)];
            };
            HashSet.prototype.clear = function() {
                this.set = {};
            };
            HashSet.prototype.contains = function(obj) {
                return this.set[UniqueIDGeneretor.createID(obj)] == obj;
            };
            HashSet.prototype.isEmpty = function() {
                return this.size() === 0;
            };
            HashSet.prototype.size = function() {
                return Object.keys(this.set).length;
            };
            //concats this.set to the given list
            HashSet.prototype.addAllTo = function(list) {
                var keys = Object.keys(this.set);
                var length = keys.length;
                for(var i = 0; i < length; i++)list.push(this.set[keys[i]]);
            };
            HashSet.prototype.size = function() {
                return Object.keys(this.set).length;
            };
            HashSet.prototype.addAll = function(list) {
                var s = list.length;
                for(var i = 0; i < s; i++){
                    var v = list[i];
                    this.add(v);
                }
            };
            module1.exports = HashSet;
        /***/ },
        /* 24 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Some matrix (1d and 2d array) operations
            function Matrix() {}
            /**
 * matrix multiplication
 * array1, array2 and result are 2d arrays
 */ Matrix.multMat = function(array1, array2) {
                var result = [];
                for(var i = 0; i < array1.length; i++){
                    result[i] = [];
                    for(var j = 0; j < array2[0].length; j++){
                        result[i][j] = 0;
                        for(var k = 0; k < array1[0].length; k++)result[i][j] += array1[i][k] * array2[k][j];
                    }
                }
                return result;
            };
            /**
 * matrix transpose
 * array and result are 2d arrays
 */ Matrix.transpose = function(array) {
                var result = [];
                for(var i = 0; i < array[0].length; i++){
                    result[i] = [];
                    for(var j = 0; j < array.length; j++)result[i][j] = array[j][i];
                }
                return result;
            };
            /**
 * multiply array with constant
 * array and result are 1d arrays
 */ Matrix.multCons = function(array, constant) {
                var result = [];
                for(var i = 0; i < array.length; i++)result[i] = array[i] * constant;
                return result;
            };
            /**
 * substract two arrays
 * array1, array2 and result are 1d arrays
 */ Matrix.minusOp = function(array1, array2) {
                var result = [];
                for(var i = 0; i < array1.length; i++)result[i] = array1[i] - array2[i];
                return result;
            };
            /**
 * dot product of two arrays with same size
 * array1 and array2 are 1d arrays
 */ Matrix.dotProduct = function(array1, array2) {
                var product = 0;
                for(var i = 0; i < array1.length; i++)product += array1[i] * array2[i];
                return product;
            };
            /**
 * magnitude of an array
 * array is 1d array
 */ Matrix.mag = function(array) {
                return Math.sqrt(this.dotProduct(array, array));
            };
            /**
 * normalization of an array
 * array and result are 1d array
 */ Matrix.normalize = function(array) {
                var result = [];
                var magnitude = this.mag(array);
                for(var i = 0; i < array.length; i++)result[i] = array[i] / magnitude;
                return result;
            };
            /**
 * multiply an array with centering matrix
 * array and result are 1d array
 */ Matrix.multGamma = function(array) {
                var result = [];
                var sum = 0;
                for(var i = 0; i < array.length; i++)sum += array[i];
                sum *= -1 / array.length;
                for(var _i = 0; _i < array.length; _i++)result[_i] = sum + array[_i];
                return result;
            };
            /**
 * a special matrix multiplication
 * result = 0.5 * C * INV * C^T * array
 * array and result are 1d, C and INV are 2d arrays
 */ Matrix.multL = function(array, C, INV) {
                var result = [];
                var temp1 = [];
                var temp2 = [];
                // multiply by C^T
                for(var i = 0; i < C[0].length; i++){
                    var sum = 0;
                    for(var j = 0; j < C.length; j++)sum += -0.5 * C[j][i] * array[j];
                    temp1[i] = sum;
                }
                // multiply the result by INV
                for(var _i2 = 0; _i2 < INV.length; _i2++){
                    var _sum = 0;
                    for(var _j = 0; _j < INV.length; _j++)_sum += INV[_i2][_j] * temp1[_j];
                    temp2[_i2] = _sum;
                }
                // multiply the result by C
                for(var _i3 = 0; _i3 < C.length; _i3++){
                    var _sum2 = 0;
                    for(var _j2 = 0; _j2 < C[0].length; _j2++)_sum2 += C[_i3][_j2] * temp2[_j2];
                    result[_i3] = _sum2;
                }
                return result;
            };
            module1.exports = Matrix;
        /***/ },
        /* 25 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /**
 * A classic Quicksort algorithm with Hoare's partition
 * - Works also on LinkedList objects
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ var LinkedList = __webpack_require__(11);
            var Quicksort = function() {
                function Quicksort(A, compareFunction) {
                    _classCallCheck(this, Quicksort);
                    if (compareFunction !== null || compareFunction !== undefined) this.compareFunction = this._defaultCompareFunction;
                    var length = void 0;
                    if (A instanceof LinkedList) length = A.size();
                    else length = A.length;
                    this._quicksort(A, 0, length - 1);
                }
                _createClass(Quicksort, [
                    {
                        key: '_quicksort',
                        value: function _quicksort(A, p, r) {
                            if (p < r) {
                                var q = this._partition(A, p, r);
                                this._quicksort(A, p, q);
                                this._quicksort(A, q + 1, r);
                            }
                        }
                    },
                    {
                        key: '_partition',
                        value: function _partition(A, p, r) {
                            var x = this._get(A, p);
                            var i = p;
                            var j = r;
                            while(true){
                                while(this.compareFunction(x, this._get(A, j)))j--;
                                while(this.compareFunction(this._get(A, i), x))i++;
                                if (i < j) {
                                    this._swap(A, i, j);
                                    i++;
                                    j--;
                                } else return j;
                            }
                        }
                    },
                    {
                        key: '_get',
                        value: function _get(object, index) {
                            if (object instanceof LinkedList) return object.get_object_at(index);
                            else return object[index];
                        }
                    },
                    {
                        key: '_set',
                        value: function _set(object, index, value) {
                            if (object instanceof LinkedList) object.set_object_at(index, value);
                            else object[index] = value;
                        }
                    },
                    {
                        key: '_swap',
                        value: function _swap(A, i, j) {
                            var temp = this._get(A, i);
                            this._set(A, i, this._get(A, j));
                            this._set(A, j, temp);
                        }
                    },
                    {
                        key: '_defaultCompareFunction',
                        value: function _defaultCompareFunction(a, b) {
                            return b > a;
                        }
                    }
                ]);
                return Quicksort;
            }();
            module1.exports = Quicksort;
        /***/ },
        /* 26 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Singular Value Decomposition implementation
            function SVD() {}
            /* Below singular value decomposition (svd) code including hypot function is adopted from https://github.com/dragonfly-ai/JamaJS
   Some changes are applied to make the code compatible with the fcose code and to make it independent from Jama.
   Input matrix is changed to a 2D array instead of Jama matrix. Matrix dimensions are taken according to 2D array instead of using Jama functions.
   An object that includes singular value components is created for return. 
   The types of input parameters of the hypot function are removed. 
   let is used instead of var for the variable initialization.
*/ /*
                               Apache License
                           Version 2.0, January 2004
                        http://www.apache.org/licenses/

   TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION

   1. Definitions.

      "License" shall mean the terms and conditions for use, reproduction,
      and distribution as defined by Sections 1 through 9 of this document.

      "Licensor" shall mean the copyright owner or entity authorized by
      the copyright owner that is granting the License.

      "Legal Entity" shall mean the union of the acting entity and all
      other entities that control, are controlled by, or are under common
      control with that entity. For the purposes of this definition,
      "control" means (i) the power, direct or indirect, to cause the
      direction or management of such entity, whether by contract or
      otherwise, or (ii) ownership of fifty percent (50%) or more of the
      outstanding shares, or (iii) beneficial ownership of such entity.

      "You" (or "Your") shall mean an individual or Legal Entity
      exercising permissions granted by this License.

      "Source" form shall mean the preferred form for making modifications,
      including but not limited to software source code, documentation
      source, and configuration files.

      "Object" form shall mean any form resulting from mechanical
      transformation or translation of a Source form, including but
      not limited to compiled object code, generated documentation,
      and conversions to other media types.

      "Work" shall mean the work of authorship, whether in Source or
      Object form, made available under the License, as indicated by a
      copyright notice that is included in or attached to the work
      (an example is provided in the Appendix below).

      "Derivative Works" shall mean any work, whether in Source or Object
      form, that is based on (or derived from) the Work and for which the
      editorial revisions, annotations, elaborations, or other modifications
      represent, as a whole, an original work of authorship. For the purposes
      of this License, Derivative Works shall not include works that remain
      separable from, or merely link (or bind by name) to the interfaces of,
      the Work and Derivative Works thereof.

      "Contribution" shall mean any work of authorship, including
      the original version of the Work and any modifications or additions
      to that Work or Derivative Works thereof, that is intentionally
      submitted to Licensor for inclusion in the Work by the copyright owner
      or by an individual or Legal Entity authorized to submit on behalf of
      the copyright owner. For the purposes of this definition, "submitted"
      means any form of electronic, verbal, or written communication sent
      to the Licensor or its representatives, including but not limited to
      communication on electronic mailing lists, source code control systems,
      and issue tracking systems that are managed by, or on behalf of, the
      Licensor for the purpose of discussing and improving the Work, but
      excluding communication that is conspicuously marked or otherwise
      designated in writing by the copyright owner as "Not a Contribution."

      "Contributor" shall mean Licensor and any individual or Legal Entity
      on behalf of whom a Contribution has been received by Licensor and
      subsequently incorporated within the Work.

   2. Grant of Copyright License. Subject to the terms and conditions of
      this License, each Contributor hereby grants to You a perpetual,
      worldwide, non-exclusive, no-charge, royalty-free, irrevocable
      copyright license to reproduce, prepare Derivative Works of,
      publicly display, publicly perform, sublicense, and distribute the
      Work and such Derivative Works in Source or Object form.

   3. Grant of Patent License. Subject to the terms and conditions of
      this License, each Contributor hereby grants to You a perpetual,
      worldwide, non-exclusive, no-charge, royalty-free, irrevocable
      (except as stated in this section) patent license to make, have made,
      use, offer to sell, sell, import, and otherwise transfer the Work,
      where such license applies only to those patent claims licensable
      by such Contributor that are necessarily infringed by their
      Contribution(s) alone or by combination of their Contribution(s)
      with the Work to which such Contribution(s) was submitted. If You
      institute patent litigation against any entity (including a
      cross-claim or counterclaim in a lawsuit) alleging that the Work
      or a Contribution incorporated within the Work constitutes direct
      or contributory patent infringement, then any patent licenses
      granted to You under this License for that Work shall terminate
      as of the date such litigation is filed.

   4. Redistribution. You may reproduce and distribute copies of the
      Work or Derivative Works thereof in any medium, with or without
      modifications, and in Source or Object form, provided that You
      meet the following conditions:

      (a) You must give any other recipients of the Work or
          Derivative Works a copy of this License; and

      (b) You must cause any modified files to carry prominent notices
          stating that You changed the files; and

      (c) You must retain, in the Source form of any Derivative Works
          that You distribute, all copyright, patent, trademark, and
          attribution notices from the Source form of the Work,
          excluding those notices that do not pertain to any part of
          the Derivative Works; and

      (d) If the Work includes a "NOTICE" text file as part of its
          distribution, then any Derivative Works that You distribute must
          include a readable copy of the attribution notices contained
          within such NOTICE file, excluding those notices that do not
          pertain to any part of the Derivative Works, in at least one
          of the following places: within a NOTICE text file distributed
          as part of the Derivative Works; within the Source form or
          documentation, if provided along with the Derivative Works; or,
          within a display generated by the Derivative Works, if and
          wherever such third-party notices normally appear. The contents
          of the NOTICE file are for informational purposes only and
          do not modify the License. You may add Your own attribution
          notices within Derivative Works that You distribute, alongside
          or as an addendum to the NOTICE text from the Work, provided
          that such additional attribution notices cannot be construed
          as modifying the License.

      You may add Your own copyright statement to Your modifications and
      may provide additional or different license terms and conditions
      for use, reproduction, or distribution of Your modifications, or
      for any such Derivative Works as a whole, provided Your use,
      reproduction, and distribution of the Work otherwise complies with
      the conditions stated in this License.

   5. Submission of Contributions. Unless You explicitly state otherwise,
      any Contribution intentionally submitted for inclusion in the Work
      by You to the Licensor shall be under the terms and conditions of
      this License, without any additional terms or conditions.
      Notwithstanding the above, nothing herein shall supersede or modify
      the terms of any separate license agreement you may have executed
      with Licensor regarding such Contributions.

   6. Trademarks. This License does not grant permission to use the trade
      names, trademarks, service marks, or product names of the Licensor,
      except as required for reasonable and customary use in describing the
      origin of the Work and reproducing the content of the NOTICE file.

   7. Disclaimer of Warranty. Unless required by applicable law or
      agreed to in writing, Licensor provides the Work (and each
      Contributor provides its Contributions) on an "AS IS" BASIS,
      WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
      implied, including, without limitation, any warranties or conditions
      of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A
      PARTICULAR PURPOSE. You are solely responsible for determining the
      appropriateness of using or redistributing the Work and assume any
      risks associated with Your exercise of permissions under this License.

   8. Limitation of Liability. In no event and under no legal theory,
      whether in tort (including negligence), contract, or otherwise,
      unless required by applicable law (such as deliberate and grossly
      negligent acts) or agreed to in writing, shall any Contributor be
      liable to You for damages, including any direct, indirect, special,
      incidental, or consequential damages of any character arising as a
      result of this License or out of the use or inability to use the
      Work (including but not limited to damages for loss of goodwill,
      work stoppage, computer failure or malfunction, or any and all
      other commercial damages or losses), even if such Contributor
      has been advised of the possibility of such damages.

   9. Accepting Warranty or Additional Liability. While redistributing
      the Work or Derivative Works thereof, You may choose to offer,
      and charge a fee for, acceptance of support, warranty, indemnity,
      or other liability obligations and/or rights consistent with this
      License. However, in accepting such obligations, You may act only
      on Your own behalf and on Your sole responsibility, not on behalf
      of any other Contributor, and only if You agree to indemnify,
      defend, and hold each Contributor harmless for any liability
      incurred by, or claims asserted against, such Contributor by reason
      of your accepting any such warranty or additional liability.

   END OF TERMS AND CONDITIONS

   APPENDIX: How to apply the Apache License to your work.

      To apply the Apache License to your work, attach the following
      boilerplate notice, with the fields enclosed by brackets "{}"
      replaced with your own identifying information. (Don't include
      the brackets!)  The text should be enclosed in the appropriate
      comment syntax for the file format. We also recommend that a
      file or class name and description of purpose be included on the
      same "printed page" as the copyright notice for easier
      identification within third-party archives.

   Copyright {yyyy} {name of copyright owner}

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ SVD.svd = function(A) {
                this.U = null;
                this.V = null;
                this.s = null;
                this.m = 0;
                this.n = 0;
                this.m = A.length;
                this.n = A[0].length;
                var nu = Math.min(this.m, this.n);
                this.s = function(s) {
                    var a = [];
                    while(s-- > 0)a.push(0);
                    return a;
                }(Math.min(this.m + 1, this.n));
                this.U = function(dims) {
                    var allocate = function allocate(dims) {
                        if (dims.length == 0) return 0;
                        else {
                            var array = [];
                            for(var i = 0; i < dims[0]; i++)array.push(allocate(dims.slice(1)));
                            return array;
                        }
                    };
                    return allocate(dims);
                }([
                    this.m,
                    nu
                ]);
                this.V = function(dims) {
                    var allocate = function allocate(dims) {
                        if (dims.length == 0) return 0;
                        else {
                            var array = [];
                            for(var i = 0; i < dims[0]; i++)array.push(allocate(dims.slice(1)));
                            return array;
                        }
                    };
                    return allocate(dims);
                }([
                    this.n,
                    this.n
                ]);
                var e = function(s) {
                    var a = [];
                    while(s-- > 0)a.push(0);
                    return a;
                }(this.n);
                var work = function(s) {
                    var a = [];
                    while(s-- > 0)a.push(0);
                    return a;
                }(this.m);
                var wantu = true;
                var wantv = true;
                var nct = Math.min(this.m - 1, this.n);
                var nrt = Math.max(0, Math.min(this.n - 2, this.m));
                for(var k = 0; k < Math.max(nct, nrt); k++){
                    if (k < nct) {
                        this.s[k] = 0;
                        for(var i = k; i < this.m; i++)this.s[k] = SVD.hypot(this.s[k], A[i][k]);
                        if (this.s[k] !== 0.0) {
                            if (A[k][k] < 0.0) this.s[k] = -this.s[k];
                            for(var _i = k; _i < this.m; _i++)A[_i][k] /= this.s[k];
                            A[k][k] += 1.0;
                        }
                        this.s[k] = -this.s[k];
                    }
                    for(var j = k + 1; j < this.n; j++){
                        if (function(lhs, rhs) {
                            return lhs && rhs;
                        }(k < nct, this.s[k] !== 0.0)) {
                            var t = 0;
                            for(var _i2 = k; _i2 < this.m; _i2++)t += A[_i2][k] * A[_i2][j];
                            t = -t / A[k][k];
                            for(var _i3 = k; _i3 < this.m; _i3++)A[_i3][j] += t * A[_i3][k];
                        }
                        e[j] = A[k][j];
                    }
                    if (function(lhs, rhs) {
                        return lhs && rhs;
                    }(wantu, k < nct)) for(var _i4 = k; _i4 < this.m; _i4++)this.U[_i4][k] = A[_i4][k];
                    if (k < nrt) {
                        e[k] = 0;
                        for(var _i5 = k + 1; _i5 < this.n; _i5++)e[k] = SVD.hypot(e[k], e[_i5]);
                        if (e[k] !== 0.0) {
                            if (e[k + 1] < 0.0) e[k] = -e[k];
                            for(var _i6 = k + 1; _i6 < this.n; _i6++)e[_i6] /= e[k];
                            e[k + 1] += 1.0;
                        }
                        e[k] = -e[k];
                        if (function(lhs, rhs) {
                            return lhs && rhs;
                        }(k + 1 < this.m, e[k] !== 0.0)) {
                            for(var _i7 = k + 1; _i7 < this.m; _i7++)work[_i7] = 0.0;
                            for(var _j = k + 1; _j < this.n; _j++)for(var _i8 = k + 1; _i8 < this.m; _i8++)work[_i8] += e[_j] * A[_i8][_j];
                            for(var _j2 = k + 1; _j2 < this.n; _j2++){
                                var _t = -e[_j2] / e[k + 1];
                                for(var _i9 = k + 1; _i9 < this.m; _i9++)A[_i9][_j2] += _t * work[_i9];
                            }
                        }
                        if (wantv) for(var _i10 = k + 1; _i10 < this.n; _i10++)this.V[_i10][k] = e[_i10];
                    }
                }
                var p = Math.min(this.n, this.m + 1);
                if (nct < this.n) this.s[nct] = A[nct][nct];
                if (this.m < p) this.s[p - 1] = 0.0;
                if (nrt + 1 < p) e[nrt] = A[nrt][p - 1];
                e[p - 1] = 0.0;
                if (wantu) {
                    for(var _j3 = nct; _j3 < nu; _j3++){
                        for(var _i11 = 0; _i11 < this.m; _i11++)this.U[_i11][_j3] = 0.0;
                        this.U[_j3][_j3] = 1.0;
                    }
                    for(var _k = nct - 1; _k >= 0; _k--)if (this.s[_k] !== 0.0) {
                        for(var _j4 = _k + 1; _j4 < nu; _j4++){
                            var _t2 = 0;
                            for(var _i12 = _k; _i12 < this.m; _i12++)_t2 += this.U[_i12][_k] * this.U[_i12][_j4];
                            _t2 = -_t2 / this.U[_k][_k];
                            for(var _i13 = _k; _i13 < this.m; _i13++)this.U[_i13][_j4] += _t2 * this.U[_i13][_k];
                        }
                        for(var _i14 = _k; _i14 < this.m; _i14++)this.U[_i14][_k] = -this.U[_i14][_k];
                        this.U[_k][_k] = 1.0 + this.U[_k][_k];
                        for(var _i15 = 0; _i15 < _k - 1; _i15++)this.U[_i15][_k] = 0.0;
                    } else {
                        for(var _i16 = 0; _i16 < this.m; _i16++)this.U[_i16][_k] = 0.0;
                        this.U[_k][_k] = 1.0;
                    }
                }
                if (wantv) for(var _k2 = this.n - 1; _k2 >= 0; _k2--){
                    if (function(lhs, rhs) {
                        return lhs && rhs;
                    }(_k2 < nrt, e[_k2] !== 0.0)) for(var _j5 = _k2 + 1; _j5 < nu; _j5++){
                        var _t3 = 0;
                        for(var _i17 = _k2 + 1; _i17 < this.n; _i17++)_t3 += this.V[_i17][_k2] * this.V[_i17][_j5];
                        _t3 = -_t3 / this.V[_k2 + 1][_k2];
                        for(var _i18 = _k2 + 1; _i18 < this.n; _i18++)this.V[_i18][_j5] += _t3 * this.V[_i18][_k2];
                    }
                    for(var _i19 = 0; _i19 < this.n; _i19++)this.V[_i19][_k2] = 0.0;
                    this.V[_k2][_k2] = 1.0;
                }
                var pp = p - 1;
                var iter = 0;
                var eps = Math.pow(2.0, -52);
                var tiny = Math.pow(2.0, -966);
                while(p > 0){
                    var _k3 = void 0;
                    var kase = void 0;
                    for(_k3 = p - 2; _k3 >= -1; _k3--){
                        if (_k3 === -1) break;
                        if (Math.abs(e[_k3]) <= tiny + eps * (Math.abs(this.s[_k3]) + Math.abs(this.s[_k3 + 1]))) {
                            e[_k3] = 0.0;
                            break;
                        }
                    }
                    if (_k3 === p - 2) kase = 4;
                    else {
                        var ks = void 0;
                        for(ks = p - 1; ks >= _k3; ks--){
                            if (ks === _k3) break;
                            var _t4 = (ks !== p ? Math.abs(e[ks]) : 0.0) + (ks !== _k3 + 1 ? Math.abs(e[ks - 1]) : 0.0);
                            if (Math.abs(this.s[ks]) <= tiny + eps * _t4) {
                                this.s[ks] = 0.0;
                                break;
                            }
                        }
                        if (ks === _k3) kase = 3;
                        else if (ks === p - 1) kase = 1;
                        else {
                            kase = 2;
                            _k3 = ks;
                        }
                    }
                    _k3++;
                    switch(kase){
                        case 1:
                            var f = e[p - 2];
                            e[p - 2] = 0.0;
                            for(var _j6 = p - 2; _j6 >= _k3; _j6--){
                                var _t5 = SVD.hypot(this.s[_j6], f);
                                var cs = this.s[_j6] / _t5;
                                var sn = f / _t5;
                                this.s[_j6] = _t5;
                                if (_j6 !== _k3) {
                                    f = -sn * e[_j6 - 1];
                                    e[_j6 - 1] = cs * e[_j6 - 1];
                                }
                                if (wantv) for(var _i20 = 0; _i20 < this.n; _i20++){
                                    _t5 = cs * this.V[_i20][_j6] + sn * this.V[_i20][p - 1];
                                    this.V[_i20][p - 1] = -sn * this.V[_i20][_j6] + cs * this.V[_i20][p - 1];
                                    this.V[_i20][_j6] = _t5;
                                }
                            }
                            break;
                        case 2:
                            var _f = e[_k3 - 1];
                            e[_k3 - 1] = 0.0;
                            for(var _j7 = _k3; _j7 < p; _j7++){
                                var _t6 = SVD.hypot(this.s[_j7], _f);
                                var _cs = this.s[_j7] / _t6;
                                var _sn = _f / _t6;
                                this.s[_j7] = _t6;
                                _f = -_sn * e[_j7];
                                e[_j7] = _cs * e[_j7];
                                if (wantu) for(var _i21 = 0; _i21 < this.m; _i21++){
                                    _t6 = _cs * this.U[_i21][_j7] + _sn * this.U[_i21][_k3 - 1];
                                    this.U[_i21][_k3 - 1] = -_sn * this.U[_i21][_j7] + _cs * this.U[_i21][_k3 - 1];
                                    this.U[_i21][_j7] = _t6;
                                }
                            }
                            break;
                        case 3:
                            var scale = Math.max(Math.max(Math.max(Math.max(Math.abs(this.s[p - 1]), Math.abs(this.s[p - 2])), Math.abs(e[p - 2])), Math.abs(this.s[_k3])), Math.abs(e[_k3]));
                            var sp = this.s[p - 1] / scale;
                            var spm1 = this.s[p - 2] / scale;
                            var epm1 = e[p - 2] / scale;
                            var sk = this.s[_k3] / scale;
                            var ek = e[_k3] / scale;
                            var b = ((spm1 + sp) * (spm1 - sp) + epm1 * epm1) / 2.0;
                            var c = sp * epm1 * (sp * epm1);
                            var shift = 0.0;
                            if (function(lhs, rhs) {
                                return lhs || rhs;
                            }(b !== 0.0, c !== 0.0)) {
                                shift = Math.sqrt(b * b + c);
                                if (b < 0.0) shift = -shift;
                                shift = c / (b + shift);
                            }
                            var _f2 = (sk + sp) * (sk - sp) + shift;
                            var g = sk * ek;
                            for(var _j8 = _k3; _j8 < p - 1; _j8++){
                                var _t7 = SVD.hypot(_f2, g);
                                var _cs2 = _f2 / _t7;
                                var _sn2 = g / _t7;
                                if (_j8 !== _k3) e[_j8 - 1] = _t7;
                                _f2 = _cs2 * this.s[_j8] + _sn2 * e[_j8];
                                e[_j8] = _cs2 * e[_j8] - _sn2 * this.s[_j8];
                                g = _sn2 * this.s[_j8 + 1];
                                this.s[_j8 + 1] = _cs2 * this.s[_j8 + 1];
                                if (wantv) for(var _i22 = 0; _i22 < this.n; _i22++){
                                    _t7 = _cs2 * this.V[_i22][_j8] + _sn2 * this.V[_i22][_j8 + 1];
                                    this.V[_i22][_j8 + 1] = -_sn2 * this.V[_i22][_j8] + _cs2 * this.V[_i22][_j8 + 1];
                                    this.V[_i22][_j8] = _t7;
                                }
                                _t7 = SVD.hypot(_f2, g);
                                _cs2 = _f2 / _t7;
                                _sn2 = g / _t7;
                                this.s[_j8] = _t7;
                                _f2 = _cs2 * e[_j8] + _sn2 * this.s[_j8 + 1];
                                this.s[_j8 + 1] = -_sn2 * e[_j8] + _cs2 * this.s[_j8 + 1];
                                g = _sn2 * e[_j8 + 1];
                                e[_j8 + 1] = _cs2 * e[_j8 + 1];
                                if (wantu && _j8 < this.m - 1) for(var _i23 = 0; _i23 < this.m; _i23++){
                                    _t7 = _cs2 * this.U[_i23][_j8] + _sn2 * this.U[_i23][_j8 + 1];
                                    this.U[_i23][_j8 + 1] = -_sn2 * this.U[_i23][_j8] + _cs2 * this.U[_i23][_j8 + 1];
                                    this.U[_i23][_j8] = _t7;
                                }
                            }
                            e[p - 2] = _f2;
                            iter = iter + 1;
                            break;
                        case 4:
                            if (this.s[_k3] <= 0.0) {
                                this.s[_k3] = this.s[_k3] < 0.0 ? -this.s[_k3] : 0.0;
                                if (wantv) for(var _i24 = 0; _i24 <= pp; _i24++)this.V[_i24][_k3] = -this.V[_i24][_k3];
                            }
                            while(_k3 < pp){
                                if (this.s[_k3] >= this.s[_k3 + 1]) break;
                                var _t8 = this.s[_k3];
                                this.s[_k3] = this.s[_k3 + 1];
                                this.s[_k3 + 1] = _t8;
                                if (wantv && _k3 < this.n - 1) for(var _i25 = 0; _i25 < this.n; _i25++){
                                    _t8 = this.V[_i25][_k3 + 1];
                                    this.V[_i25][_k3 + 1] = this.V[_i25][_k3];
                                    this.V[_i25][_k3] = _t8;
                                }
                                if (wantu && _k3 < this.m - 1) for(var _i26 = 0; _i26 < this.m; _i26++){
                                    _t8 = this.U[_i26][_k3 + 1];
                                    this.U[_i26][_k3 + 1] = this.U[_i26][_k3];
                                    this.U[_i26][_k3] = _t8;
                                }
                                _k3++;
                            }
                            iter = 0;
                            p--;
                            break;
                    }
                }
                var result = {
                    U: this.U,
                    V: this.V,
                    S: this.s
                };
                return result;
            };
            // sqrt(a^2 + b^2) without under/overflow.
            SVD.hypot = function(a, b) {
                var r = void 0;
                if (Math.abs(a) > Math.abs(b)) {
                    r = b / a;
                    r = Math.abs(a) * Math.sqrt(1 + r * r);
                } else if (b != 0) {
                    r = a / b;
                    r = Math.abs(b) * Math.sqrt(1 + r * r);
                } else r = 0.0;
                return r;
            };
            module1.exports = SVD;
        /***/ },
        /* 27 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /**
 *   Needleman-Wunsch algorithm is an procedure to compute the optimal global alignment of two string
 *   sequences by S.B.Needleman and C.D.Wunsch (1970).
 *
 *   Aside from the inputs, you can assign the scores for,
 *   - Match: The two characters at the current index are same.
 *   - Mismatch: The two characters at the current index are different.
 *   - Insertion/Deletion(gaps): The best alignment involves one letter aligning to a gap in the other string.
 */ var NeedlemanWunsch = function() {
                function NeedlemanWunsch(sequence1, sequence2) {
                    var match_score = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var mismatch_penalty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
                    var gap_penalty = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
                    _classCallCheck(this, NeedlemanWunsch);
                    this.sequence1 = sequence1;
                    this.sequence2 = sequence2;
                    this.match_score = match_score;
                    this.mismatch_penalty = mismatch_penalty;
                    this.gap_penalty = gap_penalty;
                    // Just the remove redundancy
                    this.iMax = sequence1.length + 1;
                    this.jMax = sequence2.length + 1;
                    // Grid matrix of scores
                    this.grid = new Array(this.iMax);
                    for(var i = 0; i < this.iMax; i++){
                        this.grid[i] = new Array(this.jMax);
                        for(var j = 0; j < this.jMax; j++)this.grid[i][j] = 0;
                    }
                    // Traceback matrix (2D array, each cell is an array of boolean values for [`Diag`, `Up`, `Left`] positions)
                    this.tracebackGrid = new Array(this.iMax);
                    for(var _i = 0; _i < this.iMax; _i++){
                        this.tracebackGrid[_i] = new Array(this.jMax);
                        for(var _j = 0; _j < this.jMax; _j++)this.tracebackGrid[_i][_j] = [
                            null,
                            null,
                            null
                        ];
                    }
                    // The aligned sequences (return multiple possibilities)
                    this.alignments = [];
                    // Final alignment score
                    this.score = -1;
                    // Calculate scores and tracebacks
                    this.computeGrids();
                }
                _createClass(NeedlemanWunsch, [
                    {
                        key: "getScore",
                        value: function getScore() {
                            return this.score;
                        }
                    },
                    {
                        key: "getAlignments",
                        value: function getAlignments() {
                            return this.alignments;
                        }
                    },
                    {
                        key: "computeGrids",
                        value: function computeGrids() {
                            // Fill in the first row
                            for(var j = 1; j < this.jMax; j++){
                                this.grid[0][j] = this.grid[0][j - 1] + this.gap_penalty;
                                this.tracebackGrid[0][j] = [
                                    false,
                                    false,
                                    true
                                ];
                            }
                            // Fill in the first column
                            for(var i = 1; i < this.iMax; i++){
                                this.grid[i][0] = this.grid[i - 1][0] + this.gap_penalty;
                                this.tracebackGrid[i][0] = [
                                    false,
                                    true,
                                    false
                                ];
                            }
                            // Fill the rest of the grid
                            for(var _i2 = 1; _i2 < this.iMax; _i2++)for(var _j2 = 1; _j2 < this.jMax; _j2++){
                                // Find the max score(s) among [`Diag`, `Up`, `Left`]
                                var diag = void 0;
                                if (this.sequence1[_i2 - 1] === this.sequence2[_j2 - 1]) diag = this.grid[_i2 - 1][_j2 - 1] + this.match_score;
                                else diag = this.grid[_i2 - 1][_j2 - 1] + this.mismatch_penalty;
                                var up = this.grid[_i2 - 1][_j2] + this.gap_penalty;
                                var left = this.grid[_i2][_j2 - 1] + this.gap_penalty;
                                // If there exists multiple max values, capture them for multiple paths
                                var maxOf = [
                                    diag,
                                    up,
                                    left
                                ];
                                var indices = this.arrayAllMaxIndexes(maxOf);
                                // Update Grids
                                this.grid[_i2][_j2] = maxOf[indices[0]];
                                this.tracebackGrid[_i2][_j2] = [
                                    indices.includes(0),
                                    indices.includes(1),
                                    indices.includes(2)
                                ];
                            }
                            // Update alignment score
                            this.score = this.grid[this.iMax - 1][this.jMax - 1];
                        }
                    },
                    {
                        key: "alignmentTraceback",
                        value: function alignmentTraceback() {
                            var inProcessAlignments = [];
                            inProcessAlignments.push({
                                pos: [
                                    this.sequence1.length,
                                    this.sequence2.length
                                ],
                                seq1: "",
                                seq2: ""
                            });
                            while(inProcessAlignments[0]){
                                var current = inProcessAlignments[0];
                                var directions = this.tracebackGrid[current.pos[0]][current.pos[1]];
                                if (directions[0]) inProcessAlignments.push({
                                    pos: [
                                        current.pos[0] - 1,
                                        current.pos[1] - 1
                                    ],
                                    seq1: this.sequence1[current.pos[0] - 1] + current.seq1,
                                    seq2: this.sequence2[current.pos[1] - 1] + current.seq2
                                });
                                if (directions[1]) inProcessAlignments.push({
                                    pos: [
                                        current.pos[0] - 1,
                                        current.pos[1]
                                    ],
                                    seq1: this.sequence1[current.pos[0] - 1] + current.seq1,
                                    seq2: '-' + current.seq2
                                });
                                if (directions[2]) inProcessAlignments.push({
                                    pos: [
                                        current.pos[0],
                                        current.pos[1] - 1
                                    ],
                                    seq1: '-' + current.seq1,
                                    seq2: this.sequence2[current.pos[1] - 1] + current.seq2
                                });
                                if (current.pos[0] === 0 && current.pos[1] === 0) this.alignments.push({
                                    sequence1: current.seq1,
                                    sequence2: current.seq2
                                });
                                inProcessAlignments.shift();
                            }
                            return this.alignments;
                        }
                    },
                    {
                        key: "getAllIndexes",
                        value: function getAllIndexes(arr, val) {
                            var indexes = [], i = -1;
                            while((i = arr.indexOf(val, i + 1)) !== -1)indexes.push(i);
                            return indexes;
                        }
                    },
                    {
                        key: "arrayAllMaxIndexes",
                        value: function arrayAllMaxIndexes(array) {
                            return this.getAllIndexes(array, Math.max.apply(null, array));
                        }
                    }
                ]);
                return NeedlemanWunsch;
            }();
            module1.exports = NeedlemanWunsch;
        /***/ },
        /* 28 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var layoutBase = function layoutBase() {
                return;
            };
            layoutBase.FDLayout = __webpack_require__(18);
            layoutBase.FDLayoutConstants = __webpack_require__(4);
            layoutBase.FDLayoutEdge = __webpack_require__(19);
            layoutBase.FDLayoutNode = __webpack_require__(20);
            layoutBase.DimensionD = __webpack_require__(21);
            layoutBase.HashMap = __webpack_require__(22);
            layoutBase.HashSet = __webpack_require__(23);
            layoutBase.IGeometry = __webpack_require__(8);
            layoutBase.IMath = __webpack_require__(9);
            layoutBase.Integer = __webpack_require__(10);
            layoutBase.Point = __webpack_require__(12);
            layoutBase.PointD = __webpack_require__(5);
            layoutBase.RandomSeed = __webpack_require__(16);
            layoutBase.RectangleD = __webpack_require__(13);
            layoutBase.Transform = __webpack_require__(17);
            layoutBase.UniqueIDGeneretor = __webpack_require__(14);
            layoutBase.Quicksort = __webpack_require__(25);
            layoutBase.LinkedList = __webpack_require__(11);
            layoutBase.LGraphObject = __webpack_require__(2);
            layoutBase.LGraph = __webpack_require__(6);
            layoutBase.LEdge = __webpack_require__(1);
            layoutBase.LGraphManager = __webpack_require__(7);
            layoutBase.LNode = __webpack_require__(3);
            layoutBase.Layout = __webpack_require__(15);
            layoutBase.LayoutConstants = __webpack_require__(0);
            layoutBase.NeedlemanWunsch = __webpack_require__(27);
            layoutBase.Matrix = __webpack_require__(24);
            layoutBase.SVD = __webpack_require__(26);
            module1.exports = layoutBase;
        /***/ },
        /* 29 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function Emitter() {
                this.listeners = [];
            }
            var p = Emitter.prototype;
            p.addListener = function(event, callback) {
                this.listeners.push({
                    event: event,
                    callback: callback
                });
            };
            p.removeListener = function(event, callback) {
                for(var i = this.listeners.length; i >= 0; i--){
                    var l = this.listeners[i];
                    if (l.event === event && l.callback === callback) this.listeners.splice(i, 1);
                }
            };
            p.emit = function(event, data) {
                for(var i = 0; i < this.listeners.length; i++){
                    var l = this.listeners[i];
                    if (event === l.event) l.callback(data);
                }
            };
            module1.exports = Emitter;
        /***/ }
    ]);
});

});


parcelRegister("z1gio", function(module, exports) {
'use strict';
var $06943f92b55ad7fa$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $06943f92b55ad7fa$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $06943f92b55ad7fa$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("4nFCC", function(module, exports) {
'use strict';
var $330998a67e44345d$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $330998a67e44345d$var$has = Object.prototype.hasOwnProperty;
    var $330998a67e44345d$var$toStr = Object.prototype.toString;
    var $330998a67e44345d$var$isArgs = (parcelRequire("z1gio")); // eslint-disable-line global-require
    var $330998a67e44345d$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $330998a67e44345d$var$hasDontEnumBug = !$330998a67e44345d$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $330998a67e44345d$var$hasProtoEnumBug = $330998a67e44345d$var$isEnumerable.call(function() {}, 'prototype');
    var $330998a67e44345d$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $330998a67e44345d$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $330998a67e44345d$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $330998a67e44345d$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$330998a67e44345d$var$excludedKeys['$' + k] && $330998a67e44345d$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $330998a67e44345d$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$330998a67e44345d$var$hasAutomationEqualityBug) return $330998a67e44345d$var$equalsConstructorPrototype(o);
        try {
            return $330998a67e44345d$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $330998a67e44345d$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $330998a67e44345d$var$toStr.call(object) === '[object Function]';
        var isArguments = $330998a67e44345d$var$isArgs(object);
        var isString = isObject && $330998a67e44345d$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $330998a67e44345d$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$330998a67e44345d$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $330998a67e44345d$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($330998a67e44345d$var$hasDontEnumBug) {
            var skipConstructor = $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $330998a67e44345d$var$dontEnums.length; ++k)if (!(skipConstructor && $330998a67e44345d$var$dontEnums[k] === 'constructor') && $330998a67e44345d$var$has.call(object, $330998a67e44345d$var$dontEnums[k])) theKeys.push($330998a67e44345d$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $330998a67e44345d$var$keysShim;

});

parcelRegister("i16wS", function(module, exports) {
'use strict';

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});
parcelRegister("jAy3M", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = Object.defineProperty || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});


parcelRegister("24qIq", function(module, exports) {
'use strict';
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $1820ada193f67aeb$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("65AEs", function(module, exports) {
/* interact.js 1.10.27 | https://raw.github.com/taye/interact.js/main/LICENSE */ !function(t1, e) {
    module.exports = e();
}(this, function() {
    "use strict";
    function t1(t1, e) {
        var n = Object.keys(t1);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(t1);
            e && (r = r.filter(function(e) {
                return Object.getOwnPropertyDescriptor(t1, e).enumerable;
            })), n.push.apply(n, r);
        }
        return n;
    }
    function e(e) {
        for(var n = 1; n < arguments.length; n++){
            var r = null != arguments[n] ? arguments[n] : {};
            n % 2 ? t1(Object(r), !0).forEach(function(t1) {
                a(e, t1, r[t1]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : t1(Object(r)).forEach(function(t1) {
                Object.defineProperty(e, t1, Object.getOwnPropertyDescriptor(r, t1));
            });
        }
        return e;
    }
    function n(t1) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
            return typeof t1;
        } : function(t1) {
            return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
        }, n(t1);
    }
    function r(t1, e) {
        if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function i(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, d(r.key), r);
        }
    }
    function o(t1, e, n) {
        return e && i(t1.prototype, e), n && i(t1, n), Object.defineProperty(t1, "prototype", {
            writable: !1
        }), t1;
    }
    function a(t1, e, n) {
        return (e = d(e)) in t1 ? Object.defineProperty(t1, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = n, t1;
    }
    function s(t1, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t1.prototype = Object.create(e && e.prototype, {
            constructor: {
                value: t1,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(t1, "prototype", {
            writable: !1
        }), e && l(t1, e);
    }
    function c(t1) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t1) {
            return t1.__proto__ || Object.getPrototypeOf(t1);
        }, c(t1);
    }
    function l(t1, e) {
        return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t1, e) {
            return t1.__proto__ = e, t1;
        }, l(t1, e);
    }
    function u(t1) {
        if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t1;
    }
    function p(t1) {
        var e = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (t1) {
                return !1;
            }
        }();
        return function() {
            var n, r = c(t1);
            if (e) {
                var i = c(this).constructor;
                n = Reflect.construct(r, arguments, i);
            } else n = r.apply(this, arguments);
            return function(t1, e) {
                if (e && ("object" == typeof e || "function" == typeof e)) return e;
                if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                return u(t1);
            }(this, n);
        };
    }
    function f() {
        return f = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(t1, e, n) {
            var r = function(t1, e) {
                for(; !Object.prototype.hasOwnProperty.call(t1, e) && null !== (t1 = c(t1)););
                return t1;
            }(t1, e);
            if (r) {
                var i = Object.getOwnPropertyDescriptor(r, e);
                return i.get ? i.get.call(arguments.length < 3 ? t1 : n) : i.value;
            }
        }, f.apply(this, arguments);
    }
    function d(t1) {
        var e = function(t1, e) {
            if ("object" != typeof t1 || null === t1) return t1;
            var n = t1[Symbol.toPrimitive];
            if (void 0 !== n) {
                var r = n.call(t1, e || "default");
                if ("object" != typeof r) return r;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === e ? String : Number)(t1);
        }(t1, "string");
        return "symbol" == typeof e ? e : e + "";
    }
    var h = function(t1) {
        return !(!t1 || !t1.Window) && t1 instanceof t1.Window;
    }, v = void 0, g = void 0;
    function m(t1) {
        v = t1;
        var e = t1.document.createTextNode("");
        e.ownerDocument !== t1.document && "function" == typeof t1.wrap && t1.wrap(e) === e && (t1 = t1.wrap(t1)), g = t1;
    }
    function y(t1) {
        return h(t1) ? t1 : (t1.ownerDocument || t1).defaultView || g.window;
    }
    "undefined" != typeof window && window && m(window);
    var b = function(t1) {
        return !!t1 && "object" === n(t1);
    }, x = function(t1) {
        return "function" == typeof t1;
    }, w = {
        window: function(t1) {
            return t1 === g || h(t1);
        },
        docFrag: function(t1) {
            return b(t1) && 11 === t1.nodeType;
        },
        object: b,
        func: x,
        number: function(t1) {
            return "number" == typeof t1;
        },
        bool: function(t1) {
            return "boolean" == typeof t1;
        },
        string: function(t1) {
            return "string" == typeof t1;
        },
        element: function(t1) {
            if (!t1 || "object" !== n(t1)) return !1;
            var e = y(t1) || g;
            return /object|function/.test("undefined" == typeof Element ? "undefined" : n(Element)) ? t1 instanceof Element || t1 instanceof e.Element : 1 === t1.nodeType && "string" == typeof t1.nodeName;
        },
        plainObject: function(t1) {
            return b(t1) && !!t1.constructor && /function Object\b/.test(t1.constructor.toString());
        },
        array: function(t1) {
            return b(t1) && void 0 !== t1.length && x(t1.splice);
        }
    };
    function E(t1) {
        var e = t1.interaction;
        if ("drag" === e.prepared.name) {
            var n = e.prepared.axis;
            "x" === n ? (e.coords.cur.page.y = e.coords.start.page.y, e.coords.cur.client.y = e.coords.start.client.y, e.coords.velocity.client.y = 0, e.coords.velocity.page.y = 0) : "y" === n && (e.coords.cur.page.x = e.coords.start.page.x, e.coords.cur.client.x = e.coords.start.client.x, e.coords.velocity.client.x = 0, e.coords.velocity.page.x = 0);
        }
    }
    function T(t1) {
        var e = t1.iEvent, n = t1.interaction;
        if ("drag" === n.prepared.name) {
            var r = n.prepared.axis;
            if ("x" === r || "y" === r) {
                var i = "x" === r ? "y" : "x";
                e.page[i] = n.coords.start.page[i], e.client[i] = n.coords.start.client[i], e.delta[i] = 0;
            }
        }
    }
    var S = {
        id: "actions/drag",
        install: function(t1) {
            var e = t1.actions, n = t1.Interactable, r = t1.defaults;
            n.prototype.draggable = S.draggable, e.map.drag = S, e.methodDict.drag = "draggable", r.actions.drag = S.defaults;
        },
        listeners: {
            "interactions:before-action-move": E,
            "interactions:action-resume": E,
            "interactions:action-move": T,
            "auto-start:check": function(t1) {
                var e = t1.interaction, n = t1.interactable, r = t1.buttons, i = n.options.drag;
                if (i && i.enabled && (!e.pointerIsDown || !/mouse|pointer/.test(e.pointerType) || 0 != (r & n.options.drag.mouseButtons))) return t1.action = {
                    name: "drag",
                    axis: "start" === i.lockAxis ? i.startAxis : i.lockAxis
                }, !1;
            }
        },
        draggable: function(t1) {
            return w.object(t1) ? (this.options.drag.enabled = !1 !== t1.enabled, this.setPerAction("drag", t1), this.setOnEvents("drag", t1), /^(xy|x|y|start)$/.test(t1.lockAxis) && (this.options.drag.lockAxis = t1.lockAxis), /^(xy|x|y)$/.test(t1.startAxis) && (this.options.drag.startAxis = t1.startAxis), this) : w.bool(t1) ? (this.options.drag.enabled = t1, this) : this.options.drag;
        },
        beforeMove: E,
        move: T,
        defaults: {
            startAxis: "xy",
            lockAxis: "xy"
        },
        getCursor: function() {
            return "move";
        },
        filterEventType: function(t1) {
            return 0 === t1.search("drag");
        }
    }, _ = S, P = {
        init: function(t1) {
            var e = t1;
            P.document = e.document, P.DocumentFragment = e.DocumentFragment || O, P.SVGElement = e.SVGElement || O, P.SVGSVGElement = e.SVGSVGElement || O, P.SVGElementInstance = e.SVGElementInstance || O, P.Element = e.Element || O, P.HTMLElement = e.HTMLElement || P.Element, P.Event = e.Event, P.Touch = e.Touch || O, P.PointerEvent = e.PointerEvent || e.MSPointerEvent;
        },
        document: null,
        DocumentFragment: null,
        SVGElement: null,
        SVGSVGElement: null,
        SVGElementInstance: null,
        Element: null,
        HTMLElement: null,
        Event: null,
        Touch: null,
        PointerEvent: null
    };
    function O() {}
    var k = P;
    var D = {
        init: function(t1) {
            var e = k.Element, n = t1.navigator || {};
            D.supportsTouch = "ontouchstart" in t1 || w.func(t1.DocumentTouch) && k.document instanceof t1.DocumentTouch, D.supportsPointerEvent = !1 !== n.pointerEnabled && !!k.PointerEvent, D.isIOS = /iP(hone|od|ad)/.test(n.platform), D.isIOS7 = /iP(hone|od|ad)/.test(n.platform) && /OS 7[^\d]/.test(n.appVersion), D.isIe9 = /MSIE 9/.test(n.userAgent), D.isOperaMobile = "Opera" === n.appName && D.supportsTouch && /Presto/.test(n.userAgent), D.prefixedMatchesSelector = "matches" in e.prototype ? "matches" : "webkitMatchesSelector" in e.prototype ? "webkitMatchesSelector" : "mozMatchesSelector" in e.prototype ? "mozMatchesSelector" : "oMatchesSelector" in e.prototype ? "oMatchesSelector" : "msMatchesSelector", D.pEventTypes = D.supportsPointerEvent ? k.PointerEvent === t1.MSPointerEvent ? {
                up: "MSPointerUp",
                down: "MSPointerDown",
                over: "mouseover",
                out: "mouseout",
                move: "MSPointerMove",
                cancel: "MSPointerCancel"
            } : {
                up: "pointerup",
                down: "pointerdown",
                over: "pointerover",
                out: "pointerout",
                move: "pointermove",
                cancel: "pointercancel"
            } : null, D.wheelEvent = k.document && "onmousewheel" in k.document ? "mousewheel" : "wheel";
        },
        supportsTouch: null,
        supportsPointerEvent: null,
        isIOS7: null,
        isIOS: null,
        isIe9: null,
        isOperaMobile: null,
        prefixedMatchesSelector: null,
        pEventTypes: null,
        wheelEvent: null
    };
    var I = D;
    function M(t1, e) {
        if (t1.contains) return t1.contains(e);
        for(; e;){
            if (e === t1) return !0;
            e = e.parentNode;
        }
        return !1;
    }
    function z(t1, e) {
        for(; w.element(t1);){
            if (R(t1, e)) return t1;
            t1 = A(t1);
        }
        return null;
    }
    function A(t1) {
        var e = t1.parentNode;
        if (w.docFrag(e)) {
            for(; (e = e.host) && w.docFrag(e););
            return e;
        }
        return e;
    }
    function R(t1, e) {
        return g !== v && (e = e.replace(/\/deep\//g, " ")), t1[I.prefixedMatchesSelector](e);
    }
    var C = function(t1) {
        return t1.parentNode || t1.host;
    };
    function j(t1, e) {
        for(var n, r = [], i = t1; (n = C(i)) && i !== e && n !== i.ownerDocument;)r.unshift(i), i = n;
        return r;
    }
    function F(t1, e, n) {
        for(; w.element(t1);){
            if (R(t1, e)) return !0;
            if ((t1 = A(t1)) === n) return R(t1, e);
        }
        return !1;
    }
    function X(t1) {
        return t1.correspondingUseElement || t1;
    }
    function Y(t1) {
        var e = t1 instanceof k.SVGElement ? t1.getBoundingClientRect() : t1.getClientRects()[0];
        return e && {
            left: e.left,
            right: e.right,
            top: e.top,
            bottom: e.bottom,
            width: e.width || e.right - e.left,
            height: e.height || e.bottom - e.top
        };
    }
    function L(t1) {
        var e, n = Y(t1);
        if (!I.isIOS7 && n) {
            var r = {
                x: (e = (e = y(t1)) || g).scrollX || e.document.documentElement.scrollLeft,
                y: e.scrollY || e.document.documentElement.scrollTop
            };
            n.left += r.x, n.right += r.x, n.top += r.y, n.bottom += r.y;
        }
        return n;
    }
    function q(t1) {
        for(var e = []; t1;)e.push(t1), t1 = A(t1);
        return e;
    }
    function B(t1) {
        return !!w.string(t1) && (k.document.querySelector(t1), !0);
    }
    function V(t1, e) {
        for(var n in e)t1[n] = e[n];
        return t1;
    }
    function W(t1, e, n) {
        return "parent" === t1 ? A(n) : "self" === t1 ? e.getRect(n) : z(n, t1);
    }
    function G(t1, e, n, r) {
        var i = t1;
        return w.string(i) ? i = W(i, e, n) : w.func(i) && (i = i.apply(void 0, r)), w.element(i) && (i = L(i)), i;
    }
    function N(t1) {
        return t1 && {
            x: "x" in t1 ? t1.x : t1.left,
            y: "y" in t1 ? t1.y : t1.top
        };
    }
    function U(t1) {
        return !t1 || "x" in t1 && "y" in t1 || ((t1 = V({}, t1)).x = t1.left || 0, t1.y = t1.top || 0, t1.width = t1.width || (t1.right || 0) - t1.x, t1.height = t1.height || (t1.bottom || 0) - t1.y), t1;
    }
    function H(t1, e, n) {
        t1.left && (e.left += n.x), t1.right && (e.right += n.x), t1.top && (e.top += n.y), t1.bottom && (e.bottom += n.y), e.width = e.right - e.left, e.height = e.bottom - e.top;
    }
    function K(t1, e, n) {
        var r = n && t1.options[n];
        return N(G(r && r.origin || t1.options.origin, t1, e, [
            t1 && e
        ])) || {
            x: 0,
            y: 0
        };
    }
    function $(t1, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function(t1) {
            return !0;
        }, r = arguments.length > 3 ? arguments[3] : void 0;
        if (r = r || {}, w.string(t1) && -1 !== t1.search(" ") && (t1 = J(t1)), w.array(t1)) return t1.forEach(function(t1) {
            return $(t1, e, n, r);
        }), r;
        if (w.object(t1) && (e = t1, t1 = ""), w.func(e) && n(t1)) r[t1] = r[t1] || [], r[t1].push(e);
        else if (w.array(e)) for(var i = 0, o = e; i < o.length; i++){
            var a = o[i];
            $(t1, a, n, r);
        }
        else if (w.object(e)) for(var s in e)$(J(s).map(function(e) {
            return "".concat(t1).concat(e);
        }), e[s], n, r);
        return r;
    }
    function J(t1) {
        return t1.trim().split(/ +/);
    }
    var Q = function(t1, e) {
        return Math.sqrt(t1 * t1 + e * e);
    }, Z = [
        "webkit",
        "moz"
    ];
    function tt(t1, e) {
        t1.__set || (t1.__set = {});
        var n = function(n) {
            if (Z.some(function(t1) {
                return 0 === n.indexOf(t1);
            })) return 1;
            "function" != typeof t1[n] && "__set" !== n && Object.defineProperty(t1, n, {
                get: function() {
                    return n in t1.__set ? t1.__set[n] : t1.__set[n] = e[n];
                },
                set: function(e) {
                    t1.__set[n] = e;
                },
                configurable: !0
            });
        };
        for(var r in e)n(r);
        return t1;
    }
    function et(t1, e) {
        t1.page = t1.page || {}, t1.page.x = e.page.x, t1.page.y = e.page.y, t1.client = t1.client || {}, t1.client.x = e.client.x, t1.client.y = e.client.y, t1.timeStamp = e.timeStamp;
    }
    function nt(t1) {
        t1.page.x = 0, t1.page.y = 0, t1.client.x = 0, t1.client.y = 0;
    }
    function rt(t1) {
        return t1 instanceof k.Event || t1 instanceof k.Touch;
    }
    function it(t1, e, n) {
        return t1 = t1 || "page", (n = n || {}).x = e[t1 + "X"], n.y = e[t1 + "Y"], n;
    }
    function ot(t1, e) {
        return e = e || {
            x: 0,
            y: 0
        }, I.isOperaMobile && rt(t1) ? (it("screen", t1, e), e.x += window.scrollX, e.y += window.scrollY) : it("page", t1, e), e;
    }
    function at(t1) {
        return w.number(t1.pointerId) ? t1.pointerId : t1.identifier;
    }
    function st(t1, e, n) {
        var r = e.length > 1 ? lt(e) : e[0];
        ot(r, t1.page), function(t1, e) {
            e = e || {}, I.isOperaMobile && rt(t1) ? it("screen", t1, e) : it("client", t1, e);
        }(r, t1.client), t1.timeStamp = n;
    }
    function ct(t1) {
        var e = [];
        return w.array(t1) ? (e[0] = t1[0], e[1] = t1[1]) : "touchend" === t1.type ? 1 === t1.touches.length ? (e[0] = t1.touches[0], e[1] = t1.changedTouches[0]) : 0 === t1.touches.length && (e[0] = t1.changedTouches[0], e[1] = t1.changedTouches[1]) : (e[0] = t1.touches[0], e[1] = t1.touches[1]), e;
    }
    function lt(t1) {
        for(var e = {
            pageX: 0,
            pageY: 0,
            clientX: 0,
            clientY: 0,
            screenX: 0,
            screenY: 0
        }, n = 0; n < t1.length; n++){
            var r = t1[n];
            for(var i in e)e[i] += r[i];
        }
        for(var o in e)e[o] /= t1.length;
        return e;
    }
    function ut(t1) {
        if (!t1.length) return null;
        var e = ct(t1), n = Math.min(e[0].pageX, e[1].pageX), r = Math.min(e[0].pageY, e[1].pageY), i = Math.max(e[0].pageX, e[1].pageX), o = Math.max(e[0].pageY, e[1].pageY);
        return {
            x: n,
            y: r,
            left: n,
            top: r,
            right: i,
            bottom: o,
            width: i - n,
            height: o - r
        };
    }
    function pt(t1, e) {
        var n = e + "X", r = e + "Y", i = ct(t1), o = i[0][n] - i[1][n], a = i[0][r] - i[1][r];
        return Q(o, a);
    }
    function ft(t1, e) {
        var n = e + "X", r = e + "Y", i = ct(t1), o = i[1][n] - i[0][n], a = i[1][r] - i[0][r];
        return 180 * Math.atan2(a, o) / Math.PI;
    }
    function dt(t1) {
        return w.string(t1.pointerType) ? t1.pointerType : w.number(t1.pointerType) ? [
            void 0,
            void 0,
            "touch",
            "pen",
            "mouse"
        ][t1.pointerType] : /touch/.test(t1.type || "") || t1 instanceof k.Touch ? "touch" : "mouse";
    }
    function ht(t1) {
        var e = w.func(t1.composedPath) ? t1.composedPath() : t1.path;
        return [
            X(e ? e[0] : t1.target),
            X(t1.currentTarget)
        ];
    }
    var vt = function() {
        function t1(e) {
            r(this, t1), this.immediatePropagationStopped = !1, this.propagationStopped = !1, this._interaction = e;
        }
        return o(t1, [
            {
                key: "preventDefault",
                value: function() {}
            },
            {
                key: "stopPropagation",
                value: function() {
                    this.propagationStopped = !0;
                }
            },
            {
                key: "stopImmediatePropagation",
                value: function() {
                    this.immediatePropagationStopped = this.propagationStopped = !0;
                }
            }
        ]), t1;
    }();
    Object.defineProperty(vt.prototype, "interaction", {
        get: function() {
            return this._interaction._proxy;
        },
        set: function() {}
    });
    var gt = function(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            t1.push(r);
        }
        return t1;
    }, mt = function(t1) {
        return gt([], t1);
    }, yt = function(t1, e) {
        for(var n = 0; n < t1.length; n++)if (e(t1[n], n, t1)) return n;
        return -1;
    }, bt = function(t1, e) {
        return t1[yt(t1, e)];
    }, xt = function(t1) {
        s(n, t1);
        var e = p(n);
        function n(t1, i, o) {
            var a;
            r(this, n), (a = e.call(this, i._interaction)).dropzone = void 0, a.dragEvent = void 0, a.relatedTarget = void 0, a.draggable = void 0, a.propagationStopped = !1, a.immediatePropagationStopped = !1;
            var s = "dragleave" === o ? t1.prev : t1.cur, c = s.element, l = s.dropzone;
            return a.type = o, a.target = c, a.currentTarget = c, a.dropzone = l, a.dragEvent = i, a.relatedTarget = i.target, a.draggable = i.interactable, a.timeStamp = i.timeStamp, a;
        }
        return o(n, [
            {
                key: "reject",
                value: function() {
                    var t1 = this, e = this._interaction.dropState;
                    if ("dropactivate" === this.type || this.dropzone && e.cur.dropzone === this.dropzone && e.cur.element === this.target) {
                        if (e.prev.dropzone = this.dropzone, e.prev.element = this.target, e.rejected = !0, e.events.enter = null, this.stopImmediatePropagation(), "dropactivate" === this.type) {
                            var r = e.activeDrops, i = yt(r, function(e) {
                                var n = e.dropzone, r = e.element;
                                return n === t1.dropzone && r === t1.target;
                            });
                            e.activeDrops.splice(i, 1);
                            var o = new n(e, this.dragEvent, "dropdeactivate");
                            o.dropzone = this.dropzone, o.target = this.target, this.dropzone.fire(o);
                        } else this.dropzone.fire(new n(e, this.dragEvent, "dragleave"));
                    }
                }
            },
            {
                key: "preventDefault",
                value: function() {}
            },
            {
                key: "stopPropagation",
                value: function() {
                    this.propagationStopped = !0;
                }
            },
            {
                key: "stopImmediatePropagation",
                value: function() {
                    this.immediatePropagationStopped = this.propagationStopped = !0;
                }
            }
        ]), n;
    }(vt);
    function wt(t1, e) {
        for(var n = 0, r = t1.slice(); n < r.length; n++){
            var i = r[n], o = i.dropzone, a = i.element;
            e.dropzone = o, e.target = a, o.fire(e), e.propagationStopped = e.immediatePropagationStopped = !1;
        }
    }
    function Et(t1, e) {
        for(var n = function(t1, e) {
            for(var n = [], r = 0, i = t1.interactables.list; r < i.length; r++){
                var o = i[r];
                if (o.options.drop.enabled) {
                    var a = o.options.drop.accept;
                    if (!(w.element(a) && a !== e || w.string(a) && !R(e, a) || w.func(a) && !a({
                        dropzone: o,
                        draggableElement: e
                    }))) for(var s = 0, c = o.getAllElements(); s < c.length; s++){
                        var l = c[s];
                        l !== e && n.push({
                            dropzone: o,
                            element: l,
                            rect: o.getRect(l)
                        });
                    }
                }
            }
            return n;
        }(t1, e), r = 0; r < n.length; r++){
            var i = n[r];
            i.rect = i.dropzone.getRect(i.element);
        }
        return n;
    }
    function Tt(t1, e, n) {
        for(var r = t1.dropState, i = t1.interactable, o = t1.element, a = [], s = 0, c = r.activeDrops; s < c.length; s++){
            var l = c[s], u = l.dropzone, p = l.element, f = l.rect, d = u.dropCheck(e, n, i, o, p, f);
            a.push(d ? p : null);
        }
        var h = function(t1) {
            for(var e, n, r, i = [], o = 0; o < t1.length; o++){
                var a = t1[o], s = t1[e];
                if (a && o !== e) {
                    if (s) {
                        var c = C(a), l = C(s);
                        if (c !== a.ownerDocument) {
                            if (l !== a.ownerDocument) {
                                if (c !== l) {
                                    i = i.length ? i : j(s);
                                    var u = void 0;
                                    if (s instanceof k.HTMLElement && a instanceof k.SVGElement && !(a instanceof k.SVGSVGElement)) {
                                        if (a === l) continue;
                                        u = a.ownerSVGElement;
                                    } else u = a;
                                    for(var p = j(u, s.ownerDocument), f = 0; p[f] && p[f] === i[f];)f++;
                                    var d = [
                                        p[f - 1],
                                        p[f],
                                        i[f]
                                    ];
                                    if (d[0]) for(var h = d[0].lastChild; h;){
                                        if (h === d[1]) {
                                            e = o, i = p;
                                            break;
                                        }
                                        if (h === d[2]) break;
                                        h = h.previousSibling;
                                    }
                                } else r = s, (parseInt(y(n = a).getComputedStyle(n).zIndex, 10) || 0) >= (parseInt(y(r).getComputedStyle(r).zIndex, 10) || 0) && (e = o);
                            } else e = o;
                        }
                    } else e = o;
                }
            }
            return e;
        }(a);
        return r.activeDrops[h] || null;
    }
    function St(t1, e, n) {
        var r = t1.dropState, i = {
            enter: null,
            leave: null,
            activate: null,
            deactivate: null,
            move: null,
            drop: null
        };
        return "dragstart" === n.type && (i.activate = new xt(r, n, "dropactivate"), i.activate.target = null, i.activate.dropzone = null), "dragend" === n.type && (i.deactivate = new xt(r, n, "dropdeactivate"), i.deactivate.target = null, i.deactivate.dropzone = null), r.rejected || (r.cur.element !== r.prev.element && (r.prev.dropzone && (i.leave = new xt(r, n, "dragleave"), n.dragLeave = i.leave.target = r.prev.element, n.prevDropzone = i.leave.dropzone = r.prev.dropzone), r.cur.dropzone && (i.enter = new xt(r, n, "dragenter"), n.dragEnter = r.cur.element, n.dropzone = r.cur.dropzone)), "dragend" === n.type && r.cur.dropzone && (i.drop = new xt(r, n, "drop"), n.dropzone = r.cur.dropzone, n.relatedTarget = r.cur.element), "dragmove" === n.type && r.cur.dropzone && (i.move = new xt(r, n, "dropmove"), n.dropzone = r.cur.dropzone)), i;
    }
    function _t(t1, e) {
        var n = t1.dropState, r = n.activeDrops, i = n.cur, o = n.prev;
        e.leave && o.dropzone.fire(e.leave), e.enter && i.dropzone.fire(e.enter), e.move && i.dropzone.fire(e.move), e.drop && i.dropzone.fire(e.drop), e.deactivate && wt(r, e.deactivate), n.prev.dropzone = i.dropzone, n.prev.element = i.element;
    }
    function Pt(t1, e) {
        var n = t1.interaction, r = t1.iEvent, i = t1.event;
        if ("dragmove" === r.type || "dragend" === r.type) {
            var o = n.dropState;
            e.dynamicDrop && (o.activeDrops = Et(e, n.element));
            var a = r, s = Tt(n, a, i);
            o.rejected = o.rejected && !!s && s.dropzone === o.cur.dropzone && s.element === o.cur.element, o.cur.dropzone = s && s.dropzone, o.cur.element = s && s.element, o.events = St(n, 0, a);
        }
    }
    var Ot = {
        id: "actions/drop",
        install: function(t1) {
            var e = t1.actions, n = t1.interactStatic, r = t1.Interactable, i = t1.defaults;
            t1.usePlugin(_), r.prototype.dropzone = function(t1) {
                return function(t1, e) {
                    if (w.object(e)) {
                        if (t1.options.drop.enabled = !1 !== e.enabled, e.listeners) {
                            var n = $(e.listeners), r = Object.keys(n).reduce(function(t1, e) {
                                return t1[/^(enter|leave)/.test(e) ? "drag".concat(e) : /^(activate|deactivate|move)/.test(e) ? "drop".concat(e) : e] = n[e], t1;
                            }, {}), i = t1.options.drop.listeners;
                            i && t1.off(i), t1.on(r), t1.options.drop.listeners = r;
                        }
                        return w.func(e.ondrop) && t1.on("drop", e.ondrop), w.func(e.ondropactivate) && t1.on("dropactivate", e.ondropactivate), w.func(e.ondropdeactivate) && t1.on("dropdeactivate", e.ondropdeactivate), w.func(e.ondragenter) && t1.on("dragenter", e.ondragenter), w.func(e.ondragleave) && t1.on("dragleave", e.ondragleave), w.func(e.ondropmove) && t1.on("dropmove", e.ondropmove), /^(pointer|center)$/.test(e.overlap) ? t1.options.drop.overlap = e.overlap : w.number(e.overlap) && (t1.options.drop.overlap = Math.max(Math.min(1, e.overlap), 0)), "accept" in e && (t1.options.drop.accept = e.accept), "checker" in e && (t1.options.drop.checker = e.checker), t1;
                    }
                    if (w.bool(e)) return t1.options.drop.enabled = e, t1;
                    return t1.options.drop;
                }(this, t1);
            }, r.prototype.dropCheck = function(t1, e, n, r, i, o) {
                return function(t1, e, n, r, i, o, a) {
                    var s = !1;
                    if (!(a = a || t1.getRect(o))) return !!t1.options.drop.checker && t1.options.drop.checker(e, n, s, t1, o, r, i);
                    var c = t1.options.drop.overlap;
                    if ("pointer" === c) {
                        var l = K(r, i, "drag"), u = ot(e);
                        u.x += l.x, u.y += l.y;
                        var p = u.x > a.left && u.x < a.right, f = u.y > a.top && u.y < a.bottom;
                        s = p && f;
                    }
                    var d = r.getRect(i);
                    if (d && "center" === c) {
                        var h = d.left + d.width / 2, v = d.top + d.height / 2;
                        s = h >= a.left && h <= a.right && v >= a.top && v <= a.bottom;
                    }
                    if (d && w.number(c)) s = Math.max(0, Math.min(a.right, d.right) - Math.max(a.left, d.left)) * Math.max(0, Math.min(a.bottom, d.bottom) - Math.max(a.top, d.top)) / (d.width * d.height) >= c;
                    t1.options.drop.checker && (s = t1.options.drop.checker(e, n, s, t1, o, r, i));
                    return s;
                }(this, t1, e, n, r, i, o);
            }, n.dynamicDrop = function(e) {
                return w.bool(e) ? (t1.dynamicDrop = e, n) : t1.dynamicDrop;
            }, V(e.phaselessTypes, {
                dragenter: !0,
                dragleave: !0,
                dropactivate: !0,
                dropdeactivate: !0,
                dropmove: !0,
                drop: !0
            }), e.methodDict.drop = "dropzone", t1.dynamicDrop = !1, i.actions.drop = Ot.defaults;
        },
        listeners: {
            "interactions:before-action-start": function(t1) {
                var e = t1.interaction;
                "drag" === e.prepared.name && (e.dropState = {
                    cur: {
                        dropzone: null,
                        element: null
                    },
                    prev: {
                        dropzone: null,
                        element: null
                    },
                    rejected: null,
                    events: null,
                    activeDrops: []
                });
            },
            "interactions:after-action-start": function(t1, e) {
                var n = t1.interaction, r = (t1.event, t1.iEvent);
                if ("drag" === n.prepared.name) {
                    var i = n.dropState;
                    i.activeDrops = [], i.events = {}, i.activeDrops = Et(e, n.element), i.events = St(n, 0, r), i.events.activate && (wt(i.activeDrops, i.events.activate), e.fire("actions/drop:start", {
                        interaction: n,
                        dragEvent: r
                    }));
                }
            },
            "interactions:action-move": Pt,
            "interactions:after-action-move": function(t1, e) {
                var n = t1.interaction, r = t1.iEvent;
                if ("drag" === n.prepared.name) {
                    var i = n.dropState;
                    _t(n, i.events), e.fire("actions/drop:move", {
                        interaction: n,
                        dragEvent: r
                    }), i.events = {};
                }
            },
            "interactions:action-end": function(t1, e) {
                if ("drag" === t1.interaction.prepared.name) {
                    var n = t1.interaction, r = t1.iEvent;
                    Pt(t1, e), _t(n, n.dropState.events), e.fire("actions/drop:end", {
                        interaction: n,
                        dragEvent: r
                    });
                }
            },
            "interactions:stop": function(t1) {
                var e = t1.interaction;
                if ("drag" === e.prepared.name) {
                    var n = e.dropState;
                    n && (n.activeDrops = null, n.events = null, n.cur.dropzone = null, n.cur.element = null, n.prev.dropzone = null, n.prev.element = null, n.rejected = !1);
                }
            }
        },
        getActiveDrops: Et,
        getDrop: Tt,
        getDropEvents: St,
        fireDropEvents: _t,
        filterEventType: function(t1) {
            return 0 === t1.search("drag") || 0 === t1.search("drop");
        },
        defaults: {
            enabled: !1,
            accept: null,
            overlap: "pointer"
        }
    }, kt = Ot;
    function Dt(t1) {
        var e = t1.interaction, n = t1.iEvent, r = t1.phase;
        if ("gesture" === e.prepared.name) {
            var i = e.pointers.map(function(t1) {
                return t1.pointer;
            }), o = "start" === r, a = "end" === r, s = e.interactable.options.deltaSource;
            if (n.touches = [
                i[0],
                i[1]
            ], o) n.distance = pt(i, s), n.box = ut(i), n.scale = 1, n.ds = 0, n.angle = ft(i, s), n.da = 0, e.gesture.startDistance = n.distance, e.gesture.startAngle = n.angle;
            else if (a || e.pointers.length < 2) {
                var c = e.prevEvent;
                n.distance = c.distance, n.box = c.box, n.scale = c.scale, n.ds = 0, n.angle = c.angle, n.da = 0;
            } else n.distance = pt(i, s), n.box = ut(i), n.scale = n.distance / e.gesture.startDistance, n.angle = ft(i, s), n.ds = n.scale - e.gesture.scale, n.da = n.angle - e.gesture.angle;
            e.gesture.distance = n.distance, e.gesture.angle = n.angle, w.number(n.scale) && n.scale !== 1 / 0 && !isNaN(n.scale) && (e.gesture.scale = n.scale);
        }
    }
    var It = {
        id: "actions/gesture",
        before: [
            "actions/drag",
            "actions/resize"
        ],
        install: function(t1) {
            var e = t1.actions, n = t1.Interactable, r = t1.defaults;
            n.prototype.gesturable = function(t1) {
                return w.object(t1) ? (this.options.gesture.enabled = !1 !== t1.enabled, this.setPerAction("gesture", t1), this.setOnEvents("gesture", t1), this) : w.bool(t1) ? (this.options.gesture.enabled = t1, this) : this.options.gesture;
            }, e.map.gesture = It, e.methodDict.gesture = "gesturable", r.actions.gesture = It.defaults;
        },
        listeners: {
            "interactions:action-start": Dt,
            "interactions:action-move": Dt,
            "interactions:action-end": Dt,
            "interactions:new": function(t1) {
                t1.interaction.gesture = {
                    angle: 0,
                    distance: 0,
                    scale: 1,
                    startAngle: 0,
                    startDistance: 0
                };
            },
            "auto-start:check": function(t1) {
                if (!(t1.interaction.pointers.length < 2)) {
                    var e = t1.interactable.options.gesture;
                    if (e && e.enabled) return t1.action = {
                        name: "gesture"
                    }, !1;
                }
            }
        },
        defaults: {},
        getCursor: function() {
            return "";
        },
        filterEventType: function(t1) {
            return 0 === t1.search("gesture");
        }
    }, Mt = It;
    function zt(t1, e, n, r, i, o, a) {
        if (!e) return !1;
        if (!0 === e) {
            var s = w.number(o.width) ? o.width : o.right - o.left, c = w.number(o.height) ? o.height : o.bottom - o.top;
            if (a = Math.min(a, Math.abs(("left" === t1 || "right" === t1 ? s : c) / 2)), s < 0 && ("left" === t1 ? t1 = "right" : "right" === t1 && (t1 = "left")), c < 0 && ("top" === t1 ? t1 = "bottom" : "bottom" === t1 && (t1 = "top")), "left" === t1) {
                var l = s >= 0 ? o.left : o.right;
                return n.x < l + a;
            }
            if ("top" === t1) {
                var u = c >= 0 ? o.top : o.bottom;
                return n.y < u + a;
            }
            if ("right" === t1) return n.x > (s >= 0 ? o.right : o.left) - a;
            if ("bottom" === t1) return n.y > (c >= 0 ? o.bottom : o.top) - a;
        }
        return !!w.element(r) && (w.element(e) ? e === r : F(r, e, i));
    }
    function At(t1) {
        var e = t1.iEvent, n = t1.interaction;
        if ("resize" === n.prepared.name && n.resizeAxes) {
            var r = e;
            n.interactable.options.resize.square ? ("y" === n.resizeAxes ? r.delta.x = r.delta.y : r.delta.y = r.delta.x, r.axes = "xy") : (r.axes = n.resizeAxes, "x" === n.resizeAxes ? r.delta.y = 0 : "y" === n.resizeAxes && (r.delta.x = 0));
        }
    }
    var Rt, Ct, jt = {
        id: "actions/resize",
        before: [
            "actions/drag"
        ],
        install: function(t1) {
            var e = t1.actions, n = t1.browser, r = t1.Interactable, i = t1.defaults;
            jt.cursors = function(t1) {
                return t1.isIe9 ? {
                    x: "e-resize",
                    y: "s-resize",
                    xy: "se-resize",
                    top: "n-resize",
                    left: "w-resize",
                    bottom: "s-resize",
                    right: "e-resize",
                    topleft: "se-resize",
                    bottomright: "se-resize",
                    topright: "ne-resize",
                    bottomleft: "ne-resize"
                } : {
                    x: "ew-resize",
                    y: "ns-resize",
                    xy: "nwse-resize",
                    top: "ns-resize",
                    left: "ew-resize",
                    bottom: "ns-resize",
                    right: "ew-resize",
                    topleft: "nwse-resize",
                    bottomright: "nwse-resize",
                    topright: "nesw-resize",
                    bottomleft: "nesw-resize"
                };
            }(n), jt.defaultMargin = n.supportsTouch || n.supportsPointerEvent ? 20 : 10, r.prototype.resizable = function(e) {
                return function(t1, e, n) {
                    if (w.object(e)) return t1.options.resize.enabled = !1 !== e.enabled, t1.setPerAction("resize", e), t1.setOnEvents("resize", e), w.string(e.axis) && /^x$|^y$|^xy$/.test(e.axis) ? t1.options.resize.axis = e.axis : null === e.axis && (t1.options.resize.axis = n.defaults.actions.resize.axis), w.bool(e.preserveAspectRatio) ? t1.options.resize.preserveAspectRatio = e.preserveAspectRatio : w.bool(e.square) && (t1.options.resize.square = e.square), t1;
                    if (w.bool(e)) return t1.options.resize.enabled = e, t1;
                    return t1.options.resize;
                }(this, e, t1);
            }, e.map.resize = jt, e.methodDict.resize = "resizable", i.actions.resize = jt.defaults;
        },
        listeners: {
            "interactions:new": function(t1) {
                t1.interaction.resizeAxes = "xy";
            },
            "interactions:action-start": function(t1) {
                !function(t1) {
                    var e = t1.iEvent, n = t1.interaction;
                    if ("resize" === n.prepared.name && n.prepared.edges) {
                        var r = e, i = n.rect;
                        n._rects = {
                            start: V({}, i),
                            corrected: V({}, i),
                            previous: V({}, i),
                            delta: {
                                left: 0,
                                right: 0,
                                width: 0,
                                top: 0,
                                bottom: 0,
                                height: 0
                            }
                        }, r.edges = n.prepared.edges, r.rect = n._rects.corrected, r.deltaRect = n._rects.delta;
                    }
                }(t1), At(t1);
            },
            "interactions:action-move": function(t1) {
                !function(t1) {
                    var e = t1.iEvent, n = t1.interaction;
                    if ("resize" === n.prepared.name && n.prepared.edges) {
                        var r = e, i = n.interactable.options.resize.invert, o = "reposition" === i || "negate" === i, a = n.rect, s = n._rects, c = s.start, l = s.corrected, u = s.delta, p = s.previous;
                        if (V(p, l), o) {
                            if (V(l, a), "reposition" === i) {
                                if (l.top > l.bottom) {
                                    var f = l.top;
                                    l.top = l.bottom, l.bottom = f;
                                }
                                if (l.left > l.right) {
                                    var d = l.left;
                                    l.left = l.right, l.right = d;
                                }
                            }
                        } else l.top = Math.min(a.top, c.bottom), l.bottom = Math.max(a.bottom, c.top), l.left = Math.min(a.left, c.right), l.right = Math.max(a.right, c.left);
                        for(var h in l.width = l.right - l.left, l.height = l.bottom - l.top, l)u[h] = l[h] - p[h];
                        r.edges = n.prepared.edges, r.rect = l, r.deltaRect = u;
                    }
                }(t1), At(t1);
            },
            "interactions:action-end": function(t1) {
                var e = t1.iEvent, n = t1.interaction;
                if ("resize" === n.prepared.name && n.prepared.edges) {
                    var r = e;
                    r.edges = n.prepared.edges, r.rect = n._rects.corrected, r.deltaRect = n._rects.delta;
                }
            },
            "auto-start:check": function(t1) {
                var e = t1.interaction, n = t1.interactable, r = t1.element, i = t1.rect, o = t1.buttons;
                if (i) {
                    var a = V({}, e.coords.cur.page), s = n.options.resize;
                    if (s && s.enabled && (!e.pointerIsDown || !/mouse|pointer/.test(e.pointerType) || 0 != (o & s.mouseButtons))) {
                        if (w.object(s.edges)) {
                            var c = {
                                left: !1,
                                right: !1,
                                top: !1,
                                bottom: !1
                            };
                            for(var l in c)c[l] = zt(l, s.edges[l], a, e._latestPointer.eventTarget, r, i, s.margin || jt.defaultMargin);
                            c.left = c.left && !c.right, c.top = c.top && !c.bottom, (c.left || c.right || c.top || c.bottom) && (t1.action = {
                                name: "resize",
                                edges: c
                            });
                        } else {
                            var u = "y" !== s.axis && a.x > i.right - jt.defaultMargin, p = "x" !== s.axis && a.y > i.bottom - jt.defaultMargin;
                            (u || p) && (t1.action = {
                                name: "resize",
                                axes: (u ? "x" : "") + (p ? "y" : "")
                            });
                        }
                        return !t1.action && void 0;
                    }
                }
            }
        },
        defaults: {
            square: !1,
            preserveAspectRatio: !1,
            axis: "xy",
            margin: NaN,
            edges: null,
            invert: "none"
        },
        cursors: null,
        getCursor: function(t1) {
            var e = t1.edges, n = t1.axis, r = t1.name, i = jt.cursors, o = null;
            if (n) o = i[r + n];
            else if (e) {
                for(var a = "", s = 0, c = [
                    "top",
                    "bottom",
                    "left",
                    "right"
                ]; s < c.length; s++){
                    var l = c[s];
                    e[l] && (a += l);
                }
                o = i[a];
            }
            return o;
        },
        filterEventType: function(t1) {
            return 0 === t1.search("resize");
        },
        defaultMargin: null
    }, Ft = jt, Xt = {
        id: "actions",
        install: function(t1) {
            t1.usePlugin(Mt), t1.usePlugin(Ft), t1.usePlugin(_), t1.usePlugin(kt);
        }
    }, Yt = 0;
    var Lt = {
        request: function(t1) {
            return Rt(t1);
        },
        cancel: function(t1) {
            return Ct(t1);
        },
        init: function(t1) {
            if (Rt = t1.requestAnimationFrame, Ct = t1.cancelAnimationFrame, !Rt) for(var e = [
                "ms",
                "moz",
                "webkit",
                "o"
            ], n = 0; n < e.length; n++){
                var r = e[n];
                Rt = t1["".concat(r, "RequestAnimationFrame")], Ct = t1["".concat(r, "CancelAnimationFrame")] || t1["".concat(r, "CancelRequestAnimationFrame")];
            }
            Rt = Rt && Rt.bind(t1), Ct = Ct && Ct.bind(t1), Rt || (Rt = function(e) {
                var n = Date.now(), r = Math.max(0, 16 - (n - Yt)), i = t1.setTimeout(function() {
                    e(n + r);
                }, r);
                return Yt = n + r, i;
            }, Ct = function(t1) {
                return clearTimeout(t1);
            });
        }
    };
    var qt = {
        defaults: {
            enabled: !1,
            margin: 60,
            container: null,
            speed: 300
        },
        now: Date.now,
        interaction: null,
        i: 0,
        x: 0,
        y: 0,
        isScrolling: !1,
        prevTime: 0,
        margin: 0,
        speed: 0,
        start: function(t1) {
            qt.isScrolling = !0, Lt.cancel(qt.i), t1.autoScroll = qt, qt.interaction = t1, qt.prevTime = qt.now(), qt.i = Lt.request(qt.scroll);
        },
        stop: function() {
            qt.isScrolling = !1, qt.interaction && (qt.interaction.autoScroll = null), Lt.cancel(qt.i);
        },
        scroll: function() {
            var t1 = qt.interaction, e = t1.interactable, n = t1.element, r = t1.prepared.name, i = e.options[r].autoScroll, o = Bt(i.container, e, n), a = qt.now(), s = (a - qt.prevTime) / 1e3, c = i.speed * s;
            if (c >= 1) {
                var l = {
                    x: qt.x * c,
                    y: qt.y * c
                };
                if (l.x || l.y) {
                    var u = Vt(o);
                    w.window(o) ? o.scrollBy(l.x, l.y) : o && (o.scrollLeft += l.x, o.scrollTop += l.y);
                    var p = Vt(o), f = {
                        x: p.x - u.x,
                        y: p.y - u.y
                    };
                    (f.x || f.y) && e.fire({
                        type: "autoscroll",
                        target: n,
                        interactable: e,
                        delta: f,
                        interaction: t1,
                        container: o
                    });
                }
                qt.prevTime = a;
            }
            qt.isScrolling && (Lt.cancel(qt.i), qt.i = Lt.request(qt.scroll));
        },
        check: function(t1, e) {
            var n;
            return null == (n = t1.options[e].autoScroll) ? void 0 : n.enabled;
        },
        onInteractionMove: function(t1) {
            var e = t1.interaction, n = t1.pointer;
            if (e.interacting() && qt.check(e.interactable, e.prepared.name)) {
                if (e.simulation) qt.x = qt.y = 0;
                else {
                    var r, i, o, a, s = e.interactable, c = e.element, l = e.prepared.name, u = s.options[l].autoScroll, p = Bt(u.container, s, c);
                    if (w.window(p)) a = n.clientX < qt.margin, r = n.clientY < qt.margin, i = n.clientX > p.innerWidth - qt.margin, o = n.clientY > p.innerHeight - qt.margin;
                    else {
                        var f = Y(p);
                        a = n.clientX < f.left + qt.margin, r = n.clientY < f.top + qt.margin, i = n.clientX > f.right - qt.margin, o = n.clientY > f.bottom - qt.margin;
                    }
                    qt.x = i ? 1 : a ? -1 : 0, qt.y = o ? 1 : r ? -1 : 0, qt.isScrolling || (qt.margin = u.margin, qt.speed = u.speed, qt.start(e));
                }
            }
        }
    };
    function Bt(t1, e, n) {
        return (w.string(t1) ? W(t1, e, n) : t1) || y(n);
    }
    function Vt(t1) {
        return w.window(t1) && (t1 = window.document.body), {
            x: t1.scrollLeft,
            y: t1.scrollTop
        };
    }
    var Wt = {
        id: "auto-scroll",
        install: function(t1) {
            var e = t1.defaults, n = t1.actions;
            t1.autoScroll = qt, qt.now = function() {
                return t1.now();
            }, n.phaselessTypes.autoscroll = !0, e.perAction.autoScroll = qt.defaults;
        },
        listeners: {
            "interactions:new": function(t1) {
                t1.interaction.autoScroll = null;
            },
            "interactions:destroy": function(t1) {
                t1.interaction.autoScroll = null, qt.stop(), qt.interaction && (qt.interaction = null);
            },
            "interactions:stop": qt.stop,
            "interactions:action-move": function(t1) {
                return qt.onInteractionMove(t1);
            }
        }
    }, Gt = Wt;
    function Nt(t1, e) {
        var n = !1;
        return function() {
            return n || (g.console.warn(e), n = !0), t1.apply(this, arguments);
        };
    }
    function Ut(t1, e) {
        return t1.name = e.name, t1.axis = e.axis, t1.edges = e.edges, t1;
    }
    function Ht(t1) {
        return w.bool(t1) ? (this.options.styleCursor = t1, this) : null === t1 ? (delete this.options.styleCursor, this) : this.options.styleCursor;
    }
    function Kt(t1) {
        return w.func(t1) ? (this.options.actionChecker = t1, this) : null === t1 ? (delete this.options.actionChecker, this) : this.options.actionChecker;
    }
    var $t = {
        id: "auto-start/interactableMethods",
        install: function(t1) {
            var e = t1.Interactable;
            e.prototype.getAction = function(e, n, r, i) {
                var o = function(t1, e, n, r, i) {
                    var o = t1.getRect(r), a = e.buttons || ({
                        0: 1,
                        1: 4,
                        3: 8,
                        4: 16
                    })[e.button], s = {
                        action: null,
                        interactable: t1,
                        interaction: n,
                        element: r,
                        rect: o,
                        buttons: a
                    };
                    return i.fire("auto-start:check", s), s.action;
                }(this, n, r, i, t1);
                return this.options.actionChecker ? this.options.actionChecker(e, n, o, this, i, r) : o;
            }, e.prototype.ignoreFrom = Nt(function(t1) {
                return this._backCompatOption("ignoreFrom", t1);
            }, "Interactable.ignoreFrom() has been deprecated. Use Interactble.draggable({ignoreFrom: newValue})."), e.prototype.allowFrom = Nt(function(t1) {
                return this._backCompatOption("allowFrom", t1);
            }, "Interactable.allowFrom() has been deprecated. Use Interactble.draggable({allowFrom: newValue})."), e.prototype.actionChecker = Kt, e.prototype.styleCursor = Ht;
        }
    };
    function Jt(t1, e, n, r, i) {
        return e.testIgnoreAllow(e.options[t1.name], n, r) && e.options[t1.name].enabled && ee(e, n, t1, i) ? t1 : null;
    }
    function Qt(t1, e, n, r, i, o, a) {
        for(var s = 0, c = r.length; s < c; s++){
            var l = r[s], u = i[s], p = l.getAction(e, n, t1, u);
            if (p) {
                var f = Jt(p, l, u, o, a);
                if (f) return {
                    action: f,
                    interactable: l,
                    element: u
                };
            }
        }
        return {
            action: null,
            interactable: null,
            element: null
        };
    }
    function Zt(t1, e, n, r, i) {
        var o = [], a = [], s = r;
        function c(t1) {
            o.push(t1), a.push(s);
        }
        for(; w.element(s);){
            o = [], a = [], i.interactables.forEachMatch(s, c);
            var l = Qt(t1, e, n, o, a, r, i);
            if (l.action && !l.interactable.options[l.action.name].manualStart) return l;
            s = A(s);
        }
        return {
            action: null,
            interactable: null,
            element: null
        };
    }
    function te(t1, e, n) {
        var r = e.action, i = e.interactable, o = e.element;
        r = r || {
            name: null
        }, t1.interactable = i, t1.element = o, Ut(t1.prepared, r), t1.rect = i && r.name ? i.getRect(o) : null, ie(t1, n), n.fire("autoStart:prepared", {
            interaction: t1
        });
    }
    function ee(t1, e, n, r) {
        var i = t1.options, o = i[n.name].max, a = i[n.name].maxPerElement, s = r.autoStart.maxInteractions, c = 0, l = 0, u = 0;
        if (!(o && a && s)) return !1;
        for(var p = 0, f = r.interactions.list; p < f.length; p++){
            var d = f[p], h = d.prepared.name;
            if (d.interacting()) {
                if (++c >= s) return !1;
                if (d.interactable === t1) {
                    if ((l += h === n.name ? 1 : 0) >= o) return !1;
                    if (d.element === e && (u++, h === n.name && u >= a)) return !1;
                }
            }
        }
        return s > 0;
    }
    function ne(t1, e) {
        return w.number(t1) ? (e.autoStart.maxInteractions = t1, this) : e.autoStart.maxInteractions;
    }
    function re(t1, e, n) {
        var r = n.autoStart.cursorElement;
        r && r !== t1 && (r.style.cursor = ""), t1.ownerDocument.documentElement.style.cursor = e, t1.style.cursor = e, n.autoStart.cursorElement = e ? t1 : null;
    }
    function ie(t1, e) {
        var n = t1.interactable, r = t1.element, i = t1.prepared;
        if ("mouse" === t1.pointerType && n && n.options.styleCursor) {
            var o = "";
            if (i.name) {
                var a = n.options[i.name].cursorChecker;
                o = w.func(a) ? a(i, n, r, t1._interacting) : e.actions.map[i.name].getCursor(i);
            }
            re(t1.element, o || "", e);
        } else e.autoStart.cursorElement && re(e.autoStart.cursorElement, "", e);
    }
    var oe = {
        id: "auto-start/base",
        before: [
            "actions"
        ],
        install: function(t1) {
            var e = t1.interactStatic, n = t1.defaults;
            t1.usePlugin($t), n.base.actionChecker = null, n.base.styleCursor = !0, V(n.perAction, {
                manualStart: !1,
                max: 1 / 0,
                maxPerElement: 1,
                allowFrom: null,
                ignoreFrom: null,
                mouseButtons: 1
            }), e.maxInteractions = function(e) {
                return ne(e, t1);
            }, t1.autoStart = {
                maxInteractions: 1 / 0,
                withinInteractionLimit: ee,
                cursorElement: null
            };
        },
        listeners: {
            "interactions:down": function(t1, e) {
                var n = t1.interaction, r = t1.pointer, i = t1.event, o = t1.eventTarget;
                n.interacting() || te(n, Zt(n, r, i, o, e), e);
            },
            "interactions:move": function(t1, e) {
                !function(t1, e) {
                    var n = t1.interaction, r = t1.pointer, i = t1.event, o = t1.eventTarget;
                    "mouse" !== n.pointerType || n.pointerIsDown || n.interacting() || te(n, Zt(n, r, i, o, e), e);
                }(t1, e), function(t1, e) {
                    var n = t1.interaction;
                    if (n.pointerIsDown && !n.interacting() && n.pointerWasMoved && n.prepared.name) {
                        e.fire("autoStart:before-start", t1);
                        var r = n.interactable, i = n.prepared.name;
                        i && r && (r.options[i].manualStart || !ee(r, n.element, n.prepared, e) ? n.stop() : (n.start(n.prepared, r, n.element), ie(n, e)));
                    }
                }(t1, e);
            },
            "interactions:stop": function(t1, e) {
                var n = t1.interaction, r = n.interactable;
                r && r.options.styleCursor && re(n.element, "", e);
            }
        },
        maxInteractions: ne,
        withinInteractionLimit: ee,
        validateAction: Jt
    }, ae = oe;
    var se = {
        id: "auto-start/dragAxis",
        listeners: {
            "autoStart:before-start": function(t1, e) {
                var n = t1.interaction, r = t1.eventTarget, i = t1.dx, o = t1.dy;
                if ("drag" === n.prepared.name) {
                    var a = Math.abs(i), s = Math.abs(o), c = n.interactable.options.drag, l = c.startAxis, u = a > s ? "x" : a < s ? "y" : "xy";
                    if (n.prepared.axis = "start" === c.lockAxis ? u[0] : c.lockAxis, "xy" !== u && "xy" !== l && l !== u) {
                        n.prepared.name = null;
                        for(var p = r, f = function(t1) {
                            if (t1 !== n.interactable) {
                                var i = n.interactable.options.drag;
                                if (!i.manualStart && t1.testIgnoreAllow(i, p, r)) {
                                    var o = t1.getAction(n.downPointer, n.downEvent, n, p);
                                    if (o && "drag" === o.name && function(t1, e) {
                                        if (!e) return !1;
                                        var n = e.options.drag.startAxis;
                                        return "xy" === t1 || "xy" === n || n === t1;
                                    }(u, t1) && ae.validateAction(o, t1, p, r, e)) return t1;
                                }
                            }
                        }; w.element(p);){
                            var d = e.interactables.forEachMatch(p, f);
                            if (d) {
                                n.prepared.name = "drag", n.interactable = d, n.element = p;
                                break;
                            }
                            p = A(p);
                        }
                    }
                }
            }
        }
    };
    function ce(t1) {
        var e = t1.prepared && t1.prepared.name;
        if (!e) return null;
        var n = t1.interactable.options;
        return n[e].hold || n[e].delay;
    }
    var le = {
        id: "auto-start/hold",
        install: function(t1) {
            var e = t1.defaults;
            t1.usePlugin(ae), e.perAction.hold = 0, e.perAction.delay = 0;
        },
        listeners: {
            "interactions:new": function(t1) {
                t1.interaction.autoStartHoldTimer = null;
            },
            "autoStart:prepared": function(t1) {
                var e = t1.interaction, n = ce(e);
                n > 0 && (e.autoStartHoldTimer = setTimeout(function() {
                    e.start(e.prepared, e.interactable, e.element);
                }, n));
            },
            "interactions:move": function(t1) {
                var e = t1.interaction, n = t1.duplicate;
                e.autoStartHoldTimer && e.pointerWasMoved && !n && (clearTimeout(e.autoStartHoldTimer), e.autoStartHoldTimer = null);
            },
            "autoStart:before-start": function(t1) {
                var e = t1.interaction;
                ce(e) > 0 && (e.prepared.name = null);
            }
        },
        getHoldDuration: ce
    }, ue = le, pe = {
        id: "auto-start",
        install: function(t1) {
            t1.usePlugin(ae), t1.usePlugin(ue), t1.usePlugin(se);
        }
    }, fe = function(t1) {
        return /^(always|never|auto)$/.test(t1) ? (this.options.preventDefault = t1, this) : w.bool(t1) ? (this.options.preventDefault = t1 ? "always" : "never", this) : this.options.preventDefault;
    };
    function de(t1) {
        var e = t1.interaction, n = t1.event;
        e.interactable && e.interactable.checkAndPreventDefault(n);
    }
    var he = {
        id: "core/interactablePreventDefault",
        install: function(t1) {
            var e = t1.Interactable;
            e.prototype.preventDefault = fe, e.prototype.checkAndPreventDefault = function(e) {
                return function(t1, e, n) {
                    var r = t1.options.preventDefault;
                    if ("never" !== r) {
                        if ("always" !== r) {
                            if (e.events.supportsPassive && /^touch(start|move)$/.test(n.type)) {
                                var i = y(n.target).document, o = e.getDocOptions(i);
                                if (!o || !o.events || !1 !== o.events.passive) return;
                            }
                            /^(mouse|pointer|touch)*(down|start)/i.test(n.type) || w.element(n.target) && R(n.target, "input,select,textarea,[contenteditable=true],[contenteditable=true] *") || n.preventDefault();
                        } else n.preventDefault();
                    }
                }(this, t1, e);
            }, t1.interactions.docEvents.push({
                type: "dragstart",
                listener: function(e) {
                    for(var n = 0, r = t1.interactions.list; n < r.length; n++){
                        var i = r[n];
                        if (i.element && (i.element === e.target || M(i.element, e.target))) return void i.interactable.checkAndPreventDefault(e);
                    }
                }
            });
        },
        listeners: [
            "down",
            "move",
            "up",
            "cancel"
        ].reduce(function(t1, e) {
            return t1["interactions:".concat(e)] = de, t1;
        }, {})
    };
    function ve(t1, e) {
        if (e.phaselessTypes[t1]) return !0;
        for(var n in e.map)if (0 === t1.indexOf(n) && t1.substr(n.length) in e.phases) return !0;
        return !1;
    }
    function ge(t1) {
        var e = {};
        for(var n in t1){
            var r = t1[n];
            w.plainObject(r) ? e[n] = ge(r) : w.array(r) ? e[n] = mt(r) : e[n] = r;
        }
        return e;
    }
    var me = function() {
        function t1(e) {
            r(this, t1), this.states = [], this.startOffset = {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }, this.startDelta = void 0, this.result = void 0, this.endResult = void 0, this.startEdges = void 0, this.edges = void 0, this.interaction = void 0, this.interaction = e, this.result = ye(), this.edges = {
                left: !1,
                right: !1,
                top: !1,
                bottom: !1
            };
        }
        return o(t1, [
            {
                key: "start",
                value: function(t1, e) {
                    var n, r, i = t1.phase, o = this.interaction, a = function(t1) {
                        var e = t1.interactable.options[t1.prepared.name], n = e.modifiers;
                        if (n && n.length) return n;
                        return [
                            "snap",
                            "snapSize",
                            "snapEdges",
                            "restrict",
                            "restrictEdges",
                            "restrictSize"
                        ].map(function(t1) {
                            var n = e[t1];
                            return n && n.enabled && {
                                options: n,
                                methods: n._methods
                            };
                        }).filter(function(t1) {
                            return !!t1;
                        });
                    }(o);
                    this.prepareStates(a), this.startEdges = V({}, o.edges), this.edges = V({}, this.startEdges), this.startOffset = (n = o.rect, r = e, n ? {
                        left: r.x - n.left,
                        top: r.y - n.top,
                        right: n.right - r.x,
                        bottom: n.bottom - r.y
                    } : {
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0
                    }), this.startDelta = {
                        x: 0,
                        y: 0
                    };
                    var s = this.fillArg({
                        phase: i,
                        pageCoords: e,
                        preEnd: !1
                    });
                    return this.result = ye(), this.startAll(s), this.result = this.setAll(s);
                }
            },
            {
                key: "fillArg",
                value: function(t1) {
                    var e = this.interaction;
                    return t1.interaction = e, t1.interactable = e.interactable, t1.element = e.element, t1.rect || (t1.rect = e.rect), t1.edges || (t1.edges = this.startEdges), t1.startOffset = this.startOffset, t1;
                }
            },
            {
                key: "startAll",
                value: function(t1) {
                    for(var e = 0, n = this.states; e < n.length; e++){
                        var r = n[e];
                        r.methods.start && (t1.state = r, r.methods.start(t1));
                    }
                }
            },
            {
                key: "setAll",
                value: function(t1) {
                    var e = t1.phase, n = t1.preEnd, r = t1.skipModifiers, i = t1.rect, o = t1.edges;
                    t1.coords = V({}, t1.pageCoords), t1.rect = V({}, i), t1.edges = V({}, o);
                    for(var a = r ? this.states.slice(r) : this.states, s = ye(t1.coords, t1.rect), c = 0; c < a.length; c++){
                        var l, u = a[c], p = u.options, f = V({}, t1.coords), d = null;
                        null != (l = u.methods) && l.set && this.shouldDo(p, n, e) && (t1.state = u, d = u.methods.set(t1), H(t1.edges, t1.rect, {
                            x: t1.coords.x - f.x,
                            y: t1.coords.y - f.y
                        })), s.eventProps.push(d);
                    }
                    V(this.edges, t1.edges), s.delta.x = t1.coords.x - t1.pageCoords.x, s.delta.y = t1.coords.y - t1.pageCoords.y, s.rectDelta.left = t1.rect.left - i.left, s.rectDelta.right = t1.rect.right - i.right, s.rectDelta.top = t1.rect.top - i.top, s.rectDelta.bottom = t1.rect.bottom - i.bottom;
                    var h = this.result.coords, v = this.result.rect;
                    if (h && v) {
                        var g = s.rect.left !== v.left || s.rect.right !== v.right || s.rect.top !== v.top || s.rect.bottom !== v.bottom;
                        s.changed = g || h.x !== s.coords.x || h.y !== s.coords.y;
                    }
                    return s;
                }
            },
            {
                key: "applyToInteraction",
                value: function(t1) {
                    var e = this.interaction, n = t1.phase, r = e.coords.cur, i = e.coords.start, o = this.result, a = this.startDelta, s = o.delta;
                    "start" === n && V(this.startDelta, o.delta);
                    for(var c = 0, l = [
                        [
                            i,
                            a
                        ],
                        [
                            r,
                            s
                        ]
                    ]; c < l.length; c++){
                        var u = l[c], p = u[0], f = u[1];
                        p.page.x += f.x, p.page.y += f.y, p.client.x += f.x, p.client.y += f.y;
                    }
                    var d = this.result.rectDelta, h = t1.rect || e.rect;
                    h.left += d.left, h.right += d.right, h.top += d.top, h.bottom += d.bottom, h.width = h.right - h.left, h.height = h.bottom - h.top;
                }
            },
            {
                key: "setAndApply",
                value: function(t1) {
                    var e = this.interaction, n = t1.phase, r = t1.preEnd, i = t1.skipModifiers, o = this.setAll(this.fillArg({
                        preEnd: r,
                        phase: n,
                        pageCoords: t1.modifiedCoords || e.coords.cur.page
                    }));
                    if (this.result = o, !o.changed && (!i || i < this.states.length) && e.interacting()) return !1;
                    if (t1.modifiedCoords) {
                        var a = e.coords.cur.page, s = {
                            x: t1.modifiedCoords.x - a.x,
                            y: t1.modifiedCoords.y - a.y
                        };
                        o.coords.x += s.x, o.coords.y += s.y, o.delta.x += s.x, o.delta.y += s.y;
                    }
                    this.applyToInteraction(t1);
                }
            },
            {
                key: "beforeEnd",
                value: function(t1) {
                    var e = t1.interaction, n = t1.event, r = this.states;
                    if (r && r.length) {
                        for(var i = !1, o = 0; o < r.length; o++){
                            var a = r[o];
                            t1.state = a;
                            var s = a.options, c = a.methods, l = c.beforeEnd && c.beforeEnd(t1);
                            if (l) return this.endResult = l, !1;
                            i = i || !i && this.shouldDo(s, !0, t1.phase, !0);
                        }
                        i && e.move({
                            event: n,
                            preEnd: !0
                        });
                    }
                }
            },
            {
                key: "stop",
                value: function(t1) {
                    var e = t1.interaction;
                    if (this.states && this.states.length) {
                        var n = V({
                            states: this.states,
                            interactable: e.interactable,
                            element: e.element,
                            rect: null
                        }, t1);
                        this.fillArg(n);
                        for(var r = 0, i = this.states; r < i.length; r++){
                            var o = i[r];
                            n.state = o, o.methods.stop && o.methods.stop(n);
                        }
                        this.states = null, this.endResult = null;
                    }
                }
            },
            {
                key: "prepareStates",
                value: function(t1) {
                    this.states = [];
                    for(var e = 0; e < t1.length; e++){
                        var n = t1[e], r = n.options, i = n.methods, o = n.name;
                        this.states.push({
                            options: r,
                            methods: i,
                            index: e,
                            name: o
                        });
                    }
                    return this.states;
                }
            },
            {
                key: "restoreInteractionCoords",
                value: function(t1) {
                    var e = t1.interaction, n = e.coords, r = e.rect, i = e.modification;
                    if (i.result) {
                        for(var o = i.startDelta, a = i.result, s = a.delta, c = a.rectDelta, l = 0, u = [
                            [
                                n.start,
                                o
                            ],
                            [
                                n.cur,
                                s
                            ]
                        ]; l < u.length; l++){
                            var p = u[l], f = p[0], d = p[1];
                            f.page.x -= d.x, f.page.y -= d.y, f.client.x -= d.x, f.client.y -= d.y;
                        }
                        r.left -= c.left, r.right -= c.right, r.top -= c.top, r.bottom -= c.bottom;
                    }
                }
            },
            {
                key: "shouldDo",
                value: function(t1, e, n, r) {
                    return !(!t1 || !1 === t1.enabled || r && !t1.endOnly || t1.endOnly && !e || "start" === n && !t1.setStart);
                }
            },
            {
                key: "copyFrom",
                value: function(t1) {
                    this.startOffset = t1.startOffset, this.startDelta = t1.startDelta, this.startEdges = t1.startEdges, this.edges = t1.edges, this.states = t1.states.map(function(t1) {
                        return ge(t1);
                    }), this.result = ye(V({}, t1.result.coords), V({}, t1.result.rect));
                }
            },
            {
                key: "destroy",
                value: function() {
                    for(var t1 in this)this[t1] = null;
                }
            }
        ]), t1;
    }();
    function ye(t1, e) {
        return {
            rect: e,
            coords: t1,
            delta: {
                x: 0,
                y: 0
            },
            rectDelta: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            eventProps: [],
            changed: !0
        };
    }
    function be(t1, e) {
        var n = t1.defaults, r = {
            start: t1.start,
            set: t1.set,
            beforeEnd: t1.beforeEnd,
            stop: t1.stop
        }, i = function(t1) {
            var i = t1 || {};
            for(var o in i.enabled = !1 !== i.enabled, n)o in i || (i[o] = n[o]);
            var a = {
                options: i,
                methods: r,
                name: e,
                enable: function() {
                    return i.enabled = !0, a;
                },
                disable: function() {
                    return i.enabled = !1, a;
                }
            };
            return a;
        };
        return e && "string" == typeof e && (i._defaults = n, i._methods = r), i;
    }
    function xe(t1) {
        var e = t1.iEvent, n = t1.interaction.modification.result;
        n && (e.modifiers = n.eventProps);
    }
    var we = {
        id: "modifiers/base",
        before: [
            "actions"
        ],
        install: function(t1) {
            t1.defaults.perAction.modifiers = [];
        },
        listeners: {
            "interactions:new": function(t1) {
                var e = t1.interaction;
                e.modification = new me(e);
            },
            "interactions:before-action-start": function(t1) {
                var e = t1.interaction, n = t1.interaction.modification;
                n.start(t1, e.coords.start.page), e.edges = n.edges, n.applyToInteraction(t1);
            },
            "interactions:before-action-move": function(t1) {
                var e = t1.interaction, n = e.modification, r = n.setAndApply(t1);
                return e.edges = n.edges, r;
            },
            "interactions:before-action-end": function(t1) {
                var e = t1.interaction, n = e.modification, r = n.beforeEnd(t1);
                return e.edges = n.startEdges, r;
            },
            "interactions:action-start": xe,
            "interactions:action-move": xe,
            "interactions:action-end": xe,
            "interactions:after-action-start": function(t1) {
                return t1.interaction.modification.restoreInteractionCoords(t1);
            },
            "interactions:after-action-move": function(t1) {
                return t1.interaction.modification.restoreInteractionCoords(t1);
            },
            "interactions:stop": function(t1) {
                return t1.interaction.modification.stop(t1);
            }
        }
    }, Ee = we, Te = {
        base: {
            preventDefault: "auto",
            deltaSource: "page"
        },
        perAction: {
            enabled: !1,
            origin: {
                x: 0,
                y: 0
            }
        },
        actions: {}
    }, Se = function(t1) {
        s(n, t1);
        var e = p(n);
        function n(t1, i, o, a, s, c, l) {
            var p;
            r(this, n), (p = e.call(this, t1)).relatedTarget = null, p.screenX = void 0, p.screenY = void 0, p.button = void 0, p.buttons = void 0, p.ctrlKey = void 0, p.shiftKey = void 0, p.altKey = void 0, p.metaKey = void 0, p.page = void 0, p.client = void 0, p.delta = void 0, p.rect = void 0, p.x0 = void 0, p.y0 = void 0, p.t0 = void 0, p.dt = void 0, p.duration = void 0, p.clientX0 = void 0, p.clientY0 = void 0, p.velocity = void 0, p.speed = void 0, p.swipe = void 0, p.axes = void 0, p.preEnd = void 0, s = s || t1.element;
            var f = t1.interactable, d = (f && f.options || Te).deltaSource, h = K(f, s, o), v = "start" === a, g = "end" === a, m = v ? u(p) : t1.prevEvent, y = v ? t1.coords.start : g ? {
                page: m.page,
                client: m.client,
                timeStamp: t1.coords.cur.timeStamp
            } : t1.coords.cur;
            return p.page = V({}, y.page), p.client = V({}, y.client), p.rect = V({}, t1.rect), p.timeStamp = y.timeStamp, g || (p.page.x -= h.x, p.page.y -= h.y, p.client.x -= h.x, p.client.y -= h.y), p.ctrlKey = i.ctrlKey, p.altKey = i.altKey, p.shiftKey = i.shiftKey, p.metaKey = i.metaKey, p.button = i.button, p.buttons = i.buttons, p.target = s, p.currentTarget = s, p.preEnd = c, p.type = l || o + (a || ""), p.interactable = f, p.t0 = v ? t1.pointers[t1.pointers.length - 1].downTime : m.t0, p.x0 = t1.coords.start.page.x - h.x, p.y0 = t1.coords.start.page.y - h.y, p.clientX0 = t1.coords.start.client.x - h.x, p.clientY0 = t1.coords.start.client.y - h.y, p.delta = v || g ? {
                x: 0,
                y: 0
            } : {
                x: p[d].x - m[d].x,
                y: p[d].y - m[d].y
            }, p.dt = t1.coords.delta.timeStamp, p.duration = p.timeStamp - p.t0, p.velocity = V({}, t1.coords.velocity[d]), p.speed = Q(p.velocity.x, p.velocity.y), p.swipe = g || "inertiastart" === a ? p.getSwipe() : null, p;
        }
        return o(n, [
            {
                key: "getSwipe",
                value: function() {
                    var t1 = this._interaction;
                    if (t1.prevEvent.speed < 600 || this.timeStamp - t1.prevEvent.timeStamp > 150) return null;
                    var e = 180 * Math.atan2(t1.prevEvent.velocityY, t1.prevEvent.velocityX) / Math.PI;
                    e < 0 && (e += 360);
                    var n = 112.5 <= e && e < 247.5, r = 202.5 <= e && e < 337.5;
                    return {
                        up: r,
                        down: !r && 22.5 <= e && e < 157.5,
                        left: n,
                        right: !n && (292.5 <= e || e < 67.5),
                        angle: e,
                        speed: t1.prevEvent.speed,
                        velocity: {
                            x: t1.prevEvent.velocityX,
                            y: t1.prevEvent.velocityY
                        }
                    };
                }
            },
            {
                key: "preventDefault",
                value: function() {}
            },
            {
                key: "stopImmediatePropagation",
                value: function() {
                    this.immediatePropagationStopped = this.propagationStopped = !0;
                }
            },
            {
                key: "stopPropagation",
                value: function() {
                    this.propagationStopped = !0;
                }
            }
        ]), n;
    }(vt);
    Object.defineProperties(Se.prototype, {
        pageX: {
            get: function() {
                return this.page.x;
            },
            set: function(t1) {
                this.page.x = t1;
            }
        },
        pageY: {
            get: function() {
                return this.page.y;
            },
            set: function(t1) {
                this.page.y = t1;
            }
        },
        clientX: {
            get: function() {
                return this.client.x;
            },
            set: function(t1) {
                this.client.x = t1;
            }
        },
        clientY: {
            get: function() {
                return this.client.y;
            },
            set: function(t1) {
                this.client.y = t1;
            }
        },
        dx: {
            get: function() {
                return this.delta.x;
            },
            set: function(t1) {
                this.delta.x = t1;
            }
        },
        dy: {
            get: function() {
                return this.delta.y;
            },
            set: function(t1) {
                this.delta.y = t1;
            }
        },
        velocityX: {
            get: function() {
                return this.velocity.x;
            },
            set: function(t1) {
                this.velocity.x = t1;
            }
        },
        velocityY: {
            get: function() {
                return this.velocity.y;
            },
            set: function(t1) {
                this.velocity.y = t1;
            }
        }
    });
    var _e = o(function t1(e, n, i, o, a) {
        r(this, t1), this.id = void 0, this.pointer = void 0, this.event = void 0, this.downTime = void 0, this.downTarget = void 0, this.id = e, this.pointer = n, this.event = i, this.downTime = o, this.downTarget = a;
    }), Pe = function(t1) {
        return t1.interactable = "", t1.element = "", t1.prepared = "", t1.pointerIsDown = "", t1.pointerWasMoved = "", t1._proxy = "", t1;
    }({}), Oe = function(t1) {
        return t1.start = "", t1.move = "", t1.end = "", t1.stop = "", t1.interacting = "", t1;
    }({}), ke = 0, De = function() {
        function t1(e) {
            var n = this, i = e.pointerType, o = e.scopeFire;
            r(this, t1), this.interactable = null, this.element = null, this.rect = null, this._rects = void 0, this.edges = null, this._scopeFire = void 0, this.prepared = {
                name: null,
                axis: null,
                edges: null
            }, this.pointerType = void 0, this.pointers = [], this.downEvent = null, this.downPointer = {}, this._latestPointer = {
                pointer: null,
                event: null,
                eventTarget: null
            }, this.prevEvent = null, this.pointerIsDown = !1, this.pointerWasMoved = !1, this._interacting = !1, this._ending = !1, this._stopped = !0, this._proxy = void 0, this.simulation = null, this.doMove = Nt(function(t1) {
                this.move(t1);
            }, "The interaction.doMove() method has been renamed to interaction.move()"), this.coords = {
                start: {
                    page: {
                        x: 0,
                        y: 0
                    },
                    client: {
                        x: 0,
                        y: 0
                    },
                    timeStamp: 0
                },
                prev: {
                    page: {
                        x: 0,
                        y: 0
                    },
                    client: {
                        x: 0,
                        y: 0
                    },
                    timeStamp: 0
                },
                cur: {
                    page: {
                        x: 0,
                        y: 0
                    },
                    client: {
                        x: 0,
                        y: 0
                    },
                    timeStamp: 0
                },
                delta: {
                    page: {
                        x: 0,
                        y: 0
                    },
                    client: {
                        x: 0,
                        y: 0
                    },
                    timeStamp: 0
                },
                velocity: {
                    page: {
                        x: 0,
                        y: 0
                    },
                    client: {
                        x: 0,
                        y: 0
                    },
                    timeStamp: 0
                }
            }, this._id = ke++, this._scopeFire = o, this.pointerType = i;
            var a = this;
            this._proxy = {};
            var s = function(t1) {
                Object.defineProperty(n._proxy, t1, {
                    get: function() {
                        return a[t1];
                    }
                });
            };
            for(var c in Pe)s(c);
            var l = function(t1) {
                Object.defineProperty(n._proxy, t1, {
                    value: function() {
                        return a[t1].apply(a, arguments);
                    }
                });
            };
            for(var u in Oe)l(u);
            this._scopeFire("interactions:new", {
                interaction: this
            });
        }
        return o(t1, [
            {
                key: "pointerMoveTolerance",
                get: function() {
                    return 1;
                }
            },
            {
                key: "pointerDown",
                value: function(t1, e, n) {
                    var r = this.updatePointer(t1, e, n, !0), i = this.pointers[r];
                    this._scopeFire("interactions:down", {
                        pointer: t1,
                        event: e,
                        eventTarget: n,
                        pointerIndex: r,
                        pointerInfo: i,
                        type: "down",
                        interaction: this
                    });
                }
            },
            {
                key: "start",
                value: function(t1, e, n) {
                    return !(this.interacting() || !this.pointerIsDown || this.pointers.length < ("gesture" === t1.name ? 2 : 1) || !e.options[t1.name].enabled) && (Ut(this.prepared, t1), this.interactable = e, this.element = n, this.rect = e.getRect(n), this.edges = this.prepared.edges ? V({}, this.prepared.edges) : {
                        left: !0,
                        right: !0,
                        top: !0,
                        bottom: !0
                    }, this._stopped = !1, this._interacting = this._doPhase({
                        interaction: this,
                        event: this.downEvent,
                        phase: "start"
                    }) && !this._stopped, this._interacting);
                }
            },
            {
                key: "pointerMove",
                value: function(t1, e, n) {
                    this.simulation || this.modification && this.modification.endResult || this.updatePointer(t1, e, n, !1);
                    var r, i, o = this.coords.cur.page.x === this.coords.prev.page.x && this.coords.cur.page.y === this.coords.prev.page.y && this.coords.cur.client.x === this.coords.prev.client.x && this.coords.cur.client.y === this.coords.prev.client.y;
                    this.pointerIsDown && !this.pointerWasMoved && (r = this.coords.cur.client.x - this.coords.start.client.x, i = this.coords.cur.client.y - this.coords.start.client.y, this.pointerWasMoved = Q(r, i) > this.pointerMoveTolerance);
                    var a, s, c, l = this.getPointerIndex(t1), u = {
                        pointer: t1,
                        pointerIndex: l,
                        pointerInfo: this.pointers[l],
                        event: e,
                        type: "move",
                        eventTarget: n,
                        dx: r,
                        dy: i,
                        duplicate: o,
                        interaction: this
                    };
                    o || (a = this.coords.velocity, s = this.coords.delta, c = Math.max(s.timeStamp / 1e3, .001), a.page.x = s.page.x / c, a.page.y = s.page.y / c, a.client.x = s.client.x / c, a.client.y = s.client.y / c, a.timeStamp = c), this._scopeFire("interactions:move", u), o || this.simulation || (this.interacting() && (u.type = null, this.move(u)), this.pointerWasMoved && et(this.coords.prev, this.coords.cur));
                }
            },
            {
                key: "move",
                value: function(t1) {
                    t1 && t1.event || nt(this.coords.delta), (t1 = V({
                        pointer: this._latestPointer.pointer,
                        event: this._latestPointer.event,
                        eventTarget: this._latestPointer.eventTarget,
                        interaction: this
                    }, t1 || {})).phase = "move", this._doPhase(t1);
                }
            },
            {
                key: "pointerUp",
                value: function(t1, e, n, r) {
                    var i = this.getPointerIndex(t1);
                    -1 === i && (i = this.updatePointer(t1, e, n, !1));
                    var o = /cancel$/i.test(e.type) ? "cancel" : "up";
                    this._scopeFire("interactions:".concat(o), {
                        pointer: t1,
                        pointerIndex: i,
                        pointerInfo: this.pointers[i],
                        event: e,
                        eventTarget: n,
                        type: o,
                        curEventTarget: r,
                        interaction: this
                    }), this.simulation || this.end(e), this.removePointer(t1, e);
                }
            },
            {
                key: "documentBlur",
                value: function(t1) {
                    this.end(t1), this._scopeFire("interactions:blur", {
                        event: t1,
                        type: "blur",
                        interaction: this
                    });
                }
            },
            {
                key: "end",
                value: function(t1) {
                    var e;
                    this._ending = !0, t1 = t1 || this._latestPointer.event, this.interacting() && (e = this._doPhase({
                        event: t1,
                        interaction: this,
                        phase: "end"
                    })), this._ending = !1, !0 === e && this.stop();
                }
            },
            {
                key: "currentAction",
                value: function() {
                    return this._interacting ? this.prepared.name : null;
                }
            },
            {
                key: "interacting",
                value: function() {
                    return this._interacting;
                }
            },
            {
                key: "stop",
                value: function() {
                    this._scopeFire("interactions:stop", {
                        interaction: this
                    }), this.interactable = this.element = null, this._interacting = !1, this._stopped = !0, this.prepared.name = this.prevEvent = null;
                }
            },
            {
                key: "getPointerIndex",
                value: function(t1) {
                    var e = at(t1);
                    return "mouse" === this.pointerType || "pen" === this.pointerType ? this.pointers.length - 1 : yt(this.pointers, function(t1) {
                        return t1.id === e;
                    });
                }
            },
            {
                key: "getPointerInfo",
                value: function(t1) {
                    return this.pointers[this.getPointerIndex(t1)];
                }
            },
            {
                key: "updatePointer",
                value: function(t1, e, n, r) {
                    var i, o, a, s = at(t1), c = this.getPointerIndex(t1), l = this.pointers[c];
                    return r = !1 !== r && (r || /(down|start)$/i.test(e.type)), l ? l.pointer = t1 : (l = new _e(s, t1, e, null, null), c = this.pointers.length, this.pointers.push(l)), st(this.coords.cur, this.pointers.map(function(t1) {
                        return t1.pointer;
                    }), this._now()), i = this.coords.delta, o = this.coords.prev, a = this.coords.cur, i.page.x = a.page.x - o.page.x, i.page.y = a.page.y - o.page.y, i.client.x = a.client.x - o.client.x, i.client.y = a.client.y - o.client.y, i.timeStamp = a.timeStamp - o.timeStamp, r && (this.pointerIsDown = !0, l.downTime = this.coords.cur.timeStamp, l.downTarget = n, tt(this.downPointer, t1), this.interacting() || (et(this.coords.start, this.coords.cur), et(this.coords.prev, this.coords.cur), this.downEvent = e, this.pointerWasMoved = !1)), this._updateLatestPointer(t1, e, n), this._scopeFire("interactions:update-pointer", {
                        pointer: t1,
                        event: e,
                        eventTarget: n,
                        down: r,
                        pointerInfo: l,
                        pointerIndex: c,
                        interaction: this
                    }), c;
                }
            },
            {
                key: "removePointer",
                value: function(t1, e) {
                    var n = this.getPointerIndex(t1);
                    if (-1 !== n) {
                        var r = this.pointers[n];
                        this._scopeFire("interactions:remove-pointer", {
                            pointer: t1,
                            event: e,
                            eventTarget: null,
                            pointerIndex: n,
                            pointerInfo: r,
                            interaction: this
                        }), this.pointers.splice(n, 1), this.pointerIsDown = !1;
                    }
                }
            },
            {
                key: "_updateLatestPointer",
                value: function(t1, e, n) {
                    this._latestPointer.pointer = t1, this._latestPointer.event = e, this._latestPointer.eventTarget = n;
                }
            },
            {
                key: "destroy",
                value: function() {
                    this._latestPointer.pointer = null, this._latestPointer.event = null, this._latestPointer.eventTarget = null;
                }
            },
            {
                key: "_createPreparedEvent",
                value: function(t1, e, n, r) {
                    return new Se(this, t1, this.prepared.name, e, this.element, n, r);
                }
            },
            {
                key: "_fireEvent",
                value: function(t1) {
                    var e;
                    null == (e = this.interactable) || e.fire(t1), (!this.prevEvent || t1.timeStamp >= this.prevEvent.timeStamp) && (this.prevEvent = t1);
                }
            },
            {
                key: "_doPhase",
                value: function(t1) {
                    var e = t1.event, n = t1.phase, r = t1.preEnd, i = t1.type, o = this.rect;
                    if (o && "move" === n && (H(this.edges, o, this.coords.delta[this.interactable.options.deltaSource]), o.width = o.right - o.left, o.height = o.bottom - o.top), !1 === this._scopeFire("interactions:before-action-".concat(n), t1)) return !1;
                    var a = t1.iEvent = this._createPreparedEvent(e, n, r, i);
                    return this._scopeFire("interactions:action-".concat(n), t1), "start" === n && (this.prevEvent = a), this._fireEvent(a), this._scopeFire("interactions:after-action-".concat(n), t1), !0;
                }
            },
            {
                key: "_now",
                value: function() {
                    return Date.now();
                }
            }
        ]), t1;
    }();
    function Ie(t1) {
        Me(t1.interaction);
    }
    function Me(t1) {
        if (!function(t1) {
            return !(!t1.offset.pending.x && !t1.offset.pending.y);
        }(t1)) return !1;
        var e = t1.offset.pending;
        return Ae(t1.coords.cur, e), Ae(t1.coords.delta, e), H(t1.edges, t1.rect, e), e.x = 0, e.y = 0, !0;
    }
    function ze(t1) {
        var e = t1.x, n = t1.y;
        this.offset.pending.x += e, this.offset.pending.y += n, this.offset.total.x += e, this.offset.total.y += n;
    }
    function Ae(t1, e) {
        var n = t1.page, r = t1.client, i = e.x, o = e.y;
        n.x += i, n.y += o, r.x += i, r.y += o;
    }
    Oe.offsetBy = "";
    var Re = {
        id: "offset",
        before: [
            "modifiers",
            "pointer-events",
            "actions",
            "inertia"
        ],
        install: function(t1) {
            t1.Interaction.prototype.offsetBy = ze;
        },
        listeners: {
            "interactions:new": function(t1) {
                t1.interaction.offset = {
                    total: {
                        x: 0,
                        y: 0
                    },
                    pending: {
                        x: 0,
                        y: 0
                    }
                };
            },
            "interactions:update-pointer": function(t1) {
                return function(t1) {
                    t1.pointerIsDown && (Ae(t1.coords.cur, t1.offset.total), t1.offset.pending.x = 0, t1.offset.pending.y = 0);
                }(t1.interaction);
            },
            "interactions:before-action-start": Ie,
            "interactions:before-action-move": Ie,
            "interactions:before-action-end": function(t1) {
                var e = t1.interaction;
                if (Me(e)) return e.move({
                    offset: !0
                }), e.end(), !1;
            },
            "interactions:stop": function(t1) {
                var e = t1.interaction;
                e.offset.total.x = 0, e.offset.total.y = 0, e.offset.pending.x = 0, e.offset.pending.y = 0;
            }
        }
    }, Ce = Re;
    var je = function() {
        function t1(e) {
            r(this, t1), this.active = !1, this.isModified = !1, this.smoothEnd = !1, this.allowResume = !1, this.modification = void 0, this.modifierCount = 0, this.modifierArg = void 0, this.startCoords = void 0, this.t0 = 0, this.v0 = 0, this.te = 0, this.targetOffset = void 0, this.modifiedOffset = void 0, this.currentOffset = void 0, this.lambda_v0 = 0, this.one_ve_v0 = 0, this.timeout = void 0, this.interaction = void 0, this.interaction = e;
        }
        return o(t1, [
            {
                key: "start",
                value: function(t1) {
                    var e = this.interaction, n = Fe(e);
                    if (!n || !n.enabled) return !1;
                    var r = e.coords.velocity.client, i = Q(r.x, r.y), o = this.modification || (this.modification = new me(e));
                    if (o.copyFrom(e.modification), this.t0 = e._now(), this.allowResume = n.allowResume, this.v0 = i, this.currentOffset = {
                        x: 0,
                        y: 0
                    }, this.startCoords = e.coords.cur.page, this.modifierArg = o.fillArg({
                        pageCoords: this.startCoords,
                        preEnd: !0,
                        phase: "inertiastart"
                    }), this.t0 - e.coords.cur.timeStamp < 50 && i > n.minSpeed && i > n.endSpeed) this.startInertia();
                    else {
                        if (o.result = o.setAll(this.modifierArg), !o.result.changed) return !1;
                        this.startSmoothEnd();
                    }
                    return e.modification.result.rect = null, e.offsetBy(this.targetOffset), e._doPhase({
                        interaction: e,
                        event: t1,
                        phase: "inertiastart"
                    }), e.offsetBy({
                        x: -this.targetOffset.x,
                        y: -this.targetOffset.y
                    }), e.modification.result.rect = null, this.active = !0, e.simulation = this, !0;
                }
            },
            {
                key: "startInertia",
                value: function() {
                    var t1 = this, e = this.interaction.coords.velocity.client, n = Fe(this.interaction), r = n.resistance, i = -Math.log(n.endSpeed / this.v0) / r;
                    this.targetOffset = {
                        x: (e.x - i) / r,
                        y: (e.y - i) / r
                    }, this.te = i, this.lambda_v0 = r / this.v0, this.one_ve_v0 = 1 - n.endSpeed / this.v0;
                    var o = this.modification, a = this.modifierArg;
                    a.pageCoords = {
                        x: this.startCoords.x + this.targetOffset.x,
                        y: this.startCoords.y + this.targetOffset.y
                    }, o.result = o.setAll(a), o.result.changed && (this.isModified = !0, this.modifiedOffset = {
                        x: this.targetOffset.x + o.result.delta.x,
                        y: this.targetOffset.y + o.result.delta.y
                    }), this.onNextFrame(function() {
                        return t1.inertiaTick();
                    });
                }
            },
            {
                key: "startSmoothEnd",
                value: function() {
                    var t1 = this;
                    this.smoothEnd = !0, this.isModified = !0, this.targetOffset = {
                        x: this.modification.result.delta.x,
                        y: this.modification.result.delta.y
                    }, this.onNextFrame(function() {
                        return t1.smoothEndTick();
                    });
                }
            },
            {
                key: "onNextFrame",
                value: function(t1) {
                    var e = this;
                    this.timeout = Lt.request(function() {
                        e.active && t1();
                    });
                }
            },
            {
                key: "inertiaTick",
                value: function() {
                    var t1, e, n, r, i, o, a, s = this, c = this.interaction, l = Fe(c).resistance, u = (c._now() - this.t0) / 1e3;
                    if (u < this.te) {
                        var p, f = 1 - (Math.exp(-l * u) - this.lambda_v0) / this.one_ve_v0;
                        this.isModified ? (t1 = 0, e = 0, n = this.targetOffset.x, r = this.targetOffset.y, i = this.modifiedOffset.x, o = this.modifiedOffset.y, p = {
                            x: Ye(a = f, t1, n, i),
                            y: Ye(a, e, r, o)
                        }) : p = {
                            x: this.targetOffset.x * f,
                            y: this.targetOffset.y * f
                        };
                        var d = {
                            x: p.x - this.currentOffset.x,
                            y: p.y - this.currentOffset.y
                        };
                        this.currentOffset.x += d.x, this.currentOffset.y += d.y, c.offsetBy(d), c.move(), this.onNextFrame(function() {
                            return s.inertiaTick();
                        });
                    } else c.offsetBy({
                        x: this.modifiedOffset.x - this.currentOffset.x,
                        y: this.modifiedOffset.y - this.currentOffset.y
                    }), this.end();
                }
            },
            {
                key: "smoothEndTick",
                value: function() {
                    var t1 = this, e = this.interaction, n = e._now() - this.t0, r = Fe(e).smoothEndDuration;
                    if (n < r) {
                        var i = {
                            x: Le(n, 0, this.targetOffset.x, r),
                            y: Le(n, 0, this.targetOffset.y, r)
                        }, o = {
                            x: i.x - this.currentOffset.x,
                            y: i.y - this.currentOffset.y
                        };
                        this.currentOffset.x += o.x, this.currentOffset.y += o.y, e.offsetBy(o), e.move({
                            skipModifiers: this.modifierCount
                        }), this.onNextFrame(function() {
                            return t1.smoothEndTick();
                        });
                    } else e.offsetBy({
                        x: this.targetOffset.x - this.currentOffset.x,
                        y: this.targetOffset.y - this.currentOffset.y
                    }), this.end();
                }
            },
            {
                key: "resume",
                value: function(t1) {
                    var e = t1.pointer, n = t1.event, r = t1.eventTarget, i = this.interaction;
                    i.offsetBy({
                        x: -this.currentOffset.x,
                        y: -this.currentOffset.y
                    }), i.updatePointer(e, n, r, !0), i._doPhase({
                        interaction: i,
                        event: n,
                        phase: "resume"
                    }), et(i.coords.prev, i.coords.cur), this.stop();
                }
            },
            {
                key: "end",
                value: function() {
                    this.interaction.move(), this.interaction.end(), this.stop();
                }
            },
            {
                key: "stop",
                value: function() {
                    this.active = this.smoothEnd = !1, this.interaction.simulation = null, Lt.cancel(this.timeout);
                }
            }
        ]), t1;
    }();
    function Fe(t1) {
        var e = t1.interactable, n = t1.prepared;
        return e && e.options && n.name && e.options[n.name].inertia;
    }
    var Xe = {
        id: "inertia",
        before: [
            "modifiers",
            "actions"
        ],
        install: function(t1) {
            var e = t1.defaults;
            t1.usePlugin(Ce), t1.usePlugin(Ee), t1.actions.phases.inertiastart = !0, t1.actions.phases.resume = !0, e.perAction.inertia = {
                enabled: !1,
                resistance: 10,
                minSpeed: 100,
                endSpeed: 10,
                allowResume: !0,
                smoothEndDuration: 300
            };
        },
        listeners: {
            "interactions:new": function(t1) {
                var e = t1.interaction;
                e.inertia = new je(e);
            },
            "interactions:before-action-end": function(t1) {
                var e = t1.interaction, n = t1.event;
                return (!e._interacting || e.simulation || !e.inertia.start(n)) && null;
            },
            "interactions:down": function(t1) {
                var e = t1.interaction, n = t1.eventTarget, r = e.inertia;
                if (r.active) for(var i = n; w.element(i);){
                    if (i === e.element) {
                        r.resume(t1);
                        break;
                    }
                    i = A(i);
                }
            },
            "interactions:stop": function(t1) {
                var e = t1.interaction.inertia;
                e.active && e.stop();
            },
            "interactions:before-action-resume": function(t1) {
                var e = t1.interaction.modification;
                e.stop(t1), e.start(t1, t1.interaction.coords.cur.page), e.applyToInteraction(t1);
            },
            "interactions:before-action-inertiastart": function(t1) {
                return t1.interaction.modification.setAndApply(t1);
            },
            "interactions:action-resume": xe,
            "interactions:action-inertiastart": xe,
            "interactions:after-action-inertiastart": function(t1) {
                return t1.interaction.modification.restoreInteractionCoords(t1);
            },
            "interactions:after-action-resume": function(t1) {
                return t1.interaction.modification.restoreInteractionCoords(t1);
            }
        }
    };
    function Ye(t1, e, n, r) {
        var i = 1 - t1;
        return i * i * e + 2 * i * t1 * n + t1 * t1 * r;
    }
    function Le(t1, e, n, r) {
        return -n * (t1 /= r) * (t1 - 2) + e;
    }
    var qe = Xe;
    function Be(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            if (t1.immediatePropagationStopped) break;
            r(t1);
        }
    }
    var Ve = function() {
        function t1(e) {
            r(this, t1), this.options = void 0, this.types = {}, this.propagationStopped = !1, this.immediatePropagationStopped = !1, this.global = void 0, this.options = V({}, e || {});
        }
        return o(t1, [
            {
                key: "fire",
                value: function(t1) {
                    var e, n = this.global;
                    (e = this.types[t1.type]) && Be(t1, e), !t1.propagationStopped && n && (e = n[t1.type]) && Be(t1, e);
                }
            },
            {
                key: "on",
                value: function(t1, e) {
                    var n = $(t1, e);
                    for(t1 in n)this.types[t1] = gt(this.types[t1] || [], n[t1]);
                }
            },
            {
                key: "off",
                value: function(t1, e) {
                    var n = $(t1, e);
                    for(t1 in n){
                        var r = this.types[t1];
                        if (r && r.length) for(var i = 0, o = n[t1]; i < o.length; i++){
                            var a = o[i], s = r.indexOf(a);
                            -1 !== s && r.splice(s, 1);
                        }
                    }
                }
            },
            {
                key: "getRect",
                value: function(t1) {
                    return null;
                }
            }
        ]), t1;
    }();
    var We = function() {
        function t1(e) {
            r(this, t1), this.currentTarget = void 0, this.originalEvent = void 0, this.type = void 0, this.originalEvent = e, tt(this, e);
        }
        return o(t1, [
            {
                key: "preventOriginalDefault",
                value: function() {
                    this.originalEvent.preventDefault();
                }
            },
            {
                key: "stopPropagation",
                value: function() {
                    this.originalEvent.stopPropagation();
                }
            },
            {
                key: "stopImmediatePropagation",
                value: function() {
                    this.originalEvent.stopImmediatePropagation();
                }
            }
        ]), t1;
    }();
    function Ge(t1) {
        return w.object(t1) ? {
            capture: !!t1.capture,
            passive: !!t1.passive
        } : {
            capture: !!t1,
            passive: !1
        };
    }
    function Ne(t1, e) {
        return t1 === e || ("boolean" == typeof t1 ? !!e.capture === t1 && !1 == !!e.passive : !!t1.capture == !!e.capture && !!t1.passive == !!e.passive);
    }
    var Ue = {
        id: "events",
        install: function(t1) {
            var e, n = [], r = {}, i = [], o = {
                add: a,
                remove: s,
                addDelegate: function(t1, e, n, o, s) {
                    var u = Ge(s);
                    if (!r[n]) {
                        r[n] = [];
                        for(var p = 0; p < i.length; p++){
                            var f = i[p];
                            a(f, n, c), a(f, n, l, !0);
                        }
                    }
                    var d = r[n], h = bt(d, function(n) {
                        return n.selector === t1 && n.context === e;
                    });
                    h || (h = {
                        selector: t1,
                        context: e,
                        listeners: []
                    }, d.push(h));
                    h.listeners.push({
                        func: o,
                        options: u
                    });
                },
                removeDelegate: function(t1, e, n, i, o) {
                    var a, u = Ge(o), p = r[n], f = !1;
                    if (!p) return;
                    for(a = p.length - 1; a >= 0; a--){
                        var d = p[a];
                        if (d.selector === t1 && d.context === e) {
                            for(var h = d.listeners, v = h.length - 1; v >= 0; v--){
                                var g = h[v];
                                if (g.func === i && Ne(g.options, u)) {
                                    h.splice(v, 1), h.length || (p.splice(a, 1), s(e, n, c), s(e, n, l, !0)), f = !0;
                                    break;
                                }
                            }
                            if (f) break;
                        }
                    }
                },
                delegateListener: c,
                delegateUseCapture: l,
                delegatedEvents: r,
                documents: i,
                targets: n,
                supportsOptions: !1,
                supportsPassive: !1
            };
            function a(t1, e, r, i) {
                if (t1.addEventListener) {
                    var a = Ge(i), s = bt(n, function(e) {
                        return e.eventTarget === t1;
                    });
                    s || (s = {
                        eventTarget: t1,
                        events: {}
                    }, n.push(s)), s.events[e] || (s.events[e] = []), bt(s.events[e], function(t1) {
                        return t1.func === r && Ne(t1.options, a);
                    }) || (t1.addEventListener(e, r, o.supportsOptions ? a : a.capture), s.events[e].push({
                        func: r,
                        options: a
                    }));
                }
            }
            function s(t1, e, r, i) {
                if (t1.addEventListener && t1.removeEventListener) {
                    var a = yt(n, function(e) {
                        return e.eventTarget === t1;
                    }), c = n[a];
                    if (c && c.events) {
                        if ("all" !== e) {
                            var l = !1, u = c.events[e];
                            if (u) {
                                if ("all" === r) {
                                    for(var p = u.length - 1; p >= 0; p--){
                                        var f = u[p];
                                        s(t1, e, f.func, f.options);
                                    }
                                    return;
                                }
                                for(var d = Ge(i), h = 0; h < u.length; h++){
                                    var v = u[h];
                                    if (v.func === r && Ne(v.options, d)) {
                                        t1.removeEventListener(e, r, o.supportsOptions ? d : d.capture), u.splice(h, 1), 0 === u.length && (delete c.events[e], l = !0);
                                        break;
                                    }
                                }
                            }
                            l && !Object.keys(c.events).length && n.splice(a, 1);
                        } else for(e in c.events)c.events.hasOwnProperty(e) && s(t1, e, "all");
                    }
                }
            }
            function c(t1, e) {
                for(var n = Ge(e), i = new We(t1), o = r[t1.type], a = ht(t1)[0], s = a; w.element(s);){
                    for(var c = 0; c < o.length; c++){
                        var l = o[c], u = l.selector, p = l.context;
                        if (R(s, u) && M(p, a) && M(p, s)) {
                            var f = l.listeners;
                            i.currentTarget = s;
                            for(var d = 0; d < f.length; d++){
                                var h = f[d];
                                Ne(h.options, n) && h.func(i);
                            }
                        }
                    }
                    s = A(s);
                }
            }
            function l(t1) {
                return c(t1, !0);
            }
            return null == (e = t1.document) || e.createElement("div").addEventListener("test", null, {
                get capture () {
                    return o.supportsOptions = !0;
                },
                get passive () {
                    return o.supportsPassive = !0;
                }
            }), t1.events = o, o;
        }
    }, He = {
        methodOrder: [
            "simulationResume",
            "mouseOrPen",
            "hasPointer",
            "idle"
        ],
        search: function(t1) {
            for(var e = 0, n = He.methodOrder; e < n.length; e++){
                var r = n[e], i = He[r](t1);
                if (i) return i;
            }
            return null;
        },
        simulationResume: function(t1) {
            var e = t1.pointerType, n = t1.eventType, r = t1.eventTarget, i = t1.scope;
            if (!/down|start/i.test(n)) return null;
            for(var o = 0, a = i.interactions.list; o < a.length; o++){
                var s = a[o], c = r;
                if (s.simulation && s.simulation.allowResume && s.pointerType === e) for(; c;){
                    if (c === s.element) return s;
                    c = A(c);
                }
            }
            return null;
        },
        mouseOrPen: function(t1) {
            var e, n = t1.pointerId, r = t1.pointerType, i = t1.eventType, o = t1.scope;
            if ("mouse" !== r && "pen" !== r) return null;
            for(var a = 0, s = o.interactions.list; a < s.length; a++){
                var c = s[a];
                if (c.pointerType === r) {
                    if (c.simulation && !Ke(c, n)) continue;
                    if (c.interacting()) return c;
                    e || (e = c);
                }
            }
            if (e) return e;
            for(var l = 0, u = o.interactions.list; l < u.length; l++){
                var p = u[l];
                if (!(p.pointerType !== r || /down/i.test(i) && p.simulation)) return p;
            }
            return null;
        },
        hasPointer: function(t1) {
            for(var e = t1.pointerId, n = 0, r = t1.scope.interactions.list; n < r.length; n++){
                var i = r[n];
                if (Ke(i, e)) return i;
            }
            return null;
        },
        idle: function(t1) {
            for(var e = t1.pointerType, n = 0, r = t1.scope.interactions.list; n < r.length; n++){
                var i = r[n];
                if (1 === i.pointers.length) {
                    var o = i.interactable;
                    if (o && (!o.options.gesture || !o.options.gesture.enabled)) continue;
                } else if (i.pointers.length >= 2) continue;
                if (!i.interacting() && e === i.pointerType) return i;
            }
            return null;
        }
    };
    function Ke(t1, e) {
        return t1.pointers.some(function(t1) {
            return t1.id === e;
        });
    }
    var $e = He, Je = [
        "pointerDown",
        "pointerMove",
        "pointerUp",
        "updatePointer",
        "removePointer",
        "windowBlur"
    ];
    function Qe(t1, e) {
        return function(n) {
            var r = e.interactions.list, i = dt(n), o = ht(n), a = o[0], s = o[1], c = [];
            if (/^touch/.test(n.type)) {
                e.prevTouchTime = e.now();
                for(var l = 0, u = n.changedTouches; l < u.length; l++){
                    var p = u[l], f = {
                        pointer: p,
                        pointerId: at(p),
                        pointerType: i,
                        eventType: n.type,
                        eventTarget: a,
                        curEventTarget: s,
                        scope: e
                    }, d = Ze(f);
                    c.push([
                        f.pointer,
                        f.eventTarget,
                        f.curEventTarget,
                        d
                    ]);
                }
            } else {
                var h = !1;
                if (!I.supportsPointerEvent && /mouse/.test(n.type)) {
                    for(var v = 0; v < r.length && !h; v++)h = "mouse" !== r[v].pointerType && r[v].pointerIsDown;
                    h = h || e.now() - e.prevTouchTime < 500 || 0 === n.timeStamp;
                }
                if (!h) {
                    var g = {
                        pointer: n,
                        pointerId: at(n),
                        pointerType: i,
                        eventType: n.type,
                        curEventTarget: s,
                        eventTarget: a,
                        scope: e
                    }, m = Ze(g);
                    c.push([
                        g.pointer,
                        g.eventTarget,
                        g.curEventTarget,
                        m
                    ]);
                }
            }
            for(var y = 0; y < c.length; y++){
                var b = c[y], x = b[0], w = b[1], E = b[2];
                b[3][t1](x, n, w, E);
            }
        };
    }
    function Ze(t1) {
        var e = t1.pointerType, n = t1.scope, r = {
            interaction: $e.search(t1),
            searchDetails: t1
        };
        return n.fire("interactions:find", r), r.interaction || n.interactions.new({
            pointerType: e
        });
    }
    function tn(t1, e) {
        var n = t1.doc, r = t1.scope, i = t1.options, o = r.interactions.docEvents, a = r.events, s = a[e];
        for(var c in r.browser.isIOS && !i.events && (i.events = {
            passive: !1
        }), a.delegatedEvents)s(n, c, a.delegateListener), s(n, c, a.delegateUseCapture, !0);
        for(var l = i && i.events, u = 0; u < o.length; u++){
            var p = o[u];
            s(n, p.type, p.listener, l);
        }
    }
    var en = {
        id: "core/interactions",
        install: function(t1) {
            for(var e = {}, n = 0; n < Je.length; n++){
                var i = Je[n];
                e[i] = Qe(i, t1);
            }
            var a, c = I.pEventTypes;
            function l() {
                for(var e = 0, n = t1.interactions.list; e < n.length; e++){
                    var r = n[e];
                    if (r.pointerIsDown && "touch" === r.pointerType && !r._interacting) for(var i = function() {
                        var e = a[o];
                        t1.documents.some(function(t1) {
                            return M(t1.doc, e.downTarget);
                        }) || r.removePointer(e.pointer, e.event);
                    }, o = 0, a = r.pointers; o < a.length; o++)i();
                }
            }
            (a = k.PointerEvent ? [
                {
                    type: c.down,
                    listener: l
                },
                {
                    type: c.down,
                    listener: e.pointerDown
                },
                {
                    type: c.move,
                    listener: e.pointerMove
                },
                {
                    type: c.up,
                    listener: e.pointerUp
                },
                {
                    type: c.cancel,
                    listener: e.pointerUp
                }
            ] : [
                {
                    type: "mousedown",
                    listener: e.pointerDown
                },
                {
                    type: "mousemove",
                    listener: e.pointerMove
                },
                {
                    type: "mouseup",
                    listener: e.pointerUp
                },
                {
                    type: "touchstart",
                    listener: l
                },
                {
                    type: "touchstart",
                    listener: e.pointerDown
                },
                {
                    type: "touchmove",
                    listener: e.pointerMove
                },
                {
                    type: "touchend",
                    listener: e.pointerUp
                },
                {
                    type: "touchcancel",
                    listener: e.pointerUp
                }
            ]).push({
                type: "blur",
                listener: function(e) {
                    for(var n = 0, r = t1.interactions.list; n < r.length; n++)r[n].documentBlur(e);
                }
            }), t1.prevTouchTime = 0, t1.Interaction = function(e) {
                s(i, e);
                var n = p(i);
                function i() {
                    return r(this, i), n.apply(this, arguments);
                }
                return o(i, [
                    {
                        key: "pointerMoveTolerance",
                        get: function() {
                            return t1.interactions.pointerMoveTolerance;
                        },
                        set: function(e) {
                            t1.interactions.pointerMoveTolerance = e;
                        }
                    },
                    {
                        key: "_now",
                        value: function() {
                            return t1.now();
                        }
                    }
                ]), i;
            }(De), t1.interactions = {
                list: [],
                new: function(e) {
                    e.scopeFire = function(e, n) {
                        return t1.fire(e, n);
                    };
                    var n = new t1.Interaction(e);
                    return t1.interactions.list.push(n), n;
                },
                listeners: e,
                docEvents: a,
                pointerMoveTolerance: 1
            }, t1.usePlugin(he);
        },
        listeners: {
            "scope:add-document": function(t1) {
                return tn(t1, "add");
            },
            "scope:remove-document": function(t1) {
                return tn(t1, "remove");
            },
            "interactable:unset": function(t1, e) {
                for(var n = t1.interactable, r = e.interactions.list.length - 1; r >= 0; r--){
                    var i = e.interactions.list[r];
                    i.interactable === n && (i.stop(), e.fire("interactions:destroy", {
                        interaction: i
                    }), i.destroy(), e.interactions.list.length > 2 && e.interactions.list.splice(r, 1));
                }
            }
        },
        onDocSignal: tn,
        doOnInteractions: Qe,
        methodNames: Je
    }, nn = en, rn = function(t1) {
        return t1[t1.On = 0] = "On", t1[t1.Off = 1] = "Off", t1;
    }(rn || {}), on = function() {
        function t1(e, n, i, o) {
            r(this, t1), this.target = void 0, this.options = void 0, this._actions = void 0, this.events = new Ve, this._context = void 0, this._win = void 0, this._doc = void 0, this._scopeEvents = void 0, this._actions = n.actions, this.target = e, this._context = n.context || i, this._win = y(B(e) ? this._context : e), this._doc = this._win.document, this._scopeEvents = o, this.set(n);
        }
        return o(t1, [
            {
                key: "_defaults",
                get: function() {
                    return {
                        base: {},
                        perAction: {},
                        actions: {}
                    };
                }
            },
            {
                key: "setOnEvents",
                value: function(t1, e) {
                    return w.func(e.onstart) && this.on("".concat(t1, "start"), e.onstart), w.func(e.onmove) && this.on("".concat(t1, "move"), e.onmove), w.func(e.onend) && this.on("".concat(t1, "end"), e.onend), w.func(e.oninertiastart) && this.on("".concat(t1, "inertiastart"), e.oninertiastart), this;
                }
            },
            {
                key: "updatePerActionListeners",
                value: function(t1, e, n) {
                    var r, i = this, o = null == (r = this._actions.map[t1]) ? void 0 : r.filterEventType, a = function(t1) {
                        return (null == o || o(t1)) && ve(t1, i._actions);
                    };
                    (w.array(e) || w.object(e)) && this._onOff(rn.Off, t1, e, void 0, a), (w.array(n) || w.object(n)) && this._onOff(rn.On, t1, n, void 0, a);
                }
            },
            {
                key: "setPerAction",
                value: function(t1, e) {
                    var n = this._defaults;
                    for(var r in e){
                        var i = r, o = this.options[t1], a = e[i];
                        "listeners" === i && this.updatePerActionListeners(t1, o.listeners, a), w.array(a) ? o[i] = mt(a) : w.plainObject(a) ? (o[i] = V(o[i] || {}, ge(a)), w.object(n.perAction[i]) && "enabled" in n.perAction[i] && (o[i].enabled = !1 !== a.enabled)) : w.bool(a) && w.object(n.perAction[i]) ? o[i].enabled = a : o[i] = a;
                    }
                }
            },
            {
                key: "getRect",
                value: function(t1) {
                    return t1 = t1 || (w.element(this.target) ? this.target : null), w.string(this.target) && (t1 = t1 || this._context.querySelector(this.target)), L(t1);
                }
            },
            {
                key: "rectChecker",
                value: function(t1) {
                    var e = this;
                    return w.func(t1) ? (this.getRect = function(n) {
                        var r = V({}, t1.apply(e, n));
                        return "width" in r || (r.width = r.right - r.left, r.height = r.bottom - r.top), r;
                    }, this) : null === t1 ? (delete this.getRect, this) : this.getRect;
                }
            },
            {
                key: "_backCompatOption",
                value: function(t1, e) {
                    if (B(e) || w.object(e)) {
                        for(var n in this.options[t1] = e, this._actions.map)this.options[n][t1] = e;
                        return this;
                    }
                    return this.options[t1];
                }
            },
            {
                key: "origin",
                value: function(t1) {
                    return this._backCompatOption("origin", t1);
                }
            },
            {
                key: "deltaSource",
                value: function(t1) {
                    return "page" === t1 || "client" === t1 ? (this.options.deltaSource = t1, this) : this.options.deltaSource;
                }
            },
            {
                key: "getAllElements",
                value: function() {
                    var t1 = this.target;
                    return w.string(t1) ? Array.from(this._context.querySelectorAll(t1)) : w.func(t1) && t1.getAllElements ? t1.getAllElements() : w.element(t1) ? [
                        t1
                    ] : [];
                }
            },
            {
                key: "context",
                value: function() {
                    return this._context;
                }
            },
            {
                key: "inContext",
                value: function(t1) {
                    return this._context === t1.ownerDocument || M(this._context, t1);
                }
            },
            {
                key: "testIgnoreAllow",
                value: function(t1, e, n) {
                    return !this.testIgnore(t1.ignoreFrom, e, n) && this.testAllow(t1.allowFrom, e, n);
                }
            },
            {
                key: "testAllow",
                value: function(t1, e, n) {
                    return !t1 || !!w.element(n) && (w.string(t1) ? F(n, t1, e) : !!w.element(t1) && M(t1, n));
                }
            },
            {
                key: "testIgnore",
                value: function(t1, e, n) {
                    return !(!t1 || !w.element(n)) && (w.string(t1) ? F(n, t1, e) : !!w.element(t1) && M(t1, n));
                }
            },
            {
                key: "fire",
                value: function(t1) {
                    return this.events.fire(t1), this;
                }
            },
            {
                key: "_onOff",
                value: function(t1, e, n, r, i) {
                    w.object(e) && !w.array(e) && (r = n, n = null);
                    var o = $(e, n, i);
                    for(var a in o){
                        "wheel" === a && (a = I.wheelEvent);
                        for(var s = 0, c = o[a]; s < c.length; s++){
                            var l = c[s];
                            ve(a, this._actions) ? this.events[t1 === rn.On ? "on" : "off"](a, l) : w.string(this.target) ? this._scopeEvents[t1 === rn.On ? "addDelegate" : "removeDelegate"](this.target, this._context, a, l, r) : this._scopeEvents[t1 === rn.On ? "add" : "remove"](this.target, a, l, r);
                        }
                    }
                    return this;
                }
            },
            {
                key: "on",
                value: function(t1, e, n) {
                    return this._onOff(rn.On, t1, e, n);
                }
            },
            {
                key: "off",
                value: function(t1, e, n) {
                    return this._onOff(rn.Off, t1, e, n);
                }
            },
            {
                key: "set",
                value: function(t1) {
                    var e = this._defaults;
                    for(var n in w.object(t1) || (t1 = {}), this.options = ge(e.base), this._actions.methodDict){
                        var r = n, i = this._actions.methodDict[r];
                        this.options[r] = {}, this.setPerAction(r, V(V({}, e.perAction), e.actions[r])), this[i](t1[r]);
                    }
                    for(var o in t1)"getRect" !== o ? w.func(this[o]) && this[o](t1[o]) : this.rectChecker(t1.getRect);
                    return this;
                }
            },
            {
                key: "unset",
                value: function() {
                    if (w.string(this.target)) for(var t1 in this._scopeEvents.delegatedEvents)for(var e = this._scopeEvents.delegatedEvents[t1], n = e.length - 1; n >= 0; n--){
                        var r = e[n], i = r.selector, o = r.context, a = r.listeners;
                        i === this.target && o === this._context && e.splice(n, 1);
                        for(var s = a.length - 1; s >= 0; s--)this._scopeEvents.removeDelegate(this.target, this._context, t1, a[s][0], a[s][1]);
                    }
                    else this._scopeEvents.remove(this.target, "all");
                }
            }
        ]), t1;
    }(), an = function() {
        function t1(e) {
            var n = this;
            r(this, t1), this.list = [], this.selectorMap = {}, this.scope = void 0, this.scope = e, e.addListeners({
                "interactable:unset": function(t1) {
                    var e = t1.interactable, r = e.target, i = w.string(r) ? n.selectorMap[r] : r[n.scope.id], o = yt(i, function(t1) {
                        return t1 === e;
                    });
                    i.splice(o, 1);
                }
            });
        }
        return o(t1, [
            {
                key: "new",
                value: function(t1, e) {
                    e = V(e || {}, {
                        actions: this.scope.actions
                    });
                    var n = new this.scope.Interactable(t1, e, this.scope.document, this.scope.events);
                    return this.scope.addDocument(n._doc), this.list.push(n), w.string(t1) ? (this.selectorMap[t1] || (this.selectorMap[t1] = []), this.selectorMap[t1].push(n)) : (n.target[this.scope.id] || Object.defineProperty(t1, this.scope.id, {
                        value: [],
                        configurable: !0
                    }), t1[this.scope.id].push(n)), this.scope.fire("interactable:new", {
                        target: t1,
                        options: e,
                        interactable: n,
                        win: this.scope._win
                    }), n;
                }
            },
            {
                key: "getExisting",
                value: function(t1, e) {
                    var n = e && e.context || this.scope.document, r = w.string(t1), i = r ? this.selectorMap[t1] : t1[this.scope.id];
                    if (i) return bt(i, function(e) {
                        return e._context === n && (r || e.inContext(t1));
                    });
                }
            },
            {
                key: "forEachMatch",
                value: function(t1, e) {
                    for(var n = 0, r = this.list; n < r.length; n++){
                        var i = r[n], o = void 0;
                        if ((w.string(i.target) ? w.element(t1) && R(t1, i.target) : t1 === i.target) && i.inContext(t1) && (o = e(i)), void 0 !== o) return o;
                    }
                }
            }
        ]), t1;
    }();
    var sn = function() {
        function t1() {
            var e = this;
            r(this, t1), this.id = "__interact_scope_".concat(Math.floor(100 * Math.random())), this.isInitialized = !1, this.listenerMaps = [], this.browser = I, this.defaults = ge(Te), this.Eventable = Ve, this.actions = {
                map: {},
                phases: {
                    start: !0,
                    move: !0,
                    end: !0
                },
                methodDict: {},
                phaselessTypes: {}
            }, this.interactStatic = function(t1) {
                var e = function e(n, r) {
                    var i = t1.interactables.getExisting(n, r);
                    return i || ((i = t1.interactables.new(n, r)).events.global = e.globalEvents), i;
                };
                return e.getPointerAverage = lt, e.getTouchBBox = ut, e.getTouchDistance = pt, e.getTouchAngle = ft, e.getElementRect = L, e.getElementClientRect = Y, e.matchesSelector = R, e.closest = z, e.globalEvents = {}, e.version = "1.10.27", e.scope = t1, e.use = function(t1, e) {
                    return this.scope.usePlugin(t1, e), this;
                }, e.isSet = function(t1, e) {
                    return !!this.scope.interactables.get(t1, e && e.context);
                }, e.on = Nt(function(t1, e, n) {
                    if (w.string(t1) && -1 !== t1.search(" ") && (t1 = t1.trim().split(/ +/)), w.array(t1)) {
                        for(var r = 0, i = t1; r < i.length; r++){
                            var o = i[r];
                            this.on(o, e, n);
                        }
                        return this;
                    }
                    if (w.object(t1)) {
                        for(var a in t1)this.on(a, t1[a], e);
                        return this;
                    }
                    return ve(t1, this.scope.actions) ? this.globalEvents[t1] ? this.globalEvents[t1].push(e) : this.globalEvents[t1] = [
                        e
                    ] : this.scope.events.add(this.scope.document, t1, e, {
                        options: n
                    }), this;
                }, "The interact.on() method is being deprecated"), e.off = Nt(function(t1, e, n) {
                    if (w.string(t1) && -1 !== t1.search(" ") && (t1 = t1.trim().split(/ +/)), w.array(t1)) {
                        for(var r = 0, i = t1; r < i.length; r++){
                            var o = i[r];
                            this.off(o, e, n);
                        }
                        return this;
                    }
                    if (w.object(t1)) {
                        for(var a in t1)this.off(a, t1[a], e);
                        return this;
                    }
                    var s;
                    return ve(t1, this.scope.actions) ? t1 in this.globalEvents && -1 !== (s = this.globalEvents[t1].indexOf(e)) && this.globalEvents[t1].splice(s, 1) : this.scope.events.remove(this.scope.document, t1, e, n), this;
                }, "The interact.off() method is being deprecated"), e.debug = function() {
                    return this.scope;
                }, e.supportsTouch = function() {
                    return I.supportsTouch;
                }, e.supportsPointerEvent = function() {
                    return I.supportsPointerEvent;
                }, e.stop = function() {
                    for(var t1 = 0, e = this.scope.interactions.list; t1 < e.length; t1++)e[t1].stop();
                    return this;
                }, e.pointerMoveTolerance = function(t1) {
                    return w.number(t1) ? (this.scope.interactions.pointerMoveTolerance = t1, this) : this.scope.interactions.pointerMoveTolerance;
                }, e.addDocument = function(t1, e) {
                    this.scope.addDocument(t1, e);
                }, e.removeDocument = function(t1) {
                    this.scope.removeDocument(t1);
                }, e;
            }(this), this.InteractEvent = Se, this.Interactable = void 0, this.interactables = new an(this), this._win = void 0, this.document = void 0, this.window = void 0, this.documents = [], this._plugins = {
                list: [],
                map: {}
            }, this.onWindowUnload = function(t1) {
                return e.removeDocument(t1.target);
            };
            var n = this;
            this.Interactable = function(t1) {
                s(i, t1);
                var e = p(i);
                function i() {
                    return r(this, i), e.apply(this, arguments);
                }
                return o(i, [
                    {
                        key: "_defaults",
                        get: function() {
                            return n.defaults;
                        }
                    },
                    {
                        key: "set",
                        value: function(t1) {
                            return f(c(i.prototype), "set", this).call(this, t1), n.fire("interactable:set", {
                                options: t1,
                                interactable: this
                            }), this;
                        }
                    },
                    {
                        key: "unset",
                        value: function() {
                            f(c(i.prototype), "unset", this).call(this);
                            var t1 = n.interactables.list.indexOf(this);
                            t1 < 0 || (n.interactables.list.splice(t1, 1), n.fire("interactable:unset", {
                                interactable: this
                            }));
                        }
                    }
                ]), i;
            }(on);
        }
        return o(t1, [
            {
                key: "addListeners",
                value: function(t1, e) {
                    this.listenerMaps.push({
                        id: e,
                        map: t1
                    });
                }
            },
            {
                key: "fire",
                value: function(t1, e) {
                    for(var n = 0, r = this.listenerMaps; n < r.length; n++){
                        var i = r[n].map[t1];
                        if (i && !1 === i(e, this, t1)) return !1;
                    }
                }
            },
            {
                key: "init",
                value: function(t1) {
                    return this.isInitialized ? this : function(t1, e) {
                        t1.isInitialized = !0, w.window(e) && m(e);
                        return k.init(e), I.init(e), Lt.init(e), t1.window = e, t1.document = e.document, t1.usePlugin(nn), t1.usePlugin(Ue), t1;
                    }(this, t1);
                }
            },
            {
                key: "pluginIsInstalled",
                value: function(t1) {
                    var e = t1.id;
                    return e ? !!this._plugins.map[e] : -1 !== this._plugins.list.indexOf(t1);
                }
            },
            {
                key: "usePlugin",
                value: function(t1, e) {
                    if (!this.isInitialized) return this;
                    if (this.pluginIsInstalled(t1)) return this;
                    if (t1.id && (this._plugins.map[t1.id] = t1), this._plugins.list.push(t1), t1.install && t1.install(this, e), t1.listeners && t1.before) {
                        for(var n = 0, r = this.listenerMaps.length, i = t1.before.reduce(function(t1, e) {
                            return t1[e] = !0, t1[cn(e)] = !0, t1;
                        }, {}); n < r; n++){
                            var o = this.listenerMaps[n].id;
                            if (o && (i[o] || i[cn(o)])) break;
                        }
                        this.listenerMaps.splice(n, 0, {
                            id: t1.id,
                            map: t1.listeners
                        });
                    } else t1.listeners && this.listenerMaps.push({
                        id: t1.id,
                        map: t1.listeners
                    });
                    return this;
                }
            },
            {
                key: "addDocument",
                value: function(t1, e) {
                    if (-1 !== this.getDocIndex(t1)) return !1;
                    var n = y(t1);
                    e = e ? V({}, e) : {}, this.documents.push({
                        doc: t1,
                        options: e
                    }), this.events.documents.push(t1), t1 !== this.document && this.events.add(n, "unload", this.onWindowUnload), this.fire("scope:add-document", {
                        doc: t1,
                        window: n,
                        scope: this,
                        options: e
                    });
                }
            },
            {
                key: "removeDocument",
                value: function(t1) {
                    var e = this.getDocIndex(t1), n = y(t1), r = this.documents[e].options;
                    this.events.remove(n, "unload", this.onWindowUnload), this.documents.splice(e, 1), this.events.documents.splice(e, 1), this.fire("scope:remove-document", {
                        doc: t1,
                        window: n,
                        scope: this,
                        options: r
                    });
                }
            },
            {
                key: "getDocIndex",
                value: function(t1) {
                    for(var e = 0; e < this.documents.length; e++)if (this.documents[e].doc === t1) return e;
                    return -1;
                }
            },
            {
                key: "getDocOptions",
                value: function(t1) {
                    var e = this.getDocIndex(t1);
                    return -1 === e ? null : this.documents[e].options;
                }
            },
            {
                key: "now",
                value: function() {
                    return (this.window.Date || Date).now();
                }
            }
        ]), t1;
    }();
    function cn(t1) {
        return t1 && t1.replace(/\/.*$/, "");
    }
    var ln = new sn, un = ln.interactStatic, pn = "undefined" != typeof globalThis ? globalThis : window;
    ln.init(pn);
    var fn = Object.freeze({
        __proto__: null,
        edgeTarget: function() {},
        elements: function() {},
        grid: function(t1) {
            var e = [
                [
                    "x",
                    "y"
                ],
                [
                    "left",
                    "top"
                ],
                [
                    "right",
                    "bottom"
                ],
                [
                    "width",
                    "height"
                ]
            ].filter(function(e) {
                var n = e[0], r = e[1];
                return n in t1 || r in t1;
            }), n = function(n, r) {
                for(var i = t1.range, o = t1.limits, a = void 0 === o ? {
                    left: -1 / 0,
                    right: 1 / 0,
                    top: -1 / 0,
                    bottom: 1 / 0
                } : o, s = t1.offset, c = void 0 === s ? {
                    x: 0,
                    y: 0
                } : s, l = {
                    range: i,
                    grid: t1,
                    x: null,
                    y: null
                }, u = 0; u < e.length; u++){
                    var p = e[u], f = p[0], d = p[1], h = Math.round((n - c.x) / t1[f]), v = Math.round((r - c.y) / t1[d]);
                    l[f] = Math.max(a.left, Math.min(a.right, h * t1[f] + c.x)), l[d] = Math.max(a.top, Math.min(a.bottom, v * t1[d] + c.y));
                }
                return l;
            };
            return n.grid = t1, n.coordFields = e, n;
        }
    }), dn = {
        id: "snappers",
        install: function(t1) {
            var e = t1.interactStatic;
            e.snappers = V(e.snappers || {}, fn), e.createSnapGrid = e.snappers.grid;
        }
    }, hn = dn, vn = {
        start: function(t1) {
            var n = t1.state, r = t1.rect, i = t1.edges, o = t1.pageCoords, a = n.options, s = a.ratio, c = a.enabled, l = n.options, u = l.equalDelta, p = l.modifiers;
            "preserve" === s && (s = r.width / r.height), n.startCoords = V({}, o), n.startRect = V({}, r), n.ratio = s, n.equalDelta = u;
            var f = n.linkedEdges = {
                top: i.top || i.left && !i.bottom,
                left: i.left || i.top && !i.right,
                bottom: i.bottom || i.right && !i.top,
                right: i.right || i.bottom && !i.left
            };
            if (n.xIsPrimaryAxis = !(!i.left && !i.right), n.equalDelta) {
                var d = (f.left ? 1 : -1) * (f.top ? 1 : -1);
                n.edgeSign = {
                    x: d,
                    y: d
                };
            } else n.edgeSign = {
                x: f.left ? -1 : 1,
                y: f.top ? -1 : 1
            };
            if (!1 !== c && V(i, f), null != p && p.length) {
                var h = new me(t1.interaction);
                h.copyFrom(t1.interaction.modification), h.prepareStates(p), n.subModification = h, h.startAll(e({}, t1));
            }
        },
        set: function(t1) {
            var n = t1.state, r = t1.rect, i = t1.coords, o = n.linkedEdges, a = V({}, i), s = n.equalDelta ? gn : mn;
            if (V(t1.edges, o), s(n, n.xIsPrimaryAxis, i, r), !n.subModification) return null;
            var c = V({}, r);
            H(o, c, {
                x: i.x - a.x,
                y: i.y - a.y
            });
            var l = n.subModification.setAll(e(e({}, t1), {}, {
                rect: c,
                edges: o,
                pageCoords: i,
                prevCoords: i,
                prevRect: c
            })), u = l.delta;
            l.changed && (s(n, Math.abs(u.x) > Math.abs(u.y), l.coords, l.rect), V(i, l.coords));
            return l.eventProps;
        },
        defaults: {
            ratio: "preserve",
            equalDelta: !1,
            modifiers: [],
            enabled: !1
        }
    };
    function gn(t1, e, n) {
        var r = t1.startCoords, i = t1.edgeSign;
        e ? n.y = r.y + (n.x - r.x) * i.y : n.x = r.x + (n.y - r.y) * i.x;
    }
    function mn(t1, e, n, r) {
        var i = t1.startRect, o = t1.startCoords, a = t1.ratio, s = t1.edgeSign;
        if (e) {
            var c = r.width / a;
            n.y = o.y + (c - i.height) * s.y;
        } else {
            var l = r.height * a;
            n.x = o.x + (l - i.width) * s.x;
        }
    }
    var yn = be(vn, "aspectRatio"), bn = function() {};
    bn._defaults = {};
    var xn = bn;
    function wn(t1, e, n) {
        return w.func(t1) ? G(t1, e.interactable, e.element, [
            n.x,
            n.y,
            e
        ]) : G(t1, e.interactable, e.element);
    }
    var En = {
        start: function(t1) {
            var e = t1.rect, n = t1.startOffset, r = t1.state, i = t1.interaction, o = t1.pageCoords, a = r.options, s = a.elementRect, c = V({
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            }, a.offset || {});
            if (e && s) {
                var l = wn(a.restriction, i, o);
                if (l) {
                    var u = l.right - l.left - e.width, p = l.bottom - l.top - e.height;
                    u < 0 && (c.left += u, c.right += u), p < 0 && (c.top += p, c.bottom += p);
                }
                c.left += n.left - e.width * s.left, c.top += n.top - e.height * s.top, c.right += n.right - e.width * (1 - s.right), c.bottom += n.bottom - e.height * (1 - s.bottom);
            }
            r.offset = c;
        },
        set: function(t1) {
            var e = t1.coords, n = t1.interaction, r = t1.state, i = r.options, o = r.offset, a = wn(i.restriction, n, e);
            if (a) {
                var s = function(t1) {
                    return !t1 || "left" in t1 && "top" in t1 || ((t1 = V({}, t1)).left = t1.x || 0, t1.top = t1.y || 0, t1.right = t1.right || t1.left + t1.width, t1.bottom = t1.bottom || t1.top + t1.height), t1;
                }(a);
                e.x = Math.max(Math.min(s.right - o.right, e.x), s.left + o.left), e.y = Math.max(Math.min(s.bottom - o.bottom, e.y), s.top + o.top);
            }
        },
        defaults: {
            restriction: null,
            elementRect: null,
            offset: null,
            endOnly: !1,
            enabled: !1
        }
    }, Tn = be(En, "restrict"), Sn = {
        top: 1 / 0,
        left: 1 / 0,
        bottom: -1 / 0,
        right: -1 / 0
    }, _n = {
        top: -1 / 0,
        left: -1 / 0,
        bottom: 1 / 0,
        right: 1 / 0
    };
    function Pn(t1, e) {
        for(var n = 0, r = [
            "top",
            "left",
            "bottom",
            "right"
        ]; n < r.length; n++){
            var i = r[n];
            i in t1 || (t1[i] = e[i]);
        }
        return t1;
    }
    var On = {
        noInner: Sn,
        noOuter: _n,
        start: function(t1) {
            var e, n = t1.interaction, r = t1.startOffset, i = t1.state, o = i.options;
            o && (e = N(wn(o.offset, n, n.coords.start.page))), e = e || {
                x: 0,
                y: 0
            }, i.offset = {
                top: e.y + r.top,
                left: e.x + r.left,
                bottom: e.y - r.bottom,
                right: e.x - r.right
            };
        },
        set: function(t1) {
            var e = t1.coords, n = t1.edges, r = t1.interaction, i = t1.state, o = i.offset, a = i.options;
            if (n) {
                var s = V({}, e), c = wn(a.inner, r, s) || {}, l = wn(a.outer, r, s) || {};
                Pn(c, Sn), Pn(l, _n), n.top ? e.y = Math.min(Math.max(l.top + o.top, s.y), c.top + o.top) : n.bottom && (e.y = Math.max(Math.min(l.bottom + o.bottom, s.y), c.bottom + o.bottom)), n.left ? e.x = Math.min(Math.max(l.left + o.left, s.x), c.left + o.left) : n.right && (e.x = Math.max(Math.min(l.right + o.right, s.x), c.right + o.right));
            }
        },
        defaults: {
            inner: null,
            outer: null,
            offset: null,
            endOnly: !1,
            enabled: !1
        }
    }, kn = be(On, "restrictEdges"), Dn = V({
        get elementRect () {
            return {
                top: 0,
                left: 0,
                bottom: 1,
                right: 1
            };
        },
        set elementRect (t){}
    }, En.defaults), In = be({
        start: En.start,
        set: En.set,
        defaults: Dn
    }, "restrictRect"), Mn = {
        width: -1 / 0,
        height: -1 / 0
    }, zn = {
        width: 1 / 0,
        height: 1 / 0
    };
    var An = be({
        start: function(t1) {
            return On.start(t1);
        },
        set: function(t1) {
            var e = t1.interaction, n = t1.state, r = t1.rect, i = t1.edges, o = n.options;
            if (i) {
                var a = U(wn(o.min, e, t1.coords)) || Mn, s = U(wn(o.max, e, t1.coords)) || zn;
                n.options = {
                    endOnly: o.endOnly,
                    inner: V({}, On.noInner),
                    outer: V({}, On.noOuter)
                }, i.top ? (n.options.inner.top = r.bottom - a.height, n.options.outer.top = r.bottom - s.height) : i.bottom && (n.options.inner.bottom = r.top + a.height, n.options.outer.bottom = r.top + s.height), i.left ? (n.options.inner.left = r.right - a.width, n.options.outer.left = r.right - s.width) : i.right && (n.options.inner.right = r.left + a.width, n.options.outer.right = r.left + s.width), On.set(t1), n.options = o;
            }
        },
        defaults: {
            min: null,
            max: null,
            endOnly: !1,
            enabled: !1
        }
    }, "restrictSize");
    var Rn = {
        start: function(t1) {
            var e, n = t1.interaction, r = t1.interactable, i = t1.element, o = t1.rect, a = t1.state, s = t1.startOffset, c = a.options, l = c.offsetWithOrigin ? function(t1) {
                var e = t1.interaction.element, n = N(G(t1.state.options.origin, null, null, [
                    e
                ])), r = n || K(t1.interactable, e, t1.interaction.prepared.name);
                return r;
            }(t1) : {
                x: 0,
                y: 0
            };
            if ("startCoords" === c.offset) e = {
                x: n.coords.start.page.x,
                y: n.coords.start.page.y
            };
            else {
                var u = G(c.offset, r, i, [
                    n
                ]);
                (e = N(u) || {
                    x: 0,
                    y: 0
                }).x += l.x, e.y += l.y;
            }
            var p = c.relativePoints;
            a.offsets = o && p && p.length ? p.map(function(t1, n) {
                return {
                    index: n,
                    relativePoint: t1,
                    x: s.left - o.width * t1.x + e.x,
                    y: s.top - o.height * t1.y + e.y
                };
            }) : [
                {
                    index: 0,
                    relativePoint: null,
                    x: e.x,
                    y: e.y
                }
            ];
        },
        set: function(t1) {
            var e = t1.interaction, n = t1.coords, r = t1.state, i = r.options, o = r.offsets, a = K(e.interactable, e.element, e.prepared.name), s = V({}, n), c = [];
            i.offsetWithOrigin || (s.x -= a.x, s.y -= a.y);
            for(var l = 0, u = o; l < u.length; l++)for(var p = u[l], f = s.x - p.x, d = s.y - p.y, h = 0, v = i.targets.length; h < v; h++){
                var g = i.targets[h], m = void 0;
                (m = w.func(g) ? g(f, d, e._proxy, p, h) : g) && c.push({
                    x: (w.number(m.x) ? m.x : f) + p.x,
                    y: (w.number(m.y) ? m.y : d) + p.y,
                    range: w.number(m.range) ? m.range : i.range,
                    source: g,
                    index: h,
                    offset: p
                });
            }
            for(var y = {
                target: null,
                inRange: !1,
                distance: 0,
                range: 0,
                delta: {
                    x: 0,
                    y: 0
                }
            }, b = 0; b < c.length; b++){
                var x = c[b], E = x.range, T = x.x - s.x, S = x.y - s.y, _ = Q(T, S), P = _ <= E;
                E === 1 / 0 && y.inRange && y.range !== 1 / 0 && (P = !1), y.target && !(P ? y.inRange && E !== 1 / 0 ? _ / E < y.distance / y.range : E === 1 / 0 && y.range !== 1 / 0 || _ < y.distance : !y.inRange && _ < y.distance) || (y.target = x, y.distance = _, y.range = E, y.inRange = P, y.delta.x = T, y.delta.y = S);
            }
            return y.inRange && (n.x = y.target.x, n.y = y.target.y), r.closest = y, y;
        },
        defaults: {
            range: 1 / 0,
            targets: null,
            offset: null,
            offsetWithOrigin: !0,
            origin: null,
            relativePoints: null,
            endOnly: !1,
            enabled: !1
        }
    }, Cn = be(Rn, "snap");
    var jn = {
        start: function(t1) {
            var e = t1.state, n = t1.edges, r = e.options;
            if (!n) return null;
            t1.state = {
                options: {
                    targets: null,
                    relativePoints: [
                        {
                            x: n.left ? 0 : 1,
                            y: n.top ? 0 : 1
                        }
                    ],
                    offset: r.offset || "self",
                    origin: {
                        x: 0,
                        y: 0
                    },
                    range: r.range
                }
            }, e.targetFields = e.targetFields || [
                [
                    "width",
                    "height"
                ],
                [
                    "x",
                    "y"
                ]
            ], Rn.start(t1), e.offsets = t1.state.offsets, t1.state = e;
        },
        set: function(t1) {
            var e = t1.interaction, n = t1.state, r = t1.coords, i = n.options, o = n.offsets, a = {
                x: r.x - o[0].x,
                y: r.y - o[0].y
            };
            n.options = V({}, i), n.options.targets = [];
            for(var s = 0, c = i.targets || []; s < c.length; s++){
                var l = c[s], u = void 0;
                if (u = w.func(l) ? l(a.x, a.y, e) : l) {
                    for(var p = 0, f = n.targetFields; p < f.length; p++){
                        var d = f[p], h = d[0], v = d[1];
                        if (h in u || v in u) {
                            u.x = u[h], u.y = u[v];
                            break;
                        }
                    }
                    n.options.targets.push(u);
                }
            }
            var g = Rn.set(t1);
            return n.options = i, g;
        },
        defaults: {
            range: 1 / 0,
            targets: null,
            offset: null,
            endOnly: !1,
            enabled: !1
        }
    }, Fn = be(jn, "snapSize");
    var Xn = {
        aspectRatio: yn,
        restrictEdges: kn,
        restrict: Tn,
        restrictRect: In,
        restrictSize: An,
        snapEdges: be({
            start: function(t1) {
                var e = t1.edges;
                return e ? (t1.state.targetFields = t1.state.targetFields || [
                    [
                        e.left ? "left" : "right",
                        e.top ? "top" : "bottom"
                    ]
                ], jn.start(t1)) : null;
            },
            set: jn.set,
            defaults: V(ge(jn.defaults), {
                targets: void 0,
                range: void 0,
                offset: {
                    x: 0,
                    y: 0
                }
            })
        }, "snapEdges"),
        snap: Cn,
        snapSize: Fn,
        spring: xn,
        avoid: xn,
        transform: xn,
        rubberband: xn
    }, Yn = {
        id: "modifiers",
        install: function(t1) {
            var e = t1.interactStatic;
            for(var n in t1.usePlugin(Ee), t1.usePlugin(hn), e.modifiers = Xn, Xn){
                var r = Xn[n], i = r._defaults, o = r._methods;
                i._methods = o, t1.defaults.perAction[n] = i;
            }
        }
    }, Ln = Yn, qn = function(t1) {
        s(n, t1);
        var e = p(n);
        function n(t1, i, o, a, s, c) {
            var l;
            if (r(this, n), tt(u(l = e.call(this, s)), o), o !== i && tt(u(l), i), l.timeStamp = c, l.originalEvent = o, l.type = t1, l.pointerId = at(i), l.pointerType = dt(i), l.target = a, l.currentTarget = null, "tap" === t1) {
                var p = s.getPointerIndex(i);
                l.dt = l.timeStamp - s.pointers[p].downTime;
                var f = l.timeStamp - s.tapTime;
                l.double = !!s.prevTap && "doubletap" !== s.prevTap.type && s.prevTap.target === l.target && f < 500;
            } else "doubletap" === t1 && (l.dt = i.timeStamp - s.tapTime, l.double = !0);
            return l;
        }
        return o(n, [
            {
                key: "_subtractOrigin",
                value: function(t1) {
                    var e = t1.x, n = t1.y;
                    return this.pageX -= e, this.pageY -= n, this.clientX -= e, this.clientY -= n, this;
                }
            },
            {
                key: "_addOrigin",
                value: function(t1) {
                    var e = t1.x, n = t1.y;
                    return this.pageX += e, this.pageY += n, this.clientX += e, this.clientY += n, this;
                }
            },
            {
                key: "preventDefault",
                value: function() {
                    this.originalEvent.preventDefault();
                }
            }
        ]), n;
    }(vt), Bn = {
        id: "pointer-events/base",
        before: [
            "inertia",
            "modifiers",
            "auto-start",
            "actions"
        ],
        install: function(t1) {
            t1.pointerEvents = Bn, t1.defaults.actions.pointerEvents = Bn.defaults, V(t1.actions.phaselessTypes, Bn.types);
        },
        listeners: {
            "interactions:new": function(t1) {
                var e = t1.interaction;
                e.prevTap = null, e.tapTime = 0;
            },
            "interactions:update-pointer": function(t1) {
                var e = t1.down, n = t1.pointerInfo;
                if (!e && n.hold) return;
                n.hold = {
                    duration: 1 / 0,
                    timeout: null
                };
            },
            "interactions:move": function(t1, e) {
                var n = t1.interaction, r = t1.pointer, i = t1.event, o = t1.eventTarget;
                t1.duplicate || n.pointerIsDown && !n.pointerWasMoved || (n.pointerIsDown && Gn(t1), Vn({
                    interaction: n,
                    pointer: r,
                    event: i,
                    eventTarget: o,
                    type: "move"
                }, e));
            },
            "interactions:down": function(t1, e) {
                !function(t1, e) {
                    for(var n = t1.interaction, r = t1.pointer, i = t1.event, o = t1.eventTarget, a = t1.pointerIndex, s = n.pointers[a].hold, c = q(o), l = {
                        interaction: n,
                        pointer: r,
                        event: i,
                        eventTarget: o,
                        type: "hold",
                        targets: [],
                        path: c,
                        node: null
                    }, u = 0; u < c.length; u++){
                        var p = c[u];
                        l.node = p, e.fire("pointerEvents:collect-targets", l);
                    }
                    if (!l.targets.length) return;
                    for(var f = 1 / 0, d = 0, h = l.targets; d < h.length; d++){
                        var v = h[d].eventable.options.holdDuration;
                        v < f && (f = v);
                    }
                    s.duration = f, s.timeout = setTimeout(function() {
                        Vn({
                            interaction: n,
                            eventTarget: o,
                            pointer: r,
                            event: i,
                            type: "hold"
                        }, e);
                    }, f);
                }(t1, e), Vn(t1, e);
            },
            "interactions:up": function(t1, e) {
                Gn(t1), Vn(t1, e), function(t1, e) {
                    var n = t1.interaction, r = t1.pointer, i = t1.event, o = t1.eventTarget;
                    n.pointerWasMoved || Vn({
                        interaction: n,
                        eventTarget: o,
                        pointer: r,
                        event: i,
                        type: "tap"
                    }, e);
                }(t1, e);
            },
            "interactions:cancel": function(t1, e) {
                Gn(t1), Vn(t1, e);
            }
        },
        PointerEvent: qn,
        fire: Vn,
        collectEventTargets: Wn,
        defaults: {
            holdDuration: 600,
            ignoreFrom: null,
            allowFrom: null,
            origin: {
                x: 0,
                y: 0
            }
        },
        types: {
            down: !0,
            move: !0,
            up: !0,
            cancel: !0,
            tap: !0,
            doubletap: !0,
            hold: !0
        }
    };
    function Vn(t1, e) {
        var n = t1.interaction, r = t1.pointer, i = t1.event, o = t1.eventTarget, a = t1.type, s = t1.targets, c = void 0 === s ? Wn(t1, e) : s, l = new qn(a, r, i, o, n, e.now());
        e.fire("pointerEvents:new", {
            pointerEvent: l
        });
        for(var u = {
            interaction: n,
            pointer: r,
            event: i,
            eventTarget: o,
            targets: c,
            type: a,
            pointerEvent: l
        }, p = 0; p < c.length; p++){
            var f = c[p];
            for(var d in f.props || {})l[d] = f.props[d];
            var h = K(f.eventable, f.node);
            if (l._subtractOrigin(h), l.eventable = f.eventable, l.currentTarget = f.node, f.eventable.fire(l), l._addOrigin(h), l.immediatePropagationStopped || l.propagationStopped && p + 1 < c.length && c[p + 1].node !== l.currentTarget) break;
        }
        if (e.fire("pointerEvents:fired", u), "tap" === a) {
            var v = l.double ? Vn({
                interaction: n,
                pointer: r,
                event: i,
                eventTarget: o,
                type: "doubletap"
            }, e) : l;
            n.prevTap = v, n.tapTime = v.timeStamp;
        }
        return l;
    }
    function Wn(t1, e) {
        var n = t1.interaction, r = t1.pointer, i = t1.event, o = t1.eventTarget, a = t1.type, s = n.getPointerIndex(r), c = n.pointers[s];
        if ("tap" === a && (n.pointerWasMoved || !c || c.downTarget !== o)) return [];
        for(var l = q(o), u = {
            interaction: n,
            pointer: r,
            event: i,
            eventTarget: o,
            type: a,
            path: l,
            targets: [],
            node: null
        }, p = 0; p < l.length; p++){
            var f = l[p];
            u.node = f, e.fire("pointerEvents:collect-targets", u);
        }
        return "hold" === a && (u.targets = u.targets.filter(function(t1) {
            var e, r;
            return t1.eventable.options.holdDuration === (null == (e = n.pointers[s]) || null == (r = e.hold) ? void 0 : r.duration);
        })), u.targets;
    }
    function Gn(t1) {
        var e = t1.interaction, n = t1.pointerIndex, r = e.pointers[n].hold;
        r && r.timeout && (clearTimeout(r.timeout), r.timeout = null);
    }
    var Nn = Object.freeze({
        __proto__: null,
        default: Bn
    });
    function Un(t1) {
        var e = t1.interaction;
        e.holdIntervalHandle && (clearInterval(e.holdIntervalHandle), e.holdIntervalHandle = null);
    }
    var Hn = {
        id: "pointer-events/holdRepeat",
        install: function(t1) {
            t1.usePlugin(Bn);
            var e = t1.pointerEvents;
            e.defaults.holdRepeatInterval = 0, e.types.holdrepeat = t1.actions.phaselessTypes.holdrepeat = !0;
        },
        listeners: [
            "move",
            "up",
            "cancel",
            "endall"
        ].reduce(function(t1, e) {
            return t1["pointerEvents:".concat(e)] = Un, t1;
        }, {
            "pointerEvents:new": function(t1) {
                var e = t1.pointerEvent;
                "hold" === e.type && (e.count = (e.count || 0) + 1);
            },
            "pointerEvents:fired": function(t1, e) {
                var n = t1.interaction, r = t1.pointerEvent, i = t1.eventTarget, o = t1.targets;
                if ("hold" === r.type && o.length) {
                    var a = o[0].eventable.options.holdRepeatInterval;
                    a <= 0 || (n.holdIntervalHandle = setTimeout(function() {
                        e.pointerEvents.fire({
                            interaction: n,
                            eventTarget: i,
                            type: "hold",
                            pointer: r,
                            event: r
                        }, e);
                    }, a));
                }
            }
        })
    }, Kn = Hn;
    var $n = {
        id: "pointer-events/interactableTargets",
        install: function(t1) {
            var e = t1.Interactable;
            e.prototype.pointerEvents = function(t1) {
                return V(this.events.options, t1), this;
            };
            var n = e.prototype._backCompatOption;
            e.prototype._backCompatOption = function(t1, e) {
                var r = n.call(this, t1, e);
                return r === this && (this.events.options[t1] = e), r;
            };
        },
        listeners: {
            "pointerEvents:collect-targets": function(t1, e) {
                var n = t1.targets, r = t1.node, i = t1.type, o = t1.eventTarget;
                e.interactables.forEachMatch(r, function(t1) {
                    var e = t1.events, a = e.options;
                    e.types[i] && e.types[i].length && t1.testIgnoreAllow(a, r, o) && n.push({
                        node: r,
                        eventable: e,
                        props: {
                            interactable: t1
                        }
                    });
                });
            },
            "interactable:new": function(t1) {
                var e = t1.interactable;
                e.events.getRect = function(t1) {
                    return e.getRect(t1);
                };
            },
            "interactable:set": function(t1, e) {
                var n = t1.interactable, r = t1.options;
                V(n.events.options, e.pointerEvents.defaults), V(n.events.options, r.pointerEvents || {});
            }
        }
    }, Jn = $n, Qn = {
        id: "pointer-events",
        install: function(t1) {
            t1.usePlugin(Nn), t1.usePlugin(Kn), t1.usePlugin(Jn);
        }
    }, Zn = Qn;
    var tr = {
        id: "reflow",
        install: function(t1) {
            var e = t1.Interactable;
            t1.actions.phases.reflow = !0, e.prototype.reflow = function(e) {
                return function(t1, e, n) {
                    for(var r = t1.getAllElements(), i = n.window.Promise, o = i ? [] : null, a = function() {
                        var a = r[s], c = t1.getRect(a);
                        if (!c) return 1;
                        var l, u = bt(n.interactions.list, function(n) {
                            return n.interacting() && n.interactable === t1 && n.element === a && n.prepared.name === e.name;
                        });
                        if (u) u.move(), o && (l = u._reflowPromise || new i(function(t1) {
                            u._reflowResolve = t1;
                        }));
                        else {
                            var p = U(c), f = function(t1) {
                                return {
                                    coords: t1,
                                    get page () {
                                        return this.coords.page;
                                    },
                                    get client () {
                                        return this.coords.client;
                                    },
                                    get timeStamp () {
                                        return this.coords.timeStamp;
                                    },
                                    get pageX () {
                                        return this.coords.page.x;
                                    },
                                    get pageY () {
                                        return this.coords.page.y;
                                    },
                                    get clientX () {
                                        return this.coords.client.x;
                                    },
                                    get clientY () {
                                        return this.coords.client.y;
                                    },
                                    get pointerId () {
                                        return this.coords.pointerId;
                                    },
                                    get target () {
                                        return this.coords.target;
                                    },
                                    get type () {
                                        return this.coords.type;
                                    },
                                    get pointerType () {
                                        return this.coords.pointerType;
                                    },
                                    get buttons () {
                                        return this.coords.buttons;
                                    },
                                    preventDefault: function() {}
                                };
                            }({
                                page: {
                                    x: p.x,
                                    y: p.y
                                },
                                client: {
                                    x: p.x,
                                    y: p.y
                                },
                                timeStamp: n.now()
                            });
                            l = function(t1, e, n, r, i) {
                                var o = t1.interactions.new({
                                    pointerType: "reflow"
                                }), a = {
                                    interaction: o,
                                    event: i,
                                    pointer: i,
                                    eventTarget: n,
                                    phase: "reflow"
                                };
                                o.interactable = e, o.element = n, o.prevEvent = i, o.updatePointer(i, i, n, !0), nt(o.coords.delta), Ut(o.prepared, r), o._doPhase(a);
                                var s = t1.window, c = s.Promise, l = c ? new c(function(t1) {
                                    o._reflowResolve = t1;
                                }) : void 0;
                                o._reflowPromise = l, o.start(r, e, n), o._interacting ? (o.move(a), o.end(i)) : (o.stop(), o._reflowResolve());
                                return o.removePointer(i, i), l;
                            }(n, t1, a, e, f);
                        }
                        o && o.push(l);
                    }, s = 0; s < r.length && !a(); s++);
                    return o && i.all(o).then(function() {
                        return t1;
                    });
                }(this, e, t1);
            };
        },
        listeners: {
            "interactions:stop": function(t1, e) {
                var n = t1.interaction;
                "reflow" === n.pointerType && (n._reflowResolve && n._reflowResolve(), function(t1, e) {
                    t1.splice(t1.indexOf(e), 1);
                }(e.interactions.list, n));
            }
        }
    }, er = tr;
    if (un.use(he), un.use(Ce), un.use(Zn), un.use(qe), un.use(Ln), un.use(pe), un.use(Xt), un.use(Gt), un.use(er), un.default = un, "object" === n(module) && module) try {
        module.exports = un;
    } catch (t1) {}
    return un.default = un, un;
});

});

parcelRegister("hcrRu", function(module, exports) {
module.exports = JSON.parse('{"locale":"en","countries":{"AF":"Afghanistan","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":["People\'s Republic of China","China"],"CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":["Republic of the Congo","Congo"],"CD":["Democratic Republic of the Congo","Congo"],"CK":"Cook Islands","CR":"Costa Rica","CI":["Cote d\'Ivoire","C\xf4te d\'Ivoire","Ivory Coast"],"HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":["Czech Republic","Czechia"],"DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":["Republic of The Gambia","The Gambia","Gambia"],"GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","VA":"Holy See (Vatican City State)","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":["Islamic Republic of Iran","Iran"],"IQ":"Iraq","IE":"Ireland","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"North Korea","KR":["South Korea","Korea, Republic of","Republic of Korea"],"KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People\'s Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":["Netherlands","The Netherlands","Netherlands (Kingdom of the)"],"NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MK":["The Republic of North Macedonia","North Macedonia"],"MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":["State of Palestine","Palestine"],"PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":["Pitcairn","Pitcairn Islands"],"PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Reunion","RO":"Romania","RU":["Russian Federation","Russia"],"RW":"Rwanda","SH":"Saint Helena","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Eswatini","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":["Taiwan, Province of China","Taiwan"],"TJ":"Tajikistan","TZ":["United Republic of Tanzania","Tanzania"],"TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":["T\xfcrkiye","Turkey"],"TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":["United Arab Emirates","UAE"],"GB":["United Kingdom","UK","Great Britain"],"US":["United States of America","United States","USA","U.S.A.","US","U.S."],"UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe","AX":["\xc5land Islands","Aland Islands"],"BQ":"Bonaire, Sint Eustatius and Saba","CW":"Cura\xe7ao","GG":"Guernsey","IM":"Isle of Man","JE":"Jersey","ME":"Montenegro","BL":"Saint Barth\xe9lemy","MF":"Saint Martin (French part)","RS":"Serbia","SX":"Sint Maarten (Dutch part)","SS":"South Sudan","XK":"Kosovo","SU":"Soviet Union"}}');

});

parcelRegister("fxSCz", function(module, exports) {
module.exports = JSON.parse('{"locale":"pt","countries":{"AF":"Afeganist\xe3o","ZA":"\xc1frica do Sul","AL":"Alb\xe2nia","DE":"Alemanha","AD":"Andorra","AO":"Angola","AI":"Anguila","AQ":"Ant\xe1rtida","AG":"Ant\xedgua e Barbuda","SA":"Ar\xe1bia Saudita","DZ":"Arg\xe9lia","AR":"Argentina","AM":"Arm\xe9nia","AW":"Aruba","AU":"Austr\xe1lia","AT":"\xc1ustria","AZ":"Azerbaij\xe3o","BS":"Bahamas","BH":"Bahrein","BD":"Bangladesh","BB":"Barbados","BE":"B\xe9lgica","BZ":"Belize","BJ":"Benim","BM":"Bermudas","BY":"Bielorr\xfassia","BO":"Bol\xedvia","BA":"B\xf3snia-Herzegovina","BW":"Botsuana","BR":"Brasil","BN":"Brunei","BG":"Bulg\xe1ria","BF":"Burkina Faso","BI":"Burundi","BT":"But\xe3o","CV":"Cabo Verde","KH":"Camboja","CA":"Canad\xe1","QA":"Qatar","KZ":"Cazaquist\xe3o","TD":"Chade","CL":"Chile","CN":"China","CY":"Chipre","VA":"Santa S\xe9","SG":"Singapura","CO":"Col\xf4mbia","KM":"Comores","CG":"Rep\xfablica Democr\xe1tica do Congo","CD":"Rep\xfablica Popular do Congo","KP":"Coreia do Norte","KR":"Coreia do Sul","CI":"Costa do Marfim","CR":"Costa Rica","HR":"Cro\xe1cia","CU":"Cuba","CW":"Cura\xe7ao","DK":"Dinamarca","DJ":"Djibouti","DM":"Dominica","EG":"Egito","SV":"El Salvador","AE":"Emirados \xc1rabes Unidos","EC":"Equador","ER":"Eritreia","SK":"Eslov\xe1quia","SI":"Eslov\xe9nia","ES":"Espanha","US":["Estados Unidos","Estados Unidos da Am\xe9rica"],"EE":"Est\xf3nia","ET":"Eti\xf3pia","FJ":"Fiji","PH":"Filipinas","FI":"Finl\xe2ndia","FR":"Fran\xe7a","GA":"Gab\xe3o","GM":"G\xe2mbia","GH":"Gana","GE":"Ge\xf3rgia","GS":"Ge\xf3rgia do Sul e Ilhas Sandwich do Sul","GI":"Gibraltar","GD":"Granada","GR":"Gr\xe9cia","GL":"Gronel\xe2ndia","GP":"Guadalupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GY":"Guiana","GF":"Guiana Francesa","GN":"Guin\xe9","GW":"Guin\xe9-Bissau","GQ":"Guin\xe9 Equatorial","HT":"Haiti","NL":"Pa\xedses Baixos","HN":"Honduras","HK":"Hong Kong","HU":"Hungria","YE":"I\xe9men","BV":"Ilha Bouvet","CX":"Ilha de Natal","IM":"Ilha de Man","NF":"Ilha Norfolk","AX":"Ilhas \xc5land","KY":"Ilhas Caim\xe3o","CC":"Ilhas Cocos (Keeling)","CK":"Ilhas Cook","UM":"Ilhas Distantes dos EUA","HM":"Ilha Heard e Ilhas McDonald","FO":"Ilhas Faro\xe9","FK":"Ilhas Malvinas","MP":"Ilhas Marianas do Norte","MH":"Ilhas Marshall","PN":"Ilhas Pitcairn","SB":"Ilhas Salom\xe3o","TC":"Ilhas Turcas e Caicos","VG":"Ilhas Virgens Brit\xe2nicas","VI":"Ilhas Virgens Americanas","IN":"\xcdndia","ID":"Indon\xe9sia","IR":"Ir\xe3o","IQ":"Iraque","IE":"Irlanda","IS":"Isl\xe2ndia","IL":"Israel","IT":"It\xe1lia","JM":"Jamaica","JP":"Jap\xe3o","JE":"Jersey","JO":"Jord\xe2nia","KW":"Koweit","LA":"Laos","LS":"Lesoto","LV":"Let\xf3nia","LB":"L\xedbano","LR":"Lib\xe9ria","LY":"L\xedbia","LI":"Liechtenstein","LT":"Litu\xe2nia","LU":"Luxemburgo","MO":"Macau","MK":"Maced\xf3nia do Norte","MG":"Madag\xe1scar","MY":"Mal\xe1sia","MW":"Mal\xe1ui","MV":"Maldivas","ML":"Mali","MT":"Malta","MA":"Marrocos","MQ":"Martinica","MU":"Maur\xedcia","MR":"Maurit\xe2nia","YT":"Mayotte","MX":"M\xe9xico","MM":"Mianmar (Birm\xe2nia)","FM":"Micron\xe9sia","MZ":"Mo\xe7ambique","MD":"Mold\xe1via","MC":"M\xf3naco","MN":"Mong\xf3lia","ME":"Montenegro","MS":"Monserrate","NA":"Nam\xedbia","NR":"Nauru","NP":"Nepal","NI":"Nicar\xe1gua","NE":"N\xedger","NG":"Nig\xe9ria","NU":"Niue","NO":"Noruega","NC":"Nova Caled\xf3nia","NZ":"Nova Zel\xe2ndia","OM":"Om\xe3","BQ":"Pa\xedses Baixos Caribenhos","PW":"Palau","PA":"Panam\xe1","PG":"Papua-Nova Guin\xe9","PK":"Paquist\xe3o","PY":"Paraguai","PE":"Peru","PF":"Polin\xe9sia Francesa","PL":"Pol\xf3nia","PR":"Porto Rico","PT":"Portugal","KE":"Qu\xe9nia","KG":"Quirguist\xe3o","KI":"Quiribati","GB":"Reino Unido","CF":"Rep\xfablica Centro-Africana","DO":"Rep\xfablica Dominicana","CM":"Camar\xf5es","CZ":"Ch\xe9quia","RE":"Reuni\xe3o","RO":"Rom\xe9nia","RW":"Ruanda","RU":"R\xfassia","EH":"Saara Ocidental","PM":"Saint Pierre e Miquelon","WS":"Samoa","AS":"Samoa Americana","SM":"San Marino","SH":"Santa Helena","LC":"Santa L\xfacia","BL":"S\xe3o Bartolomeu","KN":"S\xe3o Crist\xf3v\xe3o e Neves","MF":"S\xe3o Martinho","ST":"S\xe3o Tom\xe9 e Pr\xedncipe","VC":"S\xe3o Vicente e Granadinas","SN":"Senegal","SL":"Serra Leoa","RS":"S\xe9rvia","SC":"Seychelles","SX":"S\xe3o Martinho","SY":"S\xedria","SO":"Som\xe1lia","LK":"Sri Lanka","SZ":"Essuat\xedni","SD":"Sud\xe3o","SS":"Sud\xe3o do Sul","SE":"Su\xe9cia","CH":"Su\xed\xe7a","SR":"Suriname","SJ":"Svalbard e Jan Mayen","TH":"Tail\xe2ndia","TW":"Taiwan","TJ":"Tajiquist\xe3o","TZ":"Tanz\xe2nia","IO":"Territ\xf3rio Brit\xe2nico do Oceano \xcdndico","TF":"Terras Austrais e Ant\xe1rticas Francesas","PS":"Territ\xf3rios palestinos","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trindade e Tobago","TN":"Tun\xedsia","TM":"Turquemenist\xe3o","TR":"Turquia","TV":"Tuvalu","UA":"Ucr\xe2nia","UG":"Uganda","UY":"Uruguai","UZ":"Uzbequist\xe3o","VU":"Vanuatu","VE":"Venezuela","VN":"Vietname","WF":"Wallis e Futuna","ZM":"Z\xe2mbia","ZW":"Zimb\xe1bue","XK":"Kosovo","SU":"Uni\xe3o Sovi\xe9tica"}}');

});

parcelRegister("iAAvH", function(module, exports) {
module.exports = JSON.parse('{"locale":"ja","countries":{"AF":"\u30A2\u30D5\u30AC\u30CB\u30B9\u30BF\u30F3","AL":"\u30A2\u30EB\u30D0\u30CB\u30A2","DZ":"\u30A2\u30EB\u30B8\u30A7\u30EA\u30A2","AS":"\u30A2\u30E1\u30EA\u30AB\u9818\u30B5\u30E2\u30A2","AD":"\u30A2\u30F3\u30C9\u30E9","AO":"\u30A2\u30F3\u30B4\u30E9","AI":"\u30A2\u30F3\u30AE\u30E9","AQ":"\u5357\u6975","AG":"\u30A2\u30F3\u30C6\u30A3\u30B0\u30A2\u30FB\u30D0\u30FC\u30D6\u30FC\u30C0","AR":"\u30A2\u30EB\u30BC\u30F3\u30C1\u30F3","AM":"\u30A2\u30EB\u30E1\u30CB\u30A2","AW":"\u30A2\u30EB\u30D0","AU":"\u30AA\u30FC\u30B9\u30C8\u30E9\u30EA\u30A2","AT":"\u30AA\u30FC\u30B9\u30C8\u30EA\u30A2","AZ":"\u30A2\u30BC\u30EB\u30D0\u30A4\u30B8\u30E3\u30F3","BS":"\u30D0\u30CF\u30DE","BH":"\u30D0\u30FC\u30EC\u30FC\u30F3","BD":"\u30D0\u30F3\u30B0\u30E9\u30C7\u30B7\u30E5","BB":"\u30D0\u30EB\u30D0\u30C9\u30B9","BY":"\u30D9\u30E9\u30EB\u30FC\u30B7","BE":"\u30D9\u30EB\u30AE\u30FC","BZ":"\u30D9\u30EA\u30FC\u30BA","BJ":"\u30D9\u30CA\u30F3","BM":"\u30D0\u30DF\u30E5\u30FC\u30C0","BT":"\u30D6\u30FC\u30BF\u30F3","BO":"\u30DC\u30EA\u30D3\u30A2\u591A\u6C11\u65CF\u56FD","BA":"\u30DC\u30B9\u30CB\u30A2\u30FB\u30D8\u30EB\u30C4\u30A7\u30B4\u30D3\u30CA","BW":"\u30DC\u30C4\u30EF\u30CA","BV":"\u30D6\u30FC\u30D9\u5CF6","BR":"\u30D6\u30E9\u30B8\u30EB","IO":"\u30A4\u30AE\u30EA\u30B9\u9818\u30A4\u30F3\u30C9\u6D0B\u5730\u57DF","BN":"\u30D6\u30EB\u30CD\u30A4\u30FB\u30C0\u30EB\u30B5\u30E9\u30FC\u30E0","BG":"\u30D6\u30EB\u30AC\u30EA\u30A2","BF":"\u30D6\u30EB\u30AD\u30CA\u30D5\u30A1\u30BD","BI":"\u30D6\u30EB\u30F3\u30B8","KH":"\u30AB\u30F3\u30DC\u30B8\u30A2","CM":"\u30AB\u30E1\u30EB\u30FC\u30F3","CA":"\u30AB\u30CA\u30C0","CV":"\u30AB\u30FC\u30DC\u30D9\u30EB\u30C7","KY":"\u30B1\u30A4\u30DE\u30F3\u8AF8\u5CF6","CF":"\u4E2D\u592E\u30A2\u30D5\u30EA\u30AB\u5171\u548C\u56FD","TD":"\u30C1\u30E3\u30C9","CL":"\u30C1\u30EA","CN":"\u4E2D\u83EF\u4EBA\u6C11\u5171\u548C\u56FD","CX":"\u30AF\u30EA\u30B9\u30DE\u30B9\u5CF6","CC":"\u30B3\u30B3\u30B9\uFF08\u30AD\u30FC\u30EA\u30F3\u30B0\uFF09\u8AF8\u5CF6","CO":"\u30B3\u30ED\u30F3\u30D3\u30A2","KM":"\u30B3\u30E2\u30ED","CG":"\u30B3\u30F3\u30B4\u5171\u548C\u56FD","CD":"\u30B3\u30F3\u30B4\u6C11\u4E3B\u5171\u548C\u56FD","CK":"\u30AF\u30C3\u30AF\u8AF8\u5CF6","CR":"\u30B3\u30B9\u30BF\u30EA\u30AB","CI":"\u30B3\u30FC\u30C8\u30B8\u30DC\u30EF\u30FC\u30EB","HR":"\u30AF\u30ED\u30A2\u30C1\u30A2","CU":"\u30AD\u30E5\u30FC\u30D0","CY":"\u30AD\u30D7\u30ED\u30B9","CZ":"\u30C1\u30A7\u30B3","DK":"\u30C7\u30F3\u30DE\u30FC\u30AF","DJ":"\u30B8\u30D6\u30C1","DM":"\u30C9\u30DF\u30CB\u30AB\u56FD","DO":"\u30C9\u30DF\u30CB\u30AB\u5171\u548C\u56FD","EC":"\u30A8\u30AF\u30A2\u30C9\u30EB","EG":"\u30A8\u30B8\u30D7\u30C8","SV":"\u30A8\u30EB\u30B5\u30EB\u30D0\u30C9\u30EB","GQ":"\u8D64\u9053\u30AE\u30CB\u30A2","ER":"\u30A8\u30EA\u30C8\u30EA\u30A2","EE":"\u30A8\u30B9\u30C8\u30CB\u30A2","ET":"\u30A8\u30C1\u30AA\u30D4\u30A2","FK":"\u30D5\u30A9\u30FC\u30AF\u30E9\u30F3\u30C9\uFF08\u30DE\u30EB\u30D3\u30CA\u30B9\uFF09\u8AF8\u5CF6","FO":"\u30D5\u30A7\u30ED\u30FC\u8AF8\u5CF6","FJ":"\u30D5\u30A3\u30B8\u30FC","FI":"\u30D5\u30A3\u30F3\u30E9\u30F3\u30C9","FR":"\u30D5\u30E9\u30F3\u30B9","GF":"\u30D5\u30E9\u30F3\u30B9\u9818\u30AE\u30A2\u30CA","PF":"\u30D5\u30E9\u30F3\u30B9\u9818\u30DD\u30EA\u30CD\u30B7\u30A2","TF":"\u30D5\u30E9\u30F3\u30B9\u9818\u5357\u65B9\u30FB\u5357\u6975\u5730\u57DF","GA":"\u30AC\u30DC\u30F3","GM":"\u30AC\u30F3\u30D3\u30A2","GE":"\u30B8\u30E7\u30FC\u30B8\u30A2","DE":"\u30C9\u30A4\u30C4","GH":"\u30AC\u30FC\u30CA","GI":"\u30B8\u30D6\u30E9\u30EB\u30BF\u30EB","GR":"\u30AE\u30EA\u30B7\u30E3","GL":"\u30B0\u30EA\u30FC\u30F3\u30E9\u30F3\u30C9","GD":"\u30B0\u30EC\u30CA\u30C0","GP":"\u30B0\u30A2\u30C9\u30EB\u30FC\u30D7","GU":"\u30B0\u30A2\u30E0","GT":"\u30B0\u30A2\u30C6\u30DE\u30E9","GN":"\u30AE\u30CB\u30A2","GW":"\u30AE\u30CB\u30A2\u30D3\u30B5\u30A6","GY":"\u30AC\u30A4\u30A2\u30CA","HT":"\u30CF\u30A4\u30C1","HM":"\u30CF\u30FC\u30C9\u5CF6\u3068\u30DE\u30AF\u30C9\u30CA\u30EB\u30C9\u8AF8\u5CF6","VA":"\u30D0\u30C1\u30AB\u30F3\u5E02\u56FD","HN":"\u30DB\u30F3\u30B8\u30E5\u30E9\u30B9","HK":"\u9999\u6E2F","HU":"\u30CF\u30F3\u30AC\u30EA\u30FC","IS":"\u30A2\u30A4\u30B9\u30E9\u30F3\u30C9","IN":"\u30A4\u30F3\u30C9","ID":"\u30A4\u30F3\u30C9\u30CD\u30B7\u30A2","IR":"\u30A4\u30E9\u30F3\u30FB\u30A4\u30B9\u30E9\u30E0\u5171\u548C\u56FD","IQ":"\u30A4\u30E9\u30AF","IE":"\u30A2\u30A4\u30EB\u30E9\u30F3\u30C9","IL":"\u30A4\u30B9\u30E9\u30A8\u30EB","IT":"\u30A4\u30BF\u30EA\u30A2","JM":"\u30B8\u30E3\u30DE\u30A4\u30AB","JP":"\u65E5\u672C","JO":"\u30E8\u30EB\u30C0\u30F3","KZ":"\u30AB\u30B6\u30D5\u30B9\u30BF\u30F3","KE":"\u30B1\u30CB\u30A2","KI":"\u30AD\u30EA\u30D0\u30B9","KP":"\u671D\u9BAE\u6C11\u4E3B\u4E3B\u7FA9\u4EBA\u6C11\u5171\u548C\u56FD","KR":"\u5927\u97D3\u6C11\u56FD","KW":"\u30AF\u30A6\u30A7\u30FC\u30C8","KG":"\u30AD\u30EB\u30AE\u30B9","LA":"\u30E9\u30AA\u30B9\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u56FD","LV":"\u30E9\u30C8\u30D3\u30A2","LB":"\u30EC\u30D0\u30CE\u30F3","LS":"\u30EC\u30BD\u30C8","LR":"\u30EA\u30D9\u30EA\u30A2","LY":"\u30EA\u30D3\u30A2","LI":"\u30EA\u30D2\u30C6\u30F3\u30B7\u30E5\u30BF\u30A4\u30F3","LT":"\u30EA\u30C8\u30A2\u30CB\u30A2","LU":"\u30EB\u30AF\u30BB\u30F3\u30D6\u30EB\u30AF","MO":"\u30DE\u30AB\u30AA","MG":"\u30DE\u30C0\u30AC\u30B9\u30AB\u30EB","MW":"\u30DE\u30E9\u30A6\u30A4","MY":"\u30DE\u30EC\u30FC\u30B7\u30A2","MV":"\u30E2\u30EB\u30C7\u30A3\u30D6","ML":"\u30DE\u30EA","MT":"\u30DE\u30EB\u30BF","MH":"\u30DE\u30FC\u30B7\u30E3\u30EB\u8AF8\u5CF6","MQ":"\u30DE\u30EB\u30C6\u30A3\u30CB\u30FC\u30AF","MR":"\u30E2\u30FC\u30EA\u30BF\u30CB\u30A2","MU":"\u30E2\u30FC\u30EA\u30B7\u30E3\u30B9","YT":"\u30DE\u30E8\u30C3\u30C8","MX":"\u30E1\u30AD\u30B7\u30B3","FM":"\u30DF\u30AF\u30ED\u30CD\u30B7\u30A2\u9023\u90A6","MD":"\u30E2\u30EB\u30C9\u30D0\u5171\u548C\u56FD","MC":"\u30E2\u30CA\u30B3","MN":"\u30E2\u30F3\u30B4\u30EB","MS":"\u30E2\u30F3\u30C8\u30BB\u30E9\u30C8","MA":"\u30E2\u30ED\u30C3\u30B3","MZ":"\u30E2\u30B6\u30F3\u30D3\u30FC\u30AF","MM":"\u30DF\u30E3\u30F3\u30DE\u30FC","NA":"\u30CA\u30DF\u30D3\u30A2","NR":"\u30CA\u30A6\u30EB","NP":"\u30CD\u30D1\u30FC\u30EB","NL":"\u30AA\u30E9\u30F3\u30C0","NC":"\u30CB\u30E5\u30FC\u30AB\u30EC\u30C9\u30CB\u30A2","NZ":"\u30CB\u30E5\u30FC\u30B8\u30FC\u30E9\u30F3\u30C9","NI":"\u30CB\u30AB\u30E9\u30B0\u30A2","NE":"\u30CB\u30B8\u30A7\u30FC\u30EB","NG":"\u30CA\u30A4\u30B8\u30A7\u30EA\u30A2","NU":"\u30CB\u30A6\u30A8","NF":"\u30CE\u30FC\u30D5\u30A9\u30FC\u30AF\u5CF6","MK":"\u5317\u30DE\u30B1\u30C9\u30CB\u30A2","MP":"\u5317\u30DE\u30EA\u30A2\u30CA\u8AF8\u5CF6","NO":"\u30CE\u30EB\u30A6\u30A7\u30FC","OM":"\u30AA\u30DE\u30FC\u30F3","PK":"\u30D1\u30AD\u30B9\u30BF\u30F3","PW":"\u30D1\u30E9\u30AA","PS":"\u30D1\u30EC\u30B9\u30C1\u30CA","PA":"\u30D1\u30CA\u30DE","PG":"\u30D1\u30D7\u30A2\u30CB\u30E5\u30FC\u30AE\u30CB\u30A2","PY":"\u30D1\u30E9\u30B0\u30A2\u30A4","PE":"\u30DA\u30EB\u30FC","PH":"\u30D5\u30A3\u30EA\u30D4\u30F3","PN":"\u30D4\u30C8\u30B1\u30A2\u30F3","PL":"\u30DD\u30FC\u30E9\u30F3\u30C9","PT":"\u30DD\u30EB\u30C8\u30AC\u30EB","PR":"\u30D7\u30A8\u30EB\u30C8\u30EA\u30B3","QA":"\u30AB\u30BF\u30FC\u30EB","RE":"\u30EC\u30E6\u30CB\u30AA\u30F3","RO":"\u30EB\u30FC\u30DE\u30CB\u30A2","RU":"\u30ED\u30B7\u30A2\u9023\u90A6","RW":"\u30EB\u30EF\u30F3\u30C0","SH":"\u30BB\u30F3\u30C8\u30D8\u30EC\u30CA\u30FB\u30A2\u30BB\u30F3\u30B7\u30E7\u30F3\u304A\u3088\u3073\u30C8\u30EA\u30B9\u30BF\u30F3\u30C0\u30AF\u30FC\u30CB\u30E3","KN":"\u30BB\u30F3\u30C8\u30AF\u30EA\u30B9\u30C8\u30D5\u30A1\u30FC\u30FB\u30CD\u30A4\u30D3\u30B9","LC":"\u30BB\u30F3\u30C8\u30EB\u30B7\u30A2","PM":"\u30B5\u30F3\u30D4\u30A8\u30FC\u30EB\u5CF6\u30FB\u30DF\u30AF\u30ED\u30F3\u5CF6","VC":"\u30BB\u30F3\u30C8\u30D3\u30F3\u30BB\u30F3\u30C8\u304A\u3088\u3073\u30B0\u30EC\u30CA\u30C7\u30A3\u30FC\u30F3\u8AF8\u5CF6","WS":"\u30B5\u30E2\u30A2","SM":"\u30B5\u30F3\u30DE\u30EA\u30CE","ST":"\u30B5\u30F3\u30C8\u30E1\u30FB\u30D7\u30EA\u30F3\u30B7\u30DA","SA":"\u30B5\u30A6\u30B8\u30A2\u30E9\u30D3\u30A2","SN":"\u30BB\u30CD\u30AC\u30EB","SC":"\u30BB\u30FC\u30B7\u30A7\u30EB","SL":"\u30B7\u30A8\u30E9\u30EC\u30AA\u30CD","SG":"\u30B7\u30F3\u30AC\u30DD\u30FC\u30EB","SK":"\u30B9\u30ED\u30D0\u30AD\u30A2","SI":"\u30B9\u30ED\u30D9\u30CB\u30A2","SB":"\u30BD\u30ED\u30E2\u30F3\u8AF8\u5CF6","SO":"\u30BD\u30DE\u30EA\u30A2","ZA":"\u5357\u30A2\u30D5\u30EA\u30AB","GS":"\u30B5\u30A6\u30B9\u30B8\u30E7\u30FC\u30B8\u30A2\u30FB\u30B5\u30A6\u30B9\u30B5\u30F3\u30C9\u30A6\u30A3\u30C3\u30C1\u8AF8\u5CF6","ES":"\u30B9\u30DA\u30A4\u30F3","LK":"\u30B9\u30EA\u30E9\u30F3\u30AB","SD":"\u30B9\u30FC\u30C0\u30F3","SR":"\u30B9\u30EA\u30CA\u30E0","SJ":"\u30B9\u30F4\u30A1\u30FC\u30EB\u30D0\u30EB\u8AF8\u5CF6\u304A\u3088\u3073\u30E4\u30F3\u30DE\u30A4\u30A8\u30F3\u5CF6","SZ":"\u30B9\u30EF\u30B8\u30E9\u30F3\u30C9","SE":"\u30B9\u30A6\u30A7\u30FC\u30C7\u30F3","CH":"\u30B9\u30A4\u30B9","SY":"\u30B7\u30EA\u30A2\u30FB\u30A2\u30E9\u30D6\u5171\u548C\u56FD","TW":"\u53F0\u6E7E","TJ":"\u30BF\u30B8\u30AD\u30B9\u30BF\u30F3","TZ":"\u30BF\u30F3\u30B6\u30CB\u30A2","TH":"\u30BF\u30A4","TL":"\u6771\u30C6\u30A3\u30E2\u30FC\u30EB","TG":"\u30C8\u30FC\u30B4","TK":"\u30C8\u30B1\u30E9\u30A6","TO":"\u30C8\u30F3\u30AC","TT":"\u30C8\u30EA\u30CB\u30C0\u30FC\u30C9\u30FB\u30C8\u30D0\u30B4","TN":"\u30C1\u30E5\u30CB\u30B8\u30A2","TR":"\u30C8\u30EB\u30B3","TM":"\u30C8\u30EB\u30AF\u30E1\u30CB\u30B9\u30BF\u30F3","TC":"\u30BF\u30FC\u30AF\u30B9\u30FB\u30AB\u30A4\u30B3\u30B9\u8AF8\u5CF6","TV":"\u30C4\u30D0\u30EB","UG":"\u30A6\u30AC\u30F3\u30C0","UA":"\u30A6\u30AF\u30E9\u30A4\u30CA","AE":"\u30A2\u30E9\u30D6\u9996\u9577\u56FD\u9023\u90A6","GB":"\u30A4\u30AE\u30EA\u30B9","US":"\u30A2\u30E1\u30EA\u30AB\u5408\u8846\u56FD","UM":"\u5408\u8846\u56FD\u9818\u6709\u5C0F\u96E2\u5CF6","UY":"\u30A6\u30EB\u30B0\u30A2\u30A4","UZ":"\u30A6\u30BA\u30D9\u30AD\u30B9\u30BF\u30F3","VU":"\u30D0\u30CC\u30A2\u30C4","VE":"\u30D9\u30CD\u30BA\u30A8\u30E9\u30FB\u30DC\u30EA\u30D0\u30EB\u5171\u548C\u56FD","VN":"\u30D9\u30C8\u30CA\u30E0","VG":"\u30A4\u30AE\u30EA\u30B9\u9818\u30F4\u30A1\u30FC\u30B8\u30F3\u8AF8\u5CF6","VI":"\u30A2\u30E1\u30EA\u30AB\u9818\u30F4\u30A1\u30FC\u30B8\u30F3\u8AF8\u5CF6","WF":"\u30A6\u30A9\u30EA\u30B9\u30FB\u30D5\u30C4\u30CA","EH":"\u897F\u30B5\u30CF\u30E9","YE":"\u30A4\u30A8\u30E1\u30F3","ZM":"\u30B6\u30F3\u30D3\u30A2","ZW":"\u30B8\u30F3\u30D0\u30D6\u30A8","AX":"\u30AA\u30FC\u30E9\u30F3\u30C9\u8AF8\u5CF6","BQ":"\u30DC\u30CD\u30FC\u30EB\u3001\u30B7\u30F3\u30C8\u30FB\u30E6\u30FC\u30B9\u30BF\u30C6\u30A3\u30A6\u30B9\u304A\u3088\u3073\u30B5\u30D0","CW":"\u30AD\u30E5\u30E9\u30BD\u30FC","GG":"\u30AC\u30FC\u30F3\u30B8\u30FC","IM":"\u30DE\u30F3\u5CF6","JE":"\u30B8\u30E3\u30FC\u30B8\u30FC","ME":"\u30E2\u30F3\u30C6\u30CD\u30B0\u30ED","BL":"\u30B5\u30F3\u30FB\u30D0\u30EB\u30C6\u30EB\u30DF\u30FC","MF":"\u30B5\u30F3\u30FB\u30DE\u30EB\u30BF\u30F3\uFF08\u30D5\u30E9\u30F3\u30B9\u9818\uFF09","RS":"\u30BB\u30EB\u30D3\u30A2","SX":"\u30B7\u30F3\u30C8\u30FB\u30DE\u30FC\u30EB\u30C6\u30F3\uFF08\u30AA\u30E9\u30F3\u30C0\u9818\uFF09","SS":"\u5357\u30B9\u30FC\u30C0\u30F3","XK":"\u30B3\u30BD\u30DC","SU":"\u30BD\u30D3\u30A8\u30C8\u9023\u90A6"}}');

});

parcelRegister("7GJAx", function(module, exports) {
module.exports = JSON.parse('{"locale":"de","countries":{"AF":"Afghanistan","EG":"\xc4gypten","AX":"\xc5land","AL":"Albanien","DZ":"Algerien","AS":"Amerikanisch-Samoa","VI":"Amerikanische Jungferninseln","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarktis","AG":"Antigua und Barbuda","GQ":"\xc4quatorialguinea","AR":"Argentinien","AM":"Armenien","AW":"Aruba","AZ":"Aserbaidschan","ET":"\xc4thiopien","AU":"Australien","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesch","BB":"Barbados","BY":"Belarus","BE":"Belgien","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivien","BQ":"Bonaire","BA":"Bosnien und Herzegowina","BW":"Botswana","BV":"Bouvetinsel","BR":"Brasilien","VG":"Britische Jungferninseln","IO":"Britisches Territorium im Indischen Ozean","BN":"Brunei Darussalam","BG":"Bulgarien","BF":"Burkina Faso","BI":"Burundi","CL":"Chile","CN":"China","CK":"Cookinseln","CR":"Costa Rica","CI":"Elfenbeink\xfcste","CW":"Cura\xe7ao","DK":"D\xe4nemark","DE":"Deutschland","DM":"Dominica","DO":"Dominikanische Republik","DJ":"Dschibuti","EC":"Ecuador","SV":"El Salvador","ER":"Eritrea","EE":"Estland","FK":"Falklandinseln","FO":"F\xe4r\xf6er","FJ":"Fidschi","FI":"Finnland","FR":"Frankreich","GF":"Franz\xf6sisch-Guayana","PF":"Franz\xf6sisch-Polynesien","TF":"Franz\xf6sische S\xfcd- und Antarktisgebiete","GA":"Gabun","GM":"Gambia","GE":"Georgien","GH":"Ghana","GI":"Gibraltar","GD":"Grenada","GR":"Griechenland","GL":"Gr\xf6nland","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard und McDonaldinseln","HN":"Honduras","HK":["Hongkong","Hong Kong"],"IN":"Indien","ID":"Indonesien","IM":"Insel Man","IQ":"Irak","IR":"Iran","IE":"Irland","IS":"Island","IL":"Israel","IT":"Italien","JM":"Jamaika","JP":"Japan","YE":"Jemen","JE":"Jersey","JO":"Jordanien","KY":"Kaimaninseln","KH":"Kambodscha","CM":"Kamerun","CA":"Kanada","CV":"Kap Verde","KZ":"Kasachstan","QA":"Katar","KE":"Kenia","KG":"Kirgisistan","KI":"Kiribati","CC":"Kokosinseln","CO":"Kolumbien","KM":"Komoren","CD":"Kongo","KP":"Nordkorea","KR":"S\xfcdkorea","HR":"Kroatien","CU":"Kuba","KW":"Kuwait","LA":"Laos","LS":"Lesotho","LV":"Lettland","LB":"Libanon","LR":"Liberia","LY":"Libyen","LI":"Liechtenstein","LT":"Litauen","LU":"Luxemburg","MO":"Macao","MG":"Madagaskar","MW":"Malawi","MY":"Malaysia","MV":"Malediven","ML":"Mali","MT":"Malta","MA":"Marokko","MH":"Marshallinseln","MQ":"Martinique","MR":"Mauretanien","MU":"Mauritius","YT":"Mayotte","MX":"Mexiko","FM":"Mikronesien","MD":"Moldawien","MC":"Monaco","MN":"Mongolei","ME":"Montenegro","MS":"Montserrat","MZ":"Mosambik","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NC":"Neukaledonien","NZ":"Neuseeland","NI":"Nicaragua","NL":"Niederlande","NE":"Niger","NG":"Nigeria","NU":"Niue","MK":"Nordmazedonien","MP":"N\xf6rdliche Marianen","NF":"Norfolkinsel","NO":"Norwegen","OM":"Oman","AT":"\xd6sterreich","TL":"Osttimor","PK":"Pakistan","PS":"Staat Pal\xe4stina","PW":"Palau","PA":"Panama","PG":"Papua-Neuguinea","PY":"Paraguay","PE":"Peru","PH":"Philippinen","PN":"Pitcairninseln","PL":"Polen","PT":"Portugal","PR":"Puerto Rico","TW":"Taiwan","CG":"Republik Kongo","RE":"R\xe9union","RW":"Ruanda","RO":"Rum\xe4nien","RU":["Russische F\xf6deration","Russland"],"BL":"Saint-Barth\xe9lemy","MF":"Saint-Martin","SB":"Salomonen","ZM":"Sambia","WS":"Samoa","SM":"San Marino","ST":"S\xe3o Tom\xe9 und Pr\xedncipe","SA":"Saudi-Arabien","SE":"Schweden","CH":"Schweiz","SN":"Senegal","RS":"Serbien","SC":"Seychellen","SL":"Sierra Leone","ZW":"Simbabwe","SG":"Singapur","SX":"Sint Maarten","SK":"Slowakei","SI":"Slowenien","SO":"Somalia","ES":"Spanien","LK":"Sri Lanka","SH":"St. Helena","KN":"St. Kitts und Nevis","LC":"St. Lucia","PM":"Saint-Pierre und Miquelon","VC":"St. Vincent und die Grenadinen","ZA":"S\xfcdafrika","SD":"Sudan","GS":"S\xfcdgeorgien und die S\xfcdlichen Sandwichinseln","SS":"S\xfcdsudan","SR":"Suriname","SJ":"Svalbard und Jan Mayen","SZ":"Eswatini","SY":"Syrien, Arabische Republik","TJ":"Tadschikistan","TZ":["Tansania, Vereinigte Republik","Tansania"],"TH":"Thailand","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad und Tobago","TD":"Tschad","CZ":["Tschechische Republik","Tschechien"],"TN":"Tunesien","TR":"T\xfcrkei","TM":"Turkmenistan","TC":"Turks- und Caicosinseln","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","HU":"Ungarn","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Usbekistan","VU":"Vanuatu","VA":"Vatikanstadt","VE":"Venezuela","AE":"Vereinigte Arabische Emirate","US":["Vereinigte Staaten von Amerika","Vereinigte Staaten","USA"],"GB":["Vereinigtes K\xf6nigreich","Gro\xdfbritannien"],"VN":"Vietnam","WF":"Wallis und Futuna","CX":"Weihnachtsinsel","EH":"Westsahara","CF":"Zentralafrikanische Republik","CY":"Zypern","XK":"Kosovo"}}');

});

parcelRegister("jg95v", function(module, exports) {
module.exports = JSON.parse('{"locale":"zh","countries":{"AD":"\u5B89\u9053\u5C14","AE":"\u963F\u8054\u914B","AF":"\u963F\u5BCC\u6C57","AG":"\u5B89\u63D0\u74DC\u548C\u5DF4\u5E03\u8FBE","AI":"\u5B89\u572D\u62C9","AL":"\u963F\u5C14\u5DF4\u5C3C\u4E9A","AM":"\u4E9A\u7F8E\u5C3C\u4E9A","AO":"\u5B89\u54E5\u62C9","AQ":"\u5357\u6781\u6D32","AR":"\u963F\u6839\u5EF7","AS":"\u7F8E\u5C5E\u8428\u6469\u4E9A","AT":"\u5965\u5730\u5229","AU":"\u6FB3\u5927\u5229\u4E9A","AW":"\u963F\u9C81\u5DF4","AX":"\u5965\u5170","AZ":"\u963F\u585E\u62DC\u7586","BA":"\u6CE2\u9ED1","BB":"\u5DF4\u5DF4\u591A\u65AF","BD":"\u5B5F\u52A0\u62C9\u56FD","BE":"\u6BD4\u5229\u65F6","BF":"\u5E03\u57FA\u7EB3\u6CD5\u7D22","BG":"\u4FDD\u52A0\u5229\u4E9A","BH":"\u5DF4\u6797","BI":"\u5E03\u9686\u8FEA","BJ":"\u8D1D\u5B81","BL":"\u5723\u5DF4\u6CF0\u52D2\u7C73","BM":"\u767E\u6155\u5927","BN":"\u6587\u83B1","BO":"\u73BB\u5229\u7EF4\u4E9A","BQ":"\u8377\u5170\u52A0\u52D2\u6BD4\u533A","BR":"\u5DF4\u897F","BS":"\u5DF4\u54C8\u9A6C","BT":"\u4E0D\u4E39","BV":"\u5E03\u97E6\u5C9B","BW":"\u535A\u8328\u74E6\u7EB3","BY":"\u767D\u4FC4\u7F57\u65AF","BZ":"\u4F2F\u5229\u5179","CA":"\u52A0\u62FF\u5927","CC":"\u79D1\u79D1\u65AF\uFF08\u57FA\u6797\uFF09\u7FA4\u5C9B","CD":"\u521A\u679C\uFF08\u91D1\uFF09","CF":"\u4E2D\u975E","CG":"\u521A\u679C\uFF08\u5E03\uFF09","CH":"\u745E\u58EB","CI":"\u79D1\u7279\u8FEA\u74E6","CK":"\u5E93\u514B\u7FA4\u5C9B","CL":"\u667A\u5229","CM":"\u5580\u9EA6\u9686","CN":"\u4E2D\u56FD","CO":"\u54E5\u4F26\u6BD4\u4E9A","CR":"\u54E5\u65AF\u8FBE\u9ECE\u52A0","CU":"\u53E4\u5DF4","CV":"\u4F5B\u5F97\u89D2","CW":"\u5E93\u62C9\u7D22","CX":"\u5723\u8BDE\u5C9B","CY":"\u585E\u6D66\u8DEF\u65AF","CZ":"\u6377\u514B","DE":"\u5FB7\u56FD","DJ":"\u5409\u5E03\u63D0","DK":"\u4E39\u9EA6","DM":"\u591A\u7C73\u5C3C\u514B","DO":"\u591A\u7C73\u5C3C\u52A0","DZ":"\u963F\u5C14\u53CA\u5229\u4E9A","EC":"\u5384\u74DC\u591A\u5C14","EE":"\u7231\u6C99\u5C3C\u4E9A","EG":"\u57C3\u53CA","EH":"\u963F\u62C9\u4F2F\u6492\u54C8\u62C9\u6C11\u4E3B\u5171\u548C\u56FD","ER":"\u5384\u7ACB\u7279\u91CC\u4E9A","ES":"\u897F\u73ED\u7259","ET":"\u57C3\u585E\u4FC4\u6BD4\u4E9A","FI":"\u82AC\u5170","FJ":"\u6590\u6D4E","FK":"\u798F\u514B\u5170\u7FA4\u5C9B","FM":"\u5BC6\u514B\u7F57\u5C3C\u897F\u4E9A\u8054\u90A6","FO":"\u6CD5\u7F57\u7FA4\u5C9B","FR":"\u6CD5\u56FD","GA":"\u52A0\u84EC","GB":"\u82F1\u56FD","GD":"\u683C\u6797\u7EB3\u8FBE","GE":"\u683C\u9C81\u5409\u4E9A","GF":"\u6CD5\u5C5E\u572D\u4E9A\u90A3","GG":"\u6839\u897F","GH":"\u52A0\u7EB3","GI":"\u76F4\u5E03\u7F57\u9640","GL":"\u683C\u9675\u5170","GM":"\u5188\u6BD4\u4E9A","GN":"\u51E0\u5185\u4E9A","GP":"\u74DC\u5FB7\u7F57\u666E","GQ":"\u8D64\u9053\u51E0\u5185\u4E9A","GR":"\u5E0C\u814A","GS":"\u5357\u4E54\u6CBB\u4E9A\u548C\u5357\u6851\u5A01\u5947\u7FA4\u5C9B","GT":"\u5371\u5730\u9A6C\u62C9","GU":"\u5173\u5C9B","GW":"\u51E0\u5185\u4E9A\u6BD4\u7ECD","GY":"\u572D\u4E9A\u90A3","HK":"\u9999\u6E2F","HM":"\u8D6B\u5FB7\u5C9B\u548C\u9EA6\u514B\u5510\u7EB3\u7FA4\u5C9B","HN":"\u6D2A\u90FD\u62C9\u65AF","HR":"\u514B\u7F57\u5730\u4E9A","HT":"\u6D77\u5730","HU":"\u5308\u7259\u5229","ID":"\u5370\u5C3C","IE":"\u7231\u5C14\u5170","IL":"\u4EE5\u8272\u5217","IM":"\u9A6C\u6069\u5C9B","IN":"\u5370\u5EA6","IO":"\u82F1\u5C5E\u5370\u5EA6\u6D0B\u9886\u5730","IQ":"\u4F0A\u62C9\u514B","IR":"\u4F0A\u6717","IS":"\u51B0\u5C9B","IT":"\u610F\u5927\u5229","JE":"\u6CFD\u897F","JM":"\u7259\u4E70\u52A0","JO":"\u7EA6\u65E6","JP":"\u65E5\u672C","KE":"\u80AF\u5C3C\u4E9A","KG":"\u5409\u5C14\u5409\u65AF\u65AF\u5766","KH":"\u67EC\u57D4\u5BE8","KI":"\u57FA\u91CC\u5DF4\u65AF","KM":"\u79D1\u6469\u7F57","KN":"\u5723\u57FA\u8328\u548C\u5C3C\u7EF4\u65AF","KP":"\u671D\u9C9C","KR":"\u97E9\u56FD","KW":"\u79D1\u5A01\u7279","KY":"\u5F00\u66FC\u7FA4\u5C9B","KZ":"\u54C8\u8428\u514B\u65AF\u5766","LA":"\u8001\u631D","LB":"\u9ECE\u5DF4\u5AE9","LC":"\u5723\u5362\u897F\u4E9A","LI":"\u5217\u652F\u6566\u58EB\u767B","LK":"\u65AF\u91CC\u5170\u5361","LR":"\u5229\u6BD4\u91CC\u4E9A","LS":"\u83B1\u7D22\u6258","LT":"\u7ACB\u9676\u5B9B","LU":"\u5362\u68EE\u5821","LV":"\u62C9\u8131\u7EF4\u4E9A","LY":"\u5229\u6BD4\u4E9A","MA":"\u6469\u6D1B\u54E5","MC":"\u6469\u7EB3\u54E5","MD":"\u6469\u5C14\u591A\u74E6","ME":"\u9ED1\u5C71","MF":"\u6CD5\u5C5E\u5723\u9A6C\u4E01","MG":"\u9A6C\u8FBE\u52A0\u65AF\u52A0","MH":"\u9A6C\u7ECD\u5C14\u7FA4\u5C9B","MK":"\u5317\u9A6C\u5176\u987F","ML":"\u9A6C\u91CC","MM":"\u7F05\u7538","MN":"\u8499\u53E4","MO":"\u6FB3\u95E8","MP":"\u5317\u9A6C\u91CC\u4E9A\u7EB3\u7FA4\u5C9B","MQ":"\u9A6C\u63D0\u5C3C\u514B","MR":"\u6BDB\u91CC\u5854\u5C3C\u4E9A","MS":"\u8499\u7279\u585E\u62C9\u7279","MT":"\u9A6C\u8033\u4ED6","MU":"\u6BDB\u91CC\u6C42\u65AF","MV":"\u9A6C\u5C14\u4EE3\u592B","MW":"\u9A6C\u62C9\u7EF4","MX":"\u58A8\u897F\u54E5","MY":"\u9A6C\u6765\u897F\u4E9A","MZ":"\u83AB\u6851\u6BD4\u514B","NA":"\u7EB3\u7C73\u6BD4\u4E9A","NC":"\u65B0\u5580\u91CC\u591A\u5C3C\u4E9A","NE":"\u5C3C\u65E5\u5C14","NF":"\u8BFA\u798F\u514B\u5C9B","NG":"\u5C3C\u65E5\u5229\u4E9A","NI":"\u5C3C\u52A0\u62C9\u74DC","NL":"\u8377\u5170","NO":"\u632A\u5A01","NP":"\u5C3C\u6CCA\u5C14","NR":"\u7459\u9C81","NU":"\u7EBD\u57C3","NZ":"\u65B0\u897F\u5170","OM":"\u963F\u66FC","PA":"\u5DF4\u62FF\u9A6C","PE":"\u79D8\u9C81","PF":"\u6CD5\u5C5E\u6CE2\u5229\u5C3C\u897F\u4E9A","PG":"\u5DF4\u5E03\u4E9A\u65B0\u51E0\u5185\u4E9A","PH":"\u83F2\u5F8B\u5BBE","PK":"\u5DF4\u57FA\u65AF\u5766","PL":"\u6CE2\u5170","PM":"\u5723\u76AE\u57C3\u5C14\u548C\u5BC6\u514B\u9686","PN":"\u76AE\u7279\u51EF\u6069\u7FA4\u5C9B","PR":"\u6CE2\u591A\u9ECE\u5404","PS":"\u5DF4\u52D2\u65AF\u5766","PT":"\u8461\u8404\u7259","PW":"\u5E15\u52B3","PY":"\u5DF4\u62C9\u572D","QA":"\u5361\u5854\u5C14","RE":"\u7559\u5C3C\u6C6A","RO":"\u7F57\u9A6C\u5C3C\u4E9A","RS":"\u585E\u5C14\u7EF4\u4E9A","RU":"\u4FC4\u7F57\u65AF","RW":"\u5362\u65FA\u8FBE","SA":"\u6C99\u7279\u963F\u62C9\u4F2F","SB":"\u6240\u7F57\u95E8\u7FA4\u5C9B","SC":"\u585E\u820C\u5C14","SD":"\u82CF\u4E39","SE":"\u745E\u5178","SG":"\u65B0\u52A0\u5761","SH":"\u5723\u8D6B\u52D2\u62FF\u3001\u963F\u68EE\u677E\u548C\u7279\u91CC\u65AF\u5766-\u8FBE\u5E93\u5C3C\u4E9A","SI":"\u65AF\u6D1B\u6587\u5C3C\u4E9A","SJ":"\u65AF\u74E6\u5C14\u5DF4\u548C\u626C\u9A6C\u5EF6","SK":"\u65AF\u6D1B\u4F10\u514B","SL":"\u585E\u62C9\u5229\u6602","SM":"\u5723\u9A6C\u529B\u8BFA","SN":"\u585E\u5185\u52A0\u5C14","SO":"\u7D22\u9A6C\u91CC","SR":"\u82CF\u91CC\u5357","SS":"\u5357\u82CF\u4E39","ST":"\u5723\u591A\u7F8E\u548C\u666E\u6797\u897F\u6BD4","SV":"\u8428\u5C14\u74E6\u591A","SX":"\u8377\u5C5E\u5723\u9A6C\u4E01","SY":"\u53D9\u5229\u4E9A","SZ":"\u65AF\u5A01\u58EB\u5170","TC":"\u7279\u514B\u65AF\u548C\u51EF\u79D1\u65AF\u7FA4\u5C9B","TD":"\u4E4D\u5F97","TF":"\u6CD5\u5C5E\u5357\u90E8\u9886\u5730","TG":"\u591A\u54E5","TH":"\u6CF0\u56FD","TJ":"\u5854\u5409\u514B\u65AF\u5766","TK":"\u6258\u514B\u52B3","TL":"\u4E1C\u5E1D\u6C76","TM":"\u571F\u5E93\u66FC\u65AF\u5766","TN":"\u7A81\u5C3C\u65AF","TO":"\u6C64\u52A0","TR":"\u571F\u8033\u5176","TT":"\u7279\u7ACB\u5C3C\u8FBE\u548C\u591A\u5DF4\u54E5","TV":"\u56FE\u74E6\u5362","TW":"\u4E2D\u56FD\u53F0\u6E7E\u7701","TZ":"\u5766\u6851\u5C3C\u4E9A","UA":"\u4E4C\u514B\u5170","UG":"\u4E4C\u5E72\u8FBE","UM":"\u7F8E\u56FD\u672C\u571F\u5916\u5C0F\u5C9B\u5C7F","US":"\u7F8E\u56FD","UY":"\u4E4C\u62C9\u572D","UZ":"\u4E4C\u5179\u522B\u514B\u65AF\u5766","VA":"\u68B5\u8482\u5188","VC":"\u5723\u6587\u68EE\u7279\u548C\u683C\u6797\u7EB3\u4E01\u65AF","VE":"\u59D4\u5185\u745E\u62C9","VG":"\u82F1\u5C5E\u7EF4\u5C14\u4EAC\u7FA4\u5C9B","VI":"\u7F8E\u5C5E\u7EF4\u5C14\u4EAC\u7FA4\u5C9B","VN":"\u8D8A\u5357","VU":"\u74E6\u52AA\u963F\u56FE","WF":"\u74E6\u5229\u65AF\u548C\u5BCC\u56FE\u7EB3","WS":"\u8428\u6469\u4E9A","XK":"\u79D1\u7D22\u6C83","YE":"\u4E5F\u95E8","YT":"\u9A6C\u7EA6\u7279","ZA":"\u5357\u975E","ZM":"\u8D5E\u6BD4\u4E9A","ZW":"\u6D25\u5DF4\u5E03\u97E6"}}');

});

/* Budotree: Martial Arts Lineage Tree

   Copyright (C) 2022-2025, Frederico Muñoz
   
   This program is free software: you can redistribute it and/or
   modify it under the terms of the GNU Affero General Public License
   as published by the Free Software Foundation, either version 3 of
   the License, or (at your option) any later version.

   This program is distributed in the hope that it will be useful, but
   WITHOUT ANY WARRANTY; without even the implied warranty of
   MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
   Affero General Public License for more details.

   You should have received a copy of the GNU Affero General Public
   License along with this program.  If not, see
   <https://www.gnu.org/licenses/>.
*/ var $d8a032920235956d$exports = {};
$d8a032920235956d$exports = JSON.parse('{"format_version":"1.0","generated_by":"Judo Tree JS","elements":{"nodes":[{"data":{"id":"JDP-24","name":"Walter Todd","nationality":["USA"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"photo_url":"https://archive.org/download/walter_todd/walter_todd.jpg","teachers":[{"id":"JDP-11","style_id":"JDP-S-1","place":"Kodokan","period":{"start":1946,"end":null},"quality":1}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://www.koryu.com/library/mskoss10.html"}],"source_yaml":"database/persons/USA/Walter_Todd.yaml","photo_url_local":"images/cache/f675dca6b1d7d2394952b1b6ee6810bc.jpg"}},{"data":{"id":"JDP-96","name":"Theodore Roosevelt Jr.","aka":[{"name":"Theodore Roosevelt Jr."},{"name":"Teddy Roosevelt"}],"nationality":["USA"],"birth":{"date":"1858-10-27","location":"Manhattan","country_code":"USA"},"death":{"date":"1919-01-06","location":"Oyster Bay","country_code":"USA"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/thumb/5/5b/Theodore_Roosevelt_by_the_Pach_Bros.jpg/800px-Theodore_Roosevelt_by_the_Pach_Bros.jpg","source":{"uri":"https://en.wikipedia.org/wiki/Theodore_Roosevelt#/media/File:Theodore_Roosevelt_by_the_Pach_Bros.jpg"}},"teachers":[{"id":"JDP-95","style_id":"JDP-S-1","place":null,"period":{"start":1904,"end":1904},"quality":2,"sources":[{"uri":"https://ejmas.com/jcs/jcsart_svinth1_1000.htm","cite":"Professor Yamashita Goes to Washington (Journal of Combative Sport, Oct 2000)","citation":"So, during March and April 1904, Roosevelt practiced judo three afternoons a week, using a ground floor office in the White House as his workout space (...) Yamashita later said that while Roosevelt was his best pupil (...)"}]},{"name":"James O\'Brien","style_id":null,"place":null,"period":{"start":null,"end":null},"quality":null}],"rank":[{"style_id":"JDP-S-1","org":"USJA","teacher":null,"rank":"8 dan (honorary)","date":2007,"sources":[{"uri":"https://ejmas.com/jcs/jcsart_svinth1_1000.htm","citation":"The USJA made Roosevelt an 8th Degree Black Belt, an honor usually bestowed on those who have been doing Judo over 50 years and occasionally on those of distinguished leadership who have bought Judo into the international limelight."}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://ejmas.com/jcs/jcsart_svinth1_1000.htm"},{"uri":"https://en.wikipedia.org/wiki/Theodore_Roosevelt"},{"uri":"https://martialarts.stackexchange.com/questions/2209/what-level-of-expertise-did-theodore-roosevelt-have-in-judo"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q33866","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Theodore_Roosevelt","cite":"DBpedia"}],"source_yaml":"database/persons/USA/Theodore_Roosevelt.yaml"}},{"data":{"id":"JDP-133","name":"Ronda Rousey","aka":[{"name":"Ronda Jean Rousey"}],"nationality":["USA"],"birth":{"date":"1987-02-01","location":"Riverside, California","country_code":"USA"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Rousey_HOF_2018_%28cropped%29.jpg/800px-Rousey_HOF_2018_%28cropped%29.jpg","source":{"uri":"https://en.wikipedia.org/wiki/Ronda_Rousey#/media/File:Rousey_HOF_2018_(cropped).jpg","cite":"WWE Hall of Fame (2018) - Wikipedia"}},"teachers":[{"id":"JDP-132","style_id":"JDP-S-1","period":{"start":"1998","end":null},"quality":3,"place":null,"sources":[{"uri":"https://www.blackbeltmag.com/fists-of-love-the-mothers-who-raised-martial-arts-legends","cite":"Fists of Love: The Mothers Who Raised Martial Arts Legends - Black Belt Magazine","citation":"She began coaching Ronda at age 11, instilling a mindset that would later carry her daughter to Olympic bronze in judo and UFC glory"}]}],"rank":[{"style_id":"JDP-S-1","org":"AAU","rank":"6 dan","date":"2018-03-03","sources":[{"uri":"http://www.freestylejudo.org/jbba/","cite":"JBBA Rank Promotions - Freestyle Judo Association","citation":"Rokudan (6th Dan): (...)Ronda Rousey, 3/3/2018, Gompers Judo"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Ronda_Rousey"},{"uri":"https://www.judoinside.com/judoka/19130/Ronda_Rousey/judo-career"},{"uri":"https://www.ijf.org/judoka/2589","cite":"Ronda ROUSEY / IJF.org"},{"uri":"https://www.usjf.com/ronda-rousey/","cite":"Ronda Rousey | United States Judo Federation"}],"source_yaml":"database/persons/USA/Ronda_Rousey.yaml"}},{"data":{"id":"JDP-122","name":"Kenneth Kuniyuki","nationality":["USA"],"birth":{"date":"1910-10-06","location":"Seattle","country_code":"USA"},"death":{"date":"2002-11-28","location":null,"country_code":"USA"},"photo":{"url":"https://www.usjf.com/wp-content/uploads/2018/02/kuniyuki.png","source":{"uri":"https://www.usjf.com/kenneth-kuniyuki/","cite":"Kenneth Kuniyuki - USJF"}},"teachers":[{"id":"JDP-31","style_id":"JDP-S-1","place":"Keio University, Tokyo","period":{"start":"1931","end":"1932"},"quality":3,"sources":[{"uri":"https://www.usjf.com/kenneth-kuniyuki/","cite":"Kenneth Kuniyuki - USJF","location":null,"citation":"From 1931 to 1932 Kenneth studied under Kunisaburo Iizuka, 8-dan, and original student of Kano Sensei in Tokyo, Japan"},{"uri":"https://shoyuzine.tripod.com/id14.html","cite":"Asian Americans who\'ve made a difference - Shoyu Zine","citation":"In 1932 he went to Japan to train at Keio University under the instruction of Kunisaburo Iizuka, 8 dan at the time"}]}],"rank":[{"style_id":"JDP-S-1","org":"USJF","rank":"9 dan","date":null,"sources":[{"uri":"https://www.usjf.com/kenneth-kuniyuki/","cite":"Kenneth Kuniyuki - USJF"},{"uri":"https://shoyuzine.tripod.com/id14.html","cite":"Asian Americans who\'ve made a difference - Shoyu Zine"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://www.usjf.com/kenneth-kuniyuki/","cite":"Kenneth Kuniyuki | United States Judo Federation"},{"uri":"https://shoyuzine.tripod.com/id14.html","cite":"Obits"}],"source_yaml":"database/persons/USA/Kenneth_Kuniyuki.yaml"}},{"data":{"id":"JDP-52","name":"Karl Geis","aka":[{"name":"Karl Geis"}],"nationality":["USA"],"birth":{"date":1933,"location":"Houston, Texas","country_code":"USA"},"death":{"date":"2014-04-07","location":null,"country_code":null},"photo_url":"https://ia601208.us.archive.org/9/items/karl_geis_formal_202312/karl_geis_formal.png","teachers":[{"id":"JDP-12","style_id":"JDP-S-1","place":"Kodokan","period":{"start":1952,"end":null},"quality":2,"sources":[{"uri":"https://www.karlgeis.com/his-resume","cite":"Karl Geis Martial Arts Resume (Karl Geis Ryu homepage)","citation":"During my studies in Japan I received significant personal instruction from the following Kodokan teachers: [...] Kobayashi Sensei, 8th Dan"}]},{"id":"JDP-53","style_id":"JDP-S-4","place":null,"period":{"start":null,"end":null},"quality":2,"sources":[{"uri":"https://www.karlgeis.com/his-resume","cite":"Karl Geis Martial Arts Resume (Karl Geis Ryu homepage)","citation":"During my studies in Japan I received significant personal instruction from the following Kodokan teachers: [...] Miyake, Tsunako Sensei, 7th Dan"}]}],"rank":[{"style_id":"JDP-S-1","org":"USJA","teacher":null,"rank":"10 dan","date":2014,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}},{"style_id":"JDP-S-4","org":null,"teacher":null,"rank":"10 dan","date":1997,"style":"Aikid\u014D","style_native":{"name":"\u5408\u6C17\u9053","lang":"ja"}},{"style_id":"JDP-S-4","org":null,"teacher":null,"rank":"6 dan","date":1980,"style":"Aikid\u014D","style_native":{"name":"\u5408\u6C17\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Karl_Geis"},{"uri":"https://www.karlgeis.com/his-resume","cite":"His Resume | karlgeisryu"},{"uri":"https://media.usja.net/2014/04/Karl-Geis-Bio-4-14.pdf"},{"uri":"https://maytt.home.blog/2020/09/09/interview-with-david-witt-judo-aikido-and-karl-geis/","cite":"Interview with David Witt: Judo, Aikido, and Karl Geis \u2013 Martial Arts of Yesterday, Today and Tomorrow"}],"source_yaml":"database/persons/USA/Karl_Geis.yaml","photo_url_local":"images/cache/f9bf4313ab12ede4973da500f2141d00.png"}},{"data":{"id":"JDP-123","name":"James Cagney","aka":[{"name":"James Francis Cagney Jr."}],"nationality":["USA"],"birth":{"date":"1899-07-17","location":"New York City","country_code":"USA"},"death":{"date":"1986-03-30","location":"Stanford, New York","country_code":"USA"},"photo":{"url":"https://archive.org/download/james_cagney/james_cagney.jpg","source":{"uri":"https://archive.org/details/james_cagney","cite":"Internet Archive"}},"teachers":[{"id":"JDP-122","style_id":"JDP-S-1","place":"Seinan Dojo, Los Angeles","period":{"start":1945,"end":null},"quality":1,"sources":[{"uri":"https://www.mixedmartialarts.com/judo/1945-film-fight-scene","cite":"1945 film fight scene - MixedMartialArts.com","citation":"James would train Judo at the Seinan Dojo under Kenneth Kuniyuki"}]}],"rank":[{"style_id":"JDP-S-1","rank":"1 dan","date":null,"org":null,"quality":0,"sources":[{"uri":"urn:isbn:0831758058","cite":"CORCORAN, John; FARKAS, Emil. Martial Arts: Traditions, History. People, 1988","location":"p. 187","citation":"James Cagney, a certified judo black belt"},{"uri":"https://www.e-budo.com/archive/index.php/t-13797.html","cite":"Cagney\'s Black Belt - E-Budo.com","citation":"He studied Judo just for the movie... up to Brown Belt"},{"uri":"https://www.e-budo.com/archive/index.php/t-13797.html","cite":"Cagney\'s Black Belt - E-Budo.com","citation":"His judo dan ranking was honorary"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/James_Cagney"},{"uri":"https://www.mixedmartialarts.com/judo/1945-film-fight-scene"},{"uri":"https://www.e-budo.com/archive/index.php/t-13797.html"}],"source_yaml":"database/persons/USA/James_Cagney.yaml"}},{"data":{"id":"JDP-25","name":"Hal Sharp","aka":[{"name":"Harold Sharp"}],"nationality":["USA"],"birth":{"date":1927,"location":null,"country_code":null},"death":{"date":2021,"location":null,"country_code":null},"photo_url":"https://article-imgs.scribdassets.com/2840m8mlj48oc26j/images/fileLKP2HSNH.jpg","teachers":[{"id":"JDP-12","style_id":"JDP-S-1","place":"Kodokan","period":{"start":1952,"end":null},"quality":3},{"id":"JDP-119","style_id":"JDP-S-1","place":"Keishicho","period":{"start":1953,"end":1955},"quality":3,"sources":[{"uri":"https://www.usjf.com/takahiko-ishikawa/","cite":"Memories of My Sensei Takahiko Ishikawa, 9th Dan by Harold (Hal) E. Sharp (USJF)","citation":"I would like to share some of my experiences with you about my Sensei and dear friend, Takahiko Ishikawa (...) I first met Ishikawa in 1953 in Japan after I became a Shodan (1st degree black belt) and thus was allowed to workout at the Keishicho (Tokyo Police Dojo) (...)"}]},{"id":"JDP-124","style_id":"JDP-S-1","place":"Kodokan","period":{"start":1950,"end":null},"quality":3,"sources":[{"uri":"https://judoinfo.com/oda/","cite":"Master Tsunetane Oda - JudoInfo","citation":"...I began to practice with Master Oda at Rikkyo University in Tokyo, during the early 1950\u2019s and still remain fascinated by his bravado (...) I remained under Master Oda\u2019s tutelage for many years practicing 3 times a day. Often I would accompany Master Oda to the Kodokan as well as the Dojo at Sugamo Prison."}]}],"rank":[{"style_id":"JDP-S-1","org":"Nanka Judo Yudanshakai","teacher":null,"rank":"10 dan","date":2020,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Harold_Sharp"},{"uri":"https://youtu.be/B5B39yYPIlQ?t=169"},{"uri":"https://www.usjf.com/2018/02/harold-hal-sharp/"},{"uri":"urn:isbn:978-0804805421"},{"uri":"https://blackbeltmag.com/hal-sharp-judo"}],"source_yaml":"database/persons/USA/Harold_Sharp.yaml","photo_url_local":"images/cache/8a2641e4f643cea115938f9b84d9eb9f.jpg"}},{"data":{"id":"JDP-120","name":"Gene LeBell","aka":[{"name":"Ivan Gene LeBell"}],"nationality":["USA"],"birth":{"date":"1932-10-09","location":"Los Angeles","country_code":"USA"},"death":{"date":"2022-08-09","location":"Los Angeles","country_code":"USA"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/en/9/95/Cropped_Photo_of_Gene_LeBell.jpg","source":{"uri":"https://upload.wikimedia.org/wikipedia/en/9/95/Cropped_Photo_of_Gene_LeBell.jpg","cite":"Cropped Photo of Gene LeBell (Wikipedia Commons)"}},"description":{"en":"Ivan Gene LeBell (October 9, 1932 \u2013 August 9, 2022) was an American judoka, stuntman, actor and professional wrestler. Nicknamed \\"Judo Gene\\" and \\"The Godfather of Grappling\\", he is credited with popularizing grappling in professional fighting circles, serving as a precursor to modern mixed martial arts. He worked on over 1,000 films and TV shows and authored 12 books."},"teachers":[{"id":"JDP-119","style_id":"JDP-S-1","place":"Keishicho","period":{"start":1953,"end":1955},"quality":3,"sources":[{"uri":"https://mokurendojo.blogspot.com/2008/05/mokuren-interview-judo-gene-lebell.html","cite":"Mokuren Interview: \'Judo\' Gene LeBell (Mokuren Dojo)","citation":"Who do you think were the greatest judo teachers you ever got to learn from? Gene Lebell: In the U.S. Shig Tashma, Larry Coughran, Kenneth Kinyuki, Fuji Nazawa (who just died 2 days ago), and of course I learned a lot from training in Japan (Ishikawa)"}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Harold_Sharp"},{"uri":"https://mokurendojo.blogspot.com/2008/05/mokuren-interview-judo-gene-lebell.html","cite":"Mokuren Dojo: Mokuren Interview: \'Judo\' Gene LeBell"}],"source_yaml":"database/persons/USA/Gene_LeBell.yaml"}},{"data":{"id":"JDP-111","name":"Donn F. Draeger","aka":[{"name":"Donald Frederick Draeger"}],"nationality":["USA"],"birth":{"date":"1922-04-15","location":"Milwaukee, Wisconsin","country_code":"USA"},"death":{"date":"1982-10-20","location":"Milwaukee, Wisconsin","country_code":"USA"},"photo":{"url":"https://archive.org/download/draeger/draeger.jpg","source":{"uri":"https://judoinfo.com/kata/","cite":"Nage no Kata and Katame no Kata, by Donn F. Draeger - JudoIndo"}},"teachers":[{"id":"JDP-112","style_id":"JDP-S-6","place":null,"period":{"start":1967,"end":null},"quality":3,"sources":[{"uri":"http://aiki-kohai.over-blog.com/2018/08/chronique-abregee-de-donn-f.draeger.html","cite":"Tatsusjin : la chronique abr\xe9g\xe9e de Donn F. Draeger (A\xefki-Koha\xef)","citation":"A partir de 1967, Il sera ensuite la premier pratiquant non japonais \xe0 entrer dans l\'\xe9cole Tenshin shoden Katori Shinto ryu alors sous la direction du c\xe9l\xe8bre Risuke Otake shihan, achevant son parcours dans cette \xe9cole par l\'obtention d\'un grade d\'instructeur."}]},{"id":"JDP-117","style_id":"JDP-S-17","place":"Meiji Shrine","period":{"start":null,"end":null},"quality":2,"sources":[{"uri":"https://kogenbudo.org/i-htm/","cite":"Donn Draeger & Robert Smith: Their Intersection Concerning Chinese Martial Arts (KogenBudo)","citation":"There was a famous xingyiquan and baguazhang teacher in Japan in those days, named Wang Shujin (...) Donn (and a number of other of his associates) began training with Wang on the grounds of the Meiji Shrine (...)"}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Donn_F._Draeger"},{"uri":"https://budojapan.com/feature-articles/donn-f-draeger-the-pioneer/","cite":"Donn F. Draeger: The Pioneer | BUDO JAPAN - Japanese martial-arts"}],"source_yaml":"database/persons/USA/Donn_Draeger.yaml"}},{"data":{"id":"JDP-132","name":"AnnMaria De Mars","aka":[{"name":"AnnMaria Burns"}],"nationality":["USA"],"birth":{"date":"1958-06-15","location":"Calumet, Michigan","country_code":"USA"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/ann-maria/AnnMaria.jpeg","source":{"uri":"https://www.historyoffighting.com/the-blog/dr-annmaria-de-mars","cite":"The History of Fighting (AnnMaria de Mars)"}},"teachers":[{"id":"JDP-131","style_id":"JDP-S-1","place":"Waseda University, Tokyo","period":{"start":"1976","end":null},"quality":2,"sources":[{"uri":"https://www.usjf.com/annmaria-de-mars-2/","cite":"AnnMaria De Mars - USJF","citation":"at the age of 18, as a college junior, De Mars was an exchange student at Waseda University in Tokyo, Japan. While there, she trained under Sensei Osawa"}]}],"rank":[{"style_id":"JDP-S-1","rank":"6 dan","date":"2016","org":null,"sources":[{"uri":"https://www.fukudajudocamp.org/archives/2016-joshi-camp/","cite":"2016 Joshi Judo Camp - Fukuda Judo","citation":"2016 Joshi Judo Camp Guest Instructors: Dr. AnnMaria DeMars (6th Dan)"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/AnnMaria_De_Mars"},{"uri":"https://www.usjf.com/annmaria-de-mars-2/","cite":"AnnMaria De Mars | United States Judo Federation"},{"uri":"https://www.fukudajudocamp.org/archives/2016-joshi-camp/","cite":"2016 Joshi Camp \xab Keiko Fukuda Joshi Judo Camp"},{"uri":"https://www.judoinside.com/judoka/6000/AnnMaria_Burns/judo-career"}],"source_yaml":"database/persons/USA/AnnMaria_De_Mars.yaml"}},{"data":{"id":"JDP-100","name":"Vladimir Putin","native_name":{"name":"\u0412\u043B\u0430\u0434\u0438\u0301\u043C\u0438\u0440 \u0412\u043B\u0430\u0434\u0438\u0301\u043C\u0438\u0440\u043E\u0432\u0438\u0447 \u041F\u0443\u0301\u0442\u0438\u043D","lang":"ru"},"nationality":["SUN","RUS"],"birth":{"date":"1952-10-07","location":"Leningrad","country_code":"SUN"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/putin_202408/putin.png","source":{"uri":"https://judo.ru/news/4783","cite":"\u0421 \u0434\u043D\u0435\u043C \u0440\u043E\u0436\u0434\u0435\u043D\u044C\u044F! (\u0424\u0415\u0414\u0415\u0420\u0410\u0426\u0418\u042F \u0414\u0417\u042E\u0414\u041E \u0420\u041E\u0421\u0421\u0418\u0418)"}},"teachers":[{"id":"JDP-99","style_id":"JDP-S-1","place":null,"period":{"start":1964,"end":null},"quality":2,"sources":[{"uri":"https://judo.ru/news/4707","citation":"\u0412 1964 \u0433\u043E\u0434\u0443 \u043D\u0430\u0431\u0440\u0430\u043B \u043F\u0435\u0440\u0432\u0443\u044E \u0433\u0440\u0443\u043F\u043F\u0443 \u044E\u043D\u043E\u0448\u0435\u0439, \u0441\u0440\u0435\u0434\u0438 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0431\u044B\u043B\u0438 \u0410\u0440\u043A\u0430\u0434\u0438\u0439 \u0420\u043E\u0442\u0435\u043D\u0431\u0435\u0440\u0433, \u0412\u0430\u043B\u0435\u043D\u0442\u0438\u043D \u0421\u0442\u0435\u043F\u0430\u043D\u043E\u0432, \u041D\u0438\u043A\u043E\u043B\u0430\u0439 \u041A\u043E\u043D\u043E\u043D\u043E\u0432, \u0412\u0430\u0441\u0438\u043B\u0438\u0439 \u0428\u0435\u0441\u0442\u0430\u043A\u043E\u0432, \u0412\u043B\u0430\u0434\u0438\u043C\u0438\u0440 \u041F\u0443\u0442\u0438\u043D.","cite":"\u0423\u0442\u0440\u0430\u0442\u0430"}]},{"id":"JDP-99","style_id":"JDP-S-15","place":null,"period":{"start":1964,"end":null},"quality":2,"sources":[{"uri":"https://vecherka-spb.ru/2023/08/08/chestnoe-i-dobrosovestnoe-otnoshenie-k-delu-kakim-bil-anatolii-rakhlin--lichnii-trener-vladimira-putina-","citation":"\u0425\u043E\u0440\u043E\u0448\u043E \u043F\u043E\u043C\u043D\u044E, \u043A\u0430\u043A \u0410\u043D\u0430\u0442\u043E\u043B\u0438\u0439 \u0421\u043E\u043B\u043E\u043C\u043E\u043D\u043E\u0432\u0438\u0447 \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u043B \u043E\u0442\u0431\u043E\u0440 \u0432 \u0441\u0435\u043A\u0446\u0438\u044E \u0441\u0430\u043C\u0431\u043E. \u041D\u0443\u0436\u043D\u043E \u0431\u044B\u043B\u043E \u043F\u043E\u0434\u0442\u044F\u043D\u0443\u0442\u044C\u0441\u044F \u2014 \u043A\u0442\u043E \u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u043C\u043E\u0436\u0435\u0442.","cite":"\u0412\u0435\u0447\u0435\u0440\u043D\u0438\u0439 \u0421\u0430\u043D\u043A\u0442-\u041F\u0435\u0442\u0435\u0440\u0431\u0443\u0440\u0433"}]}],"rank":[{"style_id":"JDP-S-15","org":null,"teacher":null,"rank":"Master of Sports","date":null,"sources":[{"uri":"http://en.putin.kremlin.ru/interests/page-0","citation":"Putin is also multiple champion of St Petersburg in Sambo and Master of Sports in Sambo"}],"style":"Sambo","style_native":{"name":"\u0441a\u043C\u0431\u043E","lang":"ru"}},{"style_id":"JDP-S-1","org":"EJU","teacher":null,"rank":"8 dan","date":null,"sources":[{"uri":"https://www.eju.net/8th-dan-attributed-to-vladimir-putin/","cite":"8th Dan attributed to Vladimir Putin (European Judo Union)","citation":"Following the festivities of the 60th anniversary of the International Judo Federation, celebrated last year in Paris on the occasion of the World Championships, the IJF had the honor of awarding the 8th dan to Vladimir Putin, President of the Russian Federation, who was also celebrating his 60th birthday on the 7th of october."}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://ru.wikipedia.org/wiki/%D0%9F%D1%83%D1%82%D0%B8%D0%BD,_%D0%92%D0%BB%D0%B0%D0%B4%D0%B8%D0%BC%D0%B8%D1%80_%D0%92%D0%BB%D0%B0%D0%B4%D0%B8%D0%BC%D0%B8%D1%80%D0%BE%D0%B2%D0%B8%D1%87"},{"uri":"https://sambo.sport/en/news/anatoliy-rakhlin-chelovek-pedagog-trener/","cite":"Anatoliy Rakhlin: Person, Teacher, Coach | International SAMBO Federation (FIAS)"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q15088978","cite":"Wikidata"}],"source_yaml":"database/persons/SUN/Vladimir_Putin.yaml"}},{"data":{"id":"JDP-97","name":"Vasili Oshchepkov","native_name":{"name":"\u0412\u0430\u0441\u0438\u0301\u043B\u0438\u0439 \u0421\u0435\u0440\u0433\u0435\u0301\u0435\u0432\u0438\u0447 \u041E\u0449\u0435\u0301\u043F\u043A\u043E\u0432","lang":"ru"},"nationality":["RUS","SUN"],"birth":{"date":"1893-01-07","location":"Sakhalin","country_code":"RUS"},"death":{"date":"1938-10-10","location":"Moscow","country_code":"SUN"},"photo":{"url":"https://archive.org/download/vasili/vasili.jpg","source":{"uri":"https://www.vokrug.tv/person/show/16914436371/"}},"teachers":[{"id":"JDP-1","style_id":"JDP-S-1","place":null,"period":{"start":1911,"end":1917},"quality":0,"sources":[{"uri":"https://oca.asia/sports/info/15/58/","citation":"Oshchepkov spent much of his life living in Japan and training judo under its founder Kano Jigoro."},{"uri":"https://en.wikipedia.org/wiki/Vasili_Oshchepkov","citation":""}]},{"name":"James O\'Brien","style_id":null,"place":null,"period":{"start":null,"end":null},"quality":null}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"2 dan","date":2007,"sources":[{"uri":"https://web.archive.org/web/20211028220427/http://kodokanjudoinstitute.org/en/news/2016/12/special-exhibition-of-the-material-concerning-mr-vasili-oshchepkov/","citation":"Mr. Oshchepkov became a disciple of the Kodokan in 1911 and then was promoted to 2nd Dan. A record book of initiation pleading shows his address and signature. Also his unique seal that says \'B.O\' can be seen on it."},{"uri":"https://en.wikipedia.org/wiki/Vasili_Oshchepkov","citation":"On June 15, 1913, Oshchepkov received the first degree black belt - shodan (first dan); in October 1917, during a trip to Japan, he passed the exams to receive his second degree black belt,becoming the first Russian and the third European to get a nidan in judo"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Vasili_Oshchepkov"},{"uri":"https://www.rbth.com/arts/2015/05/30/vasily_oshchepkov_the_founder_of_sambo_46477.html"},{"uri":"https://oca.asia/sports/info/15/58/"},{"uri":"https://ru.wikipedia.org/wiki/%D0%9E%D1%89%D0%B5%D0%BF%D0%BA%D0%BE%D0%B2,_%D0%92%D0%B0%D1%81%D0%B8%D0%BB%D0%B8%D0%B9_%D0%A1%D0%B5%D1%80%D0%B3%D0%B5%D0%B5%D0%B2%D0%B8%D1%87"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q4340844","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Vasili_Oshchepkov","cite":"DBpedia"}],"source_yaml":"database/persons/SUN/Vasili_Oshchepkov.yaml"}},{"data":{"id":"JDP-98","name":"Sergei Dashkevich","native_name":{"name":"\u0421\u0435\u0440\u0433\u0435\u044F \u0414\u0430\u0448\u043A\u0435\u0432\u0438\u0447\u0430","lang":"ru"},"nationality":["RUS","SUN"],"birth":{"date":"1896-10-18","location":"Petrodvorets","country_code":"RUS"},"death":{"date":"1955-03-17","location":"Leningrad","country_code":"SUN"},"photo":{"url":"https://archive.org/download/dashkevich/dashkevich.png","source":{"uri":"https://judo.ru/news/9889"}},"teachers":[{"id":"JDP-97","style_id":"JDP-S-1","place":null,"period":{"start":1931,"end":null},"quality":2,"sources":[{"uri":"https://judo.ru/news/9889","citation":"\u0412 1931 \u0433\u043E\u0434\u0443 \u043F\u0440\u043E\u0448\u0451\u043B \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u0435 \u0432 \u041C\u043E\u0441\u043A\u0432\u0435 \u0443 \u0440\u043E\u0434\u043E\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430 \u043E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0434\u0437\u044E\u0434\u043E \u0412\u0430\u0441\u0438\u043B\u0438\u044F \u0421\u0435\u0440\u0433\u0435\u0435\u0432\u0438\u0447\u0430 \u041E\u0449\u0435\u043F\u043A\u043E\u0432\u0430 \u043D\u0430 \u043A\u0443\u0440\u0441\u0430\u0445 \u043F\u0440\u0435\u043F\u043E\u0434\u0430\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0434\u0437\u044E\u0434\u043E \u0434\u043B\u044F \u043D\u0438\u0437\u043E\u0432\u044B\u0445 \u0437\u0430\u0432\u043E\u0434\u0441\u043A\u0438\u0445 \u0438 \u0432\u0443\u0437\u043E\u0432\u0441\u043A\u0438\u0445 \u043A\u043E\u043B\u043B\u0435\u043A\u0442\u0438\u0432\u043E\u0432"}]},{"id":"JDP-97","style_id":"JDP-S-15","place":null,"period":{"start":1931,"end":null},"quality":2,"sources":[{"uri":"https://judo.ru/news/9889","citation":"\u0412 1931 \u0433\u043E\u0434\u0443 \u043F\u0440\u043E\u0448\u0451\u043B \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u0435 \u0432 \u041C\u043E\u0441\u043A\u0432\u0435 \u0443 \u0440\u043E\u0434\u043E\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430 \u043E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0434\u0437\u044E\u0434\u043E \u0412\u0430\u0441\u0438\u043B\u0438\u044F \u0421\u0435\u0440\u0433\u0435\u0435\u0432\u0438\u0447\u0430 \u041E\u0449\u0435\u043F\u043A\u043E\u0432\u0430 \u043D\u0430 \u043A\u0443\u0440\u0441\u0430\u0445 \u043F\u0440\u0435\u043F\u043E\u0434\u0430\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0434\u0437\u044E\u0434\u043E \u0434\u043B\u044F \u043D\u0438\u0437\u043E\u0432\u044B\u0445 \u0437\u0430\u0432\u043E\u0434\u0441\u043A\u0438\u0445 \u0438 \u0432\u0443\u0437\u043E\u0432\u0441\u043A\u0438\u0445 \u043A\u043E\u043B\u043B\u0435\u043A\u0442\u0438\u0432\u043E\u0432"},{"uri":"https://turbojudo.spb.ru/news/v-den-125letiya-so-dnya-rozhdeniya-osnovopolozhnika-leningradskogo-dzyudo-sergeya-dashkevicha-sostoyalos-pamyatnoe-meropriyatie","citation":"\u0412\u0451\u043B \u0437\u0430\u043D\u044F\u0442\u0438\u044F \u0432 \u0433\u0440\u0443\u043F\u043F\u0435 \u0441\u0430\u043C\u0431\u043E, \u0433\u0434\u0435 \u0435\u0433\u043E \u0432\u043E\u0441\u043F\u0438\u0442\u0430\u043D\u043D\u0438\u043A\u043E\u043C \u0441 1952 \u0433\u043E\u0434\u0430 \u0431\u044B\u043B \u0410\u043D\u0430\u0442\u043E\u043B\u0438\u0439 \u0420\u0430\u0445\u043B\u0438\u043D."}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://judo.ru/news/9889"},{"uri":"https://turbojudo.spb.ru/news/v-den-125letiya-so-dnya-rozhdeniya-osnovopolozhnika-leningradskogo-dzyudo-sergeya-dashkevicha-sostoyalos-pamyatnoe-meropriyatie"}],"source_yaml":"database/persons/SUN/Sergei_Dashkevich.yaml"}},{"data":{"id":"JDP-101","name":"Anatoly Kharlampiyev","native_name":{"name":"\u0410\u043D\u0430\u0442\u043E\u0301\u043B\u0438\u0439 \u0410\u0440\u043A\u0430\u0301\u0434\u044C\u0435\u0432\u0438\u0447 \u0425\u0430\u0440\u043B\u0430\u0301\u043C\u043F\u0438\u0435\u0432","lang":"ru"},"nationality":["RUS","SUN"],"birth":{"date":"1906-10-29","location":"Smolensk","country_code":"RUS"},"death":{"date":"1979-04-16","location":"Moscow","country_code":"SUN"},"photo":{"url":"https://archive.org/download/kharlampiyev/kharlampiyev.jpeg","source":{"uri":"https://dzen.ru/a/YgYnw0IeDT93JdjX"}},"teachers":[{"id":"JDP-97","style_id":"JDP-S-1","place":"State Central Order of Lenin Institute of Physical Culture","period":{"start":1931,"end":null},"quality":2,"sources":[{"uri":"https://ru.wikipedia.org/wiki/%D0%A5%D0%B0%D1%80%D0%BB%D0%B0%D0%BC%D0%BF%D0%B8%D0%B5%D0%B2,_%D0%90%D0%BD%D0%B0%D1%82%D0%BE%D0%BB%D0%B8%D0%B9_%D0%90%D1%80%D0%BA%D0%B0%D0%B4%D1%8C%D0%B5%D0%B2%D0%B8%D1%87","citation":"\u0412 1936 \u0433. \u043E\u043A\u043E\u043D\u0447\u0438\u043B \u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0446\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u0440\u0434\u0435\u043D\u0430 \u041B\u0435\u043D\u0438\u043D\u0430 \u0438\u043D\u0441\u0442\u0438\u0442\u0443\u0442 \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u044B (\u043E\u0442\u0434\u0435\u043B\u0435\u043D\u0438\u0435 \u0434\u0437\u044E\u0434\u043E \u0412\u0430\u0441\u0438\u043B\u0438\u044F \u0421\u0435\u0440\u0433\u0435\u0435\u0432\u0438\u0447\u0430 \u041E\u0449\u0435\u043F\u043A\u043E\u0432\u0430)[...]\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u044F \xab\u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0441\u0430\u043C\u0431\u043E\xbb, \u0425\u0430\u0440\u043B\u0430\u043C\u043F\u0438\u0435\u0432 \u0442\u0449\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0438\u0437\u0443\u0447\u0430\u043B \u0434\u0437\u044E\u0434\u043E \u0438 \u043E\u0441\u0432\u0430\u0438\u0432\u0430\u043B \u0435\u0433\u043E \u043D\u0430 \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0435. \u0412 \u0434\u0437\u044E\u0434\u043E \u043E\u043D \u0432\u0438\u0434\u0435\u043B \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u043D\u043E\u0432\u043E\u0433\u043E \u0432\u0438\u0434\u0430 \u0431\u043E\u0440\u044C\u0431\u044B \u0432 \u043E\u0434\u0435\u0436\u0434\u0435, \u043E\u0431\u043E\u0433\u0430\u0449\u0451\u043D\u043D\u043E\u0433\u043E \u043D\u0430\u0438\u0431\u043E\u043B\u0435\u0435 \u044D\u0444\u0444\u0435\u043A\u0442\u0438\u0432\u043D\u044B\u043C\u0438 \u043F\u0440\u0438\u0451\u043C\u0430\u043C\u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u0432\u0438\u0434\u043E\u0432 \u0431\u043E\u0440\u044C\u0431\u044B. \u0414\u0437\u044E\u0434\u043E \u043E\u043D \u043E\u0441\u0432\u0430\u0438\u0432\u0430\u043B \u043F\u043E\u0434 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E\u043C \u0412\u0430\u0441\u0438\u043B\u0438\u044F \u0421\u0435\u0440\u0433\u0435\u0435\u0432\u0438\u0447\u0430 \u041E\u0449\u0435\u043F\u043A\u043E\u0432\u0430, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u043C\u043D\u043E\u0433\u043E\u043B\u0435\u0442\u043D\u0435\u0433\u043E \u043F\u0440\u0435\u0431\u044B\u0432\u0430\u043D\u0438\u044F \u0432 \u042F\u043F\u043E\u043D\u0438\u0438 \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u0430\u043B\u0441\u044F \u0432 \u0448\u043A\u043E\u043B\u0435 \u0434\u0437\u044E\u0434\u043E \u041A\u043E\u0434\u043E\u043A\u0430\u043D."}]}],"rank":[{"style_id":"JDP-S-15","org":"Soviet Union","teacher":null,"rank":"Honored Master of Sports of the USSR","date":1947,"sources":[{"uri":"https://ru.wikipedia.org/wiki/%D0%A5%D0%B0%D1%80%D0%BB%D0%B0%D0%BC%D0%BF%D0%B8%D0%B5%D0%B2,_%D0%90%D0%BD%D0%B0%D1%82%D0%BE%D0%BB%D0%B8%D0%B9_%D0%90%D1%80%D0%BA%D0%B0%D0%B4%D1%8C%D0%B5%D0%B2%D0%B8%D1%87","citation":"\u0417\u0430\u0441\u043B\u0443\u0436\u0435\u043D\u043D\u044B\u0439 \u043C\u0430\u0441\u0442\u0435\u0440 \u0441\u043F\u043E\u0440\u0442\u0430 \u0421\u0421\u0421\u0420 (1947)"}],"style":"Sambo","style_native":{"name":"\u0441a\u043C\u0431\u043E","lang":"ru"}}],"sources":[{"uri":"https://ru.wikipedia.org/wiki/%D0%A5%D0%B0%D1%80%D0%BB%D0%B0%D0%BC%D0%BF%D0%B8%D0%B5%D0%B2,_%D0%90%D0%BD%D0%B0%D1%82%D0%BE%D0%BB%D0%B8%D0%B9_%D0%90%D1%80%D0%BA%D0%B0%D0%B4%D1%8C%D0%B5%D0%B2%D0%B8%D1%87"},{"uri":"https://en.wikipedia.org/wiki/Anatoly_Kharlampiyev"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q3615112","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Anatoly_Kharlampiyev","cite":"DBpedia"}],"source_yaml":"database/persons/SUN/Anatoly_Kharlampiyev.yaml"}},{"data":{"id":"JDP-99","name":"Anatoliy Rakhlin","native_name":{"name":"\u0410\u043D\u0430\u0442\u043E\u0301\u043B\u0438\u0439 \u0421\u043E\u043B\u043E\u043C\u043E\u0301\u043D\u043E\u0432\u0438\u0447","lang":"ru"},"nationality":["SUN","RUS"],"birth":{"date":"1938-05-23","location":"Leningrad","country_code":"SUN"},"death":{"date":"2013-08-07","location":"Saint Petersburg","country_code":"RUS"},"photo":{"url":"https://archive.org/download/raxlin-5/Raxlin5.jpg","source":{"uri":"https://ekogradmoscow.ru/sreda/ekologija-kultury/sensej-dlya-prezidenta-anatolij-solomonovich-rakhlin","cite":"\u0421\u0435\u043D\u0441\u0435\u0439 \u0434\u043B\u044F \u043F\u0440\u0435\u0437\u0438\u0434\u0435\u043D\u0442\u0430 - \u0410\u043D\u0430\u0442\u043E\u043B\u0438\u0439 \u0421\u043E\u043B\u043E\u043C\u043E\u043D\u043E\u0432\u0438\u0447 \u0420\u0430\u0445\u043B\u0438\u043D (\'\u042D\u041A\u041E\u0413\u0420\u0410\u0414+\')"}},"teachers":[{"id":"JDP-98","style_id":"JDP-S-15","place":"Leningrad Palace of the Pioneers","period":{"start":1955,"end":null},"quality":2,"sources":[{"uri":"https://sambo.sport/en/news/anatoliy-rakhlin-chelovek-pedagog-trener/","citation":"In 1953 he started taking SAMBO classes in the Palace of the Pioneers under the guidance of a highly experienced wrestler S. Dashkevich, a wrestling partner of Ivan Poddubny himself.","cite":"Anatoliy Rakhlin: Person, Teacher, Coach | International SAMBO Federation (FIAS)"}]}],"rank":[{"style_id":"JDP-S-15","org":"Soviet Union","teacher":null,"rank":"Master of Sports of the USSR","date":null,"sources":[{"uri":"https://fondsambo.ru/news/detail.php?ELEMENT_ID=26984","citation":"11 \u043B\u0435\u0442 \u0437\u0430\u043D\u044F\u0442\u0438\u0439 \u0441 \u0410\u043D\u0430\u0442\u043E\u043B\u0438\u0435\u043C \u0421\u043E\u043B\u043E\u043C\u043E\u043D\u043E\u0432\u0438\u0447\u0435\u043C \u043F\u043E\u043C\u043E\u0433\u043B\u0438 \u0431\u0443\u0434\u0443\u0449\u0435\u043C\u0443 \u043F\u043E\u043B\u0438\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u043C\u0443 \u043B\u0438\u0434\u0435\u0440\u0443 \u0420\u043E\u0441\u0441\u0438\u0438 \u0441\u0442\u0430\u0442\u044C \u043C\u0430\u0441\u0442\u0435\u0440\u043E\u043C \u0441\u043F\u043E\u0440\u0442\u0430 \u0441\u043D\u0430\u0447\u0430\u043B\u0430 \u043F\u043E \u0441\u0430\u043C\u0431\u043E, \u0430 \u043F\u043E\u0442\u043E\u043C \u043F\u043E \u0434\u0437\u044E\u0434\u043E.  \u0412\u043B\u0430\u0434\u0438\u043C\u0438\u0440 \u041F\u0443\u0442\u0438\u043D \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0430\u043B \u0410\u043D\u0430\u0442\u043E\u043B\u0438\u044F \u0420\u0430\u0445\u043B\u0438\u043D\u0430 \u043D\u0430 \u0437\u043D\u0430\u0447\u0438\u043C\u044B\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F \u0441\u0432\u043E\u0435\u0439 \u0436\u0438\u0437\u043D\u0438 \u2013 \u043E\u0442 \u0434\u043D\u0435\u0439 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u0439 \u0434\u043E \u043F\u0440\u0435\u0437\u0438\u0434\u0435\u043D\u0442\u0441\u043A\u0438\u0445 \u0438\u043D\u0430\u0443\u0433\u0443\u0440\u0430\u0446\u0438\u0439. \u0422\u0430\u043A\u0438\u0435 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u044F \u043C\u043E\u0436\u043D\u043E \u0431\u0435\u0437 \u043F\u0440\u0435\u0443\u0432\u0435\u043B\u0438\u0447\u0435\u043D\u0438\u044F \u043D\u0430\u0437\u0432\u0430\u0442\u044C \u0434\u0440\u0443\u0436\u0435\u0441\u043A\u0438\u043C\u0438."}],"style":"Sambo","style_native":{"name":"\u0441a\u043C\u0431\u043E","lang":"ru"}},{"style_id":"JDP-S-1","org":null,"teacher":null,"rank":"8 dan","date":null,"sources":[{"uri":"https://sambo.sport/en/news/anatoliy-rakhlin-chelovek-pedagog-trener/","cite":"Anatoliy Rakhlin: person, teacher, coack (International Sambo Federation)","citation":"On August 7, 2013 in Saint Petersburg (Russia) after extended illness died Anatoliy Rakhlin, Honorary Coach of the Russian Federation, holder of the 8th dan rank in judo."}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://ru.wikipedia.org/wiki/%D0%A0%D0%B0%D1%85%D0%BB%D0%B8%D0%BD,_%D0%90%D0%BD%D0%B0%D1%82%D0%BE%D0%BB%D0%B8%D0%B9_%D0%A1%D0%BE%D0%BB%D0%BE%D0%BC%D0%BE%D0%BD%D0%BE%D0%B2%D0%B8%D1%87"},{"uri":"https://rus.team/people/rakhlin-anatolij-solomonovich"},{"uri":"https://sambo.sport/en/news/anatoliy-rakhlin-chelovek-pedagog-trener/","cite":"Anatoliy Rakhlin: Person, Teacher, Coach | International SAMBO Federation (FIAS)"},{"uri":"https://www.kino-teatr.ru/kino/stuntman/sov/409209/bio/"},{"uri":"https://ria.ru/20130807/954840950.html"},{"uri":"https://web.archive.org/web/20120329141858/http://www.mir-judo.ru/territory/index.php?ELEMENT_ID=1380#"},{"uri":"https://www.lechaim.ru/ARHIV/258/kadish.htm"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q15088978","cite":"Wikidata"}],"source_yaml":"database/persons/SUN/Anatoliy_Rakhlin.yaml"}},{"data":{"id":"JDP-63","name":"Nuno Delgado","aka":[{"name":"Nuno Miguel Delgado"}],"nationality":["PRT"],"birth":{"date":"1976-08-27","location":"Lisboa","country_code":"PRT"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/nuno_delgado/nuno_delgado.jpg","source":{"uri":"https://www.record.pt/jogo-da-vida/detalhe/nuno-delgado-quero-inspirar-cada-vez-mais-criancas-857704","cite":"Fernando Ferreira (in: \xabRecord\xbb, 9-XII-2013"}},"teachers":[{"id":"JDP-62","style_id":"JDP-S-1","place":"Sport Alg\xe9s e Dafundo","quality":3,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.ulisboa.pt/sites/ulisboa.pt/files/public/aluno_de_kobayashi_moldou_o_campeao.pdf","cite":"Jos\xe9 Costa Branco: Aluno de Kobayashi moldou o campe\xe3o (O Jogo, 22-II-2020)","citation":"... no hist\xf3rico Sport Alg\xe9s e Dafundo durante 28 anos. Foi l\xe1 que Jos\xe9 Costa Branco encontrou Nuno Delgado, que saiu de Santar\xe9m, onde vivia e combatia, para regressar a Lisboa e se licenciar em Ci\xeancias do Desporto"},{"uri":"https://www.record.pt/modalidades/detalhe/alges-conquista-nacional-de-seniores-por-equipas","cite":"Alg\xe9s conquista Nacional de seniores por equipas (Record, 30-IV-2001)","citation":"Quero dedicar o triunfo ao ex-treinador Jos\xe9 Branco, porque ele j\xe1 merecia este t\xedtulo no ano passado, altura em que se retirou dos tapetes, considerou Nuno Delgado, medalha de bronze em Sydney 2000."}]},{"id":"JDP-15","style_id":"JDP-S-1","place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.linkedin.com/posts/nunodelgadotpv_mestrebastosnunes-judo-portugaljudo-activity-7155564790885556225-5SnY?originalSubdomain=pt","cite":"Nuno Delgado","citation":"A par do meu Mestre Fernando Costa Matos, s\xe3o as mais altas gradua\xe7\xf5es Lusas, disc\xedpulos diretos de Kiyoshi Kobayashi, que tanto moldaram os nossos judocas, com a sua sabedoria e pedagogia"}]}],"rank":[{"style_id":"JDP-S-1","org":"FPJ","teacher":null,"rank":"3 dan","date":1982,"sources":[{"uri":"http://fpj.pt/wp-content/uploads/2017/04/17ci175-Divulga%C3%A7%C3%A3o-Evento.pdf","cite":"Circular 175/17, FPJ","citation":"Nuno Delgado - Portugal - 6\xba Dan"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://www.nunodelgado.net/nuno-delgado"},{"uri":"https://www.record.pt/jogo-da-vida/detalhe/nuno-delgado-quero-inspirar-cada-vez-mais-criancas-857704"},{"uri":"https://pt.wikipedia.org/wiki/Nuno_Delgado"},{"uri":"https://en.wikipedia.org/wiki/Nuno_Delgado"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q1884969","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Kan%C5%8D_Jigor%C5%8D","cite":"https://dbpedia.org/page/Nuno_Delgado"}],"source_yaml":"database/persons/PRT/Nuno_Delgado.yaml"}},{"data":{"id":"JDP-88","name":"M\xe1rio Aguilar","nationality":["PRT"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/mario_aguilar/mario_aguilar.jpg","source":{"uri":"https://www.facebook.com/CDMaristaCarcavelos/photos/a.122820509363828/125020709143808/?type=3","cite":"Clube Desportivo Marista de Carcavelos (Facebook)"}},"teachers":[{"id":"JDP-61","style_id":"JDP-S-1","place":"Judo Clube do Estoril","quality":2,"period":{"start":1981,"end":1982},"sources":[{"uri":"https://github.com/Judo-Documentation-Project/budotree","cite":"M\xe1rio Aguilar, private communication, 2021","citation":"... os meus mestres por ordem cronol\xf3gica foram: (...) Ant\xf3nio Roquete (...) no Judo Clube do Estoril - 1 ano"}]},{"id":"JDP-128","style_id":"JDP-S-1","place":"Academia Petrucio Monteiro","quality":3,"period":{"start":1980,"end":1981},"sources":[{"uri":"https://github.com/Judo-Documentation-Project/budotree","cite":"M\xe1rio Aguilar, private communication, 2021","citation":"... os meus mestres por ordem cronol\xf3gica foram: (...) Mestre Petr\xfacio Monteiro (Brasil) - 1980 a 1981 e meio"}]}],"rank":[{"style_id":"JDP-S-1","org":"FPJ","teacher":null,"rank":"2 dan","date":null,"sources":[{"uri":"https://github.com/Judo-Documentation-Project/budotree","cite":"M\xe1rio Aguilar, private communication, 2021"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://www.facebook.com/CDMaristaCarcavelos/photos/a.122820509363828/125020709143808/?type=3"},{"uri":"https://cdmc.marista-carcavelos.org/judo/"}],"source_yaml":"database/persons/PRT/Mario_Aguilar.yaml"}},{"data":{"id":"JDP-75","name":"Manuel Reis","aka":[{"name":"Manuel Pereira de Matos Reis"}],"nationality":["PRT"],"birth":{"date":"1922-07-23","location":null,"country_code":"PRT"},"death":{"date":"2005-11-23","location":null,"country_code":null},"photo":{"url":"https://archive.org/download/manuel_reis/manuel_reis.png","source":{"uri":"http://clubejudoporto.weebly.com/os-nossos-fundadores.html"}},"teachers":[{"id":"JDP-74","style_id":"JDP-S-1","place":"Clube de Judo do Porto","quality":2,"period":{"start":1968,"end":1969},"sources":[{"uri":"https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf","cite":"Manual de Gradua\xe7\xf5es e Regulamento de Gradua\xe7\xf5es. Federa\xe7\xe3o Portuguesa de Judo (Dezembro 2020)","citation":"Em 1968, ao abrigo do Fundo de Fomento Desportivo, chega ao Porto o jovem Mestre japon\xeas, de 26 anos, Nabuaki Yamamoto, 5\xba Dan, aluno do Kodokan e antigo campe\xe3o universit\xe1rio do Jap\xe3o, tornando-se professor do Clube de Judo do Porto. No in\xedcio de 1969, o Mestre Yamamoto parte para a Isl\xe2ndia e as aulas voltam a ser ministradas pelos judocas mais graduados, que contavam agora com o apoio muito espor\xe1dico de alguns elementos da Federa\xe7\xe3o Portuguesa de Judo"},{"uri":"https://judomagazine.pt/2023/05/16/entrevista-viagem-ao-mundo-dos-homens-bons-2/","citation":"Fernando Costa Matos encontrou-se com um dos mais antigos praticantes do judo em Portugal, Manuel Reis, que j\xe1 tinha trazido o japon\xeas Yamamoto nos anos 60 para orientar o clube e que aceitou de bom grado a vinda de Frigyes Torok para a dire\xe7\xe3o t\xe9cnica do tradicional clube da cidade Invicta."}]},{"id":"JDP-76","style_id":"JDP-S-14","place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"http://clubejudoporto.weebly.com/os-nossos-fundadores.html","citation":"...Manuel Reis fora aluno de  Armando Gon\xe7alves, um portuense Professor de Ju-Jutsu \u67D4\u8853..."}]},{"id":"JDP-78","style_id":"JDP-S-1","place":"C\xedrculo de Judo do Porto","quality":2,"period":{"start":1955,"end":1965},"sources":[{"uri":"https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf","cite":"Manual de Gradua\xe7\xf5es e Regulamento de Gradua\xe7\xf5es. Federa\xe7\xe3o Portuguesa de Judo (Dezembro 2020)","citation":"Em 1955, os judocas do Porto organizados em torno do professor Jackie Hugnet, criam o C\xedrculo de Judo do Porto, onde Hugnet foi professor durante sete anos, lecionando tr\xeas vezes por semana a primeira classe em que o Judo Kodokan foi ministrado de forma sistem\xe1tica no Porto. Os professores Hugnet e Manuel Reis foram instrutores de Judo da Pol\xedcia de Seguran\xe7a P\xfablica do Porto, durante cerca de dois anos meio, coincidentes com parte do per\xedodo em que o Comandante da corpora\xe7\xe3o era o famoso Chefe Santos J\xfanior."},{"uri":"http://clubejudoporto.weebly.com/os-nossos-fundadores.html","citation":"Este, impressionado com a determina\xe7\xe3o de Manuel Reis mas sem disponibilidade para ficar em Portugal, enviou para o C\xedrculo de Judo do Porto o seu irm\xe3o Jackie Hugnet, 2\xba Dan de Judo, que connosco permaneceu por uma d\xe9cada"}]},{"id":"JDP-79","style_id":"JDP-S-1","place":"C\xedrculo de Judo do Porto","quality":2,"period":{"start":1961,"end":1963},"sources":[{"uri":"https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf","cite":"Manual de Gradua\xe7\xf5es e Regulamento de Gradua\xe7\xf5es. Federa\xe7\xe3o Portuguesa de Judo (Dezembro 2020)","citation":"No Ver\xe3o de 1961, o professor Hugnet \xe9 substitu\xeddo pelo tamb\xe9m franc\xeas, Gilbert Bryskine, 4\xba Dan, campe\xe3o de Fran\xe7a, bicampe\xe3o da Europa (1952 e 1954) e professor diplomado pela Federa\xe7\xe3o Francesa de Judo e Ju Jutsu. \xc9 com Bryskine que os atletas do C\xedrculo come\xe7am a participar em provas federativas, quer individualmente, quer por equipas. Em 1963, Gilbert Bryskine regressou a Fran\xe7a devido a um grave acidente de autom\xf3vel que o deixou incapacitado."},{"uri":"http://clubejudoporto.weebly.com/os-nossos-fundadores.html","citation":"Na \xe9poca, recebemos tamb\xe9m os ensinamento de outro franc\xeas, Gilbert Briskine, 4\xba Dan de Judo e mestre de Karat\xe9-Do \u7A7A\u624B\u9053, Disciplina a quem a divulga\xe7\xe3o em Portugal muito deve."}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"http://clubejudoporto.weebly.com/os-nossos-fundadores.html"},{"uri":"https://www.jpn.up.pt/2015/04/21/clube-judo-do-porto-50-anos-continua-jovem/"},{"uri":"https://judomagazine.pt/2023/05/16/entrevista-viagem-ao-mundo-dos-homens-bons-2/"},{"uri":"https://judolandia.tripod.com/histport.htm"}],"source_yaml":"database/persons/PRT/Manuel_Reis.yaml"}},{"data":{"id":"JDP-82","name":"Lu\xeds Franco Pires Martins","nationality":["PRT"],"birth":{"date":"1925","location":null,"country_code":null},"death":{"date":"2003","location":null,"country_code":null},"photo":{"url":"https://archive.org/download/piresmartins1965/piresmartins1965.jpg","source":{"uri":"https://www.ubu.pt/home/professores/dr-luis-franco-pires-martins/","cite":"Dr. Lu\xeds Franco Pires Martins (1925-2003) - UBU"}},"teachers":[{"id":"JDP-83","style_id":"JDP-S-1","place":"Academia de Budo","quality":1,"period":{"start":1951,"end":null},"sources":[{"uri":"https://repositorio.ipv.pt/handle/10400.19/448","cite":"FIGUEIREDO, Abel Aur\xe9lio Abreu. A institucionaliza\xe7\xe3o do karat\xe9-os modelos organizacionais do karat\xe9 em Portugal. 2006. PhD Thesis. Instituto Politecnico de Viseu (Portugal)","citation":"(...)Al\xe9m de ser o primeiro cinto negro inscrito no Kodokan (Jap\xe3o), Corr\xeaa Pereira \xe9 o primeiro editor de revistas de Judo Kodokan (...) o Dr. Jo\xe3o Lu\xeds Franco Pires Martins refere que por volta de 1946 \xe9 que se iniciou a pr\xe1tica de Judo na Academia de Judo, sendo a\xed que ele inicia a pr\xe1tica de Judo, em 1951"}]}],"rank":[{"style_id":"JDP-S-5","org":"UBU","teacher":null,"rank":"1 dan","date":"1963-09-10","sources":[{"uri":"https://repositorio.ipv.pt/handle/10400.19/448","cite":"FIGUEIREDO, Abel Aur\xe9lio Abreu. A institucionaliza\xe7\xe3o do karat\xe9-os modelos organizacionais do karat\xe9 em Portugal. 2006. PhD Thesis. Instituto Politecnico de Viseu (Portugal)","citation":"sendo mesmo a data da sua gradua\xe7\xe3o de 1\xba dan atribu\xedda pela UBU, ou seja por Corr\xeaa Pereira, um dos primeiros marcos de institucionaliza\xe7\xe3o do Karat\xe9 em Portugal, pelo que 10 de Setembro de 1963 poder\xe1 ser simbolicamente a data de in\xedcio da \xab\xe9poca\xbb do Karat\xe9 Portugu\xeas. Note-se ainda que essa gradua\xe7\xe3o, apesar de ser institucional e sem o v\xednculo directo de um mestre ou organiza\xe7\xe3o japonesa, tem algum reconhecimento posterior quando em 1971 a FAJKO (Federation of All Japan Karatedo Organizations) atribui a gradua\xe7\xe3o honor\xedfica de 4\xba dan a Pires Martins"}],"style":"Karate","style_native":{"name":"\u7A7A\u624B","lang":"ja"}},{"style_id":"JDP-S-5","org":"FAJKO","teacher":null,"rank":"1 dan","date":"1971-12-15","sources":[{"uri":"https://repositorio.ipv.pt/handle/10400.19/448","cite":"FIGUEIREDO, Abel Aur\xe9lio Abreu. A institucionaliza\xe7\xe3o do karat\xe9-os modelos organizacionais do karat\xe9 em Portugal. 2006. PhD Thesis. Instituto Politecnico de Viseu (Portugal)","citation":"sendo mesmo a data da sua gradua\xe7\xe3o de 1\xba dan atribu\xedda pela UBU, ou seja por Corr\xeaa Pereira, um dos primeiros marcos de institucionaliza\xe7\xe3o do Karat\xe9 em Portugal, pelo que 10 de Setembro de 1963 poder\xe1 ser simbolicamente a data de in\xedcio da \xab\xe9poca\xbb do Karat\xe9 Portugu\xeas. Note-se ainda que essa gradua\xe7\xe3o, apesar de ser institucional e sem o v\xednculo directo de um mestre ou organiza\xe7\xe3o japonesa, tem algum reconhecimento posterior quando em 1971 a FAJKO (Federation of All Japan Karatedo Organizations) atribui a gradua\xe7\xe3o honor\xedfica de 4\xba dan a Pires Martins"}],"style":"Karate","style_native":{"name":"\u7A7A\u624B","lang":"ja"}}],"sources":[{"uri":"https://www.ubu.pt/home/professores/dr-luis-franco-pires-martins/"},{"uri":"https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm"},{"uri":"https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_17-22.pdf"},{"uri":"https://repositorio.ipv.pt/handle/10400.19/448"},{"uri":"https://mestremanuelceia.webnode.pt/memorias/"},{"uri":"http://pks.pt/ROP1.php"}],"notes":"As rela\xe7\xf5es de aprendizagem entre os membros fundadores da UBU n\xe3o\\ns\xe3o claras, provavelmente apenas por n\xe3o serem t\xf3pico que \xe9\\nexpressamente dito nas fontes, mas tamb\xe9m provavelmente pela\\ndin\xe2mica de grande voluntarismo e inova\xe7\xe3o que caracterizam uma\\norganiza\xe7\xe3o que foi pioneira. Uma leitura transversal das v\xe1rias\\nfontes apontam para rela\xe7\xf5es de aprendizagem m\xfatua, com posterior\\nvalida\xe7\xe3o/homologa\xe7\xe3o em alguns casos (como no do Karate).  Assim,\\na identifica\xe7\xe3o das rela\xe7\xf5es aluno/professor provavelmente\\ndemonstrar\xe3o uma rela\xe7\xe3o em rede, sendo que a figura de Corr\xeaa\\nPereira se apresenta como agregadora, mesmo n\xe3o sendo na maior\\nparte das vezes claro a influ\xeancia directa (em termos de treino)\\nque existiu, em especial a partir do final dos anos 50.  Isto \xe9\\nparticularmente aplic\xe1vel ao Judo (e jujutsu), visto que para o\\nAikido e Karate a evolu\xe7\xe3o posterior na UBU permitem leituras mais\\nconcretas. Sobre o Judo, antes de Shirooka n\xe3o \xe9 claro quem faz a\\ninstru\xe7\xe3o, assumindo-se que Corr\xeaa Pereira \xe9 uma das fontes (e.g.,\\na demonstra\xe7\xe3o com Sebasti\xe3o Dur\xe3o).\\n","source_yaml":"database/persons/PRT/Lu\xeds_Pires_Martins.yaml"}},{"data":{"id":"JDP-85","name":"Leopoldo Ferreira","aka":[{"name":"Leopoldo Ant\xf3nio Serra Ferreira"}],"nationality":["PRT"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":"2014-01-06","location":null,"country_code":null},"photo":{"url":"https://archive.org/download/leopoldo_ferreira/leopoldo_ferreira.jpg","source":{"uri":"https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm","cite":"Entrevista ao Professor Leopoldo Ferreira (Pedro Escudeiro, 2000 - Archived)"}},"teachers":[{"name":"JDP-87","style_id":"JDP-S-4","place":"Academia de Budo","quality":3,"period":{"start":1971,"end":1972},"sources":[{"uri":"https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm","cite":"Entrevista ao Professor Leopoldo Ferreira (Pedro Escudeiro, 2000 - Archived)","citation":"N\xe3o, eu s\xf3 comecei a praticar em 1971, mais precisamente a 30 de Dezembro de 1971, quinta-feira, \xe0s 18.30h (Risos), na Academia de Budo, com Misao Honda (...) Eu s\xf3 conheci o Mestre Stobbaerts, em Agosto ou Setembro de 1972, pelo simples motivo que quando o Honda se foi embora, como eu era o aluno mais graduado, e tamb\xe9m porque era estudante de Educa\xe7\xe3o F\xedsica, o Dr. Pires Martins insistiu para que eu ficasse a dar as aulas de Aikido"}]},{"id":"JDP-86","style_id":"JDP-S-4","place":"Budokai Cascais","quality":3,"period":{"start":1972,"end":1976},"sources":[{"uri":"https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm","cite":"Entrevista ao Professor Leopoldo Ferreira (Pedro Escudeiro, 2000 - Archived)","citation":" Eu s\xf3 conheci o Mestre Stobbaerts, em Agosto ou Setembro de 1972 (...) Portanto, durante anos, os meus fins-de-semana eram passados em Cascais a praticar Aikido. Pratiquei com o Mestre Stobbaerts talvez uns tr\xeas ou quatro anos."},{"uri":"https://web.archive.org/web/20081021195508/http://www.cao.pt/surya/pe_17_1.htm","cite":"Entrevista ao Professor Georges Stobbaerts (Pedro Escudeiro, 2000 - Archived)","citation":"Nessa altura o ambiente no Aikido era muito bom, toda a gente praticava com toda gente, mesmo os alunos da escola do Kobayashi, como o Leopoldo Ferreira, que chegou a ser meu aluno."}]}],"rank":[{"style_id":"JDP-S-4","org":"UBU","teacher":null,"rank":"Yudansha","date":null,"sources":[{"uri":"https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm","cite":"Entrevista ao Professor Leopoldo Ferreira (Pedro Escudeiro, 2000 - Archived)","citation":" O meu nome \xe9 Leopoldo Ant\xf3nio Serra Ferreira, tenho 48 anos e sou cinto negro de Aikido da Uni\xe3o Portuguesa de Budo. (...) Na Uni\xe3o Portuguesa de Budo n\xe3o temos gradua\xe7\xf5es. A gradua\xe7\xe3o mais elevada \xe9 o cinto negro, a partir da\xed acabaram-se os exames. N\xe3o existe 2\xba, 3\xba dan., etc."}],"style":"Aikid\u014D","style_native":{"name":"\u5408\u6C17\u9053","lang":"ja"}}],"sources":[{"uri":"https://www.ubu.pt/home/professores/mestre-luis-fernando/"},{"uri":"https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm"},{"uri":"https://www.fpaikido.pt/sites/default/files/docs/HistoPt%20-%20atualizacao%20MSendim.pdf"}],"source_yaml":"database/persons/PRT/Leopoldo_Ferreira.yaml"}},{"data":{"id":"JDP-62","name":"Jos\xe9 Costa Branco","aka":[{"name":"Jos\xe9 Branco"},{"name":"Jos\xe9 da Costa Branco"}],"nationality":["PRT"],"birth":{"date":"1937-03-13","location":"Louren\xe7o Marques","country_code":"MOZ"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/screenshot-from-2024-02-13-15-42-24/jose_branco.png","source":{"uri":"https://delagoabay.wordpress.com/2011/01/16/jose-branco-olimpico-e-campeao-de-judo-e-de-tiro/","cite":"Di\xe1rio de Lisboa, 1980 (in: The Delagoa Bay Company)"}},"teachers":[{"id":"JDP-12","style_id":"JDP-S-1","place":"Judo Clube de Portugal","quality":null,"period":{"start":1975,"end":null},"sources":[{"uri":"https://judomagazine.pt/2021/07/04/1980-moscovo/","cite":"Jos\xe9 Branco n\xe3o boicotou o seu sonho (Judo Magazine)","citation":"O judo passou a ser central na sua vida que tinha levado uma volta muito grande. No Judo Clube de Portugal teve por mestre Kiyoshi Kobayashi e os seus colegas de clube passaram a ser os seus amigos para todos os momentos da vida quotidiana."},{"uri":"https://delagoabay.wordpress.com/2011/01/16/jose-branco-olimpico-e-campeao-de-judo-e-de-tiro/","cite":"Jos\xe9 Branco, Ol\xedmpico e Campe\xe3o de Tiro e Judo (The Delagoa Bay Company blog)","citation":"Ao lado de jos\xe9 branco, um amigo muito especial , mestre Kobayaschi . Refere o Jos\xe9: no per\xedodo mais dif\xedcil da minha vida, ent\xe3o com 22 anos, quando me encontrava completamente atolado, foi o \xfanico que me lan\xe7ou a m\xe3o. No \xfaltimo segundo da minha vida, ele far\xe1 parte dos meus pensamentos."}]}],"rank":[{"style_id":"JDP-S-1","org":"FPJ","teacher":null,"rank":"3 dan","date":1982,"sources":[{"uri":"https://search.worldcat.org/title/817030285?oclcNum=817030285","cite":"Judo: da inicia\xe7\xe3o \xe0 competi\xe7\xe3o (1983), p. 23","citation":"1982: (...) Jos\xe9 Branco: 3\xba Dan . J. C. Portugal"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://judomagazine.pt/2021/07/04/1980-moscovo/"},{"uri":"https://delagoabay.wordpress.com/2011/01/16/jose-branco-olimpico-e-campeao-de-judo-e-de-tiro/"},{"uri":"https://archive.is/cMx9V"}],"source_yaml":"database/persons/PRT/Jos\xe9_Costa_Branco.yaml"}},{"data":{"id":"JDP-80","name":"Jos\xe9 Ara\xfajo","aka":[{"name":"Jos\xe9 Manuel da Silva Ara\xfajo"}],"nationality":["PRT"],"birth":{"date":"1955","location":"Lisboa","country_code":"PRT"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/luis-araujo/Luis_Araujo.png","source":{"uri":"https://aikidomdc.wixsite.com/brpd/untitled-c1eb9","cite":"Aikido Marcial D\xf4jo Clube - Mestre Jos\xe9 Ara\xfajo"}},"teachers":[{"id":"JDP-81","style_id":"JDP-S-5","place":"Academia de Budo","quality":3,"period":{"start":1966,"end":null},"sources":[{"uri":"https://aikidomdc.wixsite.com/brpd/untitled-c1eb9","cite":"Aikido Marcial D\xf4jo Clube - Mestre Jos\xe9 Ara\xfajo","citation":"Inicia a pr\xe1tica do Aikido e Karatedo em 1966, na Academia de Budo, com a idade de 10 anos, sendo seus professores Carlos Pereira, aluno de Mestre Georges Stobbaerts, e Fragoso Fernandes, aluno de Pires Martins, introdutor do Karatedo em Portugal."},{"uri":"https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm","cite":"Entrevista ao Professor Jos\xe9 Ara\xfajo (Pedro Escudeiro, 2000 - Archived)","citation":"O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o respons\xe1vel pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem s\xe9ria, rigorosa e profundamente empenhada."}]},{"id":"JDP-84","style_id":"JDP-S-4","place":"Academia de Budo","quality":3,"period":{"start":1966,"end":null},"sources":[{"uri":"https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm","cite":"Entrevista ao Professor Jos\xe9 Ara\xfajo (Pedro Escudeiro, 2000 - Archived)","citation":"O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o respons\xe1vel pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem s\xe9ria, rigorosa e profundamente empenhada."}]},{"id":"JDP-85","style_id":"JDP-S-4","place":"Academia de Budo","quality":3,"period":{"start":1973,"end":null},"sources":[{"uri":"https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm","cite":"Entrevista ao Professor Jos\xe9 Ara\xfajo (Pedro Escudeiro, 2000 - Archived)","citation":"Foi o Leopoldo Ferreira (...) Mas quem ficou na Academia, em perman\xeancia, a dar aulas de Aikido foi o Leopoldo Ferreira."},{"uri":"https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm","cite":"Entrevista ao Professor Leopoldo Ferreira (Pedro Escudeiro, 2000 - Archived)","citation":"Quando o Jos\xe9 Ara\xfajo recome\xe7ou a praticar j\xe1 estava eu a dar aulas, portanto, foi por volta de 1973, creio."}]}],"rank":[{"style_id":"JDP-S-4","org":"UBU","teacher":null,"rank":"7 dan","date":null,"sources":[{"uri":"https://www.ubu.pt/home/professores/prof-doutor-jose-manuel-araujo/","citation":"7\xba Dan Aikido UBU"}],"style":"Aikid\u014D","style_native":{"name":"\u5408\u6C17\u9053","lang":"ja"}},{"style_id":"JDP-S-4","org":"Dai Nippon Butokukai","teacher":null,"rank":"Renshi","date":null,"sources":[{"uri":"https://www.ubu.pt/home/professores/prof-doutor-jose-manuel-araujo/","citation":"6\xba Dan Aikido Dai Nippon Butokukai \u2013 Renshi"}],"style":"Aikid\u014D","style_native":{"name":"\u5408\u6C17\u9053","lang":"ja"}},{"style_id":"JDP-S-1","org":"IMAF","teacher":null,"rank":"Kyoshi","date":null,"sources":[{"uri":"https://www.ubu.pt/home/professores/prof-doutor-jose-manuel-araujo/","citation":"6\xba Dan Aikido \u2013 International Martial Arts Federation \u2013 Kyoshi"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://www.ubu.pt/home/professores/prof-doutor-jose-manuel-araujo/"},{"uri":"https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm"}],"source_yaml":"database/persons/PRT/Jos\xe9_Ara\xfajo.yaml"}},{"data":{"id":"JDP-64","name":"Henrique Nunes","aka":[{"name":"Henrique Carinhas Martins Nunes"}],"nationality":["PRT"],"birth":{"date":"1948-03-28","location":"Benguela","country_code":"AGO"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/henrique_nunes/henrique_nunes.jpeg","source":{"uri":"https://www.fpj.pt/wp-content/uploads/2019/03/19ci052-Divulga\xe7\xe3o-de-Eventos.pdf","cite":"Divulga\xe7\xe3o de Eventos (FPJ)"}},"teachers":[{"id":"JDP-12","style_id":"JDP-S-1","place":"Judo Clube de Portugal","quality":3,"period":{"start":1959,"end":null},"sources":[{"uri":"https://judomagazine.pt/2023/03/19/reportagem-no-santuario-com-henrique-nunes-1/","cite":"No \xabsantu\xe1rio\xbb com Henrique Nunes (Judo Magazine)","citation":"\xabAli em frente \xe9 a \xe1rea reservada ao meu Mestre, \xe0 pessoa que mais admiro e de quem tenho imensas saudades\xbb adiantou o nosso anfitri\xe3o sinalizando uma grande fotografia de Kiyoshi Kobayashi, aquela que \xe9 marca global do japon\xeas que desde 1958 referencia o judo nacional em todas as suas dimens\xf5es, t\xe9cnicas, culturais, profissionais e at\xe9 institucionais. Ao lado uma fotografia datada de 1966 com Henrique Nunes a receber de KK uma medalha de campe\xe3o nacional, uma das muitas, ao ponto de ser dif\xedcil recordar-se de todas."},{"uri":"https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=381","cite":"Seis hist\xf3rias \xe0 volta do Tatami _ Gala 60\xba Anivers\xe1rio FPJ","citation":"... o mestre Kobayashi em Portugal, em \'58 (...) foi o meu mestre."}]},{"id":"JDP-65","style_id":"JDP-S-1","place":"Judo Clube de Portugal","quality":3,"period":{"start":1954,"end":null},"sources":[{"uri":"https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=381","cite":"Seis hist\xf3rias \xe0 volta do Tatami _ Gala 60\xba Anivers\xe1rio FPJ","citation":"...Tive \xf3ptimos professores no princ\xedpio. Era o Comandante Afonso Henriques Maia Loureiro, era o dr. Nuno Ribeiro..."}]}],"rank":[{"style_id":"JDP-S-1","org":"FPJ","teacher":null,"rank":"8 dan","date":"2019-07-12","sources":[{"uri":"https://www.fpj.pt/wp-content/uploads/2020/06/Relat%C3%B3rio-Anual-FPJ-2019-23jun2020.pdf","cite":"Relat\xf3rio Anual FPJ 2019","citation":"Henrique Nunes (...) 8\xba Dan"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://judomagazine.pt/2023/03/19/reportagem-no-santuario-com-henrique-nunes-1/"},{"uri":"https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=381"},{"uri":"https://judolandia.tripod.com/hnunes.htm"}],"source_yaml":"database/persons/PRT/Henrique_Nunes.yaml"}},{"data":{"id":"JDP-81","name":"Fragoso Fernandes","aka":[{"name":"Ant\xf3nio Luis Rivara Fragoso Fernandes"}],"nationality":["PRT"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"teachers":[{"id":"JDP-82","style_id":"JDP-S-5","place":"Academia de Budo","quality":3,"period":{"start":1966,"end":null},"sources":[{"uri":"https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_17-22.pdf","cite":"ARA\xdaJO, Jos\xe9, O Dr. Pires Martins e a Uni\xe3o Portuguesa de Budo. In: A G\xe9nese do Karat\xe9 em Portugal","citation":"Guardo ainda a imagem das minhas primeiras aulas de Karate-do, orientadas por essa extraordin\xe1ria \uFB01gura que era o Doutor Fragoso Fernandes, para mim, naquela \xe9poca, a incarna\xe7\xe3o das virtudes f\xedsicas, t\xe9cnicas e morais do Budoka (...)  Aluno desde o primeiro dia do Dr. Pires Martins, transp\xf4s para o contacto com os alunos que se iniciavam a sua vis\xe3o, como tive desde ent\xe3o o ensejo de con\uFB01rmar"},{"uri":"https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm","cite":"Entrevista ao Professor Jos\xe9 Ara\xfajo (Pedro Escudeiro, 2000 - Archived)","citation":"O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o respons\xe1vel pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem s\xe9ria, rigorosa e profundamente empenhada."}]}],"rank":[{"style_id":"JDP-S-4","org":"UBU","teacher":null,"rank":"1 dan","date":"1968-08-14","sources":[{"uri":"https://www.fnkp.pt/wp-content/uploads/2020/06/ProgramaForma__o2012-2015_-_Passado_e_Futuro_dos_Treinadores_de_Karate_-_Abel_Figueiredo.pdf","cite":"50 Anos da carreira de treinador de Karate em Portugal (Federa\xe7\xe3o Nacional de Karate)","citation":"Ant\xf3nio Luiz Rivara Fragoso Fernandes -  14-08-68 - 1\xba Dan"}],"style":"Aikid\u014D","style_native":{"name":"\u5408\u6C17\u9053","lang":"ja"}}],"sources":[{"uri":"https://www.ubu.pt/home/professores/prof-doutor-antonio-fragoso-fernandes/"},{"uri":"https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm"},{"uri":"https://sites.google.com/campus.ul.pt/df-flul/professores/mem%C3%B3ria"}],"source_yaml":"database/persons/PRT/Fragoso_Fernandes.yaml"}},{"data":{"id":"JDP-87","name":"Fernando Seabra","nationality":["PRT"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/fernando_seabra/fernando_seabra.png","source":{"uri":"https://judomagazine.pt/2024/01/23/mestre-ze-manel/","cite":"Mestre Z\xe9 Manel (Judo MAGAZINE, 2024)"}},"teachers":[{"id":"JDP-16","style_id":"JDP-S-1","place":"Judo Clube de Sintra - Judokai","quality":2,"period":{"start":1980,"end":null},"sources":[{"uri":"https://judomagazine.pt/2024/01/23/mestre-ze-manel/","citation":"Foi com o \xabMestre Z\xe9 Manel\xbb, como carinhosamente os alunos mais chegados se atreviam a trat\xe1-lo, que iniciei a minha pr\xe1tica do Judo no Judo Clube de Sintra \u2013 Judokai, no Cac\xe9m, em 1980, e foi essencialmente com Ele que aprendi grande parte do pouco que hoje sei neste meu percurso pelo Judo"}]}],"rank":[{"style_id":"JDP-S-1","org":"FPJ","teacher":null,"rank":"5 dan","date":"2017-01-13","sources":[{"uri":"https://fpj.pt/wp-content/uploads/2018/01/18ci019-Exames-Nacionais-Gradua%C3%A7%C3%A3o-Resultados.pdf","cite":"Exames Nacionais de Gradua\xe7\xe3o - Resultados (FPJ, 13-1-2017)","citation":"Exames para 5\xba DAN (...) Fernando Seabra (...) APROVADO"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://www.judokai.pt/judokai/mestres-treinadores-e-graduados/"},{"uri":"https://site.judototal.com/seccao/treinadores-e-cintos-negros"},{"uri":"https://judobeirainterior.blogspot.com/2011/04/"}],"source_yaml":"database/persons/PRT/Fernando_Seabra.yaml"}},{"data":{"id":"JDP-73","name":"Fernando Sarmento","aka":[{"name":"Fernando Duarte Sarmento"}],"nationality":["PRT"],"birth":{"date":"1950","location":"Maia","country_code":"PRT"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/franciso_sarmento/fernando_sarmento.jpg","source":{"uri":"http://escolamurakamimaia.weebly.com/fernando-sarmento.html","cite":"Fernando Duarte Sarmento (Escola Murakami da Maia)"}},"teachers":[{"id":"JDP-74","style_id":"JDP-S-1","place":"Clube de Judo do Porto","quality":3,"period":{"start":1968,"end":1969},"sources":[{"uri":"http://escolamurakamimaia.weebly.com/fernando-sarmento.html","cite":"Fernando Duarte Sarmento (Escola Murakami da Maia)","citation":"Inicia o seu percurso nas \xabArtes Marciais\xbb em 1968 como praticante de Judo no Clube de Judo do Porto (Rua Duque de Loul\xe9), treinando sob a orienta\xe7\xe3o directa do Mestre Nobuaki Yamamoto (5\xba Dan)"}]},{"id":"JDP-72","style_id":"JDP-S-4","place":"Mussubi Escola de Aikido","quality":3,"period":{"start":2006,"end":null},"sources":[{"uri":"http://escolamurakamimaia.weebly.com/fernando-sarmento.html","cite":"Fernando Duarte Sarmento (Escola Murakami da Maia)","citation":"A 17 de Mar\xe7o de 2006 inicia a pr\xe1tica do Aikido na Mussubi Escola de Aikido / Takemusu Aiki Portugal sob a direc\xe7\xe3o t\xe9cnico-pedag\xf3gica do Mestre Carlos Portas, com quem continua a praticar regularmente at\xe9 ao presente momento. \xc9 graduado por Carlos Portas em 1\xba Dan a 11 de Agosto de 2007 e 2\xba Dan em 8 de Agosto de 2009."}]}],"rank":[{"style_id":"JDP-S-4","org":"Aikikai","teacher":null,"rank":"2 dan","date":2009,"sources":[{"uri":"http://escolamurakamimaia.weebly.com/fernando-sarmento.html","cite":"Fernando Duarte Sarmento (Escola Murakami da Maia)","citation":"A 17 de Mar\xe7o de 2006 inicia a pr\xe1tica do Aikido na Mussubi Escola de Aikido / Takemusu Aiki Portugal sob a direc\xe7\xe3o t\xe9cnico-pedag\xf3gica do Mestre Carlos Portas, com quem continua a praticar regularmente at\xe9 ao presente momento. \xc9 graduado por Carlos Portas em 1\xba Dan a 11 de Agosto de 2007 e 2\xba Dan em 8 de Agosto de 2009."}],"style":"Aikid\u014D","style_native":{"name":"\u5408\u6C17\u9053","lang":"ja"}}],"sources":[{"uri":"https://sportmagazine.pt/carlos-portas-a-pratica-e-a-evolucao-do-aikido-em-aveiro-temos-que-nos-reinventar/"},{"uri":"https://aikidomdc.wixsite.com/brpd/untitled-c1nrv"},{"uri":"https://web.archive.org/web/20081021192343/http://www.cao.pt/surya/pe_12_1.htm"}],"source_yaml":"database/persons/PRT/Fernando_Sarmento.yaml"}},{"data":{"id":"JDP-15","name":"Fernando Costa Matos","nationality":["PRT"],"birth":{"date":"1941-04-01","location":"Ponta Delgada","country_code":"PRT"},"death":{"date":null,"location":null,"country_code":null},"photo_url":"https://ia800306.us.archive.org/5/items/costamatos/costamatos1.jpg","teachers":[{"id":"JDP-12","style_id":"JDP-S-1","place":"INEF","quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.facebook.com/ipatj/photos/a.243433975668608/1073113529367311/?type=3&locale=pt_PT","cite":"Renato Santos Kobayashi, in Instituto Portugu\xeas de Artes Tradicionais Japonesas - Facebook","citation":"Em 1958 o Mestre K.K. assinou ent\xe3o um contrato para ficar em Portugal por um per\xedodo de dois anos. Nesta sequ\xeancia, aceita o convite para integrar o corpo docente do ent\xe3o Instituto Nacional de Educa\xe7\xe3o F\xedsica (INEF), onde lecionou durante dez anos (...)  Destaca-se o nome do Fernando Costa Matos, atleta ol\xedmpico que iniciou o Judo no INEF em 1959 e em 1964 participou pela 1.\xaa vez nos J. Ol\xedmpicosde T\xf3quio."}]},{"id":"JDP-12","style_id":"JDP-S-1","place":"Judo Clube de Portugal","quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://web.archive.org/web/20240212151508/https://www.linkedin.com/posts/nunodelgadotpv_mestrebastosnunes-judo-portugaljudo-activity-7155564790885556225-5SnY/?originalSubdomain=pt","cite":"Nuno Delgado LinkedIn post","citation":"O Mestre Bastos Nunes, juntou-se ao seu querido Mestre Kobayashi que serviu com verdadeira alma Samurai, \xablinha dura\xbb como dizia sempre. A par do meu Mestre Fernando Costa Matos, s\xe3o as mais altas gradua\xe7\xf5es Lusas, disc\xedpulos diretos de Kiyoshi Kobayashi, que tanto moldaram os nossos judocas, com a sua sabedoria e pedagogia."}]}],"rank":[{"style_id":"JDP-S-1","org":"Federa\xe7\xe3o Portuguesa de Judo","teacher":null,"rank":"9 dan","date":2019,"sources":[{"uri":"https://www.fpj.pt/wp-content/uploads/2020/03/20ci057-Relat%C3%B3rio-de-Atividades-e-Contas-do-Exerc%C3%ADcio-de-2019_.pdf","cite":"Relat\xf3rio de Atividade e Contas 2019, FPJ","citation":"E, grande momento da Gala e absolutamente in\xe9dito em Portugal, os Mestres Jos\xe9 Manuel Bastos Nunes (ausente por motivos de sa\xfade, tendo enviado uma linda mensagem) e Fernando Costa Matos receberam o Diploma de Gradua\xe7\xe3o de 9.\xba Dan, a mais alta gradua\xe7\xe3o nacional e naturalmente, das maiores do Mundo!"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://correiodosacores.pt/NewsDetail/ArtMID/383/ArticleID/31195/%E2%80%9CA-not237cia-de-que-iria-aos-Jogos-Ol237mpicos-foi-um-pouco-inesperada-mas-recebida-com-emo231227o-e-alegria%E2%80%9D"},{"uri":"http://www.fpj.pt/wp-content/uploads/2019/12/19ci344-Premiados-na-Gala-do-60%C2%BA-Anivers%C3%A1rio-da-FPJ.pdf"},{"uri":"https://judolandia.tripod.com/costamatos-bi.htm"},{"uri":"https://judomagazine.pt/2023/05/16/entrevista-viagem-ao-mundo-dos-homens-bons-2/"},{"uri":"https://judomagazine.pt/2023/04/30/entrevista-fernando-costa-matos-um-velejador-navegador-de-judogi/"}],"source_yaml":"database/persons/PRT/Fernando_Costa_Matos.yaml","photo_url_local":"images/cache/a1694772c78a2a3234bedc9f5abe5ca1.jpg"}},{"data":{"id":"JDP-72","name":"Carlos Portas","nationality":["PRT"],"birth":{"date":"1956","location":null,"country_code":"PRT"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/carlos_portas/carlos_portas.png","source":{"uri":"https://aikidomdc.wixsite.com/brpd/untitled-c1nrv","cite":"Mestre Carlos Portas (Aikido Marcial Dojo Clube)"}},"teachers":[{"id":"JDP-71","style_id":"JDP-S-4","place":"Iwama D\u014Dj\u014D","quality":null,"period":{"start":1985,"end":1993},"sources":[{"uri":"https://aikidomdc.wixsite.com/brpd/untitled-c1nrv","cite":"Mestre Carlos Portas (Aikido Marcial Dojo Clube)","citation":" Em 1985, viu no jornal o an\xfancio de uma demonstra\xe7\xe3o de Aikido por um mestre japon\xeas (Mestre Tomita), em Estocolmo, e foi ver. Achou que tinha ca\xeddo num po\xe7o de luz e logo ali perguntou ao Mestre se o aceitava como aluno, o que veio a acontecer. Regressou a Portugal em 1993"}]}],"rank":[{"style_id":"JDP-S-4","org":"Aikikai","teacher":null,"rank":"6 dan","date":null,"sources":[{"uri":"https://sportmagazine.pt/carlos-portas-a-pratica-e-a-evolucao-do-aikido-em-aveiro-temos-que-nos-reinventar/","cite":"Carlos Portas, a pr\xe1tica e a evolu\xe7\xe3o do Aikido em Aveiro: \xabTemos que nos reinventar\xbb (Sport Magazine)","citation":"Com gradua\xe7\xe3o de 6\xba dan, Aikikai recomendada por Ulf Evenas Shihan e atribu\xedda pelo Hombo Dojo Aikikai Tokyo, Carlos Portal \xe9 uma refer\xeancia na pr\xe1tica do Aikido em Portugal."}],"style":"Aikid\u014D","style_native":{"name":"\u5408\u6C17\u9053","lang":"ja"}}],"sources":[{"uri":"https://sportmagazine.pt/carlos-portas-a-pratica-e-a-evolucao-do-aikido-em-aveiro-temos-que-nos-reinventar/"},{"uri":"https://aikidomdc.wixsite.com/brpd/untitled-c1nrv"},{"uri":"https://web.archive.org/web/20081021192343/http://www.cao.pt/surya/pe_12_1.htm"}],"source_yaml":"database/persons/PRT/Carlos_Portas.yaml"}},{"data":{"id":"JDP-84","name":"Carlos Pereira","nationality":["PRT"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"teachers":[{"id":"JDP-86","style_id":"JDP-S-4","place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm","cite":"Entrevista ao Professor Jos\xe9 Ara\xfajo (Pedro Escudeiro, 2000 - Archived)","citation":"O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o respons\xe1vel pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem s\xe9ria, rigorosa e profundamente empenhada."}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm"},{"uri":"https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm"}],"source_yaml":"database/persons/PRT/Carlos_Pereira.yaml"}},{"data":{"id":"JDP-16","name":"Jos\xe9 Manuel Bastos Nunes","nationality":["PRT"],"birth":{"date":"1937-03-13","location":"Sintra","country_code":"PRT"},"death":{"date":"2024-01-20","location":null,"country_code":"PRT"},"photo":{"url":"https://archive.org/download/bastos_nunes/bastos_nunes.jpg","source":{"uri":"https://catalogo.bnportugal.gov.pt/ipac20/ipac.jsp?uri=full=3100024~!97548~!0","cite":"Tele-Judo e Karate-do (revista quinzenal), 1. 1977"}},"teachers":[{"id":"JDP-12","style_id":"JDP-S-1","place":"Judo Clube de Portugal","quality":null,"period":{"start":null,"end":null}},{"id":"JDP-66","style_id":"JDP-S-1","place":"Judo Clube de Portugal","quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"http://judokai.pt/JUDO%20-%20MANUAL.pdf","cite":"Judokai: Manual de Forma\xe7\xe3o para Gradua\xe7\xe3oem 1\xba Dan - Judo (Judo Clube de Sintra - Judokai)","citation":"Quase na mesma altura [1955] chega a Lisboao Sui\xe7o Antony Stryker, 1\xba Dan,que abre uma sala no Largo do Intendente, onde teve como aluno, entre outros, Jos\xe9 Manuel Bastos Nunes."}]}],"rank":[{"style_id":"JDP-S-1","org":"FPJ","teacher":null,"rank":"9 dan","date":2019,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"http://www.fpj.pt/wp-content/uploads/2019/12/19ci344-Premiados-na-Gala-do-60%C2%BA-Anivers%C3%A1rio-da-FPJ.pdf"},{"uri":"https://judolandia.tripod.com/bastosnunes.htm"},{"uri":"https://judomagazine.pt/2024/01/22/jose-manuel-bastos-nunes-uma-despedida-suave/"},{"uri":"https://www.abola.pt/mais-desporto/noticias/faleceu-jose-bastos-nunes-2024012118301165539"}],"source_yaml":"database/persons/PRT/Basto_Nunes.yaml"}},{"data":{"id":"JDP-127","name":"Augusto de Oliveira Cordeiro","nationality":["PRT","BRA"],"birth":{"date":"1920","location":"Guarda","country_code":"PRT"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/augusto-cordeiro-c/Augusto%20Cordeiro%20c.jpg","source":{"uri":"https://blogoterohermanny.blogspot.com/2009/09/o-mestre-augusto-cordeiro.html","cite":"O MESTRE AUGUSTO CORDEIRO (Rudolf Hermanny)"}},"teachers":[{"id":"JDP-126","style_id":"JDP-S-1","place":"Budokan (SP)","period":{"start":"1950","end":null},"quality":3,"sources":[{"uri":"https://blogoterohermanny.blogspot.com/2009/09/o-mestre-augusto-cordeiro.html","cite":"Rudolf Hermanny\'s Blog","citation":"ao estabelecer contato com a Associa\xe7\xe3o Budokan do Prof. Riuzo Ogawa se apaixonou pelo magn\xedfico Jud\xf4 que ali se ensinava e praticava. Ap\xf3s uma temporada residindo em casa do mestre e praticando com seus alunos, o Prof. Cordeiro adotou a nova metodologia e a forma de competi\xe7\xe3o oficial do jud\xf4"},{"uri":"https://revistabudo.com.br/georges-mehdi-e-rudolf-hermanny-uma-historia-que-transcende-o-tempo-e-os-tatamis/","cite":"Revista Bud\xf4","citation":"disc\xedpulo direto do mestre japon\xeas Ryuzo Ogawa"},{"uri":"https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php","cite":"Ma\xe7aneiro (2024)","location":"pp. 91-92","citation":"Cordeiro continuou a procurar pelo jud\xf4 e, no in\xedcio da d\xe9cada de 1950, chegou \xe0 um acordo com Ryuzo Ogawa, tornando-se sua primeira filial no Rio de Janeiro"}]},{"id":"JDP-105","style_id":"JDP-S-1","place":"Rio de Janeiro","period":{"start":"1937","end":"1948"},"quality":2,"sources":[{"uri":"https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php","cite":"MA\xc7ANEIRO, Gustavo Goulart Braga. Desenvolvimento organizacional do jud\xf4 brasileiro. S\xe3o Paulo : Escola de Educa\xe7\xe3o F\xedsica e Esporte, Universidade de S\xe3o Paulo, 2024. Disserta\xe7\xe3o de Mestrado em Estudos Socioculturais e Comportamentais da Educa\xe7\xe3o F\xedsica e Esporte","location":"p. 91","citation":"em 1944 a ACM promoveu competi\xe7\xf5es e gradua\xe7\xf5es (...) Por esse per\xedodo \xe9 que Takeo Yano foi respons\xe1vel pela gradua\xe7\xe3o de professores no Rio de Janeiro e, dentre eles, aquele que se tornou, anos mais tarde, o primeiro presidente da CBJ, Augusto Cordeiro"},{"uri":"https://memoria.bn.gov.br/DocReader/DocReader.aspx?bib=221961_03&&pasta=ano%20195&pagfis=59293","cite":"Diario da Noite","location":"Ed. 06066, 11 de Dezembro de 1957, p. 3","citation":"Corria o ano de 1937 e tratei de inscrever o meu nome entre os alunos do professor Takeo Yama [sic], que afinal de contas, funcionou como o meu descobridor"}]}],"rank":[{"style_id":"JDP-S-1","org":"Federa\xe7\xe3o Guanabarina de Jud\xf4","rank":"5 dan","date":"1963","sources":[{"uri":"https://judotradicionalgoshinjutsukan.blogspot.com/2009/04/","cite":"O JUD\xd4 NO RIO DE JANEIRO (Wanderley, 2001)","citation":"Boletim Informativo n\xba 1, de 1963... Prof. Cordeiro - 5\xba dan"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://blogoterohermanny.blogspot.com/2009/09/o-mestre-augusto-cordeiro.html"},{"uri":"https://pt.wikipedia.org/wiki/Jud%C3%B4_do_Brasil"},{"uri":"https://revistabudo.com.br/georges-mehdi-e-rudolf-hermanny-uma-historia-que-transcende-o-tempo-e-os-tatamis/"},{"uri":"https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php"},{"uri":"https://judotradicionalgoshinjutsukan.blogspot.com/2009/04/"}],"source_yaml":"database/persons/PRT/Augusto_Cordeiro.yaml"}},{"data":{"id":"JDP-76","name":"Armando Gon\xe7alves","nationality":["PRT"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/armando_goncalves/armando_goncalves.png","source":{"uri":"http://id.bnportugal.gov.pt/bib/catbnp/735884","cite":"GON\xc7ALVES, Armando. Opini\xf5es do meu amigo Fabr\xedcio: cr\xf3nicas ac\xearca da Educa\xe7\xe3o F\xedsica e dos Desportos. 1942."}},"teachers":[{"id":"JDP-77","style_id":"JDP-S-14","place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"http://id.bnportugal.gov.pt/bib/catbnp/732683","cite":"GON\xc7ALVES, Armando; O fraco vence o forte. 1941","citation":"Ex-disc\xedpulo do Professor japon\xeas, Hirano (...) O nosso saudoso ex-professor Hirano n\xe3o tinha admira\xe7\xe3o nenhuma pelo sistema Kano"}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://judolandia.tripod.com/histport.htm"},{"uri":"http://clubejudoporto.weebly.com/os-nossos-fundadores.html"},{"uri":"https://www.fjjdap.pt/jujitsu/"},{"uri":"https://www.ungoshin.pt/correa-pereira-historia-budo"},{"uri":"https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf"}],"source_yaml":"database/persons/PRT/Armando_Gon\xe7alves.yaml"}},{"data":{"id":"JDP-61","name":"Ant\xf3nio Roquette de Andrade","aka":[{"name":"Ant\xf3nio Roquette"},{"name":"Ant\xf3nio Roquete"},{"name":"Tona"}],"nationality":["PRT"],"birth":{"date":"1955-05-26","location":"Estoril","country_code":"PRT"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/tona1980/tona1980.jpg","source":{"uri":"https://fcmjudo.pt/moscovo.html","cite":"Di\xe1rio de Lisboa, 1980 (in: FCM Judo)"}},"teachers":[{"id":"JDP-15","style_id":"JDP-S-1","place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.ahbe.pt/portfolio-item/judo/","cite":"A Hist\xf3ria Do Judo na AHBE","citation":"O professor Costa Matos leccionou Judo na AHBE entre 1970 e 1976, altura em que, por motivos de sa\xfade, foi substitu\xeddo pelo seu melhor aluno, o professor Ant\xf3nio Roquete de Andrade, o qual assumiu definitivamente o cargo de treinador principal da AHBE em 1977, ap\xf3s ter participado como atleta nos Jogos Ol\xedmpicos de MONTREAL em 1976."}]}],"rank":[{"style_id":"JDP-S-1","org":"Federa\xe7\xe3o Portuguesa de Judo","teacher":null,"rank":"7 dan","date":2009,"sources":[{"uri":"https://www.fpj.pt/wp-content/uploads/2020/03/20ci057-Relat%C3%B3rio-de-Atividades-e-Contas-do-Exerc%C3%ADcio-de-2019_.pdf","cite":"Relat\xf3rio de Atividades e Contas, 2019. FPJ","citation":"Os Diplomas de 7.\xba Dan foram atribu\xeddos aos Mestres Ant\xf3nio Roquete de Andrade, Artur Alves da Mata, Jos\xe9 Pinto Farias, Nelson Trindade e Frygyes Torok. O de 8.\xba Dan ao Mestre Henrique Nunes"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://judolandia.tripod.com/roquete.htm"},{"uri":"https://www.olympedia.org/athletes/34295"},{"uri":"https://judomagazine.pt/2023/04/30/entrevista-fernando-costa-matos-um-velejador-navegador-de-judogi/"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q20973014","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Ant%C3%B3nio_Roquete_(judoka)","cite":"DBpedia"}],"source_yaml":"database/persons/PRT/Ant\xf3nio_Roquette.yaml"}},{"data":{"id":"JDP-83","name":"Ant\xf3nio Corr\xeaa Pereira","aka":[{"name":"Ant\xf3nio Hilmar Schalck Corr\xeaa Pereira"},{"name":"Ant\xf3nio Correia Pereira"}],"nationality":["PRT"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/correapereira3/correapereira3.jpg","source":{"uri":"https://www.ubu.pt/home/professores/p1/https://www.ubu.pt/home/professores/dr-luis-franco-pires-martins/","cite":"Mestre Ant\xf3nio Corr\xeaa Pereira (1906-1982) -UBU"}},"teachers":[{"id":"JDP-109","style_id":"JDP-S-14","place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"1 dan","date":"1963-09-10","sources":[{"uri":"https://repositorio.ipv.pt/handle/10400.19/448","cite":"FIGUEIREDO, Abel Aur\xe9lio Abreu. A institucionaliza\xe7\xe3o do karat\xe9-os modelos organizacionais do karat\xe9 em Portugal. 2006. PhD Thesis. Instituto Politecnico de Viseu (Portugal)","citation":"Mas o arranque institucional que mais influenciar\xe1 a hist\xf3ria do Karat\xe9 est\xe1 na Academia de Judo, propriedade de Ant\xf3nio Corr\xeaa Pereira, no 3\xba andar, do n.\xba 140, da Rua de S. Paulo, em Lisboa. Al\xe9m de ser o primeiro cinto negro inscrito no Kodokan (Jap\xe3o) (...) Ant\xf3nio LIMA retira dos estatutos respectivos a refer\xeancia de que, em 23 de Fevereiro de 1958, Corr\xeaa Pereira funda a Academia de Budo, sendo \xabo primeiro Portugu\xeas a possuir a gradua\xe7\xe3o de cinto negro conferida na Alemanha\xbb (LIMA, 1990, p. 121)"},{"uri":"https://www.ubu.pt/home/arquivo-fotografico/correapereirakodokan/","citation":"Diploma do Kodokan, atribuido ao Mestre Corr\xeaa Pereira [1 dan / 3-III-1958 / Risei Kano]"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://www.ubu.pt/home/professores/p1/"},{"uri":"https://www.ubu.pt/home/historia/"},{"uri":"https://judolandia.tripod.com/histport.htm"}],"notes":"As rela\xe7\xf5es de aprendizagem entre os membros fundadores da UBU n\xe3o\\ns\xe3o claras, provavelmente apenas por n\xe3o serem t\xf3pico que \xe9\\nexpressamente dito nas fontes, mas tamb\xe9m provavelmente pela\\ndin\xe2mica de grande voluntarismo e inova\xe7\xe3o que caracterizam uma\\norganiza\xe7\xe3o que foi pioneira. Uma leitura transversal das v\xe1rias\\nfontes apontam para rela\xe7\xf5es de aprendizagem m\xfatua, com posterior\\nvalida\xe7\xe3o/homologa\xe7\xe3o em alguns casos (como no do Karate).  Assim,\\na identifica\xe7\xe3o das rela\xe7\xf5es aluno/professor provavelmente\\ndemonstrar\xe3o uma rela\xe7\xe3o em rede, sendo que a figura de Corr\xeaa\\nPereira se apresenta como agregadora, mesmo n\xe3o sendo na maior\\nparte das vezes claro a influ\xeancia directa (em termos de treino)\\nque existiu, em especial a partir do final dos anos 50.  Isto \xe9\\nparticularmente aplic\xe1vel ao Judo (e jujutsu), visto que para o\\nAikido e Karate a evolu\xe7\xe3o posterior na UBU permitem leituras mais\\nconcretas. Sobre o Judo, antes de Shirooka n\xe3o \xe9 claro quem faz a\\ninstru\xe7\xe3o, assumindo-se que Corr\xeaa Pereira \xe9 uma das fontes (e.g.,\\na demonstra\xe7\xe3o com Sebasti\xe3o Dur\xe3o). O 1\xba dan Kodokan \xe9 dado como\\natribuido na Alemanha (Figueiredo 2006), em entrevista Luis\\nAntunes indica que Corr\xeaa Pereira treinou Jujutsu em Berlim com\\nEric Rahm.\\n","source_yaml":"database/persons/PRT/Antonio_Correa_Pereira.yaml"}},{"data":{"id":"JDP-67","name":"Alexandre Gueif\xe3o","nationality":["PRT"],"birth":{"date":"1940-12-07","location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/alexandre_gueifao/alexandre_gueifao.png","source":{"uri":"https://www.bushidoespadaepena.com/entrevistas","cite":"Bushido: a Espada e a Pena"}},"teachers":[{"id":"JDP-66","style_id":"JDP-S-1","place":"Judokai de Lisboa","quality":3,"period":{"start":1958,"end":null},"sources":[{"uri":"https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_35-62.pdf","cite":"Gueif\xe3o, Alexandre, \xab\xc0 volta de Homens com s\xe9rio C\xf3digo de Honra\xbb, in \xabA G\xe9nese do Karate em Portugal\xbb","citation":"Retrato saudoso e quase desvanecido de um karateka que se iniciou em Judo no ano de 1958 sob a orienta\xe7\xe3o de Tony Stricker e H. Bouchend-Homme da Organiza\xe7\xe3o Judokai, e mais tarde sob os ensinamentos do Grande Mestre K. Kobayashi, no Judo Clube de Portugal."}]},{"id":"JDP-68","style_id":"JDP-S-1","place":"Judokai de Lisboa","quality":3,"period":{"start":1958,"end":null},"sources":[{"uri":"https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_35-62.pdf","cite":"Gueif\xe3o, Alexandre, \xab\xc0 volta de Homens com s\xe9rio C\xf3digo de Honra\xbb, in \xabA G\xe9nese do Karate em Portugal\xbb","citation":"Retrato saudoso e quase desvanecido de um karateka que se iniciou em Judo no ano de 1958 sob a orienta\xe7\xe3o de Tony Stricker e H. Bouchend-Homme da Organiza\xe7\xe3o Judokai, e mais tarde sob os ensinamentos do Grande Mestre K. Kobayashi, no Judo Clube de Portugal."}]},{"id":"JDP-82","style_id":"JDP-S-5","place":"Academia de Budo","quality":3,"period":{"start":1964,"end":null},"sources":[{"uri":"https://www.suishinkan.com.pt/biografia.html","citation":"Foi co-introdutor da pr\xe1tica do Karate em Portugal na Academia de Budo, em Lisboa, onde come\xe7ou a praticar em 1964 sob a orienta\xe7\xe3o do seu primeiro Mestre de Karate-Do - Mestre Pires Martins da UBU"}]},{"id":"JDP-12","style_id":"JDP-S-1","place":"Judo Clube de Portugal","quality":3,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_35-62.pdf","cite":"Gueif\xe3o, Alexandre, \xab\xc0 volta de Homens com s\xe9rio C\xf3digo de Honra\xbb, in \xabA G\xe9nese do Karate em Portugal\xbb","citation":"Retrato saudoso e quase desvanecido de um karateka que se iniciou em Judo no ano de 1958 sob a orienta\xe7\xe3o de Tony Stricker e H. Bouchend-Homme da Organiza\xe7\xe3o Judokai, e mais tarde sob os ensinamentos do Grande Mestre K. Kobayashi, no Judo Clube de Portugal."}]},{"id":"JDP-94","style_id":"JDP-S-5","place":null,"quality":2,"period":{"start":1969,"end":null},"sources":[{"uri":"https://www.suishinkan.com.pt/biografia.html","citation":"O seu segundo Mestre foi Tetsuji Murakami Sensei, de quem foi aluno desde 1969, data que marca o nascimento efectivo da pr\xe1tica do estilo Shotokai em Portugal com a realiza\xe7\xe3o do primeiro est\xe1gio de Mestre Murakami."}]}],"rank":[{"style_id":"JDP-S-1","org":"UBU","teacher":null,"rank":"1 dan","date":null,"sources":[{"uri":"https://www.suishinkan.com.pt/biografia.html","citation":"Gradua\xe7\xe3o de 1\xba. Dan de Judo certificada pela UBU."}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://www.suishinkan.com.pt/biografia.html"},{"uri":"https://www.ubu.pt/home/professores/mestre-alexandre-gueifao/"},{"uri":"https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_35-62.pdf"},{"uri":"https://www.youtube.com/watch?v=BkBldZFIcBY"}],"source_yaml":"database/persons/PRT/Alexandre_Gueif\xe3o.yaml"}},{"data":{"id":"JDP-65","name":"Afonso Henriques Maia de Loureiro","aka":[{"name":"Afonso Henriques Ivens-Ferraz Maia de Loureiro"}],"nationality":["PRT"],"birth":{"date":"1917-06-27","location":"Ilha de Mo\xe7ambique","country_code":"MOZ"},"death":{"date":"1999-11-08","location":"Lisboa","country_code":"PRT"},"photo":{"url":"https://archive.org/download/maialoureiro-1/Maialoureiro1.gif","source":{"uri":"https://www.fcmjudo.pt/Socioshonorarios.html","cite":"S\xf3cios Honor\xe1rios da F.P. Judo"}},"teachers":[{"id":"JDP-66","style_id":"JDP-S-1","place":"Judo Clube de Portugal","quality":3,"period":{"start":1954,"end":1958},"sources":[{"uri":"https://judolandia.tripod.com/histport.htm","cite":"Hist\xf3ria do Judo em Portugal (Judol\xe2ndia, texto de \xabJudo: da inicia\xe7\xe3o \xe0 competi\xe7\xe3o\xbb, Costa Branco et. al","citation":"Quase na mesma altura chega a Lisboa Antony Striker (Su\xed\xe7o) 1\xba Dan, o qual abre uma sala no Largo do Intendente, onde despontaram para o Judo, entre outros, Afonso Maia de Loureiro, Vasco de Sousa e Jos\xe9 Manuel Bastos Nunes."},{"uri":"https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=243","cite":"Seis hist\xf3rias \xe0 volta do Tatami _ Gala 60\xba Anivers\xe1rio FPJ","citation":"Em 1954. O professor era um tal belga, Anton Stricker, que era seguran\xe7a do Reino Belga"}]}],"rank":[{"style_id":"JDP-S-1","org":"FPJ","teacher":null,"rank":"3 dan","date":null,"sources":[{"uri":"https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf","cite":"Relat\xf3rio de Atividades e Contas do Exerc\xedcio de 2019","citation":"Afonso Henriques I. F. Maia de Loureiro (3\xba Dan)"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://judolandia.tripod.com/histport.htm"},{"uri":"https://www.fcmjudo.pt/Socioshonorarios.html"},{"uri":"https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=243"}],"source_yaml":"database/persons/PRT/Afonso_Maia_de_Loureiro.yaml"}},{"data":{"id":"JDP-9","name":"Yokoyama Sakujiro","native_name":{"name":"\u6A2A\u5C71 \u4F5C\u6B21\u90CE","lang":"ja"},"nationality":["JPN"],"birth":{"date":1864,"location":"Tokyo","country_code":"JPN"},"death":{"date":"1912-09-23","location":null,"country_code":"JPN"},"photo_url":"https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Yokoyama-Sakujiro.jpg/220px-Yokoyama-Sakujiro.jpg","teachers":[{"id":"JDP-1","style_id":"JDP-S-1","place":"Kodokan","quality":null,"period":{"start":1886,"end":null}},{"id":"JDP-10","style_id":"JDP-S-3","place":"Yushima Tenjin dojo","quality":null,"period":{"start":null,"end":null}}],"rank":[{"style":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E6%A8%AA%E5%B1%B1%E4%BD%9C%E6%AC%A1%E9%83%8E"},{"uri":"https://en.wikipedia.org/wiki/Kan%C5%8D_Jigor%C5%8D"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q3276775","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Yokoyama_Sakujiro","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Yokoyama_Sakujiro.yaml","photo_url_local":"images/cache/3326476096b40cabee471bb36cde6755.jpg"}},{"data":{"id":"JDP-105","name":"Yano Takeo","nationality":["JPN"],"birth":{"date":"1909","location":null,"country_code":"JPN"},"death":{"date":"1988","location":"Belo Horizonte","country_code":"BRA"},"photo":{"url":"https://archive.org/download/yano_20240827/yano.png","source":{"uri":"https://simonbjj.com/takeo-yano","cite":"Takeo Yano in a pre-fight publicity photo (Simon BJJ)"}},"teachers":[{"id":"JDP-43","style_id":"JDP-S-1","place":null,"period":{"start":null,"end":null},"quality":null,"sources":[{"uri":"https://simonbjj.com/takeo-yano","cite":"The Eastern Demon, Takeo Yano (Simon BJJ)","citation":"There is not much information known about Takeo Yano, but it is believed he may have been born in 1909 and trained at the Dai Nippon Butoko Kai academy in Kioto under famed Judoka, Hajime Isogai."}]}],"rank":[{"style_id":"JDP-S-1","org":"Dai Nippon Butoku Kai","teacher":null,"rank":"3 dan","date":null,"sources":[{"uri":"https://simonbjj.com/takeo-yano","cite":"The Eastern Demon, Takeo Yano (Simon BJJ)","citation":" Yano trained at the academy until he received his 3rd dan and then began travelling internationally."},{"uri":"https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php","cite":"MA\xc7ANEIRO, Gustavo Goulart Braga. Desenvolvimento organizacional do jud\xf4 brasileiro. S\xe3o Paulo : Escola de Educa\xe7\xe3o F\xedsica e Esporte, Universidade de S\xe3o Paulo, 2024. Disserta\xe7\xe3o de Mestrado em Estudos Socioculturais e Comportamentais da Educa\xe7\xe3o F\xedsica e Esporte","citation":"A Marinha h\xe1 muito contratou um japon\xeas, Yano, 3\xba dan, como instrutor para a pr\xe1tica do jud\xf4 japon\xeas para os soldados"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Takeo_Yano"},{"uri":"https://simonbjj.com/takeo-yano"},{"uri":"https://isbnsearch.org/isbn/9798639871030"},{"uri":"https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php"}],"source_yaml":"database/persons/JPN/Yano_Takeo.yaml"}},{"data":{"id":"JDP-95","name":"Yamashita Yoshitsugu","native_name":{"name":"\u5C71\u4E0B \u7FA9\u97F6","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1865-02-16","location":"Kanazawa","country_code":"JPN"},"death":{"date":"1935-10-26","location":null,"country_code":null},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/d/d6/YoshiakiYamashita.jpg","source":{"uri":"https://en.wikipedia.org/wiki/Yamashita_Yoshitsugu#/media/File:YoshiakiYamashita.jpg"}},"teachers":[{"id":"JDP-1","style_id":"JDP-S-1","place":"Kodokan","quality":null,"period":{"start":1884,"end":null},"sources":[{"uri":"https://www.judo-ch.jp/english/legend/yamasita/","cite":"Kodokan hall of fame: Yoshitsugu Yamashita (Judo Channel)","citation":"Yoshitsugu Yamashita was the son of an Odawara Han martial arts instructor, and he entered Kodokan in August of 1884."},{"uri":"https://en.wikipedia.org/wiki/Yamashita_Yoshitsugu","citation":"In August 1884, he joined the Kodokan judo dojo of his childhood friend Kano Jigoro as its nineteenth member"}]}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"10 dan","date":null,"sources":[{"uri":"https://www.judo-ch.jp/english/legend/yamasita/","cite":"Kodokan hall of fame: Yoshitsugu Yamashita (Judo Channel)","citation":"At the memorial ceremony held at Kodokan, Jigoro Kano posthumously awarded Mr. Yamashita the 10th Dan rank as of October 24th, making Mr. Yamashita the first holder of the Kodokan 10th Dan rank in recognition of his service."}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Yamashita_Yoshitsugu"},{"uri":"https://ja.wikipedia.org/wiki/%E5%B1%B1%E4%B8%8B%E7%BE%A9%E9%9F%B6"},{"uri":"https://www.judo-ch.jp/english/legend/yamasita/"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q3236604","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Yamashita_Yoshitsugu","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Yamashita_Yoshitsugu.yaml"}},{"data":{"id":"JDP-74","name":"Yamamoto Nobuaki","native_name":{"name":null,"lang":null},"nationality":["JPN"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/yamamoto73_1/yamamoto73_1.jpg","source":{"uri":"https://www.fcmjudo.pt/visitantes.html"}},"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://www.fcmjudo.pt/visitantes.html"},{"uri":"https://www.jpn.up.pt/2015/04/21/clube-judo-do-porto-50-anos-continua-jovem/"}],"source_yaml":"database/persons/JPN/Yamamoto_Nobuaki.yaml"}},{"data":{"id":"JDP-90","name":"Ushijima Tatsukuma","native_name":{"name":"\u725B\u5CF6\u8FB0\u718A","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1904-03-10","location":"Kumamoto","country_code":"JPN"},"death":{"date":"1985-05-26","location":null,"country_code":"JPN"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/3/33/Tatsukuma_Ushijima.jpg","source":{"uri":"https://en.wikipedia.org/wiki/Tatsukuma_Ushijima#/media/File:Tatsukuma_Ushijima.jpg","cite":"Tatsukuma Ushijima. (2023, March 12). In Wikipedia. https://en.wikipedia.org/wiki/Tatsukuma_Ushijima"}},"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"9 dan","date":1984,"sources":[{"uri":"https://www.researchgate.net/publication/263087428_Nanatsu-no-kata_Endo-no-kata_and_Joge-no-kata_-A_pedagogical_and_qualitative_biomechanical_evaluation_of_Hirano_Tokio\'s_kuzushi_unbalancing_concept_as_part_of_skill_acquisition_for_throwing_techniques","cite":"De Cr\xe9e, Carl. (2014). Nanatsu-no-kata, End\u014D-no-kata, and J\u014Dge-no-kata \u2015A pedagogical and qualitative biomechanical evaluation of Hirano Tokio\u2019s kuzushi (unbalancing) concept as part of skill acquisition for throwing techniques in K\u014Dd\u014Dkan j\u016Bd\u014D. Revista de Artes Marciales Asi\xe1ticas. 9. 69-96. 10.18002/rama.v9i2.1162.","citation":"While still at Ky\u014Dto, Hirano later also became an uchi deshi to Ushijima Tatsukuma \u725B\u5CF6\u8FB0\u718A (1904\u20101985) (Figure 2), famous for his competitive achievements and who too was a Busen j\u016Bd\u014D teacher and future (1984) 9th dan holder"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Tatsukuma_Ushijima"},{"uri":"https://ja.wikipedia.org/wiki/%E7%89%9B%E5%B3%B6%E8%BE%B0%E7%86%8A"},{"uri":"https://judo.forumotion.com/t1770-tatsukuma-ushijima"},{"uri":"https://www.researchgate.net/publication/263087428_Nanatsu-no-kata_Endo-no-kata_and_Joge-no-kata_-A_pedagogical_and_qualitative_biomechanical_evaluation_of_Hirano_Tokio\'s_kuzushi_unbalancing_concept_as_part_of_skill_acquisition_for_throwing_techniques"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q11570129","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Tatsukuma_Ushijima","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Ushijima_Tatsukuma.yaml"}},{"data":{"id":"JDP-27","name":"Ueshiba Morihei","native_name":{"name":"\u690D\u829D \u76DB\u5E73","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1883-12-14","location":"Tanabe","country_code":"JPN"},"death":{"date":"1969-04-26","location":"Iwama","country_code":"JPN"},"photo_url":"https://upload.wikimedia.org/wikipedia/en/thumb/0/0f/Morihei_Ueshiba_Portrait.jpg/220px-Morihei_Ueshiba_Portrait.jpg","teachers":[{"id":"JDP-28","style_id":"JDP-S-10","place":null,"quality":null,"period":{"start":1915,"end":1922}},{"id":"JDP-47","style_id":"JDP-S-3","place":null,"quality":null,"period":{"start":1901,"end":1901},"sources":[{"uri":"http://www.hontaiyoshinryu.be/images/Documents/p_schools.pdf","cite":"BUYENS, Guy. Introduction to Traditional martial systems. 2016","citation":"Iso Mataemon Masatomo had amongst his students Inoue Keitaro and Tozawa Tokusaburo, who were the teachers of Miyamoto Hanzo). Morihei Ueshiba, founder of aikido, studied Tenjin Shinyo-ryu with Tozawa Tokusaburo"},{"uri":"https://aikidojournal.com/2011/08/27/tokusaburo-tozawa/","citation":"[Tokusaburo Tozawa]. Teacher of TENJIN SHIN\u2019YO-RYU JUJUTSU in Tokyo in late 1800s and early 1900s. Taught Morihei UESHIBA for brief period in 1901","events":["period"]}]},{"id":"JDP-50","style_id":"JDP-S-11","place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://en.wikipedia.org/wiki/Yagy%C5%AB_Shingan-ry%C5%AB","citation":"Morihei Ueshiba, the founder of Aikido, was a student of Yagy\u016B Shingan-ry\u016B. In 1908, after five years of training, he received the rank of Shoden from Masakatsu Nakai, a Shihan of the Edo-line of Yagy\u016B Shingan-ry\u016B"},{"uri":"https://aikidojournal.com/2016/09/24/interview-with-morihei-ueshiba-and-kisshomaru-ueshiba/","citation":"O-Sensei: At about the age of 14 or 15. First I learned Tenshinyo-ryu Jiujitsu from Tokusaburo Tozawa Sensei, then Kito-ryu, Yagyu-ryu, Aioi-ryu, Shinkage-ryu, all of them jujutsu forms."}]}],"rank":[{"style_id":"JDP-S-10","org":null,"teacher":"JDP-28","rank":"Ky\u014Dju Dairi","date":1922,"style":"Dait\u014D-ry\u016B Aiki-j\u016Bjutsu","style_native":{"name":"\u5927\u6771\u6D41 \u5408\u6C17\u67D4\u8853","lang":"ja"}},{"style_id":"JDP-S-13","org":null,"teacher":"JDP-50","rank":"Shoden","date":1908,"style":"Shuri-te","style_native":{"name":"\u9996\u91CC\u624B","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Morihei_Ueshiba","events":["name native_name birth death"]},{"uri":"https://ja.wikipedia.org/wiki/%E5%AF%8C%E6%9C%A8%E8%AC%99%E6%B2%BB","events":["name native_name birth death"]},{"uri":"https://en.wikipedia.org/wiki/Yagy%C5%AB_Shingan-ry%C5%AB","events":["rank"]},{"uri":"https://aikidojournal.com/2016/09/24/interview-with-morihei-ueshiba-and-kisshomaru-ueshiba/"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q182130","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Morihei_Ueshiba","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Ueshiba_Morihei.yaml","photo_url_local":"images/cache/8443eb7fc742180dd0257abdd1bc1414.jpg"}},{"data":{"id":"JDP-39","name":"Ueda Heitaro","native_name":{"name":"\u690D\u7530\u5E73\u592A\u90CE","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1877-08-14","location":"Ikenishi","country_code":"JPN"},"death":{"date":"1949-07-25","location":null,"country_code":null},"photo_url":"https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/%E5%8D%81%E4%B8%83%E4%BB%A3%E5%AE%97%E5%AE%B6%E6%A4%8D%E7%94%B0%E5%B9%B3%E5%A4%AA%E9%83%8E.png/169px-%E5%8D%81%E4%B8%83%E4%BB%A3%E5%AE%97%E5%AE%B6%E6%A4%8D%E7%94%B0%E5%B9%B3%E5%A4%AA%E9%83%8E.png","teachers":[{"id":"JDP-60","style_id":"JDP-S-8","place":"Bujutsu Kyoin Yoseijo","quality":3,"period":{"start":1905,"end":null},"sources":[{"uri":"https://kenshi247.net/blog/2022/01/24/the-iron-will-of-the-kendo-god-ueda-heitaro/","cite":"The iron will of the kendo god Ueda Heitaro - Kenshi 24/7","citation":"At the Yoseijo he was there as a koshusei or a part-time student there to learn kendo only (full time students also did academic study). There he studied directly under Naito Takaharu and crossed shinai with the likes of Saimura, Nakano, Oshima, and Shimatani (this was slightly before Mochida, Ogawa, Miyazaki, and Oasa, etc arrived). "}]}],"rank":[{"style":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://kenshi247.net/blog/2022/01/24/the-iron-will-of-the-kendo-god-ueda-heitaro/"},{"uri":"https://ja.wikipedia.org/wiki/%E6%A4%8D%E7%94%B0%E5%B9%B3%E5%A4%AA%E9%83%8E"}],"source_yaml":"database/persons/JPN/Ueda_Heitaro.yaml","photo_url_local":"images/cache/dedfe9883a7b4ce53c0e4aa65e674a05.png"}},{"data":{"id":"JDP-48","name":"Uchida Ry\u014Dhei","native_name":{"name":"\u5185\u7530\u826F\u5E73","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1873-02-11","location":"Fukuoka","country_code":"JPN"},"death":{"date":"1937-07-26","location":null,"country_code":"JPN"},"photo_url":"https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Ryohei_Uchida_Close-up.jpg/200px-Ryohei_Uchida_Close-up.jpg","description":{"en":"Ry\u014Dhei Uchida (\u5185\u7530 \u826F\u5E73, Uchida Ry\u014Dhei, 11 February 1873 \u2013 26 July 1937) was a Japanese ultranationalist political theorist, Pan-Asianist, and martial artist, active in the pre-war Empire of Japan. He was also an accomplished j\u016Bd\u014Dka, a favorite of Kan\u014D shihan \u5E2B\u7BC4 (master), one of the three most senior 5th dan rank holders in Kodokan history, and a noted street brawler.  He was the son of Shinto Muso-ryu practitioner Uchida Ry\u014Dgor\u014D, and from an early age was interested in many forms of Japanese traditional martial arts, including ky\u016Bd\u014D, kendo, judo and sumo.\\n","ja":"\u5185\u7530 \u826F\u5E73\uFF08\u3046\u3061\u3060 \u308A\u3087\u3046\u3078\u3044\u30011874\u5E74\u3008\u660E\u6CBB7\u5E74\u30092\u670811\u65E5 - 1937\u5E74 \u3008\u662D\u548C12\u5E74\u30097\u670826\u65E5\uFF09\u306F\u3001\u65E5\u672C\u306E\u56FD\u5BB6\u4E3B\u7FA9\u8005\u30FB\u53F3\u7FFC\u904B\u52D5\u5BB6\u30FB\u30A2\u30B8\u30A2\u4E3B \u7FA9\u8005\u3002\u9ED2\u9F8D\u4F1A\u4E3B\u5E79\u3001\u5927\u65E5\u672C\u751F\u7523\u515A\u7DCF\u88C1\u3002 \u65E7\u798F\u5CA1\u85E9\u58EB\u3067\u3042\u308A\u3001\u6B66\u82B8\u306E\u9054 \u4EBA\u3068\u3057\u3066\u77E5\u3089\u308C\u305F\u5185\u7530\u826F\u4E94\u90CE\u306E\u4E09\u7537\u3068\u3057\u3066\u73FE\u5728\u306E\u798F\u5CA1\u770C\u798F\u5CA1\u5E02\u5927\u5186\u5BFA\u753A \uFF08\u73FE\u30FB\u5510\u4EBA\u753A\uFF09\u306B\u751F\u307E\u308C\u308B[1]\u3002\u5E7C\u540D\u826F\u52A9\u3001\u306E\u3061\u7532\uFF08\u304D\u306E\u3048\uFF09\u3002\u660E\u6CBB34 \u5E74\uFF081902\u5E74\uFF09\u306B\u826F\u5E73\u3068\u6539\u540D\u3057\u305F\u3002\u5E7C\u6642\u3088\u308A\u5F13\u9053\u3001\u5263\u9053\u3001\u67D4\u8853\u3001\u76F8\u64B2\u3001\u5C04 \u6483\u3092\u7236\u306B\u5B66\u3093\u3060\u3002\u306A\u304A\u3001\u7236\u30FB\u826F\u4E94\u90CE\u306E\u795E\u9053\u5922\u60F3\u6D41\u6756\u8853\u306E\u9580\u4E0B\u306B\u306F\u3001[2] \u300C\u662D\u548C\u306E\u5263\u8056\u300D\u306E\u4E00\u4EBA\u3067\u3042\u308B\u4E2D\u5C71\u535A\u9053\u304C\u3044\u308B\u3002\\n"},"teachers":[{"id":"JDP-1","style_id":"JDP-S-1","place":"Kodokan","period":{"start":1893,"end":null},"sources":[{"uri":"https://www.researchgate.net/publication/277665808_Kodokan_Judo\'s_three_orphaned_forms_of_counter_techniques_-_Part_1_The_gonosen-no-kata_-_Forms_of_post-attack_initiative_counter_throws","citation":"Miyakawa remained a Gen\u2019y\u014Dshamember and became a K\u014Dd\u014Dkan top-executive (K\u014Dd\u014Dkan Saik\u014D  Kanbu\u8B1B\u9053\u9928\u6700\u9AD8\u5E79\u90E8)  closely  associated  with Kan\u014D Jigor\u014D, as was Uchida Ry\u014Dhei"},{"uri":"https://kanochronicles.com/2023/06/05/ki-%e6%b0%97-in-judo-%e6%9f%94%e9%81%93-uchida-ryohei-and-the-secrets-of-budo-%e6%ad%a6%e9%81%93%e6%a5%b5%e6%84%8f-the-kano-chronicles/","citation":"He was also an accomplished j\u016Bd\u014Dka, a favorite of Kan\u014D shihan \u5E2B\u7BC4 (master), one of the three most senior 5th dan rank holders in Kodokan history, and a noted street brawler."}],"quality":1},{"id":"JDP-49","style_id":"JDP-S-12","place":"Meikokan dojo","quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://opac.tenri-u.ac.jp/opac/repository/metadata/1573/","citation":"\u5BAE\u5DDD\u592A\u4E00\u90CE\u5609\u6C38\u5143\u5E74\uFF081848\uFF09\u751F\u6B63\u6797\u53C8\u4E03\u90CE\u306E\u9AD8\u5F1F\u30FB\u514D\u8A31\u7686\u4F1D\u4EE3\u3005\u9ED2\u7530\u5BB6\u306E\u81E3\u3067\u3042\u308B\u3002\u4E00\u4E07\u6D41\u5263\u8853\uFF0C\u81EA\u525B\u5929\u771F\u6D41\u7D44\u8A0E\u3092\u6975\u3081\uFF0C\u660E\u6CBB10\u5E74(1877) 11\u6708\u7384\u6D0B\u793E\u9644\u5C5E\u306E\u5411\u6D5C\u587E\u3067\u81EA\u805E\u5929\u771F\u6D41\u3092\u6559\u6388\u3057\u305F\u306E\u304C\uFF0C\u5F8C\u306E\u660E\u9053\u9928\u9053\u5834\u306E\u8D77\u6E90\u3068\u3055\u308C\u3066\u3044\u308B\u3002"},{"uri":"https://kanochronicles.com/2023/06/05/ki-%e6%b0%97-in-judo-%e6%9f%94%e9%81%93-uchida-ryohei-and-the-secrets-of-budo-%e6%ad%a6%e9%81%93%e6%a5%b5%e6%84%8f-the-kano-chronicles/","citation":"He learned a number of martial arts, most notably Jig\u014D Tenshin Ry\u016B J\u016Bjutsu in Fukuoka\u2019s Meidokan d\u014Dj\u014D, an art in which he was notably successful. In 1893 he moved to Tokyo to live with his wealthy coal mine owner uncle Hiraoka K\u014Dtar\u014D, a supporter of the Geny\u014Dsha, and began to study Russian at a Tokyo school and j\u016Bd\u014D at Kan\u014D Jigor\u014D\u2019s Kodokan."}]}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"5 dan","date":null,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://kanochronicles.com/2023/06/05/ki-%e6%b0%97-in-judo-%e6%9f%94%e9%81%93-uchida-ryohei-and-the-secrets-of-budo-%e6%ad%a6%e9%81%93%e6%a5%b5%e6%84%8f-the-kano-chronicles/","events":["name","native_name","birth","death","rank"]},{"uri":"https://en.wikipedia.org/wiki/Ry%C5%8Dhei_Uchida","events":["name","native_name","birth","death"]}],"tags":["Kokury\u016Bkai","Geny\u014Dsha","Omoto"],"links":[{"uri":"https://www.wikidata.org/wiki/Q120662","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Ry%C5%8Dhei_Uchida","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Uchida_Ryohei.yaml","photo_url_local":"images/cache/02cd85debf9ee87b78b2972ea0f4abfc.jpg"}},{"data":{"id":"JDP-47","name":"Tozawa Tokusaburo","native_name":{"name":"\u6238\u6CA2\u5FB3\u4E09\u90CE","lang":"ja"},"nationality":["JPN"],"birth":{"date":1848,"location":null,"country_code":null},"death":{"date":1912,"location":null,"country_code":null},"teachers":[{"id":"JDP-4","style_id":"JDP-S-3","place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"http://www.tenyokai.com/booklet.php","citation":"Geneology of Tenjin Shinyo Ryu Jujutsu: (...) Iso Matauemon Masatomo -> Tozawa Tokusaburo"},{"uri":"http://www.hontaiyoshinryu.be/images/Documents/p_schools.pdf","citation":"Iso Mataemon Masatomo had amongst his students Inoue Keitaro and Tozawa Tokusaburo, who were the teachers of Miyamoto Hanzo). Morihei Ueshiba, founder of aikido, studied Tenjin Shinyo-ryu with Tozawa Tokusaburo"}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://aikidojournal.com/2011/08/27/tokusaburo-tozawa/","events":["name","native_name","birth","death"]},{"uri":"https://www.google.pt/books/edition/Koryu_Bujutsu/ZNetk-lJ_O4C"},{"uri":"http://www.tenyokai.com/booklet.php"},{"uri":"http://www.hontaiyoshinryu.be/images/Documents/p_schools.pdf"}],"source_yaml":"database/persons/JPN/Tozawa_Tokusaburo.yaml"}},{"data":{"id":"JDP-17","name":"Tomita Tsunejir\u014D","native_name":{"name":"\u5BCC\u7530 \u5E38\u6B21\u90CE","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1864-02-28","location":"Namazu, Shizuoka","country_code":"JPN"},"death":{"date":"1937-01-13","location":null,"country_code":null},"photo_url":"https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Tomita-Tsunejiro.jpg/454px-Tomita-Tsunejiro.jpg","teachers":[{"id":"JDP-1","style_id":"JDP-S-1","place":"Kodokan","quality":null,"period":{"start":1882,"end":null}}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"7 dan","date":1937,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E5%AF%8C%E7%94%B0%E5%B8%B8%E6%AC%A1%E9%83%8E"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q2672426","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Tomita_Tsunejir%C5%8D","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Tomita_Tsunejiro.yaml","photo_url_local":"images/cache/f2ca4e8be5ae3fb80bbca86e4bd3b51c.jpg"}},{"data":{"id":"JDP-71","name":"Tomita Takeji","native_name":{"name":"\u6589\u85E4 \u5B88\u5F18","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1928-03-31","location":"Ibaraki","country_code":"JPN"},"death":{"date":"2002-05-13","location":"Iwama","country_code":"JPN"},"photo":{"url":"https://archive.org/download/takeji_tomita/takeji_tomita.png","source":{"uri":"https://www.aikidojournal.eu/docs/238/393_946_en.pdf","cite":"TAKEJI TOMITA: From studying with O-Sensei to the creation of A\xefki Shin Myo Den (Aikido Journal)"}},"teachers":[{"id":"JDP-70","style_id":"JDP-S-4","place":"Iwama D\u014Dj\u014D","quality":null,"period":{"start":1962,"end":1},"sources":[{"uri":"https://www.aikidojournal.eu/docs/238/393_946_en.pdf","cite":"TAKEJI TOMITA: From studying with O-Sensei to the creation of A\xefki Shin Myo Den (Aikido Journal)","citation":"From 1962 on, after his first visit in Iwama, he decides to follow the teaching of O\'Sensei and of his assistant, Morihiro Saito Sensei (...) In 1968, he becomes Morihiro Saito\'s Uchideshi and is rapidly adopted by the Master\'s family (...) Tomita Sensei practiced for about 7 years at the Iwama Dojo. Those years were for him formativeyears dedicated to education and to discovering the way of Budo."}]}],"rank":[{"style_id":"JDP-S-4","org":"Aikikai","teacher":null,"rank":"8 dan","date":null,"sources":[{"uri":"https://www.aikidojournal.eu/docs/238/393_946_en.pdf","cite":"TAKEJI TOMITA: From studying with O-Sensei to the creation of A\xefki Shin Myo Den (Aikido Journal)","citation":"Today an 8th Dan, Tomita Sensei still lives in Stockholm."}],"style":"Aikid\u014D","style_native":{"name":"\u5408\u6C17\u9053","lang":"ja"}}],"sources":[{"uri":"https://www.takemusuaiki.eu/master/"},{"uri":"https://www.aikidojournal.eu/docs/238/393_946_en.pdf"},{"uri":"https://aikidojournal.com/2011/08/27/takeji-tomita/"},{"uri":"https://takemusuaikichel.ru/en/tomita-sensei/"}],"source_yaml":"database/persons/JPN/Tomita_Takeji.yaml"}},{"data":{"id":"JDP-26","name":"Tomiki Kenji","native_name":{"name":"\u5BCC\u6728 \u8B19\u6CBB","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1900-03-15","location":"Yokomachi","country_code":"JPN"},"death":{"date":"1979-12-25","location":null,"country_code":null},"photo_url":"https://3.bp.blogspot.com/_Cwm1bGlUfkA/R7R9fVsP72I/AAAAAAAAANg/NjJTk4KTUqg/s400/tomiki_10.jpg","teachers":[{"id":"JDP-1","style_id":"JDP-S-1","place":null,"quality":null,"period":{"start":1895,"end":1896}},{"id":"JDP-27","style_id":"JDP-S-4","place":null,"quality":null,"period":{"start":1926,"end":null}}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"8 dan","date":1971,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}},{"style_id":"JDP-S-4","org":null,"teacher":"JDP-27","rank":"8 dan","date":1971,"style":"Aikid\u014D","style_native":{"name":"\u5408\u6C17\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Kenji_Tomiki"},{"uri":"https://ja.wikipedia.org/wiki/%E5%AF%8C%E6%9C%A8%E8%AC%99%E6%B2%BB"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q6389379","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Kenji_Tomiki","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Tomiki_Kenji.yaml","photo_url_local":"images/cache/01597240280937ae594546b0b42191db.jpg"}},{"data":{"id":"JDP-32","name":"Tamai Narimichi","native_name":{"name":null,"lang":null},"nationality":["JPN"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"photo_url":null,"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://aikidojournal.com/2018/10/15/the-last-swordsman-the-yoshio-sugino-story-part-2"}],"source_yaml":"database/persons/JPN/Tamai_Narimichi.yaml"}},{"data":{"id":"JDP-8","name":"Takino Y\u016Bken","native_name":{"name":"\u6EDD\u91CE\u904A\u8ED2","lang":"ja"},"nationality":["JPN"],"birth":{"date":1659,"location":"Tamba","country_code":"JPN"},"death":{"date":null,"location":null,"country_code":null},"teachers":[{"id":null,"style":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E8%B5%B7%E5%80%92%E6%B5%81"},{"uri":"https://doi.org/10.18002/rama.v13i2.5700"},{"uri":"https://www.ryoishintokai.com/2022/03/24/1819/","events":["birth"]}],"links":[{"uri":"https://www.wikidata.org/wiki/Q11565323","cite":"Wikidata"}],"source_yaml":"database/persons/JPN/Takino_Y\u016Bken.yaml"}},{"data":{"id":"JDP-6","name":"Takenaka Tetsunosuke Issei","native_name":{"name":"\u7AF9\u4E2D\u9244\u4E4B\u52A9\u4E00\u6E05","lang":"ja"},"nationality":["JPN"],"birth":{"date":1800,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"teachers":[{"id":"JDP-7","style_id":"JDP-S-2","place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E8%B5%B7%E5%80%92%E6%B5%81"},{"uri":"https://doi.org/10.18002/rama.v13i2.5700"}],"source_yaml":"database/persons/JPN/Takenaka_Tetsunosuke.yaml"}},{"data":{"id":"JDP-7","name":"Takenaka  Motonoshin","native_name":{"name":"\u7AF9\u4E2D\u5143\u4E4B\u9032","lang":"ja"},"nationality":["JPN"],"birth":{"date":1775,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"teachers":[{"id":"JDP-8","style_id":"JDP-S-2","place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E8%B5%B7%E5%80%92%E6%B5%81"},{"uri":"https://doi.org/10.18002/rama.v13i2.5700"}],"source_yaml":"database/persons/JPN/Takenaka_Motonoshin.yaml"}},{"data":{"id":"JDP-28","name":"Takeda S\u014Dkaku","native_name":{"name":"\u6B66\u7530 \u60E3\u89D2","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1859-10-10","location":"Aizu","country_code":"JPN"},"death":{"date":"1943-04-25","location":null,"country_code":"JPN"},"photo_url":"https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Takeda_Sokaku.jpg/220px-Takeda_Sokaku.jpg","teachers":[{"name":null,"style":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style":"Dait\u014D-ry\u016B Aiki-j\u016Bjutsu","org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E5%AF%8C%E6%9C%A8%E8%AC%99%E6%B2%BB"},{"uri":"https://aikidojournal.com/2011/09/02/interview-with-kenji-tomiki-1-2/"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q503880","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Takeda_S%C5%8Dkaku","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Takeda_Sokaku.yaml","photo_url_local":"images/cache/88929a754386f464b40986a0ba0da928.jpg"}},{"data":{"id":"JDP-14","name":"Takahashi Kazuyoshi","native_name":{"name":"\u9AD8\u6A4B\u6570\u826F","lang":"ja"},"nationality":["JPN"],"birth":{"date":1855,"location":null,"country_code":"JPN"},"death":{"date":1942,"location":null,"country_code":null},"description":null,"photo_url":null,"teachers":[{"id":"JDP-9","style_id":"JDP-S-1","place":"Kodokan","quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"8 dan","date":null,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://www.researchgate.net/publication/277665808_Kodokan_Judo\'s_three_orphaned_forms_of_counter_techniques_-_Part_1_The_gonosen-no-kata_-_Forms_of_post-attack_initiative_counter_throws"}],"source_yaml":"database/persons/JPN/Takahashi_Kazuyoshi.yaml"}},{"data":{"id":"JDP-30","name":"Sugino Yoshio","native_name":{"name":"\u6749\u91CE\u5609\u7537","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1904-12-12","location":"Tokyo","country_code":"JPN"},"death":{"date":"1998-06-13","location":"Narut\u014D, Chiba","country_code":"JPN"},"photo_url":"https://2.bp.blogspot.com/-y8nNNMaK3cs/VLvcojO-fRI/AAAAAAAAbOM/HzykaZ2XkJw/s1600/Yoshio%2BSugino.jpg","teachers":[{"id":"JDP-31","style_id":"JDP-S-1","place":"Kei\u014D Gijuku Daigaku","period":{"start":1918,"end":1919},"quality":2},{"id":"JDP-27","style_id":"JDP-S-4","place":"Wakamatsu-cho dojo","period":{"start":1931,"end":1935},"quality":2},{"id":"JDP-32","style_id":"JDP-S-6","place":"Kawasaki","period":{"start":1927,"end":null},"quality":1},{"id":"JDP-33","style_id":"JDP-S-6","place":"Kawasaki","period":{"start":1927,"end":null},"quality":1},{"id":"JDP-34","style_id":"JDP-S-6","place":"Kawasaki","period":{"start":1927,"end":null},"quality":1},{"id":"JDP-35","style_id":"JDP-S-6","place":"Kawasaki","period":{"start":1927,"end":null},"quality":1},{"id":"JDP-36","style_id":"JDP-S-7","place":null,"period":{"start":1928,"end":null},"quality":1}],"rank":[{"style":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E6%9D%89%E9%87%8E%E5%98%89%E7%94%B7"},{"uri":"https://en.wikipedia.org/wiki/Yoshio_Sugino"},{"uri":"https://ejmas.com/jcs/jcsart_svinth_0702.htm"},{"uri":"https://www.judo-ch.jp/english/legend/iizuka/"},{"uri":"https://www.aikidosangenkai.org/blog/interview-yoshio-sugino-katori-shinto/"},{"uri":"https://aikidojournal.com/2018/10/08/the-last-swordsman-the-yoshio-sugino-story-part-1/"},{"uri":"https://aikidojournal.com/2018/10/15/the-last-swordsman-the-yoshio-sugino-story-part-2/"},{"uri":"https://web.archive.org/web/20111204190328/http://www.aikidojournal.com/article.php?articleID=3"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q8056250","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Yoshio_Sugino","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Sugino_Yoshio.yaml","photo_url_local":"images/cache/204acc1061913636de7a1118afce89fe.jpg"}},{"data":{"id":"JDP-40","name":"Shingai Tadaatsu","native_name":{"name":"\u771F\u8C9D\u5FE0\u7BE4","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1842-03-01","location":null,"country_code":"JPN"},"death":{"date":"1920-02-09","location":null,"country_code":"JPN"},"photo_url":null,"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E7%9C%9F%E8%B2%9D%E5%BF%A0%E7%AF%A4"},{"uri":"https://en.wikipedia.org/wiki/Kenjutsu"},{"uri":"https://en.wikipedia.org/wiki/Tamiya-ry%C5%AB_(Tsumaki)"}],"source_yaml":"database/persons/JPN/Shingai_Tadaatsu.yaml"}},{"data":{"id":"JDP-35","name":"Shiina Ichizo","native_name":{"name":"\u690E\u540D\u5E02\u8535","lang":"ja"},"nationality":["JPN"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"photo_url":null,"teachers":[{"id":"JDP-116","style_id":"JDP-S-6","place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/","cite":"Exkurs: Die moderne Geschichte der Katori Shint\xf4 ry\xfb (Ein Leben f\xfcr die Schwertkunst)","citation":"Iisasa Morisada (sieben direkte Sch\xfcler): Yamaguchi Kumajir\xf4 Eikan Mairaku / Tamai Said\xf4 / Noguchi Jizaemon / Ono Heishichir\xf4 Moriichi / Shiina Ichiz\xf4 / Hong\xfb Toranosuke / Kaneko Shinosh\xf4"}]}],"rank":[{"style":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://aikidojournal.com/2018/10/15/the-last-swordsman-the-yoshio-sugino-story-part-2"},{"uri":"https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/"},{"uri":"https://ja.wikipedia.org/wiki/%E8%AC%9B%E9%81%93%E9%A4%A8"}],"source_yaml":"database/persons/JPN/Shiina_Ichizo.yaml"}},{"data":{"id":"JDP-22","name":"Satake Soshihiro","aka":[{"name":"Ant\xf4nio Satake"},{"name":"Nobushiro Satake"}],"nationality":["JPN","BRA"],"birth":{"date":null,"location":null,"country_code":"JPN"},"death":{"date":null,"location":null,"country_code":null},"photo_url":"https://2.bp.blogspot.com/_NjSHIRBuf3Y/S84w0kJnWrI/AAAAAAAABrg/eFg_AlSH4Cw/s1600/Nobushiro_Satake.jpg","teachers":[{"id":"JDP-9","style_id":"JDP-S-1","place":null,"period":{"start":1892,"end":null},"quality":1,"sources":[{"uri":"https://simonbjj.com/satake","cite":"The Sumo wrestle who taught BJJ, Soshiro Satake","citation":"At some point later, probably in the late 1890\u2019s, he joined the Kodokan and would become peers of Mitsuyo Maeda. The two judoka trained together under Sakujiro Yokoyama, who was known as one of the Four Guardians of the Kodokan"},{"uri":"https://ja.wikipedia.org/wiki/%E4%BD%90%E7%AB%B9%E4%BF%A1%E5%9B%9B%E9%83%8E","citation":"1892\u5E74\uFF08\u660E\u6CBB25\u5E74\uFF095\u6708\u306B\u8B1B\u9053\u9928\u306B\u5165\u9580"}]}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"3 dan","date":null,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Soshihiro_Satake"},{"uri":"https://repositorio.ufsc.br/handle/123456789/103771"},{"uri":"https://web.archive.org/web/20240507104820/https://www.faddabjj.com/historia-fadda"},{"uri":"http://judotradicionalgoshinjutsukan.blogspot.com/2009/08/mitsuyo-maeda-nasc.html"}],"source_yaml":"database/persons/JPN/Satake_Soshihiro.yaml","photo_url_local":"images/cache/5a789699a4256fc5c95059913972a8fd.jpg"}},{"data":{"id":"JDP-70","name":"Sait\u014D Morihiro","native_name":{"name":"\u6589\u85E4 \u5B88\u5F18","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1928-03-31","location":"Ibaraki","country_code":"JPN"},"death":{"date":"2002-05-13","location":"Iwama","country_code":"JPN"},"photo":{"url":"https://archive.org/download/morihiro-saito_formal/morihiro-saito_formal.jpg","source":{"uri":"https://aikidojournal.com/2003/02/28/interview-with-morihiro-saito-part-1-1987/","cite":"Interview with Morihiro Saito - Part 1 (Aikido Journal)"}},"description":{"en":"Morihiro Saito (\u6589\u85E4 \u5B88\u5F18 Sait\u014D Morihiro) was a teacher of the Japanese martial art of aikido, with many students around the world. Saito\'s practice of aikido spanned 56 years, from the age of 18, when he first met aikido founder Morihei Ueshiba, until his death in 2002.  The kind of aikido that Saito\'s students do is often referred to as Iwama aikido or Iwama style. In Europe, Saito, along with many of his students, formed a dan-ranking network of dojos called Iwama Ryu, with ranks received directly from Saito rather than or in addition to those from the Aikikai although Saito never left that organization.\\n"},"teachers":[{"id":"JDP-27","style_id":"JDP-S-4","place":"Iwama D\u014Dj\u014D","quality":null,"period":{"start":1946,"end":1969},"sources":[{"uri":"https://en.wikipedia.org/wiki/Morihiro_Saito","citation":"It was at this time, at the age of 18, that Saito joined Ueshiba for training (...) From 1946 until Ueshiba\u2019s passing in 1969, Saito served as Ueshiba\'s assistant in a variety of ways at Iwama while his wife served Mrs. Ueshiba. During Saito\u2019s period as a deshi he taught classes in the Iwama dojo."}]}],"rank":[{"style_id":"JDP-S-4","org":"Aikikai","teacher":null,"rank":"9 dan","date":null,"sources":[{"uri":"https://www.saitosensei.com/1990s/","citation":"1992. Mrs. Saito and Saito Sensei in regal formal attire at his huge first party in Iwama\u2019s Kabuki Wedding Palace, celebrating his promotion to 9th dan by Honbu Aikikai and the 50th anniversary of aikido in Iwama"}],"style":"Aikid\u014D","style_native":{"name":"\u5408\u6C17\u9053","lang":"ja"}}],"sources":[{"uri":"https://saito-sensei.org/"},{"uri":"https://en.wikipedia.org/wiki/Morihiro_Saito"},{"uri":"https://www.saitosensei.com"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q550626","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Morihiro_Saito","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Saito_Morihiro.yaml"}},{"data":{"id":"JDP-121","name":"Saig\u014D Shir\u014D","native_name":{"name":"\u897F\u90F7\u56DB\u90CE","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1866-01-04","location":"Aizuwakamatsu, Fukushima","country_code":"JPN"},"death":{"date":"1922-12-22","location":"Onomichi","country_code":"JPN"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/f/f6/Saigo_Shirou.jpg","source":{"uri":"https://en.wikipedia.org/wiki/Shiro_Saigo#/media/File:Saigo-Shiro.jpg","cite":"Saigo Shiro, Wikimedia Commons"}},"description":{"en":"Shiro Saigo (\u897F\u90F7\u56DB\u90CE, Saig\u014D Shir\u014D, February 4, 1866 \u2013 December 22, 1922) was one of the earliest disciples of Judo. Saigo, together with Tsunejiro Tomita, became first in history of judo to be awarded Shodan by the founder of judo Jigoro Kano, who established the kyu-dan ranking system. He was one of the K\u014Dd\u014Dkan Shitenn\u014D or Four Guardians of the Kodokan along with Yoshitsugu Yamashita, Sakujiro Yokoyama, and Tsunejiro Tomita.\\n"},"teachers":[{"id":"JDP-1","style_id":"JDP-S-1","place":"Kodokan","period":{"start":1882,"end":1890},"quality":3,"sources":[{"uri":"urn:isbn:1425163491","cite":"WATSON, Brian N. Judo memoirs of Jigoro Kano. Trafford Publishing, 2008","location":"p. 20","citation":"Shortly thereafter, in August 1882, the now famous Shiro Saigo became a student of mine"}]}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":"JPN/Kano_Jigoro","rank":"6 dan","date":"1923-01-14","sources":[{"uri":"https://www.judo-ch.jp/english/legend/saigou/","citation":"January, 1923: 6th Dan (...) Upon receiving news of his death, Jigoro Kano awarded him a posthumous promotion to the 6th Dan on January 14, 1923"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://www.judo-ch.jp/english/legend/saigou/"},{"uri":"https://ja.wikipedia.org/wiki/\u897F\u90F7\u56DB\u90CE"},{"uri":"https://judoinfo.com/saigo/"}],"source_yaml":"database/persons/JPN/Saigo_Shiro.yaml"}},{"data":{"id":"JDP-112","name":"\u014Ctake Risuke","native_name":{"name":"\u5927\u7AF9\u5229\u5178","lang":"ja"},"aka":[{"name":"\u014Ctake Risuke Minamoto no Takeyuki"},{"name":"\u5927\u7AF9\u5229\u5178\u6E90\u5065\u4E4B","lang":"ja"}],"nationality":["JPN"],"birth":{"date":"1926-03-10","location":null,"country_code":"JPN"},"death":{"date":"2021-06-07","location":null,"country_code":"JPN"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/7/78/Risuke_%C5%8Ctake.jpg","source":{"uri":"https://en.wikipedia.org/wiki/Risuke_Otake#/media/File:Risuke_%C5%8Ctake.jpg","cite":"Risuke \u014Ctake, Japanese swordsman (Wikipedia Commons)"}},"teachers":[{"id":"JDP-113","style_id":"JDP-S-6","place":null,"period":{"start":null,"end":null},"quality":2,"sources":[{"uri":"https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/","cite":"Exkurs: Die moderne Geschichte der Katori Shint\xf4 ry\xfb (Ein Leben f\xfcr die Schwertkunst)","citation":"Iisasa Morisada (sieben direkte Sch\xfcler): Yamaguchi Kumajir\xf4 Eikan Mairaku / Tamai Said\xf4 / Noguchi Jizaemon / Ono Heishichir\xf4 Moriichi / Shiina Ichiz\xf4 / Hong\xfb Toranosuke / Kaneko Shinosh\xf4 (...) Hayashi Saiichir\xf4 \u2013> Hayashi Yazaemon \u2013> \xd4take Risuke"}]}],"rank":[{"style":"JDP-S-6","org":null,"teacher":"JDP-113","rank":"Gokui kaiden","date":1967,"sources":[{"uri":"https://katorivietnam.org/otake-risuke-nippon-budokan-magazine-interview-about-katori-shinto-ryu-and-its-tradition-2020/","cite":"Otake Risuke Nippon Bud\u014Dkan Magazine Interview (Shobukan Dojo)","citation":"That year, I received the Gokui Kaiden scroll and a proof signifying that I have attained Gokui S\u014Dden from Hayashi-sensei. Sensei told me, \u201CCall yourself Gokui Kaiden once you are 42 years old.\u201D At the time I was 32 years old, so I think it was to be in accordance with the rules of our school."},{"uri":"https://shinbukan-katorishintoryu.org/?page_id=898&lang=en","cite":"Tenshinsho-den Katori Shinto Ryu - Shinbukan Dojo","citation":"Shinbukan Dojo\u2019s practice of Katori Shinto Ryu follows the teachings passed down from Hayashi Sakuichiro Shihan to Hayashi Yazaemon Shihan, who was then succeeded by Otake Risuke Shihan (Shinbukan Dojo founder)."}]}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Risuke_Otake"},{"uri":"https://ja.wikipedia.org/wiki/%E5%A4%A7%E7%AB%B9%E5%88%A9%E5%85%B8"},{"uri":"https://katorivietnam.org/otake-risuke-nippon-budokan-magazine-interview-about-katori-shinto-ryu-and-its-tradition-2020/"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q3433225","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Risuke_Otake","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Otake_Risuke.yaml"}},{"data":{"id":"JDP-46","name":"Oshima Masateru","native_name":{"name":null,"lang":null},"nationality":["JPN"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"photo_url":null,"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://kanochronicles.com/the-kodokan-and-bojutsu-jo-staff-fighting-and-judo/"},{"uri":"https://www.worldcat.org/title/952578913"}],"source_yaml":"database/persons/JPN/Oshima_Masateru.yaml"}},{"data":{"id":"JDP-131","name":"\u014Csawa Yoshimi","native_name":{"name":"\u5927\u6CA2 \u5409\u5DF1","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1926-03-06","location":"Munakata, Inba District, Chiba Prefecture","country_code":"JPN"},"death":{"date":"2022-10-21","location":"","country_code":"JPN"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/9/96/Yoshimi_%C5%8Csawa.jpg","source":{"uri":"https://upload.wikimedia.org/wikipedia/commons/9/96/Yoshimi_%C5%8Csawa.jpg","cite":"Japanese judoka Yoshimi Osawa, pictured here after winning the 4th Tokyo Judoka Championship in 1953 (Wikipedia)"}},"teachers":[{"id":"JDP-11","style_id":"JDP-S-1","place":"Waseda University Judo Club","period":{"start":"1943","end":null},"quality":3,"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E5%A4%A7%E6%B2%A2%E6%85%B6%E5%B7%B1","cite":"\u5927\u6CA2\u5409\u5DF1 - \u65E5\u672C\u8A9E\u7248\u30A6\u30A3\u30AD\u30DA\u30C7\u30A3\u30A2","citation":"1943\u5E744\u6708\u306B\u65E9\u7A32\u7530\u5927\u5B66\u306B\u5165\u5B66\u3057\u67D4\u9053\u90E8\u306B\u5165\u90E8\u3059\u308B\u3068\u3001\u5E2B\u7BC4\u306B\u306F\u4E09\u8239\u4E45\u8535\u3084\u5FB3\u4E09\u5B9D\u3089\u304C\u9854\u3092\u63C3\u3048\u3001\u6708\u306B1\u5EA6\u307B\u3069\u3067\u306F\u3042\u3063\u305F\u304C\u6307\u5C0E\u306B\u6765\u3066\u305D\u306E\u85AB\u9676\u3092\u53D7\u3051\u305F"}]}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","rank":"10 dan","date":"2006","sources":[{"uri":"https://judoinfo.com/judan2/","cite":"Kodokan 10th Dan Promotions - JudoInfo","citation":"Ichiro Abe (83 years old), Toshiro Daigo (80 years old) and Yoshimi Osawa (79 years old) were promoted to 10th Dan"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Yoshimi_Osawa"},{"uri":"https://ja.wikipedia.org/wiki/%E5%A4%A7%E6%B2%A2%E6%85%B6%E5%B7%B1"},{"uri":"https://judoinfo.com/judan2/"}],"source_yaml":"database/persons/JPN/Osawa_Yoshimi.yaml"}},{"data":{"id":"JDP-103","name":"Geo Omori","native_name":{"name":"\u5927\u68EE \u57CE\u53F8","lang":"ja"},"aka":["Jyoji Omori"],"nationality":["BRA","JPN"],"birth":{"date":"1898","location":"Tokyo","country_code":"JPN"},"death":{"date":"1938-03-02","location":"Belo Horizonte","country_code":"BRA"},"photo":{"url":"https://archive.org/download/geo-omori/geo-omori.jpg","source":{"uri":"https://forum.bjjforum.com.br/","cite":"BJJ Forum"}},"teachers":[{"id":"JDP-104","style_id":"JDP-S-1","place":null,"period":{"start":null,"end":null},"quality":null,"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 153","citation":"Foi disc\xedpulo de um dos maiores lutadores do Kodokan, Tokugoro Ito"},{"uri":"https://en.wikipedia.org/wiki/Geo_Omori","citation":"He learned under Tokugoro Ito and was a training partner of the famed Sanpo Toku"}]}],"rank":[{"style_id":"JDP-S-1","org":null,"teacher":null,"rank":"2 dan","date":null,"sources":[{"uri":"https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php","cite":"MA\xc7ANEIRO, Gustavo Goulart Braga. Desenvolvimento organizacional do jud\xf4 brasileiro. S\xe3o Paulo : Escola de Educa\xe7\xe3o F\xedsica e Esporte, Universidade de S\xe3o Paulo, 2024. Disserta\xe7\xe3o de Mestrado em Estudos Socioculturais e Comportamentais da Educa\xe7\xe3o F\xedsica e Esporte","citation":"Geo Omori 2\xba dan n\xe3o oficial"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Geo_Omori"},{"uri":"https://isbnsearch.org/isbn/9798639871030"},{"uri":"https://podcasters.spotify.com/pod/show/budokast0/episodes/Budokast-04---Geo-Omori-e-o-Jiu-Jitsu-Brasileiro-e8cbdt"}],"source_yaml":"database/persons/JPN/Omori_Jyoji.yaml"}},{"data":{"id":"JDP-38","name":"Okano Yoshitaro","native_name":{"name":"\u5CA1\u91CE\u597D\u592A\u90CE","lang":"ja"},"aka":[{"name":"Okano Kotaru","native_name":[{"name":"\u5CA1\u91CE\u597D\u592A\u90CE","lang":"ja"}]}],"nationality":["JPN"],"birth":{"date":"1885-04-24","location":"Tonosh\u014D","country_code":"JPN"},"death":{"date":"1967-06-02","location":null,"country_code":"JPN"},"photo_url":"https://archive.org/download/okano/okano.jpg","teachers":[{"name":null,"style_id":"JDP-S-3","place":null,"period":{"start":null,"end":null},"quality":1},{"id":"JDP-42","style_id":"JDP-S-9","place":null,"period":{"start":null,"end":null},"quality":0},{"id":"JDP-43","style_id":"JDP-S-1","place":"Butokuden","period":{"start":1906,"end":null},"quality":1},{"id":"JDP-44","style_id":"JDP-S-1","place":"Butokuden","period":{"start":1906,"end":null},"quality":1}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"10 dan","date":"1967-06-02","style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"http://kodokanjudoinstitute.org/doctrine/palace/yoshitaro-okano/"},{"uri":"https://ja.wikipedia.org/wiki/%E7%84%A1%E7%9B%B8%E6%B5%81"}],"source_yaml":"database/persons/JPN/Okano_Yoshitaro.yaml","photo_url_local":"images/cache/ef589301a9079949fe6001e90aa1e174.jpg"}},{"data":{"id":"JDP-126","name":"Ogawa Ryuzo","native_name":{"name":"\u5C0F\u5DDD \u9F8D\u9020","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1885","location":"Taira, Fukushima","country_code":"JPN"},"death":{"date":"1974","location":"","country_code":"JPN"},"photo":{"url":"https://archive.org/download/ogawa/ogawa.jpg","source":{"uri":"https://fpj.com.br/","cite":"Mestre Ryuzo Ogawa, fundador do Hombu Doj\xf4 Budokan (FPJudo)"}},"teachers":[{"name":"","style_id":"","place":null,"period":{"start":null,"end":null},"quality":null,"sources":[{"uri":"urn:isbn:1425163491","cite":"Os Pioneiros do Jud\xf4 no Brazil, Chiaki Ishii, 2015"}]},{"name":"","style_id":"","place":null,"period":{"start":null,"end":null},"quality":null,"sources":[{"uri":"urn:isbn:1425163491","cite":"Os Pioneiros do Jud\xf4 no Brazil, Chiaki Ishii, 2015"}]}],"rank":[{"style_id":"JDP-S-1","rank":"5 dan","date":"1954","org":"Dai Nippo Butokukai","quality":2,"sources":[{"uri":"https://judo.forumotion.com/t3031-japanese-certificate-help-again","cite":"Japanese Certificate - Help Again [Ryuzo Ogawa] (E-Judo)","citation":"Ogawa Ryuzo signed far left. The three vertical columns are his positions, right to left: 5th dan judo, Dai Nihon Butokukai / Member, Greater Japan Ancient Martial Arts Preservation Society / Shihan, Kashima Shin\'yo Ryu Jujutsu Judo"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}},{"style_id":"JDP-S-1","rank":"8 dan","date":"1954","org":"Dai Nippo Butokukai","quality":2,"sources":[{"uri":"https://revistabudo.com.br/a-partir-de-2022-a-federacao-paulista-de-judo-realizara-os-campeonatos-do-hombu-dojo-budokan/","cite":"A partir de 2022, a Federa\xe7\xe3o Paulista de Jud\xf4 realizar\xe1 os campeonatos do Hombu Doj\xf4 Budokan (Revista Bud\xf4)","citation":"Ap\xf3s o falecimento de Ryuzo, que conquistara a gradua\xe7\xe3o hachi-dan (8\xba dan), quem assumiu foi o pai de Hitoshi e Hatiro, Matsuo Ogawa"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"urn:isbn:1425163491"},{"uri":"https://books.google.pt/books?id=WtgDAAAAMBAJ&pg=PA23"},{"uri":"https://ge.globo.com/judo/noticia/2014/09/precursor-na-difusao-do-judo-no-pais-ryuzo-ogawa-e-uma-lenda-do-esporte.html"},{"uri":"https://pt.wikipedia.org/wiki/Jud%C3%B4_do_Brasil"},{"uri":"https://www.revistas.usp.br/rbefe/article/view/52889/56819"},{"uri":"https://isbnsearch.org/isbn/9798639871030"}],"source_yaml":"database/persons/JPN/Ogawa_Ryuzo.yaml"}},{"data":{"id":"JDP-59","name":"Ogawa Kinnosuke","native_name":{"name":"\u5C0F\u5DDD \u91D1\u4E4B\u52A9","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1884","location":"Aiichi","country_code":"JPN"},"death":{"date":"1962","location":null,"country_code":null},"description":{"en":"Ogawa Kinnosuke was born in 1884 in Aiichi prefecture. He began kendo whilst in school, at around 13/15 years of age, under kendo hanshi Kato Kiichi and later under Kohori Yasutada. In his late teens and very early 20s he taught kendo at a middle school and joined the army (field gunnery position) before being employed by Nagoya police department. He was a student and later an instructor at the Budo Senmon Gakko, as well as in the Nagoya police. He was a Butokukai hanshi and was Busen\'s principle kendo instructor in the 1930\'s and up until 1945."},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/%E5%B0%8F%E5%B7%9D%E9%87%91%E4%B9%8B%E5%8A%A9.png/220px-%E5%B0%8F%E5%B7%9D%E9%87%91%E4%B9%8B%E5%8A%A9.png","source":{"uri":"https://commons.wikimedia.org/wiki/File:%E5%B0%8F%E5%B7%9D%E9%87%91%E4%B9%8B%E5%8A%A9.png","cite":"\u5C0F\u5DDD\u91D1\u4E4B\u52A9 - Wikimedia Commons"}},"teachers":[{"id":"JDP-60","style_id":"JDP-S-8","place":"Bud\u014D Senmon Gakko","period":{"start":1907,"end":1910},"quality":3,"sources":[{"uri":"https://web.archive.org/web/20090218133219/http://rrjudo.com/history/zenjudo.htm","cite":"Ogawa Kinnosuke - Kenshi 24/7","citation":"In 1905 a school was formally opened to teach kendo instructors and Naito was selected as the senior teacher. At this time the school was known as the Bujutsu Kyoin Yoseijo, but eventually (after a few re-organisations and renames) it would be known to everyone as Busen (Budo Senmon Gakko). It was to this school that Ogawa was dispatched by the Nagoya police department in 1907. Ogawa would spend 3 years studying kendo directly under Naito."}]}],"rank":[{"style_id":"JDP-S-8","org":"Dai-Nippon Butoku Kai","teacher":null,"rank":"Hanshi","date":null,"style":"Kendo","style_native":{"name":"\u5263\u9053","lang":"ja"}},{"style_id":"JDP-S-8","org":"Zen Nippon Kendo Renmei","teacher":null,"rank":"10 dan","date":1957,"style":"Kendo","style_native":{"name":"\u5263\u9053","lang":"ja"}}],"sources":[{"uri":"https://kenshi247.net/blog/2015/05/22/ogawa-kinnosuke/"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q11460626","cite":"Wikidata"}],"source_yaml":"database/persons/JPN/Ogawa_Kinnosuke.yaml"}},{"data":{"id":"JDP-124","name":"Oda Tsunetane","aka":[{"name":"Join Oda"}],"native_name":{"name":"\u7530\u5E38\u80E4","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1892-03-10","location":"Yamanashi Prefecture","country_code":"JPN"},"death":{"date":"1955-02-11","location":"Shinjuku","country_code":"JPN"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/b/b7/J%C5%8Din_Oda.jpg","source":{"uri":"https://en.wikipedia.org/wiki/Tsunetane_Oda","cite":"Japanese judoka Oda - Wikipedia"}},"teachers":[{"id":null,"style_id":null,"place":null,"period":{"start":null,"end":null},"quality":null}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","rank":"9 dan","date":"1948","quality":3,"sources":[{"uri":"https://judoinfo.com/oda/","cite":"Master Tsunetane Oda - JudoInfo","citation":"Many years later in 1948, on the occasion of his promotion to 9th Dan, Master Oda published his third edition of Koshita Judo Wa Sushume"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://judoinfo.com/oda/"},{"uri":"https://en.wikipedia.org/wiki/Tsunetane_Oda"}],"source_yaml":"database/persons/JPN/Oda_Tsunetane.yaml"}},{"data":{"id":"JDP-60","name":"Nait\u014D Takaharu","native_name":{"name":"\u5185\u85E4\u9AD8\u6CBB","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1862","location":"Mito","country_code":"JPN"},"death":{"date":"1929","location":null,"country_code":null},"description":{"en":"A swordsman of the Hokushin Itt\u014D-ry\u016B, Nait\u014D taught kendo to the Japanese Police force, and was also the first teacher at the Budo Senmon Gakko. He helped to create the Dai Nihon Teikoku Kendo Kata, a group that promulgated the practice of kendo in Japanese schools and universities under the auspices of the Dai Nippon Butoku Kai."},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Nait%C5%8D_Takaharu_%28%E5%86%85%E8%97%A4%E9%AB%98%E6%B2%BB%29.jpg/220px-Nait%C5%8D_Takaharu_%28%E5%86%85%E8%97%A4%E9%AB%98%E6%B2%BB%29.jpg","source":{"uri":"https://en.wikipedia.org/wiki/Nait%C5%8D_Takaharu#/media/File:Nait%C5%8D_Takaharu_(%E5%86%85%E8%97%A4%E9%AB%98%E6%B2%BB).jpg","cite":"Nait\u014D Takaharu (\u5185\u85E4\u9AD8\u6CBB) - Wikimedia Commons"}},"teachers":[{"id":null,"style_id":null,"place":null,"period":{"start":null,"end":null},"quality":null}],"rank":[{"style_id":"JDP-S-8","org":"Dai-Nippon Butoku Kai","teacher":null,"rank":"Hanshi","date":null,"sources":[{"uri":"https://kenshi247.net/blog/2013/10/16/monna-tadashi/","cite":"Monna Tadashi - Kenshi 24/7","citation":"In 1913, at the same time as Naito Takaharu and Takano Sasaburo, he was awarded hanshi."}],"style":"Kendo","style_native":{"name":"\u5263\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Nait%C5%8D_Takaharu"},{"uri":"https://kenshi247.net/blog/2020/06/17/finding-naito/"},{"uri":"https://kenshi247.net/blog/2012/12/04/naito-takaharu/"},{"uri":"https://ja.wikipedia.org/wiki/%E5%86%85%E8%97%A4%E9%AB%98%E6%B2%BB"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q11394577","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Nait%C5%8D_Takaharu","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Naito_Takaharu.yaml"}},{"data":{"id":"JDP-44","name":"Nagaoka Sh\u016Bichi","native_name":{"name":"\u6C38\u5CA1 \u79C0\u4E00","lang":"ja"},"aka":[{"name":"Nagaoka Hideichi"}],"nationality":["JPN"],"birth":{"date":"1876-09-17","location":"Okayama","country_code":"JPN"},"death":{"date":"1952-11-22","location":null,"country_code":null},"photo_url":"https://archive.org/download/nagaoka_hideichi/nagaoka_hideichi.jpg","teachers":[{"name":"Noda Kensaburo","style_id":"JDP-S-2","place":null,"quality":null,"period":{"start":null,"end":null}},{"id":"JDP-1","style_id":"JDP-S-1","place":"Kodokan","quality":null,"period":{"start":1891,"end":null}}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"10 dan","date":"1937-12-27","style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Shuichi_Nagaoka"},{"uri":"https://www.judo-ch.jp/english/legend/nagaoka/"}],"source_yaml":"database/persons/JPN/Nagaoka_Shuici.yaml","photo_url_local":"images/cache/11a297ba540c94bd025868da5eb45e1b.jpg"}},{"data":{"id":"JDP-94","name":"Murakami Tetsuji","native_name":{"name":"\u6751\u4E0A \u54F2\u6B21","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1927-03-31","location":"Shizuoka","country_code":"JPN"},"death":{"date":"1987-01-24","location":"Paris","country_code":"FRA"},"photo":{"url":"https://archive.org/download/mura-4/Mura4.jpg","source":{"uri":"https://karate-shotokai.blogspot.com/2014/08/mestre-tetsuji-murakami.html","cite":"Mestre Tetsuji Murakami (Karate-do Shotokai)"}},"teachers":[{"id":"JDP-93","style_id":"JDP-S-5","place":null,"quality":2,"period":{"start":1968,"end":null},"sources":[{"uri":"https://shotokai.com/tetsuji-murakami/","cite":"Tetsuji Murakami Sensei (Shotokai Encyclopedia)","citation":"In 1968 he travels to Japan where he meets Master Shigeru Egami. Very impressed by Master Egami and the technique he observes, he decides to make a profound and very difficult transformation in his technique and his practice. He returns to Europe as the representative of the Nihon Karate-do Shotokai."},{"uri":"https://kogenbudo.org/interview-with-master-nuno-russo-by-pedro-escudeiro/","cite":"https://kogenbudo.org/interview-with-master-nuno-russo-by-pedro-escudeiro/","citation":" A couple of years later, though, we had our first international seminar with a Japanese karate master: Murakami Tetsuji, from Shotokai Karate, a student of Egami Shigeru sensei. After this seminar, Murakami sensei became the leader of our karate group"}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null,"quality":null}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Tetsuji_Murakami"},{"uri":"https://shotokai.com/tetsuji-murakami/"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q3519204","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Tetsuji_Murakami","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Murakami_Tetsuji.yaml"}},{"data":{"id":"JDP-29","name":"Mochizuki Minoru","native_name":{"name":"\u671B\u6708 \u7A14","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1907-04-07","location":"Shizuoka","country_code":"JPN"},"death":{"date":"2003-05-30","location":"Aix-en-Provence","country_code":"FRA"},"photo_url":"https://upload.wikimedia.org/wikipedia/commons/9/97/Minoru_Mochizuki_c1930.jpg","teachers":[{"id":"JDP-1","style_id":"JDP-S-1","place":"Kodokan","quality":null,"period":{"start":1925,"end":1930}},{"id":"JDP-11","style_id":"JDP-S-1","place":"Kodokan","quality":null,"period":{"start":1925,"end":1930}},{"id":"JDP-27","style_id":"JDP-S-4","place":"Kobukan dojo","quality":null,"period":{"start":1930,"end":null},"sources":[{"uri":"https://aikidojournal.com/2002/11/18/interview-with-minoru-mochizuki-1/","citation":"That was back in 1930 when Ueshiba Sensei still didn\u2019t have a place of his own and was teaching in the living room of a regular private house in the Mejiro area of Tokyo. But just after we started going there, we all moved to the newly finished Ushigome dojo (site of the present Hombu Dojo)"}]},{"id":"JDP-41","style_id":"JDP-S-5","place":null,"period":{"start":null,"end":null},"quality":1,"sources":[{"uri":"https://www.ffkarate.fr/hiroo-mochizuki-interview-yoseikan-budo/","citation":"El\xe8ve de Jigoro Kano, qui l\u2019avait envoy\xe9 apprendre l\u2019a\xefkido aupr\xe8s de Morihei Ueshiba, Minoru Mochizuki avait aussi travaill\xe9 avec Gichin Funakoshi. [...]  C\u2019\xe9tait la responsabilit\xe9 d\u2019une vie pour lui, car c\u2019est la mission que lui avait confi\xe9 Jigoro Kano. Mais il se trouvait un peu faible du point de vue des at\xe9mis, qu\u2019il avait pourtant \xe9tudi\xe9 avec Funakoshi"},{"uri":"https://books.google.pt/books?id=SdYDAAAAMBAJ&pg=PA34#v=onepage&q&f=false","cite":"A Man of Many Budo (interview with Minoru Mochizuki), Black Belt, Aug 1989.","citation":"Minoru Mochizuki holds the distinction of being the only living man to have studied with aikido founder Morihei Uyeshiba, judo founder Jigoro Kano, and \\"the father of Japanese karate, Gichin Funakoshi."}]},{"name":"Sanjuro Oshima","style":"Gyokushin Ryu","place":null,"quality":null,"period":{"start":1924,"end":null}}],"rank":[{"style":"Gyokushin Ryu","org":null,"teacher":"Sanjuro Oshima","rank":"Shoden Kirishi Mokuroku","date":1924},{"style_id":"JDP-S-10","org":null,"teacher":"JDP-27","rank":null,"date":1924,"style":"Dait\u014D-ry\u016B Aiki-j\u016Bjutsu","style_native":{"name":"\u5927\u6771\u6D41 \u5408\u6C17\u67D4\u8853","lang":"ja"}},{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"8 dan","date":null,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://aikidojournal.com/2002/11/18/interview-with-minoru-mochizuki-1/"},{"uri":"https://en.wikipedia.org/wiki/Minoru_Mochizuki"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q1937662","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Minoru_Mochizuki","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Mochizuki_Minoru.yaml","photo_url_local":"images/cache/10306b68d5b5a690b5c86d083c61657f.jpg"}},{"data":{"id":"JDP-53","name":"Tsunako Miyake","native_name":{"name":"\u4E09\u5B85\u7DB1\u5B50","lang":"ja"},"nationality":["JPN"],"birth":{"date":1926,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"photo_url":"https://4.bp.blogspot.com/-0_CB4s36WbI/TWq2YuGRTbI/AAAAAAAAAOo/XfncjJ-MHQ4/s320/Miyake.GIF","teachers":[{"id":"JDP-26","style_id":"JDP-S-4","place":null,"period":{"start":null,"end":null},"quality":2,"sources":[{"uri":"https://aikidojournal.com/2004/05/06/hiroaki-kogure-sensei-part-two","cite":"Interview with Hiroaki Kogure Sensei, part 2 (interview by Josh Gold, 2004, Aikido Journal)","citation":"Tomiki Sensei had three top students. they were Hideo Oba, Senta Yamada, and Tsunako Miyake Sensei."}]},{"id":"JDP-26","style_id":"JDP-S-1","place":"Kodokan","period":{"start":null,"end":null},"quality":2,"sources":[{"uri":"https://studygrouptomikiaikido.blog/2022/09/05/simplification-or-sportification","cite":"MIYAKE Sensei, Extracts from an Interview by R.J.Lawrance, The E.A.A. Newsletter, Issue 90.2 (in: Study Group Tomiki Aikido - The simplification of Ueshiba\u2019s Aikido)","citation":"Then, I met Tomiki sensei at the Kodokan (...) Now that he is gone, I think that it is very important for us to understand his idea, that to improve judo we must train in judo and aikido together."}]}],"rank":[{"style_id":"JDP-S-4","org":null,"teacher":"JDP-26","rank":"8 dan","date":null,"style":"Aikid\u014D","style_native":{"name":"\u5408\u6C17\u9053","lang":"ja"}},{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"7 dan","date":null,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}},{"style_id":null,"teacher":null,"rank":"7 dan","date":null}],"sources":[{"uri":"https://studygrouptomikiaikido.blog/2022/01/24/judo-taiso-a-scientific-vehicle-for-aikido/"},{"uri":"https://tomikiaikido.blogspot.com/2010/01/miyake-cultural-treasure.html"},{"uri":"https://web.archive.org/web/20120320033257/http://homepage3.nifty.com/-samidare-/ennkaku3.html"},{"uri":"https://aikidojournal.com/2004/05/06/hiroaki-kogure-sensei-part-two/"},{"uri":"https://www.dentonaikido.com/instructor.html"},{"uri":"https://www.youtube.com/watch?v=K__3OoJ_hhM"},{"uri":"https://en.wikipedia.org/wiki/Karl_Geis"},{"uri":"https://www.karlgeis.com/his-resume","cite":"His Resume | karlgeisryu"}],"source_yaml":"database/persons/JPN/Miyake_Tsunako.yaml","photo_url_local":"images/cache/57ee38fb484c838bde16ecc98bd671bb.gif"}},{"data":{"id":"JDP-49","name":"Miyagawa Taichiro","native_name":{"name":"\u5BAE\u5DDD\u592A","lang":"ja"},"nationality":["JPN"],"birth":{"date":1848,"location":"Fukuoka","country_code":"JPN"},"death":{"date":"1920-06-20","location":null,"country_code":null},"photo_url":null,"description":{"en":"Miyagawa Taichiro was born on Kaei first. He served the Kuroda clan as a retainer. He was an accomplished martial artist, having learned Itto-ryu kenjutsu and Jigo Tenshin Ryu jujutsu, which he taught at the Genyosha-linked dojo that would be the origin of the Meidokan. He participated in the Hagi Rebellion against the Meiji government.\\n","ja":"\u5BAE\u5DDD\u592A\u4E00\u90CE\u3001\u540D\u306F\u935C\u30AD\u30BF\u30A6\u3002\u7B51\u524D\u306E\u4EBA\u3002\u5609\u6C38\u5143\u5E74\u4E03\u6708\u4E8C\u5341\u56DB\u65E5\u798F\u5CA1\u306B\u751F \u308B\u3002\u4E16\u3001\u9ED2\u7530\u6C0F\u306B\u4ED5\u3078\u3001\u5176\u306E\u85E9\u58EB\u305F\u308A\u3002\u5919\u306B\u6587\u6B66\u9928\u306B\u5165\u308A\u3001\u5C02\u3089\u6B66\u6280\u3092 \u8B1B\u4FEE\u3057\u3001\u6483\u5263\uFF08\u4E00\u5200\u6D41\uFF09\u67D4\u8853\uFF08\u81EA\u5F97\u5929\u5FC3\u6D41\uFF09\u306E\u5965\u6280\u3092\u7A76\u3080\u3002\u7DAD\u65B0\u5F8C\u85E9\u306E \u4F75\u5FC3\u968A\u306B\u5165\u308A\u3001\u9752\u5E74\u6D3E\u306E\u725B\u8033\u3092\u57F7\u308B\u3002\u660E\u6CBB\u4E09\u5E74\u3001\u4E8B\u3092\u4EE5\u3066\u5C31\u7FA9\u968A\u306E\u9818\u8896 \u7BB1\u7530\u516D\u8F14\u7B49\u3068\u4E89\u3072\u3001\u5C4F\u5C45\u3092\u547D\u305C\u3089\u308B\u3002\u5F8C\u3001\u7BC0\u3092\u6298\u308A\u3001\u516D\u8F14\u3001\u53CA\u3001\u9032\u85E4\u559C \u5E73\u592A\u7B49\u3068\u5171\u306B\u3001\u9AD8\u5834\u4E71\u306E\u9580\u306B\u5165\u308B\u3002\u4E03\u5E74\u4E8C\u6708\u3001\u4F50\u8CC0\u306E\u5909\u3001\u798F\u5CA1\u81E8\u6642\u93AE\u64AB \u968A\u306E\u7D44\u7E54\u305B\u3089\u308B\u309D\u3084\u3001\u592A\u4E00\u90CE\u3001\u516D\u8F14\u3068\u5171\u306B\u3001\u5176\u534A\u968A\u9577\u305F\u308A\u3002\u516B\u5E74\u3001\u516D\u8F14\u3001 \u53CA\u3001\u982D\u5C71\u6E80\u7B49\u3068\u77EF\u5FD7\u793E\u3092\u8D77\u3057\u3001\u4E5D\u5E74\u5341\u4E8C\u6708\u3001\u8429\u306E\u4E8B\u5909\u306B\u5750\u305B\u3089\u308C\u3066\u3001\u516D \u8F14\u7B49\u3068\u5171\u306B\u7344\u306B\u4E0B\u308A\u3001\u5341\u4E00\u5E74\u4E09\u6708\u3001\u59CB\u3081\u3066\u91C8\u3055\u308B\u3002\u5F8C\u3001\u958B\u58BE\u793E\u3092\u535A\u591A\u5411 \u6D5C\u306B\u958B\u304D\u3001\u723E\u6765\u5FD7\u3092\u653F\u6CBB\u4E0A\u306B\u65AD\u3061\u3001\u5C02\u3089\u5B9F\u696D\u306B\u5F93\u4E8B\u3059\u3002 \u5BAE\u5DDD\u592A\u4E00\u90CE\u5609\u6C38\u5143\u5E74\uFF081848\uFF09\u751F\u6B63\u6797\u53C8\u4E03\u90CE\u306E\u9AD8\u5F1F\u30FB\u514D\u8A31\u7686\u4F1D\u4EE3\u3005\u9ED2\u7530\u5BB6 \u306E\u81E3\u3067\u3042\u308B\u3002\u4E00\u4E07\u6D41\u5263\u8853\uFF0C\u81EA\u525B\u5929\u771F\u6D41\u7D44\u8A0E\u3092\u6975\u3081\uFF0C\u660E\u6CBB10\u5E74(1877) 11 \u6708\u7384\u6D0B\u793E\u9644\u5C5E\u306E\u5411\u6D5C\u587E\u3067\u81EA\u805E\u5929\u771F\u6D41\u3092\u6559\u6388\u3057\u305F\u306E\u304C\uFF0C\u5F8C\u306E\u660E\u9053\u9928\u9053\u5834\u306E \u8D77\u6E90\u3068\u3055\u308C\u3066\u3044\u308B\u3002\u5927\u6B639\u5E74(1920)6\u670820\u65E577\u624D\u306B\u3066\u75C5\u6CA1\u3002\u9577\u7537\uFF0E\u5BAE\u5DDD\u5F66 \u4E4B\u52A9\u3082\u76EE\u9332\u307E\u3067\u9032\u307F\uFF0C\u81EA\u525B\u5929\u771F\u6D41\u306E\u666E\u53CA\u306B\u52D9\u3081\u305F\u3002\\n"},"teachers":[{"id":"JDP-51","style_id":"JDP-S-12","place":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://opac.tenri-u.ac.jp/opac/repository/metadata/1573/","citation":"\u5BAE\u5DDD\u592A\u4E00\u90CE\u5609\u6C38\u5143\u5E74\uFF081848\uFF09\u751F\u6B63\u6797\u53C8\u4E03\u90CE\u306E\u9AD8\u5F1F\u30FB\u514D\u8A31\u7686\u4F1D\u4EE3\u3005\u9ED2\u7530\u5BB6\u306E\u81E3\u3067\u3042\u308B\u3002\u4E00\u4E07\u6D41\u5263\u8853\uFF0C\u81EA\u525B\u5929\u771F\u6D41\u7D44\u8A0E\u3092\u6975\u3081\uFF0C\u660E\u6CBB10\u5E74(1877) 11\u6708\u7384\u6D0B\u793E\u9644\u5C5E\u306E\u5411\u6D5C\u587E\u3067\u81EA\u805E\u5929\u771F\u6D41\u3092\u6559\u6388\u3057\u305F\u306E\u304C\uFF0C\u5F8C\u306E\u660E\u9053\u9928\u9053\u5834\u306E\u8D77\u6E90\u3068\u3055\u308C\u3066\u3044\u308B\u3002\u5927\u6B639\u5E74(1920)6\u670820\u65E577\u624D\u306B\u3066\u75C5\u6CA1\u3002\u9577\u7537\uFF0E\u5BAE\u5DDD\u5F66\u4E4B\u52A9\u3082\u76EE\u9332\u307E\u3067\u9032\u307F\uFF0C\u81EA\u525B\u5929\u771F\u6D41\u306E\u666E\u53CA\u306B\u52D9\u3081\u305F\u3002"}],"quality":2}],"rank":[{"style_id":"JDP-S-12","org":null,"teacher":"\u5E84\u6797\u53C8\u4E03\u90CE","rank":"Menkyokaiden (\u514D\u8A31\u7686\u4F1D)","date":null,"style":"Jig\u014D Tenshin Ry\u016B","style_native":{"name":"\u81EA\u525B\u5929\u771F\u6D41","lang":"ja"}}],"sources":[{"uri":"http://www5e.biglobe.ne.jp/~isitaki/page048.html","events":["name","native_name","birth","death"]},{"uri":"http://www5e.biglobe.ne.jp/~isitaki/page045.html"},{"uri":"https://opac.tenri-u.ac.jp/opac/repository/metadata/1573/","events":["name","native_name","birth","death"]}],"tags":["Geny\u014Dsha"],"source_yaml":"database/persons/JPN/Miyagawa_Taichiro.yaml"}},{"data":{"id":"JDP-107","name":"Miyako Sada","native_name":{"name":"\u4E09\u6D66\u947F","lang":"ja"},"aka":["Miura Saku"],"nationality":["BRA","JPN"],"birth":{"date":"1881","location":"Ehime","country_code":"JPN"},"death":{"date":"1945-10-26","location":"Tokyo","country_code":"JPN"},"photo":{"url":"https://archive.org/download/sada_miyako/sada_miyako.jpg","source":{"uri":"https://www.ndl.go.jp/brasil/e/data/R/084/084-002r.html","cite":"100 Japanese Emigration to Brazil - Saku Miura (National Diet Library)"}},"teachers":[{"id":null,"style_id":null,"place":null,"period":{"start":null,"end":null},"quality":null}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":2,"date":null}],"sources":[{"uri":"https://judotradicionalgoshinjutsukan.blogspot.com/2009/10/capoeira-vs-jujutsu.html"},{"uri":"https://www.ndl.go.jp/brasil/e/data/R/084/084-002r.html"},{"uri":"https://cenb.org.br/articles/display/240"},{"uri":"https://isbnsearch.org/isbn/9798639871030","location":"vol. II, p. 100"},{"uri":"https://podcasters.spotify.com/pod/show/budokast0/episodes/Budokast-04---Geo-Omori-e-o-Jiu-Jitsu-Brasileiro-e8cbdt"}],"source_yaml":"database/persons/JPN/Miura_Saku.yaml"}},{"data":{"id":"JDP-11","name":"Mifune Ky\u016Bz\u014D","native_name":{"name":"\u4E09\u8239 \u4E45\u8535","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1883-04-21","location":"Iwate","country_code":"JPN"},"death":{"date":"1965-01-27","location":null,"country_code":"JPN"},"photo":{"url":"https://1.bp.blogspot.com/_NjSHIRBuf3Y/SHlsXVS7iGI/AAAAAAAAAk0/d-EnhgFOBPk/s400/kyuzomifune.jpg","source":{"uri":"http://judotradicionalgoshinjutsukan.blogspot.com/2008/07/kyuzo-mifune.html","cite":"Judo Tradicional Goshinjutsukan - Kyuzo Miffing"}},"teachers":[{"id":"JDP-1","style_id":"JDP-S-1","place":"Kodokan","quality":null,"period":{"start":1903,"end":1965}},{"id":"JDP-9","style_id":"JDP-S-1","place":"Kodokan","quality":null,"period":{"start":1903,"end":null}}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"10 dan","date":1945,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E4%B8%89%E8%88%B9%E4%B9%85%E8%94%B5"},{"uri":"https://en.wikipedia.org/wiki/Kan%C5%8D_Jigor%C5%8D"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q2453372","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Kyuzo_Mifune","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Mifune_Kyuzo.yaml"}},{"data":{"id":"JDP-54","name":"Matsumura S\u014Dkon","native_name":{"name":"\u677E\u6751 \u5B97\u68CD","lang":"ryu"},"nationality":["JPN"],"birth":{"date":1809,"location":"Shuri, Okinawa","country_code":"JPN"},"death":{"date":1899,"location":null,"country_code":null},"photo_url":"https://upload.wikimedia.org/wikipedia/commons/0/04/S%C5%8Dkon_Matsumura.jpg","teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E5%AE%89%E9%87%8C%E5%AE%89%E6%81%92"},{"uri":"https://en.wikipedia.org/wiki/Matsumura_S%C5%8Dkon#/media/File:S%C5%8Dkon_Matsumura.jpg"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q715769","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Matsumura_S%C5%8Dkon","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Matsumura_Sokon.yaml","photo_url_local":"images/cache/d3d8d5f6459ab8ddf5dc181c0fd1042b.jpg"}},{"data":{"id":"JDP-42","name":"Matsui Sanzo","native_name":{"name":"\u677E\u4E95\u4E09\u8535","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1861-05-16","location":"Higashikaji","country_code":"JPN"},"death":{"date":"1932-06-08","location":null,"country_code":null},"photo_url":null,"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E6%9D%BE%E4%BA%95%E4%B8%89%E8%94%B5"}],"source_yaml":"database/persons/JPN/Matsui_Sanzo.yaml"}},{"data":{"id":"JDP-51","name":"Matashichiro Shobayashi","native_name":{"name":"\u5E84\u6797\u53C8\u4E03\u90CE","lang":"ja"},"nationality":["JPN"],"birth":{"date":null,"location":null,"country_code":"JPN"},"death":{"date":null,"location":null,"country_code":null},"photo_url":null,"description":null,"teachers":[{"name":"JDP-52","style_id":"JDP-S-12","place":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://opac.tenri-u.ac.jp/opac/repository/metadata/1573/","citation":"\u5BAE\u5DDD\u592A\u4E00\u90CE\u5609\u6C38\u5143\u5E74\uFF081848\uFF09\u751F\u6B63\u6797\u53C8\u4E03\u90CE\u306E\u9AD8\u5F1F\u30FB\u514D\u8A31\u7686\u4F1D\u4EE3\u3005\u9ED2\u7530\u5BB6\u306E\u81E3\u3067\u3042\u308B\u3002\u4E00\u4E07\u6D41\u5263\u8853\uFF0C\u81EA\u525B\u5929\u771F\u6D41\u7D44\u8A0E\u3092\u6975\u3081\uFF0C\u660E\u6CBB10\u5E74(1877) 11\u6708\u7384\u6D0B\u793E\u9644\u5C5E\u306E\u5411\u6D5C\u587E\u3067\u81EA\u805E\u5929\u771F\u6D41\u3092\u6559\u6388\u3057\u305F\u306E\u304C\uFF0C\u5F8C\u306E\u660E\u9053\u9928\u9053\u5834\u306E\u8D77\u6E90\u3068\u3055\u308C\u3066\u3044\u308B\u3002\u5927\u6B639\u5E74(1920)6\u670820\u65E577\u624D\u306B\u3066\u75C5\u6CA1\u3002\u9577\u7537\uFF0E\u5BAE\u5DDD\u5F66\u4E4B\u52A9\u3082\u76EE\u9332\u307E\u3067\u9032\u307F\uFF0C\u81EA\u525B\u5929\u771F\u6D41\u306E\u666E\u53CA\u306B\u52D9\u3081\u305F\u3002"}],"quality":2}],"rank":[{"style_id":"JDP-S-12","org":null,"teacher":"\u5E84\u6797\u53C8\u4E03\u90CE","rank":"Menkyokaiden (\u514D\u8A31\u7686\u4F1D)","date":null,"style":"Jig\u014D Tenshin Ry\u016B","style_native":{"name":"\u81EA\u525B\u5929\u771F\u6D41","lang":"ja"}}],"sources":[{"uri":"https://opac.tenri-u.ac.jp/opac/repository/metadata/1573/","events":["name","native_name"]},{"uri":"https://ja.wikipedia.org/wiki/%E8%87%AA%E5%89%9B%E5%A4%A9%E7%9C%9F%E6%B5%81"}],"source_yaml":"database/persons/JPN/Matashichiro_Shobayashi.yaml"}},{"data":{"id":"JDP-50","name":"Masakatsu Naka","native_name":{"name":"\u4E2D\u4E95 \u6B63\u52DD","lang":"ja"},"nationality":["JPN"],"birth":{"date":null,"location":null,"country_code":"JPN"},"death":{"date":null,"location":null,"country_code":null},"photo_url":null,"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Yagy%C5%AB_Shinkage-ry%C5%AB","events":["name native_name"]},{"uri":"https://en.wikipedia.org/wiki/Yagy%C5%AB_Shingan-ry%C5%AB"}],"source_yaml":"database/persons/JPN/Masakatsu_Nakai.yaml"}},{"data":{"id":"JDP-18","name":"Maeda Mitsuyo","native_name":{"name":"\u524D\u7530 \u5149\u4E16","lang":"ja"},"aka":["Ot\xe1vio Maeda","Conde Koma"],"nationality":["JPN","BRA"],"birth":{"date":"1878-11-18","location":"Hirosaki","country_code":"JPN"},"death":{"date":"1941-11-28","location":"Bel\xe9m, Par\xe1","country_code":"BRA"},"photo_url":"https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Mitsuyo_Maeda_c1910.jpg/346px-Mitsuyo_Maeda_c1910.jpg","teachers":[{"name":"Saito Mohei","style":"Hongaku Kokki-ry\xfb","place":null,"quality":null,"period":{"start":1895,"end":1896}},{"id":"JDP-9","style_id":"JDP-S-1","place":"Kodokan","quality":1,"period":{"start":1897,"end":null},"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E6%A8%AA%E5%B1%B1%E4%BD%9C%E6%AC%A1%E9%83%8E","cite":"\u6A2A\u5C71\u4F5C\u6B21\u90CE (\u30A6\u30A3\u30AD\u30DA\u30C7\u30A3\u30A2)","citation":"\u307E\u305F\u3001\u4E09\u8239\u4E45\u8535\u3084\u524D\u7530\u5149\u4E16\u306E\u5E2B\u5320\u3068\u3057\u3066\u3082\u77E5\u3089\u308C\u308B"},{"uri":"https://simonbjj.com/satake","cite":"The Sumo wrestle who taught BJJ, Soshiro Satake","citation":"At some point later, probably in the late 1890\u2019s, he joined the Kodokan and would become peers of Mitsuyo Maeda. The two judoka trained together under Sakujiro Yokoyama, who was known as one of the Four Guardians of the Kodokan"}]}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"7 dan","date":1941,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Mitsuyo_Maeda"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q2456537","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Mitsuyo_Maeda","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Maeda_Mitsuyo.yaml","photo_url_local":"images/cache/3f7c419cc1985a2cb0d3581aa3adf353.jpg"}},{"data":{"id":"JDP-115","name":"Kumajiro Yamaguchi","native_name":{"name":"\u5C71\u53E3\u718A\u6B21\u90CE","lang":"ja"},"nationality":["JPN"],"birth":{"date":null,"location":null,"country_code":"JPN"},"death":{"date":null,"location":null,"country_code":"JPN"},"teachers":[{"id":"JDP-116","style_id":"JDP-S-6","place":null,"period":{"start":null,"end":null},"quality":2,"sources":[{"uri":"https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/","cite":"Exkurs: Die moderne Geschichte der Katori Shint\xf4 ry\xfb (Ein Leben f\xfcr die Schwertkunst)","citation":"Iisasa Morisada (sieben direkte Sch\xfcler): Yamaguchi Kumajir\xf4 Eikan Mairaku / Tamai Said\xf4 / Noguchi Jizaemon / Ono Heishichir\xf4 Moriichi / Shiina Ichiz\xf4 / Hong\xfb Toranosuke / Kaneko Shinosh\xf4 (...) Hayashi Saiichir\xf4 \u2013> Hayashi Yazaemon \u2013> \xd4take Risuke"}]}],"rank":[{"style":"JDP-S-6","org":null,"teacher":null,"rank":"Kyoju","date":null,"sources":[{"uri":"https://inoshishikukan.com/budo/katori/woman-of-katori-shinto-ryu","cite":"Women of Katori Shint\u014D-ry\u016B","citation":"In the official history of our school, the 18th Soke Iizasa Morisada died suddenly, without a male successor. For a time, under these conditions, the school was then led by the then Shihan with Yamaguchi Kumajiro as Kyoju."}]}],"sources":[{"uri":"https://shinbukan-katorishintoryu.org/?page_id=898&lang=en"},{"uri":"https://inoshishikukan.com/budo/katori/woman-of-katori-shinto-ryu"},{"uri":"https://shinbukan-katorishintoryu.org/?page_id=927&lang=ja","citation":"\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41 (\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41)"}],"source_yaml":"database/persons/JPN/Kumajiro_Yamaguchi.yaml"}},{"data":{"id":"JDP-33","name":"Kuboki Sozaemon","native_name":{"name":null,"lang":null},"nationality":["JPN"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"photo_url":null,"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://aikidojournal.com/2018/10/15/the-last-swordsman-the-yoshio-sugino-story-part-2"}],"source_yaml":"database/persons/JPN/Kuboki_Sozaemon.yaml"}},{"data":{"id":"JDP-137","name":"Kotani Sumiyuki","native_name":{"name":"\u5C0F\u8C37 \u6F84\u4E4B","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1903-08-03","location":"Nakagawa, Aogo, Hyogo","country_code":"JPN"},"death":{"date":"1991-10-09","location":"Nishinomiya, Hyogo","country_code":"JPN"},"description":{"en":"Sumiyuki Kotani (\u5C0F\u8C37 \u6F84\u4E4B, Kotani Sumiyuki; August 3, 1903 \u2013 October 9, 1991).  Judo ambassador who travelled around with Kano, and one of this last direct students."},"photo":{"url":"https://upload.wikimedia.org/wikipedia/en/6/64/Kotani_Sumiyuki_Judo_Judan.jpg","source":{"uri":"https://en.wikipedia.org/wiki/Sumiyuki_Kotani","cite":"Wikipedia. Photo from collection of Dr. Clif Norgaard"}},"teachers":[{"id":"JDP-1","style_id":"JDP-S-1","place":"Kodokan","period":{"start":1921,"end":1938},"quality":3,"sources":[{"uri":"https://judoinfo.com/judan/","cite":"Judo Info: Profiles of Judo 10th Dan Holders","citation":"He was one of Jigoro Kano\u2019s direct students, and only the 7th man to receive a 10th Degree Black Belt while he was still alive."},{"uri":"https://isbnsearch.org/isbn/9781590309162","cite":"The Way of Judo A Portrait of Jigoro Kano and His Students","location":"pp. 167-128","citation":"Kotani can be considered Kano\'s last direct disciple. (...) Kano often chose Kotani as a traveling instructor on his teaching tours overseas."}]}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"10 dan","date":1984,"sources":[{"uri":"https://www.judo-ch.jp/english/legend/kotani/","cite":"Judo Channel","citation":"Sumiyuki Kotani April, 1984: 10th dan"},{"uri":"https://isbnsearch.org/isbn/9781590309162","cite":"The Way of Judo A Portrait of Jigoro Kano and His Students","location":"pp. 167-128","citation":"[Kotani] was promoted to tenth dan in 1984"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://www.olympedia.org/athletes/59042"},{"uri":"https://judoinfo.com/judan/"},{"uri":"https://www.judo-ch.jp/english/legend/kotani/"},{"uri":"https://en.wikipedia.org/wiki/Sumiyuki_Kotani"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q982540","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Sumiyuki_Kotani","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Kotani_Sumiyuki.yaml"}},{"data":{"id":"JDP-37","name":"Konishi Yasuhiro","native_name":{"name":"\u5C0F\u897F\u5EB7\u88D5","lang":"ja"},"nationality":["JPN"],"birth":{"date":1893,"location":"Takamatsu, Kagawa","country_code":"JPN"},"death":{"date":1983,"location":"Tokyo","country_code":"JPN"},"photo_url":"https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Konishi.JPG/200px-Konishi.JPG","teachers":[{"id":"JDP-38","style_id":"JDP-S-1","place":null,"period":{"start":1906,"end":null},"quality":1},{"id":"JDP-39","style_id":"JDP-S-8","place":null,"period":{"start":1906,"end":null},"quality":1},{"id":"JDP-42","style_id":"JDP-S-9","place":null,"period":{"start":1906,"end":null},"quality":0},{"id":"JDP-40","style_id":"JDP-S-8","place":"Kei\u014D Gijuku Daigaku","period":{"start":1913,"end":null},"quality":1},{"id":"JDP-41","style_id":"JDP-S-5","place":"Kei\u014D Gijuku Daigaku","period":{"start":1924,"end":null},"quality":1,"sources":[{"uri":"https://ryukyu-bugei.com/?p=6586","citation":"When he [Konishi] met Funakoshi Gichin in June 1925, he was finally able to learn Karate. However, since its contents was only Kata, together with \u014Ctsuka Hironori \u5927\u585A\u535A\u7D00 (1892\u20131982, founder of Wad\u014D-ry\u016B Karate-d\u014D and J\u016Bjutsu Kenp\u014D) who was also a disciple of Funakoshi, Konishi began to devise Yakusoku Kumite \u7D04\u675F\u7D44\u624B and the like. Later Konishi studied Karate with Motobu Ch\u014Dki and Mabuni Kenwa."}]},{"name":"\u014Ctsuka Hironori","style_id":"JDP-S-5","place":"Kei\u014D Gijuku Daigaku","period":{"start":1924,"end":null},"quality":1},{"id":"JDP-27","style_id":"JDP-S-4","place":null,"period":{"start":1924,"end":null},"quality":1}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E5%B0%8F%E8%A5%BF%E5%BA%B7%E8%A3%95_(%E7%A9%BA%E6%89%8B%E5%AE%B6)"},{"uri":"https://ryukyu-bugei.com/?p=6586"},{"uri":"https://blackbeltmag.com/konishi-yasuhiro"},{"uri":"https://www.jkr-uk.org.uk/yasuhiro-konishi"}],"source_yaml":"database/persons/JPN/Konishi_Yasuhiro.yaml","photo_url_local":"images/cache/8b2d9702cc96e4583e32d0bf958873fd.jpg"}},{"data":{"id":"JDP-12","name":"Kobayashi Kiyoshi","native_name":{"name":"\u5C0F\u6797\u6E05","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1925-04-09","location":"Gunma","country_code":"JPN"},"death":{"date":"2013-04-09","location":null,"country_code":"JPN"},"photo_url":"https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcSuhkNSuXgXEFBZToZ69C3M_dfMhOmheEPZiLctfs0KLWtq9UNC","description":{"en":"Kobayashi Kiyoshi (\u5C0F\u6797\u6E05) was the \xabfather\xbb of Portuguese Judo and one of the founders of the Portuguese Judo Federation, and the greatest promoter of Judo in Portugal. Sensei Kobayashi was one of the highest grades in the world, 9th dan given Kodokan by in 1999.","pt":"O Mestre Kiyoshi Kobayashi, uma das mais altas gradua\xe7\xf5es da Modalidade \u2013 9\xba Dan, foi um dos grandes respons\xe1veis pelo crescimento e desenvolvimento da modalidade em Portugal, sendo conhecido inclusive como \\"o pai do judo portugu\xeas\\". Foi Selecionador e Treinador da Equipa Nacional e acompanhou-as em Campeonatos da Europa e do Mundo, assim como nas edi\xe7\xf5es dos Jogos Ol\xedmpicos de Montreal (1976), Los Angeles(1984) e Seul (1988)."},"teachers":[{"id":"JDP-11","style_id":"JDP-S-1","place":"Kodokan","quality":null,"period":{"start":1903,"end":1965}}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"9 dan","date":2013,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"http://kodokanjudoinstitute.org/news/2012/04/epost-15/"},{"uri":"http://kodokanjudoinstitute.org/magazine/201401/"},{"uri":"https://www.eju.net/judo-father-sensei-kiyoshi-kobayashi-passed-away/"},{"uri":"http://archive.today/YkEjw"},{"uri":"http://www.judo.crcharnequense.net/index.php/judo-menu/historia-do-judo-menu-item/judo-portugal-menu-item"}],"source_yaml":"database/persons/JPN/Kobayashi_Kiyoshi.yaml","photo_url_local":"images/cache/9f54fb588b61dd606a167494c564c23e.jpg"}},{"data":{"id":"JDP-89","name":"Kimura Masahiko","native_name":{"name":"\u6728\u6751 \u653F\u5F66","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1917-09-10","location":"Kumamoto","country_code":"JPN"},"death":{"date":"1993-04-18","location":"Tokyo","country_code":"JPN"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/4/4b/Masahiko_Kimura_2.jpg","source":{"uri":"https://de.wikipedia.org/wiki/Kimura_Masahiko_%28Judoka%29#/media/Datei:Masahiko_Kimura_2.jpg"}},"teachers":[{"id":"JDP-90","style_id":"JDP-S-1","place":"Kodokan","quality":null,"period":{"start":1925,"end":1930}},{"id":"JDP-41","style_id":"JDP-S-5","place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.bjjee.com/articles/my-judo-by-masahiko-kimura-his-story-vision-in-his-own-words-part-1/","cite":"\'My Judo\' by Masahiko Kimura, His Story & Vision in His Own Words Part 1 (BJJ EE)","citation":"Later on, I [ed. Kimura] got interested in karate, and learned Shorinji-ryu (Note: today\u2019s Shotokan karate) under the guidance of Master Funakoshi for a little over 2 years."}]},{"name":"JDP-xx","style_id":"JDP-S-5","place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.bjjee.com/articles/my-judo-by-masahiko-kimura-his-story-vision-in-his-own-words-part-1/","cite":"\'My Judo\' by Masahiko Kimura, His Story & Vision in His Own Words Part 1 (BJJ EE)","citation":"After this, I learned Goju-ryu karate from Master So, who was a great master of Gojuryu, and eventually became an assistant instructor in his dojo."}]}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"7 dan","date":1947,"sources":[{"uri":"https://web.archive.org/web/20120622122136/http://judoinfo.com/kimura3.htm","cite":"Masahiko Kimura (1917-1993): The Man Who Defeated Helio Gracie (by Jim Chen M.D, in Judoinfo.com [Archived])","citation":"His shichidan rank was frozen after disputes with Kodokan over becoming a professional wrestler, refusal to return the All Japan Judo Championship Flag"},{"uri":"https://en.wikipedia.org/wiki/Masahiko_Kimura","citation":"He was promoted to 7th dan at age 30"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Masahiko_Kimura"},{"uri":"https://www.aikidosangenkai.org/blog/aikido-judo-gozo-shioda-masahiko-kimura/"},{"uri":"https://web.archive.org/web/20120622122136/http://judoinfo.com/kimura3.htm"},{"uri":"https://www.bjjee.com/articles/my-judo-by-masahiko-kimura-his-story-vision-in-his-own-words-part-1/"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q270727","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Masahiko_Kimura","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Kimura_Masahiko.yaml"}},{"data":{"id":"JDP-13","name":"Kawaishi Mikinosuke","native_name":{"name":"\u5DDD\u77F3 \u9152\u9020\u4E4B\u52A9","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1899-08-13","location":"Himeji","country_code":"JPN"},"death":{"date":"1969-01-30","location":"Paris","country_code":"FRA"},"description":{"en":"Mikinosuke Kawaishi (\u5DDD\u77F3 \u9152\u9020\u4E4B\u52A9, Kawaishi Mikinosuke, born 13 August 1899 \u2013 30 January 1969) was a Japanese master of jujutsu and judo who achieved the rank of 7th Dan. He led the development of Judo in France, with Shozo Awazu, and much of Europe and is credited with introducing the colored belt system for differentiating early grades. However, written accounts from the archives of London\'s Budokwai judo club, founded in 1918, record the use of colored judo belts at the 1926 9th annual Budokwai Display, and a list of ranked colored judokas appears in the Budokwai Committee Minutes of June 1927. Kawaishi visited London and the Budokwai in 1928, and was probably inspired to bring the colored belt system to France. The F\xe9d\xe9ration Fran\xe7aise posthumously awarded him 10th Dan in judo and jujutsu."},"photo_url":"https://archive.org/download/kawaishi_mikinosuke/kawaishi_mikinosuke.jpg","teachers":[{"name":"Yoshida K\u014Dtar\u014D","style_id":"JDP-S-1","place":null,"quality":null,"period":{"start":null,"end":null}},{"name":"Miyakawa Ikkan","style_id":"JDP-S-1","place":"Waseda University","quality":null,"period":{"start":null,"end":null}},{"id":"JDP-14","style_id":"JDP-S-1","place":"Waseda University","quality":null,"period":{"start":1881,"end":null}}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"7 dan","date":null,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}},{"style_id":"JDP-S-1","org":"FFJDA","teacher":null,"rank":"10 dan","date":null,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://www.researchgate.net/publication/277665808_Kodokan_Judo\'s_three_orphaned_forms_of_counter_techniques_-_Part_1_The_gonosen-no-kata_-_Forms_of_post-attack_initiative_counter_throws"},{"uri":"https://doi.org/10.4471/hse.2013.15"},{"uri":"https://judoinfo.com/kawaishi/"},{"uri":"https://ja.wikipedia.org/wiki/%E5%B7%9D%E7%9F%B3%E9%85%92%E9%80%A0%E4%B9%8B%E5%8A%A9"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q3090191","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Mikinosuke_Kawaishi","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Kawaishi_Mikinosuke.yaml","photo_url_local":"images/cache/b1183f842d638260d7b449d81deefacd.jpg"}},{"data":{"id":"JDP-1","name":"Kan\u014D Jigor\u014D","native_name":{"name":"\u5609\u7D0D \u6CBB\u4E94\u90CE","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1860-10-28","location":"Kobe","country_code":"JPN","sources":[{"uri":"https://martialhistoryteam.blogspot.com/2020/04/when-was-professor-kano-born.html","citation":"10\u670828\u65E5 refers to October 28. In other words, by the Gregorian calendar, Kano was born on October 28, 1860."}]},"death":{"date":"1928-05-04","location":"Pacific Ocean","country_code":null},"description":{"en":"Jigoro Kano (\u5609\u7D0D \u6CBB\u4E94\u90CE, 10 December 1860 \u2013 4 May 1938[3]) was a Japanese educator, athlete, and the founder of Judo. Along with Ju-Jutsu, Judo was one of the first Japanese martial arts to gain widespread international recognition, and the first to become an official Olympic sport. Pedagogical innovations attributed to Kan\u014D include the use of black and white belts, and the introduction of dan ranking to show the relative ranking among members of a martial art style. Well-known mottoes attributed to Kan\u014D include \\"good use of energy\\" (\u7CBE\u529B\u5584\u7528 seiryoku zen\'y\u014D) and \\"mutual welfare and benefit\\" (\u81EA\u4ED6\u5171\u6804 jita ky\u014Dei).\\n","ja":"\u5609\u7D0D \u6CBB\u4E94\u90CE\uFF08\u304B\u306E\u3046 \u3058\u3054\u308D\u3046\u3001\u4E07\u5EF6\u5143\u5E7410\u670828\u65E5\u30081860\u5E7412\u670810\u65E5\u3009-\u662D \u548C13\u5E74\u30081938\u5E74\u30095\u67084\u65E5\uFF09\u306F\u3001\u65E5\u672C\u306E\u67D4\u9053\u5BB6\u30FB\u6559\u80B2\u8005\u30FB\u8CB4\u65CF\u9662\u8B70\u54E1\u3002\u5175 \u5EAB\u770C\u51FA\u8EAB\u3002\u5225\u8868\u8A18\uFF1A\u52A0\u7D0D\u6CBB\u4E94\u90CE[1]\u3002\u8B1B\u9053\u9928\u67D4\u9053\u306E\u5275\u59CB\u8005\u3067\u3042\u308A[2]\u3001\u67D4 \u9053\u30FB\u30B9\u30DD\u30FC\u30C4\u30FB\u6559\u80B2\u5206\u91CE\u306E\u767A\u5C55\u3084\u65E5\u672C\u306E\u30AA\u30EA\u30F3\u30D4\u30C3\u30AF\u521D\u53C2\u52A0\u306B\u5C3D\u529B\u3059\u308B \u306A\u3069\u3001\u660E\u6CBB\u304B\u3089\u662D\u548C\u306B\u304B\u3051\u3066\u65E5\u672C\u306B\u304A\u3051\u308B\u30B9\u30DD\u30FC\u30C4\u306E\u9053\u3092\u958B\u3044\u305F\u3002\u300C\u67D4 \u9053\u306E\u7236\u300D\u3068\u547C\u3070\u308C\u3001\u307E\u305F\u3001\u300C\u65E5\u672C\u306E\u4F53\u80B2\u306E\u7236\u300D\u3068\u3082\u79F0\u3055\u308C\u308B\\n","pt":"Jigoro Kano (em japon\xeas: \u5609\u7D0D\u6CBB\u4E94\u90CE, Kan\u014D Jigor\u014D) (Mikage, 28 de outubro de 1860 \u2013 4 de maio de 1938) foi o fundador da arte marcial Judo.\\n"},"photo_url":"https://upload.wikimedia.org/wikipedia/commons/0/0c/Kano_Jigoro.jpg","photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/0/0c/Kano_Jigoro.jpg","source":{"uri":"https://commons.wikimedia.org/wiki/Category:Photographs_of_Kan%C5%8D_Jigor%C5%8D#/media/File:Kano_Jigoro.jpg","cite":"Jigoro Kano, Wikimedia Commons"}},"teachers":[{"id":"JDP-2","style_id":"JDP-S-3","place":"Fukuda Hachinosuke dojo","period":{"start":1877,"end":1879},"quality":3},{"id":"JDP-4","style_id":"JDP-S-3","place":"Iso Masatomo dojo","period":{"start":1879,"end":1881},"quality":3},{"id":"JDP-5","style_id":"JDP-S-2","place":"Eish\u014Dji","period":{"start":1881,"end":null},"quality":3},{"id":"JDP-46","style_id":"JDP-S-11","place":null,"period":{"start":1881,"end":null},"quality":1,"sources":[{"uri":"https://kanochronicles.com/the-kodokan-and-bojutsu-jo-staff-fighting-and-judo/","citation":"When I was young, I practiced Yagy\u016B-ry\u016B b\u014Djutsu with a man named Oshima. As my practice of this discipline had not reached the level of shugy\u014D (NOTE: dedicated, austere study), usually I do not mention it. However, since then I thought there was value in b\u014Djutsu shugy\u014D"}]}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"Shihan","date":null,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}},{"style_id":"JDP-S-2","org":null,"teacher_id":"JDP-5","rank":"Menkyo kaiden","date":null,"style":"Kit\u014D-ry\u016B","style_native":{"name":"\u8D77\u5012\u6D41","lang":"ja"}},{"style_id":"JDP-S-3","org":null,"teacher_id":"JDP-4","rank":"Menkyo kaiden","date":null,"style":"Tenjin Shin\'y\u014D-ry\u016B","style_native":{"name":"\u5929\u795E\u771F\u694A\u6D41","lang":"ja"}}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E5%98%89%E7%B4%8D%E6%B2%BB%E4%BA%94%E9%83%8E"},{"uri":"https://isbnsearch.org/isbn/9781425163495"},{"uri":"https://en.wikipedia.org/wiki/Kan%C5%8D_Jigor%C5%8D"},{"uri":"https://doi.org/10.18002/rama.v9i2.1162"},{"uri":"https://martialhistoryteam.blogspot.com/2020/04/when-was-professor-kano-born.html"},{"uri":"https://kanochronicles.com/the-kodokan-and-bojutsu-jo-staff-fighting-and-judo/"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q190141","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Kan%C5%8D_Jigor%C5%8D","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Kano_Jigoro.yaml","photo_url_local":"images/cache/2d37934d8f5ff0af610d77918dbf5da6.jpg"}},{"data":{"id":"JDP-36","name":"Kanaya Genro","native_name":{"name":null,"lang":null},"aka":[{"name":"Kanaya Motoyoshi"}],"nationality":["JPN"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"photo_url":null,"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://www.e-budo.com/forum/showthread.php?48591-Yoshin-koryu-Jujutsu"},{"uri":"https://en.wikipedia.org/wiki/Yoshio_Sugino"},{"uri":"urn:isbn:9784770026194"}],"source_yaml":"database/persons/JPN/Kanaya_Genro.yaml"}},{"data":{"id":"JDP-55","name":"Itosu Ank\u014D","native_name":{"name":"\u7CF8\u6D32 \u5B89\u6052","lang":"ryu"},"nationality":["JPN"],"birth":{"date":1831,"location":"Shuri, Okinawa","country_code":"JPN"},"death":{"date":"1915-03-11","location":"Shuri, Okinawa","country_code":"JPN"},"photo_url":"https://ia601205.us.archive.org/27/items/anko-itosu/Anko_Itosu.jpg","teachers":[{"id":"JDP-54","style_id":"JDP-S-13","place":null,"period":{"start":null,"end":null},"quality":1,"sources":[{"uri":"https://en.wikipedia.org/wiki/Ank%C5%8D_Asato","citation":"In a 1934 article, Funakoshi noted that Asato and Itosu had studied karate together under S\u014Dkon Matsumura."}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Ank%C5%8D_Itosu"},{"uri":"https://web.archive.org/web/20100227032428/http://www.shotokai.jp/english/about/teacher.html"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q527422","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Ank%C5%8D_Itosu","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Itosu_Anko.yaml","photo_url_local":"images/cache/73451543abe5bd9fa0165442c90132b7.jpg"}},{"data":{"id":"JDP-104","name":"It\u014D Tokugor\u014D","native_name":{"name":"\u4F0A\u85E4 \u5FB3\u4E94\u90CE","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1878","location":"Misato, Akita","country_code":"JPN"},"death":{"date":"1939","location":null,"country_code":"JPN"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/en/5/5c/Ito_PI_nov_6_1909jpg.JPG","source":{"uri":"https://en.wikipedia.org/wiki/Tokugoro_Ito#/media/File:Ito_PI_nov_6_1909jpg.JPG","cite":"Tokugoro Ito appeared in the Seattle Post-Intelligencer on November 6, 1909 (Wikipedia)"}},"teachers":[{"id":"JDP-1","style_id":"JDP-S-1","place":null,"period":{"start":null,"end":null},"quality":null,"sources":[{"uri":"https://www.city.daisen.lg.jp/docs/2013110800147/file_contents/3.pdf","cite":"Cosmos, Daisen City Lifelong Learning Information Magazine, No. 3 , Daisen City Lifelong Learning Promotion Headquarters, December 15, 2008","location":"pp. 31-32"},{"uri":"https://ja.wikipedia.org/wiki/%E4%BC%8A%E8%97%A4%E5%BE%B3%E4%BA%94%E9%83%8E","citation":"\u4E2D\u9000\u5F8C\u306F\u8B1B\u9053\u9928\u3067\u5609\u7D0D\u6CBB\u4E94\u90CE\u9580\u4E0B\u3068\u306A\u3063\u3066\u78EF\u8C9D\u4E00\u30FB\u5FB3\u4E09\u5B9D\u30FB\u4E09\u8239\u4E45\u8535\u3089\u3068\u5171\u306B\u67D4\u9053\u306B\u52B1\u3093\u3060"}]}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"5 dan","date":null,"sources":[{"uri":"https://www.attacktheback.com/catch-wrestling/","citation":"One of the first major intercultural clashes of the 20th century in martial arts, between the American wrestler Ad Santel and the Japanese Tokugoro Ito, black belt judo of the fifth degree."}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E4%BC%8A%E8%97%A4%E5%BE%B3%E4%BA%94%E9%83%8E"},{"uri":"https://isbnsearch.org/isbn/9798639871030"},{"uri":"https://www.attacktheback.com/catch-wrestling/"}],"source_yaml":"database/persons/JPN/Ito_Tokugoro.yaml"}},{"data":{"id":"JDP-34","name":"Ito Tanekichi","native_name":{"name":"\u4F0A\u85E4\u7A2E\u5409","lang":null},"nationality":["JPN"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"photo_url":null,"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://aikidojournal.com/2018/10/15/the-last-swordsman-the-yoshio-sugino-story-part-2"}],"source_yaml":"database/persons/JPN/Ito_Tanekichi.yaml"}},{"data":{"id":"JDP-43","name":"Isogai Hajime","native_name":{"name":"\u78EF\u8C9D","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1871-10-26","location":"Miyazaki","country_code":"JPN"},"death":{"date":"1947-04-19","location":null,"country_code":null},"photo_url":"https://archive.org/download/isogai_hajime/isogai_hajime.jpg","teachers":[{"id":"JDP-9","style_id":"JDP-S-1","place":"Kodokan","quality":null,"period":{"start":1891,"end":null}}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"10 dan","date":"1927-12-22","style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"http://kodokanjudoinstitute.org/en/doctrine/palace/"},{"uri":"https://en.wikipedia.org/wiki/Hajime_Isogai"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q11973675","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Hajime_Isogai","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Isogai_Hajime.yaml","photo_url_local":"images/cache/473c6f563fa53cadd82ceda396295ca0.jpg"}},{"data":{"id":"JDP-4","name":"Iso Masatomo","native_name":{"name":"\u78EF\u6B63\u667A","lang":"ja"},"nationality":["JPN"],"birth":{"date":1818,"location":null,"country_code":null},"death":{"date":1881,"location":null,"country_code":null},"teachers":[{"id":"JDP-3","style_id":"JDP-S-3","place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"http://www.tenyokai.com/history.html"},{"uri":"https://ja.wikipedia.org/wiki/%E7%A3%AF%E6%AD%A3%E6%99%BA"}],"source_yaml":"database/persons/JPN/Iso_Masatomo.yaml"}},{"data":{"id":"JDP-3","name":"Iso Masatari Mataemon","native_name":{"name":"\u78EF\u53C8\u53F3\u885B\u9580","lang":"ja"},"nationality":["JPN"],"birth":{"date":1790,"location":"Matsuzaka","country_code":"JPN"},"death":{"date":1863,"location":"Otamagaike","country_code":"JPN"},"teachers":[{"name":"Hitotsu Yanagi Oribe","style_id":"JDP-S-3","place":null,"quality":null,"period":{"start":1785,"end":1792}},{"name":"Homma Jouemon","style":"Shin no Shinto-ryu","place":null,"quality":null,"period":{"start":1792,"end":1798}}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"http://www.tenyokai.com/history.html"},{"uri":"https://ja.wikipedia.org/wiki/%E7%A3%AF%E5%8F%88%E5%8F%B3%E8%A1%9B%E9%96%80"}],"source_yaml":"database/persons/JPN/Iso_Masatari_Mataemon.yaml"}},{"data":{"id":"JDP-119","name":"Ishikawa Takahiko","native_name":{"name":"\u77F3\u5DDD\u9686\u5F66","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1917-05-15","location":"Mitoyo, Kagawa","country_code":"JPN"},"death":{"date":"2008-06-09","location":null,"country_code":"JPN"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/c/c6/Takahiko_Ishikawa_%281949%29.jpg","source":{"uri":"https://en.wikipedia.org/wiki/Takahiko_Ishikawa#/media/File:Takahiko_Ishikawa_(1949).jpg","cite":" Takahiko Ishikawa (1949) (Wikipedia Commons)"}},"description":{"en":"Takahiko Ishikawa (\u77F3\u5DDD\u9686\u5F66, Ishikawa Takahiko, 1917\u20132008) was an All Japan Judo Champion. In the 1949 All-Japan Judo Championships Tahahiko fought Masahiko Kimura to a draw. In the following year he became the champion and subsequently placed three more times in the semi-finals and then retired.      ","ja":"\u77F3\u5DDD \u9686\u5F66\uFF08\u3044\u3057\u304B\u308F \u305F\u304B\u3072\u3053\u30011917\u5E74\u3008\u5927\u6B636\u5E74\u30095\u670815\u65E5 - 2008\u5E74 \u3008\u5E73\u621020\u5E74\u30096\u67089\u65E5\uFF09\u306F\u65E5\u672C\u306E\u67D4\u9053\u5BB6\uFF08\u8B1B\u9053\u99289\u6BB5\uFF09\u3002\u6226\u524D\u304B\u3089\u6226\u5F8C\u306B \u304B\u3051\u3066\u662D\u548C\u5929\u89A7\u8A66\u5408\u6E96\u512A\u52DD\u3001\u7B2C2\u56DE\u30FB\u7B2C3\u56DE\u5168\u65E5\u672C\u9078\u624B\u6A29\u512A\u52DD\u7B49\u306E\u6210\u7E3E\u3092 \u6B8B\u3057\u3001\u6669\u5E74\u306F\u7C73\u56FD\u3067\u67D4\u9053\u666E\u53CA\u3092\u884C\u3063\u305F\u3002\u8EAB\u9577175cm\u3001\u4F53\u91CD82kg\u3002"},"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"9 dan","date":1984,"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E7%9F%B3%E5%B7%9D%E9%9A%86%E5%BD%A6","cite":"\u77F3\u5DDD\u9686\u5F66 (Wikipedia)","citation":"1963\u5E74\u306B8\u6BB5\u3092\u8A31\u3055\u308C\u30011984\u5E74\u306E\u8B1B\u9053\u9928\u5275\u7ACB100\u5468\u5E74\u8A18\u5FF5\u306B\u969B\u3057\u30669\u6BB5\u3078\u6607\u6BB5\u3002"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E7%9F%B3%E5%B7%9D%E9%9A%86%E5%BD%A6"},{"uri":"https://www.usjf.com/takahiko-ishikawa/"}],"source_yaml":"database/persons/JPN/Ishikawa_Takahiko.yaml"}},{"data":{"id":"JDP-10","name":"Inoe Keitaro","native_name":{"name":"\u4E95\u4E0A\u656C\u592A\u90CE","lang":"ja"},"aka":[{"name":"Okusawa Keitaro"},{"native_name":{"name":"\u5965\u6FA4\u656C\u592A\u90CE","lang":"ja"}}],"nationality":["JPN"],"birth":{"date":1847,"location":"Tokyo","country_code":"JPN"},"death":{"date":"1912-09-23","location":null,"country_code":"JPN"},"teachers":[{"id":"JDP-3","style_id":"JDP-S-3","place":null,"quality":null,"period":{"start":null,"end":null}},{"name":"Okuzawa Sanzo","style":"Kiraku-ryu","place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E5%A5%A5%E6%BE%A4%E6%95%AC%E5%A4%AA%E9%83%8E"},{"uri":"https://ja.wikipedia.org/wiki/%E6%A8%AA%E5%B1%B1%E4%BD%9C%E6%AC%A1%E9%83%8E"}],"source_yaml":"database/persons/JPN/Inoue_Keitaro.yaml"}},{"data":{"id":"JDP-31","name":"Iizuka Kunisabur\u014D","native_name":{"name":"\u98EF\u585A \u56FD\u4E09\u90CE","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1875-02-13","location":"Mikamo","country_code":"JPN"},"death":{"date":"1958-07-25","location":null,"country_code":null},"photo_url":"https://upload.wikimedia.org/wikipedia/commons/7/79/Iiduka_kunisaburo.jpg","teachers":[{"id":"JDP-9","style_id":"JDP-S-1","place":"Kodokan","period":{"start":1891,"end":null},"quality":null}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"10 dan","date":1946,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://ejmas.com/jcs/jcsart_svinth_0702.htm"},{"uri":"https://ja.wikipedia.org/wiki/%E9%A3%AF%E5%A1%9A%E5%9B%BD%E4%B8%89%E9%83%8E"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q6444749","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Kunisaburo_Iizuka","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Iizuka_Kunisaburu.yaml","photo_url_local":"images/cache/4f34b5221e2c9496072d5abbecb3e67b.jpg"}},{"data":{"id":"JDP-116","name":"Iizasa Shuri-no-suke Morisada","native_name":{"name":"\u98EF\u7BE0\u4FEE\u7406\u4EAE\u76DB\u8C9E","lang":"ja"},"nationality":["JPN"],"birth":{"date":null,"location":null,"country_code":"JPN"},"death":{"date":null,"location":null,"country_code":"JPN"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/a/ad/XVIII_Dai_S%C5%8Dke_Iizasa_Shuri-no-suke_Morisada.jpg","source":{"uri":"https://commons.wikimedia.org/wiki/File:XVIII_Dai_S%C5%8Dke_Iizasa_Shuri-no-suke_Morisada.jpg","cite":"XVIII Dai S\u014Dke Iizasa Shuri-no-suke Morisada (Wikimedia Commons)"}},"teachers":[{"id":null,"style_id":null,"place":null,"period":{"start":null,"end":null},"quality":2}],"rank":[{"style":"JDP-S-6","org":null,"teacher":null,"rank":"Soke","date":null,"sources":[{"uri":"https://inoshishikukan.com/budo/katori/woman-of-katori-shinto-ryu","cite":"Women of Katori Shint\u014D-ry\u016B","citation":"In the official history of our school, the 18th Soke Iizasa Morisada died suddenly, without a male successor. For a time, under these conditions, the school was then led by the then Shihan with Yamaguchi Kumajiro as Kyoju."}]}],"sources":[{"uri":"https://shinbukan-katorishintoryu.org/?page_id=898&lang=en"},{"uri":"https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/"},{"uri":"https://inoshishikukan.com/budo/katori/woman-of-katori-shinto-ryu"},{"uri":"https://shinbukan-katorishintoryu.org/?page_id=927&lang=ja","citation":"\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41 (\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41)"}],"source_yaml":"database/persons/JPN/Iizasa_Morisada.yaml"}},{"data":{"id":"JDP-5","name":"Iikubo Tsunetoshi","aka":[{"name":"Iikubo K\u014Dnen"}],"native_name":{"name":"\u98EF\u4E45\u4FDD\u936C\u5409\u6052\u5E74\u5148\u751F","lang":"ja"},"nationality":["JPN"],"birth":{"date":1835,"location":null,"country_code":null},"death":{"date":1889,"location":null,"country_code":null},"teachers":[{"id":"JDP-6","style_id":"JDP-S-2","place":null,"period":{"start":null,"end":null},"quality":null}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E8%B5%B7%E5%80%92%E6%B5%81"},{"uri":"https://doi.org/10.18002/rama.v9i2.1162"},{"uri":"https://books.google.pt/books/about/Judo_Memoirs_of_Jigoro_Kano.html?id=DT8rLOzndekC","events":["birth"]},{"uri":"https://www.cismeurope.org/history-judo/","events":["birth death"]}],"source_yaml":"database/persons/JPN/Iikubo_Tsunetoshi.yaml"}},{"data":{"id":"JDP-77","name":"Hirano Yuzo","nationality":["JPN"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/hirano_202402/hirano.png","source":{"uri":"https://orca.cardiff.ac.uk/id/eprint/136518/"}},"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://www.abola.pt/espaco-universidade/noticias/os-primordios-do-jujutsu-em-portugal-artigo-de-vitor-rosa-147-2023080911320721614"},{"uri":"https://orca.cardiff.ac.uk/id/eprint/136518/"},{"uri":"https://judolandia.tripod.com/histport.htm"}],"source_yaml":"database/persons/JPN/Hirano_Yuzo.yaml"}},{"data":{"id":"JDP-91","name":"Hirano Tokio","native_name":{"name":"\u5E73\u91CE\u6642\u7537","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1922-10-06","location":"Awaji-shima","country_code":"JPN"},"death":{"date":"1993-07-26","location":null,"country_code":"JPN"},"photo":{"url":"https://archive.org/download/tokio_hirano/tokio_hirano.jpg","source":{"uri":"https://www.facebook.com/267050263349461/photos/pb.100063573521426.-2207520000/418174741570345/?type=3","cite":"Tokio Hirano - (Official) Facebook"}},"teachers":[{"id":"JDP-90","style_id":"JDP-S-1","place":"Bud\u014D Senmon Gakko","quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.researchgate.net/publication/263087428_Nanatsu-no-kata_Endo-no-kata_and_Joge-no-kata_-A_pedagogical_and_qualitative_biomechanical_evaluation_of_Hirano_Tokio\'s_kuzushi_unbalancing_concept_as_part_of_skill_acquisition_for_throwing_techniques","cite":"De Cr\xe9e, Carl. (2014). Nanatsu-no-kata, End\u014D-no-kata, and J\u014Dge-no-kata \u2015A pedagogical and qualitative biomechanical evaluation of Hirano Tokio\u2019s kuzushi (unbalancing) concept as part of skill acquisition for throwing techniques in K\u014Dd\u014Dkan j\u016Bd\u014D. Revista de Artes Marciales Asi\xe1ticas. 9. 69-96. 10.18002/rama.v9i2.1162.","citation":"While still at Ky\u014Dto, Hirano later also became an uchi deshi to Ushijima Tatsukuma"}]}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"8 dan","date":null,"sources":[{"uri":"https://www.researchgate.net/publication/263087428_Nanatsu-no-kata_Endo-no-kata_and_Joge-no-kata_-A_pedagogical_and_qualitative_biomechanical_evaluation_of_Hirano_Tokio\'s_kuzushi_unbalancing_concept_as_part_of_skill_acquisition_for_throwing_techniques","cite":"De Cr\xe9e, Carl. (2014). Nanatsu-no-kata, End\u014D-no-kata, and J\u014Dge-no-kata \u2015A pedagogical and qualitative biomechanical evaluation of Hirano Tokio\u2019s kuzushi (unbalancing) concept as part of skill acquisition for throwing techniques in K\u014Dd\u014Dkan j\u016Bd\u014D. Revista de Artes Marciales Asi\xe1ticas. 9. 69-96. 10.18002/rama.v9i2.1162.","citation":"Hirano Tokio, then 8th dan, passed away on 26 July 1993"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://judoinfo.com/hirano/"},{"uri":"https://ja.wikipedia.org/wiki/%E5%B9%B3%E9%87%8E%E6%99%82%E7%94%B7"},{"uri":"https://www.researchgate.net/publication/263087428_Nanatsu-no-kata_Endo-no-kata_and_Joge-no-kata_-A_pedagogical_and_qualitative_biomechanical_evaluation_of_Hirano_Tokio\'s_kuzushi_unbalancing_concept_as_part_of_skill_acquisition_for_throwing_techniques"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q21701522","cite":"Wikidata"}],"source_yaml":"database/persons/JPN/Hirano_Tokio.yaml"}},{"data":{"id":"JDP-113","name":"Hayashi Yazaemon","native_name":{"name":"\u6797\u5F25\u5DE6\u885B\u9580","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1892","location":null,"country_code":"JPN"},"death":{"date":"1964","location":null,"country_code":"JPN"},"photo":{"url":"https://archive.org/download/hayashi-yazaemon-sensei/Hayashi-Yazaemon-sensei.jpg","source":{"uri":"https://katorivietnam.org/otake-risuke-nippon-budokan-magazine-interview-about-katori-shinto-ryu-and-its-tradition-2020/","cite":"Hayashi Yazaemon-sensei (Shobukan Dojo)"}},"teachers":[{"id":"JDP-114","style_id":"JDP-S-6","place":null,"period":{"start":null,"end":null},"quality":2,"sources":[{"uri":"https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/","cite":"Exkurs: Die moderne Geschichte der Katori Shint\xf4 ry\xfb (Ein Leben f\xfcr die Schwertkunst)","citation":"Iisasa Morisada (sieben direkte Sch\xfcler): Yamaguchi Kumajir\xf4 Eikan Mairaku / Tamai Said\xf4 / Noguchi Jizaemon / Ono Heishichir\xf4 Moriichi / Shiina Ichiz\xf4 / Hong\xfb Toranosuke / Kaneko Shinosh\xf4 (...) Hayashi Saiichir\xf4 \u2013> Hayashi Yazaemon \u2013> \xd4take Risuke"},{"uri":"https://shinbukan-katorishintoryu.org/?page_id=898&lang=en","cite":"Tenshinsho-den Katori Shinto Ryu - Shinbukan Dojo","citation":"Shinbukan Dojo\u2019s practice of Katori Shinto Ryu follows the teachings passed down from Hayashi Sakuichiro Shihan to Hayashi Yazaemon Shihan, who was then succeeded by Otake Risuke Shihan (Shinbukan Dojo founder)."}]}],"rank":[{"style":"JDP-S-6","org":null,"teacher":"JDP-114","rank":"Gokui kaiden","date":null,"sources":[{"uri":"https://katorivietnam.org/otake-risuke-nippon-budokan-magazine-interview-about-katori-shinto-ryu-and-its-tradition-2020/","cite":"Otake Risuke Nippon Bud\u014Dkan Magazine Interview (Shobukan Dojo)","citation":"\u014Ctake: Hayashi-sensei, of course with his skill as a Gokui Kaiden holder of Katori Shint\u014D-ry\u016B, but also with his gentle and sincere character, was loved by his students as if he were the most affectionate father."}]}],"sources":[{"uri":"https://katorivietnam.org/otake-risuke-nippon-budokan-magazine-interview-about-katori-shinto-ryu-and-its-tradition-2020/"},{"uri":"https://en.wikipedia.org/wiki/Risuke_Otake"}],"source_yaml":"database/persons/JPN/Hayashi_Yazaemon.yaml"}},{"data":{"id":"JDP-114","name":"Hayashi Sakuichiro","native_name":{"name":"\u6797\u4F5C\u4E00\u90CE","lang":"ja"},"nationality":["JPN"],"birth":{"date":null,"location":null,"country_code":"JPN"},"death":{"date":null,"location":null,"country_code":"JPN"},"teachers":[{"id":"JDP-115","style_id":"JDP-S-6","place":null,"period":{"start":null,"end":null},"quality":2,"sources":[{"uri":"https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/","cite":"Exkurs: Die moderne Geschichte der Katori Shint\xf4 ry\xfb (Ein Leben f\xfcr die Schwertkunst)","citation":"Iisasa Morisada (sieben direkte Sch\xfcler): Yamaguchi Kumajir\xf4 Eikan Mairaku / Tamai Said\xf4 / Noguchi Jizaemon / Ono Heishichir\xf4 Moriichi / Shiina Ichiz\xf4 / Hong\xfb Toranosuke / Kaneko Shinosh\xf4 (...) Hayashi Saiichir\xf4 \u2013> Hayashi Yazaemon \u2013> \xd4take Risuke"},{"uri":"https://shinbukan-katorishintoryu.org/?page_id=898&lang=en","cite":"Tenshinsho-den Katori Shinto Ryu - Shinbukan Dojo","citation":"Shinbukan Dojo\u2019s practice of Katori Shinto Ryu follows the teachings passed down from Hayashi Sakuichiro Shihan to Hayashi Yazaemon Shihan, who was then succeeded by Otake Risuke Shihan (Shinbukan Dojo founder)."}]}],"rank":[{"style":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://shinbukan-katorishintoryu.org/?page_id=898&lang=en"}],"source_yaml":"database/persons/JPN/Hayashi_Sakuichiro.yaml"}},{"data":{"id":"JDP-92","name":"Funakoshi Gig\u014D","native_name":{"name":"\u8239\u8D8A\u7FA9\u8C6A","lang":"ja"},"aka":[{"name":"Funakoshi Yoshitaka"}],"nationality":["JPN"],"birth":{"date":"1906","location":"Okinawa","country_code":"JPN"},"death":{"date":"1945-11-24","location":"Tokyo","country_code":"JPN"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Gigo_funakoshi.jpg/200px-Gigo_funakoshi.jpg","source":{"uri":"https://ja.wikipedia.org/wiki/%E8%88%B9%E8%B6%8A%E7%BE%A9%E8%B1%AA#/media/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB:Gigo_funakoshi.jpg"}},"teachers":[{"id":"JDP-41","style_id":"JDP-S-5","place":null,"quality":2,"period":{"start":1918,"end":null},"sources":[{"uri":"https://en.wikipedia.org/wiki/Gig%C5%8D_Funakoshi","citation":"He was sickly as a child and began the formal study of karate-do at the age of twelve as a means to improve his health.[4] In the early years, Gichin Funakoshi often took Gigo with him to his trainings with Yasutsune Itosu"}]}],"rank":[{"style_id":"JDP-S-5","org":null,"teacher":"JDP-41","rank":"10 dan","date":null,"quality":1,"sources":[{"uri":"https://en.wikipedia.org/wiki/Gig%C5%8D_Funakoshi","citation":"10th dan, successor waka (\u5F8C\u7D99\u8005) sensei to his father"}],"style":"Karate","style_native":{"name":"\u7A7A\u624B","lang":"ja"}},{"style_id":"JDP-S-5","org":"Dai-Nippon Butoku Kai","teacher":null,"rank":"Renshi","date":null,"sources":[{"uri":"https://ryukyu-bugei.com/?p=7840","citation":"Renshi title holders are \u014Ctuska Hironori (Wad\u014D-ry\u016B), Funakoshi Gigo (Sh\u014Dt\u014Dkan, Funakoshi Gichin (Sh\u014Dt\u014Dkan)"}],"style":"Karate","style_native":{"name":"\u7A7A\u624B","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Gig%C5%8D_Funakoshi"},{"uri":"https://ja.wikipedia.org/wiki/%E8%88%B9%E8%B6%8A%E7%BE%A9%E8%B1%AA"},{"uri":"https://shotokai.com/gigo-yoshitaka-funakoshi/"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q628761","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Gig%C5%8D_Funakoshi","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Funakoshi_Gigo.yaml"}},{"data":{"id":"JDP-41","name":"Funakoshi Gichin","native_name":{"name":"\u8239\u8D8A \u7FA9\u73CD","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1868-10-11","location":"Shuri, Okinawa","country_code":"JPN"},"death":{"date":"1957-04-26","location":"Tokyo","country_code":"JPN"},"photo_url":"https://upload.wikimedia.org/wikipedia/commons/1/1d/EVD-kumite-002.jpg","teachers":[{"id":"JDP-56","style_id":"JDP-S-13","place":null,"period":{"start":null,"end":null},"quality":1,"sources":[{"uri":"https://en.wikipedia.org/wiki/Ank%C5%8D_Asato","citation":"Anko Asato (\u5B89\u91CC \u5B89\u6052, Asato Ank\u014D, Azato Yasutsune in Japanese, 1827 \u2013 1906) was a Ry\u016Bky\u016Ban master of karate. He and Ank\u014D Itosu were the two main karate masters who taught Gichin Funakoshi, the founder of Shotokan karate."}]},{"id":"JDP-55","style_id":"JDP-S-13","place":null,"period":{"start":null,"end":null},"quality":1,"sources":[{"uri":"https://en.wikipedia.org/wiki/Ank%C5%8D_Asato","citation":"Anko Asato (\u5B89\u91CC \u5B89\u6052, Asato Ank\u014D, Azato Yasutsune in Japanese, 1827 \u2013 1906) was a Ry\u016Bky\u016Ban master of karate. He and Ank\u014D Itosu were the two main karate masters who taught Gichin Funakoshi, the founder of Shotokan karate."}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Gichin_Funakoshi"},{"uri":"https://judoinfo.com/karateranks/"},{"uri":"https://search.worldcat.org/title/7673297"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q41105","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Gichin_Funakoshi","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Funakoshi_Gichin.yaml","photo_url_local":"images/cache/3bd273efb342fd77de8cd38ab0974a11.jpg"}},{"data":{"id":"JDP-57","name":"Fukuda Keiko","native_name":{"name":"\u798F\u7530 \u656C\u5B50","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1913-04-12","location":"Tokyo","country_code":"JPN"},"death":{"date":"2013-02-09","location":"San Francisco","country_code":"USA"},"description":{"en":"Keiko Fukuda (Japanese: \u798F\u7530 \u656C\u5B50, Hepburn: Fukuda Keiko, April 12, 1913 \u2013 February 9, 2013) was a Japanese-American martial artist. She was the highest-ranked female judoka in history, holding the rank of 9th dan from the Kodokan (2006), and 10th dan from USA Judo (July 2011) and from the United States Judo Federation (USJF) (September 2011), and was the last surviving student of Kan\u014D Jigor\u014D, founder of judo. She was a renowned pioneer of women\'s judo, together with her senpai Masako Noritomi (1913\u20131982) being the first woman promoted to 6th dan (c. 1972). In 2006 the Kodokan promoted Fukuda to 9th dan.[8] She is also the first and, so far, only woman to have been promoted to 10th dan in the art of judo."},"photo":{"url":"https://assets.change.org/photos/7/kx/tf/pUKxTfavKIGEOvT-800x450-noPad.jpg","source":{"uri":"https://www.change.org/p/uemura-haruki-demand-10th-degree-black-belt-for-keiko-fukuda","cite":"Change.org - Keiko Fukuda 10th dan petition"}},"teachers":[{"id":"JDP-1","style_id":"JDP-S-1","place":"Kodokan","period":{"start":1935,"end":1966},"quality":3,"sources":[{"uri":"https://books.google.pt/books?id=fNYDAAAAMBAJ&pg=PA29","cite":"Johnson, G. (1974): \xabA single reed that bends gracefully in the wind.\xbb Black Belt, 12(6):28\u201333.","citation":"Keiko Fukuda is the granddaughter of Professor Jigoro Kano\'s first jujitsu instructor. She began studying the art at Professor Kano\'s request at age 21 and since that time has taught in Australia,Canada, the Philippines, the U.S. and, of course, the Kodokan where she has received all her promotions (...) In the Kodokan, sometimes we would sit around the mat with Professor Kano and just talk and ask questions so we would know what each other was thinking"}]},{"id":"JDP-11","style_id":"JDP-S-1","place":"Kodokan","period":{"start":1935,"end":1966},"quality":3,"sources":[{"uri":"https://books.google.pt/books?id=fNYDAAAAMBAJ&pg=PA29","cite":"Johnson, G. (1974): \xabA single reed that bends gracefully in the wind.\xbb Black Belt, 12(6):28\u201333.","citation":"Miss Fukuda, describing her training with the late Professor Kyuzo Mifune (10th dan) (...)"}]}],"rank":[{"style_id":"JDP-S-1","org":"Kodokan","teacher":null,"rank":"9 dan","date":null,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}},{"style_id":"JDP-S-1","org":"USJF","teacher":null,"rank":"10 dan","date":null,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Keiko_Fukuda"},{"uri":"https://www.usjf.com/2018/02/keiko-fukuda/"},{"uri":"https://judoinfo.com/fukuda/"},{"uri":"https://books.google.pt/books?id=fNYDAAAAMBAJ&pg=PA29"},{"uri":"https://stephdavis.co/blog/a-living-legend-judo-master-keiko-fukuda/"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q460890","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Keiko_Fukuda","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Fukuda_Keiko.yaml"}},{"data":{"id":"JDP-2","name":"Fukuda Hachinosuke","native_name":{"name":"\u798F\u7530\u516B\u4E4B\u52A9","lang":"ja"},"nationality":["JPN"],"birth":{"date":1828,"location":"Nagatoro","country_code":"JPN"},"death":{"date":"1879-08-14","location":null,"country_code":"JPN"},"teachers":[{"id":"JDP-4","style_id":"JDP-S-3","place":"Otamagaike dojo","quality":null,"period":{"start":1851,"end":null}}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"http://www.tenyokai.com/history.html"},{"uri":"https://ja.wikipedia.org/wiki/%E7%A6%8F%E7%94%B0%E5%85%AB%E4%B9%8B%E5%8A%A9"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q22124384","cite":"Wikidata"}],"source_yaml":"database/persons/JPN/Fukuda_Hachinosuke.yaml"}},{"data":{"id":"JDP-93","name":"Egami Shigeru","native_name":{"name":"\u6C5F\u4E0A \u8302","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1912-12-07","location":"\u014Cmuta","country_code":"JPN"},"death":{"date":"1981-01-08","location":"Tokyo","country_code":"JPN"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/en/f/f4/Egami.jpg","source":{"uri":"https://en.wikipedia.org/wiki/Shigeru_Egami#/media/File:Egami.jpg"}},"teachers":[{"id":"JDP-41","style_id":"JDP-S-5","place":null,"quality":2,"period":{"start":1930,"end":null},"sources":[{"uri":"https://shotokai.com/shigeru-egami/","cite":"Master Shigeru Egami, O-sensei\u2019s successor (1912-1981) (Shotokai Encyclopedia)","citation":"Egami met Master Funakoshi when he was 18 years old, the moment he began studying at the famous Waseda University, there he helped to establish its Karate Do Club. (...)  He followed his Master together with Yoshitaka Funakoshi and Takeshi Shimoda all around Japan staging exhibitions, trying to expand the knowledge of Karate-do as a Japanese martial art."}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null,"quality":null}],"sources":[{"uri":"https://www.shotokai.jp/en_about/en_teacher/en_egami/"},{"uri":"https://en.wikipedia.org/wiki/Shigeru_Egami"},{"uri":"https://ja.wikipedia.org/wiki/%E6%B1%9F%E4%B8%8A%E8%8C%82"},{"uri":"https://budojapan.com/karate/20230608se/"},{"uri":"https://shotokai.com/shigeru-egami/"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q1246030","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Shigeru_Egami","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Egami_Shigeru.yaml"}},{"data":{"id":"JDP-56","name":"Asato Ank\u014D","native_name":{"name":"\u5B89\u91CC \u5B89\u6052","lang":"ryu"},"nationality":["JPN"],"birth":{"date":1827,"location":"Shuri, Okinawa","country_code":"JPN"},"death":{"date":1903,"location":null,"country_code":null},"photo_url":"https://archive.org/download/anko-asato/Anko-Asato.jpg","teachers":[{"id":"JDP-54","style_id":"JDP-S-13","place":null,"period":{"start":null,"end":null},"quality":1,"sources":[{"uri":"https://en.wikipedia.org/wiki/Ank%C5%8D_Asato","citation":"In a 1934 article, Funakoshi noted that Asato and Itosu had studied karate together under S\u014Dkon Matsumura."}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E5%AE%89%E9%87%8C%E5%AE%89%E6%81%92"},{"uri":"https://www.world-traditional-karate-federation.com/anko-asato-move-to-tokyo.html"},{"uri":"https://web.archive.org/web/20100227032428/http://www.shotokai.jp/english/about/teacher.html"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q721201","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Ank%C5%8D_Asato","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Asato_Anko.yaml","photo_url_local":"images/cache/b76050a70bf8ad93156f68171d1b25fd.jpg"}},{"data":{"id":"JDP-58","name":"Abbe Kenshir\xf5","native_name":{"name":"\u963F\u90E8 \u8B19\u56DB\u90CE","lang":"ja"},"nationality":["JPN"],"birth":{"date":"1915-12-15","location":"Tokushima","country_code":"JPN"},"death":{"date":"1985-12-01","location":"Tokushima","country_code":"USA"},"description":{"en":"Kenshiro Abbe was a prominent Japanese master of judo, aikido, and kendo. He introduced aikido to the United Kingdom in 1955, and founded the Kyushindo system.  Abbe was a graduate of the Budo Senmon Gakko, having studied judo and kendo there. Following an illustrious early career in the martial arts, he served in the Imperial Japanese Army before and during World War II. He then trained in aikido under its founder, Morihei Ueshiba, for a decade. Abbe held dan ranks in several martial arts, most notably 8th dan in judo, 6th dan in aikido, and 6th dan in kendo. After introducing aikido to the UK, he established several Japanese martial arts councils there during the late 1950s. He returned to Japan in 1964 and remained there for most of the remainder of his life."},"photo":{"url":"https://upload.wikimedia.org/wikipedia/en/thumb/5/56/Kenshiro_Abbe.jpg/220px-Kenshiro_Abbe.jpg","source":{"uri":"https://en.wikipedia.org/wiki/Kenshiro_Abbe#/media/File:Kenshiro_Abbe.jpg","cite":"Kenshiro Abbe - Wikipedia (original from Kendo Nagasaki, http://kendonagasaki.org/)"}},"teachers":[{"id":"JDP-59","style_id":"JDP-S-8","place":"Bud\u014D Senmon Gakko","period":{"start":1934,"end":1945},"quality":3,"sources":[{"uri":"https://web.archive.org/web/20090218133219/http://rrjudo.com/history/zenjudo.htm","cite":"Kenshiro Abbe, The Kyu-Shin-Do And Zen Judo - Keo Cavalcanti, 6th Dan Zen Judo","citation":"At the Busen Abbe received instruction from Ogawa Hanshi (genius), the Butokukai Judan (10th Dan) sword master. While at the Busen Kenshiro also enrolled in Mr. Gen Tanabe\'s philosophy class, at the Kyoto Teikoku University. That early encounter with philosophy would be influential in the formation of his system. While the training was arduous at the Busen, Kenshiro managed to receive his Yondan (4th Dan) rank in Judo, being again the young Judoka to attain it. His sister, Toyoka, decided to take Martial Arts too, enrolling in Mrs. Mitamura\'s Naginata class. She would dedicate the rest of her life to the practice of the art."}]},{"id":"JDP-27","style_id":"JDP-S-4","place":null,"period":{"start":1937,"end":1947},"quality":3,"sources":[{"uri":"https://web.archive.org/web/20090218133219/http://rrjudo.com/history/zenjudo.htm","cite":"Kenshiro Abbe, The Kyu-Shin-Do And Zen Judo - Keo Cavalcanti, 6th Dan Zen Judo","citation":"In 1937, at the age of 23, Abbe was awarded his Rokudan (6th Dan) rank and in June of that year he enlisted in the Japanese army, serving for four years in a garrison in the Toan-sho Province in Manchuria. It was during the time in Manchuria that Abbe began formulating his theory of Budo (the Way of the Warrior), Kyu-Shin-Do. And it was also at this time that Abbe was invited by O\'Sensei, Morihei Ueshiba to study Aikido under his care."}]}],"rank":[{"style_id":"JDP-S-8","org":"Dai-Nippon Butoku Kai","teacher":null,"rank":"6 dan","date":1945,"style":"Kendo","style_native":{"name":"\u5263\u9053","lang":"ja"}},{"style_id":"JDP-S-4","org":null,"teacher":"JDP-27","rank":"6 dan","date":1945,"style":"Aikid\u014D","style_native":{"name":"\u5408\u6C17\u9053","lang":"ja"}},{"style_id":"JDP-S-1","org":"Dai-Nippon Butoku Kai","teacher":null,"rank":"7 dan","date":1945,"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Kenshiro_Abbe"},{"uri":"https://ja.wikipedia.org/wiki/%E9%98%BF%E9%83%A8%E8%AC%99%E5%9B%9B%E9%83%8E"},{"uri":"http://www.sydhoare.com/Kenshiro.pdf"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q1739011","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Keiko_Fukuda","cite":"DBpedia"}],"source_yaml":"database/persons/JPN/Abe_Kenshiro.yaml"}},{"data":{"id":"JDP-69","name":"Frigyes T\u04E7r\u04E7k","aka":[{"name":"Frigyes Vilmos T\xf6r\xf6k"}],"nationality":["HUN"],"birth":{"date":1944,"location":"Budapest","country_code":"HUN"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/torok_202402/torok.jpeg","source":{"uri":"https://judomagazine.pt/2023/05/16/entrevista-viagem-ao-mundo-dos-homens-bons-2/","cite":"ENTREVISTA \u2013 Viagem ao mundo dos homens bons (Judo Magazine)"}},"teachers":[{"id":"JDP-12","style_id":"JDP-S-1","place":"Judo Clube de Portugal","quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf","cite":"Manual de Gradua\xe7\xf5es e Regulamento de Gradua\xe7\xf5es. Federa\xe7\xe3o Portuguesa de Judo (Dezembro 2020)","citation":"Em 1974, o ent\xe3o presidente da Federa\xe7\xe3o Portuguesa de Judo, Prof. Fernando Costa Matos, sabendo da inten\xe7\xe3o do Mestre Frigyes T\u04E7r\u04E7k, 3\xba Dan, de regressar a Portugal, vindo de Angola onde lecionava, colocou em contacto este professor de ascend\xeancia h\xfangara e disc\xedpulo direto do Mestre Kiyoshi Kobayashi, com a Dire\xe7\xe3o do Clube. "}]}],"rank":[{"style_id":"JDP-S-1","org":"FPJ","teacher":null,"rank":"7 dan","date":2019,"sources":[{"uri":"https://www.fpj.pt/wp-content/uploads/2020/06/Relat%C3%B3rio-Anual-FPJ-2019-23jun2020.pdf","cite":"Relat\xf3rio Anual FPJ 2019","citation":"Os Diplomas de 7.\xba Dan foram atribu\xeddos aos Mestres Ant\xf3nio Roquete de Andrade, Artur Alves da Mata, Jos\xe9 Pinto Farias, Nelson Trindade e Frygyes Torok"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://judolandia.tripod.com/torok.htm"},{"uri":"https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf"},{"uri":"https://judomagazine.pt/2023/05/16/entrevista-viagem-ao-mundo-dos-homens-bons-2/"},{"uri":"http://clubejudoporto.weebly.com/os-nossos-fundadores.html"}],"source_yaml":"database/persons/HUN/Frigyes_Torok.yaml"}},{"data":{"id":"JDP-125","name":"Yves Klein","nationality":["FRA"],"birth":{"date":"1928-04-28","location":"Nice","country_code":"FRA"},"death":{"date":"1962-06-06","location":"Paris","country_code":"FRA"},"photo":{"url":"https://www.radiofrance.fr/s3/cruiser-production/2023/12/8d7118cf-6be3-4573-8886-fd621281f20d/860_sc_photo-file-597.webp","source":{"uri":"https://www.radiofrance.fr/francebleu/podcasts/les-pourquoi-de-la-cote-d-azur/pourquoi-7150784","cite":"Pourquoi un judoka ni\xe7ois est-il devenu le ma\xeetre du bleu ? - Radio France"}},"teachers":[{"id":"JDP-124","style_id":"JDP-S-1","place":"Kodokan","period":{"start":"1952","end":"1954"},"quality":3,"sources":[{"uri":"https://theeverydaypress.net/the-foundations-of-judo/","cite":"THE FOUNDATIONS OF JUDO - The Everyday Press","citation":"In the early 1950s, the 24-year-old Yves Klein spent a year and a half in Tokyo, studying mainly at the Kodokan under the ninth-dan judo master Oda"}]},{"id":"JDP-124","style_id":"JDP-S-1","place":"Municipal Police of Tokyo","period":{"start":"1952","end":"1954"},"quality":2,"sources":[{"uri":"https://www.ianwhittlesea.net/works_pages/wks_klein/wks_klein1.html","cite":"The Foundations of Judo - Ian Whittlesea","citation":"He has spent this time solely studying Judo... with the Municipal Police of Tokyo under Master Oda"}]}],"rank":[{"style_id":"JDP-S-1","rank":"4 dan","date":"1954","org":"Kodokan","quality":3,"sources":[{"uri":"https://www.yvesklein.com/en/yves-klein/","cite":"Yves Klein - Official Website","citation":"Shortly before his return, he obtained his 4th dan in judo, thus reaching the highest level in Europe"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://theeverydaypress.net/the-foundations-of-judo/"},{"uri":"https://www.ianwhittlesea.net/works_pages/wks_klein/wks_klein1.html"},{"uri":"https://en.wikipedia.org/wiki/Yves_Klein"},{"uri":"https://fr.wikipedia.org/wiki/Yves_Klein"},{"uri":"https://www.yvesklein.com/en/yves-klein/"},{"uri":"https://walkerart.org/magazine/yves-klein-the-judoka/"}],"source_yaml":"database/persons/FRA/Yves_Klein.yaml"}},{"data":{"id":"JDP-78","name":"Jackie Hugnet","nationality":["FRA"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":"2 dan","date":null,"sources":[{"uri":"https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf","cite":"Manual de Gradua\xe7\xf5es e Regulamento de Gradua\xe7\xf5es. Federa\xe7\xe3o Portuguesa de Judo (Dezembro 2020)","citation":"Determinado em encontrar professores que o ajudassem a criar um Dojo, conheceu no ent\xe3o Parque de Campismo do Lima o franc\xeas Mestre Hugnet. N\xe3o podendo ficar em Portugal, mas sens\xedvel \xe0 determina\xe7\xe3o de Manuel Reis, enviou o seu irm\xe3o, Jackie Hugnet, 2\xba Dan, para o Porto."}]}],"sources":[{"uri":"http://clubejudoporto.weebly.com/os-nossos-fundadores.html"},{"uri":"https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf"}],"source_yaml":"database/persons/FRA/Jackie_Hugnet.yaml"}},{"data":{"id":"JDP-68","name":"Henri Bouchend\'Homme","nationality":["FRA"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null,"sources":[{"uri":"https://judolandia.tripod.com/histport.htm","cite":"Hist\xf3ria do Judo em Portugal (Judol\xe2ndia, texto de \xabJudo: da inicia\xe7\xe3o \xe0 competi\xe7\xe3o\xbb, Costa Branco et. al","citation":"Ainda neste ano vem para Lisboa, integrando-se no  corpo docente do  Liceu Franc\xeas Charles Lepierre, Henri Bouchend\'Homme - professor de Educa\xe7\xe3o F\xedsica e 1\xba Dan. Henri Bouchend\u2019 Homme vendo que n\xe3o se praticava Judo em Lisboa come\xe7ou a leccionar no Lisboa Gin\xe1sio."}]}],"sources":[{"uri":"https://judolandia.tripod.com/histport.htm"}],"source_yaml":"database/persons/FRA/Henri_Bouchend_Homme.yaml"}},{"data":{"id":"JDP-79","name":"Gilbert Briskine","nationality":["FRA"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":null,"org":"FFJDA","teacher":null,"rank":"4 dan","date":null,"sources":[{"uri":"https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf","cite":"Manual de Gradua\xe7\xf5es e Regulamento de Gradua\xe7\xf5es. Federa\xe7\xe3o Portuguesa de Judo (Dezembro 2020)","citation":"No Ver\xe3o de 1961, o professor Hugnet \xe9 substitu\xeddo pelo tamb\xe9m franc\xeas, Gilbert Bryskine, 4\xba Dan, campe\xe3o de Fran\xe7a, bicampe\xe3o da Europa (1952 e 1954) e professor diplomado pela Federa\xe7\xe3o Francesa de Judo e Ju Jutsu."}]}],"sources":[{"uri":"http://clubejudoporto.weebly.com/os-nossos-fundadores.html"},{"uri":"https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf"},{"uri":"https://www.fnkp.pt/historia/"},{"uri":"https://www.judoinside.com/judoka/5062/Gilbert_Briskine/judo-career"}],"source_yaml":"database/persons/FRA/Gilbert_Briskine.yaml"}},{"data":{"id":"JDP-109","name":"Erich Rahn","nationality":["DEU"],"birth":{"date":"1885-05-01","location":"Berlin","country_code":"DEU"},"death":{"date":"1973-07-05","location":"Berlin","country_code":"DEU"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/d/da/Bundesarchiv_Bild_102-12574%2C_Berlin%2C_Jiu-Jitsu-Schule.jpg","source":{"uri":"https://de.wikipedia.org/wiki/Erich_Rahn#/media/Datei:Bundesarchiv_Bild_102-12574,_Berlin,_Jiu-Jitsu-Schule.jpg","cite":"Erich Rahn (below) performing an overhead throw (Tomoe-nage), November 1931 (Wikipedia)"}},"teachers":[{"name":"Higashi","style_id":"JDP-S-14","place":null,"period":{"start":null,"end":null},"quality":null}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://de.wikipedia.org/wiki/Erich_Rahn"},{"uri":"https://judoencyclopedia.jimdofree.com/internationalization-diffusion-of-judo/"}],"source_yaml":"database/persons/DEU/Erich_Rahn.yaml"}},{"data":{"id":"JDP-110","name":"Alfred Rhode","aka":[{"name":"Alfred Werner Carl Rhode"}],"nationality":["DEU"],"birth":{"date":"1896-08-16","location":"Steinwalde","country_code":"DEU"},"death":{"date":"1978-09-13","location":"Sprendlingen","country_code":"DEU"},"photo":{"url":"https://archive.org/download/alfred_rhode/alfred_rhode.jpg","source":{"uri":"https://www.bath.ac.uk/library/cabinet-of-curiosities/story/45","cite":"Yannick SCHULTZE - Die \xabInternationale Judo-Sommerschule\xbb"}},"teachers":[{"id":"JDP-109","style_id":"JDP-S-14","place":null,"period":{"start":null,"end":null},"quality":null,"sources":[{"uri":"https://books.google.de/books?id=Oa8Cdh9UVrIC","cite":"WEDEMEYER-KOLWE, Bernd. \xabDer neue Mensch\xbb: K\xf6rperkultur im Kaiserreich und in der Weimarer Republik. K\xf6nigshausen & Neumann, 2004, p. 308","citation":"(...) 1922 gr\xfcndete der Rahn-Sch\xfcler Alfred Rohde dann den 1. Deutschen Judo-Club in Frankfur (...)"},{"uri":"https://link.springer.com/chapter/10.1057/9781137573971_6","cite":"PANZER, Sarah. When Jiu-Jitsu was German: Japanese Martial Arts in German Sport-and K\xf6rperkultur, 1905\u20131933. In: Transnational Encounters between Germany and Japan: Perceptions of Partnership in the Nineteenth and Twentieth Centuries. New York: Palgrave Macmillan US, 2016. p. 91-106.","citation":"The first German judo club was formed in 1922 in Frankfurt by Alfred Rhode, a former student of Erich Rahn. For several years, jiu-jitsu and judo coexisted relatively collegially in Germany, most likely because the still relatively small community of instructors and active participants made cooperation necessary if either discipline was to survive"}]}],"rank":[{"style_id":"JDP-S-1","org":"Deutsches-Dan Kollegium","teacher":null,"rank":"8 dan","date":"1976-08-16","sources":[{"uri":"http://www.lothar-nest.de/ln0243/ddk1932.html","cite":"Sportschule Lothar Nest: Judo - Sommerschule 1932 in Frankfurt a.M. aus den Unterlagen von Dieter Schiemann","citation":"Doris Schiemann und ihr Sohn Holger \xfcberbringen Lothar Nest mehrere Kartons aus dem Nachla\xdf von Dieter Schiemann, - er war Schatzmeister des DDK/DJB in den 60er Jahren und \xfcberreichte Alfred Rhode am 16.8.1076 die Urkunde zum 8.DAN DDK/DJB! Alfred Rhode gr\xfcndete 1952 das DDK."}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://de.wikipedia.org/wiki/Alfred_Rhode"},{"uri":"https://www.judobund.de/ueber-uns/judo-und-seine-geschichte"},{"uri":"https://www.ijf.org/history/from-martial-art-to-olympic-sport/1129"},{"uri":"https://www.bath.ac.uk/library/cabinet-of-curiosities/story/45"},{"uri":"http://www.lothar-nest.de/ln0243/ddk1932.html"},{"uri":"https://www.1djc.de/judobilder1952.html"}],"source_yaml":"database/persons/DEU/Alfred_Rhode.yaml"}},{"data":{"id":"JDP-118","name":"Zhang Zhaodong","native_name":{"name":"\u5F35\u5146\u6771","lang":"zh"},"nationality":["CHN"],"birth":{"date":"1865","location":null,"country_code":"CHN"},"death":{"date":"1938","location":"Tianjin","country_code":"CHN"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/b/b1/250_Bagau016ChangChaoDong.jpg","source":{"uri":"https://en.wikipedia.org/wiki/Baguazhang#/media/File:250_Bagau016ChangChaoDong.jpg","cite":"Xingyi/Baguazhang master Chang Chan Kuei (1859\u20131940) [Wikipedia Commons]"}},"teachers":[{"id":null,"style_id":null,"place":null,"period":{"start":null,"end":null},"quality":2}],"rank":[{"style":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://zh.wikipedia.org/w/index.php?title=%E5%BC%B5%E5%8D%A0%E9%AD%81"},{"uri":"https://www.taipeitimes.com/News/feat/archives/2002/02/17/124274"}],"source_yaml":"database/persons/CHN/Zhang_Zhaodong.yaml"}},{"data":{"id":"JDP-117","name":"Wang Shujin","aka":[{"name":"Wang Heng Sun"}],"nationality":["CHN","TWN"],"birth":{"date":"1904","location":null,"country_code":"CHN"},"death":{"date":"1981","location":"Taipei","country_code":"TWN"},"photo":{"url":"https://archive.org/download/wang-hawk-posture/Wang-hawk-posture.jpg","source":{"uri":"https://blog.awma.com/man-of-steel/wang-hawk-posture/","cite":"Wang [Shujin] hawk posture (AWMA)"}},"teachers":[{"id":"JDP-118","style_id":"JDP-S-17","place":null,"period":{"start":null,"end":null},"quality":2,"sources":[{"uri":"https://www.taipeitimes.com/News/feat/archives/2002/02/17/124274","cite":"Martial arts fight for survival (Taipei Times)","citation":" By chance one day, a senior student of the famous martial arts master Zhang Zhao-dong came to the business where Wang worked. (...)  Under Zhang\'s instruction, Wang learned the two arts for which he would later become famous; pa kua chang and hsing yi chuan. Pa kua chang means \\"eight diagram palms\\" and refers to the eight core diagrams which make up the I-Ching (\u6613\u7D93, Book of Changes), one of the most important books of classical Chinese philosophy"}]},{"id":"JDP-118","style_id":"JDP-S-18","place":null,"period":{"start":null,"end":null},"quality":2,"sources":[{"uri":"https://www.taipeitimes.com/News/feat/archives/2002/02/17/124274","cite":"Martial arts fight for survival (Taipei Times)","citation":" By chance one day, a senior student of the famous martial arts master Zhang Zhao-dong came to the business where Wang worked. (...)  Under Zhang\'s instruction, Wang learned the two arts for which he would later become famous; pa kua chang and hsing yi chuan. Pa kua chang means \\"eight diagram palms\\" and refers to the eight core diagrams which make up the I-Ching (\u6613\u7D93, Book of Changes), one of the most important books of classical Chinese philosophy"}]}],"rank":[{"style":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://en.wikipedia.org/wiki/Wang_Shujin"},{"uri":"https://www.taipeitimes.com/News/feat/archives/2002/02/17/124274"}],"links":[{"uri":"https://www.wikidata.org/wiki/Q4018116","cite":"Wikidata"},{"uri":"https://dbpedia.org/page/Wang_Shujin","cite":"DBpedia"}],"source_yaml":"database/persons/CHN/Wang_Shujin.yaml"}},{"data":{"id":"JDP-128","name":"Petrucio Monteiro","aka":[{"name":"Petrucio de Queiroz Monteiro"}],"nationality":["BRA"],"birth":{"date":"1942","location":"","country_code":"BRA"},"death":{"date":"2022","location":"","country_code":"BRA"},"photo":{"url":"https://i0.wp.com/judorio.org/wp-content/uploads/2022/04/Petrucio-Monteiro.jpg","source":{"uri":"https://judorio.org/nota-de-pesar-falecimento-do-sensei-petrucio-de-queiroz-monteiro/","cite":"Nota de pesar \u2013 Falecimento do Sensei Petrucio de Queiroz Monteiro"}},"teachers":[{"id":"JDP-127","style_id":"JDP-S-1","quality":2,"place":"Academia Rudolf Hermanny","period":{"start":null,"end":null},"sources":[{"uri":"https://benfeitoria.com/projeto/biopetrucio","cite":"Biografia Petrucio Monteiro - Benfeitoria","citation":"O professor Petrucio seguiu a linha do professor Rudolf Hermanny"}]}],"rank":[{"style_id":"JDP-S-1","rank":"1 dan","date":"1967","org":null,"sources":[{"uri":"https://www.judorio.org/PDF/PETRUCIO%20MONTEIRO.pdf","cite":"Petrucio Monteiro (PDF)","citation":"Faixa preta desde 1967"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://judorio.org/nota-de-pesar-falecimento-do-sensei-petrucio-de-queiroz-monteiro/"},{"uri":"https://benfeitoria.com/projeto/biopetrucio"},{"uri":"https://www.judorio.org/PDF/PETRUCIO%20MONTEIRO.pdf"},{"uri":"https://www.facebook.com/judopetruciomonteiro/"}],"source_yaml":"database/persons/BRA/Petrucio_Monteiro.yaml"}},{"data":{"id":"JDP-134","name":"Pedro Valente Sr.","nationality":["BRA"],"birth":{"date":"1928-11-21","location":"Rio de Janeiro","country_code":"BRA"},"death":{"date":"2016-05-28","location":"","country_code":"BRA"},"photo":{"url":"https://archive.org/download/pedro_valente_sr/pedro_valente_sr.png","source":{"uri":"https://valentebrothers.com/our-story/","cite":"Valente Brothers: Our Story"}},"teachers":[{"id":"JDP-102","style_id":"JDP-S-16","place":"Academia Gracie, Rio de Janeiro","period":{"start":"1951","end":null},"quality":3,"sources":[{"uri":"https://www.graciemag.com/interview-with-red-belt-pedro-valente-sr/","cite":"Interview with red-belt Pedro Valente Sr. - GracieMag","citation":"My father took me to the Gracie Academy in downtown Rio back in the 50\u2019s. I was 13 then and started to learn Jiu-Jitsu. Later on I participated at some fights at Maracan\xe3zinho"}]}],"rank":[{"style_id":"JDP-S-16","rank":"7 dan","teacher":"JDP-102","date":null,"sources":[{"uri":"https://www.graciemag.com/interview-with-red-belt-pedro-valente-sr/","cite":"Interview with red-belt Pedro Valente Sr. - GracieMag","citation":"Helio Gracie himself gave me my black belt, as well as the teacher\u2019s degree and the red and black 7th Dan belt"}],"style":"Brazilian jiu-jitsu","style_native":{"name":"Jiu-Jitsu brasileiro","lang":"pt"}}],"sources":[{"uri":"https://www.facebook.com/photo.php?fbid=1524410540929851&id=188638484507070&set=a.614160078621573"},{"uri":"https://www.gresportela.com.br/Noticias/Detalhes/portela-participa-de-homenagem-ao-cirurgiao-e-torcedor-ilustre-pedro-valente"},{"uri":"https://www.graciemag.com/interview-with-red-belt-pedro-valente-sr/"},{"uri":"https://valentebrothers.com/our-story/"}],"source_yaml":"database/persons/BRA/Pedro_Valente_Sr.yaml"}},{"data":{"id":"JDP-135","name":"Pedro Valente","nationality":["BRA"],"birth":{"date":null,"location":null,"country_code":"BRA"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/pedro_valente/pedro_valente.jpg","source":{"uri":"https://www.youtube.com/watch?v=kggBsJ0j5FI","cite":"Pedro Valente - Resenha PVT"}},"teachers":[{"id":"JDP-134","style_id":"JDP-S-16","place":null,"quality":3,"period":{"start":null,"end":null},"sources":[{"uri":"https://valentebrothers.com/our-story/","cite":"Valente Brothers: Our Story","citation":"Pedro Valente Sr. taught his sons Pedro, Gui, and Joaquim the art of Gracie Jiu-Jitsu"}]}],"rank":[{"style_id":"JDP-S-16","rank":"Black belt","teacher":"JDP-S-16","date":null,"sources":[{"uri":"https://valentebrothers.com/instructors/","cite":"Valente Brothers Instructors","citation":""}],"style":"Brazilian jiu-jitsu","style_native":{"name":"Jiu-Jitsu brasileiro","lang":"pt"}}],"sources":[{"uri":"https://valentebrothers.com/our-story/"},{"uri":"https://valentebrothers.com/instructors/"}],"source_yaml":"database/persons/BRA/Pedro_Valente.yaml"}},{"data":{"id":"JDP-106","name":"Oswaldo Fadda","aka":[{"name":"Oswaldo Baptista Fadda"}],"nationality":["BRA"],"birth":{"date":"1920-08-01","location":"Rio de Janeiro","country_code":"BRA"},"death":{"date":"2005-04-01","location":"Rio de Janeiro","country_code":"BRA"},"photo":{"url":"https://archive.org/download/oswaldo_fadda/oswaldo_fadda.jpeg","source":{"uri":"https://www.portaldovaletudo.com.br/fadda-e-paiva-explicam-origem-do-sapateiro-e-principais-linhagens-do-jiu-jitsu-do-suburbio-carioca/","cite":"Oswaldo Fadda (Portal do Vale Tudo)"}},"teachers":[{"id":"JDP-20","style_id":"JDP-S-16","place":"Academia Fran\xe7a de Jiu-jitsu","period":{"start":1938,"end":null},"quality":3,"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 108","citation":"Oswaldo Fadda come\xe7ou a treinar com Fran\xe7a por volta de 1938"}]},{"id":"JDP-129","style_id":"JDP-S-19","place":"Liga de Esportes da Marinha","period":{"start":1938,"end":null},"quality":3,"sources":[{"uri":"https://www.faddabjj.com/historia-fadda","cite":"A hist\xf3ria da Fam\xedlia Fadda (FaddaBJJ)","citation":"Antes da sua hist\xf3ria com o Jiu-Jitsu, os primeiros passos de Fadda no mundo das lutas foi na \\"Nobre Arte\\", ou seja, no boxe, atrav\xe9s do campe\xe3o Baltazar Cardoso."}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null,"sources":[{"uri":"https://bjjfanatics.com.br/blogs/news/oswaldo-fadda","cite":"Oswaldo Fadda, Um Pioneiro na Democratiza\xe7\xe3o do Jiu Jitsu (BJJ Fanatics)","citation":"Oswaldo Baptista Fadda, conhecido como \u201CMestre Fadda\u201D, nascido 15 de janeiro de 1921 no Rio de Janeiro e falecido em 1 de abril de 2005, na mesma cidade. Fadda foi um Grande Mestre de Jiu Jitsu Brasileiro, chegando ao 9\xba grau (faixa vermelha), sendo o aluno mais talentoso de Luiz Fran\xe7a, e dando continuidade ao legado de seu mestre, sendo um dos mais importantes nomes da linhagem de mestres da GF Team, como Julio Cesar e Bara\xfana."}]}],"sources":[{"uri":"https://pt.wikipedia.org/wiki/Oswaldo_Fadda"},{"uri":"https://isbnsearch.org/isbn/9798639871030"},{"uri":"https://bjjfanatics.com.br/blogs/news/oswaldo-fadda"},{"uri":"https://web.archive.org/web/20240507104820/https://www.faddabjj.com/historia-fadda"}],"source_yaml":"database/persons/BRA/Oswaldo_Fadda.yaml"}},{"data":{"id":"JDP-45","name":"Mario Aleixo","nationality":["BRA"],"birth":{"date":1887,"location":"Rio de Janeiro, RJ","country_code":"BRA"},"death":{"date":1947,"location":null,"country_code":"BRA"},"photo_url":"https://img1.wsimg.com/isteam/ip/480b94b8-cb6a-48b7-9add-7d9635474067/Aleixo_1918.jpg/:/rs=w:400,cg:true,m","teachers":[{"id":"JDP-18","style_id":"JDP-S-1","place":null,"period":{"start":1915,"end":null},"quality":3,"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 1, p. 110","citation":"M\xe1rio Alexio teve o privil\xe9gio de se adestrar no Jiu Jitsu com dois dos mais experientes e famosos mestres japoneses dos ringues. Recebeu suas primeiras instru\xe7\xf5es de Sada Miyako por volta de 1909. Posteriormente teve a oportunidade de se aperfei\xe7oar com o grande Conde Koma, pouco depois deste chegar ao Brasil, em 1915."}]},{"id":"JDP-107","style_id":"JDP-S-1","place":null,"period":{"start":1909,"end":null},"quality":3,"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 1, p. 110","citation":"M\xe1rio Alexio teve o privil\xe9gio de se adestrar no Jiu Jitsu com dois dos mais experientes e famosos mestres japoneses dos ringues. Recebeu suas primeiras instru\xe7\xf5es de Sada Miyako por volta de 1909. Posteriormente teve a oportunidade de se aperfei\xe7oar com o grande Conde Koma, pouco depois deste chegar ao Brasil, em 1915."}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://agbook.com.br/book/361393--MUITO_ANTES_DO_MMA_O_legado_dos_precursores_do_Vale_Tudo_no_Brasil_e_no_mundo"}],"source_yaml":"database/persons/BRA/Mario_Aleixo.yaml","photo_url_local":"images/cache/c6045e9f5e720ffc90b700bc4a13cc78.jpg"}},{"data":{"id":"JDP-20","name":"Luis de Fran\xe7a Filho","aka":[{"name":"Luiz Fran\xe7a"}],"nationality":["BRA"],"birth":{"date":"1910-06-02","location":"Alagoas","country_code":"BRA"},"death":{"date":null,"location":null,"country_code":null},"photo_url":"https://ia601602.us.archive.org/29/items/luiz_franca_filho/vsr23XAf.jpg","teachers":[{"id":"JDP-22","style_id":"JDP-S-1","place":null,"period":{"start":1916,"end":null},"quality":1,"sources":[{"uri":"https://www.bjjheroes.com/bjj-fighters/luiz-franca","cite":"BJJ Heroes: Luiz Fran\xe7a","citation":"There Satake settled for a while, opening his own academy in 1916, at the Atl\xe9tico Clube Rio Negro, becoming the first Japanese to open a Judo/Jiu Jitsu academy in Brazil. This gym became the place where Luiz Fran\xe7a started his life as a martial artist. Satake would also become a Brazilian citizen years later, and change his name to Ant\xf4nio Soshihiro Satake."},{"uri":"https://www.facebook.com/photo.php?fbid=543032192445535&id=455479647867457&set=a.455593414522747","cite":"Equipe Fadda Jiu-Jitsu (Facebook)","citation":"Antigo aluno de Soishiro Satake e Mitsuyo Maeda, Luiz Fran\xe7a foi o fundador da linhagem (n\xe3o pertencente \xe0 fam\xedlia Gracie) de mais sucesso no Jiu-Jitsu, uma linhagem continuada especialmente atrav\xe9s do trabalho efetuado pelo mais proeminente e capaz aluno de Fran\xe7a, o Mestre Oswaldo Fadda, que mais tarde formaria a sua pr\xf3pria escola de talentosos alunos."}]},{"id":"JDP-18","style_id":"JDP-S-1","place":"Bel\xe9m","period":{"start":1929,"end":null},"quality":2,"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 106","citation":"Se Fran\xe7a se iniciou no Jiu Jitsu com o Conde Koma, muito provavelmente foi em 1929 n Marinha, quando esteve em Bel\xe9m ao servi\xe7o no navio Minas Gerais."}]},{"id":"JDP-103","style_id":"JDP-S-1","place":"Rio de Janeiro","period":{"start":1930,"end":null},"quality":2,"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 106","citation":"Posteriormente, deu continuidade ao seu aprendizado no Rio de Janeiro com Geo Omori, Takeo Yano e H\xe9lio Gracie..."}]},{"id":"JDP-102","style_id":"JDP-S-16","place":"Rio de Janeiro","period":{"start":null,"end":null},"quality":2,"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 106","citation":"Posteriormente, deu continuidade ao seu aprendizado no Rio de Janeiro com Geo Omori, Takeo Yano e H\xe9lio Gracie..."}]},{"id":"JDP-129","style_id":"JDP-S-19","place":"Liga de Esportes da Marinha","period":{"start":1928,"end":null},"quality":2,"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","citation":"Foi na Marinha, em 1928, que Fran\xe7a se iniciou nas artes marciais. Primeiro com o Boxe, sob a orienta\xe7\xe3o de Balthazar Cardoso"}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://repositorio.ufsc.br/handle/123456789/103771"},{"uri":"https://www.faddabjj.com/historia-fadda"},{"uri":"https://www.bjjee.com/articles/the-lost-legend-of-jacyntho-ferro-one-of-carlos-gracie-sr-s-jiu-jitsu-instructors/"},{"uri":"http://judotradicionalgoshinjutsukan.blogspot.com/2009/08/mitsuyo-maeda-nasc.html"},{"uri":"https://isbnsearch.org/isbn/9798639871030"}],"source_yaml":"database/persons/BRA/Luis_de_Fran\xe7a_Filho.yaml","photo_url_local":"images/cache/2eb49812686fa9df85178583b7666f50.jpg"}},{"data":{"id":"JDP-19","name":"Jacinto Ferro","nationality":["BRA"],"birth":{"date":1881,"location":null,"country_code":"BRA"},"death":{"date":1929,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/jacinto_ferro/jacinto_ferro.png","source":{"uri":"https://simonbjj.com/ferro"}},"teachers":[{"id":"JDP-18","style_id":"JDP-S-1","place":null,"quality":null,"period":{"start":1915,"end":null},"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 89","citation":"... Tenho [Maeda] os seguintes alunos aos quais deposito inteira confian\xe7a [...] Jacintho Ferro, Dr. Matheus Pereira, Guilherm de La Rocque, Raphael Gomes e Waldermar Gomes..."},{"uri":"https://judotradicionalgoshinjutsukan.blogspot.com/2009/08/mitsuyo-maeda-nasc.html","cite":"Mitsuyo Maeda e o Jud\xf4 Kodokan (Judo Tradicional Goshinjutsukan)","citation":"as aulas eram dadas em uma academia que Maeda abriu em 1916,nos sal\xf5es do Cine Teatro Moderno, localizado ao lado da Igreja de Nazar\xe9, hoje uma pra\xe7a, as aulas eram amplamente divulgadas nos ornais para quem quisesse aprender pagando.O primeiro aluno de Maeda foi o estivador Jacinto Ferro, ex-lutador de greco-romana, Jacinto foi instrutor de Maeda e ajudou a dar aulas para o Carlos Gracie."}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://repositorio.ufsc.br/handle/123456789/103771"},{"uri":"https://isbnsearch.org/isbn/9798639871030"},{"uri":"https://www.bjjee.com/articles/the-lost-legend-of-jacyntho-ferro-one-of-carlos-gracie-sr-s-jiu-jitsu-instructors/"},{"uri":"https://judotradicionalgoshinjutsukan.blogspot.com/2009/08/mitsuyo-maeda-nasc.html"}],"source_yaml":"database/persons/BRA/Jacinto_Ferro.yaml"}},{"data":{"id":"JDP-102","name":"H\xe9lio Gracie","nationality":["BRA"],"birth":{"date":"1913-10-01","location":"Bel\xe9m","country_code":"BRA"},"death":{"date":"2009-01-29","location":"Petr\xf3polis","country_code":"BRA"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/H%C3%A9lio_Gracie_%281952%29.tif/lossy-page1-800px-H%C3%A9lio_Gracie_%281952%29.tif.jpg","source":{"uri":"https://pt.wikipedia.org/wiki/H%C3%A9lio_Gracie#/media/Ficheiro:H%C3%A9lio_Gracie_(1952).tif","cite":"Arquivo Nacional, 1952 (H\xe9lio Gracie - Wikipedia)"}},"teachers":[{"id":"JDP-21","style_id":"JDP-S-16","place":null,"period":{"start":1925,"end":null},"quality":null,"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 165","citation":"... meu Jiu Jitsu era muito diferente do dele. O meu f\xf4ra aprendido h\xe1 muitos anos com o meu irm\xe3o Carlos..."},{"uri":"https://pt.wikipedia.org/wiki/H%C3%A9lio_Gracie","citation":"Observador, H\xe9lio passou a acompanhar, dos seus treze aos dezesseis anos, as aulas ministradas por Carlos."}]},{"name":"George","style_id":"JDP-S-16","place":null,"period":{"start":null,"end":null},"quality":null,"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol 3, p.91","citation":"H\xe9lio foi treinado por George para as suas primeiras lutas, antes deste romper com Carlos em 1934"}]}],"rank":[{"style_id":"JDP-S-16","org":null,"teacher":null,"rank":"10 dan","date":null,"sources":[{"uri":"https://ge.globo.com/rj/serra-lagos-norte/noticia/2017/01/faixa-vermelha-lembra-ensinamentos-de-helio-gracie-oito-anos-apos-morte.html","citation":"H\xe9lio Gracie foi o \xfaltimo condecorado com a faixa vermelha 10\xba grau"}],"style":"Brazilian jiu-jitsu","style_native":{"name":"Jiu-Jitsu brasileiro","lang":"pt"}}],"sources":[{"uri":"https://pt.wikipedia.org/wiki/H%C3%A9lio_Gracie"},{"uri":"https://isbnsearch.org/isbn/9798639871030"},{"uri":"https://bjjfanatics.com.br/blogs/news/helio-gracie-o-mestre-dos-mestres"}],"source_yaml":"database/persons/BRA/H\xe9lio_Gracie.yaml"}},{"data":{"id":"JDP-136","name":"Pedro Valente","nationality":["BRA"],"birth":{"date":null,"location":null,"country_code":"BRA"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/pedro_valente/pedro_valente.jpg","source":{"uri":"https://www.youtube.com/watch?v=kggBsJ0j5FI","cite":"Pedro Valente - Resenha PVT"}},"teachers":[{"id":"JDP-134","style_id":"JDP-S-16","place":null,"quality":3,"period":{"start":null,"end":null},"sources":[{"uri":"https://valentebrothers.com/our-story/","cite":"Valente Brothers: Our Story","citation":"Pedro Valente Sr. taught his sons Pedro, Gui, and Joaquim the art of Gracie Jiu-Jitsu"}]}],"rank":[{"style_id":"JDP-S-16","rank":"Black belt","teacher":"JDP-S-16","date":null,"sources":[{"uri":"https://valentebrothers.com/instructors/","cite":"Valente Brothers Instructors","citation":""}],"style":"Brazilian jiu-jitsu","style_native":{"name":"Jiu-Jitsu brasileiro","lang":"pt"}}],"sources":[{"uri":"https://valentebrothers.com/our-story/"},{"uri":"https://valentebrothers.com/instructors/"}],"source_yaml":"database/persons/BRA/Guilherme_Valente.yaml"}},{"data":{"id":"JDP-108","name":"George Gracie","nationality":["BRA"],"birth":{"date":"1911","location":null,"country_code":"BRA"},"death":{"date":"1986","location":null,"country_code":"BRA"},"photo":{"url":"https://archive.org/download/george_gracie/george_gracie.png","source":{"uri":"https://www.instagram.com/historyofbjj/p/C6I-H-prJB3/","cite":"George Gracie (History of BJJ Instagram)"}},"teachers":[{"id":"JDP-21","style_id":"JDP-S-1","place":null,"period":{"start":null,"end":null},"quality":null,"sources":[{"uri":"https://judotradicionalgoshinjutsukan.blogspot.com/2010/01/topico-bubishi.html","cite":"T\xf3pico Bubishi (Judo Tradicional Goshinjutsukan)","citation":"...O que sabemos de fato \xe9 que, Maeda ensinou Jud\xf4 a Carlos Gracie em virtude da afinidade com seu pai, Gast\xe3o Gracie. Carlos por sua vez ensinou a seus demais irm\xe3os, em especial a H\xe9lio Gracie. Neste ponto surgem duas teorias. A primeira alega que Maeda ensinou somente o jud\xf4 de Jigoro Kano a Carlos, e esse o repassou a H\xe9lio, que era o mais franzino dos Gracie, adaptando-o com grande enfoque no Ne-waza - t\xe9cnicas de solo do jud\xf4, ponto central do Gracie jiu-jitsu ou brasilian jiu-jitsu. Para compensar seu biotipo, a partir dos ensinamentos de Carlos, H\xe9lio aprimorou a parte de solo pelo uso do dispositivo de alavanca, dando-lhe a for\xe7a extra que o mesmo n\xe3o dispunha. A segunda teoria, apoiada pelos Gracies, fala que Maeda era, tamb\xe9m, ex\xedmio praticante de Ju-jutsu tradicional e foi essa a arte que ensinou aos brasileiros. Por\xe9m, em uma recente entrevista, H\xe9lio Gracie afirma que \'Carlos lutava jud\xf4\', veja a entrevista http://www.youtube.com/watch?v=BG309oqVLb4"}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://www.bjjheroes.com/bjj-fighters/george-gracie-facts-and-bio"},{"uri":"https://isbnsearch.org/isbn/9798639871030","location":"vol III, p. 172"},{"uri":"https://simonbjj.com/george-gracie"}],"source_yaml":"database/persons/BRA/George_Gracie.yaml"}},{"data":{"id":"JDP-23","name":"Donato Pires dos Reis","nationality":["BRA"],"birth":{"date":null,"location":"Bel\xe9m, Par\xe1","country_code":"BRA"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/donato/donato.png","source":{"uri":"https://simonbjj.com/donato-pires","cite":"Donato Pires dos Reis, RJ, 1930"}},"teachers":[{"id":"JDP-19","style_id":"JDP-S-1","place":null,"period":{"start":1920,"end":null},"quality":null,"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 94","citation":"...\'Oscar\' muito provavelmente se trata do nome de Carlos grafado equivocadamente (...) Na not\xedcia, \'Oscar Gracie\' e Donato s\xe3o apresentados como alunos do famoso esportista paraense Jacyntho Ferro, este sim, disc\xedpulo directo de Maeda..."}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://www.budokast.com.br/post/breve-hist%C3%B3ria-do-jiu-jitsu-brasileiro-parte-1"},{"uri":"http://judotradicionalgoshinjutsukan.blogspot.com/2009/08/mitsuyo-maeda-nasc.html"},{"uri":"https://isbnsearch.org/isbn/9798639871030"},{"uri":"https://simonbjj.com/donato-pires"}],"source_yaml":"database/persons/BRA/Donato_Pires_dos_reis.yaml"}},{"data":{"id":"JDP-21","name":"Carlos Gracie","nationality":["BRA"],"birth":{"date":"1902-09-14","location":"Bel\xe9m, Par\xe1","country_code":"BRA"},"death":{"date":"1994-10-07","location":"Petr\xf3polis","country_code":"BRA"},"photo":{"url":"https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Carlos_Gracie_%281951%29_%28cropped%29.tif/lossy-page1-206px-Carlos_Gracie_%281951%29_%28cropped%29.tif.jpg","source":{"uri":"https://en.wikipedia.org/wiki/Carlos_Gracie#/media/File:Carlos_Gracie_(1951).tif","cite":"Imagem do Fundo Correio da Manh\xe3 (Carlos Gracie - Wikipedia)"}},"teachers":[{"id":"JDP-19","style_id":"JDP-S-1","place":null,"period":{"start":1916,"end":null},"quality":null,"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 94","citation":"...\'Oscar\' muito provavelmente se trata do nome de Carlos grafado equivocadamente (...) Na not\xedcia, \'Oscar Gracie\' e Donato s\xe3o apresentados como alunos do famoso esportista paraense Jacyntho Ferro, este sim, disc\xedpulo directo de Maeda..."}]},{"id":"JDP-18","style_id":"JDP-S-1","place":"Paysandu Sport Club","period":{"start":1916,"end":null},"quality":null,"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol 3, p.91","citation":"...chefiada pelo competentissimo prof. Conde Koma. Aqui, depois de algumas demosntra\xe7\xf5es, organisou um gymnasio e eu [Carlos] fui um dos primeiros alunos [...] h\xe1 registos que Maeda deu aulas, em 1916, no Paysandu Sport Club, em Bel\xe9m, cidade onde Carlos residia com a sua fam\xedlia"},{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol 3, p.93","citation":"Fui aluno do c\xe9lebre Conde Koma, no Par\xe1 [...] e nessa \xe9poca Carlos Gracia tamb\xe9m estava aprendendo"}]}],"rank":[{"style_id":null,"org":null,"teacher":null,"rank":null,"date":null}],"sources":[{"uri":"https://repositorio.ufsc.br/handle/123456789/103771"},{"uri":"https://isbnsearch.org/isbn/9798639871030"},{"uri":"https://www.bjjee.com/articles/the-lost-legend-of-jacyntho-ferro-one-of-carlos-gracie-sr-s-jiu-jitsu-instructors/"},{"uri":"http://judotradicionalgoshinjutsukan.blogspot.com/2009/08/mitsuyo-maeda-nasc.html"},{"uri":"https://pt.wikipedia.org/wiki/Carlos_Gracie"}],"source_yaml":"database/persons/BRA/Carlos_Gracie.yaml"}},{"data":{"id":"JDP-129","name":"Balthazar Cardoso","nationality":["BRA"],"birth":{"date":null,"location":"S\xe3o Lu\xeds, Maranh\xe3o","country_code":"BRA"},"death":{"date":null,"location":null,"country_code":null},"photo":{"url":"https://archive.org/download/screenshot-from-2025-05-11-16-58-43/Screenshot%20From%202025-05-11%2016-58-43.png","source":{"uri":"https://memoria.bn.gov.br/DocReader/DocReader.aspx?bib=112518_01&Pesq=%22Balthazar%20Cardoso%22&pagfis=695","cite":"Jornal dos Esportes (1931-09-28, Ed. 167, p.3)"}},"teachers":[{"id":null,"style_id":null,"quality":null,"place":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":"JDP-S-19","rank":"W42/L6/D8","date":null,"org":null,"sources":[{"uri":"https://boxrec.com/en/proboxer/624960","cite":"Balthazar Cardoso (Boxrec)","citation":""}],"style":"Boxing"}],"sources":[{"uri":"https://boxrec.com/en/proboxer/624960"},{"uri":"https://www.faddabjj.com/historia-fadda"}],"source_yaml":"database/persons/BRA/Balthazar_Cardoso.yaml"}},{"data":{"id":"JDP-130","name":"Aluizio de Melo","aka":[{"name":"Professor Loanzi"},{"name":"Aluizio Nogueira Bandeira de Melo"}],"nationality":["BRA"],"birth":{"date":"1893","location":"Para\xedba","country_code":"BRA"},"death":{"date":"1975","location":"Porto Alegre","country_code":"BRA"},"photo":{"url":"https://archive.org/download/loanzi/loanzi.png","source":{"uri":"https://acervosvirtuais.ufpel.edu.br/museuvirtualdojudo/2022/07/academia-ruy-barbosa/","cite":"Doj\xf4 Professor Loanzi - Museu Virtual do Jud\xf4"}},"teachers":[{"id":"JDP-18","style_id":"JDP-S-1","period":{"start":"1915","end":null},"place":null,"quality":3,"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA & CORR\xcaA (2020). Muito antes do MMA","location":"vol. III, p. 111-113","citation":"aos 17 anos, teve a oportunidade de treinar Jiu Jitsu com o Conde Koma, durante a passagem da trupe japonesa pelo Nordeste do Brasil"},{"uri":"https://aratabajiujitsu.com.br/a-origem-dos-arataba/","cite":"A Origem dos Arataba (Arataba Jiu-Jitsu)","citation":"Todo mundo sabe que Mitsuyo Maeda, o Conde Koma, radicou-se no norte do Brasil por volta de 1913 e ensinou jiu-jitsu para diversas pessoas, dentre as quais posso citar Carlos Gracie, Luiz Fran\xe7a e Aluizio de Melo"},{"uri":"https://acervosvirtuais.ufpel.edu.br/museuvirtualdojudo/2022/07/academia-ruy-barbosa/","cite":"Doj\xf4 Professor Loanzi - Museu Virtual do Jud\xf4","citation":"QUEM FOI ALOIZIO NOGUEIRA BANDEIRA DE MELLO \u2013 PROF. LOANZI (...) Foi aluno do famoso Mitsuyo Moeda, Conde Koma, introdutor do jiu jitsu e do jud\xf4 no Brasil"}]},{"id":"JDP-126","style_id":"JDP-S-1","place":"Budokan, S\xe3o Paulo","quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://acervosvirtuais.ufpel.edu.br/museuvirtualdojudo/2022/07/academia-ruy-barbosa/","cite":"Doj\xf4 Professor Loanzi - Museu Virtual do Jud\xf4","citation":"Em 1959 contatou seu mestre e sensei, que lhe havia promovido \xe0 faixa preta sho-dan, Ryuzo Ogawa, de S\xe3o Paulo"}]}],"rank":[{"style_id":"JDP-S-1","org":"Budokan - SP","rank":"1 dan","date":null,"sources":[{"uri":"https://acervosvirtuais.ufpel.edu.br/museuvirtualdojudo/2022/07/academia-ruy-barbosa/","cite":"Doj\xf4 Professor Loanzi - Museu Virtual do Jud\xf4","citation":"Em 1959 contatou seu mestre e sensei, que lhe havia promovido \xe0 faixa preta sho-dan, Ryuzo Ogawa, de S\xe3o Paulo"}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030"},{"uri":"https://aratabajiujitsu.com.br/a-origem-dos-arataba/"},{"uri":"https://acervosvirtuais.ufpel.edu.br/museuvirtualdojudo/2022/07/academia-ruy-barbosa/"}],"source_yaml":"database/persons/BRA/Aluizio_de_Melo.yaml"}},{"data":{"id":"JDP-86","name":"Georges Stobbaerts","nationality":["PRT","BEL"],"birth":{"date":1940,"location":"Casablanca","country_code":"MAR"},"death":{"date":"2014-01-06","location":null,"country_code":null},"photo":{"url":"https://archive.org/download/stobbaerts/stobbaerts.jpg","source":{"uri":"https://www.georgesstobbaerts.com/pt/","cite":"Life and work of Georges Stobbaerts"}},"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":"JDP-S-4","org":"Dai Nippon Butokukai","teacher":null,"rank":"8 dan","date":null,"sources":[{"uri":"https://web.archive.org/web/20081021195508/http://www.cao.pt/surya/pe_17_1.htm","cite":"Entrevista ao Professor Georges Stobbaerts (Pedro Escudeiro, 2000 - Archived)","citation":"Georges Stobbaerts, tenho 62 anos e actualmente sou 8\xba dan de Aikido conferido pela Dai Nippon Butoku Kai, cuja sede \xe9 em Kyoto no Jap\xe3o, no mais antigo Dojo o Butokuden que depende directamente da fam\xedlia Imperial."}],"style":"Aikid\u014D","style_native":{"name":"\u5408\u6C17\u9053","lang":"ja"}}],"sources":[{"uri":"https://www.georgesstobbaerts.com/georges/"},{"uri":"https://tenchi.pt/georges-stobbaerts/"},{"uri":"https://web.archive.org/web/20081021195508/http://www.cao.pt/surya/pe_17_1.htm"}],"source_yaml":"database/persons/BEL/Georges_Stobbaerts.yaml"}},{"data":{"id":"JDP-66","name":"Antony Striker","aka":[{"name":"Antony Stricker"},{"name":"Tony Striker"}],"nationality":["BEL"],"birth":{"date":null,"location":null,"country_code":null},"death":{"date":null,"location":null,"country_code":null},"teachers":[{"id":null,"style_id":null,"place":null,"quality":null,"period":{"start":null,"end":null}}],"rank":[{"style_id":"JDP-S-1","org":null,"teacher":null,"rank":"1 dan","date":null,"sources":[{"uri":"https://judolandia.tripod.com/histport.htm","cite":"Hist\xf3ria do Judo em Portugal (Judol\xe2ndia, texto de \xabJudo: da inicia\xe7\xe3o \xe0 competi\xe7\xe3o\xbb, Costa Branco et. al","citation":"Quase na mesma altura chega a Lisboa Antony Striker (Su\xed\xe7o) 1\xba Dan, o qual abre uma sala no Largo do Intendente, onde despontaram para o Judo, entre outros, Afonso Maia de Loureiro, Vasco de Sousa e Jos\xe9 Manuel Bastos Nunes."}],"style":"K\u014Dd\u014Dkan J\u016Bd\u014D","style_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"}}],"sources":[{"uri":"https://judolandia.tripod.com/histport.htm"}],"source_yaml":"database/persons/BEL/Antony_Striker.yaml"}}],"edges":[{"data":{"id":"JDP24edd5981aeff","name":"Mifune Ky\u016Bz\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Walter Todd","source":"JDP-11","target":"JDP-24","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":1,"period":{"start":1946,"end":null}}},{"data":{"id":"JDPc5087a8f0b1e5","name":"Yamashita Yoshitsugu (K\u014Dd\u014Dkan J\u016Bd\u014D) Theodore Roosevelt Jr.","source":"JDP-95","target":"JDP-96","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":2,"period":{"start":1904,"end":1904},"sources":[{"uri":"https://ejmas.com/jcs/jcsart_svinth1_1000.htm","cite":"Professor Yamashita Goes to Washington (Journal of Combative Sport, Oct 2000)","citation":"So, during March and April 1904, Roosevelt practiced judo three afternoons a week, using a ground floor office in the White House as his workout space (...) Yamashita later said that while Roosevelt was his best pupil (...)"}]}},{"data":{"id":"JDP5fd39d7c6c855","name":"AnnMaria De Mars (K\u014Dd\u014Dkan J\u016Bd\u014D) Ronda Rousey","source":"JDP-132","target":"JDP-133","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":3,"period":{"start":"1998","end":null},"sources":[{"uri":"https://www.blackbeltmag.com/fists-of-love-the-mothers-who-raised-martial-arts-legends","cite":"Fists of Love: The Mothers Who Raised Martial Arts Legends - Black Belt Magazine","citation":"She began coaching Ronda at age 11, instilling a mindset that would later carry her daughter to Olympic bronze in judo and UFC glory"}]}},{"data":{"id":"JDPe278b6f14638f","name":"Iizuka Kunisabur\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Kenneth Kuniyuki","source":"JDP-31","target":"JDP-122","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Keio University, Tokyo","quality":3,"period":{"start":"1931","end":"1932"},"sources":[{"uri":"https://www.usjf.com/kenneth-kuniyuki/","cite":"Kenneth Kuniyuki - USJF","location":null,"citation":"From 1931 to 1932 Kenneth studied under Kunisaburo Iizuka, 8-dan, and original student of Kano Sensei in Tokyo, Japan"},{"uri":"https://shoyuzine.tripod.com/id14.html","cite":"Asian Americans who\'ve made a difference - Shoyu Zine","citation":"In 1932 he went to Japan to train at Keio University under the instruction of Kunisaburo Iizuka, 8 dan at the time"}]}},{"data":{"id":"JDP0b14656d7e201","name":"Kobayashi Kiyoshi (K\u014Dd\u014Dkan J\u016Bd\u014D) Karl Geis","source":"JDP-12","target":"JDP-52","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":2,"period":{"start":1952,"end":null},"sources":[{"uri":"https://www.karlgeis.com/his-resume","cite":"Karl Geis Martial Arts Resume (Karl Geis Ryu homepage)","citation":"During my studies in Japan I received significant personal instruction from the following Kodokan teachers: [...] Kobayashi Sensei, 8th Dan"}]}},{"data":{"id":"JDP0486addbd415e","name":"Tsunako Miyake (Aikid\u014D) Karl Geis","source":"JDP-53","target":"JDP-52","interaction":"Aikid\u014D","interaction_id":"JDP-S-4","interaction_native":{"name":"\u5408\u6C17\u9053","lang":"ja"},"place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.karlgeis.com/his-resume","cite":"Karl Geis Martial Arts Resume (Karl Geis Ryu homepage)","citation":"During my studies in Japan I received significant personal instruction from the following Kodokan teachers: [...] Miyake, Tsunako Sensei, 7th Dan"}]}},{"data":{"id":"JDPcfd8df809421f","name":"Kenneth Kuniyuki (K\u014Dd\u014Dkan J\u016Bd\u014D) James Cagney","source":"JDP-122","target":"JDP-123","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Seinan Dojo, Los Angeles","quality":1,"period":{"start":1945,"end":null},"sources":[{"uri":"https://www.mixedmartialarts.com/judo/1945-film-fight-scene","cite":"1945 film fight scene - MixedMartialArts.com","citation":"James would train Judo at the Seinan Dojo under Kenneth Kuniyuki"}]}},{"data":{"id":"JDP21b4e7d5d5e02","name":"Kobayashi Kiyoshi (K\u014Dd\u014Dkan J\u016Bd\u014D) Hal Sharp","source":"JDP-12","target":"JDP-25","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":3,"period":{"start":1952,"end":null}}},{"data":{"id":"JDP31d529bf72cda","name":"Ishikawa Takahiko (K\u014Dd\u014Dkan J\u016Bd\u014D) Hal Sharp","source":"JDP-119","target":"JDP-25","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Keishicho","quality":3,"period":{"start":1953,"end":1955},"sources":[{"uri":"https://www.usjf.com/takahiko-ishikawa/","cite":"Memories of My Sensei Takahiko Ishikawa, 9th Dan by Harold (Hal) E. Sharp (USJF)","citation":"I would like to share some of my experiences with you about my Sensei and dear friend, Takahiko Ishikawa (...) I first met Ishikawa in 1953 in Japan after I became a Shodan (1st degree black belt) and thus was allowed to workout at the Keishicho (Tokyo Police Dojo) (...)"}]}},{"data":{"id":"JDP05af202b9dccf","name":"Oda Tsunetane (K\u014Dd\u014Dkan J\u016Bd\u014D) Hal Sharp","source":"JDP-124","target":"JDP-25","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":3,"period":{"start":1950,"end":null},"sources":[{"uri":"https://judoinfo.com/oda/","cite":"Master Tsunetane Oda - JudoInfo","citation":"...I began to practice with Master Oda at Rikkyo University in Tokyo, during the early 1950\u2019s and still remain fascinated by his bravado (...) I remained under Master Oda\u2019s tutelage for many years practicing 3 times a day. Often I would accompany Master Oda to the Kodokan as well as the Dojo at Sugamo Prison."}]}},{"data":{"id":"JDPa7cc5d276c9d1","name":"Ishikawa Takahiko (K\u014Dd\u014Dkan J\u016Bd\u014D) Gene LeBell","source":"JDP-119","target":"JDP-120","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Keishicho","quality":3,"period":{"start":1953,"end":1955},"sources":[{"uri":"https://mokurendojo.blogspot.com/2008/05/mokuren-interview-judo-gene-lebell.html","cite":"Mokuren Interview: \'Judo\' Gene LeBell (Mokuren Dojo)","citation":"Who do you think were the greatest judo teachers you ever got to learn from? Gene Lebell: In the U.S. Shig Tashma, Larry Coughran, Kenneth Kinyuki, Fuji Nazawa (who just died 2 days ago), and of course I learned a lot from training in Japan (Ishikawa)"}]}},{"data":{"id":"JDP91f0ca6727cce","name":"\u014Ctake Risuke (Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B) Donn F. Draeger","source":"JDP-112","target":"JDP-111","interaction":"Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B","interaction_id":"JDP-S-6","interaction_native":{"name":"\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41","lang":"ja"},"place":null,"quality":3,"period":{"start":1967,"end":null},"sources":[{"uri":"http://aiki-kohai.over-blog.com/2018/08/chronique-abregee-de-donn-f.draeger.html","cite":"Tatsusjin : la chronique abr\xe9g\xe9e de Donn F. Draeger (A\xefki-Koha\xef)","citation":"A partir de 1967, Il sera ensuite la premier pratiquant non japonais \xe0 entrer dans l\'\xe9cole Tenshin shoden Katori Shinto ryu alors sous la direction du c\xe9l\xe8bre Risuke Otake shihan, achevant son parcours dans cette \xe9cole par l\'obtention d\'un grade d\'instructeur."}]}},{"data":{"id":"JDP9d74a356905e5","name":"Wang Shujin (Baguazhang) Donn F. Draeger","source":"JDP-117","target":"JDP-111","interaction":"Baguazhang","interaction_id":"JDP-S-17","interaction_native":{"name":"\u516B\u5366\u638C","lang":"cn"},"place":"Meiji Shrine","quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://kogenbudo.org/i-htm/","cite":"Donn Draeger & Robert Smith: Their Intersection Concerning Chinese Martial Arts (KogenBudo)","citation":"There was a famous xingyiquan and baguazhang teacher in Japan in those days, named Wang Shujin (...) Donn (and a number of other of his associates) began training with Wang on the grounds of the Meiji Shrine (...)"}]}},{"data":{"id":"JDPa788a756199","name":"\u014Csawa Yoshimi (K\u014Dd\u014Dkan J\u016Bd\u014D) AnnMaria De Mars","source":"JDP-131","target":"JDP-132","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Waseda University, Tokyo","quality":2,"period":{"start":"1976","end":null},"sources":[{"uri":"https://www.usjf.com/annmaria-de-mars-2/","cite":"AnnMaria De Mars - USJF","citation":"at the age of 18, as a college junior, De Mars was an exchange student at Waseda University in Tokyo, Japan. While there, she trained under Sensei Osawa"}]}},{"data":{"id":"JDP9fd57f4a52cc3","name":"Anatoliy Rakhlin (K\u014Dd\u014Dkan J\u016Bd\u014D) Vladimir Putin","source":"JDP-99","target":"JDP-100","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":2,"period":{"start":1964,"end":null},"sources":[{"uri":"https://judo.ru/news/4707","citation":"\u0412 1964 \u0433\u043E\u0434\u0443 \u043D\u0430\u0431\u0440\u0430\u043B \u043F\u0435\u0440\u0432\u0443\u044E \u0433\u0440\u0443\u043F\u043F\u0443 \u044E\u043D\u043E\u0448\u0435\u0439, \u0441\u0440\u0435\u0434\u0438 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0431\u044B\u043B\u0438 \u0410\u0440\u043A\u0430\u0434\u0438\u0439 \u0420\u043E\u0442\u0435\u043D\u0431\u0435\u0440\u0433, \u0412\u0430\u043B\u0435\u043D\u0442\u0438\u043D \u0421\u0442\u0435\u043F\u0430\u043D\u043E\u0432, \u041D\u0438\u043A\u043E\u043B\u0430\u0439 \u041A\u043E\u043D\u043E\u043D\u043E\u0432, \u0412\u0430\u0441\u0438\u043B\u0438\u0439 \u0428\u0435\u0441\u0442\u0430\u043A\u043E\u0432, \u0412\u043B\u0430\u0434\u0438\u043C\u0438\u0440 \u041F\u0443\u0442\u0438\u043D.","cite":"\u0423\u0442\u0440\u0430\u0442\u0430"}]}},{"data":{"id":"JDP622f40b4e5094","name":"Anatoliy Rakhlin (Sambo) Vladimir Putin","source":"JDP-99","target":"JDP-100","interaction":"Sambo","interaction_id":"JDP-S-15","interaction_native":{"name":"\u0441a\u043C\u0431\u043E","lang":"ru"},"place":null,"quality":2,"period":{"start":1964,"end":null},"sources":[{"uri":"https://vecherka-spb.ru/2023/08/08/chestnoe-i-dobrosovestnoe-otnoshenie-k-delu-kakim-bil-anatolii-rakhlin--lichnii-trener-vladimira-putina-","citation":"\u0425\u043E\u0440\u043E\u0448\u043E \u043F\u043E\u043C\u043D\u044E, \u043A\u0430\u043A \u0410\u043D\u0430\u0442\u043E\u043B\u0438\u0439 \u0421\u043E\u043B\u043E\u043C\u043E\u043D\u043E\u0432\u0438\u0447 \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u043B \u043E\u0442\u0431\u043E\u0440 \u0432 \u0441\u0435\u043A\u0446\u0438\u044E \u0441\u0430\u043C\u0431\u043E. \u041D\u0443\u0436\u043D\u043E \u0431\u044B\u043B\u043E \u043F\u043E\u0434\u0442\u044F\u043D\u0443\u0442\u044C\u0441\u044F \u2014 \u043A\u0442\u043E \u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u043C\u043E\u0436\u0435\u0442.","cite":"\u0412\u0435\u0447\u0435\u0440\u043D\u0438\u0439 \u0421\u0430\u043D\u043A\u0442-\u041F\u0435\u0442\u0435\u0440\u0431\u0443\u0440\u0433"}]}},{"data":{"id":"JDPebf1a147e17a2","name":"Kan\u014D Jigor\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Vasili Oshchepkov","source":"JDP-1","target":"JDP-97","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":0,"period":{"start":1911,"end":1917},"sources":[{"uri":"https://oca.asia/sports/info/15/58/","citation":"Oshchepkov spent much of his life living in Japan and training judo under its founder Kano Jigoro."},{"uri":"https://en.wikipedia.org/wiki/Vasili_Oshchepkov","citation":""}]}},{"data":{"id":"JDPecf507a04ffe","name":"Vasili Oshchepkov (K\u014Dd\u014Dkan J\u016Bd\u014D) Sergei Dashkevich","source":"JDP-97","target":"JDP-98","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":2,"period":{"start":1931,"end":null},"sources":[{"uri":"https://judo.ru/news/9889","citation":"\u0412 1931 \u0433\u043E\u0434\u0443 \u043F\u0440\u043E\u0448\u0451\u043B \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u0435 \u0432 \u041C\u043E\u0441\u043A\u0432\u0435 \u0443 \u0440\u043E\u0434\u043E\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430 \u043E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0434\u0437\u044E\u0434\u043E \u0412\u0430\u0441\u0438\u043B\u0438\u044F \u0421\u0435\u0440\u0433\u0435\u0435\u0432\u0438\u0447\u0430 \u041E\u0449\u0435\u043F\u043A\u043E\u0432\u0430 \u043D\u0430 \u043A\u0443\u0440\u0441\u0430\u0445 \u043F\u0440\u0435\u043F\u043E\u0434\u0430\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0434\u0437\u044E\u0434\u043E \u0434\u043B\u044F \u043D\u0438\u0437\u043E\u0432\u044B\u0445 \u0437\u0430\u0432\u043E\u0434\u0441\u043A\u0438\u0445 \u0438 \u0432\u0443\u0437\u043E\u0432\u0441\u043A\u0438\u0445 \u043A\u043E\u043B\u043B\u0435\u043A\u0442\u0438\u0432\u043E\u0432"}]}},{"data":{"id":"JDP01b7900d666aa","name":"Vasili Oshchepkov (Sambo) Sergei Dashkevich","source":"JDP-97","target":"JDP-98","interaction":"Sambo","interaction_id":"JDP-S-15","interaction_native":{"name":"\u0441a\u043C\u0431\u043E","lang":"ru"},"place":null,"quality":2,"period":{"start":1931,"end":null},"sources":[{"uri":"https://judo.ru/news/9889","citation":"\u0412 1931 \u0433\u043E\u0434\u0443 \u043F\u0440\u043E\u0448\u0451\u043B \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u0435 \u0432 \u041C\u043E\u0441\u043A\u0432\u0435 \u0443 \u0440\u043E\u0434\u043E\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430 \u043E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0434\u0437\u044E\u0434\u043E \u0412\u0430\u0441\u0438\u043B\u0438\u044F \u0421\u0435\u0440\u0433\u0435\u0435\u0432\u0438\u0447\u0430 \u041E\u0449\u0435\u043F\u043A\u043E\u0432\u0430 \u043D\u0430 \u043A\u0443\u0440\u0441\u0430\u0445 \u043F\u0440\u0435\u043F\u043E\u0434\u0430\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0434\u0437\u044E\u0434\u043E \u0434\u043B\u044F \u043D\u0438\u0437\u043E\u0432\u044B\u0445 \u0437\u0430\u0432\u043E\u0434\u0441\u043A\u0438\u0445 \u0438 \u0432\u0443\u0437\u043E\u0432\u0441\u043A\u0438\u0445 \u043A\u043E\u043B\u043B\u0435\u043A\u0442\u0438\u0432\u043E\u0432"},{"uri":"https://turbojudo.spb.ru/news/v-den-125letiya-so-dnya-rozhdeniya-osnovopolozhnika-leningradskogo-dzyudo-sergeya-dashkevicha-sostoyalos-pamyatnoe-meropriyatie","citation":"\u0412\u0451\u043B \u0437\u0430\u043D\u044F\u0442\u0438\u044F \u0432 \u0433\u0440\u0443\u043F\u043F\u0435 \u0441\u0430\u043C\u0431\u043E, \u0433\u0434\u0435 \u0435\u0433\u043E \u0432\u043E\u0441\u043F\u0438\u0442\u0430\u043D\u043D\u0438\u043A\u043E\u043C \u0441 1952 \u0433\u043E\u0434\u0430 \u0431\u044B\u043B \u0410\u043D\u0430\u0442\u043E\u043B\u0438\u0439 \u0420\u0430\u0445\u043B\u0438\u043D."}]}},{"data":{"id":"JDPc75dda543e76b","name":"Vasili Oshchepkov (K\u014Dd\u014Dkan J\u016Bd\u014D) Anatoly Kharlampiyev","source":"JDP-97","target":"JDP-101","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"State Central Order of Lenin Institute of Physical Culture","quality":2,"period":{"start":1931,"end":null},"sources":[{"uri":"https://ru.wikipedia.org/wiki/%D0%A5%D0%B0%D1%80%D0%BB%D0%B0%D0%BC%D0%BF%D0%B8%D0%B5%D0%B2,_%D0%90%D0%BD%D0%B0%D1%82%D0%BE%D0%BB%D0%B8%D0%B9_%D0%90%D1%80%D0%BA%D0%B0%D0%B4%D1%8C%D0%B5%D0%B2%D0%B8%D1%87","citation":"\u0412 1936 \u0433. \u043E\u043A\u043E\u043D\u0447\u0438\u043B \u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0446\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u0440\u0434\u0435\u043D\u0430 \u041B\u0435\u043D\u0438\u043D\u0430 \u0438\u043D\u0441\u0442\u0438\u0442\u0443\u0442 \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u044B (\u043E\u0442\u0434\u0435\u043B\u0435\u043D\u0438\u0435 \u0434\u0437\u044E\u0434\u043E \u0412\u0430\u0441\u0438\u043B\u0438\u044F \u0421\u0435\u0440\u0433\u0435\u0435\u0432\u0438\u0447\u0430 \u041E\u0449\u0435\u043F\u043A\u043E\u0432\u0430)[...]\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u044F \xab\u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0441\u0430\u043C\u0431\u043E\xbb, \u0425\u0430\u0440\u043B\u0430\u043C\u043F\u0438\u0435\u0432 \u0442\u0449\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0438\u0437\u0443\u0447\u0430\u043B \u0434\u0437\u044E\u0434\u043E \u0438 \u043E\u0441\u0432\u0430\u0438\u0432\u0430\u043B \u0435\u0433\u043E \u043D\u0430 \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0435. \u0412 \u0434\u0437\u044E\u0434\u043E \u043E\u043D \u0432\u0438\u0434\u0435\u043B \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u043D\u043E\u0432\u043E\u0433\u043E \u0432\u0438\u0434\u0430 \u0431\u043E\u0440\u044C\u0431\u044B \u0432 \u043E\u0434\u0435\u0436\u0434\u0435, \u043E\u0431\u043E\u0433\u0430\u0449\u0451\u043D\u043D\u043E\u0433\u043E \u043D\u0430\u0438\u0431\u043E\u043B\u0435\u0435 \u044D\u0444\u0444\u0435\u043A\u0442\u0438\u0432\u043D\u044B\u043C\u0438 \u043F\u0440\u0438\u0451\u043C\u0430\u043C\u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u0432\u0438\u0434\u043E\u0432 \u0431\u043E\u0440\u044C\u0431\u044B. \u0414\u0437\u044E\u0434\u043E \u043E\u043D \u043E\u0441\u0432\u0430\u0438\u0432\u0430\u043B \u043F\u043E\u0434 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E\u043C \u0412\u0430\u0441\u0438\u043B\u0438\u044F \u0421\u0435\u0440\u0433\u0435\u0435\u0432\u0438\u0447\u0430 \u041E\u0449\u0435\u043F\u043A\u043E\u0432\u0430, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u043C\u043D\u043E\u0433\u043E\u043B\u0435\u0442\u043D\u0435\u0433\u043E \u043F\u0440\u0435\u0431\u044B\u0432\u0430\u043D\u0438\u044F \u0432 \u042F\u043F\u043E\u043D\u0438\u0438 \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u0430\u043B\u0441\u044F \u0432 \u0448\u043A\u043E\u043B\u0435 \u0434\u0437\u044E\u0434\u043E \u041A\u043E\u0434\u043E\u043A\u0430\u043D."}]}},{"data":{"id":"JDP5bce5b3a48e44","name":"Sergei Dashkevich (Sambo) Anatoliy Rakhlin","source":"JDP-98","target":"JDP-99","interaction":"Sambo","interaction_id":"JDP-S-15","interaction_native":{"name":"\u0441a\u043C\u0431\u043E","lang":"ru"},"place":"Leningrad Palace of the Pioneers","quality":2,"period":{"start":1955,"end":null},"sources":[{"uri":"https://sambo.sport/en/news/anatoliy-rakhlin-chelovek-pedagog-trener/","citation":"In 1953 he started taking SAMBO classes in the Palace of the Pioneers under the guidance of a highly experienced wrestler S. Dashkevich, a wrestling partner of Ivan Poddubny himself.","cite":"Anatoliy Rakhlin: Person, Teacher, Coach | International SAMBO Federation (FIAS)"}]}},{"data":{"id":"JDP24394171551c8","name":"Jos\xe9 Costa Branco (K\u014Dd\u014Dkan J\u016Bd\u014D) Nuno Delgado","source":"JDP-62","target":"JDP-63","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Sport Alg\xe9s e Dafundo","quality":3,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.ulisboa.pt/sites/ulisboa.pt/files/public/aluno_de_kobayashi_moldou_o_campeao.pdf","cite":"Jos\xe9 Costa Branco: Aluno de Kobayashi moldou o campe\xe3o (O Jogo, 22-II-2020)","citation":"... no hist\xf3rico Sport Alg\xe9s e Dafundo durante 28 anos. Foi l\xe1 que Jos\xe9 Costa Branco encontrou Nuno Delgado, que saiu de Santar\xe9m, onde vivia e combatia, para regressar a Lisboa e se licenciar em Ci\xeancias do Desporto"},{"uri":"https://www.record.pt/modalidades/detalhe/alges-conquista-nacional-de-seniores-por-equipas","cite":"Alg\xe9s conquista Nacional de seniores por equipas (Record, 30-IV-2001)","citation":"Quero dedicar o triunfo ao ex-treinador Jos\xe9 Branco, porque ele j\xe1 merecia este t\xedtulo no ano passado, altura em que se retirou dos tapetes, considerou Nuno Delgado, medalha de bronze em Sydney 2000."}]}},{"data":{"id":"JDPb7fe1f9012745","name":"Fernando Costa Matos (K\u014Dd\u014Dkan J\u016Bd\u014D) Nuno Delgado","source":"JDP-15","target":"JDP-63","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.linkedin.com/posts/nunodelgadotpv_mestrebastosnunes-judo-portugaljudo-activity-7155564790885556225-5SnY?originalSubdomain=pt","cite":"Nuno Delgado","citation":"A par do meu Mestre Fernando Costa Matos, s\xe3o as mais altas gradua\xe7\xf5es Lusas, disc\xedpulos diretos de Kiyoshi Kobayashi, que tanto moldaram os nossos judocas, com a sua sabedoria e pedagogia"}]}},{"data":{"id":"JDP2fe2eb784bf8a","name":"Ant\xf3nio Roquette de Andrade (K\u014Dd\u014Dkan J\u016Bd\u014D) M\xe1rio Aguilar","source":"JDP-61","target":"JDP-88","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Judo Clube do Estoril","quality":2,"period":{"start":1981,"end":1982},"sources":[{"uri":"https://github.com/Judo-Documentation-Project/budotree","cite":"M\xe1rio Aguilar, private communication, 2021","citation":"... os meus mestres por ordem cronol\xf3gica foram: (...) Ant\xf3nio Roquete (...) no Judo Clube do Estoril - 1 ano"}]}},{"data":{"id":"JDPd9bb58834fc0d","name":"Petrucio Monteiro (K\u014Dd\u014Dkan J\u016Bd\u014D) M\xe1rio Aguilar","source":"JDP-128","target":"JDP-88","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Academia Petrucio Monteiro","quality":3,"period":{"start":1980,"end":1981},"sources":[{"uri":"https://github.com/Judo-Documentation-Project/budotree","cite":"M\xe1rio Aguilar, private communication, 2021","citation":"... os meus mestres por ordem cronol\xf3gica foram: (...) Mestre Petr\xfacio Monteiro (Brasil) - 1980 a 1981 e meio"}]}},{"data":{"id":"JDP239c87ab8a9e9","name":"Yamamoto Nobuaki (K\u014Dd\u014Dkan J\u016Bd\u014D) Manuel Reis","source":"JDP-74","target":"JDP-75","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Clube de Judo do Porto","quality":2,"period":{"start":1968,"end":1969},"sources":[{"uri":"https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf","cite":"Manual de Gradua\xe7\xf5es e Regulamento de Gradua\xe7\xf5es. Federa\xe7\xe3o Portuguesa de Judo (Dezembro 2020)","citation":"Em 1968, ao abrigo do Fundo de Fomento Desportivo, chega ao Porto o jovem Mestre japon\xeas, de 26 anos, Nabuaki Yamamoto, 5\xba Dan, aluno do Kodokan e antigo campe\xe3o universit\xe1rio do Jap\xe3o, tornando-se professor do Clube de Judo do Porto. No in\xedcio de 1969, o Mestre Yamamoto parte para a Isl\xe2ndia e as aulas voltam a ser ministradas pelos judocas mais graduados, que contavam agora com o apoio muito espor\xe1dico de alguns elementos da Federa\xe7\xe3o Portuguesa de Judo"},{"uri":"https://judomagazine.pt/2023/05/16/entrevista-viagem-ao-mundo-dos-homens-bons-2/","citation":"Fernando Costa Matos encontrou-se com um dos mais antigos praticantes do judo em Portugal, Manuel Reis, que j\xe1 tinha trazido o japon\xeas Yamamoto nos anos 60 para orientar o clube e que aceitou de bom grado a vinda de Frigyes Torok para a dire\xe7\xe3o t\xe9cnica do tradicional clube da cidade Invicta."}]}},{"data":{"id":"JDP7551111eed665","name":"Armando Gon\xe7alves (J\u016Bjutsu) Manuel Reis","source":"JDP-76","target":"JDP-75","interaction":"J\u016Bjutsu","interaction_id":"JDP-S-14","interaction_native":{"name":"\u67D4\u8853","lang":"ja"},"place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"http://clubejudoporto.weebly.com/os-nossos-fundadores.html","citation":"...Manuel Reis fora aluno de  Armando Gon\xe7alves, um portuense Professor de Ju-Jutsu \u67D4\u8853..."}]}},{"data":{"id":"JDP4e7390317c5bf","name":"Jackie Hugnet (K\u014Dd\u014Dkan J\u016Bd\u014D) Manuel Reis","source":"JDP-78","target":"JDP-75","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"C\xedrculo de Judo do Porto","quality":2,"period":{"start":1955,"end":1965},"sources":[{"uri":"https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf","cite":"Manual de Gradua\xe7\xf5es e Regulamento de Gradua\xe7\xf5es. Federa\xe7\xe3o Portuguesa de Judo (Dezembro 2020)","citation":"Em 1955, os judocas do Porto organizados em torno do professor Jackie Hugnet, criam o C\xedrculo de Judo do Porto, onde Hugnet foi professor durante sete anos, lecionando tr\xeas vezes por semana a primeira classe em que o Judo Kodokan foi ministrado de forma sistem\xe1tica no Porto. Os professores Hugnet e Manuel Reis foram instrutores de Judo da Pol\xedcia de Seguran\xe7a P\xfablica do Porto, durante cerca de dois anos meio, coincidentes com parte do per\xedodo em que o Comandante da corpora\xe7\xe3o era o famoso Chefe Santos J\xfanior."},{"uri":"http://clubejudoporto.weebly.com/os-nossos-fundadores.html","citation":"Este, impressionado com a determina\xe7\xe3o de Manuel Reis mas sem disponibilidade para ficar em Portugal, enviou para o C\xedrculo de Judo do Porto o seu irm\xe3o Jackie Hugnet, 2\xba Dan de Judo, que connosco permaneceu por uma d\xe9cada"}]}},{"data":{"id":"JDPafa2db29008f","name":"Gilbert Briskine (K\u014Dd\u014Dkan J\u016Bd\u014D) Manuel Reis","source":"JDP-79","target":"JDP-75","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"C\xedrculo de Judo do Porto","quality":2,"period":{"start":1961,"end":1963},"sources":[{"uri":"https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf","cite":"Manual de Gradua\xe7\xf5es e Regulamento de Gradua\xe7\xf5es. Federa\xe7\xe3o Portuguesa de Judo (Dezembro 2020)","citation":"No Ver\xe3o de 1961, o professor Hugnet \xe9 substitu\xeddo pelo tamb\xe9m franc\xeas, Gilbert Bryskine, 4\xba Dan, campe\xe3o de Fran\xe7a, bicampe\xe3o da Europa (1952 e 1954) e professor diplomado pela Federa\xe7\xe3o Francesa de Judo e Ju Jutsu. \xc9 com Bryskine que os atletas do C\xedrculo come\xe7am a participar em provas federativas, quer individualmente, quer por equipas. Em 1963, Gilbert Bryskine regressou a Fran\xe7a devido a um grave acidente de autom\xf3vel que o deixou incapacitado."},{"uri":"http://clubejudoporto.weebly.com/os-nossos-fundadores.html","citation":"Na \xe9poca, recebemos tamb\xe9m os ensinamento de outro franc\xeas, Gilbert Briskine, 4\xba Dan de Judo e mestre de Karat\xe9-Do \u7A7A\u624B\u9053, Disciplina a quem a divulga\xe7\xe3o em Portugal muito deve."}]}},{"data":{"id":"JDPe21d3c07980fb","name":"Ant\xf3nio Corr\xeaa Pereira (K\u014Dd\u014Dkan J\u016Bd\u014D) Lu\xeds Franco Pires Martins","source":"JDP-83","target":"JDP-82","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Academia de Budo","quality":1,"period":{"start":1951,"end":null},"sources":[{"uri":"https://repositorio.ipv.pt/handle/10400.19/448","cite":"FIGUEIREDO, Abel Aur\xe9lio Abreu. A institucionaliza\xe7\xe3o do karat\xe9-os modelos organizacionais do karat\xe9 em Portugal. 2006. PhD Thesis. Instituto Politecnico de Viseu (Portugal)","citation":"(...)Al\xe9m de ser o primeiro cinto negro inscrito no Kodokan (Jap\xe3o), Corr\xeaa Pereira \xe9 o primeiro editor de revistas de Judo Kodokan (...) o Dr. Jo\xe3o Lu\xeds Franco Pires Martins refere que por volta de 1946 \xe9 que se iniciou a pr\xe1tica de Judo na Academia de Judo, sendo a\xed que ele inicia a pr\xe1tica de Judo, em 1951"}]}},{"data":{"id":"JDP7ab5d46e142b4","name":"Georges Stobbaerts (Aikid\u014D) Leopoldo Ferreira","source":"JDP-86","target":"JDP-85","interaction":"Aikid\u014D","interaction_id":"JDP-S-4","interaction_native":{"name":"\u5408\u6C17\u9053","lang":"ja"},"place":"Budokai Cascais","quality":3,"period":{"start":1972,"end":1976},"sources":[{"uri":"https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm","cite":"Entrevista ao Professor Leopoldo Ferreira (Pedro Escudeiro, 2000 - Archived)","citation":" Eu s\xf3 conheci o Mestre Stobbaerts, em Agosto ou Setembro de 1972 (...) Portanto, durante anos, os meus fins-de-semana eram passados em Cascais a praticar Aikido. Pratiquei com o Mestre Stobbaerts talvez uns tr\xeas ou quatro anos."},{"uri":"https://web.archive.org/web/20081021195508/http://www.cao.pt/surya/pe_17_1.htm","cite":"Entrevista ao Professor Georges Stobbaerts (Pedro Escudeiro, 2000 - Archived)","citation":"Nessa altura o ambiente no Aikido era muito bom, toda a gente praticava com toda gente, mesmo os alunos da escola do Kobayashi, como o Leopoldo Ferreira, que chegou a ser meu aluno."}]}},{"data":{"id":"JDP9c2504091b405","name":"Kobayashi Kiyoshi (K\u014Dd\u014Dkan J\u016Bd\u014D) Jos\xe9 Costa Branco","source":"JDP-12","target":"JDP-62","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Judo Clube de Portugal","quality":null,"period":{"start":1975,"end":null},"sources":[{"uri":"https://judomagazine.pt/2021/07/04/1980-moscovo/","cite":"Jos\xe9 Branco n\xe3o boicotou o seu sonho (Judo Magazine)","citation":"O judo passou a ser central na sua vida que tinha levado uma volta muito grande. No Judo Clube de Portugal teve por mestre Kiyoshi Kobayashi e os seus colegas de clube passaram a ser os seus amigos para todos os momentos da vida quotidiana."},{"uri":"https://delagoabay.wordpress.com/2011/01/16/jose-branco-olimpico-e-campeao-de-judo-e-de-tiro/","cite":"Jos\xe9 Branco, Ol\xedmpico e Campe\xe3o de Tiro e Judo (The Delagoa Bay Company blog)","citation":"Ao lado de jos\xe9 branco, um amigo muito especial , mestre Kobayaschi . Refere o Jos\xe9: no per\xedodo mais dif\xedcil da minha vida, ent\xe3o com 22 anos, quando me encontrava completamente atolado, foi o \xfanico que me lan\xe7ou a m\xe3o. No \xfaltimo segundo da minha vida, ele far\xe1 parte dos meus pensamentos."}]}},{"data":{"id":"JDPee1eb4111c2e3","name":"Fragoso Fernandes (Karate) Jos\xe9 Ara\xfajo","source":"JDP-81","target":"JDP-80","interaction":"Karate","interaction_id":"JDP-S-5","interaction_native":{"name":"\u7A7A\u624B","lang":"ja"},"place":"Academia de Budo","quality":3,"period":{"start":1966,"end":null},"sources":[{"uri":"https://aikidomdc.wixsite.com/brpd/untitled-c1eb9","cite":"Aikido Marcial D\xf4jo Clube - Mestre Jos\xe9 Ara\xfajo","citation":"Inicia a pr\xe1tica do Aikido e Karatedo em 1966, na Academia de Budo, com a idade de 10 anos, sendo seus professores Carlos Pereira, aluno de Mestre Georges Stobbaerts, e Fragoso Fernandes, aluno de Pires Martins, introdutor do Karatedo em Portugal."},{"uri":"https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm","cite":"Entrevista ao Professor Jos\xe9 Ara\xfajo (Pedro Escudeiro, 2000 - Archived)","citation":"O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o respons\xe1vel pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem s\xe9ria, rigorosa e profundamente empenhada."}]}},{"data":{"id":"JDPfd12271e535c4","name":"Carlos Pereira (Aikid\u014D) Jos\xe9 Ara\xfajo","source":"JDP-84","target":"JDP-80","interaction":"Aikid\u014D","interaction_id":"JDP-S-4","interaction_native":{"name":"\u5408\u6C17\u9053","lang":"ja"},"place":"Academia de Budo","quality":3,"period":{"start":1966,"end":null},"sources":[{"uri":"https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm","cite":"Entrevista ao Professor Jos\xe9 Ara\xfajo (Pedro Escudeiro, 2000 - Archived)","citation":"O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o respons\xe1vel pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem s\xe9ria, rigorosa e profundamente empenhada."}]}},{"data":{"id":"JDP6db08afd78209","name":"Leopoldo Ferreira (Aikid\u014D) Jos\xe9 Ara\xfajo","source":"JDP-85","target":"JDP-80","interaction":"Aikid\u014D","interaction_id":"JDP-S-4","interaction_native":{"name":"\u5408\u6C17\u9053","lang":"ja"},"place":"Academia de Budo","quality":3,"period":{"start":1973,"end":null},"sources":[{"uri":"https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm","cite":"Entrevista ao Professor Jos\xe9 Ara\xfajo (Pedro Escudeiro, 2000 - Archived)","citation":"Foi o Leopoldo Ferreira (...) Mas quem ficou na Academia, em perman\xeancia, a dar aulas de Aikido foi o Leopoldo Ferreira."},{"uri":"https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm","cite":"Entrevista ao Professor Leopoldo Ferreira (Pedro Escudeiro, 2000 - Archived)","citation":"Quando o Jos\xe9 Ara\xfajo recome\xe7ou a praticar j\xe1 estava eu a dar aulas, portanto, foi por volta de 1973, creio."}]}},{"data":{"id":"JDPf8ca20d0d18af","name":"Kobayashi Kiyoshi (K\u014Dd\u014Dkan J\u016Bd\u014D) Henrique Nunes","source":"JDP-12","target":"JDP-64","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Judo Clube de Portugal","quality":3,"period":{"start":1959,"end":null},"sources":[{"uri":"https://judomagazine.pt/2023/03/19/reportagem-no-santuario-com-henrique-nunes-1/","cite":"No \xabsantu\xe1rio\xbb com Henrique Nunes (Judo Magazine)","citation":"\xabAli em frente \xe9 a \xe1rea reservada ao meu Mestre, \xe0 pessoa que mais admiro e de quem tenho imensas saudades\xbb adiantou o nosso anfitri\xe3o sinalizando uma grande fotografia de Kiyoshi Kobayashi, aquela que \xe9 marca global do japon\xeas que desde 1958 referencia o judo nacional em todas as suas dimens\xf5es, t\xe9cnicas, culturais, profissionais e at\xe9 institucionais. Ao lado uma fotografia datada de 1966 com Henrique Nunes a receber de KK uma medalha de campe\xe3o nacional, uma das muitas, ao ponto de ser dif\xedcil recordar-se de todas."},{"uri":"https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=381","cite":"Seis hist\xf3rias \xe0 volta do Tatami _ Gala 60\xba Anivers\xe1rio FPJ","citation":"... o mestre Kobayashi em Portugal, em \'58 (...) foi o meu mestre."}]}},{"data":{"id":"JDP8b019a3cf6f52","name":"Afonso Henriques Maia de Loureiro (K\u014Dd\u014Dkan J\u016Bd\u014D) Henrique Nunes","source":"JDP-65","target":"JDP-64","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Judo Clube de Portugal","quality":3,"period":{"start":1954,"end":null},"sources":[{"uri":"https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=381","cite":"Seis hist\xf3rias \xe0 volta do Tatami _ Gala 60\xba Anivers\xe1rio FPJ","citation":"...Tive \xf3ptimos professores no princ\xedpio. Era o Comandante Afonso Henriques Maia Loureiro, era o dr. Nuno Ribeiro..."}]}},{"data":{"id":"JDPd4bac54ee28cc","name":"Lu\xeds Franco Pires Martins (Karate) Fragoso Fernandes","source":"JDP-82","target":"JDP-81","interaction":"Karate","interaction_id":"JDP-S-5","interaction_native":{"name":"\u7A7A\u624B","lang":"ja"},"place":"Academia de Budo","quality":3,"period":{"start":1966,"end":null},"sources":[{"uri":"https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_17-22.pdf","cite":"ARA\xdaJO, Jos\xe9, O Dr. Pires Martins e a Uni\xe3o Portuguesa de Budo. In: A G\xe9nese do Karat\xe9 em Portugal","citation":"Guardo ainda a imagem das minhas primeiras aulas de Karate-do, orientadas por essa extraordin\xe1ria \uFB01gura que era o Doutor Fragoso Fernandes, para mim, naquela \xe9poca, a incarna\xe7\xe3o das virtudes f\xedsicas, t\xe9cnicas e morais do Budoka (...)  Aluno desde o primeiro dia do Dr. Pires Martins, transp\xf4s para o contacto com os alunos que se iniciavam a sua vis\xe3o, como tive desde ent\xe3o o ensejo de con\uFB01rmar"},{"uri":"https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm","cite":"Entrevista ao Professor Jos\xe9 Ara\xfajo (Pedro Escudeiro, 2000 - Archived)","citation":"O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o respons\xe1vel pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem s\xe9ria, rigorosa e profundamente empenhada."}]}},{"data":{"id":"JDP6da872642605f","name":"Jos\xe9 Manuel Bastos Nunes (K\u014Dd\u014Dkan J\u016Bd\u014D) Fernando Seabra","source":"JDP-16","target":"JDP-87","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Judo Clube de Sintra - Judokai","quality":2,"period":{"start":1980,"end":null},"sources":[{"uri":"https://judomagazine.pt/2024/01/23/mestre-ze-manel/","citation":"Foi com o \xabMestre Z\xe9 Manel\xbb, como carinhosamente os alunos mais chegados se atreviam a trat\xe1-lo, que iniciei a minha pr\xe1tica do Judo no Judo Clube de Sintra \u2013 Judokai, no Cac\xe9m, em 1980, e foi essencialmente com Ele que aprendi grande parte do pouco que hoje sei neste meu percurso pelo Judo"}]}},{"data":{"id":"JDP15e44f59ed49c","name":"Yamamoto Nobuaki (K\u014Dd\u014Dkan J\u016Bd\u014D) Fernando Sarmento","source":"JDP-74","target":"JDP-73","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Clube de Judo do Porto","quality":3,"period":{"start":1968,"end":1969},"sources":[{"uri":"http://escolamurakamimaia.weebly.com/fernando-sarmento.html","cite":"Fernando Duarte Sarmento (Escola Murakami da Maia)","citation":"Inicia o seu percurso nas \xabArtes Marciais\xbb em 1968 como praticante de Judo no Clube de Judo do Porto (Rua Duque de Loul\xe9), treinando sob a orienta\xe7\xe3o directa do Mestre Nobuaki Yamamoto (5\xba Dan)"}]}},{"data":{"id":"JDPdb18e946a9d0b","name":"Carlos Portas (Aikid\u014D) Fernando Sarmento","source":"JDP-72","target":"JDP-73","interaction":"Aikid\u014D","interaction_id":"JDP-S-4","interaction_native":{"name":"\u5408\u6C17\u9053","lang":"ja"},"place":"Mussubi Escola de Aikido","quality":3,"period":{"start":2006,"end":null},"sources":[{"uri":"http://escolamurakamimaia.weebly.com/fernando-sarmento.html","cite":"Fernando Duarte Sarmento (Escola Murakami da Maia)","citation":"A 17 de Mar\xe7o de 2006 inicia a pr\xe1tica do Aikido na Mussubi Escola de Aikido / Takemusu Aiki Portugal sob a direc\xe7\xe3o t\xe9cnico-pedag\xf3gica do Mestre Carlos Portas, com quem continua a praticar regularmente at\xe9 ao presente momento. \xc9 graduado por Carlos Portas em 1\xba Dan a 11 de Agosto de 2007 e 2\xba Dan em 8 de Agosto de 2009."}]}},{"data":{"id":"JDP51b0c53e9808d","name":"Kobayashi Kiyoshi (K\u014Dd\u014Dkan J\u016Bd\u014D) Fernando Costa Matos","source":"JDP-12","target":"JDP-15","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"INEF","quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.facebook.com/ipatj/photos/a.243433975668608/1073113529367311/?type=3&locale=pt_PT","cite":"Renato Santos Kobayashi, in Instituto Portugu\xeas de Artes Tradicionais Japonesas - Facebook","citation":"Em 1958 o Mestre K.K. assinou ent\xe3o um contrato para ficar em Portugal por um per\xedodo de dois anos. Nesta sequ\xeancia, aceita o convite para integrar o corpo docente do ent\xe3o Instituto Nacional de Educa\xe7\xe3o F\xedsica (INEF), onde lecionou durante dez anos (...)  Destaca-se o nome do Fernando Costa Matos, atleta ol\xedmpico que iniciou o Judo no INEF em 1959 e em 1964 participou pela 1.\xaa vez nos J. Ol\xedmpicosde T\xf3quio."}]}},{"data":{"id":"JDP50eb53b486751","name":"Kobayashi Kiyoshi (K\u014Dd\u014Dkan J\u016Bd\u014D) Fernando Costa Matos","source":"JDP-12","target":"JDP-15","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Judo Clube de Portugal","quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://web.archive.org/web/20240212151508/https://www.linkedin.com/posts/nunodelgadotpv_mestrebastosnunes-judo-portugaljudo-activity-7155564790885556225-5SnY/?originalSubdomain=pt","cite":"Nuno Delgado LinkedIn post","citation":"O Mestre Bastos Nunes, juntou-se ao seu querido Mestre Kobayashi que serviu com verdadeira alma Samurai, \xablinha dura\xbb como dizia sempre. A par do meu Mestre Fernando Costa Matos, s\xe3o as mais altas gradua\xe7\xf5es Lusas, disc\xedpulos diretos de Kiyoshi Kobayashi, que tanto moldaram os nossos judocas, com a sua sabedoria e pedagogia."}]}},{"data":{"id":"JDP2cd88e5b0630d","name":"Tomita Takeji (Aikid\u014D) Carlos Portas","source":"JDP-71","target":"JDP-72","interaction":"Aikid\u014D","interaction_id":"JDP-S-4","interaction_native":{"name":"\u5408\u6C17\u9053","lang":"ja"},"place":"Iwama D\u014Dj\u014D","quality":null,"period":{"start":1985,"end":1993},"sources":[{"uri":"https://aikidomdc.wixsite.com/brpd/untitled-c1nrv","cite":"Mestre Carlos Portas (Aikido Marcial Dojo Clube)","citation":" Em 1985, viu no jornal o an\xfancio de uma demonstra\xe7\xe3o de Aikido por um mestre japon\xeas (Mestre Tomita), em Estocolmo, e foi ver. Achou que tinha ca\xeddo num po\xe7o de luz e logo ali perguntou ao Mestre se o aceitava como aluno, o que veio a acontecer. Regressou a Portugal em 1993"}]}},{"data":{"id":"JDPbdd02f83c798f","name":"Georges Stobbaerts (Aikid\u014D) Carlos Pereira","source":"JDP-86","target":"JDP-84","interaction":"Aikid\u014D","interaction_id":"JDP-S-4","interaction_native":{"name":"\u5408\u6C17\u9053","lang":"ja"},"place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm","cite":"Entrevista ao Professor Jos\xe9 Ara\xfajo (Pedro Escudeiro, 2000 - Archived)","citation":"O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o respons\xe1vel pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem s\xe9ria, rigorosa e profundamente empenhada."}]}},{"data":{"id":"JDPa3c3a465969a2","name":"Kobayashi Kiyoshi (K\u014Dd\u014Dkan J\u016Bd\u014D) Jos\xe9 Manuel Bastos Nunes","source":"JDP-12","target":"JDP-16","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Judo Clube de Portugal","quality":null,"period":{"start":null,"end":null}}},{"data":{"id":"JDP63e1c0fbe4887","name":"Antony Striker (K\u014Dd\u014Dkan J\u016Bd\u014D) Jos\xe9 Manuel Bastos Nunes","source":"JDP-66","target":"JDP-16","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Judo Clube de Portugal","quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"http://judokai.pt/JUDO%20-%20MANUAL.pdf","cite":"Judokai: Manual de Forma\xe7\xe3o para Gradua\xe7\xe3oem 1\xba Dan - Judo (Judo Clube de Sintra - Judokai)","citation":"Quase na mesma altura [1955] chega a Lisboao Sui\xe7o Antony Stryker, 1\xba Dan,que abre uma sala no Largo do Intendente, onde teve como aluno, entre outros, Jos\xe9 Manuel Bastos Nunes."}]}},{"data":{"id":"JDPe03510402e29a","name":"Ogawa Ryuzo (K\u014Dd\u014Dkan J\u016Bd\u014D) Augusto de Oliveira Cordeiro","source":"JDP-126","target":"JDP-127","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Budokan (SP)","quality":3,"period":{"start":"1950","end":null},"sources":[{"uri":"https://blogoterohermanny.blogspot.com/2009/09/o-mestre-augusto-cordeiro.html","cite":"Rudolf Hermanny\'s Blog","citation":"ao estabelecer contato com a Associa\xe7\xe3o Budokan do Prof. Riuzo Ogawa se apaixonou pelo magn\xedfico Jud\xf4 que ali se ensinava e praticava. Ap\xf3s uma temporada residindo em casa do mestre e praticando com seus alunos, o Prof. Cordeiro adotou a nova metodologia e a forma de competi\xe7\xe3o oficial do jud\xf4"},{"uri":"https://revistabudo.com.br/georges-mehdi-e-rudolf-hermanny-uma-historia-que-transcende-o-tempo-e-os-tatamis/","cite":"Revista Bud\xf4","citation":"disc\xedpulo direto do mestre japon\xeas Ryuzo Ogawa"},{"uri":"https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php","cite":"Ma\xe7aneiro (2024)","location":"pp. 91-92","citation":"Cordeiro continuou a procurar pelo jud\xf4 e, no in\xedcio da d\xe9cada de 1950, chegou \xe0 um acordo com Ryuzo Ogawa, tornando-se sua primeira filial no Rio de Janeiro"}]}},{"data":{"id":"JDP776b79e97fd1","name":"Yano Takeo (K\u014Dd\u014Dkan J\u016Bd\u014D) Augusto de Oliveira Cordeiro","source":"JDP-105","target":"JDP-127","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Rio de Janeiro","quality":2,"period":{"start":"1937","end":"1948"},"sources":[{"uri":"https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php","cite":"MA\xc7ANEIRO, Gustavo Goulart Braga. Desenvolvimento organizacional do jud\xf4 brasileiro. S\xe3o Paulo : Escola de Educa\xe7\xe3o F\xedsica e Esporte, Universidade de S\xe3o Paulo, 2024. Disserta\xe7\xe3o de Mestrado em Estudos Socioculturais e Comportamentais da Educa\xe7\xe3o F\xedsica e Esporte","location":"p. 91","citation":"em 1944 a ACM promoveu competi\xe7\xf5es e gradua\xe7\xf5es (...) Por esse per\xedodo \xe9 que Takeo Yano foi respons\xe1vel pela gradua\xe7\xe3o de professores no Rio de Janeiro e, dentre eles, aquele que se tornou, anos mais tarde, o primeiro presidente da CBJ, Augusto Cordeiro"},{"uri":"https://memoria.bn.gov.br/DocReader/DocReader.aspx?bib=221961_03&&pasta=ano%20195&pagfis=59293","cite":"Diario da Noite","location":"Ed. 06066, 11 de Dezembro de 1957, p. 3","citation":"Corria o ano de 1937 e tratei de inscrever o meu nome entre os alunos do professor Takeo Yama [sic], que afinal de contas, funcionou como o meu descobridor"}]}},{"data":{"id":"JDP5ceaf79769ab1","name":"Hirano Yuzo (J\u016Bjutsu) Armando Gon\xe7alves","source":"JDP-77","target":"JDP-76","interaction":"J\u016Bjutsu","interaction_id":"JDP-S-14","interaction_native":{"name":"\u67D4\u8853","lang":"ja"},"place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"http://id.bnportugal.gov.pt/bib/catbnp/732683","cite":"GON\xc7ALVES, Armando; O fraco vence o forte. 1941","citation":"Ex-disc\xedpulo do Professor japon\xeas, Hirano (...) O nosso saudoso ex-professor Hirano n\xe3o tinha admira\xe7\xe3o nenhuma pelo sistema Kano"}]}},{"data":{"id":"JDP3c24522f4b93","name":"Fernando Costa Matos (K\u014Dd\u014Dkan J\u016Bd\u014D) Ant\xf3nio Roquette de Andrade","source":"JDP-15","target":"JDP-61","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.ahbe.pt/portfolio-item/judo/","cite":"A Hist\xf3ria Do Judo na AHBE","citation":"O professor Costa Matos leccionou Judo na AHBE entre 1970 e 1976, altura em que, por motivos de sa\xfade, foi substitu\xeddo pelo seu melhor aluno, o professor Ant\xf3nio Roquete de Andrade, o qual assumiu definitivamente o cargo de treinador principal da AHBE em 1977, ap\xf3s ter participado como atleta nos Jogos Ol\xedmpicos de MONTREAL em 1976."}]}},{"data":{"id":"JDPa31ef787a0c4a","name":"Erich Rahn (J\u016Bjutsu) Ant\xf3nio Corr\xeaa Pereira","source":"JDP-109","target":"JDP-83","interaction":"J\u016Bjutsu","interaction_id":"JDP-S-14","interaction_native":{"name":"\u67D4\u8853","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null}}},{"data":{"id":"JDPaa65586abf64e","name":"Antony Striker (K\u014Dd\u014Dkan J\u016Bd\u014D) Alexandre Gueif\xe3o","source":"JDP-66","target":"JDP-67","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Judokai de Lisboa","quality":3,"period":{"start":1958,"end":null},"sources":[{"uri":"https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_35-62.pdf","cite":"Gueif\xe3o, Alexandre, \xab\xc0 volta de Homens com s\xe9rio C\xf3digo de Honra\xbb, in \xabA G\xe9nese do Karate em Portugal\xbb","citation":"Retrato saudoso e quase desvanecido de um karateka que se iniciou em Judo no ano de 1958 sob a orienta\xe7\xe3o de Tony Stricker e H. Bouchend-Homme da Organiza\xe7\xe3o Judokai, e mais tarde sob os ensinamentos do Grande Mestre K. Kobayashi, no Judo Clube de Portugal."}]}},{"data":{"id":"JDP68834ec3f1cb7","name":"Henri Bouchend\'Homme (K\u014Dd\u014Dkan J\u016Bd\u014D) Alexandre Gueif\xe3o","source":"JDP-68","target":"JDP-67","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Judokai de Lisboa","quality":3,"period":{"start":1958,"end":null},"sources":[{"uri":"https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_35-62.pdf","cite":"Gueif\xe3o, Alexandre, \xab\xc0 volta de Homens com s\xe9rio C\xf3digo de Honra\xbb, in \xabA G\xe9nese do Karate em Portugal\xbb","citation":"Retrato saudoso e quase desvanecido de um karateka que se iniciou em Judo no ano de 1958 sob a orienta\xe7\xe3o de Tony Stricker e H. Bouchend-Homme da Organiza\xe7\xe3o Judokai, e mais tarde sob os ensinamentos do Grande Mestre K. Kobayashi, no Judo Clube de Portugal."}]}},{"data":{"id":"JDP236239c3089c","name":"Lu\xeds Franco Pires Martins (Karate) Alexandre Gueif\xe3o","source":"JDP-82","target":"JDP-67","interaction":"Karate","interaction_id":"JDP-S-5","interaction_native":{"name":"\u7A7A\u624B","lang":"ja"},"place":"Academia de Budo","quality":3,"period":{"start":1964,"end":null},"sources":[{"uri":"https://www.suishinkan.com.pt/biografia.html","citation":"Foi co-introdutor da pr\xe1tica do Karate em Portugal na Academia de Budo, em Lisboa, onde come\xe7ou a praticar em 1964 sob a orienta\xe7\xe3o do seu primeiro Mestre de Karate-Do - Mestre Pires Martins da UBU"}]}},{"data":{"id":"JDP67fec0583f254","name":"Kobayashi Kiyoshi (K\u014Dd\u014Dkan J\u016Bd\u014D) Alexandre Gueif\xe3o","source":"JDP-12","target":"JDP-67","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Judo Clube de Portugal","quality":3,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_35-62.pdf","cite":"Gueif\xe3o, Alexandre, \xab\xc0 volta de Homens com s\xe9rio C\xf3digo de Honra\xbb, in \xabA G\xe9nese do Karate em Portugal\xbb","citation":"Retrato saudoso e quase desvanecido de um karateka que se iniciou em Judo no ano de 1958 sob a orienta\xe7\xe3o de Tony Stricker e H. Bouchend-Homme da Organiza\xe7\xe3o Judokai, e mais tarde sob os ensinamentos do Grande Mestre K. Kobayashi, no Judo Clube de Portugal."}]}},{"data":{"id":"JDP62056c4d336f","name":"Murakami Tetsuji (Karate) Alexandre Gueif\xe3o","source":"JDP-94","target":"JDP-67","interaction":"Karate","interaction_id":"JDP-S-5","interaction_native":{"name":"\u7A7A\u624B","lang":"ja"},"place":null,"quality":2,"period":{"start":1969,"end":null},"sources":[{"uri":"https://www.suishinkan.com.pt/biografia.html","citation":"O seu segundo Mestre foi Tetsuji Murakami Sensei, de quem foi aluno desde 1969, data que marca o nascimento efectivo da pr\xe1tica do estilo Shotokai em Portugal com a realiza\xe7\xe3o do primeiro est\xe1gio de Mestre Murakami."}]}},{"data":{"id":"JDP22d81a4e47697","name":"Antony Striker (K\u014Dd\u014Dkan J\u016Bd\u014D) Afonso Henriques Maia de Loureiro","source":"JDP-66","target":"JDP-65","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Judo Clube de Portugal","quality":3,"period":{"start":1954,"end":1958},"sources":[{"uri":"https://judolandia.tripod.com/histport.htm","cite":"Hist\xf3ria do Judo em Portugal (Judol\xe2ndia, texto de \xabJudo: da inicia\xe7\xe3o \xe0 competi\xe7\xe3o\xbb, Costa Branco et. al","citation":"Quase na mesma altura chega a Lisboa Antony Striker (Su\xed\xe7o) 1\xba Dan, o qual abre uma sala no Largo do Intendente, onde despontaram para o Judo, entre outros, Afonso Maia de Loureiro, Vasco de Sousa e Jos\xe9 Manuel Bastos Nunes."},{"uri":"https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=243","cite":"Seis hist\xf3rias \xe0 volta do Tatami _ Gala 60\xba Anivers\xe1rio FPJ","citation":"Em 1954. O professor era um tal belga, Anton Stricker, que era seguran\xe7a do Reino Belga"}]}},{"data":{"id":"JDPe46e0f4966b25","name":"Kan\u014D Jigor\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Yokoyama Sakujiro","source":"JDP-1","target":"JDP-9","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":null,"period":{"start":1886,"end":null}}},{"data":{"id":"JDP6984835e65ea7","name":"Inoe Keitaro (Tenjin Shin\'y\u014D-ry\u016B) Yokoyama Sakujiro","source":"JDP-10","target":"JDP-9","interaction":"Tenjin Shin\'y\u014D-ry\u016B","interaction_id":"JDP-S-3","interaction_native":{"name":"\u5929\u795E\u771F\u694A\u6D41","lang":"ja"},"place":"Yushima Tenjin dojo","quality":null,"period":{"start":null,"end":null}}},{"data":{"id":"JDPcf5a08856184f","name":"Isogai Hajime (K\u014Dd\u014Dkan J\u016Bd\u014D) Yano Takeo","source":"JDP-43","target":"JDP-105","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://simonbjj.com/takeo-yano","cite":"The Eastern Demon, Takeo Yano (Simon BJJ)","citation":"There is not much information known about Takeo Yano, but it is believed he may have been born in 1909 and trained at the Dai Nippon Butoko Kai academy in Kioto under famed Judoka, Hajime Isogai."}]}},{"data":{"id":"JDP39834f3ebb2f7","name":"Kan\u014D Jigor\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Yamashita Yoshitsugu","source":"JDP-1","target":"JDP-95","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":null,"period":{"start":1884,"end":null},"sources":[{"uri":"https://www.judo-ch.jp/english/legend/yamasita/","cite":"Kodokan hall of fame: Yoshitsugu Yamashita (Judo Channel)","citation":"Yoshitsugu Yamashita was the son of an Odawara Han martial arts instructor, and he entered Kodokan in August of 1884."},{"uri":"https://en.wikipedia.org/wiki/Yamashita_Yoshitsugu","citation":"In August 1884, he joined the Kodokan judo dojo of his childhood friend Kano Jigoro as its nineteenth member"}]}},{"data":{"id":"JDPaf13b6b39514d","name":"Takeda S\u014Dkaku (Dait\u014D-ry\u016B Aiki-j\u016Bjutsu) Ueshiba Morihei","source":"JDP-28","target":"JDP-27","interaction":"Dait\u014D-ry\u016B Aiki-j\u016Bjutsu","interaction_id":"JDP-S-10","interaction_native":{"name":"\u5927\u6771\u6D41 \u5408\u6C17\u67D4\u8853","lang":"ja"},"place":null,"quality":null,"period":{"start":1915,"end":1922}}},{"data":{"id":"JDPb55e62479da15","name":"Tozawa Tokusaburo (Tenjin Shin\'y\u014D-ry\u016B) Ueshiba Morihei","source":"JDP-47","target":"JDP-27","interaction":"Tenjin Shin\'y\u014D-ry\u016B","interaction_id":"JDP-S-3","interaction_native":{"name":"\u5929\u795E\u771F\u694A\u6D41","lang":"ja"},"place":null,"quality":null,"period":{"start":1901,"end":1901},"sources":[{"uri":"http://www.hontaiyoshinryu.be/images/Documents/p_schools.pdf","cite":"BUYENS, Guy. Introduction to Traditional martial systems. 2016","citation":"Iso Mataemon Masatomo had amongst his students Inoue Keitaro and Tozawa Tokusaburo, who were the teachers of Miyamoto Hanzo). Morihei Ueshiba, founder of aikido, studied Tenjin Shinyo-ryu with Tozawa Tokusaburo"},{"uri":"https://aikidojournal.com/2011/08/27/tokusaburo-tozawa/","citation":"[Tokusaburo Tozawa]. Teacher of TENJIN SHIN\u2019YO-RYU JUJUTSU in Tokyo in late 1800s and early 1900s. Taught Morihei UESHIBA for brief period in 1901","events":["period"]}]}},{"data":{"id":"JDP565830982bd2c","name":"Masakatsu Naka (Yagy\u016B Shingan-ry\u016B) Ueshiba Morihei","source":"JDP-50","target":"JDP-27","interaction":"Yagy\u016B Shingan-ry\u016B","interaction_id":"JDP-S-11","interaction_native":{"name":"\u67F3\u751F\u5FC3\u773C\u6D41","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://en.wikipedia.org/wiki/Yagy%C5%AB_Shingan-ry%C5%AB","citation":"Morihei Ueshiba, the founder of Aikido, was a student of Yagy\u016B Shingan-ry\u016B. In 1908, after five years of training, he received the rank of Shoden from Masakatsu Nakai, a Shihan of the Edo-line of Yagy\u016B Shingan-ry\u016B"},{"uri":"https://aikidojournal.com/2016/09/24/interview-with-morihei-ueshiba-and-kisshomaru-ueshiba/","citation":"O-Sensei: At about the age of 14 or 15. First I learned Tenshinyo-ryu Jiujitsu from Tokusaburo Tozawa Sensei, then Kito-ryu, Yagyu-ryu, Aioi-ryu, Shinkage-ryu, all of them jujutsu forms."}]}},{"data":{"id":"JDP8f7c0ed8f45b2","name":"Nait\u014D Takaharu (Kendo) Ueda Heitaro","source":"JDP-60","target":"JDP-39","interaction":"Kendo","interaction_id":"JDP-S-8","interaction_native":{"name":"\u5263\u9053","lang":"ja"},"place":"Bujutsu Kyoin Yoseijo","quality":3,"period":{"start":1905,"end":null},"sources":[{"uri":"https://kenshi247.net/blog/2022/01/24/the-iron-will-of-the-kendo-god-ueda-heitaro/","cite":"The iron will of the kendo god Ueda Heitaro - Kenshi 24/7","citation":"At the Yoseijo he was there as a koshusei or a part-time student there to learn kendo only (full time students also did academic study). There he studied directly under Naito Takaharu and crossed shinai with the likes of Saimura, Nakano, Oshima, and Shimatani (this was slightly before Mochida, Ogawa, Miyazaki, and Oasa, etc arrived). "}]}},{"data":{"id":"JDP122f6b961672c","name":"Kan\u014D Jigor\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Uchida Ry\u014Dhei","source":"JDP-1","target":"JDP-48","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":1,"period":{"start":1893,"end":null},"sources":[{"uri":"https://www.researchgate.net/publication/277665808_Kodokan_Judo\'s_three_orphaned_forms_of_counter_techniques_-_Part_1_The_gonosen-no-kata_-_Forms_of_post-attack_initiative_counter_throws","citation":"Miyakawa remained a Gen\u2019y\u014Dshamember and became a K\u014Dd\u014Dkan top-executive (K\u014Dd\u014Dkan Saik\u014D  Kanbu\u8B1B\u9053\u9928\u6700\u9AD8\u5E79\u90E8)  closely  associated  with Kan\u014D Jigor\u014D, as was Uchida Ry\u014Dhei"},{"uri":"https://kanochronicles.com/2023/06/05/ki-%e6%b0%97-in-judo-%e6%9f%94%e9%81%93-uchida-ryohei-and-the-secrets-of-budo-%e6%ad%a6%e9%81%93%e6%a5%b5%e6%84%8f-the-kano-chronicles/","citation":"He was also an accomplished j\u016Bd\u014Dka, a favorite of Kan\u014D shihan \u5E2B\u7BC4 (master), one of the three most senior 5th dan rank holders in Kodokan history, and a noted street brawler."}]}},{"data":{"id":"JDPd1312a98c402f","name":"Miyagawa Taichiro (Jig\u014D Tenshin Ry\u016B) Uchida Ry\u014Dhei","source":"JDP-49","target":"JDP-48","interaction":"Jig\u014D Tenshin Ry\u016B","interaction_id":"JDP-S-12","interaction_native":{"name":"\u81EA\u525B\u5929\u771F\u6D41","lang":"ja"},"place":"Meikokan dojo","quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://opac.tenri-u.ac.jp/opac/repository/metadata/1573/","citation":"\u5BAE\u5DDD\u592A\u4E00\u90CE\u5609\u6C38\u5143\u5E74\uFF081848\uFF09\u751F\u6B63\u6797\u53C8\u4E03\u90CE\u306E\u9AD8\u5F1F\u30FB\u514D\u8A31\u7686\u4F1D\u4EE3\u3005\u9ED2\u7530\u5BB6\u306E\u81E3\u3067\u3042\u308B\u3002\u4E00\u4E07\u6D41\u5263\u8853\uFF0C\u81EA\u525B\u5929\u771F\u6D41\u7D44\u8A0E\u3092\u6975\u3081\uFF0C\u660E\u6CBB10\u5E74(1877) 11\u6708\u7384\u6D0B\u793E\u9644\u5C5E\u306E\u5411\u6D5C\u587E\u3067\u81EA\u805E\u5929\u771F\u6D41\u3092\u6559\u6388\u3057\u305F\u306E\u304C\uFF0C\u5F8C\u306E\u660E\u9053\u9928\u9053\u5834\u306E\u8D77\u6E90\u3068\u3055\u308C\u3066\u3044\u308B\u3002"},{"uri":"https://kanochronicles.com/2023/06/05/ki-%e6%b0%97-in-judo-%e6%9f%94%e9%81%93-uchida-ryohei-and-the-secrets-of-budo-%e6%ad%a6%e9%81%93%e6%a5%b5%e6%84%8f-the-kano-chronicles/","citation":"He learned a number of martial arts, most notably Jig\u014D Tenshin Ry\u016B J\u016Bjutsu in Fukuoka\u2019s Meidokan d\u014Dj\u014D, an art in which he was notably successful. In 1893 he moved to Tokyo to live with his wealthy coal mine owner uncle Hiraoka K\u014Dtar\u014D, a supporter of the Geny\u014Dsha, and began to study Russian at a Tokyo school and j\u016Bd\u014D at Kan\u014D Jigor\u014D\u2019s Kodokan."}]}},{"data":{"id":"JDP8f9a909909605","name":"Iso Masatomo (Tenjin Shin\'y\u014D-ry\u016B) Tozawa Tokusaburo","source":"JDP-4","target":"JDP-47","interaction":"Tenjin Shin\'y\u014D-ry\u016B","interaction_id":"JDP-S-3","interaction_native":{"name":"\u5929\u795E\u771F\u694A\u6D41","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"http://www.tenyokai.com/booklet.php","citation":"Geneology of Tenjin Shinyo Ryu Jujutsu: (...) Iso Matauemon Masatomo -> Tozawa Tokusaburo"},{"uri":"http://www.hontaiyoshinryu.be/images/Documents/p_schools.pdf","citation":"Iso Mataemon Masatomo had amongst his students Inoue Keitaro and Tozawa Tokusaburo, who were the teachers of Miyamoto Hanzo). Morihei Ueshiba, founder of aikido, studied Tenjin Shinyo-ryu with Tozawa Tokusaburo"}]}},{"data":{"id":"JDPbb3babcb207d7","name":"Kan\u014D Jigor\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Tomita Tsunejir\u014D","source":"JDP-1","target":"JDP-17","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":null,"period":{"start":1882,"end":null}}},{"data":{"id":"JDPd8e791d88d61e","name":"Sait\u014D Morihiro (Aikid\u014D) Tomita Takeji","source":"JDP-70","target":"JDP-71","interaction":"Aikid\u014D","interaction_id":"JDP-S-4","interaction_native":{"name":"\u5408\u6C17\u9053","lang":"ja"},"place":"Iwama D\u014Dj\u014D","quality":null,"period":{"start":1962,"end":1},"sources":[{"uri":"https://www.aikidojournal.eu/docs/238/393_946_en.pdf","cite":"TAKEJI TOMITA: From studying with O-Sensei to the creation of A\xefki Shin Myo Den (Aikido Journal)","citation":"From 1962 on, after his first visit in Iwama, he decides to follow the teaching of O\'Sensei and of his assistant, Morihiro Saito Sensei (...) In 1968, he becomes Morihiro Saito\'s Uchideshi and is rapidly adopted by the Master\'s family (...) Tomita Sensei practiced for about 7 years at the Iwama Dojo. Those years were for him formativeyears dedicated to education and to discovering the way of Budo."}]}},{"data":{"id":"JDPcda2455cfc9d2","name":"Kan\u014D Jigor\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Tomiki Kenji","source":"JDP-1","target":"JDP-26","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":null,"period":{"start":1895,"end":1896}}},{"data":{"id":"JDPc5762da067e76","name":"Ueshiba Morihei (Aikid\u014D) Tomiki Kenji","source":"JDP-27","target":"JDP-26","interaction":"Aikid\u014D","interaction_id":"JDP-S-4","interaction_native":{"name":"\u5408\u6C17\u9053","lang":"ja"},"place":null,"quality":null,"period":{"start":1926,"end":null}}},{"data":{"id":"JDPee403dcd28a2d","name":"Takenaka  Motonoshin (Kit\u014D-ry\u016B) Takenaka Tetsunosuke Issei","source":"JDP-7","target":"JDP-6","interaction":"Kit\u014D-ry\u016B","interaction_id":"JDP-S-2","interaction_native":{"name":"\u8D77\u5012\u6D41","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null}}},{"data":{"id":"JDPc51b13dc5a2c2","name":"Takino Y\u016Bken (Kit\u014D-ry\u016B) Takenaka  Motonoshin","source":"JDP-8","target":"JDP-7","interaction":"Kit\u014D-ry\u016B","interaction_id":"JDP-S-2","interaction_native":{"name":"\u8D77\u5012\u6D41","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null}}},{"data":{"id":"JDPd8d43de71e0cd","name":"Yokoyama Sakujiro (K\u014Dd\u014Dkan J\u016Bd\u014D) Takahashi Kazuyoshi","source":"JDP-9","target":"JDP-14","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":null,"period":{"start":null,"end":null}}},{"data":{"id":"JDPd77d0d95645af","name":"Iizuka Kunisabur\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Sugino Yoshio","source":"JDP-31","target":"JDP-30","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kei\u014D Gijuku Daigaku","quality":2,"period":{"start":1918,"end":1919}}},{"data":{"id":"JDPf222d9fb17dcd","name":"Ueshiba Morihei (Aikid\u014D) Sugino Yoshio","source":"JDP-27","target":"JDP-30","interaction":"Aikid\u014D","interaction_id":"JDP-S-4","interaction_native":{"name":"\u5408\u6C17\u9053","lang":"ja"},"place":"Wakamatsu-cho dojo","quality":2,"period":{"start":1931,"end":1935}}},{"data":{"id":"JDPecbd6193c54ed","name":"Tamai Narimichi (Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B) Sugino Yoshio","source":"JDP-32","target":"JDP-30","interaction":"Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B","interaction_id":"JDP-S-6","interaction_native":{"name":"\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41","lang":"ja"},"place":"Kawasaki","quality":1,"period":{"start":1927,"end":null}}},{"data":{"id":"JDP8e0255213bc47","name":"Kuboki Sozaemon (Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B) Sugino Yoshio","source":"JDP-33","target":"JDP-30","interaction":"Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B","interaction_id":"JDP-S-6","interaction_native":{"name":"\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41","lang":"ja"},"place":"Kawasaki","quality":1,"period":{"start":1927,"end":null}}},{"data":{"id":"JDPcfea5b6a25bd6","name":"Ito Tanekichi (Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B) Sugino Yoshio","source":"JDP-34","target":"JDP-30","interaction":"Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B","interaction_id":"JDP-S-6","interaction_native":{"name":"\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41","lang":"ja"},"place":"Kawasaki","quality":1,"period":{"start":1927,"end":null}}},{"data":{"id":"JDPe952795d3fc32","name":"Shiina Ichizo (Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B) Sugino Yoshio","source":"JDP-35","target":"JDP-30","interaction":"Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B","interaction_id":"JDP-S-6","interaction_native":{"name":"\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41","lang":"ja"},"place":"Kawasaki","quality":1,"period":{"start":1927,"end":null}}},{"data":{"id":"JDPa29fd5084fc8b","name":"Kanaya Genro (Y\u014Dshin-ry\u016B) Sugino Yoshio","source":"JDP-36","target":"JDP-30","interaction":"Y\u014Dshin-ry\u016B","interaction_id":"JDP-S-7","interaction_native":{"name":"\u694A\u5FC3\u6D41","lang":"ja"},"place":null,"quality":1,"period":{"start":1928,"end":null}}},{"data":{"id":"JDP515010353b335","name":"Iizasa Shuri-no-suke Morisada (Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B) Shiina Ichizo","source":"JDP-116","target":"JDP-35","interaction":"Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B","interaction_id":"JDP-S-6","interaction_native":{"name":"\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/","cite":"Exkurs: Die moderne Geschichte der Katori Shint\xf4 ry\xfb (Ein Leben f\xfcr die Schwertkunst)","citation":"Iisasa Morisada (sieben direkte Sch\xfcler): Yamaguchi Kumajir\xf4 Eikan Mairaku / Tamai Said\xf4 / Noguchi Jizaemon / Ono Heishichir\xf4 Moriichi / Shiina Ichiz\xf4 / Hong\xfb Toranosuke / Kaneko Shinosh\xf4"}]}},{"data":{"id":"JDPb3a8b080ce189","name":"Yokoyama Sakujiro (K\u014Dd\u014Dkan J\u016Bd\u014D) Satake Soshihiro","source":"JDP-9","target":"JDP-22","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":1,"period":{"start":1892,"end":null},"sources":[{"uri":"https://simonbjj.com/satake","cite":"The Sumo wrestle who taught BJJ, Soshiro Satake","citation":"At some point later, probably in the late 1890\u2019s, he joined the Kodokan and would become peers of Mitsuyo Maeda. The two judoka trained together under Sakujiro Yokoyama, who was known as one of the Four Guardians of the Kodokan"},{"uri":"https://ja.wikipedia.org/wiki/%E4%BD%90%E7%AB%B9%E4%BF%A1%E5%9B%9B%E9%83%8E","citation":"1892\u5E74\uFF08\u660E\u6CBB25\u5E74\uFF095\u6708\u306B\u8B1B\u9053\u9928\u306B\u5165\u9580"}]}},{"data":{"id":"JDP46bd2b488bf55","name":"Ueshiba Morihei (Aikid\u014D) Sait\u014D Morihiro","source":"JDP-27","target":"JDP-70","interaction":"Aikid\u014D","interaction_id":"JDP-S-4","interaction_native":{"name":"\u5408\u6C17\u9053","lang":"ja"},"place":"Iwama D\u014Dj\u014D","quality":null,"period":{"start":1946,"end":1969},"sources":[{"uri":"https://en.wikipedia.org/wiki/Morihiro_Saito","citation":"It was at this time, at the age of 18, that Saito joined Ueshiba for training (...) From 1946 until Ueshiba\u2019s passing in 1969, Saito served as Ueshiba\'s assistant in a variety of ways at Iwama while his wife served Mrs. Ueshiba. During Saito\u2019s period as a deshi he taught classes in the Iwama dojo."}]}},{"data":{"id":"JDPfab7e61f440e9","name":"Kan\u014D Jigor\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Saig\u014D Shir\u014D","source":"JDP-1","target":"JDP-121","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":3,"period":{"start":1882,"end":1890},"sources":[{"uri":"urn:isbn:1425163491","cite":"WATSON, Brian N. Judo memoirs of Jigoro Kano. Trafford Publishing, 2008","location":"p. 20","citation":"Shortly thereafter, in August 1882, the now famous Shiro Saigo became a student of mine"}]}},{"data":{"id":"JDP1e4c89448c345","name":"Hayashi Yazaemon (Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B) \u014Ctake Risuke","source":"JDP-113","target":"JDP-112","interaction":"Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B","interaction_id":"JDP-S-6","interaction_native":{"name":"\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41","lang":"ja"},"place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/","cite":"Exkurs: Die moderne Geschichte der Katori Shint\xf4 ry\xfb (Ein Leben f\xfcr die Schwertkunst)","citation":"Iisasa Morisada (sieben direkte Sch\xfcler): Yamaguchi Kumajir\xf4 Eikan Mairaku / Tamai Said\xf4 / Noguchi Jizaemon / Ono Heishichir\xf4 Moriichi / Shiina Ichiz\xf4 / Hong\xfb Toranosuke / Kaneko Shinosh\xf4 (...) Hayashi Saiichir\xf4 \u2013> Hayashi Yazaemon \u2013> \xd4take Risuke"}]}},{"data":{"id":"JDP6894d918df887","name":"Mifune Ky\u016Bz\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) \u014Csawa Yoshimi","source":"JDP-11","target":"JDP-131","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Waseda University Judo Club","quality":3,"period":{"start":"1943","end":null},"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E5%A4%A7%E6%B2%A2%E6%85%B6%E5%B7%B1","cite":"\u5927\u6CA2\u5409\u5DF1 - \u65E5\u672C\u8A9E\u7248\u30A6\u30A3\u30AD\u30DA\u30C7\u30A3\u30A2","citation":"1943\u5E744\u6708\u306B\u65E9\u7A32\u7530\u5927\u5B66\u306B\u5165\u5B66\u3057\u67D4\u9053\u90E8\u306B\u5165\u90E8\u3059\u308B\u3068\u3001\u5E2B\u7BC4\u306B\u306F\u4E09\u8239\u4E45\u8535\u3084\u5FB3\u4E09\u5B9D\u3089\u304C\u9854\u3092\u63C3\u3048\u3001\u6708\u306B1\u5EA6\u307B\u3069\u3067\u306F\u3042\u3063\u305F\u304C\u6307\u5C0E\u306B\u6765\u3066\u305D\u306E\u85AB\u9676\u3092\u53D7\u3051\u305F"}]}},{"data":{"id":"JDP32c12488329f4","name":"It\u014D Tokugor\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Geo Omori","source":"JDP-104","target":"JDP-103","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 153","citation":"Foi disc\xedpulo de um dos maiores lutadores do Kodokan, Tokugoro Ito"},{"uri":"https://en.wikipedia.org/wiki/Geo_Omori","citation":"He learned under Tokugoro Ito and was a training partner of the famed Sanpo Toku"}]}},{"data":{"id":"JDP5291121189854","name":"Matsui Sanzo (Muso-ryu Shinjujutsu) Okano Yoshitaro","source":"JDP-42","target":"JDP-38","interaction":"Muso-ryu Shinjujutsu","interaction_id":"JDP-S-9","interaction_native":{"name":"\u7121\u76F8\u6D41\u65B0\u67D4\u8853","lang":"ja"},"place":null,"quality":0,"period":{"start":null,"end":null}}},{"data":{"id":"JDP32e180a5630c","name":"Isogai Hajime (K\u014Dd\u014Dkan J\u016Bd\u014D) Okano Yoshitaro","source":"JDP-43","target":"JDP-38","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Butokuden","quality":1,"period":{"start":1906,"end":null}}},{"data":{"id":"JDP79f3b63306296","name":"Nagaoka Sh\u016Bichi (K\u014Dd\u014Dkan J\u016Bd\u014D) Okano Yoshitaro","source":"JDP-44","target":"JDP-38","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Butokuden","quality":1,"period":{"start":1906,"end":null}}},{"data":{"id":"JDPd31e373018486","name":"Nait\u014D Takaharu (Kendo) Ogawa Kinnosuke","source":"JDP-60","target":"JDP-59","interaction":"Kendo","interaction_id":"JDP-S-8","interaction_native":{"name":"\u5263\u9053","lang":"ja"},"place":"Bud\u014D Senmon Gakko","quality":3,"period":{"start":1907,"end":1910},"sources":[{"uri":"https://web.archive.org/web/20090218133219/http://rrjudo.com/history/zenjudo.htm","cite":"Ogawa Kinnosuke - Kenshi 24/7","citation":"In 1905 a school was formally opened to teach kendo instructors and Naito was selected as the senior teacher. At this time the school was known as the Bujutsu Kyoin Yoseijo, but eventually (after a few re-organisations and renames) it would be known to everyone as Busen (Budo Senmon Gakko). It was to this school that Ogawa was dispatched by the Nagoya police department in 1907. Ogawa would spend 3 years studying kendo directly under Naito."}]}},{"data":{"id":"JDP9e0af269ce4c5","name":"Kan\u014D Jigor\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Nagaoka Sh\u016Bichi","source":"JDP-1","target":"JDP-44","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":null,"period":{"start":1891,"end":null}}},{"data":{"id":"JDP19c802a9b9c2b","name":"Egami Shigeru (Karate) Murakami Tetsuji","source":"JDP-93","target":"JDP-94","interaction":"Karate","interaction_id":"JDP-S-5","interaction_native":{"name":"\u7A7A\u624B","lang":"ja"},"place":null,"quality":2,"period":{"start":1968,"end":null},"sources":[{"uri":"https://shotokai.com/tetsuji-murakami/","cite":"Tetsuji Murakami Sensei (Shotokai Encyclopedia)","citation":"In 1968 he travels to Japan where he meets Master Shigeru Egami. Very impressed by Master Egami and the technique he observes, he decides to make a profound and very difficult transformation in his technique and his practice. He returns to Europe as the representative of the Nihon Karate-do Shotokai."},{"uri":"https://kogenbudo.org/interview-with-master-nuno-russo-by-pedro-escudeiro/","cite":"https://kogenbudo.org/interview-with-master-nuno-russo-by-pedro-escudeiro/","citation":" A couple of years later, though, we had our first international seminar with a Japanese karate master: Murakami Tetsuji, from Shotokai Karate, a student of Egami Shigeru sensei. After this seminar, Murakami sensei became the leader of our karate group"}]}},{"data":{"id":"JDP6fc43dd00d1de","name":"Kan\u014D Jigor\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Mochizuki Minoru","source":"JDP-1","target":"JDP-29","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":null,"period":{"start":1925,"end":1930}}},{"data":{"id":"JDPc4b5b5657362","name":"Mifune Ky\u016Bz\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Mochizuki Minoru","source":"JDP-11","target":"JDP-29","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":null,"period":{"start":1925,"end":1930}}},{"data":{"id":"JDP0ffb5b49150ce","name":"Ueshiba Morihei (Aikid\u014D) Mochizuki Minoru","source":"JDP-27","target":"JDP-29","interaction":"Aikid\u014D","interaction_id":"JDP-S-4","interaction_native":{"name":"\u5408\u6C17\u9053","lang":"ja"},"place":"Kobukan dojo","quality":null,"period":{"start":1930,"end":null},"sources":[{"uri":"https://aikidojournal.com/2002/11/18/interview-with-minoru-mochizuki-1/","citation":"That was back in 1930 when Ueshiba Sensei still didn\u2019t have a place of his own and was teaching in the living room of a regular private house in the Mejiro area of Tokyo. But just after we started going there, we all moved to the newly finished Ushigome dojo (site of the present Hombu Dojo)"}]}},{"data":{"id":"JDP1a50f5a23cfc5","name":"Funakoshi Gichin (Karate) Mochizuki Minoru","source":"JDP-41","target":"JDP-29","interaction":"Karate","interaction_id":"JDP-S-5","interaction_native":{"name":"\u7A7A\u624B","lang":"ja"},"place":null,"quality":1,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.ffkarate.fr/hiroo-mochizuki-interview-yoseikan-budo/","citation":"El\xe8ve de Jigoro Kano, qui l\u2019avait envoy\xe9 apprendre l\u2019a\xefkido aupr\xe8s de Morihei Ueshiba, Minoru Mochizuki avait aussi travaill\xe9 avec Gichin Funakoshi. [...]  C\u2019\xe9tait la responsabilit\xe9 d\u2019une vie pour lui, car c\u2019est la mission que lui avait confi\xe9 Jigoro Kano. Mais il se trouvait un peu faible du point de vue des at\xe9mis, qu\u2019il avait pourtant \xe9tudi\xe9 avec Funakoshi"},{"uri":"https://books.google.pt/books?id=SdYDAAAAMBAJ&pg=PA34#v=onepage&q&f=false","cite":"A Man of Many Budo (interview with Minoru Mochizuki), Black Belt, Aug 1989.","citation":"Minoru Mochizuki holds the distinction of being the only living man to have studied with aikido founder Morihei Uyeshiba, judo founder Jigoro Kano, and \\"the father of Japanese karate, Gichin Funakoshi."}]}},{"data":{"id":"JDP71e10cc89551e","name":"Tomiki Kenji (Aikid\u014D) Tsunako Miyake","source":"JDP-26","target":"JDP-53","interaction":"Aikid\u014D","interaction_id":"JDP-S-4","interaction_native":{"name":"\u5408\u6C17\u9053","lang":"ja"},"place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://aikidojournal.com/2004/05/06/hiroaki-kogure-sensei-part-two","cite":"Interview with Hiroaki Kogure Sensei, part 2 (interview by Josh Gold, 2004, Aikido Journal)","citation":"Tomiki Sensei had three top students. they were Hideo Oba, Senta Yamada, and Tsunako Miyake Sensei."}]}},{"data":{"id":"JDP5bd9d060d0399","name":"Tomiki Kenji (K\u014Dd\u014Dkan J\u016Bd\u014D) Tsunako Miyake","source":"JDP-26","target":"JDP-53","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://studygrouptomikiaikido.blog/2022/09/05/simplification-or-sportification","cite":"MIYAKE Sensei, Extracts from an Interview by R.J.Lawrance, The E.A.A. Newsletter, Issue 90.2 (in: Study Group Tomiki Aikido - The simplification of Ueshiba\u2019s Aikido)","citation":"Then, I met Tomiki sensei at the Kodokan (...) Now that he is gone, I think that it is very important for us to understand his idea, that to improve judo we must train in judo and aikido together."}]}},{"data":{"id":"JDPb8a92f2523cd","name":"Matashichiro Shobayashi (Jig\u014D Tenshin Ry\u016B) Miyagawa Taichiro","source":"JDP-51","target":"JDP-49","interaction":"Jig\u014D Tenshin Ry\u016B","interaction_id":"JDP-S-12","interaction_native":{"name":"\u81EA\u525B\u5929\u771F\u6D41","lang":"ja"},"place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://opac.tenri-u.ac.jp/opac/repository/metadata/1573/","citation":"\u5BAE\u5DDD\u592A\u4E00\u90CE\u5609\u6C38\u5143\u5E74\uFF081848\uFF09\u751F\u6B63\u6797\u53C8\u4E03\u90CE\u306E\u9AD8\u5F1F\u30FB\u514D\u8A31\u7686\u4F1D\u4EE3\u3005\u9ED2\u7530\u5BB6\u306E\u81E3\u3067\u3042\u308B\u3002\u4E00\u4E07\u6D41\u5263\u8853\uFF0C\u81EA\u525B\u5929\u771F\u6D41\u7D44\u8A0E\u3092\u6975\u3081\uFF0C\u660E\u6CBB10\u5E74(1877) 11\u6708\u7384\u6D0B\u793E\u9644\u5C5E\u306E\u5411\u6D5C\u587E\u3067\u81EA\u805E\u5929\u771F\u6D41\u3092\u6559\u6388\u3057\u305F\u306E\u304C\uFF0C\u5F8C\u306E\u660E\u9053\u9928\u9053\u5834\u306E\u8D77\u6E90\u3068\u3055\u308C\u3066\u3044\u308B\u3002\u5927\u6B639\u5E74(1920)6\u670820\u65E577\u624D\u306B\u3066\u75C5\u6CA1\u3002\u9577\u7537\uFF0E\u5BAE\u5DDD\u5F66\u4E4B\u52A9\u3082\u76EE\u9332\u307E\u3067\u9032\u307F\uFF0C\u81EA\u525B\u5929\u771F\u6D41\u306E\u666E\u53CA\u306B\u52D9\u3081\u305F\u3002"}]}},{"data":{"id":"JDP2fbee5999cd69","name":"Kan\u014D Jigor\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Mifune Ky\u016Bz\u014D","source":"JDP-1","target":"JDP-11","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":null,"period":{"start":1903,"end":1965}}},{"data":{"id":"JDP243adf665abcb","name":"Yokoyama Sakujiro (K\u014Dd\u014Dkan J\u016Bd\u014D) Mifune Ky\u016Bz\u014D","source":"JDP-9","target":"JDP-11","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":null,"period":{"start":1903,"end":null}}},{"data":{"id":"JDP75069cfd05479","name":"Yokoyama Sakujiro (K\u014Dd\u014Dkan J\u016Bd\u014D) Maeda Mitsuyo","source":"JDP-9","target":"JDP-18","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":1,"period":{"start":1897,"end":null},"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E6%A8%AA%E5%B1%B1%E4%BD%9C%E6%AC%A1%E9%83%8E","cite":"\u6A2A\u5C71\u4F5C\u6B21\u90CE (\u30A6\u30A3\u30AD\u30DA\u30C7\u30A3\u30A2)","citation":"\u307E\u305F\u3001\u4E09\u8239\u4E45\u8535\u3084\u524D\u7530\u5149\u4E16\u306E\u5E2B\u5320\u3068\u3057\u3066\u3082\u77E5\u3089\u308C\u308B"},{"uri":"https://simonbjj.com/satake","cite":"The Sumo wrestle who taught BJJ, Soshiro Satake","citation":"At some point later, probably in the late 1890\u2019s, he joined the Kodokan and would become peers of Mitsuyo Maeda. The two judoka trained together under Sakujiro Yokoyama, who was known as one of the Four Guardians of the Kodokan"}]}},{"data":{"id":"JDPde0f831e67d","name":"Iizasa Shuri-no-suke Morisada (Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B) Kumajiro Yamaguchi","source":"JDP-116","target":"JDP-115","interaction":"Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B","interaction_id":"JDP-S-6","interaction_native":{"name":"\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41","lang":"ja"},"place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/","cite":"Exkurs: Die moderne Geschichte der Katori Shint\xf4 ry\xfb (Ein Leben f\xfcr die Schwertkunst)","citation":"Iisasa Morisada (sieben direkte Sch\xfcler): Yamaguchi Kumajir\xf4 Eikan Mairaku / Tamai Said\xf4 / Noguchi Jizaemon / Ono Heishichir\xf4 Moriichi / Shiina Ichiz\xf4 / Hong\xfb Toranosuke / Kaneko Shinosh\xf4 (...) Hayashi Saiichir\xf4 \u2013> Hayashi Yazaemon \u2013> \xd4take Risuke"}]}},{"data":{"id":"JDP5d89e5ed015f7","name":"Kan\u014D Jigor\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Kotani Sumiyuki","source":"JDP-1","target":"JDP-137","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":3,"period":{"start":1921,"end":1938},"sources":[{"uri":"https://judoinfo.com/judan/","cite":"Judo Info: Profiles of Judo 10th Dan Holders","citation":"He was one of Jigoro Kano\u2019s direct students, and only the 7th man to receive a 10th Degree Black Belt while he was still alive."},{"uri":"https://isbnsearch.org/isbn/9781590309162","cite":"The Way of Judo A Portrait of Jigoro Kano and His Students","location":"pp. 167-128","citation":"Kotani can be considered Kano\'s last direct disciple. (...) Kano often chose Kotani as a traveling instructor on his teaching tours overseas."}]}},{"data":{"id":"JDP71b595e467658","name":"Okano Yoshitaro (K\u014Dd\u014Dkan J\u016Bd\u014D) Konishi Yasuhiro","source":"JDP-38","target":"JDP-37","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":1,"period":{"start":1906,"end":null}}},{"data":{"id":"JDPaff7cb07975a1","name":"Ueda Heitaro (Kendo) Konishi Yasuhiro","source":"JDP-39","target":"JDP-37","interaction":"Kendo","interaction_id":"JDP-S-8","interaction_native":{"name":"\u5263\u9053","lang":"ja"},"place":null,"quality":1,"period":{"start":1906,"end":null}}},{"data":{"id":"JDP5ff96d0376b9d","name":"Matsui Sanzo (Muso-ryu Shinjujutsu) Konishi Yasuhiro","source":"JDP-42","target":"JDP-37","interaction":"Muso-ryu Shinjujutsu","interaction_id":"JDP-S-9","interaction_native":{"name":"\u7121\u76F8\u6D41\u65B0\u67D4\u8853","lang":"ja"},"place":null,"quality":0,"period":{"start":1906,"end":null}}},{"data":{"id":"JDP5771c74efe32b","name":"Shingai Tadaatsu (Kendo) Konishi Yasuhiro","source":"JDP-40","target":"JDP-37","interaction":"Kendo","interaction_id":"JDP-S-8","interaction_native":{"name":"\u5263\u9053","lang":"ja"},"place":"Kei\u014D Gijuku Daigaku","quality":1,"period":{"start":1913,"end":null}}},{"data":{"id":"JDP2a6e9445cc74b","name":"Funakoshi Gichin (Karate) Konishi Yasuhiro","source":"JDP-41","target":"JDP-37","interaction":"Karate","interaction_id":"JDP-S-5","interaction_native":{"name":"\u7A7A\u624B","lang":"ja"},"place":"Kei\u014D Gijuku Daigaku","quality":1,"period":{"start":1924,"end":null},"sources":[{"uri":"https://ryukyu-bugei.com/?p=6586","citation":"When he [Konishi] met Funakoshi Gichin in June 1925, he was finally able to learn Karate. However, since its contents was only Kata, together with \u014Ctsuka Hironori \u5927\u585A\u535A\u7D00 (1892\u20131982, founder of Wad\u014D-ry\u016B Karate-d\u014D and J\u016Bjutsu Kenp\u014D) who was also a disciple of Funakoshi, Konishi began to devise Yakusoku Kumite \u7D04\u675F\u7D44\u624B and the like. Later Konishi studied Karate with Motobu Ch\u014Dki and Mabuni Kenwa."}]}},{"data":{"id":"JDPbc083f822ea41","name":"Ueshiba Morihei (Aikid\u014D) Konishi Yasuhiro","source":"JDP-27","target":"JDP-37","interaction":"Aikid\u014D","interaction_id":"JDP-S-4","interaction_native":{"name":"\u5408\u6C17\u9053","lang":"ja"},"place":null,"quality":1,"period":{"start":1924,"end":null}}},{"data":{"id":"JDP5b65399a07b28","name":"Mifune Ky\u016Bz\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Kobayashi Kiyoshi","source":"JDP-11","target":"JDP-12","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":null,"period":{"start":1903,"end":1965}}},{"data":{"id":"JDP0d6bb7d40d84d","name":"Ushijima Tatsukuma (K\u014Dd\u014Dkan J\u016Bd\u014D) Kimura Masahiko","source":"JDP-90","target":"JDP-89","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":null,"period":{"start":1925,"end":1930}}},{"data":{"id":"JDP58e89a1dcc7ea","name":"Funakoshi Gichin (Karate) Kimura Masahiko","source":"JDP-41","target":"JDP-89","interaction":"Karate","interaction_id":"JDP-S-5","interaction_native":{"name":"\u7A7A\u624B","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.bjjee.com/articles/my-judo-by-masahiko-kimura-his-story-vision-in-his-own-words-part-1/","cite":"\'My Judo\' by Masahiko Kimura, His Story & Vision in His Own Words Part 1 (BJJ EE)","citation":"Later on, I [ed. Kimura] got interested in karate, and learned Shorinji-ryu (Note: today\u2019s Shotokan karate) under the guidance of Master Funakoshi for a little over 2 years."}]}},{"data":{"id":"JDP29ad2ef85c53c","name":"Takahashi Kazuyoshi (K\u014Dd\u014Dkan J\u016Bd\u014D) Kawaishi Mikinosuke","source":"JDP-14","target":"JDP-13","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Waseda University","quality":null,"period":{"start":1881,"end":null}}},{"data":{"id":"JDP4703ec6c8cc04","name":"Fukuda Hachinosuke (Tenjin Shin\'y\u014D-ry\u016B) Kan\u014D Jigor\u014D","source":"JDP-2","target":"JDP-1","interaction":"Tenjin Shin\'y\u014D-ry\u016B","interaction_id":"JDP-S-3","interaction_native":{"name":"\u5929\u795E\u771F\u694A\u6D41","lang":"ja"},"place":"Fukuda Hachinosuke dojo","quality":3,"period":{"start":1877,"end":1879}}},{"data":{"id":"JDPefc9b502ce81a","name":"Iso Masatomo (Tenjin Shin\'y\u014D-ry\u016B) Kan\u014D Jigor\u014D","source":"JDP-4","target":"JDP-1","interaction":"Tenjin Shin\'y\u014D-ry\u016B","interaction_id":"JDP-S-3","interaction_native":{"name":"\u5929\u795E\u771F\u694A\u6D41","lang":"ja"},"place":"Iso Masatomo dojo","quality":3,"period":{"start":1879,"end":1881}}},{"data":{"id":"JDP0ee1d74c57b4f","name":"Iikubo Tsunetoshi (Kit\u014D-ry\u016B) Kan\u014D Jigor\u014D","source":"JDP-5","target":"JDP-1","interaction":"Kit\u014D-ry\u016B","interaction_id":"JDP-S-2","interaction_native":{"name":"\u8D77\u5012\u6D41","lang":"ja"},"place":"Eish\u014Dji","quality":3,"period":{"start":1881,"end":null}}},{"data":{"id":"JDP8a5e44d6ecac1","name":"Oshima Masateru (Yagy\u016B Shingan-ry\u016B) Kan\u014D Jigor\u014D","source":"JDP-46","target":"JDP-1","interaction":"Yagy\u016B Shingan-ry\u016B","interaction_id":"JDP-S-11","interaction_native":{"name":"\u67F3\u751F\u5FC3\u773C\u6D41","lang":"ja"},"place":null,"quality":1,"period":{"start":1881,"end":null},"sources":[{"uri":"https://kanochronicles.com/the-kodokan-and-bojutsu-jo-staff-fighting-and-judo/","citation":"When I was young, I practiced Yagy\u016B-ry\u016B b\u014Djutsu with a man named Oshima. As my practice of this discipline had not reached the level of shugy\u014D (NOTE: dedicated, austere study), usually I do not mention it. However, since then I thought there was value in b\u014Djutsu shugy\u014D"}]}},{"data":{"id":"JDPfb2eacff22fa3","name":"Matsumura S\u014Dkon (Shuri-te) Itosu Ank\u014D","source":"JDP-54","target":"JDP-55","interaction":"Shuri-te","interaction_id":"JDP-S-13","interaction_native":{"name":"\u9996\u91CC\u624B","lang":"ja"},"place":null,"quality":1,"period":{"start":null,"end":null},"sources":[{"uri":"https://en.wikipedia.org/wiki/Ank%C5%8D_Asato","citation":"In a 1934 article, Funakoshi noted that Asato and Itosu had studied karate together under S\u014Dkon Matsumura."}]}},{"data":{"id":"JDP8f1045fcc12aa","name":"Kan\u014D Jigor\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) It\u014D Tokugor\u014D","source":"JDP-1","target":"JDP-104","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.city.daisen.lg.jp/docs/2013110800147/file_contents/3.pdf","cite":"Cosmos, Daisen City Lifelong Learning Information Magazine, No. 3 , Daisen City Lifelong Learning Promotion Headquarters, December 15, 2008","location":"pp. 31-32"},{"uri":"https://ja.wikipedia.org/wiki/%E4%BC%8A%E8%97%A4%E5%BE%B3%E4%BA%94%E9%83%8E","citation":"\u4E2D\u9000\u5F8C\u306F\u8B1B\u9053\u9928\u3067\u5609\u7D0D\u6CBB\u4E94\u90CE\u9580\u4E0B\u3068\u306A\u3063\u3066\u78EF\u8C9D\u4E00\u30FB\u5FB3\u4E09\u5B9D\u30FB\u4E09\u8239\u4E45\u8535\u3089\u3068\u5171\u306B\u67D4\u9053\u306B\u52B1\u3093\u3060"}]}},{"data":{"id":"JDP783b3c180bde4","name":"Yokoyama Sakujiro (K\u014Dd\u014Dkan J\u016Bd\u014D) Isogai Hajime","source":"JDP-9","target":"JDP-43","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":null,"period":{"start":1891,"end":null}}},{"data":{"id":"JDPd3dc0449ee0c4","name":"Iso Masatari Mataemon (Tenjin Shin\'y\u014D-ry\u016B) Iso Masatomo","source":"JDP-3","target":"JDP-4","interaction":"Tenjin Shin\'y\u014D-ry\u016B","interaction_id":"JDP-S-3","interaction_native":{"name":"\u5929\u795E\u771F\u694A\u6D41","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null}}},{"data":{"id":"JDP705fe1b771184","name":"Iso Masatari Mataemon (Tenjin Shin\'y\u014D-ry\u016B) Inoe Keitaro","source":"JDP-3","target":"JDP-10","interaction":"Tenjin Shin\'y\u014D-ry\u016B","interaction_id":"JDP-S-3","interaction_native":{"name":"\u5929\u795E\u771F\u694A\u6D41","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null}}},{"data":{"id":"JDPc0bd4ac67dfdc","name":"Yokoyama Sakujiro (K\u014Dd\u014Dkan J\u016Bd\u014D) Iizuka Kunisabur\u014D","source":"JDP-9","target":"JDP-31","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":null,"period":{"start":1891,"end":null}}},{"data":{"id":"JDPed90e4bae42f1","name":"Takenaka Tetsunosuke Issei (Kit\u014D-ry\u016B) Iikubo Tsunetoshi","source":"JDP-6","target":"JDP-5","interaction":"Kit\u014D-ry\u016B","interaction_id":"JDP-S-2","interaction_native":{"name":"\u8D77\u5012\u6D41","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null}}},{"data":{"id":"JDP9debf9618c836","name":"Ushijima Tatsukuma (K\u014Dd\u014Dkan J\u016Bd\u014D) Hirano Tokio","source":"JDP-90","target":"JDP-91","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Bud\u014D Senmon Gakko","quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.researchgate.net/publication/263087428_Nanatsu-no-kata_Endo-no-kata_and_Joge-no-kata_-A_pedagogical_and_qualitative_biomechanical_evaluation_of_Hirano_Tokio\'s_kuzushi_unbalancing_concept_as_part_of_skill_acquisition_for_throwing_techniques","cite":"De Cr\xe9e, Carl. (2014). Nanatsu-no-kata, End\u014D-no-kata, and J\u014Dge-no-kata \u2015A pedagogical and qualitative biomechanical evaluation of Hirano Tokio\u2019s kuzushi (unbalancing) concept as part of skill acquisition for throwing techniques in K\u014Dd\u014Dkan j\u016Bd\u014D. Revista de Artes Marciales Asi\xe1ticas. 9. 69-96. 10.18002/rama.v9i2.1162.","citation":"While still at Ky\u014Dto, Hirano later also became an uchi deshi to Ushijima Tatsukuma"}]}},{"data":{"id":"JDP2bbc7cb78eb2e","name":"Hayashi Sakuichiro (Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B) Hayashi Yazaemon","source":"JDP-114","target":"JDP-113","interaction":"Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B","interaction_id":"JDP-S-6","interaction_native":{"name":"\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41","lang":"ja"},"place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/","cite":"Exkurs: Die moderne Geschichte der Katori Shint\xf4 ry\xfb (Ein Leben f\xfcr die Schwertkunst)","citation":"Iisasa Morisada (sieben direkte Sch\xfcler): Yamaguchi Kumajir\xf4 Eikan Mairaku / Tamai Said\xf4 / Noguchi Jizaemon / Ono Heishichir\xf4 Moriichi / Shiina Ichiz\xf4 / Hong\xfb Toranosuke / Kaneko Shinosh\xf4 (...) Hayashi Saiichir\xf4 \u2013> Hayashi Yazaemon \u2013> \xd4take Risuke"},{"uri":"https://shinbukan-katorishintoryu.org/?page_id=898&lang=en","cite":"Tenshinsho-den Katori Shinto Ryu - Shinbukan Dojo","citation":"Shinbukan Dojo\u2019s practice of Katori Shinto Ryu follows the teachings passed down from Hayashi Sakuichiro Shihan to Hayashi Yazaemon Shihan, who was then succeeded by Otake Risuke Shihan (Shinbukan Dojo founder)."}]}},{"data":{"id":"JDP85b53467c5d52","name":"Kumajiro Yamaguchi (Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B) Hayashi Sakuichiro","source":"JDP-115","target":"JDP-114","interaction":"Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B","interaction_id":"JDP-S-6","interaction_native":{"name":"\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41","lang":"ja"},"place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/","cite":"Exkurs: Die moderne Geschichte der Katori Shint\xf4 ry\xfb (Ein Leben f\xfcr die Schwertkunst)","citation":"Iisasa Morisada (sieben direkte Sch\xfcler): Yamaguchi Kumajir\xf4 Eikan Mairaku / Tamai Said\xf4 / Noguchi Jizaemon / Ono Heishichir\xf4 Moriichi / Shiina Ichiz\xf4 / Hong\xfb Toranosuke / Kaneko Shinosh\xf4 (...) Hayashi Saiichir\xf4 \u2013> Hayashi Yazaemon \u2013> \xd4take Risuke"},{"uri":"https://shinbukan-katorishintoryu.org/?page_id=898&lang=en","cite":"Tenshinsho-den Katori Shinto Ryu - Shinbukan Dojo","citation":"Shinbukan Dojo\u2019s practice of Katori Shinto Ryu follows the teachings passed down from Hayashi Sakuichiro Shihan to Hayashi Yazaemon Shihan, who was then succeeded by Otake Risuke Shihan (Shinbukan Dojo founder)."}]}},{"data":{"id":"JDP54ff77f5ecd","name":"Funakoshi Gichin (Karate) Funakoshi Gig\u014D","source":"JDP-41","target":"JDP-92","interaction":"Karate","interaction_id":"JDP-S-5","interaction_native":{"name":"\u7A7A\u624B","lang":"ja"},"place":null,"quality":2,"period":{"start":1918,"end":null},"sources":[{"uri":"https://en.wikipedia.org/wiki/Gig%C5%8D_Funakoshi","citation":"He was sickly as a child and began the formal study of karate-do at the age of twelve as a means to improve his health.[4] In the early years, Gichin Funakoshi often took Gigo with him to his trainings with Yasutsune Itosu"}]}},{"data":{"id":"JDP373d0fccee49d","name":"Asato Ank\u014D (Shuri-te) Funakoshi Gichin","source":"JDP-56","target":"JDP-41","interaction":"Shuri-te","interaction_id":"JDP-S-13","interaction_native":{"name":"\u9996\u91CC\u624B","lang":"ja"},"place":null,"quality":1,"period":{"start":null,"end":null},"sources":[{"uri":"https://en.wikipedia.org/wiki/Ank%C5%8D_Asato","citation":"Anko Asato (\u5B89\u91CC \u5B89\u6052, Asato Ank\u014D, Azato Yasutsune in Japanese, 1827 \u2013 1906) was a Ry\u016Bky\u016Ban master of karate. He and Ank\u014D Itosu were the two main karate masters who taught Gichin Funakoshi, the founder of Shotokan karate."}]}},{"data":{"id":"JDPbf8a11b890b0d","name":"Itosu Ank\u014D (Shuri-te) Funakoshi Gichin","source":"JDP-55","target":"JDP-41","interaction":"Shuri-te","interaction_id":"JDP-S-13","interaction_native":{"name":"\u9996\u91CC\u624B","lang":"ja"},"place":null,"quality":1,"period":{"start":null,"end":null},"sources":[{"uri":"https://en.wikipedia.org/wiki/Ank%C5%8D_Asato","citation":"Anko Asato (\u5B89\u91CC \u5B89\u6052, Asato Ank\u014D, Azato Yasutsune in Japanese, 1827 \u2013 1906) was a Ry\u016Bky\u016Ban master of karate. He and Ank\u014D Itosu were the two main karate masters who taught Gichin Funakoshi, the founder of Shotokan karate."}]}},{"data":{"id":"JDPd4c324b8e8fd7","name":"Kan\u014D Jigor\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Fukuda Keiko","source":"JDP-1","target":"JDP-57","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":3,"period":{"start":1935,"end":1966},"sources":[{"uri":"https://books.google.pt/books?id=fNYDAAAAMBAJ&pg=PA29","cite":"Johnson, G. (1974): \xabA single reed that bends gracefully in the wind.\xbb Black Belt, 12(6):28\u201333.","citation":"Keiko Fukuda is the granddaughter of Professor Jigoro Kano\'s first jujitsu instructor. She began studying the art at Professor Kano\'s request at age 21 and since that time has taught in Australia,Canada, the Philippines, the U.S. and, of course, the Kodokan where she has received all her promotions (...) In the Kodokan, sometimes we would sit around the mat with Professor Kano and just talk and ask questions so we would know what each other was thinking"}]}},{"data":{"id":"JDP3bea66a146cc6","name":"Mifune Ky\u016Bz\u014D (K\u014Dd\u014Dkan J\u016Bd\u014D) Fukuda Keiko","source":"JDP-11","target":"JDP-57","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":3,"period":{"start":1935,"end":1966},"sources":[{"uri":"https://books.google.pt/books?id=fNYDAAAAMBAJ&pg=PA29","cite":"Johnson, G. (1974): \xabA single reed that bends gracefully in the wind.\xbb Black Belt, 12(6):28\u201333.","citation":"Miss Fukuda, describing her training with the late Professor Kyuzo Mifune (10th dan) (...)"}]}},{"data":{"id":"JDP793c812c2b695","name":"Iso Masatomo (Tenjin Shin\'y\u014D-ry\u016B) Fukuda Hachinosuke","source":"JDP-4","target":"JDP-2","interaction":"Tenjin Shin\'y\u014D-ry\u016B","interaction_id":"JDP-S-3","interaction_native":{"name":"\u5929\u795E\u771F\u694A\u6D41","lang":"ja"},"place":"Otamagaike dojo","quality":null,"period":{"start":1851,"end":null}}},{"data":{"id":"JDP6bbe3a52d1f95","name":"Funakoshi Gichin (Karate) Egami Shigeru","source":"JDP-41","target":"JDP-93","interaction":"Karate","interaction_id":"JDP-S-5","interaction_native":{"name":"\u7A7A\u624B","lang":"ja"},"place":null,"quality":2,"period":{"start":1930,"end":null},"sources":[{"uri":"https://shotokai.com/shigeru-egami/","cite":"Master Shigeru Egami, O-sensei\u2019s successor (1912-1981) (Shotokai Encyclopedia)","citation":"Egami met Master Funakoshi when he was 18 years old, the moment he began studying at the famous Waseda University, there he helped to establish its Karate Do Club. (...)  He followed his Master together with Yoshitaka Funakoshi and Takeshi Shimoda all around Japan staging exhibitions, trying to expand the knowledge of Karate-do as a Japanese martial art."}]}},{"data":{"id":"JDP0e32b439600c3","name":"Matsumura S\u014Dkon (Shuri-te) Asato Ank\u014D","source":"JDP-54","target":"JDP-56","interaction":"Shuri-te","interaction_id":"JDP-S-13","interaction_native":{"name":"\u9996\u91CC\u624B","lang":"ja"},"place":null,"quality":1,"period":{"start":null,"end":null},"sources":[{"uri":"https://en.wikipedia.org/wiki/Ank%C5%8D_Asato","citation":"In a 1934 article, Funakoshi noted that Asato and Itosu had studied karate together under S\u014Dkon Matsumura."}]}},{"data":{"id":"JDPe614fb07308f5","name":"Ogawa Kinnosuke (Kendo) Abbe Kenshir\xf5","source":"JDP-59","target":"JDP-58","interaction":"Kendo","interaction_id":"JDP-S-8","interaction_native":{"name":"\u5263\u9053","lang":"ja"},"place":"Bud\u014D Senmon Gakko","quality":3,"period":{"start":1934,"end":1945},"sources":[{"uri":"https://web.archive.org/web/20090218133219/http://rrjudo.com/history/zenjudo.htm","cite":"Kenshiro Abbe, The Kyu-Shin-Do And Zen Judo - Keo Cavalcanti, 6th Dan Zen Judo","citation":"At the Busen Abbe received instruction from Ogawa Hanshi (genius), the Butokukai Judan (10th Dan) sword master. While at the Busen Kenshiro also enrolled in Mr. Gen Tanabe\'s philosophy class, at the Kyoto Teikoku University. That early encounter with philosophy would be influential in the formation of his system. While the training was arduous at the Busen, Kenshiro managed to receive his Yondan (4th Dan) rank in Judo, being again the young Judoka to attain it. His sister, Toyoka, decided to take Martial Arts too, enrolling in Mrs. Mitamura\'s Naginata class. She would dedicate the rest of her life to the practice of the art."}]}},{"data":{"id":"JDP918820f35c37c","name":"Ueshiba Morihei (Aikid\u014D) Abbe Kenshir\xf5","source":"JDP-27","target":"JDP-58","interaction":"Aikid\u014D","interaction_id":"JDP-S-4","interaction_native":{"name":"\u5408\u6C17\u9053","lang":"ja"},"place":null,"quality":3,"period":{"start":1937,"end":1947},"sources":[{"uri":"https://web.archive.org/web/20090218133219/http://rrjudo.com/history/zenjudo.htm","cite":"Kenshiro Abbe, The Kyu-Shin-Do And Zen Judo - Keo Cavalcanti, 6th Dan Zen Judo","citation":"In 1937, at the age of 23, Abbe was awarded his Rokudan (6th Dan) rank and in June of that year he enlisted in the Japanese army, serving for four years in a garrison in the Toan-sho Province in Manchuria. It was during the time in Manchuria that Abbe began formulating his theory of Budo (the Way of the Warrior), Kyu-Shin-Do. And it was also at this time that Abbe was invited by O\'Sensei, Morihei Ueshiba to study Aikido under his care."}]}},{"data":{"id":"JDP9f227fd17d3f9","name":"Kobayashi Kiyoshi (K\u014Dd\u014Dkan J\u016Bd\u014D) Frigyes T\u04E7r\u04E7k","source":"JDP-12","target":"JDP-69","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Judo Clube de Portugal","quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf","cite":"Manual de Gradua\xe7\xf5es e Regulamento de Gradua\xe7\xf5es. Federa\xe7\xe3o Portuguesa de Judo (Dezembro 2020)","citation":"Em 1974, o ent\xe3o presidente da Federa\xe7\xe3o Portuguesa de Judo, Prof. Fernando Costa Matos, sabendo da inten\xe7\xe3o do Mestre Frigyes T\u04E7r\u04E7k, 3\xba Dan, de regressar a Portugal, vindo de Angola onde lecionava, colocou em contacto este professor de ascend\xeancia h\xfangara e disc\xedpulo direto do Mestre Kiyoshi Kobayashi, com a Dire\xe7\xe3o do Clube. "}]}},{"data":{"id":"JDPd72347b3123fc","name":"Oda Tsunetane (K\u014Dd\u014Dkan J\u016Bd\u014D) Yves Klein","source":"JDP-124","target":"JDP-125","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Kodokan","quality":3,"period":{"start":"1952","end":"1954"},"sources":[{"uri":"https://theeverydaypress.net/the-foundations-of-judo/","cite":"THE FOUNDATIONS OF JUDO - The Everyday Press","citation":"In the early 1950s, the 24-year-old Yves Klein spent a year and a half in Tokyo, studying mainly at the Kodokan under the ninth-dan judo master Oda"}]}},{"data":{"id":"JDPa7f0240d422f1","name":"Oda Tsunetane (K\u014Dd\u014Dkan J\u016Bd\u014D) Yves Klein","source":"JDP-124","target":"JDP-125","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Municipal Police of Tokyo","quality":2,"period":{"start":"1952","end":"1954"},"sources":[{"uri":"https://www.ianwhittlesea.net/works_pages/wks_klein/wks_klein1.html","cite":"The Foundations of Judo - Ian Whittlesea","citation":"He has spent this time solely studying Judo... with the Municipal Police of Tokyo under Master Oda"}]}},{"data":{"id":"JDPf57a39eb14005","name":"Erich Rahn (J\u016Bjutsu) Alfred Rhode","source":"JDP-109","target":"JDP-110","interaction":"J\u016Bjutsu","interaction_id":"JDP-S-14","interaction_native":{"name":"\u67D4\u8853","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://books.google.de/books?id=Oa8Cdh9UVrIC","cite":"WEDEMEYER-KOLWE, Bernd. \xabDer neue Mensch\xbb: K\xf6rperkultur im Kaiserreich und in der Weimarer Republik. K\xf6nigshausen & Neumann, 2004, p. 308","citation":"(...) 1922 gr\xfcndete der Rahn-Sch\xfcler Alfred Rohde dann den 1. Deutschen Judo-Club in Frankfur (...)"},{"uri":"https://link.springer.com/chapter/10.1057/9781137573971_6","cite":"PANZER, Sarah. When Jiu-Jitsu was German: Japanese Martial Arts in German Sport-and K\xf6rperkultur, 1905\u20131933. In: Transnational Encounters between Germany and Japan: Perceptions of Partnership in the Nineteenth and Twentieth Centuries. New York: Palgrave Macmillan US, 2016. p. 91-106.","citation":"The first German judo club was formed in 1922 in Frankfurt by Alfred Rhode, a former student of Erich Rahn. For several years, jiu-jitsu and judo coexisted relatively collegially in Germany, most likely because the still relatively small community of instructors and active participants made cooperation necessary if either discipline was to survive"}]}},{"data":{"id":"JDP91b60386786e3","name":"Zhang Zhaodong (Baguazhang) Wang Shujin","source":"JDP-118","target":"JDP-117","interaction":"Baguazhang","interaction_id":"JDP-S-17","interaction_native":{"name":"\u516B\u5366\u638C","lang":"cn"},"place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.taipeitimes.com/News/feat/archives/2002/02/17/124274","cite":"Martial arts fight for survival (Taipei Times)","citation":" By chance one day, a senior student of the famous martial arts master Zhang Zhao-dong came to the business where Wang worked. (...)  Under Zhang\'s instruction, Wang learned the two arts for which he would later become famous; pa kua chang and hsing yi chuan. Pa kua chang means \\"eight diagram palms\\" and refers to the eight core diagrams which make up the I-Ching (\u6613\u7D93, Book of Changes), one of the most important books of classical Chinese philosophy"}]}},{"data":{"id":"JDP319734aab679","name":"Zhang Zhaodong (Xingyiquan) Wang Shujin","source":"JDP-118","target":"JDP-117","interaction":"Xingyiquan","interaction_id":"JDP-S-18","interaction_native":{"name":"\u5F62\u610F\u62F3","lang":"cn"},"place":null,"quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://www.taipeitimes.com/News/feat/archives/2002/02/17/124274","cite":"Martial arts fight for survival (Taipei Times)","citation":" By chance one day, a senior student of the famous martial arts master Zhang Zhao-dong came to the business where Wang worked. (...)  Under Zhang\'s instruction, Wang learned the two arts for which he would later become famous; pa kua chang and hsing yi chuan. Pa kua chang means \\"eight diagram palms\\" and refers to the eight core diagrams which make up the I-Ching (\u6613\u7D93, Book of Changes), one of the most important books of classical Chinese philosophy"}]}},{"data":{"id":"JDPbf62c63e87421","name":"Augusto de Oliveira Cordeiro (K\u014Dd\u014Dkan J\u016Bd\u014D) Petrucio Monteiro","source":"JDP-127","target":"JDP-128","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Academia Rudolf Hermanny","quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://benfeitoria.com/projeto/biopetrucio","cite":"Biografia Petrucio Monteiro - Benfeitoria","citation":"O professor Petrucio seguiu a linha do professor Rudolf Hermanny"}]}},{"data":{"id":"JDPee7f40c115ea","name":"H\xe9lio Gracie (Brazilian jiu-jitsu) Pedro Valente Sr.","source":"JDP-102","target":"JDP-134","interaction":"Brazilian jiu-jitsu","interaction_id":"JDP-S-16","interaction_native":{"name":"Jiu-Jitsu brasileiro","lang":"pt"},"place":"Academia Gracie, Rio de Janeiro","quality":3,"period":{"start":"1951","end":null},"sources":[{"uri":"https://www.graciemag.com/interview-with-red-belt-pedro-valente-sr/","cite":"Interview with red-belt Pedro Valente Sr. - GracieMag","citation":"My father took me to the Gracie Academy in downtown Rio back in the 50\u2019s. I was 13 then and started to learn Jiu-Jitsu. Later on I participated at some fights at Maracan\xe3zinho"}]}},{"data":{"id":"JDP247680ead65d4","name":"Pedro Valente Sr. (Brazilian jiu-jitsu) Pedro Valente","source":"JDP-134","target":"JDP-135","interaction":"Brazilian jiu-jitsu","interaction_id":"JDP-S-16","interaction_native":{"name":"Jiu-Jitsu brasileiro","lang":"pt"},"place":null,"quality":3,"period":{"start":null,"end":null},"sources":[{"uri":"https://valentebrothers.com/our-story/","cite":"Valente Brothers: Our Story","citation":"Pedro Valente Sr. taught his sons Pedro, Gui, and Joaquim the art of Gracie Jiu-Jitsu"}]}},{"data":{"id":"JDP462767185d847","name":"Luis de Fran\xe7a Filho (Brazilian jiu-jitsu) Oswaldo Fadda","source":"JDP-20","target":"JDP-106","interaction":"Brazilian jiu-jitsu","interaction_id":"JDP-S-16","interaction_native":{"name":"Jiu-Jitsu brasileiro","lang":"pt"},"place":"Academia Fran\xe7a de Jiu-jitsu","quality":3,"period":{"start":1938,"end":null},"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 108","citation":"Oswaldo Fadda come\xe7ou a treinar com Fran\xe7a por volta de 1938"}]}},{"data":{"id":"JDP4422a44ce6e5","name":"Balthazar Cardoso (Boxing) Oswaldo Fadda","source":"JDP-129","target":"JDP-106","interaction":"Boxing","interaction_id":"JDP-S-19","place":"Liga de Esportes da Marinha","quality":3,"period":{"start":1938,"end":null},"sources":[{"uri":"https://www.faddabjj.com/historia-fadda","cite":"A hist\xf3ria da Fam\xedlia Fadda (FaddaBJJ)","citation":"Antes da sua hist\xf3ria com o Jiu-Jitsu, os primeiros passos de Fadda no mundo das lutas foi na \\"Nobre Arte\\", ou seja, no boxe, atrav\xe9s do campe\xe3o Baltazar Cardoso."}]}},{"data":{"id":"JDPd390f7a32a6bc","name":"Maeda Mitsuyo (K\u014Dd\u014Dkan J\u016Bd\u014D) Mario Aleixo","source":"JDP-18","target":"JDP-45","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":3,"period":{"start":1915,"end":null},"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 1, p. 110","citation":"M\xe1rio Alexio teve o privil\xe9gio de se adestrar no Jiu Jitsu com dois dos mais experientes e famosos mestres japoneses dos ringues. Recebeu suas primeiras instru\xe7\xf5es de Sada Miyako por volta de 1909. Posteriormente teve a oportunidade de se aperfei\xe7oar com o grande Conde Koma, pouco depois deste chegar ao Brasil, em 1915."}]}},{"data":{"id":"JDP19bf011c1a323","name":"Miyako Sada (K\u014Dd\u014Dkan J\u016Bd\u014D) Mario Aleixo","source":"JDP-107","target":"JDP-45","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":3,"period":{"start":1909,"end":null},"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 1, p. 110","citation":"M\xe1rio Alexio teve o privil\xe9gio de se adestrar no Jiu Jitsu com dois dos mais experientes e famosos mestres japoneses dos ringues. Recebeu suas primeiras instru\xe7\xf5es de Sada Miyako por volta de 1909. Posteriormente teve a oportunidade de se aperfei\xe7oar com o grande Conde Koma, pouco depois deste chegar ao Brasil, em 1915."}]}},{"data":{"id":"JDPa34ff4d2c0cef","name":"Satake Soshihiro (K\u014Dd\u014Dkan J\u016Bd\u014D) Luis de Fran\xe7a Filho","source":"JDP-22","target":"JDP-20","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":1,"period":{"start":1916,"end":null},"sources":[{"uri":"https://www.bjjheroes.com/bjj-fighters/luiz-franca","cite":"BJJ Heroes: Luiz Fran\xe7a","citation":"There Satake settled for a while, opening his own academy in 1916, at the Atl\xe9tico Clube Rio Negro, becoming the first Japanese to open a Judo/Jiu Jitsu academy in Brazil. This gym became the place where Luiz Fran\xe7a started his life as a martial artist. Satake would also become a Brazilian citizen years later, and change his name to Ant\xf4nio Soshihiro Satake."},{"uri":"https://www.facebook.com/photo.php?fbid=543032192445535&id=455479647867457&set=a.455593414522747","cite":"Equipe Fadda Jiu-Jitsu (Facebook)","citation":"Antigo aluno de Soishiro Satake e Mitsuyo Maeda, Luiz Fran\xe7a foi o fundador da linhagem (n\xe3o pertencente \xe0 fam\xedlia Gracie) de mais sucesso no Jiu-Jitsu, uma linhagem continuada especialmente atrav\xe9s do trabalho efetuado pelo mais proeminente e capaz aluno de Fran\xe7a, o Mestre Oswaldo Fadda, que mais tarde formaria a sua pr\xf3pria escola de talentosos alunos."}]}},{"data":{"id":"JDP426fcff13eced","name":"Maeda Mitsuyo (K\u014Dd\u014Dkan J\u016Bd\u014D) Luis de Fran\xe7a Filho","source":"JDP-18","target":"JDP-20","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Bel\xe9m","quality":2,"period":{"start":1929,"end":null},"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 106","citation":"Se Fran\xe7a se iniciou no Jiu Jitsu com o Conde Koma, muito provavelmente foi em 1929 n Marinha, quando esteve em Bel\xe9m ao servi\xe7o no navio Minas Gerais."}]}},{"data":{"id":"JDPae0d5a9e5a227","name":"Geo Omori (K\u014Dd\u014Dkan J\u016Bd\u014D) Luis de Fran\xe7a Filho","source":"JDP-103","target":"JDP-20","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Rio de Janeiro","quality":2,"period":{"start":1930,"end":null},"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 106","citation":"Posteriormente, deu continuidade ao seu aprendizado no Rio de Janeiro com Geo Omori, Takeo Yano e H\xe9lio Gracie..."}]}},{"data":{"id":"JDP64b0a311a480c","name":"H\xe9lio Gracie (Brazilian jiu-jitsu) Luis de Fran\xe7a Filho","source":"JDP-102","target":"JDP-20","interaction":"Brazilian jiu-jitsu","interaction_id":"JDP-S-16","interaction_native":{"name":"Jiu-Jitsu brasileiro","lang":"pt"},"place":"Rio de Janeiro","quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 106","citation":"Posteriormente, deu continuidade ao seu aprendizado no Rio de Janeiro com Geo Omori, Takeo Yano e H\xe9lio Gracie..."}]}},{"data":{"id":"JDP30a02bf43b6e7","name":"Balthazar Cardoso (Boxing) Luis de Fran\xe7a Filho","source":"JDP-129","target":"JDP-20","interaction":"Boxing","interaction_id":"JDP-S-19","place":"Liga de Esportes da Marinha","quality":2,"period":{"start":1928,"end":null},"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","citation":"Foi na Marinha, em 1928, que Fran\xe7a se iniciou nas artes marciais. Primeiro com o Boxe, sob a orienta\xe7\xe3o de Balthazar Cardoso"}]}},{"data":{"id":"JDP0b7868bed194b","name":"Maeda Mitsuyo (K\u014Dd\u014Dkan J\u016Bd\u014D) Jacinto Ferro","source":"JDP-18","target":"JDP-19","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":null,"period":{"start":1915,"end":null},"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 89","citation":"... Tenho [Maeda] os seguintes alunos aos quais deposito inteira confian\xe7a [...] Jacintho Ferro, Dr. Matheus Pereira, Guilherm de La Rocque, Raphael Gomes e Waldermar Gomes..."},{"uri":"https://judotradicionalgoshinjutsukan.blogspot.com/2009/08/mitsuyo-maeda-nasc.html","cite":"Mitsuyo Maeda e o Jud\xf4 Kodokan (Judo Tradicional Goshinjutsukan)","citation":"as aulas eram dadas em uma academia que Maeda abriu em 1916,nos sal\xf5es do Cine Teatro Moderno, localizado ao lado da Igreja de Nazar\xe9, hoje uma pra\xe7a, as aulas eram amplamente divulgadas nos ornais para quem quisesse aprender pagando.O primeiro aluno de Maeda foi o estivador Jacinto Ferro, ex-lutador de greco-romana, Jacinto foi instrutor de Maeda e ajudou a dar aulas para o Carlos Gracie."}]}},{"data":{"id":"JDPd0c687d63db2e","name":"Carlos Gracie (Brazilian jiu-jitsu) H\xe9lio Gracie","source":"JDP-21","target":"JDP-102","interaction":"Brazilian jiu-jitsu","interaction_id":"JDP-S-16","interaction_native":{"name":"Jiu-Jitsu brasileiro","lang":"pt"},"place":null,"quality":null,"period":{"start":1925,"end":null},"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 165","citation":"... meu Jiu Jitsu era muito diferente do dele. O meu f\xf4ra aprendido h\xe1 muitos anos com o meu irm\xe3o Carlos..."},{"uri":"https://pt.wikipedia.org/wiki/H%C3%A9lio_Gracie","citation":"Observador, H\xe9lio passou a acompanhar, dos seus treze aos dezesseis anos, as aulas ministradas por Carlos."}]}},{"data":{"id":"JDP020361b37bc66","name":"Pedro Valente Sr. (Brazilian jiu-jitsu) Pedro Valente","source":"JDP-134","target":"JDP-136","interaction":"Brazilian jiu-jitsu","interaction_id":"JDP-S-16","interaction_native":{"name":"Jiu-Jitsu brasileiro","lang":"pt"},"place":null,"quality":3,"period":{"start":null,"end":null},"sources":[{"uri":"https://valentebrothers.com/our-story/","cite":"Valente Brothers: Our Story","citation":"Pedro Valente Sr. taught his sons Pedro, Gui, and Joaquim the art of Gracie Jiu-Jitsu"}]}},{"data":{"id":"JDP8b37d8b3e4af6","name":"Carlos Gracie (K\u014Dd\u014Dkan J\u016Bd\u014D) George Gracie","source":"JDP-21","target":"JDP-108","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":null,"period":{"start":null,"end":null},"sources":[{"uri":"https://judotradicionalgoshinjutsukan.blogspot.com/2010/01/topico-bubishi.html","cite":"T\xf3pico Bubishi (Judo Tradicional Goshinjutsukan)","citation":"...O que sabemos de fato \xe9 que, Maeda ensinou Jud\xf4 a Carlos Gracie em virtude da afinidade com seu pai, Gast\xe3o Gracie. Carlos por sua vez ensinou a seus demais irm\xe3os, em especial a H\xe9lio Gracie. Neste ponto surgem duas teorias. A primeira alega que Maeda ensinou somente o jud\xf4 de Jigoro Kano a Carlos, e esse o repassou a H\xe9lio, que era o mais franzino dos Gracie, adaptando-o com grande enfoque no Ne-waza - t\xe9cnicas de solo do jud\xf4, ponto central do Gracie jiu-jitsu ou brasilian jiu-jitsu. Para compensar seu biotipo, a partir dos ensinamentos de Carlos, H\xe9lio aprimorou a parte de solo pelo uso do dispositivo de alavanca, dando-lhe a for\xe7a extra que o mesmo n\xe3o dispunha. A segunda teoria, apoiada pelos Gracies, fala que Maeda era, tamb\xe9m, ex\xedmio praticante de Ju-jutsu tradicional e foi essa a arte que ensinou aos brasileiros. Por\xe9m, em uma recente entrevista, H\xe9lio Gracie afirma que \'Carlos lutava jud\xf4\', veja a entrevista http://www.youtube.com/watch?v=BG309oqVLb4"}]}},{"data":{"id":"JDP99959c2142c33","name":"Jacinto Ferro (K\u014Dd\u014Dkan J\u016Bd\u014D) Donato Pires dos Reis","source":"JDP-19","target":"JDP-23","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":null,"period":{"start":1920,"end":null},"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 94","citation":"...\'Oscar\' muito provavelmente se trata do nome de Carlos grafado equivocadamente (...) Na not\xedcia, \'Oscar Gracie\' e Donato s\xe3o apresentados como alunos do famoso esportista paraense Jacyntho Ferro, este sim, disc\xedpulo directo de Maeda..."}]}},{"data":{"id":"JDP883e313538f9a","name":"Jacinto Ferro (K\u014Dd\u014Dkan J\u016Bd\u014D) Carlos Gracie","source":"JDP-19","target":"JDP-21","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":null,"period":{"start":1916,"end":null},"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol. 3, p. 94","citation":"...\'Oscar\' muito provavelmente se trata do nome de Carlos grafado equivocadamente (...) Na not\xedcia, \'Oscar Gracie\' e Donato s\xe3o apresentados como alunos do famoso esportista paraense Jacyntho Ferro, este sim, disc\xedpulo directo de Maeda..."}]}},{"data":{"id":"JDP231a86656247","name":"Maeda Mitsuyo (K\u014Dd\u014Dkan J\u016Bd\u014D) Carlos Gracie","source":"JDP-18","target":"JDP-21","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Paysandu Sport Club","quality":null,"period":{"start":1916,"end":null},"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol 3, p.91","citation":"...chefiada pelo competentissimo prof. Conde Koma. Aqui, depois de algumas demosntra\xe7\xf5es, organisou um gymnasio e eu [Carlos] fui um dos primeiros alunos [...] h\xe1 registos que Maeda deu aulas, em 1916, no Paysandu Sport Club, em Bel\xe9m, cidade onde Carlos residia com a sua fam\xedlia"},{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA, Elton; CORR\xcaA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.","location":"vol 3, p.93","citation":"Fui aluno do c\xe9lebre Conde Koma, no Par\xe1 [...] e nessa \xe9poca Carlos Gracia tamb\xe9m estava aprendendo"}]}},{"data":{"id":"JDP5ea71feb07fa4","name":"Maeda Mitsuyo (K\u014Dd\u014Dkan J\u016Bd\u014D) Aluizio de Melo","source":"JDP-18","target":"JDP-130","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":null,"quality":3,"period":{"start":"1915","end":null},"sources":[{"uri":"https://isbnsearch.org/isbn/9798639871030","cite":"SILVA & CORR\xcaA (2020). Muito antes do MMA","location":"vol. III, p. 111-113","citation":"aos 17 anos, teve a oportunidade de treinar Jiu Jitsu com o Conde Koma, durante a passagem da trupe japonesa pelo Nordeste do Brasil"},{"uri":"https://aratabajiujitsu.com.br/a-origem-dos-arataba/","cite":"A Origem dos Arataba (Arataba Jiu-Jitsu)","citation":"Todo mundo sabe que Mitsuyo Maeda, o Conde Koma, radicou-se no norte do Brasil por volta de 1913 e ensinou jiu-jitsu para diversas pessoas, dentre as quais posso citar Carlos Gracie, Luiz Fran\xe7a e Aluizio de Melo"},{"uri":"https://acervosvirtuais.ufpel.edu.br/museuvirtualdojudo/2022/07/academia-ruy-barbosa/","cite":"Doj\xf4 Professor Loanzi - Museu Virtual do Jud\xf4","citation":"QUEM FOI ALOIZIO NOGUEIRA BANDEIRA DE MELLO \u2013 PROF. LOANZI (...) Foi aluno do famoso Mitsuyo Moeda, Conde Koma, introdutor do jiu jitsu e do jud\xf4 no Brasil"}]}},{"data":{"id":"JDP90eecbdaa6d93","name":"Ogawa Ryuzo (K\u014Dd\u014Dkan J\u016Bd\u014D) Aluizio de Melo","source":"JDP-126","target":"JDP-130","interaction":"K\u014Dd\u014Dkan J\u016Bd\u014D","interaction_id":"JDP-S-1","interaction_native":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"place":"Budokan, S\xe3o Paulo","quality":2,"period":{"start":null,"end":null},"sources":[{"uri":"https://acervosvirtuais.ufpel.edu.br/museuvirtualdojudo/2022/07/academia-ruy-barbosa/","cite":"Doj\xf4 Professor Loanzi - Museu Virtual do Jud\xf4","citation":"Em 1959 contatou seu mestre e sensei, que lhe havia promovido \xe0 faixa preta sho-dan, Ryuzo Ogawa, de S\xe3o Paulo"}]}}]}}');


var $ef59b8cb902fcc5b$exports = {};
$ef59b8cb902fcc5b$exports = JSON.parse("{\"dbversion\":\"1ffcaa3 Sun Feb 1 07:22:12 2026 -0600\"}");


var $144986459bad920b$exports = {};
$144986459bad920b$exports = JSON.parse('{"Bud\u014D Lineage Tree":"\xc1rvore de artes marciais","Teachers":"Professores","Students":"Estudantes","Rank":"Gradua\xe7\xe3o","Sources":"Fontes","Tree":"\xc1rvore","Persons":"Pessoas","Styles":"Estilos","All Styles":"Todos os Estilos","Timeline":"Linha do Tempo"}');


var $41aa1533bd82fa0c$exports = {};
$41aa1533bd82fa0c$exports = JSON.parse('{"Bud\u014D Lineage Tree":"\u6B66\u9053\u306E\u7CFB\u8B5C","Teachers":"\u5148\u751F\u65B9","Students":"\u5F1F\u5B50","Rank":"\u9806\u4F4D","Sources":"\u60C5\u5831\u6E90","Tree":"\u7CFB\u8B5C","Persons":"\u6B66\u9053\u5BB6","Styles":"\u6D41\u5100","All Styles":"\u3059\u3079\u3066\u306E\u6D41\u5100","Timeline":"\u5E74\u8868","A timeline of Bud\u014Dka":"\u6B66\u9053\u5BB6\u306E\u5E74\u8868"}');


var $9ea14d8ba7454975$exports = {};
$9ea14d8ba7454975$exports = JSON.parse('{"Bud\u014D Lineage Tree":"Kampfk\xfcnste-Stammbaum","Teachers":"Lehrer","Students":"Studenten","Rank":"Grad","Sources":"Quellen","Tree":"Baum","Persons":"Personen","Styles":"Stile","All Styles":"Alle Stile","Timeline":"Zeitleiste"}');


var $cdc580e3bb72528f$exports = {};
$cdc580e3bb72528f$exports = JSON.parse('{"Bud\u014D Lineage Tree":"\u6B66\u672F\u5BB6\u8C31","Teachers":"\u6559\u5E08","Students":"\u5B66\u751F","Rank":"\u7B49\u7EA7","Sources":"\u6765\u6E90","Tree":"\u6765\u6E90","Persons":"\u4E2A\u4EBA","Styles":"\u6B66\u672F\u98CE\u683C","All Styles":"\u6B66\u672F\u98CE\u683C","Timeline":"\u65F6\u95F4\u7EBF","A timeline of Bud\u014Dka":"\u6B66\u672F\u65F6\u95F4\u7EBF"}');


/**
 * Copyright (c) 2016-2024, The Cytoscape Consortium.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the “Software”), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
 * of the Software, and to permit persons to whom the Software is furnished to do
 * so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ function $e815fda779bc047b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e815fda779bc047b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e815fda779bc047b$var$_typeof(obj);
}
function $e815fda779bc047b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e815fda779bc047b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e815fda779bc047b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e815fda779bc047b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e815fda779bc047b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e815fda779bc047b$var$_defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e815fda779bc047b$var$_slicedToArray(arr, i) {
    return $e815fda779bc047b$var$_arrayWithHoles(arr) || $e815fda779bc047b$var$_iterableToArrayLimit(arr, i) || $e815fda779bc047b$var$_unsupportedIterableToArray(arr, i) || $e815fda779bc047b$var$_nonIterableRest();
}
function $e815fda779bc047b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e815fda779bc047b$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e815fda779bc047b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e815fda779bc047b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e815fda779bc047b$var$_arrayLikeToArray(o, minLen);
}
function $e815fda779bc047b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e815fda779bc047b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e815fda779bc047b$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $e815fda779bc047b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(e) {
            didErr = true;
            err = e;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
var $e815fda779bc047b$var$_window = typeof window === 'undefined' ? null : window; // eslint-disable-line no-undef
var $e815fda779bc047b$var$navigator = $e815fda779bc047b$var$_window ? $e815fda779bc047b$var$_window.navigator : null;
$e815fda779bc047b$var$_window && $e815fda779bc047b$var$_window.document;
var $e815fda779bc047b$var$typeofstr = $e815fda779bc047b$var$_typeof('');
var $e815fda779bc047b$var$typeofobj = $e815fda779bc047b$var$_typeof({});
var $e815fda779bc047b$var$typeoffn = $e815fda779bc047b$var$_typeof(function() {});
var $e815fda779bc047b$var$typeofhtmlele = typeof HTMLElement === "undefined" ? "undefined" : $e815fda779bc047b$var$_typeof(HTMLElement);
var $e815fda779bc047b$var$instanceStr = function instanceStr(obj) {
    return obj && obj.instanceString && $e815fda779bc047b$var$fn$6(obj.instanceString) ? obj.instanceString() : null;
};
var $e815fda779bc047b$var$string = function string(obj) {
    return obj != null && $e815fda779bc047b$var$_typeof(obj) == $e815fda779bc047b$var$typeofstr;
};
var $e815fda779bc047b$var$fn$6 = function fn(obj) {
    return obj != null && $e815fda779bc047b$var$_typeof(obj) === $e815fda779bc047b$var$typeoffn;
};
var $e815fda779bc047b$var$array = function array(obj) {
    return !$e815fda779bc047b$var$elementOrCollection(obj) && (Array.isArray ? Array.isArray(obj) : obj != null && obj instanceof Array);
};
var $e815fda779bc047b$var$plainObject = function plainObject(obj) {
    return obj != null && $e815fda779bc047b$var$_typeof(obj) === $e815fda779bc047b$var$typeofobj && !$e815fda779bc047b$var$array(obj) && obj.constructor === Object;
};
var $e815fda779bc047b$var$object = function object(obj) {
    return obj != null && $e815fda779bc047b$var$_typeof(obj) === $e815fda779bc047b$var$typeofobj;
};
var $e815fda779bc047b$var$number$1 = function number(obj) {
    return obj != null && $e815fda779bc047b$var$_typeof(obj) === $e815fda779bc047b$var$_typeof(1) && !isNaN(obj);
};
var $e815fda779bc047b$var$integer = function integer(obj) {
    return $e815fda779bc047b$var$number$1(obj) && Math.floor(obj) === obj;
};
var $e815fda779bc047b$var$htmlElement = function htmlElement(obj) {
    if ('undefined' === $e815fda779bc047b$var$typeofhtmlele) return undefined;
    else return null != obj && obj instanceof HTMLElement;
};
var $e815fda779bc047b$var$elementOrCollection = function elementOrCollection(obj) {
    return $e815fda779bc047b$var$element(obj) || $e815fda779bc047b$var$collection(obj);
};
var $e815fda779bc047b$var$element = function element(obj) {
    return $e815fda779bc047b$var$instanceStr(obj) === 'collection' && obj._private.single;
};
var $e815fda779bc047b$var$collection = function collection(obj) {
    return $e815fda779bc047b$var$instanceStr(obj) === 'collection' && !obj._private.single;
};
var $e815fda779bc047b$var$core = function core(obj) {
    return $e815fda779bc047b$var$instanceStr(obj) === 'core';
};
var $e815fda779bc047b$var$stylesheet = function stylesheet(obj) {
    return $e815fda779bc047b$var$instanceStr(obj) === 'stylesheet';
};
var $e815fda779bc047b$var$event = function event(obj) {
    return $e815fda779bc047b$var$instanceStr(obj) === 'event';
};
var $e815fda779bc047b$var$emptyString = function emptyString(obj) {
    if (obj === undefined || obj === null) // null is empty
    return true;
    else if (obj === '' || obj.match(/^\s+$/)) return true; // empty string is empty
    return false; // otherwise, we don't know what we've got
};
var $e815fda779bc047b$var$domElement = function domElement(obj) {
    if (typeof HTMLElement === 'undefined') return false; // we're not in a browser so it doesn't matter
    else return obj instanceof HTMLElement;
};
var $e815fda779bc047b$var$boundingBox = function boundingBox(obj) {
    return $e815fda779bc047b$var$plainObject(obj) && $e815fda779bc047b$var$number$1(obj.x1) && $e815fda779bc047b$var$number$1(obj.x2) && $e815fda779bc047b$var$number$1(obj.y1) && $e815fda779bc047b$var$number$1(obj.y2);
};
var $e815fda779bc047b$var$promise = function promise(obj) {
    return $e815fda779bc047b$var$object(obj) && $e815fda779bc047b$var$fn$6(obj.then);
};
var $e815fda779bc047b$var$ms = function ms() {
    return $e815fda779bc047b$var$navigator && $e815fda779bc047b$var$navigator.userAgent.match(/msie|trident|edge/i);
}; // probably a better way to detect this...
var $e815fda779bc047b$var$memoize$1 = function memoize(fn, keyFn) {
    if (!keyFn) keyFn = function keyFn() {
        if (arguments.length === 1) return arguments[0];
        else if (arguments.length === 0) return 'undefined';
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        return args.join('$');
    };
    var memoizedFn = function memoizedFn() {
        var self1 = this;
        var args = arguments;
        var ret;
        var k = keyFn.apply(self1, args);
        var cache = memoizedFn.cache;
        if (!(ret = cache[k])) ret = cache[k] = fn.apply(self1, args);
        return ret;
    };
    memoizedFn.cache = {};
    return memoizedFn;
};
var $e815fda779bc047b$var$camel2dash = $e815fda779bc047b$var$memoize$1(function(str) {
    return str.replace(/([A-Z])/g, function(v) {
        return '-' + v.toLowerCase();
    });
});
var $e815fda779bc047b$var$dash2camel = $e815fda779bc047b$var$memoize$1(function(str) {
    return str.replace(/(-\w)/g, function(v) {
        return v[1].toUpperCase();
    });
});
var $e815fda779bc047b$var$prependCamel = $e815fda779bc047b$var$memoize$1(function(prefix, str) {
    return prefix + str[0].toUpperCase() + str.substring(1);
}, function(prefix, str) {
    return prefix + '$' + str;
});
var $e815fda779bc047b$var$capitalize = function capitalize(str) {
    if ($e815fda779bc047b$var$emptyString(str)) return str;
    return str.charAt(0).toUpperCase() + str.substring(1);
};
var $e815fda779bc047b$var$number = '(?:[-+]?(?:(?:\\d+|\\d*\\.\\d+)(?:[Ee][+-]?\\d+)?))';
var $e815fda779bc047b$var$rgba = 'rgb[a]?\\((' + $e815fda779bc047b$var$number + '[%]?)\\s*,\\s*(' + $e815fda779bc047b$var$number + '[%]?)\\s*,\\s*(' + $e815fda779bc047b$var$number + '[%]?)(?:\\s*,\\s*(' + $e815fda779bc047b$var$number + '))?\\)';
var $e815fda779bc047b$var$rgbaNoBackRefs = 'rgb[a]?\\((?:' + $e815fda779bc047b$var$number + '[%]?)\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '[%]?)\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '[%]?)(?:\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '))?\\)';
var $e815fda779bc047b$var$hsla = 'hsl[a]?\\((' + $e815fda779bc047b$var$number + ')\\s*,\\s*(' + $e815fda779bc047b$var$number + '[%])\\s*,\\s*(' + $e815fda779bc047b$var$number + '[%])(?:\\s*,\\s*(' + $e815fda779bc047b$var$number + '))?\\)';
var $e815fda779bc047b$var$hslaNoBackRefs = 'hsl[a]?\\((?:' + $e815fda779bc047b$var$number + ')\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '[%])\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '[%])(?:\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '))?\\)';
var $e815fda779bc047b$var$hex3 = '\\#[0-9a-fA-F]{3}';
var $e815fda779bc047b$var$hex6 = '\\#[0-9a-fA-F]{6}';
var $e815fda779bc047b$var$ascending = function ascending(a, b) {
    if (a < b) return -1;
    else if (a > b) return 1;
    else return 0;
};
var $e815fda779bc047b$var$descending = function descending(a, b) {
    return -1 * $e815fda779bc047b$var$ascending(a, b);
};
var $e815fda779bc047b$var$extend = Object.assign != null ? Object.assign.bind(Object) : function(tgt) {
    var args = arguments;
    for(var i = 1; i < args.length; i++){
        var obj = args[i];
        if (obj == null) continue;
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; j++){
            var k = keys[j];
            tgt[k] = obj[k];
        }
    }
    return tgt;
};
// get [r, g, b] from #abc or #aabbcc
var $e815fda779bc047b$var$hex2tuple = function hex2tuple(hex) {
    if (!(hex.length === 4 || hex.length === 7) || hex[0] !== '#') return;
    var shortHex = hex.length === 4;
    var r, g, b;
    var base = 16;
    if (shortHex) {
        r = parseInt(hex[1] + hex[1], base);
        g = parseInt(hex[2] + hex[2], base);
        b = parseInt(hex[3] + hex[3], base);
    } else {
        r = parseInt(hex[1] + hex[2], base);
        g = parseInt(hex[3] + hex[4], base);
        b = parseInt(hex[5] + hex[6], base);
    }
    return [
        r,
        g,
        b
    ];
};
// get [r, g, b, a] from hsl(0, 0, 0) or hsla(0, 0, 0, 0)
var $e815fda779bc047b$var$hsl2tuple = function hsl2tuple(hsl) {
    var ret;
    var h, s, l, a, r, g, b;
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    var m1 = new RegExp('^' + $e815fda779bc047b$var$hsla + '$').exec(hsl);
    if (m1) {
        // get hue
        h = parseInt(m1[1]);
        if (h < 0) h = (360 - -1 * h % 360) % 360;
        else if (h > 360) h = h % 360;
        h /= 360; // normalise on [0, 1]
        s = parseFloat(m1[2]);
        if (s < 0 || s > 100) return;
         // saturation is [0, 100]
        s = s / 100; // normalise on [0, 1]
        l = parseFloat(m1[3]);
        if (l < 0 || l > 100) return;
         // lightness is [0, 100]
        l = l / 100; // normalise on [0, 1]
        a = m1[4];
        if (a !== undefined) {
            a = parseFloat(a);
            if (a < 0 || a > 1) return;
             // alpha is [0, 1]
        }
        // now, convert to rgb
        // code from http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript
        if (s === 0) r = g = b = Math.round(l * 255); // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = Math.round(255 * hue2rgb(p, q, h + 1 / 3));
            g = Math.round(255 * hue2rgb(p, q, h));
            b = Math.round(255 * hue2rgb(p, q, h - 1 / 3));
        }
        ret = [
            r,
            g,
            b,
            a
        ];
    }
    return ret;
};
// get [r, g, b, a] from rgb(0, 0, 0) or rgba(0, 0, 0, 0)
var $e815fda779bc047b$var$rgb2tuple = function rgb2tuple(rgb) {
    var ret;
    var m1 = new RegExp('^' + $e815fda779bc047b$var$rgba + '$').exec(rgb);
    if (m1) {
        ret = [];
        var isPct = [];
        for(var i = 1; i <= 3; i++){
            var channel = m1[i];
            if (channel[channel.length - 1] === '%') isPct[i] = true;
            channel = parseFloat(channel);
            if (isPct[i]) channel = channel / 100 * 255; // normalise to [0, 255]
            if (channel < 0 || channel > 255) return;
             // invalid channel value
            ret.push(Math.floor(channel));
        }
        var atLeastOneIsPct = isPct[1] || isPct[2] || isPct[3];
        var allArePct = isPct[1] && isPct[2] && isPct[3];
        if (atLeastOneIsPct && !allArePct) return;
         // must all be percent values if one is
        var alpha = m1[4];
        if (alpha !== undefined) {
            alpha = parseFloat(alpha);
            if (alpha < 0 || alpha > 1) return;
             // invalid alpha value
            ret.push(alpha);
        }
    }
    return ret;
};
var $e815fda779bc047b$var$colorname2tuple = function colorname2tuple(color) {
    return $e815fda779bc047b$var$colors[color.toLowerCase()];
};
var $e815fda779bc047b$var$color2tuple = function color2tuple(color) {
    return ($e815fda779bc047b$var$array(color) ? color : null) || $e815fda779bc047b$var$colorname2tuple(color) || $e815fda779bc047b$var$hex2tuple(color) || $e815fda779bc047b$var$rgb2tuple(color) || $e815fda779bc047b$var$hsl2tuple(color);
};
var $e815fda779bc047b$var$colors = {
    // special colour names
    transparent: [
        0,
        0,
        0,
        0
    ],
    // NB alpha === 0
    // regular colours
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    grey: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};
// sets the value in a map (map may not be built)
var $e815fda779bc047b$var$setMap = function setMap(options) {
    var obj = options.map;
    var keys = options.keys;
    var l = keys.length;
    for(var i = 0; i < l; i++){
        var key = keys[i];
        if ($e815fda779bc047b$var$plainObject(key)) throw Error('Tried to set map with object key');
        if (i < keys.length - 1) {
            // extend the map if necessary
            if (obj[key] == null) obj[key] = {};
            obj = obj[key];
        } else // set the value
        obj[key] = options.value;
    }
};
// gets the value in a map even if it's not built in places
var $e815fda779bc047b$var$getMap = function getMap(options) {
    var obj = options.map;
    var keys = options.keys;
    var l = keys.length;
    for(var i = 0; i < l; i++){
        var key = keys[i];
        if ($e815fda779bc047b$var$plainObject(key)) throw Error('Tried to get map with object key');
        obj = obj[key];
        if (obj == null) return obj;
    }
    return obj;
};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e815fda779bc047b$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $e815fda779bc047b$var$isObject_1 = $e815fda779bc047b$var$isObject;
var $e815fda779bc047b$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $e815fda779bc047b$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
/** Detect free variable `global` from Node.js. */ var $e815fda779bc047b$var$freeGlobal = typeof $e815fda779bc047b$var$commonjsGlobal == 'object' && $e815fda779bc047b$var$commonjsGlobal && $e815fda779bc047b$var$commonjsGlobal.Object === Object && $e815fda779bc047b$var$commonjsGlobal;
var $e815fda779bc047b$var$_freeGlobal = $e815fda779bc047b$var$freeGlobal;
/** Detect free variable `self`. */ var $e815fda779bc047b$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e815fda779bc047b$var$root = $e815fda779bc047b$var$_freeGlobal || $e815fda779bc047b$var$freeSelf || Function('return this')();
var $e815fda779bc047b$var$_root = $e815fda779bc047b$var$root;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $e815fda779bc047b$var$now = function() {
    return $e815fda779bc047b$var$_root.Date.now();
};
var $e815fda779bc047b$var$now_1 = $e815fda779bc047b$var$now;
/** Used to match a single whitespace character. */ var $e815fda779bc047b$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $e815fda779bc047b$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $e815fda779bc047b$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $e815fda779bc047b$var$_trimmedEndIndex = $e815fda779bc047b$var$trimmedEndIndex;
/** Used to match leading whitespace. */ var $e815fda779bc047b$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $e815fda779bc047b$var$baseTrim(string) {
    return string ? string.slice(0, $e815fda779bc047b$var$_trimmedEndIndex(string) + 1).replace($e815fda779bc047b$var$reTrimStart, '') : string;
}
var $e815fda779bc047b$var$_baseTrim = $e815fda779bc047b$var$baseTrim;
/** Built-in value references. */ var $e815fda779bc047b$var$Symbol$1 = $e815fda779bc047b$var$_root.Symbol;
var $e815fda779bc047b$var$_Symbol = $e815fda779bc047b$var$Symbol$1;
/** Used for built-in method references. */ var $e815fda779bc047b$var$objectProto$5 = Object.prototype;
/** Used to check objects for own properties. */ var $e815fda779bc047b$var$hasOwnProperty$4 = $e815fda779bc047b$var$objectProto$5.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e815fda779bc047b$var$nativeObjectToString$1 = $e815fda779bc047b$var$objectProto$5.toString;
/** Built-in value references. */ var $e815fda779bc047b$var$symToStringTag$1 = $e815fda779bc047b$var$_Symbol ? $e815fda779bc047b$var$_Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $e815fda779bc047b$var$getRawTag(value) {
    var isOwn = $e815fda779bc047b$var$hasOwnProperty$4.call(value, $e815fda779bc047b$var$symToStringTag$1), tag = value[$e815fda779bc047b$var$symToStringTag$1];
    try {
        value[$e815fda779bc047b$var$symToStringTag$1] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $e815fda779bc047b$var$nativeObjectToString$1.call(value);
    if (unmasked) {
        if (isOwn) value[$e815fda779bc047b$var$symToStringTag$1] = tag;
        else delete value[$e815fda779bc047b$var$symToStringTag$1];
    }
    return result;
}
var $e815fda779bc047b$var$_getRawTag = $e815fda779bc047b$var$getRawTag;
/** Used for built-in method references. */ var $e815fda779bc047b$var$objectProto$4 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e815fda779bc047b$var$nativeObjectToString = $e815fda779bc047b$var$objectProto$4.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $e815fda779bc047b$var$objectToString(value) {
    return $e815fda779bc047b$var$nativeObjectToString.call(value);
}
var $e815fda779bc047b$var$_objectToString = $e815fda779bc047b$var$objectToString;
/** `Object#toString` result references. */ var $e815fda779bc047b$var$nullTag = '[object Null]', $e815fda779bc047b$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $e815fda779bc047b$var$symToStringTag = $e815fda779bc047b$var$_Symbol ? $e815fda779bc047b$var$_Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $e815fda779bc047b$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $e815fda779bc047b$var$undefinedTag : $e815fda779bc047b$var$nullTag;
    return $e815fda779bc047b$var$symToStringTag && $e815fda779bc047b$var$symToStringTag in Object(value) ? $e815fda779bc047b$var$_getRawTag(value) : $e815fda779bc047b$var$_objectToString(value);
}
var $e815fda779bc047b$var$_baseGetTag = $e815fda779bc047b$var$baseGetTag;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $e815fda779bc047b$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $e815fda779bc047b$var$isObjectLike_1 = $e815fda779bc047b$var$isObjectLike;
/** `Object#toString` result references. */ var $e815fda779bc047b$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e815fda779bc047b$var$isSymbol(value) {
    return typeof value == 'symbol' || $e815fda779bc047b$var$isObjectLike_1(value) && $e815fda779bc047b$var$_baseGetTag(value) == $e815fda779bc047b$var$symbolTag;
}
var $e815fda779bc047b$var$isSymbol_1 = $e815fda779bc047b$var$isSymbol;
/** Used as references for various `Number` constants. */ var $e815fda779bc047b$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $e815fda779bc047b$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e815fda779bc047b$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e815fda779bc047b$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e815fda779bc047b$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e815fda779bc047b$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($e815fda779bc047b$var$isSymbol_1(value)) return $e815fda779bc047b$var$NAN;
    if ($e815fda779bc047b$var$isObject_1(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $e815fda779bc047b$var$isObject_1(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $e815fda779bc047b$var$_baseTrim(value);
    var isBinary = $e815fda779bc047b$var$reIsBinary.test(value);
    return isBinary || $e815fda779bc047b$var$reIsOctal.test(value) ? $e815fda779bc047b$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e815fda779bc047b$var$reIsBadHex.test(value) ? $e815fda779bc047b$var$NAN : +value;
}
var $e815fda779bc047b$var$toNumber_1 = $e815fda779bc047b$var$toNumber;
/** Error message constants. */ var $e815fda779bc047b$var$FUNC_ERROR_TEXT$1 = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e815fda779bc047b$var$nativeMax = Math.max, $e815fda779bc047b$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $e815fda779bc047b$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($e815fda779bc047b$var$FUNC_ERROR_TEXT$1);
    wait = $e815fda779bc047b$var$toNumber_1(wait) || 0;
    if ($e815fda779bc047b$var$isObject_1(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $e815fda779bc047b$var$nativeMax($e815fda779bc047b$var$toNumber_1(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $e815fda779bc047b$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $e815fda779bc047b$var$now_1();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($e815fda779bc047b$var$now_1());
    }
    function debounced() {
        var time = $e815fda779bc047b$var$now_1(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $e815fda779bc047b$var$debounce_1 = $e815fda779bc047b$var$debounce;
var $e815fda779bc047b$var$performance = $e815fda779bc047b$var$_window ? $e815fda779bc047b$var$_window.performance : null;
var $e815fda779bc047b$var$pnow = $e815fda779bc047b$var$performance && $e815fda779bc047b$var$performance.now ? function() {
    return $e815fda779bc047b$var$performance.now();
} : function() {
    return Date.now();
};
var $e815fda779bc047b$var$raf = function() {
    if ($e815fda779bc047b$var$_window) {
        if ($e815fda779bc047b$var$_window.requestAnimationFrame) return function(fn) {
            $e815fda779bc047b$var$_window.requestAnimationFrame(fn);
        };
        else if ($e815fda779bc047b$var$_window.mozRequestAnimationFrame) return function(fn) {
            $e815fda779bc047b$var$_window.mozRequestAnimationFrame(fn);
        };
        else if ($e815fda779bc047b$var$_window.webkitRequestAnimationFrame) return function(fn) {
            $e815fda779bc047b$var$_window.webkitRequestAnimationFrame(fn);
        };
        else if ($e815fda779bc047b$var$_window.msRequestAnimationFrame) return function(fn) {
            $e815fda779bc047b$var$_window.msRequestAnimationFrame(fn);
        };
    }
    return function(fn) {
        if (fn) setTimeout(function() {
            fn($e815fda779bc047b$var$pnow());
        }, 1000 / 60);
    };
}();
var $e815fda779bc047b$var$requestAnimationFrame = function requestAnimationFrame(fn) {
    return $e815fda779bc047b$var$raf(fn);
};
var $e815fda779bc047b$var$performanceNow = $e815fda779bc047b$var$pnow;
var $e815fda779bc047b$var$DEFAULT_HASH_SEED = 9261;
var $e815fda779bc047b$var$K = 65599; // 37 also works pretty well
var $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT = 5381;
var $e815fda779bc047b$var$hashIterableInts = function hashIterableInts(iterator) {
    var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e815fda779bc047b$var$DEFAULT_HASH_SEED;
    // sdbm/string-hash
    var hash = seed;
    var entry;
    for(;;){
        entry = iterator.next();
        if (entry.done) break;
        hash = hash * $e815fda779bc047b$var$K + entry.value | 0;
    }
    return hash;
};
var $e815fda779bc047b$var$hashInt = function hashInt(num) {
    var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e815fda779bc047b$var$DEFAULT_HASH_SEED;
    // sdbm/string-hash
    return seed * $e815fda779bc047b$var$K + num | 0;
};
var $e815fda779bc047b$var$hashIntAlt = function hashIntAlt(num) {
    var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT;
    // djb2/string-hash
    return (seed << 5) + seed + num | 0;
};
var $e815fda779bc047b$var$combineHashes = function combineHashes(hash1, hash2) {
    return hash1 * 0x200000 + hash2;
};
var $e815fda779bc047b$var$combineHashesArray = function combineHashesArray(hashes) {
    return hashes[0] * 0x200000 + hashes[1];
};
var $e815fda779bc047b$var$hashArrays = function hashArrays(hashes1, hashes2) {
    return [
        $e815fda779bc047b$var$hashInt(hashes1[0], hashes2[0]),
        $e815fda779bc047b$var$hashIntAlt(hashes1[1], hashes2[1])
    ];
};
var $e815fda779bc047b$var$hashIntsArray = function hashIntsArray(ints, seed) {
    var entry = {
        value: 0,
        done: false
    };
    var i = 0;
    var length = ints.length;
    var iterator = {
        next: function next() {
            if (i < length) entry.value = ints[i++];
            else entry.done = true;
            return entry;
        }
    };
    return $e815fda779bc047b$var$hashIterableInts(iterator, seed);
};
var $e815fda779bc047b$var$hashString = function hashString(str, seed) {
    var entry = {
        value: 0,
        done: false
    };
    var i = 0;
    var length = str.length;
    var iterator = {
        next: function next() {
            if (i < length) entry.value = str.charCodeAt(i++);
            else entry.done = true;
            return entry;
        }
    };
    return $e815fda779bc047b$var$hashIterableInts(iterator, seed);
};
var $e815fda779bc047b$var$hashStrings = function hashStrings() {
    return $e815fda779bc047b$var$hashStringsArray(arguments);
};
var $e815fda779bc047b$var$hashStringsArray = function hashStringsArray(strs) {
    var hash;
    for(var i = 0; i < strs.length; i++){
        var str = strs[i];
        if (i === 0) hash = $e815fda779bc047b$var$hashString(str);
        else hash = $e815fda779bc047b$var$hashString(str, hash);
    }
    return hash;
};
/*global console */ var $e815fda779bc047b$var$warningsEnabled = true;
var $e815fda779bc047b$var$warnSupported = console.warn != null; // eslint-disable-line no-console
var $e815fda779bc047b$var$traceSupported = console.trace != null; // eslint-disable-line no-console
var $e815fda779bc047b$var$MAX_INT$1 = Number.MAX_SAFE_INTEGER || 9007199254740991;
var $e815fda779bc047b$var$trueify = function trueify() {
    return true;
};
var $e815fda779bc047b$var$falsify = function falsify() {
    return false;
};
var $e815fda779bc047b$var$zeroify = function zeroify() {
    return 0;
};
var $e815fda779bc047b$var$noop$1 = function noop() {};
var $e815fda779bc047b$var$error = function error(msg) {
    throw new Error(msg);
};
var $e815fda779bc047b$var$warnings = function warnings(enabled) {
    if (enabled !== undefined) $e815fda779bc047b$var$warningsEnabled = !!enabled;
    else return $e815fda779bc047b$var$warningsEnabled;
};
var $e815fda779bc047b$var$warn = function warn(msg) {
    /* eslint-disable no-console */ if (!$e815fda779bc047b$var$warnings()) return;
    if ($e815fda779bc047b$var$warnSupported) console.warn(msg);
    else {
        console.log(msg);
        if ($e815fda779bc047b$var$traceSupported) console.trace();
    }
}; /* eslint-enable */ 
var $e815fda779bc047b$var$clone = function clone(obj) {
    return $e815fda779bc047b$var$extend({}, obj);
};
// gets a shallow copy of the argument
var $e815fda779bc047b$var$copy = function copy(obj) {
    if (obj == null) return obj;
    if ($e815fda779bc047b$var$array(obj)) return obj.slice();
    else if ($e815fda779bc047b$var$plainObject(obj)) return $e815fda779bc047b$var$clone(obj);
    else return obj;
};
var $e815fda779bc047b$var$copyArray$1 = function copyArray(arr) {
    return arr.slice();
};
var $e815fda779bc047b$var$uuid = function uuid(a, b /* placeholders */ ) {
    for(// loop :)
    b = a = ''; // b - result , a - numeric letiable
    a++ < 36; //
    b += a * 51 & 52 // if "a" is not 9 or 14 or 19 or 24
     ? //  return a random number or 4
    (a ^ 15 // if "a" is not 15
     ? // generate a random number from 0 to 15
    8 ^ Math.random() * (a ^ 20 ? 16 : 4 // unless "a" is 20, in which case a random number from 8 to 11
    ) : 4 //  otherwise 4
    ).toString(16) : '-' //  in other cases (if "a" is 9,14,19,24) insert "-"
    );
    return b;
};
var $e815fda779bc047b$var$_staticEmptyObject = {};
var $e815fda779bc047b$var$staticEmptyObject = function staticEmptyObject() {
    return $e815fda779bc047b$var$_staticEmptyObject;
};
var $e815fda779bc047b$var$defaults$g = function defaults(_defaults) {
    var keys = Object.keys(_defaults);
    return function(opts) {
        var filledOpts = {};
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var optVal = opts == null ? undefined : opts[key];
            filledOpts[key] = optVal === undefined ? _defaults[key] : optVal;
        }
        return filledOpts;
    };
};
var $e815fda779bc047b$var$removeFromArray = function removeFromArray(arr, ele, oneCopy) {
    for(var i = arr.length - 1; i >= 0; i--)if (arr[i] === ele) {
        arr.splice(i, 1);
        if (oneCopy) break;
    }
};
var $e815fda779bc047b$var$clearArray = function clearArray(arr) {
    arr.splice(0, arr.length);
};
var $e815fda779bc047b$var$push = function push(arr, otherArr) {
    for(var i = 0; i < otherArr.length; i++){
        var el = otherArr[i];
        arr.push(el);
    }
};
var $e815fda779bc047b$var$getPrefixedProperty = function getPrefixedProperty(obj, propName, prefix) {
    if (prefix) propName = $e815fda779bc047b$var$prependCamel(prefix, propName); // e.g. (labelWidth, source) => sourceLabelWidth
    return obj[propName];
};
var $e815fda779bc047b$var$setPrefixedProperty = function setPrefixedProperty(obj, propName, prefix, value) {
    if (prefix) propName = $e815fda779bc047b$var$prependCamel(prefix, propName); // e.g. (labelWidth, source) => sourceLabelWidth
    obj[propName] = value;
};
/* global Map */ var $e815fda779bc047b$var$ObjectMap = /*#__PURE__*/ function() {
    function ObjectMap() {
        $e815fda779bc047b$var$_classCallCheck(this, ObjectMap);
        this._obj = {};
    }
    $e815fda779bc047b$var$_createClass(ObjectMap, [
        {
            key: "set",
            value: function set(key, val) {
                this._obj[key] = val;
                return this;
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this._obj[key] = undefined;
                return this;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this._obj = {};
            }
        },
        {
            key: "has",
            value: function has(key) {
                return this._obj[key] !== undefined;
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this._obj[key];
            }
        }
    ]);
    return ObjectMap;
}();
var $e815fda779bc047b$var$Map$2 = typeof Map !== 'undefined' ? Map : $e815fda779bc047b$var$ObjectMap;
/* global Set */ var $e815fda779bc047b$var$undef = "undefined";
var $e815fda779bc047b$var$ObjectSet = /*#__PURE__*/ function() {
    function ObjectSet(arrayOrObjectSet) {
        $e815fda779bc047b$var$_classCallCheck(this, ObjectSet);
        this._obj = Object.create(null);
        this.size = 0;
        if (arrayOrObjectSet != null) {
            var arr;
            if (arrayOrObjectSet.instanceString != null && arrayOrObjectSet.instanceString() === this.instanceString()) arr = arrayOrObjectSet.toArray();
            else arr = arrayOrObjectSet;
            for(var i = 0; i < arr.length; i++)this.add(arr[i]);
        }
    }
    $e815fda779bc047b$var$_createClass(ObjectSet, [
        {
            key: "instanceString",
            value: function instanceString() {
                return 'set';
            }
        },
        {
            key: "add",
            value: function add(val) {
                var o = this._obj;
                if (o[val] !== 1) {
                    o[val] = 1;
                    this.size++;
                }
            }
        },
        {
            key: "delete",
            value: function _delete(val) {
                var o = this._obj;
                if (o[val] === 1) {
                    o[val] = 0;
                    this.size--;
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                this._obj = Object.create(null);
            }
        },
        {
            key: "has",
            value: function has(val) {
                return this._obj[val] === 1;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var _this = this;
                return Object.keys(this._obj).filter(function(key) {
                    return _this.has(key);
                });
            }
        },
        {
            key: "forEach",
            value: function forEach(callback, thisArg) {
                return this.toArray().forEach(callback, thisArg);
            }
        }
    ]);
    return ObjectSet;
}();
var $e815fda779bc047b$var$Set$1 = (typeof Set === "undefined" ? "undefined" : $e815fda779bc047b$var$_typeof(Set)) !== $e815fda779bc047b$var$undef ? Set : $e815fda779bc047b$var$ObjectSet;
// represents a node or an edge
var $e815fda779bc047b$var$Element = function Element(cy, params) {
    var restore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (cy === undefined || params === undefined || !$e815fda779bc047b$var$core(cy)) {
        $e815fda779bc047b$var$error('An element must have a core reference and parameters set');
        return;
    }
    var group = params.group;
    // try to automatically infer the group if unspecified
    if (group == null) {
        if (params.data && params.data.source != null && params.data.target != null) group = 'edges';
        else group = 'nodes';
    }
    // validate group
    if (group !== 'nodes' && group !== 'edges') {
        $e815fda779bc047b$var$error('An element must be of type `nodes` or `edges`; you specified `' + group + '`');
        return;
    }
    // make the element array-like, just like a collection
    this.length = 1;
    this[0] = this;
    // NOTE: when something is added here, add also to ele.json()
    var _p = this._private = {
        cy: cy,
        single: true,
        // indicates this is an element
        data: params.data || {},
        // data object
        position: params.position || {
            x: 0,
            y: 0
        },
        // (x, y) position pair
        autoWidth: undefined,
        // width and height of nodes calculated by the renderer when set to special 'auto' value
        autoHeight: undefined,
        autoPadding: undefined,
        compoundBoundsClean: false,
        // whether the compound dimensions need to be recalculated the next time dimensions are read
        listeners: [],
        // array of bound listeners
        group: group,
        // string; 'nodes' or 'edges'
        style: {},
        // properties as set by the style
        rstyle: {},
        // properties for style sent from the renderer to the core
        styleCxts: [],
        // applied style contexts from the styler
        styleKeys: {},
        // per-group keys of style property values
        removed: true,
        // whether it's inside the vis; true if removed (set true here since we call restore)
        selected: params.selected ? true : false,
        // whether it's selected
        selectable: params.selectable === undefined ? true : params.selectable ? true : false,
        // whether it's selectable
        locked: params.locked ? true : false,
        // whether the element is locked (cannot be moved)
        grabbed: false,
        // whether the element is grabbed by the mouse; renderer sets this privately
        grabbable: params.grabbable === undefined ? true : params.grabbable ? true : false,
        // whether the element can be grabbed
        pannable: params.pannable === undefined ? group === 'edges' ? true : false : params.pannable ? true : false,
        // whether the element has passthrough panning enabled
        active: false,
        // whether the element is active from user interaction
        classes: new $e815fda779bc047b$var$Set$1(),
        // map ( className => true )
        animation: {
            // object for currently-running animations
            current: [],
            queue: []
        },
        rscratch: {},
        // object in which the renderer can store information
        scratch: params.scratch || {},
        // scratch objects
        edges: [],
        // array of connected edges
        children: [],
        // array of children
        parent: params.parent && params.parent.isNode() ? params.parent : null,
        // parent ref
        traversalCache: {},
        // cache of output of traversal functions
        backgrounding: false,
        // whether background images are loading
        bbCache: null,
        // cache of the current bounding box
        bbCacheShift: {
            x: 0,
            y: 0
        },
        // shift applied to cached bb to be applied on next get
        bodyBounds: null,
        // bounds cache of element body, w/o overlay
        overlayBounds: null,
        // bounds cache of element body, including overlay
        labelBounds: {
            // bounds cache of labels
            all: null,
            source: null,
            target: null,
            main: null
        },
        arrowBounds: {
            // bounds cache of edge arrows
            source: null,
            target: null,
            'mid-source': null,
            'mid-target': null
        }
    };
    if (_p.position.x == null) _p.position.x = 0;
    if (_p.position.y == null) _p.position.y = 0;
    // renderedPosition overrides if specified
    if (params.renderedPosition) {
        var rpos = params.renderedPosition;
        var pan = cy.pan();
        var zoom = cy.zoom();
        _p.position = {
            x: (rpos.x - pan.x) / zoom,
            y: (rpos.y - pan.y) / zoom
        };
    }
    var classes = [];
    if ($e815fda779bc047b$var$array(params.classes)) classes = params.classes;
    else if ($e815fda779bc047b$var$string(params.classes)) classes = params.classes.split(/\s+/);
    for(var i = 0, l = classes.length; i < l; i++){
        var cls = classes[i];
        if (!cls || cls === '') continue;
        _p.classes.add(cls);
    }
    this.createEmitter();
    var bypass = params.style || params.css;
    if (bypass) {
        $e815fda779bc047b$var$warn('Setting a `style` bypass at element creation should be done only when absolutely necessary.  Try to use the stylesheet instead.');
        this.style(bypass);
    }
    if (restore === undefined || restore) this.restore();
};
var $e815fda779bc047b$var$defineSearch = function defineSearch(params) {
    params = {
        bfs: params.bfs || !params.dfs,
        dfs: params.dfs || !params.bfs
    };
    // from pseudocode on wikipedia
    return function searchFn(roots, fn, directed) {
        var options;
        if ($e815fda779bc047b$var$plainObject(roots) && !$e815fda779bc047b$var$elementOrCollection(roots)) {
            options = roots;
            roots = options.roots || options.root;
            fn = options.visit;
            directed = options.directed;
        }
        directed = arguments.length === 2 && !$e815fda779bc047b$var$fn$6(fn) ? fn : directed;
        fn = $e815fda779bc047b$var$fn$6(fn) ? fn : function() {};
        var cy = this._private.cy;
        var v = roots = $e815fda779bc047b$var$string(roots) ? this.filter(roots) : roots;
        var Q = [];
        var connectedNodes = [];
        var connectedBy = {};
        var id2depth = {};
        var V = {};
        var j = 0;
        var found;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        // enqueue v
        for(var i = 0; i < v.length; i++){
            var vi = v[i];
            var viId = vi.id();
            if (vi.isNode()) {
                Q.unshift(vi);
                if (params.bfs) {
                    V[viId] = true;
                    connectedNodes.push(vi);
                }
                id2depth[viId] = 0;
            }
        }
        var _loop = function _loop() {
            var v = params.bfs ? Q.shift() : Q.pop();
            var vId = v.id();
            if (params.dfs) {
                if (V[vId]) return "continue";
                V[vId] = true;
                connectedNodes.push(v);
            }
            var depth = id2depth[vId];
            var prevEdge = connectedBy[vId];
            var src = prevEdge != null ? prevEdge.source() : null;
            var tgt = prevEdge != null ? prevEdge.target() : null;
            var prevNode = prevEdge == null ? undefined : v.same(src) ? tgt[0] : src[0];
            var ret = void 0;
            ret = fn(v, prevEdge, prevNode, j++, depth);
            if (ret === true) {
                found = v;
                return "break";
            }
            if (ret === false) return "break";
            var vwEdges = v.connectedEdges().filter(function(e) {
                return (!directed || e.source().same(v)) && edges.has(e);
            });
            for(var _i2 = 0; _i2 < vwEdges.length; _i2++){
                var e = vwEdges[_i2];
                var w = e.connectedNodes().filter(function(n) {
                    return !n.same(v) && nodes.has(n);
                });
                var wId = w.id();
                if (w.length !== 0 && !V[wId]) {
                    w = w[0];
                    Q.push(w);
                    if (params.bfs) {
                        V[wId] = true;
                        connectedNodes.push(w);
                    }
                    connectedBy[wId] = e;
                    id2depth[wId] = id2depth[vId] + 1;
                }
            }
        };
        while(Q.length !== 0){
            var _ret = _loop();
            if (_ret === "continue") continue;
            if (_ret === "break") break;
        }
        var connectedEles = cy.collection();
        for(var _i = 0; _i < connectedNodes.length; _i++){
            var node = connectedNodes[_i];
            var edge = connectedBy[node.id()];
            if (edge != null) connectedEles.push(edge);
            connectedEles.push(node);
        }
        return {
            path: cy.collection(connectedEles),
            found: cy.collection(found)
        };
    };
};
// search, spanning trees, etc
var $e815fda779bc047b$var$elesfn$v = {
    breadthFirstSearch: $e815fda779bc047b$var$defineSearch({
        bfs: true
    }),
    depthFirstSearch: $e815fda779bc047b$var$defineSearch({
        dfs: true
    })
};
// nice, short mathematical alias
$e815fda779bc047b$var$elesfn$v.bfs = $e815fda779bc047b$var$elesfn$v.breadthFirstSearch;
$e815fda779bc047b$var$elesfn$v.dfs = $e815fda779bc047b$var$elesfn$v.depthFirstSearch;
var $e815fda779bc047b$var$heap$1 = $e815fda779bc047b$var$createCommonjsModule(function(module, exports) {
    // Generated by CoffeeScript 1.8.0
    (function() {
        var Heap, defaultCmp, floor, heapify, heappop, heappush, heappushpop, heapreplace, insort, min, nlargest, nsmallest, updateItem, _siftdown, _siftup;
        floor = Math.floor, min = Math.min;
        /*
  Default comparison function to be used
   */ defaultCmp = function(x, y) {
            if (x < y) return -1;
            if (x > y) return 1;
            return 0;
        };
        /*
  Insert item x in list a, and keep it sorted assuming a is sorted.
  
  If x is already in a, insert it to the right of the rightmost x.
  
  Optional args lo (default 0) and hi (default a.length) bound the slice
  of a to be searched.
   */ insort = function(a, x, lo, hi, cmp) {
            var mid;
            if (lo == null) lo = 0;
            if (cmp == null) cmp = defaultCmp;
            if (lo < 0) throw new Error('lo must be non-negative');
            if (hi == null) hi = a.length;
            while(lo < hi){
                mid = floor((lo + hi) / 2);
                if (cmp(x, a[mid]) < 0) hi = mid;
                else lo = mid + 1;
            }
            return [].splice.apply(a, [
                lo,
                lo - lo
            ].concat(x)), x;
        };
        /*
  Push item onto heap, maintaining the heap invariant.
   */ heappush = function(array, item, cmp) {
            if (cmp == null) cmp = defaultCmp;
            array.push(item);
            return _siftdown(array, 0, array.length - 1, cmp);
        };
        /*
  Pop the smallest item off the heap, maintaining the heap invariant.
   */ heappop = function(array, cmp) {
            var lastelt, returnitem;
            if (cmp == null) cmp = defaultCmp;
            lastelt = array.pop();
            if (array.length) {
                returnitem = array[0];
                array[0] = lastelt;
                _siftup(array, 0, cmp);
            } else returnitem = lastelt;
            return returnitem;
        };
        /*
  Pop and return the current smallest value, and add the new item.
  
  This is more efficient than heappop() followed by heappush(), and can be
  more appropriate when using a fixed size heap. Note that the value
  returned may be larger than item! That constrains reasonable use of
  this routine unless written as part of a conditional replacement:
      if item > array[0]
        item = heapreplace(array, item)
   */ heapreplace = function(array, item, cmp) {
            var returnitem;
            if (cmp == null) cmp = defaultCmp;
            returnitem = array[0];
            array[0] = item;
            _siftup(array, 0, cmp);
            return returnitem;
        };
        /*
  Fast version of a heappush followed by a heappop.
   */ heappushpop = function(array, item, cmp) {
            var _ref;
            if (cmp == null) cmp = defaultCmp;
            if (array.length && cmp(array[0], item) < 0) {
                _ref = [
                    array[0],
                    item
                ], item = _ref[0], array[0] = _ref[1];
                _siftup(array, 0, cmp);
            }
            return item;
        };
        /*
  Transform list into a heap, in-place, in O(array.length) time.
   */ heapify = function(array, cmp) {
            var i, _i, _len, _ref1, _results, _results1;
            if (cmp == null) cmp = defaultCmp;
            _ref1 = (function() {
                _results1 = [];
                for(var _j = 0, _ref = floor(array.length / 2); 0 <= _ref ? _j < _ref : _j > _ref; 0 <= _ref ? _j++ : _j--)_results1.push(_j);
                return _results1;
            }).apply(this).reverse();
            _results = [];
            for(_i = 0, _len = _ref1.length; _i < _len; _i++){
                i = _ref1[_i];
                _results.push(_siftup(array, i, cmp));
            }
            return _results;
        };
        /*
  Update the position of the given item in the heap.
  This function should be called every time the item is being modified.
   */ updateItem = function(array, item, cmp) {
            var pos;
            if (cmp == null) cmp = defaultCmp;
            pos = array.indexOf(item);
            if (pos === -1) return;
            _siftdown(array, 0, pos, cmp);
            return _siftup(array, pos, cmp);
        };
        /*
  Find the n largest elements in a dataset.
   */ nlargest = function(array, n, cmp) {
            var elem, result, _i, _len, _ref;
            if (cmp == null) cmp = defaultCmp;
            result = array.slice(0, n);
            if (!result.length) return result;
            heapify(result, cmp);
            _ref = array.slice(n);
            for(_i = 0, _len = _ref.length; _i < _len; _i++){
                elem = _ref[_i];
                heappushpop(result, elem, cmp);
            }
            return result.sort(cmp).reverse();
        };
        /*
  Find the n smallest elements in a dataset.
   */ nsmallest = function(array, n, cmp) {
            var elem, los, result, _i, _j, _len, _ref, _ref1, _results;
            if (cmp == null) cmp = defaultCmp;
            if (n * 10 <= array.length) {
                result = array.slice(0, n).sort(cmp);
                if (!result.length) return result;
                los = result[result.length - 1];
                _ref = array.slice(n);
                for(_i = 0, _len = _ref.length; _i < _len; _i++){
                    elem = _ref[_i];
                    if (cmp(elem, los) < 0) {
                        insort(result, elem, 0, null, cmp);
                        result.pop();
                        los = result[result.length - 1];
                    }
                }
                return result;
            }
            heapify(array, cmp);
            _results = [];
            for(_j = 0, _ref1 = min(n, array.length); 0 <= _ref1 ? _j < _ref1 : _j > _ref1; 0 <= _ref1 ? ++_j : --_j)_results.push(heappop(array, cmp));
            return _results;
        };
        _siftdown = function(array, startpos, pos, cmp) {
            var newitem, parent, parentpos;
            if (cmp == null) cmp = defaultCmp;
            newitem = array[pos];
            while(pos > startpos){
                parentpos = pos - 1 >> 1;
                parent = array[parentpos];
                if (cmp(newitem, parent) < 0) {
                    array[pos] = parent;
                    pos = parentpos;
                    continue;
                }
                break;
            }
            return array[pos] = newitem;
        };
        _siftup = function(array, pos, cmp) {
            var childpos, endpos, newitem, rightpos, startpos;
            if (cmp == null) cmp = defaultCmp;
            endpos = array.length;
            startpos = pos;
            newitem = array[pos];
            childpos = 2 * pos + 1;
            while(childpos < endpos){
                rightpos = childpos + 1;
                if (rightpos < endpos && !(cmp(array[childpos], array[rightpos]) < 0)) childpos = rightpos;
                array[pos] = array[childpos];
                pos = childpos;
                childpos = 2 * pos + 1;
            }
            array[pos] = newitem;
            return _siftdown(array, startpos, pos, cmp);
        };
        Heap = function() {
            Heap.push = heappush;
            Heap.pop = heappop;
            Heap.replace = heapreplace;
            Heap.pushpop = heappushpop;
            Heap.heapify = heapify;
            Heap.updateItem = updateItem;
            Heap.nlargest = nlargest;
            Heap.nsmallest = nsmallest;
            function Heap(cmp) {
                this.cmp = cmp != null ? cmp : defaultCmp;
                this.nodes = [];
            }
            Heap.prototype.push = function(x) {
                return heappush(this.nodes, x, this.cmp);
            };
            Heap.prototype.pop = function() {
                return heappop(this.nodes, this.cmp);
            };
            Heap.prototype.peek = function() {
                return this.nodes[0];
            };
            Heap.prototype.contains = function(x) {
                return this.nodes.indexOf(x) !== -1;
            };
            Heap.prototype.replace = function(x) {
                return heapreplace(this.nodes, x, this.cmp);
            };
            Heap.prototype.pushpop = function(x) {
                return heappushpop(this.nodes, x, this.cmp);
            };
            Heap.prototype.heapify = function() {
                return heapify(this.nodes, this.cmp);
            };
            Heap.prototype.updateItem = function(x) {
                return updateItem(this.nodes, x, this.cmp);
            };
            Heap.prototype.clear = function() {
                return this.nodes = [];
            };
            Heap.prototype.empty = function() {
                return this.nodes.length === 0;
            };
            Heap.prototype.size = function() {
                return this.nodes.length;
            };
            Heap.prototype.clone = function() {
                var heap;
                heap = new Heap();
                heap.nodes = this.nodes.slice(0);
                return heap;
            };
            Heap.prototype.toArray = function() {
                return this.nodes.slice(0);
            };
            Heap.prototype.insert = Heap.prototype.push;
            Heap.prototype.top = Heap.prototype.peek;
            Heap.prototype.front = Heap.prototype.peek;
            Heap.prototype.has = Heap.prototype.contains;
            Heap.prototype.copy = Heap.prototype.clone;
            return Heap;
        }();
        (function(root, factory) {
            return module.exports = factory();
        })(this, function() {
            return Heap;
        });
    }).call($e815fda779bc047b$var$commonjsGlobal);
});
var $e815fda779bc047b$var$heap = $e815fda779bc047b$var$heap$1;
var $e815fda779bc047b$var$dijkstraDefaults = $e815fda779bc047b$var$defaults$g({
    root: null,
    weight: function weight(edge) {
        return 1;
    },
    directed: false
});
var $e815fda779bc047b$var$elesfn$u = {
    dijkstra: function dijkstra(options) {
        if (!$e815fda779bc047b$var$plainObject(options)) {
            var args = arguments;
            options = {
                root: args[0],
                weight: args[1],
                directed: args[2]
            };
        }
        var _dijkstraDefaults = $e815fda779bc047b$var$dijkstraDefaults(options), root = _dijkstraDefaults.root, weight = _dijkstraDefaults.weight, directed = _dijkstraDefaults.directed;
        var eles = this;
        var weightFn = weight;
        var source = $e815fda779bc047b$var$string(root) ? this.filter(root)[0] : root[0];
        var dist = {};
        var prev = {};
        var knownDist = {};
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        edges.unmergeBy(function(ele) {
            return ele.isLoop();
        });
        var getDist = function getDist(node) {
            return dist[node.id()];
        };
        var setDist = function setDist(node, d) {
            dist[node.id()] = d;
            Q.updateItem(node);
        };
        var Q = new $e815fda779bc047b$var$heap(function(a, b) {
            return getDist(a) - getDist(b);
        });
        for(var i = 0; i < nodes.length; i++){
            var node = nodes[i];
            dist[node.id()] = node.same(source) ? 0 : Infinity;
            Q.push(node);
        }
        var distBetween = function distBetween(u, v) {
            var uvs = (directed ? u.edgesTo(v) : u.edgesWith(v)).intersect(edges);
            var smallestDistance = Infinity;
            var smallestEdge;
            for(var _i = 0; _i < uvs.length; _i++){
                var edge = uvs[_i];
                var _weight = weightFn(edge);
                if (_weight < smallestDistance || !smallestEdge) {
                    smallestDistance = _weight;
                    smallestEdge = edge;
                }
            }
            return {
                edge: smallestEdge,
                dist: smallestDistance
            };
        };
        while(Q.size() > 0){
            var u = Q.pop();
            var smalletsDist = getDist(u);
            var uid = u.id();
            knownDist[uid] = smalletsDist;
            if (smalletsDist === Infinity) continue;
            var neighbors = u.neighborhood().intersect(nodes);
            for(var _i2 = 0; _i2 < neighbors.length; _i2++){
                var v = neighbors[_i2];
                var vid = v.id();
                var vDist = distBetween(u, v);
                var alt = smalletsDist + vDist.dist;
                if (alt < getDist(v)) {
                    setDist(v, alt);
                    prev[vid] = {
                        node: u,
                        edge: vDist.edge
                    };
                }
            } // for
        } // while
        return {
            distanceTo: function distanceTo(node) {
                var target = $e815fda779bc047b$var$string(node) ? nodes.filter(node)[0] : node[0];
                return knownDist[target.id()];
            },
            pathTo: function pathTo(node) {
                var target = $e815fda779bc047b$var$string(node) ? nodes.filter(node)[0] : node[0];
                var S = [];
                var u = target;
                var uid = u.id();
                if (target.length > 0) {
                    S.unshift(target);
                    while(prev[uid]){
                        var p = prev[uid];
                        S.unshift(p.edge);
                        S.unshift(p.node);
                        u = p.node;
                        uid = u.id();
                    }
                }
                return eles.spawn(S);
            }
        };
    }
};
var $e815fda779bc047b$var$elesfn$t = {
    // kruskal's algorithm (finds min spanning tree, assuming undirected graph)
    // implemented from pseudocode from wikipedia
    kruskal: function kruskal(weightFn) {
        weightFn = weightFn || function(edge) {
            return 1;
        };
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        var numNodes = nodes.length;
        var forest = new Array(numNodes);
        var A = nodes; // assumes byGroup() creates new collections that can be safely mutated
        var findSetIndex = function findSetIndex(ele) {
            for(var i = 0; i < forest.length; i++){
                var eles = forest[i];
                if (eles.has(ele)) return i;
            }
        };
        // start with one forest per node
        for(var i = 0; i < numNodes; i++)forest[i] = this.spawn(nodes[i]);
        var S = edges.sort(function(a, b) {
            return weightFn(a) - weightFn(b);
        });
        for(var _i = 0; _i < S.length; _i++){
            var edge = S[_i];
            var u = edge.source()[0];
            var v = edge.target()[0];
            var setUIndex = findSetIndex(u);
            var setVIndex = findSetIndex(v);
            var setU = forest[setUIndex];
            var setV = forest[setVIndex];
            if (setUIndex !== setVIndex) {
                A.merge(edge);
                // combine forests for u and v
                setU.merge(setV);
                forest.splice(setVIndex, 1);
            }
        }
        return A;
    }
};
var $e815fda779bc047b$var$aStarDefaults = $e815fda779bc047b$var$defaults$g({
    root: null,
    goal: null,
    weight: function weight(edge) {
        return 1;
    },
    heuristic: function heuristic(edge) {
        return 0;
    },
    directed: false
});
var $e815fda779bc047b$var$elesfn$s = {
    // Implemented from pseudocode from wikipedia
    aStar: function aStar(options) {
        var cy = this.cy();
        var _aStarDefaults = $e815fda779bc047b$var$aStarDefaults(options), root = _aStarDefaults.root, goal = _aStarDefaults.goal, heuristic = _aStarDefaults.heuristic, directed = _aStarDefaults.directed, weight = _aStarDefaults.weight;
        root = cy.collection(root)[0];
        goal = cy.collection(goal)[0];
        var sid = root.id();
        var tid = goal.id();
        var gScore = {};
        var fScore = {};
        var closedSetIds = {};
        var openSet = new $e815fda779bc047b$var$heap(function(a, b) {
            return fScore[a.id()] - fScore[b.id()];
        });
        var openSetIds = new $e815fda779bc047b$var$Set$1();
        var cameFrom = {};
        var cameFromEdge = {};
        var addToOpenSet = function addToOpenSet(ele, id) {
            openSet.push(ele);
            openSetIds.add(id);
        };
        var cMin, cMinId;
        var popFromOpenSet = function popFromOpenSet() {
            cMin = openSet.pop();
            cMinId = cMin.id();
            openSetIds["delete"](cMinId);
        };
        var isInOpenSet = function isInOpenSet(id) {
            return openSetIds.has(id);
        };
        addToOpenSet(root, sid);
        gScore[sid] = 0;
        fScore[sid] = heuristic(root);
        // Counter
        var steps = 0;
        // Main loop
        while(openSet.size() > 0){
            popFromOpenSet();
            steps++;
            // If we've found our goal, then we are done
            if (cMinId === tid) {
                var path = [];
                var pathNode = goal;
                var pathNodeId = tid;
                var pathEdge = cameFromEdge[pathNodeId];
                for(;;){
                    path.unshift(pathNode);
                    if (pathEdge != null) path.unshift(pathEdge);
                    pathNode = cameFrom[pathNodeId];
                    if (pathNode == null) break;
                    pathNodeId = pathNode.id();
                    pathEdge = cameFromEdge[pathNodeId];
                }
                return {
                    found: true,
                    distance: gScore[cMinId],
                    path: this.spawn(path),
                    steps: steps
                };
            }
            // Add cMin to processed nodes
            closedSetIds[cMinId] = true;
            // Update scores for neighbors of cMin
            // Take into account if graph is directed or not
            var vwEdges = cMin._private.edges;
            for(var i = 0; i < vwEdges.length; i++){
                var e = vwEdges[i];
                // edge must be in set of calling eles
                if (!this.hasElementWithId(e.id())) continue;
                // cMin must be the source of edge if directed
                if (directed && e.data('source') !== cMinId) continue;
                var wSrc = e.source();
                var wTgt = e.target();
                var w = wSrc.id() !== cMinId ? wSrc : wTgt;
                var wid = w.id();
                // node must be in set of calling eles
                if (!this.hasElementWithId(wid)) continue;
                // if node is in closedSet, ignore it
                if (closedSetIds[wid]) continue;
                // New tentative score for node w
                var tempScore = gScore[cMinId] + weight(e);
                // Update gScore for node w if:
                //   w not present in openSet
                // OR
                //   tentative gScore is less than previous value
                // w not in openSet
                if (!isInOpenSet(wid)) {
                    gScore[wid] = tempScore;
                    fScore[wid] = tempScore + heuristic(w);
                    addToOpenSet(w, wid);
                    cameFrom[wid] = cMin;
                    cameFromEdge[wid] = e;
                    continue;
                }
                // w already in openSet, but with greater gScore
                if (tempScore < gScore[wid]) {
                    gScore[wid] = tempScore;
                    fScore[wid] = tempScore + heuristic(w);
                    cameFrom[wid] = cMin;
                    cameFromEdge[wid] = e;
                }
            } // End of neighbors update
        } // End of main loop
        // If we've reached here, then we've not reached our goal
        return {
            found: false,
            distance: undefined,
            path: undefined,
            steps: steps
        };
    }
}; // elesfn
var $e815fda779bc047b$var$floydWarshallDefaults = $e815fda779bc047b$var$defaults$g({
    weight: function weight(edge) {
        return 1;
    },
    directed: false
});
var $e815fda779bc047b$var$elesfn$r = {
    // Implemented from pseudocode from wikipedia
    floydWarshall: function floydWarshall(options) {
        var cy = this.cy();
        var _floydWarshallDefault = $e815fda779bc047b$var$floydWarshallDefaults(options), weight = _floydWarshallDefault.weight, directed = _floydWarshallDefault.directed;
        var weightFn = weight;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        var N = nodes.length;
        var Nsq = N * N;
        var indexOf = function indexOf(node) {
            return nodes.indexOf(node);
        };
        var atIndex = function atIndex(i) {
            return nodes[i];
        };
        // Initialize distance matrix
        var dist = new Array(Nsq);
        for(var n = 0; n < Nsq; n++){
            var j = n % N;
            var i = (n - j) / N;
            if (i === j) dist[n] = 0;
            else dist[n] = Infinity;
        }
        // Initialize matrix used for path reconstruction
        // Initialize distance matrix
        var next = new Array(Nsq);
        var edgeNext = new Array(Nsq);
        // Process edges
        for(var _i = 0; _i < edges.length; _i++){
            var edge = edges[_i];
            var src = edge.source()[0];
            var tgt = edge.target()[0];
            if (src === tgt) continue;
             // exclude loops
            var s = indexOf(src);
            var t = indexOf(tgt);
            var st = s * N + t; // source to target index
            var _weight = weightFn(edge);
            // Check if already process another edge between same 2 nodes
            if (dist[st] > _weight) {
                dist[st] = _weight;
                next[st] = t;
                edgeNext[st] = edge;
            }
            // If undirected graph, process 'reversed' edge
            if (!directed) {
                var ts = t * N + s; // target to source index
                if (!directed && dist[ts] > _weight) {
                    dist[ts] = _weight;
                    next[ts] = s;
                    edgeNext[ts] = edge;
                }
            }
        }
        // Main loop
        for(var k = 0; k < N; k++)for(var _i2 = 0; _i2 < N; _i2++){
            var ik = _i2 * N + k;
            for(var _j = 0; _j < N; _j++){
                var ij = _i2 * N + _j;
                var kj = k * N + _j;
                if (dist[ik] + dist[kj] < dist[ij]) {
                    dist[ij] = dist[ik] + dist[kj];
                    next[ij] = next[ik];
                }
            }
        }
        var getArgEle = function getArgEle(ele) {
            return ($e815fda779bc047b$var$string(ele) ? cy.filter(ele) : ele)[0];
        };
        var indexOfArgEle = function indexOfArgEle(ele) {
            return indexOf(getArgEle(ele));
        };
        var res = {
            distance: function distance(from, to) {
                var i = indexOfArgEle(from);
                var j = indexOfArgEle(to);
                return dist[i * N + j];
            },
            path: function path(from, to) {
                var i = indexOfArgEle(from);
                var j = indexOfArgEle(to);
                var fromNode = atIndex(i);
                if (i === j) return fromNode.collection();
                if (next[i * N + j] == null) return cy.collection();
                var path = cy.collection();
                var prev = i;
                var edge;
                path.merge(fromNode);
                while(i !== j){
                    prev = i;
                    i = next[i * N + j];
                    edge = edgeNext[prev * N + i];
                    path.merge(edge);
                    path.merge(atIndex(i));
                }
                return path;
            }
        };
        return res;
    } // floydWarshall
}; // elesfn
var $e815fda779bc047b$var$bellmanFordDefaults = $e815fda779bc047b$var$defaults$g({
    weight: function weight(edge) {
        return 1;
    },
    directed: false,
    root: null
});
var $e815fda779bc047b$var$elesfn$q = {
    // Implemented from pseudocode from wikipedia
    bellmanFord: function bellmanFord(options) {
        var _this = this;
        var _bellmanFordDefaults = $e815fda779bc047b$var$bellmanFordDefaults(options), weight = _bellmanFordDefaults.weight, directed = _bellmanFordDefaults.directed, root = _bellmanFordDefaults.root;
        var weightFn = weight;
        var eles = this;
        var cy = this.cy();
        var _this$byGroup = this.byGroup(), edges = _this$byGroup.edges, nodes = _this$byGroup.nodes;
        var numNodes = nodes.length;
        var infoMap = new $e815fda779bc047b$var$Map$2();
        var hasNegativeWeightCycle = false;
        var negativeWeightCycles = [];
        root = cy.collection(root)[0]; // in case selector passed
        edges.unmergeBy(function(edge) {
            return edge.isLoop();
        });
        var numEdges = edges.length;
        var getInfo = function getInfo(node) {
            var obj = infoMap.get(node.id());
            if (!obj) {
                obj = {};
                infoMap.set(node.id(), obj);
            }
            return obj;
        };
        var getNodeFromTo = function getNodeFromTo(to) {
            return ($e815fda779bc047b$var$string(to) ? cy.$(to) : to)[0];
        };
        var distanceTo = function distanceTo(to) {
            return getInfo(getNodeFromTo(to)).dist;
        };
        var pathTo = function pathTo(to) {
            var thisStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : root;
            var end = getNodeFromTo(to);
            var path = [];
            var node = end;
            for(;;){
                if (node == null) return _this.spawn();
                var _getInfo = getInfo(node), edge = _getInfo.edge, pred = _getInfo.pred;
                path.unshift(node[0]);
                if (node.same(thisStart) && path.length > 0) break;
                if (edge != null) path.unshift(edge);
                node = pred;
            }
            return eles.spawn(path);
        };
        // Initializations { dist, pred, edge }
        for(var i = 0; i < numNodes; i++){
            var node = nodes[i];
            var info = getInfo(node);
            if (node.same(root)) info.dist = 0;
            else info.dist = Infinity;
            info.pred = null;
            info.edge = null;
        }
        // Edges relaxation
        var replacedEdge = false;
        var checkForEdgeReplacement = function checkForEdgeReplacement(node1, node2, edge, info1, info2, weight) {
            var dist = info1.dist + weight;
            if (dist < info2.dist && !edge.same(info1.edge)) {
                info2.dist = dist;
                info2.pred = node1;
                info2.edge = edge;
                replacedEdge = true;
            }
        };
        for(var _i = 1; _i < numNodes; _i++){
            replacedEdge = false;
            for(var e = 0; e < numEdges; e++){
                var edge = edges[e];
                var src = edge.source();
                var tgt = edge.target();
                var _weight = weightFn(edge);
                var srcInfo = getInfo(src);
                var tgtInfo = getInfo(tgt);
                checkForEdgeReplacement(src, tgt, edge, srcInfo, tgtInfo, _weight);
                // If undirected graph, we need to take into account the 'reverse' edge
                if (!directed) checkForEdgeReplacement(tgt, src, edge, tgtInfo, srcInfo, _weight);
            }
            if (!replacedEdge) break;
        }
        if (replacedEdge) {
            // Check for negative weight cycles
            var negativeWeightCycleIds = [];
            for(var _e = 0; _e < numEdges; _e++){
                var _edge = edges[_e];
                var _src = _edge.source();
                var _tgt = _edge.target();
                var _weight2 = weightFn(_edge);
                var srcDist = getInfo(_src).dist;
                var tgtDist = getInfo(_tgt).dist;
                if (srcDist + _weight2 < tgtDist || !directed && tgtDist + _weight2 < srcDist) {
                    if (!hasNegativeWeightCycle) {
                        $e815fda779bc047b$var$warn('Graph contains a negative weight cycle for Bellman-Ford');
                        hasNegativeWeightCycle = true;
                    }
                    if (options.findNegativeWeightCycles !== false) {
                        var negativeNodes = [];
                        if (srcDist + _weight2 < tgtDist) negativeNodes.push(_src);
                        if (!directed && tgtDist + _weight2 < srcDist) negativeNodes.push(_tgt);
                        var numNegativeNodes = negativeNodes.length;
                        for(var n = 0; n < numNegativeNodes; n++){
                            var start = negativeNodes[n];
                            var cycle = [
                                start
                            ];
                            cycle.push(getInfo(start).edge);
                            var _node = getInfo(start).pred;
                            while(cycle.indexOf(_node) === -1){
                                cycle.push(_node);
                                cycle.push(getInfo(_node).edge);
                                _node = getInfo(_node).pred;
                            }
                            cycle = cycle.slice(cycle.indexOf(_node));
                            var smallestId = cycle[0].id();
                            var smallestIndex = 0;
                            for(var c = 2; c < cycle.length; c += 2)if (cycle[c].id() < smallestId) {
                                smallestId = cycle[c].id();
                                smallestIndex = c;
                            }
                            cycle = cycle.slice(smallestIndex).concat(cycle.slice(0, smallestIndex));
                            cycle.push(cycle[0]);
                            var cycleId = cycle.map(function(el) {
                                return el.id();
                            }).join(",");
                            if (negativeWeightCycleIds.indexOf(cycleId) === -1) {
                                negativeWeightCycles.push(eles.spawn(cycle));
                                negativeWeightCycleIds.push(cycleId);
                            }
                        }
                    } else break;
                }
            }
        }
        return {
            distanceTo: distanceTo,
            pathTo: pathTo,
            hasNegativeWeightCycle: hasNegativeWeightCycle,
            negativeWeightCycles: negativeWeightCycles
        };
    } // bellmanFord
}; // elesfn
var $e815fda779bc047b$var$sqrt2 = Math.sqrt(2);
// Function which colapses 2 (meta) nodes into one
// Updates the remaining edge lists
// Receives as a paramater the edge which causes the collapse
var $e815fda779bc047b$var$collapse = function collapse(edgeIndex, nodeMap, remainingEdges) {
    if (remainingEdges.length === 0) $e815fda779bc047b$var$error("Karger-Stein must be run on a connected (sub)graph");
    var edgeInfo = remainingEdges[edgeIndex];
    var sourceIn = edgeInfo[1];
    var targetIn = edgeInfo[2];
    var partition1 = nodeMap[sourceIn];
    var partition2 = nodeMap[targetIn];
    var newEdges = remainingEdges; // re-use array
    // Delete all edges between partition1 and partition2
    for(var i = newEdges.length - 1; i >= 0; i--){
        var edge = newEdges[i];
        var src = edge[1];
        var tgt = edge[2];
        if (nodeMap[src] === partition1 && nodeMap[tgt] === partition2 || nodeMap[src] === partition2 && nodeMap[tgt] === partition1) newEdges.splice(i, 1);
    }
    // All edges pointing to partition2 should now point to partition1
    for(var _i = 0; _i < newEdges.length; _i++){
        var _edge = newEdges[_i];
        if (_edge[1] === partition2) {
            // Check source
            newEdges[_i] = _edge.slice(); // copy
            newEdges[_i][1] = partition1;
        } else if (_edge[2] === partition2) {
            // Check target
            newEdges[_i] = _edge.slice(); // copy
            newEdges[_i][2] = partition1;
        }
    }
    // Move all nodes from partition2 to partition1
    for(var _i2 = 0; _i2 < nodeMap.length; _i2++)if (nodeMap[_i2] === partition2) nodeMap[_i2] = partition1;
    return newEdges;
};
// Contracts a graph until we reach a certain number of meta nodes
var $e815fda779bc047b$var$contractUntil = function contractUntil(metaNodeMap, remainingEdges, size, sizeLimit) {
    while(size > sizeLimit){
        // Choose an edge randomly
        var edgeIndex = Math.floor(Math.random() * remainingEdges.length);
        // Collapse graph based on edge
        remainingEdges = $e815fda779bc047b$var$collapse(edgeIndex, metaNodeMap, remainingEdges);
        size--;
    }
    return remainingEdges;
};
var $e815fda779bc047b$var$elesfn$p = {
    // Computes the minimum cut of an undirected graph
    // Returns the correct answer with high probability
    kargerStein: function kargerStein() {
        var _this = this;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        edges.unmergeBy(function(edge) {
            return edge.isLoop();
        });
        var numNodes = nodes.length;
        var numEdges = edges.length;
        var numIter = Math.ceil(Math.pow(Math.log(numNodes) / Math.LN2, 2));
        var stopSize = Math.floor(numNodes / $e815fda779bc047b$var$sqrt2);
        if (numNodes < 2) {
            $e815fda779bc047b$var$error('At least 2 nodes are required for Karger-Stein algorithm');
            return undefined;
        }
        // Now store edge destination as indexes
        // Format for each edge (edge index, source node index, target node index)
        var edgeIndexes = [];
        for(var i = 0; i < numEdges; i++){
            var e = edges[i];
            edgeIndexes.push([
                i,
                nodes.indexOf(e.source()),
                nodes.indexOf(e.target())
            ]);
        }
        // We will store the best cut found here
        var minCutSize = Infinity;
        var minCutEdgeIndexes = [];
        var minCutNodeMap = new Array(numNodes);
        // Initial meta node partition
        var metaNodeMap = new Array(numNodes);
        var metaNodeMap2 = new Array(numNodes);
        var copyNodesMap = function copyNodesMap(from, to) {
            for(var _i3 = 0; _i3 < numNodes; _i3++)to[_i3] = from[_i3];
        };
        // Main loop
        for(var iter = 0; iter <= numIter; iter++){
            // Reset meta node partition
            for(var _i4 = 0; _i4 < numNodes; _i4++)metaNodeMap[_i4] = _i4;
            // Contract until stop point (stopSize nodes)
            var edgesState = $e815fda779bc047b$var$contractUntil(metaNodeMap, edgeIndexes.slice(), numNodes, stopSize);
            var edgesState2 = edgesState.slice(); // copy
            // Create a copy of the colapsed nodes state
            copyNodesMap(metaNodeMap, metaNodeMap2);
            // Run 2 iterations starting in the stop state
            var res1 = $e815fda779bc047b$var$contractUntil(metaNodeMap, edgesState, stopSize, 2);
            var res2 = $e815fda779bc047b$var$contractUntil(metaNodeMap2, edgesState2, stopSize, 2);
            // Is any of the 2 results the best cut so far?
            if (res1.length <= res2.length && res1.length < minCutSize) {
                minCutSize = res1.length;
                minCutEdgeIndexes = res1;
                copyNodesMap(metaNodeMap, minCutNodeMap);
            } else if (res2.length <= res1.length && res2.length < minCutSize) {
                minCutSize = res2.length;
                minCutEdgeIndexes = res2;
                copyNodesMap(metaNodeMap2, minCutNodeMap);
            }
        } // end of main loop
        // Construct result
        var cut = this.spawn(minCutEdgeIndexes.map(function(e) {
            return edges[e[0]];
        }));
        var partition1 = this.spawn();
        var partition2 = this.spawn();
        // traverse metaNodeMap for best cut
        var witnessNodePartition = minCutNodeMap[0];
        for(var _i5 = 0; _i5 < minCutNodeMap.length; _i5++){
            var partitionId = minCutNodeMap[_i5];
            var node = nodes[_i5];
            if (partitionId === witnessNodePartition) partition1.merge(node);
            else partition2.merge(node);
        }
        // construct components corresponding to each disjoint subset of nodes
        var constructComponent = function constructComponent(subset) {
            var component = _this.spawn();
            subset.forEach(function(node) {
                component.merge(node);
                node.connectedEdges().forEach(function(edge) {
                    // ensure edge is within calling collection and edge is not in cut
                    if (_this.contains(edge) && !cut.contains(edge)) component.merge(edge);
                });
            });
            return component;
        };
        var components = [
            constructComponent(partition1),
            constructComponent(partition2)
        ];
        var ret = {
            cut: cut,
            components: components,
            // n.b. partitions are included to be compatible with the old api spec
            // (could be removed in a future major version)
            partition1: partition1,
            partition2: partition2
        };
        return ret;
    }
}; // elesfn
var $e815fda779bc047b$var$copyPosition = function copyPosition(p) {
    return {
        x: p.x,
        y: p.y
    };
};
var $e815fda779bc047b$var$modelToRenderedPosition = function modelToRenderedPosition(p, zoom, pan) {
    return {
        x: p.x * zoom + pan.x,
        y: p.y * zoom + pan.y
    };
};
var $e815fda779bc047b$var$renderedToModelPosition = function renderedToModelPosition(p, zoom, pan) {
    return {
        x: (p.x - pan.x) / zoom,
        y: (p.y - pan.y) / zoom
    };
};
var $e815fda779bc047b$var$array2point = function array2point(arr) {
    return {
        x: arr[0],
        y: arr[1]
    };
};
var $e815fda779bc047b$var$min = function min(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var min = Infinity;
    for(var i = begin; i < end; i++){
        var val = arr[i];
        if (isFinite(val)) min = Math.min(val, min);
    }
    return min;
};
var $e815fda779bc047b$var$max = function max(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var max = -Infinity;
    for(var i = begin; i < end; i++){
        var val = arr[i];
        if (isFinite(val)) max = Math.max(val, max);
    }
    return max;
};
var $e815fda779bc047b$var$mean = function mean(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var total = 0;
    var n = 0;
    for(var i = begin; i < end; i++){
        var val = arr[i];
        if (isFinite(val)) {
            total += val;
            n++;
        }
    }
    return total / n;
};
var $e815fda779bc047b$var$median = function median(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var copy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var sort = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var includeHoles = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    if (copy) arr = arr.slice(begin, end);
    else {
        if (end < arr.length) arr.splice(end, arr.length - end);
        if (begin > 0) arr.splice(0, begin);
    }
    // all non finite (e.g. Infinity, NaN) elements must be -Infinity so they go to the start
    var off = 0; // offset from non-finite values
    for(var i = arr.length - 1; i >= 0; i--){
        var v = arr[i];
        if (includeHoles) {
            if (!isFinite(v)) {
                arr[i] = -Infinity;
                off++;
            }
        } else // just remove it if we don't want to consider holes
        arr.splice(i, 1);
    }
    if (sort) arr.sort(function(a, b) {
        return a - b;
    }); // requires copy = true if you don't want to change the orig
    var len = arr.length;
    var mid = Math.floor(len / 2);
    if (len % 2 !== 0) return arr[mid + 1 + off];
    else return (arr[mid - 1 + off] + arr[mid + off]) / 2;
};
var $e815fda779bc047b$var$deg2rad = function deg2rad(deg) {
    return Math.PI * deg / 180;
};
var $e815fda779bc047b$var$getAngleFromDisp = function getAngleFromDisp(dispX, dispY) {
    return Math.atan2(dispY, dispX) - Math.PI / 2;
};
var $e815fda779bc047b$var$log2 = Math.log2 || function(n) {
    return Math.log(n) / Math.log(2);
};
var $e815fda779bc047b$var$signum = function signum(x) {
    if (x > 0) return 1;
    else if (x < 0) return -1;
    else return 0;
};
var $e815fda779bc047b$var$dist = function dist(p1, p2) {
    return Math.sqrt($e815fda779bc047b$var$sqdist(p1, p2));
};
var $e815fda779bc047b$var$sqdist = function sqdist(p1, p2) {
    var dx = p2.x - p1.x;
    var dy = p2.y - p1.y;
    return dx * dx + dy * dy;
};
var $e815fda779bc047b$var$inPlaceSumNormalize = function inPlaceSumNormalize(v) {
    var length = v.length;
    // First, get sum of all elements
    var total = 0;
    for(var i = 0; i < length; i++)total += v[i];
    // Now, divide each by the sum of all elements
    for(var _i = 0; _i < length; _i++)v[_i] = v[_i] / total;
    return v;
};
// from http://en.wikipedia.org/wiki/Bézier_curve#Quadratic_curves
var $e815fda779bc047b$var$qbezierAt = function qbezierAt(p0, p1, p2, t) {
    return (1 - t) * (1 - t) * p0 + 2 * (1 - t) * t * p1 + t * t * p2;
};
var $e815fda779bc047b$var$qbezierPtAt = function qbezierPtAt(p0, p1, p2, t) {
    return {
        x: $e815fda779bc047b$var$qbezierAt(p0.x, p1.x, p2.x, t),
        y: $e815fda779bc047b$var$qbezierAt(p0.y, p1.y, p2.y, t)
    };
};
var $e815fda779bc047b$var$lineAt = function lineAt(p0, p1, t, d) {
    var vec = {
        x: p1.x - p0.x,
        y: p1.y - p0.y
    };
    var vecDist = $e815fda779bc047b$var$dist(p0, p1);
    var normVec = {
        x: vec.x / vecDist,
        y: vec.y / vecDist
    };
    t = t == null ? 0 : t;
    d = d != null ? d : t * vecDist;
    return {
        x: p0.x + normVec.x * d,
        y: p0.y + normVec.y * d
    };
};
var $e815fda779bc047b$var$bound = function bound(min, val, max) {
    return Math.max(min, Math.min(max, val));
};
// makes a full bb (x1, y1, x2, y2, w, h) from implicit params
var $e815fda779bc047b$var$makeBoundingBox = function makeBoundingBox(bb) {
    if (bb == null) return {
        x1: Infinity,
        y1: Infinity,
        x2: -Infinity,
        y2: -Infinity,
        w: 0,
        h: 0
    };
    else if (bb.x1 != null && bb.y1 != null) {
        if (bb.x2 != null && bb.y2 != null && bb.x2 >= bb.x1 && bb.y2 >= bb.y1) return {
            x1: bb.x1,
            y1: bb.y1,
            x2: bb.x2,
            y2: bb.y2,
            w: bb.x2 - bb.x1,
            h: bb.y2 - bb.y1
        };
        else if (bb.w != null && bb.h != null && bb.w >= 0 && bb.h >= 0) return {
            x1: bb.x1,
            y1: bb.y1,
            x2: bb.x1 + bb.w,
            y2: bb.y1 + bb.h,
            w: bb.w,
            h: bb.h
        };
    }
};
var $e815fda779bc047b$var$copyBoundingBox = function copyBoundingBox(bb) {
    return {
        x1: bb.x1,
        x2: bb.x2,
        w: bb.w,
        y1: bb.y1,
        y2: bb.y2,
        h: bb.h
    };
};
var $e815fda779bc047b$var$clearBoundingBox = function clearBoundingBox(bb) {
    bb.x1 = Infinity;
    bb.y1 = Infinity;
    bb.x2 = -Infinity;
    bb.y2 = -Infinity;
    bb.w = 0;
    bb.h = 0;
};
var $e815fda779bc047b$var$shiftBoundingBox = function shiftBoundingBox(bb, dx, dy) {
    return {
        x1: bb.x1 + dx,
        x2: bb.x2 + dx,
        y1: bb.y1 + dy,
        y2: bb.y2 + dy,
        w: bb.w,
        h: bb.h
    };
};
var $e815fda779bc047b$var$updateBoundingBox = function updateBoundingBox(bb1, bb2) {
    // update bb1 with bb2 bounds
    bb1.x1 = Math.min(bb1.x1, bb2.x1);
    bb1.x2 = Math.max(bb1.x2, bb2.x2);
    bb1.w = bb1.x2 - bb1.x1;
    bb1.y1 = Math.min(bb1.y1, bb2.y1);
    bb1.y2 = Math.max(bb1.y2, bb2.y2);
    bb1.h = bb1.y2 - bb1.y1;
};
var $e815fda779bc047b$var$expandBoundingBoxByPoint = function expandBoundingBoxByPoint(bb, x, y) {
    bb.x1 = Math.min(bb.x1, x);
    bb.x2 = Math.max(bb.x2, x);
    bb.w = bb.x2 - bb.x1;
    bb.y1 = Math.min(bb.y1, y);
    bb.y2 = Math.max(bb.y2, y);
    bb.h = bb.y2 - bb.y1;
};
var $e815fda779bc047b$var$expandBoundingBox = function expandBoundingBox(bb) {
    var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    bb.x1 -= padding;
    bb.x2 += padding;
    bb.y1 -= padding;
    bb.y2 += padding;
    bb.w = bb.x2 - bb.x1;
    bb.h = bb.y2 - bb.y1;
    return bb;
};
var $e815fda779bc047b$var$expandBoundingBoxSides = function expandBoundingBoxSides(bb) {
    var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [
        0
    ];
    var top, right, bottom, left;
    if (padding.length === 1) top = right = bottom = left = padding[0];
    else if (padding.length === 2) {
        top = bottom = padding[0];
        left = right = padding[1];
    } else if (padding.length === 4) {
        var _padding = $e815fda779bc047b$var$_slicedToArray(padding, 4);
        top = _padding[0];
        right = _padding[1];
        bottom = _padding[2];
        left = _padding[3];
    }
    bb.x1 -= left;
    bb.x2 += right;
    bb.y1 -= top;
    bb.y2 += bottom;
    bb.w = bb.x2 - bb.x1;
    bb.h = bb.y2 - bb.y1;
    return bb;
};
// assign the values of bb2 into bb1
var $e815fda779bc047b$var$assignBoundingBox = function assignBoundingBox(bb1, bb2) {
    bb1.x1 = bb2.x1;
    bb1.y1 = bb2.y1;
    bb1.x2 = bb2.x2;
    bb1.y2 = bb2.y2;
    bb1.w = bb1.x2 - bb1.x1;
    bb1.h = bb1.y2 - bb1.y1;
};
var $e815fda779bc047b$var$boundingBoxesIntersect = function boundingBoxesIntersect(bb1, bb2) {
    // case: one bb to right of other
    if (bb1.x1 > bb2.x2) return false;
    if (bb2.x1 > bb1.x2) return false;
    // case: one bb to left of other
    if (bb1.x2 < bb2.x1) return false;
    if (bb2.x2 < bb1.x1) return false;
    // case: one bb above other
    if (bb1.y2 < bb2.y1) return false;
    if (bb2.y2 < bb1.y1) return false;
    // case: one bb below other
    if (bb1.y1 > bb2.y2) return false;
    if (bb2.y1 > bb1.y2) return false;
    // otherwise, must have some overlap
    return true;
};
var $e815fda779bc047b$var$inBoundingBox = function inBoundingBox(bb, x, y) {
    return bb.x1 <= x && x <= bb.x2 && bb.y1 <= y && y <= bb.y2;
};
var $e815fda779bc047b$var$pointInBoundingBox = function pointInBoundingBox(bb, pt) {
    return $e815fda779bc047b$var$inBoundingBox(bb, pt.x, pt.y);
};
var $e815fda779bc047b$var$boundingBoxInBoundingBox = function boundingBoxInBoundingBox(bb1, bb2) {
    return $e815fda779bc047b$var$inBoundingBox(bb1, bb2.x1, bb2.y1) && $e815fda779bc047b$var$inBoundingBox(bb1, bb2.x2, bb2.y2);
};
var $e815fda779bc047b$var$roundRectangleIntersectLine = function roundRectangleIntersectLine(x, y, nodeX, nodeY, width, height, padding) {
    var radius = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'auto';
    var cornerRadius = radius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(width, height) : radius;
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    cornerRadius = Math.min(cornerRadius, halfWidth, halfHeight);
    var doWidth = cornerRadius !== halfWidth, doHeight = cornerRadius !== halfHeight;
    // Check intersections with straight line segments
    var straightLineIntersections;
    // Top segment, left to right
    if (doWidth) {
        var topStartX = nodeX - halfWidth + cornerRadius - padding;
        var topStartY = nodeY - halfHeight - padding;
        var topEndX = nodeX + halfWidth - cornerRadius + padding;
        var topEndY = topStartY;
        straightLineIntersections = $e815fda779bc047b$var$finiteLinesIntersect(x, y, nodeX, nodeY, topStartX, topStartY, topEndX, topEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Right segment, top to bottom
    if (doHeight) {
        var rightStartX = nodeX + halfWidth + padding;
        var rightStartY = nodeY - halfHeight + cornerRadius - padding;
        var rightEndX = rightStartX;
        var rightEndY = nodeY + halfHeight - cornerRadius + padding;
        straightLineIntersections = $e815fda779bc047b$var$finiteLinesIntersect(x, y, nodeX, nodeY, rightStartX, rightStartY, rightEndX, rightEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Bottom segment, left to right
    if (doWidth) {
        var bottomStartX = nodeX - halfWidth + cornerRadius - padding;
        var bottomStartY = nodeY + halfHeight + padding;
        var bottomEndX = nodeX + halfWidth - cornerRadius + padding;
        var bottomEndY = bottomStartY;
        straightLineIntersections = $e815fda779bc047b$var$finiteLinesIntersect(x, y, nodeX, nodeY, bottomStartX, bottomStartY, bottomEndX, bottomEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Left segment, top to bottom
    if (doHeight) {
        var leftStartX = nodeX - halfWidth - padding;
        var leftStartY = nodeY - halfHeight + cornerRadius - padding;
        var leftEndX = leftStartX;
        var leftEndY = nodeY + halfHeight - cornerRadius + padding;
        straightLineIntersections = $e815fda779bc047b$var$finiteLinesIntersect(x, y, nodeX, nodeY, leftStartX, leftStartY, leftEndX, leftEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Check intersections with arc segments
    var arcIntersections;
    var topLeftCenterX = nodeX - halfWidth + cornerRadius;
    var topLeftCenterY = nodeY - halfHeight + cornerRadius;
    arcIntersections = $e815fda779bc047b$var$intersectLineCircle(x, y, nodeX, nodeY, topLeftCenterX, topLeftCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] <= topLeftCenterX && arcIntersections[1] <= topLeftCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    var topRightCenterX = nodeX + halfWidth - cornerRadius;
    var topRightCenterY = nodeY - halfHeight + cornerRadius;
    arcIntersections = $e815fda779bc047b$var$intersectLineCircle(x, y, nodeX, nodeY, topRightCenterX, topRightCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] >= topRightCenterX && arcIntersections[1] <= topRightCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    var bottomRightCenterX = nodeX + halfWidth - cornerRadius;
    var bottomRightCenterY = nodeY + halfHeight - cornerRadius;
    arcIntersections = $e815fda779bc047b$var$intersectLineCircle(x, y, nodeX, nodeY, bottomRightCenterX, bottomRightCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] >= bottomRightCenterX && arcIntersections[1] >= bottomRightCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    var bottomLeftCenterX = nodeX - halfWidth + cornerRadius;
    var bottomLeftCenterY = nodeY + halfHeight - cornerRadius;
    arcIntersections = $e815fda779bc047b$var$intersectLineCircle(x, y, nodeX, nodeY, bottomLeftCenterX, bottomLeftCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] <= bottomLeftCenterX && arcIntersections[1] >= bottomLeftCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    return []; // if nothing
};
var $e815fda779bc047b$var$inLineVicinity = function inLineVicinity(x, y, lx1, ly1, lx2, ly2, tolerance) {
    var t = tolerance;
    var x1 = Math.min(lx1, lx2);
    var x2 = Math.max(lx1, lx2);
    var y1 = Math.min(ly1, ly2);
    var y2 = Math.max(ly1, ly2);
    return x1 - t <= x && x <= x2 + t && y1 - t <= y && y <= y2 + t;
};
var $e815fda779bc047b$var$inBezierVicinity = function inBezierVicinity(x, y, x1, y1, x2, y2, x3, y3, tolerance) {
    var bb = {
        x1: Math.min(x1, x3, x2) - tolerance,
        x2: Math.max(x1, x3, x2) + tolerance,
        y1: Math.min(y1, y3, y2) - tolerance,
        y2: Math.max(y1, y3, y2) + tolerance
    };
    // if outside the rough bounding box for the bezier, then it can't be a hit
    if (x < bb.x1 || x > bb.x2 || y < bb.y1 || y > bb.y2) // console.log('bezier out of rough bb')
    return false;
    else // console.log('do more expensive check');
    return true;
};
var $e815fda779bc047b$var$solveQuadratic = function solveQuadratic(a, b, c, val) {
    c -= val;
    var r = b * b - 4 * a * c;
    if (r < 0) return [];
    var sqrtR = Math.sqrt(r);
    var denom = 2 * a;
    var root1 = (-b + sqrtR) / denom;
    var root2 = (-b - sqrtR) / denom;
    return [
        root1,
        root2
    ];
};
var $e815fda779bc047b$var$solveCubic = function solveCubic(a, b, c, d, result) {
    // Solves a cubic function, returns root in form [r1, i1, r2, i2, r3, i3], where
    // r is the real component, i is the imaginary component
    // An implementation of the Cardano method from the year 1545
    // http://en.wikipedia.org/wiki/Cubic_function#The_nature_of_the_roots
    var epsilon = 0.00001;
    // avoid division by zero while keeping the overall expression close in value
    if (a === 0) a = epsilon;
    b /= a;
    c /= a;
    d /= a;
    var discriminant, q, r, dum1, s, t, term1, r13;
    q = (3.0 * c - b * b) / 9.0;
    r = -(27.0 * d) + b * (9.0 * c - 2.0 * (b * b));
    r /= 54.0;
    discriminant = q * q * q + r * r;
    result[1] = 0;
    term1 = b / 3.0;
    if (discriminant > 0) {
        s = r + Math.sqrt(discriminant);
        s = s < 0 ? -Math.pow(-s, 1.0 / 3.0) : Math.pow(s, 1.0 / 3.0);
        t = r - Math.sqrt(discriminant);
        t = t < 0 ? -Math.pow(-t, 1.0 / 3.0) : Math.pow(t, 1.0 / 3.0);
        result[0] = -term1 + s + t;
        term1 += (s + t) / 2.0;
        result[4] = result[2] = -term1;
        term1 = Math.sqrt(3.0) * (-t + s) / 2;
        result[3] = term1;
        result[5] = -term1;
        return;
    }
    result[5] = result[3] = 0;
    if (discriminant === 0) {
        r13 = r < 0 ? -Math.pow(-r, 1.0 / 3.0) : Math.pow(r, 1.0 / 3.0);
        result[0] = -term1 + 2.0 * r13;
        result[4] = result[2] = -(r13 + term1);
        return;
    }
    q = -q;
    dum1 = q * q * q;
    dum1 = Math.acos(r / Math.sqrt(dum1));
    r13 = 2.0 * Math.sqrt(q);
    result[0] = -term1 + r13 * Math.cos(dum1 / 3.0);
    result[2] = -term1 + r13 * Math.cos((dum1 + 2.0 * Math.PI) / 3.0);
    result[4] = -term1 + r13 * Math.cos((dum1 + 4.0 * Math.PI) / 3.0);
    return;
};
var $e815fda779bc047b$var$sqdistToQuadraticBezier = function sqdistToQuadraticBezier(x, y, x1, y1, x2, y2, x3, y3) {
    // Find minimum distance by using the minimum of the distance
    // function between the given point and the curve
    // This gives the coefficients of the resulting cubic equation
    // whose roots tell us where a possible minimum is
    // (Coefficients are divided by 4)
    var a = 1.0 * x1 * x1 - 4 * x1 * x2 + 2 * x1 * x3 + 4 * x2 * x2 - 4 * x2 * x3 + x3 * x3 + y1 * y1 - 4 * y1 * y2 + 2 * y1 * y3 + 4 * y2 * y2 - 4 * y2 * y3 + y3 * y3;
    var b = 9 * x1 * x2 - 3 * x1 * x1 - 3 * x1 * x3 - 6 * x2 * x2 + 3 * x2 * x3 + 9 * y1 * y2 - 3 * y1 * y1 - 3 * y1 * y3 - 6 * y2 * y2 + 3 * y2 * y3;
    var c = 3 * x1 * x1 - 6 * x1 * x2 + x1 * x3 - x1 * x + 2 * x2 * x2 + 2 * x2 * x - x3 * x + 3 * y1 * y1 - 6 * y1 * y2 + y1 * y3 - y1 * y + 2 * y2 * y2 + 2 * y2 * y - y3 * y;
    var d = 1.0 * x1 * x2 - x1 * x1 + x1 * x - x2 * x + y1 * y2 - y1 * y1 + y1 * y - y2 * y;
    // debug("coefficients: " + a / a + ", " + b / a + ", " + c / a + ", " + d / a);
    var roots = [];
    // Use the cubic solving algorithm
    $e815fda779bc047b$var$solveCubic(a, b, c, d, roots);
    var zeroThreshold = 0.0000001;
    var params = [];
    for(var index = 0; index < 6; index += 2)if (Math.abs(roots[index + 1]) < zeroThreshold && roots[index] >= 0 && roots[index] <= 1.0) params.push(roots[index]);
    params.push(1.0);
    params.push(0.0);
    var minDistanceSquared = -1;
    var curX, curY, distSquared;
    for(var i = 0; i < params.length; i++){
        curX = Math.pow(1.0 - params[i], 2.0) * x1 + 2.0 * (1 - params[i]) * params[i] * x2 + params[i] * params[i] * x3;
        curY = Math.pow(1 - params[i], 2.0) * y1 + 2 * (1.0 - params[i]) * params[i] * y2 + params[i] * params[i] * y3;
        distSquared = Math.pow(curX - x, 2) + Math.pow(curY - y, 2);
        // debug('distance for param ' + params[i] + ": " + Math.sqrt(distSquared));
        if (minDistanceSquared >= 0) {
            if (distSquared < minDistanceSquared) minDistanceSquared = distSquared;
        } else minDistanceSquared = distSquared;
    }
    return minDistanceSquared;
};
var $e815fda779bc047b$var$sqdistToFiniteLine = function sqdistToFiniteLine(x, y, x1, y1, x2, y2) {
    var offset = [
        x - x1,
        y - y1
    ];
    var line = [
        x2 - x1,
        y2 - y1
    ];
    var lineSq = line[0] * line[0] + line[1] * line[1];
    var hypSq = offset[0] * offset[0] + offset[1] * offset[1];
    var dotProduct = offset[0] * line[0] + offset[1] * line[1];
    var adjSq = dotProduct * dotProduct / lineSq;
    if (dotProduct < 0) return hypSq;
    if (adjSq > lineSq) return (x - x2) * (x - x2) + (y - y2) * (y - y2);
    return hypSq - adjSq;
};
var $e815fda779bc047b$var$pointInsidePolygonPoints = function pointInsidePolygonPoints(x, y, points) {
    var x1, y1, x2, y2;
    var y3;
    // Intersect with vertical line through (x, y)
    var up = 0;
    // let down = 0;
    for(var i = 0; i < points.length / 2; i++){
        x1 = points[i * 2];
        y1 = points[i * 2 + 1];
        if (i + 1 < points.length / 2) {
            x2 = points[(i + 1) * 2];
            y2 = points[(i + 1) * 2 + 1];
        } else {
            x2 = points[(i + 1 - points.length / 2) * 2];
            y2 = points[(i + 1 - points.length / 2) * 2 + 1];
        }
        if (x1 == x && x2 == x) ;
        else if (x1 >= x && x >= x2 || x1 <= x && x <= x2) {
            y3 = (x - x1) / (x2 - x1) * (y2 - y1) + y1;
            if (y3 > y) up++;
        // if( y3 < y ){
        // down++;
        // }
        } else continue;
    }
    if (up % 2 === 0) return false;
    else return true;
};
var $e815fda779bc047b$var$pointInsidePolygon = function pointInsidePolygon(x, y, basePoints, centerX, centerY, width, height, direction, padding) {
    var transformedPoints = new Array(basePoints.length);
    // Gives negative angle
    var angle;
    if (direction[0] != null) {
        angle = Math.atan(direction[1] / direction[0]);
        if (direction[0] < 0) angle = angle + Math.PI / 2;
        else angle = -angle - Math.PI / 2;
    } else angle = direction;
    var cos = Math.cos(-angle);
    var sin = Math.sin(-angle);
    //    console.log("base: " + basePoints);
    for(var i = 0; i < transformedPoints.length / 2; i++){
        transformedPoints[i * 2] = width / 2 * (basePoints[i * 2] * cos - basePoints[i * 2 + 1] * sin);
        transformedPoints[i * 2 + 1] = height / 2 * (basePoints[i * 2 + 1] * cos + basePoints[i * 2] * sin);
        transformedPoints[i * 2] += centerX;
        transformedPoints[i * 2 + 1] += centerY;
    }
    var points;
    if (padding > 0) {
        var expandedLineSet = $e815fda779bc047b$var$expandPolygon(transformedPoints, -padding);
        points = $e815fda779bc047b$var$joinLines(expandedLineSet);
    } else points = transformedPoints;
    return $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, points);
};
var $e815fda779bc047b$var$pointInsideRoundPolygon = function pointInsideRoundPolygon(x, y, basePoints, centerX, centerY, width, height, corners) {
    var cutPolygonPoints = new Array(basePoints.length * 2);
    for(var i = 0; i < corners.length; i++){
        var corner = corners[i];
        cutPolygonPoints[i * 4 + 0] = corner.startX;
        cutPolygonPoints[i * 4 + 1] = corner.startY;
        cutPolygonPoints[i * 4 + 2] = corner.stopX;
        cutPolygonPoints[i * 4 + 3] = corner.stopY;
        var squaredDistance = Math.pow(corner.cx - x, 2) + Math.pow(corner.cy - y, 2);
        if (squaredDistance <= Math.pow(corner.radius, 2)) return true;
    }
    return $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, cutPolygonPoints);
};
var $e815fda779bc047b$var$joinLines = function joinLines(lineSet) {
    var vertices = new Array(lineSet.length / 2);
    var currentLineStartX, currentLineStartY, currentLineEndX, currentLineEndY;
    var nextLineStartX, nextLineStartY, nextLineEndX, nextLineEndY;
    for(var i = 0; i < lineSet.length / 4; i++){
        currentLineStartX = lineSet[i * 4];
        currentLineStartY = lineSet[i * 4 + 1];
        currentLineEndX = lineSet[i * 4 + 2];
        currentLineEndY = lineSet[i * 4 + 3];
        if (i < lineSet.length / 4 - 1) {
            nextLineStartX = lineSet[(i + 1) * 4];
            nextLineStartY = lineSet[(i + 1) * 4 + 1];
            nextLineEndX = lineSet[(i + 1) * 4 + 2];
            nextLineEndY = lineSet[(i + 1) * 4 + 3];
        } else {
            nextLineStartX = lineSet[0];
            nextLineStartY = lineSet[1];
            nextLineEndX = lineSet[2];
            nextLineEndY = lineSet[3];
        }
        var intersection = $e815fda779bc047b$var$finiteLinesIntersect(currentLineStartX, currentLineStartY, currentLineEndX, currentLineEndY, nextLineStartX, nextLineStartY, nextLineEndX, nextLineEndY, true);
        vertices[i * 2] = intersection[0];
        vertices[i * 2 + 1] = intersection[1];
    }
    return vertices;
};
var $e815fda779bc047b$var$expandPolygon = function expandPolygon(points, pad) {
    var expandedLineSet = new Array(points.length * 2);
    var currentPointX, currentPointY, nextPointX, nextPointY;
    for(var i = 0; i < points.length / 2; i++){
        currentPointX = points[i * 2];
        currentPointY = points[i * 2 + 1];
        if (i < points.length / 2 - 1) {
            nextPointX = points[(i + 1) * 2];
            nextPointY = points[(i + 1) * 2 + 1];
        } else {
            nextPointX = points[0];
            nextPointY = points[1];
        }
        // Current line: [currentPointX, currentPointY] to [nextPointX, nextPointY]
        // Assume CCW polygon winding
        var offsetX = nextPointY - currentPointY;
        var offsetY = -(nextPointX - currentPointX);
        // Normalize
        var offsetLength = Math.sqrt(offsetX * offsetX + offsetY * offsetY);
        var normalizedOffsetX = offsetX / offsetLength;
        var normalizedOffsetY = offsetY / offsetLength;
        expandedLineSet[i * 4] = currentPointX + normalizedOffsetX * pad;
        expandedLineSet[i * 4 + 1] = currentPointY + normalizedOffsetY * pad;
        expandedLineSet[i * 4 + 2] = nextPointX + normalizedOffsetX * pad;
        expandedLineSet[i * 4 + 3] = nextPointY + normalizedOffsetY * pad;
    }
    return expandedLineSet;
};
var $e815fda779bc047b$var$intersectLineEllipse = function intersectLineEllipse(x, y, centerX, centerY, ellipseWradius, ellipseHradius) {
    var dispX = centerX - x;
    var dispY = centerY - y;
    dispX /= ellipseWradius;
    dispY /= ellipseHradius;
    var len = Math.sqrt(dispX * dispX + dispY * dispY);
    var newLength = len - 1;
    if (newLength < 0) return [];
    var lenProportion = newLength / len;
    return [
        (centerX - x) * lenProportion + x,
        (centerY - y) * lenProportion + y
    ];
};
var $e815fda779bc047b$var$checkInEllipse = function checkInEllipse(x, y, width, height, centerX, centerY, padding) {
    x -= centerX;
    y -= centerY;
    x /= width / 2 + padding;
    y /= height / 2 + padding;
    return x * x + y * y <= 1;
};
// Returns intersections of increasing distance from line's start point
var $e815fda779bc047b$var$intersectLineCircle = function intersectLineCircle(x1, y1, x2, y2, centerX, centerY, radius) {
    // Calculate d, direction vector of line
    var d = [
        x2 - x1,
        y2 - y1
    ]; // Direction vector of line
    var f = [
        x1 - centerX,
        y1 - centerY
    ];
    var a = d[0] * d[0] + d[1] * d[1];
    var b = 2 * (f[0] * d[0] + f[1] * d[1]);
    var c = f[0] * f[0] + f[1] * f[1] - radius * radius;
    var discriminant = b * b - 4 * a * c;
    if (discriminant < 0) return [];
    var t1 = (-b + Math.sqrt(discriminant)) / (2 * a);
    var t2 = (-b - Math.sqrt(discriminant)) / (2 * a);
    var tMin = Math.min(t1, t2);
    var tMax = Math.max(t1, t2);
    var inRangeParams = [];
    if (tMin >= 0 && tMin <= 1) inRangeParams.push(tMin);
    if (tMax >= 0 && tMax <= 1) inRangeParams.push(tMax);
    if (inRangeParams.length === 0) return [];
    var nearIntersectionX = inRangeParams[0] * d[0] + x1;
    var nearIntersectionY = inRangeParams[0] * d[1] + y1;
    if (inRangeParams.length > 1) {
        if (inRangeParams[0] == inRangeParams[1]) return [
            nearIntersectionX,
            nearIntersectionY
        ];
        else {
            var farIntersectionX = inRangeParams[1] * d[0] + x1;
            var farIntersectionY = inRangeParams[1] * d[1] + y1;
            return [
                nearIntersectionX,
                nearIntersectionY,
                farIntersectionX,
                farIntersectionY
            ];
        }
    } else return [
        nearIntersectionX,
        nearIntersectionY
    ];
};
var $e815fda779bc047b$var$midOfThree = function midOfThree(a, b, c) {
    if (b <= a && a <= c || c <= a && a <= b) return a;
    else if (a <= b && b <= c || c <= b && b <= a) return b;
    else return c;
};
// (x1,y1)=>(x2,y2) intersect with (x3,y3)=>(x4,y4)
var $e815fda779bc047b$var$finiteLinesIntersect = function finiteLinesIntersect(x1, y1, x2, y2, x3, y3, x4, y4, infiniteLines) {
    var dx13 = x1 - x3;
    var dx21 = x2 - x1;
    var dx43 = x4 - x3;
    var dy13 = y1 - y3;
    var dy21 = y2 - y1;
    var dy43 = y4 - y3;
    var ua_t = dx43 * dy13 - dy43 * dx13;
    var ub_t = dx21 * dy13 - dy21 * dx13;
    var u_b = dy43 * dx21 - dx43 * dy21;
    if (u_b !== 0) {
        var ua = ua_t / u_b;
        var ub = ub_t / u_b;
        var flptThreshold = 0.001;
        var _min = 0 - flptThreshold;
        var _max = 1 + flptThreshold;
        if (_min <= ua && ua <= _max && _min <= ub && ub <= _max) return [
            x1 + ua * dx21,
            y1 + ua * dy21
        ];
        else {
            if (!infiniteLines) return [];
            else return [
                x1 + ua * dx21,
                y1 + ua * dy21
            ];
        }
    } else {
        if (ua_t === 0 || ub_t === 0) {
            // Parallel, coincident lines. Check if overlap
            // Check endpoint of second line
            if ($e815fda779bc047b$var$midOfThree(x1, x2, x4) === x4) return [
                x4,
                y4
            ];
            // Check start point of second line
            if ($e815fda779bc047b$var$midOfThree(x1, x2, x3) === x3) return [
                x3,
                y3
            ];
            // Endpoint of first line
            if ($e815fda779bc047b$var$midOfThree(x3, x4, x2) === x2) return [
                x2,
                y2
            ];
            return [];
        } else // Parallel, non-coincident
        return [];
    }
};
// math.polygonIntersectLine( x, y, basePoints, centerX, centerY, width, height, padding )
// intersect a node polygon (pts transformed)
//
// math.polygonIntersectLine( x, y, basePoints, centerX, centerY )
// intersect the points (no transform)
var $e815fda779bc047b$var$polygonIntersectLine = function polygonIntersectLine(x, y, basePoints, centerX, centerY, width, height, padding) {
    var intersections = [];
    var intersection;
    var transformedPoints = new Array(basePoints.length);
    var doTransform = true;
    if (width == null) doTransform = false;
    var points;
    if (doTransform) {
        for(var i = 0; i < transformedPoints.length / 2; i++){
            transformedPoints[i * 2] = basePoints[i * 2] * width + centerX;
            transformedPoints[i * 2 + 1] = basePoints[i * 2 + 1] * height + centerY;
        }
        if (padding > 0) {
            var expandedLineSet = $e815fda779bc047b$var$expandPolygon(transformedPoints, -padding);
            points = $e815fda779bc047b$var$joinLines(expandedLineSet);
        } else points = transformedPoints;
    } else points = basePoints;
    var currentX, currentY, nextX, nextY;
    for(var _i2 = 0; _i2 < points.length / 2; _i2++){
        currentX = points[_i2 * 2];
        currentY = points[_i2 * 2 + 1];
        if (_i2 < points.length / 2 - 1) {
            nextX = points[(_i2 + 1) * 2];
            nextY = points[(_i2 + 1) * 2 + 1];
        } else {
            nextX = points[0];
            nextY = points[1];
        }
        intersection = $e815fda779bc047b$var$finiteLinesIntersect(x, y, centerX, centerY, currentX, currentY, nextX, nextY);
        if (intersection.length !== 0) intersections.push(intersection[0], intersection[1]);
    }
    return intersections;
};
var $e815fda779bc047b$var$roundPolygonIntersectLine = function roundPolygonIntersectLine(x, y, basePoints, centerX, centerY, width, height, padding, corners) {
    var intersections = [];
    var intersection;
    var lines = new Array(basePoints.length * 2);
    corners.forEach(function(corner, i) {
        if (i === 0) {
            lines[lines.length - 2] = corner.startX;
            lines[lines.length - 1] = corner.startY;
        } else {
            lines[i * 4 - 2] = corner.startX;
            lines[i * 4 - 1] = corner.startY;
        }
        lines[i * 4] = corner.stopX;
        lines[i * 4 + 1] = corner.stopY;
        intersection = $e815fda779bc047b$var$intersectLineCircle(x, y, centerX, centerY, corner.cx, corner.cy, corner.radius);
        if (intersection.length !== 0) intersections.push(intersection[0], intersection[1]);
    });
    for(var i = 0; i < lines.length / 4; i++){
        intersection = $e815fda779bc047b$var$finiteLinesIntersect(x, y, centerX, centerY, lines[i * 4], lines[i * 4 + 1], lines[i * 4 + 2], lines[i * 4 + 3], false);
        if (intersection.length !== 0) intersections.push(intersection[0], intersection[1]);
    }
    if (intersections.length > 2) {
        var lowestIntersection = [
            intersections[0],
            intersections[1]
        ];
        var lowestSquaredDistance = Math.pow(lowestIntersection[0] - x, 2) + Math.pow(lowestIntersection[1] - y, 2);
        for(var _i3 = 1; _i3 < intersections.length / 2; _i3++){
            var squaredDistance = Math.pow(intersections[_i3 * 2] - x, 2) + Math.pow(intersections[_i3 * 2 + 1] - y, 2);
            if (squaredDistance <= lowestSquaredDistance) {
                lowestIntersection[0] = intersections[_i3 * 2];
                lowestIntersection[1] = intersections[_i3 * 2 + 1];
                lowestSquaredDistance = squaredDistance;
            }
        }
        return lowestIntersection;
    }
    return intersections;
};
var $e815fda779bc047b$var$shortenIntersection = function shortenIntersection(intersection, offset, amount) {
    var disp = [
        intersection[0] - offset[0],
        intersection[1] - offset[1]
    ];
    var length = Math.sqrt(disp[0] * disp[0] + disp[1] * disp[1]);
    var lenRatio = (length - amount) / length;
    if (lenRatio < 0) lenRatio = 0.00001;
    return [
        offset[0] + lenRatio * disp[0],
        offset[1] + lenRatio * disp[1]
    ];
};
var $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare = function generateUnitNgonPointsFitToSquare(sides, rotationRadians) {
    var points = $e815fda779bc047b$var$generateUnitNgonPoints(sides, rotationRadians);
    points = $e815fda779bc047b$var$fitPolygonToSquare(points);
    return points;
};
var $e815fda779bc047b$var$fitPolygonToSquare = function fitPolygonToSquare(points) {
    var x, y;
    var sides = points.length / 2;
    var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for(var i = 0; i < sides; i++){
        x = points[2 * i];
        y = points[2 * i + 1];
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
    }
    // stretch factors
    var sx = 2 / (maxX - minX);
    var sy = 2 / (maxY - minY);
    for(var _i4 = 0; _i4 < sides; _i4++){
        x = points[2 * _i4] = points[2 * _i4] * sx;
        y = points[2 * _i4 + 1] = points[2 * _i4 + 1] * sy;
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
    }
    if (minY < -1) for(var _i5 = 0; _i5 < sides; _i5++)y = points[2 * _i5 + 1] = points[2 * _i5 + 1] + (-1 - minY);
    return points;
};
var $e815fda779bc047b$var$generateUnitNgonPoints = function generateUnitNgonPoints(sides, rotationRadians) {
    var increment = 1.0 / sides * 2 * Math.PI;
    var startAngle = sides % 2 === 0 ? Math.PI / 2.0 + increment / 2.0 : Math.PI / 2.0;
    startAngle += rotationRadians;
    var points = new Array(sides * 2);
    var currentAngle;
    for(var i = 0; i < sides; i++){
        currentAngle = i * increment + startAngle;
        points[2 * i] = Math.cos(currentAngle); // x
        points[2 * i + 1] = Math.sin(-currentAngle); // y
    }
    return points;
};
// Set the default radius, unless half of width or height is smaller than default
var $e815fda779bc047b$var$getRoundRectangleRadius = function getRoundRectangleRadius(width, height) {
    return Math.min(width / 4, height / 4, 8);
};
// Set the default radius
var $e815fda779bc047b$var$getRoundPolygonRadius = function getRoundPolygonRadius(width, height) {
    return Math.min(width / 10, height / 10, 8);
};
var $e815fda779bc047b$var$getCutRectangleCornerLength = function getCutRectangleCornerLength() {
    return 8;
};
var $e815fda779bc047b$var$bezierPtsToQuadCoeff = function bezierPtsToQuadCoeff(p0, p1, p2) {
    return [
        p0 - 2 * p1 + p2,
        2 * (p1 - p0),
        p0
    ];
};
// get curve width, height, and control point position offsets as a percentage of node height / width
var $e815fda779bc047b$var$getBarrelCurveConstants = function getBarrelCurveConstants(width, height) {
    return {
        heightOffset: Math.min(15, 0.05 * height),
        widthOffset: Math.min(100, 0.25 * width),
        ctrlPtOffsetPct: 0.05
    };
};
var $e815fda779bc047b$var$pageRankDefaults = $e815fda779bc047b$var$defaults$g({
    dampingFactor: 0.8,
    precision: 0.000001,
    iterations: 200,
    weight: function weight(edge) {
        return 1;
    }
});
var $e815fda779bc047b$var$elesfn$o = {
    pageRank: function pageRank(options) {
        var _pageRankDefaults = $e815fda779bc047b$var$pageRankDefaults(options), dampingFactor = _pageRankDefaults.dampingFactor, precision = _pageRankDefaults.precision, iterations = _pageRankDefaults.iterations, weight = _pageRankDefaults.weight;
        var cy = this._private.cy;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        var numNodes = nodes.length;
        var numNodesSqd = numNodes * numNodes;
        var numEdges = edges.length;
        // Construct transposed adjacency matrix
        // First lets have a zeroed matrix of the right size
        // We'll also keep track of the sum of each column
        var matrix = new Array(numNodesSqd);
        var columnSum = new Array(numNodes);
        var additionalProb = (1 - dampingFactor) / numNodes;
        // Create null matrix
        for(var i = 0; i < numNodes; i++){
            for(var j = 0; j < numNodes; j++){
                var n = i * numNodes + j;
                matrix[n] = 0;
            }
            columnSum[i] = 0;
        }
        // Now, process edges
        for(var _i = 0; _i < numEdges; _i++){
            var edge = edges[_i];
            var srcId = edge.data('source');
            var tgtId = edge.data('target');
            // Don't include loops in the matrix
            if (srcId === tgtId) continue;
            var s = nodes.indexOfId(srcId);
            var t = nodes.indexOfId(tgtId);
            var w = weight(edge);
            var _n = t * numNodes + s;
            // Update matrix
            matrix[_n] += w;
            // Update column sum
            columnSum[s] += w;
        }
        // Add additional probability based on damping factor
        // Also, take into account columns that have sum = 0
        var p = 1.0 / numNodes + additionalProb; // Shorthand
        // Traverse matrix, column by column
        for(var _j = 0; _j < numNodes; _j++){
            if (columnSum[_j] === 0) // No 'links' out from node jth, assume equal probability for each possible node
            for(var _i2 = 0; _i2 < numNodes; _i2++){
                var _n2 = _i2 * numNodes + _j;
                matrix[_n2] = p;
            }
            else // Node jth has outgoing link, compute normalized probabilities
            for(var _i3 = 0; _i3 < numNodes; _i3++){
                var _n3 = _i3 * numNodes + _j;
                matrix[_n3] = matrix[_n3] / columnSum[_j] + additionalProb;
            }
        }
        // Compute dominant eigenvector using power method
        var eigenvector = new Array(numNodes);
        var temp = new Array(numNodes);
        var previous;
        // Start with a vector of all 1's
        // Also, initialize a null vector which will be used as shorthand
        for(var _i4 = 0; _i4 < numNodes; _i4++)eigenvector[_i4] = 1;
        for(var iter = 0; iter < iterations; iter++){
            // Temp array with all 0's
            for(var _i5 = 0; _i5 < numNodes; _i5++)temp[_i5] = 0;
            // Multiply matrix with previous result
            for(var _i6 = 0; _i6 < numNodes; _i6++)for(var _j2 = 0; _j2 < numNodes; _j2++){
                var _n4 = _i6 * numNodes + _j2;
                temp[_i6] += matrix[_n4] * eigenvector[_j2];
            }
            $e815fda779bc047b$var$inPlaceSumNormalize(temp);
            previous = eigenvector;
            eigenvector = temp;
            temp = previous;
            var diff = 0;
            // Compute difference (squared module) of both vectors
            for(var _i7 = 0; _i7 < numNodes; _i7++){
                var delta = previous[_i7] - eigenvector[_i7];
                diff += delta * delta;
            }
            // If difference is less than the desired threshold, stop iterating
            if (diff < precision) break;
        }
        // Construct result
        var res = {
            rank: function rank(node) {
                node = cy.collection(node)[0];
                return eigenvector[nodes.indexOf(node)];
            }
        };
        return res;
    } // pageRank
}; // elesfn
var $e815fda779bc047b$var$defaults$f = $e815fda779bc047b$var$defaults$g({
    root: null,
    weight: function weight(edge) {
        return 1;
    },
    directed: false,
    alpha: 0
});
var $e815fda779bc047b$var$elesfn$n = {
    degreeCentralityNormalized: function degreeCentralityNormalized(options) {
        options = $e815fda779bc047b$var$defaults$f(options);
        var cy = this.cy();
        var nodes = this.nodes();
        var numNodes = nodes.length;
        if (!options.directed) {
            var degrees = {};
            var maxDegree = 0;
            for(var i = 0; i < numNodes; i++){
                var node = nodes[i];
                // add current node to the current options object and call degreeCentrality
                options.root = node;
                var currDegree = this.degreeCentrality(options);
                if (maxDegree < currDegree.degree) maxDegree = currDegree.degree;
                degrees[node.id()] = currDegree.degree;
            }
            return {
                degree: function degree(node) {
                    if (maxDegree === 0) return 0;
                    if ($e815fda779bc047b$var$string(node)) // from is a selector string
                    node = cy.filter(node);
                    return degrees[node.id()] / maxDegree;
                }
            };
        } else {
            var indegrees = {};
            var outdegrees = {};
            var maxIndegree = 0;
            var maxOutdegree = 0;
            for(var _i = 0; _i < numNodes; _i++){
                var _node = nodes[_i];
                var id = _node.id();
                // add current node to the current options object and call degreeCentrality
                options.root = _node;
                var _currDegree = this.degreeCentrality(options);
                if (maxIndegree < _currDegree.indegree) maxIndegree = _currDegree.indegree;
                if (maxOutdegree < _currDegree.outdegree) maxOutdegree = _currDegree.outdegree;
                indegrees[id] = _currDegree.indegree;
                outdegrees[id] = _currDegree.outdegree;
            }
            return {
                indegree: function indegree(node) {
                    if (maxIndegree == 0) return 0;
                    if ($e815fda779bc047b$var$string(node)) // from is a selector string
                    node = cy.filter(node);
                    return indegrees[node.id()] / maxIndegree;
                },
                outdegree: function outdegree(node) {
                    if (maxOutdegree === 0) return 0;
                    if ($e815fda779bc047b$var$string(node)) // from is a selector string
                    node = cy.filter(node);
                    return outdegrees[node.id()] / maxOutdegree;
                }
            };
        }
    },
    // degreeCentralityNormalized
    // Implemented from the algorithm in Opsahl's paper
    // "Node centrality in weighted networks: Generalizing degree and shortest paths"
    // check the heading 2 "Degree"
    degreeCentrality: function degreeCentrality(options) {
        options = $e815fda779bc047b$var$defaults$f(options);
        var cy = this.cy();
        var callingEles = this;
        var _options = options, root = _options.root, weight = _options.weight, directed = _options.directed, alpha = _options.alpha;
        root = cy.collection(root)[0];
        if (!directed) {
            var connEdges = root.connectedEdges().intersection(callingEles);
            var k = connEdges.length;
            var s = 0;
            // Now, sum edge weights
            for(var i = 0; i < connEdges.length; i++)s += weight(connEdges[i]);
            return {
                degree: Math.pow(k, 1 - alpha) * Math.pow(s, alpha)
            };
        } else {
            var edges = root.connectedEdges();
            var incoming = edges.filter(function(edge) {
                return edge.target().same(root) && callingEles.has(edge);
            });
            var outgoing = edges.filter(function(edge) {
                return edge.source().same(root) && callingEles.has(edge);
            });
            var k_in = incoming.length;
            var k_out = outgoing.length;
            var s_in = 0;
            var s_out = 0;
            // Now, sum incoming edge weights
            for(var _i2 = 0; _i2 < incoming.length; _i2++)s_in += weight(incoming[_i2]);
            // Now, sum outgoing edge weights
            for(var _i3 = 0; _i3 < outgoing.length; _i3++)s_out += weight(outgoing[_i3]);
            return {
                indegree: Math.pow(k_in, 1 - alpha) * Math.pow(s_in, alpha),
                outdegree: Math.pow(k_out, 1 - alpha) * Math.pow(s_out, alpha)
            };
        }
    } // degreeCentrality
}; // elesfn
// nice, short mathematical alias
$e815fda779bc047b$var$elesfn$n.dc = $e815fda779bc047b$var$elesfn$n.degreeCentrality;
$e815fda779bc047b$var$elesfn$n.dcn = $e815fda779bc047b$var$elesfn$n.degreeCentralityNormalised = $e815fda779bc047b$var$elesfn$n.degreeCentralityNormalized;
var $e815fda779bc047b$var$defaults$e = $e815fda779bc047b$var$defaults$g({
    harmonic: true,
    weight: function weight() {
        return 1;
    },
    directed: false,
    root: null
});
var $e815fda779bc047b$var$elesfn$m = {
    closenessCentralityNormalized: function closenessCentralityNormalized(options) {
        var _defaults = $e815fda779bc047b$var$defaults$e(options), harmonic = _defaults.harmonic, weight = _defaults.weight, directed = _defaults.directed;
        var cy = this.cy();
        var closenesses = {};
        var maxCloseness = 0;
        var nodes = this.nodes();
        var fw = this.floydWarshall({
            weight: weight,
            directed: directed
        });
        // Compute closeness for every node and find the maximum closeness
        for(var i = 0; i < nodes.length; i++){
            var currCloseness = 0;
            var node_i = nodes[i];
            for(var j = 0; j < nodes.length; j++)if (i !== j) {
                var d = fw.distance(node_i, nodes[j]);
                if (harmonic) currCloseness += 1 / d;
                else currCloseness += d;
            }
            if (!harmonic) currCloseness = 1 / currCloseness;
            if (maxCloseness < currCloseness) maxCloseness = currCloseness;
            closenesses[node_i.id()] = currCloseness;
        }
        return {
            closeness: function closeness(node) {
                if (maxCloseness == 0) return 0;
                if ($e815fda779bc047b$var$string(node)) // from is a selector string
                node = cy.filter(node)[0].id();
                else // from is a node
                node = node.id();
                return closenesses[node] / maxCloseness;
            }
        };
    },
    // Implemented from pseudocode from wikipedia
    closenessCentrality: function closenessCentrality(options) {
        var _defaults2 = $e815fda779bc047b$var$defaults$e(options), root = _defaults2.root, weight = _defaults2.weight, directed = _defaults2.directed, harmonic = _defaults2.harmonic;
        root = this.filter(root)[0];
        // we need distance from this node to every other node
        var dijkstra = this.dijkstra({
            root: root,
            weight: weight,
            directed: directed
        });
        var totalDistance = 0;
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++){
            var n = nodes[i];
            if (!n.same(root)) {
                var d = dijkstra.distanceTo(n);
                if (harmonic) totalDistance += 1 / d;
                else totalDistance += d;
            }
        }
        return harmonic ? totalDistance : 1 / totalDistance;
    } // closenessCentrality
}; // elesfn
// nice, short mathematical alias
$e815fda779bc047b$var$elesfn$m.cc = $e815fda779bc047b$var$elesfn$m.closenessCentrality;
$e815fda779bc047b$var$elesfn$m.ccn = $e815fda779bc047b$var$elesfn$m.closenessCentralityNormalised = $e815fda779bc047b$var$elesfn$m.closenessCentralityNormalized;
var $e815fda779bc047b$var$defaults$d = $e815fda779bc047b$var$defaults$g({
    weight: null,
    directed: false
});
var $e815fda779bc047b$var$elesfn$l = {
    // Implemented from the algorithm in the paper "On Variants of Shortest-Path Betweenness Centrality and their Generic Computation" by Ulrik Brandes
    betweennessCentrality: function betweennessCentrality(options) {
        var _defaults = $e815fda779bc047b$var$defaults$d(options), directed = _defaults.directed, weight = _defaults.weight;
        var weighted = weight != null;
        var cy = this.cy();
        // starting
        var V = this.nodes();
        var A = {};
        var _C = {};
        var max = 0;
        var C = {
            set: function set(key, val) {
                _C[key] = val;
                if (val > max) max = val;
            },
            get: function get(key) {
                return _C[key];
            }
        };
        // A contains the neighborhoods of every node
        for(var i = 0; i < V.length; i++){
            var v = V[i];
            var vid = v.id();
            if (directed) A[vid] = v.outgoers().nodes(); // get outgoers of every node
            else A[vid] = v.openNeighborhood().nodes(); // get neighbors of every node
            C.set(vid, 0);
        }
        var _loop = function _loop(s) {
            var sid = V[s].id();
            var S = []; // stack
            var P = {};
            var g = {};
            var d = {};
            var Q = new $e815fda779bc047b$var$heap(function(a, b) {
                return d[a] - d[b];
            }); // queue
            // init dictionaries
            for(var _i = 0; _i < V.length; _i++){
                var _vid = V[_i].id();
                P[_vid] = [];
                g[_vid] = 0;
                d[_vid] = Infinity;
            }
            g[sid] = 1; // sigma
            d[sid] = 0; // distance to s
            Q.push(sid);
            while(!Q.empty()){
                var _v = Q.pop();
                S.push(_v);
                if (weighted) for(var j = 0; j < A[_v].length; j++){
                    var w = A[_v][j];
                    var vEle = cy.getElementById(_v);
                    var edge = void 0;
                    if (vEle.edgesTo(w).length > 0) edge = vEle.edgesTo(w)[0];
                    else edge = w.edgesTo(vEle)[0];
                    var edgeWeight = weight(edge);
                    w = w.id();
                    if (d[w] > d[_v] + edgeWeight) {
                        d[w] = d[_v] + edgeWeight;
                        if (Q.nodes.indexOf(w) < 0) //if w is not in Q
                        Q.push(w);
                        else // update position if w is in Q
                        Q.updateItem(w);
                        g[w] = 0;
                        P[w] = [];
                    }
                    if (d[w] == d[_v] + edgeWeight) {
                        g[w] = g[w] + g[_v];
                        P[w].push(_v);
                    }
                }
                else for(var _j = 0; _j < A[_v].length; _j++){
                    var _w = A[_v][_j].id();
                    if (d[_w] == Infinity) {
                        Q.push(_w);
                        d[_w] = d[_v] + 1;
                    }
                    if (d[_w] == d[_v] + 1) {
                        g[_w] = g[_w] + g[_v];
                        P[_w].push(_v);
                    }
                }
            }
            var e = {};
            for(var _i2 = 0; _i2 < V.length; _i2++)e[V[_i2].id()] = 0;
            while(S.length > 0){
                var _w2 = S.pop();
                for(var _j2 = 0; _j2 < P[_w2].length; _j2++){
                    var _v2 = P[_w2][_j2];
                    e[_v2] = e[_v2] + g[_v2] / g[_w2] * (1 + e[_w2]);
                }
                if (_w2 != V[s].id()) C.set(_w2, C.get(_w2) + e[_w2]);
            }
        };
        for(var s = 0; s < V.length; s++)_loop(s);
        var ret = {
            betweenness: function betweenness(node) {
                var id = cy.collection(node).id();
                return C.get(id);
            },
            betweennessNormalized: function betweennessNormalized(node) {
                if (max == 0) return 0;
                var id = cy.collection(node).id();
                return C.get(id) / max;
            }
        };
        // alias
        ret.betweennessNormalised = ret.betweennessNormalized;
        return ret;
    } // betweennessCentrality
}; // elesfn
// nice, short mathematical alias
$e815fda779bc047b$var$elesfn$l.bc = $e815fda779bc047b$var$elesfn$l.betweennessCentrality;
// Implemented by Zoe Xi @zoexi for GSOC 2016
/* eslint-disable no-unused-vars */ var $e815fda779bc047b$var$defaults$c = $e815fda779bc047b$var$defaults$g({
    expandFactor: 2,
    // affects time of computation and cluster granularity to some extent: M * M
    inflateFactor: 2,
    // affects cluster granularity (the greater the value, the more clusters): M(i,j) / E(j)
    multFactor: 1,
    // optional self loops for each node. Use a neutral value to improve cluster computations.
    maxIterations: 20,
    // maximum number of iterations of the MCL algorithm in a single run
    attributes: [
        // attributes/features used to group nodes, ie. similarity values between nodes
        function(edge) {
            return 1;
        }
    ]
});
/* eslint-enable */ var $e815fda779bc047b$var$setOptions$3 = function setOptions(options) {
    return $e815fda779bc047b$var$defaults$c(options);
};
/* eslint-enable */ var $e815fda779bc047b$var$getSimilarity$1 = function getSimilarity(edge, attributes) {
    var total = 0;
    for(var i = 0; i < attributes.length; i++)total += attributes[i](edge);
    return total;
};
var $e815fda779bc047b$var$addLoops = function addLoops(M, n, val) {
    for(var i = 0; i < n; i++)M[i * n + i] = val;
};
var $e815fda779bc047b$var$normalize = function normalize(M, n) {
    var sum;
    for(var col = 0; col < n; col++){
        sum = 0;
        for(var row = 0; row < n; row++)sum += M[row * n + col];
        for(var _row = 0; _row < n; _row++)M[_row * n + col] = M[_row * n + col] / sum;
    }
};
// TODO: blocked matrix multiplication?
var $e815fda779bc047b$var$mmult = function mmult(A, B, n) {
    var C = new Array(n * n);
    for(var i = 0; i < n; i++){
        for(var j = 0; j < n; j++)C[i * n + j] = 0;
        for(var k = 0; k < n; k++)for(var _j = 0; _j < n; _j++)C[i * n + _j] += A[i * n + k] * B[k * n + _j];
    }
    return C;
};
var $e815fda779bc047b$var$expand = function expand(M, n, expandFactor /** power **/ ) {
    var _M = M.slice(0);
    for(var p = 1; p < expandFactor; p++)M = $e815fda779bc047b$var$mmult(M, _M, n);
    return M;
};
var $e815fda779bc047b$var$inflate = function inflate(M, n, inflateFactor /** r **/ ) {
    var _M = new Array(n * n);
    // M(i,j) ^ inflatePower
    for(var i = 0; i < n * n; i++)_M[i] = Math.pow(M[i], inflateFactor);
    $e815fda779bc047b$var$normalize(_M, n);
    return _M;
};
var $e815fda779bc047b$var$hasConverged = function hasConverged(M, _M, n2, roundFactor) {
    // Check that both matrices have the same elements (i,j)
    for(var i = 0; i < n2; i++){
        var v1 = Math.round(M[i] * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor); // truncate to 'roundFactor' decimal places
        var v2 = Math.round(_M[i] * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor);
        if (v1 !== v2) return false;
    }
    return true;
};
var $e815fda779bc047b$var$assign$2 = function assign(M, n, nodes, cy) {
    var clusters = [];
    for(var i = 0; i < n; i++){
        var cluster = [];
        for(var j = 0; j < n; j++)// Row-wise attractors and elements that they attract belong in same cluster
        if (Math.round(M[i * n + j] * 1000) / 1000 > 0) cluster.push(nodes[j]);
        if (cluster.length !== 0) clusters.push(cy.collection(cluster));
    }
    return clusters;
};
var $e815fda779bc047b$var$isDuplicate = function isDuplicate(c1, c2) {
    for(var i = 0; i < c1.length; i++){
        if (!c2[i] || c1[i].id() !== c2[i].id()) return false;
    }
    return true;
};
var $e815fda779bc047b$var$removeDuplicates = function removeDuplicates(clusters) {
    for(var i = 0; i < clusters.length; i++){
        for(var j = 0; j < clusters.length; j++)if (i != j && $e815fda779bc047b$var$isDuplicate(clusters[i], clusters[j])) clusters.splice(j, 1);
    }
    return clusters;
};
var $e815fda779bc047b$var$markovClustering = function markovClustering(options) {
    var nodes = this.nodes();
    var edges = this.edges();
    var cy = this.cy();
    // Set parameters of algorithm:
    var opts = $e815fda779bc047b$var$setOptions$3(options);
    // Map each node to its position in node array
    var id2position = {};
    for(var i = 0; i < nodes.length; i++)id2position[nodes[i].id()] = i;
    // Generate stochastic matrix M from input graph G (should be symmetric/undirected)
    var n = nodes.length, n2 = n * n;
    var M = new Array(n2), _M;
    for(var _i = 0; _i < n2; _i++)M[_i] = 0;
    for(var e = 0; e < edges.length; e++){
        var edge = edges[e];
        var _i2 = id2position[edge.source().id()];
        var j = id2position[edge.target().id()];
        var sim = $e815fda779bc047b$var$getSimilarity$1(edge, opts.attributes);
        M[_i2 * n + j] += sim; // G should be symmetric and undirected
        M[j * n + _i2] += sim;
    }
    // Begin Markov cluster algorithm
    // Step 1: Add self loops to each node, ie. add multFactor to matrix diagonal
    $e815fda779bc047b$var$addLoops(M, n, opts.multFactor);
    // Step 2: M = normalize( M );
    $e815fda779bc047b$var$normalize(M, n);
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        isStillMoving = false;
        // Step 3:
        _M = $e815fda779bc047b$var$expand(M, n, opts.expandFactor);
        // Step 4:
        M = $e815fda779bc047b$var$inflate(_M, n, opts.inflateFactor);
        // Step 5: check to see if ~steady state has been reached
        if (!$e815fda779bc047b$var$hasConverged(M, _M, n2, 4)) isStillMoving = true;
        iterations++;
    }
    // Build clusters from matrix
    var clusters = $e815fda779bc047b$var$assign$2(M, n, nodes, cy);
    // Remove duplicate clusters due to symmetry of graph and M matrix
    clusters = $e815fda779bc047b$var$removeDuplicates(clusters);
    return clusters;
};
var $e815fda779bc047b$var$markovClustering$1 = {
    markovClustering: $e815fda779bc047b$var$markovClustering,
    mcl: $e815fda779bc047b$var$markovClustering
};
// Common distance metrics for clustering algorithms
var $e815fda779bc047b$var$identity = function identity(x) {
    return x;
};
var $e815fda779bc047b$var$absDiff = function absDiff(p, q) {
    return Math.abs(q - p);
};
var $e815fda779bc047b$var$addAbsDiff = function addAbsDiff(total, p, q) {
    return total + $e815fda779bc047b$var$absDiff(p, q);
};
var $e815fda779bc047b$var$addSquaredDiff = function addSquaredDiff(total, p, q) {
    return total + Math.pow(q - p, 2);
};
var $e815fda779bc047b$var$sqrt = function sqrt(x) {
    return Math.sqrt(x);
};
var $e815fda779bc047b$var$maxAbsDiff = function maxAbsDiff(currentMax, p, q) {
    return Math.max(currentMax, $e815fda779bc047b$var$absDiff(p, q));
};
var $e815fda779bc047b$var$getDistance = function getDistance(length, getP, getQ, init, visit) {
    var post = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : $e815fda779bc047b$var$identity;
    var ret = init;
    var p, q;
    for(var dim = 0; dim < length; dim++){
        p = getP(dim);
        q = getQ(dim);
        ret = visit(ret, p, q);
    }
    return post(ret);
};
var $e815fda779bc047b$var$distances = {
    euclidean: function euclidean(length, getP, getQ) {
        if (length >= 2) return $e815fda779bc047b$var$getDistance(length, getP, getQ, 0, $e815fda779bc047b$var$addSquaredDiff, $e815fda779bc047b$var$sqrt);
        else // for single attr case, more efficient to avoid sqrt
        return $e815fda779bc047b$var$getDistance(length, getP, getQ, 0, $e815fda779bc047b$var$addAbsDiff);
    },
    squaredEuclidean: function squaredEuclidean(length, getP, getQ) {
        return $e815fda779bc047b$var$getDistance(length, getP, getQ, 0, $e815fda779bc047b$var$addSquaredDiff);
    },
    manhattan: function manhattan(length, getP, getQ) {
        return $e815fda779bc047b$var$getDistance(length, getP, getQ, 0, $e815fda779bc047b$var$addAbsDiff);
    },
    max: function max(length, getP, getQ) {
        return $e815fda779bc047b$var$getDistance(length, getP, getQ, -Infinity, $e815fda779bc047b$var$maxAbsDiff);
    }
};
// in case the user accidentally doesn't use camel case
$e815fda779bc047b$var$distances['squared-euclidean'] = $e815fda779bc047b$var$distances['squaredEuclidean'];
$e815fda779bc047b$var$distances['squaredeuclidean'] = $e815fda779bc047b$var$distances['squaredEuclidean'];
function $e815fda779bc047b$var$clusteringDistance(method, length, getP, getQ, nodeP, nodeQ) {
    var impl;
    if ($e815fda779bc047b$var$fn$6(method)) impl = method;
    else impl = $e815fda779bc047b$var$distances[method] || $e815fda779bc047b$var$distances.euclidean;
    if (length === 0 && $e815fda779bc047b$var$fn$6(method)) return impl(nodeP, nodeQ);
    else return impl(length, getP, getQ, nodeP, nodeQ);
}
var $e815fda779bc047b$var$defaults$b = $e815fda779bc047b$var$defaults$g({
    k: 2,
    m: 2,
    sensitivityThreshold: 0.0001,
    distance: 'euclidean',
    maxIterations: 10,
    attributes: [],
    testMode: false,
    testCentroids: null
});
var $e815fda779bc047b$var$setOptions$2 = function setOptions(options) {
    return $e815fda779bc047b$var$defaults$b(options);
};
var $e815fda779bc047b$var$getDist = function getDist(type, node, centroid, attributes, mode) {
    var noNodeP = mode !== 'kMedoids';
    var getP = noNodeP ? function(i) {
        return centroid[i];
    } : function(i) {
        return attributes[i](centroid);
    };
    var getQ = function getQ(i) {
        return attributes[i](node);
    };
    var nodeP = centroid;
    var nodeQ = node;
    return $e815fda779bc047b$var$clusteringDistance(type, attributes.length, getP, getQ, nodeP, nodeQ);
};
var $e815fda779bc047b$var$randomCentroids = function randomCentroids(nodes, k, attributes) {
    var ndim = attributes.length;
    var min = new Array(ndim);
    var max = new Array(ndim);
    var centroids = new Array(k);
    var centroid = null;
    // Find min, max values for each attribute dimension
    for(var i = 0; i < ndim; i++){
        min[i] = nodes.min(attributes[i]).value;
        max[i] = nodes.max(attributes[i]).value;
    }
    // Build k centroids, each represented as an n-dim feature vector
    for(var c = 0; c < k; c++){
        centroid = [];
        for(var _i = 0; _i < ndim; _i++)centroid[_i] = Math.random() * (max[_i] - min[_i]) + min[_i]; // random initial value
        centroids[c] = centroid;
    }
    return centroids;
};
var $e815fda779bc047b$var$classify = function classify(node, centroids, distance, attributes, type) {
    var min = Infinity;
    var index = 0;
    for(var i = 0; i < centroids.length; i++){
        var dist = $e815fda779bc047b$var$getDist(distance, node, centroids[i], attributes, type);
        if (dist < min) {
            min = dist;
            index = i;
        }
    }
    return index;
};
var $e815fda779bc047b$var$buildCluster = function buildCluster(centroid, nodes, assignment) {
    var cluster = [];
    var node = null;
    for(var n = 0; n < nodes.length; n++){
        node = nodes[n];
        if (assignment[node.id()] === centroid) //console.log("Node " + node.id() + " is associated with medoid #: " + m);
        cluster.push(node);
    }
    return cluster;
};
var $e815fda779bc047b$var$haveValuesConverged = function haveValuesConverged(v1, v2, sensitivityThreshold) {
    return Math.abs(v2 - v1) <= sensitivityThreshold;
};
var $e815fda779bc047b$var$haveMatricesConverged = function haveMatricesConverged(v1, v2, sensitivityThreshold) {
    for(var i = 0; i < v1.length; i++)for(var j = 0; j < v1[i].length; j++){
        var diff = Math.abs(v1[i][j] - v2[i][j]);
        if (diff > sensitivityThreshold) return false;
    }
    return true;
};
var $e815fda779bc047b$var$seenBefore = function seenBefore(node, medoids, n) {
    for(var i = 0; i < n; i++){
        if (node === medoids[i]) return true;
    }
    return false;
};
var $e815fda779bc047b$var$randomMedoids = function randomMedoids(nodes, k) {
    var medoids = new Array(k);
    // For small data sets, the probability of medoid conflict is greater,
    // so we need to check to see if we've already seen or chose this node before.
    if (nodes.length < 50) // Randomly select k medoids from the n nodes
    for(var i = 0; i < k; i++){
        var node = nodes[Math.floor(Math.random() * nodes.length)];
        // If we've already chosen this node to be a medoid, don't choose it again (for small data sets).
        // Instead choose a different random node.
        while($e815fda779bc047b$var$seenBefore(node, medoids, i))node = nodes[Math.floor(Math.random() * nodes.length)];
        medoids[i] = node;
    }
    else // Relatively large data set, so pretty safe to not check and just select random nodes
    for(var _i2 = 0; _i2 < k; _i2++)medoids[_i2] = nodes[Math.floor(Math.random() * nodes.length)];
    return medoids;
};
var $e815fda779bc047b$var$findCost = function findCost(potentialNewMedoid, cluster, attributes) {
    var cost = 0;
    for(var n = 0; n < cluster.length; n++)cost += $e815fda779bc047b$var$getDist('manhattan', cluster[n], potentialNewMedoid, attributes, 'kMedoids');
    return cost;
};
var $e815fda779bc047b$var$kMeans = function kMeans(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var node = null;
    // Set parameters of algorithm: # of clusters, distance metric, etc.
    var opts = $e815fda779bc047b$var$setOptions$2(options);
    // Begin k-means algorithm
    var clusters = new Array(opts.k);
    var assignment = {};
    var centroids;
    // Step 1: Initialize centroid positions
    if (opts.testMode) {
        if (typeof opts.testCentroids === 'number') {
            // TODO: implement a seeded random number generator.
            opts.testCentroids;
            centroids = $e815fda779bc047b$var$randomCentroids(nodes, opts.k, opts.attributes);
        } else if ($e815fda779bc047b$var$_typeof(opts.testCentroids) === 'object') centroids = opts.testCentroids;
        else centroids = $e815fda779bc047b$var$randomCentroids(nodes, opts.k, opts.attributes);
    } else centroids = $e815fda779bc047b$var$randomCentroids(nodes, opts.k, opts.attributes);
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        // Step 2: Assign nodes to the nearest centroid
        for(var n = 0; n < nodes.length; n++){
            node = nodes[n];
            // Determine which cluster this node belongs to: node id => cluster #
            assignment[node.id()] = $e815fda779bc047b$var$classify(node, centroids, opts.distance, opts.attributes, 'kMeans');
        }
        // Step 3: For each of the k clusters, update its centroid
        isStillMoving = false;
        for(var c = 0; c < opts.k; c++){
            // Get all nodes that belong to this cluster
            var cluster = $e815fda779bc047b$var$buildCluster(c, nodes, assignment);
            if (cluster.length === 0) continue;
            // Update centroids by calculating avg of all nodes within the cluster.
            var ndim = opts.attributes.length;
            var centroid = centroids[c]; // [ dim_1, dim_2, dim_3, ... , dim_n ]
            var newCentroid = new Array(ndim);
            var sum = new Array(ndim);
            for(var d = 0; d < ndim; d++){
                sum[d] = 0.0;
                for(var i = 0; i < cluster.length; i++){
                    node = cluster[i];
                    sum[d] += opts.attributes[d](node);
                }
                newCentroid[d] = sum[d] / cluster.length;
                // Check to see if algorithm has converged, i.e. when centroids no longer change
                if (!$e815fda779bc047b$var$haveValuesConverged(newCentroid[d], centroid[d], opts.sensitivityThreshold)) isStillMoving = true;
            }
            centroids[c] = newCentroid;
            clusters[c] = cy.collection(cluster);
        }
        iterations++;
    }
    return clusters;
};
var $e815fda779bc047b$var$kMedoids = function kMedoids(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var node = null;
    var opts = $e815fda779bc047b$var$setOptions$2(options);
    // Begin k-medoids algorithm
    var clusters = new Array(opts.k);
    var medoids;
    var assignment = {};
    var curCost;
    var minCosts = new Array(opts.k); // minimum cost configuration for each cluster
    // Step 1: Initialize k medoids
    if (opts.testMode) {
        if (typeof opts.testCentroids === 'number') ;
        else if ($e815fda779bc047b$var$_typeof(opts.testCentroids) === 'object') medoids = opts.testCentroids;
        else medoids = $e815fda779bc047b$var$randomMedoids(nodes, opts.k);
    } else medoids = $e815fda779bc047b$var$randomMedoids(nodes, opts.k);
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        // Step 2: Assign nodes to the nearest medoid
        for(var n = 0; n < nodes.length; n++){
            node = nodes[n];
            // Determine which cluster this node belongs to: node id => cluster #
            assignment[node.id()] = $e815fda779bc047b$var$classify(node, medoids, opts.distance, opts.attributes, 'kMedoids');
        }
        isStillMoving = false;
        // Step 3: For each medoid m, and for each node associated with mediod m,
        // select the node with the lowest configuration cost as new medoid.
        for(var m1 = 0; m1 < medoids.length; m1++){
            // Get all nodes that belong to this medoid
            var cluster = $e815fda779bc047b$var$buildCluster(m1, nodes, assignment);
            if (cluster.length === 0) continue;
            minCosts[m1] = $e815fda779bc047b$var$findCost(medoids[m1], cluster, opts.attributes); // original cost
            // Select different medoid if its configuration has the lowest cost
            for(var _n = 0; _n < cluster.length; _n++){
                curCost = $e815fda779bc047b$var$findCost(cluster[_n], cluster, opts.attributes);
                if (curCost < minCosts[m1]) {
                    minCosts[m1] = curCost;
                    medoids[m1] = cluster[_n];
                    isStillMoving = true;
                }
            }
            clusters[m1] = cy.collection(cluster);
        }
        iterations++;
    }
    return clusters;
};
var $e815fda779bc047b$var$updateCentroids = function updateCentroids(centroids, nodes, U, weight, opts) {
    var numerator, denominator;
    for(var n = 0; n < nodes.length; n++)for(var c = 0; c < centroids.length; c++)weight[n][c] = Math.pow(U[n][c], opts.m);
    for(var _c = 0; _c < centroids.length; _c++)for(var dim = 0; dim < opts.attributes.length; dim++){
        numerator = 0;
        denominator = 0;
        for(var _n2 = 0; _n2 < nodes.length; _n2++){
            numerator += weight[_n2][_c] * opts.attributes[dim](nodes[_n2]);
            denominator += weight[_n2][_c];
        }
        centroids[_c][dim] = numerator / denominator;
    }
};
var $e815fda779bc047b$var$updateMembership = function updateMembership(U, _U, centroids, nodes, opts) {
    // Save previous step
    for(var i = 0; i < U.length; i++)_U[i] = U[i].slice();
    var sum, numerator, denominator;
    var pow = 2 / (opts.m - 1);
    for(var c = 0; c < centroids.length; c++)for(var n = 0; n < nodes.length; n++){
        sum = 0;
        for(var k = 0; k < centroids.length; k++){
            // against all other centroids
            numerator = $e815fda779bc047b$var$getDist(opts.distance, nodes[n], centroids[c], opts.attributes, 'cmeans');
            denominator = $e815fda779bc047b$var$getDist(opts.distance, nodes[n], centroids[k], opts.attributes, 'cmeans');
            sum += Math.pow(numerator / denominator, pow);
        }
        U[n][c] = 1 / sum;
    }
};
var $e815fda779bc047b$var$assign$1 = function assign(nodes, U, opts, cy) {
    var clusters = new Array(opts.k);
    for(var c = 0; c < clusters.length; c++)clusters[c] = [];
    var max;
    var index;
    for(var n = 0; n < U.length; n++){
        // for each node (U is N x C matrix)
        max = -Infinity;
        index = -1;
        // Determine which cluster the node is most likely to belong in
        for(var _c2 = 0; _c2 < U[0].length; _c2++)if (U[n][_c2] > max) {
            max = U[n][_c2];
            index = _c2;
        }
        clusters[index].push(nodes[n]);
    }
    // Turn every array into a collection of nodes
    for(var _c3 = 0; _c3 < clusters.length; _c3++)clusters[_c3] = cy.collection(clusters[_c3]);
    return clusters;
};
var $e815fda779bc047b$var$fuzzyCMeans = function fuzzyCMeans(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var opts = $e815fda779bc047b$var$setOptions$2(options);
    // Begin fuzzy c-means algorithm
    var clusters;
    var centroids;
    var U;
    var _U;
    var weight;
    // Step 1: Initialize letiables.
    _U = new Array(nodes.length);
    for(var i = 0; i < nodes.length; i++)// N x C matrix
    _U[i] = new Array(opts.k);
    U = new Array(nodes.length);
    for(var _i3 = 0; _i3 < nodes.length; _i3++)// N x C matrix
    U[_i3] = new Array(opts.k);
    for(var _i4 = 0; _i4 < nodes.length; _i4++){
        var total = 0;
        for(var j = 0; j < opts.k; j++){
            U[_i4][j] = Math.random();
            total += U[_i4][j];
        }
        for(var _j = 0; _j < opts.k; _j++)U[_i4][_j] = U[_i4][_j] / total;
    }
    centroids = new Array(opts.k);
    for(var _i5 = 0; _i5 < opts.k; _i5++)centroids[_i5] = new Array(opts.attributes.length);
    weight = new Array(nodes.length);
    for(var _i6 = 0; _i6 < nodes.length; _i6++)// N x C matrix
    weight[_i6] = new Array(opts.k);
    // end init FCM
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        isStillMoving = false;
        // Step 2: Calculate the centroids for each step.
        $e815fda779bc047b$var$updateCentroids(centroids, nodes, U, weight, opts);
        // Step 3: Update the partition matrix U.
        $e815fda779bc047b$var$updateMembership(U, _U, centroids, nodes, opts);
        // Step 4: Check for convergence.
        if (!$e815fda779bc047b$var$haveMatricesConverged(U, _U, opts.sensitivityThreshold)) isStillMoving = true;
        iterations++;
    }
    // Assign nodes to clusters with highest probability.
    clusters = $e815fda779bc047b$var$assign$1(nodes, U, opts, cy);
    return {
        clusters: clusters,
        degreeOfMembership: U
    };
};
var $e815fda779bc047b$var$kClustering = {
    kMeans: $e815fda779bc047b$var$kMeans,
    kMedoids: $e815fda779bc047b$var$kMedoids,
    fuzzyCMeans: $e815fda779bc047b$var$fuzzyCMeans,
    fcm: $e815fda779bc047b$var$fuzzyCMeans
};
// Implemented by Zoe Xi @zoexi for GSOC 2016
var $e815fda779bc047b$var$defaults$a = $e815fda779bc047b$var$defaults$g({
    distance: 'euclidean',
    // distance metric to compare nodes
    linkage: 'min',
    // linkage criterion : how to determine the distance between clusters of nodes
    mode: 'threshold',
    // mode:'threshold' => clusters must be threshold distance apart
    threshold: Infinity,
    // the distance threshold
    // mode:'dendrogram' => the nodes are organised as leaves in a tree (siblings are close), merging makes clusters
    addDendrogram: false,
    // whether to add the dendrogram to the graph for viz
    dendrogramDepth: 0,
    // depth at which dendrogram branches are merged into the returned clusters
    attributes: [] // array of attr functions
});
var $e815fda779bc047b$var$linkageAliases = {
    'single': 'min',
    'complete': 'max'
};
var $e815fda779bc047b$var$setOptions$1 = function setOptions(options) {
    var opts = $e815fda779bc047b$var$defaults$a(options);
    var preferredAlias = $e815fda779bc047b$var$linkageAliases[opts.linkage];
    if (preferredAlias != null) opts.linkage = preferredAlias;
    return opts;
};
var $e815fda779bc047b$var$mergeClosest = function mergeClosest(clusters, index, dists, mins, opts) {
    // Find two closest clusters from cached mins
    var minKey = 0;
    var min = Infinity;
    var dist;
    var attrs = opts.attributes;
    var getDist = function getDist(n1, n2) {
        return $e815fda779bc047b$var$clusteringDistance(opts.distance, attrs.length, function(i) {
            return attrs[i](n1);
        }, function(i) {
            return attrs[i](n2);
        }, n1, n2);
    };
    for(var i = 0; i < clusters.length; i++){
        var key = clusters[i].key;
        var _dist = dists[key][mins[key]];
        if (_dist < min) {
            minKey = key;
            min = _dist;
        }
    }
    if (opts.mode === 'threshold' && min >= opts.threshold || opts.mode === 'dendrogram' && clusters.length === 1) return false;
    var c1 = index[minKey];
    var c2 = index[mins[minKey]];
    var merged;
    // Merge two closest clusters
    if (opts.mode === 'dendrogram') merged = {
        left: c1,
        right: c2,
        key: c1.key
    };
    else merged = {
        value: c1.value.concat(c2.value),
        key: c1.key
    };
    clusters[c1.index] = merged;
    clusters.splice(c2.index, 1);
    index[c1.key] = merged;
    // Update distances with new merged cluster
    for(var _i = 0; _i < clusters.length; _i++){
        var cur = clusters[_i];
        if (c1.key === cur.key) dist = Infinity;
        else if (opts.linkage === 'min') {
            dist = dists[c1.key][cur.key];
            if (dists[c1.key][cur.key] > dists[c2.key][cur.key]) dist = dists[c2.key][cur.key];
        } else if (opts.linkage === 'max') {
            dist = dists[c1.key][cur.key];
            if (dists[c1.key][cur.key] < dists[c2.key][cur.key]) dist = dists[c2.key][cur.key];
        } else if (opts.linkage === 'mean') dist = (dists[c1.key][cur.key] * c1.size + dists[c2.key][cur.key] * c2.size) / (c1.size + c2.size);
        else if (opts.mode === 'dendrogram') dist = getDist(cur.value, c1.value);
        else dist = getDist(cur.value[0], c1.value[0]);
        dists[c1.key][cur.key] = dists[cur.key][c1.key] = dist; // distance matrix is symmetric
    }
    // Update cached mins
    for(var _i2 = 0; _i2 < clusters.length; _i2++){
        var key1 = clusters[_i2].key;
        if (mins[key1] === c1.key || mins[key1] === c2.key) {
            var _min = key1;
            for(var j = 0; j < clusters.length; j++){
                var key2 = clusters[j].key;
                if (dists[key1][key2] < dists[key1][_min]) _min = key2;
            }
            mins[key1] = _min;
        }
        clusters[_i2].index = _i2;
    }
    // Clean up meta data used for clustering
    c1.key = c2.key = c1.index = c2.index = null;
    return true;
};
var $e815fda779bc047b$var$getAllChildren = function getAllChildren(root, arr, cy) {
    if (!root) return;
    if (root.value) arr.push(root.value);
    else {
        if (root.left) getAllChildren(root.left, arr);
        if (root.right) getAllChildren(root.right, arr);
    }
};
var $e815fda779bc047b$var$buildDendrogram = function buildDendrogram(root, cy) {
    if (!root) return '';
    if (root.left && root.right) {
        var leftStr = buildDendrogram(root.left, cy);
        var rightStr = buildDendrogram(root.right, cy);
        var node = cy.add({
            group: 'nodes',
            data: {
                id: leftStr + ',' + rightStr
            }
        });
        cy.add({
            group: 'edges',
            data: {
                source: leftStr,
                target: node.id()
            }
        });
        cy.add({
            group: 'edges',
            data: {
                source: rightStr,
                target: node.id()
            }
        });
        return node.id();
    } else if (root.value) return root.value.id();
};
var $e815fda779bc047b$var$buildClustersFromTree = function buildClustersFromTree(root, k, cy) {
    if (!root) return [];
    var left = [], right = [], leaves = [];
    if (k === 0) {
        // don't cut tree, simply return all nodes as 1 single cluster
        if (root.left) $e815fda779bc047b$var$getAllChildren(root.left, left);
        if (root.right) $e815fda779bc047b$var$getAllChildren(root.right, right);
        leaves = left.concat(right);
        return [
            cy.collection(leaves)
        ];
    } else if (k === 1) {
        // cut at root
        if (root.value) // leaf node
        return [
            cy.collection(root.value)
        ];
        else {
            if (root.left) $e815fda779bc047b$var$getAllChildren(root.left, left);
            if (root.right) $e815fda779bc047b$var$getAllChildren(root.right, right);
            return [
                cy.collection(left),
                cy.collection(right)
            ];
        }
    } else {
        if (root.value) return [
            cy.collection(root.value)
        ];
        else {
            if (root.left) left = buildClustersFromTree(root.left, k - 1, cy);
            if (root.right) right = buildClustersFromTree(root.right, k - 1, cy);
            return left.concat(right);
        }
    }
};
var $e815fda779bc047b$var$hierarchicalClustering = function hierarchicalClustering(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    // Set parameters of algorithm: linkage type, distance metric, etc.
    var opts = $e815fda779bc047b$var$setOptions$1(options);
    var attrs = opts.attributes;
    var getDist = function getDist(n1, n2) {
        return $e815fda779bc047b$var$clusteringDistance(opts.distance, attrs.length, function(i) {
            return attrs[i](n1);
        }, function(i) {
            return attrs[i](n2);
        }, n1, n2);
    };
    // Begin hierarchical algorithm
    var clusters = [];
    var dists = []; // distances between each pair of clusters
    var mins = []; // closest cluster for each cluster
    var index = []; // hash of all clusters by key
    // In agglomerative (bottom-up) clustering, each node starts as its own cluster
    for(var n = 0; n < nodes.length; n++){
        var cluster = {
            value: opts.mode === 'dendrogram' ? nodes[n] : [
                nodes[n]
            ],
            key: n,
            index: n
        };
        clusters[n] = cluster;
        index[n] = cluster;
        dists[n] = [];
        mins[n] = 0;
    }
    // Calculate the distance between each pair of clusters
    for(var i = 0; i < clusters.length; i++)for(var j = 0; j <= i; j++){
        var dist = void 0;
        if (opts.mode === 'dendrogram') // modes store cluster values differently
        dist = i === j ? Infinity : getDist(clusters[i].value, clusters[j].value);
        else dist = i === j ? Infinity : getDist(clusters[i].value[0], clusters[j].value[0]);
        dists[i][j] = dist;
        dists[j][i] = dist;
        if (dist < dists[i][mins[i]]) mins[i] = j; // Cache mins: closest cluster to cluster i is cluster j
    }
    // Find the closest pair of clusters and merge them into a single cluster.
    // Update distances between new cluster and each of the old clusters, and loop until threshold reached.
    var merged = $e815fda779bc047b$var$mergeClosest(clusters, index, dists, mins, opts);
    while(merged)merged = $e815fda779bc047b$var$mergeClosest(clusters, index, dists, mins, opts);
    var retClusters;
    // Dendrogram mode builds the hierarchy and adds intermediary nodes + edges
    // in addition to returning the clusters.
    if (opts.mode === 'dendrogram') {
        retClusters = $e815fda779bc047b$var$buildClustersFromTree(clusters[0], opts.dendrogramDepth, cy);
        if (opts.addDendrogram) $e815fda779bc047b$var$buildDendrogram(clusters[0], cy);
    } else {
        // Regular mode simply returns the clusters
        retClusters = new Array(clusters.length);
        clusters.forEach(function(cluster, i) {
            // Clean up meta data used for clustering
            cluster.key = cluster.index = null;
            retClusters[i] = cy.collection(cluster.value);
        });
    }
    return retClusters;
};
var $e815fda779bc047b$var$hierarchicalClustering$1 = {
    hierarchicalClustering: $e815fda779bc047b$var$hierarchicalClustering,
    hca: $e815fda779bc047b$var$hierarchicalClustering
};
// Implemented by Zoe Xi @zoexi for GSOC 2016
var $e815fda779bc047b$var$defaults$9 = $e815fda779bc047b$var$defaults$g({
    distance: 'euclidean',
    // distance metric to compare attributes between two nodes
    preference: 'median',
    // suitability of a data point to serve as an exemplar
    damping: 0.8,
    // damping factor between [0.5, 1)
    maxIterations: 1000,
    // max number of iterations to run
    minIterations: 100,
    // min number of iterations to run in order for clustering to stop
    attributes: []
});
var $e815fda779bc047b$var$setOptions = function setOptions(options) {
    var dmp = options.damping;
    var pref = options.preference;
    if (!(0.5 <= dmp && dmp < 1)) $e815fda779bc047b$var$error("Damping must range on [0.5, 1).  Got: ".concat(dmp));
    var validPrefs = [
        'median',
        'mean',
        'min',
        'max'
    ];
    if (!(validPrefs.some(function(v) {
        return v === pref;
    }) || $e815fda779bc047b$var$number$1(pref))) $e815fda779bc047b$var$error("Preference must be one of [".concat(validPrefs.map(function(p) {
        return "'".concat(p, "'");
    }).join(', '), "] or a number.  Got: ").concat(pref));
    return $e815fda779bc047b$var$defaults$9(options);
};
var $e815fda779bc047b$var$getSimilarity = function getSimilarity(type, n1, n2, attributes) {
    var attr = function attr(n, i) {
        return attributes[i](n);
    };
    // nb negative because similarity should have an inverse relationship to distance
    return -$e815fda779bc047b$var$clusteringDistance(type, attributes.length, function(i) {
        return attr(n1, i);
    }, function(i) {
        return attr(n2, i);
    }, n1, n2);
};
var $e815fda779bc047b$var$getPreference = function getPreference(S, preference) {
    // larger preference = greater # of clusters
    var p = null;
    if (preference === 'median') p = $e815fda779bc047b$var$median(S);
    else if (preference === 'mean') p = $e815fda779bc047b$var$mean(S);
    else if (preference === 'min') p = $e815fda779bc047b$var$min(S);
    else if (preference === 'max') p = $e815fda779bc047b$var$max(S);
    else // Custom preference number, as set by user
    p = preference;
    return p;
};
var $e815fda779bc047b$var$findExemplars = function findExemplars(n, R, A) {
    var indices = [];
    for(var i = 0; i < n; i++)if (R[i * n + i] + A[i * n + i] > 0) indices.push(i);
    return indices;
};
var $e815fda779bc047b$var$assignClusters = function assignClusters(n, S, exemplars) {
    var clusters = [];
    for(var i = 0; i < n; i++){
        var index = -1;
        var max = -Infinity;
        for(var ei = 0; ei < exemplars.length; ei++){
            var e = exemplars[ei];
            if (S[i * n + e] > max) {
                index = e;
                max = S[i * n + e];
            }
        }
        if (index > 0) clusters.push(index);
    }
    for(var _ei = 0; _ei < exemplars.length; _ei++)clusters[exemplars[_ei]] = exemplars[_ei];
    return clusters;
};
var $e815fda779bc047b$var$assign = function assign(n, S, exemplars) {
    var clusters = $e815fda779bc047b$var$assignClusters(n, S, exemplars);
    for(var ei = 0; ei < exemplars.length; ei++){
        var ii = [];
        for(var c = 0; c < clusters.length; c++)if (clusters[c] === exemplars[ei]) ii.push(c);
        var maxI = -1;
        var maxSum = -Infinity;
        for(var i = 0; i < ii.length; i++){
            var sum = 0;
            for(var j = 0; j < ii.length; j++)sum += S[ii[j] * n + ii[i]];
            if (sum > maxSum) {
                maxI = i;
                maxSum = sum;
            }
        }
        exemplars[ei] = ii[maxI];
    }
    clusters = $e815fda779bc047b$var$assignClusters(n, S, exemplars);
    return clusters;
};
var $e815fda779bc047b$var$affinityPropagation = function affinityPropagation(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var opts = $e815fda779bc047b$var$setOptions(options);
    // Map each node to its position in node array
    var id2position = {};
    for(var i = 0; i < nodes.length; i++)id2position[nodes[i].id()] = i;
    // Begin affinity propagation algorithm
    var n; // number of data points
    var n2; // size of matrices
    var S; // similarity matrix (1D array)
    var p; // preference/suitability of a data point to serve as an exemplar
    var R; // responsibility matrix (1D array)
    var A; // availability matrix (1D array)
    n = nodes.length;
    n2 = n * n;
    // Initialize and build S similarity matrix
    S = new Array(n2);
    for(var _i = 0; _i < n2; _i++)S[_i] = -Infinity; // for cases where two data points shouldn't be linked together
    for(var _i2 = 0; _i2 < n; _i2++){
        for(var j = 0; j < n; j++)if (_i2 !== j) S[_i2 * n + j] = $e815fda779bc047b$var$getSimilarity(opts.distance, nodes[_i2], nodes[j], opts.attributes);
    }
    // Place preferences on the diagonal of S
    p = $e815fda779bc047b$var$getPreference(S, opts.preference);
    for(var _i3 = 0; _i3 < n; _i3++)S[_i3 * n + _i3] = p;
    // Initialize R responsibility matrix
    R = new Array(n2);
    for(var _i4 = 0; _i4 < n2; _i4++)R[_i4] = 0.0;
    // Initialize A availability matrix
    A = new Array(n2);
    for(var _i5 = 0; _i5 < n2; _i5++)A[_i5] = 0.0;
    var old = new Array(n);
    var Rp = new Array(n);
    var se = new Array(n);
    for(var _i6 = 0; _i6 < n; _i6++){
        old[_i6] = 0.0;
        Rp[_i6] = 0.0;
        se[_i6] = 0;
    }
    var e = new Array(n * opts.minIterations);
    for(var _i7 = 0; _i7 < e.length; _i7++)e[_i7] = 0;
    var iter;
    for(iter = 0; iter < opts.maxIterations; iter++){
        // main algorithmic loop
        // Update R responsibility matrix
        for(var _i8 = 0; _i8 < n; _i8++){
            var max = -Infinity, max2 = -Infinity, maxI = -1, AS = 0.0;
            for(var _j = 0; _j < n; _j++){
                old[_j] = R[_i8 * n + _j];
                AS = A[_i8 * n + _j] + S[_i8 * n + _j];
                if (AS >= max) {
                    max2 = max;
                    max = AS;
                    maxI = _j;
                } else if (AS > max2) max2 = AS;
            }
            for(var _j2 = 0; _j2 < n; _j2++)R[_i8 * n + _j2] = (1 - opts.damping) * (S[_i8 * n + _j2] - max) + opts.damping * old[_j2];
            R[_i8 * n + maxI] = (1 - opts.damping) * (S[_i8 * n + maxI] - max2) + opts.damping * old[maxI];
        }
        // Update A availability matrix
        for(var _i9 = 0; _i9 < n; _i9++){
            var sum = 0;
            for(var _j3 = 0; _j3 < n; _j3++){
                old[_j3] = A[_j3 * n + _i9];
                Rp[_j3] = Math.max(0, R[_j3 * n + _i9]);
                sum += Rp[_j3];
            }
            sum -= Rp[_i9];
            Rp[_i9] = R[_i9 * n + _i9];
            sum += Rp[_i9];
            for(var _j4 = 0; _j4 < n; _j4++)A[_j4 * n + _i9] = (1 - opts.damping) * Math.min(0, sum - Rp[_j4]) + opts.damping * old[_j4];
            A[_i9 * n + _i9] = (1 - opts.damping) * (sum - Rp[_i9]) + opts.damping * old[_i9];
        }
        // Check for convergence
        var K = 0;
        for(var _i10 = 0; _i10 < n; _i10++){
            var E = A[_i10 * n + _i10] + R[_i10 * n + _i10] > 0 ? 1 : 0;
            e[iter % opts.minIterations * n + _i10] = E;
            K += E;
        }
        if (K > 0 && (iter >= opts.minIterations - 1 || iter == opts.maxIterations - 1)) {
            var _sum = 0;
            for(var _i11 = 0; _i11 < n; _i11++){
                se[_i11] = 0;
                for(var _j5 = 0; _j5 < opts.minIterations; _j5++)se[_i11] += e[_j5 * n + _i11];
                if (se[_i11] === 0 || se[_i11] === opts.minIterations) _sum++;
            }
            if (_sum === n) break;
        }
    }
    // Identify exemplars (cluster centers)
    var exemplarsIndices = $e815fda779bc047b$var$findExemplars(n, R, A);
    // Assign nodes to clusters
    var clusterIndices = $e815fda779bc047b$var$assign(n, S, exemplarsIndices);
    var clusters = {};
    for(var c = 0; c < exemplarsIndices.length; c++)clusters[exemplarsIndices[c]] = [];
    for(var _i12 = 0; _i12 < nodes.length; _i12++){
        var pos = id2position[nodes[_i12].id()];
        var clusterIndex = clusterIndices[pos];
        if (clusterIndex != null) // the node may have not been assigned a cluster if no valid attributes were specified
        clusters[clusterIndex].push(nodes[_i12]);
    }
    var retClusters = new Array(exemplarsIndices.length);
    for(var _c = 0; _c < exemplarsIndices.length; _c++)retClusters[_c] = cy.collection(clusters[exemplarsIndices[_c]]);
    return retClusters;
};
var $e815fda779bc047b$var$affinityPropagation$1 = {
    affinityPropagation: $e815fda779bc047b$var$affinityPropagation,
    ap: $e815fda779bc047b$var$affinityPropagation
};
var $e815fda779bc047b$var$hierholzerDefaults = $e815fda779bc047b$var$defaults$g({
    root: undefined,
    directed: false
});
var $e815fda779bc047b$var$elesfn$k = {
    hierholzer: function hierholzer(options) {
        if (!$e815fda779bc047b$var$plainObject(options)) {
            var args = arguments;
            options = {
                root: args[0],
                directed: args[1]
            };
        }
        var _hierholzerDefaults = $e815fda779bc047b$var$hierholzerDefaults(options), root = _hierholzerDefaults.root, directed = _hierholzerDefaults.directed;
        var eles = this;
        var dflag = false;
        var oddIn;
        var oddOut;
        var startVertex;
        if (root) startVertex = $e815fda779bc047b$var$string(root) ? this.filter(root)[0].id() : root[0].id();
        var nodes = {};
        var edges = {};
        if (directed) eles.forEach(function(ele) {
            var id = ele.id();
            if (ele.isNode()) {
                var ind = ele.indegree(true);
                var outd = ele.outdegree(true);
                var d1 = ind - outd;
                var d2 = outd - ind;
                if (d1 == 1) {
                    if (oddIn) dflag = true;
                    else oddIn = id;
                } else if (d2 == 1) {
                    if (oddOut) dflag = true;
                    else oddOut = id;
                } else if (d2 > 1 || d1 > 1) dflag = true;
                nodes[id] = [];
                ele.outgoers().forEach(function(e) {
                    if (e.isEdge()) nodes[id].push(e.id());
                });
            } else edges[id] = [
                undefined,
                ele.target().id()
            ];
        });
        else eles.forEach(function(ele) {
            var id = ele.id();
            if (ele.isNode()) {
                var d = ele.degree(true);
                if (d % 2) {
                    if (!oddIn) oddIn = id;
                    else if (!oddOut) oddOut = id;
                    else dflag = true;
                }
                nodes[id] = [];
                ele.connectedEdges().forEach(function(e) {
                    return nodes[id].push(e.id());
                });
            } else edges[id] = [
                ele.source().id(),
                ele.target().id()
            ];
        });
        var result = {
            found: false,
            trail: undefined
        };
        if (dflag) return result;
        else if (oddOut && oddIn) {
            if (directed) {
                if (startVertex && oddOut != startVertex) return result;
                startVertex = oddOut;
            } else {
                if (startVertex && oddOut != startVertex && oddIn != startVertex) return result;
                else if (!startVertex) startVertex = oddOut;
            }
        } else if (!startVertex) startVertex = eles[0].id();
        var walk = function walk(v) {
            var currentNode = v;
            var subtour = [
                v
            ];
            var adj, adjTail, adjHead;
            while(nodes[currentNode].length){
                adj = nodes[currentNode].shift();
                adjTail = edges[adj][0];
                adjHead = edges[adj][1];
                if (currentNode != adjHead) {
                    nodes[adjHead] = nodes[adjHead].filter(function(e) {
                        return e != adj;
                    });
                    currentNode = adjHead;
                } else if (!directed && currentNode != adjTail) {
                    nodes[adjTail] = nodes[adjTail].filter(function(e) {
                        return e != adj;
                    });
                    currentNode = adjTail;
                }
                subtour.unshift(adj);
                subtour.unshift(currentNode);
            }
            return subtour;
        };
        var trail = [];
        var subtour = [];
        subtour = walk(startVertex);
        while(subtour.length != 1)if (nodes[subtour[0]].length == 0) {
            trail.unshift(eles.getElementById(subtour.shift()));
            trail.unshift(eles.getElementById(subtour.shift()));
        } else subtour = walk(subtour.shift()).concat(subtour);
        trail.unshift(eles.getElementById(subtour.shift())); // final node
        for(var d in nodes){
            if (nodes[d].length) return result;
        }
        result.found = true;
        result.trail = this.spawn(trail, true);
        return result;
    }
};
var $e815fda779bc047b$var$hopcroftTarjanBiconnected = function hopcroftTarjanBiconnected() {
    var eles = this;
    var nodes = {};
    var id = 0;
    var edgeCount = 0;
    var components = [];
    var stack = [];
    var visitedEdges = {};
    var buildComponent = function buildComponent(x, y) {
        var i = stack.length - 1;
        var cutset = [];
        var component = eles.spawn();
        while(stack[i].x != x || stack[i].y != y){
            cutset.push(stack.pop().edge);
            i--;
        }
        cutset.push(stack.pop().edge);
        cutset.forEach(function(edge) {
            var connectedNodes = edge.connectedNodes().intersection(eles);
            component.merge(edge);
            connectedNodes.forEach(function(node) {
                var nodeId = node.id();
                var connectedEdges = node.connectedEdges().intersection(eles);
                component.merge(node);
                if (!nodes[nodeId].cutVertex) component.merge(connectedEdges);
                else component.merge(connectedEdges.filter(function(edge) {
                    return edge.isLoop();
                }));
            });
        });
        components.push(component);
    };
    var biconnectedSearch = function biconnectedSearch(root, currentNode, parent) {
        if (root === parent) edgeCount += 1;
        nodes[currentNode] = {
            id: id,
            low: id++,
            cutVertex: false
        };
        var edges = eles.getElementById(currentNode).connectedEdges().intersection(eles);
        if (edges.size() === 0) components.push(eles.spawn(eles.getElementById(currentNode)));
        else {
            var sourceId, targetId, otherNodeId, edgeId;
            edges.forEach(function(edge) {
                sourceId = edge.source().id();
                targetId = edge.target().id();
                otherNodeId = sourceId === currentNode ? targetId : sourceId;
                if (otherNodeId !== parent) {
                    edgeId = edge.id();
                    if (!visitedEdges[edgeId]) {
                        visitedEdges[edgeId] = true;
                        stack.push({
                            x: currentNode,
                            y: otherNodeId,
                            edge: edge
                        });
                    }
                    if (!(otherNodeId in nodes)) {
                        biconnectedSearch(root, otherNodeId, currentNode);
                        nodes[currentNode].low = Math.min(nodes[currentNode].low, nodes[otherNodeId].low);
                        if (nodes[currentNode].id <= nodes[otherNodeId].low) {
                            nodes[currentNode].cutVertex = true;
                            buildComponent(currentNode, otherNodeId);
                        }
                    } else nodes[currentNode].low = Math.min(nodes[currentNode].low, nodes[otherNodeId].id);
                }
            });
        }
    };
    eles.forEach(function(ele) {
        if (ele.isNode()) {
            var nodeId = ele.id();
            if (!(nodeId in nodes)) {
                edgeCount = 0;
                biconnectedSearch(nodeId, nodeId);
                nodes[nodeId].cutVertex = edgeCount > 1;
            }
        }
    });
    var cutVertices = Object.keys(nodes).filter(function(id) {
        return nodes[id].cutVertex;
    }).map(function(id) {
        return eles.getElementById(id);
    });
    return {
        cut: eles.spawn(cutVertices),
        components: components
    };
};
var $e815fda779bc047b$var$hopcroftTarjanBiconnected$1 = {
    hopcroftTarjanBiconnected: $e815fda779bc047b$var$hopcroftTarjanBiconnected,
    htbc: $e815fda779bc047b$var$hopcroftTarjanBiconnected,
    htb: $e815fda779bc047b$var$hopcroftTarjanBiconnected,
    hopcroftTarjanBiconnectedComponents: $e815fda779bc047b$var$hopcroftTarjanBiconnected
};
var $e815fda779bc047b$var$tarjanStronglyConnected = function tarjanStronglyConnected() {
    var eles = this;
    var nodes = {};
    var index = 0;
    var components = [];
    var stack = [];
    var cut = eles.spawn(eles);
    var stronglyConnectedSearch = function stronglyConnectedSearch(sourceNodeId) {
        stack.push(sourceNodeId);
        nodes[sourceNodeId] = {
            index: index,
            low: index++,
            explored: false
        };
        var connectedEdges = eles.getElementById(sourceNodeId).connectedEdges().intersection(eles);
        connectedEdges.forEach(function(edge) {
            var targetNodeId = edge.target().id();
            if (targetNodeId !== sourceNodeId) {
                if (!(targetNodeId in nodes)) stronglyConnectedSearch(targetNodeId);
                if (!nodes[targetNodeId].explored) nodes[sourceNodeId].low = Math.min(nodes[sourceNodeId].low, nodes[targetNodeId].low);
            }
        });
        if (nodes[sourceNodeId].index === nodes[sourceNodeId].low) {
            var componentNodes = eles.spawn();
            for(;;){
                var nodeId = stack.pop();
                componentNodes.merge(eles.getElementById(nodeId));
                nodes[nodeId].low = nodes[sourceNodeId].index;
                nodes[nodeId].explored = true;
                if (nodeId === sourceNodeId) break;
            }
            var componentEdges = componentNodes.edgesWith(componentNodes);
            var component = componentNodes.merge(componentEdges);
            components.push(component);
            cut = cut.difference(component);
        }
    };
    eles.forEach(function(ele) {
        if (ele.isNode()) {
            var nodeId = ele.id();
            if (!(nodeId in nodes)) stronglyConnectedSearch(nodeId);
        }
    });
    return {
        cut: cut,
        components: components
    };
};
var $e815fda779bc047b$var$tarjanStronglyConnected$1 = {
    tarjanStronglyConnected: $e815fda779bc047b$var$tarjanStronglyConnected,
    tsc: $e815fda779bc047b$var$tarjanStronglyConnected,
    tscc: $e815fda779bc047b$var$tarjanStronglyConnected,
    tarjanStronglyConnectedComponents: $e815fda779bc047b$var$tarjanStronglyConnected
};
var $e815fda779bc047b$var$elesfn$j = {};
[
    $e815fda779bc047b$var$elesfn$v,
    $e815fda779bc047b$var$elesfn$u,
    $e815fda779bc047b$var$elesfn$t,
    $e815fda779bc047b$var$elesfn$s,
    $e815fda779bc047b$var$elesfn$r,
    $e815fda779bc047b$var$elesfn$q,
    $e815fda779bc047b$var$elesfn$p,
    $e815fda779bc047b$var$elesfn$o,
    $e815fda779bc047b$var$elesfn$n,
    $e815fda779bc047b$var$elesfn$m,
    $e815fda779bc047b$var$elesfn$l,
    $e815fda779bc047b$var$markovClustering$1,
    $e815fda779bc047b$var$kClustering,
    $e815fda779bc047b$var$hierarchicalClustering$1,
    $e815fda779bc047b$var$affinityPropagation$1,
    $e815fda779bc047b$var$elesfn$k,
    $e815fda779bc047b$var$hopcroftTarjanBiconnected$1,
    $e815fda779bc047b$var$tarjanStronglyConnected$1
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$j, props);
});
/*!
Embeddable Minimum Strictly-Compliant Promises/A+ 1.1.1 Thenable
Copyright (c) 2013-2014 Ralf S. Engelschall (http://engelschall.com)
Licensed under The MIT License (http://opensource.org/licenses/MIT)
*/ /*  promise states [Promises/A+ 2.1]  */ var $e815fda779bc047b$var$STATE_PENDING = 0; /*  [Promises/A+ 2.1.1]  */ 
var $e815fda779bc047b$var$STATE_FULFILLED = 1; /*  [Promises/A+ 2.1.2]  */ 
var $e815fda779bc047b$var$STATE_REJECTED = 2; /*  [Promises/A+ 2.1.3]  */ 
/*  promise object constructor  */ var $e815fda779bc047b$var$api = function api(executor) {
    /*  optionally support non-constructor/plain-function call  */ if (!(this instanceof api)) return new api(executor);
    /*  initialize object  */ this.id = 'Thenable/1.0.7';
    this.state = $e815fda779bc047b$var$STATE_PENDING; /*  initial state  */ 
    this.fulfillValue = undefined; /*  initial value  */  /*  [Promises/A+ 1.3, 2.1.2.2]  */ 
    this.rejectReason = undefined; /*  initial reason */  /*  [Promises/A+ 1.5, 2.1.3.2]  */ 
    this.onFulfilled = []; /*  initial handlers  */ 
    this.onRejected = []; /*  initial handlers  */ 
    /*  provide optional information-hiding proxy  */ this.proxy = {
        then: this.then.bind(this)
    };
    /*  support optional executor function  */ if (typeof executor === 'function') executor.call(this, this.fulfill.bind(this), this.reject.bind(this));
};
/*  promise API methods  */ $e815fda779bc047b$var$api.prototype = {
    /*  promise resolving methods  */ fulfill: function fulfill(value) {
        return $e815fda779bc047b$var$deliver(this, $e815fda779bc047b$var$STATE_FULFILLED, 'fulfillValue', value);
    },
    reject: function reject(value) {
        return $e815fda779bc047b$var$deliver(this, $e815fda779bc047b$var$STATE_REJECTED, 'rejectReason', value);
    },
    /*  "The then Method" [Promises/A+ 1.1, 1.2, 2.2]  */ then: function then(onFulfilled, onRejected) {
        var curr = this;
        var next = new $e815fda779bc047b$var$api(); /*  [Promises/A+ 2.2.7]  */ 
        curr.onFulfilled.push($e815fda779bc047b$var$resolver(onFulfilled, next, 'fulfill')); /*  [Promises/A+ 2.2.2/2.2.6]  */ 
        curr.onRejected.push($e815fda779bc047b$var$resolver(onRejected, next, 'reject')); /*  [Promises/A+ 2.2.3/2.2.6]  */ 
        $e815fda779bc047b$var$execute(curr);
        return next.proxy; /*  [Promises/A+ 2.2.7, 3.3]  */ 
    }
};
/*  deliver an action  */ var $e815fda779bc047b$var$deliver = function deliver(curr, state, name, value) {
    if (curr.state === $e815fda779bc047b$var$STATE_PENDING) {
        curr.state = state; /*  [Promises/A+ 2.1.2.1, 2.1.3.1]  */ 
        curr[name] = value; /*  [Promises/A+ 2.1.2.2, 2.1.3.2]  */ 
        $e815fda779bc047b$var$execute(curr);
    }
    return curr;
};
/*  execute all handlers  */ var $e815fda779bc047b$var$execute = function execute(curr) {
    if (curr.state === $e815fda779bc047b$var$STATE_FULFILLED) $e815fda779bc047b$var$execute_handlers(curr, 'onFulfilled', curr.fulfillValue);
    else if (curr.state === $e815fda779bc047b$var$STATE_REJECTED) $e815fda779bc047b$var$execute_handlers(curr, 'onRejected', curr.rejectReason);
};
/*  execute particular set of handlers  */ var $e815fda779bc047b$var$execute_handlers = function execute_handlers(curr, name, value) {
    /* global setImmediate: true */ /* global setTimeout: true */ /*  short-circuit processing  */ if (curr[name].length === 0) return;
    /*  iterate over all handlers, exactly once  */ var handlers = curr[name];
    curr[name] = []; /*  [Promises/A+ 2.2.2.3, 2.2.3.3]  */ 
    var func = function func() {
        for(var i = 0; i < handlers.length; i++)handlers[i](value);
         /*  [Promises/A+ 2.2.5]  */ 
    };
    /*  execute procedure asynchronously  */ /*  [Promises/A+ 2.2.4, 3.1]  */ if (typeof setImmediate === 'function') setImmediate(func);
    else setTimeout(func, 0);
};
/*  generate a resolver function  */ var $e815fda779bc047b$var$resolver = function resolver(cb, next, method) {
    return function(value) {
        if (typeof cb !== 'function') /*  [Promises/A+ 2.2.1, 2.2.7.3, 2.2.7.4]  */ next[method].call(next, value); /*  [Promises/A+ 2.2.7.3, 2.2.7.4]  */ 
        else {
            var result;
            try {
                result = cb(value);
            } catch (e) {
                next.reject(e); /*  [Promises/A+ 2.2.7.2]  */ 
                return;
            }
            $e815fda779bc047b$var$resolve(next, result); /*  [Promises/A+ 2.2.7.1]  */ 
        }
    };
};
/*  "Promise Resolution Procedure"  */ /*  [Promises/A+ 2.3]  */ var $e815fda779bc047b$var$resolve = function resolve(promise, x) {
    /*  sanity check arguments  */ /*  [Promises/A+ 2.3.1]  */ if (promise === x || promise.proxy === x) {
        promise.reject(new TypeError('cannot resolve promise with itself'));
        return;
    }
    /*  surgically check for a "then" method
    (mainly to just call the "getter" of "then" only once)  */ var then;
    if ($e815fda779bc047b$var$_typeof(x) === 'object' && x !== null || typeof x === 'function') try {
        then = x.then;
    } catch (e) {
        promise.reject(e); /*  [Promises/A+ 2.3.3.2]  */ 
        return;
    }
    /*  handle own Thenables    [Promises/A+ 2.3.2]
    and similar "thenables" [Promises/A+ 2.3.3]  */ if (typeof then === 'function') {
        var resolved = false;
        try {
            /*  call retrieved "then" method */ /*  [Promises/A+ 2.3.3.3]  */ then.call(x, /*  resolvePromise  */ /*  [Promises/A+ 2.3.3.3.1]  */ function(y) {
                if (resolved) return;
                resolved = true; /*  [Promises/A+ 2.3.3.3.3]  */ 
                if (y === x) /*  [Promises/A+ 3.6]  */ promise.reject(new TypeError('circular thenable chain'));
                else resolve(promise, y);
            }, /*  rejectPromise  */ /*  [Promises/A+ 2.3.3.3.2]  */ function(r) {
                if (resolved) return;
                resolved = true; /*  [Promises/A+ 2.3.3.3.3]  */ 
                promise.reject(r);
            });
        } catch (e) {
            if (!resolved) /*  [Promises/A+ 2.3.3.3.3]  */ promise.reject(e); /*  [Promises/A+ 2.3.3.3.4]  */ 
        }
        return;
    }
    /*  handle other values  */ promise.fulfill(x); /*  [Promises/A+ 2.3.4, 2.3.3.4]  */ 
};
// so we always have Promise.all()
$e815fda779bc047b$var$api.all = function(ps) {
    return new $e815fda779bc047b$var$api(function(resolveAll, rejectAll) {
        var vals = new Array(ps.length);
        var doneCount = 0;
        var fulfill = function fulfill(i, val) {
            vals[i] = val;
            doneCount++;
            if (doneCount === ps.length) resolveAll(vals);
        };
        for(var i = 0; i < ps.length; i++)(function(i) {
            var p = ps[i];
            var isPromise = p != null && p.then != null;
            if (isPromise) p.then(function(val) {
                fulfill(i, val);
            }, function(err) {
                rejectAll(err);
            });
            else {
                var val = p;
                fulfill(i, val);
            }
        })(i);
    });
};
$e815fda779bc047b$var$api.resolve = function(val) {
    return new $e815fda779bc047b$var$api(function(resolve, reject) {
        resolve(val);
    });
};
$e815fda779bc047b$var$api.reject = function(val) {
    return new $e815fda779bc047b$var$api(function(resolve, reject) {
        reject(val);
    });
};
var $e815fda779bc047b$var$Promise$1 = typeof Promise !== 'undefined' ? Promise : $e815fda779bc047b$var$api; // eslint-disable-line no-undef
var $e815fda779bc047b$var$Animation = function Animation(target, opts, opts2) {
    var isCore = $e815fda779bc047b$var$core(target);
    var isEle = !isCore;
    var _p = this._private = $e815fda779bc047b$var$extend({
        duration: 1000
    }, opts, opts2);
    _p.target = target;
    _p.style = _p.style || _p.css;
    _p.started = false;
    _p.playing = false;
    _p.hooked = false;
    _p.applying = false;
    _p.progress = 0;
    _p.completes = [];
    _p.frames = [];
    if (_p.complete && $e815fda779bc047b$var$fn$6(_p.complete)) _p.completes.push(_p.complete);
    if (isEle) {
        var pos = target.position();
        _p.startPosition = _p.startPosition || {
            x: pos.x,
            y: pos.y
        };
        _p.startStyle = _p.startStyle || target.cy().style().getAnimationStartStyle(target, _p.style);
    }
    if (isCore) {
        var pan = target.pan();
        _p.startPan = {
            x: pan.x,
            y: pan.y
        };
        _p.startZoom = target.zoom();
    }
    // for future timeline/animations impl
    this.length = 1;
    this[0] = this;
};
var $e815fda779bc047b$var$anifn = $e815fda779bc047b$var$Animation.prototype;
$e815fda779bc047b$var$extend($e815fda779bc047b$var$anifn, {
    instanceString: function instanceString() {
        return 'animation';
    },
    hook: function hook() {
        var _p = this._private;
        if (!_p.hooked) {
            // add to target's animation queue
            var q;
            var tAni = _p.target._private.animation;
            if (_p.queue) q = tAni.queue;
            else q = tAni.current;
            q.push(this);
            // add to the animation loop pool
            if ($e815fda779bc047b$var$elementOrCollection(_p.target)) _p.target.cy().addToAnimationPool(_p.target);
            _p.hooked = true;
        }
        return this;
    },
    play: function play() {
        var _p = this._private;
        // autorewind
        if (_p.progress === 1) _p.progress = 0;
        _p.playing = true;
        _p.started = false; // needs to be started by animation loop
        _p.stopped = false;
        this.hook();
        // the animation loop will start the animation...
        return this;
    },
    playing: function playing() {
        return this._private.playing;
    },
    apply: function apply() {
        var _p = this._private;
        _p.applying = true;
        _p.started = false; // needs to be started by animation loop
        _p.stopped = false;
        this.hook();
        // the animation loop will apply the animation at this progress
        return this;
    },
    applying: function applying() {
        return this._private.applying;
    },
    pause: function pause() {
        var _p = this._private;
        _p.playing = false;
        _p.started = false;
        return this;
    },
    stop: function stop() {
        var _p = this._private;
        _p.playing = false;
        _p.started = false;
        _p.stopped = true; // to be removed from animation queues
        return this;
    },
    rewind: function rewind() {
        return this.progress(0);
    },
    fastforward: function fastforward() {
        return this.progress(1);
    },
    time: function time(t) {
        var _p = this._private;
        if (t === undefined) return _p.progress * _p.duration;
        else return this.progress(t / _p.duration);
    },
    progress: function progress(p) {
        var _p = this._private;
        var wasPlaying = _p.playing;
        if (p === undefined) return _p.progress;
        else {
            if (wasPlaying) this.pause();
            _p.progress = p;
            _p.started = false;
            if (wasPlaying) this.play();
        }
        return this;
    },
    completed: function completed() {
        return this._private.progress === 1;
    },
    reverse: function reverse() {
        var _p = this._private;
        var wasPlaying = _p.playing;
        if (wasPlaying) this.pause();
        _p.progress = 1 - _p.progress;
        _p.started = false;
        var swap = function swap(a, b) {
            var _pa = _p[a];
            if (_pa == null) return;
            _p[a] = _p[b];
            _p[b] = _pa;
        };
        swap('zoom', 'startZoom');
        swap('pan', 'startPan');
        swap('position', 'startPosition');
        // swap styles
        if (_p.style) for(var i = 0; i < _p.style.length; i++){
            var prop = _p.style[i];
            var name = prop.name;
            var startStyleProp = _p.startStyle[name];
            _p.startStyle[name] = prop;
            _p.style[i] = startStyleProp;
        }
        if (wasPlaying) this.play();
        return this;
    },
    promise: function promise(type) {
        var _p = this._private;
        var arr;
        switch(type){
            case 'frame':
                arr = _p.frames;
                break;
            default:
            case 'complete':
            case 'completed':
                arr = _p.completes;
        }
        return new $e815fda779bc047b$var$Promise$1(function(resolve, reject) {
            arr.push(function() {
                resolve();
            });
        });
    }
});
$e815fda779bc047b$var$anifn.complete = $e815fda779bc047b$var$anifn.completed;
$e815fda779bc047b$var$anifn.run = $e815fda779bc047b$var$anifn.play;
$e815fda779bc047b$var$anifn.running = $e815fda779bc047b$var$anifn.playing;
var $e815fda779bc047b$var$define$3 = {
    animated: function animated() {
        return function animatedImpl() {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return false;
            var ele = all[0];
            if (ele) return ele._private.animation.current.length > 0;
        };
    },
    // animated
    clearQueue: function clearQueue() {
        return function clearQueueImpl() {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            for(var i = 0; i < all.length; i++){
                var ele = all[i];
                ele._private.animation.queue = [];
            }
            return this;
        };
    },
    // clearQueue
    delay: function delay() {
        return function delayImpl(time, complete) {
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            return this.animate({
                delay: time,
                duration: time,
                complete: complete
            });
        };
    },
    // delay
    delayAnimation: function delayAnimation() {
        return function delayAnimationImpl(time, complete) {
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            return this.animation({
                delay: time,
                duration: time,
                complete: complete
            });
        };
    },
    // delay
    animation: function animation() {
        return function animationImpl(properties, params) {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            var isCore = !selfIsArrayLike;
            var isEles = !isCore;
            if (!cy.styleEnabled()) return this;
            var style = cy.style();
            properties = $e815fda779bc047b$var$extend({}, properties, params);
            var propertiesEmpty = Object.keys(properties).length === 0;
            if (propertiesEmpty) return new $e815fda779bc047b$var$Animation(all[0], properties); // nothing to animate
            if (properties.duration === undefined) properties.duration = 400;
            switch(properties.duration){
                case 'slow':
                    properties.duration = 600;
                    break;
                case 'fast':
                    properties.duration = 200;
                    break;
            }
            if (isEles) {
                properties.style = style.getPropsList(properties.style || properties.css);
                properties.css = undefined;
            }
            if (isEles && properties.renderedPosition != null) {
                var rpos = properties.renderedPosition;
                var pan = cy.pan();
                var zoom = cy.zoom();
                properties.position = $e815fda779bc047b$var$renderedToModelPosition(rpos, zoom, pan);
            }
            // override pan w/ panBy if set
            if (isCore && properties.panBy != null) {
                var panBy = properties.panBy;
                var cyPan = cy.pan();
                properties.pan = {
                    x: cyPan.x + panBy.x,
                    y: cyPan.y + panBy.y
                };
            }
            // override pan w/ center if set
            var center = properties.center || properties.centre;
            if (isCore && center != null) {
                var centerPan = cy.getCenterPan(center.eles, properties.zoom);
                if (centerPan != null) properties.pan = centerPan;
            }
            // override pan & zoom w/ fit if set
            if (isCore && properties.fit != null) {
                var fit = properties.fit;
                var fitVp = cy.getFitViewport(fit.eles || fit.boundingBox, fit.padding);
                if (fitVp != null) {
                    properties.pan = fitVp.pan;
                    properties.zoom = fitVp.zoom;
                }
            }
            // override zoom (& potentially pan) w/ zoom obj if set
            if (isCore && $e815fda779bc047b$var$plainObject(properties.zoom)) {
                var vp = cy.getZoomedViewport(properties.zoom);
                if (vp != null) {
                    if (vp.zoomed) properties.zoom = vp.zoom;
                    if (vp.panned) properties.pan = vp.pan;
                } else properties.zoom = null; // an inavalid zoom (e.g. no delta) gets automatically destroyed
            }
            return new $e815fda779bc047b$var$Animation(all[0], properties);
        };
    },
    // animate
    animate: function animate() {
        return function animateImpl(properties, params) {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            if (params) properties = $e815fda779bc047b$var$extend({}, properties, params);
            // manually hook and run the animation
            for(var i = 0; i < all.length; i++){
                var ele = all[i];
                var queue = ele.animated() && (properties.queue === undefined || properties.queue);
                var ani = ele.animation(properties, queue ? {
                    queue: true
                } : undefined);
                ani.play();
            }
            return this; // chaining
        };
    },
    // animate
    stop: function stop() {
        return function stopImpl(clearQueue, jumpToEnd) {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            for(var i = 0; i < all.length; i++){
                var ele = all[i];
                var _p = ele._private;
                var anis = _p.animation.current;
                for(var j = 0; j < anis.length; j++){
                    var ani = anis[j];
                    var ani_p = ani._private;
                    if (jumpToEnd) // next iteration of the animation loop, the animation
                    // will go straight to the end and be removed
                    ani_p.duration = 0;
                }
                // clear the queue of future animations
                if (clearQueue) _p.animation.queue = [];
                if (!jumpToEnd) _p.animation.current = [];
            }
            // we have to notify (the animation loop doesn't do it for us on `stop`)
            cy.notify('draw');
            return this;
        };
    } // stop
}; // define
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $e815fda779bc047b$var$isArray = Array.isArray;
var $e815fda779bc047b$var$isArray_1 = $e815fda779bc047b$var$isArray;
/** Used to match property names within property paths. */ var $e815fda779bc047b$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $e815fda779bc047b$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $e815fda779bc047b$var$isKey(value, object) {
    if ($e815fda779bc047b$var$isArray_1(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $e815fda779bc047b$var$isSymbol_1(value)) return true;
    return $e815fda779bc047b$var$reIsPlainProp.test(value) || !$e815fda779bc047b$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $e815fda779bc047b$var$_isKey = $e815fda779bc047b$var$isKey;
/** `Object#toString` result references. */ var $e815fda779bc047b$var$asyncTag = '[object AsyncFunction]', $e815fda779bc047b$var$funcTag = '[object Function]', $e815fda779bc047b$var$genTag = '[object GeneratorFunction]', $e815fda779bc047b$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $e815fda779bc047b$var$isFunction(value) {
    if (!$e815fda779bc047b$var$isObject_1(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $e815fda779bc047b$var$_baseGetTag(value);
    return tag == $e815fda779bc047b$var$funcTag || tag == $e815fda779bc047b$var$genTag || tag == $e815fda779bc047b$var$asyncTag || tag == $e815fda779bc047b$var$proxyTag;
}
var $e815fda779bc047b$var$isFunction_1 = $e815fda779bc047b$var$isFunction;
/** Used to detect overreaching core-js shims. */ var $e815fda779bc047b$var$coreJsData = $e815fda779bc047b$var$_root['__core-js_shared__'];
var $e815fda779bc047b$var$_coreJsData = $e815fda779bc047b$var$coreJsData;
/** Used to detect methods masquerading as native. */ var $e815fda779bc047b$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($e815fda779bc047b$var$_coreJsData && $e815fda779bc047b$var$_coreJsData.keys && $e815fda779bc047b$var$_coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e815fda779bc047b$var$isMasked(func) {
    return !!$e815fda779bc047b$var$maskSrcKey && $e815fda779bc047b$var$maskSrcKey in func;
}
var $e815fda779bc047b$var$_isMasked = $e815fda779bc047b$var$isMasked;
/** Used for built-in method references. */ var $e815fda779bc047b$var$funcProto$1 = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $e815fda779bc047b$var$funcToString$1 = $e815fda779bc047b$var$funcProto$1.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $e815fda779bc047b$var$toSource(func) {
    if (func != null) {
        try {
            return $e815fda779bc047b$var$funcToString$1.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $e815fda779bc047b$var$_toSource = $e815fda779bc047b$var$toSource;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $e815fda779bc047b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $e815fda779bc047b$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $e815fda779bc047b$var$funcProto = Function.prototype, $e815fda779bc047b$var$objectProto$3 = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $e815fda779bc047b$var$funcToString = $e815fda779bc047b$var$funcProto.toString;
/** Used to check objects for own properties. */ var $e815fda779bc047b$var$hasOwnProperty$3 = $e815fda779bc047b$var$objectProto$3.hasOwnProperty;
/** Used to detect if a method is native. */ var $e815fda779bc047b$var$reIsNative = RegExp('^' + $e815fda779bc047b$var$funcToString.call($e815fda779bc047b$var$hasOwnProperty$3).replace($e815fda779bc047b$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $e815fda779bc047b$var$baseIsNative(value) {
    if (!$e815fda779bc047b$var$isObject_1(value) || $e815fda779bc047b$var$_isMasked(value)) return false;
    var pattern = $e815fda779bc047b$var$isFunction_1(value) ? $e815fda779bc047b$var$reIsNative : $e815fda779bc047b$var$reIsHostCtor;
    return pattern.test($e815fda779bc047b$var$_toSource(value));
}
var $e815fda779bc047b$var$_baseIsNative = $e815fda779bc047b$var$baseIsNative;
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e815fda779bc047b$var$getValue$1(object, key) {
    return object == null ? undefined : object[key];
}
var $e815fda779bc047b$var$_getValue = $e815fda779bc047b$var$getValue$1;
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e815fda779bc047b$var$getNative(object, key) {
    var value = $e815fda779bc047b$var$_getValue(object, key);
    return $e815fda779bc047b$var$_baseIsNative(value) ? value : undefined;
}
var $e815fda779bc047b$var$_getNative = $e815fda779bc047b$var$getNative;
/* Built-in method references that are verified to be native. */ var $e815fda779bc047b$var$nativeCreate = $e815fda779bc047b$var$_getNative(Object, 'create');
var $e815fda779bc047b$var$_nativeCreate = $e815fda779bc047b$var$nativeCreate;
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $e815fda779bc047b$var$hashClear() {
    this.__data__ = $e815fda779bc047b$var$_nativeCreate ? $e815fda779bc047b$var$_nativeCreate(null) : {};
    this.size = 0;
}
var $e815fda779bc047b$var$_hashClear = $e815fda779bc047b$var$hashClear;
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e815fda779bc047b$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $e815fda779bc047b$var$_hashDelete = $e815fda779bc047b$var$hashDelete;
/** Used to stand-in for `undefined` hash values. */ var $e815fda779bc047b$var$HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $e815fda779bc047b$var$objectProto$2 = Object.prototype;
/** Used to check objects for own properties. */ var $e815fda779bc047b$var$hasOwnProperty$2 = $e815fda779bc047b$var$objectProto$2.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e815fda779bc047b$var$hashGet(key) {
    var data = this.__data__;
    if ($e815fda779bc047b$var$_nativeCreate) {
        var result = data[key];
        return result === $e815fda779bc047b$var$HASH_UNDEFINED$1 ? undefined : result;
    }
    return $e815fda779bc047b$var$hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}
var $e815fda779bc047b$var$_hashGet = $e815fda779bc047b$var$hashGet;
/** Used for built-in method references. */ var $e815fda779bc047b$var$objectProto$1 = Object.prototype;
/** Used to check objects for own properties. */ var $e815fda779bc047b$var$hasOwnProperty$1 = $e815fda779bc047b$var$objectProto$1.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e815fda779bc047b$var$hashHas(key) {
    var data = this.__data__;
    return $e815fda779bc047b$var$_nativeCreate ? data[key] !== undefined : $e815fda779bc047b$var$hasOwnProperty$1.call(data, key);
}
var $e815fda779bc047b$var$_hashHas = $e815fda779bc047b$var$hashHas;
/** Used to stand-in for `undefined` hash values. */ var $e815fda779bc047b$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $e815fda779bc047b$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $e815fda779bc047b$var$_nativeCreate && value === undefined ? $e815fda779bc047b$var$HASH_UNDEFINED : value;
    return this;
}
var $e815fda779bc047b$var$_hashSet = $e815fda779bc047b$var$hashSet;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e815fda779bc047b$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$e815fda779bc047b$var$Hash.prototype.clear = $e815fda779bc047b$var$_hashClear;
$e815fda779bc047b$var$Hash.prototype['delete'] = $e815fda779bc047b$var$_hashDelete;
$e815fda779bc047b$var$Hash.prototype.get = $e815fda779bc047b$var$_hashGet;
$e815fda779bc047b$var$Hash.prototype.has = $e815fda779bc047b$var$_hashHas;
$e815fda779bc047b$var$Hash.prototype.set = $e815fda779bc047b$var$_hashSet;
var $e815fda779bc047b$var$_Hash = $e815fda779bc047b$var$Hash;
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $e815fda779bc047b$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $e815fda779bc047b$var$_listCacheClear = $e815fda779bc047b$var$listCacheClear;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $e815fda779bc047b$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $e815fda779bc047b$var$eq_1 = $e815fda779bc047b$var$eq;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e815fda779bc047b$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($e815fda779bc047b$var$eq_1(array[length][0], key)) return length;
    }
    return -1;
}
var $e815fda779bc047b$var$_assocIndexOf = $e815fda779bc047b$var$assocIndexOf;
/** Used for built-in method references. */ var $e815fda779bc047b$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $e815fda779bc047b$var$splice = $e815fda779bc047b$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e815fda779bc047b$var$listCacheDelete(key) {
    var data = this.__data__, index = $e815fda779bc047b$var$_assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $e815fda779bc047b$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $e815fda779bc047b$var$_listCacheDelete = $e815fda779bc047b$var$listCacheDelete;
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e815fda779bc047b$var$listCacheGet(key) {
    var data = this.__data__, index = $e815fda779bc047b$var$_assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $e815fda779bc047b$var$_listCacheGet = $e815fda779bc047b$var$listCacheGet;
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e815fda779bc047b$var$listCacheHas(key) {
    return $e815fda779bc047b$var$_assocIndexOf(this.__data__, key) > -1;
}
var $e815fda779bc047b$var$_listCacheHas = $e815fda779bc047b$var$listCacheHas;
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $e815fda779bc047b$var$listCacheSet(key, value) {
    var data = this.__data__, index = $e815fda779bc047b$var$_assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $e815fda779bc047b$var$_listCacheSet = $e815fda779bc047b$var$listCacheSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e815fda779bc047b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$e815fda779bc047b$var$ListCache.prototype.clear = $e815fda779bc047b$var$_listCacheClear;
$e815fda779bc047b$var$ListCache.prototype['delete'] = $e815fda779bc047b$var$_listCacheDelete;
$e815fda779bc047b$var$ListCache.prototype.get = $e815fda779bc047b$var$_listCacheGet;
$e815fda779bc047b$var$ListCache.prototype.has = $e815fda779bc047b$var$_listCacheHas;
$e815fda779bc047b$var$ListCache.prototype.set = $e815fda779bc047b$var$_listCacheSet;
var $e815fda779bc047b$var$_ListCache = $e815fda779bc047b$var$ListCache;
/* Built-in method references that are verified to be native. */ var $e815fda779bc047b$var$Map$1 = $e815fda779bc047b$var$_getNative($e815fda779bc047b$var$_root, 'Map');
var $e815fda779bc047b$var$_Map = $e815fda779bc047b$var$Map$1;
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $e815fda779bc047b$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $e815fda779bc047b$var$_Hash,
        'map': new ($e815fda779bc047b$var$_Map || $e815fda779bc047b$var$_ListCache),
        'string': new $e815fda779bc047b$var$_Hash
    };
}
var $e815fda779bc047b$var$_mapCacheClear = $e815fda779bc047b$var$mapCacheClear;
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $e815fda779bc047b$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $e815fda779bc047b$var$_isKeyable = $e815fda779bc047b$var$isKeyable;
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e815fda779bc047b$var$getMapData(map, key) {
    var data = map.__data__;
    return $e815fda779bc047b$var$_isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $e815fda779bc047b$var$_getMapData = $e815fda779bc047b$var$getMapData;
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e815fda779bc047b$var$mapCacheDelete(key) {
    var result = $e815fda779bc047b$var$_getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $e815fda779bc047b$var$_mapCacheDelete = $e815fda779bc047b$var$mapCacheDelete;
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e815fda779bc047b$var$mapCacheGet(key) {
    return $e815fda779bc047b$var$_getMapData(this, key).get(key);
}
var $e815fda779bc047b$var$_mapCacheGet = $e815fda779bc047b$var$mapCacheGet;
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e815fda779bc047b$var$mapCacheHas(key) {
    return $e815fda779bc047b$var$_getMapData(this, key).has(key);
}
var $e815fda779bc047b$var$_mapCacheHas = $e815fda779bc047b$var$mapCacheHas;
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $e815fda779bc047b$var$mapCacheSet(key, value) {
    var data = $e815fda779bc047b$var$_getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $e815fda779bc047b$var$_mapCacheSet = $e815fda779bc047b$var$mapCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e815fda779bc047b$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$e815fda779bc047b$var$MapCache.prototype.clear = $e815fda779bc047b$var$_mapCacheClear;
$e815fda779bc047b$var$MapCache.prototype['delete'] = $e815fda779bc047b$var$_mapCacheDelete;
$e815fda779bc047b$var$MapCache.prototype.get = $e815fda779bc047b$var$_mapCacheGet;
$e815fda779bc047b$var$MapCache.prototype.has = $e815fda779bc047b$var$_mapCacheHas;
$e815fda779bc047b$var$MapCache.prototype.set = $e815fda779bc047b$var$_mapCacheSet;
var $e815fda779bc047b$var$_MapCache = $e815fda779bc047b$var$MapCache;
/** Error message constants. */ var $e815fda779bc047b$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $e815fda779bc047b$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($e815fda779bc047b$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($e815fda779bc047b$var$memoize.Cache || $e815fda779bc047b$var$_MapCache);
    return memoized;
}
// Expose `MapCache`.
$e815fda779bc047b$var$memoize.Cache = $e815fda779bc047b$var$_MapCache;
var $e815fda779bc047b$var$memoize_1 = $e815fda779bc047b$var$memoize;
/** Used as the maximum memoize cache size. */ var $e815fda779bc047b$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $e815fda779bc047b$var$memoizeCapped(func) {
    var result = $e815fda779bc047b$var$memoize_1(func, function(key) {
        if (cache.size === $e815fda779bc047b$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $e815fda779bc047b$var$_memoizeCapped = $e815fda779bc047b$var$memoizeCapped;
/** Used to match property names within property paths. */ var $e815fda779bc047b$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $e815fda779bc047b$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $e815fda779bc047b$var$stringToPath = $e815fda779bc047b$var$_memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($e815fda779bc047b$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($e815fda779bc047b$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $e815fda779bc047b$var$_stringToPath = $e815fda779bc047b$var$stringToPath;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e815fda779bc047b$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $e815fda779bc047b$var$_arrayMap = $e815fda779bc047b$var$arrayMap;
/** Used as references for various `Number` constants. */ var $e815fda779bc047b$var$INFINITY$1 = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $e815fda779bc047b$var$symbolProto = $e815fda779bc047b$var$_Symbol ? $e815fda779bc047b$var$_Symbol.prototype : undefined, $e815fda779bc047b$var$symbolToString = $e815fda779bc047b$var$symbolProto ? $e815fda779bc047b$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $e815fda779bc047b$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($e815fda779bc047b$var$isArray_1(value)) // Recursively convert values (susceptible to call stack limits).
    return $e815fda779bc047b$var$_arrayMap(value, $e815fda779bc047b$var$baseToString) + '';
    if ($e815fda779bc047b$var$isSymbol_1(value)) return $e815fda779bc047b$var$symbolToString ? $e815fda779bc047b$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$e815fda779bc047b$var$INFINITY$1 ? '-0' : result;
}
var $e815fda779bc047b$var$_baseToString = $e815fda779bc047b$var$baseToString;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $e815fda779bc047b$var$toString$1(value) {
    return value == null ? '' : $e815fda779bc047b$var$_baseToString(value);
}
var $e815fda779bc047b$var$toString_1 = $e815fda779bc047b$var$toString$1;
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $e815fda779bc047b$var$castPath(value, object) {
    if ($e815fda779bc047b$var$isArray_1(value)) return value;
    return $e815fda779bc047b$var$_isKey(value, object) ? [
        value
    ] : $e815fda779bc047b$var$_stringToPath($e815fda779bc047b$var$toString_1(value));
}
var $e815fda779bc047b$var$_castPath = $e815fda779bc047b$var$castPath;
/** Used as references for various `Number` constants. */ var $e815fda779bc047b$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $e815fda779bc047b$var$toKey(value) {
    if (typeof value == 'string' || $e815fda779bc047b$var$isSymbol_1(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$e815fda779bc047b$var$INFINITY ? '-0' : result;
}
var $e815fda779bc047b$var$_toKey = $e815fda779bc047b$var$toKey;
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $e815fda779bc047b$var$baseGet(object, path) {
    path = $e815fda779bc047b$var$_castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$e815fda779bc047b$var$_toKey(path[index++])];
    return index && index == length ? object : undefined;
}
var $e815fda779bc047b$var$_baseGet = $e815fda779bc047b$var$baseGet;
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $e815fda779bc047b$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $e815fda779bc047b$var$_baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
var $e815fda779bc047b$var$get_1 = $e815fda779bc047b$var$get;
var $e815fda779bc047b$var$defineProperty = function() {
    try {
        var func = $e815fda779bc047b$var$_getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $e815fda779bc047b$var$_defineProperty = $e815fda779bc047b$var$defineProperty;
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $e815fda779bc047b$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $e815fda779bc047b$var$_defineProperty) $e815fda779bc047b$var$_defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $e815fda779bc047b$var$_baseAssignValue = $e815fda779bc047b$var$baseAssignValue;
/** Used for built-in method references. */ var $e815fda779bc047b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e815fda779bc047b$var$hasOwnProperty = $e815fda779bc047b$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $e815fda779bc047b$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($e815fda779bc047b$var$hasOwnProperty.call(object, key) && $e815fda779bc047b$var$eq_1(objValue, value)) || value === undefined && !(key in object)) $e815fda779bc047b$var$_baseAssignValue(object, key, value);
}
var $e815fda779bc047b$var$_assignValue = $e815fda779bc047b$var$assignValue;
/** Used as references for various `Number` constants. */ var $e815fda779bc047b$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $e815fda779bc047b$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $e815fda779bc047b$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $e815fda779bc047b$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $e815fda779bc047b$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $e815fda779bc047b$var$_isIndex = $e815fda779bc047b$var$isIndex;
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $e815fda779bc047b$var$baseSet(object, path, value, customizer) {
    if (!$e815fda779bc047b$var$isObject_1(object)) return object;
    path = $e815fda779bc047b$var$_castPath(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $e815fda779bc047b$var$_toKey(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $e815fda779bc047b$var$isObject_1(objValue) ? objValue : $e815fda779bc047b$var$_isIndex(path[index + 1]) ? [] : {};
        }
        $e815fda779bc047b$var$_assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
var $e815fda779bc047b$var$_baseSet = $e815fda779bc047b$var$baseSet;
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $e815fda779bc047b$var$set(object, path, value) {
    return object == null ? object : $e815fda779bc047b$var$_baseSet(object, path, value);
}
var $e815fda779bc047b$var$set_1 = $e815fda779bc047b$var$set;
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $e815fda779bc047b$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $e815fda779bc047b$var$_copyArray = $e815fda779bc047b$var$copyArray;
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $e815fda779bc047b$var$toPath(value) {
    if ($e815fda779bc047b$var$isArray_1(value)) return $e815fda779bc047b$var$_arrayMap(value, $e815fda779bc047b$var$_toKey);
    return $e815fda779bc047b$var$isSymbol_1(value) ? [
        value
    ] : $e815fda779bc047b$var$_copyArray($e815fda779bc047b$var$_stringToPath($e815fda779bc047b$var$toString_1(value)));
}
var $e815fda779bc047b$var$toPath_1 = $e815fda779bc047b$var$toPath;
var $e815fda779bc047b$var$define$2 = {
    // access data field
    data: function data(params) {
        var defaults = {
            field: 'data',
            bindingEvent: 'data',
            allowBinding: false,
            allowSetting: false,
            allowGetting: false,
            settingEvent: 'data',
            settingTriggersEvent: false,
            triggerFnName: 'trigger',
            immutableKeys: {},
            // key => true if immutable
            updateStyle: false,
            beforeGet: function beforeGet(self1) {},
            beforeSet: function beforeSet(self1, obj) {},
            onSet: function onSet(self1) {},
            canSet: function canSet(self1) {
                return true;
            }
        };
        params = $e815fda779bc047b$var$extend({}, defaults, params);
        return function dataImpl(name, value) {
            var p = params;
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var single = selfIsArrayLike ? self1[0] : self1;
            // .data('foo', ...)
            if ($e815fda779bc047b$var$string(name)) {
                // set or get property
                var isPathLike = name.indexOf('.') !== -1; // there might be a normal field with a dot 
                var path = isPathLike && $e815fda779bc047b$var$toPath_1(name);
                // .data('foo')
                if (p.allowGetting && value === undefined) {
                    // get
                    var ret;
                    if (single) {
                        p.beforeGet(single);
                        // check if it's path and a field with the same name doesn't exist
                        if (path && single._private[p.field][name] === undefined) ret = $e815fda779bc047b$var$get_1(single._private[p.field], path);
                        else ret = single._private[p.field][name];
                    }
                    return ret;
                // .data('foo', 'bar')
                } else if (p.allowSetting && value !== undefined) {
                    // set
                    var valid = !p.immutableKeys[name];
                    if (valid) {
                        var change = $e815fda779bc047b$var$_defineProperty$1({}, name, value);
                        p.beforeSet(self1, change);
                        for(var i = 0, l = all.length; i < l; i++){
                            var ele = all[i];
                            if (p.canSet(ele)) {
                                if (path && single._private[p.field][name] === undefined) $e815fda779bc047b$var$set_1(ele._private[p.field], path, value);
                                else ele._private[p.field][name] = value;
                            }
                        }
                        // update mappers if asked
                        if (p.updateStyle) self1.updateStyle();
                        // call onSet callback
                        p.onSet(self1);
                        if (p.settingTriggersEvent) self1[p.triggerFnName](p.settingEvent);
                    }
                }
            // .data({ 'foo': 'bar' })
            } else if (p.allowSetting && $e815fda779bc047b$var$plainObject(name)) {
                // extend
                var obj = name;
                var k, v;
                var keys = Object.keys(obj);
                p.beforeSet(self1, obj);
                for(var _i = 0; _i < keys.length; _i++){
                    k = keys[_i];
                    v = obj[k];
                    var _valid = !p.immutableKeys[k];
                    if (_valid) for(var j = 0; j < all.length; j++){
                        var _ele = all[j];
                        if (p.canSet(_ele)) _ele._private[p.field][k] = v;
                    }
                }
                // update mappers if asked
                if (p.updateStyle) self1.updateStyle();
                // call onSet callback
                p.onSet(self1);
                if (p.settingTriggersEvent) self1[p.triggerFnName](p.settingEvent);
            // .data(function(){ ... })
            } else if (p.allowBinding && $e815fda779bc047b$var$fn$6(name)) {
                // bind to event
                var fn = name;
                self1.on(p.bindingEvent, fn);
            // .data()
            } else if (p.allowGetting && name === undefined) {
                // get whole object
                var _ret;
                if (single) {
                    p.beforeGet(single);
                    _ret = single._private[p.field];
                }
                return _ret;
            }
            return self1; // maintain chainability
        }; // function
    },
    // data
    // remove data field
    removeData: function removeData(params) {
        var defaults = {
            field: 'data',
            event: 'data',
            triggerFnName: 'trigger',
            triggerEvent: false,
            immutableKeys: {} // key => true if immutable
        };
        params = $e815fda779bc047b$var$extend({}, defaults, params);
        return function removeDataImpl(names) {
            var p = params;
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            // .removeData('foo bar')
            if ($e815fda779bc047b$var$string(names)) {
                // then get the list of keys, and delete them
                var keys = names.split(/\s+/);
                var l = keys.length;
                for(var i = 0; i < l; i++){
                    // delete each non-empty key
                    var key = keys[i];
                    if ($e815fda779bc047b$var$emptyString(key)) continue;
                    var valid = !p.immutableKeys[key]; // not valid if immutable
                    if (valid) for(var i_a = 0, l_a = all.length; i_a < l_a; i_a++)all[i_a]._private[p.field][key] = undefined;
                }
                if (p.triggerEvent) self1[p.triggerFnName](p.event);
            // .removeData()
            } else if (names === undefined) {
                // then delete all keys
                for(var _i_a = 0, _l_a = all.length; _i_a < _l_a; _i_a++){
                    var _privateFields = all[_i_a]._private[p.field];
                    var _keys = Object.keys(_privateFields);
                    for(var _i2 = 0; _i2 < _keys.length; _i2++){
                        var _key = _keys[_i2];
                        var validKeyToDelete = !p.immutableKeys[_key];
                        if (validKeyToDelete) _privateFields[_key] = undefined;
                    }
                }
                if (p.triggerEvent) self1[p.triggerFnName](p.event);
            }
            return self1; // maintain chaining
        }; // function
    } // removeData
}; // define
var $e815fda779bc047b$var$define$1 = {
    eventAliasesOn: function eventAliasesOn(proto) {
        var p = proto;
        p.addListener = p.listen = p.bind = p.on;
        p.unlisten = p.unbind = p.off = p.removeListener;
        p.trigger = p.emit;
        // this is just a wrapper alias of .on()
        p.pon = p.promiseOn = function(events, selector) {
            var self1 = this;
            var args = Array.prototype.slice.call(arguments, 0);
            return new $e815fda779bc047b$var$Promise$1(function(resolve, reject) {
                var callback = function callback(e) {
                    self1.off.apply(self1, offArgs);
                    resolve(e);
                };
                var onArgs = args.concat([
                    callback
                ]);
                var offArgs = onArgs.concat([]);
                self1.on.apply(self1, onArgs);
            });
        };
    }
}; // define
// use this module to cherry pick functions into your prototype
var $e815fda779bc047b$var$define = {};
[
    $e815fda779bc047b$var$define$3,
    $e815fda779bc047b$var$define$2,
    $e815fda779bc047b$var$define$1
].forEach(function(m1) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$define, m1);
});
var $e815fda779bc047b$var$elesfn$i = {
    animate: $e815fda779bc047b$var$define.animate(),
    animation: $e815fda779bc047b$var$define.animation(),
    animated: $e815fda779bc047b$var$define.animated(),
    clearQueue: $e815fda779bc047b$var$define.clearQueue(),
    delay: $e815fda779bc047b$var$define.delay(),
    delayAnimation: $e815fda779bc047b$var$define.delayAnimation(),
    stop: $e815fda779bc047b$var$define.stop()
};
var $e815fda779bc047b$var$elesfn$h = {
    classes: function classes(_classes) {
        var self1 = this;
        if (_classes === undefined) {
            var ret = [];
            self1[0]._private.classes.forEach(function(cls) {
                return ret.push(cls);
            });
            return ret;
        } else if (!$e815fda779bc047b$var$array(_classes)) // extract classes from string
        _classes = (_classes || '').match(/\S+/g) || [];
        var changed = [];
        var classesSet = new $e815fda779bc047b$var$Set$1(_classes);
        // check and update each ele
        for(var j = 0; j < self1.length; j++){
            var ele = self1[j];
            var _p = ele._private;
            var eleClasses = _p.classes;
            var changedEle = false;
            // check if ele has all of the passed classes
            for(var i = 0; i < _classes.length; i++){
                var cls = _classes[i];
                var eleHasClass = eleClasses.has(cls);
                if (!eleHasClass) {
                    changedEle = true;
                    break;
                }
            }
            // check if ele has classes outside of those passed
            if (!changedEle) changedEle = eleClasses.size !== _classes.length;
            if (changedEle) {
                _p.classes = classesSet;
                changed.push(ele);
            }
        }
        // trigger update style on those eles that had class changes
        if (changed.length > 0) this.spawn(changed).updateStyle().emit('class');
        return self1;
    },
    addClass: function addClass(classes) {
        return this.toggleClass(classes, true);
    },
    hasClass: function hasClass(className) {
        var ele = this[0];
        return ele != null && ele._private.classes.has(className);
    },
    toggleClass: function toggleClass(classes, toggle) {
        if (!$e815fda779bc047b$var$array(classes)) // extract classes from string
        classes = classes.match(/\S+/g) || [];
        var self1 = this;
        var toggleUndefd = toggle === undefined;
        var changed = []; // eles who had classes changed
        for(var i = 0, il = self1.length; i < il; i++){
            var ele = self1[i];
            var eleClasses = ele._private.classes;
            var changedEle = false;
            for(var j = 0; j < classes.length; j++){
                var cls = classes[j];
                var hasClass = eleClasses.has(cls);
                var changedNow = false;
                if (toggle || toggleUndefd && !hasClass) {
                    eleClasses.add(cls);
                    changedNow = true;
                } else if (!toggle || toggleUndefd && hasClass) {
                    eleClasses["delete"](cls);
                    changedNow = true;
                }
                if (!changedEle && changedNow) {
                    changed.push(ele);
                    changedEle = true;
                }
            } // for j classes
        } // for i eles
        // trigger update style on those eles that had class changes
        if (changed.length > 0) this.spawn(changed).updateStyle().emit('class');
        return self1;
    },
    removeClass: function removeClass(classes) {
        return this.toggleClass(classes, false);
    },
    flashClass: function flashClass(classes, duration) {
        var self1 = this;
        if (duration == null) duration = 250;
        else if (duration === 0) return self1; // nothing to do really
        self1.addClass(classes);
        setTimeout(function() {
            self1.removeClass(classes);
        }, duration);
        return self1;
    }
};
$e815fda779bc047b$var$elesfn$h.className = $e815fda779bc047b$var$elesfn$h.classNames = $e815fda779bc047b$var$elesfn$h.classes;
// tokens in the query language
var $e815fda779bc047b$var$tokens = {
    metaChar: '[\\!\\"\\#\\$\\%\\&\\\'\\(\\)\\*\\+\\,\\.\\/\\:\\;\\<\\=\\>\\?\\@\\[\\]\\^\\`\\{\\|\\}\\~]',
    // chars we need to escape in let names, etc
    comparatorOp: '=|\\!=|>|>=|<|<=|\\$=|\\^=|\\*=',
    // binary comparison op (used in data selectors)
    boolOp: '\\?|\\!|\\^',
    // boolean (unary) operators (used in data selectors)
    string: "\"(?:\\\\\"|[^\"])*\"|'(?:\\\\'|[^'])*'",
    // string literals (used in data selectors) -- doublequotes | singlequotes
    number: $e815fda779bc047b$var$number,
    // number literal (used in data selectors) --- e.g. 0.1234, 1234, 12e123
    meta: 'degree|indegree|outdegree',
    // allowed metadata fields (i.e. allowed functions to use from Collection)
    separator: '\\s*,\\s*',
    // queries are separated by commas, e.g. edge[foo = 'bar'], node.someClass
    descendant: '\\s+',
    child: '\\s+>\\s+',
    subject: '\\$',
    group: 'node|edge|\\*',
    directedEdge: '\\s+->\\s+',
    undirectedEdge: '\\s+<->\\s+'
};
$e815fda779bc047b$var$tokens.variable = '(?:[\\w-.]|(?:\\\\' + $e815fda779bc047b$var$tokens.metaChar + '))+'; // a variable name can have letters, numbers, dashes, and periods
$e815fda779bc047b$var$tokens.className = '(?:[\\w-]|(?:\\\\' + $e815fda779bc047b$var$tokens.metaChar + '))+'; // a class name has the same rules as a variable except it can't have a '.' in the name
$e815fda779bc047b$var$tokens.value = $e815fda779bc047b$var$tokens.string + '|' + $e815fda779bc047b$var$tokens.number; // a value literal, either a string or number
$e815fda779bc047b$var$tokens.id = $e815fda779bc047b$var$tokens.variable; // an element id (follows variable conventions)
(function() {
    var ops, op, i;
    // add @ variants to comparatorOp
    ops = $e815fda779bc047b$var$tokens.comparatorOp.split('|');
    for(i = 0; i < ops.length; i++){
        op = ops[i];
        $e815fda779bc047b$var$tokens.comparatorOp += '|@' + op;
    }
    // add ! variants to comparatorOp
    ops = $e815fda779bc047b$var$tokens.comparatorOp.split('|');
    for(i = 0; i < ops.length; i++){
        op = ops[i];
        if (op.indexOf('!') >= 0) continue;
         // skip ops that explicitly contain !
        if (op === '=') continue;
         // skip = b/c != is explicitly defined
        $e815fda779bc047b$var$tokens.comparatorOp += '|\\!' + op;
    }
})();
/**
 * Make a new query object
 *
 * @prop type {Type} The type enum (int) of the query
 * @prop checks List of checks to make against an ele to test for a match
 */ var $e815fda779bc047b$var$newQuery = function newQuery() {
    return {
        checks: []
    };
};
/**
 * A check type enum-like object.  Uses integer values for fast match() lookup.
 * The ordering does not matter as long as the ints are unique.
 */ var $e815fda779bc047b$var$Type = {
    /** E.g. node */ GROUP: 0,
    /** A collection of elements */ COLLECTION: 1,
    /** A filter(ele) function */ FILTER: 2,
    /** E.g. [foo > 1] */ DATA_COMPARE: 3,
    /** E.g. [foo] */ DATA_EXIST: 4,
    /** E.g. [?foo] */ DATA_BOOL: 5,
    /** E.g. [[degree > 2]] */ META_COMPARE: 6,
    /** E.g. :selected */ STATE: 7,
    /** E.g. #foo */ ID: 8,
    /** E.g. .foo */ CLASS: 9,
    /** E.g. #foo <-> #bar */ UNDIRECTED_EDGE: 10,
    /** E.g. #foo -> #bar */ DIRECTED_EDGE: 11,
    /** E.g. $#foo -> #bar */ NODE_SOURCE: 12,
    /** E.g. #foo -> $#bar */ NODE_TARGET: 13,
    /** E.g. $#foo <-> #bar */ NODE_NEIGHBOR: 14,
    /** E.g. #foo > #bar */ CHILD: 15,
    /** E.g. #foo #bar */ DESCENDANT: 16,
    /** E.g. $#foo > #bar */ PARENT: 17,
    /** E.g. $#foo #bar */ ANCESTOR: 18,
    /** E.g. #foo > $bar > #baz */ COMPOUND_SPLIT: 19,
    /** Always matches, useful placeholder for subject in `COMPOUND_SPLIT` */ TRUE: 20
};
var $e815fda779bc047b$var$stateSelectors = [
    {
        selector: ':selected',
        matches: function matches(ele) {
            return ele.selected();
        }
    },
    {
        selector: ':unselected',
        matches: function matches(ele) {
            return !ele.selected();
        }
    },
    {
        selector: ':selectable',
        matches: function matches(ele) {
            return ele.selectable();
        }
    },
    {
        selector: ':unselectable',
        matches: function matches(ele) {
            return !ele.selectable();
        }
    },
    {
        selector: ':locked',
        matches: function matches(ele) {
            return ele.locked();
        }
    },
    {
        selector: ':unlocked',
        matches: function matches(ele) {
            return !ele.locked();
        }
    },
    {
        selector: ':visible',
        matches: function matches(ele) {
            return ele.visible();
        }
    },
    {
        selector: ':hidden',
        matches: function matches(ele) {
            return !ele.visible();
        }
    },
    {
        selector: ':transparent',
        matches: function matches(ele) {
            return ele.transparent();
        }
    },
    {
        selector: ':grabbed',
        matches: function matches(ele) {
            return ele.grabbed();
        }
    },
    {
        selector: ':free',
        matches: function matches(ele) {
            return !ele.grabbed();
        }
    },
    {
        selector: ':removed',
        matches: function matches(ele) {
            return ele.removed();
        }
    },
    {
        selector: ':inside',
        matches: function matches(ele) {
            return !ele.removed();
        }
    },
    {
        selector: ':grabbable',
        matches: function matches(ele) {
            return ele.grabbable();
        }
    },
    {
        selector: ':ungrabbable',
        matches: function matches(ele) {
            return !ele.grabbable();
        }
    },
    {
        selector: ':animated',
        matches: function matches(ele) {
            return ele.animated();
        }
    },
    {
        selector: ':unanimated',
        matches: function matches(ele) {
            return !ele.animated();
        }
    },
    {
        selector: ':parent',
        matches: function matches(ele) {
            return ele.isParent();
        }
    },
    {
        selector: ':childless',
        matches: function matches(ele) {
            return ele.isChildless();
        }
    },
    {
        selector: ':child',
        matches: function matches(ele) {
            return ele.isChild();
        }
    },
    {
        selector: ':orphan',
        matches: function matches(ele) {
            return ele.isOrphan();
        }
    },
    {
        selector: ':nonorphan',
        matches: function matches(ele) {
            return ele.isChild();
        }
    },
    {
        selector: ':compound',
        matches: function matches(ele) {
            if (ele.isNode()) return ele.isParent();
            else return ele.source().isParent() || ele.target().isParent();
        }
    },
    {
        selector: ':loop',
        matches: function matches(ele) {
            return ele.isLoop();
        }
    },
    {
        selector: ':simple',
        matches: function matches(ele) {
            return ele.isSimple();
        }
    },
    {
        selector: ':active',
        matches: function matches(ele) {
            return ele.active();
        }
    },
    {
        selector: ':inactive',
        matches: function matches(ele) {
            return !ele.active();
        }
    },
    {
        selector: ':backgrounding',
        matches: function matches(ele) {
            return ele.backgrounding();
        }
    },
    {
        selector: ':nonbackgrounding',
        matches: function matches(ele) {
            return !ele.backgrounding();
        }
    }
].sort(function(a, b) {
    // n.b. selectors that are starting substrings of others must have the longer ones first
    return $e815fda779bc047b$var$descending(a.selector, b.selector);
});
var $e815fda779bc047b$var$lookup = function() {
    var selToFn = {};
    var s;
    for(var i = 0; i < $e815fda779bc047b$var$stateSelectors.length; i++){
        s = $e815fda779bc047b$var$stateSelectors[i];
        selToFn[s.selector] = s.matches;
    }
    return selToFn;
}();
var $e815fda779bc047b$var$stateSelectorMatches = function stateSelectorMatches(sel, ele) {
    return $e815fda779bc047b$var$lookup[sel](ele);
};
var $e815fda779bc047b$var$stateSelectorRegex = '(' + $e815fda779bc047b$var$stateSelectors.map(function(s) {
    return s.selector;
}).join('|') + ')';
// when a token like a variable has escaped meta characters, we need to clean the backslashes out
// so that values get compared properly in Selector.filter()
var $e815fda779bc047b$var$cleanMetaChars = function cleanMetaChars(str) {
    return str.replace(new RegExp('\\\\(' + $e815fda779bc047b$var$tokens.metaChar + ')', 'g'), function(match, $1) {
        return $1;
    });
};
var $e815fda779bc047b$var$replaceLastQuery = function replaceLastQuery(selector, examiningQuery, replacementQuery) {
    selector[selector.length - 1] = replacementQuery;
};
// NOTE: add new expression syntax here to have it recognised by the parser;
// - a query contains all adjacent (i.e. no separator in between) expressions;
// - the current query is stored in selector[i]
// - you need to check the query objects in match() for it actually filter properly, but that's pretty straight forward
var $e815fda779bc047b$var$exprs = [
    {
        name: 'group',
        // just used for identifying when debugging
        query: true,
        regex: '(' + $e815fda779bc047b$var$tokens.group + ')',
        populate: function populate(selector, query, _ref) {
            var _ref2 = $e815fda779bc047b$var$_slicedToArray(_ref, 1), group = _ref2[0];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.GROUP,
                value: group === '*' ? group : group + 's'
            });
        }
    },
    {
        name: 'state',
        query: true,
        regex: $e815fda779bc047b$var$stateSelectorRegex,
        populate: function populate(selector, query, _ref3) {
            var _ref4 = $e815fda779bc047b$var$_slicedToArray(_ref3, 1), state = _ref4[0];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.STATE,
                value: state
            });
        }
    },
    {
        name: 'id',
        query: true,
        regex: '\\#(' + $e815fda779bc047b$var$tokens.id + ')',
        populate: function populate(selector, query, _ref5) {
            var _ref6 = $e815fda779bc047b$var$_slicedToArray(_ref5, 1), id = _ref6[0];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.ID,
                value: $e815fda779bc047b$var$cleanMetaChars(id)
            });
        }
    },
    {
        name: 'className',
        query: true,
        regex: '\\.(' + $e815fda779bc047b$var$tokens.className + ')',
        populate: function populate(selector, query, _ref7) {
            var _ref8 = $e815fda779bc047b$var$_slicedToArray(_ref7, 1), className = _ref8[0];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.CLASS,
                value: $e815fda779bc047b$var$cleanMetaChars(className)
            });
        }
    },
    {
        name: 'dataExists',
        query: true,
        regex: '\\[\\s*(' + $e815fda779bc047b$var$tokens.variable + ')\\s*\\]',
        populate: function populate(selector, query, _ref9) {
            var _ref10 = $e815fda779bc047b$var$_slicedToArray(_ref9, 1), variable = _ref10[0];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.DATA_EXIST,
                field: $e815fda779bc047b$var$cleanMetaChars(variable)
            });
        }
    },
    {
        name: 'dataCompare',
        query: true,
        regex: '\\[\\s*(' + $e815fda779bc047b$var$tokens.variable + ')\\s*(' + $e815fda779bc047b$var$tokens.comparatorOp + ')\\s*(' + $e815fda779bc047b$var$tokens.value + ')\\s*\\]',
        populate: function populate(selector, query, _ref11) {
            var _ref12 = $e815fda779bc047b$var$_slicedToArray(_ref11, 3), variable = _ref12[0], comparatorOp = _ref12[1], value = _ref12[2];
            var valueIsString = new RegExp('^' + $e815fda779bc047b$var$tokens.string + '$').exec(value) != null;
            if (valueIsString) value = value.substring(1, value.length - 1);
            else value = parseFloat(value);
            query.checks.push({
                type: $e815fda779bc047b$var$Type.DATA_COMPARE,
                field: $e815fda779bc047b$var$cleanMetaChars(variable),
                operator: comparatorOp,
                value: value
            });
        }
    },
    {
        name: 'dataBool',
        query: true,
        regex: '\\[\\s*(' + $e815fda779bc047b$var$tokens.boolOp + ')\\s*(' + $e815fda779bc047b$var$tokens.variable + ')\\s*\\]',
        populate: function populate(selector, query, _ref13) {
            var _ref14 = $e815fda779bc047b$var$_slicedToArray(_ref13, 2), boolOp = _ref14[0], variable = _ref14[1];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.DATA_BOOL,
                field: $e815fda779bc047b$var$cleanMetaChars(variable),
                operator: boolOp
            });
        }
    },
    {
        name: 'metaCompare',
        query: true,
        regex: '\\[\\[\\s*(' + $e815fda779bc047b$var$tokens.meta + ')\\s*(' + $e815fda779bc047b$var$tokens.comparatorOp + ')\\s*(' + $e815fda779bc047b$var$tokens.number + ')\\s*\\]\\]',
        populate: function populate(selector, query, _ref15) {
            var _ref16 = $e815fda779bc047b$var$_slicedToArray(_ref15, 3), meta = _ref16[0], comparatorOp = _ref16[1], number = _ref16[2];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.META_COMPARE,
                field: $e815fda779bc047b$var$cleanMetaChars(meta),
                operator: comparatorOp,
                value: parseFloat(number)
            });
        }
    },
    {
        name: 'nextQuery',
        separator: true,
        regex: $e815fda779bc047b$var$tokens.separator,
        populate: function populate(selector, query) {
            var currentSubject = selector.currentSubject;
            var edgeCount = selector.edgeCount;
            var compoundCount = selector.compoundCount;
            var lastQ = selector[selector.length - 1];
            if (currentSubject != null) {
                lastQ.subject = currentSubject;
                selector.currentSubject = null;
            }
            lastQ.edgeCount = edgeCount;
            lastQ.compoundCount = compoundCount;
            selector.edgeCount = 0;
            selector.compoundCount = 0;
            // go on to next query
            var nextQuery = selector[selector.length++] = $e815fda779bc047b$var$newQuery();
            return nextQuery; // this is the new query to be filled by the following exprs
        }
    },
    {
        name: 'directedEdge',
        separator: true,
        regex: $e815fda779bc047b$var$tokens.directedEdge,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // undirected edge
                var edgeQuery = $e815fda779bc047b$var$newQuery();
                var source = query;
                var target = $e815fda779bc047b$var$newQuery();
                edgeQuery.checks.push({
                    type: $e815fda779bc047b$var$Type.DIRECTED_EDGE,
                    source: source,
                    target: target
                });
                // the query in the selector should be the edge rather than the source
                $e815fda779bc047b$var$replaceLastQuery(selector, query, edgeQuery);
                selector.edgeCount++;
                // we're now populating the target query with expressions that follow
                return target;
            } else {
                // source/target
                var srcTgtQ = $e815fda779bc047b$var$newQuery();
                var _source = query;
                var _target = $e815fda779bc047b$var$newQuery();
                srcTgtQ.checks.push({
                    type: $e815fda779bc047b$var$Type.NODE_SOURCE,
                    source: _source,
                    target: _target
                });
                // the query in the selector should be the neighbourhood rather than the node
                $e815fda779bc047b$var$replaceLastQuery(selector, query, srcTgtQ);
                selector.edgeCount++;
                return _target; // now populating the target with the following expressions
            }
        }
    },
    {
        name: 'undirectedEdge',
        separator: true,
        regex: $e815fda779bc047b$var$tokens.undirectedEdge,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // undirected edge
                var edgeQuery = $e815fda779bc047b$var$newQuery();
                var source = query;
                var target = $e815fda779bc047b$var$newQuery();
                edgeQuery.checks.push({
                    type: $e815fda779bc047b$var$Type.UNDIRECTED_EDGE,
                    nodes: [
                        source,
                        target
                    ]
                });
                // the query in the selector should be the edge rather than the source
                $e815fda779bc047b$var$replaceLastQuery(selector, query, edgeQuery);
                selector.edgeCount++;
                // we're now populating the target query with expressions that follow
                return target;
            } else {
                // neighbourhood
                var nhoodQ = $e815fda779bc047b$var$newQuery();
                var node = query;
                var neighbor = $e815fda779bc047b$var$newQuery();
                nhoodQ.checks.push({
                    type: $e815fda779bc047b$var$Type.NODE_NEIGHBOR,
                    node: node,
                    neighbor: neighbor
                });
                // the query in the selector should be the neighbourhood rather than the node
                $e815fda779bc047b$var$replaceLastQuery(selector, query, nhoodQ);
                return neighbor; // now populating the neighbor with following expressions
            }
        }
    },
    {
        name: 'child',
        separator: true,
        regex: $e815fda779bc047b$var$tokens.child,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // default: child query
                var parentChildQuery = $e815fda779bc047b$var$newQuery();
                var child = $e815fda779bc047b$var$newQuery();
                var parent = selector[selector.length - 1];
                parentChildQuery.checks.push({
                    type: $e815fda779bc047b$var$Type.CHILD,
                    parent: parent,
                    child: child
                });
                // the query in the selector should be the '>' itself
                $e815fda779bc047b$var$replaceLastQuery(selector, query, parentChildQuery);
                selector.compoundCount++;
                // we're now populating the child query with expressions that follow
                return child;
            } else if (selector.currentSubject === query) {
                // compound split query
                var compound = $e815fda779bc047b$var$newQuery();
                var left = selector[selector.length - 1];
                var right = $e815fda779bc047b$var$newQuery();
                var subject = $e815fda779bc047b$var$newQuery();
                var _child = $e815fda779bc047b$var$newQuery();
                var _parent = $e815fda779bc047b$var$newQuery();
                // set up the root compound q
                compound.checks.push({
                    type: $e815fda779bc047b$var$Type.COMPOUND_SPLIT,
                    left: left,
                    right: right,
                    subject: subject
                });
                // populate the subject and replace the q at the old spot (within left) with TRUE
                subject.checks = query.checks; // take the checks from the left
                query.checks = [
                    {
                        type: $e815fda779bc047b$var$Type.TRUE
                    }
                ]; // checks under left refs the subject implicitly
                // set up the right q
                _parent.checks.push({
                    type: $e815fda779bc047b$var$Type.TRUE
                }); // parent implicitly refs the subject
                right.checks.push({
                    type: $e815fda779bc047b$var$Type.PARENT,
                    // type is swapped on right side queries
                    parent: _parent,
                    child: _child // empty for now
                });
                $e815fda779bc047b$var$replaceLastQuery(selector, left, compound);
                // update the ref since we moved things around for `query`
                selector.currentSubject = subject;
                selector.compoundCount++;
                return _child; // now populating the right side's child
            } else {
                // parent query
                // info for parent query
                var _parent2 = $e815fda779bc047b$var$newQuery();
                var _child2 = $e815fda779bc047b$var$newQuery();
                var pcQChecks = [
                    {
                        type: $e815fda779bc047b$var$Type.PARENT,
                        parent: _parent2,
                        child: _child2
                    }
                ];
                // the parent-child query takes the place of the query previously being populated
                _parent2.checks = query.checks; // the previous query contains the checks for the parent
                query.checks = pcQChecks; // pc query takes over
                selector.compoundCount++;
                return _child2; // we're now populating the child
            }
        }
    },
    {
        name: 'descendant',
        separator: true,
        regex: $e815fda779bc047b$var$tokens.descendant,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // default: descendant query
                var ancChQuery = $e815fda779bc047b$var$newQuery();
                var descendant = $e815fda779bc047b$var$newQuery();
                var ancestor = selector[selector.length - 1];
                ancChQuery.checks.push({
                    type: $e815fda779bc047b$var$Type.DESCENDANT,
                    ancestor: ancestor,
                    descendant: descendant
                });
                // the query in the selector should be the '>' itself
                $e815fda779bc047b$var$replaceLastQuery(selector, query, ancChQuery);
                selector.compoundCount++;
                // we're now populating the descendant query with expressions that follow
                return descendant;
            } else if (selector.currentSubject === query) {
                // compound split query
                var compound = $e815fda779bc047b$var$newQuery();
                var left = selector[selector.length - 1];
                var right = $e815fda779bc047b$var$newQuery();
                var subject = $e815fda779bc047b$var$newQuery();
                var _descendant = $e815fda779bc047b$var$newQuery();
                var _ancestor = $e815fda779bc047b$var$newQuery();
                // set up the root compound q
                compound.checks.push({
                    type: $e815fda779bc047b$var$Type.COMPOUND_SPLIT,
                    left: left,
                    right: right,
                    subject: subject
                });
                // populate the subject and replace the q at the old spot (within left) with TRUE
                subject.checks = query.checks; // take the checks from the left
                query.checks = [
                    {
                        type: $e815fda779bc047b$var$Type.TRUE
                    }
                ]; // checks under left refs the subject implicitly
                // set up the right q
                _ancestor.checks.push({
                    type: $e815fda779bc047b$var$Type.TRUE
                }); // ancestor implicitly refs the subject
                right.checks.push({
                    type: $e815fda779bc047b$var$Type.ANCESTOR,
                    // type is swapped on right side queries
                    ancestor: _ancestor,
                    descendant: _descendant // empty for now
                });
                $e815fda779bc047b$var$replaceLastQuery(selector, left, compound);
                // update the ref since we moved things around for `query`
                selector.currentSubject = subject;
                selector.compoundCount++;
                return _descendant; // now populating the right side's descendant
            } else {
                // ancestor query
                // info for parent query
                var _ancestor2 = $e815fda779bc047b$var$newQuery();
                var _descendant2 = $e815fda779bc047b$var$newQuery();
                var adQChecks = [
                    {
                        type: $e815fda779bc047b$var$Type.ANCESTOR,
                        ancestor: _ancestor2,
                        descendant: _descendant2
                    }
                ];
                // the parent-child query takes the place of the query previously being populated
                _ancestor2.checks = query.checks; // the previous query contains the checks for the parent
                query.checks = adQChecks; // pc query takes over
                selector.compoundCount++;
                return _descendant2; // we're now populating the child
            }
        }
    },
    {
        name: 'subject',
        modifier: true,
        regex: $e815fda779bc047b$var$tokens.subject,
        populate: function populate(selector, query) {
            if (selector.currentSubject != null && selector.currentSubject !== query) {
                $e815fda779bc047b$var$warn('Redefinition of subject in selector `' + selector.toString() + '`');
                return false;
            }
            selector.currentSubject = query;
            var topQ = selector[selector.length - 1];
            var topChk = topQ.checks[0];
            var topType = topChk == null ? null : topChk.type;
            if (topType === $e815fda779bc047b$var$Type.DIRECTED_EDGE) // directed edge with subject on the target
            // change to target node check
            topChk.type = $e815fda779bc047b$var$Type.NODE_TARGET;
            else if (topType === $e815fda779bc047b$var$Type.UNDIRECTED_EDGE) {
                // undirected edge with subject on the second node
                // change to neighbor check
                topChk.type = $e815fda779bc047b$var$Type.NODE_NEIGHBOR;
                topChk.node = topChk.nodes[1]; // second node is subject
                topChk.neighbor = topChk.nodes[0];
                // clean up unused fields for new type
                topChk.nodes = null;
            }
        }
    }
];
$e815fda779bc047b$var$exprs.forEach(function(e) {
    return e.regexObj = new RegExp('^' + e.regex);
});
/**
 * Of all the expressions, find the first match in the remaining text.
 * @param {string} remaining The remaining text to parse
 * @returns The matched expression and the newly remaining text `{ expr, match, name, remaining }`
 */ var $e815fda779bc047b$var$consumeExpr = function consumeExpr(remaining) {
    var expr;
    var match;
    var name;
    for(var j = 0; j < $e815fda779bc047b$var$exprs.length; j++){
        var e = $e815fda779bc047b$var$exprs[j];
        var n = e.name;
        var m1 = remaining.match(e.regexObj);
        if (m1 != null) {
            match = m1;
            expr = e;
            name = n;
            var consumed = m1[0];
            remaining = remaining.substring(consumed.length);
            break; // we've consumed one expr, so we can return now
        }
    }
    return {
        expr: expr,
        match: match,
        name: name,
        remaining: remaining
    };
};
/**
 * Consume all the leading whitespace
 * @param {string} remaining The text to consume
 * @returns The text with the leading whitespace removed
 */ var $e815fda779bc047b$var$consumeWhitespace = function consumeWhitespace(remaining) {
    var match = remaining.match(/^\s+/);
    if (match) {
        var consumed = match[0];
        remaining = remaining.substring(consumed.length);
    }
    return remaining;
};
/**
 * Parse the string and store the parsed representation in the Selector.
 * @param {string} selector The selector string
 * @returns `true` if the selector was successfully parsed, `false` otherwise
 */ var $e815fda779bc047b$var$parse = function parse(selector) {
    var self1 = this;
    var remaining = self1.inputText = selector;
    var currentQuery = self1[0] = $e815fda779bc047b$var$newQuery();
    self1.length = 1;
    remaining = $e815fda779bc047b$var$consumeWhitespace(remaining); // get rid of leading whitespace
    for(;;){
        var exprInfo = $e815fda779bc047b$var$consumeExpr(remaining);
        if (exprInfo.expr == null) {
            $e815fda779bc047b$var$warn('The selector `' + selector + '`is invalid');
            return false;
        } else {
            var args = exprInfo.match.slice(1);
            // let the token populate the selector object in currentQuery
            var ret = exprInfo.expr.populate(self1, currentQuery, args);
            if (ret === false) return false; // exit if population failed
            else if (ret != null) currentQuery = ret; // change the current query to be filled if the expr specifies
        }
        remaining = exprInfo.remaining;
        // we're done when there's nothing left to parse
        if (remaining.match(/^\s*$/)) break;
    }
    var lastQ = self1[self1.length - 1];
    if (self1.currentSubject != null) lastQ.subject = self1.currentSubject;
    lastQ.edgeCount = self1.edgeCount;
    lastQ.compoundCount = self1.compoundCount;
    for(var i = 0; i < self1.length; i++){
        var q = self1[i];
        // in future, this could potentially be allowed if there were operator precedence and detection of invalid combinations
        if (q.compoundCount > 0 && q.edgeCount > 0) {
            $e815fda779bc047b$var$warn('The selector `' + selector + '` is invalid because it uses both a compound selector and an edge selector');
            return false;
        }
        if (q.edgeCount > 1) {
            $e815fda779bc047b$var$warn('The selector `' + selector + '` is invalid because it uses multiple edge selectors');
            return false;
        } else if (q.edgeCount === 1) $e815fda779bc047b$var$warn('The selector `' + selector + '` is deprecated.  Edge selectors do not take effect on changes to source and target nodes after an edge is added, for performance reasons.  Use a class or data selector on edges instead, updating the class or data of an edge when your app detects a change in source or target nodes.');
    }
    return true; // success
};
/**
 * Get the selector represented as a string.  This value uses default formatting,
 * so things like spacing may differ from the input text passed to the constructor.
 * @returns {string} The selector string
 */ var $e815fda779bc047b$var$toString = function toString() {
    if (this.toStringCache != null) return this.toStringCache;
    var clean = function clean(obj) {
        if (obj == null) return '';
        else return obj;
    };
    var cleanVal = function cleanVal(val) {
        if ($e815fda779bc047b$var$string(val)) return '"' + val + '"';
        else return clean(val);
    };
    var space = function space(val) {
        return ' ' + val + ' ';
    };
    var checkToString = function checkToString(check, subject) {
        var type = check.type, value = check.value;
        switch(type){
            case $e815fda779bc047b$var$Type.GROUP:
                var group = clean(value);
                return group.substring(0, group.length - 1);
            case $e815fda779bc047b$var$Type.DATA_COMPARE:
                var field = check.field, operator = check.operator;
                return '[' + field + space(clean(operator)) + cleanVal(value) + ']';
            case $e815fda779bc047b$var$Type.DATA_BOOL:
                var _operator = check.operator, _field = check.field;
                return '[' + clean(_operator) + _field + ']';
            case $e815fda779bc047b$var$Type.DATA_EXIST:
                var _field2 = check.field;
                return '[' + _field2 + ']';
            case $e815fda779bc047b$var$Type.META_COMPARE:
                var _operator2 = check.operator, _field3 = check.field;
                return '[[' + _field3 + space(clean(_operator2)) + cleanVal(value) + ']]';
            case $e815fda779bc047b$var$Type.STATE:
                return value;
            case $e815fda779bc047b$var$Type.ID:
                return '#' + value;
            case $e815fda779bc047b$var$Type.CLASS:
                return '.' + value;
            case $e815fda779bc047b$var$Type.PARENT:
            case $e815fda779bc047b$var$Type.CHILD:
                return queryToString(check.parent, subject) + space('>') + queryToString(check.child, subject);
            case $e815fda779bc047b$var$Type.ANCESTOR:
            case $e815fda779bc047b$var$Type.DESCENDANT:
                return queryToString(check.ancestor, subject) + ' ' + queryToString(check.descendant, subject);
            case $e815fda779bc047b$var$Type.COMPOUND_SPLIT:
                var lhs = queryToString(check.left, subject);
                var sub = queryToString(check.subject, subject);
                var rhs = queryToString(check.right, subject);
                return lhs + (lhs.length > 0 ? ' ' : '') + sub + rhs;
            case $e815fda779bc047b$var$Type.TRUE:
                return '';
        }
    };
    var queryToString = function queryToString(query, subject) {
        return query.checks.reduce(function(str, chk, i) {
            return str + (subject === query && i === 0 ? '$' : '') + checkToString(chk, subject);
        }, '');
    };
    var str = '';
    for(var i = 0; i < this.length; i++){
        var query = this[i];
        str += queryToString(query, query.subject);
        if (this.length > 1 && i < this.length - 1) str += ', ';
    }
    this.toStringCache = str;
    return str;
};
var $e815fda779bc047b$var$parse$1 = {
    parse: $e815fda779bc047b$var$parse,
    toString: $e815fda779bc047b$var$toString
};
var $e815fda779bc047b$var$valCmp = function valCmp(fieldVal, operator, value) {
    var matches;
    var isFieldStr = $e815fda779bc047b$var$string(fieldVal);
    var isFieldNum = $e815fda779bc047b$var$number$1(fieldVal);
    var isValStr = $e815fda779bc047b$var$string(value);
    var fieldStr, valStr;
    var caseInsensitive = false;
    var notExpr = false;
    var isIneqCmp = false;
    if (operator.indexOf('!') >= 0) {
        operator = operator.replace('!', '');
        notExpr = true;
    }
    if (operator.indexOf('@') >= 0) {
        operator = operator.replace('@', '');
        caseInsensitive = true;
    }
    if (isFieldStr || isValStr || caseInsensitive) {
        fieldStr = !isFieldStr && !isFieldNum ? '' : '' + fieldVal;
        valStr = '' + value;
    }
    // if we're doing a case insensitive comparison, then we're using a STRING comparison
    // even if we're comparing numbers
    if (caseInsensitive) {
        fieldVal = fieldStr = fieldStr.toLowerCase();
        value = valStr = valStr.toLowerCase();
    }
    switch(operator){
        case '*=':
            matches = fieldStr.indexOf(valStr) >= 0;
            break;
        case '$=':
            matches = fieldStr.indexOf(valStr, fieldStr.length - valStr.length) >= 0;
            break;
        case '^=':
            matches = fieldStr.indexOf(valStr) === 0;
            break;
        case '=':
            matches = fieldVal === value;
            break;
        case '>':
            isIneqCmp = true;
            matches = fieldVal > value;
            break;
        case '>=':
            isIneqCmp = true;
            matches = fieldVal >= value;
            break;
        case '<':
            isIneqCmp = true;
            matches = fieldVal < value;
            break;
        case '<=':
            isIneqCmp = true;
            matches = fieldVal <= value;
            break;
        default:
            matches = false;
            break;
    }
    // apply the not op, but null vals for inequalities should always stay non-matching
    if (notExpr && (fieldVal != null || !isIneqCmp)) matches = !matches;
    return matches;
};
var $e815fda779bc047b$var$boolCmp = function boolCmp(fieldVal, operator) {
    switch(operator){
        case '?':
            return fieldVal ? true : false;
        case '!':
            return fieldVal ? false : true;
        case '^':
            return fieldVal === undefined;
    }
};
var $e815fda779bc047b$var$existCmp = function existCmp(fieldVal) {
    return fieldVal !== undefined;
};
var $e815fda779bc047b$var$data$1 = function data(ele, field) {
    return ele.data(field);
};
var $e815fda779bc047b$var$meta = function meta(ele, field) {
    return ele[field]();
};
/** A lookup of `match(check, ele)` functions by `Type` int */ var $e815fda779bc047b$var$match = [];
/**
 * Returns whether the query matches for the element
 * @param query The `{ type, value, ... }` query object
 * @param ele The element to compare against
*/ var $e815fda779bc047b$var$matches$1 = function matches(query, ele) {
    return query.checks.every(function(chk) {
        return $e815fda779bc047b$var$match[chk.type](chk, ele);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.GROUP] = function(check, ele) {
    var group = check.value;
    return group === '*' || group === ele.group();
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.STATE] = function(check, ele) {
    var stateSelector = check.value;
    return $e815fda779bc047b$var$stateSelectorMatches(stateSelector, ele);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.ID] = function(check, ele) {
    var id = check.value;
    return ele.id() === id;
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.CLASS] = function(check, ele) {
    var cls = check.value;
    return ele.hasClass(cls);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.META_COMPARE] = function(check, ele) {
    var field = check.field, operator = check.operator, value = check.value;
    return $e815fda779bc047b$var$valCmp($e815fda779bc047b$var$meta(ele, field), operator, value);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.DATA_COMPARE] = function(check, ele) {
    var field = check.field, operator = check.operator, value = check.value;
    return $e815fda779bc047b$var$valCmp($e815fda779bc047b$var$data$1(ele, field), operator, value);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.DATA_BOOL] = function(check, ele) {
    var field = check.field, operator = check.operator;
    return $e815fda779bc047b$var$boolCmp($e815fda779bc047b$var$data$1(ele, field), operator);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.DATA_EXIST] = function(check, ele) {
    var field = check.field;
    check.operator;
    return $e815fda779bc047b$var$existCmp($e815fda779bc047b$var$data$1(ele, field));
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.UNDIRECTED_EDGE] = function(check, ele) {
    var qA = check.nodes[0];
    var qB = check.nodes[1];
    var src = ele.source();
    var tgt = ele.target();
    return $e815fda779bc047b$var$matches$1(qA, src) && $e815fda779bc047b$var$matches$1(qB, tgt) || $e815fda779bc047b$var$matches$1(qB, src) && $e815fda779bc047b$var$matches$1(qA, tgt);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.NODE_NEIGHBOR] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.node, ele) && ele.neighborhood().some(function(n) {
        return n.isNode() && $e815fda779bc047b$var$matches$1(check.neighbor, n);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.DIRECTED_EDGE] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.source, ele.source()) && $e815fda779bc047b$var$matches$1(check.target, ele.target());
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.NODE_SOURCE] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.source, ele) && ele.outgoers().some(function(n) {
        return n.isNode() && $e815fda779bc047b$var$matches$1(check.target, n);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.NODE_TARGET] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.target, ele) && ele.incomers().some(function(n) {
        return n.isNode() && $e815fda779bc047b$var$matches$1(check.source, n);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.CHILD] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.child, ele) && $e815fda779bc047b$var$matches$1(check.parent, ele.parent());
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.PARENT] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.parent, ele) && ele.children().some(function(c) {
        return $e815fda779bc047b$var$matches$1(check.child, c);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.DESCENDANT] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.descendant, ele) && ele.ancestors().some(function(a) {
        return $e815fda779bc047b$var$matches$1(check.ancestor, a);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.ANCESTOR] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.ancestor, ele) && ele.descendants().some(function(d) {
        return $e815fda779bc047b$var$matches$1(check.descendant, d);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.COMPOUND_SPLIT] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.subject, ele) && $e815fda779bc047b$var$matches$1(check.left, ele) && $e815fda779bc047b$var$matches$1(check.right, ele);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.TRUE] = function() {
    return true;
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.COLLECTION] = function(check, ele) {
    var collection = check.value;
    return collection.has(ele);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.FILTER] = function(check, ele) {
    var filter = check.value;
    return filter(ele);
};
// filter an existing collection
var $e815fda779bc047b$var$filter = function filter(collection) {
    var self1 = this;
    // for 1 id #foo queries, just get the element
    if (self1.length === 1 && self1[0].checks.length === 1 && self1[0].checks[0].type === $e815fda779bc047b$var$Type.ID) return collection.getElementById(self1[0].checks[0].value).collection();
    var selectorFunction = function selectorFunction(element) {
        for(var j = 0; j < self1.length; j++){
            var query = self1[j];
            if ($e815fda779bc047b$var$matches$1(query, element)) return true;
        }
        return false;
    };
    if (self1.text() == null) selectorFunction = function selectorFunction() {
        return true;
    };
    return collection.filter(selectorFunction);
}; // filter
// does selector match a single element?
var $e815fda779bc047b$var$matches = function matches(ele) {
    var self1 = this;
    for(var j = 0; j < self1.length; j++){
        var query = self1[j];
        if ($e815fda779bc047b$var$matches$1(query, ele)) return true;
    }
    return false;
}; // matches
var $e815fda779bc047b$var$matching = {
    matches: $e815fda779bc047b$var$matches,
    filter: $e815fda779bc047b$var$filter
};
var $e815fda779bc047b$var$Selector = function Selector(selector) {
    this.inputText = selector;
    this.currentSubject = null;
    this.compoundCount = 0;
    this.edgeCount = 0;
    this.length = 0;
    if (selector == null || $e815fda779bc047b$var$string(selector) && selector.match(/^\s*$/)) ;
    else if ($e815fda779bc047b$var$elementOrCollection(selector)) this.addQuery({
        checks: [
            {
                type: $e815fda779bc047b$var$Type.COLLECTION,
                value: selector.collection()
            }
        ]
    });
    else if ($e815fda779bc047b$var$fn$6(selector)) this.addQuery({
        checks: [
            {
                type: $e815fda779bc047b$var$Type.FILTER,
                value: selector
            }
        ]
    });
    else if ($e815fda779bc047b$var$string(selector)) {
        if (!this.parse(selector)) this.invalid = true;
    } else $e815fda779bc047b$var$error('A selector must be created from a string; found ');
};
var $e815fda779bc047b$var$selfn = $e815fda779bc047b$var$Selector.prototype;
[
    $e815fda779bc047b$var$parse$1,
    $e815fda779bc047b$var$matching
].forEach(function(p) {
    return $e815fda779bc047b$var$extend($e815fda779bc047b$var$selfn, p);
});
$e815fda779bc047b$var$selfn.text = function() {
    return this.inputText;
};
$e815fda779bc047b$var$selfn.size = function() {
    return this.length;
};
$e815fda779bc047b$var$selfn.eq = function(i) {
    return this[i];
};
$e815fda779bc047b$var$selfn.sameText = function(otherSel) {
    return !this.invalid && !otherSel.invalid && this.text() === otherSel.text();
};
$e815fda779bc047b$var$selfn.addQuery = function(q) {
    this[this.length++] = q;
};
$e815fda779bc047b$var$selfn.selector = $e815fda779bc047b$var$selfn.toString;
var $e815fda779bc047b$var$elesfn$g = {
    allAre: function allAre(selector) {
        var selObj = new $e815fda779bc047b$var$Selector(selector);
        return this.every(function(ele) {
            return selObj.matches(ele);
        });
    },
    is: function is(selector) {
        var selObj = new $e815fda779bc047b$var$Selector(selector);
        return this.some(function(ele) {
            return selObj.matches(ele);
        });
    },
    some: function some(fn, thisArg) {
        for(var i = 0; i < this.length; i++){
            var ret = !thisArg ? fn(this[i], i, this) : fn.apply(thisArg, [
                this[i],
                i,
                this
            ]);
            if (ret) return true;
        }
        return false;
    },
    every: function every(fn, thisArg) {
        for(var i = 0; i < this.length; i++){
            var ret = !thisArg ? fn(this[i], i, this) : fn.apply(thisArg, [
                this[i],
                i,
                this
            ]);
            if (!ret) return false;
        }
        return true;
    },
    same: function same(collection) {
        // cheap collection ref check
        if (this === collection) return true;
        collection = this.cy().collection(collection);
        var thisLength = this.length;
        var collectionLength = collection.length;
        // cheap length check
        if (thisLength !== collectionLength) return false;
        // cheap element ref check
        if (thisLength === 1) return this[0] === collection[0];
        return this.every(function(ele) {
            return collection.hasElementWithId(ele.id());
        });
    },
    anySame: function anySame(collection) {
        collection = this.cy().collection(collection);
        return this.some(function(ele) {
            return collection.hasElementWithId(ele.id());
        });
    },
    allAreNeighbors: function allAreNeighbors(collection) {
        collection = this.cy().collection(collection);
        var nhood = this.neighborhood();
        return collection.every(function(ele) {
            return nhood.hasElementWithId(ele.id());
        });
    },
    contains: function contains(collection) {
        collection = this.cy().collection(collection);
        var self1 = this;
        return collection.every(function(ele) {
            return self1.hasElementWithId(ele.id());
        });
    }
};
$e815fda779bc047b$var$elesfn$g.allAreNeighbours = $e815fda779bc047b$var$elesfn$g.allAreNeighbors;
$e815fda779bc047b$var$elesfn$g.has = $e815fda779bc047b$var$elesfn$g.contains;
$e815fda779bc047b$var$elesfn$g.equal = $e815fda779bc047b$var$elesfn$g.equals = $e815fda779bc047b$var$elesfn$g.same;
var $e815fda779bc047b$var$cache = function cache(fn, name) {
    return function traversalCache(arg1, arg2, arg3, arg4) {
        var selectorOrEles = arg1;
        var eles = this;
        var key;
        if (selectorOrEles == null) key = '';
        else if ($e815fda779bc047b$var$elementOrCollection(selectorOrEles) && selectorOrEles.length === 1) key = selectorOrEles.id();
        if (eles.length === 1 && key) {
            var _p = eles[0]._private;
            var tch = _p.traversalCache = _p.traversalCache || {};
            var ch = tch[name] = tch[name] || [];
            var hash = $e815fda779bc047b$var$hashString(key);
            var cacheHit = ch[hash];
            if (cacheHit) return cacheHit;
            else return ch[hash] = fn.call(eles, arg1, arg2, arg3, arg4);
        } else return fn.call(eles, arg1, arg2, arg3, arg4);
    };
};
var $e815fda779bc047b$var$elesfn$f = {
    parent: function parent(selector) {
        var parents = [];
        // optimisation for single ele call
        if (this.length === 1) {
            var parent = this[0]._private.parent;
            if (parent) return parent;
        }
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var _parent = ele._private.parent;
            if (_parent) parents.push(_parent);
        }
        return this.spawn(parents, true).filter(selector);
    },
    parents: function parents(selector) {
        var parents = [];
        var eles = this.parent();
        while(eles.nonempty()){
            for(var i = 0; i < eles.length; i++){
                var ele = eles[i];
                parents.push(ele);
            }
            eles = eles.parent();
        }
        return this.spawn(parents, true).filter(selector);
    },
    commonAncestors: function commonAncestors(selector) {
        var ancestors;
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var parents = ele.parents();
            ancestors = ancestors || parents;
            ancestors = ancestors.intersect(parents); // current list must be common with current ele parents set
        }
        return ancestors.filter(selector);
    },
    orphans: function orphans(selector) {
        return this.stdFilter(function(ele) {
            return ele.isOrphan();
        }).filter(selector);
    },
    nonorphans: function nonorphans(selector) {
        return this.stdFilter(function(ele) {
            return ele.isChild();
        }).filter(selector);
    },
    children: $e815fda779bc047b$var$cache(function(selector) {
        var children = [];
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var eleChildren = ele._private.children;
            for(var j = 0; j < eleChildren.length; j++)children.push(eleChildren[j]);
        }
        return this.spawn(children, true).filter(selector);
    }, 'children'),
    siblings: function siblings(selector) {
        return this.parent().children().not(this).filter(selector);
    },
    isParent: function isParent() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.children.length !== 0;
    },
    isChildless: function isChildless() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.children.length === 0;
    },
    isChild: function isChild() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.parent != null;
    },
    isOrphan: function isOrphan() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.parent == null;
    },
    descendants: function descendants(selector) {
        var elements = [];
        function add(eles) {
            for(var i = 0; i < eles.length; i++){
                var ele = eles[i];
                elements.push(ele);
                if (ele.children().nonempty()) add(ele.children());
            }
        }
        add(this.children());
        return this.spawn(elements, true).filter(selector);
    }
};
function $e815fda779bc047b$var$forEachCompound(eles, fn, includeSelf, recursiveStep) {
    var q = [];
    var did = new $e815fda779bc047b$var$Set$1();
    var cy = eles.cy();
    var hasCompounds = cy.hasCompoundNodes();
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        if (includeSelf) q.push(ele);
        else if (hasCompounds) recursiveStep(q, did, ele);
    }
    while(q.length > 0){
        var _ele = q.shift();
        fn(_ele);
        did.add(_ele.id());
        if (hasCompounds) recursiveStep(q, did, _ele);
    }
    return eles;
}
function $e815fda779bc047b$var$addChildren(q, did, ele) {
    if (ele.isParent()) {
        var children = ele._private.children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (!did.has(child.id())) q.push(child);
        }
    }
}
// very efficient version of eles.add( eles.descendants() ).forEach()
// for internal use
$e815fda779bc047b$var$elesfn$f.forEachDown = function(fn) {
    var includeSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return $e815fda779bc047b$var$forEachCompound(this, fn, includeSelf, $e815fda779bc047b$var$addChildren);
};
function $e815fda779bc047b$var$addParent(q, did, ele) {
    if (ele.isChild()) {
        var parent = ele._private.parent;
        if (!did.has(parent.id())) q.push(parent);
    }
}
$e815fda779bc047b$var$elesfn$f.forEachUp = function(fn) {
    var includeSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return $e815fda779bc047b$var$forEachCompound(this, fn, includeSelf, $e815fda779bc047b$var$addParent);
};
function $e815fda779bc047b$var$addParentAndChildren(q, did, ele) {
    $e815fda779bc047b$var$addParent(q, did, ele);
    $e815fda779bc047b$var$addChildren(q, did, ele);
}
$e815fda779bc047b$var$elesfn$f.forEachUpAndDown = function(fn) {
    var includeSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return $e815fda779bc047b$var$forEachCompound(this, fn, includeSelf, $e815fda779bc047b$var$addParentAndChildren);
};
// aliases
$e815fda779bc047b$var$elesfn$f.ancestors = $e815fda779bc047b$var$elesfn$f.parents;
var $e815fda779bc047b$var$fn$5, $e815fda779bc047b$var$elesfn$e;
$e815fda779bc047b$var$fn$5 = $e815fda779bc047b$var$elesfn$e = {
    data: $e815fda779bc047b$var$define.data({
        field: 'data',
        bindingEvent: 'data',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'data',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        immutableKeys: {
            'id': true,
            'source': true,
            'target': true,
            'parent': true
        },
        updateStyle: true
    }),
    removeData: $e815fda779bc047b$var$define.removeData({
        field: 'data',
        event: 'data',
        triggerFnName: 'trigger',
        triggerEvent: true,
        immutableKeys: {
            'id': true,
            'source': true,
            'target': true,
            'parent': true
        },
        updateStyle: true
    }),
    scratch: $e815fda779bc047b$var$define.data({
        field: 'scratch',
        bindingEvent: 'scratch',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'scratch',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        updateStyle: true
    }),
    removeScratch: $e815fda779bc047b$var$define.removeData({
        field: 'scratch',
        event: 'scratch',
        triggerFnName: 'trigger',
        triggerEvent: true,
        updateStyle: true
    }),
    rscratch: $e815fda779bc047b$var$define.data({
        field: 'rscratch',
        allowBinding: false,
        allowSetting: true,
        settingTriggersEvent: false,
        allowGetting: true
    }),
    removeRscratch: $e815fda779bc047b$var$define.removeData({
        field: 'rscratch',
        triggerEvent: false
    }),
    id: function id() {
        var ele = this[0];
        if (ele) return ele._private.data.id;
    }
};
// aliases
$e815fda779bc047b$var$fn$5.attr = $e815fda779bc047b$var$fn$5.data;
$e815fda779bc047b$var$fn$5.removeAttr = $e815fda779bc047b$var$fn$5.removeData;
var $e815fda779bc047b$var$data = $e815fda779bc047b$var$elesfn$e;
var $e815fda779bc047b$var$elesfn$d = {};
function $e815fda779bc047b$var$defineDegreeFunction(callback) {
    return function(includeLoops) {
        var self1 = this;
        if (includeLoops === undefined) includeLoops = true;
        if (self1.length === 0) return;
        if (self1.isNode() && !self1.removed()) {
            var degree = 0;
            var node = self1[0];
            var connectedEdges = node._private.edges;
            for(var i = 0; i < connectedEdges.length; i++){
                var edge = connectedEdges[i];
                if (!includeLoops && edge.isLoop()) continue;
                degree += callback(node, edge);
            }
            return degree;
        } else return;
    };
}
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$d, {
    degree: $e815fda779bc047b$var$defineDegreeFunction(function(node, edge) {
        if (edge.source().same(edge.target())) return 2;
        else return 1;
    }),
    indegree: $e815fda779bc047b$var$defineDegreeFunction(function(node, edge) {
        if (edge.target().same(node)) return 1;
        else return 0;
    }),
    outdegree: $e815fda779bc047b$var$defineDegreeFunction(function(node, edge) {
        if (edge.source().same(node)) return 1;
        else return 0;
    })
});
function $e815fda779bc047b$var$defineDegreeBoundsFunction(degreeFn, callback) {
    return function(includeLoops) {
        var ret;
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++){
            var ele = nodes[i];
            var degree = ele[degreeFn](includeLoops);
            if (degree !== undefined && (ret === undefined || callback(degree, ret))) ret = degree;
        }
        return ret;
    };
}
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$d, {
    minDegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('degree', function(degree, min) {
        return degree < min;
    }),
    maxDegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('degree', function(degree, max) {
        return degree > max;
    }),
    minIndegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('indegree', function(degree, min) {
        return degree < min;
    }),
    maxIndegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('indegree', function(degree, max) {
        return degree > max;
    }),
    minOutdegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('outdegree', function(degree, min) {
        return degree < min;
    }),
    maxOutdegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('outdegree', function(degree, max) {
        return degree > max;
    })
});
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$d, {
    totalDegree: function totalDegree(includeLoops) {
        var total = 0;
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++)total += nodes[i].degree(includeLoops);
        return total;
    }
});
var $e815fda779bc047b$var$fn$4, $e815fda779bc047b$var$elesfn$c;
var $e815fda779bc047b$var$beforePositionSet = function beforePositionSet(eles, newPos, silent) {
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        if (!ele.locked()) {
            var oldPos = ele._private.position;
            var delta = {
                x: newPos.x != null ? newPos.x - oldPos.x : 0,
                y: newPos.y != null ? newPos.y - oldPos.y : 0
            };
            if (ele.isParent() && !(delta.x === 0 && delta.y === 0)) ele.children().shift(delta, silent);
            ele.dirtyBoundingBoxCache();
        }
    }
};
var $e815fda779bc047b$var$positionDef = {
    field: 'position',
    bindingEvent: 'position',
    allowBinding: true,
    allowSetting: true,
    settingEvent: 'position',
    settingTriggersEvent: true,
    triggerFnName: 'emitAndNotify',
    allowGetting: true,
    validKeys: [
        'x',
        'y'
    ],
    beforeGet: function beforeGet(ele) {
        ele.updateCompoundBounds();
    },
    beforeSet: function beforeSet(eles, newPos) {
        $e815fda779bc047b$var$beforePositionSet(eles, newPos, false);
    },
    onSet: function onSet(eles) {
        eles.dirtyCompoundBoundsCache();
    },
    canSet: function canSet(ele) {
        return !ele.locked();
    }
};
$e815fda779bc047b$var$fn$4 = $e815fda779bc047b$var$elesfn$c = {
    position: $e815fda779bc047b$var$define.data($e815fda779bc047b$var$positionDef),
    // position but no notification to renderer
    silentPosition: $e815fda779bc047b$var$define.data($e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$positionDef, {
        allowBinding: false,
        allowSetting: true,
        settingTriggersEvent: false,
        allowGetting: false,
        beforeSet: function beforeSet(eles, newPos) {
            $e815fda779bc047b$var$beforePositionSet(eles, newPos, true);
        },
        onSet: function onSet(eles) {
            eles.dirtyCompoundBoundsCache();
        }
    })),
    positions: function positions(pos, silent) {
        if ($e815fda779bc047b$var$plainObject(pos)) {
            if (silent) this.silentPosition(pos);
            else this.position(pos);
        } else if ($e815fda779bc047b$var$fn$6(pos)) {
            var _fn = pos;
            var cy = this.cy();
            cy.startBatch();
            for(var i = 0; i < this.length; i++){
                var ele = this[i];
                var _pos = void 0;
                if (_pos = _fn(ele, i)) {
                    if (silent) ele.silentPosition(_pos);
                    else ele.position(_pos);
                }
            }
            cy.endBatch();
        }
        return this; // chaining
    },
    silentPositions: function silentPositions(pos) {
        return this.positions(pos, true);
    },
    shift: function shift(dim, val, silent) {
        var delta;
        if ($e815fda779bc047b$var$plainObject(dim)) {
            delta = {
                x: $e815fda779bc047b$var$number$1(dim.x) ? dim.x : 0,
                y: $e815fda779bc047b$var$number$1(dim.y) ? dim.y : 0
            };
            silent = val;
        } else if ($e815fda779bc047b$var$string(dim) && $e815fda779bc047b$var$number$1(val)) {
            delta = {
                x: 0,
                y: 0
            };
            delta[dim] = val;
        }
        if (delta != null) {
            var cy = this.cy();
            cy.startBatch();
            for(var i = 0; i < this.length; i++){
                var ele = this[i];
                // exclude any node that is a descendant of the calling collection
                if (cy.hasCompoundNodes() && ele.isChild() && ele.ancestors().anySame(this)) continue;
                var pos = ele.position();
                var newPos = {
                    x: pos.x + delta.x,
                    y: pos.y + delta.y
                };
                if (silent) ele.silentPosition(newPos);
                else ele.position(newPos);
            }
            cy.endBatch();
        }
        return this;
    },
    silentShift: function silentShift(dim, val) {
        if ($e815fda779bc047b$var$plainObject(dim)) this.shift(dim, true);
        else if ($e815fda779bc047b$var$string(dim) && $e815fda779bc047b$var$number$1(val)) this.shift(dim, val, true);
        return this;
    },
    // get/set the rendered (i.e. on screen) positon of the element
    renderedPosition: function renderedPosition(dim, val) {
        var ele = this[0];
        var cy = this.cy();
        var zoom = cy.zoom();
        var pan = cy.pan();
        var rpos = $e815fda779bc047b$var$plainObject(dim) ? dim : undefined;
        var setting = rpos !== undefined || val !== undefined && $e815fda779bc047b$var$string(dim);
        if (ele && ele.isNode()) {
            // must have an element and must be a node to return position
            if (setting) for(var i = 0; i < this.length; i++){
                var _ele = this[i];
                if (val !== undefined) // set one dimension
                _ele.position(dim, (val - pan[dim]) / zoom);
                else if (rpos !== undefined) // set whole position
                _ele.position($e815fda779bc047b$var$renderedToModelPosition(rpos, zoom, pan));
            }
            else {
                // getting
                var pos = ele.position();
                rpos = $e815fda779bc047b$var$modelToRenderedPosition(pos, zoom, pan);
                if (dim === undefined) // then return the whole rendered position
                return rpos;
                else // then return the specified dimension
                return rpos[dim];
            }
        } else if (!setting) return undefined; // for empty collection case
        return this; // chaining
    },
    // get/set the position relative to the parent
    relativePosition: function relativePosition(dim, val) {
        var ele = this[0];
        var cy = this.cy();
        var ppos = $e815fda779bc047b$var$plainObject(dim) ? dim : undefined;
        var setting = ppos !== undefined || val !== undefined && $e815fda779bc047b$var$string(dim);
        var hasCompoundNodes = cy.hasCompoundNodes();
        if (ele && ele.isNode()) {
            // must have an element and must be a node to return position
            if (setting) for(var i = 0; i < this.length; i++){
                var _ele2 = this[i];
                var parent = hasCompoundNodes ? _ele2.parent() : null;
                var hasParent = parent && parent.length > 0;
                var relativeToParent = hasParent;
                if (hasParent) parent = parent[0];
                var origin = relativeToParent ? parent.position() : {
                    x: 0,
                    y: 0
                };
                if (val !== undefined) // set one dimension
                _ele2.position(dim, val + origin[dim]);
                else if (ppos !== undefined) // set whole position
                _ele2.position({
                    x: ppos.x + origin.x,
                    y: ppos.y + origin.y
                });
            }
            else {
                // getting
                var pos = ele.position();
                var _parent = hasCompoundNodes ? ele.parent() : null;
                var _hasParent = _parent && _parent.length > 0;
                var _relativeToParent = _hasParent;
                if (_hasParent) _parent = _parent[0];
                var _origin = _relativeToParent ? _parent.position() : {
                    x: 0,
                    y: 0
                };
                ppos = {
                    x: pos.x - _origin.x,
                    y: pos.y - _origin.y
                };
                if (dim === undefined) // then return the whole rendered position
                return ppos;
                else // then return the specified dimension
                return ppos[dim];
            }
        } else if (!setting) return undefined; // for empty collection case
        return this; // chaining
    }
};
// aliases
$e815fda779bc047b$var$fn$4.modelPosition = $e815fda779bc047b$var$fn$4.point = $e815fda779bc047b$var$fn$4.position;
$e815fda779bc047b$var$fn$4.modelPositions = $e815fda779bc047b$var$fn$4.points = $e815fda779bc047b$var$fn$4.positions;
$e815fda779bc047b$var$fn$4.renderedPoint = $e815fda779bc047b$var$fn$4.renderedPosition;
$e815fda779bc047b$var$fn$4.relativePoint = $e815fda779bc047b$var$fn$4.relativePosition;
var $e815fda779bc047b$var$position = $e815fda779bc047b$var$elesfn$c;
var $e815fda779bc047b$var$fn$3, $e815fda779bc047b$var$elesfn$b;
$e815fda779bc047b$var$fn$3 = $e815fda779bc047b$var$elesfn$b = {};
$e815fda779bc047b$var$elesfn$b.renderedBoundingBox = function(options) {
    var bb = this.boundingBox(options);
    var cy = this.cy();
    var zoom = cy.zoom();
    var pan = cy.pan();
    var x1 = bb.x1 * zoom + pan.x;
    var x2 = bb.x2 * zoom + pan.x;
    var y1 = bb.y1 * zoom + pan.y;
    var y2 = bb.y2 * zoom + pan.y;
    return {
        x1: x1,
        x2: x2,
        y1: y1,
        y2: y2,
        w: x2 - x1,
        h: y2 - y1
    };
};
$e815fda779bc047b$var$elesfn$b.dirtyCompoundBoundsCache = function() {
    var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var cy = this.cy();
    if (!cy.styleEnabled() || !cy.hasCompoundNodes()) return this;
    this.forEachUp(function(ele) {
        if (ele.isParent()) {
            var _p = ele._private;
            _p.compoundBoundsClean = false;
            _p.bbCache = null;
            if (!silent) ele.emitAndNotify('bounds');
        }
    });
    return this;
};
$e815fda779bc047b$var$elesfn$b.updateCompoundBounds = function() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var cy = this.cy();
    // not possible to do on non-compound graphs or with the style disabled
    if (!cy.styleEnabled() || !cy.hasCompoundNodes()) return this;
    // save cycles when batching -- but bounds will be stale (or not exist yet)
    if (!force && cy.batching()) return this;
    function update(parent) {
        if (!parent.isParent()) return;
        var _p = parent._private;
        var children = parent.children();
        var includeLabels = parent.pstyle('compound-sizing-wrt-labels').value === 'include';
        var min = {
            width: {
                val: parent.pstyle('min-width').pfValue,
                left: parent.pstyle('min-width-bias-left'),
                right: parent.pstyle('min-width-bias-right')
            },
            height: {
                val: parent.pstyle('min-height').pfValue,
                top: parent.pstyle('min-height-bias-top'),
                bottom: parent.pstyle('min-height-bias-bottom')
            }
        };
        var bb = children.boundingBox({
            includeLabels: includeLabels,
            includeOverlays: false,
            // updating the compound bounds happens outside of the regular
            // cache cycle (i.e. before fired events)
            useCache: false
        });
        var pos = _p.position;
        // if children take up zero area then keep position and fall back on stylesheet w/h
        if (bb.w === 0 || bb.h === 0) {
            bb = {
                w: parent.pstyle('width').pfValue,
                h: parent.pstyle('height').pfValue
            };
            bb.x1 = pos.x - bb.w / 2;
            bb.x2 = pos.x + bb.w / 2;
            bb.y1 = pos.y - bb.h / 2;
            bb.y2 = pos.y + bb.h / 2;
        }
        function computeBiasValues(propDiff, propBias, propBiasComplement) {
            var biasDiff = 0;
            var biasComplementDiff = 0;
            var biasTotal = propBias + propBiasComplement;
            if (propDiff > 0 && biasTotal > 0) {
                biasDiff = propBias / biasTotal * propDiff;
                biasComplementDiff = propBiasComplement / biasTotal * propDiff;
            }
            return {
                biasDiff: biasDiff,
                biasComplementDiff: biasComplementDiff
            };
        }
        function computePaddingValues(width, height, paddingObject, relativeTo) {
            // Assuming percentage is number from 0 to 1
            if (paddingObject.units === '%') switch(relativeTo){
                case 'width':
                    return width > 0 ? paddingObject.pfValue * width : 0;
                case 'height':
                    return height > 0 ? paddingObject.pfValue * height : 0;
                case 'average':
                    return width > 0 && height > 0 ? paddingObject.pfValue * (width + height) / 2 : 0;
                case 'min':
                    return width > 0 && height > 0 ? width > height ? paddingObject.pfValue * height : paddingObject.pfValue * width : 0;
                case 'max':
                    return width > 0 && height > 0 ? width > height ? paddingObject.pfValue * width : paddingObject.pfValue * height : 0;
                default:
                    return 0;
            }
            else if (paddingObject.units === 'px') return paddingObject.pfValue;
            else return 0;
        }
        var leftVal = min.width.left.value;
        if (min.width.left.units === 'px' && min.width.val > 0) leftVal = leftVal * 100 / min.width.val;
        var rightVal = min.width.right.value;
        if (min.width.right.units === 'px' && min.width.val > 0) rightVal = rightVal * 100 / min.width.val;
        var topVal = min.height.top.value;
        if (min.height.top.units === 'px' && min.height.val > 0) topVal = topVal * 100 / min.height.val;
        var bottomVal = min.height.bottom.value;
        if (min.height.bottom.units === 'px' && min.height.val > 0) bottomVal = bottomVal * 100 / min.height.val;
        var widthBiasDiffs = computeBiasValues(min.width.val - bb.w, leftVal, rightVal);
        var diffLeft = widthBiasDiffs.biasDiff;
        var diffRight = widthBiasDiffs.biasComplementDiff;
        var heightBiasDiffs = computeBiasValues(min.height.val - bb.h, topVal, bottomVal);
        var diffTop = heightBiasDiffs.biasDiff;
        var diffBottom = heightBiasDiffs.biasComplementDiff;
        _p.autoPadding = computePaddingValues(bb.w, bb.h, parent.pstyle('padding'), parent.pstyle('padding-relative-to').value);
        _p.autoWidth = Math.max(bb.w, min.width.val);
        pos.x = (-diffLeft + bb.x1 + bb.x2 + diffRight) / 2;
        _p.autoHeight = Math.max(bb.h, min.height.val);
        pos.y = (-diffTop + bb.y1 + bb.y2 + diffBottom) / 2;
    }
    for(var i = 0; i < this.length; i++){
        var ele = this[i];
        var _p = ele._private;
        if (!_p.compoundBoundsClean || force) {
            update(ele);
            if (!cy.batching()) _p.compoundBoundsClean = true;
        }
    }
    return this;
};
var $e815fda779bc047b$var$noninf = function noninf(x) {
    if (x === Infinity || x === -Infinity) return 0;
    return x;
};
var $e815fda779bc047b$var$updateBounds = function updateBounds(b, x1, y1, x2, y2) {
    // don't update with zero area boxes
    if (x2 - x1 === 0 || y2 - y1 === 0) return;
    // don't update with null dim
    if (x1 == null || y1 == null || x2 == null || y2 == null) return;
    b.x1 = x1 < b.x1 ? x1 : b.x1;
    b.x2 = x2 > b.x2 ? x2 : b.x2;
    b.y1 = y1 < b.y1 ? y1 : b.y1;
    b.y2 = y2 > b.y2 ? y2 : b.y2;
    b.w = b.x2 - b.x1;
    b.h = b.y2 - b.y1;
};
var $e815fda779bc047b$var$updateBoundsFromBox = function updateBoundsFromBox(b, b2) {
    if (b2 == null) return b;
    return $e815fda779bc047b$var$updateBounds(b, b2.x1, b2.y1, b2.x2, b2.y2);
};
var $e815fda779bc047b$var$prefixedProperty = function prefixedProperty(obj, field, prefix) {
    return $e815fda779bc047b$var$getPrefixedProperty(obj, field, prefix);
};
var $e815fda779bc047b$var$updateBoundsFromArrow = function updateBoundsFromArrow(bounds, ele, prefix) {
    if (ele.cy().headless()) return;
    var _p = ele._private;
    var rstyle = _p.rstyle;
    var halfArW = rstyle.arrowWidth / 2;
    var arrowType = ele.pstyle(prefix + '-arrow-shape').value;
    var x;
    var y;
    if (arrowType !== 'none') {
        if (prefix === 'source') {
            x = rstyle.srcX;
            y = rstyle.srcY;
        } else if (prefix === 'target') {
            x = rstyle.tgtX;
            y = rstyle.tgtY;
        } else {
            x = rstyle.midX;
            y = rstyle.midY;
        }
        // always store the individual arrow bounds
        var bbs = _p.arrowBounds = _p.arrowBounds || {};
        var bb = bbs[prefix] = bbs[prefix] || {};
        bb.x1 = x - halfArW;
        bb.y1 = y - halfArW;
        bb.x2 = x + halfArW;
        bb.y2 = y + halfArW;
        bb.w = bb.x2 - bb.x1;
        bb.h = bb.y2 - bb.y1;
        $e815fda779bc047b$var$expandBoundingBox(bb, 1);
        $e815fda779bc047b$var$updateBounds(bounds, bb.x1, bb.y1, bb.x2, bb.y2);
    }
};
var $e815fda779bc047b$var$updateBoundsFromLabel = function updateBoundsFromLabel(bounds, ele, prefix) {
    if (ele.cy().headless()) return;
    var prefixDash;
    if (prefix) prefixDash = prefix + '-';
    else prefixDash = '';
    var _p = ele._private;
    var rstyle = _p.rstyle;
    var label = ele.pstyle(prefixDash + 'label').strValue;
    if (label) {
        var halign = ele.pstyle('text-halign');
        var valign = ele.pstyle('text-valign');
        var labelWidth = $e815fda779bc047b$var$prefixedProperty(rstyle, 'labelWidth', prefix);
        var labelHeight = $e815fda779bc047b$var$prefixedProperty(rstyle, 'labelHeight', prefix);
        var labelX = $e815fda779bc047b$var$prefixedProperty(rstyle, 'labelX', prefix);
        var labelY = $e815fda779bc047b$var$prefixedProperty(rstyle, 'labelY', prefix);
        var marginX = ele.pstyle(prefixDash + 'text-margin-x').pfValue;
        var marginY = ele.pstyle(prefixDash + 'text-margin-y').pfValue;
        var isEdge = ele.isEdge();
        var rotation = ele.pstyle(prefixDash + 'text-rotation');
        var outlineWidth = ele.pstyle('text-outline-width').pfValue;
        var borderWidth = ele.pstyle('text-border-width').pfValue;
        var halfBorderWidth = borderWidth / 2;
        var padding = ele.pstyle('text-background-padding').pfValue;
        var marginOfError = 2; // expand to work around browser dimension inaccuracies
        var lh = labelHeight;
        var lw = labelWidth;
        var lw_2 = lw / 2;
        var lh_2 = lh / 2;
        var lx1, lx2, ly1, ly2;
        if (isEdge) {
            lx1 = labelX - lw_2;
            lx2 = labelX + lw_2;
            ly1 = labelY - lh_2;
            ly2 = labelY + lh_2;
        } else {
            switch(halign.value){
                case 'left':
                    lx1 = labelX - lw;
                    lx2 = labelX;
                    break;
                case 'center':
                    lx1 = labelX - lw_2;
                    lx2 = labelX + lw_2;
                    break;
                case 'right':
                    lx1 = labelX;
                    lx2 = labelX + lw;
                    break;
            }
            switch(valign.value){
                case 'top':
                    ly1 = labelY - lh;
                    ly2 = labelY;
                    break;
                case 'center':
                    ly1 = labelY - lh_2;
                    ly2 = labelY + lh_2;
                    break;
                case 'bottom':
                    ly1 = labelY;
                    ly2 = labelY + lh;
                    break;
            }
        }
        // shift by margin and expand by outline and border
        var leftPad = marginX - Math.max(outlineWidth, halfBorderWidth) - padding - marginOfError;
        var rightPad = marginX + Math.max(outlineWidth, halfBorderWidth) + padding + marginOfError;
        var topPad = marginY - Math.max(outlineWidth, halfBorderWidth) - padding - marginOfError;
        var botPad = marginY + Math.max(outlineWidth, halfBorderWidth) + padding + marginOfError;
        lx1 += leftPad;
        lx2 += rightPad;
        ly1 += topPad;
        ly2 += botPad;
        // always store the unrotated label bounds separately
        var bbPrefix = prefix || 'main';
        var bbs = _p.labelBounds;
        var bb = bbs[bbPrefix] = bbs[bbPrefix] || {};
        bb.x1 = lx1;
        bb.y1 = ly1;
        bb.x2 = lx2;
        bb.y2 = ly2;
        bb.w = lx2 - lx1;
        bb.h = ly2 - ly1;
        bb.leftPad = leftPad;
        bb.rightPad = rightPad;
        bb.topPad = topPad;
        bb.botPad = botPad;
        var isAutorotate = isEdge && rotation.strValue === 'autorotate';
        var isPfValue = rotation.pfValue != null && rotation.pfValue !== 0;
        if (isAutorotate || isPfValue) {
            var theta = isAutorotate ? $e815fda779bc047b$var$prefixedProperty(_p.rstyle, 'labelAngle', prefix) : rotation.pfValue;
            var cos = Math.cos(theta);
            var sin = Math.sin(theta);
            // rotation point (default value for center-center)
            var xo = (lx1 + lx2) / 2;
            var yo = (ly1 + ly2) / 2;
            if (!isEdge) {
                switch(halign.value){
                    case 'left':
                        xo = lx2;
                        break;
                    case 'right':
                        xo = lx1;
                        break;
                }
                switch(valign.value){
                    case 'top':
                        yo = ly2;
                        break;
                    case 'bottom':
                        yo = ly1;
                        break;
                }
            }
            var rotate = function rotate(x, y) {
                x = x - xo;
                y = y - yo;
                return {
                    x: x * cos - y * sin + xo,
                    y: x * sin + y * cos + yo
                };
            };
            var px1y1 = rotate(lx1, ly1);
            var px1y2 = rotate(lx1, ly2);
            var px2y1 = rotate(lx2, ly1);
            var px2y2 = rotate(lx2, ly2);
            lx1 = Math.min(px1y1.x, px1y2.x, px2y1.x, px2y2.x);
            lx2 = Math.max(px1y1.x, px1y2.x, px2y1.x, px2y2.x);
            ly1 = Math.min(px1y1.y, px1y2.y, px2y1.y, px2y2.y);
            ly2 = Math.max(px1y1.y, px1y2.y, px2y1.y, px2y2.y);
        }
        var bbPrefixRot = bbPrefix + 'Rot';
        var bbRot = bbs[bbPrefixRot] = bbs[bbPrefixRot] || {};
        bbRot.x1 = lx1;
        bbRot.y1 = ly1;
        bbRot.x2 = lx2;
        bbRot.y2 = ly2;
        bbRot.w = lx2 - lx1;
        bbRot.h = ly2 - ly1;
        $e815fda779bc047b$var$updateBounds(bounds, lx1, ly1, lx2, ly2);
        $e815fda779bc047b$var$updateBounds(_p.labelBounds.all, lx1, ly1, lx2, ly2);
    }
    return bounds;
};
var $e815fda779bc047b$var$updateBoundsFromOutline = function updateBoundsFromOutline(bounds, ele) {
    if (ele.cy().headless()) return;
    var outlineOpacity = ele.pstyle('outline-opacity').value;
    var outlineWidth = ele.pstyle('outline-width').value;
    if (outlineOpacity > 0 && outlineWidth > 0) {
        var outlineOffset = ele.pstyle('outline-offset').value;
        var nodeShape = ele.pstyle('shape').value;
        var outlineSize = outlineWidth + outlineOffset;
        var scaleX = (bounds.w + outlineSize * 2) / bounds.w;
        var scaleY = (bounds.h + outlineSize * 2) / bounds.h;
        var xOffset = 0;
        var yOffset = 0;
        if ([
            "diamond",
            "pentagon",
            "round-triangle"
        ].includes(nodeShape)) {
            scaleX = (bounds.w + outlineSize * 2.4) / bounds.w;
            yOffset = -outlineSize / 3.6;
        } else if ([
            "concave-hexagon",
            "rhomboid",
            "right-rhomboid"
        ].includes(nodeShape)) scaleX = (bounds.w + outlineSize * 2.4) / bounds.w;
        else if (nodeShape === "star") {
            scaleX = (bounds.w + outlineSize * 2.8) / bounds.w;
            scaleY = (bounds.h + outlineSize * 2.6) / bounds.h;
            yOffset = -outlineSize / 3.8;
        } else if (nodeShape === "triangle") {
            scaleX = (bounds.w + outlineSize * 2.8) / bounds.w;
            scaleY = (bounds.h + outlineSize * 2.4) / bounds.h;
            yOffset = -outlineSize / 1.4;
        } else if (nodeShape === "vee") {
            scaleX = (bounds.w + outlineSize * 4.4) / bounds.w;
            scaleY = (bounds.h + outlineSize * 3.8) / bounds.h;
            yOffset = -outlineSize * .5;
        }
        var hDelta = bounds.h * scaleY - bounds.h;
        var wDelta = bounds.w * scaleX - bounds.w;
        $e815fda779bc047b$var$expandBoundingBoxSides(bounds, [
            Math.ceil(hDelta / 2),
            Math.ceil(wDelta / 2)
        ]);
        if (xOffset != 0 || yOffset !== 0) {
            var oBounds = $e815fda779bc047b$var$shiftBoundingBox(bounds, xOffset, yOffset);
            $e815fda779bc047b$var$updateBoundingBox(bounds, oBounds);
        }
    }
};
// get the bounding box of the elements (in raw model position)
var $e815fda779bc047b$var$boundingBoxImpl = function boundingBoxImpl(ele, options) {
    var cy = ele._private.cy;
    var styleEnabled = cy.styleEnabled();
    var headless = cy.headless();
    var bounds = $e815fda779bc047b$var$makeBoundingBox();
    var _p = ele._private;
    var isNode = ele.isNode();
    var isEdge = ele.isEdge();
    var ex1, ex2, ey1, ey2; // extrema of body / lines
    var x, y; // node pos
    var rstyle = _p.rstyle;
    var manualExpansion = isNode && styleEnabled ? ele.pstyle('bounds-expansion').pfValue : [
        0
    ];
    // must use `display` prop only, as reading `compound.width()` causes recursion
    // (other factors like width values will be considered later in this function anyway)
    var isDisplayed = function isDisplayed(ele) {
        return ele.pstyle('display').value !== 'none';
    };
    var displayed = !styleEnabled || isDisplayed(ele) && (!isEdge || isDisplayed(ele.source()) && isDisplayed(ele.target()));
    if (displayed) {
        // displayed suffices, since we will find zero area eles anyway
        var overlayOpacity = 0;
        var overlayPadding = 0;
        if (styleEnabled && options.includeOverlays) {
            overlayOpacity = ele.pstyle('overlay-opacity').value;
            if (overlayOpacity !== 0) overlayPadding = ele.pstyle('overlay-padding').value;
        }
        var underlayOpacity = 0;
        var underlayPadding = 0;
        if (styleEnabled && options.includeUnderlays) {
            underlayOpacity = ele.pstyle('underlay-opacity').value;
            if (underlayOpacity !== 0) underlayPadding = ele.pstyle('underlay-padding').value;
        }
        var padding = Math.max(overlayPadding, underlayPadding);
        var w = 0;
        var wHalf = 0;
        if (styleEnabled) {
            w = ele.pstyle('width').pfValue;
            wHalf = w / 2;
        }
        if (isNode && options.includeNodes) {
            var pos = ele.position();
            x = pos.x;
            y = pos.y;
            var _w = ele.outerWidth();
            var halfW = _w / 2;
            var h = ele.outerHeight();
            var halfH = h / 2;
            // handle node dimensions
            /////////////////////////
            ex1 = x - halfW;
            ex2 = x + halfW;
            ey1 = y - halfH;
            ey2 = y + halfH;
            $e815fda779bc047b$var$updateBounds(bounds, ex1, ey1, ex2, ey2);
            if (styleEnabled && options.includeOutlines) $e815fda779bc047b$var$updateBoundsFromOutline(bounds, ele);
        } else if (isEdge && options.includeEdges) {
            if (styleEnabled && !headless) {
                var curveStyle = ele.pstyle('curve-style').strValue;
                // handle edge dimensions (rough box estimate)
                //////////////////////////////////////////////
                ex1 = Math.min(rstyle.srcX, rstyle.midX, rstyle.tgtX);
                ex2 = Math.max(rstyle.srcX, rstyle.midX, rstyle.tgtX);
                ey1 = Math.min(rstyle.srcY, rstyle.midY, rstyle.tgtY);
                ey2 = Math.max(rstyle.srcY, rstyle.midY, rstyle.tgtY);
                // take into account edge width
                ex1 -= wHalf;
                ex2 += wHalf;
                ey1 -= wHalf;
                ey2 += wHalf;
                $e815fda779bc047b$var$updateBounds(bounds, ex1, ey1, ex2, ey2);
                // precise edges
                ////////////////
                if (curveStyle === 'haystack') {
                    var hpts = rstyle.haystackPts;
                    if (hpts && hpts.length === 2) {
                        ex1 = hpts[0].x;
                        ey1 = hpts[0].y;
                        ex2 = hpts[1].x;
                        ey2 = hpts[1].y;
                        if (ex1 > ex2) {
                            var temp = ex1;
                            ex1 = ex2;
                            ex2 = temp;
                        }
                        if (ey1 > ey2) {
                            var _temp = ey1;
                            ey1 = ey2;
                            ey2 = _temp;
                        }
                        $e815fda779bc047b$var$updateBounds(bounds, ex1 - wHalf, ey1 - wHalf, ex2 + wHalf, ey2 + wHalf);
                    }
                } else if (curveStyle === 'bezier' || curveStyle === 'unbundled-bezier' || curveStyle.endsWith('segments') || curveStyle.endsWith('taxi')) {
                    var pts;
                    switch(curveStyle){
                        case 'bezier':
                        case 'unbundled-bezier':
                            pts = rstyle.bezierPts;
                            break;
                        case 'segments':
                        case 'taxi':
                        case 'round-segments':
                        case 'round-taxi':
                            pts = rstyle.linePts;
                            break;
                    }
                    if (pts != null) for(var j = 0; j < pts.length; j++){
                        var pt = pts[j];
                        ex1 = pt.x - wHalf;
                        ex2 = pt.x + wHalf;
                        ey1 = pt.y - wHalf;
                        ey2 = pt.y + wHalf;
                        $e815fda779bc047b$var$updateBounds(bounds, ex1, ey1, ex2, ey2);
                    }
                } // bezier-like or segment-like edge
            } else {
                // headless or style disabled
                // fallback on source and target positions
                //////////////////////////////////////////
                var n1 = ele.source();
                var n1pos = n1.position();
                var n2 = ele.target();
                var n2pos = n2.position();
                ex1 = n1pos.x;
                ex2 = n2pos.x;
                ey1 = n1pos.y;
                ey2 = n2pos.y;
                if (ex1 > ex2) {
                    var _temp2 = ex1;
                    ex1 = ex2;
                    ex2 = _temp2;
                }
                if (ey1 > ey2) {
                    var _temp3 = ey1;
                    ey1 = ey2;
                    ey2 = _temp3;
                }
                // take into account edge width
                ex1 -= wHalf;
                ex2 += wHalf;
                ey1 -= wHalf;
                ey2 += wHalf;
                $e815fda779bc047b$var$updateBounds(bounds, ex1, ey1, ex2, ey2);
            } // headless or style disabled
        } // edges
        // handle edge arrow size
        /////////////////////////
        if (styleEnabled && options.includeEdges && isEdge) {
            $e815fda779bc047b$var$updateBoundsFromArrow(bounds, ele, 'mid-source');
            $e815fda779bc047b$var$updateBoundsFromArrow(bounds, ele, 'mid-target');
            $e815fda779bc047b$var$updateBoundsFromArrow(bounds, ele, 'source');
            $e815fda779bc047b$var$updateBoundsFromArrow(bounds, ele, 'target');
        }
        // ghost
        ////////
        if (styleEnabled) {
            var ghost = ele.pstyle('ghost').value === 'yes';
            if (ghost) {
                var gx = ele.pstyle('ghost-offset-x').pfValue;
                var gy = ele.pstyle('ghost-offset-y').pfValue;
                $e815fda779bc047b$var$updateBounds(bounds, bounds.x1 + gx, bounds.y1 + gy, bounds.x2 + gx, bounds.y2 + gy);
            }
        }
        // always store the body bounds separately from the labels
        var bbBody = _p.bodyBounds = _p.bodyBounds || {};
        $e815fda779bc047b$var$assignBoundingBox(bbBody, bounds);
        $e815fda779bc047b$var$expandBoundingBoxSides(bbBody, manualExpansion);
        $e815fda779bc047b$var$expandBoundingBox(bbBody, 1); // expand to work around browser dimension inaccuracies
        // overlay
        //////////
        if (styleEnabled) {
            ex1 = bounds.x1;
            ex2 = bounds.x2;
            ey1 = bounds.y1;
            ey2 = bounds.y2;
            $e815fda779bc047b$var$updateBounds(bounds, ex1 - padding, ey1 - padding, ex2 + padding, ey2 + padding);
        }
        // always store the body bounds separately from the labels
        var bbOverlay = _p.overlayBounds = _p.overlayBounds || {};
        $e815fda779bc047b$var$assignBoundingBox(bbOverlay, bounds);
        $e815fda779bc047b$var$expandBoundingBoxSides(bbOverlay, manualExpansion);
        $e815fda779bc047b$var$expandBoundingBox(bbOverlay, 1); // expand to work around browser dimension inaccuracies
        // handle label dimensions
        //////////////////////////
        var bbLabels = _p.labelBounds = _p.labelBounds || {};
        if (bbLabels.all != null) $e815fda779bc047b$var$clearBoundingBox(bbLabels.all);
        else bbLabels.all = $e815fda779bc047b$var$makeBoundingBox();
        if (styleEnabled && options.includeLabels) {
            if (options.includeMainLabels) $e815fda779bc047b$var$updateBoundsFromLabel(bounds, ele, null);
            if (isEdge) {
                if (options.includeSourceLabels) $e815fda779bc047b$var$updateBoundsFromLabel(bounds, ele, 'source');
                if (options.includeTargetLabels) $e815fda779bc047b$var$updateBoundsFromLabel(bounds, ele, 'target');
            }
        } // style enabled for labels
    } // if displayed
    bounds.x1 = $e815fda779bc047b$var$noninf(bounds.x1);
    bounds.y1 = $e815fda779bc047b$var$noninf(bounds.y1);
    bounds.x2 = $e815fda779bc047b$var$noninf(bounds.x2);
    bounds.y2 = $e815fda779bc047b$var$noninf(bounds.y2);
    bounds.w = $e815fda779bc047b$var$noninf(bounds.x2 - bounds.x1);
    bounds.h = $e815fda779bc047b$var$noninf(bounds.y2 - bounds.y1);
    if (bounds.w > 0 && bounds.h > 0 && displayed) {
        $e815fda779bc047b$var$expandBoundingBoxSides(bounds, manualExpansion);
        // expand bounds by 1 because antialiasing can increase the visual/effective size by 1 on all sides
        $e815fda779bc047b$var$expandBoundingBox(bounds, 1);
    }
    return bounds;
};
var $e815fda779bc047b$var$getKey = function getKey(opts) {
    var i = 0;
    var tf = function tf(val) {
        return (val ? 1 : 0) << i++;
    };
    var key = 0;
    key += tf(opts.incudeNodes);
    key += tf(opts.includeEdges);
    key += tf(opts.includeLabels);
    key += tf(opts.includeMainLabels);
    key += tf(opts.includeSourceLabels);
    key += tf(opts.includeTargetLabels);
    key += tf(opts.includeOverlays);
    key += tf(opts.includeOutlines);
    return key;
};
var $e815fda779bc047b$var$getBoundingBoxPosKey = function getBoundingBoxPosKey(ele) {
    if (ele.isEdge()) {
        var p1 = ele.source().position();
        var p2 = ele.target().position();
        var r = function r(x) {
            return Math.round(x);
        };
        return $e815fda779bc047b$var$hashIntsArray([
            r(p1.x),
            r(p1.y),
            r(p2.x),
            r(p2.y)
        ]);
    } else return 0;
};
var $e815fda779bc047b$var$cachedBoundingBoxImpl = function cachedBoundingBoxImpl(ele, opts) {
    var _p = ele._private;
    var bb;
    var isEdge = ele.isEdge();
    var key = opts == null ? $e815fda779bc047b$var$defBbOptsKey : $e815fda779bc047b$var$getKey(opts);
    var usingDefOpts = key === $e815fda779bc047b$var$defBbOptsKey;
    var currPosKey = $e815fda779bc047b$var$getBoundingBoxPosKey(ele);
    var isPosKeySame = _p.bbCachePosKey === currPosKey;
    var useCache = opts.useCache && isPosKeySame;
    var isDirty = function isDirty(ele) {
        return ele._private.bbCache == null || ele._private.styleDirty;
    };
    var needRecalc = !useCache || isDirty(ele) || isEdge && (isDirty(ele.source()) || isDirty(ele.target()));
    if (needRecalc) {
        if (!isPosKeySame) ele.recalculateRenderedStyle(useCache);
        bb = $e815fda779bc047b$var$boundingBoxImpl(ele, $e815fda779bc047b$var$defBbOpts);
        _p.bbCache = bb;
        _p.bbCachePosKey = currPosKey;
    } else bb = _p.bbCache;
    // not using def opts => need to build up bb from combination of sub bbs
    if (!usingDefOpts) {
        var isNode = ele.isNode();
        bb = $e815fda779bc047b$var$makeBoundingBox();
        if (opts.includeNodes && isNode || opts.includeEdges && !isNode) {
            if (opts.includeOverlays) $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.overlayBounds);
            else $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.bodyBounds);
        }
        if (opts.includeLabels) {
            if (opts.includeMainLabels && (!isEdge || opts.includeSourceLabels && opts.includeTargetLabels)) $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.labelBounds.all);
            else {
                if (opts.includeMainLabels) $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.labelBounds.mainRot);
                if (opts.includeSourceLabels) $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.labelBounds.sourceRot);
                if (opts.includeTargetLabels) $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.labelBounds.targetRot);
            }
        }
        bb.w = bb.x2 - bb.x1;
        bb.h = bb.y2 - bb.y1;
    }
    return bb;
};
var $e815fda779bc047b$var$defBbOpts = {
    includeNodes: true,
    includeEdges: true,
    includeLabels: true,
    includeMainLabels: true,
    includeSourceLabels: true,
    includeTargetLabels: true,
    includeOverlays: true,
    includeUnderlays: true,
    includeOutlines: true,
    useCache: true
};
var $e815fda779bc047b$var$defBbOptsKey = $e815fda779bc047b$var$getKey($e815fda779bc047b$var$defBbOpts);
var $e815fda779bc047b$var$filledBbOpts = $e815fda779bc047b$var$defaults$g($e815fda779bc047b$var$defBbOpts);
$e815fda779bc047b$var$elesfn$b.boundingBox = function(options) {
    var bounds;
    // the main usecase is ele.boundingBox() for a single element with no/def options
    // specified s.t. the cache is used, so check for this case to make it faster by
    // avoiding the overhead of the rest of the function
    if (this.length === 1 && this[0]._private.bbCache != null && !this[0]._private.styleDirty && (options === undefined || options.useCache === undefined || options.useCache === true)) {
        if (options === undefined) options = $e815fda779bc047b$var$defBbOpts;
        else options = $e815fda779bc047b$var$filledBbOpts(options);
        bounds = $e815fda779bc047b$var$cachedBoundingBoxImpl(this[0], options);
    } else {
        bounds = $e815fda779bc047b$var$makeBoundingBox();
        options = options || $e815fda779bc047b$var$defBbOpts;
        var opts = $e815fda779bc047b$var$filledBbOpts(options);
        var eles = this;
        var cy = eles.cy();
        var styleEnabled = cy.styleEnabled();
        if (styleEnabled) for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var _p = ele._private;
            var currPosKey = $e815fda779bc047b$var$getBoundingBoxPosKey(ele);
            var isPosKeySame = _p.bbCachePosKey === currPosKey;
            var useCache = opts.useCache && isPosKeySame && !_p.styleDirty;
            ele.recalculateRenderedStyle(useCache);
        }
        this.updateCompoundBounds(!options.useCache);
        for(var _i = 0; _i < eles.length; _i++){
            var _ele = eles[_i];
            $e815fda779bc047b$var$updateBoundsFromBox(bounds, $e815fda779bc047b$var$cachedBoundingBoxImpl(_ele, opts));
        }
    }
    bounds.x1 = $e815fda779bc047b$var$noninf(bounds.x1);
    bounds.y1 = $e815fda779bc047b$var$noninf(bounds.y1);
    bounds.x2 = $e815fda779bc047b$var$noninf(bounds.x2);
    bounds.y2 = $e815fda779bc047b$var$noninf(bounds.y2);
    bounds.w = $e815fda779bc047b$var$noninf(bounds.x2 - bounds.x1);
    bounds.h = $e815fda779bc047b$var$noninf(bounds.y2 - bounds.y1);
    return bounds;
};
$e815fda779bc047b$var$elesfn$b.dirtyBoundingBoxCache = function() {
    for(var i = 0; i < this.length; i++){
        var _p = this[i]._private;
        _p.bbCache = null;
        _p.bbCachePosKey = null;
        _p.bodyBounds = null;
        _p.overlayBounds = null;
        _p.labelBounds.all = null;
        _p.labelBounds.source = null;
        _p.labelBounds.target = null;
        _p.labelBounds.main = null;
        _p.labelBounds.sourceRot = null;
        _p.labelBounds.targetRot = null;
        _p.labelBounds.mainRot = null;
        _p.arrowBounds.source = null;
        _p.arrowBounds.target = null;
        _p.arrowBounds['mid-source'] = null;
        _p.arrowBounds['mid-target'] = null;
    }
    this.emitAndNotify('bounds');
    return this;
};
// private helper to get bounding box for custom node positions
// - good for perf in certain cases but currently requires dirtying the rendered style
// - would be better to not modify the nodes but the nodes are read directly everywhere in the renderer...
// - try to use for only things like discrete layouts where the node position would change anyway
$e815fda779bc047b$var$elesfn$b.boundingBoxAt = function(fn) {
    var nodes = this.nodes();
    var cy = this.cy();
    var hasCompoundNodes = cy.hasCompoundNodes();
    var parents = cy.collection();
    if (hasCompoundNodes) {
        parents = nodes.filter(function(node) {
            return node.isParent();
        });
        nodes = nodes.not(parents);
    }
    if ($e815fda779bc047b$var$plainObject(fn)) {
        var obj = fn;
        fn = function fn() {
            return obj;
        };
    }
    var storeOldPos = function storeOldPos(node, i) {
        return node._private.bbAtOldPos = fn(node, i);
    };
    var getOldPos = function getOldPos(node) {
        return node._private.bbAtOldPos;
    };
    cy.startBatch();
    nodes.forEach(storeOldPos).silentPositions(fn);
    if (hasCompoundNodes) {
        parents.dirtyCompoundBoundsCache();
        parents.dirtyBoundingBoxCache();
        parents.updateCompoundBounds(true); // force update b/c we're inside a batch cycle
    }
    var bb = $e815fda779bc047b$var$copyBoundingBox(this.boundingBox({
        useCache: false
    }));
    nodes.silentPositions(getOldPos);
    if (hasCompoundNodes) {
        parents.dirtyCompoundBoundsCache();
        parents.dirtyBoundingBoxCache();
        parents.updateCompoundBounds(true); // force update b/c we're inside a batch cycle
    }
    cy.endBatch();
    return bb;
};
$e815fda779bc047b$var$fn$3.boundingbox = $e815fda779bc047b$var$fn$3.bb = $e815fda779bc047b$var$fn$3.boundingBox;
$e815fda779bc047b$var$fn$3.renderedBoundingbox = $e815fda779bc047b$var$fn$3.renderedBoundingBox;
var $e815fda779bc047b$var$bounds = $e815fda779bc047b$var$elesfn$b;
var $e815fda779bc047b$var$fn$2, $e815fda779bc047b$var$elesfn$a;
$e815fda779bc047b$var$fn$2 = $e815fda779bc047b$var$elesfn$a = {};
var $e815fda779bc047b$var$defineDimFns = function defineDimFns(opts) {
    opts.uppercaseName = $e815fda779bc047b$var$capitalize(opts.name);
    opts.autoName = 'auto' + opts.uppercaseName;
    opts.labelName = 'label' + opts.uppercaseName;
    opts.outerName = 'outer' + opts.uppercaseName;
    opts.uppercaseOuterName = $e815fda779bc047b$var$capitalize(opts.outerName);
    $e815fda779bc047b$var$fn$2[opts.name] = function dimImpl() {
        var ele = this[0];
        var _p = ele._private;
        var cy = _p.cy;
        var styleEnabled = cy._private.styleEnabled;
        if (ele) {
            if (styleEnabled) {
                if (ele.isParent()) {
                    ele.updateCompoundBounds();
                    return _p[opts.autoName] || 0;
                }
                var d = ele.pstyle(opts.name);
                switch(d.strValue){
                    case 'label':
                        ele.recalculateRenderedStyle();
                        return _p.rstyle[opts.labelName] || 0;
                    default:
                        return d.pfValue;
                }
            } else return 1;
        }
    };
    $e815fda779bc047b$var$fn$2['outer' + opts.uppercaseName] = function outerDimImpl() {
        var ele = this[0];
        var _p = ele._private;
        var cy = _p.cy;
        var styleEnabled = cy._private.styleEnabled;
        if (ele) {
            if (styleEnabled) {
                var dim = ele[opts.name]();
                var border = ele.pstyle('border-width').pfValue; // n.b. 1/2 each side
                var padding = 2 * ele.padding();
                return dim + border + padding;
            } else return 1;
        }
    };
    $e815fda779bc047b$var$fn$2['rendered' + opts.uppercaseName] = function renderedDimImpl() {
        var ele = this[0];
        if (ele) {
            var d = ele[opts.name]();
            return d * this.cy().zoom();
        }
    };
    $e815fda779bc047b$var$fn$2['rendered' + opts.uppercaseOuterName] = function renderedOuterDimImpl() {
        var ele = this[0];
        if (ele) {
            var od = ele[opts.outerName]();
            return od * this.cy().zoom();
        }
    };
};
$e815fda779bc047b$var$defineDimFns({
    name: 'width'
});
$e815fda779bc047b$var$defineDimFns({
    name: 'height'
});
$e815fda779bc047b$var$elesfn$a.padding = function() {
    var ele = this[0];
    var _p = ele._private;
    if (ele.isParent()) {
        ele.updateCompoundBounds();
        if (_p.autoPadding !== undefined) return _p.autoPadding;
        else return ele.pstyle('padding').pfValue;
    } else return ele.pstyle('padding').pfValue;
};
$e815fda779bc047b$var$elesfn$a.paddedHeight = function() {
    var ele = this[0];
    return ele.height() + 2 * ele.padding();
};
$e815fda779bc047b$var$elesfn$a.paddedWidth = function() {
    var ele = this[0];
    return ele.width() + 2 * ele.padding();
};
var $e815fda779bc047b$var$widthHeight = $e815fda779bc047b$var$elesfn$a;
var $e815fda779bc047b$var$ifEdge = function ifEdge(ele, getValue) {
    if (ele.isEdge()) return getValue(ele);
};
var $e815fda779bc047b$var$ifEdgeRenderedPosition = function ifEdgeRenderedPosition(ele, getPoint) {
    if (ele.isEdge()) {
        var cy = ele.cy();
        return $e815fda779bc047b$var$modelToRenderedPosition(getPoint(ele), cy.zoom(), cy.pan());
    }
};
var $e815fda779bc047b$var$ifEdgeRenderedPositions = function ifEdgeRenderedPositions(ele, getPoints) {
    if (ele.isEdge()) {
        var cy = ele.cy();
        var pan = cy.pan();
        var zoom = cy.zoom();
        return getPoints(ele).map(function(p) {
            return $e815fda779bc047b$var$modelToRenderedPosition(p, zoom, pan);
        });
    }
};
var $e815fda779bc047b$var$controlPoints = function controlPoints(ele) {
    return ele.renderer().getControlPoints(ele);
};
var $e815fda779bc047b$var$segmentPoints = function segmentPoints(ele) {
    return ele.renderer().getSegmentPoints(ele);
};
var $e815fda779bc047b$var$sourceEndpoint = function sourceEndpoint(ele) {
    return ele.renderer().getSourceEndpoint(ele);
};
var $e815fda779bc047b$var$targetEndpoint = function targetEndpoint(ele) {
    return ele.renderer().getTargetEndpoint(ele);
};
var $e815fda779bc047b$var$midpoint = function midpoint(ele) {
    return ele.renderer().getEdgeMidpoint(ele);
};
var $e815fda779bc047b$var$pts = {
    controlPoints: {
        get: $e815fda779bc047b$var$controlPoints,
        mult: true
    },
    segmentPoints: {
        get: $e815fda779bc047b$var$segmentPoints,
        mult: true
    },
    sourceEndpoint: {
        get: $e815fda779bc047b$var$sourceEndpoint
    },
    targetEndpoint: {
        get: $e815fda779bc047b$var$targetEndpoint
    },
    midpoint: {
        get: $e815fda779bc047b$var$midpoint
    }
};
var $e815fda779bc047b$var$renderedName = function renderedName(name) {
    return 'rendered' + name[0].toUpperCase() + name.substr(1);
};
var $e815fda779bc047b$var$edgePoints = Object.keys($e815fda779bc047b$var$pts).reduce(function(obj, name) {
    var spec = $e815fda779bc047b$var$pts[name];
    var rName = $e815fda779bc047b$var$renderedName(name);
    obj[name] = function() {
        return $e815fda779bc047b$var$ifEdge(this, spec.get);
    };
    if (spec.mult) obj[rName] = function() {
        return $e815fda779bc047b$var$ifEdgeRenderedPositions(this, spec.get);
    };
    else obj[rName] = function() {
        return $e815fda779bc047b$var$ifEdgeRenderedPosition(this, spec.get);
    };
    return obj;
}, {});
var $e815fda779bc047b$var$dimensions = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$position, $e815fda779bc047b$var$bounds, $e815fda779bc047b$var$widthHeight, $e815fda779bc047b$var$edgePoints);
/*!
Event object based on jQuery events, MIT license

https://jquery.org/license/
https://tldrlegal.com/license/mit-license
https://github.com/jquery/jquery/blob/master/src/event.js
*/ var $e815fda779bc047b$var$Event = function Event(src, props) {
    this.recycle(src, props);
};
function $e815fda779bc047b$var$returnFalse() {
    return false;
}
function $e815fda779bc047b$var$returnTrue() {
    return true;
}
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
$e815fda779bc047b$var$Event.prototype = {
    instanceString: function instanceString() {
        return 'event';
    },
    recycle: function recycle(src, props) {
        this.isImmediatePropagationStopped = this.isPropagationStopped = this.isDefaultPrevented = $e815fda779bc047b$var$returnFalse;
        if (src != null && src.preventDefault) {
            // Browser Event object
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented ? $e815fda779bc047b$var$returnTrue : $e815fda779bc047b$var$returnFalse;
        } else if (src != null && src.type) // Plain object containing all event details
        props = src;
        else // Event string
        this.type = src;
        // Put explicitly provided properties onto the event object
        if (props != null) {
            // more efficient to manually copy fields we use
            this.originalEvent = props.originalEvent;
            this.type = props.type != null ? props.type : this.type;
            this.cy = props.cy;
            this.target = props.target;
            this.position = props.position;
            this.renderedPosition = props.renderedPosition;
            this.namespace = props.namespace;
            this.layout = props.layout;
        }
        if (this.cy != null && this.position != null && this.renderedPosition == null) {
            // create a rendered position based on the passed position
            var pos = this.position;
            var zoom = this.cy.zoom();
            var pan = this.cy.pan();
            this.renderedPosition = {
                x: pos.x * zoom + pan.x,
                y: pos.y * zoom + pan.y
            };
        }
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
    },
    preventDefault: function preventDefault() {
        this.isDefaultPrevented = $e815fda779bc047b$var$returnTrue;
        var e = this.originalEvent;
        if (!e) return;
        // if preventDefault exists run it on the original event
        if (e.preventDefault) e.preventDefault();
    },
    stopPropagation: function stopPropagation() {
        this.isPropagationStopped = $e815fda779bc047b$var$returnTrue;
        var e = this.originalEvent;
        if (!e) return;
        // if stopPropagation exists run it on the original event
        if (e.stopPropagation) e.stopPropagation();
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
        this.isImmediatePropagationStopped = $e815fda779bc047b$var$returnTrue;
        this.stopPropagation();
    },
    isDefaultPrevented: $e815fda779bc047b$var$returnFalse,
    isPropagationStopped: $e815fda779bc047b$var$returnFalse,
    isImmediatePropagationStopped: $e815fda779bc047b$var$returnFalse
};
var $e815fda779bc047b$var$eventRegex = /^([^.]+)(\.(?:[^.]+))?$/; // regex for matching event strings (e.g. "click.namespace")
var $e815fda779bc047b$var$universalNamespace = '.*'; // matches as if no namespace specified and prevents users from unbinding accidentally
var $e815fda779bc047b$var$defaults$8 = {
    qualifierCompare: function qualifierCompare(q1, q2) {
        return q1 === q2;
    },
    eventMatches: function eventMatches() {
        return true;
    },
    addEventFields: function addEventFields() {},
    callbackContext: function callbackContext(context /*, listener, eventObj*/ ) {
        return context;
    },
    beforeEmit: function beforeEmit() {},
    afterEmit: function afterEmit() {},
    bubble: function bubble() {
        return false;
    },
    parent: function parent() {
        return null;
    },
    context: null
};
var $e815fda779bc047b$var$defaultsKeys = Object.keys($e815fda779bc047b$var$defaults$8);
var $e815fda779bc047b$var$emptyOpts = {};
function $e815fda779bc047b$var$Emitter() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e815fda779bc047b$var$emptyOpts;
    var context = arguments.length > 1 ? arguments[1] : undefined;
    // micro-optimisation vs Object.assign() -- reduces Element instantiation time
    for(var i = 0; i < $e815fda779bc047b$var$defaultsKeys.length; i++){
        var key = $e815fda779bc047b$var$defaultsKeys[i];
        this[key] = opts[key] || $e815fda779bc047b$var$defaults$8[key];
    }
    this.context = context || this.context;
    this.listeners = [];
    this.emitting = 0;
}
var $e815fda779bc047b$var$p = $e815fda779bc047b$var$Emitter.prototype;
var $e815fda779bc047b$var$forEachEvent = function forEachEvent(self1, handler, events, qualifier, callback, conf, confOverrides) {
    if ($e815fda779bc047b$var$fn$6(qualifier)) {
        callback = qualifier;
        qualifier = null;
    }
    if (confOverrides) {
        if (conf == null) conf = confOverrides;
        else conf = $e815fda779bc047b$var$extend({}, conf, confOverrides);
    }
    var eventList = $e815fda779bc047b$var$array(events) ? events : events.split(/\s+/);
    for(var i = 0; i < eventList.length; i++){
        var evt = eventList[i];
        if ($e815fda779bc047b$var$emptyString(evt)) continue;
        var match = evt.match($e815fda779bc047b$var$eventRegex); // type[.namespace]
        if (match) {
            var type = match[1];
            var namespace = match[2] ? match[2] : null;
            var ret = handler(self1, evt, type, namespace, qualifier, callback, conf);
            if (ret === false) break;
             // allow exiting early
        }
    }
};
var $e815fda779bc047b$var$makeEventObj = function makeEventObj(self1, obj) {
    self1.addEventFields(self1.context, obj);
    return new $e815fda779bc047b$var$Event(obj.type, obj);
};
var $e815fda779bc047b$var$forEachEventObj = function forEachEventObj(self1, handler, events) {
    if ($e815fda779bc047b$var$event(events)) {
        handler(self1, events);
        return;
    } else if ($e815fda779bc047b$var$plainObject(events)) {
        handler(self1, $e815fda779bc047b$var$makeEventObj(self1, events));
        return;
    }
    var eventList = $e815fda779bc047b$var$array(events) ? events : events.split(/\s+/);
    for(var i = 0; i < eventList.length; i++){
        var evt = eventList[i];
        if ($e815fda779bc047b$var$emptyString(evt)) continue;
        var match = evt.match($e815fda779bc047b$var$eventRegex); // type[.namespace]
        if (match) {
            var type = match[1];
            var namespace = match[2] ? match[2] : null;
            var eventObj = $e815fda779bc047b$var$makeEventObj(self1, {
                type: type,
                namespace: namespace,
                target: self1.context
            });
            handler(self1, eventObj);
        }
    }
};
$e815fda779bc047b$var$p.on = $e815fda779bc047b$var$p.addListener = function(events, qualifier, callback, conf, confOverrides) {
    $e815fda779bc047b$var$forEachEvent(this, function(self1, event, type, namespace, qualifier, callback, conf) {
        if ($e815fda779bc047b$var$fn$6(callback)) self1.listeners.push({
            event: event,
            // full event string
            callback: callback,
            // callback to run
            type: type,
            // the event type (e.g. 'click')
            namespace: namespace,
            // the event namespace (e.g. ".foo")
            qualifier: qualifier,
            // a restriction on whether to match this emitter
            conf: conf // additional configuration
        });
    }, events, qualifier, callback, conf, confOverrides);
    return this;
};
$e815fda779bc047b$var$p.one = function(events, qualifier, callback, conf) {
    return this.on(events, qualifier, callback, conf, {
        one: true
    });
};
$e815fda779bc047b$var$p.removeListener = $e815fda779bc047b$var$p.off = function(events, qualifier, callback, conf) {
    var _this = this;
    if (this.emitting !== 0) this.listeners = $e815fda779bc047b$var$copyArray$1(this.listeners);
    var listeners = this.listeners;
    var _loop = function _loop(i) {
        var listener = listeners[i];
        $e815fda779bc047b$var$forEachEvent(_this, function(self1, event, type, namespace, qualifier, callback /*, conf*/ ) {
            if ((listener.type === type || events === '*') && (!namespace && listener.namespace !== '.*' || listener.namespace === namespace) && (!qualifier || self1.qualifierCompare(listener.qualifier, qualifier)) && (!callback || listener.callback === callback)) {
                listeners.splice(i, 1);
                return false;
            }
        }, events, qualifier, callback, conf);
    };
    for(var i = listeners.length - 1; i >= 0; i--)_loop(i);
    return this;
};
$e815fda779bc047b$var$p.removeAllListeners = function() {
    return this.removeListener('*');
};
$e815fda779bc047b$var$p.emit = $e815fda779bc047b$var$p.trigger = function(events, extraParams, manualCallback) {
    var listeners = this.listeners;
    var numListenersBeforeEmit = listeners.length;
    this.emitting++;
    if (!$e815fda779bc047b$var$array(extraParams)) extraParams = [
        extraParams
    ];
    $e815fda779bc047b$var$forEachEventObj(this, function(self1, eventObj) {
        if (manualCallback != null) {
            listeners = [
                {
                    event: eventObj.event,
                    type: eventObj.type,
                    namespace: eventObj.namespace,
                    callback: manualCallback
                }
            ];
            numListenersBeforeEmit = listeners.length;
        }
        var _loop2 = function _loop2(i) {
            var listener = listeners[i];
            if (listener.type === eventObj.type && (!listener.namespace || listener.namespace === eventObj.namespace || listener.namespace === $e815fda779bc047b$var$universalNamespace) && self1.eventMatches(self1.context, listener, eventObj)) {
                var args = [
                    eventObj
                ];
                if (extraParams != null) $e815fda779bc047b$var$push(args, extraParams);
                self1.beforeEmit(self1.context, listener, eventObj);
                if (listener.conf && listener.conf.one) self1.listeners = self1.listeners.filter(function(l) {
                    return l !== listener;
                });
                var context = self1.callbackContext(self1.context, listener, eventObj);
                var ret = listener.callback.apply(context, args);
                self1.afterEmit(self1.context, listener, eventObj);
                if (ret === false) {
                    eventObj.stopPropagation();
                    eventObj.preventDefault();
                }
            } // if listener matches
        };
        for(var i = 0; i < numListenersBeforeEmit; i++)_loop2(i);
         // for listener
        if (self1.bubble(self1.context) && !eventObj.isPropagationStopped()) self1.parent(self1.context).emit(eventObj, extraParams);
    }, events);
    this.emitting--;
    return this;
};
var $e815fda779bc047b$var$emitterOptions$1 = {
    qualifierCompare: function qualifierCompare(selector1, selector2) {
        if (selector1 == null || selector2 == null) return selector1 == null && selector2 == null;
        else return selector1.sameText(selector2);
    },
    eventMatches: function eventMatches(ele, listener, eventObj) {
        var selector = listener.qualifier;
        if (selector != null) return ele !== eventObj.target && $e815fda779bc047b$var$element(eventObj.target) && selector.matches(eventObj.target);
        return true;
    },
    addEventFields: function addEventFields(ele, evt) {
        evt.cy = ele.cy();
        evt.target = ele;
    },
    callbackContext: function callbackContext(ele, listener, eventObj) {
        return listener.qualifier != null ? eventObj.target : ele;
    },
    beforeEmit: function beforeEmit(context, listener /*, eventObj*/ ) {
        if (listener.conf && listener.conf.once) listener.conf.onceCollection.removeListener(listener.event, listener.qualifier, listener.callback);
    },
    bubble: function bubble() {
        return true;
    },
    parent: function parent(ele) {
        return ele.isChild() ? ele.parent() : ele.cy();
    }
};
var $e815fda779bc047b$var$argSelector$1 = function argSelector(arg) {
    if ($e815fda779bc047b$var$string(arg)) return new $e815fda779bc047b$var$Selector(arg);
    else return arg;
};
var $e815fda779bc047b$var$elesfn$9 = {
    createEmitter: function createEmitter() {
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var _p = ele._private;
            if (!_p.emitter) _p.emitter = new $e815fda779bc047b$var$Emitter($e815fda779bc047b$var$emitterOptions$1, ele);
        }
        return this;
    },
    emitter: function emitter() {
        return this._private.emitter;
    },
    on: function on(events, selector, callback) {
        var argSel = $e815fda779bc047b$var$argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().on(events, argSel, callback);
        }
        return this;
    },
    removeListener: function removeListener(events, selector, callback) {
        var argSel = $e815fda779bc047b$var$argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().removeListener(events, argSel, callback);
        }
        return this;
    },
    removeAllListeners: function removeAllListeners() {
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().removeAllListeners();
        }
        return this;
    },
    one: function one(events, selector, callback) {
        var argSel = $e815fda779bc047b$var$argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().one(events, argSel, callback);
        }
        return this;
    },
    once: function once(events, selector, callback) {
        var argSel = $e815fda779bc047b$var$argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().on(events, argSel, callback, {
                once: true,
                onceCollection: this
            });
        }
    },
    emit: function emit(events, extraParams) {
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().emit(events, extraParams);
        }
        return this;
    },
    emitAndNotify: function emitAndNotify(event, extraParams) {
        // for internal use only
        if (this.length === 0) return;
         // empty collections don't need to notify anything
        // notify renderer
        this.cy().notify(event, this);
        this.emit(event, extraParams);
        return this;
    }
};
$e815fda779bc047b$var$define.eventAliasesOn($e815fda779bc047b$var$elesfn$9);
var $e815fda779bc047b$var$elesfn$8 = {
    nodes: function nodes(selector) {
        return this.filter(function(ele) {
            return ele.isNode();
        }).filter(selector);
    },
    edges: function edges(selector) {
        return this.filter(function(ele) {
            return ele.isEdge();
        }).filter(selector);
    },
    // internal helper to get nodes and edges as separate collections with single iteration over elements
    byGroup: function byGroup() {
        var nodes = this.spawn();
        var edges = this.spawn();
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            if (ele.isNode()) nodes.push(ele);
            else edges.push(ele);
        }
        return {
            nodes: nodes,
            edges: edges
        };
    },
    filter: function filter(_filter, thisArg) {
        if (_filter === undefined) // check this first b/c it's the most common/performant case
        return this;
        else if ($e815fda779bc047b$var$string(_filter) || $e815fda779bc047b$var$elementOrCollection(_filter)) return new $e815fda779bc047b$var$Selector(_filter).filter(this);
        else if ($e815fda779bc047b$var$fn$6(_filter)) {
            var filterEles = this.spawn();
            var eles = this;
            for(var i = 0; i < eles.length; i++){
                var ele = eles[i];
                var include = thisArg ? _filter.apply(thisArg, [
                    ele,
                    i,
                    eles
                ]) : _filter(ele, i, eles);
                if (include) filterEles.push(ele);
            }
            return filterEles;
        }
        return this.spawn(); // if not handled by above, give 'em an empty collection
    },
    not: function not(toRemove) {
        if (!toRemove) return this;
        else {
            if ($e815fda779bc047b$var$string(toRemove)) toRemove = this.filter(toRemove);
            var elements = this.spawn();
            for(var i = 0; i < this.length; i++){
                var element = this[i];
                var remove = toRemove.has(element);
                if (!remove) elements.push(element);
            }
            return elements;
        }
    },
    absoluteComplement: function absoluteComplement() {
        var cy = this.cy();
        return cy.mutableElements().not(this);
    },
    intersect: function intersect(other) {
        // if a selector is specified, then filter by it instead
        if ($e815fda779bc047b$var$string(other)) {
            var selector = other;
            return this.filter(selector);
        }
        var elements = this.spawn();
        var col1 = this;
        var col2 = other;
        var col1Smaller = this.length < other.length;
        var colS = col1Smaller ? col1 : col2;
        var colL = col1Smaller ? col2 : col1;
        for(var i = 0; i < colS.length; i++){
            var ele = colS[i];
            if (colL.has(ele)) elements.push(ele);
        }
        return elements;
    },
    xor: function xor(other) {
        var cy = this._private.cy;
        if ($e815fda779bc047b$var$string(other)) other = cy.$(other);
        var elements = this.spawn();
        var col1 = this;
        var col2 = other;
        var add = function add(col, other) {
            for(var i = 0; i < col.length; i++){
                var ele = col[i];
                var id = ele._private.data.id;
                var inOther = other.hasElementWithId(id);
                if (!inOther) elements.push(ele);
            }
        };
        add(col1, col2);
        add(col2, col1);
        return elements;
    },
    diff: function diff(other) {
        var cy = this._private.cy;
        if ($e815fda779bc047b$var$string(other)) other = cy.$(other);
        var left = this.spawn();
        var right = this.spawn();
        var both = this.spawn();
        var col1 = this;
        var col2 = other;
        var add = function add(col, other, retEles) {
            for(var i = 0; i < col.length; i++){
                var ele = col[i];
                var id = ele._private.data.id;
                var inOther = other.hasElementWithId(id);
                if (inOther) both.merge(ele);
                else retEles.push(ele);
            }
        };
        add(col1, col2, left);
        add(col2, col1, right);
        return {
            left: left,
            right: right,
            both: both
        };
    },
    add: function add(toAdd) {
        var cy = this._private.cy;
        if (!toAdd) return this;
        if ($e815fda779bc047b$var$string(toAdd)) {
            var selector = toAdd;
            toAdd = cy.mutableElements().filter(selector);
        }
        var elements = this.spawnSelf();
        for(var i = 0; i < toAdd.length; i++){
            var ele = toAdd[i];
            var add = !this.has(ele);
            if (add) elements.push(ele);
        }
        return elements;
    },
    // in place merge on calling collection
    merge: function merge(toAdd) {
        var _p = this._private;
        var cy = _p.cy;
        if (!toAdd) return this;
        if (toAdd && $e815fda779bc047b$var$string(toAdd)) {
            var selector = toAdd;
            toAdd = cy.mutableElements().filter(selector);
        }
        var map = _p.map;
        for(var i = 0; i < toAdd.length; i++){
            var toAddEle = toAdd[i];
            var id = toAddEle._private.data.id;
            var add = !map.has(id);
            if (add) {
                var index = this.length++;
                this[index] = toAddEle;
                map.set(id, {
                    ele: toAddEle,
                    index: index
                });
            }
        }
        return this; // chaining
    },
    unmergeAt: function unmergeAt(i) {
        var ele = this[i];
        var id = ele.id();
        var _p = this._private;
        var map = _p.map;
        // remove ele
        this[i] = undefined;
        map["delete"](id);
        var unmergedLastEle = i === this.length - 1;
        // replace empty spot with last ele in collection
        if (this.length > 1 && !unmergedLastEle) {
            var lastEleI = this.length - 1;
            var lastEle = this[lastEleI];
            var lastEleId = lastEle._private.data.id;
            this[lastEleI] = undefined;
            this[i] = lastEle;
            map.set(lastEleId, {
                ele: lastEle,
                index: i
            });
        }
        // the collection is now 1 ele smaller
        this.length--;
        return this;
    },
    // remove single ele in place in calling collection
    unmergeOne: function unmergeOne(ele) {
        ele = ele[0];
        var _p = this._private;
        var id = ele._private.data.id;
        var map = _p.map;
        var entry = map.get(id);
        if (!entry) return this; // no need to remove
        var i = entry.index;
        this.unmergeAt(i);
        return this;
    },
    // remove eles in place on calling collection
    unmerge: function unmerge(toRemove) {
        var cy = this._private.cy;
        if (!toRemove) return this;
        if (toRemove && $e815fda779bc047b$var$string(toRemove)) {
            var selector = toRemove;
            toRemove = cy.mutableElements().filter(selector);
        }
        for(var i = 0; i < toRemove.length; i++)this.unmergeOne(toRemove[i]);
        return this; // chaining
    },
    unmergeBy: function unmergeBy(toRmFn) {
        for(var i = this.length - 1; i >= 0; i--){
            var ele = this[i];
            if (toRmFn(ele)) this.unmergeAt(i);
        }
        return this;
    },
    map: function map(mapFn, thisArg) {
        var arr = [];
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var ret = thisArg ? mapFn.apply(thisArg, [
                ele,
                i,
                eles
            ]) : mapFn(ele, i, eles);
            arr.push(ret);
        }
        return arr;
    },
    reduce: function reduce(fn, initialValue) {
        var val = initialValue;
        var eles = this;
        for(var i = 0; i < eles.length; i++)val = fn(val, eles[i], i, eles);
        return val;
    },
    max: function max(valFn, thisArg) {
        var max = -Infinity;
        var maxEle;
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var val = thisArg ? valFn.apply(thisArg, [
                ele,
                i,
                eles
            ]) : valFn(ele, i, eles);
            if (val > max) {
                max = val;
                maxEle = ele;
            }
        }
        return {
            value: max,
            ele: maxEle
        };
    },
    min: function min(valFn, thisArg) {
        var min = Infinity;
        var minEle;
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var val = thisArg ? valFn.apply(thisArg, [
                ele,
                i,
                eles
            ]) : valFn(ele, i, eles);
            if (val < min) {
                min = val;
                minEle = ele;
            }
        }
        return {
            value: min,
            ele: minEle
        };
    }
};
// aliases
var $e815fda779bc047b$var$fn$1 = $e815fda779bc047b$var$elesfn$8;
$e815fda779bc047b$var$fn$1['u'] = $e815fda779bc047b$var$fn$1['|'] = $e815fda779bc047b$var$fn$1['+'] = $e815fda779bc047b$var$fn$1.union = $e815fda779bc047b$var$fn$1.or = $e815fda779bc047b$var$fn$1.add;
$e815fda779bc047b$var$fn$1['\\'] = $e815fda779bc047b$var$fn$1['!'] = $e815fda779bc047b$var$fn$1['-'] = $e815fda779bc047b$var$fn$1.difference = $e815fda779bc047b$var$fn$1.relativeComplement = $e815fda779bc047b$var$fn$1.subtract = $e815fda779bc047b$var$fn$1.not;
$e815fda779bc047b$var$fn$1['n'] = $e815fda779bc047b$var$fn$1['&'] = $e815fda779bc047b$var$fn$1['.'] = $e815fda779bc047b$var$fn$1.and = $e815fda779bc047b$var$fn$1.intersection = $e815fda779bc047b$var$fn$1.intersect;
$e815fda779bc047b$var$fn$1['^'] = $e815fda779bc047b$var$fn$1['(+)'] = $e815fda779bc047b$var$fn$1['(-)'] = $e815fda779bc047b$var$fn$1.symmetricDifference = $e815fda779bc047b$var$fn$1.symdiff = $e815fda779bc047b$var$fn$1.xor;
$e815fda779bc047b$var$fn$1.fnFilter = $e815fda779bc047b$var$fn$1.filterFn = $e815fda779bc047b$var$fn$1.stdFilter = $e815fda779bc047b$var$fn$1.filter;
$e815fda779bc047b$var$fn$1.complement = $e815fda779bc047b$var$fn$1.abscomp = $e815fda779bc047b$var$fn$1.absoluteComplement;
var $e815fda779bc047b$var$elesfn$7 = {
    isNode: function isNode() {
        return this.group() === 'nodes';
    },
    isEdge: function isEdge() {
        return this.group() === 'edges';
    },
    isLoop: function isLoop() {
        return this.isEdge() && this.source()[0] === this.target()[0];
    },
    isSimple: function isSimple() {
        return this.isEdge() && this.source()[0] !== this.target()[0];
    },
    group: function group() {
        var ele = this[0];
        if (ele) return ele._private.group;
    }
};
/**
 *  Elements are drawn in a specific order based on compound depth (low to high), the element type (nodes above edges),
 *  and z-index (low to high).  These styles affect how this applies:
 *
 *  z-compound-depth: May be `bottom | orphan | auto | top`.  The first drawn is `bottom`, then `orphan` which is the
 *      same depth as the root of the compound graph, followed by the default value `auto` which draws in order from
 *      root to leaves of the compound graph.  The last drawn is `top`.
 *  z-index-compare: May be `auto | manual`.  The default value is `auto` which always draws edges under nodes.
 *      `manual` ignores this convention and draws based on the `z-index` value setting.
 *  z-index: An integer value that affects the relative draw order of elements.  In general, an element with a higher
 *      `z-index` will be drawn on top of an element with a lower `z-index`.
 */ var $e815fda779bc047b$var$zIndexSort = function zIndexSort(a, b) {
    var cy = a.cy();
    var hasCompoundNodes = cy.hasCompoundNodes();
    function getDepth(ele) {
        var style = ele.pstyle('z-compound-depth');
        if (style.value === 'auto') return hasCompoundNodes ? ele.zDepth() : 0;
        else if (style.value === 'bottom') return -1;
        else if (style.value === 'top') return $e815fda779bc047b$var$MAX_INT$1;
        // 'orphan'
        return 0;
    }
    var depthDiff = getDepth(a) - getDepth(b);
    if (depthDiff !== 0) return depthDiff;
    function getEleDepth(ele) {
        var style = ele.pstyle('z-index-compare');
        if (style.value === 'auto') return ele.isNode() ? 1 : 0;
        // 'manual'
        return 0;
    }
    var eleDiff = getEleDepth(a) - getEleDepth(b);
    if (eleDiff !== 0) return eleDiff;
    var zDiff = a.pstyle('z-index').value - b.pstyle('z-index').value;
    if (zDiff !== 0) return zDiff;
    // compare indices in the core (order added to graph w/ last on top)
    return a.poolIndex() - b.poolIndex();
};
var $e815fda779bc047b$var$elesfn$6 = {
    forEach: function forEach(fn, thisArg) {
        if ($e815fda779bc047b$var$fn$6(fn)) {
            var N = this.length;
            for(var i = 0; i < N; i++){
                var ele = this[i];
                var ret = thisArg ? fn.apply(thisArg, [
                    ele,
                    i,
                    this
                ]) : fn(ele, i, this);
                if (ret === false) break;
                 // exit each early on return false
            }
        }
        return this;
    },
    toArray: function toArray() {
        var array = [];
        for(var i = 0; i < this.length; i++)array.push(this[i]);
        return array;
    },
    slice: function slice(start, end) {
        var array = [];
        var thisSize = this.length;
        if (end == null) end = thisSize;
        if (start == null) start = 0;
        if (start < 0) start = thisSize + start;
        if (end < 0) end = thisSize + end;
        for(var i = start; i >= 0 && i < end && i < thisSize; i++)array.push(this[i]);
        return this.spawn(array);
    },
    size: function size() {
        return this.length;
    },
    eq: function eq(i) {
        return this[i] || this.spawn();
    },
    first: function first() {
        return this[0] || this.spawn();
    },
    last: function last() {
        return this[this.length - 1] || this.spawn();
    },
    empty: function empty() {
        return this.length === 0;
    },
    nonempty: function nonempty() {
        return !this.empty();
    },
    sort: function sort(sortFn) {
        if (!$e815fda779bc047b$var$fn$6(sortFn)) return this;
        var sorted = this.toArray().sort(sortFn);
        return this.spawn(sorted);
    },
    sortByZIndex: function sortByZIndex() {
        return this.sort($e815fda779bc047b$var$zIndexSort);
    },
    zDepth: function zDepth() {
        var ele = this[0];
        if (!ele) return undefined;
        // let cy = ele.cy();
        var _p = ele._private;
        var group = _p.group;
        if (group === 'nodes') {
            var depth = _p.data.parent ? ele.parents().size() : 0;
            if (!ele.isParent()) return $e815fda779bc047b$var$MAX_INT$1 - 1; // childless nodes always on top
            return depth;
        } else {
            var src = _p.source;
            var tgt = _p.target;
            var srcDepth = src.zDepth();
            var tgtDepth = tgt.zDepth();
            return Math.max(srcDepth, tgtDepth, 0); // depth of deepest parent
        }
    }
};
$e815fda779bc047b$var$elesfn$6.each = $e815fda779bc047b$var$elesfn$6.forEach;
var $e815fda779bc047b$var$defineSymbolIterator = function defineSymbolIterator() {
    var typeofUndef = "undefined";
    var isIteratorSupported = (typeof Symbol === "undefined" ? "undefined" : $e815fda779bc047b$var$_typeof(Symbol)) != typeofUndef && $e815fda779bc047b$var$_typeof(Symbol.iterator) != typeofUndef; // eslint-disable-line no-undef
    if (isIteratorSupported) $e815fda779bc047b$var$elesfn$6[Symbol.iterator] = function() {
        var _this = this;
        // eslint-disable-line no-undef
        var entry = {
            value: undefined,
            done: false
        };
        var i = 0;
        var length = this.length;
        return $e815fda779bc047b$var$_defineProperty$1({
            next: function next() {
                if (i < length) entry.value = _this[i++];
                else {
                    entry.value = undefined;
                    entry.done = true;
                }
                return entry;
            }
        }, Symbol.iterator, function() {
            // eslint-disable-line no-undef
            return this;
        });
    };
};
$e815fda779bc047b$var$defineSymbolIterator();
var $e815fda779bc047b$var$getLayoutDimensionOptions = $e815fda779bc047b$var$defaults$g({
    nodeDimensionsIncludeLabels: false
});
var $e815fda779bc047b$var$elesfn$5 = {
    // Calculates and returns node dimensions { x, y } based on options given
    layoutDimensions: function layoutDimensions(options) {
        options = $e815fda779bc047b$var$getLayoutDimensionOptions(options);
        var dims;
        if (!this.takesUpSpace()) dims = {
            w: 0,
            h: 0
        };
        else if (options.nodeDimensionsIncludeLabels) {
            var bbDim = this.boundingBox();
            dims = {
                w: bbDim.w,
                h: bbDim.h
            };
        } else dims = {
            w: this.outerWidth(),
            h: this.outerHeight()
        };
        // sanitise the dimensions for external layouts (avoid division by zero)
        if (dims.w === 0 || dims.h === 0) dims.w = dims.h = 1;
        return dims;
    },
    // using standard layout options, apply position function (w/ or w/o animation)
    layoutPositions: function layoutPositions(layout, options, fn) {
        var nodes = this.nodes().filter(function(n) {
            return !n.isParent();
        });
        var cy = this.cy();
        var layoutEles = options.eles; // nodes & edges
        var getMemoizeKey = function getMemoizeKey(node) {
            return node.id();
        };
        var fnMem = $e815fda779bc047b$var$memoize$1(fn, getMemoizeKey); // memoized version of position function
        layout.emit({
            type: 'layoutstart',
            layout: layout
        });
        layout.animations = [];
        var calculateSpacing = function calculateSpacing(spacing, nodesBb, pos) {
            var center = {
                x: nodesBb.x1 + nodesBb.w / 2,
                y: nodesBb.y1 + nodesBb.h / 2
            };
            var spacingVector = {
                // scale from center of bounding box (not necessarily 0,0)
                x: (pos.x - center.x) * spacing,
                y: (pos.y - center.y) * spacing
            };
            return {
                x: center.x + spacingVector.x,
                y: center.y + spacingVector.y
            };
        };
        var useSpacingFactor = options.spacingFactor && options.spacingFactor !== 1;
        var spacingBb = function spacingBb() {
            if (!useSpacingFactor) return null;
            var bb = $e815fda779bc047b$var$makeBoundingBox();
            for(var i = 0; i < nodes.length; i++){
                var node = nodes[i];
                var pos = fnMem(node, i);
                $e815fda779bc047b$var$expandBoundingBoxByPoint(bb, pos.x, pos.y);
            }
            return bb;
        };
        var bb = spacingBb();
        var getFinalPos = $e815fda779bc047b$var$memoize$1(function(node, i) {
            var newPos = fnMem(node, i);
            if (useSpacingFactor) {
                var spacing = Math.abs(options.spacingFactor);
                newPos = calculateSpacing(spacing, bb, newPos);
            }
            if (options.transform != null) newPos = options.transform(node, newPos);
            return newPos;
        }, getMemoizeKey);
        if (options.animate) {
            for(var i = 0; i < nodes.length; i++){
                var node = nodes[i];
                var newPos = getFinalPos(node, i);
                var animateNode = options.animateFilter == null || options.animateFilter(node, i);
                if (animateNode) {
                    var ani = node.animation({
                        position: newPos,
                        duration: options.animationDuration,
                        easing: options.animationEasing
                    });
                    layout.animations.push(ani);
                } else node.position(newPos);
            }
            if (options.fit) {
                var fitAni = cy.animation({
                    fit: {
                        boundingBox: layoutEles.boundingBoxAt(getFinalPos),
                        padding: options.padding
                    },
                    duration: options.animationDuration,
                    easing: options.animationEasing
                });
                layout.animations.push(fitAni);
            } else if (options.zoom !== undefined && options.pan !== undefined) {
                var zoomPanAni = cy.animation({
                    zoom: options.zoom,
                    pan: options.pan,
                    duration: options.animationDuration,
                    easing: options.animationEasing
                });
                layout.animations.push(zoomPanAni);
            }
            layout.animations.forEach(function(ani) {
                return ani.play();
            });
            layout.one('layoutready', options.ready);
            layout.emit({
                type: 'layoutready',
                layout: layout
            });
            $e815fda779bc047b$var$Promise$1.all(layout.animations.map(function(ani) {
                return ani.promise();
            })).then(function() {
                layout.one('layoutstop', options.stop);
                layout.emit({
                    type: 'layoutstop',
                    layout: layout
                });
            });
        } else {
            nodes.positions(getFinalPos);
            if (options.fit) cy.fit(options.eles, options.padding);
            if (options.zoom != null) cy.zoom(options.zoom);
            if (options.pan) cy.pan(options.pan);
            layout.one('layoutready', options.ready);
            layout.emit({
                type: 'layoutready',
                layout: layout
            });
            layout.one('layoutstop', options.stop);
            layout.emit({
                type: 'layoutstop',
                layout: layout
            });
        }
        return this; // chaining
    },
    layout: function layout(options) {
        var cy = this.cy();
        return cy.makeLayout($e815fda779bc047b$var$extend({}, options, {
            eles: this
        }));
    }
};
// aliases:
$e815fda779bc047b$var$elesfn$5.createLayout = $e815fda779bc047b$var$elesfn$5.makeLayout = $e815fda779bc047b$var$elesfn$5.layout;
function $e815fda779bc047b$var$styleCache(key, fn, ele) {
    var _p = ele._private;
    var cache = _p.styleCache = _p.styleCache || [];
    var val;
    if ((val = cache[key]) != null) return val;
    else {
        val = cache[key] = fn(ele);
        return val;
    }
}
function $e815fda779bc047b$var$cacheStyleFunction(key, fn) {
    key = $e815fda779bc047b$var$hashString(key);
    return function cachedStyleFunction(ele) {
        return $e815fda779bc047b$var$styleCache(key, fn, ele);
    };
}
function $e815fda779bc047b$var$cachePrototypeStyleFunction(key, fn) {
    key = $e815fda779bc047b$var$hashString(key);
    var selfFn = function selfFn(ele) {
        return fn.call(ele);
    };
    return function cachedPrototypeStyleFunction() {
        var ele = this[0];
        if (ele) return $e815fda779bc047b$var$styleCache(key, selfFn, ele);
    };
}
var $e815fda779bc047b$var$elesfn$4 = {
    recalculateRenderedStyle: function recalculateRenderedStyle(useCache) {
        var cy = this.cy();
        var renderer = cy.renderer();
        var styleEnabled = cy.styleEnabled();
        if (renderer && styleEnabled) renderer.recalculateRenderedStyle(this, useCache);
        return this;
    },
    dirtyStyleCache: function dirtyStyleCache() {
        var cy = this.cy();
        var dirty = function dirty(ele) {
            return ele._private.styleCache = null;
        };
        if (cy.hasCompoundNodes()) {
            var eles;
            eles = this.spawnSelf().merge(this.descendants()).merge(this.parents());
            eles.merge(eles.connectedEdges());
            eles.forEach(dirty);
        } else this.forEach(function(ele) {
            dirty(ele);
            ele.connectedEdges().forEach(dirty);
        });
        return this;
    },
    // fully updates (recalculates) the style for the elements
    updateStyle: function updateStyle(notifyRenderer) {
        var cy = this._private.cy;
        if (!cy.styleEnabled()) return this;
        if (cy.batching()) {
            var bEles = cy._private.batchStyleEles;
            bEles.merge(this);
            return this; // chaining and exit early when batching
        }
        var hasCompounds = cy.hasCompoundNodes();
        var updatedEles = this;
        notifyRenderer = notifyRenderer || notifyRenderer === undefined ? true : false;
        if (hasCompounds) // then add everything up and down for compound selector checks
        updatedEles = this.spawnSelf().merge(this.descendants()).merge(this.parents());
        // let changedEles = style.apply( updatedEles );
        var changedEles = updatedEles;
        if (notifyRenderer) changedEles.emitAndNotify('style'); // let renderer know we changed style
        else changedEles.emit('style'); // just fire the event
        updatedEles.forEach(function(ele) {
            return ele._private.styleDirty = true;
        });
        return this; // chaining
    },
    // private: clears dirty flag and recalculates style
    cleanStyle: function cleanStyle() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return;
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            if (ele._private.styleDirty) {
                // n.b. this flag should be set before apply() to avoid potential infinite recursion
                ele._private.styleDirty = false;
                cy.style().apply(ele);
            }
        }
    },
    // get the internal parsed style object for the specified property
    parsedStyle: function parsedStyle(property) {
        var includeNonDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var ele = this[0];
        var cy = ele.cy();
        if (!cy.styleEnabled()) return;
        if (ele) {
            this.cleanStyle();
            var overriddenStyle = ele._private.style[property];
            if (overriddenStyle != null) return overriddenStyle;
            else if (includeNonDefault) return cy.style().getDefaultProperty(property);
            else return null;
        }
    },
    numericStyle: function numericStyle(property) {
        var ele = this[0];
        if (!ele.cy().styleEnabled()) return;
        if (ele) {
            var pstyle = ele.pstyle(property);
            return pstyle.pfValue !== undefined ? pstyle.pfValue : pstyle.value;
        }
    },
    numericStyleUnits: function numericStyleUnits(property) {
        var ele = this[0];
        if (!ele.cy().styleEnabled()) return;
        if (ele) return ele.pstyle(property).units;
    },
    // get the specified css property as a rendered value (i.e. on-screen value)
    // or get the whole rendered style if no property specified (NB doesn't allow setting)
    renderedStyle: function renderedStyle(property) {
        var cy = this.cy();
        if (!cy.styleEnabled()) return this;
        var ele = this[0];
        if (ele) return cy.style().getRenderedStyle(ele, property);
    },
    // read the calculated css style of the element or override the style (via a bypass)
    style: function style(name, value) {
        var cy = this.cy();
        if (!cy.styleEnabled()) return this;
        var updateTransitions = false;
        var style = cy.style();
        if ($e815fda779bc047b$var$plainObject(name)) {
            // then extend the bypass
            var props = name;
            style.applyBypass(this, props, updateTransitions);
            this.emitAndNotify('style'); // let the renderer know we've updated style
        } else if ($e815fda779bc047b$var$string(name)) {
            if (value === undefined) {
                // then get the property from the style
                var ele = this[0];
                if (ele) return style.getStylePropertyValue(ele, name);
                else // empty collection => can't get any value
                return;
            } else {
                // then set the bypass with the property value
                style.applyBypass(this, name, value, updateTransitions);
                this.emitAndNotify('style'); // let the renderer know we've updated style
            }
        } else if (name === undefined) {
            var _ele = this[0];
            if (_ele) return style.getRawStyle(_ele);
            else // empty collection => can't get any value
            return;
        }
        return this; // chaining
    },
    removeStyle: function removeStyle(names) {
        var cy = this.cy();
        if (!cy.styleEnabled()) return this;
        var updateTransitions = false;
        var style = cy.style();
        var eles = this;
        if (names === undefined) for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            style.removeAllBypasses(ele, updateTransitions);
        }
        else {
            names = names.split(/\s+/);
            for(var _i = 0; _i < eles.length; _i++){
                var _ele2 = eles[_i];
                style.removeBypasses(_ele2, names, updateTransitions);
            }
        }
        this.emitAndNotify('style'); // let the renderer know we've updated style
        return this; // chaining
    },
    show: function show() {
        this.css('display', 'element');
        return this; // chaining
    },
    hide: function hide() {
        this.css('display', 'none');
        return this; // chaining
    },
    effectiveOpacity: function effectiveOpacity() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return 1;
        var hasCompoundNodes = cy.hasCompoundNodes();
        var ele = this[0];
        if (ele) {
            var _p = ele._private;
            var parentOpacity = ele.pstyle('opacity').value;
            if (!hasCompoundNodes) return parentOpacity;
            var parents = !_p.data.parent ? null : ele.parents();
            if (parents) for(var i = 0; i < parents.length; i++){
                var parent = parents[i];
                var opacity = parent.pstyle('opacity').value;
                parentOpacity = opacity * parentOpacity;
            }
            return parentOpacity;
        }
    },
    transparent: function transparent() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return false;
        var ele = this[0];
        var hasCompoundNodes = ele.cy().hasCompoundNodes();
        if (ele) {
            if (!hasCompoundNodes) return ele.pstyle('opacity').value === 0;
            else return ele.effectiveOpacity() === 0;
        }
    },
    backgrounding: function backgrounding() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return false;
        var ele = this[0];
        return ele._private.backgrounding ? true : false;
    }
};
function $e815fda779bc047b$var$checkCompound(ele, parentOk) {
    var _p = ele._private;
    var parents = _p.data.parent ? ele.parents() : null;
    if (parents) for(var i = 0; i < parents.length; i++){
        var parent = parents[i];
        if (!parentOk(parent)) return false;
    }
    return true;
}
function $e815fda779bc047b$var$defineDerivedStateFunction(specs) {
    var ok = specs.ok;
    var edgeOkViaNode = specs.edgeOkViaNode || specs.ok;
    var parentOk = specs.parentOk || specs.ok;
    return function() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return true;
        var ele = this[0];
        var hasCompoundNodes = cy.hasCompoundNodes();
        if (ele) {
            var _p = ele._private;
            if (!ok(ele)) return false;
            if (ele.isNode()) return !hasCompoundNodes || $e815fda779bc047b$var$checkCompound(ele, parentOk);
            else {
                var src = _p.source;
                var tgt = _p.target;
                return edgeOkViaNode(src) && (!hasCompoundNodes || $e815fda779bc047b$var$checkCompound(src, edgeOkViaNode)) && (src === tgt || edgeOkViaNode(tgt) && (!hasCompoundNodes || $e815fda779bc047b$var$checkCompound(tgt, edgeOkViaNode)));
            }
        }
    };
}
var $e815fda779bc047b$var$eleTakesUpSpace = $e815fda779bc047b$var$cacheStyleFunction('eleTakesUpSpace', function(ele) {
    return ele.pstyle('display').value === 'element' && ele.width() !== 0 && (ele.isNode() ? ele.height() !== 0 : true);
});
$e815fda779bc047b$var$elesfn$4.takesUpSpace = $e815fda779bc047b$var$cachePrototypeStyleFunction('takesUpSpace', $e815fda779bc047b$var$defineDerivedStateFunction({
    ok: $e815fda779bc047b$var$eleTakesUpSpace
}));
var $e815fda779bc047b$var$eleInteractive = $e815fda779bc047b$var$cacheStyleFunction('eleInteractive', function(ele) {
    return ele.pstyle('events').value === 'yes' && ele.pstyle('visibility').value === 'visible' && $e815fda779bc047b$var$eleTakesUpSpace(ele);
});
var $e815fda779bc047b$var$parentInteractive = $e815fda779bc047b$var$cacheStyleFunction('parentInteractive', function(parent) {
    return parent.pstyle('visibility').value === 'visible' && $e815fda779bc047b$var$eleTakesUpSpace(parent);
});
$e815fda779bc047b$var$elesfn$4.interactive = $e815fda779bc047b$var$cachePrototypeStyleFunction('interactive', $e815fda779bc047b$var$defineDerivedStateFunction({
    ok: $e815fda779bc047b$var$eleInteractive,
    parentOk: $e815fda779bc047b$var$parentInteractive,
    edgeOkViaNode: $e815fda779bc047b$var$eleTakesUpSpace
}));
$e815fda779bc047b$var$elesfn$4.noninteractive = function() {
    var ele = this[0];
    if (ele) return !ele.interactive();
};
var $e815fda779bc047b$var$eleVisible = $e815fda779bc047b$var$cacheStyleFunction('eleVisible', function(ele) {
    return ele.pstyle('visibility').value === 'visible' && ele.pstyle('opacity').pfValue !== 0 && $e815fda779bc047b$var$eleTakesUpSpace(ele);
});
var $e815fda779bc047b$var$edgeVisibleViaNode = $e815fda779bc047b$var$eleTakesUpSpace;
$e815fda779bc047b$var$elesfn$4.visible = $e815fda779bc047b$var$cachePrototypeStyleFunction('visible', $e815fda779bc047b$var$defineDerivedStateFunction({
    ok: $e815fda779bc047b$var$eleVisible,
    edgeOkViaNode: $e815fda779bc047b$var$edgeVisibleViaNode
}));
$e815fda779bc047b$var$elesfn$4.hidden = function() {
    var ele = this[0];
    if (ele) return !ele.visible();
};
$e815fda779bc047b$var$elesfn$4.isBundledBezier = $e815fda779bc047b$var$cachePrototypeStyleFunction('isBundledBezier', function() {
    if (!this.cy().styleEnabled()) return false;
    return !this.removed() && this.pstyle('curve-style').value === 'bezier' && this.takesUpSpace();
});
$e815fda779bc047b$var$elesfn$4.bypass = $e815fda779bc047b$var$elesfn$4.css = $e815fda779bc047b$var$elesfn$4.style;
$e815fda779bc047b$var$elesfn$4.renderedCss = $e815fda779bc047b$var$elesfn$4.renderedStyle;
$e815fda779bc047b$var$elesfn$4.removeBypass = $e815fda779bc047b$var$elesfn$4.removeCss = $e815fda779bc047b$var$elesfn$4.removeStyle;
$e815fda779bc047b$var$elesfn$4.pstyle = $e815fda779bc047b$var$elesfn$4.parsedStyle;
var $e815fda779bc047b$var$elesfn$3 = {};
function $e815fda779bc047b$var$defineSwitchFunction(params) {
    return function() {
        var args = arguments;
        var changedEles = [];
        // e.g. cy.nodes().select( data, handler )
        if (args.length === 2) {
            var data = args[0];
            var handler = args[1];
            this.on(params.event, data, handler);
        } else if (args.length === 1 && $e815fda779bc047b$var$fn$6(args[0])) {
            var _handler = args[0];
            this.on(params.event, _handler);
        } else if (args.length === 0 || args.length === 1 && $e815fda779bc047b$var$array(args[0])) {
            var addlEvents = args.length === 1 ? args[0] : null;
            for(var i = 0; i < this.length; i++){
                var ele = this[i];
                var able = !params.ableField || ele._private[params.ableField];
                var changed = ele._private[params.field] != params.value;
                if (params.overrideAble) {
                    var overrideAble = params.overrideAble(ele);
                    if (overrideAble !== undefined) {
                        able = overrideAble;
                        if (!overrideAble) return this;
                         // to save cycles assume not able for all on override
                    }
                }
                if (able) {
                    ele._private[params.field] = params.value;
                    if (changed) changedEles.push(ele);
                }
            }
            var changedColl = this.spawn(changedEles);
            changedColl.updateStyle(); // change of state => possible change of style
            changedColl.emit(params.event);
            if (addlEvents) changedColl.emit(addlEvents);
        }
        return this;
    };
}
function $e815fda779bc047b$var$defineSwitchSet(params) {
    $e815fda779bc047b$var$elesfn$3[params.field] = function() {
        var ele = this[0];
        if (ele) {
            if (params.overrideField) {
                var val = params.overrideField(ele);
                if (val !== undefined) return val;
            }
            return ele._private[params.field];
        }
    };
    $e815fda779bc047b$var$elesfn$3[params.on] = $e815fda779bc047b$var$defineSwitchFunction({
        event: params.on,
        field: params.field,
        ableField: params.ableField,
        overrideAble: params.overrideAble,
        value: true
    });
    $e815fda779bc047b$var$elesfn$3[params.off] = $e815fda779bc047b$var$defineSwitchFunction({
        event: params.off,
        field: params.field,
        ableField: params.ableField,
        overrideAble: params.overrideAble,
        value: false
    });
}
$e815fda779bc047b$var$defineSwitchSet({
    field: 'locked',
    overrideField: function overrideField(ele) {
        return ele.cy().autolock() ? true : undefined;
    },
    on: 'lock',
    off: 'unlock'
});
$e815fda779bc047b$var$defineSwitchSet({
    field: 'grabbable',
    overrideField: function overrideField(ele) {
        return ele.cy().autoungrabify() || ele.pannable() ? false : undefined;
    },
    on: 'grabify',
    off: 'ungrabify'
});
$e815fda779bc047b$var$defineSwitchSet({
    field: 'selected',
    ableField: 'selectable',
    overrideAble: function overrideAble(ele) {
        return ele.cy().autounselectify() ? false : undefined;
    },
    on: 'select',
    off: 'unselect'
});
$e815fda779bc047b$var$defineSwitchSet({
    field: 'selectable',
    overrideField: function overrideField(ele) {
        return ele.cy().autounselectify() ? false : undefined;
    },
    on: 'selectify',
    off: 'unselectify'
});
$e815fda779bc047b$var$elesfn$3.deselect = $e815fda779bc047b$var$elesfn$3.unselect;
$e815fda779bc047b$var$elesfn$3.grabbed = function() {
    var ele = this[0];
    if (ele) return ele._private.grabbed;
};
$e815fda779bc047b$var$defineSwitchSet({
    field: 'active',
    on: 'activate',
    off: 'unactivate'
});
$e815fda779bc047b$var$defineSwitchSet({
    field: 'pannable',
    on: 'panify',
    off: 'unpanify'
});
$e815fda779bc047b$var$elesfn$3.inactive = function() {
    var ele = this[0];
    if (ele) return !ele._private.active;
};
var $e815fda779bc047b$var$elesfn$2 = {};
// DAG functions
////////////////
var $e815fda779bc047b$var$defineDagExtremity = function defineDagExtremity(params) {
    return function dagExtremityImpl(selector) {
        var eles = this;
        var ret = [];
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            if (!ele.isNode()) continue;
            var disqualified = false;
            var edges = ele.connectedEdges();
            for(var j = 0; j < edges.length; j++){
                var edge = edges[j];
                var src = edge.source();
                var tgt = edge.target();
                if (params.noIncomingEdges && tgt === ele && src !== ele || params.noOutgoingEdges && src === ele && tgt !== ele) {
                    disqualified = true;
                    break;
                }
            }
            if (!disqualified) ret.push(ele);
        }
        return this.spawn(ret, true).filter(selector);
    };
};
var $e815fda779bc047b$var$defineDagOneHop = function defineDagOneHop(params) {
    return function(selector) {
        var eles = this;
        var oEles = [];
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            if (!ele.isNode()) continue;
            var edges = ele.connectedEdges();
            for(var j = 0; j < edges.length; j++){
                var edge = edges[j];
                var src = edge.source();
                var tgt = edge.target();
                if (params.outgoing && src === ele) {
                    oEles.push(edge);
                    oEles.push(tgt);
                } else if (params.incoming && tgt === ele) {
                    oEles.push(edge);
                    oEles.push(src);
                }
            }
        }
        return this.spawn(oEles, true).filter(selector);
    };
};
var $e815fda779bc047b$var$defineDagAllHops = function defineDagAllHops(params) {
    return function(selector) {
        var eles = this;
        var sEles = [];
        var sElesIds = {};
        for(;;){
            var next = params.outgoing ? eles.outgoers() : eles.incomers();
            if (next.length === 0) break;
             // done if none left
            var newNext = false;
            for(var i = 0; i < next.length; i++){
                var n = next[i];
                var nid = n.id();
                if (!sElesIds[nid]) {
                    sElesIds[nid] = true;
                    sEles.push(n);
                    newNext = true;
                }
            }
            if (!newNext) break;
             // done if touched all outgoers already
            eles = next;
        }
        return this.spawn(sEles, true).filter(selector);
    };
};
$e815fda779bc047b$var$elesfn$2.clearTraversalCache = function() {
    for(var i = 0; i < this.length; i++)this[i]._private.traversalCache = null;
};
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    // get the root nodes in the DAG
    roots: $e815fda779bc047b$var$defineDagExtremity({
        noIncomingEdges: true
    }),
    // get the leaf nodes in the DAG
    leaves: $e815fda779bc047b$var$defineDagExtremity({
        noOutgoingEdges: true
    }),
    // normally called children in graph theory
    // these nodes =edges=> outgoing nodes
    outgoers: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineDagOneHop({
        outgoing: true
    }), 'outgoers'),
    // aka DAG descendants
    successors: $e815fda779bc047b$var$defineDagAllHops({
        outgoing: true
    }),
    // normally called parents in graph theory
    // these nodes <=edges= incoming nodes
    incomers: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineDagOneHop({
        incoming: true
    }), 'incomers'),
    // aka DAG ancestors
    predecessors: $e815fda779bc047b$var$defineDagAllHops({
        incoming: true
    })
});
// Neighbourhood functions
//////////////////////////
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    neighborhood: $e815fda779bc047b$var$cache(function(selector) {
        var elements = [];
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++){
            // for all nodes
            var node = nodes[i];
            var connectedEdges = node.connectedEdges();
            // for each connected edge, add the edge and the other node
            for(var j = 0; j < connectedEdges.length; j++){
                var edge = connectedEdges[j];
                var src = edge.source();
                var tgt = edge.target();
                var otherNode = node === src ? tgt : src;
                // need check in case of loop
                if (otherNode.length > 0) elements.push(otherNode[0]); // add node 1 hop away
                // add connected edge
                elements.push(edge[0]);
            }
        }
        return this.spawn(elements, true).filter(selector);
    }, 'neighborhood'),
    closedNeighborhood: function closedNeighborhood(selector) {
        return this.neighborhood().add(this).filter(selector);
    },
    openNeighborhood: function openNeighborhood(selector) {
        return this.neighborhood(selector);
    }
});
// aliases
$e815fda779bc047b$var$elesfn$2.neighbourhood = $e815fda779bc047b$var$elesfn$2.neighborhood;
$e815fda779bc047b$var$elesfn$2.closedNeighbourhood = $e815fda779bc047b$var$elesfn$2.closedNeighborhood;
$e815fda779bc047b$var$elesfn$2.openNeighbourhood = $e815fda779bc047b$var$elesfn$2.openNeighborhood;
// Edge functions
/////////////////
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    source: $e815fda779bc047b$var$cache(function sourceImpl(selector) {
        var ele = this[0];
        var src;
        if (ele) src = ele._private.source || ele.cy().collection();
        return src && selector ? src.filter(selector) : src;
    }, 'source'),
    target: $e815fda779bc047b$var$cache(function targetImpl(selector) {
        var ele = this[0];
        var tgt;
        if (ele) tgt = ele._private.target || ele.cy().collection();
        return tgt && selector ? tgt.filter(selector) : tgt;
    }, 'target'),
    sources: $e815fda779bc047b$var$defineSourceFunction({
        attr: 'source'
    }),
    targets: $e815fda779bc047b$var$defineSourceFunction({
        attr: 'target'
    })
});
function $e815fda779bc047b$var$defineSourceFunction(params) {
    return function sourceImpl(selector) {
        var sources = [];
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var src = ele._private[params.attr];
            if (src) sources.push(src);
        }
        return this.spawn(sources, true).filter(selector);
    };
}
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    edgesWith: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineEdgesWithFunction(), 'edgesWith'),
    edgesTo: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineEdgesWithFunction({
        thisIsSrc: true
    }), 'edgesTo')
});
function $e815fda779bc047b$var$defineEdgesWithFunction(params) {
    return function edgesWithImpl(otherNodes) {
        var elements = [];
        var cy = this._private.cy;
        var p = params || {};
        // get elements if a selector is specified
        if ($e815fda779bc047b$var$string(otherNodes)) otherNodes = cy.$(otherNodes);
        for(var h = 0; h < otherNodes.length; h++){
            var edges = otherNodes[h]._private.edges;
            for(var i = 0; i < edges.length; i++){
                var edge = edges[i];
                var edgeData = edge._private.data;
                var thisToOther = this.hasElementWithId(edgeData.source) && otherNodes.hasElementWithId(edgeData.target);
                var otherToThis = otherNodes.hasElementWithId(edgeData.source) && this.hasElementWithId(edgeData.target);
                var edgeConnectsThisAndOther = thisToOther || otherToThis;
                if (!edgeConnectsThisAndOther) continue;
                if (p.thisIsSrc || p.thisIsTgt) {
                    if (p.thisIsSrc && !thisToOther) continue;
                    if (p.thisIsTgt && !otherToThis) continue;
                }
                elements.push(edge);
            }
        }
        return this.spawn(elements, true);
    };
}
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    connectedEdges: $e815fda779bc047b$var$cache(function(selector) {
        var retEles = [];
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var node = eles[i];
            if (!node.isNode()) continue;
            var edges = node._private.edges;
            for(var j = 0; j < edges.length; j++){
                var edge = edges[j];
                retEles.push(edge);
            }
        }
        return this.spawn(retEles, true).filter(selector);
    }, 'connectedEdges'),
    connectedNodes: $e815fda779bc047b$var$cache(function(selector) {
        var retEles = [];
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var edge = eles[i];
            if (!edge.isEdge()) continue;
            retEles.push(edge.source()[0]);
            retEles.push(edge.target()[0]);
        }
        return this.spawn(retEles, true).filter(selector);
    }, 'connectedNodes'),
    parallelEdges: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineParallelEdgesFunction(), 'parallelEdges'),
    codirectedEdges: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineParallelEdgesFunction({
        codirected: true
    }), 'codirectedEdges')
});
function $e815fda779bc047b$var$defineParallelEdgesFunction(params) {
    var defaults = {
        codirected: false
    };
    params = $e815fda779bc047b$var$extend({}, defaults, params);
    return function parallelEdgesImpl(selector) {
        // micro-optimised for renderer
        var elements = [];
        var edges = this.edges();
        var p = params;
        // look at all the edges in the collection
        for(var i = 0; i < edges.length; i++){
            var edge1 = edges[i];
            var edge1_p = edge1._private;
            var src1 = edge1_p.source;
            var srcid1 = src1._private.data.id;
            var tgtid1 = edge1_p.data.target;
            var srcEdges1 = src1._private.edges;
            // look at edges connected to the src node of this edge
            for(var j = 0; j < srcEdges1.length; j++){
                var edge2 = srcEdges1[j];
                var edge2data = edge2._private.data;
                var tgtid2 = edge2data.target;
                var srcid2 = edge2data.source;
                var codirected = tgtid2 === tgtid1 && srcid2 === srcid1;
                var oppdirected = srcid1 === tgtid2 && tgtid1 === srcid2;
                if (p.codirected && codirected || !p.codirected && (codirected || oppdirected)) elements.push(edge2);
            }
        }
        return this.spawn(elements, true).filter(selector);
    };
}
// Misc functions
/////////////////
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    components: function components(root) {
        var self1 = this;
        var cy = self1.cy();
        var visited = cy.collection();
        var unvisited = root == null ? self1.nodes() : root.nodes();
        var components = [];
        if (root != null && unvisited.empty()) // root may contain only edges
        unvisited = root.sources(); // doesn't matter which node to use (undirected), so just use the source sides
        var visitInComponent = function visitInComponent(node, component) {
            visited.merge(node);
            unvisited.unmerge(node);
            component.merge(node);
        };
        if (unvisited.empty()) return self1.spawn();
        var _loop = function _loop() {
            // each iteration yields a component
            var cmpt = cy.collection();
            components.push(cmpt);
            var root = unvisited[0];
            visitInComponent(root, cmpt);
            self1.bfs({
                directed: false,
                roots: root,
                visit: function visit(v) {
                    return visitInComponent(v, cmpt);
                }
            });
            cmpt.forEach(function(node) {
                node.connectedEdges().forEach(function(e) {
                    // connectedEdges() usually cached
                    if (self1.has(e) && cmpt.has(e.source()) && cmpt.has(e.target())) // has() is cheap
                    cmpt.merge(e); // forEach() only considers nodes -- sets N at call time
                });
            });
        };
        do _loop();
        while (unvisited.length > 0);
        return components;
    },
    component: function component() {
        var ele = this[0];
        return ele.cy().mutableElements().components(ele)[0];
    }
});
$e815fda779bc047b$var$elesfn$2.componentsOf = $e815fda779bc047b$var$elesfn$2.components;
// represents a set of nodes, edges, or both together
var $e815fda779bc047b$var$Collection = function Collection(cy, elements) {
    var unique = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var removed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (cy === undefined) {
        $e815fda779bc047b$var$error('A collection must have a reference to the core');
        return;
    }
    var map = new $e815fda779bc047b$var$Map$2();
    var createdElements = false;
    if (!elements) elements = [];
    else if (elements.length > 0 && $e815fda779bc047b$var$plainObject(elements[0]) && !$e815fda779bc047b$var$element(elements[0])) {
        createdElements = true;
        // make elements from json and restore all at once later
        var eles = [];
        var elesIds = new $e815fda779bc047b$var$Set$1();
        for(var i = 0, l = elements.length; i < l; i++){
            var json = elements[i];
            if (json.data == null) json.data = {};
            var _data = json.data;
            // make sure newly created elements have valid ids
            if (_data.id == null) _data.id = $e815fda779bc047b$var$uuid();
            else if (cy.hasElementWithId(_data.id) || elesIds.has(_data.id)) continue; // can't create element if prior id already exists
            var ele = new $e815fda779bc047b$var$Element(cy, json, false);
            eles.push(ele);
            elesIds.add(_data.id);
        }
        elements = eles;
    }
    this.length = 0;
    for(var _i = 0, _l = elements.length; _i < _l; _i++){
        var element$1 = elements[_i][0]; // [0] in case elements is an array of collections, rather than array of elements
        if (element$1 == null) continue;
        var id = element$1._private.data.id;
        if (!unique || !map.has(id)) {
            if (unique) map.set(id, {
                index: this.length,
                ele: element$1
            });
            this[this.length] = element$1;
            this.length++;
        }
    }
    this._private = {
        eles: this,
        cy: cy,
        get map () {
            if (this.lazyMap == null) this.rebuildMap();
            return this.lazyMap;
        },
        set map (m){
            this.lazyMap = m;
        },
        rebuildMap: function rebuildMap() {
            var m1 = this.lazyMap = new $e815fda779bc047b$var$Map$2();
            var eles = this.eles;
            for(var _i2 = 0; _i2 < eles.length; _i2++){
                var _ele = eles[_i2];
                m1.set(_ele.id(), {
                    index: _i2,
                    ele: _ele
                });
            }
        }
    };
    if (unique) this._private.map = map;
    // restore the elements if we created them from json
    if (createdElements && !removed) this.restore();
};
// Functions
////////////////////////////////////////////////////////////////////////////////////////////////////
// keep the prototypes in sync (an element has the same functions as a collection)
// and use elefn and elesfn as shorthands to the prototypes
var $e815fda779bc047b$var$elesfn$1 = $e815fda779bc047b$var$Element.prototype = $e815fda779bc047b$var$Collection.prototype = Object.create(Array.prototype);
$e815fda779bc047b$var$elesfn$1.instanceString = function() {
    return 'collection';
};
$e815fda779bc047b$var$elesfn$1.spawn = function(eles, unique) {
    return new $e815fda779bc047b$var$Collection(this.cy(), eles, unique);
};
$e815fda779bc047b$var$elesfn$1.spawnSelf = function() {
    return this.spawn(this);
};
$e815fda779bc047b$var$elesfn$1.cy = function() {
    return this._private.cy;
};
$e815fda779bc047b$var$elesfn$1.renderer = function() {
    return this._private.cy.renderer();
};
$e815fda779bc047b$var$elesfn$1.element = function() {
    return this[0];
};
$e815fda779bc047b$var$elesfn$1.collection = function() {
    if ($e815fda779bc047b$var$collection(this)) return this;
    else // an element
    return new $e815fda779bc047b$var$Collection(this._private.cy, [
        this
    ]);
};
$e815fda779bc047b$var$elesfn$1.unique = function() {
    return new $e815fda779bc047b$var$Collection(this._private.cy, this, true);
};
$e815fda779bc047b$var$elesfn$1.hasElementWithId = function(id) {
    id = '' + id; // id must be string
    return this._private.map.has(id);
};
$e815fda779bc047b$var$elesfn$1.getElementById = function(id) {
    id = '' + id; // id must be string
    var cy = this._private.cy;
    var entry = this._private.map.get(id);
    return entry ? entry.ele : new $e815fda779bc047b$var$Collection(cy); // get ele or empty collection
};
$e815fda779bc047b$var$elesfn$1.$id = $e815fda779bc047b$var$elesfn$1.getElementById;
$e815fda779bc047b$var$elesfn$1.poolIndex = function() {
    var cy = this._private.cy;
    var eles = cy._private.elements;
    var id = this[0]._private.data.id;
    return eles._private.map.get(id).index;
};
$e815fda779bc047b$var$elesfn$1.indexOf = function(ele) {
    var id = ele[0]._private.data.id;
    return this._private.map.get(id).index;
};
$e815fda779bc047b$var$elesfn$1.indexOfId = function(id) {
    id = '' + id; // id must be string
    return this._private.map.get(id).index;
};
$e815fda779bc047b$var$elesfn$1.json = function(obj) {
    var ele = this.element();
    var cy = this.cy();
    if (ele == null && obj) return this;
     // can't set to no eles
    if (ele == null) return undefined;
     // can't get from no eles
    var p = ele._private;
    if ($e815fda779bc047b$var$plainObject(obj)) {
        // set
        cy.startBatch();
        if (obj.data) {
            ele.data(obj.data);
            var _data2 = p.data;
            if (ele.isEdge()) {
                // source and target are immutable via data()
                var move = false;
                var spec = {};
                var src = obj.data.source;
                var tgt = obj.data.target;
                if (src != null && src != _data2.source) {
                    spec.source = '' + src; // id must be string
                    move = true;
                }
                if (tgt != null && tgt != _data2.target) {
                    spec.target = '' + tgt; // id must be string
                    move = true;
                }
                if (move) ele = ele.move(spec);
            } else {
                // parent is immutable via data()
                var newParentValSpecd = 'parent' in obj.data;
                var parent = obj.data.parent;
                if (newParentValSpecd && (parent != null || _data2.parent != null) && parent != _data2.parent) {
                    if (parent === undefined) // can't set undefined imperatively, so use null
                    parent = null;
                    if (parent != null) parent = '' + parent; // id must be string
                    ele = ele.move({
                        parent: parent
                    });
                }
            }
        }
        if (obj.position) ele.position(obj.position);
        // ignore group -- immutable
        var checkSwitch = function checkSwitch(k, trueFnName, falseFnName) {
            var obj_k = obj[k];
            if (obj_k != null && obj_k !== p[k]) {
                if (obj_k) ele[trueFnName]();
                else ele[falseFnName]();
            }
        };
        checkSwitch('removed', 'remove', 'restore');
        checkSwitch('selected', 'select', 'unselect');
        checkSwitch('selectable', 'selectify', 'unselectify');
        checkSwitch('locked', 'lock', 'unlock');
        checkSwitch('grabbable', 'grabify', 'ungrabify');
        checkSwitch('pannable', 'panify', 'unpanify');
        if (obj.classes != null) ele.classes(obj.classes);
        cy.endBatch();
        return this;
    } else if (obj === undefined) {
        // get
        var json = {
            data: $e815fda779bc047b$var$copy(p.data),
            position: $e815fda779bc047b$var$copy(p.position),
            group: p.group,
            removed: p.removed,
            selected: p.selected,
            selectable: p.selectable,
            locked: p.locked,
            grabbable: p.grabbable,
            pannable: p.pannable,
            classes: null
        };
        json.classes = '';
        var i = 0;
        p.classes.forEach(function(cls) {
            return json.classes += i++ === 0 ? cls : ' ' + cls;
        });
        return json;
    }
};
$e815fda779bc047b$var$elesfn$1.jsons = function() {
    var jsons = [];
    for(var i = 0; i < this.length; i++){
        var ele = this[i];
        var json = ele.json();
        jsons.push(json);
    }
    return jsons;
};
$e815fda779bc047b$var$elesfn$1.clone = function() {
    var cy = this.cy();
    var elesArr = [];
    for(var i = 0; i < this.length; i++){
        var ele = this[i];
        var json = ele.json();
        var clone = new $e815fda779bc047b$var$Element(cy, json, false); // NB no restore
        elesArr.push(clone);
    }
    return new $e815fda779bc047b$var$Collection(cy, elesArr);
};
$e815fda779bc047b$var$elesfn$1.copy = $e815fda779bc047b$var$elesfn$1.clone;
$e815fda779bc047b$var$elesfn$1.restore = function() {
    var notifyRenderer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var addToPool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var self1 = this;
    var cy = self1.cy();
    var cy_p = cy._private;
    // create arrays of nodes and edges, since we need to
    // restore the nodes first
    var nodes = [];
    var edges = [];
    var elements;
    for(var _i3 = 0, l = self1.length; _i3 < l; _i3++){
        var ele = self1[_i3];
        if (addToPool && !ele.removed()) continue;
        // keep nodes first in the array and edges after
        if (ele.isNode()) // put to front of array if node
        nodes.push(ele);
        else // put to end of array if edge
        edges.push(ele);
    }
    elements = nodes.concat(edges);
    var i;
    var removeFromElements = function removeFromElements() {
        elements.splice(i, 1);
        i--;
    };
    // now, restore each element
    for(i = 0; i < elements.length; i++){
        var _ele2 = elements[i];
        var _private = _ele2._private;
        var _data3 = _private.data;
        // the traversal cache should start fresh when ele is added
        _ele2.clearTraversalCache();
        // set id and validate
        if (!addToPool && !_private.removed) ;
        else if (_data3.id === undefined) _data3.id = $e815fda779bc047b$var$uuid();
        else if ($e815fda779bc047b$var$number$1(_data3.id)) _data3.id = '' + _data3.id; // now it's a string
        else if ($e815fda779bc047b$var$emptyString(_data3.id) || !$e815fda779bc047b$var$string(_data3.id)) {
            $e815fda779bc047b$var$error('Can not create element with invalid string ID `' + _data3.id + '`');
            // can't create element if it has empty string as id or non-string id
            removeFromElements();
            continue;
        } else if (cy.hasElementWithId(_data3.id)) {
            $e815fda779bc047b$var$error('Can not create second element with ID `' + _data3.id + '`');
            // can't create element if one already has that id
            removeFromElements();
            continue;
        }
        var id = _data3.id; // id is finalised, now let's keep a ref
        if (_ele2.isNode()) {
            // extra checks for nodes
            var pos = _private.position;
            // make sure the nodes have a defined position
            if (pos.x == null) pos.x = 0;
            if (pos.y == null) pos.y = 0;
        }
        if (_ele2.isEdge()) {
            // extra checks for edges
            var edge = _ele2;
            var fields = [
                'source',
                'target'
            ];
            var fieldsLength = fields.length;
            var badSourceOrTarget = false;
            for(var j = 0; j < fieldsLength; j++){
                var field = fields[j];
                var val = _data3[field];
                if ($e815fda779bc047b$var$number$1(val)) val = _data3[field] = '' + _data3[field]; // now string
                if (val == null || val === '') {
                    // can't create if source or target is not defined properly
                    $e815fda779bc047b$var$error('Can not create edge `' + id + '` with unspecified ' + field);
                    badSourceOrTarget = true;
                } else if (!cy.hasElementWithId(val)) {
                    // can't create edge if one of its nodes doesn't exist
                    $e815fda779bc047b$var$error('Can not create edge `' + id + '` with nonexistant ' + field + ' `' + val + '`');
                    badSourceOrTarget = true;
                }
            }
            if (badSourceOrTarget) {
                removeFromElements();
                continue;
            } // can't create this
            var src = cy.getElementById(_data3.source);
            var tgt = cy.getElementById(_data3.target);
            // only one edge in node if loop
            if (src.same(tgt)) src._private.edges.push(edge);
            else {
                src._private.edges.push(edge);
                tgt._private.edges.push(edge);
            }
            edge._private.source = src;
            edge._private.target = tgt;
        } // if is edge
        // create mock ids / indexes maps for element so it can be used like collections
        _private.map = new $e815fda779bc047b$var$Map$2();
        _private.map.set(id, {
            ele: _ele2,
            index: 0
        });
        _private.removed = false;
        if (addToPool) cy.addToPool(_ele2);
    } // for each element
    // do compound node sanity checks
    for(var _i4 = 0; _i4 < nodes.length; _i4++){
        // each node
        var node = nodes[_i4];
        var _data4 = node._private.data;
        if ($e815fda779bc047b$var$number$1(_data4.parent)) // then automake string
        _data4.parent = '' + _data4.parent;
        var parentId = _data4.parent;
        var specifiedParent = parentId != null;
        if (specifiedParent || node._private.parent) {
            var parent = node._private.parent ? cy.collection().merge(node._private.parent) : cy.getElementById(parentId);
            if (parent.empty()) // non-existant parent; just remove it
            _data4.parent = undefined;
            else if (parent[0].removed()) {
                $e815fda779bc047b$var$warn('Node added with missing parent, reference to parent removed');
                _data4.parent = undefined;
                node._private.parent = null;
            } else {
                var selfAsParent = false;
                var ancestor = parent;
                while(!ancestor.empty()){
                    if (node.same(ancestor)) {
                        // mark self as parent and remove from data
                        selfAsParent = true;
                        _data4.parent = undefined; // remove parent reference
                        break;
                    }
                    ancestor = ancestor.parent();
                }
                if (!selfAsParent) {
                    // connect with children
                    parent[0]._private.children.push(node);
                    node._private.parent = parent[0];
                    // let the core know we have a compound graph
                    cy_p.hasCompoundNodes = true;
                }
            } // else
        } // if specified parent
    } // for each node
    if (elements.length > 0) {
        var restored = elements.length === self1.length ? self1 : new $e815fda779bc047b$var$Collection(cy, elements);
        for(var _i5 = 0; _i5 < restored.length; _i5++){
            var _ele3 = restored[_i5];
            if (_ele3.isNode()) continue;
            // adding an edge invalidates the traversal caches for the parallel edges
            _ele3.parallelEdges().clearTraversalCache();
            // adding an edge invalidates the traversal cache for the connected nodes
            _ele3.source().clearTraversalCache();
            _ele3.target().clearTraversalCache();
        }
        var toUpdateStyle;
        if (cy_p.hasCompoundNodes) toUpdateStyle = cy.collection().merge(restored).merge(restored.connectedNodes()).merge(restored.parent());
        else toUpdateStyle = restored;
        toUpdateStyle.dirtyCompoundBoundsCache().dirtyBoundingBoxCache().updateStyle(notifyRenderer);
        if (notifyRenderer) restored.emitAndNotify('add');
        else if (addToPool) restored.emit('add');
    }
    return self1; // chainability
};
$e815fda779bc047b$var$elesfn$1.removed = function() {
    var ele = this[0];
    return ele && ele._private.removed;
};
$e815fda779bc047b$var$elesfn$1.inside = function() {
    var ele = this[0];
    return ele && !ele._private.removed;
};
$e815fda779bc047b$var$elesfn$1.remove = function() {
    var notifyRenderer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var removeFromPool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var self1 = this;
    var elesToRemove = [];
    var elesToRemoveIds = {};
    var cy = self1._private.cy;
    // add connected edges
    function addConnectedEdges(node) {
        var edges = node._private.edges;
        for(var i = 0; i < edges.length; i++)add(edges[i]);
    }
    // add descendant nodes
    function addChildren(node) {
        var children = node._private.children;
        for(var i = 0; i < children.length; i++)add(children[i]);
    }
    function add(ele) {
        var alreadyAdded = elesToRemoveIds[ele.id()];
        if (removeFromPool && ele.removed() || alreadyAdded) return;
        else elesToRemoveIds[ele.id()] = true;
        if (ele.isNode()) {
            elesToRemove.push(ele); // nodes are removed last
            addConnectedEdges(ele);
            addChildren(ele);
        } else elesToRemove.unshift(ele); // edges are removed first
    }
    // make the list of elements to remove
    // (may be removing more than specified due to connected edges etc)
    for(var i = 0, l = self1.length; i < l; i++){
        var ele = self1[i];
        add(ele);
    }
    function removeEdgeRef(node, edge) {
        var connectedEdges = node._private.edges;
        $e815fda779bc047b$var$removeFromArray(connectedEdges, edge);
        // removing an edges invalidates the traversal cache for its nodes
        node.clearTraversalCache();
    }
    function removeParallelRef(pllEdge) {
        // removing an edge invalidates the traversal caches for the parallel edges
        pllEdge.clearTraversalCache();
    }
    var alteredParents = [];
    alteredParents.ids = {};
    function removeChildRef(parent, ele) {
        ele = ele[0];
        parent = parent[0];
        var children = parent._private.children;
        var pid = parent.id();
        $e815fda779bc047b$var$removeFromArray(children, ele); // remove parent => child ref
        ele._private.parent = null; // remove child => parent ref
        if (!alteredParents.ids[pid]) {
            alteredParents.ids[pid] = true;
            alteredParents.push(parent);
        }
    }
    self1.dirtyCompoundBoundsCache();
    if (removeFromPool) cy.removeFromPool(elesToRemove); // remove from core pool
    for(var _i6 = 0; _i6 < elesToRemove.length; _i6++){
        var _ele4 = elesToRemove[_i6];
        if (_ele4.isEdge()) {
            // remove references to this edge in its connected nodes
            var src = _ele4.source()[0];
            var tgt = _ele4.target()[0];
            removeEdgeRef(src, _ele4);
            removeEdgeRef(tgt, _ele4);
            var pllEdges = _ele4.parallelEdges();
            for(var j = 0; j < pllEdges.length; j++){
                var pllEdge = pllEdges[j];
                removeParallelRef(pllEdge);
                if (pllEdge.isBundledBezier()) pllEdge.dirtyBoundingBoxCache();
            }
        } else {
            // remove reference to parent
            var parent = _ele4.parent();
            if (parent.length !== 0) removeChildRef(parent, _ele4);
        }
        if (removeFromPool) // mark as removed
        _ele4._private.removed = true;
    }
    // check to see if we have a compound graph or not
    var elesStillInside = cy._private.elements;
    cy._private.hasCompoundNodes = false;
    for(var _i7 = 0; _i7 < elesStillInside.length; _i7++){
        var _ele5 = elesStillInside[_i7];
        if (_ele5.isParent()) {
            cy._private.hasCompoundNodes = true;
            break;
        }
    }
    var removedElements = new $e815fda779bc047b$var$Collection(this.cy(), elesToRemove);
    if (removedElements.size() > 0) {
        // must manually notify since trigger won't do this automatically once removed
        if (notifyRenderer) removedElements.emitAndNotify('remove');
        else if (removeFromPool) removedElements.emit('remove');
    }
    // the parents who were modified by the removal need their style updated
    for(var _i8 = 0; _i8 < alteredParents.length; _i8++){
        var _ele6 = alteredParents[_i8];
        if (!removeFromPool || !_ele6.removed()) _ele6.updateStyle();
    }
    return removedElements;
};
$e815fda779bc047b$var$elesfn$1.move = function(struct) {
    var cy = this._private.cy;
    var eles = this;
    // just clean up refs, caches, etc. in the same way as when removing and then restoring
    // (our calls to remove/restore do not remove from the graph or make events)
    var notifyRenderer = false;
    var modifyPool = false;
    var toString = function toString(id) {
        return id == null ? id : '' + id;
    }; // id must be string
    if (struct.source !== undefined || struct.target !== undefined) {
        var srcId = toString(struct.source);
        var tgtId = toString(struct.target);
        var srcExists = srcId != null && cy.hasElementWithId(srcId);
        var tgtExists = tgtId != null && cy.hasElementWithId(tgtId);
        if (srcExists || tgtExists) {
            cy.batch(function() {
                // avoid duplicate style updates
                eles.remove(notifyRenderer, modifyPool); // clean up refs etc.
                eles.emitAndNotify('moveout');
                for(var i = 0; i < eles.length; i++){
                    var ele = eles[i];
                    var _data5 = ele._private.data;
                    if (ele.isEdge()) {
                        if (srcExists) _data5.source = srcId;
                        if (tgtExists) _data5.target = tgtId;
                    }
                }
                eles.restore(notifyRenderer, modifyPool); // make new refs, style, etc.
            });
            eles.emitAndNotify('move');
        }
    } else if (struct.parent !== undefined) {
        // move node to new parent
        var parentId = toString(struct.parent);
        var parentExists = parentId === null || cy.hasElementWithId(parentId);
        if (parentExists) {
            var pidToAssign = parentId === null ? undefined : parentId;
            cy.batch(function() {
                // avoid duplicate style updates
                var updated = eles.remove(notifyRenderer, modifyPool); // clean up refs etc.
                updated.emitAndNotify('moveout');
                for(var i = 0; i < eles.length; i++){
                    var ele = eles[i];
                    var _data6 = ele._private.data;
                    if (ele.isNode()) _data6.parent = pidToAssign;
                }
                updated.restore(notifyRenderer, modifyPool); // make new refs, style, etc.
            });
            eles.emitAndNotify('move');
        }
    }
    return this;
};
[
    $e815fda779bc047b$var$elesfn$j,
    $e815fda779bc047b$var$elesfn$i,
    $e815fda779bc047b$var$elesfn$h,
    $e815fda779bc047b$var$elesfn$g,
    $e815fda779bc047b$var$elesfn$f,
    $e815fda779bc047b$var$data,
    $e815fda779bc047b$var$elesfn$d,
    $e815fda779bc047b$var$dimensions,
    $e815fda779bc047b$var$elesfn$9,
    $e815fda779bc047b$var$elesfn$8,
    $e815fda779bc047b$var$elesfn$7,
    $e815fda779bc047b$var$elesfn$6,
    $e815fda779bc047b$var$elesfn$5,
    $e815fda779bc047b$var$elesfn$4,
    $e815fda779bc047b$var$elesfn$3,
    $e815fda779bc047b$var$elesfn$2
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$1, props);
});
var $e815fda779bc047b$var$corefn$9 = {
    add: function add(opts) {
        var elements;
        var cy = this;
        // add the elements
        if ($e815fda779bc047b$var$elementOrCollection(opts)) {
            var eles = opts;
            if (eles._private.cy === cy) // same instance => just restore
            elements = eles.restore();
            else {
                // otherwise, copy from json
                var jsons = [];
                for(var i = 0; i < eles.length; i++){
                    var ele = eles[i];
                    jsons.push(ele.json());
                }
                elements = new $e815fda779bc047b$var$Collection(cy, jsons);
            }
        } else if ($e815fda779bc047b$var$array(opts)) {
            var _jsons = opts;
            elements = new $e815fda779bc047b$var$Collection(cy, _jsons);
        } else if ($e815fda779bc047b$var$plainObject(opts) && ($e815fda779bc047b$var$array(opts.nodes) || $e815fda779bc047b$var$array(opts.edges))) {
            var elesByGroup = opts;
            var _jsons2 = [];
            var grs = [
                'nodes',
                'edges'
            ];
            for(var _i = 0, il = grs.length; _i < il; _i++){
                var group = grs[_i];
                var elesArray = elesByGroup[group];
                if ($e815fda779bc047b$var$array(elesArray)) for(var j = 0, jl = elesArray.length; j < jl; j++){
                    var json = $e815fda779bc047b$var$extend({
                        group: group
                    }, elesArray[j]);
                    _jsons2.push(json);
                }
            }
            elements = new $e815fda779bc047b$var$Collection(cy, _jsons2);
        } else {
            var _json = opts;
            elements = new $e815fda779bc047b$var$Element(cy, _json).collection();
        }
        return elements;
    },
    remove: function remove(collection) {
        if ($e815fda779bc047b$var$elementOrCollection(collection)) ;
        else if ($e815fda779bc047b$var$string(collection)) {
            var selector = collection;
            collection = this.$(selector);
        }
        return collection.remove();
    }
};
/* global Float32Array */ /*! Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */ function $e815fda779bc047b$var$generateCubicBezier(mX1, mY1, mX2, mY2) {
    var NEWTON_ITERATIONS = 4, NEWTON_MIN_SLOPE = 0.001, SUBDIVISION_PRECISION = 0.0000001, SUBDIVISION_MAX_ITERATIONS = 10, kSplineTableSize = 11, kSampleStepSize = 1.0 / (kSplineTableSize - 1.0), float32ArraySupported = typeof Float32Array !== 'undefined';
    /* Must contain four arguments. */ if (arguments.length !== 4) return false;
    /* Arguments must be numbers. */ for(var i = 0; i < 4; ++i){
        if (typeof arguments[i] !== "number" || isNaN(arguments[i]) || !isFinite(arguments[i])) return false;
    }
    /* X values must be in the [0, 1] range. */ mX1 = Math.min(mX1, 1);
    mX2 = Math.min(mX2, 1);
    mX1 = Math.max(mX1, 0);
    mX2 = Math.max(mX2, 0);
    var mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
    function A(aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }
    function B(aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    }
    function C(aA1) {
        return 3.0 * aA1;
    }
    function calcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }
    function getSlope(aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }
    function newtonRaphsonIterate(aX, aGuessT) {
        for(var _i = 0; _i < NEWTON_ITERATIONS; ++_i){
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }
    function calcSampleValues() {
        for(var _i2 = 0; _i2 < kSplineTableSize; ++_i2)mSampleValues[_i2] = calcBezier(_i2 * kSampleStepSize, mX1, mX2);
    }
    function binarySubdivide(aX, aA, aB) {
        var currentX, currentT, i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) aB = currentT;
            else aA = currentT;
        }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
        return currentT;
    }
    function getTForX(aX) {
        var intervalStart = 0.0, currentSample = 1, lastSample = kSplineTableSize - 1;
        for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
        --currentSample;
        var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]), guessForT = intervalStart + dist * kSampleStepSize, initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT);
        else if (initialSlope === 0.0) return guessForT;
        else return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize);
    }
    var _precomputed = false;
    function precompute() {
        _precomputed = true;
        if (mX1 !== mY1 || mX2 !== mY2) calcSampleValues();
    }
    var f = function f(aX) {
        if (!_precomputed) precompute();
        if (mX1 === mY1 && mX2 === mY2) return aX;
        if (aX === 0) return 0;
        if (aX === 1) return 1;
        return calcBezier(getTForX(aX), mY1, mY2);
    };
    f.getControlPoints = function() {
        return [
            {
                x: mX1,
                y: mY1
            },
            {
                x: mX2,
                y: mY2
            }
        ];
    };
    var str = "generateBezier(" + [
        mX1,
        mY1,
        mX2,
        mY2
    ] + ")";
    f.toString = function() {
        return str;
    };
    return f;
}
/*! Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */ /* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
   then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */ var $e815fda779bc047b$var$generateSpringRK4 = function() {
    function springAccelerationForState(state) {
        return -state.tension * state.x - state.friction * state.v;
    }
    function springEvaluateStateWithDerivative(initialState, dt, derivative) {
        var state = {
            x: initialState.x + derivative.dx * dt,
            v: initialState.v + derivative.dv * dt,
            tension: initialState.tension,
            friction: initialState.friction
        };
        return {
            dx: state.v,
            dv: springAccelerationForState(state)
        };
    }
    function springIntegrateState(state, dt) {
        var a = {
            dx: state.v,
            dv: springAccelerationForState(state)
        }, b = springEvaluateStateWithDerivative(state, dt * 0.5, a), c = springEvaluateStateWithDerivative(state, dt * 0.5, b), d = springEvaluateStateWithDerivative(state, dt, c), dxdt = 1.0 / 6.0 * (a.dx + 2.0 * (b.dx + c.dx) + d.dx), dvdt = 1.0 / 6.0 * (a.dv + 2.0 * (b.dv + c.dv) + d.dv);
        state.x = state.x + dxdt * dt;
        state.v = state.v + dvdt * dt;
        return state;
    }
    return function springRK4Factory(tension, friction, duration) {
        var initState = {
            x: -1,
            v: 0,
            tension: null,
            friction: null
        }, path = [
            0
        ], time_lapsed = 0, tolerance = 0.0001, DT = 0.016, have_duration, dt, last_state;
        tension = parseFloat(tension) || 500;
        friction = parseFloat(friction) || 20;
        duration = duration || null;
        initState.tension = tension;
        initState.friction = friction;
        have_duration = duration !== null;
        /* Calculate the actual time it takes for this animation to complete with the provided conditions. */ if (have_duration) {
            /* Run the simulation without a duration. */ time_lapsed = springRK4Factory(tension, friction);
            /* Compute the adjusted time delta. */ dt = time_lapsed / duration * DT;
        } else dt = DT;
        for(;;){
            /* Next/step function .*/ last_state = springIntegrateState(last_state || initState, dt);
            /* Store the position. */ path.push(1 + last_state.x);
            time_lapsed += 16;
            /* If the change threshold is reached, break. */ if (!(Math.abs(last_state.x) > tolerance && Math.abs(last_state.v) > tolerance)) break;
        }
        /* If duration is not defined, return the actual time required for completing this animation. Otherwise, return a closure that holds the
       computed path and returns a snapshot of the position according to a given percentComplete. */ return !have_duration ? time_lapsed : function(percentComplete) {
            return path[percentComplete * (path.length - 1) | 0];
        };
    };
}();
var $e815fda779bc047b$var$cubicBezier = function cubicBezier(t1, p1, t2, p2) {
    var bezier = $e815fda779bc047b$var$generateCubicBezier(t1, p1, t2, p2);
    return function(start, end, percent) {
        return start + (end - start) * bezier(percent);
    };
};
var $e815fda779bc047b$var$easings = {
    'linear': function linear(start, end, percent) {
        return start + (end - start) * percent;
    },
    // default easings
    'ease': $e815fda779bc047b$var$cubicBezier(0.25, 0.1, 0.25, 1),
    'ease-in': $e815fda779bc047b$var$cubicBezier(0.42, 0, 1, 1),
    'ease-out': $e815fda779bc047b$var$cubicBezier(0, 0, 0.58, 1),
    'ease-in-out': $e815fda779bc047b$var$cubicBezier(0.42, 0, 0.58, 1),
    // sine
    'ease-in-sine': $e815fda779bc047b$var$cubicBezier(0.47, 0, 0.745, 0.715),
    'ease-out-sine': $e815fda779bc047b$var$cubicBezier(0.39, 0.575, 0.565, 1),
    'ease-in-out-sine': $e815fda779bc047b$var$cubicBezier(0.445, 0.05, 0.55, 0.95),
    // quad
    'ease-in-quad': $e815fda779bc047b$var$cubicBezier(0.55, 0.085, 0.68, 0.53),
    'ease-out-quad': $e815fda779bc047b$var$cubicBezier(0.25, 0.46, 0.45, 0.94),
    'ease-in-out-quad': $e815fda779bc047b$var$cubicBezier(0.455, 0.03, 0.515, 0.955),
    // cubic
    'ease-in-cubic': $e815fda779bc047b$var$cubicBezier(0.55, 0.055, 0.675, 0.19),
    'ease-out-cubic': $e815fda779bc047b$var$cubicBezier(0.215, 0.61, 0.355, 1),
    'ease-in-out-cubic': $e815fda779bc047b$var$cubicBezier(0.645, 0.045, 0.355, 1),
    // quart
    'ease-in-quart': $e815fda779bc047b$var$cubicBezier(0.895, 0.03, 0.685, 0.22),
    'ease-out-quart': $e815fda779bc047b$var$cubicBezier(0.165, 0.84, 0.44, 1),
    'ease-in-out-quart': $e815fda779bc047b$var$cubicBezier(0.77, 0, 0.175, 1),
    // quint
    'ease-in-quint': $e815fda779bc047b$var$cubicBezier(0.755, 0.05, 0.855, 0.06),
    'ease-out-quint': $e815fda779bc047b$var$cubicBezier(0.23, 1, 0.32, 1),
    'ease-in-out-quint': $e815fda779bc047b$var$cubicBezier(0.86, 0, 0.07, 1),
    // expo
    'ease-in-expo': $e815fda779bc047b$var$cubicBezier(0.95, 0.05, 0.795, 0.035),
    'ease-out-expo': $e815fda779bc047b$var$cubicBezier(0.19, 1, 0.22, 1),
    'ease-in-out-expo': $e815fda779bc047b$var$cubicBezier(1, 0, 0, 1),
    // circ
    'ease-in-circ': $e815fda779bc047b$var$cubicBezier(0.6, 0.04, 0.98, 0.335),
    'ease-out-circ': $e815fda779bc047b$var$cubicBezier(0.075, 0.82, 0.165, 1),
    'ease-in-out-circ': $e815fda779bc047b$var$cubicBezier(0.785, 0.135, 0.15, 0.86),
    // user param easings...
    'spring': function spring(tension, friction, duration) {
        if (duration === 0) // can't get a spring w/ duration 0
        return $e815fda779bc047b$var$easings.linear; // duration 0 => jump to end so impl doesn't matter
        var spring = $e815fda779bc047b$var$generateSpringRK4(tension, friction, duration);
        return function(start, end, percent) {
            return start + (end - start) * spring(percent);
        };
    },
    'cubic-bezier': $e815fda779bc047b$var$cubicBezier
};
function $e815fda779bc047b$var$getEasedValue(type, start, end, percent, easingFn) {
    if (percent === 1) return end;
    if (start === end) return end;
    var val = easingFn(start, end, percent);
    if (type == null) return val;
    if (type.roundValue || type.color) val = Math.round(val);
    if (type.min !== undefined) val = Math.max(val, type.min);
    if (type.max !== undefined) val = Math.min(val, type.max);
    return val;
}
function $e815fda779bc047b$var$getValue(prop, spec) {
    if (prop.pfValue != null || prop.value != null) {
        if (prop.pfValue != null && (spec == null || spec.type.units !== '%')) return prop.pfValue;
        else return prop.value;
    } else return prop;
}
function $e815fda779bc047b$var$ease(startProp, endProp, percent, easingFn, propSpec) {
    var type = propSpec != null ? propSpec.type : null;
    if (percent < 0) percent = 0;
    else if (percent > 1) percent = 1;
    var start = $e815fda779bc047b$var$getValue(startProp, propSpec);
    var end = $e815fda779bc047b$var$getValue(endProp, propSpec);
    if ($e815fda779bc047b$var$number$1(start) && $e815fda779bc047b$var$number$1(end)) return $e815fda779bc047b$var$getEasedValue(type, start, end, percent, easingFn);
    else if ($e815fda779bc047b$var$array(start) && $e815fda779bc047b$var$array(end)) {
        var easedArr = [];
        for(var i = 0; i < end.length; i++){
            var si = start[i];
            var ei = end[i];
            if (si != null && ei != null) {
                var val = $e815fda779bc047b$var$getEasedValue(type, si, ei, percent, easingFn);
                easedArr.push(val);
            } else easedArr.push(ei);
        }
        return easedArr;
    }
    return undefined;
}
function $e815fda779bc047b$var$step$1(self1, ani, now, isCore) {
    var isEles = !isCore;
    var _p = self1._private;
    var ani_p = ani._private;
    var pEasing = ani_p.easing;
    var startTime = ani_p.startTime;
    var cy = isCore ? self1 : self1.cy();
    var style = cy.style();
    if (!ani_p.easingImpl) {
        if (pEasing == null) // use default
        ani_p.easingImpl = $e815fda779bc047b$var$easings['linear'];
        else {
            // then define w/ name
            var easingVals;
            if ($e815fda779bc047b$var$string(pEasing)) {
                var easingProp = style.parse('transition-timing-function', pEasing);
                easingVals = easingProp.value;
            } else // then assume preparsed array
            easingVals = pEasing;
            var name, args;
            if ($e815fda779bc047b$var$string(easingVals)) {
                name = easingVals;
                args = [];
            } else {
                name = easingVals[1];
                args = easingVals.slice(2).map(function(n) {
                    return +n;
                });
            }
            if (args.length > 0) {
                // create with args
                if (name === 'spring') args.push(ani_p.duration); // need duration to generate spring
                ani_p.easingImpl = $e815fda779bc047b$var$easings[name].apply(null, args);
            } else // static impl by name
            ani_p.easingImpl = $e815fda779bc047b$var$easings[name];
        }
    }
    var easing = ani_p.easingImpl;
    var percent;
    if (ani_p.duration === 0) percent = 1;
    else percent = (now - startTime) / ani_p.duration;
    if (ani_p.applying) percent = ani_p.progress;
    if (percent < 0) percent = 0;
    else if (percent > 1) percent = 1;
    if (ani_p.delay == null) {
        // then update
        var startPos = ani_p.startPosition;
        var endPos = ani_p.position;
        if (endPos && isEles && !self1.locked()) {
            var newPos = {};
            if ($e815fda779bc047b$var$valid(startPos.x, endPos.x)) newPos.x = $e815fda779bc047b$var$ease(startPos.x, endPos.x, percent, easing);
            if ($e815fda779bc047b$var$valid(startPos.y, endPos.y)) newPos.y = $e815fda779bc047b$var$ease(startPos.y, endPos.y, percent, easing);
            self1.position(newPos);
        }
        var startPan = ani_p.startPan;
        var endPan = ani_p.pan;
        var pan = _p.pan;
        var animatingPan = endPan != null && isCore;
        if (animatingPan) {
            if ($e815fda779bc047b$var$valid(startPan.x, endPan.x)) pan.x = $e815fda779bc047b$var$ease(startPan.x, endPan.x, percent, easing);
            if ($e815fda779bc047b$var$valid(startPan.y, endPan.y)) pan.y = $e815fda779bc047b$var$ease(startPan.y, endPan.y, percent, easing);
            self1.emit('pan');
        }
        var startZoom = ani_p.startZoom;
        var endZoom = ani_p.zoom;
        var animatingZoom = endZoom != null && isCore;
        if (animatingZoom) {
            if ($e815fda779bc047b$var$valid(startZoom, endZoom)) _p.zoom = $e815fda779bc047b$var$bound(_p.minZoom, $e815fda779bc047b$var$ease(startZoom, endZoom, percent, easing), _p.maxZoom);
            self1.emit('zoom');
        }
        if (animatingPan || animatingZoom) self1.emit('viewport');
        var props = ani_p.style;
        if (props && props.length > 0 && isEles) {
            for(var i = 0; i < props.length; i++){
                var prop = props[i];
                var _name = prop.name;
                var end = prop;
                var start = ani_p.startStyle[_name];
                var propSpec = style.properties[start.name];
                var easedVal = $e815fda779bc047b$var$ease(start, end, percent, easing, propSpec);
                style.overrideBypass(self1, _name, easedVal);
            } // for props
            self1.emit('style');
        } // if
    }
    ani_p.progress = percent;
    return percent;
}
function $e815fda779bc047b$var$valid(start, end) {
    if (start == null || end == null) return false;
    if ($e815fda779bc047b$var$number$1(start) && $e815fda779bc047b$var$number$1(end)) return true;
    else if (start && end) return true;
    return false;
}
function $e815fda779bc047b$var$startAnimation(self1, ani, now, isCore) {
    var ani_p = ani._private;
    ani_p.started = true;
    ani_p.startTime = now - ani_p.progress * ani_p.duration;
}
function $e815fda779bc047b$var$stepAll(now, cy) {
    var eles = cy._private.aniEles;
    var doneEles = [];
    function stepOne(ele, isCore) {
        var _p = ele._private;
        var current = _p.animation.current;
        var queue = _p.animation.queue;
        var ranAnis = false;
        // if nothing currently animating, get something from the queue
        if (current.length === 0) {
            var next = queue.shift();
            if (next) current.push(next);
        }
        var callbacks = function callbacks(_callbacks) {
            for(var j = _callbacks.length - 1; j >= 0; j--){
                var cb = _callbacks[j];
                cb();
            }
            _callbacks.splice(0, _callbacks.length);
        };
        // step and remove if done
        for(var i = current.length - 1; i >= 0; i--){
            var ani = current[i];
            var ani_p = ani._private;
            if (ani_p.stopped) {
                current.splice(i, 1);
                ani_p.hooked = false;
                ani_p.playing = false;
                ani_p.started = false;
                callbacks(ani_p.frames);
                continue;
            }
            if (!ani_p.playing && !ani_p.applying) continue;
            // an apply() while playing shouldn't do anything
            if (ani_p.playing && ani_p.applying) ani_p.applying = false;
            if (!ani_p.started) $e815fda779bc047b$var$startAnimation(ele, ani, now);
            $e815fda779bc047b$var$step$1(ele, ani, now, isCore);
            if (ani_p.applying) ani_p.applying = false;
            callbacks(ani_p.frames);
            if (ani_p.step != null) ani_p.step(now);
            if (ani.completed()) {
                current.splice(i, 1);
                ani_p.hooked = false;
                ani_p.playing = false;
                ani_p.started = false;
                callbacks(ani_p.completes);
            }
            ranAnis = true;
        }
        if (!isCore && current.length === 0 && queue.length === 0) doneEles.push(ele);
        return ranAnis;
    } // stepElement
    // handle all eles
    var ranEleAni = false;
    for(var e = 0; e < eles.length; e++){
        var ele = eles[e];
        var handledThisEle = stepOne(ele);
        ranEleAni = ranEleAni || handledThisEle;
    } // each element
    var ranCoreAni = stepOne(cy, true);
    // notify renderer
    if (ranEleAni || ranCoreAni) {
        if (eles.length > 0) cy.notify('draw', eles);
        else cy.notify('draw');
    }
    // remove elements from list of currently animating if its queues are empty
    eles.unmerge(doneEles);
    cy.emit('step');
} // stepAll
var $e815fda779bc047b$var$corefn$8 = {
    // pull in animation functions
    animate: $e815fda779bc047b$var$define.animate(),
    animation: $e815fda779bc047b$var$define.animation(),
    animated: $e815fda779bc047b$var$define.animated(),
    clearQueue: $e815fda779bc047b$var$define.clearQueue(),
    delay: $e815fda779bc047b$var$define.delay(),
    delayAnimation: $e815fda779bc047b$var$define.delayAnimation(),
    stop: $e815fda779bc047b$var$define.stop(),
    addToAnimationPool: function addToAnimationPool(eles) {
        var cy = this;
        if (!cy.styleEnabled()) return;
         // save cycles when no style used
        cy._private.aniEles.merge(eles);
    },
    stopAnimationLoop: function stopAnimationLoop() {
        this._private.animationsRunning = false;
    },
    startAnimationLoop: function startAnimationLoop() {
        var cy = this;
        cy._private.animationsRunning = true;
        if (!cy.styleEnabled()) return;
         // save cycles when no style used
        // NB the animation loop will exec in headless environments if style enabled
        // and explicit cy.destroy() is necessary to stop the loop
        function headlessStep() {
            if (!cy._private.animationsRunning) return;
            $e815fda779bc047b$var$requestAnimationFrame(function animationStep(now) {
                $e815fda779bc047b$var$stepAll(now, cy);
                headlessStep();
            });
        }
        var renderer = cy.renderer();
        if (renderer && renderer.beforeRender) // let the renderer schedule animations
        renderer.beforeRender(function rendererAnimationStep(willDraw, now) {
            $e815fda779bc047b$var$stepAll(now, cy);
        }, renderer.beforeRenderPriorities.animations);
        else // manage the animation loop ourselves
        headlessStep(); // first call
    }
};
var $e815fda779bc047b$var$emitterOptions = {
    qualifierCompare: function qualifierCompare(selector1, selector2) {
        if (selector1 == null || selector2 == null) return selector1 == null && selector2 == null;
        else return selector1.sameText(selector2);
    },
    eventMatches: function eventMatches(cy, listener, eventObj) {
        var selector = listener.qualifier;
        if (selector != null) return cy !== eventObj.target && $e815fda779bc047b$var$element(eventObj.target) && selector.matches(eventObj.target);
        return true;
    },
    addEventFields: function addEventFields(cy, evt) {
        evt.cy = cy;
        evt.target = cy;
    },
    callbackContext: function callbackContext(cy, listener, eventObj) {
        return listener.qualifier != null ? eventObj.target : cy;
    }
};
var $e815fda779bc047b$var$argSelector = function argSelector(arg) {
    if ($e815fda779bc047b$var$string(arg)) return new $e815fda779bc047b$var$Selector(arg);
    else return arg;
};
var $e815fda779bc047b$var$elesfn = {
    createEmitter: function createEmitter() {
        var _p = this._private;
        if (!_p.emitter) _p.emitter = new $e815fda779bc047b$var$Emitter($e815fda779bc047b$var$emitterOptions, this);
        return this;
    },
    emitter: function emitter() {
        return this._private.emitter;
    },
    on: function on(events, selector, callback) {
        this.emitter().on(events, $e815fda779bc047b$var$argSelector(selector), callback);
        return this;
    },
    removeListener: function removeListener(events, selector, callback) {
        this.emitter().removeListener(events, $e815fda779bc047b$var$argSelector(selector), callback);
        return this;
    },
    removeAllListeners: function removeAllListeners() {
        this.emitter().removeAllListeners();
        return this;
    },
    one: function one(events, selector, callback) {
        this.emitter().one(events, $e815fda779bc047b$var$argSelector(selector), callback);
        return this;
    },
    once: function once(events, selector, callback) {
        this.emitter().one(events, $e815fda779bc047b$var$argSelector(selector), callback);
        return this;
    },
    emit: function emit(events, extraParams) {
        this.emitter().emit(events, extraParams);
        return this;
    },
    emitAndNotify: function emitAndNotify(event, eles) {
        this.emit(event);
        this.notify(event, eles);
        return this;
    }
};
$e815fda779bc047b$var$define.eventAliasesOn($e815fda779bc047b$var$elesfn);
var $e815fda779bc047b$var$corefn$7 = {
    png: function png(options) {
        var renderer = this._private.renderer;
        options = options || {};
        return renderer.png(options);
    },
    jpg: function jpg(options) {
        var renderer = this._private.renderer;
        options = options || {};
        options.bg = options.bg || '#fff';
        return renderer.jpg(options);
    }
};
$e815fda779bc047b$var$corefn$7.jpeg = $e815fda779bc047b$var$corefn$7.jpg;
var $e815fda779bc047b$var$corefn$6 = {
    layout: function layout(options) {
        var cy = this;
        if (options == null) {
            $e815fda779bc047b$var$error('Layout options must be specified to make a layout');
            return;
        }
        if (options.name == null) {
            $e815fda779bc047b$var$error('A `name` must be specified to make a layout');
            return;
        }
        var name = options.name;
        var Layout = cy.extension('layout', name);
        if (Layout == null) {
            $e815fda779bc047b$var$error('No such layout `' + name + '` found.  Did you forget to import it and `cytoscape.use()` it?');
            return;
        }
        var eles;
        if ($e815fda779bc047b$var$string(options.eles)) eles = cy.$(options.eles);
        else eles = options.eles != null ? options.eles : cy.$();
        var layout = new Layout($e815fda779bc047b$var$extend({}, options, {
            cy: cy,
            eles: eles
        }));
        return layout;
    }
};
$e815fda779bc047b$var$corefn$6.createLayout = $e815fda779bc047b$var$corefn$6.makeLayout = $e815fda779bc047b$var$corefn$6.layout;
var $e815fda779bc047b$var$corefn$5 = {
    notify: function notify(eventName, eventEles) {
        var _p = this._private;
        if (this.batching()) {
            _p.batchNotifications = _p.batchNotifications || {};
            var eles = _p.batchNotifications[eventName] = _p.batchNotifications[eventName] || this.collection();
            if (eventEles != null) eles.merge(eventEles);
            return; // notifications are disabled during batching
        }
        if (!_p.notificationsEnabled) return;
         // exit on disabled
        var renderer = this.renderer();
        // exit if destroy() called on core or renderer in between frames #1499 #1528
        if (this.destroyed() || !renderer) return;
        renderer.notify(eventName, eventEles);
    },
    notifications: function notifications(bool) {
        var p = this._private;
        if (bool === undefined) return p.notificationsEnabled;
        else p.notificationsEnabled = bool ? true : false;
        return this;
    },
    noNotifications: function noNotifications(callback) {
        this.notifications(false);
        callback();
        this.notifications(true);
    },
    batching: function batching() {
        return this._private.batchCount > 0;
    },
    startBatch: function startBatch() {
        var _p = this._private;
        if (_p.batchCount == null) _p.batchCount = 0;
        if (_p.batchCount === 0) {
            _p.batchStyleEles = this.collection();
            _p.batchNotifications = {};
        }
        _p.batchCount++;
        return this;
    },
    endBatch: function endBatch() {
        var _p = this._private;
        if (_p.batchCount === 0) return this;
        _p.batchCount--;
        if (_p.batchCount === 0) {
            // update style for dirty eles
            _p.batchStyleEles.updateStyle();
            var renderer = this.renderer();
            // notify the renderer of queued eles and event types
            Object.keys(_p.batchNotifications).forEach(function(eventName) {
                var eles = _p.batchNotifications[eventName];
                if (eles.empty()) renderer.notify(eventName);
                else renderer.notify(eventName, eles);
            });
        }
        return this;
    },
    batch: function batch(callback) {
        this.startBatch();
        callback();
        this.endBatch();
        return this;
    },
    // for backwards compatibility
    batchData: function batchData(map) {
        var cy = this;
        return this.batch(function() {
            var ids = Object.keys(map);
            for(var i = 0; i < ids.length; i++){
                var id = ids[i];
                var data = map[id];
                var ele = cy.getElementById(id);
                ele.data(data);
            }
        });
    }
};
var $e815fda779bc047b$var$rendererDefaults = $e815fda779bc047b$var$defaults$g({
    hideEdgesOnViewport: false,
    textureOnViewport: false,
    motionBlur: false,
    motionBlurOpacity: 0.05,
    pixelRatio: undefined,
    desktopTapThreshold: 4,
    touchTapThreshold: 8,
    wheelSensitivity: 1,
    debug: false,
    showFps: false
});
var $e815fda779bc047b$var$corefn$4 = {
    renderTo: function renderTo(context, zoom, pan, pxRatio) {
        var r = this._private.renderer;
        r.renderTo(context, zoom, pan, pxRatio);
        return this;
    },
    renderer: function renderer() {
        return this._private.renderer;
    },
    forceRender: function forceRender() {
        this.notify('draw');
        return this;
    },
    resize: function resize() {
        this.invalidateSize();
        this.emitAndNotify('resize');
        return this;
    },
    initRenderer: function initRenderer(options) {
        var cy = this;
        var RendererProto = cy.extension('renderer', options.name);
        if (RendererProto == null) {
            $e815fda779bc047b$var$error("Can not initialise: No such renderer `".concat(options.name, "` found. Did you forget to import it and `cytoscape.use()` it?"));
            return;
        }
        if (options.wheelSensitivity !== undefined) $e815fda779bc047b$var$warn("You have set a custom wheel sensitivity.  This will make your app zoom unnaturally when using mainstream mice.  You should change this value from the default only if you can guarantee that all your users will use the same hardware and OS configuration as your current machine.");
        var rOpts = $e815fda779bc047b$var$rendererDefaults(options);
        rOpts.cy = cy;
        cy._private.renderer = new RendererProto(rOpts);
        this.notify('init');
    },
    destroyRenderer: function destroyRenderer() {
        var cy = this;
        cy.notify('destroy'); // destroy the renderer
        var domEle = cy.container();
        if (domEle) {
            domEle._cyreg = null;
            while(domEle.childNodes.length > 0)domEle.removeChild(domEle.childNodes[0]);
        }
        cy._private.renderer = null; // to be extra safe, remove the ref
        cy.mutableElements().forEach(function(ele) {
            var _p = ele._private;
            _p.rscratch = {};
            _p.rstyle = {};
            _p.animation.current = [];
            _p.animation.queue = [];
        });
    },
    onRender: function onRender(fn) {
        return this.on('render', fn);
    },
    offRender: function offRender(fn) {
        return this.off('render', fn);
    }
};
$e815fda779bc047b$var$corefn$4.invalidateDimensions = $e815fda779bc047b$var$corefn$4.resize;
var $e815fda779bc047b$var$corefn$3 = {
    // get a collection
    // - empty collection on no args
    // - collection of elements in the graph on selector arg
    // - guarantee a returned collection when elements or collection specified
    collection: function collection(eles, opts) {
        if ($e815fda779bc047b$var$string(eles)) return this.$(eles);
        else if ($e815fda779bc047b$var$elementOrCollection(eles)) return eles.collection();
        else if ($e815fda779bc047b$var$array(eles)) {
            if (!opts) opts = {};
            return new $e815fda779bc047b$var$Collection(this, eles, opts.unique, opts.removed);
        }
        return new $e815fda779bc047b$var$Collection(this);
    },
    nodes: function nodes(selector) {
        var nodes = this.$(function(ele) {
            return ele.isNode();
        });
        if (selector) return nodes.filter(selector);
        return nodes;
    },
    edges: function edges(selector) {
        var edges = this.$(function(ele) {
            return ele.isEdge();
        });
        if (selector) return edges.filter(selector);
        return edges;
    },
    // search the graph like jQuery
    $: function $(selector) {
        var eles = this._private.elements;
        if (selector) return eles.filter(selector);
        else return eles.spawnSelf();
    },
    mutableElements: function mutableElements() {
        return this._private.elements;
    }
};
// aliases
$e815fda779bc047b$var$corefn$3.elements = $e815fda779bc047b$var$corefn$3.filter = $e815fda779bc047b$var$corefn$3.$;
var $e815fda779bc047b$var$styfn$8 = {};
// keys for style blocks, e.g. ttfftt
var $e815fda779bc047b$var$TRUE = 't';
var $e815fda779bc047b$var$FALSE = 'f';
// (potentially expensive calculation)
// apply the style to the element based on
// - its bypass
// - what selectors match it
$e815fda779bc047b$var$styfn$8.apply = function(eles) {
    var self1 = this;
    var _p = self1._private;
    var cy = _p.cy;
    var updatedEles = cy.collection();
    for(var ie = 0; ie < eles.length; ie++){
        var ele = eles[ie];
        var cxtMeta = self1.getContextMeta(ele);
        if (cxtMeta.empty) continue;
        var cxtStyle = self1.getContextStyle(cxtMeta);
        var app = self1.applyContextStyle(cxtMeta, cxtStyle, ele);
        if (ele._private.appliedInitStyle) self1.updateTransitions(ele, app.diffProps);
        else ele._private.appliedInitStyle = true;
        var hintsDiff = self1.updateStyleHints(ele);
        if (hintsDiff) updatedEles.push(ele);
    } // for elements
    return updatedEles;
};
$e815fda779bc047b$var$styfn$8.getPropertiesDiff = function(oldCxtKey, newCxtKey) {
    var self1 = this;
    var cache = self1._private.propDiffs = self1._private.propDiffs || {};
    var dualCxtKey = oldCxtKey + '-' + newCxtKey;
    var cachedVal = cache[dualCxtKey];
    if (cachedVal) return cachedVal;
    var diffProps = [];
    var addedProp = {};
    for(var i = 0; i < self1.length; i++){
        var cxt = self1[i];
        var oldHasCxt = oldCxtKey[i] === $e815fda779bc047b$var$TRUE;
        var newHasCxt = newCxtKey[i] === $e815fda779bc047b$var$TRUE;
        var cxtHasDiffed = oldHasCxt !== newHasCxt;
        var cxtHasMappedProps = cxt.mappedProperties.length > 0;
        if (cxtHasDiffed || newHasCxt && cxtHasMappedProps) {
            var props = void 0;
            if (cxtHasDiffed && cxtHasMappedProps) props = cxt.properties; // suffices b/c mappedProperties is a subset of properties
            else if (cxtHasDiffed) props = cxt.properties; // need to check them all
            else if (cxtHasMappedProps) props = cxt.mappedProperties; // only need to check mapped
            for(var j = 0; j < props.length; j++){
                var prop = props[j];
                var name = prop.name;
                // if a later context overrides this property, then the fact that this context has switched/diffed doesn't matter
                // (semi expensive check since it makes this function O(n^2) on context length, but worth it since overall result
                // is cached)
                var laterCxtOverrides = false;
                for(var k = i + 1; k < self1.length; k++){
                    var laterCxt = self1[k];
                    var hasLaterCxt = newCxtKey[k] === $e815fda779bc047b$var$TRUE;
                    if (!hasLaterCxt) continue;
                     // can't override unless the context is active
                    laterCxtOverrides = laterCxt.properties[prop.name] != null;
                    if (laterCxtOverrides) break;
                     // exit early as long as one later context overrides
                }
                if (!addedProp[name] && !laterCxtOverrides) {
                    addedProp[name] = true;
                    diffProps.push(name);
                }
            } // for props
        } // if
    } // for contexts
    cache[dualCxtKey] = diffProps;
    return diffProps;
};
$e815fda779bc047b$var$styfn$8.getContextMeta = function(ele) {
    var self1 = this;
    var cxtKey = '';
    var diffProps;
    var prevKey = ele._private.styleCxtKey || '';
    // get the cxt key
    for(var i = 0; i < self1.length; i++){
        var context = self1[i];
        var contextSelectorMatches = context.selector && context.selector.matches(ele); // NB: context.selector may be null for 'core'
        if (contextSelectorMatches) cxtKey += $e815fda779bc047b$var$TRUE;
        else cxtKey += $e815fda779bc047b$var$FALSE;
    } // for context
    diffProps = self1.getPropertiesDiff(prevKey, cxtKey);
    ele._private.styleCxtKey = cxtKey;
    return {
        key: cxtKey,
        diffPropNames: diffProps,
        empty: diffProps.length === 0
    };
};
// gets a computed ele style object based on matched contexts
$e815fda779bc047b$var$styfn$8.getContextStyle = function(cxtMeta) {
    var cxtKey = cxtMeta.key;
    var self1 = this;
    var cxtStyles = this._private.contextStyles = this._private.contextStyles || {};
    // if already computed style, returned cached copy
    if (cxtStyles[cxtKey]) return cxtStyles[cxtKey];
    var style = {
        _private: {
            key: cxtKey
        }
    };
    for(var i = 0; i < self1.length; i++){
        var cxt = self1[i];
        var hasCxt = cxtKey[i] === $e815fda779bc047b$var$TRUE;
        if (!hasCxt) continue;
        for(var j = 0; j < cxt.properties.length; j++){
            var prop = cxt.properties[j];
            style[prop.name] = prop;
        }
    }
    cxtStyles[cxtKey] = style;
    return style;
};
$e815fda779bc047b$var$styfn$8.applyContextStyle = function(cxtMeta, cxtStyle, ele) {
    var self1 = this;
    var diffProps = cxtMeta.diffPropNames;
    var retDiffProps = {};
    var types = self1.types;
    for(var i = 0; i < diffProps.length; i++){
        var diffPropName = diffProps[i];
        var cxtProp = cxtStyle[diffPropName];
        var eleProp = ele.pstyle(diffPropName);
        if (!cxtProp) {
            // no context prop means delete
            if (!eleProp) continue; // no existing prop means nothing needs to be removed
            else if (eleProp.bypass) cxtProp = {
                name: diffPropName,
                deleteBypassed: true
            };
            else cxtProp = {
                name: diffPropName,
                "delete": true
            };
        }
        // save cycles when the context prop doesn't need to be applied
        if (eleProp === cxtProp) continue;
        // save cycles when a mapped context prop doesn't need to be applied
        if (cxtProp.mapped === types.fn // context prop is function mapper
         && eleProp != null // some props can be null even by default (e.g. a prop that overrides another one)
         && eleProp.mapping != null // ele prop is a concrete value from from a mapper
         && eleProp.mapping.value === cxtProp.value // the current prop on the ele is a flat prop value for the function mapper
        ) {
            // NB don't write to cxtProp, as it's shared among eles (stored in stylesheet)
            var mapping = eleProp.mapping; // can write to mapping, as it's a per-ele copy
            var fnValue = mapping.fnValue = cxtProp.value(ele); // temporarily cache the value in case of a miss
            if (fnValue === mapping.prevFnValue) continue;
        }
        var retDiffProp = retDiffProps[diffPropName] = {
            prev: eleProp
        };
        self1.applyParsedProperty(ele, cxtProp);
        retDiffProp.next = ele.pstyle(diffPropName);
        if (retDiffProp.next && retDiffProp.next.bypass) retDiffProp.next = retDiffProp.next.bypassed;
    }
    return {
        diffProps: retDiffProps
    };
};
$e815fda779bc047b$var$styfn$8.updateStyleHints = function(ele) {
    var _p = ele._private;
    var self1 = this;
    var propNames = self1.propertyGroupNames;
    var propGrKeys = self1.propertyGroupKeys;
    var propHash = function propHash(ele, propNames, seedKey) {
        return self1.getPropertiesHash(ele, propNames, seedKey);
    };
    var oldStyleKey = _p.styleKey;
    if (ele.removed()) return false;
    var isNode = _p.group === 'nodes';
    // get the style key hashes per prop group
    // but lazily -- only use non-default prop values to reduce the number of hashes
    //
    var overriddenStyles = ele._private.style;
    propNames = Object.keys(overriddenStyles);
    for(var i = 0; i < propGrKeys.length; i++){
        var grKey = propGrKeys[i];
        _p.styleKeys[grKey] = [
            $e815fda779bc047b$var$DEFAULT_HASH_SEED,
            $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT
        ];
    }
    var updateGrKey1 = function updateGrKey1(val, grKey) {
        return _p.styleKeys[grKey][0] = $e815fda779bc047b$var$hashInt(val, _p.styleKeys[grKey][0]);
    };
    var updateGrKey2 = function updateGrKey2(val, grKey) {
        return _p.styleKeys[grKey][1] = $e815fda779bc047b$var$hashIntAlt(val, _p.styleKeys[grKey][1]);
    };
    var updateGrKey = function updateGrKey(val, grKey) {
        updateGrKey1(val, grKey);
        updateGrKey2(val, grKey);
    };
    var updateGrKeyWStr = function updateGrKeyWStr(strVal, grKey) {
        for(var j = 0; j < strVal.length; j++){
            var ch = strVal.charCodeAt(j);
            updateGrKey1(ch, grKey);
            updateGrKey2(ch, grKey);
        }
    };
    // - hashing works on 32 bit ints b/c we use bitwise ops
    // - small numbers get cut off (e.g. 0.123 is seen as 0 by the hashing function)
    // - raise up small numbers so more significant digits are seen by hashing
    // - make small numbers larger than a normal value to avoid collisions
    // - works in practice and it's relatively cheap
    var N = 2000000000;
    var cleanNum = function cleanNum(val) {
        return -128 < val && val < 128 && Math.floor(val) !== val ? N - (val * 1024 | 0) : val;
    };
    for(var _i = 0; _i < propNames.length; _i++){
        var name = propNames[_i];
        var parsedProp = overriddenStyles[name];
        if (parsedProp == null) continue;
        var propInfo = this.properties[name];
        var type = propInfo.type;
        var _grKey = propInfo.groupKey;
        var normalizedNumberVal = void 0;
        if (propInfo.hashOverride != null) normalizedNumberVal = propInfo.hashOverride(ele, parsedProp);
        else if (parsedProp.pfValue != null) normalizedNumberVal = parsedProp.pfValue;
        // might not be a number if it allows enums
        var numberVal = propInfo.enums == null ? parsedProp.value : null;
        var haveNormNum = normalizedNumberVal != null;
        var haveUnitedNum = numberVal != null;
        var haveNum = haveNormNum || haveUnitedNum;
        var units = parsedProp.units;
        // numbers are cheaper to hash than strings
        // 1 hash op vs n hash ops (for length n string)
        if (type.number && haveNum && !type.multiple) {
            var v = haveNormNum ? normalizedNumberVal : numberVal;
            updateGrKey(cleanNum(v), _grKey);
            if (!haveNormNum && units != null) updateGrKeyWStr(units, _grKey);
        } else updateGrKeyWStr(parsedProp.strValue, _grKey);
    }
    // overall style key
    //
    var hash = [
        $e815fda779bc047b$var$DEFAULT_HASH_SEED,
        $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT
    ];
    for(var _i2 = 0; _i2 < propGrKeys.length; _i2++){
        var _grKey2 = propGrKeys[_i2];
        var grHash = _p.styleKeys[_grKey2];
        hash[0] = $e815fda779bc047b$var$hashInt(grHash[0], hash[0]);
        hash[1] = $e815fda779bc047b$var$hashIntAlt(grHash[1], hash[1]);
    }
    _p.styleKey = $e815fda779bc047b$var$combineHashes(hash[0], hash[1]);
    // label dims
    //
    var sk = _p.styleKeys;
    _p.labelDimsKey = $e815fda779bc047b$var$combineHashesArray(sk.labelDimensions);
    var labelKeys = propHash(ele, [
        'label'
    ], sk.labelDimensions);
    _p.labelKey = $e815fda779bc047b$var$combineHashesArray(labelKeys);
    _p.labelStyleKey = $e815fda779bc047b$var$combineHashesArray($e815fda779bc047b$var$hashArrays(sk.commonLabel, labelKeys));
    if (!isNode) {
        var sourceLabelKeys = propHash(ele, [
            'source-label'
        ], sk.labelDimensions);
        _p.sourceLabelKey = $e815fda779bc047b$var$combineHashesArray(sourceLabelKeys);
        _p.sourceLabelStyleKey = $e815fda779bc047b$var$combineHashesArray($e815fda779bc047b$var$hashArrays(sk.commonLabel, sourceLabelKeys));
        var targetLabelKeys = propHash(ele, [
            'target-label'
        ], sk.labelDimensions);
        _p.targetLabelKey = $e815fda779bc047b$var$combineHashesArray(targetLabelKeys);
        _p.targetLabelStyleKey = $e815fda779bc047b$var$combineHashesArray($e815fda779bc047b$var$hashArrays(sk.commonLabel, targetLabelKeys));
    }
    // node
    //
    if (isNode) {
        var _p$styleKeys = _p.styleKeys, nodeBody = _p$styleKeys.nodeBody, nodeBorder = _p$styleKeys.nodeBorder, nodeOutline = _p$styleKeys.nodeOutline, backgroundImage = _p$styleKeys.backgroundImage, compound = _p$styleKeys.compound, pie = _p$styleKeys.pie;
        var nodeKeys = [
            nodeBody,
            nodeBorder,
            nodeOutline,
            backgroundImage,
            compound,
            pie
        ].filter(function(k) {
            return k != null;
        }).reduce($e815fda779bc047b$var$hashArrays, [
            $e815fda779bc047b$var$DEFAULT_HASH_SEED,
            $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT
        ]);
        _p.nodeKey = $e815fda779bc047b$var$combineHashesArray(nodeKeys);
        _p.hasPie = pie != null && pie[0] !== $e815fda779bc047b$var$DEFAULT_HASH_SEED && pie[1] !== $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT;
    }
    return oldStyleKey !== _p.styleKey;
};
$e815fda779bc047b$var$styfn$8.clearStyleHints = function(ele) {
    var _p = ele._private;
    _p.styleCxtKey = '';
    _p.styleKeys = {};
    _p.styleKey = null;
    _p.labelKey = null;
    _p.labelStyleKey = null;
    _p.sourceLabelKey = null;
    _p.sourceLabelStyleKey = null;
    _p.targetLabelKey = null;
    _p.targetLabelStyleKey = null;
    _p.nodeKey = null;
    _p.hasPie = null;
};
// apply a property to the style (for internal use)
// returns whether application was successful
//
// now, this function flattens the property, and here's how:
//
// for parsedProp:{ bypass: true, deleteBypass: true }
// no property is generated, instead the bypass property in the
// element's style is replaced by what's pointed to by the `bypassed`
// field in the bypass property (i.e. restoring the property the
// bypass was overriding)
//
// for parsedProp:{ mapped: truthy }
// the generated flattenedProp:{ mapping: prop }
//
// for parsedProp:{ bypass: true }
// the generated flattenedProp:{ bypassed: parsedProp }
$e815fda779bc047b$var$styfn$8.applyParsedProperty = function(ele, parsedProp) {
    var self1 = this;
    var prop = parsedProp;
    var style = ele._private.style;
    var flatProp;
    var types = self1.types;
    var type = self1.properties[prop.name].type;
    var propIsBypass = prop.bypass;
    var origProp = style[prop.name];
    var origPropIsBypass = origProp && origProp.bypass;
    var _p = ele._private;
    var flatPropMapping = 'mapping';
    var getVal = function getVal(p) {
        if (p == null) return null;
        else if (p.pfValue != null) return p.pfValue;
        else return p.value;
    };
    var checkTriggers = function checkTriggers() {
        var fromVal = getVal(origProp);
        var toVal = getVal(prop);
        self1.checkTriggers(ele, prop.name, fromVal, toVal);
    };
    // edge sanity checks to prevent the client from making serious mistakes
    if (parsedProp.name === 'curve-style' && ele.isEdge() && // loops must be bundled beziers
    (parsedProp.value !== 'bezier' && ele.isLoop() || // edges connected to compound nodes can not be haystacks
    parsedProp.value === 'haystack' && (ele.source().isParent() || ele.target().isParent()))) prop = parsedProp = this.parse(parsedProp.name, 'bezier', propIsBypass);
    if (prop["delete"]) {
        // delete the property and use the default value on falsey value
        style[prop.name] = undefined;
        checkTriggers();
        return true;
    }
    if (prop.deleteBypassed) {
        // delete the property that the
        if (!origProp) {
            checkTriggers();
            return true; // can't delete if no prop
        } else if (origProp.bypass) {
            // delete bypassed
            origProp.bypassed = undefined;
            checkTriggers();
            return true;
        } else return false; // we're unsuccessful deleting the bypassed
    }
    // check if we need to delete the current bypass
    if (prop.deleteBypass) {
        // then this property is just here to indicate we need to delete
        if (!origProp) {
            checkTriggers();
            return true; // property is already not defined
        } else if (origProp.bypass) {
            // then replace the bypass property with the original
            // because the bypassed property was already applied (and therefore parsed), we can just replace it (no reapplying necessary)
            style[prop.name] = origProp.bypassed;
            checkTriggers();
            return true;
        } else return false; // we're unsuccessful deleting the bypass
    }
    var printMappingErr = function printMappingErr() {
        $e815fda779bc047b$var$warn('Do not assign mappings to elements without corresponding data (i.e. ele `' + ele.id() + '` has no mapping for property `' + prop.name + '` with data field `' + prop.field + '`); try a `[' + prop.field + ']` selector to limit scope to elements with `' + prop.field + '` defined');
    };
    // put the property in the style objects
    switch(prop.mapped){
        // flatten the property if mapped
        case types.mapData:
            // flatten the field (e.g. data.foo.bar)
            var fields = prop.field.split('.');
            var fieldVal = _p.data;
            for(var i = 0; i < fields.length && fieldVal; i++){
                var field = fields[i];
                fieldVal = fieldVal[field];
            }
            if (fieldVal == null) {
                printMappingErr();
                return false;
            }
            var percent;
            if (!$e815fda779bc047b$var$number$1(fieldVal)) {
                // then don't apply and fall back on the existing style
                $e815fda779bc047b$var$warn('Do not use continuous mappers without specifying numeric data (i.e. `' + prop.field + ': ' + fieldVal + '` for `' + ele.id() + '` is non-numeric)');
                return false;
            } else {
                var fieldWidth = prop.fieldMax - prop.fieldMin;
                if (fieldWidth === 0) // safety check -- not strictly necessary as no props of zero range should be passed here
                percent = 0;
                else percent = (fieldVal - prop.fieldMin) / fieldWidth;
            }
            // make sure to bound percent value
            if (percent < 0) percent = 0;
            else if (percent > 1) percent = 1;
            if (type.color) {
                var r1 = prop.valueMin[0];
                var r2 = prop.valueMax[0];
                var g1 = prop.valueMin[1];
                var g2 = prop.valueMax[1];
                var b1 = prop.valueMin[2];
                var b2 = prop.valueMax[2];
                var a1 = prop.valueMin[3] == null ? 1 : prop.valueMin[3];
                var a2 = prop.valueMax[3] == null ? 1 : prop.valueMax[3];
                var clr = [
                    Math.round(r1 + (r2 - r1) * percent),
                    Math.round(g1 + (g2 - g1) * percent),
                    Math.round(b1 + (b2 - b1) * percent),
                    Math.round(a1 + (a2 - a1) * percent)
                ];
                flatProp = {
                    // colours are simple, so just create the flat property instead of expensive string parsing
                    bypass: prop.bypass,
                    // we're a bypass if the mapping property is a bypass
                    name: prop.name,
                    value: clr,
                    strValue: 'rgb(' + clr[0] + ', ' + clr[1] + ', ' + clr[2] + ')'
                };
            } else if (type.number) {
                var calcValue = prop.valueMin + (prop.valueMax - prop.valueMin) * percent;
                flatProp = this.parse(prop.name, calcValue, prop.bypass, flatPropMapping);
            } else return false; // can only map to colours and numbers
            if (!flatProp) {
                // if we can't flatten the property, then don't apply the property and fall back on the existing style
                printMappingErr();
                return false;
            }
            flatProp.mapping = prop; // keep a reference to the mapping
            prop = flatProp; // the flattened (mapped) property is the one we want
            break;
        // direct mapping
        case types.data:
            // flatten the field (e.g. data.foo.bar)
            var _fields = prop.field.split('.');
            var _fieldVal = _p.data;
            for(var _i3 = 0; _i3 < _fields.length && _fieldVal; _i3++){
                var _field = _fields[_i3];
                _fieldVal = _fieldVal[_field];
            }
            if (_fieldVal != null) flatProp = this.parse(prop.name, _fieldVal, prop.bypass, flatPropMapping);
            if (!flatProp) {
                // if we can't flatten the property, then don't apply and fall back on the existing style
                printMappingErr();
                return false;
            }
            flatProp.mapping = prop; // keep a reference to the mapping
            prop = flatProp; // the flattened (mapped) property is the one we want
            break;
        case types.fn:
            var fn = prop.value;
            var fnRetVal = prop.fnValue != null ? prop.fnValue : fn(ele); // check for cached value before calling function
            prop.prevFnValue = fnRetVal;
            if (fnRetVal == null) {
                $e815fda779bc047b$var$warn('Custom function mappers may not return null (i.e. `' + prop.name + '` for ele `' + ele.id() + '` is null)');
                return false;
            }
            flatProp = this.parse(prop.name, fnRetVal, prop.bypass, flatPropMapping);
            if (!flatProp) {
                $e815fda779bc047b$var$warn('Custom function mappers may not return invalid values for the property type (i.e. `' + prop.name + '` for ele `' + ele.id() + '` is invalid)');
                return false;
            }
            flatProp.mapping = $e815fda779bc047b$var$copy(prop); // keep a reference to the mapping
            prop = flatProp; // the flattened (mapped) property is the one we want
            break;
        case undefined:
            break;
        // just set the property
        default:
            return false;
    }
    // if the property is a bypass property, then link the resultant property to the original one
    if (propIsBypass) {
        if (origPropIsBypass) // then this bypass overrides the existing one
        prop.bypassed = origProp.bypassed; // steal bypassed prop from old bypass
        else // then link the orig prop to the new bypass
        prop.bypassed = origProp;
        style[prop.name] = prop; // and set
    } else // prop is not bypass
    if (origPropIsBypass) // then keep the orig prop (since it's a bypass) and link to the new prop
    origProp.bypassed = prop;
    else // then just replace the old prop with the new one
    style[prop.name] = prop;
    checkTriggers();
    return true;
};
$e815fda779bc047b$var$styfn$8.cleanElements = function(eles, keepBypasses) {
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        this.clearStyleHints(ele);
        ele.dirtyCompoundBoundsCache();
        ele.dirtyBoundingBoxCache();
        if (!keepBypasses) ele._private.style = {};
        else {
            var style = ele._private.style;
            var propNames = Object.keys(style);
            for(var j = 0; j < propNames.length; j++){
                var propName = propNames[j];
                var eleProp = style[propName];
                if (eleProp != null) {
                    if (eleProp.bypass) eleProp.bypassed = null;
                    else style[propName] = null;
                }
            }
        }
    }
};
// updates the visual style for all elements (useful for manual style modification after init)
$e815fda779bc047b$var$styfn$8.update = function() {
    var cy = this._private.cy;
    var eles = cy.mutableElements();
    eles.updateStyle();
};
// diffProps : { name => { prev, next } }
$e815fda779bc047b$var$styfn$8.updateTransitions = function(ele, diffProps) {
    var self1 = this;
    var _p = ele._private;
    var props = ele.pstyle('transition-property').value;
    var duration = ele.pstyle('transition-duration').pfValue;
    var delay = ele.pstyle('transition-delay').pfValue;
    if (props.length > 0 && duration > 0) {
        var style = {};
        // build up the style to animate towards
        var anyPrev = false;
        for(var i = 0; i < props.length; i++){
            var prop = props[i];
            var styProp = ele.pstyle(prop);
            var diffProp = diffProps[prop];
            if (!diffProp) continue;
            var prevProp = diffProp.prev;
            var fromProp = prevProp;
            var toProp = diffProp.next != null ? diffProp.next : styProp;
            var diff = false;
            var initVal = void 0;
            var initDt = 0.000001; // delta time % value for initVal (allows animating out of init zero opacity)
            if (!fromProp) continue;
            // consider px values
            if ($e815fda779bc047b$var$number$1(fromProp.pfValue) && $e815fda779bc047b$var$number$1(toProp.pfValue)) {
                diff = toProp.pfValue - fromProp.pfValue; // nonzero is truthy
                initVal = fromProp.pfValue + initDt * diff;
            // consider numerical values
            } else if ($e815fda779bc047b$var$number$1(fromProp.value) && $e815fda779bc047b$var$number$1(toProp.value)) {
                diff = toProp.value - fromProp.value; // nonzero is truthy
                initVal = fromProp.value + initDt * diff;
            // consider colour values
            } else if ($e815fda779bc047b$var$array(fromProp.value) && $e815fda779bc047b$var$array(toProp.value)) {
                diff = fromProp.value[0] !== toProp.value[0] || fromProp.value[1] !== toProp.value[1] || fromProp.value[2] !== toProp.value[2];
                initVal = fromProp.strValue;
            }
            // the previous value is good for an animation only if it's different
            if (diff) {
                style[prop] = toProp.strValue; // to val
                this.applyBypass(ele, prop, initVal); // from val
                anyPrev = true;
            }
        } // end if props allow ani
        // can't transition if there's nothing previous to transition from
        if (!anyPrev) return;
        _p.transitioning = true;
        new $e815fda779bc047b$var$Promise$1(function(resolve) {
            if (delay > 0) ele.delayAnimation(delay).play().promise().then(resolve);
            else resolve();
        }).then(function() {
            return ele.animation({
                style: style,
                duration: duration,
                easing: ele.pstyle('transition-timing-function').value,
                queue: false
            }).play().promise();
        }).then(function() {
            // if( !isBypass ){
            self1.removeBypasses(ele, props);
            ele.emitAndNotify('style');
            // }
            _p.transitioning = false;
        });
    } else if (_p.transitioning) {
        this.removeBypasses(ele, props);
        ele.emitAndNotify('style');
        _p.transitioning = false;
    }
};
$e815fda779bc047b$var$styfn$8.checkTrigger = function(ele, name, fromValue, toValue, getTrigger, onTrigger) {
    var prop = this.properties[name];
    var triggerCheck = getTrigger(prop);
    if (triggerCheck != null && triggerCheck(fromValue, toValue)) onTrigger(prop);
};
$e815fda779bc047b$var$styfn$8.checkZOrderTrigger = function(ele, name, fromValue, toValue) {
    var _this = this;
    this.checkTrigger(ele, name, fromValue, toValue, function(prop) {
        return prop.triggersZOrder;
    }, function() {
        _this._private.cy.notify('zorder', ele);
    });
};
$e815fda779bc047b$var$styfn$8.checkBoundsTrigger = function(ele, name, fromValue, toValue) {
    this.checkTrigger(ele, name, fromValue, toValue, function(prop) {
        return prop.triggersBounds;
    }, function(prop) {
        ele.dirtyCompoundBoundsCache();
        ele.dirtyBoundingBoxCache();
        // if the prop change makes the bb of pll bezier edges invalid,
        // then dirty the pll edge bb cache as well
        if (// only for beziers -- so performance of other edges isn't affected
        prop.triggersBoundsOfParallelBeziers && name === 'curve-style' && (fromValue === 'bezier' || toValue === 'bezier')) ele.parallelEdges().forEach(function(pllEdge) {
            pllEdge.dirtyBoundingBoxCache();
        });
        if (prop.triggersBoundsOfConnectedEdges && name === 'display' && (fromValue === 'none' || toValue === 'none')) ele.connectedEdges().forEach(function(edge) {
            edge.dirtyBoundingBoxCache();
        });
    });
};
$e815fda779bc047b$var$styfn$8.checkTriggers = function(ele, name, fromValue, toValue) {
    ele.dirtyStyleCache();
    this.checkZOrderTrigger(ele, name, fromValue, toValue);
    this.checkBoundsTrigger(ele, name, fromValue, toValue);
};
var $e815fda779bc047b$var$styfn$7 = {};
// bypasses are applied to an existing style on an element, and just tacked on temporarily
// returns true iff application was successful for at least 1 specified property
$e815fda779bc047b$var$styfn$7.applyBypass = function(eles, name, value, updateTransitions) {
    var self1 = this;
    var props = [];
    var isBypass = true;
    // put all the properties (can specify one or many) in an array after parsing them
    if (name === '*' || name === '**') {
        // apply to all property names
        if (value !== undefined) for(var i = 0; i < self1.properties.length; i++){
            var prop = self1.properties[i];
            var _name = prop.name;
            var parsedProp = this.parse(_name, value, true);
            if (parsedProp) props.push(parsedProp);
        }
    } else if ($e815fda779bc047b$var$string(name)) {
        // then parse the single property
        var _parsedProp = this.parse(name, value, true);
        if (_parsedProp) props.push(_parsedProp);
    } else if ($e815fda779bc047b$var$plainObject(name)) {
        // then parse each property
        var specifiedProps = name;
        updateTransitions = value;
        var names = Object.keys(specifiedProps);
        for(var _i = 0; _i < names.length; _i++){
            var _name2 = names[_i];
            var _value = specifiedProps[_name2];
            if (_value === undefined) // try camel case name too
            _value = specifiedProps[$e815fda779bc047b$var$dash2camel(_name2)];
            if (_value !== undefined) {
                var _parsedProp2 = this.parse(_name2, _value, true);
                if (_parsedProp2) props.push(_parsedProp2);
            }
        }
    } else // can't do anything without well defined properties
    return false;
    // we've failed if there are no valid properties
    if (props.length === 0) return false;
    // now, apply the bypass properties on the elements
    var ret = false; // return true if at least one succesful bypass applied
    for(var _i2 = 0; _i2 < eles.length; _i2++){
        // for each ele
        var ele = eles[_i2];
        var diffProps = {};
        var diffProp = void 0;
        for(var j = 0; j < props.length; j++){
            // for each prop
            var _prop = props[j];
            if (updateTransitions) {
                var prevProp = ele.pstyle(_prop.name);
                diffProp = diffProps[_prop.name] = {
                    prev: prevProp
                };
            }
            ret = this.applyParsedProperty(ele, $e815fda779bc047b$var$copy(_prop)) || ret;
            if (updateTransitions) diffProp.next = ele.pstyle(_prop.name);
        } // for props
        if (ret) this.updateStyleHints(ele);
        if (updateTransitions) this.updateTransitions(ele, diffProps, isBypass);
    } // for eles
    return ret;
};
// only useful in specific cases like animation
$e815fda779bc047b$var$styfn$7.overrideBypass = function(eles, name, value) {
    name = $e815fda779bc047b$var$camel2dash(name);
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var prop = ele._private.style[name];
        var type = this.properties[name].type;
        var isColor = type.color;
        var isMulti = type.mutiple;
        var oldValue = !prop ? null : prop.pfValue != null ? prop.pfValue : prop.value;
        if (!prop || !prop.bypass) // need a bypass if one doesn't exist
        this.applyBypass(ele, name, value);
        else {
            prop.value = value;
            if (prop.pfValue != null) prop.pfValue = value;
            if (isColor) prop.strValue = 'rgb(' + value.join(',') + ')';
            else if (isMulti) prop.strValue = value.join(' ');
            else prop.strValue = '' + value;
            this.updateStyleHints(ele);
        }
        this.checkTriggers(ele, name, oldValue, value);
    }
};
$e815fda779bc047b$var$styfn$7.removeAllBypasses = function(eles, updateTransitions) {
    return this.removeBypasses(eles, this.propertyNames, updateTransitions);
};
$e815fda779bc047b$var$styfn$7.removeBypasses = function(eles, props, updateTransitions) {
    var isBypass = true;
    for(var j = 0; j < eles.length; j++){
        var ele = eles[j];
        var diffProps = {};
        for(var i = 0; i < props.length; i++){
            var name = props[i];
            var prop = this.properties[name];
            var prevProp = ele.pstyle(prop.name);
            if (!prevProp || !prevProp.bypass) continue;
            var value = ''; // empty => remove bypass
            var parsedProp = this.parse(name, value, true);
            var diffProp = diffProps[prop.name] = {
                prev: prevProp
            };
            this.applyParsedProperty(ele, parsedProp);
            diffProp.next = ele.pstyle(prop.name);
        } // for props
        this.updateStyleHints(ele);
        if (updateTransitions) this.updateTransitions(ele, diffProps, isBypass);
    } // for eles
};
var $e815fda779bc047b$var$styfn$6 = {};
// gets what an em size corresponds to in pixels relative to a dom element
$e815fda779bc047b$var$styfn$6.getEmSizeInPixels = function() {
    var px = this.containerCss('font-size');
    if (px != null) return parseFloat(px);
    else return 1; // for headless
};
// gets css property from the core container
$e815fda779bc047b$var$styfn$6.containerCss = function(propName) {
    var cy = this._private.cy;
    var domElement = cy.container();
    var containerWindow = cy.window();
    if (containerWindow && domElement && containerWindow.getComputedStyle) return containerWindow.getComputedStyle(domElement).getPropertyValue(propName);
};
var $e815fda779bc047b$var$styfn$5 = {};
// gets the rendered style for an element
$e815fda779bc047b$var$styfn$5.getRenderedStyle = function(ele, prop) {
    if (prop) return this.getStylePropertyValue(ele, prop, true);
    else return this.getRawStyle(ele, true);
};
// gets the raw style for an element
$e815fda779bc047b$var$styfn$5.getRawStyle = function(ele, isRenderedVal) {
    var self1 = this;
    ele = ele[0]; // insure it's an element
    if (ele) {
        var rstyle = {};
        for(var i = 0; i < self1.properties.length; i++){
            var prop = self1.properties[i];
            var val = self1.getStylePropertyValue(ele, prop.name, isRenderedVal);
            if (val != null) {
                rstyle[prop.name] = val;
                rstyle[$e815fda779bc047b$var$dash2camel(prop.name)] = val;
            }
        }
        return rstyle;
    }
};
$e815fda779bc047b$var$styfn$5.getIndexedStyle = function(ele, property, subproperty, index) {
    var pstyle = ele.pstyle(property)[subproperty][index];
    return pstyle != null ? pstyle : ele.cy().style().getDefaultProperty(property)[subproperty][0];
};
$e815fda779bc047b$var$styfn$5.getStylePropertyValue = function(ele, propName, isRenderedVal) {
    var self1 = this;
    ele = ele[0]; // insure it's an element
    if (ele) {
        var prop = self1.properties[propName];
        if (prop.alias) prop = prop.pointsTo;
        var type = prop.type;
        var styleProp = ele.pstyle(prop.name);
        if (styleProp) {
            var value = styleProp.value, units = styleProp.units, strValue = styleProp.strValue;
            if (isRenderedVal && type.number && value != null && $e815fda779bc047b$var$number$1(value)) {
                var zoom = ele.cy().zoom();
                var getRenderedValue = function getRenderedValue(val) {
                    return val * zoom;
                };
                var getValueStringWithUnits = function getValueStringWithUnits(val, units) {
                    return getRenderedValue(val) + units;
                };
                var isArrayValue = $e815fda779bc047b$var$array(value);
                var haveUnits = isArrayValue ? units.every(function(u) {
                    return u != null;
                }) : units != null;
                if (haveUnits) {
                    if (isArrayValue) return value.map(function(v, i) {
                        return getValueStringWithUnits(v, units[i]);
                    }).join(' ');
                    else return getValueStringWithUnits(value, units);
                } else {
                    if (isArrayValue) return value.map(function(v) {
                        return $e815fda779bc047b$var$string(v) ? v : '' + getRenderedValue(v);
                    }).join(' ');
                    else return '' + getRenderedValue(value);
                }
            } else if (strValue != null) return strValue;
        }
        return null;
    }
};
$e815fda779bc047b$var$styfn$5.getAnimationStartStyle = function(ele, aniProps) {
    var rstyle = {};
    for(var i = 0; i < aniProps.length; i++){
        var aniProp = aniProps[i];
        var name = aniProp.name;
        var styleProp = ele.pstyle(name);
        if (styleProp !== undefined) {
            // then make a prop of it
            if ($e815fda779bc047b$var$plainObject(styleProp)) styleProp = this.parse(name, styleProp.strValue);
            else styleProp = this.parse(name, styleProp);
        }
        if (styleProp) rstyle[name] = styleProp;
    }
    return rstyle;
};
$e815fda779bc047b$var$styfn$5.getPropsList = function(propsObj) {
    var self1 = this;
    var rstyle = [];
    var style = propsObj;
    var props = self1.properties;
    if (style) {
        var names = Object.keys(style);
        for(var i = 0; i < names.length; i++){
            var name = names[i];
            var val = style[name];
            var prop = props[name] || props[$e815fda779bc047b$var$camel2dash(name)];
            var styleProp = this.parse(prop.name, val);
            if (styleProp) rstyle.push(styleProp);
        }
    }
    return rstyle;
};
$e815fda779bc047b$var$styfn$5.getNonDefaultPropertiesHash = function(ele, propNames, seed) {
    var hash = seed.slice();
    var name, val, strVal, chVal;
    var i, j;
    for(i = 0; i < propNames.length; i++){
        name = propNames[i];
        val = ele.pstyle(name, false);
        if (val == null) continue;
        else if (val.pfValue != null) {
            hash[0] = $e815fda779bc047b$var$hashInt(chVal, hash[0]);
            hash[1] = $e815fda779bc047b$var$hashIntAlt(chVal, hash[1]);
        } else {
            strVal = val.strValue;
            for(j = 0; j < strVal.length; j++){
                chVal = strVal.charCodeAt(j);
                hash[0] = $e815fda779bc047b$var$hashInt(chVal, hash[0]);
                hash[1] = $e815fda779bc047b$var$hashIntAlt(chVal, hash[1]);
            }
        }
    }
    return hash;
};
$e815fda779bc047b$var$styfn$5.getPropertiesHash = $e815fda779bc047b$var$styfn$5.getNonDefaultPropertiesHash;
var $e815fda779bc047b$var$styfn$4 = {};
$e815fda779bc047b$var$styfn$4.appendFromJson = function(json) {
    var style = this;
    for(var i = 0; i < json.length; i++){
        var context = json[i];
        var selector = context.selector;
        var props = context.style || context.css;
        var names = Object.keys(props);
        style.selector(selector); // apply selector
        for(var j = 0; j < names.length; j++){
            var name = names[j];
            var value = props[name];
            style.css(name, value); // apply property
        }
    }
    return style;
};
// accessible cy.style() function
$e815fda779bc047b$var$styfn$4.fromJson = function(json) {
    var style = this;
    style.resetToDefault();
    style.appendFromJson(json);
    return style;
};
// get json from cy.style() api
$e815fda779bc047b$var$styfn$4.json = function() {
    var json = [];
    for(var i = this.defaultLength; i < this.length; i++){
        var cxt = this[i];
        var selector = cxt.selector;
        var props = cxt.properties;
        var css = {};
        for(var j = 0; j < props.length; j++){
            var prop = props[j];
            css[prop.name] = prop.strValue;
        }
        json.push({
            selector: !selector ? 'core' : selector.toString(),
            style: css
        });
    }
    return json;
};
var $e815fda779bc047b$var$styfn$3 = {};
$e815fda779bc047b$var$styfn$3.appendFromString = function(string) {
    var self1 = this;
    var style = this;
    var remaining = '' + string;
    var selAndBlockStr;
    var blockRem;
    var propAndValStr;
    // remove comments from the style string
    remaining = remaining.replace(/[/][*](\s|.)+?[*][/]/g, '');
    function removeSelAndBlockFromRemaining() {
        // remove the parsed selector and block from the remaining text to parse
        if (remaining.length > selAndBlockStr.length) remaining = remaining.substr(selAndBlockStr.length);
        else remaining = '';
    }
    function removePropAndValFromRem() {
        // remove the parsed property and value from the remaining block text to parse
        if (blockRem.length > propAndValStr.length) blockRem = blockRem.substr(propAndValStr.length);
        else blockRem = '';
    }
    for(;;){
        var nothingLeftToParse = remaining.match(/^\s*$/);
        if (nothingLeftToParse) break;
        var selAndBlock = remaining.match(/^\s*((?:.|\s)+?)\s*\{((?:.|\s)+?)\}/);
        if (!selAndBlock) {
            $e815fda779bc047b$var$warn('Halting stylesheet parsing: String stylesheet contains more to parse but no selector and block found in: ' + remaining);
            break;
        }
        selAndBlockStr = selAndBlock[0];
        // parse the selector
        var selectorStr = selAndBlock[1];
        if (selectorStr !== 'core') {
            var selector = new $e815fda779bc047b$var$Selector(selectorStr);
            if (selector.invalid) {
                $e815fda779bc047b$var$warn('Skipping parsing of block: Invalid selector found in string stylesheet: ' + selectorStr);
                // skip this selector and block
                removeSelAndBlockFromRemaining();
                continue;
            }
        }
        // parse the block of properties and values
        var blockStr = selAndBlock[2];
        var invalidBlock = false;
        blockRem = blockStr;
        var props = [];
        for(;;){
            var _nothingLeftToParse = blockRem.match(/^\s*$/);
            if (_nothingLeftToParse) break;
            var propAndVal = blockRem.match(/^\s*(.+?)\s*:\s*(.+?)(?:\s*;|\s*$)/);
            if (!propAndVal) {
                $e815fda779bc047b$var$warn('Skipping parsing of block: Invalid formatting of style property and value definitions found in:' + blockStr);
                invalidBlock = true;
                break;
            }
            propAndValStr = propAndVal[0];
            var propStr = propAndVal[1];
            var valStr = propAndVal[2];
            var prop = self1.properties[propStr];
            if (!prop) {
                $e815fda779bc047b$var$warn('Skipping property: Invalid property name in: ' + propAndValStr);
                // skip this property in the block
                removePropAndValFromRem();
                continue;
            }
            var parsedProp = style.parse(propStr, valStr);
            if (!parsedProp) {
                $e815fda779bc047b$var$warn('Skipping property: Invalid property definition in: ' + propAndValStr);
                // skip this property in the block
                removePropAndValFromRem();
                continue;
            }
            props.push({
                name: propStr,
                val: valStr
            });
            removePropAndValFromRem();
        }
        if (invalidBlock) {
            removeSelAndBlockFromRemaining();
            break;
        }
        // put the parsed block in the style
        style.selector(selectorStr);
        for(var i = 0; i < props.length; i++){
            var _prop = props[i];
            style.css(_prop.name, _prop.val);
        }
        removeSelAndBlockFromRemaining();
    }
    return style;
};
$e815fda779bc047b$var$styfn$3.fromString = function(string) {
    var style = this;
    style.resetToDefault();
    style.appendFromString(string);
    return style;
};
var $e815fda779bc047b$var$styfn$2 = {};
(function() {
    var number$1 = $e815fda779bc047b$var$number;
    var rgba = $e815fda779bc047b$var$rgbaNoBackRefs;
    var hsla = $e815fda779bc047b$var$hslaNoBackRefs;
    var hex3$1 = $e815fda779bc047b$var$hex3;
    var hex6$1 = $e815fda779bc047b$var$hex6;
    var data = function data(prefix) {
        return '^' + prefix + '\\s*\\(\\s*([\\w\\.]+)\\s*\\)$';
    };
    var mapData = function mapData(prefix) {
        var mapArg = number$1 + '|\\w+|' + rgba + '|' + hsla + '|' + hex3$1 + '|' + hex6$1;
        return '^' + prefix + '\\s*\\(([\\w\\.]+)\\s*\\,\\s*(' + number$1 + ')\\s*\\,\\s*(' + number$1 + ')\\s*,\\s*(' + mapArg + ')\\s*\\,\\s*(' + mapArg + ')\\)$';
    };
    var urlRegexes = [
        '^url\\s*\\(\\s*[\'"]?(.+?)[\'"]?\\s*\\)$',
        '^(none)$',
        '^(.+)$'
    ];
    // each visual style property has a type and needs to be validated according to it
    $e815fda779bc047b$var$styfn$2.types = {
        time: {
            number: true,
            min: 0,
            units: 's|ms',
            implicitUnits: 'ms'
        },
        percent: {
            number: true,
            min: 0,
            max: 100,
            units: '%',
            implicitUnits: '%'
        },
        percentages: {
            number: true,
            min: 0,
            max: 100,
            units: '%',
            implicitUnits: '%',
            multiple: true
        },
        zeroOneNumber: {
            number: true,
            min: 0,
            max: 1,
            unitless: true
        },
        zeroOneNumbers: {
            number: true,
            min: 0,
            max: 1,
            unitless: true,
            multiple: true
        },
        nOneOneNumber: {
            number: true,
            min: -1,
            max: 1,
            unitless: true
        },
        nonNegativeInt: {
            number: true,
            min: 0,
            integer: true,
            unitless: true
        },
        nonNegativeNumber: {
            number: true,
            min: 0,
            unitless: true
        },
        position: {
            enums: [
                'parent',
                'origin'
            ]
        },
        nodeSize: {
            number: true,
            min: 0,
            enums: [
                'label'
            ]
        },
        number: {
            number: true,
            unitless: true
        },
        numbers: {
            number: true,
            unitless: true,
            multiple: true
        },
        positiveNumber: {
            number: true,
            unitless: true,
            min: 0,
            strictMin: true
        },
        size: {
            number: true,
            min: 0
        },
        bidirectionalSize: {
            number: true
        },
        // allows negative
        bidirectionalSizeMaybePercent: {
            number: true,
            allowPercent: true
        },
        // allows negative
        bidirectionalSizes: {
            number: true,
            multiple: true
        },
        // allows negative
        sizeMaybePercent: {
            number: true,
            min: 0,
            allowPercent: true
        },
        axisDirection: {
            enums: [
                'horizontal',
                'leftward',
                'rightward',
                'vertical',
                'upward',
                'downward',
                'auto'
            ]
        },
        paddingRelativeTo: {
            enums: [
                'width',
                'height',
                'average',
                'min',
                'max'
            ]
        },
        bgWH: {
            number: true,
            min: 0,
            allowPercent: true,
            enums: [
                'auto'
            ],
            multiple: true
        },
        bgPos: {
            number: true,
            allowPercent: true,
            multiple: true
        },
        bgRelativeTo: {
            enums: [
                'inner',
                'include-padding'
            ],
            multiple: true
        },
        bgRepeat: {
            enums: [
                'repeat',
                'repeat-x',
                'repeat-y',
                'no-repeat'
            ],
            multiple: true
        },
        bgFit: {
            enums: [
                'none',
                'contain',
                'cover'
            ],
            multiple: true
        },
        bgCrossOrigin: {
            enums: [
                'anonymous',
                'use-credentials',
                'null'
            ],
            multiple: true
        },
        bgClip: {
            enums: [
                'none',
                'node'
            ],
            multiple: true
        },
        bgContainment: {
            enums: [
                'inside',
                'over'
            ],
            multiple: true
        },
        color: {
            color: true
        },
        colors: {
            color: true,
            multiple: true
        },
        fill: {
            enums: [
                'solid',
                'linear-gradient',
                'radial-gradient'
            ]
        },
        bool: {
            enums: [
                'yes',
                'no'
            ]
        },
        bools: {
            enums: [
                'yes',
                'no'
            ],
            multiple: true
        },
        lineStyle: {
            enums: [
                'solid',
                'dotted',
                'dashed'
            ]
        },
        lineCap: {
            enums: [
                'butt',
                'round',
                'square'
            ]
        },
        linePosition: {
            enums: [
                'center',
                'inside',
                'outside'
            ]
        },
        lineJoin: {
            enums: [
                'round',
                'bevel',
                'miter'
            ]
        },
        borderStyle: {
            enums: [
                'solid',
                'dotted',
                'dashed',
                'double'
            ]
        },
        curveStyle: {
            enums: [
                'bezier',
                'unbundled-bezier',
                'haystack',
                'segments',
                'straight',
                'straight-triangle',
                'taxi',
                'round-segments',
                'round-taxi'
            ]
        },
        radiusType: {
            enums: [
                'arc-radius',
                'influence-radius'
            ],
            multiple: true
        },
        fontFamily: {
            regex: '^([\\w- \\"]+(?:\\s*,\\s*[\\w- \\"]+)*)$'
        },
        fontStyle: {
            enums: [
                'italic',
                'normal',
                'oblique'
            ]
        },
        fontWeight: {
            enums: [
                'normal',
                'bold',
                'bolder',
                'lighter',
                '100',
                '200',
                '300',
                '400',
                '500',
                '600',
                '800',
                '900',
                100,
                200,
                300,
                400,
                500,
                600,
                700,
                800,
                900
            ]
        },
        textDecoration: {
            enums: [
                'none',
                'underline',
                'overline',
                'line-through'
            ]
        },
        textTransform: {
            enums: [
                'none',
                'uppercase',
                'lowercase'
            ]
        },
        textWrap: {
            enums: [
                'none',
                'wrap',
                'ellipsis'
            ]
        },
        textOverflowWrap: {
            enums: [
                'whitespace',
                'anywhere'
            ]
        },
        textBackgroundShape: {
            enums: [
                'rectangle',
                'roundrectangle',
                'round-rectangle'
            ]
        },
        nodeShape: {
            enums: [
                'rectangle',
                'roundrectangle',
                'round-rectangle',
                'cutrectangle',
                'cut-rectangle',
                'bottomroundrectangle',
                'bottom-round-rectangle',
                'barrel',
                'ellipse',
                'triangle',
                'round-triangle',
                'square',
                'pentagon',
                'round-pentagon',
                'hexagon',
                'round-hexagon',
                'concavehexagon',
                'concave-hexagon',
                'heptagon',
                'round-heptagon',
                'octagon',
                'round-octagon',
                'tag',
                'round-tag',
                'star',
                'diamond',
                'round-diamond',
                'vee',
                'rhomboid',
                'right-rhomboid',
                'polygon'
            ]
        },
        overlayShape: {
            enums: [
                'roundrectangle',
                'round-rectangle',
                'ellipse'
            ]
        },
        cornerRadius: {
            number: true,
            min: 0,
            units: 'px|em',
            implicitUnits: 'px',
            enums: [
                'auto'
            ]
        },
        compoundIncludeLabels: {
            enums: [
                'include',
                'exclude'
            ]
        },
        arrowShape: {
            enums: [
                'tee',
                'triangle',
                'triangle-tee',
                'circle-triangle',
                'triangle-cross',
                'triangle-backcurve',
                'vee',
                'square',
                'circle',
                'diamond',
                'chevron',
                'none'
            ]
        },
        arrowFill: {
            enums: [
                'filled',
                'hollow'
            ]
        },
        arrowWidth: {
            number: true,
            units: '%|px|em',
            implicitUnits: 'px',
            enums: [
                'match-line'
            ]
        },
        display: {
            enums: [
                'element',
                'none'
            ]
        },
        visibility: {
            enums: [
                'hidden',
                'visible'
            ]
        },
        zCompoundDepth: {
            enums: [
                'bottom',
                'orphan',
                'auto',
                'top'
            ]
        },
        zIndexCompare: {
            enums: [
                'auto',
                'manual'
            ]
        },
        valign: {
            enums: [
                'top',
                'center',
                'bottom'
            ]
        },
        halign: {
            enums: [
                'left',
                'center',
                'right'
            ]
        },
        justification: {
            enums: [
                'left',
                'center',
                'right',
                'auto'
            ]
        },
        text: {
            string: true
        },
        data: {
            mapping: true,
            regex: data('data')
        },
        layoutData: {
            mapping: true,
            regex: data('layoutData')
        },
        scratch: {
            mapping: true,
            regex: data('scratch')
        },
        mapData: {
            mapping: true,
            regex: mapData('mapData')
        },
        mapLayoutData: {
            mapping: true,
            regex: mapData('mapLayoutData')
        },
        mapScratch: {
            mapping: true,
            regex: mapData('mapScratch')
        },
        fn: {
            mapping: true,
            fn: true
        },
        url: {
            regexes: urlRegexes,
            singleRegexMatchValue: true
        },
        urls: {
            regexes: urlRegexes,
            singleRegexMatchValue: true,
            multiple: true
        },
        propList: {
            propList: true
        },
        angle: {
            number: true,
            units: 'deg|rad',
            implicitUnits: 'rad'
        },
        textRotation: {
            number: true,
            units: 'deg|rad',
            implicitUnits: 'rad',
            enums: [
                'none',
                'autorotate'
            ]
        },
        polygonPointList: {
            number: true,
            multiple: true,
            evenMultiple: true,
            min: -1,
            max: 1,
            unitless: true
        },
        edgeDistances: {
            enums: [
                'intersection',
                'node-position',
                'endpoints'
            ]
        },
        edgeEndpoint: {
            number: true,
            multiple: true,
            units: '%|px|em|deg|rad',
            implicitUnits: 'px',
            enums: [
                'inside-to-node',
                'outside-to-node',
                'outside-to-node-or-label',
                'outside-to-line',
                'outside-to-line-or-label'
            ],
            singleEnum: true,
            validate: function validate(valArr, unitsArr) {
                switch(valArr.length){
                    case 2:
                        // can be % or px only
                        return unitsArr[0] !== 'deg' && unitsArr[0] !== 'rad' && unitsArr[1] !== 'deg' && unitsArr[1] !== 'rad';
                    case 1:
                        // can be enum, deg, or rad only
                        return $e815fda779bc047b$var$string(valArr[0]) || unitsArr[0] === 'deg' || unitsArr[0] === 'rad';
                    default:
                        return false;
                }
            }
        },
        easing: {
            regexes: [
                '^(spring)\\s*\\(\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*\\)$',
                '^(cubic-bezier)\\s*\\(\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*\\)$'
            ],
            enums: [
                'linear',
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'ease-in-sine',
                'ease-out-sine',
                'ease-in-out-sine',
                'ease-in-quad',
                'ease-out-quad',
                'ease-in-out-quad',
                'ease-in-cubic',
                'ease-out-cubic',
                'ease-in-out-cubic',
                'ease-in-quart',
                'ease-out-quart',
                'ease-in-out-quart',
                'ease-in-quint',
                'ease-out-quint',
                'ease-in-out-quint',
                'ease-in-expo',
                'ease-out-expo',
                'ease-in-out-expo',
                'ease-in-circ',
                'ease-out-circ',
                'ease-in-out-circ'
            ]
        },
        gradientDirection: {
            enums: [
                'to-bottom',
                'to-top',
                'to-left',
                'to-right',
                'to-bottom-right',
                'to-bottom-left',
                'to-top-right',
                'to-top-left',
                'to-right-bottom',
                'to-left-bottom',
                'to-right-top',
                'to-left-top' // different order
            ]
        },
        boundsExpansion: {
            number: true,
            multiple: true,
            min: 0,
            validate: function validate(valArr) {
                var length = valArr.length;
                return length === 1 || length === 2 || length === 4;
            }
        }
    };
    var diff = {
        zeroNonZero: function zeroNonZero(val1, val2) {
            if ((val1 == null || val2 == null) && val1 !== val2) return true; // null cases could represent any value
            if (val1 == 0 && val2 != 0) return true;
            else if (val1 != 0 && val2 == 0) return true;
            else return false;
        },
        any: function any(val1, val2) {
            return val1 != val2;
        },
        emptyNonEmpty: function emptyNonEmpty(str1, str2) {
            var empty1 = $e815fda779bc047b$var$emptyString(str1);
            var empty2 = $e815fda779bc047b$var$emptyString(str2);
            return empty1 && !empty2 || !empty1 && empty2;
        }
    };
    // define visual style properties
    //
    // - n.b. adding a new group of props may require updates to updateStyleHints()
    // - adding new props to an existing group gets handled automatically
    var t = $e815fda779bc047b$var$styfn$2.types;
    var mainLabel = [
        {
            name: 'label',
            type: t.text,
            triggersBounds: diff.any,
            triggersZOrder: diff.emptyNonEmpty
        },
        {
            name: 'text-rotation',
            type: t.textRotation,
            triggersBounds: diff.any
        },
        {
            name: 'text-margin-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'text-margin-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        }
    ];
    var sourceLabel = [
        {
            name: 'source-label',
            type: t.text,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-rotation',
            type: t.textRotation,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-margin-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-margin-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-offset',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var targetLabel = [
        {
            name: 'target-label',
            type: t.text,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-rotation',
            type: t.textRotation,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-margin-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-margin-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-offset',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var labelDimensions = [
        {
            name: 'font-family',
            type: t.fontFamily,
            triggersBounds: diff.any
        },
        {
            name: 'font-style',
            type: t.fontStyle,
            triggersBounds: diff.any
        },
        {
            name: 'font-weight',
            type: t.fontWeight,
            triggersBounds: diff.any
        },
        {
            name: 'font-size',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-transform',
            type: t.textTransform,
            triggersBounds: diff.any
        },
        {
            name: 'text-wrap',
            type: t.textWrap,
            triggersBounds: diff.any
        },
        {
            name: 'text-overflow-wrap',
            type: t.textOverflowWrap,
            triggersBounds: diff.any
        },
        {
            name: 'text-max-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-outline-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'line-height',
            type: t.positiveNumber,
            triggersBounds: diff.any
        }
    ];
    var commonLabel = [
        {
            name: 'text-valign',
            type: t.valign,
            triggersBounds: diff.any
        },
        {
            name: 'text-halign',
            type: t.halign,
            triggersBounds: diff.any
        },
        {
            name: 'color',
            type: t.color
        },
        {
            name: 'text-outline-color',
            type: t.color
        },
        {
            name: 'text-outline-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'text-background-color',
            type: t.color
        },
        {
            name: 'text-background-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'text-background-padding',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-border-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'text-border-color',
            type: t.color
        },
        {
            name: 'text-border-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-border-style',
            type: t.borderStyle,
            triggersBounds: diff.any
        },
        {
            name: 'text-background-shape',
            type: t.textBackgroundShape,
            triggersBounds: diff.any
        },
        {
            name: 'text-justification',
            type: t.justification
        }
    ];
    var behavior = [
        {
            name: 'events',
            type: t.bool,
            triggersZOrder: diff.any
        },
        {
            name: 'text-events',
            type: t.bool,
            triggersZOrder: diff.any
        }
    ];
    var visibility = [
        {
            name: 'display',
            type: t.display,
            triggersZOrder: diff.any,
            triggersBounds: diff.any,
            triggersBoundsOfConnectedEdges: true
        },
        {
            name: 'visibility',
            type: t.visibility,
            triggersZOrder: diff.any
        },
        {
            name: 'opacity',
            type: t.zeroOneNumber,
            triggersZOrder: diff.zeroNonZero
        },
        {
            name: 'text-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'min-zoomed-font-size',
            type: t.size
        },
        {
            name: 'z-compound-depth',
            type: t.zCompoundDepth,
            triggersZOrder: diff.any
        },
        {
            name: 'z-index-compare',
            type: t.zIndexCompare,
            triggersZOrder: diff.any
        },
        {
            name: 'z-index',
            type: t.number,
            triggersZOrder: diff.any
        }
    ];
    var overlay = [
        {
            name: 'overlay-padding',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'overlay-color',
            type: t.color
        },
        {
            name: 'overlay-opacity',
            type: t.zeroOneNumber,
            triggersBounds: diff.zeroNonZero
        },
        {
            name: 'overlay-shape',
            type: t.overlayShape,
            triggersBounds: diff.any
        },
        {
            name: 'overlay-corner-radius',
            type: t.cornerRadius
        }
    ];
    var underlay = [
        {
            name: 'underlay-padding',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'underlay-color',
            type: t.color
        },
        {
            name: 'underlay-opacity',
            type: t.zeroOneNumber,
            triggersBounds: diff.zeroNonZero
        },
        {
            name: 'underlay-shape',
            type: t.overlayShape,
            triggersBounds: diff.any
        },
        {
            name: 'underlay-corner-radius',
            type: t.cornerRadius
        }
    ];
    var transition = [
        {
            name: 'transition-property',
            type: t.propList
        },
        {
            name: 'transition-duration',
            type: t.time
        },
        {
            name: 'transition-delay',
            type: t.time
        },
        {
            name: 'transition-timing-function',
            type: t.easing
        }
    ];
    var nodeSizeHashOverride = function nodeSizeHashOverride(ele, parsedProp) {
        if (parsedProp.value === 'label') return -ele.poolIndex(); // no hash key hits is using label size (hitrate for perf probably low anyway)
        else return parsedProp.pfValue;
    };
    var nodeBody = [
        {
            name: 'height',
            type: t.nodeSize,
            triggersBounds: diff.any,
            hashOverride: nodeSizeHashOverride
        },
        {
            name: 'width',
            type: t.nodeSize,
            triggersBounds: diff.any,
            hashOverride: nodeSizeHashOverride
        },
        {
            name: 'shape',
            type: t.nodeShape,
            triggersBounds: diff.any
        },
        {
            name: 'shape-polygon-points',
            type: t.polygonPointList,
            triggersBounds: diff.any
        },
        {
            name: 'corner-radius',
            type: t.cornerRadius
        },
        {
            name: 'background-color',
            type: t.color
        },
        {
            name: 'background-fill',
            type: t.fill
        },
        {
            name: 'background-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'background-blacken',
            type: t.nOneOneNumber
        },
        {
            name: 'background-gradient-stop-colors',
            type: t.colors
        },
        {
            name: 'background-gradient-stop-positions',
            type: t.percentages
        },
        {
            name: 'background-gradient-direction',
            type: t.gradientDirection
        },
        {
            name: 'padding',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'padding-relative-to',
            type: t.paddingRelativeTo,
            triggersBounds: diff.any
        },
        {
            name: 'bounds-expansion',
            type: t.boundsExpansion,
            triggersBounds: diff.any
        }
    ];
    var nodeBorder = [
        {
            name: 'border-color',
            type: t.color
        },
        {
            name: 'border-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'border-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'border-style',
            type: t.borderStyle
        },
        {
            name: 'border-cap',
            type: t.lineCap
        },
        {
            name: 'border-join',
            type: t.lineJoin
        },
        {
            name: 'border-dash-pattern',
            type: t.numbers
        },
        {
            name: 'border-dash-offset',
            type: t.number
        },
        {
            name: 'border-position',
            type: t.linePosition
        }
    ];
    var nodeOutline = [
        {
            name: 'outline-color',
            type: t.color
        },
        {
            name: 'outline-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'outline-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'outline-style',
            type: t.borderStyle
        },
        {
            name: 'outline-offset',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var backgroundImage = [
        {
            name: 'background-image',
            type: t.urls
        },
        {
            name: 'background-image-crossorigin',
            type: t.bgCrossOrigin
        },
        {
            name: 'background-image-opacity',
            type: t.zeroOneNumbers
        },
        {
            name: 'background-image-containment',
            type: t.bgContainment
        },
        {
            name: 'background-image-smoothing',
            type: t.bools
        },
        {
            name: 'background-position-x',
            type: t.bgPos
        },
        {
            name: 'background-position-y',
            type: t.bgPos
        },
        {
            name: 'background-width-relative-to',
            type: t.bgRelativeTo
        },
        {
            name: 'background-height-relative-to',
            type: t.bgRelativeTo
        },
        {
            name: 'background-repeat',
            type: t.bgRepeat
        },
        {
            name: 'background-fit',
            type: t.bgFit
        },
        {
            name: 'background-clip',
            type: t.bgClip
        },
        {
            name: 'background-width',
            type: t.bgWH
        },
        {
            name: 'background-height',
            type: t.bgWH
        },
        {
            name: 'background-offset-x',
            type: t.bgPos
        },
        {
            name: 'background-offset-y',
            type: t.bgPos
        }
    ];
    var compound = [
        {
            name: 'position',
            type: t.position,
            triggersBounds: diff.any
        },
        {
            name: 'compound-sizing-wrt-labels',
            type: t.compoundIncludeLabels,
            triggersBounds: diff.any
        },
        {
            name: 'min-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'min-width-bias-left',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'min-width-bias-right',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'min-height',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'min-height-bias-top',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'min-height-bias-bottom',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        }
    ];
    var edgeLine = [
        {
            name: 'line-style',
            type: t.lineStyle
        },
        {
            name: 'line-color',
            type: t.color
        },
        {
            name: 'line-fill',
            type: t.fill
        },
        {
            name: 'line-cap',
            type: t.lineCap
        },
        {
            name: 'line-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'line-dash-pattern',
            type: t.numbers
        },
        {
            name: 'line-dash-offset',
            type: t.number
        },
        {
            name: 'line-outline-width',
            type: t.size
        },
        {
            name: 'line-outline-color',
            type: t.color
        },
        {
            name: 'line-gradient-stop-colors',
            type: t.colors
        },
        {
            name: 'line-gradient-stop-positions',
            type: t.percentages
        },
        {
            name: 'curve-style',
            type: t.curveStyle,
            triggersBounds: diff.any,
            triggersBoundsOfParallelBeziers: true
        },
        {
            name: 'haystack-radius',
            type: t.zeroOneNumber,
            triggersBounds: diff.any
        },
        {
            name: 'source-endpoint',
            type: t.edgeEndpoint,
            triggersBounds: diff.any
        },
        {
            name: 'target-endpoint',
            type: t.edgeEndpoint,
            triggersBounds: diff.any
        },
        {
            name: 'control-point-step-size',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'control-point-distances',
            type: t.bidirectionalSizes,
            triggersBounds: diff.any
        },
        {
            name: 'control-point-weights',
            type: t.numbers,
            triggersBounds: diff.any
        },
        {
            name: 'segment-distances',
            type: t.bidirectionalSizes,
            triggersBounds: diff.any
        },
        {
            name: 'segment-weights',
            type: t.numbers,
            triggersBounds: diff.any
        },
        {
            name: 'segment-radii',
            type: t.numbers,
            triggersBounds: diff.any
        },
        {
            name: 'radius-type',
            type: t.radiusType,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-turn',
            type: t.bidirectionalSizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-turn-min-distance',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-direction',
            type: t.axisDirection,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-radius',
            type: t.number,
            triggersBounds: diff.any
        },
        {
            name: 'edge-distances',
            type: t.edgeDistances,
            triggersBounds: diff.any
        },
        {
            name: 'arrow-scale',
            type: t.positiveNumber,
            triggersBounds: diff.any
        },
        {
            name: 'loop-direction',
            type: t.angle,
            triggersBounds: diff.any
        },
        {
            name: 'loop-sweep',
            type: t.angle,
            triggersBounds: diff.any
        },
        {
            name: 'source-distance-from-node',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'target-distance-from-node',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var ghost = [
        {
            name: 'ghost',
            type: t.bool,
            triggersBounds: diff.any
        },
        {
            name: 'ghost-offset-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'ghost-offset-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'ghost-opacity',
            type: t.zeroOneNumber
        }
    ];
    var core = [
        {
            name: 'selection-box-color',
            type: t.color
        },
        {
            name: 'selection-box-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'selection-box-border-color',
            type: t.color
        },
        {
            name: 'selection-box-border-width',
            type: t.size
        },
        {
            name: 'active-bg-color',
            type: t.color
        },
        {
            name: 'active-bg-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'active-bg-size',
            type: t.size
        },
        {
            name: 'outside-texture-bg-color',
            type: t.color
        },
        {
            name: 'outside-texture-bg-opacity',
            type: t.zeroOneNumber
        }
    ];
    // pie backgrounds for nodes
    var pie = [];
    $e815fda779bc047b$var$styfn$2.pieBackgroundN = 16; // because the pie properties are numbered, give access to a constant N (for renderer use)
    pie.push({
        name: 'pie-size',
        type: t.sizeMaybePercent
    });
    for(var i = 1; i <= $e815fda779bc047b$var$styfn$2.pieBackgroundN; i++){
        pie.push({
            name: 'pie-' + i + '-background-color',
            type: t.color
        });
        pie.push({
            name: 'pie-' + i + '-background-size',
            type: t.percent
        });
        pie.push({
            name: 'pie-' + i + '-background-opacity',
            type: t.zeroOneNumber
        });
    }
    // edge arrows
    var edgeArrow = [];
    var arrowPrefixes = $e815fda779bc047b$var$styfn$2.arrowPrefixes = [
        'source',
        'mid-source',
        'target',
        'mid-target'
    ];
    [
        {
            name: 'arrow-shape',
            type: t.arrowShape,
            triggersBounds: diff.any
        },
        {
            name: 'arrow-color',
            type: t.color
        },
        {
            name: 'arrow-fill',
            type: t.arrowFill
        },
        {
            name: 'arrow-width',
            type: t.arrowWidth
        }
    ].forEach(function(prop) {
        arrowPrefixes.forEach(function(prefix) {
            var name = prefix + '-' + prop.name;
            var type = prop.type, triggersBounds = prop.triggersBounds;
            edgeArrow.push({
                name: name,
                type: type,
                triggersBounds: triggersBounds
            });
        });
    }, {});
    var props = $e815fda779bc047b$var$styfn$2.properties = [].concat(behavior, transition, visibility, overlay, underlay, ghost, commonLabel, labelDimensions, mainLabel, sourceLabel, targetLabel, nodeBody, nodeBorder, nodeOutline, backgroundImage, pie, compound, edgeLine, edgeArrow, core);
    var propGroups = $e815fda779bc047b$var$styfn$2.propertyGroups = {
        // common to all eles
        behavior: behavior,
        transition: transition,
        visibility: visibility,
        overlay: overlay,
        underlay: underlay,
        ghost: ghost,
        // labels
        commonLabel: commonLabel,
        labelDimensions: labelDimensions,
        mainLabel: mainLabel,
        sourceLabel: sourceLabel,
        targetLabel: targetLabel,
        // node props
        nodeBody: nodeBody,
        nodeBorder: nodeBorder,
        nodeOutline: nodeOutline,
        backgroundImage: backgroundImage,
        pie: pie,
        compound: compound,
        // edge props
        edgeLine: edgeLine,
        edgeArrow: edgeArrow,
        core: core
    };
    var propGroupNames = $e815fda779bc047b$var$styfn$2.propertyGroupNames = {};
    var propGroupKeys = $e815fda779bc047b$var$styfn$2.propertyGroupKeys = Object.keys(propGroups);
    propGroupKeys.forEach(function(key) {
        propGroupNames[key] = propGroups[key].map(function(prop) {
            return prop.name;
        });
        propGroups[key].forEach(function(prop) {
            return prop.groupKey = key;
        });
    });
    // define aliases
    var aliases = $e815fda779bc047b$var$styfn$2.aliases = [
        {
            name: 'content',
            pointsTo: 'label'
        },
        {
            name: 'control-point-distance',
            pointsTo: 'control-point-distances'
        },
        {
            name: 'control-point-weight',
            pointsTo: 'control-point-weights'
        },
        {
            name: 'segment-distance',
            pointsTo: 'segment-distances'
        },
        {
            name: 'segment-weight',
            pointsTo: 'segment-weights'
        },
        {
            name: 'segment-radius',
            pointsTo: 'segment-radii'
        },
        {
            name: 'edge-text-rotation',
            pointsTo: 'text-rotation'
        },
        {
            name: 'padding-left',
            pointsTo: 'padding'
        },
        {
            name: 'padding-right',
            pointsTo: 'padding'
        },
        {
            name: 'padding-top',
            pointsTo: 'padding'
        },
        {
            name: 'padding-bottom',
            pointsTo: 'padding'
        }
    ];
    // list of property names
    $e815fda779bc047b$var$styfn$2.propertyNames = props.map(function(p) {
        return p.name;
    });
    // allow access of properties by name ( e.g. style.properties.height )
    for(var _i = 0; _i < props.length; _i++){
        var prop = props[_i];
        props[prop.name] = prop; // allow lookup by name
    }
    // map aliases
    for(var _i2 = 0; _i2 < aliases.length; _i2++){
        var alias = aliases[_i2];
        var pointsToProp = props[alias.pointsTo];
        var aliasProp = {
            name: alias.name,
            alias: true,
            pointsTo: pointsToProp
        };
        // add alias prop for parsing
        props.push(aliasProp);
        props[alias.name] = aliasProp; // allow lookup by name
    }
})();
$e815fda779bc047b$var$styfn$2.getDefaultProperty = function(name) {
    return this.getDefaultProperties()[name];
};
$e815fda779bc047b$var$styfn$2.getDefaultProperties = function() {
    var _p = this._private;
    if (_p.defaultProperties != null) return _p.defaultProperties;
    var rawProps = $e815fda779bc047b$var$extend({
        // core props
        'selection-box-color': '#ddd',
        'selection-box-opacity': 0.65,
        'selection-box-border-color': '#aaa',
        'selection-box-border-width': 1,
        'active-bg-color': 'black',
        'active-bg-opacity': 0.15,
        'active-bg-size': 30,
        'outside-texture-bg-color': '#000',
        'outside-texture-bg-opacity': 0.125,
        // common node/edge props
        'events': 'yes',
        'text-events': 'no',
        'text-valign': 'top',
        'text-halign': 'center',
        'text-justification': 'auto',
        'line-height': 1,
        'color': '#000',
        'text-outline-color': '#000',
        'text-outline-width': 0,
        'text-outline-opacity': 1,
        'text-opacity': 1,
        'text-decoration': 'none',
        'text-transform': 'none',
        'text-wrap': 'none',
        'text-overflow-wrap': 'whitespace',
        'text-max-width': 9999,
        'text-background-color': '#000',
        'text-background-opacity': 0,
        'text-background-shape': 'rectangle',
        'text-background-padding': 0,
        'text-border-opacity': 0,
        'text-border-width': 0,
        'text-border-style': 'solid',
        'text-border-color': '#000',
        'font-family': 'Helvetica Neue, Helvetica, sans-serif',
        'font-style': 'normal',
        'font-weight': 'normal',
        'font-size': 16,
        'min-zoomed-font-size': 0,
        'text-rotation': 'none',
        'source-text-rotation': 'none',
        'target-text-rotation': 'none',
        'visibility': 'visible',
        'display': 'element',
        'opacity': 1,
        'z-compound-depth': 'auto',
        'z-index-compare': 'auto',
        'z-index': 0,
        'label': '',
        'text-margin-x': 0,
        'text-margin-y': 0,
        'source-label': '',
        'source-text-offset': 0,
        'source-text-margin-x': 0,
        'source-text-margin-y': 0,
        'target-label': '',
        'target-text-offset': 0,
        'target-text-margin-x': 0,
        'target-text-margin-y': 0,
        'overlay-opacity': 0,
        'overlay-color': '#000',
        'overlay-padding': 10,
        'overlay-shape': 'round-rectangle',
        'overlay-corner-radius': 'auto',
        'underlay-opacity': 0,
        'underlay-color': '#000',
        'underlay-padding': 10,
        'underlay-shape': 'round-rectangle',
        'underlay-corner-radius': 'auto',
        'transition-property': 'none',
        'transition-duration': 0,
        'transition-delay': 0,
        'transition-timing-function': 'linear',
        // node props
        'background-blacken': 0,
        'background-color': '#999',
        'background-fill': 'solid',
        'background-opacity': 1,
        'background-image': 'none',
        'background-image-crossorigin': 'anonymous',
        'background-image-opacity': 1,
        'background-image-containment': 'inside',
        'background-image-smoothing': 'yes',
        'background-position-x': '50%',
        'background-position-y': '50%',
        'background-offset-x': 0,
        'background-offset-y': 0,
        'background-width-relative-to': 'include-padding',
        'background-height-relative-to': 'include-padding',
        'background-repeat': 'no-repeat',
        'background-fit': 'none',
        'background-clip': 'node',
        'background-width': 'auto',
        'background-height': 'auto',
        'border-color': '#000',
        'border-opacity': 1,
        'border-width': 0,
        'border-style': 'solid',
        'border-dash-pattern': [
            4,
            2
        ],
        'border-dash-offset': 0,
        'border-cap': 'butt',
        'border-join': 'miter',
        'border-position': 'center',
        'outline-color': '#999',
        'outline-opacity': 1,
        'outline-width': 0,
        'outline-offset': 0,
        'outline-style': 'solid',
        'height': 30,
        'width': 30,
        'shape': 'ellipse',
        'shape-polygon-points': '-1, -1,   1, -1,   1, 1,   -1, 1',
        'corner-radius': 'auto',
        'bounds-expansion': 0,
        // node gradient
        'background-gradient-direction': 'to-bottom',
        'background-gradient-stop-colors': '#999',
        'background-gradient-stop-positions': '0%',
        // ghost props
        'ghost': 'no',
        'ghost-offset-y': 0,
        'ghost-offset-x': 0,
        'ghost-opacity': 0,
        // compound props
        'padding': 0,
        'padding-relative-to': 'width',
        'position': 'origin',
        'compound-sizing-wrt-labels': 'include',
        'min-width': 0,
        'min-width-bias-left': 0,
        'min-width-bias-right': 0,
        'min-height': 0,
        'min-height-bias-top': 0,
        'min-height-bias-bottom': 0
    }, {
        // node pie bg
        'pie-size': '100%'
    }, [
        {
            name: 'pie-{{i}}-background-color',
            value: 'black'
        },
        {
            name: 'pie-{{i}}-background-size',
            value: '0%'
        },
        {
            name: 'pie-{{i}}-background-opacity',
            value: 1
        }
    ].reduce(function(css, prop) {
        for(var i = 1; i <= $e815fda779bc047b$var$styfn$2.pieBackgroundN; i++){
            var name = prop.name.replace('{{i}}', i);
            var val = prop.value;
            css[name] = val;
        }
        return css;
    }, {}), {
        // edge props
        'line-style': 'solid',
        'line-color': '#999',
        'line-fill': 'solid',
        'line-cap': 'butt',
        'line-opacity': 1,
        'line-outline-width': 0,
        'line-outline-color': '#000',
        'line-gradient-stop-colors': '#999',
        'line-gradient-stop-positions': '0%',
        'control-point-step-size': 40,
        'control-point-weights': 0.5,
        'segment-weights': 0.5,
        'segment-distances': 20,
        'segment-radii': 15,
        'radius-type': 'arc-radius',
        'taxi-turn': '50%',
        'taxi-radius': 15,
        'taxi-turn-min-distance': 10,
        'taxi-direction': 'auto',
        'edge-distances': 'intersection',
        'curve-style': 'haystack',
        'haystack-radius': 0,
        'arrow-scale': 1,
        'loop-direction': '-45deg',
        'loop-sweep': '-90deg',
        'source-distance-from-node': 0,
        'target-distance-from-node': 0,
        'source-endpoint': 'outside-to-node',
        'target-endpoint': 'outside-to-node',
        'line-dash-pattern': [
            6,
            3
        ],
        'line-dash-offset': 0
    }, [
        {
            name: 'arrow-shape',
            value: 'none'
        },
        {
            name: 'arrow-color',
            value: '#999'
        },
        {
            name: 'arrow-fill',
            value: 'filled'
        },
        {
            name: 'arrow-width',
            value: 1
        }
    ].reduce(function(css, prop) {
        $e815fda779bc047b$var$styfn$2.arrowPrefixes.forEach(function(prefix) {
            var name = prefix + '-' + prop.name;
            var val = prop.value;
            css[name] = val;
        });
        return css;
    }, {}));
    var parsedProps = {};
    for(var i = 0; i < this.properties.length; i++){
        var prop = this.properties[i];
        if (prop.pointsTo) continue;
        var name = prop.name;
        var val = rawProps[name];
        var parsedProp = this.parse(name, val);
        parsedProps[name] = parsedProp;
    }
    _p.defaultProperties = parsedProps;
    return _p.defaultProperties;
};
$e815fda779bc047b$var$styfn$2.addDefaultStylesheet = function() {
    this.selector(':parent').css({
        'shape': 'rectangle',
        'padding': 10,
        'background-color': '#eee',
        'border-color': '#ccc',
        'border-width': 1
    }).selector('edge').css({
        'width': 3
    }).selector(':loop').css({
        'curve-style': 'bezier'
    }).selector('edge:compound').css({
        'curve-style': 'bezier',
        'source-endpoint': 'outside-to-line',
        'target-endpoint': 'outside-to-line'
    }).selector(':selected').css({
        'background-color': '#0169D9',
        'line-color': '#0169D9',
        'source-arrow-color': '#0169D9',
        'target-arrow-color': '#0169D9',
        'mid-source-arrow-color': '#0169D9',
        'mid-target-arrow-color': '#0169D9'
    }).selector(':parent:selected').css({
        'background-color': '#CCE1F9',
        'border-color': '#aec8e5'
    }).selector(':active').css({
        'overlay-color': 'black',
        'overlay-padding': 10,
        'overlay-opacity': 0.25
    });
    this.defaultLength = this.length;
};
var $e815fda779bc047b$var$styfn$1 = {};
// a caching layer for property parsing
$e815fda779bc047b$var$styfn$1.parse = function(name, value, propIsBypass, propIsFlat) {
    var self1 = this;
    // function values can't be cached in all cases, and there isn't much benefit of caching them anyway
    if ($e815fda779bc047b$var$fn$6(value)) return self1.parseImplWarn(name, value, propIsBypass, propIsFlat);
    var flatKey = propIsFlat === 'mapping' || propIsFlat === true || propIsFlat === false || propIsFlat == null ? 'dontcare' : propIsFlat;
    var bypassKey = propIsBypass ? 't' : 'f';
    var valueKey = '' + value;
    var argHash = $e815fda779bc047b$var$hashStrings(name, valueKey, bypassKey, flatKey);
    var propCache = self1.propCache = self1.propCache || [];
    var ret;
    if (!(ret = propCache[argHash])) ret = propCache[argHash] = self1.parseImplWarn(name, value, propIsBypass, propIsFlat);
    // - bypasses can't be shared b/c the value can be changed by animations or otherwise overridden
    // - mappings can't be shared b/c mappings are per-element
    if (propIsBypass || propIsFlat === 'mapping') {
        // need a copy since props are mutated later in their lifecycles
        ret = $e815fda779bc047b$var$copy(ret);
        if (ret) ret.value = $e815fda779bc047b$var$copy(ret.value); // because it could be an array, e.g. colour
    }
    return ret;
};
$e815fda779bc047b$var$styfn$1.parseImplWarn = function(name, value, propIsBypass, propIsFlat) {
    var prop = this.parseImpl(name, value, propIsBypass, propIsFlat);
    if (!prop && value != null) $e815fda779bc047b$var$warn("The style property `".concat(name, ": ").concat(value, "` is invalid"));
    if (prop && (prop.name === 'width' || prop.name === 'height') && value === 'label') $e815fda779bc047b$var$warn('The style value of `label` is deprecated for `' + prop.name + '`');
    return prop;
};
// parse a property; return null on invalid; return parsed property otherwise
// fields :
// - name : the name of the property
// - value : the parsed, native-typed value of the property
// - strValue : a string value that represents the property value in valid css
// - bypass : true iff the property is a bypass property
$e815fda779bc047b$var$styfn$1.parseImpl = function(name, value, propIsBypass, propIsFlat) {
    var self1 = this;
    name = $e815fda779bc047b$var$camel2dash(name); // make sure the property name is in dash form (e.g. 'property-name' not 'propertyName')
    var property = self1.properties[name];
    var passedValue = value;
    var types = self1.types;
    if (!property) return null;
     // return null on property of unknown name
    if (value === undefined) return null;
     // can't assign undefined
    // the property may be an alias
    if (property.alias) {
        property = property.pointsTo;
        name = property.name;
    }
    var valueIsString = $e815fda779bc047b$var$string(value);
    if (valueIsString) // trim the value to make parsing easier
    value = value.trim();
    var type = property.type;
    if (!type) return null;
     // no type, no luck
    // check if bypass is null or empty string (i.e. indication to delete bypass property)
    if (propIsBypass && (value === '' || value === null)) return {
        name: name,
        value: value,
        bypass: true,
        deleteBypass: true
    };
    // check if value is a function used as a mapper
    if ($e815fda779bc047b$var$fn$6(value)) return {
        name: name,
        value: value,
        strValue: 'fn',
        mapped: types.fn,
        bypass: propIsBypass
    };
    // check if value is mapped
    var data, mapData;
    if (!valueIsString || propIsFlat || value.length < 7 || value[1] !== 'a') ;
    else if (value.length >= 7 && value[0] === 'd' && (data = new RegExp(types.data.regex).exec(value))) {
        if (propIsBypass) return false;
         // mappers not allowed in bypass
        var mapped = types.data;
        return {
            name: name,
            value: data,
            strValue: '' + value,
            mapped: mapped,
            field: data[1],
            bypass: propIsBypass
        };
    } else if (value.length >= 10 && value[0] === 'm' && (mapData = new RegExp(types.mapData.regex).exec(value))) {
        if (propIsBypass) return false;
         // mappers not allowed in bypass
        if (type.multiple) return false;
         // impossible to map to num
        var _mapped = types.mapData;
        // we can map only if the type is a colour or a number
        if (!(type.color || type.number)) return false;
        var valueMin = this.parse(name, mapData[4]); // parse to validate
        if (!valueMin || valueMin.mapped) return false;
         // can't be invalid or mapped
        var valueMax = this.parse(name, mapData[5]); // parse to validate
        if (!valueMax || valueMax.mapped) return false;
         // can't be invalid or mapped
        // check if valueMin and valueMax are the same
        if (valueMin.pfValue === valueMax.pfValue || valueMin.strValue === valueMax.strValue) {
            $e815fda779bc047b$var$warn('`' + name + ': ' + value + '` is not a valid mapper because the output range is zero; converting to `' + name + ': ' + valueMin.strValue + '`');
            return this.parse(name, valueMin.strValue); // can't make much of a mapper without a range
        } else if (type.color) {
            var c1 = valueMin.value;
            var c2 = valueMax.value;
            var same = c1[0] === c2[0] // red
             && c1[1] === c2[1] // green
             && c1[2] === c2[2] // blue
             && // optional alpha
            (c1[3] === c2[3] // same alpha outright
             || (c1[3] == null || c1[3] === 1 // full opacity for colour 1?
            ) && (c2[3] == null || c2[3] === 1 // full opacity for colour 2?
            ));
            if (same) return false;
             // can't make a mapper without a range
        }
        return {
            name: name,
            value: mapData,
            strValue: '' + value,
            mapped: _mapped,
            field: mapData[1],
            fieldMin: parseFloat(mapData[2]),
            // min & max are numeric
            fieldMax: parseFloat(mapData[3]),
            valueMin: valueMin.value,
            valueMax: valueMax.value,
            bypass: propIsBypass
        };
    }
    if (type.multiple && propIsFlat !== 'multiple') {
        var vals;
        if (valueIsString) vals = value.split(/\s+/);
        else if ($e815fda779bc047b$var$array(value)) vals = value;
        else vals = [
            value
        ];
        if (type.evenMultiple && vals.length % 2 !== 0) return null;
        var valArr = [];
        var unitsArr = [];
        var pfValArr = [];
        var strVal = '';
        var hasEnum = false;
        for(var i = 0; i < vals.length; i++){
            var p = self1.parse(name, vals[i], propIsBypass, 'multiple');
            hasEnum = hasEnum || $e815fda779bc047b$var$string(p.value);
            valArr.push(p.value);
            pfValArr.push(p.pfValue != null ? p.pfValue : p.value);
            unitsArr.push(p.units);
            strVal += (i > 0 ? ' ' : '') + p.strValue;
        }
        if (type.validate && !type.validate(valArr, unitsArr)) return null;
        if (type.singleEnum && hasEnum) {
            if (valArr.length === 1 && $e815fda779bc047b$var$string(valArr[0])) return {
                name: name,
                value: valArr[0],
                strValue: valArr[0],
                bypass: propIsBypass
            };
            else return null;
        }
        return {
            name: name,
            value: valArr,
            pfValue: pfValArr,
            strValue: strVal,
            bypass: propIsBypass,
            units: unitsArr
        };
    }
    // several types also allow enums
    var checkEnums = function checkEnums() {
        for(var _i = 0; _i < type.enums.length; _i++){
            var en = type.enums[_i];
            if (en === value) return {
                name: name,
                value: value,
                strValue: '' + value,
                bypass: propIsBypass
            };
        }
        return null;
    };
    // check the type and return the appropriate object
    if (type.number) {
        var units;
        var implicitUnits = 'px'; // not set => px
        if (type.units) // use specified units if set
        units = type.units;
        if (type.implicitUnits) implicitUnits = type.implicitUnits;
        if (!type.unitless) {
            if (valueIsString) {
                var unitsRegex = 'px|em' + (type.allowPercent ? '|\\%' : '');
                if (units) unitsRegex = units;
                 // only allow explicit units if so set
                var match = value.match('^(' + $e815fda779bc047b$var$number + ')(' + unitsRegex + ')?' + '$');
                if (match) {
                    value = match[1];
                    units = match[2] || implicitUnits;
                }
            } else if (!units || type.implicitUnits) units = implicitUnits; // implicitly px if unspecified
        }
        value = parseFloat(value);
        // if not a number and enums not allowed, then the value is invalid
        if (isNaN(value) && type.enums === undefined) return null;
        // check if this number type also accepts special keywords in place of numbers
        // (i.e. `left`, `auto`, etc)
        if (isNaN(value) && type.enums !== undefined) {
            value = passedValue;
            return checkEnums();
        }
        // check if value must be an integer
        if (type.integer && !$e815fda779bc047b$var$integer(value)) return null;
        // check value is within range
        if (type.min !== undefined && (value < type.min || type.strictMin && value === type.min) || type.max !== undefined && (value > type.max || type.strictMax && value === type.max)) return null;
        var ret = {
            name: name,
            value: value,
            strValue: '' + value + (units ? units : ''),
            units: units,
            bypass: propIsBypass
        };
        // normalise value in pixels
        if (type.unitless || units !== 'px' && units !== 'em') ret.pfValue = value;
        else ret.pfValue = units === 'px' || !units ? value : this.getEmSizeInPixels() * value;
        // normalise value in ms
        if (units === 'ms' || units === 's') ret.pfValue = units === 'ms' ? value : 1000 * value;
        // normalise value in rad
        if (units === 'deg' || units === 'rad') ret.pfValue = units === 'rad' ? value : $e815fda779bc047b$var$deg2rad(value);
        // normalize value in %
        if (units === '%') ret.pfValue = value / 100;
        return ret;
    } else if (type.propList) {
        var props = [];
        var propsStr = '' + value;
        if (propsStr === 'none') ;
        else {
            // go over each prop
            var propsSplit = propsStr.split(/\s*,\s*|\s+/);
            for(var _i2 = 0; _i2 < propsSplit.length; _i2++){
                var propName = propsSplit[_i2].trim();
                if (self1.properties[propName]) props.push(propName);
                else $e815fda779bc047b$var$warn('`' + propName + '` is not a valid property name');
            }
            if (props.length === 0) return null;
        }
        return {
            name: name,
            value: props,
            strValue: props.length === 0 ? 'none' : props.join(' '),
            bypass: propIsBypass
        };
    } else if (type.color) {
        var tuple = $e815fda779bc047b$var$color2tuple(value);
        if (!tuple) return null;
        return {
            name: name,
            value: tuple,
            pfValue: tuple,
            strValue: 'rgb(' + tuple[0] + ',' + tuple[1] + ',' + tuple[2] + ')',
            // n.b. no spaces b/c of multiple support
            bypass: propIsBypass
        };
    } else if (type.regex || type.regexes) {
        // first check enums
        if (type.enums) {
            var enumProp = checkEnums();
            if (enumProp) return enumProp;
        }
        var regexes = type.regexes ? type.regexes : [
            type.regex
        ];
        for(var _i3 = 0; _i3 < regexes.length; _i3++){
            var regex = new RegExp(regexes[_i3]); // make a regex from the type string
            var m1 = regex.exec(value);
            if (m1) // regex matches
            return {
                name: name,
                value: type.singleRegexMatchValue ? m1[1] : m1,
                strValue: '' + value,
                bypass: propIsBypass
            };
        }
        return null; // didn't match any
    } else if (type.string) // just return
    return {
        name: name,
        value: '' + value,
        strValue: '' + value,
        bypass: propIsBypass
    };
    else if (type.enums) // check enums last because it's a combo type in others
    return checkEnums();
    else return null; // not a type we can handle
};
var $e815fda779bc047b$var$Style = function Style(cy) {
    if (!(this instanceof Style)) return new Style(cy);
    if (!$e815fda779bc047b$var$core(cy)) {
        $e815fda779bc047b$var$error('A style must have a core reference');
        return;
    }
    this._private = {
        cy: cy,
        coreStyle: {}
    };
    this.length = 0;
    this.resetToDefault();
};
var $e815fda779bc047b$var$styfn = $e815fda779bc047b$var$Style.prototype;
$e815fda779bc047b$var$styfn.instanceString = function() {
    return 'style';
};
// remove all contexts
$e815fda779bc047b$var$styfn.clear = function() {
    var _p = this._private;
    var cy = _p.cy;
    var eles = cy.elements();
    for(var i = 0; i < this.length; i++)this[i] = undefined;
    this.length = 0;
    _p.contextStyles = {};
    _p.propDiffs = {};
    this.cleanElements(eles, true);
    eles.forEach(function(ele) {
        var ele_p = ele[0]._private;
        ele_p.styleDirty = true;
        ele_p.appliedInitStyle = false;
    });
    return this; // chaining
};
$e815fda779bc047b$var$styfn.resetToDefault = function() {
    this.clear();
    this.addDefaultStylesheet();
    return this;
};
// builds a style object for the 'core' selector
$e815fda779bc047b$var$styfn.core = function(propName) {
    return this._private.coreStyle[propName] || this.getDefaultProperty(propName);
};
// create a new context from the specified selector string and switch to that context
$e815fda779bc047b$var$styfn.selector = function(selectorStr) {
    // 'core' is a special case and does not need a selector
    var selector = selectorStr === 'core' ? null : new $e815fda779bc047b$var$Selector(selectorStr);
    var i = this.length++; // new context means new index
    this[i] = {
        selector: selector,
        properties: [],
        mappedProperties: [],
        index: i
    };
    return this; // chaining
};
// add one or many css rules to the current context
$e815fda779bc047b$var$styfn.css = function() {
    var self1 = this;
    var args = arguments;
    if (args.length === 1) {
        var map = args[0];
        for(var i = 0; i < self1.properties.length; i++){
            var prop = self1.properties[i];
            var mapVal = map[prop.name];
            if (mapVal === undefined) mapVal = map[$e815fda779bc047b$var$dash2camel(prop.name)];
            if (mapVal !== undefined) this.cssRule(prop.name, mapVal);
        }
    } else if (args.length === 2) this.cssRule(args[0], args[1]);
    // do nothing if args are invalid
    return this; // chaining
};
$e815fda779bc047b$var$styfn.style = $e815fda779bc047b$var$styfn.css;
// add a single css rule to the current context
$e815fda779bc047b$var$styfn.cssRule = function(name, value) {
    // name-value pair
    var property = this.parse(name, value);
    // add property to current context if valid
    if (property) {
        var i = this.length - 1;
        this[i].properties.push(property);
        this[i].properties[property.name] = property; // allow access by name as well
        if (property.name.match(/pie-(\d+)-background-size/) && property.value) this._private.hasPie = true;
        if (property.mapped) this[i].mappedProperties.push(property);
        // add to core style if necessary
        var currentSelectorIsCore = !this[i].selector;
        if (currentSelectorIsCore) this._private.coreStyle[property.name] = property;
    }
    return this; // chaining
};
$e815fda779bc047b$var$styfn.append = function(style) {
    if ($e815fda779bc047b$var$stylesheet(style)) style.appendToStyle(this);
    else if ($e815fda779bc047b$var$array(style)) this.appendFromJson(style);
    else if ($e815fda779bc047b$var$string(style)) this.appendFromString(style);
     // you probably wouldn't want to append a Style, since you'd duplicate the default parts
    return this;
};
// static function
$e815fda779bc047b$var$Style.fromJson = function(cy, json) {
    var style = new $e815fda779bc047b$var$Style(cy);
    style.fromJson(json);
    return style;
};
$e815fda779bc047b$var$Style.fromString = function(cy, string) {
    return new $e815fda779bc047b$var$Style(cy).fromString(string);
};
[
    $e815fda779bc047b$var$styfn$8,
    $e815fda779bc047b$var$styfn$7,
    $e815fda779bc047b$var$styfn$6,
    $e815fda779bc047b$var$styfn$5,
    $e815fda779bc047b$var$styfn$4,
    $e815fda779bc047b$var$styfn$3,
    $e815fda779bc047b$var$styfn$2,
    $e815fda779bc047b$var$styfn$1
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$styfn, props);
});
$e815fda779bc047b$var$Style.types = $e815fda779bc047b$var$styfn.types;
$e815fda779bc047b$var$Style.properties = $e815fda779bc047b$var$styfn.properties;
$e815fda779bc047b$var$Style.propertyGroups = $e815fda779bc047b$var$styfn.propertyGroups;
$e815fda779bc047b$var$Style.propertyGroupNames = $e815fda779bc047b$var$styfn.propertyGroupNames;
$e815fda779bc047b$var$Style.propertyGroupKeys = $e815fda779bc047b$var$styfn.propertyGroupKeys;
var $e815fda779bc047b$var$corefn$2 = {
    style: function style(newStyle) {
        if (newStyle) {
            var s = this.setStyle(newStyle);
            s.update();
        }
        return this._private.style;
    },
    setStyle: function setStyle(style) {
        var _p = this._private;
        if ($e815fda779bc047b$var$stylesheet(style)) _p.style = style.generateStyle(this);
        else if ($e815fda779bc047b$var$array(style)) _p.style = $e815fda779bc047b$var$Style.fromJson(this, style);
        else if ($e815fda779bc047b$var$string(style)) _p.style = $e815fda779bc047b$var$Style.fromString(this, style);
        else _p.style = $e815fda779bc047b$var$Style(this);
        return _p.style;
    },
    // e.g. cy.data() changed => recalc ele mappers
    updateStyle: function updateStyle() {
        this.mutableElements().updateStyle(); // just send to all eles
    }
};
var $e815fda779bc047b$var$defaultSelectionType = 'single';
var $e815fda779bc047b$var$corefn$1 = {
    autolock: function autolock(bool) {
        if (bool !== undefined) this._private.autolock = bool ? true : false;
        else return this._private.autolock;
        return this; // chaining
    },
    autoungrabify: function autoungrabify(bool) {
        if (bool !== undefined) this._private.autoungrabify = bool ? true : false;
        else return this._private.autoungrabify;
        return this; // chaining
    },
    autounselectify: function autounselectify(bool) {
        if (bool !== undefined) this._private.autounselectify = bool ? true : false;
        else return this._private.autounselectify;
        return this; // chaining
    },
    selectionType: function selectionType(selType) {
        var _p = this._private;
        if (_p.selectionType == null) _p.selectionType = $e815fda779bc047b$var$defaultSelectionType;
        if (selType !== undefined) {
            if (selType === 'additive' || selType === 'single') _p.selectionType = selType;
        } else return _p.selectionType;
        return this;
    },
    panningEnabled: function panningEnabled(bool) {
        if (bool !== undefined) this._private.panningEnabled = bool ? true : false;
        else return this._private.panningEnabled;
        return this; // chaining
    },
    userPanningEnabled: function userPanningEnabled(bool) {
        if (bool !== undefined) this._private.userPanningEnabled = bool ? true : false;
        else return this._private.userPanningEnabled;
        return this; // chaining
    },
    zoomingEnabled: function zoomingEnabled(bool) {
        if (bool !== undefined) this._private.zoomingEnabled = bool ? true : false;
        else return this._private.zoomingEnabled;
        return this; // chaining
    },
    userZoomingEnabled: function userZoomingEnabled(bool) {
        if (bool !== undefined) this._private.userZoomingEnabled = bool ? true : false;
        else return this._private.userZoomingEnabled;
        return this; // chaining
    },
    boxSelectionEnabled: function boxSelectionEnabled(bool) {
        if (bool !== undefined) this._private.boxSelectionEnabled = bool ? true : false;
        else return this._private.boxSelectionEnabled;
        return this; // chaining
    },
    pan: function pan() {
        var args = arguments;
        var pan = this._private.pan;
        var dim, val, dims, x, y;
        switch(args.length){
            case 0:
                // .pan()
                return pan;
            case 1:
                if ($e815fda779bc047b$var$string(args[0])) {
                    // .pan('x')
                    dim = args[0];
                    return pan[dim];
                } else if ($e815fda779bc047b$var$plainObject(args[0])) {
                    // .pan({ x: 0, y: 100 })
                    if (!this._private.panningEnabled) return this;
                    dims = args[0];
                    x = dims.x;
                    y = dims.y;
                    if ($e815fda779bc047b$var$number$1(x)) pan.x = x;
                    if ($e815fda779bc047b$var$number$1(y)) pan.y = y;
                    this.emit('pan viewport');
                }
                break;
            case 2:
                // .pan('x', 100)
                if (!this._private.panningEnabled) return this;
                dim = args[0];
                val = args[1];
                if ((dim === 'x' || dim === 'y') && $e815fda779bc047b$var$number$1(val)) pan[dim] = val;
                this.emit('pan viewport');
                break;
        }
        this.notify('viewport');
        return this; // chaining
    },
    panBy: function panBy(arg0, arg1) {
        var args = arguments;
        var pan = this._private.pan;
        var dim, val, dims, x, y;
        if (!this._private.panningEnabled) return this;
        switch(args.length){
            case 1:
                if ($e815fda779bc047b$var$plainObject(arg0)) {
                    // .panBy({ x: 0, y: 100 })
                    dims = args[0];
                    x = dims.x;
                    y = dims.y;
                    if ($e815fda779bc047b$var$number$1(x)) pan.x += x;
                    if ($e815fda779bc047b$var$number$1(y)) pan.y += y;
                    this.emit('pan viewport');
                }
                break;
            case 2:
                // .panBy('x', 100)
                dim = arg0;
                val = arg1;
                if ((dim === 'x' || dim === 'y') && $e815fda779bc047b$var$number$1(val)) pan[dim] += val;
                this.emit('pan viewport');
                break;
        }
        this.notify('viewport');
        return this; // chaining
    },
    fit: function fit(elements, padding) {
        var viewportState = this.getFitViewport(elements, padding);
        if (viewportState) {
            var _p = this._private;
            _p.zoom = viewportState.zoom;
            _p.pan = viewportState.pan;
            this.emit('pan zoom viewport');
            this.notify('viewport');
        }
        return this; // chaining
    },
    getFitViewport: function getFitViewport(elements, padding) {
        if ($e815fda779bc047b$var$number$1(elements) && padding === undefined) {
            // elements is optional
            padding = elements;
            elements = undefined;
        }
        if (!this._private.panningEnabled || !this._private.zoomingEnabled) return;
        var bb;
        if ($e815fda779bc047b$var$string(elements)) {
            var sel = elements;
            elements = this.$(sel);
        } else if ($e815fda779bc047b$var$boundingBox(elements)) {
            // assume bb
            var bbe = elements;
            bb = {
                x1: bbe.x1,
                y1: bbe.y1,
                x2: bbe.x2,
                y2: bbe.y2
            };
            bb.w = bb.x2 - bb.x1;
            bb.h = bb.y2 - bb.y1;
        } else if (!$e815fda779bc047b$var$elementOrCollection(elements)) elements = this.mutableElements();
        if ($e815fda779bc047b$var$elementOrCollection(elements) && elements.empty()) return;
         // can't fit to nothing
        bb = bb || elements.boundingBox();
        var w = this.width();
        var h = this.height();
        var zoom;
        padding = $e815fda779bc047b$var$number$1(padding) ? padding : 0;
        if (!isNaN(w) && !isNaN(h) && w > 0 && h > 0 && !isNaN(bb.w) && !isNaN(bb.h) && bb.w > 0 && bb.h > 0) {
            zoom = Math.min((w - 2 * padding) / bb.w, (h - 2 * padding) / bb.h);
            // crop zoom
            zoom = zoom > this._private.maxZoom ? this._private.maxZoom : zoom;
            zoom = zoom < this._private.minZoom ? this._private.minZoom : zoom;
            var pan = {
                // now pan to middle
                x: (w - zoom * (bb.x1 + bb.x2)) / 2,
                y: (h - zoom * (bb.y1 + bb.y2)) / 2
            };
            return {
                zoom: zoom,
                pan: pan
            };
        }
        return;
    },
    zoomRange: function zoomRange(min, max) {
        var _p = this._private;
        if (max == null) {
            var opts = min;
            min = opts.min;
            max = opts.max;
        }
        if ($e815fda779bc047b$var$number$1(min) && $e815fda779bc047b$var$number$1(max) && min <= max) {
            _p.minZoom = min;
            _p.maxZoom = max;
        } else if ($e815fda779bc047b$var$number$1(min) && max === undefined && min <= _p.maxZoom) _p.minZoom = min;
        else if ($e815fda779bc047b$var$number$1(max) && min === undefined && max >= _p.minZoom) _p.maxZoom = max;
        return this;
    },
    minZoom: function minZoom(zoom) {
        if (zoom === undefined) return this._private.minZoom;
        else return this.zoomRange({
            min: zoom
        });
    },
    maxZoom: function maxZoom(zoom) {
        if (zoom === undefined) return this._private.maxZoom;
        else return this.zoomRange({
            max: zoom
        });
    },
    getZoomedViewport: function getZoomedViewport(params) {
        var _p = this._private;
        var currentPan = _p.pan;
        var currentZoom = _p.zoom;
        var pos; // in rendered px
        var zoom;
        var bail = false;
        if (!_p.zoomingEnabled) // zooming disabled
        bail = true;
        if ($e815fda779bc047b$var$number$1(params)) // then set the zoom
        zoom = params;
        else if ($e815fda779bc047b$var$plainObject(params)) {
            // then zoom about a point
            zoom = params.level;
            if (params.position != null) pos = $e815fda779bc047b$var$modelToRenderedPosition(params.position, currentZoom, currentPan);
            else if (params.renderedPosition != null) pos = params.renderedPosition;
            if (pos != null && !_p.panningEnabled) // panning disabled
            bail = true;
        }
        // crop zoom
        zoom = zoom > _p.maxZoom ? _p.maxZoom : zoom;
        zoom = zoom < _p.minZoom ? _p.minZoom : zoom;
        // can't zoom with invalid params
        if (bail || !$e815fda779bc047b$var$number$1(zoom) || zoom === currentZoom || pos != null && (!$e815fda779bc047b$var$number$1(pos.x) || !$e815fda779bc047b$var$number$1(pos.y))) return null;
        if (pos != null) {
            // set zoom about position
            var pan1 = currentPan;
            var zoom1 = currentZoom;
            var zoom2 = zoom;
            var pan2 = {
                x: -zoom2 / zoom1 * (pos.x - pan1.x) + pos.x,
                y: -zoom2 / zoom1 * (pos.y - pan1.y) + pos.y
            };
            return {
                zoomed: true,
                panned: true,
                zoom: zoom2,
                pan: pan2
            };
        } else // just set the zoom
        return {
            zoomed: true,
            panned: false,
            zoom: zoom,
            pan: currentPan
        };
    },
    zoom: function zoom(params) {
        if (params === undefined) // get
        return this._private.zoom;
        else {
            // set
            var vp = this.getZoomedViewport(params);
            var _p = this._private;
            if (vp == null || !vp.zoomed) return this;
            _p.zoom = vp.zoom;
            if (vp.panned) {
                _p.pan.x = vp.pan.x;
                _p.pan.y = vp.pan.y;
            }
            this.emit('zoom' + (vp.panned ? ' pan' : '') + ' viewport');
            this.notify('viewport');
            return this; // chaining
        }
    },
    viewport: function viewport(opts) {
        var _p = this._private;
        var zoomDefd = true;
        var panDefd = true;
        var events = []; // to trigger
        var zoomFailed = false;
        var panFailed = false;
        if (!opts) return this;
        if (!$e815fda779bc047b$var$number$1(opts.zoom)) zoomDefd = false;
        if (!$e815fda779bc047b$var$plainObject(opts.pan)) panDefd = false;
        if (!zoomDefd && !panDefd) return this;
        if (zoomDefd) {
            var z = opts.zoom;
            if (z < _p.minZoom || z > _p.maxZoom || !_p.zoomingEnabled) zoomFailed = true;
            else {
                _p.zoom = z;
                events.push('zoom');
            }
        }
        if (panDefd && (!zoomFailed || !opts.cancelOnFailedZoom) && _p.panningEnabled) {
            var p = opts.pan;
            if ($e815fda779bc047b$var$number$1(p.x)) {
                _p.pan.x = p.x;
                panFailed = false;
            }
            if ($e815fda779bc047b$var$number$1(p.y)) {
                _p.pan.y = p.y;
                panFailed = false;
            }
            if (!panFailed) events.push('pan');
        }
        if (events.length > 0) {
            events.push('viewport');
            this.emit(events.join(' '));
            this.notify('viewport');
        }
        return this; // chaining
    },
    center: function center(elements) {
        var pan = this.getCenterPan(elements);
        if (pan) {
            this._private.pan = pan;
            this.emit('pan viewport');
            this.notify('viewport');
        }
        return this; // chaining
    },
    getCenterPan: function getCenterPan(elements, zoom) {
        if (!this._private.panningEnabled) return;
        if ($e815fda779bc047b$var$string(elements)) {
            var selector = elements;
            elements = this.mutableElements().filter(selector);
        } else if (!$e815fda779bc047b$var$elementOrCollection(elements)) elements = this.mutableElements();
        if (elements.length === 0) return;
         // can't centre pan to nothing
        var bb = elements.boundingBox();
        var w = this.width();
        var h = this.height();
        zoom = zoom === undefined ? this._private.zoom : zoom;
        var pan = {
            // middle
            x: (w - zoom * (bb.x1 + bb.x2)) / 2,
            y: (h - zoom * (bb.y1 + bb.y2)) / 2
        };
        return pan;
    },
    reset: function reset() {
        if (!this._private.panningEnabled || !this._private.zoomingEnabled) return this;
        this.viewport({
            pan: {
                x: 0,
                y: 0
            },
            zoom: 1
        });
        return this; // chaining
    },
    invalidateSize: function invalidateSize() {
        this._private.sizeCache = null;
    },
    size: function size() {
        var _p = this._private;
        var container = _p.container;
        var cy = this;
        return _p.sizeCache = _p.sizeCache || (container ? function() {
            var style = cy.window().getComputedStyle(container);
            var val = function val(name) {
                return parseFloat(style.getPropertyValue(name));
            };
            return {
                width: container.clientWidth - val('padding-left') - val('padding-right'),
                height: container.clientHeight - val('padding-top') - val('padding-bottom')
            };
        }() : {
            // fallback if no container (not 0 b/c can be used for dividing etc)
            width: 1,
            height: 1
        });
    },
    width: function width() {
        return this.size().width;
    },
    height: function height() {
        return this.size().height;
    },
    extent: function extent() {
        var pan = this._private.pan;
        var zoom = this._private.zoom;
        var rb = this.renderedExtent();
        var b = {
            x1: (rb.x1 - pan.x) / zoom,
            x2: (rb.x2 - pan.x) / zoom,
            y1: (rb.y1 - pan.y) / zoom,
            y2: (rb.y2 - pan.y) / zoom
        };
        b.w = b.x2 - b.x1;
        b.h = b.y2 - b.y1;
        return b;
    },
    renderedExtent: function renderedExtent() {
        var width = this.width();
        var height = this.height();
        return {
            x1: 0,
            y1: 0,
            x2: width,
            y2: height,
            w: width,
            h: height
        };
    },
    multiClickDebounceTime: function multiClickDebounceTime(_int) {
        if (_int) this._private.multiClickDebounceTime = _int;
        else return this._private.multiClickDebounceTime;
        return this; // chaining
    }
};
// aliases
$e815fda779bc047b$var$corefn$1.centre = $e815fda779bc047b$var$corefn$1.center;
// backwards compatibility
$e815fda779bc047b$var$corefn$1.autolockNodes = $e815fda779bc047b$var$corefn$1.autolock;
$e815fda779bc047b$var$corefn$1.autoungrabifyNodes = $e815fda779bc047b$var$corefn$1.autoungrabify;
var $e815fda779bc047b$var$fn = {
    data: $e815fda779bc047b$var$define.data({
        field: 'data',
        bindingEvent: 'data',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'data',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        updateStyle: true
    }),
    removeData: $e815fda779bc047b$var$define.removeData({
        field: 'data',
        event: 'data',
        triggerFnName: 'trigger',
        triggerEvent: true,
        updateStyle: true
    }),
    scratch: $e815fda779bc047b$var$define.data({
        field: 'scratch',
        bindingEvent: 'scratch',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'scratch',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        updateStyle: true
    }),
    removeScratch: $e815fda779bc047b$var$define.removeData({
        field: 'scratch',
        event: 'scratch',
        triggerFnName: 'trigger',
        triggerEvent: true,
        updateStyle: true
    })
};
// aliases
$e815fda779bc047b$var$fn.attr = $e815fda779bc047b$var$fn.data;
$e815fda779bc047b$var$fn.removeAttr = $e815fda779bc047b$var$fn.removeData;
var $e815fda779bc047b$var$Core = function Core(opts) {
    var cy = this;
    opts = $e815fda779bc047b$var$extend({}, opts);
    var container = opts.container;
    // allow for passing a wrapped jquery object
    // e.g. cytoscape({ container: $('#cy') })
    if (container && !$e815fda779bc047b$var$htmlElement(container) && $e815fda779bc047b$var$htmlElement(container[0])) container = container[0];
    var reg = container ? container._cyreg : null; // e.g. already registered some info (e.g. readies) via jquery
    reg = reg || {};
    if (reg && reg.cy) {
        reg.cy.destroy();
        reg = {}; // old instance => replace reg completely
    }
    var readies = reg.readies = reg.readies || [];
    if (container) container._cyreg = reg;
     // make sure container assoc'd reg points to this cy
    reg.cy = cy;
    var head = $e815fda779bc047b$var$_window !== undefined && container !== undefined && !opts.headless;
    var options = opts;
    options.layout = $e815fda779bc047b$var$extend({
        name: head ? 'grid' : 'null'
    }, options.layout);
    options.renderer = $e815fda779bc047b$var$extend({
        name: head ? 'canvas' : 'null'
    }, options.renderer);
    var defVal = function defVal(def, val, altVal) {
        if (val !== undefined) return val;
        else if (altVal !== undefined) return altVal;
        else return def;
    };
    var _p = this._private = {
        container: container,
        // html dom ele container
        ready: false,
        // whether ready has been triggered
        options: options,
        // cached options
        elements: new $e815fda779bc047b$var$Collection(this),
        // elements in the graph
        listeners: [],
        // list of listeners
        aniEles: new $e815fda779bc047b$var$Collection(this),
        // elements being animated
        data: options.data || {},
        // data for the core
        scratch: {},
        // scratch object for core
        layout: null,
        renderer: null,
        destroyed: false,
        // whether destroy was called
        notificationsEnabled: true,
        // whether notifications are sent to the renderer
        minZoom: 1e-50,
        maxZoom: 1e50,
        zoomingEnabled: defVal(true, options.zoomingEnabled),
        userZoomingEnabled: defVal(true, options.userZoomingEnabled),
        panningEnabled: defVal(true, options.panningEnabled),
        userPanningEnabled: defVal(true, options.userPanningEnabled),
        boxSelectionEnabled: defVal(true, options.boxSelectionEnabled),
        autolock: defVal(false, options.autolock, options.autolockNodes),
        autoungrabify: defVal(false, options.autoungrabify, options.autoungrabifyNodes),
        autounselectify: defVal(false, options.autounselectify),
        styleEnabled: options.styleEnabled === undefined ? head : options.styleEnabled,
        zoom: $e815fda779bc047b$var$number$1(options.zoom) ? options.zoom : 1,
        pan: {
            x: $e815fda779bc047b$var$plainObject(options.pan) && $e815fda779bc047b$var$number$1(options.pan.x) ? options.pan.x : 0,
            y: $e815fda779bc047b$var$plainObject(options.pan) && $e815fda779bc047b$var$number$1(options.pan.y) ? options.pan.y : 0
        },
        animation: {
            // object for currently-running animations
            current: [],
            queue: []
        },
        hasCompoundNodes: false,
        multiClickDebounceTime: defVal(250, options.multiClickDebounceTime)
    };
    this.createEmitter();
    // set selection type
    this.selectionType(options.selectionType);
    // init zoom bounds
    this.zoomRange({
        min: options.minZoom,
        max: options.maxZoom
    });
    var loadExtData = function loadExtData(extData, next) {
        var anyIsPromise = extData.some($e815fda779bc047b$var$promise);
        if (anyIsPromise) return $e815fda779bc047b$var$Promise$1.all(extData).then(next); // load all data asynchronously, then exec rest of init
        else next(extData); // exec synchronously for convenience
    };
    // start with the default stylesheet so we have something before loading an external stylesheet
    if (_p.styleEnabled) cy.setStyle([]);
    // create the renderer
    var rendererOptions = $e815fda779bc047b$var$extend({}, options, options.renderer); // allow rendering hints in top level options
    cy.initRenderer(rendererOptions);
    var setElesAndLayout = function setElesAndLayout(elements, onload, ondone) {
        cy.notifications(false);
        // remove old elements
        var oldEles = cy.mutableElements();
        if (oldEles.length > 0) oldEles.remove();
        if (elements != null) {
            if ($e815fda779bc047b$var$plainObject(elements) || $e815fda779bc047b$var$array(elements)) cy.add(elements);
        }
        cy.one('layoutready', function(e) {
            cy.notifications(true);
            cy.emit(e); // we missed this event by turning notifications off, so pass it on
            cy.one('load', onload);
            cy.emitAndNotify('load');
        }).one('layoutstop', function() {
            cy.one('done', ondone);
            cy.emit('done');
        });
        var layoutOpts = $e815fda779bc047b$var$extend({}, cy._private.options.layout);
        layoutOpts.eles = cy.elements();
        cy.layout(layoutOpts).run();
    };
    loadExtData([
        options.style,
        options.elements
    ], function(thens) {
        var initStyle = thens[0];
        var initEles = thens[1];
        // init style
        if (_p.styleEnabled) cy.style().append(initStyle);
        // initial load
        setElesAndLayout(initEles, function() {
            // onready
            cy.startAnimationLoop();
            _p.ready = true;
            // if a ready callback is specified as an option, the bind it
            if ($e815fda779bc047b$var$fn$6(options.ready)) cy.on('ready', options.ready);
            // bind all the ready handlers registered before creating this instance
            for(var i = 0; i < readies.length; i++){
                var fn = readies[i];
                cy.on('ready', fn);
            }
            if (reg) reg.readies = [];
             // clear b/c we've bound them all and don't want to keep it around in case a new core uses the same div etc
            cy.emit('ready');
        }, options.done);
    });
};
var $e815fda779bc047b$var$corefn = $e815fda779bc047b$var$Core.prototype; // short alias
$e815fda779bc047b$var$extend($e815fda779bc047b$var$corefn, {
    instanceString: function instanceString() {
        return 'core';
    },
    isReady: function isReady() {
        return this._private.ready;
    },
    destroyed: function destroyed() {
        return this._private.destroyed;
    },
    ready: function ready(fn) {
        if (this.isReady()) this.emitter().emit('ready', [], fn); // just calls fn as though triggered via ready event
        else this.on('ready', fn);
        return this;
    },
    destroy: function destroy() {
        var cy = this;
        if (cy.destroyed()) return;
        cy.stopAnimationLoop();
        cy.destroyRenderer();
        this.emit('destroy');
        cy._private.destroyed = true;
        return cy;
    },
    hasElementWithId: function hasElementWithId(id) {
        return this._private.elements.hasElementWithId(id);
    },
    getElementById: function getElementById(id) {
        return this._private.elements.getElementById(id);
    },
    hasCompoundNodes: function hasCompoundNodes() {
        return this._private.hasCompoundNodes;
    },
    headless: function headless() {
        return this._private.renderer.isHeadless();
    },
    styleEnabled: function styleEnabled() {
        return this._private.styleEnabled;
    },
    addToPool: function addToPool(eles) {
        this._private.elements.merge(eles);
        return this; // chaining
    },
    removeFromPool: function removeFromPool(eles) {
        this._private.elements.unmerge(eles);
        return this;
    },
    container: function container() {
        return this._private.container || null;
    },
    window: function window1() {
        var container = this._private.container;
        if (container == null) return $e815fda779bc047b$var$_window;
        var ownerDocument = this._private.container.ownerDocument;
        if (ownerDocument === undefined || ownerDocument == null) return $e815fda779bc047b$var$_window;
        return ownerDocument.defaultView || $e815fda779bc047b$var$_window;
    },
    mount: function mount(container) {
        if (container == null) return;
        var cy = this;
        var _p = cy._private;
        var options = _p.options;
        if (!$e815fda779bc047b$var$htmlElement(container) && $e815fda779bc047b$var$htmlElement(container[0])) container = container[0];
        cy.stopAnimationLoop();
        cy.destroyRenderer();
        _p.container = container;
        _p.styleEnabled = true;
        cy.invalidateSize();
        cy.initRenderer($e815fda779bc047b$var$extend({}, options, options.renderer, {
            // allow custom renderer name to be re-used, otherwise use canvas
            name: options.renderer.name === 'null' ? 'canvas' : options.renderer.name
        }));
        cy.startAnimationLoop();
        cy.style(options.style);
        cy.emit('mount');
        return cy;
    },
    unmount: function unmount() {
        var cy = this;
        cy.stopAnimationLoop();
        cy.destroyRenderer();
        cy.initRenderer({
            name: 'null'
        });
        cy.emit('unmount');
        return cy;
    },
    options: function options() {
        return $e815fda779bc047b$var$copy(this._private.options);
    },
    json: function json(obj) {
        var cy = this;
        var _p = cy._private;
        var eles = cy.mutableElements();
        var getFreshRef = function getFreshRef(ele) {
            return cy.getElementById(ele.id());
        };
        if ($e815fda779bc047b$var$plainObject(obj)) {
            // set
            cy.startBatch();
            if (obj.elements) {
                var idInJson = {};
                var updateEles = function updateEles(jsons, gr) {
                    var toAdd = [];
                    var toMod = [];
                    for(var i = 0; i < jsons.length; i++){
                        var json = jsons[i];
                        if (!json.data.id) {
                            $e815fda779bc047b$var$warn('cy.json() cannot handle elements without an ID attribute');
                            continue;
                        }
                        var id = '' + json.data.id; // id must be string
                        var ele = cy.getElementById(id);
                        idInJson[id] = true;
                        if (ele.length !== 0) // existing element should be updated
                        toMod.push({
                            ele: ele,
                            json: json
                        });
                        else // otherwise should be added
                        if (gr) {
                            json.group = gr;
                            toAdd.push(json);
                        } else toAdd.push(json);
                    }
                    cy.add(toAdd);
                    for(var _i = 0; _i < toMod.length; _i++){
                        var _toMod$_i = toMod[_i], _ele = _toMod$_i.ele, _json = _toMod$_i.json;
                        _ele.json(_json);
                    }
                };
                if ($e815fda779bc047b$var$array(obj.elements)) // elements: []
                updateEles(obj.elements);
                else {
                    // elements: { nodes: [], edges: [] }
                    var grs = [
                        'nodes',
                        'edges'
                    ];
                    for(var i = 0; i < grs.length; i++){
                        var gr = grs[i];
                        var elements = obj.elements[gr];
                        if ($e815fda779bc047b$var$array(elements)) updateEles(elements, gr);
                    }
                }
                var parentsToRemove = cy.collection();
                eles.filter(function(ele) {
                    return !idInJson[ele.id()];
                }).forEach(function(ele) {
                    if (ele.isParent()) parentsToRemove.merge(ele);
                    else ele.remove();
                });
                // so that children are not removed w/parent
                parentsToRemove.forEach(function(ele) {
                    return ele.children().move({
                        parent: null
                    });
                });
                // intermediate parents may be moved by prior line, so make sure we remove by fresh refs
                parentsToRemove.forEach(function(ele) {
                    return getFreshRef(ele).remove();
                });
            }
            if (obj.style) cy.style(obj.style);
            if (obj.zoom != null && obj.zoom !== _p.zoom) cy.zoom(obj.zoom);
            if (obj.pan) {
                if (obj.pan.x !== _p.pan.x || obj.pan.y !== _p.pan.y) cy.pan(obj.pan);
            }
            if (obj.data) cy.data(obj.data);
            var fields = [
                'minZoom',
                'maxZoom',
                'zoomingEnabled',
                'userZoomingEnabled',
                'panningEnabled',
                'userPanningEnabled',
                'boxSelectionEnabled',
                'autolock',
                'autoungrabify',
                'autounselectify',
                'multiClickDebounceTime'
            ];
            for(var _i2 = 0; _i2 < fields.length; _i2++){
                var f = fields[_i2];
                if (obj[f] != null) cy[f](obj[f]);
            }
            cy.endBatch();
            return this; // chaining
        } else {
            // get
            var flat = !!obj;
            var json = {};
            if (flat) json.elements = this.elements().map(function(ele) {
                return ele.json();
            });
            else {
                json.elements = {};
                eles.forEach(function(ele) {
                    var group = ele.group();
                    if (!json.elements[group]) json.elements[group] = [];
                    json.elements[group].push(ele.json());
                });
            }
            if (this._private.styleEnabled) json.style = cy.style().json();
            json.data = $e815fda779bc047b$var$copy(cy.data());
            var options = _p.options;
            json.zoomingEnabled = _p.zoomingEnabled;
            json.userZoomingEnabled = _p.userZoomingEnabled;
            json.zoom = _p.zoom;
            json.minZoom = _p.minZoom;
            json.maxZoom = _p.maxZoom;
            json.panningEnabled = _p.panningEnabled;
            json.userPanningEnabled = _p.userPanningEnabled;
            json.pan = $e815fda779bc047b$var$copy(_p.pan);
            json.boxSelectionEnabled = _p.boxSelectionEnabled;
            json.renderer = $e815fda779bc047b$var$copy(options.renderer);
            json.hideEdgesOnViewport = options.hideEdgesOnViewport;
            json.textureOnViewport = options.textureOnViewport;
            json.wheelSensitivity = options.wheelSensitivity;
            json.motionBlur = options.motionBlur;
            json.multiClickDebounceTime = options.multiClickDebounceTime;
            return json;
        }
    }
});
$e815fda779bc047b$var$corefn.$id = $e815fda779bc047b$var$corefn.getElementById;
[
    $e815fda779bc047b$var$corefn$9,
    $e815fda779bc047b$var$corefn$8,
    $e815fda779bc047b$var$elesfn,
    $e815fda779bc047b$var$corefn$7,
    $e815fda779bc047b$var$corefn$6,
    $e815fda779bc047b$var$corefn$5,
    $e815fda779bc047b$var$corefn$4,
    $e815fda779bc047b$var$corefn$3,
    $e815fda779bc047b$var$corefn$2,
    $e815fda779bc047b$var$corefn$1,
    $e815fda779bc047b$var$fn
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$corefn, props);
});
/* eslint-disable no-unused-vars */ var $e815fda779bc047b$var$defaults$7 = {
    fit: true,
    // whether to fit the viewport to the graph
    directed: false,
    // whether the tree is directed downwards (or edges can point in any direction if false)
    padding: 30,
    // padding on fit
    circle: false,
    // put depths in concentric circles if true, put depths top down if false
    grid: false,
    // whether to create an even grid into which the DAG is placed (circle:false only)
    spacingFactor: 1.75,
    // positive spacing factor, larger => more space between nodes (N.B. n/a if causes overlap)
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox if not enough space
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    roots: undefined,
    // the roots of the trees
    depthSort: undefined,
    // a sorting function to order nodes at equal depth. e.g. function(a, b){ return a.data('weight') - b.data('weight') }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled,
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts
};
var $e815fda779bc047b$var$deprecatedOptionDefaults = {
    maximal: false,
    // whether to shift nodes down their natural BFS depths in order to avoid upwards edges (DAGS only); setting acyclic to true sets maximal to true also
    acyclic: false // whether the tree is acyclic and thus a node could be shifted (due to the maximal option) multiple times without causing an infinite loop; setting to true sets maximal to true also; if you are uncertain whether a tree is acyclic, set to false to avoid potential infinite loops
};
/* eslint-enable */ var $e815fda779bc047b$var$getInfo = function getInfo(ele) {
    return ele.scratch('breadthfirst');
};
var $e815fda779bc047b$var$setInfo = function setInfo(ele, obj) {
    return ele.scratch('breadthfirst', obj);
};
function $e815fda779bc047b$var$BreadthFirstLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$7, $e815fda779bc047b$var$deprecatedOptionDefaults, options);
}
$e815fda779bc047b$var$BreadthFirstLayout.prototype.run = function() {
    var params = this.options;
    var options = params;
    var cy = params.cy;
    var eles = options.eles;
    var nodes = eles.nodes().filter(function(n) {
        return !n.isParent();
    });
    var graph = eles;
    var directed = options.directed;
    var maximal = options.acyclic || options.maximal || options.maximalAdjustments > 0; // maximalAdjustments for compat. w/ old code; also, setting acyclic to true sets maximal to true
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var roots;
    if ($e815fda779bc047b$var$elementOrCollection(options.roots)) roots = options.roots;
    else if ($e815fda779bc047b$var$array(options.roots)) {
        var rootsArray = [];
        for(var i = 0; i < options.roots.length; i++){
            var id = options.roots[i];
            var ele = cy.getElementById(id);
            rootsArray.push(ele);
        }
        roots = cy.collection(rootsArray);
    } else if ($e815fda779bc047b$var$string(options.roots)) roots = cy.$(options.roots);
    else if (directed) roots = nodes.roots();
    else {
        var components = eles.components();
        roots = cy.collection();
        var _loop = function _loop(_i) {
            var comp = components[_i];
            var maxDegree = comp.maxDegree(false);
            var compRoots = comp.filter(function(ele) {
                return ele.degree(false) === maxDegree;
            });
            roots = roots.add(compRoots);
        };
        for(var _i = 0; _i < components.length; _i++)_loop(_i);
    }
    var depths = [];
    var foundByBfs = {};
    var addToDepth = function addToDepth(ele, d) {
        if (depths[d] == null) depths[d] = [];
        var i = depths[d].length;
        depths[d].push(ele);
        $e815fda779bc047b$var$setInfo(ele, {
            index: i,
            depth: d
        });
    };
    var changeDepth = function changeDepth(ele, newDepth) {
        var _getInfo = $e815fda779bc047b$var$getInfo(ele), depth = _getInfo.depth, index = _getInfo.index;
        depths[depth][index] = null;
        addToDepth(ele, newDepth);
    };
    // find the depths of the nodes
    graph.bfs({
        roots: roots,
        directed: options.directed,
        visit: function visit(node, edge, pNode, i, depth) {
            var ele = node[0];
            var id = ele.id();
            addToDepth(ele, depth);
            foundByBfs[id] = true;
        }
    });
    // check for nodes not found by bfs
    var orphanNodes = [];
    for(var _i2 = 0; _i2 < nodes.length; _i2++){
        var _ele = nodes[_i2];
        if (foundByBfs[_ele.id()]) continue;
        else orphanNodes.push(_ele);
    }
    // assign the nodes a depth and index
    var assignDepthsAt = function assignDepthsAt(i) {
        var eles = depths[i];
        for(var j = 0; j < eles.length; j++){
            var _ele2 = eles[j];
            if (_ele2 == null) {
                eles.splice(j, 1);
                j--;
                continue;
            }
            $e815fda779bc047b$var$setInfo(_ele2, {
                depth: i,
                index: j
            });
        }
    };
    var assignDepths = function assignDepths() {
        for(var _i3 = 0; _i3 < depths.length; _i3++)assignDepthsAt(_i3);
    };
    var adjustMaximally = function adjustMaximally(ele, shifted) {
        var eInfo = $e815fda779bc047b$var$getInfo(ele);
        var incomers = ele.incomers().filter(function(el) {
            return el.isNode() && eles.has(el);
        });
        var maxDepth = -1;
        var id = ele.id();
        for(var k = 0; k < incomers.length; k++){
            var incmr = incomers[k];
            var iInfo = $e815fda779bc047b$var$getInfo(incmr);
            maxDepth = Math.max(maxDepth, iInfo.depth);
        }
        if (eInfo.depth <= maxDepth) {
            if (!options.acyclic && shifted[id]) return null;
            var newDepth = maxDepth + 1;
            changeDepth(ele, newDepth);
            shifted[id] = newDepth;
            return true;
        }
        return false;
    };
    // for the directed case, try to make the edges all go down (i.e. depth i => depth i + 1)
    if (directed && maximal) {
        var Q = [];
        var shifted = {};
        var enqueue = function enqueue(n) {
            return Q.push(n);
        };
        var dequeue = function dequeue() {
            return Q.shift();
        };
        nodes.forEach(function(n) {
            return Q.push(n);
        });
        while(Q.length > 0){
            var _ele3 = dequeue();
            var didShift = adjustMaximally(_ele3, shifted);
            if (didShift) _ele3.outgoers().filter(function(el) {
                return el.isNode() && eles.has(el);
            }).forEach(enqueue);
            else if (didShift === null) {
                $e815fda779bc047b$var$warn('Detected double maximal shift for node `' + _ele3.id() + '`.  Bailing maximal adjustment due to cycle.  Use `options.maximal: true` only on DAGs.');
                break; // exit on failure
            }
        }
    }
    assignDepths(); // clear holes
    // find min distance we need to leave between nodes
    var minDistance = 0;
    if (options.avoidOverlap) for(var _i4 = 0; _i4 < nodes.length; _i4++){
        var n = nodes[_i4];
        var nbb = n.layoutDimensions(options);
        var w = nbb.w;
        var h = nbb.h;
        minDistance = Math.max(minDistance, w, h);
    }
    // get the weighted percent for an element based on its connectivity to other levels
    var cachedWeightedPercent = {};
    var getWeightedPercent = function getWeightedPercent(ele) {
        if (cachedWeightedPercent[ele.id()]) return cachedWeightedPercent[ele.id()];
        var eleDepth = $e815fda779bc047b$var$getInfo(ele).depth;
        var neighbors = ele.neighborhood();
        var percent = 0;
        var samples = 0;
        for(var _i5 = 0; _i5 < neighbors.length; _i5++){
            var neighbor = neighbors[_i5];
            if (neighbor.isEdge() || neighbor.isParent() || !nodes.has(neighbor)) continue;
            var bf = $e815fda779bc047b$var$getInfo(neighbor);
            if (bf == null) continue;
            var index = bf.index;
            var depth = bf.depth;
            // unassigned neighbours shouldn't affect the ordering
            if (index == null || depth == null) continue;
            var nDepth = depths[depth].length;
            if (depth < eleDepth) {
                // only get influenced by elements above
                percent += index / nDepth;
                samples++;
            }
        }
        samples = Math.max(1, samples);
        percent = percent / samples;
        if (samples === 0) // put lone nodes at the start
        percent = 0;
        cachedWeightedPercent[ele.id()] = percent;
        return percent;
    };
    // rearrange the indices in each depth level based on connectivity
    var sortFn = function sortFn(a, b) {
        var apct = getWeightedPercent(a);
        var bpct = getWeightedPercent(b);
        var diff = apct - bpct;
        if (diff === 0) return $e815fda779bc047b$var$ascending(a.id(), b.id()); // make sure sort doesn't have don't-care comparisons
        else return diff;
    };
    if (options.depthSort !== undefined) sortFn = options.depthSort;
    // sort each level to make connected nodes closer
    for(var _i6 = 0; _i6 < depths.length; _i6++){
        depths[_i6].sort(sortFn);
        assignDepthsAt(_i6);
    }
    // assign orphan nodes to a new top-level depth
    var orphanDepth = [];
    for(var _i7 = 0; _i7 < orphanNodes.length; _i7++)orphanDepth.push(orphanNodes[_i7]);
    depths.unshift(orphanDepth);
    assignDepths();
    var biggestDepthSize = 0;
    for(var _i8 = 0; _i8 < depths.length; _i8++)biggestDepthSize = Math.max(depths[_i8].length, biggestDepthSize);
    var center = {
        x: bb.x1 + bb.w / 2,
        y: bb.x1 + bb.h / 2
    };
    var maxDepthSize = depths.reduce(function(max, eles) {
        return Math.max(max, eles.length);
    }, 0);
    var getPosition = function getPosition(ele) {
        var _getInfo2 = $e815fda779bc047b$var$getInfo(ele), depth = _getInfo2.depth, index = _getInfo2.index;
        var depthSize = depths[depth].length;
        var distanceX = Math.max(bb.w / ((options.grid ? maxDepthSize : depthSize) + 1), minDistance);
        var distanceY = Math.max(bb.h / (depths.length + 1), minDistance);
        var radiusStepSize = Math.min(bb.w / 2 / depths.length, bb.h / 2 / depths.length);
        radiusStepSize = Math.max(radiusStepSize, minDistance);
        if (!options.circle) {
            var epos = {
                x: center.x + (index + 1 - (depthSize + 1) / 2) * distanceX,
                y: (depth + 1) * distanceY
            };
            return epos;
        } else {
            var radius = radiusStepSize * depth + radiusStepSize - (depths.length > 0 && depths[0].length <= 3 ? radiusStepSize / 2 : 0);
            var theta = 2 * Math.PI / depths[depth].length * index;
            if (depth === 0 && depths[0].length === 1) radius = 1;
            return {
                x: center.x + radius * Math.cos(theta),
                y: center.y + radius * Math.sin(theta)
            };
        }
    };
    eles.nodes().layoutPositions(this, options, getPosition);
    return this; // chaining
};
var $e815fda779bc047b$var$defaults$6 = {
    fit: true,
    // whether to fit the viewport to the graph
    padding: 30,
    // the padding on fit
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox and radius if not enough space
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    radius: undefined,
    // the radius of the circle
    startAngle: 1.5 * Math.PI,
    // where nodes start in radians
    sweep: undefined,
    // how many radians should be between the first and last node (defaults to full circle)
    clockwise: true,
    // whether the layout should go clockwise (true) or counterclockwise/anticlockwise (false)
    sort: undefined,
    // a sorting function to order the nodes; e.g. function(a, b){ return a.data('weight') - b.data('weight') }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts 
};
function $e815fda779bc047b$var$CircleLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$6, options);
}
$e815fda779bc047b$var$CircleLayout.prototype.run = function() {
    var params = this.options;
    var options = params;
    var cy = params.cy;
    var eles = options.eles;
    var clockwise = options.counterclockwise !== undefined ? !options.counterclockwise : options.clockwise;
    var nodes = eles.nodes().not(':parent');
    if (options.sort) nodes = nodes.sort(options.sort);
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var center = {
        x: bb.x1 + bb.w / 2,
        y: bb.y1 + bb.h / 2
    };
    var sweep = options.sweep === undefined ? 2 * Math.PI - 2 * Math.PI / nodes.length : options.sweep;
    var dTheta = sweep / Math.max(1, nodes.length - 1);
    var r;
    var minDistance = 0;
    for(var i = 0; i < nodes.length; i++){
        var n = nodes[i];
        var nbb = n.layoutDimensions(options);
        var w = nbb.w;
        var h = nbb.h;
        minDistance = Math.max(minDistance, w, h);
    }
    if ($e815fda779bc047b$var$number$1(options.radius)) r = options.radius;
    else if (nodes.length <= 1) r = 0;
    else r = Math.min(bb.h, bb.w) / 2 - minDistance;
    // calculate the radius
    if (nodes.length > 1 && options.avoidOverlap) {
        // but only if more than one node (can't overlap)
        minDistance *= 1.75; // just to have some nice spacing
        var dcos = Math.cos(dTheta) - Math.cos(0);
        var dsin = Math.sin(dTheta) - Math.sin(0);
        var rMin = Math.sqrt(minDistance * minDistance / (dcos * dcos + dsin * dsin)); // s.t. no nodes overlapping
        r = Math.max(rMin, r);
    }
    var getPos = function getPos(ele, i) {
        var theta = options.startAngle + i * dTheta * (clockwise ? 1 : -1);
        var rx = r * Math.cos(theta);
        var ry = r * Math.sin(theta);
        var pos = {
            x: center.x + rx,
            y: center.y + ry
        };
        return pos;
    };
    eles.nodes().layoutPositions(this, options, getPos);
    return this; // chaining
};
var $e815fda779bc047b$var$defaults$5 = {
    fit: true,
    // whether to fit the viewport to the graph
    padding: 30,
    // the padding on fit
    startAngle: 1.5 * Math.PI,
    // where nodes start in radians
    sweep: undefined,
    // how many radians should be between the first and last node (defaults to full circle)
    clockwise: true,
    // whether the layout should go clockwise (true) or counterclockwise/anticlockwise (false)
    equidistant: false,
    // whether levels have an equal radial distance betwen them, may cause bounding box overflow
    minNodeSpacing: 10,
    // min spacing between outside of nodes (used for radius adjustment)
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox if not enough space
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    height: undefined,
    // height of layout area (overrides container height)
    width: undefined,
    // width of layout area (overrides container width)
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    concentric: function concentric(node) {
        // returns numeric value for each node, placing higher nodes in levels towards the centre
        return node.degree();
    },
    levelWidth: function levelWidth(nodes) {
        // the variation of concentric values in each level
        return nodes.maxDegree() / 4;
    },
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts
};
function $e815fda779bc047b$var$ConcentricLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$5, options);
}
$e815fda779bc047b$var$ConcentricLayout.prototype.run = function() {
    var params = this.options;
    var options = params;
    var clockwise = options.counterclockwise !== undefined ? !options.counterclockwise : options.clockwise;
    var cy = params.cy;
    var eles = options.eles;
    var nodes = eles.nodes().not(':parent');
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var center = {
        x: bb.x1 + bb.w / 2,
        y: bb.y1 + bb.h / 2
    };
    var nodeValues = []; // { node, value }
    var maxNodeSize = 0;
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        var value = void 0;
        // calculate the node value
        value = options.concentric(node);
        nodeValues.push({
            value: value,
            node: node
        });
        // for style mapping
        node._private.scratch.concentric = value;
    }
    // in case we used the `concentric` in style
    nodes.updateStyle();
    // calculate max size now based on potentially updated mappers
    for(var _i = 0; _i < nodes.length; _i++){
        var _node = nodes[_i];
        var nbb = _node.layoutDimensions(options);
        maxNodeSize = Math.max(maxNodeSize, nbb.w, nbb.h);
    }
    // sort node values in descreasing order
    nodeValues.sort(function(a, b) {
        return b.value - a.value;
    });
    var levelWidth = options.levelWidth(nodes);
    // put the values into levels
    var levels = [
        []
    ];
    var currentLevel = levels[0];
    for(var _i2 = 0; _i2 < nodeValues.length; _i2++){
        var val = nodeValues[_i2];
        if (currentLevel.length > 0) {
            var diff = Math.abs(currentLevel[0].value - val.value);
            if (diff >= levelWidth) {
                currentLevel = [];
                levels.push(currentLevel);
            }
        }
        currentLevel.push(val);
    }
    // create positions from levels
    var minDist = maxNodeSize + options.minNodeSpacing; // min dist between nodes
    if (!options.avoidOverlap) {
        // then strictly constrain to bb
        var firstLvlHasMulti = levels.length > 0 && levels[0].length > 1;
        var maxR = Math.min(bb.w, bb.h) / 2 - minDist;
        var rStep = maxR / (levels.length + firstLvlHasMulti ? 1 : 0);
        minDist = Math.min(minDist, rStep);
    }
    // find the metrics for each level
    var r = 0;
    for(var _i3 = 0; _i3 < levels.length; _i3++){
        var level = levels[_i3];
        var sweep = options.sweep === undefined ? 2 * Math.PI - 2 * Math.PI / level.length : options.sweep;
        var dTheta = level.dTheta = sweep / Math.max(1, level.length - 1);
        // calculate the radius
        if (level.length > 1 && options.avoidOverlap) {
            // but only if more than one node (can't overlap)
            var dcos = Math.cos(dTheta) - Math.cos(0);
            var dsin = Math.sin(dTheta) - Math.sin(0);
            var rMin = Math.sqrt(minDist * minDist / (dcos * dcos + dsin * dsin)); // s.t. no nodes overlapping
            r = Math.max(rMin, r);
        }
        level.r = r;
        r += minDist;
    }
    if (options.equidistant) {
        var rDeltaMax = 0;
        var _r = 0;
        for(var _i4 = 0; _i4 < levels.length; _i4++){
            var _level = levels[_i4];
            var rDelta = _level.r - _r;
            rDeltaMax = Math.max(rDeltaMax, rDelta);
        }
        _r = 0;
        for(var _i5 = 0; _i5 < levels.length; _i5++){
            var _level2 = levels[_i5];
            if (_i5 === 0) _r = _level2.r;
            _level2.r = _r;
            _r += rDeltaMax;
        }
    }
    // calculate the node positions
    var pos = {}; // id => position
    for(var _i6 = 0; _i6 < levels.length; _i6++){
        var _level3 = levels[_i6];
        var _dTheta = _level3.dTheta;
        var _r2 = _level3.r;
        for(var j = 0; j < _level3.length; j++){
            var _val = _level3[j];
            var theta = options.startAngle + (clockwise ? 1 : -1) * _dTheta * j;
            var p = {
                x: center.x + _r2 * Math.cos(theta),
                y: center.y + _r2 * Math.sin(theta)
            };
            pos[_val.node.id()] = p;
        }
    }
    // position the nodes
    eles.nodes().layoutPositions(this, options, function(ele) {
        var id = ele.id();
        return pos[id];
    });
    return this; // chaining
};
/*
The CoSE layout was written by Gerardo Huck.
https://www.linkedin.com/in/gerardohuck/

Based on the following article:
http://dl.acm.org/citation.cfm?id=1498047

Modifications tracked on Github.
*/ var $e815fda779bc047b$var$DEBUG;
/**
 * @brief :  default layout options
 */ var $e815fda779bc047b$var$defaults$4 = {
    // Called on `layoutready`
    ready: function ready() {},
    // Called on `layoutstop`
    stop: function stop() {},
    // Whether to animate while running the layout
    // true : Animate continuously as the layout is running
    // false : Just show the end result
    // 'end' : Animate with the end result, from the initial positions to the end positions
    animate: true,
    // Easing of the animation for animate:'end'
    animationEasing: undefined,
    // The duration of the animation for animate:'end'
    animationDuration: undefined,
    // A function that determines whether the node should be animated
    // All nodes animated by default on animate enabled
    // Non-animated nodes are positioned immediately when the layout starts
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // The layout animates only after this many milliseconds for animate:true
    // (prevents flashing on fast runs)
    animationThreshold: 250,
    // Number of iterations between consecutive screen positions update
    refresh: 20,
    // Whether to fit the network view after when done
    fit: true,
    // Padding on fit
    padding: 30,
    // Constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    boundingBox: undefined,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    nodeDimensionsIncludeLabels: false,
    // Randomize the initial positions of the nodes (true) or use existing positions (false)
    randomize: false,
    // Extra spacing between components in non-compound graphs
    componentSpacing: 40,
    // Node repulsion (non overlapping) multiplier
    nodeRepulsion: function nodeRepulsion(node) {
        return 2048;
    },
    // Node repulsion (overlapping) multiplier
    nodeOverlap: 4,
    // Ideal edge (non nested) length
    idealEdgeLength: function idealEdgeLength(edge) {
        return 32;
    },
    // Divisor to compute edge forces
    edgeElasticity: function edgeElasticity(edge) {
        return 32;
    },
    // Nesting factor (multiplier) to compute ideal edge length for nested edges
    nestingFactor: 1.2,
    // Gravity force (constant)
    gravity: 1,
    // Maximum number of iterations to perform
    numIter: 1000,
    // Initial temperature (maximum node displacement)
    initialTemp: 1000,
    // Cooling factor (how the temperature is reduced between consecutive iterations
    coolingFactor: 0.99,
    // Lower temperature threshold (below this point the layout will end)
    minTemp: 1.0
};
/**
 * @brief       : constructor
 * @arg options : object containing layout options
 */ function $e815fda779bc047b$var$CoseLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$4, options);
    this.options.layout = this;
    // Exclude any edge that has a source or target node that is not in the set of passed-in nodes
    var nodes = this.options.eles.nodes();
    var edges = this.options.eles.edges();
    var notEdges = edges.filter(function(e) {
        var sourceId = e.source().data('id');
        var targetId = e.target().data('id');
        var hasSource = nodes.some(function(n) {
            return n.data('id') === sourceId;
        });
        var hasTarget = nodes.some(function(n) {
            return n.data('id') === targetId;
        });
        return !hasSource || !hasTarget;
    });
    this.options.eles = this.options.eles.not(notEdges);
}
/**
 * @brief : runs the layout
 */ $e815fda779bc047b$var$CoseLayout.prototype.run = function() {
    var options = this.options;
    var cy = options.cy;
    var layout = this;
    layout.stopped = false;
    if (options.animate === true || options.animate === false) layout.emit({
        type: 'layoutstart',
        layout: layout
    });
    // Set DEBUG - Global variable
    if (true === options.debug) $e815fda779bc047b$var$DEBUG = true;
    else $e815fda779bc047b$var$DEBUG = false;
    // Initialize layout info
    var layoutInfo = $e815fda779bc047b$var$createLayoutInfo(cy, layout, options);
    // Show LayoutInfo contents if debugging
    if ($e815fda779bc047b$var$DEBUG) $e815fda779bc047b$var$printLayoutInfo(layoutInfo);
    // If required, randomize node positions
    if (options.randomize) $e815fda779bc047b$var$randomizePositions(layoutInfo);
    var startTime = $e815fda779bc047b$var$performanceNow();
    var refresh = function refresh() {
        $e815fda779bc047b$var$refreshPositions(layoutInfo, cy, options);
        // Fit the graph if necessary
        if (true === options.fit) cy.fit(options.padding);
    };
    var mainLoop = function mainLoop(i) {
        if (layout.stopped || i >= options.numIter) // logDebug("Layout manually stopped. Stopping computation in step " + i);
        return false;
        // Do one step in the phisical simulation
        $e815fda779bc047b$var$step(layoutInfo, options);
        // Update temperature
        layoutInfo.temperature = layoutInfo.temperature * options.coolingFactor;
        // logDebug("New temperature: " + layoutInfo.temperature);
        if (layoutInfo.temperature < options.minTemp) // logDebug("Temperature drop below minimum threshold. Stopping computation in step " + i);
        return false;
        return true;
    };
    var done = function done() {
        if (options.animate === true || options.animate === false) {
            refresh();
            // Layout has finished
            layout.one('layoutstop', options.stop);
            layout.emit({
                type: 'layoutstop',
                layout: layout
            });
        } else {
            var nodes = options.eles.nodes();
            var getScaledPos = $e815fda779bc047b$var$getScaleInBoundsFn(layoutInfo, options, nodes);
            nodes.layoutPositions(layout, options, getScaledPos);
        }
    };
    var i = 0;
    var loopRet = true;
    if (options.animate === true) {
        var frame = function frame() {
            var f = 0;
            while(loopRet && f < options.refresh){
                loopRet = mainLoop(i);
                i++;
                f++;
            }
            if (!loopRet) {
                // it's done
                $e815fda779bc047b$var$separateComponents(layoutInfo, options);
                done();
            } else {
                var now = $e815fda779bc047b$var$performanceNow();
                if (now - startTime >= options.animationThreshold) refresh();
                $e815fda779bc047b$var$requestAnimationFrame(frame);
            }
        };
        frame();
    } else {
        while(loopRet){
            loopRet = mainLoop(i);
            i++;
        }
        $e815fda779bc047b$var$separateComponents(layoutInfo, options);
        done();
    }
    return this; // chaining
};
/**
 * @brief : called on continuous layouts to stop them before they finish
 */ $e815fda779bc047b$var$CoseLayout.prototype.stop = function() {
    this.stopped = true;
    if (this.thread) this.thread.stop();
    this.emit('layoutstop');
    return this; // chaining
};
$e815fda779bc047b$var$CoseLayout.prototype.destroy = function() {
    if (this.thread) this.thread.stop();
    return this; // chaining
};
/**
 * @brief     : Creates an object which is contains all the data
 *              used in the layout process
 * @arg cy    : cytoscape.js object
 * @return    : layoutInfo object initialized
 */ var $e815fda779bc047b$var$createLayoutInfo = function createLayoutInfo(cy, layout, options) {
    // Shortcut
    var edges = options.eles.edges();
    var nodes = options.eles.nodes();
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var layoutInfo = {
        isCompound: cy.hasCompoundNodes(),
        layoutNodes: [],
        idToIndex: {},
        nodeSize: nodes.size(),
        graphSet: [],
        indexToGraph: [],
        layoutEdges: [],
        edgeSize: edges.size(),
        temperature: options.initialTemp,
        clientWidth: bb.w,
        clientHeight: bb.h,
        boundingBox: bb
    };
    var components = options.eles.components();
    var id2cmptId = {};
    for(var i = 0; i < components.length; i++){
        var component = components[i];
        for(var j = 0; j < component.length; j++){
            var node = component[j];
            id2cmptId[node.id()] = i;
        }
    }
    // Iterate over all nodes, creating layout nodes
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = nodes[i];
        var nbb = n.layoutDimensions(options);
        var tempNode = {};
        tempNode.isLocked = n.locked();
        tempNode.id = n.data('id');
        tempNode.parentId = n.data('parent');
        tempNode.cmptId = id2cmptId[n.id()];
        tempNode.children = [];
        tempNode.positionX = n.position('x');
        tempNode.positionY = n.position('y');
        tempNode.offsetX = 0;
        tempNode.offsetY = 0;
        tempNode.height = nbb.w;
        tempNode.width = nbb.h;
        tempNode.maxX = tempNode.positionX + tempNode.width / 2;
        tempNode.minX = tempNode.positionX - tempNode.width / 2;
        tempNode.maxY = tempNode.positionY + tempNode.height / 2;
        tempNode.minY = tempNode.positionY - tempNode.height / 2;
        tempNode.padLeft = parseFloat(n.style('padding'));
        tempNode.padRight = parseFloat(n.style('padding'));
        tempNode.padTop = parseFloat(n.style('padding'));
        tempNode.padBottom = parseFloat(n.style('padding'));
        // forces
        tempNode.nodeRepulsion = $e815fda779bc047b$var$fn$6(options.nodeRepulsion) ? options.nodeRepulsion(n) : options.nodeRepulsion;
        // Add new node
        layoutInfo.layoutNodes.push(tempNode);
        // Add entry to id-index map
        layoutInfo.idToIndex[tempNode.id] = i;
    }
    // Inline implementation of a queue, used for traversing the graph in BFS order
    var queue = [];
    var start = 0; // Points to the start the queue
    var end = -1; // Points to the end of the queue
    var tempGraph = [];
    // Second pass to add child information and
    // initialize queue for hierarchical traversal
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        var p_id = n.parentId;
        // Check if node n has a parent node
        if (null != p_id) // Add node Id to parent's list of children
        layoutInfo.layoutNodes[layoutInfo.idToIndex[p_id]].children.push(n.id);
        else {
            // If a node doesn't have a parent, then it's in the root graph
            queue[++end] = n.id;
            tempGraph.push(n.id);
        }
    }
    // Add root graph to graphSet
    layoutInfo.graphSet.push(tempGraph);
    // Traverse the graph, level by level,
    while(start <= end){
        // Get the node to visit and remove it from queue
        var node_id = queue[start++];
        var node_ix = layoutInfo.idToIndex[node_id];
        var node = layoutInfo.layoutNodes[node_ix];
        var children = node.children;
        if (children.length > 0) {
            // Add children nodes as a new graph to graph set
            layoutInfo.graphSet.push(children);
            // Add children to que queue to be visited
            for(var i = 0; i < children.length; i++)queue[++end] = children[i];
        }
    }
    // Create indexToGraph map
    for(var i = 0; i < layoutInfo.graphSet.length; i++){
        var graph = layoutInfo.graphSet[i];
        for(var j = 0; j < graph.length; j++){
            var index = layoutInfo.idToIndex[graph[j]];
            layoutInfo.indexToGraph[index] = i;
        }
    }
    // Iterate over all edges, creating Layout Edges
    for(var i = 0; i < layoutInfo.edgeSize; i++){
        var e = edges[i];
        var tempEdge = {};
        tempEdge.id = e.data('id');
        tempEdge.sourceId = e.data('source');
        tempEdge.targetId = e.data('target');
        // Compute ideal length
        var idealLength = $e815fda779bc047b$var$fn$6(options.idealEdgeLength) ? options.idealEdgeLength(e) : options.idealEdgeLength;
        var elasticity = $e815fda779bc047b$var$fn$6(options.edgeElasticity) ? options.edgeElasticity(e) : options.edgeElasticity;
        // Check if it's an inter graph edge
        var sourceIx = layoutInfo.idToIndex[tempEdge.sourceId];
        var targetIx = layoutInfo.idToIndex[tempEdge.targetId];
        var sourceGraph = layoutInfo.indexToGraph[sourceIx];
        var targetGraph = layoutInfo.indexToGraph[targetIx];
        if (sourceGraph != targetGraph) {
            // Find lowest common graph ancestor
            var lca = $e815fda779bc047b$var$findLCA(tempEdge.sourceId, tempEdge.targetId, layoutInfo);
            // Compute sum of node depths, relative to lca graph
            var lcaGraph = layoutInfo.graphSet[lca];
            var depth = 0;
            // Source depth
            var tempNode = layoutInfo.layoutNodes[sourceIx];
            while(-1 === lcaGraph.indexOf(tempNode.id)){
                tempNode = layoutInfo.layoutNodes[layoutInfo.idToIndex[tempNode.parentId]];
                depth++;
            }
            // Target depth
            tempNode = layoutInfo.layoutNodes[targetIx];
            while(-1 === lcaGraph.indexOf(tempNode.id)){
                tempNode = layoutInfo.layoutNodes[layoutInfo.idToIndex[tempNode.parentId]];
                depth++;
            }
            // logDebug('LCA of nodes ' + tempEdge.sourceId + ' and ' + tempEdge.targetId +
            //  ". Index: " + lca + " Contents: " + lcaGraph.toString() +
            //  ". Depth: " + depth);
            // Update idealLength
            idealLength *= depth * options.nestingFactor;
        }
        tempEdge.idealLength = idealLength;
        tempEdge.elasticity = elasticity;
        layoutInfo.layoutEdges.push(tempEdge);
    }
    // Finally, return layoutInfo object
    return layoutInfo;
};
/**
 * @brief : This function finds the index of the lowest common
 *          graph ancestor between 2 nodes in the subtree
 *          (from the graph hierarchy induced tree) whose
 *          root is graphIx
 *
 * @arg node1: node1's ID
 * @arg node2: node2's ID
 * @arg layoutInfo: layoutInfo object
 *
 */ var $e815fda779bc047b$var$findLCA = function findLCA(node1, node2, layoutInfo) {
    // Find their common ancester, starting from the root graph
    var res = $e815fda779bc047b$var$findLCA_aux(node1, node2, 0, layoutInfo);
    if (2 > res.count) // If aux function couldn't find the common ancester,
    // then it is the root graph
    return 0;
    else return res.graph;
};
/**
 * @brief          : Auxiliary function used for LCA computation
 *
 * @arg node1      : node1's ID
 * @arg node2      : node2's ID
 * @arg graphIx    : subgraph index
 * @arg layoutInfo : layoutInfo object
 *
 * @return         : object of the form {count: X, graph: Y}, where:
 *                   X is the number of ancestors (max: 2) found in
 *                   graphIx (and it's subgraphs),
 *                   Y is the graph index of the lowest graph containing
 *                   all X nodes
 */ var $e815fda779bc047b$var$findLCA_aux = function findLCA_aux(node1, node2, graphIx, layoutInfo) {
    var graph = layoutInfo.graphSet[graphIx];
    // If both nodes belongs to graphIx
    if (-1 < graph.indexOf(node1) && -1 < graph.indexOf(node2)) return {
        count: 2,
        graph: graphIx
    };
    // Make recursive calls for all subgraphs
    var c = 0;
    for(var i = 0; i < graph.length; i++){
        var nodeId = graph[i];
        var nodeIx = layoutInfo.idToIndex[nodeId];
        var children = layoutInfo.layoutNodes[nodeIx].children;
        // If the node has no child, skip it
        if (0 === children.length) continue;
        var childGraphIx = layoutInfo.indexToGraph[layoutInfo.idToIndex[children[0]]];
        var result = findLCA_aux(node1, node2, childGraphIx, layoutInfo);
        if (0 === result.count) continue;
        else if (1 === result.count) {
            // One of (node1, node2) is present in this subgraph
            c++;
            if (2 === c) break;
        } else // Both nodes are present in this subgraph
        return result;
    }
    return {
        count: c,
        graph: graphIx
    };
};
/**
 * @brief: printsLayoutInfo into js console
 *         Only used for debbuging
 */ var $e815fda779bc047b$var$printLayoutInfo;
/**
 * @brief : Randomizes the position of all nodes
 */ var $e815fda779bc047b$var$randomizePositions = function randomizePositions(layoutInfo, cy) {
    var width = layoutInfo.clientWidth;
    var height = layoutInfo.clientHeight;
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        // No need to randomize compound nodes or locked nodes
        if (0 === n.children.length && !n.isLocked) {
            n.positionX = Math.random() * width;
            n.positionY = Math.random() * height;
        }
    }
};
var $e815fda779bc047b$var$getScaleInBoundsFn = function getScaleInBoundsFn(layoutInfo, options, nodes) {
    var bb = layoutInfo.boundingBox;
    var coseBB = {
        x1: Infinity,
        x2: -Infinity,
        y1: Infinity,
        y2: -Infinity
    };
    if (options.boundingBox) {
        nodes.forEach(function(node) {
            var lnode = layoutInfo.layoutNodes[layoutInfo.idToIndex[node.data('id')]];
            coseBB.x1 = Math.min(coseBB.x1, lnode.positionX);
            coseBB.x2 = Math.max(coseBB.x2, lnode.positionX);
            coseBB.y1 = Math.min(coseBB.y1, lnode.positionY);
            coseBB.y2 = Math.max(coseBB.y2, lnode.positionY);
        });
        coseBB.w = coseBB.x2 - coseBB.x1;
        coseBB.h = coseBB.y2 - coseBB.y1;
    }
    return function(ele, i) {
        var lnode = layoutInfo.layoutNodes[layoutInfo.idToIndex[ele.data('id')]];
        if (options.boundingBox) {
            // then add extra bounding box constraint
            var pctX = (lnode.positionX - coseBB.x1) / coseBB.w;
            var pctY = (lnode.positionY - coseBB.y1) / coseBB.h;
            return {
                x: bb.x1 + pctX * bb.w,
                y: bb.y1 + pctY * bb.h
            };
        } else return {
            x: lnode.positionX,
            y: lnode.positionY
        };
    };
};
/**
 * @brief          : Updates the positions of nodes in the network
 * @arg layoutInfo : LayoutInfo object
 * @arg cy         : Cytoscape object
 * @arg options    : Layout options
 */ var $e815fda779bc047b$var$refreshPositions = function refreshPositions(layoutInfo, cy, options) {
    // var s = 'Refreshing positions';
    // logDebug(s);
    var layout = options.layout;
    var nodes = options.eles.nodes();
    var getScaledPos = $e815fda779bc047b$var$getScaleInBoundsFn(layoutInfo, options, nodes);
    nodes.positions(getScaledPos);
    // Trigger layoutReady only on first call
    if (true !== layoutInfo.ready) {
        // s = 'Triggering layoutready';
        // logDebug(s);
        layoutInfo.ready = true;
        layout.one('layoutready', options.ready);
        layout.emit({
            type: 'layoutready',
            layout: this
        });
    }
};
/**
 * @brief : Logs a debug message in JS console, if DEBUG is ON
 */ // var logDebug = function(text) {
//   if (DEBUG) {
//     console.debug(text);
//   }
// };
/**
 * @brief          : Performs one iteration of the physical simulation
 * @arg layoutInfo : LayoutInfo object already initialized
 * @arg cy         : Cytoscape object
 * @arg options    : Layout options
 */ var $e815fda779bc047b$var$step = function step(layoutInfo, options, _step) {
    // var s = "\n\n###############################";
    // s += "\nSTEP: " + step;
    // s += "\n###############################\n";
    // logDebug(s);
    // Calculate node repulsions
    $e815fda779bc047b$var$calculateNodeForces(layoutInfo, options);
    // Calculate edge forces
    $e815fda779bc047b$var$calculateEdgeForces(layoutInfo);
    // Calculate gravity forces
    $e815fda779bc047b$var$calculateGravityForces(layoutInfo, options);
    // Propagate forces from parent to child
    $e815fda779bc047b$var$propagateForces(layoutInfo);
    // Update positions based on calculated forces
    $e815fda779bc047b$var$updatePositions(layoutInfo);
};
/**
 * @brief : Computes the node repulsion forces
 */ var $e815fda779bc047b$var$calculateNodeForces = function calculateNodeForces(layoutInfo, options) {
    // Go through each of the graphs in graphSet
    // Nodes only repel each other if they belong to the same graph
    // var s = 'calculateNodeForces';
    // logDebug(s);
    for(var i = 0; i < layoutInfo.graphSet.length; i++){
        var graph = layoutInfo.graphSet[i];
        var numNodes = graph.length;
        // s = "Set: " + graph.toString();
        // logDebug(s);
        // Now get all the pairs of nodes
        // Only get each pair once, (A, B) = (B, A)
        for(var j = 0; j < numNodes; j++){
            var node1 = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[j]]];
            for(var k = j + 1; k < numNodes; k++){
                var node2 = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[k]]];
                $e815fda779bc047b$var$nodeRepulsion(node1, node2, layoutInfo, options);
            }
        }
    }
};
var $e815fda779bc047b$var$randomDistance = function randomDistance(max) {
    return -max + 2 * max * Math.random();
};
/**
 * @brief : Compute the node repulsion forces between a pair of nodes
 */ var $e815fda779bc047b$var$nodeRepulsion = function nodeRepulsion(node1, node2, layoutInfo, options) {
    // var s = "Node repulsion. Node1: " + node1.id + " Node2: " + node2.id;
    var cmptId1 = node1.cmptId;
    var cmptId2 = node2.cmptId;
    if (cmptId1 !== cmptId2 && !layoutInfo.isCompound) return;
    // Get direction of line connecting both node centers
    var directionX = node2.positionX - node1.positionX;
    var directionY = node2.positionY - node1.positionY;
    var maxRandDist = 1;
    // s += "\ndirectionX: " + directionX + ", directionY: " + directionY;
    // If both centers are the same, apply a random force
    if (0 === directionX && 0 === directionY) {
        directionX = $e815fda779bc047b$var$randomDistance(maxRandDist);
        directionY = $e815fda779bc047b$var$randomDistance(maxRandDist);
    }
    var overlap = $e815fda779bc047b$var$nodesOverlap(node1, node2, directionX, directionY);
    if (overlap > 0) {
        // s += "\nNodes DO overlap.";
        // s += "\nOverlap: " + overlap;
        // If nodes overlap, repulsion force is proportional
        // to the overlap
        var force = options.nodeOverlap * overlap;
        // Compute the module and components of the force vector
        var distance = Math.sqrt(directionX * directionX + directionY * directionY);
        // s += "\nDistance: " + distance;
        var forceX = force * directionX / distance;
        var forceY = force * directionY / distance;
    } else {
        // s += "\nNodes do NOT overlap.";
        // If there's no overlap, force is inversely proportional
        // to squared distance
        // Get clipping points for both nodes
        var point1 = $e815fda779bc047b$var$findClippingPoint(node1, directionX, directionY);
        var point2 = $e815fda779bc047b$var$findClippingPoint(node2, -1 * directionX, -1 * directionY);
        // Use clipping points to compute distance
        var distanceX = point2.x - point1.x;
        var distanceY = point2.y - point1.y;
        var distanceSqr = distanceX * distanceX + distanceY * distanceY;
        var distance = Math.sqrt(distanceSqr);
        // s += "\nDistance: " + distance;
        // Compute the module and components of the force vector
        var force = (node1.nodeRepulsion + node2.nodeRepulsion) / distanceSqr;
        var forceX = force * distanceX / distance;
        var forceY = force * distanceY / distance;
    }
    // Apply force
    if (!node1.isLocked) {
        node1.offsetX -= forceX;
        node1.offsetY -= forceY;
    }
    if (!node2.isLocked) {
        node2.offsetX += forceX;
        node2.offsetY += forceY;
    }
    // s += "\nForceX: " + forceX + " ForceY: " + forceY;
    // logDebug(s);
    return;
};
/**
 * @brief  : Determines whether two nodes overlap or not
 * @return : Amount of overlapping (0 => no overlap)
 */ var $e815fda779bc047b$var$nodesOverlap = function nodesOverlap(node1, node2, dX, dY) {
    if (dX > 0) var overlapX = node1.maxX - node2.minX;
    else var overlapX = node2.maxX - node1.minX;
    if (dY > 0) var overlapY = node1.maxY - node2.minY;
    else var overlapY = node2.maxY - node1.minY;
    if (overlapX >= 0 && overlapY >= 0) return Math.sqrt(overlapX * overlapX + overlapY * overlapY);
    else return 0;
};
/**
 * @brief : Finds the point in which an edge (direction dX, dY) intersects
 *          the rectangular bounding box of it's source/target node
 */ var $e815fda779bc047b$var$findClippingPoint = function findClippingPoint(node, dX, dY) {
    // Shorcuts
    var X = node.positionX;
    var Y = node.positionY;
    var H = node.height || 1;
    var W = node.width || 1;
    var dirSlope = dY / dX;
    var nodeSlope = H / W;
    // var s = 'Computing clipping point of node ' + node.id +
    //   " . Height:  " + H + ", Width: " + W +
    //   "\nDirection " + dX + ", " + dY;
    //
    // Compute intersection
    var res = {};
    // Case: Vertical direction (up)
    if (0 === dX && 0 < dY) {
        res.x = X;
        // s += "\nUp direction";
        res.y = Y + H / 2;
        return res;
    }
    // Case: Vertical direction (down)
    if (0 === dX && 0 > dY) {
        res.x = X;
        res.y = Y + H / 2;
        // s += "\nDown direction";
        return res;
    }
    // Case: Intersects the right border
    if (0 < dX && -1 * nodeSlope <= dirSlope && dirSlope <= nodeSlope) {
        res.x = X + W / 2;
        res.y = Y + W * dY / 2 / dX;
        // s += "\nRightborder";
        return res;
    }
    // Case: Intersects the left border
    if (0 > dX && -1 * nodeSlope <= dirSlope && dirSlope <= nodeSlope) {
        res.x = X - W / 2;
        res.y = Y - W * dY / 2 / dX;
        // s += "\nLeftborder";
        return res;
    }
    // Case: Intersects the top border
    if (0 < dY && (dirSlope <= -1 * nodeSlope || dirSlope >= nodeSlope)) {
        res.x = X + H * dX / 2 / dY;
        res.y = Y + H / 2;
        // s += "\nTop border";
        return res;
    }
    // Case: Intersects the bottom border
    if (0 > dY && (dirSlope <= -1 * nodeSlope || dirSlope >= nodeSlope)) {
        res.x = X - H * dX / 2 / dY;
        res.y = Y - H / 2;
        // s += "\nBottom border";
        return res;
    }
    // s += "\nClipping point found at " + res.x + ", " + res.y;
    // logDebug(s);
    return res;
};
/**
 * @brief : Calculates all edge forces
 */ var $e815fda779bc047b$var$calculateEdgeForces = function calculateEdgeForces(layoutInfo, options) {
    // Iterate over all edges
    for(var i = 0; i < layoutInfo.edgeSize; i++){
        // Get edge, source & target nodes
        var edge = layoutInfo.layoutEdges[i];
        var sourceIx = layoutInfo.idToIndex[edge.sourceId];
        var source = layoutInfo.layoutNodes[sourceIx];
        var targetIx = layoutInfo.idToIndex[edge.targetId];
        var target = layoutInfo.layoutNodes[targetIx];
        // Get direction of line connecting both node centers
        var directionX = target.positionX - source.positionX;
        var directionY = target.positionY - source.positionY;
        // If both centers are the same, do nothing.
        // A random force has already been applied as node repulsion
        if (0 === directionX && 0 === directionY) continue;
        // Get clipping points for both nodes
        var point1 = $e815fda779bc047b$var$findClippingPoint(source, directionX, directionY);
        var point2 = $e815fda779bc047b$var$findClippingPoint(target, -1 * directionX, -1 * directionY);
        var lx = point2.x - point1.x;
        var ly = point2.y - point1.y;
        var l = Math.sqrt(lx * lx + ly * ly);
        var force = Math.pow(edge.idealLength - l, 2) / edge.elasticity;
        if (0 !== l) {
            var forceX = force * lx / l;
            var forceY = force * ly / l;
        } else {
            var forceX = 0;
            var forceY = 0;
        }
        // Add this force to target and source nodes
        if (!source.isLocked) {
            source.offsetX += forceX;
            source.offsetY += forceY;
        }
        if (!target.isLocked) {
            target.offsetX -= forceX;
            target.offsetY -= forceY;
        }
    // var s = 'Edge force between nodes ' + source.id + ' and ' + target.id;
    // s += "\nDistance: " + l + " Force: (" + forceX + ", " + forceY + ")";
    // logDebug(s);
    }
};
/**
 * @brief : Computes gravity forces for all nodes
 */ var $e815fda779bc047b$var$calculateGravityForces = function calculateGravityForces(layoutInfo, options) {
    if (options.gravity === 0) return;
    var distThreshold = 1;
    // var s = 'calculateGravityForces';
    // logDebug(s);
    for(var i = 0; i < layoutInfo.graphSet.length; i++){
        var graph = layoutInfo.graphSet[i];
        var numNodes = graph.length;
        // s = "Set: " + graph.toString();
        // logDebug(s);
        // Compute graph center
        if (0 === i) {
            var centerX = layoutInfo.clientHeight / 2;
            var centerY = layoutInfo.clientWidth / 2;
        } else {
            // Get Parent node for this graph, and use its position as center
            var temp = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[0]]];
            var parent = layoutInfo.layoutNodes[layoutInfo.idToIndex[temp.parentId]];
            var centerX = parent.positionX;
            var centerY = parent.positionY;
        }
        // s = "Center found at: " + centerX + ", " + centerY;
        // logDebug(s);
        // Apply force to all nodes in graph
        for(var j = 0; j < numNodes; j++){
            var node = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[j]]];
            // s = "Node: " + node.id;
            if (node.isLocked) continue;
            var dx = centerX - node.positionX;
            var dy = centerY - node.positionY;
            var d = Math.sqrt(dx * dx + dy * dy);
            if (d > distThreshold) {
                var fx = options.gravity * dx / d;
                var fy = options.gravity * dy / d;
                node.offsetX += fx;
                node.offsetY += fy;
            // s += ": Applied force: " + fx + ", " + fy;
            }
        // logDebug(s);
        }
    }
};
/**
 * @brief          : This function propagates the existing offsets from
 *                   parent nodes to its descendents.
 * @arg layoutInfo : layoutInfo Object
 * @arg cy         : cytoscape Object
 * @arg options    : Layout options
 */ var $e815fda779bc047b$var$propagateForces = function propagateForces(layoutInfo, options) {
    // Inline implementation of a queue, used for traversing the graph in BFS order
    var queue = [];
    var start = 0; // Points to the start the queue
    var end = -1; // Points to the end of the queue
    // logDebug('propagateForces');
    // Start by visiting the nodes in the root graph
    queue.push.apply(queue, layoutInfo.graphSet[0]);
    end += layoutInfo.graphSet[0].length;
    // Traverse the graph, level by level,
    while(start <= end){
        // Get the node to visit and remove it from queue
        var nodeId = queue[start++];
        var nodeIndex = layoutInfo.idToIndex[nodeId];
        var node = layoutInfo.layoutNodes[nodeIndex];
        var children = node.children;
        // We only need to process the node if it's compound
        if (0 < children.length && !node.isLocked) {
            var offX = node.offsetX;
            var offY = node.offsetY;
            // var s = "Propagating offset from parent node : " + node.id +
            //   ". OffsetX: " + offX + ". OffsetY: " + offY;
            // s += "\n Children: " + children.toString();
            // logDebug(s);
            for(var i = 0; i < children.length; i++){
                var childNode = layoutInfo.layoutNodes[layoutInfo.idToIndex[children[i]]];
                // Propagate offset
                childNode.offsetX += offX;
                childNode.offsetY += offY;
                // Add children to queue to be visited
                queue[++end] = children[i];
            }
            // Reset parent offsets
            node.offsetX = 0;
            node.offsetY = 0;
        }
    }
};
/**
 * @brief : Updates the layout model positions, based on
 *          the accumulated forces
 */ var $e815fda779bc047b$var$updatePositions = function updatePositions(layoutInfo, options) {
    // var s = 'Updating positions';
    // logDebug(s);
    // Reset boundaries for compound nodes
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        if (0 < n.children.length) {
            // logDebug("Resetting boundaries of compound node: " + n.id);
            n.maxX = undefined;
            n.minX = undefined;
            n.maxY = undefined;
            n.minY = undefined;
        }
    }
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        if (0 < n.children.length || n.isLocked) continue;
        // s = "Node: " + n.id + " Previous position: (" +
        // n.positionX + ", " + n.positionY + ").";
        // Limit displacement in order to improve stability
        var tempForce = $e815fda779bc047b$var$limitForce(n.offsetX, n.offsetY, layoutInfo.temperature);
        n.positionX += tempForce.x;
        n.positionY += tempForce.y;
        n.offsetX = 0;
        n.offsetY = 0;
        n.minX = n.positionX - n.width;
        n.maxX = n.positionX + n.width;
        n.minY = n.positionY - n.height;
        n.maxY = n.positionY + n.height;
        // s += " New Position: (" + n.positionX + ", " + n.positionY + ").";
        // logDebug(s);
        // Update ancestry boudaries
        $e815fda779bc047b$var$updateAncestryBoundaries(n, layoutInfo);
    }
    // Update size, position of compund nodes
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        if (0 < n.children.length && !n.isLocked) {
            n.positionX = (n.maxX + n.minX) / 2;
            n.positionY = (n.maxY + n.minY) / 2;
            n.width = n.maxX - n.minX;
            n.height = n.maxY - n.minY;
        // s = "Updating position, size of compound node " + n.id;
        // s += "\nPositionX: " + n.positionX + ", PositionY: " + n.positionY;
        // s += "\nWidth: " + n.width + ", Height: " + n.height;
        // logDebug(s);
        }
    }
};
/**
 * @brief : Limits a force (forceX, forceY) to be not
 *          greater (in modulo) than max.
 8          Preserves force direction.
  */ var $e815fda779bc047b$var$limitForce = function limitForce(forceX, forceY, max) {
    // var s = "Limiting force: (" + forceX + ", " + forceY + "). Max: " + max;
    var force = Math.sqrt(forceX * forceX + forceY * forceY);
    if (force > max) var res = {
        x: max * forceX / force,
        y: max * forceY / force
    };
    else var res = {
        x: forceX,
        y: forceY
    };
    // s += ".\nResult: (" + res.x + ", " + res.y + ")";
    // logDebug(s);
    return res;
};
/**
 * @brief : Function used for keeping track of compound node
 *          sizes, since they should bound all their subnodes.
 */ var $e815fda779bc047b$var$updateAncestryBoundaries = function updateAncestryBoundaries(node, layoutInfo) {
    // var s = "Propagating new position/size of node " + node.id;
    var parentId = node.parentId;
    if (null == parentId) // If there's no parent, we are done
    // s += ". No parent node.";
    // logDebug(s);
    return;
    // Get Parent Node
    var p = layoutInfo.layoutNodes[layoutInfo.idToIndex[parentId]];
    var flag = false;
    // MaxX
    if (null == p.maxX || node.maxX + p.padRight > p.maxX) {
        p.maxX = node.maxX + p.padRight;
        flag = true;
    // s += "\nNew maxX for parent node " + p.id + ": " + p.maxX;
    }
    // MinX
    if (null == p.minX || node.minX - p.padLeft < p.minX) {
        p.minX = node.minX - p.padLeft;
        flag = true;
    // s += "\nNew minX for parent node " + p.id + ": " + p.minX;
    }
    // MaxY
    if (null == p.maxY || node.maxY + p.padBottom > p.maxY) {
        p.maxY = node.maxY + p.padBottom;
        flag = true;
    // s += "\nNew maxY for parent node " + p.id + ": " + p.maxY;
    }
    // MinY
    if (null == p.minY || node.minY - p.padTop < p.minY) {
        p.minY = node.minY - p.padTop;
        flag = true;
    // s += "\nNew minY for parent node " + p.id + ": " + p.minY;
    }
    // If updated boundaries, propagate changes upward
    if (flag) // logDebug(s);
    return updateAncestryBoundaries(p, layoutInfo);
    // s += ". No changes in boundaries/position of parent node " + p.id;
    // logDebug(s);
    return;
};
var $e815fda779bc047b$var$separateComponents = function separateComponents(layoutInfo, options) {
    var nodes = layoutInfo.layoutNodes;
    var components = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        var cid = node.cmptId;
        var component = components[cid] = components[cid] || [];
        component.push(node);
    }
    var totalA = 0;
    for(var i = 0; i < components.length; i++){
        var c = components[i];
        if (!c) continue;
        c.x1 = Infinity;
        c.x2 = -Infinity;
        c.y1 = Infinity;
        c.y2 = -Infinity;
        for(var j = 0; j < c.length; j++){
            var n = c[j];
            c.x1 = Math.min(c.x1, n.positionX - n.width / 2);
            c.x2 = Math.max(c.x2, n.positionX + n.width / 2);
            c.y1 = Math.min(c.y1, n.positionY - n.height / 2);
            c.y2 = Math.max(c.y2, n.positionY + n.height / 2);
        }
        c.w = c.x2 - c.x1;
        c.h = c.y2 - c.y1;
        totalA += c.w * c.h;
    }
    components.sort(function(c1, c2) {
        return c2.w * c2.h - c1.w * c1.h;
    });
    var x = 0;
    var y = 0;
    var usedW = 0;
    var rowH = 0;
    var maxRowW = Math.sqrt(totalA) * layoutInfo.clientWidth / layoutInfo.clientHeight;
    for(var i = 0; i < components.length; i++){
        var c = components[i];
        if (!c) continue;
        for(var j = 0; j < c.length; j++){
            var n = c[j];
            if (!n.isLocked) {
                n.positionX += x - c.x1;
                n.positionY += y - c.y1;
            }
        }
        x += c.w + options.componentSpacing;
        usedW += c.w + options.componentSpacing;
        rowH = Math.max(rowH, c.h);
        if (usedW > maxRowW) {
            y += rowH + options.componentSpacing;
            x = 0;
            usedW = 0;
            rowH = 0;
        }
    }
};
var $e815fda779bc047b$var$defaults$3 = {
    fit: true,
    // whether to fit the viewport to the graph
    padding: 30,
    // padding used on fit
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox if not enough space
    avoidOverlapPadding: 10,
    // extra spacing around nodes when avoidOverlap: true
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    condense: false,
    // uses all available space on false, uses minimal space on true
    rows: undefined,
    // force num of rows in the grid
    cols: undefined,
    // force num of columns in the grid
    position: function position(node) {},
    // returns { row, col } for element
    sort: undefined,
    // a sorting function to order the nodes; e.g. function(a, b){ return a.data('weight') - b.data('weight') }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts 
};
function $e815fda779bc047b$var$GridLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$3, options);
}
$e815fda779bc047b$var$GridLayout.prototype.run = function() {
    var params = this.options;
    var options = params;
    var cy = params.cy;
    var eles = options.eles;
    var nodes = eles.nodes().not(':parent');
    if (options.sort) nodes = nodes.sort(options.sort);
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    if (bb.h === 0 || bb.w === 0) eles.nodes().layoutPositions(this, options, function(ele) {
        return {
            x: bb.x1,
            y: bb.y1
        };
    });
    else {
        // width/height * splits^2 = cells where splits is number of times to split width
        var cells = nodes.size();
        var splits = Math.sqrt(cells * bb.h / bb.w);
        var rows = Math.round(splits);
        var cols = Math.round(bb.w / bb.h * splits);
        var small = function small(val) {
            if (val == null) return Math.min(rows, cols);
            else {
                var min = Math.min(rows, cols);
                if (min == rows) rows = val;
                else cols = val;
            }
        };
        var large = function large(val) {
            if (val == null) return Math.max(rows, cols);
            else {
                var max = Math.max(rows, cols);
                if (max == rows) rows = val;
                else cols = val;
            }
        };
        var oRows = options.rows;
        var oCols = options.cols != null ? options.cols : options.columns;
        // if rows or columns were set in options, use those values
        if (oRows != null && oCols != null) {
            rows = oRows;
            cols = oCols;
        } else if (oRows != null && oCols == null) {
            rows = oRows;
            cols = Math.ceil(cells / rows);
        } else if (oRows == null && oCols != null) {
            cols = oCols;
            rows = Math.ceil(cells / cols);
        } else if (cols * rows > cells) {
            var sm = small();
            var lg = large();
            // reducing the small side takes away the most cells, so try it first
            if ((sm - 1) * lg >= cells) small(sm - 1);
            else if ((lg - 1) * sm >= cells) large(lg - 1);
        } else // if rounding was too low, add rows or columns
        while(cols * rows < cells){
            var _sm = small();
            var _lg = large();
            // try to add to larger side first (adds less in multiplication)
            if ((_lg + 1) * _sm >= cells) large(_lg + 1);
            else small(_sm + 1);
        }
        var cellWidth = bb.w / cols;
        var cellHeight = bb.h / rows;
        if (options.condense) {
            cellWidth = 0;
            cellHeight = 0;
        }
        if (options.avoidOverlap) for(var i = 0; i < nodes.length; i++){
            var node = nodes[i];
            var pos = node._private.position;
            if (pos.x == null || pos.y == null) {
                // for bb
                pos.x = 0;
                pos.y = 0;
            }
            var nbb = node.layoutDimensions(options);
            var p = options.avoidOverlapPadding;
            var w = nbb.w + p;
            var h = nbb.h + p;
            cellWidth = Math.max(cellWidth, w);
            cellHeight = Math.max(cellHeight, h);
        }
        var cellUsed = {}; // e.g. 'c-0-2' => true
        var used = function used(row, col) {
            return cellUsed['c-' + row + '-' + col] ? true : false;
        };
        var use = function use(row, col) {
            cellUsed['c-' + row + '-' + col] = true;
        };
        // to keep track of current cell position
        var row = 0;
        var col = 0;
        var moveToNextCell = function moveToNextCell() {
            col++;
            if (col >= cols) {
                col = 0;
                row++;
            }
        };
        // get a cache of all the manual positions
        var id2manPos = {};
        for(var _i = 0; _i < nodes.length; _i++){
            var _node = nodes[_i];
            var rcPos = options.position(_node);
            if (rcPos && (rcPos.row !== undefined || rcPos.col !== undefined)) {
                // must have at least row or col def'd
                var _pos = {
                    row: rcPos.row,
                    col: rcPos.col
                };
                if (_pos.col === undefined) {
                    // find unused col
                    _pos.col = 0;
                    while(used(_pos.row, _pos.col))_pos.col++;
                } else if (_pos.row === undefined) {
                    // find unused row
                    _pos.row = 0;
                    while(used(_pos.row, _pos.col))_pos.row++;
                }
                id2manPos[_node.id()] = _pos;
                use(_pos.row, _pos.col);
            }
        }
        var getPos = function getPos(element, i) {
            var x, y;
            if (element.locked() || element.isParent()) return false;
            // see if we have a manual position set
            var rcPos = id2manPos[element.id()];
            if (rcPos) {
                x = rcPos.col * cellWidth + cellWidth / 2 + bb.x1;
                y = rcPos.row * cellHeight + cellHeight / 2 + bb.y1;
            } else {
                // otherwise set automatically
                while(used(row, col))moveToNextCell();
                x = col * cellWidth + cellWidth / 2 + bb.x1;
                y = row * cellHeight + cellHeight / 2 + bb.y1;
                use(row, col);
                moveToNextCell();
            }
            return {
                x: x,
                y: y
            };
        };
        nodes.layoutPositions(this, options, getPos);
    }
    return this; // chaining
};
// default layout options
var $e815fda779bc047b$var$defaults$2 = {
    ready: function ready() {},
    // on layoutready
    stop: function stop() {} // on layoutstop
};
// constructor
// options : object containing layout options
function $e815fda779bc047b$var$NullLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$2, options);
}
// runs the layout
$e815fda779bc047b$var$NullLayout.prototype.run = function() {
    var options = this.options;
    var eles = options.eles; // elements to consider in the layout
    var layout = this;
    // cy is automatically populated for us in the constructor
    // (disable eslint for next line as this serves as example layout code to external developers)
    // eslint-disable-next-line no-unused-vars
    options.cy;
    layout.emit('layoutstart');
    // puts all nodes at (0, 0)
    // n.b. most layouts would use layoutPositions(), instead of positions() and manual events
    eles.nodes().positions(function() {
        return {
            x: 0,
            y: 0
        };
    });
    // trigger layoutready when each node has had its position set at least once
    layout.one('layoutready', options.ready);
    layout.emit('layoutready');
    // trigger layoutstop when the layout stops (e.g. finishes)
    layout.one('layoutstop', options.stop);
    layout.emit('layoutstop');
    return this; // chaining
};
// called on continuous layouts to stop them before they finish
$e815fda779bc047b$var$NullLayout.prototype.stop = function() {
    return this; // chaining
};
var $e815fda779bc047b$var$defaults$1 = {
    positions: undefined,
    // map of (node id) => (position obj); or function(node){ return somPos; }
    zoom: undefined,
    // the zoom level to set (prob want fit = false if set)
    pan: undefined,
    // the pan level to set (prob want fit = false if set)
    fit: true,
    // whether to fit to viewport
    padding: 30,
    // padding on fit
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts
};
function $e815fda779bc047b$var$PresetLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$1, options);
}
$e815fda779bc047b$var$PresetLayout.prototype.run = function() {
    var options = this.options;
    var eles = options.eles;
    var nodes = eles.nodes();
    var posIsFn = $e815fda779bc047b$var$fn$6(options.positions);
    function getPosition(node) {
        if (options.positions == null) return $e815fda779bc047b$var$copyPosition(node.position());
        if (posIsFn) return options.positions(node);
        var pos = options.positions[node._private.data.id];
        if (pos == null) return null;
        return pos;
    }
    nodes.layoutPositions(this, options, function(node, i) {
        var position = getPosition(node);
        if (node.locked() || position == null) return false;
        return position;
    });
    return this; // chaining
};
var $e815fda779bc047b$var$defaults = {
    fit: true,
    // whether to fit to viewport
    padding: 30,
    // fit padding
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts 
};
function $e815fda779bc047b$var$RandomLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults, options);
}
$e815fda779bc047b$var$RandomLayout.prototype.run = function() {
    var options = this.options;
    var cy = options.cy;
    var eles = options.eles;
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var getPos = function getPos(node, i) {
        return {
            x: bb.x1 + Math.round(Math.random() * bb.w),
            y: bb.y1 + Math.round(Math.random() * bb.h)
        };
    };
    eles.nodes().layoutPositions(this, options, getPos);
    return this; // chaining
};
var $e815fda779bc047b$var$layout = [
    {
        name: 'breadthfirst',
        impl: $e815fda779bc047b$var$BreadthFirstLayout
    },
    {
        name: 'circle',
        impl: $e815fda779bc047b$var$CircleLayout
    },
    {
        name: 'concentric',
        impl: $e815fda779bc047b$var$ConcentricLayout
    },
    {
        name: 'cose',
        impl: $e815fda779bc047b$var$CoseLayout
    },
    {
        name: 'grid',
        impl: $e815fda779bc047b$var$GridLayout
    },
    {
        name: 'null',
        impl: $e815fda779bc047b$var$NullLayout
    },
    {
        name: 'preset',
        impl: $e815fda779bc047b$var$PresetLayout
    },
    {
        name: 'random',
        impl: $e815fda779bc047b$var$RandomLayout
    }
];
function $e815fda779bc047b$var$NullRenderer(options) {
    this.options = options;
    this.notifications = 0; // for testing
}
var $e815fda779bc047b$var$noop = function noop() {};
var $e815fda779bc047b$var$throwImgErr = function throwImgErr() {
    throw new Error('A headless instance can not render images');
};
$e815fda779bc047b$var$NullRenderer.prototype = {
    recalculateRenderedStyle: $e815fda779bc047b$var$noop,
    notify: function notify() {
        this.notifications++;
    },
    init: $e815fda779bc047b$var$noop,
    isHeadless: function isHeadless() {
        return true;
    },
    png: $e815fda779bc047b$var$throwImgErr,
    jpg: $e815fda779bc047b$var$throwImgErr
};
var $e815fda779bc047b$var$BRp$f = {};
$e815fda779bc047b$var$BRp$f.arrowShapeWidth = 0.3;
$e815fda779bc047b$var$BRp$f.registerArrowShapes = function() {
    var arrowShapes = this.arrowShapes = {};
    var renderer = this;
    // Contract for arrow shapes:
    // 0, 0 is arrow tip
    // (0, 1) is direction towards node
    // (1, 0) is right
    //
    // functional api:
    // collide: check x, y in shape
    // roughCollide: called before collide, no false negatives
    // draw: draw
    // spacing: dist(arrowTip, nodeBoundary)
    // gap: dist(edgeTip, nodeBoundary), edgeTip may != arrowTip
    var bbCollide = function bbCollide(x, y, size, angle, translation, edgeWidth, padding) {
        var x1 = translation.x - size / 2 - padding;
        var x2 = translation.x + size / 2 + padding;
        var y1 = translation.y - size / 2 - padding;
        var y2 = translation.y + size / 2 + padding;
        var inside = x1 <= x && x <= x2 && y1 <= y && y <= y2;
        return inside;
    };
    var transform = function transform(x, y, size, angle, translation) {
        var xRotated = x * Math.cos(angle) - y * Math.sin(angle);
        var yRotated = x * Math.sin(angle) + y * Math.cos(angle);
        var xScaled = xRotated * size;
        var yScaled = yRotated * size;
        var xTranslated = xScaled + translation.x;
        var yTranslated = yScaled + translation.y;
        return {
            x: xTranslated,
            y: yTranslated
        };
    };
    var transformPoints = function transformPoints(pts, size, angle, translation) {
        var retPts = [];
        for(var i = 0; i < pts.length; i += 2){
            var x = pts[i];
            var y = pts[i + 1];
            retPts.push(transform(x, y, size, angle, translation));
        }
        return retPts;
    };
    var pointsToArr = function pointsToArr(pts) {
        var ret = [];
        for(var i = 0; i < pts.length; i++){
            var p = pts[i];
            ret.push(p.x, p.y);
        }
        return ret;
    };
    var standardGap = function standardGap(edge) {
        return edge.pstyle('width').pfValue * edge.pstyle('arrow-scale').pfValue * 2;
    };
    var defineArrowShape = function defineArrowShape(name, defn) {
        if ($e815fda779bc047b$var$string(defn)) defn = arrowShapes[defn];
        arrowShapes[name] = $e815fda779bc047b$var$extend({
            name: name,
            points: [
                -0.15,
                -0.3,
                0.15,
                -0.3,
                0.15,
                0.3,
                -0.15,
                0.3
            ],
            collide: function collide(x, y, size, angle, translation, padding) {
                var points = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
                var inside = $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, points);
                return inside;
            },
            roughCollide: bbCollide,
            draw: function draw(context, size, angle, translation) {
                var points = transformPoints(this.points, size, angle, translation);
                renderer.arrowShapeImpl('polygon')(context, points);
            },
            spacing: function spacing(edge) {
                return 0;
            },
            gap: standardGap
        }, defn);
    };
    defineArrowShape('none', {
        collide: $e815fda779bc047b$var$falsify,
        roughCollide: $e815fda779bc047b$var$falsify,
        draw: $e815fda779bc047b$var$noop$1,
        spacing: $e815fda779bc047b$var$zeroify,
        gap: $e815fda779bc047b$var$zeroify
    });
    defineArrowShape('triangle', {
        points: [
            -0.15,
            -0.3,
            0,
            0,
            0.15,
            -0.3
        ]
    });
    defineArrowShape('arrow', 'triangle');
    defineArrowShape('triangle-backcurve', {
        points: arrowShapes['triangle'].points,
        controlPoint: [
            0,
            -0.15
        ],
        roughCollide: bbCollide,
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var ptsTrans = transformPoints(this.points, size, angle, translation);
            var ctrlPt = this.controlPoint;
            var ctrlPtTrans = transform(ctrlPt[0], ctrlPt[1], size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, ptsTrans, ctrlPtTrans);
        },
        gap: function gap(edge) {
            return standardGap(edge) * 0.8;
        }
    });
    defineArrowShape('triangle-tee', {
        points: [
            0,
            0,
            0.15,
            -0.3,
            -0.15,
            -0.3,
            0,
            0
        ],
        pointsTee: [
            -0.15,
            -0.4,
            -0.15,
            -0.5,
            0.15,
            -0.5,
            0.15,
            -0.4
        ],
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var triPts = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
            var teePts = pointsToArr(transformPoints(this.pointsTee, size + 2 * padding, angle, translation));
            var inside = $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, triPts) || $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, teePts);
            return inside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var triPts = transformPoints(this.points, size, angle, translation);
            var teePts = transformPoints(this.pointsTee, size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, triPts, teePts);
        }
    });
    defineArrowShape('circle-triangle', {
        radius: 0.15,
        pointsTr: [
            0,
            -0.15,
            0.15,
            -0.45,
            -0.15,
            -0.45,
            0,
            -0.15
        ],
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var t = translation;
            var circleInside = Math.pow(t.x - x, 2) + Math.pow(t.y - y, 2) <= Math.pow((size + 2 * padding) * this.radius, 2);
            var triPts = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
            return $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, triPts) || circleInside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var triPts = transformPoints(this.pointsTr, size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, triPts, translation.x, translation.y, this.radius * size);
        },
        spacing: function spacing(edge) {
            return renderer.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.radius;
        }
    });
    defineArrowShape('triangle-cross', {
        points: [
            0,
            0,
            0.15,
            -0.3,
            -0.15,
            -0.3,
            0,
            0
        ],
        baseCrossLinePts: [
            -0.15,
            -0.4,
            // first half of the rectangle
            -0.15,
            -0.4,
            0.15,
            -0.4,
            // second half of the rectangle
            0.15,
            -0.4
        ],
        crossLinePts: function crossLinePts(size, edgeWidth) {
            // shift points so that the distance between the cross points matches edge width
            var p = this.baseCrossLinePts.slice();
            var shiftFactor = edgeWidth / size;
            var y0 = 3;
            var y1 = 5;
            p[y0] = p[y0] - shiftFactor;
            p[y1] = p[y1] - shiftFactor;
            return p;
        },
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var triPts = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
            var teePts = pointsToArr(transformPoints(this.crossLinePts(size, edgeWidth), size + 2 * padding, angle, translation));
            var inside = $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, triPts) || $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, teePts);
            return inside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var triPts = transformPoints(this.points, size, angle, translation);
            var crossLinePts = transformPoints(this.crossLinePts(size, edgeWidth), size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, triPts, crossLinePts);
        }
    });
    defineArrowShape('vee', {
        points: [
            -0.15,
            -0.3,
            0,
            0,
            0.15,
            -0.3,
            0,
            -0.15
        ],
        gap: function gap(edge) {
            return standardGap(edge) * 0.525;
        }
    });
    defineArrowShape('circle', {
        radius: 0.15,
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var t = translation;
            var inside = Math.pow(t.x - x, 2) + Math.pow(t.y - y, 2) <= Math.pow((size + 2 * padding) * this.radius, 2);
            return inside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            renderer.arrowShapeImpl(this.name)(context, translation.x, translation.y, this.radius * size);
        },
        spacing: function spacing(edge) {
            return renderer.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.radius;
        }
    });
    defineArrowShape('tee', {
        points: [
            -0.15,
            0,
            -0.15,
            -0.1,
            0.15,
            -0.1,
            0.15,
            0
        ],
        spacing: function spacing(edge) {
            return 1;
        },
        gap: function gap(edge) {
            return 1;
        }
    });
    defineArrowShape('square', {
        points: [
            -0.15,
            0.00,
            0.15,
            0.00,
            0.15,
            -0.3,
            -0.15,
            -0.3
        ]
    });
    defineArrowShape('diamond', {
        points: [
            -0.15,
            -0.15,
            0,
            -0.3,
            0.15,
            -0.15,
            0,
            0
        ],
        gap: function gap(edge) {
            return edge.pstyle('width').pfValue * edge.pstyle('arrow-scale').value;
        }
    });
    defineArrowShape('chevron', {
        points: [
            0,
            0,
            -0.15,
            -0.15,
            -0.1,
            -0.2,
            0,
            -0.1,
            0.1,
            -0.2,
            0.15,
            -0.15
        ],
        gap: function gap(edge) {
            return 0.95 * edge.pstyle('width').pfValue * edge.pstyle('arrow-scale').value;
        }
    });
};
var $e815fda779bc047b$var$BRp$e = {};
// Project mouse
$e815fda779bc047b$var$BRp$e.projectIntoViewport = function(clientX, clientY) {
    var cy = this.cy;
    var offsets = this.findContainerClientCoords();
    var offsetLeft = offsets[0];
    var offsetTop = offsets[1];
    var scale = offsets[4];
    var pan = cy.pan();
    var zoom = cy.zoom();
    var x = ((clientX - offsetLeft) / scale - pan.x) / zoom;
    var y = ((clientY - offsetTop) / scale - pan.y) / zoom;
    return [
        x,
        y
    ];
};
$e815fda779bc047b$var$BRp$e.findContainerClientCoords = function() {
    if (this.containerBB) return this.containerBB;
    var container = this.container;
    var rect = container.getBoundingClientRect();
    var style = this.cy.window().getComputedStyle(container);
    var styleValue = function styleValue(name) {
        return parseFloat(style.getPropertyValue(name));
    };
    var padding = {
        left: styleValue('padding-left'),
        right: styleValue('padding-right'),
        top: styleValue('padding-top'),
        bottom: styleValue('padding-bottom')
    };
    var border = {
        left: styleValue('border-left-width'),
        right: styleValue('border-right-width'),
        top: styleValue('border-top-width'),
        bottom: styleValue('border-bottom-width')
    };
    var clientWidth = container.clientWidth;
    var clientHeight = container.clientHeight;
    var paddingHor = padding.left + padding.right;
    var paddingVer = padding.top + padding.bottom;
    var borderHor = border.left + border.right;
    var scale = rect.width / (clientWidth + borderHor);
    var unscaledW = clientWidth - paddingHor;
    var unscaledH = clientHeight - paddingVer;
    var left = rect.left + padding.left + border.left;
    var top = rect.top + padding.top + border.top;
    return this.containerBB = [
        left,
        top,
        unscaledW,
        unscaledH,
        scale
    ];
};
$e815fda779bc047b$var$BRp$e.invalidateContainerClientCoordsCache = function() {
    this.containerBB = null;
};
$e815fda779bc047b$var$BRp$e.findNearestElement = function(x, y, interactiveElementsOnly, isTouch) {
    return this.findNearestElements(x, y, interactiveElementsOnly, isTouch)[0];
};
$e815fda779bc047b$var$BRp$e.findNearestElements = function(x, y, interactiveElementsOnly, isTouch) {
    var self1 = this;
    var r = this;
    var eles = r.getCachedZSortedEles();
    var near = []; // 1 node max, 1 edge max
    var zoom = r.cy.zoom();
    var hasCompounds = r.cy.hasCompoundNodes();
    var edgeThreshold = (isTouch ? 24 : 8) / zoom;
    var nodeThreshold = (isTouch ? 8 : 2) / zoom;
    var labelThreshold = (isTouch ? 8 : 2) / zoom;
    var minSqDist = Infinity;
    var nearEdge;
    var nearNode;
    if (interactiveElementsOnly) eles = eles.interactive;
    function addEle(ele, sqDist) {
        if (ele.isNode()) {
            if (nearNode) return; // can't replace node
            else {
                nearNode = ele;
                near.push(ele);
            }
        }
        if (ele.isEdge() && (sqDist == null || sqDist < minSqDist)) {
            if (nearEdge) // then replace existing edge
            // can replace only if same z-index
            {
                if (nearEdge.pstyle('z-compound-depth').value === ele.pstyle('z-compound-depth').value && nearEdge.pstyle('z-compound-depth').value === ele.pstyle('z-compound-depth').value) {
                    for(var i = 0; i < near.length; i++)if (near[i].isEdge()) {
                        near[i] = ele;
                        nearEdge = ele;
                        minSqDist = sqDist != null ? sqDist : minSqDist;
                        break;
                    }
                }
            } else {
                near.push(ele);
                nearEdge = ele;
                minSqDist = sqDist != null ? sqDist : minSqDist;
            }
        }
    }
    function checkNode(node) {
        var width = node.outerWidth() + 2 * nodeThreshold;
        var height = node.outerHeight() + 2 * nodeThreshold;
        var hw = width / 2;
        var hh = height / 2;
        var pos = node.position();
        var cornerRadius = node.pstyle('corner-radius').value === 'auto' ? 'auto' : node.pstyle('corner-radius').pfValue;
        var rs = node._private.rscratch;
        if (pos.x - hw <= x && x <= pos.x + hw // bb check x
         && pos.y - hh <= y && y <= pos.y + hh // bb check y
        ) {
            var shape = r.nodeShapes[self1.getNodeShape(node)];
            if (shape.checkPoint(x, y, 0, width, height, pos.x, pos.y, cornerRadius, rs)) {
                addEle(node, 0);
                return true;
            }
        }
    }
    function checkEdge(edge) {
        var _p = edge._private;
        var rs = _p.rscratch;
        var styleWidth = edge.pstyle('width').pfValue;
        var scale = edge.pstyle('arrow-scale').value;
        var width = styleWidth / 2 + edgeThreshold; // more like a distance radius from centre
        var widthSq = width * width;
        var width2 = width * 2;
        var src = _p.source;
        var tgt = _p.target;
        var sqDist;
        if (rs.edgeType === 'segments' || rs.edgeType === 'straight' || rs.edgeType === 'haystack') {
            var pts = rs.allpts;
            for(var i = 0; i + 3 < pts.length; i += 2)if ($e815fda779bc047b$var$inLineVicinity(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3], width2) && widthSq > (sqDist = $e815fda779bc047b$var$sqdistToFiniteLine(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3]))) {
                addEle(edge, sqDist);
                return true;
            }
        } else if (rs.edgeType === 'bezier' || rs.edgeType === 'multibezier' || rs.edgeType === 'self' || rs.edgeType === 'compound') {
            var pts = rs.allpts;
            for(var i = 0; i + 5 < rs.allpts.length; i += 4)if ($e815fda779bc047b$var$inBezierVicinity(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3], pts[i + 4], pts[i + 5], width2) && widthSq > (sqDist = $e815fda779bc047b$var$sqdistToQuadraticBezier(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3], pts[i + 4], pts[i + 5]))) {
                addEle(edge, sqDist);
                return true;
            }
        }
        // if we're close to the edge but didn't hit it, maybe we hit its arrows
        var src = src || _p.source;
        var tgt = tgt || _p.target;
        var arSize = self1.getArrowWidth(styleWidth, scale);
        var arrows = [
            {
                name: 'source',
                x: rs.arrowStartX,
                y: rs.arrowStartY,
                angle: rs.srcArrowAngle
            },
            {
                name: 'target',
                x: rs.arrowEndX,
                y: rs.arrowEndY,
                angle: rs.tgtArrowAngle
            },
            {
                name: 'mid-source',
                x: rs.midX,
                y: rs.midY,
                angle: rs.midsrcArrowAngle
            },
            {
                name: 'mid-target',
                x: rs.midX,
                y: rs.midY,
                angle: rs.midtgtArrowAngle
            }
        ];
        for(var i = 0; i < arrows.length; i++){
            var ar = arrows[i];
            var shape = r.arrowShapes[edge.pstyle(ar.name + '-arrow-shape').value];
            var edgeWidth = edge.pstyle('width').pfValue;
            if (shape.roughCollide(x, y, arSize, ar.angle, {
                x: ar.x,
                y: ar.y
            }, edgeWidth, edgeThreshold) && shape.collide(x, y, arSize, ar.angle, {
                x: ar.x,
                y: ar.y
            }, edgeWidth, edgeThreshold)) {
                addEle(edge);
                return true;
            }
        }
        // for compound graphs, hitting edge may actually want a connected node instead (b/c edge may have greater z-index precedence)
        if (hasCompounds && near.length > 0) {
            checkNode(src);
            checkNode(tgt);
        }
    }
    function preprop(obj, name, pre) {
        return $e815fda779bc047b$var$getPrefixedProperty(obj, name, pre);
    }
    function checkLabel(ele, prefix) {
        var _p = ele._private;
        var th = labelThreshold;
        var prefixDash;
        if (prefix) prefixDash = prefix + '-';
        else prefixDash = '';
        ele.boundingBox();
        var bb = _p.labelBounds[prefix || 'main'];
        var text = ele.pstyle(prefixDash + 'label').value;
        var eventsEnabled = ele.pstyle('text-events').strValue === 'yes';
        if (!eventsEnabled || !text) return;
        var lx = preprop(_p.rscratch, 'labelX', prefix);
        var ly = preprop(_p.rscratch, 'labelY', prefix);
        var theta = preprop(_p.rscratch, 'labelAngle', prefix);
        var ox = ele.pstyle(prefixDash + 'text-margin-x').pfValue;
        var oy = ele.pstyle(prefixDash + 'text-margin-y').pfValue;
        var lx1 = bb.x1 - th - ox; // (-ox, -oy) as bb already includes margin
        var lx2 = bb.x2 + th - ox; // and rotation is about (lx, ly)
        var ly1 = bb.y1 - th - oy;
        var ly2 = bb.y2 + th - oy;
        if (theta) {
            var cos = Math.cos(theta);
            var sin = Math.sin(theta);
            var rotate = function rotate(x, y) {
                x = x - lx;
                y = y - ly;
                return {
                    x: x * cos - y * sin + lx,
                    y: x * sin + y * cos + ly
                };
            };
            var px1y1 = rotate(lx1, ly1);
            var px1y2 = rotate(lx1, ly2);
            var px2y1 = rotate(lx2, ly1);
            var px2y2 = rotate(lx2, ly2);
            var points = [
                // with the margin added after the rotation is applied
                px1y1.x + ox,
                px1y1.y + oy,
                px2y1.x + ox,
                px2y1.y + oy,
                px2y2.x + ox,
                px2y2.y + oy,
                px1y2.x + ox,
                px1y2.y + oy
            ];
            if ($e815fda779bc047b$var$pointInsidePolygonPoints(x, y, points)) {
                addEle(ele);
                return true;
            }
        } else // do a cheaper bb check
        if ($e815fda779bc047b$var$inBoundingBox(bb, x, y)) {
            addEle(ele);
            return true;
        }
    }
    for(var i = eles.length - 1; i >= 0; i--){
        // reverse order for precedence
        var ele = eles[i];
        if (ele.isNode()) checkNode(ele) || checkLabel(ele);
        else // then edge
        checkEdge(ele) || checkLabel(ele) || checkLabel(ele, 'source') || checkLabel(ele, 'target');
    }
    return near;
};
// 'Give me everything from this box'
$e815fda779bc047b$var$BRp$e.getAllInBox = function(x1, y1, x2, y2) {
    var eles = this.getCachedZSortedEles().interactive;
    var box = [];
    var x1c = Math.min(x1, x2);
    var x2c = Math.max(x1, x2);
    var y1c = Math.min(y1, y2);
    var y2c = Math.max(y1, y2);
    x1 = x1c;
    x2 = x2c;
    y1 = y1c;
    y2 = y2c;
    var boxBb = $e815fda779bc047b$var$makeBoundingBox({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    for(var e = 0; e < eles.length; e++){
        var ele = eles[e];
        if (ele.isNode()) {
            var node = ele;
            var nodeBb = node.boundingBox({
                includeNodes: true,
                includeEdges: false,
                includeLabels: false
            });
            if ($e815fda779bc047b$var$boundingBoxesIntersect(boxBb, nodeBb) && !$e815fda779bc047b$var$boundingBoxInBoundingBox(nodeBb, boxBb)) box.push(node);
        } else {
            var edge = ele;
            var _p = edge._private;
            var rs = _p.rscratch;
            if (rs.startX != null && rs.startY != null && !$e815fda779bc047b$var$inBoundingBox(boxBb, rs.startX, rs.startY)) continue;
            if (rs.endX != null && rs.endY != null && !$e815fda779bc047b$var$inBoundingBox(boxBb, rs.endX, rs.endY)) continue;
            if (rs.edgeType === 'bezier' || rs.edgeType === 'multibezier' || rs.edgeType === 'self' || rs.edgeType === 'compound' || rs.edgeType === 'segments' || rs.edgeType === 'haystack') {
                var pts = _p.rstyle.bezierPts || _p.rstyle.linePts || _p.rstyle.haystackPts;
                var allInside = true;
                for(var i = 0; i < pts.length; i++)if (!$e815fda779bc047b$var$pointInBoundingBox(boxBb, pts[i])) {
                    allInside = false;
                    break;
                }
                if (allInside) box.push(edge);
            } else if (rs.edgeType === 'haystack' || rs.edgeType === 'straight') box.push(edge);
        }
    }
    return box;
};
var $e815fda779bc047b$var$BRp$d = {};
$e815fda779bc047b$var$BRp$d.calculateArrowAngles = function(edge) {
    var rs = edge._private.rscratch;
    var isHaystack = rs.edgeType === 'haystack';
    var isBezier = rs.edgeType === 'bezier';
    var isMultibezier = rs.edgeType === 'multibezier';
    var isSegments = rs.edgeType === 'segments';
    var isCompound = rs.edgeType === 'compound';
    var isSelf = rs.edgeType === 'self';
    // Displacement gives direction for arrowhead orientation
    var dispX, dispY;
    var startX, startY, endX, endY, midX, midY;
    if (isHaystack) {
        startX = rs.haystackPts[0];
        startY = rs.haystackPts[1];
        endX = rs.haystackPts[2];
        endY = rs.haystackPts[3];
    } else {
        startX = rs.arrowStartX;
        startY = rs.arrowStartY;
        endX = rs.arrowEndX;
        endY = rs.arrowEndY;
    }
    midX = rs.midX;
    midY = rs.midY;
    // source
    //
    if (isSegments) {
        dispX = startX - rs.segpts[0];
        dispY = startY - rs.segpts[1];
    } else if (isMultibezier || isCompound || isSelf || isBezier) {
        var pts = rs.allpts;
        var bX = $e815fda779bc047b$var$qbezierAt(pts[0], pts[2], pts[4], 0.1);
        var bY = $e815fda779bc047b$var$qbezierAt(pts[1], pts[3], pts[5], 0.1);
        dispX = startX - bX;
        dispY = startY - bY;
    } else {
        dispX = startX - midX;
        dispY = startY - midY;
    }
    rs.srcArrowAngle = $e815fda779bc047b$var$getAngleFromDisp(dispX, dispY);
    // mid target
    //
    var midX = rs.midX;
    var midY = rs.midY;
    if (isHaystack) {
        midX = (startX + endX) / 2;
        midY = (startY + endY) / 2;
    }
    dispX = endX - startX;
    dispY = endY - startY;
    if (isSegments) {
        var pts = rs.allpts;
        if (pts.length / 2 % 2 === 0) {
            var i2 = pts.length / 2;
            var i1 = i2 - 2;
            dispX = pts[i2] - pts[i1];
            dispY = pts[i2 + 1] - pts[i1 + 1];
        } else if (rs.isRound) {
            dispX = rs.midVector[1];
            dispY = -rs.midVector[0];
        } else {
            var i2 = pts.length / 2 - 1;
            var i1 = i2 - 2;
            dispX = pts[i2] - pts[i1];
            dispY = pts[i2 + 1] - pts[i1 + 1];
        }
    } else if (isMultibezier || isCompound || isSelf) {
        var pts = rs.allpts;
        var cpts = rs.ctrlpts;
        var bp0x, bp0y;
        var bp1x, bp1y;
        if (cpts.length / 2 % 2 === 0) {
            var p0 = pts.length / 2 - 1; // startpt
            var ic = p0 + 2;
            var p1 = ic + 2;
            bp0x = $e815fda779bc047b$var$qbezierAt(pts[p0], pts[ic], pts[p1], 0.0);
            bp0y = $e815fda779bc047b$var$qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.0);
            bp1x = $e815fda779bc047b$var$qbezierAt(pts[p0], pts[ic], pts[p1], 0.0001);
            bp1y = $e815fda779bc047b$var$qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.0001);
        } else {
            var ic = pts.length / 2 - 1; // ctrpt
            var p0 = ic - 2; // startpt
            var p1 = ic + 2; // endpt
            bp0x = $e815fda779bc047b$var$qbezierAt(pts[p0], pts[ic], pts[p1], 0.4999);
            bp0y = $e815fda779bc047b$var$qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.4999);
            bp1x = $e815fda779bc047b$var$qbezierAt(pts[p0], pts[ic], pts[p1], 0.5);
            bp1y = $e815fda779bc047b$var$qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.5);
        }
        dispX = bp1x - bp0x;
        dispY = bp1y - bp0y;
    }
    rs.midtgtArrowAngle = $e815fda779bc047b$var$getAngleFromDisp(dispX, dispY);
    rs.midDispX = dispX;
    rs.midDispY = dispY;
    // mid source
    //
    dispX *= -1;
    dispY *= -1;
    if (isSegments) {
        var pts = rs.allpts;
        if (pts.length / 2 % 2 === 0) ;
        else if (!rs.isRound) {
            var i2 = pts.length / 2 - 1;
            var i3 = i2 + 2;
            dispX = -(pts[i3] - pts[i2]);
            dispY = -(pts[i3 + 1] - pts[i2 + 1]);
        }
    }
    rs.midsrcArrowAngle = $e815fda779bc047b$var$getAngleFromDisp(dispX, dispY);
    // target
    //
    if (isSegments) {
        dispX = endX - rs.segpts[rs.segpts.length - 2];
        dispY = endY - rs.segpts[rs.segpts.length - 1];
    } else if (isMultibezier || isCompound || isSelf || isBezier) {
        var pts = rs.allpts;
        var l = pts.length;
        var bX = $e815fda779bc047b$var$qbezierAt(pts[l - 6], pts[l - 4], pts[l - 2], 0.9);
        var bY = $e815fda779bc047b$var$qbezierAt(pts[l - 5], pts[l - 3], pts[l - 1], 0.9);
        dispX = endX - bX;
        dispY = endY - bY;
    } else {
        dispX = endX - midX;
        dispY = endY - midY;
    }
    rs.tgtArrowAngle = $e815fda779bc047b$var$getAngleFromDisp(dispX, dispY);
};
$e815fda779bc047b$var$BRp$d.getArrowWidth = $e815fda779bc047b$var$BRp$d.getArrowHeight = function(edgeWidth, scale) {
    var cache = this.arrowWidthCache = this.arrowWidthCache || {};
    var cachedVal = cache[edgeWidth + ', ' + scale];
    if (cachedVal) return cachedVal;
    cachedVal = Math.max(Math.pow(edgeWidth * 13.37, 0.9), 29) * scale;
    cache[edgeWidth + ', ' + scale] = cachedVal;
    return cachedVal;
};
/**
 * Explained by Blindman67 at https://stackoverflow.com/a/44856925/11028828
 */ // Declare reused variable to avoid reallocating variables every time the function is called
var $e815fda779bc047b$var$x, $e815fda779bc047b$var$y, $e815fda779bc047b$var$v1 = {}, $e815fda779bc047b$var$v2 = {}, $e815fda779bc047b$var$sinA, $e815fda779bc047b$var$sinA90, $e815fda779bc047b$var$radDirection, $e815fda779bc047b$var$drawDirection, $e815fda779bc047b$var$angle, $e815fda779bc047b$var$halfAngle, $e815fda779bc047b$var$cRadius, $e815fda779bc047b$var$lenOut, $e815fda779bc047b$var$radius, $e815fda779bc047b$var$limit;
var $e815fda779bc047b$var$startX, $e815fda779bc047b$var$startY, $e815fda779bc047b$var$stopX, $e815fda779bc047b$var$stopY;
var $e815fda779bc047b$var$lastPoint;
// convert 2 points into vector form, polar form, and normalised
var $e815fda779bc047b$var$asVec = function asVec(p, pp, v) {
    v.x = pp.x - p.x;
    v.y = pp.y - p.y;
    v.len = Math.sqrt(v.x * v.x + v.y * v.y);
    v.nx = v.x / v.len;
    v.ny = v.y / v.len;
    v.ang = Math.atan2(v.ny, v.nx);
};
var $e815fda779bc047b$var$invertVec = function invertVec(originalV, invertedV) {
    invertedV.x = originalV.x * -1;
    invertedV.y = originalV.y * -1;
    invertedV.nx = originalV.nx * -1;
    invertedV.ny = originalV.ny * -1;
    invertedV.ang = originalV.ang > 0 ? -(Math.PI - originalV.ang) : Math.PI + originalV.ang;
};
var $e815fda779bc047b$var$calcCornerArc = function calcCornerArc(previousPoint, currentPoint, nextPoint, radiusMax, isArcRadius) {
    //-----------------------------------------
    // Part 1
    previousPoint !== $e815fda779bc047b$var$lastPoint ? $e815fda779bc047b$var$asVec(currentPoint, previousPoint, $e815fda779bc047b$var$v1) : $e815fda779bc047b$var$invertVec($e815fda779bc047b$var$v2, $e815fda779bc047b$var$v1); // Avoid recalculating vec if it is the invert of the last one calculated
    $e815fda779bc047b$var$asVec(currentPoint, nextPoint, $e815fda779bc047b$var$v2);
    $e815fda779bc047b$var$sinA = $e815fda779bc047b$var$v1.nx * $e815fda779bc047b$var$v2.ny - $e815fda779bc047b$var$v1.ny * $e815fda779bc047b$var$v2.nx;
    $e815fda779bc047b$var$sinA90 = $e815fda779bc047b$var$v1.nx * $e815fda779bc047b$var$v2.nx - $e815fda779bc047b$var$v1.ny * -$e815fda779bc047b$var$v2.ny;
    $e815fda779bc047b$var$angle = Math.asin(Math.max(-1, Math.min(1, $e815fda779bc047b$var$sinA)));
    if (Math.abs($e815fda779bc047b$var$angle) < 1e-6) {
        $e815fda779bc047b$var$x = currentPoint.x;
        $e815fda779bc047b$var$y = currentPoint.y;
        $e815fda779bc047b$var$cRadius = $e815fda779bc047b$var$radius = 0;
        return;
    }
    //-----------------------------------------
    $e815fda779bc047b$var$radDirection = 1;
    $e815fda779bc047b$var$drawDirection = false;
    if ($e815fda779bc047b$var$sinA90 < 0) {
        if ($e815fda779bc047b$var$angle < 0) $e815fda779bc047b$var$angle = Math.PI + $e815fda779bc047b$var$angle;
        else {
            $e815fda779bc047b$var$angle = Math.PI - $e815fda779bc047b$var$angle;
            $e815fda779bc047b$var$radDirection = -1;
            $e815fda779bc047b$var$drawDirection = true;
        }
    } else if ($e815fda779bc047b$var$angle > 0) {
        $e815fda779bc047b$var$radDirection = -1;
        $e815fda779bc047b$var$drawDirection = true;
    }
    if (currentPoint.radius !== undefined) $e815fda779bc047b$var$radius = currentPoint.radius;
    else $e815fda779bc047b$var$radius = radiusMax;
    //-----------------------------------------
    // Part 2
    $e815fda779bc047b$var$halfAngle = $e815fda779bc047b$var$angle / 2;
    //-----------------------------------------
    $e815fda779bc047b$var$limit = Math.min($e815fda779bc047b$var$v1.len / 2, $e815fda779bc047b$var$v2.len / 2);
    if (isArcRadius) {
        //-----------------------------------------
        // Part 3
        $e815fda779bc047b$var$lenOut = Math.abs(Math.cos($e815fda779bc047b$var$halfAngle) * $e815fda779bc047b$var$radius / Math.sin($e815fda779bc047b$var$halfAngle));
        //-----------------------------------------
        // Special part A
        if ($e815fda779bc047b$var$lenOut > $e815fda779bc047b$var$limit) {
            $e815fda779bc047b$var$lenOut = $e815fda779bc047b$var$limit;
            $e815fda779bc047b$var$cRadius = Math.abs($e815fda779bc047b$var$lenOut * Math.sin($e815fda779bc047b$var$halfAngle) / Math.cos($e815fda779bc047b$var$halfAngle));
        } else $e815fda779bc047b$var$cRadius = $e815fda779bc047b$var$radius;
    } else {
        $e815fda779bc047b$var$lenOut = Math.min($e815fda779bc047b$var$limit, $e815fda779bc047b$var$radius);
        $e815fda779bc047b$var$cRadius = Math.abs($e815fda779bc047b$var$lenOut * Math.sin($e815fda779bc047b$var$halfAngle) / Math.cos($e815fda779bc047b$var$halfAngle));
    }
    //-----------------------------------------
    //-----------------------------------------
    // Part 4
    $e815fda779bc047b$var$stopX = currentPoint.x + $e815fda779bc047b$var$v2.nx * $e815fda779bc047b$var$lenOut;
    $e815fda779bc047b$var$stopY = currentPoint.y + $e815fda779bc047b$var$v2.ny * $e815fda779bc047b$var$lenOut;
    //-----------------------------------------
    // Part 5
    $e815fda779bc047b$var$x = $e815fda779bc047b$var$stopX - $e815fda779bc047b$var$v2.ny * $e815fda779bc047b$var$cRadius * $e815fda779bc047b$var$radDirection;
    $e815fda779bc047b$var$y = $e815fda779bc047b$var$stopY + $e815fda779bc047b$var$v2.nx * $e815fda779bc047b$var$cRadius * $e815fda779bc047b$var$radDirection;
    //-----------------------------------------
    // Additional Part : calculate start point E
    $e815fda779bc047b$var$startX = currentPoint.x + $e815fda779bc047b$var$v1.nx * $e815fda779bc047b$var$lenOut;
    $e815fda779bc047b$var$startY = currentPoint.y + $e815fda779bc047b$var$v1.ny * $e815fda779bc047b$var$lenOut;
    // Save last point to avoid recalculating vector when not needed
    $e815fda779bc047b$var$lastPoint = currentPoint;
};
/**
 * Draw corner provided by {@link getRoundCorner}
 *
 * @param ctx :CanvasRenderingContext2D
 * @param roundCorner {{cx:number, cy:number, radius:number, endAngle: number, startAngle: number, counterClockwise: boolean}}
 */ function $e815fda779bc047b$var$drawPreparedRoundCorner(ctx, roundCorner) {
    if (roundCorner.radius === 0) ctx.lineTo(roundCorner.cx, roundCorner.cy);
    else ctx.arc(roundCorner.cx, roundCorner.cy, roundCorner.radius, roundCorner.startAngle, roundCorner.endAngle, roundCorner.counterClockwise);
}
/**
 * Get round corner from a point and its previous and next neighbours in a path
 *
 * @param previousPoint {{x: number, y:number, radius: number?}}
 * @param currentPoint {{x: number, y:number, radius: number?}}
 * @param nextPoint {{x: number, y:number, radius: number?}}
 * @param radiusMax :number
 * @param isArcRadius :boolean
 * @return {{
 * cx:number, cy:number, radius:number,
 * startX:number, startY:number,
 * stopX:number, stopY: number,
 * endAngle: number, startAngle: number, counterClockwise: boolean
 * }}
 */ function $e815fda779bc047b$var$getRoundCorner(previousPoint, currentPoint, nextPoint, radiusMax) {
    var isArcRadius = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    if (radiusMax === 0 || currentPoint.radius === 0) return {
        cx: currentPoint.x,
        cy: currentPoint.y,
        radius: 0,
        startX: currentPoint.x,
        startY: currentPoint.y,
        stopX: currentPoint.x,
        stopY: currentPoint.y,
        startAngle: undefined,
        endAngle: undefined,
        counterClockwise: undefined
    };
    $e815fda779bc047b$var$calcCornerArc(previousPoint, currentPoint, nextPoint, radiusMax, isArcRadius);
    return {
        cx: $e815fda779bc047b$var$x,
        cy: $e815fda779bc047b$var$y,
        radius: $e815fda779bc047b$var$cRadius,
        startX: $e815fda779bc047b$var$startX,
        startY: $e815fda779bc047b$var$startY,
        stopX: $e815fda779bc047b$var$stopX,
        stopY: $e815fda779bc047b$var$stopY,
        startAngle: $e815fda779bc047b$var$v1.ang + Math.PI / 2 * $e815fda779bc047b$var$radDirection,
        endAngle: $e815fda779bc047b$var$v2.ang - Math.PI / 2 * $e815fda779bc047b$var$radDirection,
        counterClockwise: $e815fda779bc047b$var$drawDirection
    };
}
var $e815fda779bc047b$var$BRp$c = {};
$e815fda779bc047b$var$BRp$c.findMidptPtsEtc = function(edge, pairInfo) {
    var posPts = pairInfo.posPts, intersectionPts = pairInfo.intersectionPts, vectorNormInverse = pairInfo.vectorNormInverse;
    var midptPts;
    // n.b. assumes all edges in bezier bundle have same endpoints specified
    var srcManEndpt = edge.pstyle('source-endpoint');
    var tgtManEndpt = edge.pstyle('target-endpoint');
    var haveManualEndPts = srcManEndpt.units != null && tgtManEndpt.units != null;
    var recalcVectorNormInverse = function recalcVectorNormInverse(x1, y1, x2, y2) {
        var dy = y2 - y1;
        var dx = x2 - x1;
        var l = Math.sqrt(dx * dx + dy * dy);
        return {
            x: -dy / l,
            y: dx / l
        };
    };
    var edgeDistances = edge.pstyle('edge-distances').value;
    switch(edgeDistances){
        case 'node-position':
            midptPts = posPts;
            break;
        case 'intersection':
            midptPts = intersectionPts;
            break;
        case 'endpoints':
            if (haveManualEndPts) {
                var _this$manualEndptToPx = this.manualEndptToPx(edge.source()[0], srcManEndpt), _this$manualEndptToPx2 = $e815fda779bc047b$var$_slicedToArray(_this$manualEndptToPx, 2), x1 = _this$manualEndptToPx2[0], y1 = _this$manualEndptToPx2[1];
                var _this$manualEndptToPx3 = this.manualEndptToPx(edge.target()[0], tgtManEndpt), _this$manualEndptToPx4 = $e815fda779bc047b$var$_slicedToArray(_this$manualEndptToPx3, 2), x2 = _this$manualEndptToPx4[0], y2 = _this$manualEndptToPx4[1];
                var endPts = {
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2
                };
                vectorNormInverse = recalcVectorNormInverse(x1, y1, x2, y2);
                midptPts = endPts;
            } else {
                $e815fda779bc047b$var$warn("Edge ".concat(edge.id(), " has edge-distances:endpoints specified without manual endpoints specified via source-endpoint and target-endpoint.  Falling back on edge-distances:intersection (default)."));
                midptPts = intersectionPts; // back to default
            }
            break;
    }
    return {
        midptPts: midptPts,
        vectorNormInverse: vectorNormInverse
    };
};
$e815fda779bc047b$var$BRp$c.findHaystackPoints = function(edges) {
    for(var i = 0; i < edges.length; i++){
        var edge = edges[i];
        var _p = edge._private;
        var rs = _p.rscratch;
        if (!rs.haystack) {
            var angle = Math.random() * 2 * Math.PI;
            rs.source = {
                x: Math.cos(angle),
                y: Math.sin(angle)
            };
            angle = Math.random() * 2 * Math.PI;
            rs.target = {
                x: Math.cos(angle),
                y: Math.sin(angle)
            };
        }
        var src = _p.source;
        var tgt = _p.target;
        var srcPos = src.position();
        var tgtPos = tgt.position();
        var srcW = src.width();
        var tgtW = tgt.width();
        var srcH = src.height();
        var tgtH = tgt.height();
        var radius = edge.pstyle('haystack-radius').value;
        var halfRadius = radius / 2; // b/c have to half width/height
        rs.haystackPts = rs.allpts = [
            rs.source.x * srcW * halfRadius + srcPos.x,
            rs.source.y * srcH * halfRadius + srcPos.y,
            rs.target.x * tgtW * halfRadius + tgtPos.x,
            rs.target.y * tgtH * halfRadius + tgtPos.y
        ];
        rs.midX = (rs.allpts[0] + rs.allpts[2]) / 2;
        rs.midY = (rs.allpts[1] + rs.allpts[3]) / 2;
        // always override as haystack in case set to different type previously
        rs.edgeType = 'haystack';
        rs.haystack = true;
        this.storeEdgeProjections(edge);
        this.calculateArrowAngles(edge);
        this.recalculateEdgeLabelProjections(edge);
        this.calculateLabelAngles(edge);
    }
};
$e815fda779bc047b$var$BRp$c.findSegmentsPoints = function(edge, pairInfo) {
    // Segments (multiple straight lines)
    var rs = edge._private.rscratch;
    var segmentWs = edge.pstyle('segment-weights');
    var segmentDs = edge.pstyle('segment-distances');
    var segmentRs = edge.pstyle('segment-radii');
    var segmentTs = edge.pstyle('radius-type');
    var segmentsN = Math.min(segmentWs.pfValue.length, segmentDs.pfValue.length);
    var lastRadius = segmentRs.pfValue[segmentRs.pfValue.length - 1];
    var lastRadiusType = segmentTs.pfValue[segmentTs.pfValue.length - 1];
    rs.edgeType = 'segments';
    rs.segpts = [];
    rs.radii = [];
    rs.isArcRadius = [];
    for(var s = 0; s < segmentsN; s++){
        var w = segmentWs.pfValue[s];
        var d = segmentDs.pfValue[s];
        var w1 = 1 - w;
        var w2 = w;
        var _this$findMidptPtsEtc = this.findMidptPtsEtc(edge, pairInfo), midptPts = _this$findMidptPtsEtc.midptPts, vectorNormInverse = _this$findMidptPtsEtc.vectorNormInverse;
        var adjustedMidpt = {
            x: midptPts.x1 * w1 + midptPts.x2 * w2,
            y: midptPts.y1 * w1 + midptPts.y2 * w2
        };
        rs.segpts.push(adjustedMidpt.x + vectorNormInverse.x * d, adjustedMidpt.y + vectorNormInverse.y * d);
        rs.radii.push(segmentRs.pfValue[s] !== undefined ? segmentRs.pfValue[s] : lastRadius);
        rs.isArcRadius.push((segmentTs.pfValue[s] !== undefined ? segmentTs.pfValue[s] : lastRadiusType) === 'arc-radius');
    }
};
$e815fda779bc047b$var$BRp$c.findLoopPoints = function(edge, pairInfo, i, edgeIsUnbundled) {
    // Self-edge
    var rs = edge._private.rscratch;
    var dirCounts = pairInfo.dirCounts, srcPos = pairInfo.srcPos;
    var ctrlptDists = edge.pstyle('control-point-distances');
    var ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[0] : undefined;
    var loopDir = edge.pstyle('loop-direction').pfValue;
    var loopSwp = edge.pstyle('loop-sweep').pfValue;
    var stepSize = edge.pstyle('control-point-step-size').pfValue;
    rs.edgeType = 'self';
    var j = i;
    var loopDist = stepSize;
    if (edgeIsUnbundled) {
        j = 0;
        loopDist = ctrlptDist;
    }
    var loopAngle = loopDir - Math.PI / 2;
    var outAngle = loopAngle - loopSwp / 2;
    var inAngle = loopAngle + loopSwp / 2;
    // increase by step size for overlapping loops, keyed on direction and sweep values
    var dc = String(loopDir + '_' + loopSwp);
    j = dirCounts[dc] === undefined ? dirCounts[dc] = 0 : ++dirCounts[dc];
    rs.ctrlpts = [
        srcPos.x + Math.cos(outAngle) * 1.4 * loopDist * (j / 3 + 1),
        srcPos.y + Math.sin(outAngle) * 1.4 * loopDist * (j / 3 + 1),
        srcPos.x + Math.cos(inAngle) * 1.4 * loopDist * (j / 3 + 1),
        srcPos.y + Math.sin(inAngle) * 1.4 * loopDist * (j / 3 + 1)
    ];
};
$e815fda779bc047b$var$BRp$c.findCompoundLoopPoints = function(edge, pairInfo, i, edgeIsUnbundled) {
    // Compound edge
    var rs = edge._private.rscratch;
    rs.edgeType = 'compound';
    var srcPos = pairInfo.srcPos, tgtPos = pairInfo.tgtPos, srcW = pairInfo.srcW, srcH = pairInfo.srcH, tgtW = pairInfo.tgtW, tgtH = pairInfo.tgtH;
    var stepSize = edge.pstyle('control-point-step-size').pfValue;
    var ctrlptDists = edge.pstyle('control-point-distances');
    var ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[0] : undefined;
    var j = i;
    var loopDist = stepSize;
    if (edgeIsUnbundled) {
        j = 0;
        loopDist = ctrlptDist;
    }
    var loopW = 50;
    var loopaPos = {
        x: srcPos.x - srcW / 2,
        y: srcPos.y - srcH / 2
    };
    var loopbPos = {
        x: tgtPos.x - tgtW / 2,
        y: tgtPos.y - tgtH / 2
    };
    var loopPos = {
        x: Math.min(loopaPos.x, loopbPos.x),
        y: Math.min(loopaPos.y, loopbPos.y)
    };
    // avoids cases with impossible beziers
    var minCompoundStretch = 0.5;
    var compoundStretchA = Math.max(minCompoundStretch, Math.log(srcW * 0.01));
    var compoundStretchB = Math.max(minCompoundStretch, Math.log(tgtW * 0.01));
    rs.ctrlpts = [
        loopPos.x,
        loopPos.y - (1 + Math.pow(loopW, 1.12) / 100) * loopDist * (j / 3 + 1) * compoundStretchA,
        loopPos.x - (1 + Math.pow(loopW, 1.12) / 100) * loopDist * (j / 3 + 1) * compoundStretchB,
        loopPos.y
    ];
};
$e815fda779bc047b$var$BRp$c.findStraightEdgePoints = function(edge) {
    // Straight edge within bundle
    edge._private.rscratch.edgeType = 'straight';
};
$e815fda779bc047b$var$BRp$c.findBezierPoints = function(edge, pairInfo, i, edgeIsUnbundled, edgeIsSwapped) {
    var rs = edge._private.rscratch;
    var stepSize = edge.pstyle('control-point-step-size').pfValue;
    var ctrlptDists = edge.pstyle('control-point-distances');
    var ctrlptWs = edge.pstyle('control-point-weights');
    var bezierN = ctrlptDists && ctrlptWs ? Math.min(ctrlptDists.value.length, ctrlptWs.value.length) : 1;
    var ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[0] : undefined;
    var ctrlptWeight = ctrlptWs.value[0];
    // (Multi)bezier
    var multi = edgeIsUnbundled;
    rs.edgeType = multi ? 'multibezier' : 'bezier';
    rs.ctrlpts = [];
    for(var b = 0; b < bezierN; b++){
        var normctrlptDist = (0.5 - pairInfo.eles.length / 2 + i) * stepSize * (edgeIsSwapped ? -1 : 1);
        var manctrlptDist = void 0;
        var sign = $e815fda779bc047b$var$signum(normctrlptDist);
        if (multi) {
            ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[b] : stepSize; // fall back on step size
            ctrlptWeight = ctrlptWs.value[b];
        }
        if (edgeIsUnbundled) // multi or single unbundled
        manctrlptDist = ctrlptDist;
        else manctrlptDist = ctrlptDist !== undefined ? sign * ctrlptDist : undefined;
        var distanceFromMidpoint = manctrlptDist !== undefined ? manctrlptDist : normctrlptDist;
        var w1 = 1 - ctrlptWeight;
        var w2 = ctrlptWeight;
        var _this$findMidptPtsEtc2 = this.findMidptPtsEtc(edge, pairInfo), midptPts = _this$findMidptPtsEtc2.midptPts, vectorNormInverse = _this$findMidptPtsEtc2.vectorNormInverse;
        var adjustedMidpt = {
            x: midptPts.x1 * w1 + midptPts.x2 * w2,
            y: midptPts.y1 * w1 + midptPts.y2 * w2
        };
        rs.ctrlpts.push(adjustedMidpt.x + vectorNormInverse.x * distanceFromMidpoint, adjustedMidpt.y + vectorNormInverse.y * distanceFromMidpoint);
    }
};
$e815fda779bc047b$var$BRp$c.findTaxiPoints = function(edge, pairInfo) {
    // Taxicab geometry with two turns maximum
    var rs = edge._private.rscratch;
    rs.edgeType = 'segments';
    var VERTICAL = 'vertical';
    var HORIZONTAL = 'horizontal';
    var LEFTWARD = 'leftward';
    var RIGHTWARD = 'rightward';
    var DOWNWARD = 'downward';
    var UPWARD = 'upward';
    var AUTO = 'auto';
    var posPts = pairInfo.posPts, srcW = pairInfo.srcW, srcH = pairInfo.srcH, tgtW = pairInfo.tgtW, tgtH = pairInfo.tgtH;
    var edgeDistances = edge.pstyle('edge-distances').value;
    var dIncludesNodeBody = edgeDistances !== 'node-position';
    var taxiDir = edge.pstyle('taxi-direction').value;
    var rawTaxiDir = taxiDir; // unprocessed value
    var taxiTurn = edge.pstyle('taxi-turn');
    var turnIsPercent = taxiTurn.units === '%';
    var taxiTurnPfVal = taxiTurn.pfValue;
    var turnIsNegative = taxiTurnPfVal < 0; // i.e. from target side
    var minD = edge.pstyle('taxi-turn-min-distance').pfValue;
    var dw = dIncludesNodeBody ? (srcW + tgtW) / 2 : 0;
    var dh = dIncludesNodeBody ? (srcH + tgtH) / 2 : 0;
    var pdx = posPts.x2 - posPts.x1;
    var pdy = posPts.y2 - posPts.y1;
    // take away the effective w/h from the magnitude of the delta value
    var subDWH = function subDWH(dxy, dwh) {
        if (dxy > 0) return Math.max(dxy - dwh, 0);
        else return Math.min(dxy + dwh, 0);
    };
    var dx = subDWH(pdx, dw);
    var dy = subDWH(pdy, dh);
    var isExplicitDir = false;
    if (rawTaxiDir === AUTO) taxiDir = Math.abs(dx) > Math.abs(dy) ? HORIZONTAL : VERTICAL;
    else if (rawTaxiDir === UPWARD || rawTaxiDir === DOWNWARD) {
        taxiDir = VERTICAL;
        isExplicitDir = true;
    } else if (rawTaxiDir === LEFTWARD || rawTaxiDir === RIGHTWARD) {
        taxiDir = HORIZONTAL;
        isExplicitDir = true;
    }
    var isVert = taxiDir === VERTICAL;
    var l = isVert ? dy : dx;
    var pl = isVert ? pdy : pdx;
    var sgnL = $e815fda779bc047b$var$signum(pl);
    var forcedDir = false;
    if (!(isExplicitDir && (turnIsPercent || turnIsNegative) // forcing in this case would cause weird growing in the opposite direction
    ) && (rawTaxiDir === DOWNWARD && pl < 0 || rawTaxiDir === UPWARD && pl > 0 || rawTaxiDir === LEFTWARD && pl > 0 || rawTaxiDir === RIGHTWARD && pl < 0)) {
        sgnL *= -1;
        l = sgnL * Math.abs(l);
        forcedDir = true;
    }
    var d;
    if (turnIsPercent) {
        var p = taxiTurnPfVal < 0 ? 1 + taxiTurnPfVal : taxiTurnPfVal;
        d = p * l;
    } else {
        var k = taxiTurnPfVal < 0 ? l : 0;
        d = k + taxiTurnPfVal * sgnL;
    }
    var getIsTooClose = function getIsTooClose(d) {
        return Math.abs(d) < minD || Math.abs(d) >= Math.abs(l);
    };
    var isTooCloseSrc = getIsTooClose(d);
    var isTooCloseTgt = getIsTooClose(Math.abs(l) - Math.abs(d));
    var isTooClose = isTooCloseSrc || isTooCloseTgt;
    if (isTooClose && !forcedDir) {
        // non-ideal routing
        if (isVert) {
            // vertical fallbacks
            var lShapeInsideSrc = Math.abs(pl) <= srcH / 2;
            var lShapeInsideTgt = Math.abs(pdx) <= tgtW / 2;
            if (lShapeInsideSrc) {
                // horizontal Z-shape (direction not respected)
                var x = (posPts.x1 + posPts.x2) / 2;
                var y1 = posPts.y1, y2 = posPts.y2;
                rs.segpts = [
                    x,
                    y1,
                    x,
                    y2
                ];
            } else if (lShapeInsideTgt) {
                // vertical Z-shape (distance not respected)
                var y = (posPts.y1 + posPts.y2) / 2;
                var x1 = posPts.x1, x2 = posPts.x2;
                rs.segpts = [
                    x1,
                    y,
                    x2,
                    y
                ];
            } else // L-shape fallback (turn distance not respected, but works well with tree siblings)
            rs.segpts = [
                posPts.x1,
                posPts.y2
            ];
        } else {
            // horizontal fallbacks
            var _lShapeInsideSrc = Math.abs(pl) <= srcW / 2;
            var _lShapeInsideTgt = Math.abs(pdy) <= tgtH / 2;
            if (_lShapeInsideSrc) {
                // vertical Z-shape (direction not respected)
                var _y = (posPts.y1 + posPts.y2) / 2;
                var _x = posPts.x1, _x2 = posPts.x2;
                rs.segpts = [
                    _x,
                    _y,
                    _x2,
                    _y
                ];
            } else if (_lShapeInsideTgt) {
                // horizontal Z-shape (turn distance not respected)
                var _x3 = (posPts.x1 + posPts.x2) / 2;
                var _y2 = posPts.y1, _y3 = posPts.y2;
                rs.segpts = [
                    _x3,
                    _y2,
                    _x3,
                    _y3
                ];
            } else // L-shape (turn distance not respected, but works well for tree siblings)
            rs.segpts = [
                posPts.x2,
                posPts.y1
            ];
        }
    } else // ideal routing
    if (isVert) {
        var _y4 = posPts.y1 + d + (dIncludesNodeBody ? srcH / 2 * sgnL : 0);
        var _x4 = posPts.x1, _x5 = posPts.x2;
        rs.segpts = [
            _x4,
            _y4,
            _x5,
            _y4
        ];
    } else {
        // horizontal
        var _x6 = posPts.x1 + d + (dIncludesNodeBody ? srcW / 2 * sgnL : 0);
        var _y5 = posPts.y1, _y6 = posPts.y2;
        rs.segpts = [
            _x6,
            _y5,
            _x6,
            _y6
        ];
    }
    if (rs.isRound) {
        var radius = edge.pstyle('taxi-radius').value;
        var isArcRadius = edge.pstyle('radius-type').value[0] === 'arc-radius';
        rs.radii = new Array(rs.segpts.length / 2).fill(radius);
        rs.isArcRadius = new Array(rs.segpts.length / 2).fill(isArcRadius);
    }
};
$e815fda779bc047b$var$BRp$c.tryToCorrectInvalidPoints = function(edge, pairInfo) {
    var rs = edge._private.rscratch;
    // can only correct beziers for now...
    if (rs.edgeType === 'bezier') {
        var srcPos = pairInfo.srcPos, tgtPos = pairInfo.tgtPos, srcW = pairInfo.srcW, srcH = pairInfo.srcH, tgtW = pairInfo.tgtW, tgtH = pairInfo.tgtH, srcShape = pairInfo.srcShape, tgtShape = pairInfo.tgtShape, srcCornerRadius = pairInfo.srcCornerRadius, tgtCornerRadius = pairInfo.tgtCornerRadius, srcRs = pairInfo.srcRs, tgtRs = pairInfo.tgtRs;
        var badStart = !$e815fda779bc047b$var$number$1(rs.startX) || !$e815fda779bc047b$var$number$1(rs.startY);
        var badAStart = !$e815fda779bc047b$var$number$1(rs.arrowStartX) || !$e815fda779bc047b$var$number$1(rs.arrowStartY);
        var badEnd = !$e815fda779bc047b$var$number$1(rs.endX) || !$e815fda779bc047b$var$number$1(rs.endY);
        var badAEnd = !$e815fda779bc047b$var$number$1(rs.arrowEndX) || !$e815fda779bc047b$var$number$1(rs.arrowEndY);
        var minCpADistFactor = 3;
        var arrowW = this.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.arrowShapeWidth;
        var minCpADist = minCpADistFactor * arrowW;
        var startACpDist = $e815fda779bc047b$var$dist({
            x: rs.ctrlpts[0],
            y: rs.ctrlpts[1]
        }, {
            x: rs.startX,
            y: rs.startY
        });
        var closeStartACp = startACpDist < minCpADist;
        var endACpDist = $e815fda779bc047b$var$dist({
            x: rs.ctrlpts[0],
            y: rs.ctrlpts[1]
        }, {
            x: rs.endX,
            y: rs.endY
        });
        var closeEndACp = endACpDist < minCpADist;
        var overlapping = false;
        if (badStart || badAStart || closeStartACp) {
            overlapping = true;
            // project control point along line from src centre to outside the src shape
            // (otherwise intersection will yield nothing)
            var cpD = {
                // delta
                x: rs.ctrlpts[0] - srcPos.x,
                y: rs.ctrlpts[1] - srcPos.y
            };
            var cpL = Math.sqrt(cpD.x * cpD.x + cpD.y * cpD.y); // length of line
            var cpM = {
                // normalised delta
                x: cpD.x / cpL,
                y: cpD.y / cpL
            };
            var radius = Math.max(srcW, srcH);
            var cpProj = {
                // *2 radius guarantees outside shape
                x: rs.ctrlpts[0] + cpM.x * 2 * radius,
                y: rs.ctrlpts[1] + cpM.y * 2 * radius
            };
            var srcCtrlPtIntn = srcShape.intersectLine(srcPos.x, srcPos.y, srcW, srcH, cpProj.x, cpProj.y, 0, srcCornerRadius, srcRs);
            if (closeStartACp) {
                rs.ctrlpts[0] = rs.ctrlpts[0] + cpM.x * (minCpADist - startACpDist);
                rs.ctrlpts[1] = rs.ctrlpts[1] + cpM.y * (minCpADist - startACpDist);
            } else {
                rs.ctrlpts[0] = srcCtrlPtIntn[0] + cpM.x * minCpADist;
                rs.ctrlpts[1] = srcCtrlPtIntn[1] + cpM.y * minCpADist;
            }
        }
        if (badEnd || badAEnd || closeEndACp) {
            overlapping = true;
            // project control point along line from tgt centre to outside the tgt shape
            // (otherwise intersection will yield nothing)
            var _cpD = {
                // delta
                x: rs.ctrlpts[0] - tgtPos.x,
                y: rs.ctrlpts[1] - tgtPos.y
            };
            var _cpL = Math.sqrt(_cpD.x * _cpD.x + _cpD.y * _cpD.y); // length of line
            var _cpM = {
                // normalised delta
                x: _cpD.x / _cpL,
                y: _cpD.y / _cpL
            };
            var _radius = Math.max(srcW, srcH);
            var _cpProj = {
                // *2 radius guarantees outside shape
                x: rs.ctrlpts[0] + _cpM.x * 2 * _radius,
                y: rs.ctrlpts[1] + _cpM.y * 2 * _radius
            };
            var tgtCtrlPtIntn = tgtShape.intersectLine(tgtPos.x, tgtPos.y, tgtW, tgtH, _cpProj.x, _cpProj.y, 0, tgtCornerRadius, tgtRs);
            if (closeEndACp) {
                rs.ctrlpts[0] = rs.ctrlpts[0] + _cpM.x * (minCpADist - endACpDist);
                rs.ctrlpts[1] = rs.ctrlpts[1] + _cpM.y * (minCpADist - endACpDist);
            } else {
                rs.ctrlpts[0] = tgtCtrlPtIntn[0] + _cpM.x * minCpADist;
                rs.ctrlpts[1] = tgtCtrlPtIntn[1] + _cpM.y * minCpADist;
            }
        }
        if (overlapping) // recalc endpts
        this.findEndpoints(edge);
    }
};
$e815fda779bc047b$var$BRp$c.storeAllpts = function(edge) {
    var rs = edge._private.rscratch;
    if (rs.edgeType === 'multibezier' || rs.edgeType === 'bezier' || rs.edgeType === 'self' || rs.edgeType === 'compound') {
        rs.allpts = [];
        rs.allpts.push(rs.startX, rs.startY);
        for(var b = 0; b + 1 < rs.ctrlpts.length; b += 2){
            // ctrl pt itself
            rs.allpts.push(rs.ctrlpts[b], rs.ctrlpts[b + 1]);
            // the midpt between ctrlpts as intermediate destination pts
            if (b + 3 < rs.ctrlpts.length) rs.allpts.push((rs.ctrlpts[b] + rs.ctrlpts[b + 2]) / 2, (rs.ctrlpts[b + 1] + rs.ctrlpts[b + 3]) / 2);
        }
        rs.allpts.push(rs.endX, rs.endY);
        var m1, mt;
        if (rs.ctrlpts.length / 2 % 2 === 0) {
            m1 = rs.allpts.length / 2 - 1;
            rs.midX = rs.allpts[m1];
            rs.midY = rs.allpts[m1 + 1];
        } else {
            m1 = rs.allpts.length / 2 - 3;
            mt = 0.5;
            rs.midX = $e815fda779bc047b$var$qbezierAt(rs.allpts[m1], rs.allpts[m1 + 2], rs.allpts[m1 + 4], mt);
            rs.midY = $e815fda779bc047b$var$qbezierAt(rs.allpts[m1 + 1], rs.allpts[m1 + 3], rs.allpts[m1 + 5], mt);
        }
    } else if (rs.edgeType === 'straight') {
        // need to calc these after endpts
        rs.allpts = [
            rs.startX,
            rs.startY,
            rs.endX,
            rs.endY
        ];
        // default midpt for labels etc
        rs.midX = (rs.startX + rs.endX + rs.arrowStartX + rs.arrowEndX) / 4;
        rs.midY = (rs.startY + rs.endY + rs.arrowStartY + rs.arrowEndY) / 4;
    } else if (rs.edgeType === 'segments') {
        rs.allpts = [];
        rs.allpts.push(rs.startX, rs.startY);
        rs.allpts.push.apply(rs.allpts, rs.segpts);
        rs.allpts.push(rs.endX, rs.endY);
        if (rs.isRound) {
            rs.roundCorners = [];
            for(var i = 2; i + 3 < rs.allpts.length; i += 2){
                var radius = rs.radii[i / 2 - 1];
                var isArcRadius = rs.isArcRadius[i / 2 - 1];
                rs.roundCorners.push($e815fda779bc047b$var$getRoundCorner({
                    x: rs.allpts[i - 2],
                    y: rs.allpts[i - 1]
                }, {
                    x: rs.allpts[i],
                    y: rs.allpts[i + 1],
                    radius: radius
                }, {
                    x: rs.allpts[i + 2],
                    y: rs.allpts[i + 3]
                }, radius, isArcRadius));
            }
        }
        if (rs.segpts.length % 4 === 0) {
            var i2 = rs.segpts.length / 2;
            var i1 = i2 - 2;
            rs.midX = (rs.segpts[i1] + rs.segpts[i2]) / 2;
            rs.midY = (rs.segpts[i1 + 1] + rs.segpts[i2 + 1]) / 2;
        } else {
            var _i = rs.segpts.length / 2 - 1;
            if (!rs.isRound) {
                rs.midX = rs.segpts[_i];
                rs.midY = rs.segpts[_i + 1];
            } else {
                var point = {
                    x: rs.segpts[_i],
                    y: rs.segpts[_i + 1]
                };
                var corner = rs.roundCorners[_i / 2];
                var v = [
                    point.x - corner.cx,
                    point.y - corner.cy
                ];
                var factor = corner.radius / Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2));
                v = v.map(function(c) {
                    return c * factor;
                });
                rs.midX = corner.cx + v[0];
                rs.midY = corner.cy + v[1];
                rs.midVector = v;
            }
        }
    }
};
$e815fda779bc047b$var$BRp$c.checkForInvalidEdgeWarning = function(edge) {
    var rs = edge[0]._private.rscratch;
    if (rs.nodesOverlap || $e815fda779bc047b$var$number$1(rs.startX) && $e815fda779bc047b$var$number$1(rs.startY) && $e815fda779bc047b$var$number$1(rs.endX) && $e815fda779bc047b$var$number$1(rs.endY)) rs.loggedErr = false;
    else if (!rs.loggedErr) {
        rs.loggedErr = true;
        $e815fda779bc047b$var$warn('Edge `' + edge.id() + '` has invalid endpoints and so it is impossible to draw.  Adjust your edge style (e.g. control points) accordingly or use an alternative edge type.  This is expected behaviour when the source node and the target node overlap.');
    }
};
$e815fda779bc047b$var$BRp$c.findEdgeControlPoints = function(edges) {
    var _this = this;
    if (!edges || edges.length === 0) return;
    var r = this;
    var cy = r.cy;
    var hasCompounds = cy.hasCompoundNodes();
    var hashTable = {
        map: new $e815fda779bc047b$var$Map$2(),
        get: function get(pairId) {
            var map2 = this.map.get(pairId[0]);
            if (map2 != null) return map2.get(pairId[1]);
            else return null;
        },
        set: function set(pairId, val) {
            var map2 = this.map.get(pairId[0]);
            if (map2 == null) {
                map2 = new $e815fda779bc047b$var$Map$2();
                this.map.set(pairId[0], map2);
            }
            map2.set(pairId[1], val);
        }
    };
    var pairIds = [];
    var haystackEdges = [];
    // create a table of edge (src, tgt) => list of edges between them
    for(var i = 0; i < edges.length; i++){
        var edge = edges[i];
        var _p = edge._private;
        var curveStyle = edge.pstyle('curve-style').value;
        // ignore edges who are not to be displayed
        // they shouldn't take up space
        if (edge.removed() || !edge.takesUpSpace()) continue;
        if (curveStyle === 'haystack') {
            haystackEdges.push(edge);
            continue;
        }
        var edgeIsUnbundled = curveStyle === 'unbundled-bezier' || curveStyle.endsWith('segments') || curveStyle === 'straight' || curveStyle === 'straight-triangle' || curveStyle.endsWith('taxi');
        var edgeIsBezier = curveStyle === 'unbundled-bezier' || curveStyle === 'bezier';
        var src = _p.source;
        var tgt = _p.target;
        var srcIndex = src.poolIndex();
        var tgtIndex = tgt.poolIndex();
        var pairId = [
            srcIndex,
            tgtIndex
        ].sort();
        var tableEntry = hashTable.get(pairId);
        if (tableEntry == null) {
            tableEntry = {
                eles: []
            };
            hashTable.set(pairId, tableEntry);
            pairIds.push(pairId);
        }
        tableEntry.eles.push(edge);
        if (edgeIsUnbundled) tableEntry.hasUnbundled = true;
        if (edgeIsBezier) tableEntry.hasBezier = true;
    }
    // for each pair (src, tgt), create the ctrl pts
    // Nested for loop is OK; total number of iterations for both loops = edgeCount
    var _loop = function _loop(p) {
        var pairId = pairIds[p];
        var pairInfo = hashTable.get(pairId);
        var swappedpairInfo = void 0;
        if (!pairInfo.hasUnbundled) {
            var pllEdges = pairInfo.eles[0].parallelEdges().filter(function(e) {
                return e.isBundledBezier();
            });
            $e815fda779bc047b$var$clearArray(pairInfo.eles);
            pllEdges.forEach(function(edge) {
                return pairInfo.eles.push(edge);
            });
            // for each pair id, the edges should be sorted by index
            pairInfo.eles.sort(function(edge1, edge2) {
                return edge1.poolIndex() - edge2.poolIndex();
            });
        }
        var firstEdge = pairInfo.eles[0];
        var src = firstEdge.source();
        var tgt = firstEdge.target();
        // make sure src/tgt distinction is consistent w.r.t. pairId
        if (src.poolIndex() > tgt.poolIndex()) {
            var temp = src;
            src = tgt;
            tgt = temp;
        }
        var srcPos = pairInfo.srcPos = src.position();
        var tgtPos = pairInfo.tgtPos = tgt.position();
        var srcW = pairInfo.srcW = src.outerWidth();
        var srcH = pairInfo.srcH = src.outerHeight();
        var tgtW = pairInfo.tgtW = tgt.outerWidth();
        var tgtH = pairInfo.tgtH = tgt.outerHeight();
        var srcShape = pairInfo.srcShape = r.nodeShapes[_this.getNodeShape(src)];
        var tgtShape = pairInfo.tgtShape = r.nodeShapes[_this.getNodeShape(tgt)];
        var srcCornerRadius = pairInfo.srcCornerRadius = src.pstyle('corner-radius').value === 'auto' ? 'auto' : src.pstyle('corner-radius').pfValue;
        var tgtCornerRadius = pairInfo.tgtCornerRadius = tgt.pstyle('corner-radius').value === 'auto' ? 'auto' : tgt.pstyle('corner-radius').pfValue;
        var tgtRs = pairInfo.tgtRs = tgt._private.rscratch;
        var srcRs = pairInfo.srcRs = src._private.rscratch;
        pairInfo.dirCounts = {
            'north': 0,
            'west': 0,
            'south': 0,
            'east': 0,
            'northwest': 0,
            'southwest': 0,
            'northeast': 0,
            'southeast': 0
        };
        for(var _i2 = 0; _i2 < pairInfo.eles.length; _i2++){
            var _edge = pairInfo.eles[_i2];
            var rs = _edge[0]._private.rscratch;
            var _curveStyle = _edge.pstyle('curve-style').value;
            var _edgeIsUnbundled = _curveStyle === 'unbundled-bezier' || _curveStyle.endsWith('segments') || _curveStyle.endsWith('taxi');
            // whether the normalised pair order is the reverse of the edge's src-tgt order
            var edgeIsSwapped = !src.same(_edge.source());
            if (!pairInfo.calculatedIntersection && src !== tgt && (pairInfo.hasBezier || pairInfo.hasUnbundled)) {
                pairInfo.calculatedIntersection = true;
                // pt outside src shape to calc distance/displacement from src to tgt
                var srcOutside = srcShape.intersectLine(srcPos.x, srcPos.y, srcW, srcH, tgtPos.x, tgtPos.y, 0, srcCornerRadius, srcRs);
                var srcIntn = pairInfo.srcIntn = srcOutside;
                // pt outside tgt shape to calc distance/displacement from src to tgt
                var tgtOutside = tgtShape.intersectLine(tgtPos.x, tgtPos.y, tgtW, tgtH, srcPos.x, srcPos.y, 0, tgtCornerRadius, tgtRs);
                var tgtIntn = pairInfo.tgtIntn = tgtOutside;
                var intersectionPts = pairInfo.intersectionPts = {
                    x1: srcOutside[0],
                    x2: tgtOutside[0],
                    y1: srcOutside[1],
                    y2: tgtOutside[1]
                };
                var posPts = pairInfo.posPts = {
                    x1: srcPos.x,
                    x2: tgtPos.x,
                    y1: srcPos.y,
                    y2: tgtPos.y
                };
                var dy = tgtOutside[1] - srcOutside[1];
                var dx = tgtOutside[0] - srcOutside[0];
                var l = Math.sqrt(dx * dx + dy * dy);
                var vector = pairInfo.vector = {
                    x: dx,
                    y: dy
                };
                var vectorNorm = pairInfo.vectorNorm = {
                    x: vector.x / l,
                    y: vector.y / l
                };
                var vectorNormInverse = {
                    x: -vectorNorm.y,
                    y: vectorNorm.x
                };
                // if node shapes overlap, then no ctrl pts to draw
                pairInfo.nodesOverlap = !$e815fda779bc047b$var$number$1(l) || tgtShape.checkPoint(srcOutside[0], srcOutside[1], 0, tgtW, tgtH, tgtPos.x, tgtPos.y, tgtCornerRadius, tgtRs) || srcShape.checkPoint(tgtOutside[0], tgtOutside[1], 0, srcW, srcH, srcPos.x, srcPos.y, srcCornerRadius, srcRs);
                pairInfo.vectorNormInverse = vectorNormInverse;
                swappedpairInfo = {
                    nodesOverlap: pairInfo.nodesOverlap,
                    dirCounts: pairInfo.dirCounts,
                    calculatedIntersection: true,
                    hasBezier: pairInfo.hasBezier,
                    hasUnbundled: pairInfo.hasUnbundled,
                    eles: pairInfo.eles,
                    srcPos: tgtPos,
                    srcRs: tgtRs,
                    tgtPos: srcPos,
                    tgtRs: srcRs,
                    srcW: tgtW,
                    srcH: tgtH,
                    tgtW: srcW,
                    tgtH: srcH,
                    srcIntn: tgtIntn,
                    tgtIntn: srcIntn,
                    srcShape: tgtShape,
                    tgtShape: srcShape,
                    posPts: {
                        x1: posPts.x2,
                        y1: posPts.y2,
                        x2: posPts.x1,
                        y2: posPts.y1
                    },
                    intersectionPts: {
                        x1: intersectionPts.x2,
                        y1: intersectionPts.y2,
                        x2: intersectionPts.x1,
                        y2: intersectionPts.y1
                    },
                    vector: {
                        x: -vector.x,
                        y: -vector.y
                    },
                    vectorNorm: {
                        x: -vectorNorm.x,
                        y: -vectorNorm.y
                    },
                    vectorNormInverse: {
                        x: -vectorNormInverse.x,
                        y: -vectorNormInverse.y
                    }
                };
            }
            var passedPairInfo = edgeIsSwapped ? swappedpairInfo : pairInfo;
            rs.nodesOverlap = passedPairInfo.nodesOverlap;
            rs.srcIntn = passedPairInfo.srcIntn;
            rs.tgtIntn = passedPairInfo.tgtIntn;
            rs.isRound = _curveStyle.startsWith('round');
            if (hasCompounds && (src.isParent() || src.isChild() || tgt.isParent() || tgt.isChild()) && (src.parents().anySame(tgt) || tgt.parents().anySame(src) || src.same(tgt) && src.isParent())) _this.findCompoundLoopPoints(_edge, passedPairInfo, _i2, _edgeIsUnbundled);
            else if (src === tgt) _this.findLoopPoints(_edge, passedPairInfo, _i2, _edgeIsUnbundled);
            else if (_curveStyle.endsWith('segments')) _this.findSegmentsPoints(_edge, passedPairInfo);
            else if (_curveStyle.endsWith('taxi')) _this.findTaxiPoints(_edge, passedPairInfo);
            else if (_curveStyle === 'straight' || !_edgeIsUnbundled && pairInfo.eles.length % 2 === 1 && _i2 === Math.floor(pairInfo.eles.length / 2)) _this.findStraightEdgePoints(_edge);
            else _this.findBezierPoints(_edge, passedPairInfo, _i2, _edgeIsUnbundled, edgeIsSwapped);
            _this.findEndpoints(_edge);
            _this.tryToCorrectInvalidPoints(_edge, passedPairInfo);
            _this.checkForInvalidEdgeWarning(_edge);
            _this.storeAllpts(_edge);
            _this.storeEdgeProjections(_edge);
            _this.calculateArrowAngles(_edge);
            _this.recalculateEdgeLabelProjections(_edge);
            _this.calculateLabelAngles(_edge);
        } // for pair edges
    };
    for(var p = 0; p < pairIds.length; p++)_loop(p);
     // for pair ids
    // haystacks avoid the expense of pairInfo stuff (intersections etc.)
    this.findHaystackPoints(haystackEdges);
};
function $e815fda779bc047b$var$getPts(pts) {
    var retPts = [];
    if (pts == null) return;
    for(var i = 0; i < pts.length; i += 2){
        var x = pts[i];
        var y = pts[i + 1];
        retPts.push({
            x: x,
            y: y
        });
    }
    return retPts;
}
$e815fda779bc047b$var$BRp$c.getSegmentPoints = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    var type = rs.edgeType;
    if (type === 'segments') return $e815fda779bc047b$var$getPts(rs.segpts);
};
$e815fda779bc047b$var$BRp$c.getControlPoints = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    var type = rs.edgeType;
    if (type === 'bezier' || type === 'multibezier' || type === 'self' || type === 'compound') return $e815fda779bc047b$var$getPts(rs.ctrlpts);
};
$e815fda779bc047b$var$BRp$c.getEdgeMidpoint = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    return {
        x: rs.midX,
        y: rs.midY
    };
};
var $e815fda779bc047b$var$BRp$b = {};
$e815fda779bc047b$var$BRp$b.manualEndptToPx = function(node, prop) {
    var r = this;
    var npos = node.position();
    var w = node.outerWidth();
    var h = node.outerHeight();
    var rs = node._private.rscratch;
    if (prop.value.length === 2) {
        var p = [
            prop.pfValue[0],
            prop.pfValue[1]
        ];
        if (prop.units[0] === '%') p[0] = p[0] * w;
        if (prop.units[1] === '%') p[1] = p[1] * h;
        p[0] += npos.x;
        p[1] += npos.y;
        return p;
    } else {
        var angle = prop.pfValue[0];
        angle = -Math.PI / 2 + angle; // start at 12 o'clock
        var l = 2 * Math.max(w, h);
        var _p = [
            npos.x + Math.cos(angle) * l,
            npos.y + Math.sin(angle) * l
        ];
        return r.nodeShapes[this.getNodeShape(node)].intersectLine(npos.x, npos.y, w, h, _p[0], _p[1], 0, node.pstyle('corner-radius').value === 'auto' ? 'auto' : node.pstyle('corner-radius').pfValue, rs);
    }
};
$e815fda779bc047b$var$BRp$b.findEndpoints = function(edge) {
    var r = this;
    var intersect;
    var source = edge.source()[0];
    var target = edge.target()[0];
    var srcPos = source.position();
    var tgtPos = target.position();
    var tgtArShape = edge.pstyle('target-arrow-shape').value;
    var srcArShape = edge.pstyle('source-arrow-shape').value;
    var tgtDist = edge.pstyle('target-distance-from-node').pfValue;
    var srcDist = edge.pstyle('source-distance-from-node').pfValue;
    var srcRs = source._private.rscratch;
    var tgtRs = target._private.rscratch;
    var curveStyle = edge.pstyle('curve-style').value;
    var rs = edge._private.rscratch;
    var et = rs.edgeType;
    var taxi = curveStyle === 'taxi';
    var self1 = et === 'self' || et === 'compound';
    var bezier = et === 'bezier' || et === 'multibezier' || self1;
    var multi = et !== 'bezier';
    var lines = et === 'straight' || et === 'segments';
    var segments = et === 'segments';
    var hasEndpts = bezier || multi || lines;
    var overrideEndpts = self1 || taxi;
    var srcManEndpt = edge.pstyle('source-endpoint');
    var srcManEndptVal = overrideEndpts ? 'outside-to-node' : srcManEndpt.value;
    var srcCornerRadius = source.pstyle('corner-radius').value === 'auto' ? 'auto' : source.pstyle('corner-radius').pfValue;
    var tgtManEndpt = edge.pstyle('target-endpoint');
    var tgtManEndptVal = overrideEndpts ? 'outside-to-node' : tgtManEndpt.value;
    var tgtCornerRadius = target.pstyle('corner-radius').value === 'auto' ? 'auto' : target.pstyle('corner-radius').pfValue;
    rs.srcManEndpt = srcManEndpt;
    rs.tgtManEndpt = tgtManEndpt;
    var p1; // last known point of edge on target side
    var p2; // last known point of edge on source side
    var p1_i; // point to intersect with target shape
    var p2_i; // point to intersect with source shape
    if (bezier) {
        var cpStart = [
            rs.ctrlpts[0],
            rs.ctrlpts[1]
        ];
        var cpEnd = multi ? [
            rs.ctrlpts[rs.ctrlpts.length - 2],
            rs.ctrlpts[rs.ctrlpts.length - 1]
        ] : cpStart;
        p1 = cpEnd;
        p2 = cpStart;
    } else if (lines) {
        var srcArrowFromPt = !segments ? [
            tgtPos.x,
            tgtPos.y
        ] : rs.segpts.slice(0, 2);
        var tgtArrowFromPt = !segments ? [
            srcPos.x,
            srcPos.y
        ] : rs.segpts.slice(rs.segpts.length - 2);
        p1 = tgtArrowFromPt;
        p2 = srcArrowFromPt;
    }
    if (tgtManEndptVal === 'inside-to-node') intersect = [
        tgtPos.x,
        tgtPos.y
    ];
    else if (tgtManEndpt.units) intersect = this.manualEndptToPx(target, tgtManEndpt);
    else if (tgtManEndptVal === 'outside-to-line') intersect = rs.tgtIntn; // use cached value from ctrlpt calc
    else {
        if (tgtManEndptVal === 'outside-to-node' || tgtManEndptVal === 'outside-to-node-or-label') p1_i = p1;
        else if (tgtManEndptVal === 'outside-to-line' || tgtManEndptVal === 'outside-to-line-or-label') p1_i = [
            srcPos.x,
            srcPos.y
        ];
        intersect = r.nodeShapes[this.getNodeShape(target)].intersectLine(tgtPos.x, tgtPos.y, target.outerWidth(), target.outerHeight(), p1_i[0], p1_i[1], 0, tgtCornerRadius, tgtRs);
        if (tgtManEndptVal === 'outside-to-node-or-label' || tgtManEndptVal === 'outside-to-line-or-label') {
            var trs = target._private.rscratch;
            var lw = trs.labelWidth;
            var lh = trs.labelHeight;
            var lx = trs.labelX;
            var ly = trs.labelY;
            var lw2 = lw / 2;
            var lh2 = lh / 2;
            var va = target.pstyle('text-valign').value;
            if (va === 'top') ly -= lh2;
            else if (va === 'bottom') ly += lh2;
            var ha = target.pstyle('text-halign').value;
            if (ha === 'left') lx -= lw2;
            else if (ha === 'right') lx += lw2;
            var labelIntersect = $e815fda779bc047b$var$polygonIntersectLine(p1_i[0], p1_i[1], [
                lx - lw2,
                ly - lh2,
                lx + lw2,
                ly - lh2,
                lx + lw2,
                ly + lh2,
                lx - lw2,
                ly + lh2
            ], tgtPos.x, tgtPos.y);
            if (labelIntersect.length > 0) {
                var refPt = srcPos;
                var intSqdist = $e815fda779bc047b$var$sqdist(refPt, $e815fda779bc047b$var$array2point(intersect));
                var labIntSqdist = $e815fda779bc047b$var$sqdist(refPt, $e815fda779bc047b$var$array2point(labelIntersect));
                var minSqDist = intSqdist;
                if (labIntSqdist < intSqdist) {
                    intersect = labelIntersect;
                    minSqDist = labIntSqdist;
                }
                if (labelIntersect.length > 2) {
                    var labInt2SqDist = $e815fda779bc047b$var$sqdist(refPt, {
                        x: labelIntersect[2],
                        y: labelIntersect[3]
                    });
                    if (labInt2SqDist < minSqDist) intersect = [
                        labelIntersect[2],
                        labelIntersect[3]
                    ];
                }
            }
        }
    }
    var arrowEnd = $e815fda779bc047b$var$shortenIntersection(intersect, p1, r.arrowShapes[tgtArShape].spacing(edge) + tgtDist);
    var edgeEnd = $e815fda779bc047b$var$shortenIntersection(intersect, p1, r.arrowShapes[tgtArShape].gap(edge) + tgtDist);
    rs.endX = edgeEnd[0];
    rs.endY = edgeEnd[1];
    rs.arrowEndX = arrowEnd[0];
    rs.arrowEndY = arrowEnd[1];
    if (srcManEndptVal === 'inside-to-node') intersect = [
        srcPos.x,
        srcPos.y
    ];
    else if (srcManEndpt.units) intersect = this.manualEndptToPx(source, srcManEndpt);
    else if (srcManEndptVal === 'outside-to-line') intersect = rs.srcIntn; // use cached value from ctrlpt calc
    else {
        if (srcManEndptVal === 'outside-to-node' || srcManEndptVal === 'outside-to-node-or-label') p2_i = p2;
        else if (srcManEndptVal === 'outside-to-line' || srcManEndptVal === 'outside-to-line-or-label') p2_i = [
            tgtPos.x,
            tgtPos.y
        ];
        intersect = r.nodeShapes[this.getNodeShape(source)].intersectLine(srcPos.x, srcPos.y, source.outerWidth(), source.outerHeight(), p2_i[0], p2_i[1], 0, srcCornerRadius, srcRs);
        if (srcManEndptVal === 'outside-to-node-or-label' || srcManEndptVal === 'outside-to-line-or-label') {
            var srs = source._private.rscratch;
            var _lw = srs.labelWidth;
            var _lh = srs.labelHeight;
            var _lx = srs.labelX;
            var _ly = srs.labelY;
            var _lw2 = _lw / 2;
            var _lh2 = _lh / 2;
            var _va = source.pstyle('text-valign').value;
            if (_va === 'top') _ly -= _lh2;
            else if (_va === 'bottom') _ly += _lh2;
            var _ha = source.pstyle('text-halign').value;
            if (_ha === 'left') _lx -= _lw2;
            else if (_ha === 'right') _lx += _lw2;
            var _labelIntersect = $e815fda779bc047b$var$polygonIntersectLine(p2_i[0], p2_i[1], [
                _lx - _lw2,
                _ly - _lh2,
                _lx + _lw2,
                _ly - _lh2,
                _lx + _lw2,
                _ly + _lh2,
                _lx - _lw2,
                _ly + _lh2
            ], srcPos.x, srcPos.y);
            if (_labelIntersect.length > 0) {
                var _refPt = tgtPos;
                var _intSqdist = $e815fda779bc047b$var$sqdist(_refPt, $e815fda779bc047b$var$array2point(intersect));
                var _labIntSqdist = $e815fda779bc047b$var$sqdist(_refPt, $e815fda779bc047b$var$array2point(_labelIntersect));
                var _minSqDist = _intSqdist;
                if (_labIntSqdist < _intSqdist) {
                    intersect = [
                        _labelIntersect[0],
                        _labelIntersect[1]
                    ];
                    _minSqDist = _labIntSqdist;
                }
                if (_labelIntersect.length > 2) {
                    var _labInt2SqDist = $e815fda779bc047b$var$sqdist(_refPt, {
                        x: _labelIntersect[2],
                        y: _labelIntersect[3]
                    });
                    if (_labInt2SqDist < _minSqDist) intersect = [
                        _labelIntersect[2],
                        _labelIntersect[3]
                    ];
                }
            }
        }
    }
    var arrowStart = $e815fda779bc047b$var$shortenIntersection(intersect, p2, r.arrowShapes[srcArShape].spacing(edge) + srcDist);
    var edgeStart = $e815fda779bc047b$var$shortenIntersection(intersect, p2, r.arrowShapes[srcArShape].gap(edge) + srcDist);
    rs.startX = edgeStart[0];
    rs.startY = edgeStart[1];
    rs.arrowStartX = arrowStart[0];
    rs.arrowStartY = arrowStart[1];
    if (hasEndpts) {
        if (!$e815fda779bc047b$var$number$1(rs.startX) || !$e815fda779bc047b$var$number$1(rs.startY) || !$e815fda779bc047b$var$number$1(rs.endX) || !$e815fda779bc047b$var$number$1(rs.endY)) rs.badLine = true;
        else rs.badLine = false;
    }
};
$e815fda779bc047b$var$BRp$b.getSourceEndpoint = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    switch(rs.edgeType){
        case 'haystack':
            return {
                x: rs.haystackPts[0],
                y: rs.haystackPts[1]
            };
        default:
            return {
                x: rs.arrowStartX,
                y: rs.arrowStartY
            };
    }
};
$e815fda779bc047b$var$BRp$b.getTargetEndpoint = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    switch(rs.edgeType){
        case 'haystack':
            return {
                x: rs.haystackPts[2],
                y: rs.haystackPts[3]
            };
        default:
            return {
                x: rs.arrowEndX,
                y: rs.arrowEndY
            };
    }
};
var $e815fda779bc047b$var$BRp$a = {};
function $e815fda779bc047b$var$pushBezierPts(r, edge, pts) {
    var qbezierAt$1 = function qbezierAt$1(p1, p2, p3, t) {
        return $e815fda779bc047b$var$qbezierAt(p1, p2, p3, t);
    };
    var _p = edge._private;
    var bpts = _p.rstyle.bezierPts;
    for(var i = 0; i < r.bezierProjPcts.length; i++){
        var p = r.bezierProjPcts[i];
        bpts.push({
            x: qbezierAt$1(pts[0], pts[2], pts[4], p),
            y: qbezierAt$1(pts[1], pts[3], pts[5], p)
        });
    }
}
$e815fda779bc047b$var$BRp$a.storeEdgeProjections = function(edge) {
    var _p = edge._private;
    var rs = _p.rscratch;
    var et = rs.edgeType;
    // clear the cached points state
    _p.rstyle.bezierPts = null;
    _p.rstyle.linePts = null;
    _p.rstyle.haystackPts = null;
    if (et === 'multibezier' || et === 'bezier' || et === 'self' || et === 'compound') {
        _p.rstyle.bezierPts = [];
        for(var i = 0; i + 5 < rs.allpts.length; i += 4)$e815fda779bc047b$var$pushBezierPts(this, edge, rs.allpts.slice(i, i + 6));
    } else if (et === 'segments') {
        var lpts = _p.rstyle.linePts = [];
        for(var i = 0; i + 1 < rs.allpts.length; i += 2)lpts.push({
            x: rs.allpts[i],
            y: rs.allpts[i + 1]
        });
    } else if (et === 'haystack') {
        var hpts = rs.haystackPts;
        _p.rstyle.haystackPts = [
            {
                x: hpts[0],
                y: hpts[1]
            },
            {
                x: hpts[2],
                y: hpts[3]
            }
        ];
    }
    _p.rstyle.arrowWidth = this.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.arrowShapeWidth;
};
$e815fda779bc047b$var$BRp$a.recalculateEdgeProjections = function(edges) {
    this.findEdgeControlPoints(edges);
};
var $e815fda779bc047b$var$BRp$9 = {};
$e815fda779bc047b$var$BRp$9.recalculateNodeLabelProjection = function(node) {
    var content = node.pstyle('label').strValue;
    if ($e815fda779bc047b$var$emptyString(content)) return;
    var textX, textY;
    var _p = node._private;
    var nodeWidth = node.width();
    var nodeHeight = node.height();
    var padding = node.padding();
    var nodePos = node.position();
    var textHalign = node.pstyle('text-halign').strValue;
    var textValign = node.pstyle('text-valign').strValue;
    var rs = _p.rscratch;
    var rstyle = _p.rstyle;
    switch(textHalign){
        case 'left':
            textX = nodePos.x - nodeWidth / 2 - padding;
            break;
        case 'right':
            textX = nodePos.x + nodeWidth / 2 + padding;
            break;
        default:
            // e.g. center
            textX = nodePos.x;
    }
    switch(textValign){
        case 'top':
            textY = nodePos.y - nodeHeight / 2 - padding;
            break;
        case 'bottom':
            textY = nodePos.y + nodeHeight / 2 + padding;
            break;
        default:
            // e.g. middle
            textY = nodePos.y;
    }
    rs.labelX = textX;
    rs.labelY = textY;
    rstyle.labelX = textX;
    rstyle.labelY = textY;
    this.calculateLabelAngles(node);
    this.applyLabelDimensions(node);
};
var $e815fda779bc047b$var$lineAngleFromDelta = function lineAngleFromDelta(dx, dy) {
    var angle = Math.atan(dy / dx);
    if (dx === 0 && angle < 0) angle = angle * -1;
    return angle;
};
var $e815fda779bc047b$var$lineAngle = function lineAngle(p0, p1) {
    var dx = p1.x - p0.x;
    var dy = p1.y - p0.y;
    return $e815fda779bc047b$var$lineAngleFromDelta(dx, dy);
};
var $e815fda779bc047b$var$bezierAngle = function bezierAngle(p0, p1, p2, t) {
    var t0 = $e815fda779bc047b$var$bound(0, t - 0.001, 1);
    var t1 = $e815fda779bc047b$var$bound(0, t + 0.001, 1);
    var lp0 = $e815fda779bc047b$var$qbezierPtAt(p0, p1, p2, t0);
    var lp1 = $e815fda779bc047b$var$qbezierPtAt(p0, p1, p2, t1);
    return $e815fda779bc047b$var$lineAngle(lp0, lp1);
};
$e815fda779bc047b$var$BRp$9.recalculateEdgeLabelProjections = function(edge) {
    var p;
    var _p = edge._private;
    var rs = _p.rscratch;
    var r = this;
    var content = {
        mid: edge.pstyle('label').strValue,
        source: edge.pstyle('source-label').strValue,
        target: edge.pstyle('target-label').strValue
    };
    if (content.mid || content.source || content.target) ;
    else return; // no labels => no calcs
    // add center point to style so bounding box calculations can use it
    //
    p = {
        x: rs.midX,
        y: rs.midY
    };
    var setRs = function setRs(propName, prefix, value) {
        $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, propName, prefix, value);
        $e815fda779bc047b$var$setPrefixedProperty(_p.rstyle, propName, prefix, value);
    };
    setRs('labelX', null, p.x);
    setRs('labelY', null, p.y);
    var midAngle = $e815fda779bc047b$var$lineAngleFromDelta(rs.midDispX, rs.midDispY);
    setRs('labelAutoAngle', null, midAngle);
    var createControlPointInfo = function createControlPointInfo() {
        if (createControlPointInfo.cache) return createControlPointInfo.cache;
         // use cache so only 1x per edge
        var ctrlpts = [];
        // store each ctrlpt info init
        for(var i = 0; i + 5 < rs.allpts.length; i += 4){
            var p0 = {
                x: rs.allpts[i],
                y: rs.allpts[i + 1]
            };
            var p1 = {
                x: rs.allpts[i + 2],
                y: rs.allpts[i + 3]
            }; // ctrlpt
            var p2 = {
                x: rs.allpts[i + 4],
                y: rs.allpts[i + 5]
            };
            ctrlpts.push({
                p0: p0,
                p1: p1,
                p2: p2,
                startDist: 0,
                length: 0,
                segments: []
            });
        }
        var bpts = _p.rstyle.bezierPts;
        var nProjs = r.bezierProjPcts.length;
        function addSegment(cp, p0, p1, t0, t1) {
            var length = $e815fda779bc047b$var$dist(p0, p1);
            var prevSegment = cp.segments[cp.segments.length - 1];
            var segment = {
                p0: p0,
                p1: p1,
                t0: t0,
                t1: t1,
                startDist: prevSegment ? prevSegment.startDist + prevSegment.length : 0,
                length: length
            };
            cp.segments.push(segment);
            cp.length += length;
        }
        // update each ctrlpt with segment info
        for(var _i = 0; _i < ctrlpts.length; _i++){
            var cp = ctrlpts[_i];
            var prevCp = ctrlpts[_i - 1];
            if (prevCp) cp.startDist = prevCp.startDist + prevCp.length;
            addSegment(cp, cp.p0, bpts[_i * nProjs], 0, r.bezierProjPcts[0]); // first
            for(var j = 0; j < nProjs - 1; j++)addSegment(cp, bpts[_i * nProjs + j], bpts[_i * nProjs + j + 1], r.bezierProjPcts[j], r.bezierProjPcts[j + 1]);
            addSegment(cp, bpts[_i * nProjs + nProjs - 1], cp.p2, r.bezierProjPcts[nProjs - 1], 1); // last
        }
        return createControlPointInfo.cache = ctrlpts;
    };
    var calculateEndProjection = function calculateEndProjection(prefix) {
        var angle;
        var isSrc = prefix === 'source';
        if (!content[prefix]) return;
        var offset = edge.pstyle(prefix + '-text-offset').pfValue;
        switch(rs.edgeType){
            case 'self':
            case 'compound':
            case 'bezier':
            case 'multibezier':
                var cps = createControlPointInfo();
                var selected;
                var startDist = 0;
                var totalDist = 0;
                // find the segment we're on
                for(var i = 0; i < cps.length; i++){
                    var _cp = cps[isSrc ? i : cps.length - 1 - i];
                    for(var j = 0; j < _cp.segments.length; j++){
                        var _seg = _cp.segments[isSrc ? j : _cp.segments.length - 1 - j];
                        var lastSeg = i === cps.length - 1 && j === _cp.segments.length - 1;
                        startDist = totalDist;
                        totalDist += _seg.length;
                        if (totalDist >= offset || lastSeg) {
                            selected = {
                                cp: _cp,
                                segment: _seg
                            };
                            break;
                        }
                    }
                    if (selected) break;
                }
                var cp = selected.cp;
                var seg = selected.segment;
                var tSegment = (offset - startDist) / seg.length;
                var segDt = seg.t1 - seg.t0;
                var t = isSrc ? seg.t0 + segDt * tSegment : seg.t1 - segDt * tSegment;
                t = $e815fda779bc047b$var$bound(0, t, 1);
                p = $e815fda779bc047b$var$qbezierPtAt(cp.p0, cp.p1, cp.p2, t);
                angle = $e815fda779bc047b$var$bezierAngle(cp.p0, cp.p1, cp.p2, t);
                break;
            case 'straight':
            case 'segments':
            case 'haystack':
                var d = 0, di, d0;
                var p0, p1;
                var l = rs.allpts.length;
                for(var _i2 = 0; _i2 + 3 < l; _i2 += 2){
                    if (isSrc) {
                        p0 = {
                            x: rs.allpts[_i2],
                            y: rs.allpts[_i2 + 1]
                        };
                        p1 = {
                            x: rs.allpts[_i2 + 2],
                            y: rs.allpts[_i2 + 3]
                        };
                    } else {
                        p0 = {
                            x: rs.allpts[l - 2 - _i2],
                            y: rs.allpts[l - 1 - _i2]
                        };
                        p1 = {
                            x: rs.allpts[l - 4 - _i2],
                            y: rs.allpts[l - 3 - _i2]
                        };
                    }
                    di = $e815fda779bc047b$var$dist(p0, p1);
                    d0 = d;
                    d += di;
                    if (d >= offset) break;
                }
                var pD = offset - d0;
                var _t = pD / di;
                _t = $e815fda779bc047b$var$bound(0, _t, 1);
                p = $e815fda779bc047b$var$lineAt(p0, p1, _t);
                angle = $e815fda779bc047b$var$lineAngle(p0, p1);
                break;
        }
        setRs('labelX', prefix, p.x);
        setRs('labelY', prefix, p.y);
        setRs('labelAutoAngle', prefix, angle);
    };
    calculateEndProjection('source');
    calculateEndProjection('target');
    this.applyLabelDimensions(edge);
};
$e815fda779bc047b$var$BRp$9.applyLabelDimensions = function(ele) {
    this.applyPrefixedLabelDimensions(ele);
    if (ele.isEdge()) {
        this.applyPrefixedLabelDimensions(ele, 'source');
        this.applyPrefixedLabelDimensions(ele, 'target');
    }
};
$e815fda779bc047b$var$BRp$9.applyPrefixedLabelDimensions = function(ele, prefix) {
    var _p = ele._private;
    var text = this.getLabelText(ele, prefix);
    var labelDims = this.calculateLabelDimensions(ele, text);
    var lineHeight = ele.pstyle('line-height').pfValue;
    var textWrap = ele.pstyle('text-wrap').strValue;
    var lines = $e815fda779bc047b$var$getPrefixedProperty(_p.rscratch, 'labelWrapCachedLines', prefix) || [];
    var numLines = textWrap !== 'wrap' ? 1 : Math.max(lines.length, 1);
    var normPerLineHeight = labelDims.height / numLines;
    var labelLineHeight = normPerLineHeight * lineHeight;
    var width = labelDims.width;
    var height = labelDims.height + (numLines - 1) * (lineHeight - 1) * normPerLineHeight;
    $e815fda779bc047b$var$setPrefixedProperty(_p.rstyle, 'labelWidth', prefix, width);
    $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, 'labelWidth', prefix, width);
    $e815fda779bc047b$var$setPrefixedProperty(_p.rstyle, 'labelHeight', prefix, height);
    $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, 'labelHeight', prefix, height);
    $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, 'labelLineHeight', prefix, labelLineHeight);
};
$e815fda779bc047b$var$BRp$9.getLabelText = function(ele, prefix) {
    var _p = ele._private;
    var pfd = prefix ? prefix + '-' : '';
    var text = ele.pstyle(pfd + 'label').strValue;
    var textTransform = ele.pstyle('text-transform').value;
    var rscratch = function rscratch(propName, value) {
        if (value) {
            $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, propName, prefix, value);
            return value;
        } else return $e815fda779bc047b$var$getPrefixedProperty(_p.rscratch, propName, prefix);
    };
    // for empty text, skip all processing
    if (!text) return '';
    if (textTransform == 'none') ;
    else if (textTransform == 'uppercase') text = text.toUpperCase();
    else if (textTransform == 'lowercase') text = text.toLowerCase();
    var wrapStyle = ele.pstyle('text-wrap').value;
    if (wrapStyle === 'wrap') {
        var labelKey = rscratch('labelKey');
        // save recalc if the label is the same as before
        if (labelKey != null && rscratch('labelWrapKey') === labelKey) return rscratch('labelWrapCachedText');
        var zwsp = "\u200B";
        var lines = text.split('\n');
        var maxW = ele.pstyle('text-max-width').pfValue;
        var overflow = ele.pstyle('text-overflow-wrap').value;
        var overflowAny = overflow === 'anywhere';
        var wrappedLines = [];
        var separatorRegex = /[\s\u200b]+|$/g; // Include end of string to add last word
        for(var l = 0; l < lines.length; l++){
            var line = lines[l];
            var lineDims = this.calculateLabelDimensions(ele, line);
            var lineW = lineDims.width;
            if (overflowAny) {
                var processedLine = line.split('').join(zwsp);
                line = processedLine;
            }
            if (lineW > maxW) {
                // line is too long
                var separatorMatches = line.matchAll(separatorRegex);
                var subline = '';
                var previousIndex = 0;
                // Add fake match
                var _iterator = $e815fda779bc047b$var$_createForOfIteratorHelper(separatorMatches), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var separatorMatch = _step.value;
                        var wordSeparator = separatorMatch[0];
                        var word = line.substring(previousIndex, separatorMatch.index);
                        previousIndex = separatorMatch.index + wordSeparator.length;
                        var testLine = subline.length === 0 ? word : subline + word + wordSeparator;
                        var testDims = this.calculateLabelDimensions(ele, testLine);
                        var testW = testDims.width;
                        if (testW <= maxW) // word fits on current line
                        subline += word + wordSeparator;
                        else {
                            // word starts new line
                            if (subline) wrappedLines.push(subline);
                            subline = word + wordSeparator;
                        }
                    }
                // if there's remaining text, put it in a wrapped line
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                if (!subline.match(/^[\s\u200b]+$/)) wrappedLines.push(subline);
            } else // line is already short enough
            wrappedLines.push(line);
        } // for
        rscratch('labelWrapCachedLines', wrappedLines);
        text = rscratch('labelWrapCachedText', wrappedLines.join('\n'));
        rscratch('labelWrapKey', labelKey);
    } else if (wrapStyle === 'ellipsis') {
        var _maxW = ele.pstyle('text-max-width').pfValue;
        var ellipsized = '';
        var ellipsis = "\u2026";
        var incLastCh = false;
        if (this.calculateLabelDimensions(ele, text).width < _maxW) // the label already fits
        return text;
        for(var i = 0; i < text.length; i++){
            var widthWithNextCh = this.calculateLabelDimensions(ele, ellipsized + text[i] + ellipsis).width;
            if (widthWithNextCh > _maxW) break;
            ellipsized += text[i];
            if (i === text.length - 1) incLastCh = true;
        }
        if (!incLastCh) ellipsized += ellipsis;
        return ellipsized;
    } // if ellipsize
    return text;
};
$e815fda779bc047b$var$BRp$9.getLabelJustification = function(ele) {
    var justification = ele.pstyle('text-justification').strValue;
    var textHalign = ele.pstyle('text-halign').strValue;
    if (justification === 'auto') {
        if (ele.isNode()) switch(textHalign){
            case 'left':
                return 'right';
            case 'right':
                return 'left';
            default:
                return 'center';
        }
        else return 'center';
    } else return justification;
};
$e815fda779bc047b$var$BRp$9.calculateLabelDimensions = function(ele, text) {
    var r = this;
    var containerWindow = r.cy.window();
    var document1 = containerWindow.document;
    var cacheKey = $e815fda779bc047b$var$hashString(text, ele._private.labelDimsKey);
    var cache = r.labelDimCache || (r.labelDimCache = []);
    var existingVal = cache[cacheKey];
    if (existingVal != null) return existingVal;
    var padding = 0; // add padding around text dims, as the measurement isn't that accurate
    var fStyle = ele.pstyle('font-style').strValue;
    var size = ele.pstyle('font-size').pfValue;
    var family = ele.pstyle('font-family').strValue;
    var weight = ele.pstyle('font-weight').strValue;
    var canvas = this.labelCalcCanvas;
    var c2d = this.labelCalcCanvasContext;
    if (!canvas) {
        canvas = this.labelCalcCanvas = document1.createElement('canvas');
        c2d = this.labelCalcCanvasContext = canvas.getContext('2d');
        var ds = canvas.style;
        ds.position = 'absolute';
        ds.left = '-9999px';
        ds.top = '-9999px';
        ds.zIndex = '-1';
        ds.visibility = 'hidden';
        ds.pointerEvents = 'none';
    }
    c2d.font = "".concat(fStyle, " ").concat(weight, " ").concat(size, "px ").concat(family);
    var width = 0;
    var height = 0;
    var lines = text.split('\n');
    for(var i = 0; i < lines.length; i++){
        var line = lines[i];
        var metrics = c2d.measureText(line);
        var w = Math.ceil(metrics.width);
        var h = size;
        width = Math.max(w, width);
        height += h;
    }
    width += padding;
    height += padding;
    return cache[cacheKey] = {
        width: width,
        height: height
    };
};
$e815fda779bc047b$var$BRp$9.calculateLabelAngle = function(ele, prefix) {
    var _p = ele._private;
    var rs = _p.rscratch;
    var isEdge = ele.isEdge();
    var prefixDash = prefix ? prefix + '-' : '';
    var rot = ele.pstyle(prefixDash + 'text-rotation');
    var rotStr = rot.strValue;
    if (rotStr === 'none') return 0;
    else if (isEdge && rotStr === 'autorotate') return rs.labelAutoAngle;
    else if (rotStr === 'autorotate') return 0;
    else return rot.pfValue;
};
$e815fda779bc047b$var$BRp$9.calculateLabelAngles = function(ele) {
    var r = this;
    var isEdge = ele.isEdge();
    var _p = ele._private;
    var rs = _p.rscratch;
    rs.labelAngle = r.calculateLabelAngle(ele);
    if (isEdge) {
        rs.sourceLabelAngle = r.calculateLabelAngle(ele, 'source');
        rs.targetLabelAngle = r.calculateLabelAngle(ele, 'target');
    }
};
var $e815fda779bc047b$var$BRp$8 = {};
var $e815fda779bc047b$var$TOO_SMALL_CUT_RECT = 28;
var $e815fda779bc047b$var$warnedCutRect = false;
$e815fda779bc047b$var$BRp$8.getNodeShape = function(node) {
    var r = this;
    var shape = node.pstyle('shape').value;
    if (shape === 'cutrectangle' && (node.width() < $e815fda779bc047b$var$TOO_SMALL_CUT_RECT || node.height() < $e815fda779bc047b$var$TOO_SMALL_CUT_RECT)) {
        if (!$e815fda779bc047b$var$warnedCutRect) {
            $e815fda779bc047b$var$warn('The `cutrectangle` node shape can not be used at small sizes so `rectangle` is used instead');
            $e815fda779bc047b$var$warnedCutRect = true;
        }
        return 'rectangle';
    }
    if (node.isParent()) {
        if (shape === 'rectangle' || shape === 'roundrectangle' || shape === 'round-rectangle' || shape === 'cutrectangle' || shape === 'cut-rectangle' || shape === 'barrel') return shape;
        else return 'rectangle';
    }
    if (shape === 'polygon') {
        var points = node.pstyle('shape-polygon-points').value;
        return r.nodeShapes.makePolygon(points).name;
    }
    return shape;
};
var $e815fda779bc047b$var$BRp$7 = {};
$e815fda779bc047b$var$BRp$7.registerCalculationListeners = function() {
    var cy = this.cy;
    var elesToUpdate = cy.collection();
    var r = this;
    var enqueue = function enqueue(eles) {
        var dirtyStyleCaches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        elesToUpdate.merge(eles);
        if (dirtyStyleCaches) for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var _p = ele._private;
            var rstyle = _p.rstyle;
            rstyle.clean = false;
            rstyle.cleanConnected = false;
        }
    };
    r.binder(cy).on('bounds.* dirty.*', function onDirtyBounds(e) {
        var ele = e.target;
        enqueue(ele);
    }).on('style.* background.*', function onDirtyStyle(e) {
        var ele = e.target;
        enqueue(ele, false);
    });
    var updateEleCalcs = function updateEleCalcs(willDraw) {
        if (willDraw) {
            var fns = r.onUpdateEleCalcsFns;
            // because we need to have up-to-date style (e.g. stylesheet mappers)
            // before calculating rendered style (and pstyle might not be called yet)
            elesToUpdate.cleanStyle();
            for(var i = 0; i < elesToUpdate.length; i++){
                var ele = elesToUpdate[i];
                var rstyle = ele._private.rstyle;
                if (ele.isNode() && !rstyle.cleanConnected) {
                    enqueue(ele.connectedEdges());
                    rstyle.cleanConnected = true;
                }
            }
            if (fns) for(var _i = 0; _i < fns.length; _i++){
                var fn = fns[_i];
                fn(willDraw, elesToUpdate);
            }
            r.recalculateRenderedStyle(elesToUpdate);
            elesToUpdate = cy.collection();
        }
    };
    r.flushRenderedStyleQueue = function() {
        updateEleCalcs(true);
    };
    r.beforeRender(updateEleCalcs, r.beforeRenderPriorities.eleCalcs);
};
$e815fda779bc047b$var$BRp$7.onUpdateEleCalcs = function(fn) {
    var fns = this.onUpdateEleCalcsFns = this.onUpdateEleCalcsFns || [];
    fns.push(fn);
};
$e815fda779bc047b$var$BRp$7.recalculateRenderedStyle = function(eles, useCache) {
    var isCleanConnected = function isCleanConnected(ele) {
        return ele._private.rstyle.cleanConnected;
    };
    var edges = [];
    var nodes = [];
    // the renderer can't be used for calcs when destroyed, e.g. ele.boundingBox()
    if (this.destroyed) return;
    // use cache by default for perf
    if (useCache === undefined) useCache = true;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var _p = ele._private;
        var rstyle = _p.rstyle;
        // an edge may be implicitly dirty b/c of one of its connected nodes
        // (and a request for recalc may come in between frames)
        if (ele.isEdge() && (!isCleanConnected(ele.source()) || !isCleanConnected(ele.target()))) rstyle.clean = false;
        // only update if dirty and in graph
        if (useCache && rstyle.clean || ele.removed()) continue;
        // only update if not display: none
        if (ele.pstyle('display').value === 'none') continue;
        if (_p.group === 'nodes') nodes.push(ele);
        else // edges
        edges.push(ele);
        rstyle.clean = true;
    }
    // update node data from projections
    for(var _i2 = 0; _i2 < nodes.length; _i2++){
        var _ele = nodes[_i2];
        var _p2 = _ele._private;
        var _rstyle = _p2.rstyle;
        var pos = _ele.position();
        this.recalculateNodeLabelProjection(_ele);
        _rstyle.nodeX = pos.x;
        _rstyle.nodeY = pos.y;
        _rstyle.nodeW = _ele.pstyle('width').pfValue;
        _rstyle.nodeH = _ele.pstyle('height').pfValue;
    }
    this.recalculateEdgeProjections(edges);
    // update edge data from projections
    for(var _i3 = 0; _i3 < edges.length; _i3++){
        var _ele2 = edges[_i3];
        var _p3 = _ele2._private;
        var _rstyle2 = _p3.rstyle;
        var rs = _p3.rscratch;
        // update rstyle positions
        _rstyle2.srcX = rs.arrowStartX;
        _rstyle2.srcY = rs.arrowStartY;
        _rstyle2.tgtX = rs.arrowEndX;
        _rstyle2.tgtY = rs.arrowEndY;
        _rstyle2.midX = rs.midX;
        _rstyle2.midY = rs.midY;
        _rstyle2.labelAngle = rs.labelAngle;
        _rstyle2.sourceLabelAngle = rs.sourceLabelAngle;
        _rstyle2.targetLabelAngle = rs.targetLabelAngle;
    }
};
var $e815fda779bc047b$var$BRp$6 = {};
$e815fda779bc047b$var$BRp$6.updateCachedGrabbedEles = function() {
    var eles = this.cachedZSortedEles;
    if (!eles) // just let this be recalculated on the next z sort tick
    return;
    eles.drag = [];
    eles.nondrag = [];
    var grabTargets = [];
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var rs = ele._private.rscratch;
        if (ele.grabbed() && !ele.isParent()) grabTargets.push(ele);
        else if (rs.inDragLayer) eles.drag.push(ele);
        else eles.nondrag.push(ele);
    }
    // put the grab target nodes last so it's on top of its neighbourhood
    for(var i = 0; i < grabTargets.length; i++){
        var ele = grabTargets[i];
        eles.drag.push(ele);
    }
};
$e815fda779bc047b$var$BRp$6.invalidateCachedZSortedEles = function() {
    this.cachedZSortedEles = null;
};
$e815fda779bc047b$var$BRp$6.getCachedZSortedEles = function(forceRecalc) {
    if (forceRecalc || !this.cachedZSortedEles) {
        var eles = this.cy.mutableElements().toArray();
        eles.sort($e815fda779bc047b$var$zIndexSort);
        eles.interactive = eles.filter(function(ele) {
            return ele.interactive();
        });
        this.cachedZSortedEles = eles;
        this.updateCachedGrabbedEles();
    } else eles = this.cachedZSortedEles;
    return eles;
};
var $e815fda779bc047b$var$BRp$5 = {};
[
    $e815fda779bc047b$var$BRp$e,
    $e815fda779bc047b$var$BRp$d,
    $e815fda779bc047b$var$BRp$c,
    $e815fda779bc047b$var$BRp$b,
    $e815fda779bc047b$var$BRp$a,
    $e815fda779bc047b$var$BRp$9,
    $e815fda779bc047b$var$BRp$8,
    $e815fda779bc047b$var$BRp$7,
    $e815fda779bc047b$var$BRp$6
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$BRp$5, props);
});
var $e815fda779bc047b$var$BRp$4 = {};
$e815fda779bc047b$var$BRp$4.getCachedImage = function(url, crossOrigin, onLoad) {
    var r = this;
    var imageCache = r.imageCache = r.imageCache || {};
    var cache = imageCache[url];
    if (cache) {
        if (!cache.image.complete) cache.image.addEventListener('load', onLoad);
        return cache.image;
    } else {
        cache = imageCache[url] = imageCache[url] || {};
        var image = cache.image = new Image(); // eslint-disable-line no-undef
        image.addEventListener('load', onLoad);
        image.addEventListener('error', function() {
            image.error = true;
        });
        // #1582 safari doesn't load data uris with crossOrigin properly
        // https://bugs.webkit.org/show_bug.cgi?id=123978
        var dataUriPrefix = 'data:';
        var isDataUri = url.substring(0, dataUriPrefix.length).toLowerCase() === dataUriPrefix;
        if (!isDataUri) {
            // if crossorigin is 'null'(stringified), then manually set it to null 
            crossOrigin = crossOrigin === 'null' ? null : crossOrigin;
            image.crossOrigin = crossOrigin; // prevent tainted canvas
        }
        image.src = url;
        return image;
    }
};
var $e815fda779bc047b$var$BRp$3 = {};
/* global document, ResizeObserver, MutationObserver */ $e815fda779bc047b$var$BRp$3.registerBinding = function(target, event, handler, useCapture) {
    // eslint-disable-line no-unused-vars
    var args = Array.prototype.slice.apply(arguments, [
        1
    ]); // copy
    if (Array.isArray(target)) {
        var res = [];
        for(var i = 0; i < target.length; i++){
            var t = target[i];
            if (t !== undefined) {
                var b = this.binder(t);
                res.push(b.on.apply(b, args));
            }
        }
        return res;
    }
    var b = this.binder(target);
    return b.on.apply(b, args);
};
$e815fda779bc047b$var$BRp$3.binder = function(tgt) {
    var r = this;
    var containerWindow = r.cy.window();
    var tgtIsDom = tgt === containerWindow || tgt === containerWindow.document || tgt === containerWindow.document.body || $e815fda779bc047b$var$domElement(tgt);
    if (r.supportsPassiveEvents == null) {
        // from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
        var supportsPassive = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function get() {
                    supportsPassive = true;
                    return true;
                }
            });
            containerWindow.addEventListener('test', null, opts);
        } catch (err) {
        // not supported
        }
        r.supportsPassiveEvents = supportsPassive;
    }
    var on = function on(event, handler, useCapture) {
        var args = Array.prototype.slice.call(arguments);
        if (tgtIsDom && r.supportsPassiveEvents) // replace useCapture w/ opts obj
        args[2] = {
            capture: useCapture != null ? useCapture : false,
            passive: false,
            once: false
        };
        r.bindings.push({
            target: tgt,
            args: args
        });
        (tgt.addEventListener || tgt.on).apply(tgt, args);
        return this;
    };
    return {
        on: on,
        addEventListener: on,
        addListener: on,
        bind: on
    };
};
$e815fda779bc047b$var$BRp$3.nodeIsDraggable = function(node) {
    return node && node.isNode() && !node.locked() && node.grabbable();
};
$e815fda779bc047b$var$BRp$3.nodeIsGrabbable = function(node) {
    return this.nodeIsDraggable(node) && node.interactive();
};
$e815fda779bc047b$var$BRp$3.load = function() {
    var r = this;
    var containerWindow = r.cy.window();
    var isSelected = function isSelected(ele) {
        return ele.selected();
    };
    var getShadowRoot = function getShadowRoot(element) {
        var rootNode = element.getRootNode();
        // Check if the root node is a shadow root
        if (rootNode && rootNode.nodeType === 11 && rootNode.host !== undefined) return rootNode;
    };
    var triggerEvents = function triggerEvents(target, names, e, position) {
        if (target == null) target = r.cy;
        for(var i = 0; i < names.length; i++){
            var name = names[i];
            target.emit({
                originalEvent: e,
                type: name,
                position: position
            });
        }
    };
    var isMultSelKeyDown = function isMultSelKeyDown(e) {
        return e.shiftKey || e.metaKey || e.ctrlKey; // maybe e.altKey
    };
    var allowPanningPassthrough = function allowPanningPassthrough(down, downs) {
        var allowPassthrough = true;
        if (r.cy.hasCompoundNodes() && down && down.pannable()) // a grabbable compound node below the ele => no passthrough panning
        for(var i = 0; downs && i < downs.length; i++){
            var down = downs[i];
            //if any parent node in event hierarchy isn't pannable, reject passthrough
            if (down.isNode() && down.isParent() && !down.pannable()) {
                allowPassthrough = false;
                break;
            }
        }
        else allowPassthrough = true;
        return allowPassthrough;
    };
    var setGrabbed = function setGrabbed(ele) {
        ele[0]._private.grabbed = true;
    };
    var setFreed = function setFreed(ele) {
        ele[0]._private.grabbed = false;
    };
    var setInDragLayer = function setInDragLayer(ele) {
        ele[0]._private.rscratch.inDragLayer = true;
    };
    var setOutDragLayer = function setOutDragLayer(ele) {
        ele[0]._private.rscratch.inDragLayer = false;
    };
    var setGrabTarget = function setGrabTarget(ele) {
        ele[0]._private.rscratch.isGrabTarget = true;
    };
    var removeGrabTarget = function removeGrabTarget(ele) {
        ele[0]._private.rscratch.isGrabTarget = false;
    };
    var addToDragList = function addToDragList(ele, opts) {
        var list = opts.addToList;
        var listHasEle = list.has(ele);
        if (!listHasEle && ele.grabbable() && !ele.locked()) {
            list.merge(ele);
            setGrabbed(ele);
        }
    };
    // helper function to determine which child nodes and inner edges
    // of a compound node to be dragged as well as the grabbed and selected nodes
    var addDescendantsToDrag = function addDescendantsToDrag(node, opts) {
        if (!node.cy().hasCompoundNodes()) return;
        if (opts.inDragLayer == null && opts.addToList == null) return;
         // nothing to do
        var innerNodes = node.descendants();
        if (opts.inDragLayer) {
            innerNodes.forEach(setInDragLayer);
            innerNodes.connectedEdges().forEach(setInDragLayer);
        }
        if (opts.addToList) addToDragList(innerNodes, opts);
    };
    // adds the given nodes and its neighbourhood to the drag layer
    var addNodesToDrag = function addNodesToDrag(nodes, opts) {
        opts = opts || {};
        var hasCompoundNodes = nodes.cy().hasCompoundNodes();
        if (opts.inDragLayer) {
            nodes.forEach(setInDragLayer);
            nodes.neighborhood().stdFilter(function(ele) {
                return !hasCompoundNodes || ele.isEdge();
            }).forEach(setInDragLayer);
        }
        if (opts.addToList) nodes.forEach(function(ele) {
            addToDragList(ele, opts);
        });
        addDescendantsToDrag(nodes, opts); // always add to drag
        // also add nodes and edges related to the topmost ancestor
        updateAncestorsInDragLayer(nodes, {
            inDragLayer: opts.inDragLayer
        });
        r.updateCachedGrabbedEles();
    };
    var addNodeToDrag = addNodesToDrag;
    var freeDraggedElements = function freeDraggedElements(grabbedEles) {
        if (!grabbedEles) return;
        // just go over all elements rather than doing a bunch of (possibly expensive) traversals
        r.getCachedZSortedEles().forEach(function(ele) {
            setFreed(ele);
            setOutDragLayer(ele);
            removeGrabTarget(ele);
        });
        r.updateCachedGrabbedEles();
    };
    // helper function to determine which ancestor nodes and edges should go
    // to the drag layer (or should be removed from drag layer).
    var updateAncestorsInDragLayer = function updateAncestorsInDragLayer(node, opts) {
        if (opts.inDragLayer == null && opts.addToList == null) return;
         // nothing to do
        if (!node.cy().hasCompoundNodes()) return;
        // find top-level parent
        var parent = node.ancestors().orphans();
        // no parent node: no nodes to add to the drag layer
        if (parent.same(node)) return;
        var nodes = parent.descendants().spawnSelf().merge(parent).unmerge(node).unmerge(node.descendants());
        var edges = nodes.connectedEdges();
        if (opts.inDragLayer) {
            edges.forEach(setInDragLayer);
            nodes.forEach(setInDragLayer);
        }
        if (opts.addToList) nodes.forEach(function(ele) {
            addToDragList(ele, opts);
        });
    };
    var blurActiveDomElement = function blurActiveDomElement() {
        if (document.activeElement != null && document.activeElement.blur != null) document.activeElement.blur();
    };
    var haveMutationsApi = typeof MutationObserver !== 'undefined';
    var haveResizeObserverApi = typeof ResizeObserver !== 'undefined';
    // watch for when the cy container is removed from the dom
    if (haveMutationsApi) {
        r.removeObserver = new MutationObserver(function(mutns) {
            // eslint-disable-line no-undef
            for(var i = 0; i < mutns.length; i++){
                var mutn = mutns[i];
                var rNodes = mutn.removedNodes;
                if (rNodes) for(var j = 0; j < rNodes.length; j++){
                    var rNode = rNodes[j];
                    if (rNode === r.container) {
                        r.destroy();
                        break;
                    }
                }
            }
        });
        if (r.container.parentNode) r.removeObserver.observe(r.container.parentNode, {
            childList: true
        });
    } else r.registerBinding(r.container, 'DOMNodeRemoved', function(e) {
        // eslint-disable-line no-unused-vars
        r.destroy();
    });
    var onResize = $e815fda779bc047b$var$debounce_1(function() {
        r.cy.resize();
    }, 100);
    if (haveMutationsApi) {
        r.styleObserver = new MutationObserver(onResize); // eslint-disable-line no-undef
        r.styleObserver.observe(r.container, {
            attributes: true
        });
    }
    // auto resize
    r.registerBinding(containerWindow, 'resize', onResize); // eslint-disable-line no-undef
    if (haveResizeObserverApi) {
        r.resizeObserver = new ResizeObserver(onResize); // eslint-disable-line no-undef
        r.resizeObserver.observe(r.container);
    }
    var forEachUp = function forEachUp(domEle, fn) {
        while(domEle != null){
            fn(domEle);
            domEle = domEle.parentNode;
        }
    };
    var invalidateCoords = function invalidateCoords() {
        r.invalidateContainerClientCoordsCache();
    };
    forEachUp(r.container, function(domEle) {
        r.registerBinding(domEle, 'transitionend', invalidateCoords);
        r.registerBinding(domEle, 'animationend', invalidateCoords);
        r.registerBinding(domEle, 'scroll', invalidateCoords);
    });
    // stop right click menu from appearing on cy
    r.registerBinding(r.container, 'contextmenu', function(e) {
        e.preventDefault();
    });
    var inBoxSelection = function inBoxSelection() {
        return r.selection[4] !== 0;
    };
    var eventInContainer = function eventInContainer(e) {
        // save cycles if mouse events aren't to be captured
        var containerPageCoords = r.findContainerClientCoords();
        var x = containerPageCoords[0];
        var y = containerPageCoords[1];
        var width = containerPageCoords[2];
        var height = containerPageCoords[3];
        var positions = e.touches ? e.touches : [
            e
        ];
        var atLeastOnePosInside = false;
        for(var i = 0; i < positions.length; i++){
            var p = positions[i];
            if (x <= p.clientX && p.clientX <= x + width && y <= p.clientY && p.clientY <= y + height) {
                atLeastOnePosInside = true;
                break;
            }
        }
        if (!atLeastOnePosInside) return false;
        var container = r.container;
        var target = e.target;
        var tParent = target.parentNode;
        var containerIsTarget = false;
        while(tParent){
            if (tParent === container) {
                containerIsTarget = true;
                break;
            }
            tParent = tParent.parentNode;
        }
        if (!containerIsTarget) return false;
         // if target is outisde cy container, then this event is not for us
        return true;
    };
    // Primary key
    r.registerBinding(r.container, 'mousedown', function mousedownHandler(e) {
        if (!eventInContainer(e)) return;
        // during left mouse button gestures, ignore other buttons
        if (r.hoverData.which === 1 && e.which !== 1) return;
        e.preventDefault();
        blurActiveDomElement();
        r.hoverData.capture = true;
        r.hoverData.which = e.which;
        var cy = r.cy;
        var gpos = [
            e.clientX,
            e.clientY
        ];
        var pos = r.projectIntoViewport(gpos[0], gpos[1]);
        var select = r.selection;
        var nears = r.findNearestElements(pos[0], pos[1], true, false);
        var near = nears[0];
        var draggedElements = r.dragData.possibleDragElements;
        r.hoverData.mdownPos = pos;
        r.hoverData.mdownGPos = gpos;
        var checkForTaphold = function checkForTaphold() {
            r.hoverData.tapholdCancelled = false;
            clearTimeout(r.hoverData.tapholdTimeout);
            r.hoverData.tapholdTimeout = setTimeout(function() {
                if (r.hoverData.tapholdCancelled) return;
                else {
                    var ele = r.hoverData.down;
                    if (ele) ele.emit({
                        originalEvent: e,
                        type: 'taphold',
                        position: {
                            x: pos[0],
                            y: pos[1]
                        }
                    });
                    else cy.emit({
                        originalEvent: e,
                        type: 'taphold',
                        position: {
                            x: pos[0],
                            y: pos[1]
                        }
                    });
                }
            }, r.tapholdDuration);
        };
        // Right click button
        if (e.which == 3) {
            r.hoverData.cxtStarted = true;
            var cxtEvt = {
                originalEvent: e,
                type: 'cxttapstart',
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            };
            if (near) {
                near.activate();
                near.emit(cxtEvt);
                r.hoverData.down = near;
            } else cy.emit(cxtEvt);
            r.hoverData.downTime = new Date().getTime();
            r.hoverData.cxtDragged = false;
        // Primary button
        } else if (e.which == 1) {
            if (near) near.activate();
            // If something is under the cursor and it is draggable, prepare to grab it
            if (near != null) {
                if (r.nodeIsGrabbable(near)) {
                    var makeEvent = function makeEvent(type) {
                        return {
                            originalEvent: e,
                            type: type,
                            position: {
                                x: pos[0],
                                y: pos[1]
                            }
                        };
                    };
                    var triggerGrab = function triggerGrab(ele) {
                        ele.emit(makeEvent('grab'));
                    };
                    setGrabTarget(near);
                    if (!near.selected()) {
                        draggedElements = r.dragData.possibleDragElements = cy.collection();
                        addNodeToDrag(near, {
                            addToList: draggedElements
                        });
                        near.emit(makeEvent('grabon')).emit(makeEvent('grab'));
                    } else {
                        draggedElements = r.dragData.possibleDragElements = cy.collection();
                        var selectedNodes = cy.$(function(ele) {
                            return ele.isNode() && ele.selected() && r.nodeIsGrabbable(ele);
                        });
                        addNodesToDrag(selectedNodes, {
                            addToList: draggedElements
                        });
                        near.emit(makeEvent('grabon'));
                        selectedNodes.forEach(triggerGrab);
                    }
                    r.redrawHint('eles', true);
                    r.redrawHint('drag', true);
                }
            }
            r.hoverData.down = near;
            r.hoverData.downs = nears;
            r.hoverData.downTime = new Date().getTime();
            triggerEvents(near, [
                'mousedown',
                'tapstart',
                'vmousedown'
            ], e, {
                x: pos[0],
                y: pos[1]
            });
            if (near == null) {
                select[4] = 1;
                r.data.bgActivePosistion = {
                    x: pos[0],
                    y: pos[1]
                };
                r.redrawHint('select', true);
                r.redraw();
            } else if (near.pannable()) select[4] = 1; // for future pan
            checkForTaphold();
        }
        // Initialize selection box coordinates
        select[0] = select[2] = pos[0];
        select[1] = select[3] = pos[1];
    }, false);
    var shadowRoot = getShadowRoot(r.container);
    r.registerBinding([
        containerWindow,
        shadowRoot
    ], 'mousemove', function mousemoveHandler(e) {
        // eslint-disable-line no-undef
        var capture = r.hoverData.capture;
        if (!capture && !eventInContainer(e)) return;
        var preventDefault = false;
        var cy = r.cy;
        var zoom = cy.zoom();
        var gpos = [
            e.clientX,
            e.clientY
        ];
        var pos = r.projectIntoViewport(gpos[0], gpos[1]);
        var mdownPos = r.hoverData.mdownPos;
        var mdownGPos = r.hoverData.mdownGPos;
        var select = r.selection;
        var near = null;
        if (!r.hoverData.draggingEles && !r.hoverData.dragging && !r.hoverData.selecting) near = r.findNearestElement(pos[0], pos[1], true, false);
        var last = r.hoverData.last;
        var down = r.hoverData.down;
        var disp = [
            pos[0] - select[2],
            pos[1] - select[3]
        ];
        var draggedElements = r.dragData.possibleDragElements;
        var isOverThresholdDrag;
        if (mdownGPos) {
            var dx = gpos[0] - mdownGPos[0];
            var dx2 = dx * dx;
            var dy = gpos[1] - mdownGPos[1];
            var dy2 = dy * dy;
            var dist2 = dx2 + dy2;
            r.hoverData.isOverThresholdDrag = isOverThresholdDrag = dist2 >= r.desktopTapThreshold2;
        }
        var multSelKeyDown = isMultSelKeyDown(e);
        if (isOverThresholdDrag) r.hoverData.tapholdCancelled = true;
        var updateDragDelta = function updateDragDelta() {
            var dragDelta = r.hoverData.dragDelta = r.hoverData.dragDelta || [];
            if (dragDelta.length === 0) {
                dragDelta.push(disp[0]);
                dragDelta.push(disp[1]);
            } else {
                dragDelta[0] += disp[0];
                dragDelta[1] += disp[1];
            }
        };
        preventDefault = true;
        triggerEvents(near, [
            'mousemove',
            'vmousemove',
            'tapdrag'
        ], e, {
            x: pos[0],
            y: pos[1]
        });
        var goIntoBoxMode = function goIntoBoxMode() {
            r.data.bgActivePosistion = undefined;
            if (!r.hoverData.selecting) cy.emit({
                originalEvent: e,
                type: 'boxstart',
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            });
            select[4] = 1;
            r.hoverData.selecting = true;
            r.redrawHint('select', true);
            r.redraw();
        };
        // trigger context drag if rmouse down
        if (r.hoverData.which === 3) // but only if over threshold
        {
            if (isOverThresholdDrag) {
                var cxtEvt = {
                    originalEvent: e,
                    type: 'cxtdrag',
                    position: {
                        x: pos[0],
                        y: pos[1]
                    }
                };
                if (down) down.emit(cxtEvt);
                else cy.emit(cxtEvt);
                r.hoverData.cxtDragged = true;
                if (!r.hoverData.cxtOver || near !== r.hoverData.cxtOver) {
                    if (r.hoverData.cxtOver) r.hoverData.cxtOver.emit({
                        originalEvent: e,
                        type: 'cxtdragout',
                        position: {
                            x: pos[0],
                            y: pos[1]
                        }
                    });
                    r.hoverData.cxtOver = near;
                    if (near) near.emit({
                        originalEvent: e,
                        type: 'cxtdragover',
                        position: {
                            x: pos[0],
                            y: pos[1]
                        }
                    });
                }
            }
        } else if (r.hoverData.dragging) {
            preventDefault = true;
            if (cy.panningEnabled() && cy.userPanningEnabled()) {
                var deltaP;
                if (r.hoverData.justStartedPan) {
                    var mdPos = r.hoverData.mdownPos;
                    deltaP = {
                        x: (pos[0] - mdPos[0]) * zoom,
                        y: (pos[1] - mdPos[1]) * zoom
                    };
                    r.hoverData.justStartedPan = false;
                } else deltaP = {
                    x: disp[0] * zoom,
                    y: disp[1] * zoom
                };
                cy.panBy(deltaP);
                cy.emit('dragpan');
                r.hoverData.dragged = true;
            }
            // Needs reproject due to pan changing viewport
            pos = r.projectIntoViewport(e.clientX, e.clientY);
        // Checks primary button down & out of time & mouse not moved much
        } else if (select[4] == 1 && (down == null || down.pannable())) {
            if (isOverThresholdDrag) {
                if (!r.hoverData.dragging && cy.boxSelectionEnabled() && (multSelKeyDown || !cy.panningEnabled() || !cy.userPanningEnabled())) goIntoBoxMode();
                else if (!r.hoverData.selecting && cy.panningEnabled() && cy.userPanningEnabled()) {
                    var allowPassthrough = allowPanningPassthrough(down, r.hoverData.downs);
                    if (allowPassthrough) {
                        r.hoverData.dragging = true;
                        r.hoverData.justStartedPan = true;
                        select[4] = 0;
                        r.data.bgActivePosistion = $e815fda779bc047b$var$array2point(mdownPos);
                        r.redrawHint('select', true);
                        r.redraw();
                    }
                }
                if (down && down.pannable() && down.active()) down.unactivate();
            }
        } else {
            if (down && down.pannable() && down.active()) down.unactivate();
            if ((!down || !down.grabbed()) && near != last) {
                if (last) triggerEvents(last, [
                    'mouseout',
                    'tapdragout'
                ], e, {
                    x: pos[0],
                    y: pos[1]
                });
                if (near) triggerEvents(near, [
                    'mouseover',
                    'tapdragover'
                ], e, {
                    x: pos[0],
                    y: pos[1]
                });
                r.hoverData.last = near;
            }
            if (down) {
                if (isOverThresholdDrag) {
                    // then we can take action
                    if (cy.boxSelectionEnabled() && multSelKeyDown) {
                        // then selection overrides
                        if (down && down.grabbed()) {
                            freeDraggedElements(draggedElements);
                            down.emit('freeon');
                            draggedElements.emit('free');
                            if (r.dragData.didDrag) {
                                down.emit('dragfreeon');
                                draggedElements.emit('dragfree');
                            }
                        }
                        goIntoBoxMode();
                    } else if (down && down.grabbed() && r.nodeIsDraggable(down)) {
                        // drag node
                        var justStartedDrag = !r.dragData.didDrag;
                        if (justStartedDrag) r.redrawHint('eles', true);
                        r.dragData.didDrag = true; // indicate that we actually did drag the node
                        // now, add the elements to the drag layer if not done already
                        if (!r.hoverData.draggingEles) addNodesToDrag(draggedElements, {
                            inDragLayer: true
                        });
                        var totalShift = {
                            x: 0,
                            y: 0
                        };
                        if ($e815fda779bc047b$var$number$1(disp[0]) && $e815fda779bc047b$var$number$1(disp[1])) {
                            totalShift.x += disp[0];
                            totalShift.y += disp[1];
                            if (justStartedDrag) {
                                var dragDelta = r.hoverData.dragDelta;
                                if (dragDelta && $e815fda779bc047b$var$number$1(dragDelta[0]) && $e815fda779bc047b$var$number$1(dragDelta[1])) {
                                    totalShift.x += dragDelta[0];
                                    totalShift.y += dragDelta[1];
                                }
                            }
                        }
                        r.hoverData.draggingEles = true;
                        draggedElements.silentShift(totalShift).emit('position drag');
                        r.redrawHint('drag', true);
                        r.redraw();
                    }
                } else // otherwise save drag delta for when we actually start dragging so the relative grab pos is constant
                updateDragDelta();
            }
            // prevent the dragging from triggering text selection on the page
            preventDefault = true;
        }
        select[2] = pos[0];
        select[3] = pos[1];
        if (preventDefault) {
            if (e.stopPropagation) e.stopPropagation();
            if (e.preventDefault) e.preventDefault();
            return false;
        }
    }, false);
    var clickTimeout, didDoubleClick, prevClickTimeStamp;
    r.registerBinding(containerWindow, 'mouseup', function mouseupHandler(e) {
        // eslint-disable-line no-undef
        // during left mouse button gestures, ignore other buttons
        if (r.hoverData.which === 1 && e.which !== 1 && r.hoverData.capture) return;
        var capture = r.hoverData.capture;
        if (!capture) return;
        r.hoverData.capture = false;
        var cy = r.cy;
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        var select = r.selection;
        var near = r.findNearestElement(pos[0], pos[1], true, false);
        var draggedElements = r.dragData.possibleDragElements;
        var down = r.hoverData.down;
        var multSelKeyDown = isMultSelKeyDown(e);
        if (r.data.bgActivePosistion) {
            r.redrawHint('select', true);
            r.redraw();
        }
        r.hoverData.tapholdCancelled = true;
        r.data.bgActivePosistion = undefined; // not active bg now
        if (down) down.unactivate();
        if (r.hoverData.which === 3) {
            var cxtEvt = {
                originalEvent: e,
                type: 'cxttapend',
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            };
            if (down) down.emit(cxtEvt);
            else cy.emit(cxtEvt);
            if (!r.hoverData.cxtDragged) {
                var cxtTap = {
                    originalEvent: e,
                    type: 'cxttap',
                    position: {
                        x: pos[0],
                        y: pos[1]
                    }
                };
                if (down) down.emit(cxtTap);
                else cy.emit(cxtTap);
            }
            r.hoverData.cxtDragged = false;
            r.hoverData.which = null;
        } else if (r.hoverData.which === 1) {
            triggerEvents(near, [
                'mouseup',
                'tapend',
                'vmouseup'
            ], e, {
                x: pos[0],
                y: pos[1]
            });
            if (!r.dragData.didDrag && // didn't move a node around
            !r.hoverData.dragged && // didn't pan
            !r.hoverData.selecting && // not box selection
            !r.hoverData.isOverThresholdDrag // didn't move too much
            ) {
                triggerEvents(down, [
                    "click",
                    "tap",
                    "vclick"
                ], e, {
                    x: pos[0],
                    y: pos[1]
                });
                didDoubleClick = false;
                if (e.timeStamp - prevClickTimeStamp <= cy.multiClickDebounceTime()) {
                    clickTimeout && clearTimeout(clickTimeout);
                    didDoubleClick = true;
                    prevClickTimeStamp = null;
                    triggerEvents(down, [
                        "dblclick",
                        "dbltap",
                        "vdblclick"
                    ], e, {
                        x: pos[0],
                        y: pos[1]
                    });
                } else {
                    clickTimeout = setTimeout(function() {
                        if (didDoubleClick) return;
                        triggerEvents(down, [
                            "oneclick",
                            "onetap",
                            "voneclick"
                        ], e, {
                            x: pos[0],
                            y: pos[1]
                        });
                    }, cy.multiClickDebounceTime());
                    prevClickTimeStamp = e.timeStamp;
                }
            }
            // Deselect all elements if nothing is currently under the mouse cursor and we aren't dragging something
            if (down == null // not mousedown on node
             && !r.dragData.didDrag // didn't move the node around
             && !r.hoverData.selecting // not box selection
             && !r.hoverData.dragged // didn't pan
             && !isMultSelKeyDown(e)) {
                cy.$(isSelected).unselect([
                    'tapunselect'
                ]);
                if (draggedElements.length > 0) r.redrawHint('eles', true);
                r.dragData.possibleDragElements = draggedElements = cy.collection();
            }
            // Single selection
            if (near == down && !r.dragData.didDrag && !r.hoverData.selecting) {
                if (near != null && near._private.selectable) {
                    if (r.hoverData.dragging) ;
                    else if (cy.selectionType() === 'additive' || multSelKeyDown) {
                        if (near.selected()) near.unselect([
                            'tapunselect'
                        ]);
                        else near.select([
                            'tapselect'
                        ]);
                    } else if (!multSelKeyDown) {
                        cy.$(isSelected).unmerge(near).unselect([
                            'tapunselect'
                        ]);
                        near.select([
                            'tapselect'
                        ]);
                    }
                    r.redrawHint('eles', true);
                }
            }
            if (r.hoverData.selecting) {
                var box = cy.collection(r.getAllInBox(select[0], select[1], select[2], select[3]));
                r.redrawHint('select', true);
                if (box.length > 0) r.redrawHint('eles', true);
                cy.emit({
                    type: 'boxend',
                    originalEvent: e,
                    position: {
                        x: pos[0],
                        y: pos[1]
                    }
                });
                var eleWouldBeSelected = function eleWouldBeSelected(ele) {
                    return ele.selectable() && !ele.selected();
                };
                if (cy.selectionType() === 'additive') box.emit('box').stdFilter(eleWouldBeSelected).select().emit('boxselect');
                else {
                    if (!multSelKeyDown) cy.$(isSelected).unmerge(box).unselect();
                    box.emit('box').stdFilter(eleWouldBeSelected).select().emit('boxselect');
                }
                // always need redraw in case eles unselectable
                r.redraw();
            }
            // Cancel drag pan
            if (r.hoverData.dragging) {
                r.hoverData.dragging = false;
                r.redrawHint('select', true);
                r.redrawHint('eles', true);
                r.redraw();
            }
            if (!select[4]) {
                r.redrawHint('drag', true);
                r.redrawHint('eles', true);
                var downWasGrabbed = down && down.grabbed();
                freeDraggedElements(draggedElements);
                if (downWasGrabbed) {
                    down.emit('freeon');
                    draggedElements.emit('free');
                    if (r.dragData.didDrag) {
                        down.emit('dragfreeon');
                        draggedElements.emit('dragfree');
                    }
                }
            }
        } // else not right mouse
        select[4] = 0;
        r.hoverData.down = null;
        r.hoverData.cxtStarted = false;
        r.hoverData.draggingEles = false;
        r.hoverData.selecting = false;
        r.hoverData.isOverThresholdDrag = false;
        r.dragData.didDrag = false;
        r.hoverData.dragged = false;
        r.hoverData.dragDelta = [];
        r.hoverData.mdownPos = null;
        r.hoverData.mdownGPos = null;
        r.hoverData.which = null;
    }, false);
    var wheelHandler = function wheelHandler(e) {
        if (r.scrollingPage) return;
         // while scrolling, ignore wheel-to-zoom
        var cy = r.cy;
        var zoom = cy.zoom();
        var pan = cy.pan();
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        var rpos = [
            pos[0] * zoom + pan.x,
            pos[1] * zoom + pan.y
        ];
        if (r.hoverData.draggingEles || r.hoverData.dragging || r.hoverData.cxtStarted || inBoxSelection()) {
            // if pan dragging or cxt dragging, wheel movements make no zoom
            e.preventDefault();
            return;
        }
        if (cy.panningEnabled() && cy.userPanningEnabled() && cy.zoomingEnabled() && cy.userZoomingEnabled()) {
            e.preventDefault();
            r.data.wheelZooming = true;
            clearTimeout(r.data.wheelTimeout);
            r.data.wheelTimeout = setTimeout(function() {
                r.data.wheelZooming = false;
                r.redrawHint('eles', true);
                r.redraw();
            }, 150);
            var diff;
            if (e.deltaY != null) diff = e.deltaY / -250;
            else if (e.wheelDeltaY != null) diff = e.wheelDeltaY / 1000;
            else diff = e.wheelDelta / 1000;
            diff = diff * r.wheelSensitivity;
            var needsWheelFix = e.deltaMode === 1;
            if (needsWheelFix) // fixes slow wheel events on ff/linux and ff/windows
            diff *= 33;
            var newZoom = cy.zoom() * Math.pow(10, diff);
            if (e.type === 'gesturechange') newZoom = r.gestureStartZoom * e.scale;
            cy.zoom({
                level: newZoom,
                renderedPosition: {
                    x: rpos[0],
                    y: rpos[1]
                }
            });
            cy.emit(e.type === 'gesturechange' ? 'pinchzoom' : 'scrollzoom');
        }
    };
    // Functions to help with whether mouse wheel should trigger zooming
    // --
    r.registerBinding(r.container, 'wheel', wheelHandler, true);
    // disable nonstandard wheel events
    // r.registerBinding(r.container, 'mousewheel', wheelHandler, true);
    // r.registerBinding(r.container, 'DOMMouseScroll', wheelHandler, true);
    // r.registerBinding(r.container, 'MozMousePixelScroll', wheelHandler, true); // older firefox
    r.registerBinding(containerWindow, 'scroll', function scrollHandler(e) {
        // eslint-disable-line no-unused-vars
        r.scrollingPage = true;
        clearTimeout(r.scrollingPageTimeout);
        r.scrollingPageTimeout = setTimeout(function() {
            r.scrollingPage = false;
        }, 250);
    }, true);
    // desktop safari pinch to zoom start
    r.registerBinding(r.container, 'gesturestart', function gestureStartHandler(e) {
        r.gestureStartZoom = r.cy.zoom();
        if (!r.hasTouchStarted) // don't affect touch devices like iphone
        e.preventDefault();
    }, true);
    r.registerBinding(r.container, 'gesturechange', function(e) {
        if (!r.hasTouchStarted) // don't affect touch devices like iphone
        wheelHandler(e);
    }, true);
    // Functions to help with handling mouseout/mouseover on the Cytoscape container
    // Handle mouseout on Cytoscape container
    r.registerBinding(r.container, 'mouseout', function mouseOutHandler(e) {
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        r.cy.emit({
            originalEvent: e,
            type: 'mouseout',
            position: {
                x: pos[0],
                y: pos[1]
            }
        });
    }, false);
    r.registerBinding(r.container, 'mouseover', function mouseOverHandler(e) {
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        r.cy.emit({
            originalEvent: e,
            type: 'mouseover',
            position: {
                x: pos[0],
                y: pos[1]
            }
        });
    }, false);
    var f1x1, f1y1, f2x1, f2y1; // starting points for pinch-to-zoom
    var distance1, distance1Sq; // initial distance between finger 1 and finger 2 for pinch-to-zoom
    var center1, modelCenter1; // center point on start pinch to zoom
    var offsetLeft, offsetTop;
    var containerWidth, containerHeight;
    var twoFingersStartInside;
    var distance = function distance(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    };
    var distanceSq = function distanceSq(x1, y1, x2, y2) {
        return (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
    };
    var touchstartHandler;
    r.registerBinding(r.container, 'touchstart', touchstartHandler = function touchstartHandler(e) {
        r.hasTouchStarted = true;
        if (!eventInContainer(e)) return;
        blurActiveDomElement();
        r.touchData.capture = true;
        r.data.bgActivePosistion = undefined;
        var cy = r.cy;
        var now = r.touchData.now;
        var earlier = r.touchData.earlier;
        if (e.touches[0]) {
            var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
            now[0] = pos[0];
            now[1] = pos[1];
        }
        if (e.touches[1]) {
            var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
            now[2] = pos[0];
            now[3] = pos[1];
        }
        if (e.touches[2]) {
            var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
            now[4] = pos[0];
            now[5] = pos[1];
        }
        // record starting points for pinch-to-zoom
        if (e.touches[1]) {
            r.touchData.singleTouchMoved = true;
            freeDraggedElements(r.dragData.touchDragEles);
            var offsets = r.findContainerClientCoords();
            offsetLeft = offsets[0];
            offsetTop = offsets[1];
            containerWidth = offsets[2];
            containerHeight = offsets[3];
            f1x1 = e.touches[0].clientX - offsetLeft;
            f1y1 = e.touches[0].clientY - offsetTop;
            f2x1 = e.touches[1].clientX - offsetLeft;
            f2y1 = e.touches[1].clientY - offsetTop;
            twoFingersStartInside = 0 <= f1x1 && f1x1 <= containerWidth && 0 <= f2x1 && f2x1 <= containerWidth && 0 <= f1y1 && f1y1 <= containerHeight && 0 <= f2y1 && f2y1 <= containerHeight;
            var pan = cy.pan();
            var zoom = cy.zoom();
            distance1 = distance(f1x1, f1y1, f2x1, f2y1);
            distance1Sq = distanceSq(f1x1, f1y1, f2x1, f2y1);
            center1 = [
                (f1x1 + f2x1) / 2,
                (f1y1 + f2y1) / 2
            ];
            modelCenter1 = [
                (center1[0] - pan.x) / zoom,
                (center1[1] - pan.y) / zoom
            ];
            // consider context tap
            var cxtDistThreshold = 200;
            var cxtDistThresholdSq = cxtDistThreshold * cxtDistThreshold;
            if (distance1Sq < cxtDistThresholdSq && !e.touches[2]) {
                var near1 = r.findNearestElement(now[0], now[1], true, true);
                var near2 = r.findNearestElement(now[2], now[3], true, true);
                if (near1 && near1.isNode()) {
                    near1.activate().emit({
                        originalEvent: e,
                        type: 'cxttapstart',
                        position: {
                            x: now[0],
                            y: now[1]
                        }
                    });
                    r.touchData.start = near1;
                } else if (near2 && near2.isNode()) {
                    near2.activate().emit({
                        originalEvent: e,
                        type: 'cxttapstart',
                        position: {
                            x: now[0],
                            y: now[1]
                        }
                    });
                    r.touchData.start = near2;
                } else cy.emit({
                    originalEvent: e,
                    type: 'cxttapstart',
                    position: {
                        x: now[0],
                        y: now[1]
                    }
                });
                if (r.touchData.start) r.touchData.start._private.grabbed = false;
                r.touchData.cxt = true;
                r.touchData.cxtDragged = false;
                r.data.bgActivePosistion = undefined;
                r.redraw();
                return;
            }
        }
        if (e.touches[2]) // ignore
        // safari on ios pans the page otherwise (normally you should be able to preventdefault on touchmove...)
        {
            if (cy.boxSelectionEnabled()) e.preventDefault();
        } else if (e.touches[1]) ;
        else if (e.touches[0]) {
            var nears = r.findNearestElements(now[0], now[1], true, true);
            var near = nears[0];
            if (near != null) {
                near.activate();
                r.touchData.start = near;
                r.touchData.starts = nears;
                if (r.nodeIsGrabbable(near)) {
                    var draggedEles = r.dragData.touchDragEles = cy.collection();
                    var selectedNodes = null;
                    r.redrawHint('eles', true);
                    r.redrawHint('drag', true);
                    if (near.selected()) {
                        // reset drag elements, since near will be added again
                        selectedNodes = cy.$(function(ele) {
                            return ele.selected() && r.nodeIsGrabbable(ele);
                        });
                        addNodesToDrag(selectedNodes, {
                            addToList: draggedEles
                        });
                    } else addNodeToDrag(near, {
                        addToList: draggedEles
                    });
                    setGrabTarget(near);
                    var makeEvent = function makeEvent(type) {
                        return {
                            originalEvent: e,
                            type: type,
                            position: {
                                x: now[0],
                                y: now[1]
                            }
                        };
                    };
                    near.emit(makeEvent('grabon'));
                    if (selectedNodes) selectedNodes.forEach(function(n) {
                        n.emit(makeEvent('grab'));
                    });
                    else near.emit(makeEvent('grab'));
                }
            }
            triggerEvents(near, [
                'touchstart',
                'tapstart',
                'vmousedown'
            ], e, {
                x: now[0],
                y: now[1]
            });
            if (near == null) {
                r.data.bgActivePosistion = {
                    x: pos[0],
                    y: pos[1]
                };
                r.redrawHint('select', true);
                r.redraw();
            }
            // Tap, taphold
            // -----
            r.touchData.singleTouchMoved = false;
            r.touchData.singleTouchStartTime = +new Date();
            clearTimeout(r.touchData.tapholdTimeout);
            r.touchData.tapholdTimeout = setTimeout(function() {
                if (r.touchData.singleTouchMoved === false && !r.pinching // if pinching, then taphold unselect shouldn't take effect
                 && !r.touchData.selecting // box selection shouldn't allow taphold through
                ) triggerEvents(r.touchData.start, [
                    'taphold'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
            }, r.tapholdDuration);
        }
        if (e.touches.length >= 1) {
            var sPos = r.touchData.startPosition = [
                null,
                null,
                null,
                null,
                null,
                null
            ];
            for(var i = 0; i < now.length; i++)sPos[i] = earlier[i] = now[i];
            var touch0 = e.touches[0];
            r.touchData.startGPosition = [
                touch0.clientX,
                touch0.clientY
            ];
        }
    }, false);
    var touchmoveHandler;
    r.registerBinding(containerWindow, 'touchmove', touchmoveHandler = function touchmoveHandler(e) {
        // eslint-disable-line no-undef
        var capture = r.touchData.capture;
        if (!capture && !eventInContainer(e)) return;
        var select = r.selection;
        var cy = r.cy;
        var now = r.touchData.now;
        var earlier = r.touchData.earlier;
        var zoom = cy.zoom();
        if (e.touches[0]) {
            var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
            now[0] = pos[0];
            now[1] = pos[1];
        }
        if (e.touches[1]) {
            var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
            now[2] = pos[0];
            now[3] = pos[1];
        }
        if (e.touches[2]) {
            var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
            now[4] = pos[0];
            now[5] = pos[1];
        }
        var startGPos = r.touchData.startGPosition;
        var isOverThresholdDrag;
        if (capture && e.touches[0] && startGPos) {
            var disp = [];
            for(var j = 0; j < now.length; j++)disp[j] = now[j] - earlier[j];
            var dx = e.touches[0].clientX - startGPos[0];
            var dx2 = dx * dx;
            var dy = e.touches[0].clientY - startGPos[1];
            var dy2 = dy * dy;
            var dist2 = dx2 + dy2;
            isOverThresholdDrag = dist2 >= r.touchTapThreshold2;
        }
        // context swipe cancelling
        if (capture && r.touchData.cxt) {
            e.preventDefault();
            var f1x2 = e.touches[0].clientX - offsetLeft, f1y2 = e.touches[0].clientY - offsetTop;
            var f2x2 = e.touches[1].clientX - offsetLeft, f2y2 = e.touches[1].clientY - offsetTop;
            // var distance2 = distance( f1x2, f1y2, f2x2, f2y2 );
            var distance2Sq = distanceSq(f1x2, f1y2, f2x2, f2y2);
            var factorSq = distance2Sq / distance1Sq;
            var distThreshold = 150;
            var distThresholdSq = distThreshold * distThreshold;
            var factorThreshold = 1.5;
            var factorThresholdSq = factorThreshold * factorThreshold;
            // cancel ctx gestures if the distance b/t the fingers increases
            if (factorSq >= factorThresholdSq || distance2Sq >= distThresholdSq) {
                r.touchData.cxt = false;
                r.data.bgActivePosistion = undefined;
                r.redrawHint('select', true);
                var cxtEvt = {
                    originalEvent: e,
                    type: 'cxttapend',
                    position: {
                        x: now[0],
                        y: now[1]
                    }
                };
                if (r.touchData.start) {
                    r.touchData.start.unactivate().emit(cxtEvt);
                    r.touchData.start = null;
                } else cy.emit(cxtEvt);
            }
        }
        // context swipe
        if (capture && r.touchData.cxt) {
            var cxtEvt = {
                originalEvent: e,
                type: 'cxtdrag',
                position: {
                    x: now[0],
                    y: now[1]
                }
            };
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            if (r.touchData.start) r.touchData.start.emit(cxtEvt);
            else cy.emit(cxtEvt);
            if (r.touchData.start) r.touchData.start._private.grabbed = false;
            r.touchData.cxtDragged = true;
            var near = r.findNearestElement(now[0], now[1], true, true);
            if (!r.touchData.cxtOver || near !== r.touchData.cxtOver) {
                if (r.touchData.cxtOver) r.touchData.cxtOver.emit({
                    originalEvent: e,
                    type: 'cxtdragout',
                    position: {
                        x: now[0],
                        y: now[1]
                    }
                });
                r.touchData.cxtOver = near;
                if (near) near.emit({
                    originalEvent: e,
                    type: 'cxtdragover',
                    position: {
                        x: now[0],
                        y: now[1]
                    }
                });
            }
        // box selection
        } else if (capture && e.touches[2] && cy.boxSelectionEnabled()) {
            e.preventDefault();
            r.data.bgActivePosistion = undefined;
            this.lastThreeTouch = +new Date();
            if (!r.touchData.selecting) cy.emit({
                originalEvent: e,
                type: 'boxstart',
                position: {
                    x: now[0],
                    y: now[1]
                }
            });
            r.touchData.selecting = true;
            r.touchData.didSelect = true;
            select[4] = 1;
            if (!select || select.length === 0 || select[0] === undefined) {
                select[0] = (now[0] + now[2] + now[4]) / 3;
                select[1] = (now[1] + now[3] + now[5]) / 3;
                select[2] = (now[0] + now[2] + now[4]) / 3 + 1;
                select[3] = (now[1] + now[3] + now[5]) / 3 + 1;
            } else {
                select[2] = (now[0] + now[2] + now[4]) / 3;
                select[3] = (now[1] + now[3] + now[5]) / 3;
            }
            r.redrawHint('select', true);
            r.redraw();
        // pinch to zoom
        } else if (capture && e.touches[1] && !r.touchData.didSelect // don't allow box selection to degrade to pinch-to-zoom
         && cy.zoomingEnabled() && cy.panningEnabled() && cy.userZoomingEnabled() && cy.userPanningEnabled()) {
            // two fingers => pinch to zoom
            e.preventDefault();
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            var draggedEles = r.dragData.touchDragEles;
            if (draggedEles) {
                r.redrawHint('drag', true);
                for(var i = 0; i < draggedEles.length; i++){
                    var de_p = draggedEles[i]._private;
                    de_p.grabbed = false;
                    de_p.rscratch.inDragLayer = false;
                }
            }
            var _start = r.touchData.start;
            // (x2, y2) for fingers 1 and 2
            var f1x2 = e.touches[0].clientX - offsetLeft, f1y2 = e.touches[0].clientY - offsetTop;
            var f2x2 = e.touches[1].clientX - offsetLeft, f2y2 = e.touches[1].clientY - offsetTop;
            var distance2 = distance(f1x2, f1y2, f2x2, f2y2);
            // var distance2Sq = distanceSq( f1x2, f1y2, f2x2, f2y2 );
            // var factor = Math.sqrt( distance2Sq ) / Math.sqrt( distance1Sq );
            var factor = distance2 / distance1;
            if (twoFingersStartInside) {
                // delta finger1
                var df1x = f1x2 - f1x1;
                var df1y = f1y2 - f1y1;
                // delta finger 2
                var df2x = f2x2 - f2x1;
                var df2y = f2y2 - f2y1;
                // translation is the normalised vector of the two fingers movement
                // i.e. so pinching cancels out and moving together pans
                var tx = (df1x + df2x) / 2;
                var ty = (df1y + df2y) / 2;
                // now calculate the zoom
                var zoom1 = cy.zoom();
                var zoom2 = zoom1 * factor;
                var pan1 = cy.pan();
                // the model center point converted to the current rendered pos
                var ctrx = modelCenter1[0] * zoom1 + pan1.x;
                var ctry = modelCenter1[1] * zoom1 + pan1.y;
                var pan2 = {
                    x: -zoom2 / zoom1 * (ctrx - pan1.x - tx) + ctrx,
                    y: -zoom2 / zoom1 * (ctry - pan1.y - ty) + ctry
                };
                // remove dragged eles
                if (_start && _start.active()) {
                    var draggedEles = r.dragData.touchDragEles;
                    freeDraggedElements(draggedEles);
                    r.redrawHint('drag', true);
                    r.redrawHint('eles', true);
                    _start.unactivate().emit('freeon');
                    draggedEles.emit('free');
                    if (r.dragData.didDrag) {
                        _start.emit('dragfreeon');
                        draggedEles.emit('dragfree');
                    }
                }
                cy.viewport({
                    zoom: zoom2,
                    pan: pan2,
                    cancelOnFailedZoom: true
                });
                cy.emit('pinchzoom');
                distance1 = distance2;
                f1x1 = f1x2;
                f1y1 = f1y2;
                f2x1 = f2x2;
                f2y1 = f2y2;
                r.pinching = true;
            }
            // Re-project
            if (e.touches[0]) {
                var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
                now[0] = pos[0];
                now[1] = pos[1];
            }
            if (e.touches[1]) {
                var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
                now[2] = pos[0];
                now[3] = pos[1];
            }
            if (e.touches[2]) {
                var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
                now[4] = pos[0];
                now[5] = pos[1];
            }
        } else if (e.touches[0] && !r.touchData.didSelect // don't allow box selection to degrade to single finger events like panning
        ) {
            var start = r.touchData.start;
            var last = r.touchData.last;
            var near;
            if (!r.hoverData.draggingEles && !r.swipePanning) near = r.findNearestElement(now[0], now[1], true, true);
            if (capture && start != null) e.preventDefault();
            // dragging nodes
            if (capture && start != null && r.nodeIsDraggable(start)) {
                if (isOverThresholdDrag) {
                    // then dragging can happen
                    var draggedEles = r.dragData.touchDragEles;
                    var justStartedDrag = !r.dragData.didDrag;
                    if (justStartedDrag) addNodesToDrag(draggedEles, {
                        inDragLayer: true
                    });
                    r.dragData.didDrag = true;
                    var totalShift = {
                        x: 0,
                        y: 0
                    };
                    if ($e815fda779bc047b$var$number$1(disp[0]) && $e815fda779bc047b$var$number$1(disp[1])) {
                        totalShift.x += disp[0];
                        totalShift.y += disp[1];
                        if (justStartedDrag) {
                            r.redrawHint('eles', true);
                            var dragDelta = r.touchData.dragDelta;
                            if (dragDelta && $e815fda779bc047b$var$number$1(dragDelta[0]) && $e815fda779bc047b$var$number$1(dragDelta[1])) {
                                totalShift.x += dragDelta[0];
                                totalShift.y += dragDelta[1];
                            }
                        }
                    }
                    r.hoverData.draggingEles = true;
                    draggedEles.silentShift(totalShift).emit('position drag');
                    r.redrawHint('drag', true);
                    if (r.touchData.startPosition[0] == earlier[0] && r.touchData.startPosition[1] == earlier[1]) r.redrawHint('eles', true);
                    r.redraw();
                } else {
                    // otherwise keep track of drag delta for later
                    var dragDelta = r.touchData.dragDelta = r.touchData.dragDelta || [];
                    if (dragDelta.length === 0) {
                        dragDelta.push(disp[0]);
                        dragDelta.push(disp[1]);
                    } else {
                        dragDelta[0] += disp[0];
                        dragDelta[1] += disp[1];
                    }
                }
            }
            triggerEvents(start || near, [
                'touchmove',
                'tapdrag',
                'vmousemove'
            ], e, {
                x: now[0],
                y: now[1]
            });
            if ((!start || !start.grabbed()) && near != last) {
                if (last) last.emit({
                    originalEvent: e,
                    type: 'tapdragout',
                    position: {
                        x: now[0],
                        y: now[1]
                    }
                });
                if (near) near.emit({
                    originalEvent: e,
                    type: 'tapdragover',
                    position: {
                        x: now[0],
                        y: now[1]
                    }
                });
            }
            r.touchData.last = near;
            // check to cancel taphold
            if (capture) {
                for(var i = 0; i < now.length; i++)if (now[i] && r.touchData.startPosition[i] && isOverThresholdDrag) r.touchData.singleTouchMoved = true;
            }
            // panning
            if (capture && (start == null || start.pannable()) && cy.panningEnabled() && cy.userPanningEnabled()) {
                var allowPassthrough = allowPanningPassthrough(start, r.touchData.starts);
                if (allowPassthrough) {
                    e.preventDefault();
                    if (!r.data.bgActivePosistion) r.data.bgActivePosistion = $e815fda779bc047b$var$array2point(r.touchData.startPosition);
                    if (r.swipePanning) {
                        cy.panBy({
                            x: disp[0] * zoom,
                            y: disp[1] * zoom
                        });
                        cy.emit('dragpan');
                    } else if (isOverThresholdDrag) {
                        r.swipePanning = true;
                        cy.panBy({
                            x: dx * zoom,
                            y: dy * zoom
                        });
                        cy.emit('dragpan');
                        if (start) {
                            start.unactivate();
                            r.redrawHint('select', true);
                            r.touchData.start = null;
                        }
                    }
                }
                // Re-project
                var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
                now[0] = pos[0];
                now[1] = pos[1];
            }
        }
        for(var j = 0; j < now.length; j++)earlier[j] = now[j];
        // the active bg indicator should be removed when making a swipe that is neither for dragging nodes or panning
        if (capture && e.touches.length > 0 && !r.hoverData.draggingEles && !r.swipePanning && r.data.bgActivePosistion != null) {
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            r.redraw();
        }
    }, false);
    var touchcancelHandler;
    r.registerBinding(containerWindow, 'touchcancel', touchcancelHandler = function touchcancelHandler(e) {
        // eslint-disable-line no-unused-vars
        var start = r.touchData.start;
        r.touchData.capture = false;
        if (start) start.unactivate();
    });
    var touchendHandler, didDoubleTouch, touchTimeout, prevTouchTimeStamp;
    r.registerBinding(containerWindow, 'touchend', touchendHandler = function touchendHandler(e) {
        // eslint-disable-line no-unused-vars
        var start = r.touchData.start;
        var capture = r.touchData.capture;
        if (capture) {
            if (e.touches.length === 0) r.touchData.capture = false;
            e.preventDefault();
        } else return;
        var select = r.selection;
        r.swipePanning = false;
        r.hoverData.draggingEles = false;
        var cy = r.cy;
        var zoom = cy.zoom();
        var now = r.touchData.now;
        var earlier = r.touchData.earlier;
        if (e.touches[0]) {
            var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
            now[0] = pos[0];
            now[1] = pos[1];
        }
        if (e.touches[1]) {
            var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
            now[2] = pos[0];
            now[3] = pos[1];
        }
        if (e.touches[2]) {
            var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
            now[4] = pos[0];
            now[5] = pos[1];
        }
        if (start) start.unactivate();
        var ctxTapend;
        if (r.touchData.cxt) {
            ctxTapend = {
                originalEvent: e,
                type: 'cxttapend',
                position: {
                    x: now[0],
                    y: now[1]
                }
            };
            if (start) start.emit(ctxTapend);
            else cy.emit(ctxTapend);
            if (!r.touchData.cxtDragged) {
                var ctxTap = {
                    originalEvent: e,
                    type: 'cxttap',
                    position: {
                        x: now[0],
                        y: now[1]
                    }
                };
                if (start) start.emit(ctxTap);
                else cy.emit(ctxTap);
            }
            if (r.touchData.start) r.touchData.start._private.grabbed = false;
            r.touchData.cxt = false;
            r.touchData.start = null;
            r.redraw();
            return;
        }
        // no more box selection if we don't have three fingers
        if (!e.touches[2] && cy.boxSelectionEnabled() && r.touchData.selecting) {
            r.touchData.selecting = false;
            var box = cy.collection(r.getAllInBox(select[0], select[1], select[2], select[3]));
            select[0] = undefined;
            select[1] = undefined;
            select[2] = undefined;
            select[3] = undefined;
            select[4] = 0;
            r.redrawHint('select', true);
            cy.emit({
                type: 'boxend',
                originalEvent: e,
                position: {
                    x: now[0],
                    y: now[1]
                }
            });
            var eleWouldBeSelected = function eleWouldBeSelected(ele) {
                return ele.selectable() && !ele.selected();
            };
            box.emit('box').stdFilter(eleWouldBeSelected).select().emit('boxselect');
            if (box.nonempty()) r.redrawHint('eles', true);
            r.redraw();
        }
        if (start != null) start.unactivate();
        if (e.touches[2]) {
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
        } else if (e.touches[1]) ;
        else if (e.touches[0]) ;
        else if (!e.touches[0]) {
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            var draggedEles = r.dragData.touchDragEles;
            if (start != null) {
                var startWasGrabbed = start._private.grabbed;
                freeDraggedElements(draggedEles);
                r.redrawHint('drag', true);
                r.redrawHint('eles', true);
                if (startWasGrabbed) {
                    start.emit('freeon');
                    draggedEles.emit('free');
                    if (r.dragData.didDrag) {
                        start.emit('dragfreeon');
                        draggedEles.emit('dragfree');
                    }
                }
                triggerEvents(start, [
                    'touchend',
                    'tapend',
                    'vmouseup',
                    'tapdragout'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
                start.unactivate();
                r.touchData.start = null;
            } else {
                var near = r.findNearestElement(now[0], now[1], true, true);
                triggerEvents(near, [
                    'touchend',
                    'tapend',
                    'vmouseup',
                    'tapdragout'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
            }
            var dx = r.touchData.startPosition[0] - now[0];
            var dx2 = dx * dx;
            var dy = r.touchData.startPosition[1] - now[1];
            var dy2 = dy * dy;
            var dist2 = dx2 + dy2;
            var rdist2 = dist2 * zoom * zoom;
            // Tap event, roughly same as mouse click event for touch
            if (!r.touchData.singleTouchMoved) {
                if (!start) cy.$(':selected').unselect([
                    'tapunselect'
                ]);
                triggerEvents(start, [
                    'tap',
                    'vclick'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
                didDoubleTouch = false;
                if (e.timeStamp - prevTouchTimeStamp <= cy.multiClickDebounceTime()) {
                    touchTimeout && clearTimeout(touchTimeout);
                    didDoubleTouch = true;
                    prevTouchTimeStamp = null;
                    triggerEvents(start, [
                        'dbltap',
                        'vdblclick'
                    ], e, {
                        x: now[0],
                        y: now[1]
                    });
                } else {
                    touchTimeout = setTimeout(function() {
                        if (didDoubleTouch) return;
                        triggerEvents(start, [
                            'onetap',
                            'voneclick'
                        ], e, {
                            x: now[0],
                            y: now[1]
                        });
                    }, cy.multiClickDebounceTime());
                    prevTouchTimeStamp = e.timeStamp;
                }
            }
            // Prepare to select the currently touched node, only if it hasn't been dragged past a certain distance
            if (start != null && !r.dragData.didDrag // didn't drag nodes around
             && start._private.selectable && rdist2 < r.touchTapThreshold2 && !r.pinching // pinch to zoom should not affect selection
            ) {
                if (cy.selectionType() === 'single') {
                    cy.$(isSelected).unmerge(start).unselect([
                        'tapunselect'
                    ]);
                    start.select([
                        'tapselect'
                    ]);
                } else if (start.selected()) start.unselect([
                    'tapunselect'
                ]);
                else start.select([
                    'tapselect'
                ]);
                r.redrawHint('eles', true);
            }
            r.touchData.singleTouchMoved = true;
        }
        for(var j = 0; j < now.length; j++)earlier[j] = now[j];
        r.dragData.didDrag = false; // reset for next touchstart
        if (e.touches.length === 0) {
            r.touchData.dragDelta = [];
            r.touchData.startPosition = [
                null,
                null,
                null,
                null,
                null,
                null
            ];
            r.touchData.startGPosition = null;
            r.touchData.didSelect = false;
        }
        if (e.touches.length < 2) {
            if (e.touches.length === 1) // the old start global pos'n may not be the same finger that remains
            r.touchData.startGPosition = [
                e.touches[0].clientX,
                e.touches[0].clientY
            ];
            r.pinching = false;
            r.redrawHint('eles', true);
            r.redraw();
        }
    //r.redraw();
    }, false);
    // fallback compatibility layer for ms pointer events
    if (typeof TouchEvent === 'undefined') {
        var pointers = [];
        var makeTouch = function makeTouch(e) {
            return {
                clientX: e.clientX,
                clientY: e.clientY,
                force: 1,
                identifier: e.pointerId,
                pageX: e.pageX,
                pageY: e.pageY,
                radiusX: e.width / 2,
                radiusY: e.height / 2,
                screenX: e.screenX,
                screenY: e.screenY,
                target: e.target
            };
        };
        var makePointer = function makePointer(e) {
            return {
                event: e,
                touch: makeTouch(e)
            };
        };
        var addPointer = function addPointer(e) {
            pointers.push(makePointer(e));
        };
        var removePointer = function removePointer(e) {
            for(var i = 0; i < pointers.length; i++){
                var p = pointers[i];
                if (p.event.pointerId === e.pointerId) {
                    pointers.splice(i, 1);
                    return;
                }
            }
        };
        var updatePointer = function updatePointer(e) {
            var p = pointers.filter(function(p) {
                return p.event.pointerId === e.pointerId;
            })[0];
            p.event = e;
            p.touch = makeTouch(e);
        };
        var addTouchesToEvent = function addTouchesToEvent(e) {
            e.touches = pointers.map(function(p) {
                return p.touch;
            });
        };
        var pointerIsMouse = function pointerIsMouse(e) {
            return e.pointerType === 'mouse' || e.pointerType === 4;
        };
        r.registerBinding(r.container, 'pointerdown', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            e.preventDefault();
            addPointer(e);
            addTouchesToEvent(e);
            touchstartHandler(e);
        });
        r.registerBinding(r.container, 'pointerup', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            removePointer(e);
            addTouchesToEvent(e);
            touchendHandler(e);
        });
        r.registerBinding(r.container, 'pointercancel', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            removePointer(e);
            addTouchesToEvent(e);
            touchcancelHandler(e);
        });
        r.registerBinding(r.container, 'pointermove', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            e.preventDefault();
            updatePointer(e);
            addTouchesToEvent(e);
            touchmoveHandler(e);
        });
    }
};
var $e815fda779bc047b$var$BRp$2 = {};
$e815fda779bc047b$var$BRp$2.generatePolygon = function(name, points) {
    return this.nodeShapes[name] = {
        renderer: this,
        name: name,
        points: points,
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl('polygon', context, centerX, centerY, width, height, this.points);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            return $e815fda779bc047b$var$polygonIntersectLine(x, y, this.points, nodeX, nodeY, width / 2, height / 2, padding);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            return $e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width, height, [
                0,
                -1
            ], padding);
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateEllipse = function() {
    return this.nodeShapes['ellipse'] = {
        renderer: this,
        name: 'ellipse',
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            return $e815fda779bc047b$var$intersectLineEllipse(x, y, nodeX, nodeY, width / 2 + padding, height / 2 + padding);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            return $e815fda779bc047b$var$checkInEllipse(x, y, width, height, centerX, centerY, padding);
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateRoundPolygon = function(name, points) {
    return this.nodeShapes[name] = {
        renderer: this,
        name: name,
        points: points,
        getOrCreateCorners: function getOrCreateCorners(centerX, centerY, width, height, cornerRadius, rs, field) {
            if (rs[field] !== undefined && rs[field + '-cx'] === centerX && rs[field + '-cy'] === centerY) return rs[field];
            rs[field] = new Array(points.length / 2);
            rs[field + '-cx'] = centerX;
            rs[field + '-cy'] = centerY;
            var halfW = width / 2;
            var halfH = height / 2;
            cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundPolygonRadius(width, height) : cornerRadius;
            var p = new Array(points.length / 2);
            for(var _i = 0; _i < points.length / 2; _i++)p[_i] = {
                x: centerX + halfW * points[_i * 2],
                y: centerY + halfH * points[_i * 2 + 1]
            };
            var i, p1, p2, p3, len = p.length;
            p1 = p[len - 1];
            // for each point
            for(i = 0; i < len; i++){
                p2 = p[i % len];
                p3 = p[(i + 1) % len];
                rs[field][i] = $e815fda779bc047b$var$getRoundCorner(p1, p2, p3, cornerRadius);
                p1 = p2;
                p2 = p3;
            }
            return rs[field];
        },
        draw: function draw(context, centerX, centerY, width, height, cornerRadius, rs) {
            this.renderer.nodeShapeImpl('round-polygon', context, centerX, centerY, width, height, this.points, this.getOrCreateCorners(centerX, centerY, width, height, cornerRadius, rs, 'drawCorners'));
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius, rs) {
            return $e815fda779bc047b$var$roundPolygonIntersectLine(x, y, this.points, nodeX, nodeY, width, height, padding, this.getOrCreateCorners(nodeX, nodeY, width, height, cornerRadius, rs, 'corners'));
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius, rs) {
            return $e815fda779bc047b$var$pointInsideRoundPolygon(x, y, this.points, centerX, centerY, width, height, this.getOrCreateCorners(centerX, centerY, width, height, cornerRadius, rs, 'corners'));
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateRoundRectangle = function() {
    return this.nodeShapes['round-rectangle'] = this.nodeShapes['roundrectangle'] = {
        renderer: this,
        name: 'round-rectangle',
        points: $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height, this.points, cornerRadius);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            return $e815fda779bc047b$var$roundRectangleIntersectLine(x, y, nodeX, nodeY, width, height, padding, cornerRadius);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            var halfWidth = width / 2;
            var halfHeight = height / 2;
            cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(width, height) : cornerRadius;
            cornerRadius = Math.min(halfWidth, halfHeight, cornerRadius);
            var diam = cornerRadius * 2;
            // Check hBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - diam, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width - diam, height, [
                0,
                -1
            ], padding)) return true;
            // Check top left quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX - halfWidth + cornerRadius, centerY - halfHeight + cornerRadius, padding)) return true;
            // Check top right quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX + halfWidth - cornerRadius, centerY - halfHeight + cornerRadius, padding)) return true;
            // Check bottom right quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX + halfWidth - cornerRadius, centerY + halfHeight - cornerRadius, padding)) return true;
            // Check bottom left quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX - halfWidth + cornerRadius, centerY + halfHeight - cornerRadius, padding)) return true;
            return false;
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateCutRectangle = function() {
    return this.nodeShapes['cut-rectangle'] = this.nodeShapes['cutrectangle'] = {
        renderer: this,
        name: 'cut-rectangle',
        cornerLength: $e815fda779bc047b$var$getCutRectangleCornerLength(),
        points: $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height, null, cornerRadius);
        },
        generateCutTrianglePts: function generateCutTrianglePts(width, height, centerX, centerY, cornerRadius) {
            var cl = cornerRadius === 'auto' ? this.cornerLength : cornerRadius;
            var hh = height / 2;
            var hw = width / 2;
            var xBegin = centerX - hw;
            var xEnd = centerX + hw;
            var yBegin = centerY - hh;
            var yEnd = centerY + hh;
            // points are in clockwise order, inner (imaginary) triangle pt on [4, 5]
            return {
                topLeft: [
                    xBegin,
                    yBegin + cl,
                    xBegin + cl,
                    yBegin,
                    xBegin + cl,
                    yBegin + cl
                ],
                topRight: [
                    xEnd - cl,
                    yBegin,
                    xEnd,
                    yBegin + cl,
                    xEnd - cl,
                    yBegin + cl
                ],
                bottomRight: [
                    xEnd,
                    yEnd - cl,
                    xEnd - cl,
                    yEnd,
                    xEnd - cl,
                    yEnd - cl
                ],
                bottomLeft: [
                    xBegin + cl,
                    yEnd,
                    xBegin,
                    yEnd - cl,
                    xBegin + cl,
                    yEnd - cl
                ]
            };
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            var cPts = this.generateCutTrianglePts(width + 2 * padding, height + 2 * padding, nodeX, nodeY, cornerRadius);
            var pts = [].concat.apply([], [
                cPts.topLeft.splice(0, 4),
                cPts.topRight.splice(0, 4),
                cPts.bottomRight.splice(0, 4),
                cPts.bottomLeft.splice(0, 4)
            ]);
            return $e815fda779bc047b$var$polygonIntersectLine(x, y, pts, nodeX, nodeY);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            var cl = cornerRadius === 'auto' ? this.cornerLength : cornerRadius;
            // Check hBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - 2 * cl, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width - 2 * cl, height, [
                0,
                -1
            ], padding)) return true;
            var cutTrianglePts = this.generateCutTrianglePts(width, height, centerX, centerY);
            return $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, cutTrianglePts.topLeft) || $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, cutTrianglePts.topRight) || $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, cutTrianglePts.bottomRight) || $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, cutTrianglePts.bottomLeft);
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateBarrel = function() {
    return this.nodeShapes['barrel'] = {
        renderer: this,
        name: 'barrel',
        points: $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            // use two fixed t values for the bezier curve approximation
            var t0 = 0.15;
            var t1 = 0.5;
            var t2 = 0.85;
            var bPts = this.generateBarrelBezierPts(width + 2 * padding, height + 2 * padding, nodeX, nodeY);
            var approximateBarrelCurvePts = function approximateBarrelCurvePts(pts) {
                // approximate curve pts based on the two t values
                var m0 = $e815fda779bc047b$var$qbezierPtAt({
                    x: pts[0],
                    y: pts[1]
                }, {
                    x: pts[2],
                    y: pts[3]
                }, {
                    x: pts[4],
                    y: pts[5]
                }, t0);
                var m1 = $e815fda779bc047b$var$qbezierPtAt({
                    x: pts[0],
                    y: pts[1]
                }, {
                    x: pts[2],
                    y: pts[3]
                }, {
                    x: pts[4],
                    y: pts[5]
                }, t1);
                var m2 = $e815fda779bc047b$var$qbezierPtAt({
                    x: pts[0],
                    y: pts[1]
                }, {
                    x: pts[2],
                    y: pts[3]
                }, {
                    x: pts[4],
                    y: pts[5]
                }, t2);
                return [
                    pts[0],
                    pts[1],
                    m0.x,
                    m0.y,
                    m1.x,
                    m1.y,
                    m2.x,
                    m2.y,
                    pts[4],
                    pts[5]
                ];
            };
            var pts = [].concat(approximateBarrelCurvePts(bPts.topLeft), approximateBarrelCurvePts(bPts.topRight), approximateBarrelCurvePts(bPts.bottomRight), approximateBarrelCurvePts(bPts.bottomLeft));
            return $e815fda779bc047b$var$polygonIntersectLine(x, y, pts, nodeX, nodeY);
        },
        generateBarrelBezierPts: function generateBarrelBezierPts(width, height, centerX, centerY) {
            var hh = height / 2;
            var hw = width / 2;
            var xBegin = centerX - hw;
            var xEnd = centerX + hw;
            var yBegin = centerY - hh;
            var yEnd = centerY + hh;
            var curveConstants = $e815fda779bc047b$var$getBarrelCurveConstants(width, height);
            var hOffset = curveConstants.heightOffset;
            var wOffset = curveConstants.widthOffset;
            var ctrlPtXOffset = curveConstants.ctrlPtOffsetPct * width;
            // points are in clockwise order, inner (imaginary) control pt on [4, 5]
            var pts = {
                topLeft: [
                    xBegin,
                    yBegin + hOffset,
                    xBegin + ctrlPtXOffset,
                    yBegin,
                    xBegin + wOffset,
                    yBegin
                ],
                topRight: [
                    xEnd - wOffset,
                    yBegin,
                    xEnd - ctrlPtXOffset,
                    yBegin,
                    xEnd,
                    yBegin + hOffset
                ],
                bottomRight: [
                    xEnd,
                    yEnd - hOffset,
                    xEnd - ctrlPtXOffset,
                    yEnd,
                    xEnd - wOffset,
                    yEnd
                ],
                bottomLeft: [
                    xBegin + wOffset,
                    yEnd,
                    xBegin + ctrlPtXOffset,
                    yEnd,
                    xBegin,
                    yEnd - hOffset
                ]
            };
            pts.topLeft.isTop = true;
            pts.topRight.isTop = true;
            pts.bottomLeft.isBottom = true;
            pts.bottomRight.isBottom = true;
            return pts;
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            var curveConstants = $e815fda779bc047b$var$getBarrelCurveConstants(width, height);
            var hOffset = curveConstants.heightOffset;
            var wOffset = curveConstants.widthOffset;
            // Check hBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - 2 * hOffset, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width - 2 * wOffset, height, [
                0,
                -1
            ], padding)) return true;
            var barrelCurvePts = this.generateBarrelBezierPts(width, height, centerX, centerY);
            var getCurveT = function getCurveT(x, y, curvePts) {
                var x0 = curvePts[4];
                var x1 = curvePts[2];
                var x2 = curvePts[0];
                var y0 = curvePts[5];
                // var y1 = curvePts[ 3 ];
                var y2 = curvePts[1];
                var xMin = Math.min(x0, x2);
                var xMax = Math.max(x0, x2);
                var yMin = Math.min(y0, y2);
                var yMax = Math.max(y0, y2);
                if (xMin <= x && x <= xMax && yMin <= y && y <= yMax) {
                    var coeff = $e815fda779bc047b$var$bezierPtsToQuadCoeff(x0, x1, x2);
                    var roots = $e815fda779bc047b$var$solveQuadratic(coeff[0], coeff[1], coeff[2], x);
                    var validRoots = roots.filter(function(r) {
                        return 0 <= r && r <= 1;
                    });
                    if (validRoots.length > 0) return validRoots[0];
                }
                return null;
            };
            var curveRegions = Object.keys(barrelCurvePts);
            for(var i = 0; i < curveRegions.length; i++){
                var corner = curveRegions[i];
                var cornerPts = barrelCurvePts[corner];
                var t = getCurveT(x, y, cornerPts);
                if (t == null) continue;
                var y0 = cornerPts[5];
                var y1 = cornerPts[3];
                var y2 = cornerPts[1];
                var bezY = $e815fda779bc047b$var$qbezierAt(y0, y1, y2, t);
                if (cornerPts.isTop && bezY <= y) return true;
                if (cornerPts.isBottom && y <= bezY) return true;
            }
            return false;
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateBottomRoundrectangle = function() {
    return this.nodeShapes['bottom-round-rectangle'] = this.nodeShapes['bottomroundrectangle'] = {
        renderer: this,
        name: 'bottom-round-rectangle',
        points: $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height, this.points, cornerRadius);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            var topStartX = nodeX - (width / 2 + padding);
            var topStartY = nodeY - (height / 2 + padding);
            var topEndY = topStartY;
            var topEndX = nodeX + (width / 2 + padding);
            var topIntersections = $e815fda779bc047b$var$finiteLinesIntersect(x, y, nodeX, nodeY, topStartX, topStartY, topEndX, topEndY, false);
            if (topIntersections.length > 0) return topIntersections;
            return $e815fda779bc047b$var$roundRectangleIntersectLine(x, y, nodeX, nodeY, width, height, padding, cornerRadius);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(width, height) : cornerRadius;
            var diam = 2 * cornerRadius;
            // Check hBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - diam, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width - diam, height, [
                0,
                -1
            ], padding)) return true;
            // check non-rounded top side
            var outerWidth = width / 2 + 2 * padding;
            var outerHeight = height / 2 + 2 * padding;
            var points = [
                centerX - outerWidth,
                centerY - outerHeight,
                centerX - outerWidth,
                centerY,
                centerX + outerWidth,
                centerY,
                centerX + outerWidth,
                centerY - outerHeight
            ];
            if ($e815fda779bc047b$var$pointInsidePolygonPoints(x, y, points)) return true;
            // Check bottom right quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX + width / 2 - cornerRadius, centerY + height / 2 - cornerRadius, padding)) return true;
            // Check bottom left quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX - width / 2 + cornerRadius, centerY + height / 2 - cornerRadius, padding)) return true;
            return false;
        }
    };
};
$e815fda779bc047b$var$BRp$2.registerNodeShapes = function() {
    var nodeShapes = this.nodeShapes = {};
    var renderer = this;
    this.generateEllipse();
    this.generatePolygon('triangle', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(3, 0));
    this.generateRoundPolygon('round-triangle', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(3, 0));
    this.generatePolygon('rectangle', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(4, 0));
    nodeShapes['square'] = nodeShapes['rectangle'];
    this.generateRoundRectangle();
    this.generateCutRectangle();
    this.generateBarrel();
    this.generateBottomRoundrectangle();
    var diamondPoints = [
        0,
        1,
        1,
        0,
        0,
        -1,
        -1,
        0
    ];
    this.generatePolygon('diamond', diamondPoints);
    this.generateRoundPolygon('round-diamond', diamondPoints);
    this.generatePolygon('pentagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(5, 0));
    this.generateRoundPolygon('round-pentagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(5, 0));
    this.generatePolygon('hexagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(6, 0));
    this.generateRoundPolygon('round-hexagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(6, 0));
    this.generatePolygon('heptagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(7, 0));
    this.generateRoundPolygon('round-heptagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(7, 0));
    this.generatePolygon('octagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(8, 0));
    this.generateRoundPolygon('round-octagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(8, 0));
    var star5Points = new Array(20);
    var outerPoints = $e815fda779bc047b$var$generateUnitNgonPoints(5, 0);
    var innerPoints = $e815fda779bc047b$var$generateUnitNgonPoints(5, Math.PI / 5);
    // Outer radius is 1; inner radius of star is smaller
    var innerRadius = 0.5 * (3 - Math.sqrt(5));
    innerRadius *= 1.57;
    for(var i = 0; i < innerPoints.length / 2; i++){
        innerPoints[i * 2] *= innerRadius;
        innerPoints[i * 2 + 1] *= innerRadius;
    }
    for(var i = 0; i < 5; i++){
        star5Points[i * 4] = outerPoints[i * 2];
        star5Points[i * 4 + 1] = outerPoints[i * 2 + 1];
        star5Points[i * 4 + 2] = innerPoints[i * 2];
        star5Points[i * 4 + 3] = innerPoints[i * 2 + 1];
    }
    star5Points = $e815fda779bc047b$var$fitPolygonToSquare(star5Points);
    this.generatePolygon('star', star5Points);
    this.generatePolygon('vee', [
        -1,
        -1,
        0,
        -0.333,
        1,
        -1,
        0,
        1
    ]);
    this.generatePolygon('rhomboid', [
        -1,
        -1,
        0.333,
        -1,
        1,
        1,
        -0.333,
        1
    ]);
    this.generatePolygon('right-rhomboid', [
        -0.333,
        -1,
        1,
        -1,
        0.333,
        1,
        -1,
        1
    ]);
    this.nodeShapes['concavehexagon'] = this.generatePolygon('concave-hexagon', [
        -1,
        -0.95,
        -0.75,
        0,
        -1,
        0.95,
        1,
        0.95,
        0.75,
        0,
        1,
        -0.95
    ]);
    var tagPoints = [
        -1,
        -1,
        0.25,
        -1,
        1,
        0,
        0.25,
        1,
        -1,
        1
    ];
    this.generatePolygon('tag', tagPoints);
    this.generateRoundPolygon('round-tag', tagPoints);
    nodeShapes.makePolygon = function(points) {
        // use caching on user-specified polygons so they are as fast as native shapes
        var key = points.join('$');
        var name = 'polygon-' + key;
        var shape;
        if (shape = this[name]) // got cached shape
        return shape;
        // create and cache new shape
        return renderer.generatePolygon(name, points);
    };
};
var $e815fda779bc047b$var$BRp$1 = {};
$e815fda779bc047b$var$BRp$1.timeToRender = function() {
    return this.redrawTotalTime / this.redrawCount;
};
$e815fda779bc047b$var$BRp$1.redraw = function(options) {
    options = options || $e815fda779bc047b$var$staticEmptyObject();
    var r = this;
    if (r.averageRedrawTime === undefined) r.averageRedrawTime = 0;
    if (r.lastRedrawTime === undefined) r.lastRedrawTime = 0;
    if (r.lastDrawTime === undefined) r.lastDrawTime = 0;
    r.requestedFrame = true;
    r.renderOptions = options;
};
$e815fda779bc047b$var$BRp$1.beforeRender = function(fn, priority) {
    // the renderer can't add tick callbacks when destroyed
    if (this.destroyed) return;
    if (priority == null) $e815fda779bc047b$var$error('Priority is not optional for beforeRender');
    var cbs = this.beforeRenderCallbacks;
    cbs.push({
        fn: fn,
        priority: priority
    });
    // higher priority callbacks executed first
    cbs.sort(function(a, b) {
        return b.priority - a.priority;
    });
};
var $e815fda779bc047b$var$beforeRenderCallbacks = function beforeRenderCallbacks(r, willDraw, startTime) {
    var cbs = r.beforeRenderCallbacks;
    for(var i = 0; i < cbs.length; i++)cbs[i].fn(willDraw, startTime);
};
$e815fda779bc047b$var$BRp$1.startRenderLoop = function() {
    var r = this;
    var cy = r.cy;
    if (r.renderLoopStarted) return;
    else r.renderLoopStarted = true;
    var renderFn = function renderFn(requestTime) {
        if (r.destroyed) return;
        if (cy.batching()) ;
        else if (r.requestedFrame && !r.skipFrame) {
            $e815fda779bc047b$var$beforeRenderCallbacks(r, true, requestTime);
            var startTime = $e815fda779bc047b$var$performanceNow();
            r.render(r.renderOptions);
            var endTime = r.lastDrawTime = $e815fda779bc047b$var$performanceNow();
            if (r.averageRedrawTime === undefined) r.averageRedrawTime = endTime - startTime;
            if (r.redrawCount === undefined) r.redrawCount = 0;
            r.redrawCount++;
            if (r.redrawTotalTime === undefined) r.redrawTotalTime = 0;
            var duration = endTime - startTime;
            r.redrawTotalTime += duration;
            r.lastRedrawTime = duration;
            // use a weighted average with a bias from the previous average so we don't spike so easily
            r.averageRedrawTime = r.averageRedrawTime / 2 + duration / 2;
            r.requestedFrame = false;
        } else $e815fda779bc047b$var$beforeRenderCallbacks(r, false, requestTime);
        r.skipFrame = false;
        $e815fda779bc047b$var$requestAnimationFrame(renderFn);
    };
    $e815fda779bc047b$var$requestAnimationFrame(renderFn);
};
var $e815fda779bc047b$var$BaseRenderer = function BaseRenderer(options) {
    this.init(options);
};
var $e815fda779bc047b$var$BR = $e815fda779bc047b$var$BaseRenderer;
var $e815fda779bc047b$var$BRp = $e815fda779bc047b$var$BR.prototype;
$e815fda779bc047b$var$BRp.clientFunctions = [
    'redrawHint',
    'render',
    'renderTo',
    'matchCanvasSize',
    'nodeShapeImpl',
    'arrowShapeImpl'
];
$e815fda779bc047b$var$BRp.init = function(options) {
    var r = this;
    r.options = options;
    r.cy = options.cy;
    var ctr = r.container = options.cy.container();
    var containerWindow = r.cy.window();
    // prepend a stylesheet in the head such that
    if (containerWindow) {
        var document1 = containerWindow.document;
        var head = document1.head;
        var stylesheetId = '__________cytoscape_stylesheet';
        var className = '__________cytoscape_container';
        var stylesheetAlreadyExists = document1.getElementById(stylesheetId) != null;
        if (ctr.className.indexOf(className) < 0) ctr.className = (ctr.className || '') + ' ' + className;
        if (!stylesheetAlreadyExists) {
            var stylesheet = document1.createElement('style');
            stylesheet.id = stylesheetId;
            stylesheet.textContent = '.' + className + ' { position: relative; }';
            head.insertBefore(stylesheet, head.children[0]); // first so lowest priority
        }
        var computedStyle = containerWindow.getComputedStyle(ctr);
        var position = computedStyle.getPropertyValue('position');
        if (position === 'static') $e815fda779bc047b$var$warn('A Cytoscape container has style position:static and so can not use UI extensions properly');
    }
    r.selection = [
        undefined,
        undefined,
        undefined,
        undefined,
        0
    ]; // Coordinates for selection box, plus enabled flag
    r.bezierProjPcts = [
        0.05,
        0.225,
        0.4,
        0.5,
        0.6,
        0.775,
        0.95
    ];
    //--Pointer-related data
    r.hoverData = {
        down: null,
        last: null,
        downTime: null,
        triggerMode: null,
        dragging: false,
        initialPan: [
            null,
            null
        ],
        capture: false
    };
    r.dragData = {
        possibleDragElements: []
    };
    r.touchData = {
        start: null,
        capture: false,
        // These 3 fields related to tap, taphold events
        startPosition: [
            null,
            null,
            null,
            null,
            null,
            null
        ],
        singleTouchStartTime: null,
        singleTouchMoved: true,
        now: [
            null,
            null,
            null,
            null,
            null,
            null
        ],
        earlier: [
            null,
            null,
            null,
            null,
            null,
            null
        ]
    };
    r.redraws = 0;
    r.showFps = options.showFps;
    r.debug = options.debug;
    r.hideEdgesOnViewport = options.hideEdgesOnViewport;
    r.textureOnViewport = options.textureOnViewport;
    r.wheelSensitivity = options.wheelSensitivity;
    r.motionBlurEnabled = options.motionBlur; // on by default
    r.forcedPixelRatio = $e815fda779bc047b$var$number$1(options.pixelRatio) ? options.pixelRatio : null;
    r.motionBlur = options.motionBlur; // for initial kick off
    r.motionBlurOpacity = options.motionBlurOpacity;
    r.motionBlurTransparency = 1 - r.motionBlurOpacity;
    r.motionBlurPxRatio = 1;
    r.mbPxRBlurry = 1; //0.8;
    r.minMbLowQualFrames = 4;
    r.fullQualityMb = false;
    r.clearedForMotionBlur = [];
    r.desktopTapThreshold = options.desktopTapThreshold;
    r.desktopTapThreshold2 = options.desktopTapThreshold * options.desktopTapThreshold;
    r.touchTapThreshold = options.touchTapThreshold;
    r.touchTapThreshold2 = options.touchTapThreshold * options.touchTapThreshold;
    r.tapholdDuration = 500;
    r.bindings = [];
    r.beforeRenderCallbacks = [];
    r.beforeRenderPriorities = {
        // higher priority execs before lower one
        animations: 400,
        eleCalcs: 300,
        eleTxrDeq: 200,
        lyrTxrDeq: 150,
        lyrTxrSkip: 100
    };
    r.registerNodeShapes();
    r.registerArrowShapes();
    r.registerCalculationListeners();
};
$e815fda779bc047b$var$BRp.notify = function(eventName, eles) {
    var r = this;
    var cy = r.cy;
    // the renderer can't be notified after it's destroyed
    if (this.destroyed) return;
    if (eventName === 'init') {
        r.load();
        return;
    }
    if (eventName === 'destroy') {
        r.destroy();
        return;
    }
    if (eventName === 'add' || eventName === 'remove' || eventName === 'move' && cy.hasCompoundNodes() || eventName === 'load' || eventName === 'zorder' || eventName === 'mount') r.invalidateCachedZSortedEles();
    if (eventName === 'viewport') r.redrawHint('select', true);
    if (eventName === 'load' || eventName === 'resize' || eventName === 'mount') {
        r.invalidateContainerClientCoordsCache();
        r.matchCanvasSize(r.container);
    }
    r.redrawHint('eles', true);
    r.redrawHint('drag', true);
    this.startRenderLoop();
    this.redraw();
};
$e815fda779bc047b$var$BRp.destroy = function() {
    var r = this;
    r.destroyed = true;
    r.cy.stopAnimationLoop();
    for(var i = 0; i < r.bindings.length; i++){
        var binding = r.bindings[i];
        var b = binding;
        var tgt = b.target;
        (tgt.off || tgt.removeEventListener).apply(tgt, b.args);
    }
    r.bindings = [];
    r.beforeRenderCallbacks = [];
    r.onUpdateEleCalcsFns = [];
    if (r.removeObserver) r.removeObserver.disconnect();
    if (r.styleObserver) r.styleObserver.disconnect();
    if (r.resizeObserver) r.resizeObserver.disconnect();
    if (r.labelCalcDiv) try {
        document.body.removeChild(r.labelCalcDiv); // eslint-disable-line no-undef
    } catch (e) {
    // ie10 issue #1014
    }
};
$e815fda779bc047b$var$BRp.isHeadless = function() {
    return false;
};
[
    $e815fda779bc047b$var$BRp$f,
    $e815fda779bc047b$var$BRp$5,
    $e815fda779bc047b$var$BRp$4,
    $e815fda779bc047b$var$BRp$3,
    $e815fda779bc047b$var$BRp$2,
    $e815fda779bc047b$var$BRp$1
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$BRp, props);
});
var $e815fda779bc047b$var$fullFpsTime = 1000 / 60; // assume 60 frames per second
var $e815fda779bc047b$var$defs = {
    setupDequeueing: function setupDequeueing(opts) {
        return function setupDequeueingImpl() {
            var self1 = this;
            var r = this.renderer;
            if (self1.dequeueingSetup) return;
            else self1.dequeueingSetup = true;
            var queueRedraw = $e815fda779bc047b$var$debounce_1(function() {
                r.redrawHint('eles', true);
                r.redrawHint('drag', true);
                r.redraw();
            }, opts.deqRedrawThreshold);
            var dequeue = function dequeue(willDraw, frameStartTime) {
                var startTime = $e815fda779bc047b$var$performanceNow();
                var avgRenderTime = r.averageRedrawTime;
                var renderTime = r.lastRedrawTime;
                var deqd = [];
                var extent = r.cy.extent();
                var pixelRatio = r.getPixelRatio();
                // if we aren't in a tick that causes a draw, then the rendered style
                // queue won't automatically be flushed before dequeueing starts
                if (!willDraw) r.flushRenderedStyleQueue();
                while(true){
                    // eslint-disable-line no-constant-condition
                    var now = $e815fda779bc047b$var$performanceNow();
                    var duration = now - startTime;
                    var frameDuration = now - frameStartTime;
                    if (renderTime < $e815fda779bc047b$var$fullFpsTime) {
                        // if we're rendering faster than the ideal fps, then do dequeueing
                        // during all of the remaining frame time
                        var timeAvailable = $e815fda779bc047b$var$fullFpsTime - (willDraw ? avgRenderTime : 0);
                        if (frameDuration >= opts.deqFastCost * timeAvailable) break;
                    } else {
                        if (willDraw) {
                            if (duration >= opts.deqCost * renderTime || duration >= opts.deqAvgCost * avgRenderTime) break;
                        } else if (frameDuration >= opts.deqNoDrawCost * $e815fda779bc047b$var$fullFpsTime) break;
                    }
                    var thisDeqd = opts.deq(self1, pixelRatio, extent);
                    if (thisDeqd.length > 0) for(var i = 0; i < thisDeqd.length; i++)deqd.push(thisDeqd[i]);
                    else break;
                }
                // callbacks on dequeue
                if (deqd.length > 0) {
                    opts.onDeqd(self1, deqd);
                    if (!willDraw && opts.shouldRedraw(self1, deqd, pixelRatio, extent)) queueRedraw();
                }
            };
            var priority = opts.priority || $e815fda779bc047b$var$noop$1;
            r.beforeRender(dequeue, priority(self1));
        };
    }
};
// Allows lookups for (ele, lvl) => cache.
// Uses keys so elements may share the same cache.
var $e815fda779bc047b$var$ElementTextureCacheLookup = /*#__PURE__*/ function() {
    function ElementTextureCacheLookup(getKey) {
        var doesEleInvalidateKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e815fda779bc047b$var$falsify;
        $e815fda779bc047b$var$_classCallCheck(this, ElementTextureCacheLookup);
        this.idsByKey = new $e815fda779bc047b$var$Map$2();
        this.keyForId = new $e815fda779bc047b$var$Map$2();
        this.cachesByLvl = new $e815fda779bc047b$var$Map$2();
        this.lvls = [];
        this.getKey = getKey;
        this.doesEleInvalidateKey = doesEleInvalidateKey;
    }
    $e815fda779bc047b$var$_createClass(ElementTextureCacheLookup, [
        {
            key: "getIdsFor",
            value: function getIdsFor(key) {
                if (key == null) $e815fda779bc047b$var$error("Can not get id list for null key");
                var idsByKey = this.idsByKey;
                var ids = this.idsByKey.get(key);
                if (!ids) {
                    ids = new $e815fda779bc047b$var$Set$1();
                    idsByKey.set(key, ids);
                }
                return ids;
            }
        },
        {
            key: "addIdForKey",
            value: function addIdForKey(key, id) {
                if (key != null) this.getIdsFor(key).add(id);
            }
        },
        {
            key: "deleteIdForKey",
            value: function deleteIdForKey(key, id) {
                if (key != null) this.getIdsFor(key)["delete"](id);
            }
        },
        {
            key: "getNumberOfIdsForKey",
            value: function getNumberOfIdsForKey(key) {
                if (key == null) return 0;
                else return this.getIdsFor(key).size;
            }
        },
        {
            key: "updateKeyMappingFor",
            value: function updateKeyMappingFor(ele) {
                var id = ele.id();
                var prevKey = this.keyForId.get(id);
                var currKey = this.getKey(ele);
                this.deleteIdForKey(prevKey, id);
                this.addIdForKey(currKey, id);
                this.keyForId.set(id, currKey);
            }
        },
        {
            key: "deleteKeyMappingFor",
            value: function deleteKeyMappingFor(ele) {
                var id = ele.id();
                var prevKey = this.keyForId.get(id);
                this.deleteIdForKey(prevKey, id);
                this.keyForId["delete"](id);
            }
        },
        {
            key: "keyHasChangedFor",
            value: function keyHasChangedFor(ele) {
                var id = ele.id();
                var prevKey = this.keyForId.get(id);
                var newKey = this.getKey(ele);
                return prevKey !== newKey;
            }
        },
        {
            key: "isInvalid",
            value: function isInvalid(ele) {
                return this.keyHasChangedFor(ele) || this.doesEleInvalidateKey(ele);
            }
        },
        {
            key: "getCachesAt",
            value: function getCachesAt(lvl) {
                var cachesByLvl = this.cachesByLvl, lvls = this.lvls;
                var caches = cachesByLvl.get(lvl);
                if (!caches) {
                    caches = new $e815fda779bc047b$var$Map$2();
                    cachesByLvl.set(lvl, caches);
                    lvls.push(lvl);
                }
                return caches;
            }
        },
        {
            key: "getCache",
            value: function getCache(key, lvl) {
                return this.getCachesAt(lvl).get(key);
            }
        },
        {
            key: "get",
            value: function get(ele, lvl) {
                var key = this.getKey(ele);
                var cache = this.getCache(key, lvl);
                // getting for an element may need to add to the id list b/c eles can share keys
                if (cache != null) this.updateKeyMappingFor(ele);
                return cache;
            }
        },
        {
            key: "getForCachedKey",
            value: function getForCachedKey(ele, lvl) {
                var key = this.keyForId.get(ele.id()); // n.b. use cached key, not newly computed key
                var cache = this.getCache(key, lvl);
                return cache;
            }
        },
        {
            key: "hasCache",
            value: function hasCache(key, lvl) {
                return this.getCachesAt(lvl).has(key);
            }
        },
        {
            key: "has",
            value: function has(ele, lvl) {
                var key = this.getKey(ele);
                return this.hasCache(key, lvl);
            }
        },
        {
            key: "setCache",
            value: function setCache(key, lvl, cache) {
                cache.key = key;
                this.getCachesAt(lvl).set(key, cache);
            }
        },
        {
            key: "set",
            value: function set(ele, lvl, cache) {
                var key = this.getKey(ele);
                this.setCache(key, lvl, cache);
                this.updateKeyMappingFor(ele);
            }
        },
        {
            key: "deleteCache",
            value: function deleteCache(key, lvl) {
                this.getCachesAt(lvl)["delete"](key);
            }
        },
        {
            key: "delete",
            value: function _delete(ele, lvl) {
                var key = this.getKey(ele);
                this.deleteCache(key, lvl);
            }
        },
        {
            key: "invalidateKey",
            value: function invalidateKey(key) {
                var _this = this;
                this.lvls.forEach(function(lvl) {
                    return _this.deleteCache(key, lvl);
                });
            }
        },
        {
            key: "invalidate",
            value: function invalidate(ele) {
                var id = ele.id();
                var key = this.keyForId.get(id); // n.b. use stored key rather than current (potential key)
                this.deleteKeyMappingFor(ele);
                var entireKeyInvalidated = this.doesEleInvalidateKey(ele);
                if (entireKeyInvalidated) // clear mapping for current key
                this.invalidateKey(key);
                return entireKeyInvalidated || this.getNumberOfIdsForKey(key) === 0;
            }
        }
    ]);
    return ElementTextureCacheLookup;
}();
var $e815fda779bc047b$var$minTxrH = 25; // the size of the texture cache for small height eles (special case)
var $e815fda779bc047b$var$txrStepH = 50; // the min size of the regular cache, and the size it increases with each step up
var $e815fda779bc047b$var$minLvl$1 = -4; // when scaling smaller than that we don't need to re-render
var $e815fda779bc047b$var$maxLvl$1 = 3; // when larger than this scale just render directly (caching is not helpful)
var $e815fda779bc047b$var$maxZoom$1 = 7.99; // beyond this zoom level, layered textures are not used
var $e815fda779bc047b$var$eleTxrSpacing = 8; // spacing between elements on textures to avoid blitting overlaps
var $e815fda779bc047b$var$defTxrWidth = 1024; // default/minimum texture width
var $e815fda779bc047b$var$maxTxrW = 1024; // the maximum width of a texture
var $e815fda779bc047b$var$maxTxrH = 1024; // the maximum height of a texture
var $e815fda779bc047b$var$minUtility = 0.2; // if usage of texture is less than this, it is retired
var $e815fda779bc047b$var$maxFullness = 0.8; // fullness of texture after which queue removal is checked
var $e815fda779bc047b$var$maxFullnessChecks = 10; // dequeued after this many checks
var $e815fda779bc047b$var$deqCost$1 = 0.15; // % of add'l rendering cost allowed for dequeuing ele caches each frame
var $e815fda779bc047b$var$deqAvgCost$1 = 0.1; // % of add'l rendering cost compared to average overall redraw time
var $e815fda779bc047b$var$deqNoDrawCost$1 = 0.9; // % of avg frame time that can be used for dequeueing when not drawing
var $e815fda779bc047b$var$deqFastCost$1 = 0.9; // % of frame time to be used when >60fps
var $e815fda779bc047b$var$deqRedrawThreshold$1 = 100; // time to batch redraws together from dequeueing to allow more dequeueing calcs to happen in the meanwhile
var $e815fda779bc047b$var$maxDeqSize$1 = 1; // number of eles to dequeue and render at higher texture in each batch
var $e815fda779bc047b$var$getTxrReasons = {
    dequeue: 'dequeue',
    downscale: 'downscale',
    highQuality: 'highQuality'
};
var $e815fda779bc047b$var$initDefaults = $e815fda779bc047b$var$defaults$g({
    getKey: null,
    doesEleInvalidateKey: $e815fda779bc047b$var$falsify,
    drawElement: null,
    getBoundingBox: null,
    getRotationPoint: null,
    getRotationOffset: null,
    isVisible: $e815fda779bc047b$var$trueify,
    allowEdgeTxrCaching: true,
    allowParentTxrCaching: true
});
var $e815fda779bc047b$var$ElementTextureCache = function ElementTextureCache(renderer, initOptions) {
    var self1 = this;
    self1.renderer = renderer;
    self1.onDequeues = [];
    var opts = $e815fda779bc047b$var$initDefaults(initOptions);
    $e815fda779bc047b$var$extend(self1, opts);
    self1.lookup = new $e815fda779bc047b$var$ElementTextureCacheLookup(opts.getKey, opts.doesEleInvalidateKey);
    self1.setupDequeueing();
};
var $e815fda779bc047b$var$ETCp = $e815fda779bc047b$var$ElementTextureCache.prototype;
$e815fda779bc047b$var$ETCp.reasons = $e815fda779bc047b$var$getTxrReasons;
// the list of textures in which new subtextures for elements can be placed
$e815fda779bc047b$var$ETCp.getTextureQueue = function(txrH) {
    var self1 = this;
    self1.eleImgCaches = self1.eleImgCaches || {};
    return self1.eleImgCaches[txrH] = self1.eleImgCaches[txrH] || [];
};
// the list of usused textures which can be recycled (in use in texture queue)
$e815fda779bc047b$var$ETCp.getRetiredTextureQueue = function(txrH) {
    var self1 = this;
    var rtxtrQs = self1.eleImgCaches.retired = self1.eleImgCaches.retired || {};
    var rtxtrQ = rtxtrQs[txrH] = rtxtrQs[txrH] || [];
    return rtxtrQ;
};
// queue of element draw requests at different scale levels
$e815fda779bc047b$var$ETCp.getElementQueue = function() {
    var self1 = this;
    var q = self1.eleCacheQueue = self1.eleCacheQueue || new $e815fda779bc047b$var$heap(function(a, b) {
        return b.reqs - a.reqs;
    });
    return q;
};
// queue of element draw requests at different scale levels (element id lookup)
$e815fda779bc047b$var$ETCp.getElementKeyToQueue = function() {
    var self1 = this;
    var k2q = self1.eleKeyToCacheQueue = self1.eleKeyToCacheQueue || {};
    return k2q;
};
$e815fda779bc047b$var$ETCp.getElement = function(ele, bb, pxRatio, lvl, reason) {
    var self1 = this;
    var r = this.renderer;
    var zoom = r.cy.zoom();
    var lookup = this.lookup;
    if (!bb || bb.w === 0 || bb.h === 0 || isNaN(bb.w) || isNaN(bb.h) || !ele.visible() || ele.removed()) return null;
    if (!self1.allowEdgeTxrCaching && ele.isEdge() || !self1.allowParentTxrCaching && ele.isParent()) return null;
    if (lvl == null) lvl = Math.ceil($e815fda779bc047b$var$log2(zoom * pxRatio));
    if (lvl < $e815fda779bc047b$var$minLvl$1) lvl = $e815fda779bc047b$var$minLvl$1;
    else if (zoom >= $e815fda779bc047b$var$maxZoom$1 || lvl > $e815fda779bc047b$var$maxLvl$1) return null;
    var scale = Math.pow(2, lvl);
    var eleScaledH = bb.h * scale;
    var eleScaledW = bb.w * scale;
    var scaledLabelShown = r.eleTextBiggerThanMin(ele, scale);
    if (!this.isVisible(ele, scaledLabelShown)) return null;
    var eleCache = lookup.get(ele, lvl);
    // if this get was on an unused/invalidated cache, then restore the texture usage metric
    if (eleCache && eleCache.invalidated) {
        eleCache.invalidated = false;
        eleCache.texture.invalidatedWidth -= eleCache.width;
    }
    if (eleCache) return eleCache;
    var txrH; // which texture height this ele belongs to
    if (eleScaledH <= $e815fda779bc047b$var$minTxrH) txrH = $e815fda779bc047b$var$minTxrH;
    else if (eleScaledH <= $e815fda779bc047b$var$txrStepH) txrH = $e815fda779bc047b$var$txrStepH;
    else txrH = Math.ceil(eleScaledH / $e815fda779bc047b$var$txrStepH) * $e815fda779bc047b$var$txrStepH;
    if (eleScaledH > $e815fda779bc047b$var$maxTxrH || eleScaledW > $e815fda779bc047b$var$maxTxrW) return null; // caching large elements is not efficient
    var txrQ = self1.getTextureQueue(txrH);
    // first try the second last one in case it has space at the end
    var txr = txrQ[txrQ.length - 2];
    var addNewTxr = function addNewTxr() {
        return self1.recycleTexture(txrH, eleScaledW) || self1.addTexture(txrH, eleScaledW);
    };
    // try the last one if there is no second last one
    if (!txr) txr = txrQ[txrQ.length - 1];
    // if the last one doesn't exist, we need a first one
    if (!txr) txr = addNewTxr();
    // if there's no room in the current texture, we need a new one
    if (txr.width - txr.usedWidth < eleScaledW) txr = addNewTxr();
    var scalableFrom = function scalableFrom(otherCache) {
        return otherCache && otherCache.scaledLabelShown === scaledLabelShown;
    };
    var deqing = reason && reason === $e815fda779bc047b$var$getTxrReasons.dequeue;
    var highQualityReq = reason && reason === $e815fda779bc047b$var$getTxrReasons.highQuality;
    var downscaleReq = reason && reason === $e815fda779bc047b$var$getTxrReasons.downscale;
    var higherCache; // the nearest cache with a higher level
    for(var l = lvl + 1; l <= $e815fda779bc047b$var$maxLvl$1; l++){
        var c = lookup.get(ele, l);
        if (c) {
            higherCache = c;
            break;
        }
    }
    var oneUpCache = higherCache && higherCache.level === lvl + 1 ? higherCache : null;
    var downscale = function downscale() {
        txr.context.drawImage(oneUpCache.texture.canvas, oneUpCache.x, 0, oneUpCache.width, oneUpCache.height, txr.usedWidth, 0, eleScaledW, eleScaledH);
    };
    // reset ele area in texture
    txr.context.setTransform(1, 0, 0, 1, 0, 0);
    txr.context.clearRect(txr.usedWidth, 0, eleScaledW, txrH);
    if (scalableFrom(oneUpCache)) // then we can relatively cheaply rescale the existing image w/o rerendering
    downscale();
    else if (scalableFrom(higherCache)) {
        // then use the higher cache for now and queue the next level down
        // to cheaply scale towards the smaller level
        if (highQualityReq) {
            for(var _l = higherCache.level; _l > lvl; _l--)oneUpCache = self1.getElement(ele, bb, pxRatio, _l, $e815fda779bc047b$var$getTxrReasons.downscale);
            downscale();
        } else {
            self1.queueElement(ele, higherCache.level - 1);
            return higherCache;
        }
    } else {
        var lowerCache; // the nearest cache with a lower level
        if (!deqing && !highQualityReq && !downscaleReq) for(var _l2 = lvl - 1; _l2 >= $e815fda779bc047b$var$minLvl$1; _l2--){
            var _c = lookup.get(ele, _l2);
            if (_c) {
                lowerCache = _c;
                break;
            }
        }
        if (scalableFrom(lowerCache)) {
            // then use the lower quality cache for now and queue the better one for later
            self1.queueElement(ele, lvl);
            return lowerCache;
        }
        txr.context.translate(txr.usedWidth, 0);
        txr.context.scale(scale, scale);
        this.drawElement(txr.context, ele, bb, scaledLabelShown, false);
        txr.context.scale(1 / scale, 1 / scale);
        txr.context.translate(-txr.usedWidth, 0);
    }
    eleCache = {
        x: txr.usedWidth,
        texture: txr,
        level: lvl,
        scale: scale,
        width: eleScaledW,
        height: eleScaledH,
        scaledLabelShown: scaledLabelShown
    };
    txr.usedWidth += Math.ceil(eleScaledW + $e815fda779bc047b$var$eleTxrSpacing);
    txr.eleCaches.push(eleCache);
    lookup.set(ele, lvl, eleCache);
    self1.checkTextureFullness(txr);
    return eleCache;
};
$e815fda779bc047b$var$ETCp.invalidateElements = function(eles) {
    for(var i = 0; i < eles.length; i++)this.invalidateElement(eles[i]);
};
$e815fda779bc047b$var$ETCp.invalidateElement = function(ele) {
    var self1 = this;
    var lookup = self1.lookup;
    var caches = [];
    var invalid = lookup.isInvalid(ele);
    if (!invalid) return; // override the invalidation request if the element key has not changed
    for(var lvl = $e815fda779bc047b$var$minLvl$1; lvl <= $e815fda779bc047b$var$maxLvl$1; lvl++){
        var cache = lookup.getForCachedKey(ele, lvl);
        if (cache) caches.push(cache);
    }
    var noOtherElesUseCache = lookup.invalidate(ele);
    if (noOtherElesUseCache) for(var i = 0; i < caches.length; i++){
        var _cache = caches[i];
        var txr = _cache.texture;
        // remove space from the texture it belongs to
        txr.invalidatedWidth += _cache.width;
        // mark the cache as invalidated
        _cache.invalidated = true;
        // retire the texture if its utility is low
        self1.checkTextureUtility(txr);
    }
    // remove from queue since the old req was for the old state
    self1.removeFromQueue(ele);
};
$e815fda779bc047b$var$ETCp.checkTextureUtility = function(txr) {
    // invalidate all entries in the cache if the cache size is small
    if (txr.invalidatedWidth >= $e815fda779bc047b$var$minUtility * txr.width) this.retireTexture(txr);
};
$e815fda779bc047b$var$ETCp.checkTextureFullness = function(txr) {
    // if texture has been mostly filled and passed over several times, remove
    // it from the queue so we don't need to waste time looking at it to put new things
    var self1 = this;
    var txrQ = self1.getTextureQueue(txr.height);
    if (txr.usedWidth / txr.width > $e815fda779bc047b$var$maxFullness && txr.fullnessChecks >= $e815fda779bc047b$var$maxFullnessChecks) $e815fda779bc047b$var$removeFromArray(txrQ, txr);
    else txr.fullnessChecks++;
};
$e815fda779bc047b$var$ETCp.retireTexture = function(txr) {
    var self1 = this;
    var txrH = txr.height;
    var txrQ = self1.getTextureQueue(txrH);
    var lookup = this.lookup;
    // retire the texture from the active / searchable queue:
    $e815fda779bc047b$var$removeFromArray(txrQ, txr);
    txr.retired = true;
    // remove the refs from the eles to the caches:
    var eleCaches = txr.eleCaches;
    for(var i = 0; i < eleCaches.length; i++){
        var eleCache = eleCaches[i];
        lookup.deleteCache(eleCache.key, eleCache.level);
    }
    $e815fda779bc047b$var$clearArray(eleCaches);
    // add the texture to a retired queue so it can be recycled in future:
    var rtxtrQ = self1.getRetiredTextureQueue(txrH);
    rtxtrQ.push(txr);
};
$e815fda779bc047b$var$ETCp.addTexture = function(txrH, minW) {
    var self1 = this;
    var txrQ = self1.getTextureQueue(txrH);
    var txr = {};
    txrQ.push(txr);
    txr.eleCaches = [];
    txr.height = txrH;
    txr.width = Math.max($e815fda779bc047b$var$defTxrWidth, minW);
    txr.usedWidth = 0;
    txr.invalidatedWidth = 0;
    txr.fullnessChecks = 0;
    txr.canvas = self1.renderer.makeOffscreenCanvas(txr.width, txr.height);
    txr.context = txr.canvas.getContext('2d');
    return txr;
};
$e815fda779bc047b$var$ETCp.recycleTexture = function(txrH, minW) {
    var self1 = this;
    var txrQ = self1.getTextureQueue(txrH);
    var rtxtrQ = self1.getRetiredTextureQueue(txrH);
    for(var i = 0; i < rtxtrQ.length; i++){
        var txr = rtxtrQ[i];
        if (txr.width >= minW) {
            txr.retired = false;
            txr.usedWidth = 0;
            txr.invalidatedWidth = 0;
            txr.fullnessChecks = 0;
            $e815fda779bc047b$var$clearArray(txr.eleCaches);
            txr.context.setTransform(1, 0, 0, 1, 0, 0);
            txr.context.clearRect(0, 0, txr.width, txr.height);
            $e815fda779bc047b$var$removeFromArray(rtxtrQ, txr);
            txrQ.push(txr);
            return txr;
        }
    }
};
$e815fda779bc047b$var$ETCp.queueElement = function(ele, lvl) {
    var self1 = this;
    var q = self1.getElementQueue();
    var k2q = self1.getElementKeyToQueue();
    var key = this.getKey(ele);
    var existingReq = k2q[key];
    if (existingReq) {
        // use the max lvl b/c in between lvls are cheap to make
        existingReq.level = Math.max(existingReq.level, lvl);
        existingReq.eles.merge(ele);
        existingReq.reqs++;
        q.updateItem(existingReq);
    } else {
        var req = {
            eles: ele.spawn().merge(ele),
            level: lvl,
            reqs: 1,
            key: key
        };
        q.push(req);
        k2q[key] = req;
    }
};
$e815fda779bc047b$var$ETCp.dequeue = function(pxRatio /*, extent*/ ) {
    var self1 = this;
    var q = self1.getElementQueue();
    var k2q = self1.getElementKeyToQueue();
    var dequeued = [];
    var lookup = self1.lookup;
    for(var i = 0; i < $e815fda779bc047b$var$maxDeqSize$1; i++){
        if (q.size() > 0) {
            var req = q.pop();
            var key = req.key;
            var ele = req.eles[0]; // all eles have the same key
            var cacheExists = lookup.hasCache(ele, req.level);
            // clear out the key to req lookup
            k2q[key] = null;
            // dequeueing isn't necessary with an existing cache
            if (cacheExists) continue;
            dequeued.push(req);
            var bb = self1.getBoundingBox(ele);
            self1.getElement(ele, bb, pxRatio, req.level, $e815fda779bc047b$var$getTxrReasons.dequeue);
        } else break;
    }
    return dequeued;
};
$e815fda779bc047b$var$ETCp.removeFromQueue = function(ele) {
    var self1 = this;
    var q = self1.getElementQueue();
    var k2q = self1.getElementKeyToQueue();
    var key = this.getKey(ele);
    var req = k2q[key];
    if (req != null) {
        if (req.eles.length === 1) {
            // remove if last ele in the req
            // bring to front of queue
            req.reqs = $e815fda779bc047b$var$MAX_INT$1;
            q.updateItem(req);
            q.pop(); // remove from queue
            k2q[key] = null; // remove from lookup map
        } else // otherwise just remove ele from req
        req.eles.unmerge(ele);
    }
};
$e815fda779bc047b$var$ETCp.onDequeue = function(fn) {
    this.onDequeues.push(fn);
};
$e815fda779bc047b$var$ETCp.offDequeue = function(fn) {
    $e815fda779bc047b$var$removeFromArray(this.onDequeues, fn);
};
$e815fda779bc047b$var$ETCp.setupDequeueing = $e815fda779bc047b$var$defs.setupDequeueing({
    deqRedrawThreshold: $e815fda779bc047b$var$deqRedrawThreshold$1,
    deqCost: $e815fda779bc047b$var$deqCost$1,
    deqAvgCost: $e815fda779bc047b$var$deqAvgCost$1,
    deqNoDrawCost: $e815fda779bc047b$var$deqNoDrawCost$1,
    deqFastCost: $e815fda779bc047b$var$deqFastCost$1,
    deq: function deq(self1, pxRatio, extent) {
        return self1.dequeue(pxRatio, extent);
    },
    onDeqd: function onDeqd(self1, deqd) {
        for(var i = 0; i < self1.onDequeues.length; i++){
            var fn = self1.onDequeues[i];
            fn(deqd);
        }
    },
    shouldRedraw: function shouldRedraw(self1, deqd, pxRatio, extent) {
        for(var i = 0; i < deqd.length; i++){
            var eles = deqd[i].eles;
            for(var j = 0; j < eles.length; j++){
                var bb = eles[j].boundingBox();
                if ($e815fda779bc047b$var$boundingBoxesIntersect(bb, extent)) return true;
            }
        }
        return false;
    },
    priority: function priority(self1) {
        return self1.renderer.beforeRenderPriorities.eleTxrDeq;
    }
});
var $e815fda779bc047b$var$defNumLayers = 1; // default number of layers to use
var $e815fda779bc047b$var$minLvl = -4; // when scaling smaller than that we don't need to re-render
var $e815fda779bc047b$var$maxLvl = 2; // when larger than this scale just render directly (caching is not helpful)
var $e815fda779bc047b$var$maxZoom = 3.99; // beyond this zoom level, layered textures are not used
var $e815fda779bc047b$var$deqRedrawThreshold = 50; // time to batch redraws together from dequeueing to allow more dequeueing calcs to happen in the meanwhile
var $e815fda779bc047b$var$refineEleDebounceTime = 50; // time to debounce sharper ele texture updates
var $e815fda779bc047b$var$deqCost = 0.15; // % of add'l rendering cost allowed for dequeuing ele caches each frame
var $e815fda779bc047b$var$deqAvgCost = 0.1; // % of add'l rendering cost compared to average overall redraw time
var $e815fda779bc047b$var$deqNoDrawCost = 0.9; // % of avg frame time that can be used for dequeueing when not drawing
var $e815fda779bc047b$var$deqFastCost = 0.9; // % of frame time to be used when >60fps
var $e815fda779bc047b$var$maxDeqSize = 1; // number of eles to dequeue and render at higher texture in each batch
var $e815fda779bc047b$var$invalidThreshold = 250; // time threshold for disabling b/c of invalidations
var $e815fda779bc047b$var$maxLayerArea = 16000000; // layers can't be bigger than this
var $e815fda779bc047b$var$maxLayerDim = 32767; // maximum size for the width/height of layer canvases
var $e815fda779bc047b$var$useHighQualityEleTxrReqs = true; // whether to use high quality ele txr requests (generally faster and cheaper in the longterm)
// var log = function(){ console.log.apply( console, arguments ); };
var $e815fda779bc047b$var$LayeredTextureCache = function LayeredTextureCache(renderer) {
    var self1 = this;
    var r = self1.renderer = renderer;
    var cy = r.cy;
    self1.layersByLevel = {}; // e.g. 2 => [ layer1, layer2, ..., layerN ]
    self1.firstGet = true;
    self1.lastInvalidationTime = $e815fda779bc047b$var$performanceNow() - 2 * $e815fda779bc047b$var$invalidThreshold;
    self1.skipping = false;
    self1.eleTxrDeqs = cy.collection();
    self1.scheduleElementRefinement = $e815fda779bc047b$var$debounce_1(function() {
        self1.refineElementTextures(self1.eleTxrDeqs);
        self1.eleTxrDeqs.unmerge(self1.eleTxrDeqs);
    }, $e815fda779bc047b$var$refineEleDebounceTime);
    r.beforeRender(function(willDraw, now) {
        if (now - self1.lastInvalidationTime <= $e815fda779bc047b$var$invalidThreshold) self1.skipping = true;
        else self1.skipping = false;
    }, r.beforeRenderPriorities.lyrTxrSkip);
    var qSort = function qSort(a, b) {
        return b.reqs - a.reqs;
    };
    self1.layersQueue = new $e815fda779bc047b$var$heap(qSort);
    self1.setupDequeueing();
};
var $e815fda779bc047b$var$LTCp = $e815fda779bc047b$var$LayeredTextureCache.prototype;
var $e815fda779bc047b$var$layerIdPool = 0;
var $e815fda779bc047b$var$MAX_INT = Math.pow(2, 53) - 1;
$e815fda779bc047b$var$LTCp.makeLayer = function(bb, lvl) {
    var scale = Math.pow(2, lvl);
    var w = Math.ceil(bb.w * scale);
    var h = Math.ceil(bb.h * scale);
    var canvas = this.renderer.makeOffscreenCanvas(w, h);
    var layer = {
        id: $e815fda779bc047b$var$layerIdPool = ++$e815fda779bc047b$var$layerIdPool % $e815fda779bc047b$var$MAX_INT,
        bb: bb,
        level: lvl,
        width: w,
        height: h,
        canvas: canvas,
        context: canvas.getContext('2d'),
        eles: [],
        elesQueue: [],
        reqs: 0
    };
    // log('make layer %s with w %s and h %s and lvl %s', layer.id, layer.width, layer.height, layer.level);
    var cxt = layer.context;
    var dx = -layer.bb.x1;
    var dy = -layer.bb.y1;
    // do the transform on creation to save cycles (it's the same for all eles)
    cxt.scale(scale, scale);
    cxt.translate(dx, dy);
    return layer;
};
$e815fda779bc047b$var$LTCp.getLayers = function(eles, pxRatio, lvl) {
    var self1 = this;
    var r = self1.renderer;
    var cy = r.cy;
    var zoom = cy.zoom();
    var firstGet = self1.firstGet;
    self1.firstGet = false;
    // log('--\nget layers with %s eles', eles.length);
    //log eles.map(function(ele){ return ele.id() }) );
    if (lvl == null) {
        lvl = Math.ceil($e815fda779bc047b$var$log2(zoom * pxRatio));
        if (lvl < $e815fda779bc047b$var$minLvl) lvl = $e815fda779bc047b$var$minLvl;
        else if (zoom >= $e815fda779bc047b$var$maxZoom || lvl > $e815fda779bc047b$var$maxLvl) return null;
    }
    self1.validateLayersElesOrdering(lvl, eles);
    var layersByLvl = self1.layersByLevel;
    var scale = Math.pow(2, lvl);
    var layers = layersByLvl[lvl] = layersByLvl[lvl] || [];
    var bb;
    var lvlComplete = self1.levelIsComplete(lvl, eles);
    var tmpLayers;
    var checkTempLevels = function checkTempLevels() {
        var canUseAsTmpLvl = function canUseAsTmpLvl(l) {
            self1.validateLayersElesOrdering(l, eles);
            if (self1.levelIsComplete(l, eles)) {
                tmpLayers = layersByLvl[l];
                return true;
            }
        };
        var checkLvls = function checkLvls(dir) {
            if (tmpLayers) return;
            for(var l = lvl + dir; $e815fda779bc047b$var$minLvl <= l && l <= $e815fda779bc047b$var$maxLvl; l += dir){
                if (canUseAsTmpLvl(l)) break;
            }
        };
        checkLvls(1);
        checkLvls(-1);
        // remove the invalid layers; they will be replaced as needed later in this function
        for(var i = layers.length - 1; i >= 0; i--){
            var layer = layers[i];
            if (layer.invalid) $e815fda779bc047b$var$removeFromArray(layers, layer);
        }
    };
    if (!lvlComplete) // if the current level is incomplete, then use the closest, best quality layerset temporarily
    // and later queue the current layerset so we can get the proper quality level soon
    checkTempLevels();
    else // log('level complete, using existing layers\n--');
    return layers;
    var getBb = function getBb() {
        if (!bb) {
            bb = $e815fda779bc047b$var$makeBoundingBox();
            for(var i = 0; i < eles.length; i++)$e815fda779bc047b$var$updateBoundingBox(bb, eles[i].boundingBox());
        }
        return bb;
    };
    var makeLayer = function makeLayer(opts) {
        opts = opts || {};
        var after = opts.after;
        getBb();
        var w = Math.ceil(bb.w * scale);
        var h = Math.ceil(bb.h * scale);
        if (w > $e815fda779bc047b$var$maxLayerDim || h > $e815fda779bc047b$var$maxLayerDim) return null;
        var area = w * h;
        if (area > $e815fda779bc047b$var$maxLayerArea) return null;
        var layer = self1.makeLayer(bb, lvl);
        if (after != null) {
            var index = layers.indexOf(after) + 1;
            layers.splice(index, 0, layer);
        } else if (opts.insert === undefined || opts.insert) // no after specified => first layer made so put at start
        layers.unshift(layer);
        // if( tmpLayers ){
        //self.queueLayer( layer );
        // }
        return layer;
    };
    if (self1.skipping && !firstGet) // log('skip layers');
    return null;
    // log('do layers');
    var layer = null;
    var maxElesPerLayer = eles.length / $e815fda779bc047b$var$defNumLayers;
    var allowLazyQueueing = !firstGet;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var rs = ele._private.rscratch;
        var caches = rs.imgLayerCaches = rs.imgLayerCaches || {};
        // log('look at ele', ele.id());
        var existingLayer = caches[lvl];
        if (existingLayer) {
            // reuse layer for later eles
            // log('reuse layer for', ele.id());
            layer = existingLayer;
            continue;
        }
        if (!layer || layer.eles.length >= maxElesPerLayer || !$e815fda779bc047b$var$boundingBoxInBoundingBox(layer.bb, ele.boundingBox())) {
            // log('make new layer for ele %s', ele.id());
            layer = makeLayer({
                insert: true,
                after: layer
            });
            // if now layer can be built then we can't use layers at this level
            if (!layer) return null;
        // log('new layer with id %s', layer.id);
        }
        if (tmpLayers || allowLazyQueueing) // log('queue ele %s in layer %s', ele.id(), layer.id);
        self1.queueLayer(layer, ele);
        else // log('draw ele %s in layer %s', ele.id(), layer.id);
        self1.drawEleInLayer(layer, ele, lvl, pxRatio);
        layer.eles.push(ele);
        caches[lvl] = layer;
    }
    // log('--');
    if (tmpLayers) // then we only queued the current layerset and can't draw it yet
    return tmpLayers;
    if (allowLazyQueueing) // log('lazy queue level', lvl);
    return null;
    return layers;
};
// a layer may want to use an ele cache of a higher level to avoid blurriness
// so the layer level might not equal the ele level
$e815fda779bc047b$var$LTCp.getEleLevelForLayerLevel = function(lvl, pxRatio) {
    return lvl;
};
$e815fda779bc047b$var$LTCp.drawEleInLayer = function(layer, ele, lvl, pxRatio) {
    var self1 = this;
    var r = this.renderer;
    var context = layer.context;
    var bb = ele.boundingBox();
    if (bb.w === 0 || bb.h === 0 || !ele.visible()) return;
    lvl = self1.getEleLevelForLayerLevel(lvl, pxRatio);
    r.setImgSmoothing(context, false);
    r.drawCachedElement(context, ele, null, null, lvl, $e815fda779bc047b$var$useHighQualityEleTxrReqs);
    r.setImgSmoothing(context, true);
};
$e815fda779bc047b$var$LTCp.levelIsComplete = function(lvl, eles) {
    var self1 = this;
    var layers = self1.layersByLevel[lvl];
    if (!layers || layers.length === 0) return false;
    var numElesInLayers = 0;
    for(var i = 0; i < layers.length; i++){
        var layer = layers[i];
        // if there are any eles needed to be drawn yet, the level is not complete
        if (layer.reqs > 0) return false;
        // if the layer is invalid, the level is not complete
        if (layer.invalid) return false;
        numElesInLayers += layer.eles.length;
    }
    // we should have exactly the number of eles passed in to be complete
    if (numElesInLayers !== eles.length) return false;
    return true;
};
$e815fda779bc047b$var$LTCp.validateLayersElesOrdering = function(lvl, eles) {
    var layers = this.layersByLevel[lvl];
    if (!layers) return;
    // if in a layer the eles are not in the same order, then the layer is invalid
    // (i.e. there is an ele in between the eles in the layer)
    for(var i = 0; i < layers.length; i++){
        var layer = layers[i];
        var offset = -1;
        // find the offset
        for(var j = 0; j < eles.length; j++)if (layer.eles[0] === eles[j]) {
            offset = j;
            break;
        }
        if (offset < 0) {
            // then the layer has nonexistent elements and is invalid
            this.invalidateLayer(layer);
            continue;
        }
        // the eles in the layer must be in the same continuous order, else the layer is invalid
        var o = offset;
        for(var j = 0; j < layer.eles.length; j++)if (layer.eles[j] !== eles[o + j]) {
            // log('invalidate based on ordering', layer.id);
            this.invalidateLayer(layer);
            break;
        }
    }
};
$e815fda779bc047b$var$LTCp.updateElementsInLayers = function(eles, update) {
    var self1 = this;
    var isEles = $e815fda779bc047b$var$element(eles[0]);
    // collect udpated elements (cascaded from the layers) and update each
    // layer itself along the way
    for(var i = 0; i < eles.length; i++){
        var req = isEles ? null : eles[i];
        var ele = isEles ? eles[i] : eles[i].ele;
        var rs = ele._private.rscratch;
        var caches = rs.imgLayerCaches = rs.imgLayerCaches || {};
        for(var l = $e815fda779bc047b$var$minLvl; l <= $e815fda779bc047b$var$maxLvl; l++){
            var layer = caches[l];
            if (!layer) continue;
            // if update is a request from the ele cache, then it affects only
            // the matching level
            if (req && self1.getEleLevelForLayerLevel(layer.level) !== req.level) continue;
            update(layer, ele, req);
        }
    }
};
$e815fda779bc047b$var$LTCp.haveLayers = function() {
    var self1 = this;
    var haveLayers = false;
    for(var l = $e815fda779bc047b$var$minLvl; l <= $e815fda779bc047b$var$maxLvl; l++){
        var layers = self1.layersByLevel[l];
        if (layers && layers.length > 0) {
            haveLayers = true;
            break;
        }
    }
    return haveLayers;
};
$e815fda779bc047b$var$LTCp.invalidateElements = function(eles) {
    var self1 = this;
    if (eles.length === 0) return;
    self1.lastInvalidationTime = $e815fda779bc047b$var$performanceNow();
    // log('update invalidate layer time from eles');
    if (eles.length === 0 || !self1.haveLayers()) return;
    self1.updateElementsInLayers(eles, function invalAssocLayers(layer, ele, req) {
        self1.invalidateLayer(layer);
    });
};
$e815fda779bc047b$var$LTCp.invalidateLayer = function(layer) {
    // log('update invalidate layer time');
    this.lastInvalidationTime = $e815fda779bc047b$var$performanceNow();
    if (layer.invalid) return;
     // save cycles
    var lvl = layer.level;
    var eles = layer.eles;
    var layers = this.layersByLevel[lvl];
    // log('invalidate layer', layer.id );
    $e815fda779bc047b$var$removeFromArray(layers, layer);
    // layer.eles = [];
    layer.elesQueue = [];
    layer.invalid = true;
    if (layer.replacement) layer.replacement.invalid = true;
    for(var i = 0; i < eles.length; i++){
        var caches = eles[i]._private.rscratch.imgLayerCaches;
        if (caches) caches[lvl] = null;
    }
};
$e815fda779bc047b$var$LTCp.refineElementTextures = function(eles) {
    var self1 = this;
    // log('refine', eles.length);
    self1.updateElementsInLayers(eles, function refineEachEle(layer, ele, req) {
        var rLyr = layer.replacement;
        if (!rLyr) {
            rLyr = layer.replacement = self1.makeLayer(layer.bb, layer.level);
            rLyr.replaces = layer;
            rLyr.eles = layer.eles;
        // log('make replacement layer %s for %s with level %s', rLyr.id, layer.id, rLyr.level);
        }
        if (!rLyr.reqs) for(var i = 0; i < rLyr.eles.length; i++)self1.queueLayer(rLyr, rLyr.eles[i]);
    });
};
$e815fda779bc047b$var$LTCp.enqueueElementRefinement = function(ele) {
    this.eleTxrDeqs.merge(ele);
    this.scheduleElementRefinement();
};
$e815fda779bc047b$var$LTCp.queueLayer = function(layer, ele) {
    var self1 = this;
    var q = self1.layersQueue;
    var elesQ = layer.elesQueue;
    var hasId = elesQ.hasId = elesQ.hasId || {};
    // if a layer is going to be replaced, queuing is a waste of time
    if (layer.replacement) return;
    if (ele) {
        if (hasId[ele.id()]) return;
        elesQ.push(ele);
        hasId[ele.id()] = true;
    }
    if (layer.reqs) {
        layer.reqs++;
        q.updateItem(layer);
    } else {
        layer.reqs = 1;
        q.push(layer);
    }
};
$e815fda779bc047b$var$LTCp.dequeue = function(pxRatio) {
    var self1 = this;
    var q = self1.layersQueue;
    var deqd = [];
    var eleDeqs = 0;
    while(eleDeqs < $e815fda779bc047b$var$maxDeqSize){
        if (q.size() === 0) break;
        var layer = q.peek();
        // if a layer has been or will be replaced, then don't waste time with it
        if (layer.replacement) {
            // log('layer %s in queue skipped b/c it already has a replacement', layer.id);
            q.pop();
            continue;
        }
        // if this is a replacement layer that has been superceded, then forget it
        if (layer.replaces && layer !== layer.replaces.replacement) {
            // log('layer is no longer the most uptodate replacement; dequeued', layer.id)
            q.pop();
            continue;
        }
        if (layer.invalid) {
            // log('replacement layer %s is invalid; dequeued', layer.id);
            q.pop();
            continue;
        }
        var ele = layer.elesQueue.shift();
        if (ele) {
            // log('dequeue layer %s', layer.id);
            self1.drawEleInLayer(layer, ele, layer.level, pxRatio);
            eleDeqs++;
        }
        if (deqd.length === 0) // we need only one entry in deqd to queue redrawing etc
        deqd.push(true);
        // if the layer has all its eles done, then remove from the queue
        if (layer.elesQueue.length === 0) {
            q.pop();
            layer.reqs = 0;
            // log('dequeue of layer %s complete', layer.id);
            // when a replacement layer is dequeued, it replaces the old layer in the level
            if (layer.replaces) self1.applyLayerReplacement(layer);
            self1.requestRedraw();
        }
    }
    return deqd;
};
$e815fda779bc047b$var$LTCp.applyLayerReplacement = function(layer) {
    var self1 = this;
    var layersInLevel = self1.layersByLevel[layer.level];
    var replaced = layer.replaces;
    var index = layersInLevel.indexOf(replaced);
    // if the replaced layer is not in the active list for the level, then replacing
    // refs would be a mistake (i.e. overwriting the true active layer)
    if (index < 0 || replaced.invalid) // log('replacement layer would have no effect', layer.id);
    return;
    layersInLevel[index] = layer; // replace level ref
    // replace refs in eles
    for(var i = 0; i < layer.eles.length; i++){
        var _p = layer.eles[i]._private;
        var cache = _p.imgLayerCaches = _p.imgLayerCaches || {};
        if (cache) cache[layer.level] = layer;
    }
    // log('apply replacement layer %s over %s', layer.id, replaced.id);
    self1.requestRedraw();
};
$e815fda779bc047b$var$LTCp.requestRedraw = $e815fda779bc047b$var$debounce_1(function() {
    var r = this.renderer;
    r.redrawHint('eles', true);
    r.redrawHint('drag', true);
    r.redraw();
}, 100);
$e815fda779bc047b$var$LTCp.setupDequeueing = $e815fda779bc047b$var$defs.setupDequeueing({
    deqRedrawThreshold: $e815fda779bc047b$var$deqRedrawThreshold,
    deqCost: $e815fda779bc047b$var$deqCost,
    deqAvgCost: $e815fda779bc047b$var$deqAvgCost,
    deqNoDrawCost: $e815fda779bc047b$var$deqNoDrawCost,
    deqFastCost: $e815fda779bc047b$var$deqFastCost,
    deq: function deq(self1, pxRatio) {
        return self1.dequeue(pxRatio);
    },
    onDeqd: $e815fda779bc047b$var$noop$1,
    shouldRedraw: $e815fda779bc047b$var$trueify,
    priority: function priority(self1) {
        return self1.renderer.beforeRenderPriorities.lyrTxrDeq;
    }
});
var $e815fda779bc047b$var$CRp$a = {};
var $e815fda779bc047b$var$impl;
function $e815fda779bc047b$var$polygon(context, points) {
    for(var i = 0; i < points.length; i++){
        var pt = points[i];
        context.lineTo(pt.x, pt.y);
    }
}
function $e815fda779bc047b$var$triangleBackcurve(context, points, controlPoint) {
    var firstPt;
    for(var i = 0; i < points.length; i++){
        var pt = points[i];
        if (i === 0) firstPt = pt;
        context.lineTo(pt.x, pt.y);
    }
    context.quadraticCurveTo(controlPoint.x, controlPoint.y, firstPt.x, firstPt.y);
}
function $e815fda779bc047b$var$triangleTee(context, trianglePoints, teePoints) {
    if (context.beginPath) context.beginPath();
    var triPts = trianglePoints;
    for(var i = 0; i < triPts.length; i++){
        var pt = triPts[i];
        context.lineTo(pt.x, pt.y);
    }
    var teePts = teePoints;
    var firstTeePt = teePoints[0];
    context.moveTo(firstTeePt.x, firstTeePt.y);
    for(var i = 1; i < teePts.length; i++){
        var pt = teePts[i];
        context.lineTo(pt.x, pt.y);
    }
    if (context.closePath) context.closePath();
}
function $e815fda779bc047b$var$circleTriangle(context, trianglePoints, rx, ry, r) {
    if (context.beginPath) context.beginPath();
    context.arc(rx, ry, r, 0, Math.PI * 2, false);
    var triPts = trianglePoints;
    var firstTrPt = triPts[0];
    context.moveTo(firstTrPt.x, firstTrPt.y);
    for(var i = 0; i < triPts.length; i++){
        var pt = triPts[i];
        context.lineTo(pt.x, pt.y);
    }
    if (context.closePath) context.closePath();
}
function $e815fda779bc047b$var$circle(context, rx, ry, r) {
    context.arc(rx, ry, r, 0, Math.PI * 2, false);
}
$e815fda779bc047b$var$CRp$a.arrowShapeImpl = function(name) {
    return ($e815fda779bc047b$var$impl || ($e815fda779bc047b$var$impl = {
        'polygon': $e815fda779bc047b$var$polygon,
        'triangle-backcurve': $e815fda779bc047b$var$triangleBackcurve,
        'triangle-tee': $e815fda779bc047b$var$triangleTee,
        'circle-triangle': $e815fda779bc047b$var$circleTriangle,
        'triangle-cross': $e815fda779bc047b$var$triangleTee,
        'circle': $e815fda779bc047b$var$circle
    }))[name];
};
var $e815fda779bc047b$var$CRp$9 = {};
$e815fda779bc047b$var$CRp$9.drawElement = function(context, ele, shiftToOriginWithBb, showLabel, showOverlay, showOpacity) {
    var r = this;
    if (ele.isNode()) r.drawNode(context, ele, shiftToOriginWithBb, showLabel, showOverlay, showOpacity);
    else r.drawEdge(context, ele, shiftToOriginWithBb, showLabel, showOverlay, showOpacity);
};
$e815fda779bc047b$var$CRp$9.drawElementOverlay = function(context, ele) {
    var r = this;
    if (ele.isNode()) r.drawNodeOverlay(context, ele);
    else r.drawEdgeOverlay(context, ele);
};
$e815fda779bc047b$var$CRp$9.drawElementUnderlay = function(context, ele) {
    var r = this;
    if (ele.isNode()) r.drawNodeUnderlay(context, ele);
    else r.drawEdgeUnderlay(context, ele);
};
$e815fda779bc047b$var$CRp$9.drawCachedElementPortion = function(context, ele, eleTxrCache, pxRatio, lvl, reason, getRotation, getOpacity) {
    var r = this;
    var bb = eleTxrCache.getBoundingBox(ele);
    if (bb.w === 0 || bb.h === 0) return;
     // ignore zero size case
    var eleCache = eleTxrCache.getElement(ele, bb, pxRatio, lvl, reason);
    if (eleCache != null) {
        var opacity = getOpacity(r, ele);
        if (opacity === 0) return;
        var theta = getRotation(r, ele);
        var x1 = bb.x1, y1 = bb.y1, w = bb.w, h = bb.h;
        var x, y, sx, sy, smooth;
        if (theta !== 0) {
            var rotPt = eleTxrCache.getRotationPoint(ele);
            sx = rotPt.x;
            sy = rotPt.y;
            context.translate(sx, sy);
            context.rotate(theta);
            smooth = r.getImgSmoothing(context);
            if (!smooth) r.setImgSmoothing(context, true);
            var off = eleTxrCache.getRotationOffset(ele);
            x = off.x;
            y = off.y;
        } else {
            x = x1;
            y = y1;
        }
        var oldGlobalAlpha;
        if (opacity !== 1) {
            oldGlobalAlpha = context.globalAlpha;
            context.globalAlpha = oldGlobalAlpha * opacity;
        }
        context.drawImage(eleCache.texture.canvas, eleCache.x, 0, eleCache.width, eleCache.height, x, y, w, h);
        if (opacity !== 1) context.globalAlpha = oldGlobalAlpha;
        if (theta !== 0) {
            context.rotate(-theta);
            context.translate(-sx, -sy);
            if (!smooth) r.setImgSmoothing(context, false);
        }
    } else eleTxrCache.drawElement(context, ele); // direct draw fallback
};
var $e815fda779bc047b$var$getZeroRotation = function getZeroRotation() {
    return 0;
};
var $e815fda779bc047b$var$getLabelRotation = function getLabelRotation(r, ele) {
    return r.getTextAngle(ele, null);
};
var $e815fda779bc047b$var$getSourceLabelRotation = function getSourceLabelRotation(r, ele) {
    return r.getTextAngle(ele, 'source');
};
var $e815fda779bc047b$var$getTargetLabelRotation = function getTargetLabelRotation(r, ele) {
    return r.getTextAngle(ele, 'target');
};
var $e815fda779bc047b$var$getOpacity = function getOpacity(r, ele) {
    return ele.effectiveOpacity();
};
var $e815fda779bc047b$var$getTextOpacity = function getTextOpacity(e, ele) {
    return ele.pstyle('text-opacity').pfValue * ele.effectiveOpacity();
};
$e815fda779bc047b$var$CRp$9.drawCachedElement = function(context, ele, pxRatio, extent, lvl, requestHighQuality) {
    var r = this;
    var _r$data = r.data, eleTxrCache = _r$data.eleTxrCache, lblTxrCache = _r$data.lblTxrCache, slbTxrCache = _r$data.slbTxrCache, tlbTxrCache = _r$data.tlbTxrCache;
    var bb = ele.boundingBox();
    var reason = requestHighQuality === true ? eleTxrCache.reasons.highQuality : null;
    if (bb.w === 0 || bb.h === 0 || !ele.visible()) return;
    if (!extent || $e815fda779bc047b$var$boundingBoxesIntersect(bb, extent)) {
        var isEdge = ele.isEdge();
        var badLine = ele.element()._private.rscratch.badLine;
        r.drawElementUnderlay(context, ele);
        r.drawCachedElementPortion(context, ele, eleTxrCache, pxRatio, lvl, reason, $e815fda779bc047b$var$getZeroRotation, $e815fda779bc047b$var$getOpacity);
        if (!isEdge || !badLine) r.drawCachedElementPortion(context, ele, lblTxrCache, pxRatio, lvl, reason, $e815fda779bc047b$var$getLabelRotation, $e815fda779bc047b$var$getTextOpacity);
        if (isEdge && !badLine) {
            r.drawCachedElementPortion(context, ele, slbTxrCache, pxRatio, lvl, reason, $e815fda779bc047b$var$getSourceLabelRotation, $e815fda779bc047b$var$getTextOpacity);
            r.drawCachedElementPortion(context, ele, tlbTxrCache, pxRatio, lvl, reason, $e815fda779bc047b$var$getTargetLabelRotation, $e815fda779bc047b$var$getTextOpacity);
        }
        r.drawElementOverlay(context, ele);
    }
};
$e815fda779bc047b$var$CRp$9.drawElements = function(context, eles) {
    var r = this;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        r.drawElement(context, ele);
    }
};
$e815fda779bc047b$var$CRp$9.drawCachedElements = function(context, eles, pxRatio, extent) {
    var r = this;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        r.drawCachedElement(context, ele, pxRatio, extent);
    }
};
$e815fda779bc047b$var$CRp$9.drawCachedNodes = function(context, eles, pxRatio, extent) {
    var r = this;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        if (!ele.isNode()) continue;
        r.drawCachedElement(context, ele, pxRatio, extent);
    }
};
$e815fda779bc047b$var$CRp$9.drawLayeredElements = function(context, eles, pxRatio, extent) {
    var r = this;
    var layers = r.data.lyrTxrCache.getLayers(eles, pxRatio);
    if (layers) for(var i = 0; i < layers.length; i++){
        var layer = layers[i];
        var bb = layer.bb;
        if (bb.w === 0 || bb.h === 0) continue;
        context.drawImage(layer.canvas, bb.x1, bb.y1, bb.w, bb.h);
    }
    else // fall back on plain caching if no layers
    r.drawCachedElements(context, eles, pxRatio, extent);
};
var $e815fda779bc047b$var$CRp$8 = {};
$e815fda779bc047b$var$CRp$8.drawEdge = function(context, edge, shiftToOriginWithBb) {
    var drawLabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var shouldDrawOverlay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var shouldDrawOpacity = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var r = this;
    var rs = edge._private.rscratch;
    if (shouldDrawOpacity && !edge.visible()) return;
    // if bezier ctrl pts can not be calculated, then die
    if (rs.badLine || rs.allpts == null || isNaN(rs.allpts[0])) // isNaN in case edge is impossible and browser bugs (e.g. safari)
    return;
    var bb;
    if (shiftToOriginWithBb) {
        bb = shiftToOriginWithBb;
        context.translate(-bb.x1, -bb.y1);
    }
    var opacity = shouldDrawOpacity ? edge.pstyle('opacity').value : 1;
    var lineOpacity = shouldDrawOpacity ? edge.pstyle('line-opacity').value : 1;
    var curveStyle = edge.pstyle('curve-style').value;
    var lineStyle = edge.pstyle('line-style').value;
    var edgeWidth = edge.pstyle('width').pfValue;
    var lineCap = edge.pstyle('line-cap').value;
    var lineOutlineWidth = edge.pstyle('line-outline-width').value;
    var lineOutlineColor = edge.pstyle('line-outline-color').value;
    var effectiveLineOpacity = opacity * lineOpacity;
    // separate arrow opacity would require arrow-opacity property
    var effectiveArrowOpacity = opacity * lineOpacity;
    var drawLine = function drawLine() {
        var strokeOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : effectiveLineOpacity;
        if (curveStyle === 'straight-triangle') {
            r.eleStrokeStyle(context, edge, strokeOpacity);
            r.drawEdgeTrianglePath(edge, context, rs.allpts);
        } else {
            context.lineWidth = edgeWidth;
            context.lineCap = lineCap;
            r.eleStrokeStyle(context, edge, strokeOpacity);
            r.drawEdgePath(edge, context, rs.allpts, lineStyle);
            context.lineCap = 'butt'; // reset for other drawing functions
        }
    };
    var drawLineOutline = function drawLineOutline() {
        var strokeOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : effectiveLineOpacity;
        context.lineWidth = edgeWidth + lineOutlineWidth;
        context.lineCap = lineCap;
        if (lineOutlineWidth > 0) r.colorStrokeStyle(context, lineOutlineColor[0], lineOutlineColor[1], lineOutlineColor[2], strokeOpacity);
        else {
            // do not draw any lineOutline
            context.lineCap = 'butt'; // reset for other drawing functions
            return;
        }
        if (curveStyle === 'straight-triangle') r.drawEdgeTrianglePath(edge, context, rs.allpts);
        else {
            r.drawEdgePath(edge, context, rs.allpts, lineStyle);
            context.lineCap = 'butt'; // reset for other drawing functions
        }
    };
    var drawOverlay = function drawOverlay() {
        if (!shouldDrawOverlay) return;
        r.drawEdgeOverlay(context, edge);
    };
    var drawUnderlay = function drawUnderlay() {
        if (!shouldDrawOverlay) return;
        r.drawEdgeUnderlay(context, edge);
    };
    var drawArrows = function drawArrows() {
        var arrowOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : effectiveArrowOpacity;
        r.drawArrowheads(context, edge, arrowOpacity);
    };
    var drawText = function drawText() {
        r.drawElementText(context, edge, null, drawLabel);
    };
    context.lineJoin = 'round';
    var ghost = edge.pstyle('ghost').value === 'yes';
    if (ghost) {
        var gx = edge.pstyle('ghost-offset-x').pfValue;
        var gy = edge.pstyle('ghost-offset-y').pfValue;
        var ghostOpacity = edge.pstyle('ghost-opacity').value;
        var effectiveGhostOpacity = effectiveLineOpacity * ghostOpacity;
        context.translate(gx, gy);
        drawLine(effectiveGhostOpacity);
        drawArrows(effectiveGhostOpacity);
        context.translate(-gx, -gy);
    } else drawLineOutline();
    drawUnderlay();
    drawLine();
    drawArrows();
    drawOverlay();
    drawText();
    if (shiftToOriginWithBb) context.translate(bb.x1, bb.y1);
};
var $e815fda779bc047b$var$drawEdgeOverlayUnderlay = function drawEdgeOverlayUnderlay(overlayOrUnderlay) {
    if (![
        'overlay',
        'underlay'
    ].includes(overlayOrUnderlay)) throw new Error('Invalid state');
    return function(context, edge) {
        if (!edge.visible()) return;
        var opacity = edge.pstyle("".concat(overlayOrUnderlay, "-opacity")).value;
        if (opacity === 0) return;
        var r = this;
        var usePaths = r.usePaths();
        var rs = edge._private.rscratch;
        var padding = edge.pstyle("".concat(overlayOrUnderlay, "-padding")).pfValue;
        var width = 2 * padding;
        var color = edge.pstyle("".concat(overlayOrUnderlay, "-color")).value;
        context.lineWidth = width;
        if (rs.edgeType === 'self' && !usePaths) context.lineCap = 'butt';
        else context.lineCap = 'round';
        r.colorStrokeStyle(context, color[0], color[1], color[2], opacity);
        r.drawEdgePath(edge, context, rs.allpts, 'solid');
    };
};
$e815fda779bc047b$var$CRp$8.drawEdgeOverlay = $e815fda779bc047b$var$drawEdgeOverlayUnderlay('overlay');
$e815fda779bc047b$var$CRp$8.drawEdgeUnderlay = $e815fda779bc047b$var$drawEdgeOverlayUnderlay('underlay');
$e815fda779bc047b$var$CRp$8.drawEdgePath = function(edge, context, pts, type) {
    var rs = edge._private.rscratch;
    var canvasCxt = context;
    var path;
    var pathCacheHit = false;
    var usePaths = this.usePaths();
    var lineDashPattern = edge.pstyle('line-dash-pattern').pfValue;
    var lineDashOffset = edge.pstyle('line-dash-offset').pfValue;
    if (usePaths) {
        var pathCacheKey = pts.join('$');
        var keyMatches = rs.pathCacheKey && rs.pathCacheKey === pathCacheKey;
        if (keyMatches) {
            path = context = rs.pathCache;
            pathCacheHit = true;
        } else {
            path = context = new Path2D();
            rs.pathCacheKey = pathCacheKey;
            rs.pathCache = path;
        }
    }
    if (canvasCxt.setLineDash) // for very outofdate browsers
    switch(type){
        case 'dotted':
            canvasCxt.setLineDash([
                1,
                1
            ]);
            break;
        case 'dashed':
            canvasCxt.setLineDash(lineDashPattern);
            canvasCxt.lineDashOffset = lineDashOffset;
            break;
        case 'solid':
            canvasCxt.setLineDash([]);
            break;
    }
    if (!pathCacheHit && !rs.badLine) {
        if (context.beginPath) context.beginPath();
        context.moveTo(pts[0], pts[1]);
        switch(rs.edgeType){
            case 'bezier':
            case 'self':
            case 'compound':
            case 'multibezier':
                for(var i = 2; i + 3 < pts.length; i += 4)context.quadraticCurveTo(pts[i], pts[i + 1], pts[i + 2], pts[i + 3]);
                break;
            case 'straight':
            case 'haystack':
                for(var _i = 2; _i + 1 < pts.length; _i += 2)context.lineTo(pts[_i], pts[_i + 1]);
                break;
            case 'segments':
                if (rs.isRound) {
                    var _iterator = $e815fda779bc047b$var$_createForOfIteratorHelper(rs.roundCorners), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var corner = _step.value;
                            $e815fda779bc047b$var$drawPreparedRoundCorner(context, corner);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    context.lineTo(pts[pts.length - 2], pts[pts.length - 1]);
                } else for(var _i2 = 2; _i2 + 1 < pts.length; _i2 += 2)context.lineTo(pts[_i2], pts[_i2 + 1]);
                break;
        }
    }
    context = canvasCxt;
    if (usePaths) context.stroke(path);
    else context.stroke();
    // reset any line dashes
    if (context.setLineDash) // for very outofdate browsers
    context.setLineDash([]);
};
$e815fda779bc047b$var$CRp$8.drawEdgeTrianglePath = function(edge, context, pts) {
    // use line stroke style for triangle fill style
    context.fillStyle = context.strokeStyle;
    var edgeWidth = edge.pstyle('width').pfValue;
    for(var i = 0; i + 1 < pts.length; i += 2){
        var vector = [
            pts[i + 2] - pts[i],
            pts[i + 3] - pts[i + 1]
        ];
        var length = Math.sqrt(vector[0] * vector[0] + vector[1] * vector[1]);
        var normal = [
            vector[1] / length,
            -vector[0] / length
        ];
        var triangleHead = [
            normal[0] * edgeWidth / 2,
            normal[1] * edgeWidth / 2
        ];
        context.beginPath();
        context.moveTo(pts[i] - triangleHead[0], pts[i + 1] - triangleHead[1]);
        context.lineTo(pts[i] + triangleHead[0], pts[i + 1] + triangleHead[1]);
        context.lineTo(pts[i + 2], pts[i + 3]);
        context.closePath();
        context.fill();
    }
};
$e815fda779bc047b$var$CRp$8.drawArrowheads = function(context, edge, opacity) {
    var rs = edge._private.rscratch;
    var isHaystack = rs.edgeType === 'haystack';
    if (!isHaystack) this.drawArrowhead(context, edge, 'source', rs.arrowStartX, rs.arrowStartY, rs.srcArrowAngle, opacity);
    this.drawArrowhead(context, edge, 'mid-target', rs.midX, rs.midY, rs.midtgtArrowAngle, opacity);
    this.drawArrowhead(context, edge, 'mid-source', rs.midX, rs.midY, rs.midsrcArrowAngle, opacity);
    if (!isHaystack) this.drawArrowhead(context, edge, 'target', rs.arrowEndX, rs.arrowEndY, rs.tgtArrowAngle, opacity);
};
$e815fda779bc047b$var$CRp$8.drawArrowhead = function(context, edge, prefix, x, y, angle, opacity) {
    if (isNaN(x) || x == null || isNaN(y) || y == null || isNaN(angle) || angle == null) return;
    var self1 = this;
    var arrowShape = edge.pstyle(prefix + '-arrow-shape').value;
    if (arrowShape === 'none') return;
    var arrowClearFill = edge.pstyle(prefix + '-arrow-fill').value === 'hollow' ? 'both' : 'filled';
    var arrowFill = edge.pstyle(prefix + '-arrow-fill').value;
    var edgeWidth = edge.pstyle('width').pfValue;
    var pArrowWidth = edge.pstyle(prefix + '-arrow-width');
    var arrowWidth = pArrowWidth.value === 'match-line' ? edgeWidth : pArrowWidth.pfValue;
    if (pArrowWidth.units === '%') arrowWidth *= edgeWidth;
    var edgeOpacity = edge.pstyle('opacity').value;
    if (opacity === undefined) opacity = edgeOpacity;
    var gco = context.globalCompositeOperation;
    if (opacity !== 1 || arrowFill === 'hollow') {
        // then extra clear is needed
        context.globalCompositeOperation = 'destination-out';
        self1.colorFillStyle(context, 255, 255, 255, 1);
        self1.colorStrokeStyle(context, 255, 255, 255, 1);
        self1.drawArrowShape(edge, context, arrowClearFill, edgeWidth, arrowShape, arrowWidth, x, y, angle);
        context.globalCompositeOperation = gco;
    } // otherwise, the opaque arrow clears it for free :)
    var color = edge.pstyle(prefix + '-arrow-color').value;
    self1.colorFillStyle(context, color[0], color[1], color[2], opacity);
    self1.colorStrokeStyle(context, color[0], color[1], color[2], opacity);
    self1.drawArrowShape(edge, context, arrowFill, edgeWidth, arrowShape, arrowWidth, x, y, angle);
};
$e815fda779bc047b$var$CRp$8.drawArrowShape = function(edge, context, fill, edgeWidth, shape, shapeWidth, x, y, angle) {
    var r = this;
    var usePaths = this.usePaths() && shape !== 'triangle-cross';
    var pathCacheHit = false;
    var path;
    var canvasContext = context;
    var translation = {
        x: x,
        y: y
    };
    var scale = edge.pstyle('arrow-scale').value;
    var size = this.getArrowWidth(edgeWidth, scale);
    var shapeImpl = r.arrowShapes[shape];
    if (usePaths) {
        var cache = r.arrowPathCache = r.arrowPathCache || [];
        var key = $e815fda779bc047b$var$hashString(shape);
        var cachedPath = cache[key];
        if (cachedPath != null) {
            path = context = cachedPath;
            pathCacheHit = true;
        } else {
            path = context = new Path2D();
            cache[key] = path;
        }
    }
    if (!pathCacheHit) {
        if (context.beginPath) context.beginPath();
        if (usePaths) // store in the path cache with values easily manipulated later
        shapeImpl.draw(context, 1, 0, {
            x: 0,
            y: 0
        }, 1);
        else shapeImpl.draw(context, size, angle, translation, edgeWidth);
        if (context.closePath) context.closePath();
    }
    context = canvasContext;
    if (usePaths) {
        // set transform to arrow position/orientation
        context.translate(x, y);
        context.rotate(angle);
        context.scale(size, size);
    }
    if (fill === 'filled' || fill === 'both') {
        if (usePaths) context.fill(path);
        else context.fill();
    }
    if (fill === 'hollow' || fill === 'both') {
        context.lineWidth = shapeWidth / (usePaths ? size : 1);
        context.lineJoin = 'miter';
        if (usePaths) context.stroke(path);
        else context.stroke();
    }
    if (usePaths) {
        // reset transform by applying inverse
        context.scale(1 / size, 1 / size);
        context.rotate(-angle);
        context.translate(-x, -y);
    }
};
var $e815fda779bc047b$var$CRp$7 = {};
$e815fda779bc047b$var$CRp$7.safeDrawImage = function(context, img, ix, iy, iw, ih, x, y, w, h) {
    // detect problematic cases for old browsers with bad images (cheaper than try-catch)
    if (iw <= 0 || ih <= 0 || w <= 0 || h <= 0) return;
    try {
        context.drawImage(img, ix, iy, iw, ih, x, y, w, h);
    } catch (e) {
        $e815fda779bc047b$var$warn(e);
    }
};
$e815fda779bc047b$var$CRp$7.drawInscribedImage = function(context, img, node, index, nodeOpacity) {
    var r = this;
    var pos = node.position();
    var nodeX = pos.x;
    var nodeY = pos.y;
    var styleObj = node.cy().style();
    var getIndexedStyle = styleObj.getIndexedStyle.bind(styleObj);
    var fit = getIndexedStyle(node, 'background-fit', 'value', index);
    var repeat = getIndexedStyle(node, 'background-repeat', 'value', index);
    var nodeW = node.width();
    var nodeH = node.height();
    var paddingX2 = node.padding() * 2;
    var nodeTW = nodeW + (getIndexedStyle(node, 'background-width-relative-to', 'value', index) === 'inner' ? 0 : paddingX2);
    var nodeTH = nodeH + (getIndexedStyle(node, 'background-height-relative-to', 'value', index) === 'inner' ? 0 : paddingX2);
    var rs = node._private.rscratch;
    var clip = getIndexedStyle(node, 'background-clip', 'value', index);
    var shouldClip = clip === 'node';
    var imgOpacity = getIndexedStyle(node, 'background-image-opacity', 'value', index) * nodeOpacity;
    var smooth = getIndexedStyle(node, 'background-image-smoothing', 'value', index);
    var cornerRadius = node.pstyle('corner-radius').value;
    if (cornerRadius !== 'auto') cornerRadius = node.pstyle('corner-radius').pfValue;
    var imgW = img.width || img.cachedW;
    var imgH = img.height || img.cachedH;
    // workaround for broken browsers like ie
    if (null == imgW || null == imgH) {
        document.body.appendChild(img); // eslint-disable-line no-undef
        imgW = img.cachedW = img.width || img.offsetWidth;
        imgH = img.cachedH = img.height || img.offsetHeight;
        document.body.removeChild(img); // eslint-disable-line no-undef
    }
    var w = imgW;
    var h = imgH;
    if (getIndexedStyle(node, 'background-width', 'value', index) !== 'auto') {
        if (getIndexedStyle(node, 'background-width', 'units', index) === '%') w = getIndexedStyle(node, 'background-width', 'pfValue', index) * nodeTW;
        else w = getIndexedStyle(node, 'background-width', 'pfValue', index);
    }
    if (getIndexedStyle(node, 'background-height', 'value', index) !== 'auto') {
        if (getIndexedStyle(node, 'background-height', 'units', index) === '%') h = getIndexedStyle(node, 'background-height', 'pfValue', index) * nodeTH;
        else h = getIndexedStyle(node, 'background-height', 'pfValue', index);
    }
    if (w === 0 || h === 0) return; // no point in drawing empty image (and chrome is broken in this case)
    if (fit === 'contain') {
        var scale = Math.min(nodeTW / w, nodeTH / h);
        w *= scale;
        h *= scale;
    } else if (fit === 'cover') {
        var scale = Math.max(nodeTW / w, nodeTH / h);
        w *= scale;
        h *= scale;
    }
    var x = nodeX - nodeTW / 2; // left
    var posXUnits = getIndexedStyle(node, 'background-position-x', 'units', index);
    var posXPfVal = getIndexedStyle(node, 'background-position-x', 'pfValue', index);
    if (posXUnits === '%') x += (nodeTW - w) * posXPfVal;
    else x += posXPfVal;
    var offXUnits = getIndexedStyle(node, 'background-offset-x', 'units', index);
    var offXPfVal = getIndexedStyle(node, 'background-offset-x', 'pfValue', index);
    if (offXUnits === '%') x += (nodeTW - w) * offXPfVal;
    else x += offXPfVal;
    var y = nodeY - nodeTH / 2; // top
    var posYUnits = getIndexedStyle(node, 'background-position-y', 'units', index);
    var posYPfVal = getIndexedStyle(node, 'background-position-y', 'pfValue', index);
    if (posYUnits === '%') y += (nodeTH - h) * posYPfVal;
    else y += posYPfVal;
    var offYUnits = getIndexedStyle(node, 'background-offset-y', 'units', index);
    var offYPfVal = getIndexedStyle(node, 'background-offset-y', 'pfValue', index);
    if (offYUnits === '%') y += (nodeTH - h) * offYPfVal;
    else y += offYPfVal;
    if (rs.pathCache) {
        x -= nodeX;
        y -= nodeY;
        nodeX = 0;
        nodeY = 0;
    }
    var gAlpha = context.globalAlpha;
    context.globalAlpha = imgOpacity;
    var smoothingEnabled = r.getImgSmoothing(context);
    var isSmoothingSwitched = false;
    if (smooth === 'no' && smoothingEnabled) {
        r.setImgSmoothing(context, false);
        isSmoothingSwitched = true;
    } else if (smooth === 'yes' && !smoothingEnabled) {
        r.setImgSmoothing(context, true);
        isSmoothingSwitched = true;
    }
    if (repeat === 'no-repeat') {
        if (shouldClip) {
            context.save();
            if (rs.pathCache) context.clip(rs.pathCache);
            else {
                r.nodeShapes[r.getNodeShape(node)].draw(context, nodeX, nodeY, nodeTW, nodeTH, cornerRadius, rs);
                context.clip();
            }
        }
        r.safeDrawImage(context, img, 0, 0, imgW, imgH, x, y, w, h);
        if (shouldClip) context.restore();
    } else {
        var pattern = context.createPattern(img, repeat);
        context.fillStyle = pattern;
        r.nodeShapes[r.getNodeShape(node)].draw(context, nodeX, nodeY, nodeTW, nodeTH, cornerRadius, rs);
        context.translate(x, y);
        context.fill();
        context.translate(-x, -y);
    }
    context.globalAlpha = gAlpha;
    if (isSmoothingSwitched) r.setImgSmoothing(context, smoothingEnabled);
};
var $e815fda779bc047b$var$CRp$6 = {};
$e815fda779bc047b$var$CRp$6.eleTextBiggerThanMin = function(ele, scale) {
    if (!scale) {
        var zoom = ele.cy().zoom();
        var pxRatio = this.getPixelRatio();
        var lvl = Math.ceil($e815fda779bc047b$var$log2(zoom * pxRatio)); // the effective texture level
        scale = Math.pow(2, lvl);
    }
    var computedSize = ele.pstyle('font-size').pfValue * scale;
    var minSize = ele.pstyle('min-zoomed-font-size').pfValue;
    if (computedSize < minSize) return false;
    return true;
};
$e815fda779bc047b$var$CRp$6.drawElementText = function(context, ele, shiftToOriginWithBb, force, prefix) {
    var useEleOpacity = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var r = this;
    if (force == null) {
        if (useEleOpacity && !r.eleTextBiggerThanMin(ele)) return;
    } else if (force === false) return;
    if (ele.isNode()) {
        var label = ele.pstyle('label');
        if (!label || !label.value) return;
        var justification = r.getLabelJustification(ele);
        context.textAlign = justification;
        context.textBaseline = 'bottom';
    } else {
        var badLine = ele.element()._private.rscratch.badLine;
        var _label = ele.pstyle('label');
        var srcLabel = ele.pstyle('source-label');
        var tgtLabel = ele.pstyle('target-label');
        if (badLine || (!_label || !_label.value) && (!srcLabel || !srcLabel.value) && (!tgtLabel || !tgtLabel.value)) return;
        context.textAlign = 'center';
        context.textBaseline = 'bottom';
    }
    var applyRotation = !shiftToOriginWithBb;
    var bb;
    if (shiftToOriginWithBb) {
        bb = shiftToOriginWithBb;
        context.translate(-bb.x1, -bb.y1);
    }
    if (prefix == null) {
        r.drawText(context, ele, null, applyRotation, useEleOpacity);
        if (ele.isEdge()) {
            r.drawText(context, ele, 'source', applyRotation, useEleOpacity);
            r.drawText(context, ele, 'target', applyRotation, useEleOpacity);
        }
    } else r.drawText(context, ele, prefix, applyRotation, useEleOpacity);
    if (shiftToOriginWithBb) context.translate(bb.x1, bb.y1);
};
$e815fda779bc047b$var$CRp$6.getFontCache = function(context) {
    var cache;
    this.fontCaches = this.fontCaches || [];
    for(var i = 0; i < this.fontCaches.length; i++){
        cache = this.fontCaches[i];
        if (cache.context === context) return cache;
    }
    cache = {
        context: context
    };
    this.fontCaches.push(cache);
    return cache;
};
// set up canvas context with font
// returns transformed text string
$e815fda779bc047b$var$CRp$6.setupTextStyle = function(context, ele) {
    var useEleOpacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // Font style
    var labelStyle = ele.pstyle('font-style').strValue;
    var labelSize = ele.pstyle('font-size').pfValue + 'px';
    var labelFamily = ele.pstyle('font-family').strValue;
    var labelWeight = ele.pstyle('font-weight').strValue;
    var opacity = useEleOpacity ? ele.effectiveOpacity() * ele.pstyle('text-opacity').value : 1;
    var outlineOpacity = ele.pstyle('text-outline-opacity').value * opacity;
    var color = ele.pstyle('color').value;
    var outlineColor = ele.pstyle('text-outline-color').value;
    context.font = labelStyle + ' ' + labelWeight + ' ' + labelSize + ' ' + labelFamily;
    context.lineJoin = 'round'; // so text outlines aren't jagged
    this.colorFillStyle(context, color[0], color[1], color[2], opacity);
    this.colorStrokeStyle(context, outlineColor[0], outlineColor[1], outlineColor[2], outlineOpacity);
};
// TODO ensure re-used
function $e815fda779bc047b$var$roundRect(ctx, x, y, width, height) {
    var radius = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 5;
    var stroke = arguments.length > 6 ? arguments[6] : undefined;
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width - radius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    ctx.lineTo(x + width, y + height - radius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    ctx.lineTo(x + radius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
    if (stroke) ctx.stroke();
    else ctx.fill();
}
$e815fda779bc047b$var$CRp$6.getTextAngle = function(ele, prefix) {
    var theta;
    var _p = ele._private;
    var rscratch = _p.rscratch;
    var pdash = prefix ? prefix + '-' : '';
    var rotation = ele.pstyle(pdash + 'text-rotation');
    var textAngle = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelAngle', prefix);
    if (rotation.strValue === 'autorotate') theta = ele.isEdge() ? textAngle : 0;
    else if (rotation.strValue === 'none') theta = 0;
    else theta = rotation.pfValue;
    return theta;
};
$e815fda779bc047b$var$CRp$6.drawText = function(context, ele, prefix) {
    var applyRotation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var useEleOpacity = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var _p = ele._private;
    var rscratch = _p.rscratch;
    var parentOpacity = useEleOpacity ? ele.effectiveOpacity() : 1;
    if (useEleOpacity && (parentOpacity === 0 || ele.pstyle('text-opacity').value === 0)) return;
    // use 'main' as an alias for the main label (i.e. null prefix)
    if (prefix === 'main') prefix = null;
    var textX = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelX', prefix);
    var textY = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelY', prefix);
    var orgTextX, orgTextY; // used for rotation
    var text = this.getLabelText(ele, prefix);
    if (text != null && text !== '' && !isNaN(textX) && !isNaN(textY)) {
        this.setupTextStyle(context, ele, useEleOpacity);
        var pdash = prefix ? prefix + '-' : '';
        var textW = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelWidth', prefix);
        var textH = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelHeight', prefix);
        var marginX = ele.pstyle(pdash + 'text-margin-x').pfValue;
        var marginY = ele.pstyle(pdash + 'text-margin-y').pfValue;
        var isEdge = ele.isEdge();
        var halign = ele.pstyle('text-halign').value;
        var valign = ele.pstyle('text-valign').value;
        if (isEdge) {
            halign = 'center';
            valign = 'center';
        }
        textX += marginX;
        textY += marginY;
        var theta;
        if (!applyRotation) theta = 0;
        else theta = this.getTextAngle(ele, prefix);
        if (theta !== 0) {
            orgTextX = textX;
            orgTextY = textY;
            context.translate(orgTextX, orgTextY);
            context.rotate(theta);
            textX = 0;
            textY = 0;
        }
        switch(valign){
            case 'top':
                break;
            case 'center':
                textY += textH / 2;
                break;
            case 'bottom':
                textY += textH;
                break;
        }
        var backgroundOpacity = ele.pstyle('text-background-opacity').value;
        var borderOpacity = ele.pstyle('text-border-opacity').value;
        var textBorderWidth = ele.pstyle('text-border-width').pfValue;
        var backgroundPadding = ele.pstyle('text-background-padding').pfValue;
        var styleShape = ele.pstyle('text-background-shape').strValue;
        var rounded = styleShape.indexOf('round') === 0;
        var roundRadius = 2;
        if (backgroundOpacity > 0 || textBorderWidth > 0 && borderOpacity > 0) {
            var bgX = textX - backgroundPadding;
            switch(halign){
                case 'left':
                    bgX -= textW;
                    break;
                case 'center':
                    bgX -= textW / 2;
                    break;
            }
            var bgY = textY - textH - backgroundPadding;
            var bgW = textW + 2 * backgroundPadding;
            var bgH = textH + 2 * backgroundPadding;
            if (backgroundOpacity > 0) {
                var textFill = context.fillStyle;
                var textBackgroundColor = ele.pstyle('text-background-color').value;
                context.fillStyle = 'rgba(' + textBackgroundColor[0] + ',' + textBackgroundColor[1] + ',' + textBackgroundColor[2] + ',' + backgroundOpacity * parentOpacity + ')';
                if (rounded) $e815fda779bc047b$var$roundRect(context, bgX, bgY, bgW, bgH, roundRadius);
                else context.fillRect(bgX, bgY, bgW, bgH);
                context.fillStyle = textFill;
            }
            if (textBorderWidth > 0 && borderOpacity > 0) {
                var textStroke = context.strokeStyle;
                var textLineWidth = context.lineWidth;
                var textBorderColor = ele.pstyle('text-border-color').value;
                var textBorderStyle = ele.pstyle('text-border-style').value;
                context.strokeStyle = 'rgba(' + textBorderColor[0] + ',' + textBorderColor[1] + ',' + textBorderColor[2] + ',' + borderOpacity * parentOpacity + ')';
                context.lineWidth = textBorderWidth;
                if (context.setLineDash) // for very outofdate browsers
                switch(textBorderStyle){
                    case 'dotted':
                        context.setLineDash([
                            1,
                            1
                        ]);
                        break;
                    case 'dashed':
                        context.setLineDash([
                            4,
                            2
                        ]);
                        break;
                    case 'double':
                        context.lineWidth = textBorderWidth / 4; // 50% reserved for white between the two borders
                        context.setLineDash([]);
                        break;
                    case 'solid':
                        context.setLineDash([]);
                        break;
                }
                if (rounded) $e815fda779bc047b$var$roundRect(context, bgX, bgY, bgW, bgH, roundRadius, 'stroke');
                else context.strokeRect(bgX, bgY, bgW, bgH);
                if (textBorderStyle === 'double') {
                    var whiteWidth = textBorderWidth / 2;
                    if (rounded) $e815fda779bc047b$var$roundRect(context, bgX + whiteWidth, bgY + whiteWidth, bgW - whiteWidth * 2, bgH - whiteWidth * 2, roundRadius, 'stroke');
                    else context.strokeRect(bgX + whiteWidth, bgY + whiteWidth, bgW - whiteWidth * 2, bgH - whiteWidth * 2);
                }
                if (context.setLineDash) // for very outofdate browsers
                context.setLineDash([]);
                context.lineWidth = textLineWidth;
                context.strokeStyle = textStroke;
            }
        }
        var lineWidth = 2 * ele.pstyle('text-outline-width').pfValue; // *2 b/c the stroke is drawn centred on the middle
        if (lineWidth > 0) context.lineWidth = lineWidth;
        if (ele.pstyle('text-wrap').value === 'wrap') {
            var lines = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelWrapCachedLines', prefix);
            var lineHeight = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelLineHeight', prefix);
            var halfTextW = textW / 2;
            var justification = this.getLabelJustification(ele);
            if (justification === 'auto') ;
            else if (halign === 'left') {
                // auto justification : right
                if (justification === 'left') textX += -textW;
                else if (justification === 'center') textX += -halfTextW;
                 // else same as auto
            } else if (halign === 'center') {
                // auto justfication : center
                if (justification === 'left') textX += -halfTextW;
                else if (justification === 'right') textX += halfTextW;
                 // else same as auto
            } else if (halign === 'right') {
                // auto justification : left
                if (justification === 'center') textX += halfTextW;
                else if (justification === 'right') textX += textW;
                 // else same as auto
            }
            switch(valign){
                case 'top':
                    textY -= (lines.length - 1) * lineHeight;
                    break;
                case 'center':
                case 'bottom':
                    textY -= (lines.length - 1) * lineHeight;
                    break;
            }
            for(var l = 0; l < lines.length; l++){
                if (lineWidth > 0) context.strokeText(lines[l], textX, textY);
                context.fillText(lines[l], textX, textY);
                textY += lineHeight;
            }
        } else {
            if (lineWidth > 0) context.strokeText(text, textX, textY);
            context.fillText(text, textX, textY);
        }
        if (theta !== 0) {
            context.rotate(-theta);
            context.translate(-orgTextX, -orgTextY);
        }
    }
};
/* global Path2D */ var $e815fda779bc047b$var$CRp$5 = {};
$e815fda779bc047b$var$CRp$5.drawNode = function(context, node, shiftToOriginWithBb) {
    var drawLabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var shouldDrawOverlay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var shouldDrawOpacity = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var r = this;
    var nodeWidth, nodeHeight;
    var _p = node._private;
    var rs = _p.rscratch;
    var pos = node.position();
    if (!$e815fda779bc047b$var$number$1(pos.x) || !$e815fda779bc047b$var$number$1(pos.y)) return; // can't draw node with undefined position
    if (shouldDrawOpacity && !node.visible()) return;
    var eleOpacity = shouldDrawOpacity ? node.effectiveOpacity() : 1;
    var usePaths = r.usePaths();
    var path;
    var pathCacheHit = false;
    var padding = node.padding();
    nodeWidth = node.width() + 2 * padding;
    nodeHeight = node.height() + 2 * padding;
    //
    // setup shift
    var bb;
    if (shiftToOriginWithBb) {
        bb = shiftToOriginWithBb;
        context.translate(-bb.x1, -bb.y1);
    }
    //
    // load bg image
    var bgImgProp = node.pstyle('background-image');
    var urls = bgImgProp.value;
    var urlDefined = new Array(urls.length);
    var image = new Array(urls.length);
    var numImages = 0;
    for(var i = 0; i < urls.length; i++){
        var url = urls[i];
        var defd = urlDefined[i] = url != null && url !== 'none';
        if (defd) {
            var bgImgCrossOrigin = node.cy().style().getIndexedStyle(node, 'background-image-crossorigin', 'value', i);
            numImages++;
            // get image, and if not loaded then ask to redraw when later loaded
            image[i] = r.getCachedImage(url, bgImgCrossOrigin, function() {
                _p.backgroundTimestamp = Date.now();
                node.emitAndNotify('background');
            });
        }
    }
    //
    // setup styles
    var darkness = node.pstyle('background-blacken').value;
    var borderWidth = node.pstyle('border-width').pfValue;
    var bgOpacity = node.pstyle('background-opacity').value * eleOpacity;
    var borderColor = node.pstyle('border-color').value;
    var borderStyle = node.pstyle('border-style').value;
    var borderJoin = node.pstyle('border-join').value;
    var borderCap = node.pstyle('border-cap').value;
    var borderPosition = node.pstyle('border-position').value;
    var borderPattern = node.pstyle('border-dash-pattern').pfValue;
    var borderOffset = node.pstyle('border-dash-offset').pfValue;
    var borderOpacity = node.pstyle('border-opacity').value * eleOpacity;
    var outlineWidth = node.pstyle('outline-width').pfValue;
    var outlineColor = node.pstyle('outline-color').value;
    var outlineStyle = node.pstyle('outline-style').value;
    var outlineOpacity = node.pstyle('outline-opacity').value * eleOpacity;
    var outlineOffset = node.pstyle('outline-offset').value;
    var cornerRadius = node.pstyle('corner-radius').value;
    if (cornerRadius !== 'auto') cornerRadius = node.pstyle('corner-radius').pfValue;
    var setupShapeColor = function setupShapeColor() {
        var bgOpy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bgOpacity;
        r.eleFillStyle(context, node, bgOpy);
    };
    var setupBorderColor = function setupBorderColor() {
        var bdrOpy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : borderOpacity;
        r.colorStrokeStyle(context, borderColor[0], borderColor[1], borderColor[2], bdrOpy);
    };
    var setupOutlineColor = function setupOutlineColor() {
        var otlnOpy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : outlineOpacity;
        r.colorStrokeStyle(context, outlineColor[0], outlineColor[1], outlineColor[2], otlnOpy);
    };
    //
    // setup shape
    var getPath = function getPath(width, height, shape, points) {
        var pathCache = r.nodePathCache = r.nodePathCache || [];
        var key = $e815fda779bc047b$var$hashStrings(shape === 'polygon' ? shape + ',' + points.join(',') : shape, '' + height, '' + width, '' + cornerRadius);
        var cachedPath = pathCache[key];
        var path;
        var cacheHit = false;
        if (cachedPath != null) {
            path = cachedPath;
            cacheHit = true;
            rs.pathCache = path;
        } else {
            path = new Path2D();
            pathCache[key] = rs.pathCache = path;
        }
        return {
            path: path,
            cacheHit: cacheHit
        };
    };
    var styleShape = node.pstyle('shape').strValue;
    var shapePts = node.pstyle('shape-polygon-points').pfValue;
    if (usePaths) {
        context.translate(pos.x, pos.y);
        var shapePath = getPath(nodeWidth, nodeHeight, styleShape, shapePts);
        path = shapePath.path;
        pathCacheHit = shapePath.cacheHit;
    }
    var drawShape = function drawShape() {
        if (!pathCacheHit) {
            var npos = pos;
            if (usePaths) npos = {
                x: 0,
                y: 0
            };
            r.nodeShapes[r.getNodeShape(node)].draw(path || context, npos.x, npos.y, nodeWidth, nodeHeight, cornerRadius, rs);
        }
        if (usePaths) context.fill(path);
        else context.fill();
    };
    var drawImages = function drawImages() {
        var nodeOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eleOpacity;
        var inside = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var prevBging = _p.backgrounding;
        var totalCompleted = 0;
        for(var _i = 0; _i < image.length; _i++){
            var bgContainment = node.cy().style().getIndexedStyle(node, 'background-image-containment', 'value', _i);
            if (inside && bgContainment === 'over' || !inside && bgContainment === 'inside') {
                totalCompleted++;
                continue;
            }
            if (urlDefined[_i] && image[_i].complete && !image[_i].error) {
                totalCompleted++;
                r.drawInscribedImage(context, image[_i], node, _i, nodeOpacity);
            }
        }
        _p.backgrounding = !(totalCompleted === numImages);
        if (prevBging !== _p.backgrounding) // update style b/c :backgrounding state changed
        node.updateStyle(false);
    };
    var drawPie = function drawPie() {
        var redrawShape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var pieOpacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : eleOpacity;
        if (r.hasPie(node)) {
            r.drawPie(context, node, pieOpacity);
            // redraw/restore path if steps after pie need it
            if (redrawShape) {
                if (!usePaths) r.nodeShapes[r.getNodeShape(node)].draw(context, pos.x, pos.y, nodeWidth, nodeHeight, cornerRadius, rs);
            }
        }
    };
    var darken = function darken() {
        var darkenOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eleOpacity;
        var opacity = (darkness > 0 ? darkness : -darkness) * darkenOpacity;
        var c = darkness > 0 ? 0 : 255;
        if (darkness !== 0) {
            r.colorFillStyle(context, c, c, c, opacity);
            if (usePaths) context.fill(path);
            else context.fill();
        }
    };
    var drawBorder = function drawBorder() {
        if (borderWidth > 0) {
            context.lineWidth = borderWidth;
            context.lineCap = borderCap;
            context.lineJoin = borderJoin;
            if (context.setLineDash) // for very outofdate browsers
            switch(borderStyle){
                case 'dotted':
                    context.setLineDash([
                        1,
                        1
                    ]);
                    break;
                case 'dashed':
                    context.setLineDash(borderPattern);
                    context.lineDashOffset = borderOffset;
                    break;
                case 'solid':
                case 'double':
                    context.setLineDash([]);
                    break;
            }
            if (borderPosition !== 'center') {
                context.save();
                context.lineWidth *= 2;
                if (borderPosition === 'inside') usePaths ? context.clip(path) : context.clip();
                else {
                    var region = new Path2D();
                    region.rect(-nodeWidth / 2 - borderWidth, -nodeHeight / 2 - borderWidth, nodeWidth + 2 * borderWidth, nodeHeight + 2 * borderWidth);
                    region.addPath(path);
                    context.clip(region, 'evenodd');
                }
                usePaths ? context.stroke(path) : context.stroke();
                context.restore();
            } else usePaths ? context.stroke(path) : context.stroke();
            if (borderStyle === 'double') {
                context.lineWidth = borderWidth / 3;
                var gco = context.globalCompositeOperation;
                context.globalCompositeOperation = 'destination-out';
                if (usePaths) context.stroke(path);
                else context.stroke();
                context.globalCompositeOperation = gco;
            }
            // reset in case we changed the border style
            if (context.setLineDash) // for very outofdate browsers
            context.setLineDash([]);
        }
    };
    var drawOutline = function drawOutline() {
        if (outlineWidth > 0) {
            context.lineWidth = outlineWidth;
            context.lineCap = 'butt';
            if (context.setLineDash) // for very outofdate browsers
            switch(outlineStyle){
                case 'dotted':
                    context.setLineDash([
                        1,
                        1
                    ]);
                    break;
                case 'dashed':
                    context.setLineDash([
                        4,
                        2
                    ]);
                    break;
                case 'solid':
                case 'double':
                    context.setLineDash([]);
                    break;
            }
            var npos = pos;
            if (usePaths) npos = {
                x: 0,
                y: 0
            };
            var shape = r.getNodeShape(node);
            var bWidth = borderWidth;
            if (borderPosition === 'inside') bWidth = 0;
            if (borderPosition === 'outside') bWidth *= 2;
            var scaleX = (nodeWidth + bWidth + (outlineWidth + outlineOffset)) / nodeWidth;
            var scaleY = (nodeHeight + bWidth + (outlineWidth + outlineOffset)) / nodeHeight;
            var sWidth = nodeWidth * scaleX;
            var sHeight = nodeHeight * scaleY;
            var points = r.nodeShapes[shape].points;
            var _path;
            if (usePaths) {
                var outlinePath = getPath(sWidth, sHeight, shape, points);
                _path = outlinePath.path;
            }
            // draw the outline path, either by using expanded points or by scaling 
            // the dimensions, depending on shape
            if (shape === "ellipse") r.drawEllipsePath(_path || context, npos.x, npos.y, sWidth, sHeight);
            else if ([
                'round-diamond',
                'round-heptagon',
                'round-hexagon',
                'round-octagon',
                'round-pentagon',
                'round-polygon',
                'round-triangle',
                'round-tag'
            ].includes(shape)) {
                var sMult = 0;
                var offsetX = 0;
                var offsetY = 0;
                if (shape === 'round-diamond') sMult = (bWidth + outlineOffset + outlineWidth) * 1.4;
                else if (shape === 'round-heptagon') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * 1.075;
                    offsetY = -(bWidth / 2 + outlineOffset + outlineWidth) / 35;
                } else if (shape === 'round-hexagon') sMult = (bWidth + outlineOffset + outlineWidth) * 1.12;
                else if (shape === 'round-pentagon') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * 1.13;
                    offsetY = -(bWidth / 2 + outlineOffset + outlineWidth) / 15;
                } else if (shape === 'round-tag') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * 1.12;
                    offsetX = (bWidth / 2 + outlineWidth + outlineOffset) * .07;
                } else if (shape === 'round-triangle') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * (Math.PI / 2);
                    offsetY = -(bWidth + outlineOffset / 2 + outlineWidth) / Math.PI;
                }
                if (sMult !== 0) {
                    scaleX = (nodeWidth + sMult) / nodeWidth;
                    sWidth = nodeWidth * scaleX;
                    if (![
                        'round-hexagon',
                        'round-tag'
                    ].includes(shape)) {
                        scaleY = (nodeHeight + sMult) / nodeHeight;
                        sHeight = nodeHeight * scaleY;
                    }
                }
                cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundPolygonRadius(sWidth, sHeight) : cornerRadius;
                var halfW = sWidth / 2;
                var halfH = sHeight / 2;
                var radius = cornerRadius + (bWidth + outlineWidth + outlineOffset) / 2;
                var p = new Array(points.length / 2);
                var corners = new Array(points.length / 2);
                for(var _i3 = 0; _i3 < points.length / 2; _i3++)p[_i3] = {
                    x: npos.x + offsetX + halfW * points[_i3 * 2],
                    y: npos.y + offsetY + halfH * points[_i3 * 2 + 1]
                };
                var _i2, p1, p2, p3, len = p.length;
                p1 = p[len - 1];
                // for each point
                for(_i2 = 0; _i2 < len; _i2++){
                    p2 = p[_i2 % len];
                    p3 = p[(_i2 + 1) % len];
                    corners[_i2] = $e815fda779bc047b$var$getRoundCorner(p1, p2, p3, radius);
                    p1 = p2;
                    p2 = p3;
                }
                r.drawRoundPolygonPath(_path || context, npos.x + offsetX, npos.y + offsetY, nodeWidth * scaleX, nodeHeight * scaleY, points, corners);
            } else if ([
                'roundrectangle',
                'round-rectangle'
            ].includes(shape)) {
                cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(sWidth, sHeight) : cornerRadius;
                r.drawRoundRectanglePath(_path || context, npos.x, npos.y, sWidth, sHeight, cornerRadius + (bWidth + outlineWidth + outlineOffset) / 2);
            } else if ([
                'cutrectangle',
                'cut-rectangle'
            ].includes(shape)) {
                cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getCutRectangleCornerLength() : cornerRadius;
                r.drawCutRectanglePath(_path || context, npos.x, npos.y, sWidth, sHeight, null, cornerRadius + (bWidth + outlineWidth + outlineOffset) / 4);
            } else if ([
                'bottomroundrectangle',
                'bottom-round-rectangle'
            ].includes(shape)) {
                cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(sWidth, sHeight) : cornerRadius;
                r.drawBottomRoundRectanglePath(_path || context, npos.x, npos.y, sWidth, sHeight, cornerRadius + (bWidth + outlineWidth + outlineOffset) / 2);
            } else if (shape === "barrel") r.drawBarrelPath(_path || context, npos.x, npos.y, sWidth, sHeight);
            else if (shape.startsWith("polygon") || [
                'rhomboid',
                'right-rhomboid',
                'round-tag',
                'tag',
                'vee'
            ].includes(shape)) {
                var pad = (bWidth + outlineWidth + outlineOffset) / nodeWidth;
                points = $e815fda779bc047b$var$joinLines($e815fda779bc047b$var$expandPolygon(points, pad));
                r.drawPolygonPath(_path || context, npos.x, npos.y, nodeWidth, nodeHeight, points);
            } else {
                var _pad = (bWidth + outlineWidth + outlineOffset) / nodeWidth;
                points = $e815fda779bc047b$var$joinLines($e815fda779bc047b$var$expandPolygon(points, -_pad));
                r.drawPolygonPath(_path || context, npos.x, npos.y, nodeWidth, nodeHeight, points);
            }
            if (usePaths) context.stroke(_path);
            else context.stroke();
            if (outlineStyle === 'double') {
                context.lineWidth = bWidth / 3;
                var gco = context.globalCompositeOperation;
                context.globalCompositeOperation = 'destination-out';
                if (usePaths) context.stroke(_path);
                else context.stroke();
                context.globalCompositeOperation = gco;
            }
            // reset in case we changed the border style
            if (context.setLineDash) // for very outofdate browsers
            context.setLineDash([]);
        }
    };
    var drawOverlay = function drawOverlay() {
        if (shouldDrawOverlay) r.drawNodeOverlay(context, node, pos, nodeWidth, nodeHeight);
    };
    var drawUnderlay = function drawUnderlay() {
        if (shouldDrawOverlay) r.drawNodeUnderlay(context, node, pos, nodeWidth, nodeHeight);
    };
    var drawText = function drawText() {
        r.drawElementText(context, node, null, drawLabel);
    };
    var ghost = node.pstyle('ghost').value === 'yes';
    if (ghost) {
        var gx = node.pstyle('ghost-offset-x').pfValue;
        var gy = node.pstyle('ghost-offset-y').pfValue;
        var ghostOpacity = node.pstyle('ghost-opacity').value;
        var effGhostOpacity = ghostOpacity * eleOpacity;
        context.translate(gx, gy);
        setupOutlineColor();
        drawOutline();
        setupShapeColor(ghostOpacity * bgOpacity);
        drawShape();
        drawImages(effGhostOpacity, true);
        setupBorderColor(ghostOpacity * borderOpacity);
        drawBorder();
        drawPie(darkness !== 0 || borderWidth !== 0);
        drawImages(effGhostOpacity, false);
        darken(effGhostOpacity);
        context.translate(-gx, -gy);
    }
    if (usePaths) context.translate(-pos.x, -pos.y);
    drawUnderlay();
    if (usePaths) context.translate(pos.x, pos.y);
    setupOutlineColor();
    drawOutline();
    setupShapeColor();
    drawShape();
    drawImages(eleOpacity, true);
    setupBorderColor();
    drawBorder();
    drawPie(darkness !== 0 || borderWidth !== 0);
    drawImages(eleOpacity, false);
    darken();
    if (usePaths) context.translate(-pos.x, -pos.y);
    drawText();
    drawOverlay();
    //
    // clean up shift
    if (shiftToOriginWithBb) context.translate(bb.x1, bb.y1);
};
var $e815fda779bc047b$var$drawNodeOverlayUnderlay = function drawNodeOverlayUnderlay(overlayOrUnderlay) {
    if (![
        'overlay',
        'underlay'
    ].includes(overlayOrUnderlay)) throw new Error('Invalid state');
    return function(context, node, pos, nodeWidth, nodeHeight) {
        var r = this;
        if (!node.visible()) return;
        var padding = node.pstyle("".concat(overlayOrUnderlay, "-padding")).pfValue;
        var opacity = node.pstyle("".concat(overlayOrUnderlay, "-opacity")).value;
        var color = node.pstyle("".concat(overlayOrUnderlay, "-color")).value;
        var shape = node.pstyle("".concat(overlayOrUnderlay, "-shape")).value;
        var radius = node.pstyle("".concat(overlayOrUnderlay, "-corner-radius")).value;
        if (opacity > 0) {
            pos = pos || node.position();
            if (nodeWidth == null || nodeHeight == null) {
                var _padding = node.padding();
                nodeWidth = node.width() + 2 * _padding;
                nodeHeight = node.height() + 2 * _padding;
            }
            r.colorFillStyle(context, color[0], color[1], color[2], opacity);
            r.nodeShapes[shape].draw(context, pos.x, pos.y, nodeWidth + padding * 2, nodeHeight + padding * 2, radius);
            context.fill();
        }
    };
};
$e815fda779bc047b$var$CRp$5.drawNodeOverlay = $e815fda779bc047b$var$drawNodeOverlayUnderlay('overlay');
$e815fda779bc047b$var$CRp$5.drawNodeUnderlay = $e815fda779bc047b$var$drawNodeOverlayUnderlay('underlay');
// does the node have at least one pie piece?
$e815fda779bc047b$var$CRp$5.hasPie = function(node) {
    node = node[0]; // ensure ele ref
    return node._private.hasPie;
};
$e815fda779bc047b$var$CRp$5.drawPie = function(context, node, nodeOpacity, pos) {
    node = node[0]; // ensure ele ref
    pos = pos || node.position();
    var cyStyle = node.cy().style();
    var pieSize = node.pstyle('pie-size');
    var x = pos.x;
    var y = pos.y;
    var nodeW = node.width();
    var nodeH = node.height();
    var radius = Math.min(nodeW, nodeH) / 2; // must fit in node
    var lastPercent = 0; // what % to continue drawing pie slices from on [0, 1]
    var usePaths = this.usePaths();
    if (usePaths) {
        x = 0;
        y = 0;
    }
    if (pieSize.units === '%') radius = radius * pieSize.pfValue;
    else if (pieSize.pfValue !== undefined) radius = pieSize.pfValue / 2;
    for(var i = 1; i <= cyStyle.pieBackgroundN; i++){
        // 1..N
        var size = node.pstyle('pie-' + i + '-background-size').value;
        var color = node.pstyle('pie-' + i + '-background-color').value;
        var opacity = node.pstyle('pie-' + i + '-background-opacity').value * nodeOpacity;
        var percent = size / 100; // map integer range [0, 100] to [0, 1]
        // percent can't push beyond 1
        if (percent + lastPercent > 1) percent = 1 - lastPercent;
        var angleStart = 1.5 * Math.PI + 2 * Math.PI * lastPercent; // start at 12 o'clock and go clockwise
        var angleDelta = 2 * Math.PI * percent;
        var angleEnd = angleStart + angleDelta;
        // ignore if
        // - zero size
        // - we're already beyond the full circle
        // - adding the current slice would go beyond the full circle
        if (size === 0 || lastPercent >= 1 || lastPercent + percent > 1) continue;
        context.beginPath();
        context.moveTo(x, y);
        context.arc(x, y, radius, angleStart, angleEnd);
        context.closePath();
        this.colorFillStyle(context, color[0], color[1], color[2], opacity);
        context.fill();
        lastPercent += percent;
    }
};
var $e815fda779bc047b$var$CRp$4 = {};
var $e815fda779bc047b$var$motionBlurDelay = 100;
// var isFirefox = typeof InstallTrigger !== 'undefined';
$e815fda779bc047b$var$CRp$4.getPixelRatio = function() {
    var context = this.data.contexts[0];
    if (this.forcedPixelRatio != null) return this.forcedPixelRatio;
    var containerWindow = this.cy.window();
    var backingStore = context.backingStorePixelRatio || context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
    return (containerWindow.devicePixelRatio || 1) / backingStore; // eslint-disable-line no-undef
};
$e815fda779bc047b$var$CRp$4.paintCache = function(context) {
    var caches = this.paintCaches = this.paintCaches || [];
    var needToCreateCache = true;
    var cache;
    for(var i = 0; i < caches.length; i++){
        cache = caches[i];
        if (cache.context === context) {
            needToCreateCache = false;
            break;
        }
    }
    if (needToCreateCache) {
        cache = {
            context: context
        };
        caches.push(cache);
    }
    return cache;
};
$e815fda779bc047b$var$CRp$4.createGradientStyleFor = function(context, shapeStyleName, ele, fill, opacity) {
    var gradientStyle;
    var usePaths = this.usePaths();
    var colors = ele.pstyle(shapeStyleName + '-gradient-stop-colors').value, positions = ele.pstyle(shapeStyleName + '-gradient-stop-positions').pfValue;
    if (fill === 'radial-gradient') {
        if (ele.isEdge()) {
            var start = ele.sourceEndpoint(), end = ele.targetEndpoint(), mid = ele.midpoint();
            var d1 = $e815fda779bc047b$var$dist(start, mid);
            var d2 = $e815fda779bc047b$var$dist(end, mid);
            gradientStyle = context.createRadialGradient(mid.x, mid.y, 0, mid.x, mid.y, Math.max(d1, d2));
        } else {
            var pos = usePaths ? {
                x: 0,
                y: 0
            } : ele.position(), width = ele.paddedWidth(), height = ele.paddedHeight();
            gradientStyle = context.createRadialGradient(pos.x, pos.y, 0, pos.x, pos.y, Math.max(width, height));
        }
    } else if (ele.isEdge()) {
        var _start = ele.sourceEndpoint(), _end = ele.targetEndpoint();
        gradientStyle = context.createLinearGradient(_start.x, _start.y, _end.x, _end.y);
    } else {
        var _pos = usePaths ? {
            x: 0,
            y: 0
        } : ele.position(), _width = ele.paddedWidth(), _height = ele.paddedHeight(), halfWidth = _width / 2, halfHeight = _height / 2;
        var direction = ele.pstyle('background-gradient-direction').value;
        switch(direction){
            case 'to-bottom':
                gradientStyle = context.createLinearGradient(_pos.x, _pos.y - halfHeight, _pos.x, _pos.y + halfHeight);
                break;
            case 'to-top':
                gradientStyle = context.createLinearGradient(_pos.x, _pos.y + halfHeight, _pos.x, _pos.y - halfHeight);
                break;
            case 'to-left':
                gradientStyle = context.createLinearGradient(_pos.x + halfWidth, _pos.y, _pos.x - halfWidth, _pos.y);
                break;
            case 'to-right':
                gradientStyle = context.createLinearGradient(_pos.x - halfWidth, _pos.y, _pos.x + halfWidth, _pos.y);
                break;
            case 'to-bottom-right':
            case 'to-right-bottom':
                gradientStyle = context.createLinearGradient(_pos.x - halfWidth, _pos.y - halfHeight, _pos.x + halfWidth, _pos.y + halfHeight);
                break;
            case 'to-top-right':
            case 'to-right-top':
                gradientStyle = context.createLinearGradient(_pos.x - halfWidth, _pos.y + halfHeight, _pos.x + halfWidth, _pos.y - halfHeight);
                break;
            case 'to-bottom-left':
            case 'to-left-bottom':
                gradientStyle = context.createLinearGradient(_pos.x + halfWidth, _pos.y - halfHeight, _pos.x - halfWidth, _pos.y + halfHeight);
                break;
            case 'to-top-left':
            case 'to-left-top':
                gradientStyle = context.createLinearGradient(_pos.x + halfWidth, _pos.y + halfHeight, _pos.x - halfWidth, _pos.y - halfHeight);
                break;
        }
    }
    if (!gradientStyle) return null; // invalid gradient style
    var hasPositions = positions.length === colors.length;
    var length = colors.length;
    for(var i = 0; i < length; i++)gradientStyle.addColorStop(hasPositions ? positions[i] : i / (length - 1), 'rgba(' + colors[i][0] + ',' + colors[i][1] + ',' + colors[i][2] + ',' + opacity + ')');
    return gradientStyle;
};
$e815fda779bc047b$var$CRp$4.gradientFillStyle = function(context, ele, fill, opacity) {
    var gradientStyle = this.createGradientStyleFor(context, 'background', ele, fill, opacity);
    if (!gradientStyle) return null; // error
    context.fillStyle = gradientStyle;
};
$e815fda779bc047b$var$CRp$4.colorFillStyle = function(context, r, g, b, a) {
    context.fillStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// turn off for now, seems context does its own caching
// var cache = this.paintCache(context);
// var fillStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// if( cache.fillStyle !== fillStyle ){
//   context.fillStyle = cache.fillStyle = fillStyle;
// }
};
$e815fda779bc047b$var$CRp$4.eleFillStyle = function(context, ele, opacity) {
    var backgroundFill = ele.pstyle('background-fill').value;
    if (backgroundFill === 'linear-gradient' || backgroundFill === 'radial-gradient') this.gradientFillStyle(context, ele, backgroundFill, opacity);
    else {
        var backgroundColor = ele.pstyle('background-color').value;
        this.colorFillStyle(context, backgroundColor[0], backgroundColor[1], backgroundColor[2], opacity);
    }
};
$e815fda779bc047b$var$CRp$4.gradientStrokeStyle = function(context, ele, fill, opacity) {
    var gradientStyle = this.createGradientStyleFor(context, 'line', ele, fill, opacity);
    if (!gradientStyle) return null; // error
    context.strokeStyle = gradientStyle;
};
$e815fda779bc047b$var$CRp$4.colorStrokeStyle = function(context, r, g, b, a) {
    context.strokeStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// turn off for now, seems context does its own caching
// var cache = this.paintCache(context);
// var strokeStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// if( cache.strokeStyle !== strokeStyle ){
//   context.strokeStyle = cache.strokeStyle = strokeStyle;
// }
};
$e815fda779bc047b$var$CRp$4.eleStrokeStyle = function(context, ele, opacity) {
    var lineFill = ele.pstyle('line-fill').value;
    if (lineFill === 'linear-gradient' || lineFill === 'radial-gradient') this.gradientStrokeStyle(context, ele, lineFill, opacity);
    else {
        var lineColor = ele.pstyle('line-color').value;
        this.colorStrokeStyle(context, lineColor[0], lineColor[1], lineColor[2], opacity);
    }
};
// Resize canvas
$e815fda779bc047b$var$CRp$4.matchCanvasSize = function(container) {
    var r = this;
    var data = r.data;
    var bb = r.findContainerClientCoords();
    var width = bb[2];
    var height = bb[3];
    var pixelRatio = r.getPixelRatio();
    var mbPxRatio = r.motionBlurPxRatio;
    if (container === r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_NODE] || container === r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_DRAG]) pixelRatio = mbPxRatio;
    var canvasWidth = width * pixelRatio;
    var canvasHeight = height * pixelRatio;
    var canvas;
    if (canvasWidth === r.canvasWidth && canvasHeight === r.canvasHeight) return; // save cycles if same
    r.fontCaches = null; // resizing resets the style
    var canvasContainer = data.canvasContainer;
    canvasContainer.style.width = width + 'px';
    canvasContainer.style.height = height + 'px';
    for(var i = 0; i < r.CANVAS_LAYERS; i++){
        canvas = data.canvases[i];
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
    }
    for(var i = 0; i < r.BUFFER_COUNT; i++){
        canvas = data.bufferCanvases[i];
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
    }
    r.textureMult = 1;
    if (pixelRatio <= 1) {
        canvas = data.bufferCanvases[r.TEXTURE_BUFFER];
        r.textureMult = 2;
        canvas.width = canvasWidth * r.textureMult;
        canvas.height = canvasHeight * r.textureMult;
    }
    r.canvasWidth = canvasWidth;
    r.canvasHeight = canvasHeight;
};
$e815fda779bc047b$var$CRp$4.renderTo = function(cxt, zoom, pan, pxRatio) {
    this.render({
        forcedContext: cxt,
        forcedZoom: zoom,
        forcedPan: pan,
        drawAllLayers: true,
        forcedPxRatio: pxRatio
    });
};
$e815fda779bc047b$var$CRp$4.render = function(options) {
    options = options || $e815fda779bc047b$var$staticEmptyObject();
    var forcedContext = options.forcedContext;
    var drawAllLayers = options.drawAllLayers;
    var drawOnlyNodeLayer = options.drawOnlyNodeLayer;
    var forcedZoom = options.forcedZoom;
    var forcedPan = options.forcedPan;
    var r = this;
    var pixelRatio = options.forcedPxRatio === undefined ? this.getPixelRatio() : options.forcedPxRatio;
    var cy = r.cy;
    var data = r.data;
    var needDraw = data.canvasNeedsRedraw;
    var textureDraw = r.textureOnViewport && !forcedContext && (r.pinching || r.hoverData.dragging || r.swipePanning || r.data.wheelZooming);
    var motionBlur = options.motionBlur !== undefined ? options.motionBlur : r.motionBlur;
    var mbPxRatio = r.motionBlurPxRatio;
    var hasCompoundNodes = cy.hasCompoundNodes();
    var inNodeDragGesture = r.hoverData.draggingEles;
    var inBoxSelection = r.hoverData.selecting || r.touchData.selecting ? true : false;
    motionBlur = motionBlur && !forcedContext && r.motionBlurEnabled && !inBoxSelection;
    var motionBlurFadeEffect = motionBlur;
    if (!forcedContext) {
        if (r.prevPxRatio !== pixelRatio) {
            r.invalidateContainerClientCoordsCache();
            r.matchCanvasSize(r.container);
            r.redrawHint('eles', true);
            r.redrawHint('drag', true);
        }
        r.prevPxRatio = pixelRatio;
    }
    if (!forcedContext && r.motionBlurTimeout) clearTimeout(r.motionBlurTimeout);
    if (motionBlur) {
        if (r.mbFrames == null) r.mbFrames = 0;
        r.mbFrames++;
        if (r.mbFrames < 3) // need several frames before even high quality motionblur
        motionBlurFadeEffect = false;
        // go to lower quality blurry frames when several m/b frames have been rendered (avoids flashing)
        if (r.mbFrames > r.minMbLowQualFrames) //r.fullQualityMb = false;
        r.motionBlurPxRatio = r.mbPxRBlurry;
    }
    if (r.clearingMotionBlur) r.motionBlurPxRatio = 1;
    // b/c drawToContext() may be async w.r.t. redraw(), keep track of last texture frame
    // because a rogue async texture frame would clear needDraw
    if (r.textureDrawLastFrame && !textureDraw) {
        needDraw[r.NODE] = true;
        needDraw[r.SELECT_BOX] = true;
    }
    var style = cy.style();
    var zoom = cy.zoom();
    var effectiveZoom = forcedZoom !== undefined ? forcedZoom : zoom;
    var pan = cy.pan();
    var effectivePan = {
        x: pan.x,
        y: pan.y
    };
    var vp = {
        zoom: zoom,
        pan: {
            x: pan.x,
            y: pan.y
        }
    };
    var prevVp = r.prevViewport;
    var viewportIsDiff = prevVp === undefined || vp.zoom !== prevVp.zoom || vp.pan.x !== prevVp.pan.x || vp.pan.y !== prevVp.pan.y;
    // we want the low quality motionblur only when the viewport is being manipulated etc (where it's not noticed)
    if (!viewportIsDiff && !(inNodeDragGesture && !hasCompoundNodes)) r.motionBlurPxRatio = 1;
    if (forcedPan) effectivePan = forcedPan;
    // apply pixel ratio
    effectiveZoom *= pixelRatio;
    effectivePan.x *= pixelRatio;
    effectivePan.y *= pixelRatio;
    var eles = r.getCachedZSortedEles();
    function mbclear(context, x, y, w, h) {
        var gco = context.globalCompositeOperation;
        context.globalCompositeOperation = 'destination-out';
        r.colorFillStyle(context, 255, 255, 255, r.motionBlurTransparency);
        context.fillRect(x, y, w, h);
        context.globalCompositeOperation = gco;
    }
    function setContextTransform(context, clear) {
        var ePan, eZoom, w, h;
        if (!r.clearingMotionBlur && (context === data.bufferContexts[r.MOTIONBLUR_BUFFER_NODE] || context === data.bufferContexts[r.MOTIONBLUR_BUFFER_DRAG])) {
            ePan = {
                x: pan.x * mbPxRatio,
                y: pan.y * mbPxRatio
            };
            eZoom = zoom * mbPxRatio;
            w = r.canvasWidth * mbPxRatio;
            h = r.canvasHeight * mbPxRatio;
        } else {
            ePan = effectivePan;
            eZoom = effectiveZoom;
            w = r.canvasWidth;
            h = r.canvasHeight;
        }
        context.setTransform(1, 0, 0, 1, 0, 0);
        if (clear === 'motionBlur') mbclear(context, 0, 0, w, h);
        else if (!forcedContext && (clear === undefined || clear)) context.clearRect(0, 0, w, h);
        if (!drawAllLayers) {
            context.translate(ePan.x, ePan.y);
            context.scale(eZoom, eZoom);
        }
        if (forcedPan) context.translate(forcedPan.x, forcedPan.y);
        if (forcedZoom) context.scale(forcedZoom, forcedZoom);
    }
    if (!textureDraw) r.textureDrawLastFrame = false;
    if (textureDraw) {
        r.textureDrawLastFrame = true;
        if (!r.textureCache) {
            r.textureCache = {};
            r.textureCache.bb = cy.mutableElements().boundingBox();
            r.textureCache.texture = r.data.bufferCanvases[r.TEXTURE_BUFFER];
            var cxt = r.data.bufferContexts[r.TEXTURE_BUFFER];
            cxt.setTransform(1, 0, 0, 1, 0, 0);
            cxt.clearRect(0, 0, r.canvasWidth * r.textureMult, r.canvasHeight * r.textureMult);
            r.render({
                forcedContext: cxt,
                drawOnlyNodeLayer: true,
                forcedPxRatio: pixelRatio * r.textureMult
            });
            var vp = r.textureCache.viewport = {
                zoom: cy.zoom(),
                pan: cy.pan(),
                width: r.canvasWidth,
                height: r.canvasHeight
            };
            vp.mpan = {
                x: (0 - vp.pan.x) / vp.zoom,
                y: (0 - vp.pan.y) / vp.zoom
            };
        }
        needDraw[r.DRAG] = false;
        needDraw[r.NODE] = false;
        var context = data.contexts[r.NODE];
        var texture = r.textureCache.texture;
        var vp = r.textureCache.viewport;
        context.setTransform(1, 0, 0, 1, 0, 0);
        if (motionBlur) mbclear(context, 0, 0, vp.width, vp.height);
        else context.clearRect(0, 0, vp.width, vp.height);
        var outsideBgColor = style.core('outside-texture-bg-color').value;
        var outsideBgOpacity = style.core('outside-texture-bg-opacity').value;
        r.colorFillStyle(context, outsideBgColor[0], outsideBgColor[1], outsideBgColor[2], outsideBgOpacity);
        context.fillRect(0, 0, vp.width, vp.height);
        var zoom = cy.zoom();
        setContextTransform(context, false);
        context.clearRect(vp.mpan.x, vp.mpan.y, vp.width / vp.zoom / pixelRatio, vp.height / vp.zoom / pixelRatio);
        context.drawImage(texture, vp.mpan.x, vp.mpan.y, vp.width / vp.zoom / pixelRatio, vp.height / vp.zoom / pixelRatio);
    } else if (r.textureOnViewport && !forcedContext) // clear the cache since we don't need it
    r.textureCache = null;
    var extent = cy.extent();
    var vpManip = r.pinching || r.hoverData.dragging || r.swipePanning || r.data.wheelZooming || r.hoverData.draggingEles || r.cy.animated();
    var hideEdges = r.hideEdgesOnViewport && vpManip;
    var needMbClear = [];
    needMbClear[r.NODE] = !needDraw[r.NODE] && motionBlur && !r.clearedForMotionBlur[r.NODE] || r.clearingMotionBlur;
    if (needMbClear[r.NODE]) r.clearedForMotionBlur[r.NODE] = true;
    needMbClear[r.DRAG] = !needDraw[r.DRAG] && motionBlur && !r.clearedForMotionBlur[r.DRAG] || r.clearingMotionBlur;
    if (needMbClear[r.DRAG]) r.clearedForMotionBlur[r.DRAG] = true;
    if (needDraw[r.NODE] || drawAllLayers || drawOnlyNodeLayer || needMbClear[r.NODE]) {
        var useBuffer = motionBlur && !needMbClear[r.NODE] && mbPxRatio !== 1;
        var context = forcedContext || (useBuffer ? r.data.bufferContexts[r.MOTIONBLUR_BUFFER_NODE] : data.contexts[r.NODE]);
        var clear = motionBlur && !useBuffer ? 'motionBlur' : undefined;
        setContextTransform(context, clear);
        if (hideEdges) r.drawCachedNodes(context, eles.nondrag, pixelRatio, extent);
        else r.drawLayeredElements(context, eles.nondrag, pixelRatio, extent);
        if (r.debug) r.drawDebugPoints(context, eles.nondrag);
        if (!drawAllLayers && !motionBlur) needDraw[r.NODE] = false;
    }
    if (!drawOnlyNodeLayer && (needDraw[r.DRAG] || drawAllLayers || needMbClear[r.DRAG])) {
        var useBuffer = motionBlur && !needMbClear[r.DRAG] && mbPxRatio !== 1;
        var context = forcedContext || (useBuffer ? r.data.bufferContexts[r.MOTIONBLUR_BUFFER_DRAG] : data.contexts[r.DRAG]);
        setContextTransform(context, motionBlur && !useBuffer ? 'motionBlur' : undefined);
        if (hideEdges) r.drawCachedNodes(context, eles.drag, pixelRatio, extent);
        else r.drawCachedElements(context, eles.drag, pixelRatio, extent);
        if (r.debug) r.drawDebugPoints(context, eles.drag);
        if (!drawAllLayers && !motionBlur) needDraw[r.DRAG] = false;
    }
    if (r.showFps || !drawOnlyNodeLayer && needDraw[r.SELECT_BOX] && !drawAllLayers) {
        var context = forcedContext || data.contexts[r.SELECT_BOX];
        setContextTransform(context);
        if (r.selection[4] == 1 && (r.hoverData.selecting || r.touchData.selecting)) {
            var zoom = r.cy.zoom();
            var borderWidth = style.core('selection-box-border-width').value / zoom;
            context.lineWidth = borderWidth;
            context.fillStyle = 'rgba(' + style.core('selection-box-color').value[0] + ',' + style.core('selection-box-color').value[1] + ',' + style.core('selection-box-color').value[2] + ',' + style.core('selection-box-opacity').value + ')';
            context.fillRect(r.selection[0], r.selection[1], r.selection[2] - r.selection[0], r.selection[3] - r.selection[1]);
            if (borderWidth > 0) {
                context.strokeStyle = 'rgba(' + style.core('selection-box-border-color').value[0] + ',' + style.core('selection-box-border-color').value[1] + ',' + style.core('selection-box-border-color').value[2] + ',' + style.core('selection-box-opacity').value + ')';
                context.strokeRect(r.selection[0], r.selection[1], r.selection[2] - r.selection[0], r.selection[3] - r.selection[1]);
            }
        }
        if (data.bgActivePosistion && !r.hoverData.selecting) {
            var zoom = r.cy.zoom();
            var pos = data.bgActivePosistion;
            context.fillStyle = 'rgba(' + style.core('active-bg-color').value[0] + ',' + style.core('active-bg-color').value[1] + ',' + style.core('active-bg-color').value[2] + ',' + style.core('active-bg-opacity').value + ')';
            context.beginPath();
            context.arc(pos.x, pos.y, style.core('active-bg-size').pfValue / zoom, 0, 2 * Math.PI);
            context.fill();
        }
        var timeToRender = r.lastRedrawTime;
        if (r.showFps && timeToRender) {
            timeToRender = Math.round(timeToRender);
            var fps = Math.round(1000 / timeToRender);
            context.setTransform(1, 0, 0, 1, 0, 0);
            context.fillStyle = 'rgba(255, 0, 0, 0.75)';
            context.strokeStyle = 'rgba(255, 0, 0, 0.75)';
            context.lineWidth = 1;
            context.fillText('1 frame = ' + timeToRender + ' ms = ' + fps + ' fps', 0, 20);
            var maxFps = 60;
            context.strokeRect(0, 30, 250, 20);
            context.fillRect(0, 30, 250 * Math.min(fps / maxFps, 1), 20);
        }
        if (!drawAllLayers) needDraw[r.SELECT_BOX] = false;
    }
    // motionblur: blit rendered blurry frames
    if (motionBlur && mbPxRatio !== 1) {
        var cxtNode = data.contexts[r.NODE];
        var txtNode = r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_NODE];
        var cxtDrag = data.contexts[r.DRAG];
        var txtDrag = r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_DRAG];
        var drawMotionBlur = function drawMotionBlur(cxt, txt, needClear) {
            cxt.setTransform(1, 0, 0, 1, 0, 0);
            if (needClear || !motionBlurFadeEffect) cxt.clearRect(0, 0, r.canvasWidth, r.canvasHeight);
            else mbclear(cxt, 0, 0, r.canvasWidth, r.canvasHeight);
            var pxr = mbPxRatio;
            cxt.drawImage(txt, // img
            0, 0, // sx, sy
            r.canvasWidth * pxr, r.canvasHeight * pxr, // sw, sh
            0, 0, // x, y
            r.canvasWidth, r.canvasHeight // w, h
            );
        };
        if (needDraw[r.NODE] || needMbClear[r.NODE]) {
            drawMotionBlur(cxtNode, txtNode, needMbClear[r.NODE]);
            needDraw[r.NODE] = false;
        }
        if (needDraw[r.DRAG] || needMbClear[r.DRAG]) {
            drawMotionBlur(cxtDrag, txtDrag, needMbClear[r.DRAG]);
            needDraw[r.DRAG] = false;
        }
    }
    r.prevViewport = vp;
    if (r.clearingMotionBlur) {
        r.clearingMotionBlur = false;
        r.motionBlurCleared = true;
        r.motionBlur = true;
    }
    if (motionBlur) r.motionBlurTimeout = setTimeout(function() {
        r.motionBlurTimeout = null;
        r.clearedForMotionBlur[r.NODE] = false;
        r.clearedForMotionBlur[r.DRAG] = false;
        r.motionBlur = false;
        r.clearingMotionBlur = !textureDraw;
        r.mbFrames = 0;
        needDraw[r.NODE] = true;
        needDraw[r.DRAG] = true;
        r.redraw();
    }, $e815fda779bc047b$var$motionBlurDelay);
    if (!forcedContext) cy.emit('render');
};
var $e815fda779bc047b$var$CRp$3 = {};
// @O Polygon drawing
$e815fda779bc047b$var$CRp$3.drawPolygonPath = function(context, x, y, width, height, points) {
    var halfW = width / 2;
    var halfH = height / 2;
    if (context.beginPath) context.beginPath();
    context.moveTo(x + halfW * points[0], y + halfH * points[1]);
    for(var i = 1; i < points.length / 2; i++)context.lineTo(x + halfW * points[i * 2], y + halfH * points[i * 2 + 1]);
    context.closePath();
};
$e815fda779bc047b$var$CRp$3.drawRoundPolygonPath = function(context, x, y, width, height, points, corners) {
    corners.forEach(function(corner) {
        return $e815fda779bc047b$var$drawPreparedRoundCorner(context, corner);
    });
    context.closePath();
};
// Round rectangle drawing
$e815fda779bc047b$var$CRp$3.drawRoundRectanglePath = function(context, x, y, width, height, radius) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var cornerRadius = radius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(width, height) : Math.min(radius, halfHeight, halfWidth);
    if (context.beginPath) context.beginPath();
    // Start at top middle
    context.moveTo(x, y - halfHeight);
    // Arc from middle top to right side
    context.arcTo(x + halfWidth, y - halfHeight, x + halfWidth, y, cornerRadius);
    // Arc from right side to bottom
    context.arcTo(x + halfWidth, y + halfHeight, x, y + halfHeight, cornerRadius);
    // Arc from bottom to left side
    context.arcTo(x - halfWidth, y + halfHeight, x - halfWidth, y, cornerRadius);
    // Arc from left side to topBorder
    context.arcTo(x - halfWidth, y - halfHeight, x, y - halfHeight, cornerRadius);
    // Join line
    context.lineTo(x, y - halfHeight);
    context.closePath();
};
$e815fda779bc047b$var$CRp$3.drawBottomRoundRectanglePath = function(context, x, y, width, height, radius) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var cornerRadius = radius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(width, height) : radius;
    if (context.beginPath) context.beginPath();
    // Start at top middle
    context.moveTo(x, y - halfHeight);
    context.lineTo(x + halfWidth, y - halfHeight);
    context.lineTo(x + halfWidth, y);
    context.arcTo(x + halfWidth, y + halfHeight, x, y + halfHeight, cornerRadius);
    context.arcTo(x - halfWidth, y + halfHeight, x - halfWidth, y, cornerRadius);
    context.lineTo(x - halfWidth, y - halfHeight);
    context.lineTo(x, y - halfHeight);
    context.closePath();
};
$e815fda779bc047b$var$CRp$3.drawCutRectanglePath = function(context, x, y, width, height, points, corners) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var cornerLength = corners === 'auto' ? $e815fda779bc047b$var$getCutRectangleCornerLength() : corners;
    if (context.beginPath) context.beginPath();
    context.moveTo(x - halfWidth + cornerLength, y - halfHeight);
    context.lineTo(x + halfWidth - cornerLength, y - halfHeight);
    context.lineTo(x + halfWidth, y - halfHeight + cornerLength);
    context.lineTo(x + halfWidth, y + halfHeight - cornerLength);
    context.lineTo(x + halfWidth - cornerLength, y + halfHeight);
    context.lineTo(x - halfWidth + cornerLength, y + halfHeight);
    context.lineTo(x - halfWidth, y + halfHeight - cornerLength);
    context.lineTo(x - halfWidth, y - halfHeight + cornerLength);
    context.closePath();
};
$e815fda779bc047b$var$CRp$3.drawBarrelPath = function(context, x, y, width, height) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var xBegin = x - halfWidth;
    var xEnd = x + halfWidth;
    var yBegin = y - halfHeight;
    var yEnd = y + halfHeight;
    var barrelCurveConstants = $e815fda779bc047b$var$getBarrelCurveConstants(width, height);
    var wOffset = barrelCurveConstants.widthOffset;
    var hOffset = barrelCurveConstants.heightOffset;
    var ctrlPtXOffset = barrelCurveConstants.ctrlPtOffsetPct * wOffset;
    if (context.beginPath) context.beginPath();
    context.moveTo(xBegin, yBegin + hOffset);
    context.lineTo(xBegin, yEnd - hOffset);
    context.quadraticCurveTo(xBegin + ctrlPtXOffset, yEnd, xBegin + wOffset, yEnd);
    context.lineTo(xEnd - wOffset, yEnd);
    context.quadraticCurveTo(xEnd - ctrlPtXOffset, yEnd, xEnd, yEnd - hOffset);
    context.lineTo(xEnd, yBegin + hOffset);
    context.quadraticCurveTo(xEnd - ctrlPtXOffset, yBegin, xEnd - wOffset, yBegin);
    context.lineTo(xBegin + wOffset, yBegin);
    context.quadraticCurveTo(xBegin + ctrlPtXOffset, yBegin, xBegin, yBegin + hOffset);
    context.closePath();
};
var $e815fda779bc047b$var$sin0 = Math.sin(0);
var $e815fda779bc047b$var$cos0 = Math.cos(0);
var $e815fda779bc047b$var$sin = {};
var $e815fda779bc047b$var$cos = {};
var $e815fda779bc047b$var$ellipseStepSize = Math.PI / 40;
for(var $e815fda779bc047b$var$i = 0 * Math.PI; $e815fda779bc047b$var$i < 2 * Math.PI; $e815fda779bc047b$var$i += $e815fda779bc047b$var$ellipseStepSize){
    $e815fda779bc047b$var$sin[$e815fda779bc047b$var$i] = Math.sin($e815fda779bc047b$var$i);
    $e815fda779bc047b$var$cos[$e815fda779bc047b$var$i] = Math.cos($e815fda779bc047b$var$i);
}
$e815fda779bc047b$var$CRp$3.drawEllipsePath = function(context, centerX, centerY, width, height) {
    if (context.beginPath) context.beginPath();
    if (context.ellipse) context.ellipse(centerX, centerY, width / 2, height / 2, 0, 0, 2 * Math.PI);
    else {
        var xPos, yPos;
        var rw = width / 2;
        var rh = height / 2;
        for(var i = 0 * Math.PI; i < 2 * Math.PI; i += $e815fda779bc047b$var$ellipseStepSize){
            xPos = centerX - rw * $e815fda779bc047b$var$sin[i] * $e815fda779bc047b$var$sin0 + rw * $e815fda779bc047b$var$cos[i] * $e815fda779bc047b$var$cos0;
            yPos = centerY + rh * $e815fda779bc047b$var$cos[i] * $e815fda779bc047b$var$sin0 + rh * $e815fda779bc047b$var$sin[i] * $e815fda779bc047b$var$cos0;
            if (i === 0) context.moveTo(xPos, yPos);
            else context.lineTo(xPos, yPos);
        }
    }
    context.closePath();
};
/* global atob, ArrayBuffer, Uint8Array, Blob */ var $e815fda779bc047b$var$CRp$2 = {};
$e815fda779bc047b$var$CRp$2.createBuffer = function(w, h) {
    var buffer = document.createElement('canvas'); // eslint-disable-line no-undef
    buffer.width = w;
    buffer.height = h;
    return [
        buffer,
        buffer.getContext('2d')
    ];
};
$e815fda779bc047b$var$CRp$2.bufferCanvasImage = function(options) {
    var cy = this.cy;
    var eles = cy.mutableElements();
    var bb = eles.boundingBox();
    var ctrRect = this.findContainerClientCoords();
    var width = options.full ? Math.ceil(bb.w) : ctrRect[2];
    var height = options.full ? Math.ceil(bb.h) : ctrRect[3];
    var specdMaxDims = $e815fda779bc047b$var$number$1(options.maxWidth) || $e815fda779bc047b$var$number$1(options.maxHeight);
    var pxRatio = this.getPixelRatio();
    var scale = 1;
    if (options.scale !== undefined) {
        width *= options.scale;
        height *= options.scale;
        scale = options.scale;
    } else if (specdMaxDims) {
        var maxScaleW = Infinity;
        var maxScaleH = Infinity;
        if ($e815fda779bc047b$var$number$1(options.maxWidth)) maxScaleW = scale * options.maxWidth / width;
        if ($e815fda779bc047b$var$number$1(options.maxHeight)) maxScaleH = scale * options.maxHeight / height;
        scale = Math.min(maxScaleW, maxScaleH);
        width *= scale;
        height *= scale;
    }
    if (!specdMaxDims) {
        width *= pxRatio;
        height *= pxRatio;
        scale *= pxRatio;
    }
    var buffCanvas = document.createElement('canvas'); // eslint-disable-line no-undef
    buffCanvas.width = width;
    buffCanvas.height = height;
    buffCanvas.style.width = width + 'px';
    buffCanvas.style.height = height + 'px';
    var buffCxt = buffCanvas.getContext('2d');
    // Rasterize the layers, but only if container has nonzero size
    if (width > 0 && height > 0) {
        buffCxt.clearRect(0, 0, width, height);
        buffCxt.globalCompositeOperation = 'source-over';
        var zsortedEles = this.getCachedZSortedEles();
        if (options.full) {
            // draw the full bounds of the graph
            buffCxt.translate(-bb.x1 * scale, -bb.y1 * scale);
            buffCxt.scale(scale, scale);
            this.drawElements(buffCxt, zsortedEles);
            buffCxt.scale(1 / scale, 1 / scale);
            buffCxt.translate(bb.x1 * scale, bb.y1 * scale);
        } else {
            // draw the current view
            var pan = cy.pan();
            var translation = {
                x: pan.x * scale,
                y: pan.y * scale
            };
            scale *= cy.zoom();
            buffCxt.translate(translation.x, translation.y);
            buffCxt.scale(scale, scale);
            this.drawElements(buffCxt, zsortedEles);
            buffCxt.scale(1 / scale, 1 / scale);
            buffCxt.translate(-translation.x, -translation.y);
        }
        // need to fill bg at end like this in order to fill cleared transparent pixels in jpgs
        if (options.bg) {
            buffCxt.globalCompositeOperation = 'destination-over';
            buffCxt.fillStyle = options.bg;
            buffCxt.rect(0, 0, width, height);
            buffCxt.fill();
        }
    }
    return buffCanvas;
};
function $e815fda779bc047b$var$b64ToBlob(b64, mimeType) {
    var bytes = atob(b64);
    var buff = new ArrayBuffer(bytes.length);
    var buffUint8 = new Uint8Array(buff);
    for(var i = 0; i < bytes.length; i++)buffUint8[i] = bytes.charCodeAt(i);
    return new Blob([
        buff
    ], {
        type: mimeType
    });
}
function $e815fda779bc047b$var$b64UriToB64(b64uri) {
    var i = b64uri.indexOf(',');
    return b64uri.substr(i + 1);
}
function $e815fda779bc047b$var$output(options, canvas, mimeType) {
    var getB64Uri = function getB64Uri() {
        return canvas.toDataURL(mimeType, options.quality);
    };
    switch(options.output){
        case 'blob-promise':
            return new $e815fda779bc047b$var$Promise$1(function(resolve, reject) {
                try {
                    canvas.toBlob(function(blob) {
                        if (blob != null) resolve(blob);
                        else reject(new Error('`canvas.toBlob()` sent a null value in its callback'));
                    }, mimeType, options.quality);
                } catch (err) {
                    reject(err);
                }
            });
        case 'blob':
            return $e815fda779bc047b$var$b64ToBlob($e815fda779bc047b$var$b64UriToB64(getB64Uri()), mimeType);
        case 'base64':
            return $e815fda779bc047b$var$b64UriToB64(getB64Uri());
        case 'base64uri':
        default:
            return getB64Uri();
    }
}
$e815fda779bc047b$var$CRp$2.png = function(options) {
    return $e815fda779bc047b$var$output(options, this.bufferCanvasImage(options), 'image/png');
};
$e815fda779bc047b$var$CRp$2.jpg = function(options) {
    return $e815fda779bc047b$var$output(options, this.bufferCanvasImage(options), 'image/jpeg');
};
var $e815fda779bc047b$var$CRp$1 = {};
$e815fda779bc047b$var$CRp$1.nodeShapeImpl = function(name, context, centerX, centerY, width, height, points, corners) {
    switch(name){
        case 'ellipse':
            return this.drawEllipsePath(context, centerX, centerY, width, height);
        case 'polygon':
            return this.drawPolygonPath(context, centerX, centerY, width, height, points);
        case 'round-polygon':
            return this.drawRoundPolygonPath(context, centerX, centerY, width, height, points, corners);
        case 'roundrectangle':
        case 'round-rectangle':
            return this.drawRoundRectanglePath(context, centerX, centerY, width, height, corners);
        case 'cutrectangle':
        case 'cut-rectangle':
            return this.drawCutRectanglePath(context, centerX, centerY, width, height, points, corners);
        case 'bottomroundrectangle':
        case 'bottom-round-rectangle':
            return this.drawBottomRoundRectanglePath(context, centerX, centerY, width, height, corners);
        case 'barrel':
            return this.drawBarrelPath(context, centerX, centerY, width, height);
    }
};
var $e815fda779bc047b$var$CR = $e815fda779bc047b$var$CanvasRenderer;
var $e815fda779bc047b$var$CRp = $e815fda779bc047b$var$CanvasRenderer.prototype;
$e815fda779bc047b$var$CRp.CANVAS_LAYERS = 3;
//
$e815fda779bc047b$var$CRp.SELECT_BOX = 0;
$e815fda779bc047b$var$CRp.DRAG = 1;
$e815fda779bc047b$var$CRp.NODE = 2;
$e815fda779bc047b$var$CRp.BUFFER_COUNT = 3;
//
$e815fda779bc047b$var$CRp.TEXTURE_BUFFER = 0;
$e815fda779bc047b$var$CRp.MOTIONBLUR_BUFFER_NODE = 1;
$e815fda779bc047b$var$CRp.MOTIONBLUR_BUFFER_DRAG = 2;
function $e815fda779bc047b$var$CanvasRenderer(options) {
    var r = this;
    var containerWindow = r.cy.window();
    var document1 = containerWindow.document;
    r.data = {
        canvases: new Array($e815fda779bc047b$var$CRp.CANVAS_LAYERS),
        contexts: new Array($e815fda779bc047b$var$CRp.CANVAS_LAYERS),
        canvasNeedsRedraw: new Array($e815fda779bc047b$var$CRp.CANVAS_LAYERS),
        bufferCanvases: new Array($e815fda779bc047b$var$CRp.BUFFER_COUNT),
        bufferContexts: new Array($e815fda779bc047b$var$CRp.CANVAS_LAYERS)
    };
    var tapHlOffAttr = '-webkit-tap-highlight-color';
    var tapHlOffStyle = 'rgba(0,0,0,0)';
    r.data.canvasContainer = document1.createElement('div'); // eslint-disable-line no-undef
    var containerStyle = r.data.canvasContainer.style;
    r.data.canvasContainer.style[tapHlOffAttr] = tapHlOffStyle;
    containerStyle.position = 'relative';
    containerStyle.zIndex = '0';
    containerStyle.overflow = 'hidden';
    var container = options.cy.container();
    container.appendChild(r.data.canvasContainer);
    container.style[tapHlOffAttr] = tapHlOffStyle;
    var styleMap = {
        '-webkit-user-select': 'none',
        '-moz-user-select': '-moz-none',
        'user-select': 'none',
        '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
        'outline-style': 'none'
    };
    if ($e815fda779bc047b$var$ms()) {
        styleMap['-ms-touch-action'] = 'none';
        styleMap['touch-action'] = 'none';
    }
    for(var i = 0; i < $e815fda779bc047b$var$CRp.CANVAS_LAYERS; i++){
        var canvas = r.data.canvases[i] = document1.createElement('canvas'); // eslint-disable-line no-undef
        r.data.contexts[i] = canvas.getContext('2d');
        Object.keys(styleMap).forEach(function(k) {
            canvas.style[k] = styleMap[k];
        });
        canvas.style.position = 'absolute';
        canvas.setAttribute('data-id', 'layer' + i);
        canvas.style.zIndex = String($e815fda779bc047b$var$CRp.CANVAS_LAYERS - i);
        r.data.canvasContainer.appendChild(canvas);
        r.data.canvasNeedsRedraw[i] = false;
    }
    r.data.topCanvas = r.data.canvases[0];
    r.data.canvases[$e815fda779bc047b$var$CRp.NODE].setAttribute('data-id', 'layer' + $e815fda779bc047b$var$CRp.NODE + '-node');
    r.data.canvases[$e815fda779bc047b$var$CRp.SELECT_BOX].setAttribute('data-id', 'layer' + $e815fda779bc047b$var$CRp.SELECT_BOX + '-selectbox');
    r.data.canvases[$e815fda779bc047b$var$CRp.DRAG].setAttribute('data-id', 'layer' + $e815fda779bc047b$var$CRp.DRAG + '-drag');
    for(var i = 0; i < $e815fda779bc047b$var$CRp.BUFFER_COUNT; i++){
        r.data.bufferCanvases[i] = document1.createElement('canvas'); // eslint-disable-line no-undef
        r.data.bufferContexts[i] = r.data.bufferCanvases[i].getContext('2d');
        r.data.bufferCanvases[i].style.position = 'absolute';
        r.data.bufferCanvases[i].setAttribute('data-id', 'buffer' + i);
        r.data.bufferCanvases[i].style.zIndex = String(-i - 1);
        r.data.bufferCanvases[i].style.visibility = 'hidden';
    //r.data.canvasContainer.appendChild(r.data.bufferCanvases[i]);
    }
    r.pathsEnabled = true;
    var emptyBb = $e815fda779bc047b$var$makeBoundingBox();
    var getBoxCenter = function getBoxCenter(bb) {
        return {
            x: (bb.x1 + bb.x2) / 2,
            y: (bb.y1 + bb.y2) / 2
        };
    };
    var getCenterOffset = function getCenterOffset(bb) {
        return {
            x: -bb.w / 2,
            y: -bb.h / 2
        };
    };
    var backgroundTimestampHasChanged = function backgroundTimestampHasChanged(ele) {
        var _p = ele[0]._private;
        var same = _p.oldBackgroundTimestamp === _p.backgroundTimestamp;
        return !same;
    };
    var getStyleKey = function getStyleKey(ele) {
        return ele[0]._private.nodeKey;
    };
    var getLabelKey = function getLabelKey(ele) {
        return ele[0]._private.labelStyleKey;
    };
    var getSourceLabelKey = function getSourceLabelKey(ele) {
        return ele[0]._private.sourceLabelStyleKey;
    };
    var getTargetLabelKey = function getTargetLabelKey(ele) {
        return ele[0]._private.targetLabelStyleKey;
    };
    var drawElement = function drawElement(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElement(context, ele, bb, false, false, useEleOpacity);
    };
    var drawLabel = function drawLabel(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElementText(context, ele, bb, scaledLabelShown, 'main', useEleOpacity);
    };
    var drawSourceLabel = function drawSourceLabel(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElementText(context, ele, bb, scaledLabelShown, 'source', useEleOpacity);
    };
    var drawTargetLabel = function drawTargetLabel(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElementText(context, ele, bb, scaledLabelShown, 'target', useEleOpacity);
    };
    var getElementBox = function getElementBox(ele) {
        ele.boundingBox();
        return ele[0]._private.bodyBounds;
    };
    var getLabelBox = function getLabelBox(ele) {
        ele.boundingBox();
        return ele[0]._private.labelBounds.main || emptyBb;
    };
    var getSourceLabelBox = function getSourceLabelBox(ele) {
        ele.boundingBox();
        return ele[0]._private.labelBounds.source || emptyBb;
    };
    var getTargetLabelBox = function getTargetLabelBox(ele) {
        ele.boundingBox();
        return ele[0]._private.labelBounds.target || emptyBb;
    };
    var isLabelVisibleAtScale = function isLabelVisibleAtScale(ele, scaledLabelShown) {
        return scaledLabelShown;
    };
    var getElementRotationPoint = function getElementRotationPoint(ele) {
        return getBoxCenter(getElementBox(ele));
    };
    var addTextMargin = function addTextMargin(prefix, pt, ele) {
        var pre = prefix ? prefix + '-' : '';
        return {
            x: pt.x + ele.pstyle(pre + 'text-margin-x').pfValue,
            y: pt.y + ele.pstyle(pre + 'text-margin-y').pfValue
        };
    };
    var getRsPt = function getRsPt(ele, x, y) {
        var rs = ele[0]._private.rscratch;
        return {
            x: rs[x],
            y: rs[y]
        };
    };
    var getLabelRotationPoint = function getLabelRotationPoint(ele) {
        return addTextMargin('', getRsPt(ele, 'labelX', 'labelY'), ele);
    };
    var getSourceLabelRotationPoint = function getSourceLabelRotationPoint(ele) {
        return addTextMargin('source', getRsPt(ele, 'sourceLabelX', 'sourceLabelY'), ele);
    };
    var getTargetLabelRotationPoint = function getTargetLabelRotationPoint(ele) {
        return addTextMargin('target', getRsPt(ele, 'targetLabelX', 'targetLabelY'), ele);
    };
    var getElementRotationOffset = function getElementRotationOffset(ele) {
        return getCenterOffset(getElementBox(ele));
    };
    var getSourceLabelRotationOffset = function getSourceLabelRotationOffset(ele) {
        return getCenterOffset(getSourceLabelBox(ele));
    };
    var getTargetLabelRotationOffset = function getTargetLabelRotationOffset(ele) {
        return getCenterOffset(getTargetLabelBox(ele));
    };
    var getLabelRotationOffset = function getLabelRotationOffset(ele) {
        var bb = getLabelBox(ele);
        var p = getCenterOffset(getLabelBox(ele));
        if (ele.isNode()) {
            switch(ele.pstyle('text-halign').value){
                case 'left':
                    p.x = -bb.w - (bb.leftPad || 0);
                    break;
                case 'right':
                    p.x = -(bb.rightPad || 0);
                    break;
            }
            switch(ele.pstyle('text-valign').value){
                case 'top':
                    p.y = -bb.h - (bb.topPad || 0);
                    break;
                case 'bottom':
                    p.y = -(bb.botPad || 0);
                    break;
            }
        }
        return p;
    };
    var eleTxrCache = r.data.eleTxrCache = new $e815fda779bc047b$var$ElementTextureCache(r, {
        getKey: getStyleKey,
        doesEleInvalidateKey: backgroundTimestampHasChanged,
        drawElement: drawElement,
        getBoundingBox: getElementBox,
        getRotationPoint: getElementRotationPoint,
        getRotationOffset: getElementRotationOffset,
        allowEdgeTxrCaching: false,
        allowParentTxrCaching: false
    });
    var lblTxrCache = r.data.lblTxrCache = new $e815fda779bc047b$var$ElementTextureCache(r, {
        getKey: getLabelKey,
        drawElement: drawLabel,
        getBoundingBox: getLabelBox,
        getRotationPoint: getLabelRotationPoint,
        getRotationOffset: getLabelRotationOffset,
        isVisible: isLabelVisibleAtScale
    });
    var slbTxrCache = r.data.slbTxrCache = new $e815fda779bc047b$var$ElementTextureCache(r, {
        getKey: getSourceLabelKey,
        drawElement: drawSourceLabel,
        getBoundingBox: getSourceLabelBox,
        getRotationPoint: getSourceLabelRotationPoint,
        getRotationOffset: getSourceLabelRotationOffset,
        isVisible: isLabelVisibleAtScale
    });
    var tlbTxrCache = r.data.tlbTxrCache = new $e815fda779bc047b$var$ElementTextureCache(r, {
        getKey: getTargetLabelKey,
        drawElement: drawTargetLabel,
        getBoundingBox: getTargetLabelBox,
        getRotationPoint: getTargetLabelRotationPoint,
        getRotationOffset: getTargetLabelRotationOffset,
        isVisible: isLabelVisibleAtScale
    });
    var lyrTxrCache = r.data.lyrTxrCache = new $e815fda779bc047b$var$LayeredTextureCache(r);
    r.onUpdateEleCalcs(function invalidateTextureCaches(willDraw, eles) {
        // each cache should check for sub-key diff to see that the update affects that cache particularly
        eleTxrCache.invalidateElements(eles);
        lblTxrCache.invalidateElements(eles);
        slbTxrCache.invalidateElements(eles);
        tlbTxrCache.invalidateElements(eles);
        // any change invalidates the layers
        lyrTxrCache.invalidateElements(eles);
        // update the old bg timestamp so diffs can be done in the ele txr caches
        for(var _i = 0; _i < eles.length; _i++){
            var _p = eles[_i]._private;
            _p.oldBackgroundTimestamp = _p.backgroundTimestamp;
        }
    });
    var refineInLayers = function refineInLayers(reqs) {
        for(var i = 0; i < reqs.length; i++)lyrTxrCache.enqueueElementRefinement(reqs[i].ele);
    };
    eleTxrCache.onDequeue(refineInLayers);
    lblTxrCache.onDequeue(refineInLayers);
    slbTxrCache.onDequeue(refineInLayers);
    tlbTxrCache.onDequeue(refineInLayers);
}
$e815fda779bc047b$var$CRp.redrawHint = function(group, bool) {
    var r = this;
    switch(group){
        case 'eles':
            r.data.canvasNeedsRedraw[$e815fda779bc047b$var$CRp.NODE] = bool;
            break;
        case 'drag':
            r.data.canvasNeedsRedraw[$e815fda779bc047b$var$CRp.DRAG] = bool;
            break;
        case 'select':
            r.data.canvasNeedsRedraw[$e815fda779bc047b$var$CRp.SELECT_BOX] = bool;
            break;
    }
};
// whether to use Path2D caching for drawing
var $e815fda779bc047b$var$pathsImpld = typeof Path2D !== 'undefined';
$e815fda779bc047b$var$CRp.path2dEnabled = function(on) {
    if (on === undefined) return this.pathsEnabled;
    this.pathsEnabled = on ? true : false;
};
$e815fda779bc047b$var$CRp.usePaths = function() {
    return $e815fda779bc047b$var$pathsImpld && this.pathsEnabled;
};
$e815fda779bc047b$var$CRp.setImgSmoothing = function(context, bool) {
    if (context.imageSmoothingEnabled != null) context.imageSmoothingEnabled = bool;
    else {
        context.webkitImageSmoothingEnabled = bool;
        context.mozImageSmoothingEnabled = bool;
        context.msImageSmoothingEnabled = bool;
    }
};
$e815fda779bc047b$var$CRp.getImgSmoothing = function(context) {
    if (context.imageSmoothingEnabled != null) return context.imageSmoothingEnabled;
    else return context.webkitImageSmoothingEnabled || context.mozImageSmoothingEnabled || context.msImageSmoothingEnabled;
};
$e815fda779bc047b$var$CRp.makeOffscreenCanvas = function(width, height) {
    var canvas;
    if ((typeof OffscreenCanvas === "undefined" ? "undefined" : $e815fda779bc047b$var$_typeof(OffscreenCanvas)) !== "undefined") canvas = new OffscreenCanvas(width, height);
    else {
        var containerWindow = this.cy.window();
        var document1 = containerWindow.document;
        canvas = document1.createElement('canvas'); // eslint-disable-line no-undef
        canvas.width = width;
        canvas.height = height;
    }
    return canvas;
};
[
    $e815fda779bc047b$var$CRp$a,
    $e815fda779bc047b$var$CRp$9,
    $e815fda779bc047b$var$CRp$8,
    $e815fda779bc047b$var$CRp$7,
    $e815fda779bc047b$var$CRp$6,
    $e815fda779bc047b$var$CRp$5,
    $e815fda779bc047b$var$CRp$4,
    $e815fda779bc047b$var$CRp$3,
    $e815fda779bc047b$var$CRp$2,
    $e815fda779bc047b$var$CRp$1
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$CRp, props);
});
var $e815fda779bc047b$var$renderer = [
    {
        name: 'null',
        impl: $e815fda779bc047b$var$NullRenderer
    },
    {
        name: 'base',
        impl: $e815fda779bc047b$var$BR
    },
    {
        name: 'canvas',
        impl: $e815fda779bc047b$var$CR
    }
];
var $e815fda779bc047b$var$incExts = [
    {
        type: 'layout',
        extensions: $e815fda779bc047b$var$layout
    },
    {
        type: 'renderer',
        extensions: $e815fda779bc047b$var$renderer
    }
];
// registered extensions to cytoscape, indexed by name
var $e815fda779bc047b$var$extensions = {};
// registered modules for extensions, indexed by name
var $e815fda779bc047b$var$modules = {};
function $e815fda779bc047b$var$setExtension(type, name, registrant) {
    var ext = registrant;
    var overrideErr = function overrideErr(field) {
        $e815fda779bc047b$var$warn('Can not register `' + name + '` for `' + type + '` since `' + field + '` already exists in the prototype and can not be overridden');
    };
    if (type === 'core') {
        if ($e815fda779bc047b$var$Core.prototype[name]) return overrideErr(name);
        else $e815fda779bc047b$var$Core.prototype[name] = registrant;
    } else if (type === 'collection') {
        if ($e815fda779bc047b$var$Collection.prototype[name]) return overrideErr(name);
        else $e815fda779bc047b$var$Collection.prototype[name] = registrant;
    } else if (type === 'layout') {
        // fill in missing layout functions in the prototype
        var Layout = function Layout(options) {
            this.options = options;
            registrant.call(this, options);
            // make sure layout has _private for use w/ std apis like .on()
            if (!$e815fda779bc047b$var$plainObject(this._private)) this._private = {};
            this._private.cy = options.cy;
            this._private.listeners = [];
            this.createEmitter();
        };
        var layoutProto = Layout.prototype = Object.create(registrant.prototype);
        var optLayoutFns = [];
        for(var i = 0; i < optLayoutFns.length; i++){
            var fnName = optLayoutFns[i];
            layoutProto[fnName] = layoutProto[fnName] || function() {
                return this;
            };
        }
        // either .start() or .run() is defined, so autogen the other
        if (layoutProto.start && !layoutProto.run) layoutProto.run = function() {
            this.start();
            return this;
        };
        else if (!layoutProto.start && layoutProto.run) layoutProto.start = function() {
            this.run();
            return this;
        };
        var regStop = registrant.prototype.stop;
        layoutProto.stop = function() {
            var opts = this.options;
            if (opts && opts.animate) {
                var anis = this.animations;
                if (anis) for(var _i = 0; _i < anis.length; _i++)anis[_i].stop();
            }
            if (regStop) regStop.call(this);
            else this.emit('layoutstop');
            return this;
        };
        if (!layoutProto.destroy) layoutProto.destroy = function() {
            return this;
        };
        layoutProto.cy = function() {
            return this._private.cy;
        };
        var getCy = function getCy(layout) {
            return layout._private.cy;
        };
        var emitterOpts = {
            addEventFields: function addEventFields(layout, evt) {
                evt.layout = layout;
                evt.cy = getCy(layout);
                evt.target = layout;
            },
            bubble: function bubble() {
                return true;
            },
            parent: function parent(layout) {
                return getCy(layout);
            }
        };
        $e815fda779bc047b$var$extend(layoutProto, {
            createEmitter: function createEmitter() {
                this._private.emitter = new $e815fda779bc047b$var$Emitter(emitterOpts, this);
                return this;
            },
            emitter: function emitter() {
                return this._private.emitter;
            },
            on: function on(evt, cb) {
                this.emitter().on(evt, cb);
                return this;
            },
            one: function one(evt, cb) {
                this.emitter().one(evt, cb);
                return this;
            },
            once: function once(evt, cb) {
                this.emitter().one(evt, cb);
                return this;
            },
            removeListener: function removeListener(evt, cb) {
                this.emitter().removeListener(evt, cb);
                return this;
            },
            removeAllListeners: function removeAllListeners() {
                this.emitter().removeAllListeners();
                return this;
            },
            emit: function emit(evt, params) {
                this.emitter().emit(evt, params);
                return this;
            }
        });
        $e815fda779bc047b$var$define.eventAliasesOn(layoutProto);
        ext = Layout; // replace with our wrapped layout
    } else if (type === 'renderer' && name !== 'null' && name !== 'base') {
        // user registered renderers inherit from base
        var BaseRenderer = $e815fda779bc047b$var$getExtension('renderer', 'base');
        var bProto = BaseRenderer.prototype;
        var RegistrantRenderer = registrant;
        var rProto = registrant.prototype;
        var Renderer = function Renderer() {
            BaseRenderer.apply(this, arguments);
            RegistrantRenderer.apply(this, arguments);
        };
        var proto = Renderer.prototype;
        for(var pName in bProto){
            var pVal = bProto[pName];
            var existsInR = rProto[pName] != null;
            if (existsInR) return overrideErr(pName);
            proto[pName] = pVal; // take impl from base
        }
        for(var _pName in rProto)proto[_pName] = rProto[_pName]; // take impl from registrant
        bProto.clientFunctions.forEach(function(name) {
            proto[name] = proto[name] || function() {
                $e815fda779bc047b$var$error('Renderer does not implement `renderer.' + name + '()` on its prototype');
            };
        });
        ext = Renderer;
    } else if (type === '__proto__' || type === 'constructor' || type === 'prototype') // to avoid potential prototype pollution
    return $e815fda779bc047b$var$error(type + ' is an illegal type to be registered, possibly lead to prototype pollutions');
    return $e815fda779bc047b$var$setMap({
        map: $e815fda779bc047b$var$extensions,
        keys: [
            type,
            name
        ],
        value: ext
    });
}
function $e815fda779bc047b$var$getExtension(type, name) {
    return $e815fda779bc047b$var$getMap({
        map: $e815fda779bc047b$var$extensions,
        keys: [
            type,
            name
        ]
    });
}
function $e815fda779bc047b$var$setModule(type, name, moduleType, moduleName, registrant) {
    return $e815fda779bc047b$var$setMap({
        map: $e815fda779bc047b$var$modules,
        keys: [
            type,
            name,
            moduleType,
            moduleName
        ],
        value: registrant
    });
}
function $e815fda779bc047b$var$getModule(type, name, moduleType, moduleName) {
    return $e815fda779bc047b$var$getMap({
        map: $e815fda779bc047b$var$modules,
        keys: [
            type,
            name,
            moduleType,
            moduleName
        ]
    });
}
var $e815fda779bc047b$var$extension = function extension() {
    // e.g. extension('renderer', 'svg')
    if (arguments.length === 2) return $e815fda779bc047b$var$getExtension.apply(null, arguments);
    else if (arguments.length === 3) return $e815fda779bc047b$var$setExtension.apply(null, arguments);
    else if (arguments.length === 4) return $e815fda779bc047b$var$getModule.apply(null, arguments);
    else if (arguments.length === 5) return $e815fda779bc047b$var$setModule.apply(null, arguments);
    else $e815fda779bc047b$var$error('Invalid extension access syntax');
};
// allows a core instance to access extensions internally
$e815fda779bc047b$var$Core.prototype.extension = $e815fda779bc047b$var$extension;
// included extensions
$e815fda779bc047b$var$incExts.forEach(function(group) {
    group.extensions.forEach(function(ext) {
        $e815fda779bc047b$var$setExtension(group.type, ext.name, ext.impl);
    });
});
// a dummy stylesheet object that doesn't need a reference to the core
// (useful for init)
var $e815fda779bc047b$var$Stylesheet = function Stylesheet() {
    if (!(this instanceof Stylesheet)) return new Stylesheet();
    this.length = 0;
};
var $e815fda779bc047b$var$sheetfn = $e815fda779bc047b$var$Stylesheet.prototype;
$e815fda779bc047b$var$sheetfn.instanceString = function() {
    return 'stylesheet';
};
// just store the selector to be parsed later
$e815fda779bc047b$var$sheetfn.selector = function(selector) {
    var i = this.length++;
    this[i] = {
        selector: selector,
        properties: []
    };
    return this; // chaining
};
// just store the property to be parsed later
$e815fda779bc047b$var$sheetfn.css = function(name, value) {
    var i = this.length - 1;
    if ($e815fda779bc047b$var$string(name)) this[i].properties.push({
        name: name,
        value: value
    });
    else if ($e815fda779bc047b$var$plainObject(name)) {
        var map = name;
        var propNames = Object.keys(map);
        for(var j = 0; j < propNames.length; j++){
            var key = propNames[j];
            var mapVal = map[key];
            if (mapVal == null) continue;
            var prop = $e815fda779bc047b$var$Style.properties[key] || $e815fda779bc047b$var$Style.properties[$e815fda779bc047b$var$dash2camel(key)];
            if (prop == null) continue;
            var _name = prop.name;
            var _value = mapVal;
            this[i].properties.push({
                name: _name,
                value: _value
            });
        }
    }
    return this; // chaining
};
$e815fda779bc047b$var$sheetfn.style = $e815fda779bc047b$var$sheetfn.css;
// generate a real style object from the dummy stylesheet
$e815fda779bc047b$var$sheetfn.generateStyle = function(cy) {
    var style = new $e815fda779bc047b$var$Style(cy);
    return this.appendToStyle(style);
};
// append a dummy stylesheet object on a real style object
$e815fda779bc047b$var$sheetfn.appendToStyle = function(style) {
    for(var i = 0; i < this.length; i++){
        var context = this[i];
        var selector = context.selector;
        var props = context.properties;
        style.selector(selector); // apply selector
        for(var j = 0; j < props.length; j++){
            var prop = props[j];
            style.css(prop.name, prop.value); // apply property
        }
    }
    return style;
};
var $e815fda779bc047b$var$version = "3.30.4";
var $e815fda779bc047b$export$2e2bcd8739ae039 = function cytoscape(options) {
    // if no options specified, use default
    if (options === undefined) options = {};
    // create instance
    if ($e815fda779bc047b$var$plainObject(options)) return new $e815fda779bc047b$var$Core(options);
    else if ($e815fda779bc047b$var$string(options)) return $e815fda779bc047b$var$extension.apply($e815fda779bc047b$var$extension, arguments);
};
// e.g. cytoscape.use( require('cytoscape-foo'), bar )
$e815fda779bc047b$export$2e2bcd8739ae039.use = function(ext) {
    var args = Array.prototype.slice.call(arguments, 1); // args to pass to ext
    args.unshift($e815fda779bc047b$export$2e2bcd8739ae039); // cytoscape is first arg to ext
    ext.apply(null, args);
    return this;
};
$e815fda779bc047b$export$2e2bcd8739ae039.warnings = function(bool) {
    return $e815fda779bc047b$var$warnings(bool);
};
// replaced by build system
$e815fda779bc047b$export$2e2bcd8739ae039.version = $e815fda779bc047b$var$version;
// expose public apis (mostly for extensions)
$e815fda779bc047b$export$2e2bcd8739ae039.stylesheet = $e815fda779bc047b$export$2e2bcd8739ae039.Stylesheet = $e815fda779bc047b$var$Stylesheet;


var $3316c281642e828a$exports = {};

(function webpackUniversalModuleDefinition(root, factory) {
    $3316c281642e828a$exports = factory((parcelRequire("aOnO8")));
})($3316c281642e828a$exports, function(__WEBPACK_EXTERNAL_MODULE__632__) {
    return /******/ function() {
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ 632: /***/ function(module1) {
                module1.exports = __WEBPACK_EXTERNAL_MODULE__632__;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1['default'];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        !function() {
            // EXPORTS
            __webpack_require__.d(__webpack_exports__, {
                "default": function() {
                    return /* binding */ src;
                }
            });
            // EXTERNAL MODULE: external {"commonjs":"elkjs/lib/elk.bundled.js","commonjs2":"elkjs/lib/elk.bundled.js","amd":"elkjs","root":"ELK"}
            var elk_bundled_js_amd_elkjs_root_ELK_ = __webpack_require__(632);
            var elk_bundled_js_amd_elkjs_root_ELK_default = /*#__PURE__*/ __webpack_require__.n(elk_bundled_js_amd_elkjs_root_ELK_);
            // Simple, internal Object.assign() polyfill for options objects etc.
            function assign_assign(tgt) {
                for(var _len = arguments.length, srcs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)srcs[_key - 1] = arguments[_key];
                srcs.forEach(function(src) {
                    Object.keys(src).forEach(function(k) {
                        return tgt[k] = src[k];
                    });
                });
                return tgt;
            }
            /* harmony default export */ var src_assign = Object.assign != null ? Object.assign.bind(Object) : assign_assign;
            var defaults = {
                nodeDimensionsIncludeLabels: false,
                // Boolean which changes whether label dimensions are included when calculating node dimensions
                fit: true,
                // Whether to fit
                padding: 20,
                // Padding on fit
                animate: false,
                // Whether to transition the node positions
                animateFilter: function animateFilter() {
                    return true;
                },
                // Whether to animate specific nodes when animation is on; non-animated nodes immediately go to their final positions
                animationDuration: 500,
                // Duration of animation in ms if enabled
                animationEasing: undefined,
                // Easing of animation if enabled
                transform: function transform(node, pos) {
                    return pos;
                },
                // A function that applies a transform to the final node position
                ready: undefined,
                // Callback on layoutready
                stop: undefined,
                // Callback on layoutstop
                nodeLayoutOptions: undefined,
                // Special options for only the nodes
                elk: {
                    // Options to pass directly to ELK `layoutOptions`. The subsequent identifier has to be used as property key in quotes.
                    // E.g. for 'org.eclipse.elk.direction' use:
                    // 'elk.direction'
                    // Primary/mandatory, the elk algorithm to use
                    // one of 'box', 'disco', 'force', 'layered', 'mrtree', 'radial', 'random', 'stress'
                    // (see https://www.eclipse.org/elk/reference/algorithms.html)
                    algorithm: undefined
                },
                priority: function priority() {
                    return null;
                } // Edges with a non-nil value are skipped when geedy edge cycle breaking is enabled
            };
            /* harmony default export */ var src_defaults = defaults;
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            var elkOverrides = {};
            var getPos = function getPos(ele, options) {
                var dims = ele.layoutDimensions(options);
                var parent = ele.parent();
                var k = ele.scratch('elk');
                var p = {
                    x: k.x,
                    y: k.y
                };
                while(parent.nonempty()){
                    var kp = parent.scratch('elk');
                    p.x += kp.x;
                    p.y += kp.y;
                    parent = parent.parent();
                } // elk considers a node position to be its top-left corner, while cy is the centre
                p.x += dims.w / 2;
                p.y += dims.h / 2;
                return p;
            };
            var makeNode = function makeNode(node, options) {
                var k = {
                    _cyEle: node,
                    id: node.id()
                }; // Apply nodeLayoutOptions per user-specified function
                // e.g. nodeLayoutOptions => n.scratch('layoutOptions')
                if (options.nodeLayoutOptions) k.layoutOptions = options.nodeLayoutOptions(node);
                if (!node.isParent()) {
                    var dims = node.layoutDimensions(options);
                    var p = node.position(); // the elk position is the top-left corner, cy is the centre
                    k.x = p.x - dims.w / 2;
                    k.y = p.y - dims.h / 2;
                    k.width = dims.w;
                    k.height = dims.h;
                }
                node.scratch('elk', k);
                return k;
            };
            var makeEdge = function makeEdge(edge) {
                var k = {
                    _cyEle: edge,
                    id: edge.id(),
                    source: edge.data('source'),
                    target: edge.data('target')
                };
                edge.scratch('elk', k);
                return k;
            };
            var makeGraph = function makeGraph(nodes, edges, options) {
                var elkNodes = [];
                var elkEdges = [];
                var elkEleLookup = {};
                var graph = {
                    id: 'root',
                    children: [],
                    edges: []
                }; // map all nodes
                for(var i = 0; i < nodes.length; i++){
                    var n = nodes[i];
                    var k = makeNode(n, options);
                    elkNodes.push(k);
                    elkEleLookup[n.id()] = k;
                } // map all edges
                for(var _i = 0; _i < edges.length; _i++){
                    var e = edges[_i];
                    var _k = makeEdge(e, options);
                    elkEdges.push(_k);
                    elkEleLookup[e.id()] = _k;
                } // make hierarchy
                for(var _i2 = 0; _i2 < elkNodes.length; _i2++){
                    var _k2 = elkNodes[_i2];
                    var _n = _k2._cyEle;
                    if (!_n.isChild()) graph.children.push(_k2);
                    else {
                        var parent = _n.parent();
                        var parentK = elkEleLookup[parent.id()];
                        var children = parentK.children = parentK.children || [];
                        children.push(_k2);
                    }
                }
                for(var _i3 = 0; _i3 < elkEdges.length; _i3++){
                    var _k3 = elkEdges[_i3]; // put all edges in the top level for now
                    // TODO does this cause issues in certain edgecases?
                    /*let e = k._cyEle;
    let parentSrc = e.source().parent();
    let parentTgt = e.target().parent();
    if ( false && parentSrc.nonempty() && parentTgt.nonempty() && parentSrc.same( parentTgt ) ){
      let kp = elkEleLookup[ parentSrc.id() ];
       kp.edges = kp.edges || [];
       kp.edges.push( k );
    } else {*/ graph.edges.push(_k3); //}
                }
                return graph;
            };
            var Layout = /*#__PURE__*/ function() {
                function Layout(options) {
                    _classCallCheck(this, Layout);
                    var elkOptions = options.elk;
                    var cy = options.cy;
                    this.options = src_assign({}, src_defaults, options);
                    this.options.elk = src_assign({
                        aspectRatio: cy.width() / cy.height()
                    }, src_defaults.elk, elkOptions, elkOverrides);
                }
                _createClass(Layout, [
                    {
                        key: "run",
                        value: function run() {
                            var layout = this;
                            var options = this.options;
                            var eles = options.eles;
                            var nodes = eles.nodes();
                            var edges = eles.edges();
                            var elk = new (elk_bundled_js_amd_elkjs_root_ELK_default())();
                            var graph = makeGraph(nodes, edges, options);
                            graph['layoutOptions'] = options.elk;
                            elk.layout(graph).then(function() {
                                nodes.filter(function(n) {
                                    return !n.isParent();
                                }).layoutPositions(layout, options, function(n) {
                                    return getPos(n, options);
                                });
                            });
                            return this;
                        }
                    },
                    {
                        key: "stop",
                        value: function stop() {
                            return this; // chaining
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            return this; // chaining
                        }
                    }
                ]);
                return Layout;
            }();
            /* harmony default export */ var layout = Layout;
            // registers the extension on a cytoscape lib ref
            var register = function register(cytoscape1) {
                if (!cytoscape1) return;
                 // can't register if cytoscape unspecified
                cytoscape1('layout', 'elk', layout); // register with cytoscape.js
            };
            if (typeof cytoscape !== 'undefined') // expose to global cytoscape (i.e. window.cytoscape)
            // eslint-disable-next-line no-undef
            register(cytoscape);
            /* harmony default export */ var src = register;
        }();
        __webpack_exports__ = __webpack_exports__["default"];
        /******/ return __webpack_exports__;
    /******/ }();
});


var $6537b3cb2d643597$exports = {};

(function webpackUniversalModuleDefinition(root, factory) {
    $6537b3cb2d643597$exports = factory((parcelRequire("7l4g1")));
})($6537b3cb2d643597$exports, function(__WEBPACK_EXTERNAL_MODULE_5__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var assign = __webpack_require__(1);
            var defaults = __webpack_require__(2);
            var cola = __webpack_require__(5) || (typeof window !== 'undefined' ? window.cola : null);
            var raf = __webpack_require__(4);
            var isString = function isString(o) {
                return (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === _typeof('');
            };
            var isNumber = function isNumber(o) {
                return (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === _typeof(0);
            };
            var isObject = function isObject(o) {
                return o != null && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === _typeof({});
            };
            var isFunction = function isFunction(o) {
                return o != null && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === _typeof(function() {});
            };
            var nop = function nop() {};
            var getOptVal = function getOptVal(val, ele) {
                if (isFunction(val)) {
                    var fn = val;
                    return fn.apply(ele, [
                        ele
                    ]);
                } else return val;
            };
            // constructor
            // options : object containing layout options
            function ColaLayout(options) {
                this.options = assign({}, defaults, options);
            }
            // runs the layout
            ColaLayout.prototype.run = function() {
                var layout = this;
                var options = this.options;
                layout.manuallyStopped = false;
                var cy = options.cy; // cy is automatically populated for us in the constructor
                var eles = options.eles;
                var nodes = eles.nodes();
                var edges = eles.edges();
                var ready = false;
                var isParent = function isParent(ele) {
                    return ele.isParent();
                };
                var parentNodes = nodes.filter(isParent);
                var nonparentNodes = nodes.subtract(parentNodes);
                var bb = options.boundingBox || {
                    x1: 0,
                    y1: 0,
                    w: cy.width(),
                    h: cy.height()
                };
                if (bb.x2 === undefined) bb.x2 = bb.x1 + bb.w;
                if (bb.w === undefined) bb.w = bb.x2 - bb.x1;
                if (bb.y2 === undefined) bb.y2 = bb.y1 + bb.h;
                if (bb.h === undefined) bb.h = bb.y2 - bb.y1;
                var updateNodePositions = function updateNodePositions() {
                    for(var i = 0; i < nodes.length; i++){
                        var node = nodes[i];
                        var dimensions = node.layoutDimensions(options);
                        var scratch = node.scratch('cola');
                        // update node dims
                        if (!scratch.updatedDims) {
                            var padding = getOptVal(options.nodeSpacing, node);
                            scratch.width = dimensions.w + 2 * padding;
                            scratch.height = dimensions.h + 2 * padding;
                        }
                    }
                    nodes.positions(function(node) {
                        var scratch = node.scratch().cola;
                        var retPos = void 0;
                        if (!node.grabbed() && nonparentNodes.contains(node)) {
                            retPos = {
                                x: bb.x1 + scratch.x,
                                y: bb.y1 + scratch.y
                            };
                            if (!isNumber(retPos.x) || !isNumber(retPos.y)) retPos = undefined;
                        }
                        return retPos;
                    });
                    nodes.updateCompoundBounds(); // because the way this layout sets positions is buggy for some reason; ref #878
                    if (!ready) {
                        onReady();
                        ready = true;
                    }
                    if (options.fit) cy.fit(options.padding);
                };
                var onDone = function onDone() {
                    if (options.ungrabifyWhileSimulating) grabbableNodes.grabify();
                    cy.off('destroy', destroyHandler);
                    nodes.off('grab free position', grabHandler);
                    nodes.off('lock unlock', lockHandler);
                    // trigger layoutstop when the layout stops (e.g. finishes)
                    layout.one('layoutstop', options.stop);
                    layout.trigger({
                        type: 'layoutstop',
                        layout: layout
                    });
                };
                var onReady = function onReady() {
                    // trigger layoutready when each node has had its position set at least once
                    layout.one('layoutready', options.ready);
                    layout.trigger({
                        type: 'layoutready',
                        layout: layout
                    });
                };
                var ticksPerFrame = options.refresh;
                if (options.refresh < 0) ticksPerFrame = 1;
                else ticksPerFrame = Math.max(1, ticksPerFrame); // at least 1
                var adaptor = layout.adaptor = cola.adaptor({
                    trigger: function trigger(e) {
                        // on sim event
                        var TICK = cola.EventType ? cola.EventType.tick : null;
                        var END = cola.EventType ? cola.EventType.end : null;
                        switch(e.type){
                            case 'tick':
                            case TICK:
                                if (options.animate) updateNodePositions();
                                break;
                            case 'end':
                            case END:
                                updateNodePositions();
                                if (!options.infinite) onDone();
                                break;
                        }
                    },
                    kick: function kick() {
                        // kick off the simulation
                        //let skip = 0;
                        var firstTick = true;
                        var inftick = function inftick() {
                            if (layout.manuallyStopped) {
                                onDone();
                                return true;
                            }
                            var ret = adaptor.tick();
                            if (!options.infinite && !firstTick) adaptor.convergenceThreshold(options.convergenceThreshold);
                            firstTick = false;
                            if (ret && options.infinite) // resume layout if done
                            adaptor.resume(); // resume => new kick
                            return ret; // allow regular finish b/c of new kick
                        };
                        var multitick = function multitick() {
                            // multiple ticks in a row
                            var ret = void 0;
                            for(var i = 0; i < ticksPerFrame && !ret; i++)ret = ret || inftick(); // pick up true ret vals => sim done
                            return ret;
                        };
                        if (options.animate) {
                            var frame = function frame() {
                                if (multitick()) return;
                                raf(frame);
                            };
                            raf(frame);
                        } else {
                            while(!inftick());
                        }
                    },
                    on: nop,
                    drag: nop // not needed for our case
                });
                layout.adaptor = adaptor;
                // if set no grabbing during layout
                var grabbableNodes = nodes.filter(':grabbable');
                if (options.ungrabifyWhileSimulating) grabbableNodes.ungrabify();
                var destroyHandler = void 0;
                cy.one('destroy', destroyHandler = function destroyHandler() {
                    layout.stop();
                });
                // handle node dragging
                var grabHandler = void 0;
                nodes.on('grab free position', grabHandler = function grabHandler(e) {
                    var node = this;
                    var scrCola = node.scratch().cola;
                    var pos = node.position();
                    var nodeIsTarget = e.cyTarget === node || e.target === node;
                    if (!nodeIsTarget) return;
                    switch(e.type){
                        case 'grab':
                            adaptor.dragstart(scrCola);
                            break;
                        case 'free':
                            adaptor.dragend(scrCola);
                            break;
                        case 'position':
                            // only update when different (i.e. manual .position() call or drag) so we don't loop needlessly
                            if (scrCola.px !== pos.x - bb.x1 || scrCola.py !== pos.y - bb.y1) {
                                scrCola.px = pos.x - bb.x1;
                                scrCola.py = pos.y - bb.y1;
                            }
                            break;
                    }
                });
                var lockHandler = void 0;
                nodes.on('lock unlock', lockHandler = function lockHandler() {
                    var node = this;
                    var scrCola = node.scratch().cola;
                    scrCola.fixed = node.locked();
                    if (node.locked()) adaptor.dragstart(scrCola);
                    else adaptor.dragend(scrCola);
                });
                // add nodes to cola
                adaptor.nodes(nonparentNodes.map(function(node, i) {
                    var padding = getOptVal(options.nodeSpacing, node);
                    var pos = node.position();
                    var dimensions = node.layoutDimensions(options);
                    var struct = node.scratch().cola = {
                        x: options.randomize && !node.locked() || pos.x === undefined ? Math.round(Math.random() * bb.w) : pos.x,
                        y: options.randomize && !node.locked() || pos.y === undefined ? Math.round(Math.random() * bb.h) : pos.y,
                        width: dimensions.w + 2 * padding,
                        height: dimensions.h + 2 * padding,
                        index: i,
                        fixed: node.locked()
                    };
                    return struct;
                }));
                // the constraints to be added on nodes
                var constraints = [];
                if (options.alignment) {
                    // then set alignment constraints
                    if (options.alignment.vertical) {
                        var verticalAlignments = options.alignment.vertical;
                        verticalAlignments.forEach(function(alignment) {
                            var offsetsX = [];
                            alignment.forEach(function(nodeData) {
                                var node = nodeData.node;
                                var scrCola = node.scratch().cola;
                                var index = scrCola.index;
                                offsetsX.push({
                                    node: index,
                                    offset: nodeData.offset ? nodeData.offset : 0
                                });
                            });
                            constraints.push({
                                type: 'alignment',
                                axis: 'x',
                                offsets: offsetsX
                            });
                        });
                    }
                    if (options.alignment.horizontal) {
                        var horizontalAlignments = options.alignment.horizontal;
                        horizontalAlignments.forEach(function(alignment) {
                            var offsetsY = [];
                            alignment.forEach(function(nodeData) {
                                var node = nodeData.node;
                                var scrCola = node.scratch().cola;
                                var index = scrCola.index;
                                offsetsY.push({
                                    node: index,
                                    offset: nodeData.offset ? nodeData.offset : 0
                                });
                            });
                            constraints.push({
                                type: 'alignment',
                                axis: 'y',
                                offsets: offsetsY
                            });
                        });
                    }
                }
                // if gapInequalities variable is set add each inequality constraint to list of constraints
                if (options.gapInequalities) options.gapInequalities.forEach(function(inequality) {
                    // for the constraints to be passed to cola layout adaptor use indices of nodes,
                    // not the nodes themselves
                    var leftIndex = inequality.left.scratch().cola.index;
                    var rightIndex = inequality.right.scratch().cola.index;
                    constraints.push({
                        axis: inequality.axis,
                        left: leftIndex,
                        right: rightIndex,
                        gap: inequality.gap,
                        equality: inequality.equality
                    });
                });
                // add constraints if any
                if (constraints.length > 0) adaptor.constraints(constraints);
                // add compound nodes to cola
                adaptor.groups(parentNodes.map(function(node, i) {
                    // add basic group incl leaf nodes
                    var optPadding = getOptVal(options.nodeSpacing, node);
                    var getPadding = function getPadding(d) {
                        return parseFloat(node.style('padding-' + d));
                    };
                    var pleft = getPadding('left') + optPadding;
                    var pright = getPadding('right') + optPadding;
                    var ptop = getPadding('top') + optPadding;
                    var pbottom = getPadding('bottom') + optPadding;
                    node.scratch().cola = {
                        index: i,
                        padding: Math.max(pleft, pright, ptop, pbottom),
                        // leaves should only contain direct descendants (children),
                        // not the leaves of nested compound nodes or any nodes that are compounds themselves
                        leaves: node.children().intersection(nonparentNodes).map(function(child) {
                            return child[0].scratch().cola.index;
                        }),
                        fixed: node.locked()
                    };
                    return node;
                }).map(function(node) {
                    // add subgroups
                    node.scratch().cola.groups = node.children().intersection(parentNodes).map(function(child) {
                        return child.scratch().cola.index;
                    });
                    return node.scratch().cola;
                }));
                // get the edge length setting mechanism
                var length = void 0;
                var lengthFnName = void 0;
                if (options.edgeLength != null) {
                    length = options.edgeLength;
                    lengthFnName = 'linkDistance';
                } else if (options.edgeSymDiffLength != null) {
                    length = options.edgeSymDiffLength;
                    lengthFnName = 'symmetricDiffLinkLengths';
                } else if (options.edgeJaccardLength != null) {
                    length = options.edgeJaccardLength;
                    lengthFnName = 'jaccardLinkLengths';
                } else {
                    length = 100;
                    lengthFnName = 'linkDistance';
                }
                var lengthGetter = function lengthGetter(link) {
                    return link.calcLength;
                };
                // add the edges to cola
                adaptor.links(edges.stdFilter(function(edge) {
                    return nonparentNodes.contains(edge.source()) && nonparentNodes.contains(edge.target());
                }).map(function(edge) {
                    var c = edge.scratch().cola = {
                        source: edge.source()[0].scratch().cola.index,
                        target: edge.target()[0].scratch().cola.index
                    };
                    if (length != null) c.calcLength = getOptVal(length, edge);
                    return c;
                }));
                adaptor.size([
                    bb.w,
                    bb.h
                ]);
                if (length != null) adaptor[lengthFnName](lengthGetter);
                // set the flow of cola
                if (options.flow) {
                    var flow = void 0;
                    var defAxis = 'y';
                    var defMinSep = 50;
                    if (isString(options.flow)) flow = {
                        axis: options.flow,
                        minSeparation: defMinSep
                    };
                    else if (isNumber(options.flow)) flow = {
                        axis: defAxis,
                        minSeparation: options.flow
                    };
                    else if (isObject(options.flow)) {
                        flow = options.flow;
                        flow.axis = flow.axis || defAxis;
                        flow.minSeparation = flow.minSeparation != null ? flow.minSeparation : defMinSep;
                    } else // e.g. options.flow: true
                    flow = {
                        axis: defAxis,
                        minSeparation: defMinSep
                    };
                    adaptor.flowLayout(flow.axis, flow.minSeparation);
                }
                layout.trigger({
                    type: 'layoutstart',
                    layout: layout
                });
                adaptor.avoidOverlaps(options.avoidOverlap).handleDisconnected(options.handleDisconnected).start(options.unconstrIter, options.userConstIter, options.allConstIter, undefined, undefined, options.centerGraph);
                if (!options.infinite) setTimeout(function() {
                    if (!layout.manuallyStopped) adaptor.stop();
                }, options.maxSimulationTime);
                return this; // chaining
            };
            // called on continuous layouts to stop them before they finish
            ColaLayout.prototype.stop = function() {
                if (this.adaptor) {
                    this.manuallyStopped = true;
                    this.adaptor.stop();
                }
                return this; // chaining
            };
            module1.exports = ColaLayout;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Simple, internal Object.assign() polyfill for options objects etc.
            module1.exports = Object.assign != null ? Object.assign.bind(Object) : function(tgt) {
                for(var _len = arguments.length, srcs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)srcs[_key - 1] = arguments[_key];
                srcs.filter(function(src) {
                    return src != null;
                }).forEach(function(src) {
                    Object.keys(src).forEach(function(k) {
                        return tgt[k] = src[k];
                    });
                });
                return tgt;
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // default layout options
            var defaults = {
                animate: true,
                refresh: 1,
                maxSimulationTime: 4000,
                ungrabifyWhileSimulating: false,
                fit: true,
                padding: 30,
                boundingBox: undefined,
                nodeDimensionsIncludeLabels: false,
                // layout event callbacks
                ready: function ready() {},
                stop: function stop() {},
                // positioning options
                randomize: false,
                avoidOverlap: true,
                handleDisconnected: true,
                convergenceThreshold: 0.01,
                nodeSpacing: function nodeSpacing(node) {
                    return 10;
                },
                flow: undefined,
                alignment: undefined,
                gapInequalities: undefined,
                centerGraph: true,
                // different methods of specifying edge length
                // each can be a constant numerical value or a function like `function( edge ){ return 2; }`
                edgeLength: undefined,
                edgeSymDiffLength: undefined,
                edgeJaccardLength: undefined,
                // iterations of cola algorithm; uses default values on undefined
                unconstrIter: undefined,
                userConstIter: undefined,
                allConstIter: undefined,
                // infinite layout options
                infinite: false // overrides all other options for a forces-all-the-time mode
            };
            module1.exports = defaults;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var impl = __webpack_require__(0);
            // registers the extension on a cytoscape lib ref
            var register = function register(cytoscape1) {
                if (!cytoscape1) return;
                 // can't register if cytoscape unspecified
                cytoscape1('layout', 'cola', impl); // register with cytoscape.js
            };
            if (typeof cytoscape !== 'undefined') // expose to global cytoscape (i.e. window.cytoscape)
            register(cytoscape);
            module1.exports = register;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var raf = void 0;
            if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== "undefined") raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function(fn) {
                return setTimeout(fn, 16);
            };
            else // if not available, all you get is immediate calls
            raf = function raf(cb) {
                cb();
            };
            module1.exports = raf;
        /***/ },
        /* 5 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_5__;
        /***/ }
    ]);
});


var $e767d170f347f030$exports = {};


(function webpackUniversalModuleDefinition(root, factory) {
    $e767d170f347f030$exports = factory((parcelRequire("46LIa")), (parcelRequire("54IE7")));
})($e767d170f347f030$exports, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_3__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 15);
    /******/ }([
        /* 0 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_0__;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * This class maintains the constants used by CiSE layout.
 *
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ var FDLayoutConstants = __webpack_require__(0).layoutBase.FDLayoutConstants;
            function CiSEConstants() {}
            for(var prop in FDLayoutConstants)CiSEConstants[prop] = FDLayoutConstants[prop];
            // -----------------------------------------------------------------------------
            // Section: CiSE layout user options
            // -----------------------------------------------------------------------------
            CiSEConstants.DEFAULT_SPRING_STRENGTH = 1.5 * FDLayoutConstants.DEFAULT_SPRING_STRENGTH;
            // Amount of separation of nodes on the associated circle
            CiSEConstants.DEFAULT_NODE_SEPARATION = FDLayoutConstants.DEFAULT_EDGE_LENGTH / 4;
            // Inter-cluster edge length factor (2.0 means inter-cluster edges should be
            // twice as long as intra-cluster edges)
            CiSEConstants.DEFAULT_IDEAL_INTER_CLUSTER_EDGE_LENGTH_COEFF = 1.4;
            // Whether to enable pulling nodes inside of the circles
            CiSEConstants.DEFAULT_ALLOW_NODES_INSIDE_CIRCLE = false;
            // Max percentage of the nodes in a circle that can be inside the circle
            CiSEConstants.DEFAULT_MAX_RATIO_OF_NODES_INSIDE_CIRCLE = 0.1;
            // -----------------------------------------------------------------------------
            // Section: CiSE layout remaining constants
            // -----------------------------------------------------------------------------
            // Ideal length of an edge incident with an inner-node
            CiSEConstants.DEFAULT_INNER_EDGE_LENGTH = FDLayoutConstants.DEFAULT_EDGE_LENGTH / 3;
            // Maximum rotation angle
            CiSEConstants.MAX_ROTATION_ANGLE = Math.PI / 36.0;
            // Minimum rotation angle
            CiSEConstants.MIN_ROTATION_ANGLE = -CiSEConstants.MAX_ROTATION_ANGLE;
            // Number of iterations without swap or swap prepartion
            CiSEConstants.SWAP_IDLE_DURATION = 45;
            // Number of iterations required for collecting information about swapping
            CiSEConstants.SWAP_PREPERATION_DURATION = 5;
            // Number of iterations that should be done in between two swaps.
            CiSEConstants.SWAP_PERIOD = CiSEConstants.SWAP_IDLE_DURATION + CiSEConstants.SWAP_PREPERATION_DURATION;
            // Number of iterations during which history (of pairs swapped) kept
            CiSEConstants.SWAP_HISTORY_CLEARANCE_PERIOD = 6 * CiSEConstants.SWAP_PERIOD;
            // Buffer for swapping
            CiSEConstants.MIN_DISPLACEMENT_FOR_SWAP = 6;
            // Number of iterations that should be done in between two flips.
            CiSEConstants.REVERSE_PERIOD = 25;
            module1.exports = CiSEConstants;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Simple, internal Object.assign() polyfill for options objects etc.
            module1.exports = Object.assign != null ? Object.assign.bind(Object) : function(tgt) {
                for(var _len = arguments.length, srcs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)srcs[_key - 1] = arguments[_key];
                srcs.forEach(function(src) {
                    Object.keys(src).forEach(function(k) {
                        return tgt[k] = src[k];
                    });
                });
                return tgt;
            };
        /***/ },
        /* 3 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_3__;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 *
 * Choose the type of layout that best suits your usecase as a starting point.
 *
 * A discrete layout is one that algorithmically sets resultant positions.  It
 * does not have intermediate positions.
 *
 * A continuous layout is one that updates positions continuously, like a force-
 * directed / physics simulation layout.
 */ module1.exports = __webpack_require__(16);
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * This class implements data and functionality required for CiSE layout per
 * cluster.
 *
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ var LGraph = __webpack_require__(0).layoutBase.LGraph;
            var IGeometry = __webpack_require__(0).layoutBase.IGeometry;
            var NeedlemanWunsch = __webpack_require__(0).layoutBase.NeedlemanWunsch;
            var CircularForce = __webpack_require__(14);
            var CiSEConstants = __webpack_require__(1);
            var CiSEInterClusterEdgeInfo = __webpack_require__(8);
            var CiSEInterClusterEdgeSort = __webpack_require__(9);
            function CiSECircle(parent, graphMgr, vNode) {
                LGraph.call(this, parent, graphMgr, vNode);
                // Holds the intra-cluster edges of this circle, initially it is null. It
                // will be calculated and stored when getIntraClusterEdges method is first
                // called.
                this.intraClusterEdges = null;
                // Holds the inter-cluster edges of this circle, initially it is null. It
                // will be calculated and stored when getInterClusterEdges method is first
                // called.
                this.interClusterEdges = null;
                // Holds the nodes which don't have neighbors outside this circle
                this.inNodes = [];
                // Holds the nodes which have neighbors outside this circle
                this.outNodes = [];
                // Holds the nodes which are on the circle
                this.onCircleNodes = [];
                // Holds the nodes which are inside the circle
                this.inCircleNodes = [];
                // The radius of this circle, calculated with respect to the dimensions of
                // the nodes on this circle and node separation options
                this.radius = 0;
                // Holds the pairwise ordering of on-circle nodes computed in earlier stages
                // of layout. Value at i,j means the following assuming u and v are
                // on-circle nodes with orderIndex i and j, respectively. Value at i,j is
                // true (false) if u and v are closer when we go from u to v in clockwise
                // (counter-clockwise) direction. Here we base distance on the angles of the
                // two nodes as opposed to their order indices (this might make a difference
                // due to non-uniform node sizes).
                this.orderMatrix = null;
                // Whether or not this circle may be reserved for the purpose of improving
                // inter-cluster edge crossing number as we do not want to redundantly
                // reverse clusters and end up in oscillating situtations. Clusters with
                // special circumstances (e.g. less than two inter-cluster edge) are set as
                // may not be reversed as well.
                this.mayBeReversed = true;
            }
            CiSECircle.prototype = Object.create(LGraph.prototype);
            for(var prop in LGraph)CiSECircle[prop] = LGraph[prop];
            // -----------------------------------------------------------------------------
            // Section: Accessors and mutators
            // -----------------------------------------------------------------------------
            // This method returns the radius of this circle.
            CiSECircle.prototype.setRadius = function(radius) {
                this.radius = radius;
            };
            // This method sets the radius of this circle.
            CiSECircle.prototype.getRadius = function() {
                return this.radius;
            };
            // This method returns nodes that don't have neighbors outside this circle.
            CiSECircle.prototype.getInNodes = function() {
                return this.inNodes;
            };
            // This method returns nodes that have neighbors outside this circle.
            CiSECircle.prototype.getOutNodes = function() {
                return this.outNodes;
            };
            // This method returns nodes that don't have neighbors outside this circle.
            CiSECircle.prototype.getOnCircleNodes = function() {
                return this.onCircleNodes;
            };
            // This method returns nodes that don't have neighbors outside this circle.
            CiSECircle.prototype.getInCircleNodes = function() {
                return this.inCircleNodes;
            };
            CiSECircle.prototype.setMayNotBeReversed = function() {
                this.mayBeReversed = false;
            };
            // This method returns whether or not this circle has been reversed.
            CiSECircle.prototype.getMayBeReversed = function() {
                return this.mayBeReversed;
            };
            // This method downcasts and returns the child at given index.
            CiSECircle.prototype.getChildAt = function(index) {
                return this.onCircleNodes[index];
            };
            /**
 * This method returns the inter-cluster edges whose one end is in this
 * cluster.
 */ CiSECircle.prototype.getInterClusterEdges = function() {
                var self = this;
                if (this.interClusterEdges === null) {
                    this.interClusterEdges = [];
                    this.outNodes.forEach(function(node) {
                        var edgesToAdd = node.getOnCircleNodeExt().getInterClusterEdges();
                        for(var i = 0; i < edgesToAdd.length; i++)self.interClusterEdges.push(edgesToAdd[i]);
                    });
                }
                return this.interClusterEdges;
            };
            /**
 * This method returns the intra cluster edges of this circle
 */ CiSECircle.prototype.getIntraClusterEdges = function() {
                var self = this;
                if (this.intraClusterEdges === null) {
                    this.intraClusterEdges = [];
                    var allEdges = this.getEdges();
                    allEdges.forEach(function(edge) {
                        if (edge.isIntraEdge()) self.intraClusterEdges.push(edge);
                    });
                }
                return this.intraClusterEdges;
            };
            // -----------------------------------------------------------------------------
            // Section: Other methods
            // -----------------------------------------------------------------------------
            // This method calculates and sets dimensions of the parent node of this
            // circle. Parent node is centered to be at the same location of the
            // associated circle but its dimensions are larger than the circle by a
            // factor (must be >= 1 to ensure all nodes are enclosed within its
            // rectangle) of the largest dimension (width or height) of on-circle nodes
            // so that it completely encapsulates the nodes on this circle.
            CiSECircle.prototype.calculateParentNodeDimension = function() {
                var self = this;
                var maxOnCircleNodeDimension = Number.MIN_SAFE_INTEGER;
                for(var i = 0; i < this.onCircleNodes.length; i++){
                    var node = this.onCircleNodes[i];
                    if (node.getWidth() > maxOnCircleNodeDimension) maxOnCircleNodeDimension = node.getWidth();
                    if (node.getHeight() > maxOnCircleNodeDimension) maxOnCircleNodeDimension = node.getHeight();
                }
                var dimension = 2.0 * (self.radius + self.margin) + maxOnCircleNodeDimension;
                var parentNode = self.getParent();
                parentNode.setHeight(dimension);
                parentNode.setWidth(dimension);
            };
            /*
 * This method computes the order matrix of this circle. This should be
 * called only once at early stages of layout and is used to hold the order
 * of on-circle nodes as specified.
 */ CiSECircle.prototype.computeOrderMatrix = function() {
                var N = this.onCircleNodes.length;
                // 'Two Dimensional array' (array of arrays in JS) with bool cell values
                this.orderMatrix = new Array(N);
                for(var i = 0; i < this.orderMatrix.length; i++)this.orderMatrix[i] = new Array(N);
                for(var _i = 0; _i < N; _i++){
                    for(var j = 0; j < N; j++)if (j > _i) {
                        var angleDiff = this.onCircleNodes[j].getOnCircleNodeExt().getAngle() - this.onCircleNodes[_i].getOnCircleNodeExt().getAngle();
                        if (angleDiff < 0) angleDiff += IGeometry.TWO_PI;
                        if (angleDiff <= Math.PI) {
                            this.orderMatrix[_i][j] = true;
                            this.orderMatrix[j][_i] = false;
                        } else {
                            this.orderMatrix[_i][j] = false;
                            this.orderMatrix[j][_i] = true;
                        }
                    }
                }
            };
            /**
 * This method rotates this circle by iterating over and adjusting the
 * relative positioning of all nodes on this circle by the calculated angle
 * with respect to the rotation amount of the owner node.
 */ CiSECircle.prototype.rotate = function() {
                // Take size into account when reflecting total force into rotation!
                var parentNode = this.getParent();
                var noOfNodes = this.getOnCircleNodes().length;
                var rotationAmount = parentNode.rotationAmount / noOfNodes; // Think about the momentum
                var layout = this.getGraphManager().getLayout();
                if (rotationAmount !== 0.0) {
                    // The angle (θ) of rotation applied to each node
                    var theta = rotationAmount / this.radius;
                    if (theta > CiSEConstants.MAX_ROTATION_ANGLE) theta = CiSEConstants.MAX_ROTATION_ANGLE;
                    else if (theta < CiSEConstants.MIN_ROTATION_ANGLE) theta = CiSEConstants.MIN_ROTATION_ANGLE;
                    for(var i = 0; i < noOfNodes; i++){
                        var onCircleNode = this.getChildAt(i);
                        var onCircleNodeExt = onCircleNode.getOnCircleNodeExt();
                        onCircleNodeExt.setAngle(onCircleNodeExt.getAngle() + theta); // Change the angle
                        onCircleNodeExt.updatePosition(); // Apply the above angle change to its position
                    }
                    // Update CiSELayout displacement
                    layout.totalDisplacement += parentNode.rotationAmount;
                    // Reset rotationAmount
                    parentNode.rotationAmount = 0.0;
                }
            };
            /**
 * This method returns the pairwise order of the input nodes as computed and
 * held in orderMatrix.
 */ CiSECircle.prototype.getOrder = function(nodeA, nodeB) {
                return this.orderMatrix[nodeA.getOnCircleNodeExt().getIndex()][nodeB.getOnCircleNodeExt().getIndex()];
            };
            /**
 * This method gets the end node of the input inter-cluster edge in this
 * cluster.
 */ CiSECircle.prototype.getThisEnd = function(edge) {
                var sourceNode = edge.getSource();
                var targetNode = edge.getTarget();
                if (sourceNode.getOwner() === this) return sourceNode;
                else return targetNode;
            };
            /**
 * This method gets the end node of the input inter-cluster edge not in this
 * cluster.
 */ CiSECircle.prototype.getOtherEnd = function(edge) {
                var sourceNode = edge.getSource();
                var targetNode = edge.getTarget();
                if (sourceNode.getOwner() === this) return targetNode;
                else return sourceNode;
            };
            /**
 * This method calculates and returns rotational and translational parts of
 * the total force calculated for the given node. The translational part is
 * composed of components in x and y directions.
 */ CiSECircle.prototype.decomposeForce = function(node) {
                var circularForce = void 0;
                if (node.displacementX !== 0.0 || node.displacementY !== 0.0) {
                    var ownerNode = this.getParent();
                    var Cx = ownerNode.getCenterX();
                    var Cy = ownerNode.getCenterY();
                    var Nx = node.getCenterX();
                    var Ny = node.getCenterY();
                    var Fx = node.displacementX;
                    var Fy = node.displacementY;
                    var C_angle = IGeometry.angleOfVector(Cx, Cy, Nx, Ny);
                    var F_angle = IGeometry.angleOfVector(0.0, 0.0, Fx, Fy);
                    var C_rev_angle = C_angle + Math.PI;
                    // Check whether F lies between C and its opposite angle C-reverse;
                    // if so, rotation is +ve (clockwise); otherwise, it's -ve.
                    // We handle angles greater than 360 specially in the else part.
                    var isRotationClockwise = void 0;
                    if (Math.PI <= C_rev_angle && C_rev_angle < IGeometry.TWO_PI) isRotationClockwise = C_angle <= F_angle && F_angle < C_rev_angle;
                    else {
                        C_rev_angle -= IGeometry.TWO_PI;
                        isRotationClockwise = !(C_rev_angle <= F_angle && F_angle < C_angle);
                    }
                    var angle_diff = Math.abs(C_angle - F_angle);
                    var F_magnitude = Math.sqrt(Fx * Fx + Fy * Fy);
                    var R_magnitude = Math.abs(Math.sin(angle_diff) * F_magnitude);
                    if (!isRotationClockwise) R_magnitude = -R_magnitude;
                    circularForce = new CircularForce(R_magnitude, Fx, Fy);
                } else circularForce = new CircularForce(0.0, 0.0, 0.0);
                return circularForce;
            };
            /**
 * This method swaps the nodes given as parameter and make necessary angle
 * and positioning updates.
 */ CiSECircle.prototype.swapNodes = function(first, second) {
                // Determine which node has smaller index
                var smallIndexNode = first;
                var bigIndexNode = second;
                var firstExt = first.getOnCircleNodeExt();
                var secondExt = second.getOnCircleNodeExt();
                if (smallIndexNode.getOnCircleNodeExt().getIndex() > second.getOnCircleNodeExt().getIndex()) {
                    smallIndexNode = second;
                    bigIndexNode = first;
                }
                // Check the exceptional case where the small index node is at 0 index
                // and the big index node is at the last index of the circle. In this
                // case, we treat smaller index node as bigger index node and vice versa
                if (smallIndexNode.getOnCircleNodeExt().getPrevNode() === bigIndexNode) {
                    var tempNode = bigIndexNode;
                    bigIndexNode = smallIndexNode;
                    smallIndexNode = tempNode;
                }
                var smallIndexNodeExt = smallIndexNode.getOnCircleNodeExt();
                var bigIndexNodeExt = bigIndexNode.getOnCircleNodeExt();
                // Calculate the angle for the big index node
                var smallIndexPrevNode = smallIndexNodeExt.getPrevNode();
                var layout = this.getGraphManager().getLayout();
                var nodeSeparation = layout.getNodeSeparation();
                var angle = (smallIndexPrevNode.getOnCircleNodeExt().getAngle() + (smallIndexPrevNode.getHalfTheDiagonal() + bigIndexNode.getHalfTheDiagonal() + nodeSeparation) / this.radius) % (2 * Math.PI);
                bigIndexNodeExt.setAngle(angle);
                // Calculate the angle for the small index node
                angle = (bigIndexNodeExt.getAngle() + (bigIndexNode.getHalfTheDiagonal() + smallIndexNode.getHalfTheDiagonal() + nodeSeparation) / this.radius) % (2 * Math.PI);
                smallIndexNodeExt.setAngle(angle);
                smallIndexNodeExt.updatePosition();
                bigIndexNodeExt.updatePosition();
                var tempIndex = firstExt.getIndex();
                firstExt.setIndex(secondExt.getIndex());
                secondExt.setIndex(tempIndex);
                this.getOnCircleNodes()[firstExt.getIndex()] = first;
                this.getOnCircleNodes()[secondExt.getIndex()] = second;
                firstExt.updateSwappingConditions();
                secondExt.updateSwappingConditions();
                if (firstExt.getNextNode() === second) {
                    firstExt.getPrevNode().getOnCircleNodeExt().updateSwappingConditions();
                    secondExt.getNextNode().getOnCircleNodeExt().updateSwappingConditions();
                } else {
                    firstExt.getNextNode().getOnCircleNodeExt().updateSwappingConditions();
                    secondExt.getPrevNode().getOnCircleNodeExt().updateSwappingConditions();
                }
            };
            /*
 * This method checks to see for each cluster (in no particular order)
 * whether or not reversing the order of the cluster would reduce
 * inter-cluster edge crossings. The decision is based on global sequence
 * alignment of the order of the nodes in the cluster vs. the order of their
 * neighbors in other clusters. A cluster that was reversed earlier is not
 * reversed again to avoid oscillations. It returns true if reverse order
 * is adapted.
 */ CiSECircle.prototype.checkAndReverseIfReverseIsBetter = function() {
                // First form the list of inter cluster edges of this cluster
                var interClusterEdges = this.getInterClusterEdges();
                var interClusterEdgeInfos = new Array(interClusterEdges.length);
                // Now form the info array that contains not only the inter-cluster
                // edges but also other information such as the angle they make w.r.t.
                // the cluster center and neighboring node center.
                // In the meantime, calculate how many inter-cluster edge each on-circle
                // node is incident with. This information will be used to duplicate
                // char codes of those nodes with 2 or more inter-graph edge.
                var angle = void 0;
                var clusterCenter = this.getParent().getCenter();
                var interClusterEdge = void 0;
                var endInThisCluster = void 0;
                var endInOtherCluster = void 0;
                var centerOfEndInOtherCluster = void 0;
                var nodeCount = this.onCircleNodes.length;
                var interClusterEdgeDegree = new Array(nodeCount);
                for(var i = 0; i < nodeCount; i++)interClusterEdgeDegree[i] = 0;
                var noOfOnCircleNodesToBeRepeated = 0;
                for(var _i2 = 0; _i2 < interClusterEdges.length; _i2++){
                    interClusterEdge = interClusterEdges[_i2];
                    endInOtherCluster = this.getOtherEnd(interClusterEdge);
                    centerOfEndInOtherCluster = endInOtherCluster.getCenter();
                    angle = IGeometry.angleOfVector(clusterCenter.x, clusterCenter.y, centerOfEndInOtherCluster.x, centerOfEndInOtherCluster.y);
                    interClusterEdgeInfos[_i2] = new CiSEInterClusterEdgeInfo(interClusterEdge, angle);
                    endInThisCluster = this.getThisEnd(interClusterEdge);
                    interClusterEdgeDegree[endInThisCluster.getOnCircleNodeExt().getIndex()]++;
                    if (interClusterEdgeDegree[endInThisCluster.getOnCircleNodeExt().getIndex()] > 1) noOfOnCircleNodesToBeRepeated++;
                }
                // On circle nodes will be ordered by their indices in this array
                var onCircleNodes = this.onCircleNodes;
                // Form arrays for current and reversed order of nodes of this cluster
                // Take any repetitions into account (if node with char code 'b' is
                // incident with 3 inter-cluster edges, then repeat 'b' 2 times)
                var nodeCountWithRepetitions = nodeCount + noOfOnCircleNodesToBeRepeated;
                var clusterNodes = new Array(2 * nodeCountWithRepetitions);
                var reversedClusterNodes = new Array(2 * nodeCountWithRepetitions);
                var node = void 0;
                var index = -1;
                for(var _i3 = 0; _i3 < nodeCount; _i3++){
                    node = onCircleNodes[_i3];
                    // on circle nodes with no inter-cluster edges are also considered
                    if (interClusterEdgeDegree[_i3] === 0) interClusterEdgeDegree[_i3] = 1;
                    for(var j = 0; j < interClusterEdgeDegree[_i3]; j++){
                        index++;
                        clusterNodes[index] = clusterNodes[nodeCountWithRepetitions + index] = reversedClusterNodes[nodeCountWithRepetitions - 1 - index] = reversedClusterNodes[2 * nodeCountWithRepetitions - 1 - index] = node.getOnCircleNodeExt().getCharCode();
                    }
                }
                // Now sort the inter-cluster edges w.r.t. their angles
                var edgeSorter = new CiSEInterClusterEdgeSort(this, interClusterEdgeInfos);
                // Form an array for order of neighboring nodes of this cluster
                var neighborNodes = new Array(interClusterEdgeInfos.length);
                for(var _i4 = 0; _i4 < interClusterEdgeInfos.length; _i4++){
                    interClusterEdge = interClusterEdgeInfos[_i4].getEdge();
                    endInThisCluster = this.getThisEnd(interClusterEdge);
                    neighborNodes[_i4] = endInThisCluster.getOnCircleNodeExt().getCharCode();
                }
                // Now calculate a score for the alignment of the current order of the
                // nodes of this cluster w.r.t. to their neighbors order
                var alignmentScoreCurrent = this.computeAlignmentScore(clusterNodes, neighborNodes);
                // Then calculate a score for the alignment of the reversed order of the
                // nodes of this cluster w.r.t. to their neighbors order
                if (alignmentScoreCurrent !== -1) {
                    var alignmentScoreReversed = this.computeAlignmentScore(reversedClusterNodes, neighborNodes);
                    // Check if reversed order is *substantially* better aligned with
                    // the order of the neighbors of this cluster around the cluster; if
                    // so, reverse the order
                    if (alignmentScoreReversed !== -1) {
                        if (alignmentScoreReversed > alignmentScoreCurrent) {
                            this.reverseNodes();
                            this.setMayNotBeReversed();
                            return true;
                        }
                    }
                }
                return false;
            };
            /**
 * This method computes an alignment for the two input char arrays and
 * returns the alignment amount. If alignment is unsuccessful for some
 * reason, it returns -1.
 */ CiSECircle.prototype.computeAlignmentScore = function(charArrayReader1, charArrayReader2) {
                var aligner = new NeedlemanWunsch(charArrayReader1, charArrayReader2, 20, -1, -2);
                return aligner.getScore();
            };
            /**
 * This method reverses the nodes on this circle.
 */ CiSECircle.prototype.reverseNodes = function() {
                var onCircleNodes = this.getOnCircleNodes();
                var noOfNodesOnCircle = this.getOnCircleNodes().length;
                for(var i = 0; i < noOfNodesOnCircle; i++){
                    var node = onCircleNodes[i];
                    var nodeExt = node.getOnCircleNodeExt();
                    nodeExt.setIndex((noOfNodesOnCircle - nodeExt.getIndex()) % noOfNodesOnCircle);
                }
                this.reCalculateNodeAnglesAndPositions();
            };
            /**
 * This method removes given on-circle node from the circle and calls
 * reCalculateCircleSizeAndRadius and  reCalculateNodeAnglesAndPositions.
 * This method should be called when an inner node is found and to be moved
 * inside the circle.
 * @param node
 */ CiSECircle.prototype.moveOnCircleNodeInside = function(node) {
                // Remove the node from on-circle nodes list and add it to in-circle
                // nodes list
                // Make sure it has not been already moved to the out node list
                var index = this.onCircleNodes.indexOf(node);
                if (index > -1) this.onCircleNodes.splice(index, 1);
                this.inCircleNodes.push(node);
                // Re-adjust all order indexes of remaining on circle nodes.
                for(var i = 0; i < this.onCircleNodes.length; i++){
                    var onCircleNode = this.onCircleNodes[i];
                    onCircleNode.getOnCircleNodeExt().setIndex(i);
                }
                // De-register extension
                node.setAsNonOnCircleNode();
                // calculateRadius
                this.reCalculateCircleSizeAndRadius();
                //calculateNodePositions
                this.reCalculateNodeAnglesAndPositions();
                node.setCenter(this.getParent().getCenterX(), this.getParent().getCenterY());
            };
            /**
 * This method calculates the size and radius of this circle with respect
 * to the sizes of the vertices and the node separation parameter.
 */ CiSECircle.prototype.reCalculateCircleSizeAndRadius = function() {
                var totalDiagonal = 0;
                var onCircleNodes = this.getOnCircleNodes();
                for(var i = 0; i < onCircleNodes.length; i++){
                    var node = onCircleNodes[i];
                    var temp = node.getWidth() * node.getWidth() + node.getHeight() * node.getHeight();
                    totalDiagonal += Math.sqrt(temp);
                }
                var layout = this.getGraphManager().getLayout();
                var nodeSeparation = layout.getNodeSeparation();
                var perimeter = totalDiagonal + this.getOnCircleNodes().length * nodeSeparation;
                this.radius = perimeter / (2 * Math.PI);
                this.calculateParentNodeDimension();
            };
            /**
 * This method goes over all on-circle nodes and re-calculates their angles
 * and corresponding positions. This method should be called when on-circle
 * nodes (content or order) have been changed for this circle.
 */ CiSECircle.prototype.reCalculateNodeAnglesAndPositions = function() {
                var layout = this.getGraphManager().getLayout();
                var nodeSeparation = layout.getNodeSeparation();
                // It is important that we sort these on-circle nodes in place.
                var inOrderCopy = this.onCircleNodes;
                inOrderCopy.sort(function(a, b) {
                    return a.getOnCircleNodeExt().getIndex() - b.getOnCircleNodeExt().getIndex();
                });
                var parentCenterX = this.getParent().getCenterX();
                var parentCenterY = this.getParent().getCenterY();
                for(var i = 0; i < inOrderCopy.length; i++){
                    var node = inOrderCopy[i];
                    var angle = void 0;
                    if (i === 0) angle = 0.0;
                    else {
                        var previousNode = inOrderCopy[i - 1];
                        // => angle in radian = (2*PI)*(circular distance/(2*PI*r))
                        angle = previousNode.getOnCircleNodeExt().getAngle() + (node.getHalfTheDiagonal() + nodeSeparation + previousNode.getHalfTheDiagonal()) / this.radius;
                    }
                    node.getOnCircleNodeExt().setAngle(angle);
                    node.setCenter(parentCenterX + this.radius * Math.cos(angle), parentCenterY + this.radius * Math.sin(angle));
                }
            };
            module1.exports = CiSECircle;
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * This class implements data and functionality required for CiSE layout per
 * edge.
 *
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ var FDLayoutEdge = __webpack_require__(0).layoutBase.FDLayoutEdge;
            // -----------------------------------------------------------------------------
            // Section: Constructors and initialization
            // -----------------------------------------------------------------------------
            // Constructor
            function CiSEEdge(source, target, vEdge) {
                FDLayoutEdge.call(this, source, target, vEdge);
                /**
     * Flag for inter-graph edges in the base is not good enough. So we define
     * this one to mean: a CiSE edge is intra-cluster only if both its ends are
     * on a common circle; not intra-cluster, otherwise!
     */ this.isIntraCluster = true;
            }
            CiSEEdge.prototype = Object.create(FDLayoutEdge.prototype);
            for(var property in FDLayoutEdge)CiSEEdge[property] = FDLayoutEdge[property];
            CiSEEdge.prototype.isIntraEdge = function() {
                return this.isIntraCluster;
            };
            // -----------------------------------------------------------------------------
            // Section: Remaining methods
            // -----------------------------------------------------------------------------
            /**
 * This method checks whether this edge crosses with the input edge. It
 * returns false, if any of the vertices those edges are incident to are
 * not yet placed on the circle.
 */ CiSEEdge.prototype.crossesWithEdge = function(other) {
                var result = false;
                var sourceExt = this.getSource().getOnCircleNodeExt();
                var targetExt = this.getTarget().getOnCircleNodeExt();
                var otherSourceExt = other.getSource().getOnCircleNodeExt();
                var otherTargetExt = other.getTarget().getOnCircleNodeExt();
                var sourcePos = -1;
                var targetPos = -1;
                var otherSourcePos = -1;
                var otherTargetPos = -1;
                if (sourceExt !== null) sourcePos = sourceExt.getIndex();
                if (targetExt !== null) targetPos = targetExt.getIndex();
                if (otherSourceExt !== null) otherSourcePos = otherSourceExt.getIndex();
                if (otherTargetExt !== null) otherTargetPos = otherTargetExt.getIndex();
                if (!this.isInterGraph && !other.isInterGraph) {
                    if (this.source.getOwner() !== this.target.getOwner()) result = false;
                    else {
                        // if any of the vertices those two edges are not yet placed
                        if (sourcePos === -1 || targetPos === -1 || otherSourcePos === -1 || otherTargetPos === -1) result = false;
                        var otherSourceDist = otherSourceExt.getCircDistWithTheNode(sourceExt);
                        var otherTargetDist = otherTargetExt.getCircDistWithTheNode(sourceExt);
                        var thisTargetDist = targetExt.getCircDistWithTheNode(sourceExt);
                        if (thisTargetDist < Math.max(otherSourceDist, otherTargetDist) && thisTargetDist > Math.min(otherSourceDist, otherTargetDist) && otherTargetDist !== 0 && otherSourceDist !== 0) result = true;
                    }
                } else result = true;
                return result;
            };
            /**
 * This method calculates the total number of crossings of this edge with
 * all the edges given in the input list.
 */ CiSEEdge.prototype.calculateTotalCrossingWithList = function(edgeList) {
                var totalCrossing = 0;
                for(var i = 0; i < edgeList.length; i++)totalCrossing += this.crossingWithEdge(edgeList[i]);
                return totalCrossing;
            };
            /**
 * This method returns 1 if this edge crosses with the input edge, 0
 * otherwise.
 */ CiSEEdge.prototype.crossingWithEdge = function(other) {
                var crosses = this.crossesWithEdge(other);
                var result = 0;
                if (crosses) result = 1;
                return result;
            };
            module1.exports = CiSEEdge;
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * This class implements a graph-manager for CiSE layout specific data and
 * functionality.
 *
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ var LGraphManager = __webpack_require__(0).layoutBase.LGraphManager;
            // -----------------------------------------------------------------------------
            // Section: Constructors and initialization
            // -----------------------------------------------------------------------------
            function CiSEGraphManager(layout) {
                LGraphManager.call(this, layout);
                /**
     * All on-circle and other nodes (unclustered nodes and nodes representing
     * each cluster/circle) in this graph manager. For efficiency purposes we
     * hold references of these nodes that we operate on in arrays.
     */ this.onCircleNodes = [];
                this.inCircleNodes = [];
                this.nonOnCircleNodes = [];
            }
            CiSEGraphManager.prototype = Object.create(LGraphManager.prototype);
            for(var property in LGraphManager)CiSEGraphManager[property] = LGraphManager[property];
            // -----------------------------------------------------------------------------
            // Section: Accessors
            // -----------------------------------------------------------------------------
            // This method returns an array of all on-circle nodes.
            CiSEGraphManager.prototype.getOnCircleNodes = function() {
                return this.onCircleNodes;
            };
            // This method returns an array of all in-circle nodes.
            CiSEGraphManager.prototype.getInCircleNodes = function() {
                return this.inCircleNodes;
            };
            // This method returns an array of all nodes other than on-circle nodes.
            CiSEGraphManager.prototype.getNonOnCircleNodes = function() {
                return this.nonOnCircleNodes;
            };
            // This method sets the array of all on-circle nodes.
            CiSEGraphManager.prototype.setOnCircleNodes = function(nodes) {
                this.onCircleNodes = nodes;
            };
            // This method sets the array of all in-circle nodes.
            CiSEGraphManager.prototype.setInCircleNodes = function(nodes) {
                this.inCircleNodes = nodes;
            };
            // This method sets the array of all nodes other than on-circle nodes.
            CiSEGraphManager.prototype.setNonOnCircleNodes = function(nodes) {
                this.nonOnCircleNodes = nodes;
            };
            module1.exports = CiSEGraphManager;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * This class keeps the information of each inter-cluster edge of the associated
 * circle. It is to be used for sorting inter-cluster edges based on this info.
 *
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ function CiSEInterClusterEdgeInfo(edge, angle) {
                // Inter-cluster edge
                this.edge = edge;
                // Angle in radians (in clockwise direction from the positive x-axis) that
                // is computed for this inter-cluster edge based on the line segment with
                // one end as the center of the associated cluster and the other end being
                // the center of the source/target node of this inter-cluster edge that is
                // not in this cluster.
                this.angle = angle;
            }
            CiSEInterClusterEdgeInfo.prototype = Object.create(null);
            CiSEInterClusterEdgeInfo.prototype.getEdge = function() {
                return this.edge;
            };
            CiSEInterClusterEdgeInfo.prototype.getAngle = function() {
                return this.angle;
            };
            module1.exports = CiSEInterClusterEdgeInfo;
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /**
 * This class sorts the array of input edges based on the associated angles. If
 * angles turn out to be the same, then we sort the edges based on their
 * in-cluster end nodes' orders in clockwise direction. This information is
 * calculated beforehand and stored in a matrix in each associated circle.
 *
 */ var CiSEInterClusterEdgeSort = function() {
                function CiSEInterClusterEdgeSort(ownerCircle, A) {
                    _classCallCheck(this, CiSEInterClusterEdgeSort);
                    this.ownerCircle = ownerCircle;
                    this._quicksort(A, 0, A.length - 1);
                }
                _createClass(CiSEInterClusterEdgeSort, [
                    {
                        key: "compareFunction",
                        value: function compareFunction(a, b) {
                            if (b.getAngle() > a.getAngle()) return true;
                            else if (b.getAngle() === a.getAngle()) {
                                if (a === b) return false;
                                else return this.ownerCircle.getOrder(this.ownerCircle.getThisEnd(a.getEdge()), this.ownerCircle.getThisEnd(b.getEdge()));
                            } else return false;
                        }
                    },
                    {
                        key: "_quicksort",
                        value: function _quicksort(A, p, r) {
                            if (p < r) {
                                var q = this._partition(A, p, r);
                                this._quicksort(A, p, q);
                                this._quicksort(A, q + 1, r);
                            }
                        }
                    },
                    {
                        key: "_partition",
                        value: function _partition(A, p, r) {
                            var x = this._get(A, p);
                            var i = p;
                            var j = r;
                            while(true){
                                while(this.compareFunction(x, this._get(A, j)))j--;
                                while(this.compareFunction(this._get(A, i), x))i++;
                                if (i < j) {
                                    this._swap(A, i, j);
                                    i++;
                                    j--;
                                } else return j;
                            }
                        }
                    },
                    {
                        key: "_get",
                        value: function _get(object, index) {
                            return object[index];
                        }
                    },
                    {
                        key: "_set",
                        value: function _set(object, index, value) {
                            object[index] = value;
                        }
                    },
                    {
                        key: "_swap",
                        value: function _swap(A, i, j) {
                            var temp = this._get(A, i);
                            this._set(A, i, this._get(A, j));
                            this._set(A, j, temp);
                        }
                    }
                ]);
                return CiSEInterClusterEdgeSort;
            }();
            module1.exports = CiSEInterClusterEdgeSort;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * This class implements a Circular Spring Embedder (CiSE) layout algortithm.
 * The algorithm is used for layout of clustered nodes where nodes in each
 * cluster is drawn around a circle. The basic steps of the algorithm follows:
 * - Step 1: each cluster is laid out with AVSDF circular layout algorithm;
 * - Step 2: cluster graph (quotient graph of the clustered graph, where nodes
 *   correspond to clusters and edges correspond to inter-cluster edges) is laid
 *   out with a spring embedder to determine the initial layout;
 * - Steps 3-5: the cluster graph is laid out with a modified spring embedder,
 *   where the nodes corresponding to clusters are also allowed to rotate,
 *   indirectly affecting the layout of the nodes inside the clusters. In Step
 *   3, we allow flipping of clusters, whereas in Step 4, we allow swapping of
 *   neighboring node pairs in a cluster to improve inter-cluster edge crossings
 *   without increasing intra-cluster crossings.
 *
 *   The input view aspect of GraphManager is inherited from Java version of
 *   CiSE (Chilay) as a side effect. Ignore any references to 'view' elements.
 *
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ // -----------------------------------------------------------------------------
            // Section: Initializations
            // -----------------------------------------------------------------------------
            var Layout = __webpack_require__(0).layoutBase.FDLayout;
            var HashMap = __webpack_require__(0).layoutBase.HashMap;
            var PointD = __webpack_require__(0).layoutBase.PointD;
            var DimensionD = __webpack_require__(0).layoutBase.DimensionD;
            var AVSDFConstants = __webpack_require__(0).AVSDFConstants;
            var AVSDFLayout = __webpack_require__(0).AVSDFLayout;
            var CoSELayout = __webpack_require__(3).CoSELayout;
            var CoSEConstants = __webpack_require__(3).CoSEConstants;
            var CiSEConstants = __webpack_require__(1);
            var CiSEGraphManager = __webpack_require__(7);
            var CiSECircle = __webpack_require__(5);
            var CiSENode = __webpack_require__(11);
            var CiSEEdge = __webpack_require__(6);
            var CiSEOnCircleNodePair = __webpack_require__(13);
            // Constructor
            function CiSELayout() {
                Layout.call(this);
                /**
     * Whether it is incremental
     */ this.incremental = CiSEConstants.INCREMENTAL;
                /**
     * Separation of the nodes on each circle customizable by the user
     */ this.nodeSeparation = CiSEConstants.DEFAULT_NODE_SEPARATION;
                /**
     * Ideal edge length coefficient for inter-cluster edges
     */ this.idealInterClusterEdgeLengthCoefficient = CiSEConstants.DEFAULT_IDEAL_INTER_CLUSTER_EDGE_LENGTH_COEFF;
                /**
     * Decides whether pull on-circle nodes inside of the circle.
     */ this.allowNodesInsideCircle = CiSEConstants.DEFAULT_ALLOW_NODES_INSIDE_CIRCLE;
                /**
     * Max percentage of the nodes in a circle that can move inside the circle
     */ this.maxRatioOfNodesInsideCircle = CiSEConstants.DEFAULT_MAX_RATIO_OF_NODES_INSIDE_CIRCLE;
                /**
     * Current step of the layout process
     */ this.step = CiSELayout.STEP_NOT_STARTED;
                /**
     * Current phase of current step
     */ this.phase = CiSELayout.PHASE_NOT_STARTED;
                /**
     * Holds the set of pairs swapped in the last swap phase.
     */ this.swappedPairsInLastIteration = [];
                /**
     * Iterations in the runSpringEmbedderTicl function
     */ this.iterations = 0;
                this.oldTotalDisplacement = 0.0;
                /**
     * Cooling Factor Variables
     */ this.coolingCycle = 0;
                this.maxCoolingCycle = this.maxIterations / CiSEConstants.CONVERGENCE_CHECK_PERIOD;
            }
            CiSELayout.prototype = Object.create(Layout.prototype);
            for(var property in Layout)CiSELayout[property] = Layout[property];
            // -----------------------------------------------------------------------------
            // Section: Class constants
            // -----------------------------------------------------------------------------
            /**
 * Steps of layout
 */ CiSELayout.STEP_NOT_STARTED = 0;
            CiSELayout.STEP_1 = 1;
            CiSELayout.STEP_2 = 2;
            CiSELayout.STEP_3 = 3;
            CiSELayout.STEP_4 = 4;
            CiSELayout.STEP_5 = 5;
            /**
 * Phases of a step
 */ CiSELayout.PHASE_NOT_STARTED = 0;
            CiSELayout.PHASE_SWAP_PREPERATION = 1;
            CiSELayout.PHASE_PERFORM_SWAP = 2;
            CiSELayout.PHASE_OTHER = 3;
            // -----------------------------------------------------------------------------
            // Section: Class methods
            // -----------------------------------------------------------------------------
            /**
 * This method creates a new graph manager associated with this layout.
 */ CiSELayout.prototype.newGraphManager = function() {
                this.graphManager = new CiSEGraphManager(this);
                return this.graphManager;
            };
            /**
 * This method creates a new graph(CiSECircle) associated with the input view graph.
 */ CiSELayout.prototype.newCircleLGraph = function(vGraph) {
                return new CiSECircle(null, this.graphManager, vGraph);
            };
            /**
 * This method creates a new node associated with the input view node.
 */ CiSELayout.prototype.newNode = function(loc, size) {
                return new CiSENode(this.graphManager, loc, size, null);
            };
            /**
 * This method creates a new on-circle CiSE node associated with the input
 * view node.
 */ CiSELayout.prototype.newCiSEOnCircleNode = function(loc, size) {
                var newNode = this.newNode(loc, size);
                newNode.setAsOnCircleNode();
                return newNode;
            };
            /**
 * This method creates a new edge associated with the input view edge.
 */ CiSELayout.prototype.newEdge = function(source, target, vEdge) {
                return new CiSEEdge(source, target, vEdge);
            };
            /**
 * This method returns the node separation amount for this layout.
 */ CiSELayout.prototype.getNodeSeparation = function() {
                return this.nodeSeparation;
            };
            /**
 * This method establishes the GraphManager object related to this layout. Each compound(LGraph) is CiSECircle except
 * for the root.
 * @param nodes: All nodes in the graph
 * @param edges: All edges in the graph
 * @param clusters: Array of cluster ID arrays. Each array represents a cluster where ID ∈ {0,1,2,..,n(# of clusters)}
 *
 * Notes:
 * -> For unclustered nodes, their clusterID is -1.
 * -> CiSENode that corresponds to a cluster has no ID property.
 */ CiSELayout.prototype.convertToClusteredGraph = function(nodes, edges, clusters) {
                var _this = this;
                var self = this;
                var idToLNode = {};
                var rootGraph = this.graphManager.getRoot();
                // Firstly, lets create a HashMap to get node properties easier
                var idToCytoscapeNode = new HashMap();
                for(var i = 0; i < nodes.length; i++)idToCytoscapeNode.put(nodes[i].data('id'), nodes[i]);
                // If it is a function just change it
                if (typeof clusters === "function") {
                    var cIDs = [];
                    var temp = [];
                    for(var _i = 0; _i < nodes.length; _i++){
                        var cID = clusters(nodes[_i]);
                        if (cID > 0 && cID !== null && cID !== undefined) {
                            var index = cIDs.indexOf(cID);
                            if (index > -1) temp[index].push(nodes[_i].data('id'));
                            else {
                                cIDs.push(cID);
                                temp.push([
                                    nodes[_i].data('id')
                                ]);
                            }
                        }
                    }
                    clusters = temp;
                }
                // lets add the nodes in clusters to the GraphManager
                var _loop = function _loop(_i2) {
                    if (clusters[_i2].length === 0) return 'continue';
                    // Create a CiSENode for the cluster
                    var clusterNode = _this.newNode(null);
                    // ClusterID ∈ {0,1,2,..,n(# of clusters)}
                    clusterNode.setClusterId(_i2);
                    // Add it rootGraph
                    rootGraph.add(clusterNode);
                    // Create the associated Circle representing the cluster and link them together
                    var circle = _this.newCircleLGraph(null);
                    _this.graphManager.add(circle, clusterNode);
                    // Set bigger margins so clusters are spaced out nicely
                    circle.margin = circle.margin + 15;
                    // Move each node of the cluster into this circle
                    clusters[_i2].forEach(function(nodeID) {
                        var cytoNode = idToCytoscapeNode.get(nodeID);
                        var dimensions = cytoNode.layoutDimensions({
                            nodeDimensionsIncludeLabels: false
                        });
                        // Adding a node into the circle
                        var ciseNode = self.newCiSEOnCircleNode(new PointD(cytoNode.position('x') - dimensions.w / 2, cytoNode.position('y') - dimensions.h / 2), new DimensionD(parseFloat(dimensions.w), parseFloat(dimensions.h)));
                        ciseNode.setId(nodeID);
                        ciseNode.setClusterId(_i2);
                        circle.getOnCircleNodes().push(ciseNode);
                        circle.add(ciseNode);
                        // Initially all on-circle nodes are assumed to be in-nodes
                        circle.getInNodes().push(ciseNode);
                        // Map the node
                        idToLNode[ciseNode.getId()] = ciseNode;
                    });
                };
                for(var _i2 = 0; _i2 < clusters.length; _i2++){
                    var _ret = _loop(_i2);
                    if (_ret === 'continue') continue;
                }
                // Now, add unclustered nodes to the GraphManager
                var _loop2 = function _loop2(_i3) {
                    var clustered = false;
                    clusters.forEach(function(cluster) {
                        if (cluster.includes(nodes[_i3].data('id'))) clustered = true;
                    });
                    if (!clustered) {
                        var cytoNode = nodes[_i3];
                        var dimensions = cytoNode.layoutDimensions({
                            nodeDimensionsIncludeLabels: false
                        });
                        var _CiSENode = _this.newNode(new PointD(cytoNode.position('x') - dimensions.w / 2, cytoNode.position('y') - dimensions.h / 2), new DimensionD(parseFloat(dimensions.w), parseFloat(dimensions.h)));
                        _CiSENode.setClusterId(-1);
                        _CiSENode.setId(nodes[_i3].data('id'));
                        rootGraph.add(_CiSENode);
                        // Map the node
                        idToLNode[_CiSENode.getId()] = _CiSENode;
                    }
                };
                for(var _i3 = 0; _i3 < nodes.length; _i3++)_loop2(_i3);
                // Lastly, add all edges
                for(var _i4 = 0; _i4 < edges.length; _i4++){
                    var e = edges[_i4];
                    var sourceNode = idToLNode[e.data("source")];
                    var targetNode = idToLNode[e.data("target")];
                    var sourceClusterID = sourceNode.getClusterId();
                    var targetClusterID = targetNode.getClusterId();
                    if (sourceNode === targetNode) continue;
                    var ciseEdge = self.newEdge(sourceNode, targetNode, null);
                    // Edge is intracluster
                    // Remember: If source or target is unclustered then edge is Not intracluster
                    if (sourceClusterID === targetClusterID && sourceClusterID !== -1 && targetClusterID !== -1) {
                        ciseEdge.isIntraCluster = true;
                        ciseEdge.getSource().getOwner().add(ciseEdge, ciseEdge.getSource(), ciseEdge.getTarget());
                    } else {
                        ciseEdge.isIntraCluster = false;
                        this.graphManager.add(ciseEdge, ciseEdge.getSource(), ciseEdge.getTarget());
                    }
                }
                // Populate the references of GraphManager
                var onCircleNodes = [];
                var nonOnCircleNodes = [];
                var allNodes = this.graphManager.getAllNodes();
                for(var _i5 = 0; _i5 < allNodes.length; _i5++)if (allNodes[_i5].getOnCircleNodeExt()) onCircleNodes.push(allNodes[_i5]);
                else nonOnCircleNodes.push(allNodes[_i5]);
                this.graphManager.setOnCircleNodes(onCircleNodes);
                this.graphManager.setNonOnCircleNodes(nonOnCircleNodes);
                // Deternine out-nodes of each circle
                this.graphManager.edges.forEach(function(e) {
                    var sourceNode = e.getSource();
                    var targetNode = e.getTarget();
                    var sourceClusterID = sourceNode.getClusterId();
                    var targetClusterID = targetNode.getClusterId();
                    // If an on-circle node is an out-node, then remove it from the
                    // in-node list and add it to out-node list of the associated
                    // circle. Notice that one or two ends of an inter-graph edge will
                    // be out-node(s).
                    if (sourceClusterID !== -1) {
                        var _circle = sourceNode.getOwner();
                        // Make sure it has not been already moved to the out node list
                        var _index = _circle.getInNodes().indexOf(sourceNode);
                        if (_index > -1) {
                            _circle.getInNodes().splice(_index, 1);
                            _circle.getOutNodes().push(sourceNode);
                        }
                    }
                    if (targetClusterID !== -1) {
                        var _circle2 = targetNode.getOwner();
                        // Make sure it has not been already moved to the out node list
                        var _index2 = _circle2.getInNodes().indexOf(targetNode);
                        if (_index2 > -1) {
                            _circle2.getInNodes().splice(_index2, 1);
                            _circle2.getOutNodes().push(targetNode);
                        }
                    }
                });
                return idToLNode;
            };
            /**
 * This method runs AVSDF layout for each cluster.
 */ CiSELayout.prototype.doStep1 = function() {
                this.step = CiSELayout.STEP_1;
                this.phase = CiSELayout.PHASE_OTHER;
                // Mapping for transferring positions and dimensions back
                var ciseToAvsdf = new HashMap();
                var allGraphs = this.graphManager.getGraphs();
                for(var i = 0; i < allGraphs.length; i++){
                    var graph = allGraphs[i];
                    // Skip the root graph which is a normal LGraph
                    if (graph instanceof CiSECircle) {
                        // Create the AVSDF layout objects
                        AVSDFConstants.DEFAULT_NODE_SEPARATION = this.nodeSeparation;
                        var avsdfLayout = new AVSDFLayout();
                        var avsdfCircle = avsdfLayout.graphManager.addRoot();
                        var clusteredNodes = graph.getOnCircleNodes();
                        // Create corresponding AVSDF nodes in current cluster
                        for(var _i6 = 0; _i6 < clusteredNodes.length; _i6++){
                            var ciseOnCircleNode = clusteredNodes[_i6];
                            var avsdfNode = avsdfLayout.newNode(null);
                            var loc = ciseOnCircleNode.getLocation();
                            avsdfNode.setLocation(loc.x, loc.y);
                            avsdfNode.setWidth(ciseOnCircleNode.getWidth());
                            avsdfNode.setHeight(ciseOnCircleNode.getHeight());
                            avsdfCircle.add(avsdfNode);
                            ciseToAvsdf.put(ciseOnCircleNode, avsdfNode);
                        }
                        // For each edge, create a corresponding AVSDF edge if its both ends
                        // are in this cluster.
                        var allEdges = this.getAllEdges();
                        for(var _i7 = 0; _i7 < allEdges.length; _i7++){
                            var edge = allEdges[_i7];
                            if (clusteredNodes.includes(edge.getSource()) && clusteredNodes.includes(edge.getTarget())) {
                                var avsdfSource = ciseToAvsdf.get(edge.getSource());
                                var avsdfTarget = ciseToAvsdf.get(edge.getTarget());
                                var avsdfEdge = avsdfLayout.newEdge("");
                                avsdfCircle.add(avsdfEdge, avsdfSource, avsdfTarget);
                            }
                        }
                        // Run AVSDF layout
                        avsdfLayout.layout();
                        // Do post-processing
                        var sortedByDegreeList = avsdfLayout.initPostProcess();
                        for(var _i8 = 0; _i8 < sortedByDegreeList.length; _i8++)avsdfLayout.oneStepPostProcess(sortedByDegreeList[_i8]);
                        avsdfLayout.updateNodeAngles();
                        avsdfLayout.updateNodeCoordinates();
                        // Reflect changes back to CiSENode's
                        for(var _i9 = 0; _i9 < clusteredNodes.length; _i9++){
                            var _ciseOnCircleNode = clusteredNodes[_i9];
                            var _avsdfNode = ciseToAvsdf.get(_ciseOnCircleNode);
                            var _loc = _avsdfNode.getLocation();
                            _ciseOnCircleNode.setLocation(_loc.x, _loc.y);
                            _ciseOnCircleNode.getOnCircleNodeExt().setIndex(_avsdfNode.getIndex());
                            _ciseOnCircleNode.getOnCircleNodeExt().setAngle(_avsdfNode.getAngle());
                        }
                        // Sort nodes of this ciseCircle according to circle indexes of
                        // ciseOnCircleNodes.
                        clusteredNodes.sort(function(a, b) {
                            return a.getOnCircleNodeExt().getIndex() - b.getOnCircleNodeExt().getIndex();
                        });
                        // Assign width and height of the AVSDF circle containing the nodes
                        // above to the corresponding cise-circle.
                        if (avsdfCircle.getNodes().length > 0) {
                            var parentCiSE = graph.getParent();
                            var parentAVSDF = avsdfCircle.getParent();
                            parentCiSE.setLocation(parentAVSDF.getLocation().x, parentAVSDF.getLocation().y);
                            graph.setRadius(avsdfCircle.getRadius());
                            graph.calculateParentNodeDimension();
                        }
                    }
                }
            };
            /**
 * This method runs a spring embedder on the cluster-graph (quotient graph
 * of the clustered graph) to determine initial layout.
 */ CiSELayout.prototype.doStep2 = function() {
                this.step = CiSELayout.STEP_2;
                this.phase = CiSELayout.PHASE_OTHER;
                var newCoSENodes = [];
                var newCoSEEdges = [];
                // Used for holding conversion mapping between cise and cose nodes.
                var ciseNodeToCoseNode = new HashMap();
                // Used for reverse mapping between cose and cise edges while sorting
                // incident edges.
                var coseEdgeToCiseEdges = new HashMap();
                // Create a CoSE layout object
                var coseLayout = new CoSELayout();
                coseLayout.isSubLayout = false;
                coseLayout.useMultiLevelScaling = false;
                coseLayout.useFRGridVariant = true;
                coseLayout.springConstant *= 1.5;
                var gm = coseLayout.newGraphManager();
                var coseRoot = gm.addRoot();
                // Traverse through all nodes and create new CoSENode's.
                // !WARNING! = REMEMBER to set unique "id" properties to CoSENodes!!!!
                var nonOnCircleNodes = this.graphManager.getNonOnCircleNodes();
                for(var i = 0; i < nonOnCircleNodes.length; i++){
                    var ciseNode = nonOnCircleNodes[i];
                    var newNode = coseLayout.newNode(null);
                    var loc = ciseNode.getLocation();
                    newNode.setLocation(loc.x, loc.y);
                    newNode.setWidth(ciseNode.getWidth());
                    newNode.setHeight(ciseNode.getHeight());
                    // Set nodes corresponding to circles to be larger than original, so
                    // inter-cluster edges end up longer.
                    if (ciseNode.getChild() != null) {
                        newNode.setWidth(1.2 * newNode.getWidth());
                        newNode.setHeight(1.2 * newNode.getHeight());
                    }
                    // !WARNING! = CoSE EXPECTS "id" PROPERTY IMPLICITLY, REMOVING IT WILL CAUSE TILING TO OCCUR ON THE WHOLE GRAPH
                    newNode.id = i;
                    coseRoot.add(newNode);
                    newCoSENodes.push(newNode);
                    ciseNodeToCoseNode.put(ciseNode, newNode);
                }
                // Used for preventing duplicate edge creation between two cose nodes
                var nodePairs = new Array(newCoSENodes.length);
                for(var _i10 = 0; _i10 < nodePairs.length; _i10++)nodePairs[_i10] = new Array(newCoSENodes.length);
                // Traverse through edges and create cose edges for inter-cluster ones.
                var allEdges = this.graphManager.getAllEdges();
                for(var _i11 = 0; _i11 < allEdges.length; _i11++){
                    var ciseEdge = allEdges[_i11];
                    var sourceCise = ciseEdge.getSource();
                    var targetCise = ciseEdge.getTarget();
                    // Determine source and target nodes for current edge
                    if (sourceCise.getOnCircleNodeExt() != null) // Source node is an on-circle node, take its parent as source node
                    sourceCise = ciseEdge.getSource().getOwner().getParent();
                    if (targetCise.getOnCircleNodeExt() != null) // Target node is an on-circle node, take its parent as target node
                    targetCise = ciseEdge.getTarget().getOwner().getParent();
                    var sourceCose = ciseNodeToCoseNode.get(sourceCise);
                    var targetCose = ciseNodeToCoseNode.get(targetCise);
                    var sourceIndex = newCoSENodes.indexOf(sourceCose);
                    var targetIndex = newCoSENodes.indexOf(targetCose);
                    var newEdge = void 0;
                    if (sourceIndex !== targetIndex) {
                        // Make sure it's an inter-cluster edge
                        if (nodePairs[sourceIndex][targetIndex] == null && nodePairs[targetIndex][sourceIndex] == null) {
                            newEdge = coseLayout.newEdge(null);
                            coseRoot.add(newEdge, sourceCose, targetCose);
                            newCoSEEdges.push(newEdge);
                            coseEdgeToCiseEdges.put(newEdge, []);
                            nodePairs[sourceIndex][targetIndex] = newEdge;
                            nodePairs[targetIndex][sourceIndex] = newEdge;
                        } else newEdge = nodePairs[sourceIndex][targetIndex];
                        coseEdgeToCiseEdges.get(newEdge).push(ciseEdge);
                    }
                }
                // Run CoSELayout
                coseLayout.runLayout();
                // Reflect changes back to cise nodes
                // First update all non-on-circle nodes.
                for(var _i12 = 0; _i12 < nonOnCircleNodes.length; _i12++){
                    var _ciseNode = nonOnCircleNodes[_i12];
                    var coseNode = ciseNodeToCoseNode.get(_ciseNode);
                    var _loc2 = coseNode.getLocation();
                    _ciseNode.setLocation(_loc2.x, _loc2.y);
                }
                // Then update all cise on-circle nodes, since their parents have
                // changed location.
                var onCircleNodes = this.graphManager.getOnCircleNodes();
                for(var _i13 = 0; _i13 < onCircleNodes.length; _i13++){
                    var _ciseNode2 = onCircleNodes[_i13];
                    var _loc3 = _ciseNode2.getLocation();
                    var parentLoc = _ciseNode2.getOwner().getParent().getLocation();
                    _ciseNode2.setLocation(_loc3.x + parentLoc.x, _loc3.y + parentLoc.y);
                }
            };
            /**
 * This method runs a modified spring embedder as described by the CiSE
 * layout algorithm where the on-circle nodes are fixed (pinned down to
 * the location on their owner circle). Circles, however, are allowed to be
 * flipped (i.e. nodes are re-ordered in the reverse direction) if reversal
 * yields a better aligned neighborhood (w.r.t. its inter-graph edges).
 */ CiSELayout.prototype.step3Init = function() {
                this.step = CiSELayout.STEP_3;
                this.phase = CiSELayout.PHASE_OTHER;
                this.initSpringEmbedder();
                this.coolingCycle = 0;
            };
            /**
 * This method runs a modified spring embedder as described by the CiSE
 * layout algorithm where the neighboring on-circle nodes are allowed to
 * move by swapping without increasing crossing number but circles are not
 * allowed to be flipped.
 */ CiSELayout.prototype.step4Init = function() {
                this.step = CiSELayout.STEP_4;
                this.phase = CiSELayout.PHASE_OTHER;
                this.initSpringEmbedder();
                for(var i = 0; i < this.graphManager.getOnCircleNodes().length; i++)this.graphManager.getOnCircleNodes()[i].getOnCircleNodeExt().updateSwappingConditions();
                this.coolingCycle = 0;
            };
            /**
 * This method runs a modified spring embedder as described by the CiSE
 * layout algorithm where the on-circle nodes are fixed (pinned down to
 * the location on their owner circle) and circles are not allowed to be
 * flipped.
 */ CiSELayout.prototype.step5Init = function() {
                this.step = CiSELayout.STEP_5;
                this.phase = CiSELayout.PHASE_OTHER;
                this.initSpringEmbedder();
                this.coolingCycle = 0;
            };
            /**
 * This method implements a spring embedder used by steps 3 thru 5 with
 * potentially different parameters.
 *
 */ CiSELayout.prototype.runSpringEmbedderTick = function() {
                // This function uses iterations but FDLayout uses this.totalIterations
                this.iterations++;
                this.totalIterations = this.iterations;
                if (this.iterations % CiSEConstants.CONVERGENCE_CHECK_PERIOD === 0) {
                    // In step 4 make sure at least a 1/4 of max iters take place
                    var notTooEarly = this.step !== CiSELayout.STEP_4 || this.iterations > this.maxIterations / 4;
                    if (notTooEarly && this.isConverged()) return true;
                    // Cooling factor descend function
                    //this.coolingFactor = this.initialCoolingFactor * Math.pow( 1 - 0.005 , this.iterations) ;
                    this.coolingFactor = this.initialCoolingFactor * ((this.maxIterations - this.iterations) / this.maxIterations);
                }
                this.totalDisplacement = 0;
                if (this.step === CiSELayout.STEP_3) {
                    if (this.iterations % CiSEConstants.REVERSE_PERIOD === 0) this.checkAndReverseIfReverseIsBetter();
                } else if (this.step === CiSELayout.STEP_4) {
                    // clear history every now and then
                    if (this.iterations % CiSEConstants.SWAP_HISTORY_CLEARANCE_PERIOD === 0) this.swappedPairsInLastIteration = [];
                    // no of iterations in this swap period
                    var iterationInPeriod = this.iterations % CiSEConstants.SWAP_PERIOD;
                    if (iterationInPeriod >= CiSEConstants.SWAP_IDLE_DURATION) this.phase = CiSELayout.PHASE_SWAP_PREPERATION;
                    else if (iterationInPeriod === 0) this.phase = CiSELayout.PHASE_PERFORM_SWAP;
                    else this.phase = CiSELayout.PHASE_OTHER;
                }
                this.calcSpringForces();
                this.calcRepulsionForces();
                this.calcGravitationalForces();
                this.calcTotalForces();
                this.moveNodes();
                return this.iterations >= this.maxIterations;
            };
            /**
 * This method prepares circles for possible reversal by computing the order
 * matrix of each circle. It also determines any circles that should never
 * be reversed (e.g. when it has no more than 1 inter-cluster edge).
 */ CiSELayout.prototype.prepareCirclesForReversal = function() {
                var nodes = this.graphManager.getRoot().getNodes();
                nodes.forEach(function(node) {
                    var circle = node.getChild();
                    if (circle !== null && circle !== undefined) {
                        //It is a circle
                        if (circle.getInterClusterEdges().length < 2) circle.setMayNotBeReversed();
                        circle.computeOrderMatrix();
                    }
                });
            };
            /**
 * This method calculates the ideal edge length of each edge. Here we relax
 * edge lengths in the polishing step and keep the edge lengths of the edges
 * incident with inner-nodes very short to avoid overlaps.
 */ CiSELayout.prototype.calcIdealEdgeLengths = function(isPolishingStep) {
                var lEdges = this.graphManager.getAllEdges();
                for(var i = 0; i < lEdges.length; i++){
                    var edge = lEdges[i];
                    // Loosen in the polishing step to avoid overlaps
                    if (isPolishingStep) edge.idealLength = 1.5 * this.idealEdgeLength * this.idealInterClusterEdgeLengthCoefficient;
                    else edge.idealLength = this.idealEdgeLength * this.idealInterClusterEdgeLengthCoefficient;
                }
                // Update in-nodes edge's lengths
                var lNodes = this.graphManager.getInCircleNodes();
                for(var _i14 = 0; _i14 < lNodes.length; _i14++){
                    var node = lNodes[_i14];
                    node.getEdges().forEach(function(edge) {
                        edge.idealLength = CiSEConstants.DEFAULT_INNER_EDGE_LENGTH;
                    });
                }
            };
            /**
 * This method calculates the spring forces applied to end nodes of each
 * edge. In steps 3 & 5, where on-circle nodes are not allowed to move,
 * intra-cluster edges are ignored (as their total will equal zero and won't
 * have an affect on the owner circle).
 */ CiSELayout.prototype.calcSpringForces = function() {
                var lEdges = this.graphManager.getAllEdges();
                for(var i = 0; i < lEdges.length; i++){
                    var edge = lEdges[i];
                    var source = edge.getSource();
                    var target = edge.getTarget();
                    // Ignore intra-cluster edges (all steps 3 thru 5) except for those
                    // incident w/ any inner-nodes
                    if (edge.isIntraCluster && source.getOnCircleNodeExt() != null && target.getOnCircleNodeExt() != null) continue;
                    this.calcSpringForce(edge, edge.idealLength);
                }
            };
            /**
 * This method calculates the repulsion forces for each pair of nodes.
 * Repulsions need not be calculated for on-circle nodes.
 */ CiSELayout.prototype.calcRepulsionForces = function() {
                var lNodes = this.graphManager.getNonOnCircleNodes();
                for(var i = 0; i < lNodes.length; i++){
                    var nodeA = lNodes[i];
                    for(var j = i + 1; j < lNodes.length; j++){
                        var nodeB = lNodes[j];
                        this.calcRepulsionForce(nodeA, nodeB);
                    }
                }
                // We need the calculate repulsion forces for in-circle nodes as well
                // to keep them inside circle.
                var inCircleNodes = this.graphManager.getInCircleNodes();
                for(var _i15 = 0; _i15 < inCircleNodes.length; _i15++){
                    var inCircleNode = inCircleNodes[_i15];
                    var ownerCircle = inCircleNode.getOwner();
                    //TODO: inner nodes repulse on-circle nodes as well, not desired!
                    // Calculate repulsion forces with all nodes inside the owner circle
                    // of this inner node.
                    var childNodes = ownerCircle.getNodes();
                    for(var _i16 = 0; _i16 < childNodes.length; _i16++){
                        var childCiSENode = childNodes[_i16];
                        if (childCiSENode !== inCircleNode) this.calcRepulsionForce(inCircleNode, childCiSENode);
                    }
                }
            };
            /**
 * This method calculates the gravitational forces for each node. On-circle
 * nodes move with their owner; thus they are not applied separate gravity.
 */ CiSELayout.prototype.calcGravitationalForces = function() {
                if (!this.graphManager.rootGraph.isConnected) {
                    var _lNodes = this.graphManager.getNonOnCircleNodes();
                    for(var i = 0; i < _lNodes.length; i++){
                        var node = _lNodes[i];
                        this.calcGravitationalForce(node);
                    }
                }
                // Calculate gravitational forces to keep in-circle nodes in the center
                // TODO: is this really helping or necessary?
                var lNodes = this.graphManager.getInCircleNodes();
                for(var _i17 = 0; _i17 < lNodes.length; _i17++){
                    var _node = lNodes[_i17];
                    this.calcGravitationalForce(_node);
                }
            };
            /**
 * This method adds up all the forces calculated earlier transferring forces
 * of on-circle nodes to their owner node (as regular and rotational forces)
 * when they are not allowed to move. When they are allowed to move,
 * on-circle nodes will partially contribute to the forces of their owner
 * circle (no rotational contribution).
 */ CiSELayout.prototype.calcTotalForces = function() {
                var allNodes = this.graphManager.getAllNodes();
                for(var i = 0; i < allNodes.length; i++){
                    var node = allNodes[i];
                    node.displacementX = this.coolingFactor * (node.springForceX + node.repulsionForceX + node.gravitationForceX);
                    node.displacementY = this.coolingFactor * (node.springForceY + node.repulsionForceY + node.gravitationForceY);
                    node.rotationAmount = 0.0;
                    node.springForceX = 0.0;
                    node.springForceY = 0.0;
                    node.repulsionForceX = 0.0;
                    node.repulsionForceY = 0.0;
                    node.gravitationForceX = 0.0;
                    node.gravitationForceY = 0.0;
                }
                var onCircleNodes = this.graphManager.getOnCircleNodes();
                for(var _i18 = 0; _i18 < onCircleNodes.length; _i18++){
                    var _node2 = onCircleNodes[_i18];
                    var parentNode = _node2.getOwner().getParent();
                    var values = _node2.getOwner().decomposeForce(_node2);
                    if (this.phase === CiSELayout.PHASE_SWAP_PREPERATION) _node2.getOnCircleNodeExt().addDisplacementForSwap(values.getRotationAmount());
                    parentNode.displacementX += values.getDisplacementX();
                    parentNode.displacementY += values.getDisplacementY();
                    _node2.displacementX = 0.0;
                    _node2.displacementY = 0.0;
                    parentNode.rotationAmount += values.getRotationAmount();
                    _node2.rotationAmount = 0.0;
                }
            };
            /**
 * This method updates positions of each node at the end of an iteration.
 * Also, it deals with swapping of two consecutive nodes on a circle in
 * step 4.
 */ CiSELayout.prototype.moveNodes = function() {
                if (this.phase !== CiSELayout.PHASE_PERFORM_SWAP) {
                    var nonOnCircleNodes = this.graphManager.getNonOnCircleNodes();
                    // Simply move all non-on-circle nodes.
                    for(var i = 0; i < nonOnCircleNodes.length; i++){
                        nonOnCircleNodes[i].move();
                        // Also make required rotations for circles
                        if (nonOnCircleNodes[i].getChild() !== null && nonOnCircleNodes[i].getChild() !== undefined) nonOnCircleNodes[i].getChild().rotate();
                    }
                    // Also move all in-circle nodes. Note that in-circle nodes will be
                    // empty if this option is not set, hence no negative effect on
                    // performance
                    var inCircleNodes = this.graphManager.getInCircleNodes();
                    var inCircleNode = void 0;
                    for(var _i19 = 0; _i19 < inCircleNodes.length; _i19++){
                        inCircleNode = inCircleNodes[_i19];
                        // TODO: workaround to force inner nodes to stay inside
                        inCircleNode.displacementX /= 20.0;
                        inCircleNode.displacementY /= 20.0;
                        inCircleNode.move();
                    }
                } else {
                    // If in perform-swap phase of step 4, we have to look for swappings
                    // that do not increase edge crossings and is likely to decrease total
                    // energy.
                    var ciseOnCircleNodes = this.graphManager.getOnCircleNodes();
                    var size = ciseOnCircleNodes.length;
                    // Both nodes of a pair are out-nodes, not necessarilly safe due to
                    // inter-cluster edge crossings
                    // TODO It should be a max heap structure
                    var nonSafePairs = [];
                    // Pairs where one of the on circle nodes is an in-node; no problem
                    // swapping these
                    var safePairs = [];
                    // Nodes swapped in this round
                    var swappedNodes = [];
                    // Pairs swapped or prevented from being swapped in this round
                    var swappedPairs = [];
                    var firstNode = void 0;
                    var secondNode = void 0;
                    var firstNodeExt = void 0;
                    var secondNodeExt = void 0;
                    var firstNodeDisp = void 0;
                    var secondNodeDisp = void 0;
                    var discrepancy = void 0;
                    var inSameDirection = void 0;
                    // Check each node with its next node for swapping
                    for(var _i20 = 0; _i20 < size; _i20++){
                        firstNode = ciseOnCircleNodes[_i20];
                        secondNode = firstNode.getOnCircleNodeExt().getNextNode();
                        firstNodeExt = firstNode.getOnCircleNodeExt();
                        secondNodeExt = secondNode.getOnCircleNodeExt();
                        // Ignore if the swap is to introduce new intra-edge crossings
                        if (!firstNodeExt.canSwapWithNext || !secondNodeExt.canSwapWithPrev) continue;
                        firstNodeDisp = firstNodeExt.getDisplacementForSwap();
                        secondNodeDisp = secondNodeExt.getDisplacementForSwap();
                        discrepancy = firstNodeDisp - secondNodeDisp;
                        // Pulling in reverse directions, no swap
                        if (discrepancy < 0.0) continue;
                        // Might swap, create safe or nonsafe node pairs
                        inSameDirection = firstNodeDisp > 0 && secondNodeDisp > 0 || firstNodeDisp < 0 && secondNodeDisp < 0;
                        var pair = new CiSEOnCircleNodePair(firstNode, secondNode, discrepancy, inSameDirection);
                        // When both are out-nodes, nonsafe; otherwise, safe
                        if (firstNodeDisp === 0.0 || secondNodeDisp === 0.0) safePairs.push(pair);
                        else nonSafePairs.push(pair);
                    }
                    var nonSafePair = void 0;
                    var lookForSwap = true;
                    var rollback = void 0;
                    // TODO max heap -> extractMax
                    nonSafePairs.sort(function(a, b) {
                        return a.getDiscrepancy() - b.getDiscrepancy();
                    });
                    // Look for a nonsafe pair until we swap one
                    while(lookForSwap && nonSafePairs.length > 0){
                        // Pick the non safe pair that has the maximum discrepancy.
                        nonSafePair = nonSafePairs[nonSafePairs.length - 1];
                        firstNode = nonSafePair.getFirstNode();
                        secondNode = nonSafePair.getSecondNode();
                        firstNodeExt = firstNode.getOnCircleNodeExt();
                        secondNodeExt = secondNode.getOnCircleNodeExt();
                        // If this pair is swapped in previous swap phase, don't allow
                        // this swap. Also save it for the future as if it is actually
                        // swapped in order to prevent future oscilations
                        if (this.isSwappedPreviously(nonSafePair)) {
                            nonSafePairs.pop();
                            swappedPairs.push(nonSafePair);
                            continue;
                        }
                        // Check for inter-cluster edge crossings before swapping.
                        var int1 = firstNodeExt.getInterClusterIntersections(secondNodeExt);
                        // Try a swap
                        nonSafePair.swap();
                        rollback = false;
                        // Then re-compute crossings
                        var int2 = firstNodeExt.getInterClusterIntersections(secondNodeExt);
                        // Possible cases regarding discrepancy:
                        // first  second  action
                        // +      +       both clockwise: might swap if disp > 0
                        // +      -       disp > 0: might swap
                        // -      -       both counter-clockwise: might swap if disp > 0
                        // -      +       disp <= 0: no swap
                        // Under following conditions roll swap back:
                        // - swap increases inter-cluster edge crossings
                        // - inter-cluster edge number is the same but pulling in the
                        // same direction or discrepancy is below pre-determined
                        // threshold (not enough for swap)
                        rollback = int2 > int1;
                        if (!rollback && int2 === int1) rollback = nonSafePair.inSameDirection() || nonSafePair.getDiscrepancy() < CiSEConstants.MIN_DISPLACEMENT_FOR_SWAP;
                        if (rollback) {
                            nonSafePair.swap();
                            nonSafePairs.pop();
                            continue;
                        }
                        swappedNodes.push(nonSafePair.getFirstNode());
                        swappedNodes.push(nonSafePair.getSecondNode());
                        swappedPairs.push(nonSafePair);
                        // Swap performed, do not look for another nonsafe pair
                        lookForSwap = false;
                    }
                    // Now process all safe pairs
                    for(var _i21 = 0; _i21 < safePairs.length; _i21++){
                        var safePair = safePairs[_i21];
                        // Check if discrepancy is above the threshold (enough to swap)
                        if (safePair.inSameDirection() || safePair.getDiscrepancy() < CiSEConstants.MIN_DISPLACEMENT_FOR_SWAP) continue;
                        // Check if they were already involved in a swap in this phase
                        if (swappedNodes.includes(safePair.getFirstNode()) || swappedNodes.includes(safePair.getSecondNode())) continue;
                        // Should be swapped if not previously swapped; so
                        // Check if they were previously swapped
                        if (!this.isSwappedPreviously(safePair)) {
                            safePair.swap();
                            swappedNodes.push(safePair.getFirstNode());
                            swappedNodes.push(safePair.getSecondNode());
                        }
                        // Mark swapped (even if not) to prevent future oscillations
                        swappedPairs.push(safePair);
                    }
                    // Update swap history
                    this.swappedPairsInLastIteration = [];
                    for(var _i22 = 0; _i22 < swappedPairs.length; _i22++)this.swappedPairsInLastIteration.push(swappedPairs[_i22]);
                    // Reset all discrepancy values of on circle nodes.
                    var node = void 0;
                    for(var _i23 = 0; _i23 < size; _i23++){
                        node = ciseOnCircleNodes[_i23];
                        node.getOnCircleNodeExt().setDisplacementForSwap(0.0);
                    }
                }
            };
            /*
 * This method returns whether or not the input node pair was previously
 * swapped.
 */ CiSELayout.prototype.isSwappedPreviously = function(pair) {
                for(var i = 0; i < this.swappedPairsInLastIteration.length; i++){
                    var swappedPair = this.swappedPairsInLastIteration[i];
                    if (swappedPair.getFirstNode() === pair.getFirstNode() && swappedPair.getSecondNode() === pair.getSecondNode() || swappedPair.getSecondNode() === pair.getFirstNode() && swappedPair.getFirstNode() === pair.getSecondNode()) return true;
                }
                return false;
            };
            /**
* This method tries to improve the edge crossing number by reversing a
* cluster (i.e., the order of the nodes in the cluster such as C,B,A
* instead of A,B,C). No more than one reversal is performed with each
* execution. The decision is based on the global sequence alignment
* heuristic (typically used in biological sequence alignment). A cluster
* that was previsouly reversed is not a candidate for reversal to avoid
* oscillations. It returns true if a reversal has been performed.
*/ CiSELayout.prototype.checkAndReverseIfReverseIsBetter = function() {
                var gm = this.getGraphManager();
                // For each cluster (in no particular order) check to see whether
                // reversing the order of the nodes on the cluster could improve on
                // inter-graph edge crossing number of that cluster.
                var nodeIterator = gm.getRoot().getNodes();
                var node = void 0;
                var circle = void 0;
                for(var i = 0; i < nodeIterator.length; i++){
                    node = nodeIterator[i];
                    circle = node.getChild();
                    if (circle != null && circle.getMayBeReversed() && circle.getNodes().length <= 52) {
                        if (circle.checkAndReverseIfReverseIsBetter()) return true;
                    }
                }
                return false;
            };
            /**
 * This method goes over all circles and tries to find nodes that can be
 * moved inside the circle. Inner nodes are found and moved inside one at a
 * time. This process continues for a circle until either there is no inner
 * node or reached max inner nodes for that circle.
 */ CiSELayout.prototype.findAndMoveInnerNodes = function() {
                if (!this.allowNodesInsideCircle) return;
                var graphs = this.graphManager.getGraphs();
                for(var i = 0; i < graphs.length; i++){
                    var ciseCircle = graphs[i];
                    // Count inner nodes not to exceed user defined maximum
                    var innerNodeCount = 0;
                    if (ciseCircle !== this.getGraphManager().getRoot()) {
                        // It is a user parameter, retrieve it.
                        var maxInnerNodes = ciseCircle.getNodes().length * this.maxRatioOfNodesInsideCircle;
                        // Look for an inner node and move it inside
                        var innerNode = this.findInnerNode(ciseCircle);
                        while(innerNode !== null && innerNode !== undefined && innerNodeCount < maxInnerNodes){
                            this.moveInnerNode(innerNode);
                            innerNodeCount++;
                            if (innerNodeCount < maxInnerNodes) innerNode = this.findInnerNode(ciseCircle);
                        }
                    }
                }
            };
            /**
 * This method finds an inner node (if any) in the given circle.
 */ CiSELayout.prototype.findInnerNode = function(ciseCircle) {
                var innerNode = null;
                var onCircleNodeCount = ciseCircle.getOnCircleNodes().length;
                // First sort the nodes in the circle according to their degrees.
                var sortedNodes = ciseCircle.getOnCircleNodes();
                sortedNodes.sort(function(a, b) {
                    return a.getEdges().length - b.getEdges().length;
                });
                // Evaluate each node as possible candidate
                for(var i = onCircleNodeCount - 1; i >= 0 && innerNode == null; i--){
                    var candidateNode = sortedNodes[i];
                    // Out nodes cannot be moved inside, so just skip them
                    if (candidateNode.getOnCircleNodeExt().getInterClusterEdges().length !== 0) continue;
                    var circleSegment = this.findMinimalSpanningSegment(candidateNode);
                    // Skip nodes with no neighbors (circle segment will be empty)
                    if (circleSegment.length === 0) continue;
                    // For all nodes in the spanning circle segment, check if that node
                    // is connected to another node on the circle with an index diff of
                    // greater than 1 (i.e. connected to a non-immediate neighbor)
                    var connectedToNonImmediate = false;
                    for(var _i24 = 0; _i24 < circleSegment.length; _i24++){
                        var spanningNode = circleSegment[_i24];
                        // Performance improvement: stop iteration if this cannot be
                        // an inner node.
                        if (connectedToNonImmediate) break;
                        // Look for neighbors of this spanning node.
                        var neighbors = spanningNode.getNeighborsList();
                        for(var j = 0; j < neighbors.length; j++){
                            var neighborOfSpanningNode = neighbors[j];
                            // In some case we don't need to look at the neighborhood
                            // relationship. We won't care the neighbor of spanning node
                            // if:
                            // - It is the candidate node
                            // - It is on another circle
                            // - It is already an inner node.
                            if (neighborOfSpanningNode !== candidateNode && neighborOfSpanningNode.getOwner() === ciseCircle && neighborOfSpanningNode.getOnCircleNodeExt() != null && neighborOfSpanningNode.getOnCircleNodeExt() != undefined) {
                                var spanningIndex = spanningNode.getOnCircleNodeExt().getIndex();
                                var neighborOfSpanningIndex = neighborOfSpanningNode.getOnCircleNodeExt().getIndex();
                                // Calculate the index difference between spanning node
                                // and its neighbor
                                var indexDiff = spanningIndex - neighborOfSpanningIndex;
                                indexDiff += onCircleNodeCount; // Get rid of neg. index
                                indexDiff %= onCircleNodeCount; // Mod it
                                // Give one more chance, try reverse order of nodes
                                // just in case.
                                if (indexDiff > 1) {
                                    indexDiff = neighborOfSpanningIndex - spanningIndex;
                                    indexDiff += onCircleNodeCount; // Get rid of neg.
                                    indexDiff %= onCircleNodeCount; // Mod it
                                }
                                // If the diff is still greater 1, this spanning node
                                // has a non-immediate neighbor. Sorry but you cannot
                                // be an inner node. Poor candidate node !!!
                                if (indexDiff > 1) {
                                    connectedToNonImmediate = true;
                                    break;
                                }
                            }
                        }
                    }
                    // If neighbors of candidate node is not connect to a non-immediate
                    // neighbor that this can be an inner node.
                    if (!connectedToNonImmediate) innerNode = candidateNode;
                }
                return innerNode;
            };
            /**
 * This method safely removes inner node from circle perimeter (on-circle)
 * and moves them inside their owner circles (as in-circle nodes)
 */ CiSELayout.prototype.moveInnerNode = function(innerNode) {
                var ciseCircle = innerNode.getOwner();
                // Remove the node from the circle first. This forces circle to
                // re-adjust its geometry. A costly operation indeed...
                ciseCircle.moveOnCircleNodeInside(innerNode);
                // We need to also remove the inner node from on-circle nodes list
                // of the associated graph manager
                var onCircleNodesList = this.graphManager.getOnCircleNodes();
                var index = onCircleNodesList.indexOf(innerNode);
                if (index > -1) onCircleNodesList.splice(index, 1);
                this.graphManager.inCircleNodes.push(innerNode);
            };
            /**
 * This method returns a circular segment (ordered array of nodes),
 * which is the smallest segment that spans neighbors of the given node.
 */ CiSELayout.prototype.findMinimalSpanningSegment = function(node) {
                var segment = [];
                // First create an ordered neighbors list which includes given node and
                // its neighbors and ordered according to their indexes in this circle.
                var orderedNeigbors = node.getOnCircleNeighbors();
                if (orderedNeigbors.length === 0) return segment;
                orderedNeigbors.sort(function(a, b) {
                    return a.getOnCircleNodeExt().getIndex() - b.getOnCircleNodeExt().getIndex();
                });
                // According to the order found, find the start and end nodes of the
                // segment by testing each (order adjacent) neighbor pair.
                var orderedNodes = node.getOwner().getOnCircleNodes();
                orderedNodes.sort(function(a, b) {
                    return a.getOnCircleNodeExt().getIndex() - b.getOnCircleNodeExt().getIndex();
                });
                var shortestSegmentStartNode = null;
                var shortestSegmentEndNode = null;
                var shortestSegmentLength = orderedNodes.length;
                var segmentLength = orderedNodes.length;
                var neighSize = orderedNeigbors.length;
                var i = void 0;
                var j = void 0;
                var tempSegmentStartNode = void 0;
                var tempSegmentEndNode = void 0;
                var tempSegmentLength = void 0;
                for(i = 0; i < neighSize; i++){
                    j = (i - 1 + neighSize) % neighSize;
                    tempSegmentStartNode = orderedNeigbors[i];
                    tempSegmentEndNode = orderedNeigbors[j];
                    tempSegmentLength = (tempSegmentEndNode.getOnCircleNodeExt().getIndex() - tempSegmentStartNode.getOnCircleNodeExt().getIndex() + segmentLength) % segmentLength + 1;
                    if (tempSegmentLength < shortestSegmentLength) {
                        shortestSegmentStartNode = tempSegmentStartNode;
                        shortestSegmentEndNode = tempSegmentEndNode;
                        shortestSegmentLength = tempSegmentLength;
                    }
                }
                // After finding start and end nodes for the segment, simply go over
                // ordered nodes and create an ordered list of nodes in the segment
                var segmentEndReached = false;
                var currentNode = shortestSegmentStartNode;
                while(!segmentEndReached){
                    if (currentNode !== node) segment.push(currentNode);
                    if (currentNode === shortestSegmentEndNode) segmentEndReached = true;
                    else {
                        var nextIndex = currentNode.getOnCircleNodeExt().getIndex() + 1;
                        if (nextIndex === orderedNodes.length) nextIndex = 0;
                        currentNode = orderedNodes[nextIndex];
                    }
                }
                return segment;
            };
            module1.exports = CiSELayout;
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * This class implements data and functionality required for CiSE layout per
 * node.
 *
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ var FDLayoutNode = __webpack_require__(0).layoutBase.FDLayoutNode;
            var IMath = __webpack_require__(0).layoutBase.IMath;
            var CiSEConstants = __webpack_require__(1);
            var CiSEOnCircleNodeExt = __webpack_require__(12);
            function CiSENode(gm, loc, size, vNode) {
                // the constructor of LNode handles alternative constructors
                FDLayoutNode.call(this, gm, loc, size, vNode);
                // Amount by which this node will be rotated in this iteration. Note that
                // clockwise rotation is positive and counter-clockwise is negative.
                this.rotationAmount = null;
                // Extension for on-circle nodes
                this.onCircleNodeExt = null; //Extension for on-circle nodes
                // Cluster ID which the node belongs to
                this.clusterID = null;
                // Cytoscape node ID for transforming between layout and cytoscape
                this.ID = null;
            }
            CiSENode.prototype = Object.create(FDLayoutNode.prototype);
            for(var prop in FDLayoutNode)CiSENode[prop] = FDLayoutNode[prop];
            // -----------------------------------------------------------------------------
            // Section: Accessors and mutators
            // -----------------------------------------------------------------------------
            CiSENode.prototype.setClusterId = function(cID) {
                this.clusterID = cID;
            };
            CiSENode.prototype.getClusterId = function() {
                return this.clusterID;
            };
            CiSENode.prototype.setId = function(ID) {
                this.ID = ID;
            };
            CiSENode.prototype.getId = function() {
                return this.ID;
            };
            /**
 * This method sets this node as an on-circle node by creating an extension for it.
 */ CiSENode.prototype.setAsOnCircleNode = function() {
                this.onCircleNodeExt = new CiSEOnCircleNodeExt(this);
                return this.onCircleNodeExt;
            };
            /**
 * This method sets this node as an non on-circle node by deleting the
 * extension for it.
 */ CiSENode.prototype.setAsNonOnCircleNode = function() {
                this.onCircleNodeExt = null;
            };
            /**
 * This method returns the extension of this node for on-circle nodes. This
 * extension is null if this node is a non-on-circle node.
 */ CiSENode.prototype.getOnCircleNodeExt = function() {
                return this.onCircleNodeExt;
            };
            /**
 * This method limits the input displacement with the maximum possible.
 */ CiSENode.prototype.getLimitedDisplacement = function(displacement) {
                if (Math.abs(displacement) > CiSEConstants.MAX_NODE_DISPLACEMENT) displacement = CiSEConstants.MAX_NODE_DISPLACEMENT * IMath.sign(displacement);
                return displacement;
            };
            /**
 * This method returns neighbors of this node which are on-circle, not
 * in-circle.
 */ CiSENode.prototype.getOnCircleNeighbors = function() {
                var neighbors = Array.from(this.getNeighborsList());
                var onCircleNeighbors = [];
                for(var i = 0; i < neighbors.length; i++){
                    var node = neighbors[i];
                    if (node.getOnCircleNodeExt() !== null && node.getClusterId() === this.getClusterId()) onCircleNeighbors.push(node);
                }
                return onCircleNeighbors;
            };
            /**
 * This method returns the number of children (weight) of this node.
 * If it is a compound, then return the number of simple nodes inside,
 * otherwise return 1.
 */ CiSENode.prototype.getNoOfChildren = function() {
                if (this.getChild() === null || this.getChild() === undefined) return 1;
                else return this.getChild().getNodes().length;
            };
            // -----------------------------------------------------------------------------
            // Section: Remaining methods
            // -----------------------------------------------------------------------------
            /**
 * This method moves this node as a result of the computations at the end of
 * this iteration.
 */ CiSENode.prototype.move = function() {
                var layout = this.getOwner().getGraphManager().getLayout();
                this.displacementX = this.getLimitedDisplacement(this.displacementX);
                this.displacementY = this.getLimitedDisplacement(this.displacementY);
                // First propagate movement to children if it's a circle
                if (this.getChild() !== null && this.getChild() !== undefined) {
                    // Take size into account when reflecting total force into movement!
                    var noOfNodesOnCircle = this.getChild().getNodes().length;
                    this.displacementX /= noOfNodesOnCircle;
                    this.displacementY /= noOfNodesOnCircle;
                    var children = this.getChild().getNodes();
                    for(var i = 0; i < children.length; i++){
                        var node = children[i];
                        node.moveBy(this.displacementX, this.displacementY);
                        layout.totalDisplacement += Math.abs(this.displacementX) + Math.abs(this.displacementY);
                    }
                }
                this.moveBy(this.displacementX, this.displacementY);
                layout.totalDisplacement += Math.abs(this.displacementX) + Math.abs(this.displacementY);
                if (this.getChild() !== null && this.getChild() !== undefined) this.getChild().updateBounds(true);
            };
            /**
 * This method resets displacement values
 */ CiSENode.prototype.reset = function() {
                this.displacementX = 0.0;
                this.displacementY = 0.0;
            };
            module1.exports = CiSENode;
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
/**
 * This class implements data and functionality required for CiSE layout per
 * on-circle node. In other words, it is an extension to CiSENode class for
 * on-circle nodes.
 *
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ var IGeometry = __webpack_require__(0).layoutBase.IGeometry;
            // -----------------------------------------------------------------------------
            // Section: Constructors and initializations
            // -----------------------------------------------------------------------------
            function CiSEOnCircleNodeExt(ciseNode) {
                // Associated CiSE node
                this.ciseNode = ciseNode;
                // Holds the intra-cluster edges of this node, initially it is null. It
                // will be calculated and stored when getIntraClusterEdges method is first
                // called.
                this.intraClusterEdges = null;
                // Holds the inter-cluster edges of this node, initially it is null. It
                // will be calculated and stored when getInterClusterEdges method is first
                // called.
                this.interClusterEdges = null;
                // Holds relative position of this node with respect to its owner circle
                // It is less than 0 (=-1) only if not assigned. Its unit is radian.
                this.angle = -1;
                // Holds current index of this node within its owner circle; it is -1 if not
                // assigned.
                this.orderIndex = -1;
                // Indicates whether a swapping with next node in the owner circle order
                // will cause no additional crossings or not.
                this.canSwapWithNext = null;
                // Indicates whether a swapping with previous node in the owner circle order
                // will cause no additional crossings or not.
                this.canSwapWithPrevious = null;
                // Holds the total weighted displacement value calculated over a constant
                // number of iterations used for deciding whether two nodes should be
                // swapped.
                this.displacementForSwap = null;
            }
            CiSEOnCircleNodeExt.prototype = Object.create(null);
            // -----------------------------------------------------------------------------
            // Section: Accessors and mutators
            // -----------------------------------------------------------------------------
            // This function returns the associated CiSENode
            CiSEOnCircleNodeExt.prototype.getCiseNode = function() {
                return this.ciseNode;
            };
            // This function returns the relative position of this node
            // within it's owner circle
            CiSEOnCircleNodeExt.prototype.getAngle = function() {
                return this.angle;
            };
            // This function sets the relative position of this node within its owner
            // circle. We keep the angle positive for easy debugging.
            CiSEOnCircleNodeExt.prototype.setAngle = function(angle) {
                this.angle = angle % IGeometry.TWO_PI;
                if (this.angle < 0) this.angle += IGeometry.TWO_PI;
            };
            // This function returns current index of this in it's owner circle
            CiSEOnCircleNodeExt.prototype.getIndex = function() {
                return this.orderIndex;
            };
            // This function sets current index of this node in its owner circle.
            CiSEOnCircleNodeExt.prototype.setIndex = function(index) {
                this.orderIndex = index;
            };
            /**
 * This method returns the char code of this node based on the node index.
 * First node of the cluster is 'a', second one is 'b", and so on. We only
 * guarentee a unique char code up to 52 nodes in a cluster.
 *
 * Remember in ASCII, 'a' is 97 and 'A' is 65. In Unicode, 'A' has a bigger decimal value
 */ CiSEOnCircleNodeExt.prototype.getCharCode = function() {
                var charCode = void 0;
                if (this.orderIndex < 26) charCode = String.fromCharCode(97 + this.orderIndex);
                else if (this.orderIndex < 52) charCode = String.fromCharCode(65 + this.orderIndex);
                else charCode = '?';
                return charCode;
            };
            /**
 * This method returns the next node according to current ordering of the
 * owner circle.
 */ CiSEOnCircleNodeExt.prototype.getNextNode = function() {
                var circle = this.ciseNode.getOwner();
                var totalNodes = circle.getOnCircleNodes().length;
                var nextNodeIndex = this.orderIndex + 1;
                if (nextNodeIndex === totalNodes) nextNodeIndex = 0;
                return circle.getOnCircleNodes()[nextNodeIndex];
            };
            /**
 * This method returns the previous node according to current ordering of
 * the owner circle.
 */ CiSEOnCircleNodeExt.prototype.getPrevNode = function() {
                var circle = this.ciseNode.getOwner();
                var nextNodeIndex = this.orderIndex - 1;
                if (nextNodeIndex === -1) nextNodeIndex = circle.getOnCircleNodes().length - 1;
                return circle.getOnCircleNodes()[nextNodeIndex];
            };
            /**
 * This method returns the extension of the next node according to current
 * ordering of the owner circle.
 */ CiSEOnCircleNodeExt.prototype.getNextNodeExt = function() {
                return this.getNextNode().getOnCircleNodeExt();
            };
            /**
 * This method returns the extension of the previous node according to
 * current ordering of the owner circle.
 */ CiSEOnCircleNodeExt.prototype.prevNextNodeExt = function() {
                return this.getPrevNode().getOnCircleNodeExt();
            };
            CiSEOnCircleNodeExt.prototype.canSwapWithNext = function() {
                return this.canSwapWithNext;
            };
            CiSEOnCircleNodeExt.prototype.canSwapWithPrev = function() {
                return this.canSwapWithPrev;
            };
            CiSEOnCircleNodeExt.prototype.getDisplacementForSwap = function() {
                return this.displacementForSwap;
            };
            CiSEOnCircleNodeExt.prototype.setDisplacementForSwap = function(displacementForSwap) {
                this.displacementForSwap = displacementForSwap;
            };
            CiSEOnCircleNodeExt.prototype.addDisplacementForSwap = function(displacementIncrForSwap) {
                this.displacementForSwap = displacementIncrForSwap;
            // This is what we intended (but above seems to work better):
            //		this.displacementForSwap = (this.displacementForSwap +
            //			displacementIncrForSwap) / 2.0;
            };
            // -----------------------------------------------------------------------------
            // Section: Remaining methods
            // -----------------------------------------------------------------------------
            /**
 * This method updates the absolute position of this node with respect to
 * its angle and the position of node that owns the owner circle.
 */ CiSEOnCircleNodeExt.prototype.updatePosition = function() {
                var ownerGraph = this.ciseNode.getOwner();
                var parentNode = ownerGraph.getParent();
                var parentX = parentNode.getCenterX();
                var parentY = parentNode.getCenterY();
                var xDifference = ownerGraph.getRadius() * Math.cos(this.angle);
                var yDifference = ownerGraph.getRadius() * Math.sin(this.angle);
                this.ciseNode.setCenter(parentX + xDifference, parentY + yDifference);
            };
            /**
 * This method returns the index difference of this node with the input
 * node. Note that the index difference cannot be negative if both nodes are
 * placed on the circle. Here -1 means at least one of the nodes are not yet
 * placed on the circle.
 */ CiSEOnCircleNodeExt.prototype.getCircDistWithTheNode = function(refNode) {
                var otherIndex = refNode.getIndex();
                if (otherIndex === -1 || this.getIndex() === -1) return -1;
                var diff = this.getIndex() - otherIndex;
                if (diff < 0) diff += this.ciseNode.getOwner().getOnCircleNodes().length;
                return diff;
            };
            /**
 * This method calculates the total number of crossings the edges of this
 * node cause.
 */ CiSEOnCircleNodeExt.prototype.calculateTotalCrossing = function() {
                var intraEdges = this.getIntraClusterEdges();
                var count = 0;
                var temp = [];
                this.ciseNode.getOwner().getIntraClusterEdges().forEach(function(edge) {
                    temp.push(edge);
                });
                this.ciseNode.getEdges().forEach(function(edge) {
                    var index = temp.indexOf(edge);
                    if (index > -1) temp.splice(index, 1);
                });
                intraEdges.forEach(function(edge) {
                    count += edge.calculateTotalCrossingWithList(temp);
                });
                return count;
            };
            /**
 * This method updates the conditions for swapping of this node with its
 * previous and next neighbors on the associated circle.
 */ CiSEOnCircleNodeExt.prototype.updateSwappingConditions = function() {
                // Current values
                var currentCrossingNumber = this.calculateTotalCrossing();
                var currentNodeIndex = this.orderIndex;
                // What will happen if node is swapped with next
                var nextNodeExt = this.getNextNode().getOnCircleNodeExt();
                this.orderIndex = nextNodeExt.getIndex();
                nextNodeExt.setIndex(currentNodeIndex);
                var tempCrossingNumber = this.calculateTotalCrossing();
                this.canSwapWithNext = tempCrossingNumber <= currentCrossingNumber;
                // Reset indices
                nextNodeExt.setIndex(this.orderIndex);
                this.setIndex(currentNodeIndex);
                // What will happen if node is swapped with prev
                var prevNodeExt = this.getPrevNode().getOnCircleNodeExt();
                this.orderIndex = prevNodeExt.getIndex();
                prevNodeExt.setIndex(currentNodeIndex);
                tempCrossingNumber = this.calculateTotalCrossing();
                this.canSwapWithPrevious = tempCrossingNumber <= currentCrossingNumber;
                // Reset indices
                prevNodeExt.setIndex(this.orderIndex);
                this.setIndex(currentNodeIndex);
            };
            /**
 * This method swaps this node with the specified neighbor (prev or next).
 */ CiSEOnCircleNodeExt.prototype.swapWith = function(neighborExt) {
                this.ciseNode.getOwner().swapNodes(this.ciseNode, neighborExt.ciseNode);
            };
            /**
 * This method finds the number of crossings of inter cluster edges of this
 * node with the inter cluster edges of the other node.
 */ CiSEOnCircleNodeExt.prototype.getInterClusterIntersections = function(other) {
                var count = 0;
                var thisInterClusterEdges = this.getInterClusterEdges();
                var otherInterClusterEdges = other.getInterClusterEdges();
                for(var i = 0; i < thisInterClusterEdges.length; i++){
                    var edge = thisInterClusterEdges[i];
                    var point1 = this.ciseNode.getCenter();
                    var point2 = edge.getOtherEnd(this.ciseNode).getCenter();
                    for(var j = 0; j < otherInterClusterEdges.length; j++){
                        var otherEdge = otherInterClusterEdges[j];
                        var point3 = other.ciseNode.getCenter();
                        var point4 = otherEdge.getOtherEnd(other.ciseNode).getCenter();
                        if (edge.getOtherEnd(this.ciseNode) !== otherEdge.getOtherEnd(other.ciseNode)) {
                            var result = IGeometry.doIntersect(point1, point2, point3, point4);
                            if (result) count++;
                        }
                    }
                }
                return count;
            };
            /**
 * This method returns the inter cluster edges of the associated node.
 */ CiSEOnCircleNodeExt.prototype.getInterClusterEdges = function() {
                if (this.interClusterEdges === null) {
                    //first time accessing
                    this.interClusterEdges = [];
                    var edgesOfNode = this.ciseNode.getEdges();
                    for(var i = 0; i < edgesOfNode.length; i++){
                        var edge = edgesOfNode[i];
                        if (!edge.isIntraCluster) this.interClusterEdges.push(edge);
                    }
                }
                return this.interClusterEdges;
            };
            /**
 * This method returns the intra cluster edges of the associated node.
 */ CiSEOnCircleNodeExt.prototype.getIntraClusterEdges = function() {
                if (this.intraClusterEdges === null) {
                    //first time accessing
                    this.intraClusterEdges = [];
                    var edgesOfNode = this.ciseNode.getEdges();
                    for(var i = 0; i < edgesOfNode.length; i++){
                        var edge = edgesOfNode[i];
                        if (edge.isIntraCluster) this.intraClusterEdges.push(edge);
                    }
                }
                return this.intraClusterEdges;
            };
            module1.exports = CiSEOnCircleNodeExt;
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * This class implements a pair of on-circle nodes used for swapping in phase 4.
 *
 */ // -----------------------------------------------------------------------------
            // Section: Constructors and initializations
            // -----------------------------------------------------------------------------
            function CiSEOnCircleNodePair(first, second, displacement, inSameDirection) {
                // The node of the pair which comes first in the ordering of its owner
                // circle.
                this.firstNode = first;
                // The node of the pair which comes second in the ordering of its owner
                // circle.
                this.secondNode = second;
                // The discrepancy of the displacement values of two nodes, indicating the
                // swapping potential of the two nodes. Higher value means that nodes are
                // more inclined to swap.
                this.discrepancy = displacement;
                // Whether or not the two nodes are pulling in the same direction
                this.inSameDir = inSameDirection;
            }
            CiSEOnCircleNodePair.prototype = Object.create;
            // -----------------------------------------------------------------------------
            // Section: Accessors
            // -----------------------------------------------------------------------------
            CiSEOnCircleNodePair.prototype.getDiscrepancy = function() {
                return this.discrepancy;
            };
            CiSEOnCircleNodePair.prototype.inSameDirection = function() {
                return this.inSameDir;
            };
            CiSEOnCircleNodePair.prototype.getFirstNode = function() {
                return this.firstNode;
            };
            CiSEOnCircleNodePair.prototype.getSecondNode = function() {
                return this.secondNode;
            };
            // -----------------------------------------------------------------------------
            // Section: Remaining methods
            // -----------------------------------------------------------------------------
            CiSEOnCircleNodePair.prototype.compareTo = function(other) {
                return this.getDiscrepancy() - other.getDiscrepancy();
            };
            CiSEOnCircleNodePair.prototype.swap = function() {
                this.getFirstNode().getOnCircleNodeExt().swapWith(this.getSecondNode().getOnCircleNodeExt());
            };
            CiSEOnCircleNodePair.prototype.equals = function(other) {
                var result = other instanceof CiSEOnCircleNodePair;
                if (result) {
                    var pair = other;
                    result &= this.firstNode.equals(pair.getFirstNode()) && this.secondNode.equals(pair.getSecondNode()) || this.secondNode.equals(pair.getFirstNode()) && this.firstNode.equals(pair.getSecondNode());
                }
                return result;
            };
            CiSEOnCircleNodePair.prototype.hashCode = function() {
                return this.firstNode.hashCode() + this.secondNode.hashCode();
            };
            CiSEOnCircleNodePair.prototype.toString = function() {
                var result = "Swap: " + this.getFirstNode().label;
                result += "<->" + this.getSecondNode().label;
                result += ", " + this.getDiscrepancy();
                return result;
            };
            module1.exports = CiSEOnCircleNodePair;
        /***/ },
        /* 14 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * This class is a utility class that is used to store the rotation amount,
 * x-axis displacement and y-axis displacement components of a force that act
 * upon an on-circle node. The calculation for this is done in CiSECircle for
 * specified on-circle node. Here we assume that forces on on-circle nodes can
 * be modelled with forces acting upon the perimeter of a circular flat, rigid
 * object sitting on a 2-dimensional surface, free to move in a direction
 * without any friction. Thus, such an object is assumed to move and rotate on
 * this force in amounts proportional to the total force (not just the vertical
 * component of the force!) and the component of the force that is tangential to
 * the circular shape of the object, respectively.
 *
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ // -----------------------------------------------------------------------------
            // Section: Constructors and initializations
            // -----------------------------------------------------------------------------
            function CircularForce(rotationAmount, displacementX, displacementY) {
                // This is the rotation amount that is to be assigned to the rotationAmount
                // of a CiSENode
                this.rotationAmount = rotationAmount;
                // This is the x-axis displacement value that is to be assigned to the displacementX
                // of a CiSENode
                this.displacementX = displacementX;
                // This is the y-axis displacement value that is to be assigned to the displacementY
                // of a CiSENode
                this.displacementY = displacementY;
            }
            // -----------------------------------------------------------------------------
            // Section: Accessors and mutators
            // -----------------------------------------------------------------------------
            CircularForce.prototype.getRotationAmount = function() {
                return this.rotationAmount;
            };
            CircularForce.prototype.setRotationAmount = function(rotationAmount) {
                this.rotationAmount = rotationAmount;
            };
            CircularForce.prototype.getDisplacementX = function() {
                return this.displacementX;
            };
            CircularForce.prototype.setDisplacementX = function(displacementX) {
                this.displacementX = displacementX;
            };
            CircularForce.prototype.getDisplacementY = function() {
                return this.displacementY;
            };
            CircularForce.prototype.setDisplacementY = function(displacementY) {
                this.displacementY = displacementY;
            };
            module1.exports = CircularForce;
        /***/ },
        /* 15 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var impl = __webpack_require__(4);
            // registers the extension on a cytoscape lib ref
            var register = function register(cytoscape1) {
                if (!cytoscape1) return;
                 // can't register if cytoscape unspecified
                cytoscape1('layout', 'cise', impl); // register with cytoscape.js
            };
            if (typeof cytoscape !== 'undefined') // expose to global cytoscape (i.e. window.cytoscape)
            register(cytoscape);
            module1.exports = register;
        /***/ },
        /* 16 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * This class builds the required connection between CiSE elements and Cytoscape extension elements
 *
 *
 * Copyright: i-Vis Research Group, Bilkent University, 2007 - present
 */ var CiSELayout = __webpack_require__(10);
            var CiSEConstants = __webpack_require__(1);
            var FDLayoutConstants = __webpack_require__(0).layoutBase.FDLayoutConstants;
            var ContinuousLayout = __webpack_require__(18);
            var defaults = ContinuousLayout.defaults;
            var assign = __webpack_require__(2);
            var isFn = function isFn(fn) {
                return typeof fn === 'function';
            };
            var optFn = function optFn(opt, ele) {
                if (isFn(opt)) return opt(ele);
                else return opt;
            };
            var Layout = function(_ContinuousLayout) {
                _inherits(Layout, _ContinuousLayout);
                function Layout(options) {
                    _classCallCheck(this, Layout);
                    //Changing CiSEConstants if there is a particular option defined in 'options' part of Layout call
                    var _this = _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).call(this, assign({}, defaults, options)));
                    if (options.nodeSeparation !== null && options.nodeSeparation !== undefined) CiSEConstants.DEFAULT_NODE_SEPARATION = options.nodeSeparation;
                    else CiSEConstants.DEFAULT_NODE_SEPARATION = FDLayoutConstants.DEFAULT_EDGE_LENGTH / 4;
                    if (options.idealInterClusterEdgeLengthCoefficient !== null && options.idealInterClusterEdgeLengthCoefficient !== undefined) CiSEConstants.DEFAULT_IDEAL_INTER_CLUSTER_EDGE_LENGTH_COEFF = options.idealInterClusterEdgeLengthCoefficient;
                    else CiSEConstants.DEFAULT_IDEAL_INTER_CLUSTER_EDGE_LENGTH_COEFF = 1.4;
                    if (options.allowNodesInsideCircle !== null && options.allowNodesInsideCircle !== undefined) CiSEConstants.DEFAULT_ALLOW_NODES_INSIDE_CIRCLE = options.allowNodesInsideCircle;
                    else CiSEConstants.DEFAULT_ALLOW_NODES_INSIDE_CIRCLE = false;
                    if (options.maxRatioOfNodesInsideCircle !== null && options.maxRatioOfNodesInsideCircle !== undefined) CiSEConstants.DEFAULT_MAX_RATIO_OF_NODES_INSIDE_CIRCLE = options.maxRatioOfNodesInsideCircle;
                    else CiSEConstants.DEFAULT_MAX_RATIO_OF_NODES_INSIDE_CIRCLE = 0.1;
                    if (options.springCoeff !== null && options.springCoeff !== undefined) CiSEConstants.DEFAULT_SPRING_STRENGTH = options.springCoeff;
                    else CiSEConstants.DEFAULT_SPRING_STRENGTH = 1.5 * FDLayoutConstants.DEFAULT_SPRING_STRENGTH;
                    if (options.nodeRepulsion != null) CiSEConstants.DEFAULT_REPULSION_STRENGTH = FDLayoutConstants.DEFAULT_REPULSION_STRENGTH = options.nodeRepulsion;
                    if (options.gravity != null) CiSEConstants.DEFAULT_GRAVITY_STRENGTH = FDLayoutConstants.DEFAULT_GRAVITY_STRENGTH = options.gravity;
                    if (options.gravityRange != null) CiSEConstants.DEFAULT_GRAVITY_RANGE_FACTOR = FDLayoutConstants.DEFAULT_GRAVITY_RANGE_FACTOR = options.gravityRange;
                    if (options.maxRatioOfNodesInsideCircle !== null && options.maxRatioOfNodesInsideCircle !== undefined) CiSEConstants.DEFAULT_MAX_RATIO_OF_NODES_INSIDE_CIRCLE = options.maxRatioOfNodesInsideCircle;
                    else CiSEConstants.DEFAULT_MAX_RATIO_OF_NODES_INSIDE_CIRCLE = 0.1;
                    return _this;
                }
                _createClass(Layout, [
                    {
                        key: 'prerun',
                        value: function prerun() {
                            var state = this.state;
                            //Get the graph information from Cytoscape
                            var clusters = [
                                []
                            ];
                            if (this.options.clusters !== null && this.options.clusters !== undefined) clusters = this.options.clusters;
                            var nodes = state.nodes;
                            var edges = state.edges;
                            //Initialize CiSE elements
                            var ciseLayout = this.ciseLayout = new CiSELayout();
                            var graphManager = this.graphManager = ciseLayout.newGraphManager();
                            var root = this.root = graphManager.addRoot();
                            // Construct the GraphManager according to the graph from Cytoscape
                            this.idToLNode = ciseLayout.convertToClusteredGraph(nodes, edges, clusters);
                            //This method updates whether this graph is connected or not
                            root.updateConnected();
                            // This method calculates and returns the estimated size of this graph
                            root.calcEstimatedSize();
                            ciseLayout.calcNoOfChildrenForAllNodes();
                            ciseLayout.doStep1();
                            ciseLayout.doStep2();
                            root.updateBounds(true);
                            root.estimatedSize = Math.max(root.right - root.left, root.bottom - root.top);
                            ciseLayout.prepareCirclesForReversal();
                            ciseLayout.calcIdealEdgeLengths(false);
                            // ------------------------------------------
                            // The variables to maintain the spring steps
                            // ------------------------------------------
                            // Index is there to iterate over steps
                            this.initializerIndex = 0;
                            // If the whole algorithm is finished
                            this.isDone = false;
                            // If the current step is finished
                            this.isStepDone = false;
                            // when to change to next step
                            this.timeToSwitchNextStep = true;
                        }
                    },
                    {
                        key: 'tick',
                        value: function tick() {
                            var _this2 = this;
                            // Getting References
                            var self = this;
                            var state = this.state;
                            // Update Each Node Locations
                            state.nodes.forEach(function(n) {
                                var s = _this2.getScratch(n);
                                var location = self.idToLNode[n.data('id')];
                                s.x = location.getCenterX();
                                s.y = location.getCenterY();
                            });
                            if (this.timeToSwitchNextStep) {
                                switch(this.initializerIndex){
                                    case 0:
                                        this.ciseLayout.step5Init();
                                        break;
                                    case 1:
                                        this.ciseLayout.step3Init();
                                        break;
                                    case 2:
                                        this.ciseLayout.step5Init();
                                        break;
                                    case 3:
                                        this.ciseLayout.step4Init();
                                        break;
                                    case 4:
                                        this.ciseLayout.findAndMoveInnerNodes();
                                        this.ciseLayout.calcIdealEdgeLengths(true);
                                        this.ciseLayout.step5Init();
                                        break;
                                }
                                this.initializerIndex++;
                                this.ciseLayout.iterations = 0;
                                this.ciseLayout.totalDisplacement = 1000;
                                this.timeToSwitchNextStep = false;
                            }
                            // Run one spring iteration
                            this.isStepDone = this.ciseLayout.runSpringEmbedderTick();
                            if (this.isStepDone && this.initializerIndex < 5) this.timeToSwitchNextStep = true;
                            if (this.isStepDone && this.timeToSwitchNextStep === false) this.isDone = true;
                            return this.isDone;
                        }
                    },
                    {
                        key: 'postrun',
                        value: function postrun() {}
                    },
                    {
                        key: 'destroy',
                        value: function destroy() {
                            _get(Layout.prototype.__proto__ || Object.getPrototypeOf(Layout.prototype), 'destroy', this).call(this);
                            return this;
                        }
                    }
                ]);
                return Layout;
            }(ContinuousLayout);
            module1.exports = Layout;
        /***/ },
        /* 17 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // general default options for force-directed layout
            module1.exports = Object.freeze({
                animate: false,
                refresh: 10,
                maxIterations: 2500,
                maxSimulationTime: 5000,
                ungrabifyWhileSimulating: false,
                fit: true,
                padding: 30,
                boundingBox: undefined,
                // layout event callbacks
                ready: function ready() {},
                stop: function stop() {},
                // positioning options
                randomize: false,
                // infinite layout options
                infinite: false // overrides all other options for a forces-all-the-time mode
            });
        /***/ },
        /* 18 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /**
A generic continuous layout class
*/ var assign = __webpack_require__(2);
            var defaults = __webpack_require__(17);
            var makeBoundingBox = __webpack_require__(19);
            var _require = __webpack_require__(20), setInitialPositionState = _require.setInitialPositionState, refreshPositions = _require.refreshPositions, getNodePositionData = _require.getNodePositionData;
            var _require2 = __webpack_require__(21), multitick = _require2.multitick;
            var Layout = function() {
                function Layout(options) {
                    _classCallCheck(this, Layout);
                    var o = this.options = assign({}, defaults, options);
                    var s = this.state = assign({}, o, {
                        layout: this,
                        nodes: o.eles.nodes(),
                        edges: o.eles.edges(),
                        tickIndex: 0,
                        firstUpdate: true
                    });
                    s.animateEnd = o.animate && o.animate === 'end';
                    s.animateContinuously = o.animate && !s.animateEnd;
                }
                _createClass(Layout, [
                    {
                        key: 'getScratch',
                        value: function getScratch(el) {
                            var name = this.state.name;
                            var scratch = el.scratch(name);
                            if (!scratch) {
                                scratch = {};
                                el.scratch(name, scratch);
                            }
                            return scratch;
                        }
                    },
                    {
                        key: 'run',
                        value: function run() {
                            var l = this;
                            var s = this.state;
                            s.tickIndex = 0;
                            s.firstUpdate = true;
                            s.startTime = Date.now();
                            s.running = true;
                            s.currentBoundingBox = makeBoundingBox(s.boundingBox, s.cy);
                            if (s.ready) l.one('ready', s.ready);
                            if (s.stop) l.one('stop', s.stop);
                            s.nodes.forEach(function(n) {
                                return setInitialPositionState(n, s);
                            });
                            l.prerun(s);
                            if (s.animateContinuously) {
                                var ungrabify = function ungrabify(node) {
                                    if (!s.ungrabifyWhileSimulating) return;
                                    var grabbable = getNodePositionData(node, s).grabbable = node.grabbable();
                                    if (grabbable) node.ungrabify();
                                };
                                var regrabify = function regrabify(node) {
                                    if (!s.ungrabifyWhileSimulating) return;
                                    var grabbable = getNodePositionData(node, s).grabbable;
                                    if (grabbable) node.grabify();
                                };
                                var updateGrabState = function updateGrabState(node) {
                                    return getNodePositionData(node, s).grabbed = node.grabbed();
                                };
                                var onGrab = function onGrab(_ref) {
                                    var target = _ref.target;
                                    updateGrabState(target);
                                };
                                var onFree = onGrab;
                                var onDrag = function onDrag(_ref2) {
                                    var target = _ref2.target;
                                    var p = getNodePositionData(target, s);
                                    var tp = target.position();
                                    p.x = tp.x;
                                    p.y = tp.y;
                                };
                                var listenToGrab = function listenToGrab(node) {
                                    node.on('grab', onGrab);
                                    node.on('free', onFree);
                                    node.on('drag', onDrag);
                                };
                                var unlistenToGrab = function unlistenToGrab(node) {
                                    node.removeListener('grab', onGrab);
                                    node.removeListener('free', onFree);
                                    node.removeListener('drag', onDrag);
                                };
                                var fit = function fit() {
                                    if (s.fit && s.animateContinuously) s.cy.fit(s.padding);
                                };
                                var onNotDone = function onNotDone() {
                                    refreshPositions(s.nodes, s);
                                    fit();
                                    requestAnimationFrame(_frame);
                                };
                                var _frame = function _frame() {
                                    multitick(s, onNotDone, _onDone);
                                };
                                var _onDone = function _onDone() {
                                    refreshPositions(s.nodes, s);
                                    fit();
                                    s.nodes.forEach(function(n) {
                                        regrabify(n);
                                        unlistenToGrab(n);
                                    });
                                    s.running = false;
                                    l.emit('layoutstop');
                                };
                                l.emit('layoutstart');
                                s.nodes.forEach(function(n) {
                                    ungrabify(n);
                                    listenToGrab(n);
                                });
                                _frame(); // kick off
                            } else {
                                var done = false;
                                var _onNotDone = function _onNotDone() {};
                                var _onDone2 = function _onDone2() {
                                    return done = true;
                                };
                                while(!done)multitick(s, _onNotDone, _onDone2);
                                s.eles.layoutPositions(this, s, function(node) {
                                    var pd = getNodePositionData(node, s);
                                    return {
                                        x: pd.x,
                                        y: pd.y
                                    };
                                });
                            }
                            l.postrun(s);
                            return this; // chaining
                        }
                    },
                    {
                        key: 'prerun',
                        value: function prerun() {}
                    },
                    {
                        key: 'postrun',
                        value: function postrun() {}
                    },
                    {
                        key: 'tick',
                        value: function tick() {}
                    },
                    {
                        key: 'stop',
                        value: function stop() {
                            this.state.running = false;
                            return this; // chaining
                        }
                    },
                    {
                        key: 'destroy',
                        value: function destroy() {
                            return this; // chaining
                        }
                    }
                ]);
                return Layout;
            }();
            module1.exports = Layout;
        /***/ },
        /* 19 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function(bb, cy) {
                if (bb == null) bb = {
                    x1: 0,
                    y1: 0,
                    w: cy.width(),
                    h: cy.height()
                };
                else // copy
                bb = {
                    x1: bb.x1,
                    x2: bb.x2,
                    y1: bb.y1,
                    y2: bb.y2,
                    w: bb.w,
                    h: bb.h
                };
                if (bb.x2 == null) bb.x2 = bb.x1 + bb.w;
                if (bb.w == null) bb.w = bb.x2 - bb.x1;
                if (bb.y2 == null) bb.y2 = bb.y1 + bb.h;
                if (bb.h == null) bb.h = bb.y2 - bb.y1;
                return bb;
            };
        /***/ },
        /* 20 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var assign = __webpack_require__(2);
            var setInitialPositionState = function setInitialPositionState(node, state) {
                var p = node.position();
                var bb = state.currentBoundingBox;
                var scratch = node.scratch(state.name);
                if (scratch == null) {
                    scratch = {};
                    node.scratch(state.name, scratch);
                }
                assign(scratch, state.randomize ? {
                    x: bb.x1 + Math.round(Math.random() * bb.w),
                    y: bb.y1 + Math.round(Math.random() * bb.h)
                } : {
                    x: p.x,
                    y: p.y
                });
                scratch.locked = node.locked();
            };
            var getNodePositionData = function getNodePositionData(node, state) {
                return node.scratch(state.name);
            };
            var refreshPositions = function refreshPositions(nodes, state) {
                nodes.positions(function(node) {
                    var scratch = node.scratch(state.name);
                    return {
                        x: scratch.x,
                        y: scratch.y
                    };
                });
            };
            module1.exports = {
                setInitialPositionState: setInitialPositionState,
                getNodePositionData: getNodePositionData,
                refreshPositions: refreshPositions
            };
        /***/ },
        /* 21 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var nop = function nop() {};
            var tick = function tick(state) {
                var s = state;
                var l = state.layout;
                var tickIndicatesDone = l.tick(s);
                if (s.firstUpdate) {
                    if (s.animateContinuously) // indicate the initial positions have been set
                    s.layout.emit('layoutready');
                    s.firstUpdate = false;
                }
                s.tickIndex++;
                // || s.tickIndex >= s.maxIterations || duration >= s.maxSimulationTime -> This depends on # of nodes
                return !s.infinite && tickIndicatesDone;
            };
            var multitick = function multitick(state) {
                var onNotDone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : nop;
                var onDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : nop;
                var done = false;
                var s = state;
                for(var i = 0; i < s.refresh; i++){
                    done = !s.running || tick(s);
                    if (done) break;
                }
                if (!done) onNotDone();
                else onDone();
            };
            module1.exports = {
                tick: tick,
                multitick: multitick
            };
        /***/ }
    ]);
});


var $bc39d0a5044c7403$exports = {};

(function webpackUniversalModuleDefinition(root, factory) {
    $bc39d0a5044c7403$exports = factory((parcelRequire("ex9m6")));
})($bc39d0a5044c7403$exports, function(__WEBPACK_EXTERNAL_MODULE__140__) {
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ 658: /***/ (module1)=>{
                // Simple, internal Object.assign() polyfill for options objects etc.
                module1.exports = Object.assign != null ? Object.assign.bind(Object) : function(tgt) {
                    for(var _len = arguments.length, srcs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)srcs[_key - 1] = arguments[_key];
                    srcs.forEach(function(src) {
                        Object.keys(src).forEach(function(k) {
                            return tgt[k] = src[k];
                        });
                    });
                    return tgt;
                };
            /***/ },
            /***/ 548: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                var _slicedToArray = function() {
                    function sliceIterator(arr, i) {
                        var _arr = [];
                        var _n = true;
                        var _d = false;
                        var _e = undefined;
                        try {
                            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                                _arr.push(_s.value);
                                if (i && _arr.length === i) break;
                            }
                        } catch (err) {
                            _d = true;
                            _e = err;
                        } finally{
                            try {
                                if (!_n && _i["return"]) _i["return"]();
                            } finally{
                                if (_d) throw _e;
                            }
                        }
                        return _arr;
                    }
                    return function(arr, i) {
                        if (Array.isArray(arr)) return arr;
                        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    };
                }();
                /*
 * Auxiliary functions
 */ var LinkedList = __webpack_require__(140).layoutBase.LinkedList;
                var auxiliary = {};
                // get the top most nodes
                auxiliary.getTopMostNodes = function(nodes) {
                    var nodesMap = {};
                    for(var i = 0; i < nodes.length; i++)nodesMap[nodes[i].id()] = true;
                    var roots = nodes.filter(function(ele, i) {
                        if (typeof ele === "number") ele = i;
                        var parent = ele.parent()[0];
                        while(parent != null){
                            if (nodesMap[parent.id()]) return false;
                            parent = parent.parent()[0];
                        }
                        return true;
                    });
                    return roots;
                };
                // find disconnected components and create dummy nodes that connect them
                auxiliary.connectComponents = function(cy, eles, topMostNodes, dummyNodes) {
                    var queue = new LinkedList();
                    var visited = new Set();
                    var visitedTopMostNodes = [];
                    var currentNeighbor = void 0;
                    var minDegreeNode = void 0;
                    var minDegree = void 0;
                    var isConnected = false;
                    var count = 1;
                    var nodesConnectedToDummy = [];
                    var components = [];
                    var _loop = function _loop() {
                        var cmpt = cy.collection();
                        components.push(cmpt);
                        var currentNode = topMostNodes[0];
                        var childrenOfCurrentNode = cy.collection();
                        childrenOfCurrentNode.merge(currentNode).merge(currentNode.descendants().intersection(eles));
                        visitedTopMostNodes.push(currentNode);
                        childrenOfCurrentNode.forEach(function(node) {
                            queue.push(node);
                            visited.add(node);
                            cmpt.merge(node);
                        });
                        var _loop2 = function _loop2() {
                            currentNode = queue.shift();
                            // Traverse all neighbors of this node
                            var neighborNodes = cy.collection();
                            currentNode.neighborhood().nodes().forEach(function(node) {
                                if (eles.intersection(currentNode.edgesWith(node)).length > 0) neighborNodes.merge(node);
                            });
                            for(var i = 0; i < neighborNodes.length; i++){
                                var neighborNode = neighborNodes[i];
                                currentNeighbor = topMostNodes.intersection(neighborNode.union(neighborNode.ancestors()));
                                if (currentNeighbor != null && !visited.has(currentNeighbor[0])) {
                                    var childrenOfNeighbor = currentNeighbor.union(currentNeighbor.descendants());
                                    childrenOfNeighbor.forEach(function(node) {
                                        queue.push(node);
                                        visited.add(node);
                                        cmpt.merge(node);
                                        if (topMostNodes.has(node)) visitedTopMostNodes.push(node);
                                    });
                                }
                            }
                        };
                        while(queue.length != 0)_loop2();
                        cmpt.forEach(function(node) {
                            eles.intersection(node.connectedEdges()).forEach(function(e) {
                                // connectedEdges() usually cached
                                if (cmpt.has(e.source()) && cmpt.has(e.target())) // has() is cheap
                                cmpt.merge(e);
                            });
                        });
                        if (visitedTopMostNodes.length == topMostNodes.length) isConnected = true;
                        if (!isConnected || isConnected && count > 1) {
                            minDegreeNode = visitedTopMostNodes[0];
                            minDegree = minDegreeNode.connectedEdges().length;
                            visitedTopMostNodes.forEach(function(node) {
                                if (node.connectedEdges().length < minDegree) {
                                    minDegree = node.connectedEdges().length;
                                    minDegreeNode = node;
                                }
                            });
                            nodesConnectedToDummy.push(minDegreeNode.id());
                            // TO DO: Check efficiency of this part
                            var temp = cy.collection();
                            temp.merge(visitedTopMostNodes[0]);
                            visitedTopMostNodes.forEach(function(node) {
                                temp.merge(node);
                            });
                            visitedTopMostNodes = [];
                            topMostNodes = topMostNodes.difference(temp);
                            count++;
                        }
                    };
                    do _loop();
                    while (!isConnected);
                    if (dummyNodes) {
                        if (nodesConnectedToDummy.length > 0) dummyNodes.set('dummy' + (dummyNodes.size + 1), nodesConnectedToDummy);
                    }
                    return components;
                };
                // relocates componentResult to originalCenter if there is no fixedNodeConstraint
                auxiliary.relocateComponent = function(originalCenter, componentResult, options) {
                    if (!options.fixedNodeConstraint) {
                        var minXCoord = Number.POSITIVE_INFINITY;
                        var maxXCoord = Number.NEGATIVE_INFINITY;
                        var minYCoord = Number.POSITIVE_INFINITY;
                        var maxYCoord = Number.NEGATIVE_INFINITY;
                        if (options.quality == "draft") {
                            // calculate current bounding box
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = componentResult.nodeIndexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _ref = _step.value;
                                    var _ref2 = _slicedToArray(_ref, 2);
                                    var key = _ref2[0];
                                    var value = _ref2[1];
                                    var cyNode = options.cy.getElementById(key);
                                    if (cyNode) {
                                        var nodeBB = cyNode.boundingBox();
                                        var leftX = componentResult.xCoords[value] - nodeBB.w / 2;
                                        var rightX = componentResult.xCoords[value] + nodeBB.w / 2;
                                        var topY = componentResult.yCoords[value] - nodeBB.h / 2;
                                        var bottomY = componentResult.yCoords[value] + nodeBB.h / 2;
                                        if (leftX < minXCoord) minXCoord = leftX;
                                        if (rightX > maxXCoord) maxXCoord = rightX;
                                        if (topY < minYCoord) minYCoord = topY;
                                        if (bottomY > maxYCoord) maxYCoord = bottomY;
                                    }
                                }
                            // find difference between current and original center
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            var diffOnX = originalCenter.x - (maxXCoord + minXCoord) / 2;
                            var diffOnY = originalCenter.y - (maxYCoord + minYCoord) / 2;
                            // move component to original center
                            componentResult.xCoords = componentResult.xCoords.map(function(x) {
                                return x + diffOnX;
                            });
                            componentResult.yCoords = componentResult.yCoords.map(function(y) {
                                return y + diffOnY;
                            });
                        } else {
                            // calculate current bounding box
                            Object.keys(componentResult).forEach(function(item) {
                                var node = componentResult[item];
                                var leftX = node.getRect().x;
                                var rightX = node.getRect().x + node.getRect().width;
                                var topY = node.getRect().y;
                                var bottomY = node.getRect().y + node.getRect().height;
                                if (leftX < minXCoord) minXCoord = leftX;
                                if (rightX > maxXCoord) maxXCoord = rightX;
                                if (topY < minYCoord) minYCoord = topY;
                                if (bottomY > maxYCoord) maxYCoord = bottomY;
                            });
                            // find difference between current and original center
                            var _diffOnX = originalCenter.x - (maxXCoord + minXCoord) / 2;
                            var _diffOnY = originalCenter.y - (maxYCoord + minYCoord) / 2;
                            // move component to original center
                            Object.keys(componentResult).forEach(function(item) {
                                var node = componentResult[item];
                                node.setCenter(node.getCenterX() + _diffOnX, node.getCenterY() + _diffOnY);
                            });
                        }
                    }
                };
                auxiliary.calcBoundingBox = function(parentNode, xCoords, yCoords, nodeIndexes) {
                    // calculate bounds
                    var left = Number.MAX_SAFE_INTEGER;
                    var right = Number.MIN_SAFE_INTEGER;
                    var top = Number.MAX_SAFE_INTEGER;
                    var bottom = Number.MIN_SAFE_INTEGER;
                    var nodeLeft = void 0;
                    var nodeRight = void 0;
                    var nodeTop = void 0;
                    var nodeBottom = void 0;
                    var nodes = parentNode.descendants().not(":parent");
                    var s = nodes.length;
                    for(var i = 0; i < s; i++){
                        var node = nodes[i];
                        nodeLeft = xCoords[nodeIndexes.get(node.id())] - node.width() / 2;
                        nodeRight = xCoords[nodeIndexes.get(node.id())] + node.width() / 2;
                        nodeTop = yCoords[nodeIndexes.get(node.id())] - node.height() / 2;
                        nodeBottom = yCoords[nodeIndexes.get(node.id())] + node.height() / 2;
                        if (left > nodeLeft) left = nodeLeft;
                        if (right < nodeRight) right = nodeRight;
                        if (top > nodeTop) top = nodeTop;
                        if (bottom < nodeBottom) bottom = nodeBottom;
                    }
                    var boundingBox = {};
                    boundingBox.topLeftX = left;
                    boundingBox.topLeftY = top;
                    boundingBox.width = right - left;
                    boundingBox.height = bottom - top;
                    return boundingBox;
                };
                // This function finds and returns parent nodes whose all children are hidden
                auxiliary.calcParentsWithoutChildren = function(cy, eles) {
                    var parentsWithoutChildren = cy.collection();
                    eles.nodes(':parent').forEach(function(parent) {
                        var check = false;
                        parent.children().forEach(function(child) {
                            if (child.css('display') != 'none') check = true;
                        });
                        if (!check) parentsWithoutChildren.merge(parent);
                    });
                    return parentsWithoutChildren;
                };
                module1.exports = auxiliary;
            /***/ },
            /***/ 816: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
  The implementation of the postprocessing part that applies CoSE layout over the spectral layout
*/ var aux = __webpack_require__(548);
                var CoSELayout = __webpack_require__(140).CoSELayout;
                var CoSENode = __webpack_require__(140).CoSENode;
                var PointD = __webpack_require__(140).layoutBase.PointD;
                var DimensionD = __webpack_require__(140).layoutBase.DimensionD;
                var LayoutConstants = __webpack_require__(140).layoutBase.LayoutConstants;
                var FDLayoutConstants = __webpack_require__(140).layoutBase.FDLayoutConstants;
                var CoSEConstants = __webpack_require__(140).CoSEConstants;
                // main function that cose layout is processed
                var coseLayout = function coseLayout(options, spectralResult) {
                    var cy = options.cy;
                    var eles = options.eles;
                    var nodes = eles.nodes();
                    var edges = eles.edges();
                    var nodeIndexes = void 0;
                    var xCoords = void 0;
                    var yCoords = void 0;
                    var idToLNode = {};
                    if (options.randomize) {
                        nodeIndexes = spectralResult["nodeIndexes"];
                        xCoords = spectralResult["xCoords"];
                        yCoords = spectralResult["yCoords"];
                    }
                    var isFn = function isFn(fn) {
                        return typeof fn === 'function';
                    };
                    var optFn = function optFn(opt, ele) {
                        if (isFn(opt)) return opt(ele);
                        else return opt;
                    };
                    /**** Postprocessing functions ****/ var parentsWithoutChildren = aux.calcParentsWithoutChildren(cy, eles);
                    // transfer cytoscape nodes to cose nodes
                    var processChildrenList = function processChildrenList(parent, children, layout, options) {
                        var size = children.length;
                        for(var i = 0; i < size; i++){
                            var theChild = children[i];
                            var children_of_children = null;
                            if (theChild.intersection(parentsWithoutChildren).length == 0) children_of_children = theChild.children();
                            var theNode = void 0;
                            var dimensions = theChild.layoutDimensions({
                                nodeDimensionsIncludeLabels: options.nodeDimensionsIncludeLabels
                            });
                            if (theChild.outerWidth() != null && theChild.outerHeight() != null) {
                                if (options.randomize) {
                                    if (!theChild.isParent()) theNode = parent.add(new CoSENode(layout.graphManager, new PointD(xCoords[nodeIndexes.get(theChild.id())] - dimensions.w / 2, yCoords[nodeIndexes.get(theChild.id())] - dimensions.h / 2), new DimensionD(parseFloat(dimensions.w), parseFloat(dimensions.h))));
                                    else {
                                        var parentInfo = aux.calcBoundingBox(theChild, xCoords, yCoords, nodeIndexes);
                                        if (theChild.intersection(parentsWithoutChildren).length == 0) theNode = parent.add(new CoSENode(layout.graphManager, new PointD(parentInfo.topLeftX, parentInfo.topLeftY), new DimensionD(parentInfo.width, parentInfo.height)));
                                        else // for the parentsWithoutChildren
                                        theNode = parent.add(new CoSENode(layout.graphManager, new PointD(parentInfo.topLeftX, parentInfo.topLeftY), new DimensionD(parseFloat(dimensions.w), parseFloat(dimensions.h))));
                                    }
                                } else theNode = parent.add(new CoSENode(layout.graphManager, new PointD(theChild.position('x') - dimensions.w / 2, theChild.position('y') - dimensions.h / 2), new DimensionD(parseFloat(dimensions.w), parseFloat(dimensions.h))));
                            } else theNode = parent.add(new CoSENode(this.graphManager));
                            // Attach id to the layout node and repulsion value
                            theNode.id = theChild.data("id");
                            theNode.nodeRepulsion = optFn(options.nodeRepulsion, theChild);
                            // Attach the paddings of cy node to layout node
                            theNode.paddingLeft = parseInt(theChild.css('padding'));
                            theNode.paddingTop = parseInt(theChild.css('padding'));
                            theNode.paddingRight = parseInt(theChild.css('padding'));
                            theNode.paddingBottom = parseInt(theChild.css('padding'));
                            //Attach the label properties to both compound and simple nodes if labels will be included in node dimensions
                            //These properties will be used while updating bounds of compounds during iterations or tiling
                            //and will be used for simple nodes while transferring final positions to cytoscape
                            if (options.nodeDimensionsIncludeLabels) {
                                theNode.labelWidth = theChild.boundingBox({
                                    includeLabels: true,
                                    includeNodes: false,
                                    includeOverlays: false
                                }).w;
                                theNode.labelHeight = theChild.boundingBox({
                                    includeLabels: true,
                                    includeNodes: false,
                                    includeOverlays: false
                                }).h;
                                theNode.labelPosVertical = theChild.css("text-valign");
                                theNode.labelPosHorizontal = theChild.css("text-halign");
                            }
                            // Map the layout node
                            idToLNode[theChild.data("id")] = theNode;
                            if (isNaN(theNode.rect.x)) theNode.rect.x = 0;
                            if (isNaN(theNode.rect.y)) theNode.rect.y = 0;
                            if (children_of_children != null && children_of_children.length > 0) {
                                var theNewGraph = void 0;
                                theNewGraph = layout.getGraphManager().add(layout.newGraph(), theNode);
                                processChildrenList(theNewGraph, children_of_children, layout, options);
                            }
                        }
                    };
                    // transfer cytoscape edges to cose edges
                    var processEdges = function processEdges(layout, gm, edges) {
                        var idealLengthTotal = 0;
                        var edgeCount = 0;
                        for(var i = 0; i < edges.length; i++){
                            var edge = edges[i];
                            var sourceNode = idToLNode[edge.data("source")];
                            var targetNode = idToLNode[edge.data("target")];
                            if (sourceNode && targetNode && sourceNode !== targetNode && sourceNode.getEdgesBetween(targetNode).length == 0) {
                                var e1 = gm.add(layout.newEdge(), sourceNode, targetNode);
                                e1.id = edge.id();
                                e1.idealLength = optFn(options.idealEdgeLength, edge);
                                e1.edgeElasticity = optFn(options.edgeElasticity, edge);
                                idealLengthTotal += e1.idealLength;
                                edgeCount++;
                            }
                        }
                        // we need to update the ideal edge length constant with the avg. ideal length value after processing edges
                        // in case there is no edge, use other options
                        if (options.idealEdgeLength != null) {
                            if (edgeCount > 0) CoSEConstants.DEFAULT_EDGE_LENGTH = FDLayoutConstants.DEFAULT_EDGE_LENGTH = idealLengthTotal / edgeCount;
                            else if (!isFn(options.idealEdgeLength)) CoSEConstants.DEFAULT_EDGE_LENGTH = FDLayoutConstants.DEFAULT_EDGE_LENGTH = options.idealEdgeLength;
                            else CoSEConstants.DEFAULT_EDGE_LENGTH = FDLayoutConstants.DEFAULT_EDGE_LENGTH = 50;
                            // we need to update these constant values based on the ideal edge length constant
                            CoSEConstants.MIN_REPULSION_DIST = FDLayoutConstants.MIN_REPULSION_DIST = FDLayoutConstants.DEFAULT_EDGE_LENGTH / 10.0;
                            CoSEConstants.DEFAULT_RADIAL_SEPARATION = FDLayoutConstants.DEFAULT_EDGE_LENGTH;
                        }
                    };
                    // transfer cytoscape constraints to cose layout
                    var processConstraints = function processConstraints(layout, options) {
                        // get nodes to be fixed
                        if (options.fixedNodeConstraint) layout.constraints["fixedNodeConstraint"] = options.fixedNodeConstraint;
                        // get nodes to be aligned
                        if (options.alignmentConstraint) layout.constraints["alignmentConstraint"] = options.alignmentConstraint;
                        // get nodes to be relatively placed
                        if (options.relativePlacementConstraint) layout.constraints["relativePlacementConstraint"] = options.relativePlacementConstraint;
                    };
                    /**** Apply postprocessing ****/ if (options.nestingFactor != null) CoSEConstants.PER_LEVEL_IDEAL_EDGE_LENGTH_FACTOR = FDLayoutConstants.PER_LEVEL_IDEAL_EDGE_LENGTH_FACTOR = options.nestingFactor;
                    if (options.gravity != null) CoSEConstants.DEFAULT_GRAVITY_STRENGTH = FDLayoutConstants.DEFAULT_GRAVITY_STRENGTH = options.gravity;
                    if (options.numIter != null) CoSEConstants.MAX_ITERATIONS = FDLayoutConstants.MAX_ITERATIONS = options.numIter;
                    if (options.gravityRange != null) CoSEConstants.DEFAULT_GRAVITY_RANGE_FACTOR = FDLayoutConstants.DEFAULT_GRAVITY_RANGE_FACTOR = options.gravityRange;
                    if (options.gravityCompound != null) CoSEConstants.DEFAULT_COMPOUND_GRAVITY_STRENGTH = FDLayoutConstants.DEFAULT_COMPOUND_GRAVITY_STRENGTH = options.gravityCompound;
                    if (options.gravityRangeCompound != null) CoSEConstants.DEFAULT_COMPOUND_GRAVITY_RANGE_FACTOR = FDLayoutConstants.DEFAULT_COMPOUND_GRAVITY_RANGE_FACTOR = options.gravityRangeCompound;
                    if (options.initialEnergyOnIncremental != null) CoSEConstants.DEFAULT_COOLING_FACTOR_INCREMENTAL = FDLayoutConstants.DEFAULT_COOLING_FACTOR_INCREMENTAL = options.initialEnergyOnIncremental;
                    if (options.tilingCompareBy != null) CoSEConstants.TILING_COMPARE_BY = options.tilingCompareBy;
                    if (options.quality == 'proof') LayoutConstants.QUALITY = 2;
                    else LayoutConstants.QUALITY = 0;
                    CoSEConstants.NODE_DIMENSIONS_INCLUDE_LABELS = FDLayoutConstants.NODE_DIMENSIONS_INCLUDE_LABELS = LayoutConstants.NODE_DIMENSIONS_INCLUDE_LABELS = options.nodeDimensionsIncludeLabels;
                    CoSEConstants.DEFAULT_INCREMENTAL = FDLayoutConstants.DEFAULT_INCREMENTAL = LayoutConstants.DEFAULT_INCREMENTAL = !options.randomize;
                    CoSEConstants.ANIMATE = FDLayoutConstants.ANIMATE = LayoutConstants.ANIMATE = options.animate;
                    CoSEConstants.TILE = options.tile;
                    CoSEConstants.TILING_PADDING_VERTICAL = typeof options.tilingPaddingVertical === 'function' ? options.tilingPaddingVertical.call() : options.tilingPaddingVertical;
                    CoSEConstants.TILING_PADDING_HORIZONTAL = typeof options.tilingPaddingHorizontal === 'function' ? options.tilingPaddingHorizontal.call() : options.tilingPaddingHorizontal;
                    CoSEConstants.DEFAULT_INCREMENTAL = FDLayoutConstants.DEFAULT_INCREMENTAL = LayoutConstants.DEFAULT_INCREMENTAL = true;
                    CoSEConstants.PURE_INCREMENTAL = !options.randomize;
                    LayoutConstants.DEFAULT_UNIFORM_LEAF_NODE_SIZES = options.uniformNodeDimensions;
                    // This part is for debug/demo purpose
                    if (options.step == "transformed") {
                        CoSEConstants.TRANSFORM_ON_CONSTRAINT_HANDLING = true;
                        CoSEConstants.ENFORCE_CONSTRAINTS = false;
                        CoSEConstants.APPLY_LAYOUT = false;
                    }
                    if (options.step == "enforced") {
                        CoSEConstants.TRANSFORM_ON_CONSTRAINT_HANDLING = false;
                        CoSEConstants.ENFORCE_CONSTRAINTS = true;
                        CoSEConstants.APPLY_LAYOUT = false;
                    }
                    if (options.step == "cose") {
                        CoSEConstants.TRANSFORM_ON_CONSTRAINT_HANDLING = false;
                        CoSEConstants.ENFORCE_CONSTRAINTS = false;
                        CoSEConstants.APPLY_LAYOUT = true;
                    }
                    if (options.step == "all") {
                        if (options.randomize) CoSEConstants.TRANSFORM_ON_CONSTRAINT_HANDLING = true;
                        else CoSEConstants.TRANSFORM_ON_CONSTRAINT_HANDLING = false;
                        CoSEConstants.ENFORCE_CONSTRAINTS = true;
                        CoSEConstants.APPLY_LAYOUT = true;
                    }
                    if (options.fixedNodeConstraint || options.alignmentConstraint || options.relativePlacementConstraint) CoSEConstants.TREE_REDUCTION_ON_INCREMENTAL = false;
                    else CoSEConstants.TREE_REDUCTION_ON_INCREMENTAL = true;
                    var coseLayout = new CoSELayout();
                    var gm = coseLayout.newGraphManager();
                    processChildrenList(gm.addRoot(), aux.getTopMostNodes(nodes), coseLayout, options);
                    processEdges(coseLayout, gm, edges);
                    processConstraints(coseLayout, options);
                    coseLayout.runLayout();
                    return idToLNode;
                };
                module1.exports = {
                    coseLayout: coseLayout
                };
            /***/ },
            /***/ 212: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                /**
  The implementation of the fcose layout algorithm
*/ var assign = __webpack_require__(658);
                var aux = __webpack_require__(548);
                var _require = __webpack_require__(657), spectralLayout = _require.spectralLayout;
                var _require2 = __webpack_require__(816), coseLayout = _require2.coseLayout;
                var defaults = Object.freeze({
                    // 'draft', 'default' or 'proof' 
                    // - 'draft' only applies spectral layout 
                    // - 'default' improves the quality with subsequent CoSE layout (fast cooling rate)
                    // - 'proof' improves the quality with subsequent CoSE layout (slow cooling rate) 
                    quality: "default",
                    // Use random node positions at beginning of layout
                    // if this is set to false, then quality option must be "proof"
                    randomize: true,
                    // Whether or not to animate the layout
                    animate: true,
                    // Duration of animation in ms, if enabled
                    animationDuration: 1000,
                    // Easing of animation, if enabled
                    animationEasing: undefined,
                    // Fit the viewport to the repositioned nodes
                    fit: true,
                    // Padding around layout
                    padding: 30,
                    // Whether to include labels in node dimensions. Valid in "proof" quality
                    nodeDimensionsIncludeLabels: false,
                    // Whether or not simple nodes (non-compound nodes) are of uniform dimensions
                    uniformNodeDimensions: false,
                    // Whether to pack disconnected components - valid only if randomize: true
                    packComponents: true,
                    // Layout step - all, transformed, enforced, cose - for debug purpose only
                    step: "all",
                    /* spectral layout options */ // False for random, true for greedy
                    samplingType: true,
                    // Sample size to construct distance matrix
                    sampleSize: 25,
                    // Separation amount between nodes
                    nodeSeparation: 75,
                    // Power iteration tolerance
                    piTol: 0.0000001,
                    /* CoSE layout options */ // Node repulsion (non overlapping) multiplier
                    nodeRepulsion: function nodeRepulsion(node) {
                        return 4500;
                    },
                    // Ideal edge (non nested) length
                    idealEdgeLength: function idealEdgeLength(edge) {
                        return 50;
                    },
                    // Divisor to compute edge forces
                    edgeElasticity: function edgeElasticity(edge) {
                        return 0.45;
                    },
                    // Nesting factor (multiplier) to compute ideal edge length for nested edges
                    nestingFactor: 0.1,
                    // Gravity force (constant)
                    gravity: 0.25,
                    // Maximum number of iterations to perform
                    numIter: 2500,
                    // For enabling tiling
                    tile: true,
                    // The function that specifies the criteria for comparing nodes while sorting them during tiling operation.
                    // Takes the node id as a parameter and the default tiling operation is perfomed when this option is not set.
                    tilingCompareBy: undefined,
                    // Represents the amount of the vertical space to put between the zero degree members during the tiling operation(can also be a function)
                    tilingPaddingVertical: 10,
                    // Represents the amount of the horizontal space to put between the zero degree members during the tiling operation(can also be a function)
                    tilingPaddingHorizontal: 10,
                    // Gravity range (constant) for compounds
                    gravityRangeCompound: 1.5,
                    // Gravity force (constant) for compounds
                    gravityCompound: 1.0,
                    // Gravity range (constant)
                    gravityRange: 3.8,
                    // Initial cooling factor for incremental layout  
                    initialEnergyOnIncremental: 0.3,
                    /* constraint options */ // Fix required nodes to predefined positions
                    // [{nodeId: 'n1', position: {x: 100, y: 200}, {...}]
                    fixedNodeConstraint: undefined,
                    // Align required nodes in vertical/horizontal direction
                    // {vertical: [['n1', 'n2')], ['n3', 'n4']], horizontal: ['n2', 'n4']}
                    alignmentConstraint: undefined,
                    // Place two nodes relatively in vertical/horizontal direction 
                    // [{top: 'n1', bottom: 'n2', gap: 100}, {left: 'n3', right: 'n4', gap: 75}]
                    relativePlacementConstraint: undefined,
                    /* layout event callbacks */ ready: function ready() {},
                    stop: function stop() {} // on layoutstop
                });
                var Layout = function() {
                    function Layout(options) {
                        _classCallCheck(this, Layout);
                        this.options = assign({}, defaults, options);
                    }
                    _createClass(Layout, [
                        {
                            key: 'run',
                            value: function run() {
                                var layout = this;
                                var options = this.options;
                                var cy = options.cy;
                                var eles = options.eles;
                                var spectralResult = [];
                                var xCoords = void 0;
                                var yCoords = void 0;
                                var coseResult = [];
                                var components = void 0;
                                var componentCenters = [];
                                // basic validity check for constraint inputs 
                                if (options.fixedNodeConstraint && (!Array.isArray(options.fixedNodeConstraint) || options.fixedNodeConstraint.length == 0)) options.fixedNodeConstraint = undefined;
                                if (options.alignmentConstraint) {
                                    if (options.alignmentConstraint.vertical && (!Array.isArray(options.alignmentConstraint.vertical) || options.alignmentConstraint.vertical.length == 0)) options.alignmentConstraint.vertical = undefined;
                                    if (options.alignmentConstraint.horizontal && (!Array.isArray(options.alignmentConstraint.horizontal) || options.alignmentConstraint.horizontal.length == 0)) options.alignmentConstraint.horizontal = undefined;
                                }
                                if (options.relativePlacementConstraint && (!Array.isArray(options.relativePlacementConstraint) || options.relativePlacementConstraint.length == 0)) options.relativePlacementConstraint = undefined;
                                // if any constraint exists, set some options
                                var constraintExist = options.fixedNodeConstraint || options.alignmentConstraint || options.relativePlacementConstraint;
                                if (constraintExist) {
                                    // constraints work with these options
                                    options.tile = false;
                                    options.packComponents = false;
                                }
                                // decide component packing is enabled or not
                                var layUtil = void 0;
                                var packingEnabled = false;
                                if (cy.layoutUtilities && options.packComponents) {
                                    layUtil = cy.layoutUtilities("get");
                                    if (!layUtil) layUtil = cy.layoutUtilities();
                                    packingEnabled = true;
                                }
                                if (eles.nodes().length > 0) {
                                    // if packing is not enabled, perform layout on the whole graph
                                    if (!packingEnabled) {
                                        // store component center
                                        var boundingBox = options.eles.boundingBox();
                                        componentCenters.push({
                                            x: boundingBox.x1 + boundingBox.w / 2,
                                            y: boundingBox.y1 + boundingBox.h / 2
                                        });
                                        // apply spectral layout
                                        if (options.randomize) {
                                            var result = spectralLayout(options);
                                            spectralResult.push(result);
                                        }
                                        // apply cose layout as postprocessing
                                        if (options.quality == "default" || options.quality == "proof") {
                                            coseResult.push(coseLayout(options, spectralResult[0]));
                                            aux.relocateComponent(componentCenters[0], coseResult[0], options); // relocate center to original position
                                        } else aux.relocateComponent(componentCenters[0], spectralResult[0], options); // relocate center to original position
                                    } else {
                                        // packing is enabled
                                        var topMostNodes = aux.getTopMostNodes(options.eles.nodes());
                                        components = aux.connectComponents(cy, options.eles, topMostNodes);
                                        // store component centers
                                        components.forEach(function(component) {
                                            var boundingBox = component.boundingBox();
                                            componentCenters.push({
                                                x: boundingBox.x1 + boundingBox.w / 2,
                                                y: boundingBox.y1 + boundingBox.h / 2
                                            });
                                        });
                                        //send each component to spectral layout if randomized
                                        if (options.randomize) components.forEach(function(component) {
                                            options.eles = component;
                                            spectralResult.push(spectralLayout(options));
                                        });
                                        if (options.quality == "default" || options.quality == "proof") {
                                            var toBeTiledNodes = cy.collection();
                                            if (options.tile) {
                                                // behave nodes to be tiled as one component
                                                var nodeIndexes = new Map();
                                                var _xCoords = [];
                                                var _yCoords = [];
                                                var count = 0;
                                                var tempSpectralResult = {
                                                    nodeIndexes: nodeIndexes,
                                                    xCoords: _xCoords,
                                                    yCoords: _yCoords
                                                };
                                                var indexesToBeDeleted = [];
                                                components.forEach(function(component, index) {
                                                    if (component.edges().length == 0) {
                                                        component.nodes().forEach(function(node, i) {
                                                            toBeTiledNodes.merge(component.nodes()[i]);
                                                            if (!node.isParent()) {
                                                                tempSpectralResult.nodeIndexes.set(component.nodes()[i].id(), count++);
                                                                tempSpectralResult.xCoords.push(component.nodes()[0].position().x);
                                                                tempSpectralResult.yCoords.push(component.nodes()[0].position().y);
                                                            }
                                                        });
                                                        indexesToBeDeleted.push(index);
                                                    }
                                                });
                                                if (toBeTiledNodes.length > 1) {
                                                    var _boundingBox = toBeTiledNodes.boundingBox();
                                                    componentCenters.push({
                                                        x: _boundingBox.x1 + _boundingBox.w / 2,
                                                        y: _boundingBox.y1 + _boundingBox.h / 2
                                                    });
                                                    components.push(toBeTiledNodes);
                                                    spectralResult.push(tempSpectralResult);
                                                    for(var i = indexesToBeDeleted.length - 1; i >= 0; i--){
                                                        components.splice(indexesToBeDeleted[i], 1);
                                                        spectralResult.splice(indexesToBeDeleted[i], 1);
                                                        componentCenters.splice(indexesToBeDeleted[i], 1);
                                                    }
                                                }
                                            }
                                            components.forEach(function(component, index) {
                                                // send each component to cose layout
                                                options.eles = component;
                                                coseResult.push(coseLayout(options, spectralResult[index]));
                                                aux.relocateComponent(componentCenters[index], coseResult[index], options); // relocate center to original position
                                            });
                                        } else components.forEach(function(component, index) {
                                            aux.relocateComponent(componentCenters[index], spectralResult[index], options); // relocate center to original position
                                        });
                                        // packing
                                        var componentsEvaluated = new Set();
                                        if (components.length > 1) {
                                            var subgraphs = [];
                                            var hiddenEles = eles.filter(function(ele) {
                                                return ele.css('display') == 'none';
                                            });
                                            components.forEach(function(component, index) {
                                                var nodeIndexes = void 0;
                                                if (options.quality == "draft") nodeIndexes = spectralResult[index].nodeIndexes;
                                                if (component.nodes().not(hiddenEles).length > 0) {
                                                    var subgraph = {};
                                                    subgraph.edges = [];
                                                    subgraph.nodes = [];
                                                    var nodeIndex = void 0;
                                                    component.nodes().not(hiddenEles).forEach(function(node) {
                                                        if (options.quality == "draft") {
                                                            if (!node.isParent()) {
                                                                nodeIndex = nodeIndexes.get(node.id());
                                                                subgraph.nodes.push({
                                                                    x: spectralResult[index].xCoords[nodeIndex] - node.boundingbox().w / 2,
                                                                    y: spectralResult[index].yCoords[nodeIndex] - node.boundingbox().h / 2,
                                                                    width: node.boundingbox().w,
                                                                    height: node.boundingbox().h
                                                                });
                                                            } else {
                                                                var parentInfo = aux.calcBoundingBox(node, spectralResult[index].xCoords, spectralResult[index].yCoords, nodeIndexes);
                                                                subgraph.nodes.push({
                                                                    x: parentInfo.topLeftX,
                                                                    y: parentInfo.topLeftY,
                                                                    width: parentInfo.width,
                                                                    height: parentInfo.height
                                                                });
                                                            }
                                                        } else if (coseResult[index][node.id()]) subgraph.nodes.push({
                                                            x: coseResult[index][node.id()].getLeft(),
                                                            y: coseResult[index][node.id()].getTop(),
                                                            width: coseResult[index][node.id()].getWidth(),
                                                            height: coseResult[index][node.id()].getHeight()
                                                        });
                                                    });
                                                    component.edges().forEach(function(edge) {
                                                        var source = edge.source();
                                                        var target = edge.target();
                                                        if (source.css("display") != "none" && target.css("display") != "none") {
                                                            if (options.quality == "draft") {
                                                                var sourceNodeIndex = nodeIndexes.get(source.id());
                                                                var targetNodeIndex = nodeIndexes.get(target.id());
                                                                var sourceCenter = [];
                                                                var targetCenter = [];
                                                                if (source.isParent()) {
                                                                    var parentInfo = aux.calcBoundingBox(source, spectralResult[index].xCoords, spectralResult[index].yCoords, nodeIndexes);
                                                                    sourceCenter.push(parentInfo.topLeftX + parentInfo.width / 2);
                                                                    sourceCenter.push(parentInfo.topLeftY + parentInfo.height / 2);
                                                                } else {
                                                                    sourceCenter.push(spectralResult[index].xCoords[sourceNodeIndex]);
                                                                    sourceCenter.push(spectralResult[index].yCoords[sourceNodeIndex]);
                                                                }
                                                                if (target.isParent()) {
                                                                    var _parentInfo = aux.calcBoundingBox(target, spectralResult[index].xCoords, spectralResult[index].yCoords, nodeIndexes);
                                                                    targetCenter.push(_parentInfo.topLeftX + _parentInfo.width / 2);
                                                                    targetCenter.push(_parentInfo.topLeftY + _parentInfo.height / 2);
                                                                } else {
                                                                    targetCenter.push(spectralResult[index].xCoords[targetNodeIndex]);
                                                                    targetCenter.push(spectralResult[index].yCoords[targetNodeIndex]);
                                                                }
                                                                subgraph.edges.push({
                                                                    startX: sourceCenter[0],
                                                                    startY: sourceCenter[1],
                                                                    endX: targetCenter[0],
                                                                    endY: targetCenter[1]
                                                                });
                                                            } else if (coseResult[index][source.id()] && coseResult[index][target.id()]) subgraph.edges.push({
                                                                startX: coseResult[index][source.id()].getCenterX(),
                                                                startY: coseResult[index][source.id()].getCenterY(),
                                                                endX: coseResult[index][target.id()].getCenterX(),
                                                                endY: coseResult[index][target.id()].getCenterY()
                                                            });
                                                        }
                                                    });
                                                    if (subgraph.nodes.length > 0) {
                                                        subgraphs.push(subgraph);
                                                        componentsEvaluated.add(index);
                                                    }
                                                }
                                            });
                                            var shiftResult = layUtil.packComponents(subgraphs, options.randomize).shifts;
                                            if (options.quality == "draft") spectralResult.forEach(function(result, index) {
                                                var newXCoords = result.xCoords.map(function(x) {
                                                    return x + shiftResult[index].dx;
                                                });
                                                var newYCoords = result.yCoords.map(function(y) {
                                                    return y + shiftResult[index].dy;
                                                });
                                                result.xCoords = newXCoords;
                                                result.yCoords = newYCoords;
                                            });
                                            else {
                                                var _count = 0;
                                                componentsEvaluated.forEach(function(index) {
                                                    Object.keys(coseResult[index]).forEach(function(item) {
                                                        var nodeRectangle = coseResult[index][item];
                                                        nodeRectangle.setCenter(nodeRectangle.getCenterX() + shiftResult[_count].dx, nodeRectangle.getCenterY() + shiftResult[_count].dy);
                                                    });
                                                    _count++;
                                                });
                                            }
                                        }
                                    }
                                }
                                // get each element's calculated position
                                var getPositions = function getPositions(ele, i) {
                                    if (options.quality == "default" || options.quality == "proof") {
                                        if (typeof ele === "number") ele = i;
                                        var pos = void 0;
                                        var node = void 0;
                                        var theId = ele.data('id');
                                        coseResult.forEach(function(result) {
                                            if (theId in result) {
                                                pos = {
                                                    x: result[theId].getRect().getCenterX(),
                                                    y: result[theId].getRect().getCenterY()
                                                };
                                                node = result[theId];
                                            }
                                        });
                                        if (options.nodeDimensionsIncludeLabels) {
                                            if (node.labelWidth) {
                                                if (node.labelPosHorizontal == "left") pos.x += node.labelWidth / 2;
                                                else if (node.labelPosHorizontal == "right") pos.x -= node.labelWidth / 2;
                                            }
                                            if (node.labelHeight) {
                                                if (node.labelPosVertical == "top") pos.y += node.labelHeight / 2;
                                                else if (node.labelPosVertical == "bottom") pos.y -= node.labelHeight / 2;
                                            }
                                        }
                                        if (pos == undefined) pos = {
                                            x: ele.position("x"),
                                            y: ele.position("y")
                                        };
                                        return {
                                            x: pos.x,
                                            y: pos.y
                                        };
                                    } else {
                                        var _pos = void 0;
                                        spectralResult.forEach(function(result) {
                                            var index = result.nodeIndexes.get(ele.id());
                                            if (index != undefined) _pos = {
                                                x: result.xCoords[index],
                                                y: result.yCoords[index]
                                            };
                                        });
                                        if (_pos == undefined) _pos = {
                                            x: ele.position("x"),
                                            y: ele.position("y")
                                        };
                                        return {
                                            x: _pos.x,
                                            y: _pos.y
                                        };
                                    }
                                };
                                // quality = "draft" and randomize = false are contradictive so in that case positions don't change
                                if (options.quality == "default" || options.quality == "proof" || options.randomize) {
                                    // transfer calculated positions to nodes (positions of only simple nodes are evaluated, compounds are positioned automatically)
                                    var parentsWithoutChildren = aux.calcParentsWithoutChildren(cy, eles);
                                    var _hiddenEles = eles.filter(function(ele) {
                                        return ele.css('display') == 'none';
                                    });
                                    options.eles = eles.not(_hiddenEles);
                                    eles.nodes().not(":parent").not(_hiddenEles).layoutPositions(layout, options, getPositions);
                                    if (parentsWithoutChildren.length > 0) parentsWithoutChildren.forEach(function(ele) {
                                        ele.position(getPositions(ele));
                                    });
                                } else console.log("If randomize option is set to false, then quality option must be 'default' or 'proof'.");
                            }
                        }
                    ]);
                    return Layout;
                }();
                module1.exports = Layout;
            /***/ },
            /***/ 657: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
  The implementation of the spectral layout that is the first part of the fcose layout algorithm
*/ var aux = __webpack_require__(548);
                var Matrix = __webpack_require__(140).layoutBase.Matrix;
                var SVD = __webpack_require__(140).layoutBase.SVD;
                // main function that spectral layout is processed
                var spectralLayout = function spectralLayout(options) {
                    var cy = options.cy;
                    var eles = options.eles;
                    var nodes = eles.nodes();
                    var parentNodes = eles.nodes(":parent");
                    var dummyNodes = new Map(); // map to keep dummy nodes and their neighbors
                    var nodeIndexes = new Map(); // map to keep indexes to nodes
                    var parentChildMap = new Map(); // mapping btw. compound and its representative node 
                    var allNodesNeighborhood = []; // array to keep neighborhood of all nodes
                    var xCoords = [];
                    var yCoords = [];
                    var samplesColumn = []; // sampled vertices
                    var minDistancesColumn = [];
                    var C = []; // column sampling matrix
                    var PHI = []; // intersection of column and row sampling matrices 
                    var INV = []; // inverse of PHI 
                    var firstSample = void 0; // the first sampled node
                    var nodeSize = void 0;
                    var infinity = 100000000;
                    var small = 0.000000001;
                    var piTol = options.piTol;
                    var samplingType = options.samplingType; // false for random, true for greedy
                    var nodeSeparation = options.nodeSeparation;
                    var sampleSize = void 0;
                    /**** Spectral-preprocessing functions ****/ /**** Spectral layout functions ****/ // determine which columns to be sampled
                    var randomSampleCR = function randomSampleCR() {
                        var sample = 0;
                        var count = 0;
                        var flag = false;
                        while(count < sampleSize){
                            sample = Math.floor(Math.random() * nodeSize);
                            flag = false;
                            for(var i = 0; i < count; i++)if (samplesColumn[i] == sample) {
                                flag = true;
                                break;
                            }
                            if (!flag) {
                                samplesColumn[count] = sample;
                                count++;
                            } else continue;
                        }
                    };
                    // takes the index of the node(pivot) to initiate BFS as a parameter
                    var BFS = function BFS(pivot, index, samplingMethod) {
                        var path = []; // the front of the path
                        var front = 0; // the back of the path
                        var back = 0;
                        var current = 0;
                        var temp = void 0;
                        var distance = [];
                        var max_dist = 0; // the furthest node to be returned
                        var max_ind = 1;
                        for(var i = 0; i < nodeSize; i++)distance[i] = infinity;
                        path[back] = pivot;
                        distance[pivot] = 0;
                        while(back >= front){
                            current = path[front++];
                            var neighbors = allNodesNeighborhood[current];
                            for(var _i = 0; _i < neighbors.length; _i++){
                                temp = nodeIndexes.get(neighbors[_i]);
                                if (distance[temp] == infinity) {
                                    distance[temp] = distance[current] + 1;
                                    path[++back] = temp;
                                }
                            }
                            C[current][index] = distance[current] * nodeSeparation;
                        }
                        if (samplingMethod) {
                            for(var _i2 = 0; _i2 < nodeSize; _i2++)if (C[_i2][index] < minDistancesColumn[_i2]) minDistancesColumn[_i2] = C[_i2][index];
                            for(var _i3 = 0; _i3 < nodeSize; _i3++)if (minDistancesColumn[_i3] > max_dist) {
                                max_dist = minDistancesColumn[_i3];
                                max_ind = _i3;
                            }
                        }
                        return max_ind;
                    };
                    // apply BFS to all nodes or selected samples
                    var allBFS = function allBFS(samplingMethod) {
                        var sample = void 0;
                        if (!samplingMethod) {
                            randomSampleCR();
                            // call BFS
                            for(var i = 0; i < sampleSize; i++)BFS(samplesColumn[i], i, samplingMethod, false);
                        } else {
                            sample = Math.floor(Math.random() * nodeSize);
                            firstSample = sample;
                            for(var _i4 = 0; _i4 < nodeSize; _i4++)minDistancesColumn[_i4] = infinity;
                            for(var _i5 = 0; _i5 < sampleSize; _i5++){
                                samplesColumn[_i5] = sample;
                                sample = BFS(sample, _i5, samplingMethod);
                            }
                        }
                        // form the squared distances for C
                        for(var _i6 = 0; _i6 < nodeSize; _i6++)for(var j = 0; j < sampleSize; j++)C[_i6][j] *= C[_i6][j];
                        // form PHI
                        for(var _i7 = 0; _i7 < sampleSize; _i7++)PHI[_i7] = [];
                        for(var _i8 = 0; _i8 < sampleSize; _i8++)for(var _j = 0; _j < sampleSize; _j++)PHI[_i8][_j] = C[samplesColumn[_j]][_i8];
                    };
                    // perform the SVD algorithm and apply a regularization step
                    var sample = function sample() {
                        var SVDResult = SVD.svd(PHI);
                        var a_q = SVDResult.S;
                        var a_u = SVDResult.U;
                        var a_v = SVDResult.V;
                        var max_s = a_q[0] * a_q[0] * a_q[0];
                        var a_Sig = [];
                        //  regularization
                        for(var i = 0; i < sampleSize; i++){
                            a_Sig[i] = [];
                            for(var j = 0; j < sampleSize; j++){
                                a_Sig[i][j] = 0;
                                if (i == j) a_Sig[i][j] = a_q[i] / (a_q[i] * a_q[i] + max_s / (a_q[i] * a_q[i]));
                            }
                        }
                        INV = Matrix.multMat(Matrix.multMat(a_v, a_Sig), Matrix.transpose(a_u));
                    };
                    // calculate final coordinates 
                    var powerIteration = function powerIteration() {
                        // two largest eigenvalues
                        var theta1 = void 0;
                        var theta2 = void 0;
                        // initial guesses for eigenvectors
                        var Y1 = [];
                        var Y2 = [];
                        var V1 = [];
                        var V2 = [];
                        for(var i = 0; i < nodeSize; i++){
                            Y1[i] = Math.random();
                            Y2[i] = Math.random();
                        }
                        Y1 = Matrix.normalize(Y1);
                        Y2 = Matrix.normalize(Y2);
                        var count = 0;
                        // to keep track of the improvement ratio in power iteration
                        var current = small;
                        var previous = small;
                        var temp = void 0;
                        while(true){
                            count++;
                            for(var _i9 = 0; _i9 < nodeSize; _i9++)V1[_i9] = Y1[_i9];
                            Y1 = Matrix.multGamma(Matrix.multL(Matrix.multGamma(V1), C, INV));
                            theta1 = Matrix.dotProduct(V1, Y1);
                            Y1 = Matrix.normalize(Y1);
                            current = Matrix.dotProduct(V1, Y1);
                            temp = Math.abs(current / previous);
                            if (temp <= 1 + piTol && temp >= 1) break;
                            previous = current;
                        }
                        for(var _i10 = 0; _i10 < nodeSize; _i10++)V1[_i10] = Y1[_i10];
                        count = 0;
                        previous = small;
                        while(true){
                            count++;
                            for(var _i11 = 0; _i11 < nodeSize; _i11++)V2[_i11] = Y2[_i11];
                            V2 = Matrix.minusOp(V2, Matrix.multCons(V1, Matrix.dotProduct(V1, V2)));
                            Y2 = Matrix.multGamma(Matrix.multL(Matrix.multGamma(V2), C, INV));
                            theta2 = Matrix.dotProduct(V2, Y2);
                            Y2 = Matrix.normalize(Y2);
                            current = Matrix.dotProduct(V2, Y2);
                            temp = Math.abs(current / previous);
                            if (temp <= 1 + piTol && temp >= 1) break;
                            previous = current;
                        }
                        for(var _i12 = 0; _i12 < nodeSize; _i12++)V2[_i12] = Y2[_i12];
                        // theta1 now contains dominant eigenvalue
                        // theta2 now contains the second-largest eigenvalue
                        // V1 now contains theta1's eigenvector
                        // V2 now contains theta2's eigenvector
                        //populate the two vectors
                        xCoords = Matrix.multCons(V1, Math.sqrt(Math.abs(theta1)));
                        yCoords = Matrix.multCons(V2, Math.sqrt(Math.abs(theta2)));
                    };
                    /**** Preparation for spectral layout (Preprocessing) ****/ // connect disconnected components (first top level, then inside of each compound node)
                    aux.connectComponents(cy, eles, aux.getTopMostNodes(nodes), dummyNodes);
                    parentNodes.forEach(function(ele) {
                        aux.connectComponents(cy, eles, aux.getTopMostNodes(ele.descendants().intersection(eles)), dummyNodes);
                    });
                    // assign indexes to nodes (first real, then dummy nodes)
                    var index = 0;
                    for(var i = 0; i < nodes.length; i++)if (!nodes[i].isParent()) nodeIndexes.set(nodes[i].id(), index++);
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;
                    try {
                        for(var _iterator = dummyNodes.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            nodeIndexes.set(key, index++);
                        }
                    // instantiate the neighborhood matrix
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                        } finally{
                            if (_didIteratorError) throw _iteratorError;
                        }
                    }
                    for(var _i13 = 0; _i13 < nodeIndexes.size; _i13++)allNodesNeighborhood[_i13] = [];
                    // form a parent-child map to keep representative node of each compound node  
                    parentNodes.forEach(function(ele) {
                        var children = ele.children().intersection(eles);
                        //      let random = 0;
                        while(children.nodes(":childless").length == 0)//        random = Math.floor(Math.random() * children.nodes().length); // if all children are compound then proceed randomly
                        children = children.nodes()[0].children().intersection(eles);
                        //  select the representative node - we can apply different methods here
                        //      random = Math.floor(Math.random() * children.nodes(":childless").length);
                        var index = 0;
                        var min = children.nodes(":childless")[0].connectedEdges().length;
                        children.nodes(":childless").forEach(function(ele2, i) {
                            if (ele2.connectedEdges().length < min) {
                                min = ele2.connectedEdges().length;
                                index = i;
                            }
                        });
                        parentChildMap.set(ele.id(), children.nodes(":childless")[index].id());
                    });
                    // add neighborhood relations (first real, then dummy nodes)
                    nodes.forEach(function(ele) {
                        var eleIndex = void 0;
                        if (ele.isParent()) eleIndex = nodeIndexes.get(parentChildMap.get(ele.id()));
                        else eleIndex = nodeIndexes.get(ele.id());
                        ele.neighborhood().nodes().forEach(function(node) {
                            if (eles.intersection(ele.edgesWith(node)).length > 0) {
                                if (node.isParent()) allNodesNeighborhood[eleIndex].push(parentChildMap.get(node.id()));
                                else allNodesNeighborhood[eleIndex].push(node.id());
                            }
                        });
                    });
                    var _loop = function _loop(_key) {
                        var eleIndex = nodeIndexes.get(_key);
                        var disconnectedId = void 0;
                        dummyNodes.get(_key).forEach(function(id) {
                            if (cy.getElementById(id).isParent()) disconnectedId = parentChildMap.get(id);
                            else disconnectedId = id;
                            allNodesNeighborhood[eleIndex].push(disconnectedId);
                            allNodesNeighborhood[nodeIndexes.get(disconnectedId)].push(_key);
                        });
                    };
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = dummyNodes.keys()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var _key = _step2.value;
                            _loop(_key);
                        }
                    // nodeSize now only considers the size of transformed graph
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                        } finally{
                            if (_didIteratorError2) throw _iteratorError2;
                        }
                    }
                    nodeSize = nodeIndexes.size;
                    var spectralResult = void 0;
                    // If number of nodes in transformed graph is 1 or 2, either SVD or powerIteration causes problem
                    // So skip spectral and layout the graph with cose
                    if (nodeSize > 2) {
                        // if # of nodes in transformed graph is smaller than sample size,
                        // then use # of nodes as sample size
                        sampleSize = nodeSize < options.sampleSize ? nodeSize : options.sampleSize;
                        // instantiates the partial matrices that will be used in spectral layout
                        for(var _i14 = 0; _i14 < nodeSize; _i14++)C[_i14] = [];
                        for(var _i15 = 0; _i15 < sampleSize; _i15++)INV[_i15] = [];
                        /**** Apply spectral layout ****/ if (options.quality == "draft" || options.step == "all") {
                            allBFS(samplingType);
                            sample();
                            powerIteration();
                            spectralResult = {
                                nodeIndexes: nodeIndexes,
                                xCoords: xCoords,
                                yCoords: yCoords
                            };
                        } else {
                            nodeIndexes.forEach(function(value, key) {
                                xCoords.push(cy.getElementById(key).position("x"));
                                yCoords.push(cy.getElementById(key).position("y"));
                            });
                            spectralResult = {
                                nodeIndexes: nodeIndexes,
                                xCoords: xCoords,
                                yCoords: yCoords
                            };
                        }
                        return spectralResult;
                    } else {
                        var iterator = nodeIndexes.keys();
                        var firstNode = cy.getElementById(iterator.next().value);
                        var firstNodePos = firstNode.position();
                        var firstNodeWidth = firstNode.outerWidth();
                        xCoords.push(firstNodePos.x);
                        yCoords.push(firstNodePos.y);
                        if (nodeSize == 2) {
                            var secondNode = cy.getElementById(iterator.next().value);
                            var secondNodeWidth = secondNode.outerWidth();
                            xCoords.push(firstNodePos.x + firstNodeWidth / 2 + secondNodeWidth / 2 + options.idealEdgeLength);
                            yCoords.push(firstNodePos.y);
                        }
                        spectralResult = {
                            nodeIndexes: nodeIndexes,
                            xCoords: xCoords,
                            yCoords: yCoords
                        };
                        return spectralResult;
                    }
                };
                module1.exports = {
                    spectralLayout: spectralLayout
                };
            /***/ },
            /***/ 579: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                var impl = __webpack_require__(212);
                // registers the extension on a cytoscape lib ref
                var register = function register(cytoscape1) {
                    if (!cytoscape1) return;
                     // can't register if cytoscape unspecified
                    cytoscape1('layout', 'fcose', impl); // register with cytoscape.js
                };
                if (typeof cytoscape !== 'undefined') // expose to global cytoscape (i.e. window.cytoscape)
                register(cytoscape);
                module1.exports = register;
            /***/ },
            /***/ 140: /***/ (module1)=>{
                module1.exports = __WEBPACK_EXTERNAL_MODULE__140__;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__(579);
        /******/ /******/ return __webpack_exports__;
    /******/ })();
});


/**
 * cytoscape-bubblesets
 * https://github.com/upsetjs/cytoscape.js-bubblesets
 *
 * Copyright (c) 2021-2022 Samuel Gratzl <sam@sgratzl.com>
 */ /**
 * cytoscape-layers
 * https://github.com/sgratzl/cytoscape.js-layers
 *
 * Copyright (c) 2020 Samuel Gratzl <sam@sgratzl.com>
 */ const $cb9df2af88d35554$var$layerStyle = {
    position: 'absolute',
    left: '0',
    top: '0',
    userSelect: 'none',
    outlineStyle: 'none',
    width: '100%',
    height: '100%'
};
function $cb9df2af88d35554$var$stop(e) {
    e.stopPropagation();
}
function $cb9df2af88d35554$var$stopClicks(node) {
    node.addEventListener('click', $cb9df2af88d35554$var$stop);
    node.addEventListener('mousedown', $cb9df2af88d35554$var$stop);
    node.addEventListener('mouseup', $cb9df2af88d35554$var$stop);
    node.addEventListener('mousemove', $cb9df2af88d35554$var$stop);
}
class $cb9df2af88d35554$var$ABaseLayer {
    constructor(adapter){
        this.adapter = adapter;
        this.updateOnRenderEnabled = false;
        this.updateOnRenderOnceEnabled = false;
        this.updateOnRenderOnce = ()=>{
            if (this.updateOnRenderOnceEnabled) return;
            this.updateOnRenderOnceEnabled = true;
            this.cy.one('render', ()=>{
                this.updateOnRenderOnceEnabled = false;
                this.update();
            });
        };
    }
    inVisibleBounds(p) {
        return this.adapter.inVisibleBounds(p);
    }
    supportsRender() {
        return false;
    }
    renderInto(_ctx) {}
    get updateOnRender() {
        return this.updateOnRenderEnabled;
    }
    set updateOnRender(value) {
        if (this.updateOnRenderEnabled === value) return;
        this.updateOnRenderEnabled = value;
        if (value) this.cy.on('render', this.update);
        else this.cy.off('render', this.update);
    }
    get cy() {
        return this.adapter.cy;
    }
    moveUp() {
        this.adapter.move(this, -1);
    }
    moveDown() {
        this.adapter.move(this, 1);
    }
    moveBack() {
        this.adapter.move(this, Number.NEGATIVE_INFINITY);
    }
    moveFront() {
        this.adapter.move(this, Number.POSITIVE_INFINITY);
    }
    insertBefore(type, options) {
        return this.adapter.insert('before', this, type, options);
    }
    insertAfter(type, options) {
        return this.adapter.insert('after', this, type, options);
    }
}
class $cb9df2af88d35554$var$ADOMBaseLayer extends $cb9df2af88d35554$var$ABaseLayer {
    constructor(adapter, root){
        super(adapter);
        this.callbacks = [];
        this.update = ()=>{
            for (const o of this.callbacks)o(this.node);
        };
        this.root = root;
        Object.assign(this.root.style, $cb9df2af88d35554$var$layerStyle);
    }
    get visible() {
        return this.root.style.display !== 'none';
    }
    set visible(value) {
        if (this.visible === value) return;
        this.root.style.display = value ? '' : 'none';
    }
    show() {
        this.visible = true;
    }
    hide() {
        this.visible = false;
    }
    callback(callback) {
        this.callbacks.push(callback);
        this.update();
        return this;
    }
    resize() {}
    remove() {
        this.root.remove();
    }
}
const $cb9df2af88d35554$var$SVG_NS = 'http://www.w3.org/2000/svg';
class $cb9df2af88d35554$var$SVGLayer extends $cb9df2af88d35554$var$ADOMBaseLayer {
    constructor(adapter, doc, options = {}){
        super(adapter, doc.createElementNS($cb9df2af88d35554$var$SVG_NS, 'svg'));
        this.type = 'svg';
        this.updateOnTransform = false;
        this.root.__cy_layer = this;
        this.node = doc.createElementNS($cb9df2af88d35554$var$SVG_NS, 'g');
        this.node.__cy_layer = this;
        this.root.appendChild(this.node);
        if (options.stopClicks) $cb9df2af88d35554$var$stopClicks(this.node);
    }
    setViewport(tx, ty, zoom) {
        this.node.setAttribute('transform', `translate(${tx},${ty})scale(${zoom})`);
        if (this.updateOnTransform) this.update();
    }
    supportsRender() {
        return this.node.childElementCount === 0;
    }
}
class $cb9df2af88d35554$var$SVGStaticLayer extends $cb9df2af88d35554$var$ADOMBaseLayer {
    constructor(adapter, doc, options = {}){
        super(adapter, doc.createElementNS($cb9df2af88d35554$var$SVG_NS, 'svg'));
        this.type = 'svg-static';
        this.root.__cy_layer = this;
        this.node = doc.createElementNS($cb9df2af88d35554$var$SVG_NS, 'g');
        this.node.__cy_layer = this;
        this.root.appendChild(this.node);
        if (options.stopClicks) $cb9df2af88d35554$var$stopClicks(this.node);
    }
    setViewport() {}
}
class $cb9df2af88d35554$var$CanvasBaseLayer extends $cb9df2af88d35554$var$ABaseLayer {
    constructor(adapter, doc, options = {}){
        var _a, _b;
        super(adapter);
        this.callbacks = [];
        this.transform = {
            tx: 0,
            ty: 0,
            zoom: 1
        };
        this.update = ()=>this.draw();
        this.node = doc.createElement('canvas');
        Object.assign(this.node.style, $cb9df2af88d35554$var$layerStyle);
        if (options.stopClicks) $cb9df2af88d35554$var$stopClicks(this.node);
        this.pixelRatio = (_b = (_a = options.pixelRatio) !== null && _a !== void 0 ? _a : (window !== null && window !== void 0 ? window : {}).devicePixelRatio) !== null && _b !== void 0 ? _b : 1;
        this.ctx = this.node.getContext('2d', options);
        this.ctx.resetTransform();
    }
    get visible() {
        return this.node.style.display !== 'none';
    }
    set visible(value) {
        this.node.style.display = value ? '' : 'none';
    }
    show() {
        this.visible = true;
    }
    hide() {
        this.visible = false;
    }
    get root() {
        return this.node;
    }
    callback(callback) {
        this.callbacks.push(callback);
        this.update();
        return this;
    }
    clear() {
        const ctx = this.ctx;
        const bak = ctx.getTransform();
        ctx.resetTransform();
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        ctx.setTransform(bak);
    }
    draw() {
        this.clear();
        this.drawImpl(this.ctx);
    }
    drawImpl(ctx, scale = 1) {
        ctx.save();
        ctx.resetTransform();
        ctx.scale(this.pixelRatio, this.pixelRatio);
        ctx.translate(this.transform.tx * scale, this.transform.ty * scale);
        ctx.scale(this.transform.zoom * scale, this.transform.zoom * scale);
        for (const r of this.callbacks)r(ctx, {});
        ctx.restore();
    }
    supportsRender() {
        return true;
    }
    renderInto(ctx) {
        for (const r of this.callbacks)r(ctx, {
            forExport: true
        });
    }
    resize(width, height) {
        this.node.width = width * this.pixelRatio;
        this.node.height = height * this.pixelRatio;
        this.update();
    }
    setViewport(_tx, _ty, _zoom) {}
    remove() {
        this.node.remove();
    }
}
class $cb9df2af88d35554$var$CanvasLayer extends $cb9df2af88d35554$var$CanvasBaseLayer {
    constructor(adapter, doc, options = {}){
        super(adapter, doc, options);
        this.type = 'canvas';
        this.node.__cy_layer = this;
    }
    setViewport(tx, ty, zoom) {
        this.transform.tx = tx;
        this.transform.ty = ty;
        this.transform.zoom = zoom;
        this.update();
    }
}
class $cb9df2af88d35554$var$CanvasStaticLayer extends $cb9df2af88d35554$var$CanvasBaseLayer {
    constructor(adapter, doc, options = {}){
        super(adapter, doc, options);
        this.type = 'canvas-static';
        this.node.__cy_layer = this;
    }
}
class $cb9df2af88d35554$var$HTMLLayer extends $cb9df2af88d35554$var$ADOMBaseLayer {
    constructor(adapter, doc, options = {}){
        super(adapter, doc.createElement('div'));
        this.type = 'html';
        this.updateOnTransform = false;
        this.root.__cy_layer = this;
        this.node = doc.createElement('div');
        this.node.__cy_layer = this;
        this.node.style.position = 'absolute';
        this.node.style.left = '0px';
        this.node.style.top = '0px';
        this.root.appendChild(this.node);
        if (options.stopClicks) $cb9df2af88d35554$var$stopClicks(this.node);
    }
    setViewport(tx, ty, zoom) {
        this.node.style.transform = `translate(${tx}px,${ty}px)scale(${zoom})`;
        if (this.updateOnTransform) this.update();
    }
    supportsRender() {
        return this.node.childElementCount === 0;
    }
}
class $cb9df2af88d35554$var$HTMLStaticLayer extends $cb9df2af88d35554$var$ADOMBaseLayer {
    constructor(adapter, doc, options = {}){
        super(adapter, doc.createElement('div'));
        this.type = 'html-static';
        this.node.__cy_layer = this;
        if (options.stopClicks) $cb9df2af88d35554$var$stopClicks(this.node);
    }
    get node() {
        return this.root;
    }
    setViewport() {}
}
class $cb9df2af88d35554$var$CytoscapeBaseLayer extends $cb9df2af88d35554$var$ABaseLayer {
    constructor(adapter, node){
        super(adapter);
        this.update = ()=>{};
        this.node = node;
    }
    get root() {
        return this.node;
    }
    resize() {}
    setViewport() {}
    remove() {}
    supportsRender() {
        return true;
    }
}
class $cb9df2af88d35554$var$CytoscapeNodeLayer extends $cb9df2af88d35554$var$CytoscapeBaseLayer {
    constructor(adapter, node){
        super(adapter, node);
        this.type = 'node';
        this.node.__cy_layer = this;
    }
}
class $cb9df2af88d35554$var$CytoscapeDragLayer extends $cb9df2af88d35554$var$CytoscapeBaseLayer {
    constructor(adapter, node){
        super(adapter, node);
        this.type = 'drag';
        this.node.__cy_layer = this;
    }
}
class $cb9df2af88d35554$var$CytoscapeSelectBoxLayer extends $cb9df2af88d35554$var$CytoscapeBaseLayer {
    constructor(adapter, node){
        super(adapter, node);
        this.type = 'select-box';
        this.node.__cy_layer = this;
    }
}
function $cb9df2af88d35554$var$matchNodes(root, nodes, options) {
    const arr = Array.from(root.children);
    if (!options.uniqueElements) {
        nodes.forEach((node)=>{
            if (node.removed()) return;
            const bb = options.bb(node);
            if (!options.isVisible(bb)) return;
            if (arr.length > 0) options.update(arr.shift(), node, bb);
            else {
                const elem = options.enter(node, bb);
                root.appendChild(elem);
                options.update(elem, node, bb);
            }
        });
        for (const rest of arr)rest.remove();
        return;
    }
    const map = new Map(arr.map((d)=>[
            d.dataset.id,
            d
        ]));
    let i = -1;
    nodes.forEach((node)=>{
        if (node.removed()) return;
        const bb = options.bb(node);
        if (!options.isVisible(bb)) return;
        i++;
        const id = node.id();
        const expected = arr[i];
        const has = map.get(id);
        let n;
        if (has) {
            options.update(has, node, bb);
            map.delete(id);
            if (expected === has) return;
            n = has;
        } else {
            n = options.enter(node, bb);
            n.dataset.id = id;
            options.update(n, node, bb);
        }
        if (i === 0) root.insertAdjacentElement('afterbegin', n);
        else arr[i - 1].insertAdjacentElement('afterend', n);
        arr.splice(i, 0, n);
    });
    map.forEach((n)=>n.remove());
}
function $cb9df2af88d35554$var$registerCallback(layer, renderer) {
    layer.callback(renderer);
    return {
        remove: ()=>{
            layer.callbacks.splice(layer.callbacks.indexOf(renderer), 1);
        }
    };
}
function $cb9df2af88d35554$var$defaultElementLayerOptions(o) {
    return {
        selector: ':visible',
        updateOn: o != null && o.queryEachTime ? 'render' : 'position',
        queryEachTime: false,
        checkBounds: true
    };
}
function $cb9df2af88d35554$export$36ef5ea9943e865(layer, render, options) {
    const o = Object.assign({
        checkBoundsPointCount: 5,
        initCollection: ()=>undefined
    }, $cb9df2af88d35554$var$defaultElementLayerOptions(options), options);
    let edges = layer.cy.collection();
    let updateOnRenderOnceEnabled = false;
    const revaluateAndUpdateOnce = ()=>{
        if (updateOnRenderOnceEnabled) return;
        updateOnRenderOnceEnabled = true;
        layer.cy.one('render', ()=>{
            updateOnRenderOnceEnabled = false;
            edges = reevaluateCollection(edges);
            layer.update();
        });
    };
    const reevaluateCollection = (current)=>{
        if (o.updateOn !== 'none' && o.updateOn !== 'render') {
            current.off(o.updateOn, undefined, layer.updateOnRenderOnce);
            current.sources().off(o.updateOn, undefined, layer.updateOnRenderOnce);
            current.targets().off(o.updateOn, undefined, layer.updateOnRenderOnce);
        }
        const newEdges = layer.cy.edges(o.selector);
        o.initCollection(newEdges);
        if (o.updateOn !== 'none' && o.updateOn !== 'render') {
            newEdges.on(o.updateOn, layer.updateOnRenderOnce);
            newEdges.sources().on(o.updateOn, layer.updateOnRenderOnce);
            newEdges.targets().on(o.updateOn, layer.updateOnRenderOnce);
        }
        layer.updateOnRenderOnce();
        return newEdges;
    };
    if (o.updateOn === 'render') layer.updateOnRender = true;
    if (!o.queryEachTime) {
        edges = reevaluateCollection(edges);
        layer.cy.on('add remove', o.selector, revaluateAndUpdateOnce);
    }
    const renderer = (ctx, hint)=>{
        if (o.queryEachTime) edges = reevaluateCollection(edges);
        edges.forEach((edge)=>{
            if (edge.removed()) return;
            const impl = edge._private.rscratch;
            const s = impl && impl.startX != null && impl.startY != null ? {
                x: impl.startX,
                y: impl.startY
            } : edge.sourceEndpoint();
            const t = impl && impl.endX != null && impl.endY != null ? {
                x: impl.endX,
                y: impl.endY
            } : edge.targetEndpoint();
            if (!hint.forExport && o.checkBounds && o.checkBoundsPointCount > 0 && !$cb9df2af88d35554$var$anyVisible(layer, s, t, o.checkBoundsPointCount)) return;
            if (impl && impl.pathCache) {
                render(ctx, edge, impl.pathCache, s, t);
                return;
            }
            const path = new Path2D();
            path.moveTo(s.x, s.y);
            path.lineTo(t.x, t.y);
            render(ctx, edge, path, s, t);
        });
    };
    const r = $cb9df2af88d35554$var$registerCallback(layer, renderer);
    return {
        layer: layer,
        edges: edges,
        remove: ()=>{
            if (o.updateOn !== 'none' && o.updateOn !== 'render') {
                edges.off(o.updateOn, undefined, layer.updateOnRenderOnce);
                edges.sources().off(o.updateOn, undefined, layer.updateOnRenderOnce);
                edges.targets().off(o.updateOn, undefined, layer.updateOnRenderOnce);
            }
            layer.cy.off('add remove', o.selector, revaluateAndUpdateOnce);
            r.remove();
        }
    };
}
function $cb9df2af88d35554$var$anyVisible(layer, s, t, count) {
    const interpolate = (v)=>({
            x: s.x * v + t.x * (1 - v),
            y: s.y * v + t.y * (1 - v)
        });
    if (count === 1) return layer.inVisibleBounds(interpolate(0.5));
    const step = 1 / count;
    for(let i = 0; i <= count; i++){
        if (layer.inVisibleBounds(interpolate(i * step))) return true;
    }
    return false;
}
function $cb9df2af88d35554$export$b9b3a07abf638e3(layer, render, options = {}) {
    const o = Object.assign({
        transform: '',
        position: 'top-left',
        boundingBox: {
            includeLabels: false,
            includeOverlays: false
        },
        uniqueElements: false,
        initCollection: ()=>undefined
    }, $cb9df2af88d35554$var$defaultElementLayerOptions(options), options);
    let nodes = layer.cy.collection();
    let updateOnRenderOnceEnabled = false;
    const revaluateAndUpdateOnce = ()=>{
        if (updateOnRenderOnceEnabled) return;
        updateOnRenderOnceEnabled = true;
        layer.cy.one('render', ()=>{
            updateOnRenderOnceEnabled = false;
            nodes = reevaluateCollection(nodes);
            layer.update();
        });
    };
    const reevaluateCollection = (current)=>{
        if (o.updateOn !== 'none' && o.updateOn !== 'render') current.off(o.updateOn, undefined, layer.updateOnRenderOnce);
        const newNodes = layer.cy.nodes(o.selector);
        o.initCollection(newNodes);
        if (o.updateOn !== 'none' && o.updateOn !== 'render') newNodes.on(o.updateOn, layer.updateOnRenderOnce);
        layer.updateOnRenderOnce();
        return newNodes;
    };
    if (o.updateOn === 'render') layer.updateOnRender = true;
    if (!o.queryEachTime) {
        nodes = reevaluateCollection(nodes);
        layer.cy.on('add remove', o.selector, revaluateAndUpdateOnce);
    }
    const wrapResult = (v)=>({
            layer: layer,
            nodes: nodes,
            remove: ()=>{
                if (o.updateOn !== 'none' && o.updateOn !== 'render') nodes.off(o.updateOn, undefined, layer.updateOnRenderOnce);
                layer.cy.off('add remove', o.selector, revaluateAndUpdateOnce);
                v.remove();
            }
        });
    if (layer.type === 'canvas') {
        const oCanvas = o;
        const renderer = (ctx, hint)=>{
            const t = ctx.getTransform();
            if (o.queryEachTime) nodes = reevaluateCollection(nodes);
            nodes.forEach((node)=>{
                if (node.removed()) return;
                const bb = node.boundingBox(o.boundingBox);
                if (!hint.forExport && oCanvas.checkBounds && !layer.inVisibleBounds(bb)) return;
                if (oCanvas.position === 'top-left') ctx.translate(bb.x1, bb.y1);
                else if (oCanvas.position === 'center') {
                    const pos = node.position();
                    ctx.translate(pos.x, pos.y);
                }
                render(ctx, node, bb);
                if (oCanvas.position !== 'none') ctx.setTransform(t);
            });
        };
        return wrapResult($cb9df2af88d35554$var$registerCallback(layer, renderer));
    }
    const oDOM = o;
    const baseOptions = {
        bb: (node)=>node.boundingBox(oDOM.boundingBox),
        isVisible: oDOM.checkBounds ? (bb)=>layer.inVisibleBounds(bb) : ()=>true,
        uniqueElements: oDOM.uniqueElements === true
    };
    if (oDOM.checkBounds) layer.updateOnTransform = true;
    if (layer.type === 'html') {
        const matchOptions = {
            ...baseOptions,
            enter: (node, bb)=>{
                const r = layer.node.ownerDocument.createElement('div');
                r.style.position = 'absolute';
                if (oDOM.init) oDOM.init(r, node, bb);
                return r;
            },
            update: (elem, node, bb)=>{
                if (oDOM.position === 'top-left') elem.style.transform = `${oDOM.transform}translate3d(${bb.x1}px,${bb.y1}px,0)`;
                else if (oDOM.position === 'center') {
                    const pos = node.position();
                    elem.style.transform = `${oDOM.transform}translate3d(${pos.x}px,${pos.y}px,0)`;
                }
                render(elem, node, bb);
            }
        };
        const renderer = (root)=>{
            if (o.queryEachTime) nodes = reevaluateCollection(nodes);
            $cb9df2af88d35554$var$matchNodes(root, nodes, matchOptions);
        };
        return wrapResult($cb9df2af88d35554$var$registerCallback(layer, renderer));
    }
    const matchOptions = {
        ...baseOptions,
        enter: (node, bb)=>{
            const r = layer.node.ownerDocument.createElementNS($cb9df2af88d35554$var$SVG_NS, 'g');
            if (oDOM.init) oDOM.init(r, node, bb);
            return r;
        },
        update: (elem, node, bb)=>{
            if (oDOM.position === 'top-left') elem.setAttribute('transform', `${oDOM.transform}translate3d(${bb.x1},${bb.y1},0)`);
            else if (oDOM.position === 'center') {
                const pos = node.position();
                elem.setAttribute('transform', `${oDOM.transform}translate3d(${pos.x},${pos.y},0)`);
            }
            render(elem, node, bb);
        }
    };
    const renderer = (root)=>{
        if (o.queryEachTime) nodes = reevaluateCollection(nodes);
        $cb9df2af88d35554$var$matchNodes(root, nodes, matchOptions);
    };
    return wrapResult($cb9df2af88d35554$var$registerCallback(layer, renderer));
}
function $cb9df2af88d35554$var$b64ToBlob(b64, mimeType) {
    const bytes = atob(b64);
    const buff = new ArrayBuffer(bytes.length);
    const buffUint8 = new Uint8Array(buff);
    for(let i = 0; i < bytes.length; i++)buffUint8[i] = bytes.charCodeAt(i);
    return new Blob([
        buff
    ], {
        type: mimeType
    });
}
function $cb9df2af88d35554$var$b64UriToB64(b64uri) {
    const i = b64uri.indexOf(',');
    return b64uri.substring(i + 1);
}
function $cb9df2af88d35554$var$output(options, canvas, mimeType) {
    const getB64Uri = function getB64Uri() {
        return canvas.toDataURL(mimeType, options.quality);
    };
    switch(options.output){
        case 'blob-promise':
            return new Promise((resolve, reject)=>{
                try {
                    canvas.toBlob(function(blob) {
                        if (blob != null) resolve(blob);
                        else reject(new Error('`canvas.toBlob()` sent a null value in its callback'));
                    }, mimeType, options.quality);
                } catch (err) {
                    reject(err);
                }
            });
        case 'blob':
            return $cb9df2af88d35554$var$b64ToBlob($cb9df2af88d35554$var$b64UriToB64(getB64Uri()), mimeType);
        case 'base64':
            return $cb9df2af88d35554$var$b64UriToB64(getB64Uri());
        case 'base64uri':
        default:
            return getB64Uri();
    }
}
function $cb9df2af88d35554$var$isPoint(p) {
    return p.x != null;
}
class $cb9df2af88d35554$export$c876cc569856725c extends Error {
}
class $cb9df2af88d35554$export$c953189236b7b18a {
    constructor(cy){
        this.bak = {};
        this.resize = ()=>{
            const width = this.cy.width();
            const height = this.cy.height();
            this.viewport.width = width;
            this.viewport.height = height;
            for (const layer of this.layers)layer.resize(width, height);
        };
        this.destroy = ()=>{
            for (const layer of this.layers)layer.remove();
            this.cy.off('destroy', this.destroy);
            this.cy.off('viewport', this.zoomed);
            this.cy.off('resize', this.resize);
            this.cy.scratch('_layers', undefined);
            this.cy.png = this.bak.png;
            this.cy.jpg = this.bak.jpg;
            this.cy.jpeg = this.bak.jpeg;
            this.bak = {};
        };
        this.zoomed = ()=>{
            const pan = this.cy.pan();
            const zoom = this.cy.zoom();
            this.viewport.tx = pan.x;
            this.viewport.ty = pan.y;
            this.viewport.zoom = zoom;
            for (const layer of this.layers)layer.setViewport(pan.x, pan.y, zoom);
        };
        this.renderPerEdge = $cb9df2af88d35554$export$36ef5ea9943e865;
        this.renderPerNode = $cb9df2af88d35554$export$b9b3a07abf638e3;
        this.cy = cy;
        this.adapter = {
            cy: this.cy,
            insert: (where, layer, type)=>this.insert(where, layer, type),
            move: (layer, offset)=>this.move(layer, offset),
            inVisibleBounds: (p)=>{
                const v = this.viewport;
                const inX = (x)=>{
                    const xp = x * v.zoom + v.tx;
                    return xp >= 0 && xp <= v.width;
                };
                const inY = (y)=>{
                    const yp = y * v.zoom + v.ty;
                    return yp >= 0 && yp <= v.height;
                };
                if ($cb9df2af88d35554$var$isPoint(p)) return inX(p.x) && inY(p.y);
                return inX(p.x1) && inY(p.y1) || inX(p.x2) && inY(p.y1) || inX(p.x2) && inY(p.y2) || inX(p.x1) && inY(p.y2) || inX((p.x1 + p.x2) / 2) && inY((p.y1 + p.y2) / 2);
            }
        };
        const container = cy.container();
        const nodeLayer = new $cb9df2af88d35554$var$CytoscapeNodeLayer(this.adapter, container.querySelector('[data-id="layer2-node"]'));
        this.nodeLayer = nodeLayer;
        const dragLayer = new $cb9df2af88d35554$var$CytoscapeDragLayer(this.adapter, container.querySelector('[data-id="layer1-drag"]'));
        this.dragLayer = dragLayer;
        const selectBoxLayer = new $cb9df2af88d35554$var$CytoscapeSelectBoxLayer(this.adapter, container.querySelector('[data-id="layer0-selectbox"]'));
        this.selectBoxLayer = selectBoxLayer;
        nodeLayer.root.style.zIndex = '';
        dragLayer.root.style.zIndex = '';
        selectBoxLayer.root.style.zIndex = '';
        nodeLayer.root.insertAdjacentElement('afterend', dragLayer.root);
        dragLayer.root.insertAdjacentElement('afterend', selectBoxLayer.root);
        cy.on('viewport', this.zoomed);
        cy.on('resize', this.resize);
        cy.on('destroy', this.destroy);
        this.bak = {
            png: cy.png,
            jpg: cy.jpg,
            jpeg: cy.jpeg
        };
        cy.png = this.png.bind(this);
        cy.jpg = this.jpg.bind(this);
        cy.jpeg = this.jpeg.bind(this);
        this.viewport = {
            width: this.cy.width(),
            height: this.cy.height(),
            tx: this.cy.pan().x,
            ty: this.cy.pan().y,
            zoom: this.cy.zoom()
        };
    }
    move(layer, offset) {
        const l = this.layers;
        const index = l.indexOf(layer);
        const target = Math.max(Math.min(index + offset, l.length, 0));
        if (target === index) return;
        if (index >= l.length - 1) this.root.appendChild(layer.root);
        else this.root.insertBefore(layer.root, l[target].root);
    }
    get document() {
        return this.cy.container().ownerDocument;
    }
    get root() {
        return this.nodeLayer.node.parentElement;
    }
    get layers() {
        return Array.from(this.root.children).map((d)=>d.__cy_layer).filter((d)=>d != null);
    }
    getLayers() {
        return this.layers;
    }
    init(layer) {
        layer.resize(this.viewport.width, this.viewport.height);
        layer.setViewport(this.viewport.tx, this.viewport.ty, this.viewport.zoom);
        return layer;
    }
    update() {
        this.zoomed();
        for (const layer of this.layers)if (layer instanceof $cb9df2af88d35554$var$CanvasLayer) layer.draw();
    }
    createLayer(type, options) {
        switch(type){
            case 'svg':
                return this.init(new $cb9df2af88d35554$var$SVGLayer(this.adapter, this.document, options));
            case 'html':
                return this.init(new $cb9df2af88d35554$var$HTMLLayer(this.adapter, this.document, options));
            case 'canvas':
                return this.init(new $cb9df2af88d35554$var$CanvasLayer(this.adapter, this.document, options));
            case 'html-static':
                return this.init(new $cb9df2af88d35554$var$HTMLStaticLayer(this.adapter, this.document, options));
            case 'svg-static':
                return this.init(new $cb9df2af88d35554$var$SVGStaticLayer(this.adapter, this.document, options));
            case 'canvas-static':
                return this.init(new $cb9df2af88d35554$var$CanvasStaticLayer(this.adapter, this.document, options));
        }
    }
    append(type, options) {
        const layer = this.createLayer(type, options);
        this.root.appendChild(layer.root);
        return layer;
    }
    insert(where, ref, type, options) {
        const layer = this.createLayer(type, options);
        ref.root.insertAdjacentElement(where === 'before' ? 'beforebegin' : 'afterend', layer.root);
        return layer;
    }
    getLast() {
        var _a;
        const layers = this.layers;
        return (_a = layers[layers.length - 1]) !== null && _a !== void 0 ? _a : null;
    }
    getFirst() {
        var _a;
        const layers = this.layers;
        return (_a = layers[0]) !== null && _a !== void 0 ? _a : null;
    }
    hasCustomLayer() {
        return this.layers.some((d)=>!(d instanceof $cb9df2af88d35554$var$CytoscapeBaseLayer));
    }
    toCanvas(options) {
        const layers = this.layers;
        if (layers.some((d)=>!d.supportsRender) && !options.ignoreUnsupportedLayers) throw new $cb9df2af88d35554$export$c876cc569856725c(`some layer doesn't support exporting, use {ignoreUnsupportedLayers: true} option to ignore`);
        const nodeIndex = layers.indexOf(this.nodeLayer);
        const dragIndex = layers.indexOf(this.dragLayer);
        const selectBoxIndex = layers.indexOf(this.selectBoxLayer);
        if ((nodeIndex !== dragIndex - 1 || dragIndex !== selectBoxIndex - 1) && !options.ignoreUnsupportedLayerOrder) throw new $cb9df2af88d35554$export$c876cc569856725c(`cytoscape layers are not in order, use {ignoreUnsupportedLayerOrder: true} option to ignore`);
        const before = layers.slice(0, nodeIndex).reverse().filter((d)=>d.supportsRender() && d !== this.dragLayer && d !== this.selectBoxLayer);
        const after = layers.slice(nodeIndex + 1).filter((d)=>d.supportsRender() && d !== this.dragLayer && d !== this.selectBoxLayer);
        const renderer = this.cy.renderer();
        const drawElements = renderer.drawElements;
        renderer.drawElements = function(ctx, elems) {
            for (const l of before)l.renderInto(ctx);
            drawElements.call(this, ctx, elems);
            for (const l of after)l.renderInto(ctx);
        };
        const canvas = renderer.bufferCanvasImage(options);
        renderer.drawElements = drawElements;
        return canvas;
    }
    png(options) {
        if (!this.hasCustomLayer()) return this.bak.png.call(this.cy, options);
        return $cb9df2af88d35554$var$output(options !== null && options !== void 0 ? options : {}, this.toCanvas(options !== null && options !== void 0 ? options : {}), 'image/png');
    }
    jpg(options) {
        if (!this.hasCustomLayer()) return this.bak.jpg.call(this.cy, options);
        const o = {
            bg: '#fff',
            ...options !== null && options !== void 0 ? options : {}
        };
        return $cb9df2af88d35554$var$output(o, this.toCanvas(o), 'image/png');
    }
    jpeg(options) {
        if (!this.hasCustomLayer()) return this.bak.jpeg.call(this.cy, options);
        return this.jpg(options);
    }
}
function $cb9df2af88d35554$export$7be255094ccdc533(cy = this) {
    if (!cy.container()) throw new Error('layers plugin does not work in headless environments');
    const singleton = cy.scratch('_layers');
    if (singleton) return singleton;
    const plugin = new $cb9df2af88d35554$export$c953189236b7b18a(cy);
    cy.scratch('_layers', plugin);
    return plugin;
}
function $cb9df2af88d35554$export$2e2bcd8739ae039(cytoscape) {
    cytoscape('core', 'layers', $cb9df2af88d35554$export$7be255094ccdc533);
}
if (typeof window.cytoscape !== 'undefined') $cb9df2af88d35554$export$2e2bcd8739ae039(window.cytoscape);


/**
 * bubblesets-js
 * https://github.com/upsetjs/bubblesets-js
 *
 * Copyright (c) 2021-2022 Samuel Gratzl <sam@sgratzl.com>
 */ function $21a54bda07acbf50$var$linePtSegDistSq(lx1, ly1, lx2, ly2, x, y) {
    const x1 = lx1;
    const y1 = ly1;
    const x2 = lx2 - x1;
    const y2 = ly2 - y1;
    let px = x - x1;
    let py = y - y1;
    let dotprod = px * x2 + py * y2;
    let projlenSq = 0;
    if (dotprod <= 0) projlenSq = 0;
    else {
        px = x2 - px;
        py = y2 - py;
        dotprod = px * x2 + py * y2;
        if (dotprod <= 0) projlenSq = 0;
        else projlenSq = dotprod * dotprod / (x2 * x2 + y2 * y2);
    }
    const lenSq = px * px + py * py - projlenSq;
    if (lenSq < 0) return 0;
    return lenSq;
}
function $21a54bda07acbf50$var$ptsDistanceSq(x1, y1, x2, y2) {
    return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
}
function $21a54bda07acbf50$var$doublePointsEqual(x1, y1, x2, y2, delta) {
    return $21a54bda07acbf50$var$ptsDistanceSq(x1, y1, x2, y2) < delta * delta;
}
function $21a54bda07acbf50$var$round(digits) {
    if (!Number.isFinite(digits)) return (v)=>v;
    if (digits === 0) return Math.round;
    const factor = Math.pow(10, digits);
    return (v)=>Math.round(v * factor) / factor;
}
function $21a54bda07acbf50$export$26fe0db1e56290ef(line) {
    const minX = Math.min(line.x1, line.x2);
    const maxX = Math.max(line.x1, line.x2);
    const minY = Math.min(line.y1, line.y2);
    const maxY = Math.max(line.y1, line.y2);
    return {
        x: minX,
        y: minY,
        x2: maxX,
        y2: maxY,
        width: maxX - minX,
        height: maxY - minY
    };
}
class $21a54bda07acbf50$export$17d680238e50603e {
    constructor(x1, y1, x2, y2){
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
    }
    equals(that) {
        return this.x1 === that.x1 && this.y1 === that.y1 && this.x2 === that.x2 && this.y2 === that.y2;
    }
    draw(ctx) {
        ctx.moveTo(this.x1, this.y1);
        ctx.lineTo(this.x2, this.y2);
    }
    toString() {
        return `Line(from=(${this.x1},${this.y1}),to=(${this.x2},${this.y2}))`;
    }
    static from(l) {
        return new $21a54bda07acbf50$export$17d680238e50603e(l.x1, l.y1, l.x2, l.y2);
    }
    cuts(px, py) {
        if (this.y1 === this.y2) return false;
        if (py < this.y1 && py <= this.y2 || py > this.y1 && py >= this.y2) return false;
        if (px > this.x1 && px >= this.x2) return false;
        if (px < this.x1 && px <= this.x2) return true;
        const cross = this.x1 + (py - this.y1) * (this.x2 - this.x1) / (this.y2 - this.y1);
        return px <= cross;
    }
    distSquare(x, y) {
        return $21a54bda07acbf50$var$linePtSegDistSq(this.x1, this.y1, this.x2, this.y2, x, y);
    }
    ptClose(x, y, r) {
        if (this.x1 < this.x2) {
            if (x < this.x1 - r || x > this.x2 + r) return false;
        } else {
            if (x < this.x2 - r || x > this.x1 + r) return false;
        }
        if (this.y1 < this.y2) {
            if (y < this.y1 - r || y > this.y2 + r) return false;
        } else {
            if (y < this.y2 - r || y > this.y1 + r) return false;
        }
        return true;
    }
}
var $21a54bda07acbf50$var$EState;
(function(EState) {
    EState[EState["POINT"] = 1] = "POINT";
    EState[EState["PARALLEL"] = 2] = "PARALLEL";
    EState[EState["COINCIDENT"] = 3] = "COINCIDENT";
    EState[EState["NONE"] = 4] = "NONE";
})($21a54bda07acbf50$var$EState || ($21a54bda07acbf50$var$EState = {}));
class $21a54bda07acbf50$var$Intersection {
    constructor(state, x = 0, y = 0){
        this.state = state;
        this.x = x;
        this.y = y;
    }
}
function $21a54bda07acbf50$var$intersectLineLine(la, lb) {
    const uaT = (lb.x2 - lb.x1) * (la.y1 - lb.y1) - (lb.y2 - lb.y1) * (la.x1 - lb.x1);
    const ubT = (la.x2 - la.x1) * (la.y1 - lb.y1) - (la.y2 - la.y1) * (la.x1 - lb.x1);
    const uB = (lb.y2 - lb.y1) * (la.x2 - la.x1) - (lb.x2 - lb.x1) * (la.y2 - la.y1);
    if (uB) {
        const ua = uaT / uB;
        const ub = ubT / uB;
        if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) return new $21a54bda07acbf50$var$Intersection($21a54bda07acbf50$var$EState.POINT, la.x1 + ua * (la.x2 - la.x1), la.y1 + ua * (la.y2 - la.y1));
        return new $21a54bda07acbf50$var$Intersection($21a54bda07acbf50$var$EState.NONE);
    }
    return new $21a54bda07acbf50$var$Intersection(uaT === 0 || ubT === 0 ? $21a54bda07acbf50$var$EState.COINCIDENT : $21a54bda07acbf50$var$EState.PARALLEL);
}
function $21a54bda07acbf50$var$fractionAlongLineA(la, lb) {
    const uaT = (lb.x2 - lb.x1) * (la.y1 - lb.y1) - (lb.y2 - lb.y1) * (la.x1 - lb.x1);
    const ubT = (la.x2 - la.x1) * (la.y1 - lb.y1) - (la.y2 - la.y1) * (la.x1 - lb.x1);
    const uB = (lb.y2 - lb.y1) * (la.x2 - la.x1) - (lb.x2 - lb.x1) * (la.y2 - la.y1);
    if (uB) {
        const ua = uaT / uB;
        const ub = ubT / uB;
        if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) return ua;
    }
    return Number.POSITIVE_INFINITY;
}
function $21a54bda07acbf50$var$hasFractionToLineCenter(bounds, line) {
    function testLine(xa, ya, xb, yb) {
        let testDistance = $21a54bda07acbf50$var$fractionAlongLineA(line, new $21a54bda07acbf50$export$17d680238e50603e(xa, ya, xb, yb));
        testDistance = Math.abs(testDistance - 0.5);
        if (testDistance >= 0 && testDistance <= 1) return 1;
        return 0;
    }
    let countIntersections = testLine(bounds.x, bounds.y, bounds.x2, bounds.y);
    countIntersections += testLine(bounds.x, bounds.y, bounds.x, bounds.y2);
    if (countIntersections > 1) return true;
    countIntersections += testLine(bounds.x, bounds.y2, bounds.x2, bounds.y2);
    if (countIntersections > 1) return true;
    countIntersections += testLine(bounds.x2, bounds.y, bounds.x2, bounds.y2);
    return countIntersections > 0;
}
var $21a54bda07acbf50$var$OutCode;
(function(OutCode) {
    OutCode[OutCode["LEFT"] = 0] = "LEFT";
    OutCode[OutCode["TOP"] = 1] = "TOP";
    OutCode[OutCode["RIGHT"] = 2] = "RIGHT";
    OutCode[OutCode["BOTTOM"] = 3] = "BOTTOM";
})($21a54bda07acbf50$var$OutCode || ($21a54bda07acbf50$var$OutCode = {}));
function $21a54bda07acbf50$var$outcode(bounds, px, py) {
    const out = new Set();
    if (bounds.width <= 0) {
        out.add($21a54bda07acbf50$var$OutCode.LEFT);
        out.add($21a54bda07acbf50$var$OutCode.RIGHT);
    } else if (px < bounds.x) out.add($21a54bda07acbf50$var$OutCode.LEFT);
    else if (px > bounds.x + bounds.width) out.add($21a54bda07acbf50$var$OutCode.RIGHT);
    if (bounds.height <= 0) {
        out.add($21a54bda07acbf50$var$OutCode.TOP);
        out.add($21a54bda07acbf50$var$OutCode.BOTTOM);
    } else if (py < bounds.y) out.add($21a54bda07acbf50$var$OutCode.TOP);
    else if (py > bounds.y + bounds.height) out.add($21a54bda07acbf50$var$OutCode.BOTTOM);
    return out;
}
function $21a54bda07acbf50$var$intersectsLine(bounds, line) {
    let x1 = line.x1;
    let y1 = line.y1;
    const x2 = line.x2;
    const y2 = line.y2;
    const out2 = Array.from($21a54bda07acbf50$var$outcode(bounds, x2, y2));
    if (out2.length === 0) return true;
    let out1 = $21a54bda07acbf50$var$outcode(bounds, x1, y1);
    while(out1.size !== 0){
        for (const a of out2){
            if (out1.has(a)) return false;
        }
        if (out1.has($21a54bda07acbf50$var$OutCode.RIGHT) || out1.has($21a54bda07acbf50$var$OutCode.LEFT)) {
            let x = bounds.x;
            if (out1.has($21a54bda07acbf50$var$OutCode.RIGHT)) x += bounds.width;
            y1 = y1 + (x - x1) * (y2 - y1) / (x2 - x1);
            x1 = x;
        } else {
            let y = bounds.y;
            if (out1.has($21a54bda07acbf50$var$OutCode.BOTTOM)) y += bounds.height;
            x1 = x1 + (y - y1) * (x2 - x1) / (y2 - y1);
            y1 = y;
        }
        out1 = $21a54bda07acbf50$var$outcode(bounds, x1, y1);
    }
    return true;
}
function $21a54bda07acbf50$var$fractionToLineCenter(bounds, line) {
    let minDistance = Number.POSITIVE_INFINITY;
    let countIntersections = 0;
    function testLine(xa, ya, xb, yb) {
        let testDistance = $21a54bda07acbf50$var$fractionAlongLineA(line, new $21a54bda07acbf50$export$17d680238e50603e(xa, ya, xb, yb));
        testDistance = Math.abs(testDistance - 0.5);
        if (testDistance >= 0 && testDistance <= 1) {
            countIntersections++;
            if (testDistance < minDistance) minDistance = testDistance;
        }
    }
    testLine(bounds.x, bounds.y, bounds.x2, bounds.y);
    testLine(bounds.x, bounds.y, bounds.x, bounds.y2);
    if (countIntersections > 1) return minDistance;
    testLine(bounds.x, bounds.y2, bounds.x2, bounds.y2);
    if (countIntersections > 1) return minDistance;
    testLine(bounds.x2, bounds.y, bounds.x2, bounds.y2);
    if (countIntersections === 0) return -1;
    return minDistance;
}
function $21a54bda07acbf50$var$testIntersection(line, bounds) {
    let count = 0;
    const top = $21a54bda07acbf50$var$intersectLineLine(line, new $21a54bda07acbf50$export$17d680238e50603e(bounds.x, bounds.y, bounds.x2, bounds.y));
    count += top.state === $21a54bda07acbf50$var$EState.POINT ? 1 : 0;
    const left = $21a54bda07acbf50$var$intersectLineLine(line, new $21a54bda07acbf50$export$17d680238e50603e(bounds.x, bounds.y, bounds.x, bounds.y2));
    count += left.state === $21a54bda07acbf50$var$EState.POINT ? 1 : 0;
    const bottom = $21a54bda07acbf50$var$intersectLineLine(line, new $21a54bda07acbf50$export$17d680238e50603e(bounds.x, bounds.y2, bounds.x2, bounds.y2));
    count += bottom.state === $21a54bda07acbf50$var$EState.POINT ? 1 : 0;
    const right = $21a54bda07acbf50$var$intersectLineLine(line, new $21a54bda07acbf50$export$17d680238e50603e(bounds.x2, bounds.y, bounds.x2, bounds.y2));
    count += right.state === $21a54bda07acbf50$var$EState.POINT ? 1 : 0;
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        count: count
    };
}
class $21a54bda07acbf50$export$4617fb02663045ef {
    constructor(x, y, width, height){
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    get x2() {
        return this.x + this.width;
    }
    get y2() {
        return this.y + this.height;
    }
    get cx() {
        return this.x + this.width / 2;
    }
    get cy() {
        return this.y + this.height / 2;
    }
    get radius() {
        return Math.max(this.width, this.height) / 2;
    }
    static from(r) {
        return new $21a54bda07acbf50$export$4617fb02663045ef(r.x, r.y, r.width, r.height);
    }
    equals(that) {
        return this.x === that.x && this.y === that.y && this.width === that.width && this.height === that.height;
    }
    clone() {
        return new $21a54bda07acbf50$export$4617fb02663045ef(this.x, this.y, this.width, this.height);
    }
    add(that) {
        const x = Math.min(this.x, that.x);
        const y = Math.min(this.y, that.y);
        const x2 = Math.max(this.x2, that.x + that.width);
        const y2 = Math.max(this.y2, that.y + that.height);
        this.x = x;
        this.y = y;
        this.width = x2 - x;
        this.height = y2 - y;
    }
    addPoint(p) {
        const x = Math.min(this.x, p.x);
        const y = Math.min(this.y, p.y);
        const x2 = Math.max(this.x2, p.x);
        const y2 = Math.max(this.y2, p.y);
        this.x = x;
        this.y = y;
        this.width = x2 - x;
        this.height = y2 - y;
    }
    toString() {
        return `Rectangle[x=${this.x}, y=${this.y}, w=${this.width}, h=${this.height}]`;
    }
    draw(ctx) {
        ctx.rect(this.x, this.y, this.width, this.height);
    }
    containsPt(px, py) {
        return px >= this.x && px <= this.x2 && py >= this.y && py <= this.y2;
    }
    get area() {
        return this.width * this.height;
    }
    intersects(that) {
        if (this.area <= 0 || that.width <= 0 || that.height <= 0) return false;
        return that.x + that.width > this.x && that.y + that.height > this.y && that.x < this.x2 && that.y < this.y2;
    }
    distSquare(tempX, tempY) {
        if (this.containsPt(tempX, tempY)) return 0;
        const code = $21a54bda07acbf50$var$outcode(this, tempX, tempY);
        if (code.has($21a54bda07acbf50$var$OutCode.TOP)) {
            if (code.has($21a54bda07acbf50$var$OutCode.LEFT)) return $21a54bda07acbf50$var$ptsDistanceSq(tempX, tempY, this.x, this.y);
            if (code.has($21a54bda07acbf50$var$OutCode.RIGHT)) return $21a54bda07acbf50$var$ptsDistanceSq(tempX, tempY, this.x2, this.y);
            return (this.y - tempY) * (this.y - tempY);
        }
        if (code.has($21a54bda07acbf50$var$OutCode.BOTTOM)) {
            if (code.has($21a54bda07acbf50$var$OutCode.LEFT)) return $21a54bda07acbf50$var$ptsDistanceSq(tempX, tempY, this.x, this.y2);
            if (code.has($21a54bda07acbf50$var$OutCode.RIGHT)) return $21a54bda07acbf50$var$ptsDistanceSq(tempX, tempY, this.x2, this.y2);
            return (tempY - this.y2) * (tempY - this.y2);
        }
        if (code.has($21a54bda07acbf50$var$OutCode.LEFT)) return (this.x - tempX) * (this.x - tempX);
        if (code.has($21a54bda07acbf50$var$OutCode.RIGHT)) return (tempX - this.x2) * (tempX - this.x2);
        return 0;
    }
}
function $21a54bda07acbf50$export$c845df1685d3e70f(path) {
    if (path.length === 0) return null;
    const first = path[0];
    const bb = new $21a54bda07acbf50$export$4617fb02663045ef(first.x, first.y, 0, 0);
    for (const point of path)bb.addPoint(point);
    return bb;
}
class $21a54bda07acbf50$export$c89a927ffc67e6fa {
    constructor(cx, cy, radius){
        this.cx = cx;
        this.cy = cy;
        this.radius = radius;
    }
    get x() {
        return this.cx - this.radius;
    }
    get x2() {
        return this.cx + this.radius;
    }
    get width() {
        return this.radius * 2;
    }
    get y() {
        return this.cy - this.radius;
    }
    get y2() {
        return this.cy + this.radius;
    }
    get height() {
        return this.radius * 2;
    }
    static from(r) {
        return new $21a54bda07acbf50$export$c89a927ffc67e6fa(r.cx, r.cy, r.radius);
    }
    containsPt(x, y) {
        return $21a54bda07acbf50$var$ptsDistanceSq(this.cx, this.cy, x, y) < this.radius * this.radius;
    }
    distSquare(tempX, tempY) {
        const dist = $21a54bda07acbf50$var$ptsDistanceSq(this.cx, this.cy, tempX, tempY);
        if (dist < this.radius * this.radius) return 0;
        const offset = Math.sqrt(dist) - this.radius;
        return offset * offset;
    }
    draw(ctx) {
        ctx.ellipse(this.cx, this.cy, this.radius, this.radius, 0, 0, Math.PI * 2);
    }
}
class $21a54bda07acbf50$export$ea1a111407f37557 {
    constructor(pixelGroup, i = 0, j = 0, pixelX = 0, pixelY = 0, width = 10, height = 10, pixels = new Float32Array(Math.max(0, width * height)).fill(0)){
        this.pixelGroup = pixelGroup;
        this.i = i;
        this.j = j;
        this.pixelX = pixelX;
        this.pixelY = pixelY;
        this.width = width;
        this.height = height;
        this.area = pixels;
    }
    createSub(rect, pixelPos) {
        return new $21a54bda07acbf50$export$ea1a111407f37557(this.pixelGroup, rect.x, rect.y, pixelPos.x, pixelPos.y, rect.width, rect.height);
    }
    static fromPixelRegion(pixelRect, pixelGroup) {
        return new $21a54bda07acbf50$export$ea1a111407f37557(pixelGroup, 0, 0, pixelRect.x, pixelRect.y, Math.ceil(pixelRect.width / pixelGroup), Math.ceil(pixelRect.height / pixelGroup));
    }
    copy(sub, pixelPoint) {
        return new $21a54bda07acbf50$export$ea1a111407f37557(this.pixelGroup, this.scaleX(pixelPoint.x), this.scaleY(pixelPoint.y), pixelPoint.x, pixelPoint.y, sub.width, sub.height, sub.area);
    }
    boundX(pos) {
        if (pos < this.i) return this.i;
        if (pos >= this.width) return this.width - 1;
        return pos;
    }
    boundY(pos) {
        if (pos < this.j) return this.j;
        if (pos >= this.height) return this.height - 1;
        return pos;
    }
    scaleX(pixel) {
        return this.boundX(Math.floor((pixel - this.pixelX) / this.pixelGroup));
    }
    scaleY(pixel) {
        return this.boundY(Math.floor((pixel - this.pixelY) / this.pixelGroup));
    }
    scale(pixelRect) {
        const x = this.scaleX(pixelRect.x);
        const y = this.scaleY(pixelRect.y);
        const x2 = this.boundX(Math.ceil((pixelRect.x + pixelRect.width - this.pixelX) / this.pixelGroup));
        const y2 = this.boundY(Math.ceil((pixelRect.y + pixelRect.height - this.pixelY) / this.pixelGroup));
        const width = x2 - x;
        const height = y2 - y;
        return new $21a54bda07acbf50$export$4617fb02663045ef(x, y, width, height);
    }
    invertScaleX(v) {
        return Math.round(v * this.pixelGroup + this.pixelX);
    }
    invertScaleY(v) {
        return Math.round(v * this.pixelGroup + this.pixelY);
    }
    addPadding(rect, pixelPadding) {
        const padding = Math.ceil(pixelPadding / this.pixelGroup);
        const x = this.boundX(rect.x - padding);
        const y = this.boundY(rect.y - padding);
        const x2 = this.boundX(rect.x2 + padding);
        const y2 = this.boundY(rect.y2 + padding);
        const width = x2 - x;
        const height = y2 - y;
        return new $21a54bda07acbf50$export$4617fb02663045ef(x, y, width, height);
    }
    get(i, j) {
        if (i < 0 || j < 0 || i >= this.width || j >= this.height) return Number.NaN;
        return this.area[i + j * this.width];
    }
    inc(i, j, v) {
        if (i < 0 || j < 0 || i >= this.width || j >= this.height) return;
        this.area[i + j * this.width] += v;
    }
    set(i, j, v) {
        if (i < 0 || j < 0 || i >= this.width || j >= this.height) return;
        this.area[i + j * this.width] = v;
    }
    incArea(sub, factor) {
        if (sub.width <= 0 || sub.height <= 0 || factor === 0) return;
        const w = this.width;
        const aw = sub.width;
        const i1 = Math.max(0, sub.i);
        const j1 = Math.max(0, sub.j);
        const i2 = Math.min(sub.i + sub.width, w);
        const j2 = Math.min(sub.j + sub.height, this.height);
        if (j2 <= 0 || i2 <= 0 || i1 >= w || j2 >= this.height) return;
        for(let j = j1; j < j2; j++){
            const subRow = (j - sub.j) * aw;
            const row = j * w;
            for(let i = i1; i < i2; i++){
                const v = sub.area[i - sub.i + subRow];
                if (v === 0) continue;
                this.area[i + row] += factor * v;
            }
        }
    }
    fill(value) {
        this.area.fill(value);
    }
    fillArea(rect, value) {
        const offset = rect.x + rect.y * this.width;
        for(let j = 0; j < rect.height; j++){
            const pos = offset + j * this.width;
            this.area.fill(value, pos, pos + rect.width);
        }
    }
    fillHorizontalLine(i, j, width, value) {
        const offset = i + j * this.width;
        this.area.fill(value, offset, offset + width);
    }
    fillVerticalLine(i, j, height, value) {
        const offset = i + j * this.width;
        for(let k = 0; k < height; k++)this.area[offset + k * this.width] = value;
    }
    clear() {
        this.area.fill(0);
    }
    toString() {
        let r = '';
        for(let j = 0; j < this.height; j++){
            const row = j * this.width;
            for(let i = 0; i < this.width; i++){
                const v = this.area[row + i];
                r += v.toFixed(1).padStart(6);
                r += ' ';
            }
            r += '\n';
        }
        return r;
    }
    draw(ctx, offset = true) {
        if (this.width <= 0 || this.height <= 0) return;
        ctx.save();
        if (offset) ctx.translate(this.pixelX, this.pixelY);
        const min = this.area.reduce((acc, v)=>Math.min(acc, v), Number.POSITIVE_INFINITY);
        const max = this.area.reduce((acc, v)=>Math.max(acc, v), Number.NEGATIVE_INFINITY);
        const scale = (v)=>(v - min) / (max - min);
        ctx.scale(this.pixelGroup, this.pixelGroup);
        for(let i = 0; i < this.width; i++)for(let j = 0; j < this.height; j++){
            const v = this.area[i + j * this.width];
            ctx.fillStyle = `rgba(0, 0, 0, ${scale(v)})`;
            ctx.fillRect(i, j, 1, 1);
        }
        ctx.restore();
    }
    drawThreshold(ctx, threshold, offset = true) {
        if (this.width <= 0 || this.height <= 0) return;
        ctx.save();
        if (offset) ctx.translate(this.pixelX, this.pixelY);
        ctx.scale(this.pixelGroup, this.pixelGroup);
        for(let i = 0; i < this.width; i++)for(let j = 0; j < this.height; j++){
            const v = this.area[i + j * this.width];
            ctx.fillStyle = v > threshold ? 'black' : 'white';
            ctx.fillRect(i, j, 1, 1);
        }
        ctx.restore();
    }
}
function $21a54bda07acbf50$export$adf255e13b40f23f(rect, padding) {
    const map = (r)=>({
            x: r.x - padding,
            y: r.y - padding,
            width: r.width + 2 * padding,
            height: r.height + 2 * padding
        });
    if (Array.isArray(rect)) return rect.map(map);
    return map(rect);
}
function $21a54bda07acbf50$export$4a96817c3621429e(line, potentialArea, padding) {
    return $21a54bda07acbf50$export$88df63bd43ece0f0(Object.assign($21a54bda07acbf50$export$26fe0db1e56290ef(line), {
        distSquare: (x, y)=>$21a54bda07acbf50$var$linePtSegDistSq(line.x1, line.y1, line.x2, line.y2, x, y)
    }), potentialArea, padding);
}
function $21a54bda07acbf50$export$88df63bd43ece0f0(shape, potentialArea, padding) {
    const lr = $21a54bda07acbf50$export$adf255e13b40f23f(shape, padding);
    const scaled = potentialArea.scale(lr);
    const area = potentialArea.createSub(scaled, lr);
    $21a54bda07acbf50$var$sample(area, potentialArea, padding, (x, y)=>shape.distSquare(x, y));
    return area;
}
function $21a54bda07acbf50$var$sample(area, potentialArea, padding, distanceFunction) {
    const padding2 = padding * padding;
    for(let y = 0; y < area.height; y++)for(let x = 0; x < area.width; x++){
        const tempX = potentialArea.invertScaleX(area.i + x);
        const tempY = potentialArea.invertScaleY(area.j + y);
        const distanceSq = distanceFunction(tempX, tempY);
        if (distanceSq === 0) {
            area.set(x, y, padding2);
            continue;
        }
        if (distanceSq < padding2) {
            const dr = padding - Math.sqrt(distanceSq);
            area.set(x, y, dr * dr);
        }
    }
    return area;
}
function $21a54bda07acbf50$export$1f5241b260204fa9(rect, potentialArea, padding) {
    const scaled = potentialArea.scale(rect);
    const padded = potentialArea.addPadding(scaled, padding);
    const area = potentialArea.createSub(padded, {
        x: rect.x - padding,
        y: rect.y - padding
    });
    const paddingLeft = scaled.x - padded.x;
    const paddingTop = scaled.y - padded.y;
    const paddingRight = padded.x2 - scaled.x2;
    const paddingBottom = padded.y2 - scaled.y2;
    const innerWidth = padded.width - paddingLeft - paddingRight;
    const innerHeight = padded.height - paddingTop - paddingBottom;
    const padding2 = padding * padding;
    area.fillArea({
        x: paddingLeft,
        y: paddingTop,
        width: innerWidth + 1,
        height: innerHeight + 1
    }, padding2);
    const straightDistances = [
        0
    ];
    const maxPadding = Math.max(paddingTop, paddingLeft, paddingRight, paddingBottom);
    {
        const tempX = potentialArea.invertScaleX(scaled.x + scaled.width / 2);
        for(let i = 1; i < maxPadding; i++){
            const tempY = potentialArea.invertScaleY(scaled.y - i);
            const distanceSq = rect.distSquare(tempX, tempY);
            if (distanceSq < padding2) {
                const dr = padding - Math.sqrt(distanceSq);
                straightDistances.push(dr * dr);
            } else break;
        }
    }
    const cornerDistances = [];
    const maxHorizontalPadding = Math.max(paddingLeft, paddingRight);
    const maxVerticalPadding = Math.max(paddingTop, paddingRight);
    for(let i = 1; i < maxHorizontalPadding; i++){
        const tempX = potentialArea.invertScaleX(scaled.x - i);
        const row = [];
        for(let j = 1; j < maxVerticalPadding; j++){
            const tempY = potentialArea.invertScaleY(scaled.y - j);
            const distanceSq = rect.distSquare(tempX, tempY);
            if (distanceSq < padding2) {
                const dr = padding - Math.sqrt(distanceSq);
                row.push(dr * dr);
            } else row.push(0);
        }
        cornerDistances.push(row);
    }
    for(let y = 1; y < Math.min(paddingTop, straightDistances.length); y++){
        const value = straightDistances[y];
        area.fillHorizontalLine(paddingLeft, paddingTop - y, innerWidth + 1, value);
    }
    for(let y = 1; y < Math.min(paddingBottom, straightDistances.length); y++){
        const value = straightDistances[y];
        area.fillHorizontalLine(paddingLeft, paddingTop + innerHeight + y, innerWidth + 1, value);
    }
    for(let x = 1; x < Math.min(paddingLeft, straightDistances.length); x++){
        const value = straightDistances[x];
        area.fillVerticalLine(paddingLeft - x, paddingTop, innerHeight + 1, value);
    }
    for(let x = 1; x < Math.min(paddingBottom, straightDistances.length); x++){
        const value = straightDistances[x];
        area.fillVerticalLine(paddingLeft + innerWidth + x, paddingTop, innerHeight + 1, value);
    }
    for(let i = 1; i < paddingLeft; i++){
        const row = cornerDistances[i - 1];
        const ii = paddingLeft - i;
        for(let j = 1; j < paddingTop; j++)area.set(ii, paddingTop - j, row[j - 1]);
        for(let j = 1; j < paddingBottom; j++)area.set(ii, paddingTop + innerHeight + j, row[j - 1]);
    }
    for(let i = 1; i < paddingRight; i++){
        const row = cornerDistances[i - 1];
        const ii = paddingLeft + innerWidth + i;
        for(let j = 1; j < paddingTop; j++)area.set(ii, paddingTop - j, row[j - 1]);
        for(let j = 1; j < paddingBottom; j++)area.set(ii, paddingTop + innerHeight + j, row[j - 1]);
    }
    return area;
}
function $21a54bda07acbf50$export$4b409e53cf4df6e6(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
function $21a54bda07acbf50$export$e1d786d2f707b414(cx, cy, radius) {
    return {
        cx: cx,
        cy: cy,
        radius: radius
    };
}
function $21a54bda07acbf50$export$53f1d5ea8de3d7c(x1, y1, x2, y2) {
    return {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
}
function $21a54bda07acbf50$export$105684a3041cb6f3(x, y) {
    return {
        x: x,
        y: y
    };
}
function $21a54bda07acbf50$export$adcb69fca15b3962(items, nonMembers, maxRoutingIterations, morphBuffer) {
    if (items.length === 0) return [];
    const sorted = $21a54bda07acbf50$var$sortByDistanceToCentroid(items);
    return sorted.map((d, i)=>{
        const visited = sorted.slice(0, i);
        return $21a54bda07acbf50$var$connectItem(nonMembers, d, visited, maxRoutingIterations, morphBuffer);
    }).flat();
}
function $21a54bda07acbf50$var$connectItem(nonMembers, item, visited, maxRoutingIterations, morphBuffer) {
    const itemCenter = $21a54bda07acbf50$export$105684a3041cb6f3(item.cx, item.cy);
    const closestNeighbor = $21a54bda07acbf50$var$calculateClosestNeighbor(itemCenter, visited, nonMembers);
    if (closestNeighbor == null) return [];
    const directLine = new $21a54bda07acbf50$export$17d680238e50603e(itemCenter.x, itemCenter.y, closestNeighbor.cx, closestNeighbor.cy);
    const scannedLines = $21a54bda07acbf50$var$computeRoute(directLine, nonMembers, maxRoutingIterations, morphBuffer);
    return $21a54bda07acbf50$var$mergeLines(scannedLines, nonMembers);
}
function $21a54bda07acbf50$var$computeRoute(directLine, nonMembers, maxRoutingIterations, morphBuffer) {
    const scannedLines = [];
    const linesToCheck = [];
    linesToCheck.push(directLine);
    let hasIntersection = true;
    for(let iterations = 0; iterations < maxRoutingIterations && hasIntersection; iterations++){
        hasIntersection = false;
        while(!hasIntersection && linesToCheck.length > 0){
            const line = linesToCheck.pop();
            const closestItem = $21a54bda07acbf50$var$getCenterItem(nonMembers, line);
            const intersections = closestItem ? $21a54bda07acbf50$var$testIntersection(line, closestItem) : null;
            if (!closestItem || !intersections || intersections.count !== 2) {
                if (!hasIntersection) scannedLines.push(line);
                continue;
            }
            let tempMorphBuffer = morphBuffer;
            let movePoint = $21a54bda07acbf50$var$rerouteLine(closestItem, tempMorphBuffer, intersections, true);
            let foundFirst = $21a54bda07acbf50$var$pointExists(movePoint, linesToCheck) || $21a54bda07acbf50$var$pointExists(movePoint, scannedLines);
            let pointInside = $21a54bda07acbf50$var$isPointInRectangles(movePoint, nonMembers);
            while(!foundFirst && pointInside && tempMorphBuffer >= 1){
                tempMorphBuffer /= 1.5;
                movePoint = $21a54bda07acbf50$var$rerouteLine(closestItem, tempMorphBuffer, intersections, true);
                foundFirst = $21a54bda07acbf50$var$pointExists(movePoint, linesToCheck) || $21a54bda07acbf50$var$pointExists(movePoint, scannedLines);
                pointInside = $21a54bda07acbf50$var$isPointInRectangles(movePoint, nonMembers);
            }
            if (movePoint && !foundFirst && !pointInside) {
                linesToCheck.push(new $21a54bda07acbf50$export$17d680238e50603e(line.x1, line.y1, movePoint.x, movePoint.y));
                linesToCheck.push(new $21a54bda07acbf50$export$17d680238e50603e(movePoint.x, movePoint.y, line.x2, line.y2));
                hasIntersection = true;
            }
            if (hasIntersection) continue;
            tempMorphBuffer = morphBuffer;
            movePoint = $21a54bda07acbf50$var$rerouteLine(closestItem, tempMorphBuffer, intersections, false);
            let foundSecond = $21a54bda07acbf50$var$pointExists(movePoint, linesToCheck) || $21a54bda07acbf50$var$pointExists(movePoint, scannedLines);
            pointInside = $21a54bda07acbf50$var$isPointInRectangles(movePoint, nonMembers);
            while(!foundSecond && pointInside && tempMorphBuffer >= 1){
                tempMorphBuffer /= 1.5;
                movePoint = $21a54bda07acbf50$var$rerouteLine(closestItem, tempMorphBuffer, intersections, false);
                foundSecond = $21a54bda07acbf50$var$pointExists(movePoint, linesToCheck) || $21a54bda07acbf50$var$pointExists(movePoint, scannedLines);
                pointInside = $21a54bda07acbf50$var$isPointInRectangles(movePoint, nonMembers);
            }
            if (movePoint && !foundSecond) {
                linesToCheck.push(new $21a54bda07acbf50$export$17d680238e50603e(line.x1, line.y1, movePoint.x, movePoint.y));
                linesToCheck.push(new $21a54bda07acbf50$export$17d680238e50603e(movePoint.x, movePoint.y, line.x2, line.y2));
                hasIntersection = true;
            }
            if (!hasIntersection) scannedLines.push(line);
        }
    }
    while(linesToCheck.length > 0)scannedLines.push(linesToCheck.pop());
    return scannedLines;
}
function $21a54bda07acbf50$var$mergeLines(scannedLines, nonMembers) {
    const finalRoute = [];
    while(scannedLines.length > 0){
        const line1 = scannedLines.pop();
        if (scannedLines.length === 0) {
            finalRoute.push(line1);
            break;
        }
        const line2 = scannedLines.pop();
        const mergeLine = new $21a54bda07acbf50$export$17d680238e50603e(line1.x1, line1.y1, line2.x2, line2.y2);
        const closestItem = $21a54bda07acbf50$var$getCenterItem(nonMembers, mergeLine);
        if (!closestItem) scannedLines.push(mergeLine);
        else {
            finalRoute.push(line1);
            scannedLines.push(line2);
        }
    }
    return finalRoute;
}
function $21a54bda07acbf50$var$calculateClosestNeighbor(itemCenter, visited, nonMembers) {
    let minLengthSq = Number.POSITIVE_INFINITY;
    return visited.reduce((closestNeighbor, neighborItem)=>{
        const distanceSq = $21a54bda07acbf50$var$ptsDistanceSq(itemCenter.x, itemCenter.y, neighborItem.cx, neighborItem.cy);
        if (distanceSq > minLengthSq) return closestNeighbor;
        const directLine = new $21a54bda07acbf50$export$17d680238e50603e(itemCenter.x, itemCenter.y, neighborItem.cx, neighborItem.cy);
        const numberInterferenceItems = $21a54bda07acbf50$var$itemsCuttingLine(nonMembers, directLine);
        if (distanceSq * (numberInterferenceItems + 1) * (numberInterferenceItems + 1) < minLengthSq) {
            closestNeighbor = neighborItem;
            minLengthSq = distanceSq * (numberInterferenceItems + 1) * (numberInterferenceItems + 1);
        }
        return closestNeighbor;
    }, null);
}
function $21a54bda07acbf50$var$sortByDistanceToCentroid(items) {
    if (items.length < 2) return items;
    let totalX = 0;
    let totalY = 0;
    items.forEach((item)=>{
        totalX += item.cx;
        totalY += item.cy;
    });
    totalX /= items.length;
    totalY /= items.length;
    return items.map((item)=>{
        const diffX = totalX - item.cx;
        const diffY = totalY - item.cy;
        const dist = diffX * diffX + diffY * diffY;
        return [
            item,
            dist
        ];
    }).sort((a, b)=>a[1] - b[1]).map((d)=>d[0]);
}
function $21a54bda07acbf50$var$isPointInRectangles(p, rects) {
    return rects.some((r)=>r.containsPt(p.x, p.y));
}
function $21a54bda07acbf50$var$pointExists(pointToCheck, lines) {
    return lines.some((checkEndPointsLine)=>{
        if ($21a54bda07acbf50$var$doublePointsEqual(checkEndPointsLine.x1, checkEndPointsLine.y1, pointToCheck.x, pointToCheck.y, 1e-3)) return true;
        if ($21a54bda07acbf50$var$doublePointsEqual(checkEndPointsLine.x2, checkEndPointsLine.y2, pointToCheck.x, pointToCheck.y, 1e-3)) return true;
        return false;
    });
}
function $21a54bda07acbf50$var$getCenterItem(items, testLine) {
    let minDistance = Number.POSITIVE_INFINITY;
    let closestItem = null;
    for (const item of items){
        if (!$21a54bda07acbf50$var$intersectsLine(item, testLine)) continue;
        const distance = $21a54bda07acbf50$var$fractionToLineCenter(item, testLine);
        if (distance >= 0 && distance < minDistance) {
            closestItem = item;
            minDistance = distance;
        }
    }
    return closestItem;
}
function $21a54bda07acbf50$var$itemsCuttingLine(items, testLine) {
    return items.reduce((count, item)=>{
        if ($21a54bda07acbf50$var$intersectsLine(item, testLine) && $21a54bda07acbf50$var$hasFractionToLineCenter(item, testLine)) return count + 1;
        return count;
    }, 0);
}
function $21a54bda07acbf50$var$rerouteLine(item, rerouteBuffer, intersections, wrapNormal) {
    const topIntersect = intersections.top;
    const leftIntersect = intersections.left;
    const bottomIntersect = intersections.bottom;
    const rightIntersect = intersections.right;
    if (wrapNormal) {
        if (leftIntersect.state === $21a54bda07acbf50$var$EState.POINT) {
            if (topIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y - rerouteBuffer);
            if (bottomIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y2 + rerouteBuffer);
            const totalArea = item.width * item.height;
            const topArea = item.width * ((leftIntersect.y - item.y + (rightIntersect.y - item.y)) * 0.5);
            if (topArea < totalArea * 0.5) {
                if (leftIntersect.y > rightIntersect.y) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y - rerouteBuffer);
                return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y - rerouteBuffer);
            }
            if (leftIntersect.y < rightIntersect.y) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y2 + rerouteBuffer);
            return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y2 + rerouteBuffer);
        }
        if (rightIntersect.state === $21a54bda07acbf50$var$EState.POINT) {
            if (topIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y - rerouteBuffer);
            if (bottomIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y2 + rerouteBuffer);
        }
        const totalArea = item.height * item.width;
        const leftArea = item.height * ((topIntersect.x - item.x + (rightIntersect.x - item.x)) * 0.5);
        if (leftArea < totalArea * 0.5) {
            if (topIntersect.x > bottomIntersect.x) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y - rerouteBuffer);
            return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y2 + rerouteBuffer);
        }
        if (topIntersect.x < bottomIntersect.x) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y - rerouteBuffer);
        return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y2 + rerouteBuffer);
    }
    if (leftIntersect.state === $21a54bda07acbf50$var$EState.POINT) {
        if (topIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y2 + rerouteBuffer);
        if (bottomIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y - rerouteBuffer);
        const totalArea = item.height * item.width;
        const topArea = item.width * ((leftIntersect.y - item.y + (rightIntersect.y - item.y)) * 0.5);
        if (topArea < totalArea * 0.5) {
            if (leftIntersect.y > rightIntersect.y) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y2 + rerouteBuffer);
            return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y2 + rerouteBuffer);
        }
        if (leftIntersect.y < rightIntersect.y) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y - rerouteBuffer);
        return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y - rerouteBuffer);
    }
    if (rightIntersect.state === $21a54bda07acbf50$var$EState.POINT) {
        if (topIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y2 + rerouteBuffer);
        if (bottomIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y - rerouteBuffer);
    }
    const totalArea = item.height * item.width;
    const leftArea = item.height * ((topIntersect.x - item.x + (rightIntersect.x - item.x)) * 0.5);
    if (leftArea < totalArea * 0.5) {
        if (topIntersect.x > bottomIntersect.x) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y2 + rerouteBuffer);
        return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y - rerouteBuffer);
    }
    if (topIntersect.x < bottomIntersect.x) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y2 + rerouteBuffer);
    return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y - rerouteBuffer);
}
function $21a54bda07acbf50$var$canTakeNext(path, start, end, toleranceSquared) {
    const validEnd = path.closed ? end < path.length : end < path.length - 1;
    if (!validEnd) return false;
    const s = path.get(start);
    const e = path.get(end + 1);
    for(let index = start + 1; index <= end; index++){
        const p = path.get(index);
        const len = $21a54bda07acbf50$var$linePtSegDistSq(s.x, s.y, e.x, e.y, p.x, p.y);
        if (len > toleranceSquared) return false;
    }
    return true;
}
function $21a54bda07acbf50$var$shapeSimplifier(tolerance = 0.0) {
    return (path)=>{
        if (tolerance < 0 || path.length < 3) return path;
        const points = [];
        let start = 0;
        const toleranceSquared = tolerance * tolerance;
        while(start < path.length){
            let end = start + 1;
            while($21a54bda07acbf50$var$canTakeNext(path, start, end, toleranceSquared))end++;
            points.push(path.get(start));
            start = end;
        }
        return new $21a54bda07acbf50$export$e11c86b5a124f28(points);
    };
}
function $21a54bda07acbf50$var$basicFunction(i, t) {
    switch(i){
        case -2:
            return (((-t + 3.0) * t - 3.0) * t + 1.0) / 6.0;
        case -1:
            return ((3.0 * t - 6.0) * t * t + 4.0) / 6.0;
        case 0:
            return (((-3 * t + 3.0) * t + 3.0) * t + 1.0) / 6.0;
        case 1:
            return t * t * t / 6.0;
        default:
            throw new Error('unknown error');
    }
}
function $21a54bda07acbf50$var$bSplineShapeGenerator(granularity = 6.0) {
    const ORDER = 3;
    const START_INDEX = ORDER - 1;
    const REL_END = 1;
    const REL_START = REL_END - ORDER;
    function calcPoint(path, i, t) {
        let px = 0.0;
        let py = 0.0;
        for(let j = REL_START; j <= REL_END; j++){
            const p = path.get(i + j);
            const bf = $21a54bda07acbf50$var$basicFunction(j, t);
            px += bf * p.x;
            py += bf * p.y;
        }
        return {
            x: px,
            y: py
        };
    }
    return (path)=>{
        if (path.length < 3) return path;
        const res = [];
        const closed = path.closed;
        const count = path.length + ORDER - 1 + (closed ? 0 : 2);
        res.push(calcPoint(path, START_INDEX - (closed ? 0 : 2), 0));
        for(let ix = START_INDEX - (closed ? 0 : 2); ix < count; ix++)for(let k = 1; k <= granularity; k++)res.push(calcPoint(path, ix, k / granularity));
        return new $21a54bda07acbf50$export$e11c86b5a124f28(res);
    };
}
function $21a54bda07acbf50$var$samplePath(skip = 8) {
    return (path)=>{
        let actSkip = skip;
        let size = path.length;
        if (actSkip > 1) {
            size = Math.floor(path.length / actSkip);
            while(size < 3 && actSkip > 1){
                actSkip -= 1;
                size = Math.floor(path.length / actSkip);
            }
        }
        const finalHull = [];
        for(let i = 0, j = 0; j < size; j++, i += actSkip)finalHull.push(path.get(i));
        return new $21a54bda07acbf50$export$e11c86b5a124f28(finalHull);
    };
}
class $21a54bda07acbf50$export$e11c86b5a124f28 {
    constructor(points = [], closed = true){
        this.points = points;
        this.closed = closed;
    }
    get(index) {
        const i = index;
        const l = this.points.length;
        if (index < 0) return this.closed ? this.get(index + l) : this.points[0];
        else if (index >= l) return this.closed ? this.get(index - l) : this.points[l - 1];
        return this.points[i];
    }
    get length() {
        return this.points.length;
    }
    toString(roundToDigits = Infinity) {
        const points = this.points;
        if (points.length === 0) return '';
        const rounder = typeof roundToDigits === 'function' ? roundToDigits : $21a54bda07acbf50$var$round(roundToDigits);
        let r = 'M';
        for (const p of points)r += `${rounder(p.x)},${rounder(p.y)} L`;
        r = r.slice(0, -1);
        if (this.closed) r += ' Z';
        return r;
    }
    draw(ctx) {
        const points = this.points;
        if (points.length === 0) return;
        ctx.beginPath();
        ctx.moveTo(points[0].x, points[0].y);
        for (const p of points)ctx.lineTo(p.x, p.y);
        if (this.closed) ctx.closePath();
    }
    sample(skip) {
        return $21a54bda07acbf50$var$samplePath(skip)(this);
    }
    simplify(tolerance) {
        return $21a54bda07acbf50$var$shapeSimplifier(tolerance)(this);
    }
    bSplines(granularity) {
        return $21a54bda07acbf50$var$bSplineShapeGenerator(granularity)(this);
    }
    apply(transformer) {
        return transformer(this);
    }
    containsElements(members) {
        const bb = $21a54bda07acbf50$export$c845df1685d3e70f(this.points);
        if (!bb) return false;
        return members.every((member)=>{
            return bb.containsPt(member.cx, member.cy) && this.withinArea(member.cx, member.cy);
        });
    }
    withinArea(px, py) {
        if (this.length === 0) return false;
        let crossings = 0;
        const first = this.points[0];
        const line = new $21a54bda07acbf50$export$17d680238e50603e(first.x, first.y, first.x, first.y);
        for(let i = 1; i < this.points.length; i++){
            const cur = this.points[i];
            line.x1 = line.x2;
            line.y1 = line.y2;
            line.x2 = cur.x;
            line.y2 = cur.y;
            if (line.cuts(px, py)) crossings++;
        }
        line.x1 = line.x2;
        line.y1 = line.y2;
        line.x2 = first.x;
        line.y2 = first.y;
        if (line.cuts(px, py)) crossings++;
        return crossings % 2 === 1;
    }
}
class $21a54bda07acbf50$var$PointList {
    constructor(size = 0){
        this.count = 0;
        this.arr = [];
        this.set = new Set();
        this.arr.length = size;
    }
    add(p) {
        this.set.add(`${p.x}x${p.y}`);
        this.arr[this.count++] = p;
    }
    contains(p) {
        return this.set.has(`${p.x}x${p.y}`);
    }
    isFirst(p) {
        if (this.count === 0) return false;
        const o = this.arr[0];
        return o != null && o.x === p.x && o.y === p.y;
    }
    path() {
        return new $21a54bda07acbf50$export$e11c86b5a124f28(this.arr.slice(0, this.count));
    }
    clear() {
        this.set.clear();
        this.count = 0;
    }
    get(ix) {
        return this.arr[ix];
    }
    get length() {
        return this.count;
    }
}
const $21a54bda07acbf50$var$N = 0;
const $21a54bda07acbf50$var$S = 1;
const $21a54bda07acbf50$var$E = 2;
const $21a54bda07acbf50$var$W = 3;
function $21a54bda07acbf50$var$marchingSquares(potentialArea, threshold) {
    const estLength = (Math.floor(potentialArea.width) + Math.floor(potentialArea.height)) * 2;
    const contour = new $21a54bda07acbf50$var$PointList(estLength);
    function updateDir(x, y, dir, res) {
        const v = potentialArea.get(x, y);
        if (Number.isNaN(v)) return Number.NaN;
        if (v > threshold) return dir + res;
        return dir;
    }
    function getState(x, y) {
        let dir = $21a54bda07acbf50$var$N;
        dir = updateDir(x, y, dir, 1);
        dir = updateDir(x + 1, y, dir, 2);
        dir = updateDir(x, y + 1, dir, 4);
        dir = updateDir(x + 1, y + 1, dir, 8);
        if (Number.isNaN(dir)) return -1;
        return dir;
    }
    let direction = $21a54bda07acbf50$var$S;
    function doMarch(xPos, yPos) {
        let x = xPos;
        let y = yPos;
        let xPixel = potentialArea.invertScaleX(x);
        let yPixel = potentialArea.invertScaleY(y);
        for(let i = 0; i < potentialArea.width * potentialArea.height; i++){
            const p = {
                x: xPixel,
                y: yPixel
            };
            if (contour.contains(p)) {
                if (!contour.isFirst(p)) ;
                else return true;
            } else contour.add(p);
            const state = getState(x, y);
            switch(state){
                case -1:
                    return true;
                case 0:
                case 3:
                case 2:
                case 7:
                    direction = $21a54bda07acbf50$var$E;
                    break;
                case 12:
                case 14:
                case 4:
                    direction = $21a54bda07acbf50$var$W;
                    break;
                case 6:
                    direction = direction === $21a54bda07acbf50$var$N ? $21a54bda07acbf50$var$W : $21a54bda07acbf50$var$E;
                    break;
                case 1:
                case 13:
                case 5:
                    direction = $21a54bda07acbf50$var$N;
                    break;
                case 9:
                    direction = direction === $21a54bda07acbf50$var$E ? $21a54bda07acbf50$var$N : $21a54bda07acbf50$var$S;
                    break;
                case 10:
                case 8:
                case 11:
                    direction = $21a54bda07acbf50$var$S;
                    break;
                default:
                    console.warn('Marching squares invalid state: ' + state);
                    return true;
            }
            switch(direction){
                case $21a54bda07acbf50$var$N:
                    y--;
                    yPixel -= potentialArea.pixelGroup;
                    break;
                case $21a54bda07acbf50$var$S:
                    y++;
                    yPixel += potentialArea.pixelGroup;
                    break;
                case $21a54bda07acbf50$var$W:
                    x--;
                    xPixel -= potentialArea.pixelGroup;
                    break;
                case $21a54bda07acbf50$var$E:
                    x++;
                    xPixel += potentialArea.pixelGroup;
                    break;
                default:
                    console.warn('Marching squares invalid state: ' + state);
                    return true;
            }
        }
        return true;
    }
    for(let x = 0; x < potentialArea.width; x++)for(let y = 0; y < potentialArea.height; y++){
        if (potentialArea.get(x, y) <= threshold) continue;
        const state = getState(x, y);
        if (state < 0 || state === 15) continue;
        if (doMarch(x, y)) return contour.path();
    }
    return null;
}
const $21a54bda07acbf50$export$ba43bf67f3d48107 = {
    maxRoutingIterations: 100,
    maxMarchingIterations: 20,
    pixelGroup: 4,
    edgeR0: 10,
    edgeR1: 20,
    nodeR0: 15,
    nodeR1: 50,
    morphBuffer: 10,
    threshold: 1,
    memberInfluenceFactor: 1,
    edgeInfluenceFactor: 1,
    nonMemberInfluenceFactor: -0.8,
    virtualEdges: true
};
function $21a54bda07acbf50$var$isCircle(v) {
    return v != null && typeof v.radius === 'number';
}
function $21a54bda07acbf50$var$isEqual(a, b) {
    if ($21a54bda07acbf50$var$isCircle(a) !== $21a54bda07acbf50$var$isCircle(b)) return false;
    if ($21a54bda07acbf50$var$isCircle(a)) {
        const bc = b;
        return a.cx === bc.cx && a.cy === bc.cy && a.radius === bc.radius;
    }
    const br = b;
    return a.x === br.x && a.y === br.y && a.width === br.width && a.height === br.height;
}
var $21a54bda07acbf50$var$EDirty;
(function(EDirty) {
    EDirty[EDirty["MEMBERS"] = 0] = "MEMBERS";
    EDirty[EDirty["NON_MEMBERS"] = 1] = "NON_MEMBERS";
    EDirty[EDirty["EDGES"] = 2] = "EDGES";
})($21a54bda07acbf50$var$EDirty || ($21a54bda07acbf50$var$EDirty = {}));
class $21a54bda07acbf50$export$b0964bf07e78d5cb {
    constructor(options = {}){
        this.dirty = new Set();
        this.members = [];
        this.nonMembers = [];
        this.virtualEdges = [];
        this.edges = [];
        this.activeRegion = new $21a54bda07acbf50$export$4617fb02663045ef(0, 0, 0, 0);
        this.potentialArea = new $21a54bda07acbf50$export$ea1a111407f37557(1, 0, 0, 0, 0, 0, 0);
        this.o = Object.assign({}, $21a54bda07acbf50$export$ba43bf67f3d48107, options);
    }
    pushMember(...members) {
        if (members.length === 0) return;
        this.dirty.add($21a54bda07acbf50$var$EDirty.MEMBERS);
        for (const v of members)this.members.push({
            raw: v,
            obj: $21a54bda07acbf50$var$isCircle(v) ? $21a54bda07acbf50$export$c89a927ffc67e6fa.from(v) : $21a54bda07acbf50$export$4617fb02663045ef.from(v),
            area: null
        });
    }
    removeMember(member) {
        const index = this.members.findIndex((d)=>$21a54bda07acbf50$var$isEqual(d.raw, member));
        if (index < 0) return false;
        this.members.splice(index, 1);
        this.dirty.add($21a54bda07acbf50$var$EDirty.MEMBERS);
        return true;
    }
    removeNonMember(nonMember) {
        const index = this.nonMembers.findIndex((d)=>$21a54bda07acbf50$var$isEqual(d.raw, nonMember));
        if (index < 0) return false;
        this.nonMembers.splice(index, 1);
        this.dirty.add($21a54bda07acbf50$var$EDirty.NON_MEMBERS);
        return true;
    }
    removeEdge(edge) {
        const index = this.edges.findIndex((d)=>d.obj.equals(edge));
        if (index < 0) return false;
        this.edges.splice(index, 1);
        this.dirty.add($21a54bda07acbf50$var$EDirty.NON_MEMBERS);
        return true;
    }
    pushNonMember(...nonMembers) {
        if (nonMembers.length === 0) return;
        this.dirty.add($21a54bda07acbf50$var$EDirty.NON_MEMBERS);
        for (const v of nonMembers)this.nonMembers.push({
            raw: v,
            obj: $21a54bda07acbf50$var$isCircle(v) ? $21a54bda07acbf50$export$c89a927ffc67e6fa.from(v) : $21a54bda07acbf50$export$4617fb02663045ef.from(v),
            area: null
        });
    }
    pushEdge(...edges) {
        if (edges.length === 0) return;
        this.dirty.add($21a54bda07acbf50$var$EDirty.EDGES);
        for (const v of edges)this.edges.push({
            raw: v,
            obj: $21a54bda07acbf50$export$17d680238e50603e.from(v),
            area: null
        });
    }
    update() {
        const dirtyMembers = this.dirty.has($21a54bda07acbf50$var$EDirty.MEMBERS);
        const dirtyNonMembers = this.dirty.has($21a54bda07acbf50$var$EDirty.NON_MEMBERS);
        let dirtyEdges = this.dirty.has($21a54bda07acbf50$var$EDirty.EDGES);
        this.dirty.clear();
        const memberObjs = this.members.map((d)=>d.obj);
        if (this.o.virtualEdges && (dirtyMembers || dirtyNonMembers)) {
            const nonMembersAsRects = this.nonMembers.map((d)=>d.obj);
            const virtualEdges = $21a54bda07acbf50$export$adcb69fca15b3962(memberObjs, nonMembersAsRects, this.o.maxRoutingIterations, this.o.morphBuffer);
            const old = new Map(this.virtualEdges.map((e)=>[
                    e.obj.toString(),
                    e.area
                ]));
            this.virtualEdges = virtualEdges.map((e)=>{
                var _a;
                return {
                    raw: e,
                    obj: e,
                    area: (_a = old.get(e.toString())) !== null && _a !== void 0 ? _a : null
                };
            });
            dirtyEdges = true;
        }
        let activeRegionDirty = false;
        if (dirtyMembers || dirtyEdges) {
            const edgesObj = this.virtualEdges.concat(this.edges).map((e)=>e.obj);
            const bb = $21a54bda07acbf50$export$2ee2c9fb0417d5ac(memberObjs, edgesObj);
            const padding = Math.max(this.o.edgeR1, this.o.nodeR1) + this.o.morphBuffer;
            const activeRegion = $21a54bda07acbf50$export$4617fb02663045ef.from($21a54bda07acbf50$export$adf255e13b40f23f(bb, padding));
            if (!activeRegion.equals(this.activeRegion)) {
                activeRegionDirty = true;
                this.activeRegion = activeRegion;
            }
        }
        if (activeRegionDirty) {
            const potentialWidth = Math.ceil(this.activeRegion.width / this.o.pixelGroup);
            const potentialHeight = Math.ceil(this.activeRegion.height / this.o.pixelGroup);
            if (this.activeRegion.x !== this.potentialArea.pixelX || this.activeRegion.y !== this.potentialArea.pixelY) {
                this.potentialArea = $21a54bda07acbf50$export$ea1a111407f37557.fromPixelRegion(this.activeRegion, this.o.pixelGroup);
                this.members.forEach((m)=>m.area = null);
                this.nonMembers.forEach((m)=>m.area = null);
                this.edges.forEach((m)=>m.area = null);
                this.virtualEdges.forEach((m)=>m.area = null);
            } else if (potentialWidth !== this.potentialArea.width || potentialHeight !== this.potentialArea.height) this.potentialArea = $21a54bda07acbf50$export$ea1a111407f37557.fromPixelRegion(this.activeRegion, this.o.pixelGroup);
        }
        const existing = new Map();
        const addCache = (m)=>{
            if (m.area) {
                const key = `${m.obj.width}x${m.obj.height}x${m.obj instanceof $21a54bda07acbf50$export$4617fb02663045ef ? 'R' : 'C'}`;
                existing.set(key, m.area);
            }
        };
        const createOrAddCache = (m)=>{
            if (m.area) return;
            const key = `${m.obj.width}x${m.obj.height}x${m.obj instanceof $21a54bda07acbf50$export$4617fb02663045ef ? 'R' : 'C'}`;
            if (existing.has(key)) {
                const r = existing.get(key);
                m.area = this.potentialArea.copy(r, {
                    x: m.obj.x - this.o.nodeR1,
                    y: m.obj.y - this.o.nodeR1
                });
                return;
            }
            const r = m.obj instanceof $21a54bda07acbf50$export$4617fb02663045ef ? $21a54bda07acbf50$export$1f5241b260204fa9(m.obj, this.potentialArea, this.o.nodeR1) : $21a54bda07acbf50$export$88df63bd43ece0f0(m.obj, this.potentialArea, this.o.nodeR1);
            m.area = r;
            existing.set(key, r);
        };
        this.members.forEach(addCache);
        this.nonMembers.forEach(addCache);
        this.members.forEach(createOrAddCache);
        this.nonMembers.forEach((m)=>{
            if (!this.activeRegion.intersects(m.obj)) m.area = null;
            else createOrAddCache(m);
        });
        this.edges.forEach((edge)=>{
            if (!edge.area) edge.area = $21a54bda07acbf50$export$4a96817c3621429e(edge.obj, this.potentialArea, this.o.edgeR1);
        });
        this.virtualEdges.forEach((edge)=>{
            if (!edge.area) edge.area = $21a54bda07acbf50$export$4a96817c3621429e(edge.obj, this.potentialArea, this.o.edgeR1);
        });
    }
    drawMembers(ctx) {
        for (const member of this.members)member.obj.draw(ctx);
    }
    drawNonMembers(ctx) {
        for (const member of this.nonMembers)member.obj.draw(ctx);
    }
    drawEdges(ctx) {
        for (const edge of this.edges)edge.obj.draw(ctx);
    }
    drawPotentialArea(ctx, offset = true) {
        this.potentialArea.draw(ctx, offset);
    }
    compute() {
        if (this.members.length === 0) return new $21a54bda07acbf50$export$e11c86b5a124f28([]);
        if (this.dirty.size > 0) this.update();
        const { o: o, potentialArea: potentialArea } = this;
        const members = this.members.map((m)=>m.area);
        const edges = this.virtualEdges.concat(this.edges).map((d)=>d.area);
        const nonMembers = this.nonMembers.filter((d)=>d.area != null).map((d)=>d.area);
        const memberObjs = this.members.map((m)=>m.obj);
        return $21a54bda07acbf50$export$a7b1397aa533a84f(potentialArea, members, edges, nonMembers, (p)=>p.containsElements(memberObjs), o);
    }
}
function $21a54bda07acbf50$export$a7b1397aa533a84f(potentialArea, members, edges, nonMembers, validPath, options = {}) {
    const o = Object.assign({}, $21a54bda07acbf50$export$ba43bf67f3d48107, options);
    let threshold = o.threshold;
    let memberInfluenceFactor = o.memberInfluenceFactor;
    let edgeInfluenceFactor = o.edgeInfluenceFactor;
    let nonMemberInfluenceFactor = o.nonMemberInfluenceFactor;
    const nodeInfA = (o.nodeR0 - o.nodeR1) * (o.nodeR0 - o.nodeR1);
    const edgeInfA = (o.edgeR0 - o.edgeR1) * (o.edgeR0 - o.edgeR1);
    for(let iterations = 0; iterations < o.maxMarchingIterations; iterations++){
        potentialArea.clear();
        if (memberInfluenceFactor !== 0) {
            const f = memberInfluenceFactor / nodeInfA;
            for (const item of members)potentialArea.incArea(item, f);
        }
        if (edgeInfluenceFactor !== 0) {
            const f = edgeInfluenceFactor / edgeInfA;
            for (const area of edges)potentialArea.incArea(area, f);
        }
        if (nonMemberInfluenceFactor !== 0) {
            const f = nonMemberInfluenceFactor / nodeInfA;
            for (const area of nonMembers)potentialArea.incArea(area, f);
        }
        const contour = $21a54bda07acbf50$var$marchingSquares(potentialArea, threshold);
        if (contour && validPath(contour)) return contour;
        threshold *= 0.95;
        if (iterations <= o.maxMarchingIterations * 0.5) {
            memberInfluenceFactor *= 1.2;
            edgeInfluenceFactor *= 1.2;
        } else if (nonMemberInfluenceFactor !== 0 && nonMembers.length > 0) nonMemberInfluenceFactor *= 0.8;
        else break;
    }
    return new $21a54bda07acbf50$export$e11c86b5a124f28([]);
}
function $21a54bda07acbf50$export$2ee2c9fb0417d5ac(memberItems, edgeItems) {
    if (memberItems.length === 0) return new $21a54bda07acbf50$export$4617fb02663045ef(0, 0, 0, 0);
    const activeRegion = $21a54bda07acbf50$export$4617fb02663045ef.from(memberItems[0]);
    for (const m of memberItems)activeRegion.add(m);
    for (const l of edgeItems)activeRegion.add($21a54bda07acbf50$export$26fe0db1e56290ef(l));
    return activeRegion;
}
function $21a54bda07acbf50$export$cc913e7b2de70ad9(members, nonMembers = [], edges = [], options = {}) {
    if (members.length === 0) return new $21a54bda07acbf50$export$e11c86b5a124f28([]);
    const bb = new $21a54bda07acbf50$export$b0964bf07e78d5cb(options);
    bb.pushMember(...members);
    bb.pushNonMember(...nonMembers);
    bb.pushEdge(...edges);
    return bb.compute();
}


var $ac43bb23aa0a60e2$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $ac43bb23aa0a60e2$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $ac43bb23aa0a60e2$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $ac43bb23aa0a60e2$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $ac43bb23aa0a60e2$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $ac43bb23aa0a60e2$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $ac43bb23aa0a60e2$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $ac43bb23aa0a60e2$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $ac43bb23aa0a60e2$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $ac43bb23aa0a60e2$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $ac43bb23aa0a60e2$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ac43bb23aa0a60e2$var$root = $ac43bb23aa0a60e2$var$freeGlobal || $ac43bb23aa0a60e2$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $ac43bb23aa0a60e2$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ac43bb23aa0a60e2$var$objectToString = $ac43bb23aa0a60e2$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ac43bb23aa0a60e2$var$nativeMax = Math.max, $ac43bb23aa0a60e2$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $ac43bb23aa0a60e2$var$now = function() {
    return $ac43bb23aa0a60e2$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ac43bb23aa0a60e2$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($ac43bb23aa0a60e2$var$FUNC_ERROR_TEXT);
    wait = $ac43bb23aa0a60e2$var$toNumber(wait) || 0;
    if ($ac43bb23aa0a60e2$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $ac43bb23aa0a60e2$var$nativeMax($ac43bb23aa0a60e2$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $ac43bb23aa0a60e2$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $ac43bb23aa0a60e2$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($ac43bb23aa0a60e2$var$now());
    }
    function debounced() {
        var time = $ac43bb23aa0a60e2$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $ac43bb23aa0a60e2$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($ac43bb23aa0a60e2$var$FUNC_ERROR_TEXT);
    if ($ac43bb23aa0a60e2$var$isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $ac43bb23aa0a60e2$var$debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ac43bb23aa0a60e2$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ac43bb23aa0a60e2$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $ac43bb23aa0a60e2$var$isSymbol(value) {
    return typeof value == 'symbol' || $ac43bb23aa0a60e2$var$isObjectLike(value) && $ac43bb23aa0a60e2$var$objectToString.call(value) == $ac43bb23aa0a60e2$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $ac43bb23aa0a60e2$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($ac43bb23aa0a60e2$var$isSymbol(value)) return $ac43bb23aa0a60e2$var$NAN;
    if ($ac43bb23aa0a60e2$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $ac43bb23aa0a60e2$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($ac43bb23aa0a60e2$var$reTrim, '');
    var isBinary = $ac43bb23aa0a60e2$var$reIsBinary.test(value);
    return isBinary || $ac43bb23aa0a60e2$var$reIsOctal.test(value) ? $ac43bb23aa0a60e2$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $ac43bb23aa0a60e2$var$reIsBadHex.test(value) ? $ac43bb23aa0a60e2$var$NAN : +value;
}
$ac43bb23aa0a60e2$exports = $ac43bb23aa0a60e2$var$throttle;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $1ffa4796a7b2001e$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $1ffa4796a7b2001e$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $1ffa4796a7b2001e$var$_BubbleSetPath_activeArea, $1ffa4796a7b2001e$var$_BubbleSetPath_potentialArea, $1ffa4796a7b2001e$var$_BubbleSetPath_options, $1ffa4796a7b2001e$var$_BubbleSetPath_virtualEdgeAreas, $1ffa4796a7b2001e$var$_BubbleSetPath_throttledUpdate, $1ffa4796a7b2001e$var$_BubbleSetPath_adder, $1ffa4796a7b2001e$var$_BubbleSetPath_remover, $1ffa4796a7b2001e$var$_BubbleSetPath_adapter;
function $1ffa4796a7b2001e$var$round2(v) {
    return Math.round(v * 100) / 100;
}
const $1ffa4796a7b2001e$var$SCRATCH_KEY = 'bubbleSets';
const $1ffa4796a7b2001e$var$circularBase = [
    'ellipse',
    'diamond',
    'diamond',
    'pentagon',
    'diamond',
    'hexagon',
    'heptagon',
    'octagon',
    'star'
];
const $1ffa4796a7b2001e$var$circular = new Set($1ffa4796a7b2001e$var$circularBase.concat($1ffa4796a7b2001e$var$circularBase.map((v)=>`round-${v}`)));
function $1ffa4796a7b2001e$var$isCircleShape(shape) {
    return $1ffa4796a7b2001e$var$circular.has(shape);
}
function $1ffa4796a7b2001e$var$toNodeKey(data) {
    return `${$1ffa4796a7b2001e$var$round2(data.shape.width)}x${$1ffa4796a7b2001e$var$round2(data.shape.height)}x${data.isCircle}`;
}
function $1ffa4796a7b2001e$var$toEdgeKey(line) {
    return `${$1ffa4796a7b2001e$var$round2(line.x1)}x${$1ffa4796a7b2001e$var$round2(line.y1)}x${$1ffa4796a7b2001e$var$round2(line.x2)}x${$1ffa4796a7b2001e$var$round2(line.y2)}`;
}
function $1ffa4796a7b2001e$var$linesEquals(a, b) {
    return a.length === b.length && a.every((ai, i)=>$1ffa4796a7b2001e$var$toEdgeKey(ai) === $1ffa4796a7b2001e$var$toEdgeKey(b[i]));
}
function $1ffa4796a7b2001e$var$createShape(isCircle, bb) {
    return isCircle ? new (0, $21a54bda07acbf50$export$c89a927ffc67e6fa)(bb.x1 + bb.w / 2, bb.y1 + bb.h / 2, Math.max(bb.w, bb.h) / 2) : new (0, $21a54bda07acbf50$export$4617fb02663045ef)(bb.x1, bb.y1, bb.w, bb.h);
}
class $1ffa4796a7b2001e$export$62bbf24f96012683 {
    constructor(adapter, node, nodes, edges, avoidNodes, options = {}){
        this.node = node;
        this.nodes = nodes;
        this.edges = edges;
        this.avoidNodes = avoidNodes;
        $1ffa4796a7b2001e$var$_BubbleSetPath_activeArea.set(this, {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        });
        $1ffa4796a7b2001e$var$_BubbleSetPath_potentialArea.set(this, new (0, $21a54bda07acbf50$export$ea1a111407f37557)(4, 0, 0, 0, 0, 0, 0));
        $1ffa4796a7b2001e$var$_BubbleSetPath_options.set(this, void 0);
        $1ffa4796a7b2001e$var$_BubbleSetPath_virtualEdgeAreas.set(this, new Map());
        $1ffa4796a7b2001e$var$_BubbleSetPath_throttledUpdate.set(this, void 0);
        $1ffa4796a7b2001e$var$_BubbleSetPath_adder.set(this, void 0);
        $1ffa4796a7b2001e$var$_BubbleSetPath_remover.set(this, void 0);
        $1ffa4796a7b2001e$var$_BubbleSetPath_adapter.set(this, void 0);
        this.update = (forceUpdate = false)=>{
            const bb = this.nodes.union(this.edges).boundingBox($1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f"));
            let potentialAreaDirty = false;
            const padding = Math.max($1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").edgeR1, $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").nodeR1) + $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").morphBuffer;
            const nextPotentialBB = {
                x: bb.x1 - padding,
                y: bb.y1 - padding,
                width: bb.w + padding * 2,
                height: bb.h + padding * 2
            };
            if (forceUpdate || $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_activeArea, "f").x !== nextPotentialBB.x || $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_activeArea, "f").y !== nextPotentialBB.y) {
                potentialAreaDirty = true;
                $1ffa4796a7b2001e$var$__classPrivateFieldSet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_potentialArea, (0, $21a54bda07acbf50$export$ea1a111407f37557).fromPixelRegion(nextPotentialBB, $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").pixelGroup), "f");
            } else if ($1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_activeArea, "f").width !== nextPotentialBB.width || $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_activeArea, "f").height !== nextPotentialBB.height) $1ffa4796a7b2001e$var$__classPrivateFieldSet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_potentialArea, (0, $21a54bda07acbf50$export$ea1a111407f37557).fromPixelRegion(nextPotentialBB, $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").pixelGroup), "f");
            $1ffa4796a7b2001e$var$__classPrivateFieldSet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_activeArea, nextPotentialBB, "f");
            const potentialArea = $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_potentialArea, "f");
            const cache = new Map();
            if (!potentialAreaDirty) this.nodes.forEach((n)=>{
                var _a;
                const data = (_a = n.scratch($1ffa4796a7b2001e$var$SCRATCH_KEY)) !== null && _a !== void 0 ? _a : null;
                if (data && data.area) cache.set($1ffa4796a7b2001e$var$toNodeKey(data), data.area);
            });
            let updateEdges = false;
            const updateNodeData = (n)=>{
                var _a;
                const nodeBB = n.boundingBox($1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f"));
                let data = (_a = n.scratch($1ffa4796a7b2001e$var$SCRATCH_KEY)) !== null && _a !== void 0 ? _a : null;
                const isCircle = $1ffa4796a7b2001e$var$isCircleShape(n.style('shape'));
                if (!data || potentialAreaDirty || !data.area || data.isCircle !== isCircle || data.shape.width !== nodeBB.w || data.shape.height !== nodeBB.h) {
                    updateEdges = true;
                    data = {
                        isCircle: isCircle,
                        shape: $1ffa4796a7b2001e$var$createShape(isCircle, nodeBB)
                    };
                    const key = $1ffa4796a7b2001e$var$toNodeKey(data);
                    const cached = cache.get(key);
                    if (cached != null) data.area = $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_potentialArea, "f").copy(cached, {
                        x: nodeBB.x1 - $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").nodeR1,
                        y: nodeBB.y1 - $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").nodeR1
                    });
                    else {
                        data.area = data.isCircle ? (0, $21a54bda07acbf50$export$88df63bd43ece0f0)(data.shape, potentialArea, $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").nodeR1) : (0, $21a54bda07acbf50$export$1f5241b260204fa9)(data.shape, potentialArea, $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").nodeR1);
                        cache.set(key, data.area);
                    }
                    n.scratch($1ffa4796a7b2001e$var$SCRATCH_KEY, data);
                } else if (data.shape.x !== nodeBB.x1 || data.shape.y !== nodeBB.y1) {
                    updateEdges = true;
                    data.shape = $1ffa4796a7b2001e$var$createShape(isCircle, nodeBB);
                    data.area = $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_potentialArea, "f").copy(data.area, {
                        x: nodeBB.x1 - $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").nodeR1,
                        y: nodeBB.y1 - $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").nodeR1
                    });
                }
                return data;
            };
            const members = this.nodes.map(updateNodeData);
            const nonMembers = this.avoidNodes.map(updateNodeData);
            const edgeCache = new Map();
            if (!potentialAreaDirty) {
                $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_virtualEdgeAreas, "f").forEach((value, key)=>edgeCache.set(key, value));
                this.edges.forEach((n)=>{
                    var _a;
                    const data = (_a = n.scratch($1ffa4796a7b2001e$var$SCRATCH_KEY)) !== null && _a !== void 0 ? _a : null;
                    if (data && data.lines) data.lines.forEach((line, i)=>{
                        const area = data.areas[i];
                        if (area) cache.set($1ffa4796a7b2001e$var$toEdgeKey(line), area);
                    });
                });
            }
            const updateEdgeArea = (line)=>{
                const key = $1ffa4796a7b2001e$var$toEdgeKey(line);
                const cached = edgeCache.get(key);
                if (cached != null) return cached;
                const r = (0, $21a54bda07acbf50$export$4a96817c3621429e)(line, $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_potentialArea, "f"), $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").edgeR1);
                edgeCache.set(key, r);
                return r;
            };
            const edges = [];
            this.edges.forEach((e)=>{
                var _a, _b;
                const ps = ((_a = e.segmentPoints()) !== null && _a !== void 0 ? _a : [
                    e.sourceEndpoint(),
                    e.targetEndpoint()
                ]).map((d)=>({
                        ...d
                    }));
                if (ps.length === 0) return;
                const lines = ps.slice(1).map((next, i)=>{
                    const prev = ps[i];
                    return (0, $21a54bda07acbf50$export$17d680238e50603e).from({
                        x1: prev.x,
                        y1: prev.y,
                        x2: next.x,
                        y2: next.y
                    });
                });
                let data = (_b = e.scratch($1ffa4796a7b2001e$var$SCRATCH_KEY)) !== null && _b !== void 0 ? _b : null;
                if (!data || potentialAreaDirty || !$1ffa4796a7b2001e$var$linesEquals(data.lines, lines)) {
                    data = {
                        lines: lines,
                        areas: lines.map(updateEdgeArea)
                    };
                    e.scratch($1ffa4796a7b2001e$var$SCRATCH_KEY, data);
                }
                edges.push(...data.areas);
            });
            const memberShapes = members.map((d)=>d.shape);
            if ($1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").virtualEdges) {
                if (updateEdges) {
                    const nonMembersShapes = nonMembers.map((d)=>d.shape);
                    const lines = (0, $21a54bda07acbf50$export$adcb69fca15b3962)(memberShapes, nonMembersShapes, $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").maxRoutingIterations, $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").morphBuffer);
                    $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_virtualEdgeAreas, "f").clear();
                    lines.forEach((line)=>{
                        const area = updateEdgeArea(line);
                        const key = $1ffa4796a7b2001e$var$toEdgeKey(line);
                        $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_virtualEdgeAreas, "f").set(key, area);
                        edges.push(area);
                    });
                } else $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_virtualEdgeAreas, "f").forEach((area)=>edges.push(area));
            }
            const memberAreas = members.filter((d)=>d.area != null).map((d)=>d.area);
            const nonMemberAreas = nonMembers.filter((d)=>d.area != null).map((d)=>d.area);
            const path = (0, $21a54bda07acbf50$export$a7b1397aa533a84f)(potentialArea, memberAreas, edges, nonMemberAreas, (p)=>p.containsElements(memberShapes), $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f"));
            this.node.setAttribute('d', path.sample(8).simplify(0).bSplines().simplify(0).toString(2));
        };
        $1ffa4796a7b2001e$var$__classPrivateFieldSet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_adapter, adapter, "f");
        $1ffa4796a7b2001e$var$__classPrivateFieldSet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, {
            ...(0, $21a54bda07acbf50$export$ba43bf67f3d48107),
            style: {
                stroke: 'black',
                fill: 'black',
                fillOpacity: '0.25'
            },
            className: '',
            throttle: 100,
            virtualEdges: false,
            interactive: false,
            includeLabels: false,
            includeMainLabels: false,
            includeOverlays: false,
            includeSourceLabels: false,
            includeTargetLabels: false,
            ...options
        }, "f");
        Object.assign(this.node.style, $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").style);
        if ($1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").className) this.node.classList.add($1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").className);
        if ($1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").interactive) this.node.addEventListener('dblclick', ()=>{
            this.nodes.select();
        });
        $1ffa4796a7b2001e$var$__classPrivateFieldSet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_throttledUpdate, (0, (/*@__PURE__*/$parcel$interopDefault($ac43bb23aa0a60e2$exports)))(()=>{
            this.update();
        }, $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_options, "f").throttle), "f");
        $1ffa4796a7b2001e$var$__classPrivateFieldSet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_adder, (e)=>{
            e.target.on('add', $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_adder, "f"));
            e.target.on('remove', $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_remover, "f"));
            $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_throttledUpdate, "f").call(this);
        }, "f");
        $1ffa4796a7b2001e$var$__classPrivateFieldSet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_remover, (e)=>{
            e.target.off('add', undefined, $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_adder, "f"));
            e.target.off('remove', undefined, $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_remover, "f"));
            $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_throttledUpdate, "f").call(this);
        }, "f");
        nodes.on('position', $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_throttledUpdate, "f"));
        nodes.on('add', $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_adder, "f"));
        nodes.on('remove', $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_remover, "f"));
        avoidNodes.on('position', $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_throttledUpdate, "f"));
        avoidNodes.on('add', $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_adder, "f"));
        avoidNodes.on('remove', $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_remover, "f"));
        edges.on('move position', $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_throttledUpdate, "f"));
        edges.on('add', $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_adder, "f"));
        edges.on('remove', $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_remover, "f"));
    }
    remove() {
        for (const set of [
            this.nodes,
            this.edges,
            this.avoidNodes
        ]){
            set.off('move position', undefined, $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_throttledUpdate, "f"));
            set.off('add', undefined, $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_adder, "f"));
            set.off('remove', undefined, $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_remover, "f"));
            set.forEach((d)=>{
                d.scratch($1ffa4796a7b2001e$var$SCRATCH_KEY, {});
            });
        }
        this.node.remove();
        return $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetPath_adapter, "f").remove(this);
    }
}
$1ffa4796a7b2001e$var$_BubbleSetPath_activeArea = new WeakMap(), $1ffa4796a7b2001e$var$_BubbleSetPath_potentialArea = new WeakMap(), $1ffa4796a7b2001e$var$_BubbleSetPath_options = new WeakMap(), $1ffa4796a7b2001e$var$_BubbleSetPath_virtualEdgeAreas = new WeakMap(), $1ffa4796a7b2001e$var$_BubbleSetPath_throttledUpdate = new WeakMap(), $1ffa4796a7b2001e$var$_BubbleSetPath_adder = new WeakMap(), $1ffa4796a7b2001e$var$_BubbleSetPath_remover = new WeakMap(), $1ffa4796a7b2001e$var$_BubbleSetPath_adapter = new WeakMap();
var $1ffa4796a7b2001e$var$_BubbleSetsPlugin_layers, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_adapter, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_cy, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_options;
const $1ffa4796a7b2001e$var$SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
class $1ffa4796a7b2001e$export$ce9c03bfcdb010d {
    constructor(currentCy, options = {}){
        var _a;
        $1ffa4796a7b2001e$var$_BubbleSetsPlugin_layers.set(this, []);
        $1ffa4796a7b2001e$var$_BubbleSetsPlugin_adapter.set(this, {
            remove: (path)=>{
                const index = $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_layers, "f").indexOf(path);
                if (index < 0) return false;
                $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_layers, "f").splice(index, 1);
                return true;
            }
        });
        $1ffa4796a7b2001e$var$_BubbleSetsPlugin_cy.set(this, void 0);
        $1ffa4796a7b2001e$var$_BubbleSetsPlugin_options.set(this, void 0);
        $1ffa4796a7b2001e$var$__classPrivateFieldSet(this, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_cy, currentCy, "f");
        $1ffa4796a7b2001e$var$__classPrivateFieldSet(this, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_options, options, "f");
        this.layer = (_a = options.layer) !== null && _a !== void 0 ? _a : (0, $cb9df2af88d35554$export$7be255094ccdc533)(currentCy).nodeLayer.insertBefore('svg');
    }
    destroy() {
        for (const path of $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_layers, "f"))path.remove();
        this.layer.remove();
    }
    addPath(nodes, edges = $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_cy, "f").collection(), avoidNodes = $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_cy, "f").collection(), options = {}) {
        const node = this.layer.node.ownerDocument.createElementNS($1ffa4796a7b2001e$var$SVG_NAMESPACE, 'path');
        this.layer.node.appendChild(node);
        const path = new $1ffa4796a7b2001e$export$62bbf24f96012683($1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_adapter, "f"), node, nodes, edges !== null && edges !== void 0 ? edges : $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_cy, "f").collection(), avoidNodes !== null && avoidNodes !== void 0 ? avoidNodes : $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_cy, "f").collection(), {
            ...$1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_options, "f"),
            ...options
        });
        $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_layers, "f").push(path);
        path.update();
        return path;
    }
    getPaths() {
        return $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_layers, "f").slice();
    }
    removePath(path) {
        const i = $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_layers, "f").indexOf(path);
        if (i < 0) return false;
        return path.remove();
    }
    update(forceUpdate = false) {
        $1ffa4796a7b2001e$var$__classPrivateFieldGet(this, $1ffa4796a7b2001e$var$_BubbleSetsPlugin_layers, "f").forEach((p)=>p.update(forceUpdate));
    }
}
$1ffa4796a7b2001e$var$_BubbleSetsPlugin_layers = new WeakMap(), $1ffa4796a7b2001e$var$_BubbleSetsPlugin_adapter = new WeakMap(), $1ffa4796a7b2001e$var$_BubbleSetsPlugin_cy = new WeakMap(), $1ffa4796a7b2001e$var$_BubbleSetsPlugin_options = new WeakMap();
function $1ffa4796a7b2001e$export$4168cbebe461eccd(options = {}) {
    return new $1ffa4796a7b2001e$export$ce9c03bfcdb010d(this, options);
}
function $1ffa4796a7b2001e$export$2e2bcd8739ae039(cytoscape) {
    cytoscape('core', 'bubbleSets', $1ffa4796a7b2001e$export$4168cbebe461eccd);
}
function $1ffa4796a7b2001e$var$hasCytoscape(obj) {
    return typeof obj.cytoscape === 'function';
}
if ($1ffa4796a7b2001e$var$hasCytoscape(window)) $1ffa4796a7b2001e$export$2e2bcd8739ae039(window.cytoscape);


var $4eae0a726ab50395$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $4eae0a726ab50395$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $4eae0a726ab50395$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $4eae0a726ab50395$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});


var $fe356312f17a2f78$exports = {};
//     (c) 2012-2018 Airbnb, Inc.
//
//     polyglot.js may be freely distributed under the terms of the BSD
//     license. For all licensing information, details, and documentation:
//     http://airbnb.github.com/polyglot.js
//
//
// Polyglot.js is an I18n helper library written in JavaScript, made to
// work both in the browser and in Node. It provides a simple solution for
// interpolation and pluralization, based off of Airbnb's
// experience adding I18n functionality to its Backbone.js and Node apps.
//
// Polylglot is agnostic to your translation backend. It doesn't perform any
// translation; it simply gives you a way to manage translated phrases from
// your client- or server-side JavaScript application.
//
'use strict';
var $2a23000ff22f4da6$exports = {};
'use strict';
var $16343f2546a69e4c$exports = {};
'use strict';
var $5d69935f2747da8d$exports = {};
'use strict';
var $5d69935f2747da8d$var$slice = Array.prototype.slice;

var $z1gio = parcelRequire("z1gio");
var $5d69935f2747da8d$var$origKeys = Object.keys;

var $5d69935f2747da8d$var$keysShim = $5d69935f2747da8d$var$origKeys ? function keys(o) {
    return $5d69935f2747da8d$var$origKeys(o);
} : (parcelRequire("4nFCC"));
var $5d69935f2747da8d$var$originalKeys = Object.keys;
$5d69935f2747da8d$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($z1gio(object)) return $5d69935f2747da8d$var$originalKeys($5d69935f2747da8d$var$slice.call(object));
            return $5d69935f2747da8d$var$originalKeys(object);
        };
    } else Object.keys = $5d69935f2747da8d$var$keysShim;
    return Object.keys || $5d69935f2747da8d$var$keysShim;
};
$5d69935f2747da8d$exports = $5d69935f2747da8d$var$keysShim;


var $16343f2546a69e4c$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $16343f2546a69e4c$var$toStr = Object.prototype.toString;
var $16343f2546a69e4c$var$concat = Array.prototype.concat;
var $421050b39f25e605$exports = {};
'use strict';

var $jAy3M = parcelRequire("jAy3M");
var $43bb4ccdc6568bcf$exports = {};
'use strict';
/** @type {import('./syntax')} */ $43bb4ccdc6568bcf$exports = SyntaxError;


var $aaa4be976b2d27a3$exports = {};
'use strict';
/** @type {import('./type')} */ $aaa4be976b2d27a3$exports = TypeError;


var $a2d7d74e83f6c3ed$exports = {};
'use strict';
var $985031ced66f900d$exports = {};
'use strict';
/** @type {import('./gOPD')} */ $985031ced66f900d$exports = Object.getOwnPropertyDescriptor;


var $a2d7d74e83f6c3ed$require$$gOPD = $985031ced66f900d$exports;
if ($a2d7d74e83f6c3ed$require$$gOPD) try {
    $a2d7d74e83f6c3ed$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$require$$gOPD = null;
}
$a2d7d74e83f6c3ed$exports = $a2d7d74e83f6c3ed$require$$gOPD;


/** @type {import('.')} */ $421050b39f25e605$exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $aaa4be976b2d27a3$exports('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $aaa4be976b2d27a3$exports('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $aaa4be976b2d27a3$exports('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $aaa4be976b2d27a3$exports('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $aaa4be976b2d27a3$exports('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $aaa4be976b2d27a3$exports('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$a2d7d74e83f6c3ed$exports && $a2d7d74e83f6c3ed$exports(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $43bb4ccdc6568bcf$exports('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};


var $16343f2546a69e4c$var$isFunction = function(fn) {
    return typeof fn === 'function' && $16343f2546a69e4c$var$toStr.call(fn) === '[object Function]';
};

var $16343f2546a69e4c$var$supportsDescriptors = (parcelRequire("i16wS"))();
var $16343f2546a69e4c$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$16343f2546a69e4c$var$isFunction(predicate) || !predicate()) return;
    }
    if ($16343f2546a69e4c$var$supportsDescriptors) $421050b39f25e605$exports(object, name, value, true);
    else $421050b39f25e605$exports(object, name, value);
};
var $16343f2546a69e4c$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $5d69935f2747da8d$exports(map);
    if ($16343f2546a69e4c$var$hasSymbols) props = $16343f2546a69e4c$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$16343f2546a69e4c$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$16343f2546a69e4c$var$defineProperties.supportsDescriptors = !!$16343f2546a69e4c$var$supportsDescriptors;
$16343f2546a69e4c$exports = $16343f2546a69e4c$var$defineProperties;


var $9546dce5bd4976bd$exports = {};
'use strict';
var $071b317808876eb5$exports = {};
'use strict';
var $1258b452ecf218a1$exports = {};
'use strict';
var $1258b452ecf218a1$var$undefined1;
var $68f77cfee0d91ea0$exports = {};
'use strict';
/** @type {import('.')} */ $68f77cfee0d91ea0$exports = Object;


var $41038844aec6eaa2$exports = {};
'use strict';
/** @type {import('.')} */ $41038844aec6eaa2$exports = Error;


var $cd6d4b204c89f4f4$exports = {};
'use strict';
/** @type {import('./eval')} */ $cd6d4b204c89f4f4$exports = EvalError;


var $72e6a4e026a755bb$exports = {};
'use strict';
/** @type {import('./range')} */ $72e6a4e026a755bb$exports = RangeError;


var $1e478fcc3e34e216$exports = {};
'use strict';
/** @type {import('./ref')} */ $1e478fcc3e34e216$exports = ReferenceError;




var $cde0c3ef12944098$exports = {};
'use strict';
/** @type {import('./uri')} */ $cde0c3ef12944098$exports = URIError;


var $829c6ad74b893335$exports = {};
'use strict';
/** @type {import('./abs')} */ $829c6ad74b893335$exports = Math.abs;


var $a0167fb8027efc6c$exports = {};
'use strict';
/** @type {import('./floor')} */ $a0167fb8027efc6c$exports = Math.floor;


var $59437e5dc9fc2c61$exports = {};
'use strict';
/** @type {import('./max')} */ $59437e5dc9fc2c61$exports = Math.max;


var $328f401f1e19f003$exports = {};
'use strict';
/** @type {import('./min')} */ $328f401f1e19f003$exports = Math.min;


var $8560e7c6d4e34f2f$exports = {};
'use strict';
/** @type {import('./pow')} */ $8560e7c6d4e34f2f$exports = Math.pow;


var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};


var $jAy3M = parcelRequire("jAy3M");
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $aaa4be976b2d27a3$exports();
};
var $1258b452ecf218a1$var$ThrowTypeError = $a2d7d74e83f6c3ed$exports ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $a2d7d74e83f6c3ed$exports(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();
var $55566fcac2c38fe4$exports = {};
'use strict';
var $e3cb45ba87de93fe$exports = {};
'use strict';
var $c0378745895dc03c$exports = {};
'use strict';
var $efd80b1d7fbb2850$exports = {};
'use strict';
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = '[object Function]';
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
$efd80b1d7fbb2850$exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $efd80b1d7fbb2850$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};


$c0378745895dc03c$exports = Function.prototype.bind || $efd80b1d7fbb2850$exports;



var $6da1bf1c46eb4156$exports = {};
'use strict';
/** @type {import('./functionCall')} */ $6da1bf1c46eb4156$exports = Function.prototype.call;


var $2e4f98706b21e7c9$exports = {};
'use strict';

var $0658b6e5d2101996$exports = {};
'use strict';
/** @type {import('./functionApply')} */ $0658b6e5d2101996$exports = Function.prototype.apply;



var $623e642332342b72$exports = {};
'use strict';
/** @type {import('./reflectApply')} */ $623e642332342b72$exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/** @type {import('./actualApply')} */ $2e4f98706b21e7c9$exports = $623e642332342b72$exports || $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, $0658b6e5d2101996$exports);


/** @type {import('.')} */ $e3cb45ba87de93fe$exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $aaa4be976b2d27a3$exports('a function is required');
    return $2e4f98706b21e7c9$exports($c0378745895dc03c$exports, $6da1bf1c46eb4156$exports, args);
};



var $55566fcac2c38fe4$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $55566fcac2c38fe4$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $55566fcac2c38fe4$var$desc = !!$55566fcac2c38fe4$var$hasProtoAccessor && $a2d7d74e83f6c3ed$exports && $a2d7d74e83f6c3ed$exports(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $55566fcac2c38fe4$var$$Object = Object;
var $55566fcac2c38fe4$var$$getPrototypeOf = $55566fcac2c38fe4$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ $55566fcac2c38fe4$exports = $55566fcac2c38fe4$var$desc && typeof $55566fcac2c38fe4$var$desc.get === 'function' ? $e3cb45ba87de93fe$exports([
    $55566fcac2c38fe4$var$desc.get
]) : typeof $55566fcac2c38fe4$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $55566fcac2c38fe4$var$$getPrototypeOf(value == null ? value : $55566fcac2c38fe4$var$$Object(value));
} : false;


var $1258b452ecf218a1$var$getProto = typeof Reflect === 'function' && Reflect.getPrototypeOf || $68f77cfee0d91ea0$exports.getPrototypeOf || $55566fcac2c38fe4$exports;


var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === 'undefined' || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGenerator%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncIteratorPrototype%': $1258b452ecf218a1$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $41038844aec6eaa2$exports,
    '%eval%': eval,
    '%EvalError%': $cd6d4b204c89f4f4$exports,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $1258b452ecf218a1$var$$Function,
    '%GeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $68f77cfee0d91ea0$exports,
    '%Object.getOwnPropertyDescriptor%': $a2d7d74e83f6c3ed$exports,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $72e6a4e026a755bb$exports,
    '%ReferenceError%': $1e478fcc3e34e216$exports,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $43bb4ccdc6568bcf$exports,
    '%ThrowTypeError%': $1258b452ecf218a1$var$ThrowTypeError,
    '%TypedArray%': $1258b452ecf218a1$var$TypedArray,
    '%TypeError%': $aaa4be976b2d27a3$exports,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $cde0c3ef12944098$exports,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $6da1bf1c46eb4156$exports,
    '%Function.prototype.apply%': $0658b6e5d2101996$exports,
    '%Object.defineProperty%': $jAy3M,
    '%Math.abs%': $829c6ad74b893335$exports,
    '%Math.floor%': $a0167fb8027efc6c$exports,
    '%Math.max%': $59437e5dc9fc2c61$exports,
    '%Math.min%': $328f401f1e19f003$exports,
    '%Math.pow%': $8560e7c6d4e34f2f$exports
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS['%Error.prototype%'] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $30dbf79dbae6c725$exports = {};
'use strict';
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

/** @type {import('.')} */ $30dbf79dbae6c725$exports = $c0378745895dc03c$exports.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);


var $1258b452ecf218a1$var$$concat = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $c0378745895dc03c$exports.call($0658b6e5d2101996$exports, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $43bb4ccdc6568bcf$exports('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $43bb4ccdc6568bcf$exports('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($30dbf79dbae6c725$exports($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($30dbf79dbae6c725$exports($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $aaa4be976b2d27a3$exports('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $43bb4ccdc6568bcf$exports('intrinsic ' + name + ' does not exist!');
};
$1258b452ecf218a1$exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $aaa4be976b2d27a3$exports('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $aaa4be976b2d27a3$exports('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $43bb4ccdc6568bcf$exports('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $43bb4ccdc6568bcf$exports('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($30dbf79dbae6c725$exports($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $aaa4be976b2d27a3$exports('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($a2d7d74e83f6c3ed$exports && i + 1 >= parts.length) {
                var desc = $a2d7d74e83f6c3ed$exports(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $30dbf79dbae6c725$exports(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};




var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();


var $071b317808876eb5$var$$floor = $1258b452ecf218a1$exports('%Math.floor%');
/** @type {import('.')} */ $071b317808876eb5$exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $aaa4be976b2d27a3$exports('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $aaa4be976b2d27a3$exports('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $a2d7d74e83f6c3ed$exports) {
        var desc = $a2d7d74e83f6c3ed$exports(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $421050b39f25e605$exports(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $421050b39f25e605$exports(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};



var $jAy3M = parcelRequire("jAy3M");

var $116f9b7fd8015fd6$exports = {};
'use strict';



/** @type {import('./applyBind')} */ $116f9b7fd8015fd6$exports = function applyBind() {
    return $2e4f98706b21e7c9$exports($c0378745895dc03c$exports, $0658b6e5d2101996$exports, arguments);
};


$9546dce5bd4976bd$exports = function callBind(originalFunction) {
    var func = $e3cb45ba87de93fe$exports(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $071b317808876eb5$exports(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($jAy3M) $jAy3M($9546dce5bd4976bd$exports, 'apply', {
    value: $116f9b7fd8015fd6$exports
});
else $9546dce5bd4976bd$exports.apply = $116f9b7fd8015fd6$exports;


var $a8dccd4d65287606$exports = {};
'use strict';
var $b7c880cc61b4726a$exports = {};
'use strict';

/** @type {import('./RequireObjectCoercible')} */ $b7c880cc61b4726a$exports = function RequireObjectCoercible(value) {
    if (value == null) throw new $aaa4be976b2d27a3$exports(arguments.length > 0 && arguments[1] || 'Cannot call method on ' + value);
    return value;
};


var $d12f4cdcd6b10506$exports = {};
'use strict';


var $d12f4cdcd6b10506$var$$indexOf = $9546dce5bd4976bd$exports($1258b452ecf218a1$exports('String.prototype.indexOf'));
$d12f4cdcd6b10506$exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1258b452ecf218a1$exports(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $d12f4cdcd6b10506$var$$indexOf(name, '.prototype.') > -1) return $9546dce5bd4976bd$exports(intrinsic);
    return intrinsic;
};


var $a8dccd4d65287606$var$$isEnumerable = $d12f4cdcd6b10506$exports('Object.prototype.propertyIsEnumerable');
var $a8dccd4d65287606$var$$push = $d12f4cdcd6b10506$exports('Array.prototype.push');
$a8dccd4d65287606$exports = function entries(O) {
    var obj = $b7c880cc61b4726a$exports(O);
    var entrys = [];
    for(var key in obj)if ($a8dccd4d65287606$var$$isEnumerable(obj, key)) $a8dccd4d65287606$var$$push(entrys, [
        key,
        obj[key]
    ]);
    return entrys;
};


var $f622650c2a2738b9$exports = {};
'use strict';

$f622650c2a2738b9$exports = function getPolyfill() {
    return typeof Object.entries === 'function' ? Object.entries : $a8dccd4d65287606$exports;
};


var $d7493869527a2aaf$exports = {};
'use strict';


$d7493869527a2aaf$exports = function shimEntries() {
    var polyfill = $f622650c2a2738b9$exports();
    $16343f2546a69e4c$exports(Object, {
        entries: polyfill
    }, {
        entries: function testEntries() {
            return Object.entries !== polyfill;
        }
    });
    return polyfill;
};


var $2a23000ff22f4da6$var$polyfill = $9546dce5bd4976bd$exports($f622650c2a2738b9$exports(), Object);
$16343f2546a69e4c$exports($2a23000ff22f4da6$var$polyfill, {
    getPolyfill: $f622650c2a2738b9$exports,
    implementation: $a8dccd4d65287606$exports,
    shim: $d7493869527a2aaf$exports
});
$2a23000ff22f4da6$exports = $2a23000ff22f4da6$var$polyfill;


var $ebfc6adce9fdacf8$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = false;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ebfc6adce9fdacf8$exports = $ebfc6adce9fdacf8$var$warning;



var $fe356312f17a2f78$var$warn = function warn(message) {
    $ebfc6adce9fdacf8$exports(false, message);
};
var $fe356312f17a2f78$var$defaultReplace = String.prototype.replace;
var $fe356312f17a2f78$var$split = String.prototype.split;
// #### Pluralization methods
// The string that separates the different phrase possibilities.
var $fe356312f17a2f78$var$delimiter = '||||';
var $fe356312f17a2f78$var$russianPluralGroups = function(n) {
    var lastTwo = n % 100;
    var end = lastTwo % 10;
    if (lastTwo !== 11 && end === 1) return 0;
    if (2 <= end && end <= 4 && !(lastTwo >= 12 && lastTwo <= 14)) return 1;
    return 2;
};
var $fe356312f17a2f78$var$defaultPluralRules = {
    // Mapping from pluralization group plural logic.
    pluralTypes: {
        arabic: function(n) {
            // http://www.arabeyes.org/Plural_Forms
            if (n < 3) return n;
            var lastTwo = n % 100;
            if (lastTwo >= 3 && lastTwo <= 10) return 3;
            return lastTwo >= 11 ? 4 : 5;
        },
        bosnian_serbian: $fe356312f17a2f78$var$russianPluralGroups,
        chinese: function() {
            return 0;
        },
        croatian: $fe356312f17a2f78$var$russianPluralGroups,
        french: function(n) {
            return n >= 2 ? 1 : 0;
        },
        german: function(n) {
            return n !== 1 ? 1 : 0;
        },
        russian: $fe356312f17a2f78$var$russianPluralGroups,
        lithuanian: function(n) {
            if (n % 10 === 1 && n % 100 !== 11) return 0;
            return n % 10 >= 2 && n % 10 <= 9 && (n % 100 < 11 || n % 100 > 19) ? 1 : 2;
        },
        czech: function(n) {
            if (n === 1) return 0;
            return n >= 2 && n <= 4 ? 1 : 2;
        },
        polish: function(n) {
            if (n === 1) return 0;
            var end = n % 10;
            return 2 <= end && end <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
        },
        icelandic: function(n) {
            return n % 10 !== 1 || n % 100 === 11 ? 1 : 0;
        },
        slovenian: function(n) {
            var lastTwo = n % 100;
            if (lastTwo === 1) return 0;
            if (lastTwo === 2) return 1;
            if (lastTwo === 3 || lastTwo === 4) return 2;
            return 3;
        },
        romanian: function(n) {
            if (n === 1) return 0;
            var lastTwo = n % 100;
            if (n === 0 || lastTwo >= 2 && lastTwo <= 19) return 1;
            return 2;
        },
        ukrainian: $fe356312f17a2f78$var$russianPluralGroups
    },
    // Mapping from pluralization group to individual language codes/locales.
    // Will look up based on exact match, if not found and it's a locale will parse the locale
    // for language code, and if that does not exist will default to 'en'
    pluralTypeToLanguages: {
        arabic: [
            'ar'
        ],
        bosnian_serbian: [
            'bs-Latn-BA',
            'bs-Cyrl-BA',
            'srl-RS',
            'sr-RS'
        ],
        chinese: [
            'id',
            'id-ID',
            'ja',
            'ko',
            'ko-KR',
            'lo',
            'ms',
            'th',
            'th-TH',
            'zh'
        ],
        croatian: [
            'hr',
            'hr-HR'
        ],
        german: [
            'fa',
            'da',
            'de',
            'en',
            'es',
            'fi',
            'el',
            'he',
            'hi-IN',
            'hu',
            'hu-HU',
            'it',
            'nl',
            'no',
            'pt',
            'sv',
            'tr'
        ],
        french: [
            'fr',
            'tl',
            'pt-br'
        ],
        russian: [
            'ru',
            'ru-RU'
        ],
        lithuanian: [
            'lt'
        ],
        czech: [
            'cs',
            'cs-CZ',
            'sk'
        ],
        polish: [
            'pl'
        ],
        icelandic: [
            'is',
            'mk'
        ],
        slovenian: [
            'sl-SL'
        ],
        romanian: [
            'ro'
        ],
        ukrainian: [
            'uk',
            'ua'
        ]
    }
};
function $fe356312f17a2f78$var$langToTypeMap(mapping) {
    var ret = {};
    var mappingEntries = $2a23000ff22f4da6$exports(mapping);
    for(var i = 0; i < mappingEntries.length; i += 1){
        var type = mappingEntries[i][0];
        var langs = mappingEntries[i][1];
        for(var j = 0; j < langs.length; j += 1)ret[langs[j]] = type;
    }
    return ret;
}
function $fe356312f17a2f78$var$pluralTypeName(pluralRules, locale) {
    var langToPluralType = $fe356312f17a2f78$var$langToTypeMap(pluralRules.pluralTypeToLanguages);
    return langToPluralType[locale] || langToPluralType[$fe356312f17a2f78$var$split.call(locale, /-/, 1)[0]] || langToPluralType.en;
}
function $fe356312f17a2f78$var$pluralTypeIndex(pluralRules, pluralType, count) {
    return pluralRules.pluralTypes[pluralType](count);
}
function $fe356312f17a2f78$var$createMemoizedPluralTypeNameSelector() {
    var localePluralTypeStorage = {};
    return function(pluralRules, locale) {
        var pluralType = localePluralTypeStorage[locale];
        if (pluralType && !pluralRules.pluralTypes[pluralType]) {
            pluralType = null;
            localePluralTypeStorage[locale] = pluralType;
        }
        if (!pluralType) {
            pluralType = $fe356312f17a2f78$var$pluralTypeName(pluralRules, locale);
            if (pluralType) localePluralTypeStorage[locale] = pluralType;
        }
        return pluralType;
    };
}
function $fe356312f17a2f78$var$escape(token) {
    return token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function $fe356312f17a2f78$var$constructTokenRegex(opts) {
    var prefix = opts && opts.prefix || '%{';
    var suffix = opts && opts.suffix || '}';
    if (prefix === $fe356312f17a2f78$var$delimiter || suffix === $fe356312f17a2f78$var$delimiter) throw new RangeError('"' + $fe356312f17a2f78$var$delimiter + '" token is reserved for pluralization');
    return new RegExp($fe356312f17a2f78$var$escape(prefix) + '(.*?)' + $fe356312f17a2f78$var$escape(suffix), 'g');
}
var $fe356312f17a2f78$var$memoizedPluralTypeName = $fe356312f17a2f78$var$createMemoizedPluralTypeNameSelector();
var $fe356312f17a2f78$var$defaultTokenRegex = /%\{(.*?)\}/g;
// ### transformPhrase(phrase, substitutions, locale)
//
// Takes a phrase string and transforms it by choosing the correct
// plural form and interpolating it.
//
//     transformPhrase('Hello, %{name}!', {name: 'Spike'});
//     // "Hello, Spike!"
//
// The correct plural form is selected if substitutions.smart_count
// is set. You can pass in a number instead of an Object as `substitutions`
// as a shortcut for `smart_count`.
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 1}, 'en');
//     // "1 new message"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 2}, 'en');
//     // "2 new messages"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', 5, 'en');
//     // "5 new messages"
//
// You should pass in a third argument, the locale, to specify the correct plural type.
// It defaults to `'en'` with 2 plural forms.
function $fe356312f17a2f78$var$transformPhrase(phrase, substitutions, locale, tokenRegex, pluralRules, replaceImplementation) {
    if (typeof phrase !== 'string') throw new TypeError('Polyglot.transformPhrase expects argument #1 to be string');
    if (substitutions == null) return phrase;
    var result = phrase;
    var interpolationRegex = tokenRegex || $fe356312f17a2f78$var$defaultTokenRegex;
    var replace = replaceImplementation || $fe356312f17a2f78$var$defaultReplace;
    // allow number as a pluralization shortcut
    var options = typeof substitutions === 'number' ? {
        smart_count: substitutions
    } : substitutions;
    // Select plural form: based on a phrase text that contains `n`
    // plural forms separated by `delimiter`, a `locale`, and a `substitutions.smart_count`,
    // choose the correct plural form. This is only done if `count` is set.
    if (options.smart_count != null && phrase) {
        var pluralRulesOrDefault = pluralRules || $fe356312f17a2f78$var$defaultPluralRules;
        var texts = $fe356312f17a2f78$var$split.call(phrase, $fe356312f17a2f78$var$delimiter);
        var bestLocale = locale || 'en';
        var pluralType = $fe356312f17a2f78$var$memoizedPluralTypeName(pluralRulesOrDefault, bestLocale);
        var pluralTypeWithCount = $fe356312f17a2f78$var$pluralTypeIndex(pluralRulesOrDefault, pluralType, options.smart_count);
        result = $fe356312f17a2f78$var$defaultReplace.call(texts[pluralTypeWithCount] || texts[0], /^[^\S]*|[^\S]*$/g, '');
    }
    // Interpolate: Creates a `RegExp` object for each interpolation placeholder.
    result = replace.call(result, interpolationRegex, function(expression, argument) {
        if (!$30dbf79dbae6c725$exports(options, argument) || options[argument] == null) return expression;
        return options[argument];
    });
    return result;
}
// ### Polyglot class constructor
function $fe356312f17a2f78$var$Polyglot(options) {
    var opts = options || {};
    this.phrases = {};
    this.extend(opts.phrases || {});
    this.currentLocale = opts.locale || 'en';
    var allowMissing = opts.allowMissing ? $fe356312f17a2f78$var$transformPhrase : null;
    this.onMissingKey = typeof opts.onMissingKey === 'function' ? opts.onMissingKey : allowMissing;
    this.warn = opts.warn || $fe356312f17a2f78$var$warn;
    this.replaceImplementation = opts.replace || $fe356312f17a2f78$var$defaultReplace;
    this.tokenRegex = $fe356312f17a2f78$var$constructTokenRegex(opts.interpolation);
    this.pluralRules = opts.pluralRules || $fe356312f17a2f78$var$defaultPluralRules;
}
// ### polyglot.locale([locale])
//
// Get or set locale. Internally, Polyglot only uses locale for pluralization.
$fe356312f17a2f78$var$Polyglot.prototype.locale = function(newLocale) {
    if (newLocale) this.currentLocale = newLocale;
    return this.currentLocale;
};
// ### polyglot.extend(phrases)
//
// Use `extend` to tell Polyglot how to translate a given key.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The key can be any string.  Feel free to call `extend` multiple times;
// it will override any phrases with the same key, but leave existing phrases
// untouched.
//
// It is also possible to pass nested phrase objects, which get flattened
// into an object with the nested keys concatenated using dot notation.
//
//     polyglot.extend({
//       "nav": {
//         "hello": "Hello",
//         "hello_name": "Hello, %{name}",
//         "sidebar": {
//           "welcome": "Welcome"
//         }
//       }
//     });
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}',
//     //   'nav.sidebar.welcome': 'Welcome'
//     // }
//
// `extend` accepts an optional second argument, `prefix`, which can be used
// to prefix every key in the phrases object with some string, using dot
// notation.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     }, "nav");
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}'
//     // }
//
// This feature is used internally to support nested phrase objects.
$fe356312f17a2f78$var$Polyglot.prototype.extend = function(morePhrases, prefix) {
    var phraseEntries = $2a23000ff22f4da6$exports(morePhrases || {});
    for(var i = 0; i < phraseEntries.length; i += 1){
        var key = phraseEntries[i][0];
        var phrase = phraseEntries[i][1];
        var prefixedKey = prefix ? prefix + '.' + key : key;
        if (typeof phrase === 'object') this.extend(phrase, prefixedKey);
        else this.phrases[prefixedKey] = phrase;
    }
};
// ### polyglot.unset(phrases)
// Use `unset` to selectively remove keys from a polyglot instance.
//
//     polyglot.unset("some_key");
//     polyglot.unset({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The unset method can take either a string (for the key), or an object hash with
// the keys that you would like to unset.
$fe356312f17a2f78$var$Polyglot.prototype.unset = function(morePhrases, prefix) {
    if (typeof morePhrases === 'string') delete this.phrases[morePhrases];
    else {
        var phraseEntries = $2a23000ff22f4da6$exports(morePhrases || {});
        for(var i = 0; i < phraseEntries.length; i += 1){
            var key = phraseEntries[i][0];
            var phrase = phraseEntries[i][1];
            var prefixedKey = prefix ? prefix + '.' + key : key;
            if (typeof phrase === 'object') this.unset(phrase, prefixedKey);
            else delete this.phrases[prefixedKey];
        }
    }
};
// ### polyglot.clear()
//
// Clears all phrases. Useful for special cases, such as freeing
// up memory if you have lots of phrases but no longer need to
// perform any translation. Also used internally by `replace`.
$fe356312f17a2f78$var$Polyglot.prototype.clear = function() {
    this.phrases = {};
};
// ### polyglot.replace(phrases)
//
// Completely replace the existing phrases with a new set of phrases.
// Normally, just use `extend` to add more phrases, but under certain
// circumstances, you may want to make sure no old phrases are lying around.
$fe356312f17a2f78$var$Polyglot.prototype.replace = function(newPhrases) {
    this.clear();
    this.extend(newPhrases);
};
// ### polyglot.t(key, options)
//
// The most-used method. Provide a key, and `t` will return the
// phrase.
//
//     polyglot.t("hello");
//     => "Hello"
//
// The phrase value is provided first by a call to `polyglot.extend()` or
// `polyglot.replace()`.
//
// Pass in an object as the second argument to perform interpolation.
//
//     polyglot.t("hello_name", {name: "Spike"});
//     => "Hello, Spike"
//
// If you like, you can provide a default value in case the phrase is missing.
// Use the special option key "_" to specify a default.
//
//     polyglot.t("i_like_to_write_in_language", {
//       _: "I like to write in %{language}.",
//       language: "JavaScript"
//     });
//     => "I like to write in JavaScript."
//
$fe356312f17a2f78$var$Polyglot.prototype.t = function(key, options) {
    var phrase, result;
    var opts = options == null ? {} : options;
    if (typeof this.phrases[key] === 'string') phrase = this.phrases[key];
    else if (typeof opts._ === 'string') phrase = opts._;
    else if (this.onMissingKey) {
        var onMissingKey = this.onMissingKey;
        result = onMissingKey(key, opts, this.currentLocale, this.tokenRegex, this.pluralRules, this.replaceImplementation);
    } else {
        this.warn('Missing translation for key: "' + key + '"');
        result = key;
    }
    if (typeof phrase === 'string') result = $fe356312f17a2f78$var$transformPhrase(phrase, opts, this.currentLocale, this.tokenRegex, this.pluralRules, this.replaceImplementation);
    return result;
};
// ### polyglot.has(key)
//
// Check if polyglot has a translation for given key
$fe356312f17a2f78$var$Polyglot.prototype.has = function(key) {
    return $30dbf79dbae6c725$exports(this.phrases, key);
};
// export transformPhrase
$fe356312f17a2f78$var$Polyglot.transformPhrase = function transform(phrase, substitutions, locale) {
    return $fe356312f17a2f78$var$transformPhrase(phrase, substitutions, locale);
};
$fe356312f17a2f78$exports = $fe356312f17a2f78$var$Polyglot;



var $65AEs = parcelRequire("65AEs");

/*
	Based on Leaflet Browser
*/ const $e8c72613a0980cab$export$1a85a5b39245481e = navigator ? navigator.userAgent.toLowerCase() : 'no-user-agent-specified';
const $e8c72613a0980cab$var$doc = document ? document.documentElement : null;
const $e8c72613a0980cab$var$phantomjs = $e8c72613a0980cab$export$1a85a5b39245481e ? $e8c72613a0980cab$export$1a85a5b39245481e.indexOf("phantom") !== -1 : false;
const $e8c72613a0980cab$export$bd1b734a238eb944 = window && 'ActiveXObject' in window;
const $e8c72613a0980cab$export$92addaefea3caa7c = Boolean($e8c72613a0980cab$export$bd1b734a238eb944 && $e8c72613a0980cab$export$1a85a5b39245481e.match(/MSIE 9/i));
const $e8c72613a0980cab$export$3c0b92ede381abef = $e8c72613a0980cab$export$bd1b734a238eb944 && document && !document.addEventListener;
const $e8c72613a0980cab$export$db07bc05b2fb9b73 = $e8c72613a0980cab$export$1a85a5b39245481e.indexOf('webkit') !== -1;
const $e8c72613a0980cab$export$49aa0afaaf9db9cb = $e8c72613a0980cab$export$1a85a5b39245481e.indexOf('android') !== -1;
const $e8c72613a0980cab$export$d23f6c3e87b0cce3 = $e8c72613a0980cab$export$1a85a5b39245481e.search('android [23]') !== -1;
const $e8c72613a0980cab$export$1c4e7a9c31a6c071 = window ? typeof window.orientation !== 'undefined' : false;
const $e8c72613a0980cab$export$3d1ad85c5b21ed70 = navigator && window ? navigator.msPointerEnabled && navigator.msMaxTouchPoints && !window.PointerEvent : false;
const $e8c72613a0980cab$export$b7fd2c2937973304 = navigator && window ? window.PointerEvent && navigator.pointerEnabled && navigator.maxTouchPoints : $e8c72613a0980cab$export$3d1ad85c5b21ed70;
const $e8c72613a0980cab$export$685242cf827c72f4 = window ? window.opera : false;
const $e8c72613a0980cab$export$249f5a6e3b293e58 = $e8c72613a0980cab$export$1a85a5b39245481e.indexOf("gecko") !== -1 && !$e8c72613a0980cab$export$db07bc05b2fb9b73 && !$e8c72613a0980cab$export$685242cf827c72f4 && !$e8c72613a0980cab$export$bd1b734a238eb944;
const $e8c72613a0980cab$export$bbe03eaf052676c9 = $e8c72613a0980cab$export$1a85a5b39245481e.indexOf("gecko") !== -1 && !$e8c72613a0980cab$export$db07bc05b2fb9b73 && !$e8c72613a0980cab$export$685242cf827c72f4 && !$e8c72613a0980cab$export$bd1b734a238eb944;
const $e8c72613a0980cab$export$7b60a2159daa9614 = $e8c72613a0980cab$export$1a85a5b39245481e.indexOf("chrome") !== -1;
const $e8c72613a0980cab$export$7adf1fd9692ce935 = $e8c72613a0980cab$export$1a85a5b39245481e.indexOf("edge/") !== -1;
const $e8c72613a0980cab$export$3a7c8bdb9fa3589c = $e8c72613a0980cab$var$doc ? $e8c72613a0980cab$export$bd1b734a238eb944 && 'transition' in $e8c72613a0980cab$var$doc.style : false;
const $e8c72613a0980cab$export$df12890f2851f320 = window ? 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !$e8c72613a0980cab$export$d23f6c3e87b0cce3 : false;
const $e8c72613a0980cab$export$18851e61b50d4046 = $e8c72613a0980cab$var$doc ? 'MozPerspective' in $e8c72613a0980cab$var$doc.style : false;
const $e8c72613a0980cab$export$2a5618840adef055 = $e8c72613a0980cab$var$doc ? 'OTransition' in $e8c72613a0980cab$var$doc.style : false;
const $e8c72613a0980cab$export$800c96928bd487f0 = window && !window.L_DISABLE_3D && ($e8c72613a0980cab$export$3a7c8bdb9fa3589c || $e8c72613a0980cab$export$df12890f2851f320 || $e8c72613a0980cab$export$18851e61b50d4046 || $e8c72613a0980cab$export$2a5618840adef055) && !$e8c72613a0980cab$var$phantomjs;
const $e8c72613a0980cab$export$a718ee2c7901cb14 = $e8c72613a0980cab$export$1c4e7a9c31a6c071 && $e8c72613a0980cab$export$db07bc05b2fb9b73;
const $e8c72613a0980cab$export$c87447041849bfeb = $e8c72613a0980cab$export$1c4e7a9c31a6c071 && $e8c72613a0980cab$export$df12890f2851f320;
const $e8c72613a0980cab$export$5774a020122b704b = $e8c72613a0980cab$export$1c4e7a9c31a6c071 && window.opera;
let $e8c72613a0980cab$export$a80bdb7a98464c7b = window ? 'devicePixelRatio' in window && window.devicePixelRatio > 1 : false;
if (!$e8c72613a0980cab$export$a80bdb7a98464c7b && window && 'matchMedia' in window) {
    let media_matches = window.matchMedia('(min-resolution:144dpi)');
    $e8c72613a0980cab$export$a80bdb7a98464c7b = media_matches && media_matches.matches;
}
const $e8c72613a0980cab$export$d0b7ea69ab6056df = window && !window.L_NO_TOUCH && !$e8c72613a0980cab$var$phantomjs && ($e8c72613a0980cab$export$b7fd2c2937973304 || 'ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch);
function $e8c72613a0980cab$export$b363cb15cbb91a1a() {
    var w = window.innerWidth, h = window.innerHeight, _orientation = "portrait";
    if (w > h) _orientation = "landscape";
    window.orientation;
    return _orientation;
}


function $9eb7ee258fcc7829$export$3988ae62b71be9a3(id) {
    return typeof id === 'string' ? document.getElementById(id) : id;
}
function $9eb7ee258fcc7829$var$getByClass(id) {
    if (id) return document.getElementsByClassName(id);
}
function $9eb7ee258fcc7829$export$185802fd694ee1f5(tagName, className, container) {
    var el = document.createElement(tagName);
    el.className = className;
    if (container) container.appendChild(el);
    return el;
}
function $9eb7ee258fcc7829$export$9b6d6ca62970729f(className, container) {
    var el = $9eb7ee258fcc7829$export$185802fd694ee1f5('button', className, container);
    el.type = 'button';
    return el;
}
function $9eb7ee258fcc7829$var$createText(content, container) {
    var el = document.createTextNode(content);
    if (container) container.appendChild(el);
    return el;
}
function $9eb7ee258fcc7829$var$getTranslateString(point) {
    return $9eb7ee258fcc7829$var$TRANSLATE_OPEN + point.x + 'px,' + point.y + 'px' + $9eb7ee258fcc7829$var$TRANSLATE_CLOSE;
}
function $9eb7ee258fcc7829$var$setPosition(el, point) {
    el._tl_pos = point;
    if ($e8c72613a0980cab$export$df12890f2851f320) {
        el.style[$9eb7ee258fcc7829$var$TRANSFORM] = $9eb7ee258fcc7829$var$getTranslateString(point);
        if ($e8c72613a0980cab$export$49aa0afaaf9db9cb) {
            el.style['-webkit-perspective'] = '1000';
            el.style['-webkit-backface-visibility'] = 'hidden';
        }
    } else {
        el.style.left = point.x + 'px';
        el.style.top = point.y + 'px';
    }
}
function $9eb7ee258fcc7829$export$1690e12b840569b9(el) {
    var pos = {
        x: 0,
        y: 0
    };
    while(el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)){
        pos.x += el.offsetLeft // - el.scrollLeft;
        ;
        pos.y += el.offsetTop // - el.scrollTop;
        ;
        el = el.offsetParent;
    }
    return pos;
}
function $9eb7ee258fcc7829$var$testProp(props) {
    var style = document.documentElement.style;
    for(var i = 0; i < props.length; i++){
        if (props[i] in style) return props[i];
    }
    return false;
}
let $9eb7ee258fcc7829$var$TRANSITION = $9eb7ee258fcc7829$var$testProp([
    'transition',
    'webkitTransition',
    'OTransition',
    'MozTransition',
    'msTransition'
]);
let $9eb7ee258fcc7829$var$TRANSFORM = $9eb7ee258fcc7829$var$testProp([
    'transformProperty',
    'WebkitTransform',
    'OTransform',
    'MozTransform',
    'msTransform'
]);
let $9eb7ee258fcc7829$var$TRANSLATE_OPEN = 'translate' + ($e8c72613a0980cab$export$df12890f2851f320 ? '3d(' : '(');
let $9eb7ee258fcc7829$var$TRANSLATE_CLOSE = $e8c72613a0980cab$export$df12890f2851f320 ? ',0)' : ')';


/* Timeline Error class */ class $07909642145031f1$export$2e2bcd8739ae039 extends Error {
    constructor(message_key, detail){
        super();
        this.name = 'TLError';
        this.message = message_key || 'error';
        this.message_key = this.message;
        this.detail = detail || '';
    }
}


const $ea7d21fd242a7c44$var$css_named_colors = {
    "aliceblue": "#f0f8ff",
    "antiquewhite": "#faebd7",
    "aqua": "#00ffff",
    "aquamarine": "#7fffd4",
    "azure": "#f0ffff",
    "beige": "#f5f5dc",
    "bisque": "#ffe4c4",
    "black": "#000000",
    "blanchedalmond": "#ffebcd",
    "blue": "#0000ff",
    "blueviolet": "#8a2be2",
    "brown": "#a52a2a",
    "burlywood": "#deb887",
    "cadetblue": "#5f9ea0",
    "chartreuse": "#7fff00",
    "chocolate": "#d2691e",
    "coral": "#ff7f50",
    "cornflowerblue": "#6495ed",
    "cornsilk": "#fff8dc",
    "crimson": "#dc143c",
    "cyan": "#00ffff",
    "darkblue": "#00008b",
    "darkcyan": "#008b8b",
    "darkgoldenrod": "#b8860b",
    "darkgray": "#a9a9a9",
    "darkgreen": "#006400",
    "darkkhaki": "#bdb76b",
    "darkmagenta": "#8b008b",
    "darkolivegreen": "#556b2f",
    "darkorange": "#ff8c00",
    "darkorchid": "#9932cc",
    "darkred": "#8b0000",
    "darksalmon": "#e9967a",
    "darkseagreen": "#8fbc8f",
    "darkslateblue": "#483d8b",
    "darkslategray": "#2f4f4f",
    "darkturquoise": "#00ced1",
    "darkviolet": "#9400d3",
    "deeppink": "#ff1493",
    "deepskyblue": "#00bfff",
    "dimgray": "#696969",
    "dodgerblue": "#1e90ff",
    "firebrick": "#b22222",
    "floralwhite": "#fffaf0",
    "forestgreen": "#228b22",
    "fuchsia": "#ff00ff",
    "gainsboro": "#dcdcdc",
    "ghostwhite": "#f8f8ff",
    "gold": "#ffd700",
    "goldenrod": "#daa520",
    "gray": "#808080",
    "green": "#008000",
    "greenyellow": "#adff2f",
    "honeydew": "#f0fff0",
    "hotpink": "#ff69b4",
    "indianred": "#cd5c5c",
    "indigo": "#4b0082",
    "ivory": "#fffff0",
    "khaki": "#f0e68c",
    "lavender": "#e6e6fa",
    "lavenderblush": "#fff0f5",
    "lawngreen": "#7cfc00",
    "lemonchiffon": "#fffacd",
    "lightblue": "#add8e6",
    "lightcoral": "#f08080",
    "lightcyan": "#e0ffff",
    "lightgoldenrodyellow": "#fafad2",
    "lightgray": "#d3d3d3",
    "lightgreen": "#90ee90",
    "lightpink": "#ffb6c1",
    "lightsalmon": "#ffa07a",
    "lightseagreen": "#20b2aa",
    "lightskyblue": "#87cefa",
    "lightslategray": "#778899",
    "lightsteelblue": "#b0c4de",
    "lightyellow": "#ffffe0",
    "lime": "#00ff00",
    "limegreen": "#32cd32",
    "linen": "#faf0e6",
    "magenta": "#ff00ff",
    "maroon": "#800000",
    "mediumaquamarine": "#66cdaa",
    "mediumblue": "#0000cd",
    "mediumorchid": "#ba55d3",
    "mediumpurple": "#9370db",
    "mediumseagreen": "#3cb371",
    "mediumslateblue": "#7b68ee",
    "mediumspringgreen": "#00fa9a",
    "mediumturquoise": "#48d1cc",
    "mediumvioletred": "#c71585",
    "midnightblue": "#191970",
    "mintcream": "#f5fffa",
    "mistyrose": "#ffe4e1",
    "moccasin": "#ffe4b5",
    "navajowhite": "#ffdead",
    "navy": "#000080",
    "oldlace": "#fdf5e6",
    "olive": "#808000",
    "olivedrab": "#6b8e23",
    "orange": "#ffa500",
    "orangered": "#ff4500",
    "orchid": "#da70d6",
    "palegoldenrod": "#eee8aa",
    "palegreen": "#98fb98",
    "paleturquoise": "#afeeee",
    "palevioletred": "#db7093",
    "papayawhip": "#ffefd5",
    "peachpuff": "#ffdab9",
    "peru": "#cd853f",
    "pink": "#ffc0cb",
    "plum": "#dda0dd",
    "powderblue": "#b0e0e6",
    "purple": "#800080",
    "rebeccapurple": "#663399",
    "red": "#ff0000",
    "rosybrown": "#bc8f8f",
    "royalblue": "#4169e1",
    "saddlebrown": "#8b4513",
    "salmon": "#fa8072",
    "sandybrown": "#f4a460",
    "seagreen": "#2e8b57",
    "seashell": "#fff5ee",
    "sienna": "#a0522d",
    "silver": "#c0c0c0",
    "skyblue": "#87ceeb",
    "slateblue": "#6a5acd",
    "slategray": "#708090",
    "snow": "#fffafa",
    "springgreen": "#00ff7f",
    "steelblue": "#4682b4",
    "tan": "#d2b48c",
    "teal": "#008080",
    "thistle": "#d8bfd8",
    "tomato": "#ff6347",
    "turquoise": "#40e0d0",
    "violet": "#ee82ee",
    "wheat": "#f5deb3",
    "white": "#ffffff",
    "whitesmoke": "#f5f5f5",
    "yellow": "#ffff00",
    "yellowgreen": "#9acd32"
};
function $ea7d21fd242a7c44$var$intToHexString(i) {
    return $ea7d21fd242a7c44$export$5d04458e2a6c373e(parseInt(i, 10).toString(16));
}
function $ea7d21fd242a7c44$export$5a544e13ad4e1fa5(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    if ($ea7d21fd242a7c44$var$css_named_colors[hex.toLowerCase()]) hex = $ea7d21fd242a7c44$var$css_named_colors[hex.toLowerCase()];
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
function $ea7d21fd242a7c44$export$34d09c4a771c46ef(rgb) {
    var r, g, b;
    if (typeof rgb == 'object') {
        r = rgb.r;
        g = rgb.g;
        b = rgb.b;
    } else if (typeof rgb.match == 'function') {
        var parts = rgb.match(/^rgb\((\d+),(\d+),(\d+)\)$/);
        if (parts) {
            r = parts[1];
            g = parts[2];
            b = parts[3];
        }
    }
    if (isNaN(r) || isNaN(b) || isNaN(g)) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_rgb_err");
    return "#" + $ea7d21fd242a7c44$var$intToHexString(r) + $ea7d21fd242a7c44$var$intToHexString(g) + $ea7d21fd242a7c44$var$intToHexString(b);
}
function $ea7d21fd242a7c44$export$696bf4df45a0ddde(data_main, data_to_merge) {
    var x;
    for(x in data_to_merge)if (Object.prototype.hasOwnProperty.call(data_to_merge, x)) data_main[x] = data_to_merge[x];
    return data_main;
}
function $ea7d21fd242a7c44$export$7afc298d8ffd816(s) {
    if (s == null) return false;
    return s == true || String(s).toLowerCase() == 'true' || Number(s) == 1;
}
function $ea7d21fd242a7c44$export$8b58be045bf06082(/*Object*/ dest) /*-> Object*/ {
    var sources = Array.prototype.slice.call(arguments, 1);
    for(var j = 0, len = sources.length, src; j < len; j++){
        src = sources[j] || {};
        $ea7d21fd242a7c44$export$696bf4df45a0ddde(dest, src);
    }
    return dest;
}
const $ea7d21fd242a7c44$var$TRACE_HANDLERS = [];
function $ea7d21fd242a7c44$export$611560a6d0a92d9e(cb) {
    $ea7d21fd242a7c44$var$TRACE_HANDLERS.push(cb);
}
function $ea7d21fd242a7c44$export$357889f174732d38(msg) {
    $ea7d21fd242a7c44$var$TRACE_HANDLERS.forEach((cb)=>{
        try {
            cb(msg);
        } catch (e) {
            if (console && console.log) console.log("Error handling trace", e);
        }
    });
}
function $ea7d21fd242a7c44$export$5d04458e2a6c373e(val, len) {
    val = String(val);
    len = len || 2;
    while(val.length < len)val = "0" + val;
    return val;
}
const $ea7d21fd242a7c44$export$bd3fba034e28f6b = function() {
    var lastId = 0, key = '_tl_id';
    return function(/*Object*/ obj) {
        obj[key] = obj[key] || ++lastId;
        return obj[key];
    };
}();
function $ea7d21fd242a7c44$export$87c2784dc9fc4ab(str) {
    if (str && typeof str.replace == 'function') return str.replace(/^\s+|\s+$/g, '');
    return "";
}
function $ea7d21fd242a7c44$export$8ed7b26ec403d551(ary) {
    // given a sorted array of 2-tuples of numbers, count how many "deep" the items are.
    // that is, what is the maximum number of tuples that occupy any one moment
    // each tuple should also be sorted
    var stack = [];
    var max_depth = 0;
    for(var i = 0; i < ary.length; i++){
        stack.push(ary[i]);
        if (stack.length > 1) {
            var top = stack[stack.length - 1];
            var bottom_idx = -1;
            for(var j = 0; j < stack.length - 1; j++)if (stack[j][1] < top[0]) bottom_idx = j;
            if (bottom_idx >= 0) stack = stack.slice(bottom_idx + 1);
        }
        if (stack.length > max_depth) max_depth = stack.length;
    }
    return max_depth;
}
function $ea7d21fd242a7c44$export$c5910a33574a115e(cls, ...src) {
    for (let _cl of src)for (var key of Object.getOwnPropertyNames(_cl.prototype))cls.prototype[key] = _cl.prototype[key];
}
function $ea7d21fd242a7c44$export$f967b1e04044146f(obj, candidate) {
    if (!candidate) candidate = $ea7d21fd242a7c44$export$b40aeedae59b59d1(6);
    if (!(candidate in obj)) return candidate;
    var root = candidate.match(/^(.+)(-\d+)?$/)[1];
    var similar_ids = [];
    // get an alternative
    for(let key in obj)if (key.match(/^(.+?)(-\d+)?$/)[1] == root) similar_ids.push(key);
    candidate = root + "-" + (similar_ids.length + 1);
    for(var counter = similar_ids.length; similar_ids.indexOf(candidate) != -1; counter++)candidate = root + '-' + counter;
    return candidate;
}
function $ea7d21fd242a7c44$export$83b788b1a3698c03(o) {
    var properties = [];
    if (Object.keys) properties = Object.keys(o);
    else {
        for(var p in o)if (Object.prototype.hasOwnProperty.call(o, p)) properties.push(p);
    }
    for(var i = 0; i < properties.length; i++){
        var k = properties[i];
        if (o[k] != null && typeof o[k] != "string") return false;
        if ($ea7d21fd242a7c44$export$87c2784dc9fc4ab(o[k]).length != 0) return false;
    }
    return true;
}
function $ea7d21fd242a7c44$export$c383cdd2a518017a(str) {
    // borrowed from http://stackoverflow.com/a/5782563/102476
    str = $ea7d21fd242a7c44$export$87c2784dc9fc4ab(str);
    str = str.toLowerCase();
    // remove accents, swap ñ for n, etc
    var from = "\xe3\xe0\xe1\xe4\xe2\u1EBD\xe8\xe9\xeb\xea\xec\xed\xef\xee\xf5\xf2\xf3\xf6\xf4\xf9\xfa\xfc\xfb\xf1\xe7\xb7/_,:;";
    var to = "aaaaaeeeeeiiiiooooouuuunc------";
    for(var i = 0, l = from.length; i < l; i++)str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes
    str = str.replace(/^([0-9])/, '_$1');
    return str;
}
function $ea7d21fd242a7c44$export$b40aeedae59b59d1(size, prefix) {
    var getRandomNumber = function(range) {
        return Math.floor(Math.random() * range);
    };
    var getRandomChar = function() {
        var chars = "abcdefghijklmnopqurstuvwxyz";
        return chars.substr(getRandomNumber(32), 1);
    };
    var randomID = function(size) {
        var str = "";
        for(var i = 0; i < size; i++)str += getRandomChar();
        return str;
    };
    if (prefix) return prefix + "-" + randomID(size);
    else return "tl-" + randomID(size);
}
function $ea7d21fd242a7c44$export$f4cb9e34106306b(list, current, default_value) {
    // given a sorted list and a current value which *might* be in the list,
    // return the next greatest value if the current value is >= the last item in the list, return default,
    // or if default is undefined, return input value
    for(var i = 0; i < list.length; i++){
        if (current < list[i]) return list[i];
    }
    return default_value ? default_value : current;
}
function $ea7d21fd242a7c44$export$dc4ff90759501dac(list, current, default_value) {
    // given a sorted list and a current value which *might* be in the list,
    // return the next lesser value if the current value is <= the last item in the list, return default,
    // or if default is undefined, return input value
    for(var i = list.length - 1; i >= 0; i--){
        if (current > list[i]) return list[i];
    }
    return default_value ? default_value : current;
}
function $ea7d21fd242a7c44$export$ce16302d1253e25(n) {
    return n == parseFloat(n) ? !(n % 2) : void 0;
}
function $ea7d21fd242a7c44$export$c4632a8493ebcf7d(id, array, prop, defaultVal) {
    var _n = defaultVal || 0;
    for(var i = 0; i < array.length; i++)if (array[i].data[prop] == id) _n = i;
    return _n;
}
function $ea7d21fd242a7c44$export$8c140248b4280ca1(text) {
    if (!text) return text;
    text = text.replace(/<a\b[^>]*>/i, "");
    text = text.replace(/<\/a>/i, "");
    return text;
}
function $ea7d21fd242a7c44$export$3a6802af14bf5fa6(obj, data) {
    obj.data = $ea7d21fd242a7c44$export$8b58be045bf06082({}, obj.data, data);
    if (obj.data.unique_id === "") obj.data.unique_id = $ea7d21fd242a7c44$export$b40aeedae59b59d1(6);
}
function $ea7d21fd242a7c44$export$beaf23cf02933a13(str) {
    //if (str.match(/<\s*p[^>]*>([^<]*)<\s*\/\s*p\s*>/)) {
    if (str.match(/<p>[\s\S]*?<\/p>/)) return str;
    else return "<p>" + str + "</p>";
}
function $ea7d21fd242a7c44$export$db594ec12e4bdab1(str) {
    str = str.replace(/(<[^>]*>)+/g, '');
    return str.replace('"', "'");
}
function $ea7d21fd242a7c44$export$8ccbde94d5c7f8e7(text, targets, is_touch) {
    var make_link = function(url, link_text, prefix) {
        if (!prefix) prefix = "";
        var MAX_LINK_TEXT_LENGTH = 30;
        if (link_text && link_text.length > MAX_LINK_TEXT_LENGTH) link_text = link_text.substring(0, MAX_LINK_TEXT_LENGTH) + "\u2026"; // unicode ellipsis
        return prefix + "<a class='tl-makelink' href='" + url + "' onclick='void(0)'>" + link_text + "</a>";
    };
    // http://, https://, ftp://
    var urlPattern = /\b(?:https?|ftp):\/\/([a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|])/gim;
    // www. sans http:// or https://
    var pseudoUrlPattern = /(^|[^\/>])(www\.[\S]+(\b|$))/gim;
    // Email addresses
    var emailAddressPattern = /([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)/gim;
    return text.replace(urlPattern, function(match, url_sans_protocol, offset, string) {
        // Javascript doesn't support negative lookbehind assertions, so
        // we need to handle risk of matching URLs in legit hrefs
        if (offset > 0) {
            var prechar = string[offset - 1];
            if (prechar == '"' || prechar == "'" || prechar == "=") return match;
        }
        return make_link(match, url_sans_protocol);
    }).replace(pseudoUrlPattern, function(match, beforePseudo, pseudoUrl, offset, string) {
        return make_link('http://' + pseudoUrl, pseudoUrl, beforePseudo);
    }).replace(emailAddressPattern, function(match, email, offset, string) {
        return make_link('mailto:' + email, email);
    });
}
function $ea7d21fd242a7c44$export$5ca970047f7e3018(url) {
    return url.replace(/(.*)www.dropbox.com\/(.*)/, '$1dl.dropboxusercontent.com/$2');
}
const $ea7d21fd242a7c44$export$85f17f73487c6e7d = {
    square: (size)=>{
        var s = {
            w: 0,
            h: 0
        };
        if (size.w > size.h && size.h > 0) {
            s.h = size.h;
            s.w = size.h;
        } else {
            s.w = size.w;
            s.h = size.w;
        }
        return s;
    },
    r16_9: (size)=>{
        if (size.w !== null && size.w !== "") return Math.round(size.w / 16 * 9);
        else if (size.h !== null && size.h !== "") return Math.round(size.h / 9 * 16);
        else return 0;
    },
    r4_3: (size)=>{
        if (size.w !== null && size.w !== "") return Math.round(size.w / 4 * 3);
        else if (size.h !== null && size.h !== "") return Math.round(size.h / 3 * 4);
    }
};
function $ea7d21fd242a7c44$export$59a8f5abf382974d(string) {
    var str, vars = [], hash, hashes;
    str = string.toString();
    if (str.match('&#038;')) str = str.replace("&#038;", "&");
    else if (str.match('&#38;')) str = str.replace("&#38;", "&");
    else if (str.match('&amp;')) str = str.replace("&amp;", "&");
    hashes = str.slice(str.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++){
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
function $ea7d21fd242a7c44$export$27213b73b2075e98(obj) {
    var params = [];
    for(var i in obj)if (obj.hasOwnProperty(i)) params.push(i + '=' + obj[i]);
    return '?' + params.join('&');
}
function $ea7d21fd242a7c44$export$124940dce15eb641(obj, index) {
    if (typeof obj != 'undefined') {
        var i = 0;
        for(var attr in obj){
            if (index === i) return obj[attr];
            i++;
        }
        return "";
    } else return "";
}
let $ea7d21fd242a7c44$export$61f53211c069eefb = function(alpha) {
    var alphabet = alpha || '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ', base = alphabet.length;
    return {
        encode: function(enc) {
            if (typeof enc !== 'number' || enc !== parseInt(enc)) throw '"encode" only accepts integers.';
            var encoded = '';
            while(enc){
                var remainder = enc % base;
                enc = Math.floor(enc / base);
                encoded = alphabet[remainder].toString() + encoded;
            }
            return encoded;
        },
        decode: function(dec) {
            if (typeof dec !== 'string') throw '"decode" only accepts strings.';
            var decoded = 0;
            while(dec){
                var alphabetPosition = alphabet.indexOf(dec[0]);
                if (alphabetPosition < 0) throw '"decode" can\'t find "' + dec[0] + '" in the alphabet: "' + alphabet + '"';
                var powerOf = dec.length - 1;
                decoded += alphabetPosition * Math.pow(base, powerOf);
                dec = dec.substring(1);
            }
            return decoded;
        }
    };
}();
function $ea7d21fd242a7c44$export$f0bed2e490a4f892(s) {
    // given a YouTube start time string in a reasonable format, reduce it to a number of seconds as an integer.
    if (typeof s == 'string') {
        let parts = s.match(/^\s*(\d+h)?(\d+m)?(\d+s)?\s*/i);
        if (parts) {
            var hours = parseInt(parts[1]) || 0;
            var minutes = parseInt(parts[2]) || 0;
            var seconds = parseInt(parts[3]) || 0;
            return seconds + minutes * 60 + hours * 3600;
        }
    } else if (typeof s == 'number') return s;
    return 0;
}
function $ea7d21fd242a7c44$export$8ad6fe2e294be355(txt) {
    var doc = new DOMParser().parseFromString(txt, 'text/html');
    return doc.body.textContent || "";
}


/* The equations defined here are open source under BSD License.
 * http://www.robertpenner.com/easing_terms_of_use.html (c) 2003 Robert Penner
 * Adapted to single time-based by
 * Brian Crescimanno <brian.crescimanno@gmail.com>
 * Ken Snyder <kendsnyder@gmail.com>
 */ /** MIT License
 *
 * KeySpline - use bezier curve for transition easing function
 * Copyright (c) 2012 Gaetan Renaudeau <renaudeau.gaetan@gmail.com>
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ /**
 * KeySpline - use bezier curve for transition easing function
 * is inspired from Firefox's nsSMILKeySpline.cpp
 * Usage:
 * var spline = new KeySpline(0.25, 0.1, 0.25, 1.0)
 * spline.get(x) => returns the easing value | x must be in [0, 1] range
 */ const $2baebbd96bfe7e6e$var$Easings = {
    ease: [
        0.25,
        0.1,
        0.25,
        1.0
    ],
    linear: [
        0.00,
        0.0,
        1.00,
        1.0
    ],
    easein: [
        0.42,
        0.0,
        1.00,
        1.0
    ],
    easeout: [
        0.00,
        0.0,
        0.58,
        1.0
    ],
    easeinout: [
        0.42,
        0.0,
        0.58,
        1.0
    ]
};
function $2baebbd96bfe7e6e$var$sinusoidal(pos) {
    return -Math.cos(pos * Math.PI) / 2 + 0.5;
}
function $2baebbd96bfe7e6e$var$KeySpline(a) {
    //KeySpline(mX1, mY1, mX2, mY2){
    function get(aX) {
        if (a[0] == a[1] && a[2] == a[3]) return aX; // linear
        return CalcBezier(GetTForX(aX), a[1], a[3]);
    }
    function A(aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }
    function B(aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    }
    function C(aA1) {
        return 3.0 * aA1;
    }
    // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
    function CalcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }
    // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
    function GetSlope(aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }
    function GetTForX(aX) {
        // Newton raphson iteration
        var aGuessT = aX;
        for(var i = 0; i < 4; ++i){
            var currentSlope = GetSlope(aGuessT, a[0], a[2]);
            if (currentSlope == 0.0) return aGuessT;
            var currentX = CalcBezier(aGuessT, a[0], a[2]) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }
}
function $2baebbd96bfe7e6e$export$f7d97b709d0a6c59(t) {
    var spline = new $2baebbd96bfe7e6e$var$KeySpline($2baebbd96bfe7e6e$var$Easings.easein);
    return spline.get(t);
}
function $2baebbd96bfe7e6e$export$ea354f4caf3d04bf(t) {
    var spline = new $2baebbd96bfe7e6e$var$KeySpline($2baebbd96bfe7e6e$var$Easings.easein);
    return spline.get(t);
}
function $2baebbd96bfe7e6e$export$57636bb43b1ccbb0(t) {
    return Math.sin(t * Math.PI / 2);
}
function $2baebbd96bfe7e6e$export$3e62b4b316a17914(t) {
    return t == 1 ? 1 : 1 - Math.pow(2, -10 * t);
}
function $2baebbd96bfe7e6e$export$929e5a82286172a6(t) {
    return t * t;
}
function $2baebbd96bfe7e6e$export$c9c7e53991f62d3b(t) {
    return t == 0 ? 0 : Math.pow(2, 10 * (t - 1));
}
function $2baebbd96bfe7e6e$export$1f36003cbba0aa13(pos) {
    if (pos < 1 / 2.75) return 7.5625 * pos * pos;
    else if (pos < 2 / 2.75) return 7.5625 * (pos -= 1.5 / 2.75) * pos + .75;
    else if (pos < 2.5 / 2.75) return 7.5625 * (pos -= 2.25 / 2.75) * pos + .9375;
    else return 7.5625 * (pos -= 2.625 / 2.75) * pos + .984375;
}
function $2baebbd96bfe7e6e$export$9d60100a8a802bac(pos) {
    var s = 1.70158;
    return pos * pos * ((s + 1) * pos - s);
}
function $2baebbd96bfe7e6e$export$3daa4a78f444687d(pos) {
    var s = 1.70158;
    return (pos = pos - 1) * pos * ((s + 1) * pos + s) + 1;
}
function $2baebbd96bfe7e6e$export$e3ce947fb98643bf(t) {
    if (t < 1 / 2.75) return 7.5625 * t * t;
    if (t < 2 / 2.75) return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
    if (t < 2.5 / 2.75) return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
    return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
}
function $2baebbd96bfe7e6e$export$a2639d0bcb646a0a(pos) {
    if (pos < 1 / 2.75) return 7.5625 * pos * pos;
    else if (pos < 2 / 2.75) return 2 - (7.5625 * (pos -= 1.5 / 2.75) * pos + .75);
    else if (pos < 2.5 / 2.75) return 2 - (7.5625 * (pos -= 2.25 / 2.75) * pos + .9375);
    else return 2 - (7.5625 * (pos -= 2.625 / 2.75) * pos + .984375);
}
function $2baebbd96bfe7e6e$export$9b7728bde9e9316e(pos) {
    var s = 1.70158;
    return (pos -= 1) * pos * ((s + 1) * pos + s) + 1;
}
function $2baebbd96bfe7e6e$export$38edc0001992155f(pos) {
    var s = 1.70158;
    return pos * pos * ((s + 1) * pos - s);
}
function $2baebbd96bfe7e6e$export$e3f8198a677f57c2(pos) {
    return -1 * Math.pow(4, -8 * pos) * Math.sin((pos * 6 - 1) * (2 * Math.PI) / 2) + 1;
}
function $2baebbd96bfe7e6e$export$b36281d89752ae66(pos) {
    return 1 - Math.cos(pos * 4.5 * Math.PI) * Math.exp(-pos * 6);
}
function $2baebbd96bfe7e6e$export$a0f5ee27be08228f(pos, blinks) {
    return Math.round(pos * (blinks || 5)) % 2;
}
function $2baebbd96bfe7e6e$export$f3aaf94dc96a60de(pos, pulses) {
    return -Math.cos(pos * ((pulses || 5) - .5) * 2 * Math.PI) / 2 + .5;
}
function $2baebbd96bfe7e6e$export$138a91d3335be56(pos) {
    return -Math.cos(pos * Math.PI * (9 * pos)) / 2 + 0.5;
}
function $2baebbd96bfe7e6e$export$61e1f52f544ad1da(pos) {
    var pos = pos + (Math.random() - 0.5) / 5;
    return $2baebbd96bfe7e6e$var$sinusoidal(pos < 0 ? 0 : pos > 1 ? 1 : pos);
}
function $2baebbd96bfe7e6e$export$205349702e9dbad8(pos) {
    if (pos < 0.5) return $2baebbd96bfe7e6e$var$sinusoidal(pos * 2);
    else return $2baebbd96bfe7e6e$var$sinusoidal(1 - (pos - 0.5) * 2);
}
function $2baebbd96bfe7e6e$export$2d59ca22077f6eab(t) {
    return t * t;
}
function $2baebbd96bfe7e6e$export$be35423d31ba201e(t) {
    return t * (2 - t);
}
function $2baebbd96bfe7e6e$export$42add3d9cb3645a2(t) {
    return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}
function $2baebbd96bfe7e6e$export$5da70c9577229d30(t) {
    return t * t * t;
}
function $2baebbd96bfe7e6e$export$1157fb72e7fbceb5(t) {
    return --t * t * t + 1;
}
function $2baebbd96bfe7e6e$export$24656b269d8df7d6(t) {
    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}
function $2baebbd96bfe7e6e$export$c3d8280971f5e7ab(t) {
    return t * t * t * t;
}
function $2baebbd96bfe7e6e$export$fb9e4320a4025f10(t) {
    return 1 - --t * t * t * t;
}
function $2baebbd96bfe7e6e$export$bd93209e120f4915(t) {
    return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
}
function $2baebbd96bfe7e6e$export$d5a2637b851d40fa(t) {
    return t * t * t * t * t;
}
function $2baebbd96bfe7e6e$export$54ef52175ef1a966(t) {
    return 1 + --t * t * t * t * t;
}
function $2baebbd96bfe7e6e$export$40df750f1044ce5e(t) {
    return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
}


/*	Message
	
================================================== */ /*	TLClass
	Class powers the OOP facilities of the library.
================================================== */ 
let $aede701022b5d50a$export$7d0ecf6d8e5abad6 = function() {};
$aede701022b5d50a$export$7d0ecf6d8e5abad6.extend = function(/*Object*/ props) /*-> Class*/ {
    // extended class with the new prototype
    var NewClass = function() {
        if (this.initialize) this.initialize.apply(this, arguments);
    };
    // instantiate class without calling constructor
    var F = function() {};
    F.prototype = this.prototype;
    var proto = new F();
    proto.constructor = NewClass;
    NewClass.prototype = proto;
    // add superclass access
    NewClass.superclass = this.prototype;
    // add class name
    //proto.className = props;
    //inherit parent's statics
    for(var i in this)if (this.hasOwnProperty(i) && i !== 'prototype' && i !== 'superclass') NewClass[i] = this[i];
    // mix static properties into the class
    if (props.statics) {
        (0, $ea7d21fd242a7c44$export$8b58be045bf06082)(NewClass, props.statics);
        delete props.statics;
    }
    // mix includes into the prototype
    if (props.includes) {
        (0, $ea7d21fd242a7c44$export$8b58be045bf06082).apply(null, [
            proto
        ].concat(props.includes));
        delete props.includes;
    }
    // merge options
    if (props.options && proto.options) props.options = (0, $ea7d21fd242a7c44$export$8b58be045bf06082)({}, proto.options, props.options);
    // mix given properties into the prototype
    (0, $ea7d21fd242a7c44$export$8b58be045bf06082)(proto, props);
    // allow inheriting further
    NewClass.extend = $aede701022b5d50a$export$7d0ecf6d8e5abad6.extend;
    // method for adding properties to prototype
    NewClass.include = function(props) {
        (0, $ea7d21fd242a7c44$export$8b58be045bf06082)(this.prototype, props);
    };
    return NewClass;
};




/*	Events
	adds custom events functionality to TL classes
================================================== */ 

class $d92d8eaa035c7b70$export$2e2bcd8739ae039 {
    /**
     * Add an event listener callback for the given type.
     * @param {string} type 
     * @param {function} fn 
     * @param {object} [context] 
     * @returns { Events } this (the instance upon which the method was called)
     */ on(type, fn, context) {
        if (!fn) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("No callback function provided");
        var events = this._tl_events = this._tl_events || {};
        events[type] = events[type] || [];
        events[type].push({
            action: fn,
            context: context || this
        });
        return this;
    }
    /**
     * Synonym for on(type, fn, context). It would be great to determine 
     *     that this is obsolete, but that wasn't clear.
     * @param {string} type
     * @param {function} fn
     * @param {object} [context]
     * @returns { Events } this (the instance upon which the method was called)
     */ addEventListener(/*String*/ type, /*Function*/ fn, /*(optional) Object*/ context) {
        return this.on(type, fn, context);
    }
    /**
     * Return true if this object has any listeners of the given type.
     * @param {string} type 
     * @returns {boolean}
     */ hasEventListeners(type) {
        var k = '_tl_events';
        return k in this && type in this[k] && this[k][type].length > 0;
    }
    /**
     * Remove any event listeners for the given type that use the given 
     *     callback and have the given context.
     * @param {string} type 
     * @param {function} fn 
     * @param {object} context 
     * @returns { Events } this (the instance upon which the method was called)
     */ removeEventListener(/*String*/ type, /*Function*/ fn, /*(optional) Object*/ context) {
        if (!this.hasEventListeners(type)) return this;
        for(var i = 0, events = this._tl_events, len = events[type].length; i < len; i++)if (events[type][i].action === fn && (!context || events[type][i].context === context)) {
            events[type].splice(i, 1);
            return this;
        }
        return this;
    }
    /**
     * Synonym for removeEventListener. Is this really needed? While 'off' is opposite of 'on',
     *     it doesn't actually read as 'remove' unless you know that.
     * @param {string} type
     * @param {function} fn
     * @param {object} context
     * @returns { Events } this (the instance upon which the method was called)
     */ off(type, fn, context) {
        return this.removeEventListener(type, fn, context);
    }
    /**
     * Activate (execute) all registered callback functions for the given
     *     type, passing the given data, if any.
     * @param {string} type 
     * @param {object} [data] 
     * @returns { Events } this (the instance upon which the method was called)
     */ fire(type, data) {
        if (!this.hasEventListeners(type)) return this;
        var event = (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)({
            type: type,
            target: this
        }, data);
        var listeners = this._tl_events[type].slice();
        for(var i = 0, len = listeners.length; i < len; i++)if (listeners[i].action) listeners[i].action.call(listeners[i].context || this, event);
        else (0, $ea7d21fd242a7c44$export$357889f174732d38)(`no action defined for ${type} listener`);
        return this;
    }
}


/*	
	DOM methods used regularly
	Assumes there is a _el.container and animator
================================================== */ 
/*	Animate
  Basic animation
  once we've switched to an npm buildable model
  we could probably replace this with a true dependency upon
  https://www.npmjs.com/package/morpheus
================================================== */ function $92002c55b7773eef$export$83a1293bbde53b95(el, options) {
    return $92002c55b7773eef$var$tlanimate(el, options);
}
/*	Based on: Morpheus
	https://github.com/ded/morpheus - (c) Dustin Diaz 2011
	License MIT
================================================== */ const $92002c55b7773eef$var$tlanimate = function() {
    var doc = document, win = window, perf = win.performance, perfNow = perf && (perf.now || perf.webkitNow || perf.msNow || perf.mozNow), now = perfNow ? function() {
        return perfNow.call(perf);
    } : function() {
        return +new Date();
    }, html = doc.documentElement, fixTs = false, thousand = 1000, rgbOhex = /^rgb\(|#/, relVal = /^([+\-])=([\d\.]+)/, numUnit = /^(?:[\+\-]=?)?\d+(?:\.\d+)?(%|in|cm|mm|em|ex|pt|pc|px)$/, rotate = /rotate\(((?:[+\-]=)?([\-\d\.]+))deg\)/, scale = /scale\(((?:[+\-]=)?([\d\.]+))\)/, skew = /skew\(((?:[+\-]=)?([\-\d\.]+))deg, ?((?:[+\-]=)?([\-\d\.]+))deg\)/, translate = /translate\(((?:[+\-]=)?([\-\d\.]+))px, ?((?:[+\-]=)?([\-\d\.]+))px\)/, // these elements do not require 'px'
    unitless = {
        lineHeight: 1,
        zoom: 1,
        zIndex: 1,
        opacity: 1,
        transform: 1
    };
    // which property name does this browser use for transform
    var transform = function() {
        var styles = doc.createElement('a').style, props = [
            'webkitTransform',
            'MozTransform',
            'OTransform',
            'msTransform',
            'Transform'
        ], i;
        for(i = 0; i < props.length; i++){
            if (props[i] in styles) return props[i];
        }
    }();
    // does this browser support the opacity property?
    var opacity = function() {
        return typeof doc.createElement('a').style.opacity !== 'undefined';
    }();
    // initial style is determined by the elements themselves
    var getStyle = doc.defaultView && doc.defaultView.getComputedStyle ? function(el, property) {
        property = property == 'transform' ? transform : property;
        property = camelize(property);
        var value = null, computed = doc.defaultView.getComputedStyle(el, '');
        computed && (value = computed[property]);
        return el.style[property] || value;
    } : html.currentStyle ? function(el, property) {
        property = camelize(property);
        if (property == 'opacity') {
            var val = 100;
            try {
                val = el.filters['DXImageTransform.Microsoft.Alpha'].opacity;
            } catch (e1) {
                try {
                    val = el.filters('alpha').opacity;
                } catch (e2) {}
            }
            return val / 100;
        }
        var value = el.currentStyle ? el.currentStyle[property] : null;
        return el.style[property] || value;
    } : function(el, property) {
        return el.style[camelize(property)];
    };
    var frame = function() {
        // native animation frames
        // http://webstuff.nfshost.com/anim-timing/Overview.html
        // http://dev.chromium.org/developers/design-documents/requestanimationframe-implementation
        return win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.msRequestAnimationFrame || win.oRequestAnimationFrame || function(callback) {
            win.setTimeout(function() {
                callback(+new Date());
            }, 17) // when I was 17..
            ;
        };
    }();
    var children = [];
    frame(function(timestamp) {
        // feature-detect if rAF and now() are of the same scale (epoch or high-res),
        // if not, we have to do a timestamp fix on each frame
        fixTs = timestamp > 1e12 != now() > 1e12;
    });
    function has(array, elem, i) {
        if (Array.prototype.indexOf) return array.indexOf(elem);
        for(i = 0; i < array.length; ++i){
            if (array[i] === elem) return i;
        }
    }
    function render(timestamp) {
        var i, count = children.length;
        // if we're using a high res timer, make sure timestamp is not the old epoch-based value.
        // http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
        if (perfNow && timestamp > 1e12) timestamp = now();
        if (fixTs) timestamp = now();
        for(i = count; i--;)children[i](timestamp);
        children.length && frame(render);
    }
    function live(f) {
        if (children.push(f) === 1) frame(render);
    }
    function die(f) {
        var rest, index = has(children, f);
        if (index >= 0) {
            rest = children.slice(index + 1);
            children.length = index;
            children = children.concat(rest);
        }
    }
    function parseTransform(style, base) {
        var values = {}, m;
        if (m = style.match(rotate)) values.rotate = by(m[1], base ? base.rotate : null);
        if (m = style.match(scale)) values.scale = by(m[1], base ? base.scale : null);
        if (m = style.match(skew)) {
            values.skewx = by(m[1], base ? base.skewx : null);
            values.skewy = by(m[3], base ? base.skewy : null);
        }
        if (m = style.match(translate)) {
            values.translatex = by(m[1], base ? base.translatex : null);
            values.translatey = by(m[3], base ? base.translatey : null);
        }
        return values;
    }
    function formatTransform(v) {
        var s = '';
        if ('rotate' in v) s += 'rotate(' + v.rotate + 'deg) ';
        if ('scale' in v) s += 'scale(' + v.scale + ') ';
        if ('translatex' in v) s += 'translate(' + v.translatex + 'px,' + v.translatey + 'px) ';
        if ('skewx' in v) s += 'skew(' + v.skewx + 'deg,' + v.skewy + 'deg)';
        return s;
    }
    function rgb(r, g, b) {
        return '#' + (16777216 | r << 16 | g << 8 | b).toString(16).slice(1);
    }
    // convert rgb and short hex to long hex
    function toHex(c) {
        var m = c.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
        return (m ? rgb(m[1], m[2], m[3]) : c).replace(/#(\w)(\w)(\w)$/, '#$1$1$2$2$3$3') // short skirt to long jacket
        ;
    }
    // change font-size => fontSize etc.
    function camelize(s) {
        return s.replace(/-(.)/g, function(m, m1) {
            return m1.toUpperCase();
        });
    }
    // aren't we having it?
    function fun(f) {
        return typeof f == 'function';
    }
    function nativeTween(t) {
        // default to a pleasant-to-the-eye easeOut (like native animations)
        return Math.sin(t * Math.PI / 2);
    }
    /**
    * Core tween method that requests each frame
    * @param duration: time in milliseconds. defaults to 1000
    * @param fn: tween frame callback function receiving 'position'
    * @param done {optional}: complete callback function
    * @param ease {optional}: easing method. defaults to easeOut
    * @param from {optional}: integer to start from
    * @param to {optional}: integer to end at
    * @returns method to stop the animation
    */ function tween(duration, fn, done, ease, from, to) {
        ease = fun(ease) ? ease : morpheus.easings[ease] || nativeTween;
        var time = duration || thousand, self = this, diff = to - from, start = now(), stop = 0, end = 0;
        function run(t) {
            var delta = t - start;
            if (delta > time || stop) {
                to = isFinite(to) ? to : 1;
                stop ? end && fn(to) : fn(to);
                die(run);
                return done && done.apply(self);
            }
            // if you don't specify a 'to' you can use tween as a generic delta tweener
            // cool, eh?
            isFinite(to) ? fn(diff * ease(delta / time) + from) : fn(ease(delta / time));
        }
        live(run);
        return {
            stop: function(jump) {
                stop = 1;
                end = jump // jump to end of animation?
                ;
                if (!jump) done = null // remove callback if not jumping to end
                ;
            }
        };
    }
    /**
    * generic bezier method for animating x|y coordinates
    * minimum of 2 points required (start and end).
    * first point start, last point end
    * additional control points are optional (but why else would you use this anyway ;)
    * @param points: array containing control points
       [[0, 0], [100, 200], [200, 100]]
    * @param pos: current be(tween) position represented as float  0 - 1
    * @return [x, y]
    */ function bezier(points, pos) {
        var n = points.length, r = [], i, j;
        for(i = 0; i < n; ++i)r[i] = [
            points[i][0],
            points[i][1]
        ];
        for(j = 1; j < n; ++j)for(i = 0; i < n - j; ++i){
            r[i][0] = (1 - pos) * r[i][0] + pos * r[parseInt(i + 1, 10)][0];
            r[i][1] = (1 - pos) * r[i][1] + pos * r[parseInt(i + 1, 10)][1];
        }
        return [
            r[0][0],
            r[0][1]
        ];
    }
    // this gets you the next hex in line according to a 'position'
    function nextColor(pos, start, finish) {
        var r = [], i, e, from, to;
        for(i = 0; i < 6; i++){
            from = Math.min(15, parseInt(start.charAt(i), 16));
            to = Math.min(15, parseInt(finish.charAt(i), 16));
            e = Math.floor((to - from) * pos + from);
            e = e > 15 ? 15 : e < 0 ? 0 : e;
            r[i] = e.toString(16);
        }
        return '#' + r.join('');
    }
    // this retreives the frame value within a sequence
    function getTweenVal(pos, units, begin, end, k, i, v) {
        if (k == 'transform') {
            v = {};
            for(var t in begin[i][k])v[t] = t in end[i][k] ? Math.round(((end[i][k][t] - begin[i][k][t]) * pos + begin[i][k][t]) * thousand) / thousand : begin[i][k][t];
            return v;
        } else if (typeof begin[i][k] == 'string') return nextColor(pos, begin[i][k], end[i][k]);
        else {
            // round so we don't get crazy long floats
            v = Math.round(((end[i][k] - begin[i][k]) * pos + begin[i][k]) * thousand) / thousand;
            // some css properties don't require a unit (like zIndex, lineHeight, opacity)
            if (!(k in unitless)) v += units[i][k] || 'px';
            return v;
        }
    }
    // support for relative movement via '+=n' or '-=n'
    function by(val, start, m, r, i) {
        return (m = relVal.exec(val)) ? (i = parseFloat(m[2])) && start + (m[1] == '+' ? 1 : -1) * i : parseFloat(val);
    }
    /**
    * morpheus:
    * @param element(s): HTMLElement(s)
    * @param options: mixed bag between CSS Style properties & animation options
    *  - {n} CSS properties|values
    *     - value can be strings, integers,
    *     - or callback function that receives element to be animated. method must return value to be tweened
    *     - relative animations start with += or -= followed by integer
    *  - duration: time in ms - defaults to 1000(ms)
    *  - easing: a transition method - defaults to an 'easeOut' algorithm
    *  - complete: a callback method for when all elements have finished
    *  - bezier: array of arrays containing x|y coordinates that define the bezier points. defaults to none
    *     - this may also be a function that receives element to be animated. it must return a value
    */ function morpheus(elements, options) {
        var els = elements ? els = isFinite(elements.length) ? elements : [
            elements
        ] : [], i, complete = options.complete, duration = options.duration, ease = options.easing, points = options.bezier, begin = [], end = [], units = [], bez = [], originalLeft, originalTop;
        if (points) {
            // remember the original values for top|left
            originalLeft = options.left;
            originalTop = options.top;
            delete options.right;
            delete options.bottom;
            delete options.left;
            delete options.top;
        }
        for(i = els.length; i--;){
            // record beginning and end states to calculate positions
            begin[i] = {};
            end[i] = {};
            units[i] = {};
            // are we 'moving'?
            if (points) {
                var left = getStyle(els[i], 'left'), top = getStyle(els[i], 'top'), xy = [
                    by(fun(originalLeft) ? originalLeft(els[i]) : originalLeft || 0, parseFloat(left)),
                    by(fun(originalTop) ? originalTop(els[i]) : originalTop || 0, parseFloat(top))
                ];
                bez[i] = fun(points) ? points(els[i], xy) : points;
                bez[i].push(xy);
                bez[i].unshift([
                    parseInt(left, 10),
                    parseInt(top, 10)
                ]);
            }
            for(var k in options){
                switch(k){
                    case 'complete':
                    case 'duration':
                    case 'easing':
                    case 'bezier':
                        continue;
                }
                var v = getStyle(els[i], k), unit, tmp = fun(options[k]) ? options[k](els[i]) : options[k];
                if (typeof tmp == 'string' && rgbOhex.test(tmp) && !rgbOhex.test(v)) {
                    delete options[k]; // remove key :(
                    continue; // cannot animate colors like 'orange' or 'transparent'
                // only #xxx, #xxxxxx, rgb(n,n,n)
                }
                begin[i][k] = k == 'transform' ? parseTransform(v) : typeof tmp == 'string' && rgbOhex.test(tmp) ? toHex(v).slice(1) : parseFloat(v);
                end[i][k] = k == 'transform' ? parseTransform(tmp, begin[i][k]) : typeof tmp == 'string' && tmp.charAt(0) == '#' ? toHex(tmp).slice(1) : by(tmp, parseFloat(v));
                // record original unit
                typeof tmp == 'string' && (unit = tmp.match(numUnit)) && (units[i][k] = unit[1]);
            }
        }
        // ONE TWEEN TO RULE THEM ALL
        return tween.apply(els, [
            duration,
            function(pos, v, xy) {
                // normally not a fan of optimizing for() loops, but we want something
                // fast for animating
                for(i = els.length; i--;){
                    if (points) {
                        xy = bezier(bez[i], pos);
                        els[i].style.left = xy[0] + 'px';
                        els[i].style.top = xy[1] + 'px';
                    }
                    for(var k in options){
                        v = getTweenVal(pos, units, begin, end, k, i);
                        k == 'transform' ? els[i].style[transform] = formatTransform(v) : k == 'opacity' && !opacity ? els[i].style.filter = 'alpha(opacity=' + v * 100 + ')' : els[i].style[camelize(k)] = v;
                    }
                }
            },
            complete,
            ease
        ]);
    }
    // expose useful methods
    morpheus.tween = tween;
    morpheus.getStyle = getStyle;
    morpheus.bezier = bezier;
    morpheus.transform = transform;
    morpheus.parseTransform = parseTransform;
    morpheus.formatTransform = formatTransform;
    morpheus.easings = {};
    return morpheus;
}() // must be executed at initialization
;


class $8948f35b9a5753b9$export$b8c17d0037837cb6 {
    /*	Adding, Hiding, Showing etc
	================================================== */ show(animate) {
        if (animate) ;
        else this._el.container.style.display = "block";
    }
    hide(animate) {
        this._el.container.style.display = "none";
    }
    addTo(container) {
        container.appendChild(this._el.container);
        this.onAdd();
    }
    removeFrom(container) {
        container.removeChild(this._el.container);
        this.onRemove();
    }
    /*	Animate to Position
	================================================== */ animatePosition(pos, el) {
        var ani = {
            duration: this.options.duration,
            easing: this.options.ease
        };
        for(var name in pos)if (pos.hasOwnProperty(name)) ani[name] = pos[name] + "px";
        if (this.animator) this.animator.stop();
        this.animator = (0, $92002c55b7773eef$export$83a1293bbde53b95)(el, ani);
    }
    /*	Events
	================================================== */ onLoaded() {
        this.fire("loaded", this.data);
    }
    onAdd() {
        this.fire("added", this.data);
    }
    onRemove() {
        this.fire("removed", this.data);
    }
    /*	Set the Position
	================================================== */ setPosition(pos, el) {
        for(var name in pos)if (pos.hasOwnProperty(name)) {
            if (el) el.style[name] = pos[name] + "px";
            else this._el.container.style[name] = pos[name] + "px";
        }
    }
    getPosition() {
        return (0, $9eb7ee258fcc7829$export$1690e12b840569b9)(this._el.container);
    }
}


/*	DOMEvent
	Inspired by Leaflet 
	DomEvent contains functions for working with DOM events.
================================================== */ /*	Draggable
	Draggable allows you to add dragging capabilities to any element. Supports mobile devices too.
================================================== */ 







class $0e961291b0ba4fa8$export$f2a139e5d18b9882 {
    constructor(drag_elem, options, move_elem){
        // DOM ELements
        this._el = {
            drag: drag_elem,
            move: drag_elem
        };
        this.mousedrag = {
            down: "mousedown",
            up: "mouseup",
            leave: "mouseleave",
            move: "mousemove"
        };
        this.touchdrag = {
            down: "touchstart",
            up: "touchend",
            leave: "mouseleave",
            move: "touchmove"
        };
        if (move_elem) this._el.move = move_elem;
        //Options
        this.options = {
            enable: {
                x: true,
                y: true
            },
            constraint: {
                top: false,
                bottom: false,
                left: false,
                right: false
            },
            momentum_multiplier: 2000,
            duration: 1000,
            ease: (0, $2baebbd96bfe7e6e$export$40df750f1044ce5e)
        };
        // Animation Object
        this.animator = null;
        // Drag Event Type
        this.dragevent = this.mousedrag;
        if (0, $e8c72613a0980cab$export$d0b7ea69ab6056df) this.dragevent = this.touchdrag;
        // Draggable Data
        this.data = {
            sliding: false,
            direction: "none",
            pagex: {
                start: 0,
                end: 0
            },
            pagey: {
                start: 0,
                end: 0
            },
            pos: {
                start: {
                    x: 0,
                    y: 0
                },
                end: {
                    x: 0,
                    y: 0
                }
            },
            new_pos: {
                x: 0,
                y: 0
            },
            new_pos_parent: {
                x: 0,
                y: 0
            },
            time: {
                start: 0,
                end: 0
            },
            touch: false
        };
        // Merge Data and Options
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.options, options);
    }
    enable(e) {
        this.data.pos.start = 0;
        this._el.move.style.left = this.data.pos.start.x + "px";
        this._el.move.style.top = this.data.pos.start.y + "px";
        this._el.move.style.position = "absolute";
    }
    disable() {
        (0, $7d599a41227e2243$export$196e5b15bdb52968).removeListener(this._el.drag, this.dragevent.down, this._onDragStart, this);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).removeListener(this._el.drag, this.dragevent.up, this._onDragEnd, this);
    }
    stopMomentum() {
        if (this.animator) this.animator.stop();
    }
    updateConstraint(c) {
        this.options.constraint = c;
    }
    /*	Private Methods
	================================================== */ _onDragStart(e) {
        if (0, $e8c72613a0980cab$export$d0b7ea69ab6056df) {
            if (e.originalEvent) {
                this.data.pagex.start = e.originalEvent.touches[0].screenX;
                this.data.pagey.start = e.originalEvent.touches[0].screenY;
            } else {
                this.data.pagex.start = e.targetTouches[0].screenX;
                this.data.pagey.start = e.targetTouches[0].screenY;
            }
        } else {
            this.data.pagex.start = e.pageX;
            this.data.pagey.start = e.pageY;
        }
        // Center element to finger or mouse
        if (this.options.enable.x) this._el.move.style.left = this.data.pagex.start - this._el.move.offsetWidth / 2 + "px";
        if (this.options.enable.y) this._el.move.style.top = this.data.pagey.start - this._el.move.offsetHeight / 2 + "px";
        this.data.pos.start = (0, $9eb7ee258fcc7829$export$1690e12b840569b9)(this._el.drag);
        this.data.time.start = new Date().getTime();
        this.fire("dragstart", this.data);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.drag, this.dragevent.move, this._onDragMove, this);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.drag, this.dragevent.leave, this._onDragEnd, this);
    }
    _onDragEnd(e) {
        this.data.sliding = false;
        (0, $7d599a41227e2243$export$196e5b15bdb52968).removeListener(this._el.drag, this.dragevent.move, this._onDragMove, this);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).removeListener(this._el.drag, this.dragevent.leave, this._onDragEnd, this);
        this.fire("dragend", this.data);
        //  momentum
        this._momentum();
    }
    _onDragMove(e) {
        e.preventDefault();
        this.data.sliding = true;
        if (0, $e8c72613a0980cab$export$d0b7ea69ab6056df) {
            if (e.originalEvent) {
                this.data.pagex.end = e.originalEvent.touches[0].screenX;
                this.data.pagey.end = e.originalEvent.touches[0].screenY;
            } else {
                this.data.pagex.end = e.targetTouches[0].screenX;
                this.data.pagey.end = e.targetTouches[0].screenY;
            }
        } else {
            this.data.pagex.end = e.pageX;
            this.data.pagey.end = e.pageY;
        }
        this.data.pos.end = (0, $9eb7ee258fcc7829$export$1690e12b840569b9)(this._el.drag);
        this.data.new_pos.x = -(this.data.pagex.start - this.data.pagex.end - this.data.pos.start.x);
        this.data.new_pos.y = -(this.data.pagey.start - this.data.pagey.end - this.data.pos.start.y);
        if (this.options.enable.x) this._el.move.style.left = this.data.new_pos.x + "px";
        if (this.options.enable.y) this._el.move.style.top = this.data.new_pos.y + "px";
        this.fire("dragmove", this.data);
    }
    _momentum() {
        var pos_adjust = {
            x: 0,
            y: 0,
            time: 0
        }, pos_change = {
            x: 0,
            y: 0,
            time: 0
        }, swipe = false, swipe_direction = "";
        0, $e8c72613a0980cab$export$d0b7ea69ab6056df;
        pos_adjust.time = (new Date().getTime() - this.data.time.start) * 10;
        pos_change.time = (new Date().getTime() - this.data.time.start) * 10;
        pos_change.x = this.options.momentum_multiplier * (Math.abs(this.data.pagex.end) - Math.abs(this.data.pagex.start));
        pos_change.y = this.options.momentum_multiplier * (Math.abs(this.data.pagey.end) - Math.abs(this.data.pagey.start));
        pos_adjust.x = Math.round(pos_change.x / pos_change.time);
        pos_adjust.y = Math.round(pos_change.y / pos_change.time);
        this.data.new_pos.x = Math.min(this.data.pos.end.x + pos_adjust.x);
        this.data.new_pos.y = Math.min(this.data.pos.end.y + pos_adjust.y);
        if (!this.options.enable.x) this.data.new_pos.x = this.data.pos.start.x;
        else if (this.data.new_pos.x < 0) this.data.new_pos.x = 0;
        if (!this.options.enable.y) this.data.new_pos.y = this.data.pos.start.y;
        else if (this.data.new_pos.y < 0) this.data.new_pos.y = 0;
        // Detect Swipe
        if (pos_change.time < 3000) swipe = true;
        // Detect Direction
        if (Math.abs(pos_change.x) > 10000) {
            this.data.direction = "left";
            if (pos_change.x > 0) this.data.direction = "right";
        }
        // Detect Swipe
        if (Math.abs(pos_change.y) > 10000) {
            this.data.direction = "up";
            if (pos_change.y > 0) this.data.direction = "down";
        }
        this._animateMomentum();
        if (swipe) this.fire("swipe_" + this.data.direction, this.data);
    }
    _animateMomentum() {
        var pos = {
            x: this.data.new_pos.x,
            y: this.data.new_pos.y
        }, animate = {
            duration: this.options.duration,
            easing: (0, $2baebbd96bfe7e6e$export$3e62b4b316a17914)
        };
        if (this.options.enable.y) {
            if (this.options.constraint.top || this.options.constraint.bottom) {
                if (pos.y > this.options.constraint.bottom) pos.y = this.options.constraint.bottom;
                else if (pos.y < this.options.constraint.top) pos.y = this.options.constraint.top;
            }
            animate.top = Math.floor(pos.y) + "px";
        }
        if (this.options.enable.x) {
            if (this.options.constraint.left || this.options.constraint.right) {
                if (pos.x > this.options.constraint.left) pos.x = this.options.constraint.left;
                else if (pos.x < this.options.constraint.right) pos.x = this.options.constraint.right;
            }
            animate.left = Math.floor(pos.x) + "px";
        }
        this.animator = (0, $92002c55b7773eef$export$83a1293bbde53b95)(this._el.move, animate);
        this.fire("momentum", this.data);
    }
}
(0, $ea7d21fd242a7c44$export$c5910a33574a115e)((0, $d92d8eaa035c7b70$export$2e2bcd8739ae039));




var $7d599a41227e2243$export$196e5b15bdb52968 = {
    /* inpired by John Resig, Dean Edwards and YUI addEvent implementations */ addListener: function(/*HTMLElement*/ obj, /*String*/ type, /*Function*/ fn, /*Object*/ context) {
        var id = (0, $ea7d21fd242a7c44$export$bd3fba034e28f6b)(fn), key = "_tl_" + type + id;
        if (obj[key]) return;
        var handler = function(e) {
            return fn.call(context || obj, e || $7d599a41227e2243$export$196e5b15bdb52968._getEvent());
        };
        if ((0, $e8c72613a0980cab$export$d0b7ea69ab6056df) && type === "dblclick" && this.addDoubleTapListener) this.addDoubleTapListener(obj, handler, id);
        else if ("addEventListener" in obj) {
            if (type === "mousewheel") {
                obj.addEventListener("DOMMouseScroll", handler, false);
                obj.addEventListener(type, handler, false);
            } else if (type === "mouseenter" || type === "mouseleave") {
                var originalHandler = handler, newType = type === "mouseenter" ? "mouseover" : "mouseout";
                handler = function(e) {
                    if (!$7d599a41227e2243$export$196e5b15bdb52968._checkMouse(obj, e)) return;
                    return originalHandler(e);
                };
                obj.addEventListener(newType, handler, false);
            } else obj.addEventListener(type, handler, false);
        } else if ("attachEvent" in obj) obj.attachEvent("on" + type, handler);
        obj[key] = handler;
    },
    removeListener: function(/*HTMLElement*/ obj, /*String*/ type, /*Function*/ fn) {
        var id = (0, $ea7d21fd242a7c44$export$bd3fba034e28f6b)(fn), key = "_tl_" + type + id, handler = obj[key];
        if (!handler) return;
        if ((0, $e8c72613a0980cab$export$d0b7ea69ab6056df) && type === 'dblclick' && this.removeDoubleTapListener) this.removeDoubleTapListener(obj, id);
        else if ('removeEventListener' in obj) {
            if (type === 'mousewheel') {
                obj.removeEventListener('DOMMouseScroll', handler, false);
                obj.removeEventListener(type, handler, false);
            } else if (type === 'mouseenter' || type === 'mouseleave') obj.removeEventListener(type === 'mouseenter' ? 'mouseover' : 'mouseout', handler, false);
            else obj.removeEventListener(type, handler, false);
        } else if ('detachEvent' in obj) obj.detachEvent("on" + type, handler);
        obj[key] = null;
    },
    _checkMouse: function(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    },
    /*jshint noarg:false */ // evil magic for IE
    _getEvent: function() {
        var e = window.event;
        if (!e) {
            var caller = arguments.callee.caller;
            while(caller){
                e = caller['arguments'][0];
                if (e && window.Event === e.constructor) break;
                caller = caller.caller;
            }
        }
        return e;
    },
    /*jshint noarg:false */ stopPropagation: function(/*Event*/ e) {
        if (e.stopPropagation) e.stopPropagation();
        else e.cancelBubble = true;
    },
    disableClickPropagation: function(/*HTMLElement*/ el) {
        $7d599a41227e2243$export$196e5b15bdb52968.addListener(el, (0, $0e961291b0ba4fa8$export$f2a139e5d18b9882).START, $7d599a41227e2243$export$196e5b15bdb52968.stopPropagation);
        $7d599a41227e2243$export$196e5b15bdb52968.addListener(el, "click", $7d599a41227e2243$export$196e5b15bdb52968.stopPropagation);
        $7d599a41227e2243$export$196e5b15bdb52968.addListener(el, "dblclick", $7d599a41227e2243$export$196e5b15bdb52968.stopPropagation);
    },
    preventDefault: function(/*Event*/ e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
    },
    stop: function(e) {
        $7d599a41227e2243$export$196e5b15bdb52968.preventDefault(e);
        $7d599a41227e2243$export$196e5b15bdb52968.stopPropagation(e);
    },
    getWheelDelta: function(e) {
        var delta = 0;
        if (e.wheelDelta) delta = e.wheelDelta / 120;
        if (e.detail) delta = -e.detail / 3;
        return delta;
    }
};


/*  I18NMixins
    assumes that its class has an attribute `language` with a Language instance    
================================================== */ 

var $7f99b552874efbe4$var$Zepto = function() {
    var undefined1, key, $, classList, emptyArray = [], slice = emptyArray.slice, filter = emptyArray.filter, document1 = window.document, elementDisplay = {}, classCache = {}, cssNumber = {
        'column-count': 1,
        'columns': 1,
        'font-weight': 1,
        'line-height': 1,
        'opacity': 1,
        'z-index': 1,
        'zoom': 1
    }, fragmentRE = /^\s*<(\w+|!)[^>]*>/, singleTagRE = /^<(\w+)\s*\/?>(?:<\/\1>|)$/, tagExpanderRE = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/ig, rootNodeRE = /^(?:body|html)$/i, capitalRE = /([A-Z])/g, // special attributes that should be get/set via method calls
    methodAttributes = [
        'val',
        'css',
        'html',
        'text',
        'data',
        'width',
        'height',
        'offset'
    ], adjacencyOperators = [
        'after',
        'prepend',
        'before',
        'append'
    ], table = document1.createElement('table'), tableRow = document1.createElement('tr'), containers = {
        'tr': document1.createElement('tbody'),
        'tbody': table,
        'thead': table,
        'tfoot': table,
        'td': tableRow,
        'th': tableRow,
        '*': document1.createElement('div')
    }, readyRE = /complete|loaded|interactive/, classSelectorRE = /^\.([\w-]+)$/, idSelectorRE = /^#([\w-]*)$/, simpleSelectorRE = /^[\w-]*$/, class2type = {}, toString = class2type.toString, zepto = {}, camelize, uniq, tempParent = document1.createElement('div'), propMap = {
        'tabindex': 'tabIndex',
        'readonly': 'readOnly',
        'for': 'htmlFor',
        'class': 'className',
        'maxlength': 'maxLength',
        'cellspacing': 'cellSpacing',
        'cellpadding': 'cellPadding',
        'rowspan': 'rowSpan',
        'colspan': 'colSpan',
        'usemap': 'useMap',
        'frameborder': 'frameBorder',
        'contenteditable': 'contentEditable'
    }, isArray = Array.isArray || function(object) {
        return object instanceof Array;
    };
    zepto.matches = function(element, selector) {
        if (!selector || !element || element.nodeType !== 1) return false;
        var matchesSelector = element.webkitMatchesSelector || element.mozMatchesSelector || element.oMatchesSelector || element.matchesSelector;
        if (matchesSelector) return matchesSelector.call(element, selector);
        // fall back to performing a selector:
        var match, parent = element.parentNode, temp = !parent;
        if (temp) (parent = tempParent).appendChild(element);
        match = ~zepto.qsa(parent, selector).indexOf(element);
        temp && tempParent.removeChild(element);
        return match;
    };
    function type(obj) {
        return obj == null ? String(obj) : class2type[toString.call(obj)] || "object";
    }
    function isFunction(value) {
        return type(value) == "function";
    }
    function isWindow(obj) {
        return obj != null && obj == obj.window;
    }
    function isDocument(obj) {
        return obj != null && obj.nodeType == obj.DOCUMENT_NODE;
    }
    function isObject(obj) {
        return type(obj) == "object";
    }
    function isPlainObject(obj) {
        return isObject(obj) && !isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype;
    }
    function likeArray(obj) {
        return typeof obj.length == 'number';
    }
    function compact(array) {
        return filter.call(array, function(item) {
            return item != null;
        });
    }
    function flatten(array) {
        return array.length > 0 ? $.fn.concat.apply([], array) : array;
    }
    camelize = function(str) {
        return str.replace(/-+(.)?/g, function(match, chr) {
            return chr ? chr.toUpperCase() : '';
        });
    };
    function dasherize(str) {
        return str.replace(/::/g, '/').replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2').replace(/([a-z\d])([A-Z])/g, '$1_$2').replace(/_/g, '-').toLowerCase();
    }
    uniq = function(array) {
        return filter.call(array, function(item, idx) {
            return array.indexOf(item) == idx;
        });
    };
    function classRE(name) {
        return name in classCache ? classCache[name] : classCache[name] = new RegExp('(^|\\s)' + name + '(\\s|$)');
    }
    function maybeAddPx(name, value) {
        return typeof value == "number" && !cssNumber[dasherize(name)] ? value + "px" : value;
    }
    function defaultDisplay(nodeName) {
        var element, display;
        if (!elementDisplay[nodeName]) {
            element = document1.createElement(nodeName);
            document1.body.appendChild(element);
            display = getComputedStyle(element, '').getPropertyValue("display");
            element.parentNode.removeChild(element);
            display == "none" && (display = "block");
            elementDisplay[nodeName] = display;
        }
        return elementDisplay[nodeName];
    }
    function children(element) {
        return 'children' in element ? slice.call(element.children) : $.map(element.childNodes, function(node) {
            if (node.nodeType == 1) return node;
        });
    }
    // `$.zepto.fragment` takes a html string and an optional tag name
    // to generate DOM nodes nodes from the given html string.
    // The generated DOM nodes are returned as an array.
    // This function can be overriden in plugins for example to make
    // it compatible with browsers that don't support the DOM fully.
    zepto.fragment = function(html, name, properties) {
        var dom, nodes, container;
        // A special case optimization for a single tag
        if (singleTagRE.test(html)) dom = $(document1.createElement(RegExp.$1));
        if (!dom) {
            if (html.replace) html = html.replace(tagExpanderRE, "<$1></$2>");
            if (name === undefined1) name = fragmentRE.test(html) && RegExp.$1;
            if (!(name in containers)) name = '*';
            container = containers[name];
            container.innerHTML = '' + html;
            dom = $.each(slice.call(container.childNodes), function() {
                container.removeChild(this);
            });
        }
        if (isPlainObject(properties)) {
            nodes = $(dom);
            $.each(properties, function(key, value) {
                if (methodAttributes.indexOf(key) > -1) nodes[key](value);
                else nodes.attr(key, value);
            });
        }
        return dom;
    };
    // `$.zepto.Z` swaps out the prototype of the given `dom` array
    // of nodes with `$.fn` and thus supplying all the Zepto functions
    // to the array. Note that `__proto__` is not supported on Internet
    // Explorer. This method can be overriden in plugins.
    zepto.Z = function(dom, selector) {
        dom = dom || [];
        dom.__proto__ = $.fn;
        dom.selector = selector || '';
        return dom;
    };
    // `$.zepto.isZ` should return `true` if the given object is a Zepto
    // collection. This method can be overriden in plugins.
    zepto.isZ = function(object) {
        return object instanceof zepto.Z;
    };
    // `$.zepto.init` is Zepto's counterpart to jQuery's `$.fn.init` and
    // takes a CSS selector and an optional context (and handles various
    // special cases).
    // This method can be overriden in plugins.
    zepto.init = function(selector, context) {
        var dom;
        // If nothing given, return an empty Zepto collection
        if (!selector) return zepto.Z();
        else if (typeof selector == 'string') {
            selector = selector.trim();
            // If it's a html fragment, create nodes from it
            // Note: In both Chrome 21 and Firefox 15, DOM error 12
            // is thrown if the fragment doesn't begin with <
            if (selector[0] == '<' && fragmentRE.test(selector)) dom = zepto.fragment(selector, RegExp.$1, context), selector = null;
            else if (context !== undefined1) return $(context).find(selector);
            else dom = zepto.qsa(document1, selector);
        } else if (isFunction(selector)) return $(document1).ready(selector);
        else if (zepto.isZ(selector)) return selector;
        else {
            // normalize array if an array of nodes is given
            if (isArray(selector)) dom = compact(selector);
            else if (isObject(selector)) dom = [
                selector
            ], selector = null;
            else if (fragmentRE.test(selector)) dom = zepto.fragment(selector.trim(), RegExp.$1, context), selector = null;
            else if (context !== undefined1) return $(context).find(selector);
            else dom = zepto.qsa(document1, selector);
        }
        // create a new Zepto collection from the nodes found
        return zepto.Z(dom, selector);
    };
    // `$` will be the base `Zepto` object. When calling this
    // function just call `$.zepto.init, which makes the implementation
    // details of selecting nodes and creating Zepto collections
    // patchable in plugins.
    $ = function(selector, context) {
        return zepto.init(selector, context);
    };
    function extend(target, source, deep) {
        for(key in source)if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) target[key] = {};
            if (isArray(source[key]) && !isArray(target[key])) target[key] = [];
            extend(target[key], source[key], deep);
        } else if (source[key] !== undefined1) target[key] = source[key];
    }
    // Copy all but undefined properties from one or more
    // objects to the `target` object.
    $.extend = function(target) {
        var deep, args = slice.call(arguments, 1);
        if (typeof target == 'boolean') {
            deep = target;
            target = args.shift();
        }
        args.forEach(function(arg) {
            extend(target, arg, deep);
        });
        return target;
    };
    // `$.zepto.qsa` is Zepto's CSS selector implementation which
    // uses `document.querySelectorAll` and optimizes for some special cases, like `#id`.
    // This method can be overriden in plugins.
    zepto.qsa = function(element, selector) {
        var found, maybeID = selector[0] == '#', maybeClass = !maybeID && selector[0] == '.', nameOnly = maybeID || maybeClass ? selector.slice(1) : selector, isSimple = simpleSelectorRE.test(nameOnly);
        return isDocument(element) && isSimple && maybeID ? (found = element.getElementById(nameOnly)) ? [
            found
        ] : [] : element.nodeType !== 1 && element.nodeType !== 9 ? [] : slice.call(isSimple && !maybeID ? maybeClass ? element.getElementsByClassName(nameOnly) : element.getElementsByTagName(selector) : element.querySelectorAll(selector) // Or it's not simple, and we need to query all
        );
    };
    function filtered(nodes, selector) {
        return selector == null ? $(nodes) : $(nodes).filter(selector);
    }
    $.contains = function(parent, node) {
        return parent !== node && parent.contains(node);
    };
    function funcArg(context, arg, idx, payload) {
        return isFunction(arg) ? arg.call(context, idx, payload) : arg;
    }
    function setAttribute(node, name, value) {
        value == null ? node.removeAttribute(name) : node.setAttribute(name, value);
    }
    // access className property while respecting SVGAnimatedString
    function className(node, value) {
        var klass = node.className, svg = klass && klass.baseVal !== undefined1;
        if (value === undefined1) return svg ? klass.baseVal : klass;
        svg ? klass.baseVal = value : node.className = value;
    }
    // "true"  => true
    // "false" => false
    // "null"  => null
    // "42"    => 42
    // "42.5"  => 42.5
    // "08"    => "08"
    // JSON    => parse if valid
    // String  => self
    function deserializeValue(value) {
        var num;
        try {
            return value ? value == "true" || (value == "false" ? false : value == "null" ? null : !/^0/.test(value) && !isNaN(num = Number(value)) ? num : /^[\[\{]/.test(value) ? $.parseJSON(value) : value) : value;
        } catch (e) {
            return value;
        }
    }
    $.type = type;
    $.isFunction = isFunction;
    $.isWindow = isWindow;
    $.isArray = isArray;
    $.isPlainObject = isPlainObject;
    $.isEmptyObject = function(obj) {
        var name;
        for(name in obj)return false;
        return true;
    };
    $.inArray = function(elem, array, i) {
        return emptyArray.indexOf.call(array, elem, i);
    };
    $.camelCase = camelize;
    $.trim = function(str) {
        return str == null ? "" : String.prototype.trim.call(str);
    };
    // plugin compatibility
    $.uuid = 0;
    $.support = {};
    $.expr = {};
    $.map = function(elements, callback) {
        var value, values = [], i, key;
        if (likeArray(elements)) for(i = 0; i < elements.length; i++){
            value = callback(elements[i], i);
            if (value != null) values.push(value);
        }
        else for(key in elements){
            value = callback(elements[key], key);
            if (value != null) values.push(value);
        }
        return flatten(values);
    };
    $.each = function(elements, callback) {
        var i, key;
        if (likeArray(elements)) {
            for(i = 0; i < elements.length; i++)if (callback.call(elements[i], i, elements[i]) === false) return elements;
        } else {
            for(key in elements)if (callback.call(elements[key], key, elements[key]) === false) return elements;
        }
        return elements;
    };
    $.grep = function(elements, callback) {
        return filter.call(elements, callback);
    };
    if (window.JSON) $.parseJSON = JSON.parse;
    // Populate the class2type map
    $.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    // Define methods that will be available on all
    // Zepto collections
    $.fn = {
        // Because a collection acts like an array
        // copy over these useful array functions.
        forEach: emptyArray.forEach,
        reduce: emptyArray.reduce,
        push: emptyArray.push,
        sort: emptyArray.sort,
        indexOf: emptyArray.indexOf,
        concat: emptyArray.concat,
        // `map` and `slice` in the jQuery API work differently
        // from their array counterparts
        map: function(fn) {
            return $($.map(this, function(el, i) {
                return fn.call(el, i, el);
            }));
        },
        slice: function() {
            return $(slice.apply(this, arguments));
        },
        ready: function(callback) {
            // need to check if document.body exists for IE as that browser reports
            // document ready when it hasn't yet created the body element
            if (readyRE.test(document1.readyState) && document1.body) callback($);
            else document1.addEventListener('DOMContentLoaded', function() {
                callback($);
            }, false);
            return this;
        },
        get: function(idx) {
            return idx === undefined1 ? slice.call(this) : this[idx >= 0 ? idx : idx + this.length];
        },
        toArray: function() {
            return this.get();
        },
        size: function() {
            return this.length;
        },
        remove: function() {
            return this.each(function() {
                if (this.parentNode != null) this.parentNode.removeChild(this);
            });
        },
        each: function(callback) {
            emptyArray.every.call(this, function(el, idx) {
                return callback.call(el, idx, el) !== false;
            });
            return this;
        },
        filter: function(selector) {
            if (isFunction(selector)) return this.not(this.not(selector));
            return $(filter.call(this, function(element) {
                return zepto.matches(element, selector);
            }));
        },
        add: function(selector, context) {
            return $(uniq(this.concat($(selector, context))));
        },
        is: function(selector) {
            return this.length > 0 && zepto.matches(this[0], selector);
        },
        not: function(selector) {
            var nodes = [];
            if (isFunction(selector) && selector.call !== undefined1) this.each(function(idx) {
                if (!selector.call(this, idx)) nodes.push(this);
            });
            else {
                var excludes = typeof selector == 'string' ? this.filter(selector) : likeArray(selector) && isFunction(selector.item) ? slice.call(selector) : $(selector);
                this.forEach(function(el) {
                    if (excludes.indexOf(el) < 0) nodes.push(el);
                });
            }
            return $(nodes);
        },
        has: function(selector) {
            return this.filter(function() {
                return isObject(selector) ? $.contains(this, selector) : $(this).find(selector).size();
            });
        },
        eq: function(idx) {
            return idx === -1 ? this.slice(idx) : this.slice(idx, +idx + 1);
        },
        first: function() {
            var el = this[0];
            return el && !isObject(el) ? el : $(el);
        },
        last: function() {
            var el = this[this.length - 1];
            return el && !isObject(el) ? el : $(el);
        },
        find: function(selector) {
            var result, $this = this;
            if (typeof selector == 'object') result = $(selector).filter(function() {
                var node = this;
                return emptyArray.some.call($this, function(parent) {
                    return $.contains(parent, node);
                });
            });
            else if (this.length == 1) result = $(zepto.qsa(this[0], selector));
            else result = this.map(function() {
                return zepto.qsa(this, selector);
            });
            return result;
        },
        closest: function(selector, context) {
            var node = this[0], collection = false;
            if (typeof selector == 'object') collection = $(selector);
            while(node && !(collection ? collection.indexOf(node) >= 0 : zepto.matches(node, selector)))node = node !== context && !isDocument(node) && node.parentNode;
            return $(node);
        },
        parents: function(selector) {
            var ancestors = [], nodes = this;
            while(nodes.length > 0)nodes = $.map(nodes, function(node) {
                if ((node = node.parentNode) && !isDocument(node) && ancestors.indexOf(node) < 0) {
                    ancestors.push(node);
                    return node;
                }
            });
            return filtered(ancestors, selector);
        },
        parent: function(selector) {
            return filtered(uniq(this.pluck('parentNode')), selector);
        },
        children: function(selector) {
            return filtered(this.map(function() {
                return children(this);
            }), selector);
        },
        contents: function() {
            return this.map(function() {
                return slice.call(this.childNodes);
            });
        },
        siblings: function(selector) {
            return filtered(this.map(function(i, el) {
                return filter.call(children(el.parentNode), function(child) {
                    return child !== el;
                });
            }), selector);
        },
        empty: function() {
            return this.each(function() {
                this.innerHTML = '';
            });
        },
        // `pluck` is borrowed from Prototype.js
        pluck: function(property) {
            return $.map(this, function(el) {
                return el[property];
            });
        },
        show: function() {
            return this.each(function() {
                this.style.display == "none" && (this.style.display = '');
                if (getComputedStyle(this, '').getPropertyValue("display") == "none") this.style.display = defaultDisplay(this.nodeName);
            });
        },
        replaceWith: function(newContent) {
            return this.before(newContent).remove();
        },
        wrap: function(structure) {
            var func = isFunction(structure);
            if (this[0] && !func) var dom = $(structure).get(0), clone = dom.parentNode || this.length > 1;
            return this.each(function(index) {
                $(this).wrapAll(func ? structure.call(this, index) : clone ? dom.cloneNode(true) : dom);
            });
        },
        wrapAll: function(structure) {
            if (this[0]) {
                $(this[0]).before(structure = $(structure));
                var children;
                // drill down to the inmost element
                while((children = structure.children()).length)structure = children.first();
                $(structure).append(this);
            }
            return this;
        },
        wrapInner: function(structure) {
            var func = isFunction(structure);
            return this.each(function(index) {
                var self = $(this), contents = self.contents(), dom = func ? structure.call(this, index) : structure;
                contents.length ? contents.wrapAll(dom) : self.append(dom);
            });
        },
        unwrap: function() {
            this.parent().each(function() {
                $(this).replaceWith($(this).children());
            });
            return this;
        },
        clone: function() {
            return this.map(function() {
                return this.cloneNode(true);
            });
        },
        hide: function() {
            return this.css("display", "none");
        },
        toggle: function(setting) {
            return this.each(function() {
                var el = $(this);
                (setting === undefined1 ? el.css("display") == "none" : setting) ? el.show() : el.hide();
            });
        },
        prev: function(selector) {
            return $(this.pluck('previousElementSibling')).filter(selector || '*');
        },
        next: function(selector) {
            return $(this.pluck('nextElementSibling')).filter(selector || '*');
        },
        html: function(html) {
            return arguments.length === 0 ? this.length > 0 ? this[0].innerHTML : null : this.each(function(idx) {
                var originHtml = this.innerHTML;
                $(this).empty().append(funcArg(this, html, idx, originHtml));
            });
        },
        text: function(text) {
            return arguments.length === 0 ? this.length > 0 ? this[0].textContent : null : this.each(function() {
                this.textContent = text === undefined1 ? '' : '' + text;
            });
        },
        attr: function(name, value) {
            var result;
            return typeof name == 'string' && value === undefined1 ? this.length == 0 || this[0].nodeType !== 1 ? undefined1 : name == 'value' && this[0].nodeName == 'INPUT' ? this.val() : !(result = this[0].getAttribute(name)) && name in this[0] ? this[0][name] : result : this.each(function(idx) {
                if (this.nodeType !== 1) return;
                if (isObject(name)) for(key in name)setAttribute(this, key, name[key]);
                else setAttribute(this, name, funcArg(this, value, idx, this.getAttribute(name)));
            });
        },
        removeAttr: function(name) {
            return this.each(function() {
                this.nodeType === 1 && setAttribute(this, name);
            });
        },
        prop: function(name, value) {
            name = propMap[name] || name;
            return value === undefined1 ? this[0] && this[0][name] : this.each(function(idx) {
                this[name] = funcArg(this, value, idx, this[name]);
            });
        },
        data: function(name, value) {
            var data = this.attr('data-' + name.replace(capitalRE, '-$1').toLowerCase(), value);
            return data !== null ? deserializeValue(data) : undefined1;
        },
        val: function(value) {
            return arguments.length === 0 ? this[0] && (this[0].multiple ? $(this[0]).find('option').filter(function() {
                return this.selected;
            }).pluck('value') : this[0].value) : this.each(function(idx) {
                this.value = funcArg(this, value, idx, this.value);
            });
        },
        offset: function(coordinates) {
            if (coordinates) return this.each(function(index) {
                var $this = $(this), coords = funcArg(this, coordinates, index, $this.offset()), parentOffset = $this.offsetParent().offset(), props = {
                    top: coords.top - parentOffset.top,
                    left: coords.left - parentOffset.left
                };
                if ($this.css('position') == 'static') props['position'] = 'relative';
                $this.css(props);
            });
            if (this.length == 0) return null;
            var obj = this[0].getBoundingClientRect();
            return {
                left: obj.left + window.pageXOffset,
                top: obj.top + window.pageYOffset,
                width: Math.round(obj.width),
                height: Math.round(obj.height)
            };
        },
        css: function(property, value) {
            if (arguments.length < 2) {
                var element = this[0], computedStyle = getComputedStyle(element, '');
                if (!element) return;
                if (typeof property == 'string') return element.style[camelize(property)] || computedStyle.getPropertyValue(property);
                else if (isArray(property)) {
                    var props = {};
                    $.each(isArray(property) ? property : [
                        property
                    ], function(_, prop) {
                        props[prop] = element.style[camelize(prop)] || computedStyle.getPropertyValue(prop);
                    });
                    return props;
                }
            }
            var css = '';
            if (type(property) == 'string') {
                if (!value && value !== 0) this.each(function() {
                    this.style.removeProperty(dasherize(property));
                });
                else css = dasherize(property) + ":" + maybeAddPx(property, value);
            } else {
                for(key in property)if (!property[key] && property[key] !== 0) this.each(function() {
                    this.style.removeProperty(dasherize(key));
                });
                else css += dasherize(key) + ':' + maybeAddPx(key, property[key]) + ';';
            }
            return this.each(function() {
                this.style.cssText += ';' + css;
            });
        },
        index: function(element) {
            return element ? this.indexOf($(element)[0]) : this.parent().children().indexOf(this[0]);
        },
        hasClass: function(name) {
            if (!name) return false;
            return emptyArray.some.call(this, function(el) {
                return this.test(className(el));
            }, classRE(name));
        },
        addClass: function(name) {
            if (!name) return this;
            return this.each(function(idx) {
                classList = [];
                var cls = className(this), newName = funcArg(this, name, idx, cls);
                newName.split(/\s+/g).forEach(function(klass) {
                    if (!$(this).hasClass(klass)) classList.push(klass);
                }, this);
                classList.length && className(this, cls + (cls ? " " : "") + classList.join(" "));
            });
        },
        removeClass: function(name) {
            return this.each(function(idx) {
                if (name === undefined1) return className(this, '');
                classList = className(this);
                funcArg(this, name, idx, classList).split(/\s+/g).forEach(function(klass) {
                    classList = classList.replace(classRE(klass), " ");
                });
                className(this, classList.trim());
            });
        },
        toggleClass: function(name, when) {
            if (!name) return this;
            return this.each(function(idx) {
                var $this = $(this), names = funcArg(this, name, idx, className(this));
                names.split(/\s+/g).forEach(function(klass) {
                    (when === undefined1 ? !$this.hasClass(klass) : when) ? $this.addClass(klass) : $this.removeClass(klass);
                });
            });
        },
        scrollTop: function(value) {
            if (!this.length) return;
            var hasScrollTop = 'scrollTop' in this[0];
            if (value === undefined1) return hasScrollTop ? this[0].scrollTop : this[0].pageYOffset;
            return this.each(hasScrollTop ? function() {
                this.scrollTop = value;
            } : function() {
                this.scrollTo(this.scrollX, value);
            });
        },
        scrollLeft: function(value) {
            if (!this.length) return;
            var hasScrollLeft = 'scrollLeft' in this[0];
            if (value === undefined1) return hasScrollLeft ? this[0].scrollLeft : this[0].pageXOffset;
            return this.each(hasScrollLeft ? function() {
                this.scrollLeft = value;
            } : function() {
                this.scrollTo(value, this.scrollY);
            });
        },
        position: function() {
            if (!this.length) return;
            var elem = this[0], // Get *real* offsetParent
            offsetParent = this.offsetParent(), // Get correct offsets
            offset = this.offset(), parentOffset = rootNodeRE.test(offsetParent[0].nodeName) ? {
                top: 0,
                left: 0
            } : offsetParent.offset();
            // Subtract element margins
            // note: when an element has margin: auto the offsetLeft and marginLeft
            // are the same in Safari causing offset.left to incorrectly be 0
            offset.top -= parseFloat($(elem).css('margin-top')) || 0;
            offset.left -= parseFloat($(elem).css('margin-left')) || 0;
            // Add offsetParent borders
            parentOffset.top += parseFloat($(offsetParent[0]).css('border-top-width')) || 0;
            parentOffset.left += parseFloat($(offsetParent[0]).css('border-left-width')) || 0;
            // Subtract the two offsets
            return {
                top: offset.top - parentOffset.top,
                left: offset.left - parentOffset.left
            };
        },
        offsetParent: function() {
            return this.map(function() {
                var parent = this.offsetParent || document1.body;
                while(parent && !rootNodeRE.test(parent.nodeName) && $(parent).css("position") == "static")parent = parent.offsetParent;
                return parent;
            });
        }
    };
    // for now
    $.fn.detach = $.fn.remove;
    [
        'width',
        'height'
    ].forEach(function(dimension) {
        var dimensionProperty = dimension.replace(/./, function(m) {
            return m[0].toUpperCase();
        });
        $.fn[dimension] = function(value) {
            var offset, el = this[0];
            if (value === undefined1) return isWindow(el) ? el['inner' + dimensionProperty] : isDocument(el) ? el.documentElement['scroll' + dimensionProperty] : (offset = this.offset()) && offset[dimension];
            else return this.each(function(idx) {
                el = $(this);
                el.css(dimension, funcArg(this, value, idx, el[dimension]()));
            });
        };
    });
    function traverseNode(node, fun) {
        fun(node);
        for(var key in node.childNodes)traverseNode(node.childNodes[key], fun);
    }
    // Generate the `after`, `prepend`, `before`, `append`,
    // `insertAfter`, `insertBefore`, `appendTo`, and `prependTo` methods.
    adjacencyOperators.forEach(function(operator, operatorIndex) {
        var inside = operatorIndex % 2 //=> prepend, append
        ;
        $.fn[operator] = function() {
            // arguments can be nodes, arrays of nodes, Zepto objects and HTML strings
            var argType, nodes = $.map(arguments, function(arg) {
                argType = type(arg);
                return argType == "object" || argType == "array" || arg == null ? arg : zepto.fragment(arg);
            }), parent, copyByClone = this.length > 1;
            if (nodes.length < 1) return this;
            return this.each(function(_, target) {
                parent = inside ? target : target.parentNode;
                // convert all methods to a "before" operation
                target = operatorIndex == 0 ? target.nextSibling : operatorIndex == 1 ? target.firstChild : operatorIndex == 2 ? target : null;
                nodes.forEach(function(node) {
                    if (copyByClone) node = node.cloneNode(true);
                    else if (!parent) return $(node).remove();
                    traverseNode(parent.insertBefore(node, target), function(el) {
                        if (el.nodeName != null && el.nodeName.toUpperCase() === 'SCRIPT' && (!el.type || el.type === 'text/javascript') && !el.src) window['eval'].call(window, el.innerHTML);
                    });
                });
            });
        };
        // after    => insertAfter
        // prepend  => prependTo
        // before   => insertBefore
        // append   => appendTo
        $.fn[inside ? operator + 'To' : 'insert' + (operatorIndex ? 'Before' : 'After')] = function(html) {
            $(html)[operator](this);
            return this;
        };
    });
    zepto.Z.prototype = $.fn;
    // Export internal API functions in the `$.zepto` namespace
    zepto.uniq = uniq;
    zepto.deserializeValue = deserializeValue;
    $.zepto = zepto;
    return $;
}();
window.Zepto = $7f99b552874efbe4$var$Zepto;
window.$ === undefined && (window.$ = $7f99b552874efbe4$var$Zepto);
(function($) {
    var $$ = $.zepto.qsa, _zid = 1, undefined1, slice = Array.prototype.slice, isFunction = $.isFunction, isString = function(obj) {
        return typeof obj == 'string';
    }, handlers = {}, specialEvents = {}, focusinSupported = 'onfocusin' in window, focus = {
        focus: 'focusin',
        blur: 'focusout'
    }, hover = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout'
    };
    specialEvents.click = specialEvents.mousedown = specialEvents.mouseup = specialEvents.mousemove = 'MouseEvents';
    function zid(element) {
        return element._zid || (element._zid = _zid++);
    }
    function findHandlers(element, event, fn, selector) {
        event = parse(event);
        if (event.ns) var matcher = matcherFor(event.ns);
        return (handlers[zid(element)] || []).filter(function(handler) {
            return handler && (!event.e || handler.e == event.e) && (!event.ns || matcher.test(handler.ns)) && (!fn || zid(handler.fn) === zid(fn)) && (!selector || handler.sel == selector);
        });
    }
    function parse(event) {
        var parts = ('' + event).split('.');
        return {
            e: parts[0],
            ns: parts.slice(1).sort().join(' ')
        };
    }
    function matcherFor(ns) {
        return new RegExp('(?:^| )' + ns.replace(' ', ' .* ?') + '(?: |$)');
    }
    function eventCapture(handler, captureSetting) {
        return handler.del && !focusinSupported && handler.e in focus || !!captureSetting;
    }
    function realEvent(type) {
        return hover[type] || focusinSupported && focus[type] || type;
    }
    function add(element, events, fn, data, selector, delegator, capture) {
        var id = zid(element), set = handlers[id] || (handlers[id] = []);
        events.split(/\s/).forEach(function(event) {
            if (event == 'ready') return $(document).ready(fn);
            var handler = parse(event);
            handler.fn = fn;
            handler.sel = selector;
            // emulate mouseenter, mouseleave
            if (handler.e in hover) fn = function(e) {
                var related = e.relatedTarget;
                if (!related || related !== this && !$.contains(this, related)) return handler.fn.apply(this, arguments);
            };
            handler.del = delegator;
            var callback = delegator || fn;
            handler.proxy = function(e) {
                e = compatible(e);
                if (e.isImmediatePropagationStopped()) return;
                e.data = data;
                var result = callback.apply(element, e._args == undefined1 ? [
                    e
                ] : [
                    e
                ].concat(e._args));
                if (result === false) e.preventDefault(), e.stopPropagation();
                return result;
            };
            handler.i = set.length;
            set.push(handler);
            if ('addEventListener' in element) element.addEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture));
        });
    }
    function remove(element, events, fn, selector, capture) {
        var id = zid(element);
        (events || '').split(/\s/).forEach(function(event) {
            findHandlers(element, event, fn, selector).forEach(function(handler) {
                delete handlers[id][handler.i];
                if ('removeEventListener' in element) element.removeEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture));
            });
        });
    }
    $.event = {
        add: add,
        remove: remove
    };
    $.proxy = function(fn, context) {
        if (isFunction(fn)) {
            var proxyFn = function() {
                return fn.apply(context, arguments);
            };
            proxyFn._zid = zid(fn);
            return proxyFn;
        } else if (isString(context)) return $.proxy(fn[context], fn);
        else throw new TypeError("expected function");
    };
    $.fn.bind = function(event, data, callback) {
        return this.on(event, data, callback);
    };
    $.fn.unbind = function(event, callback) {
        return this.off(event, callback);
    };
    $.fn.one = function(event, selector, data, callback) {
        return this.on(event, selector, data, callback, 1);
    };
    var returnTrue = function() {
        return true;
    }, returnFalse = function() {
        return false;
    }, ignoreProperties = /^([A-Z]|returnValue$|layer[XY]$)/, eventMethods = {
        preventDefault: 'isDefaultPrevented',
        stopImmediatePropagation: 'isImmediatePropagationStopped',
        stopPropagation: 'isPropagationStopped'
    };
    function compatible(event, source) {
        if (source || !event.isDefaultPrevented) {
            source || (source = event);
            $.each(eventMethods, function(name, predicate) {
                var sourceMethod = source[name];
                event[name] = function() {
                    this[predicate] = returnTrue;
                    return sourceMethod && sourceMethod.apply(source, arguments);
                };
                event[predicate] = returnFalse;
            });
            if (source.defaultPrevented !== undefined1 ? source.defaultPrevented : 'returnValue' in source ? source.returnValue === false : source.getPreventDefault && source.getPreventDefault()) event.isDefaultPrevented = returnTrue;
        }
        return event;
    }
    function createProxy(event) {
        var key, proxy = {
            originalEvent: event
        };
        for(key in event)if (!ignoreProperties.test(key) && event[key] !== undefined1) proxy[key] = event[key];
        return compatible(proxy, event);
    }
    $.fn.delegate = function(selector, event, callback) {
        return this.on(event, selector, callback);
    };
    $.fn.undelegate = function(selector, event, callback) {
        return this.off(event, selector, callback);
    };
    $.fn.live = function(event, callback) {
        $(document.body).delegate(this.selector, event, callback);
        return this;
    };
    $.fn.die = function(event, callback) {
        $(document.body).undelegate(this.selector, event, callback);
        return this;
    };
    $.fn.on = function(event, selector, data, callback, one) {
        var autoRemove, delegator, $this = this;
        if (event && !isString(event)) {
            $.each(event, function(type, fn) {
                $this.on(type, selector, data, fn, one);
            });
            return $this;
        }
        if (!isString(selector) && !isFunction(callback) && callback !== false) callback = data, data = selector, selector = undefined1;
        if (isFunction(data) || data === false) callback = data, data = undefined1;
        if (callback === false) callback = returnFalse;
        return $this.each(function(_, element) {
            if (one) autoRemove = function(e) {
                remove(element, e.type, callback);
                return callback.apply(this, arguments);
            };
            if (selector) delegator = function(e) {
                var evt, match = $(e.target).closest(selector, element).get(0);
                if (match && match !== element) {
                    evt = $.extend(createProxy(e), {
                        currentTarget: match,
                        liveFired: element
                    });
                    return (autoRemove || callback).apply(match, [
                        evt
                    ].concat(slice.call(arguments, 1)));
                }
            };
            add(element, event, callback, data, selector, delegator || autoRemove);
        });
    };
    $.fn.off = function(event, selector, callback) {
        var $this = this;
        if (event && !isString(event)) {
            $.each(event, function(type, fn) {
                $this.off(type, selector, fn);
            });
            return $this;
        }
        if (!isString(selector) && !isFunction(callback) && callback !== false) callback = selector, selector = undefined1;
        if (callback === false) callback = returnFalse;
        return $this.each(function() {
            remove(this, event, callback, selector);
        });
    };
    $.fn.trigger = function(event, args) {
        event = isString(event) || $.isPlainObject(event) ? $.Event(event) : compatible(event);
        event._args = args;
        return this.each(function() {
            // items in the collection might not be DOM elements
            if ('dispatchEvent' in this) this.dispatchEvent(event);
            else $(this).triggerHandler(event, args);
        });
    };
    // triggers event handlers on current element just as if an event occurred,
    // doesn't trigger an actual event, doesn't bubble
    $.fn.triggerHandler = function(event, args) {
        var e, result;
        this.each(function(i, element) {
            e = createProxy(isString(event) ? $.Event(event) : event);
            e._args = args;
            e.target = element;
            $.each(findHandlers(element, event.type || event), function(i, handler) {
                result = handler.proxy(e);
                if (e.isImmediatePropagationStopped()) return false;
            });
        });
        return result;
    };
    "focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select keydown keypress keyup error".split(' ').forEach(function(event) {
        $.fn[event] = function(callback) {
            return callback ? this.bind(event, callback) : this.trigger(event);
        };
    });
    [
        'focus',
        'blur'
    ].forEach(function(name) {
        $.fn[name] = function(callback) {
            if (callback) this.bind(name, callback);
            else this.each(function() {
                try {
                    this[name]();
                } catch (e) {}
            });
            return this;
        };
    });
    $.Event = function(type, props) {
        if (!isString(type)) props = type, type = props.type;
        var event = document.createEvent(specialEvents[type] || 'Events'), bubbles = true;
        if (props) for(var name in props)name == 'bubbles' ? bubbles = !!props[name] : event[name] = props[name];
        event.initEvent(type, bubbles, true);
        return compatible(event);
    };
})($7f99b552874efbe4$var$Zepto);
(function($) {
    var jsonpID = 0, document1 = window.document, key, name, rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, scriptTypeRE = /^(?:text|application)\/javascript/i, xmlTypeRE = /^(?:text|application)\/xml/i, jsonType = 'application/json', htmlType = 'text/html', blankRE = /^\s*$/;
    // trigger a custom event and return false if it was cancelled
    function triggerAndReturn(context, eventName, data) {
        var event = $.Event(eventName);
        $(context).trigger(event, data);
        return !event.isDefaultPrevented();
    }
    // trigger an Ajax "global" event
    function triggerGlobal(settings, context, eventName, data) {
        if (settings.global) return triggerAndReturn(context || document1, eventName, data);
    }
    // Number of active Ajax requests
    $.active = 0;
    function ajaxStart(settings) {
        if (settings.global && $.active++ === 0) triggerGlobal(settings, null, 'ajaxStart');
    }
    function ajaxStop(settings) {
        if (settings.global && !--$.active) triggerGlobal(settings, null, 'ajaxStop');
    }
    // triggers an extra global event "ajaxBeforeSend" that's like "ajaxSend" but cancelable
    function ajaxBeforeSend(xhr, settings) {
        var context = settings.context;
        if (settings.beforeSend.call(context, xhr, settings) === false || triggerGlobal(settings, context, 'ajaxBeforeSend', [
            xhr,
            settings
        ]) === false) return false;
        triggerGlobal(settings, context, 'ajaxSend', [
            xhr,
            settings
        ]);
    }
    function ajaxSuccess(data, xhr, settings, deferred) {
        var context = settings.context, status = 'success';
        settings.success.call(context, data, status, xhr);
        if (deferred) deferred.resolveWith(context, [
            data,
            status,
            xhr
        ]);
        triggerGlobal(settings, context, 'ajaxSuccess', [
            xhr,
            settings,
            data
        ]);
        ajaxComplete(status, xhr, settings);
    }
    // type: "timeout", "error", "abort", "parsererror"
    function ajaxError(error, type, xhr, settings, deferred) {
        var context = settings.context;
        settings.error.call(context, xhr, type, error);
        if (deferred) deferred.rejectWith(context, [
            xhr,
            type,
            error
        ]);
        triggerGlobal(settings, context, 'ajaxError', [
            xhr,
            settings,
            error || type
        ]);
        ajaxComplete(type, xhr, settings);
    }
    // status: "success", "notmodified", "error", "timeout", "abort", "parsererror"
    function ajaxComplete(status, xhr, settings) {
        var context = settings.context;
        settings.complete.call(context, xhr, status);
        triggerGlobal(settings, context, 'ajaxComplete', [
            xhr,
            settings
        ]);
        ajaxStop(settings);
    }
    // Empty function, used as default callback
    function empty() {}
    $.ajaxJSONP = function(options, deferred) {
        if (!('type' in options)) return $.ajax(options);
        var _callbackName = options.jsonpCallback, callbackName = ($.isFunction(_callbackName) ? _callbackName() : _callbackName) || 'jsonp' + ++jsonpID, script = document1.createElement('script'), originalCallback = window[callbackName], responseData, abort = function(errorType) {
            $(script).triggerHandler('error', errorType || 'abort');
        }, xhr = {
            abort: abort
        }, abortTimeout;
        if (deferred) deferred.promise(xhr);
        $(script).on('load error', function(e, errorType) {
            clearTimeout(abortTimeout);
            $(script).off().remove();
            if (e.type == 'error' || !responseData) ajaxError(null, errorType || 'error', xhr, options, deferred);
            else ajaxSuccess(responseData[0], xhr, options, deferred);
            window[callbackName] = originalCallback;
            if (responseData && $.isFunction(originalCallback)) originalCallback(responseData[0]);
            originalCallback = responseData = undefined;
        });
        if (ajaxBeforeSend(xhr, options) === false) {
            abort('abort');
            return xhr;
        }
        window[callbackName] = function() {
            responseData = arguments;
        };
        script.src = options.url.replace(/\?(.+)=\?/, '?$1=' + callbackName);
        document1.head.appendChild(script);
        if (options.timeout > 0) abortTimeout = setTimeout(function() {
            abort('timeout');
        }, options.timeout);
        return xhr;
    };
    $.ajaxSettings = {
        // Default type of request
        type: 'GET',
        // Callback that is executed before request
        beforeSend: empty,
        // Callback that is executed if the request succeeds
        success: empty,
        // Callback that is executed the the server drops error
        error: empty,
        // Callback that is executed on request complete (both: error and success)
        complete: empty,
        // The context for the callbacks
        context: null,
        // Whether to trigger "global" Ajax events
        global: true,
        // Transport
        xhr: function() {
            return new window.XMLHttpRequest();
        },
        // MIME types mapping
        // IIS returns Javascript as "application/x-javascript"
        accepts: {
            script: 'text/javascript, application/javascript, application/x-javascript',
            json: jsonType,
            xml: 'application/xml, text/xml',
            html: htmlType,
            text: 'text/plain'
        },
        // Whether the request is to another domain
        crossDomain: false,
        // Default timeout
        timeout: 0,
        // Whether data should be serialized to string
        processData: true,
        // Whether the browser should be allowed to cache GET responses
        cache: true
    };
    function mimeToDataType(mime) {
        if (mime) mime = mime.split(';', 2)[0];
        return mime && (mime == htmlType ? 'html' : mime == jsonType ? 'json' : scriptTypeRE.test(mime) ? 'script' : xmlTypeRE.test(mime) && 'xml') || 'text';
    }
    function appendQuery(url, query) {
        if (query == '') return url;
        return (url + '&' + query).replace(/[&?]{1,2}/, '?');
    }
    // serialize payload and append it to the URL for GET requests
    function serializeData(options) {
        if (options.processData && options.data && $.type(options.data) != "string") options.data = $.param(options.data, options.traditional);
        if (options.data && (!options.type || options.type.toUpperCase() == 'GET')) options.url = appendQuery(options.url, options.data), options.data = undefined;
    }
    $.ajax = function(options) {
        var settings = $.extend({}, options || {}), deferred = $.Deferred && $.Deferred();
        for(key in $.ajaxSettings)if (settings[key] === undefined) settings[key] = $.ajaxSettings[key];
        ajaxStart(settings);
        if (!settings.crossDomain) settings.crossDomain = /^([\w-]+:)?\/\/([^\/]+)/.test(settings.url) && RegExp.$2 != window.location.host;
        if (!settings.url) settings.url = window.location.toString();
        serializeData(settings);
        if (settings.cache === false) settings.url = appendQuery(settings.url, '_=' + Date.now());
        var dataType = settings.dataType, hasPlaceholder = /\?.+=\?/.test(settings.url);
        if (dataType == 'jsonp' || hasPlaceholder) {
            if (!hasPlaceholder) settings.url = appendQuery(settings.url, settings.jsonp ? settings.jsonp + '=?' : settings.jsonp === false ? '' : 'callback=?');
            return $.ajaxJSONP(settings, deferred);
        }
        var mime = settings.accepts[dataType], headers = {}, setHeader = function(name, value) {
            headers[name.toLowerCase()] = [
                name,
                value
            ];
        }, protocol = /^([\w-]+:)\/\//.test(settings.url) ? RegExp.$1 : window.location.protocol, xhr = settings.xhr(), nativeSetHeader = xhr.setRequestHeader, abortTimeout;
        if (deferred) deferred.promise(xhr);
        if (!settings.crossDomain) setHeader('X-Requested-With', 'XMLHttpRequest');
        setHeader('Accept', mime || '*/*');
        if (mime = settings.mimeType || mime) {
            if (mime.indexOf(',') > -1) mime = mime.split(',', 2)[0];
            xhr.overrideMimeType && xhr.overrideMimeType(mime);
        }
        if (settings.contentType || settings.contentType !== false && settings.data && settings.type.toUpperCase() != 'GET') setHeader('Content-Type', settings.contentType || 'application/x-www-form-urlencoded');
        if (settings.headers) for(name in settings.headers)setHeader(name, settings.headers[name]);
        xhr.setRequestHeader = setHeader;
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                xhr.onreadystatechange = empty;
                clearTimeout(abortTimeout);
                var result, error = false;
                if (xhr.status >= 200 && xhr.status < 300 || xhr.status == 304 || xhr.status == 0 && protocol == 'file:') {
                    dataType = dataType || mimeToDataType(settings.mimeType || xhr.getResponseHeader('content-type'));
                    result = xhr.responseText;
                    try {
                        // http://perfectionkills.com/global-eval-what-are-the-options/
                        if (dataType == 'script') (0, eval)(result);
                        else if (dataType == 'xml') result = xhr.responseXML;
                        else if (dataType == 'json') result = blankRE.test(result) ? null : $.parseJSON(result);
                    } catch (e) {
                        error = e;
                    }
                    if (error) ajaxError(error, 'parsererror', xhr, settings, deferred);
                    else ajaxSuccess(result, xhr, settings, deferred);
                } else ajaxError(xhr.statusText || null, xhr.status ? 'error' : 'abort', xhr, settings, deferred);
            }
        };
        if (ajaxBeforeSend(xhr, settings) === false) {
            xhr.abort();
            ajaxError(null, 'abort', xhr, settings, deferred);
            return xhr;
        }
        if (settings.xhrFields) for(name in settings.xhrFields)xhr[name] = settings.xhrFields[name];
        var async = 'async' in settings ? settings.async : true;
        xhr.open(settings.type, settings.url, async, settings.username, settings.password);
        for(name in headers)nativeSetHeader.apply(xhr, headers[name]);
        if (settings.timeout > 0) abortTimeout = setTimeout(function() {
            xhr.onreadystatechange = empty;
            xhr.abort();
            ajaxError(null, 'timeout', xhr, settings, deferred);
        }, settings.timeout);
        // avoid sending empty string (#319)
        xhr.send(settings.data ? settings.data : null);
        return xhr;
    };
    // handle optional data/success arguments
    function parseArguments(url, data, success, dataType) {
        var hasData = !$.isFunction(data);
        return {
            url: url,
            data: hasData ? data : undefined,
            success: !hasData ? data : $.isFunction(success) ? success : undefined,
            dataType: hasData ? dataType || success : success
        };
    }
    $.get = function(url, data, success, dataType) {
        return $.ajax(parseArguments.apply(null, arguments));
    };
    $.post = function(url, data, success, dataType) {
        var options = parseArguments.apply(null, arguments);
        options.type = 'POST';
        return $.ajax(options);
    };
    $.getJSON = function(url, data, success) {
        var options = parseArguments.apply(null, arguments);
        options.dataType = 'json';
        return $.ajax(options);
    };
    /**
     * Add a promisified option to better handle cases where we need the data 
     * asynchronously.
     * @param {String} url 
     */ $.fetchJSON = function(url) {
        var request = new XMLHttpRequest();
        return new Promise(function(resolve, reject) {
            // Setup our listener to process compeleted requests
            request.onreadystatechange = function() {
                try {
                    // Only run if the request is complete
                    if (request.readyState !== 4) return;
                    // Process the response
                    if (request.status >= 200 && request.status < 300) {
                        var json = JSON.parse(request.responseText);
                        resolve(json);
                    } else reject({
                        status: request.status,
                        statusText: request.statusText
                    });
                } catch (e) {
                    reject({
                        status: 400,
                        statusText: `Error fetching JSON from ${url}: ${e}`
                    });
                }
            };
            // Setup our HTTP request
            request.open('GET', url, true);
            // Send the request
            request.send();
        });
    };
    $.fn.load = function(url, data, success) {
        if (!this.length) return this;
        var self = this, parts = url.split(/\s/), selector, options = parseArguments(url, data, success), callback = options.success;
        if (parts.length > 1) options.url = parts[0], selector = parts[1];
        options.success = function(response) {
            self.html(selector ? $('<div>').html(response.replace(rscript, "")).find(selector) : response);
            callback && callback.apply(self, arguments);
        };
        $.ajax(options);
        return this;
    };
    var escape = encodeURIComponent;
    function serialize(params, obj, traditional, scope) {
        var type, array = $.isArray(obj), hash = $.isPlainObject(obj);
        $.each(obj, function(key, value) {
            type = $.type(value);
            if (scope) key = traditional ? scope : scope + '[' + (hash || type == 'object' || type == 'array' ? key : '') + ']';
            // handle data in serializeArray() format
            if (!scope && array) params.add(value.name, value.value);
            else if (type == "array" || !traditional && type == "object") serialize(params, value, traditional, key);
            else params.add(key, value);
        });
    }
    $.param = function(obj, traditional) {
        var params = [];
        params.add = function(k, v) {
            this.push(escape(k) + '=' + escape(v));
        };
        serialize(params, obj, traditional);
        return params.join('&').replace(/%20/g, '+');
    };
})($7f99b552874efbe4$var$Zepto);
(function($) {
    $.fn.serializeArray = function() {
        var result = [], el;
        $([].slice.call(this.get(0).elements)).each(function() {
            el = $(this);
            var type = el.attr('type');
            if (this.nodeName.toLowerCase() != 'fieldset' && !this.disabled && type != 'submit' && type != 'reset' && type != 'button' && (type != 'radio' && type != 'checkbox' || this.checked)) result.push({
                name: el.attr('name'),
                value: el.val()
            });
        });
        return result;
    };
    $.fn.serialize = function() {
        var result = [];
        this.serializeArray().forEach(function(elm) {
            result.push(encodeURIComponent(elm.name) + '=' + encodeURIComponent(elm.value));
        });
        return result.join('&');
    };
    $.fn.submit = function(callback) {
        if (callback) this.bind('submit', callback);
        else if (this.length) {
            var event = $.Event('submit');
            this.eq(0).trigger(event);
            if (!event.isDefaultPrevented()) this.get(0).submit();
        }
        return this;
    };
})($7f99b552874efbe4$var$Zepto);
(function($) {
    // __proto__ doesn't exist on IE<11, so redefine
    // the Z function to use object extension instead
    if (!('__proto__' in {})) $.extend($.zepto, {
        Z: function(dom, selector) {
            dom = dom || [];
            $.extend(dom, $.fn);
            dom.selector = selector || '';
            dom.__Z = true;
            return dom;
        },
        // this is a kludge but works
        isZ: function(object) {
            return $.type(object) === 'array' && '__Z' in object;
        }
    });
    // getComputedStyle shouldn't freak out when called
    // without a valid element as argument
    try {
        getComputedStyle(undefined);
    } catch (e) {
        var nativeGetComputedStyle = getComputedStyle;
        window.getComputedStyle = function(element, pseudoElement) {
            try {
                return nativeGetComputedStyle(element, pseudoElement);
            } catch (e) {
                return null;
            }
        };
    }
})($7f99b552874efbe4$var$Zepto);
const $7f99b552874efbe4$export$d047a7c56db64af4 = $7f99b552874efbe4$var$Zepto.getJSON;
const $7f99b552874efbe4$export$e68fce4c5f453854 = $7f99b552874efbe4$var$Zepto.ajax;
const $7f99b552874efbe4$export$81bec6e38e8b706b = $7f99b552874efbe4$var$Zepto.fetchJSON; //     Based on https://github.com/madrobby/zepto/blob/5585fe00f1828711c04208372265a5d71e3238d1/src/ajax.js
 //     Zepto.js
 //     (c) 2010-2012 Thomas Fuchs
 //     Zepto.js may be freely distributed under the MIT license.
 /*
Copyright (c) 2010-2012 Thomas Fuchs
http://zeptojs.com

Permission is hereby granted, free of charge, to any person obtaining a copy 
of this software and associated documentation files (the "Software"), to deal 
in the Software without restriction, including without limitation the rights 
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell 
copies of the Software, and to permit persons to whom the Software is 
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all 
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR 
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, 
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE 
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER 
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE 
SOFTWARE.
*/ 


/*	Date
	Date object
	MONTHS are 1-BASED, not 0-BASED (different from Javascript date objects)
================================================== */ 



const $8d19420aa75ccebb$export$9c2218f463f17dc5 = [
    // ( name, units_per_tick, flooring function )
    [
        "millisecond",
        1,
        function(d) {}
    ],
    [
        "second",
        1000,
        function(d) {
            d.setMilliseconds(0);
        }
    ],
    [
        "minute",
        60000,
        function(d) {
            d.setSeconds(0);
        }
    ],
    [
        "hour",
        3600000,
        function(d) {
            d.setMinutes(0);
        }
    ],
    [
        "day",
        86400000,
        function(d) {
            d.setHours(0);
        }
    ],
    [
        "month",
        2592000000,
        function(d) {
            d.setDate(1);
        }
    ],
    [
        "year",
        31536000000,
        function(d) {
            d.setMonth(0);
        }
    ],
    [
        "decade",
        315360000000,
        function(d) {
            var real_year = d.getFullYear();
            d.setFullYear(real_year - real_year % 10);
        }
    ],
    [
        "century",
        3153600000000,
        function(d) {
            var real_year = d.getFullYear();
            d.setFullYear(real_year - real_year % 100);
        }
    ],
    [
        "millennium",
        31536000000000,
        function(d) {
            var real_year = d.getFullYear();
            d.setFullYear(real_year - real_year % 1000);
        }
    ]
];
// Date parts from highest to lowest precision
const $8d19420aa75ccebb$var$DATE_PARTS = [
    "millisecond",
    "second",
    "minute",
    "hour",
    "day",
    "month",
    "year"
];
const $8d19420aa75ccebb$var$ISO8601_SHORT_PATTERN = /^([\+-]?\d+?)(-\d{2}?)?(-\d{2}?)?$/;
// regex below from
// http://www.pelagodesign.com/blog/2009/05/20/iso-8601-date-validation-that-doesnt-suck/
const $8d19420aa75ccebb$var$ISO8601_PATTERN = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
/* For now, rather than extract parts from regexp, lets trust the browser.
 * Famous last words...
 * What about UTC vs local time?
 * see also http://stackoverflow.com/questions/10005374/ecmascript-5-date-parse-results-for-iso-8601-test-cases
 */ function $8d19420aa75ccebb$var$parseISODate(str) {
    var d = new Date(str); // this is a true JavaScript date, not a TLDate
    if (isNaN(d)) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_date_err", str);
    return {
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        day: d.getDate(),
        hour: d.getHours(),
        minute: d.getMinutes(),
        second: d.getSeconds(),
        millisecond: d.getMilliseconds()
    };
}
const $8d19420aa75ccebb$var$BEST_DATEFORMATS = {
    base: {
        millisecond: "time_short",
        second: "time",
        minute: "time_no_seconds_small_date",
        hour: "time_no_seconds_small_date",
        day: "full",
        month: "month",
        year: "year",
        decade: "year",
        century: "year",
        millennium: "year",
        age: "fallback",
        epoch: "fallback",
        era: "fallback",
        eon: "fallback",
        eon2: "fallback"
    },
    short: {
        millisecond: "time_short",
        second: "time_short",
        minute: "time_no_seconds_short",
        hour: "time_no_minutes_short",
        day: "full_short",
        month: "month_short",
        year: "year",
        decade: "year",
        century: "year",
        millennium: "year",
        age: "fallback",
        epoch: "fallback",
        era: "fallback",
        eon: "fallback",
        eon2: "fallback"
    }
};
const $8d19420aa75ccebb$export$f39ff3a2b9f665c1 = (0, $aede701022b5d50a$export$7d0ecf6d8e5abad6).extend({
    // @data = ms, JS Date object, or JS dictionary with date properties
    initialize: function(data, format, format_short) {
        if (typeof data == "number") this.data = {
            format: "yyyy mmmm",
            date_obj: new Date(data)
        };
        else if (Date == data.constructor) this.data = {
            format: "yyyy mmmm",
            date_obj: data
        };
        else {
            this.data = JSON.parse(JSON.stringify(data)); // clone don't use by reference.
            this._createDateObj();
        }
        if (data.format && !format) format = data.format;
        this._setFormat(format, format_short);
    },
    setDateFormat: function(format) {
        this.data.format = format;
    },
    /**
     * Return a string representation of this date. If this date has been created with a `display_date` property,
     * that value is always returned, regardless of arguments to the method invocation. Otherwise,
     * the given `Language` is asked to create a string representation based on this Date's data, passing through the provided
     * `format` String, or, if that is undefined, this date's default format string.
     * @param {Language} language
     * @param {String} format
     * @returns {String} formattedDate
     */ getDisplayDate: function(language, format) {
        if (this.data.display_date) return this.data.display_date;
        if (!language) language = (0, $3bd1753d03e195ea$export$ce4fe1c9e6520c1a).fallback;
        if (language.constructor != (0, $3bd1753d03e195ea$export$ce4fe1c9e6520c1a)) {
            (0, $ea7d21fd242a7c44$export$357889f174732d38)("First argument to getDisplayDate must be type Language");
            language = (0, $3bd1753d03e195ea$export$ce4fe1c9e6520c1a).fallback;
        }
        var format_key = format || this.data.format;
        return language.formatDate(this.data.date_obj, format_key);
    },
    getMillisecond: function() {
        return this.getTime();
    },
    getTime: function() {
        return this.data.date_obj.getTime();
    },
    isBefore: function(other_date) {
        if (!this.data.date_obj.constructor == other_date.data.date_obj.constructor) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("date_compare_err"); // but should be able to compare 'cosmological scale' dates once we get to that...
        if ("isBefore" in this.data.date_obj) return this.data.date_obj["isBefore"](other_date.data.date_obj);
        return this.data.date_obj < other_date.data.date_obj;
    },
    isAfter: function(other_date) {
        if (!this.data.date_obj.constructor == other_date.data.date_obj.constructor) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("date_compare_err"); // but should be able to compare 'cosmological scale' dates once we get to that...
        if ("isAfter" in this.data.date_obj) return this.data.date_obj["isAfter"](other_date.data.date_obj);
        return this.data.date_obj > other_date.data.date_obj;
    },
    // Return a new TLDate which has been 'floored' at the given scale.
    // @scale = string value from SCALES
    floor: function(scale) {
        var d = new Date(this.data.date_obj.getTime());
        for(var i = 0; i < $8d19420aa75ccebb$export$9c2218f463f17dc5.length; i++){
            // for JS dates, we iteratively apply flooring functions
            $8d19420aa75ccebb$export$9c2218f463f17dc5[i][2](d);
            if ($8d19420aa75ccebb$export$9c2218f463f17dc5[i][0] == scale) return new $8d19420aa75ccebb$export$f39ff3a2b9f665c1(d);
        }
        throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_scale_err", scale);
    },
    /*	Private Methods
	================================================== */ _getDateData: function() {
        var _date = {
            year: 0,
            month: 1,
            day: 1,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
        };
        // Merge data
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(_date, this.data);
        // Make strings into numbers
        for(var ix in $8d19420aa75ccebb$var$DATE_PARTS){
            var x = (0, $ea7d21fd242a7c44$export$87c2784dc9fc4ab)(_date[$8d19420aa75ccebb$var$DATE_PARTS[ix]]);
            if (!x.match(/^-?\d*$/)) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_date_err", $8d19420aa75ccebb$var$DATE_PARTS[ix] + " = '" + _date[$8d19420aa75ccebb$var$DATE_PARTS[ix]] + "'");
            var parsed = parseInt(_date[$8d19420aa75ccebb$var$DATE_PARTS[ix]]);
            if (isNaN(parsed)) parsed = ix == 4 || ix == 5 ? 1 : 0; // month and day have diff baselines
            _date[$8d19420aa75ccebb$var$DATE_PARTS[ix]] = parsed;
        }
        if (_date.month > 0 && _date.month <= 12) // adjust for JS's weirdness
        _date.month = _date.month - 1;
        return _date;
    },
    _createDateObj: function() {
        var _date = this._getDateData();
        this.data.date_obj = new Date(_date.year, _date.month, _date.day, _date.hour, _date.minute, _date.second, _date.millisecond);
        if (this.data.date_obj.getFullYear() != _date.year) // Javascript has stupid defaults for two-digit years
        this.data.date_obj.setFullYear(_date.year);
    },
    /*  Find Best Format
     * this may not work with 'cosmologic' dates, or with TLDate if we
     * support constructing them based on JS Date and time
    ================================================== */ findBestFormat: function(variant) {
        var eval_array = $8d19420aa75ccebb$var$DATE_PARTS, format = "";
        for(var i = 0; i < eval_array.length; i++)if (this.data[eval_array[i]]) {
            if (variant) {
                if (!(variant in $8d19420aa75ccebb$var$BEST_DATEFORMATS)) variant = "short"; // legacy
            } else variant = "base";
            return $8d19420aa75ccebb$var$BEST_DATEFORMATS[variant][eval_array[i]];
        }
        return "";
    },
    _setFormat: function(format, format_short) {
        if (format) this.data.format = format;
        else if (!this.data.format) this.data.format = this.findBestFormat();
        if (format_short) this.data.format_short = format_short;
        else if (!this.data.format_short) this.data.format_short = this.findBestFormat(true);
    },
    /**
     * Get the year-only representation of this date. Ticks need this to layout
     * the time axis, and this needs to work isomorphically for TLDate and BigDate 
     * @returns {Number}
     */ getFullYear: function() {
        return this.data.date_obj.getFullYear();
    }
});
function $8d19420aa75ccebb$export$57c754c1a6224f38(data) {
    var date = new $8d19420aa75ccebb$export$f39ff3a2b9f665c1(data);
    if (!isNaN(date.getTime())) return date;
    return new $8d19420aa75ccebb$export$bd36b6829733f649(data);
}
function $8d19420aa75ccebb$export$6b862160d295c8e(str) {
    if (str.match($8d19420aa75ccebb$var$ISO8601_SHORT_PATTERN)) {
        // parse short specifically to avoid timezone offset confusion
        // most browsers assume short is UTC, not local time.
        var parts = str.match($8d19420aa75ccebb$var$ISO8601_SHORT_PATTERN).slice(1);
        var d = {
            year: parts[0].replace("+", "")
        }; // year can be negative
        if (parts[1]) d["month"] = parts[1].replace("-", "");
        if (parts[2]) d["day"] = parts[2].replace("-", "");
        return d;
    }
    if (str.match($8d19420aa75ccebb$var$ISO8601_PATTERN)) return cls.parseISODate(str);
    if (str.match(/^\-?\d+$/)) return {
        year: str
    };
    var parsed = {};
    if (str.match(/\d+\/\d+\/\d+/)) {
        // mm/yy/dddd
        var date = str.match(/\d+\/\d+\/\d+/)[0];
        str = (0, $ea7d21fd242a7c44$export$87c2784dc9fc4ab)(str.replace(date, ""));
        var date_parts = date.split("/");
        parsed.month = date_parts[0];
        parsed.day = date_parts[1];
        parsed.year = date_parts[2];
    }
    if (str.match(/\d+\/\d+/)) {
        // mm/yy
        var date = str.match(/\d+\/\d+/)[0];
        str = (0, $ea7d21fd242a7c44$export$87c2784dc9fc4ab)(str.replace(date, ""));
        var date_parts = date.split("/");
        parsed.month = date_parts[0];
        parsed.year = date_parts[1];
    }
    if (str.match(":")) {
        var time_parts = str.split(":");
        parsed.hour = time_parts[0];
        parsed.minute = time_parts[1];
        if (time_parts[2]) {
            let second_parts = time_parts[2].split(".");
            parsed.second = second_parts[0];
            parsed.millisecond = second_parts[1];
        }
    }
    return parsed;
}
const $8d19420aa75ccebb$export$e5224a862286d631 = (0, $aede701022b5d50a$export$7d0ecf6d8e5abad6).extend({
    initialize: function(year) {
        this.year = parseInt(year);
        if (isNaN(this.year)) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_year_err", year);
    },
    isBefore: function(that) {
        return this.year < that.year;
    },
    isAfter: function(that) {
        return this.year > that.year;
    },
    getTime: function() {
        return this.year;
    }
});
//
// Class for cosmological dates
//
// cosmo units are years, not millis
const $8d19420aa75ccebb$var$AGE = 1000000;
const $8d19420aa75ccebb$var$EPOCH = $8d19420aa75ccebb$var$AGE * 10;
const $8d19420aa75ccebb$var$ERA = $8d19420aa75ccebb$var$EPOCH * 10;
const $8d19420aa75ccebb$var$EON = $8d19420aa75ccebb$var$ERA * 10;
function $8d19420aa75ccebb$var$Floorer(unit) {
    return function(a_big_year) {
        var year = a_big_year.getTime();
        return new $8d19420aa75ccebb$export$e5224a862286d631(Math.floor(year / unit) * unit);
    };
}
const $8d19420aa75ccebb$export$47c5250e3f827cc3 = [
    [
        'year',
        1,
        new $8d19420aa75ccebb$var$Floorer(1)
    ],
    [
        'decade',
        10,
        new $8d19420aa75ccebb$var$Floorer(10)
    ],
    [
        'century',
        100,
        new $8d19420aa75ccebb$var$Floorer(100)
    ],
    [
        'millennium',
        1000,
        new $8d19420aa75ccebb$var$Floorer(1000)
    ],
    [
        'age',
        $8d19420aa75ccebb$var$AGE,
        new $8d19420aa75ccebb$var$Floorer($8d19420aa75ccebb$var$AGE)
    ],
    [
        'epoch',
        $8d19420aa75ccebb$var$EPOCH,
        new $8d19420aa75ccebb$var$Floorer($8d19420aa75ccebb$var$EPOCH)
    ],
    [
        'era',
        $8d19420aa75ccebb$var$ERA,
        new $8d19420aa75ccebb$var$Floorer($8d19420aa75ccebb$var$ERA)
    ],
    [
        'eon',
        $8d19420aa75ccebb$var$EON,
        new $8d19420aa75ccebb$var$Floorer($8d19420aa75ccebb$var$EON)
    ] // 1B years
];
const $8d19420aa75ccebb$export$bd36b6829733f649 = $8d19420aa75ccebb$export$f39ff3a2b9f665c1.extend({
    // @data = BigYear object or JS dictionary with date properties
    initialize: function(data, format, format_short) {
        if ($8d19420aa75ccebb$export$e5224a862286d631 == data.constructor) this.data = {
            date_obj: data
        };
        else {
            this.data = JSON.parse(JSON.stringify(data));
            this._createDateObj();
        }
        if (data.format && !format) format = data.format;
        this._setFormat(format, format_short);
    },
    // Create date_obj
    _createDateObj: function() {
        var _date = this._getDateData();
        this.data.date_obj = new $8d19420aa75ccebb$export$e5224a862286d631(_date.year);
    },
    // Return a new BigDate which has been 'floored' at the given scale.
    // @scale = string value from BIG_DATE_SCALES
    floor: function(scale) {
        for(var i = 0; i < $8d19420aa75ccebb$export$47c5250e3f827cc3.length; i++)if ($8d19420aa75ccebb$export$47c5250e3f827cc3[i][0] == scale) {
            var floored = $8d19420aa75ccebb$export$47c5250e3f827cc3[i][2](this.data.date_obj);
            return new $8d19420aa75ccebb$export$bd36b6829733f649(floored);
        }
        throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_scale_err", scale);
    },
    /**
     * Get the year-only representation of this date. Ticks need this to layout
     * the time axis, and this needs to work isomorphically for TLDate and BigDate 
     * @returns {Number}
     */ getFullYear: function() {
        return this.data.date_obj.getTime();
    }
});



const $3bd1753d03e195ea$var$MESSAGE_VARIABLE_PATTERN = new RegExp(/\$\{(.+?)\}/g);
/**
     * Instantiate a Language object to manage I18N. 
     * WARNING: In general, this should not be called directly, because it doesn't block while
     * the language file is loaded, which can lead to race conditions in some cases. In most
     * cases, language objects other than the fallback should be gotten by calling the 
     * async function loadLanguage defined elsewhere in this file.
     * 
     * @param {String} [language=en] - a language code or a URL to a 
     *     translation file
     * @param {string} [script_path] - if `language` is not a URL, this is used
     *     to construct a fully-qualified URL to load a translation file.
     */ class $3bd1753d03e195ea$export$ce4fe1c9e6520c1a {
    constructor(language, script_path){
        // borrowed from http://stackoverflow.com/a/14446414/102476
        for(let k1 in $3bd1753d03e195ea$var$LANGUAGES.en)this[k1] = $3bd1753d03e195ea$var$LANGUAGES.en[k1];
        // `language` won't be defined when the fallback is constructed
        if (language && typeof language == 'string' && language != 'en') {
            var code = language;
            if (!(code in $3bd1753d03e195ea$var$LANGUAGES)) {
                console.log(`Expected language ${code} to be cached. Did you call the constructor directly?`);
                var url = $3bd1753d03e195ea$var$buildLanguageURL(code, script_path);
                (0, $7f99b552874efbe4$export$81bec6e38e8b706b)(url).then((json)=>{
                    $3bd1753d03e195ea$var$LANGUAGES[code] = json;
                }).catch((resp)=>{
                    console.log(`Error loading language [${url}] ${resp.statusText} [${resp.status}]`);
                });
            }
            (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this, $3bd1753d03e195ea$var$LANGUAGES[code]);
        }
    }
    /**
     * Reimplement Util.mergeData to handle nested dictionaries
     * @param {object} lang_json 
     */ mergeData(lang_json) {
        for(k in $3bd1753d03e195ea$var$LANGUAGES.en)if (lang_json[k]) {
            if (typeof this[k] == 'object') (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(lang_json[k], this[k]);
            else this[k] = lang_json[k]; // strings, mostly
        }
    }
    formatBigYear(bigyear, format_name) {
        var the_year = bigyear.year;
        var format_list = this.bigdateformats[format_name] || this.bigdateformats['fallback'];
        if (format_list) {
            for(var i = 0; i < format_list.length; i++){
                var tuple = format_list[i];
                if (Math.abs(the_year / tuple[0]) > 1) // will we ever deal with distant future dates?
                return $3bd1753d03e195ea$var$formatNumber(Math.abs(the_year / tuple[0]), tuple[1]);
            }
            return the_year.toString();
        } else {
            (0, $ea7d21fd242a7c44$export$357889f174732d38)("Language file dateformats missing cosmological. Falling back.");
            return $3bd1753d03e195ea$var$formatNumber(the_year, format_name);
        }
    }
    /**
     * Look up a localized version of a standard message. While using `_` for the
     * method name is not exactly idiomatic javascript, it was inspired by Python's
     * {@link https://docs.python.org/3/library/gettext.html|gettext} module, with
     * the intention of reducing clutter in places where, in a non-I18N'd app, you'd 
     * simply have a quoted string.
     * 
     * @param {string} k - a message key 
     * @param {Object} [context] - a dictionary with string keys appropriate to message `k` 
     *      and string values which will be interpolated into the message.
     * @returns {string} - a localized string appropriate to the message key
     */ _(k1, context) {
        let msg = this.messages[k1] || $3bd1753d03e195ea$export$ce4fe1c9e6520c1a.fallback.messages[k1] || k1;
        if (msg.match($3bd1753d03e195ea$var$MESSAGE_VARIABLE_PATTERN)) {
            if (!context) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("template_message_without_context");
            for (let match of msg.matchAll($3bd1753d03e195ea$var$MESSAGE_VARIABLE_PATTERN)){
                if (!(match[1] in context)) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("template_message_without_context");
                msg = msg.replace(match[0], context[match[1]]);
            }
        }
        return msg;
    }
    formatDate(date, format_name) {
        if (date.constructor == Date) return this.formatJSDate(date, format_name);
        if (date.constructor == (0, $8d19420aa75ccebb$export$e5224a862286d631)) return this.formatBigYear(date, format_name);
        if (date.data && date.data.date_obj) return this.formatDate(date.data.date_obj, format_name);
        (0, $ea7d21fd242a7c44$export$357889f174732d38)("Unfamiliar date presented for formatting");
        return date.toString();
    }
    formatJSDate(js_date, format_name) {
        // ultimately we probably want this to work with TLDate instead of (in addition to?) JS Date
        // utc, timezone and timezoneClip are carry over from Steven Levithan implementation. We probably aren't going to use them.
        var self = this;
        var formatPeriod = function(fmt, value) {
            var formats = self.period_labels[fmt];
            if (formats) var fmt = value < 12 ? formats[0] : formats[1];
            return "<span class='tl-timeaxis-timesuffix'>" + fmt + "</span>";
        };
        var utc = false, timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g, timezoneClip = /[^-+\dA-Z]/g;
        if (!format_name) format_name = 'full';
        var mask = this.dateformats[format_name] || $3bd1753d03e195ea$export$ce4fe1c9e6520c1a.fallback.dateformats[format_name];
        if (!mask) mask = format_name; // allow custom format strings
        var _ = utc ? "getUTC" : "get", d = js_date[_ + "Date"](), D = js_date[_ + "Day"](), m = js_date[_ + "Month"](), y = js_date[_ + "FullYear"](), H = js_date[_ + "Hours"](), M = js_date[_ + "Minutes"](), s = js_date[_ + "Seconds"](), L = js_date[_ + "Milliseconds"](), o = utc ? 0 : js_date.getTimezoneOffset(), year = "", flags = {
            d: d,
            dd: (0, $ea7d21fd242a7c44$export$5d04458e2a6c373e)(d),
            ddd: this.date.day_abbr[D],
            dddd: this.date.day[D],
            m: m + 1,
            mm: (0, $ea7d21fd242a7c44$export$5d04458e2a6c373e)(m + 1),
            mmm: this.date.month_abbr[m],
            mmmm: this.date.month[m],
            yy: String(y).slice(2),
            yyyy: y < 0 && this.has_negative_year_modifier() ? Math.abs(y) : y,
            h: H % 12 || 12,
            hh: (0, $ea7d21fd242a7c44$export$5d04458e2a6c373e)(H % 12 || 12),
            H: H,
            HH: (0, $ea7d21fd242a7c44$export$5d04458e2a6c373e)(H),
            M: M,
            MM: (0, $ea7d21fd242a7c44$export$5d04458e2a6c373e)(M),
            s: s,
            ss: (0, $ea7d21fd242a7c44$export$5d04458e2a6c373e)(s),
            l: (0, $ea7d21fd242a7c44$export$5d04458e2a6c373e)(L, 3),
            L: (0, $ea7d21fd242a7c44$export$5d04458e2a6c373e)(L > 99 ? Math.round(L / 10) : L),
            t: formatPeriod('t', H),
            tt: formatPeriod('tt', H),
            T: formatPeriod('T', H),
            TT: formatPeriod('TT', H),
            Z: utc ? "UTC" : (String(js_date).match(timezone) || [
                ""
            ]).pop().replace(timezoneClip, ""),
            o: (o > 0 ? "-" : "+") + (0, $ea7d21fd242a7c44$export$5d04458e2a6c373e)(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
            S: [
                "th",
                "st",
                "nd",
                "rd"
            ][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
        };
        var formatted = mask.replace($3bd1753d03e195ea$export$ce4fe1c9e6520c1a.DATE_FORMAT_TOKENS, function($0) {
            return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
        });
        return this._applyEra(formatted, y);
    }
    has_negative_year_modifier() {
        return Boolean(this.era_labels.negative_year.prefix || this.era_labels.negative_year.suffix);
    }
    _applyEra(formatted_date, original_year) {
        // trusts that the formatted_date was property created with a non-negative year if there are
        // negative affixes to be applied
        var labels = original_year < 0 ? this.era_labels.negative_year : this.era_labels.positive_year;
        var result = '';
        if (labels.prefix) result += '<span>' + labels.prefix + '</span> ';
        result += formatted_date;
        if (labels.suffix) result += ' <span>' + labels.suffix + '</span>';
        return result;
    }
}
/**
 * Provide an async factory method for loading languages that clarifies the need to wait 
 * for the language data to be loaded, so that other code doesn't press ahead before the language
 * is available. 
 * 
 * 
 * @param {String} language_code - a language code or a fully-qualified URL to a language JSON file
 * @param {String} script_path - a URL prefix which can be used to construct a fully-qualified URL to a language file using `language_code`
 * 
 * @returns {Language} - an instance of Language, or null if there's an error loading the translation file
 */ async function $3bd1753d03e195ea$export$f02cbd868e2f57cf(language_code, script_path) {
    var url = $3bd1753d03e195ea$var$buildLanguageURL(language_code, script_path);
    try {
        if (!$3bd1753d03e195ea$var$LANGUAGES[language_code]) {
            let json = await (0, $7f99b552874efbe4$export$81bec6e38e8b706b)(url);
            $3bd1753d03e195ea$var$LANGUAGES[language_code] = json;
        }
        return new $3bd1753d03e195ea$export$ce4fe1c9e6520c1a(language_code, script_path);
    } catch (e) {
        console.log(`Error loading language [${url}] ${e.statusText}`);
        return null;
    }
}
function $3bd1753d03e195ea$var$buildLanguageURL(code, script_path) {
    if (/\.json$/.test(code)) var url = code;
    else {
        var fragment = "/locale/" + code + ".json";
        if (/\/$/.test(script_path)) fragment = fragment.substr(1);
        var url = script_path + fragment;
    }
    return url;
}
function $3bd1753d03e195ea$var$formatNumber(val, mask) {
    if (mask.match(/%(\.(\d+))?f/)) {
        var match = mask.match(/%(\.(\d+))?f/);
        var token = match[0];
        if (match[2]) val = val.toFixed(match[2]);
        return mask.replace(token, val);
    }
    // use mask as literal display value.
    return mask;
}
$3bd1753d03e195ea$export$ce4fe1c9e6520c1a.fallback = {
    messages: {}
}; // placeholder to satisfy IE8 early compilation
$3bd1753d03e195ea$export$ce4fe1c9e6520c1a.DATE_FORMAT_TOKENS = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g;
var $3bd1753d03e195ea$var$LANGUAGES = {
    /*
	This represents the canonical list of message keys which translation files should handle. The existence of the 'en.json' file should not mislead you.
	It is provided more as a starting point for someone who wants to provide a
    new translation since the form for non-default languages (JSON not JS) is slightly different 
    from what appears below. Also, those files have some message keys grandfathered in from TimelineJS2 
    which we'd rather not have to get "re-translated" if we use them.
*/ en: {
        name: "English (built-in)",
        lang: "en",
        api: {
            wikipedia: "en" // the two letter code at the beginning of the Wikipedia subdomain for this language
        },
        messages: {
            loading: "Loading",
            wikipedia: "From Wikipedia, the free encyclopedia",
            error: "Error",
            return_to_title: "Return to Title",
            go_to_end: "Go to the last slide",
            loading_content: "Loading Content",
            loading_timeline: "Loading Timeline... ",
            swipe_to_navigate: "Swipe to Navigate<br><span class='tl-button'>OK</span>",
            zoom_in: "Zoom in",
            zoom_out: "Zoom out",
            unknown_read_err: "An unexpected error occurred trying to read your spreadsheet data",
            invalid_url_err: "Unable to read Timeline data. Make sure your URL is for a Google Spreadsheet or a Timeline JSON file.",
            network_err: "Unable to read your Google Spreadsheet. Make sure you have published it to the web.",
            missing_start_date_err: "Missing start_date",
            invalid_start_time_without_date: "Invalid configuration: time cannot be used without date.",
            invalid_end_time_without_date: "Invalid configuration: end time cannot be used without end date.",
            date_compare_err: "Can't compare timeline date objects on different scales",
            invalid_scale_err: "Invalid scale",
            invalid_date_err: "Invalid date: month, day and year must be numbers.",
            invalid_separator_error: "Invalid time: misuse of : or . as separator.",
            invalid_hour_err: "Invalid time (hour)",
            invalid_minute_err: "Invalid time (minute)",
            invalid_second_err: "Invalid time (second)",
            invalid_fractional_err: "Invalid time (fractional seconds)",
            invalid_second_fractional_err: "Invalid time (seconds and fractional seconds)",
            invalid_year_err: "Invalid year",
            flickr_notfound_err: "Photo not found or private",
            flickr_invalidurl_err: "Invalid Flickr URL",
            imgur_invalidurl_err: "Invalid Imgur URL",
            twitter_load_err: "Unable to load Tweet",
            twitterembed_invalidurl_err: "Invalid Twitter Embed url",
            wikipedia_load_err: "Unable to load Wikipedia entry",
            wikipedia_image_load_err: "Unable to load Wikipedia image data",
            spotify_invalid_url: "Invalid Spotify URL",
            invalid_rgb_err: "Invalid RGB argument",
            time_scale_scale_err: "Don't know how to get date from time for scale",
            axis_helper_no_options_err: "Axis helper must be configured with options",
            axis_helper_scale_err: "No AxisHelper available for scale",
            invalid_integer_option: "Invalid option value\u2014must be a whole number.",
            instagram_bad_request: "Invalid or private Instagram URL",
            template_message_without_context: "Required variables not provided for template translation message",
            aria_label_timeline: "Timeline",
            aria_label_timeline_navigation: "Timeline navigation",
            aria_label_timeline_content: "Timeline content",
            // The following message keys are pseudo-template literal. 
            // Do not surround with backticks (`) since evaluation is deferred 
            // (and backticks wouldn't be allowed in JSON localization files)
            // for each, document typical values for variable components
            aria_label_zoomin: "Show less than ${start} to ${end}",
            aria_label_zoomout: "Show more than ${start} to ${end}" // 'start' and 'end' should be numeric years 
        },
        date: {
            month: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            month_abbr: [
                "Jan.",
                "Feb.",
                "March",
                "April",
                "May",
                "June",
                "July",
                "Aug.",
                "Sept.",
                "Oct.",
                "Nov.",
                "Dec."
            ],
            day: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ],
            day_abbr: [
                "Sun.",
                "Mon.",
                "Tues.",
                "Wed.",
                "Thurs.",
                "Fri.",
                "Sat."
            ]
        },
        era_labels: {
            // specify prefix or suffix to apply to formatted date. Blanks mean no change.
            positive_year: {
                prefix: "",
                suffix: ""
            },
            negative_year: {
                // if either of these is specified, the year will be converted to positive before they are applied
                prefix: "",
                suffix: "BCE"
            }
        },
        period_labels: {
            // use of t/tt/T/TT legacy of original Timeline date format
            t: [
                "a",
                "p"
            ],
            tt: [
                "am",
                "pm"
            ],
            T: [
                "A",
                "P"
            ],
            TT: [
                "AM",
                "PM"
            ]
        },
        dateformats: {
            year: "yyyy",
            month_short: "mmm",
            month: "mmmm yyyy",
            full_short: "mmm d",
            full: "mmmm d',' yyyy",
            time: "h:MM:ss TT' <small>'mmmm d',' yyyy'</small>'",
            time_short: "h:MM:ss TT",
            time_no_seconds_short: "h:MM TT",
            time_no_minutes_short: "h TT",
            time_no_seconds_small_date: "h:MM TT' <small>'mmmm d',' yyyy'</small>'",
            time_milliseconds: "l",
            full_long: "mmm d',' yyyy 'at' h:MM TT",
            full_long_small_date: "h:MM TT' <small>mmm d',' yyyy'</small>'"
        },
        bigdateformats: {
            fallback: [
                // a list of tuples, with t[0] an order of magnitude and t[1] a format string. format string syntax may change...
                [
                    1000000000,
                    "%.2f billion years ago"
                ],
                [
                    1000000,
                    "%.1f million years ago"
                ],
                [
                    1000,
                    "%.1f thousand years ago"
                ],
                [
                    1,
                    "%f years ago"
                ]
            ],
            compact: [
                [
                    1000000000,
                    "%.2f bya"
                ],
                [
                    1000000,
                    "%.1f mya"
                ],
                [
                    1000,
                    "%.1f kya"
                ],
                [
                    1,
                    "%f years ago"
                ]
            ],
            verbose: [
                [
                    1000000000,
                    "%.2f billion years ago"
                ],
                [
                    1000000,
                    "%.1f million years ago"
                ],
                [
                    1000,
                    "%.1f thousand years ago"
                ],
                [
                    1,
                    "%f years ago"
                ]
            ]
        }
    }
};
let $3bd1753d03e195ea$export$bcd1dd1f397bba12 = new $3bd1753d03e195ea$export$ce4fe1c9e6520c1a();
$3bd1753d03e195ea$export$ce4fe1c9e6520c1a.fallback = $3bd1753d03e195ea$export$bcd1dd1f397bba12;


class $2319cf524e876851$export$222529f9b823899b {
    setLanguage(language) {
        this.language = language;
    }
    getLanguage() {
        if (this.language) {
            if (typeof this.language == 'object') return this.language;
            else (0, $ea7d21fd242a7c44$export$357889f174732d38)(`I18NMixins.getLanguage: this.language should be object, but is ${typeof this.language}`);
        }
        // trace("I18NMixins.getLanguage: Expected a language option");
        return 0, $3bd1753d03e195ea$export$bcd1dd1f397bba12;
    }
    /**
     * Look up a localized version of a standard message using the Language instance
     * that was previously set with {@link setLanguage}.
     * 
     * @see {@link Language#_}
     * @param {string} msg - a message key 
     * @param {Object} [context] - a dictionary with string keys appropriate to message `k` 
     *      and string values which will be interpolated into the message.
     * @returns {string} - a localized string appropriate to the message key
     */ _(msg, context) {
        return this.getLanguage()._(msg, context);
    }
}


class $c47270e117695841$export$2e2bcd8739ae039 {
    /**
     * Initialize a Message object with the container where it appears and, 
     *     optionally, a JS object of options.
     * @param {HTMLElement} container 
     * @param {object} [options] 
     */ constructor(container, options, language){
        if (language) this.setLanguage(language);
        // DOM ELEMENTS
        this._el = {
            parent: {},
            container: {},
            message_container: {},
            loading_icon: {},
            message: {}
        };
        //Options
        this.options = {
            width: 600,
            height: 600,
            message_class: "tl-message",
            message_icon_class: "tl-loading-icon"
        };
        this.container = container;
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.options, options);
        this._el.container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", this.options.message_class);
        if (container) {
            container.appendChild(this._el.container);
            this._el.parent = container;
        }
        // Animation
        this.animator = {};
        this._initLayout();
        this._initEvents();
    }
    updateMessage(t) {
        if (!t) this._el.message.innerHTML = this._("loading");
        else this._el.message.innerHTML = t;
        // Re-add to DOM?
        if (!this._el.parent.atributes && this.container.attributes) {
            this.container.appendChild(this._el.container);
            this._el.parent = this.container;
        }
    }
    /*	Update Display
================================================== */ updateDisplay(w, h) {
    // no-op but probably should be implemented
    }
    _onMouseClick() {
        this.fire("clicked", this.options);
    }
    _onRemove() {
        this._el.parent = {};
    }
    _initLayout() {
        // Create Layout
        this._el.message_container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-message-container", this._el.container);
        this._el.loading_icon = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", this.options.message_icon_class, this._el.message_container);
        this._el.message = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-message-content", this._el.message_container);
        this.updateMessage();
    }
    _initEvents() {
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.container, 'click', this._onMouseClick, this);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this, 'removed', this._onRemove, this);
    }
}
(0, $ea7d21fd242a7c44$export$c5910a33574a115e)($c47270e117695841$export$2e2bcd8739ae039, (0, $2319cf524e876851$export$222529f9b823899b), (0, $d92d8eaa035c7b70$export$2e2bcd8739ae039), (0, $8948f35b9a5753b9$export$b8c17d0037837cb6));








function $f07ad0328aac39ec$export$2830befb6f558677(array, prop_name) {
    var prop_name = prop_name || 'start_date';
    array.sort(function(a, b) {
        if (a[prop_name].isBefore(b[prop_name])) return -1;
        if (a[prop_name].isAfter(b[prop_name])) return 1;
        return 0;
    });
}
function $f07ad0328aac39ec$export$c9698ec7f05a07e1(time_str) {
    var parsed = {
        hour: null,
        minute: null,
        second: null,
        millisecond: null // conform to keys in TLDate
    };
    var period = null;
    var match = time_str.match(/(\s*[AaPp]\.?[Mm]\.?\s*)$/);
    if (match) {
        period = (0, $ea7d21fd242a7c44$export$87c2784dc9fc4ab)(match[0]);
        time_str = (0, $ea7d21fd242a7c44$export$87c2784dc9fc4ab)(time_str.substring(0, time_str.lastIndexOf(period)));
    }
    var parts = [];
    var no_separators = time_str.match(/^\s*(\d{1,2})(\d{2})\s*$/);
    if (no_separators) parts = no_separators.slice(1);
    else {
        parts = time_str.split(':');
        if (parts.length == 1) parts = time_str.split('.');
    }
    if (parts.length > 4) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_separator_error");
    let hour_part = parts[0];
    parsed.hour = parseInt(hour_part);
    if (period && period.toLowerCase()[0] == 'p' && parsed.hour != 12) parsed.hour += 12;
    else if (period && period.toLowerCase()[0] == 'a' && parsed.hour == 12) parsed.hour = 0;
    if (isNaN(parsed.hour) || parsed.hour < 0 || parsed.hour > 23) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_hour_err", hour_part);
    if (parts.length > 1) {
        let minute_part = parts[1];
        parsed.minute = parseInt(minute_part);
        if (isNaN(parsed.minute)) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_minute_err", minute_part);
    }
    if (parts.length > 2) {
        var sec_parts = parts[2].split(/[\.,]/);
        parts = sec_parts.concat(parts.slice(3)) // deal with various methods of specifying fractional seconds
        ;
        if (parts.length > 2) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_second_fractional_err");
        parsed.second = parseInt(parts[0]);
        if (isNaN(parsed.second)) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_second_err", parts[0]);
        if (parts.length == 2) {
            var frac_secs = parseInt(parts[1]);
            if (isNaN(frac_secs)) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_fractional_err", parts[1]);
            parsed.millisecond = 100 * frac_secs;
        }
    }
    return parsed;
}
const $f07ad0328aac39ec$var$VALID_INTEGER_PATTERN = new RegExp('(^-?\\d+$|^$)');
function $f07ad0328aac39ec$export$3b4666606e877c21(d) {
    try {
        Object.keys(d).forEach((k)=>{
            let v = d[k];
            if (v && v.match) {
                if (!v.match($f07ad0328aac39ec$var$VALID_INTEGER_PATTERN)) throw `invalid value ${v} for ${k}`;
            }
        });
        return true;
    } catch (error) {
        return false;
    }
}
const $f07ad0328aac39ec$export$a24ce01db94b1aa0 = {
    human: (0, $8d19420aa75ccebb$export$f39ff3a2b9f665c1),
    cosmological: (0, $8d19420aa75ccebb$export$bd36b6829733f649)
};





var $d349326c2b62c55f$exports = {};
/*! @license DOMPurify 3.2.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.3/LICENSE */ (function(global, factory) {
    $d349326c2b62c55f$exports = factory();
})($d349326c2b62c55f$exports, function() {
    'use strict';
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== 'undefined' && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!construct) construct = function construct(Func, args) {
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\$\{[\w\W]*}/gm); // eslint-disable-line unicorn/better-regex
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.2.3';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
            HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */ const _isNode = function _isNode(value) {
            return typeof Node === 'function' && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                let value = name === 'value' ? attrValue : stringTrim(attrValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint) {
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});


const $8849a36019263cbd$var$SANITIZE_FIELDS = {
    text: [
        'headline',
        'text'
    ],
    media: [
        'caption',
        'credit'
    ] // media "URL" must be sanitized in Media classes to avoid messing up URLs
};
const $8849a36019263cbd$var$STRIP_MARKUP_FIELDS = {
    start_date: [
        'display_date'
    ],
    end_date: [
        'display_date'
    ],
    slide: [
        'display_date',
        'group'
    ],
    date: [
        'display_date'
    ]
};
/**
 * After sanitizing, make sure all <a> tags with 'href' attributes that 
 * don't have a target attribute are set to open in a new ('_blank') 
 * window. Also make sure that all <a> tags which are set to open in a '_blank'
 * window set `rel="noopener"`
 */ (0, (/*@__PURE__*/$parcel$interopDefault($d349326c2b62c55f$exports))).addHook('afterSanitizeAttributes', function(node) {
    if (node.nodeName == 'A' && 'href' in node) {
        if (!('target' in node.attributes)) node.setAttribute('target', '_blank');
        let rel = node.attributes['rel'];
        if (!rel) node.setAttribute('rel', 'noopener');
        else if (rel.value.indexOf('noopener') == -1) node.setAttribute('rel', `noopener ${rel.value}`);
    }
});
function $8849a36019263cbd$var$_process_fields(slide, callback, fieldmap) {
    Object.keys(fieldmap).forEach((k)=>{
        var to_sanitize = k == 'slide' ? slide : slide[k];
        if (to_sanitize) fieldmap[k].forEach((i)=>{
            if (typeof to_sanitize[i] != 'undefined') to_sanitize[i] = callback(to_sanitize[i]);
        });
    });
}
/**
 * Centralize use of HTML sanitizer so that we can enforce common
 * rules. Maybe we would want to push this to Util and unit test
 * but ultimately we're trusting the creators of the library.
 * @param {string} txt 
 */ function $8849a36019263cbd$var$_tl_sanitize(txt) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($d349326c2b62c55f$exports))).sanitize(txt, {
        ADD_TAGS: [
            'iframe'
        ],
        ADD_ATTR: [
            'frameborder',
            'target'
        ]
    });
}
class $8849a36019263cbd$export$9e1cf9dd451bce3a {
    constructor(data){
        this.title = '';
        this.scale = '';
        this.events = [];
        this.eras = [];
        this.event_dict = {}; // despite name, all slides (events + title) indexed by slide.unique_id
        this.messages = {
            errors: [],
            warnings: []
        };
        // Initialize the data
        if (typeof data === 'object' && data.events) {
            this.scale = data.scale;
            this.events = [];
            this._ensureValidScale(data.events);
            if (data.title) {
                // the 'title' is a kind of slide, one without a date
                var title_id = this._assignID(data.title);
                this._tidyFields(data.title);
                this.title = data.title;
                this.event_dict[title_id] = this.title;
            }
            for(var i = 0; i < data.events.length; i++)try {
                this.addEvent(data.events[i], true);
            } catch (e) {
                this.logError(e);
            }
            if (data.eras) data.eras.forEach((era_data, indexOf)=>{
                try {
                    this.addEra(era_data);
                } catch (e) {
                    this.logError("Era " + indexOf + ": " + e);
                }
            });
            (0, $f07ad0328aac39ec$export$2830befb6f558677)(this.events);
            (0, $f07ad0328aac39ec$export$2830befb6f558677)(this.eras);
        }
    }
    logError(msg) {
        (0, $ea7d21fd242a7c44$export$357889f174732d38)(`logError: ${msg}`);
        this.messages.errors.push(msg);
    }
    /*
     * Return any accumulated error messages. If `sep` is passed, it should be a string which will be used to join all messages, resulting in a string return value. Otherwise,
     * errors will be returned as an array.
     */ getErrors(sep) {
        if (sep) return this.messages.errors.join(sep);
        else return this.messages.errors;
    }
    /*
     * Perform any sanity checks we can before trying to use this to make a timeline. Returns nothing, but errors will be logged
     * such that after this is called, one can test `this.isValid()` to see if everything is OK.
     */ validate() {
        if (typeof this.events == "undefined" || typeof this.events.length == "undefined" || this.events.length == 0) this.logError("Timeline configuration has no events.");
        // make sure all eras have start and end dates
        for(var i = 0; i < this.eras.length; i++)if (typeof this.eras[i].start_date == 'undefined' || typeof this.eras[i].end_date == 'undefined') {
            var era_identifier;
            if (this.eras[i].headline) era_identifier = this.eras[i].headline;
            else era_identifier = "era " + (i + 1);
            this.logError("All eras must have start and end dates. [" + era_identifier + "]") // add internationalization (I18N) and context
            ;
        }
    }
    /**
     * @returns {boolean} whether or not this config has logged errors.  
     */ isValid() {
        return this.messages.errors.length == 0;
    }
    /* Add an event (including cleaning/validation) and return the unique id.
     * All event data validation should happen in here.
     * Throws: TLError for any validation problems.
     */ addEvent(data, defer_sort) {
        var event_id = this._assignID(data);
        if (typeof data.start_date == 'undefined') {
            (0, $ea7d21fd242a7c44$export$357889f174732d38)("Missing start date, skipping event");
            console.log(data);
            return null;
        }
        this._processDates(data);
        this._tidyFields(data);
        this.events.push(data);
        this.event_dict[event_id] = data;
        if (!defer_sort) (0, $f07ad0328aac39ec$export$2830befb6f558677)(this.events);
        return event_id;
    }
    addEra(data) {
        var event_id = this._assignID(data);
        if (typeof data.start_date == 'undefined') throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("missing_start_date_err", event_id);
        this._processDates(data);
        this._tidyFields(data);
        this.eras.push({
            start_date: data.start_date,
            end_date: data.end_date,
            headline: data.text.headline
        });
    }
    /**
     * Given a slide, verify that its ID is unique, or assign it one which is.
     * The assignment happens in this function, and the assigned ID is also
     * the return value. Not thread-safe, because ids are not reserved
     * when assigned here.
     */ _assignID(slide) {
        var slide_id = slide.unique_id;
        if (!(0, $ea7d21fd242a7c44$export$87c2784dc9fc4ab)(slide_id)) // give it an ID if it doesn't have one
        slide_id = slide.text ? (0, $ea7d21fd242a7c44$export$c383cdd2a518017a)(slide.text.headline) : null;
        // make sure it's unique and add it.
        slide.unique_id = (0, $ea7d21fd242a7c44$export$f967b1e04044146f)(this.event_dict, slide_id);
        return slide.unique_id;
    }
    /**
     * Given an array of slide configs (the events), ensure that each one has a distinct unique_id. The id of the title
     * is also passed in because in most ways it functions as an event slide, and the event IDs must also all be unique
     * from the title ID.
     */ _makeUniqueIdentifiers(title_id, array) {
        var used = [
            title_id
        ];
        // establish which IDs are assigned and if any appear twice, clear out successors.
        for(var i = 0; i < array.length; i++)if ((0, $ea7d21fd242a7c44$export$87c2784dc9fc4ab)(array[i].unique_id)) {
            array[i].unique_id = (0, $ea7d21fd242a7c44$export$c383cdd2a518017a)(array[i].unique_id); // enforce valid
            if (used.indexOf(array[i].unique_id) == -1) used.push(array[i].unique_id);
            else array[i].unique_id = '';
        }
        if (used.length != array.length + 1) {
            // at least some are yet to be assigned
            for(var i = 0; i < array.length; i++)if (!array[i].unique_id) {
                // use the headline for the unique ID if it's available
                var slug = array[i].text ? (0, $ea7d21fd242a7c44$export$c383cdd2a518017a)(array[i].text.headline) : null;
                if (!slug) slug = (0, $ea7d21fd242a7c44$export$b40aeedae59b59d1)(6); // or generate a random ID
                if (used.indexOf(slug) != -1) slug = slug + '-' + i; // use the index to get a unique ID.
                used.push(slug);
                array[i].unique_id = slug;
            }
        }
    }
    _ensureValidScale(events) {
        if (!this.scale) {
            this.scale = "human"; // default to human unless there's a slide which is explicitly 'cosmological' or one which has a cosmological year
            for(var i = 0; i < events.length; i++){
                if (events[i].scale == 'cosmological') {
                    this.scale = 'cosmological';
                    break;
                }
                if (events[i].start_date && typeof events[i].start_date.year != "undefined") {
                    var d = new (0, $8d19420aa75ccebb$export$bd36b6829733f649)(events[i].start_date);
                    var year = d.data.date_obj.year;
                    if (year < -271820 || year > 275759) {
                        this.scale = "cosmological";
                        break;
                    }
                }
            }
            (0, $ea7d21fd242a7c44$export$357889f174732d38)(`Determining scale dynamically: ${this.scale}`);
        }
        var dateCls = (0, $f07ad0328aac39ec$export$a24ce01db94b1aa0)[this.scale];
        if (!dateCls) this.logError("Don't know how to process dates on scale " + this.scale);
    }
    /*
            Given a thing which has a start_date and optionally an end_date, make sure that it is an instance
                of the correct date class (for human or cosmological scale). For slides, remove redundant end dates
                (people frequently configure an end date which is the same as the start date).
            */ _processDates(slide_or_era) {
        var dateCls = (0, $f07ad0328aac39ec$export$a24ce01db94b1aa0)[this.scale];
        if (!(slide_or_era.start_date instanceof dateCls)) {
            var start_date = slide_or_era.start_date;
            slide_or_era.start_date = new dateCls(start_date);
            // eliminate redundant end dates.
            if (typeof slide_or_era.end_date != 'undefined' && !(slide_or_era.end_date instanceof dateCls)) {
                var end_date = slide_or_era.end_date;
                var equal = true;
                for(let property in start_date)equal = equal && start_date[property] == end_date[property];
                if (equal) {
                    (0, $ea7d21fd242a7c44$export$357889f174732d38)("End date same as start date is redundant; dropping end date");
                    delete slide_or_era.end_date;
                } else slide_or_era.end_date = new dateCls(end_date);
            }
        }
    }
    /**
         * Return the earliest date that this config knows about, whether it's a slide or an era
         */ getEarliestDate() {
        // counting that dates were sorted in initialization
        var date = this.events[0].start_date;
        if (this.eras && this.eras.length > 0) {
            if (this.eras[0].start_date.isBefore(date)) return this.eras[0].start_date;
        }
        return date;
    }
    /**
         * Return the latest date that this config knows about, whether it's a slide or an era, taking end_dates into account.
         */ getLatestDate() {
        var dates = [];
        for(var i = 0; i < this.events.length; i++)if (this.events[i].end_date) dates.push({
            date: this.events[i].end_date
        });
        else dates.push({
            date: this.events[i].start_date
        });
        for(var i = 0; i < this.eras.length; i++)if (this.eras[i].end_date) dates.push({
            date: this.eras[i].end_date
        });
        else dates.push({
            date: this.eras[i].start_date
        });
        (0, $f07ad0328aac39ec$export$2830befb6f558677)(dates, 'date');
        return dates.slice(-1)[0].date;
    }
    /**
     * Do some simple cleanup for all slides and eras, including sanitizing 
     * HTML input, or stripping markup for fields which are not intended to support
     * it.
     * @param { Slide | TimeEra } slide 
     */ _tidyFields(slide) {
        function fillIn(obj, key, default_value) {
            if (!default_value) default_value = '';
            if (!obj.hasOwnProperty(key)) obj[key] = default_value;
        }
        if (slide.group) slide.group = (0, $ea7d21fd242a7c44$export$87c2784dc9fc4ab)(slide.group);
        if (!slide.text) slide.text = {};
        fillIn(slide.text, 'text');
        fillIn(slide.text, 'headline');
        $8849a36019263cbd$var$_process_fields(slide, $8849a36019263cbd$var$_tl_sanitize, $8849a36019263cbd$var$SANITIZE_FIELDS);
        // handle media.url separately
        $8849a36019263cbd$var$_process_fields(slide, (0, $ea7d21fd242a7c44$export$8ad6fe2e294be355), $8849a36019263cbd$var$STRIP_MARKUP_FIELDS);
    }
}







/* Adapted from okfn/csv.js under MIT license
https://github.com/okfn/csv.js/blob/master/LICENSE.txt
Copyright (c) 2011-2013 Open Knowledge Foundation

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ function $2b5648a5a2019cdf$var$chomp(s, lineterminator) {
    if (s == null) return '';
    lineterminator = lineterminator || '\n';
    if (s.charAt(s.length - lineterminator.length) !== lineterminator) // Does not end with \n, just return string
    return s;
    else // Remove the \n
    return s.substring(0, s.length - lineterminator.length);
}
async function $2b5648a5a2019cdf$export$e7a4dadcf0e70e1a(dataset) {
    return new Promise((resolve, reject)=>{
        if (dataset.data) {
            var out = $2b5648a5a2019cdf$export$594a403c6b2e822($2b5648a5a2019cdf$export$98e6a39c04603d36(dataset.data, dataset), dataset);
            out.useMemoryStore = true;
            resolve(out);
        } else if (dataset.url) window.fetch(dataset.url, {
            mode: 'cors'
        }).then(function(response) {
            if (response.status != 200) {
                if (response.headers.get('content-type') == "application/json") response.text().then((text)=>{
                    reject(JSON.parse(text));
                });
                else reject({
                    status_code: response.status,
                    message: `Error fetching CSV: [${response.status} ${response.statusText}]`
                });
                return;
            }
            if (response.text) return response.text();
            else return response;
        }).then(function(data) {
            if (data) {
                var out = $2b5648a5a2019cdf$export$6170d888562bc21f(data, dataset);
                out.useMemoryStore = true;
                resolve(out);
            }
        }).catch((msg)=>{
            reject({
                status_code: 500,
                message: `Error fetching CSV: ${msg}`
            });
            return;
        });
    });
}
function $2b5648a5a2019cdf$export$594a403c6b2e822(rows, noFields) {
    noFields = noFields || {};
    if (noFields.noHeaderRow !== true && rows.length > 0) return {
        fields: rows[0].map((x, i)=>{
            if (x && x.trim) return x.trim();
            return `untitled${i}`;
        }),
        records: rows.slice(1)
    };
    else return {
        records: rows
    };
}
function $2b5648a5a2019cdf$var$normalizeDialectOptions(options) {
    // note lower case compared to CSV DDF
    var out = {
        delimiter: ",",
        doublequote: true,
        lineterminator: "\n",
        quotechar: '"',
        skipinitialspace: true,
        skipinitialrows: 0
    };
    for(var key in options)if (key === "trim") out["skipinitialspace"] = options.trim;
    else out[key.toLowerCase()] = options[key];
    return out;
}
function $2b5648a5a2019cdf$export$98e6a39c04603d36(s, dialect) {
    // When line terminator is not provided then we try to guess it
    // and normalize it across the file.
    if (!dialect || dialect && !dialect.lineterminator) s = $2b5648a5a2019cdf$var$normalizeLineTerminator(s, dialect);
    // Get rid of any trailing \n
    var options = $2b5648a5a2019cdf$var$normalizeDialectOptions(dialect);
    s = $2b5648a5a2019cdf$var$chomp(s, options.lineterminator);
    var cur = "", inQuote = false, fieldQuoted = false, field = "", row = [], out = [], i, processField;
    processField = function(field) {
        if (fieldQuoted !== true) {
            // If field is empty set to null
            if (field === "") field = null;
            else if (options.skipinitialspace === true) field = field.trim();
        // Convert unquoted numbers to their appropriate types
        // but Timeline never expects real numbers, so we'll leave that out here.
        // if (rxIsInt.test(field)) {
        //     field = parseInt(field, 10);
        // } else if (rxIsFloat.test(field)) {
        //     field = parseFloat(field, 10);
        // }
        }
        return field;
    };
    for(i = 0; i < s.length; i += 1){
        cur = s.charAt(i);
        // If we are at a EOF or EOR
        if (inQuote === false && (cur === options.delimiter || cur === options.lineterminator)) {
            field = processField(field);
            // Add the current field to the current row
            row.push(field);
            // If this is EOR append row to output and flush row
            if (cur === options.lineterminator) {
                out.push(row);
                row = [];
            }
            // Flush the field buffer
            field = "";
            fieldQuoted = false;
        } else // If it's not a quotechar, add it to the field buffer
        if (cur !== options.quotechar) field += cur;
        else {
            if (!inQuote) {
                // We are not in a quote, start a quote
                inQuote = true;
                fieldQuoted = true;
            } else // Next char is quotechar, this is an escaped quotechar
            if (s.charAt(i + 1) === options.quotechar) {
                field += options.quotechar;
                // Skip the next char
                i += 1;
            } else // It's not escaping, so end quote
            inQuote = false;
        }
    }
    // Add the last field
    field = processField(field);
    row.push(field);
    out.push(row);
    // Expose the ability to discard initial rows
    if (options.skipinitialrows) out = out.slice(options.skipinitialrows);
    return out;
}
/**
 * If no lineterminator is specified in `dialect`, convert CRLF and CR 
 * to LF (newline) to simplify splitting lines.
 * @param {String} csvString - a String representation of a CSV file
 * @param {Object} [dialect] - details about the CSV dialect to guide the parser
 */ function $2b5648a5a2019cdf$var$normalizeLineTerminator(csvString, dialect) {
    if (dialect && !dialect.lineterminator) return csvString.replace(/(\r\n|\n|\r)/gm, "\n");
    // if not return the string untouched.
    return csvString;
}
function $2b5648a5a2019cdf$export$6170d888562bc21f(s, dialect) {
    let rows = $2b5648a5a2019cdf$export$594a403c6b2e822($2b5648a5a2019cdf$export$98e6a39c04603d36(s, dialect));
    let objects = [];
    rows.records.forEach((record)=>{
        let obj = {};
        rows.fields.forEach((f, i)=>obj[f] = record[i]);
        objects.push(obj);
    });
    return objects;
}


function $ce175c6e1ee59955$var$clean_integer(s) {
    if (s) return s.replace(/[\s,]+/g, ''); // doesn't handle '.' as comma separator, but how to distinguish that from decimal separator?
}
function $ce175c6e1ee59955$export$a0660ae999f8e7aa(url) {
    let parts = {
        key: null,
        worksheet: 0 // not really sure how to use this to get the feed for that sheet, so this is not ready except for first sheet right now
    };
    // key as url parameter (old-fashioned)
    var key_pat = /\bkey=([-_A-Za-z0-9]+)&?/i;
    var url_pat = /docs.google.com\/spreadsheets(.*?)\/d\//; // fixing issue of URLs with u/0/d
    if (url.match(key_pat)) parts.key = url.match(key_pat)[1];
    else if (url.match(url_pat)) {
        var pos = url.search(url_pat) + url.match(url_pat)[0].length;
        var tail = url.substr(pos);
        parts.key = tail.split('/')[0];
        if (url.match(/\?gid=(\d+)/)) parts.worksheet = url.match(/\?gid=(\d+)/)[1];
    } else if (url.match(/^\b[-_A-Za-z0-9]+$/)) parts.key = url;
    if (parts.key) return parts;
    else return null;
}
function $ce175c6e1ee59955$var$interpretBackground(bkgd) {
    if (typeof bkgd != 'string') return '';
    if (bkgd.match(/^(https?:)?\/\/?/)) return {
        'url': bkgd
    };
    else return {
        'color': bkgd
    };
}
function $ce175c6e1ee59955$var$extractEventFromCSVObject(orig_row) {
    let row = {};
    Object.keys(orig_row).forEach((k)=>{
        row[k] = (0, $ea7d21fd242a7c44$export$87c2784dc9fc4ab)(orig_row[k]) // get rid of white-space and reduce all-blank cells to empty strings
        ;
    });
    var d = {
        media: {
            caption: row['Media Caption'] || '',
            credit: row['Media Credit'] || '',
            url: row['Media'] || '',
            thumbnail: row['Media Thumbnail'] || '',
            alt: row['Alt Text'] || ''
        },
        text: {
            headline: row['Headline'] || '',
            text: row['Text'] || ''
        },
        display_date: row['Display Date'] || '',
        group: row['Group'] || row['Tag'] || '',
        background: $ce175c6e1ee59955$var$interpretBackground(row['Background']),
        type: row['Type'] || ''
    };
    if (Object.keys(row).includes('Start Date') || Object.keys(row).includes('End Date')) {
        // V1 date handling
        if (row['Start Date']) d.start_date = (0, $8d19420aa75ccebb$export$6b862160d295c8e)(row['Start Date']);
        if (row['End Date']) d.end_date = (0, $8d19420aa75ccebb$export$6b862160d295c8e)(row['End Date']);
    } else {
        // V3 date handling
        // every date must have at least a year to be valid.
        if (row['Year']) d.start_date = {
            year: $ce175c6e1ee59955$var$clean_integer(row['Year']),
            month: $ce175c6e1ee59955$var$clean_integer(row['Month']) || '',
            day: $ce175c6e1ee59955$var$clean_integer(row['Day']) || ''
        };
        if (row['End Year']) d.end_date = {
            year: $ce175c6e1ee59955$var$clean_integer(row['End Year']) || '',
            month: $ce175c6e1ee59955$var$clean_integer(row['End Month']) || '',
            day: $ce175c6e1ee59955$var$clean_integer(row['End Day']) || ''
        };
        if (row['Time']) {
            if (d.start_date) (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(d.start_date, (0, $f07ad0328aac39ec$export$c9698ec7f05a07e1)(row['Time']));
            else throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_start_time_without_date");
        }
        if (row['End Time']) {
            if (d.end_date) (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(d.end_date, (0, $f07ad0328aac39ec$export$c9698ec7f05a07e1)(row['End Time']));
            else throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_end_time_without_date");
        }
        if (d.start_date && !(0, $f07ad0328aac39ec$export$3b4666606e877c21)(d.start_date)) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_date_err");
        if (d.end_date && !(0, $f07ad0328aac39ec$export$3b4666606e877c21)(d.end_date)) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_date_err");
    }
    return d;
}
async function $ce175c6e1ee59955$export$d3617a7e872f1479(url, sheets_proxy) {
    let rows = [];
    url = $ce175c6e1ee59955$export$e14e2c1e13bebdb4(url);
    let error = null;
    await (0, $2b5648a5a2019cdf$export$e7a4dadcf0e70e1a)({
        url: `${sheets_proxy}${url}`
    }).then((d)=>{
        rows = d;
    }).catch((error_json)=>{
        if (error_json.proxy_err_code == 'response_not_csv') throw new (0, $07909642145031f1$export$2e2bcd8739ae039)('Timeline could not read the data for your timeline. Make sure you have published it to the web.');
        let msg = "undefined error";
        if (Array.isArray(error_json.message)) msg = error_json.message.join('<br>');
        else msg = String(error_json.message);
        throw new (0, $07909642145031f1$export$2e2bcd8739ae039)(msg);
    });
    let timeline_config = {
        'events': [],
        'errors': [],
        'warnings': [],
        'eras': []
    };
    rows.forEach((row, i)=>{
        try {
            if (!(0, $ea7d21fd242a7c44$export$83b788b1a3698c03)(row)) {
                let event = $ce175c6e1ee59955$var$extractEventFromCSVObject(row);
                $ce175c6e1ee59955$var$handleRow(event, timeline_config);
            }
        } catch (e) {
            if (e.constructor == (0, $07909642145031f1$export$2e2bcd8739ae039)) timeline_config.errors.push(e);
            else {
                if (e.message) e = e.message;
                let label = row['Headline'] || i;
                timeline_config.errors.push(e + `[${label}]`);
            }
        }
    });
    return timeline_config;
}
function $ce175c6e1ee59955$export$e14e2c1e13bebdb4(url_or_key) {
    url_or_key = url_or_key.trim();
    if (url_or_key.match(/^[a-zA-Z0-9-_]+$/)) // key pattern from https://developers.google.com/sheets/api/guides/concepts#spreadsheet_id
    return `https://docs.google.com/spreadsheets/d/${url_or_key}/pub?output=csv`;
    if (url_or_key.startsWith('https://docs.google.com/spreadsheets/')) {
        if (url_or_key.match(/\/pub\?output=csv$/)) return url_or_key;
        let parsed = new URL(url_or_key);
        let params = new URLSearchParams(parsed.search);
        params.set('output', 'csv');
        if (params.get('gid')) params.set('single', 'true');
        parsed.search = `?${params.toString()}`;
        let base_path = parsed.pathname.substr(0, parsed.pathname.lastIndexOf('/'));
        parsed.pathname = `${base_path}/pub`;
        return parsed.toString();
    }
    throw new (0, $07909642145031f1$export$2e2bcd8739ae039)('invalid_url_err', url_or_key);
}
var $ce175c6e1ee59955$var$buildGoogleFeedURL = function(key, api_version) {
    if (api_version == 'v4') return "https://sheets.googleapis.com/v4/spreadsheets/" + key + "/values/A1:R1000?key=AIzaSyCInR0kjJJ2Co6aQAXjLBQ14CEHam3K0xg";
    else return "https://spreadsheets.google.com/feeds/list/" + key + "/1/public/values?alt=json";
};
async function $ce175c6e1ee59955$export$e0bad53d1fd55d95(google_url, options) {
    if (!options['sheets_proxy']) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("Proxy option must be set to read data from Google");
    var timeline_json = await $ce175c6e1ee59955$export$d3617a7e872f1479(google_url, options['sheets_proxy']);
    if (timeline_json) return timeline_json;
}
async function $ce175c6e1ee59955$export$38ad3c7c789c7fed(url, callback_or_options) {
    let callback = null, options = {};
    if (typeof callback_or_options == 'function') callback = callback_or_options;
    else if (typeof callback_or_options == 'object') {
        options = callback_or_options;
        callback = callback_or_options['callback'];
        if (typeof options['callback'] == 'function') callback = options['callback'];
    }
    if (!callback) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("Second argument to makeConfig must be either a function or an object which includes a 'callback' property with a 'function' type value");
    var tc, json, key = $ce175c6e1ee59955$export$a0660ae999f8e7aa(url);
    if (key) {
        try {
            json = await $ce175c6e1ee59955$export$e0bad53d1fd55d95(url, options);
        } catch (e) {
            // even with an error, we make 
            // a TimelineConfig because it's 
            // the most straightforward way to display messages
            // in the DOM
            tc = new (0, $8849a36019263cbd$export$9e1cf9dd451bce3a)();
            if (e.name == 'NetworkError') tc.logError(new (0, $07909642145031f1$export$2e2bcd8739ae039)("network_err"));
            else if (e.name == 'TLError') tc.logError(e);
            else tc.logError(new (0, $07909642145031f1$export$2e2bcd8739ae039)("unknown_read_err", e.name));
            callback(tc);
            return; // don't process further if there were errors
        }
        tc = new (0, $8849a36019263cbd$export$9e1cf9dd451bce3a)(json);
        if (json.errors) for(var i = 0; i < json.errors.length; i++)tc.logError(json.errors[i]);
        callback(tc);
    } else (0, $7f99b552874efbe4$export$e68fce4c5f453854)({
        url: url,
        dataType: 'json',
        success: function(data) {
            try {
                tc = new (0, $8849a36019263cbd$export$9e1cf9dd451bce3a)(data);
            } catch (e) {
                tc = new (0, $8849a36019263cbd$export$9e1cf9dd451bce3a)();
                tc.logError(e);
            }
            callback(tc);
        },
        error: function(xhr, errorType, error) {
            tc = new (0, $8849a36019263cbd$export$9e1cf9dd451bce3a)();
            if (errorType == 'parsererror') var error = new (0, $07909642145031f1$export$2e2bcd8739ae039)("invalid_url_err");
            else var error = new (0, $07909642145031f1$export$2e2bcd8739ae039)("unknown_read_err", errorType);
            tc.logError(error);
            callback(tc);
        }
    });
}
function $ce175c6e1ee59955$var$handleRow(event, timeline_config) {
    var row_type = 'event';
    if (typeof event.type != 'undefined') {
        row_type = event.type;
        delete event.type;
    }
    if (row_type == 'title') {
        if (!timeline_config.title) timeline_config.title = event;
        else {
            timeline_config.warnings.push("Multiple title slides detected.");
            timeline_config.events.push(event);
        }
    } else if (row_type == 'era') timeline_config.eras.push(event);
    else timeline_config.events.push(event);
}














/*  AxisHelper
    Strategies for laying out the timenav
    markers and time axis
    Intended as a private class -- probably only known to TimeScale
    Get them using the exported getBestHelper function
================================================== */ class $4e201d158eb532e8$var$AxisHelper {
    constructor(options){
        if (options) {
            this.scale = options.scale;
            this.minor = options.minor;
            this.major = options.major;
        } else throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("axis_helper_no_options_err");
    }
    getPixelsPerTick(pixels_per_milli) {
        return pixels_per_milli * this.minor.factor;
    }
    getMajorTicks(timescale) {
        return this._getTicks(timescale, this.major);
    }
    getMinorTicks(timescale) {
        return this._getTicks(timescale, this.minor);
    }
    _getTicks(timescale, option) {
        var factor_scale = timescale._scaled_padding * option.factor;
        var first_tick_time = timescale._earliest - factor_scale;
        var last_tick_time = timescale._latest + factor_scale;
        var ticks = [];
        for(var i = first_tick_time; i < last_tick_time; i += option.factor)ticks.push(timescale.getDateFromTime(i).floor(option.name));
        return {
            name: option.name,
            ticks: ticks
        };
    }
}
var $4e201d158eb532e8$var$HELPERS = {};
var $4e201d158eb532e8$var$setHelpers = function(scale_type, scales) {
    $4e201d158eb532e8$var$HELPERS[scale_type] = [];
    for(var idx = 0; idx < scales.length - 1; idx++){
        var minor = scales[idx];
        var major = scales[idx + 1];
        $4e201d158eb532e8$var$HELPERS[scale_type].push(new $4e201d158eb532e8$var$AxisHelper({
            scale: minor[3],
            minor: {
                name: minor[0],
                factor: minor[1]
            },
            major: {
                name: major[0],
                factor: major[1]
            }
        }));
    }
};
$4e201d158eb532e8$var$setHelpers('human', (0, $8d19420aa75ccebb$export$9c2218f463f17dc5));
$4e201d158eb532e8$var$setHelpers('cosmological', (0, $8d19420aa75ccebb$export$47c5250e3f827cc3));
function $4e201d158eb532e8$export$5b920fc1a63f82b3(ts, optimal_tick_width) {
    if (typeof optimal_tick_width != 'number') optimal_tick_width = 100;
    var ts_scale = ts.getScale();
    var helpers = $4e201d158eb532e8$var$HELPERS[ts_scale];
    if (!helpers) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("axis_helper_scale_err", ts_scale);
    var prev = null;
    for(var idx = 0; idx < helpers.length; idx++){
        var curr = helpers[idx];
        var pixels_per_tick = curr.getPixelsPerTick(ts._pixels_per_milli);
        if (pixels_per_tick > optimal_tick_width) {
            if (prev == null) return curr;
            var curr_dist = Math.abs(optimal_tick_width - pixels_per_tick);
            var prev_dist = Math.abs(optimal_tick_width - pixels_per_tick);
            if (curr_dist < prev_dist) return curr;
            else return prev;
        }
        prev = curr;
    }
    return helpers[helpers.length - 1]; // last resort           
}


// Date Format Lookup, map TLDate.SCALES names to...
const $123519fe12b5174b$var$AXIS_TICK_DATEFORMAT_LOOKUP = {
    millisecond: 'time_milliseconds',
    second: 'time_short',
    minute: 'time_no_seconds_short',
    hour: 'time_no_minutes_short',
    day: 'full_short',
    month: 'month_short',
    year: 'year',
    decade: 'year',
    century: 'year',
    millennium: 'year',
    age: 'compact',
    epoch: 'compact',
    era: 'compact',
    eon: 'compact',
    eon2: 'compact'
};
class $123519fe12b5174b$export$a894c72689ff3ec {
    constructor(timeline_config, options){
        var slides = timeline_config.events;
        this._scale = timeline_config.scale;
        options = (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)({
            display_width: 500,
            screen_multiplier: 3,
            max_rows: null
        }, options);
        this._display_width = options.display_width;
        this._screen_multiplier = options.screen_multiplier;
        this._pixel_width = this._screen_multiplier * this._display_width;
        this._group_labels = undefined;
        this._positions = [];
        this._pixels_per_milli = 0;
        this._earliest = timeline_config.getEarliestDate().getTime();
        this._latest = timeline_config.getLatestDate().getTime();
        this._span_in_millis = this._latest - this._earliest;
        if (this._span_in_millis <= 0) this._span_in_millis = this._computeDefaultSpan(timeline_config);
        this._average = this._span_in_millis / slides.length;
        this._pixels_per_milli = this.getPixelWidth() / this._span_in_millis;
        this._axis_helper = (0, $4e201d158eb532e8$export$5b920fc1a63f82b3)(this);
        this._scaled_padding = 1 / this.getPixelsPerTick() * (this._display_width / 2);
        this._computePositionInfo(slides, options.max_rows);
    }
    _computeDefaultSpan(timeline_config) {
        // this gets called when all events are at the same instant,
        // or maybe when the span_in_millis is > 0 but still below a desired threshold
        if (timeline_config.scale == 'human') {
            var formats = {};
            for(var i = 0; i < timeline_config.events.length; i++){
                var fmt = timeline_config.events[i].start_date.findBestFormat();
                formats[fmt] = formats[fmt] ? formats[fmt] + 1 : 1;
            }
            for(var i = (0, $8d19420aa75ccebb$export$9c2218f463f17dc5).length - 1; i >= 0; i--)if (formats.hasOwnProperty((0, $8d19420aa75ccebb$export$9c2218f463f17dc5)[i][0])) {
                var scale = (0, $8d19420aa75ccebb$export$9c2218f463f17dc5)[(0, $8d19420aa75ccebb$export$9c2218f463f17dc5).length - 1]; // default
                if ((0, $8d19420aa75ccebb$export$9c2218f463f17dc5)[i + 1]) scale = (0, $8d19420aa75ccebb$export$9c2218f463f17dc5)[i + 1]; // one larger than the largest in our data
                return scale[1];
            }
            return 31536000000; // default to a year?
        }
        return 200000; // what is the right handling for cosmo dates?
    }
    getGroupLabels() {
        /*
               return an array of objects, one per group, in the order (top to bottom) that the groups are expected to appear. Each object will have two properties:
                   * label (the string as specified in one or more 'group' properties of events in the configuration)
                   * rows (the number of rows occupied by events associated with the label. )
               */ return this._group_labels || [];
    }
    getScale() {
        return this._scale;
    }
    getNumberOfRows() {
        return this._number_of_rows;
    }
    getPixelWidth() {
        return this._pixel_width;
    }
    getPosition(time_in_millis) {
        // be careful using millis, as they won't scale to cosmological time.
        // however, we're moving to make the arg to this whatever value
        // comes from TLDate.getTime() which could be made smart about that --
        // so it may just be about the naming.
        return (time_in_millis - this._earliest) * this._pixels_per_milli;
    }
    getPositionInfo(idx) {
        return this._positions[idx];
    }
    getPixelsPerTick() {
        return this._axis_helper.getPixelsPerTick(this._pixels_per_milli);
    }
    getTicks() {
        return {
            major: this._axis_helper.getMajorTicks(this),
            minor: this._axis_helper.getMinorTicks(this)
        };
    }
    getDateFromTime(t) {
        if (this._scale == 'human') return new (0, $8d19420aa75ccebb$export$f39ff3a2b9f665c1)(t);
        else if (this._scale == 'cosmological') return new (0, $8d19420aa75ccebb$export$bd36b6829733f649)(new (0, $8d19420aa75ccebb$export$e5224a862286d631)(t));
        throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("time_scale_scale_err", this._scale);
    }
    getMajorScale() {
        return this._axis_helper.major.name;
    }
    getMinorScale() {
        return this._axis_helper.minor.name;
    }
    _assessGroups(slides) {
        var groups = [];
        var empty_group = false;
        for(var i = 0; i < slides.length; i++)if (slides[i].group) {
            if (groups.indexOf(slides[i].group) < 0) groups.push(slides[i].group);
            else empty_group = true;
        }
        if (groups.length && empty_group) groups.push('');
        return groups;
    }
    /*  Compute the marker row positions, minimizing the number of
        overlaps.

        @positions = list of objects from this._positions
        @rows_left = number of rows available (assume > 0)
    */ _computeRowInfo(positions, rows_left) {
        var lasts_in_row = [];
        var n_overlaps = 0;
        for(var i = 0; i < positions.length; i++){
            var pos_info = positions[i];
            var overlaps = [];
            // See if we can add item to an existing row without
            // overlapping the previous item in that row
            delete pos_info.row;
            for(var j = 0; j < lasts_in_row.length; j++){
                overlaps.push(lasts_in_row[j].end - pos_info.start);
                if (overlaps[j] <= 0) {
                    pos_info.row = j;
                    lasts_in_row[j] = pos_info;
                    break;
                }
            }
            // If we couldn't add to an existing row without overlap...
            if (typeof pos_info.row == 'undefined') {
                if (rows_left === null) {
                    // Make a new row
                    pos_info.row = lasts_in_row.length;
                    lasts_in_row.push(pos_info);
                } else if (rows_left > 0) {
                    // Make a new row
                    pos_info.row = lasts_in_row.length;
                    lasts_in_row.push(pos_info);
                    rows_left--;
                } else {
                    // Add to existing row with minimum overlap.
                    var min_overlap = Math.min.apply(null, overlaps);
                    var idx = overlaps.indexOf(min_overlap);
                    pos_info.row = idx;
                    if (pos_info.end > lasts_in_row[idx].end) lasts_in_row[idx] = pos_info;
                    n_overlaps++;
                }
            }
        }
        return {
            n_rows: lasts_in_row.length,
            n_overlaps: n_overlaps
        };
    }
    /*  Compute marker positions.  If using groups, this._number_of_rows
        will never be less than the number of groups.

        @max_rows = total number of available rows
        @default_marker_width should be in pixels
    */ _computePositionInfo(slides, max_rows, default_marker_width) {
        default_marker_width = default_marker_width || 100;
        var groups = [];
        var empty_group = false;
        // Set start/end/width; enumerate groups
        for(var i = 0; i < slides.length; i++){
            var pos_info = {
                start: this.getPosition(slides[i].start_date.getTime())
            };
            this._positions.push(pos_info);
            if (typeof slides[i].end_date != 'undefined') {
                var end_pos = this.getPosition(slides[i].end_date.getTime());
                pos_info.width = end_pos - pos_info.start;
                if (pos_info.width > default_marker_width) pos_info.end = pos_info.start + pos_info.width;
                else pos_info.end = pos_info.start + default_marker_width;
            } else {
                pos_info.width = default_marker_width;
                pos_info.end = pos_info.start + default_marker_width;
            }
            if (slides[i].group) {
                if (groups.indexOf(slides[i].group) < 0) groups.push(slides[i].group);
            } else empty_group = true;
        }
        if (!groups.length) {
            var result = this._computeRowInfo(this._positions, max_rows);
            this._number_of_rows = result.n_rows;
        } else {
            if (empty_group) groups.push("");
            // Init group info
            var group_info = [];
            for(var i = 0; i < groups.length; i++)group_info[i] = {
                label: groups[i],
                idx: i,
                positions: [],
                n_rows: 1,
                n_overlaps: 0
            };
            for(var i = 0; i < this._positions.length; i++){
                var pos_info = this._positions[i];
                pos_info.group = groups.indexOf(slides[i].group || "");
                pos_info.row = 0;
                var gi = group_info[pos_info.group];
                for(var j = gi.positions.length - 1; j >= 0; j--)if (gi.positions[j].end > pos_info.start) gi.n_overlaps++;
                gi.positions.push(pos_info);
            }
            var n_rows = groups.length; // start with 1 row per group
            while(true){
                // Count free rows available
                var rows_left = Math.max(0, max_rows - n_rows);
                if (!rows_left) break; // no free rows, nothing to do
                // Sort by # overlaps, idx
                group_info.sort(function(a, b) {
                    if (a.n_overlaps > b.n_overlaps) return -1;
                    else if (a.n_overlaps < b.n_overlaps) return 1;
                    return a.idx - b.idx;
                });
                if (!group_info[0].n_overlaps) break; // no overlaps, nothing to do
                // Distribute free rows among groups with overlaps
                var n_rows = 0;
                for(var i = 0; i < group_info.length; i++){
                    var gi = group_info[i];
                    if (gi.n_overlaps && rows_left) {
                        var res = this._computeRowInfo(gi.positions, gi.n_rows + 1);
                        gi.n_rows = res.n_rows; // update group info
                        gi.n_overlaps = res.n_overlaps;
                        rows_left--; // update rows left
                    }
                    n_rows += gi.n_rows; // update rows used
                }
            }
            // Set number of rows
            this._number_of_rows = n_rows;
            // Set group labels; offset row positions
            this._group_labels = [];
            group_info.sort(function(a, b) {
                return a.idx - b.idx;
            });
            for(var i = 0, row_offset = 0; i < group_info.length; i++){
                this._group_labels.push({
                    label: group_info[i].label,
                    rows: group_info[i].n_rows
                });
                for(var j = 0; j < group_info[i].positions.length; j++){
                    var pos_info = group_info[i].positions[j];
                    pos_info.row += row_offset;
                }
                row_offset += group_info[i].n_rows;
            }
        }
    }
    /**
     * To handle formatting cosmological ticks correctly, let the TimeScale (which knows)
     * give us the format for tick labels on the time axis.
     * @param {String} name - the "level" of dates in the axis
     */ getAxisTickDateFormat(name) {
        if (this._scale == 'cosmological') return 'compact' // is this heavy-handed? cosmologic
        ;
        return $123519fe12b5174b$var$AXIS_TICK_DATEFORMAT_LOOKUP[name];
    }
}







class $a5808eb6456b091b$export$9886ff53633678b5 {
    constructor(data){
        // DOM ELEMENTS
        this._el = {
            parent: {},
            container: {},
            message: {}
        };
        //Options
        this.options = {
            width: 600,
            height: 600
        };
        // Data
        this.data = {
            label: "",
            rows: 1
        };
        this._el.container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timegroup");
        // Merge Data
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.data, data);
        // Animation
        this.animator = {};
        this._initLayout();
        this._initEvents();
    }
    /*	Public
	================================================== */ /*	Update Display
	================================================== */ updateDisplay(w, h) {}
    setRowPosition(n, h) {
        this.options.height = h * this.data.rows;
        this.setPosition({
            top: n
        });
        this._el.container.style.height = this.options.height + "px";
    }
    setAlternateRowColor(alternate, hide) {
        var class_name = "tl-timegroup";
        if (alternate) class_name += " tl-timegroup-alternate";
        if (hide) class_name += " tl-timegroup-hidden";
        this._el.container.className = class_name;
    }
    /*	Events
	================================================== */ _onMouseClick() {
        this.fire("clicked", this.options);
    }
    /*	Private Methods
	================================================== */ _initLayout() {
        // Create Layout
        this._el.message = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timegroup-message", this._el.container);
        this._el.message.innerHTML = this.data.label;
    }
    _initEvents() {
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.container, 'click', this._onMouseClick, this);
    }
    // Update Display
    _updateDisplay(width, height, animate) {}
}
(0, $ea7d21fd242a7c44$export$c5910a33574a115e)($a5808eb6456b091b$export$9886ff53633678b5, (0, $d92d8eaa035c7b70$export$2e2bcd8739ae039), (0, $8948f35b9a5753b9$export$b8c17d0037837cb6));








class $cb9449ab395564cb$export$7f5cf634ef8d6093 {
    constructor(start_date, end_date, headline, options){
        this.start_date = start_date;
        this.end_date = end_date;
        this.headline = headline;
        // DOM Elements
        this._el = {
            container: {},
            background: {},
            content_container: {},
            content: {},
            text: {}
        };
        // Components
        this._text = {};
        // State
        this._state = {
            loaded: false
        };
        // Options
        this.options = {
            duration: 1000,
            ease: (0, $2baebbd96bfe7e6e$export$f7d97b709d0a6c59),
            width: 600,
            height: 600,
            marker_width_min: 100
        };
        // Actively Displaying
        this.active = false;
        // Animation Object
        this.animator = {};
        // End date
        this.has_end_date = false;
        // Merge Data and Options
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.options, options);
        this._initLayout();
        this._initEvents();
    }
    /*	Adding, Hiding, Showing etc
    ================================================== */ show() {}
    hide() {}
    setActive(is_active) {}
    addTo(container) {
        container.appendChild(this._el.container);
    }
    removeFrom(container) {
        container.removeChild(this._el.container);
    }
    updateDisplay(w, h) {
        this._updateDisplay(w, h);
    }
    getLeft() {
        return this._el.container.style.left.slice(0, -2);
    }
    getTime() {
        return this.start_date.getTime();
    }
    getEndTime() {
        if (this.end_date) return this.end_date.getTime();
        else return false;
    }
    setHeight(h) {
        var text_line_height = 12, text_lines = 1;
        this._el.content_container.style.height = h + "px";
        this._el.content.className = "tl-timeera-content";
        // Handle number of lines visible vertically
        if ($e8c72613a0980cab$export$db07bc05b2fb9b73) {
            text_lines = Math.floor(h / (text_line_height + 2));
            if (text_lines < 1) text_lines = 1;
            this._text.className = "tl-headline";
            this._text.style.webkitLineClamp = text_lines;
        } else {
            text_lines = h / text_line_height;
            if (text_lines > 1) this._text.className = "tl-headline tl-headline-fadeout";
            else this._text.className = "tl-headline";
            this._text.style.height = text_lines * text_line_height + "px";
        }
    }
    setWidth(w) {
        if (this.end_date) {
            this._el.container.style.width = w + "px";
            if (w > this.options.marker_width_min) {
                this._el.content_container.style.width = w + "px";
                this._el.content_container.className = "tl-timeera-content-container tl-timeera-content-container-long";
            } else {
                this._el.content_container.style.width = this.options.marker_width_min + "px";
                this._el.content_container.className = "tl-timeera-content-container";
            }
        }
    }
    setClass(n) {
        this._el.container.className = n;
    }
    setRowPosition(n, remainder) {
        this.setPosition({
            top: n
        });
        if (remainder < 56) this._el.content_container.remove("tl-timeera-content-container-small");
    }
    setColor(color_num) {
        this._el.container.className = 'tl-timeera tl-timeera-color' + color_num;
    }
    /*	Events
    ================================================== */ /*	Private Methods
    ================================================== */ _initLayout() {
        // Create Layout
        this._el.container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timeera");
        if (this.end_date) {
            this.has_end_date = true;
            this._el.container.className = 'tl-timeera tl-timeera-with-end';
        }
        this._el.content_container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timeera-content-container", this._el.container);
        this._el.background = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timeera-background", this._el.content_container);
        this._el.content = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timeera-content", this._el.content_container);
        // Text
        this._el.text = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timeera-text", this._el.content);
        this._text = $9eb7ee258fcc7829$export$185802fd694ee1f5("h2", "tl-headline", this._el.text);
        if (this.headline && this.headline != "") this._text.innerHTML = (0, $ea7d21fd242a7c44$export$8c140248b4280ca1)(this.headline);
        // Fire event that the slide is loaded
        this.onLoaded();
    }
    _initEvents() {}
    // Update Display
    _updateDisplay(width, height, layout) {
        if (width) this.options.width = width;
        if (height) this.options.height = height;
    }
}
(0, $ea7d21fd242a7c44$export$c5910a33574a115e)($cb9449ab395564cb$export$7f5cf634ef8d6093, (0, $d92d8eaa035c7b70$export$2e2bcd8739ae039), (0, $8948f35b9a5753b9$export$b8c17d0037837cb6));








function $bca268421445ad88$var$isInHorizontalViewport(element) {
    const rect = element.getBoundingClientRect();
    return rect.left >= 0 && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}
class $bca268421445ad88$export$ff3f087ada3aa913 {
    constructor(elem, options, language){
        if (language) this.setLanguage(language);
        // DOM Elements
        this._el = {
            container: {},
            content_container: {},
            major: {},
            minor: {}
        };
        // Components
        this._text = {};
        // State
        this._state = {
            loaded: false
        };
        // Data
        this.data = {};
        // Options
        this.options = {
            duration: 1000,
            ease: (0, $2baebbd96bfe7e6e$export$f7d97b709d0a6c59),
            width: 600,
            height: 600
        };
        // Actively Displaying
        this.active = false;
        // Animation Object
        this.animator = {};
        // Axis Helper
        this.axis_helper = {};
        // Minor tick dom element array
        this.minor_ticks = [];
        // Minor tick dom element array
        this.major_ticks = [];
        // Main element
        if (typeof elem === 'object') this._el.container = elem;
        else this._el.container = $9eb7ee258fcc7829$export$3988ae62b71be9a3(elem);
        // Merge Data and Options
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.options, options);
        this._initLayout();
        this._initEvents();
    }
    /*	Adding, Hiding, Showing etc
    ================================================== */ show() {}
    hide() {}
    addTo(container) {
        container.appendChild(this._el.container);
    }
    removeFrom(container) {
        container.removeChild(this._el.container);
    }
    updateDisplay(w, h) {
        this._updateDisplay(w, h);
    }
    getLeft() {
        return this._el.container.style.left.slice(0, -2);
    }
    drawTicks(timescale, optimal_tick_width) {
        var ticks = timescale.getTicks();
        // FADE OUT
        this._el.major.className = "tl-timeaxis-major";
        this._el.minor.className = "tl-timeaxis-minor";
        this._el.major.style.opacity = 0;
        this._el.minor.style.opacity = 0;
        // CREATE MAJOR TICKS
        this.major_ticks = this._createTickElements(ticks['major'].ticks, this._el.major, timescale.getAxisTickDateFormat(ticks['major'].name));
        // CREATE MINOR TICKS
        this.minor_ticks = this._createTickElements(ticks['minor'].ticks, this._el.minor, timescale.getAxisTickDateFormat(ticks['minor'].name), ticks['major'].ticks);
        this.positionTicks(timescale, optimal_tick_width, true);
        // FADE IN
        this._el.major.className = "tl-timeaxis-major tl-animate-opacity tl-timeaxis-animate-opacity";
        this._el.minor.className = "tl-timeaxis-minor tl-animate-opacity tl-timeaxis-animate-opacity";
        this._el.major.style.opacity = 1;
        this._el.minor.style.opacity = 1;
    }
    _createTickElements(ts_ticks, tick_element, dateformat, ticks_to_skip) {
        tick_element.innerHTML = "";
        var skip_times = {};
        var yearZero = new Date(-1, 13, -30);
        skip_times[yearZero.getTime()] = true;
        if (ticks_to_skip) for(var i = 0; i < ticks_to_skip.length; i++)skip_times[ticks_to_skip[i].getTime()] = true;
        var tick_elements = [];
        for(var i = 0; i < ts_ticks.length; i++){
            var ts_tick = ts_ticks[i];
            if (!(ts_tick.getTime() in skip_times)) {
                var tick = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timeaxis-tick", tick_element), tick_text = $9eb7ee258fcc7829$export$185802fd694ee1f5("span", "tl-timeaxis-tick-text tl-animate-opacity", tick);
                let tick_display_date = ts_tick.getDisplayDate(this.getLanguage(), dateformat);
                tick_text.innerHTML = tick_display_date;
                tick_elements.push({
                    tick: tick,
                    tick_text: tick_text,
                    display_date: tick_display_date,
                    date: ts_tick
                });
            }
        }
        return tick_elements;
    }
    positionTicks(timescale, optimal_tick_width, no_animate) {
        // Handle Animation
        if (no_animate) {
            this._el.major.className = "tl-timeaxis-major";
            this._el.minor.className = "tl-timeaxis-minor";
        } else {
            this._el.major.className = "tl-timeaxis-major tl-timeaxis-animate";
            this._el.minor.className = "tl-timeaxis-minor tl-timeaxis-animate";
        }
        this._positionTickArray(this.major_ticks, timescale, optimal_tick_width);
        this._positionTickArray(this.minor_ticks, timescale, optimal_tick_width);
    }
    _positionTickArray(tick_array, timescale, optimal_tick_width) {
        // Poition Ticks & Handle density of ticks
        if (tick_array[1] && tick_array[0]) {
            var distance = timescale.getPosition(tick_array[1].date.getMillisecond()) - timescale.getPosition(tick_array[0].date.getMillisecond()), fraction_of_array = 1;
            if (distance < optimal_tick_width) fraction_of_array = Math.round(optimal_tick_width / timescale.getPixelsPerTick());
            var show = 1;
            for(var i = 0; i < tick_array.length; i++){
                var tick = tick_array[i];
                // Poition Ticks
                tick.tick.style.left = timescale.getPosition(tick.date.getMillisecond()) + "px";
                tick.tick_text.innerHTML = tick.display_date;
                // Handle density of ticks
                if (fraction_of_array > 1) {
                    if (show >= fraction_of_array) {
                        show = 1;
                        tick.tick_text.style.opacity = 1;
                        tick.tick.className = "tl-timeaxis-tick";
                    } else {
                        show++;
                        tick.tick_text.style.opacity = 0;
                        tick.tick.className = "tl-timeaxis-tick tl-timeaxis-tick-hidden";
                    }
                } else {
                    tick.tick_text.style.opacity = 1;
                    tick.tick.className = "tl-timeaxis-tick";
                }
            }
        }
    }
    getVisibleTicks() {
        return {
            major: this._getVisibleTickArray(this.major_ticks),
            minor: this._getVisibleTickArray(this.minor_ticks)
        };
    }
    _getVisibleTickArray(tick_array) {
        return tick_array.filter(({ tick: tick })=>$bca268421445ad88$var$isInHorizontalViewport(tick));
    }
    /*	Events
    ================================================== */ /*	Private Methods
    ================================================== */ _initLayout() {
        this._el.content_container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timeaxis-content-container", this._el.container);
        this._el.major = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timeaxis-major", this._el.content_container);
        this._el.minor = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timeaxis-minor", this._el.content_container);
        // Fire event that the slide is loaded
        this.onLoaded();
    }
    _initEvents() {}
    // Update Display
    _updateDisplay(width, height, layout) {
        if (width) this.options.width = width;
        if (height) this.options.height = height;
    }
}
(0, $ea7d21fd242a7c44$export$c5910a33574a115e)($bca268421445ad88$export$ff3f087ada3aa913, (0, $d92d8eaa035c7b70$export$2e2bcd8739ae039), (0, $8948f35b9a5753b9$export$b8c17d0037837cb6), (0, $2319cf524e876851$export$222529f9b823899b));









/*
    Determines the type of media the url string is.
    returns an object with .type and .id
    You can add new media types by adding a regex
    to match and the media class name to use to
    render the media

    The image_only parameter indicates that the
    call only wants an image-based media type
    that can be resolved to an image URL.
================================================== */ 







class $1c5ef04904e0a0f5$export$5f1af8db9871e1d6 {
    constructor(data, options, add_to_container){
        this._el = {
            container: {},
            content_container: {},
            content: {},
            headline_container: {},
            headline: {},
            date: {}
        };
        this.options = {
            title: false
        };
        this.data = {
            unique_id: "",
            headline: "headline",
            text: "text"
        };
        (0, $ea7d21fd242a7c44$export$3a6802af14bf5fa6)(this, data); // override defaults
        // Merge Options
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.options, options);
        this._el.container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-text");
        this._el.container.id = this.data.unique_id;
        this._initLayout();
        if (add_to_container) add_to_container.appendChild(this._el.container);
    }
    /*	Adding, Hiding, Showing etc
	================================================== */ show() {}
    hide() {}
    addTo(container) {
        container.appendChild(this._el.container);
    //this.onAdd();
    }
    removeFrom(container) {
        container.removeChild(this._el.container);
    }
    headlineHeight() {
        return this._el.headline.offsetHeight + 40;
    }
    addDateText(str) {
        this._el.date.innerHTML = str;
    }
    /*	Events
	================================================== */ onLoaded() {
        this.fire("loaded", this.data);
    }
    onAdd() {
        this.fire("added", this.data);
    }
    onRemove() {
        this.fire("removed", this.data);
    }
    /*	Private Methods
	================================================== */ _initLayout() {
        // Create Layout
        this._el.content_container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-text-content-container", this._el.container);
        this._el.headline_container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-text-headline-container", this._el.content_container);
        // Headline
        if (this.data.headline != "") {
            var headline_class = "tl-headline";
            if (this.options.title) headline_class = "tl-headline tl-headline-title";
            this._el.headline = $9eb7ee258fcc7829$export$185802fd694ee1f5("h2", headline_class, this._el.headline_container);
            this._el.headline.innerHTML = this.data.headline;
        }
        // Date
        this._el.date = $9eb7ee258fcc7829$export$185802fd694ee1f5("h3", "tl-headline-date", this._el.headline_container);
        // Text
        if (this.data.text != "") {
            var text_content = "";
            text_content += (0, $ea7d21fd242a7c44$export$beaf23cf02933a13)(this.options.autolink == true ? (0, $ea7d21fd242a7c44$export$8ccbde94d5c7f8e7)(this.data.text) : this.data.text);
            this._el.content = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-text-content", this._el.content_container);
            this._el.content.innerHTML = text_content;
        }
        // Fire event that the slide is loaded
        this.onLoaded();
    }
}
(0, $ea7d21fd242a7c44$export$c5910a33574a115e)($1c5ef04904e0a0f5$export$5f1af8db9871e1d6, (0, $d92d8eaa035c7b70$export$2e2bcd8739ae039));



class $b9944b7f97982afb$export$7fc53215244aec38 {
    constructor(data, options, language){
        if (language) this.setLanguage(language);
        // DOM ELEMENTS
        this._el = {
            container: {},
            content_container: {},
            content: {},
            content_item: {},
            content_link: {},
            caption: null,
            credit: null,
            parent: {},
            link: null
        };
        // Player (If Needed)
        this.player = null;
        // Timer (If Needed)
        this.timer = null;
        this.load_timer = null;
        // Message
        this.message = null;
        // Media ID
        this.media_id = null;
        // State
        this._state = {
            loaded: false,
            show_meta: false,
            media_loaded: false
        };
        // Data
        this.data = {
            unique_id: null,
            url: null,
            credit: null,
            caption: null,
            credit_alternate: null,
            caption_alternate: null,
            link: null,
            link_target: null
        };
        //Options
        this.options = {
            api_key_flickr: "bd3a7c45ddd52f3101825d41563a6125",
            api_key_googlemaps: "AIzaSyB9dW8e_iRrATFa8g24qB6BDBGdkrLDZYI",
            api_key_embedly: "",
            credit_height: 0,
            caption_height: 0,
            background: 0 // is background media (for slide)
        };
        this.animator = {};
        // Merge Data and Options
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.options, options);
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.data, data);
        // Don't create DOM elements if this is background media
        if (!this.options.background) {
            this._el.container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-media");
            if (this.data.unique_id) this._el.container.id = this.data.unique_id;
            this._initLayout();
        }
    }
    loadMedia() {
        var self = this;
        if (!this._state.loaded) try {
            this.load_timer = setTimeout(function() {
                self.loadingMessage();
                self._loadMedia();
                // self._state.loaded = true; handled in onLoaded()
                self._updateDisplay();
            }, 1200);
        } catch (e) {
            (0, $ea7d21fd242a7c44$export$357889f174732d38)("Error loading media for ", this._media);
            (0, $ea7d21fd242a7c44$export$357889f174732d38)(e);
        }
    }
    _updateMessage(msg) {
        if (this.message) this.message.updateMessage(msg);
    }
    loadingMessage() {
        this._updateMessage(this._('loading') + " " + this.options.media_name);
    }
    errorMessage(msg) {
        if (msg) msg = this._('error') + ": " + msg;
        else msg = this._('error');
        this._updateMessage(msg);
    }
    updateMediaDisplay(layout) {
        if (this._state.loaded && !this.options.background) {
            if ($e8c72613a0980cab$export$1c4e7a9c31a6c071) this._el.content_item.style.maxHeight = this.options.height / 2 + "px";
            else this._el.content_item.style.maxHeight = this.options.height - this.options.credit_height - this.options.caption_height - 30 + "px";
            //this._el.content_item.style.maxWidth = this.options.width + "px";
            this._el.container.style.maxWidth = this.options.width + "px";
            // Fix for max-width issues in Firefox
            if ($e8c72613a0980cab$export$bbe03eaf052676c9) this._el.content_item.offsetWidth, this._el.content_item.offsetHeight;
            this._updateMediaDisplay(layout);
            if (this._state.media_loaded) {
                if (this._el.credit) this._el.credit.style.width = this._el.content_item.offsetWidth + "px";
                if (this._el.caption) this._el.caption.style.width = this._el.content_item.offsetWidth + "px";
            }
        }
    }
    /*	Media Specific
    ================================================== */ _loadMedia() {
        // All overrides must call this.onLoaded() to set state
        this.onLoaded();
    }
    _updateMediaDisplay(l) {
        //this._el.content_item.style.maxHeight = (this.options.height - this.options.credit_height - this.options.caption_height - 16) + "px";
        if ($e8c72613a0980cab$export$bbe03eaf052676c9) {
            this._el.content_item.style.maxWidth = this.options.width + "px";
            this._el.content_item.style.width = "auto";
        }
    }
    _getMeta() {}
    _getImageURL(w, h) {
        // Image-based media types should return <img>-compatible src url
        return "";
    }
    /*	Public
    ================================================== */ show() {}
    hide() {}
    addTo(container) {
        container.appendChild(this._el.container);
        this.onAdd();
    }
    removeFrom(container) {
        container.removeChild(this._el.container);
        this.onRemove();
    }
    getImageURL(w, h) {
        return this._getImageURL(w, h);
    }
    // Update Display
    updateDisplay(w, h, l) {
        this._updateDisplay(w, h, l);
    }
    stopMedia() {
        try {
            this._stopMedia();
        } catch (e) {
            (0, $ea7d21fd242a7c44$export$357889f174732d38)(`stopMedia() exception: ${e}`);
        }
    }
    loadErrorDisplay(message) {
        try {
            this._el.content.removeChild(this._el.content_item);
        } catch (e) {
        // if this._el.content_item isn't a child of this._el then just keep truckin
        }
        this._el.content_item = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-media-item tl-media-loaderror", this._el.content);
        this._el.content_item.innerHTML = "<div class='tl-icon-" + this.options.media_type + "'></div><p>" + message + "</p>";
        // After Loaded
        this.onLoaded(true);
    }
    /*	Events
    ================================================== */ onLoaded(error) {
        this._state.loaded = true;
        this.fire("loaded", this.data);
        if (this.message) this.message.hide();
        if (!(error || this.options.background)) this.showMeta();
        this.updateDisplay();
    }
    onMediaLoaded(e) {
        this._state.media_loaded = true;
        this.fire("media_loaded", this.data);
        if (this._el.credit) this._el.credit.style.width = this._el.content_item.offsetWidth + "px";
        if (this._el.caption) this._el.caption.style.width = this._el.content_item.offsetWidth + "px";
    }
    showMeta(credit, caption) {
        this._state.show_meta = true;
        // Credit
        if (this.data.credit && this.data.credit != "") {
            this._el.credit = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-credit", this._el.content_container);
            this._el.credit.innerHTML = this.options.autolink == true ? (0, $ea7d21fd242a7c44$export$8ccbde94d5c7f8e7)(this.data.credit) : this.data.credit;
            this.options.credit_height = this._el.credit.offsetHeight;
        }
        // Caption
        if (this.data.caption && this.data.caption != "") {
            this._el.caption = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-caption", this._el.content_container);
            this._el.caption.innerHTML = this.options.autolink == true ? (0, $ea7d21fd242a7c44$export$8ccbde94d5c7f8e7)(this.data.caption) : this.data.caption;
            this.options.caption_height = this._el.caption.offsetHeight;
        }
        if (!this.data.caption || !this.data.credit) this.getMeta();
    }
    getMeta() {
        this._getMeta();
    }
    updateMeta() {
        if (!this.data.credit && this.data.credit_alternate) {
            this._el.credit = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-credit", this._el.content_container);
            this._el.credit.innerHTML = this.data.credit_alternate;
            this.options.credit_height = this._el.credit.offsetHeight;
        }
        if (!this.data.caption && this.data.caption_alternate) {
            this._el.caption = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-caption", this._el.content_container);
            this._el.caption.innerHTML = this.data.caption_alternate;
            this.options.caption_height = this._el.caption.offsetHeight;
        }
        this.updateDisplay();
    }
    onAdd() {
        this.fire("added", this.data);
    }
    onRemove() {
        this.fire("removed", this.data);
    }
    /*	Private Methods
    ================================================== */ _initLayout() {
        // Message
        this.message = new (0, $c47270e117695841$export$2e2bcd8739ae039)(this._el.container, this.options, this.getLanguage());
        // this.message.addTo(this._el.container);
        // Create Layout
        this._el.content_container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-media-content-container", this._el.container);
        // Link
        if (this.data.link && this.data.link != "") {
            this._el.link = $9eb7ee258fcc7829$export$185802fd694ee1f5("a", "tl-media-link", this._el.content_container);
            this._el.link.href = this.data.link;
            if (this.data.link_target && this.data.link_target != "") this._el.link.target = this.data.link_target;
            else this._el.link.target = "_blank";
            if (this._el.link.target == '_blank') this._el.link.setAttribute('rel', 'noopener');
            this._el.content = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-media-content", this._el.link);
        } else this._el.content = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-media-content", this._el.content_container);
    }
    // Update Display
    _updateDisplay(w, h, l) {
        if (w) this.options.width = w;
        //this._el.container.style.width = this.options.width + "px";
        if (h) this.options.height = h;
        if (l) this.options.layout = l;
        if (this._el.credit) this.options.credit_height = this._el.credit.offsetHeight;
        if (this._el.caption) this.options.caption_height = this._el.caption.offsetHeight + 5;
        this.updateMediaDisplay(this.options.layout);
    }
    domCreate(...params) {
        return $9eb7ee258fcc7829$export$185802fd694ee1f5(...params);
    }
    _stopMedia() {}
}
(0, $ea7d21fd242a7c44$export$c5910a33574a115e)($b9944b7f97982afb$export$7fc53215244aec38, (0, $d92d8eaa035c7b70$export$2e2bcd8739ae039), (0, $2319cf524e876851$export$222529f9b823899b));




class $dc938f6728847e27$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        // Loading Message
        this.loadingMessage();
        // Create media?
        if (!this.options.background) this.createMedia();
        // After loaded
        this.onLoaded();
    }
    createMedia() {
        var self = this, image_class = "tl-media-item tl-media-image tl-media-shadow";
        if (this.data.url.match(/.png(\?.*)?$/) || this.data.url.match(/.svg(\?.*)?$/)) image_class = "tl-media-item tl-media-image";
        this._el.content_item = this.domCreate("img", image_class, this._el.content);
        if (this.data.alt) this._el.content_item.alt = this.data.alt;
        else if (this.data.caption) this._el.content_item.alt = (0, $ea7d21fd242a7c44$export$db594ec12e4bdab1)(this.data.caption);
        if (this.data.title) this._el.content_item.title = this.data.title;
        else if (this.data.caption) this._el.content_item.title = (0, $ea7d21fd242a7c44$export$db594ec12e4bdab1)(this.data.caption);
        // Media Loaded Event
        this._el.content_item.addEventListener('load', function(e) {
            self.onMediaLoaded();
        });
        this._el.content_item.src = this.getImageURL();
    }
    getImageURL(w, h) {
        return (0, $ea7d21fd242a7c44$export$5ca970047f7e3018)(this.data.url);
    }
    _updateMediaDisplay(layout) {
        if ($e8c72613a0980cab$export$bbe03eaf052676c9) //this._el.content_item.style.maxWidth = (this.options.width/2) - 40 + "px";
        this._el.content_item.style.width = "auto";
    }
}



/*	Load
  Loads External Javascript and CSS
  Adapted from LazyLoad and adjusted from earlier TimelineJS to
  not add an extra layer.  Seems like we could simplify
  this, but leaving in in case users need support for older browsers.
  ================================================== */ /*
LazyLoad makes it easy and painless to lazily load one or more external
JavaScript or CSS files on demand either during or after the rendering of a web
page.

Supported browsers include Firefox 2+, IE6+, Safari 3+ (including Mobile
Safari), Google Chrome, and Opera 9+. Other browsers may or may not work and
are not officially supported.

Visit https://github.com/rgrove/lazyload/ for more info.

Copyright (c) 2011 Ryan Grove <ryan@wonko.com>
All rights reserved.

Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the 'Software'), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
the Software, and to permit persons to whom the Software is furnished to do so,
subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ class $6ba50b95af76efe0$var$Loader {
    constructor(document1){
        this.doc = document1;
        this.pending = {};
        this.queue = {
            css: [],
            js: []
        };
        this.styleSheets = document1.styleSheets;
        this.env = this.getEnv();
        this.head = this.doc.head || this.doc.getElementsByTagName('head')[0];
        this.pollCount = 0;
    }
    // -- Private Methods --------------------------------------------------------
    /**
    Creates and returns an HTML element with the specified name and attributes.

    @method createNode
    @param {String} name element name
    @param {Object} attrs name/value mapping of element attributes
    @return {HTMLElement}
    @private
    */ createNode(name, attrs) {
        var node = this.doc.createElement(name), attr;
        for(attr in attrs)if (attrs.hasOwnProperty(attr)) node.setAttribute(attr, attrs[attr]);
        return node;
    }
    /**
    Called when the current pending resource of the specified type has finished
    loading. Executes the associated callback (if any) and loads the next
    resource in the queue.

    @method finish
    @param {String} type resource type ('css' or 'js')
    @private
    */ finish(type) {
        var p = this.pending[type], callback, urls;
        if (p) {
            callback = p.callback;
            urls = p.urls;
            urls.shift();
            this.pollCount = 0;
            // If this is the last of the pending URLs, execute the callback and
            // start the next request in the queue (if any).
            if (!urls.length) {
                callback && callback.call(p.context, p.obj);
                this.pending[type] = null;
                this.queue[type].length && this.load(type);
            }
        }
    }
    /**
    Populates the <code>env</code> variable with user agent and feature test
    information.

    @method getEnv
    @private
    */ getEnv() {
        var ua = navigator.userAgent;
        var env = {
            // True if this browser supports disabling async mode on dynamically
            // created script nodes. See
            // http://wiki.whatwg.org/wiki/Dynamic_Script_Execution_Order
            async: this.doc.createElement('script').async === true
        };
        (env.webkit = /AppleWebKit\//.test(ua)) || (env.ie = /MSIE/.test(ua)) || (env.opera = /Opera/.test(ua)) || (env.gecko = /Gecko\//.test(ua)) || (env.unknown = true);
        return env;
    }
    /**
    Loads the specified resources, or the next resource of the specified type
    in the queue if no resources are specified. If a resource of the specified
    type is already being loaded, the new request will be queued until the
    first request has been finished.

    When an array of resource URLs is specified, those URLs will be loaded in
    parallel if it is possible to do so while preserving execution order. All
    browsers support parallel loading of CSS, but only Firefox and Opera
    support parallel loading of scripts. In other browsers, scripts will be
    queued and loaded one at a time to ensure correct execution order.

    @method load
    @param {String} type resource type ('css' or 'js')
    @param {String|Array} urls (optional) URL or array of URLs to load
    @param {Function} callback (optional) callback function to execute when the
      resource is loaded
    @param {Object} obj (optional) object to pass to the callback function
    @param {Object} context (optional) if provided, the callback function will
      be executed in this object's context
    @private
    */ load(type, urls, callback, obj, context) {
        var _finish = (function() {
            this.finish(type);
        }).bind(this), isCSS = type === 'css', nodes = [], i, len, node, p, pendingUrls, url;
        if (urls) {
            // If urls is a string, wrap it in an array. Otherwise assume it's an
            // array and create a copy of it so modifications won't be made to the
            // original.
            urls = typeof urls === 'string' ? [
                urls
            ] : urls.concat();
            // Create a request object for each URL. If multiple URLs are specified,
            // the callback will only be executed after all URLs have been loaded.
            //
            // Sadly, Firefox and Opera are the only browsers capable of loading
            // scripts in parallel while preserving execution order. In all other
            // browsers, scripts must be loaded sequentially.
            //
            // All browsers respect CSS specificity based on the order of the link
            // elements in the DOM, regardless of the order in which the stylesheets
            // are actually downloaded.
            if (isCSS || this.env.async || this.env.gecko || this.env.opera) // Load in parallel.
            this.queue[type].push({
                urls: urls,
                callback: callback,
                obj: obj,
                context: context
            });
            else // Load sequentially.
            for(i = 0, len = urls.length; i < len; ++i)this.queue[type].push({
                urls: [
                    urls[i]
                ],
                callback: i === len - 1 ? callback : null,
                obj: obj,
                context: context
            });
        }
        // If a previous load request of this type is currently in progress, we'll
        // wait our turn. Otherwise, grab the next item in the queue.
        if (this.pending[type] || !(p = this.pending[type] = this.queue[type].shift())) return;
        pendingUrls = p.urls;
        for(i = 0, len = pendingUrls.length; i < len; ++i){
            url = pendingUrls[i];
            if (isCSS) node = this.env.gecko ? this.createNode('style') : this.createNode('link', {
                href: url,
                rel: 'stylesheet'
            });
            else {
                node = this.createNode('script', {
                    src: url
                });
                node.async = false;
            }
            node.className = 'lazyload';
            node.setAttribute('charset', 'utf-8');
            if (this.env.ie && !isCSS) node.onreadystatechange = function() {
                if (/loaded|complete/.test(node.readyState)) {
                    node.onreadystatechange = null;
                    _finish();
                }
            };
            else if (isCSS && (this.env.gecko || this.env.webkit)) {
                // Gecko and WebKit don't support the onload event on link nodes.
                if (this.env.webkit) {
                    // In WebKit, we can poll for changes to document.styleSheets to
                    // figure out when stylesheets have loaded.
                    p.urls[i] = node.href; // resolve relative URLs (or polling won't work)
                    this.pollWebKit();
                } else {
                    // In Gecko, we can import the requested URL into a <style> node and
                    // poll for the existence of node.sheet.cssRules. Props to Zach
                    // Leatherman for calling my attention to this technique.
                    node.innerHTML = '@import "' + url + '";';
                    this.pollGecko(node);
                }
            } else node.onload = node.onerror = _finish;
            nodes.push(node);
        }
        for(i = 0, len = nodes.length; i < len; ++i)this.head.appendChild(nodes[i]);
    }
    /**
    Begins polling to determine when the specified stylesheet has finished loading
    in Gecko. Polling stops when all pending stylesheets have loaded or after 10
    seconds (to prevent stalls).

    Thanks to Zach Leatherman for calling my attention to the @import-based
    cross-domain technique used here, and to Oleg Slobodskoi for an earlier
    same-domain implementation. See Zach's blog for more details:
    http://www.zachleat.com/web/2010/07/29/load-css-dynamically/

    @method pollGecko
    @param {HTMLElement} node Style node to poll.
    @private
    */ pollGecko(node) {
        var hasRules;
        try {
            // We don't really need to store this value or ever refer to it again, but
            // if we don't store it, Closure Compiler assumes the code is useless and
            // removes it.
            hasRules = !!node.sheet.cssRules;
        } catch (ex) {
            // An exception means the stylesheet is still loading.
            this.pollCount += 1;
            if (this.pollCount < 200) {
                var self = this;
                setTimeout(function() {
                    self.pollGecko(node);
                }, 50);
            } else // We've been polling for 10 seconds and nothing's happened. Stop
            // polling and finish the pending requests to avoid blocking further
            // requests.
            hasRules && this.finish('css');
            return;
        }
        // If we get here, the stylesheet has loaded.
        this.finish('css');
    }
    /**
    Begins polling to determine when pending stylesheets have finished loading
    in WebKit. Polling stops when all pending stylesheets have loaded or after 10
    seconds (to prevent stalls).

    @method pollWebKit
    @private
    */ pollWebKit() {
        var css = this.pending.css, i;
        if (css) {
            i = this.styleSheets.length;
            // Look for a stylesheet matching the pending URL.
            while(--i >= 0)if (this.styleSheets[i].href === css.urls[0]) {
                this.finish('css');
                break;
            }
            this.pollCount += 1;
            if (css) {
                if (this.pollCount < 200) setTimeout(this.pollWebKit.bind(this), 50);
                else // We've been polling for 10 seconds and nothing's happened, which may
                // indicate that the stylesheet has been removed from the document
                // before it had a chance to load. Stop polling and finish the pending
                // request to prevent blocking further requests.
                this.finish('css');
            }
        }
    }
    /**
    Requests the specified CSS URL or URLs and executes the specified
    callback (if any) when they have finished loading. If an array of URLs is
    specified, the stylesheets will be loaded in parallel and the callback
    will be executed after all stylesheets have finished loading.

    @method css
    @param {String|Array} urls CSS URL or array of CSS URLs to load
    @param {Function} callback (optional) callback function to execute when
      the specified stylesheets are loaded
    @param {Object} obj (optional) object to pass to the callback function
    @param {Object} context (optional) if provided, the callback function
      will be executed in this object's context
    @static
    */ css(urls, callback, obj, context) {
        this.load('css', urls, callback, obj, context);
    }
    /**
    Requests the specified JavaScript URL or URLs and executes the specified
    callback (if any) when they have finished loading. If an array of URLs is
    specified and the browser supports it, the scripts will be loaded in
    parallel and the callback will be executed after all scripts have
    finished loading.

    Currently, only Firefox and Opera support parallel loading of scripts while
    preserving execution order. In other browsers, scripts will be
    queued and loaded one at a time to ensure correct execution order.

    @method js
    @param {String|Array} urls JS URL or array of JS URLs to load
    @param {Function} callback (optional) callback function to execute when
      the specified scripts are loaded
    @param {Object} obj (optional) object to pass to the callback function
    @param {Object} context (optional) if provided, the callback function
      will be executed in this object's context
    @static
    */ js(urls, callback, obj, context) {
        this.load('js', urls, callback, obj, context);
    }
}
function $6ba50b95af76efe0$export$93b33d367be6802b(urls, callback, obj, context) {
    $6ba50b95af76efe0$var$loader.js(urls, callback, obj, context);
}
function $6ba50b95af76efe0$export$5c4fe40904b85610(urls, callback, obj, context) {
    $6ba50b95af76efe0$var$loader.css(urls, callback, obj, context);
}
// this seems fragile but not sure how else to inject the document
// besides 
let $6ba50b95af76efe0$var$loader = new $6ba50b95af76efe0$var$Loader(document);



class $eed44470b9442f52$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        var self = this, url_vars;
        this.youtube_loaded = false;
        // Create Dom element
        this._el.content_item = this.domCreate("div", "tl-media-item tl-media-youtube tl-media-shadow", this._el.content);
        this._el.content_item.id = (0, $ea7d21fd242a7c44$export$b40aeedae59b59d1)(7);
        // URL Vars
        url_vars = (0, $ea7d21fd242a7c44$export$59a8f5abf382974d)(this.data.url);
        // Get Media ID
        this.media_id = {};
        if (this.data.url.match('v=')) this.media_id.id = url_vars["v"];
        else if (this.data.url.match('\/embed\/')) this.media_id.id = this.data.url.split("embed\/")[1].split(/[?&]/)[0];
        else if (this.data.url.match(/v\/|v=|youtu\.be\//)) this.media_id.id = this.data.url.split(/v\/|v=|youtu\.be\//)[1].split(/[?&]/)[0];
        else (0, $ea7d21fd242a7c44$export$357889f174732d38)("YOUTUBE IN URL BUT NOT A VALID VIDEO");
        // TODO: switch this to use parseYouTubeTime
        // Get start second
        if (this.data.url.match("start=")) this.media_id.start = (0, $ea7d21fd242a7c44$export$f0bed2e490a4f892)(this.data.url.split("start=")[1], 10);
        else if (this.data.url.match("t=")) this.media_id.start = (0, $ea7d21fd242a7c44$export$f0bed2e490a4f892)(this.data.url.split("t=")[1], 10);
        //Get end second
        if (this.data.url.match("end=")) this.media_id.end = (0, $ea7d21fd242a7c44$export$f0bed2e490a4f892)(this.data.url.split("end=")[1], 10);
        this.media_id.hd = Boolean(typeof url_vars["hd"] != 'undefined');
        // API Call
        (0, $6ba50b95af76efe0$export$93b33d367be6802b)('https://www.youtube.com/iframe_api', function() {
            self.createMedia();
        });
    }
    // Update Media Display
    _updateMediaDisplay() {
        //this.el.content_item = document.getElementById(this._el.content_item.id);
        this._el.content_item.style.height = (0, $ea7d21fd242a7c44$export$85f17f73487c6e7d).r16_9({
            w: this.options.width
        }) + "px";
        this._el.content_item.style.width = this.options.width + "px";
    }
    _stopMedia() {
        if (this.youtube_loaded) try {
            if (this.player.getPlayerState() == YT.PlayerState.PLAYING) this.player.pauseVideo();
        } catch (err) {
            (0, $ea7d21fd242a7c44$export$357889f174732d38)(err);
        }
    }
    createMedia() {
        var self = this;
        clearTimeout(this.timer);
        if (typeof YT != 'undefined' && typeof YT.Player != 'undefined') // Create Player
        this.player = new YT.Player(this._el.content_item.id, {
            playerVars: {
                enablejsapi: 1,
                color: 'white',
                controls: 1,
                start: this.media_id.start,
                end: this.media_id.end,
                fs: 1
            },
            videoId: this.media_id.id,
            events: {
                onReady: function() {
                    self.onPlayerReady();
                    // After Loaded
                    self.onLoaded();
                },
                'onStateChange': self.onStateChange
            }
        });
        else this.timer = setTimeout(function() {
            self.createMedia();
        }, 1000);
    }
    /*	Events
    ================================================== */ onPlayerReady(e) {
        this.youtube_loaded = true;
        this._el.content_item = document.getElementById(this._el.content_item.id);
        this.onMediaLoaded();
    }
    onStateChange(e) {
        if (e.data == YT.PlayerState.ENDED) {
            e.target.seekTo(0);
            e.target.pauseVideo();
        }
    }
}




class $cc0d53a2d9e0db0e$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    /*  Load the media
    ================================================== */ _loadMedia() {
        // Create Dom element
        this._el.content_item = this.domCreate("div", "tl-media-item tl-media-map tl-media-shadow", this._el.content);
        // Get Media ID
        this.media_id = this.data.url;
        // API Call
        this.mapframe = this.domCreate("iframe", "", this._el.content_item);
        this.mapframe.width = "100%";
        this.mapframe.height = "100%";
        this.mapframe.frameBorder = "0";
        this.mapframe.src = this.makeGoogleMapsEmbedURL(this.media_id, this.options.api_key_googlemaps);
        // After Loaded
        this.onLoaded();
    }
    _updateMediaDisplay() {
        if (this._state.loaded) {
            var dimensions = (0, $ea7d21fd242a7c44$export$85f17f73487c6e7d).square({
                w: this._el.content_item.offsetWidth
            });
            this._el.content_item.style.height = dimensions.h + "px";
        }
    }
    makeGoogleMapsEmbedURL(url, api_key) {
        // Test with https://docs.google.com/spreadsheets/d/1zCpvtRdftlR5fBPppmy_-SkGIo7RMwoPUiGFZDAXbTc/edit
        var Streetview = false;
        function determineMapMode(url) {
            function parseDisplayMode(display_mode, param_string) {
                // Set the zoom param
                if (display_mode.slice(-1) == "z") param_string["zoom"] = display_mode;
                else if (display_mode.slice(-1) == "m") {
                    // TODO: make this somehow interpret the correct zoom level
                    // until then fake it by using Google's default zoom level
                    param_string["zoom"] = 14;
                    param_string["maptype"] = "satellite";
                // Set all the fun streetview params
                } else if (display_mode.slice(-1) == "t") {
                    Streetview = true;
                    // streetview uses "location" instead of "center"
                    // "place" mode doesn't have the center param, so we may need to grab that now
                    if (mapmode == "place") var center = url.match(regexes["place"])[3] + "," + url.match(regexes["place"])[4];
                    else {
                        var center = param_string["center"];
                        delete param_string["center"];
                    }
                    // Clear out all the other params -- this is so hacky
                    param_string = {};
                    param_string["location"] = center;
                    streetview_params = display_mode.split(",");
                    for(let param in param_defs["streetview"]){
                        var i = parseInt(param) + 1;
                        if (param_defs["streetview"][param] == "pitch" && streetview_params[i] == "90t") // Although 90deg is the horizontal default in the URL, 0 is horizontal default for embed URL. WHY??
                        // https://developers.google.com/maps/documentation/javascript/streetview
                        param_string[param_defs["streetview"][param]] = 0;
                        else param_string[param_defs["streetview"][param]] = streetview_params[i].slice(0, -1);
                    }
                }
                return param_string;
            }
            function determineMapModeURL(mapmode, match) {
                var param_string = {};
                var url_root = match[1], display_mode = match[match.length - 1];
                for(let param in param_defs[mapmode]){
                    // skip first 2 matches, because they reflect the URL and not params
                    var i = parseInt(param) + 2;
                    if (param_defs[mapmode][param] == "center") param_string[param_defs[mapmode][param]] = match[i] + "," + match[++i];
                    else param_string[param_defs[mapmode][param]] = match[i];
                }
                param_string = parseDisplayMode(display_mode, param_string);
                param_string["key"] = api_key;
                if (Streetview == true) mapmode = "streetview";
                return url_root + "/embed/v1/" + mapmode + (0, $ea7d21fd242a7c44$export$27213b73b2075e98)(param_string);
            }
            let mapmode = "view";
            if (url.match(regexes["place"])) mapmode = "place";
            else if (url.match(regexes["directions"])) mapmode = "directions";
            else if (url.match(regexes["search"])) mapmode = "search";
            return determineMapModeURL(mapmode, url.match(regexes[mapmode]));
        }
        // These must be in the order they appear in the original URL
        // "key" param not included since it's not in the URL structure
        // Streetview "location" param not included since it's captured as "center"
        // Place "center" param ...um...
        var param_defs = {
            "view": [
                "center"
            ],
            "place": [
                "q",
                "center"
            ],
            "directions": [
                "origin",
                "destination",
                "center"
            ],
            "search": [
                "q",
                "center"
            ],
            "streetview": [
                "fov",
                "heading",
                "pitch"
            ]
        };
        // Set up regex parts to make updating these easier if Google changes them
        var root_url_regex = /(https:\/\/.+google.+?\/maps)/;
        var coords_regex = /@([-\d.]+),([-\d.]+)/;
        var address_regex = /([\w\W]+)/;
        // Data doesn't seem to get used for anything
        var data_regex = /data=[\S]*/;
        // Capture the parameters that determine what map tiles to use
        // In roadmap view, mode URLs include zoom paramater (e.g. "14z")
        // In satellite (or "earth") view, URLs include a distance parameter (e.g. "84511m")
        // In streetview, URLs include paramaters like "3a,75y,49.76h,90t" -- see http://stackoverflow.com/a/22988073
        var display_mode_regex = /,((?:[-\d.]+[zmayht],?)*)/;
        var regexes = {
            view: new RegExp(root_url_regex.source + "/" + coords_regex.source + display_mode_regex.source),
            place: new RegExp(root_url_regex.source + "/place/" + address_regex.source + "/" + coords_regex.source + display_mode_regex.source),
            directions: new RegExp(root_url_regex.source + "/dir/" + address_regex.source + "/" + address_regex.source + "/" + coords_regex.source + display_mode_regex.source),
            search: new RegExp(root_url_regex.source + "/search/" + address_regex.source + "/" + coords_regex.source + display_mode_regex.source)
        };
        return determineMapMode(url);
    }
}




class $a637e0615ccc2514$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    constructor(data, options, language){
        super(data, options, language);
        this.blockquote = (0, (/*@__PURE__*/$parcel$interopDefault($d349326c2b62c55f$exports))).sanitize(this.data.url);
    }
    _loadMedia() {
        // Create Dom element
        this._el.content_item = this.domCreate("div", "tl-media-item tl-media-blockquote", this._el.content);
        this._el.content_container.className = "tl-media-content-container tl-media-content-container-text";
        // API Call
        this._el.content_item.innerHTML = this.blockquote;
        // After Loaded
        this.onLoaded();
    }
    updateMediaDisplay() {
    // override DOM-oriented updates that don't apply to blockquotes	
    }
}





class $06766069d46c1311$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        var api_url, api_language, self = this;
        // Create Dom element
        this._el.content_item = this.domCreate("div", "tl-media-item tl-media-wikipedia", this._el.content);
        this._el.content_container.className = "tl-media-content-container tl-media-content-container-text";
        // Get Media ID
        this.media_id = this.data.url.split("wiki\/")[1].split("#")[0].replace("_", " ");
        this.media_id = this.media_id.replace(" ", "%20");
        api_language = this.data.url.split("//")[1].split(".wikipedia")[0];
        // API URL
        api_url = "https://" + api_language + ".wikipedia.org/w/api.php?action=query&prop=extracts|pageimages&redirects=&titles=" + this.media_id + "&exintro=1&format=json&callback=?";
        // API Call
        (0, $7f99b552874efbe4$export$e68fce4c5f453854)({
            type: 'GET',
            url: api_url,
            dataType: 'json',
            success: function(d) {
                self.createMedia(d);
            },
            error: function(xhr, type) {
                var error_text = "";
                error_text += self._("wikipedia_load_err") + "<br/>" + self.media_id + "<br/>" + type;
                self.loadErrorDisplay(error_text);
            }
        });
    }
    createMedia(d) {
        var wiki = "";
        if (d.query) {
            var content = "", wiki = {
                entry: {},
                title: "",
                text: "",
                extract: "",
                paragraphs: 1,
                page_image: "",
                text_array: []
            };
            wiki.entry = (0, $ea7d21fd242a7c44$export$124940dce15eb641)(d.query.pages, 0);
            wiki.extract = wiki.entry.extract;
            wiki.title = wiki.entry.title;
            wiki.page_image = wiki.entry.thumbnail;
            if (wiki.extract.match("<p>")) wiki.text_array = wiki.extract.split("<p>");
            else wiki.text_array.push(wiki.extract);
            for(var i = 0; i < wiki.text_array.length; i++)if (i + 1 <= wiki.paragraphs && i + 1 < wiki.text_array.length) wiki.text += "<p>" + wiki.text_array[i + 1];
            content += "<span class='tl-icon-wikipedia'></span>";
            content += "<div class='tl-wikipedia-title'><h4><a href='" + this.data.url + "' target='_blank' rel='noopener'>" + wiki.title + "</a></h4>";
            content += "<span class='tl-wikipedia-source'>" + this._('wikipedia') + "</span></div>";
            wiki.page_image;
            content += wiki.text;
            if (wiki.extract.match("REDIRECT")) ;
            else {
                // Add to DOM
                this._el.content_item.innerHTML = content;
                // After Loaded
                this.onLoaded();
            }
        }
    }
    updateMediaDisplay() {}
}






function $e4a34fa1a44bd737$export$2bd6139c98b9e90d(url) {
    if (url.match(/^.+#\/media\/.+/)) {
        let parts = url.split('#');
        let file_parts = parts[1].split(':') // the prefix is File in English but different on other language WPs
        ;
        return `File:${file_parts[1]}`;
    }
    if (url.match(/^.*commons.wikimedia.org\/wiki\/File:.+/)) {
        let parts = url.split('/');
        return parts[parts.length - 1];
    }
    return null;
}
function $e4a34fa1a44bd737$export$54ee641cfb79dfb2(j) {
    let response = {};
    if (j.query && j.query.pages) {
        let page_ids = Object.keys(j.query.pages);
        response['page_id'] = page_ids[0];
        let data = j.query.pages[response['page_id']];
        response['url'] = data.imageinfo[0].thumburl;
        if (data.entityterms && data.entityterms.label) response['label'] = data.entityterms.label[0];
    }
    return response;
}
class $e4a34fa1a44bd737$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        var api_url, image_width = Math.round(this.options.width) || 1000, language_code = this.getLanguage().lang.toLowerCase(), self = this;
        try {
            // Get Media ID
            this.establishMediaID();
            // API URL
            api_url = `https://commons.wikimedia.org/w/api.php?action=query&titles=${this.media_id}&prop=imageinfo|entityterms&iiprop=url&&iiurlwidth=${image_width}&format=json&origin=*&wbetlanguage=${language_code}`;
            // API Call
            (0, $7f99b552874efbe4$export$d047a7c56db64af4)(api_url, function(d) {
                let response = $e4a34fa1a44bd737$export$54ee641cfb79dfb2(d);
                if (response.url) {
                    self.base_image_url = response.url;
                    self.page_id = response.page_id;
                    if (!self.data.alt && response.label) self.data.alt = response.label;
                    if (!self.options.background) self.createMedia();
                    self.onLoaded();
                } else self.loadErrorDisplay(self._("wikipedia_image_load_err"));
            });
        } catch (e) {
            self.loadErrorDisplay(self._(e.message_key));
        }
    }
    /**
     * Analyze the URL provided in the data object passed to the constructor to extract
     * the Wikimedia commons "page" name
     */ establishMediaID() {
        let media_id = $e4a34fa1a44bd737$export$2bd6139c98b9e90d(this.data.url);
        if (media_id) this.media_id = media_id;
        else throw new (0, $07909642145031f1$export$2e2bcd8739ae039)(`Invalid Wikipedia Image URL`);
    }
    createMedia() {
        var self = this;
        // Photo
        this._el.content_item = this.domCreate("img", "tl-media-item tl-media-image tl-media-wikipedia-image tl-media-shadow", this._el.content);
        if (this.data.alt) this._el.content_item.alt = this.data.alt;
        else if (this.page_id) {
            let wikibase_id = `M${this.page_id}`;
            let wikibase_url = `https://commons.wikimedia.org/w/api.php?action=wbgetentities&format=json&ids=${wikibase_id}&format=json&origin=*`;
            (0, $7f99b552874efbe4$export$81bec6e38e8b706b)(wikibase_url).then((j)=>{
                if (j.entities && j.entities[wikibase_id]) {
                    let labels = j.entities[wikibase_id].labels;
                    let language_code = self.getLanguage().lang.toLowerCase();
                    let label = null;
                    if (labels[language_code]) label = labels[language_code];
                    else if (language_code.length > 2 && labels[language_code.substr(0, 2)]) label = labels[language_code.substr(0, 2)];
                    else if (labels['en']) label = labels['en'];
                    if (label) {
                        console.log(`wikibase_id: ${self.media_id} alt ${label.value}`);
                        self.data.alt = label.value;
                        self._el.content_item.alt = self.data.alt;
                    } else console.log(`wikibase_id: ${self.media_id} ain't got no alt`);
                }
            });
        }
        if (this.data.title) this._el.content_item.title = this.data.title;
        // Media Loaded Event
        this._el.content_item.addEventListener('load', function(e) {
            self.onMediaLoaded();
        });
        // Set Image Source
        this._el.content_item.src = this.getImageURL(this.options.width, this.options.height);
    }
    _getImageURL(w, h) {
        if (w && this.base_image_url) {
            let match = this.base_image_url.match(/(\/[\d\.]+px-)/);
            if (match) {
                w = Math.round(w) // WP image URLS 404 if floats are used so round it.
                ;
                return this.base_image_url.replace(match[1], `/${w}px-`) // Wikipedia will autoscale the image for us
                ;
            }
        }
        // they don't always have that pattern!
        return this.base_image_url;
    }
} /**
 * 
 * 
 * https://commons.wikimedia.org/w/api.php?action=query&titles=File:Beryl-Quartz-Emerald-Zambia-33mm_0885.jpg&prop=imageinfo&iiprop=url&&iiurlwidth=1000
 * https://commons.wikimedia.org/wiki/File:Beryl-Quartz-Emerald-Zambia-33mm_0885.jpg
 */ 





class $eca4ebb36f54acbc$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        var api_url, self1 = this;
        // Create Dom element
        this._el.content_item = this.domCreate("div", "tl-media-item tl-media-iframe tl-media-soundcloud tl-media-shadow", this._el.content);
        // Get Media ID
        this.media_id = this.data.url;
        // API URL
        api_url = "https://soundcloud.com/oembed?url=" + this.media_id + "&format=js&callback=?";
        // API Call
        (0, $7f99b552874efbe4$export$d047a7c56db64af4)(api_url, function(d) {
            (0, $6ba50b95af76efe0$export$93b33d367be6802b)("https://w.soundcloud.com/player/api.js", function() {
                self1.createMedia(d);
            });
        });
    }
    createMedia(d) {
        this._el.content_item.innerHTML = d.html;
        self.widget = SC.Widget(this._el.content_item.querySelector("iframe")); //create widget for api use
        this.soundCloudCreated = true;
        // After Loaded
        this.onLoaded();
    }
    _stopMedia() {
        if (this.soundCloudCreated) self.widget.pause();
    }
}




class $10c18a27debb0e04$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        var api_url, self = this;
        // Create Dom element
        this._el.content_item = this.domCreate("div", "tl-media-item tl-media-iframe tl-media-vimeo tl-media-shadow", this._el.content);
        // Get Media ID
        this.media_id = this.data.url.split(/video\/|\/\/vimeo\.com\//)[1].split(/[?&]/)[0];
        var start_time = null;
        // Get start time
        if (this.data.url.match(/#t=([^&]+).*/)) start_time = this.data.url.match(/#t=([^&]+).*/)[1];
        // API URL
        api_url = "https://player.vimeo.com/video/" + this.media_id + "?api=1&title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff";
        if (start_time) api_url = api_url += '&amp;#t=' + start_time;
        this.player = this.domCreate("iframe", "", this._el.content_item);
        // Media Loaded Event
        this.player.addEventListener('load', function(e) {
            self.onMediaLoaded();
        });
        this.player.width = "100%";
        this.player.height = "100%";
        this.player.frameBorder = "0";
        this.player.src = api_url;
        this.player.setAttribute('allowfullscreen', '');
        this.player.setAttribute('webkitallowfullscreen', '');
        this.player.setAttribute('mozallowfullscreen', '');
        // After Loaded
        this.onLoaded();
    }
    // Update Media Display
    _updateMediaDisplay() {
        this._el.content_item.style.height = (0, $ea7d21fd242a7c44$export$85f17f73487c6e7d).r16_9({
            w: this._el.content_item.offsetWidth
        }) + "px";
    }
    _stopMedia() {
        try {
            if (this.player && this.player.contentWindow) this.player.contentWindow.postMessage(JSON.stringify({
                method: "pause"
            }), "https://player.vimeo.com");
        } catch (err) {
            (0, $ea7d21fd242a7c44$export$357889f174732d38)(err);
        }
    }
}




class $2873cddfd2fa7baf$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        var api_url, self = this;
        // Create Dom element
        this._el.content_item = this.domCreate("div", "tl-media-item tl-media-iframe tl-media-dailymotion", this._el.content);
        // Get Media ID
        if (this.data.url.indexOf("dai.ly/") != -1) this.media_id = this.data.url.substr(this.data.url.indexOf("dai.ly/") + 7);
        else if (this.data.url.match("video")) this.media_id = this.data.url.split("video\/")[1].split(/[?&]/)[0];
        else this.media_id = this.data.url.split("embed\/")[1].split(/[?&]/)[0];
        // some URLs, at least old ones we have, include an underscore and a readable URL string 
        // which gets dropped in a rewrite, but which doesn't work in the embed URL
        if (this.media_id.indexOf('_') != -1) this.media_id = this.media_id.split('_')[0];
        // API URL
        api_url = "https://www.dailymotion.com/embed/video/" + this.media_id + "?api=postMessage";
        // API Call
        this._el.content_item.innerHTML = "<iframe autostart='false' frameborder='0' width='100%' height='100%' src='" + api_url + "'></iframe>";
        // After Loaded
        this.onLoaded();
    }
    // Update Media Display
    _updateMediaDisplay() {
        if (this._state.loaded) this._el.content_item.style.height = (0, $ea7d21fd242a7c44$export$85f17f73487c6e7d).r16_9({
            w: this._el.content_item.offsetWidth
        }) + "px";
    }
    _stopMedia() {
        if (this._state.loaded) this._el.content_item.querySelector("iframe").contentWindow.postMessage('{"command":"pause","parameters":[]}', "*");
    }
}




class $6a572899499aa99c$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        var api_url, self = this;
        // Create Dom element
        this._el.content_item = this.domCreate("div", "tl-media-item tl-media-iframe tl-media-vine tl-media-shadow", this._el.content);
        // Get Media ID
        this.media_id = this.data.url.split("vine.co/v/")[1];
        // API URL
        api_url = "https://vine.co/v/" + this.media_id + "/embed/simple";
        // API Call
        this._el.content_item.innerHTML = "<iframe frameborder='0' width='100%' height='100%' src='" + api_url + "'></iframe><script async src='https://platform.vine.co/static/scripts/embed.js' charset='utf-8'></script>";
        // After Loaded
        this.onLoaded();
    }
    // Update Media Display
    _updateMediaDisplay() {
        var size = (0, $ea7d21fd242a7c44$export$85f17f73487c6e7d).square({
            w: this._el.content_item.offsetWidth,
            h: this.options.height
        });
        this._el.content_item.style.height = size.h + "px";
    }
    _stopMedia() {
        this._el.content_item.querySelector("iframe").contentWindow.postMessage('pause', '*');
    }
}





class $42d51278de3b32f2$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        var api_url, self = this;
        // Create Dom element
        this._el.content_item = this.domCreate("div", "tl-media-twitter", this._el.content);
        this._el.content_container.className = "tl-media-content-container tl-media-content-container-text";
        // Get Media ID
        if (this.data.url.match("^(https?:)?\/*(www.)?(twitter|x)\.com")) {
            if (this.data.url.match("status\/")) this.media_id = this.data.url.split("status\/")[1];
            else if (this.data.url.match("statuses\/")) this.media_id = this.data.url.split("statuses\/")[1];
            else this.media_id = "";
        } else if (this.data.url.match("<blockquote class=['\"]twitter-tweet['\"]")) {
            var found = this.data.url.match(/(status|statuses)\/(\d+)/);
            if (found && found.length > 2) this.media_id = found[2];
            else {
                self.loadErrorDisplay(self._("twitterembed_invalidurl_err"));
                return;
            }
        }
        // API URL
        api_url = "https://api.twitter.com/1/statuses/oembed.json?id=" + this.media_id + "&omit_script=true&include_entities=true&callback=?";
        // API Call
        (0, $7f99b552874efbe4$export$e68fce4c5f453854)({
            type: 'GET',
            url: api_url,
            dataType: 'json',
            success: function(d) {
                self.createMedia(d);
            },
            error: function(xhr, type) {
                var error_text = "";
                error_text += self._("twitter_load_err") + "<br/>" + self.media_id + "<br/>" + type;
                self.loadErrorDisplay(error_text);
            }
        });
    }
    createMedia(d) {
        var tweet = "", tweet_text = "", tweetuser = "", tweet_status_temp = "", tweet_status_url = "", tweet_status_date = "", self = this;
        //	TWEET CONTENT
        tweet_text = d.html.split("<\/p>\&mdash;")[0] + "</p></blockquote>";
        tweetuser = d.author_url.split("twitter.com\/")[1];
        tweet_status_temp = d.html.split("<\/p>\&mdash;")[1].split("<a href=\"")[1];
        tweet_status_url = tweet_status_temp.split("\"\>")[0];
        tweet_status_date = tweet_status_temp.split("\"\>")[1].split("<\/a>")[0];
        // Open links in new window
        tweet_text = tweet_text.replace(/<a href/ig, '<a target="_blank" rel="noopener" href');
        if (tweet_text.includes("pic.twitter.com") || tweet_text.includes("pic.x.com")) {
            // platform.x.com gets redirected to platform.twitter.com as of 2024-12-13
            (0, $6ba50b95af76efe0$export$93b33d367be6802b)('https://platform.twitter.com/widgets.js', function() {
                twttr.widgets.createTweet(self.media_id, self._el.content_item, {
                    conversation: 'none',
                    linkColor: '#cc0000',
                    theme: 'light' // or dark
                });
            });
            this.onLoaded();
        } else {
            // 	TWEET CONTENT
            tweet += tweet_text;
            //	TWEET AUTHOR
            tweet += "<div class='vcard'>";
            tweet += "<a href='" + tweet_status_url + "' class='twitter-date' rel='noopener' target='_blank'>" + tweet_status_date + "</a>";
            tweet += "<img src='' class='tl-media-item tl-media-image'></a>";
            tweet += "<div class='author'>";
            tweet += "<a class='screen-name url' href='" + d.author_url + "' rel='noopener' target='_blank'>";
            tweet += "<span class='avatar'></span>";
            tweet += "<span class='fn'>" + d.author_name + " <span class='tl-icon-twitter'></span></span>";
            tweet += "<span class='nickname'>@" + tweetuser + "<span class='thumbnail-inline'></span></span>";
            tweet += "</a>";
            tweet += "</div>";
            tweet += "</div>";
            // Add to DOM
            this._el.content_item.innerHTML = tweet;
            // After Loaded
            this.onLoaded();
        }
    }
    updateMediaDisplay() {}
    _updateMediaDisplay() {}
}




class $43d642849780d65f$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        var api_url, self = this;
        // Create Dom element
        this._el.content_item = this.domCreate("div", "tl-media-twitter", this._el.content);
        this._el.content_container.className = "tl-media-content-container tl-media-content-container-text";
        // Get Media ID
        var found = this.data.url.match(/(status|statuses)\/(\d+)/);
        if (found && found.length > 2) this.media_id = found[2];
        else {
            self.loadErrorDisplay(self._("twitterembed_invalidurl_err"));
            return;
        }
        // API URL
        api_url = "https://api.twitter.com/1/statuses/oembed.json?id=" + this.media_id + "&omit_script=true&include_entities=true&callback=?";
        window.twttr = function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0], t = window.twttr || {};
            if (d.getElementById(id)) return t;
            js = d.createElement(s);
            js.id = id;
            js.src = "https://platform.twitter.com/widgets.js";
            fjs.parentNode.insertBefore(js, fjs);
            t._e = [];
            t.ready = function(f) {
                t._e.push(f);
            };
            return t;
        }(document, "script", "twitter-wjs");
        // API Call
        (0, $7f99b552874efbe4$export$e68fce4c5f453854)({
            type: 'GET',
            url: api_url,
            dataType: 'json',
            success (d) {
                self.createMedia(d);
            },
            error: function(xhr, type) {
                var error_text = "";
                error_text += self._("twitter_load_err") + "<br/>" + self.media_id + "<br/>" + type;
                self.loadErrorDisplay(error_text);
            }
        });
    }
    createMedia(d) {
        var tweet = "", tweet_text = "", tweetuser = "", tweet_status_temp = "", tweet_status_url = "", tweet_status_date = "";
        //	TWEET CONTENT
        tweet_text = d.html.split("<\/p>\&mdash;")[0] + "</p></blockquote>";
        tweetuser = d.author_url.split("twitter.com\/")[1];
        tweet_status_temp = d.html.split("<\/p>\&mdash;")[1].split("<a href=\"")[1];
        tweet_status_url = tweet_status_temp.split("\"\>")[0];
        tweet_status_date = tweet_status_temp.split("\"\>")[1].split("<\/a>")[0];
        // Open links in new window
        tweet_text = tweet_text.replace(/<a href/ig, '<a target="_blank" rel="noopener" href');
        let mediaID = this.media_id; // make visible in callback.
        if (tweet_text.includes("pic.twitter.com")) {
            twttr.ready(function(evt) {
                tweet = document.getElementsByClassName("tl-media-twitter")[0];
                var id = String(mediaID);
                twttr.widgets.createTweet(id, tweet, {
                    conversation: 'none',
                    linkColor: '#cc0000',
                    theme: 'light' // or dark
                }).then(function(evt) {
                    this.onLoaded();
                });
            });
            this._el.content_item.innerHTML = tweet;
            this.onLoaded();
        } else {
            // 	TWEET CONTENT
            tweet += tweet_text;
            //	TWEET AUTHOR
            tweet += "<div class='vcard'>";
            tweet += "<a href='" + tweet_status_url + "' class='twitter-date' rel='noopener' target='_blank'>" + tweet_status_date + "</a>";
            tweet += "<div class='author'>";
            tweet += "<a class='screen-name url' href='" + d.author_url + "' rel='noopener' target='_blank'>";
            tweet += "<span class='avatar'></span>";
            tweet += "<span class='fn'>" + d.author_name + " <span class='tl-icon-twitter'></span></span>";
            tweet += "<span class='nickname'>@" + tweetuser + "<span class='thumbnail-inline'></span></span>";
            tweet += "</a>";
            tweet += "</div>";
            tweet += "</div>";
            // Add to DOM
            this._el.content_item.innerHTML = tweet;
            // After Loaded
            this.onLoaded();
        }
    }
    updateMediaDisplay() {}
    _updateMediaDisplay() {}
}






class $ab04c5d13610e46f$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        var api_url, self = this;
        try {
            // Get Media ID
            this.establishMediaID();
            // API URL
            api_url = "https://api.flickr.com/services/rest/?method=flickr.photos.getSizes&api_key=" + this.options.api_key_flickr + "&photo_id=" + this.media_id + "&format=json&jsoncallback=?";
            // API Call
            (0, $7f99b552874efbe4$export$d047a7c56db64af4)(api_url, function(d) {
                if (d.stat == "ok") {
                    self.sizes = d.sizes.size; // store sizes info
                    if (!self.options.background) self.createMedia();
                    self.onLoaded();
                } else self.loadErrorDisplay(self._("flickr_notfound_err"));
            });
        } catch (e) {
            self.loadErrorDisplay(self._(e.message_key));
        }
    }
    establishMediaID() {
        if (this.data.url.match(/flic.kr\/.+/i)) {
            var encoded = this.data.url.split('/').slice(-1)[0];
            this.media_id = (0, $ea7d21fd242a7c44$export$61f53211c069eefb).decode(encoded);
        } else {
            var marker = 'flickr.com/photos/';
            var idx = this.data.url.indexOf(marker);
            if (idx == -1) throw new (0, $07909642145031f1$export$2e2bcd8739ae039)("flickr_invalidurl_err");
            var pos = idx + marker.length;
            this.media_id = this.data.url.substr(pos).split("/")[1];
        }
    }
    createMedia() {
        var self = this;
        // Link
        this._el.content_link = this.domCreate("a", "", this._el.content);
        this._el.content_link.href = this.data.url;
        this._el.content_link.target = "_blank";
        this._el.content_link.setAttribute('rel', 'noopener');
        // Photo
        this._el.content_item = this.domCreate("img", "tl-media-item tl-media-image tl-media-flickr tl-media-shadow", this._el.content_link);
        if (this.data.alt) this._el.content_item.alt = this.data.alt;
        else if (this.data.caption) this._el.content_item.alt = (0, $ea7d21fd242a7c44$export$db594ec12e4bdab1)(this.data.caption);
        if (this.data.title) this._el.content_item.title = this.data.title;
        else if (this.data.caption) this._el.content_item.title = (0, $ea7d21fd242a7c44$export$db594ec12e4bdab1)(this.data.caption);
        // Media Loaded Event
        this._el.content_item.addEventListener('load', function(e) {
            self.onMediaLoaded();
        });
        // Set Image Source
        this._el.content_item.src = this.getImageURL(this.options.width, this.options.height);
    }
    getImageURL(w, h) {
        var best_size = this.size_label(h), source = this.sizes[this.sizes.length - 2].source;
        for(var i = 0; i < this.sizes.length; i++)if (this.sizes[i].label == best_size) source = this.sizes[i].source;
        return source;
    }
    _getMeta() {
        var self = this, api_url;
        // API URL
        api_url = "https://api.flickr.com/services/rest/?method=flickr.photos.getInfo&api_key=" + this.options.api_key_flickr + "&photo_id=" + this.media_id + "&format=json&jsoncallback=?";
        // API Call
        (0, $7f99b552874efbe4$export$d047a7c56db64af4)(api_url, function(d) {
            self.data.credit_alternate = "<a href='" + self.data.url + "' target='_blank' rel='noopener'>" + d.photo.owner.realname + "</a>";
            self.data.caption_alternate = d.photo.title._content + " " + d.photo.description._content;
            self.updateMeta();
        });
    }
    size_label(s) {
        var _size = "";
        if (s <= 75) {
            if (s <= 0) _size = "Large";
            else _size = "Thumbnail";
        } else if (s <= 180) _size = "Small";
        else if (s <= 240) _size = "Small 320";
        else if (s <= 375) _size = "Medium";
        else if (s <= 480) _size = "Medium 640";
        else if (s <= 600) _size = "Large";
        else _size = "Large";
        return _size;
    }
}





class $dcc338041fb9c49b$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        var self = this;
        // Create Dom elements
        this._el.content_item = this.domCreate("div", "tl-media-item tl-media-documentcloud tl-media-shadow", this._el.content);
        this._el.content_item.id = (0, $ea7d21fd242a7c44$export$b40aeedae59b59d1)(7);
        // Check url
        if (this.data.url.match(/\.html$/)) this.data.url = this._transformURL(this.data.url);
        else if (!this.data.url.match(/.(json|js)$/)) (0, $ea7d21fd242a7c44$export$357889f174732d38)("DOCUMENT CLOUD IN URL BUT INVALID SUFFIX");
        // Load viewer API
        (0, $6ba50b95af76efe0$export$93b33d367be6802b)([
            'https://assets.documentcloud.org/viewer/loader.js',
            'https://assets.documentcloud.org/viewer/viewer.js'
        ], function() {
            self.createMedia();
        });
    }
    // Viewer API needs js, not html
    _transformURL(url) {
        return url.replace(/(.*)\.html$/, '$1.js');
    }
    // Update Media Display
    _updateMediaDisplay() {
        this._el.content_item.style.height = this.options.height + "px";
    //this._el.content_item.style.width = this.options.width + "px";
    }
    createMedia() {
        // DocumentCloud API call
        // DV is defined by the JS load in _loadMedia
        DV.load(this.data.url, {
            container: '#' + this._el.content_item.id,
            showSidebar: false
        });
        this.onLoaded();
    }
}





const $8198c80a2b264a31$var$CLIENT_TOKEN = '830b21071290df4f81a35c56abbea096';
const $8198c80a2b264a31$var$FB_APP_ID = '704270473831239';
const $8198c80a2b264a31$var$ACCESS_TOKEN = `${$8198c80a2b264a31$var$FB_APP_ID}|${$8198c80a2b264a31$var$CLIENT_TOKEN}`;
const $8198c80a2b264a31$var$API_URL_ROOT = `https://graph.facebook.com/v8.0/instagram_oembed?access_token=${$8198c80a2b264a31$var$ACCESS_TOKEN}&fields=html,thumbnail_url,author_name&url=`;
/**
 * Break out from AJAX call for clarity. Remember to .bind() a this value.
 * @param {XMLHttpResponse} resp 
 */ function $8198c80a2b264a31$var$successHandler(resp) {
    this.oembed_response = resp;
    // Link
    this._el.content_link = this.domCreate("a", "", this._el.content);
    this._el.content_link.href = this.data.url;
    this._el.content_link.target = "_blank";
    this._el.content_link.setAttribute('rel', 'noopener');
    // Photo
    this._el.content_item = this.domCreate("img", "tl-media-item tl-media-image tl-media-instagram tl-media-shadow", this._el.content_link);
    if (this.data.alt) this._el.content_item.alt = this.data.alt;
    else if (this.data.caption) this._el.content_item.alt = (0, $ea7d21fd242a7c44$export$db594ec12e4bdab1)(this.data.caption);
    if (this.data.title) this._el.content_item.title = this.data.title;
    else if (this.data.caption) this._el.content_item.title = (0, $ea7d21fd242a7c44$export$db594ec12e4bdab1)(this.data.caption);
    // Media Loaded Event
    this._el.content_item.addEventListener('load', (function(e) {
        this.onMediaLoaded();
    }).bind(this));
    this._el.content_item.src = resp.thumbnail_url;
    // After Loaded
    this.onLoaded();
}
/**
 * Break out from AJAX call for clarity. Remember to .bind() a this value.
 * @param {XMLHttpResponse} resp
 */ function $8198c80a2b264a31$var$errorHandler(resp) {
    let msg = `${resp.statusText} [${resp.status}]`;
    if (resp.status == 400) msg = this._('instagram_bad_request');
    this.loadErrorDisplay(msg);
}
class $8198c80a2b264a31$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        // Get Media ID
        this.media_id = this.data.url.split("\/p\/")[1].split("/")[0];
        if (!this.options.background) this.createMedia();
    }
    createMedia() {
        this.oembed_response = null;
        var self = this;
        let data_url = `${$8198c80a2b264a31$var$API_URL_ROOT}${this.data.url}`;
        try {
            (0, $7f99b552874efbe4$export$e68fce4c5f453854)({
                url: data_url,
                dataType: 'json',
                success: $8198c80a2b264a31$var$successHandler,
                error: $8198c80a2b264a31$var$errorHandler,
                context: this
            });
        } catch (e) {
            console.log(`Instagram: error fetching ${data_url}`);
            console.log(e);
            debugger;
        }
    }
    getImageURL() {
        if (this.oembed_response && this.oembed_response.thumbnail_url) return this.oembed_response.thumbnail_url;
        (0, $7f99b552874efbe4$export$81bec6e38e8b706b)(`${$8198c80a2b264a31$var$API_URL_ROOT}${this.data.url}`).then((json)=>{
            return json.thumbnail_url;
        }).catch((err)=>{
            (0, $ea7d21fd242a7c44$export$357889f174732d38)(`Instagram getImageURL Error: ${err.status} ${err.statusText}`);
        });
    }
    _getMeta() {
        if (this.oembed_response && this.oembed_response.author_name) this.data.credit_alternate = `Instagram: <a href="https://instagram.com/${this.oembed_response.author_name}" target="_blank">@${this.oembed_response.author_name}</a>`;
        // nothing in our data helps us provide an alternative caption...
        // this.data.caption_alternate = d.title;
        this.updateMeta();
    }
    sizes(s) {
        var _size = "";
        if (s <= 150) _size = "t";
        else if (s <= 306) _size = "m";
        else _size = "l";
        return _size;
    }
}




class $a9a2fe7640d7d66e$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        this._el.content_item = this.domCreate("img", "tl-media-item tl-media-image tl-media-profile tl-media-shadow", this._el.content);
        this._el.content_item.src = this.data.url;
        this.onLoaded();
    }
    _updateMediaDisplay(layout) {
        if ($e8c72613a0980cab$export$bbe03eaf052676c9) this._el.content_item.style.maxWidth = this.options.width / 2 - 40 + "px";
    }
}



class $ffed295b96137f28$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    /*	Load the media
    ================================================== */ _loadMedia() {
        var url, self = this;
        // Create Dom element
        this._el.content_item = this.domCreate("div", "tl-media-item tl-media-iframe", this._el.content);
        // Get Media ID
        if (this.data.url.match(/open\?id=([^&]+)/)) {
            var doc_id = this.data.url.match(/open\?id=([^&]+)/)[1];
            url = 'https://drive.google.com/file/d/' + doc_id + '/preview';
        } else if (this.data.url.match(/file\/d\/([^/]*)\/?/)) {
            var doc_id = this.data.url.match(/file\/d\/([^/]*)\/?/)[1];
            url = 'https://drive.google.com/file/d/' + doc_id + '/preview';
        } else url = this.data.url;
        // this URL makes something suitable for an img src but what if it's not an image?
        // api_url = "http://www.googledrive.com/host/" + this.media_id + "/";
        this._el.content_item.innerHTML = "<iframe class='doc' frameborder='0' width='100%' height='100%' src='" + url + "'></iframe>";
        // After Loaded
        this.onLoaded();
    }
    // Update Media Display
    _updateMediaDisplay() {
        this._el.content_item.style.height = this.options.height + "px";
    }
}





function $b664abc3cd68150a$export$2bd6139c98b9e90d(url) {
    var media_id = null;
    if (url.match(/^spotify:/)) return url; // trust all Spotify URIs will be embeddable
    url = new URL(url);
    // again, we're kind of trusting here, but especially that the embed service will reject wrong cases.
    let path = url.pathname.replace(/\/$/, '') // strip trailing slash if there is one
    ;
    return `spotify${path.replace(/\//g, ':')}`;
}
class $b664abc3cd68150a$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        var api_url;
        // Create Dom element
        this._el.content_item = this.domCreate("div", "tl-media-item tl-media-iframe tl-media-spotify", this._el.content);
        this.media_id = $b664abc3cd68150a$export$2bd6139c98b9e90d(this.data.url);
        if (this.media_id) {
            // API URL
            api_url = "https://embed.spotify.com/?uri=" + this.media_id + "&theme=white&view=coverart";
            this.player = this.domCreate("iframe", "tl-media-shadow", this._el.content_item);
            this.player.width = "100%";
            this.player.height = "100%";
            this.player.frameBorder = "0";
            this.player.src = api_url;
            // After Loaded
            this.onLoaded();
        } else this.loadErrorDisplay(this._('spotify_invalid_url'));
    }
    // Update Media Display
    _updateMediaDisplay(l) {
        var _height = this.options.height, _player_height = 0, _player_width = 0;
        if ($e8c72613a0980cab$export$1c4e7a9c31a6c071) _height = this.options.height / 2;
        else _height = this.options.height - this.options.credit_height - this.options.caption_height - 30;
        this._el.content_item.style.maxHeight = "none";
        (0, $ea7d21fd242a7c44$export$357889f174732d38)(_height);
        (0, $ea7d21fd242a7c44$export$357889f174732d38)(this.options.width);
        if (_height > this.options.width) {
            (0, $ea7d21fd242a7c44$export$357889f174732d38)("height is greater");
            _player_height = this.options.width + 80 + "px";
            _player_width = this.options.width + "px";
        } else {
            (0, $ea7d21fd242a7c44$export$357889f174732d38)("width is greater");
            (0, $ea7d21fd242a7c44$export$357889f174732d38)(this.options.width);
            _player_height = _height + "px";
            _player_width = _height - 80 + "px";
        }
        this.player.style.width = _player_width;
        this.player.style.height = _player_height;
        if (this._el.credit) this._el.credit.style.width = _player_width;
        if (this._el.caption) this._el.caption.style.width = _player_width;
    }
    _stopMedia() {
    // Need spotify stop code
    }
}




class $ecd6bd5a4a49d553$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    constructor(data, options, language){
        super(data, options, language);
        this.iframe = (0, (/*@__PURE__*/$parcel$interopDefault($d349326c2b62c55f$exports))).sanitize(this.data.url, {
            ADD_TAGS: [
                'iframe'
            ],
            ADD_ATTR: [
                'frameborder'
            ]
        });
    }
    _loadMedia() {
        // Create Dom element
        this._el.content_item = this.domCreate("div", "tl-media-item tl-media-iframe", this._el.content);
        // API Call
        this._el.content_item.innerHTML = this.iframe;
        // After Loaded
        this.onLoaded();
    }
    // Update Media Display
    _updateMediaDisplay() {
        this._el.content_item.style.height = this.options.height + "px";
    }
}







class $d175baa4c5892ac8$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        try {
            var self = this;
            if (this.data.url.match("<blockquote class=['\"]imgur-embed-pub['\"]")) {
                var found = this.data.url.match(/(imgur\.com)\/(\w+)/);
                this.media_id = found[2];
                this.data.url = "http://imgur.com/gallery/" + this.media_id;
            } else if (this.data.url) this.media_id = this.data.url.split('/').slice(-1)[0];
            (0, $6ba50b95af76efe0$export$93b33d367be6802b)([
                'https://s.imgur.com/min/embed.js'
            ], function() {
                self.createMedia();
            });
        } catch (e) {
            this.loadErrorDisplay(this._("imgur_invalidurl_err"));
        }
    }
    createMedia() {
        var self = this;
        var api_url = "https://api.imgur.com/oembed.json?url=" + this.data.url;
        // Content div
        this._el.content_item = this.domCreate("div", "tl-media-item tl-media-image tl-media-imgur", this._el.content);
        // API Call
        (0, $7f99b552874efbe4$export$e68fce4c5f453854)({
            type: 'GET',
            url: api_url,
            dataType: 'json',
            success: function(data) {
                try {
                    self._el.content_item.innerHTML = data.html;
                    setInterval(function() {
                        if (document.querySelector("blockquote.imgur-embed-pub") == null) clearInterval();
                        else {
                            imgurEmbed.createIframe();
                            document.getElementById("imageElement").removeAttribute("style");
                            document.getElementById("image").removeAttribute("style");
                        }
                    }, 2000);
                } catch (e) {
                    (0, $ea7d21fd242a7c44$export$357889f174732d38)("Error processing imgur ajax response", e);
                }
            },
            error: function(xhr, errorType, error) {
                if (errorType == 'parsererror') self.loadErrorDisplay(self._("imgur_invalidurl_err"));
                else self.loadErrorDisplay(self._("unknown_read_err", errorType));
            }
        });
        this.onLoaded();
    }
    _updateMediaDisplay() {
        //this.el.content_item = document.getElementById(this._el.content_item.id);
        this._el.content_item.style.width = this.options.width + "px";
        this._el.content_item.style.height = (0, $ea7d21fd242a7c44$export$85f17f73487c6e7d).r16_9({
            w: this.options.width
        }) + "px";
    }
}





class $5b44ba70390b5f92$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        var url = (0, $ea7d21fd242a7c44$export$5ca970047f7e3018)(this.data.url), self = this;
        // Create Dom element
        this._el.content_item = this.domCreate("div", "tl-media-item tl-media-iframe", this._el.content);
        var markup = "";
        // not assigning media_id attribute. Seems like a holdover which is no longer used.
        if ($e8c72613a0980cab$export$bd1b734a238eb944 || $e8c72613a0980cab$export$7adf1fd9692ce935 || url.match(/dl.dropboxusercontent.com/)) markup = "<iframe class='doc' frameborder='0' width='100%' height='100%' src='//docs.google.com/viewer?url=" + url + "&amp;embedded=true'></iframe>";
        else markup = "<iframe class='doc' frameborder='0' width='100%' height='100%' src='" + url + "'></iframe>";
        this._el.content_item.innerHTML = markup;
        this.onLoaded();
    }
    // Update Media Display
    _updateMediaDisplay() {
        this._el.content_item.style.height = this.options.height + "px";
    }
}





class $7813a63ccabc84d6$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        // Loading Message
        this.loadingMessage();
        // Create media?
        if (!this.options.background) this.createMedia();
        // After loaded
        this.onLoaded();
    }
    createMedia() {
        //Transform URL for Dropbox
        var url = (0, $ea7d21fd242a7c44$export$5ca970047f7e3018)(this.data.url), self = this;
        var self = this, audio_class = "tl-media-item tl-media-audio tl-media-shadow";
        this._el.content_item = this.domCreate("audio", audio_class, this._el.content);
        this._el.content_item.controls = true;
        this._el.source_item = this.domCreate("source", "", this._el.content_item);
        // Media Loaded Event
        this._el.content_item.addEventListener('load', function(e) {
            self.onMediaLoaded();
        });
        this._el.source_item.src = url;
        this._el.source_item.type = this._getType(this.data.url, this.data.mediatype.match_str);
        this._el.content_item.innerHTML += "Your browser doesn't support HTML5 audio with " + this._el.source_item.type;
        this.player_element = this._el.content_item;
    }
    _updateMediaDisplay(layout) {
        if ($e8c72613a0980cab$export$bbe03eaf052676c9) this._el.content_item.style.width = "auto";
    }
    _stopMedia() {
        if (this.player_element) this.player_element.pause();
    }
    _getType(url, reg) {
        var ext = url.match(reg);
        var type = "audio/";
        switch(ext[1]){
            case "mp3":
                type += "mpeg";
                break;
            case "wav":
                type += "wav";
                break;
            case "m4a":
                type += "mp4";
                break;
            default:
                type = "audio";
                break;
        }
        return type;
    }
}





class $daab5ff026a2fd35$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        // Loading Message
        this.loadingMessage();
        // Create media?
        if (!this.options.background) this.createMedia();
        // After loaded
        this.onLoaded();
    }
    createMedia() {
        //Transform URL for Dropbox
        var url = (0, $ea7d21fd242a7c44$export$5ca970047f7e3018)(this.data.url), self = this;
        var self = this, video_class = "tl-media-item tl-media-video tl-media-shadow";
        // Link
        this._el.content_item = this.domCreate("video", video_class, this._el.content);
        this._el.content_item.controls = true;
        this._el.source_item = this.domCreate("source", "", this._el.content_item);
        // Media Loaded Event
        this._el.content_item.addEventListener('load', function(e) {
            self.onMediaLoaded();
        });
        this._el.source_item.src = url;
        this._el.source_item.type = this._getType(this.data.url, this.data.mediatype.match_str);
        this._el.content_item.innerHTML += "Your browser doesn't support HTML5 video with " + this._el.source_item.type;
        this.player_element = this._el.content_item;
    }
    _updateMediaDisplay(layout) {
        if ($e8c72613a0980cab$export$bbe03eaf052676c9) this._el.content_item.style.width = "auto";
    }
    _stopMedia() {
        if (this.player_element) this.player_element.pause();
    }
    _getType(url, reg) {
        var ext = url.match(reg);
        var type = "video/";
        switch(ext[1]){
            case "mp4":
                type += "mp4";
                break;
            case "webm":
                type += "webm";
                break;
            default:
                type = "video";
                break;
        }
        return type;
    }
}




class $7eb87333b287323e$export$2e2bcd8739ae039 extends (0, $b9944b7f97982afb$export$7fc53215244aec38) {
    _loadMedia() {
        var api_url, self = this;
        // Create Dom element
        this._el.content_item = this.domCreate("div", "tl-media-item tl-media-iframe tl-media-wistia tl-media-shadow", this._el.content);
        // Get Media ID
        this.media_id = this.data.url.split(/https?:\/\/(.+)?(wistia\.com|wi\.st)\/medias\/(.*)/)[3];
        (0, $ea7d21fd242a7c44$export$357889f174732d38)(`Wistia: media_id: ${this.media_id}`);
        // API URL
        api_url = "https://fast.wistia.com/embed/iframe/" + this.media_id + "?version=v1&controlsVisibleOnLoad=true&playerColor=aae3d8";
        this.player = this.domCreate("iframe", "", this._el.content_item);
        // Media Loaded Event
        this.player.addEventListener('load', function(e) {
            self.onMediaLoaded();
        });
        this.player.width = "100%";
        this.player.height = "100%";
        this.player.frameBorder = "0";
        this.player.src = api_url;
        this.player.setAttribute('allowfullscreen', '');
        this.player.setAttribute('webkitallowfullscreen', '');
        this.player.setAttribute('mozallowfullscreen', '');
        // After Loaded
        this.onLoaded();
    }
    // Update Media Display
    _updateMediaDisplay() {
        this._el.content_item.style.height = (0, $ea7d21fd242a7c44$export$85f17f73487c6e7d).r16_9({
            w: this._el.content_item.offsetWidth
        }) + "px";
    }
    _stopMedia() {
        try {
            this.player.contentWindow.postMessage(JSON.stringify({
                method: "pause"
            }), "https://player.vimeo.com");
        } catch (err) {
            (0, $ea7d21fd242a7c44$export$357889f174732d38)(err);
        }
    }
}


function $9122c61f73d8eb13$export$46c3b8b96b580bf5(m, image_only) {
    var media = {}, media_types = [
        {
            type: "youtube",
            name: "YouTube",
            match_str: "^(https?:)?\/*(www.|m.)?youtube|youtu\.be",
            cls: (0, $eed44470b9442f52$export$2e2bcd8739ae039)
        },
        {
            type: "vimeo",
            name: "Vimeo",
            match_str: "^(https?:)?\/*(player.)?vimeo\.com",
            cls: (0, $10c18a27debb0e04$export$2e2bcd8739ae039)
        },
        {
            type: "dailymotion",
            name: "DailyMotion",
            match_str: "^(https?:)?\/*(www.)?(dailymotion\.com|dai.ly)",
            cls: (0, $2873cddfd2fa7baf$export$2e2bcd8739ae039)
        },
        {
            type: "vine",
            name: "Vine",
            match_str: "^(https?:)?\/*(www.)?vine\.co",
            cls: (0, $6a572899499aa99c$export$2e2bcd8739ae039)
        },
        {
            type: "soundcloud",
            name: "SoundCloud",
            match_str: "^(https?:)?\/*(player.)?soundcloud\.com",
            cls: (0, $eca4ebb36f54acbc$export$2e2bcd8739ae039)
        },
        {
            type: "twitter",
            name: "Twitter",
            match_str: "^(https?:)?\/*(www.)?(twitter|x)\.com",
            cls: (0, $42d51278de3b32f2$export$2e2bcd8739ae039)
        },
        {
            type: "twitterembed",
            name: "TwitterEmbed",
            match_str: "<blockquote class=['\"]twitter-tweet['\"]",
            cls: (0, $43d642849780d65f$export$2e2bcd8739ae039)
        },
        {
            type: "googlemaps",
            name: "Google Map",
            match_str: /google.+?\/maps\/@([-\d.]+),([-\d.]+),((?:[-\d.]+[zmayht],?)*)|google.+?\/maps\/search\/([\w\W]+)\/@([-\d.]+),([-\d.]+),((?:[-\d.]+[zmayht],?)*)|google.+?\/maps\/place\/([\w\W]+)\/@([-\d.]+),([-\d.]+),((?:[-\d.]+[zmayht],?)*)|google.+?\/maps\/dir\/([\w\W]+)\/([\w\W]+)\/@([-\d.]+),([-\d.]+),((?:[-\d.]+[zmayht],?)*)/,
            cls: (0, $cc0d53a2d9e0db0e$export$2e2bcd8739ae039)
        },
        {
            type: "flickr",
            name: "Flickr",
            match_str: "^(https?:)?\/*(www.)?flickr.com\/photos",
            cls: (0, $ab04c5d13610e46f$export$2e2bcd8739ae039)
        },
        {
            type: "flickr",
            name: "Flickr",
            match_str: "^(https?:\/\/)?flic.kr\/.*",
            cls: (0, $ab04c5d13610e46f$export$2e2bcd8739ae039)
        },
        {
            type: "instagram",
            name: "Instagram",
            match_str: /^(https?:)?\/*(www.)?(instagr.am|^(https?:)?\/*(www.)?instagram.com)\/p\//,
            cls: (0, $8198c80a2b264a31$export$2e2bcd8739ae039)
        },
        {
            type: "profile",
            name: "Profile",
            match_str: /^(https?:)?\/*(www.)?instagr.am\/[a-zA-Z0-9]{2,}|^(https?:)?\/*(www.)?instagram.com\/[a-zA-Z0-9]{2,}/,
            cls: (0, $a9a2fe7640d7d66e$export$2e2bcd8739ae039)
        },
        {
            type: "documentcloud",
            name: "Document Cloud",
            match_str: /documentcloud.org\//,
            cls: (0, $dcc338041fb9c49b$export$2e2bcd8739ae039)
        },
        {
            type: "wikipedia-image",
            name: "WikipediaImage",
            match_str: "^https:\/\/.+\.wiki[mp]edia\.org.+#/media/.+\.(jpg|jpeg|png|gif|svg|webp)",
            cls: (0, $e4a34fa1a44bd737$export$2e2bcd8739ae039)
        },
        {
            type: "wikipedia-image",
            name: "WikipediaImage",
            match_str: "^https:\/\/commons.wikimedia.org/wiki/File:.+\.(jpg|jpeg|png|gif|svg|webp)",
            cls: (0, $e4a34fa1a44bd737$export$2e2bcd8739ae039)
        },
        {
            type: "wikipedia",
            name: "Wikipedia",
            match_str: "^(https?:)?\/.+.wikipedia\.org",
            cls: (0, $06766069d46c1311$export$2e2bcd8739ae039)
        },
        {
            type: "image",
            name: "Image",
            match_str: /(jpg|jpeg|png|gif|svg|webp)(\?.*)?$/i,
            cls: (0, $dc938f6728847e27$export$2e2bcd8739ae039)
        },
        {
            type: "imgur",
            name: "Imgur",
            match_str: /^.*imgur.com\/.+$|<blockquote class=['\"]imgur-embed-pub['\"]/i,
            cls: (0, $d175baa4c5892ac8$export$2e2bcd8739ae039)
        },
        {
            type: "googledocs",
            name: "Google Doc",
            match_str: "^(https?:)?\/*[^.]*.google.com\/[^\/]*\/d\/[^\/]*\/[^\/]*\?usp=shar.*|^(https?:)?\/*drive.google.com\/open\?id=[^\&]*\&authuser=0|^(https?:)?\/\/*drive.google.com\/open\\?id=[^\&]*|^(https?:)?\/*[^.]*.googledrive.com\/host\/[^\/]*\/",
            cls: (0, $ffed295b96137f28$export$2e2bcd8739ae039)
        },
        {
            type: "pdf",
            name: "PDF",
            match_str: /^.*\.pdf(\?.*)?(\#.*)?/,
            cls: (0, $5b44ba70390b5f92$export$2e2bcd8739ae039)
        },
        {
            type: "spotify",
            name: "spotify",
            match_str: "spotify",
            cls: (0, $b664abc3cd68150a$export$2e2bcd8739ae039)
        },
        {
            type: "iframe",
            name: "iFrame",
            match_str: "iframe",
            cls: (0, $ecd6bd5a4a49d553$export$2e2bcd8739ae039)
        },
        {
            type: "blockquote",
            name: "Quote",
            match_str: "blockquote",
            cls: (0, $a637e0615ccc2514$export$2e2bcd8739ae039)
        },
        {
            type: "video",
            name: "Video",
            match_str: /(mp4|webm)(\?.*)?$/i,
            cls: (0, $daab5ff026a2fd35$export$2e2bcd8739ae039)
        },
        {
            type: "wistia",
            name: "Wistia",
            match_str: /https?:\/\/(.+)?(wistia\.com|wi\.st)\/.*/i,
            cls: (0, $7eb87333b287323e$export$2e2bcd8739ae039)
        },
        {
            type: "audio",
            name: "Audio",
            match_str: /(mp3|wav|m4a)(\?.*)?$/i,
            cls: (0, $7813a63ccabc84d6$export$2e2bcd8739ae039)
        },
        {
            type: "imageblank",
            name: "Imageblank",
            match_str: "",
            cls: (0, $dc938f6728847e27$export$2e2bcd8739ae039)
        }
    ];
    if (image_only) {
        if (m instanceof Array) return false;
        for(var i = 0; i < media_types.length; i++)switch(media_types[i].type){
            case "flickr":
            case "image":
            case "instagram":
                if (m.url.match(media_types[i].match_str)) {
                    media = media_types[i];
                    return media;
                }
                break;
            default:
                break;
        }
    } else for(var i = 0; i < media_types.length; i++){
        if (m.url.match(media_types[i].match_str)) return media_types[i];
    }
    return false;
}



class $d7b4443306f8c446$export$db846fe170990ef7 {
    constructor(data, options){
        // DOM Elements
        this._el = {
            container: {},
            content_container: {},
            media_container: {},
            timespan: {},
            line_left: {},
            line_right: {},
            content: {},
            text: {},
            media: {}
        };
        // Components
        this._text = {};
        // State
        this._state = {
            loaded: false
        };
        // Data
        this.data = {
            unique_id: "",
            background: null,
            date: {
                year: 0,
                month: 0,
                day: 0,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                thumbnail: "",
                format: ""
            },
            text: {
                headline: "",
                text: ""
            },
            media: null
        };
        // Options
        this.options = {
            duration: 1000,
            ease: (0, $2baebbd96bfe7e6e$export$f7d97b709d0a6c59),
            width: 600,
            height: 600,
            marker_width_min: 100 // Minimum Marker Width
        };
        // Actively Displaying
        this.active = false;
        // Animation Object
        this.animator = {};
        // End date
        this.has_end_date = false;
        // Alternative text
        this.ariaLabel = '';
        // Merge Data and Options
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.options, options);
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.data, data);
        this._initLayout();
        this._initEvents();
    }
    /*	Adding, Hiding, Showing etc
	================================================== */ show() {}
    hide() {}
    setActive(is_active) {
        this.active = is_active;
        if (this.active && this.has_end_date) this._el.container.className = 'tl-timemarker tl-timemarker-with-end tl-timemarker-active';
        else if (this.active) this._el.container.className = 'tl-timemarker tl-timemarker-active';
        else if (this.has_end_date) this._el.container.className = 'tl-timemarker tl-timemarker-with-end';
        else this._el.container.className = 'tl-timemarker';
        this._el.container.ariaLabel = this.ariaLabel;
        if (this.active) this._el.container.ariaLabel += ', shown';
        else this._el.container.ariaLabel += ', press space to show';
    }
    setFocus(options = {
        preventScroll: true
    }) {
        this._el.container.focus(options);
    }
    addTo(container) {
        container.appendChild(this._el.container);
    }
    removeFrom(container) {
        container.removeChild(this._el.container);
    }
    updateDisplay(w, h) {
        this._updateDisplay(w, h);
    }
    loadMedia() {
        if (this._media && !this._state.loaded) {
            this._media.loadMedia();
            this._state.loaded = true;
        }
    }
    stopMedia() {
        if (this._media && this._state.loaded) this._media.stopMedia();
    }
    getLeft() {
        return this._el.container.style.left.slice(0, -2);
    }
    getTime() {
        return this.data.start_date.getTime();
    }
    getEndTime() {
        if (this.data.end_date) return this.data.end_date.getTime();
        else return false;
    }
    setHeight(h) {
        var text_line_height = 12, text_lines = 1;
        this._el.content_container.style.height = h + "px";
        this._el.timespan_content.style.height = h + "px";
        // Handle Line height for better display of text
        if (h <= 30) this._el.content.className = "tl-timemarker-content tl-timemarker-content-small";
        else this._el.content.className = "tl-timemarker-content";
        if (h <= 56) this._el.content_container.classList.add("tl-timemarker-content-container-small");
        else this._el.content_container.classList.remove("tl-timemarker-content-container-small");
        // Handle number of lines visible vertically
        if (0, $e8c72613a0980cab$export$db07bc05b2fb9b73) {
            text_lines = Math.floor(h / (text_line_height + 2));
            if (text_lines < 1) text_lines = 1;
            this._text.className = "tl-headline";
            this._text.style.webkitLineClamp = text_lines;
        } else {
            text_lines = h / text_line_height;
            if (text_lines > 1) this._text.className = "tl-headline tl-headline-fadeout";
            else this._text.className = "tl-headline";
            this._text.style.height = text_lines * text_line_height + "px";
        }
    }
    setWidth(w) {
        if (this.data.end_date) {
            this._el.container.style.width = w + "px";
            if (w > this.options.marker_width_min) {
                this._el.content_container.style.width = w + "px";
                this._el.content_container.className = "tl-timemarker-content-container tl-timemarker-content-container-long";
            } else {
                this._el.content_container.style.width = this.options.marker_width_min + "px";
                this._el.content_container.className = "tl-timemarker-content-container";
            }
        }
    }
    setClass(n) {
        this._el.container.className = n;
    }
    setRowPosition(n, remainder) {
        this.setPosition({
            top: n
        });
        this._el.timespan.style.height = remainder + "px";
    }
    getFormattedDate() {
        if ((0, $ea7d21fd242a7c44$export$87c2784dc9fc4ab)(this.data.display_date).length > 0) return this.data.display_date;
        let date_text = "";
        if (this.data.end_date) date_text = " to " + this.data.end_date.getDisplayDate(this.getLanguage());
        if (this.data.start_date) date_text = (date_text ? "from " : "") + this.data.start_date.getDisplayDate(this.getLanguage()) + date_text;
        return date_text;
    }
    /*	Events
	================================================== */ _onMarkerClick(e) {
        this.fire("markerclick", {
            unique_id: this.data.unique_id
        });
    }
    _onMarkerKeydown(e) {
        if (/Space|Enter/.test(e.code)) this.fire("markerclick", {
            unique_id: this.data.unique_id
        });
    }
    _onMarkerBlur(e) {
        this.fire("markerblur", {
            unique_id: this.data.unique_id
        });
    }
    /*	Private Methods
	================================================== */ _initLayout() {
        // Create Layout
        this._el.container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timemarker");
        this._el.container.setAttribute('tabindex', '-1');
        if (this.data.unique_id) this._el.container.id = this.data.unique_id + "-marker";
        if (this.data.end_date) {
            this.has_end_date = true;
            this._el.container.className = 'tl-timemarker tl-timemarker-with-end';
        }
        this._el.timespan = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timemarker-timespan", this._el.container);
        this._el.timespan_content = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timemarker-timespan-content", this._el.timespan);
        this._el.content_container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timemarker-content-container", this._el.container);
        this._el.content = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timemarker-content", this._el.content_container);
        this._el.line_left = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timemarker-line-left", this._el.timespan);
        this._el.line_right = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timemarker-line-right", this._el.timespan);
        // Thumbnail or Icon
        if (this.data.media) {
            this._el.media_container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timemarker-media-container", this._el.content);
            // ugh. needs an overhaul
            var mtd = {
                url: this.data.media.thumbnail
            };
            var thumbnail_media_type = this.data.media.thumbnail ? (0, $9122c61f73d8eb13$export$46c3b8b96b580bf5)(mtd, true) : null;
            if (thumbnail_media_type) {
                var thumbnail_media = new thumbnail_media_type.cls(mtd);
                thumbnail_media.on("loaded", (function() {
                    this._el.media = $9eb7ee258fcc7829$export$185802fd694ee1f5("img", "tl-timemarker-media", this._el.media_container);
                    this._el.media.src = thumbnail_media.getImageURL();
                }).bind(this));
                thumbnail_media.loadMedia();
            } else {
                var media_type = (0, $9122c61f73d8eb13$export$46c3b8b96b580bf5)(this.data.media).type;
                this._el.media = $9eb7ee258fcc7829$export$185802fd694ee1f5("span", "tl-icon-" + media_type, this._el.media_container);
            }
        }
        // Text
        this._el.text = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-timemarker-text", this._el.content);
        this._text = $9eb7ee258fcc7829$export$185802fd694ee1f5("h2", "tl-headline", this._el.text);
        if (this.data.text.headline && this.data.text.headline != "") this._text.innerHTML = (0, $ea7d21fd242a7c44$export$8c140248b4280ca1)(this.data.text.headline);
        else if (this.data.text.text && this.data.text.text != "") this._text.innerHTML = (0, $ea7d21fd242a7c44$export$8c140248b4280ca1)(this.data.text.text);
        else if (this.data.media && this.data.media.caption && this.data.media.caption != "") this._text.innerHTML = (0, $ea7d21fd242a7c44$export$8c140248b4280ca1)(this.data.media.caption);
        const date = this.getFormattedDate();
        this.ariaLabel = `${this._text.innerHTML}, ${date}`;
        // Fire event that the slide is loaded
        this.onLoaded();
    }
    _initEvents() {
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.container, 'click', this._onMarkerClick, this);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.container, 'keydown', this._onMarkerKeydown, this);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.container, 'blur', this._onMarkerBlur, this);
    }
    // Update Display
    _updateDisplay(width, height, layout) {
        if (width) this.options.width = width;
        if (height) this.options.height = height;
    }
}
(0, $ea7d21fd242a7c44$export$c5910a33574a115e)($d7b4443306f8c446$export$db846fe170990ef7, (0, $2319cf524e876851$export$222529f9b823899b), (0, $d92d8eaa035c7b70$export$2e2bcd8739ae039), (0, $8948f35b9a5753b9$export$b8c17d0037837cb6));








class $1c262bf4756176a8$export$2e2bcd8739ae039 {
    constructor(drag_elem, move_elem, options){
        // DOM ELements 
        this._el = {
            drag: drag_elem,
            move: drag_elem
        };
        this.mousedrag = {
            down: "mousedown",
            up: "mouseup",
            leave: "mouseleave",
            move: "mousemove"
        };
        this.touchdrag = {
            down: "touchstart",
            up: "touchend",
            leave: "mouseleave",
            move: "touchmove"
        };
        if (move_elem) this._el.move = move_elem;
        //Options
        this.options = {
            snap: false,
            enable: {
                x: true,
                y: true
            },
            constraint: {
                top: false,
                bottom: false,
                left: 0,
                right: false
            },
            momentum_multiplier: 2000,
            duration: 1000,
            ease: (0, $2baebbd96bfe7e6e$export$40df750f1044ce5e)
        };
        // Animation Object
        this.animator = null;
        // Drag Event Type
        this.dragevent = this.mousedrag;
        if (0, $e8c72613a0980cab$export$d0b7ea69ab6056df) this.dragevent = this.touchdrag;
        // Draggable Data
        this.data = {
            sliding: false,
            direction: "none",
            pagex: {
                start: 0,
                end: 0
            },
            pagey: {
                start: 0,
                end: 0
            },
            pos: {
                start: {
                    x: 0,
                    y: 0
                },
                end: {
                    x: 0,
                    y: 0
                }
            },
            new_pos: {
                x: 0,
                y: 0
            },
            new_pos_parent: {
                x: 0,
                y: 0
            },
            time: {
                start: 0,
                end: 0
            },
            touch: false
        };
        // Merge Data and Options
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.options, options);
    }
    enable(e) {
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.drag, this.dragevent.down, this._onDragStart, this);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.drag, this.dragevent.up, this._onDragEnd, this);
        this.data.pos.start = 0;
        this._el.move.style.left = this.data.pos.start.x + "px";
        this._el.move.style.top = this.data.pos.start.y + "px";
        this._el.move.style.position = "absolute";
    //this._el.move.style.zIndex = "11";
    //this._el.move.style.cursor = "move";
    }
    disable() {
        (0, $7d599a41227e2243$export$196e5b15bdb52968).removeListener(this._el.drag, this.dragevent.down, this._onDragStart, this);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).removeListener(this._el.drag, this.dragevent.up, this._onDragEnd, this);
    }
    stopMomentum() {
        if (this.animator) this.animator.stop();
    }
    updateConstraint(c) {
        this.options.constraint = c;
    // Temporary until issues are fixed
    }
    /*	Private Methods
	================================================== */ _onDragStart(e) {
        if (this.animator) this.animator.stop();
        if (0, $e8c72613a0980cab$export$d0b7ea69ab6056df) {
            if (e.originalEvent) {
                this.data.pagex.start = e.originalEvent.touches[0].screenX;
                this.data.pagey.start = e.originalEvent.touches[0].screenY;
            } else {
                this.data.pagex.start = e.targetTouches[0].screenX;
                this.data.pagey.start = e.targetTouches[0].screenY;
            }
        } else {
            this.data.pagex.start = e.pageX;
            this.data.pagey.start = e.pageY;
        }
        // Center element to finger or mouse
        this.options.enable.x;
        this.options.enable.y;
        this.data.pos.start = {
            x: this._el.move.offsetLeft,
            y: this._el.move.offsetTop
        };
        this.data.time.start = new Date().getTime();
        this.fire("dragstart", this.data);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.drag, this.dragevent.move, this._onDragMove, this);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.drag, this.dragevent.leave, this._onDragEnd, this);
    }
    _onDragEnd(e) {
        this.data.sliding = false;
        (0, $7d599a41227e2243$export$196e5b15bdb52968).removeListener(this._el.drag, this.dragevent.move, this._onDragMove, this);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).removeListener(this._el.drag, this.dragevent.leave, this._onDragEnd, this);
        this.fire("dragend", this.data);
        //  momentum
        this._momentum();
    }
    _onDragMove(e) {
        var change = {
            x: 0,
            y: 0
        };
        //e.preventDefault();
        this.data.sliding = true;
        if (0, $e8c72613a0980cab$export$d0b7ea69ab6056df) {
            if (e.originalEvent) {
                this.data.pagex.end = e.originalEvent.touches[0].screenX;
                this.data.pagey.end = e.originalEvent.touches[0].screenY;
            } else {
                this.data.pagex.end = e.targetTouches[0].screenX;
                this.data.pagey.end = e.targetTouches[0].screenY;
            }
        } else {
            this.data.pagex.end = e.pageX;
            this.data.pagey.end = e.pageY;
        }
        change.x = this.data.pagex.start - this.data.pagex.end;
        change.y = this.data.pagey.start - this.data.pagey.end;
        this.data.pos.end = {
            x: this._el.drag.offsetLeft,
            y: this._el.drag.offsetTop
        };
        this.data.new_pos.x = -(change.x - this.data.pos.start.x);
        this.data.new_pos.y = -(change.y - this.data.pos.start.y);
        if (this.options.enable.x && Math.abs(change.x) > Math.abs(change.y)) {
            e.preventDefault();
            this._el.move.style.left = this.data.new_pos.x + "px";
        }
        if (this.options.enable.y && Math.abs(change.y) > Math.abs(change.y)) {
            e.preventDefault();
            this._el.move.style.top = this.data.new_pos.y + "px";
        }
        this.fire("dragmove", this.data);
    }
    _momentum() {
        var pos_adjust = {
            x: 0,
            y: 0,
            time: 0
        }, pos_change = {
            x: 0,
            y: 0,
            time: 0
        }, swipe_detect = {
            x: false,
            y: false
        }, swipe = false, swipe_direction = "";
        this.data.direction = null;
        pos_adjust.time = (new Date().getTime() - this.data.time.start) * 10;
        pos_change.time = (new Date().getTime() - this.data.time.start) * 10;
        pos_change.x = this.options.momentum_multiplier * (Math.abs(this.data.pagex.end) - Math.abs(this.data.pagex.start));
        pos_change.y = this.options.momentum_multiplier * (Math.abs(this.data.pagey.end) - Math.abs(this.data.pagey.start));
        pos_adjust.x = Math.round(pos_change.x / pos_change.time);
        pos_adjust.y = Math.round(pos_change.y / pos_change.time);
        this.data.new_pos.x = Math.min(this.data.new_pos.x + pos_adjust.x);
        this.data.new_pos.y = Math.min(this.data.new_pos.y + pos_adjust.y);
        if (!this.options.enable.x) this.data.new_pos.x = this.data.pos.start.x;
        else if (this.options.constraint.left && this.data.new_pos.x > this.options.constraint.left) this.data.new_pos.x = this.options.constraint.left;
        if (!this.options.enable.y) this.data.new_pos.y = this.data.pos.start.y;
        else if (this.data.new_pos.y < 0) this.data.new_pos.y = 0;
        // Detect Swipe
        if (pos_change.time < 2000) swipe = true;
        if (this.options.enable.x && this.options.enable.y) {
            if (Math.abs(pos_change.x) > Math.abs(pos_change.y)) swipe_detect.x = true;
            else swipe_detect.y = true;
        } else if (this.options.enable.x) {
            if (Math.abs(pos_change.x) > Math.abs(pos_change.y)) swipe_detect.x = true;
        } else if (Math.abs(pos_change.y) > Math.abs(pos_change.x)) swipe_detect.y = true;
        // Detect Direction and long swipe
        if (swipe_detect.x) {
            // Long Swipe
            if (Math.abs(pos_change.x) > this._el.drag.offsetWidth / 2) swipe = true;
            if (Math.abs(pos_change.x) > 10000) {
                this.data.direction = "left";
                if (pos_change.x > 0) this.data.direction = "right";
            }
        }
        if (swipe_detect.y) {
            // Long Swipe
            if (Math.abs(pos_change.y) > this._el.drag.offsetHeight / 2) swipe = true;
            if (Math.abs(pos_change.y) > 10000) {
                this.data.direction = "up";
                if (pos_change.y > 0) this.data.direction = "down";
            }
        }
        if (pos_change.time < 1000) ;
        else this._animateMomentum();
        if (swipe && this.data.direction) this.fire("swipe_" + this.data.direction, this.data);
        else if (this.data.direction) this.fire("swipe_nodirection", this.data);
        else if (this.options.snap) {
            this.animator.stop();
            this.animator = (0, $92002c55b7773eef$export$83a1293bbde53b95)(this._el.move, {
                top: this.data.pos.start.y,
                left: this.data.pos.start.x,
                duration: this.options.duration,
                easing: (0, $2baebbd96bfe7e6e$export$3e62b4b316a17914)
            });
        }
    }
    _animateMomentum() {
        var pos = {
            x: this.data.new_pos.x,
            y: this.data.new_pos.y
        }, animate = {
            duration: this.options.duration,
            easing: (0, $2baebbd96bfe7e6e$export$3e62b4b316a17914)
        };
        if (this.options.enable.y) {
            if (this.options.constraint.top || this.options.constraint.bottom) {
                if (pos.y > this.options.constraint.bottom) pos.y = this.options.constraint.bottom;
                else if (pos.y < this.options.constraint.top) pos.y = this.options.constraint.top;
            }
            animate.top = Math.floor(pos.y) + "px";
        }
        if (this.options.enable.x) {
            if (this.options.constraint.left && pos.x >= this.options.constraint.left) pos.x = this.options.constraint.left;
            if (this.options.constraint.right && pos.x < this.options.constraint.right) pos.x = this.options.constraint.right;
            animate.left = Math.floor(pos.x) + "px";
        }
        this.animator = (0, $92002c55b7773eef$export$83a1293bbde53b95)(this._el.move, animate);
        this.fire("momentum", this.data);
    }
}
(0, $ea7d21fd242a7c44$export$c5910a33574a115e)($1c262bf4756176a8$export$2e2bcd8739ae039, (0, $d92d8eaa035c7b70$export$2e2bcd8739ae039));




class $93ce4eb99ac55aa1$export$5b0c8a6e1a376125 {
    constructor(elem, timeline_config, options, language){
        this.language = language;
        // DOM ELEMENTS
        this._el = {
            parent: {},
            container: {},
            slider: {},
            slider_background: {},
            line: {},
            marker_container_mask: {},
            marker_container: {},
            marker_item_container: {},
            timeaxis: {},
            timeaxis_background: {}
        };
        this.collapsed = false;
        if (typeof elem === 'object') this._el.container = elem;
        else this._el.container = $9eb7ee258fcc7829$export$3988ae62b71be9a3(elem);
        this._el.container.setAttribute('tabindex', '0');
        // 'application' role supports predictable control of keyboard input in a complex component
        this._el.container.setAttribute('role', 'application');
        this._el.container.setAttribute('aria-label', this._('aria_label_timeline_navigation'));
        this._el.container.setAttribute('aria-description', 'Navigate between markers with arrow keys. Press "Home" for the first and "End" for the last markers');
        this.config = timeline_config;
        //Options
        this.options = {
            width: 600,
            height: 600,
            duration: 1000,
            ease: (0, $2baebbd96bfe7e6e$export$40df750f1044ce5e),
            has_groups: false,
            optimal_tick_width: 50,
            scale_factor: 2,
            marker_padding: 5,
            timenav_height_min: 150,
            marker_height_min: 30,
            marker_width_min: 100,
            zoom_sequence: [
                0.5,
                1,
                2,
                3,
                5,
                8,
                13,
                21,
                34,
                55,
                89
            ] // Array of Fibonacci numbers for TimeNav zoom levels http://www.maths.surrey.ac.uk/hosted-sites/R.Knott/Fibonacci/fibtable.html
        };
        // Animation
        this.animator = null;
        // Ready state
        this.ready = false;
        // Markers Array
        this._markers = [];
        // Eras Array
        this._eras = [];
        this.has_eras = false;
        /**
         * @type TimeGroup
         */ this._groups = [];
        // Row Height
        this._calculated_row_height = 100;
        // Current Marker
        this.current_id = "";
        // Current Focused Marker
        this.current_focused_id = "";
        // TimeScale
        this.timescale = {};
        // TimeAxis
        this.timeaxis = {};
        // Max Rows
        this.max_rows = 6;
        // Animate CSS
        this.animate_css = false;
        // Swipe Object
        this._swipable;
        // Merge Data and Options
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.options, options);
    }
    init() {
        this._initLayout();
        this._initEvents();
        this._initData();
        this.updateDisplay();
        this._onLoaded();
    }
    /*	Public
    ================================================== */ positionMarkers(fast) {
        // POSITION X
        for(var i = 0; i < this._markers.length; i++){
            var pos = this.timescale.getPositionInfo(i);
            if (fast) this._markers[i].setClass("tl-timemarker tl-timemarker-fast");
            else this._markers[i].setClass("tl-timemarker");
            this._markers[i].setPosition({
                left: pos.start
            });
            this._markers[i].setWidth(pos.width);
        }
    }
    /*	Update Display
    ================================================== */ updateDisplay(width, height, animate) {
        let reposition_markers = false;
        if (width) {
            if (this.options.width == 0 && width > 0) reposition_markers = true;
            this.options.width = width;
        }
        if (height && height != this.options.height) {
            this.options.height = height;
            this.timescale = this._getTimeScale();
        }
        // Size Markers
        this._assignRowsToMarkers();
        // Size swipable area
        this._el.slider_background.style.width = this.timescale.getPixelWidth() + this.options.width + "px";
        this._el.slider_background.style.left = -(this.options.width / 2) + "px";
        this._el.slider.style.width = this.timescale.getPixelWidth() + this.options.width + "px";
        // Update Swipable constraint
        this._swipable.updateConstraint({
            top: false,
            bottom: false,
            left: this.options.width / 2,
            right: -(this.timescale.getPixelWidth() - this.options.width / 2)
        });
        if (reposition_markers) this._drawTimeline();
        // Go to the current slide
        this.goToId(this.current_id, true);
    }
    /*	TimeScale
    ================================================== */ _getTimeScale() {
        /* maybe the establishing config values (marker_height_min and max_rows) should be
        separated from making a TimeScale object, which happens in another spot in this file with duplicate mapping of properties of this TimeNav into the TimeScale options object? */ // Set Max Rows
        var marker_height_min = 0;
        try {
            marker_height_min = parseInt(this.options.marker_height_min);
        } catch (e) {
            (0, $ea7d21fd242a7c44$export$357889f174732d38)("Invalid value for marker_height_min option.");
            marker_height_min = 30;
        }
        if (marker_height_min == 0) {
            (0, $ea7d21fd242a7c44$export$357889f174732d38)("marker_height_min option must not be zero.");
            marker_height_min = 30;
        }
        this.max_rows = Math.round((this.options.height - this._el.timeaxis_background.offsetHeight - this.options.marker_padding) / marker_height_min);
        if (this.max_rows < 1) this.max_rows = 1;
        return new (0, $123519fe12b5174b$export$a894c72689ff3ec)(this.config, {
            display_width: this._el.container.offsetWidth,
            screen_multiplier: this.options.scale_factor,
            max_rows: this.max_rows
        });
    }
    _updateTimeScale(new_scale) {
        this.options.scale_factor = new_scale;
        this._updateDrawTimeline();
    }
    zoomIn() {
        var new_scale = (0, $ea7d21fd242a7c44$export$f4cb9e34106306b)(this.options.zoom_sequence, this.options.scale_factor);
        this.setZoomFactor(new_scale);
    }
    zoomOut() {
        var new_scale = (0, $ea7d21fd242a7c44$export$dc4ff90759501dac)(this.options.zoom_sequence, this.options.scale_factor);
        this.setZoomFactor(new_scale);
    }
    setZoom(level) {
        var zoom_factor = this.options.zoom_sequence[level];
        if (typeof zoom_factor == 'number') this.setZoomFactor(zoom_factor);
        else console.warn("Invalid zoom level. Please use an index number between 0 and " + (this.options.zoom_sequence.length - 1));
    }
    setZoomFactor(factor) {
        if (factor <= this.options.zoom_sequence[0]) this.fire("zoomtoggle", {
            zoom: "out",
            show: false
        });
        else this.fire("zoomtoggle", {
            zoom: "out",
            show: true
        });
        if (factor >= this.options.zoom_sequence[this.options.zoom_sequence.length - 1]) this.fire("zoomtoggle", {
            zoom: "in",
            show: false
        });
        else this.fire("zoomtoggle", {
            zoom: "in",
            show: true
        });
        if (factor == 0) {
            console.warn("Zoom factor must be greater than zero. Using 0.1");
            factor = 0.1;
        }
        this.options.scale_factor = factor;
        //this._updateDrawTimeline(true);
        this.goToId(this.current_id, !this._updateDrawTimeline(true), true);
    }
    /*	Groups
    ================================================== */ _createGroups() {
        this._groups = [];
        var group_labels = this.timescale.getGroupLabels();
        if (group_labels) {
            this.options.has_groups = true;
            for(var i = 0; i < group_labels.length; i++)this._createGroup(group_labels[i]);
        }
    }
    _createGroup(group_label) {
        var group = new (0, $a5808eb6456b091b$export$9886ff53633678b5)(group_label);
        this._addGroup(group);
        this._groups.push(group);
    }
    _addGroup(group) {
        group.addTo(this._el.container);
    }
    _positionGroups() {
        if (this.options.has_groups) {
            var available_height = this.options.height - this._el.timeaxis_background.offsetHeight, group_height = Math.floor(available_height / this.timescale.getNumberOfRows() - this.options.marker_padding), group_labels = this.timescale.getGroupLabels();
            for(var i = 0, group_rows = 0; i < this._groups.length; i++){
                var group_y = Math.floor(group_rows * (group_height + this.options.marker_padding));
                var group_hide = false;
                if (group_y > available_height - this.options.marker_padding) group_hide = true;
                this._groups[i].setRowPosition(group_y, this._calculated_row_height + this.options.marker_padding / 2);
                this._groups[i].setAlternateRowColor((0, $ea7d21fd242a7c44$export$ce16302d1253e25)(i), group_hide);
                group_rows += this._groups[i].data.rows; // account for groups spanning multiple rows
            }
        }
    }
    /*	Markers
    ================================================== */ _addMarker(marker) {
        marker.addTo(this._el.marker_item_container);
        marker.on('markerclick', this._onMarkerClick, this);
        marker.on('added', this._onMarkerAdded, this);
    }
    _createMarker(data, n) {
        var marker = new (0, $d7b4443306f8c446$export$db846fe170990ef7)(data, this.options);
        this._addMarker(marker);
        if (n < 0) this._markers.push(marker);
        else this._markers.splice(n, 0, marker);
    }
    _createMarkers(array) {
        for(var i = 0; i < array.length; i++)this._createMarker(array[i], -1);
    }
    _removeMarker(marker) {
        marker.removeFrom(this._el.marker_item_container);
    //marker.off('added', this._onMarkerRemoved, this);
    }
    _destroyMarker(n) {
        this._removeMarker(this._markers[n]);
        this._markers.splice(n, 1);
    }
    _calculateMarkerHeight(h) {
        return h / this.timescale.getNumberOfRows() - this.options.marker_padding;
    }
    _calculateRowHeight(h) {
        return h / this.timescale.getNumberOfRows();
    }
    _calculateAvailableHeight() {
        return this.options.height - this._el.timeaxis_background.offsetHeight - this.options.marker_padding;
    }
    _calculateMinimumTimeNavHeight() {
        return this.timescale.getNumberOfRows() * this.options.marker_height_min + this._el.timeaxis_background.offsetHeight + this.options.marker_padding;
    }
    getMinimumHeight() {
        return this._calculateMinimumTimeNavHeight();
    }
    _assignRowsToMarkers() {
        var available_height = this._calculateAvailableHeight(), marker_height = this._calculateMarkerHeight(available_height);
        this._positionGroups();
        this._calculated_row_height = this._calculateRowHeight(available_height);
        for(var i = 0; i < this._markers.length; i++){
            // Set Height
            this._markers[i].setHeight(marker_height);
            //Position by Row
            var row = this.timescale.getPositionInfo(i).row;
            var marker_y = Math.floor(row * (marker_height + this.options.marker_padding)) + this.options.marker_padding;
            var remainder_height = available_height - marker_y + this.options.marker_padding;
            this._markers[i].setRowPosition(marker_y, remainder_height);
        }
    }
    _resetMarkersActive() {
        for(var i = 0; i < this._markers.length; i++)this._markers[i].setActive(false);
    }
    _resetMarkersBlurListeners() {
        for(var i = 0; i < this._markers.length; i++)this._markers[i].off('markerblur', this._onMarkerBlur, this);
    }
    _findMarkerIndex(n) {
        var _n = -1;
        if (typeof n == 'string' || n instanceof String) _n = (0, $ea7d21fd242a7c44$export$c4632a8493ebcf7d)(n, this._markers, "unique_id", _n);
        return _n;
    }
    /*	ERAS
    ================================================== */ _createEras(array) {
        for(var i = 0; i < array.length; i++){
            var data = array[i];
            var era = new (0, $cb9449ab395564cb$export$7f5cf634ef8d6093)(data.start_date, data.end_date, data.headline, this.options);
            this._eras.push(era);
            era.addTo(this._el.marker_item_container);
            era.on('added', this._onEraAdded, this);
        }
    }
    _positionEras(fast) {
        var era_color = 0;
        // POSITION X
        for(var i = 0; i < this._eras.length; i++){
            var pos = {
                start: 0,
                end: 0,
                width: 0
            };
            pos.start = this.timescale.getPosition(this._eras[i].start_date.getTime());
            pos.end = this.timescale.getPosition(this._eras[i].end_date.getTime());
            pos.width = pos.end - pos.start;
            if (fast) this._eras[i].setClass("tl-timeera tl-timeera-fast");
            else this._eras[i].setClass("tl-timeera");
            this._eras[i].setPosition({
                left: pos.start
            });
            this._eras[i].setWidth(pos.width);
            era_color++;
            if (era_color > 5) era_color = 0;
            this._eras[i].setColor(era_color);
        }
    }
    /*	Public
    ================================================== */ // Create a marker
    createMarker(d, n) {
        this._createMarker(d, n);
    }
    // Create many markers from an array
    createMarkers(array) {
        this._createMarkers(array);
    }
    // Destroy marker by index
    destroyMarker(n) {
        this._destroyMarker(n);
    }
    // Destroy marker by id
    destroyMarkerId(id) {
        this.destroyMarker(this._findMarkerIndex(id));
    }
    /*	Navigation
    ================================================== */ goTo(n, fast, css_animation) {
        var self = this, _ease = this.options.ease, _duration = this.options.duration, _n = n < 0 ? 0 : n;
        // Set Marker active state
        this._resetMarkersActive();
        if (n >= 0 && n < this._markers.length) this._markers[n].setActive(true);
        this.animateMovement(_n, fast, css_animation, _duration, _ease);
        if (n >= 0 && n < this._markers.length) this.current_id = this.current_focused_id = this._markers[n].data.unique_id;
        else this.current_id = this.current_focused_id = '';
        this._setLabelWithCurrentMarker();
    }
    goToId(id, fast, css_animation) {
        this.goTo(this._findMarkerIndex(id), fast, css_animation);
    }
    focusOn(n, fast, css_animation) {
        const _ease = this.options.ease, _duration = this.options.duration, _n = n < 0 ? 0 : n;
        this.animateMovement(_n, fast, css_animation, _duration, _ease);
        this._resetMarkersBlurListeners();
        if (n >= 0 && n < this._markers.length) {
            this._markers[n].setFocus();
            this.current_focused_id = this._markers[n].data.unique_id;
            this._markers[n].on('markerblur', this._onMarkerBlur, this);
        }
    }
    focusNext() {
        const n = this._findMarkerIndex(this.current_focused_id);
        if (n + 1 < this._markers.length) this.focusOn(n + 1);
        else this.focusOn(n);
    }
    focusPrevious() {
        const n = this._findMarkerIndex(this.current_focused_id);
        if (n - 1 >= 0) this.focusOn(n - 1);
        else this.focusOn(n);
    }
    animateMovement(n, fast, css_animation, duration, ease) {
        // Stop animation
        if (this.animator) this.animator.stop();
        if (fast) {
            this._el.slider.className = "tl-timenav-slider";
            this._el.slider.style.left = -this._markers[n].getLeft() + this.options.width / 2 + "px";
        } else if (css_animation) {
            this._el.slider.className = "tl-timenav-slider tl-timenav-slider-animate";
            this.animate_css = true;
            this._el.slider.style.left = -this._markers[n].getLeft() + this.options.width / 2 + "px";
        } else {
            this._el.slider.className = "tl-timenav-slider";
            this.animator = (0, $92002c55b7773eef$export$83a1293bbde53b95)(this._el.slider, {
                left: -this._markers[n].getLeft() + this.options.width / 2 + "px",
                duration: duration,
                easing: ease
            });
        }
        if (n >= 0 && n < this._markers.length) this.current_id = this._markers[n].data.unique_id;
        else this.current_id = '';
        this._dispatchVisibleTicksChange();
    }
    goToId(id, fast, css_animation) {
        this.goTo(this._findMarkerIndex(id), fast, css_animation);
    }
    _dispatchVisibleTicksChange() {
        /**
         * The timeout is required to wait till the end of the animation
         * and repositioning of the ticks on the screen
         */ if (this.ticks_change_timeout) {
            clearTimeout(this.ticks_change_timeout);
            this.ticks_change_timeout = null;
        }
        this.ticks_change_timeout = setTimeout(()=>{
            const visible_ticks = this.timeaxis.getVisibleTicks();
            this.fire("visible_ticks_change", {
                visible_ticks: visible_ticks
            });
        }, this.options.duration);
    }
    /*	Events
    ================================================== */ _onLoaded() {
        this.ready = true;
        this.fire("loaded", this.config);
    }
    _onMarkerAdded(e) {
        this.fire("dateAdded", this.config);
    }
    _onEraAdded(e) {
        this.fire("eraAdded", this.config);
    }
    _onMarkerRemoved(e) {
        this.fire("dateRemoved", this.config);
    }
    _onMarkerClick(e) {
        // Go to the clicked marker
        this.goToId(e.unique_id);
        this.fire("change", {
            unique_id: e.unique_id
        });
    }
    _onMarkerBlur(e) {
        // Reset the focused marked to the active marker after it lost the focus
        if (this.current_focused_id === this.current_id) return;
        this.focusOn(this._findMarkerIndex(this.current_id));
    }
    _onMouseScroll(e) {
        var delta = 0, scroll_to = 0, constraint = {
            right: -(this.timescale.getPixelWidth() - this.options.width / 2),
            left: this.options.width / 2
        };
        if (!e) e = window.event;
        if (e.originalEvent) e = e.originalEvent;
        // Webkit and browsers able to differntiate between up/down and left/right scrolling
        if (typeof e.wheelDeltaX != 'undefined') {
            delta = e.wheelDeltaY / 6;
            if (Math.abs(e.wheelDeltaX) > Math.abs(e.wheelDeltaY)) delta = e.wheelDeltaX / 6;
            else //delta = e.wheelDeltaY/6;
            delta = 0;
        }
        if (delta) {
            if (e.preventDefault) e.preventDefault();
            e.returnValue = false;
        }
        // Stop from scrolling too far
        scroll_to = parseInt(this._el.slider.style.left.replace("px", "")) + delta;
        if (scroll_to > constraint.left) scroll_to = constraint.left;
        else if (scroll_to < constraint.right) scroll_to = constraint.right;
        if (this.animate_css) {
            this._el.slider.className = "tl-timenav-slider";
            this.animate_css = false;
        }
        this._el.slider.style.left = scroll_to + "px";
    }
    _onDragMove(e) {
        if (this.animate_css) {
            this._el.slider.className = "tl-timenav-slider";
            this.animate_css = false;
        }
    }
    _onKeydown(e) {
        (0, $7d599a41227e2243$export$196e5b15bdb52968).stopPropagation(e);
        switch(e.key){
            case "ArrowUp":
            case "ArrowRight":
                this.focusNext();
                break;
            case "ArrowDown":
            case "ArrowLeft":
                this.focusPrevious();
                break;
            case "Home":
                this.focusOn(0);
                break;
            case "End":
                this.focusOn(this._markers.length - 1);
                break;
        }
    }
    /*	Private Methods
    ================================================== */ _drawTimeline(fast) {
        this.timescale = this._getTimeScale();
        this.timeaxis.drawTicks(this.timescale, this.options.optimal_tick_width);
        this.positionMarkers(fast);
        this._assignRowsToMarkers();
        this._createGroups();
        this._positionGroups();
        if (this.has_eras) this._positionEras(fast);
    }
    _updateDrawTimeline(check_update) {
        var do_update = false;
        // Check to see if redraw is needed
        if (check_update) {
            /* keep this aligned with _getTimeScale or reduce code duplication */ var temp_timescale = new (0, $123519fe12b5174b$export$a894c72689ff3ec)(this.config, {
                display_width: this._el.container.offsetWidth,
                screen_multiplier: this.options.scale_factor,
                max_rows: this.max_rows
            });
            if (this.timescale.getMajorScale() == temp_timescale.getMajorScale() && this.timescale.getMinorScale() == temp_timescale.getMinorScale()) do_update = true;
        } else do_update = true;
        // Perform update or redraw
        if (do_update) {
            this.timescale = this._getTimeScale();
            this.timeaxis.positionTicks(this.timescale, this.options.optimal_tick_width);
            this.positionMarkers();
            this._assignRowsToMarkers();
            this._positionGroups();
            if (this.has_eras) this._positionEras();
            this.updateDisplay();
        } else this._drawTimeline(true);
        return do_update;
    }
    _setLabelWithCurrentMarker() {
        const currentMarker = this._markers[this._findMarkerIndex(this.current_focused_id)];
        const currentMarkerText = currentMarker && currentMarker.ariaLabel ? `, ${currentMarker.ariaLabel}, shown` : '';
        this._el.container.setAttribute('aria-label', `Timeline navigation ${currentMarkerText}`);
    }
    /*	Init
    ================================================== */ _initLayout() {
        // Create Layout
        this._el.line = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-timenav-line', this._el.container);
        this._el.slider = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-timenav-slider', this._el.container);
        this._el.slider_background = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-timenav-slider-background', this._el.slider);
        this._el.marker_container_mask = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-timenav-container-mask', this._el.slider);
        this._el.marker_container = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-timenav-container', this._el.marker_container_mask);
        this._el.marker_item_container = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-timenav-item-container', this._el.marker_container);
        this._el.timeaxis = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-timeaxis', this._el.slider);
        this._el.timeaxis_background = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-timeaxis-background', this._el.container);
        // Time Axis
        this.timeaxis = new (0, $bca268421445ad88$export$ff3f087ada3aa913)(this._el.timeaxis, this.options, this.language);
        // Swipable
        this._swipable = new (0, $1c262bf4756176a8$export$2e2bcd8739ae039)(this._el.slider_background, this._el.slider, {
            enable: {
                x: true,
                y: false
            },
            constraint: {
                top: false,
                bottom: false,
                left: this.options.width / 2,
                right: false
            },
            snap: false
        });
        this._swipable.enable();
    }
    _initEvents() {
        // Drag Events
        this._swipable.on('dragmove', this._onDragMove, this);
        // Scroll Events
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.container, 'mousewheel', this._onMouseScroll, this);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.container, 'DOMMouseScroll', this._onMouseScroll, this);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.container, 'keydown', this._onKeydown, this);
    }
    _initData() {
        // Create Markers and then add them
        this._createMarkers(this.config.events);
        if (this.config.eras && this.config.eras.length > 0) {
            this.has_eras = true;
            this._createEras(this.config.eras);
        }
        this._drawTimeline();
    }
}
(0, $ea7d21fd242a7c44$export$c5910a33574a115e)($93ce4eb99ac55aa1$export$5b0c8a6e1a376125, (0, $d92d8eaa035c7b70$export$2e2bcd8739ae039), (0, $8948f35b9a5753b9$export$b8c17d0037837cb6), (0, $2319cf524e876851$export$222529f9b823899b));














var $b278282c6b3a7f26$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $b278282c6b3a7f26$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/**
 * This work is licensed under the W3C Software and Document License
 * (http://www.w3.org/Consortium/Legal/2015/copyright-software-and-document).
 */ (function() {
    // Return early if we're not running inside of the browser.
    if (typeof window === 'undefined' || typeof Element === 'undefined') return;
    // Convenience function for converting NodeLists.
    /** @type {typeof Array.prototype.slice} */ var slice = Array.prototype.slice;
    /**
   * IE has a non-standard name for "matches".
   * @type {typeof Element.prototype.matches}
   */ var matches = Element.prototype.matches || Element.prototype.msMatchesSelector;
    /** @type {string} */ var _focusableElementsString = [
        'a[href]',
        'area[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'button:not([disabled])',
        'details',
        'summary',
        'iframe',
        'object',
        'embed',
        'video',
        '[contenteditable]'
    ].join(',');
    /**
   * `InertRoot` manages a single inert subtree, i.e. a DOM subtree whose root element has an `inert`
   * attribute.
   *
   * Its main functions are:
   *
   * - to create and maintain a set of managed `InertNode`s, including when mutations occur in the
   *   subtree. The `makeSubtreeUnfocusable()` method handles collecting `InertNode`s via registering
   *   each focusable node in the subtree with the singleton `InertManager` which manages all known
   *   focusable nodes within inert subtrees. `InertManager` ensures that a single `InertNode`
   *   instance exists for each focusable node which has at least one inert root as an ancestor.
   *
   * - to notify all managed `InertNode`s when this subtree stops being inert (i.e. when the `inert`
   *   attribute is removed from the root node). This is handled in the destructor, which calls the
   *   `deregister` method on `InertManager` for each managed inert node.
   */ var InertRoot = function() {
        /**
     * @param {!HTMLElement} rootElement The HTMLElement at the root of the inert subtree.
     * @param {!InertManager} inertManager The global singleton InertManager object.
     */ function InertRoot(rootElement, inertManager) {
            $b278282c6b3a7f26$var$_classCallCheck(this, InertRoot);
            /** @type {!InertManager} */ this._inertManager = inertManager;
            /** @type {!HTMLElement} */ this._rootElement = rootElement;
            /**
       * @type {!Set<!InertNode>}
       * All managed focusable nodes in this InertRoot's subtree.
       */ this._managedNodes = new Set();
            // Make the subtree hidden from assistive technology
            if (this._rootElement.hasAttribute('aria-hidden')) /** @type {?string} */ this._savedAriaHidden = this._rootElement.getAttribute('aria-hidden');
            else this._savedAriaHidden = null;
            this._rootElement.setAttribute('aria-hidden', 'true');
            // Make all focusable elements in the subtree unfocusable and add them to _managedNodes
            this._makeSubtreeUnfocusable(this._rootElement);
            // Watch for:
            // - any additions in the subtree: make them unfocusable too
            // - any removals from the subtree: remove them from this inert root's managed nodes
            // - attribute changes: if `tabindex` is added, or removed from an intrinsically focusable
            //   element, make that node a managed node.
            this._observer = new MutationObserver(this._onMutation.bind(this));
            this._observer.observe(this._rootElement, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        /**
     * Call this whenever this object is about to become obsolete.  This unwinds all of the state
     * stored in this object and updates the state of all of the managed nodes.
     */ $b278282c6b3a7f26$var$_createClass(InertRoot, [
            {
                key: 'destructor',
                value: function destructor() {
                    this._observer.disconnect();
                    if (this._rootElement) {
                        if (this._savedAriaHidden !== null) this._rootElement.setAttribute('aria-hidden', this._savedAriaHidden);
                        else this._rootElement.removeAttribute('aria-hidden');
                    }
                    this._managedNodes.forEach(function(inertNode) {
                        this._unmanageNode(inertNode.node);
                    }, this);
                    // Note we cast the nulls to the ANY type here because:
                    // 1) We want the class properties to be declared as non-null, or else we
                    //    need even more casts throughout this code. All bets are off if an
                    //    instance has been destroyed and a method is called.
                    // 2) We don't want to cast "this", because we want type-aware optimizations
                    //    to know which properties we're setting.
                    this._observer = /** @type {?} */ null;
                    this._rootElement = /** @type {?} */ null;
                    this._managedNodes = /** @type {?} */ null;
                    this._inertManager = /** @type {?} */ null;
                }
            },
            {
                key: '_makeSubtreeUnfocusable',
                /**
       * @param {!Node} startNode
       */ value: function _makeSubtreeUnfocusable(startNode) {
                    var _this2 = this;
                    composedTreeWalk(startNode, function(node) {
                        return _this2._visitNode(node);
                    });
                    var activeElement = document.activeElement;
                    if (!document.body.contains(startNode)) {
                        // startNode may be in shadow DOM, so find its nearest shadowRoot to get the activeElement.
                        var node = startNode;
                        /** @type {!ShadowRoot|undefined} */ var root = undefined;
                        while(node){
                            if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                root = /** @type {!ShadowRoot} */ node;
                                break;
                            }
                            node = node.parentNode;
                        }
                        if (root) activeElement = root.activeElement;
                    }
                    if (startNode.contains(activeElement)) {
                        activeElement.blur();
                        // In IE11, if an element is already focused, and then set to tabindex=-1
                        // calling blur() will not actually move the focus.
                        // To work around this we call focus() on the body instead.
                        if (activeElement === document.activeElement) document.body.focus();
                    }
                }
            },
            {
                key: '_visitNode',
                value: function _visitNode(node) {
                    if (node.nodeType !== Node.ELEMENT_NODE) return;
                    var element = /** @type {!HTMLElement} */ node;
                    // If a descendant inert root becomes un-inert, its descendants will still be inert because of
                    // this inert root, so all of its managed nodes need to be adopted by this InertRoot.
                    if (element !== this._rootElement && element.hasAttribute('inert')) this._adoptInertRoot(element);
                    if (matches.call(element, _focusableElementsString) || element.hasAttribute('tabindex')) this._manageNode(element);
                }
            },
            {
                key: '_manageNode',
                value: function _manageNode(node) {
                    var inertNode = this._inertManager.register(node, this);
                    this._managedNodes.add(inertNode);
                }
            },
            {
                key: '_unmanageNode',
                value: function _unmanageNode(node) {
                    var inertNode = this._inertManager.deregister(node, this);
                    if (inertNode) this._managedNodes['delete'](inertNode);
                }
            },
            {
                key: '_unmanageSubtree',
                value: function _unmanageSubtree(startNode) {
                    var _this3 = this;
                    composedTreeWalk(startNode, function(node) {
                        return _this3._unmanageNode(node);
                    });
                }
            },
            {
                key: '_adoptInertRoot',
                value: function _adoptInertRoot(node) {
                    var inertSubroot = this._inertManager.getInertRoot(node);
                    // During initialisation this inert root may not have been registered yet,
                    // so register it now if need be.
                    if (!inertSubroot) {
                        this._inertManager.setInert(node, true);
                        inertSubroot = this._inertManager.getInertRoot(node);
                    }
                    inertSubroot.managedNodes.forEach(function(savedInertNode) {
                        this._manageNode(savedInertNode.node);
                    }, this);
                }
            },
            {
                key: '_onMutation',
                value: function _onMutation(records, self) {
                    records.forEach(function(record) {
                        var target = /** @type {!HTMLElement} */ record.target;
                        if (record.type === 'childList') {
                            // Manage added nodes
                            slice.call(record.addedNodes).forEach(function(node) {
                                this._makeSubtreeUnfocusable(node);
                            }, this);
                            // Un-manage removed nodes
                            slice.call(record.removedNodes).forEach(function(node) {
                                this._unmanageSubtree(node);
                            }, this);
                        } else if (record.type === 'attributes') {
                            if (record.attributeName === 'tabindex') // Re-initialise inert node if tabindex changes
                            this._manageNode(target);
                            else if (target !== this._rootElement && record.attributeName === 'inert' && target.hasAttribute('inert')) {
                                // If a new inert root is added, adopt its managed nodes and make sure it knows about the
                                // already managed nodes from this inert subroot.
                                this._adoptInertRoot(target);
                                var inertSubroot = this._inertManager.getInertRoot(target);
                                this._managedNodes.forEach(function(managedNode) {
                                    if (target.contains(managedNode.node)) inertSubroot._manageNode(managedNode.node);
                                });
                            }
                        }
                    }, this);
                }
            },
            {
                key: 'managedNodes',
                get: function get() {
                    return new Set(this._managedNodes);
                }
            },
            {
                key: 'hasSavedAriaHidden',
                get: function get() {
                    return this._savedAriaHidden !== null;
                }
            },
            {
                key: 'savedAriaHidden',
                set: function set(ariaHidden) {
                    this._savedAriaHidden = ariaHidden;
                },
                get: function get() {
                    return this._savedAriaHidden;
                }
            }
        ]);
        return InertRoot;
    }();
    /**
   * `InertNode` initialises and manages a single inert node.
   * A node is inert if it is a descendant of one or more inert root elements.
   *
   * On construction, `InertNode` saves the existing `tabindex` value for the node, if any, and
   * either removes the `tabindex` attribute or sets it to `-1`, depending on whether the element
   * is intrinsically focusable or not.
   *
   * `InertNode` maintains a set of `InertRoot`s which are descendants of this `InertNode`. When an
   * `InertRoot` is destroyed, and calls `InertManager.deregister()`, the `InertManager` notifies the
   * `InertNode` via `removeInertRoot()`, which in turn destroys the `InertNode` if no `InertRoot`s
   * remain in the set. On destruction, `InertNode` reinstates the stored `tabindex` if one exists,
   * or removes the `tabindex` attribute if the element is intrinsically focusable.
   */ var InertNode = function() {
        /**
     * @param {!Node} node A focusable element to be made inert.
     * @param {!InertRoot} inertRoot The inert root element associated with this inert node.
     */ function InertNode(node, inertRoot) {
            $b278282c6b3a7f26$var$_classCallCheck(this, InertNode);
            /** @type {!Node} */ this._node = node;
            /** @type {boolean} */ this._overrodeFocusMethod = false;
            /**
       * @type {!Set<!InertRoot>} The set of descendant inert roots.
       *    If and only if this set becomes empty, this node is no longer inert.
       */ this._inertRoots = new Set([
                inertRoot
            ]);
            /** @type {?number} */ this._savedTabIndex = null;
            /** @type {boolean} */ this._destroyed = false;
            // Save any prior tabindex info and make this node untabbable
            this.ensureUntabbable();
        }
        /**
     * Call this whenever this object is about to become obsolete.
     * This makes the managed node focusable again and deletes all of the previously stored state.
     */ $b278282c6b3a7f26$var$_createClass(InertNode, [
            {
                key: 'destructor',
                value: function destructor() {
                    this._throwIfDestroyed();
                    if (this._node && this._node.nodeType === Node.ELEMENT_NODE) {
                        var element = /** @type {!HTMLElement} */ this._node;
                        if (this._savedTabIndex !== null) element.setAttribute('tabindex', this._savedTabIndex);
                        else element.removeAttribute('tabindex');
                        // Use `delete` to restore native focus method.
                        if (this._overrodeFocusMethod) delete element.focus;
                    }
                    // See note in InertRoot.destructor for why we cast these nulls to ANY.
                    this._node = /** @type {?} */ null;
                    this._inertRoots = /** @type {?} */ null;
                    this._destroyed = true;
                }
            },
            {
                key: '_throwIfDestroyed',
                /**
       * Throw if user tries to access destroyed InertNode.
       */ value: function _throwIfDestroyed() {
                    if (this.destroyed) throw new Error('Trying to access destroyed InertNode');
                }
            },
            {
                key: 'ensureUntabbable',
                /** Save the existing tabindex value and make the node untabbable and unfocusable */ value: function ensureUntabbable() {
                    if (this.node.nodeType !== Node.ELEMENT_NODE) return;
                    var element = /** @type {!HTMLElement} */ this.node;
                    if (matches.call(element, _focusableElementsString)) {
                        if (/** @type {!HTMLElement} */ element.tabIndex === -1 && this.hasSavedTabIndex) return;
                        if (element.hasAttribute('tabindex')) this._savedTabIndex = /** @type {!HTMLElement} */ element.tabIndex;
                        element.setAttribute('tabindex', '-1');
                        if (element.nodeType === Node.ELEMENT_NODE) {
                            element.focus = function() {};
                            this._overrodeFocusMethod = true;
                        }
                    } else if (element.hasAttribute('tabindex')) {
                        this._savedTabIndex = /** @type {!HTMLElement} */ element.tabIndex;
                        element.removeAttribute('tabindex');
                    }
                }
            },
            {
                key: 'addInertRoot',
                value: function addInertRoot(inertRoot) {
                    this._throwIfDestroyed();
                    this._inertRoots.add(inertRoot);
                }
            },
            {
                key: 'removeInertRoot',
                value: function removeInertRoot(inertRoot) {
                    this._throwIfDestroyed();
                    this._inertRoots['delete'](inertRoot);
                    if (this._inertRoots.size === 0) this.destructor();
                }
            },
            {
                key: 'destroyed',
                get: function get() {
                    return /** @type {!InertNode} */ this._destroyed;
                }
            },
            {
                key: 'hasSavedTabIndex',
                get: function get() {
                    return this._savedTabIndex !== null;
                }
            },
            {
                key: 'node',
                get: function get() {
                    this._throwIfDestroyed();
                    return this._node;
                }
            },
            {
                key: 'savedTabIndex',
                set: function set(tabIndex) {
                    this._throwIfDestroyed();
                    this._savedTabIndex = tabIndex;
                },
                get: function get() {
                    this._throwIfDestroyed();
                    return this._savedTabIndex;
                }
            }
        ]);
        return InertNode;
    }();
    /**
   * InertManager is a per-document singleton object which manages all inert roots and nodes.
   *
   * When an element becomes an inert root by having an `inert` attribute set and/or its `inert`
   * property set to `true`, the `setInert` method creates an `InertRoot` object for the element.
   * The `InertRoot` in turn registers itself as managing all of the element's focusable descendant
   * nodes via the `register()` method. The `InertManager` ensures that a single `InertNode` instance
   * is created for each such node, via the `_managedNodes` map.
   */ var InertManager = function() {
        /**
     * @param {!Document} document
     */ function InertManager(document1) {
            $b278282c6b3a7f26$var$_classCallCheck(this, InertManager);
            if (!document1) throw new Error('Missing required argument; InertManager needs to wrap a document.');
            /** @type {!Document} */ this._document = document1;
            /**
       * All managed nodes known to this InertManager. In a map to allow looking up by Node.
       * @type {!Map<!Node, !InertNode>}
       */ this._managedNodes = new Map();
            /**
       * All inert roots known to this InertManager. In a map to allow looking up by Node.
       * @type {!Map<!Node, !InertRoot>}
       */ this._inertRoots = new Map();
            /**
       * Observer for mutations on `document.body`.
       * @type {!MutationObserver}
       */ this._observer = new MutationObserver(this._watchForInert.bind(this));
            // Add inert style.
            addInertStyle(document1.head || document1.body || document1.documentElement);
            // Wait for document to be loaded.
            if (document1.readyState === 'loading') document1.addEventListener('DOMContentLoaded', this._onDocumentLoaded.bind(this));
            else this._onDocumentLoaded();
        }
        /**
     * Set whether the given element should be an inert root or not.
     * @param {!HTMLElement} root
     * @param {boolean} inert
     */ $b278282c6b3a7f26$var$_createClass(InertManager, [
            {
                key: 'setInert',
                value: function setInert(root, inert) {
                    if (inert) {
                        if (this._inertRoots.has(root)) // element is already inert
                        return;
                        var inertRoot = new InertRoot(root, this);
                        root.setAttribute('inert', '');
                        this._inertRoots.set(root, inertRoot);
                        // If not contained in the document, it must be in a shadowRoot.
                        // Ensure inert styles are added there.
                        if (!this._document.body.contains(root)) {
                            var parent = root.parentNode;
                            while(parent){
                                if (parent.nodeType === 11) addInertStyle(parent);
                                parent = parent.parentNode;
                            }
                        }
                    } else {
                        if (!this._inertRoots.has(root)) // element is already non-inert
                        return;
                        var _inertRoot = this._inertRoots.get(root);
                        _inertRoot.destructor();
                        this._inertRoots['delete'](root);
                        root.removeAttribute('inert');
                    }
                }
            },
            {
                key: 'getInertRoot',
                value: function getInertRoot(element) {
                    return this._inertRoots.get(element);
                }
            },
            {
                key: 'register',
                value: function register(node, inertRoot) {
                    var inertNode = this._managedNodes.get(node);
                    if (inertNode !== undefined) // node was already in an inert subtree
                    inertNode.addInertRoot(inertRoot);
                    else inertNode = new InertNode(node, inertRoot);
                    this._managedNodes.set(node, inertNode);
                    return inertNode;
                }
            },
            {
                key: 'deregister',
                value: function deregister(node, inertRoot) {
                    var inertNode = this._managedNodes.get(node);
                    if (!inertNode) return null;
                    inertNode.removeInertRoot(inertRoot);
                    if (inertNode.destroyed) this._managedNodes['delete'](node);
                    return inertNode;
                }
            },
            {
                key: '_onDocumentLoaded',
                value: function _onDocumentLoaded() {
                    // Find all inert roots in document and make them actually inert.
                    var inertElements = slice.call(this._document.querySelectorAll('[inert]'));
                    inertElements.forEach(function(inertElement) {
                        this.setInert(inertElement, true);
                    }, this);
                    // Comment this out to use programmatic API only.
                    this._observer.observe(this._document.body || this._document.documentElement, {
                        attributes: true,
                        subtree: true,
                        childList: true
                    });
                }
            },
            {
                key: '_watchForInert',
                value: function _watchForInert(records, self) {
                    var _this = this;
                    records.forEach(function(record) {
                        switch(record.type){
                            case 'childList':
                                slice.call(record.addedNodes).forEach(function(node) {
                                    if (node.nodeType !== Node.ELEMENT_NODE) return;
                                    var inertElements = slice.call(node.querySelectorAll('[inert]'));
                                    if (matches.call(node, '[inert]')) inertElements.unshift(node);
                                    inertElements.forEach(function(inertElement) {
                                        this.setInert(inertElement, true);
                                    }, _this);
                                }, _this);
                                break;
                            case 'attributes':
                                if (record.attributeName !== 'inert') return;
                                var target = /** @type {!HTMLElement} */ record.target;
                                var inert = target.hasAttribute('inert');
                                _this.setInert(target, inert);
                                break;
                        }
                    }, this);
                }
            }
        ]);
        return InertManager;
    }();
    /**
   * Recursively walk the composed tree from |node|.
   * @param {!Node} node
   * @param {(function (!HTMLElement))=} callback Callback to be called for each element traversed,
   *     before descending into child nodes.
   * @param {?ShadowRoot=} shadowRootAncestor The nearest ShadowRoot ancestor, if any.
   */ function composedTreeWalk(node, callback, shadowRootAncestor) {
        if (node.nodeType == Node.ELEMENT_NODE) {
            var element = /** @type {!HTMLElement} */ node;
            if (callback) callback(element);
            // Descend into node:
            // If it has a ShadowRoot, ignore all child elements - these will be picked
            // up by the <content> or <shadow> elements. Descend straight into the
            // ShadowRoot.
            var shadowRoot = /** @type {!HTMLElement} */ element.shadowRoot;
            if (shadowRoot) {
                composedTreeWalk(shadowRoot, callback, shadowRoot);
                return;
            }
            // If it is a <content> element, descend into distributed elements - these
            // are elements from outside the shadow root which are rendered inside the
            // shadow DOM.
            if (element.localName == 'content') {
                var content = /** @type {!HTMLContentElement} */ element;
                // Verifies if ShadowDom v0 is supported.
                var distributedNodes = content.getDistributedNodes ? content.getDistributedNodes() : [];
                for(var i = 0; i < distributedNodes.length; i++)composedTreeWalk(distributedNodes[i], callback, shadowRootAncestor);
                return;
            }
            // If it is a <slot> element, descend into assigned nodes - these
            // are elements from outside the shadow root which are rendered inside the
            // shadow DOM.
            if (element.localName == 'slot') {
                var slot = /** @type {!HTMLSlotElement} */ element;
                // Verify if ShadowDom v1 is supported.
                var _distributedNodes = slot.assignedNodes ? slot.assignedNodes({
                    flatten: true
                }) : [];
                for(var _i = 0; _i < _distributedNodes.length; _i++)composedTreeWalk(_distributedNodes[_i], callback, shadowRootAncestor);
                return;
            }
        }
        // If it is neither the parent of a ShadowRoot, a <content> element, a <slot>
        // element, nor a <shadow> element recurse normally.
        var child = node.firstChild;
        while(child != null){
            composedTreeWalk(child, callback, shadowRootAncestor);
            child = child.nextSibling;
        }
    }
    /**
   * Adds a style element to the node containing the inert specific styles
   * @param {!Node} node
   */ function addInertStyle(node) {
        if (node.querySelector('style#inert-style, link#inert-style')) return;
        var style = document.createElement('style');
        style.setAttribute('id', 'inert-style');
        style.textContent = "\n[inert] {\n  pointer-events: none;\n  cursor: default;\n}\n\n[inert], [inert] * {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n";
        node.appendChild(style);
    }
    if (!HTMLElement.prototype.hasOwnProperty('inert')) {
        /** @type {!InertManager} */ var inertManager = new InertManager(document);
        Object.defineProperty(HTMLElement.prototype, 'inert', {
            enumerable: true,
            /** @this {!HTMLElement} */ get: function get() {
                return this.hasAttribute('inert');
            },
            /** @this {!HTMLElement} */ set: function set(inert) {
                inertManager.setInert(this, inert);
            }
        });
    }
})();












class $06e03040259c9616$export$d8dc01b5c85a37b9 {
    constructor(data, options, title_slide, language){
        if (language) this.setLanguage(language);
        // DOM Elements
        this._el = {
            container: {},
            scroll_container: {},
            background: {},
            content_container: {},
            content: {}
        };
        // Components
        this._media = null;
        this._mediaclass = {};
        this._text = {};
        this._background_media = null;
        // State
        this._state = {
            loaded: false
        };
        this.has = {
            headline: false,
            text: false,
            media: false,
            title: false,
            background: {
                image: false,
                color: false,
                color_value: ""
            }
        };
        this.has.title = title_slide;
        // Data
        this.data = {
            unique_id: null,
            background: null,
            start_date: null,
            end_date: null,
            location: null,
            text: null,
            media: null,
            autolink: true
        };
        // Options
        this.options = {
            // animation
            duration: 1000,
            slide_padding_lr: 40,
            ease: (0, $2baebbd96bfe7e6e$export$f7d97b709d0a6c59),
            width: 600,
            height: 600,
            skinny_size: 650,
            media_name: ""
        };
        // Actively Displaying
        this.active = false;
        // Animation Object
        this.animator = {};
        // Merge Data and Options
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.options, options);
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.data, data);
        this._initLayout();
        this._initEvents();
    }
    /*	Adding, Hiding, Showing etc
    ================================================== */ show() {
        this.animator = (0, $92002c55b7773eef$export$83a1293bbde53b95)(this._el.slider_container, {
            left: -(this._el.container.offsetWidth * n) + "px",
            duration: this.options.duration,
            easing: this.options.ease
        });
    }
    hide() {}
    setActive(is_active) {
        this.active = is_active;
        if (this.active) {
            if (this.data.background) this.fire("background_change", this.has.background);
            this._setInteractive(true);
            this.loadMedia();
        } else {
            this.stopMedia();
            this._setInteractive(false);
        }
    }
    addTo(container) {
        container.appendChild(this._el.container);
    //this.onAdd();
    }
    removeFrom(container) {
        container.removeChild(this._el.container);
    }
    updateDisplay(width, height, layout) {
        var content_width, content_padding_left = this.options.slide_padding_lr, content_padding_right = this.options.slide_padding_lr;
        if (width) this.options.width = width;
        else this.options.width = this._el.container.offsetWidth;
        content_width = this.options.width - this.options.slide_padding_lr * 2;
        if ($e8c72613a0980cab$export$1c4e7a9c31a6c071 && this.options.width <= this.options.skinny_size) {
            content_padding_left = 0;
            content_padding_right = 0;
            content_width = this.options.width;
        } else if (layout == "landscape") ;
        else if (this.options.width <= this.options.skinny_size) {
            content_padding_left = 50;
            content_padding_right = 50;
            content_width = this.options.width - content_padding_left - content_padding_right;
        }
        this._el.content.style.paddingLeft = content_padding_left + "px";
        this._el.content.style.paddingRight = content_padding_right + "px";
        this._el.content.style.width = content_width + "px";
        if (height) this.options.height = height;
        else this.options.height = this._el.container.offsetHeight;
        if (this._media) {
            if (!this.has.text && this.has.headline) this._media.updateDisplay(content_width, this.options.height - this._text.headlineHeight(), layout);
            else if (!this.has.text && !this.has.headline) this._media.updateDisplay(content_width, this.options.height, layout);
            else if (this.options.width <= this.options.skinny_size) this._media.updateDisplay(content_width, this.options.height, layout);
            else this._media.updateDisplay(content_width / 2, this.options.height, layout);
        }
        this._updateBackgroundDisplay();
    }
    loadMedia() {
        var self = this;
        if (this._media && !this._state.loaded) {
            this._media.loadMedia();
            this._state.loaded = true;
        }
        if (this._background_media && !this._background_media._state.loaded) {
            this._background_media.on("loaded", function() {
                self._updateBackgroundDisplay();
            });
            this._background_media.loadMedia();
        }
    }
    stopMedia() {
        if (this._media && this._state.loaded) this._media.stopMedia();
    }
    getBackground() {
        return this.has.background;
    }
    scrollToTop() {
        this._el.container.scrollTop = 0;
    }
    getFormattedDate() {
        if ((0, $ea7d21fd242a7c44$export$87c2784dc9fc4ab)(this.data.display_date).length > 0) return this.data.display_date;
        var date_text = "";
        if (!this.has.title) {
            if (this.data.end_date) date_text = " &mdash; " + this.data.end_date.getDisplayDate(this.getLanguage());
            if (this.data.start_date) date_text = this.data.start_date.getDisplayDate(this.getLanguage()) + date_text;
        }
        return date_text;
    }
    /*	Events
    ================================================== */ /*	Private Methods
    ================================================== */ _initLayout() {
        // Create Layout
        this._el.container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-slide");
        if (this.has.title) this._el.container.className = "tl-slide tl-slide-titleslide";
        if (this.data.unique_id) this._el.container.id = this.data.unique_id;
        this._el.scroll_container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-slide-scrollable-container", this._el.container);
        this._el.content_container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-slide-content-container", this._el.scroll_container);
        this._el.content = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-slide-content", this._el.content_container);
        this._el.background = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-slide-background", this._el.container);
        // Style Slide Background
        if (this.data.background) {
            if (this.data.background.url) {
                var media_type = (0, $9122c61f73d8eb13$export$46c3b8b96b580bf5)(this.data.background, true);
                if (media_type) {
                    this._background_media = new media_type.cls(this.data.background, {
                        background: 1
                    });
                    this.has.background.image = true;
                    this._el.container.className += ' tl-full-image-background';
                    this.has.background.color_value = "#000";
                    this._el.background.style.display = "block";
                }
                if (this.data.background.alt) {
                    this._el.background.setAttribute('role', 'img');
                    this._el.background.setAttribute('aria-label', this.data.background.alt);
                }
            }
            if (this.data.background.color) {
                this.has.background.color = true;
                this._el.container.className += ' tl-full-color-background';
                this.has.background.color_value = this.data.background.color;
            //this._el.container.style.backgroundColor = this.data.background.color;
            //this._el.background.style.backgroundColor 	= this.data.background.color;
            //this._el.background.style.display 			= "block";
            }
            if (this.data.background.text_background) this._el.container.className += ' tl-text-background';
        }
        // Determine Assets for layout and loading
        if (this.data.media && this.data.media.url && this.data.media.url != "") this.has.media = true;
        if (this.data.text && this.data.text.text) this.has.text = true;
        if (this.data.text && this.data.text.headline) this.has.headline = true;
        // Create Media
        if (this.has.media) {
            // Determine the media type
            this.data.media.mediatype = (0, $9122c61f73d8eb13$export$46c3b8b96b580bf5)(this.data.media);
            this.options.media_name = this.data.media.mediatype.name;
            this.options.media_type = this.data.media.mediatype.type;
            this.options.autolink = this.data.autolink;
            // Create a media object using the matched class name
            this._media = new this.data.media.mediatype.cls(this.data.media, this.options, this.getLanguage());
        }
        // Create Text
        if (this.has.text || this.has.headline) {
            this._text = new (0, $1c5ef04904e0a0f5$export$5f1af8db9871e1d6)(this.data.text, {
                title: this.has.title,
                language: this.getLanguage(),
                autolink: this.data.autolink
            });
            this._text.addDateText(this.getFormattedDate());
        }
        // Add to DOM
        if (!this.has.text && !this.has.headline && this.has.media) {
            this._el.container.classList.add('tl-slide-media-only');
            this._media.addTo(this._el.content);
        } else if (this.has.headline && this.has.media && !this.has.text) {
            this._el.container.classList.add('tl-slide-media-only');
            this._text.addTo(this._el.content);
            this._media.addTo(this._el.content);
        } else if (this.has.text && this.has.media) {
            this._text.addTo(this._el.content);
            this._media.addTo(this._el.content);
        } else if (this.has.text || this.has.headline) {
            this._el.container.classList.add('tl-slide-text-only');
            this._text.addTo(this._el.content);
        }
        // Fire event that the slide is loaded
        this.onLoaded();
    }
    _initEvents() {}
    _updateBackgroundDisplay() {
        if (this._background_media && this._background_media._state.loaded) this._el.background.style.backgroundImage = "url('" + this._background_media.getImageURL(this.options.width, this.options.height) + "')";
    }
    _setInteractive(is_interactive) {
        if (is_interactive) this._el.container.removeAttribute('inert');
        else this._el.container.setAttribute('inert', true);
    }
}
(0, $ea7d21fd242a7c44$export$c5910a33574a115e)($06e03040259c9616$export$d8dc01b5c85a37b9, (0, $2319cf524e876851$export$222529f9b823899b), (0, $d92d8eaa035c7b70$export$2e2bcd8739ae039), (0, $8948f35b9a5753b9$export$b8c17d0037837cb6));








class $883fa4702ba55013$export$16465c09560404e3 {
    constructor(data, options, add_to_container){
        // DOM ELEMENTS
        this._el = {
            container: {},
            content_container: {},
            icon: {},
            title: {},
            description: {}
        };
        // Media Type
        this.mediatype = {};
        // Data
        this.data = {
            title: "Navigation",
            description: "Description",
            date: "Date"
        };
        //Options
        this.options = {
            direction: "previous"
        };
        this.animator = null;
        // Merge Data and Options
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.options, options);
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.data, data);
        this._el.container = $9eb7ee258fcc7829$export$9b6d6ca62970729f("tl-slidenav-" + this.options.direction);
        if ($e8c72613a0980cab$export$1c4e7a9c31a6c071) this._el.container.setAttribute("ontouchstart", " ");
        this._initLayout();
        this._initEvents();
        if (add_to_container) add_to_container.appendChild(this._el.container);
    }
    /*	Update Content
	================================================== */ update(slide) {
        var d = {
            title: "",
            description: "",
            date: slide.getFormattedDate()
        };
        if (slide.data.text) {
            if (slide.data.text.headline) d.title = slide.data.text.headline;
        }
        this._update(d);
    }
    /*	Color
	================================================== */ setColor(inverted) {
        if (inverted) this._el.content_container.className = 'tl-slidenav-content-container tl-slidenav-inverted';
        else this._el.content_container.className = 'tl-slidenav-content-container';
    }
    /*	Events
	================================================== */ _onMouseClick() {
        this.fire("clicked", this.options);
    }
    /*	Private Methods
	================================================== */ _update(d) {
        // update data
        this.data = (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.data, d);
        // Title
        const title = (0, $ea7d21fd242a7c44$export$8c140248b4280ca1)(this.data.title);
        this._el.title.innerHTML = title;
        // Date
        const date = (0, $ea7d21fd242a7c44$export$8c140248b4280ca1)(this.data.date);
        this._el.description.innerHTML = date;
        // Alternative text
        this._el.container.setAttribute('aria-label', `${this.options.direction}, ${title}, ${date}`);
    }
    _initLayout() {
        // Create Layout
        this._el.content_container = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-slidenav-content-container", this._el.container);
        this._el.icon = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-slidenav-icon", this._el.content_container);
        this._el.title = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-slidenav-title", this._el.content_container);
        this._el.description = $9eb7ee258fcc7829$export$185802fd694ee1f5("div", "tl-slidenav-description", this._el.content_container);
        this._el.icon.innerHTML = "&nbsp;";
        this._update();
    }
    _initEvents() {
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.container, 'click', this._onMouseClick, this);
    }
}
(0, $ea7d21fd242a7c44$export$c5910a33574a115e)($883fa4702ba55013$export$16465c09560404e3, (0, $8948f35b9a5753b9$export$b8c17d0037837cb6), (0, $d92d8eaa035c7b70$export$2e2bcd8739ae039));


class $bda2fe9bb5c443b2$export$fbed8a369e958f75 {
    constructor(elem, data, options, language){
        if (language) this.setLanguage(language);
        // DOM ELEMENTS
        this._el = {
            container: {},
            background: {},
            slider_container_mask: {},
            slider_container: {},
            slider_item_container: {}
        };
        this._nav = {};
        this._nav.previous = {};
        this._nav.next = {};
        // Slide Spacing
        this.slide_spacing = 0;
        // Slides Array
        this._slides = [];
        // Swipe Object
        this._swipable;
        // Preload Timer
        this.preloadTimer;
        // Message
        this._message;
        // Current Slide
        this.current_id = '';
        // Data Object
        this.data = {};
        this.options = {
            id: "",
            layout: "portrait",
            width: 600,
            height: 600,
            default_bg_color: {
                r: 255,
                g: 255,
                b: 255
            },
            slide_padding_lr: 40,
            start_at_slide: 1,
            slide_default_fade: "0%",
            // animation
            duration: 1000,
            ease: (0, $2baebbd96bfe7e6e$export$40df750f1044ce5e),
            // interaction
            dragging: true,
            trackResize: true
        };
        // Main element ID
        if (typeof elem === 'object') {
            this._el.container = elem;
            this.options.id = (0, $ea7d21fd242a7c44$export$b40aeedae59b59d1)(6, "tl");
        } else {
            this.options.id = elem;
            this._el.container = $9eb7ee258fcc7829$export$3988ae62b71be9a3(elem);
        }
        if (!this._el.container.id) this._el.container.id = this.options.id;
        // Animation Object
        this.animator = null;
        // Merge Data and Options
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.options, options);
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.data, data);
    }
    init() {
        this._initLayout();
        this._initEvents();
        this._initData();
        this.updateDisplay();
        // Go to initial slide
        this.goTo(this.options.start_at_slide);
        this._onLoaded();
    }
    /* Slides
    ================================================== */ _addSlide(slide) {
        slide.addTo(this._el.slider_item_container);
        slide.on('added', this._onSlideAdded, this);
        slide.on('background_change', this._onBackgroundChange, this);
    }
    _createSlide(d, title_slide, n) {
        var slide = new (0, $06e03040259c9616$export$d8dc01b5c85a37b9)(d, this.options, title_slide, this.getLanguage());
        this._addSlide(slide);
        if (n < 0) this._slides.push(slide);
        else this._slides.splice(n, 0, slide);
    }
    _createSlides(array) {
        for(var i = 0; i < array.length; i++){
            if (array[i].unique_id == "") array[i].unique_id = (0, $ea7d21fd242a7c44$export$b40aeedae59b59d1)(6, "tl-slide");
            this._createSlide(array[i], false, -1);
        }
    }
    _removeSlide(slide) {
        slide.removeFrom(this._el.slider_item_container);
        slide.off('added', this._onSlideRemoved, this);
        slide.off('background_change', this._onBackgroundChange);
    }
    _destroySlide(n) {
        this._removeSlide(this._slides[n]);
        this._slides.splice(n, 1);
    }
    _findSlideIndex(n) {
        var _n = n;
        if (typeof n == 'string' || n instanceof String) _n = (0, $ea7d21fd242a7c44$export$c4632a8493ebcf7d)(n, this._slides, "unique_id");
        return _n;
    }
    /*	Public
    ================================================== */ updateDisplay(width, height, animate, layout) {
        var nav_pos, _layout;
        if (typeof layout === 'undefined') _layout = this.options.layout;
        else _layout = layout;
        this.options.layout = _layout;
        if (width) this.options.width = width;
        else this.options.width = this._el.container.offsetWidth;
        if (height) this.options.height = height;
        else this.options.height = this._el.container.offsetHeight;
        this.slide_spacing = this.options.width * 2;
        // position navigation
        nav_pos = this.options.height / 2;
        this._nav.next.setPosition({
            top: nav_pos
        });
        this._nav.previous.setPosition({
            top: nav_pos
        });
        // Position slides
        for(var i = 0; i < this._slides.length; i++){
            this._slides[i].updateDisplay(this.options.width, this.options.height, _layout);
            this._slides[i].setPosition({
                left: this.slide_spacing * i,
                top: 0
            });
        }
        // Go to the current slide
        this.goToId(this.current_id, true, true);
    }
    // Create a slide
    createSlide(d, n) {
        this._createSlide(d, false, n);
    }
    // Create Many Slides from an array
    createSlides(array) {
        this._createSlides(array);
    }
    // Destroy slide by index
    destroySlide(n) {
        this._destroySlide(n);
    }
    // Destroy slide by id
    destroySlideId(id) {
        this.destroySlide(this._findSlideIndex(id));
    }
    /*	Navigation
    ================================================== */ goTo(n, fast, displayupdate) {
        n = parseInt(n);
        if (isNaN(n)) n = 0;
        var self = this;
        this.changeBackground({
            color_value: "",
            image: false
        });
        // Clear Preloader Timer
        if (this.preloadTimer) clearTimeout(this.preloadTimer);
        // Set Slide Active State
        for(var i = 0; i < this._slides.length; i++)this._slides[i].setActive(false);
        if (n < this._slides.length && n >= 0) {
            this.current_id = this._slides[n].data.unique_id;
            // Stop animation
            if (this.animator) this.animator.stop();
            if (this._swipable) this._swipable.stopMomentum();
            if (fast) {
                this._el.slider_container.style.left = -(this.slide_spacing * n) + "px";
                this._onSlideChange(displayupdate);
            } else this.animator = (0, $92002c55b7773eef$export$83a1293bbde53b95)(this._el.slider_container, {
                left: -(this.slide_spacing * n) + "px",
                duration: this.options.duration,
                easing: this.options.ease,
                complete: this._onSlideChange(displayupdate)
            });
            // Set Slide Active State
            this._slides[n].setActive(true);
            // Update Navigation and Info
            if (this._slides[n + 1]) {
                this.showNav(this._nav.next, true);
                this._nav.next.update(this._slides[n + 1]);
            } else this.showNav(this._nav.next, false);
            if (this._slides[n - 1]) {
                this.showNav(this._nav.previous, true);
                this._nav.previous.update(this._slides[n - 1]);
            } else this.showNav(this._nav.previous, false);
            // Preload Slides
            this.preloadTimer = setTimeout(function() {
                self.preloadSlides(n);
            }, this.options.duration);
        }
    }
    goToId(id, fast, displayupdate) {
        this.goTo(this._findSlideIndex(id), fast, displayupdate);
    }
    preloadSlides(n) {
        if (this._slides[n + 1]) {
            this._slides[n + 1].loadMedia();
            this._slides[n + 1].scrollToTop();
        }
        if (this._slides[n + 2]) {
            this._slides[n + 2].loadMedia();
            this._slides[n + 2].scrollToTop();
        }
        if (this._slides[n - 1]) {
            this._slides[n - 1].loadMedia();
            this._slides[n - 1].scrollToTop();
        }
        if (this._slides[n - 2]) {
            this._slides[n - 2].loadMedia();
            this._slides[n - 2].scrollToTop();
        }
    }
    next() {
        var n = this._findSlideIndex(this.current_id);
        if (n + 1 < this._slides.length) this.goTo(n + 1);
        else this.goTo(n);
    }
    previous() {
        var n = this._findSlideIndex(this.current_id);
        if (n - 1 >= 0) this.goTo(n - 1);
        else this.goTo(n);
    }
    showNav(nav_obj, show) {
        if (this.options.width <= 500 && $e8c72613a0980cab$export$1c4e7a9c31a6c071) nav_obj.hide();
        else if (show) nav_obj.show();
        else nav_obj.hide();
    }
    changeBackground(bg) {
        var bg_color = {
            r: 256,
            g: 256,
            b: 256
        }, bg_color_rgb;
        if (bg.color_value && bg.color_value != "") {
            bg_color = (0, $ea7d21fd242a7c44$export$5a544e13ad4e1fa5)(bg.color_value);
            if (!bg_color) {
                (0, $ea7d21fd242a7c44$export$357889f174732d38)("Invalid color value " + bg.color_value);
                bg_color = this.options.default_bg_color;
            }
        } else {
            bg_color = this.options.default_bg_color;
            bg.color_value = "rgb(" + bg_color.r + " , " + bg_color.g + ", " + bg_color.b + ")";
        }
        bg_color_rgb = bg_color.r + "," + bg_color.g + "," + bg_color.b;
        this._el.background.style.backgroundImage = "none";
        if (bg.color_value) this._el.background.style.backgroundColor = bg.color_value;
        else this._el.background.style.backgroundColor = "transparent";
        if (bg_color.r < 255 || bg_color.g < 255 || bg_color.b < 255 || bg.image) {
            this._nav.next.setColor(true);
            this._nav.previous.setColor(true);
        } else {
            this._nav.next.setColor(false);
            this._nav.previous.setColor(false);
        }
    }
    /*	Private Methods
        ================================================== */ // Update Display
    // Reposition and redraw slides
    _updateDrawSlides() {
        var _layout = this.options.layout;
        for(var i = 0; i < this._slides.length; i++){
            this._slides[i].updateDisplay(this.options.width, this.options.height, _layout);
            this._slides[i].setPosition({
                left: this.slide_spacing * i,
                top: 0
            });
        }
        this.goToId(this.current_id, true, false);
    }
    /*	Init
    ================================================== */ _initLayout() {
        this._el.container.classList.add('tl-storyslider');
        // Create Navigation
        this._nav.previous = new (0, $883fa4702ba55013$export$16465c09560404e3)({
            title: "Previous",
            description: "description"
        }, {
            direction: "previous"
        }, this._el.container);
        this._nav.next = new (0, $883fa4702ba55013$export$16465c09560404e3)({
            title: "Next",
            description: "description"
        }, {
            direction: "next"
        }, this._el.container);
        // Create Layout
        this._el.slider_container_mask = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-slider-container-mask', this._el.container);
        this._el.background = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-slider-background tl-animate', this._el.container);
        this._el.slider_container = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-slider-container tlanimate', this._el.slider_container_mask);
        this._el.slider_item_container = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-slider-item-container', this._el.slider_container);
        // Add aria-live polite to slide_container
        this._el.slider_container.setAttribute('aria-live', 'polite');
        // Update Size
        this.options.width = this._el.container.offsetWidth;
        this.options.height = this._el.container.offsetHeight;
        this._el.slider_container.style.left = "0px";
        if ($e8c72613a0980cab$export$d0b7ea69ab6056df) {
            //this._el.slider_touch_mask = DOM.create('div', 'tl-slider-touch-mask', this._el.slider_container_mask);
            this._swipable = new (0, $1c262bf4756176a8$export$2e2bcd8739ae039)(this._el.slider_container_mask, this._el.slider_container, {
                enable: {
                    x: true,
                    y: false
                },
                snap: true
            });
            this._swipable.enable();
            // Message
            this._message = new (0, $c47270e117695841$export$2e2bcd8739ae039)(this._el.container, {
                message_class: "tl-message-full",
                message_icon_class: "tl-icon-swipe-left"
            }, this.getLanguage());
            this._message.updateMessage(this._("swipe_to_navigate"));
            this._message.addTo(this._el.container);
        }
    }
    _initEvents() {
        this._nav.next.on('clicked', this._onNavigation, this);
        this._nav.previous.on('clicked', this._onNavigation, this);
        if (this._message) this._message.on('clicked', this._onMessageClick, this);
        if (this._swipable) {
            this._swipable.on('swipe_left', this._onNavigation, this);
            this._swipable.on('swipe_right', this._onNavigation, this);
            this._swipable.on('swipe_nodirection', this._onSwipeNoDirection, this);
        }
    }
    _initData() {
        if (this.data.title) this._createSlide(this.data.title, true, -1);
        this._createSlides(this.data.events);
    }
    /*	Events
    ================================================== */ _onBackgroundChange(e) {
        var n = this._findSlideIndex(this.current_id);
        var slide_background = this._slides[n].getBackground();
        this.changeBackground(e);
        this.fire("colorchange", slide_background);
    }
    _onMessageClick(e) {
        this._message.hide();
    }
    _onSwipeNoDirection(e) {
        this.goToId(this.current_id);
    }
    _onNavigation(e) {
        if (e.direction == "next" || e.direction == "left") this.next();
        else if (e.direction == "previous" || e.direction == "right") this.previous();
        this.fire("nav_" + e.direction, this.data);
    }
    _onSlideAdded(e) {
        (0, $ea7d21fd242a7c44$export$357889f174732d38)("slideadded");
        this.fire("slideAdded", this.data);
    }
    _onSlideRemoved(e) {
        this.fire("slideRemoved", this.data);
    }
    _onSlideChange(displayupdate) {
        if (!displayupdate) this.fire("change", {
            unique_id: this.current_id
        });
    }
    _onMouseClick(e) {}
    _fireMouseEvent(e) {
        if (!this._loaded) return;
        var type = e.type;
        type = type === 'mouseenter' ? 'mouseover' : type === 'mouseleave' ? 'mouseout' : type;
        if (!this.hasEventListeners(type)) return;
        if (type === 'contextmenu') (0, $7d599a41227e2243$export$196e5b15bdb52968).preventDefault(e);
        this.fire(type, {
            latlng: "something",
            layerPoint: "something else" //this.mouseEventToLayerPoint(e)
        });
    }
    _onLoaded() {
        this.fire("loaded", this.data);
    }
}
(0, $ea7d21fd242a7c44$export$c5910a33574a115e)($bda2fe9bb5c443b2$export$fbed8a369e958f75, (0, $2319cf524e876851$export$222529f9b823899b), (0, $d92d8eaa035c7b70$export$2e2bcd8739ae039));










class $21f81503d687c40d$export$11a6fe490bbc4873 {
    constructor(elem, parent_elem, options, language){
        // DOM ELEMENTS
        this._el = {
            parent: {},
            container: {},
            button_forwardtoend: {},
            button_backtostart: {},
            button_zoomin: {},
            button_zoomout: {},
            arrow: {},
            line: {},
            coverbar: {},
            grip: {}
        };
        this.collapsed = false;
        if (typeof elem === 'object') this._el.container = elem;
        else this._el.container = $9eb7ee258fcc7829$export$3988ae62b71be9a3(elem);
        if (parent_elem) this._el.parent = parent_elem;
        // Data
        this.data = {
            visible_ticks_dates: {}
        };
        //Options
        this.options = {
            width: 600,
            height: 600,
            duration: 1000,
            ease: (0, $2baebbd96bfe7e6e$export$40df750f1044ce5e),
            menubar_default_y: 0
        };
        // Animation
        this.animator = {};
        this.setLanguage(language);
        // Merge Data and Options
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.options, options);
        this._initLayout();
        this._initEvents();
    }
    /*	Public
    ================================================== */ show(d) {
        var duration = this.options.duration;
        if (d) duration = d;
    }
    hide(top) {}
    toogleZoomIn(show) {
        if (show) this._el.button_zoomin.removeAttribute('disabled');
        else this._el.button_zoomin.setAttribute('disabled', true);
    }
    toogleZoomOut(show) {
        if (show) this._el.button_zoomout.removeAttribute('disabled');
        else this._el.button_zoomout.setAttribute('disabled', true);
    }
    changeVisibleTicks(visible_ticks) {
        const minor_ticks = visible_ticks.minor;
        if (!minor_ticks.length) {
            this.data.visible_ticks_dates = {};
            return;
        }
        const firstTick = minor_ticks[0];
        const firstYear = firstTick.date.getFullYear();
        const lastTick = minor_ticks[minor_ticks.length - 1];
        const lastYear = lastTick.date.getFullYear();
        this.data.visible_ticks_dates = {
            start: firstYear,
            end: lastYear
        };
        this._updateZoomAriaLabels();
    }
    setSticky(y) {
        this.options.menubar_default_y = y;
    }
    /*	Color
    ================================================== */ setColor(inverted) {
        if (inverted) this._el.container.className = 'tl-menubar tl-menubar-inverted';
        else this._el.container.className = 'tl-menubar';
    }
    /*	Update Display
    ================================================== */ updateDisplay(w, h, a, l) {
        this._updateDisplay(w, h, a, l);
    }
    /*	Events
    ================================================== */ _onButtonZoomIn(e) {
        this.fire("zoom_in", e);
    }
    _onButtonZoomOut(e) {
        this.fire("zoom_out", e);
    }
    _onButtonForwardToEnd(e) {
        this.fire("forward_to_end", e);
    }
    _onButtonBackToStart(e) {
        this.fire("back_to_start", e);
    }
    /*	Private Methods
    ================================================== */ _initLayout() {
        // Create Layout
        this._el.button_zoomin = $9eb7ee258fcc7829$export$9b6d6ca62970729f('tl-menubar-button', this._el.container);
        this._el.button_zoomout = $9eb7ee258fcc7829$export$9b6d6ca62970729f('tl-menubar-button', this._el.container);
        this._el.button_forwardtoend = $9eb7ee258fcc7829$export$9b6d6ca62970729f('tl-menubar-button', this._el.container);
        this._el.button_backtostart = $9eb7ee258fcc7829$export$9b6d6ca62970729f('tl-menubar-button', this._el.container);
        if ($e8c72613a0980cab$export$1c4e7a9c31a6c071) this._el.container.setAttribute("ontouchstart", " ");
        this._el.button_backtostart.innerHTML = "<span class='tl-icon-goback'></span>";
        this._el.button_backtostart.setAttribute('aria-label', this._('return_to_title'));
        this._el.button_forwardtoend.innerHTML = "<span class='tl-icon-goend'></span>";
        this._el.button_forwardtoend.setAttribute('aria-label', this._('go_to_end'));
        this._el.button_zoomin.innerHTML = "<span class='tl-icon-zoom-in'></span>";
        this._el.button_zoomin.setAttribute('aria-label', this._('zoom_in'));
        this._el.button_zoomout.innerHTML = "<span class='tl-icon-zoom-out'></span>";
        this._el.button_zoomout.setAttribute('aria-label', this._('zoom_out'));
    }
    _initEvents() {
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.button_forwardtoend, 'click', this._onButtonForwardToEnd, this);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.button_backtostart, 'click', this._onButtonBackToStart, this);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.button_zoomin, 'click', this._onButtonZoomIn, this);
        (0, $7d599a41227e2243$export$196e5b15bdb52968).addListener(this._el.button_zoomout, 'click', this._onButtonZoomOut, this);
    }
    // Update Display
    _updateDisplay(width, height, animate) {
        if (width) this.options.width = width;
        if (height) this.options.height = height;
    }
    // Update Display
    _updateZoomAriaLabels() {
        if (Object.keys(this.data.visible_ticks_dates).length == 0) {
            this._el.button_zoomin.setAttribute('aria-description', '');
            this._el.button_zoomout.setAttribute('aria-description', '');
        } else {
            this._el.button_zoomin.setAttribute('aria-description', this._("aria_label_zoomin", this.data.visible_ticks_dates));
            this._el.button_zoomout.setAttribute('aria-description', this._("aria_label_zoomout", this.data.visible_ticks_dates));
        }
    }
}
(0, $ea7d21fd242a7c44$export$c5910a33574a115e)($21f81503d687c40d$export$11a6fe490bbc4873, (0, $8948f35b9a5753b9$export$b8c17d0037837cb6), (0, $d92d8eaa035c7b70$export$2e2bcd8739ae039), (0, $2319cf524e876851$export$222529f9b823899b));



let $8112dcaee14ab84c$var$script_src_url = null;
if (document) {
    let script_tags = document.getElementsByTagName('script');
    if (script_tags && script_tags.length > 0) $8112dcaee14ab84c$var$script_src_url = script_tags[script_tags.length - 1].src;
}
function $8112dcaee14ab84c$var$make_keydown_handler(timeline) {
    return function(event) {
        if (timeline.config) {
            var keyName = event.key;
            var currentSlide = timeline._getSlideIndex(self.current_id);
            var _n = timeline.config.events.length - 1;
            var lastSlide = timeline.config.title ? _n + 1 : _n;
            var firstSlide = 0;
            if (keyName == 'ArrowLeft') {
                if (currentSlide != firstSlide) timeline.goToPrev();
            } else if (keyName == 'ArrowRight') {
                if (currentSlide != lastSlide) timeline.goToNext();
            }
        }
    };
}
/**
 * Primary entry point for using TimelineJS.
 * @constructor
 * @param {HTMLElement|string} elem - the HTML element, or its ID, to which 
 *     the Timeline should be bound
 * @param {object|String} - a JavaScript object conforming to the TimelineJS
 *     configuration format, or a String which is the URL for a Google Sheets document
 *     or JSON configuration file which Timeline will retrieve and parse into a JavaScript object.
 *     NOTE: do not pass a JSON String for this. TimelineJS doesn't try to distinguish a 
 *     JSON string from a URL string. If you have a JSON String literal, parse it using
 *     `JSON.parse` before passing it to the constructor.
 *
 * @param {object} [options] - a JavaScript object specifying 
 *     presentation options
 */ class $8112dcaee14ab84c$export$e6a97ba2cae5bb94 {
    constructor(elem, data, options){
        if (!options) options = {};
        this.ready = false;
        this._el = {
            container: $9eb7ee258fcc7829$export$3988ae62b71be9a3(elem),
            storyslider: {},
            timenav: {},
            menubar: {}
        };
        if (options.lang && !options.language) options.language = options.lang;
        /** @type {Language} */ this.language = (0, $3bd1753d03e195ea$export$bcd1dd1f397bba12);
        /** @type {StorySlider} */ this._storyslider = {};
        /** @type {TimeNav} */ this._timenav = {};
        /** @type {MenuBar} */ this._menubar = {};
        // Loaded State
        this._loaded = {
            storyslider: false,
            timenav: false
        };
        /** @type {TimelineConfig} */ this.config = null;
        this.options = {
            script_path: "https://cdn.knightlab.com/libs/timeline3/latest/js/",
            height: this._el.container.offsetHeight,
            width: this._el.container.offsetWidth,
            debug: false,
            font: 'default',
            is_embed: false,
            is_full_embed: false,
            hash_bookmark: false,
            default_bg_color: {
                r: 255,
                g: 255,
                b: 255
            },
            scale_factor: 2,
            layout: "landscape",
            timenav_position: "bottom",
            optimal_tick_width: 60,
            base_class: "tl-timeline",
            timenav_height: null,
            timenav_height_percentage: 25,
            timenav_mobile_height_percentage: 40,
            timenav_height_min: 175,
            marker_height_min: 30,
            marker_width_min: 100,
            marker_padding: 5,
            start_at_slide: 0,
            start_at_end: false,
            menubar_height: 0,
            skinny_size: 650,
            medium_size: 800,
            use_bc: false,
            // animation
            duration: 1000,
            ease: (0, $2baebbd96bfe7e6e$export$40df750f1044ce5e),
            // interaction
            dragging: true,
            trackResize: true,
            map_type: "stamen:toner-lite",
            slide_padding_lr: 100,
            slide_default_fade: "0%",
            zoom_sequence: [
                0.5,
                1,
                2,
                3,
                5,
                8,
                13,
                21,
                34,
                55,
                89
            ],
            language: "en",
            ga_measurement_id: null,
            ga_property_id: null,
            track_events: [
                'back_to_start',
                'nav_next',
                'nav_previous',
                'zoom_in',
                'zoom_out'
            ],
            theme: null,
            // sheets_proxy value should be suitable for simply postfixing with the Google Sheets CSV URL
            // as in include trailing slashes, or '?url=' or whatever. No support right now for anything but
            // postfixing. The default proxy should work in most cases, but only for TimelineJS sheets.
            sheets_proxy: 'https://sheets-proxy.knightlab.com/proxy/',
            soundcite: false
        };
        // Animation Objects
        this.animator_timenav = null;
        this.animator_storyslider = null;
        this.animator_menubar = null;
        // Ideally we'd set the language here, but we're bootstrapping and may hit problems
        // before we're able to load it. if it weren't a remote resource, we could probably 
        // do it.
        this.message = new (0, $c47270e117695841$export$2e2bcd8739ae039)(this._el.container, {
            message_class: "tl-message-full"
        });
        // Merge Options
        if (typeof options.default_bg_color == "string") {
            var parsed = (0, $ea7d21fd242a7c44$export$5a544e13ad4e1fa5)(options.default_bg_color); // will clear it out if its invalid
            if (parsed) options.default_bg_color = parsed;
            else {
                delete options.default_bg_color;
                (0, $ea7d21fd242a7c44$export$357889f174732d38)("Invalid default background color. Ignoring.");
            }
        }
        (0, $ea7d21fd242a7c44$export$696bf4df45a0ddde)(this.options, options);
        if (!this.options.script_path) this.options.script_path = this.determineScriptPath();
        if (options.soundcite) this.on('ready', ()=>{
            (0, $ea7d21fd242a7c44$export$357889f174732d38)("Loading Soundcite resources ");
            (0, $6ba50b95af76efe0$export$5c4fe40904b85610)('https://cdn.knightlab.com/libs/soundcite/latest/css/player.css');
            (0, $6ba50b95af76efe0$export$93b33d367be6802b)('https://cdn.knightlab.com/libs/soundcite/latest/js/soundcite.min.js');
        });
        // load font, theme
        this._loadStyles();
        document.addEventListener("keydown", $8112dcaee14ab84c$var$make_keydown_handler(this));
        window.addEventListener("resize", (function(e) {
            this.updateDisplay();
        }).bind(this));
        if (this.options.debug) (0, $ea7d21fd242a7c44$export$611560a6d0a92d9e)(console.log);
        // Apply base class to container
        this._el.container.classList.add('tl-timeline');
        this._el.container.setAttribute('tabindex', '0');
        this._el.container.setAttribute('role', 'region');
        this._el.container.setAttribute('aria-label', this._('aria_label_timeline'));
        if (this.options.is_embed) this._el.container.classList.add('tl-timeline-embed');
        if (this.options.is_full_embed) this._el.container.classList.add('tl-timeline-full-embed');
        this._loadLanguage(data);
    }
    _loadStyles() {
        let font_css_url = null, theme_css_url = null;
        if (this.options.font && (this.options.font.indexOf('http') == 0 || this.options.font.match(/\.css$/))) font_css_url = this.options.font;
        else if (this.options.font) {
            let fragment = '../css/fonts/font.' + this.options.font.toLowerCase() + '.css';
            font_css_url = new URL(fragment, this.options.script_path).toString();
        }
        if (font_css_url) (0, $6ba50b95af76efe0$export$5c4fe40904b85610)(font_css_url);
        if (this.options.theme && (this.options.theme.indexOf('http') == 0 || this.options.theme.match(/\.css$/))) theme_css_url = this.options.theme;
        else if (this.options.theme) {
            let fragment = '../css/themes/timeline.theme.' + this.options.theme.toLowerCase() + '.css';
            theme_css_url = new URL(fragment, this.options.script_path).toString();
        }
        if (theme_css_url) (0, $6ba50b95af76efe0$export$5c4fe40904b85610)(theme_css_url);
    }
    _loadLanguage(data) {
        try {
            var lang = this.options.language;
            var script_path = this.options.script_path;
            (0, $3bd1753d03e195ea$export$f02cbd868e2f57cf)(lang, script_path).then((language)=>{
                if (language) {
                    this.language = language;
                    this.message.setLanguage(this.language);
                    this.showMessage(this._('loading_timeline'));
                } else this.showMessage(`Error loading ${lang}`) // but we will carry on using the fallback
                ;
                this._initData(data);
            });
        } catch (e) {
            this.showMessage(this._translateError(e));
        }
    }
    /**
     * Initialize the data for this timeline. If data is a URL, pass it to ConfigFactory
     * to get a TimelineConfig; if data is a TimelineConfig, just use it; otherwise, 
     * assume it's a JSON object in the right format, and wrap it in a new TimelineConfig.
     * @param {string|TimelineConfig|object} data
     */ _initData(data) {
        if (typeof data == 'string') (0, $ce175c6e1ee59955$export$38ad3c7c789c7fed)(data, {
            callback: (function(config) {
                this.setConfig(config);
            }).bind(this),
            sheets_proxy: this.options.sheets_proxy
        });
        else if ((0, $8849a36019263cbd$export$9e1cf9dd451bce3a) == data.constructor) this.setConfig(data);
        else this.setConfig(new (0, $8849a36019263cbd$export$9e1cf9dd451bce3a)(data));
    }
    /**
     * Given an input, if it is a Timeline Error object, look up the
     * appropriate error in the current language and return it, optionally 
     * with detail that also comes in the object. Alternatively, pass back
     * the input, which is expected to be a string ready to display.
     * @param {Error|string} e - an Error object which can be localized, 
     *     or a string message
     */ _translateError(e) {
        if (e.hasOwnProperty('stack')) (0, $ea7d21fd242a7c44$export$357889f174732d38)(e.stack);
        if (e.message_key) return this._(e.message_key) + (e.detail ? ' [' + e.detail + ']' : '');
        return e;
    }
    /**
     * Display a message in the Timeline window.
     * @param {string} msg 
     */ showMessage(msg) {
        if (this.message) this.message.updateMessage(msg);
        else {
            (0, $ea7d21fd242a7c44$export$357889f174732d38)("No message display available.");
            (0, $ea7d21fd242a7c44$export$357889f174732d38)(msg);
        }
    }
    /**
         * Not ideal, but if users don't specify the script path, we try to figure it out.
         * The script path is needed to load other languages
         */ determineScriptPath() {
        let src = null;
        if ($8112dcaee14ab84c$var$script_src_url) src = $8112dcaee14ab84c$var$script_src_url;
        else {
            let script_tag = document.getElementById('timeline-script-tag');
            if (script_tag) src = script_tag.src;
        }
        if (!src) {
            let script_tags = document.getElementsByTagName('script');
            for(let index = script_tags.length - 1; index >= 0; index--)if (script_tags[index].src) {
                src = script_tags[index].src;
                break; // if we haven't found anything else, use the latest loaded script
            }
        }
        if (src) // +1 to include the trailing slash or concatting for dynamic CSS load won't work.
        return src.substr(0, src.lastIndexOf('/') + 1);
        return '';
    }
    setConfig(config) {
        this.config = config;
        if (this.config.isValid()) {
            // don't validate if it's already problematic to avoid clutter
            this.config.validate();
            this._validateOptions();
        }
        if (this.config.isValid()) try {
            if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this._onDataLoaded.bind(this));
            else this._onDataLoaded();
        } catch (e) {
            this.showMessage("<strong>" + this._('error') + ":</strong> " + this._translateError(e));
        }
        else {
            var translated_errs = [];
            for(var i = 0, errs = this.config.getErrors(); i < errs.length; i++)translated_errs.push(this._translateError(errs[i]));
            this.showMessage("<strong>" + this._('error') + ":</strong> " + translated_errs.join('<br>'));
        // should we set 'self.ready'? if not, it won't resize,
        // but most resizing would only work
        // if more setup happens
        }
    }
    _onDataLoaded() {
        this.fire("dataloaded");
        this._initLayout();
        this._initEvents();
        this._initAnalytics();
        if (this.message) this.message.hide();
        let callback = (entries, observer)=>{
            if (entries.reduce((accum, curr)=>accum || curr.isIntersecting, false)) this.updateDisplay();
        };
        let observer = new IntersectionObserver(callback.bind(this));
        observer.observe(this._el.container);
        this.ready = true;
        this.fire("ready");
    }
    _initLayout() {
        this.message.removeFrom(this._el.container);
        this._el.container.innerHTML = "";
        // Create Layout
        if (this.options.timenav_position == "top") {
            this._el.timenav = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-timenav', this._el.container);
            this._el.menubar = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-menubar', this._el.container);
            this._el.storyslider = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-storyslider', this._el.container);
        } else {
            this._el.storyslider = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-storyslider', this._el.container);
            this._el.timenav = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-timenav', this._el.container);
            this._el.menubar = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-menubar', this._el.container);
        }
        // Knight Lab Logo
        this._el.attribution = $9eb7ee258fcc7829$export$185802fd694ee1f5('div', 'tl-attribution', this._el.container);
        this._el.attribution.innerHTML = "<a href='https://timeline.knightlab.com' target='_blank' rel='noopener'><span class='tl-knightlab-logo'></span>TimelineJS</a>";
        // Initial Default Layout
        this.options.width = this._el.container.offsetWidth;
        this.options.height = this._el.container.offsetHeight;
        // this._el.storyslider.style.top  = "1px";
        // Set TimeNav Height
        this.options.timenav_height = this._calculateTimeNavHeight(this.options.timenav_height);
        // Create TimeNav
        this._timenav = new (0, $93ce4eb99ac55aa1$export$5b0c8a6e1a376125)(this._el.timenav, this.config, this.options, this.language);
        this._timenav.on('loaded', this._onTimeNavLoaded, this);
        this._timenav.options.height = this.options.timenav_height;
        this._timenav.init();
        // intial_zoom cannot be applied before the timenav has been created
        if (this.options.initial_zoom) // at this point, this.options refers to the merged set of options
        this.setZoom(this.options.initial_zoom);
        // Create StorySlider
        this._storyslider = new (0, $bda2fe9bb5c443b2$export$fbed8a369e958f75)(this._el.storyslider, this.config, this.options, this.language);
        this._el.storyslider.setAttribute('role', 'group');
        this._el.storyslider.setAttribute('aria-label', this._('aria_label_timeline_content'));
        this._storyslider.on('loaded', this._onStorySliderLoaded, this);
        this._storyslider.init();
        // Create Menu Bar
        this._menubar = new (0, $21f81503d687c40d$export$11a6fe490bbc4873)(this._el.menubar, this._el.container, this.options, this.getLanguage());
        // LAYOUT
        if (this.options.layout == "portrait") this.options.storyslider_height = this.options.height - this.options.timenav_height - 1;
        else this.options.storyslider_height = this.options.height - 1;
        // Update Display
        this._updateDisplay(this._timenav.options.height, true, 2000);
    }
    _initEvents() {
        // TimeNav Events
        this._timenav.on('change', this._onTimeNavChange, this);
        this._timenav.on('zoomtoggle', this._onZoomToggle, this);
        this._timenav.on('visible_ticks_change', this._onVisibleTicksChange, this);
        // StorySlider Events
        this._storyslider.on('change', this._onSlideChange, this);
        this._storyslider.on('colorchange', this._onColorChange, this);
        this._storyslider.on('nav_next', this._onStorySliderNext, this);
        this._storyslider.on('nav_previous', this._onStorySliderPrevious, this);
        // Menubar Events
        this._menubar.on('zoom_in', this._onZoomIn, this);
        this._menubar.on('zoom_out', this._onZoomOut, this);
        this._menubar.on('forward_to_end', this._onForwardToEnd, this);
        this._menubar.on('back_to_start', this._onBackToStart, this);
    }
    _onColorChange(e) {
        this.fire("color_change", {
            unique_id: this.current_id
        }, this);
    }
    _onSlideChange(e) {
        if (this.current_id != e.unique_id) {
            this.current_id = e.unique_id;
            this._timenav.goToId(this.current_id);
            this._onChange(e);
        }
    }
    _onTimeNavChange(e) {
        if (this.current_id != e.unique_id) {
            this.current_id = e.unique_id;
            this._storyslider.goToId(this.current_id);
            this._onChange(e);
        }
    }
    _onZoomToggle(e) {
        if (e.zoom == "in") this._menubar.toogleZoomIn(e.show);
        else if (e.zoom == "out") this._menubar.toogleZoomOut(e.show);
    }
    _onChange(e) {
        this.fire("change", {
            unique_id: this.current_id
        }, this);
        if (this.options.hash_bookmark && this.current_id) this._updateHashBookmark(this.current_id);
    }
    _onVisibleTicksChange(e) {
        this._menubar.changeVisibleTicks(e.visible_ticks);
    }
    _onForwardToEnd(e) {
        this.goToEnd();
        this.fire("forward_to_end", {
            unique_id: this.current_id
        }, this);
    }
    _onBackToStart(e) {
        this.goToStart();
        this.fire("back_to_start", {
            unique_id: this.current_id
        }, this);
    }
    _onZoomIn(e) {
        this._timenav.zoomIn();
        this.fire("zoom_in", {
            zoom_level: this._timenav.options.scale_factor
        }, this);
    }
    _onZoomOut(e) {
        this._timenav.zoomOut();
        this.fire("zoom_out", {
            zoom_level: this._timenav.options.scale_factor
        }, this);
    }
    _onTimeNavLoaded() {
        this._loaded.timenav = true;
        this._onLoaded();
    }
    _onStorySliderLoaded() {
        this._loaded.storyslider = true;
        this._onLoaded();
    }
    _onStorySliderNext(e) {
        this.fire("nav_next", e);
    }
    _onStorySliderPrevious(e) {
        this.fire("nav_previous", e);
    }
    _updateDisplay(timenav_height, animate, d) {
        var duration = this.options.duration, display_class = this.options.base_class, menu_position = 0, self1 = this;
        if (d) duration = d;
        // Update width and height
        this.options.width = this._el.container.offsetWidth;
        this.options.height = this._el.container.offsetHeight;
        // Check if skinny
        if (this.options.width <= this.options.skinny_size) {
            display_class += " tl-skinny";
            this.options.layout = "portrait";
        } else if (this.options.width <= this.options.medium_size) {
            display_class += " tl-medium";
            this.options.layout = "landscape";
        } else this.options.layout = "landscape";
        // Detect Mobile and Update Orientation on Touch devices
        if ($e8c72613a0980cab$export$d0b7ea69ab6056df) this.options.layout = $e8c72613a0980cab$export$b363cb15cbb91a1a();
        if ($e8c72613a0980cab$export$1c4e7a9c31a6c071) {
            display_class += " tl-mobile";
            // Set TimeNav Height
            this.options.timenav_height = this._calculateTimeNavHeight(timenav_height, this.options.timenav_mobile_height_percentage);
        } else // Set TimeNav Height
        this.options.timenav_height = this._calculateTimeNavHeight(timenav_height);
        // LAYOUT
        if (this.options.layout == "portrait") // Portrait
        display_class += " tl-layout-portrait";
        else // Landscape
        display_class += " tl-layout-landscape";
        // Set StorySlider Height
        this.options.storyslider_height = this.options.height - this.options.timenav_height;
        // Positon Menu
        if (this.options.timenav_position == "top") menu_position = Math.ceil(this.options.timenav_height) / 2 - this._el.menubar.offsetHeight / 2 - 19.5;
        else menu_position = Math.round(this.options.storyslider_height + 1 + Math.ceil(this.options.timenav_height) / 2 - this._el.menubar.offsetHeight / 2 - 17.5);
        if (animate) {
            this._el.timenav.style.height = Math.ceil(this.options.timenav_height) + "px";
            // Animate StorySlider
            if (this.animator_storyslider) this.animator_storyslider.stop();
            this.animator_storyslider = (0, $92002c55b7773eef$export$83a1293bbde53b95)(this._el.storyslider, {
                height: this.options.storyslider_height + "px",
                duration: duration / 2,
                easing: (0, $2baebbd96bfe7e6e$export$3e62b4b316a17914)
            });
            // Animate Menubar
            if (this.animator_menubar) this.animator_menubar.stop();
            this.animator_menubar = (0, $92002c55b7773eef$export$83a1293bbde53b95)(this._el.menubar, {
                top: menu_position + "px",
                duration: duration / 2,
                easing: (0, $2baebbd96bfe7e6e$export$3e62b4b316a17914)
            });
        } else {
            // TimeNav
            this._el.timenav.style.height = Math.ceil(this.options.timenav_height) + "px";
            // StorySlider
            this._el.storyslider.style.height = this.options.storyslider_height + "px";
            // Menubar
            this._el.menubar.style.top = menu_position + "px";
        }
        if (this.message) this.message.updateDisplay(this.options.width, this.options.height);
        // Update Component Displays
        this._timenav.updateDisplay(this.options.width, this.options.timenav_height, animate);
        this._storyslider.updateDisplay(this.options.width, this.options.storyslider_height, animate, this.options.layout);
        if (this.language.direction == 'rtl') display_class += ' tl-rtl';
        // Apply class
        this._el.container.className = display_class;
    }
    /**
     * Compute the height of the navigation section of the Timeline, taking 
     *     into account the possibility of an explicit height or height 
     *     percentage, but also honoring the `timenav_height_min` option 
     *     value. If `timenav_height` is specified it takes precedence over 
     *     `timenav_height_percentage` but in either case, if the resultant 
     *     pixel height is less than `options.timenav_height_min` then the 
     *     value of `options.timenav_height_min` will be returned. (A minor 
     *     adjustment is made to the returned value to account for marker 
     *     padding.)
     * 
     * @param {number} [timenav_height] - an integer value for the desired height in pixels
     * @param {number} [timenav_height_percentage] - an integer between 1 and 100
     */ _calculateTimeNavHeight(timenav_height, timenav_height_percentage) {
        var height = 0;
        if (timenav_height) height = timenav_height;
        else if (this.options.timenav_height_percentage || timenav_height_percentage) {
            if (timenav_height_percentage) height = Math.round(this.options.height / 100 * timenav_height_percentage);
            else height = Math.round(this.options.height / 100 * this.options.timenav_height_percentage);
        }
        // Set new minimum based on how many rows needed
        if (this._timenav.ready) {
            if (this.options.timenav_height_min < this._timenav.getMinimumHeight()) this.options.timenav_height_min = this._timenav.getMinimumHeight();
        }
        // If height is less than minimum set it to minimum
        if (height < this.options.timenav_height_min) height = this.options.timenav_height_min;
        height = height - this.options.marker_padding * 2;
        return height;
    }
    _validateOptions() {
        // assumes that this.options and this.config have been set.
        var INTEGER_PROPERTIES = [
            'timenav_height',
            'timenav_height_min',
            'marker_height_min',
            'marker_width_min',
            'marker_padding',
            'start_at_slide',
            'slide_padding_lr'
        ];
        for(var i = 0; i < INTEGER_PROPERTIES.length; i++){
            var opt = INTEGER_PROPERTIES[i];
            var value = this.options[opt];
            let valid = true;
            if (typeof value == 'number') valid = value == parseInt(value);
            else if (typeof value == "string") valid = value.match(/^\s*(\-?\d+)?\s*$/);
            if (!valid) this.config.logError({
                message_key: 'invalid_integer_option',
                detail: opt
            });
        }
    }
    /**
     * Given a slide identifier, return the zero-based positional index of
     * that slide. If this timeline has a 'title' slide, it is at position 0
     * and all other slides are numbered after that. If there is no 'title' 
     * slide, then the first event slide is at position 0.
     * @param {String} id 
     */ _getSlideIndex(id) {
        if (this.config) {
            if (this.config.title && this.config.title.unique_id == id) return 0;
            for(var i = 0; i < this.config.events.length; i++){
                if (id == this.config.events[i].unique_id) return this.config.title ? i + 1 : i;
            }
        }
        return -1;
    }
    /**
     * Given a slide identifier, return the zero-based positional index of that slide.
     * Does not take the existence of a 'title' slide into account, so if there is a title
     * slide, this value should be one less than calling `_getSlideIndex` with the same
     * identifier. If there is no title slide, `_getSlideIndex` and `_getEventIndex` 
     * should return the same value.
     * TODO: does it really make sense to have both `_getSlideIndex` and `_getEventIndex`?
     * @param {String} id 
     */ _getEventIndex(id) {
        for(var i = 0; i < this.config.events.length; i++){
            if (id == this.config.events[i].unique_id) return i;
        }
        return -1;
    }
    _onLoaded() {
        if (this._loaded.storyslider && this._loaded.timenav) {
            this.fire("loaded", this.config);
            // Go to proper slide
            if ((0, $ea7d21fd242a7c44$export$7afc298d8ffd816)(this.options.start_at_end) || this.options.start_at_slide > this.config.events.length) this.goToEnd();
            else this.goTo(this.options.start_at_slide);
            if (this.options.hash_bookmark) {
                if (window.location.hash != "") this.goToId(window.location.hash.replace("#event-", ""));
                else this._updateHashBookmark(this.current_id);
                let the_timeline = this;
                window.addEventListener('hashchange', function() {
                    if (window.location.hash.indexOf('#event-') == 0) the_timeline.goToId(window.location.hash.replace("#event-", ""));
                }, false);
            }
        }
    }
    // Update hashbookmark in the url bar
    _updateHashBookmark(id) {
        if (id) {
            var hash = "#event-" + id.toString();
            window.history.replaceState(null, "Browsing TimelineJS", hash);
            this.fire("hash_updated", {
                unique_id: this.current_id,
                hashbookmark: "#event-" + id.toString()
            }, this);
        }
    }
    /*
        PUBLIC API
        This has been minimally tested since most people use TimelineJS as an embed.
        If we hear from people who are trying to use TimelineJS this way, we will do
        what we can to make sure it works correctly, and will appreciate help!
    */ zoomIn() {
        this._timenav.zoomIn();
    }
    zoomOut() {
        this._timenav.zoomOut();
    }
    setZoom(level) {
        this._timenav.setZoom(level);
    }
    // Goto slide with id
    goToId(id) {
        if (this.current_id != id) {
            this.current_id = id;
            this._timenav.goToId(this.current_id);
            this._storyslider.goToId(this.current_id, false, true);
            this.fire("change", {
                unique_id: this.current_id
            }, this);
        }
    }
    // Goto slide n
    goTo(n) {
        if (n < 0) return;
        try {
            if (this.config.title) {
                if (n === 0) this.goToId(this.config.title.unique_id);
                else this.goToId(this.config.events[n - 1].unique_id);
            } else this.goToId(this.config.events[n].unique_id);
        } catch  {
            // because n is interpreted differently depending on 
            // whether there's a title slide, easier to use catch
            // to handle navigating beyond end instead of test before
            return;
        }
    }
    // Goto first slide
    goToStart() {
        this.goTo(0);
    }
    // Goto last slide
    goToEnd() {
        var _n = this.config.events.length - 1;
        this.goTo(this.config.title ? _n + 1 : _n);
    }
    // Goto previous slide
    goToPrev() {
        this.goTo(this._getSlideIndex(this.current_id) - 1);
        this.focusContainer();
    }
    // Goto next slide
    goToNext() {
        this.goTo(this._getSlideIndex(this.current_id) + 1);
        this.focusContainer();
    }
    /* Event manipulation
    ================================================== */ // Add an event
    add(data) {
        var unique_id = this.config.addEvent(data);
        var n = this._getEventIndex(unique_id);
        var d = this.config.events[n];
        this._storyslider.createSlide(d, this.config.title ? n + 1 : n);
        this._storyslider._updateDrawSlides();
        this._timenav.createMarker(d, n);
        this._timenav._updateDrawTimeline(false);
        this.fire("added", {
            unique_id: unique_id
        });
    }
    // Remove an event
    remove(n) {
        if (n >= 0 && n < this.config.events.length) {
            // If removing the current, nav to new one first
            if (this.config.events[n].unique_id == this.current_id) {
                if (n < this.config.events.length - 1) this.goTo(n + 1);
                else this.goTo(n - 1);
            }
            var event = this.config.events.splice(n, 1);
            delete this.config.event_dict[event[0].unique_id];
            this._storyslider.destroySlide(this.config.title ? n + 1 : n);
            this._storyslider._updateDrawSlides();
            this._timenav.destroyMarker(n);
            this._timenav._updateDrawTimeline(false);
            this.fire("removed", {
                unique_id: event[0].unique_id
            });
        }
    }
    removeId(id) {
        this.remove(this._getEventIndex(id));
    }
    /* Get slide data
    ================================================== */ getData(n) {
        if (this.config.title) {
            if (n == 0) return this.config.title;
            else if (n > 0 && n <= this.config.events.length) return this.config.events[n - 1];
        } else if (n >= 0 && n < this.config.events.length) return this.config.events[n];
        return null;
    }
    getDataById(id) {
        return this.getData(this._getSlideIndex(id));
    }
    /* Get slide object
    ================================================== */ getSlide(n) {
        if (n >= 0 && n < this._storyslider._slides.length) return this._storyslider._slides[n];
        return null;
    }
    getSlideById(id) {
        return this.getSlide(this._getSlideIndex(id));
    }
    getCurrentSlide() {
        return this.getSlideById(this.current_id);
    }
    updateDisplay() {
        if (this.ready) this._updateDisplay();
        else (0, $ea7d21fd242a7c44$export$357889f174732d38)('updateDisplay called but timeline is not in ready state');
    }
    focusContainer() {
        this._el.container.focus();
    }
    _initGoogleAnalytics(measurement_id) {
        (0, $6ba50b95af76efe0$export$93b33d367be6802b)(`https://www.googletagmanager.com/gtag/js?id=${measurement_id}`);
        window.dataLayer = window.dataLayer || [];
        window.gtag = function() {
            dataLayer.push(arguments);
        };
        gtag('js', new Date());
        gtag('config', measurement_id);
    }
    _initAnalytics() {
        let measurement_id = this.options.ga_measurement_id || this.options.ga_property_id || null;
        if (!measurement_id) return;
        this._initGoogleAnalytics(measurement_id);
        var events = this.options.track_events;
        for(let i = 0; i < events.length; i++){
            var event_ = events[i];
            this.addEventListener(event_, function(e) {
                gtag('event', e.type);
            });
        }
    }
}
(0, $ea7d21fd242a7c44$export$c5910a33574a115e)($8112dcaee14ab84c$export$e6a97ba2cae5bb94, (0, $2319cf524e876851$export$222529f9b823899b), (0, $d92d8eaa035c7b70$export$2e2bcd8739ae039));
async function $8112dcaee14ab84c$export$9a13a592817af225(url, proxy_url) {
    if (!proxy_url) proxy_url = 'https://sheets-proxy.knightlab.com/proxy/';
    let json = await (0, $ce175c6e1ee59955$export$e0bad53d1fd55d95)(url, {
        sheets_proxy: proxy_url
    });
    return json;
}








var $c6a5708c86c6cd0b$exports = {};
!function(t, e) {
    $c6a5708c86c6cd0b$exports = e();
}(self, function() {
    return (()=>{
        "use strict";
        var n = {
            d: (t, e)=>{
                for(var r in e)n.o(e, r) && !n.o(t, r) && Object.defineProperty(t, r, {
                    enumerable: !0,
                    get: e[r]
                });
            },
            o: (t, e)=>Object.prototype.hasOwnProperty.call(t, e)
        }, t = {};
        n.d(t, {
            default: ()=>o
        });
        var e, u = (function(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            }
        }((e = r).prototype, [
            {
                key: "listenerCount",
                value: function(t) {
                    return this._listeners.has(t) ? this._listeners.get(t).length : 0;
                }
            },
            {
                key: "removeListeners",
                value: function() {
                    var e = this, t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : null, r = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];
                    null !== t ? Array.isArray(t) ? name.forEach(function(t) {
                        return e.removeListeners(t, r);
                    }) : (this._listeners.delete(t), r && this.removeMiddleware(t)) : this._listeners = new Map;
                }
            },
            {
                key: "middleware",
                value: function(t, e) {
                    var r = this;
                    Array.isArray(t) ? name.forEach(function(t) {
                        return r.middleware(t, e);
                    }) : (Array.isArray(this._middlewares.get(t)) || this._middlewares.set(t, []), this._middlewares.get(t).push(e));
                }
            },
            {
                key: "removeMiddleware",
                value: function() {
                    var e = this, t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : null;
                    null !== t ? Array.isArray(t) ? name.forEach(function(t) {
                        return e.removeMiddleware(t);
                    }) : this._middlewares.delete(t) : this._middlewares = new Map;
                }
            },
            {
                key: "on",
                value: function(t, e) {
                    var r, n = this, o = 2 < arguments.length && void 0 !== arguments[2] && arguments[2];
                    Array.isArray(t) ? t.forEach(function(t) {
                        return n.on(t, e);
                    }) : 1 < (r = (t = t.toString()).split(/,|, | /)).length ? r.forEach(function(t) {
                        return n.on(t, e);
                    }) : (Array.isArray(this._listeners.get(t)) || this._listeners.set(t, []), this._listeners.get(t).push({
                        once: o,
                        callback: e
                    }));
                }
            },
            {
                key: "once",
                value: function(t, e) {
                    this.on(t, e, !0);
                }
            },
            {
                key: "emit",
                value: function(r, n) {
                    var o = this, i = 2 < arguments.length && void 0 !== arguments[2] && arguments[2];
                    r = r.toString();
                    var u = this._listeners.get(r), l = null, a = 0, s = i;
                    if (Array.isArray(u)) for(u.forEach(function(t, e) {
                        i || (l = o._middlewares.get(r), Array.isArray(l) ? (l.forEach(function(t) {
                            t(n, function() {
                                var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : null;
                                null !== t && (n = t), a++;
                            }, r);
                        }), a >= l.length && (s = !0)) : s = !0), s && (t.once && (u[e] = null), t.callback(n));
                    }); -1 !== u.indexOf(null);)u.splice(u.indexOf(null), 1);
                }
            }
        ]), Object.defineProperty(e, "prototype", {
            writable: !1
        }), r);
        function r() {
            var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : [];
            (function(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            })(this, r), this._listeners = new Map(t), this._middlewares = new Map;
        }
        function i(e, t) {
            var r, n = Object.keys(e);
            return Object.getOwnPropertySymbols && (r = Object.getOwnPropertySymbols(e), t && (r = r.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r)), n;
        }
        function l(n) {
            for(var t = 1; t < arguments.length; t++){
                var o = null != arguments[t] ? arguments[t] : {};
                t % 2 ? i(Object(o), !0).forEach(function(t) {
                    var e, r;
                    e = n, t = o[r = t], r in e ? Object.defineProperty(e, r, {
                        value: t,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[r] = t;
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(o)) : i(Object(o)).forEach(function(t) {
                    Object.defineProperty(n, t, Object.getOwnPropertyDescriptor(o, t));
                });
            }
            return n;
        }
        function a(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            }
        }
        function s(t, e) {
            return (s = Object.setPrototypeOf || function(t, e) {
                return t.__proto__ = e, t;
            })(t, e);
        }
        function c(t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        }
        function f(t) {
            return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
        }
        function p(t) {
            return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var o = function() {
            !function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), s(t, e);
            }(i, u);
            var t, e, r, n, o = (r = i, n = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (t) {
                    return !1;
                }
            }(), function() {
                var t, e = f(r);
                return function(t, e) {
                    if (e && ("object" === p(e) || "function" == typeof e)) return e;
                    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                    return c(t);
                }(this, n ? (t = f(this).constructor, Reflect.construct(e, arguments, t)) : e.apply(this, arguments));
            });
            function i(t) {
                var e, r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
                if (function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, i), (e = o.call(this)).element = "string" == typeof t ? document.querySelector(t) : t, !e.element) throw new Error("An invalid selector or non-DOM node has been provided.");
                return e._clickEvents = [
                    "click"
                ], e.options = l({}, r), e.onSliderInput = e.onSliderInput.bind(c(e)), e.init(), e;
            }
            return e = [
                {
                    key: "attach",
                    value: function() {
                        var t, r = this, e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 'input[type="range"].slider', n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, o = new Array;
                        return ("string" == typeof (t = e) || !!t && "object" === p(t) && "[object String]" === Object.prototype.toString.call(t) ? document.querySelectorAll(e) : Array.isArray(e) ? e : [
                            e
                        ]).forEach(function(t) {
                            var e;
                            void 0 === t[r.constructor.name] ? (e = new i(t, n), t[r.constructor.name] = e, o.push(e)) : o.push(t[r.constructor.name]);
                        }), o;
                    }
                }
            ], a((t = i).prototype, [
                {
                    key: "init",
                    value: function() {
                        var t;
                        this._id = "bulmaSlider" + (new Date).getTime() + Math.floor(Math.random() * Math.floor(9999)), this.output = this._findOutputForSlider(), this._bindEvents(), this.output && this.element.classList.contains("has-output-tooltip") && (t = this._getSliderOutputPosition(), this.output.style.left = t.position), this.emit("bulmaslider:ready", this.element.value);
                    }
                },
                {
                    key: "_findOutputForSlider",
                    value: function() {
                        var e = this, r = null, t = document.getElementsByTagName("output") || [];
                        return Array.from(t).forEach(function(t) {
                            if (t.htmlFor == e.element.getAttribute("id")) return r = t, !0;
                        }), r;
                    }
                },
                {
                    key: "_getSliderOutputPosition",
                    value: function() {
                        var t = window.getComputedStyle(this.element, null), e = parseInt(t.getPropertyValue("width"), 10), t = this.element.getAttribute("min") ? this.element.getAttribute("min") : 0, t = (this.element.value - t) / (this.element.getAttribute("max") - t);
                        return {
                            position: (t < 0 ? 0 : 1 < t ? e : e * t) + "px"
                        };
                    }
                },
                {
                    key: "_bindEvents",
                    value: function() {
                        this.output && this.element.addEventListener("input", this.onSliderInput, !1);
                    }
                },
                {
                    key: "onSliderInput",
                    value: function(t) {
                        t.preventDefault(), this.element.classList.contains("has-output-tooltip") && (e = this._getSliderOutputPosition(), this.output.style.left = e.position);
                        var t = this.output.hasAttribute("data-prefix") ? this.output.getAttribute("data-prefix") : "", e = this.output.hasAttribute("data-postfix") ? this.output.getAttribute("data-postfix") : "";
                        this.output.value = t + this.element.value + e, this.emit("bulmaslider:ready", this.element.value);
                    }
                }
            ]), a(t, e), Object.defineProperty(t, "prototype", {
                writable: !1
            }), i;
        }();
        return t.default;
    })();
});


var $2be514c301921327$exports = {};
$2be514c301921327$exports = JSON.parse('{"JDP-S-4":{"id":"JDP-S-4","name":"Aikid\u014D","native_name":{"name":"\u5408\u6C17\u9053","lang":"ja"},"birth":{"date":1920,"location":null,"country_code":"JPN"},"description":{"en":"Aikido (Shinjitai: \u5408\u6C17\u9053, Ky\u016Bjitai: \u5408\u6C23\u9053,) is a modern Japanese martial art that is split into many different styles, including Iwama Ryu, Iwama Shin Shin Aiki Shuren Kai, Shodokan Aikido, Yoshinkan, Renshinkai, Aikikai and Ki Aikido. Aikido is now practiced in around 140 countries. It was originally developed by Morihei Ueshiba, as a synthesis of his martial studies, philosophy and religious beliefs. Ueshiba\'s goal was to create an art that practitioners could use to defend themselves while also protecting their attackers from injury.      \\n"},"media":{"photo_url":"https://aikido.com.br/wp-content/uploads/2015/03/Ueshiba_8.jpg","video_url":"https://www.youtube.com/watch?v=30Sa0PLquFg"},"sources":[{"uri":"https://en.wikipedia.org/wiki/Aikido"}]},"JDP-S-16":{"id":"JDP-S-16","name":"Brazilian jiu-jitsu","native_name":{"name":"Jiu-Jitsu brasileiro","lang":"pt"},"aka":[{"name":"Jiu-jitsu"},{"name":"BJJ"}],"birth":{"date":null,"location":null,"country_code":"BRA"},"media":{"video_url":"https://www.youtube.com/watch?v=rZQkydT-SyM","photo_url":"https://s2-ge.glbimg.com/XHMUEtCldtpWyc7VaWzVWKN6NIk=/0x0:900x559/600x0/smart/filters:gifv():strip_icc()/i.s3.glbimg.com/v1/AUTH_bc8228b6673f488aa253bbcb03c80ec5/internal_photos/bs/2024/s/L/UpVASJTr65lfkp2P8x8g/heliograciefamilia.jpg"},"description":{"en":"Brazilian jiu-jitsu also abbreviated as BJJ, is a self-defence martial art and combat sport based on grappling, ground fighting, and submission holds. BJJ is primarily a ground-based fighting style and focuses on taking one\'s opponent down to the ground, gaining a dominant position, and using a number of techniques to force them into submission via joint locks, chokeholds, or compression locks. Brazilian jiu-jitsu was first developed around 1925 by Brazilian brothers Carlos, Oswaldo, Gast\xe3o Jr., and H\xe9lio Gracie, after Carlos was taught a hybrid fighting style of traditional Jujutsu and Kodokan judo by a travelling Japanese judoka, Mitsuyo Maeda, in 1917. Later on the Gracie family developed their own self-defense system which they named Gracie Jiu-Jitsu. BJJ eventually came to be its own defined combat sport through the innovations, practices, and adaptation of Gracie jiu-jitsu and judo, and has become one of the essential martial arts for modern MMA.\\n","pt":"Jiu-j\xedtsu brasileiro \xe9 uma arte marcial e esporte de combate, desenvolvido pela fam\xedlia Gracie, no in\xedcio do s\xe9culo XX, que se tornou a forma mais difundida e praticada do \\"Jiu-jitsu\\" (ap\xf3s o jud\xf4) no mundo, principalmente depois das primeiras edi\xe7\xf5es dos torneios de Vale Tudo e artes marciais mistas (MMA), principalmente no UFC, nos idos da d\xe9cada de 1990 e no Pride FC durante o final da d\xe9cada de 1990 e come\xe7o da d\xe9cada de 2000. \xc9 uma arte marcial de luta agarrada, onde o objetivo \xe9 imobilizar o oponente no ch\xe3o por meio de uma \\"finaliza\xe7\xe3o\\", colocando o oponente em uma tor\xe7\xe3o de um membro do corpo (como por exemplo uma chave de bra\xe7o ou chave de perna) ou estrangulamento (como o mata-le\xe3o ou tri\xe2ngulo), for\xe7ando o oponente a desistir. O jiu-jitsu brasileiro tem um apre\xe7o em focar na luta de solo onde a luta em p\xe9 tem papel secund\xe1rio, ao contr\xe1rio de outras marciais de luta agarrada.\\n"},"sources":[{"uri":"https://pt.wikipedia.org/wiki/Jiu-j%C3%ADtsu_brasileiro"},{"uri":"https://cbjj.com.br/"},{"uri":"https://ibjjf.com/"},{"uri":"https://jjgf.com/"}]},"JDP-S-17":{"id":"JDP-S-17","name":"Baguazhang","native_name":{"name":"\u516B\u5366\u638C","lang":"cn"},"birth":{"date":null,"location":null,"country_code":"CHN"},"media":{"video_url":"https://www.youtube.com/watch?v=0E_mVfFfsPU","photo_url":"https://upload.wikimedia.org/wikipedia/commons/b/b1/250_Bagau016ChangChaoDong.jpg"},"description":{"en":"Baguazhang (Chinese: \u516B\u5366\u638C; pinyin: b\u0101 gu\xe0 zh\u01CEng; Wade\u2013Giles: pa-kua chang) is one of the three main Chinese martial arts of the Wudang school, the other two being tai chi and xingyiquan. It is more broadly grouped as an internal practice (or neijia). Baguazhang literally means \\"eight trigram palm\\", referring to the bagua \\"trigrams\\" of the I Ching, one of the canons of Taoism.\\n","cn":"\u516B\u5366\u638C\u70BA\u4E2D\u570B\u6B66\u8853\u7684\u8457\u540D\u62F3\u7A2E\uFF0C\u6E90\u81EA\u6E05\u671D\u672B\u5E74\u6B66\u5E2B\u8463\u6D77\u5DDD\uFF0C\u8207\u592A\u6975\u62F3\u548C\u5F62\u610F\u62F3\u4E26\u7A31\u4E09\u5927\u5167\u5BB6\u62F3\u3002"},"sources":[{"uri":"https://en.wikipedia.org/wiki/Baguazhang"},{"uri":"https://zh.wikipedia.org/wiki/%E5%85%AB%E5%8D%A6%E6%8E%8C"}]},"JDP-S-19":{"id":"JDP-S-19","name":"Boxing","birth":{"date":null,"location":null,"country_code":"ENG"},"description":{"en":"Combat sport involving striking with fists, historically practiced worldwide with modern codification in 18th-19th century England. Governed by the Marquess of Queensberry Rules since 1867.\\n"},"sources":[{"uri":"https://en.wikipedia.org/wiki/Boxing","cite":"Boxing - Wikipedia"},{"uri":"https://www.britannica.com/sports/boxing","cite":"Boxing - Encyclopedia Britannica"}]},"JDP-S-10":{"id":"JDP-S-10","name":"Dait\u014D-ry\u016B Aiki-j\u016Bjutsu","native_name":{"name":"\u5927\u6771\u6D41 \u5408\u6C17\u67D4\u8853","lang":"ja"},"birth":{"date":1100,"location":null,"country_code":"JPN"},"media":{"video_url":"https://youtu.be/zgezzfG1Rwk?t=167","photo_url":"https://aikidojournal.com/wp-content/uploads/2018/05/soden-vol5.jpg"},"sources":[{"uri":"https://en.wikipedia.org/wiki/Dait%C5%8D-ry%C5%AB_Aiki-j%C5%ABjutsu"},{"uri":"https://www.daitohryu.com/eng-history01","events":["birth"],"citation":"According to this tradition, the name Daito-ryu can be traced back about 900 years, to Shinra Saburo Minamoto no Yoshimitsu (1045-1127), a warrior considered to have been the distant founder of the school."}]},"JDP-S-12":{"id":"JDP-S-12","name":"Jig\u014D Tenshin Ry\u016B","native_name":{"name":"\u81EA\u525B\u5929\u771F\u6D41","lang":"ja"},"aka":[{"name":"Ise Jitoku Tenshin-ry\u016B","native_name":{"name":"\u70BA\u52E2\u81EA\u5F97\u5929\u771E\u6D41\u67D4\u8853","lang":"ja"}}],"birth":{"date":1800,"location":"Fukuoka","country_code":"JPN"},"description":{"en":"Jigo Tenshin Ryu (also known as Isei Jitoku Tenshinryu) is one of the martial arts handed down from the Fukuoka Domain. It was founded as a comprehensive martial art system, but the jujutsu component is the one that has been handed down to the present. Many ancient techniques remain, including joint techniques, restraining techniques, and Kappo. In 2005, it was designated as an intangible cultural property of Fukuoka City.\\n","ja":"\u81EA\u525B\u5929\u771F\u6D41\uFF08\u3058\u3054\u3046\u3066\u3093\u3057\u3093\u308A\u3085\u3046\uFF09\u306F\u3001\u798F\u5CA1\u85E9\u4F1D\u6765\u306E\u6B66\u8853\u306E\u4E00\u3064\u3002\u5225 \u540D\u3001\u70BA\u52E2\u81EA\u5F97\u5929\u771F\u6D41\u3002\u5275\u6D41\u6642\u306F\u5168\u3066\u306E\u3082\u306E\u3092\u6B66\u5668\u3068\u3057\u3066\u4F7F\u7528\u3059\u308B\u7D9C\u5408\u6B66 \u8853\u3067\u3042\u3063\u305F\u304C\u3001\u73FE\u5728\u3067\u306F\u4E3B\u306B\u67D4\u8853\u304C\u76F8\u4F1D\u3055\u308C\u3066\u3044\u308B\u3002\u53E4\u5F0F\u306E\u6280\u6CD5\u304C\u6570\u591A \u304F\u6B8B\u3055\u308C\u3066\u304A\u308A\u3001\u9006\u624B\u3092\u4E2D\u5FC3\u3068\u3057\u305F\u95A2\u7BC0\u6280\u3001\u5C45\u53D6\u3001\u62F3\u6CD5\u3001\u902E\u6355\u8853\u3001\u6D3B\u6CD5 \u306A\u3069\u591A\u5F69\u306A\u6280\u3092\u4ECA\u306B\u4F1D\u3048\u3066\u3044\u308B\u3002\u307E\u305F2005\u5E74\u306B\u798F\u5CA1\u5E02\u306E\u7121\u5F62\u6587\u5316\u8CA1\u306B\u6307 \u5B9A\u3055\u308C\u305F\u3002\\n","pt":"O Jigo Tenshin Ryu (tamb\xe9m conhecido como Isei Jitoku Tenshinryu) \xe9 uma das artes marciais tradicionais do Dom\xednio de Fukuoka, Jap\xe3o.Na \xe9poca de sua funda\xe7\xe3o, era uma arte marcial completa, mas foi o jujutsu que foi transmitido at\xe9 aos nossos dias. Preserva muitas t\xe9cnicas antigas t\xe9cnicas como as centradas na manipula\xe7\xe3o de articula\xe7\xf5es, imobiliza\xe7\xe3o,e kappo. Em 2005, foi designado como propriedade cultural imaterial da cidade de Fukuoka.\\n"},"media":{"video_url":"https://youtu.be/yA32io5HYic?t=92","photo_url":null},"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E8%87%AA%E5%89%9B%E5%A4%A9%E7%9C%9F%E6%B5%81"},{"uri":"https://www.ryoishintokai.com/2019/12/24/84/"}]},"JDP-S-14":{"id":"JDP-S-14","name":"J\u016Bjutsu","native_name":{"name":"\u67D4\u8853","lang":"ja"},"birth":{"date":1530,"location":null,"country_code":"JPN"},"media":{"video_url":"https://www.youtube.com/watch?v=TFFGo14oSxg","photo_url":"https://upload.wikimedia.org/wikipedia/commons/1/14/JUJITSU_%28AND_RIFLES%29_in_an_agricultural_school.jpg"},"description":{"en":"Jujutsu, also known as jiu-jitsu and ju-jitsu, is a family of Japanese martial arts and a system of close combat (unarmed or with a minor weapon) that can be used in a defensive or offensive manner to kill or subdue one or more weaponless or armed and armored opponents. It was designed in the 1530s and is coined by Hisamori Tenenuchi when he officially established the first school of Jiu-Jitsu in Japan. A subset of techniques from certain styles of jujutsu were used to develop many modern martial arts and combat sports, such as judo, aikido, sambo, ARB, Brazilian jiu-jitsu, and mixed martial arts.\\n"},"sources":[{"uri":"https://en.wikipedia.org/wiki/Jujutsu"}]},"JDP-S-5":{"id":"JDP-S-5","name":"Karate","native_name":{"name":"\u7A7A\u624B","lang":"ja"},"aka":[{"name":"Karatedo","native_name":[{"name":"\u7A7A\u624B\u9053","lang":"ja"}]}],"birth":{"date":1800,"location":"Okinawa","country_code":"JPN"},"sources":[{"uri":"https://en.wikipedia.org/wiki/Karate"}]},"JDP-S-8":{"id":"JDP-S-8","name":"Kendo","native_name":{"name":"\u5263\u9053","lang":"ja"},"birth":{"date":1912,"location":null,"country_code":"JPN"},"sources":[{"uri":"https://www.kendo.or.jp/en/knowledge/kendo-history/"}]},"JDP-S-2":{"id":"JDP-S-2","name":"Kit\u014D-ry\u016B","native_name":{"name":"\u8D77\u5012\u6D41","lang":"ja"},"birth":{"date":1600,"location":null,"country_code":"JPN"},"media":{"video_url":"https://youtu.be/qdzzF4ziu68?t=667","photo_url":"https://www.ryoishintokai.com/wp-content/uploads/2020/09/Screenshot-2020-09-19-at-00.21.19.png"},"description":{"en":"The Kit\u014D Ryu [\u8D77\u5012\u6D41] is a system of jujutsu that merits a particular place in the doctrine of unarmed martial arts because of its esoteric elements, adopted along with various techniques and training methods (such as randori) in Judo. Of particular interest are the kata that have been preserved by the modern inheritors of kito ryu. Kito ryu is the \\"rise and fall\\" school of jujutsu.  Some of the available records trace the origin of this school to a Chinese combat based upon the principle of ju (suppleness), as explained and illustrated by Chin Gempin to selected warriors of 17th century Japan. Another version associates this method with two other noted jujutsu experts, Yoshimura and Takenaka.      \\n"},"sources":[{"uri":"https://en.wikipedia.org/wiki/Kit%C5%8D-ry%C5%AB"},{"uri":"https://www.ryoishintokai.com/wp-content/uploads/2020/09/Screenshot-2020-09-19-at-00.21.19.png"}]},"JDP-S-1":{"id":"JDP-S-1","name":"K\u014Dd\u014Dkan J\u016Bd\u014D","native_name":{"name":"\u8B1B\u9053\u9928\u67D4\u9053","lang":"ja"},"birth":{"date":1882,"location":null,"country_code":"JPN"},"media":{"video_url":"https://www.youtube.com/watch?v=FoFwE8pX2js","photo_url":"http://kodokanjudoinstitute.org/images/doctrine/purpose/01.jpg"},"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E6%9F%94%E9%81%93"}]},"JDP-S-9":{"id":"JDP-S-9","name":"Muso-ryu Shinjujutsu","native_name":{"name":"\u7121\u76F8\u6D41\u65B0\u67D4\u8853","lang":"ja"},"birth":{"date":1592,"location":"Sanuki","country_code":"JPN"},"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E7%84%A1%E7%9B%B8%E6%B5%81%E6%96%B0%E6%9F%94%E8%A1%93"}]},"JDP-S-15":{"id":"JDP-S-15","name":"Sambo","native_name":{"name":"\u0441a\u043C\u0431\u043E","lang":"ru"},"aka":[{"name":"Samozashchita bez oruzhiya","native_name":[{"name":"\u0441\u0430\u043C\u043E\u0437\u0430\u0449\u0438\u0442\u0430 \u0431\u0435\u0437 \u043E\u0440\u0443\u0436\u0438\u044F","lang":"ru"}]}],"birth":{"date":1920,"location":null,"country_code":"SUN"},"media":{"video_url":"https://www.youtube.com/watch?v=S3AgKTD1cYc&t=321","photo_url":"https://archive.org/download/sambo-history/Sambo-history.jpeg"},"description":{"en":"Sambo (Russian: \u0441a\u043C\u0431\u043E, pronounced [\u02C8samb\u0259]) is a martial art with Soviet origins, an internationally practised combat sport, and a recognized style of amateur wrestling included by UWW in the World Wrestling Championships along with Graeco-Roman wrestling and freestyle wrestling.  It originated in the Russian SFSR in the Soviet Union. The word sambo is an acronym of samozashchita bez oruzhiya (Russian: \u0441\u0430\u043C\u043E\u0437\u0430\u0449\u0438\u0442\u0430 \u0431\u0435\u0437 \u043E\u0440\u0443\u0436\u0438\u044F), which literally translates to \'self-defence without weapons\'. SAMBO is a martial art and combat sport developed and used by the Soviet Red Army in the early 1920s to improve their hand-to-hand combat abilities. The sport is similar in many ways to judo and jiu jitsu but also incorporates different types of wrestling and various self-defence systems.  Soviet martial arts expert Vasili Oshchepkov is credited as one of the founding fathers of SAMBO.\\n"},"sources":[{"uri":"https://en.wikipedia.org/wiki/Sambo_(martial_art)"},{"uri":"https://sambo.sport"}]},"JDP-S-13":{"id":"JDP-S-13","name":"Shuri-te","native_name":{"name":"\u9996\u91CC\u624B","lang":"ja"},"birth":{"date":1700,"location":"Okinawa","country_code":"JPN"},"sources":[{"uri":"https://ja.wikipedia.org/wiki/%E9%A6%96%E9%87%8C%E6%89%8B"}]},"JDP-S-6":{"id":"JDP-S-6","name":"Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B","native_name":{"name":"\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41","lang":"ja"},"aka":[{"name":"Katori Shint\u014D-ry\u016B","native_name":{"name":"\u9999\u53D6\u795E\u9053\u6D41","lang":"ja"}}],"birth":{"date":1147,"location":"Shim\u014Dsa","country_code":"JPN"},"description":{"en":"Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B (\u5929\u771F\u6B63\u4F1D\u9999\u53D6\u795E\u9053\u6D41) is one of the oldest extant Japanese martial arts, and an exemplar of bujutsu. The Tenshin Sh\u014Dden Katori Shint\u014D-ry\u016B was founded by Iizasa Ienao, born in 1387 in Iizasa village (modern Takomachi, Chiba Prefecture), who was living near Katori Shrine (Sawara City, Chiba Prefecture) at the time. The ry\u016B gives 1447 as the year it was founded, but some scholars state that it was about 1480.\\n"},"media":{"video_url":"https://youtu.be/4EvjslbRTaA?t=120","photo_url":"https://upload.wikimedia.org/wikipedia/commons/1/19/Kenjyutsu-2.jpg"},"sources":[{"uri":"https://en.wikipedia.org/wiki/Tenshin_Sh%C5%8Dden_Katori_Shint%C5%8D-ry%C5%AB"},{"uri":"https://ja.wikipedia.org/wiki/%E5%A4%A9%E7%9C%9F%E6%AD%A3%E4%BC%9D%E9%A6%99%E5%8F%96%E7%A5%9E%E9%81%93%E6%B5%81"},{"uri":"https://www.katorishintoryu-shinbukan.org/"}]},"JDP-S-3":{"id":"JDP-S-3","name":"Tenjin Shin\'y\u014D-ry\u016B","native_name":{"name":"\u5929\u795E\u771F\u694A\u6D41","lang":"ja"},"description":{"en":"Tenjin Shinyo-ryu (\u5929\u795E\u771F\u694A\u6D41, Tenjin Shin\'y\u014D-ry\u016B), meaning \\"Divine True Willow School\\", can be classified as a traditional school (kory\u016B) of jujutsu. It was founded by Iso Mataemon Ry\u016Bkansai Minamoto no Masatari (\u78EF\u53C8\u53F3\u885B\u9580\u67F3\u95A2\u658E\u6E90\u6B63\u8DB3) in the 1830s. Its syllabus comprises atemi-waza (striking techniques), nage-waza (throwing techniques), torae-waza (immobilization methods), and shime-waza (choking techniques). Once a very popular jujutsu system in Japan, among the famous students who studied the art were Kan\u014D Jigor\u014D, whose modern art of judo was greatly inspired by the Tenjin Shin\'y\u014D-ry\u016B and Kit\u014D-ry\u016B.\\n"},"media":{"video_url":"https://youtu.be/RhTpeCdANzA?t=24","photo_url":"https://upload.wikimedia.org/wikipedia/commons/0/0c/Kuchikitaoshi.jpeg"},"birth":{"date":1830,"location":null,"country_code":"JPN"},"sources":[{"uri":"https://en.wikipedia.org/wiki/Tenjin_Shin%27y%C5%8D-ry%C5%AB"},{"uri":"http://www.tenyokai.com"}]},"JDP-S-18":{"id":"JDP-S-18","name":"Xingyiquan","native_name":{"name":"\u5F62\u610F\u62F3","lang":"cn"},"birth":{"date":null,"location":null,"country_code":"CHN"},"media":{"video_url":"https://www.youtube.com/watch?v=MD144T5cpiU","photo_url":"https://upload.wikimedia.org/wikipedia/commons/b/b1/250_Bagau016ChangChaoDong.jpg"},"description":{"en":"Xingyiquan, or Xingyi, is a style of internal Chinese martial arts. The word translates approximately to \\"Form-Intention Fist\\", or \\"Shape-Will Fist\\". It is characterized by aggressive, seemingly linear movements and explosive power most often applied from a short range. A practitioner of Xingyi uses coordinated movements to generate bursts of power intended to overwhelm the opponent, simultaneously attacking and defending. Methods vary from school to school, but always include bare-handed fighting training (mostly in single movements/combinations and sometimes in forms) and the training of weapons usage with similar or identical body mechanics to that used for bare-handed intense fighting. The most basic notions of movement and body mechanics in the art were heavily influenced by the practice of staves and spears.\\n","cn":"\u5F62\u610F\u62F3\uFF0C\u53C8\u79F0\u5FC3\u610F\u62F3\u3001\u5FC3\u610F\u516D\u5408\u62F3\uFF0C\u4E2D\u56FD\u4F20\u7EDF\u6B66\u672F\uFF0C\u5C5E\u5185\u5BB6\u62F3\uFF0C\u6D41\u884C\u4E8E\u4E2D \u56FD\u5317\u65B9\uFF0C\u5206\u6210\u6CB3\u5317\u3001\u5C71\u897F\u3001\u6CB3\u53573\u4E2A\u7CFB\u7EDF\uFF0C\u6253\u6CD5\u591A\u76F4\u884C\u76F4\u8FDB\u3002\u5F62\u610F\u62F3\u53D1\u6E90 \u4E8E\u5C71\u897F\u592A\u8C37\uFF0C\u5C71\u897F\u5F62\u62F3\u8BB2\u7A76\u529F\u529B\uFF0C\u5F62\u677E\u610F\u7D27\uFF0C\u5916\u5F62\u4E0D\u62D8\u4E00\u683C\uFF0C\u6253\u6CD5\u53D8\u5E7B\u591A \u7AEF\u7684\u98CE\u683C\u7279\u70B9\u3002\u5728\u5F62\u610F\u5341\u4E8C\u5F62\u4E2D\uFF0C\u91CD\u70B9\u7A81\u51FA\u6240\u53D6\u52A8\u7269\u7684\u8FDB\u653B\u6280\u5DE7\uFF0C\u4E0D\u6C42\u5F62 \u8C61\u4F46\u6C42\u610F\u771F\u7684\u7EC3\u6CD5\uFF0C\u4E94\u884C\u4E2D\u8BB2\u7A76\u6728\u3001\u706B\u3001\u571F\u3001\u91D1\u3001\u6C34\u7684\u5185\u6DB5\u3002\u5F62\u610F\u62F3\u662F\u4E2D \u56FD\u4E09\u5927\u8457\u540D\u5185\u5BB6\u62F3\u62F3\u79CD\u4E4B\u4E00\uFF08\u5F62\u610F\u3001\u592A\u6781\u3001\u516B\u5366\uFF09\uFF0C\u4E0E\u5C11\u6797\u62F3\u4F4D\u5217\u4E2D\u56FD\u56DB \u5927\u540D\u62F3\u3002"},"sources":[{"uri":"https://en.wikipedia.org/wiki/Xingyiquan"},{"uri":"https://zh.wikipedia.org/zh-hans/%E5%BD%A2%E6%84%8F%E6%8B%B3"}]},"JDP-S-11":{"id":"JDP-S-11","name":"Yagy\u016B Shingan-ry\u016B","native_name":{"name":"\u67F3\u751F\u5FC3\u773C\u6D41","lang":"ja"},"birth":{"date":1600,"location":"Sendai","country_code":"JPN"},"description":{"en":"Yagy\u016B Shingan-ry\u016B (\u67F3\u751F\u5FC3\u773C\u6D41), is a traditional school (kory\u016B) of Japanese martial arts. Different styles of Yagy\u016B Shingan-ry\u016B, such as Heihojutsu and Taijutsu, assert different founders, Takenaga Hayato and Araki Mataemon respectively, but they all go back to Ush\u016B Tatewaki (\u7FBD\u5DDE \u5E2F\u5200), referred to in some historical scrolls as Shind\u014D Tatewaki, who taught a system based on Sengoku-period battlefield tactics, that was called Shind\u014D-ry\u016B. The word shingan (\u5FC3\u773C) is rooted in Zen philosophy, and was chosen to describe a fundamental concept of the style. Shingan means \\"mind\u2019s eye,\\" or \\"heart\'s eye,\\" and refers to the ability to sense or read an opponent\'s intentions via an inner sense. Originally called simply Shingan-ry\u016B, it was later renamed Yagy\u016B Shingan-ry\u016B, due to the influence of Yagyu Tajima no Kami Munenori\'s Yagy\u016B Shinkage-ry\u016B.\\n","ja":"\u67F3\u751F\u5FC3\u773C\u6D41\uFF08\u3084\u304E\u3085\u3046\u3057\u3093\u304C\u3093\u308A\u3085\u3046\uFF09\u306F\u3001\u65E5\u672C\u306E\u4F1D\u7D71\u6B66\u8853\u306E\u6D41\u6D3E\u3068\u3055 \u308C\u3066\u3044\u308B\u3002\u73FE\u4EE3\u306B\u4F1D\u308F\u308B\u67F3\u751F\u5FC3\u773C\u6D41\u306B\u306F\u5927\u304D\u304F\u5206\u985E\u3057\u3066\u6771\u5317\u4F1D\u3001\u6C5F\u6238\u4F1D \uFF08\u67F3\u751F\u5FC3\u773C\u6D41\u8352\u6728\u5802\uFF09\u304C\u3042\u308B\u3002\u6771\u5317\u4F1D\u306B\u304A\u3044\u3066\u306F\u7AF9\u6C38\u96BC\u4EBA\uFF08\u76F4\u5165\uFF09\u517C\u6B21 (\u91D1\u6B21)\u3092\u958B\u7956\u3068\u3057\u3066\u304A\u308A\u3001\u6C5F\u6238\u4F1D\u306B\u304A\u3044\u3066\u306F\u8352\u6728\u53C8\u53F3\u885B\u9580\u3092\u958B\u7956\u3068\u4F1D\u3048 \u3066\u3044\u308B\u3002\u6771\u5317\u4F1D\u3067\u306F\u5F53\u8EAB\u6280\u3092\u4E2D\u5FC3\u3068\u3059\u308B\u7279\u7570\u306A\u5185\u5BB9\u306E\u67D4\u8853\u304C\u4F1D\u3048\u3089\u308C\u3066 \u304A\u308A\u3001\u6C5F\u6238\u4F1D\u306B\u304A\u3044\u3066\u306F\u53E4\u5F0F\u304B\u3089\u306A\u308B\u7532\u5191\u67D4\uFF08\u93A7\u7D44\u6253\u3061\uFF09\u304C\u4F1D\u627F\u3055\u308C\u3066 \u3044\u308B\u3002 \u7CFB\u7D71\u306B\u3088\u3063\u3066\u4F1D\u3048\u308B\u5185\u5BB9\u306F\u7570\u306A\u308B\u304C\u3001\u4F53\u8853\uFF08\u67D4\u8853\uFF09\u30FB\u5263\u8853\u30FB\u5C45 \u5408\u8853\u30FB\u68D2\u8853\u30FB\u8599\u5200\u8853\u306A\u3069\u3092\u542B\u307F\u3001\u66F4\u306B\u6C5F\u6238\u4F1D\u3067\u306F\u5927\u592A\u5200\u3092\u9063\u3046\u6280\u6CD5\u3082\u4F1D \u3048\u3089\u308C\u3066\u3044\u308B\u3002\\n","pt":"Yagy\u016B shingan-ry\u016B \xe9 uma tradicional escola japonesa de bujutsu (lit. arte da guerra). Ensina todos os fundamentos das artes marciais japonesas cl\xe1ssicas. \xc9 conhecida como Yagy\u016B shingan-ry\u016B kacchu yawara, e foi um estilo de luta adotado por alguns samurais do xogunato Tokugawa. Foi bastante divulgado pela s\xe9rie, \\"Lobo Solit\xe1rio\\" (de Kazuo Koike & Goseki Kojima) e no livro \\"Musashi\\" de Eiji Yoshikawa.\\n"},"media":{"video_url":"https://youtu.be/6Ke_d6hN7CI?t=30","photo_url":"https://upload.wikimedia.org/wikipedia/commons/8/87/Nimai_Gasa.jpg"},"sources":[{"uri":"https://en.wikipedia.org/wiki/Yagy%C5%AB_Shingan-ry%C5%AB"},{"uri":"https://ja.wikipedia.org/wiki/%E6%9F%B3%E7%94%9F%E5%BF%83%E7%9C%BC%E6%B5%81"}]},"JDP-S-7":{"id":"JDP-S-7","name":"Y\u014Dshin-ry\u016B","native_name":{"name":"\u694A\u5FC3\u6D41","lang":"ja"},"aka":[{"name":"Y\u014Dshin Kory\u016B","native_name":{"name":"\u694A\u5FC3\u53E4\u6D41","lang":"ja"}}],"birth":{"date":1610,"location":null,"country_code":"JPN"},"sources":[{"uri":"https://en.wikipedia.org/wiki/Y%C5%8Dshin_Kory%C5%AB"}]}}');


console.log("Cytoscape version: ", (0, $e815fda779bc047b$export$2e2bcd8739ae039).version);
// URL parameters
// const url = require('url')
// import url from 'url'
const $388b617130f03bd4$var$queryString = window.location.search;
const $388b617130f03bd4$var$urlParams = new URLSearchParams($388b617130f03bd4$var$queryString);
console.log("URL: ", $388b617130f03bd4$var$urlParams.get("id"));
var $63618293c58b5f80$exports = {};
'use strict';
Object.defineProperty($63618293c58b5f80$exports, '__esModule', {
    value: true
});
function $63618293c58b5f80$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $63618293c58b5f80$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $63618293c58b5f80$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $63618293c58b5f80$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $63618293c58b5f80$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $63618293c58b5f80$var$_extends() {
    $63618293c58b5f80$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $63618293c58b5f80$var$_extends.apply(this, arguments);
}
function $63618293c58b5f80$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $63618293c58b5f80$var$_setPrototypeOf(subClass, superClass);
}
function $63618293c58b5f80$var$_getPrototypeOf(o) {
    $63618293c58b5f80$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $63618293c58b5f80$var$_getPrototypeOf(o);
}
function $63618293c58b5f80$var$_setPrototypeOf(o, p) {
    $63618293c58b5f80$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $63618293c58b5f80$var$_setPrototypeOf(o, p);
}
function $63618293c58b5f80$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $63618293c58b5f80$var$_construct(Parent, args, Class) {
    if ($63618293c58b5f80$var$_isNativeReflectConstruct()) $63618293c58b5f80$var$_construct = Reflect.construct.bind();
    else $63618293c58b5f80$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $63618293c58b5f80$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $63618293c58b5f80$var$_construct.apply(null, arguments);
}
function $63618293c58b5f80$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $63618293c58b5f80$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $63618293c58b5f80$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$63618293c58b5f80$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $63618293c58b5f80$var$_construct(Class, arguments, $63618293c58b5f80$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $63618293c58b5f80$var$_setPrototypeOf(Wrapper, Class);
    };
    return $63618293c58b5f80$var$_wrapNativeSuper(Class);
}
function $63618293c58b5f80$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $63618293c58b5f80$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $63618293c58b5f80$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $63618293c58b5f80$var$_arrayLikeToArray(o, minLen);
}
function $63618293c58b5f80$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $63618293c58b5f80$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $63618293c58b5f80$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $63618293c58b5f80$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $63618293c58b5f80$var$_toPropertyKey(arg) {
    var key = $63618293c58b5f80$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $63618293c58b5f80$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $63618293c58b5f80$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $63618293c58b5f80$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $63618293c58b5f80$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $63618293c58b5f80$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$n = "numeric", $63618293c58b5f80$var$s = "short", $63618293c58b5f80$var$l = "long";
var $63618293c58b5f80$var$DATE_SHORT = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_MED = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATE_FULL = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_HUGE = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$TIME_SIMPLE = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$TIME_WITH_SECONDS = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$TIME_24_SIMPLE = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    hourCycle: "h23"
};
var $63618293c58b5f80$var$TIME_24_WITH_SECONDS = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hourCycle: "h23"
};
var $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hourCycle: "h23",
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hourCycle: "h23",
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$DATETIME_SHORT = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$s,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_FULL = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATETIME_HUGE = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
/**
 * @interface
 */ var $63618293c58b5f80$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ ;
    _proto.offset = function offset(ts) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ ;
    $63618293c58b5f80$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $63618293c58b5f80$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $63618293c58b5f80$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $63618293c58b5f80$var$parseZoneInfo(ts, format, locale);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($63618293c58b5f80$var$singleton$1 === null) $63618293c58b5f80$var$singleton$1 = new SystemZone();
                return $63618293c58b5f80$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($63618293c58b5f80$var$Zone);
var $63618293c58b5f80$var$dtfCache = {};
function $63618293c58b5f80$var$makeDTF(zone) {
    if (!$63618293c58b5f80$var$dtfCache[zone]) $63618293c58b5f80$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        era: "short"
    });
    return $63618293c58b5f80$var$dtfCache[zone];
}
var $63618293c58b5f80$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $63618293c58b5f80$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $63618293c58b5f80$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $63618293c58b5f80$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$63618293c58b5f80$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $63618293c58b5f80$var$ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $63618293c58b5f80$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        if (!$63618293c58b5f80$var$ianaZoneCache[name]) $63618293c58b5f80$var$ianaZoneCache[name] = new IANAZone(name);
        return $63618293c58b5f80$var$ianaZoneCache[name];
    } /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ ;
    IANAZone.resetCache = function resetCache() {
        $63618293c58b5f80$var$ianaZoneCache = {};
        $63618293c58b5f80$var$dtfCache = {};
    } /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */ ;
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    } /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ ;
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */ var _proto = IANAZone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $63618293c58b5f80$var$parseZoneInfo(ts, format, locale, this.name);
    } /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.offset(ts), format);
    } /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ ;
    _proto.offset = function offset(ts) {
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $63618293c58b5f80$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $63618293c58b5f80$var$partsOffset(dtf, date) : $63618293c58b5f80$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $63618293c58b5f80$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    } /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    } /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */ ;
    $63618293c58b5f80$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($63618293c58b5f80$var$Zone);
var $63618293c58b5f80$var$_excluded = [
    "base"
], $63618293c58b5f80$var$_excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var $63618293c58b5f80$var$intlLFCache = {};
function $63618293c58b5f80$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $63618293c58b5f80$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $63618293c58b5f80$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $63618293c58b5f80$var$intlDTCache = {};
function $63618293c58b5f80$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $63618293c58b5f80$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $63618293c58b5f80$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
var $63618293c58b5f80$var$intlNumCache = {};
function $63618293c58b5f80$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $63618293c58b5f80$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $63618293c58b5f80$var$intlNumCache[key] = inf;
    }
    return inf;
}
var $63618293c58b5f80$var$intlRelCache = {};
function $63618293c58b5f80$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $63618293c58b5f80$var$_objectWithoutPropertiesLoose(_opts, $63618293c58b5f80$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $63618293c58b5f80$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $63618293c58b5f80$var$intlRelCache[key] = inf;
    }
    return inf;
}
var $63618293c58b5f80$var$sysLocaleCache = null;
function $63618293c58b5f80$var$systemLocale() {
    if ($63618293c58b5f80$var$sysLocaleCache) return $63618293c58b5f80$var$sysLocaleCache;
    else {
        $63618293c58b5f80$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $63618293c58b5f80$var$sysLocaleCache;
    }
}
var $63618293c58b5f80$var$weekInfoCache = {};
function $63618293c58b5f80$var$getCachedWeekInfo(locString) {
    var data = $63618293c58b5f80$var$weekInfoCache[locString];
    if (!data) {
        var locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        $63618293c58b5f80$var$weekInfoCache[locString] = data;
    }
    return data;
}
function $63618293c58b5f80$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = $63618293c58b5f80$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = $63618293c58b5f80$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $63618293c58b5f80$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $63618293c58b5f80$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $63618293c58b5f80$var$DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $63618293c58b5f80$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $63618293c58b5f80$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $63618293c58b5f80$var$listStuff(loc, length, englishFn, intlFn) {
    var mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $63618293c58b5f80$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ var $63618293c58b5f80$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $63618293c58b5f80$var$_objectWithoutPropertiesLoose(opts, $63618293c58b5f80$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $63618293c58b5f80$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $63618293c58b5f80$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $63618293c58b5f80$var$roundTo(i, 3);
            return $63618293c58b5f80$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $63618293c58b5f80$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = $63618293c58b5f80$var$_extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $63618293c58b5f80$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return $63618293c58b5f80$var$_extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $63618293c58b5f80$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $63618293c58b5f80$var$hasRelative()) this.rtf = $63618293c58b5f80$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $63618293c58b5f80$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
var $63618293c58b5f80$var$fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
/**
 * @private
 */ var $63618293c58b5f80$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $63618293c58b5f80$var$Settings.defaultLocale;
        // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $63618293c58b5f80$var$systemLocale());
        var numberingSystemR = numberingSystem || $63618293c58b5f80$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $63618293c58b5f80$var$Settings.defaultOutputCalendar;
        var weekSettingsR = $63618293c58b5f80$var$validateWeekSettings(weekSettings) || $63618293c58b5f80$var$Settings.defaultWeekSettings;
        return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $63618293c58b5f80$var$sysLocaleCache = null;
        $63618293c58b5f80$var$intlDTCache = {};
        $63618293c58b5f80$var$intlNumCache = {};
        $63618293c58b5f80$var$intlRelCache = {};
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar, weekSettings = _ref2.weekSettings;
        return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
    };
    function Locale(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
        var _parseLocaleString = $63618293c58b5f80$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = $63618293c58b5f80$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, $63618293c58b5f80$var$validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($63618293c58b5f80$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($63618293c58b5f80$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format) {
        var _this2 = this;
        if (format === void 0) format = false;
        return $63618293c58b5f80$var$listStuff(this, length, $63618293c58b5f80$var$months, function() {
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) _this2.monthsCache[formatStr][length] = $63618293c58b5f80$var$mapMonths(function(dt) {
                return _this2.extract(dt, intl, "month");
            });
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format) {
        var _this3 = this;
        if (format === void 0) format = false;
        return $63618293c58b5f80$var$listStuff(this, length, $63618293c58b5f80$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = $63618293c58b5f80$var$mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1() {
        var _this4 = this;
        return $63618293c58b5f80$var$listStuff(this, undefined, function() {
            return $63618293c58b5f80$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    $63618293c58b5f80$var$DateTime.utc(2016, 11, 13, 9),
                    $63618293c58b5f80$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length) {
        var _this5 = this;
        return $63618293c58b5f80$var$listStuff(this, length, $63618293c58b5f80$var$eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                $63618293c58b5f80$var$DateTime.utc(-40, 1, 1),
                $63618293c58b5f80$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $63618293c58b5f80$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $63618293c58b5f80$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $63618293c58b5f80$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $63618293c58b5f80$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    };
    _proto4.getWeekSettings = function getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!$63618293c58b5f80$var$hasLocaleWeekInfo()) return $63618293c58b5f80$var$fallbackWeekSettings;
        else return $63618293c58b5f80$var$getCachedWeekInfo(this.locale);
    };
    _proto4.getStartOfWeek = function getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    };
    _proto4.getMinDaysInFirstWeek = function getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    };
    _proto4.getWeekendDays = function getWeekendDays() {
        return this.getWeekSettings().weekend;
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    _proto4.toString = function toString() {
        return "Locale(" + this.locale + ", " + this.numberingSystem + ", " + this.outputCalendar + ")";
    };
    $63618293c58b5f80$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $63618293c58b5f80$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var $63618293c58b5f80$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $63618293c58b5f80$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    } /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ ;
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($63618293c58b5f80$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */ var _proto = FixedOffsetZone.prototype;
    /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */ _proto.offsetName = function offsetName() {
        return this.name;
    } /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.fixed, format);
    } /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */ ;
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */ _proto.offset = function offset() {
        return this.fixed;
    } /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    } /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */ ;
    $63618293c58b5f80$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $63618293c58b5f80$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $63618293c58b5f80$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($63618293c58b5f80$var$singleton === null) $63618293c58b5f80$var$singleton = new FixedOffsetZone(0);
                return $63618293c58b5f80$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($63618293c58b5f80$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $63618293c58b5f80$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset() {
        return "";
    } /** @override **/ ;
    _proto.offset = function offset() {
        return NaN;
    } /** @override **/ ;
    _proto.equals = function equals() {
        return false;
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($63618293c58b5f80$var$Zone);
/**
 * @private
 */ function $63618293c58b5f80$var$normalizeZone(input, defaultZone) {
    if ($63618293c58b5f80$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $63618293c58b5f80$var$Zone) return input;
    else if ($63618293c58b5f80$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $63618293c58b5f80$var$SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return $63618293c58b5f80$var$FixedOffsetZone.utcInstance;
        else return $63618293c58b5f80$var$FixedOffsetZone.parseSpecifier(lowered) || $63618293c58b5f80$var$IANAZone.create(input);
    } else if ($63618293c58b5f80$var$isNumber(input)) return $63618293c58b5f80$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $63618293c58b5f80$var$InvalidZone(input);
}
var $63618293c58b5f80$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $63618293c58b5f80$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $63618293c58b5f80$var$hanidecChars = $63618293c58b5f80$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $63618293c58b5f80$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($63618293c58b5f80$var$numberingSystems.hanidec) !== -1) value += $63618293c58b5f80$var$hanidecChars.indexOf(str[i]);
            else for(var key in $63618293c58b5f80$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $63618293c58b5f80$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
// cache of {numberingSystem: {append: regex}}
var $63618293c58b5f80$var$digitRegexCache = {};
function $63618293c58b5f80$var$resetDigitRegexCache() {
    $63618293c58b5f80$var$digitRegexCache = {};
}
function $63618293c58b5f80$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    var ns = numberingSystem || "latn";
    if (!$63618293c58b5f80$var$digitRegexCache[ns]) $63618293c58b5f80$var$digitRegexCache[ns] = {};
    if (!$63618293c58b5f80$var$digitRegexCache[ns][append]) $63618293c58b5f80$var$digitRegexCache[ns][append] = new RegExp("" + $63618293c58b5f80$var$numberingSystems[ns] + append);
    return $63618293c58b5f80$var$digitRegexCache[ns][append];
}
var $63618293c58b5f80$var$now = function now() {
    return Date.now();
}, $63618293c58b5f80$var$defaultZone = "system", $63618293c58b5f80$var$defaultLocale = null, $63618293c58b5f80$var$defaultNumberingSystem = null, $63618293c58b5f80$var$defaultOutputCalendar = null, $63618293c58b5f80$var$twoDigitCutoffYear = 60, $63618293c58b5f80$var$throwOnInvalid, $63618293c58b5f80$var$defaultWeekSettings = null;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $63618293c58b5f80$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $63618293c58b5f80$var$Locale.resetCache();
        $63618293c58b5f80$var$IANAZone.resetCache();
        $63618293c58b5f80$var$DateTime.resetCache();
        $63618293c58b5f80$var$resetDigitRegexCache();
    };
    $63618293c58b5f80$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $63618293c58b5f80$var$now;
            },
            set: function set(n) {
                $63618293c58b5f80$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $63618293c58b5f80$var$normalizeZone($63618293c58b5f80$var$defaultZone, $63618293c58b5f80$var$SystemZone.instance);
            },
            set: function set(zone) {
                $63618293c58b5f80$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $63618293c58b5f80$var$defaultLocale;
            },
            set: function set(locale) {
                $63618293c58b5f80$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $63618293c58b5f80$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $63618293c58b5f80$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $63618293c58b5f80$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $63618293c58b5f80$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "defaultWeekSettings",
            get: function get() {
                return $63618293c58b5f80$var$defaultWeekSettings;
            },
            set: function set(weekSettings) {
                $63618293c58b5f80$var$defaultWeekSettings = $63618293c58b5f80$var$validateWeekSettings(weekSettings);
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return $63618293c58b5f80$var$twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                $63618293c58b5f80$var$twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $63618293c58b5f80$var$throwOnInvalid;
            },
            set: function set(t) {
                $63618293c58b5f80$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var $63618293c58b5f80$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
var $63618293c58b5f80$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $63618293c58b5f80$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $63618293c58b5f80$var$unitOutOfRange(unit, value) {
    return new $63618293c58b5f80$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $63618293c58b5f80$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $63618293c58b5f80$var$computeOrdinal(year, month, day) {
    return day + ($63618293c58b5f80$var$isLeapYear(year) ? $63618293c58b5f80$var$leapLadder : $63618293c58b5f80$var$nonLeapLadder)[month - 1];
}
function $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal) {
    var table = $63618293c58b5f80$var$isLeapYear(year) ? $63618293c58b5f80$var$leapLadder : $63618293c58b5f80$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
function $63618293c58b5f80$var$isoWeekdayToLocal(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
/**
 * @private
 */ function $63618293c58b5f80$var$gregorianToWeek(gregObj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $63618293c58b5f80$var$computeOrdinal(year, month, day), weekday = $63618293c58b5f80$var$isoWeekdayToLocal($63618293c58b5f80$var$dayOfWeek(year, month, day), startOfWeek);
    var weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $63618293c58b5f80$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > $63618293c58b5f80$var$weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $63618293c58b5f80$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $63618293c58b5f80$var$timeObject(gregObj));
}
function $63618293c58b5f80$var$weekToGregorian(weekData, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $63618293c58b5f80$var$isoWeekdayToLocal($63618293c58b5f80$var$dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = $63618293c58b5f80$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $63618293c58b5f80$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $63618293c58b5f80$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $63618293c58b5f80$var$_extends({
        year: year,
        month: month,
        day: day
    }, $63618293c58b5f80$var$timeObject(weekData));
}
function $63618293c58b5f80$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $63618293c58b5f80$var$computeOrdinal(year, month, day);
    return $63618293c58b5f80$var$_extends({
        year: year,
        ordinal: ordinal
    }, $63618293c58b5f80$var$timeObject(gregData));
}
function $63618293c58b5f80$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $63618293c58b5f80$var$_extends({
        year: year,
        month: month,
        day: day
    }, $63618293c58b5f80$var$timeObject(ordinalData));
}
/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */ function $63618293c58b5f80$var$usesLocalWeekValues(obj, loc) {
    var hasLocaleWeekData = !$63618293c58b5f80$var$isUndefined(obj.localWeekday) || !$63618293c58b5f80$var$isUndefined(obj.localWeekNumber) || !$63618293c58b5f80$var$isUndefined(obj.localWeekYear);
    if (hasLocaleWeekData) {
        var hasIsoWeekData = !$63618293c58b5f80$var$isUndefined(obj.weekday) || !$63618293c58b5f80$var$isUndefined(obj.weekNumber) || !$63618293c58b5f80$var$isUndefined(obj.weekYear);
        if (hasIsoWeekData) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
        if (!$63618293c58b5f80$var$isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!$63618293c58b5f80$var$isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!$63618293c58b5f80$var$isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function $63618293c58b5f80$var$hasInvalidWeekData(obj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var validYear = $63618293c58b5f80$var$isInteger(obj.weekYear), validWeek = $63618293c58b5f80$var$integerBetween(obj.weekNumber, 1, $63618293c58b5f80$var$weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = $63618293c58b5f80$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $63618293c58b5f80$var$unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return $63618293c58b5f80$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidOrdinalData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.year), validOrdinal = $63618293c58b5f80$var$integerBetween(obj.ordinal, 1, $63618293c58b5f80$var$daysInYear(obj.year));
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $63618293c58b5f80$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidGregorianData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.year), validMonth = $63618293c58b5f80$var$integerBetween(obj.month, 1, 12), validDay = $63618293c58b5f80$var$integerBetween(obj.day, 1, $63618293c58b5f80$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $63618293c58b5f80$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $63618293c58b5f80$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $63618293c58b5f80$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $63618293c58b5f80$var$integerBetween(minute, 0, 59), validSecond = $63618293c58b5f80$var$integerBetween(second, 0, 59), validMillisecond = $63618293c58b5f80$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $63618293c58b5f80$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $63618293c58b5f80$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $63618293c58b5f80$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $63618293c58b5f80$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
/**
 * @private
 */ // TYPES
function $63618293c58b5f80$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $63618293c58b5f80$var$isNumber(o) {
    return typeof o === "number";
}
function $63618293c58b5f80$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $63618293c58b5f80$var$isString(o) {
    return typeof o === "string";
}
function $63618293c58b5f80$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $63618293c58b5f80$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function $63618293c58b5f80$var$hasLocaleWeekInfo() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $63618293c58b5f80$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $63618293c58b5f80$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $63618293c58b5f80$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $63618293c58b5f80$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $63618293c58b5f80$var$validateWeekSettings(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new $63618293c58b5f80$var$InvalidArgumentError("Week settings must be an object");
    else {
        if (!$63618293c58b5f80$var$integerBetween(settings.firstDay, 1, 7) || !$63618293c58b5f80$var$integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some(function(v) {
            return !$63618293c58b5f80$var$integerBetween(v, 1, 7);
        })) throw new $63618293c58b5f80$var$InvalidArgumentError("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
// NUMBERS AND STRINGS
function $63618293c58b5f80$var$integerBetween(thing, bottom, top) {
    return $63618293c58b5f80$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $63618293c58b5f80$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $63618293c58b5f80$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $63618293c58b5f80$var$parseInteger(string) {
    if ($63618293c58b5f80$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $63618293c58b5f80$var$parseFloating(string) {
    if ($63618293c58b5f80$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $63618293c58b5f80$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($63618293c58b5f80$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $63618293c58b5f80$var$roundTo(number, digits, towardZero) {
    if (towardZero === void 0) towardZero = false;
    var factor = Math.pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
}
// DATE BASICS
function $63618293c58b5f80$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $63618293c58b5f80$var$daysInYear(year) {
    return $63618293c58b5f80$var$isLeapYear(year) ? 366 : 365;
}
function $63618293c58b5f80$var$daysInMonth(year, month) {
    var modMonth = $63618293c58b5f80$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $63618293c58b5f80$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $63618293c58b5f80$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function $63618293c58b5f80$var$firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    var fwdlw = $63618293c58b5f80$var$isoWeekdayToLocal($63618293c58b5f80$var$dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function $63618293c58b5f80$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekOffset = $63618293c58b5f80$var$firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    var weekOffsetNext = $63618293c58b5f80$var$firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return ($63618293c58b5f80$var$daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function $63618293c58b5f80$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $63618293c58b5f80$var$Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $63618293c58b5f80$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $63618293c58b5f80$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $63618293c58b5f80$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $63618293c58b5f80$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new $63618293c58b5f80$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $63618293c58b5f80$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($63618293c58b5f80$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $63618293c58b5f80$var$asNumber(v);
    }
    return normalized;
}
/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */ function $63618293c58b5f80$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $63618293c58b5f80$var$padStart(hours, 2) + ":" + $63618293c58b5f80$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $63618293c58b5f80$var$padStart(hours, 2) + $63618293c58b5f80$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $63618293c58b5f80$var$timeObject(obj) {
    return $63618293c58b5f80$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var $63618293c58b5f80$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $63618293c58b5f80$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $63618293c58b5f80$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $63618293c58b5f80$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$monthsNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$monthsShort);
        case "long":
            return [].concat($63618293c58b5f80$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $63618293c58b5f80$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $63618293c58b5f80$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $63618293c58b5f80$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $63618293c58b5f80$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$weekdaysNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$weekdaysShort);
        case "long":
            return [].concat($63618293c58b5f80$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $63618293c58b5f80$var$meridiems = [
    "AM",
    "PM"
];
var $63618293c58b5f80$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $63618293c58b5f80$var$erasShort = [
    "BC",
    "AD"
];
var $63618293c58b5f80$var$erasNarrow = [
    "B",
    "A"
];
function $63618293c58b5f80$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$erasNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$erasShort);
        case "long":
            return [].concat($63618293c58b5f80$var$erasLong);
        default:
            return null;
    }
}
function $63618293c58b5f80$var$meridiemForDateTime(dt) {
    return $63618293c58b5f80$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $63618293c58b5f80$var$weekdayForDateTime(dt, length) {
    return $63618293c58b5f80$var$weekdays(length)[dt.weekday - 1];
}
function $63618293c58b5f80$var$monthForDateTime(dt, length) {
    return $63618293c58b5f80$var$months(length)[dt.month - 1];
}
function $63618293c58b5f80$var$eraForDateTime(dt, length) {
    return $63618293c58b5f80$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $63618293c58b5f80$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $63618293c58b5f80$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $63618293c58b5f80$var$_macroTokenToFormatOpts = {
    D: $63618293c58b5f80$var$DATE_SHORT,
    DD: $63618293c58b5f80$var$DATE_MED,
    DDD: $63618293c58b5f80$var$DATE_FULL,
    DDDD: $63618293c58b5f80$var$DATE_HUGE,
    t: $63618293c58b5f80$var$TIME_SIMPLE,
    tt: $63618293c58b5f80$var$TIME_WITH_SECONDS,
    ttt: $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET,
    tttt: $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET,
    T: $63618293c58b5f80$var$TIME_24_SIMPLE,
    TT: $63618293c58b5f80$var$TIME_24_WITH_SECONDS,
    TTT: $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET,
    f: $63618293c58b5f80$var$DATETIME_SHORT,
    ff: $63618293c58b5f80$var$DATETIME_MED,
    fff: $63618293c58b5f80$var$DATETIME_FULL,
    ffff: $63618293c58b5f80$var$DATETIME_HUGE,
    F: $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS,
    FFF: $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $63618293c58b5f80$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $63618293c58b5f80$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $63618293c58b5f80$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.dtFormatter = function dtFormatter(dt, opts) {
        if (opts === void 0) opts = {};
        return this.loc.dtFormatter(dt, $63618293c58b5f80$var$_extends({}, this.opts, opts));
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        var df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    };
    _proto.num = function num(n, p) {
        if (p === void 0) p = 0;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $63618293c58b5f80$var$padStart(n, p);
        var opts = $63618293c58b5f80$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $63618293c58b5f80$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $63618293c58b5f80$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $63618293c58b5f80$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $63618293c58b5f80$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "n":
                    return _this.num(dt.localWeekNumber);
                case "nn":
                    return _this.num(dt.localWeekNumber, 2);
                case "ii":
                    return _this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return _this.num(dt.localWeekYear, 4);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $63618293c58b5f80$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "w":
                    return "week";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) return _this2.num(lildur.get(mapped), token.length);
                else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        }));
        return $63618293c58b5f80$var$stringifyTokens(tokens, tokenToString(collapsed));
    };
    return Formatter;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var $63618293c58b5f80$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $63618293c58b5f80$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $63618293c58b5f80$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $63618293c58b5f80$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $63618293c58b5f80$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $63618293c58b5f80$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $63618293c58b5f80$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var $63618293c58b5f80$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var $63618293c58b5f80$var$isoExtendedZone = "(?:" + $63618293c58b5f80$var$offsetRegex.source + "?(?:\\[(" + $63618293c58b5f80$var$ianaRegex.source + ")\\])?)?";
var $63618293c58b5f80$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $63618293c58b5f80$var$isoTimeRegex = RegExp("" + $63618293c58b5f80$var$isoTimeBaseRegex.source + $63618293c58b5f80$var$isoExtendedZone);
var $63618293c58b5f80$var$isoTimeExtensionRegex = RegExp("(?:T" + $63618293c58b5f80$var$isoTimeRegex.source + ")?");
var $63618293c58b5f80$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $63618293c58b5f80$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $63618293c58b5f80$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $63618293c58b5f80$var$extractISOWeekData = $63618293c58b5f80$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $63618293c58b5f80$var$extractISOOrdinalData = $63618293c58b5f80$var$simpleParse("year", "ordinal");
var $63618293c58b5f80$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $63618293c58b5f80$var$sqlTimeRegex = RegExp($63618293c58b5f80$var$isoTimeBaseRegex.source + " ?(?:" + $63618293c58b5f80$var$offsetRegex.source + "|(" + $63618293c58b5f80$var$ianaRegex.source + "))?");
var $63618293c58b5f80$var$sqlTimeExtensionRegex = RegExp("(?: " + $63618293c58b5f80$var$sqlTimeRegex.source + ")?");
function $63618293c58b5f80$var$int(match, pos, fallback) {
    var m = match[pos];
    return $63618293c58b5f80$var$isUndefined(m) ? fallback : $63618293c58b5f80$var$parseInteger(m);
}
function $63618293c58b5f80$var$extractISOYmd(match, cursor) {
    var item = {
        year: $63618293c58b5f80$var$int(match, cursor),
        month: $63618293c58b5f80$var$int(match, cursor + 1, 1),
        day: $63618293c58b5f80$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $63618293c58b5f80$var$extractISOTime(match, cursor) {
    var item = {
        hours: $63618293c58b5f80$var$int(match, cursor, 0),
        minutes: $63618293c58b5f80$var$int(match, cursor + 1, 0),
        seconds: $63618293c58b5f80$var$int(match, cursor + 2, 0),
        milliseconds: $63618293c58b5f80$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $63618293c58b5f80$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $63618293c58b5f80$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $63618293c58b5f80$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $63618293c58b5f80$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $63618293c58b5f80$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var $63618293c58b5f80$var$isoTimeOnly = RegExp("^T?" + $63618293c58b5f80$var$isoTimeBaseRegex.source + "$");
// ISO duration parsing
var $63618293c58b5f80$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $63618293c58b5f80$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($63618293c58b5f80$var$parseFloating(yearStr)),
            months: maybeNegate($63618293c58b5f80$var$parseFloating(monthStr)),
            weeks: maybeNegate($63618293c58b5f80$var$parseFloating(weekStr)),
            days: maybeNegate($63618293c58b5f80$var$parseFloating(dayStr)),
            hours: maybeNegate($63618293c58b5f80$var$parseFloating(hourStr)),
            minutes: maybeNegate($63618293c58b5f80$var$parseFloating(minuteStr)),
            seconds: maybeNegate($63618293c58b5f80$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($63618293c58b5f80$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $63618293c58b5f80$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $63618293c58b5f80$var$untruncateYear($63618293c58b5f80$var$parseInteger(yearStr)) : $63618293c58b5f80$var$parseInteger(yearStr),
        month: $63618293c58b5f80$var$monthsShort.indexOf(monthStr) + 1,
        day: $63618293c58b5f80$var$parseInteger(dayStr),
        hour: $63618293c58b5f80$var$parseInteger(hourStr),
        minute: $63618293c58b5f80$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $63618293c58b5f80$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $63618293c58b5f80$var$weekdaysLong.indexOf(weekdayStr) + 1 : $63618293c58b5f80$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var $63618293c58b5f80$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $63618293c58b5f80$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $63618293c58b5f80$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $63618293c58b5f80$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $63618293c58b5f80$var$FixedOffsetZone(offset)
    ];
}
function $63618293c58b5f80$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var $63618293c58b5f80$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $63618293c58b5f80$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $63618293c58b5f80$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $63618293c58b5f80$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $63618293c58b5f80$var$FixedOffsetZone.utcInstance
    ];
}
function $63618293c58b5f80$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $63618293c58b5f80$var$FixedOffsetZone.utcInstance
    ];
}
var $63618293c58b5f80$var$isoYmdWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoYmdRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoWeekWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoWeekRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoOrdinalWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoOrdinalRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoTimeCombinedRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoTimeRegex);
var $63618293c58b5f80$var$extractISOYmdTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOYmd, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
var $63618293c58b5f80$var$extractISOWeekTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOWeekData, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
var $63618293c58b5f80$var$extractISOOrdinalDateAndTime = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOOrdinalData, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
var $63618293c58b5f80$var$extractISOTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
/*
 * @private
 */ function $63618293c58b5f80$var$parseISODate(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoYmdWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOYmdTimeAndOffset
    ], [
        $63618293c58b5f80$var$isoWeekWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOWeekTimeAndOffset
    ], [
        $63618293c58b5f80$var$isoOrdinalWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOOrdinalDateAndTime
    ], [
        $63618293c58b5f80$var$isoTimeCombinedRegex,
        $63618293c58b5f80$var$extractISOTimeAndOffset
    ]);
}
function $63618293c58b5f80$var$parseRFC2822Date(s) {
    return $63618293c58b5f80$var$parse($63618293c58b5f80$var$preprocessRFC2822(s), [
        $63618293c58b5f80$var$rfc2822,
        $63618293c58b5f80$var$extractRFC2822
    ]);
}
function $63618293c58b5f80$var$parseHTTPDate(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$rfc1123,
        $63618293c58b5f80$var$extractRFC1123Or850
    ], [
        $63618293c58b5f80$var$rfc850,
        $63618293c58b5f80$var$extractRFC1123Or850
    ], [
        $63618293c58b5f80$var$ascii,
        $63618293c58b5f80$var$extractASCII
    ]);
}
function $63618293c58b5f80$var$parseISODuration(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoDuration,
        $63618293c58b5f80$var$extractISODuration
    ]);
}
var $63618293c58b5f80$var$extractISOTimeOnly = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime);
function $63618293c58b5f80$var$parseISOTimeOnly(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoTimeOnly,
        $63618293c58b5f80$var$extractISOTimeOnly
    ]);
}
var $63618293c58b5f80$var$sqlYmdWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$sqlYmdRegex, $63618293c58b5f80$var$sqlTimeExtensionRegex);
var $63618293c58b5f80$var$sqlTimeCombinedRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$sqlTimeRegex);
var $63618293c58b5f80$var$extractISOTimeOffsetAndIANAZone = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
function $63618293c58b5f80$var$parseSQL(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$sqlYmdWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOYmdTimeAndOffset
    ], [
        $63618293c58b5f80$var$sqlTimeCombinedRegex,
        $63618293c58b5f80$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $63618293c58b5f80$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
var $63618293c58b5f80$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $63618293c58b5f80$var$casualMatrix = $63618293c58b5f80$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $63618293c58b5f80$var$lowOrderMatrix), $63618293c58b5f80$var$daysInYearAccurate = 365.2425, $63618293c58b5f80$var$daysInMonthAccurate = 30.436875, $63618293c58b5f80$var$accurateMatrix = $63618293c58b5f80$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $63618293c58b5f80$var$daysInYearAccurate / 7,
        days: $63618293c58b5f80$var$daysInYearAccurate,
        hours: $63618293c58b5f80$var$daysInYearAccurate * 24,
        minutes: $63618293c58b5f80$var$daysInYearAccurate * 1440,
        seconds: $63618293c58b5f80$var$daysInYearAccurate * 86400,
        milliseconds: $63618293c58b5f80$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $63618293c58b5f80$var$daysInYearAccurate / 28,
        days: $63618293c58b5f80$var$daysInYearAccurate / 4,
        hours: $63618293c58b5f80$var$daysInYearAccurate * 24 / 4,
        minutes: $63618293c58b5f80$var$daysInYearAccurate * 1440 / 4,
        seconds: $63618293c58b5f80$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $63618293c58b5f80$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $63618293c58b5f80$var$daysInMonthAccurate / 7,
        days: $63618293c58b5f80$var$daysInMonthAccurate,
        hours: $63618293c58b5f80$var$daysInMonthAccurate * 24,
        minutes: $63618293c58b5f80$var$daysInMonthAccurate * 1440,
        seconds: $63618293c58b5f80$var$daysInMonthAccurate * 86400,
        milliseconds: $63618293c58b5f80$var$daysInMonthAccurate * 86400000
    }
}, $63618293c58b5f80$var$lowOrderMatrix);
// units ordered by size
var $63618293c58b5f80$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $63618293c58b5f80$var$reverseUnits = $63618293c58b5f80$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $63618293c58b5f80$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $63618293c58b5f80$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $63618293c58b5f80$var$Duration(conf);
}
function $63618293c58b5f80$var$durationToMillis(matrix, vals) {
    var _vals$milliseconds;
    var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$reverseUnits.slice(1)), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    }
    return sum;
}
// NB: mutates parameters
function $63618293c58b5f80$var$normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    var factor = $63618293c58b5f80$var$durationToMillis(matrix, vals) < 0 ? -1 : 1;
    $63618293c58b5f80$var$orderedUnits$1.reduceRight(function(previous, current) {
        if (!$63618293c58b5f80$var$isUndefined(vals[current])) {
            if (previous) {
                var previousVal = vals[previous] * factor;
                var conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                var rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    $63618293c58b5f80$var$orderedUnits$1.reduce(function(previous, current) {
        if (!$63618293c58b5f80$var$isUndefined(vals[current])) {
            if (previous) {
                var fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $63618293c58b5f80$var$removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $63618293c58b5f80$var$Duration = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? $63618293c58b5f80$var$accurateMatrix : $63618293c58b5f80$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $63618293c58b5f80$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    } /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */ ;
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $63618293c58b5f80$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $63618293c58b5f80$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $63618293c58b5f80$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    } /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ ;
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($63618293c58b5f80$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $63618293c58b5f80$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    } /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ ;
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $63618293c58b5f80$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ ;
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $63618293c58b5f80$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ ;
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    } /**
   * @private
   */ ;
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $63618293c58b5f80$var$InvalidUnitError(unit);
        return normalized;
    } /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    } /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ ;
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $63618293c58b5f80$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $63618293c58b5f80$var$INVALID$2;
    } /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */ ;
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$2;
        var l = $63618293c58b5f80$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($63618293c58b5f80$var$isUndefined(val)) return null;
            return _this.loc.numberFormatter($63618293c58b5f80$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($63618293c58b5f80$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    } /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $63618293c58b5f80$var$_extends({}, this.values);
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ ;
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $63618293c58b5f80$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $63618293c58b5f80$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts, {
            includeOffset: false
        });
        var dateTime = $63618293c58b5f80$var$DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.toISO();
    } /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */ ;
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Duration { values: " + JSON.stringify(this.values) + " }";
        else return "Duration { Invalid, reason: " + this.invalidReason + " }";
    } /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        if (!this.isValid) return NaN;
        return $63618293c58b5f80$var$durationToMillis(this.matrix, this.values);
    } /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = $63618293c58b5f80$var$orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if ($63618293c58b5f80$var$hasOwnProperty(dur.values, k) || $63618293c58b5f80$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $63618293c58b5f80$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    } /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ ;
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = $63618293c58b5f80$var$asNumber(fn(this.values[k], k));
        }
        return $63618293c58b5f80$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ ;
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    } /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $63618293c58b5f80$var$_extends({}, this.values, $63618293c58b5f80$var$normalizeObject(values, Duration.normalizeUnit));
        return $63618293c58b5f80$var$clone$1(this, {
            values: mixed
        });
    } /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ ;
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $63618293c58b5f80$var$clone$1(this, opts);
    } /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ ;
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    } /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */ ;
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $63618293c58b5f80$var$normalizeValues(this.matrix, vals);
        return $63618293c58b5f80$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */ ;
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = $63618293c58b5f80$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $63618293c58b5f80$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ ;
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = $63618293c58b5f80$var$orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($63618293c58b5f80$var$isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if ($63618293c58b5f80$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        $63618293c58b5f80$var$normalizeValues(this.matrix, built);
        return $63618293c58b5f80$var$clone$1(this, {
            values: built
        }, true);
    } /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */ ;
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    } /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ ;
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $63618293c58b5f80$var$clone$1(this, {
            values: negated
        }, true);
    } /**
   * Get the years.
   * @type {number}
   */ ;
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = $63618293c58b5f80$var$orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $63618293c58b5f80$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}(Symbol.for("nodejs.util.inspect.custom"));
var $63618293c58b5f80$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $63618293c58b5f80$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $63618293c58b5f80$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $63618293c58b5f80$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $63618293c58b5f80$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $63618293c58b5f80$var$Interval = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    } /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ ;
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $63618293c58b5f80$var$friendlyDateTime(start), builtEnd = $63618293c58b5f80$var$friendlyDateTime(end);
        var validateError = $63618293c58b5f80$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    } /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.after = function after(start, duration) {
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration), dt = $63618293c58b5f80$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    } /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.before = function before(end, duration) {
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration), dt = $63618293c58b5f80$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    } /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ ;
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $63618293c58b5f80$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $63618293c58b5f80$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $63618293c58b5f80$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $63618293c58b5f80$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    } /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    } /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ ;
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    } /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */ ;
    _proto.count = function count(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit, opts);
        var end;
        if (opts != null && opts.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    } /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    } /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ ;
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    } /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    } /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    } /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    } /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ ;
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    } /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ ;
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($63618293c58b5f80$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(function(a, b) {
            return a.toMillis() - b.toMillis();
        }), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    } /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ ;
    _proto.splitBy = function splitBy(duration) {
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    } /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ ;
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    } /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    } /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    } /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    } /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    } /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    } /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    } /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    } /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    } /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    } /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ ;
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    } /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    } /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */ ;
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Interval { start: " + this.s.toISO() + ", end: " + this.e.toISO() + " }";
        else return "Interval { Invalid, reason: " + this.invalidReason + " }";
    } /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $63618293c58b5f80$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $63618293c58b5f80$var$INVALID$1;
    } /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    } /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    } /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    } /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    } /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ ;
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $63618293c58b5f80$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    } /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ ;
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $63618293c58b5f80$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}(Symbol.for("nodejs.util.inspect.custom"));
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $63618293c58b5f80$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $63618293c58b5f80$var$Settings.defaultZone;
        var proto = $63618293c58b5f80$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    } /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ ;
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $63618293c58b5f80$var$IANAZone.isValidZone(zone);
    } /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ ;
    Info.normalizeZone = function normalizeZone$1(input) {
        return $63618293c58b5f80$var$normalizeZone(input, $63618293c58b5f80$var$Settings.defaultZone);
    } /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */ ;
    Info.getStartOfWeek = function getStartOfWeek(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale)).getStartOfWeek();
    } /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */ ;
    Info.getMinimumDaysInFirstWeek = function getMinimumDaysInFirstWeek(_temp2) {
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale)).getMinDaysInFirstWeek();
    } /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */ ;
    Info.getWeekendWeekdays = function getWeekendWeekdays(_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        // copy the array, because we cache it internally
        return (locObj || $63618293c58b5f80$var$Locale.create(locale)).getWeekendDays().slice();
    } /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ ;
    Info.months = function months(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj, _ref4$outputCalendar = _ref4.outputCalendar, outputCalendar = _ref4$outputCalendar === void 0 ? "gregory" : _ref4$outputCalendar;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    } /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ ;
    Info.monthsFormat = function monthsFormat(length, _temp5) {
        if (length === void 0) length = "long";
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale, _ref5$numberingSystem = _ref5.numberingSystem, numberingSystem = _ref5$numberingSystem === void 0 ? null : _ref5$numberingSystem, _ref5$locObj = _ref5.locObj, locObj = _ref5$locObj === void 0 ? null : _ref5$locObj, _ref5$outputCalendar = _ref5.outputCalendar, outputCalendar = _ref5$outputCalendar === void 0 ? "gregory" : _ref5$outputCalendar;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    } /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ ;
    Info.weekdays = function weekdays(length, _temp6) {
        if (length === void 0) length = "long";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale, _ref6$numberingSystem = _ref6.numberingSystem, numberingSystem = _ref6$numberingSystem === void 0 ? null : _ref6$numberingSystem, _ref6$locObj = _ref6.locObj, locObj = _ref6$locObj === void 0 ? null : _ref6$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    } /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ ;
    Info.weekdaysFormat = function weekdaysFormat(length, _temp7) {
        if (length === void 0) length = "long";
        var _ref7 = _temp7 === void 0 ? {} : _temp7, _ref7$locale = _ref7.locale, locale = _ref7$locale === void 0 ? null : _ref7$locale, _ref7$numberingSystem = _ref7.numberingSystem, numberingSystem = _ref7$numberingSystem === void 0 ? null : _ref7$numberingSystem, _ref7$locObj = _ref7.locObj, locObj = _ref7$locObj === void 0 ? null : _ref7$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    } /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ ;
    Info.meridiems = function meridiems(_temp8) {
        var _ref8 = _temp8 === void 0 ? {} : _temp8, _ref8$locale = _ref8.locale, locale = _ref8$locale === void 0 ? null : _ref8$locale;
        return $63618293c58b5f80$var$Locale.create(locale).meridiems();
    } /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ ;
    Info.eras = function eras(length, _temp9) {
        if (length === void 0) length = "short";
        var _ref9 = _temp9 === void 0 ? {} : _temp9, _ref9$locale = _ref9.locale, locale = _ref9$locale === void 0 ? null : _ref9$locale;
        return $63618293c58b5f80$var$Locale.create(locale, null, "gregory").eras(length);
    } /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */ ;
    Info.features = function features() {
        return {
            relative: $63618293c58b5f80$var$hasRelative(),
            localeWeek: $63618293c58b5f80$var$hasLocaleWeekInfo()
        };
    };
    return Info;
}();
function $63618293c58b5f80$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($63618293c58b5f80$var$Duration.fromMillis(ms).as("days"));
}
function $63618293c58b5f80$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $63618293c58b5f80$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $63618293c58b5f80$var$dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                // we overshot the end point, backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
                // if we are still overshooting now, we need to backtrack again
                // this happens in certain situations when diffing times in different zones,
                // because this calculation ignores time zones
                if (cursor > later) {
                    // keep the "overshot by 1" around as highWater
                    highWater = cursor;
                    // backtrack cursor by 1
                    results[unit]--;
                    cursor = earlier.plus(results);
                }
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $63618293c58b5f80$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $63618293c58b5f80$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $63618293c58b5f80$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $63618293c58b5f80$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $63618293c58b5f80$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $63618293c58b5f80$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($63618293c58b5f80$var$parseDigits(s));
        }
    };
}
var $63618293c58b5f80$var$NBSP = String.fromCharCode(160);
var $63618293c58b5f80$var$spaceOrNBSP = "[ " + $63618293c58b5f80$var$NBSP + "]";
var $63618293c58b5f80$var$spaceOrNBSPRegExp = new RegExp($63618293c58b5f80$var$spaceOrNBSP, "g");
function $63618293c58b5f80$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($63618293c58b5f80$var$spaceOrNBSPRegExp, $63618293c58b5f80$var$spaceOrNBSP);
}
function $63618293c58b5f80$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($63618293c58b5f80$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $63618293c58b5f80$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($63618293c58b5f80$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $63618293c58b5f80$var$stripInsensitivities(s) === $63618293c58b5f80$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $63618293c58b5f80$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $63618293c58b5f80$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $63618293c58b5f80$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $63618293c58b5f80$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function $63618293c58b5f80$var$unitForToken(token, loc) {
    var one = $63618293c58b5f80$var$digitRegex(loc), two = $63618293c58b5f80$var$digitRegex(loc, "{2}"), three = $63618293c58b5f80$var$digitRegex(loc, "{3}"), four = $63618293c58b5f80$var$digitRegex(loc, "{4}"), six = $63618293c58b5f80$var$digitRegex(loc, "{6}"), oneOrTwo = $63618293c58b5f80$var$digitRegex(loc, "{1,2}"), oneToThree = $63618293c58b5f80$var$digitRegex(loc, "{1,3}"), oneToSix = $63618293c58b5f80$var$digitRegex(loc, "{1,6}"), oneToNine = $63618293c58b5f80$var$digitRegex(loc, "{1,9}"), twoToFour = $63618293c58b5f80$var$digitRegex(loc, "{2,4}"), fourToSix = $63618293c58b5f80$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($63618293c58b5f80$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $63618293c58b5f80$var$oneOf(loc.eras("short"), 0);
            case "GG":
                return $63618293c58b5f80$var$oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return $63618293c58b5f80$var$intUnit(oneToSix);
            case "yy":
                return $63618293c58b5f80$var$intUnit(twoToFour, $63618293c58b5f80$var$untruncateYear);
            case "yyyy":
                return $63618293c58b5f80$var$intUnit(four);
            case "yyyyy":
                return $63618293c58b5f80$var$intUnit(fourToSix);
            case "yyyyyy":
                return $63618293c58b5f80$var$intUnit(six);
            // months
            case "M":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "MM":
                return $63618293c58b5f80$var$intUnit(two);
            case "MMM":
                return $63618293c58b5f80$var$oneOf(loc.months("short", true), 1);
            case "MMMM":
                return $63618293c58b5f80$var$oneOf(loc.months("long", true), 1);
            case "L":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "LL":
                return $63618293c58b5f80$var$intUnit(two);
            case "LLL":
                return $63618293c58b5f80$var$oneOf(loc.months("short", false), 1);
            case "LLLL":
                return $63618293c58b5f80$var$oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "dd":
                return $63618293c58b5f80$var$intUnit(two);
            // ordinals
            case "o":
                return $63618293c58b5f80$var$intUnit(oneToThree);
            case "ooo":
                return $63618293c58b5f80$var$intUnit(three);
            // time
            case "HH":
                return $63618293c58b5f80$var$intUnit(two);
            case "H":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "hh":
                return $63618293c58b5f80$var$intUnit(two);
            case "h":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "mm":
                return $63618293c58b5f80$var$intUnit(two);
            case "m":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "q":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "qq":
                return $63618293c58b5f80$var$intUnit(two);
            case "s":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "ss":
                return $63618293c58b5f80$var$intUnit(two);
            case "S":
                return $63618293c58b5f80$var$intUnit(oneToThree);
            case "SSS":
                return $63618293c58b5f80$var$intUnit(three);
            case "u":
                return $63618293c58b5f80$var$simple(oneToNine);
            case "uu":
                return $63618293c58b5f80$var$simple(oneOrTwo);
            case "uuu":
                return $63618293c58b5f80$var$intUnit(one);
            // meridiem
            case "a":
                return $63618293c58b5f80$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $63618293c58b5f80$var$intUnit(four);
            case "kk":
                return $63618293c58b5f80$var$intUnit(twoToFour, $63618293c58b5f80$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "WW":
                return $63618293c58b5f80$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $63618293c58b5f80$var$intUnit(one);
            case "EEE":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $63618293c58b5f80$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $63618293c58b5f80$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $63618293c58b5f80$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $63618293c58b5f80$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $63618293c58b5f80$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $63618293c58b5f80$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $63618293c58b5f80$var$tokenForPart(part, formatOpts, resolvedOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    var actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    var val = $63618293c58b5f80$var$partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $63618293c58b5f80$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $63618293c58b5f80$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($63618293c58b5f80$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $63618293c58b5f80$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$63618293c58b5f80$var$isUndefined(matches.z)) zone = $63618293c58b5f80$var$IANAZone.create(matches.z);
    if (!$63618293c58b5f80$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $63618293c58b5f80$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$63618293c58b5f80$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$63618293c58b5f80$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$63618293c58b5f80$var$isUndefined(matches.u)) matches.S = $63618293c58b5f80$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $63618293c58b5f80$var$dummyDateTimeCache = null;
function $63618293c58b5f80$var$getDummyDateTime() {
    if (!$63618293c58b5f80$var$dummyDateTimeCache) $63618293c58b5f80$var$dummyDateTimeCache = $63618293c58b5f80$var$DateTime.fromMillis(1555555555555);
    return $63618293c58b5f80$var$dummyDateTimeCache;
}
function $63618293c58b5f80$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $63618293c58b5f80$var$Formatter.macroTokenToFormatOpts(token.val);
    var tokens = $63618293c58b5f80$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $63618293c58b5f80$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $63618293c58b5f80$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ var $63618293c58b5f80$var$TokenParser = /*#__PURE__*/ function() {
    function TokenParser(locale, format) {
        this.locale = locale;
        this.format = format;
        this.tokens = $63618293c58b5f80$var$expandMacroTokens($63618293c58b5f80$var$Formatter.parseFormat(format), locale);
        this.units = this.tokens.map(function(t) {
            return $63618293c58b5f80$var$unitForToken(t, locale);
        });
        this.disqualifyingUnit = this.units.find(function(t) {
            return t.invalidReason;
        });
        if (!this.disqualifyingUnit) {
            var _buildRegex = $63618293c58b5f80$var$buildRegex(this.units), regexString = _buildRegex[0], handlers = _buildRegex[1];
            this.regex = RegExp(regexString, "i");
            this.handlers = handlers;
        }
    }
    var _proto = TokenParser.prototype;
    _proto.explainFromTokens = function explainFromTokens(input) {
        if (!this.isValid) return {
            input: input,
            tokens: this.tokens,
            invalidReason: this.invalidReason
        };
        else {
            var _match = $63618293c58b5f80$var$match(input, this.regex, this.handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $63618293c58b5f80$var$dateTimeFromMatches(matches) : [
                null,
                null,
                undefined
            ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
            if ($63618293c58b5f80$var$hasOwnProperty(matches, "a") && $63618293c58b5f80$var$hasOwnProperty(matches, "H")) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
            return {
                input: input,
                tokens: this.tokens,
                regex: this.regex,
                rawMatches: rawMatches,
                matches: matches,
                result: result,
                zone: zone,
                specificOffset: specificOffset
            };
        }
    };
    $63618293c58b5f80$var$_createClass(TokenParser, [
        {
            key: "isValid",
            get: function get() {
                return !this.disqualifyingUnit;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
            }
        }
    ]);
    return TokenParser;
}();
function $63618293c58b5f80$var$explainFromTokens(locale, input, format) {
    var parser = new $63618293c58b5f80$var$TokenParser(locale, format);
    return parser.explainFromTokens(input);
}
function $63618293c58b5f80$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $63618293c58b5f80$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $63618293c58b5f80$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = $63618293c58b5f80$var$Formatter.create(locale, formatOpts);
    var df = formatter.dtFormatter($63618293c58b5f80$var$getDummyDateTime());
    var parts = df.formatToParts();
    var resolvedOpts = df.resolvedOptions();
    return parts.map(function(p) {
        return $63618293c58b5f80$var$tokenForPart(p, formatOpts, resolvedOpts);
    });
}
var $63618293c58b5f80$var$INVALID = "Invalid DateTime";
var $63618293c58b5f80$var$MAX_DATE = 8.64e15;
function $63618293c58b5f80$var$unsupportedZone(zone) {
    return new $63618293c58b5f80$var$Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function $63618293c58b5f80$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $63618293c58b5f80$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function $63618293c58b5f80$var$possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = $63618293c58b5f80$var$gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $63618293c58b5f80$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $63618293c58b5f80$var$DateTime($63618293c58b5f80$var$_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $63618293c58b5f80$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $63618293c58b5f80$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $63618293c58b5f80$var$objToTS(obj, offset, zone) {
    return $63618293c58b5f80$var$fixOffset($63618293c58b5f80$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $63618293c58b5f80$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $63618293c58b5f80$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $63618293c58b5f80$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $63618293c58b5f80$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $63618293c58b5f80$var$objToLocalTS(c);
    var _fixOffset = $63618293c58b5f80$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $63618293c58b5f80$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = $63618293c58b5f80$var$DateTime.fromObject(parsed, $63618293c58b5f80$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $63618293c58b5f80$var$DateTime.invalid(new $63618293c58b5f80$var$Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $63618293c58b5f80$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $63618293c58b5f80$var$Formatter.create($63618293c58b5f80$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $63618293c58b5f80$var$_toISODate(o, extended) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $63618293c58b5f80$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += $63618293c58b5f80$var$padStart(o.c.month);
        c += "-";
        c += $63618293c58b5f80$var$padStart(o.c.day);
    } else {
        c += $63618293c58b5f80$var$padStart(o.c.month);
        c += $63618293c58b5f80$var$padStart(o.c.day);
    }
    return c;
}
function $63618293c58b5f80$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
    var c = $63618293c58b5f80$var$padStart(o.c.hour);
    if (extended) {
        c += ":";
        c += $63618293c58b5f80$var$padStart(o.c.minute);
        if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += $63618293c58b5f80$var$padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
        c += $63618293c58b5f80$var$padStart(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += $63618293c58b5f80$var$padStart(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $63618293c58b5f80$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $63618293c58b5f80$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $63618293c58b5f80$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $63618293c58b5f80$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var $63618293c58b5f80$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $63618293c58b5f80$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $63618293c58b5f80$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var $63618293c58b5f80$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $63618293c58b5f80$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $63618293c58b5f80$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $63618293c58b5f80$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $63618293c58b5f80$var$InvalidUnitError(unit);
    return normalized;
}
function $63618293c58b5f80$var$normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return $63618293c58b5f80$var$normalizeUnit(unit);
    }
}
// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
function $63618293c58b5f80$var$guessOffsetForZone(zone) {
    if (!$63618293c58b5f80$var$zoneOffsetGuessCache[zone]) {
        if ($63618293c58b5f80$var$zoneOffsetTs === undefined) $63618293c58b5f80$var$zoneOffsetTs = $63618293c58b5f80$var$Settings.now();
        $63618293c58b5f80$var$zoneOffsetGuessCache[zone] = zone.offset($63618293c58b5f80$var$zoneOffsetTs);
    }
    return $63618293c58b5f80$var$zoneOffsetGuessCache[zone];
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $63618293c58b5f80$var$quickDT(obj, opts) {
    var zone = $63618293c58b5f80$var$normalizeZone(opts.zone, $63618293c58b5f80$var$Settings.defaultZone);
    if (!zone.isValid) return $63618293c58b5f80$var$DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zone));
    var loc = $63618293c58b5f80$var$Locale.fromObject(opts);
    var ts, o;
    // assume we have the higher-order units
    if (!$63618293c58b5f80$var$isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = $63618293c58b5f80$var$orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if ($63618293c58b5f80$var$isUndefined(obj[u])) obj[u] = $63618293c58b5f80$var$defaultUnitValues[u];
        }
        var invalid = $63618293c58b5f80$var$hasInvalidGregorianData(obj) || $63618293c58b5f80$var$hasInvalidTimeData(obj);
        if (invalid) return $63618293c58b5f80$var$DateTime.invalid(invalid);
        var offsetProvis = $63618293c58b5f80$var$guessOffsetForZone(zone);
        var _objToTS = $63618293c58b5f80$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = $63618293c58b5f80$var$Settings.now();
    return new $63618293c58b5f80$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $63618293c58b5f80$var$diffRelative(start, end, opts) {
    var round = $63618293c58b5f80$var$isUndefined(opts.round) ? true : opts.round, format = function format(c, unit) {
        c = $63618293c58b5f80$var$roundTo(c, round || opts.calendary ? 0 : 2, true);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $63618293c58b5f80$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */ var $63618293c58b5f80$var$zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */ var $63618293c58b5f80$var$zoneOffsetGuessCache = {};
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $63618293c58b5f80$var$DateTime = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $63618293c58b5f80$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $63618293c58b5f80$var$Invalid("invalid input") : null) || (!zone.isValid ? $63618293c58b5f80$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $63618293c58b5f80$var$isUndefined(config.ts) ? $63618293c58b5f80$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                // If an offset has been passed and we have not been called from
                // clone(), we can trust it and avoid the offset calculation.
                var ot = $63618293c58b5f80$var$isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
                c = $63618293c58b5f80$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $63618293c58b5f80$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $63618293c58b5f80$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    } /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ ;
    DateTime.local = function local() {
        var _lastOpts = $63618293c58b5f80$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $63618293c58b5f80$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ ;
    DateTime.utc = function utc() {
        var _lastOpts2 = $63618293c58b5f80$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $63618293c58b5f80$var$FixedOffsetZone.utcInstance;
        return $63618293c58b5f80$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ ;
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $63618293c58b5f80$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$63618293c58b5f80$var$isNumber(milliseconds)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$63618293c58b5f80$var$MAX_DATE || milliseconds > $63618293c58b5f80$var$MAX_DATE) // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone),
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$63618293c58b5f80$var$isNumber(seconds)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone),
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */ ;
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $63618293c58b5f80$var$normalizeZone(opts.zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zoneToUse));
        var loc = $63618293c58b5f80$var$Locale.fromObject(opts);
        var normalized = $63618293c58b5f80$var$normalizeObject(obj, $63618293c58b5f80$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues = $63618293c58b5f80$var$usesLocalWeekValues(normalized, loc), minDaysInFirstWeek = _usesLocalWeekValues.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues.startOfWeek;
        var tsNow = $63618293c58b5f80$var$Settings.now(), offsetProvis = !$63618293c58b5f80$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !$63618293c58b5f80$var$isUndefined(normalized.ordinal), containsGregorYear = !$63618293c58b5f80$var$isUndefined(normalized.year), containsGregorMD = !$63618293c58b5f80$var$isUndefined(normalized.month) || !$63618293c58b5f80$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $63618293c58b5f80$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $63618293c58b5f80$var$orderedWeekUnits;
            defaultValues = $63618293c58b5f80$var$defaultWeekUnitValues;
            objNow = $63618293c58b5f80$var$gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = $63618293c58b5f80$var$orderedOrdinalUnits;
            defaultValues = $63618293c58b5f80$var$defaultOrdinalUnitValues;
            objNow = $63618293c58b5f80$var$gregorianToOrdinal(objNow);
        } else {
            units = $63618293c58b5f80$var$orderedUnits;
            defaultValues = $63618293c58b5f80$var$defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!$63618293c58b5f80$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $63618293c58b5f80$var$hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $63618293c58b5f80$var$hasInvalidOrdinalData(normalized) : $63618293c58b5f80$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $63618293c58b5f80$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? $63618293c58b5f80$var$weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $63618293c58b5f80$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $63618293c58b5f80$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        if (!inst.isValid) return DateTime.invalid(inst.invalid);
        return inst;
    } /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ ;
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $63618293c58b5f80$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    } /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ ;
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $63618293c58b5f80$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    } /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ ;
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $63618293c58b5f80$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    } /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($63618293c58b5f80$var$isUndefined(text) || $63618293c58b5f80$var$isUndefined(fmt)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $63618293c58b5f80$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    } /**
   * @deprecated use fromFormat instead
   */ ;
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    } /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ ;
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $63618293c58b5f80$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    } /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ ;
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    } /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    } /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = $63618293c58b5f80$var$formatOptsToTokens(formatOpts, $63618293c58b5f80$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    } /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = $63618293c58b5f80$var$expandMacroTokens($63618293c58b5f80$var$Formatter.parseFormat(fmt), $63618293c58b5f80$var$Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    };
    DateTime.resetCache = function resetCache() {
        $63618293c58b5f80$var$zoneOffsetTs = undefined;
        $63618293c58b5f80$var$zoneOffsetGuessCache = {};
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ ;
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    } /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ ;
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ _proto.getPossibleOffsets = function getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        var dayMs = 86400000;
        var minuteMs = 60000;
        var localTS = $63618293c58b5f80$var$objToLocalTS(this.c);
        var oEarlier = this.zone.offset(localTS - dayMs);
        var oLater = this.zone.offset(localTS + dayMs);
        var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        var o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        var ts1 = localTS - o1 * minuteMs;
        var ts2 = localTS - o2 * minuteMs;
        var c1 = $63618293c58b5f80$var$tsToObj(ts1, o1);
        var c2 = $63618293c58b5f80$var$tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            $63618293c58b5f80$var$clone(this, {
                ts: ts1
            }),
            $63618293c58b5f80$var$clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    } /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */ ;
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    } /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ ;
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($63618293c58b5f80$var$FixedOffsetZone.instance(offset), opts);
    } /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ ;
    _proto.toLocal = function toLocal() {
        return this.setZone($63618293c58b5f80$var$Settings.defaultZone);
    } /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ ;
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $63618293c58b5f80$var$normalizeZone(zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $63618293c58b5f80$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $63618293c58b5f80$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    } /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ ;
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $63618293c58b5f80$var$clone(this, {
            loc: loc
        });
    } /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ ;
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    } /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $63618293c58b5f80$var$normalizeObject(values, $63618293c58b5f80$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues2 = $63618293c58b5f80$var$usesLocalWeekValues(normalized, this.loc), minDaysInFirstWeek = _usesLocalWeekValues2.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues2.startOfWeek;
        var settingWeekStuff = !$63618293c58b5f80$var$isUndefined(normalized.weekYear) || !$63618293c58b5f80$var$isUndefined(normalized.weekNumber) || !$63618293c58b5f80$var$isUndefined(normalized.weekday), containsOrdinal = !$63618293c58b5f80$var$isUndefined(normalized.ordinal), containsGregorYear = !$63618293c58b5f80$var$isUndefined(normalized.year), containsGregorMD = !$63618293c58b5f80$var$isUndefined(normalized.month) || !$63618293c58b5f80$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $63618293c58b5f80$var$weekToGregorian($63618293c58b5f80$var$_extends({}, $63618293c58b5f80$var$gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), normalized), minDaysInFirstWeek, startOfWeek);
        else if (!$63618293c58b5f80$var$isUndefined(normalized.ordinal)) mixed = $63618293c58b5f80$var$ordinalToGregorian($63618293c58b5f80$var$_extends({}, $63618293c58b5f80$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $63618293c58b5f80$var$_extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($63618293c58b5f80$var$isUndefined(normalized.day)) mixed.day = Math.min($63618293c58b5f80$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $63618293c58b5f80$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $63618293c58b5f80$var$clone(this, {
            ts: ts,
            o: o
        });
    } /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration);
        return $63618293c58b5f80$var$clone(this, $63618293c58b5f80$var$adjustTime(this, dur));
    } /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration).negate();
        return $63618293c58b5f80$var$clone(this, $63618293c58b5f80$var$adjustTime(this, dur));
    } /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ ;
    _proto.startOf = function startOf(unit, _temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$useLocaleWeeks = _ref4.useLocaleWeeks, useLocaleWeeks = _ref4$useLocaleWeeks === void 0 ? false : _ref4$useLocaleWeeks;
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $63618293c58b5f80$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                var startOfWeek = this.loc.getStartOfWeek();
                var weekday = this.weekday;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    } /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ ;
    _proto.endOf = function endOf(unit, opts) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit, opts).minus(1) : this;
    } /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $63618293c58b5f80$var$INVALID;
    } /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $63618293c58b5f80$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $63618293c58b5f80$var$INVALID;
    } /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ ;
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */ ;
    _proto.toISO = function toISO(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format, _ref5$suppressSeconds = _ref5.suppressSeconds, suppressSeconds = _ref5$suppressSeconds === void 0 ? false : _ref5$suppressSeconds, _ref5$suppressMillise = _ref5.suppressMilliseconds, suppressMilliseconds = _ref5$suppressMillise === void 0 ? false : _ref5$suppressMillise, _ref5$includeOffset = _ref5.includeOffset, includeOffset = _ref5$includeOffset === void 0 ? true : _ref5$includeOffset, _ref5$extendedZone = _ref5.extendedZone, extendedZone = _ref5$extendedZone === void 0 ? false : _ref5$extendedZone;
        if (!this.isValid) return null;
        var ext = format === "extended";
        var c = $63618293c58b5f80$var$_toISODate(this, ext);
        c += "T";
        c += $63618293c58b5f80$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
        return c;
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format;
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$_toISODate(this, format === "extended");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ ;
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $63618293c58b5f80$var$toTechFormat(this, "kkkk-'W'WW-c");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$suppressMillise = _ref7.suppressMilliseconds, suppressMilliseconds = _ref7$suppressMillise === void 0 ? false : _ref7$suppressMillise, _ref7$suppressSeconds = _ref7.suppressSeconds, suppressSeconds = _ref7$suppressSeconds === void 0 ? false : _ref7$suppressSeconds, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includePrefix = _ref7.includePrefix, includePrefix = _ref7$includePrefix === void 0 ? false : _ref7$includePrefix, _ref7$extendedZone = _ref7.extendedZone, extendedZone = _ref7$extendedZone === void 0 ? false : _ref7$extendedZone, _ref7$format = _ref7.format, format = _ref7$format === void 0 ? "extended" : _ref7$format;
        if (!this.isValid) return null;
        var c = includePrefix ? "T" : "";
        return c + $63618293c58b5f80$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    } /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ ;
    _proto.toRFC2822 = function toRFC2822() {
        return $63618293c58b5f80$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    } /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ ;
    _proto.toHTTP = function toHTTP() {
        return $63618293c58b5f80$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */ ;
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$_toISODate(this, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQLTime = function toSQLTime(_temp7) {
        var _ref8 = _temp7 === void 0 ? {} : _temp7, _ref8$includeOffset = _ref8.includeOffset, includeOffset = _ref8$includeOffset === void 0 ? true : _ref8$includeOffset, _ref8$includeZone = _ref8.includeZone, includeZone = _ref8$includeZone === void 0 ? false : _ref8$includeZone, _ref8$includeOffsetSp = _ref8.includeOffsetSpace, includeOffsetSpace = _ref8$includeOffsetSp === void 0 ? true : _ref8$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $63618293c58b5f80$var$toTechFormat(this, fmt, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    } /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $63618293c58b5f80$var$INVALID;
    } /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */ ;
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "DateTime { ts: " + this.toISO() + ", zone: " + this.zone.name + ", locale: " + this.locale + " }";
        else return "DateTime { Invalid, reason: " + this.invalidReason + " }";
    } /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    } /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    } /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ ;
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    } /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    } /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $63618293c58b5f80$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    } /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    } /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ ;
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $63618293c58b5f80$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $63618293c58b5f80$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $63618293c58b5f80$var$maybeArray(unit).map($63618293c58b5f80$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $63618293c58b5f80$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    } /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ ;
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    } /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */ ;
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $63618293c58b5f80$var$Interval.fromDateTimes(this, otherDateTime) : this;
    } /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    } /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    } /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ ;
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $63618293c58b5f80$var$diffRelative(base, this.plus(padding), $63618293c58b5f80$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    } /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ ;
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $63618293c58b5f80$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    } /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ ;
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $63618293c58b5f80$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $63618293c58b5f80$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    } /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ ;
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $63618293c58b5f80$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $63618293c58b5f80$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    } /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ ;
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $63618293c58b5f80$var$explainFromTokens(localeToUse, text, fmt);
    } /**
   * @deprecated use fromFormatExplain instead
   */ ;
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    } /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */ ;
    DateTime.buildFormatParser = function buildFormatParser(fmt, options) {
        if (options === void 0) options = {};
        var _options2 = options, _options2$locale = _options2.locale, locale = _options2$locale === void 0 ? null : _options2$locale, _options2$numberingSy = _options2.numberingSystem, numberingSystem = _options2$numberingSy === void 0 ? null : _options2$numberingSy, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return new $63618293c58b5f80$var$TokenParser(localeToUse, fmt);
    } /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */ ;
    DateTime.fromFormatParser = function fromFormatParser(text, formatParser, opts) {
        if (opts === void 0) opts = {};
        if ($63618293c58b5f80$var$isUndefined(text) || $63618293c58b5f80$var$isUndefined(formatParser)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromFormatParser requires an input string and a format parser");
        var _opts2 = opts, _opts2$locale = _opts2.locale, locale = _opts2$locale === void 0 ? null : _opts2$locale, _opts2$numberingSyste = _opts2.numberingSystem, numberingSystem = _opts2$numberingSyste === void 0 ? null : _opts2$numberingSyste, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        if (!localeToUse.equals(formatParser.locale)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromFormatParser called with a locale of " + localeToUse + ", " + ("but the format parser was created for " + formatParser.locale));
        var _formatParser$explain = formatParser.explainFromTokens(text), result = _formatParser$explain.result, zone = _formatParser$explain.zone, specificOffset = _formatParser$explain.specificOffset, invalidReason = _formatParser$explain.invalidReason;
        if (invalidReason) return DateTime.invalid(invalidReason);
        else return $63618293c58b5f80$var$parseDataToDateTime(result, zone, opts, "format " + formatParser.format, text, specificOffset);
    } /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ ;
    $63618293c58b5f80$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "isWeekend",
            get: function get() {
                return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
            }
        },
        {
            key: "localWeekday",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedLocalWeekData(this).weekday : NaN;
            }
        },
        {
            key: "localWeekNumber",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedLocalWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "localWeekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedLocalWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $63618293c58b5f80$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $63618293c58b5f80$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        },
        {
            key: "weeksInLocalWeekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $63618293c58b5f80$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $63618293c58b5f80$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $63618293c58b5f80$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $63618293c58b5f80$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $63618293c58b5f80$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}(Symbol.for("nodejs.util.inspect.custom"));
function $63618293c58b5f80$var$friendlyDateTime(dateTimeish) {
    if ($63618293c58b5f80$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $63618293c58b5f80$var$isNumber(dateTimeish.valueOf())) return $63618293c58b5f80$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $63618293c58b5f80$var$DateTime.fromObject(dateTimeish);
    else throw new $63618293c58b5f80$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $63618293c58b5f80$var$VERSION = "3.5.0";
$63618293c58b5f80$exports.DateTime = $63618293c58b5f80$var$DateTime;
$63618293c58b5f80$exports.Duration = $63618293c58b5f80$var$Duration;
$63618293c58b5f80$exports.FixedOffsetZone = $63618293c58b5f80$var$FixedOffsetZone;
$63618293c58b5f80$exports.IANAZone = $63618293c58b5f80$var$IANAZone;
$63618293c58b5f80$exports.Info = $63618293c58b5f80$var$Info;
$63618293c58b5f80$exports.Interval = $63618293c58b5f80$var$Interval;
$63618293c58b5f80$exports.InvalidZone = $63618293c58b5f80$var$InvalidZone;
$63618293c58b5f80$exports.Settings = $63618293c58b5f80$var$Settings;
$63618293c58b5f80$exports.SystemZone = $63618293c58b5f80$var$SystemZone;
$63618293c58b5f80$exports.VERSION = $63618293c58b5f80$var$VERSION;
$63618293c58b5f80$exports.Zone = $63618293c58b5f80$var$Zone;


var $388b617130f03bd4$require$DateTime = $63618293c58b5f80$exports.DateTime;
var $d486cd8337e91fbc$exports = {};
(function(global, factory) {
    $d486cd8337e91fbc$exports = factory();
})($d486cd8337e91fbc$exports, function() {
    'use strict';
    /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */ var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === '[object Array]';
    };
    function isFunction(object) {
        return typeof object === 'function';
    }
    /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */ function typeStr(obj) {
        return isArray(obj) ? 'array' : typeof obj;
    }
    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
    }
    /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */ function hasProperty(obj, propName) {
        return obj != null && typeof obj === 'object' && propName in obj;
    }
    /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */ function primitiveHasOwnProperty(primitive, propName) {
        return primitive != null && typeof primitive !== 'object' && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
    }
    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    function testRegExp(re, string) {
        return regExpTest.call(re, string);
    }
    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }
    var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
    };
    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    }
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   *
   * Tokens for partials also contain two more elements: 1) a string value of
   * indendation prior to that tag and 2) the index of that tag on that line -
   * eg a value of 2 indicates the partial is the third tag on this line.
   */ function parseTemplate(template, tags) {
        if (!template) return [];
        var lineHasNonSpace = false;
        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?
        var indentation = ''; // Tracks indentation for tags that use it
        var tagIndex = 0; // Stores a count of number of tags encountered on a line
        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) while(spaces.length)delete tokens[spaces.pop()];
            else spaces = [];
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === 'string') tagsToCompile = tagsToCompile.split(spaceRe, 2);
            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error('Invalid tags: ' + tagsToCompile);
            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
            closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while(!scanner.eos()){
            start = scanner.pos;
            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);
            if (value) for(var i = 0, valueLength = value.length; i < valueLength; ++i){
                chr = value.charAt(i);
                if (isWhitespace(chr)) {
                    spaces.push(tokens.length);
                    indentation += chr;
                } else {
                    nonSpace = true;
                    lineHasNonSpace = true;
                    indentation += ' ';
                }
                tokens.push([
                    'text',
                    chr,
                    start,
                    start + 1
                ]);
                start += 1;
                // Check for whitespace on the current line.
                if (chr === '\n') {
                    stripSpace();
                    indentation = '';
                    tagIndex = 0;
                    lineHasNonSpace = false;
                }
            }
            // Match the opening tag.
            if (!scanner.scan(openingTagRe)) break;
            hasTag = true;
            // Get the tag type.
            type = scanner.scan(tagRe) || 'name';
            scanner.scan(whiteRe);
            // Get the tag value.
            if (type === '=') {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === '{') {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = '&';
            } else value = scanner.scanUntil(closingTagRe);
            // Match the closing tag.
            if (!scanner.scan(closingTagRe)) throw new Error('Unclosed tag at ' + scanner.pos);
            if (type == '>') token = [
                type,
                value,
                start,
                scanner.pos,
                indentation,
                tagIndex,
                lineHasNonSpace
            ];
            else token = [
                type,
                value,
                start,
                scanner.pos
            ];
            tagIndex++;
            tokens.push(token);
            if (type === '#' || type === '^') sections.push(token);
            else if (type === '/') {
                // Check section nesting.
                openSection = sections.pop();
                if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === 'name' || type === '{' || type === '&') nonSpace = true;
            else if (type === '=') // Set the tags for the next time around.
            compileTags(value);
        }
        stripSpace();
        // Make sure there are no open sections when we're done.
        openSection = sections.pop();
        if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    }
    /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */ function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            if (token) {
                if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    }
    /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */ function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            switch(token[0]){
                case '#':
                case '^':
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case '/':
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    }
    /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */ function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }
    /**
   * Returns `true` if the tail is empty (end of string).
   */ Scanner.prototype.eos = function eos() {
        return this.tail === '';
    };
    /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */ Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0) return '';
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */ Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re), match;
        switch(index){
            case -1:
                match = this.tail;
                this.tail = '';
                break;
            case 0:
                match = '';
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */ function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            '.': this.view
        };
        this.parent = parentContext;
    }
    /**
   * Creates a new context using the given view with this context
   * as the parent.
   */ Context.prototype.push = function push(view) {
        return new Context(view, this);
    };
    /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */ Context.prototype.lookup = function lookup(name) {
        var cache1 = this.cache;
        var value;
        if (cache1.hasOwnProperty(name)) value = cache1[name];
        else {
            var context = this, intermediateValue, names, index, lookupHit = false;
            while(context){
                if (name.indexOf('.') > 0) {
                    intermediateValue = context.view;
                    names = name.split('.');
                    index = 0;
                    /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/ while(intermediateValue != null && index < names.length){
                        if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
                        intermediateValue = intermediateValue[names[index++]];
                    }
                } else {
                    intermediateValue = context.view[name];
                    /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/ lookupHit = hasProperty(context.view, name);
                }
                if (lookupHit) {
                    value = intermediateValue;
                    break;
                }
                context = context.parent;
            }
            cache1[name] = value;
        }
        if (isFunction(value)) value = value.call(this.view);
        return value;
    };
    /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */ function Writer() {
        this.templateCache = {
            _cache: {},
            set: function set(key, value) {
                this._cache[key] = value;
            },
            get: function get(key) {
                return this._cache[key];
            },
            clear: function clear() {
                this._cache = {};
            }
        };
    }
    /**
   * Clears all cached templates in this writer.
   */ Writer.prototype.clearCache = function clearCache() {
        if (typeof this.templateCache !== 'undefined') this.templateCache.clear();
    };
    /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */ Writer.prototype.parse = function parse(template, tags) {
        var cache1 = this.templateCache;
        var cacheKey = template + ':' + (tags || mustache.tags).join(':');
        var isCacheEnabled = typeof cache1 !== 'undefined';
        var tokens = isCacheEnabled ? cache1.get(cacheKey) : undefined;
        if (tokens == undefined) {
            tokens = parseTemplate(template, tags);
            isCacheEnabled && cache1.set(cacheKey, tokens);
        }
        return tokens;
    };
    /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `config` argument is given here, then it should be an
   * object with a `tags` attribute or an `escape` attribute or both.
   * If an array is passed, then it will be interpreted the same way as
   * a `tags` attribute on a `config` object.
   *
   * The `tags` attribute of a `config` object must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   *
   * The `escape` attribute of a `config` object must be a function which
   * accepts a string as input and outputs a safely escaped string.
   * If an `escape` function is not provided, then an HTML-safe string
   * escaping function is used as the default.
   */ Writer.prototype.render = function render(template, view, partials, config) {
        var tags = this.getConfigTags(config);
        var tokens = this.parse(template, tags);
        var context = view instanceof Context ? view : new Context(view, undefined);
        return this.renderTokens(tokens, context, partials, template, config);
    };
    /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */ Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
        var buffer = '';
        var token, symbol, value;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            value = undefined;
            token = tokens[i];
            symbol = token[0];
            if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate, config);
            else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate, config);
            else if (symbol === '>') value = this.renderPartial(token, context, partials, config);
            else if (symbol === '&') value = this.unescapedValue(token, context);
            else if (symbol === 'name') value = this.escapedValue(token, context, config);
            else if (symbol === 'text') value = this.rawValue(token);
            if (value !== undefined) buffer += value;
        }
        return buffer;
    };
    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
        var self = this;
        var buffer = '';
        var value = context.lookup(token[1]);
        // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials, config);
        }
        if (!value) return;
        if (isArray(value)) for(var j = 0, valueLength = value.length; j < valueLength; ++j)buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
        else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
        else if (isFunction(value)) {
            if (typeof originalTemplate !== 'string') throw new Error('Cannot use higher-order sections without the original template');
            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
            if (value != null) buffer += value;
        } else buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
        return buffer;
    };
    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
        var value = context.lookup(token[1]);
        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate, config);
    };
    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
        var filteredIndentation = indentation.replace(/[^ \t]/g, '');
        var partialByNl = partial.split('\n');
        for(var i = 0; i < partialByNl.length; i++)if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) partialByNl[i] = filteredIndentation + partialByNl[i];
        return partialByNl.join('\n');
    };
    Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
        if (!partials) return;
        var tags = this.getConfigTags(config);
        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) {
            var lineHasNonSpace = token[6];
            var tagIndex = token[5];
            var indentation = token[4];
            var indentedValue = value;
            if (tagIndex == 0 && indentation) indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
            var tokens = this.parse(indentedValue, tags);
            return this.renderTokens(tokens, context, partials, indentedValue, config);
        }
    };
    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return value;
    };
    Writer.prototype.escapedValue = function escapedValue(token, context, config) {
        var escape = this.getConfigEscape(config) || mustache.escape;
        var value = context.lookup(token[1]);
        if (value != null) return typeof value === 'number' && escape === mustache.escape ? String(value) : escape(value);
    };
    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };
    Writer.prototype.getConfigTags = function getConfigTags(config) {
        if (isArray(config)) return config;
        else if (config && typeof config === 'object') return config.tags;
        else return undefined;
    };
    Writer.prototype.getConfigEscape = function getConfigEscape(config) {
        if (config && typeof config === 'object' && !isArray(config)) return config.escape;
        else return undefined;
    };
    var mustache = {
        name: 'mustache.js',
        version: '4.2.0',
        tags: [
            '{{',
            '}}'
        ],
        clearCache: undefined,
        escape: undefined,
        parse: undefined,
        render: undefined,
        Scanner: undefined,
        Context: undefined,
        Writer: undefined,
        /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */ set templateCache (cache){
            defaultWriter.templateCache = cache;
        },
        /**
     * Gets the default or overridden caching object from the default writer.
     */ get templateCache () {
            return defaultWriter.templateCache;
        }
    };
    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();
    /**
   * Clears all cached templates in the default writer.
   */ mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };
    /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */ mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };
    /**
   * Renders the `template` with the given `view`, `partials`, and `config`
   * using the default writer.
   */ mustache.render = function render(template, view, partials, config) {
        if (typeof template !== 'string') throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first ' + 'argument for mustache#render(template, view, partials)');
        return defaultWriter.render(template, view, partials, config);
    };
    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;
    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
});


/**
 * Register countries in browsers' environment:
 * @param {object} localeData
 * @example countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
 * @return void
 */ var $15e3aefa8e338b9b$export$bab6a7822cc1e2cd;
var $15e3aefa8e338b9b$export$2a91d0f6f59b9f68;
var $15e3aefa8e338b9b$export$65a456803fd0f049;
var $15e3aefa8e338b9b$export$442b6884bee533cd;
var $15e3aefa8e338b9b$export$e8f1fd30e9fba660;
var $15e3aefa8e338b9b$export$c50ba58d0968541f;
var $15e3aefa8e338b9b$export$e21a59c72a3c77a7;
var $15e3aefa8e338b9b$export$3d1d5c3d00561285;
var $15e3aefa8e338b9b$export$53e0b99b5d556acf;
/**
 * @param {string | number | Alpha2Code | Alpha3Code} code
 * @param {String} lang          language for country name
 * @param {GetNameOptions} options
 * @return {String | String[] | undefined}  name
 */ var $15e3aefa8e338b9b$export$7d9f7e9c1c02b41e;
/**
 * @param {String} lang             language for country names
 * @param {GetNameOptions} options   getNames Options
 * @return {LocalizedCountryNames}  country code
 *                                  mapped to county name
 */ var $15e3aefa8e338b9b$export$dc8de070e3f64a1a;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-2 or undefined
 */ var $15e3aefa8e338b9b$export$9abd449eff192ddc;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-2 or undefined
 */ var $15e3aefa8e338b9b$export$2db6702cc2165503;
/*
 * @return Object of alpha-2 codes mapped to alpha-3 codes
 */ var $15e3aefa8e338b9b$export$f340c49a8d00de7f;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-3 or undefined
 */ var $15e3aefa8e338b9b$export$51175d5ff4bc4261;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-3 or undefined
 */ var $15e3aefa8e338b9b$export$13496d6083a3d6ac;
/*
 * @return Object of alpha-3 codes mapped to alpha-2 codes
 */ var $15e3aefa8e338b9b$export$5b1d6865bbe9ebc;
/*
 * @return Object of numeric codes mapped to alpha-2 codes
 */ var $15e3aefa8e338b9b$export$5169b68793e9dfd1;
/*
 * @return Array of registered languages
 */ var $15e3aefa8e338b9b$export$359be4c8544d6fb1;
/*
 * @return Array of supported languages
 */ var $15e3aefa8e338b9b$export$3308a67cbbb588bc;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return Boolean
 */ var $15e3aefa8e338b9b$export$1ea939691cdc45b8;
"use strict";
var $da66b25377f1dccf$exports = {};
$da66b25377f1dccf$exports = JSON.parse("[[\"AF\",\"AFG\",\"004\",\"ISO 3166-2:AF\"],[\"AL\",\"ALB\",\"008\",\"ISO 3166-2:AL\"],[\"DZ\",\"DZA\",\"012\",\"ISO 3166-2:DZ\"],[\"AS\",\"ASM\",\"016\",\"ISO 3166-2:AS\"],[\"AD\",\"AND\",\"020\",\"ISO 3166-2:AD\"],[\"AO\",\"AGO\",\"024\",\"ISO 3166-2:AO\"],[\"AI\",\"AIA\",\"660\",\"ISO 3166-2:AI\"],[\"AQ\",\"ATA\",\"010\",\"ISO 3166-2:AQ\"],[\"AG\",\"ATG\",\"028\",\"ISO 3166-2:AG\"],[\"AR\",\"ARG\",\"032\",\"ISO 3166-2:AR\"],[\"AM\",\"ARM\",\"051\",\"ISO 3166-2:AM\"],[\"AW\",\"ABW\",\"533\",\"ISO 3166-2:AW\"],[\"AU\",\"AUS\",\"036\",\"ISO 3166-2:AU\"],[\"AT\",\"AUT\",\"040\",\"ISO 3166-2:AT\"],[\"AZ\",\"AZE\",\"031\",\"ISO 3166-2:AZ\"],[\"BS\",\"BHS\",\"044\",\"ISO 3166-2:BS\"],[\"BH\",\"BHR\",\"048\",\"ISO 3166-2:BH\"],[\"BD\",\"BGD\",\"050\",\"ISO 3166-2:BD\"],[\"BB\",\"BRB\",\"052\",\"ISO 3166-2:BB\"],[\"BY\",\"BLR\",\"112\",\"ISO 3166-2:BY\"],[\"BE\",\"BEL\",\"056\",\"ISO 3166-2:BE\"],[\"BZ\",\"BLZ\",\"084\",\"ISO 3166-2:BZ\"],[\"BJ\",\"BEN\",\"204\",\"ISO 3166-2:BJ\"],[\"BM\",\"BMU\",\"060\",\"ISO 3166-2:BM\"],[\"BT\",\"BTN\",\"064\",\"ISO 3166-2:BT\"],[\"BO\",\"BOL\",\"068\",\"ISO 3166-2:BO\"],[\"BA\",\"BIH\",\"070\",\"ISO 3166-2:BA\"],[\"BW\",\"BWA\",\"072\",\"ISO 3166-2:BW\"],[\"BV\",\"BVT\",\"074\",\"ISO 3166-2:BV\"],[\"BR\",\"BRA\",\"076\",\"ISO 3166-2:BR\"],[\"IO\",\"IOT\",\"086\",\"ISO 3166-2:IO\"],[\"BN\",\"BRN\",\"096\",\"ISO 3166-2:BN\"],[\"BG\",\"BGR\",\"100\",\"ISO 3166-2:BG\"],[\"BF\",\"BFA\",\"854\",\"ISO 3166-2:BF\"],[\"BI\",\"BDI\",\"108\",\"ISO 3166-2:BI\"],[\"KH\",\"KHM\",\"116\",\"ISO 3166-2:KH\"],[\"CM\",\"CMR\",\"120\",\"ISO 3166-2:CM\"],[\"CA\",\"CAN\",\"124\",\"ISO 3166-2:CA\"],[\"CV\",\"CPV\",\"132\",\"ISO 3166-2:CV\"],[\"KY\",\"CYM\",\"136\",\"ISO 3166-2:KY\"],[\"CF\",\"CAF\",\"140\",\"ISO 3166-2:CF\"],[\"TD\",\"TCD\",\"148\",\"ISO 3166-2:TD\"],[\"CL\",\"CHL\",\"152\",\"ISO 3166-2:CL\"],[\"CN\",\"CHN\",\"156\",\"ISO 3166-2:CN\"],[\"CX\",\"CXR\",\"162\",\"ISO 3166-2:CX\"],[\"CC\",\"CCK\",\"166\",\"ISO 3166-2:CC\"],[\"CO\",\"COL\",\"170\",\"ISO 3166-2:CO\"],[\"KM\",\"COM\",\"174\",\"ISO 3166-2:KM\"],[\"CG\",\"COG\",\"178\",\"ISO 3166-2:CG\"],[\"CD\",\"COD\",\"180\",\"ISO 3166-2:CD\"],[\"CK\",\"COK\",\"184\",\"ISO 3166-2:CK\"],[\"CR\",\"CRI\",\"188\",\"ISO 3166-2:CR\"],[\"CI\",\"CIV\",\"384\",\"ISO 3166-2:CI\"],[\"HR\",\"HRV\",\"191\",\"ISO 3166-2:HR\"],[\"CU\",\"CUB\",\"192\",\"ISO 3166-2:CU\"],[\"CY\",\"CYP\",\"196\",\"ISO 3166-2:CY\"],[\"CZ\",\"CZE\",\"203\",\"ISO 3166-2:CZ\"],[\"DK\",\"DNK\",\"208\",\"ISO 3166-2:DK\"],[\"DJ\",\"DJI\",\"262\",\"ISO 3166-2:DJ\"],[\"DM\",\"DMA\",\"212\",\"ISO 3166-2:DM\"],[\"DO\",\"DOM\",\"214\",\"ISO 3166-2:DO\"],[\"EC\",\"ECU\",\"218\",\"ISO 3166-2:EC\"],[\"EG\",\"EGY\",\"818\",\"ISO 3166-2:EG\"],[\"SV\",\"SLV\",\"222\",\"ISO 3166-2:SV\"],[\"GQ\",\"GNQ\",\"226\",\"ISO 3166-2:GQ\"],[\"ER\",\"ERI\",\"232\",\"ISO 3166-2:ER\"],[\"EE\",\"EST\",\"233\",\"ISO 3166-2:EE\"],[\"ET\",\"ETH\",\"231\",\"ISO 3166-2:ET\"],[\"FK\",\"FLK\",\"238\",\"ISO 3166-2:FK\"],[\"FO\",\"FRO\",\"234\",\"ISO 3166-2:FO\"],[\"FJ\",\"FJI\",\"242\",\"ISO 3166-2:FJ\"],[\"FI\",\"FIN\",\"246\",\"ISO 3166-2:FI\"],[\"FR\",\"FRA\",\"250\",\"ISO 3166-2:FR\"],[\"GF\",\"GUF\",\"254\",\"ISO 3166-2:GF\"],[\"PF\",\"PYF\",\"258\",\"ISO 3166-2:PF\"],[\"TF\",\"ATF\",\"260\",\"ISO 3166-2:TF\"],[\"GA\",\"GAB\",\"266\",\"ISO 3166-2:GA\"],[\"GM\",\"GMB\",\"270\",\"ISO 3166-2:GM\"],[\"GE\",\"GEO\",\"268\",\"ISO 3166-2:GE\"],[\"DE\",\"DEU\",\"276\",\"ISO 3166-2:DE\"],[\"GH\",\"GHA\",\"288\",\"ISO 3166-2:GH\"],[\"GI\",\"GIB\",\"292\",\"ISO 3166-2:GI\"],[\"GR\",\"GRC\",\"300\",\"ISO 3166-2:GR\"],[\"GL\",\"GRL\",\"304\",\"ISO 3166-2:GL\"],[\"GD\",\"GRD\",\"308\",\"ISO 3166-2:GD\"],[\"GP\",\"GLP\",\"312\",\"ISO 3166-2:GP\"],[\"GU\",\"GUM\",\"316\",\"ISO 3166-2:GU\"],[\"GT\",\"GTM\",\"320\",\"ISO 3166-2:GT\"],[\"GN\",\"GIN\",\"324\",\"ISO 3166-2:GN\"],[\"GW\",\"GNB\",\"624\",\"ISO 3166-2:GW\"],[\"GY\",\"GUY\",\"328\",\"ISO 3166-2:GY\"],[\"HT\",\"HTI\",\"332\",\"ISO 3166-2:HT\"],[\"HM\",\"HMD\",\"334\",\"ISO 3166-2:HM\"],[\"VA\",\"VAT\",\"336\",\"ISO 3166-2:VA\"],[\"HN\",\"HND\",\"340\",\"ISO 3166-2:HN\"],[\"HK\",\"HKG\",\"344\",\"ISO 3166-2:HK\"],[\"HU\",\"HUN\",\"348\",\"ISO 3166-2:HU\"],[\"IS\",\"ISL\",\"352\",\"ISO 3166-2:IS\"],[\"IN\",\"IND\",\"356\",\"ISO 3166-2:IN\"],[\"ID\",\"IDN\",\"360\",\"ISO 3166-2:ID\"],[\"IR\",\"IRN\",\"364\",\"ISO 3166-2:IR\"],[\"IQ\",\"IRQ\",\"368\",\"ISO 3166-2:IQ\"],[\"IE\",\"IRL\",\"372\",\"ISO 3166-2:IE\"],[\"IL\",\"ISR\",\"376\",\"ISO 3166-2:IL\"],[\"IT\",\"ITA\",\"380\",\"ISO 3166-2:IT\"],[\"JM\",\"JAM\",\"388\",\"ISO 3166-2:JM\"],[\"JP\",\"JPN\",\"392\",\"ISO 3166-2:JP\"],[\"JO\",\"JOR\",\"400\",\"ISO 3166-2:JO\"],[\"KZ\",\"KAZ\",\"398\",\"ISO 3166-2:KZ\"],[\"KE\",\"KEN\",\"404\",\"ISO 3166-2:KE\"],[\"KI\",\"KIR\",\"296\",\"ISO 3166-2:KI\"],[\"KP\",\"PRK\",\"408\",\"ISO 3166-2:KP\"],[\"KR\",\"KOR\",\"410\",\"ISO 3166-2:KR\"],[\"KW\",\"KWT\",\"414\",\"ISO 3166-2:KW\"],[\"KG\",\"KGZ\",\"417\",\"ISO 3166-2:KG\"],[\"LA\",\"LAO\",\"418\",\"ISO 3166-2:LA\"],[\"LV\",\"LVA\",\"428\",\"ISO 3166-2:LV\"],[\"LB\",\"LBN\",\"422\",\"ISO 3166-2:LB\"],[\"LS\",\"LSO\",\"426\",\"ISO 3166-2:LS\"],[\"LR\",\"LBR\",\"430\",\"ISO 3166-2:LR\"],[\"LY\",\"LBY\",\"434\",\"ISO 3166-2:LY\"],[\"LI\",\"LIE\",\"438\",\"ISO 3166-2:LI\"],[\"LT\",\"LTU\",\"440\",\"ISO 3166-2:LT\"],[\"LU\",\"LUX\",\"442\",\"ISO 3166-2:LU\"],[\"MO\",\"MAC\",\"446\",\"ISO 3166-2:MO\"],[\"MG\",\"MDG\",\"450\",\"ISO 3166-2:MG\"],[\"MW\",\"MWI\",\"454\",\"ISO 3166-2:MW\"],[\"MY\",\"MYS\",\"458\",\"ISO 3166-2:MY\"],[\"MV\",\"MDV\",\"462\",\"ISO 3166-2:MV\"],[\"ML\",\"MLI\",\"466\",\"ISO 3166-2:ML\"],[\"MT\",\"MLT\",\"470\",\"ISO 3166-2:MT\"],[\"MH\",\"MHL\",\"584\",\"ISO 3166-2:MH\"],[\"MQ\",\"MTQ\",\"474\",\"ISO 3166-2:MQ\"],[\"MR\",\"MRT\",\"478\",\"ISO 3166-2:MR\"],[\"MU\",\"MUS\",\"480\",\"ISO 3166-2:MU\"],[\"YT\",\"MYT\",\"175\",\"ISO 3166-2:YT\"],[\"MX\",\"MEX\",\"484\",\"ISO 3166-2:MX\"],[\"FM\",\"FSM\",\"583\",\"ISO 3166-2:FM\"],[\"MD\",\"MDA\",\"498\",\"ISO 3166-2:MD\"],[\"MC\",\"MCO\",\"492\",\"ISO 3166-2:MC\"],[\"MN\",\"MNG\",\"496\",\"ISO 3166-2:MN\"],[\"MS\",\"MSR\",\"500\",\"ISO 3166-2:MS\"],[\"MA\",\"MAR\",\"504\",\"ISO 3166-2:MA\"],[\"MZ\",\"MOZ\",\"508\",\"ISO 3166-2:MZ\"],[\"MM\",\"MMR\",\"104\",\"ISO 3166-2:MM\"],[\"NA\",\"NAM\",\"516\",\"ISO 3166-2:NA\"],[\"NR\",\"NRU\",\"520\",\"ISO 3166-2:NR\"],[\"NP\",\"NPL\",\"524\",\"ISO 3166-2:NP\"],[\"NL\",\"NLD\",\"528\",\"ISO 3166-2:NL\"],[\"NC\",\"NCL\",\"540\",\"ISO 3166-2:NC\"],[\"NZ\",\"NZL\",\"554\",\"ISO 3166-2:NZ\"],[\"NI\",\"NIC\",\"558\",\"ISO 3166-2:NI\"],[\"NE\",\"NER\",\"562\",\"ISO 3166-2:NE\"],[\"NG\",\"NGA\",\"566\",\"ISO 3166-2:NG\"],[\"NU\",\"NIU\",\"570\",\"ISO 3166-2:NU\"],[\"NF\",\"NFK\",\"574\",\"ISO 3166-2:NF\"],[\"MP\",\"MNP\",\"580\",\"ISO 3166-2:MP\"],[\"MK\",\"MKD\",\"807\",\"ISO 3166-2:MK\"],[\"NO\",\"NOR\",\"578\",\"ISO 3166-2:NO\"],[\"OM\",\"OMN\",\"512\",\"ISO 3166-2:OM\"],[\"PK\",\"PAK\",\"586\",\"ISO 3166-2:PK\"],[\"PW\",\"PLW\",\"585\",\"ISO 3166-2:PW\"],[\"PS\",\"PSE\",\"275\",\"ISO 3166-2:PS\"],[\"PA\",\"PAN\",\"591\",\"ISO 3166-2:PA\"],[\"PG\",\"PNG\",\"598\",\"ISO 3166-2:PG\"],[\"PY\",\"PRY\",\"600\",\"ISO 3166-2:PY\"],[\"PE\",\"PER\",\"604\",\"ISO 3166-2:PE\"],[\"PH\",\"PHL\",\"608\",\"ISO 3166-2:PH\"],[\"PN\",\"PCN\",\"612\",\"ISO 3166-2:PN\"],[\"PL\",\"POL\",\"616\",\"ISO 3166-2:PL\"],[\"PT\",\"PRT\",\"620\",\"ISO 3166-2:PT\"],[\"PR\",\"PRI\",\"630\",\"ISO 3166-2:PR\"],[\"QA\",\"QAT\",\"634\",\"ISO 3166-2:QA\"],[\"RE\",\"REU\",\"638\",\"ISO 3166-2:RE\"],[\"RO\",\"ROU\",\"642\",\"ISO 3166-2:RO\"],[\"RU\",\"RUS\",\"643\",\"ISO 3166-2:RU\"],[\"RW\",\"RWA\",\"646\",\"ISO 3166-2:RW\"],[\"SH\",\"SHN\",\"654\",\"ISO 3166-2:SH\"],[\"KN\",\"KNA\",\"659\",\"ISO 3166-2:KN\"],[\"LC\",\"LCA\",\"662\",\"ISO 3166-2:LC\"],[\"PM\",\"SPM\",\"666\",\"ISO 3166-2:PM\"],[\"VC\",\"VCT\",\"670\",\"ISO 3166-2:VC\"],[\"WS\",\"WSM\",\"882\",\"ISO 3166-2:WS\"],[\"SM\",\"SMR\",\"674\",\"ISO 3166-2:SM\"],[\"ST\",\"STP\",\"678\",\"ISO 3166-2:ST\"],[\"SA\",\"SAU\",\"682\",\"ISO 3166-2:SA\"],[\"SN\",\"SEN\",\"686\",\"ISO 3166-2:SN\"],[\"SC\",\"SYC\",\"690\",\"ISO 3166-2:SC\"],[\"SL\",\"SLE\",\"694\",\"ISO 3166-2:SL\"],[\"SG\",\"SGP\",\"702\",\"ISO 3166-2:SG\"],[\"SK\",\"SVK\",\"703\",\"ISO 3166-2:SK\"],[\"SI\",\"SVN\",\"705\",\"ISO 3166-2:SI\"],[\"SB\",\"SLB\",\"090\",\"ISO 3166-2:SB\"],[\"SO\",\"SOM\",\"706\",\"ISO 3166-2:SO\"],[\"ZA\",\"ZAF\",\"710\",\"ISO 3166-2:ZA\"],[\"GS\",\"SGS\",\"239\",\"ISO 3166-2:GS\"],[\"ES\",\"ESP\",\"724\",\"ISO 3166-2:ES\"],[\"LK\",\"LKA\",\"144\",\"ISO 3166-2:LK\"],[\"SD\",\"SDN\",\"729\",\"ISO 3166-2:SD\"],[\"SR\",\"SUR\",\"740\",\"ISO 3166-2:SR\"],[\"SJ\",\"SJM\",\"744\",\"ISO 3166-2:SJ\"],[\"SZ\",\"SWZ\",\"748\",\"ISO 3166-2:SZ\"],[\"SE\",\"SWE\",\"752\",\"ISO 3166-2:SE\"],[\"CH\",\"CHE\",\"756\",\"ISO 3166-2:CH\"],[\"SY\",\"SYR\",\"760\",\"ISO 3166-2:SY\"],[\"TW\",\"TWN\",\"158\",\"ISO 3166-2:TW\"],[\"TJ\",\"TJK\",\"762\",\"ISO 3166-2:TJ\"],[\"TZ\",\"TZA\",\"834\",\"ISO 3166-2:TZ\"],[\"TH\",\"THA\",\"764\",\"ISO 3166-2:TH\"],[\"TL\",\"TLS\",\"626\",\"ISO 3166-2:TL\"],[\"TG\",\"TGO\",\"768\",\"ISO 3166-2:TG\"],[\"TK\",\"TKL\",\"772\",\"ISO 3166-2:TK\"],[\"TO\",\"TON\",\"776\",\"ISO 3166-2:TO\"],[\"TT\",\"TTO\",\"780\",\"ISO 3166-2:TT\"],[\"TN\",\"TUN\",\"788\",\"ISO 3166-2:TN\"],[\"TR\",\"TUR\",\"792\",\"ISO 3166-2:TR\"],[\"TM\",\"TKM\",\"795\",\"ISO 3166-2:TM\"],[\"TC\",\"TCA\",\"796\",\"ISO 3166-2:TC\"],[\"TV\",\"TUV\",\"798\",\"ISO 3166-2:TV\"],[\"UG\",\"UGA\",\"800\",\"ISO 3166-2:UG\"],[\"UA\",\"UKR\",\"804\",\"ISO 3166-2:UA\"],[\"AE\",\"ARE\",\"784\",\"ISO 3166-2:AE\"],[\"GB\",\"GBR\",\"826\",\"ISO 3166-2:GB\"],[\"US\",\"USA\",\"840\",\"ISO 3166-2:US\"],[\"UM\",\"UMI\",\"581\",\"ISO 3166-2:UM\"],[\"UY\",\"URY\",\"858\",\"ISO 3166-2:UY\"],[\"UZ\",\"UZB\",\"860\",\"ISO 3166-2:UZ\"],[\"VU\",\"VUT\",\"548\",\"ISO 3166-2:VU\"],[\"VE\",\"VEN\",\"862\",\"ISO 3166-2:VE\"],[\"VN\",\"VNM\",\"704\",\"ISO 3166-2:VN\"],[\"VG\",\"VGB\",\"092\",\"ISO 3166-2:VG\"],[\"VI\",\"VIR\",\"850\",\"ISO 3166-2:VI\"],[\"WF\",\"WLF\",\"876\",\"ISO 3166-2:WF\"],[\"EH\",\"ESH\",\"732\",\"ISO 3166-2:EH\"],[\"YE\",\"YEM\",\"887\",\"ISO 3166-2:YE\"],[\"ZM\",\"ZMB\",\"894\",\"ISO 3166-2:ZM\"],[\"ZW\",\"ZWE\",\"716\",\"ISO 3166-2:ZW\"],[\"AX\",\"ALA\",\"248\",\"ISO 3166-2:AX\"],[\"BQ\",\"BES\",\"535\",\"ISO 3166-2:BQ\"],[\"CW\",\"CUW\",\"531\",\"ISO 3166-2:CW\"],[\"GG\",\"GGY\",\"831\",\"ISO 3166-2:GG\"],[\"IM\",\"IMN\",\"833\",\"ISO 3166-2:IM\"],[\"JE\",\"JEY\",\"832\",\"ISO 3166-2:JE\"],[\"ME\",\"MNE\",\"499\",\"ISO 3166-2:ME\"],[\"BL\",\"BLM\",\"652\",\"ISO 3166-2:BL\"],[\"MF\",\"MAF\",\"663\",\"ISO 3166-2:MF\"],[\"RS\",\"SRB\",\"688\",\"ISO 3166-2:RS\"],[\"SX\",\"SXM\",\"534\",\"ISO 3166-2:SX\"],[\"SS\",\"SSD\",\"728\",\"ISO 3166-2:SS\"],[\"XK\",\"XKK\",\"983\",\"ISO 3166-2:XK\"],[\"SU\",\"SUN\",\"810\",\"ISO 3166-3:SU\"]]");


var $ac8329aaa7c2f2a8$exports = {};
$ac8329aaa7c2f2a8$exports = JSON.parse("[\"br\",\"cy\",\"dv\",\"sw\",\"eu\",\"af\",\"am\",\"ha\",\"ku\",\"ml\",\"mt\",\"no\",\"ps\",\"sd\",\"so\",\"sq\",\"ta\",\"tg\",\"tt\",\"ug\",\"ur\",\"vi\",\"ar\",\"az\",\"be\",\"bg\",\"bn\",\"bs\",\"ca\",\"cs\",\"da\",\"de\",\"el\",\"en\",\"es\",\"et\",\"fa\",\"fi\",\"fr\",\"ga\",\"gl\",\"he\",\"hi\",\"hr\",\"hu\",\"hy\",\"id\",\"is\",\"it\",\"ja\",\"ka\",\"kk\",\"km\",\"ko\",\"ky\",\"lt\",\"lv\",\"mk\",\"mn\",\"mr\",\"ms\",\"nb\",\"nl\",\"nn\",\"pl\",\"pt\",\"ro\",\"ru\",\"sk\",\"sl\",\"sr\",\"sv\",\"th\",\"tr\",\"uk\",\"uz\",\"zh\"]");


var $6e4725ac584d2777$export$cd7f480d6b8286c3;
var $6e4725ac584d2777$export$452fcf31d2a11c49;
var $6e4725ac584d2777$export$a078a2660a2c4d03;
$6e4725ac584d2777$export$cd7f480d6b8286c3 = $6e4725ac584d2777$var$removeDiacritics;
var $6e4725ac584d2777$var$replacementList = [
    {
        base: ' ',
        chars: "\u00A0"
    },
    {
        base: '0',
        chars: "\u07C0"
    },
    {
        base: 'A',
        chars: "\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        chars: "\uA732"
    },
    {
        base: 'AE',
        chars: "\u00C6\u01FC\u01E2"
    },
    {
        base: 'AO',
        chars: "\uA734"
    },
    {
        base: 'AU',
        chars: "\uA736"
    },
    {
        base: 'AV',
        chars: "\uA738\uA73A"
    },
    {
        base: 'AY',
        chars: "\uA73C"
    },
    {
        base: 'B',
        chars: "\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0181"
    },
    {
        base: 'C',
        chars: "\u24b8\uff23\uA73E\u1E08\u0106\u0043\u0108\u010A\u010C\u00C7\u0187\u023B"
    },
    {
        base: 'D',
        chars: "\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018A\u0189\u1D05\uA779"
    },
    {
        base: 'Dh',
        chars: "\u00D0"
    },
    {
        base: 'DZ',
        chars: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        chars: "\u01F2\u01C5"
    },
    {
        base: 'E',
        chars: "\u025B\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E\u1D07"
    },
    {
        base: 'F',
        chars: "\uA77C\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        chars: "\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E\u0262"
    },
    {
        base: 'H',
        chars: "\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        chars: "\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        chars: "\u24BF\uFF2A\u0134\u0248\u0237"
    },
    {
        base: 'K',
        chars: "\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        chars: "\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        chars: "\u01C7"
    },
    {
        base: 'Lj',
        chars: "\u01C8"
    },
    {
        base: 'M',
        chars: "\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C\u03FB"
    },
    {
        base: 'N',
        chars: "\uA7A4\u0220\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u019D\uA790\u1D0E"
    },
    {
        base: 'NJ',
        chars: "\u01CA"
    },
    {
        base: 'Nj',
        chars: "\u01CB"
    },
    {
        base: 'O',
        chars: "\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OE',
        chars: "\u0152"
    },
    {
        base: 'OI',
        chars: "\u01A2"
    },
    {
        base: 'OO',
        chars: "\uA74E"
    },
    {
        base: 'OU',
        chars: "\u0222"
    },
    {
        base: 'P',
        chars: "\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        chars: "\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        chars: "\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        chars: "\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        chars: "\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'Th',
        chars: "\u00DE"
    },
    {
        base: 'TZ',
        chars: "\uA728"
    },
    {
        base: 'U',
        chars: "\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        chars: "\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        chars: "\uA760"
    },
    {
        base: 'W',
        chars: "\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        chars: "\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        chars: "\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        chars: "\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        chars: "\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251"
    },
    {
        base: 'aa',
        chars: "\uA733"
    },
    {
        base: 'ae',
        chars: "\u00E6\u01FD\u01E3"
    },
    {
        base: 'ao',
        chars: "\uA735"
    },
    {
        base: 'au',
        chars: "\uA737"
    },
    {
        base: 'av',
        chars: "\uA739\uA73B"
    },
    {
        base: 'ay',
        chars: "\uA73D"
    },
    {
        base: 'b',
        chars: "\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253\u0182"
    },
    {
        base: 'c',
        chars: "\uFF43\u24D2\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        chars: "\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\u018B\u13E7\u0501\uA7AA"
    },
    {
        base: 'dh',
        chars: "\u00F0"
    },
    {
        base: 'dz',
        chars: "\u01F3\u01C6"
    },
    {
        base: 'e',
        chars: "\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u01DD"
    },
    {
        base: 'f',
        chars: "\u24D5\uFF46\u1E1F\u0192"
    },
    {
        base: 'ff',
        chars: "\uFB00"
    },
    {
        base: 'fi',
        chars: "\uFB01"
    },
    {
        base: 'fl',
        chars: "\uFB02"
    },
    {
        base: 'ffi',
        chars: "\uFB03"
    },
    {
        base: 'ffl',
        chars: "\uFB04"
    },
    {
        base: 'g',
        chars: "\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\uA77F\u1D79"
    },
    {
        base: 'h',
        chars: "\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        chars: "\u0195"
    },
    {
        base: 'i',
        chars: "\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        chars: "\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        chars: "\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        chars: "\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747\u026D"
    },
    {
        base: 'lj',
        chars: "\u01C9"
    },
    {
        base: 'm',
        chars: "\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        chars: "\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509"
    },
    {
        base: 'nj',
        chars: "\u01CC"
    },
    {
        base: 'o',
        chars: "\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\uA74B\uA74D\u0275\u0254\u1D11"
    },
    {
        base: 'oe',
        chars: "\u0153"
    },
    {
        base: 'oi',
        chars: "\u01A3"
    },
    {
        base: 'oo',
        chars: "\uA74F"
    },
    {
        base: 'ou',
        chars: "\u0223"
    },
    {
        base: 'p',
        chars: "\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755\u03C1"
    },
    {
        base: 'q',
        chars: "\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        chars: "\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        chars: "\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u0282"
    },
    {
        base: 'ss',
        chars: "\xDF"
    },
    {
        base: 't',
        chars: "\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'th',
        chars: "\u00FE"
    },
    {
        base: 'tz',
        chars: "\uA729"
    },
    {
        base: 'u',
        chars: "\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        chars: "\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        chars: "\uA761"
    },
    {
        base: 'w',
        chars: "\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        chars: "\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        chars: "\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        chars: "\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $6e4725ac584d2777$var$diacriticsMap = {};
for(var $6e4725ac584d2777$var$i = 0; $6e4725ac584d2777$var$i < $6e4725ac584d2777$var$replacementList.length; $6e4725ac584d2777$var$i += 1){
    var $6e4725ac584d2777$var$chars = $6e4725ac584d2777$var$replacementList[$6e4725ac584d2777$var$i].chars;
    for(var $6e4725ac584d2777$var$j = 0; $6e4725ac584d2777$var$j < $6e4725ac584d2777$var$chars.length; $6e4725ac584d2777$var$j += 1)$6e4725ac584d2777$var$diacriticsMap[$6e4725ac584d2777$var$chars[$6e4725ac584d2777$var$j]] = $6e4725ac584d2777$var$replacementList[$6e4725ac584d2777$var$i].base;
}
function $6e4725ac584d2777$var$removeDiacritics(str) {
    return str.replace(/[^\u0000-\u007e]/g, function(c) {
        return $6e4725ac584d2777$var$diacriticsMap[c] || c;
    });
}
$6e4725ac584d2777$export$452fcf31d2a11c49 = $6e4725ac584d2777$var$replacementList;
$6e4725ac584d2777$export$a078a2660a2c4d03 = $6e4725ac584d2777$var$diacriticsMap;


var $15e3aefa8e338b9b$require$removeDiacritics = $6e4725ac584d2777$export$cd7f480d6b8286c3;
const $15e3aefa8e338b9b$var$registeredLocales = {};
/*
 * All codes map to ISO 3166-1 alpha-2
 */ const $15e3aefa8e338b9b$var$alpha2 = {}, $15e3aefa8e338b9b$var$alpha3 = {}, $15e3aefa8e338b9b$var$numeric = {}, $15e3aefa8e338b9b$var$invertedNumeric = {};
$da66b25377f1dccf$exports.forEach(function(codeInformation) {
    const s = codeInformation;
    $15e3aefa8e338b9b$var$alpha2[s[0]] = s[1];
    $15e3aefa8e338b9b$var$alpha3[s[1]] = s[0];
    $15e3aefa8e338b9b$var$numeric[s[2]] = s[0];
    $15e3aefa8e338b9b$var$invertedNumeric[s[0]] = s[2];
});
/**
 * @private
 * @param {number} code
 */ function $15e3aefa8e338b9b$var$formatNumericCode(code) {
    return String("000" + (code ? code : "")).slice(-3);
}
/**
 * @private
 * Avoid using obj.hasOwnProperty directly as `hasOwnProperty` could be a
 * property in itself ({ hasOwnProperty: 1 }) and cause weird bugs
 * https://eslint.org/docs/rules/no-prototype-builtins
 */ function $15e3aefa8e338b9b$var$hasOwnProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
/**
 * @private
 * Pass localeList through a filter and return a newLocaleList obj
 * with the same structure of the old localeList.
 *
 * @param {LocalizedCountryNames} localeList  Local List in raw
 * @param {Function} filter    callback to set filter rule
 * @return {String | String[]} new filtered Local List
 */ function $15e3aefa8e338b9b$var$localeFilter(localeList, filter) {
    return Object.keys(localeList).reduce(function(newLocaleList, alpha2) {
        const nameList = localeList[alpha2];
        newLocaleList[alpha2] = filter(nameList, alpha2);
        return newLocaleList;
    }, {});
}
/**
 * @private
 * Preserve for getName & getNames
 *
 * @param {GetNameOptions.select} type all | official | alias
 * @param countryNameList  string array of country's
 *                         official name and alias
 * @return {String | String[]} of a country name
 */ function $15e3aefa8e338b9b$var$filterNameBy(type, countryNameList) {
    switch(type){
        case "official":
            return Array.isArray(countryNameList) ? countryNameList[0] : countryNameList;
        case "all":
            return typeof countryNameList === "string" ? [
                countryNameList
            ] : countryNameList;
        case "alias":
            return Array.isArray(countryNameList) ? countryNameList[1] || countryNameList[0] : countryNameList;
        default:
            throw new TypeError("LocaleNameType must be one of these: all, official, alias!");
    }
}
$15e3aefa8e338b9b$export$bab6a7822cc1e2cd = function(localeData) {
    if (!localeData.locale) throw new TypeError("Missing localeData.locale");
    if (!localeData.countries) throw new TypeError("Missing localeData.countries");
    $15e3aefa8e338b9b$var$registeredLocales[localeData.locale] = localeData.countries;
};
/*
 * @param code Alpha-3 code
 * @return Alpha-2 code or undefined
 */ function $15e3aefa8e338b9b$var$alpha3ToAlpha2(code) {
    return $15e3aefa8e338b9b$var$alpha3[code];
}
$15e3aefa8e338b9b$export$2a91d0f6f59b9f68 = $15e3aefa8e338b9b$var$alpha3ToAlpha2;
/*
 * @param code Alpha-2 code
 * @return Alpha-3 code or undefined
 */ function $15e3aefa8e338b9b$var$alpha2ToAlpha3(code) {
    return $15e3aefa8e338b9b$var$alpha2[code];
}
$15e3aefa8e338b9b$export$65a456803fd0f049 = $15e3aefa8e338b9b$var$alpha2ToAlpha3;
/*
 * @param code Alpha-3 code
 * @return Numeric code or undefined
 */ function $15e3aefa8e338b9b$var$alpha3ToNumeric(code) {
    return $15e3aefa8e338b9b$var$invertedNumeric[$15e3aefa8e338b9b$var$alpha3ToAlpha2(code)];
}
$15e3aefa8e338b9b$export$442b6884bee533cd = $15e3aefa8e338b9b$var$alpha3ToNumeric;
/*
 * @param code Alpha-2 code
 * @return Numeric code or undefined
 */ function $15e3aefa8e338b9b$var$alpha2ToNumeric(code) {
    return $15e3aefa8e338b9b$var$invertedNumeric[code];
}
$15e3aefa8e338b9b$export$e8f1fd30e9fba660 = $15e3aefa8e338b9b$var$alpha2ToNumeric;
/*
 * @param code Numeric code
 * @return Alpha-3 code or undefined
 */ function $15e3aefa8e338b9b$var$numericToAlpha3(code) {
    const padded = $15e3aefa8e338b9b$var$formatNumericCode(code);
    return $15e3aefa8e338b9b$var$alpha2ToAlpha3($15e3aefa8e338b9b$var$numeric[padded]);
}
$15e3aefa8e338b9b$export$c50ba58d0968541f = $15e3aefa8e338b9b$var$numericToAlpha3;
/*
 * @param code Numeric code
 * @return Alpha-2 code or undefined
 */ function $15e3aefa8e338b9b$var$numericToAlpha2(code) {
    const padded = $15e3aefa8e338b9b$var$formatNumericCode(code);
    return $15e3aefa8e338b9b$var$numeric[padded];
}
$15e3aefa8e338b9b$export$e21a59c72a3c77a7 = $15e3aefa8e338b9b$var$numericToAlpha2;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return ISO 3166-1 alpha-3
 */ function $15e3aefa8e338b9b$var$toAlpha3(code) {
    if (typeof code === "string") {
        if (/^[0-9]*$/.test(code)) return $15e3aefa8e338b9b$var$numericToAlpha3(code);
        if (code.length === 2) return $15e3aefa8e338b9b$var$alpha2ToAlpha3(code.toUpperCase());
        if (code.length === 3) return code.toUpperCase();
    }
    if (typeof code === "number") return $15e3aefa8e338b9b$var$numericToAlpha3(code);
    return undefined;
}
$15e3aefa8e338b9b$export$3d1d5c3d00561285 = $15e3aefa8e338b9b$var$toAlpha3;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return ISO 3166-1 alpha-2
 */ function $15e3aefa8e338b9b$var$toAlpha2(code) {
    if (typeof code === "string") {
        if (/^[0-9]*$/.test(code)) return $15e3aefa8e338b9b$var$numericToAlpha2(code);
        if (code.length === 2) return code.toUpperCase();
        if (code.length === 3) return $15e3aefa8e338b9b$var$alpha3ToAlpha2(code.toUpperCase());
    }
    if (typeof code === "number") return $15e3aefa8e338b9b$var$numericToAlpha2(code);
    return undefined;
}
$15e3aefa8e338b9b$export$53e0b99b5d556acf = $15e3aefa8e338b9b$var$toAlpha2;
$15e3aefa8e338b9b$export$7d9f7e9c1c02b41e = function(code, lang, options = {}) {
    if (!("select" in options)) options.select = "official";
    try {
        const codeMaps = $15e3aefa8e338b9b$var$registeredLocales[lang.toLowerCase()];
        const nameList = codeMaps[$15e3aefa8e338b9b$var$toAlpha2(code)];
        return $15e3aefa8e338b9b$var$filterNameBy(options.select, nameList);
    } catch (err) {
        return undefined;
    }
};
$15e3aefa8e338b9b$export$dc8de070e3f64a1a = function(lang, options = {}) {
    if (!("select" in options)) options.select = "official";
    const localeList = $15e3aefa8e338b9b$var$registeredLocales[lang.toLowerCase()];
    if (localeList === undefined) return {};
    return $15e3aefa8e338b9b$var$localeFilter(localeList, function(nameList) {
        return $15e3aefa8e338b9b$var$filterNameBy(options.select, nameList);
    });
};
$15e3aefa8e338b9b$export$9abd449eff192ddc = function(name, lang) {
    const normalizeString = (string)=>string.toLowerCase();
    const areSimilar = (a, b)=>normalizeString(a) === normalizeString(b);
    try {
        const codenames = $15e3aefa8e338b9b$var$registeredLocales[lang.toLowerCase()];
        for(const p in codenames){
            if (!$15e3aefa8e338b9b$var$hasOwnProperty(codenames, p)) continue;
            if (typeof codenames[p] === "string") {
                if (areSimilar(codenames[p], name)) return p;
            }
            if (Array.isArray(codenames[p])) for (const mappedName of codenames[p]){
                if (areSimilar(mappedName, name)) return p;
            }
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};
$15e3aefa8e338b9b$export$2db6702cc2165503 = function(name, lang) {
    const normalizeString = (string)=>$15e3aefa8e338b9b$require$removeDiacritics(string.toLowerCase());
    const areSimilar = (a, b)=>normalizeString(a) === normalizeString(b);
    try {
        const codenames = $15e3aefa8e338b9b$var$registeredLocales[lang.toLowerCase()];
        for(const p in codenames){
            if (!$15e3aefa8e338b9b$var$hasOwnProperty(codenames, p)) continue;
            if (typeof codenames[p] === "string") {
                if (areSimilar(codenames[p], name)) return p;
            }
            if (Array.isArray(codenames[p])) for (const mappedName of codenames[p]){
                if (areSimilar(mappedName, name)) return p;
            }
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};
$15e3aefa8e338b9b$export$f340c49a8d00de7f = function() {
    return $15e3aefa8e338b9b$var$alpha2;
};
$15e3aefa8e338b9b$export$51175d5ff4bc4261 = function(name, lang) {
    const alpha2 = $15e3aefa8e338b9b$export$9abd449eff192ddc(name, lang);
    if (alpha2) return $15e3aefa8e338b9b$export$3d1d5c3d00561285(alpha2);
    else return undefined;
};
$15e3aefa8e338b9b$export$13496d6083a3d6ac = function(name, lang) {
    const alpha2 = $15e3aefa8e338b9b$export$2db6702cc2165503(name, lang);
    if (alpha2) return $15e3aefa8e338b9b$export$3d1d5c3d00561285(alpha2);
    else return undefined;
};
$15e3aefa8e338b9b$export$5b1d6865bbe9ebc = function() {
    return $15e3aefa8e338b9b$var$alpha3;
};
$15e3aefa8e338b9b$export$5169b68793e9dfd1 = function() {
    return $15e3aefa8e338b9b$var$numeric;
};
$15e3aefa8e338b9b$export$359be4c8544d6fb1 = function() {
    return Object.keys($15e3aefa8e338b9b$var$registeredLocales);
};
$15e3aefa8e338b9b$export$3308a67cbbb588bc = function() {
    return $ac8329aaa7c2f2a8$exports;
};
$15e3aefa8e338b9b$export$1ea939691cdc45b8 = function(code) {
    if (!code) return false;
    const coerced = code.toString().toUpperCase();
    return $15e3aefa8e338b9b$var$hasOwnProperty($15e3aefa8e338b9b$var$alpha3, coerced) || $15e3aefa8e338b9b$var$hasOwnProperty($15e3aefa8e338b9b$var$alpha2, coerced) || $15e3aefa8e338b9b$var$hasOwnProperty($15e3aefa8e338b9b$var$numeric, coerced);
};



$15e3aefa8e338b9b$export$bab6a7822cc1e2cd((parcelRequire("hcrRu")));

$15e3aefa8e338b9b$export$bab6a7822cc1e2cd((parcelRequire("fxSCz")));

$15e3aefa8e338b9b$export$bab6a7822cc1e2cd((parcelRequire("iAAvH")));

$15e3aefa8e338b9b$export$bab6a7822cc1e2cd((parcelRequire("7GJAx")));

$15e3aefa8e338b9b$export$bab6a7822cc1e2cd((parcelRequire("jg95v")));
(0, $e815fda779bc047b$export$2e2bcd8739ae039).use((0, (/*@__PURE__*/$parcel$interopDefault($3316c281642e828a$exports))));
(0, $e815fda779bc047b$export$2e2bcd8739ae039).use((0, (/*@__PURE__*/$parcel$interopDefault($6537b3cb2d643597$exports))));
(0, $e815fda779bc047b$export$2e2bcd8739ae039).use((0, (/*@__PURE__*/$parcel$interopDefault($e767d170f347f030$exports))));
(0, $e815fda779bc047b$export$2e2bcd8739ae039).use((0, (/*@__PURE__*/$parcel$interopDefault($bc39d0a5044c7403$exports))));
(0, $e815fda779bc047b$export$2e2bcd8739ae039).use((0, $1ffa4796a7b2001e$export$2e2bcd8739ae039));
console.log((0, (/*@__PURE__*/$parcel$interopDefault($d8a032920235956d$exports))));
// let polyglot
const $388b617130f03bd4$var$langRes = {};
$388b617130f03bd4$var$langRes.pt = (0, (/*@__PURE__*/$parcel$interopDefault($144986459bad920b$exports)));
$388b617130f03bd4$var$langRes.ja = (0, (/*@__PURE__*/$parcel$interopDefault($41aa1533bd82fa0c$exports)));
$388b617130f03bd4$var$langRes.de = (0, (/*@__PURE__*/$parcel$interopDefault($9ea14d8ba7454975$exports)));
$388b617130f03bd4$var$langRes.zh = (0, (/*@__PURE__*/$parcel$interopDefault($cdc580e3bb72528f$exports)));
let $388b617130f03bd4$var$lang = "en";
console.log("i18n: setting lang to ", $388b617130f03bd4$var$lang);
let $388b617130f03bd4$var$polyglot = new (0, (/*@__PURE__*/$parcel$interopDefault($fe356312f17a2f78$exports)))({
    allowMissing: true
});
$388b617130f03bd4$var$polyglot.extend($388b617130f03bd4$var$langRes[$388b617130f03bd4$var$lang]);
const $388b617130f03bd4$var$updateLanguage = document.getElementById("language");
$388b617130f03bd4$var$updateLanguage.onchange = $388b617130f03bd4$var$changeLanguage;
function $388b617130f03bd4$var$changeLanguage() {
    const value = $388b617130f03bd4$var$updateLanguage.value;
    const text = $388b617130f03bd4$var$updateLanguage.options[$388b617130f03bd4$var$updateLanguage.selectedIndex].text;
    $388b617130f03bd4$var$lang = $388b617130f03bd4$var$updateLanguage.value;
    console.log("changeLanguage: ", value, text, $388b617130f03bd4$var$langRes[$388b617130f03bd4$var$lang]);
    $388b617130f03bd4$var$polyglot = new (0, (/*@__PURE__*/$parcel$interopDefault($fe356312f17a2f78$exports)))({
        allowMissing: true
    });
    $388b617130f03bd4$var$polyglot.extend($388b617130f03bd4$var$langRes[$388b617130f03bd4$var$lang]);
    $388b617130f03bd4$var$updateContent();
}
function $388b617130f03bd4$var$updateContent() {
    document.getElementById("nav-budo").innerHTML = $388b617130f03bd4$var$polyglot.t("Bud\u014D Lineage Tree");
    $388b617130f03bd4$var$updateInfo($388b617130f03bd4$var$cy.elements(":selected"));
    document.getElementById("tab:cy").innerHTML = $388b617130f03bd4$var$polyglot.t("Tree");
    document.getElementById("tab:Persons").innerHTML = $388b617130f03bd4$var$polyglot.t("Persons");
    document.getElementById("tab:Styles").innerHTML = $388b617130f03bd4$var$polyglot.t("Styles");
    document.getElementById("tab:Timeline").innerHTML = $388b617130f03bd4$var$polyglot.t("Timeline");
    $388b617130f03bd4$var$updateStyleFilter();
    $388b617130f03bd4$var$updateTimeline();
    $388b617130f03bd4$var$cy.style().update();
}
let $388b617130f03bd4$var$edgesShowStyle = true;
let $388b617130f03bd4$var$edgesShowPeriod = false;
const $388b617130f03bd4$var$style = [
    // the stylesheet for the graph
    {
        selector: "node",
        style: {
            label: (ele)=>{
                if (ele.data().native_name && ele.data().native_name.lang == $388b617130f03bd4$var$lang) return ele.data().native_name.name;
                else return ele.data().name;
            },
            "background-image": (ele)=>{
                if (ele.data().photo_url_local) return ele.data().photo_url_local;
                else if (ele.data().photo) return ele.data().photo.url;
                else if (ele.data().photo_url) return ele.data().photo_url;
                else return false;
            },
            "background-fit": "cover cover",
            "background-image-opacity": 0.4,
            "background-position-y": "10%",
            // 'label': 'data(name)',
            "font-size": "0.5em",
            "font-family": "Noto Serif JP, serif",
            color: "white",
            "text-valign": "center",
            "text-halign": "center",
            shape: "ellipse",
            "text-wrap": "wrap",
            "text-overflow-wrap": (ele)=>{
                if (ele.data().native_name && ele.data().native_name.lang == $388b617130f03bd4$var$lang) return "anywhere";
                else return "whitespace";
            },
            "word-break": "break-all",
            "text-max-width": 40,
            width: 55,
            height: 55,
            "background-color": "black",
            "border-width": "1"
        }
    },
    {
        selector: "edge",
        style: {
            width: 1,
            "line-style": "solid",
            "curve-style": "bezier",
            "control-point-step-size": "40",
            "taxi-direction": "auto",
            "line-color": "#888",
            label: (ele)=>{
                let edgeLabel = "";
                if ($388b617130f03bd4$var$edgesShowStyle) {
                    if (ele.data().interaction_native && ele.data().interaction_native.lang == $388b617130f03bd4$var$lang) edgeLabel = ele.data().interaction_native.name;
                    else edgeLabel = ele.data().interaction;
                } else edgeLabel = "";
                if ($388b617130f03bd4$var$edgesShowPeriod) {
                    if (ele.data().period && (ele.data().period.start || ele.data().period.end)) {
                        edgeLabel += "\n";
                        if (ele.data().period.start) edgeLabel += ele.data().period.start;
                        edgeLabel += " - ";
                        if (ele.data().period.end) edgeLabel += ele.data().period.end;
                    }
                }
                return edgeLabel;
            },
            // 'label': 'data(interaction)',
            "font-size": "0.4em",
            "font-family": "Noto Serif JP, serif",
            "font-weight": "700",
            "text-wrap": "wrap",
            "text-max-width": 35,
            color: "#444",
            "target-arrow-shape": "triangle",
            "arrow-scale": "0.8",
            "target-arrow-color": "#666"
        }
    },
    {
        selector: "node:selected",
        css: {
            "background-color": "#cb4042",
            color: "white"
        }
    },
    {
        selector: "edge:selected",
        css: {
            color: "#cb4042",
            "line-color": "#f9bf45",
            "target-arrow-color": "#f9bf45"
        }
    },
    {
        selector: ".hidden",
        css: {
            display: "none"
        }
    },
    {
        selector: ".focused",
        css: {
            "background-color": "#096148"
        }
    },
    {
        selector: ".ancestors",
        css: {
            color: "#f596aa"
        }
    },
    {
        selector: ".descendants",
        css: {
            color: "#f9bf45"
        }
    },
    {
        selector: ".parents",
        css: {
            "background-color": "#446",
            color: "white"
        }
    },
    {
        selector: ".children",
        css: {
            "background-color": "#464",
            color: "white"
        }
    },
    {
        selector: ".stylefocus",
        css: {
            "background-color": "yellow",
            color: "white"
        }
    },
    {
        selector: ":parent",
        css: {
            label: (ele)=>{
                console.log("parent title");
                console.log(ele);
                return $15e3aefa8e338b9b$export$7d9f7e9c1c02b41e(ele.data().name, $388b617130f03bd4$var$lang);
            },
            color: "black",
            shape: "round-rectangle",
            //shape: 'cutrectangle',
            //"shape": 'triangle',
            "background-color": "blue",
            "background-opacity": 0.1,
            "text-valign": "top",
            "text-halign": "left"
        }
    },
    {
        selector: ".matched",
        css: {
            "background-color": "gold",
            "color": "#446"
        }
    },
    {
        selector: ".path",
        css: {
            "background-color": "#FBE251",
            "color": "#446"
        }
    },
    {
        selector: ".start-path",
        css: {
            "background-color": "#FBE251",
            "color": "#446"
        }
    },
    {
        selector: ".end-path",
        css: {
            "background-color": "#FFA400",
            "color": "#446"
        }
    }
];
const $388b617130f03bd4$var$layoutOptions = {
    name: "fcose",
    spacingFactor: 1,
    nodeDimensionsIncludeLabels: true,
    animate: "end",
    refresh: 100,
    animationDuration: 250,
    elk: {
        algorithm: "mrtree"
    }
};
var $388b617130f03bd4$var$cy = (0, $e815fda779bc047b$export$2e2bcd8739ae039)({
    container: (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#cy"),
    elements: (0, (/*@__PURE__*/$parcel$interopDefault($d8a032920235956d$exports))).elements,
    style: $388b617130f03bd4$var$style,
    userPanningEnabled: true,
    //boxSelectionEnabled: true,
    selectionType: "addictive",
    wheelSensitivity: 0.1
});
// Keep track of who is being displayed in the info box
let $388b617130f03bd4$var$focusedPerson;
let $388b617130f03bd4$var$layout = $388b617130f03bd4$var$cy.layout($388b617130f03bd4$var$layoutOptions);
const $388b617130f03bd4$var$bb = $388b617130f03bd4$var$cy.bubbleSets({
    interactive: false
});
const $388b617130f03bd4$var$layoutButton = document.querySelectorAll("[id=ddlViewBy]");
const $388b617130f03bd4$var$availableLayouts = [
    ...$388b617130f03bd4$var$layoutButton[0].options
].map((o)=>o.value);
const $388b617130f03bd4$var$langButton = document.querySelectorAll("[id=language]");
const $388b617130f03bd4$var$availableLanguages = [
    ...$388b617130f03bd4$var$langButton[0].options
].map((o)=>o.value);
console.log($388b617130f03bd4$var$availableLayouts);
document.addEventListener("DOMContentLoaded", function() {
    console.log("DOM content loaded, running layout");
    $388b617130f03bd4$var$openTab(true, "tab:cy");
    //    layoutOptions["name"]="elk";
    //    layoutOptions["elk"]["algorithm"] = "stress";
    $388b617130f03bd4$var$cy.nodes().unselect();
    if ($388b617130f03bd4$var$urlParams.get("id") && $388b617130f03bd4$var$cy.getElementById($388b617130f03bd4$var$urlParams.get("id")).isNode()) $388b617130f03bd4$var$cy.getElementById($388b617130f03bd4$var$urlParams.get("id")).select();
    else $388b617130f03bd4$var$cy.getElementById("JDP-1").select();
    if ($388b617130f03bd4$var$urlParams.get("layout") && $388b617130f03bd4$var$availableLayouts.includes($388b617130f03bd4$var$urlParams.get("layout"))) {
        console.log("Setting layout from URL: ", $388b617130f03bd4$var$urlParams.get("layout"));
        // layoutOptions["name"]=urlParams.get('layout');
        $388b617130f03bd4$var$updateLayout.value = $388b617130f03bd4$var$urlParams.get("layout");
        $388b617130f03bd4$var$changeLayout();
    }
    if ($388b617130f03bd4$var$urlParams.get("infobox")) $388b617130f03bd4$var$setInfoboxVisibility($388b617130f03bd4$var$urlParams.get("infobox"));
    if ($388b617130f03bd4$var$urlParams.get("focus")) {
        const isTrueSet = $388b617130f03bd4$var$urlParams.get("focus") === "true";
        $388b617130f03bd4$var$focusOnIndividual(isTrueSet);
    }
    if ($388b617130f03bd4$var$urlParams.get("lang") && $388b617130f03bd4$var$availableLanguages.includes($388b617130f03bd4$var$urlParams.get("lang"))) {
        console.log(" Setting lang from URL", $388b617130f03bd4$var$urlParams.get("lang"));
        $388b617130f03bd4$var$updateLanguage.value = $388b617130f03bd4$var$urlParams.get("lang");
        $388b617130f03bd4$var$changeLanguage();
    }
    // Update content is needed to refresh the infobox, but must be
    // before the style filter since it would otherwise reset the option
    $388b617130f03bd4$var$updateContent();
    const styleList = [];
    for (const edge of (0, (/*@__PURE__*/$parcel$interopDefault($d8a032920235956d$exports))).elements.edges)styleList[edge.data.interaction_id] = "";
    $388b617130f03bd4$var$updateStyleFilter();
    if ($388b617130f03bd4$var$urlParams.get("style") && $388b617130f03bd4$var$urlParams.get("style") in styleList) {
        $388b617130f03bd4$var$styleFilter.value = $388b617130f03bd4$var$urlParams.get("style");
        $388b617130f03bd4$var$pickStyle();
    }
    const layout = $388b617130f03bd4$var$cy.layout($388b617130f03bd4$var$layoutOptions);
    layout.run();
    console.log(layout);
    // This is used by the nationality bubbles
    $388b617130f03bd4$var$nodesByCountry();
    $388b617130f03bd4$var$listPersons();
    $388b617130f03bd4$var$listStyles();
    $388b617130f03bd4$var$listVersions();
// updateStyleFilter();
//
//    updateTimeline();
// edgesByStyle();
});
function $388b617130f03bd4$var$goHome() {
    // console.log("Going home...");
    const homeNode = $388b617130f03bd4$var$cy.nodes('[id = "JDP-1"]');
    $388b617130f03bd4$var$cy.nodes().unselect();
    $388b617130f03bd4$var$cy.nodes(homeNode).select();
    $388b617130f03bd4$var$cy.center();
    $388b617130f03bd4$var$updateInfo($388b617130f03bd4$var$cy.nodes(homeNode));
    $388b617130f03bd4$var$layout.run();
}
function $388b617130f03bd4$var$wordToInteger(word) {
    // Simple hash function to convert string to integer
    let hash = 0;
    for(let i = 0; i < word.length; i++){
        hash = (hash << 5) - hash + word.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}
function $388b617130f03bd4$var$clusterInfo(node) {
    let clusterId;
    if (node.data().nationality) clusterId = node.data().nationality[0];
    else clusterId = null;
    //console.log("Clusterid"+ clusterId)
    return $388b617130f03bd4$var$wordToInteger(clusterId);
}
function $388b617130f03bd4$var$setCluster(criteria) {
    if (criteria == "nationality") $388b617130f03bd4$var$cy.nodes().forEach(function(ele) {
        if (ele.data()[criteria]) for (const criteriaEle of ele.data()[criteria]){
            if ($388b617130f03bd4$var$cy.getElementById(criteriaEle).length == 0) $388b617130f03bd4$var$cy.add({
                group: 'nodes',
                data: {
                    id: criteriaEle,
                    name: criteriaEle,
                    type: "grouping"
                }
            });
            ele.move({
                parent: criteriaEle
            });
        }
    });
}
function $388b617130f03bd4$var$changeLayout() {
    // var value = updateLayout.value;
    // var text = updateLayout.options[updateLayout.selectedIndex].text;
    // console.log(value, text);
    switch($388b617130f03bd4$var$updateLayout.value){
        case "mrtree":
            $388b617130f03bd4$var$layoutOptions.name = "elk";
            $388b617130f03bd4$var$layoutOptions.elk.algorithm = "mrtree";
            break;
        case "layered":
            $388b617130f03bd4$var$layoutOptions.name = "elk";
            $388b617130f03bd4$var$layoutOptions.elk.algorithm = "layered";
            break;
        case "breadthfirst":
            $388b617130f03bd4$var$layoutOptions.name = "breadthfirst";
            break;
        case "stress":
            $388b617130f03bd4$var$layoutOptions.name = "elk";
            $388b617130f03bd4$var$layoutOptions.elk.algorithm = "stress";
            break;
        case "cise":
            $388b617130f03bd4$var$layoutOptions.name = "cise";
            $388b617130f03bd4$var$layoutOptions.allowNodesInsideCircle = false;
            break;
        case "cola":
            $388b617130f03bd4$var$layoutOptions.name = "cola";
            break;
        case "fcose":
            $388b617130f03bd4$var$layoutOptions.name = "fcose";
            break;
        case "concentric":
            $388b617130f03bd4$var$layoutOptions.name = "concentric";
            $388b617130f03bd4$var$layoutOptions.concentric = $388b617130f03bd4$var$nodeLevel;
            $388b617130f03bd4$var$layoutOptions.levelWidth = function() {
                return $388b617130f03bd4$var$cy.nodes(":visible").maxDegree() / 6;
            };
            break;
    }
    $388b617130f03bd4$var$layout = $388b617130f03bd4$var$cy.layout($388b617130f03bd4$var$layoutOptions);
    $388b617130f03bd4$var$cy.layout($388b617130f03bd4$var$layoutOptions);
    console.log($388b617130f03bd4$var$layoutOptions.name);
    $388b617130f03bd4$var$layout.run();
}
function $388b617130f03bd4$var$nodeLevel(node) {
    // console.log("Nodelevel ", node.data().id);
    if (node.selected()) // console.log ("NodeLevel", node.data())
    return $388b617130f03bd4$var$cy.nodes(":visible").maxDegree();
    else // console.log(node.data().name, cy.elements().aStar({ root: cy.$(':selected'), goal: node }).distance);
    return -1 * $388b617130f03bd4$var$cy.elements().aStar({
        root: $388b617130f03bd4$var$cy.$(":selected"),
        goal: node
    }).distance;
}
var $388b617130f03bd4$var$updateLayout = document.getElementById("ddlViewBy");
$388b617130f03bd4$var$updateLayout.onchange = $388b617130f03bd4$var$changeLayout;
const $388b617130f03bd4$var$homeBtn = document.getElementById("home");
$388b617130f03bd4$var$homeBtn.addEventListener("click", $388b617130f03bd4$var$goHome);
const $388b617130f03bd4$var$distance = document.getElementById("distance");
function $388b617130f03bd4$var$setDistance(distance) {
    $388b617130f03bd4$var$layoutOptions.spacingFactor = distance;
    $388b617130f03bd4$var$layout = $388b617130f03bd4$var$cy.layout($388b617130f03bd4$var$layoutOptions);
    $388b617130f03bd4$var$cy.layout($388b617130f03bd4$var$layoutOptions);
    console.log($388b617130f03bd4$var$layoutOptions.name);
    $388b617130f03bd4$var$cy.center();
    $388b617130f03bd4$var$layout.run();
}
$388b617130f03bd4$var$distance.addEventListener("change", function() {
    // var distanceDisplay = document.getElementById("distanceDisplay");
    // console.log(document.getElementById("distance").textContent = distance.value);
    $388b617130f03bd4$var$setDistance($388b617130f03bd4$var$distance.value);
// distanceDisplay.innerHTML = distance.value;
});
(0, (/*@__PURE__*/$parcel$interopDefault($c6a5708c86c6cd0b$exports))).attach();
// FIXME: find ou and comment why we need this, or remove it
$388b617130f03bd4$var$cy.elements().unbind("mouseover");
const $388b617130f03bd4$var$searchNode = document.getElementById("searchNode");
const $388b617130f03bd4$var$searchReset = document.getElementById("reset-search");
$388b617130f03bd4$var$searchReset.addEventListener("click", function(e) {
    $388b617130f03bd4$var$searchNode.value = "";
    $388b617130f03bd4$var$cy.nodes().removeClass("matched");
});
$388b617130f03bd4$var$searchNode.addEventListener("input", $388b617130f03bd4$var$updateValue);
function $388b617130f03bd4$var$updateValue(e) {
    $388b617130f03bd4$var$search(e.target.value);
}
function $388b617130f03bd4$var$search(pattern) {
    console.log(pattern);
    $388b617130f03bd4$var$cy.nodes().removeClass("matched");
    let matchingNodes = $388b617130f03bd4$var$cy.elements('node[ name *= "' + pattern + '"]');
    console.log(matchingNodes);
    if ($388b617130f03bd4$var$cy.nodes().size() != matchingNodes.size()) matchingNodes.addClass("matched");
}
// Path
const $388b617130f03bd4$var$showPath = document.getElementById("show-path");
$388b617130f03bd4$var$showPath.addEventListener("click", function(e) {
    if (e.target.checked) $388b617130f03bd4$var$getPath(true);
    else $388b617130f03bd4$var$getPath(false);
});
const $388b617130f03bd4$var$isolatePath = document.getElementById("isolate-path");
$388b617130f03bd4$var$isolatePath.addEventListener("click", function(e) {
    if (e.target.checked) $388b617130f03bd4$var$focusPath(true);
    else $388b617130f03bd4$var$focusPath(false);
});
let $388b617130f03bd4$var$pathOriginNode = $388b617130f03bd4$var$cy.getElementById("JDP-1").select();
let $388b617130f03bd4$var$pathEndNode = $388b617130f03bd4$var$cy.getElementById("JDP-1").select();
//const pathOrigin = document.getElementById("pathOrigin");
//pathOrigin.onclick = setPathOrigin
//const pathEnd = document.getElementById("pathEnd");
//pathEnd.onclick = setPathEnd
const $388b617130f03bd4$var$pathOriginT = document.getElementById("pathOriginT");
const $388b617130f03bd4$var$pathEndT = document.getElementById("pathEndT");
document.addEventListener("DOMContentLoaded", function() {
    $388b617130f03bd4$var$pathOriginT.addEventListener("click", (e)=>{
        console.log(e);
        if (e.target.checked) $388b617130f03bd4$var$setPathOrigin(true);
        else $388b617130f03bd4$var$setPathOrigin(false);
    });
});
document.addEventListener("DOMContentLoaded", function() {
    $388b617130f03bd4$var$pathEndT.addEventListener("click", (e)=>{
        // console.log("Predecessors" + ele.data().name);
        if (e.target.checked) $388b617130f03bd4$var$setPathEnd(true);
        else $388b617130f03bd4$var$setPathEnd(false);
    });
});
function $388b617130f03bd4$var$setPathOrigin(state) {
    let person;
    person = $388b617130f03bd4$var$cy.elements("node:selected");
    if (state) {
        $388b617130f03bd4$var$pathOriginNode = person;
        $388b617130f03bd4$var$cy.nodes().removeClass("start-path");
        person.addClass("start-path");
    //cy.nodes('[id = "' + origi + '"]').addClass("start-path");
    } else {
        $388b617130f03bd4$var$cy.nodes().removeClass("start-path");
        $388b617130f03bd4$var$pathOriginNode = false;
    }
}
function $388b617130f03bd4$var$setPathEnd(state) {
    let person;
    person = $388b617130f03bd4$var$cy.elements("node:selected");
    if (state) {
        $388b617130f03bd4$var$pathEndNode = person;
        $388b617130f03bd4$var$cy.nodes().removeClass("end-path");
        person.addClass("end-path");
    //cy.nodes('[id = "' + origi + '"]').addClass("start-path");
    } else {
        $388b617130f03bd4$var$cy.nodes().removeClass("end-path");
        $388b617130f03bd4$var$pathEndNode = false;
    }
}
function $388b617130f03bd4$var$setPathEnd_() {
    const originNode = pathEnd.value;
    $388b617130f03bd4$var$cy.nodes().removeClass("end-path");
    $388b617130f03bd4$var$cy.nodes('[id = "' + originNode + '"]').addClass("end-path");
}
function $388b617130f03bd4$var$getPath(state) {
    $388b617130f03bd4$var$cy.nodes().removeClass("path");
    //const root = cy.nodes('[id = "' + pathOrigin.value + '"]')
    //const goal = cy.nodes('[id = "' + pathEnd.value + '"]')
    let aStar = $388b617130f03bd4$var$cy.elements().aStar({
        root: $388b617130f03bd4$var$pathOriginNode,
        goal: $388b617130f03bd4$var$pathEndNode
    });
    if (state) aStar.path.addClass("path");
    else aStar.path.removeClass("path");
//console.log("A*");
// console.log(aStar);
//aStar.path.select();
}
function $388b617130f03bd4$var$focusPath(state) {
    // const root = cy.nodes('[id = "' + pathOrigin.value + '"]')
    // const goal = cy.nodes('[id = "' + pathEnd.value + '"]')    
    let aStar = $388b617130f03bd4$var$cy.elements().aStar({
        root: $388b617130f03bd4$var$pathOriginNode,
        goal: $388b617130f03bd4$var$pathEndNode
    });
    if (state) {
        aStar.path.addClass("path");
        $388b617130f03bd4$var$cy.nodes().difference(aStar.path).addClass("hidden");
    } else $388b617130f03bd4$var$cy.nodes().removeClass([
        "path",
        "hidden"
    ]);
    $388b617130f03bd4$var$layout.run();
}
//updateNodeName()
function $388b617130f03bd4$var$updateNodeName() {
    pathOrigin.innerHTML = "";
    pathEnd.innerHTML = "";
    const nameList = {};
    for (const node of (0, (/*@__PURE__*/$parcel$interopDefault($d8a032920235956d$exports))).elements.nodes)if (!nameList[node.data.id]) nameList[node.data.id] = {
        name: node.data.name
    };
    const allEl = document.createElement("option");
    //allEl.textContent = polyglot.t("All Styles");
    //allEl.value = "all";
    //styleFilter.appendChild(allEl);
    const sorted = [];
    for (const [key] of Object.entries(nameList))sorted.push(key);
    sorted.sort((a, b)=>nameList[a].name.localeCompare(nameList[b].name));
    console.log(sorted);
    // for (const [key, value] of Object.entries(styleList)) {
    for (const key of sorted){
        const value = nameList[key];
        const el = document.createElement("option");
        if (value.native_name && value.native_name.lang == $388b617130f03bd4$var$lang) el.textContent = value.native_name.name;
        else el.textContent = value.name;
        el.value = key;
        pathOrigin.appendChild(el);
    }
    for (const key of sorted){
        const value = nameList[key];
        const el = document.createElement("option");
        if (value.native_name && value.native_name.lang == $388b617130f03bd4$var$lang) el.textContent = value.native_name.name;
        else el.textContent = value.name;
        el.value = key;
        pathEnd.appendChild(el);
    }
}
const $388b617130f03bd4$var$gitRoot = "https://github.com/Judo-Documentation-Project/budotree/tree/main/";
// var info = document.getElementById("info");
const $388b617130f03bd4$var$cardTitle = document.getElementById("card-title");
const $388b617130f03bd4$var$cardFooter = document.getElementById("card-footer");
const $388b617130f03bd4$var$cardFooterShare = document.getElementById("card-footer-share");
const $388b617130f03bd4$var$cardFooterLink = document.getElementById("card-footer-link");
// var focusedPeople =[]
// var ancestorsOfPeople = []
// var descendantsOfPeople = []
// let styleNodes;
let $388b617130f03bd4$var$personNodes;
const $388b617130f03bd4$var$pred = document.getElementById("predecessors");
//const focus = document.getElementById("focus");
function $388b617130f03bd4$var$focusOnIndividual(state) {
    let person;
    if (state) {
        // console.log(cy.elements(":selected"),cy.elements(":selected").isEdge())
        if ($388b617130f03bd4$var$cy.elements(":selected").isEdge()) person = $388b617130f03bd4$var$cy.elements(":selected").target();
        else person = $388b617130f03bd4$var$cy.elements("node:selected");
        $388b617130f03bd4$var$focusedPerson = person;
        $388b617130f03bd4$var$cy.nodes().removeClass([
            "hidden",
            "ancestors",
            "descendants",
            "focused"
        ]);
        $388b617130f03bd4$var$personNodes = $388b617130f03bd4$var$cy.nodes(":visible");
        const ancestors = person.predecessors("node").filter(":visible");
        const successors = person.successors("node").filter(":visible");
        // ancestorsOfPeople = ancestors
        // descendantsOfPeople = successors
        const family = ancestors.union(successors).union(person);
        $388b617130f03bd4$var$cy.nodes().difference(family).addClass("hidden");
        person.addClass("focused");
        ancestors.addClass("ancestors");
        successors.addClass("descendants");
        $388b617130f03bd4$var$pred.classList.toggle("focus-on");
    } else {
        //personNodes.removeClass(["hidden", "ancestors", "descendants", "focused"]);
        $388b617130f03bd4$var$cy.nodes().removeClass([
            "hidden",
            "ancestors",
            "descendants",
            "focused"
        ]);
        $388b617130f03bd4$var$pred.classList.toggle("focus-on");
    // document.getElementById('pickStyle').value="all";
    // pickStyle();
    }
    $388b617130f03bd4$var$layout.run();
}
document.addEventListener("DOMContentLoaded", function() {
    $388b617130f03bd4$var$pred.addEventListener("click", (e)=>{
        // console.log("Predecessors" + ele.data().name);
        if (e.target.checked) $388b617130f03bd4$var$focusOnIndividual(true);
        else $388b617130f03bd4$var$focusOnIndividual(false);
    });
});
function $388b617130f03bd4$var$updatePath(target) {
    $388b617130f03bd4$var$pathOriginNode = $388b617130f03bd4$var$pathEndNode;
    $388b617130f03bd4$var$pathEndNode = target;
    pathOrigin.value = $388b617130f03bd4$var$pathOriginNode.data().id;
    pathEnd.value = $388b617130f03bd4$var$pathEndNode.data().id;
}
function $388b617130f03bd4$var$updateInfo(target) {
    const template = document.getElementById("template").innerHTML;
    target.select();
    // Commented out in path refactoring.
    //updatePath(target);
    // console.log("Updating info: ", event);
    if (target.isNode()) {
        for(let i = 0; i < target.data().teachers.length; i++){
            // console.log(event.target.data().teachers[i]);
            for (const person of (0, (/*@__PURE__*/$parcel$interopDefault($d8a032920235956d$exports))).elements.nodes)if (person.data.id == target.data().teachers[i].id) {
                // console.log(person.data.name);
                target.data().teachers[i].teacher_name = person.data.name;
                target.data().teachers[i].teacher_native = person.data.native_name;
                target.data().teachers[i].style = $388b617130f03bd4$var$getStyleById(target.data().teachers[i].style_id).name;
            // console.log(target.data().teachers[i]["teacher_name"]);
            }
        }
        if (target.data().rank) for(let i = 0; i < target.data().rank.length; i++){
            // console.log(event.target.data().teachers[i]);
            for (const person of (0, (/*@__PURE__*/$parcel$interopDefault($d8a032920235956d$exports))).elements.nodes)if (person.data.id == target.data().rank[i].teacher_id) {
                // console.log(person.data.name);
                target.data().rank[i].teacher_name = person.data.name;
                target.data().rank[i].teacher_native = person.data.native_name;
            // console.log(event.target.data().teachers[i]);
            }
        }
        // console.log("Students? ", target.outgoers('node'))
        const students = [];
        target.outgoers("node").forEach((e)=>{
            students.push(e.data());
        });
        target.data().students = students;
        target.data().birth.country_local = function() {
            return $15e3aefa8e338b9b$export$7d9f7e9c1c02b41e(this.country_code, $388b617130f03bd4$var$lang);
        };
        target.data().death.country_local = function() {
            return $15e3aefa8e338b9b$export$7d9f7e9c1c02b41e(this.country_code, $388b617130f03bd4$var$lang);
        };
        if (target.data().description) target.data().description_lang = target.data().description[$388b617130f03bd4$var$lang];
        if (target.data().birth.date) target.data().birth.date_local = $388b617130f03bd4$require$DateTime.fromISO(target.data().birth.date).toFormat("yyyy");
        if (target.data().death.date) target.data().death.date_local = $388b617130f03bd4$require$DateTime.fromISO(target.data().death.date).toFormat("yyyy");
        if (target.data().native_name && target.data().native_name.lang == $388b617130f03bd4$var$lang) $388b617130f03bd4$var$cardTitle.innerHTML = target.data().native_name.name;
        else $388b617130f03bd4$var$cardTitle.innerHTML = target.data().name;
        const rendered = $d486cd8337e91fbc$exports.render(template, target.data());
        document.getElementById("info").innerHTML = rendered;
        // i18n
        document.getElementById("i18n:teachers").innerHTML = $388b617130f03bd4$var$polyglot.t("Teachers");
        document.getElementById("i18n:students").innerHTML = $388b617130f03bd4$var$polyglot.t("Students");
        document.getElementById("i18n:rank").innerHTML = $388b617130f03bd4$var$polyglot.t("Rank");
        document.getElementById("i18n:sources").innerHTML = $388b617130f03bd4$var$polyglot.t("Sources");
        // Removed to make space for path UI; uncomment to add the "JDP-xx" label
        //document.getElementById("footerId").innerHTML = target.data().id + ": ";
        $388b617130f03bd4$var$cardFooterShare.setAttribute("href", "https://" + window.location.host + "/tree.html?id=" + target.data().id);
        $388b617130f03bd4$var$cardFooterShare.innerHTML = '<i class="fas fa-share-nodes mr-3 "></i> ' //+ target.data().id;
        ;
        $388b617130f03bd4$var$cardFooterLink.setAttribute("href", "https://" + window.location.host + "/" + target.data().id + ".html");
        $388b617130f03bd4$var$cardFooterLink.innerHTML = '<i class="fas fa-circle-user mr-3 "></i> ' //+ target.data().id;
        ;
        $388b617130f03bd4$var$cardFooter.setAttribute("href", $388b617130f03bd4$var$gitRoot + target.data().source_yaml);
        $388b617130f03bd4$var$cardFooter.innerHTML = '<i class="fas fa-file-code mr-3"></i> ' //+ target.data().id;
        ;
        // Teacher link navigation
        const teachers = document.getElementById("teachers");
        teachers.addEventListener("click", (e)=>{
            // console.log("Teacher ID: " + e.target.id);
            target.unselect();
            $388b617130f03bd4$var$updateInfo($388b617130f03bd4$var$cy.nodes("#" + e.target.id));
        });
        // Student link navigation
        if (students.length > 0) {
            const studentsInfo = document.getElementById("students");
            studentsInfo.addEventListener("click", (e)=>{
                target.unselect();
                $388b617130f03bd4$var$updateInfo($388b617130f03bd4$var$cy.nodes("#" + e.target.id));
            });
        }
        $388b617130f03bd4$var$cy.nodes().removeClass([
            "parents"
        ]);
        $388b617130f03bd4$var$cy.nodes().removeClass([
            "children"
        ]);
        target.outgoers("node").addClass("children");
        target.incomers("node").addClass("parents");
        // Individual buttons
        console.log("Pred state:");
        if (target.same($388b617130f03bd4$var$focusedPerson)) $388b617130f03bd4$var$pred.checked = true;
        else $388b617130f03bd4$var$pred.checked = false;
        if (target.same($388b617130f03bd4$var$pathOriginNode)) $388b617130f03bd4$var$pathOriginT.checked = true;
        else $388b617130f03bd4$var$pathOriginT.checked = false;
        if (target.same($388b617130f03bd4$var$pathEndNode)) $388b617130f03bd4$var$pathEndT.checked = true;
        else $388b617130f03bd4$var$pathEndT.checked = false;
    } else {
        // is edge
        // console.log("Tapped on edge: ", target.data());
        for (const person of (0, (/*@__PURE__*/$parcel$interopDefault($d8a032920235956d$exports))).elements.nodes)if (person.data.id == target.data().source) {
            // console.log(person.data.name);
            target.data().teacher_name = person.data.name;
            target.data().teacher_native = person.data.native_name;
            if (person.data.photo_local_url) target.data().teacher_photo_url = person.data.photo_local_url;
            else if (person.data.photo_url) target.data().teacher_photo_url = person.data.photo_url;
            else if (person.data.photo) target.data().teacher_photo_url = person.data.photo.url;
            else target.data().teacher_photo_url = "";
        // console.log(event.target.data().teachers[i]);
        }
        for (const person of (0, (/*@__PURE__*/$parcel$interopDefault($d8a032920235956d$exports))).elements.nodes)if (person.data.id == target.data().target) {
            //console.log(person.data.name);
            target.data().student_name = person.data.name;
            target.data().student_native = person.data.native_name;
            if (person.data.photo_local_url) target.data().student_photo_url = person.data.photo_local_url;
            else if (person.data.photo_url) target.data().student_photo_url = person.data.photo_url;
            else if (person.data.photo) target.data().student_photo_url = person.data.photo.url;
            else target.data().student_photo_url = "";
        //  console.log(target.data().student_photo_url)
        // console.log(event.target.data().teachers[i]);
        }
        if (target.data().interaction_native && target.data().interaction_native.lang == $388b617130f03bd4$var$lang) $388b617130f03bd4$var$cardTitle.innerHTML = target.data().interaction_native.name;
        else $388b617130f03bd4$var$cardTitle.innerHTML = target.data().interaction;
        const rendered = $d486cd8337e91fbc$exports.render(template, target.data());
        document.getElementById("info").innerHTML = rendered;
        // i18n
        document.getElementById("i18n:sources_int").innerHTML = $388b617130f03bd4$var$polyglot.t("Sources");
    }
}
$388b617130f03bd4$var$cy.nodes().bind("tap", (event)=>$388b617130f03bd4$var$updateInfo(event.target));
$388b617130f03bd4$var$cy.edges().bind("tap", (event)=>$388b617130f03bd4$var$updateInfo(event.target));
$388b617130f03bd4$var$cy.nodes().bind("dbltap", (event)=>{
    // cy.reset();
    console.log("Centering on ", event.target.data().name);
    $388b617130f03bd4$var$cy.center(event.target);
    $388b617130f03bd4$var$layout.run();
});
$388b617130f03bd4$var$cy.nodes().bind("dbltap", (event)=>{
    console.log("Centering on ", event.target.data().name);
    $388b617130f03bd4$var$cy.center(event.target);
// layout.run();
});
const $388b617130f03bd4$var$cardToggles = document.getElementsByClassName("card-toggle");
function $388b617130f03bd4$var$setInfoboxVisibility(state) {
    switch(state){
        case "toggle":
            $388b617130f03bd4$var$cardToggles[0].parentElement.parentElement.childNodes[3].classList.toggle("is-hidden");
            break;
        case "visible":
            $388b617130f03bd4$var$cardToggles[0].parentElement.parentElement.childNodes[3].classList.remove("is-hidden");
            break;
        case "hidden":
            $388b617130f03bd4$var$cardToggles[0].parentElement.parentElement.childNodes[3].classList.add("is-hidden");
            break;
    }
}
document.addEventListener("DOMContentLoaded", function() {
    for(let i = 0; i < $388b617130f03bd4$var$cardToggles.length; i++)$388b617130f03bd4$var$cardToggles[i].addEventListener("click", ()=>{
        $388b617130f03bd4$var$setInfoboxVisibility("toggle");
    });
});
document.addEventListener("DOMContentLoaded", function() {
    const lineType = document.getElementById("lineType");
    lineType.addEventListener("click", (e)=>{
        // console.log(style[1]["style"]["curve-style"]);
        if (e.target.checked) $388b617130f03bd4$var$cy.style().selector("edge").style({
            "curve-style": "bezier"
        }).update();
        else $388b617130f03bd4$var$cy.style().selector("edge").style({
            "curve-style": "taxi"
        }).update();
    });
});
const $388b617130f03bd4$var$countryNodes = {};
let $388b617130f03bd4$var$styleEdges = {};
//var nativeNames = false;
const $388b617130f03bd4$var$stringToColour = function(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++)hash = str.charCodeAt(i) + ((hash << 5) - hash);
    let colour = "#";
    for(let i = 0; i < 3; i++){
        const value = hash >> i * 8 & 0xff;
        colour += ("00" + value.toString(16)).substr(-2);
    }
    return colour + "33";
};
const $388b617130f03bd4$var$stringToColourSimple = function(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++)hash = str.charCodeAt(i) + ((hash << 5) - hash);
    let colour = "#";
    for(let i = 0; i < 3; i++){
        const value = hash >> i * 8 & 0xff;
        colour += ("00" + value.toString(16)).substr(-2);
    }
    return colour;
};
function $388b617130f03bd4$var$edgesByQuality() {
    // console.log("Setting edges by quality")
    $388b617130f03bd4$var$cy.edges().forEach(function(ele) {
        // console.log(ele.data().quality);
        switch(ele.data().quality){
            case 3:
                ele.style({
                    "line-style": "solid",
                    width: 3
                });
                break;
            case 2:
                ele.style({
                    "line-style": "solid",
                    width: 2
                });
                break;
            case 1:
                ele.style({
                    "line-style": "dashed",
                    width: 2
                });
                break;
            case 0:
                ele.style({
                    "line-style": "dashed",
                    width: 1
                });
                break;
            default:
                ele.style({
                    "line-style": "dotted",
                    width: 1
                });
        }
    });
}
function $388b617130f03bd4$var$edgesByStyle() {
    // console.log ("Setting edges by style");
    $388b617130f03bd4$var$cy.edges().forEach(function(ele) {
        ele.style({
            "line-color": $388b617130f03bd4$var$stringToColourSimple(ele.data().interaction)
        });
    });
}
document.addEventListener("DOMContentLoaded", function() {
    const styleColor = document.getElementById("styleColor");
    styleColor.addEventListener("click", (e)=>{
        if (e.target.checked) $388b617130f03bd4$var$edgesByStyle();
        else {
            $388b617130f03bd4$var$cy.style().selector("edge").style({
                "line-color": "#888"
            }).update();
            $388b617130f03bd4$var$cy.edges().forEach(function(ele) {
                ele.style({
                    "line-color": "#888"
                });
            });
        }
    });
});
document.addEventListener("DOMContentLoaded", function() {
    const quality = document.getElementById("quality");
    quality.addEventListener("click", (e)=>{
        // console.log(style[1]["style"]["line-type"]);
        if (e.target.checked) $388b617130f03bd4$var$edgesByQuality();
        else // console.log("Resetting styles");
        $388b617130f03bd4$var$cy.edges().forEach(function(ele) {
            ele.style({
                "line-style": "solid",
                width: 1,
                "line-color": "#888"
            });
        });
    });
});
function $388b617130f03bd4$var$nodesByCountry() {
    const countryList = {};
    let country;
    $388b617130f03bd4$var$cy.nodes().forEach(function(ele) {
        for (country of ele.data().nationality)countryList[country] = "";
    });
    for (const [key] of Object.entries(countryList)){
        // console.log(countryList);
        console.log(key);
        $388b617130f03bd4$var$countryNodes[key] = $388b617130f03bd4$var$cy.filter((element)=>{
            if (element.isNode()) for (country of element.data().nationality){
                if (country == key) return element;
            }
        });
    }
}
document.addEventListener("DOMContentLoaded", function() {
    const showStyles = document.getElementById("showStyles");
    showStyles.addEventListener("click", (e)=>{
        // console.log(style[1]["style"]["line-type"]);
        if (e.target.checked) {
            $388b617130f03bd4$var$edgesShowStyle = true;
            $388b617130f03bd4$var$cy.style().update();
        } else {
            $388b617130f03bd4$var$edgesShowStyle = false;
            $388b617130f03bd4$var$cy.style().update();
        }
    });
});
document.addEventListener("DOMContentLoaded", function() {
    const showPeriod = document.getElementById("showPeriod");
    showPeriod.addEventListener("click", (e)=>{
        // console.log(style[1]["style"]["line-type"]);
        console.log("Toggle on");
        if (e.target.checked) {
            $388b617130f03bd4$var$edgesShowPeriod = true;
            $388b617130f03bd4$var$cy.style().update();
        } else {
            $388b617130f03bd4$var$edgesShowPeriod = false;
            $388b617130f03bd4$var$cy.style().update();
        }
    });
});
document.addEventListener("DOMContentLoaded", function() {
    const clusterNationality = document.getElementById("clusterNationality");
    clusterNationality.addEventListener("click", (e)=>{
        if (e.target.checked) $388b617130f03bd4$var$layoutOptions.clusters = $388b617130f03bd4$var$clusterInfo;
        else $388b617130f03bd4$var$layoutOptions.clusters = null;
        $388b617130f03bd4$var$layout = $388b617130f03bd4$var$cy.layout($388b617130f03bd4$var$layoutOptions);
        $388b617130f03bd4$var$layout.run();
    });
});
document.addEventListener("DOMContentLoaded", function() {
    const compoundNationality = document.getElementById("compoundNationality");
    compoundNationality.addEventListener("click", (e)=>{
        console.log(e.target.checked);
        if (e.target.checked) {
            console.log("Cluster nationality checked");
            $388b617130f03bd4$var$setCluster("nationality");
        } else {
            $388b617130f03bd4$var$cy.nodes().forEach(function(ele) {
                ele.move({
                    parent: null
                });
            });
            let parents = $388b617130f03bd4$var$cy.elements('node[type = "grouping"]');
            console.log("Parents");
            console.log(parents);
            $388b617130f03bd4$var$cy.remove(parents);
        }
        $388b617130f03bd4$var$layout = $388b617130f03bd4$var$cy.layout($388b617130f03bd4$var$layoutOptions);
        $388b617130f03bd4$var$layout.run();
    });
});
document.addEventListener("DOMContentLoaded", function() {
    const bubbles = document.getElementById("bubbles");
    bubbles.addEventListener("click", (e)=>{
        if (e.target.checked) for (const [country, nodes] of Object.entries($388b617130f03bd4$var$countryNodes))$388b617130f03bd4$var$bb.addPath(nodes, null, null, {
            virtualEdges: true,
            style: {
                fill: $388b617130f03bd4$var$stringToColour(country)
            }
        });
        else for (const path of $388b617130f03bd4$var$bb.getPaths())$388b617130f03bd4$var$bb.removePath(path);
    });
});
// document.addEventListener('DOMContentLoaded', function() {
//     let nativeName = document.getElementById("nativename");
//     nativeName.addEventListener('click', e => {
//         console.log("Changing native name");
//         if (e.target.checked) {
//             nativeNames = true
//         } else {
//             nativeNames = false
//         }
//         cy.style().update()
//     })});
// navbar burguer
document.addEventListener("DOMContentLoaded", ()=>{
    // Get all "navbar-burger" elements
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll(".navbar-burger"), 0);
    // Add a click event on each of them
    $navbarBurgers.forEach((el)=>{
        el.addEventListener("click", ()=>{
            // Get the target from the "data-target" attribute
            const target = el.dataset.target;
            const $target = document.getElementById(target);
            // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
            el.classList.toggle("is-active");
            $target.classList.toggle("is-active");
        });
    });
});
// Tabs
const $388b617130f03bd4$var$tabs = document.getElementById("tabs");
$388b617130f03bd4$var$tabs.addEventListener("click", (e)=>{
    // console.log("target:",e.target)
    if (e.target.id != "tabs") $388b617130f03bd4$var$openTab(e, e.target.id);
});
function $388b617130f03bd4$var$openTab(evt, tabName) {
    // console.log("tab name: ",tabName.replace(/tab\:/, ""))
    let i, x, tablinks;
    const info = document.getElementById("infobox");
    x = document.getElementsByClassName("content-tab");
    for(i = 0; i < x.length; i++)x[i].style.display = "none";
    tablinks = document.getElementsByClassName("tab");
    for(i = 0; i < x.length; i++)tablinks[i].className = tablinks[i].className.replace(" is-active", "");
    document.getElementById(tabName.replace(/tab:/, "")).style.display = "block";
    document.getElementById(tabName).parentElement.className += " is-active";
    if (tabName == "tab:cy") info.style.display = "block";
    else info.style.display = "none";
}
function $388b617130f03bd4$var$listVersions() {
    const template = document.getElementById("template:versions").innerHTML;
    const rendered = $d486cd8337e91fbc$exports.render(template, {
        cytoscape_version: (0, $e815fda779bc047b$export$2e2bcd8739ae039).version,
        db_version: (0, (/*@__PURE__*/$parcel$interopDefault($ef59b8cb902fcc5b$exports))).dbversion
    });
    document.getElementById("versions").innerHTML = rendered;
}
function $388b617130f03bd4$var$listPersons() {
    const template = document.getElementById("template:persons").innerHTML;
    const sorted = (0, (/*@__PURE__*/$parcel$interopDefault($d8a032920235956d$exports))).elements.nodes.sort((a, b)=>a.data.name.localeCompare(b.data.name));
    const rendered = $d486cd8337e91fbc$exports.render(template, {
        arr: sorted
    });
    const persons = document.getElementById("Persons");
    persons.addEventListener("click", (e)=>{
        $388b617130f03bd4$var$cy.nodes().unselect();
        $388b617130f03bd4$var$cy.nodes('[id = "' + e.target.id + '"]').select();
        $388b617130f03bd4$var$updateInfo($388b617130f03bd4$var$cy.nodes("#" + e.target.id));
        $388b617130f03bd4$var$cy.reset();
        // cy.center('[id = "' + e.target.id +  '"]');
        $388b617130f03bd4$var$openTab(true, "tab:cy");
    });
    document.getElementById("Persons").innerHTML = rendered;
}
function $388b617130f03bd4$var$getNameById(id) {
    for (const person of (0, (/*@__PURE__*/$parcel$interopDefault($d8a032920235956d$exports))).elements.nodes){
        if (person.data.id == id) return person.data;
    }
}
function $388b617130f03bd4$var$listStyles() {
    const template = document.getElementById("template:styles").innerHTML;
    //  const sorted = data.elements.nodes.sort((a, b) => a.data.name.localeCompare(b.data.name))
    const view = [];
    const styleList = {};
    // console.log("data:", data);
    for (const edge of (0, (/*@__PURE__*/$parcel$interopDefault($d8a032920235956d$exports))).elements.edges){
        // console.log("EDGE: ", edge.data)
        if (!styleList[edge.data.interaction]) styleList[edge.data.interaction] = [];
        // let sourceName = getNameById(edge.data.source).name
        // let targetName = getNameById(edge.data.target).name
        // styleList[edge.data.interaction].indexOf(sourceName) === -1 ? styleList[edge.data.interaction].push(sourceName) : false;
        // styleList[edge.data.interaction].indexOf(targetName) === -1 ? styleList[edge.data.interaction].psh(targetName) : false;
        styleList[edge.data.interaction].indexOf(edge.data.source) === -1 && styleList[edge.data.interaction].push(edge.data.source);
        styleList[edge.data.interaction].indexOf(edge.data.target) === -1 && styleList[edge.data.interaction].push(edge.data.target);
    }
    //    for (const [key, value] of Object.entries(styleList)) {
    //        styleList[key] = value.sort((a, b) => a.localeCompare(b))
    //    }
    const sorted = [];
    for (const [key] of Object.entries(styleList)){
        sorted.push(key);
        styleList[key].sort((a, b)=>$388b617130f03bd4$var$getNameById(a).name.localeCompare($388b617130f03bd4$var$getNameById(b).name));
    }
    sorted.sort((a, b)=>a.localeCompare(b));
    for (const key of sorted){
        const value = styleList[key];
        const s = {};
        const pp = [];
        s.name = key;
        for (const person of value){
            const p = {};
            p.name = $388b617130f03bd4$var$getNameById(person).name;
            p.id = person;
            pp.push(p);
        }
        s.persons = pp;
        view.push(s);
    }
    const rendered = $d486cd8337e91fbc$exports.render(template, {
        arr: view
    });
    document.getElementById("Styles").innerHTML = rendered;
    const styles = document.getElementById("Styles");
    styles.addEventListener("click", (e)=>{
        $388b617130f03bd4$var$cy.nodes().unselect();
        $388b617130f03bd4$var$cy.nodes('[id = "' + e.target.id + '"]').select();
        $388b617130f03bd4$var$updateInfo($388b617130f03bd4$var$cy.nodes("#" + e.target.id));
        $388b617130f03bd4$var$cy.reset();
        $388b617130f03bd4$var$openTab(true, "tab:cy");
    });
}
// Style filter
const $388b617130f03bd4$var$styleFilter = document.getElementById("pickStyle");
$388b617130f03bd4$var$styleFilter.onclick = $388b617130f03bd4$var$pickStyle;
function $388b617130f03bd4$var$updateStyleFilter() {
    $388b617130f03bd4$var$styleFilter.innerHTML = "";
    const styleList = {};
    for (const edge of (0, (/*@__PURE__*/$parcel$interopDefault($d8a032920235956d$exports))).elements.edges)if (!styleList[edge.data.interaction_id]) styleList[edge.data.interaction_id] = {
        name: edge.data.interaction,
        native_name: edge.data.interaction_native
    };
    // const sorted = data.elements.nodes.sort((a, b) => a.data.name.localeCompare(b.data.name))
    // styleList = styleList.sort((a, b) => a.name_native.localeCompare(b.name_native))
    // console.log("Style list: ", styleList);
    const allEl = document.createElement("option");
    allEl.textContent = $388b617130f03bd4$var$polyglot.t("All Styles");
    allEl.value = "all";
    $388b617130f03bd4$var$styleFilter.appendChild(allEl);
    const sorted = [];
    for (const [key] of Object.entries(styleList))sorted.push(key);
    sorted.sort((a, b)=>styleList[a].name.localeCompare(styleList[b].name));
    // for (const [key, value] of Object.entries(styleList)) {
    for (const key of sorted){
        const value = styleList[key];
        const el = document.createElement("option");
        if (value.native_name && value.native_name.lang == $388b617130f03bd4$var$lang) el.textContent = value.native_name.name;
        else el.textContent = value.name;
        el.value = key;
        $388b617130f03bd4$var$styleFilter.appendChild(el);
    }
}
function $388b617130f03bd4$var$pickStyle() {
    const value = $388b617130f03bd4$var$styleFilter.value;
    // let text = styleFilter.options[styleFilter.selectedIndex].text;
    const clearButton = document.getElementById("i18n:clear");
    const lock = document.getElementById("lock-style");
    let styleNodes;
    $388b617130f03bd4$var$cy.nodes().removeClass([
        "hidden",
        "ancestors",
        "descendants",
        "focused"
    ]);
    // console.log("pickStyle: ", value, text);
    if (value == "all") {
        $388b617130f03bd4$var$cy.nodes().removeClass([
            "hidden"
        ]);
        $388b617130f03bd4$var$cy.edges().removeClass([
            "hidden"
        ]);
        // focus.classList.toggle('focus-on');
        clearButton.classList.remove("focus-style");
        clearButton.classList.add("is-dark");
        // clearButton.classList.toggle("is-dark");
        // clearButton.classList.toggle("has-text-dark");
        lock.classList.remove("fa-lock");
        lock.classList.add("fa-lock-open");
    } else {
        $388b617130f03bd4$var$cy.edges().removeClass([
            "hidden"
        ]);
        $388b617130f03bd4$var$styleEdges = $388b617130f03bd4$var$cy.edges('[interaction_id = "' + value + '"]');
        styleNodes = $388b617130f03bd4$var$styleEdges.connectedNodes();
        // styleNodes.addClass("stylefocus")
        $388b617130f03bd4$var$cy.nodes().difference(styleNodes).addClass("hidden");
        $388b617130f03bd4$var$cy.edges().difference($388b617130f03bd4$var$styleEdges).addClass("hidden");
        // clearButton.classList.toggle("focus-style");
        // clearButton.classList.toggle("is-dark");
        // clearButton.classList.toggle("has-text-dark");
        lock.classList.add("fa-lock");
        lock.classList.remove("fa-lock-open");
        clearButton.classList.remove("is-dark");
        clearButton.classList.add("focus-style");
    }
    // console.log("Style Edges", styleEdges);
    $388b617130f03bd4$var$cy.reset();
    $388b617130f03bd4$var$cy.center();
    $388b617130f03bd4$var$cy.fit(styleNodes);
    $388b617130f03bd4$var$layout.run();
    $388b617130f03bd4$var$updateTimeline();
}
document.addEventListener("DOMContentLoaded", function() {
    const clearStyle = document.getElementById("i18n:clear");
    // let clearButton = document.getElementById("i18n:clear");
    clearStyle.addEventListener("click", ()=>{
        // console.log("Clear style:", e);
        document.getElementById("pickStyle").value = "all";
        $388b617130f03bd4$var$pickStyle();
    });
});
// Toolbox interact
// const position = { x: 0, y: 0 }
const $388b617130f03bd4$var$positions = {};
(0, (/*@__PURE__*/$parcel$interopDefault($65AEs)))(".draggable").allowFrom(".drag-handle").draggable({
    listeners: {
        // start (event) {
        // console.log(event.type, event.target.id)
        // },
        move (event) {
            if (!$388b617130f03bd4$var$positions[event.target.id]) $388b617130f03bd4$var$positions[event.target.id] = {
                x: 0,
                y: 0
            };
            $388b617130f03bd4$var$positions[event.target.id].x += event.dx;
            $388b617130f03bd4$var$positions[event.target.id].y += event.dy;
            event.target.style.transform = `translate(${$388b617130f03bd4$var$positions[event.target.id].x}px, ${$388b617130f03bd4$var$positions[event.target.id].y}px)`;
        }
    }
});
function $388b617130f03bd4$var$getStyleById(id) {
    const tree = (0, (/*@__PURE__*/$parcel$interopDefault($2be514c301921327$exports)));
    if (id in tree) return tree[id];
    else return false;
}
function $388b617130f03bd4$var$createTimeline(nodes, title) {
    const tlOutput = {};
    const events = [];
    tlOutput.title = title;
    // create events
    for (const node of nodes){
        const person = node.data();
        const event = {};
        // console.log(person);
        if (person.birth.date) {
            event.start_date = {
                year: $388b617130f03bd4$require$DateTime.fromISO(person.birth.date).year
            };
            if (person.death.date) event.end_date = {
                year: $388b617130f03bd4$require$DateTime.fromISO(person.death.date).year
            };
            if (person.description) event.text = {
                headline: person.name,
                text: person.description.en
            };
            else event.text = {
                headline: person.name
            };
            if (person.photo_url_local) event.media = {
                url: person.photo_url_local
            };
            else if (person.photo_url) event.media = {
                url: person.photo_url
            };
            else if (person.photo) event.media = {
                url: person.photo.url
            };
            // event["group"] = person.data.nationality[0]
            events.push(event);
        }
    }
    tlOutput.events = events;
    console.debug("Created timeline from database", tlOutput);
    return tlOutput;
}
function $388b617130f03bd4$var$updateTimeline() {
    // let timeline;
    const selectedStyle = $388b617130f03bd4$var$styleFilter.value;
    const styleData = (0, (/*@__PURE__*/$parcel$interopDefault($2be514c301921327$exports)))[selectedStyle];
    let url;
    let caption;
    let credit;
    let headline;
    let text;
    let background;
    if (selectedStyle == "all") {
        url = "https://res.cloudinary.com/duu3v9gfg/image/fetch/t_w_640_auto/https://78884ca60822a34fb0e6-082b8fd5551e97bc65e327988b444396.ssl.cf3.rackcdn.com/up/2019/01/jpn-03-1548749418-1548749418.jpg";
        caption = "Judo practiced at the Fujimi-cho Kodokan dojo";
        credit = "Image by Hishida Shunso, copyright Kodokan Institute";
        headline = $388b617130f03bd4$var$polyglot.t("A timeline of martial artists");
        text = $388b617130f03bd4$var$polyglot.t("The history of martial arts through the tree database.");
    } else {
        if (styleData.description && styleData.description[$388b617130f03bd4$var$lang]) text = styleData.description[$388b617130f03bd4$var$lang];
        else text = $388b617130f03bd4$var$polyglot.t("A timeline through the tree database.");
        if (styleData.media && styleData.media.video_url && styleData.media.photo_url) {
            url = styleData.media.video_url;
            background = {
                url: styleData.media.photo_url
            };
        } else if (styleData.media && styleData.media.video_url) url = styleData.media.video_url;
        else if (styleData.media && styleData.media.photo_url) url = styleData.media.photo_url;
        else url = "";
        caption = "";
        credit = "";
        headline = $388b617130f03bd4$var$getStyleById(selectedStyle).name;
    }
    console.log("Update Timeline, selected style:", selectedStyle, $388b617130f03bd4$var$getStyleById(selectedStyle));
    const title = {
        media: {
            url: url,
            caption: caption,
            credit: credit
        },
        text: {
            headline: headline,
            text: text
        },
        background: background
    };
    const tl = $388b617130f03bd4$var$createTimeline($388b617130f03bd4$var$cy.nodes(":visible"), title);
    // timeline =
    new (0, $8112dcaee14ab84c$export$e6a97ba2cae5bb94)("timeline-embed", tl);
}
// Modal info screen
// From Bulma example in docs
document.addEventListener('DOMContentLoaded', ()=>{
    // Functions to open and close a modal
    function openModal($el) {
        $el.classList.add('is-active');
    }
    function closeModal($el) {
        $el.classList.remove('is-active');
    }
    function closeAllModals() {
        (document.querySelectorAll('.modal') || []).forEach(($modal)=>{
            closeModal($modal);
        });
    }
    // Add a click event on buttons to open a specific modal
    (document.querySelectorAll('.js-modal-trigger') || []).forEach(($trigger)=>{
        const modal = $trigger.dataset.target;
        const $target = document.getElementById(modal);
        $trigger.addEventListener('click', ()=>{
            openModal($target);
        });
    });
    // Add a click event on various child elements to close the parent modal
    (document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button') || []).forEach(($close)=>{
        const $target = $close.closest('.modal');
        $close.addEventListener('click', ()=>{
            closeModal($target);
        });
    });
    // Add a keyboard event to close all modals
    document.addEventListener('keydown', (event)=>{
        if (event.code === 'Escape') closeAllModals();
    });
});


//# sourceMappingURL=tree.268f841b.js.map
